
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1efd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1efd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cx8Kh", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $91ff59c6dbf7f798$export$ffb0004e005737fa; }, function (v) { return $91ff59c6dbf7f798$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $91ff59c6dbf7f798$export$34b9dba7ce09269b; }, function (v) { return $91ff59c6dbf7f798$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $91ff59c6dbf7f798$export$25062201e9e25d76; }, function (v) { return $91ff59c6dbf7f798$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91ff59c6dbf7f798$export$ffb0004e005737fa;
var $91ff59c6dbf7f798$export$34b9dba7ce09269b;
var $91ff59c6dbf7f798$export$25062201e9e25d76;
"use strict";
var $91ff59c6dbf7f798$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $91ff59c6dbf7f798$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $91ff59c6dbf7f798$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $91ff59c6dbf7f798$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$91ff59c6dbf7f798$export$ffb0004e005737fa = $91ff59c6dbf7f798$var$REACT_FRAGMENT_TYPE;
$91ff59c6dbf7f798$export$34b9dba7ce09269b = $91ff59c6dbf7f798$var$jsxProd;
$91ff59c6dbf7f798$export$25062201e9e25d76 = $91ff59c6dbf7f798$var$jsxProd;

});

parcelRegister("ik80y", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $d5704e75ccc6e977$export$9c16c1426311996d; }, function (v) { return $d5704e75ccc6e977$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $d5704e75ccc6e977$export$dca3b0875bd9a954; }, function (v) { return $d5704e75ccc6e977$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d5704e75ccc6e977$export$16fa2f45be04daa8; }, function (v) { return $d5704e75ccc6e977$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d5704e75ccc6e977$export$ffb0004e005737fa; }, function (v) { return $d5704e75ccc6e977$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d5704e75ccc6e977$export$e2c29f18771995cb; }, function (v) { return $d5704e75ccc6e977$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d5704e75ccc6e977$export$221d75b3f55bb0bd; }, function (v) { return $d5704e75ccc6e977$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d5704e75ccc6e977$export$5f8d39834fd61797; }, function (v) { return $d5704e75ccc6e977$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d5704e75ccc6e977$export$74bf444e3cd11ea5; }, function (v) { return $d5704e75ccc6e977$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $d5704e75ccc6e977$export$1ced07cd6b1985ce; }, function (v) { return $d5704e75ccc6e977$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $d5704e75ccc6e977$export$abd8e32b826d7ea7; }, function (v) { return $d5704e75ccc6e977$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $d5704e75ccc6e977$export$69a3209f1a06c04d; }, function (v) { return $d5704e75ccc6e977$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $d5704e75ccc6e977$export$8c538325882c7eec; }, function (v) { return $d5704e75ccc6e977$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d5704e75ccc6e977$export$e530037191fcd5d7; }, function (v) { return $d5704e75ccc6e977$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d5704e75ccc6e977$export$fd42f52fd3ae1109; }, function (v) { return $d5704e75ccc6e977$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d5704e75ccc6e977$export$c8a8987d4410bf2d; }, function (v) { return $d5704e75ccc6e977$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $d5704e75ccc6e977$export$7d1e3a5e95ceca43; }, function (v) { return $d5704e75ccc6e977$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d5704e75ccc6e977$export$257a8862b851cb5b; }, function (v) { return $d5704e75ccc6e977$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d5704e75ccc6e977$export$a8257692ac88316c; }, function (v) { return $d5704e75ccc6e977$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d5704e75ccc6e977$export$488013bae63b21da; }, function (v) { return $d5704e75ccc6e977$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d5704e75ccc6e977$export$7c73462e0d25e514; }, function (v) { return $d5704e75ccc6e977$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d5704e75ccc6e977$export$7568632d0d33d16d; }, function (v) { return $d5704e75ccc6e977$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $d5704e75ccc6e977$export$f93f40ac0ca7e3a8; }, function (v) { return $d5704e75ccc6e977$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $d5704e75ccc6e977$export$1f96ae73734a86cc; }, function (v) { return $d5704e75ccc6e977$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $d5704e75ccc6e977$export$9a47ced3238df325; }, function (v) { return $d5704e75ccc6e977$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d5704e75ccc6e977$export$35808ee640e87ca7; }, function (v) { return $d5704e75ccc6e977$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d5704e75ccc6e977$export$fae74005e78b1a27; }, function (v) { return $d5704e75ccc6e977$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d5704e75ccc6e977$export$dc8fbce3eb94dc1e; }, function (v) { return $d5704e75ccc6e977$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d5704e75ccc6e977$export$6a7bc4e911dc01cf; }, function (v) { return $d5704e75ccc6e977$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d5704e75ccc6e977$export$6d9c69b0de29b591; }, function (v) { return $d5704e75ccc6e977$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $d5704e75ccc6e977$export$7f54fc3180508a52; }, function (v) { return $d5704e75ccc6e977$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $d5704e75ccc6e977$export$f680877a34711e37; }, function (v) { return $d5704e75ccc6e977$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d5704e75ccc6e977$export$d5a552a76deda3c2; }, function (v) { return $d5704e75ccc6e977$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d5704e75ccc6e977$export$aaabe4eda9ed9969; }, function (v) { return $d5704e75ccc6e977$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d5704e75ccc6e977$export$e5c5a5f917a5871c; }, function (v) { return $d5704e75ccc6e977$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d5704e75ccc6e977$export$1538c33de8887b59; }, function (v) { return $d5704e75ccc6e977$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $d5704e75ccc6e977$export$fca7f784ae7a249a; }, function (v) { return $d5704e75ccc6e977$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $d5704e75ccc6e977$export$13e3392192263954; }, function (v) { return $d5704e75ccc6e977$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d5704e75ccc6e977$export$b8f5890fc79d6aca; }, function (v) { return $d5704e75ccc6e977$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d5704e75ccc6e977$export$60241385465d0a34; }, function (v) { return $d5704e75ccc6e977$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d5704e75ccc6e977$export$306c0aa65ff9ec16; }, function (v) { return $d5704e75ccc6e977$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d5704e75ccc6e977$export$7b286972b8d8ccbf; }, function (v) { return $d5704e75ccc6e977$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d5704e75ccc6e977$export$83d89fbfd8236492; }, function (v) { return $d5704e75ccc6e977$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5704e75ccc6e977$export$9c16c1426311996d;
var $d5704e75ccc6e977$export$dca3b0875bd9a954;
var $d5704e75ccc6e977$export$16fa2f45be04daa8;
var $d5704e75ccc6e977$export$ffb0004e005737fa;
var $d5704e75ccc6e977$export$e2c29f18771995cb;
var $d5704e75ccc6e977$export$221d75b3f55bb0bd;
var $d5704e75ccc6e977$export$5f8d39834fd61797;
var $d5704e75ccc6e977$export$74bf444e3cd11ea5;
var $d5704e75ccc6e977$export$1ced07cd6b1985ce;
var $d5704e75ccc6e977$export$abd8e32b826d7ea7;
var $d5704e75ccc6e977$export$69a3209f1a06c04d;
var $d5704e75ccc6e977$export$8c538325882c7eec;
var $d5704e75ccc6e977$export$e530037191fcd5d7;
var $d5704e75ccc6e977$export$fd42f52fd3ae1109;
var $d5704e75ccc6e977$export$c8a8987d4410bf2d;
var $d5704e75ccc6e977$export$7d1e3a5e95ceca43;
var $d5704e75ccc6e977$export$257a8862b851cb5b;
var $d5704e75ccc6e977$export$a8257692ac88316c;
var $d5704e75ccc6e977$export$488013bae63b21da;
var $d5704e75ccc6e977$export$7c73462e0d25e514;
var $d5704e75ccc6e977$export$7568632d0d33d16d;
var $d5704e75ccc6e977$export$f93f40ac0ca7e3a8;
var $d5704e75ccc6e977$export$1f96ae73734a86cc;
var $d5704e75ccc6e977$export$9a47ced3238df325;
var $d5704e75ccc6e977$export$35808ee640e87ca7;
var $d5704e75ccc6e977$export$fae74005e78b1a27;
var $d5704e75ccc6e977$export$dc8fbce3eb94dc1e;
var $d5704e75ccc6e977$export$6a7bc4e911dc01cf;
var $d5704e75ccc6e977$export$6d9c69b0de29b591;
var $d5704e75ccc6e977$export$7f54fc3180508a52;
var $d5704e75ccc6e977$export$f680877a34711e37;
var $d5704e75ccc6e977$export$d5a552a76deda3c2;
var $d5704e75ccc6e977$export$aaabe4eda9ed9969;
var $d5704e75ccc6e977$export$e5c5a5f917a5871c;
var $d5704e75ccc6e977$export$1538c33de8887b59;
var $d5704e75ccc6e977$export$fca7f784ae7a249a;
var $d5704e75ccc6e977$export$13e3392192263954;
var $d5704e75ccc6e977$export$b8f5890fc79d6aca;
var $d5704e75ccc6e977$export$60241385465d0a34;
var $d5704e75ccc6e977$export$306c0aa65ff9ec16;
var $d5704e75ccc6e977$export$7b286972b8d8ccbf;
var $d5704e75ccc6e977$export$83d89fbfd8236492;
"use strict";
var $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d5704e75ccc6e977$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d5704e75ccc6e977$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d5704e75ccc6e977$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d5704e75ccc6e977$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d5704e75ccc6e977$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d5704e75ccc6e977$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d5704e75ccc6e977$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d5704e75ccc6e977$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d5704e75ccc6e977$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d5704e75ccc6e977$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $d5704e75ccc6e977$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $d5704e75ccc6e977$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d5704e75ccc6e977$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d5704e75ccc6e977$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d5704e75ccc6e977$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d5704e75ccc6e977$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d5704e75ccc6e977$var$assign = Object.assign, $d5704e75ccc6e977$var$emptyObject = {};
function $d5704e75ccc6e977$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $d5704e75ccc6e977$var$emptyObject;
    this.updater = updater || $d5704e75ccc6e977$var$ReactNoopUpdateQueue;
}
$d5704e75ccc6e977$var$Component.prototype.isReactComponent = {};
$d5704e75ccc6e977$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$d5704e75ccc6e977$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $d5704e75ccc6e977$var$ComponentDummy() {}
$d5704e75ccc6e977$var$ComponentDummy.prototype = $d5704e75ccc6e977$var$Component.prototype;
function $d5704e75ccc6e977$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $d5704e75ccc6e977$var$emptyObject;
    this.updater = updater || $d5704e75ccc6e977$var$ReactNoopUpdateQueue;
}
var $d5704e75ccc6e977$var$pureComponentPrototype = $d5704e75ccc6e977$var$PureComponent.prototype = new $d5704e75ccc6e977$var$ComponentDummy();
$d5704e75ccc6e977$var$pureComponentPrototype.constructor = $d5704e75ccc6e977$var$PureComponent;
$d5704e75ccc6e977$var$assign($d5704e75ccc6e977$var$pureComponentPrototype, $d5704e75ccc6e977$var$Component.prototype);
$d5704e75ccc6e977$var$pureComponentPrototype.isPureReactComponent = !0;
var $d5704e75ccc6e977$var$isArrayImpl = Array.isArray;
function $d5704e75ccc6e977$var$noop() {}
var $d5704e75ccc6e977$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $d5704e75ccc6e977$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d5704e75ccc6e977$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $d5704e75ccc6e977$var$cloneAndReplaceKey(oldElement, newKey) {
    return $d5704e75ccc6e977$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $d5704e75ccc6e977$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE;
}
function $d5704e75ccc6e977$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $d5704e75ccc6e977$var$userProvidedKeyEscapeRegex = /\/+/g;
function $d5704e75ccc6e977$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $d5704e75ccc6e977$var$escape("" + element.key) : index.toString(36);
}
function $d5704e75ccc6e977$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($d5704e75ccc6e977$var$noop, $d5704e75ccc6e977$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $d5704e75ccc6e977$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE:
                case $d5704e75ccc6e977$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $d5704e75ccc6e977$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $d5704e75ccc6e977$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $d5704e75ccc6e977$var$getElementKey(children, 0) : nameSoFar, $d5704e75ccc6e977$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($d5704e75ccc6e977$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $d5704e75ccc6e977$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($d5704e75ccc6e977$var$isValidElement(callback) && (callback = $d5704e75ccc6e977$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($d5704e75ccc6e977$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($d5704e75ccc6e977$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $d5704e75ccc6e977$var$getElementKey(nameSoFar, i), invokeCallback += $d5704e75ccc6e977$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $d5704e75ccc6e977$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $d5704e75ccc6e977$var$getElementKey(nameSoFar, i++), invokeCallback += $d5704e75ccc6e977$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $d5704e75ccc6e977$var$mapIntoArray($d5704e75ccc6e977$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $d5704e75ccc6e977$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $d5704e75ccc6e977$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $d5704e75ccc6e977$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $d5704e75ccc6e977$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $d5704e75ccc6e977$var$Children = {
    map: $d5704e75ccc6e977$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $d5704e75ccc6e977$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $d5704e75ccc6e977$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $d5704e75ccc6e977$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$d5704e75ccc6e977$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$d5704e75ccc6e977$export$9c16c1426311996d = $d5704e75ccc6e977$var$REACT_ACTIVITY_TYPE;
$d5704e75ccc6e977$export$dca3b0875bd9a954 = $d5704e75ccc6e977$var$Children;
$d5704e75ccc6e977$export$16fa2f45be04daa8 = $d5704e75ccc6e977$var$Component;
$d5704e75ccc6e977$export$ffb0004e005737fa = $d5704e75ccc6e977$var$REACT_FRAGMENT_TYPE;
$d5704e75ccc6e977$export$e2c29f18771995cb = $d5704e75ccc6e977$var$REACT_PROFILER_TYPE;
$d5704e75ccc6e977$export$221d75b3f55bb0bd = $d5704e75ccc6e977$var$PureComponent;
$d5704e75ccc6e977$export$5f8d39834fd61797 = $d5704e75ccc6e977$var$REACT_STRICT_MODE_TYPE;
$d5704e75ccc6e977$export$74bf444e3cd11ea5 = $d5704e75ccc6e977$var$REACT_SUSPENSE_TYPE;
$d5704e75ccc6e977$export$1ced07cd6b1985ce = $d5704e75ccc6e977$var$ReactSharedInternals;
$d5704e75ccc6e977$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $d5704e75ccc6e977$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$d5704e75ccc6e977$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$d5704e75ccc6e977$export$8c538325882c7eec = function() {
    return null;
};
$d5704e75ccc6e977$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $d5704e75ccc6e977$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$d5704e75ccc6e977$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $d5704e75ccc6e977$var$ReactElement(element.type, key, props);
};
$d5704e75ccc6e977$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $d5704e75ccc6e977$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $d5704e75ccc6e977$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$d5704e75ccc6e977$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$d5704e75ccc6e977$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $d5704e75ccc6e977$var$ReactElement(type, key, props);
};
$d5704e75ccc6e977$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d5704e75ccc6e977$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$d5704e75ccc6e977$export$a8257692ac88316c = $d5704e75ccc6e977$var$isValidElement;
$d5704e75ccc6e977$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $d5704e75ccc6e977$var$lazyInitializer
    };
};
$d5704e75ccc6e977$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$d5704e75ccc6e977$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $d5704e75ccc6e977$var$ReactSharedInternals.T, currentTransition = {};
    $d5704e75ccc6e977$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $d5704e75ccc6e977$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($d5704e75ccc6e977$var$noop, $d5704e75ccc6e977$var$reportGlobalError);
    } catch (error) {
        $d5704e75ccc6e977$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d5704e75ccc6e977$var$ReactSharedInternals.T = prevTransition;
    }
};
$d5704e75ccc6e977$export$f93f40ac0ca7e3a8 = function() {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useCacheRefresh();
};
$d5704e75ccc6e977$export$1f96ae73734a86cc = function(usable) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.use(usable);
};
$d5704e75ccc6e977$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$d5704e75ccc6e977$export$35808ee640e87ca7 = function(callback, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$d5704e75ccc6e977$export$fae74005e78b1a27 = function(Context) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useContext(Context);
};
$d5704e75ccc6e977$export$dc8fbce3eb94dc1e = function() {};
$d5704e75ccc6e977$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$d5704e75ccc6e977$export$6d9c69b0de29b591 = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useEffect(create, deps);
};
$d5704e75ccc6e977$export$7f54fc3180508a52 = function(callback) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$d5704e75ccc6e977$export$f680877a34711e37 = function() {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useId();
};
$d5704e75ccc6e977$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$d5704e75ccc6e977$export$aaabe4eda9ed9969 = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$d5704e75ccc6e977$export$e5c5a5f917a5871c = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$d5704e75ccc6e977$export$1538c33de8887b59 = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useMemo(create, deps);
};
$d5704e75ccc6e977$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$d5704e75ccc6e977$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$d5704e75ccc6e977$export$b8f5890fc79d6aca = function(initialValue) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useRef(initialValue);
};
$d5704e75ccc6e977$export$60241385465d0a34 = function(initialState) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useState(initialState);
};
$d5704e75ccc6e977$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$d5704e75ccc6e977$export$7b286972b8d8ccbf = function() {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useTransition();
};
$d5704e75ccc6e977$export$83d89fbfd8236492 = "19.2.8";

});

parcelRegister("9kHYF", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $6cb818575e31460e$export$a7c73072b1a182ae; }, function (v) { return $6cb818575e31460e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $6cb818575e31460e$export$9f27bc3417b4524d; }, function (v) { return $6cb818575e31460e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $6cb818575e31460e$export$db77ccec0bb4ccac; }, function (v) { return $6cb818575e31460e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $6cb818575e31460e$export$8392c0c9d3dcbd35; }, function (v) { return $6cb818575e31460e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6cb818575e31460e$export$ffb0004e005737fa; }, function (v) { return $6cb818575e31460e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $6cb818575e31460e$export$b624eff549462981; }, function (v) { return $6cb818575e31460e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $6cb818575e31460e$export$7897aa7841a5380c; }, function (v) { return $6cb818575e31460e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $6cb818575e31460e$export$602eac185826482c; }, function (v) { return $6cb818575e31460e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $6cb818575e31460e$export$e2c29f18771995cb; }, function (v) { return $6cb818575e31460e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6cb818575e31460e$export$5f8d39834fd61797; }, function (v) { return $6cb818575e31460e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6cb818575e31460e$export$74bf444e3cd11ea5; }, function (v) { return $6cb818575e31460e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $6cb818575e31460e$export$998bcd577473dd93; }, function (v) { return $6cb818575e31460e$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $6cb818575e31460e$export$b706b080d889d2c9; }, function (v) { return $6cb818575e31460e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $6cb818575e31460e$export$5be5a87408f70ddc; }, function (v) { return $6cb818575e31460e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $6cb818575e31460e$export$45a5e7f76e0caa8d; }, function (v) { return $6cb818575e31460e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $6cb818575e31460e$export$455c2e768291efa6; }, function (v) { return $6cb818575e31460e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $6cb818575e31460e$export$9522e17588c12572; }, function (v) { return $6cb818575e31460e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $6cb818575e31460e$export$2110ac352bb060b9; }, function (v) { return $6cb818575e31460e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $6cb818575e31460e$export$56885ab8b9c456ab; }, function (v) { return $6cb818575e31460e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $6cb818575e31460e$export$d927fcb6adf8f9de; }, function (v) { return $6cb818575e31460e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $6cb818575e31460e$export$b82d16f27459e05a; }, function (v) { return $6cb818575e31460e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $6cb818575e31460e$export$522c17b4f5e123e8; }, function (v) { return $6cb818575e31460e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $6cb818575e31460e$export$1aabd8a0274ecfd6; }, function (v) { return $6cb818575e31460e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $6cb818575e31460e$export$3d6c20d97e46b957; }, function (v) { return $6cb818575e31460e$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $6cb818575e31460e$export$9b621391a187a31a; }, function (v) { return $6cb818575e31460e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $6cb818575e31460e$export$f5bbd400c2f4426f; }, function (v) { return $6cb818575e31460e$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6cb818575e31460e$export$a7c73072b1a182ae;
var $6cb818575e31460e$export$9f27bc3417b4524d;
var $6cb818575e31460e$export$db77ccec0bb4ccac;
var $6cb818575e31460e$export$8392c0c9d3dcbd35;
var $6cb818575e31460e$export$ffb0004e005737fa;
var $6cb818575e31460e$export$b624eff549462981;
var $6cb818575e31460e$export$7897aa7841a5380c;
var $6cb818575e31460e$export$602eac185826482c;
var $6cb818575e31460e$export$e2c29f18771995cb;
var $6cb818575e31460e$export$5f8d39834fd61797;
var $6cb818575e31460e$export$74bf444e3cd11ea5;
var $6cb818575e31460e$export$998bcd577473dd93;
var $6cb818575e31460e$export$b706b080d889d2c9;
var $6cb818575e31460e$export$5be5a87408f70ddc;
var $6cb818575e31460e$export$45a5e7f76e0caa8d;
var $6cb818575e31460e$export$455c2e768291efa6;
var $6cb818575e31460e$export$9522e17588c12572;
var $6cb818575e31460e$export$2110ac352bb060b9;
var $6cb818575e31460e$export$56885ab8b9c456ab;
var $6cb818575e31460e$export$d927fcb6adf8f9de;
var $6cb818575e31460e$export$b82d16f27459e05a;
var $6cb818575e31460e$export$522c17b4f5e123e8;
var $6cb818575e31460e$export$1aabd8a0274ecfd6;
var $6cb818575e31460e$export$3d6c20d97e46b957;
var $6cb818575e31460e$export$9b621391a187a31a;
var $6cb818575e31460e$export$f5bbd400c2f4426f;
"use strict";
var $6cb818575e31460e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6cb818575e31460e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6cb818575e31460e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6cb818575e31460e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6cb818575e31460e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6cb818575e31460e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6cb818575e31460e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $6cb818575e31460e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6cb818575e31460e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6cb818575e31460e$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $6cb818575e31460e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $6cb818575e31460e$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $6cb818575e31460e$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $6cb818575e31460e$var$REACT_FRAGMENT_TYPE:
                    case $6cb818575e31460e$var$REACT_PROFILER_TYPE:
                    case $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE:
                    case $6cb818575e31460e$var$REACT_SUSPENSE_TYPE:
                    case $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE:
                    case $6cb818575e31460e$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $6cb818575e31460e$var$REACT_CONTEXT_TYPE:
                            case $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE:
                            case $6cb818575e31460e$var$REACT_LAZY_TYPE:
                            case $6cb818575e31460e$var$REACT_MEMO_TYPE:
                                return object;
                            case $6cb818575e31460e$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $6cb818575e31460e$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$6cb818575e31460e$export$a7c73072b1a182ae = $6cb818575e31460e$var$REACT_CONSUMER_TYPE;
$6cb818575e31460e$export$9f27bc3417b4524d = $6cb818575e31460e$var$REACT_CONTEXT_TYPE;
$6cb818575e31460e$export$db77ccec0bb4ccac = $6cb818575e31460e$var$REACT_ELEMENT_TYPE;
$6cb818575e31460e$export$8392c0c9d3dcbd35 = $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE;
$6cb818575e31460e$export$ffb0004e005737fa = $6cb818575e31460e$var$REACT_FRAGMENT_TYPE;
$6cb818575e31460e$export$b624eff549462981 = $6cb818575e31460e$var$REACT_LAZY_TYPE;
$6cb818575e31460e$export$7897aa7841a5380c = $6cb818575e31460e$var$REACT_MEMO_TYPE;
$6cb818575e31460e$export$602eac185826482c = $6cb818575e31460e$var$REACT_PORTAL_TYPE;
$6cb818575e31460e$export$e2c29f18771995cb = $6cb818575e31460e$var$REACT_PROFILER_TYPE;
$6cb818575e31460e$export$5f8d39834fd61797 = $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE;
$6cb818575e31460e$export$74bf444e3cd11ea5 = $6cb818575e31460e$var$REACT_SUSPENSE_TYPE;
$6cb818575e31460e$export$998bcd577473dd93 = $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE;
$6cb818575e31460e$export$b706b080d889d2c9 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_CONSUMER_TYPE;
};
$6cb818575e31460e$export$5be5a87408f70ddc = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_CONTEXT_TYPE;
};
$6cb818575e31460e$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6cb818575e31460e$var$REACT_ELEMENT_TYPE;
};
$6cb818575e31460e$export$455c2e768291efa6 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE;
};
$6cb818575e31460e$export$9522e17588c12572 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_FRAGMENT_TYPE;
};
$6cb818575e31460e$export$2110ac352bb060b9 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_LAZY_TYPE;
};
$6cb818575e31460e$export$56885ab8b9c456ab = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_MEMO_TYPE;
};
$6cb818575e31460e$export$d927fcb6adf8f9de = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_PORTAL_TYPE;
};
$6cb818575e31460e$export$b82d16f27459e05a = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_PROFILER_TYPE;
};
$6cb818575e31460e$export$522c17b4f5e123e8 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE;
};
$6cb818575e31460e$export$1aabd8a0274ecfd6 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_SUSPENSE_TYPE;
};
$6cb818575e31460e$export$3d6c20d97e46b957 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE;
};
$6cb818575e31460e$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $6cb818575e31460e$var$REACT_FRAGMENT_TYPE || type === $6cb818575e31460e$var$REACT_PROFILER_TYPE || type === $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE || type === $6cb818575e31460e$var$REACT_SUSPENSE_TYPE || type === $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $6cb818575e31460e$var$REACT_LAZY_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_MEMO_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CONTEXT_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CONSUMER_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$6cb818575e31460e$export$f5bbd400c2f4426f = $6cb818575e31460e$var$typeOf;

});

parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
'use strict';
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});

parcelRegister("5toGc", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("5x3at")).then(()=>parcelRequire('fVMg8'));

});
parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("a8X8z", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $76288626b30e899c$export$882461b6382ed46c; }, function (v) { return $76288626b30e899c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $76288626b30e899c$export$757ceba2d55c277e; }, function (v) { return $76288626b30e899c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $76288626b30e899c$export$83d89fbfd8236492; }, function (v) { return $76288626b30e899c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $76288626b30e899c$export$882461b6382ed46c;
var $76288626b30e899c$export$757ceba2d55c277e;
var $76288626b30e899c$export$83d89fbfd8236492;
"use strict";

var $33s19 = parcelRequire("33s19");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $76288626b30e899c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $76288626b30e899c$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $76288626b30e899c$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $76288626b30e899c$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $76288626b30e899c$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $76288626b30e899c$var$assertIsMounted(fiber) {
    if ($76288626b30e899c$var$getNearestMountedFiber(fiber) !== fiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
}
function $76288626b30e899c$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $76288626b30e899c$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $76288626b30e899c$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $76288626b30e899c$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($76288626b30e899c$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($76288626b30e899c$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $76288626b30e899c$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $76288626b30e899c$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $76288626b30e899c$var$assign = Object.assign, $76288626b30e899c$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $76288626b30e899c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $76288626b30e899c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $76288626b30e899c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $76288626b30e899c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $76288626b30e899c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $76288626b30e899c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $76288626b30e899c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $76288626b30e899c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $76288626b30e899c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $76288626b30e899c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $76288626b30e899c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $76288626b30e899c$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $76288626b30e899c$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $76288626b30e899c$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $76288626b30e899c$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $76288626b30e899c$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$76288626b30e899c$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $76288626b30e899c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $76288626b30e899c$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $76288626b30e899c$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $76288626b30e899c$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $76288626b30e899c$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $76288626b30e899c$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $76288626b30e899c$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $76288626b30e899c$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $76288626b30e899c$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $76288626b30e899c$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $76288626b30e899c$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $76288626b30e899c$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $76288626b30e899c$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $76288626b30e899c$var$getComponentNameFromType(type.type) || "Memo";
        case $76288626b30e899c$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $76288626b30e899c$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $76288626b30e899c$var$isArrayImpl = Array.isArray, $76288626b30e899c$var$ReactSharedInternals = $7fPBF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $76288626b30e899c$var$ReactDOMSharedInternals = $fw0lo.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $76288626b30e899c$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $76288626b30e899c$var$valueStack = [], $76288626b30e899c$var$index = -1;
function $76288626b30e899c$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $76288626b30e899c$var$pop(cursor) {
    0 > $76288626b30e899c$var$index || (cursor.current = $76288626b30e899c$var$valueStack[$76288626b30e899c$var$index], $76288626b30e899c$var$valueStack[$76288626b30e899c$var$index] = null, $76288626b30e899c$var$index--);
}
function $76288626b30e899c$var$push(cursor, value) {
    $76288626b30e899c$var$index++;
    $76288626b30e899c$var$valueStack[$76288626b30e899c$var$index] = cursor.current;
    cursor.current = value;
}
var $76288626b30e899c$var$contextStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$contextFiberStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$rootInstanceStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$hostTransitionProviderCursor = $76288626b30e899c$var$createCursor(null);
function $76288626b30e899c$var$pushHostContainer(fiber, nextRootInstance) {
    $76288626b30e899c$var$push($76288626b30e899c$var$rootInstanceStackCursor, nextRootInstance);
    $76288626b30e899c$var$push($76288626b30e899c$var$contextFiberStackCursor, fiber);
    $76288626b30e899c$var$push($76288626b30e899c$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $76288626b30e899c$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $76288626b30e899c$var$getOwnHostContext(nextRootInstance), fiber = $76288626b30e899c$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $76288626b30e899c$var$pop($76288626b30e899c$var$contextStackCursor);
    $76288626b30e899c$var$push($76288626b30e899c$var$contextStackCursor, fiber);
}
function $76288626b30e899c$var$popHostContainer() {
    $76288626b30e899c$var$pop($76288626b30e899c$var$contextStackCursor);
    $76288626b30e899c$var$pop($76288626b30e899c$var$contextFiberStackCursor);
    $76288626b30e899c$var$pop($76288626b30e899c$var$rootInstanceStackCursor);
}
function $76288626b30e899c$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $76288626b30e899c$var$push($76288626b30e899c$var$hostTransitionProviderCursor, fiber);
    var context = $76288626b30e899c$var$contextStackCursor.current;
    var JSCompiler_inline_result = $76288626b30e899c$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($76288626b30e899c$var$push($76288626b30e899c$var$contextFiberStackCursor, fiber), $76288626b30e899c$var$push($76288626b30e899c$var$contextStackCursor, JSCompiler_inline_result));
}
function $76288626b30e899c$var$popHostContext(fiber) {
    $76288626b30e899c$var$contextFiberStackCursor.current === fiber && ($76288626b30e899c$var$pop($76288626b30e899c$var$contextStackCursor), $76288626b30e899c$var$pop($76288626b30e899c$var$contextFiberStackCursor));
    $76288626b30e899c$var$hostTransitionProviderCursor.current === fiber && ($76288626b30e899c$var$pop($76288626b30e899c$var$hostTransitionProviderCursor), $76288626b30e899c$var$HostTransitionContext._currentValue = $76288626b30e899c$var$sharedNotPendingObject);
}
var $76288626b30e899c$var$prefix, $76288626b30e899c$var$suffix;
function $76288626b30e899c$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $76288626b30e899c$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $76288626b30e899c$var$prefix = match && match[1] || "";
        $76288626b30e899c$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $76288626b30e899c$var$prefix + name + $76288626b30e899c$var$suffix;
}
var $76288626b30e899c$var$reentry = !1;
function $76288626b30e899c$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $76288626b30e899c$var$reentry) return "";
    $76288626b30e899c$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $76288626b30e899c$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $76288626b30e899c$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $76288626b30e899c$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $76288626b30e899c$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $76288626b30e899c$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $76288626b30e899c$var$describeBuiltInComponentFrame("Suspense Fallback") : $76288626b30e899c$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $76288626b30e899c$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $76288626b30e899c$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $76288626b30e899c$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $76288626b30e899c$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $76288626b30e899c$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $76288626b30e899c$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $76288626b30e899c$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $76288626b30e899c$var$hasOwnProperty = Object.prototype.hasOwnProperty, $76288626b30e899c$var$scheduleCallback$3 = $33s19.unstable_scheduleCallback, $76288626b30e899c$var$cancelCallback$1 = $33s19.unstable_cancelCallback, $76288626b30e899c$var$shouldYield = $33s19.unstable_shouldYield, $76288626b30e899c$var$requestPaint = $33s19.unstable_requestPaint, $76288626b30e899c$var$now = $33s19.unstable_now, $76288626b30e899c$var$getCurrentPriorityLevel = $33s19.unstable_getCurrentPriorityLevel, $76288626b30e899c$var$ImmediatePriority = $33s19.unstable_ImmediatePriority, $76288626b30e899c$var$UserBlockingPriority = $33s19.unstable_UserBlockingPriority, $76288626b30e899c$var$NormalPriority$1 = $33s19.unstable_NormalPriority, $76288626b30e899c$var$LowPriority = $33s19.unstable_LowPriority, $76288626b30e899c$var$IdlePriority = $33s19.unstable_IdlePriority, $76288626b30e899c$var$log$1 = $33s19.log, $76288626b30e899c$var$unstable_setDisableYieldValue = $33s19.unstable_setDisableYieldValue, $76288626b30e899c$var$rendererID = null, $76288626b30e899c$var$injectedHook = null;
function $76288626b30e899c$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $76288626b30e899c$var$log$1 && $76288626b30e899c$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.setStrictMode) try {
        $76288626b30e899c$var$injectedHook.setStrictMode($76288626b30e899c$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $76288626b30e899c$var$clz32 = Math.clz32 ? Math.clz32 : $76288626b30e899c$var$clz32Fallback, $76288626b30e899c$var$log = Math.log, $76288626b30e899c$var$LN2 = Math.LN2;
function $76288626b30e899c$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($76288626b30e899c$var$log(x) / $76288626b30e899c$var$LN2 | 0) | 0;
}
var $76288626b30e899c$var$nextTransitionUpdateLane = 256, $76288626b30e899c$var$nextTransitionDeferredLane = 262144, $76288626b30e899c$var$nextRetryLane = 4194304;
function $76288626b30e899c$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $76288626b30e899c$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $76288626b30e899c$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $76288626b30e899c$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $76288626b30e899c$var$claimNextRetryLane() {
    var lane = $76288626b30e899c$var$nextRetryLane;
    $76288626b30e899c$var$nextRetryLane <<= 1;
    0 === ($76288626b30e899c$var$nextRetryLane & 62914560) && ($76288626b30e899c$var$nextRetryLane = 4194304);
    return lane;
}
function $76288626b30e899c$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $76288626b30e899c$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $76288626b30e899c$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $76288626b30e899c$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $76288626b30e899c$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $76288626b30e899c$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $76288626b30e899c$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $76288626b30e899c$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $76288626b30e899c$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $76288626b30e899c$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $76288626b30e899c$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $76288626b30e899c$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $76288626b30e899c$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $76288626b30e899c$var$resolveUpdatePriority() {
    var updatePriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $76288626b30e899c$var$getEventPriority(updatePriority.type);
}
function $76288626b30e899c$var$runWithPriority(priority, fn) {
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        return $76288626b30e899c$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $76288626b30e899c$var$randomKey = Math.random().toString(36).slice(2), $76288626b30e899c$var$internalInstanceKey = "__reactFiber$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalPropsKey = "__reactProps$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalContainerInstanceKey = "__reactContainer$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalEventHandlersKey = "__reactEvents$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalEventHandlerListenersKey = "__reactListeners$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalEventHandlesSetKey = "__reactHandles$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalRootNodeResourcesKey = "__reactResources$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalHoistableMarker = "__reactMarker$" + $76288626b30e899c$var$randomKey;
function $76288626b30e899c$var$detachDeletedInstance(node) {
    delete node[$76288626b30e899c$var$internalInstanceKey];
    delete node[$76288626b30e899c$var$internalPropsKey];
    delete node[$76288626b30e899c$var$internalEventHandlersKey];
    delete node[$76288626b30e899c$var$internalEventHandlerListenersKey];
    delete node[$76288626b30e899c$var$internalEventHandlesSetKey];
}
function $76288626b30e899c$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$76288626b30e899c$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$76288626b30e899c$var$internalContainerInstanceKey] || parentNode[$76288626b30e899c$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $76288626b30e899c$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$76288626b30e899c$var$internalInstanceKey]) return parentNode;
                targetNode = $76288626b30e899c$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $76288626b30e899c$var$getInstanceFromNode(node) {
    if (node = node[$76288626b30e899c$var$internalInstanceKey] || node[$76288626b30e899c$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $76288626b30e899c$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($76288626b30e899c$var$formatProdErrorMessage(33));
}
function $76288626b30e899c$var$getResourcesFromRoot(root) {
    var resources = root[$76288626b30e899c$var$internalRootNodeResourcesKey];
    resources || (resources = root[$76288626b30e899c$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $76288626b30e899c$var$markNodeAsHoistable(node) {
    node[$76288626b30e899c$var$internalHoistableMarker] = !0;
}
var $76288626b30e899c$var$allNativeEvents = new Set(), $76288626b30e899c$var$registrationNameDependencies = {};
function $76288626b30e899c$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $76288626b30e899c$var$registerDirectEvent(registrationName, dependencies);
    $76288626b30e899c$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $76288626b30e899c$var$registerDirectEvent(registrationName, dependencies) {
    $76288626b30e899c$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$76288626b30e899c$var$allNativeEvents.add(dependencies[registrationName]);
}
var $76288626b30e899c$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $76288626b30e899c$var$illegalAttributeNameCache = {}, $76288626b30e899c$var$validatedAttributeNameCache = {};
function $76288626b30e899c$var$isAttributeNameSafe(attributeName) {
    if ($76288626b30e899c$var$hasOwnProperty.call($76288626b30e899c$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($76288626b30e899c$var$hasOwnProperty.call($76288626b30e899c$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($76288626b30e899c$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $76288626b30e899c$var$validatedAttributeNameCache[attributeName] = !0;
    $76288626b30e899c$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $76288626b30e899c$var$setValueForAttribute(node, name, value) {
    if ($76288626b30e899c$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $76288626b30e899c$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $76288626b30e899c$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $76288626b30e899c$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $76288626b30e899c$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $76288626b30e899c$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $76288626b30e899c$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $76288626b30e899c$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $76288626b30e899c$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $76288626b30e899c$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $76288626b30e899c$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $76288626b30e899c$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $76288626b30e899c$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $76288626b30e899c$var$getToStringValue(value);
        } else element.value !== "" + $76288626b30e899c$var$getToStringValue(value) && (element.value = "" + $76288626b30e899c$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $76288626b30e899c$var$setDefaultValue(element, type, $76288626b30e899c$var$getToStringValue(value)) : null != defaultValue ? $76288626b30e899c$var$setDefaultValue(element, type, $76288626b30e899c$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $76288626b30e899c$var$getToStringValue(name) : element.removeAttribute("name");
}
function $76288626b30e899c$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $76288626b30e899c$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $76288626b30e899c$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $76288626b30e899c$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $76288626b30e899c$var$track(element);
}
function $76288626b30e899c$var$setDefaultValue(node, type, value) {
    "number" === type && $76288626b30e899c$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $76288626b30e899c$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $76288626b30e899c$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $76288626b30e899c$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $76288626b30e899c$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $76288626b30e899c$var$getToStringValue(defaultValue) : "";
}
function $76288626b30e899c$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($76288626b30e899c$var$formatProdErrorMessage(92));
            if ($76288626b30e899c$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($76288626b30e899c$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $76288626b30e899c$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $76288626b30e899c$var$track(element);
}
function $76288626b30e899c$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $76288626b30e899c$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $76288626b30e899c$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $76288626b30e899c$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $76288626b30e899c$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($76288626b30e899c$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $76288626b30e899c$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $76288626b30e899c$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $76288626b30e899c$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $76288626b30e899c$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $76288626b30e899c$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $76288626b30e899c$var$sanitizeURL(url) {
    return $76288626b30e899c$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $76288626b30e899c$var$noop$1() {}
var $76288626b30e899c$var$currentReplayingEvent = null;
function $76288626b30e899c$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $76288626b30e899c$var$restoreTarget = null, $76288626b30e899c$var$restoreQueue = null;
function $76288626b30e899c$var$restoreStateOfTarget(target) {
    var internalInstance = $76288626b30e899c$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$76288626b30e899c$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $76288626b30e899c$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$76288626b30e899c$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($76288626b30e899c$var$formatProdErrorMessage(90));
                            $76288626b30e899c$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $76288626b30e899c$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $76288626b30e899c$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $76288626b30e899c$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $76288626b30e899c$var$isInsideEventHandler = !1;
function $76288626b30e899c$var$batchedUpdates$1(fn, a, b) {
    if ($76288626b30e899c$var$isInsideEventHandler) return fn(a, b);
    $76288626b30e899c$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($76288626b30e899c$var$isInsideEventHandler = !1, null !== $76288626b30e899c$var$restoreTarget || null !== $76288626b30e899c$var$restoreQueue) {
            if ($76288626b30e899c$var$flushSyncWork$1(), $76288626b30e899c$var$restoreTarget && (a = $76288626b30e899c$var$restoreTarget, fn = $76288626b30e899c$var$restoreQueue, $76288626b30e899c$var$restoreQueue = $76288626b30e899c$var$restoreTarget = null, $76288626b30e899c$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$76288626b30e899c$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $76288626b30e899c$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$76288626b30e899c$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $76288626b30e899c$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $76288626b30e899c$var$passiveBrowserEventsSupported = !1;
if ($76288626b30e899c$var$canUseDOM) try {
    var $76288626b30e899c$var$options = {};
    Object.defineProperty($76288626b30e899c$var$options, "passive", {
        get: function() {
            $76288626b30e899c$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $76288626b30e899c$var$options, $76288626b30e899c$var$options);
    window.removeEventListener("test", $76288626b30e899c$var$options, $76288626b30e899c$var$options);
} catch (e) {
    $76288626b30e899c$var$passiveBrowserEventsSupported = !1;
}
var $76288626b30e899c$var$root = null, $76288626b30e899c$var$startText = null, $76288626b30e899c$var$fallbackText = null;
function $76288626b30e899c$var$getData() {
    if ($76288626b30e899c$var$fallbackText) return $76288626b30e899c$var$fallbackText;
    var start, startValue = $76288626b30e899c$var$startText, startLength = startValue.length, end, endValue = "value" in $76288626b30e899c$var$root ? $76288626b30e899c$var$root.value : $76288626b30e899c$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $76288626b30e899c$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $76288626b30e899c$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $76288626b30e899c$var$functionThatReturnsTrue() {
    return !0;
}
function $76288626b30e899c$var$functionThatReturnsFalse() {
    return !1;
}
function $76288626b30e899c$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $76288626b30e899c$var$functionThatReturnsTrue : $76288626b30e899c$var$functionThatReturnsFalse;
        this.isPropagationStopped = $76288626b30e899c$var$functionThatReturnsFalse;
        return this;
    }
    $76288626b30e899c$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $76288626b30e899c$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $76288626b30e899c$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $76288626b30e899c$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $76288626b30e899c$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $76288626b30e899c$var$SyntheticEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$EventInterface), $76288626b30e899c$var$UIEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    view: 0,
    detail: 0
}), $76288626b30e899c$var$SyntheticUIEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$UIEventInterface), $76288626b30e899c$var$lastMovementX, $76288626b30e899c$var$lastMovementY, $76288626b30e899c$var$lastMouseEvent, $76288626b30e899c$var$MouseEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $76288626b30e899c$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $76288626b30e899c$var$lastMouseEvent && ($76288626b30e899c$var$lastMouseEvent && "mousemove" === event.type ? ($76288626b30e899c$var$lastMovementX = event.screenX - $76288626b30e899c$var$lastMouseEvent.screenX, $76288626b30e899c$var$lastMovementY = event.screenY - $76288626b30e899c$var$lastMouseEvent.screenY) : $76288626b30e899c$var$lastMovementY = $76288626b30e899c$var$lastMovementX = 0, $76288626b30e899c$var$lastMouseEvent = event);
        return $76288626b30e899c$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $76288626b30e899c$var$lastMovementY;
    }
}), $76288626b30e899c$var$SyntheticMouseEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$MouseEventInterface), $76288626b30e899c$var$DragEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$MouseEventInterface, {
    dataTransfer: 0
}), $76288626b30e899c$var$SyntheticDragEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$DragEventInterface), $76288626b30e899c$var$FocusEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    relatedTarget: 0
}), $76288626b30e899c$var$SyntheticFocusEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$FocusEventInterface), $76288626b30e899c$var$AnimationEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $76288626b30e899c$var$SyntheticAnimationEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$AnimationEventInterface), $76288626b30e899c$var$ClipboardEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $76288626b30e899c$var$SyntheticClipboardEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$ClipboardEventInterface), $76288626b30e899c$var$CompositionEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    data: 0
}), $76288626b30e899c$var$SyntheticCompositionEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$CompositionEventInterface), $76288626b30e899c$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $76288626b30e899c$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $76288626b30e899c$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $76288626b30e899c$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $76288626b30e899c$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $76288626b30e899c$var$getEventModifierState() {
    return $76288626b30e899c$var$modifierStateGetter;
}
var $76288626b30e899c$var$KeyboardEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $76288626b30e899c$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $76288626b30e899c$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $76288626b30e899c$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $76288626b30e899c$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $76288626b30e899c$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $76288626b30e899c$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $76288626b30e899c$var$SyntheticKeyboardEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$KeyboardEventInterface), $76288626b30e899c$var$PointerEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $76288626b30e899c$var$SyntheticPointerEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$PointerEventInterface), $76288626b30e899c$var$TouchEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $76288626b30e899c$var$getEventModifierState
}), $76288626b30e899c$var$SyntheticTouchEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$TouchEventInterface), $76288626b30e899c$var$TransitionEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $76288626b30e899c$var$SyntheticTransitionEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$TransitionEventInterface), $76288626b30e899c$var$WheelEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $76288626b30e899c$var$SyntheticWheelEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$WheelEventInterface), $76288626b30e899c$var$ToggleEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $76288626b30e899c$var$SyntheticToggleEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$ToggleEventInterface), $76288626b30e899c$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $76288626b30e899c$var$canUseCompositionEvent = $76288626b30e899c$var$canUseDOM && "CompositionEvent" in window, $76288626b30e899c$var$documentMode = null;
$76288626b30e899c$var$canUseDOM && "documentMode" in document && ($76288626b30e899c$var$documentMode = document.documentMode);
var $76288626b30e899c$var$canUseTextInputEvent = $76288626b30e899c$var$canUseDOM && "TextEvent" in window && !$76288626b30e899c$var$documentMode, $76288626b30e899c$var$useFallbackCompositionData = $76288626b30e899c$var$canUseDOM && (!$76288626b30e899c$var$canUseCompositionEvent || $76288626b30e899c$var$documentMode && 8 < $76288626b30e899c$var$documentMode && 11 >= $76288626b30e899c$var$documentMode), $76288626b30e899c$var$SPACEBAR_CHAR = String.fromCharCode(32), $76288626b30e899c$var$hasSpaceKeypress = !1;
function $76288626b30e899c$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $76288626b30e899c$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $76288626b30e899c$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $76288626b30e899c$var$isComposing = !1;
function $76288626b30e899c$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $76288626b30e899c$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $76288626b30e899c$var$hasSpaceKeypress = !0;
            return $76288626b30e899c$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $76288626b30e899c$var$SPACEBAR_CHAR && $76288626b30e899c$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $76288626b30e899c$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($76288626b30e899c$var$isComposing) return "compositionend" === domEventName || !$76288626b30e899c$var$canUseCompositionEvent && $76288626b30e899c$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $76288626b30e899c$var$getData(), $76288626b30e899c$var$fallbackText = $76288626b30e899c$var$startText = $76288626b30e899c$var$root = null, $76288626b30e899c$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $76288626b30e899c$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $76288626b30e899c$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $76288626b30e899c$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$76288626b30e899c$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $76288626b30e899c$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $76288626b30e899c$var$restoreTarget ? $76288626b30e899c$var$restoreQueue ? $76288626b30e899c$var$restoreQueue.push(target) : $76288626b30e899c$var$restoreQueue = [
        target
    ] : $76288626b30e899c$var$restoreTarget = target;
    inst = $76288626b30e899c$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $76288626b30e899c$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $76288626b30e899c$var$activeElement$1 = null, $76288626b30e899c$var$activeElementInst$1 = null;
function $76288626b30e899c$var$runEventInBatch(dispatchQueue) {
    $76288626b30e899c$var$processDispatchQueue(dispatchQueue, 0);
}
function $76288626b30e899c$var$getInstIfValueChanged(targetInst) {
    var targetNode = $76288626b30e899c$var$getNodeFromInstance(targetInst);
    if ($76288626b30e899c$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $76288626b30e899c$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $76288626b30e899c$var$isInputEventSupported = !1;
if ($76288626b30e899c$var$canUseDOM) {
    var $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286;
    if ($76288626b30e899c$var$canUseDOM) {
        var $76288626b30e899c$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$76288626b30e899c$var$isSupported$jscomp$inline_427) {
            var $76288626b30e899c$var$element$jscomp$inline_428 = document.createElement("div");
            $76288626b30e899c$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $76288626b30e899c$var$isSupported$jscomp$inline_427 = "function" === typeof $76288626b30e899c$var$element$jscomp$inline_428.oninput;
        }
        $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286 = $76288626b30e899c$var$isSupported$jscomp$inline_427;
    } else $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286 = !1;
    $76288626b30e899c$var$isInputEventSupported = $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $76288626b30e899c$var$stopWatchingForValueChange() {
    $76288626b30e899c$var$activeElement$1 && ($76288626b30e899c$var$activeElement$1.detachEvent("onpropertychange", $76288626b30e899c$var$handlePropertyChange), $76288626b30e899c$var$activeElementInst$1 = $76288626b30e899c$var$activeElement$1 = null);
}
function $76288626b30e899c$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $76288626b30e899c$var$getInstIfValueChanged($76288626b30e899c$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $76288626b30e899c$var$createAndAccumulateChangeEvent(dispatchQueue, $76288626b30e899c$var$activeElementInst$1, nativeEvent, $76288626b30e899c$var$getEventTarget(nativeEvent));
        $76288626b30e899c$var$batchedUpdates$1($76288626b30e899c$var$runEventInBatch, dispatchQueue);
    }
}
function $76288626b30e899c$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($76288626b30e899c$var$stopWatchingForValueChange(), $76288626b30e899c$var$activeElement$1 = target, $76288626b30e899c$var$activeElementInst$1 = targetInst, $76288626b30e899c$var$activeElement$1.attachEvent("onpropertychange", $76288626b30e899c$var$handlePropertyChange)) : "focusout" === domEventName && $76288626b30e899c$var$stopWatchingForValueChange();
}
function $76288626b30e899c$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $76288626b30e899c$var$getInstIfValueChanged($76288626b30e899c$var$activeElementInst$1);
}
function $76288626b30e899c$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $76288626b30e899c$var$getInstIfValueChanged(targetInst);
}
function $76288626b30e899c$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $76288626b30e899c$var$getInstIfValueChanged(targetInst);
}
function $76288626b30e899c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $76288626b30e899c$var$objectIs = "function" === typeof Object.is ? Object.is : $76288626b30e899c$var$is;
function $76288626b30e899c$var$shallowEqual(objA, objB) {
    if ($76288626b30e899c$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$76288626b30e899c$var$hasOwnProperty.call(objB, currentKey) || !$76288626b30e899c$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $76288626b30e899c$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $76288626b30e899c$var$getNodeForCharacterOffset(root, offset) {
    var node = $76288626b30e899c$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $76288626b30e899c$var$getLeafNode(node);
    }
}
function $76288626b30e899c$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $76288626b30e899c$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $76288626b30e899c$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $76288626b30e899c$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $76288626b30e899c$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $76288626b30e899c$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $76288626b30e899c$var$skipSelectionChangeEvent = $76288626b30e899c$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $76288626b30e899c$var$activeElement = null, $76288626b30e899c$var$activeElementInst = null, $76288626b30e899c$var$lastSelection = null, $76288626b30e899c$var$mouseDown = !1;
function $76288626b30e899c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $76288626b30e899c$var$mouseDown || null == $76288626b30e899c$var$activeElement || $76288626b30e899c$var$activeElement !== $76288626b30e899c$var$getActiveElement(doc) || (doc = $76288626b30e899c$var$activeElement, "selectionStart" in doc && $76288626b30e899c$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $76288626b30e899c$var$lastSelection && $76288626b30e899c$var$shallowEqual($76288626b30e899c$var$lastSelection, doc) || ($76288626b30e899c$var$lastSelection = doc, doc = $76288626b30e899c$var$accumulateTwoPhaseListeners($76288626b30e899c$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $76288626b30e899c$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $76288626b30e899c$var$activeElement)));
}
function $76288626b30e899c$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $76288626b30e899c$var$vendorPrefixes = {
    animationend: $76288626b30e899c$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $76288626b30e899c$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $76288626b30e899c$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionEnd")
}, $76288626b30e899c$var$prefixedEventNames = {}, $76288626b30e899c$var$style = {};
$76288626b30e899c$var$canUseDOM && ($76288626b30e899c$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $76288626b30e899c$var$vendorPrefixes.animationend.animation, delete $76288626b30e899c$var$vendorPrefixes.animationiteration.animation, delete $76288626b30e899c$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $76288626b30e899c$var$vendorPrefixes.transitionend.transition);
function $76288626b30e899c$var$getVendorPrefixedEventName(eventName) {
    if ($76288626b30e899c$var$prefixedEventNames[eventName]) return $76288626b30e899c$var$prefixedEventNames[eventName];
    if (!$76288626b30e899c$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $76288626b30e899c$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $76288626b30e899c$var$style) return $76288626b30e899c$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $76288626b30e899c$var$ANIMATION_END = $76288626b30e899c$var$getVendorPrefixedEventName("animationend"), $76288626b30e899c$var$ANIMATION_ITERATION = $76288626b30e899c$var$getVendorPrefixedEventName("animationiteration"), $76288626b30e899c$var$ANIMATION_START = $76288626b30e899c$var$getVendorPrefixedEventName("animationstart"), $76288626b30e899c$var$TRANSITION_RUN = $76288626b30e899c$var$getVendorPrefixedEventName("transitionrun"), $76288626b30e899c$var$TRANSITION_START = $76288626b30e899c$var$getVendorPrefixedEventName("transitionstart"), $76288626b30e899c$var$TRANSITION_CANCEL = $76288626b30e899c$var$getVendorPrefixedEventName("transitioncancel"), $76288626b30e899c$var$TRANSITION_END = $76288626b30e899c$var$getVendorPrefixedEventName("transitionend"), $76288626b30e899c$var$topLevelEventsToReactNames = new Map(), $76288626b30e899c$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$76288626b30e899c$var$simpleEventPluginEvents.push("scrollEnd");
function $76288626b30e899c$var$registerSimpleEvent(domEventName, reactName) {
    $76288626b30e899c$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $76288626b30e899c$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $76288626b30e899c$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $76288626b30e899c$var$concurrentQueues = [], $76288626b30e899c$var$concurrentQueuesIndex = 0, $76288626b30e899c$var$concurrentlyUpdatedLanes = 0;
function $76288626b30e899c$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $76288626b30e899c$var$concurrentQueuesIndex, i = $76288626b30e899c$var$concurrentlyUpdatedLanes = $76288626b30e899c$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        var queue = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        var update = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        var lane = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $76288626b30e899c$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $76288626b30e899c$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = fiber;
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = queue;
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = update;
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = lane;
    $76288626b30e899c$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $76288626b30e899c$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
}
function $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $76288626b30e899c$var$enqueueUpdate$1(fiber, null, null, lane);
    return $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
}
function $76288626b30e899c$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $76288626b30e899c$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $76288626b30e899c$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $76288626b30e899c$var$nestedUpdateCount) throw $76288626b30e899c$var$nestedUpdateCount = 0, $76288626b30e899c$var$rootWithNestedUpdates = null, Error($76288626b30e899c$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $76288626b30e899c$var$emptyContextObject = {};
function $76288626b30e899c$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $76288626b30e899c$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $76288626b30e899c$var$FiberNode(tag, pendingProps, key, mode);
}
function $76288626b30e899c$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $76288626b30e899c$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $76288626b30e899c$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $76288626b30e899c$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $76288626b30e899c$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $76288626b30e899c$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $76288626b30e899c$var$isHostHoistableType(type, pendingProps, $76288626b30e899c$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $76288626b30e899c$var$REACT_ACTIVITY_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $76288626b30e899c$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $76288626b30e899c$var$REACT_FRAGMENT_TYPE:
            return $76288626b30e899c$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $76288626b30e899c$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $76288626b30e899c$var$REACT_PROFILER_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $76288626b30e899c$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $76288626b30e899c$var$REACT_SUSPENSE_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $76288626b30e899c$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $76288626b30e899c$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $76288626b30e899c$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $76288626b30e899c$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $76288626b30e899c$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($76288626b30e899c$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $76288626b30e899c$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $76288626b30e899c$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $76288626b30e899c$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $76288626b30e899c$var$createFiberFromText(content, mode, lanes) {
    content = $76288626b30e899c$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $76288626b30e899c$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $76288626b30e899c$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $76288626b30e899c$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $76288626b30e899c$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $76288626b30e899c$var$CapturedStacks = new WeakMap();
function $76288626b30e899c$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $76288626b30e899c$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $76288626b30e899c$var$getStackByFiberInDevAndProd(source)
        };
        $76288626b30e899c$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $76288626b30e899c$var$getStackByFiberInDevAndProd(source)
    };
}
var $76288626b30e899c$var$forkStack = [], $76288626b30e899c$var$forkStackIndex = 0, $76288626b30e899c$var$treeForkProvider = null, $76288626b30e899c$var$treeForkCount = 0, $76288626b30e899c$var$idStack = [], $76288626b30e899c$var$idStackIndex = 0, $76288626b30e899c$var$treeContextProvider = null, $76288626b30e899c$var$treeContextId = 1, $76288626b30e899c$var$treeContextOverflow = "";
function $76288626b30e899c$var$pushTreeFork(workInProgress, totalChildren) {
    $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex++] = $76288626b30e899c$var$treeForkCount;
    $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex++] = $76288626b30e899c$var$treeForkProvider;
    $76288626b30e899c$var$treeForkProvider = workInProgress;
    $76288626b30e899c$var$treeForkCount = totalChildren;
}
function $76288626b30e899c$var$pushTreeId(workInProgress, totalChildren, index) {
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextId;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextOverflow;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextProvider;
    $76288626b30e899c$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $76288626b30e899c$var$treeContextId;
    workInProgress = $76288626b30e899c$var$treeContextOverflow;
    var baseLength = 32 - $76288626b30e899c$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $76288626b30e899c$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $76288626b30e899c$var$treeContextId = 1 << 32 - $76288626b30e899c$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $76288626b30e899c$var$treeContextOverflow = length + workInProgress;
    } else $76288626b30e899c$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $76288626b30e899c$var$treeContextOverflow = workInProgress;
}
function $76288626b30e899c$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($76288626b30e899c$var$pushTreeFork(workInProgress, 1), $76288626b30e899c$var$pushTreeId(workInProgress, 1, 0));
}
function $76288626b30e899c$var$popTreeContext(workInProgress) {
    for(; workInProgress === $76288626b30e899c$var$treeForkProvider;)$76288626b30e899c$var$treeForkProvider = $76288626b30e899c$var$forkStack[--$76288626b30e899c$var$forkStackIndex], $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex] = null, $76288626b30e899c$var$treeForkCount = $76288626b30e899c$var$forkStack[--$76288626b30e899c$var$forkStackIndex], $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex] = null;
    for(; workInProgress === $76288626b30e899c$var$treeContextProvider;)$76288626b30e899c$var$treeContextProvider = $76288626b30e899c$var$idStack[--$76288626b30e899c$var$idStackIndex], $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex] = null, $76288626b30e899c$var$treeContextOverflow = $76288626b30e899c$var$idStack[--$76288626b30e899c$var$idStackIndex], $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex] = null, $76288626b30e899c$var$treeContextId = $76288626b30e899c$var$idStack[--$76288626b30e899c$var$idStackIndex], $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex] = null;
}
function $76288626b30e899c$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextId;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextOverflow;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextProvider;
    $76288626b30e899c$var$treeContextId = suspendedContext.id;
    $76288626b30e899c$var$treeContextOverflow = suspendedContext.overflow;
    $76288626b30e899c$var$treeContextProvider = workInProgress;
}
var $76288626b30e899c$var$hydrationParentFiber = null, $76288626b30e899c$var$nextHydratableInstance = null, $76288626b30e899c$var$isHydrating = !1, $76288626b30e899c$var$hydrationErrors = null, $76288626b30e899c$var$rootOrSingletonContext = !1, $76288626b30e899c$var$HydrationMismatchException = Error($76288626b30e899c$var$formatProdErrorMessage(519));
function $76288626b30e899c$var$throwOnHydrationMismatch(fiber) {
    var error = Error($76288626b30e899c$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $76288626b30e899c$var$queueHydrationError($76288626b30e899c$var$createCapturedValueAtFiber(error, fiber));
    throw $76288626b30e899c$var$HydrationMismatchException;
}
function $76288626b30e899c$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$76288626b30e899c$var$internalInstanceKey] = fiber;
    instance[$76288626b30e899c$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $76288626b30e899c$var$listenToNonDelegatedEvent("cancel", instance);
            $76288626b30e899c$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $76288626b30e899c$var$mediaEventTypes.length; type++)$76288626b30e899c$var$listenToNonDelegatedEvent($76288626b30e899c$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", instance);
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", instance);
            $76288626b30e899c$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", instance), $76288626b30e899c$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $76288626b30e899c$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($76288626b30e899c$var$listenToNonDelegatedEvent("beforetoggle", instance), $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $76288626b30e899c$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $76288626b30e899c$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $76288626b30e899c$var$noop$1), instance = !0) : instance = !1;
    instance || $76288626b30e899c$var$throwOnHydrationMismatch(fiber, !0);
}
function $76288626b30e899c$var$popToNextHostParent(fiber) {
    for($76288626b30e899c$var$hydrationParentFiber = fiber.return; $76288626b30e899c$var$hydrationParentFiber;)switch($76288626b30e899c$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $76288626b30e899c$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $76288626b30e899c$var$rootOrSingletonContext = !0;
            return;
        default:
            $76288626b30e899c$var$hydrationParentFiber = $76288626b30e899c$var$hydrationParentFiber.return;
    }
}
function $76288626b30e899c$var$popHydrationState(fiber) {
    if (fiber !== $76288626b30e899c$var$hydrationParentFiber) return !1;
    if (!$76288626b30e899c$var$isHydrating) return $76288626b30e899c$var$popToNextHostParent(fiber), $76288626b30e899c$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $76288626b30e899c$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $76288626b30e899c$var$nextHydratableInstance && $76288626b30e899c$var$throwOnHydrationMismatch(fiber);
    $76288626b30e899c$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(317));
        $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(317));
        $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $76288626b30e899c$var$nextHydratableInstance, $76288626b30e899c$var$isSingletonScope(fiber.type) ? (fiber = $76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton, $76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton = null, $76288626b30e899c$var$nextHydratableInstance = fiber) : $76288626b30e899c$var$nextHydratableInstance = tag) : $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$hydrationParentFiber ? $76288626b30e899c$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $76288626b30e899c$var$resetHydrationState() {
    $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$hydrationParentFiber = null;
    $76288626b30e899c$var$isHydrating = !1;
}
function $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $76288626b30e899c$var$hydrationErrors;
    null !== queuedErrors && (null === $76288626b30e899c$var$workInProgressRootRecoverableErrors ? $76288626b30e899c$var$workInProgressRootRecoverableErrors = queuedErrors : $76288626b30e899c$var$workInProgressRootRecoverableErrors.push.apply($76288626b30e899c$var$workInProgressRootRecoverableErrors, queuedErrors), $76288626b30e899c$var$hydrationErrors = null);
    return queuedErrors;
}
function $76288626b30e899c$var$queueHydrationError(error) {
    null === $76288626b30e899c$var$hydrationErrors ? $76288626b30e899c$var$hydrationErrors = [
        error
    ] : $76288626b30e899c$var$hydrationErrors.push(error);
}
var $76288626b30e899c$var$valueCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$currentlyRenderingFiber$1 = null, $76288626b30e899c$var$lastContextDependency = null;
function $76288626b30e899c$var$pushProvider(providerFiber, context, nextValue) {
    $76288626b30e899c$var$push($76288626b30e899c$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $76288626b30e899c$var$popProvider(context) {
    context._currentValue = $76288626b30e899c$var$valueCursor.current;
    $76288626b30e899c$var$pop($76288626b30e899c$var$valueCursor);
}
function $76288626b30e899c$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $76288626b30e899c$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $76288626b30e899c$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $76288626b30e899c$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($76288626b30e899c$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $76288626b30e899c$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $76288626b30e899c$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($76288626b30e899c$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($76288626b30e899c$var$HostTransitionContext) : current = [
                $76288626b30e899c$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $76288626b30e899c$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $76288626b30e899c$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$76288626b30e899c$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $76288626b30e899c$var$prepareToReadContext(workInProgress) {
    $76288626b30e899c$var$currentlyRenderingFiber$1 = workInProgress;
    $76288626b30e899c$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $76288626b30e899c$var$readContext(context) {
    return $76288626b30e899c$var$readContextForConsumer($76288626b30e899c$var$currentlyRenderingFiber$1, context);
}
function $76288626b30e899c$var$readContextDuringReconciliation(consumer, context) {
    null === $76288626b30e899c$var$currentlyRenderingFiber$1 && $76288626b30e899c$var$prepareToReadContext(consumer);
    return $76288626b30e899c$var$readContextForConsumer(consumer, context);
}
function $76288626b30e899c$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $76288626b30e899c$var$lastContextDependency) {
        if (null === consumer) throw Error($76288626b30e899c$var$formatProdErrorMessage(308));
        $76288626b30e899c$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$lastContextDependency.next = context;
    return value;
}
var $76288626b30e899c$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $76288626b30e899c$var$scheduleCallback$2 = $33s19.unstable_scheduleCallback, $76288626b30e899c$var$NormalPriority = $33s19.unstable_NormalPriority, $76288626b30e899c$var$CacheContext = {
    $$typeof: $76288626b30e899c$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $76288626b30e899c$var$createCache() {
    return {
        controller: new $76288626b30e899c$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $76288626b30e899c$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $76288626b30e899c$var$scheduleCallback$2($76288626b30e899c$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $76288626b30e899c$var$currentEntangledListeners = null, $76288626b30e899c$var$currentEntangledPendingCount = 0, $76288626b30e899c$var$currentEntangledLane = 0, $76288626b30e899c$var$currentEntangledActionThenable = null;
function $76288626b30e899c$var$entangleAsyncAction(transition, thenable) {
    if (null === $76288626b30e899c$var$currentEntangledListeners) {
        var entangledListeners = $76288626b30e899c$var$currentEntangledListeners = [];
        $76288626b30e899c$var$currentEntangledPendingCount = 0;
        $76288626b30e899c$var$currentEntangledLane = $76288626b30e899c$var$requestTransitionLane();
        $76288626b30e899c$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $76288626b30e899c$var$currentEntangledPendingCount++;
    thenable.then($76288626b30e899c$var$pingEngtangledActionScope, $76288626b30e899c$var$pingEngtangledActionScope);
    return thenable;
}
function $76288626b30e899c$var$pingEngtangledActionScope() {
    if (0 === --$76288626b30e899c$var$currentEntangledPendingCount && null !== $76288626b30e899c$var$currentEntangledListeners) {
        null !== $76288626b30e899c$var$currentEntangledActionThenable && ($76288626b30e899c$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $76288626b30e899c$var$currentEntangledListeners;
        $76288626b30e899c$var$currentEntangledListeners = null;
        $76288626b30e899c$var$currentEntangledLane = 0;
        $76288626b30e899c$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $76288626b30e899c$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $76288626b30e899c$var$prevOnStartTransitionFinish = $76288626b30e899c$var$ReactSharedInternals.S;
$76288626b30e899c$var$ReactSharedInternals.S = function(transition, returnValue) {
    $76288626b30e899c$var$globalMostRecentTransitionTime = $76288626b30e899c$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $76288626b30e899c$var$entangleAsyncAction(transition, returnValue);
    null !== $76288626b30e899c$var$prevOnStartTransitionFinish && $76288626b30e899c$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $76288626b30e899c$var$resumedCache = $76288626b30e899c$var$createCursor(null);
function $76288626b30e899c$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $76288626b30e899c$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $76288626b30e899c$var$workInProgressRoot.pooledCache;
}
function $76288626b30e899c$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $76288626b30e899c$var$push($76288626b30e899c$var$resumedCache, $76288626b30e899c$var$resumedCache.current) : $76288626b30e899c$var$push($76288626b30e899c$var$resumedCache, prevCachePool.pool);
}
function $76288626b30e899c$var$getSuspendedCache() {
    var cacheFromPool = $76288626b30e899c$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $76288626b30e899c$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $76288626b30e899c$var$SuspenseException = Error($76288626b30e899c$var$formatProdErrorMessage(460)), $76288626b30e899c$var$SuspenseyCommitException = Error($76288626b30e899c$var$formatProdErrorMessage(474)), $76288626b30e899c$var$SuspenseActionException = Error($76288626b30e899c$var$formatProdErrorMessage(542)), $76288626b30e899c$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $76288626b30e899c$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $76288626b30e899c$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($76288626b30e899c$var$noop$1, $76288626b30e899c$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $76288626b30e899c$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($76288626b30e899c$var$noop$1, $76288626b30e899c$var$noop$1);
            else {
                thenableState = $76288626b30e899c$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($76288626b30e899c$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $76288626b30e899c$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $76288626b30e899c$var$suspendedThenable = thenable;
            throw $76288626b30e899c$var$SuspenseException;
    }
}
function $76288626b30e899c$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $76288626b30e899c$var$suspendedThenable = x, $76288626b30e899c$var$SuspenseException;
        throw x;
    }
}
var $76288626b30e899c$var$suspendedThenable = null;
function $76288626b30e899c$var$getSuspendedThenable() {
    if (null === $76288626b30e899c$var$suspendedThenable) throw Error($76288626b30e899c$var$formatProdErrorMessage(459));
    var thenable = $76288626b30e899c$var$suspendedThenable;
    $76288626b30e899c$var$suspendedThenable = null;
    return thenable;
}
function $76288626b30e899c$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $76288626b30e899c$var$SuspenseException || rejectedReason === $76288626b30e899c$var$SuspenseActionException) throw Error($76288626b30e899c$var$formatProdErrorMessage(483));
}
var $76288626b30e899c$var$thenableState$1 = null, $76288626b30e899c$var$thenableIndexCounter$1 = 0;
function $76288626b30e899c$var$unwrapThenable(thenable) {
    var index = $76288626b30e899c$var$thenableIndexCounter$1;
    $76288626b30e899c$var$thenableIndexCounter$1 += 1;
    null === $76288626b30e899c$var$thenableState$1 && ($76288626b30e899c$var$thenableState$1 = []);
    return $76288626b30e899c$var$trackUsedThenable($76288626b30e899c$var$thenableState$1, thenable, index);
}
function $76288626b30e899c$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $76288626b30e899c$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($76288626b30e899c$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($76288626b30e899c$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $76288626b30e899c$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $76288626b30e899c$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $76288626b30e899c$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $76288626b30e899c$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $76288626b30e899c$var$REACT_LAZY_TYPE && $76288626b30e899c$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $76288626b30e899c$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $76288626b30e899c$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $76288626b30e899c$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $76288626b30e899c$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $76288626b30e899c$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $76288626b30e899c$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    return lanes = $76288626b30e899c$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $76288626b30e899c$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    return newChild = $76288626b30e899c$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild) || $76288626b30e899c$var$getIteratorFn(newChild)) return newChild = $76288626b30e899c$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild) || $76288626b30e899c$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild) || $76288626b30e899c$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($76288626b30e899c$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $76288626b30e899c$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $76288626b30e899c$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $76288626b30e899c$var$REACT_LAZY_TYPE && $76288626b30e899c$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $76288626b30e899c$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $76288626b30e899c$var$REACT_FRAGMENT_TYPE ? (lanes = $76288626b30e899c$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $76288626b30e899c$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $76288626b30e899c$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $76288626b30e899c$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($76288626b30e899c$var$getIteratorFn(newChild)) {
                key = $76288626b30e899c$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($76288626b30e899c$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $76288626b30e899c$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $76288626b30e899c$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $76288626b30e899c$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $76288626b30e899c$var$SuspenseException || x === $76288626b30e899c$var$SuspenseActionException) throw x;
            var fiber = $76288626b30e899c$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $76288626b30e899c$var$reconcileChildFibers = $76288626b30e899c$var$createChildReconciler(!0), $76288626b30e899c$var$mountChildFibers = $76288626b30e899c$var$createChildReconciler(!1), $76288626b30e899c$var$hasForceUpdate = !1;
function $76288626b30e899c$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $76288626b30e899c$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $76288626b30e899c$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $76288626b30e899c$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($76288626b30e899c$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
        $76288626b30e899c$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $76288626b30e899c$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
}
function $76288626b30e899c$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $76288626b30e899c$var$markRootEntangled(root, lane);
    }
}
function $76288626b30e899c$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $76288626b30e899c$var$didReadFromEntangledAsyncAction = !1;
function $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($76288626b30e899c$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $76288626b30e899c$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $76288626b30e899c$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $76288626b30e899c$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $76288626b30e899c$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($76288626b30e899c$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $76288626b30e899c$var$currentEntangledLane && ($76288626b30e899c$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $76288626b30e899c$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $76288626b30e899c$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $76288626b30e899c$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $76288626b30e899c$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($76288626b30e899c$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $76288626b30e899c$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$76288626b30e899c$var$callCallback(callbacks[updateQueue], context);
}
var $76288626b30e899c$var$currentTreeHiddenStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$prevEntangledRenderLanesCursor = $76288626b30e899c$var$createCursor(0);
function $76288626b30e899c$var$pushHiddenContext(fiber, context) {
    fiber = $76288626b30e899c$var$entangledRenderLanes;
    $76288626b30e899c$var$push($76288626b30e899c$var$prevEntangledRenderLanesCursor, fiber);
    $76288626b30e899c$var$push($76288626b30e899c$var$currentTreeHiddenStackCursor, context);
    $76288626b30e899c$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $76288626b30e899c$var$reuseHiddenContextOnStack() {
    $76288626b30e899c$var$push($76288626b30e899c$var$prevEntangledRenderLanesCursor, $76288626b30e899c$var$entangledRenderLanes);
    $76288626b30e899c$var$push($76288626b30e899c$var$currentTreeHiddenStackCursor, $76288626b30e899c$var$currentTreeHiddenStackCursor.current);
}
function $76288626b30e899c$var$popHiddenContext() {
    $76288626b30e899c$var$entangledRenderLanes = $76288626b30e899c$var$prevEntangledRenderLanesCursor.current;
    $76288626b30e899c$var$pop($76288626b30e899c$var$currentTreeHiddenStackCursor);
    $76288626b30e899c$var$pop($76288626b30e899c$var$prevEntangledRenderLanesCursor);
}
var $76288626b30e899c$var$suspenseHandlerStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$shellBoundary = null;
function $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current & 1);
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, handler);
    null === $76288626b30e899c$var$shellBoundary && (null === current || null !== $76288626b30e899c$var$currentTreeHiddenStackCursor.current ? $76288626b30e899c$var$shellBoundary = handler : null !== current.memoizedState && ($76288626b30e899c$var$shellBoundary = handler));
}
function $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current);
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, fiber);
    null === $76288626b30e899c$var$shellBoundary && ($76288626b30e899c$var$shellBoundary = fiber);
}
function $76288626b30e899c$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current), $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, fiber), null === $76288626b30e899c$var$shellBoundary && ($76288626b30e899c$var$shellBoundary = fiber)) : $76288626b30e899c$var$reuseSuspenseHandlerOnStack(fiber);
}
function $76288626b30e899c$var$reuseSuspenseHandlerOnStack() {
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current);
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, $76288626b30e899c$var$suspenseHandlerStackCursor.current);
}
function $76288626b30e899c$var$popSuspenseHandler(fiber) {
    $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseHandlerStackCursor);
    $76288626b30e899c$var$shellBoundary === fiber && ($76288626b30e899c$var$shellBoundary = null);
    $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor);
}
var $76288626b30e899c$var$suspenseStackCursor = $76288626b30e899c$var$createCursor(0);
function $76288626b30e899c$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $76288626b30e899c$var$isSuspenseInstancePending(state) || $76288626b30e899c$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $76288626b30e899c$var$renderLanes = 0, $76288626b30e899c$var$currentlyRenderingFiber = null, $76288626b30e899c$var$currentHook = null, $76288626b30e899c$var$workInProgressHook = null, $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !1, $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $76288626b30e899c$var$localIdCounter = 0, $76288626b30e899c$var$thenableIndexCounter = 0, $76288626b30e899c$var$thenableState = null, $76288626b30e899c$var$globalClientIdCounter = 0;
function $76288626b30e899c$var$throwInvalidHookError() {
    throw Error($76288626b30e899c$var$formatProdErrorMessage(321));
}
function $76288626b30e899c$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$76288626b30e899c$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $76288626b30e899c$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $76288626b30e899c$var$renderLanes = nextRenderLanes;
    $76288626b30e899c$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $76288626b30e899c$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $76288626b30e899c$var$HooksDispatcherOnMount : $76288626b30e899c$var$HooksDispatcherOnUpdate;
    $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $76288626b30e899c$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $76288626b30e899c$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $76288626b30e899c$var$finishRenderingHooks(current) {
    $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $76288626b30e899c$var$currentHook && null !== $76288626b30e899c$var$currentHook.next;
    $76288626b30e899c$var$renderLanes = 0;
    $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$currentHook = $76288626b30e899c$var$currentlyRenderingFiber = null;
    $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !1;
    $76288626b30e899c$var$thenableIndexCounter = 0;
    $76288626b30e899c$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($76288626b30e899c$var$formatProdErrorMessage(300));
    null === current || $76288626b30e899c$var$didReceiveUpdate || (current = current.dependencies, null !== current && $76288626b30e899c$var$checkIfContextChanged(current) && ($76288626b30e899c$var$didReceiveUpdate = !0));
}
function $76288626b30e899c$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $76288626b30e899c$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass && ($76288626b30e899c$var$thenableState = null);
        $76288626b30e899c$var$thenableIndexCounter = 0;
        $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($76288626b30e899c$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $76288626b30e899c$var$TransitionAwareHostComponent() {
    var dispatcher = $76288626b30e899c$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $76288626b30e899c$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $76288626b30e899c$var$currentHook ? $76288626b30e899c$var$currentHook.memoizedState : null) !== dispatcher && ($76288626b30e899c$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $76288626b30e899c$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $76288626b30e899c$var$localIdCounter;
    $76288626b30e899c$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $76288626b30e899c$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $76288626b30e899c$var$resetHooksOnUnwind(workInProgress) {
    if ($76288626b30e899c$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !1;
    }
    $76288626b30e899c$var$renderLanes = 0;
    $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$currentHook = $76288626b30e899c$var$currentlyRenderingFiber = null;
    $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $76288626b30e899c$var$thenableIndexCounter = $76288626b30e899c$var$localIdCounter = 0;
    $76288626b30e899c$var$thenableState = null;
}
function $76288626b30e899c$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $76288626b30e899c$var$workInProgressHook ? $76288626b30e899c$var$currentlyRenderingFiber.memoizedState = $76288626b30e899c$var$workInProgressHook = hook : $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$workInProgressHook.next = hook;
    return $76288626b30e899c$var$workInProgressHook;
}
function $76288626b30e899c$var$updateWorkInProgressHook() {
    if (null === $76288626b30e899c$var$currentHook) {
        var nextCurrentHook = $76288626b30e899c$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $76288626b30e899c$var$currentHook.next;
    var nextWorkInProgressHook = null === $76288626b30e899c$var$workInProgressHook ? $76288626b30e899c$var$currentlyRenderingFiber.memoizedState : $76288626b30e899c$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $76288626b30e899c$var$workInProgressHook = nextWorkInProgressHook, $76288626b30e899c$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $76288626b30e899c$var$currentlyRenderingFiber.alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(467));
            throw Error($76288626b30e899c$var$formatProdErrorMessage(310));
        }
        $76288626b30e899c$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $76288626b30e899c$var$currentHook.memoizedState,
            baseState: $76288626b30e899c$var$currentHook.baseState,
            baseQueue: $76288626b30e899c$var$currentHook.baseQueue,
            queue: $76288626b30e899c$var$currentHook.queue,
            next: null
        };
        null === $76288626b30e899c$var$workInProgressHook ? $76288626b30e899c$var$currentlyRenderingFiber.memoizedState = $76288626b30e899c$var$workInProgressHook = nextCurrentHook : $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$workInProgressHook.next = nextCurrentHook;
    }
    return $76288626b30e899c$var$workInProgressHook;
}
function $76288626b30e899c$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $76288626b30e899c$var$useThenable(thenable) {
    var index = $76288626b30e899c$var$thenableIndexCounter;
    $76288626b30e899c$var$thenableIndexCounter += 1;
    null === $76288626b30e899c$var$thenableState && ($76288626b30e899c$var$thenableState = []);
    thenable = $76288626b30e899c$var$trackUsedThenable($76288626b30e899c$var$thenableState, thenable, index);
    index = $76288626b30e899c$var$currentlyRenderingFiber;
    null === (null === $76288626b30e899c$var$workInProgressHook ? index.memoizedState : $76288626b30e899c$var$workInProgressHook.next) && (index = index.alternate, $76288626b30e899c$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $76288626b30e899c$var$HooksDispatcherOnMount : $76288626b30e899c$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $76288626b30e899c$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $76288626b30e899c$var$useThenable(usable);
        if (usable.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return $76288626b30e899c$var$readContext(usable);
    }
    throw Error($76288626b30e899c$var$formatProdErrorMessage(438, String(usable)));
}
function $76288626b30e899c$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $76288626b30e899c$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $76288626b30e899c$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $76288626b30e899c$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $76288626b30e899c$var$updateReducer(reducer) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    return $76288626b30e899c$var$updateReducerImpl(hook, $76288626b30e899c$var$currentHook, reducer);
}
function $76288626b30e899c$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($76288626b30e899c$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($76288626b30e899c$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($76288626b30e899c$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $76288626b30e899c$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($76288626b30e899c$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $76288626b30e899c$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $76288626b30e899c$var$currentlyRenderingFiber.lanes |= revertLane, $76288626b30e899c$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $76288626b30e899c$var$currentlyRenderingFiber.lanes |= updateLane, $76288626b30e899c$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$76288626b30e899c$var$objectIs(pendingQueue, hook.memoizedState) && ($76288626b30e899c$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $76288626b30e899c$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $76288626b30e899c$var$rerenderReducer(reducer) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($76288626b30e899c$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $76288626b30e899c$var$objectIs(newState, hook.memoizedState) || ($76288626b30e899c$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $76288626b30e899c$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $76288626b30e899c$var$currentlyRenderingFiber, hook = $76288626b30e899c$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $76288626b30e899c$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($76288626b30e899c$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$76288626b30e899c$var$objectIs(($76288626b30e899c$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $76288626b30e899c$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $76288626b30e899c$var$updateEffect($76288626b30e899c$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $76288626b30e899c$var$workInProgressHook && $76288626b30e899c$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $76288626b30e899c$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $76288626b30e899c$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $76288626b30e899c$var$workInProgressRoot) throw Error($76288626b30e899c$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($76288626b30e899c$var$renderLanes & 127) || $76288626b30e899c$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $76288626b30e899c$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $76288626b30e899c$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $76288626b30e899c$var$checkIfSnapshotChanged(inst) && $76288626b30e899c$var$forceStoreRerender(fiber);
}
function $76288626b30e899c$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $76288626b30e899c$var$checkIfSnapshotChanged(inst) && $76288626b30e899c$var$forceStoreRerender(fiber);
    });
}
function $76288626b30e899c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$76288626b30e899c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $76288626b30e899c$var$forceStoreRerender(fiber) {
    var root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $76288626b30e899c$var$mountStateImpl(initialState) {
    var hook = $76288626b30e899c$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $76288626b30e899c$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $76288626b30e899c$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $76288626b30e899c$var$updateReducerImpl(hook, $76288626b30e899c$var$currentHook, "function" === typeof reducer ? reducer : $76288626b30e899c$var$basicStateReducer);
}
function $76288626b30e899c$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($76288626b30e899c$var$isRenderPhaseUpdate(fiber)) throw Error($76288626b30e899c$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $76288626b30e899c$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $76288626b30e899c$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $76288626b30e899c$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T, currentTransition = {};
        $76288626b30e899c$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $76288626b30e899c$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $76288626b30e899c$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $76288626b30e899c$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $76288626b30e899c$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $76288626b30e899c$var$onActionError(actionQueue, node, error$66);
    }
}
function $76288626b30e899c$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $76288626b30e899c$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $76288626b30e899c$var$onActionError(actionQueue, node, error);
    }) : $76288626b30e899c$var$onActionSuccess(actionQueue, node, returnValue);
}
function $76288626b30e899c$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $76288626b30e899c$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $76288626b30e899c$var$runActionStateAction(actionQueue, nextState)));
}
function $76288626b30e899c$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $76288626b30e899c$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $76288626b30e899c$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $76288626b30e899c$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $76288626b30e899c$var$mountActionState(action, initialStateProp) {
    if ($76288626b30e899c$var$isHydrating) {
        var ssrFormState = $76288626b30e899c$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $76288626b30e899c$var$currentlyRenderingFiber;
                if ($76288626b30e899c$var$isHydrating) {
                    if ($76288626b30e899c$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $76288626b30e899c$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $76288626b30e899c$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $76288626b30e899c$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $76288626b30e899c$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $76288626b30e899c$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $76288626b30e899c$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $76288626b30e899c$var$dispatchSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $76288626b30e899c$var$mountStateImpl(!1);
    inRootOrSingleton = $76288626b30e899c$var$dispatchOptimisticSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $76288626b30e899c$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $76288626b30e899c$var$dispatchActionState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $76288626b30e899c$var$updateActionState(action) {
    var stateHook = $76288626b30e899c$var$updateWorkInProgressHook();
    return $76288626b30e899c$var$updateActionStateImpl(stateHook, $76288626b30e899c$var$currentHook, action);
}
function $76288626b30e899c$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $76288626b30e899c$var$updateReducerImpl(stateHook, currentStateHook, $76288626b30e899c$var$actionStateReducer)[0];
    stateHook = $76288626b30e899c$var$updateReducer($76288626b30e899c$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $76288626b30e899c$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $76288626b30e899c$var$SuspenseException) throw $76288626b30e899c$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $76288626b30e899c$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($76288626b30e899c$var$currentlyRenderingFiber.flags |= 2048, $76288626b30e899c$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $76288626b30e899c$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $76288626b30e899c$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $76288626b30e899c$var$rerenderActionState(action) {
    var stateHook = $76288626b30e899c$var$updateWorkInProgressHook(), currentStateHook = $76288626b30e899c$var$currentHook;
    if (null !== currentStateHook) return $76288626b30e899c$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $76288626b30e899c$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $76288626b30e899c$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $76288626b30e899c$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $76288626b30e899c$var$updateRef() {
    return $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
}
function $76288626b30e899c$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $76288626b30e899c$var$mountWorkInProgressHook();
    $76288626b30e899c$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $76288626b30e899c$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $76288626b30e899c$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $76288626b30e899c$var$currentHook && null !== deps && $76288626b30e899c$var$areHookInputsEqual(deps, $76288626b30e899c$var$currentHook.memoizedState.deps) ? hook.memoizedState = $76288626b30e899c$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($76288626b30e899c$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $76288626b30e899c$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $76288626b30e899c$var$mountEffect(create, deps) {
    $76288626b30e899c$var$mountEffectImpl(8390656, 8, create, deps);
}
function $76288626b30e899c$var$updateEffect(create, deps) {
    $76288626b30e899c$var$updateEffectImpl(2048, 8, create, deps);
}
function $76288626b30e899c$var$useEffectEventImpl(payload) {
    $76288626b30e899c$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $76288626b30e899c$var$updateEvent(callback) {
    var ref = $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
    $76288626b30e899c$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($76288626b30e899c$var$executionContext & 2)) throw Error($76288626b30e899c$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $76288626b30e899c$var$updateInsertionEffect(create, deps) {
    return $76288626b30e899c$var$updateEffectImpl(4, 2, create, deps);
}
function $76288626b30e899c$var$updateLayoutEffect(create, deps) {
    return $76288626b30e899c$var$updateEffectImpl(4, 4, create, deps);
}
function $76288626b30e899c$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $76288626b30e899c$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $76288626b30e899c$var$updateEffectImpl(4, 4, $76288626b30e899c$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $76288626b30e899c$var$mountDebugValue() {}
function $76288626b30e899c$var$updateCallback(callback, deps) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $76288626b30e899c$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $76288626b30e899c$var$updateMemo(nextCreate, deps) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $76288626b30e899c$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($76288626b30e899c$var$renderLanes & 1073741824) && 0 === ($76288626b30e899c$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $76288626b30e899c$var$requestDeferredLane();
    $76288626b30e899c$var$currentlyRenderingFiber.lanes |= hook;
    $76288626b30e899c$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $76288626b30e899c$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($76288626b30e899c$var$objectIs(value, prevValue)) return value;
    if (null !== $76288626b30e899c$var$currentTreeHiddenStackCursor.current) return hook = $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue), $76288626b30e899c$var$objectIs(hook, prevValue) || ($76288626b30e899c$var$didReceiveUpdate = !0), hook;
    if (0 === ($76288626b30e899c$var$renderLanes & 42) || 0 !== ($76288626b30e899c$var$renderLanes & 1073741824) && 0 === ($76288626b30e899c$var$workInProgressRootRenderLanes & 261930)) return $76288626b30e899c$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $76288626b30e899c$var$requestDeferredLane();
    $76288626b30e899c$var$currentlyRenderingFiber.lanes |= hook;
    $76288626b30e899c$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $76288626b30e899c$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    $76288626b30e899c$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T, currentTransition = {};
    $76288626b30e899c$var$ReactSharedInternals.T = currentTransition;
    $76288626b30e899c$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $76288626b30e899c$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $76288626b30e899c$var$chainThenableValue(returnValue, finishedState);
            $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $76288626b30e899c$var$requestUpdateLane(fiber));
        } else $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, finishedState, $76288626b30e899c$var$requestUpdateLane(fiber));
    } catch (error) {
        $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $76288626b30e899c$var$requestUpdateLane());
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $76288626b30e899c$var$noop() {}
function $76288626b30e899c$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($76288626b30e899c$var$formatProdErrorMessage(476));
    var queue = $76288626b30e899c$var$ensureFormComponentIsStateful(formFiber).queue;
    $76288626b30e899c$var$startTransition(formFiber, queue, pendingState, $76288626b30e899c$var$sharedNotPendingObject, null === action ? $76288626b30e899c$var$noop : function() {
        $76288626b30e899c$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $76288626b30e899c$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $76288626b30e899c$var$sharedNotPendingObject,
        baseState: $76288626b30e899c$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $76288626b30e899c$var$basicStateReducer,
            lastRenderedState: $76288626b30e899c$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $76288626b30e899c$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $76288626b30e899c$var$requestFormReset$1(formFiber) {
    var stateHook = $76288626b30e899c$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $76288626b30e899c$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $76288626b30e899c$var$requestUpdateLane());
}
function $76288626b30e899c$var$useHostTransitionStatus() {
    return $76288626b30e899c$var$readContext($76288626b30e899c$var$HostTransitionContext);
}
function $76288626b30e899c$var$updateId() {
    return $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
}
function $76288626b30e899c$var$updateRefresh() {
    return $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
}
function $76288626b30e899c$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $76288626b30e899c$var$requestUpdateLane();
                fiber = $76288626b30e899c$var$createUpdate(lane);
                var root$69 = $76288626b30e899c$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($76288626b30e899c$var$scheduleUpdateOnFiber(root$69, provider, lane), $76288626b30e899c$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $76288626b30e899c$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $76288626b30e899c$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $76288626b30e899c$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $76288626b30e899c$var$isRenderPhaseUpdate(fiber) ? $76288626b30e899c$var$enqueueRenderPhaseUpdate(queue, action) : (action = $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($76288626b30e899c$var$scheduleUpdateOnFiber(action, fiber, lane), $76288626b30e899c$var$entangleTransitionUpdate(action, queue, lane)));
}
function $76288626b30e899c$var$dispatchSetState(fiber, queue, action) {
    var lane = $76288626b30e899c$var$requestUpdateLane();
    $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($76288626b30e899c$var$isRenderPhaseUpdate(fiber)) $76288626b30e899c$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($76288626b30e899c$var$objectIs(eagerState, currentState)) return $76288626b30e899c$var$enqueueUpdate$1(fiber, queue, update, 0), null === $76288626b30e899c$var$workInProgressRoot && $76288626b30e899c$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $76288626b30e899c$var$scheduleUpdateOnFiber(action, fiber, lane), $76288626b30e899c$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $76288626b30e899c$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $76288626b30e899c$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($76288626b30e899c$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($76288626b30e899c$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $76288626b30e899c$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $76288626b30e899c$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $76288626b30e899c$var$currentlyRenderingFiber || null !== alternate && alternate === $76288626b30e899c$var$currentlyRenderingFiber;
}
function $76288626b30e899c$var$enqueueRenderPhaseUpdate(queue, update) {
    $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $76288626b30e899c$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $76288626b30e899c$var$markRootEntangled(root, lane);
    }
}
var $76288626b30e899c$var$ContextOnlyDispatcher = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: $76288626b30e899c$var$throwInvalidHookError,
    useContext: $76288626b30e899c$var$throwInvalidHookError,
    useEffect: $76288626b30e899c$var$throwInvalidHookError,
    useImperativeHandle: $76288626b30e899c$var$throwInvalidHookError,
    useLayoutEffect: $76288626b30e899c$var$throwInvalidHookError,
    useInsertionEffect: $76288626b30e899c$var$throwInvalidHookError,
    useMemo: $76288626b30e899c$var$throwInvalidHookError,
    useReducer: $76288626b30e899c$var$throwInvalidHookError,
    useRef: $76288626b30e899c$var$throwInvalidHookError,
    useState: $76288626b30e899c$var$throwInvalidHookError,
    useDebugValue: $76288626b30e899c$var$throwInvalidHookError,
    useDeferredValue: $76288626b30e899c$var$throwInvalidHookError,
    useTransition: $76288626b30e899c$var$throwInvalidHookError,
    useSyncExternalStore: $76288626b30e899c$var$throwInvalidHookError,
    useId: $76288626b30e899c$var$throwInvalidHookError,
    useHostTransitionStatus: $76288626b30e899c$var$throwInvalidHookError,
    useFormState: $76288626b30e899c$var$throwInvalidHookError,
    useActionState: $76288626b30e899c$var$throwInvalidHookError,
    useOptimistic: $76288626b30e899c$var$throwInvalidHookError,
    useMemoCache: $76288626b30e899c$var$throwInvalidHookError,
    useCacheRefresh: $76288626b30e899c$var$throwInvalidHookError
};
$76288626b30e899c$var$ContextOnlyDispatcher.useEffectEvent = $76288626b30e899c$var$throwInvalidHookError;
var $76288626b30e899c$var$HooksDispatcherOnMount = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: function(callback, deps) {
        $76288626b30e899c$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $76288626b30e899c$var$readContext,
    useEffect: $76288626b30e899c$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $76288626b30e899c$var$mountEffectImpl(4194308, 4, $76288626b30e899c$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $76288626b30e899c$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $76288626b30e899c$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $76288626b30e899c$var$dispatchReducerAction.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $76288626b30e899c$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $76288626b30e899c$var$dispatchSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $76288626b30e899c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        return $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $76288626b30e899c$var$mountStateImpl(!1);
        stateHook = $76288626b30e899c$var$startTransition.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $76288626b30e899c$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $76288626b30e899c$var$currentlyRenderingFiber, hook = $76288626b30e899c$var$mountWorkInProgressHook();
        if ($76288626b30e899c$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($76288626b30e899c$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $76288626b30e899c$var$workInProgressRoot) throw Error($76288626b30e899c$var$formatProdErrorMessage(349));
            0 !== ($76288626b30e899c$var$workInProgressRootRenderLanes & 127) || $76288626b30e899c$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $76288626b30e899c$var$mountEffect($76288626b30e899c$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $76288626b30e899c$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $76288626b30e899c$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook(), identifierPrefix = $76288626b30e899c$var$workInProgressRoot.identifierPrefix;
        if ($76288626b30e899c$var$isHydrating) {
            var JSCompiler_inline_result = $76288626b30e899c$var$treeContextOverflow;
            var idWithLeadingBit = $76288626b30e899c$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $76288626b30e899c$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $76288626b30e899c$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $76288626b30e899c$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $76288626b30e899c$var$useHostTransitionStatus,
    useFormState: $76288626b30e899c$var$mountActionState,
    useActionState: $76288626b30e899c$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $76288626b30e899c$var$dispatchOptimisticSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $76288626b30e899c$var$useMemoCache,
    useCacheRefresh: function() {
        return $76288626b30e899c$var$mountWorkInProgressHook().memoizedState = $76288626b30e899c$var$refreshCache.bind(null, $76288626b30e899c$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($76288626b30e899c$var$executionContext & 2)) throw Error($76288626b30e899c$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $76288626b30e899c$var$HooksDispatcherOnUpdate = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: $76288626b30e899c$var$updateCallback,
    useContext: $76288626b30e899c$var$readContext,
    useEffect: $76288626b30e899c$var$updateEffect,
    useImperativeHandle: $76288626b30e899c$var$updateImperativeHandle,
    useInsertionEffect: $76288626b30e899c$var$updateInsertionEffect,
    useLayoutEffect: $76288626b30e899c$var$updateLayoutEffect,
    useMemo: $76288626b30e899c$var$updateMemo,
    useReducer: $76288626b30e899c$var$updateReducer,
    useRef: $76288626b30e899c$var$updateRef,
    useState: function() {
        return $76288626b30e899c$var$updateReducer($76288626b30e899c$var$basicStateReducer);
    },
    useDebugValue: $76288626b30e899c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        return $76288626b30e899c$var$updateDeferredValueImpl(hook, $76288626b30e899c$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $76288626b30e899c$var$updateReducer($76288626b30e899c$var$basicStateReducer)[0], start = $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $76288626b30e899c$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $76288626b30e899c$var$updateSyncExternalStore,
    useId: $76288626b30e899c$var$updateId,
    useHostTransitionStatus: $76288626b30e899c$var$useHostTransitionStatus,
    useFormState: $76288626b30e899c$var$updateActionState,
    useActionState: $76288626b30e899c$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        return $76288626b30e899c$var$updateOptimisticImpl(hook, $76288626b30e899c$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $76288626b30e899c$var$useMemoCache,
    useCacheRefresh: $76288626b30e899c$var$updateRefresh
};
$76288626b30e899c$var$HooksDispatcherOnUpdate.useEffectEvent = $76288626b30e899c$var$updateEvent;
var $76288626b30e899c$var$HooksDispatcherOnRerender = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: $76288626b30e899c$var$updateCallback,
    useContext: $76288626b30e899c$var$readContext,
    useEffect: $76288626b30e899c$var$updateEffect,
    useImperativeHandle: $76288626b30e899c$var$updateImperativeHandle,
    useInsertionEffect: $76288626b30e899c$var$updateInsertionEffect,
    useLayoutEffect: $76288626b30e899c$var$updateLayoutEffect,
    useMemo: $76288626b30e899c$var$updateMemo,
    useReducer: $76288626b30e899c$var$rerenderReducer,
    useRef: $76288626b30e899c$var$updateRef,
    useState: function() {
        return $76288626b30e899c$var$rerenderReducer($76288626b30e899c$var$basicStateReducer);
    },
    useDebugValue: $76288626b30e899c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        return null === $76288626b30e899c$var$currentHook ? $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue) : $76288626b30e899c$var$updateDeferredValueImpl(hook, $76288626b30e899c$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $76288626b30e899c$var$rerenderReducer($76288626b30e899c$var$basicStateReducer)[0], start = $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $76288626b30e899c$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $76288626b30e899c$var$updateSyncExternalStore,
    useId: $76288626b30e899c$var$updateId,
    useHostTransitionStatus: $76288626b30e899c$var$useHostTransitionStatus,
    useFormState: $76288626b30e899c$var$rerenderActionState,
    useActionState: $76288626b30e899c$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        if (null !== $76288626b30e899c$var$currentHook) return $76288626b30e899c$var$updateOptimisticImpl(hook, $76288626b30e899c$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $76288626b30e899c$var$useMemoCache,
    useCacheRefresh: $76288626b30e899c$var$updateRefresh
};
$76288626b30e899c$var$HooksDispatcherOnRerender.useEffectEvent = $76288626b30e899c$var$updateEvent;
function $76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $76288626b30e899c$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $76288626b30e899c$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $76288626b30e899c$var$requestUpdateLane(), update = $76288626b30e899c$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $76288626b30e899c$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($76288626b30e899c$var$scheduleUpdateOnFiber(payload, inst, lane), $76288626b30e899c$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $76288626b30e899c$var$requestUpdateLane(), update = $76288626b30e899c$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $76288626b30e899c$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($76288626b30e899c$var$scheduleUpdateOnFiber(payload, inst, lane), $76288626b30e899c$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $76288626b30e899c$var$requestUpdateLane(), update = $76288626b30e899c$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $76288626b30e899c$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($76288626b30e899c$var$scheduleUpdateOnFiber(callback, inst, lane), $76288626b30e899c$var$entangleTransitions(callback, inst, lane));
    }
};
function $76288626b30e899c$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$76288626b30e899c$var$shallowEqual(oldProps, newProps) || !$76288626b30e899c$var$shallowEqual(oldState, newState) : !0;
}
function $76288626b30e899c$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $76288626b30e899c$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $76288626b30e899c$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $76288626b30e899c$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $76288626b30e899c$var$defaultOnUncaughtError(error) {
    $76288626b30e899c$var$reportGlobalError(error);
}
function $76288626b30e899c$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $76288626b30e899c$var$defaultOnRecoverableError(error) {
    $76288626b30e899c$var$reportGlobalError(error);
}
function $76288626b30e899c$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $76288626b30e899c$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $76288626b30e899c$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $76288626b30e899c$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $76288626b30e899c$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $76288626b30e899c$var$createClassErrorUpdate(lane) {
    lane = $76288626b30e899c$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $76288626b30e899c$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $76288626b30e899c$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $76288626b30e899c$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed ? $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $76288626b30e899c$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $76288626b30e899c$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $76288626b30e899c$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $76288626b30e899c$var$shellBoundary ? $76288626b30e899c$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $76288626b30e899c$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $76288626b30e899c$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $76288626b30e899c$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $76288626b30e899c$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($76288626b30e899c$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $76288626b30e899c$var$attachPingListener(root, value, rootRenderLanes);
        $76288626b30e899c$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($76288626b30e899c$var$isHydrating) return returnFiber = $76288626b30e899c$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $76288626b30e899c$var$HydrationMismatchException && (root = Error($76288626b30e899c$var$formatProdErrorMessage(422), {
        cause: value
    }), $76288626b30e899c$var$queueHydrationError($76288626b30e899c$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $76288626b30e899c$var$HydrationMismatchException && (returnFiber = Error($76288626b30e899c$var$formatProdErrorMessage(423), {
        cause: value
    }), $76288626b30e899c$var$queueHydrationError($76288626b30e899c$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $76288626b30e899c$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $76288626b30e899c$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $76288626b30e899c$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($76288626b30e899c$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $76288626b30e899c$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $76288626b30e899c$var$workInProgressRootConcurrentErrors ? $76288626b30e899c$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $76288626b30e899c$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $76288626b30e899c$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $76288626b30e899c$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $76288626b30e899c$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed || !$76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $76288626b30e899c$var$createClassErrorUpdate(rootRenderLanes), $76288626b30e899c$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $76288626b30e899c$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $76288626b30e899c$var$SelectiveHydrationException = Error($76288626b30e899c$var$formatProdErrorMessage(461)), $76288626b30e899c$var$didReceiveUpdate = !1;
function $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $76288626b30e899c$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $76288626b30e899c$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    nextProps = $76288626b30e899c$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $76288626b30e899c$var$checkDidRenderIdHook();
    if (null !== current && !$76288626b30e899c$var$didReceiveUpdate) return $76288626b30e899c$var$bailoutHooks(current, workInProgress, renderLanes), $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $76288626b30e899c$var$isHydrating && key && $76288626b30e899c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$76288626b30e899c$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $76288626b30e899c$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $76288626b30e899c$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $76288626b30e899c$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $76288626b30e899c$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $76288626b30e899c$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($76288626b30e899c$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($76288626b30e899c$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($76288626b30e899c$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $76288626b30e899c$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $76288626b30e899c$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $76288626b30e899c$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $76288626b30e899c$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $76288626b30e899c$var$pushHiddenContext(workInProgress, prevState) : $76288626b30e899c$var$reuseHiddenContextOnStack(), $76288626b30e899c$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $76288626b30e899c$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($76288626b30e899c$var$pushTransition(workInProgress, prevState.cachePool), $76288626b30e899c$var$pushHiddenContext(workInProgress, prevState), $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $76288626b30e899c$var$pushTransition(workInProgress, null), $76288626b30e899c$var$reuseHiddenContextOnStack(), $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress));
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $76288626b30e899c$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $76288626b30e899c$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $76288626b30e899c$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $76288626b30e899c$var$pushTransition(workInProgress, null);
    $76288626b30e899c$var$reuseHiddenContextOnStack();
    $76288626b30e899c$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $76288626b30e899c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $76288626b30e899c$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $76288626b30e899c$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $76288626b30e899c$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($76288626b30e899c$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $76288626b30e899c$var$bailoutOffscreenComponent(null, current);
            $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $76288626b30e899c$var$nextHydratableInstance) ? (current = $76288626b30e899c$var$canHydrateHydrationBoundary(current, $76288626b30e899c$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $76288626b30e899c$var$treeContextProvider ? {
                    id: $76288626b30e899c$var$treeContextId,
                    overflow: $76288626b30e899c$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $76288626b30e899c$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $76288626b30e899c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($76288626b30e899c$var$formatProdErrorMessage(558));
        } else if ($76288626b30e899c$var$didReceiveUpdate || $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $76288626b30e899c$var$didReceiveUpdate || didSuspend) {
            nextProps = $76288626b30e899c$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $76288626b30e899c$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $76288626b30e899c$var$enqueueConcurrentRenderForLane(current, dehydrated), $76288626b30e899c$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $76288626b30e899c$var$SelectiveHydrationException;
            $76288626b30e899c$var$renderDidSuspendDelayIfPossible();
            workInProgress = $76288626b30e899c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(dehydrated.nextSibling), $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$isHydrating = !0, $76288626b30e899c$var$hydrationErrors = null, $76288626b30e899c$var$rootOrSingletonContext = !1, null !== current && $76288626b30e899c$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $76288626b30e899c$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $76288626b30e899c$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($76288626b30e899c$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $76288626b30e899c$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    Component = $76288626b30e899c$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $76288626b30e899c$var$checkDidRenderIdHook();
    if (null !== current && !$76288626b30e899c$var$didReceiveUpdate) return $76288626b30e899c$var$bailoutHooks(current, workInProgress, renderLanes), $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $76288626b30e899c$var$isHydrating && nextProps && $76288626b30e899c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $76288626b30e899c$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $76288626b30e899c$var$finishRenderingHooks(current);
    Component = $76288626b30e899c$var$checkDidRenderIdHook();
    if (null !== current && !$76288626b30e899c$var$didReceiveUpdate) return $76288626b30e899c$var$bailoutHooks(current, workInProgress, renderLanes), $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $76288626b30e899c$var$isHydrating && Component && $76288626b30e899c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $76288626b30e899c$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $76288626b30e899c$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $76288626b30e899c$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $76288626b30e899c$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $76288626b30e899c$var$readContext(contextType) : $76288626b30e899c$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $76288626b30e899c$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $76288626b30e899c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $76288626b30e899c$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $76288626b30e899c$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $76288626b30e899c$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $76288626b30e899c$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $76288626b30e899c$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $76288626b30e899c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $76288626b30e899c$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $76288626b30e899c$var$hasForceUpdate || $76288626b30e899c$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $76288626b30e899c$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $76288626b30e899c$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $76288626b30e899c$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $76288626b30e899c$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $76288626b30e899c$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $76288626b30e899c$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $76288626b30e899c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $76288626b30e899c$var$hasForceUpdate || null !== current && null !== current.dependencies && $76288626b30e899c$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $76288626b30e899c$var$hasForceUpdate || $76288626b30e899c$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $76288626b30e899c$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $76288626b30e899c$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $76288626b30e899c$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $76288626b30e899c$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $76288626b30e899c$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $76288626b30e899c$var$resetHydrationState();
    workInProgress.flags |= 256;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $76288626b30e899c$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $76288626b30e899c$var$getSuspendedCache()
    };
}
function $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $76288626b30e899c$var$workInProgressDeferredLane);
    return current;
}
function $76288626b30e899c$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($76288626b30e899c$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($76288626b30e899c$var$isHydrating) {
            showFallback ? $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $76288626b30e899c$var$nextHydratableInstance) ? (current = $76288626b30e899c$var$canHydrateHydrationBoundary(current, $76288626b30e899c$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $76288626b30e899c$var$treeContextProvider ? {
                    id: $76288626b30e899c$var$treeContextId,
                    overflow: $76288626b30e899c$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $76288626b30e899c$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            $76288626b30e899c$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $76288626b30e899c$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $76288626b30e899c$var$SUSPENDED_MARKER, $76288626b30e899c$var$bailoutOffscreenComponent(null, nextProps);
        $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $76288626b30e899c$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $76288626b30e899c$var$SUSPENDED_MARKER, workInProgress = $76288626b30e899c$var$bailoutOffscreenComponent(null, nextProps));
        else if ($76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress), $76288626b30e899c$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($76288626b30e899c$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $76288626b30e899c$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($76288626b30e899c$var$didReceiveUpdate || $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $76288626b30e899c$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $76288626b30e899c$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $76288626b30e899c$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $76288626b30e899c$var$enqueueConcurrentRenderForLane(current, nextProps), $76288626b30e899c$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $76288626b30e899c$var$SelectiveHydrationException;
            $76288626b30e899c$var$isSuspenseInstancePending(nextPrimaryChildren) || $76288626b30e899c$var$renderDidSuspendDelayIfPossible();
            workInProgress = $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $76288626b30e899c$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(nextPrimaryChildren.nextSibling), $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$isHydrating = !0, $76288626b30e899c$var$hydrationErrors = null, $76288626b30e899c$var$rootOrSingletonContext = !1, null !== current && $76288626b30e899c$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $76288626b30e899c$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $76288626b30e899c$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $76288626b30e899c$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $76288626b30e899c$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $76288626b30e899c$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $76288626b30e899c$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $76288626b30e899c$var$SUSPENDED_MARKER, $76288626b30e899c$var$bailoutOffscreenComponent(current.child, nextProps);
    $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $76288626b30e899c$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $76288626b30e899c$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $76288626b30e899c$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $76288626b30e899c$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $76288626b30e899c$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $76288626b30e899c$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $76288626b30e899c$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, suspenseContext);
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $76288626b30e899c$var$isHydrating ? $76288626b30e899c$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $76288626b30e899c$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $76288626b30e899c$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $76288626b30e899c$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $76288626b30e899c$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $76288626b30e899c$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($76288626b30e899c$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $76288626b30e899c$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $76288626b30e899c$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $76288626b30e899c$var$checkIfContextChanged(current) ? !0 : !1;
}
function $76288626b30e899c$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, current.memoizedState.cache);
            $76288626b30e899c$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $76288626b30e899c$var$pushHostContext(workInProgress);
            break;
        case 4:
            $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $76288626b30e899c$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $76288626b30e899c$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $76288626b30e899c$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $76288626b30e899c$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, current.memoizedState.cache);
    }
    return $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $76288626b30e899c$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $76288626b30e899c$var$didReceiveUpdate = !0;
        else {
            if (!$76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $76288626b30e899c$var$didReceiveUpdate = !1, $76288626b30e899c$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $76288626b30e899c$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $76288626b30e899c$var$didReceiveUpdate = !1, $76288626b30e899c$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $76288626b30e899c$var$pushTreeId(workInProgress, $76288626b30e899c$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $76288626b30e899c$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $76288626b30e899c$var$shouldConstruct(current) ? (props = $76288626b30e899c$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $76288626b30e899c$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $76288626b30e899c$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $76288626b30e899c$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $76288626b30e899c$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $76288626b30e899c$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $76288626b30e899c$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $76288626b30e899c$var$getComponentNameFromType(current) || current;
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $76288626b30e899c$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $76288626b30e899c$var$resolveClassComponentProps(props, workInProgress.pendingProps), $76288626b30e899c$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($76288626b30e899c$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $76288626b30e899c$var$cloneUpdateQueue(current, workInProgress);
                $76288626b30e899c$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, props);
                props !== prevState.cache && $76288626b30e899c$var$propagateContextChanges(workInProgress, [
                    $76288626b30e899c$var$CacheContext
                ], renderLanes, !0);
                $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $76288626b30e899c$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $76288626b30e899c$var$createCapturedValueAtFiber(Error($76288626b30e899c$var$formatProdErrorMessage(424)), workInProgress);
                        $76288626b30e899c$var$queueHydrationError($$typeof);
                        workInProgress = $76288626b30e899c$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(current.firstChild);
                        $76288626b30e899c$var$hydrationParentFiber = workInProgress;
                        $76288626b30e899c$var$isHydrating = !0;
                        $76288626b30e899c$var$hydrationErrors = null;
                        $76288626b30e899c$var$rootOrSingletonContext = !0;
                        renderLanes = $76288626b30e899c$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $76288626b30e899c$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $76288626b30e899c$var$markRef(current, workInProgress), null === current ? (renderLanes = $76288626b30e899c$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $76288626b30e899c$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $76288626b30e899c$var$getOwnerDocumentFromRootContainer($76288626b30e899c$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$76288626b30e899c$var$internalInstanceKey] = workInProgress, props[$76288626b30e899c$var$internalPropsKey] = current, $76288626b30e899c$var$setInitialProperties(props, renderLanes, current), $76288626b30e899c$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $76288626b30e899c$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $76288626b30e899c$var$pushHostContext(workInProgress), null === current && $76288626b30e899c$var$isHydrating && (props = workInProgress.stateNode = $76288626b30e899c$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $76288626b30e899c$var$rootInstanceStackCursor.current), $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$rootOrSingletonContext = !0, $$typeof = $76288626b30e899c$var$nextHydratableInstance, $76288626b30e899c$var$isSingletonScope(workInProgress.type) ? ($76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(props.firstChild)) : $76288626b30e899c$var$nextHydratableInstance = $$typeof), $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $76288626b30e899c$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $76288626b30e899c$var$isHydrating) {
                if ($$typeof = props = $76288626b30e899c$var$nextHydratableInstance) props = $76288626b30e899c$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $76288626b30e899c$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(props.firstChild), $76288626b30e899c$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            }
            $76288626b30e899c$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $76288626b30e899c$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $76288626b30e899c$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $76288626b30e899c$var$renderWithHooks(current, workInProgress, $76288626b30e899c$var$TransitionAwareHostComponent, null, null, renderLanes), $76288626b30e899c$var$HostTransitionContext._currentValue = $$typeof);
            $76288626b30e899c$var$markRef(current, workInProgress);
            $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $76288626b30e899c$var$isHydrating) {
                if (current = renderLanes = $76288626b30e899c$var$nextHydratableInstance) renderLanes = $76288626b30e899c$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $76288626b30e899c$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $76288626b30e899c$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $76288626b30e899c$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $76288626b30e899c$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $76288626b30e899c$var$pushProvider(workInProgress, workInProgress.type, props.value), $76288626b30e899c$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $76288626b30e899c$var$prepareToReadContext(workInProgress), $$typeof = $76288626b30e899c$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $76288626b30e899c$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $76288626b30e899c$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $76288626b30e899c$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $76288626b30e899c$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $76288626b30e899c$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $76288626b30e899c$var$prepareToReadContext(workInProgress), props = $76288626b30e899c$var$readContext($76288626b30e899c$var$CacheContext), null === current ? ($$typeof = $76288626b30e899c$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $76288626b30e899c$var$workInProgressRoot, prevState = $76288626b30e899c$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $76288626b30e899c$var$initializeUpdateQueue(workInProgress), $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($76288626b30e899c$var$cloneUpdateQueue(current, workInProgress), $76288626b30e899c$var$processUpdateQueue(workInProgress, null, null, renderLanes), $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, props)) : (props = prevState.cache, $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, props), props !== $$typeof.cache && $76288626b30e899c$var$propagateContextChanges(workInProgress, [
                $76288626b30e899c$var$CacheContext
            ], renderLanes, !0))), $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($76288626b30e899c$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $76288626b30e899c$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($76288626b30e899c$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $76288626b30e899c$var$suspendedThenable = $76288626b30e899c$var$noopSuspenseyCommitThenable, $76288626b30e899c$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $76288626b30e899c$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$76288626b30e899c$var$preloadResource(resource)) {
        if ($76288626b30e899c$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $76288626b30e899c$var$suspendedThenable = $76288626b30e899c$var$noopSuspenseyCommitThenable, $76288626b30e899c$var$SuspenseyCommitException;
    }
}
function $76288626b30e899c$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $76288626b30e899c$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $76288626b30e899c$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $76288626b30e899c$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$76288626b30e899c$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $76288626b30e899c$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $76288626b30e899c$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $76288626b30e899c$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 1:
            return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext);
            $76288626b30e899c$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $76288626b30e899c$var$popHydrationState(workInProgress) ? $76288626b30e899c$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable());
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($76288626b30e899c$var$markUpdate(workInProgress), null !== nextResource ? ($76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($76288626b30e899c$var$markUpdate(workInProgress), $76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($76288626b30e899c$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $76288626b30e899c$var$markUpdate(workInProgress), $76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $76288626b30e899c$var$popHostContext(workInProgress);
            renderLanes = $76288626b30e899c$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $76288626b30e899c$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(166));
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $76288626b30e899c$var$contextStackCursor.current;
                $76288626b30e899c$var$popHydrationState(workInProgress) ? $76288626b30e899c$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $76288626b30e899c$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $76288626b30e899c$var$markUpdate(workInProgress));
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $76288626b30e899c$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $76288626b30e899c$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(166));
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $76288626b30e899c$var$contextStackCursor.current;
                if ($76288626b30e899c$var$popHydrationState(workInProgress)) $76288626b30e899c$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $76288626b30e899c$var$getOwnerDocumentFromRootContainer($76288626b30e899c$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    nextResource[$76288626b30e899c$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($76288626b30e899c$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $76288626b30e899c$var$markUpdate(workInProgress);
                }
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $76288626b30e899c$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(166));
                current = $76288626b30e899c$var$rootInstanceStackCursor.current;
                if ($76288626b30e899c$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $76288626b30e899c$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $76288626b30e899c$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $76288626b30e899c$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$76288626b30e899c$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $76288626b30e899c$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($76288626b30e899c$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($76288626b30e899c$var$formatProdErrorMessage(557));
                        current[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    } else $76288626b30e899c$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $76288626b30e899c$var$popSuspenseHandler(workInProgress), workInProgress;
                    $76288626b30e899c$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($76288626b30e899c$var$formatProdErrorMessage(558));
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $76288626b30e899c$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(317));
                        type[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    } else $76288626b30e899c$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $76288626b30e899c$var$popSuspenseHandler(workInProgress), workInProgress;
                    $76288626b30e899c$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $76288626b30e899c$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $76288626b30e899c$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $76288626b30e899c$var$popHostContainer(), null === current && $76288626b30e899c$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 10:
            return $76288626b30e899c$var$popProvider(workInProgress.type), $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 19:
            $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $76288626b30e899c$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $76288626b30e899c$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $76288626b30e899c$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$76288626b30e899c$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current & 1 | 2);
                            $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $76288626b30e899c$var$now() > $76288626b30e899c$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $76288626b30e899c$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $76288626b30e899c$var$scheduleRetryEffect(workInProgress, current), $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$76288626b30e899c$var$isHydrating) return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
                    } else 2 * $76288626b30e899c$var$now() - newProps.renderingStartTime > $76288626b30e899c$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $76288626b30e899c$var$now(), current.sibling = null, renderLanes = $76288626b30e899c$var$suspenseStackCursor.current, $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $76288626b30e899c$var$popSuspenseHandler(workInProgress), $76288626b30e899c$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($76288626b30e899c$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $76288626b30e899c$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $76288626b30e899c$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $76288626b30e899c$var$pop($76288626b30e899c$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext), $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($76288626b30e899c$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $76288626b30e899c$var$unwindWork(current, workInProgress) {
    $76288626b30e899c$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext), $76288626b30e899c$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $76288626b30e899c$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $76288626b30e899c$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(340));
                $76288626b30e899c$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $76288626b30e899c$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(340));
                $76288626b30e899c$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor), null;
        case 4:
            return $76288626b30e899c$var$popHostContainer(), null;
        case 10:
            return $76288626b30e899c$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $76288626b30e899c$var$popSuspenseHandler(workInProgress), $76288626b30e899c$var$popHiddenContext(), null !== current && $76288626b30e899c$var$pop($76288626b30e899c$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $76288626b30e899c$var$unwindInterruptedWork(current, interruptedWork) {
    $76288626b30e899c$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext);
            $76288626b30e899c$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $76288626b30e899c$var$popHostContext(interruptedWork);
            break;
        case 4:
            $76288626b30e899c$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $76288626b30e899c$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $76288626b30e899c$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor);
            break;
        case 10:
            $76288626b30e899c$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $76288626b30e899c$var$popSuspenseHandler(interruptedWork);
            $76288626b30e899c$var$popHiddenContext();
            null !== current && $76288626b30e899c$var$pop($76288626b30e899c$var$resumedCache);
            break;
        case 24:
            $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext);
    }
}
function $76288626b30e899c$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $76288626b30e899c$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $76288626b30e899c$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $76288626b30e899c$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $76288626b30e899c$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $76288626b30e899c$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $76288626b30e899c$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $76288626b30e899c$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$76288626b30e899c$var$internalPropsKey] = newProps;
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $76288626b30e899c$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $76288626b30e899c$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $76288626b30e899c$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $76288626b30e899c$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $76288626b30e899c$var$noop$1));
    else if (4 !== tag && (27 === tag && $76288626b30e899c$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $76288626b30e899c$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $76288626b30e899c$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($76288626b30e899c$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$76288626b30e899c$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $76288626b30e899c$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $76288626b30e899c$var$setInitialProperties(singleton, type, props);
        singleton[$76288626b30e899c$var$internalInstanceKey] = finishedWork;
        singleton[$76288626b30e899c$var$internalPropsKey] = props;
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $76288626b30e899c$var$offscreenSubtreeIsHidden = !1, $76288626b30e899c$var$offscreenSubtreeWasHidden = !1, $76288626b30e899c$var$needsFormReset = !1, $76288626b30e899c$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $76288626b30e899c$var$nextEffect = null;
function $76288626b30e899c$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $76288626b30e899c$var$eventsEnabled = $76288626b30e899c$var$_enabled;
    root = $76288626b30e899c$var$getActiveElementDeep(root);
    if ($76288626b30e899c$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $76288626b30e899c$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $76288626b30e899c$var$_enabled = !1;
    for($76288626b30e899c$var$nextEffect = firstChild; null !== $76288626b30e899c$var$nextEffect;)if (firstChild = $76288626b30e899c$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $76288626b30e899c$var$nextEffect = root;
    else for(; null !== $76288626b30e899c$var$nextEffect;){
        firstChild = $76288626b30e899c$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $76288626b30e899c$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $76288626b30e899c$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $76288626b30e899c$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $76288626b30e899c$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($76288626b30e899c$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $76288626b30e899c$var$nextEffect = root;
            break;
        }
        $76288626b30e899c$var$nextEffect = firstChild.return;
    }
}
function $76288626b30e899c$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $76288626b30e899c$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $76288626b30e899c$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $76288626b30e899c$var$commitClassCallbacks(finishedWork);
            flags & 512 && $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $76288626b30e899c$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $76288626b30e899c$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $76288626b30e899c$var$commitHostMount(finishedWork);
            flags & 512 && $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $76288626b30e899c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $76288626b30e899c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $76288626b30e899c$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $76288626b30e899c$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $76288626b30e899c$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $76288626b30e899c$var$offscreenSubtreeWasHidden;
                prevProps = $76288626b30e899c$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $76288626b30e899c$var$offscreenSubtreeWasHidden;
                $76288626b30e899c$var$offscreenSubtreeIsHidden = flags;
                ($76288626b30e899c$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $76288626b30e899c$var$offscreenSubtreeIsHidden = prevProps;
                $76288626b30e899c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $76288626b30e899c$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $76288626b30e899c$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $76288626b30e899c$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $76288626b30e899c$var$hostParent = null, $76288626b30e899c$var$hostParentIsContainer = !1;
function $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$76288626b30e899c$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $76288626b30e899c$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.onCommitFiberUnmount) try {
        $76288626b30e899c$var$injectedHook.onCommitFiberUnmount($76288626b30e899c$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $76288626b30e899c$var$hostParent, prevHostParentIsContainer = $76288626b30e899c$var$hostParentIsContainer;
            $76288626b30e899c$var$isSingletonScope(deletedFiber.type) && ($76288626b30e899c$var$hostParent = deletedFiber.stateNode, $76288626b30e899c$var$hostParentIsContainer = !1);
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$releaseSingletonInstance(deletedFiber.stateNode);
            $76288626b30e899c$var$hostParent = prevHostParent;
            $76288626b30e899c$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $76288626b30e899c$var$hostParent;
            prevHostParentIsContainer = $76288626b30e899c$var$hostParentIsContainer;
            $76288626b30e899c$var$hostParent = null;
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$hostParent = prevHostParent;
            $76288626b30e899c$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $76288626b30e899c$var$hostParent) {
                if ($76288626b30e899c$var$hostParentIsContainer) try {
                    (9 === $76288626b30e899c$var$hostParent.nodeType ? $76288626b30e899c$var$hostParent.body : "HTML" === $76288626b30e899c$var$hostParent.nodeName ? $76288626b30e899c$var$hostParent.ownerDocument.body : $76288626b30e899c$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $76288626b30e899c$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $76288626b30e899c$var$hostParent && ($76288626b30e899c$var$hostParentIsContainer ? (finishedRoot = $76288626b30e899c$var$hostParent, $76288626b30e899c$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $76288626b30e899c$var$retryIfBlockedOn(finishedRoot)) : $76288626b30e899c$var$clearHydrationBoundary($76288626b30e899c$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $76288626b30e899c$var$hostParent;
            prevHostParentIsContainer = $76288626b30e899c$var$hostParentIsContainer;
            $76288626b30e899c$var$hostParent = deletedFiber.stateNode.containerInfo;
            $76288626b30e899c$var$hostParentIsContainer = !0;
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$hostParent = prevHostParent;
            $76288626b30e899c$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $76288626b30e899c$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || ($76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $76288626b30e899c$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $76288626b30e899c$var$offscreenSubtreeWasHidden = (prevHostParent = $76288626b30e899c$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $76288626b30e899c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $76288626b30e899c$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $76288626b30e899c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $76288626b30e899c$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $76288626b30e899c$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $76288626b30e899c$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $76288626b30e899c$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $76288626b30e899c$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $76288626b30e899c$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($76288626b30e899c$var$isSingletonScope(parent.type)) {
                        $76288626b30e899c$var$hostParent = parent.stateNode;
                        $76288626b30e899c$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $76288626b30e899c$var$hostParent = parent.stateNode;
                    $76288626b30e899c$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $76288626b30e899c$var$hostParent = parent.stateNode.containerInfo;
                    $76288626b30e899c$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $76288626b30e899c$var$hostParent) throw Error($76288626b30e899c$var$formatProdErrorMessage(160));
        $76288626b30e899c$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $76288626b30e899c$var$hostParent = null;
        $76288626b30e899c$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $76288626b30e899c$var$currentHoistableRoot = null;
function $76288626b30e899c$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($76288626b30e899c$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $76288626b30e899c$var$commitHookEffectListMount(3, finishedWork), $76288626b30e899c$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            flags & 64 && $76288626b30e899c$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$76288626b30e899c$var$internalHoistableMarker] || currentResource[$76288626b30e899c$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $76288626b30e899c$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$76288626b30e899c$var$internalInstanceKey] = finishedWork;
                                        $76288626b30e899c$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $76288626b30e899c$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $76288626b30e899c$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $76288626b30e899c$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $76288626b30e899c$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($76288626b30e899c$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$76288626b30e899c$var$internalInstanceKey] = finishedWork;
                                $76288626b30e899c$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $76288626b30e899c$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $76288626b30e899c$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $76288626b30e899c$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $76288626b30e899c$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $76288626b30e899c$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $76288626b30e899c$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $76288626b30e899c$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $76288626b30e899c$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($76288626b30e899c$var$needsFormReset = !0);
            break;
        case 6:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $76288626b30e899c$var$tagCaches = null;
            hoistableRoot = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$currentHoistableRoot = $76288626b30e899c$var$getHoistableRoot(root.containerInfo);
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$currentHoistableRoot = hoistableRoot;
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $76288626b30e899c$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $76288626b30e899c$var$needsFormReset && ($76288626b30e899c$var$needsFormReset = !1, $76288626b30e899c$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$currentHoistableRoot = $76288626b30e899c$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            $76288626b30e899c$var$currentHoistableRoot = flags;
            break;
        case 12:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($76288626b30e899c$var$globalMostRecentFallbackTime = $76288626b30e899c$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $76288626b30e899c$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $76288626b30e899c$var$offscreenSubtreeWasHidden;
            $76288626b30e899c$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $76288626b30e899c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $76288626b30e899c$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $76288626b30e899c$var$offscreenSubtreeIsHidden || $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $76288626b30e899c$var$hideOrUnhideDehydratedBoundary(instance, !0) : $76288626b30e899c$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork), $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
    }
}
function $76288626b30e899c$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($76288626b30e899c$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $76288626b30e899c$var$getHostSibling(finishedWork);
                    $76288626b30e899c$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($76288626b30e899c$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $76288626b30e899c$var$getHostSibling(finishedWork);
                    $76288626b30e899c$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $76288626b30e899c$var$getHostSibling(finishedWork);
                    $76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $76288626b30e899c$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $76288626b30e899c$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $76288626b30e899c$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $76288626b30e899c$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $76288626b30e899c$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $76288626b30e899c$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $76288626b30e899c$var$safelyDetachRef(finishedWork, finishedWork.return);
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $76288626b30e899c$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$76288626b30e899c$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $76288626b30e899c$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $76288626b30e899c$var$commitClassCallbacks(finishedWork);
                $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $76288626b30e899c$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $76288626b30e899c$var$commitHostMount(finishedWork);
                $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $76288626b30e899c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $76288626b30e899c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $76288626b30e899c$var$releaseCache(previousCache));
}
function $76288626b30e899c$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $76288626b30e899c$var$releaseCache(current));
}
function $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $76288626b30e899c$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $76288626b30e899c$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $76288626b30e899c$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $76288626b30e899c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $76288626b30e899c$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $76288626b30e899c$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $76288626b30e899c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $76288626b30e899c$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $76288626b30e899c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $76288626b30e899c$var$suspenseyCommitFlag = 8192;
function $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $76288626b30e899c$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $76288626b30e899c$var$suspenseyCommitFlag && null !== fiber.memoizedState && $76288626b30e899c$var$suspendResource(suspendedState, $76288626b30e899c$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$currentHoistableRoot = $76288626b30e899c$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $76288626b30e899c$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $76288626b30e899c$var$suspenseyCommitFlag, $76288626b30e899c$var$suspenseyCommitFlag = 16777216, $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $76288626b30e899c$var$suspenseyCommitFlag = previousHoistableRoot) : $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $76288626b30e899c$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $76288626b30e899c$var$nextEffect = childToDelete;
            $76288626b30e899c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $76288626b30e899c$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $76288626b30e899c$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $76288626b30e899c$var$nextEffect = childToDelete;
            $76288626b30e899c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $76288626b30e899c$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $76288626b30e899c$var$nextEffect;){
        var fiber = $76288626b30e899c$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $76288626b30e899c$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $76288626b30e899c$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $76288626b30e899c$var$nextEffect;){
            cache = $76288626b30e899c$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $76288626b30e899c$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $76288626b30e899c$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $76288626b30e899c$var$nextEffect = sibling;
                break a;
            }
            $76288626b30e899c$var$nextEffect = returnFiber;
        }
    }
}
var $76288626b30e899c$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $76288626b30e899c$var$readContext($76288626b30e899c$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $76288626b30e899c$var$readContext($76288626b30e899c$var$CacheContext).controller.signal;
    }
}, $76288626b30e899c$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $76288626b30e899c$var$executionContext = 0, $76288626b30e899c$var$workInProgressRoot = null, $76288626b30e899c$var$workInProgress = null, $76288626b30e899c$var$workInProgressRootRenderLanes = 0, $76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings = !1, $76288626b30e899c$var$workInProgressRootIsPrerendering = !1, $76288626b30e899c$var$workInProgressRootDidAttachPingListener = !1, $76288626b30e899c$var$entangledRenderLanes = 0, $76288626b30e899c$var$workInProgressRootExitStatus = 0, $76288626b30e899c$var$workInProgressRootSkippedLanes = 0, $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes = 0, $76288626b30e899c$var$workInProgressRootPingedLanes = 0, $76288626b30e899c$var$workInProgressDeferredLane = 0, $76288626b30e899c$var$workInProgressSuspendedRetryLanes = 0, $76288626b30e899c$var$workInProgressRootConcurrentErrors = null, $76288626b30e899c$var$workInProgressRootRecoverableErrors = null, $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $76288626b30e899c$var$globalMostRecentFallbackTime = 0, $76288626b30e899c$var$globalMostRecentTransitionTime = 0, $76288626b30e899c$var$workInProgressRootRenderTargetTime = Infinity, $76288626b30e899c$var$workInProgressTransitions = null, $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed = null, $76288626b30e899c$var$pendingEffectsStatus = 0, $76288626b30e899c$var$pendingEffectsRoot = null, $76288626b30e899c$var$pendingFinishedWork = null, $76288626b30e899c$var$pendingEffectsLanes = 0, $76288626b30e899c$var$pendingEffectsRemainingLanes = 0, $76288626b30e899c$var$pendingPassiveTransitions = null, $76288626b30e899c$var$pendingRecoverableErrors = null, $76288626b30e899c$var$nestedUpdateCount = 0, $76288626b30e899c$var$rootWithNestedUpdates = null;
function $76288626b30e899c$var$requestUpdateLane() {
    return 0 !== ($76288626b30e899c$var$executionContext & 2) && 0 !== $76288626b30e899c$var$workInProgressRootRenderLanes ? $76288626b30e899c$var$workInProgressRootRenderLanes & -$76288626b30e899c$var$workInProgressRootRenderLanes : null !== $76288626b30e899c$var$ReactSharedInternals.T ? $76288626b30e899c$var$requestTransitionLane() : $76288626b30e899c$var$resolveUpdatePriority();
}
function $76288626b30e899c$var$requestDeferredLane() {
    if (0 === $76288626b30e899c$var$workInProgressDeferredLane) {
        if (0 === ($76288626b30e899c$var$workInProgressRootRenderLanes & 536870912) || $76288626b30e899c$var$isHydrating) {
            var lane = $76288626b30e899c$var$nextTransitionDeferredLane;
            $76288626b30e899c$var$nextTransitionDeferredLane <<= 1;
            0 === ($76288626b30e899c$var$nextTransitionDeferredLane & 3932160) && ($76288626b30e899c$var$nextTransitionDeferredLane = 262144);
            $76288626b30e899c$var$workInProgressDeferredLane = lane;
        } else $76288626b30e899c$var$workInProgressDeferredLane = 536870912;
    }
    lane = $76288626b30e899c$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $76288626b30e899c$var$workInProgressDeferredLane;
}
function $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $76288626b30e899c$var$workInProgressRoot && (2 === $76288626b30e899c$var$workInProgressSuspendedReason || 9 === $76288626b30e899c$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $76288626b30e899c$var$prepareFreshStack(root, 0), $76288626b30e899c$var$markRootSuspended(root, $76288626b30e899c$var$workInProgressRootRenderLanes, $76288626b30e899c$var$workInProgressDeferredLane, !1);
    $76288626b30e899c$var$markRootUpdated$1(root, lane);
    if (0 === ($76288626b30e899c$var$executionContext & 2) || root !== $76288626b30e899c$var$workInProgressRoot) root === $76288626b30e899c$var$workInProgressRoot && (0 === ($76288626b30e899c$var$executionContext & 2) && ($76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $76288626b30e899c$var$workInProgressRootExitStatus && $76288626b30e899c$var$markRootSuspended(root, $76288626b30e899c$var$workInProgressRootRenderLanes, $76288626b30e899c$var$workInProgressDeferredLane, !1)), $76288626b30e899c$var$ensureRootIsScheduled(root);
}
function $76288626b30e899c$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($76288626b30e899c$var$executionContext & 6)) throw Error($76288626b30e899c$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $76288626b30e899c$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $76288626b30e899c$var$renderRootConcurrent(root$jscomp$0, lanes) : $76288626b30e899c$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $76288626b30e899c$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $76288626b30e899c$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$76288626b30e899c$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $76288626b30e899c$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $76288626b30e899c$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($76288626b30e899c$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $76288626b30e899c$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($76288626b30e899c$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $76288626b30e899c$var$workInProgressRootRecoverableErrors;
                            $76288626b30e899c$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $76288626b30e899c$var$workInProgressRootRecoverableErrors ? $76288626b30e899c$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $76288626b30e899c$var$workInProgressRootRecoverableErrors.push.apply($76288626b30e899c$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $76288626b30e899c$var$prepareFreshStack(root$jscomp$0, 0);
                $76288626b30e899c$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($76288626b30e899c$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $76288626b30e899c$var$markRootSuspended(shouldTimeSlice, lanes, $76288626b30e899c$var$workInProgressDeferredLane, !$76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $76288626b30e899c$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($76288626b30e899c$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $76288626b30e899c$var$globalMostRecentFallbackTime + 300 - $76288626b30e899c$var$now(), 10 < exitStatus)) {
                    $76288626b30e899c$var$markRootSuspended(shouldTimeSlice, lanes, $76288626b30e899c$var$workInProgressDeferredLane, !$76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $76288626b30e899c$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $76288626b30e899c$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $76288626b30e899c$var$scheduleTimeout($76288626b30e899c$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $76288626b30e899c$var$workInProgressRootRecoverableErrors, $76288626b30e899c$var$workInProgressTransitions, $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $76288626b30e899c$var$workInProgressDeferredLane, $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes, $76288626b30e899c$var$workInProgressSuspendedRetryLanes, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $76288626b30e899c$var$commitRootWhenReady(shouldTimeSlice, forceSync, $76288626b30e899c$var$workInProgressRootRecoverableErrors, $76288626b30e899c$var$workInProgressTransitions, $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $76288626b30e899c$var$workInProgressDeferredLane, $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes, $76288626b30e899c$var$workInProgressSuspendedRetryLanes, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $76288626b30e899c$var$ensureRootIsScheduled(root$jscomp$0);
}
function $76288626b30e899c$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $76288626b30e899c$var$noop$1
        };
        $76288626b30e899c$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $76288626b30e899c$var$globalMostRecentFallbackTime - $76288626b30e899c$var$now() : (lanes & 4194048) === lanes ? $76288626b30e899c$var$globalMostRecentTransitionTime - $76288626b30e899c$var$now() : 0;
        timeoutOffset = $76288626b30e899c$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $76288626b30e899c$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($76288626b30e899c$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $76288626b30e899c$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $76288626b30e899c$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $76288626b30e899c$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$76288626b30e899c$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $76288626b30e899c$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$76288626b30e899c$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $76288626b30e899c$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $76288626b30e899c$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $76288626b30e899c$var$flushSyncWork$1() {
    return 0 === ($76288626b30e899c$var$executionContext & 6) ? ($76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $76288626b30e899c$var$resetWorkInProgressStack() {
    if (null !== $76288626b30e899c$var$workInProgress) {
        if (0 === $76288626b30e899c$var$workInProgressSuspendedReason) var interruptedWork = $76288626b30e899c$var$workInProgress.return;
        else interruptedWork = $76288626b30e899c$var$workInProgress, $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null, $76288626b30e899c$var$resetHooksOnUnwind(interruptedWork), $76288626b30e899c$var$thenableState$1 = null, $76288626b30e899c$var$thenableIndexCounter$1 = 0, interruptedWork = $76288626b30e899c$var$workInProgress;
        for(; null !== interruptedWork;)$76288626b30e899c$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $76288626b30e899c$var$workInProgress = null;
    }
}
function $76288626b30e899c$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $76288626b30e899c$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $76288626b30e899c$var$pendingEffectsLanes = 0;
    $76288626b30e899c$var$resetWorkInProgressStack();
    $76288626b30e899c$var$workInProgressRoot = root;
    $76288626b30e899c$var$workInProgress = timeoutHandle = $76288626b30e899c$var$createWorkInProgress(root.current, null);
    $76288626b30e899c$var$workInProgressRootRenderLanes = lanes;
    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
    $76288626b30e899c$var$workInProgressThrownValue = null;
    $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $76288626b30e899c$var$workInProgressRootIsPrerendering = $76288626b30e899c$var$checkIfRootIsPrerendering(root, lanes);
    $76288626b30e899c$var$workInProgressRootDidAttachPingListener = !1;
    $76288626b30e899c$var$workInProgressSuspendedRetryLanes = $76288626b30e899c$var$workInProgressDeferredLane = $76288626b30e899c$var$workInProgressRootPingedLanes = $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes = $76288626b30e899c$var$workInProgressRootSkippedLanes = $76288626b30e899c$var$workInProgressRootExitStatus = 0;
    $76288626b30e899c$var$workInProgressRootRecoverableErrors = $76288626b30e899c$var$workInProgressRootConcurrentErrors = null;
    $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $76288626b30e899c$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $76288626b30e899c$var$entangledRenderLanes = lanes;
    $76288626b30e899c$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $76288626b30e899c$var$handleThrow(root, thrownValue) {
    $76288626b30e899c$var$currentlyRenderingFiber = null;
    $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$ContextOnlyDispatcher;
    thrownValue === $76288626b30e899c$var$SuspenseException || thrownValue === $76288626b30e899c$var$SuspenseActionException ? (thrownValue = $76288626b30e899c$var$getSuspendedThenable(), $76288626b30e899c$var$workInProgressSuspendedReason = 3) : thrownValue === $76288626b30e899c$var$SuspenseyCommitException ? (thrownValue = $76288626b30e899c$var$getSuspendedThenable(), $76288626b30e899c$var$workInProgressSuspendedReason = 4) : $76288626b30e899c$var$workInProgressSuspendedReason = thrownValue === $76288626b30e899c$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $76288626b30e899c$var$workInProgressThrownValue = thrownValue;
    null === $76288626b30e899c$var$workInProgress && ($76288626b30e899c$var$workInProgressRootExitStatus = 1, $76288626b30e899c$var$logUncaughtError(root, $76288626b30e899c$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $76288626b30e899c$var$shouldRemainOnPreviousScreen() {
    var handler = $76288626b30e899c$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($76288626b30e899c$var$workInProgressRootRenderLanes & 4194048) === $76288626b30e899c$var$workInProgressRootRenderLanes ? null === $76288626b30e899c$var$shellBoundary ? !0 : !1 : ($76288626b30e899c$var$workInProgressRootRenderLanes & 62914560) === $76288626b30e899c$var$workInProgressRootRenderLanes || 0 !== ($76288626b30e899c$var$workInProgressRootRenderLanes & 536870912) ? handler === $76288626b30e899c$var$shellBoundary : !1;
}
function $76288626b30e899c$var$pushDispatcher() {
    var prevDispatcher = $76288626b30e899c$var$ReactSharedInternals.H;
    $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $76288626b30e899c$var$ContextOnlyDispatcher : prevDispatcher;
}
function $76288626b30e899c$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $76288626b30e899c$var$ReactSharedInternals.A;
    $76288626b30e899c$var$ReactSharedInternals.A = $76288626b30e899c$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $76288626b30e899c$var$renderDidSuspendDelayIfPossible() {
    $76288626b30e899c$var$workInProgressRootExitStatus = 4;
    $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings || ($76288626b30e899c$var$workInProgressRootRenderLanes & 4194048) !== $76288626b30e899c$var$workInProgressRootRenderLanes && null !== $76288626b30e899c$var$suspenseHandlerStackCursor.current || ($76288626b30e899c$var$workInProgressRootIsPrerendering = !0);
    0 === ($76288626b30e899c$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $76288626b30e899c$var$workInProgressRoot || $76288626b30e899c$var$markRootSuspended($76288626b30e899c$var$workInProgressRoot, $76288626b30e899c$var$workInProgressRootRenderLanes, $76288626b30e899c$var$workInProgressDeferredLane, !1);
}
function $76288626b30e899c$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $76288626b30e899c$var$executionContext;
    $76288626b30e899c$var$executionContext |= 2;
    var prevDispatcher = $76288626b30e899c$var$pushDispatcher(), prevAsyncDispatcher = $76288626b30e899c$var$pushAsyncDispatcher();
    if ($76288626b30e899c$var$workInProgressRoot !== root || $76288626b30e899c$var$workInProgressRootRenderLanes !== lanes) $76288626b30e899c$var$workInProgressTransitions = null, $76288626b30e899c$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $76288626b30e899c$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $76288626b30e899c$var$workInProgressSuspendedReason && null !== $76288626b30e899c$var$workInProgress) {
            var unitOfWork = $76288626b30e899c$var$workInProgress, thrownValue = $76288626b30e899c$var$workInProgressThrownValue;
            switch($76288626b30e899c$var$workInProgressSuspendedReason){
                case 8:
                    $76288626b30e899c$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $76288626b30e899c$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $76288626b30e899c$var$workInProgressSuspendedReason;
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $76288626b30e899c$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $76288626b30e899c$var$workInProgressSuspendedReason, $76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $76288626b30e899c$var$workLoopSync();
        exitStatus = $76288626b30e899c$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $76288626b30e899c$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null;
    $76288626b30e899c$var$executionContext = prevExecutionContext;
    $76288626b30e899c$var$ReactSharedInternals.H = prevDispatcher;
    $76288626b30e899c$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $76288626b30e899c$var$workInProgress && ($76288626b30e899c$var$workInProgressRoot = null, $76288626b30e899c$var$workInProgressRootRenderLanes = 0, $76288626b30e899c$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $76288626b30e899c$var$workLoopSync() {
    for(; null !== $76288626b30e899c$var$workInProgress;)$76288626b30e899c$var$performUnitOfWork($76288626b30e899c$var$workInProgress);
}
function $76288626b30e899c$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $76288626b30e899c$var$executionContext;
    $76288626b30e899c$var$executionContext |= 2;
    var prevDispatcher = $76288626b30e899c$var$pushDispatcher(), prevAsyncDispatcher = $76288626b30e899c$var$pushAsyncDispatcher();
    $76288626b30e899c$var$workInProgressRoot !== root || $76288626b30e899c$var$workInProgressRootRenderLanes !== lanes ? ($76288626b30e899c$var$workInProgressTransitions = null, $76288626b30e899c$var$workInProgressRootRenderTargetTime = $76288626b30e899c$var$now() + 500, $76288626b30e899c$var$prepareFreshStack(root, lanes)) : $76288626b30e899c$var$workInProgressRootIsPrerendering = $76288626b30e899c$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $76288626b30e899c$var$workInProgressSuspendedReason && null !== $76288626b30e899c$var$workInProgress) {
            lanes = $76288626b30e899c$var$workInProgress;
            var thrownValue = $76288626b30e899c$var$workInProgressThrownValue;
            b: switch($76288626b30e899c$var$workInProgressSuspendedReason){
                case 1:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($76288626b30e899c$var$isThenableResolved(thrownValue)) {
                        $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                        $76288626b30e899c$var$workInProgressThrownValue = null;
                        $76288626b30e899c$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $76288626b30e899c$var$workInProgressSuspendedReason && 9 !== $76288626b30e899c$var$workInProgressSuspendedReason || $76288626b30e899c$var$workInProgressRoot !== root || ($76288626b30e899c$var$workInProgressSuspendedReason = 7);
                        $76288626b30e899c$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $76288626b30e899c$var$isThenableResolved(thrownValue) ? ($76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$replaySuspendedUnitOfWork(lanes)) : ($76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($76288626b30e899c$var$workInProgress.tag){
                        case 26:
                            resource = $76288626b30e899c$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $76288626b30e899c$var$workInProgress;
                            if (resource ? $76288626b30e899c$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                                $76288626b30e899c$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $76288626b30e899c$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($76288626b30e899c$var$workInProgress = returnFiber, $76288626b30e899c$var$completeUnitOfWork(returnFiber)) : $76288626b30e899c$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $76288626b30e899c$var$resetWorkInProgressStack();
                    $76288626b30e899c$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(462));
            }
        }
        $76288626b30e899c$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $76288626b30e899c$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null;
    $76288626b30e899c$var$ReactSharedInternals.H = prevDispatcher;
    $76288626b30e899c$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $76288626b30e899c$var$executionContext = prevExecutionContext;
    if (null !== $76288626b30e899c$var$workInProgress) return 0;
    $76288626b30e899c$var$workInProgressRoot = null;
    $76288626b30e899c$var$workInProgressRootRenderLanes = 0;
    $76288626b30e899c$var$finishQueueingConcurrentUpdates();
    return $76288626b30e899c$var$workInProgressRootExitStatus;
}
function $76288626b30e899c$var$workLoopConcurrentByScheduler() {
    for(; null !== $76288626b30e899c$var$workInProgress && !$76288626b30e899c$var$shouldYield();)$76288626b30e899c$var$performUnitOfWork($76288626b30e899c$var$workInProgress);
}
function $76288626b30e899c$var$performUnitOfWork(unitOfWork) {
    var next = $76288626b30e899c$var$beginWork(unitOfWork.alternate, unitOfWork, $76288626b30e899c$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $76288626b30e899c$var$completeUnitOfWork(unitOfWork) : $76288626b30e899c$var$workInProgress = next;
}
function $76288626b30e899c$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $76288626b30e899c$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $76288626b30e899c$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $76288626b30e899c$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $76288626b30e899c$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $76288626b30e899c$var$resetHooksOnUnwind(next);
        default:
            $76288626b30e899c$var$unwindInterruptedWork(current, next), next = $76288626b30e899c$var$workInProgress = $76288626b30e899c$var$resetWorkInProgress(next, $76288626b30e899c$var$entangledRenderLanes), next = $76288626b30e899c$var$beginWork(current, next, $76288626b30e899c$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $76288626b30e899c$var$completeUnitOfWork(unitOfWork) : $76288626b30e899c$var$workInProgress = next;
}
function $76288626b30e899c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null;
    $76288626b30e899c$var$resetHooksOnUnwind(unitOfWork);
    $76288626b30e899c$var$thenableState$1 = null;
    $76288626b30e899c$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($76288626b30e899c$var$throwException(root, returnFiber, unitOfWork, thrownValue, $76288626b30e899c$var$workInProgressRootRenderLanes)) {
            $76288626b30e899c$var$workInProgressRootExitStatus = 1;
            $76288626b30e899c$var$logUncaughtError(root, $76288626b30e899c$var$createCapturedValueAtFiber(thrownValue, root.current));
            $76288626b30e899c$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $76288626b30e899c$var$workInProgress = returnFiber, error;
        $76288626b30e899c$var$workInProgressRootExitStatus = 1;
        $76288626b30e899c$var$logUncaughtError(root, $76288626b30e899c$var$createCapturedValueAtFiber(thrownValue, root.current));
        $76288626b30e899c$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($76288626b30e899c$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($76288626b30e899c$var$workInProgressRootIsPrerendering || 0 !== ($76288626b30e899c$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $76288626b30e899c$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $76288626b30e899c$var$unwindUnitOfWork(unitOfWork, root);
    } else $76288626b30e899c$var$completeUnitOfWork(unitOfWork);
}
function $76288626b30e899c$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $76288626b30e899c$var$unwindUnitOfWork(completedWork, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $76288626b30e899c$var$completeWork(completedWork.alternate, completedWork, $76288626b30e899c$var$entangledRenderLanes);
        if (null !== next) {
            $76288626b30e899c$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $76288626b30e899c$var$workInProgress = completedWork;
            return;
        }
        $76288626b30e899c$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 5);
}
function $76288626b30e899c$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $76288626b30e899c$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $76288626b30e899c$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $76288626b30e899c$var$workInProgress = unitOfWork;
            return;
        }
        $76288626b30e899c$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $76288626b30e899c$var$workInProgressRootExitStatus = 6;
    $76288626b30e899c$var$workInProgress = null;
}
function $76288626b30e899c$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $76288626b30e899c$var$flushPendingEffects();
    while (0 !== $76288626b30e899c$var$pendingEffectsStatus);
    if (0 !== ($76288626b30e899c$var$executionContext & 6)) throw Error($76288626b30e899c$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($76288626b30e899c$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $76288626b30e899c$var$concurrentlyUpdatedLanes;
        $76288626b30e899c$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $76288626b30e899c$var$workInProgressRoot && ($76288626b30e899c$var$workInProgress = $76288626b30e899c$var$workInProgressRoot = null, $76288626b30e899c$var$workInProgressRootRenderLanes = 0);
        $76288626b30e899c$var$pendingFinishedWork = finishedWork;
        $76288626b30e899c$var$pendingEffectsRoot = root;
        $76288626b30e899c$var$pendingEffectsLanes = lanes;
        $76288626b30e899c$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $76288626b30e899c$var$pendingPassiveTransitions = transitions;
        $76288626b30e899c$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $76288626b30e899c$var$scheduleCallback$1($76288626b30e899c$var$NormalPriority$1, function() {
            $76288626b30e899c$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $76288626b30e899c$var$ReactSharedInternals.T;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            transitions = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $76288626b30e899c$var$executionContext;
            $76288626b30e899c$var$executionContext |= 4;
            try {
                $76288626b30e899c$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $76288626b30e899c$var$executionContext = spawnedLane, $76288626b30e899c$var$ReactDOMSharedInternals.p = transitions, $76288626b30e899c$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $76288626b30e899c$var$pendingEffectsStatus = 1;
        $76288626b30e899c$var$flushMutationEffects();
        $76288626b30e899c$var$flushLayoutEffects();
        $76288626b30e899c$var$flushSpawnedWork();
    }
}
function $76288626b30e899c$var$flushMutationEffects() {
    if (1 === $76288626b30e899c$var$pendingEffectsStatus) {
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        var root = $76288626b30e899c$var$pendingEffectsRoot, finishedWork = $76288626b30e899c$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $76288626b30e899c$var$ReactSharedInternals.T;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $76288626b30e899c$var$executionContext;
            $76288626b30e899c$var$executionContext |= 4;
            try {
                $76288626b30e899c$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $76288626b30e899c$var$selectionInformation, curFocusedElem = $76288626b30e899c$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $76288626b30e899c$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $76288626b30e899c$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $76288626b30e899c$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $76288626b30e899c$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $76288626b30e899c$var$_enabled = !!$76288626b30e899c$var$eventsEnabled;
                $76288626b30e899c$var$selectionInformation = $76288626b30e899c$var$eventsEnabled = null;
            } finally{
                $76288626b30e899c$var$executionContext = prevExecutionContext, $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $76288626b30e899c$var$pendingEffectsStatus = 2;
    }
}
function $76288626b30e899c$var$flushLayoutEffects() {
    if (2 === $76288626b30e899c$var$pendingEffectsStatus) {
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        var root = $76288626b30e899c$var$pendingEffectsRoot, finishedWork = $76288626b30e899c$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $76288626b30e899c$var$ReactSharedInternals.T;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $76288626b30e899c$var$executionContext;
            $76288626b30e899c$var$executionContext |= 4;
            try {
                $76288626b30e899c$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $76288626b30e899c$var$executionContext = prevExecutionContext, $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $76288626b30e899c$var$pendingEffectsStatus = 3;
    }
}
function $76288626b30e899c$var$flushSpawnedWork() {
    if (4 === $76288626b30e899c$var$pendingEffectsStatus || 3 === $76288626b30e899c$var$pendingEffectsStatus) {
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        $76288626b30e899c$var$requestPaint();
        var root = $76288626b30e899c$var$pendingEffectsRoot, finishedWork = $76288626b30e899c$var$pendingFinishedWork, lanes = $76288626b30e899c$var$pendingEffectsLanes, recoverableErrors = $76288626b30e899c$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $76288626b30e899c$var$pendingEffectsStatus = 5 : ($76288626b30e899c$var$pendingEffectsStatus = 0, $76288626b30e899c$var$pendingFinishedWork = $76288626b30e899c$var$pendingEffectsRoot = null, $76288626b30e899c$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $76288626b30e899c$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.onCommitFiberRoot) try {
            $76288626b30e899c$var$injectedHook.onCommitFiberRoot($76288626b30e899c$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $76288626b30e899c$var$ReactSharedInternals.T;
            remainingLanes = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $76288626b30e899c$var$ReactSharedInternals.T = finishedWork, $76288626b30e899c$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($76288626b30e899c$var$pendingEffectsLanes & 3) && $76288626b30e899c$var$flushPendingEffects();
        $76288626b30e899c$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $76288626b30e899c$var$rootWithNestedUpdates ? $76288626b30e899c$var$nestedUpdateCount++ : ($76288626b30e899c$var$nestedUpdateCount = 0, $76288626b30e899c$var$rootWithNestedUpdates = root) : $76288626b30e899c$var$nestedUpdateCount = 0;
        $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $76288626b30e899c$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $76288626b30e899c$var$releaseCache(remainingLanes)));
}
function $76288626b30e899c$var$flushPendingEffects() {
    $76288626b30e899c$var$flushMutationEffects();
    $76288626b30e899c$var$flushLayoutEffects();
    $76288626b30e899c$var$flushSpawnedWork();
    return $76288626b30e899c$var$flushPassiveEffects();
}
function $76288626b30e899c$var$flushPassiveEffects() {
    if (5 !== $76288626b30e899c$var$pendingEffectsStatus) return !1;
    var root = $76288626b30e899c$var$pendingEffectsRoot, remainingLanes = $76288626b30e899c$var$pendingEffectsRemainingLanes;
    $76288626b30e899c$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $76288626b30e899c$var$lanesToEventPriority($76288626b30e899c$var$pendingEffectsLanes), prevTransition = $76288626b30e899c$var$ReactSharedInternals.T, previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        $76288626b30e899c$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $76288626b30e899c$var$ReactSharedInternals.T = null;
        renderPriority = $76288626b30e899c$var$pendingPassiveTransitions;
        $76288626b30e899c$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $76288626b30e899c$var$pendingEffectsRoot, lanes = $76288626b30e899c$var$pendingEffectsLanes;
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        $76288626b30e899c$var$pendingFinishedWork = $76288626b30e899c$var$pendingEffectsRoot = null;
        $76288626b30e899c$var$pendingEffectsLanes = 0;
        if (0 !== ($76288626b30e899c$var$executionContext & 6)) throw Error($76288626b30e899c$var$formatProdErrorMessage(331));
        var prevExecutionContext = $76288626b30e899c$var$executionContext;
        $76288626b30e899c$var$executionContext |= 4;
        $76288626b30e899c$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $76288626b30e899c$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $76288626b30e899c$var$executionContext = prevExecutionContext;
        $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.onPostCommitFiberRoot) try {
            $76288626b30e899c$var$injectedHook.onPostCommitFiberRoot($76288626b30e899c$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = prevTransition, $76288626b30e899c$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $76288626b30e899c$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $76288626b30e899c$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $76288626b30e899c$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $76288626b30e899c$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($76288626b30e899c$var$markRootUpdated$1(rootFiber, 2), $76288626b30e899c$var$ensureRootIsScheduled(rootFiber));
}
function $76288626b30e899c$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $76288626b30e899c$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $76288626b30e899c$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed || !$76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $76288626b30e899c$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $76288626b30e899c$var$createClassErrorUpdate(2);
                instance = $76288626b30e899c$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($76288626b30e899c$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $76288626b30e899c$var$markRootUpdated$1(instance, 2), $76288626b30e899c$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $76288626b30e899c$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $76288626b30e899c$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($76288626b30e899c$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $76288626b30e899c$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $76288626b30e899c$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $76288626b30e899c$var$workInProgressRoot === root && ($76288626b30e899c$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $76288626b30e899c$var$workInProgressRootExitStatus || 3 === $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootRenderLanes & 62914560) === $76288626b30e899c$var$workInProgressRootRenderLanes && 300 > $76288626b30e899c$var$now() - $76288626b30e899c$var$globalMostRecentFallbackTime ? 0 === ($76288626b30e899c$var$executionContext & 2) && $76288626b30e899c$var$prepareFreshStack(root, 0) : $76288626b30e899c$var$workInProgressRootPingedLanes |= pingedLanes, $76288626b30e899c$var$workInProgressSuspendedRetryLanes === $76288626b30e899c$var$workInProgressRootRenderLanes && ($76288626b30e899c$var$workInProgressSuspendedRetryLanes = 0));
    $76288626b30e899c$var$ensureRootIsScheduled(root);
}
function $76288626b30e899c$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $76288626b30e899c$var$claimNextRetryLane());
    boundaryFiber = $76288626b30e899c$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($76288626b30e899c$var$markRootUpdated$1(boundaryFiber, retryLane), $76288626b30e899c$var$ensureRootIsScheduled(boundaryFiber));
}
function $76288626b30e899c$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $76288626b30e899c$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $76288626b30e899c$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $76288626b30e899c$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $76288626b30e899c$var$scheduleCallback$1(priorityLevel, callback) {
    return $76288626b30e899c$var$scheduleCallback$3(priorityLevel, callback);
}
var $76288626b30e899c$var$firstScheduledRoot = null, $76288626b30e899c$var$lastScheduledRoot = null, $76288626b30e899c$var$didScheduleMicrotask = !1, $76288626b30e899c$var$mightHavePendingSyncWork = !1, $76288626b30e899c$var$isFlushingWork = !1, $76288626b30e899c$var$currentEventTransitionLane = 0;
function $76288626b30e899c$var$ensureRootIsScheduled(root) {
    root !== $76288626b30e899c$var$lastScheduledRoot && null === root.next && (null === $76288626b30e899c$var$lastScheduledRoot ? $76288626b30e899c$var$firstScheduledRoot = $76288626b30e899c$var$lastScheduledRoot = root : $76288626b30e899c$var$lastScheduledRoot = $76288626b30e899c$var$lastScheduledRoot.next = root);
    $76288626b30e899c$var$mightHavePendingSyncWork = !0;
    $76288626b30e899c$var$didScheduleMicrotask || ($76288626b30e899c$var$didScheduleMicrotask = !0, $76288626b30e899c$var$scheduleImmediateRootScheduleTask());
}
function $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$76288626b30e899c$var$isFlushingWork && $76288626b30e899c$var$mightHavePendingSyncWork) {
        $76288626b30e899c$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $76288626b30e899c$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $76288626b30e899c$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $76288626b30e899c$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $76288626b30e899c$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $76288626b30e899c$var$getNextLanes(root$170, root$170 === $76288626b30e899c$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $76288626b30e899c$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $76288626b30e899c$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $76288626b30e899c$var$isFlushingWork = !1;
    }
}
function $76288626b30e899c$var$processRootScheduleInImmediateTask() {
    $76288626b30e899c$var$processRootScheduleInMicrotask();
}
function $76288626b30e899c$var$processRootScheduleInMicrotask() {
    $76288626b30e899c$var$mightHavePendingSyncWork = $76288626b30e899c$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $76288626b30e899c$var$currentEventTransitionLane && $76288626b30e899c$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $76288626b30e899c$var$currentEventTransitionLane);
    for(var currentTime = $76288626b30e899c$var$now(), prev = null, root = $76288626b30e899c$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $76288626b30e899c$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $76288626b30e899c$var$firstScheduledRoot = next : prev.next = next, null === next && ($76288626b30e899c$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $76288626b30e899c$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $76288626b30e899c$var$pendingEffectsStatus && 5 !== $76288626b30e899c$var$pendingEffectsStatus || $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $76288626b30e899c$var$currentEventTransitionLane && ($76288626b30e899c$var$currentEventTransitionLane = 0);
}
function $76288626b30e899c$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $76288626b30e899c$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $76288626b30e899c$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $76288626b30e899c$var$workInProgressRoot;
    suspendedLanes = $76288626b30e899c$var$workInProgressRootRenderLanes;
    suspendedLanes = $76288626b30e899c$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $76288626b30e899c$var$workInProgressSuspendedReason || 9 === $76288626b30e899c$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $76288626b30e899c$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $76288626b30e899c$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $76288626b30e899c$var$cancelCallback$1(pingedLanes);
        switch($76288626b30e899c$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $76288626b30e899c$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $76288626b30e899c$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $76288626b30e899c$var$IdlePriority;
                break;
            default:
                suspendedLanes = $76288626b30e899c$var$NormalPriority$1;
        }
        pingedLanes = $76288626b30e899c$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $76288626b30e899c$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $76288626b30e899c$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $76288626b30e899c$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $76288626b30e899c$var$pendingEffectsStatus && 5 !== $76288626b30e899c$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($76288626b30e899c$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $76288626b30e899c$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $76288626b30e899c$var$getNextLanes(root, root === $76288626b30e899c$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $76288626b30e899c$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $76288626b30e899c$var$scheduleTaskForRootDuringMicrotask(root, $76288626b30e899c$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $76288626b30e899c$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $76288626b30e899c$var$performSyncWorkOnRoot(root, lanes) {
    if ($76288626b30e899c$var$flushPendingEffects()) return null;
    $76288626b30e899c$var$performWorkOnRoot(root, lanes, !0);
}
function $76288626b30e899c$var$scheduleImmediateRootScheduleTask() {
    $76288626b30e899c$var$scheduleMicrotask(function() {
        0 !== ($76288626b30e899c$var$executionContext & 6) ? $76288626b30e899c$var$scheduleCallback$3($76288626b30e899c$var$ImmediatePriority, $76288626b30e899c$var$processRootScheduleInImmediateTask) : $76288626b30e899c$var$processRootScheduleInMicrotask();
    });
}
function $76288626b30e899c$var$requestTransitionLane() {
    if (0 === $76288626b30e899c$var$currentEventTransitionLane) {
        var actionScopeLane = $76288626b30e899c$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $76288626b30e899c$var$nextTransitionUpdateLane, $76288626b30e899c$var$nextTransitionUpdateLane <<= 1, 0 === ($76288626b30e899c$var$nextTransitionUpdateLane & 261888) && ($76288626b30e899c$var$nextTransitionUpdateLane = 256));
        $76288626b30e899c$var$currentEventTransitionLane = actionScopeLane;
    }
    return $76288626b30e899c$var$currentEventTransitionLane;
}
function $76288626b30e899c$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $76288626b30e899c$var$sanitizeURL("" + actionProp);
}
function $76288626b30e899c$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $76288626b30e899c$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $76288626b30e899c$var$coerceFormActionProp((nativeEventTarget[$76288626b30e899c$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$76288626b30e899c$var$internalPropsKey] || null) ? $76288626b30e899c$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $76288626b30e899c$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $76288626b30e899c$var$currentEventTransitionLane) {
                                var formData = submitter ? $76288626b30e899c$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $76288626b30e899c$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $76288626b30e899c$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $76288626b30e899c$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $76288626b30e899c$var$i$jscomp$inline_1577 = 0; $76288626b30e899c$var$i$jscomp$inline_1577 < $76288626b30e899c$var$simpleEventPluginEvents.length; $76288626b30e899c$var$i$jscomp$inline_1577++){
    var $76288626b30e899c$var$eventName$jscomp$inline_1578 = $76288626b30e899c$var$simpleEventPluginEvents[$76288626b30e899c$var$i$jscomp$inline_1577], $76288626b30e899c$var$domEventName$jscomp$inline_1579 = $76288626b30e899c$var$eventName$jscomp$inline_1578.toLowerCase(), $76288626b30e899c$var$capitalizedEvent$jscomp$inline_1580 = $76288626b30e899c$var$eventName$jscomp$inline_1578[0].toUpperCase() + $76288626b30e899c$var$eventName$jscomp$inline_1578.slice(1);
    $76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$domEventName$jscomp$inline_1579, "on" + $76288626b30e899c$var$capitalizedEvent$jscomp$inline_1580);
}
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$ANIMATION_END, "onAnimationEnd");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$ANIMATION_ITERATION, "onAnimationIteration");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$ANIMATION_START, "onAnimationStart");
$76288626b30e899c$var$registerSimpleEvent("dblclick", "onDoubleClick");
$76288626b30e899c$var$registerSimpleEvent("focusin", "onFocus");
$76288626b30e899c$var$registerSimpleEvent("focusout", "onBlur");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_RUN, "onTransitionRun");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_START, "onTransitionStart");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_CANCEL, "onTransitionCancel");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_END, "onTransitionEnd");
$76288626b30e899c$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$76288626b30e899c$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$76288626b30e899c$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$76288626b30e899c$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$76288626b30e899c$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$76288626b30e899c$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $76288626b30e899c$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $76288626b30e899c$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($76288626b30e899c$var$mediaEventTypes));
function $76288626b30e899c$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $76288626b30e899c$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $76288626b30e899c$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $76288626b30e899c$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$76288626b30e899c$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$76288626b30e899c$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($76288626b30e899c$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $76288626b30e899c$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $76288626b30e899c$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $76288626b30e899c$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $76288626b30e899c$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$76288626b30e899c$var$listeningMarker]) {
        rootContainerElement[$76288626b30e899c$var$listeningMarker] = !0;
        $76288626b30e899c$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($76288626b30e899c$var$nonDelegatedEvents.has(domEventName) || $76288626b30e899c$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $76288626b30e899c$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$76288626b30e899c$var$listeningMarker] || (ownerDocument[$76288626b30e899c$var$listeningMarker] = !0, $76288626b30e899c$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $76288626b30e899c$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($76288626b30e899c$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $76288626b30e899c$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $76288626b30e899c$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $76288626b30e899c$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$76288626b30e899c$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $76288626b30e899c$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $76288626b30e899c$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $76288626b30e899c$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $76288626b30e899c$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $76288626b30e899c$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $76288626b30e899c$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticTouchEvent;
                        break;
                    case $76288626b30e899c$var$ANIMATION_END:
                    case $76288626b30e899c$var$ANIMATION_ITERATION:
                    case $76288626b30e899c$var$ANIMATION_START:
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticAnimationEvent;
                        break;
                    case $76288626b30e899c$var$TRANSITION_END:
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $76288626b30e899c$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($76288626b30e899c$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $76288626b30e899c$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($76288626b30e899c$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$76288626b30e899c$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $76288626b30e899c$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $76288626b30e899c$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $76288626b30e899c$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $76288626b30e899c$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $76288626b30e899c$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $76288626b30e899c$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $76288626b30e899c$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $76288626b30e899c$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $76288626b30e899c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $76288626b30e899c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $76288626b30e899c$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $76288626b30e899c$var$getTargetInstForChangeEvent;
                else if ($76288626b30e899c$var$isTextInputElement(reactName)) {
                    if ($76288626b30e899c$var$isInputEventSupported) getTargetInstFunc = $76288626b30e899c$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $76288626b30e899c$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $76288626b30e899c$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $76288626b30e899c$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $76288626b30e899c$var$getTargetInstForChangeEvent) : getTargetInstFunc = $76288626b30e899c$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $76288626b30e899c$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $76288626b30e899c$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $76288626b30e899c$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($76288626b30e899c$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $76288626b30e899c$var$activeElement = handleEventFunc, $76288626b30e899c$var$activeElementInst = targetInst, $76288626b30e899c$var$lastSelection = null;
                    break;
                case "focusout":
                    $76288626b30e899c$var$lastSelection = $76288626b30e899c$var$activeElementInst = $76288626b30e899c$var$activeElement = null;
                    break;
                case "mousedown":
                    $76288626b30e899c$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $76288626b30e899c$var$mouseDown = !1;
                    $76288626b30e899c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($76288626b30e899c$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $76288626b30e899c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($76288626b30e899c$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $76288626b30e899c$var$isComposing ? $76288626b30e899c$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($76288626b30e899c$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($76288626b30e899c$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $76288626b30e899c$var$isComposing && (fallbackData = $76288626b30e899c$var$getData()) : ($76288626b30e899c$var$root = nativeEventTarget, $76288626b30e899c$var$startText = "value" in $76288626b30e899c$var$root ? $76288626b30e899c$var$root.value : $76288626b30e899c$var$root.textContent, $76288626b30e899c$var$isComposing = !0)), handleEventFunc = $76288626b30e899c$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $76288626b30e899c$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $76288626b30e899c$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $76288626b30e899c$var$canUseTextInputEvent ? $76288626b30e899c$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $76288626b30e899c$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $76288626b30e899c$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $76288626b30e899c$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $76288626b30e899c$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $76288626b30e899c$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $76288626b30e899c$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $76288626b30e899c$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $76288626b30e899c$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($76288626b30e899c$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $76288626b30e899c$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($76288626b30e899c$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $76288626b30e899c$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $76288626b30e899c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $76288626b30e899c$var$getListener(target, registrationName), null != stateNode && listeners.unshift($76288626b30e899c$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $76288626b30e899c$var$getListener(target, registrationName), null != stateNode && listeners.push($76288626b30e899c$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $76288626b30e899c$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $76288626b30e899c$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $76288626b30e899c$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($76288626b30e899c$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($76288626b30e899c$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $76288626b30e899c$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $76288626b30e899c$var$normalizeMarkupForTextOrAttribute(clientText);
    return $76288626b30e899c$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $76288626b30e899c$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $76288626b30e899c$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $76288626b30e899c$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $76288626b30e899c$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $76288626b30e899c$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $76288626b30e899c$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $76288626b30e899c$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $76288626b30e899c$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $76288626b30e899c$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $76288626b30e899c$var$setProp(domElement, tag, "name", props.name, props, null), $76288626b30e899c$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $76288626b30e899c$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $76288626b30e899c$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($76288626b30e899c$var$setProp(domElement, tag, "encType", props.encType, props, null), $76288626b30e899c$var$setProp(domElement, tag, "method", props.method, props, null), $76288626b30e899c$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $76288626b30e899c$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $76288626b30e899c$var$noop$1);
            break;
        case "onScroll":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($76288626b30e899c$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($76288626b30e899c$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $76288626b30e899c$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $76288626b30e899c$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", domElement);
            $76288626b30e899c$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $76288626b30e899c$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $76288626b30e899c$var$aliases.get(key) || key, $76288626b30e899c$var$setValueForAttribute(domElement, key, value);
    }
}
function $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $76288626b30e899c$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($76288626b30e899c$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($76288626b30e899c$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $76288626b30e899c$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $76288626b30e899c$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $76288626b30e899c$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$76288626b30e899c$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$76288626b30e899c$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $76288626b30e899c$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $76288626b30e899c$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                    default:
                        $76288626b30e899c$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $76288626b30e899c$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $76288626b30e899c$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $76288626b30e899c$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $76288626b30e899c$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $76288626b30e899c$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $76288626b30e899c$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($76288626b30e899c$var$formatProdErrorMessage(91));
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $76288626b30e899c$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $76288626b30e899c$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("cancel", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $76288626b30e899c$var$mediaEventTypes.length; hasSrc++)$76288626b30e899c$var$listenToNonDelegatedEvent($76288626b30e899c$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", domElement), $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($76288626b30e899c$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $76288626b30e899c$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $76288626b30e899c$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $76288626b30e899c$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $76288626b30e899c$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $76288626b30e899c$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $76288626b30e899c$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $76288626b30e899c$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $76288626b30e899c$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $76288626b30e899c$var$updateOptions(domElement, !!lastProps, tag, !0) : $76288626b30e899c$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($76288626b30e899c$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $76288626b30e899c$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $76288626b30e899c$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $76288626b30e899c$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($76288626b30e899c$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $76288626b30e899c$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $76288626b30e899c$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $76288626b30e899c$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $76288626b30e899c$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $76288626b30e899c$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $76288626b30e899c$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $76288626b30e899c$var$eventsEnabled = null, $76288626b30e899c$var$selectionInformation = null;
function $76288626b30e899c$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $76288626b30e899c$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $76288626b30e899c$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $76288626b30e899c$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $76288626b30e899c$var$currentPopstateTransitionEvent = null;
function $76288626b30e899c$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $76288626b30e899c$var$currentPopstateTransitionEvent) return !1;
        $76288626b30e899c$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $76288626b30e899c$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $76288626b30e899c$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $76288626b30e899c$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $76288626b30e899c$var$localPromise = "function" === typeof Promise ? Promise : void 0, $76288626b30e899c$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $76288626b30e899c$var$localPromise ? function(callback) {
    return $76288626b30e899c$var$localPromise.resolve(null).then(callback).catch($76288626b30e899c$var$handleErrorInNextTick);
} : $76288626b30e899c$var$scheduleTimeout;
function $76288626b30e899c$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $76288626b30e899c$var$isSingletonScope(type) {
    return "head" === type;
}
function $76288626b30e899c$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $76288626b30e899c$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $76288626b30e899c$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $76288626b30e899c$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$76288626b30e899c$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $76288626b30e899c$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $76288626b30e899c$var$retryIfBlockedOn(hydrationInstance);
}
function $76288626b30e899c$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $76288626b30e899c$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $76288626b30e899c$var$clearContainerSparingly(node);
                $76288626b30e899c$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $76288626b30e899c$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$76288626b30e899c$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $76288626b30e899c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $76288626b30e899c$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $76288626b30e899c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $76288626b30e899c$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $76288626b30e899c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $76288626b30e899c$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $76288626b30e899c$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $76288626b30e899c$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $76288626b30e899c$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton = null;
function $76288626b30e899c$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $76288626b30e899c$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $76288626b30e899c$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $76288626b30e899c$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $76288626b30e899c$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(451));
    }
}
function $76288626b30e899c$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $76288626b30e899c$var$detachDeletedInstance(instance);
}
var $76288626b30e899c$var$preloadPropsMap = new Map(), $76288626b30e899c$var$preconnectsSet = new Set();
function $76288626b30e899c$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $76288626b30e899c$var$previousDispatcher = $76288626b30e899c$var$ReactDOMSharedInternals.d;
$76288626b30e899c$var$ReactDOMSharedInternals.d = {
    f: $76288626b30e899c$var$flushSyncWork,
    r: $76288626b30e899c$var$requestFormReset,
    D: $76288626b30e899c$var$prefetchDNS,
    C: $76288626b30e899c$var$preconnect,
    L: $76288626b30e899c$var$preload,
    m: $76288626b30e899c$var$preloadModule,
    X: $76288626b30e899c$var$preinitScript,
    S: $76288626b30e899c$var$preinitStyle,
    M: $76288626b30e899c$var$preinitModuleScript
};
function $76288626b30e899c$var$flushSyncWork() {
    var previousWasRendering = $76288626b30e899c$var$previousDispatcher.f(), wasRendering = $76288626b30e899c$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $76288626b30e899c$var$requestFormReset(form) {
    var formInst = $76288626b30e899c$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $76288626b30e899c$var$requestFormReset$1(formInst) : $76288626b30e899c$var$previousDispatcher.r(form);
}
var $76288626b30e899c$var$globalDocument = "undefined" === typeof document ? null : document;
function $76288626b30e899c$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $76288626b30e899c$var$preconnectsSet.has(limitedEscapedHref) || ($76288626b30e899c$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $76288626b30e899c$var$setInitialProperties(href, "link", rel), $76288626b30e899c$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $76288626b30e899c$var$prefetchDNS(href) {
    $76288626b30e899c$var$previousDispatcher.D(href);
    $76288626b30e899c$var$preconnectAs("dns-prefetch", href, null);
}
function $76288626b30e899c$var$preconnect(href, crossOrigin) {
    $76288626b30e899c$var$previousDispatcher.C(href, crossOrigin);
    $76288626b30e899c$var$preconnectAs("preconnect", href, crossOrigin);
}
function $76288626b30e899c$var$preload(href, as, options) {
    $76288626b30e899c$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $76288626b30e899c$var$getStyleKey(href);
                break;
            case "script":
                key = $76288626b30e899c$var$getScriptKey(href);
        }
        $76288626b30e899c$var$preloadPropsMap.has(key) || (href = $76288626b30e899c$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $76288626b30e899c$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $76288626b30e899c$var$setInitialProperties(as, "link", href), $76288626b30e899c$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $76288626b30e899c$var$preloadModule(href, options) {
    $76288626b30e899c$var$previousDispatcher.m(href, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $76288626b30e899c$var$getScriptKey(href);
        }
        if (!$76288626b30e899c$var$preloadPropsMap.has(key) && (href = $76288626b30e899c$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $76288626b30e899c$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $76288626b30e899c$var$setInitialProperties(as, "link", href);
            $76288626b30e899c$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $76288626b30e899c$var$preinitStyle(href, precedence, options) {
    $76288626b30e899c$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $76288626b30e899c$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $76288626b30e899c$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $76288626b30e899c$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $76288626b30e899c$var$markNodeAsHoistable(link);
                $76288626b30e899c$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $76288626b30e899c$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $76288626b30e899c$var$preinitScript(src, options) {
    $76288626b30e899c$var$previousDispatcher.X(src, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $76288626b30e899c$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $76288626b30e899c$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key)), resource || (src = $76288626b30e899c$var$assign({
            src: src,
            async: !0
        }, options), (options = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $76288626b30e899c$var$markNodeAsHoistable(resource), $76288626b30e899c$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $76288626b30e899c$var$preinitModuleScript(src, options) {
    $76288626b30e899c$var$previousDispatcher.M(src, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $76288626b30e899c$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $76288626b30e899c$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key)), resource || (src = $76288626b30e899c$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $76288626b30e899c$var$markNodeAsHoistable(resource), $76288626b30e899c$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $76288626b30e899c$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $76288626b30e899c$var$rootInstanceStackCursor.current) ? $76288626b30e899c$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($76288626b30e899c$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $76288626b30e899c$var$getStyleKey(pendingProps.href), pendingProps = $76288626b30e899c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $76288626b30e899c$var$getStyleKey(pendingProps.href);
                var styles$243 = $76288626b30e899c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $76288626b30e899c$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $76288626b30e899c$var$preloadPropsMap.set(type, pendingProps), styles$243 || $76288626b30e899c$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($76288626b30e899c$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($76288626b30e899c$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $76288626b30e899c$var$getScriptKey(pendingProps), pendingProps = $76288626b30e899c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(444, type));
    }
}
function $76288626b30e899c$var$getStyleKey(href) {
    return 'href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $76288626b30e899c$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $76288626b30e899c$var$stylesheetPropsFromRawProps(rawProps) {
    return $76288626b30e899c$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $76288626b30e899c$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $76288626b30e899c$var$setInitialProperties(key, "link", preloadProps), $76288626b30e899c$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $76288626b30e899c$var$getScriptKey(src) {
    return '[src="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $76288626b30e899c$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $76288626b30e899c$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $76288626b30e899c$var$markNodeAsHoistable(instance), instance;
            var styleProps = $76288626b30e899c$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $76288626b30e899c$var$markNodeAsHoistable(instance);
            $76288626b30e899c$var$setInitialProperties(instance, "style", styleProps);
            $76288626b30e899c$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $76288626b30e899c$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $76288626b30e899c$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $76288626b30e899c$var$stylesheetPropsFromRawProps(props);
            (styleProps = $76288626b30e899c$var$preloadPropsMap.get(styleProps)) && $76288626b30e899c$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $76288626b30e899c$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $76288626b30e899c$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $76288626b30e899c$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $76288626b30e899c$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $76288626b30e899c$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $76288626b30e899c$var$preloadPropsMap.get(instance$249)) instance = $76288626b30e899c$var$assign({}, props), $76288626b30e899c$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $76288626b30e899c$var$markNodeAsHoistable(styleProps);
            $76288626b30e899c$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $76288626b30e899c$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $76288626b30e899c$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $76288626b30e899c$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $76288626b30e899c$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $76288626b30e899c$var$tagCaches = null;
function $76288626b30e899c$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $76288626b30e899c$var$tagCaches) {
        var cache = new Map();
        var caches = $76288626b30e899c$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $76288626b30e899c$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$76288626b30e899c$var$internalHoistableMarker] || node[$76288626b30e899c$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $76288626b30e899c$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $76288626b30e899c$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $76288626b30e899c$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $76288626b30e899c$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $76288626b30e899c$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $76288626b30e899c$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $76288626b30e899c$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $76288626b30e899c$var$stylesheetPropsFromRawProps(props);
            (key = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $76288626b30e899c$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $76288626b30e899c$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $76288626b30e899c$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $76288626b30e899c$var$estimatedBytesWithinLimit = 0;
function $76288626b30e899c$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $76288626b30e899c$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $76288626b30e899c$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $76288626b30e899c$var$estimatedBytesWithinLimit && ($76288626b30e899c$var$estimatedBytesWithinLimit = 62500 * $76288626b30e899c$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $76288626b30e899c$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $76288626b30e899c$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $76288626b30e899c$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $76288626b30e899c$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $76288626b30e899c$var$precedencesByRoot = null;
function $76288626b30e899c$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $76288626b30e899c$var$precedencesByRoot = new Map(), resources.forEach($76288626b30e899c$var$insertStylesheetIntoRoot, state), $76288626b30e899c$var$precedencesByRoot = null, $76288626b30e899c$var$onUnsuspend.call(state));
}
function $76288626b30e899c$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $76288626b30e899c$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $76288626b30e899c$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $76288626b30e899c$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $76288626b30e899c$var$HostTransitionContext = {
    $$typeof: $76288626b30e899c$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $76288626b30e899c$var$sharedNotPendingObject,
    _currentValue2: $76288626b30e899c$var$sharedNotPendingObject,
    _threadCount: 0
};
function $76288626b30e899c$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $76288626b30e899c$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $76288626b30e899c$var$createLaneMap(0);
    this.hiddenUpdates = $76288626b30e899c$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $76288626b30e899c$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $76288626b30e899c$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $76288626b30e899c$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $76288626b30e899c$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $76288626b30e899c$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $76288626b30e899c$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $76288626b30e899c$var$emptyContextObject;
    parentComponent = $76288626b30e899c$var$emptyContextObject;
    return parentComponent;
}
function $76288626b30e899c$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $76288626b30e899c$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $76288626b30e899c$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $76288626b30e899c$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($76288626b30e899c$var$scheduleUpdateOnFiber(element, rootFiber, lane), $76288626b30e899c$var$entangleTransitions(element, rootFiber, lane));
}
function $76288626b30e899c$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $76288626b30e899c$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $76288626b30e899c$var$markRetryLaneImpl(fiber, retryLane);
}
function $76288626b30e899c$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $76288626b30e899c$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $76288626b30e899c$var$requestUpdateLane();
        lane = $76288626b30e899c$var$getBumpedLaneForHydrationByLane(lane);
        var root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, lane);
        $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $76288626b30e899c$var$_enabled = !0;
function $76288626b30e899c$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T;
    $76288626b30e899c$var$ReactSharedInternals.T = null;
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        $76288626b30e899c$var$ReactDOMSharedInternals.p = 2, $76288626b30e899c$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $76288626b30e899c$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T;
    $76288626b30e899c$var$ReactSharedInternals.T = null;
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        $76288626b30e899c$var$ReactDOMSharedInternals.p = 8, $76288626b30e899c$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $76288626b30e899c$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($76288626b30e899c$var$_enabled) {
        var blockedOn = $76288626b30e899c$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $76288626b30e899c$var$return_targetInst, targetContainer), $76288626b30e899c$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($76288626b30e899c$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($76288626b30e899c$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $76288626b30e899c$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $76288626b30e899c$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $76288626b30e899c$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $76288626b30e899c$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $76288626b30e899c$var$ensureRootIsScheduled(fiber);
                                0 === ($76288626b30e899c$var$executionContext & 6) && ($76288626b30e899c$var$workInProgressRootRenderTargetTime = $76288626b30e899c$var$now() + 500, $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, 2), $76288626b30e899c$var$flushSyncWork$1(), $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $76288626b30e899c$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $76288626b30e899c$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $76288626b30e899c$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $76288626b30e899c$var$getEventTarget(nativeEvent);
    return $76288626b30e899c$var$findInstanceBlockingTarget(nativeEvent);
}
var $76288626b30e899c$var$return_targetInst = null;
function $76288626b30e899c$var$findInstanceBlockingTarget(targetNode) {
    $76288626b30e899c$var$return_targetInst = null;
    targetNode = $76288626b30e899c$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $76288626b30e899c$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $76288626b30e899c$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $76288626b30e899c$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $76288626b30e899c$var$return_targetInst = targetNode;
    return null;
}
function $76288626b30e899c$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($76288626b30e899c$var$getCurrentPriorityLevel()){
                case $76288626b30e899c$var$ImmediatePriority:
                    return 2;
                case $76288626b30e899c$var$UserBlockingPriority:
                    return 8;
                case $76288626b30e899c$var$NormalPriority$1:
                case $76288626b30e899c$var$LowPriority:
                    return 32;
                case $76288626b30e899c$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $76288626b30e899c$var$hasScheduledReplayAttempt = !1, $76288626b30e899c$var$queuedFocus = null, $76288626b30e899c$var$queuedDrag = null, $76288626b30e899c$var$queuedMouse = null, $76288626b30e899c$var$queuedPointers = new Map(), $76288626b30e899c$var$queuedPointerCaptures = new Map(), $76288626b30e899c$var$queuedExplicitHydrationTargets = [], $76288626b30e899c$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $76288626b30e899c$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $76288626b30e899c$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $76288626b30e899c$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $76288626b30e899c$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $76288626b30e899c$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $76288626b30e899c$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $76288626b30e899c$var$getInstanceFromNode(blockedOn), null !== blockedOn && $76288626b30e899c$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $76288626b30e899c$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $76288626b30e899c$var$queuedFocus = $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $76288626b30e899c$var$queuedDrag = $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $76288626b30e899c$var$queuedMouse = $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $76288626b30e899c$var$queuedPointers.set(pointerId, $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $76288626b30e899c$var$queuedPointerCaptures.set(pointerId, $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $76288626b30e899c$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $76288626b30e899c$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $76288626b30e899c$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $76288626b30e899c$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $76288626b30e899c$var$runWithPriority(queuedTarget.priority, function() {
                        $76288626b30e899c$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $76288626b30e899c$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $76288626b30e899c$var$runWithPriority(queuedTarget.priority, function() {
                        $76288626b30e899c$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $76288626b30e899c$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $76288626b30e899c$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $76288626b30e899c$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $76288626b30e899c$var$currentReplayingEvent = null;
        } else return targetContainers = $76288626b30e899c$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $76288626b30e899c$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $76288626b30e899c$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $76288626b30e899c$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $76288626b30e899c$var$replayUnblockedEvents() {
    $76288626b30e899c$var$hasScheduledReplayAttempt = !1;
    null !== $76288626b30e899c$var$queuedFocus && $76288626b30e899c$var$attemptReplayContinuousQueuedEvent($76288626b30e899c$var$queuedFocus) && ($76288626b30e899c$var$queuedFocus = null);
    null !== $76288626b30e899c$var$queuedDrag && $76288626b30e899c$var$attemptReplayContinuousQueuedEvent($76288626b30e899c$var$queuedDrag) && ($76288626b30e899c$var$queuedDrag = null);
    null !== $76288626b30e899c$var$queuedMouse && $76288626b30e899c$var$attemptReplayContinuousQueuedEvent($76288626b30e899c$var$queuedMouse) && ($76288626b30e899c$var$queuedMouse = null);
    $76288626b30e899c$var$queuedPointers.forEach($76288626b30e899c$var$attemptReplayContinuousQueuedEventInMap);
    $76288626b30e899c$var$queuedPointerCaptures.forEach($76288626b30e899c$var$attemptReplayContinuousQueuedEventInMap);
}
function $76288626b30e899c$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $76288626b30e899c$var$hasScheduledReplayAttempt || ($76288626b30e899c$var$hasScheduledReplayAttempt = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $76288626b30e899c$var$replayUnblockedEvents)));
}
var $76288626b30e899c$var$lastScheduledReplayQueue = null;
function $76288626b30e899c$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $76288626b30e899c$var$lastScheduledReplayQueue !== formReplayingQueue && ($76288626b30e899c$var$lastScheduledReplayQueue = formReplayingQueue, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, function() {
        $76288626b30e899c$var$lastScheduledReplayQueue === formReplayingQueue && ($76288626b30e899c$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $76288626b30e899c$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $76288626b30e899c$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $76288626b30e899c$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $76288626b30e899c$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $76288626b30e899c$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $76288626b30e899c$var$queuedFocus && $76288626b30e899c$var$scheduleCallbackIfUnblocked($76288626b30e899c$var$queuedFocus, unblocked);
    null !== $76288626b30e899c$var$queuedDrag && $76288626b30e899c$var$scheduleCallbackIfUnblocked($76288626b30e899c$var$queuedDrag, unblocked);
    null !== $76288626b30e899c$var$queuedMouse && $76288626b30e899c$var$scheduleCallbackIfUnblocked($76288626b30e899c$var$queuedMouse, unblocked);
    $76288626b30e899c$var$queuedPointers.forEach(unblock);
    $76288626b30e899c$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $76288626b30e899c$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $76288626b30e899c$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $76288626b30e899c$var$queuedExplicitHydrationTargets.length && (i = $76288626b30e899c$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$76288626b30e899c$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $76288626b30e899c$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$76288626b30e899c$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $76288626b30e899c$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$76288626b30e899c$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $76288626b30e899c$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $76288626b30e899c$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $76288626b30e899c$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $76288626b30e899c$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$76288626b30e899c$var$ReactDOMHydrationRoot.prototype.render = $76288626b30e899c$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($76288626b30e899c$var$formatProdErrorMessage(409));
    var current = root.current, lane = $76288626b30e899c$var$requestUpdateLane();
    $76288626b30e899c$var$updateContainerImpl(current, lane, children, root, null, null);
};
$76288626b30e899c$var$ReactDOMHydrationRoot.prototype.unmount = $76288626b30e899c$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $76288626b30e899c$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $76288626b30e899c$var$flushSyncWork$1();
        container[$76288626b30e899c$var$internalContainerInstanceKey] = null;
    }
};
function $76288626b30e899c$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$76288626b30e899c$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $76288626b30e899c$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $76288626b30e899c$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $76288626b30e899c$var$queuedExplicitHydrationTargets[i].priority; i++);
        $76288626b30e899c$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $76288626b30e899c$var$attemptExplicitHydrationTarget(target);
    }
};
var $76288626b30e899c$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $7fPBF.version;
if ("19.2.8" !== $76288626b30e899c$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($76288626b30e899c$var$formatProdErrorMessage(527, $76288626b30e899c$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$76288626b30e899c$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($76288626b30e899c$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $76288626b30e899c$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $76288626b30e899c$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $76288626b30e899c$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $76288626b30e899c$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $76288626b30e899c$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$76288626b30e899c$var$hook$jscomp$inline_2348.isDisabled && $76288626b30e899c$var$hook$jscomp$inline_2348.supportsFiber) try {
        $76288626b30e899c$var$rendererID = $76288626b30e899c$var$hook$jscomp$inline_2348.inject($76288626b30e899c$var$internals$jscomp$inline_2347), $76288626b30e899c$var$injectedHook = $76288626b30e899c$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$76288626b30e899c$export$882461b6382ed46c = function(container, options) {
    if (!$76288626b30e899c$var$isValidContainer(container)) throw Error($76288626b30e899c$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $76288626b30e899c$var$defaultOnUncaughtError, onCaughtError = $76288626b30e899c$var$defaultOnCaughtError, onRecoverableError = $76288626b30e899c$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $76288626b30e899c$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $76288626b30e899c$var$defaultOnDefaultTransitionIndicator);
    container[$76288626b30e899c$var$internalContainerInstanceKey] = options.current;
    $76288626b30e899c$var$listenToAllSupportedEvents(container);
    return new $76288626b30e899c$var$ReactDOMRoot(options);
};
$76288626b30e899c$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$76288626b30e899c$var$isValidContainer(container)) throw Error($76288626b30e899c$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $76288626b30e899c$var$defaultOnUncaughtError, onCaughtError = $76288626b30e899c$var$defaultOnCaughtError, onRecoverableError = $76288626b30e899c$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $76288626b30e899c$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $76288626b30e899c$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $76288626b30e899c$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $76288626b30e899c$var$requestUpdateLane();
    isStrictMode = $76288626b30e899c$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $76288626b30e899c$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $76288626b30e899c$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $76288626b30e899c$var$markRootUpdated$1(initialChildren, options);
    $76288626b30e899c$var$ensureRootIsScheduled(initialChildren);
    container[$76288626b30e899c$var$internalContainerInstanceKey] = initialChildren.current;
    $76288626b30e899c$var$listenToAllSupportedEvents(container);
    return new $76288626b30e899c$var$ReactDOMHydrationRoot(initialChildren);
};
$76288626b30e899c$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i4zJ6"));

});
parcelRegister("i4zJ6", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d284504346e22df2$export$c4744153514ff05d; }, function (v) { return $d284504346e22df2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d284504346e22df2$export$3e506c1ccc9cc1a7; }, function (v) { return $d284504346e22df2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d284504346e22df2$export$e26fe2ed2fa76875; }, function (v) { return $d284504346e22df2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d284504346e22df2$export$502329bbf4b505b1; }, function (v) { return $d284504346e22df2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d284504346e22df2$export$6e3807111c4874c4; }, function (v) { return $d284504346e22df2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d284504346e22df2$export$c27134553091fb3a; }, function (v) { return $d284504346e22df2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d284504346e22df2$export$33ee1acdc04fd2a2; }, function (v) { return $d284504346e22df2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d284504346e22df2$export$b00a404bbd5edef2; }, function (v) { return $d284504346e22df2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d284504346e22df2$export$d66a1c1c77bd778b; }, function (v) { return $d284504346e22df2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d284504346e22df2$export$d3dfb8e4810cb555; }, function (v) { return $d284504346e22df2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d284504346e22df2$export$72fdf0e06517287b; }, function (v) { return $d284504346e22df2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d284504346e22df2$export$816d2913ae6b83b1; }, function (v) { return $d284504346e22df2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d284504346e22df2$export$61bcfe829111a1d0; }, function (v) { return $d284504346e22df2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d284504346e22df2$export$7ee8c9beb337bc3f; }, function (v) { return $d284504346e22df2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d284504346e22df2$export$b5836b71941fa3ed; }, function (v) { return $d284504346e22df2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d284504346e22df2$export$cf845f2c119da08a; }, function (v) { return $d284504346e22df2$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d284504346e22df2$export$c4744153514ff05d;
var $d284504346e22df2$export$3e506c1ccc9cc1a7;
var $d284504346e22df2$export$e26fe2ed2fa76875;
var $d284504346e22df2$export$502329bbf4b505b1;
var $d284504346e22df2$export$6e3807111c4874c4;
var $d284504346e22df2$export$c27134553091fb3a;
var $d284504346e22df2$export$33ee1acdc04fd2a2;
var $d284504346e22df2$export$b00a404bbd5edef2;
var $d284504346e22df2$export$d66a1c1c77bd778b;
var $d284504346e22df2$export$d3dfb8e4810cb555;
var $d284504346e22df2$export$72fdf0e06517287b;
var $d284504346e22df2$export$816d2913ae6b83b1;
var $d284504346e22df2$export$61bcfe829111a1d0;
var $d284504346e22df2$export$7ee8c9beb337bc3f;
var $d284504346e22df2$export$b5836b71941fa3ed;
var $d284504346e22df2$export$cf845f2c119da08a;
"use strict";
function $d284504346e22df2$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $d284504346e22df2$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $d284504346e22df2$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $d284504346e22df2$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $d284504346e22df2$var$compare(left, last)) rightIndex < length && 0 > $d284504346e22df2$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $d284504346e22df2$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $d284504346e22df2$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$d284504346e22df2$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d284504346e22df2$var$localPerformance = performance;
    $d284504346e22df2$export$c4744153514ff05d = function() {
        return $d284504346e22df2$var$localPerformance.now();
    };
} else {
    var $d284504346e22df2$var$localDate = Date, $d284504346e22df2$var$initialTime = $d284504346e22df2$var$localDate.now();
    $d284504346e22df2$export$c4744153514ff05d = function() {
        return $d284504346e22df2$var$localDate.now() - $d284504346e22df2$var$initialTime;
    };
}
var $d284504346e22df2$var$taskQueue = [], $d284504346e22df2$var$timerQueue = [], $d284504346e22df2$var$taskIdCounter = 1, $d284504346e22df2$var$currentTask = null, $d284504346e22df2$var$currentPriorityLevel = 3, $d284504346e22df2$var$isPerformingWork = !1, $d284504346e22df2$var$isHostCallbackScheduled = !1, $d284504346e22df2$var$isHostTimeoutScheduled = !1, $d284504346e22df2$var$needsPaint = !1, $d284504346e22df2$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $d284504346e22df2$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $d284504346e22df2$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $d284504346e22df2$var$advanceTimers(currentTime) {
    for(var timer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue); null !== timer;){
        if (null === timer.callback) $d284504346e22df2$var$pop($d284504346e22df2$var$timerQueue);
        else if (timer.startTime <= currentTime) $d284504346e22df2$var$pop($d284504346e22df2$var$timerQueue), timer.sortIndex = timer.expirationTime, $d284504346e22df2$var$push($d284504346e22df2$var$taskQueue, timer);
        else break;
        timer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue);
    }
}
function $d284504346e22df2$var$handleTimeout(currentTime) {
    $d284504346e22df2$var$isHostTimeoutScheduled = !1;
    $d284504346e22df2$var$advanceTimers(currentTime);
    if (!$d284504346e22df2$var$isHostCallbackScheduled) {
        if (null !== $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue)) $d284504346e22df2$var$isHostCallbackScheduled = !0, $d284504346e22df2$var$isMessageLoopRunning || ($d284504346e22df2$var$isMessageLoopRunning = !0, $d284504346e22df2$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue);
            null !== firstTimer && $d284504346e22df2$var$requestHostTimeout($d284504346e22df2$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $d284504346e22df2$var$isMessageLoopRunning = !1, $d284504346e22df2$var$taskTimeoutID = -1, $d284504346e22df2$var$frameInterval = 5, $d284504346e22df2$var$startTime = -1;
function $d284504346e22df2$var$shouldYieldToHost() {
    return $d284504346e22df2$var$needsPaint ? !0 : $d284504346e22df2$export$c4744153514ff05d() - $d284504346e22df2$var$startTime < $d284504346e22df2$var$frameInterval ? !1 : !0;
}
function $d284504346e22df2$var$performWorkUntilDeadline() {
    $d284504346e22df2$var$needsPaint = !1;
    if ($d284504346e22df2$var$isMessageLoopRunning) {
        var currentTime = $d284504346e22df2$export$c4744153514ff05d();
        $d284504346e22df2$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $d284504346e22df2$var$isHostCallbackScheduled = !1;
                $d284504346e22df2$var$isHostTimeoutScheduled && ($d284504346e22df2$var$isHostTimeoutScheduled = !1, $d284504346e22df2$var$localClearTimeout($d284504346e22df2$var$taskTimeoutID), $d284504346e22df2$var$taskTimeoutID = -1);
                $d284504346e22df2$var$isPerformingWork = !0;
                var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
                try {
                    b: {
                        $d284504346e22df2$var$advanceTimers(currentTime);
                        for($d284504346e22df2$var$currentTask = $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue); null !== $d284504346e22df2$var$currentTask && !($d284504346e22df2$var$currentTask.expirationTime > currentTime && $d284504346e22df2$var$shouldYieldToHost());){
                            var callback = $d284504346e22df2$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $d284504346e22df2$var$currentTask.callback = null;
                                $d284504346e22df2$var$currentPriorityLevel = $d284504346e22df2$var$currentTask.priorityLevel;
                                var continuationCallback = callback($d284504346e22df2$var$currentTask.expirationTime <= currentTime);
                                currentTime = $d284504346e22df2$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $d284504346e22df2$var$currentTask.callback = continuationCallback;
                                    $d284504346e22df2$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $d284504346e22df2$var$currentTask === $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue) && $d284504346e22df2$var$pop($d284504346e22df2$var$taskQueue);
                                $d284504346e22df2$var$advanceTimers(currentTime);
                            } else $d284504346e22df2$var$pop($d284504346e22df2$var$taskQueue);
                            $d284504346e22df2$var$currentTask = $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue);
                        }
                        if (null !== $d284504346e22df2$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue);
                            null !== firstTimer && $d284504346e22df2$var$requestHostTimeout($d284504346e22df2$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $d284504346e22df2$var$currentTask = null, $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel, $d284504346e22df2$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $d284504346e22df2$var$schedulePerformWorkUntilDeadline() : $d284504346e22df2$var$isMessageLoopRunning = !1;
        }
    }
}
var $d284504346e22df2$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $d284504346e22df2$var$localSetImmediate) $d284504346e22df2$var$schedulePerformWorkUntilDeadline = function() {
    $d284504346e22df2$var$localSetImmediate($d284504346e22df2$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d284504346e22df2$var$channel = new MessageChannel(), $d284504346e22df2$var$port = $d284504346e22df2$var$channel.port2;
    $d284504346e22df2$var$channel.port1.onmessage = $d284504346e22df2$var$performWorkUntilDeadline;
    $d284504346e22df2$var$schedulePerformWorkUntilDeadline = function() {
        $d284504346e22df2$var$port.postMessage(null);
    };
} else $d284504346e22df2$var$schedulePerformWorkUntilDeadline = function() {
    $d284504346e22df2$var$localSetTimeout($d284504346e22df2$var$performWorkUntilDeadline, 0);
};
function $d284504346e22df2$var$requestHostTimeout(callback, ms) {
    $d284504346e22df2$var$taskTimeoutID = $d284504346e22df2$var$localSetTimeout(function() {
        callback($d284504346e22df2$export$c4744153514ff05d());
    }, ms);
}
$d284504346e22df2$export$3e506c1ccc9cc1a7 = 5;
$d284504346e22df2$export$e26fe2ed2fa76875 = 1;
$d284504346e22df2$export$502329bbf4b505b1 = 4;
$d284504346e22df2$export$6e3807111c4874c4 = 3;
$d284504346e22df2$export$c27134553091fb3a = null;
$d284504346e22df2$export$33ee1acdc04fd2a2 = 2;
$d284504346e22df2$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$d284504346e22df2$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d284504346e22df2$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$d284504346e22df2$export$d3dfb8e4810cb555 = function() {
    return $d284504346e22df2$var$currentPriorityLevel;
};
$d284504346e22df2$export$72fdf0e06517287b = function(eventHandler) {
    switch($d284504346e22df2$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    $d284504346e22df2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d284504346e22df2$export$816d2913ae6b83b1 = function() {
    $d284504346e22df2$var$needsPaint = !0;
};
$d284504346e22df2$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    $d284504346e22df2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d284504346e22df2$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $d284504346e22df2$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $d284504346e22df2$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $d284504346e22df2$var$push($d284504346e22df2$var$timerQueue, priorityLevel), null === $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue) && priorityLevel === $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue) && ($d284504346e22df2$var$isHostTimeoutScheduled ? ($d284504346e22df2$var$localClearTimeout($d284504346e22df2$var$taskTimeoutID), $d284504346e22df2$var$taskTimeoutID = -1) : $d284504346e22df2$var$isHostTimeoutScheduled = !0, $d284504346e22df2$var$requestHostTimeout($d284504346e22df2$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $d284504346e22df2$var$push($d284504346e22df2$var$taskQueue, priorityLevel), $d284504346e22df2$var$isHostCallbackScheduled || $d284504346e22df2$var$isPerformingWork || ($d284504346e22df2$var$isHostCallbackScheduled = !0, $d284504346e22df2$var$isMessageLoopRunning || ($d284504346e22df2$var$isMessageLoopRunning = !0, $d284504346e22df2$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$d284504346e22df2$export$b5836b71941fa3ed = $d284504346e22df2$var$shouldYieldToHost;
$d284504346e22df2$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
        $d284504346e22df2$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ik80y"));

});

parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("bsyIp"));

});
parcelRegister("bsyIp", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $857d3cfd292f62db$export$69ce8ef3fe5cead0; }, function (v) { return $857d3cfd292f62db$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $857d3cfd292f62db$export$d39a5bbd09211389; }, function (v) { return $857d3cfd292f62db$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $857d3cfd292f62db$export$cd75ccfd720a3cd4; }, function (v) { return $857d3cfd292f62db$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $857d3cfd292f62db$export$a0816fa17a9e79be; }, function (v) { return $857d3cfd292f62db$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $857d3cfd292f62db$export$7292efcadded39f3; }, function (v) { return $857d3cfd292f62db$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $857d3cfd292f62db$export$da407abadb9b8f86; }, function (v) { return $857d3cfd292f62db$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $857d3cfd292f62db$export$314cfea32580671c; }, function (v) { return $857d3cfd292f62db$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $857d3cfd292f62db$export$513ccb98c53b8039; }, function (v) { return $857d3cfd292f62db$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $857d3cfd292f62db$export$dbca993bc2d264a; }, function (v) { return $857d3cfd292f62db$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $857d3cfd292f62db$export$4797a8006f0655d0; }, function (v) { return $857d3cfd292f62db$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $857d3cfd292f62db$export$c78a37762a8d58e1; }, function (v) { return $857d3cfd292f62db$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $857d3cfd292f62db$export$606f11b2eb45ecc6; }, function (v) { return $857d3cfd292f62db$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $857d3cfd292f62db$export$f7e8a0bf92324b1e; }, function (v) { return $857d3cfd292f62db$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $857d3cfd292f62db$export$83d89fbfd8236492; }, function (v) { return $857d3cfd292f62db$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $857d3cfd292f62db$export$69ce8ef3fe5cead0;
var $857d3cfd292f62db$export$d39a5bbd09211389;
var $857d3cfd292f62db$export$cd75ccfd720a3cd4;
var $857d3cfd292f62db$export$a0816fa17a9e79be;
var $857d3cfd292f62db$export$7292efcadded39f3;
var $857d3cfd292f62db$export$da407abadb9b8f86;
var $857d3cfd292f62db$export$314cfea32580671c;
var $857d3cfd292f62db$export$513ccb98c53b8039;
var $857d3cfd292f62db$export$dbca993bc2d264a;
var $857d3cfd292f62db$export$4797a8006f0655d0;
var $857d3cfd292f62db$export$c78a37762a8d58e1;
var $857d3cfd292f62db$export$606f11b2eb45ecc6;
var $857d3cfd292f62db$export$f7e8a0bf92324b1e;
var $857d3cfd292f62db$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $857d3cfd292f62db$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $857d3cfd292f62db$var$noop() {}
var $857d3cfd292f62db$var$Internals = {
    d: {
        f: $857d3cfd292f62db$var$noop,
        r: function() {
            throw Error($857d3cfd292f62db$var$formatProdErrorMessage(522));
        },
        D: $857d3cfd292f62db$var$noop,
        C: $857d3cfd292f62db$var$noop,
        L: $857d3cfd292f62db$var$noop,
        m: $857d3cfd292f62db$var$noop,
        X: $857d3cfd292f62db$var$noop,
        S: $857d3cfd292f62db$var$noop,
        M: $857d3cfd292f62db$var$noop
    },
    p: 0,
    findDOMNode: null
}, $857d3cfd292f62db$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $857d3cfd292f62db$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $857d3cfd292f62db$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $857d3cfd292f62db$var$ReactSharedInternals = $7fPBF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $857d3cfd292f62db$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$857d3cfd292f62db$export$69ce8ef3fe5cead0 = $857d3cfd292f62db$var$Internals;
$857d3cfd292f62db$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($857d3cfd292f62db$var$formatProdErrorMessage(299));
    return $857d3cfd292f62db$var$createPortal$1(children, container, null, key);
};
$857d3cfd292f62db$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $857d3cfd292f62db$var$ReactSharedInternals.T, previousUpdatePriority = $857d3cfd292f62db$var$Internals.p;
    try {
        if ($857d3cfd292f62db$var$ReactSharedInternals.T = null, $857d3cfd292f62db$var$Internals.p = 2, fn) return fn();
    } finally{
        $857d3cfd292f62db$var$ReactSharedInternals.T = previousTransition, $857d3cfd292f62db$var$Internals.p = previousUpdatePriority, $857d3cfd292f62db$var$Internals.d.f();
    }
};
$857d3cfd292f62db$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $857d3cfd292f62db$var$Internals.d.C(href, options));
};
$857d3cfd292f62db$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $857d3cfd292f62db$var$Internals.d.D(href);
};
$857d3cfd292f62db$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $857d3cfd292f62db$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $857d3cfd292f62db$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$857d3cfd292f62db$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $857d3cfd292f62db$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $857d3cfd292f62db$var$Internals.d.M(href);
    }
};
$857d3cfd292f62db$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(as, options.crossOrigin);
        $857d3cfd292f62db$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$857d3cfd292f62db$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $857d3cfd292f62db$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $857d3cfd292f62db$var$Internals.d.m(href);
    }
};
$857d3cfd292f62db$export$4797a8006f0655d0 = function(form) {
    $857d3cfd292f62db$var$Internals.d.r(form);
};
$857d3cfd292f62db$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$857d3cfd292f62db$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $857d3cfd292f62db$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$857d3cfd292f62db$export$f7e8a0bf92324b1e = function() {
    return $857d3cfd292f62db$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$857d3cfd292f62db$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("gSkQi", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("iBNfx", function(module, exports) {
"use strict";
var $d8c1e2a1cf8cf9b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d8c1e2a1cf8cf9b0$var$StyleToObject;

const $d8c1e2a1cf8cf9b0$var$inline_style_parser_1 = $d8c1e2a1cf8cf9b0$var$__importDefault((parcelRequire("7i3uy")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $d8c1e2a1cf8cf9b0$var$StyleToObject(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $d8c1e2a1cf8cf9b0$var$inline_style_parser_1.default)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("7i3uy", function(module, exports) {
'use strict';
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $54ecec3fabbab431$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $54ecec3fabbab431$var$NEWLINE_REGEX = /\n/g;
var $54ecec3fabbab431$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $54ecec3fabbab431$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $54ecec3fabbab431$var$COLON_REGEX = /^:\s*/;
var $54ecec3fabbab431$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $54ecec3fabbab431$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $54ecec3fabbab431$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $54ecec3fabbab431$var$NEWLINE = '\n';
var $54ecec3fabbab431$var$FORWARD_SLASH = '/';
var $54ecec3fabbab431$var$ASTERISK = '*';
var $54ecec3fabbab431$var$EMPTY_STRING = '';
// types
var $54ecec3fabbab431$var$TYPE_COMMENT = 'comment';
var $54ecec3fabbab431$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $54ecec3fabbab431$var$index(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($54ecec3fabbab431$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($54ecec3fabbab431$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($54ecec3fabbab431$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($54ecec3fabbab431$var$FORWARD_SLASH != style.charAt(0) || $54ecec3fabbab431$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($54ecec3fabbab431$var$EMPTY_STRING != style.charAt(i) && ($54ecec3fabbab431$var$ASTERISK != style.charAt(i) || $54ecec3fabbab431$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($54ecec3fabbab431$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $54ecec3fabbab431$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($54ecec3fabbab431$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($54ecec3fabbab431$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($54ecec3fabbab431$var$VALUE_REGEX);
        var ret = pos({
            type: $54ecec3fabbab431$var$TYPE_DECLARATION,
            property: $54ecec3fabbab431$var$trim(prop[0].replace($54ecec3fabbab431$var$COMMENT_REGEX, $54ecec3fabbab431$var$EMPTY_STRING)),
            value: val ? $54ecec3fabbab431$var$trim(val[0].replace($54ecec3fabbab431$var$COMMENT_REGEX, $54ecec3fabbab431$var$EMPTY_STRING)) : $54ecec3fabbab431$var$EMPTY_STRING
        });
        // ;
        match($54ecec3fabbab431$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $54ecec3fabbab431$var$trim(str) {
    return str ? str.replace($54ecec3fabbab431$var$TRIM_REGEX, $54ecec3fabbab431$var$EMPTY_STRING) : $54ecec3fabbab431$var$EMPTY_STRING;
}
module.exports = $54ecec3fabbab431$var$index;

});


parcelRegister("3MsYN", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $iPRIv = parcelRequire("iPRIv");
function isNodeEnv() {
    return !(0, $iPRIv.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {}
    return mod;
}

});
parcelRegister("iPRIv", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $db66a870e5b08f0d$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $db66a870e5b08f0d$export$8ad33f488b1ab046; });
function $db66a870e5b08f0d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $db66a870e5b08f0d$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


var $4ab4df502cb196a5$exports = {};
$parcel$extendImportMap({
    "5x3at": "browser-ponyfill.3b25b608.js",
    "dHypX": "model.tar.ad9aa18b.gz"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("cx8Kh"));


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $a3749e0ba38a91a1$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}




var $7fPBF = parcelRequire("7fPBF");
var $dddaf6f84c717660$exports = {};
'use strict';

$dddaf6f84c717660$exports = (parcelRequire("9kHYF"));


function $9450f632817fee8b$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $9450f632817fee8b$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || (0, $dddaf6f84c717660$exports.isValidElementType)(source) || !$9450f632817fee8b$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $9450f632817fee8b$var$deepClone(source[key]);
    });
    return output;
}
function $9450f632817fee8b$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, target) : target;
    if ($9450f632817fee8b$export$53b83ca8eaab0383(target) && $9450f632817fee8b$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key]) || (0, $dddaf6f84c717660$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($9450f632817fee8b$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $9450f632817fee8b$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $9450f632817fee8b$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $9450f632817fee8b$export$53b83ca8eaab0383(source[key]) ? $9450f632817fee8b$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



function $99fc5207cecba1ae$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $99fc5207cecba1ae$export$2e2bcd8739ae039 = $99fc5207cecba1ae$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $989ea3f9d8f44081$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(value, min, max);
}
function $989ea3f9d8f44081$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $989ea3f9d8f44081$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $989ea3f9d8f44081$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $989ea3f9d8f44081$export$677b39864803984e($989ea3f9d8f44081$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $989ea3f9d8f44081$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $989ea3f9d8f44081$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $989ea3f9d8f44081$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $989ea3f9d8f44081$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $989ea3f9d8f44081$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $989ea3f9d8f44081$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $989ea3f9d8f44081$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$989ea3f9d8f44081$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $989ea3f9d8f44081$export$29fb7152bd3f781a(color) {
    color = $989ea3f9d8f44081$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $989ea3f9d8f44081$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $989ea3f9d8f44081$export$c852d90bf7403b62(color) {
    color = $989ea3f9d8f44081$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $989ea3f9d8f44081$export$677b39864803984e($989ea3f9d8f44081$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $989ea3f9d8f44081$export$d061e26956a60b0a(foreground, background) {
    const lumA = $989ea3f9d8f44081$export$c852d90bf7403b62(foreground);
    const lumB = $989ea3f9d8f44081$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $989ea3f9d8f44081$export$58f0f39f63f3cf42(color, value) {
    color = $989ea3f9d8f44081$export$677b39864803984e(color);
    value = $989ea3f9d8f44081$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $989ea3f9d8f44081$export$211a73f2b8c10ce4(color);
}
function $989ea3f9d8f44081$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $989ea3f9d8f44081$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $989ea3f9d8f44081$export$4b073707ff63303(color, coefficient) {
    color = $989ea3f9d8f44081$export$677b39864803984e(color);
    coefficient = $989ea3f9d8f44081$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $989ea3f9d8f44081$export$211a73f2b8c10ce4(color);
}
function $989ea3f9d8f44081$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $989ea3f9d8f44081$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $989ea3f9d8f44081$export$c0816ed86df316af(color, coefficient) {
    color = $989ea3f9d8f44081$export$677b39864803984e(color);
    coefficient = $989ea3f9d8f44081$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $989ea3f9d8f44081$export$211a73f2b8c10ce4(color);
}
function $989ea3f9d8f44081$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $989ea3f9d8f44081$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $989ea3f9d8f44081$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $989ea3f9d8f44081$export$c852d90bf7403b62(color) > 0.5 ? $989ea3f9d8f44081$export$4b073707ff63303(color, coefficient) : $989ea3f9d8f44081$export$c0816ed86df316af(color, coefficient);
}
function $989ea3f9d8f44081$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $989ea3f9d8f44081$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $989ea3f9d8f44081$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $989ea3f9d8f44081$export$677b39864803984e(background);
    const overlayColor = $989ea3f9d8f44081$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $989ea3f9d8f44081$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


const $dac596d9abb305c6$var$common = {
    black: '#000',
    white: '#fff'
};
var $dac596d9abb305c6$export$2e2bcd8739ae039 = $dac596d9abb305c6$var$common;


const $64cefcf88c2129b4$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $64cefcf88c2129b4$export$2e2bcd8739ae039 = $64cefcf88c2129b4$var$grey;


const $bcfd6d81006b8ab8$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $bcfd6d81006b8ab8$export$2e2bcd8739ae039 = $bcfd6d81006b8ab8$var$purple;


const $53d64a9988eb98dd$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $53d64a9988eb98dd$export$2e2bcd8739ae039 = $53d64a9988eb98dd$var$red;


const $a472a56900003dbe$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a472a56900003dbe$export$2e2bcd8739ae039 = $a472a56900003dbe$var$orange;


const $8b15e2e989c63fd7$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $8b15e2e989c63fd7$export$2e2bcd8739ae039 = $8b15e2e989c63fd7$var$blue;


const $6ab7cf837977fc4c$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $6ab7cf837977fc4c$export$2e2bcd8739ae039 = $6ab7cf837977fc4c$var$lightBlue;


const $36f72371affe2c9e$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $36f72371affe2c9e$export$2e2bcd8739ae039 = $36f72371affe2c9e$var$green;


function $7a7e36d4dd7a79ff$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $dac596d9abb305c6$export$2e2bcd8739ae039).white,
            default: (0, $dac596d9abb305c6$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $7a7e36d4dd7a79ff$export$a43af521ac8c3202 = $7a7e36d4dd7a79ff$var$getLight();
function $7a7e36d4dd7a79ff$var$getDark() {
    return {
        text: {
            primary: (0, $dac596d9abb305c6$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $dac596d9abb305c6$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $7a7e36d4dd7a79ff$export$55ce6f3a06c59543 = $7a7e36d4dd7a79ff$var$getDark();
function $7a7e36d4dd7a79ff$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $989ea3f9d8f44081$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $989ea3f9d8f44081$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $7a7e36d4dd7a79ff$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $7a7e36d4dd7a79ff$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $8b15e2e989c63fd7$export$2e2bcd8739ae039)[200],
        light: (0, $8b15e2e989c63fd7$export$2e2bcd8739ae039)[50],
        dark: (0, $8b15e2e989c63fd7$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $8b15e2e989c63fd7$export$2e2bcd8739ae039)[700],
        light: (0, $8b15e2e989c63fd7$export$2e2bcd8739ae039)[400],
        dark: (0, $8b15e2e989c63fd7$export$2e2bcd8739ae039)[800]
    };
}
function $7a7e36d4dd7a79ff$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bcfd6d81006b8ab8$export$2e2bcd8739ae039)[200],
        light: (0, $bcfd6d81006b8ab8$export$2e2bcd8739ae039)[50],
        dark: (0, $bcfd6d81006b8ab8$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $bcfd6d81006b8ab8$export$2e2bcd8739ae039)[500],
        light: (0, $bcfd6d81006b8ab8$export$2e2bcd8739ae039)[300],
        dark: (0, $bcfd6d81006b8ab8$export$2e2bcd8739ae039)[700]
    };
}
function $7a7e36d4dd7a79ff$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $53d64a9988eb98dd$export$2e2bcd8739ae039)[500],
        light: (0, $53d64a9988eb98dd$export$2e2bcd8739ae039)[300],
        dark: (0, $53d64a9988eb98dd$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $53d64a9988eb98dd$export$2e2bcd8739ae039)[700],
        light: (0, $53d64a9988eb98dd$export$2e2bcd8739ae039)[400],
        dark: (0, $53d64a9988eb98dd$export$2e2bcd8739ae039)[800]
    };
}
function $7a7e36d4dd7a79ff$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $6ab7cf837977fc4c$export$2e2bcd8739ae039)[400],
        light: (0, $6ab7cf837977fc4c$export$2e2bcd8739ae039)[300],
        dark: (0, $6ab7cf837977fc4c$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $6ab7cf837977fc4c$export$2e2bcd8739ae039)[700],
        light: (0, $6ab7cf837977fc4c$export$2e2bcd8739ae039)[500],
        dark: (0, $6ab7cf837977fc4c$export$2e2bcd8739ae039)[900]
    };
}
function $7a7e36d4dd7a79ff$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $36f72371affe2c9e$export$2e2bcd8739ae039)[400],
        light: (0, $36f72371affe2c9e$export$2e2bcd8739ae039)[300],
        dark: (0, $36f72371affe2c9e$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $36f72371affe2c9e$export$2e2bcd8739ae039)[800],
        light: (0, $36f72371affe2c9e$export$2e2bcd8739ae039)[500],
        dark: (0, $36f72371affe2c9e$export$2e2bcd8739ae039)[900]
    };
}
function $7a7e36d4dd7a79ff$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $a472a56900003dbe$export$2e2bcd8739ae039)[400],
        light: (0, $a472a56900003dbe$export$2e2bcd8739ae039)[300],
        dark: (0, $a472a56900003dbe$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $a472a56900003dbe$export$2e2bcd8739ae039)[500],
        dark: (0, $a472a56900003dbe$export$2e2bcd8739ae039)[900]
    };
}
function $7a7e36d4dd7a79ff$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $7a7e36d4dd7a79ff$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace } = palette, other = (0, $8901fc92b5563702$export$71511d61b312f219)(palette, [
        "mode",
        "contrastThreshold",
        "tonalOffset",
        "colorSpace"
    ]);
    const primary = palette.primary || $7a7e36d4dd7a79ff$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $7a7e36d4dd7a79ff$var$getDefaultSecondary(mode);
    const error = palette.error || $7a7e36d4dd7a79ff$var$getDefaultError(mode);
    const info = palette.info || $7a7e36d4dd7a79ff$var$getDefaultInfo(mode);
    const success = palette.success || $7a7e36d4dd7a79ff$var$getDefaultSuccess(mode);
    const warning = palette.warning || $7a7e36d4dd7a79ff$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $7a7e36d4dd7a79ff$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $989ea3f9d8f44081$export$d061e26956a60b0a)(background, $7a7e36d4dd7a79ff$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $7a7e36d4dd7a79ff$export$55ce6f3a06c59543.text.primary : $7a7e36d4dd7a79ff$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $7a7e36d4dd7a79ff$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $7a7e36d4dd7a79ff$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $7a7e36d4dd7a79ff$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $7a7e36d4dd7a79ff$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $7a7e36d4dd7a79ff$var$getLight();
    else if (mode === 'dark') modeHydrated = $7a7e36d4dd7a79ff$var$getDark();
    const paletteOutput = (0, $9450f632817fee8b$export$2e2bcd8739ae039)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        // A collection of common colors.
        common: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $dac596d9abb305c6$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $64cefcf88c2129b4$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modeHydrated), other);
    return paletteOutput;
}





function $82893a1ac286eedc$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $3b9a765e165f5e2c$export$71511d61b312f219(input, hint) {
    if ((0, $82893a1ac286eedc$export$71511d61b312f219)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $82893a1ac286eedc$export$71511d61b312f219)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



function $48eb3f76e7383a7f$export$71511d61b312f219(arg) {
    var key = (0, $3b9a765e165f5e2c$export$71511d61b312f219)(arg, "string");
    return (0, $82893a1ac286eedc$export$71511d61b312f219)(key) === "symbol" ? key : String(key);
}







function $1f51cf9603142ca0$export$2e2bcd8739ae039(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}


// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $e24c9655957c457a$export$2e2bcd8739ae039(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($e24c9655957c457a$var$isPrimitive(source)) return source;
    else if ($e24c9655957c457a$var$isPrimitiveOrBuiltIn(target)) return $e24c9655957c457a$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $e24c9655957c457a$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $e24c9655957c457a$var$clone(source);
    else return $e24c9655957c457a$var$mergeObject(target, source);
}
function $e24c9655957c457a$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $e24c9655957c457a$var$clone(value[i]);
    return result;
}
function $e24c9655957c457a$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $e24c9655957c457a$var$clone(target[key]);
    }
    return result;
}
function $e24c9655957c457a$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $e24c9655957c457a$var$clone(source[i]);
    return target;
}
function $e24c9655957c457a$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $e24c9655957c457a$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $e24c9655957c457a$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $e24c9655957c457a$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $e24c9655957c457a$var$isMergeableObject(entry) ? Array.isArray(entry) ? $e24c9655957c457a$var$cloneArray(entry) : $e24c9655957c457a$var$cloneObject(entry) : entry;
}
function $e24c9655957c457a$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $e24c9655957c457a$export$2e2bcd8739ae039(target[key], source[key]);
        else target[key] = $e24c9655957c457a$var$clone(source[key]);
    }
    return target;
}




const $7a99033bea648245$var$options = {
    clone: false
};
function $7a99033bea648245$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $9450f632817fee8b$export$2e2bcd8739ae039)(acc, item, $7a99033bea648245$var$options);
}
var $7a99033bea648245$export$2e2bcd8739ae039 = $7a99033bea648245$var$merge;




const $8eb1669f81b5b1e4$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
function $8eb1669f81b5b1e4$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries || !$8eb1669f81b5b1e4$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        var _a_match, _b_match;
        return +(((_a_match = a.match($8eb1669f81b5b1e4$var$MIN_WIDTH_PATTERN)) === null || _a_match === void 0 ? void 0 : _a_match[1]) || 0) - +(((_b_match = b.match($8eb1669f81b5b1e4$var$MIN_WIDTH_PATTERN)) === null || _b_match === void 0 ? void 0 : _b_match[1]) || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $8eb1669f81b5b1e4$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $8eb1669f81b5b1e4$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $8eb1669f81b5b1e4$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $8eb1669f81b5b1e4$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, themeInput), {
        containerQueries: containerQueries
    });
}


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.



const $3ec250ca90ab849c$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $3ec250ca90ab849c$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, acc), {
            [obj.key]: obj.val
        });
    }, {});
};
function $3ec250ca90ab849c$export$2e2bcd8739ae039(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $8901fc92b5563702$export$71511d61b312f219)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    const sortedValues = $3ec250ca90ab849c$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys
    }, other);
}


const $65bea5ced4e8db0c$var$EMPTY_THEME = {};
const $65bea5ced4e8db0c$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $65bea5ced4e8db0c$export$666ad80b5007f835 = (0, $3ec250ca90ab849c$export$2e2bcd8739ae039)({
    values: $65bea5ced4e8db0c$export$68c286be0e7e55b7
});
const $65bea5ced4e8db0c$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $65bea5ced4e8db0c$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $65bea5ced4e8db0c$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const result = {};
    return $65bea5ced4e8db0c$export$2aea645392b97e0b(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $e24c9655957c457a$export$2e2bcd8739ae039)(result, finalValue);
    });
}
function $65bea5ced4e8db0c$export$2aea645392b97e0b(target, theme, propValue, callback) {
    theme !== null && theme !== void 0 ? theme : theme = $65bea5ced4e8db0c$var$EMPTY_THEME;
    if (Array.isArray(propValue)) {
        var _theme_breakpoints;
        const breakpoints = (_theme_breakpoints = theme.breakpoints) !== null && _theme_breakpoints !== void 0 ? _theme_breakpoints : $65bea5ced4e8db0c$export$666ad80b5007f835;
        for(let i = 0; i < propValue.length; i += 1)$65bea5ced4e8db0c$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        var _theme_breakpoints1;
        const breakpoints = (_theme_breakpoints1 = theme.breakpoints) !== null && _theme_breakpoints1 !== void 0 ? _theme_breakpoints1 : $65bea5ced4e8db0c$export$666ad80b5007f835;
        var _breakpoints_values;
        const breakpointValues = (_breakpoints_values = breakpoints.values) !== null && _breakpoints_values !== void 0 ? _breakpoints_values : $65bea5ced4e8db0c$export$68c286be0e7e55b7;
        for(const key in propValue){
            if ((0, $8eb1669f81b5b1e4$export$77c7c3e357f440e7)(breakpoints.keys, key)) {
                const containerKey = (0, $8eb1669f81b5b1e4$export$10a9745dfa00d15)(theme.containerQueries ? theme : $65bea5ced4e8db0c$var$defaultContainerQueries, key);
                if (containerKey) $65bea5ced4e8db0c$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $65bea5ced4e8db0c$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $65bea5ced4e8db0c$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    var _target, _mediaKey;
    var _;
    (_ = (_target = target)[_mediaKey = mediaKey]) !== null && _ !== void 0 ? _ : _target[_mediaKey] = {};
    callback(mediaKey, value, initialKey);
}
function $65bea5ced4e8db0c$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $65bea5ced4e8db0c$export$666ad80b5007f835;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7a99033bea648245$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $65bea5ced4e8db0c$export$1f2600516e91381f(breakpoints = $65bea5ced4e8db0c$export$666ad80b5007f835) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
function $65bea5ced4e8db0c$export$8922c90b6e020726(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $1f51cf9603142ca0$export$2e2bcd8739ae039)(style[key])) delete style[key];
    }
    return style;
}
function $65bea5ced4e8db0c$export$b89a003a1e05c0ee(breakpoints, ...styles) {
    const emptyBreakpoints = $65bea5ced4e8db0c$export$1f2600516e91381f(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $9450f632817fee8b$export$2e2bcd8739ae039)(prev, next), {});
    return $65bea5ced4e8db0c$export$8922c90b6e020726(breakpoints, mergedOutput);
}
function $65bea5ced4e8db0c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $65bea5ced4e8db0c$export$980e6a259d807490(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $65bea5ced4e8db0c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $65bea5ced4e8db0c$export$c29c12f694bb7a2f(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $8eb1669f81b5b1e4$export$77c7c3e357f440e7)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $65bea5ced4e8db0c$export$2e2bcd8739ae039 = $65bea5ced4e8db0c$var$setupBreakpoints;



function $c2e12d7064dac06e$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $162c298b3631ac0e$export$741ad47189a64aa0(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $162c298b3631ac0e$export$2aa3fd96c49a84a8(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $162c298b3631ac0e$export$245e5a5849651da5(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $162c298b3631ac0e$export$2aa3fd96c49a84a8(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $162c298b3631ac0e$export$2aa3fd96c49a84a8(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $162c298b3631ac0e$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $162c298b3631ac0e$var$getPathImpl(obj, path, alternateProp);
}
function $162c298b3631ac0e$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $c2e12d7064dac06e$export$2e2bcd8739ae039)(lastKey)}`;
        return lastResult === null || lastResult === void 0 ? void 0 : lastResult[alternateKey];
    }
    return result;
}
function $162c298b3631ac0e$export$2e2bcd8739ae039(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $162c298b3631ac0e$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $162c298b3631ac0e$export$245e5a5849651da5(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $65bea5ced4e8db0c$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}


/* eslint-disable guard-for-in */ const $920f30c3f9a97fc1$var$EMPTY_THEME = {
    internal_cache: {}
};
const $920f30c3f9a97fc1$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $920f30c3f9a97fc1$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $920f30c3f9a97fc1$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $920f30c3f9a97fc1$var$CSS_PROPERTIES = {};
for(const key in $920f30c3f9a97fc1$var$properties)$920f30c3f9a97fc1$var$CSS_PROPERTIES[key] = [
    $920f30c3f9a97fc1$var$properties[key]
];
for(const keyProperty in $920f30c3f9a97fc1$var$properties)for(const keyDirection in $920f30c3f9a97fc1$var$directions){
    const property = $920f30c3f9a97fc1$var$properties[keyProperty];
    const direction = $920f30c3f9a97fc1$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $920f30c3f9a97fc1$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $920f30c3f9a97fc1$var$aliases)$920f30c3f9a97fc1$var$CSS_PROPERTIES[key] = $920f30c3f9a97fc1$var$CSS_PROPERTIES[$920f30c3f9a97fc1$var$aliases[key]];
const $920f30c3f9a97fc1$export$aab52a0dde05ad8a = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
const $920f30c3f9a97fc1$export$f8397d44f03ab6ad = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $920f30c3f9a97fc1$var$spacingKeys = new Set([
    ...$920f30c3f9a97fc1$export$aab52a0dde05ad8a,
    ...$920f30c3f9a97fc1$export$f8397d44f03ab6ad
]);
function $920f30c3f9a97fc1$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $162c298b3631ac0e$export$2aa3fd96c49a84a8)(theme, themeKey, true)) !== null && _getPath !== void 0 ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $920f30c3f9a97fc1$export$1def6f833384e3d1(theme) {
    return $920f30c3f9a97fc1$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $920f30c3f9a97fc1$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $920f30c3f9a97fc1$var$container = [
    ''
];
function $920f30c3f9a97fc1$var$style(props, keys) {
    var _theme_internal_cache;
    var _props_theme;
    const theme = (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : $920f30c3f9a97fc1$var$EMPTY_THEME;
    var _theme_internal_cache_unarySpacing;
    const transformer = (_theme_internal_cache_unarySpacing = theme === null || theme === void 0 ? void 0 : (_theme_internal_cache = theme.internal_cache) === null || _theme_internal_cache === void 0 ? void 0 : _theme_internal_cache.unarySpacing) !== null && _theme_internal_cache_unarySpacing !== void 0 ? _theme_internal_cache_unarySpacing : $920f30c3f9a97fc1$export$1def6f833384e3d1(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        var _CSS_PROPERTIES_prop;
        const cssProperties = (_CSS_PROPERTIES_prop = $920f30c3f9a97fc1$var$CSS_PROPERTIES[prop]) !== null && _CSS_PROPERTIES_prop !== void 0 ? _CSS_PROPERTIES_prop : ($920f30c3f9a97fc1$var$container[0] = prop, $920f30c3f9a97fc1$var$container);
        const propValue = props[prop];
        (0, $65bea5ced4e8db0c$export$2aea645392b97e0b)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $920f30c3f9a97fc1$export$bf7199a9ebcb84a9(transformer, value);
        });
    }
    return result;
}
function $920f30c3f9a97fc1$var$marginFn(props) {
    return $920f30c3f9a97fc1$var$style(props, $920f30c3f9a97fc1$export$aab52a0dde05ad8a);
}
$920f30c3f9a97fc1$var$marginFn.propTypes = {};
$920f30c3f9a97fc1$var$marginFn.filterProps = $920f30c3f9a97fc1$export$aab52a0dde05ad8a;
const $920f30c3f9a97fc1$export$7ede87f9b603dd3c = $920f30c3f9a97fc1$var$marginFn;
function $920f30c3f9a97fc1$var$paddingFn(props) {
    return $920f30c3f9a97fc1$var$style(props, $920f30c3f9a97fc1$export$f8397d44f03ab6ad);
}
$920f30c3f9a97fc1$var$paddingFn.propTypes = {};
$920f30c3f9a97fc1$var$paddingFn.filterProps = $920f30c3f9a97fc1$export$f8397d44f03ab6ad;
const $920f30c3f9a97fc1$export$6f98e8eaf0be1996 = $920f30c3f9a97fc1$var$paddingFn;
function $920f30c3f9a97fc1$var$spacingFn(props) {
    return $920f30c3f9a97fc1$var$style(props, $920f30c3f9a97fc1$var$spacingKeys);
}
$920f30c3f9a97fc1$var$spacingFn.propTypes = {};
$920f30c3f9a97fc1$var$spacingFn.filterProps = $920f30c3f9a97fc1$var$spacingKeys;
const $920f30c3f9a97fc1$var$spacing = $920f30c3f9a97fc1$var$spacingFn;
var $920f30c3f9a97fc1$export$2e2bcd8739ae039 = $920f30c3f9a97fc1$var$spacing;


function $af9f4e016f149a0b$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $920f30c3f9a97fc1$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $aa28d47c5672f2dd$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



/* eslint-disable import/prefer-default-export */ function $90fcbce91983158d$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}





/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $afbc19516dfcd70a$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $afbc19516dfcd70a$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $afbc19516dfcd70a$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $afbc19516dfcd70a$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $afbc19516dfcd70a$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $afbc19516dfcd70a$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $afbc19516dfcd70a$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $afbc19516dfcd70a$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $252c80b6c05f4be0$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light' } = theme, otherTheme = (0, $8901fc92b5563702$export$71511d61b312f219)(theme, [
        "colorSchemes",
        "components",
        "defaultColorScheme"
    ]);
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $afbc19516dfcd70a$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme } = colorSchemes, otherColorSchemes = (0, $8901fc92b5563702$export$71511d61b312f219)(colorSchemes, [
        defaultColorScheme
    ].map((0, $48eb3f76e7383a7f$export$71511d61b312f219)));
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $afbc19516dfcd70a$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $9450f632817fee8b$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $afbc19516dfcd70a$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $9450f632817fee8b$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = ((_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode) || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootVars);
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $9450f632817fee8b$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, css)
            } : key);
        }
        insertStyleSheet(getSelector(undefined, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootCss)), rootCss);
        const { [colorScheme]: defaultSchemeVal } = colorSchemesMap, other = (0, $8901fc92b5563702$export$71511d61b312f219)(colorSchemesMap, [
            colorScheme
        ].map((0, $48eb3f76e7383a7f$export$71511d61b312f219)));
        if (defaultSchemeVal) {
            var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = (_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                colorScheme: cssColorSheme
            }, css) : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, css);
            insertStyleSheet(getSelector(colorScheme, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, finalCss)), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            var _colorSchemes_key_palette, _colorSchemes_key;
            const cssColorSheme = (_colorSchemes_key = colorSchemes[key]) === null || _colorSchemes_key === void 0 ? void 0 : (_colorSchemes_key_palette = _colorSchemes_key.palette) === null || _colorSchemes_key_palette === void 0 ? void 0 : _colorSchemes_key_palette.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                colorScheme: cssColorSheme
            }, css) : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, css);
            insertStyleSheet(getSelector(key, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, finalCss)), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $252c80b6c05f4be0$export$2e2bcd8739ae039 = $252c80b6c05f4be0$var$prepareCssVars;

function $89dca6f8a71aa789$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}










function $0b7f5301bc34d2af$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $e24c9655957c457a$export$2e2bcd8739ae039)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $0b7f5301bc34d2af$export$2e2bcd8739ae039 = $0b7f5301bc34d2af$var$compose;




function $71402a062aabad75$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $71402a062aabad75$var$createBorderStyle(prop, transform) {
    return (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $71402a062aabad75$export$1edee58a52776cd9 = $71402a062aabad75$var$createBorderStyle('border', $71402a062aabad75$export$34e2febe53ae29cc);
const $71402a062aabad75$export$f9a7b6bd24892946 = $71402a062aabad75$var$createBorderStyle('borderTop', $71402a062aabad75$export$34e2febe53ae29cc);
const $71402a062aabad75$export$5abca33e6be905d2 = $71402a062aabad75$var$createBorderStyle('borderRight', $71402a062aabad75$export$34e2febe53ae29cc);
const $71402a062aabad75$export$e2ce9f12a980a822 = $71402a062aabad75$var$createBorderStyle('borderBottom', $71402a062aabad75$export$34e2febe53ae29cc);
const $71402a062aabad75$export$47658cca1a909427 = $71402a062aabad75$var$createBorderStyle('borderLeft', $71402a062aabad75$export$34e2febe53ae29cc);
const $71402a062aabad75$export$e7fb0694ba2404fc = $71402a062aabad75$var$createBorderStyle('borderColor');
const $71402a062aabad75$export$126a92c968acdb85 = $71402a062aabad75$var$createBorderStyle('borderTopColor');
const $71402a062aabad75$export$85cc51cb8fbb8c0e = $71402a062aabad75$var$createBorderStyle('borderRightColor');
const $71402a062aabad75$export$340b0327727f6d1a = $71402a062aabad75$var$createBorderStyle('borderBottomColor');
const $71402a062aabad75$export$60beef91a985b4bf = $71402a062aabad75$var$createBorderStyle('borderLeftColor');
const $71402a062aabad75$export$f9258c55612cbed7 = $71402a062aabad75$var$createBorderStyle('outline', $71402a062aabad75$export$34e2febe53ae29cc);
const $71402a062aabad75$export$621fe586efeb64b9 = $71402a062aabad75$var$createBorderStyle('outlineColor');
const $71402a062aabad75$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $920f30c3f9a97fc1$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $920f30c3f9a97fc1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $65bea5ced4e8db0c$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$71402a062aabad75$export$7a57f79000377ca2.propTypes = {};
$71402a062aabad75$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $71402a062aabad75$var$borders = (0, $0b7f5301bc34d2af$export$2e2bcd8739ae039)($71402a062aabad75$export$1edee58a52776cd9, $71402a062aabad75$export$f9a7b6bd24892946, $71402a062aabad75$export$5abca33e6be905d2, $71402a062aabad75$export$e2ce9f12a980a822, $71402a062aabad75$export$47658cca1a909427, $71402a062aabad75$export$e7fb0694ba2404fc, $71402a062aabad75$export$126a92c968acdb85, $71402a062aabad75$export$85cc51cb8fbb8c0e, $71402a062aabad75$export$340b0327727f6d1a, $71402a062aabad75$export$60beef91a985b4bf, $71402a062aabad75$export$7a57f79000377ca2, $71402a062aabad75$export$f9258c55612cbed7, $71402a062aabad75$export$621fe586efeb64b9);
var $71402a062aabad75$export$2e2bcd8739ae039 = $71402a062aabad75$var$borders;







const $962eb4bc864c347b$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $920f30c3f9a97fc1$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $920f30c3f9a97fc1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $65bea5ced4e8db0c$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$962eb4bc864c347b$export$5df9adcb0db95e1e.propTypes = {};
$962eb4bc864c347b$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $962eb4bc864c347b$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $920f30c3f9a97fc1$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $920f30c3f9a97fc1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $65bea5ced4e8db0c$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$962eb4bc864c347b$export$ec60d70ff941a580.propTypes = {};
$962eb4bc864c347b$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $962eb4bc864c347b$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $920f30c3f9a97fc1$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $920f30c3f9a97fc1$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $65bea5ced4e8db0c$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$962eb4bc864c347b$export$8a833ffa5f5dbeda.propTypes = {};
$962eb4bc864c347b$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $962eb4bc864c347b$export$baf44164ca3a34e8 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $962eb4bc864c347b$export$8f7213a1cd01e832 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $962eb4bc864c347b$export$b0e0abbc49ba668 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $962eb4bc864c347b$export$bcd8b929d4b4142 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $962eb4bc864c347b$export$e5039a674e14c828 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $962eb4bc864c347b$export$42bd9088661ffb03 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $962eb4bc864c347b$export$920682ae05b999bc = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $962eb4bc864c347b$export$1b88fbdd482fd33a = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $962eb4bc864c347b$export$bdb486e40d52d26f = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $962eb4bc864c347b$var$grid = (0, $0b7f5301bc34d2af$export$2e2bcd8739ae039)($962eb4bc864c347b$export$5df9adcb0db95e1e, $962eb4bc864c347b$export$ec60d70ff941a580, $962eb4bc864c347b$export$8a833ffa5f5dbeda, $962eb4bc864c347b$export$baf44164ca3a34e8, $962eb4bc864c347b$export$8f7213a1cd01e832, $962eb4bc864c347b$export$b0e0abbc49ba668, $962eb4bc864c347b$export$bcd8b929d4b4142, $962eb4bc864c347b$export$e5039a674e14c828, $962eb4bc864c347b$export$42bd9088661ffb03, $962eb4bc864c347b$export$920682ae05b999bc, $962eb4bc864c347b$export$1b88fbdd482fd33a, $962eb4bc864c347b$export$bdb486e40d52d26f);
var $962eb4bc864c347b$export$2e2bcd8739ae039 = $962eb4bc864c347b$var$grid;




function $5d2db900edc087f8$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $5d2db900edc087f8$export$35e9368ef982300f = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $5d2db900edc087f8$export$dbaffd4420ea0ac6
});
const $5d2db900edc087f8$export$2506f56c10355b33 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $5d2db900edc087f8$export$dbaffd4420ea0ac6
});
const $5d2db900edc087f8$export$8c5a050822fd698c = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $5d2db900edc087f8$export$dbaffd4420ea0ac6
});
const $5d2db900edc087f8$var$palette = (0, $0b7f5301bc34d2af$export$2e2bcd8739ae039)($5d2db900edc087f8$export$35e9368ef982300f, $5d2db900edc087f8$export$2506f56c10355b33, $5d2db900edc087f8$export$8c5a050822fd698c);
var $5d2db900edc087f8$export$2e2bcd8739ae039 = $5d2db900edc087f8$var$palette;





const $40f590f79fad8356$var$breakpointsValues = $65bea5ced4e8db0c$export$68c286be0e7e55b7;
function $40f590f79fad8356$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $40f590f79fad8356$export$7e3df82ee760448c = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props_theme_breakpoints_values, _props_theme_breakpoints, _props_theme, _props_theme_breakpoints1, _props_theme1;
            const breakpoint = ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_breakpoints = _props_theme.breakpoints) === null || _props_theme_breakpoints === void 0 ? void 0 : (_props_theme_breakpoints_values = _props_theme_breakpoints.values) === null || _props_theme_breakpoints_values === void 0 ? void 0 : _props_theme_breakpoints_values[propValue]) || $40f590f79fad8356$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $40f590f79fad8356$export$8afece71750ec241(propValue)
            };
            if (((_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : (_props_theme_breakpoints1 = _props_theme1.breakpoints) === null || _props_theme_breakpoints1 === void 0 ? void 0 : _props_theme_breakpoints1.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $65bea5ced4e8db0c$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$40f590f79fad8356$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $40f590f79fad8356$export$ee148fbbe8357dd2 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$ac607276a8fe9f0a = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$dc0d8bd0b94f8570 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$a43cf604e12f3b17 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$ffed9f14fb65e276 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$905076ed6620e671 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $40f590f79fad8356$export$8afece71750ec241
});
const $40f590f79fad8356$export$6ccc93f785106a58 = (0, $162c298b3631ac0e$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $40f590f79fad8356$var$sizing = (0, $0b7f5301bc34d2af$export$2e2bcd8739ae039)($40f590f79fad8356$export$7e3df82ee760448c, $40f590f79fad8356$export$488fda99655ff65a, $40f590f79fad8356$export$ee148fbbe8357dd2, $40f590f79fad8356$export$ac607276a8fe9f0a, $40f590f79fad8356$export$dc0d8bd0b94f8570, $40f590f79fad8356$export$a43cf604e12f3b17, $40f590f79fad8356$export$6ccc93f785106a58);
var $40f590f79fad8356$export$2e2bcd8739ae039 = $40f590f79fad8356$var$sizing;


const $1d606436c1f166ff$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $71402a062aabad75$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $71402a062aabad75$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $71402a062aabad75$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $71402a062aabad75$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $71402a062aabad75$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $71402a062aabad75$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $71402a062aabad75$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $5d2db900edc087f8$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $5d2db900edc087f8$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $5d2db900edc087f8$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $920f30c3f9a97fc1$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $920f30c3f9a97fc1$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $962eb4bc864c347b$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $962eb4bc864c347b$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $962eb4bc864c347b$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $40f590f79fad8356$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $40f590f79fad8356$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $40f590f79fad8356$export$8afece71750ec241)
    },
    height: {
        transform: (0, $40f590f79fad8356$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $40f590f79fad8356$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $40f590f79fad8356$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $1d606436c1f166ff$export$2e2bcd8739ae039 = $1d606436c1f166ff$var$defaultSxConfig;


/* eslint-disable guard-for-in */ const $06ba45f570780ba8$var$EMPTY_THEME = {};
function $06ba45f570780ba8$export$7d53d8bf2911e013() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $06ba45f570780ba8$var$EMPTY_THEME, nested: nested } = props;
        var _theme_unstable_sxConfig;
        const config = (_theme_unstable_sxConfig = theme.unstable_sxConfig) !== null && _theme_unstable_sxConfig !== void 0 ? _theme_unstable_sxConfig : (0, $1d606436c1f166ff$export$2e2bcd8739ae039);
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            var _theme_breakpoints;
            const breakpoints = (_theme_breakpoints = theme.breakpoints) !== null && _theme_breakpoints !== void 0 ? _theme_breakpoints : (0, $65bea5ced4e8db0c$export$666ad80b5007f835);
            const css = (0, $65bea5ced4e8db0c$export$1f2600516e91381f)(breakpoints);
            for(const styleKey in sxObject){
                const value = $06ba45f570780ba8$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $06ba45f570780ba8$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $06ba45f570780ba8$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $65bea5ced4e8db0c$export$c29c12f694bb7a2f)(breakpoints, value)) (0, $65bea5ced4e8db0c$export$2aea645392b97e0b)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $8eb1669f81b5b1e4$export$456f6c1142f990db)(theme, (0, $65bea5ced4e8db0c$export$8922c90b6e020726)(breakpoints, css))
            };
            return (0, $8eb1669f81b5b1e4$export$456f6c1142f990db)(theme, (0, $65bea5ced4e8db0c$export$8922c90b6e020726)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $06ba45f570780ba8$export$2e2bcd8739ae039 = $06ba45f570780ba8$export$7d53d8bf2911e013();
function $06ba45f570780ba8$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $e24c9655957c457a$export$2e2bcd8739ae039)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $162c298b3631ac0e$export$2aa3fd96c49a84a8)(theme, themeKey);
    (0, $65bea5ced4e8db0c$export$2aea645392b97e0b)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $162c298b3631ac0e$export$245e5a5849651da5)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $e24c9655957c457a$export$2e2bcd8739ae039)(css[mediaKey], finalValue);
            else (0, $e24c9655957c457a$export$2e2bcd8739ae039)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $06ba45f570780ba8$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}














const $da98fcbcf5c6cd21$var$shape = {
    borderRadius: 4
};
var $da98fcbcf5c6cd21$export$2e2bcd8739ae039 = $da98fcbcf5c6cd21$var$shape;





/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $9e0e535c6ab11933$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        var _theme_colorSchemes;
        if (!((_theme_colorSchemes = theme.colorSchemes) === null || _theme_colorSchemes === void 0 ? void 0 : _theme_colorSchemes[key]) || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $67f12c31e9ee9daa$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $8901fc92b5563702$export$71511d61b312f219)(options, [
        "breakpoints",
        "palette",
        "spacing",
        "shape"
    ]);
    const breakpoints = (0, $3ec250ca90ab849c$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $af9f4e016f149a0b$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $9450f632817fee8b$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $da98fcbcf5c6cd21$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme = (0, $8eb1669f81b5b1e4$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $9e0e535c6ab11933$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $9450f632817fee8b$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $1d606436c1f166ff$export$2e2bcd8739ae039), other === null || other === void 0 ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $06ba45f570780ba8$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $67f12c31e9ee9daa$export$2e2bcd8739ae039 = $67f12c31e9ee9daa$var$createTheme;





function $95e6900cd5fff718$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}






function $321a94afd28e6be3$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $321a94afd28e6be3$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $321a94afd28e6be3$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $321a94afd28e6be3$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $321a94afd28e6be3$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $321a94afd28e6be3$var$defaultFontFamily ? {
            letterSpacing: `${$321a94afd28e6be3$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $321a94afd28e6be3$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $321a94afd28e6be3$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $9450f632817fee8b$export$2e2bcd8739ae039)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $99e9bac82f8f69c3$var$shadowKeyUmbraOpacity = 0.2;
const $99e9bac82f8f69c3$var$shadowKeyPenumbraOpacity = 0.14;
const $99e9bac82f8f69c3$var$shadowAmbientShadowOpacity = 0.12;
function $99e9bac82f8f69c3$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$99e9bac82f8f69c3$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$99e9bac82f8f69c3$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$99e9bac82f8f69c3$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $99e9bac82f8f69c3$var$shadows = [
    'none',
    $99e9bac82f8f69c3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $99e9bac82f8f69c3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $99e9bac82f8f69c3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $99e9bac82f8f69c3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $99e9bac82f8f69c3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $99e9bac82f8f69c3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $99e9bac82f8f69c3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $99e9bac82f8f69c3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $99e9bac82f8f69c3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $99e9bac82f8f69c3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $99e9bac82f8f69c3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $99e9bac82f8f69c3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $99e9bac82f8f69c3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $99e9bac82f8f69c3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $99e9bac82f8f69c3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $99e9bac82f8f69c3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $99e9bac82f8f69c3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $99e9bac82f8f69c3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $99e9bac82f8f69c3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $99e9bac82f8f69c3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $99e9bac82f8f69c3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $99e9bac82f8f69c3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $99e9bac82f8f69c3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $99e9bac82f8f69c3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $99e9bac82f8f69c3$export$2e2bcd8739ae039 = $99e9bac82f8f69c3$var$shadows;





const $acca3c73dc6f955d$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $acca3c73dc6f955d$var$EMPTY_OPTIONS = {};
const $acca3c73dc6f955d$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $acca3c73dc6f955d$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $acca3c73dc6f955d$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $acca3c73dc6f955d$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $acca3c73dc6f955d$export$2e2bcd8739ae039(inputTransitions) {
    const transitions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, inputTransitions);
    delete transitions.reducedMotion;
    const mergedEasing = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $acca3c73dc6f955d$export$24c5ac7c37452e7d, transitions.easing);
    const mergedDuration = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $acca3c73dc6f955d$export$1f34108aa9eb96ab, transitions.duration);
    const createTransitionValue = (props = $acca3c73dc6f955d$var$DEFAULT_TRANSITION_PROPS, options = $acca3c73dc6f955d$var$EMPTY_OPTIONS)=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $8901fc92b5563702$export$71511d61b312f219)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $acca3c73dc6f955d$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $acca3c73dc6f955d$var$formatMs(delay)}`).join(',');
    };
    var _transitions_create;
    const create = (_transitions_create = transitions.create) !== null && _transitions_create !== void 0 ? _transitions_create : createTransitionValue;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        getAutoHeightDuration: $acca3c73dc6f955d$var$getAutoHeightDuration,
        create: create
    }, transitions), {
        easing: mergedEasing,
        duration: mergedDuration
    });
}



const $a4f7e11c39c90411$var$EMPTY_MOTION = {};
function $a4f7e11c39c90411$export$2e2bcd8739ae039(inputMotion = $a4f7e11c39c90411$var$EMPTY_MOTION) {
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        reducedMotion: 'never'
    }, inputMotion);
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $c98462cfa9d5d69d$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $c98462cfa9d5d69d$export$2e2bcd8739ae039 = $c98462cfa9d5d69d$var$zIndex;


/* eslint-disable import/prefer-default-export */ 

function $7795c6a5cb9191ed$var$isSerializable(val) {
    return (0, $9450f632817fee8b$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $7795c6a5cb9191ed$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, baseTheme);
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$7795c6a5cb9191ed$var$isSerializable(value) || key.startsWith('unstable_') || key.startsWith('internal_')) delete object[key];
            else if ((0, $9450f632817fee8b$export$53b83ca8eaab0383)(value)) {
                object[key] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, value);
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.motion = { reducedMotion: 'never', ...theme.motion };
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $6136a22abe3b6b48$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $6136a22abe3b6b48$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $6136a22abe3b6b48$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $989ea3f9d8f44081$export$58f0f39f63f3cf42)(color, $6136a22abe3b6b48$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$6136a22abe3b6b48$var$coefficientToPercentage(coefficient)})`;
            return (0, $989ea3f9d8f44081$export$c0816ed86df316af)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$6136a22abe3b6b48$var$coefficientToPercentage(coefficient)})`;
            return (0, $989ea3f9d8f44081$export$4b073707ff63303)(color, coefficient);
        }
    });
}
function $6136a22abe3b6b48$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, motion: motionInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace } = options, other = (0, $8901fc92b5563702$export$71511d61b312f219)(options, [
        "breakpoints",
        "mixins",
        "spacing",
        "palette",
        "motion",
        "transitions",
        "typography",
        "shape",
        "colorSpace"
    ]);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(22));
    const palette = (0, $7a7e36d4dd7a79ff$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, paletteInput), {
        colorSpace: colorSpace
    }));
    const systemTheme = (0, $67f12c31e9ee9daa$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $9450f632817fee8b$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $95e6900cd5fff718$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $99e9bac82f8f69c3$export$2e2bcd8739ae039).slice(),
        typography: (0, $321a94afd28e6be3$export$2e2bcd8739ae039)(palette, typographyInput),
        motion: (0, $a4f7e11c39c90411$export$2e2bcd8739ae039)(motionInput),
        transitions: (0, $acca3c73dc6f955d$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $c98462cfa9d5d69d$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $9450f632817fee8b$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $9450f632817fee8b$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    // `reducedMotion` is owned by `theme.motion`; remove stale values preserved by systemCreateTheme.
    delete muiTheme.transitions.reducedMotion;
    var component;
    muiTheme.unstable_sxConfig = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $1d606436c1f166ff$export$2e2bcd8739ae039), other === null || other === void 0 ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $06ba45f570780ba8$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $7795c6a5cb9191ed$export$32c2afa5f91892aa); // for Pigment CSS integration
    $6136a22abe3b6b48$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $6136a22abe3b6b48$export$2e2bcd8739ae039 = $6136a22abe3b6b48$var$createThemeNoVars;






// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $7076a1421ccbd150$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $6823fba60f54794d$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $7076a1421ccbd150$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $6823fba60f54794d$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $6823fba60f54794d$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $6823fba60f54794d$var$defaultDarkOverlays : [];
}
function $6823fba60f54794d$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace } = options, other = (0, $8901fc92b5563702$export$71511d61b312f219)(options, [
        "palette",
        "opacity",
        "overlays",
        "colorSpace"
    ]);
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $7a7e36d4dd7a79ff$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, paletteInput), {
        colorSpace: colorSpace
    }));
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        palette: palette,
        opacity: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6823fba60f54794d$export$c85e0347fceb69ba(palette.mode), opacity),
        overlays: overlays || $6823fba60f54794d$export$dd191566510330d3(palette.mode)
    }, other);
}


function $accd25a6a2d63f14$export$2e2bcd8739ae039(keys) {
    var _keys_;
    return keys[0] === 'motion' || !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!((_keys_ = keys[1]) === null || _keys_ === void 0 ? void 0 : _keys_.match(/(mode|contrastThreshold|tonalOffset)/));
}



/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $68982d3367186178$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $68982d3367186178$export$2e2bcd8739ae039 = $68982d3367186178$var$excludeVariablesFromRoot;


var $c0890ad98037d188$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $68982d3367186178$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, css, excludedVariables)
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };




function $e391deed36504c79$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $e391deed36504c79$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $e391deed36504c79$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $989ea3f9d8f44081$export$29fb7152bd3f781a)(color);
}
function $e391deed36504c79$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $989ea3f9d8f44081$export$427365fc3db6fc5e)($e391deed36504c79$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $e391deed36504c79$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $e391deed36504c79$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $e391deed36504c79$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $aa28d47c5672f2dd$export$2e2bcd8739ae039)(cssVarPrefix);
function $e391deed36504c79$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $6823fba60f54794d$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scheme), {
            palette: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                mode: mode
            }, scheme === null || scheme === void 0 ? void 0 : scheme.palette),
            colorSpace: colorSpace
        }));
        return undefined;
    }
    const _createThemeNoVars = (0, $6136a22abe3b6b48$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restTheme), {
        palette: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            mode: mode
        }, scheme === null || scheme === void 0 ? void 0 : scheme.palette),
        colorSpace: colorSpace
    })), { palette: palette } = _createThemeNoVars, muiTheme = (0, $8901fc92b5563702$export$71511d61b312f219)(_createThemeNoVars, [
        "palette"
    ]);
    colorSchemes[colorScheme] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scheme), {
        palette: palette,
        opacity: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $6823fba60f54794d$export$c85e0347fceb69ba)(mode), scheme === null || scheme === void 0 ? void 0 : scheme.opacity),
        overlays: (scheme === null || scheme === void 0 ? void 0 : scheme.overlays) || (0, $6823fba60f54794d$export$dd191566510330d3)(mode)
    });
    return muiTheme;
}
function $e391deed36504c79$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $accd25a6a2d63f14$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root' } = options, input = (0, $8901fc92b5563702$export$71511d61b312f219)(options, [
        "colorSchemes",
        "defaultColorScheme",
        "disableCssColorScheme",
        "cssVarPrefix",
        "nativeColor",
        "shouldSkipGeneratingVar",
        "colorSchemeSelector",
        "rootSelector"
    ]);
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $e391deed36504c79$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark } = colorSchemesInput, customColorSchemes = (0, $8901fc92b5563702$export$71511d61b312f219)(colorSchemesInput, [
        defaultColorScheme,
        "light",
        "dark"
    ].map((0, $48eb3f76e7383a7f$export$71511d61b312f219)));
    const colorSchemes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, customColorSchemes);
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $e391deed36504c79$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $e391deed36504c79$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $e391deed36504c79$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        defaultColorScheme: defaultColorScheme
    }, muiTheme), {
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $89dca6f8a71aa789$export$2e2bcd8739ae039)(muiTheme.typography), muiTheme.font),
        spacing: $e391deed36504c79$var$getSpacingVal(input.spacing)
    });
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $e391deed36504c79$var$setColor(palette.common, 'background', '#fff');
            $e391deed36504c79$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $e391deed36504c79$var$setColor(palette.common, 'background', '#000');
            $e391deed36504c79$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $989ea3f9d8f44081$export$34109543fc7f43f8)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $989ea3f9d8f44081$export$eaaef2dca3e9e512)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $989ea3f9d8f44081$export$aeeda94ef1d01275)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $e391deed36504c79$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $e391deed36504c79$var$setColor(palette.Alert, 'errorColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'successColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.error.main)));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.info.main)));
            $e391deed36504c79$var$setColor(palette.Alert, 'successFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.success.main)));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $e391deed36504c79$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $e391deed36504c79$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $e391deed36504c79$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $e391deed36504c79$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $e391deed36504c79$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $e391deed36504c79$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $e391deed36504c79$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $e391deed36504c79$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $e391deed36504c79$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $e391deed36504c79$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $989ea3f9d8f44081$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $e391deed36504c79$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Slider, 'successTrack', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $989ea3f9d8f44081$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $e391deed36504c79$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $e391deed36504c79$var$setColor(palette.SnackbarContent, 'color', $e391deed36504c79$var$silent(()=>colorSpace ? (0, $7a7e36d4dd7a79ff$export$55ce6f3a06c59543).text.primary : palette.getContrastText(snackbarContentBackground)));
            $e391deed36504c79$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $989ea3f9d8f44081$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $e391deed36504c79$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $e391deed36504c79$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $e391deed36504c79$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $e391deed36504c79$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $e391deed36504c79$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $e391deed36504c79$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $e391deed36504c79$var$setColor(palette.TableCell, 'border', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), (0, $989ea3f9d8f44081$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $e391deed36504c79$var$setColor(palette.Tooltip, 'bg', colorMix((0, $989ea3f9d8f44081$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $e391deed36504c79$var$setColor(palette.Alert, 'errorColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'successColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningColor', colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $e391deed36504c79$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $e391deed36504c79$var$setColor(palette.Alert, 'successFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningFilledColor', $e391deed36504c79$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $e391deed36504c79$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $e391deed36504c79$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $e391deed36504c79$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $e391deed36504c79$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $e391deed36504c79$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $e391deed36504c79$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $e391deed36504c79$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $e391deed36504c79$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $e391deed36504c79$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $e391deed36504c79$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $e391deed36504c79$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $e391deed36504c79$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $e391deed36504c79$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $e391deed36504c79$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $e391deed36504c79$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $e391deed36504c79$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $989ea3f9d8f44081$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $e391deed36504c79$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $e391deed36504c79$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $e391deed36504c79$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $e391deed36504c79$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $e391deed36504c79$var$setColor(palette.Slider, 'successTrack', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $e391deed36504c79$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $989ea3f9d8f44081$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $989ea3f9d8f44081$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $e391deed36504c79$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $e391deed36504c79$var$setColor(palette.SnackbarContent, 'color', $e391deed36504c79$var$silent(()=>colorSpace ? (0, $7a7e36d4dd7a79ff$export$a43af521ac8c3202).text.primary : palette.getContrastText(snackbarContentBackground)));
            $e391deed36504c79$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $989ea3f9d8f44081$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $e391deed36504c79$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $e391deed36504c79$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $e391deed36504c79$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $e391deed36504c79$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $e391deed36504c79$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $e391deed36504c79$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $e391deed36504c79$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $e391deed36504c79$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $e391deed36504c79$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $e391deed36504c79$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $e391deed36504c79$var$setColor(palette.TableCell, 'border', colorMix((0, $989ea3f9d8f44081$export$eaaef2dca3e9e512), (0, $989ea3f9d8f44081$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $e391deed36504c79$var$setColor(palette.Tooltip, 'bg', colorMix((0, $989ea3f9d8f44081$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (!nativeColor) {
            $e391deed36504c79$var$setColorChannel(palette.background, 'default');
            // added for consistency with the `background.default` token
            $e391deed36504c79$var$setColorChannel(palette.background, 'paper');
            $e391deed36504c79$var$setColorChannel(palette.common, 'background');
            $e391deed36504c79$var$setColorChannel(palette.common, 'onBackground');
            $e391deed36504c79$var$setColorChannel(palette, 'divider');
        }
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && !nativeColor && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $e391deed36504c79$var$setColor(palette[color], 'mainChannel', (0, $989ea3f9d8f44081$export$427365fc3db6fc5e)($e391deed36504c79$var$toRgb(colors.main)));
                if (colors.light) $e391deed36504c79$var$setColor(palette[color], 'lightChannel', (0, $989ea3f9d8f44081$export$427365fc3db6fc5e)($e391deed36504c79$var$toRgb(colors.light)));
                if (colors.dark) $e391deed36504c79$var$setColor(palette[color], 'darkChannel', (0, $989ea3f9d8f44081$export$427365fc3db6fc5e)($e391deed36504c79$var$toRgb(colors.dark)));
                if (colors.contrastText) $e391deed36504c79$var$setColor(palette[color], 'contrastTextChannel', (0, $989ea3f9d8f44081$export$427365fc3db6fc5e)($e391deed36504c79$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $e391deed36504c79$var$setColorChannel(palette[color], 'primary');
                    $e391deed36504c79$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $e391deed36504c79$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $e391deed36504c79$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $9450f632817fee8b$export$2e2bcd8739ae039)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $c0890ad98037d188$export$2e2bcd8739ae039)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $252c80b6c05f4be0$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $af9f4e016f149a0b$export$2e2bcd8739ae039)(input.spacing, (0, $920f30c3f9a97fc1$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $90fcbce91983158d$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $1d606436c1f166ff$export$2e2bcd8739ae039), input === null || input === void 0 ? void 0 : input.unstable_sxConfig);
    theme.unstable_sx = function sx(props) {
        return (0, $06ba45f570780ba8$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.internal_cache = {};
    theme.toRuntimeSource = (0, $7795c6a5cb9191ed$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $1626f90a7ddd654a$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, colorScheme !== true && colorScheme), {
        palette: (0, $7a7e36d4dd7a79ff$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, colorScheme === true ? {} : colorScheme.palette), {
            mode: scheme
        })) // cast type to skip module augmentation test
    });
}
function $1626f90a7ddd654a$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette === null || palette === void 0 ? void 0 : palette.mode } = options, other = (0, $8901fc92b5563702$export$71511d61b312f219)(options, [
        "palette",
        "cssVariables",
        "colorSchemes",
        "defaultColorScheme"
    ]);
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes === null || initialColorSchemes === void 0 ? void 0 : initialColorSchemes[defaultColorSchemeInput];
    const colorSchemesInput = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialColorSchemes, palette ? {
        [defaultColorSchemeInput]: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, typeof defaultScheme !== 'boolean' && defaultScheme), {
            palette: palette
        })
    } : undefined);
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $6136a22abe3b6b48$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $6136a22abe3b6b48$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            palette: paletteOptions
        }), ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, colorSchemesInput.light !== true && colorSchemesInput.light), {
                palette: theme.palette
            });
            $1626f90a7ddd654a$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, colorSchemesInput.dark !== true && colorSchemesInput.dark), {
                palette: theme.palette
            });
            $1626f90a7ddd654a$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $e391deed36504c79$export$2e2bcd8739ae039)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, other), {
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput
    }), typeof cssVariables !== 'boolean' && cssVariables), ...args);
}



var $7fPBF = parcelRequire("7fPBF");
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $432f2af859c96d26$export$2335f513bbd82c6d = Math.abs;
var $432f2af859c96d26$export$6788812c4e6611e6 = String.fromCharCode;
var $432f2af859c96d26$export$e6e34fd1f2686227 = Object.assign;
function $432f2af859c96d26$export$d6af199866bfb566(value, length) {
    return $432f2af859c96d26$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 0)) << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 1)) << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 2)) << 2 ^ $432f2af859c96d26$export$a9db5e087081082d(value, 3) : 0;
}
function $432f2af859c96d26$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $432f2af859c96d26$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $432f2af859c96d26$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $432f2af859c96d26$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $432f2af859c96d26$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $432f2af859c96d26$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $432f2af859c96d26$export$36776f635604f274(value) {
    return value.length;
}
function $432f2af859c96d26$export$f9084667e487ed46(value) {
    return value.length;
}
function $432f2af859c96d26$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $432f2af859c96d26$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $21718d5ff5bac791$export$53f1d5ea8de3d7c = 1;
var $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1;
var $21718d5ff5bac791$export$f24224f1c91d8156 = 0;
var $21718d5ff5bac791$export$5880b8b5730aff45 = 0;
var $21718d5ff5bac791$export$c0306caf338ac095 = 0;
var $21718d5ff5bac791$export$30a86d91af8ff6e6 = '';
function $21718d5ff5bac791$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $21718d5ff5bac791$export$53f1d5ea8de3d7c,
        column: $21718d5ff5bac791$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $21718d5ff5bac791$export$784d13d8ee351f07(root, props) {
    return (0, $432f2af859c96d26$export$e6e34fd1f2686227)($21718d5ff5bac791$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $21718d5ff5bac791$export$eba6f6f03b0a92e7() {
    return $21718d5ff5bac791$export$c0306caf338ac095;
}
function $21718d5ff5bac791$export$232faf9add678146() {
    $21718d5ff5bac791$export$c0306caf338ac095 = $21718d5ff5bac791$export$5880b8b5730aff45 > 0 ? (0, $432f2af859c96d26$export$a9db5e087081082d)($21718d5ff5bac791$export$30a86d91af8ff6e6, --$21718d5ff5bac791$export$5880b8b5730aff45) : 0;
    if ($21718d5ff5bac791$export$4e0c71f277ca26b3--, $21718d5ff5bac791$export$c0306caf338ac095 === 10) $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1, $21718d5ff5bac791$export$53f1d5ea8de3d7c--;
    return $21718d5ff5bac791$export$c0306caf338ac095;
}
function $21718d5ff5bac791$export$48cfd1e771a65c4f() {
    $21718d5ff5bac791$export$c0306caf338ac095 = $21718d5ff5bac791$export$5880b8b5730aff45 < $21718d5ff5bac791$export$f24224f1c91d8156 ? (0, $432f2af859c96d26$export$a9db5e087081082d)($21718d5ff5bac791$export$30a86d91af8ff6e6, $21718d5ff5bac791$export$5880b8b5730aff45++) : 0;
    if ($21718d5ff5bac791$export$4e0c71f277ca26b3++, $21718d5ff5bac791$export$c0306caf338ac095 === 10) $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1, $21718d5ff5bac791$export$53f1d5ea8de3d7c++;
    return $21718d5ff5bac791$export$c0306caf338ac095;
}
function $21718d5ff5bac791$export$4d3fb11e950abb9e() {
    return (0, $432f2af859c96d26$export$a9db5e087081082d)($21718d5ff5bac791$export$30a86d91af8ff6e6, $21718d5ff5bac791$export$5880b8b5730aff45);
}
function $21718d5ff5bac791$export$e88cb2efb12ae807() {
    return $21718d5ff5bac791$export$5880b8b5730aff45;
}
function $21718d5ff5bac791$export$58adb3bec8346d0f(begin, end) {
    return (0, $432f2af859c96d26$export$2f35ab04d2335697)($21718d5ff5bac791$export$30a86d91af8ff6e6, begin, end);
}
function $21718d5ff5bac791$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $21718d5ff5bac791$export$2de70f21292aac9e(value) {
    return $21718d5ff5bac791$export$53f1d5ea8de3d7c = $21718d5ff5bac791$export$4e0c71f277ca26b3 = 1, $21718d5ff5bac791$export$f24224f1c91d8156 = (0, $432f2af859c96d26$export$36776f635604f274)($21718d5ff5bac791$export$30a86d91af8ff6e6 = value), $21718d5ff5bac791$export$5880b8b5730aff45 = 0, [];
}
function $21718d5ff5bac791$export$45918ac1574455b1(value) {
    return $21718d5ff5bac791$export$30a86d91af8ff6e6 = '', value;
}
function $21718d5ff5bac791$export$410ac95b9ec204b8(type) {
    return (0, $432f2af859c96d26$export$87c2784dc9fc4ab)($21718d5ff5bac791$export$58adb3bec8346d0f($21718d5ff5bac791$export$5880b8b5730aff45 - 1, $21718d5ff5bac791$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $21718d5ff5bac791$export$660b2ee2d4fb4eff(value) {
    return $21718d5ff5bac791$export$45918ac1574455b1($21718d5ff5bac791$export$5f8c09e3ae6f64e1($21718d5ff5bac791$export$2de70f21292aac9e(value)));
}
function $21718d5ff5bac791$export$7af1228ff777d175(type) {
    while($21718d5ff5bac791$export$c0306caf338ac095 = $21718d5ff5bac791$export$4d3fb11e950abb9e())if ($21718d5ff5bac791$export$c0306caf338ac095 < 33) $21718d5ff5bac791$export$48cfd1e771a65c4f();
    else break;
    return $21718d5ff5bac791$export$9e1725a4cfeada27(type) > 2 || $21718d5ff5bac791$export$9e1725a4cfeada27($21718d5ff5bac791$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $21718d5ff5bac791$export$5f8c09e3ae6f64e1(children) {
    while($21718d5ff5bac791$export$48cfd1e771a65c4f())switch($21718d5ff5bac791$export$9e1725a4cfeada27($21718d5ff5bac791$export$c0306caf338ac095)){
        case 0:
            (0, $432f2af859c96d26$export$10d8903dec122b9d)($21718d5ff5bac791$export$c2ab62c7bf24634($21718d5ff5bac791$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $432f2af859c96d26$export$10d8903dec122b9d)($21718d5ff5bac791$export$410ac95b9ec204b8($21718d5ff5bac791$export$c0306caf338ac095), children);
            break;
        default:
            (0, $432f2af859c96d26$export$10d8903dec122b9d)((0, $432f2af859c96d26$export$6788812c4e6611e6)($21718d5ff5bac791$export$c0306caf338ac095), children);
    }
    return children;
}
function $21718d5ff5bac791$export$955ba06d119e085e(index, count) {
    while(--count && $21718d5ff5bac791$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($21718d5ff5bac791$export$c0306caf338ac095 < 48 || $21718d5ff5bac791$export$c0306caf338ac095 > 102 || $21718d5ff5bac791$export$c0306caf338ac095 > 57 && $21718d5ff5bac791$export$c0306caf338ac095 < 65 || $21718d5ff5bac791$export$c0306caf338ac095 > 70 && $21718d5ff5bac791$export$c0306caf338ac095 < 97) break;
    return $21718d5ff5bac791$export$58adb3bec8346d0f(index, $21718d5ff5bac791$export$e88cb2efb12ae807() + (count < 6 && $21718d5ff5bac791$export$4d3fb11e950abb9e() == 32 && $21718d5ff5bac791$export$48cfd1e771a65c4f() == 32));
}
function $21718d5ff5bac791$export$c889f2fcc19dbf12(type) {
    while($21718d5ff5bac791$export$48cfd1e771a65c4f())switch($21718d5ff5bac791$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $21718d5ff5bac791$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $21718d5ff5bac791$export$c889f2fcc19dbf12($21718d5ff5bac791$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $21718d5ff5bac791$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $21718d5ff5bac791$export$48cfd1e771a65c4f();
            break;
    }
    return $21718d5ff5bac791$export$5880b8b5730aff45;
}
function $21718d5ff5bac791$export$4254d4e2b3745c4c(type, index) {
    while($21718d5ff5bac791$export$48cfd1e771a65c4f())// //
    if (type + $21718d5ff5bac791$export$c0306caf338ac095 === 57) break;
    else if (type + $21718d5ff5bac791$export$c0306caf338ac095 === 84 && $21718d5ff5bac791$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $21718d5ff5bac791$export$58adb3bec8346d0f(index, $21718d5ff5bac791$export$5880b8b5730aff45 - 1) + '*' + (0, $432f2af859c96d26$export$6788812c4e6611e6)(type === 47 ? type : $21718d5ff5bac791$export$48cfd1e771a65c4f());
}
function $21718d5ff5bac791$export$c2ab62c7bf24634(index) {
    while(!$21718d5ff5bac791$export$9e1725a4cfeada27($21718d5ff5bac791$export$4d3fb11e950abb9e()))$21718d5ff5bac791$export$48cfd1e771a65c4f();
    return $21718d5ff5bac791$export$58adb3bec8346d0f(index, $21718d5ff5bac791$export$5880b8b5730aff45);
}

var $abfe92eb9b93f71b$export$71ad59f2e432cfe8 = '-ms-';
var $abfe92eb9b93f71b$export$2c0f367103c8d01c = '-moz-';
var $abfe92eb9b93f71b$export$39dfd62a25e0fe93 = '-webkit-';
var $abfe92eb9b93f71b$export$a29989082612d0d9 = 'comm';
var $abfe92eb9b93f71b$export$aa3a2e812ca8570d = 'rule';
var $abfe92eb9b93f71b$export$527d108ccf083c2b = 'decl';
var $abfe92eb9b93f71b$export$d3d35020fa5b54f0 = '@page';
var $abfe92eb9b93f71b$export$500415a86c544f73 = '@media';
var $abfe92eb9b93f71b$export$a763edbf796b780a = '@import';
var $abfe92eb9b93f71b$export$2790aeb8b4e5c826 = '@charset';
var $abfe92eb9b93f71b$export$1cc683e23b84b133 = '@viewport';
var $abfe92eb9b93f71b$export$9447a5efea57e862 = '@supports';
var $abfe92eb9b93f71b$export$ef011b4e114b1fba = '@document';
var $abfe92eb9b93f71b$export$6aad947bda0f3f46 = '@namespace';
var $abfe92eb9b93f71b$export$b44a8529a35fcb60 = '@keyframes';
var $abfe92eb9b93f71b$export$2c16de31893252e6 = '@font-face';
var $abfe92eb9b93f71b$export$3d846dd52e150c6f = '@counter-style';
var $abfe92eb9b93f71b$export$22314bfbb57653fe = '@font-feature-values';
var $abfe92eb9b93f71b$export$d773506282b3cfe6 = '@layer';




function $87a6462d2c280dc4$export$ef7acd7185315e22(value) {
    return (0, $21718d5ff5bac791$export$45918ac1574455b1)($87a6462d2c280dc4$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $21718d5ff5bac791$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $87a6462d2c280dc4$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $21718d5ff5bac791$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $432f2af859c96d26$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $432f2af859c96d26$export$f8e21b1e77979a08)(characters += (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $21718d5ff5bac791$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $21718d5ff5bac791$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $21718d5ff5bac791$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $21718d5ff5bac791$export$955ba06d119e085e)((0, $21718d5ff5bac791$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $21718d5ff5bac791$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $432f2af859c96d26$export$10d8903dec122b9d)($87a6462d2c280dc4$export$4a34f930e789283c((0, $21718d5ff5bac791$export$4254d4e2b3745c4c)((0, $21718d5ff5bac791$export$48cfd1e771a65c4f)(), (0, $21718d5ff5bac791$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $432f2af859c96d26$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $432f2af859c96d26$export$36776f635604f274)(characters) - length) (0, $432f2af859c96d26$export$10d8903dec122b9d)(property > 32 ? $87a6462d2c280dc4$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $87a6462d2c280dc4$export$f8483753829ec8f3((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $432f2af859c96d26$export$10d8903dec122b9d)(reference = $87a6462d2c280dc4$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $87a6462d2c280dc4$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $432f2af859c96d26$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $87a6462d2c280dc4$export$98e6a39c04603d36(value, reference, reference, rule && (0, $432f2af859c96d26$export$10d8903dec122b9d)($87a6462d2c280dc4$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $87a6462d2c280dc4$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $432f2af859c96d26$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $21718d5ff5bac791$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $432f2af859c96d26$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $432f2af859c96d26$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $21718d5ff5bac791$export$4d3fb11e950abb9e)() === 45) characters += (0, $21718d5ff5bac791$export$410ac95b9ec204b8)((0, $21718d5ff5bac791$export$48cfd1e771a65c4f)());
                    atrule = (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)(), offset = length = (0, $432f2af859c96d26$export$36776f635604f274)(type = characters += (0, $21718d5ff5bac791$export$c2ab62c7bf24634)((0, $21718d5ff5bac791$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $432f2af859c96d26$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $87a6462d2c280dc4$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $432f2af859c96d26$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, post + 1, post = (0, $432f2af859c96d26$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $432f2af859c96d26$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $21718d5ff5bac791$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $87a6462d2c280dc4$export$4a34f930e789283c(value, root, parent) {
    return (0, $21718d5ff5bac791$export$35059013cd4a06db)(value, root, parent, (0, $abfe92eb9b93f71b$export$a29989082612d0d9), (0, $432f2af859c96d26$export$6788812c4e6611e6)((0, $21718d5ff5bac791$export$eba6f6f03b0a92e7)()), (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $87a6462d2c280dc4$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $21718d5ff5bac791$export$35059013cd4a06db)(value, root, parent, (0, $abfe92eb9b93f71b$export$527d108ccf083c2b), (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, 0, length), (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $e7d905dd9193eed6$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $432f2af859c96d26$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $e7d905dd9193eed6$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $abfe92eb9b93f71b$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $abfe92eb9b93f71b$export$a763edbf796b780a:
        case 0, $abfe92eb9b93f71b$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $abfe92eb9b93f71b$export$a29989082612d0d9:
            return '';
        case 0, $abfe92eb9b93f71b$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $e7d905dd9193eed6$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $432f2af859c96d26$export$36776f635604f274)(children = $e7d905dd9193eed6$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $5e2ab9a11893b73e$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $432f2af859c96d26$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $432f2af859c96d26$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(children, 'span') ? (0, $432f2af859c96d26$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $432f2af859c96d26$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $432f2af859c96d26$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $432f2af859c96d26$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value, 'stretch') ? $5e2ab9a11893b73e$export$82e9f45cca5ba907((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, (0, $432f2af859c96d26$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $9143b2e387a5a657$export$5a7767152ae0305f(collection) {
    var length = (0, $432f2af859c96d26$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $9143b2e387a5a657$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $9143b2e387a5a657$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $abfe92eb9b93f71b$export$527d108ccf083c2b:
                element.return = (0, $5e2ab9a11893b73e$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $abfe92eb9b93f71b$export$b44a8529a35fcb60:
                return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                    (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                        value: (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $432f2af859c96d26$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $9143b2e387a5a657$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $432f2af859c96d26$export$1be1fc439b849fdf)((0, $21718d5ff5bac791$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $432f2af859c96d26$export$2f35ab04d2335697)(value, 1, (0, $432f2af859c96d26$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $432f2af859c96d26$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $432f2af859c96d26$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $432f2af859c96d26$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $21718d5ff5bac791$export$9e1725a4cfeada27)(character)) break;
        (0, $21718d5ff5bac791$export$48cfd1e771a65c4f)();
    }
    return (0, $21718d5ff5bac791$export$58adb3bec8346d0f)(begin, (0, $21718d5ff5bac791$export$5880b8b5730aff45));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $21718d5ff5bac791$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $21718d5ff5bac791$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $21718d5ff5bac791$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $21718d5ff5bac791$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $432f2af859c96d26$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $21718d5ff5bac791$export$48cfd1e771a65c4f)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $21718d5ff5bac791$export$45918ac1574455b1)($0bb108cf9f15301b$var$toRules((0, $21718d5ff5bac791$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $432f2af859c96d26$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-' + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $432f2af859c96d26$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value, 'stretch') ? $0bb108cf9f15301b$var$prefix((0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, (0, $432f2af859c96d26$export$36776f635604f274)(value) - 3 - (~(0, $432f2af859c96d26$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + ((0, $432f2af859c96d26$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $432f2af859c96d26$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + value + (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $abfe92eb9b93f71b$export$527d108ccf083c2b:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $abfe92eb9b93f71b$export$b44a8529a35fcb60:
                return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                    (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                        value: (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $abfe92eb9b93f71b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $432f2af859c96d26$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $432f2af859c96d26$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)([
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $abfe92eb9b93f71b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $21718d5ff5bac791$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $432f2af859c96d26$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $abfe92eb9b93f71b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $e7d905dd9193eed6$export$fac44ee5b035f737),
        (0, $9143b2e387a5a657$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $9143b2e387a5a657$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $e7d905dd9193eed6$export$dfdc1655ccc5b9cb)((0, $87a6462d2c280dc4$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $3104ec53a35158ff$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}



var $63fc9407ef8fcdfe$exports = {};
'use strict';
var $a0e803d22f8be2af$exports = {};
'use strict';

$a0e803d22f8be2af$exports = (parcelRequire("3oWWu"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$a0e803d22f8be2af$exports.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$a0e803d22f8be2af$exports.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($a0e803d22f8be2af$exports.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$63fc9407ef8fcdfe$exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c80ca66c64e3fad5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(targetComponent, sourceComponent);
};


var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1529d79d9aa6f066$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $b2729db54ba7ee9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b2729db54ba7ee9b$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $b2729db54ba7ee9b$export$db21c7ffa21794e7 = $b2729db54ba7ee9b$var$useInsertionEffect || $b2729db54ba7ee9b$var$syncFallback;
var $b2729db54ba7ee9b$export$811a713a7276cb9d = $b2729db54ba7ee9b$var$useInsertionEffect || $7fPBF.useLayoutEffect;


var $d62c6f18f523e962$export$23f2a1d2818174ef = false;
var $d62c6f18f523e962$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $d62c6f18f523e962$export$e7094788287c5e9b = $d62c6f18f523e962$var$EmotionCacheContext.Provider;
var $d62c6f18f523e962$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($d62c6f18f523e962$var$EmotionCacheContext);
};
var $d62c6f18f523e962$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($d62c6f18f523e962$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $d62c6f18f523e962$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $d62c6f18f523e962$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7);
};
var $d62c6f18f523e962$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $d62c6f18f523e962$var$createCacheWithTheme = /* #__PURE__ */ (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fef3d59b736200bc$export$2e2bcd8739ae039)(function(theme) {
        return $d62c6f18f523e962$var$getTheme(outerTheme, theme);
    });
});
var $d62c6f18f523e962$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d62c6f18f523e962$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($d62c6f18f523e962$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d62c6f18f523e962$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $c80ca66c64e3fad5$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $d62c6f18f523e962$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d62c6f18f523e962$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $d62c6f18f523e962$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($d62c6f18f523e962$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$d62c6f18f523e962$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $d62c6f18f523e962$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $d62c6f18f523e962$var$Emotion = /* #__PURE__ */ $d62c6f18f523e962$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d62c6f18f523e962$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(registeredStyles, undefined, $7fPBF.useContext($d62c6f18f523e962$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($d62c6f18f523e962$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $d62c6f18f523e962$var$typePropName && !$d62c6f18f523e962$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d62c6f18f523e962$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $d62c6f18f523e962$export$a9c23c6ac3fc3eca = $d62c6f18f523e962$var$Emotion;



var $7fPBF = parcelRequire("7fPBF");








var $84f3fdd51733d70b$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $d62c6f18f523e962$export$dda1d9f60106f0e9).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $d62c6f18f523e962$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $d62c6f18f523e962$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($84f3fdd51733d70b$export$c8a8987d4410bf2d || ($84f3fdd51733d70b$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84f3fdd51733d70b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $d62c6f18f523e962$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)([
        styles
    ], undefined, $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $b2729db54ba7ee9b$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $b2729db54ba7ee9b$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84f3fdd51733d70b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args);
}
function $84f3fdd51733d70b$export$d25ddfdf17c3ad3e() {
    var insertable = $84f3fdd51733d70b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $84f3fdd51733d70b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $84f3fdd51733d70b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84f3fdd51733d70b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $84f3fdd51733d70b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $d62c6f18f523e962$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $d62c6f18f523e962$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $d62c6f18f523e962$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84f3fdd51733d70b$var$merge(cache.registered, css, $84f3fdd51733d70b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($84f3fdd51733d70b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});



let $8951886a6b49e92a$var$_ = (t)=>t, $8951886a6b49e92a$var$t, $8951886a6b49e92a$var$t1, $8951886a6b49e92a$var$t2;
const $8951886a6b49e92a$export$35e9368ef982300f = {
    // Backgrounds — dark mode
    bg_dark: '#041829',
    bg_light: '#FAFAFA',
    dark_text: '#EEEEEE',
    // Light mode surfaces
    surface_page: '#F5F4F8',
    surface_subtle: '#EEEDF3',
    primary_intense: '#051321',
    primary_dark: '#0A2E45',
    primary: '#12557A',
    primary_medium_light: '#E3EDF4',
    primary_medium: '#5B87A6',
    primary_light: '#1E3A52',
    primary_card_border: '#D6E4F0',
    primary_light_text: '#EDF1F5',
    // Secondary — indigo/purple
    secondary: '#2E3070',
    secondary_medium_light: '#e6e6f5',
    secondary_medium: '#706fa0',
    secondary_light: '#8888B8',
    secondary_card_border: '#D8D5EE',
    secondary_light_text: '#EEEDF3',
    // Tertiary
    tertiary: '#EE486F',
    // Accent — steel blue
    accent: '#4E8FAD',
    accent_light: '#7AAFC8',
    accent_medium_light: '#E4EFF4',
    accent_dark: '#34738E',
    accent_card_border: '#C2DBE6',
    accent_light_text: '#D6E4F0',
    accent_light_card: '#E4EFF4',
    accent_2: '#F4AE10',
    accent_2_light: '#F2C94C',
    accent_2_medium_light: '#FDF3D6',
    accent_2_dark: '#D4900A',
    accent_2_card_border: '#FAEEC4',
    accent_light_tag: '#C88309',
    accent_2_dark_text: '#754f03',
    // Semantic — error
    error: '#BA1A1A',
    error_light: '#E05555',
    error_medium_light: '#FEF3F6',
    error_dark: '#7D0E0E',
    error_card_border: '#FADDE2',
    // Semantic — success
    success: '#3A8020',
    success_light: '#5A9E28',
    success_medium_light: '#E0EED0',
    success_dark: '#255C10',
    success_card_border: '#CEEAB0',
    // Borders
    border: '#DDD8D0',
    border_dark: '#C8C4BC',
    diminished_dark: '#A9A9A9',
    diminished_light: '#666666',
    // Neutral
    neutral: '#565C61',
    neutral_light: '#87909B',
    neutral_medium: '#6b7280',
    neutral_dark: '#42474e',
    neutral_accent_1: '#EEEDF3',
    neutral_accent_2: '#F5F4F8',
    neutral_primary: '#D6E4F0'
};
const $8951886a6b49e92a$export$c1613448d66f98fa = {
    accent_50: 'rgba(110, 235, 255, 0.5)',
    accent_20: 'rgba(110, 235, 255, 0.2)',
    primary_50: 'rgba(227, 22, 91, 0.5)',
    dark_90: 'rgba(6, 40, 68, 0.9)',
    dark_semi_transparent: 'rgba(6, 40, 68, 0.9)'
};
const $8951886a6b49e92a$export$78ee211991971792 = {
    hero: 'linear-gradient(26deg, #062844 30%, #49558d 70.66%, #6b6cb1 110.51%, #6c82c0 150.36%, #6db9e7 186.13%)',
    primary_button: 'linear-gradient(54deg, #062844 4.52%, #4b2b8e 59.43%, #ee486f 125.41%)',
    primary: 'linear-gradient(30deg, #062844 0%, #693B83 33%, #A4417A 66%, #EE486F 100%);',
    primary_angle: 'linear-gradient(135deg, #062844 0%, #693B83 33%, #A4417A 66%, #EE486F 100%);',
    primary_inverted: 'linear-gradient(30deg, #EE486F 0%, #A4417A 33%, #693B83 66%, #062844 100%);',
    secondary: 'linear-gradient(30deg, #062844 0%, #49558D 25%, #6B6CB1 50%, #6C82C0 75%, #6DB9E7 100%);',
    secondary_inverted: 'linear-gradient(30deg, #6DB9E7 0%, #6C82C0 25%, #6B6CB1 50%, #49558D 75%, #062844 100%);'
};
const $8951886a6b49e92a$export$efc0d715653ad35 = {
    primary: 'linear-gradient(30deg, #062844 0%, #693B83 100%);',
    primary_inverted: 'linear-gradient(30deg, #693B83 0%, #062844 100%);',
    secondary: 'linear-gradient(30deg, #062844 0%, #49558D 100%);',
    secondary_inverted: 'linear-gradient(30deg, #49558D 0%, #062844 100%);'
};
const $8951886a6b49e92a$export$277a472bd1b5ab4b = {
    primary: 'linear-gradient(30deg, #693B83 0%, #A4417A 100%);',
    primary_inverted: 'linear-gradient(30deg, #A4417A 0%, #693B83 100%);',
    secondary: 'linear-gradient(30deg, #49558D 0%, #6B6CB1 100%);',
    secondary_inverted: 'linear-gradient(30deg, #6B6CB1 0%, #49558D 100%);'
};
const $8951886a6b49e92a$export$9d4dc8ed9a67cba0 = {
    primary: 'linear-gradient(30deg, #A4417A 0%, #EE486F 100%);',
    primary_inverted: 'linear-gradient(30deg, #EE486F 0%, #A4417A 100%);',
    secondary: 'linear-gradient(30deg, #6B6CB1 0%, #6C82C0 100%);',
    secondary_inverted: 'linear-gradient(30deg, #6C82C0 0%, #6B6CB1 100%);'
};
const $8951886a6b49e92a$export$7536ca5ba8ef94f0 = {
    font_xs: '0.62rem',
    font_sm: '0.80rem',
    font_md: '1rem',
    font_lg: '1.25rem',
    font_xlg: '1.563rem',
    font_2xlg: '1.953rem',
    font_3xlg: '2.441rem',
    font_4xlg: '3.052rem',
    default: '1rem',
    text_default: '1rem',
    caption: '0.8rem',
    button_default: '1rem',
    button_hover: '1.1rem',
    button_lg: '1.25rem',
    button_lg_hover: '1.35rem',
    button_sm: '0.8rem',
    button_sm_hover: '0.9rem',
    heading_1: '1.563rem',
    heading_2: '1.953rem',
    card_title: '1.953rem',
    card_subtitle: '1.25rem',
    menu_card: '1rem',
    step: '1.25rem',
    step_seperator: '1.563rem'
};
const $8951886a6b49e92a$export$7c48f4a82d421f6e = {
    light: '300',
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    default: '400',
    text_default: '400',
    button_default: '400',
    button_bold: '600',
    card_title: '400',
    card_subtitle: '300',
    menu_card: '400'
};
const $8951886a6b49e92a$export$aa43e0cf17fdb070 = {
    // using standard 1.5 multiplier
    font_xs: '0.930rem',
    font_sm: '1.200rem',
    font_md: '1.500rem',
    font_lg: '1.875rem',
    font_xlg: '2.344rem',
    font_2xlg: '2.930rem',
    font_3xlg: '3.661rem',
    font_4xlg: '4.578rem',
    text_default: '1.5rem'
};
const $8951886a6b49e92a$export$66bb15e2994e6a26 = {
    default: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
    button: `all 0.1s ease-in-out;`
};
const $8951886a6b49e92a$export$7a57f79000377ca2 = {
    micro: '0.125rem',
    sm: '0.25rem',
    md: '0.5rem',
    default: '0.62rem',
    chat: '1rem',
    lg: '2rem',
    pill: '9999px',
    round: '50%'
};
const $8951886a6b49e92a$export$16e1fc8de5cd9687 = {
    default: `0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);`,
    hover: `0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);`
};
const $8951886a6b49e92a$export$29bb14a8b9f2803e = `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1095" height="2164" viewBox="0 0 1095 2164" fill="none"><path opacity="0.1" d="M457.684 1500.32C427.564 1256.88 363.423 1054.11 325.82 871.89C286.698 669.335 239.351 449.24 399.125 295.785C515.961 180.441 714.417 190.481 856.597 257.274C1007.97 338.515 1092.09 469.391 994.562 733.466C1068.45 636.091 1106.37 515.177 1091.93 410.33C1045.97 77.7569 778.061 -1.68068 594.512 0.870846C418.992 3.40439 200.036 114.728 96.5716 329.053C25.8917 475.564 -3.03559 682.462 71.7142 1057.36C163.323 1516.37 125.759 1834.89 8.88889 2087.43C7.06729 2091.18 5.96644 2095.28 3.85654 2098.88C-1.55431 2108.55 -1.09116 2117.86 16.5831 2121.46C19.0256 2121.94 21.5422 2122.63 24.0588 2123.31C160.492 2157.2 297.61 2169.14 431.78 2161.12C435.615 2145.17 501.825 1856.07 457.824 1500.03L457.684 1500.32Z" fill="url(%23paint0_linear_2388_1132)"/><defs><linearGradient id="paint0_linear_2388_1132" x1="459.422" y1="41.4754" x2="192.952" y2="633.478" gradientUnits="userSpaceOnUse"><stop stop-color="%236DB9E7"/><stop offset="0.07" stop-color="%236CA2D7"/><stop offset="0.16" stop-color="%236B8AC6"/><stop offset="0.26" stop-color="%236B79BA"/><stop offset="0.37" stop-color="%236B6FB3"/><stop offset="0.5" stop-color="%236B6CB1"/><stop offset="1" stop-color="%23062844"/></linearGradient></defs></svg>')`;
const $8951886a6b49e92a$export$f6e93140e4a16f4b = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($8951886a6b49e92a$var$t || ($8951886a6b49e92a$var$t = $8951886a6b49e92a$var$_`
  0% {
    transform: translateY(10%);
    opacity: 0;
    overflow: hidden;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`));
const $8951886a6b49e92a$export$a63bc229d382c303 = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($8951886a6b49e92a$var$t1 || ($8951886a6b49e92a$var$t1 = $8951886a6b49e92a$var$_`
    0% {
        background-color: transparent;
    }
    100% {
        background-color: '#062844' ;
    }
`));
const $8951886a6b49e92a$export$42e8f6dfc68e0255 = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($8951886a6b49e92a$var$t2 || ($8951886a6b49e92a$var$t2 = $8951886a6b49e92a$var$_`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`));
const $8951886a6b49e92a$export$bca14c5b3b88a9c9 = (0, $1626f90a7ddd654a$export$2e2bcd8739ae039)({
    palette: {
        text: {
            primary: $8951886a6b49e92a$export$35e9368ef982300f.primary_dark
        },
        primary: {
            main: $8951886a6b49e92a$export$35e9368ef982300f.secondary
        },
        secondary: {
            main: $8951886a6b49e92a$export$35e9368ef982300f.tertiary
        },
        error: {
            main: $8951886a6b49e92a$export$35e9368ef982300f.error
        }
    },
    typography: {
        fontFamily: 'Archivo, sans-serif'
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: $8951886a6b49e92a$export$35e9368ef982300f.neutral
                }
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '0.5rem'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: $8951886a6b49e92a$export$7536ca5ba8ef94f0.font_sm,
                    lineHeight: $8951886a6b49e92a$export$aa43e0cf17fdb070.font_xs,
                    backgroundColor: $8951886a6b49e92a$export$c1613448d66f98fa.dark_semi_transparent
                }
            },
            defaultProps: {
                enterDelay: 800,
                leaveDelay: 200,
                enterNextDelay: 400
            }
        },
        MuiRadio: {
            defaultProps: {
                disableRipple: true
            }
        }
    }
});
const $8951886a6b49e92a$export$bf79f457b6853d65 = 32;


const $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018 = 'en';
const $3ecd3f7dea3d56de$export$f44b61b0f29ec = 'en-us';
const $3ecd3f7dea3d56de$export$a1451363a805f944 = {
    'en-us': "\uD83C\uDDFA\uD83C\uDDF8",
    'en-gb': "\uD83C\uDDEC\uD83C\uDDE7",
    'en-in': "\uD83C\uDDEE\uD83C\uDDF3",
    es: "\uD83C\uDDEA\uD83C\uDDF8",
    fr: "\uD83C\uDDEB\uD83C\uDDF7",
    it: "\uD83C\uDDEE\uD83C\uDDF9",
    de: "\uD83C\uDDE9\uD83C\uDDEA",
    ja: "\uD83C\uDDEF\uD83C\uDDF5"
};
const $3ecd3f7dea3d56de$export$20f251d25567c8b5 = {
    en: "\uD83C\uDDFA\uD83C\uDDF8",
    es: "\uD83C\uDDEA\uD83C\uDDF8",
    fr: "\uD83C\uDDEB\uD83C\uDDF7",
    it: "\uD83C\uDDEE\uD83C\uDDF9",
    de: "\uD83C\uDDE9\uD83C\uDDEA",
    ja: "\uD83C\uDDEF\uD83C\uDDF5"
};
const $3ecd3f7dea3d56de$export$df1c34db1371eeed = {
    display: [
        'en',
        'es',
        'fr',
        'it',
        'de',
        'ja'
    ],
    voice: [
        'en-us',
        'en-gb',
        'en-in',
        'es',
        'fr',
        'it',
        'de',
        'ja'
    ]
};
const $3ecd3f7dea3d56de$export$e471f5ee496a5676 = {
    'en-us': [
        'type'
    ],
    'en-gb': [
        'type'
    ],
    'en-in': [
        'type'
    ],
    es: [
        'escribe'
    ],
    fr: [
        'tape'
    ],
    it: [
        'scrivi'
    ],
    de: [
        'schreiben'
    ],
    ja: [
        "\u66F8\u304F"
    ]
};


var $3fc11051985d0b09$exports = {};
$3fc11051985d0b09$exports = JSON.parse('{"logo":"Cephable-Logo","add":"Hinzuf\xfcgen","all":"Alle","edit":"Bearbeiten","create":"Erstellen","delete":"L\xf6schen","previous":"Vorherige","next":"N\xe4chste","search":"Suchen","loading":"Laden...","reload":"Neu laden","cancel":"Stornieren","copy":"Kopie","save":"Speichern","saveAndFinish":"Speichern und beenden","saveAndContinue":"Speichern und fortfahren","saved":"Gespeichert","done":"Erledigt","back":"Zur\xfcck","play":"Spielen","pause":"Pause","success":"Erfolg","continue":"Weitermachen","options":"Optionen","share":"Aktie","finish":"Beenden","finishEdit":"Bearbeitung beenden","advancedOptions":"Erweiterte Optionen anzeigen","authenticating":"Authentifizierung...","skipToMain":"Zum Hauptinhalt springen","skip":"\xdcberspringen","close":"Schlie\xdfen","notFound":"Seite nicht gefunden","notFoundDescription":"Oh nein! Wir haben das ganze Meer abgesucht und k\xf6nnen die Seite nicht finden!","exitSetup":"Setup beenden","experimental":"Experimental","letGetStarted":"Lasst uns anfangen!","exploreInputControls":"Eingabesteuerung erkunden","when":"Wenn ich ...","thenMacro":"Cephable wird ausgef\xfchrt ...","controls":"Bedienelemente","welcome":"Willkommen.","beta":"Beta","macroEmpty":"Es gibt keine Makros, die diesen Kriterien entsprechen.","you":"Du","step":"Schritt","steps":"Vorgehensweise","learnMore":"Mehr erfahren","dangerZone":"Gefahrenzone","connected":"Verbunden","notConnected":"Nicht verbunden","connectAndLearn":"Vernetzen und lernen","tryAgain":"Versuchen Sie es erneut","by":"Von: {{value}}","noName":"- kein Name -","details":"Details","controlFeed":"Kontrollvorschub","upgrade":"Aktualisierung","mobileApp":{"title":"Mobile App"},"dashboard":{"title":"Armaturenbrett"},"invalidNumber":"N / A","wifi":{"disconnected":"Die WLAN-Verbindung ist getrennt.","connected":"WLAN ist verbunden.","description":"Stellen Sie eine WLAN-Verbindung her, damit Cephable mit Ihren Verbindungen und Ihrer Software funktioniert. M\xf6glicherweise sind Ihre aktuellen Steuerelemente nur eingeschr\xe4nkt nutzbar."},"signalR":{"disconnected":"Die Synchronisierung ist getrennt.","action":"Neu verbinden","description":"Es scheint ein Problem mit der Cephable-Synchronisierung zu geben. Dies f\xfchrt zu Problemen beim Speichern Ihrer Einstellungen oder bei der Kommunikation mit anderen Verbindungen.","disconnectedDevice":"Synchronisierung mit {{name}} nicht m\xf6glich.","disconnectedDeviceDescription":"Es scheint ein Problem mit der Synchronisierung zu geben, entweder aufgrund der Authentifizierung oder der Internetverbindung. Sie k\xf6nnen keine Daten senden oder empfangen. Bitte \xfcberpr\xfcfen Sie beide Seiten der Verbindung.","connected":"Die Synchronisierung ist verbunden.","connectedDescription":"Cephable synchronisiert ordnungsgem\xe4\xdf und sollte wie erwartet mit Ihren Verbindungen und Erweiterungen kommunizieren.","swap":"Wechseln Sie zur Verbindung mit einem lokalen Ger\xe4t.","unlinkedDevice":"Verbindung getrennt.","unlinkedDeviceDescription":"Diese Verbindung wurde von Ihrem Konto getrennt.","featureRestricted":"Die Funktionen \u201EErstellen\u201C und \u201EAutomatisieren\u201C sind f\xfcr Remote-Verbindungen nicht verf\xfcgbar.","featureRestrictedDescription":"Diese Funktion ist derzeit f\xfcr Remote-Verbindungen nicht verf\xfcgbar. Bitte wechseln Sie zur lokalen Ger\xe4teverbindung, um alle Funktionen zur Erstellung und Automatisierung Ihrer Arbeit nutzen zu k\xf6nnen."},"billing":{"title":"Abrechnung","expires":"N\xe4chste Abrechnung: {{value}}","isEmployeeAccess":{"title":"Professional","titleLong":"Cephable Profi","short":"Pro","description":"Cephable Professional verleiht Benutzern mehr Produktivit\xe4t und erweitert die lokale, private KI um generative F\xe4higkeiten.","supportedFeatures":{"tag":"Alles in Plus, plus","features":["On-Device-KI-Workflows","Unternehmensorganisationsmanagement","Unternehmensbeschr\xe4nkungen","Unbegrenzte Ger\xe4teinstallationen","Unbegrenzte Anzahl vorkonfigurierter App-Steuerelemente"]}},"isDeveloperAccess":{"title":"SDK","titleLong":"Cephable SDK","short":"SDK","description":"Mit Cephable SDKs k\xf6nnen Sie leistungsstarke adaptive Steuerelemente \u2013 Sprache, Gesicht, Kopf und mehr \u2013 mit minimalem Aufwand und maximalem Nutzen in Ihre Software integrieren.","supportedFeatures":{"tag":"Alles in Plus, plus","features":["Windows- und MacOS-Unterst\xfctzung","Leichtgewichtige, einbettbare SDKs f\xfcr die Offline-Eingabe von Sprache, Gesicht, Kopf und schnellen Aktionen","API-/Webhook-Unterst\xfctzung f\xfcr benutzerdefinierte Ausgabeaktionen","Entwicklerdokumente","Beispielprojekte","Verwandeln Sie Befehle in Dokumentautomatisierung und -navigation","Entwicklerportal zur Verwaltung Ihrer Projekte, Authentifizierungsclients, Ger\xe4tetypen und mehr"]}},"isStudentAccess":{"title":"Student","titleLong":"Cephable-Ausbildung","short":"Bildung","description":"Cephable Education unterst\xfctzt personalisiertes Lernen und inklusiven Unterricht. Cephable funktioniert offline, l\xe4uft auf dem Ger\xe4t und erfordert keine Integration von Drittanbietern.","supportedFeatures":{"tag":"Alles in Plus, plus","features":["Unbegrenzte Ger\xe4teinstallationen","Unbegrenzte vorab trainierte App-Steuerelemente","Unbegrenztes Teilen von benutzerdefinierten App-Steuerelementen"]}},"viewProducts":"Produkte anzeigen","description":"Verwalten Sie die Abrechnung, Sitze, Abonnement-Upgrades, Verl\xe4ngerungen oder K\xfcndigungen Ihres Unternehmens.","view":"Abrechnung verwalten","isResellerAccess":{"title":"Wiederverk\xe4ufer","titleLong":"Cephable-Wiederverk\xe4ufer","description":"Cephable Reseller ist eine kostenpflichtige Lizenz, mit der Sie neue Organisationen erstellen und Lizenzschl\xfcssel zuweisen k\xf6nnen. Dazu geh\xf6rt die Verwendung von Cephable mit Ihrer eigenen Software-Suite und die Verbesserung Ihrer Benutzererfahrung.","short":"Wiederverk\xe4ufer"},"error":"Bitte wenden Sie sich zur Verwaltung Ihrer Abrechnung an Ihren Systemadministrator.","included":"In Ihrer {{licenseType}}-Lizenz enthalten.","upgrade":{"description":"F\xfchren Sie jetzt ein Upgrade durch und bringen Sie Ihre Steuerung auf die n\xe4chste Stufe.","action":"Jetzt upgraden","error":"Fehler bei der Aktualisierung. Bitte versuchen Sie es sp\xe4ter erneut.","requiredDetail":"F\xfcr diese Funktion ist eine {{licenseType}}-Lizenz erforderlich. Sie k\xf6nnen jederzeit in Ihren Kontoeinstellungen ein Upgrade durchf\xfchren oder eine kostenlose Testversion starten.","enableTextGeneration":"Erstellen Sie Inhalte mithilfe von KI und Ihrer Stimme.","longDescription":"Aktualisieren Sie auf eine kostenpflichtige Lizenz, um alle Funktionen von Cephable freizuschalten. Von mehreren Ger\xe4ten \xfcber erweiterte Bedienelemente bis hin zu benutzerdefinierten Integrationen bietet Cephable alles, was Sie f\xfcr ein h\xf6heres Produktivit\xe4tsniveau ben\xf6tigen.","compare":"Pl\xe4ne vergleichen","enableAiDictation":{"title":"Upgrade auf intelligentes Diktieren","description":"Aktualisieren Sie, um die KI-gest\xfctzte Diktierfunktion freizuschalten. Ich kann Satzzeichen hinzuf\xfcgen, Gro\xdf- und Kleinschreibung korrigieren und mich Ihrem Stil anpassen, damit Ihr Text ohne zus\xe4tzlichen Aufwand professionell aussieht."},"enableAiWorkflows":"R\xfcsten Sie auf, um Ihre Desktop- und Browseraufgaben mit KI-Workflows zu automatisieren."},"isPlusAccess":{"title":"Plus","titleLong":"Cephable Plus","short":"Plus","description":"Cephable Plus ist f\xfcr Power-User, die mit intelligenter Stimme, intelligentem Diktierger\xe4t, Hunderten von App-Steuerelementen und mehr mehr erreichen m\xf6chten.","supportedFeatures":{"tag":"Alles aus Basic, plus","features":["Intelligente Sprachsteuerung (Nat\xfcrliche Sprache)","Intelligente Diktierfunktion (KI-gest\xfctzt)","Intelligente Aufgaben (Generierung, \xdcbersetzung, Umschreibung)","Hunderte vorkonfigurierte App-Steuerelemente"]}},"personal":{"short":"Basic","title":"Basic","titleLong":"Cephable Basic","description":"Cephable Basic ist dauerhaft kostenlos und hilft Ihnen, schneller voranzukommen, sich auszudr\xfccken und Aufgaben zu erledigen \u2013 ganz nach Ihren W\xfcnschen. Die in Basic enthaltenen Funktionen stehen allen Nutzern zur Verf\xfcgung.","upgrade":{"title":"Bringen Sie Ihre Steuerung auf die n\xe4chste Stufe","description":"Steigen Sie auf Plus oder Pro um und schalten Sie alle Funktionen frei. Mehr Genauigkeit. Mehr Verbindungen. Mehr Steuerungsm\xf6glichkeiten. Mehr Leistung f\xfcr maximale Produktivit\xe4t.","featureHeading":"So kann ich Ihnen helfen:","control":"Ich f\xfchre Sie per Sprachbefehl oder Schnellaktionen schneller durch Apps und Tools \u2013 ohne Unterbrechungen. Mit Intelligent Voice k\xf6nnen wir uns einfach unterhalten.","create":"Ich schreibe, diktiere, generiere und \xfcbersetze direkt in Ihren Apps \u2013 kein Kopieren, Einf\xfcgen oder Umschalten zwischen Bildschirmen erforderlich.","automate":"Ich f\xfchre intelligente Aufgaben und schnelle Aktionen aus, die Ihren Arbeitsablauf beschleunigen. Von einfachen Befehlen bis hin zu komplexen Makros \u2013 ich \xfcbernehme die Routinearbeiten, damit Sie sich auf das Wesentliche konzentrieren k\xf6nnen.","local":"Reine lokale KI. Keine Cloud-Verarbeitung."}},"mostPopular":"Am beliebtesten","subscription":{"options":"Abonnementoptionen","monthly":"Monatlich bezahlen","billedMonthly":"/Monat","yearly":"J\xe4hrliche Zahlung","billedYearly":"/Jahr"}},"organization":{"title":"Organisation","titlePlural":"Organisationen","titleLong":"Cephable Professional f\xfcr Organisationen","description":"Organisationen sind Gruppen von Benutzern, die an Projekten zusammenarbeiten und Ressourcen teilen k\xf6nnen. Hier k\xf6nnen Sie Ihr Team, Teamprofile, Abrechnungen und mehr verwalten.","noAccess":{"title":"Zugriff verweigert.","description":"Ihre Berechtigungen wurden k\xfcrzlich ge\xe4ndert und Sie haben keinen Zugriff mehr auf diese Funktion. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Administrator Ihrer Organisation."},"noOrg":{"title":"Keine zugeh\xf6rige Lizenz.","description":"Sie sind derzeit keiner Lizenz oder Entwicklergruppe zugeordnet. Der Zugriff auf das Portal ist auf Benutzer mit einer kostenpflichtigen Cephable-Lizenz beschr\xe4nkt. Um das volle Potenzial von Cephable auszusch\xf6pfen, starten Sie eine risikofreie Testversion."},"member":{"title":"Mitglied","titlePlural":"Mitglieder","me":"Meine Mitgliedschaft","description":"Mitglieder sind Benutzer, die Teil Ihrer Organisation sind. Ihnen k\xf6nnen verschiedene Rollen zugewiesen werden und sie haben Zugriff auf unterschiedliche Teile der Organisation.","edit":"Mitglieder bearbeiten","removed":"Sie wurden aus einem Team entfernt.","removedDescription":"Sie wurden aus dem Team entfernt. Sie k\xf6nnen nicht mehr auf die Organisation zugreifen. Wenn Sie glauben, dass dies ein Fehler ist, wenden Sie sich bitte an den Administrator Ihrer Organisation.","updated":"Erfolg, die Mitgliedschaft von {{value}} wurde aktualisiert.","error":"Fehler beim Aktualisieren der Mitgliedschaft von {{value}}.","delete":"Erfolg, {{value}} wurde entfernt.","deleteError":"Fehler beim Entfernen von {{value}}.","deleteConfirmation":{"title":"M\xf6chten Sie dieses Mitglied wirklich entfernen?","description":"Sobald Sie dieses Mitglied entfernen, hat es keinen Zugriff mehr auf die Organisation. Sie k\xf6nnen es sp\xe4ter jederzeit erneut einladen.","confirm":"Ja, Mitglied entfernen"},"viewAll":{"title":"Alle Mitglieder anzeigen","description":"Zeigen Sie alle Mitglieder Ihrer Organisation an und verwalten Sie ihre Rollen und Berechtigungen."},"seats":{"title":"Mitgliedersitze","description":"Jedes Mitglied in Ihrer Organisation z\xe4hlt als Sitz. Die Art der Berechtigungen, die sie haben, kann vom Organisationsadministrator ge\xe4ndert werden.","stats":"Sitzpl\xe4tze von {{value}}","max":"Max Sitzpl\xe4tze","current":"Aktuelle Sitze","limit":{"title":"Maximale Anzahl an Sitzpl\xe4tzen erreicht","description":"Ihr aktueller Plan hat sein Limit von {{ maxSeats }} verf\xfcgbaren Pl\xe4tzen erreicht. Sie k\xf6nnen keine weiteren Mitglieder einladen. Wenden Sie sich bitte an Ihren Administrator, um den Plan zu aktualisieren oder Ihre Sitzplatzzuteilung zu verwalten."},"updateLimit":{"title":"Aktualisieren Sie Ihren Plan, um weitere Pl\xe4tze hinzuzuf\xfcgen","description":"Ihr aktueller Plan hat die maximale Anzahl an Sitzpl\xe4tzen erreicht: {{ maxSeats }}. F\xfchren Sie jetzt ein Upgrade durch, um zus\xe4tzliche Sitzpl\xe4tze freizuschalten und sicherzustellen, dass Ihr Team nahtlos weiter wachsen kann.","action":"Upgrade-Plan"},"maxSeatValue":"Max. Sitzpl\xe4tze: {{value}}"},"aboutMe":"\xdcber mich","loadError":"Fehler beim Laden der Organisationsmitglieder.","orgTitle":"Mitglieder von {{value}}","emailExists":"In der Organisation ist bereits eine E-Mail-Adresse vorhanden. Bitte geben Sie eine andere E-Mail-Adresse ein."},"invite":{"title":"Einladen","titlePlural":"Einladungen","description":"Benutzer erhalten Einladungen, Ihrer Organisation beizutreten. Sie k\xf6nnen Benutzer einladen, Ihrer Organisation beizutreten und ihnen verschiedene Rollen zuweisen.","edit":"Mitglied hinzuf\xfcgen","view":"Alle Einladungen anzeigen","viewDescription":"Alle aktuellen Einladungen anzeigen, die nicht angenommen wurden.","new":"Ein Mitglied einladen","emailRequired":"E-Mail ist erforderlich","emailInvalid":"E-Mail ist ung\xfcltig. Bitte geben Sie eine g\xfcltige E-Mail-Adresse ein.","emailExists":"E-Mail wurde bereits zu einer organisation eingeladen. Bitte geben Sie eine andere E-Mail-Adresse ein.","emailPlaceholder":"E-Mail-Adresse eingeben","expiration":"L\xe4uft ab","delete":"Einladung l\xf6schen","confirm":"M\xf6chten Sie diese Einladung wirklich entfernen?","confirmLong":"Sobald Sie diese Einladung l\xf6schen, kann der Benutzer der Organisation nicht mehr beitreten. Sie k\xf6nnen ihn sp\xe4ter jederzeit erneut einladen.","accept":"Einladung annehmen","stat":"aktive Einladungen","noInvites":{"title":"Keine Einladungen.","description":"Es sieht so aus, als ob es f\xfcr Ihre Organisation keine aktiven Einladungen gibt."},"acceptSuccess":{"title":"Willkommen im Team.","description":"Sie sind der Organisation erfolgreich beigetreten.","action":"Zeigen Sie Ihre neue Organisation an"},"acceptError":{"title":"Hoppla. Da liegt offenbar ein Problem vor.","description":"Beim Beitritt zur Organisation ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Administrator Ihrer Organisation.","action":"Zur\xfcck zur Homepage"},"send":{"success":"Einladung an {{value}} gesendet.","error":"Fehler beim Senden der Einladung an {{value}}.","title":"Einladung senden"},"error":"Fehler beim Laden der Einladungen.","orgTitle":"Einladungen von {{value}}","editDescription":"Erstellen Sie eine neue Einladung f\xfcr einen Benutzer, Ihrer Organisation beizutreten.","scimManaged":{"title":"Die Mitglieder werden in Ihrem Identit\xe4tsanbieter verwaltet.","description":"Diese Organisation nutzt automatische Bereitstellung (SCIM), daher wird die Mitgliedschaft \xfcber Ihr internes Identit\xe4tssystem verwaltet. Wenn Sie Personen hinzuf\xfcgen oder entfernen, wird die \xc4nderung automatisch mit Cephable synchronisiert \u2013 Einladungen k\xf6nnen nicht \xfcber das Portal versendet werden."}},"role":{"title":"Rolle","titlePlural":"Rollen","description":"Rollen sind die verschiedenen Zugriffsebenen, die ein Benutzer in Ihrer Organisation haben kann. Sie k\xf6nnen Benutzern verschiedene Rollen zuweisen, um zu steuern, was sie tun k\xf6nnen."},"isAdmin":{"title":"Verwaltung","description":"Administratoren haben vollen Zugriff auf die Organisation und k\xf6nnen alle Aspekte der Organisation verwalten.","conflict":"Dieses Mitglied ist ein Administrator. Sie sind nicht berechtigt, seine Rollen zu bearbeiten."},"canViewMembers":{"title":"Mitglieder anzeigen","description":"Benutzer mit dieser Berechtigung k\xf6nnen alle Mitglieder der Organisation anzeigen."},"canInviteMembers":{"title":"Mitglieder einladen","description":"Benutzer mit dieser Berechtigung k\xf6nnen neue Mitglieder zur Organisation einladen und bestehende Einladungen verwalten."},"canChangeMemberPermissions":{"title":"Mitgliederrollen \xe4ndern","description":"Benutzer mit dieser Berechtigung k\xf6nnen die Rolle anderer Mitglieder in der Organisation \xe4ndern."},"canRemoveMembers":{"title":"Mitglieder entfernen","titleSingle":"Mitglied entfernen","action":"Entfernen","description":"Benutzer mit dieser Berechtigung k\xf6nnen andere Mitglieder aus der Organisation entfernen.","confirm":"M\xf6chten Sie dieses Mitglied wirklich aus der Organisation entfernen?","confirmLong":"Sobald Sie dieses Mitglied entfernen, hat es keinen Zugriff mehr auf die Organisation. Sie k\xf6nnen es sp\xe4ter jederzeit erneut einladen."},"canCreateAuthClients":{"title":"Projekte erstellen","description":"Benutzer mit dieser Berechtigung k\xf6nnen neue Authentifizierungsclients und -projekte f\xfcr die Organisation erstellen."},"canManageBilling":{"title":"Abrechnung verwalten","description":"Benutzer mit dieser Berechtigung k\xf6nnen die Abrechnungseinstellungen f\xfcr die Organisation verwalten.","error":"Sie sind nicht berechtigt, die Abrechnung f\xfcr diese Organisation zu verwalten."},"metrics":{"title":"Metriken","description":"Metriken sind Datenpunkte, die Ihnen helfen zu verstehen, wie Ihre Organisation Cephable verwendet.","view":"Metriken anzeigen","lineChart":{"title":"Durchschnittliche Anzahl gleichzeitiger Verbindungen","description":"Dieses Diagramm zeigt die durchschnittliche Anzahl gleichzeitiger Verbindungen f\xfcr die Organisations- und Projektdaten im Zeitverlauf.","max":"Max. Verbindungen: {{maxConnections}}","project":"Projektgesamt","org":"Organisation Gesamt"},"orgTitle":"Metriken f\xfcr {{value}}","manage":{"title":"Leistungsmetriken","description":"Laden Sie die w\xe4hrend der Modellinferenz erfassten Leistungsmetriken herunter oder l\xf6schen Sie sie."},"download":{"button":"Metriken herunterladen","success":"Die Metrikdatei wurde in Ihrem Download-Ordner gespeichert.","error":"Das Herunterladen der Metrikdatei ist fehlgeschlagen.","noFile":"Keine Metrikdatei gefunden. Versuchen Sie zun\xe4chst, das Modell auszuf\xfchren."},"clear":{"button":"Klare Metriken","success":"Die Metriken wurden gel\xf6scht.","error":"Das L\xf6schen der Metrikdatei ist fehlgeschlagen.","confirm":{"title":"Klare Leistungsmetriken","description":"M\xf6chten Sie wirklich alle aufgezeichneten Leistungsmesswerte l\xf6schen? Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","cancel":"Stornieren","confirm":"Klare Metriken"}}},"projects":{"title":"Projekte","description":"Verwenden Sie Projekte, um den sicheren Zugriff zu verwalten, Ger\xe4teinteraktionen zu konfigurieren und die Art und Weise zu optimieren, wie Ihre Apps plattform\xfcbergreifend Befehle senden und empfangen.","name":"App-Name","view":"Projekte anzeigen","error":"Fehler beim Laden der Projekte.","stats":{"title":"Projektstatistiken","connections":"Verbindungen insgesamt","all":{"title":"Alle Projektmetriken","description":"Aggregierte Metriken f\xfcr alle mit {{ orgName }} verkn\xfcpften Projekte"},"card":"Projekte von {{value}}","users":"Gesamtnutzerzahl seit {{date}}","avgUsers":"Durchschnittliche monatliche Benutzerzahl.","concurrent":{"title":"Durchschnittliche Anzahl gleichzeitiger Verbindungen in den letzten {{days}} Tagen","label":"Gleichzeitiger Durchschn","max":"Max. Verbindungen","overage":"\xdcberschuss","description":"Gleichzeitige Verbindungen geben die Anzahl der Benutzer an, die gleichzeitig mit Ihrem Projekt verbunden sind. Diese Kennzahl hilft Ihnen zu verstehen, wie viele Benutzer Ihre App gleichzeitig verwenden."}},"projectType":{"title":"Projekttyp","description":"Projekttypen werden verwendet, um Ihre Projekte zu kategorisieren und uns dabei zu helfen, die richtigen SDKs f\xfcr Sie auszuw\xe4hlen."},"accessDenied":{"generic":"Sie haben keinen Zugriff auf dieses Projekt.","title":"Zugriff verweigert.","description":"Sie haben keinen Zugriff zum Anzeigen, Erstellen, Bearbeiten oder L\xf6schen von Projekten. Wenden Sie sich f\xfcr den Zugriff bitte an Ihren Administrator."},"upgrade":{"title":"Upgrade auf Cephable SDK","description":"Cephable kann mithilfe unserer SDKs direkt in Ihre App, Ihr Spiel oder Ihren Dienst integriert werden. Projekte sind derzeit mit Ihrem Konto nicht verf\xfcgbar. Wenn Sie glauben, dass ein Fehler vorliegt, wenden Sie sich bitte an support@cephable.com.","shortDescription":"Projekte sind f\xfcr Ihr Konto derzeit nicht verf\xfcgbar. Wenden Sie sich an uns, um ein Upgrade durchzuf\xfchren."},"limit":{"title":"Lust auf mehr Projekte?","error":"Projektlimit erreicht.","description":"Sie haben die maximale Anzahl an Projekten f\xfcr Ihre Organisation erreicht. Wenden Sie sich bitte an Ihren Administrator, um Ihr Konto zu aktualisieren."},"create":{"title":"Projekt erstellen","titleLong":"Lasst uns anfangen.","first":{"title":"Beginnen Sie mit Ihrem Projekt.","description":"Es sieht so aus, als h\xe4tten Sie noch kein Projekt erstellt. Client-Schl\xfcssel und -Ger\xe4te sind f\xfcr die sichere Kommunikation zwischen Ihren Anwendungen und unseren Diensten unerl\xe4sslich. Mit einem Client-Schl\xfcssel k\xf6nnen Sie Sprach- und Kopfbewegungssteuerungen schnell und sicher in Ihre Apps integrieren."},"details":{"title":"Projektdetails","description":"Erstellen Sie ein neues Projekt, um die Autorisierung, Ger\xe4tefunktionen und SDK-Integrationen Ihrer Anwendung zu verwalten. Befolgen Sie die folgenden Schritte, um sichere, anpassbare Interaktionen f\xfcr Ihre Benutzer einzurichten."}},"sdk":{"title":"Laden Sie das SDK herunter","description":"Erhalten Sie Zugriff auf unser leistungsstarkes SDK, das entwickelt wurde, um adaptive Steuerungen zu vereinfachen.","select":{"title":"SDK ausw\xe4hlen","description":"W\xe4hlen Sie das SDK aus, das Sie f\xfcr dieses Projekt verwenden m\xf6chten. Unsere SDKs erm\xf6glichen die nahtlose Integration adaptiver Sprach- und Kopfbewegungssteuerungen \xfcber verschiedene Plattformen hinweg."}},"clients":{"title":"Autorisierungsclients","configure":"Autorisierungsclient konfigurieren","description":"Autorisierungsclients verwalten den sicheren Zugriff auf Ihre Anwendungen. Definieren Sie einen Autorisierungsclient, um Benutzer zu authentifizieren und Interaktionen mit Ihrer Anwendung zu steuern.","settings":"Autorisierungseinstellungen","create":"Autorisierungsclient erstellen","max":"Max. Projekte: {{value}}"},"secret":{"title":"Client-Geheimnis","created":"Ihr Client-Geheimnis wurde erstellt.","description":"Ihr Client-Geheimnis wird nur einmal angezeigt. Kopieren Sie es jetzt und bewahren Sie es an einem sicheren Ort auf.<br><br> Verwenden Sie es nur f\xfcr Ihre eigene Entwicklung. Geben Sie es nicht an Dienste oder Anwendungen von Drittanbietern weiter.","copy":"Geheimen Schl\xfcssel kopieren","rotate":{"title":"Rotieren des Client-Geheimnisses","description":"ACHTUNG: Diese Aktion widerruft Ihr bestehendes Client-Geheimnis und erstellt ein neues Client-Geheimnis. Dazu m\xfcssen Sie Ihre gesamte bestehende Nutzung in Ihren Apps aktualisieren. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","error":"Fehler beim Rotieren des Geheimnisses. Bitte versuchen Sie es sp\xe4ter noch einmal."}},"key":{"title":"Client-Schl\xfcssel","view":"Clientschl\xfcssel anzeigen","copy":"Schl\xfcssel kopieren","delete":{"title":"Clientschl\xfcssel l\xf6schen","description":"WARNUNG: Diese Aktion entfernt Ihren vorhandenen Clientschl\xfcssel und alle zugeh\xf6rigen Einstellungen. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","error":"Fehler beim L\xf6schen Ihres Client-Schl\xfcssels.","success":"Ihr Projekt wurde gel\xf6scht."}},"tokenRedirect":{"title":"Token-Umleitungs-URLs","description":"Token-Umleitungs-URLs sind die Endpunkte, an die nach Abschluss der Authentifizierung Zugriffstoken gesendet werden. Mit diesen URLs kann Ihre Anwendung sicher Token empfangen, die f\xfcr den Zugriff auf Benutzerdaten und -dienste erforderlich sind."},"authRedirect":{"title":"Autorisierungscode-Umleitungs-URLs","description":"Die AuthCode-Umleitungs-URL ist der Endpunkt, an den Autorisierungscodes gesendet werden, nachdem ein Benutzer Ihrer Anwendung die Berechtigung erteilt hat. Diese URL ist in OAuth-Flows von entscheidender Bedeutung, da sie die sichere \xdcbertragung des Autorisierungscodes vom Autorisierungsserver an Ihre App gew\xe4hrleistet und es Ihnen erm\xf6glicht, Zugriffstoken im Namen des Benutzers anzufordern."},"scopes":{"title":"Bereiche","configure":"Bereiche definieren","titleLong":"API-Berechtigungsbereiche","description":"Bereiche definieren die Berechtigungen, die dieser Autorisierungsclient haben wird. Legen Sie Bereiche fest, um den Zugriff auf bestimmte Daten und Funktionen zu beschr\xe4nken und sicherzustellen, dass Benutzer nur den Zugriff erhalten, den sie ben\xf6tigen.","manage":"Verwalten von Autorisierungsbereichen"},"type":{"title":"Implementierungstyp"},"deviceScopes":{"title":"Zugeh\xf6rige Ger\xe4tetypen","titleLong":"Erlaubte Ger\xe4tetypen","configure":"Zul\xe4ssige Ger\xe4tetypen konfigurieren","action":"Neuen Ger\xe4tetyp hinzuf\xfcgen","descriptionShort":"Definieren Sie, welche Ger\xe4tetypen auf dieses Projekt zugreifen k\xf6nnen.","titles":"Zugeh\xf6rige Ger\xe4tetypen","description":"Der Ger\xe4tetyp definiert die Berechtigungen und Zugriffsebenen, die ein Ger\xe4t innerhalb Ihrer Anwendung hat. Durch die Zuweisung bestimmter Ger\xe4tetypen k\xf6nnen Sie die Aktionen und Daten steuern, auf die jedes Ger\xe4t zugreifen kann. So stellen Sie sicher, dass Ihre Anwendung sicher bleibt und Ihren Datenschutzrichtlinien entspricht."},"deviceType":{"title":"Ger\xe4tetypen","description":"Ein DeviceType definiert eine Ger\xe4tekategorie und beschreibt detailliert ihre Eingabe-/Ausgabefunktionen und unterst\xfctzten Funktionen (z. B. Sprache, Gesten, Controllertypen). Es stellt sicher, dass nur autorisierte Ger\xe4te mit einer Anwendung interagieren k\xf6nnen.","action":"Ger\xe4tetyp erstellen","name":"Ger\xe4tetypname","descriptionLong":"Ger\xe4tetyp Beschreibung","features":{"title":"Unterst\xfctzt Funktionen","description":"Definieren Sie die Ein- und Ausgaben, die Ihre App unterst\xfctzt. Dies hilft uns, das Benutzererlebnis auf Cephable zu optimieren.","supportsVoiceInput":"Spracheingabe","supportsPhysicalInput":"Physischer Eingang","supportsKeyboardOutput":"Tastaturausgabe","supportsPlayStationControllerOutput":"PlayStation-Controller","supportsFaceInput":"Gesichtseingabe","supportsGestureInput":"Gesteneingabe","supportsXboxControllerOutput":"Xbox-Controller","supportsDigitalExtensions":"Digitale Erweiterungen","supportsPhysicalExtensions":"Physische Erweiterungen","supportsNintendoControllerOutput":"Nintendo-Controller","supportsGenericControllerOutput":"Allgemeiner Controller-Ausgang"},"canAutoStart":{"title":"Unterst\xfctzt automatische Steuerungsstarts","description":"[canAutoStart] Wenn aktiviert, \xfcberpr\xfcfen SDKs die Benutzereinstellungen und versuchen, die Kamera- oder Mikrofonsteuerung sofort nach der Benutzeranmeldung zu starten."},"isSupported":{"title":"Aktiv","description":"[isSupported] Wenn deaktiviert, sendet, empf\xe4ngt oder best\xe4tigt Cephable keine damit verbundenen Benutzerger\xe4te mehr. Entspricht veraltet."},"locale":{"title":"Standardsprache","description":"[defaultLocale] Das Standardgebietsschema f\xfcr diesen Ger\xe4tetyp. Dies wird als Standardsprache f\xfcr das Ger\xe4t verwendet.","support":"Unterst\xfctzt Sprachen","warn":"** Es sieht so aus, als ob Sie benutzerdefinierte Steuerelemente eingerichtet haben. Bitte stellen Sie sicher, dass Sie die benutzerdefinierten Steuerelemente f\xfcr die zugeh\xf6rigen Sprachen aktualisiert haben.**","name":"{{lang}} \u2013 Ger\xe4tetypname","langDescription":"{{lang}} - Beschreibung"},"customControls":{"title":"Benutzerdefinierte Steuerelemente","object":"{{lang}} \u2013 Benutzerdefiniertes Steuerelementobjekt","description":"Benutzerdefinierte Steuerelemente sind eine erweiterte Option, mit der Benutzer die mit diesem Ger\xe4t verkn\xfcpften App-Steuerelemente manuell einrichten und bearbeiten k\xf6nnen. Wenn Sie m\xf6chten, dass Benutzer Ihr Ger\xe4t direkt von Cephable aus steuern, m\xfcssen Sie Ihre Ger\xe4testeuerelemente hier registrieren. Ausf\xfchrliche Informationen zu den Optionen finden Sie in der Cephable-API.","addControl":"Steuerelement hinzuf\xfcgen","empty":"Noch keine benutzerdefinierten Steuerelemente vorhanden. Verwenden Sie \u201ESteuerelement hinzuf\xfcgen\u201C, um Ihr erstes zu erstellen.","untitled":"Unbenanntes Steuerelement","controlId":"Kontroll-ID","controlIdHelp":"Dieses Steuerelement hat eine eindeutige Kennung. Diese muss vor dem Speichern festgelegt werden \u2013 sie kann sp\xe4ter nicht mehr ge\xe4ndert werden.","fallback":"Zur\xfcckgreifen","controlName":"Steuerelementname","controlDescription":"Steuerungsbeschreibung","defaultCommandsLabel":"Standard-Sprachbefehle","defaultCommandsHelp":"Dies sind die standardm\xe4\xdfigen Sprachausl\xf6ser, die Benutzern f\xfcr dieses Steuerelement in der aktuellen Sprache angezeigt werden.","sharedAcrossLanguages":"Wird in allen Sprachen geteilt","sharedAcrossLanguagesHelp":"Durch die Bearbeitung dieser Felder wird der Wert f\xfcr alle Sprachen gleichzeitig aktualisiert.","iconUrl":"Symbol-URL","contextGroupName":"Kontextgruppe","isProfileControl":"Profilsteuerung","isPrefixVoiceCommand":"Pr\xe4fix-Sprachbefehl","allowWhenDictating":"Beim Diktieren zulassen","allowsHold":"Erm\xf6glicht Halten","isDeprecated":"Veraltet","requiresEmployeeAccess":"Erfordert Mitarbeiterzugriff","requiresStudentAccess":"Erfordert Zugang f\xfcr Studierende","requiresGenericLicense":"Erfordert eine generische Lizenz","requiresPlusAccess":"Erfordert Plus-Zugang","allIncomplete":"Alle Gebietsschemas verf\xfcgen \xfcber unvollst\xe4ndige benutzerdefinierte Steuerelemente. Bitte vervollst\xe4ndigen Sie mindestens ein Gebietsschema, bevor Sie speichern.","savedWithIncomplete":"Gespeichert. Unvollst\xe4ndige benutzerdefinierte Steuerelement-Gebietsschemas wurden nicht gespeichert: {{incompleteLocales}}"},"success":{"title":"Erfolg!","description":"Sie haben einen neuen Ger\xe4tetyp erstellt. {{name}} Sie k\xf6nnen jetzt den Umfang Ihres Autorisierungsclientger\xe4ts nach Bedarf aktualisieren."},"id":"Ger\xe4tetyp-ID","throttleRules":{"title":"Regeln f\xfcr die Gassteuerung","description":"Konfigurieren Sie Drosselungsregeln, um den Befehlsfluss und die Eingabebeschr\xe4nkungen f\xfcr diesen Ger\xe4tetyp zu steuern.","disableVoiceInput":"Spracheingabe deaktivieren","disableHotkeyInput":"Hotkey-Eingabe deaktivieren","disableCameraInput":"Kameraeingang deaktivieren","disableMultiInputs":"Mehrere Eing\xe4nge deaktivieren","maximumCommandsPerSecond":"Maximale Befehle pro Sekunde","maximumCommandsPerMinute":"Maximale Befehle pro Minute","maximumMacroLength":"Maximale Makrol\xe4nge","jitter":{"title":"Timing-Jitter","description":"Um nat\xfcrlichere Eingabemuster zu erzeugen, sollten Halte- und Pausenzeiten durch zuf\xe4llige Variationen erg\xe4nzt werden.","holdTimeJitterMin":"Haltezeitjitter Min (ms)","holdTimeJitterMax":"Maximaler Haltezeitjitter (ms)","pauseTimeJitterMin":"Pausenzeit-Jitter Min (ms)","pauseTimeJitterMax":"Maximaler Pausenzeit-Jitter (ms)"},"incompatibleActions":{"title":"Inkompatible Aktionsgruppen","description":"Definiere Aktionsgruppen, die nicht im selben Makro gleichzeitig existieren k\xf6nnen.","addGroup":"Gruppe hinzuf\xfcgen","removeGroup":"Gruppe entfernen","addAction":"Aktion hinzuf\xfcgen","removeAction":"Aktion entfernen","reason":"Grund","reasonPlaceholder":"Warum diese Aktionen unvereinbar sind","eventType":"Ereignistyp","key":"Schl\xfcssel","customActionId":"Benutzerdefinierte Aktions-ID","emptyGroup":"In dieser Gruppe sind keine Aktionen vorhanden. F\xfcgen Sie mindestens zwei Aktionen hinzu."},"requiredPause":{"title":"Erforderliche Pause zwischen den Aktionen","description":"Definiere in demselben Makro Paare von Aktionen, zwischen denen eine minimale Pause erforderlich ist.","addRule":"Regel hinzuf\xfcgen","removeRule":"Regel entfernen","actionA":"Aktion A","actionB":"Aktion B","minimumPause":"Minimale Pause (ms)","bidirectional":"Bidirektional","bidirectionalHelp":"Wenn diese Option aktiviert ist, ist die Pause in beide Richtungen (A\u2192B und B\u2192A) erforderlich."},"macroStepRules":{"title":"Makro-Schrittregeln","holdTimeJitterMin":"Haltejitter Min (ms)","holdTimeJitterMax":"Maximaler Haltejitter (ms)"}}},"originHost":{"title":"Ursprungshost","description":"Die URL, die bei API-Interaktionen als prim\xe4re Quelle f\xfcr Anfragen und Daten dient."},"orgTitle":"Projekte von {{value}}"},"viewOrganization":"Organisation Anzeigen","update":"Ihre Organisation wurde aktualisiert! Die App wird aktualisiert.","error":"Fehler beim Laden der Organisation. Bitte versuchen Sie es sp\xe4ter erneut.","new":{"name":{"label":"Name der Organisation","placeholder":"Geben Sie den Namen Ihrer Organisation ein"},"description":{"label":"Beschreibung der Organisation","placeholder":"Was sind Ihre Ziele mit der Verwendung von Cephable Professional?"},"details":"Details zur Organisation"},"expired":{"user":"Ihre Cephable-Lizenz ist anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version herabgestuft. Um Ihre Lizenz zu verl\xe4ngern, wenden Sie sich bitte an Ihren Organisationsadministrator.","admin":"Ihre Cephable-Lizenz ist anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zur\xfcckgestuft. Bitte verl\xe4ngern Sie Ihre Lizenz, um weiterhin die erweiterten Funktionen nutzen zu k\xf6nnen.","multiple":"Ihre Cephable-Lizenzen sind anscheinend abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zur\xfcckgestuft. Bitte verl\xe4ngern Sie mindestens eine Ihrer Lizenzen, um weiterhin die erweiterten Funktionen \xfcber Cephable Basic hinaus nutzen zu k\xf6nnen.","dialog":{"title":"W\xe4hlen Sie eine Organisation aus","description":"Ihrem Konto sind mehrere Organisationen zugeordnet. W\xe4hlen Sie bitte die Organisation aus, deren Abonnement Sie verl\xe4ngern m\xf6chten."},"title":"Ihre Cephable-Lizenz ist abgelaufen","titlePlural":"Ihre Cephable-Lizenzen sind abgelaufen","banner":"Ihre Cephable-Lizenz ist abgelaufen, daher wurden Sie auf die kostenlose Cephable Basic-Version zur\xfcckgestuft. Mit einer Verl\xe4ngerung erhalten Sie Zugriff auf Funktionen wie erweiterte Sprachsteuerung, KI-gest\xfctzte Aufgaben und viele vordefinierte App-Steuerelemente."},"orgName":"Name der Organisation","menu":{"title":"Organisationsmen\xfc","view":"Men\xfc anzeigen","expand":"Men\xfc erweitern"},"settings":{"title":"Organisationseinstellungen","description":"Verwalten Sie die Abrechnung, den Namen, die Beschreibung und die Ressourcen Ihrer Organisation.","view":"Einstellungen anzeigen","general":{"title":"Allgemein"},"resources":{"edit":"Ressourcen bearbeiten","description":"Verwenden Sie den Markdown-Editor auf der linken Seite, um hilfreiche Ressourcen f\xfcr alle Mitglieder der Organisation zu aktualisieren und zu formatieren. W\xe4hrend Sie tippen, zeigt die Vorschau auf der rechten Seite, wie Ihr Inhalt den Benutzern angezeigt wird. Sie k\xf6nnen \xdcberschriften, Listen, Links und andere Formatierungselemente mit Markdown-Syntax hinzuf\xfcgen. \xc4nderungen sind f\xfcr Mitglieder sichtbar, sobald sie gespeichert wurden."},"other":{"title":"Andere Einstellungen","description":"Verwalten Sie die Abrechnung, den Namen, die Beschreibung und die Ressourcen Ihrer Organisation."},"managed":{"title":"Verwaltet von Cephable","description":"Diese Einstellungen werden von Cephable f\xfcr Ihre Organisation festgelegt. Sie werden hier angezeigt, damit Sie die aktuellen Werte \xfcberpr\xfcfen k\xf6nnen und k\xf6nnen nicht \xfcber das Portal ge\xe4ndert werden.","email":{"title":"Cephable-E-Mail-Zustellung","allowedDescription":"Cephable kann E-Mails an Mitglieder dieser Organisation senden, beispielsweise Einladungen, Best\xe4tigungen und Passwortzur\xfccksetzungen.","blockedDescription":"Cephable sendet keine E-Mails an Mitglieder dieser Organisation. Einladungen, Verifizierungs-E-Mails, Passwort-Resets, Magic Links, Onboarding-E-Mails und Produkt-E-Mails werden unterdr\xfcckt."},"scim":{"title":"Automatische Mitgliederbereitstellung (SCIM)","description":"Ihr Identit\xe4tsanbieter erstellt und entfernt Mitglieder in dieser Organisation. Einladungen k\xf6nnen nicht \xfcber das Portal versendet werden."},"lockedNote":"Nur Cephable kann diese Einstellungen \xe4ndern. Wenden Sie sich an Ihren Cephable-Ansprechpartner, falls ein Wert aktualisiert werden muss."}},"managed":{"title":"Verwaltete Organisation","titlePlural":"Verwaltete Organisationen","description":"Verwaltete Organisationen sind Organisationen, die von einem Cephable-Wiederverk\xe4ufer verwaltet werden. Wiederverk\xe4ufer k\xf6nnen hier Ihr Team, Teamprofile, Abrechnung und mehr verwalten.","error":"Fehler beim Laden verwalteter Organisationen.","empty":{"title":"Keine verwalteten Organisationen gefunden.","description":"Es sieht nicht so aus, als ob es verwaltete Organisationen gibt, die diesen Kriterien entsprechen. Oder Ihre Lizenzschl\xfcssel wurden noch nicht aktiviert."},"titleShort":"Verwaltet"},"canManageChildOrganizations":{"title":"Untergeordnete Organisationen verwalten","description":"Benutzer mit dieser Berechtigung k\xf6nnen als Administrator untergeordnete Organisationen erstellen und verwalten."},"canViewAnalytics":{"title":"Analytics anzeigen","description":"Benutzer mit dieser Berechtigung k\xf6nnen die Metriken und Analysen f\xfcr die Organisation anzeigen."},"create":"Neue Organisation erstellen","orgCustomBillingUrl":{"title":"Benutzerdefinierte Abrechnungs-URL","description":"Dies ist eine benutzerdefinierte URL, die verwendet wird, um den Benutzer zu Ihrem (dem Abrechnungssystem des Wiederverk\xe4ufers) umzuleiten. Sollte mit \u201Ehttps://\u201C oder \u201EmailTo:\u201C beginnen."},"upgrade":{"existing":{"title":"Sie sind Teil einer bestehenden Lizenz.","description":"Bitte f\xfchren Sie ein Upgrade durch, indem Sie im Seitenmen\xfc auf \u201E{{action}}\u201C klicken."}},"restrictions":{"isGenAIDisabled":{"title":"Generative KI deaktiviert","description":"Ihre Organisation hat den Zugriff auf Generative AI-Funktionen deaktiviert. Weitere Informationen erhalten Sie von Ihrem Organisationsadministrator."},"isRemoteControlDisabled":{"title":"Ger\xe4te\xfcbergreifende Synchronisierung deaktiviert","description":"Ihre Organisation hat den Zugriff auf die Synchronisierung deaktiviert. Sie k\xf6nnen unsere Begleit-App nicht verwenden und keine externen Ger\xe4te steuern. Weitere Informationen erhalten Sie von Ihrem Organisationsadministrator."}},"troubleshooting":{"title":"Fehlerbehebung","editorDescription":"[Optional] Dieser Abschnitt ist f\xfcr alle Benutzer \xfcber die Seite mit den Verbindungsdetails sowohl in der mobilen als auch in der Desktop-App von Cephable sichtbar.","description":"Falls Sie Probleme mit Cephable haben, versuchen Sie die folgenden Schritte, um h\xe4ufig auftretende Probleme zu beheben."},"onboarding":{"title":"Onboarding","editorDescription":"[Optional] Nutzern wird ein Onboarding-Fenster angezeigt, wenn dieser Ger\xe4tetyp ihrem Konto hinzugef\xfcgt wird. Hier k\xf6nnen Sie Anweisungen zur Einrichtung und Verwendung des Ger\xe4tetyps mit Ihrer Anwendung bereitstellen."},"documents":"Unterlagen","completionStatus":{"title":"Abschlussstatus","error":"","complete":"Vollst\xe4ndig.","incomplete":"Unvollst\xe4ndig."},"metadata":{"title":"Metadaten","urlError":"Die URL muss mit http:// oder https:// beginnen.","metatitle":{"label":"Meta-Titel","placeholder":"Geben Sie einen Kurztitel ein"},"shortDescription":{"label":"Kurzbeschreibung","placeholder":"Geben Sie eine kurze Vorschaubeschreibung ein (maximal 150 Zeichen)."},"externalLink":{"label":"Externer Link","placeholder":"https://example.com/device-info","description":"Ein direkter Link zu einer externen Website oder Ressource mit weiteren Informationen zur Ersteinrichtung dieses Ger\xe4ts. Wenn Sie diesen Link verwenden, verzichten wir auf die Verwendung des Markdown-Formats f\xfcr die Kundenliste."},"iconUrl":{"label":"URL des Ger\xe4tesymbols","placeholder":"https://example.com/device-icon.png","description":"Ein direkter Link zu einem Bild, das diesen Ger\xe4tetyp darstellt. Dieses Symbol wird in der Cephable-App und in Ger\xe4telisten angezeigt."},"darkModeIconUrl":{"label":"URL des Symbols f\xfcr Ger\xe4te im Dunkelmodus","placeholder":"https://example.com/device-icon-dark.png","description":"Ein direkter Link zu einem Bild, das diesen Ger\xe4tetyp im Dunkelmodus darstellt. Dieses Symbol wird in der Cephable-App und in Ger\xe4telisten angezeigt, wenn der Nutzer den Dunkelmodus aktiviert hat."},"editorDescription":"Wenn Ihr Ger\xe4t in der Cephable-App als Erweiterung oder Verbindung ausgew\xe4hlt wird, verwenden wir diese Informationen, um sie Benutzern anzuzeigen, die neue Verbindungen einrichten."},"client-listing":{"title":"Kundenliste","editorDescription":"Detaillierte Anweisungen f\xfcr neue Benutzer zum Einrichten von Verbindungen mit diesem Ger\xe4tetyp. Dieser Markdown-Inhalt wird in der Cephable-App angezeigt, wenn Benutzer eine neue Verbindung hinzuf\xfcgen."},"canAccessOrganizationProfiles":{"title":"Steuerelemente der Organisations-App anzeigen","description":"Benutzer mit dieser Berechtigung k\xf6nnen die mit dieser Organisation verkn\xfcpften Organisations-App-Steuerelemente anzeigen."},"canEditOrganizationProfiles":{"title":"Verwaltung der App-Steuerelemente der Organisation","description":"Benutzer mit dieser Berechtigung k\xf6nnen Organisations-App-Steuerelemente erstellen, bearbeiten und l\xf6schen, die dieser Organisation zugeordnet sind."},"profiles":{"title":"Steuerelemente der Organisations-App","description":"Organisations-App-Steuerelemente sind gemeinsam genutzte Profile, mit denen Sie App-Steuerelemente innerhalb Ihrer Organisation verteilen oder mit Ihren Integrationsbenutzern teilen k\xf6nnen.","view":"Steuerelemente der Organisations-App anzeigen","editDescription":"Bearbeiten Sie die Steuerelemente der Organisations-App, um die Einstellungen anzupassen.","empty":"Es wurden keine Steuerelemente f\xfcr Organisations-Apps gefunden. Erstellen Sie eine, um loszulegen.","error":"Fehler beim Laden der Steuerelemente der Organisations-App.","titleShort":"App-Steuerelemente"},"canViewAuthClients":{"title":"Projekte ansehen","description":"Benutzer mit dieser Berechtigung k\xf6nnen Authentifizierungsclients und Projekte f\xfcr die Organisation anzeigen."},"governance":{"title":"Governance","orgTitle":"{{value}} Governance","description":"Legen Sie die Leitplanken fest, die Ihr Team bei der Nutzung des Cephable-Assistenten unterst\xfctzen.","automation":{"title":"Automatisierungsregeln","description":"Legen Sie fest, wo Cephable Prozesse automatisieren kann und geben Sie Anweisungen, die sein Verhalten f\xfcr Ihre Organisation pr\xe4gen.","rulesTitle":"Regeln","create":"Automatisierungsregel erstellen","edit":"Automatisierungsregel bearbeiten","created":"Automatisierungsregel erstellt.","updated":"Automatisierungsregel aktualisiert.","deleted":"Automatisierungsregel gel\xf6scht.","loadError":"Automatisierungsregeln konnten nicht geladen werden.","saveError":"Die Automatisierungsregel konnte nicht gespeichert werden.","deleteError":"Die Automatisierungsregel konnte nicht gel\xf6scht werden.","searchPlaceholder":"Suchregeln nach App, Website, Eingabeaufforderung oder Geltungsbereich","promptOnly":"Assistentenunterricht","editorDescription":"W\xe4hlen Sie den Regeltyp aus, geben Sie optional eine App oder Website als Ziel an und f\xfcgen Sie klare Anweisungen f\xfcr Cephable hinzu.","validation":"F\xfcgen Sie eine App oder Website, Anweisungen f\xfcr den Assistenten oder beides hinzu.","appOrDomain":{"label":"App oder Website","helper":"Verwenden Sie einen wiedererkennbaren App-Namen oder eine Domain, wie zum Beispiel Slack, gmail.com oder github.com."},"prompt":{"label":"Anweisungen f\xfcr den Assistenten","helper":"Beschreiben Sie, was Cephable tun sollte oder nicht. Die Anweisungen sollten pr\xe4zise und umsetzbar sein."},"type":{"label":"Regeltyp","block":"Block","allow":"Erlauben"},"scope":{"organization":"Organisationsweit","organizationDescription":"Diese Regel gilt f\xfcr alle aktuellen und zuk\xfcnftigen Mitglieder.","members":"Bestimmte Mitglieder","membersDescription":"Speichern Sie die Regel und weisen Sie sie dann nur den Mitgliedern zu, die sie ben\xf6tigen."},"assign":"Mitglieder zuweisen","delete":{"title":"Automatisierungsregel l\xf6schen?","description":"Damit wird die Regel und alle darauf basierenden Mitgliederzuweisungen endg\xfcltig entfernt."},"empty":{"title":"Noch keine Automatisierungsregeln","description":"Erstellen Sie eine Regel, um die erste Leitlinie f\xfcr Assistenzkr\xe4fte in Ihrer Organisation festzulegen."},"guidance":{"block":{"title":"Beschr\xe4nken Sie Apps und Websites","description":"Verwenden Sie eine Blockregel mit einem App-Namen oder einer Domain, um zu verhindern, dass Cephable mit der App interagiert."},"prompt":{"title":"Assistentenkontext hinzuf\xfcgen","description":"Nutzen Sie die Anweisungen Ihrer Assistenten, um Richtlinien, erforderliche Kontrollen oder sichere Arbeitsweisen zu kommunizieren."},"scope":{"title":"W\xe4hlen Sie das richtige Zielfernrohr","description":"Entweder sollten unternehmensweit gemeinsame Leitplanken gelten oder Ausnahmen auf ausgew\xe4hlte Mitglieder beschr\xe4nkt bleiben."}},"assignment":{"title":"Eine Regel einem Mitglied zuweisen","description":"Verwalten Sie die mitgliederspezifische Zuordnung f\xfcr {{value}}.","memberLabel":"Mitglied","apply":"Regel anwenden","remove":"Regel entfernen","assigned":"Diese Regel wird dem ausgew\xe4hlten Mitglied zugewiesen.","notAssigned":"Diese Regel ist dem ausgew\xe4hlten Mitglied nicht zugewiesen.","applied":"Die Regel gilt f\xfcr das Mitglied.","removed":"Regel f\xfcr Mitglied entfernt.","loadError":"Organisationsmitglieder konnten nicht geladen werden.","statusError":"Die Automatisierungsregeln dieses Mitglieds konnten nicht geladen werden.","saveError":"Die Mitgliederzuordnung konnte nicht aktualisiert werden."}},"tabs":{"automation":"Automatisierungsregeln","permissions":"Erweiterungsberechtigungen","skills":"Organisationsf\xe4higkeiten","connectors":"Org-Verbindungen","usage":"Verwendung"},"extensions":{"permissions":{"orgTitle":"Organisationsweite Richtlinie","orgDescription":"Legen Sie fest, welche Funktionen Mitglieder \xfcber verschiedene F\xe4higkeiten und Konnektoren hinweg aktivieren k\xf6nnen. Diese Einstellungen gelten f\xfcr alle, sofern ein Mitglied keine Ausnahmeregelung weiter unten festgelegt hat.","saved":"Die Organisationsrichtlinien wurden aktualisiert.","saveError":"Die Organisationsrichtlinie konnte nicht aktualisiert werden.","askAdmin":"Bitte wenden Sie sich an Ihren Organisationsadministrator, um dies zu aktivieren.","installBlocked":"Installation fehlgeschlagen.","createBlocked":"Pers\xf6nlicher {{type}} konnte nicht hinzugef\xfcgt werden.","useBlocked":"Dieser {{type}} steht Ihnen nicht mehr zur Verf\xfcgung."},"orgFlags":{"allowPublicSkills":{"title":"\xd6ffentliche F\xe4higkeiten erm\xf6glichen","description":"Mitglieder k\xf6nnen im Cephable-Marktplatz verf\xfcgbare \xf6ffentliche F\xe4higkeiten ver\xf6ffentlichen oder zug\xe4nglich machen."},"allowMemberManagedSkills":{"title":"Pers\xf6nliche F\xe4higkeiten zulassen","description":"Mitglieder k\xf6nnen ihre eigenen pers\xf6nlichen F\xe4higkeiten entwickeln und einsetzen."},"allowPublicMcpServers":{"title":"\xd6ffentliche Verbindungen zulassen","description":"Mitglieder k\xf6nnen \xf6ffentliche Konnektoren, die im Cephable-Marktplatz verf\xfcgbar sind, ver\xf6ffentlichen oder aktivieren."},"allowMemberManagedMcpServers":{"title":"Pers\xf6nliche Verbindungen zulassen","description":"Mitglieder k\xf6nnen ihre eigenen pers\xf6nlichen MCP-Konnektoren erstellen und aktivieren."}},"members":{"title":"\xdcberschreibungen pro Mitglied","description":"Gew\xe4hren Sie einem einzelnen Mitglied die M\xf6glichkeit, externe Kompetenzen und Kontakte zu teilen, zu verwalten oder zu nutzen.","memberLabel":"Mitglied","saved":"Mitgliederberechtigungen aktualisiert.","saveError":"Mitgliedsberechtigungen konnten nicht aktualisiert werden.","loadError":"Organisationsmitglieder konnten nicht geladen werden.","adminNote":"Dieses Mitglied ist ein Organisationsadministrator und verf\xfcgt bereits \xfcber alle Erweiterungsberechtigungen."},"memberFlags":{"canShareSkillsWithOrganization":{"title":"Teilen Sie Ihre F\xe4higkeiten mit der Organisation","description":"Ver\xf6ffentlichen Sie Ihre pers\xf6nlichen F\xe4higkeiten, damit andere Mitglieder diese nutzen k\xf6nnen."},"canManageOrganizationSkills":{"title":"Management-Organisationsf\xe4higkeiten","description":"Mit der Organisation geteilte F\xe4higkeiten erstellen, bearbeiten und entfernen."},"canUseExternalSkills":{"title":"Externe F\xe4higkeiten nutzen","description":"Erm\xf6glichen Sie \xf6ffentliche oder pers\xf6nliche Kompetenzen, auch wenn die Organisation diese einschr\xe4nkt."},"canShareMcpServersWithOrganization":{"title":"Verbinden Sie die Organisation","description":"Ver\xf6ffentlichen Sie pers\xf6nliche Konnektoren, damit andere Mitglieder diese aktivieren k\xf6nnen."},"canManageOrganizationMcpServers":{"title":"Organisationsverbindungen verwalten","description":"Mit der Organisation geteilte Konnektoren erstellen, bearbeiten und entfernen."},"canUseExternalMcpServers":{"title":"Externe Anschl\xfcsse verwenden","description":"Aktivieren Sie \xf6ffentliche oder pers\xf6nliche Konnektoren auch dann, wenn die Organisation diese einschr\xe4nkt."}},"skills":{"title":"Organisationsf\xe4higkeiten","description":"Konfigurieren Sie vorkonfigurierte F\xe4higkeiten f\xfcr Ihre Organisation. Mitglieder k\xf6nnen diese \xfcber ihre Apps entdecken und aktivieren.","create":"F\xe4higkeiten entwickeln","edit":"Bearbeitungsf\xe4higkeit"},"connectors":{"title":"Organisationsverbindungen","description":"Konfigurieren Sie MCP-Konnektoren vorab f\xfcr Ihre Organisation. Mitglieder geben ihre eigenen Anmeldeinformationen auf ihrem Ger\xe4t an, wenn sie einen Konnektor aktivieren.","create":"Anschluss hinzuf\xfcgen","edit":"Konnektor bearbeiten"},"sort":{"label":"Sortieren nach","recent":"Neueste","rating":"H\xf6chste Bewertung","votes":"Die meisten Upvotes","installs":"Die meisten installierten"},"list":{"loadError":"Die Liste konnte nicht geladen werden.","emptyTitle":"Hier ist noch nichts.","emptyDescription":"Erstellen Sie eine, um sie den Mitgliedern Ihrer Organisation zur Verf\xfcgung zu stellen."},"stats":{"rating":"Durchschnittliche Bewertung","installs":"Mitglieder, die dies nutzen","votes":"Abstimmungsergebnis","comments":"Kommentare"},"feedback":{"open":"Bewertungen und Kommentare","description":"Bewertungen und Kommentare werden innerhalb Ihrer Organisation geteilt.","yourRating":"Ihre Bewertung","upvote":"Hochw\xe4hlen","downvote":"Abstimmen","comments":"Kommentare","commentPlaceholder":"Teilen Sie mit, wie dies in Ihrem Team funktioniert\u2026","replyPlaceholder":"Schreiben Sie eine Antwort\u2026","noComments":"Noch keine Kommentare. Diskutieren Sie mit!","member":"Mitglied","deleted":"Dieser Kommentar wurde gel\xf6scht.","reply":"Antwort","loadError":"Kommentare konnten nicht geladen werden.","rateError":"Ihre Bewertung konnte nicht gespeichert werden.","commentError":"Ihr Kommentar konnte nicht ver\xf6ffentlicht werden.","deleteError":"Der Kommentar konnte nicht gel\xf6scht werden."},"usage":{"description":"Sehen Sie nach, welche Mitglieder die einzelnen Organisationsf\xe4higkeiten und Konnektoren aktiviert haben.","skillsTitle":"Fertigkeitsnutzung","connectorsTitle":"Anschlussverwendung","empty":"Bisher hat noch kein Mitglied etwas in dieser Kategorie aktiviert.","installCount":"{{count}} Mitglied(er)","accountWide":"Alle Ger\xe4te","perDevice":"Einzelger\xe4t","unnamed":"Ohne Titel","loadError":"Die Nutzung konnte nicht geladen werden."}}},"canManageGlobalAutomationRules":{"title":"Governance managen","description":"Benutzer mit dieser Berechtigung k\xf6nnen Organisationsautomatisierungsregeln und Mitgliederzuweisungen verwalten."}},"developer":{"title":"Entwickler","titleLong":"Entwicklerressourcen","description":"Cephable kann mit unseren SDKs direkt in Ihre App, Ihr Spiel oder Ihren Dienst integriert werden.","sdk":{"title":"Entdecken Sie unsere SDKs","description":"Wir bieten erstklassige SDKs, die Spracherkennung und adaptive Steuerungen nahtlos in Ihre Anwendungen integrieren. Unsere Tools sind darauf ausgelegt, die Benutzerinteraktion durch intuitive Steuerungen zu verbessern und die Zug\xe4nglichkeit zu f\xf6rdern, sodass Ihre Software von allen Benutzern effektiver bedient werden kann.","javascript":{"title":"JavaScript","subtitle":"Netz","description":"Integrieren Sie Sprach- und adaptive Steuerelemente direkt in Ihre Webanwendungen.","action":"NPM-Paket abrufen"},"net":{"title":".NET","subtitle":"Windows-Anwendungen","description":"Nutzen Sie die Leistungsf\xe4higkeit von .NET, um mit unseren WPF- und WinUI3-SDKs Anwendungen zu erstellen.","actionCore":"Holen Sie sich das Core-Paket","actionWpf":"WPF-Paket Abrufen"},"android":{"title":"Android","subtitle":"Mobile Ger\xe4te","description":"Android-Anwendungen zur Unterst\xfctzung von Sprach- und Kopfbewegungsfunktionen.","action":"Android SDK holen"},"more":{"title":"Mehr","description":"Sie finden nicht, was Sie brauchen? Kontaktieren Sie uns und wir helfen Ihnen.","action":"Fordern Sie ein SDK an"},"docs":{"title":"Dokumentation","description":"Entdecken Sie die detaillierte Dokumentation, Beispielprojekte und Anleitungen, um mit Cephable loszulegen.","action":"Dokumente ansehen"}},"demo":{"title":"Demos","titleLong":"Erleben Sie unsere SDKs in Aktion","description":"Entdecken Sie die Leistungsf\xe4higkeit unserer Technologien zur Sprach- und Kopfbewegungssteuerung anhand unserer Beispielanwendungen. Von interaktiven Spielen bis hin zu dynamischen Web- und Mobil-Apps demonstriert jedes Beispiel die Vielseitigkeit und Effektivit\xe4t unserer SDKs. Sehen Sie sich diese Beispiele an, um Erkenntnisse und Inspirationen f\xfcr die Integration verbesserter Zug\xe4nglichkeit und immersiver Erlebnisse in Ihre eigenen Projekte zu gewinnen.","game":{"title":"2048 Spiel","subtitle":"Netz","description":"Verbessern Sie das traditionelle Gameplay mit adaptiver Sprach- und Kopfbewegungssteuerung.","action":"Spielen Sie das Spiel"},"unity":{"title":"Einheit","subtitle":"Spieleentwicklung","description":"Erfahren Sie, wie adaptive Steuerelemente beim Spielen genutzt werden k\xf6nnen, um eine ansprechendere UX bereitzustellen.","action":"Beispiel abrufen"},"samples":"Dokumente und Beispiele","other":{"title":"Andere Demos","description":"Erleben Sie aus erster Hand, wie Cephable Ihre Anwendung, Ihr Spiel oder Ihr Ger\xe4t verbessern kann.","action":"Weitere Demos anzeigen"},"web":{"title":"Web-SDK-Beispiele","subtitle":"Netz","description":"Unkomplizierte Integration aller unserer Kernfunktionen in Webanwendungen.","action":"Erleben Sie das SDK"},"docs":{"title":"Entwicklerdokumentation und Beispiele","description":"Entdecken Sie die detaillierte Dokumentation, Beispielprojekte und Anleitungen, um mit Cephable loszulegen.","action":"Dokumente ansehen"}},"other":{"title":"Andere Ressourcen","description":"Wenn Sie in unseren SDKs nicht finden, was Sie brauchen, versuchen Sie, direkt mit unseren APIs zu arbeiten, oder wenden Sie sich f\xfcr Hilfe, Inspiration und Unterst\xfctzung an die Community.","api":{"title":"API","description":"Unsere APIs erm\xf6glichen Ihnen die direkte Interaktion mit Cephable. Sie k\xf6nnen unsere APIs verwenden, um benutzerdefinierte Integrationen zu erstellen."},"support":{"title":"Unterst\xfctzung","description":"Sie finden nicht, was Sie brauchen? Kontaktieren Sie unsere Community \xfcber Discord.","action":"Treten Sie Discord bei"}}},"customControls":{"title":"Globale und Ger\xe4testeuerung","prefixDisclaimer":"Dies ist eine Pr\xe4fixsteuerung. Sie \xfcberwacht die W\xf6rter nach dem Befehl und sucht dann in der folgenden Phrase nach \xdcbereinstimmungen.","allowPausedDisclaimer":"Diese Steuerung funktioniert auch, wenn das Mikrofon angehalten ist.","resetControls":{"title":"Steuerelemente zur\xfccksetzen","description":"Ihre Sprachsprache hat sich seit der letzten Aktualisierung Ihrer Steuerung ge\xe4ndert. Hinweis: Dadurch werden Ihre Steuerelemente auf {{language}} zur\xfcckgesetzt und Sie verlieren m\xf6glicherweise alle benutzerdefinierten Befehle. M\xf6chten Sie wirklich zur\xfccksetzen?","confirm":"Ja, Bedienelemente zur\xfccksetzen","error":"Beim Zur\xfccksetzen Ihrer Steuerung ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut."},"conflictIndicators":{"warn":"Achtung:","title":"Eingabekonfigurationskonflikte erkannt","globalControls":"Konflikte bei der globalen Steuerungskonfiguration","deviceControls":"Konfigurationskonflikte bei der Ger\xe4testeuerung","usedInput":"dient als Input f\xfcr","description":"Einige der Eingaben f\xfcr Ihre globalen und Ger\xe4testeuerungen werden auch in einer oder mehreren Ihrer App-Steuerungen verwendet. Dies kann bei der Verwendung von Cephable zu Konflikten f\xfchren. In diesem Fall geben wir der App-Steuerung stets den Vorzug vor der globalen oder Ger\xe4testeuerung.","item":"Die Eingabe <strong>{{value}}</strong> wird in Ihren App-Steuerelementen verwendet: ","globalDescription":"Die folgenden globalen Steuerelemente weisen Eingabekonflikte mit den Steuerelementen Ihrer App auf.","deviceDescription":"Bei den folgenden Ger\xe4testeuerungen treten Eingabekonflikte mit Ihren App-Steuerelementen auf."},"globalControls":{"title":"Globale Steuerelemente","empty":"Sie haben noch keine globalen Steuerelemente. Klicken Sie unten, um eines zu erstellen.","edit":"Globale Steuerelemente bearbeiten","description":"Globale Steuerelemente sind immer verf\xfcgbar, unabh\xe4ngig von der verwendeten App oder dem verwendeten Ger\xe4t. Einige funktionieren sogar, wenn die Mikrofon- oder Kamerasteuerung pausiert ist."},"deviceControls":{"title":"Ger\xe4testeuerung","empty":"Sie haben noch keine Ger\xe4testeuerung. Klicken Sie unten, um eine zu erstellen.","edit":"Ger\xe4testeuerung bearbeiten","controls":{"cephable-open-app":{"success":"App \xf6ffnen: {{value}}","error":"App nicht gefunden: {{value}}"},"cephable-close-app":{"commands":["schlie\xdfen"],"name":"App nach Namen schlie\xdfen","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um eine App auf Ihrem Computer \xfcber ihren Namen zu schlie\xdfen.","success":"App schlie\xdfen: {{value}}","error":"App nicht gefunden: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimieren"],"name":"Minimieren Sie die aktuell fokussierte App.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu minimieren.","success":"Minimieren Sie den Erfolg fokussierter Apps!","error":"Fehler beim Minimieren der fokussierten App."},"cephable-maximize-focused-app":{"commands":["maximieren"],"name":"Maximieren Sie die aktuell fokussierte App.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu maximieren.","success":"Maximieren Sie den gezielten App-Erfolg!","error":"Fehler beim Minimieren der fokussierten App."},"cephable-generate-text":{"commands":["erzeugen"],"name":"Generieren Sie Text, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um entsprechenden Text zu generieren."},"cephable-stop-generate-text":{"commands":["Stoppen Sie die Generierung","Generierung stoppen","Abbrechen Generieren","Generierung abbrechen"],"name":"Stoppen Sie die Textgenerierung.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die Textgenerierung zu stoppen"},"cephable-open-panel":{"commands":["Panel anzeigen"],"name":"\xd6ffnen Sie das Cephable-Bedienfeld","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um das Cephable-Bedienfeld zu \xf6ffnen."},"cephable-close-panel":{"commands":["Bedienfeld ausblenden"],"name":"Verstecken Sie das Cephable-Panel","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um das Cephable-Bedienfeld auszublenden oder zu minimieren."},"cephable-close-focused-app":{"commands":["Strom schlie\xdfen"],"name":"Schlie\xdfen Sie die aktuell fokussierte App.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, um die aktuell fokussierte App zu schlie\xdfen.","success":"Aktuelle App erfolgreich geschlossen!","error":"Fehler beim Schlie\xdfen der aktuellen App."},"cephable-rewrite-text":{"commands":["umschreiben"],"name":"Schreiben Sie den Text neu, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell markierten Text neu zu schreiben."},"cephable-summarize-text":{"commands":["zusammenfassen"],"name":"Fassen Sie den Text zusammen, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell hervorgehobenen Text zusammenzufassen."},"cephable-translate-text":{"commands":["\xfcbersetzen"],"name":"\xdcbersetzen Sie Text, indem Sie die Eingabeaufforderung nach diesem Befehl bereitstellen.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von Ihrer Eingabeaufforderung, um Ihren aktuell markierten Text zu \xfcbersetzen."},"cephable-click-by-name":{"commands":["klopfen","Schlag","Navigieren Sie zu","gehe zu"],"name":"Tippen Sie auf Element nach Name","description":"Tippen Sie auf ein Element auf der Seite anhand seines Namens, z. B. \u201ESpeichern\u201C, um auf die Schaltfl\xe4che \u201ESpeichern\u201C zu klicken. Dies entspricht der Sprachsteuerung mit der Maus; Sie klicken also mit Sprachbefehlen anstatt mit der Maus."},"cephable-automate":{"commands":["automatisieren","versuchen","haben cephable","einen Workflow durchf\xfchren","Arbeit an"],"name":"F\xfchren Sie einen KI-Workflow aus, indem Sie nach diesem Befehl eine Aufgabe beschreiben.","description":"Verwenden Sie diesen Befehl mit Sprachsteuerung, gefolgt von einer Aufgabe, wie z. B. \u201EAutomatisches Senden einer E-Mail an mein Team\u201C, und Cephable f\xfchrt diese als KI-Workflow aus."},"cephable-paste-background-entry":{"commands":["Aktuellen Eintrag einf\xfcgen","letzten Eintrag einf\xfcgen","Letztes Diktat einf\xfcgen","Hintergrundinhalt einf\xfcgen"],"name":"F\xfcgen Sie den aktuellsten Hintergrundinhalt ein.","description":"Mit diesem Befehl k\xf6nnen Sie die neuesten, im Hintergrund gespeicherten Inhalte in die aktuell aktive App einf\xfcgen."}},"description":"Ger\xe4testeuerungen sind an das jeweilige Ger\xe4t oder die Verbindung gebunden, die Sie verwenden. Sie sind verf\xfcgbar, ohne dass Sie sie zu Ihren App-Steuerelementen hinzuf\xfcgen m\xfcssen, und sind besonders n\xfctzlich f\xfcr Funktionen oder Ereignisse, die nur auf bestimmten Ger\xe4ten unterst\xfctzt werden."},"warn":"Das Mikrofon wurde nicht gestartet. Sie m\xfcssen Ihr Mikrofon starten, um globale Steuerelemente und Ger\xe4testeuerungen verwenden zu k\xf6nnen.","changeProfile":{"success":"App-Steuerung \xe4ndern: {{value}}","error":"App-Steuerelemente konnten nicht gefunden werden: \u201E{{value}}\u201C"},"descriptionShort":"Globale und Ger\xe4testeuerungen sind stets verf\xfcgbare Aktionen, die f\xfcr die Nutzung mit jeder Software konzipiert sind. Globale Steuerungen \u2013 wie \u201EKamera stoppen\u201C \u2013 sind systemweit und App-unabh\xe4ngig, w\xe4hrend Ger\xe4testeuerungen auf die jeweilige Ger\xe4teverbindung zugeschnitten sind und erweiterte Funktionen als Standard-App-Steuerungen freischalten.","description":"Globale und Ger\xe4testeuerungen sind jederzeit verf\xfcgbare Aktionen, die f\xfcr die Verwendung mit jeder Software konzipiert sind. Globale Steuerungen \u2013 wie \u201EKamera stoppen\u201C \u2013 gelten systemweit und App-unabh\xe4ngig, w\xe4hrend Ger\xe4testeuerungen auf die jeweilige Ger\xe4teverbindung zugeschnitten sind und erweiterte Funktionen als Standard-App-Steuerungen freischalten. Diese Steuerungen werden derzeit per Sprachsteuerung aufgerufen, zuk\xfcnftig werden wir jedoch auch andere Eingaben unterst\xfctzen.","noDevice":"Dieser Schritt verwendet eine benutzerdefinierte Erweiterung, die Sie noch nicht f\xfcr Ihr Konto konfiguriert haben. F\xfcgen Sie die Erweiterung hinzu, um diesen Schritt freizuschalten."},"notifications":{"title":"Benachrichtigungen","center":"Benachrichtigungscenter","empty":"Sie haben derzeit keine Benachrichtigungen. Versuchen Sie es ein anderes Mal noch einmal.","seen":"Gesehen","markAsRead":"Als gelesen markieren","view":"Alle {{value}}-Benachrichtigungen anzeigen"},"unsaved":{"title":"Sie haben nicht gespeicherte \xc4nderungen.","description":"Sie haben nicht gespeicherte \xc4nderungen. M\xf6chten Sie diese Seite wirklich verlassen?","cancel":"Beenden ohne Speichern","confirm":"Speichern und beenden"},"login":{"welcome":"Willkommen bei Cephable!","subtitle":"Kontrollieren Sie Ihre Technologie nach <strong>Ihren</strong> Bedingungen.","create":"Benutzerkonto erstellen","signIn":"Anmelden","loading":"Weiterleitung zur Anmeldung ...","error":"Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Bitte melden Sie sich erneut an.","existingAccount":"Hast du schon ein Konto?","description":"Steuern. Erstellen. Automatisieren. Cephable \u2013 Ihre pers\xf6nliche KI f\xfcr schnelle Befehle, kontextbezogenes Erstellen von Entw\xfcrfen und vollautomatische Arbeitsabl\xe4ufe. Keine Cloud-Verarbeitung. Nahtlose Unterst\xfctzung, die Sie \xfcberallhin begleitet."},"home":{"title":"Heim","startControls":"Schalten Sie es ein!","manage":"Konfigurieren","profileGenerate":{"title":"Ups. Sieht so aus, als ob Sie noch keine App-Steuerelemente haben.","description":"Damit Cephable Ihren Computer steuern kann, ben\xf6tigen wir Informationen zu Ihren Steuerungsw\xfcnschen. Sie k\xf6nnen App-Steuerelemente von Grund auf neu erstellen oder sich von uns mit unserem Steuerelementgenerator bei der Erstellung unterst\xfctzen lassen."}},"wizard":{"description":"Cephable verwendet diese Informationen dann, um Steuerelemente zu generieren, die Sie \xfcberpr\xfcfen und ausprobieren k\xf6nnen!","includeDefaultKeysQuestion":"Standard-Sprachbefehle f\xfcr Tasten und Mausklicks einschlie\xdfen?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code usw.","noOptionsText":"Beginnen Sie mit der Eingabe, um eine App zu finden, die Sie steuern m\xf6chten","generate":"Steuerelemente generieren","complete":{"title":"Okay, wir sind fertig!","description":"Klicken Sie auf die Schaltfl\xe4che unten, um die von uns generierten Steuerelemente anzuzeigen. Sie k\xf6nnen alle Aspekte manuell bearbeiten, hinzuf\xfcgen oder entfernen, um sie f\xfcr sich zu perfektionieren.","viewControls":"Meine Bedienelemente anzeigen"},"error":{"emptyInput":"Bitte w\xe4hlen Sie mindestens eine Eingabemethode aus","emptyApp":"Bitte geben Sie mindestens einen App-Namen ein","generatingProfile":"Fehler beim Generieren der App-Steuerelemente"},"loading":{"title":"Wir f\xfcgen alle Teile zusammen","description":"Dies kann bis zu einer Minute dauern. Verlassen Sie diese Seite nicht und gehen Sie nicht zur\xfcck, sonst wird die Generierung gestoppt."},"selectedTips":{"title":"Tipp Nr. {{count}}","previous":"Vorheriger Tipp","next":"N\xe4chster Tipp","two":"Sie k\xf6nnen die Empfindlichkeit Ihrer Eingaben im Abschnitt \u201EEinstellungen f\xfcr Ausdruckssteuerung\u201C des Hauptfensters steuern. Auf diese Weise k\xf6nnen Sie die Art und Weise, wie Cephable Ihre Eingaben interpretiert, weiter verfeinern. Und Cephable wird mit der Zeit immer besser, da es mit Ihnen zusammenarbeitet!","three":"Nachdem wir dies eingerichtet haben, haben Sie immer noch die vollst\xe4ndige Kontrolle \xfcber die Konfiguration. Wir geben Ihnen eine Basislinie, aber Sie k\xf6nnen jederzeit die Zuordnung zwischen dem, was Sie tun, und dem, was auf dem Computer geschieht, \xe4ndern.","four":"Sie k\xf6nnen Ihre Steuerelemente ausdrucken, um eine physische Kopie zu haben, w\xe4hrend Sie Cephable verwenden. Wir wissen, dass das alles neu ist und etwas Eingew\xf6hnungszeit erfordert. \xdcbung macht den Meister!","one":"Wussten Sie, dass Sie Cephable auf einem Ger\xe4t verwenden k\xf6nnen, um ein anderes zu steuern? Laden Sie Cephable auf Ihr Handy, Tablet oder sogar einen anderen Computer herunter und w\xe4hlen Sie die Verbindung aus, die Sie steuern m\xf6chten (vielleicht diese hier). Ihre pers\xf6nlichen Profile und Eingabeprofile sind auf allen Ger\xe4ten konsistent! Stellen Sie einfach sicher, dass Cephable auf Ihrem Ger\xe4t und Ihren Verbindungen l\xe4uft."},"steps":{"one":"Schritt 1. Geben Sie den Namen der App ein, die Sie steuern m\xf6chten.","two":"Schritt 2. Best\xe4tigen Sie die Eingabesteuerung, die Sie verwenden m\xf6chten:","three":"Schritt 3. (optional)","threeContinued":"Beschreiben Sie alle spezifischen Aktionen, die Sie f\xfcr Befehle einrichten m\xf6chten, die Sie h\xe4ufig verwenden oder f\xfcr die Sie eine starke Vorliebe haben. Bitte verwenden Sie einfaches Englisch wie die folgenden"},"title":"App-Steuerelemente generieren","titleLong":"Generieren einer App-Steuerung","try":"Probieren Sie den Control Generator aus","placeholder":"Achten Sie darauf, dass die Sprachbefehle kurz sind.\\n\\nIch m\xf6chte \u201EVorw\xe4rts\u201C sagen k\xf6nnen, um zur n\xe4chsten Folie in der Pr\xe4sentation zu gelangen.\\n\\nIch m\xf6chte Kopfbewegungen zum Bewegen des Cursors und Sprachsteuerung f\xfcr Bearbeitungstasten verwenden.\\n\\nSchnellaktionsschaltfl\xe4chen f\xfcr alle Bewegungen und F\xe4higkeiten meiner Figur hinzuf\xfcgen."},"macros":{"title":"Kontrolle","titlePlural":"Bedienelemente","description":"Steuerelemente enthalten eine Eingabe (eine Aktion, die Sie ausf\xfchren, z. B. Ihren Kopf neigen) und Schritte, die Cephable ausf\xfchrt, nachdem diese Eingabeaktion aufgezeichnet wurde. Sie k\xf6nnen Steuerelemente verwenden, um eine Kombination von Schritten zu erstellen, die durch eine einzelne Eingabe ausgel\xf6st werden.","new":"Erstellen eines neuen Steuerelements","newDescription":"Erstellen Sie ein neues Steuerelement, um mehrere Schritte und Eingaben zu kombinieren.","add":"Steuerelement hinzuf\xfcgen","create":"Erstellen eines Steuerelements","name":{"title":"Steuerelementname","question":"Wie m\xf6chten Sie diese Steuerung nennen?","description":"Geben Sie Ihrem Steuerelement einen Namen, damit Sie es sp\xe4ter leicht finden k\xf6nnen.","placeholder":"Aktion, die dieses Steuerelement ausf\xfchrt, z. B. \u201ESpringen\u201C oder \u201EVergr\xf6\xdfern\u201C"},"empty":"Sie haben noch keine Steuerelemente. Klicken Sie unten, um eines zu erstellen.","copySuffix":"{{name}}_kopieren"},"event":{"title":"Schritt","titlePlural":"Vorgehensweise","previewSummaryPlural":"{{first}} und {{total}} weitere Ereignisse","add":"Schritt hinzuf\xfcgen","stepType":"Schritttyp","select":"W\xe4hlen Sie den Schritttyp aus, den Sie hinzuf\xfcgen m\xf6chten.","question":"Welche Art von Aktionen soll Cephable ausf\xfchren?","setup":"Konfigurieren Sie Ihren Step","description":"Schritte sind die Aktionen, die Cephable ausf\xfchrt, nachdem die Eingabe ausgel\xf6st wurde. Sie k\xf6nnen einem Steuerelement mehrere Schritte hinzuf\xfcgen, um eine Kombination von Aktionen zu erstellen.","expand":"Erweitern Sie, um die restlichen Schritte anzuzeigen","stepUp":"Schritt nach oben verschieben","stepDown":"Schritt nach unten verschieben","stepCopy":"Schritt kopieren","stepRemove":"Schritt entfernen","insertStep":"Schritt unten einf\xfcgen","showOptions":"Optionen anzeigen","hideOptions":"Optionen ausblenden","hold":"Haltezeit (in Millisekunden)","error":"Sie m\xfcssen Ihren Schritt konfigurieren.","multiple":"Mehrere Schritte","deviceTypeCustomAction":{"title":"Benutzerdefinierte Ger\xe4teaktion"},"keyPress":{"title":"Dr\xfccken Sie die Taste oder den Knopf","short":"Dr\xfccken","fieldSet":"Zu dr\xfcckende Tasten oder Kn\xf6pfe","label":"Taste oder Knopf","holdTime":"Tastendruckdauer (in Millisekunden)","description":"Dr\xfccken Sie eine Taste auf der Tastatur, ohne die Tastatur zu verwenden.","longDescription":"Diese Funktion simuliert das Dr\xfccken einer Taste auf Ihrer Tastatur. Wenn Sie beispielsweise Schwierigkeiten beim Dr\xfccken physischer Tasten haben, k\xf6nnen Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um eine Taste virtuell zu \u201Edr\xfccken\u201C.","example":"Sagen Sie \u201EEnter\u201C, um eine E-Mail zu senden, ohne die Eingabetaste physisch zu dr\xfccken.","timing":"Tastendruck-Timing","tap":"Klopfen","tapLong":"Tippen Sie auf die Schaltfl\xe4che","latch":"Verriegeln","latchLong":"Halten bis zur Freigabe","hold":"Halten","holdLong":"Halten Sie f\xfcr eine gewisse Zeit","toggle":"Umschalten","toggleLong":"Aktion umschalten","release":"Freigeben","releaseLong":"Aktion freigeben","latchLabel":"<strong>{{value}}</strong> halten, bis es freigegeben wird","tapLabel":"Tippen Sie auf <strong>{{value}}</strong>","pressLabel":"Dr\xfccken Sie <strong>{{value}}</strong> f\xfcr <strong>{{time}}</strong> Millisekunden","remove":"Tastendruck entfernen","add":"Zum Dr\xfccken eine Taste/einen Knopf hinzuf\xfcgen"},"keyRelease":{"title":"Taste oder Knopf zum Loslassen","short":"Freigeben","selected":"Ausgew\xe4hlte Schl\xfcssel zum Loslassen","description":"Lassen Sie eine Taste auf der Tastatur los, die Sie gedr\xfcckt und gehalten haben.","longDescription":"Diese Funktion simuliert das Loslassen einer Taste auf Ihrer Tastatur. Sie sollte in Verbindung mit einem Tastendruck verwendet werden, der auf unbestimmte Zeit gedr\xfcckt gehalten wird. Wenn Sie beispielsweise Schwierigkeiten beim Dr\xfccken physischer Tasten haben, k\xf6nnen Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um eine Taste virtuell \u201Eloszulassen\u201C.","example":"Sagen Sie \u201EStopp\u201C, nachdem Sie \u201EAusf\xfchren umschalten\u201C gesagt haben, um mit dem Laufen aufzuh\xf6ren.","label":"Geben Sie <strong>{{value}}</strong> frei","add":"Schl\xfcssel/Knopf zum Entsperren hinzuf\xfcgen","remove":"Schl\xfcsselfreigabe entfernen"},"keyToggle":{"title":"Umschalttaste oder -knopf","short":"Umschalten","selected":"Ausgew\xe4hlte Tasten zum Umschalten","description":"Schalten Sie eine Taste auf der Tastatur wie einen Lichtschalter mit einem einzigen Steuerelement ein oder aus.","longDescription":"Dadurch wird die Funktion einer Taste wie bei einem Schalter ein- oder ausgeschaltet. Dies ist n\xfctzlich f\xfcr Tasten, die Sie f\xfcr eine unbestimmte Zeit gedr\xfcckt halten m\xf6chten. Sie k\xf6nnen dies verwenden, um die gleiche Aktion sowohl f\xfcr das Dr\xfccken als auch f\xfcr das Loslassen oder Anhalten einer Taste beizubehalten.","example":"Sagen Sie \u201EToggle Run\u201C, um mit dem Laufen zu beginnen. Sagen Sie \u201EToggle Run\u201C, um mit dem Laufen aufzuh\xf6ren.","label":"<strong>{{value}}</strong> umschalten","add":"Taste/Knopf zum Umschalten hinzuf\xfcgen","remove":"Schl\xfcssel entfernen - Umschalter"},"pause":{"title":"Pause","description":"F\xfcgen Sie eine kurze Verz\xf6gerung zwischen den Aktionen hinzu.","longDescription":"Mit dieser Funktion k\xf6nnen Sie eine kurze Verz\xf6gerung zwischen Aktionen einf\xfcgen. Dies ist wichtig, wenn eine Aktion vollst\xe4ndig abgeschlossen sein muss, bevor die n\xe4chste beginnt. Wenn Sie beispielsweise einen Befehl verwenden, um Text in einem Dokument fett zu formatieren, m\xfcssen Sie m\xf6glicherweise zuerst ein Kontextmen\xfc \xf6ffnen. Die Pausenfunktion gibt gen\xfcgend Zeit, damit das Kontextmen\xfc ge\xf6ffnet und aktiviert werden kann, bevor mit dem n\xe4chsten Schritt fortgefahren wird. So wird ein reibungsloser und fehlerfreier Betrieb gew\xe4hrleistet.","example":"Stellen Sie sich vor, Sie bearbeiten ein Dokument mit Sprachbefehlen. Sie sagen \u201EText formatieren\u201C, woraufhin ein Kontextmen\xfc ge\xf6ffnet wird. Dann sagen Sie nach einer kurzen Pause, damit das Men\xfc vollst\xe4ndig angezeigt werden kann, \u201EFett\u201C, um den ausgew\xe4hlten Text fett zu formatieren. Die Pausenfunktion stellt sicher, dass das Kontextmen\xfc bereit ist, Ihren n\xe4chsten Befehl zu empfangen.","label":"Pause f\xfcr <strong>{{value}}</strong> Millisekunden"},"type":{"title":"Typ","field":"Zu tippende Phrase","placeholder":"getippte Phrase","question":"Welchen Text m\xf6chten Sie eingeben?","description":"Schreiben Sie Text wie mit einer Tastatur.","longDescription":"Dies imitiert das Eintippen einer Textzeichenfolge, \xe4hnlich dem Tippen auf einer Tastatur. Es ist ideal, um l\xe4ngere Texte einzugeben, ohne jede Taste dr\xfccken zu m\xfcssen. Wenn Sie Text dynamisch eingeben m\xf6chten, k\xf6nnen Sie stattdessen die Diktierfunktion verwenden.","example":"Sagen Sie \u201EName\u201C, um \u201EHallo, mein Name ist Ellen Ripley.\u201C in ein Chatfenster einzugeben.","label":"Geben Sie <strong>{{value}} ein</strong>"},"mouseMove":{"title":"Bewegen Sie die Maus","description":"Bewegen Sie den Zeiger auf dem Bildschirm.","longDescription":"Bewegen Sie den Cursor oder Zeiger Ihres Bildschirms ohne physische Maus. Dies ist besonders hilfreich f\xfcr Benutzer mit eingeschr\xe4nkter Handbeweglichkeit. Dies ist n\xfctzlich f\xfcr die Feinsteuerung der Mausbewegung, die in einigen Spielen erforderlich ist. Wenn Sie alle Mausbewegungen mithilfe Ihrer Kopfbewegung simulieren m\xf6chten, k\xf6nnen Sie in den Kameraeinstellungen die Option \u201EKopfbewegung zur Maussteuerung\u201C ausprobieren.","example":"Sagen Sie \u201EMaus nach rechts bewegen\u201C, um den Cursor 100 Pixel nach rechts zu bewegen.","moveX":"Maus bewegt sich nach links/rechts um Pixel","numberMoveX":"Anzahl der nach links/rechts zu verschiebenden Pixel","moveY":"Mausbewegung nach oben/unten in Pixeln","numberMoveY":"Anzahl der nach oben/unten zu verschiebenden Pixel","label":"Bewegen Sie die Maus <strong>{{value}}</strong>","command":"Mausbewegung: {{command}}","commandLabel":"Mausbewegung","startCommand":"Mausbewegung starten","stopCommand":"Mausbewegung stoppen"},"joystickMove":{"title":"Joysticks bewegen","description":"Verwenden Sie einen Joystick, um Dinge auf dem Bildschirm zu bewegen.","longDescription":"Diese Funktion simuliert die Bewegung eines Joysticks. Wenn Sie beispielsweise Schwierigkeiten mit der Verwendung eines physischen Joysticks haben, k\xf6nnen Sie einen Sprachbefehl oder eine andere Eingabemethode verwenden, um einen Joystick virtuell zu bewegen.","example":"Sagen Sie \u201EJoystick nach links bewegen\u201C, um den Joystick 100 Pixel nach links zu bewegen.","prefix":"Bewegen Sie den linken Joystick","left":"Linker Joystick","leftX":"Linke X","leftY":"Linke Y","right":"Rechter Joystick","rightX":"Rechte X","rightY":"Rechte Y","x":"St\xe4rke der X-Achse","y":"St\xe4rke der Y-Achse","moveXLabel":"Zug X: {{value}}","moveYLabel":"Y bewegen: {{value}}","labelLeft":"Bewegen Sie den linken Joystick","labelRight":"Bewegen Sie den rechten Joystick","latch":"Latch h\xe4lt die Position, bis Sie sie mit dem Befehl \u201EAlles stoppen\u201C loslassen."},"playAudio":{"title":"Audio abspielen","placeholder":"Aussagesatz, den Cephable sagen wird","description":"Spielen Sie einen Ton, ein Wort oder eine Phrase ab.","longDescription":"Mit dieser Funktion k\xf6nnen Benutzer eingegebene S\xe4tze in gesprochene W\xf6rter umwandeln. Dies ist besonders n\xfctzlich f\xfcr Personen, die m\xf6glicherweise Schwierigkeiten beim Sprechen haben. Wenn Sie einen Satz eingeben, wird der Text mit der PlayAudio-Funktion mithilfe synthetischer Sprache laut ausgesprochen. Dies kann bei der Kommunikation oder in Situationen hilfreich sein, in denen ein Benutzer Informationen m\xfcndlich weitergeben muss, aber eine Alternative zur Verwendung seiner eigenen Stimme bevorzugt oder ben\xf6tigt.","example":"L\xe4cheln Sie, um das Wort \u201EHallo\u201C abzuspielen.","label":"Sprechen Sie <strong>\\"{{value}}\\"</strong>"},"stopOutputs":{"title":"Alle Ausgaben stoppen","titleLong":"Alle Ausgaben stoppen (alle Tasten und Kn\xf6pfe loslassen, alle Mausbewegungen stoppen, alle Eingaben stoppen)","description":"Stoppen Sie alle laufenden Aktionen wie etwa Tastendr\xfccke.","longDescription":"Stoppen Sie sofort alle laufenden Ausgaben oder Aktionen. Dies ist eine Sicherheits- oder Komfortfunktion, um jeden Prozess anzuhalten. Wir erledigen dies automatisch f\xfcr Sie, wenn Sie die Kamera- oder Mikrofonsteuerung schlie\xdfen oder anhalten.","example":"Sagen Sie \u201EStopp\u201C, um alle Ausgaben zu stoppen.","label":"Alle Ausg\xe4nge stoppen und Tasten loslassen"},"custom":{"title":"Brauch"},"options":{"moveUp":"Nach oben","moveDown":"Nach unten","moveLeft":"Nach links bewegen","moveRight":"Nach rechts bewegen","copyStep":"Schritt kopieren","removeStep":"Schritt entfernen"},"directions":{"up":"Hoch","down":"Runter","left":"Links","right":"Rechts"}},"expression":{"title":"Gesichtsausdruck","titlePlural":"Gesichtsausdr\xfccke","label":"Ausdruck / Gestik","start":"Starten Sie die Ausdruckssteuerung","startSmiling":{"title":"Fangen Sie an zu l\xe4cheln","description":"Wenn Sie zun\xe4chst nicht l\xe4cheln und dann anfangen zu l\xe4cheln, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Steuerung zum \xd6ffnen/Schlie\xdfen des Mundes kann zu Konflikten f\xfchren."},"stopSmiling":{"title":"H\xf6r auf zu l\xe4cheln","description":"Wenn Sie l\xe4cheln und dann aufh\xf6ren zu l\xe4cheln, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die Steuerung zum \xd6ffnen/Schlie\xdfen des Mundes kann zu Konflikten f\xfchren."},"eyebrows":{"title":"Augenbrauen hochziehen","description":"Wenn Sie beide Augenbrauen aus Ihrer Ruheposition heben, wird diese Steuerung ausgel\xf6st."},"openMouth":{"title":"Offener Mund","description":"Wenn Ihr Mund geschlossen ist (oder Ihre Grundlinie leicht ge\xf6ffnet ist) und Sie ihn weiter \xf6ffnen, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerelementen wie die L\xe4chelsteuerung kann zu Konflikten f\xfchren."},"closeMouth":{"title":"Mund schlie\xdfen","description":"Wenn Sie Ihren Mund ge\xf6ffnet haben und ihn vollst\xe4ndig schlie\xdfen, wird diese Steuerung ausgel\xf6st. Hinweis: Die Verwendung dieser Steuerung in denselben App-Steuerungen wie die L\xe4chelsteuerung kann zu Konflikten f\xfchren."},"description":"Verbessern Sie Ihr digitales Erlebnis mit Gesichtsausdr\xfccken. Verwenden Sie Gesten wie Augenbrauenheben, L\xe4cheln und andere Bewegungen, um Ihren Mauszeiger nahtlos zu steuern, Aktionen auszuf\xfchren oder Ihre Interaktionen anzupassen."},"head":{"title":"Kopfbewegung","titlePlural":"Kopfbewegungen","label":"Kopf-/K\xf6rperbewegung","question":"Welche Art von Bewegung m\xf6chten Sie verwenden?","tilt":{"title":"Kopfneigung","left":{"title":"Kopf nach links neigen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf nach links neigen, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Kopf nach rechts neigen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf nach rechts neigen, wird diese Steuerung ausgel\xf6st."},"back":{"title":"Kopf nach hinten neigen","description":"Wenn Sie in die Kamera schauen, den Kopf in den Nacken legen und nach oben schauen, wird diese Steuerung ausgel\xf6st."},"forward":{"title":"Kopf nach vorne neigen","description":"Wenn Sie in die Kamera schauen, den Kopf nach vorne neigen und nach unten schauen, wird diese Steuerung ausgel\xf6st."},"description":"Neigen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."},"turn":{"title":"Kopf drehen","left":{"title":"Kopf nach links drehen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf drehen und nach links schauen, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Kopf rechts abbiegen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf drehen und nach rechts schauen, wird diese Steuerung ausgel\xf6st."},"description":"Drehen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."},"lean":{"title":"Kopf schlank","left":{"title":"Kopf nach links neigen","description":"Wenn Sie in die Kamera schauen und sich nach links neigen, sodass Ihr Gesicht weiter links im Kamerarahmen ist, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Kopf nach rechts neigen","description":"Wenn Sie in die Kamera schauen und sich nach rechts neigen, sodass Ihr Gesicht weiter rechts im Kamerarahmen ist, wird diese Steuerung ausgel\xf6st."},"back":{"title":"Kopf nach hinten neigen","description":"Wenn Sie in die Kamera schauen und sich nach hinten lehnen, sodass Ihr Gesicht weiter von der Kamera entfernt ist, wird diese Steuerung ausgel\xf6st."},"forward":{"title":"Kopf nach vorne lehnen","description":"Wenn Sie in die Kamera schauen und sich nach vorne beugen, sodass Ihr Gesicht n\xe4her an der Kamera ist, wird diese Steuerung ausgel\xf6st."},"up":{"title":"K\xf6rper nach oben bewegen","description":"Wenn Sie in die Kamera schauen und Ihren Kopf nach oben bewegen, indem Sie Ihren Hals strecken oder Ihren ganzen K\xf6rper nach oben bewegen, wird diese Steuerung ausgel\xf6st."},"down":{"title":"K\xf6rper nach unten bewegen","description":"Diese Steuerung wird ausgel\xf6st, wenn Sie in die Kamera schauen und Ihren Kopf nach unten bewegen, indem Sie den Hals kr\xfcmmen, sich ducken oder Ihren ganzen K\xf6rper senken."},"center":{"title":"Zentrieren Sie Ihren Kopf","description":"Wenn Sie in die Kamera schauen und Ihren Kopf zur\xfcck in die der Grundlinie entsprechende Mittelposition bewegen, wird diese Steuerung ausgel\xf6st."},"description":"Neigen Sie Ihren Kopf nach links oder rechts, um die Steuerung oder Mausnavigation zu verbessern."},"description":"Steuern Sie Ihr Ger\xe4t oder Ihre Verbindung mit Kopfbewegungen wie Neigen, Nicken oder Drehen. Mithilfe der Kamera Ihres Ger\xe4ts sorgt Cephable f\xfcr ein privates und intuitives Erlebnis mit verbesserter Steuerung oder Mausnavigation."},"voice":{"title":"Sprachsteuerung","titlePlural":"Sprachsteuerung","placeholder":"Stimme oder Satz, auf den Cephable achtet","question":"Welche Aussage oder Phrase m\xf6chten Sie zu diesem Steuerelement sagen?","when":"Wenn ich sage ...","say":"Sagen Sie \'{{value}}\'","load":{"fail":{"title":"{{language}} Sprachsteuerung nicht verf\xfcgbar","description":"Oh nein! {{language}} konnte f\xfcr die Sprachsteuerung nicht geladen werden. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wir verwenden Englisch (USA), bis die Verbindung wiederhergestellt ist."}},"description":"Durch das Einschalten des Mikrofons werden intelligente und nat\xfcrliche Sprachbefehle freigeschaltet, die eine nahtlose Interaktion mit dem Computer \xfcber Anwendungen und Software hinweg erm\xf6glichen. Sprechen Sie nat\xfcrlich, um Befehle auszuf\xfchren oder Text zu diktieren \u2013 f\xfcr ein m\xfcheloses und intuitives Erlebnis."},"motion":{"title":"Bewegungssteuerung","titlePlural":"Bewegungssteuerung","question":"Welche Art der Bewegung mit einem Telefon oder Tablet m\xf6chten Sie verwenden?","start":"Bewegungssteuerung starten","settings":"Bewegungseinstellungen","descriptionShort":"Neigen, drehen oder sch\xfctteln Sie Ihr Ger\xe4t, um Cephable zu steuern.","description":"Mit Bewegungssteuerungen k\xf6nnen Sie die Bewegungen Ihres Telefons oder Tablets in der Companion App in Steuerelemente f\xfcr Ihr Ger\xe4t umwandeln. Neigen oder sch\xfctteln Sie Ihr Telefon in verschiedene Richtungen, um neue Ergebnisse zu erzielen.","up":{"title":"Neigen Sie Ihr Ger\xe4t nach oben","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach oben neigen, sodass Sie es sehen, wird diese Steuerung ausgel\xf6st."},"down":{"title":"Neigen Sie Ihr Ger\xe4t nach unten","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach unten neigen, sodass es von Ihnen weg zeigt, wird diese Steuerung ausgel\xf6st."},"left":{"title":"Neigen Sie Ihr Ger\xe4t nach links","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach links neigen, sodass es nach links zeigt, wird diese Steuerung ausgel\xf6st."},"right":{"title":"Neigen Sie Ihr Ger\xe4t nach rechts","description":"Wenn Ihr Ger\xe4t flach auf einer Oberfl\xe4che liegt und Sie es nach rechts neigen, wird diese Steuerung ausgel\xf6st."},"shake":{"title":"Sch\xfctteln Sie Ihr Ger\xe4t","description":"Wenn Sie Ihr Ger\xe4t sch\xfctteln, wird diese Steuerung ausgel\xf6st."},"edit":{"title":"Bewegungseinstellungen bearbeiten","description":"\xc4ndern Sie Ihre Bewegungssteuerungseinstellungen, um anzupassen, wie weit Sie Ihr Telefon beim Laufen zur Companion App bewegen m\xfcssen","sensitivity":{"title":"Empfindlichkeitseinstellungen f\xfcr die Bewegungssteuerung","description":"Die Empfindlichkeit gibt Cephable an, wie weit Sie Ihr Ger\xe4t neigen m\xfcssen, um eine Steuerung auszul\xf6sen. Je gr\xf6\xdfer der Wert (ganz rechts auf dem Schieberegler), desto h\xf6her ist die Empfindlichkeit und desto weniger m\xfcssen Sie neigen, um die Steuerung auszul\xf6sen."},"tilt":{"title":"Neigungsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihr Ger\xe4t nach oben, unten, links und rechts neigen m\xfcssen, damit eine Eingabe erkannt wird."},"mouse":{"title":"Bewegungssteuerung f\xfcr Mausbewegungen","description":"Legen Sie fest, ob und wie Sie Bewegungssteuerungen zum Bewegen der Maus anstelle von Ausl\xf6sesteuerungen verwenden m\xf6chten","enable":{"title":"Bewegungssteuerung f\xfcr Mausbewegungen aktivieren","description":"Wenn dies aktiviert ist, werden zum Bewegen der Maus einige Ihrer Bewegungssteuerelemente anstelle der Trigger-Steuerelemente verwendet.","option":"Bewegungssteuerung f\xfcr Mausbewegungen verwenden?"},"invert":{"title":"Mausbewegung umkehren","description":"F\xfcr die X-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach links die Maus nach rechts und eine Bewegung nach rechts nach links. F\xfcr die Y-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach unten die Maus nach oben und eine Bewegung nach oben nach unten.","x":"Mausbewegung auf der X-Achse umkehren?","y":"Mausbewegung auf der Y-Achse umkehren?"}}}},"keys":{"title":"Taste oder Knopf","titlePlural":"Tasten oder Kn\xf6pfe","label":"Externe Taste / Knopf","question":"Welche Taste oder Schaltfl\xe4che m\xf6chten Sie dr\xfccken?","edit":"Tasten und Schaltfl\xe4chen bearbeiten","defaultOption":"Standard-Sprachbefehle f\xfcr Tasten und Mausklicks einschlie\xdfen?","description":"Mithilfe von Tasten und Schaltfl\xe4chen k\xf6nnen Sie Ihre verschiedenen Eingabesteuerungen den Tastendr\xfccken auf der Tastatur und dem Controller zuordnen.","then":"Cephable wird dr\xfccken...","empty":"Es sind keine Tastensteuerungen vorhanden, die diesen Kriterien entsprechen.","backspace":"R\xfccktaste","delete":"L\xf6schen","enter":"Eingeben","space":"Leertaste","tab":"Tab","shift":"Schicht","ctrl":"Strg","leftCtrl":"Linke Strg-Taste","rightCtrl":"Rechte Strg-Taste","leftShift":"Linksverschiebung","rightShift":"Rechtsverschiebung","alt":"Alle","leftAlt":"Linke Alt-Taste","escape":"Flucht","up":"Pfeil nach oben","down":"Pfeil nach unten","left":"Pfeil nach links","right":"Pfeil nach rechts","command":"Befehl","caps":"Feststelltaste","reset":{"title":"Tastenbelegung zur\xfccksetzen","confirm":"Alle Tastenbelegungen zur\xfccksetzen?","confirmDescription":"W\xe4hlen Sie aus, wie Sie die Tastenbelegung zur\xfccksetzen m\xf6chten. Diese Aktion kann erst nach dem Speichern r\xfcckg\xe4ngig gemacht werden.","confirmButton":"Tastenbelegung zur\xfccksetzen","defaultOption":"Auf Standardwerte f\xfcr die aktuelle Sprache zur\xfccksetzen","emptyOption":"Auf leeren Zustand zur\xfccksetzen (alle Befehle l\xf6schen)"}},"talkback":{"title":"Talkback","question":"Was m\xf6chten Sie, dass Cephable sagt?","description":"Richten Sie Steuerelemente ein, mit denen Cephable f\xfcr Sie spricht. Sie k\xf6nnen Steuerelemente verschiedenen S\xe4tzen zuweisen, die vorgelesen werden sollen.","thenMacro":"dann wird Cephable sagen ...","empty":"Es gibt keine Talkback-Bedienelemente, die diesem Kriterium entsprechen.","add":"Hinzuf\xfcgen einer neuen Talkback-Steuerung","remove":"Talkback-Steuerung entfernen","edit":"Talkback-Steuerelemente bearbeiten","deprecatedNotice":"Talkback ist jetzt direkt in die prim\xe4ren App-Steuerelemente integriert. Ihre App-Steuerelemente enthalten einige \xe4ltere Talkback-Ereignisse, die aktualisiert werden m\xfcssen."},"dictation":{"title":"Diktat","question":"Welcher Satz soll den Diktiermodus ausl\xf6sen?","thenMacro":"Cephable wird \u2026","empty":"Es gibt keine Diktiersteuerungen, die diesen Kriterien entsprechen.","type":"Typ","edit":"Diktatphrasen bearbeiten","remove":"Diktatphrase entfernen","add":"Neue Diktierphrase hinzuf\xfcgen","on":"Diktat","off":"Befehle","onboarding":{"tourLabel":"Diktat","learn":"Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freih\xe4ndig in Text umwandeln.","welcome":{"title":"Diktat","description":"Mit der Diktierfunktion k\xf6nnen Sie nat\xfcrlich sprechen und Ihre Worte direkt w\xe4hrend des Sprechens abtippen lassen. Es ist, als h\xe4tten Sie einen pers\xf6nlichen Assistenten, der alles tippt, was Sie sagen."},"microphone":{"title":"Schalten Sie Ihr Mikrofon ein","description":"Schalten Sie zun\xe4chst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."},"activate":{"title":"Diktiermodus starten","description":"Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie \u201EDiktat starten\u201C oder klicken Sie auf die Schaltfl\xe4che \u201EDiktieren\u201C. Schalten wir jetzt den Diktiermodus ein."},"speaking":{"title":"Klicken Sie auf ein Dokument oder Feld und beginnen Sie zu sprechen","description":"Die Diktierfunktion gibt Ihre Eindr\xfccke in Echtzeit wieder. Klicken Sie auf ein Textfeld oder Dokument und beginnen Sie zu sprechen. Sagen Sie beispielsweise: \u201ESo verwenden Sie den Diktiermodus.\u201C"},"pauseResume":{"title":"Diktat pausieren","description":"Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach \u201EDiktat pausieren\u201C. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren. Sie k\xf6nnen die Funktion mit Ihren globalen Always-On- und Ger\xe4testeuerungen weiter anpassen."},"stop":{"title":"Diktat stoppen","description":"M\xf6chten Sie zur\xfcck zur App-Steuerung wechseln? Sagen Sie einfach \u201EDiktat beenden\u201C. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zur\xfcck. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren."},"complete":{"title":"Gl\xfcckwunsch!","description":"Das war\'s! Sie k\xf6nnen jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool f\xfcr freih\xe4ndiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen m\xfcssen."}},"description":"Mit der Diktierfunktion k\xf6nnen Sie nat\xfcrlich sprechen und Ihre Worte w\xe4hrend des Sprechens eintippen lassen. Es ist, als h\xe4tten Sie einen pers\xf6nlichen Assistenten, der alles tippt, was Sie sagen.","settings":{"title":"Diktat","description":"Wie die Diktierfunktion funktioniert und was mit Ihren W\xf6rtern passiert, bevor sie abgetippt werden."},"hold":{"enabled":{"option":"Festhalten, um zu diktieren","description":"Halten Sie die unten stehenden Tasten gedr\xfcckt, um mit dem Diktieren zu beginnen. Lassen Sie die Tasten los, um das Gesprochene einzutippen."},"keys":{"title":"Schl\xfcssel zum Halten","description":"Durch Dr\xfccken einer beliebigen anderen Taste w\xe4hrend des Gedr\xfcckthaltens dieser Tasten wird die Aktion abgebrochen, Ihre gewohnten Tastenkombinationen funktionieren also weiterhin."},"duration":{"title":"Haltezeit","description":"Wie lange m\xfcssen die Tasten gedr\xfcckt gehalten werden, bevor die Diktierfunktion startet?"},"transcribing":"Transkribiert...","aiRewriting":"KI-gest\xfctztes Umschreiben...","result":"{{words}} W\xf6rter in {{seconds}}s","resultRewritten":"{{words}} W\xf6rter in {{seconds}}s, KI {{rewriteSeconds}}s","typing":"Tippt...","permission":{"title":"Die Option \\"Diktieren\\" wartet auf Erlaubnis.","description":"Gew\xe4hren Sie Cephable Zugriff unter Systemeinstellungen > Datenschutz & Sicherheit > {{pane}}. Die Funktion \u201EGedr\xfcckt halten zum Diktieren\u201C funktioniert sofort nach der Eingabe."},"unavailable":"Die Tasteneingabe konnte nicht erkannt werden. Starten Sie Cephable neu, um es erneut zu versuchen."},"aiRewrite":{"option":"KI-gest\xfctzte Umschreibung f\xfcr lange Diktate","description":"Bevor l\xe4ngere Diktate abgetippt werden, entfernt die KI auf dem Ger\xe4t automatisch Satzzeichen, F\xfcllw\xf6rter und Korrekturen und formatiert den Text f\xfcr die jeweilige App. Kurze Diktate werden so abgetippt, wie sie gesprochen wurden. Es folgt eine kurze Wartezeit vor dem Tippen."}},"face":{"title":"Gesichtsausdruck","titlePlural":"Gesichtsausdr\xfccke","try":"Probieren Sie die Gesichtsausdrucksteuerung aus","question":"Welche Art von Gesichtsausdruck m\xf6chten Sie verwenden?","descriptionShort":"Verwenden Sie verschiedene Gesichtsbewegungen f\xfcr eine verbesserte Steuerung.","description":"Gesichtsausdr\xfccke sind Teil der Ausdruckssteuerung. Sie erm\xf6glicht Ihnen die Verwendung verschiedener Gesichtsbewegungen f\xfcr erweiterte Steuerungen. Sie k\xf6nnen Augenbrauenbewegungen, Mundbewegungen und mehr verwenden, um unterschiedliche Ergebnisse zu erzielen."},"other":{"title":"Andere","titlePlural":"Andere Bedienelemente","label":"Andere Steuerung","placeholder":"anderer experimenteller Befehl","question":"Welchen zus\xe4tzlichen Befehl m\xf6chten Sie verwenden? Diese sind typischerweise f\xfcr nicht-Cephable-Verbindungen gedacht, die nicht in andere Kategorien passen. Sie k\xf6nnen auch als Sprachbefehle fungieren, wenn Sie das angegebene Wort oder die angegebene Phrase aussprechen. Hinweis: Diese Steuerelemente sind experimentell und werden m\xf6glicherweise nicht vollst\xe4ndig unterst\xfctzt.","description":"Andere Steuerelemente sind experimentell und werden m\xf6glicherweise nicht vollst\xe4ndig unterst\xfctzt. Sie k\xf6nnen f\xfcr nicht-Cephable-Verbindungen oder als Sprachbefehle verwendet werden, wenn Sie das angegebene Wort oder den angegebenen Satz aussprechen."},"support":{"title":"Unterst\xfctzung","profiles":"Einf\xfchrung in App-Steuerelemente","question":"Finden Sie immer noch nicht, was Sie brauchen?","more":"Erfahren Sie mehr auf Cephable.com mit Schritt-f\xfcr-Schritt-Anleitungen, Tutorials, Videos und mehr."},"community":{"title":"Treten Sie der Community bei","description":"Holen Sie sich Unterst\xfctzung, tauschen Sie Ideen aus oder werden Sie Mitglied der Cephable-Communitys.","discord":"Discord-Community","facebook":"Facebook-Gruppe"},"resources":{"title":"Hilfreiche Ressourcen","description":"Finden Sie Antworten auf Ihre Fragen zu den Merkmalen und Funktionen von Cephable.","guides":"Schritt-f\xfcr-Schritt-Anleitungen"},"feedback":{"title":"R\xfcckmeldung","description":"Erz\xe4hlen Sie uns von Ihren Erfahrungen mit Cephable.","contact":"Kontaktieren Sie uns","feature":"Funktion vorschlagen","bug":"Ein Problem melden"},"settings":{"title":"Einstellungen","general":"Allgemeine App-Einstellungen","description":"Dies ist Ihre Leinwand, auf der Sie durch die Feinabstimmung Ihrer Steuerungen Ihr Erlebnis individuell gestalten k\xf6nnen.","orgTitle":"{{ value }}-Einstellungen","advanced":{"title":"Erweiterte Einstellungen","description":"Klicken Sie hier, um erweiterte Einstellungen f\xfcr Ihre KI-Einstellungen, App-Steuerung, Verbindungen, Erweiterungen und mehr zu erhalten."},"quick":"Hier finden Sie die Kontexteinstellungen f\xfcr das Bedienfeld. Nutzen Sie diese, um Ihre aktuelle Benutzererfahrung zu optimieren."},"account":{"title":"Konto","menu":"Nutzermen\xfc","settings":"Kontoeinstellungen","description":"Aktualisieren Sie wichtige Informationen, um mit Cephable in Verbindung zu bleiben.","usernameLabel":"Benutzername:","emailLabel":"E-Mail:","password":{"change":"Kennwort \xe4ndern","description":"Aktualisieren Sie Ihr Passwort, um Ihr Konto zu sch\xfctzen.","old":"Altes Passwort","current":"Ihr aktuelles Passwort","new":"Neues Passwort","desired":"Ihr gew\xfcnschtes neues Passwort","confirm":"Neues Passwort best\xe4tigen","update":"Kennwort aktualisieren"},"isEmailVerified":{"title":"E-Mail ist nicht verifiziert.","description":"Ihre E-Mail wurde nicht best\xe4tigt. Bitte suchen Sie in Ihrem Posteingang nach einem Best\xe4tigungslink.","resend":"E-Mail erneut senden","success":"Wir haben Ihnen eine neue Best\xe4tigungs-E-Mail gesendet.","error":"Beim Senden der Best\xe4tigungs-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter noch einmal.","org":"Ihre E-Mail-Adresse wurde nicht best\xe4tigt. Sie ist f\xfcr den Zugriff auf die Lizenzdaten erforderlich. Bitte \xfcberpr\xfcfen Sie Ihre E-Mail-Adresse auf einen Best\xe4tigungslink.","titleAlt":"Best\xe4tigen Sie Ihre E-Mail-Adresse","descriptionLong":"Willkommen bei Cephable! Eine Best\xe4tigungs-E-Mail wurde an {{email}} gesendet. Bitte \xfcberpr\xfcfen Sie Ihren Posteingang oder Spam-Ordner und klicken Sie auf den Link. Falls Sie ihn nicht sehen, k\xf6nnen Sie die Best\xe4tigungs-E-Mail erneut senden.","appBlock":"Du hast es fast geschafft! Eine Best\xe4tigungs-E-Mail wurde an {{email}} gesendet. Bitte \xfcberpr\xfcfe deinen Posteingang und klicke auf den Link, um deine E-Mail-Adresse zu best\xe4tigen. Solltest du den Link nicht finden, \xfcberpr\xfcfe bitte deinen Spam-Ordner."},"signout":{"title":"Abmelden","question":"M\xf6chten Sie sich wirklich abmelden?","confirm":"Ja, abmelden","warn":{"title":"Sie werden gleich abgemeldet.","description":"Es sieht so aus, als w\xe4ren Sie eine Weile inaktiv gewesen. Aus Sicherheitsgr\xfcnden melden wir Sie in XX Sekunden ab. Wenn Sie angemeldet bleiben m\xf6chten, klicken Sie unten auf \u201EAngemeldet bleiben\u201C.","confirm":"Angemeldet bleiben","cancel":"Jetzt abmelden"},"description":"Sobald Sie sich abmelden, wird diese Verbindung aus Ihrem Konto entfernt und ist in der Companion App oder anderen Verbindungen nicht mehr sichtbar.","confirmDescription":"Sie werden abgemeldet und diese Verbindung wird entfernt"},"marketing":{"title":"E-Mail-Einstellungen","description":"Aktualisieren Sie Ihre E-Mail-Einstellungen, um Updates und Neuigkeiten von Cephable zu erhalten.","marketing":"Marketing-E-Mails","optIn":"Ich m\xf6chte Tutorials, Tipps, Updates und Newsletter erhalten, um mein Cephable-Erlebnis zu verbessern"},"error":{"save":"Fehler beim Speichern der Kontoeinstellungen.","password":"Fehler beim Aktualisieren des Passworts.","signout":"Fehler beim Abmelden.","old":"Altes Passwort ist erforderlich.","new":"Ein neues Passwort ist erforderlich.","match":"Die Passw\xf6rter stimmen nicht \xfcberein.","marketing":"Fehler beim Aktualisieren der E-Mail-Einstellungen.","userPreferences":"Fehler beim Speichern der Benutzereinstellungen."},"success":{"save":"Kontoeinstellungen gespeichert.","password":"Passwort aktualisiert.","marketing":"E-Mail-Einstellungen aktualisiert.","userPreferences":"Benutzereinstellungen aktualisiert."},"userPreferences":{"title":"Benutzereinstellungen","description":"Aktualisieren Sie Ihre Einstellungen, um das f\xfcr Sie passende Cephable-Erlebnis zu schaffen.","warningOptOut":"Warnungen ausblenden, wenn ich App-Steuerelemente speichere oder aktualisiere","enableTranscribeTask":"Aktivieren Sie die experimentelle Dateitranskriptionsaufgabe im Cephable-Panel","enableGamepadSupport":"Aktivieren Sie die Gamepad-Unterst\xfctzung f\xfcr lokale Treiber und Xbox-Controller-Emulation","enableMetrics":"Aktivieren Sie die Ausgabe von Nutzungsmetriken f\xfcr Leistungstests. Sie k\xf6nnen die Protokolle herunterladen.","enableCameraControls":"Aktivieren Sie die Kamerasteuerung im Cephable-Panel.","enableWorkflowRecording":"Aktivieren Sie die Workflow-Vorschau in den Automatisierungs- und KI-Skills."},"delete":{"title":"Konto l\xf6schen","description":"Sie k\xf6nnen Ihr Konto endg\xfcltig l\xf6schen und alle Bez\xfcge zu Ihren pers\xf6nlichen Daten entfernen. Mit der L\xf6schung Ihres Kontos werden Ihre Verbindungen getrennt und funktionieren nicht mehr, sind nicht mehr mit Ihrem Konto verkn\xfcpft und Ihre App-Einstellungen sowie alle weiteren Einstellungen gehen verloren. Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden.","button":"Konto endg\xfcltig l\xf6schen","confirmation":"Sind Sie sicher, dass Sie Ihr Konto l\xf6schen m\xf6chten?","note":"Diese Handlung ist unumkehrbar.","confirm":"Ja, mein Konto l\xf6schen"},"communication":{"title":"Kommunikationseinstellungen"},"name":{"title":"Anzeigename"},"email":{"title":"E-Mail-Adresse","description":"Ihre registrierte E-Mail-Adresse"}},"appSettings":{"description":"Diese Einstellungen gelten nur f\xfcr diese App. Wenn Sie die Einstellungen der Cephable-App auf einem anderen Computer oder Mobilger\xe4t \xe4ndern m\xf6chten, bearbeiten Sie die Einstellungen in dieser App.","autostart":{"title":"Cephable automatisch starten","description":"Wenn diese Einstellung aktiviert ist, wird die Cephable-App automatisch gestartet, wenn Sie sich bei Ihrem Ger\xe4t anmelden. Wenn Sie auch \xfcber automatische Sprach- und Ausdruckssteuerungen verf\xfcgen, werden diese ebenfalls sofort gestartet.","question":"Cephable-App automatisch starten?"},"position":{"topLeft":"Oben links","top":"Oben Mitte","topRight":"Oben rechts","bottom":"Unten Mitte","bottomLeft":"Unten links","bottomRight":"Unten rechts","label":"Befehlsvorschubposition ausw\xe4hlen","description":"W\xe4hlen Sie aus, wo der Befehls-Feed auf Ihrem Bildschirm angezeigt werden soll."},"micPosition":{"title":"Position des Mikrofon-Eingangsfensters","description":"W\xe4hlen Sie aus, wo auf Ihrem Bildschirm die Mikrofonsteuerung f\xfcr Sprache und Diktieren platziert werden soll.","label":"Fensterposition f\xfcr Mikrofoneingang ausw\xe4hlen"},"cameraPosition":{"title":"Position des Kamera-Eingabefensters","description":"W\xe4hlen Sie aus, wo auf Ihrem Bildschirm die Kamerasteuerung f\xfcr Gesichts- und Kopfbewegungen positioniert werden soll.","label":"W\xe4hlen Sie die Position des Kamera-Eingabefensters"},"theme":{"title":"Thema","description":"W\xe4hlen Sie ein Thema, das zu Ihrem Stil passt.","label":"W\xe4hlen Sie ein Thema","light":"Licht","dark":"Dunkel","system":"Verwenden Sie die Betriebssystem-Systemeinstellungen"},"overlay":{"title":"Befehlsfeed","description":"Der Befehlsfeed zeigt die verschiedenen von Ihnen verwendeten Steuerelemente und die an Ihren Computer gesendeten Steuerelemente an. Er ist per Klick erreichbar, wird aber immer \xfcber anderen Fenstern angezeigt. Wenn diese Einstellung aktiviert ist, wird die Cephable-App angezeigt und befindet sich immer \xfcber anderen Fenstern und Anwendungen.","question":"Befehls-Feed anzeigen?"},"transparent":{"title":"Transparenz des Befehlsfeeds","description":"Der Wert bestimmt die Opazit\xe4t des Textes. Je niedriger der Wert, desto durchsichtiger ist der Feed."},"panelAutoHide":{"title":"Cephable-Panel automatisch ausblenden","delay":"Verz\xf6gerung vor dem Verstecken","denominator":"Sekunden","time":"{{value}} Sekunden"},"title":"Allgemeine App-Einstellungen","scale":{"description":"Passen Sie die Textgr\xf6\xdfe in der gesamten App an.","label":"Textgr\xf6\xdfe","small":"Klein","large":"Gro\xdf"},"panelScale":{"description":"Passen Sie die Gr\xf6\xdfe der Schaltfl\xe4che f\xfcr das ausgeblendete Bedienfeld an.","label":"Gr\xf6\xdfe der Bedienfeld-Schaltfl\xe4che"},"aiNewFiles":{"title":"Ordner f\xfcr neue KI-Dateien","description":"W\xe4hlen Sie aus, wo der KI-Agent neue Dateien standardm\xe4\xdfig speichert, sofern Sie keinen bestimmten Speicherort angeben. Wenn die Standardeinstellung beibehalten wird, werden neue Dateien in einem Ordner \u201ECephable-Work\u201C in Ihrem Benutzerordner gespeichert, der bei der ersten Verwendung automatisch erstellt wird.","selectButton":"Ordner ausw\xe4hlen","clearButton":"Standardordner verwenden","current":"Neue Dateien werden gespeichert unter: {{folder}}","default":"Neue Dateien werden im Standardordner \u201ECephable-Work\u201C in Ihrem Benutzerordner gespeichert.","openButton":"Ordner \xf6ffnen","openError":"Der Ordner konnte nicht ge\xf6ffnet werden. Er wurde m\xf6glicherweise verschoben oder gel\xf6scht."},"aiWorkspace":{"title":"AI Workspace-Ordner","description":"W\xe4hlen Sie einen Ordner aus, den der KI-Agent auf dem Ger\xe4t zum Suchen, Lesen und Bearbeiten von Dateien sowie zum Ausf\xfchren von Befehlen verwendet. Standardm\xe4\xdfig hat der Agent Zugriff auf Ihren gesamten Computer.","selectButton":"Ordner ausw\xe4hlen","clearButton":"Den gesamten Computer nutzen","current":"Aktueller Arbeitsbereichsordner:","none":"Es wurde kein Arbeitsbereichsordner ausgew\xe4hlt. Der KI-Agent kann auf Ihren gesamten Computer zugreifen.","restrictQuestion":"Beschr\xe4nken Sie den KI-Agenten auf diesen Ordner.","restrictDescription":"Wenn diese Option aktiviert ist, k\xf6nnen die Datei- und Befehlswerkzeuge des KI-Agenten nichts au\xdferhalb des ausgew\xe4hlten Ordners lesen oder \xe4ndern."},"documentTemplates":{"title":"Dokumentvorlagen","description":"W\xe4hlen Sie eine Vorlagendatei aus, die der KI-Agent beim Erstellen neuer Dokumente verwendet. Belassen Sie den Typ auf der Cephable-Standardeinstellung, um das integrierte Cephable-Design anzuwenden. Word, PowerPoint und Excel verf\xfcgen jeweils \xfcber eine eigene Vorlage.","word":"Word-Vorlage","wordDescription":"Vorlage, die der KI-Agent f\xfcr neue Word-Dokumente (.docx) verwendet.","powerpoint":"PowerPoint-Vorlage","powerpointDescription":"Vorlage, von der der KI-Agent f\xfcr neue PowerPoint-Pr\xe4sentationen (.pptx) ausgeht.","excel":"Excel-Vorlage","excelDescription":"Vorlage, die der KI-Agent f\xfcr neue Excel-Arbeitsmappen (.xlsx) verwendet.","selectButton":"Datei ausw\xe4hlen","clearButton":"Cephable-Standard verwenden","current":"Vorlage: ","default":"Verwendung der integrierten Cephable-Standardvorlage mit Markenstyling."},"automationBrowser":{"title":"Sichtbarkeit des Automatisierungsbrowsers","description":"Wenn der KI-Agent den Cephable-Browser nutzt (Webrecherche, Google Docs/Sheets/Slides, Gmail, Drive), l\xe4uft er normalerweise unbemerkt im Hintergrund, um Sie nicht zu st\xf6ren. Aktivieren Sie diese Option, um die Funktionsweise zu sehen.","question":"Den Automatisierungsbrowser w\xe4hrend der KI-Arbeit anzeigen?"}},"input":{"title":"Eingang","titlePlural":"Eingabesteuerung","explore":"Eingabesteuerung erkunden","descriptionShort":"Entdecken Sie die verschiedenen Eingabesteuerelemente, die Cephable nutzt, um Ihnen ein besseres digitales Erlebnis zu bieten.","typeLabel":"Eingabesteuerungstyp","toolTip":"Dies verwendet {{alt}}","remove":"Eingabesteuerung entfernen","filter":"Filtern nach Eingabetyp","select":"W\xe4hlen Sie einen Eingang","question":"Welchen Eingabetyp m\xf6chten Sie verwenden?","add":"Eingabe hinzuf\xfcgen","addMore":"Einen weiteren Eingang hinzuf\xfcgen","removeItem":"Element entfernen {{index}}","item":"Artikel {{index}}: {{label}}","duplicate":"Doppelte Elemente sind nicht zul\xe4ssig.","maximum":"Maximal {{maxItems}} Elemente zul\xe4ssig.","description":"Eingabesteuerungen sind die verschiedenen Methoden zur Steuerung Ihres Ger\xe4ts. Dazu geh\xf6ren beispielsweise Ihre Stimme, Kopfbewegungen, Gesichtsausdr\xfccke und zus\xe4tzliche Verbindungen. Entdecken Sie unten die verschiedenen Eingabesteuerungen, um mehr zu erfahren."},"time":{"soon":"Demn\xe4chst verf\xfcgbar","now":"Jetzt","today":"Heute","yesterday":"Gestern","minutesAgo":"vor {{count}} Minute","minutesAgo_plural":"vor {{count}} Minuten","daysAgo":"vor {{count}} Tagen","daysAgo_plural":"vor {{count}} Tagen","monthsAgo":"vor {{count}} Monaten","monthsAgo_plural":"vor {{count}} Monaten","yearsAgo":"vor {{count}} Jahr","yearsAgo_plural":"vor {{count}} Jahren","minutesAhead":"in {{count}} Minuten","todayAhead":"sp\xe4ter heute","tomorrow":"morgen","daysAhead":"in {{count}} Tagen","monthsAhead":"in {{count}} Monaten","yearsAhead":"in {{count}} Jahren"},"peripherals":{"empty":"Keine Peripherieger\xe4te erkannt","switch":"Schalten","keyboard":"Tastatur","gamepad":"Gamepad","companionApp":"Begleit-App","available":"Verf\xfcgbar zur Nutzung","error":"\xdcberpr\xfcfen Sie Ihre Einstellungen."},"camera":{"windowTitle":"Cephable-Kamerasteuerung","title":"Kamera","titlePlural":"Kameras","settings":"Kameraeinstellungen","start":"Kamera starten","restart":"Kamera neu starten","descriptionShort":"Erm\xf6glicht Gesichtsausdruck und Kopfbewegungen.","description":"Verwenden Sie Ihre Kamera, um Gesichtsausdr\xfccke und K\xf6rpergesten als verschiedene Steuerelemente zu erkennen.","empty":"Keine Kameras gefunden.","search":"Suche nach Kameranamen","loading":"Kamerasteuerung wird geladen \u2026","error":"Unerwarteter Fehler beim Laden der Kamerasteuerung. Bitte \xfcberpr\xfcfen Sie Ihre Kamera und versuchen Sie es erneut.","manage":{"title":"Klicken Sie hier, um Details zu Ihren Kameras anzuzeigen und zu verwalten.","description":""},"detected":{"face":"Gesicht erkannt.","noFace":"Kein Gesicht erkannt. Bitte passen Sie Ihre Kamera oder Position an und versuchen Sie es erneut.","command":"Erkannt: {{command}}"},"permission":{"title":"Kameraberechtigungen erforderlich","description":"Sie m\xfcssen Cephable die Berechtigung erteilen, Ihre Kamera zu verwenden, um Gesichts- und K\xf6rpersteuerungen zu nutzen.","button":"Berechtigungseinstellungen \xf6ffnen","no":"Kein Kamerazugriff","help":"Cephable ben\xf6tigt Zugriff auf Ihre Kamera, um Mimik und Kopfbewegungen zu steuern. Gehen Sie zu <strong>Systemeinstellungen</strong> &gt; <strong>Datenschutz &amp; Sicherheit</strong> &gt; <strong>{{pane}}</strong> und aktivieren Sie den Kamerazugriff f\xfcr Cephable."},"controls":{"startData":"Aufzeichnung der Gesichtsdaten gestartet. Dr\xfccken Sie im Kamerafenster die Tastenkombination erneut, um die Aufzeichnung und den Download zu stoppen.","downloadData":"Aufzeichnung gestoppt, Daten werden heruntergeladen","paused":"Kamerasteuerung angehalten.","pause":"Kamerasteuerung anhalten","resume":"Kamerasteuerung fortsetzen","resumed":"Kamerasteuerung wieder aufgenommen.","linesOn":"Gesichtslinien einschalten","linesOff":"Gesichtslinien ausschalten","linesToggle":"Zeichnen von Gesichtslinien ein-/ausschalten","noDeviceTitle":"Es wurde keine Kamera erkannt, die mit Cephable verwendet werden kann.","noDeviceDescription":"Sie m\xfcssen eine Kamera anschlie\xdfen, die mit mobilen Apps kompatibel ist.","noDeviceConnectedDescription":"Die Kamerasteuerung dient als Vorschau der Oberfl\xe4che. Es werden keine Schritte erfolgreich ausgef\xfchrt. Verbinden Sie dieses Begleitger\xe4t mit einem anderen, um Befehle auszul\xf6sen.","lines":"Gesichtsfalten"},"switch":{"title":"Kamera wechseln","description":"W\xe4hlen Sie eine andere Kamera zur Gesichts- und K\xf6rperkontrolle aus.","select":"Kamera ausw\xe4hlen","next":"N\xe4chste Kamera","nextLong":"Zur n\xe4chsten Kamera wechseln","empty":"Keine weiteren Kameras gefunden.","search":"Suche nach Kameranamen"},"baseline":{"title":"Ausgangslage","description":"Die Basislinie ist die Standardposition Ihres Gesichts und K\xf6rpers, die Cephable zur Bestimmung Ihrer Bewegungen verwendet. Sie k\xf6nnen die Basislinie hier aktualisieren und zur\xfccksetzen.","update":"Baseline aktualisieren","reset":"Basislinie zur\xfccksetzen","updated":"Baseline aktualisiert","tooltip":"Klicken Sie, um Ihre Basislinie auf Ihre aktuelle Ruheposition zu aktualisieren."},"edit":{"title":"Kameraeinstellungen bearbeiten","description":"Sie k\xf6nnen die Einstellungen f\xfcr Ihre Eing\xe4nge, die eine Kamera erfordern, verfeinern, um sie besser an Ihre Anforderungen anzupassen.","autoStart":{"title":"Kamera automatisch starten","option":"Kamera- und Kopf-/Ausdruckssteuerung automatisch starten?","description":"Ist diese Einstellung aktiviert, startet Ihr Controller die Kamera, sodass Sie Gesichtsausdr\xfccke und Kopfbewegungen direkt beim Start der App steuern k\xf6nnen. Ist diese Einstellung deaktiviert, tippen Sie auf der Verbindungsseite auf die Schaltfl\xe4che \u201EKamera starten\u201C."},"head":{"title":"Kopfbewegungsempfindlichkeit","description":"Die Empfindlichkeit gibt Cephable an, wie weit Sie sich bewegen m\xfcssen, um eine Steuerung auszul\xf6sen. Je gr\xf6\xdfer der Wert (ganz rechts auf dem Schieberegler), desto h\xf6her ist die Empfindlichkeit und desto weniger m\xfcssen Sie sich bewegen, um die Steuerung auszul\xf6sen.","tilt":{"title":"Kopfneigungsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf nach oben, unten, links und rechts neigen m\xfcssen, um Bedienelemente auszul\xf6sen","up":"Neigungsempfindlichkeit","down":"Neigungsempfindlichkeit","left":"Neigungsempfindlichkeit nach links","right":"Neigungsempfindlichkeit nach rechts","scaleHigh":"Leichte Neigung","scaleLow":"Gro\xdfe Neigung"},"turn":{"title":"Kopfdrehempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf nach links und rechts drehen m\xfcssen, um Bedienelemente auszul\xf6sen","left":"Empfindlichkeit f\xfcr Linksabbiegen","right":"Empfindlichkeit f\xfcr Rechtsabbiegen","scaleHigh":"Leichte Wendung","scaleLow":"Gro\xdfe Wende"},"lean":{"title":"Kopfneigungsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf nach vorne und hinten neigen m\xfcssen, um Bedienelemente auszul\xf6sen","forward":"Empfindlichkeit beim Vorw\xe4rtslehnen","back":"Zur\xfccklehnen-Empfindlichkeit","right":"Empfindlichkeit der Neigung nach rechts","left":"Empfindlichkeit f\xfcr Neigung nach links","scaleHigh":"Leichte Neigung","scaleLow":"Gro\xdfes Lean"},"duck":{"title":"Kopfentspannung/Kopfanstiegsempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Kopf beugen oder heben m\xfcssen, um die Steuerung auszul\xf6sen","down":"Empfindlichkeit von Entendaunen","up":"Sensibilit\xe4t steigern","scaleHigh":"Leichte Verschiebung","scaleLow":"Gro\xdfe Verschiebung"}},"face":{"title":"Gesichtsausdrucksempfindlichkeit","description":"Die Empfindlichkeit gibt Cephable an, wie \xfcbertrieben ein Ausdruck sein muss, damit ein Steuerelement ausgel\xf6st wird. Je gr\xf6\xdfer der Wert (ganz rechts auf dem Schieberegler), desto h\xf6her ist die Empfindlichkeit und desto weniger m\xfcssen Sie sich bewegen, um das Steuerelement auszul\xf6sen.","eyebrow":{"title":"Empfindlichkeit der Augenbrauen","description":"Diese Werte bestimmen, wie weit Sie Ihre Augenbrauen heben oder senken m\xfcssen, um die Steuerung auszul\xf6sen","up":"Erh\xf6hen Sie die Empfindlichkeit der Augenbrauen","scaleHigh":"Leichte Erh\xf6hung","scaleLow":"Gro\xdfe Erh\xf6hung"},"mouth":{"title":"Mundempfindlichkeit","description":"Diese Werte bestimmen, wie weit Sie Ihren Mund \xf6ffnen oder schlie\xdfen m\xfcssen, um Bedienelemente auszul\xf6sen","open":"Empfindlichkeit beim \xd6ffnen des Mundes","close":"Empfindlichkeit bei geschlossenem Mund","smile":"L\xe4chelempfindlichkeit","scaleHigh":"Leicht ge\xf6ffnet","scaleLow":"Gro\xdfes offenes","closeScaleHigh":"Leicht geschlossen","closeScaleLow":"Dicht verschlossen","smileScaleHigh":"Leichtes L\xe4cheln","smileScaleLow":"Gro\xdfes L\xe4cheln"}},"mouse":{"title":"Kopfbewegung zur Maussteuerung","description":"Legen Sie fest, ob und wie Sie zum Bewegen der Maus Kopfbewegungssteuerungen verwenden m\xf6chten, anstatt andere Ausgaben auszul\xf6sen.","enable":{"title":"Kopfbewegung f\xfcr Maussteuerung aktivieren","description":"Wenn dies eingeschaltet ist, werden einige Ihrer Kopfbewegungssteuerelemente anstelle der Triggersteuerelemente zum Bewegen Ihrer Maus verwendet.","option":"Kopfsteuerung f\xfcr Mausbewegungen verwenden?"},"input":{"title":"Mauseingabetyp","description":"W\xe4hlen Sie aus, welche Art von Kopfgesten Sie der Maussteuerung zuweisen m\xf6chten. Beispielsweise bedeutet Kopfneigen, dass Sie Ihren Kopf nach links und rechts neigen k\xf6nnen, um die Maus nach links und rechts zu bewegen, Kopfdrehen bedeutet, dass Sie Ihren Kopf nach links und rechts drehen k\xf6nnen, um die Maus zu bewegen, und Kopfneigen bedeutet, dass Sie sich nach links und rechts neigen k\xf6nnen, um die Maus zu bewegen.","option":"Eingabetyp ausw\xe4hlen","optionLong":"W\xe4hlen Sie die Art der Kopfbewegung aus, die Sie zur Steuerung Ihrer Maus verwenden m\xf6chten."},"invert":{"title":"Mausbewegung umkehren","description":"Wenn diese Option aktiviert ist, wird die Richtung, in die Sie Ihren Kopf bewegen, umgekehrt zur Richtung, in die Sie Ihre Maus bewegen. F\xfcr die X-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach links Ihre Maus nach rechts und eine Bewegung nach rechts nach links. F\xfcr die Y-Achse: Wenn diese Option aktiviert ist, bewegt eine Bewegung nach unten Ihre Maus nach oben und eine Bewegung nach oben nach unten.","x":"Mausbewegung auf der X-Achse umkehren?","y":"Mausbewegung auf der Y-Achse umkehren?"},"mode":{"title":"Mausbewegungsmodus","description":"W\xe4hlen Sie aus, wie der Cursor auf Ihre Kopfbewegungen reagieren soll."},"speed":{"title":"Mausgeschwindigkeit","description":"Bestimmen Sie die konstante Geschwindigkeit, mit der sich der Cursor bewegen soll.","fast":"Schnell","slow":"Langsam"},"linear":{"title":"Lineare Mausbewegung","description":"Wenn diese Option aktiviert ist, bewegt sich der Cursor nur in geraden horizontalen oder vertikalen Linien. Dies erleichtert die Navigation in diese spezifischen Richtungen ohne diagonale Abweichungen.","option":"Lineare Mausbewegung verwenden?"},"accelerationRate":{"title":"Reaktionsverz\xf6gerung bei Mausbeschleunigung","description":"Die Anzahl der Millisekunden, die zum Erh\xf6hen der Mausgeschwindigkeit ben\xf6tigt wird."},"accelerationCurve":{"title":"Mausbeschleunigungskurve","description":"Passen Sie die Rate an, mit der die Cursorgeschwindigkeit im Verh\xe4ltnis zur Kopfbewegung zunimmt.","linear":"Linear","exponential":"Exponentiell","sublinear":"Unterlinear"},"maximumSpeed":{"title":"Maximale Mausgeschwindigkeit","description":"Bestimmen Sie die maximale Anzahl an Pixeln, die sich der Cursor pro Sekunde bewegen kann."},"off":{"title":"Aus","description":"Die Mausbewegung ist deaktiviert."},"steadyGlide":{"title":"Gleichm\xe4\xdfiges Gleiten","description":"Wenn Sie Ihren Kopf \xfcber einen bestimmten Punkt hinaus bewegen, gleitet der Cursor kontinuierlich mit gleichm\xe4\xdfiger Geschwindigkeit in diese Richtung."},"speedBoost":{"title":"Geschwindigkeitsschub","description":"Der Cursor bewegt sich schneller, je l\xe4nger Sie Ihren Kopf in einer Position halten. Je l\xe4nger Sie Ihren Kopf still halten, desto schneller beschleunigt der Cursor."},"dynamicGlide":{"title":"Dynamisches Gleiten","description":"Die Geschwindigkeit des Cursors erh\xf6ht sich, je weiter Sie Ihren Kopf bewegen. Je weiter Sie Ihren Kopf bewegen, desto schneller gleitet der Cursor."},"proportionalSpeed":{"title":"Proportionale Geschwindigkeit","description":"Der Cursor folgt Ihrer Nasenspitze proportional zu Ihren Bildschirmabmessungen."},"disabled":"Diese Funktion ist f\xfcr Remote-Verbindungen und Nebenstellen deaktiviert."}},"stop":"Kamera stoppen","show":"Kamera anzeigen","hide":"Kamera ausblenden","warn":"Die Kamerasteuerung wurde nicht gestartet. Starten Sie Ihre Kamera, um die Gesichts- und K\xf6rpersteuerung zu erm\xf6glichen.","draw":{"error":"Fehler beim Laden des Kamera-Feeds. Bitte \xfcberpr\xfcfen Sie Ihre Kamera und versuchen Sie es erneut."},"select":"W\xe4hlen Sie eine Kamera aus, mit der Sie eine Verbindung herstellen m\xf6chten, um erweiterte Steuerfunktionen \xfcber Ihr Gesicht, Ihren K\xf6rper und die Schnellaktionstasten zu erhalten.","extension":{"title":"Erweiterung: Kamera","enabledTitle":"Kamerasteuerung aktivieren","enabledDescription":"Wenn diese Einstellung aktiviert ist, verwendet Cephable Ihre Kamera, um Ihre Gesichts- und Kopfbewegungen zu erkennen, damit Sie Ihr Ger\xe4t mit Mimik und Gestik steuern k\xf6nnen, einschlie\xdflich der Verwendung Ihrer Kopfbewegungen als Maus."},"live":"LIVE","paused":"Kamera angehalten"},"microphone":{"windowTitle":"Cephable-Sprachsteuerung","title":"Mikrofon","titlePlural":"Mikrofone","settings":"Mikrofoneinstellungen","start":"Mikrofon starten","stop":"Mikrofon stoppen","descriptionShort":"Erm\xf6glicht Sprachbefehle und Diktate.","description":"Verwenden Sie Ihr eingebautes Mikrofon, um Sprachsteuerung und Diktieren zu aktivieren.","select":"W\xe4hlen Sie ein Mikrofon aus, das Sie f\xfcr eine erweiterte Steuerung per Sprache koppeln m\xf6chten.","empty":"Keine Mikrofone gefunden.","search":"Suche nach Mikrofonnamen","manage":{"title":"Klicken Sie hier, um Details zu Ihren Mikrofonen anzuzeigen und zu verwalten.","description":""},"permission":{"title":"Mikrofonberechtigungen erforderlich","description":"Um die Sprachsteuerung nutzen zu k\xf6nnen, m\xfcssen Sie Cephable die Berechtigung erteilen, Ihr Mikrofon zu verwenden.","button":"Berechtigungseinstellungen \xf6ffnen","no":"Kein Mikrofonzugriff","help":"Cephable ben\xf6tigt Zugriff auf Ihr Mikrofon, um die Sprachsteuerung nutzen zu k\xf6nnen. Gehen Sie zu <strong>Systemeinstellungen</strong> &gt; <strong>Datenschutz &amp; Sicherheit</strong> &gt; <strong>{{pane}}</strong> und aktivieren Sie dort den Zugriff auf Ihr Mikrofon f\xfcr Cephable."},"controls":{"loadingDetail":"Dies kann einige Minuten dauern.","pause":"Sprachsteuerung pausieren","paused":"Steuerung angehalten.","resume":"Sprachsteuerung fortsetzen","dictationPlay":"Diktiermodus starten","dictationPause":"Diktiermodus beenden","prompt":"Beginnen Sie zu sprechen, um hier Ihre Sprachsteuerung anzuzeigen \u2026","dictationPrompt":"Beginnen Sie zu sprechen, um einzutippen, was Sie sagen m\xf6chten \u2026","latency":"Hohe Latenz erkannt. Schlie\xdfen Sie ggf. einige Anwendungen, die m\xf6glicherweise zu viele Ressourcen verbrauchen.","noDeviceConnectedDescription":"Die Mikrofonsteuerung dient als Vorschau der Oberfl\xe4che. Es werden keine Schritte erfolgreich ausgef\xfchrt. Verbinden Sie dieses Begleitger\xe4t mit einem anderen, um Befehle auszul\xf6sen.","status":{"loadingModel":"Sprachmodell wird geladen \u2026","paused":"Angehalten.","dictating":"Diktieren.","optimistic":"Optimistisch:","listening":"H\xf6ren:","thinking":"Denken...","loadingPhiModel":"Textgenerierungsmodell wird geladen \u2026","generatingText":"Generieren...","preparingPhiModel":"Textgenerierungsmodell wird vorbereitet ...","permission":"Mikrofonberechtigungen werden \xfcberpr\xfcft \u2026","typing":"Tippen..."},"generatingTextDetail":"Stoppen Sie die Generierung, indem Sie Apps \xe4ndern oder \u201EStoppen Sie die Generierung\u201C sagen.","command":"Befehl","contextual":"Kontextuell","send":"Schicken","typedInputLabel":"Geben Sie einen Befehl oder Text zum Senden ein","listeningPlaceholder":"H\xf6ren...","dictationListeningPlaceholder":"H\xf6ren...","pausedPlaceholder":"Die Stimme verstummte..."},"edit":{"title":"Mikrofoneinstellungen bearbeiten","autoStart":{"title":"Automatisches Startmikrofon","option":"Automatisches Startmikrofon","description":"Die Sprachsteuerung wird beim Einschalten des Ger\xe4ts automatisch erkannt. Falls deaktiviert, tippen Sie auf \u201EZuh\xf6ren starten\u201C, um die Funktion zu aktivieren."},"optimistic":{"title":"Optimistische, schnellere Sprachsteuerung","option":"Optimistische, schnellere Sprachsteuerung","description":"Macht die Sprachsteuerung schneller und reaktionsfreudiger, aber weniger fehlertolerant. Verwenden Sie den Standardmodus, wenn Sie Diktierfunktion oder mehr Flexibilit\xe4t w\xfcnschen. Hinweis: Der optimistische Modus kann versehentlich aktiviert werden, wenn Sie Befehle nicht exakt aussprechen."},"confirm":{"title":"Sie haben nicht gespeicherte \xc4nderungen.","description":"Es wurden nicht gespeicherte \xc4nderungen erkannt. M\xf6chten Sie vor dem Beenden speichern?"},"aiCommands":{"title":"Intelligente Sprachbefehle","description":"Sagen Sie Befehle ganz nat\xfcrlich \u2013 Cephable AI erkennt, was Sie meinen, ohne dass eine exakte \xdcbereinstimmung erforderlich ist.","option":"Intelligente Sprachbefehle"},"aiDictation":{"title":"Intelligentes Diktieren und Schnelltippen","description":"Verbesserte Spracherkennung mit automatischer Zeichensetzung, Eigennamen und Satzstruktur. Sagen Sie \u201E[beliebigen Text] eingeben\u201C, um Quick Type f\xfcr eine intelligentere und nat\xfcrlichere Diktierfunktion zu nutzen.","option":"Intelligente Diktierfunktion und Schnelleingabe"},"description":"Verwalten Sie Ihre Sprachbefehle und Diktiereinstellungen f\xfcr diese Verbindung.","input":{"title":"Mikrofon","description":"Die Mikrofon-Sprachsteuerung und Diktierfunktion werden unterst\xfctzt. Cephable merkt sich Ihre Auswahl und schaltet beim n\xe4chsten Verbindungsaufbau automatisch darauf zur\xfcck.","notConnected":"{{name}} (nicht verbunden)","systemDefault":"Systemstandard"}},"warn":"Ihr Mikrofon wurde nicht gestartet. Starten Sie das Mikrofon, um Sprachbefehle und Diktate zu erm\xf6glichen.","devices":{"error":"Mikrofon-Eingabeger\xe4t nicht gefunden."},"startDescription":"Schalten Sie das Mikrofon ein, um mit dem Anh\xf6ren von Befehlen zu beginnen.","context":{"add":"Kontext hinzuf\xfcgen","title":"Kontext hinzuf\xfcgen","highlighted":"Hervorgehobener Text","clipboard":"Klemmbrett","other":"Andere\u2026","otherTitle":"Benutzerdefinierten Kontext hinzuf\xfcgen","otherPlaceholder":"Geben Sie den zu verwendenden Kontext ein oder f\xfcgen Sie ihn ein.","otherConfirm":"Hinzuf\xfcgen","otherCancel":"Stornieren","remove":"Kontext entfernen","required":"F\xfcr {{mode}} ist ein Kontext erforderlich.","files":"Dateien\u2026","folders":"Ordner\u2026","removeAttachment":"Anhang entfernen","dropToAttach":"Ziehen Sie Dateien oder Ordner per Drag & Drop, um sie als Kontext anzuh\xe4ngen.","otherLabel":"Benutzerdefinierter Kontext"}},"localization":{"title":"Spracheinstellungen","titleShort":"Sprache","description":"W\xe4hlen Sie Ihre bevorzugte Sprache aus einer Liste unterst\xfctzter Sprachen aus.","newUserDescription":"Bitte w\xe4hlen Sie eine bevorzugte Sprache aus, bevor Sie fortfahren.","edit":"Sprache aktualisieren","display":{"title":"Anzeigesprache","description":"Sprache, die bei der Verwendung von Cephable angezeigt wird. Dazu geh\xf6ren Dinge wie Men\xfcs, Benachrichtigungen und App-Steuerelemente, die in der Sprache Ihrer Wahl angezeigt werden."},"voice":{"title":"Sprache f\xfcr die Sprachsteuerung","description":"Dies ist die Sprache, die bei der Erkennung von Diktaten und Sprachbefehlen verwendet wird. Durch die Angabe der Sprache wird die Genauigkeit Ihrer Spracheingaben verbessert.","settings":{"title":"Spracherkennung und Anzeigesprache","description":"Passen Sie Ihre Spracheinstellungen f\xfcr Anzeige und Sprachsteuerung an. Mit dieser Option k\xf6nnen Sie Ihre bevorzugten Sprachen f\xfcr Bildschirmtext und Mikrofoninteraktionen wie Sprachsteuerung und Diktierfunktion ausw\xe4hlen."}},"locales":{"en":"English - Englisch","en-us":"English (US) - Englisch (US)","es":"Espa\xf1ol \u2014 Spanisch","fr":"Fran\xe7ais \u2013 Franz\xf6sisch","it":"Italiano \u2013 Italienisch","de":"Deutsch","ja":"\u65E5\u672C\u8A9E - Japanisch","en-gb":"English (UK) - Englisch (UK)","en-in":"English (India) - Englisch (Indien)"},"save":{"success":"Benutzer-Gebietsschemaeinstellungen gespeichert!","error":"Fehler beim Speichern der Gebietsschemaeinstellungen des Benutzers"},"profile":{"view":"Varianten","title":"App-Steuerungssprache","question":"Welche App-Steuerungssprache m\xf6chten Sie bearbeiten?","description":"Einige App-Steuerelemente bieten Varianten f\xfcr verschiedene Sprachen. Wechseln Sie zu einer anderen Sprache, um die Einstellungen zu bearbeiten und anzupassen.","change":"Sprache \xe4ndern"},"unsupported":{"title":"Nicht unterst\xfctzte Sprache {{locale}}","description":"Die ausgew\xe4hlte Sprache wird nicht unterst\xfctzt. Bitte w\xe4hlen Sie eine andere Sprache."},"select":"Sprache ausw\xe4hlen","localesShort":{"en":"Englisch","en-us":"Englisch (USA)","es":"Spanisch","fr":"Franz\xf6sisch","it":"Italienisch","de":"Deutsch","ja":"japanisch","en-gb":"Englisch (UK)","en-in":"Englisch (Indien)"}},"license":{"trial":{"subtitle":"Sie k\xf6nnen {{count}} Kollegen einladen, Cephable mit Ihnen auszuprobieren.","noUsersSubtitle":"Sie haben keine Testbenutzer mehr. Aktualisieren Sie auf eine kostenpflichtige Lizenz, um weitere Benutzer hinzuzuf\xfcgen.","expired":{"user":"Ihr kostenloses Upgrade auf {{productName}} l\xe4uft am {{date}} ab. Um ein Upgrade durchzuf\xfchren, wenden Sie sich bitte an Ihren Organisationsadministrator \u2013 {{admin}}.","admin":"Ihr kostenloses Upgrade auf {{productName}} l\xe4uft am {{date}} ab.","userLong":"Ihr kostenloses Upgrade auf {{productName}} ist abgelaufen. Um ein Upgrade durchzuf\xfchren, wenden Sie sich bitte an Ihren Organisationsadministrator \u2013 {{admin}}.","adminLong":"Ihr kostenloses Upgrade auf {{productName}} ist abgelaufen. Sie k\xf6nnen Ihre Lizenz upgraden, um weiterhin auf erweiterte Funktionen zuzugreifen, die in Cephable Basic nicht verf\xfcgbar sind."},"start":"Kostenlose Testversion starten","title":{"single":"Sie wurden kostenlos auf {{productName}} mit {{days}} verbleibenden Tagen aktualisiert.","multiple":"{{organization}} ist in einer kostenlosen Testversion mit {{days}} verbleibenden Tagen"},"upgrade":"Behalten Sie durch das Upgrade Ihren Zugriff auf Funktionen wie erweiterte Sprachsteuerung, intelligente KI-Aufgaben und viele vorgefertigte App-Steuerungen."},"required":{"title":"Eine Cephable Professional-Lizenz ist erforderlich","description":"Sie verwenden offenbar Cephable Basic. Die kommerzielle Nutzung von Cephable wird jedoch nicht unterst\xfctzt. Bitte aktualisieren Sie auf eine professionelle Lizenz, um die App weiterhin nutzen zu k\xf6nnen."},"upgrade":{"professional":"Upgrade auf die Cephable Professional-Lizenz","generic":{"title":"Verbessern Sie Ihr Cephable-Erlebnis","description":"Die Cephable-Plattform bietet verschiedene Produkte f\xfcr den kommerziellen Einsatz am Arbeitsplatz, in der Schule oder integriert in native L\xf6sungen."},"fallback":{"title":"Fehler beim Laden des Abrechnungsportals","description":"Das Abrechnungsportal konnte nicht geladen werden. Bitte klicken Sie auf die Schaltfl\xe4che unten, um sales@cephable.com zu kontaktieren und mit dem Upgrade fortzufahren."}},"activate":{"question":"Sie haben bereits einen Lizenzschl\xfcssel?","button":"Aktivieren","title":"Lizenzschl\xfcssel Aktivieren","description":"Geben Sie Ihren Lizenzschl\xfcssel ein, um Cephable zu aktualisieren. Wenn Sie keinen haben, starten Sie eine kostenlose Testversion oder erwerben Sie eine Lizenz.","fieldLabel":"Lizenzschl\xfcssel","placeholder":"NkmurBfZzFrmm9Kx","success":"Gl\xfcckwunsch. Ihr Konto wurde auf {{license}} aktualisiert!","invalid":{"key":"Ung\xfcltiger Schl\xfcssel. Bitte stellen Sie sicher, dass Sie den richtigen Schl\xfcssel eingegeben haben.","empty":{"key":"Ung\xfcltiger Schl\xfcssel. Bitte stellen Sie sicher, dass Sie einen Wert eingegeben haben.","name":"Ung\xfcltiger Organisationsname. Bitte stellen Sie sicher, dass Sie einen Wert eingegeben haben."}},"descriptionLong":"Geben Sie Ihren Lizenzschl\xfcssel ein, um Cephable zu aktualisieren. Wenn Sie keinen haben, starten Sie eine kostenlose Testversion oder erwerben Sie eine Lizenz."},"welcome":{"title":"Willkommen bei {{license}}.","description":"Sie sind {{organization}} erfolgreich beigetreten. {{description}}"},"redirect":{"title":"Umleitung","description":"Sie wurden zu einem externen Abrechnungsportal weitergeleitet. In Ihrem Browser wird ein neuer Tab ge\xf6ffnet. Wenn Sie nicht innerhalb weniger Sekunden weitergeleitet werden, klicken Sie bitte auf die Schaltfl\xe4che unten.","error":"Fehler bei der Rechnungsumleitung","external":"Sie wurden weitergeleitet. Bitte \xfcberpr\xfcfen Sie Ihren Browser."},"key":{"title":"Lizenzschl\xfcssel","titlePlural":"Lizenzschl\xfcssel","description":"Ein Lizenzschl\xfcssel ist eine eindeutige Kennung, die zum Gew\xe4hren des Zugriffs auf die Funktionen \u201ECephable Professional\u201C, \u201EEducation\u201C oder \u201EDeveloper\u201C verwendet wird.","details":"Details zum Lizenzschl\xfcssel","assigned":"Verwendet am: {{date}}","expires":"L\xe4uft ab am: {{date}}","assign":"Schl\xfcssel einer neuen Organisation zuweisen","error":"Fehler beim Laden des Lizenzschl\xfcssels.","empty":{"title":"Keine Lizenzschl\xfcssel gefunden.","description":"Es scheint, als g\xe4be es keine Lizenzschl\xfcssel, die diesen Kriterien entsprechen. Oder Sie haben noch keinen Lizenzschl\xfcssel erworben."},"product":{"title":"Kaufen","titleLong":"Lizenzschl\xfcssel kaufen","description":"Erwerben Sie einen Lizenzschl\xfcssel, um das volle Potenzial von Cephable auszusch\xf6pfen. Sehen Sie sich die verschiedenen verf\xfcgbaren Pl\xe4ne und Preisoptionen an.","action":"Jetzt kaufen","empty":{"title":"Keine Produkte gefunden.","description":"Es sieht so aus, als h\xe4tten Sie keine Produkte. Bitte wenden Sie sich an unser Vertriebsteam oder Ihren Vertreter, um das Problem zu l\xf6sen."},"yearly":"J\xe4hrliche Abrechnung","years":"Abrechnung alle {{value}} Jahre","days":"Abrechnung alle {{value}} Tage","Subscription":{"title":"Abonnement"},"MeteredConsumption":{"title":"Gemessener Verbrauch"},"PayDown":{"title":"R\xfcckzahlung"},"OneTime":{"title":"Einmalig"}}},"pro":{"tag":"Pro","detail":"Dies ist eine Funktion, die nur Cephable Professional bietet.","requiredDetail":"F\xfcr diese Funktion ist eine Cephable Professional-Lizenz erforderlich. Sie k\xf6nnen in Ihren Kontoeinstellungen ein Upgrade durchf\xfchren oder eine kostenlose Testversion starten."},"titlePlural":"Lizenzen"},"purchase":"Kaufen","saveError":"Fehler beim Speichern der \xc4nderungen.","description":"Beschreibung","expand":"Expandieren","expandMenu":"Men\xfc erweitern","editor":{"title":"Markdown-Editor","bold":"Deutlich","italic":"Kursiv","underline":"Unterstreichen","hr":"Horizontale Regel","link":"Link","quote":"Zitat","code":"Code","codeBlock":"Codeblock","comment":"Kommentar","image":"Bild","table":"Tisch","unordered-list":"Ungeordnete Liste","ordered-list":"Sortierte Liste","checked-list":"Pr\xfcfliste","help":"Helfen","edit":"Bearbeiten","live":"Live","preview":"Vorschau","fullscreen":"Vollbild","placeholder":"Bitte geben Sie hier Markdown-Text ein ...","strikethrough":"Durchgestrichen"},"created":"Erstellt: {{value}}","updated":"Aktualisiert: {{value}}","deleted":"Gel\xf6scht: {{value}}","expires":"L\xe4uft ab: {{value}}","expired":"Abgelaufen: {{value}}","used":"Verwendet: {{value}}","results":"Ergebnisse","panel":{"title":"Cephable-Panel","question":"Autostart-Panel?","position":{"top":"Spitze","right":"Rechts","left":"Links","bottom":"Unten ","description":"W\xe4hlen Sie aus, wo das Cephable Panel auf Ihrem Bildschirm angezeigt werden soll.","label":"Position"},"sections":{"description":"W\xe4hlen Sie aus, welche Abschnitte im Bedienfeld sichtbar sein sollen. Sie k\xf6nnen Abschnitte nach Ihren W\xfcnschen ausblenden, um den Platz im Bedienfeld optimal zu nutzen.","microphone":"Mikrofon- und Sprachsteuerung","camera":"Kamera- und Gesichts-/Kopfsteuerung","profile":"App-Steuerung und Vorschau","globalControls":"Globale und Ger\xe4testeuerungen","tasks":"Intelligente Aufgaben","buttons":"Schnellaktionsschaltfl\xe4chen"},"titleShort":"Panel","description":"Dies ist das Bedienfeld, das als Hauptsteuerungszentrale dient. Es ist immer sichtbar und erm\xf6glicht Ihnen unter anderem die Steuerung Ihrer Apps per Sprachbefehl.","reconnecting":"Verbindung wird wiederhergestellt\u2026","reconnectRetry":"Wiederholen","modes":{"title":"Modus","generate":{"label":"Erzeugen","placeholder":"Beschreiben Sie, was Sie generieren m\xf6chten."},"rewrite":{"label":"Umschreiben","placeholder":"Wie soll ich den Text umschreiben?"},"translate":{"label":"\xdcbersetzen","placeholder":"In welche Sprache \xfcbersetzen?"},"automate":{"label":"Automatisieren","placeholder":"Beschreiben Sie die Schritte, die Sie automatisieren m\xf6chten."},"auto":{"label":"Auto","placeholder":"Geben Sie etwas ein \u2013 Cephable w\xe4hlt den besten Modus.","upgrade":"Cephable ben\xf6tigt {{tier}}, um diese Aktion auszuf\xfchren."},"control":{"label":"Kontrolle","placeholder":"Geben Sie einen Befehl oder Text zum Senden ein"},"summarize":{"label":"Zusammenfassen","placeholder":"Wie m\xf6chten Sie den Text zusammenfassen oder k\xfcrzen?"}}},"resume":"Wieder aufnehmen","textGeneration":{"settings":"Einstellungen zur Textgenerierung","edit":{"title":"Einstellungen f\xfcr die Textgenerierung bearbeiten","description":"Sie k\xf6nnen die Einstellungen f\xfcr Ihre intelligente Textgenerierung verfeinern, um die f\xfcr Sie besten Ergebnisse zu erzielen.","autoStart":{"title":"Automatisches Aufw\xe4rmen der Textgenerierung","description":"Ist diese Einstellung aktiviert, w\xe4rmt Cephable AI die f\xfcr Erstellungs- oder Automatisierungsaufgaben verwendeten KI-Modelle automatisch auf. Dadurch werden die Modelle schneller ausgef\xfchrt, verbrauchen aber mehr Systemressourcen. Durch Deaktivieren dieser Einstellung werden Ressourcen gespart, die Aufgaben k\xf6nnen jedoch langsamer ausgef\xfchrt werden.","option":"Automatisches Aufw\xe4rmen von KI-Modellen zur Textgenerierung?"},"prompt":{"title":"Zus\xe4tzliche Informationen zur Textgenerierung","description":"Geben Sie zus\xe4tzliche Details ein, die mit der KI von Cephable zur Textgenerierung verwendet werden sollen. Nutzen Sie dieses Feld, um Ihre Pr\xe4ferenzen f\xfcr Ton, Schreibstil oder andere Details einzugeben.","field":"Zus\xe4tzliche Eingabeaufforderung","placeholder":"Verwenden Sie beispielsweise einen freundlichen Ton, schreiben Sie professionell, seien Sie pr\xe4gnant und auf den Punkt. Hinterlassen Sie beim Schreiben von Code durchdachte, aber nicht zu viele Kommentare usw."},"enableTextGen":{"title":"Intelligente Textgenerierung aktivieren","description":"Wenn diese Einstellung aktiviert ist, kann Cephable AI Inhalte entwerfen, umschreiben, zusammenfassen und \xfcbersetzen oder Desktop-Aktionen in Ihren Apps automatisieren.","option":"Intelligente Textgenerierung verwenden?"},"terminate":{"title":"Clear AI Resources","description":"Klicken Sie hier, um die f\xfcr Erstellungs- oder Automatisierungsaufgaben verwendeten Ressourcen freizugeben. Dadurch werden Ressourcen auf Ihrem Computer freigegeben, die Aufgaben k\xf6nnen jedoch beim n\xe4chsten Aufruf langsamer ausgef\xfchrt werden.","button":"Ressourcen l\xf6schen","success":"Ressourcen zur Textgenerierung l\xf6schen.","confirm":{"title":"Clear AI Resources","description":"M\xf6chten Sie wirklich die f\xfcr Erstellungs- oder Automatisierungsaufgaben verwendeten Ressourcen freigeben? Dadurch werden zwar Ressourcen auf Ihrem Computer freigegeben, die Aufgaben k\xf6nnen sich jedoch beim n\xe4chsten Mal verlangsamen.","confirm":"Ja, klare Ressourcen","cancel":"Stornieren"}},"clearModelCache":{"title":"KI-Modell-Cache l\xf6schen","description":"Dadurch wird Speicherplatz auf Ihrem Computer freigegeben und das aktuell ausgew\xe4hlte Modell erneut heruntergeladen.","button":"L\xf6schen und erneut herunterladen","success":"Lokale Modelldateien gel\xf6scht.","confirm":{"title":"KI-Modellcache l\xf6schen und neu herunterladen","description":"M\xf6chten Sie den Cache des KI-Modells wirklich leeren und die Dateien von Ihrem System l\xf6schen? Das aktuell ausgew\xe4hlte Modell wird automatisch erneut heruntergeladen.","confirm":"Ja, l\xf6schen und erneut herunterladen.","cancel":"Stornieren"},"error":"Fehler beim L\xf6schen lokaler Modelldateien."},"enableHistory":{"title":"Textgenerierungsverlauf aktivieren","description":"Wenn diese Einstellung aktiviert ist, verwendet Cephable AI Ihren Textgenerierungsverlauf, um Text im Kontext Ihrer vorherigen Aktion zu generieren.","option":"Textgenerierungsverlauf verwenden?"},"modelSelection":{"title":"KI-Modell","description":"W\xe4hlen Sie die KI-Modellfamilie und -gr\xf6\xdfe, die auf diesem Ger\xe4t ausgef\xfchrt werden kann. Gr\xf6\xdfere Modelle liefern bessere Ergebnisse, ben\xf6tigen aber mehr Ressourcen. Laden Sie mehrere Modelle herunter, um schnell zwischen ihnen wechseln zu k\xf6nnen.","family":"Modellfamilie","size":"Modellgr\xf6\xdfe","downloaded":"Heruntergeladen","downloading":"Wird heruntergeladen\u2026","download":"Herunterladen","delete":"Download l\xf6schen","unavailable":"Auf diesem Ger\xe4t nicht unterst\xfctzt.","requiresBetterDevice":"F\xfcr dieses Modell wird ein leistungsf\xe4higeres Ger\xe4t ben\xf6tigt.","selectPrompt":"W\xe4hlen Sie ein Modell aus","noModels":"F\xfcr dieses Ger\xe4t sind noch keine kompatiblen Modelle verf\xfcgbar.","deleteConfirm":{"title":"Heruntergeladenes Modell l\xf6schen?","description":"Dadurch wird Speicherplatz freigegeben. Sie k\xf6nnen es sp\xe4ter erneut herunterladen."},"notDownloaded":"Dieses Modell ist ausgew\xe4hlt, aber noch nicht heruntergeladen. Klicken Sie auf \u201EHerunterladen\u201C, um es zu verwenden.","readyToUse":"Heruntergeladen \u2013 sofort einsatzbereit","offlineNoModels":"Sie sind offline und es sind noch keine Modelle auf diesem Ger\xe4t gespeichert. Stellen Sie eine Internetverbindung her, um verf\xfcgbare Modelle anzuzeigen und herunterzuladen.","offlineDownloadUnavailable":"Sie sind offline, daher kann dieses Modell nicht heruntergeladen werden. Stellen Sie eine Internetverbindung her, um es herunterzuladen, oder wechseln Sie zu einem bereits heruntergeladenen Modell.","license":{"upgrade":"Erfordert ein Lizenz-Upgrade","blockedNeedsDownload":"F\xfcr dieses Modell ist eine {{license}} erforderlich. Laden Sie ein \xe4lteres Modell herunter oder f\xfchren Sie ein Upgrade durch, um fortzufahren."},"notEnoughSpace":"Nicht gen\xfcgend Speicherplatz auf dem Ger\xe4t","notEnoughSpaceDetail":"Es wird {{required}} ben\xf6tigt, aber auf diesem Ger\xe4t ist nur {{free}} frei. Geben Sie Speicherplatz frei und versuchen Sie es erneut.","fallback":{"alert":"Es wird {{fallback}} anstelle von {{preferred}} verwendet, wof\xfcr ein Upgrade erforderlich ist.","active":"{{preferred}} erfordert {{license}}. {{fallback}} wird stattdessen verwendet, bis Sie ein anderes Modell ausw\xe4hlen oder ein Upgrade durchf\xfchren."}}},"prompt":{"systemPrompt":"Generieren Sie AUSSCHLIESSLICH den angeforderten Text \u2013 keine Erkl\xe4rungen, Kommentare oder sonstige Zus\xe4tze. Kein unaufgefordertes Markdown oder Erl\xe4uterungen. Geben Sie bei Code ausschlie\xdflich den Rohcode aus: keine Codebl\xf6cke, keine Sprachkennzeichnungen, keine Erl\xe4uterungen. Erkl\xe4ren Sie nicht, was Sie getan haben.","appName":"Sie generieren derzeit Text f\xfcr {{appName}}.","userPreferences":"Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}."},"translatePrompt":{"systemPrompt":"\xdcbersetzen Sie den folgenden Text in {{language}}. Geben Sie NUR den \xfcbersetzten Text aus. Keine Erkl\xe4rungen, keine Einleitung, keine Markdown-Formatierung, keine Codebl\xf6cke, keine Anmerkungen, keine Kommentare zur \xdcbersetzung in Klammern. Formatierung beibehalten. F\xfcr Code: Nur Kommentare und Zeichenketten \xfcbersetzen, Syntax exakt beibehalten.","userPreferences":"Beachten Sie diese Benutzereinstellungen hinsichtlich der Textgenerierung: {{userPreferences}}.","genericUserPrompt":"\xdcbersetzen: {{userRequestText}}"},"disabled":{"title":"Intelligente Aufgaben sind deaktiviert","description":"Sie haben anscheinend intelligente Aufgaben deaktiviert. Aktualisieren Sie Ihre Einstellungen, um Textgenerierung, Textumschreibung und weitere Funktionen freizuschalten."},"skipTyping":{"complete":"{{task}} ist abgeschlossen und kann in die Zwischenablage kopiert werden."},"summarizePrompt":{"systemPrompt":"Fassen Sie den bereitgestellten Text pr\xe4gnant zusammen. Er kann Teil eines l\xe4ngeren Dokuments sein. Verwenden Sie keine Markdown-Formatierung oder Codebl\xf6cke. Geben Sie NUR die Zusammenfassung aus \u2013 keine Einleitung, Beschriftungen, Erkl\xe4rungen oder Kommentare. Erl\xe4utern Sie auch nicht, was Sie getan haben.","userPreferences":"Beachten Sie diese Benutzereinstellungen f\xfcr die Textgenerierung: {{userPreferences}}.","summarizeInstructions":"Anleitung: {{summarizeInstructions}}.","userPrompt":"Zusammenfassend: {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"Schreiben oder formatieren Sie den bereitgestellten Text gem\xe4\xdf den Anweisungen um. Bei der Umformatierung (z. B. Listen, Tabellen, Struktur\xe4nderungen) behalten Sie den urspr\xfcnglichen Wortlaut exakt bei. Bei der \xdcberarbeitung (z. B. Tonfall, Stil, L\xe4nge) behalten Sie die Bedeutung, aber nicht unbedingt den Wortlaut. Dies kann Teil eines gr\xf6\xdferen Dokuments sein. Passen Sie die Formatierung der Eingabe an: Wenn der Quelltext bereits Markdown oder Code ist, behalten Sie diese bei. F\xfcgen Sie andernfalls keine Markdown-Formatierung (\xdcberschriften, Fettdruck, Aufz\xe4hlungszeichen, Codebl\xf6cke) hinzu, es sei denn, die Anweisungen fordern ausdr\xfccklich eine Liste, Tabelle oder eine \xe4hnliche Struktur an. Geben Sie NUR das Ergebnis aus \u2013 keine Einleitung, Beschriftungen, \xdcberschriften, Erkl\xe4rungen oder Kommentare.","userPreferences":"Beachten Sie diese Benutzereinstellungen f\xfcr die Textgenerierung: {{userPreferences}}.","rewriteInstructions":"Anweisungen: {{rewriteInstructions}}."}},"profile":{"title":"App-Steuerung","titlePlural":"App-Steuerung","titlePreview":"Vorschau der Steuerelemente","previous":"Vorherige App-Steuerelemente","manage":"App-Steuerelemente verwalten","view":"Steuerelemente anzeigen","edit":"App-Steuerelemente bearbeiten","add":"App-Steuerelemente hinzuf\xfcgen","create":"App-Steuerelemente erstellen","warn":"Um Ihre App-Steuerung verwenden zu k\xf6nnen, m\xfcssen Kamera oder Mikrofon gestartet sein.","descriptionShort":"Entdecken Sie die verschiedenen M\xf6glichkeiten, wie Cephable Ihnen bei der Steuerung Ihrer Ger\xe4te und Software hilft.","name":"App-Name","nameQuestion":"Wie m\xf6chten Sie diese App-Steuerelemente nennen?","newName":"Neue App-Steuerelemente","search":"App-Steuerelemente nach Namen durchsuchen","searchLong":"Suchen Sie nach App-Steuerelementen nach Name oder Beschreibung","keyboardAndMouse":"Tastatur und Maus","genericController":"Gamepad-Controller","keyboardMouseAndController":"Tastatur, Maus und Controller","permissionError":"Sie haben keine Berechtigung, diese App-Steuerelemente zu verwenden.","set":{"title":"Es sieht nicht so aus, als h\xe4tten Sie die App-Steuerung bereits eingerichtet.","cta":"App-Steuerelemente festlegen","empty":{"auto":"Wechseln Sie zu einer anderen App, um die Steuerelemente anzuzeigen","select":"W\xe4hlen Sie ein Steuerelement aus, um zu beginnen","none":"Keine App-Steuerelemente gefunden"},"description":"Mithilfe der App-Steuerung wei\xdf Cephable, worauf es achten muss und welche Aktionen ausgef\xfchrt werden sollen. Sie k\xf6nnen die App-Steuerung jederzeit von der Startseite oder \xfcber Ihre Verbindungseinstellungen \xe4ndern."},"summary":{"title":"Zusammenfassung der App-Steuerelemente","descriptionLong":"Hier sind die Details dieser App-Steuerelemente. Sie k\xf6nnen nach Steuerelementen, Aktionen und mehr suchen, um zu sehen, was Sie mit diesen App-Steuerelementen tun k\xf6nnen.","description":"Erhalten Sie eine Zusammenfassung dieser App-Steuerelemente, einschlie\xdflich der verf\xfcgbaren Steuerelemente, Anpassungsm\xf6glichkeiten, Details und mehr.","view":"Zusammenfassung der App-Steuerelemente anzeigen","filter":"Filtern nach Eingabetyp","placeholder":"Steuerelementnamen suchen ..."},"copy":{"title":"App-Steuerelemente kopieren","duplicate":"Doppelte App-Steuerelemente","question":"Eine Kopie erstellen?","description":"M\xf6chten Sie eine neue Kopie dieser App-Steuerelemente erstellen? Dadurch wird ein neues Fenster mit den kopierten App-Steuerelementen ge\xf6ffnet. Die Kopie wird Ihrem Konto jedoch erst nach dem Speichern hinzugef\xfcgt.","confirm":"Ja, Kopie erstellen","profileSuffix":"{{name}} (Kopie)"},"new":{"title":"Neue App-Steuerelemente erstellen","description":"Entwickeln Sie Steuerelemente von Grund auf neu oder lassen Sie modernste KI personalisierte Steuerelemente erstellen, sodass Sie mithilfe Ihrer Stimme, Ihres Kopfes und Ihrer Gesichtsbewegungen m\xfchelos durch Apps und Software navigieren k\xf6nnen.","note":"Empfohlen f\xfcr fortgeschrittene Benutzer.","scratch":"Von Grund auf neu erstellen"},"advancedOptions":"Erweiterte Steuerungsoptionen","delete":{"title":"App-Steuerelemente l\xf6schen","titleLong":"L\xf6schen Sie diese App-Steuerelemente","description":"Sie k\xf6nnen diese App-Steuerelemente l\xf6schen, indem Sie auf \u201EApp-Steuerelemente l\xf6schen\u201C klicken.","confirm":"M\xf6chten Sie diese App-Steuerelemente wirklich l\xf6schen?","confirmLong":"Sobald Sie diese App-Steuerelemente gel\xf6scht haben, k\xf6nnen Sie nicht mehr darauf zugreifen. M\xf6chten Sie diese App-Steuerelemente wirklich l\xf6schen?","confirmButton":"Ja, diese App-Steuerelemente l\xf6schen"},"current":"Aktuelle Kontrollen","loading":"Steuerelemente werden geladen \u2026","null":"Sie haben noch keine App-Steuerelemente. Klicken Sie unten, um eines zu erstellen.","nullButton":"Erstellen Sie Ihre ersten App-Steuerelemente","preview":"Vorschau","features":"Merkmale","byline_public":"Von: Cephable Team","byline_shared":"Geteilt von: Cephable Community","share":{"title":"App-Steuerelemente teilen","previewTitle":"Vorschau der freigegebenen App-Steuerelemente","description":"Geben Sie diese App-Steuerelemente an andere weiter, damit diese eine Kopie erhalten und diese dann personalisieren k\xf6nnen!","descriptionLong":"Teilen Sie diese App-Steuerelemente mit anderen, damit diese eine Kopie erhalten und sie anschlie\xdfend personalisieren k\xf6nnen! W\xe4hlen Sie aus, wie Sie die App teilen m\xf6chten, und erstellen Sie anschlie\xdfend einen Link zum Senden an andere.","add":"Einen Freigabelink erstellen","confirm":"Teilen Sie diese URL","link":"Link teilen","copy":"Link kopieren","copied":"Kopiert!","usage":"Nutzungsmenge","created":"Erstellt {{value}}","expiration":{"title":"Ablauf","once":"Nur eine Verwendung zulassen","unlimited":"Unbegrenzte Nutzung zulassen","no":"Kein Ablaufdatum","date":"Verfallsdatum","dateDescription":"L\xe4uft an einem bestimmten Datum ab"},"manage":"Vorherige Freigabelinks verwalten","empty":"F\xfcr diese App-Steuerelemente wurden keine Freigaben erstellt."},"swap":{"title":"Steuerelemente austauschen","titleLong":"Tauschen Sie Ihre App-Steuerelemente aus","descriptionShort":"Verwenden Sie unterschiedliche App-Steuerelemente, die zu dem von Ihnen verwendeten Programm oder der Software passen.","description":"Sie k\xf6nnen zwischen verschiedenen App-Steuerelementen wechseln, um sie an das von Ihnen verwendete Programm oder die von Ihnen verwendete Software anzupassen."},"autoProfileSwitching":{"title":"Automatische Steuerungsumschaltung","alerts":{"disabled":"Die automatische Steuerungsumschaltung ist deaktiviert.","temporarilyDisabled":"Die automatische Steuerungsumschaltung ist vor\xfcbergehend deaktiviert.","enabled":"Die automatische Steuerungsumschaltung ist eingeschaltet.","error":"Fehler beim Speichern der Einstellungen f\xfcr die automatische Steuerungsumschaltung"},"associatedPrograms":{"add":"Ein neues zugeh\xf6riges Programm hinzuf\xfcgen","description":{"personal":"W\xe4hlen Sie die Software oder Programme aus, die Sie mit diesen Steuerelementen verbinden m\xf6chten. Dies unterst\xfctzt die automatische Steuerungsumschaltung, bei der Cephable diese App-Steuerelemente automatisch an das aktuell verwendete Programm anpasst.","short":"W\xe4hlen Sie die Software oder Programme aus, die Sie mit diesen Steuerelementen verbinden m\xf6chten."},"edit":"Zugeh\xf6rige Programme bearbeiten","noOptionsText":"Beginnen Sie mit der Eingabe, um zugeh\xf6rige Programme zu finden","profileLabel":"App-Steuerung:","remove":"Zugeh\xf6riges Programm entfernen","title":"Zugeh\xf6rige Programme","when":"Cephable schaltet meine App-Steuerung automatisch auf {{profileName}} um, wenn ich \u2026 verwende.","emptySearch":"Mit diesen Steuerelementen sind keine Programme verkn\xfcpft.","error":"Fehler beim Speichern der zugeh\xf6rigen Programme. Bitte versuchen Sie es sp\xe4ter erneut.","emptyError":"Leeres zugeh\xf6riges Programm erkannt. Bitte entfernen Sie es, bevor Sie fortfahren."},"commandOverlay":{"command":"App-Steuerung wechseln: {{value}}"},"description":"Durch die automatische Steuerungsumschaltung passt sich Cephable nahtlos an Ihren Arbeitsablauf an. Ist die Funktion aktiviert, passt Cephable Ihre App-Steuerung kontextbezogen an das verwendete Programm oder die verwendete Software an. Ist sie deaktiviert, k\xf6nnen Sie die App-Steuerung manuell \xfcber die Schaltfl\xe4che \u201ESteuerung tauschen\u201C oder \xfcber globale Befehle umschalten."},"error":{"noMatch":"Keine App-Steuerung entspricht Ihrer Suche.","load":"Fehler beim Laden der App-Steuerelemente.","add":"Fehler beim Hinzuf\xfcgen der App-Steuerelemente.","delete":"Fehler beim L\xf6schen der App-Steuerelemente.","audioEventsWithEmptyCommands":"In Ihrem Talkback fehlen Steuerelemente. \xdcberpr\xfcfen Sie Ihre Talkback-Steuerelemente, um sicherzustellen, dass sie vollst\xe4ndig sind.","conflicts":"Fehler beim Speichern der App-Steuerelemente aufgrund von Konflikten.","save":"Fehler beim Speichern der App-Steuerung. Bitte versuchen Sie es erneut.","device":"Ung\xfcltige App-Steuerung f\xfcr diese Verbindung. Bitte versuchen Sie es mit einer anderen."},"conflictIndicators":{"errorTitle":"Fehler beim Speichern der App-Steuerelemente aufgrund von Konflikten","warningTitle":"App-Steuerung mit Warnungen gespeichert","subtitle":"Die von Ihnen erstellten App-Steuerelemente weisen einige Konfigurationen auf, die zu Konflikten f\xfchren k\xf6nnen.","profileNameErrors":"Namenskonflikt bei App-Steuerelementen","emptyControlsMapped":"Leere Eingabenamen","emptyControlsMappedDescription":"Bitte f\xfcgen Sie Ihrer Eingabe einen Sprachbefehl, einen Gesichtsausdruck, eine Kopfneigung oder einen anderen Befehl hinzu.","emptyKeybindingControlsMapped":"Leere Eingabenamen f\xfcr Tastenkombinationen","emptyKeybindingControlsMappedDescription":"Bitte f\xfcgen Sie Ihrer Eingabe f\xfcr Tastenkombinationen einen Sprachbefehl, einen Gesichtsausdruck, eine Kopfneigung oder einen anderen Befehl hinzu.","duplicateNameTitle":"Doppelter Name der App-Steuerung","duplicateNameDescription":"Sie verf\xfcgen \xfcber bereits vorhandene App-Steuerelemente mit demselben Namen. Bitte \xe4ndern Sie den Namen, bevor Sie fortfahren.","emptyNameTitle":"Leerer Name der App-Steuerelemente","emptyNameDescription":"Die App-Steuerelemente m\xfcssen einen Namen haben, z. B. Spiel 1, Spotify, Word usw.","macrosReleaseKeysMissingTitle":"Ausgaben mit unver\xf6ffentlichten Schl\xfcsseln","macrosReleaseKeysMissingDescription":"Bitte f\xfcgen Sie einen Freigabeschl\xfcssel hinzu oder stoppen Sie alle Schritte, um zu verhindern, dass Schl\xfcssel h\xe4ngen bleiben.","duplicateInputCommandMacroTitle":"Identische Steuereing\xe4nge","duplicateCommandsDescription":"Bitte entfernen oder \xe4ndern Sie die doppelten Eingabebefehle.","duplicateInputCommandBindingsTitle":"Identische Steuereingaben f\xfcr Tastenkombinationen","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} mit {{commandOrEventType}}","duplicateMacroNames":"Doppelte Steuerelementnamen","duplicateMacroNamesDescription":"Bitte entfernen oder \xe4ndern Sie einen Ihrer identischen Steuerelementnamen.","warningIgnore":"Ignorieren","warningDoNotShowAgain":"Warnungen nicht mehr anzeigen","macrosVoiceCommandConflictWithDictationTitle":"Sprachbefehle genauso steuern wie Diktierschl\xfcsselw\xf6rter","keybindingsVoiceCommandConflictWithDictationTitle":"Tastenkombinationen Sprachbefehle gleich wie Diktierschl\xfcsselw\xf6rter","macrosVoiceCommandConflictWithDictationDescription":"Ihre Spracheingaben l\xf6sen Diktate und Sprachbefehle aus.","keybindingsVoiceCommandConflictWithDictationDescription":"Ihre Spracheingaben l\xf6sen Diktate und Tastendr\xfccke aus.","macrosVoiceCommandConflictWithGenerationTitle":"Sprachbefehle steuern wie Schl\xfcsselw\xf6rter generieren","keybindingsVoiceCommandConflictWithGenerationTitle":"Tastenkombinationen f\xfcr Sprachbefehle sind dieselben wie bei der Generierung von Schl\xfcsselw\xf6rtern","macrosVoiceCommandConflictWithGenerationDescription":"Ihre Spracheingaben l\xf6sen die Generierung und Sprachbefehle aus.","keybindingsVoiceCommandConflictWithGenerationDescription":"Ihre Spracheingaben l\xf6sen die Generierung und Tastendr\xfccke aus.","duplicateAssociatedProgramNames":"Doppelte zugeh\xf6rige Programmnamen","duplicateAssociatedProgramNamesDescription":"Bitte entfernen oder \xe4ndern Sie eines Ihrer identischen verkn\xfcpften Programme.","emptyEvent":{"title":"Fehlende Schritte","description":"In Ihrer Steuerung fehlen Schritte. Dies kann dazu f\xfchren, dass Cephable beim Eingeben eines Befehls keine Aktion ausf\xfchrt."},"warningDetails":"Alle Konflikte anzeigen"},"success":{"save":"App-Steuerung gespeichert.","add":"App-Steuerung hinzugef\xfcgt.","delete":"App-Steuerung gel\xf6scht.","share":"Freigabelink erstellt und in die Zwischenablage kopiert","shareDelete":"Freigabelink gel\xf6scht.","generate":"App-Steuerelemente generiert."},"warning":"App-Steuerung mit Warnungen gespeichert","customize":"App-Steuerelemente anpassen","custom":"{{name}} (Benutzerdefiniert)","description":"App-Steuerelemente sind eine Reihe von Steuerelementen, mit denen Sie Ihr Ger\xe4t oder Ihre Verbindung steuern k\xf6nnen. Sie k\xf6nnen mehrere App-Steuerelemente erstellen und jederzeit zwischen ihnen wechseln."},"publicProfiles":{"toolbar":"App-Steuerelemente erkunden","title":"App-Steuerelemente erkunden","offline":{"title":"\xd6ffentliche App-Steuerelemente k\xf6nnen nicht geladen werden","description":"Offenbar sind Sie offline. Sie k\xf6nnen Ihre App-Steuerelemente weiterhin verwenden, aber keine neuen \xf6ffentlichen App-Steuerelemente laden.","confirm":"Okay"},"announcement":"{{count}} Neue App-Steuerelemente wurden geladen","description":{"personal":"\xd6ffentliche App-Steuerelemente erleichtern Ihnen den schnellen Einstieg in Cephable mit Ihren Lieblings-Apps. Sie k\xf6nnen die Standard-Steuerelemente verwenden, diese an Ihre Bed\xfcrfnisse anpassen oder v\xf6llig neue, benutzerdefinierte App-Steuerelemente erstellen.","pro":"\xd6ffentliche App-Steuerelemente erleichtern Ihnen den schnellen Einstieg in Cephable mit Ihren Lieblings-Apps. Sie k\xf6nnen die Standard-Steuerelemente verwenden, diese an Ihre Bed\xfcrfnisse anpassen oder mit dem Steuerelementgenerator v\xf6llig neue, benutzerdefinierte App-Steuerelemente erstellen."},"team":"Cephable Team"},"publicTag":"\xd6ffentlich","tray":{"panel":"Bedienfeld umschalten","dashboard":"Dashboard anzeigen","quit":"Cephable beenden"},"generate":"Erzeugen","stop":"Stoppen","clear":"Klar","rewrite":"Umschreiben","translate":"\xdcbersetzen","smartTasks":{"title":"Intelligente Aufgaben","show":"Intelligente Aufgaben anzeigen","description":"Intelligente Aufgaben sind die verschiedenen Aufgaben, die die KI von Cephable f\xfcr Sie erledigen kann. Diese Aufgaben werden durch die KI auf dem Ger\xe4t unterst\xfctzt und k\xf6nnen zum Erstellen von Texten, Zusammenfassen, Umschreiben, \xdcbersetzen, Notieren und Chatten mit Dokumenten verwendet werden.","generateText":{"title":"Text generieren","description":"Erstellen Sie Textinhalte basierend auf Ihren Eingaben oder Aufforderungen.","label":"Beschreiben Sie, was Sie generieren m\xf6chten"},"summarizeText":{"title":"Text zusammenfassen","description":"Sammeln Sie Erkenntnisse aus l\xe4ngeren Texten und erstellen Sie kurze Zusammenfassungen oder Kernaussagen.","directions":"Geben Sie den zusammenzufassenden Text ein, andernfalls verwendet Cephable automatisch den von Ihnen markierten Text.","write":"Zusammenfassung schreiben","outputLabel":"Ihre Zusammenfassung wird hier angezeigt.","inputLabel":"Geben Sie den zu k\xfcrzenden Text ein"},"rewriteText":{"title":"Text neu schreiben","description":"Markieren Sie den Text, in dem Sie schreiben, in einer anderen App, und kehren Sie dann hierher zur\xfcck und beschreiben Sie, wie er neu geschrieben werden soll.","label":"Beschreiben Sie, wie Sie den Text umschreiben m\xf6chten","inputLabel":"Geben Sie den umzuschreibenden Text ein"},"translateText":{"title":"Text \xfcbersetzen","description":"Geben Sie den zu \xfcbersetzenden Text ein, oder Cephable verwendet automatisch den von Ihnen markierten Text.","label":"Geben Sie den zu \xfcbersetzenden Text ein","languageLabel":"Zu \xfcbersetzende Sprache"},"noteTaker":{"title":"Notizenmacher","description":"Lassen Sie Cephable Ihre Meetings oder Gespr\xe4che lokal aufzeichnen und transkribieren"},"documentChat":{"title":"Dokumenten-Chat","description":"Interagieren Sie mit Dokumenten und fragen Sie sie ab, um schnelle Erkenntnisse zu gewinnen."},"highlightText":{"title":"Hervorgehobenen Text verwenden","description":"Cephable kann den in einer App markierten Text automatisch verwenden, um Aufgaben wie Zusammenfassen, Umschreiben oder \xdcbersetzen auszuf\xfchren. Sie k\xf6nnen Text auch manuell eingeben, wenn Sie m\xf6chten.","label":"Geben Sie den zu verwendenden Text ein","placeholder":"Sie k\xf6nnen Text auch in einer anderen App markieren und hierher zur\xfcckkehren, um ihn zu verwenden.","noTextFound":"Kein Text gefunden. Markieren Sie den Text in einer anderen App oder f\xfcgen Sie ihn in das Feld ein und versuchen Sie es erneut."},"pasteText":{"title":"Text einf\xfcgen","description":"Cephable kann den in die Zwischenablage kopierten Text automatisch f\xfcr Aufgaben wie Zusammenfassen, Umschreiben oder \xdcbersetzen verwenden. Sie k\xf6nnen den Text auch manuell eingeben.","label":"Geben Sie den zu verwendenden Text ein","placeholder":"Sie k\xf6nnen Text auch in einer anderen App markieren und hierher zur\xfcckkehren, um ihn zu verwenden."},"clearCache":"Falls Probleme bei der Generierung auftreten, l\xf6schen Sie bitte Ihren Cache und Ihre Ressourcen in den Einstellungen f\xfcr die Textgenerierung und versuchen Sie es erneut.","transcribeAudio":{"title":"Audio transkribieren","description":"Konvertieren Sie Audio- oder Videodateien mithilfe der KI-Transkription in Text.","inputMethod":"Eingabemethode ausw\xe4hlen","localFile":"Lokale Datei","url":"URL","selectFile":"Audio-/Videodatei ausw\xe4hlen","urlLabel":"Audio-/Video-URL","transcribe":"Transkribieren","result":"Transkriptionsergebnis","invalidFileType":"Bitte w\xe4hlen Sie eine g\xfcltige Audio- oder Videodatei (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Transkriptionsfehler","history":{"title":"Transkriptionsverlauf","description":"Zeigen Sie Ihre gespeicherten Transkriptionen an und verwalten Sie sie.","viewHistory":"Verlauf anzeigen","empty":"Noch keine Transkriptionen. Beginnen Sie mit der Transkription, um Ihren Verlauf aufzubauen!","titleLabel":"Titel (optional)","titlePlaceholder":"Geben Sie einen Titel f\xfcr diese Transkription ein","textLabel":"Transkriptionstext","confirmDelete":"M\xf6chten Sie diese Transkription wirklich l\xf6schen?"}},"aiWorkflows":{"description":"Automatisieren Sie Ihre Desktop- und Browseraufgaben mit KI. Beschreiben Sie einfach, was Sie erreichen m\xf6chten, und Cephable f\xfchrt die Aktionen f\xfcr Sie aus.","label":"Beschreiben Sie, was Sie erreichen m\xf6chten.","status":{"idle":"Wir warten auf Ihre Anweisungen...","initializing":"Die Vorbereitungen laufen...","planning":["Einen Plan machen...","Aufschl\xfcsselung Ihrer Anfrage...","Die einzelnen Schritte planen...","Organisation des Arbeitsablaufs...","Die Strategie wird vorbereitet...","Einen Aktionsplan erstellen...","Wir \xfcberlegen, wie wir Ihnen am besten helfen k\xf6nnen...","Die richtige Vorgehensweise festlegen...","Ihre Anfrage wird analysiert...","Planung der Durchf\xfchrung..."],"thinking":["Denken..."],"waitingForUser":"Ihre Eingabe ist erforderlich, um fortzufahren.","completed":"Erfolg!","failed":"Ihre Anfrage ist fehlgeschlagen: {{message}}","canceled":"Ihre Anfrage wurde storniert.","terminated":"Ihre Anfrage wurde bearbeitet.","thinkingInteractive":["\xdcberlegen Sie sich den n\xe4chsten Schritt...","Ein R\xfcckblick auf das bisher Erreichte...","Die Entscheidung, was als N\xe4chstes zu tun ist...","Analyse der Ergebnisse...","Planung der Fortsetzung...","Die Optionen auswerten...","Den besten n\xe4chsten Schritt herausfinden...","Ich arbeite am n\xe4chsten Teil Ihrer Anfrage...","Ich arbeite an den n\xe4chsten Schritten...","Die Ergebnisse des vorherigen Schritts werden verarbeitet..."],"tools":{"click_element_by_index":{"executing-start":"Durch Klicken der entsprechenden Schaltfl\xe4che...","executing-complete":"Ich habe auf {{params.index}} geklickt."},"click_element":{"executing-start":"Durch Anklicken der markierten Zahl...","executing-complete":"Ich habe auf {{params.elementName}} geklickt."},"copy_selection":{"executing-start":"Kontextinformationen sammeln...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"draft_email":{"executing-start":"Eine E-Mail verfassen...","executing-complete":"Ich habe eine E-Mail zum Thema {{params.subject}} entworfen."},"execute_app_action":{"executing-start":"{{params.actionName}} wird ausgef\xfchrt...","executing-complete":"{{params.actionName}} abgeschlossen."},"find_all_text":{"executing-start":"Suche nach allen relevanten Kontextinformationen zu {{params.searchText}}...","executing-complete":"Ich habe alle relevanten Kontextinformationen zu {{params.searchText}} gefunden."},"find_and_select_text":{"executing-start":"Suche und Auswahl relevanter Kontextinformationen zu {{params.searchText}}...","executing-complete":"Ich habe relevanten Kontext zu {{params.searchText}} gefunden und ausgew\xe4hlt."},"generate_text":{"executing-start":"Inhalte erstellen...","executing-progress":"Inhalte werden erstellt...{{progress}}%","executing-complete":"Ich habe die angeforderten Inhalte erstellt."},"get_all_interactive_elements":{"executing-start":"Scannen, um mehr Kontext zu erhalten...","executing-complete":"Ich verstehe, womit ich interagieren kann."},"get_all_text_elements_content":{"executing-start":"Lesen, um mehr Kontext zu erhalten...","executing-complete":"Ich verstehe, welche Textinhalte verf\xfcgbar sind."},"get_all_text_elements_names":{"executing-start":"Lesen, um mehr Kontext zu erhalten...","executing-complete":"Ich verstehe, welche Textinhalte verf\xfcgbar sind."},"get_available_profile_actions":{"executing-start":"Ich pr\xfcfe, welche Steuerelemente in dieser App verf\xfcgbar sind...","executing-complete":"Ich verstehe, was ich mit dieser App machen kann."},"get_document_content":{"executing-start":"Lesen, um mehr Kontext zu erhalten...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"get_installed_apps":{"executing-start":"Die Entscheidung, welche App f\xfcr Ihre Anfrage relevant ist...","executing-complete":"Ich wei\xdf, welche Apps ich verwenden kann."},"get_running_app_names":{"executing-start":"Die Entscheidung, welche App f\xfcr Ihre Anfrage relevant ist...","executing-complete":"Ich wei\xdf, welche Apps ich verwenden kann."},"get_selected_text":{"executing-start":"Der ausgew\xe4hlte Inhalt wird gelesen...","executing-complete":"Ich habe Kontextinformationen zum ausgew\xe4hlten Inhalt."},"get_stored_content":{"executing-start":"Kontext sammeln...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"keyboard_shortcut":{"executing-start":"Kontext sammeln...","executing-complete":"Ich habe den Kontext und bin bereit f\xfcr den n\xe4chsten Teil Ihrer Anfrage."},"open_app":{"executing-start":"\xd6ffne {{params.appName}}...","executing-complete":"Ich habe {{params.appName}} ge\xf6ffnet."},"open_webpage":{"executing-start":"\xd6ffne {{params.url}}...","executing-complete":"Ich habe {{params.url}} ge\xf6ffnet."},"paste_content":{"executing-start":"Schreiben...","executing-complete":"Ich habe mit dem Schreiben fertig."},"respond_to_user":{"executing-start":"Ihre Anfrage wird abgeschlossen...","executing-complete:":"Ich habe Ihre Anfrage bearbeitet."},"search_browser":{"executing-start":"Suche im Web nach {{params.query}}...","executing-complete":"Ich habe im Internet nach {{params.query}} gesucht."},"select_all_text":{"executing-start":"Der gesamte Text wird ausgew\xe4hlt...","executing-complete":"Ich habe den gesamten Text ausgew\xe4hlt."},"summarize_text":{"executing-start":"Zusammenfassend l\xe4sst sich sagen:","executing-progress":"Zusammenfassend...{{progress}}%","executing-complete":"Ich habe den Text zusammengefasst."},"translate_text":{"executing-start":"Der Text wird in {{params.targetLanguage}} \xfcbersetzt...","executing-progress":"\xdcbersetzung l\xe4uft...{{progress}}%","executing-complete":"Ich habe den Text in {{params.targetLanguage}} \xfcbersetzt."},"type_stored_content":{"executing-start":"Schreiben...","executing-complete":"Ich habe mit dem Schreiben fertig."},"type_text":{"executing-start":"Schreiben...","executing-complete":"Ich habe mit dem Schreiben fertig."},"unknown":{"executing-start":"Ich bin auf ein Problem gesto\xdfen, als ich eine andere Strategie ausprobiert habe...","executing-complete":"Ich habe eine andere Strategie ausprobiert."},"append_to_file":{"executing-start":"Der Datei wird etwas hinzugef\xfcgt...","executing-complete":"Ich habe der Datei Inhalte hinzugef\xfcgt."},"copy_path":{"executing-start":"Kopieren...","executing-complete":"Ich habe es kopiert."},"create_directory":{"executing-start":"Ordner wird erstellt...","executing-complete":"Ich habe den Ordner erstellt."},"delete_path":{"executing-start":"L\xf6schen...","executing-complete":"Ich habe es gel\xf6scht."},"edit_user_file":{"executing-start":"Die Datei wird bearbeitet...","executing-complete":"Ich habe die Datei bearbeitet."},"get_file_info":{"executing-start":"Datei wird gepr\xfcft...","executing-complete":"Ich habe die Datei \xfcberpr\xfcft."},"list_directory":{"executing-start":"Ordner auflisten...","executing-complete":"Ich habe den Ordner aufgelistet."},"move_path":{"executing-start":"Umzug...","executing-complete":"Ich habe es verschoben."},"open_path":{"executing-start":"\xd6ffnung...","executing-complete":"Ich habe es ge\xf6ffnet."},"read_user_file":{"executing-start":"Die Datei wird gelesen...","executing-complete":"Ich habe die Datei gelesen."},"run_command":{"executing-start":"Einen Befehl ausf\xfchren...","executing-complete":"Ich habe den Befehl ausgef\xfchrt."},"search_files":{"executing-start":"Suche nach Dateien...","executing-complete":"Ich habe passende Dateien gefunden."},"search_in_files":{"executing-start":"Suche in den Dateien...","executing-complete":"Ich habe in den Dateien gesucht."},"write_user_file":{"executing-start":"Die Datei wird geschrieben...","executing-complete":"Ich habe die Datei geschrieben."},"rewrite_text":{"executing-progress":"Neu schreiben...{{progress}}%"},"analyze_table":{"executing-start":"Analyse der Tabelle...","executing-complete":"Ich habe die Tabelle analysiert."}},"networkError":"Die Verbindung wurde beim Herunterladen des Modells unterbrochen. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut, indem Sie eine Anfrage senden oder die App neu starten.","executing-org-block":"{{params.toolName}} kann nicht aufgerufen werden, da die Interaktion mit {{params.appOrDomain}} von der Organisation blockiert wird.","executing-destructive-block":"Die Interaktion mit {{params.elementName}} ist blockiert. Bitte \xfcberpr\xfcfen Sie dies und f\xfchren Sie diese Aktion manuell aus.","executing-type-focus-block":"Ich hatte ein Problem beim Schreiben des Inhalts. Er wurde in Ihre Zwischenablage kopiert, bitte f\xfcgen Sie ihn manuell ein.","executing-permission-block":"Ich hatte Probleme beim Zugriff auf die Datei.","stopped":"Angehalten.","unsupportedOSVersion":"Ihr MacOS-System ist veraltet. Bitte aktualisieren Sie es und versuchen Sie es erneut.","loadNotice":{"firstRunSetup":"Die erstmalige Einrichtung der ger\xe4teinternen KI kann einige Minuten dauern, geht aber beim n\xe4chsten Mal schneller.","largeModel":"{{model}} ({{size}} GB) wird geladen. Gr\xf6\xdfere Modelle k\xf6nnen einige Minuten zum Laden ben\xf6tigen. F\xfcr schnellere Ergebnisse wechseln Sie in den Einstellungen zu einem kleineren Modell.","driverIssue":"Ihr Grafiktreiber ist m\xf6glicherweise veraltet, daher l\xe4uft die ger\xe4teinterne KI in einem langsameren Modus. Durch ein Update Ihres Grafiktreibers kann die KI schneller und zuverl\xe4ssiger werden.","longTask":"Diese Aufgabe dauert zu lange, deshalb gebe ich ihr mehr Zeit. Das kann bis zu einer Minute dauern."}},"ready":{"waiting":"AI Workflows ist einsatzbereit. Wir warten auf Ihre Anweisungen.","execute":"AI Workflows ist bereit. Wir starten auf Ihre Anfrage hin..."},"start":"Start","progress":"Arbeiten...","title":"Ihre KI-Workflows sind bereit","steps":{"thinking":"Denken","tool":"Werkzeug","details":"Details","chunkProgress":"Teil {{aktuell}} von {{gesamt}}","output":"Ausgabe","showMore":"Mehr anzeigen","showLess":"Weniger anzeigen","contentUsed":"Verwendete Inhalte","contentSource":"Quelleninhalt","contentTruncated":"Es werden die ersten {{shown}} von {{total}} Zeichen angezeigt","error":"Fehler"},"prefix":"Arbeitsablauf:","files":{"sectionTitle":"Dateien","open":"Offen","openFile":"Datei \xf6ffnen","openFolder":"Ordner \xf6ffnen","openError":"\\"{{name}}\\" konnte nicht ge\xf6ffnet werden. Die Datei wurde m\xf6glicherweise verschoben oder gel\xf6scht."},"input":{"other":"Andere\u2026","otherPlaceholder":"Geben Sie Ihre Antwort ein","submit":"Schicken"},"continue":{"label":"Weitermachen","placeholder":"Bitten Sie Cephable, mehr aus diesem Ergebnis zu machen\u2026"},"retry":{"label":"Wiederholen"},"context":{"approaching":"Diese Konversation dauert bereits l\xe4nger ({{percent}}% des KI-Speichers werden genutzt). \xc4ltere Nachrichten werden m\xf6glicherweise bald gel\xf6scht.","trimmed":"Diese Konversation hat die Speichergrenze der KI erreicht, daher werden m\xf6glicherweise fr\xfchere Nachrichten vergessen. Starten Sie einen neuen Workflow, um die Speicherung zur\xfcckzusetzen.","indicator":"{{percent}}% des Arbeitsspeichers genutzt","indicatorPending":"F\xfcr diesen Workflow verwendeter Arbeitsspeicher","indicatorTokens":"{{used}}/{{budget}} verwendet"},"approval":{"title":"Aktion best\xe4tigen","approve":"Genehmigen","reject":"Ablehnen","edit":"Bearbeiten","deletePath":"Diese Datei/diesen Ordner l\xf6schen? Dies ist endg\xfcltig.","runCommand":"Diesen Shell-Befehl ausf\xfchren?","movePath":"Diesen Pfad verschieben/umbenennen? Dadurch k\xf6nnte der Zielpfad \xfcberschrieben werden.","confirmDelete":"L\xf6schen","confirmRun":"Befehl ausf\xfchren","confirmMove":"Bewegen","badgeDestructive":"Zerst\xf6rerisch","badgeCaution":"Vorsicht"},"browser":{"sectionTitle":"Browser","view":"Browser anzeigen","open":"Offen","openError":"Der Browser konnte nicht ge\xf6ffnet werden."},"resume":{"title":"Einen fr\xfcheren Chat fortsetzen","description":"Durchsuchen Sie Ihren Automatisierungsverlauf und machen Sie dort weiter, wo Sie aufgeh\xf6rt haben.","searchPlaceholder":"Durchsuchen Sie vergangene Chats\u2026","noMatches":"Keine vergangenen Chats entsprechen der Suchanfrage \\"{{query}}\\".","empty":"Bisher keine Automatisierungen in der Vergangenheit.","continuing":"Chat wird fortgesetzt","stopContinuing":"Er\xf6ffne stattdessen einen neuen Chat.","indicator":"Fortsetzung der \\"{{title}}\\"-Konversation","clear":"Ausgew\xe4hlten Chat l\xf6schen"}},"generatedByAI":"Die Daten werden durch ger\xe4teinterne KI bereitgestellt. Bitte \xfcberpr\xfcfen Sie die Angaben auf Richtigkeit.","networkError":"Die Verbindung wurde beim Herunterladen des Modells unterbrochen. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut, indem Sie eine Anfrage senden oder die App neu starten.","genericError":"Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.","download":{"title":"Laden Sie KI-Modelle herunter, um weitere Funktionen freizuschalten","description":"Um intelligente Aufgaben nutzen zu k\xf6nnen, muss ein lokales Modell auf Ihr Ger\xe4t heruntergeladen werden. Dadurch wird sichergestellt, dass Ihre Daten privat bleiben und niemals in die Cloud \xfcbertragen werden.","confirm":"Herunterladen","cancel":"Nicht jetzt."},"runningInBackground":{"generate":"Wird im Hintergrund generiert...","rewrite":"\xdcberarbeitung im Hintergrund...","translate":"\xdcbersetzung im Hintergrund...","summarize":"Zusammenfassend im Hintergrund...","generic":"L\xe4uft im Hintergrund..."},"processing":"Verarbeitung..."},"inputMethod":"Eingabemethode:","hotkey":{"title":"Schnellaktionsschaltfl\xe4che","titlePlural":"Schnellaktionsschaltfl\xe4chen","titlePanel":"Schnellaktionen","label":"Anzeigename der Schnellaktionsschaltfl\xe4che","placeholder":"Anzuzeigender Name","question":"Wie m\xf6chten Sie diese Schaltfl\xe4che benennen?","when":"Wenn ich tippe ...","description":"Schnellaktionsschaltfl\xe4chen sind anpassbare Schaltfl\xe4chen, mit denen Sie durch Antippen relevante Aktionen in Ihrer App ausf\xfchren k\xf6nnen. Ein einziges Antippen kann mehrere Schritte oder eine einzelne Aktion ausl\xf6sen.","usagePrompt":"Schnellaktionsschaltfl\xe4chen sind anpassbare Schaltfl\xe4chen, mit denen Sie durch Antippen entsprechende Aktionen in Ihrer App ausf\xfchren k\xf6nnen. Sie k\xf6nnen die Namen auf der Hauptseite der App-Steuerungseinstellungen hinzuf\xfcgen, entfernen oder bearbeiten.","reorder":"Sie k\xf6nnen die Reihenfolge mit den Schaltfl\xe4chen \u201ENach oben\u201C und \u201ENach unten\u201C neu anordnen.","emptyTitle":"Keine Schnellaktionstasten","edit":"Schnellaktionsschaltfl\xe4chen bearbeiten","tap":"Tippen Sie auf {{value}}","copySuffix":"{{name}}_Kopie","hotkeysOnly":"Benutzerdefinierte Schaltfl\xe4chen","allControls":"Alle App-Steuerelemente","show":"Schnellaktionsschaltfl\xe4chen anzeigen","deprecatedDialog":{"title":"Ihre App-Steuerung erfordert ein Update.","description2":"Ein schnelles Update gen\xfcgt \u2013 buchst\xe4blich eine Sekunde \u2013 und Sie k\xf6nnen die nahtlose Anpassung der Schaltfl\xe4chen genie\xdfen. Verabschieden Sie sich von zus\xe4tzlichen Schritten und freuen Sie sich auf eine benutzerfreundlichere Oberfl\xe4che. Sind Sie bereit f\xfcr den Wechsel?","confirm":"Lass es uns tun!","description1":"Sie verwenden anscheinend \xe4ltere App-Steuerelemente mit Schnellaktionsschaltfl\xe4chen. Wir haben spannende Updates f\xfcr Sie! Wir haben das System \xfcberarbeitet, damit das Erstellen und Bearbeiten von Schnellaktionsschaltfl\xe4chen kinderleicht ist \u2013 Sie m\xfcssen sich nicht mehr in die erweiterten Einstellungen vertiefen."},"demo":{"title":"Demo der Schnellaktionsschaltfl\xe4chen","step1":"Aktivieren Sie die Schnellaktionsschaltfl\xe4chen","step2":"Verwenden Sie die folgenden Beispielaufforderungen, um den Textblock zu steuern.","command1":"Dr\xfccken Sie die Taste 1, um den Text zu vergr\xf6\xdfern.","command2":"Dr\xfccken Sie die Taste 2, um den Text fett darzustellen.","command3":"","continue":"Weiter mit Quick Action Buttons","description":"Im Demobereich unten k\xf6nnen Sie Schnellaktionsschaltfl\xe4chen ausprobieren. Die Demo beschr\xe4nkt sich auf die Steuerung dieses Textbereichs unten."},"example":{"title":"Beispiele f\xfcr Schnellaktionsschaltfl\xe4chen","command1":"Tippen Sie auf \u201EPause\u201C","example1":"Beispiel \u201EVideo anhalten\u201C","command2":"Tippen Sie auf Weiter","example2":"Beispiel \u201EHerauszoomen\u201C","command3":"Tippen Sie auf \u201EStopp\u201C","example3":"Beispiel \u201EFenster schlie\xdfen\u201C","description":"Diese Beispiele zeigen die Vielseitigkeit von Quick Action Buttons bei der Steuerung Ihres Ger\xe4ts oder Ihrer Verbindung. Mit ihnen k\xf6nnen Sie Befehle ausf\xfchren, durch Benutzeroberfl\xe4chen navigieren oder Aktionen mit einem einfachen Fingertipp ausf\xfchren."},"emptySearch":"Es gibt keine Schnellaktionen, die diesen Kriterien entsprechen.","empty":"Es sieht so aus, als ob Sie derzeit keine Schnellaktionen haben.","emptyLong":"In diesen App-Steuerelementen sind keine Schnellaktionsschaltfl\xe4chen konfiguriert. Sobald Sie Schnellaktionsschaltfl\xe4chen hinzuf\xfcgen oder App-Steuerelemente mit einer solchen Schaltfl\xe4che ausw\xe4hlen, werden diese hier angezeigt."},"reset":"Zur\xfccksetzen","info":"Weitere Informationen","device":{"title":"Verbindung","titlePlural":"Anschl\xfcsse","status":{"title":"Verbindungsstatus:","connected":{"application":"Verbundene Anwendung","connection":"Verbunden","device":"Verbundenes Ger\xe4t","game":"Verbundenes Spiel"},"disconnected":{"application":"Getrennte Anwendung","connection":"Getrennt","device":"Getrenntes Ger\xe4t","game":"Getrenntes Spiel"}},"running":"L\xe4uft","offline":"Offline","otherDevices":"Andere Ausgangsanschl\xfcsse","currentStatus":"Aktueller Status:","connectionStatus":"Verbindungsstatus:","profileStatus":"Aktuelle App-Steuerelemente:","name":{"title":"Verbindungsname","question":"Wie m\xf6chten Sie diese Verbindung nennen?","description":"Geben Sie Ihrer Verbindung einen Namen, damit Sie sie sp\xe4ter leicht wiederfinden k\xf6nnen.","placeholder":"Verbindungsname","edit":"Verbindungsnamen bearbeiten"},"updates":{"title":"Verbindungsupdates","settings":"Verbindungsaktualisierungseinstellungen","description":"Suchen Sie nach Firmware-Updates f\xfcr die Verbindung und \xe4ndern Sie die Einstellungen f\xfcr die automatische Aktualisierung","edit":"Update-Einstellungen bearbeiten","check":{"title":"Nach Updates suchen","processing":"Suche nach Updates! Dies kann einige Minuten dauern und Ihre Verbindung wird w\xe4hrend der Updates m\xf6glicherweise neu gestartet.","description":"Tippen Sie hier, um nach Updates f\xfcr Ihre Verbindung zu suchen. Wenn ein Update verf\xfcgbar ist und Ihre Verbindung aktiv ist, wird die Aktualisierung gestartet. Die Aktualisierung kann einige Minuten dauern."},"auto":{"title":"Automatisch aktualisieren","description":"Wenn diese Einstellung aktiviert ist, wird Ihre Verbindung automatisch aktualisiert, sobald sie angeschlossen ist, mit dem WLAN verbunden ist und ein Update verf\xfcgbar ist. Wenn diese Einstellung deaktiviert ist, m\xfcssen Sie auf die Schaltfl\xe4che \u201EAktualisieren\u201C tippen, um die neueste Version zu erhalten.","option":"Automatische Aktualisierung verwenden?"}},"delete":{"title":"Link {{name}} entfernen","titleLong":"Verkn\xfcpfung von Konto aufheben","description":"Durch das Trennen der Verbindung wird Cephable von diesem Computer oder Spiel getrennt und aus Ihrem Konto entfernt. Sie k\xf6nnen sich dann nicht mehr verbinden, Befehle senden oder Updates durchf\xfchren. Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden. Sie k\xf6nnen jedoch eine neue Verbindung zum selben Computer oder Spiel herstellen, falls Sie Cephable sp\xe4ter wieder verwenden m\xf6chten.","confirm":"M\xf6chten Sie diese Verbindung wirklich trennen?","confirmLong":"M\xf6chten Sie diese Verbindung wirklich abmelden und zur\xfccksetzen? Sie k\xf6nnen sich danach nicht mehr damit verbinden, Befehle senden oder sie aktualisieren. Nach dieser Abmeldung und Zur\xfccksetzung kann jeder diese Verbindung von Grund auf neu einrichten.","confirmButton":"Ja, diese Verbindung entfernen."},"manage":{"title":"Klicken Sie hier, um Details zu Ihren Verbindungen anzuzeigen und zu verwalten.","description":"","name":"Passen Sie Ihren Verbindungsnamen zur einfacheren Verwaltung an."},"error":{"save":"Fehler beim Speichern der Verbindung.","load":"Fehler beim Laden der Verbindung.","add":"Fehler beim Hinzuf\xfcgen der Verbindung.","delete":"Fehler beim L\xf6schen der Verbindung.","updates":"Fehler beim Suchen nach Updates.","connection":"Die Verbindung konnte nicht hergestellt werden. Stellen Sie sicher, dass die Verbindung besteht, bevor Sie es erneut versuchen.","deleteLong":"Wir konnten diese Verbindung nicht aus Ihrem Konto l\xf6schen. Wenn Sie sich erneut bei diesem Konto anmelden, m\xfcssen Sie diese Verbindung m\xf6glicherweise manuell in den Verbindungseinstellungen l\xf6schen."},"success":{"save":"Verbindung gespeichert.","add":"Verbindung hinzugef\xfcgt.","delete":"Verbindung gel\xf6scht."},"description":"Cephable unterst\xfctzt mehrere Ger\xe4te und Verbindungen. Sie k\xf6nnen hier Einstellungen verwalten oder alle ausw\xe4hlen. Dieser Computer ist immer Ihre Hauptverbindung. Sie k\xf6nnen sp\xe4ter weitere Verbindungen hinzuf\xfcgen.","swap":{"titlePlural":"Verbindungen austauschen","description":"Cephable unterst\xfctzt mehrere Ger\xe4te und Verbindungen. Sie k\xf6nnen hier eine beliebige ausw\xe4hlen. Dieser Computer dient immer als Ihre Hauptverbindung. Sie k\xf6nnen sp\xe4ter weitere Verbindungen hinzuf\xfcgen."},"control":{"button":"Kontrolle {{name}}","description":{"application":"Steuern Sie diese verbundene Anwendung per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ESpeichern\u201C sagen, wird die laufende Anwendung gespeichert.","connection":"Steuern Sie diese Verbindung per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ESpeichern\u201C sagen, wird Ihre laufende Verbindung gespeichert.","device":"Steuern Sie dieses verbundene Ger\xe4t per Sprache, Schnellaktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ESpotify \xf6ffnen\u201C sagen, wird Spotify auf dem laufenden Ger\xe4t ge\xf6ffnet.","game":"Steuern Sie dieses vernetzte Spiel mit Ihrer Stimme, schnellen Aktionen, Kopfbewegungen und mehr. Wenn Sie beispielsweise \u201ELos\u201C sagen, bewegt sich der Spieler im Laufspiel."},"generic":"Steueranschluss"},"titleShort":"Verbinden","titleLong":"Verbindungen & Erweiterungen","viewAll":"Alle Verbindungen anzeigen","add":{"short":"Verl\xe4ngern","title":"Neue Verbindung oder Erweiterung hinzuf\xfcgen","description":"Verbindungen und Erweiterungen bieten Ihnen zus\xe4tzliche M\xf6glichkeiten, Ihr Cephable-Erlebnis zu optimieren. Sie k\xf6nnen neue Verbindungen hinzuf\xfcgen, um weitere Ger\xe4te, Anwendungen oder Spiele zu verbinden. Bringen Sie Ihr Cephable-Erlebnis auf die n\xe4chste Stufe, indem Sie Verbindungen und Erweiterungen hinzuf\xfcgen.","action":"Neue Verbindung hinzuf\xfcgen","notAvailable":"Diese Verbindung bzw. Erweiterung ist derzeit nicht \xf6ffentlich verf\xfcgbar. Dies tritt h\xe4ufig bei der Verwendung von benutzergenerierten Erweiterungen auf. Bitte versuchen Sie es sp\xe4ter erneut.","isNotPublic":"VORSCHAU: Diese Erweiterung befindet sich in der Entwicklervorschau und ist m\xf6glicherweise unvollst\xe4ndig. Entwickler sollten alle Schritte vor der Ver\xf6ffentlichung abschlie\xdfen. Benutzer k\xf6nnen sp\xe4ter wieder vorbeischauen, um die Vollversion zu erhalten."},"new":"Sie haben eine neue Verbindung!","newLong":"Sie haben eine neue Verbindung! Um sie zu nutzen, w\xe4hlen Sie sie im Men\xfc unten aus.","selectDevice":"Ger\xe4t ausw\xe4hlen"},"explore":"Erkunden","shortcuts":{"title":"Globale Verkn\xfcpfungen","description":"Passen Sie Tastaturk\xfcrzel an, um von \xfcberall auf Ihrem System aus schnell auf die Cephable-Steuerelemente zugreifen zu k\xf6nnen.","info":"Diese Verkn\xfcpfungen funktionieren global und k\xf6nnen auch verwendet werden, wenn Cephable nicht das aktive Fenster ist.","shortcut":"Abk\xfcrzung","toggleMicrophone":"Mikrofon umschalten","toggleDictation":"Diktiermodus umschalten","toggleVoiceControl":"Sprachsteuerungsmodus umschalten","togglePanel":"Bedienfeld umschalten","registrationFailed":"Einige globale Tastenkombinationen konnten nicht registriert werden. Sie werden m\xf6glicherweise von einer anderen Anwendung verwendet:","record":{"title":"Verkn\xfcpfung aufzeichnen","start":"Klicken zum Aufzeichnen","listening":"Dr\xfccken Sie die gew\xfcnschte Tastenkombination...","pressKeys":"Jetzt Tasten dr\xfccken"},"formatHint":"W\xe4hlen Sie mindestens eine Sondertaste ({{modifierKey}}, {{modifierKey2}}, Umschalttaste) und eine weitere Taste aus."},"gamepad":{"title":"Gamepad-Unterst\xfctzung","description":"Konfigurieren Sie die Gamepad- und Joystick-Ausgabe f\xfcr PC-Spiele","driver":{"description":"Zur Unterst\xfctzung von Gamecontroller-Ausgaben muss Cephable einen externen Treiber namens ViGEm herunterladen und installieren. Dieser Treiber erm\xf6glicht die Funktionalit\xe4t eines virtuellen Xbox 360-Controllers, den Spiele nativ erkennen.","installed":"Gamecontroller-Treiber installiert \u2013 Sie k\xf6nnen die Gamepad-Ausg\xe4nge verwenden! Sollten weiterhin Probleme auftreten, k\xf6nnen Sie versuchen, den Treiber neu zu installieren.","notInstalled":"Gamecontroller-Treiber nicht installiert","install":"Installieren Sie den Gamecontroller-Treiber","reinstall":"Installieren Sie den Gamecontroller-Treiber neu","installing":"ViGEm-Gamecontroller-Treiber wird installiert \u2026","installSuccess":"Der ViGEm-Gamecontroller-Treiber wurde erfolgreich installiert! Sie k\xf6nnen jetzt Gamepad-Ausg\xe4nge in Ihren Steuerelementen verwenden.","installFailed":"Der ViGEm-Treiber konnte nicht installiert werden. Bitte versuchen Sie es erneut oder installieren Sie den Treiber manuell von der ViGEm-Website.","title":"Gamecontroller-Treiber","disclosure":{"title":"Treiber eines Drittanbieters f\xfcr Gamepads installieren?","description":"F\xfcr die Gamepad-Unterst\xfctzung ist die Installation von ViGEm erforderlich, einem inoffiziellen Treiber eines Drittanbieters, der es Cephable erm\xf6glicht, einen virtuellen Xbox-Controller zu emulieren. Fahren Sie nur fort, wenn Cephable diesen Treiber installieren soll.","confirm":"Installieren Sie den ViGEm-Treiber"}},"platform":{"unsupported":"Plattform wird f\xfcr Gamepad-Funktionen nicht unterst\xfctzt","unsupportedDescription":"Die Gamepad-Ausgabe wird derzeit nur auf Windows x64-Systemen unterst\xfctzt. Unterst\xfctzung f\xfcr Mac und Windows ARM64 ist noch nicht verf\xfcgbar."},"usage":"Sobald der Gamecontroller-Treiber installiert ist, k\xf6nnen Sie Joystick-Bewegungen und Gamepad-Tastendr\xfccke in Ihren Makros und Sprachbefehlen zur Steuerung von Spielen verwenden."},"youtube":{"unavailable":{"title":"Video nicht verf\xfcgbar","description":"Dieses Video ist derzeit nicht verf\xfcgbar. Bitte versuchen Sie es sp\xe4ter erneut.","retry":"Wiederholen"},"watch":{"title":"Hoppla.","description":"Beim Laden des Videos ist anscheinend ein Problem aufgetreten. Sie k\xf6nnen es direkt auf YouTube ansehen.","button":"Auf YouTube ansehen"},"offline":{"title":"Video nicht verf\xfcgbar","description":"Zum Laden dieses YouTube-Videos ist eine Internetverbindung erforderlich. Bitte \xfcberpr\xfcfen Sie Ihre Verbindung und versuchen Sie es erneut."}},"metrics":{"download":{"success":"Auf die Metrikdatei wurde erfolgreich zugegriffen.","manualPath":"Metrikdatei verf\xfcgbar unter: {{path}}","error":"Fehler beim Herunterladen der Metrikdatei.","noFile":"Keine Metrikdatei gefunden."},"clear":{"success":"Die Metrikdatei wurde erfolgreich gel\xf6scht.","error":"Fehler beim L\xf6schen der Metrikdatei.","noFile":"Keine zu l\xf6schende Metrikdatei gefunden.","confirm":"M\xf6chten Sie wirklich alle Messdaten l\xf6schen? Dies kann nicht r\xfcckg\xe4ngig gemacht werden."}},"suggestedPrompts":{"title":"Vorgeschlagene Eingabeaufforderungen","description":"Passen Sie die in KI-Aufgaben angezeigten Eingabeaufforderungen an, damit Sie schnell loslegen k\xf6nnen.","edit":"Vorgeschlagene Eingabeaufforderungen bearbeiten","generate":"Text generieren","rewrite":"Text neu schreiben","addGenerate":"Hinzuf\xfcgen einer Eingabeaufforderung zum Generieren","addRewrite":"F\xfcgen Sie eine Umschreibeaufforderung hinzu","remove":"Eingabeaufforderung entfernen","generatePlaceholder":"Geben Sie eine Eingabeaufforderung zur Textgenerierung ein ...","rewritePlaceholder":"Geben Sie eine Eingabeaufforderung zum Umschreiben des Textes ein ...","suggested":"Vorgeschlagene Eingabeaufforderungen","suggestedFor":"Vorgeschlagen f\xfcr {{profileName}}","seeAll":"Alle Eingabeaufforderungen anzeigen","showLess":"Weniger anzeigen","allPrompts":"Alle Eingabeaufforderungen","customFor":"Benutzerdefinierte Eingabeaufforderungen f\xfcr {{profileName}}","defaultPrompts":"Standardaufforderungen","defaultGenerate":["Eine professionelle E-Mail zur Vorstellung unseres neuen Produkts","Eine Tagesordnung f\xfcr die Teamdiskussion der n\xe4chsten Woche","Ein Projektvorschlagsentwurf f\xfcr eine neue Initiative","Eine formelle Gesch\xe4ftsbriefvorlage","Ein Abschnitt zur technischen Dokumentation","Eine Einf\xfchrung in das Benutzerhandbuch","Eine \xdcbersicht \xfcber Schulungsunterlagen","Entwurf eines Strategiedokuments","Eine Folge-E-Mail nach einem Meeting","Eine Dankesnachricht an einen Kunden","Eine E-Mail mit einem Update zum Projektstatus","Eine Einladung zu einer Firmenveranstaltung","Eine Erinnerungs-E-Mail f\xfcr bevorstehende Fristen","Eine Willkommens-E-Mail f\xfcr neue Teammitglieder","Eine Entschuldigungs-E-Mail f\xfcr die Dienstunterbrechung","Eine Newsletter-Einf\xfchrung","Eine Brainstorming-Liste f\xfcr Marketingkampagnen","Kreative L\xf6sungen zur Verbesserung der Teamproduktivit\xe4t","Ideen f\xfcr Aktivit\xe4ten bei einer Firmenklausur","Konzepte f\xfcr eine neue Funktion der mobilen App","Vorschl\xe4ge zur Verbesserung des Kundenerlebnisses","Innovationsideen f\xfcr unsere Produktentwicklung","Inhaltsideen f\xfcr Social-Media-Beitr\xe4ge","Workshop-Themen zur beruflichen Weiterentwicklung","Eine Funktion, die Benutzereingaben validiert","Eine Datenbankabfrage zur Benutzerverwaltung","Fehlerbehandlungscode f\xfcr API-Anfragen","Eine Konfigurationsdateivorlage","Kommentare zur Erl\xe4uterung eines komplexen Algorithmus","Unit-Testf\xe4lle f\xfcr eine neue Funktion","Dokumentation f\xfcr API-Endpunkte","Ein Skript f\xfcr die automatisierte Bereitstellung"],"defaultRewrite":["Machen Sie diesen Text pr\xe4gnanter und auf den Punkt","Erweitern Sie diese Zusammenfassung um weitere Details","Formatieren Sie dies als nummerierte Liste neu","Wandeln Sie dies in Aufz\xe4hlungspunkte um","Strukturieren Sie dies in klare Abs\xe4tze um","Machen Sie diesen Text leichter \xfcberfliegbar","Organisieren Sie diese Informationen hierarchisch","Formatieren Sie dies als Schritt-f\xfcr-Schritt-Anleitung","Gestalten Sie diese Nachricht professioneller und formeller","Schreiben Sie dies um, damit es lockerer und freundlicher klingt","Passen Sie den Ton an, um ermutigender zu sein","Machen Sie dies selbstbewusster und durchsetzungsf\xe4higer","Den Ton mildern, um diplomatischer zu sein","Geben Sie diesem Text Begeisterung und Energie","Machen Sie dies einf\xfchlsamer und verst\xe4ndnisvoller","Schreiben Sie in einem kooperativeren Ton neu","Vereinfachen Sie dies f\xfcr ein allgemeines Publikum","Machen Sie diese Erkl\xe4rung technischer und detaillierter","Zerlegen Sie dieses komplexe Konzept in einfachere Begriffe","F\xfcgen Sie mehr Kontext und Hintergrundinformationen hinzu","Fassen Sie dies in den wichtigsten Erkenntnissen zusammen","Erl\xe4utern Sie die wichtigsten Punkte anhand von Beispielen","Machen Sie dies f\xfcr Anf\xe4nger zug\xe4nglicher","Verdichten Sie dies, w\xe4hrend Sie die wesentlichen Informationen behalten","Verbessern Sie die \xdcbersichtlichkeit und Lesbarkeit","Machen Sie es ansprechender und interessanter","Passen Sie es an, um die Grammatik und den Lesefluss zu verbessern","Schreiben Sie es neu, um die Vorteile hervorzuheben"],"defaultSummarize":["Fassen Sie es in 3 Stichpunkten zusammen.","Wichtige Entscheidungen herausarbeiten","F\xfchren Sie die wichtigsten Ma\xdfnahmen auf","Fassen Sie es in einem Satz zusammen.","Heben Sie die wichtigsten Fakten hervor","F\xfcr ein nicht-technisches Publikum zusammenfassen","Die wichtigsten Erkenntnisse herausarbeiten","Fassen Sie es in 5 Stichpunkten zusammen.","Identifizieren Sie das Kernproblem und den L\xf6sungsvorschlag.","Alle Schlussfolgerungen und Empfehlungen auflisten","Geben Sie eine Managementzusammenfassung an.","Fassen Sie den zeitlichen Ablauf der Ereignisse zusammen.","Alle aufgeworfenen Fragen herausgreifen","Listen Sie die genannten Vor- und Nachteile auf.","Fassen Sie die wichtigsten Argumente zusammen."]},"accessibilityService":{"error":{"generic":"Interner Fehler. Bitte versuchen Sie es sp\xe4ter erneut.","elementNotFound":"Es wurden keine Ergebnisse gefunden. Bitte \xfcberpr\xfcfen Sie, ob die Suchanfrage existiert, und versuchen Sie es erneut.","highlightOnConflict":"Es wurden mehrere Elemente gefunden. Bitte pr\xe4zisieren Sie Ihren Befehl, um anzugeben, welches Element Sie ausw\xe4hlen m\xf6chten.","clickNotInitialized":"Die Namensauswahl ist momentan nicht verf\xfcgbar. Bitte kontaktieren Sie den Support, falls das Problem weiterhin besteht.","platformUnsupported":"Die Namensauswahl wird auf dieser Plattform nicht unterst\xfctzt.","permission":"Cephable hat keine Berechtigung, diese App zu lesen. Erteilen Sie die Berechtigung unter Systemeinstellungen > Datenschutz & Sicherheit > {{pane}} \u2013 auf einem vom Unternehmen verwalteten Ger\xe4t kann dies von Ihrem Administrator blockiert sein."},"clickWait":"Initialisierung l\xe4uft. Bitte warten Sie einen Moment und versuchen Sie es erneut."},"deprecated":"Veraltet","view":"Sicht","aiWorkflows":{"settings":{"title":"Einstellungen automatisieren","description":"Konfigurieren Sie die f\xfcr KI-Workflows verwendeten KI-Modelle und -Ger\xe4te. KI-Workflows erm\xf6glichen die Automatisierung von Desktop- und Browseraufgaben mithilfe von ger\xe4teinterner KI.","configType":{"title":"Modellkonfigurationstyp","description":"W\xe4hlen Sie den gew\xfcnschten Modellkonfigurationstyp f\xfcr KI-Workflows aus. Verschiedene Konfigurationen sind f\xfcr unterschiedliche Modelle optimiert.","label":"Konfigurationstyp"},"reasoningModel":{"title":"Argumentationsmodell","description":"W\xe4hlen Sie das KI-Modell f\xfcr die Aufgaben im Bereich logisches Denken und Planen aus. Das Modell analysiert Ihre Anfragen und erstellt Aktionspl\xe4ne.","label":"Argumentationsmodell"},"reasoningDevice":{"label":"Logikger\xe4t"},"generationModel":{"title":"Generationsmodell","description":"W\xe4hlen Sie das KI-Modell f\xfcr die Textgenerierung aus. Das Generierungsmodell erstellt bei Bedarf im Rahmen der Arbeitsabl\xe4ufe Textinhalte.","label":"Generationsmodell"},"generationDevice":{"label":"Erzeugungsger\xe4t"},"noModelsFound":"Keine Modelle gefunden","terminate":{"title":"Ressourcen f\xfcr einen klaren Workflow","description":"Klicken Sie hier, um den Workflow-Worker zu beenden und Ressourcen freizugeben. Dadurch werden alle laufenden Workflows gestoppt und der von den KI-Modellen belegte Speicher freigegeben.","button":"Workflow-Mitarbeiter beenden","success":"Workflow-Mitarbeiter beendet.","confirm":{"title":"Workflow-Mitarbeiter beenden","description":"M\xf6chten Sie den Workflow-Worker wirklich beenden? Dadurch werden alle laufenden Workflows gestoppt und Ressourcen freigegeben.","confirm":"Ja, beenden"}},"autoWarm":{"title":"Automatischer Start von KI-Workflows","description":"KI-Workflow-Modelle werden beim Start der App automatisch initialisiert. Die Modelle werden vorab geladen, sodass Workflows sofort starten k\xf6nnen.","option":"Automatischer Start von KI-Workflow-Modellen beim App-Start"},"prompt":{"title":"Zus\xe4tzliche Informationen zu KI-Workflows","description":"Geben Sie hier zus\xe4tzliche Details ein, die von der KI von Cephable bei der Ausf\xfchrung von Workflows verwendet werden sollen. In diesem Feld k\xf6nnen Sie Ihre Pr\xe4ferenzen f\xfcr Tonfall, Verhalten oder andere Details festlegen.","field":"Zus\xe4tzliche Aufforderung","placeholder":"Beispielsweise sollten Sie vor dem Absenden von E-Mails immer eine Best\xe4tigung abgeben. Bevorzugen Sie kurze Antworten. Verwenden Sie in Dokumenten eine formelle Sprache."},"disableButtonNames":{"edit":"Block-Button-Interaktionen","input":{"label":"Schaltfl\xe4chenname","question":"Welche Schaltfl\xe4chen m\xf6chten Sie blockieren? Sie k\xf6nnen vollst\xe4ndige oder teilweise Schaltfl\xe4chennamen eingeben.","remove":"Name der Schaltfl\xe4che \u201EEntfernen\u201C"},"button":"Block-Schaltfl\xe4chen","description":"Legen Sie fest, mit welchen Schaltfl\xe4chen KI-Workflows interagieren d\xfcrfen. Standardm\xe4\xdfig kann Cephable jede Schaltfl\xe4che auf Ihrem Bildschirm anklicken. Verwenden Sie diese Einstellung, um versehentliche Aktionen (z. B. \u201EKaufen\u201C, \u201EL\xf6schen\u201C) zu verhindern."},"remoteWorkflows":{"title":"F\xfchren Sie KI-Workflows auf all Ihren Ger\xe4ten aus","option":"Meine anderen Ger\xe4te sollen die auf diesem Ger\xe4t ausgef\xfchrten Automatisierungen starten und befolgen.","description":"Diese Funktion ist standardm\xe4\xdfig aktiviert. Ist sie aktiviert, k\xf6nnen Sie die Automatisierungen dieses Ger\xe4ts von Ihren anderen angemeldeten Ger\xe4ten aus starten, \xfcberwachen und beantworten: Der Fortschritt der Automatisierung (Schritttitel und KI-Entscheidungen) sowie alle Fragen, die sie Ihnen stellt, werden in Echtzeit an diese Ger\xe4te gesendet, sodass Sie von \xfcberall aus antworten k\xf6nnen. Diese Daten werden ausschlie\xdflich zwischen Ihren eigenen Ger\xe4ten ausgetauscht und niemals auf den Servern von Cephable gespeichert. Deaktivieren Sie diese Funktion, um Automatisierungen ausschlie\xdflich auf diesem Ger\xe4t auszuf\xfchren \u2013 Automatisierungen werden weiterhin hier ausgef\xfchrt, jedoch werden keine Daten an Ihre anderen Ger\xe4te gesendet und diese k\xf6nnen keine Automatisierungen auf diesem Ger\xe4t starten."},"thinkingLevel":{"field":"Argumentationsaufwand","description":"Wie gr\xfcndlich die KI jeden Schritt vor der Ausf\xfchrung durchdenkt. H\xf6here Stufen helfen ihr, Aktionen bei komplexen Aufgaben zuverl\xe4ssiger auszuw\xe4hlen und zu ordnen, verlangsamen aber jeden einzelnen Schritt etwas. Die mittlere Stufe wird f\xfcr die meisten Nutzer empfohlen.","low":"Niedrig (schnellste)","medium":"Mittel (empfohlen)","high":"Hoch","max":"Max (am gr\xfcndlichsten)"},"dynamicTools":{"option":"Smart Connector Tools werden geladen","description":"Starten Sie schneller, indem Sie nur die ben\xf6tigten Werkzeuge laden. Im deaktivierten Zustand werden alle Werkzeuge gleichzeitig geladen \u2013 n\xfctzlich, wenn das Modell die auszuf\xfchrenden Aktionen selbst bestimmen soll, aber dies kann deutlich langsamer sein und zu schlechteren Ergebnissen f\xfchren."},"longTasks":{"field":"Lange Aufgaben","description":"Wie KI-Workflows Aufgaben bew\xe4ltigen, die viel Aufmerksamkeit erfordern, wie z. B. das Lesen langer Dokumente. Die Option \u201EAutomatisch\u201C r\xe4umt einer Aufgabe nur dann mehr Speicherplatz ein, wenn dies erforderlich ist. \u201EGeschwindigkeit priorisieren\u201C sorgt f\xfcr schnelle Arbeitsabl\xe4ufe, jedoch k\xf6nnen bei sehr langen Aufgaben die ersten Schritte verloren gehen. Die Option \u201ELange Aufgaben immer zulassen\u201C gibt jeder Aufgabe maximalen Speicherplatz, allerdings dauern Schritte, die Text schreiben, etwas l\xe4nger. Dies gilt nur f\xfcr Computer mit separater Grafikkarte.","auto":"Automatisch (empfohlen)","speed":"Geschwindigkeit priorisieren","long":"Lange Aufgaben immer zulassen"}}},"control":"Kontrolle","automate":"Automatisieren","deviceCommandThrottled":{"macroLength":"Diese Verbindung unterst\xfctzt keine langen Makros. Ihr Makro wurde automatisch gek\xfcrzt.","commandCount":"Diese Verbindung begrenzt die Geschwindigkeit, mit der Sie Befehle senden k\xf6nnen. Bitte warten Sie und versuchen Sie es sp\xe4ter erneut.","incompatibleActions":"Dieses Steuerelement enth\xe4lt Aktionen, die nicht miteinander kombiniert werden k\xf6nnen und wurde daher nicht gesendet."},"tos":{"title":"Aktualisierung der Nutzungsbedingungen","description":"Unsere Nutzungsbedingungen wurden aktualisiert. Bitte lesen und akzeptieren Sie die aktualisierten Bedingungen, um Cephable weiterhin zu nutzen.","effectiveDate":"G\xfcltigkeitsdatum: {{date}}","accept":"Nutzungsbedingungen akzeptieren","loadError":"Nutzungsbedingungen k\xf6nnen nicht geladen werden. Bitte versuchen Sie es erneut.","viewInBrowser":"Nutzungsbedingungen im Browser anzeigen","acceptCheckbox":"Ich habe die Nutzungsbedingungen gelesen und akzeptiere sie"},"appearance":{"title":"Erscheinungsbild"},"troubleshooting":{"title":"Fehlerbehebung"},"extensions":{"title":"Erweiterungen","titleShort":"Erweiterungen","description":"Aktivieren Sie Funktionen, verbinden Sie Begleit-Apps und erweitern Sie die M\xf6glichkeiten von Cephable.","searchPlaceholder":"Sucherweiterungen","noResults":"Ihre Suche ergab keine Treffer f\xfcr Ihre Dateierweiterungen.","comingSoon":"Demn\xe4chst verf\xfcgbar","done":"Erledigt","getStarted":"Los geht\'s!","viewDetails":"Details und Einstellungen anzeigen","enable":"Aktivieren","publisher":{"official":"Cephable","officialTitle":"Offiziell \u2013 erstellt und gewartet von Cephable","byline":"Von {{publisher}}","thirdPartyTitle":"Drittanbieterintegration durch {{publisher}}"},"category":{"inputControls":{"title":"Eingabe & Steuerung","description":"Aktivieren Sie mit Cephable die Steuerungsm\xf6glichkeiten Ihres Ger\xe4ts."},"companionApps":{"title":"Begleit-Apps und Tools","description":"Erweitere Cephable mit unserer mobilen App und unseren webbasierten Editoren."},"buildExtend":{"title":"Bauen & Erweitern","description":"Erstellen Sie Ihre eigenen Erweiterungen mit der Cephable API und den SDKs."},"marketplace":{"title":"Marktplatz","description":"Neue F\xe4higkeiten, Werkzeuge und Kontakte sind im Anmarsch."},"previews":{"title":"Vorschau","description":"Probieren Sie die in K\xfcrze erscheinenden Funktionen aus. Vorschauen k\xf6nnen sich vor der Ver\xf6ffentlichung noch \xe4ndern."}},"camera":{"title":"Kamerasteuerung","description":"Steuern Sie Ihr Ger\xe4t durch Gesichts- und Kopfbewegungen mithilfe Ihrer Kamera.","detail":"Die Kamerasteuerung erm\xf6glicht es Ihnen, Ihr Ger\xe4t mithilfe von Gesichtsausdr\xfccken und Kopfbewegungen \u2013 einschlie\xdflich der Kopfsteuerung als Maus \u2013 zu bedienen. Aktivieren Sie diese Funktion mit dem Schalter auf der Karte und passen Sie das Verhalten anschlie\xdfend hier an.","settings":{"title":"Mimik und Gestik","description":"In den Einstellungen k\xf6nnen Sie festlegen, welche Gesichtsausdr\xfccke und Kopfbewegungen den jeweiligen Aktionen zugeordnet sind."},"advancedSettings":"Kameraeinstellungen \xf6ffnen"},"gamepad":{"title":"Gamepad-Unterst\xfctzung","description":"Emulieren Sie einen Xbox-Controller, damit Spiele Ihre Cephable-Eingaben erkennen.","detail":"F\xfcr die Gamepad-Unterst\xfctzung ist die Installation von ViGEm, einem inoffiziellen Treiber eines Drittanbieters, erforderlich, um einen virtuellen Xbox-Controller zu emulieren, der von Spielen nativ erkannt wird. Installieren oder aktualisieren Sie den Treiber unten. Verf\xfcgbar f\xfcr Windows x64."},"mobile":{"title":"Cephable Mobile App","description":"Nutzen Sie Ihr Smartphone als zus\xe4tzlichen Controller mit der Cephable-Mobil-App.","detail":"Laden Sie die Cephable-App herunter, um Ihr Smartphone als Controller zu nutzen. Scannen Sie einen Code oder nutzen Sie die Links, um die App f\xfcr iOS oder Android herunterzuladen. Eine Vorschau der App finden Sie unten.","screenshotsTitle":"Vorschau","screenshotPlaceholder":"Screenshot","screenshotAlt":"Screenshot der Cephable-Mobil-App {{number}}","scanTitle":"Scannen zum Herunterladen","ios":"iOS \u2013 App Store","android":"Android \u2013 Google Play","iosAction":"Jetzt im App Store erh\xe4ltlich","androidAction":"Jetzt bei Google Play herunterladen"},"controllerCreator":{"title":"Ersteller benutzerdefinierter Controller","description":"Entwerfen Sie Ihre eigenen Bildschirm-Controller auf controller.cephable.com.","detail":"Mit dem Custom Controller Creator k\xf6nnen Sie Ihre eigenen Bildschirmsteuerungen im Browser entwerfen und teilen.","qrCaption":"controller.cephable.com","action":"Open Controller Creator","screenshotsTitle":"Vorschau","screenshotPlaceholder":"Screenshot des Controller-Erstellers","screenshotAlt":"Screenshot des Custom Controller Creators {{number}}"},"developer":{"title":"Erstellen Sie Ihre eigene Erweiterung","description":"Verwenden Sie die Cephable API und SDKs, um Ihre eigenen Erweiterungen zu erstellen und zu teilen.","detail":"Entwickeln Sie Ihre eigenen Erweiterungen und Integrationen mit Cephable. Erkunden Sie die API und die SDKs und ver\xf6ffentlichen und teilen Sie Ihre Kreationen auf developers.cephable.com.","api":{"title":"Cephable API","description":"Profile, Ger\xe4te, Steuerelemente und Echtzeitereignisse programmatisch verwalten."},"sdk":{"title":"SDKs & Beispiele","description":"Mit unseren SDKs, Beispielen und Integrationsleitf\xe4den gelingt der schnelle Einstieg."},"action":"Gehen Sie zu developers.cephable.com"},"portal":{"title":"Projekte & Teams","description":"Verwalten Sie Ihre Projekte und Teams im Cephable-Portal.","detail":"Mit dem Cephable-Portal k\xf6nnen Sie Ihre Projekte, Teams und Organisationseinstellungen an einem Ort verwalten.","projects":{"title":"Projekte","description":"Projekte, API-Schl\xfcssel und Integrationen erstellen und verwalten."},"teams":{"title":"Teams","description":"Laden Sie Mitglieder ein, weisen Sie Rollen zu und verwalten Sie den Zugriff innerhalb Ihrer Organisation."},"action":"\xd6ffne das Cephable-Portal"},"mcpTools":{"title":"MCP-Tools","description":"Verbinden Sie die Tools des Connect Model Context Protocol, um die Funktionalit\xe4ten von Cephable zu erweitern."},"aiSkills":{"title":"KI-F\xe4higkeiten","description":"F\xfcge wiederverwendbare KI-Funktionen hinzu, die Cephable bei Bedarf ausl\xf6sen kann."},"workflows":{"title":"Wiederverwendbare Arbeitsabl\xe4ufe","description":"Vorgefertigte Automatisierungs-Workflows teilen und installieren."},"controlBundles":{"title":"Steuerungspakete","description":"Installieren Sie kuratierte Pakete von App- und Spielsteuerungen mit einem Fingertipp."},"connections":{"title":"Spiel- und App-Verbindungen","description":"Entdecke Spiele und Apps, die du mit Cephable steuern kannst, wie zum Beispiel Call of Duty: Black Ops 7."},"aiSkillsMarketplace":{"title":"AI Skills Marketplace","description":"Browse and install skills shared by the community."},"nav":{"label":"Erweiterungen durchsuchen","discover":"Entdecken","skills":"F\xe4higkeiten","connectors":"Steckverbinder","features":"Cephable-Funktionen","installed":"Installiert"},"stats":{"rating":"Bewertung","installs":"Installationen","rated":"Danke f\xfcr die Bewertung!","rateError":"Ihre Bewertung konnte nicht gespeichert werden.","yourRating":"Ihre Bewertung"},"copyLink":"Link kopieren","detail":{"access":{"developer":"Entwickler","employee":"Mitarbeiter","plus":"Plus","student":"Student"},"by":"von","categories":"Kategorien","featured":"Empfohlen","installing":"Installation l\xe4uft\u2026","size":"Downloadgr\xf6\xdfe","transport":"Transport","version":"Version"},"discover":{"connectors":"Steckverbinder","coreDescription":"Kameras, Gamepads, Begleit-Apps und Entwicklertools sind in Cephable integriert.","coreTitle":"Cephable-Funktionen","description":"Offizielle und gemeinschaftliche Kompetenzen und Verbindungen zur Erweiterung des Cephable-Assistenten.","empty":"Noch nichts vorhanden. Durchsuchen Sie die Bereiche \u201ESkills\u201C oder \u201EConnectors\u201C, um eigene hinzuzuf\xfcgen.","exploreFeatures":"Funktionen entdecken","featured":"Empfohlen","newest":"Neu und bemerkenswert","skills":"F\xe4higkeiten","title":"Entdecken","viewAll":"Alle anzeigen"},"features":{"description":"Integrierte Steuerungsm\xf6glichkeiten f\xfcr Cephable \u2013 Kameras, Controller, Begleit-Apps und Entwicklertools.","title":"Cephable-Funktionen","searchPlaceholder":"Suchfunktionen\u2026"},"install":"Installieren","installError":"Installation fehlgeschlagen.","installed":"Installiert","linkCopied":"Link kopiert","provenance":{"cephable":"Cephable","mine":"Meins","organization":"Ihre Organisation","thirdParty":"Dritte Seite"},"installedPage":{"connectors":"Steckverbinder","description":"F\xe4higkeiten und Konnektoren, die Sie hinzugef\xfcgt haben. \xd6ffnen Sie einen, um ihn zu verwalten oder zu entfernen.","empty":"Sie haben noch keine F\xe4higkeiten oder Konnektoren hinzugef\xfcgt.","manage":"Verwalten","skills":"F\xe4higkeiten","title":"Installiert","searchPlaceholder":"Installierte Erweiterungen durchsuchen\u2026"},"type":{"skill":"F\xe4higkeit","tool":"Anschluss","input":"Eingang","build":"Bauen","app":"Begleit-App","feature":"Besonderheit"},"publish":{"title":{"mcp":"Teilen Sie diesen MCP-Anschluss","skill":"Diese F\xe4higkeit teilen"},"shareWith":"Wer hat Zugriff darauf?","target":{"organization":"Personen in meiner Organisation","public":"Jeder (\xf6ffentlicher Marktplatz)"},"chooseOrganization":"W\xe4hlen Sie eine Organisation","yourOrganization":"Ihre Organisation","audience":{"public":"Sobald das Cephable-Team die Datei freigegeben hat, kann jeder Cephable-Nutzer sie finden, ansehen und installieren. W\xe4hlen Sie Ihre W\xf6rter und Symbole entsprechend.","organization":"Jeder in {{org}} wird dies finden und installieren k\xf6nnen."},"displayName":"Anzeigename","shortDescription":"Kurzbeschreibung","shortDescriptionHelp":"Eine einzeilige Zusammenfassung wird in den Angeboten angezeigt.","description":"Beschreibung","iconUrl":"Symbol-URL","darkModeIconUrl":"URL des Symbols f\xfcr den Dunkelmodus","categories":"Kategorien","categoriesHelp":"Durch Kommas getrennt (z. B. Produktivit\xe4t, Schreiben).","version":"Version","versionHelp":"Lassen Sie dieses Feld leer, um die automatische Benachrichtigung zu aktivieren.","secretNote":{"mcp":"Es werden nur die nicht geheimen Verbindungsdaten weitergegeben. Ihre API-Schl\xfcssel, Tokens und andere Zugangsdaten verbleiben auf diesem Ger\xe4t \u2013 Benutzer, die es installieren, geben ihre eigenen ein.","skill":"Die Dateien und Anweisungen f\xfcr diese Fertigkeit werden im Ist-Zustand weitergegeben. Bitte entfernen Sie vor der Ver\xf6ffentlichung alle vertraulichen Informationen."},"confirm":"Ver\xf6ffentlichen","submitConfirm":"Zur \xdcberpr\xfcfung einreichen","reviewNote":"\xd6ffentliche Einsendungen werden vom Cephable-Team gepr\xfcft, bevor sie im Marktplatz erscheinen. Sie sehen den Status Ihres Artikels und erhalten eine E-Mail, sobald die Pr\xfcfung abgeschlossen ist.","notes":"Hinweise f\xfcr den Gutachter (optional)","notesHelp":"Alles, was uns bei der \xdcberpr\xfcfung hilft \u2013 was es bewirkt und was sich seit dem letzten Mal ge\xe4ndert hat.","inReview":"Dieser Antrag wird bereits gepr\xfcft. Bitte ziehen Sie den aktuellen Antrag zur\xfcck, um die \xc4nderungen vorzunehmen, und reichen Sie ihn anschlie\xdfend erneut ein.","withdraw":"Einreichung zur\xfcckziehen","resubmitConfirm":"Zur erneuten \xdcberpr\xfcfung einreichen","resubmitNote":"Diese Ver\xf6ffentlichung wurde nicht genehmigt. Bitte ber\xfccksichtigen Sie das untenstehende Feedback und reichen Sie die Ver\xf6ffentlichung anschlie\xdfend erneut zur Pr\xfcfung ein.","previousFeedback":"Feedback des Rezensenten","publicRestricted":"Ihre Organisation erlaubt keine Ver\xf6ffentlichung auf dem \xf6ffentlichen Marktplatz, daher kann dies nur innerhalb Ihrer Organisation geteilt werden."},"reviewStatus":{"section":"\xd6ffentliche Marktplatzbewertung","reasonLabel":"Anmerkung des Rezensenten","pending":"Zusammenfassung","published":"Ver\xf6ffentlicht","rejected":"\xc4nderungen angefordert","removed":"ENTFERNT","pendingTitle":"Wir warten auf die \xdcberpr\xfcfung von Cephable, bevor es auf dem \xf6ffentlichen Markt erscheint.","publishedTitle":"Zugelassen und im \xf6ffentlichen Marktplatz gelistet.","rejectedTitle":"Nicht zur Ver\xf6ffentlichung freigegeben \u2013 siehe Anmerkung des Pr\xfcfers, dann erneut einreichen.","removedTitle":"Vom Moderator aus dem \xf6ffentlichen Marktplatz entfernt.","notify":{"published":"\u201E{{name}}\u201C wurde genehmigt und ist jetzt im Marktplatz verf\xfcgbar.","rejected":"\u201E{{name}}\u201C muss vor der Ver\xf6ffentlichung noch \xfcberarbeitet werden. \xd6ffnen Sie die Datei, um das Feedback des Gutachters zu sehen.","removed":"\u201E{{name}}\u201C wurde vom \xf6ffentlichen Marktplatz entfernt."}},"managedBy":"Verwaltet von {{provenance}}","integrationType":{"cephable":"offizielle Integration","mine":"pers\xf6nliche Integration","organization":"Organisationsintegration","thirdParty":"Drittanbieterintegration"},"automateHttpServer":{"title":"Automatisieren Sie den HTTP-Server","description":"Verbinden Sie lokale Dienste \xfcber HTTP mit dem ger\xe4teinternen Automate-Assistenten von Cephable.","detail":"Der Automate-HTTP-Server erm\xf6glicht es lokalen Diensten, Entwicklungswerkzeugen und Evaluierungs-Runnern, den Cephable-Versandassistenten zu nutzen. Er akzeptiert Verbindungen nur von diesem Ger\xe4t, erfordert bei jeder Anfrage den generierten Schl\xfcssel und beschr\xe4nkt Dateivorg\xe4nge auf einen isolierten Automate-Arbeitsbereich.","proRequired":"Der Automate HTTP-Server ist in Cephable Professional enthalten.","running":"L\xe4uft","stopped":"Angehalten","port":"Hafen","endpoint":"Endpunkt","api":{"title":"Wie man eine Verbindung herstellt","description":"Nutzen Sie den Server von einem lokalen Skript, einer Desktop-Anwendung oder einem Automatisierungstool aus, das auf diesem Computer ausgef\xfchrt wird.","routes":{"chat":"Chat","run":"Automatisierte Ausf\xfchrung","health":"Gesundheit","models":"Modelle","modelMode":"Modellmodus (Ihre eigene Agentenschleife)","tools":"Eingebaute Werkzeuge","speech":"Sprachergebnisse","settings":"Einstellungen"},"steps":{"enable":"Aktivieren Sie diese Erweiterung \xfcber die zugeh\xf6rige Karte, lassen Sie Cephable ge\xf6ffnet und vergewissern Sie sich, dass der Status oben \u201EWird ausgef\xfchrt\u201C anzeigt.","copyKey":"Kopieren Sie den unten stehenden Zugriffsschl\xfcssel. Senden Sie ihn bei jeder Anfrage im Authorization-Header als Bearer <Zugriffsschl\xfcssel>.","sendRequest":"Verwenden Sie den oben gezeigten Endpunkt und senden Sie eine JSON-Anfrage per POST an /v1/chat/completions. Bestehende OpenAI-kompatible Clients k\xf6nnen cephable-agent als Modellnamen verwenden, um den vollst\xe4ndigen Assistenten auszuf\xfchren, oder cephable-model, um Cephable als Modell in ihrem eigenen Agenten zu nutzen.","readResponse":"Lesen Sie die Antwort des Assistenten aus choices[0].message.content. Falls ein Client keine Verbindung herstellen kann, senden Sie GET /health mit demselben Autorisierungsheader."}},"key":"Zugangsschl\xfcssel","keyDescription":"Verwenden Sie diesen Schl\xfcssel als Bearer-Token f\xfcr lokale Clients. Er wird im sicheren Speicher Ihres Betriebssystems verschl\xfcsselt und niemals mit Cephable synchronisiert.","copyKey":"Zugriffsschl\xfcssel kopieren","copyError":"Der Zugriffsschl\xfcssel f\xfcr den Automate-Server konnte nicht kopiert werden.","regenerateKey":"Zugriffsschl\xfcssel neu generieren","keyRegenerated":"Automatische Neugenerierung des Serverzugriffsschl\xfcssels.","example":{"title":"Node.js-Anfragebeispiel","description":"Dieses Beispiel enth\xe4lt bereits den Endpunkt und den aktuellen Zugriffsschl\xfcssel. Kopieren Sie es in ein vertrauensw\xfcrdiges lokales Node.js-Skript und ersetzen Sie die Beispiel-Eingabeaufforderung durch Ihre Aufgabe.","copy":"Beispiel f\xfcr eine Kopieranfrage","copyError":"Das Anfragebeispiel konnte nicht kopiert werden."},"useCases":{"title":"Ideen f\xfcr die Nutzung des Servers","description":"Alles, was eine lokale HTTP-Anfrage stellen kann, kann den ger\xe4teinternen Automate-Assistenten von Cephable um Hilfe bitten.","localAutomation":"Verbinden Sie lokale Skripte, Shortcut-Tools, Desktop-Dienstprogramme oder Automatisierungsplattformen mit einem Automate-Workflow.","privateText":"Texte innerhalb eines internen Tools umschreiben, zusammenfassen, klassifizieren oder \xfcbersetzen, w\xe4hrend die Schlussfolgerungen auf diesem Ger\xe4t erhalten bleiben.","accessibleInputs":"Mit benutzerdefinierten Schaltern, Sensoren oder Begleitsoftware l\xe4sst sich eine zug\xe4ngliche Eingabe in eine umfangreichere Automatisierungsaufgabe verwandeln.","testing":"F\xfchren Sie Regressionstests f\xfcr Eingabeaufforderungen und Arbeitsabl\xe4ufe mit demselben Assistenten, denselben F\xe4higkeiten, denselben Werkzeugen und demselben lokalen Modell durch, die auch von der Cephable-App verwendet werden."},"security":{"title":"Zugriff lokal und sicher halten","description":"Der Server lauscht ausschlie\xdflich auf 127.0.0.1, daher k\xf6nnen Remote- und Cloud-Dienste keine direkte Verbindung herstellen. Behandeln Sie den Zugriffsschl\xfcssel wie ein Passwort und geben Sie ihn nur an vertrauensw\xfcrdige Software weiter. Durch die Neuerstellung des Schl\xfcssels werden Clients, die den vorherigen Schl\xfcssel verwenden, sofort getrennt."},"secureStorageUnavailable":"Dieser Server kann nicht aktiviert werden, da kein sicherer Betriebssystemspeicher verf\xfcgbar ist.","error":"Der Automate-HTTP-Server konnte nicht aktualisiert werden.","portMoved":"Der Port {{preferredPort}} war auf diesem Ger\xe4t bereits belegt, daher startete der Server stattdessen auf Port {{port}}. Verwenden Sie in Ihren Tools den oben genannten Endpunkt, nicht den Standardendpunkt.","portMovedTitle":"Anderer Port in Gebrauch"},"workflowRecording":{"title":"Workflow aufzeichnen","description":"Zeigen Sie Cephable einmal, wie Sie eine Aufgabe erledigen, und Cephable wandelt die Aufnahme in eine F\xe4higkeit um, die es f\xfcr Sie ausf\xfchren kann.","previewBadge":"Vorschau","detail":"Mit der Funktion \u201EWorkflow aufzeichnen\u201C wird Ihre Arbeit w\xe4hrend der Ausf\xfchrung einer Aufgabe \xfcberwacht \u2013 die Apps, zwischen denen Sie wechseln, die Schaltfl\xe4chen und Felder, die Sie anklicken, Ihre Eingaben und Ihre gesprochenen Worte. Nach Beendigung der Aufgabe wandelt Cephable die Aufzeichnung in eine KI-F\xe4higkeit um, die Sie \xfcberpr\xfcfen, bearbeiten und speichern k\xf6nnen. Wenn Sie Automate das n\xe4chste Mal mit einer \xe4hnlichen Aufgabe beauftragen, dient diese F\xe4higkeit als Leitfaden und w\xe4hlt den direktesten Weg, anstatt jeden Klick zu wiederholen.","howItWorks":{"title":"So funktioniert es","record":"Starten Sie eine Aufzeichnung im Arbeitsbereich, auf der Registerkarte \u201EAutomatisieren\u201C oder in den KI-F\xe4higkeiten und f\xfchren Sie die Aufgabe dann von Anfang bis Ende aus.","narrate":"Erkl\xe4re ausf\xfchrlich, was du tust und warum. Deine Erl\xe4uterungen werden zur Begr\xfcndung f\xfcr jeden einzelnen Schritt.","review":"Stoppe die Aufnahme, um einen Entwurf der Fertigkeit zu erhalten. \xdcberpr\xfcfe die Schritte und die Beschreibung, bevor du sie speicherst.","run":"Bitten Sie Automate, die Aufgabe erneut auszuf\xfchren. Das Programm liest die Aufzeichnung als Referenz und passt sie an Ihre Anforderungen an."},"captured":{"title":"Was wird aufgezeichnet?","description":"Ihre Klicks, Tastendr\xfccke, App-Wechsel sowie die Namen und IDs der verwendeten Bedienelemente und Ihre Sprachaufnahme (sofern ein Mikrofon verf\xfcgbar ist) werden auf diesem Ger\xe4t verarbeitet. Schritte, die Sie lediglich an ein Ziel f\xfchren, wie das \xd6ffnen eines neuen Browser-Tabs und das Eingeben einer Adresse, werden zu einem einzigen Schritt zusammengefasst. Vermeiden Sie die Eingabe von Passw\xf6rtern oder Zahlungsdaten w\xe4hrend der Aufnahme."},"whereToFind":{"title":"Wo man es finden kann","workspace":"Arbeitsbereich: das Band \u201EWorkflow aufzeichnen\u201C unter den Vorschl\xe4gen \u201EErstellen und Automatisieren\u201C.","automate":"Registerkarte \u201EAutomatisieren\u201C im Cephable-Panel: der Vorschlag \u201ECephable einen Workflow beibringen\u201C und das Composer-Men\xfc.","skills":"Erweiterungen \u2192 KI-F\xe4higkeiten: F\xe4higkeit erstellen \u2192 Aufzeichnen, was ich tue."},"previewNotice":"Dies ist eine Vorschaufunktion. Sie kann sich bis zur Ver\xf6ffentlichung noch \xe4ndern, und Ihr Feedback hilft dabei, sie zu optimieren.","proRequired":"Die Funktion \u201EWorkflow aufzeichnen\u201C ist in Cephable Professional verf\xfcgbar.","startAction":"Einen Workflow aufzeichnen"}},"sensitivityValues":{"verySensitive":"Sehr empfindlich","high":"Hoch","medium":"Medium","low":"Niedrig","notSensitive":"Nicht empfindlich"},"summarize":"Zusammenfassen","appControlsPanel":{"searchPlaceholder":"Suchbefehle...","searchLabel":"Suchbefehle","favorites":{"title":"Favoriten","description":"Favoriten sind Steuerelemente, die Sie h\xe4ufig verwenden. Sie k\xf6nnen einen Befehl als Favorit markieren, indem Sie auf das Sternsymbol daneben klicken."},"noCommandsFound":"Keine Befehle gefunden","globalCommands":"Global","prefixCommandToast":"Dies ist ein Pr\xe4fixbefehl \u2013 sagen oder tippen Sie das Pr\xe4fix gefolgt von der Phrase, um ihn auszul\xf6sen."},"collapse":"Zusammenbruch","intelligentTasks":{"loading":{"loadingModels":"KI-Modelle werden geladen...","extractingModels":"Extraktion von KI-Modellen..."}},"sidebar":{"collapse":"Seitenleiste ausklappen","expand":"Seitenleiste erweitern"},"workspace":{"title":"Arbeitsplatz","badge":"Auf dem Ger\xe4t \xb7 privat","subtitle":"Ihr KI-Assistent l\xe4uft vollst\xe4ndig auf diesem Ger\xe4t. Starten Sie die Steuerung, erstellen Sie Prozesse, automatisieren Sie Aufgaben oder chatten Sie einfach.","control":{"title":"Kontrolle","description":"Sprachbefehle, Tastaturk\xfcrzel und Schnellaktionsschaltfl\xe4chen \u2013 funktionieren in jeder App auf Ihrem Ger\xe4t.","voice":{"title":"Sprachsteuerung","description":"Freisprechfunktion"},"dictation":{"title":"Diktat","description":"Sprechen Sie mit dem Text"},"computerUse":{"title":"Computernutzung","description":"Lassen Sie den Assistenten handeln."},"camera":{"title":"Kamerasteuerung","description":"Gesichts- und Kopfbewegungen"},"quickActions":{"title":"Schnelle Aktionen","description":"Ein-Klick-Tastenkombinationen"}},"create":{"title":"Erstellen","description":"Entwerfen, \xfcberarbeiten, neu formatieren und \xfcbersetzen \u2013 direkt in der App, in der Sie gerade arbeiten, mithilfe von kopiertem und markiertem Text.","items":{"draftEmail":"E-Mail entwerfen","writeDocument":"Schreiben Sie ein Dokument","summarizeNotes":"In Notizen zusammenfassen","polishWriting":"Meine Schrift polieren","translateText":"Text \xfcbersetzen","socialPost":"Verfasse einen Social-Media-Beitrag","cd_brief":"Erstellen Sie ein Kreativbriefing","cd_caption":"Verfasse eine Bildunterschrift und einen Alternativtext.","ar_insights":"Fassen Sie die Ergebnisse zu Erkenntnissen zusammen.","ar_exec":"Verfassen Sie eine Managementzusammenfassung","cc_followup":"Verfassen Sie eine Folge-E-Mail","cc_meetingNotes":"Aus Notizen ein Besprechungsprotokoll erstellen","bd_commit":"Schreibe eine Commit-Nachricht","bd_review":"Fassen Sie eine Code-\xdcberpr\xfcfung zusammen","gp_bio":"Schreibe eine Stream-Bio","gp_recap":"Zusammenfassung der gestrigen Sitzung","lt_lesson":"Erstellen Sie einen Unterrichtsplan","lt_studyNotes":"Fassen Sie es in Lernnotizen zusammen.","mo_agenda":"Entwurf einer Sitzungsagenda","mo_update":"Schreiben Sie ein Projektupdate","aa_simplify":"Vereinfachen Sie Ihre Sprache.","aa_describe":"Beschreibe ein Bild in Worten"},"contextRow":{"highlightedText":"Text markieren / in die Zwischenablage kopieren","output":"Eingabe:","input":"Anwendungsgebiete:","background":"Hintergrund","currentapp":"Aktuelle App"},"prompts":{"draftEmail":"Verfassen Sie eine klare, professionelle E-Mail zu diesem Thema.","writeDocument":"Verfassen Sie ein Dokument dar\xfcber.","summarizeNotes":"Fassen Sie dies in pr\xe4gnanten, gut strukturierten Stichpunkten zusammen.","polishWriting":"\xdcberarbeiten Sie den Text so, dass er klarer und pr\xe4ziser ist, wobei Sie meine Bedeutung und meinen Tonfall beibehalten.","socialPost":"Verfasse einen kurzen, ansprechenden Social-Media-Beitrag zu diesem Thema.","cd_brief":"Erstellen Sie ein Kreativkonzept f\xfcr dieses Projekt.","ar_insights":"Fassen Sie die wichtigsten Ergebnisse und Erkenntnisse aus diesen Daten zusammen.","ar_exec":"Verfassen Sie hierf\xfcr eine pr\xe4gnante Managementzusammenfassung.","cc_followup":"Verfassen Sie eine Folge-E-Mail zu diesem Thema.","cc_meetingNotes":"Verwandeln Sie diese Notizen in \xfcbersichtliche Besprechungsprotokolle mit konkreten Handlungsempfehlungen.","bd_commit":"Verfassen Sie eine aussagekr\xe4ftige Commit-Nachricht f\xfcr diese \xc4nderungen:","bd_review":"Fassen Sie diese Code-\xdcberpr\xfcfung in den wichtigsten Punkten und den erforderlichen \xc4nderungen zusammen.","gp_bio":"Verfasse eine pr\xe4gnante Bio f\xfcr meinen Stream/mein Profil.","lt_lesson":"Entwerfen Sie einen Unterrichtsplan zu diesem Thema.","lt_studyNotes":"Fassen Sie dieses Material in Lernnotizen zusammen, die ich wiederholen kann.","mo_agenda":"Erstellen Sie eine Tagesordnung f\xfcr die Besprechung, die diesen Punkt abdeckt.","mo_update":"Verfassen Sie auf dieser Grundlage einen Projektstatusbericht f\xfcr die Stakeholder.","aa_simplify":"Schreiben Sie dies in einfacher, leicht verst\xe4ndlicher Sprache."}},"automate":{"title":"Automatisieren","description":"Beschreiben Sie eine Aufgabe in einfacher Sprache, und Cephable f\xfchrt sie in Ihren Anwendungen, Ihren Dateien und sogar in Ihrer Kommandozeile aus.","items":{"triage":"Priorisiere meine E-Mails","cd_exportAssets":"Assets umbenennen und ablegen","cd_moodboard":"Referenzen sammeln","cc_triage":"Priorisierung und Entwurf von Antworten","cc_recap":"Zusammenfassung & an das Team senden","bd_scaffold":"Ger\xfcst f\xfcr ein Projekt","gp_schedule":"Plane einen Stream-Zeitplan","lt_handout":"Erstellen Sie ein Handout","summarizeSend":"Zusammenfassen & per E-Mail senden","researchDoc":"Recherchieren und ein Dokument schreiben","organizeFiles":"Meine Dateien organisieren","cleanUp":"einen Ordner aufr\xe4umen","wordDoc":"Erstellen Sie ein Word-Dokument","ar_summarizeSend":"Zusammenfassen & per E-Mail senden","ar_analyzeData":"Eine Tabellenkalkulation analysieren","ar_deck":"Erstelle ein Deck aus Daten","cc_summarizeEmail":"In einer E-Mail zusammenfassen","cc_socialPost":"Beitrag \xfcber einen Link","bd_buildTest":"Ein Projekt erstellen und testen","bd_cleanup":"Vorschl\xe4ge zur Codebereinigung","lt_studyMaterial":"Lernmaterialien erstellen","lt_accommodation":"Erstellen Sie barrierefreie Notizen","lt_research":"Recherchieren und vergleichen","mo_meetingActions":"Notizen in Handlungen umsetzen","mo_organizeFiles":"Meine Dateien organisieren","mo_cleanup":"Downloads aufr\xe4umen","aa_translate":"Ein Dokument \xfcbersetzen"},"prompts":{"summarizeSend":"Fassen Sie den Inhalt des Ordners <folder> zusammen und senden Sie ihn per E-Mail an <team email>.","researchDoc":"Analysiere die Trends in <Ordner oder Dokument> und fasse deine Ergebnisse in einem neuen Dokument zusammen.","organizeFiles":"Kopieren Sie die Dateien von<source folder> hinein<destination folder> Die","cleanUp":"Entferne alle <Dateitypen, z. B. Screenshots> aus meinem <Ordner>.","wordDoc":"Verwenden<article or notes> um ein Microsoft Word-Dokument zu erstellen, das<does what> Die","triage":"Gehen Sie meinen Posteingang durch und teilen Sie mir mit, was meine Aufmerksamkeit erfordert. Entwerfen Sie anschlie\xdfend Antworten, wo dies n\xf6tig ist.","cd_exportAssets":"Benennen Sie die Design-Assets im Ordner <folder> nach diesem Schema \u2014 <benennungsschema> \u2014 um und sortieren Sie sie in Ordner.","cd_moodboard":"Suchen Sie online nach Referenzen f\xfcr <Idee> und fassen Sie diese in einem Dokument zusammen.","ar_summarizeSend":"Fassen Sie den Inhalt des Ordners <folder> zusammen und senden Sie ihn per E-Mail an <team email>.","ar_analyzeData":"Analysiere die <Tabellenkalkulation> und finde heraus, <worauf du achten solltest, z. B. auf Schl\xfcsselverluste>.","ar_deck":"Die Ergebnisse aus dem <Dokument oder Ordner> werden in eine PowerPoint-Pr\xe4sentation umgewandelt, die <die wichtigsten Punkte> hervorhebt.","cc_triage":"Lesen Sie meinen Posteingang und verfassen Sie Antwortentw\xfcrfe f\xfcr alle Nachrichten, die eine Antwort erfordern.","cc_summarizeEmail":"Verfassen Sie eine E-Mail mit folgender Zusammenfassung:<article or document> und auf die wichtigsten technischen Details hinweisen.","cc_recap":"Verfassen Sie eine Zusammenfassung der <Besprechungsnotizen> und senden Sie diese per E-Mail an <Team-E-Mail>.","cc_socialPost":"Lesen<article or website> und schreiben Sie eine<platform, e.g. Discord> -Schreibe einen freundlichen Beitrag dar\xfcber und speichere ihn dann in einer neuen Notiz.","bd_buildTest":"\xdcberpr\xfcfen Sie den Code im <Projektordner>, kompilieren Sie ihn und f\xfchren Sie die Tests aus. Sollte etwas fehlschlagen, pr\xfcfen Sie den Git-Verlauf und teilen Sie mir mit, was wahrscheinlich den Fehler verursacht hat.","bd_cleanup":"Schau dir den Code im <Projektordner> an und sag mir, wie ich ihn \xfcbersichtlicher gestalten kann.","bd_scaffold":"Erstelle ein neues <Projekttyp>-Projekt im <Ordner> mit den ben\xf6tigten Startdateien.","gp_schedule":"Plane einen Streaming-Zeitplan f\xfcr<time period> Abdeckung<games or activities> Die","lt_studyMaterial":"Verwenden<article or notes> um ein Word-Dokument zu erstellen f\xfcr<grade level> Studenten mit<reflection questions or a study guide> Die","lt_accommodation":"Erstellen Sie ein Word-Dokument mit Vorlesungsnotizen zum Thema <Thema>, formatiert f\xfcr einen Studenten mit <Unterst\xfctzung>.","lt_handout":"Die Lesetexte im Ordner <folder> sollen zu einem einzigen Handout-Dokument zusammengefasst werden.","lt_research":"Suche online nach <Thema, z. B. B\xfccher zum Thema Neurodiversit\xe4t> und erstelle ein Dokument, das jedes Buch zusammenfasst, damit ich es vergleichen kann.","mo_meetingActions":"Lesen Sie die Besprechungsnotizen: Was ist noch zu tun, wer ist verantwortlich und was bedarf weiterer Recherche? Teilen Sie die Notizen in Dateien auf und ordnen Sie diese in einem Ordner.","mo_organizeFiles":"Kopieren Sie die Dateien von<source folder> hinein<destination folder> Die","mo_cleanup":"Entferne alle <Dateitypen, z. B. Installationsdateien> aus meinem Download-Ordner.","aa_translate":"\xdcbersetzen Sie <Dokument> in <Sprache> und speichern Sie es im <Ordner>."}},"history":{"title":"Neuere KI-Geschichte","description":"Ihre neuesten intelligenten Aufgaben und Automatisierungen.","viewAll":"Alle Verlaufsseiten anzeigen","empty":"Ihre zuletzt ausgef\xfchrten KI-Aufgaben und Automatisierungen werden hier angezeigt."},"badgeRemote":"Fernger\xe4t \xb7 sicher","browser":{"openButton":"Browser \xf6ffnen","windowTitle":"Cephable-Browser","newTab":"Neuer Tab","reload":"Neu laden","forward":"Nach vorne","openExternal":"Im Standardbrowser \xf6ffnen","showWindow":"Versteckten Browser anzeigen","addressPlaceholder":"Suche bei Google oder gib eine URL ein.","clearData":{"description":"L\xf6schen Sie den Verlauf, die Cookies, die zwischengespeicherten Daten und die gespeicherten Anmeldedaten des Cephable-Browsers. Dadurch werden Sie von allen Websites im Cephable-Browser abgemeldet.","button":"Browserdaten l\xf6schen","cleared":"Browserdaten gel\xf6scht.","error":"Browserdaten konnten nicht gel\xf6scht werden.","confirmTitle":"Browserdaten l\xf6schen?","confirmMessage":"Von allen Programmen im Cephable-Browser abmelden?","confirmDetail":"Dadurch werden Verlauf, Cookies, zwischengespeicherte Daten und gespeicherte Anmeldedaten des Cephable-Browsers endg\xfcltig gel\xf6scht. Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden.","confirm":"Klare Daten","cancel":"Stornieren"},"context":{"newTab":"Neuer Tab","reload":"Neu laden","duplicate":"Doppelte Registerkarte","close":"Tab schlie\xdfen","closeOthers":"Andere Tabs schlie\xdfen","closeRight":"Schlie\xdfen Sie die Tabs rechts.","back":"Zur\xfcck","forward":"Nach vorne","openLinkNewTab":"Link in neuem Tab \xf6ffnen","openLinkExternal":"Link im Standardbrowser \xf6ffnen","openExternal":"Im Standardbrowser \xf6ffnen","openAllExternal":"Alle Tabs im Standardbrowser \xf6ffnen"},"home":{"tabTitle":"Heim","title":"Der Cephable-Browser","tagline":"Ein separater Browser, Cephable kann f\xfcr Sie gesteuert werden.","description":"Hier automatisiert Cephable Webaufgaben f\xfcr Sie. Es l\xe4uft unabh\xe4ngig von Ihrem gewohnten Browser, sodass Ihre normalen Tabs, Logins und Ihr Surfverhalten unber\xfchrt bleiben, w\xe4hrend die Automatisierungen hier \u2013 sogar im Hintergrund \u2013 ausgef\xfchrt werden.","searchPlaceholder":"Suchen Sie bei Google oder geben Sie eine URL ein, um loszulegen.","go":"Gehen","features":{"separate":{"title":"L\xe4uft von selbst","description":"Getrennt von Ihrem Standardbrowser, sodass Automatisierungen Ihr pers\xf6nliches Surfverhalten niemals st\xf6ren."},"automate":{"title":"F\xfcr die Automatisierung entwickelt","description":"Cephable kann hier freih\xe4ndig Seiten \xf6ffnen, Formulare ausf\xfcllen und Informationen sammeln."},"handoff":{"title":"jederzeit \xfcbergeben","description":"\xd6ffnen Sie jederzeit eine beliebige Seite in Ihrem Standardbrowser, um die Kontrolle zu \xfcbernehmen."}}}},"scheduledTasks":{"title":"Geplante Aufgaben","description":"Automatisierungen, die zu einem von Ihnen gew\xe4hlten Zeitpunkt auf diesem Ger\xe4t ausgef\xfchrt werden.","viewAll":"Alle geplanten Termine anzeigen","empty":"Planen Sie eine Eingabeaufforderung aus dem Bedienfeld, und sie wird hier angezeigt."},"subtitleRemote":"Alles, was Sie anklicken oder eingeben, steht Ihnen zur Verf\xfcgung.","suggestions":{"viewMore":"Mehr anzeigen","viewMoreTooltip":"Durchsuchen Sie alle vorgeschlagenen Eingabeaufforderungen.","dialogTitle":"Alle Vorschl\xe4ge","dialogDescription":"W\xe4hlen Sie einen Startpunkt. Die Datei wird in den Composer eingef\xfcgt, sodass Sie sie vor der Ausf\xfchrung bearbeiten k\xf6nnen.","rotationLabel":"Vorschl\xe4ge f\xfcr die Eingabeaufforderung","empty":"Es liegen keine Vorschl\xe4ge vor."}},"noResults":"Keine Ergebnisse","noResultsSearch":"Ihre Suche ergab keine Treffer.","interrupted":"Unterbrochen","aiHistory":{"title":"KI-Geschichte","description":"Lokalen KI-Konversationsverlauf ansehen, durchsuchen und verwalten.","empty":{"title":"Noch keine KI-Geschichte","description":"Ihr KI-Konversationsverlauf wird hier angezeigt, nachdem Sie intelligente Aufgaben verwendet haben."},"search":{"placeholder":"Konversationen durchsuchen..."},"pagination":{"range":"Anzeige von {{start}}\u2013{{end}} von {{total}}"},"source":{"create":"Erstellen","automate":"Automatisieren"},"workflow":{"plan":"Planen","steps":"Schritte","files":"Dateien","folders":"Ordner","interruptedNotice":"Ihr Arbeitsablauf wurde unterbrochen. Bitte versuchen Sie es erneut."},"trace":{"thinking":"Denken","toolCalls":"Tool-Aufrufe","roles":{"tool":"Ergebnis des Tools"},"thought":"Gedanke","action":"Aktion","parameters":"Parameter","result":"Ergebnis","reply":"Du hast geantwortet","sources":"Quellen"},"task":{"instructions":"Anweisungen","language":"Sprache","types":{"generate":"Erzeugen","rewrite":"Umschreiben","translate":"\xdcbersetzen","summarize":"Zusammenfassen"}},"session":{"messages":"Nachrichten","deleteTitle":"Unterhaltung l\xf6schen","deleteDescription":"M\xf6chten Sie diese Konversation wirklich l\xf6schen? Dies kann nicht r\xfcckg\xe4ngig gemacht werden.","deleteConfirm":"L\xf6schen","deleteCancel":"Stornieren"},"clear":{"title":"Clear AI-Historie","description":"L\xf6schen Sie den gesamten lokal gespeicherten KI-Konversationsverlauf von diesem Ger\xe4t.","confirm":{"title":"Clear AI-Historie","description":"Sind Sie sicher, dass Sie den gesamten KI-Konversationsverlauf l\xf6schen m\xf6chten? Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden.","confirm":"Alles l\xf6schen","cancel":"Stornieren"},"success":"KI-Verlauf erfolgreich gel\xf6scht.","error":"Fehler beim L\xf6schen des KI-Verlaufs."},"export":{"title":"Export","description":"Exportieren Sie Ihren KI-Konversationsverlauf in eine JSONL-Datei.","success":"KI-Verlauf erfolgreich exportiert.","error":"Der Export des KI-Verlaufs ist fehlgeschlagen.","session":{"title":"Exportlauf","success":"Der Export wurde erfolgreich abgeschlossen.","error":"Dieser Lauf konnte nicht exportiert werden."}},"retention":{"note":"Ihre {{count}} letzten Konversationen werden gespeichert. Favoriten bleiben immer erhalten.","label":"Halten"},"filter":{"label":"Nach Typ filtern","all":"Alle Arten"},"favorites":{"title":"Favoriten","add":"Zu Favoriten hinzuf\xfcgen","remove":"Aus Favoriten entfernen"},"select":{"selectOne":"Gespr\xe4ch ausw\xe4hlen","selected":"{{count}} ausgew\xe4hlt","deleteSelected":"Ausgew\xe4hlte l\xf6schen","clear":"Klar","deleteTitle":"Ausgew\xe4hlte Konversationen l\xf6schen","deleteDescription":"{{count}} ausgew\xe4hlte Konversationen l\xf6schen? Dies kann nicht r\xfcckg\xe4ngig gemacht werden."},"copy":{"label":"Kopie","success":"In die Zwischenablage kopiert.","error":"Fehler beim Kopieren in die Zwischenablage."},"live":"Live","keychain":{"continue":"Weitermachen","title":"Schutz der KI-Geschichte","message":"Cephable verschl\xfcsselt Ihren KI-Verlauf, einschlie\xdflich des Workflow-Verlaufs, auf diesem Mac.","detail":"macOS fragt Sie als N\xe4chstes, ob Sie den Zugriff auf \u201ECephable Safe Storage\u201C erlauben m\xf6chten. Dieser Speicher enth\xe4lt lediglich den Verschl\xfcsselungsschl\xfcssel, nicht Ihre Arbeitsabl\xe4ufe oder Aufgabeninhalte. W\xe4hlen Sie \u201EImmer erlauben\u201C, damit Ihre verschl\xfcsselte Historie weiterhin verf\xfcgbar bleibt und Sie nicht erneut gefragt werden. Wenn Sie dieses Mal \u201EErlauben\u201C w\xe4hlen, kann Cephable darauf zugreifen, macOS kann Sie jedoch bei einem sp\xe4teren Start erneut fragen."},"rename":{"title":"Umbenennen","label":"Gespr\xe4chstitel"}},"uses":"Verwendung: {{value}}","skills":{"intro":"Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.","create":"Create skill","importFolder":"Import folder","importZip":"Import .zip","importError":"Could not import the skill.","enable":"Enable","openFolder":"Open folder","deleteConfirm":"Delete?","emptyTitle":"No skills yet","emptyBody":"Create your first skill or import one to get started.","sharingComingSoon":"Sharing skills with your organization and a skills marketplace are coming soon.","source":{"user":"Created by you","imported":"Imported","organization":"Organization","marketplace":"Marketplace"},"bestPractices":{"title":"Tips for great skills","description":"Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.","focused":"Keep instructions short and focused on one job. Use numbered steps in the order they should happen.","examples":"Add a short example of a request the skill handles and the ideal result.","keywords":"Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.","trust":"Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer.","activation":"Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. release-notes","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What the skill does and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use the skill. Be specific.","keywordsLabel":"Keywords (optional)","keywordsPlaceholder":"comma, separated, words","keywordsHelp":"Extra words that should trigger this skill (brand names, aliases, file types).","instructionsLabel":"Instructions (SKILL.md)","instructionsPlaceholder":"Step-by-step instructions for the assistant. Leave blank to start from a template.","save":"Save changes","create":"Create skill","saveError":"Could not save the skill.","activationLabel":"When should the assistant use this?"},"picker":{"title":"Skills","empty":"No matching skills","hint":"Type to filter skills"},"contextMenuItem":"Skill\u2026","chipRemove":"Remove skill","attached":"Attached skills","inUse":"Using skills:","section":{"title":"AI Skills","description":"Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."},"createDescription":"Build a reusable skill from scratch or a template.","import":"Import a skill","importDescription":"Add a skill from a folder or a .zip file.","copy":"Copy an existing skill","copyDescription":"Start from a copy of one of your skills.","copyShort":"Copy","editTitle":"Edit skill","newTitle":"New skill","templates":{"title":"Start from a template","blank":{"title":"Blank","summary":"Start from an empty template."},"navigateApp":{"title":"Navigate an app (click in steps)","summary":"Tell Cephable where to click, step by step, to get through an app."},"writeText":{"title":"Write or insert text","summary":"Draft text a certain way and type it where I am working."},"fillForm":{"title":"Fill out a form","summary":"Fill a form field by field from details I give you."},"summarizeDoc":{"title":"Summarize a document","summary":"Read a file and give a short, structured summary."},"start":"Beginnen Sie mit einer Vorlage\u2026","applied":"Vorlage angewendet \u2013 bearbeiten Sie die Details unten."},"activation":{"label":"Activation","auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant picks this skill on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never picks this on its own \u2014 it runs only when you attach it with / or @."},"mode":{"label":"How this skill is used","off":"Off","offTooltip":"Off \u2014 this skill is never used or shown in the picker."},"viewDetails":"View details","files":{"label":"Reference files & scripts","help":"Add files your skill uses \u2014 the assistant reads references and can run scripts. Mention them in your instructions above.","empty":"No files added yet.","add":"Add file\u2026","remove":"Remove file","addError":"Could not add the file.","kind":{"reference":"Reference file","script":"Script","asset":"Asset","referenceShort":"Reference","scriptShort":"Script","assetShort":"Asset"},"open":"Open file"},"scriptsSetting":{"label":"Let skills run scripts","help":"When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."},"capability":{"script":{"label":"Runs scripts","tooltip":"This skill can run programs on your computer \u2014 you approve each one before it runs. Only use skills you trust."},"reference":{"label":"Uses reference files","tooltip":"This skill includes reference files the assistant can read for detail. It does not run programs on your computer."},"basic":{"label":"Instructions only","tooltip":"This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."},"alsoReferences":"It also includes reference files it reads.","scriptsOff":"Script running is currently turned off in settings."},"teach":{"action":"Lehren Sie es als Fertigkeit","generating":"Lehre\u2026","title":"Eine Fertigkeit vermitteln","heading":"Bringe Cephable eine neue F\xe4higkeit bei","subheading":"Cephable hat Ihre Aktion in eine wiederverwendbare F\xe4higkeit umgewandelt. \xdcberpr\xfcfen und optimieren Sie sie unten und speichern Sie sie anschlie\xdfend, damit der Assistent dies erneut f\xfcr Sie und alle anderen, mit denen Sie die F\xe4higkeit teilen, ausf\xfchren kann.","fromRun":"Basierend auf: {{title}}","filesTitle":"Zu enthaltende Dateien","filesHelp":"Dies sind Dateien aus deinem Durchlauf, die die Wiederholbarkeit der Fertigkeit erm\xf6glichen. Behalte die Dateien, die f\xfcr die Wiederholbarkeit der Fertigkeit relevant sind; deaktiviere alle Dateien, die nur Daten dieses Durchlaufs enthalten.","detailsTitle":"Details zu den F\xe4higkeiten","addFile":"F\xfcgen Sie eine weitere Datei hinzu\u2026","include":{"add":"Enthalten","on":"Enthalten \u2013 zum Entfernen klicken","off":"Ausgeschlossen \u2013 zum Einschlie\xdfen klicken"},"included":"Inklusive","origin":{"attached":"Sie haben bereitgestellt","template":"Vorlage","generated":"Lauf produziert","observed":"Versammelt","added":"Von Ihnen hinzugef\xfcgt"},"saved":"F\xe4higkeit gespeichert. Sie k\xf6nnen sie unten aktivieren und teilen.","error":"Aus diesem Durchlauf konnte keine Fertigkeit erstellt werden.","filesError":"Einige Referenzdateien konnten nicht hinzugef\xfcgt werden: {{files}}","notFound":"Dieser Entwurf ist nicht mehr verf\xfcgbar.","backToSkills":"Zur\xfcck zu den F\xe4higkeiten"},"actions":"Fertigkeitsaktionen","body":{"empty":"Es wurden noch keine Anweisungen hinzugef\xfcgt.","label":"Anleitung (SKILL.md)"},"importTooltip":"Importieren Sie eine F\xe4higkeit aus einem Ordner oder einer .zip-Datei","install":"Installieren","keywords":{"label":"Schl\xfcsselw\xf6rter"},"marketplace":{"description":"Von der Community geteilte \xf6ffentliche F\xe4higkeiten, die Ihrer Suche entsprechen.","title":"Vom \xf6ffentlichen Marktplatz"},"share":"Aktie","shareError":"Etwas ist schiefgelaufen.","sync":"Synchronisieren","updateAvailable":"Eine neuere Version ist verf\xfcgbar.","searchPlaceholder":"Suchf\xe4higkeiten\u2026","createTooltip":"Nimm dich selbst bei der Ausf\xfchrung einer Aufgabe auf oder beschreibe die Fertigkeit selbst.","createRecord":"Zeichne auf, was ich tue","createScratch":"Ganz von vorn beginnen"},"on":"An","off":"Aus","copied":"Kopiert","mcp":{"section":{"title":"Werkzeuge","description":"Verbinden Sie MCP-Server, um dem Cephable-Assistenten zus\xe4tzliche Funktionen bereitzustellen. Sie k\xf6nnen diese im Bedienfeld durch Eingabe von / oder @ verwenden."},"addServer":"F\xfcge einen Server hinzu","addServerDescription":"Verbinden Sie einen MCP-Server (Befehlszeile, HTTP oder SSE), um dessen Tools hinzuzuf\xfcgen.","editTitle":"Server bearbeiten","newTitle":"Server hinzuf\xfcgen","deleteConfirm":"L\xf6schen?","contextMenuItem":"Werkzeuge\u2026","chipRemove":"Werkzeuge entfernen","inUse":"Verwendung von Werkzeugen:","picker":{"title":"F\xe4higkeiten und Werkzeuge"},"mode":{"label":"Wie dieser Server genutzt wird","off":"Aus","offTooltip":"Aus \u2013 dieser Server wird nie verwendet oder im Auswahlmen\xfc angezeigt."},"activation":{"auto":"Automatisch, wenn es passt","autoShort":"Auto","autoDescription":"Der Assistent l\xe4dt die Tools dieses Servers selbstst\xe4ndig, wenn Ihre Anfrage \xfcbereinstimmt \u2013 und Sie k\xf6nnen ihn weiterhin mit / oder @ ausw\xe4hlen.","manual":"Nur wenn ich es ausw\xe4hle","manualShort":"Handbuch","manualDescription":"Der Assistent l\xe4dt es nie von selbst \u2013 nur dann, wenn Sie es mit / oder @ anh\xe4ngen."},"transport":{"stdio":"Befehl (stdio)","http":"HTTP","sse":"SSE"},"auth":{"none":"Keiner","apiKey":"API-Schl\xfcssel","headers":"Benutzerdefinierte Header","oauth":"OAuth"},"requireApproval":{"short":"Anrufe genehmigen","tooltip":"Wenn diese Option aktiviert ist, m\xfcssen Sie jeden Toolaufruf von diesem Server genehmigen, bevor er ausgef\xfchrt wird."},"oauth":{"connect":"Verbinden","reconnect":"Wiederverbinden","disconnect":"Trennen","connecting":"Warten auf Browser\u2026","connected":"Verbunden","notConnected":"Nicht verbunden","error":"Autorisierung fehlgeschlagen."},"status":{"ok":"Verbunden","error":"Fehlgeschlagen","unknown":"Nicht getestet","testing":"Verbindung wird hergestellt\u2026","toolsFound":"{{count}} Werkzeuge gefunden","label":"Verbindung","toolsEnabledOf":"{{aktiviert}} von {{Anzahl}} Werkzeugen"},"editor":{"nameLabel":"Name","namePlaceholder":"z.B. Dateisystem","nameHelp":"Nur Kleinbuchstaben, Zahlen und Bindestriche.","descriptionLabel":"Beschreibung","descriptionPlaceholder":"Was dieser Server bereitstellt und wann der Assistent ihn nutzen sollte.","descriptionHelp":"So entscheidet der Assistent, wann er es einsetzt. Seien Sie pr\xe4zise.","transportLabel":"Verbindungstyp","commandLabel":"Befehl","argsLabel":"Argumente","argsHelp":"Durch Leerzeichen getrennte Argumente, die an den Befehl \xfcbergeben werden.","envLabel":"Umgebungsvariablen","envHelp":"Eine KEY=Wert-Beziehung pro Zeile.","urlLabel":"Server-URL","authLabel":"Authentifizierung","apiKeyHeaderLabel":"Headername","apiKeyPrefixLabel":"Wertpr\xe4fix","apiKeyLabel":"API-Schl\xfcssel","secretSet":"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (gespeichert \u2014 zu ersetzender Typ)","oauthClientIdLabel":"Client-ID","oauthClientIdHelp":"Lassen Sie das Feld leer, um die automatische Registrierung zu aktivieren, sofern diese unterst\xfctzt wird.","oauthClientSecretLabel":"Kundengeheimnis","oauthScopesLabel":"Zielfernrohre","oauthScopesHelp":"Anzufordernde Bereiche sind durch Leerzeichen getrennt.","oauthDiscoveryLabel":"Discovery-URL (optional)","oauthAuthUrlLabel":"Autorisierungs-URL","oauthTokenUrlLabel":"Token-URL","redirectLabel":"Umleitungs-URI","redirectHelp":"Die meisten Server registrieren sich automatisch \u2013 lassen Sie einfach das Feld f\xfcr die Client-ID leer und klicken Sie auf \u201EVerbinden\u201C. Falls der Anbieter nach einer Umleitungs-URI fragt, w\xe4hlen Sie den akzeptierten Callback-Typ aus und registrieren Sie die URI unten.","headersHelp":"Die benutzerdefinierte Header-Authentifizierung kann hier noch nicht bearbeitet werden; verwenden Sie einen API-Schl\xfcssel oder OAuth f\xfcr authentifizierte Server.","activationLabel":"Wann sollte der Assistent dies verwenden?","requireApprovalLabel":"F\xfcr jeden Werkzeugaufruf ist eine Genehmigung erforderlich.","requireApprovalHelp":"Wenn diese Option aktiviert ist, m\xfcssen Sie jeden Toolaufruf von diesem Server vor dessen Ausf\xfchrung genehmigen. Empfohlen f\xfcr Server, die Daten \xe4ndern oder Geld ausgeben k\xf6nnen.","testConnection":"Testverbindung","save":"\xc4nderungen speichern","create":"Server hinzuf\xfcgen","saveError":"Der Server konnte nicht gerettet werden.","oauthDiscoveryHelp":"Optional \u2013 lassen Sie dieses Feld leer, um das serverseitige Discovery-Dokument zu verwenden.","oauthDiscoveryLabelShort":"Discovery-URL","oauthOnDevice":"Jedes Mitglied f\xfchrt die OAuth-Anmeldung auf seinem eigenen Ger\xe4t durch, sobald es diesen Konnektor aktiviert.","secretsOnDevice":"Jedes Mitglied gibt seinen eigenen API-Schl\xfcssel auf seinem Ger\xe4t ein, wenn es diesen Konnektor aktiviert \u2013 die Schl\xfcssel werden hier niemals gespeichert.","noPermissions":"Dieser Server verwendet die registrierte App von {{provenance}}. Klicken Sie auf die Schaltfl\xe4che, um sie anzupassen, oder verbinden Sie sich, um sie zu verwenden.","altOptions":{"copy":"Meine eigenen Anmeldeinformationen verwenden","organization":"Cephable-Portal"},"copyName":"{{name}}-Kopie","redirectTypeLabel":"R\xfcckruftyp","redirectType":{"appCallback":"Web (https)","localhost":"Localhost"},"redirectPortLabel":"Hafen","redirectNotes":{"appCallback":"Beim Anmelden \xf6ffnet sich Ihr Browser und die Steuerung wird anschlie\xdfend automatisch an die Cephable-App zur\xfcckgegeben.","localhost":"Beim Anmelden \xf6ffnet sich Ihr Browser und Sie werden \xfcber diesen Port zu Cephable zur\xfcckgeleitet. Dieser Port ist nur w\xe4hrend der Anmeldung und nur auf diesem Ger\xe4t ge\xf6ffnet."}},"actions":"Serveraktionen","marketplace":{"description":"\xd6ffentliche Konnektoren, die von der Community geteilt wurden und Ihrer Suche entsprechen.","title":"Vom \xf6ffentlichen Marktplatz"},"share":"Aktie","shareError":"Etwas ist schiefgelaufen.","sync":"Synchronisieren","tools":{"allToolsLabel":"f\xfcr alle Werkzeuge","contextLabel":"Kontext","disableAll":"Alle deaktivieren","empty":"Noch keine Tools verf\xfcgbar \u2013 testen Sie die Verbindung, um sie zu entdecken.","enableAll":"Alle aktivieren","help":"Deaktivieren Sie nicht ben\xf6tigte Tools. Weniger Tools beanspruchen weniger Platz im Kontextfenster des Assistenten, wodurch dieser schnell und \xfcbersichtlich bleibt.","label":"Werkzeuge","searchPlaceholder":"Suchwerkzeuge\u2026","tokens":"~{{tokens}} nahm","tokensLabel":"Token","disableSelected":"Ausgew\xe4hlte deaktivieren","enableSelected":"Ausgew\xe4hlte aktivieren"},"updateAvailable":"Eine aktualisierte Version ist verf\xfcgbar.","searchPlaceholder":"Konnektoren suchen\u2026"},"send":"Schicken","availableToInstall":"Verf\xfcgbar zur Installation","menu":{"expand":"Men\xfc erweitern"},"no":"NEIN","rating":{"review":{"comment":"Kommentar","commentPlaceholder":"Was hat Ihnen gefallen, was nicht? Wie haben Sie es verwendet?","optional":"(optional)","submit":"Bewertung einreichen","subtitle":"Teilen Sie Ihre Erfahrungen mit <strong>{{subject}}</strong> .","title":"Bewerten und rezensieren","write":"Schreiben Sie eine Rezension","yourRating":"Ihre Bewertung"},"summary":{"comments":"Kommentare","installs":"installiert","noRatings":"Noch keine Bewertungen","openReview":"Bewerten und rezensieren","ratingCount":"{{count}} Bewertungen"}},"workflow":{"feedback":{"includeDetails":"Teilen Sie mir bitte meine Eingabeaufforderung und die Namen der verwendeten Werkzeuge mit, um die Fehlersuche zu erleichtern.","negative":"Daumen runter","placeholder":"Erz\xe4hlen Sie uns mehr (optional).","positive":"Daumen hoch","question":"Wie verlief dieser Arbeitsablauf?","send":"Feedback senden","thanks":"Vielen Dank f\xfcr Ihr Feedback.","report":"Ein Problem melden"}},"yes":"Ja","scheduledTasks":{"title":"Geplante Aufgaben","description":"Automatisierungen werden zu einem von Ihnen gew\xe4hlten Zeitpunkt ausgef\xfchrt. Alles bleibt auf diesem Ger\xe4t.","hint":"Geplante Aufgaben werden nur ausgef\xfchrt, solange diese App l\xe4uft. Wenn Ihr PC ausgeschaltet oder die App zum geplanten Zeitpunkt geschlossen ist, wird die Ausf\xfchrung als verpasst markiert und Sie k\xf6nnen sie sp\xe4ter erneut ausf\xfchren.","new":"Neue geplante Aufgabe","scheduleButton":"Zeitplan","create":{"title":"Neue geplante Aufgabe","description":"Richten Sie eine Eingabeaufforderung ein, die automatisch nach einem Zeitplan ausgef\xfchrt wird.","saved":"Geplante Aufgabe erstellt."},"composer":{"placeholder":"Beschreiben Sie, was Cephable leisten soll\u2026 Verwenden Sie / oder @, um F\xe4higkeiten und Konnektoren hinzuzuf\xfcgen."},"runHistory":{"title":"Laufverlauf","viewRun":"Ansichtslauf","noOutput":"Keine gespeicherte Ausgabe","resolution":{"ignored":"Ignoriert","rerun":"Wiederholung","rescheduled":"Verschoben"}},"badge":{"scheduled":"Geplant","recurring":"Wiederkehrend"},"fromRun":{"scheduled":"Dieser Lauf ist Teil einer geplanten Aufgabe: {{name}}","recurring":"Dieser Lauf ist Teil einer wiederkehrenden Aufgabe: {{name}}","view":"Geplante Aufgabe anzeigen"},"search":{"placeholder":"Geplante Aufgaben suchen..."},"filter":{"label":"Filter","all":"Alle","enabled":"Aktiv","paused":"Angehalten","missed":"Verpasst"},"empty":{"title":"Noch keine geplanten Aufgaben","description":"Planen Sie eine Erinnerung, indem Sie im Auto- oder Automatisierungsmodus mit der rechten Maustaste auf die Schaltfl\xe4che \u201ESenden\u201C im Bedienfeld klicken."},"pagination":{"range":"{{start}}\u2013{{end}} von {{total}}"},"status":{"running":"L\xe4uft","success":"Erfolgreich","failed":"Fehlgeschlagen","missed":"Verpasst","paused":"Angehalten"},"summary":{"once":"Einmal am {{datetime}}","everyOne":"Jede {{unit}}","everyN":"Jede {{count}} {{unit}}","onDays":"an {{days}}","onDayOfMonth":"am Tag {{day}}","atTime":"um {{time}}","unit":{"minute":"Minute","minute_other":"Minuten","hour":"Stunde","hour_other":"Std.","day":"Tag","day_other":"Tage","week":"Woche","week_other":"Wochen","month":"Monat","month_other":"Monate"}},"card":{"nextRun":"N\xe4chster Lauf","runNow":"Jetzt laufen","pause":"Pause","resume":"Wieder aufnehmen","enabledToggle":"Diese Aufgabe aktivieren oder pausieren","viewLastRun":"Letzten erfolgreichen Lauf anzeigen","noSuccessfulRun":"Bisher kein erfolgreicher Durchlauf."},"missed":{"runNow":"Jetzt laufen","reschedule":"Neu terminieren","ignore":"Ignorieren"},"runNow":{"started":"\\"{{name}}\\" wird jetzt ausgef\xfchrt.","busy":"Ein anderer Workflow wird bereits ausgef\xfchrt. Versuchen Sie es erneut, sobald dieser abgeschlossen ist."},"delete":{"title":"Geplante Aufgabe l\xf6schen?","description":"Dadurch wird die geplante Aufgabe endg\xfcltig entfernt. Dies kann nicht r\xfcckg\xe4ngig gemacht werden."},"editor":{"kindLabel":"Zeitplanart","once":"Einmal","recurring":"Wiederkehrend","runAt":"Laufen bei","frequency":"Wiederholungen","every":"Jeder","interval":"Intervall","onDays":"An Tagen","dayOfMonth":"Tag des Monats","atTime":"Zum Zeitpunkt","startAt":"Beginnt","endsOn":"Endet am","units":"Einheiten"},"edit":{"title":"Geplante Aufgabe bearbeiten","description":"Passen Sie die Eingabeaufforderung und ihren Zeitplan an, bevor sie ausgef\xfchrt wird.","name":"Name","namePlaceholder":"Benennen Sie diese geplante Aufgabe.","prompt":"Prompt","customContext":"Benutzerdefinierter Kontext","contextNote":{"generic":"Der Kontext dieser Aufgabe wird bei ihrer Ausf\xfchrung aufgel\xf6st.","highlighted":"Diese Aufgabe verwendet den markierten Text in Ihrer aktiven App zur Laufzeit.","clipboard":"Diese Aufgabe verwendet den Inhalt Ihrer Zwischenablage zur Laufzeit.","auto":"Der Kontext dieser Aufgabe wird bei der Ausf\xfchrung automatisch aufgel\xf6st."},"attachments":"Angeh\xe4ngte Dateien und Ordner","skills":"F\xe4higkeiten","connectors":"Steckverbinder","schedule":"Zeitplan","goalRequired":"Geben Sie eine Eingabeaufforderung f\xfcr diese Aufgabe ein.","saved":"Geplante Aufgabe gespeichert.","notFound":"Diese geplante Aufgabe existiert nicht mehr."},"schedulePrompt":{"menuItem":"Planen Sie diese Aufforderung ein\u2026","title":"Planen Sie diese Aufforderung ein.","prompt":"Prompt","name":"Name (optional)","namePlaceholder":"Benennen Sie diese geplante Aufgabe.","confirm":"Zeitplan","goalRequired":"Geben Sie eine Eingabeaufforderung ein, um einen Termin zu vereinbaren.","success":"P\xfcnktlich terminiert.","error":"Diese Eingabeaufforderung konnte nicht eingeplant werden."},"notify":{"runStarted":{"title":"Geplanter Task wird ausgef\xfchrt","body":"\\"{{name}}\\" wird jetzt ausgef\xfchrt."},"missed":{"title":"Geplante Aufgabe verpasst","bodyOne":"\\"{{name}}\\" wurde nicht angezeigt, da die App nicht ausgef\xfchrt wurde.","bodyMany":"{{count}} geplante Aufgaben wurden verpasst, w\xe4hrend die App nicht ausgef\xfchrt wurde."}},"skippedBusy":"\xdcbersprungen, da bereits ein anderer Workflow ausgef\xfchrt wurde.","overlap":{"title":"Die Zeitpl\xe4ne \xfcberschneiden sich.","description":"Diese Automatisierung wird innerhalb von 5 Minuten nach \\"{{name}}\\" ({{time}}) ausgef\xfchrt. Es kann immer nur eine Automatisierung gleichzeitig laufen, daher wartet eine, bis die andere abgeschlossen ist. Soll sie trotzdem geplant werden?","confirm":"Planen Sie trotzdem"}},"keyboardService":{"unavailable":{"title":"Tastatur- und Maussteuerung eingestellt","recovering":"Cephable startet es neu. Ihre Befehle funktionieren in K\xfcrze wieder.","stalled":"Cephable konnte nicht neu gestartet werden. Versuchen Sie Ihren Befehl erneut oder starten Sie Cephable neu, falls der Fehler weiterhin besteht.","permissionTitle":"Cephable kann Ihre Tastatur und Maus nicht steuern.","permission":"Gew\xe4hren Sie Cephable Zugriff unter Systemeinstellungen > Datenschutz & Sicherheit > {{pane}} und versuchen Sie dann Ihren Befehl erneut.","permissionWindows":"Windows verhindert, dass Apps Programme steuern, die als Administrator ausgef\xfchrt werden. Schlie\xdfen Sie Cephable und \xf6ffnen Sie es anschlie\xdfend als Administrator oder starten Sie die andere App ohne Administratorrechte neu. Windows-Sicherheitsabfragen und der Sperrbildschirm k\xf6nnen nicht gesteuert werden. Auf einem Arbeitsger\xe4t blockiert Ihr IT-Administrator diese Funktion m\xf6glicherweise."},"restored":"Die Steuerung \xfcber Tastatur und Maus funktioniert wieder."},"error":"Fehler","macPermissions":{"openSettings":"Einstellungen \xf6ffnen","pane":{"accessibility":"Zug\xe4nglichkeit","deviceControl":"Ger\xe4testeuerung und Datenzugriff","inputMonitoring":"Eingangs\xfcberwachung","filesAndFolders":"Dateien und Ordner","fullDiskAccess":"Vollst\xe4ndiger Festplattenzugriff","camera":"Kamera","microphone":"Mikrofon","screenRecording":"Bildschirmaufnahme"}},"recordWorkflow":{"title":"Workflow aufzeichnen","description":"Zeigen Sie Cephable, wie Sie eine Aufgabe erledigen \u2013 beschreiben Sie laut, w\xe4hrend Sie sie durchklicken \u2013 und schon haben Sie eine wiederverwendbare F\xe4higkeit.","cardDescription":"Nehmen Sie sich selbst bei der Ausf\xfchrung einer Aufgabe auf, um Cephable beizubringen, wie es geht.","goalLabel":"Aufnahmebeschreibung","goalPlaceholder":"Was m\xf6chten Sie vorf\xfchren? (optional)","start":"Aufnahme starten","recording":"Aufzeichnung Ihres Arbeitsablaufs","stepCount":"{{count}} Schritte","stopAndCreate":"Stoppen & F\xe4higkeiten entwickeln","creating":"Mach deine Aufnahmetechnik zur Fertigkeit\u2026","permissionNeeded":"Cephable ben\xf6tigt die Berechtigung \u201EBarrierefreiheit/Eingabe\xfcberwachung\u201C, um Ihre Aktionen aufzuzeichnen. Erteilen Sie diese Berechtigung in den Systemeinstellungen und starten Sie das Programm anschlie\xdfend neu.","noMic":"Mikrofon nicht verf\xfcgbar \u2013 Ihre Aktionen werden ohne Kommentar aufgezeichnet.","startError":"Die Aufnahme konnte nicht gestartet werden.","noSteps":"Es wurden keine Aktionen aufgezeichnet, die zu einer Fertigkeit umgewandelt werden k\xf6nnten.","stopReminder":"Fahren Sie so lange fort, wie Sie ben\xf6tigen. Wenn die Aufgabe abgeschlossen ist, kehren Sie hierher zur\xfcck und klicken Sie auf \u201EStopp & F\xe4higkeit erstellen\u201C.","callout":{"title":"Bringe Cephable eine deiner Aufgaben bei","description":"F\xfchre eine Aufgabe einmalig aus, w\xe4hrend Cephable zusieht und beschreibt, was du tust. Daraus entwickelt sich eine F\xe4higkeit, die du jederzeit ausf\xfchren kannst.","action":"Zeig mir wie","dismiss":"Nicht jetzt.","badge":"Probier es aus","compactDescription":"Erledige eine Aufgabe einmal, w\xe4hrend Cephable zusieht, und sie wird zu einer F\xe4higkeit, die du jederzeit ausf\xfchren kannst.","compactAction":"Einen Workflow aufzeichnen"},"coach":{"title":"Bevor Sie aufnehmen","progress":"Tipp {{current}} von {{total}}","ready":"Ich bin bereit","skip":"\xdcberspringen Sie die Tipps.","reopen":"So funktioniert es","steps":{"pickTask":{"title":"W\xe4hle eine echte Aufgabe","body":"W\xe4hle eine Aufgabe, die du tats\xe4chlich tust, und plane, sie in einem Zug von Anfang bis Ende zu erledigen. Eine kurze, abgeschlossene Aufgabe lehrt weitaus mehr als eine lange, halbfertige.","example":"So reiche ich meinen w\xf6chentlichen Spesenbericht ein \u2013 \xf6ffnen, ausf\xfcllen, absenden."},"narrate":{"title":"Sprechen Sie die ganze Zeit hindurch.","body":"Beschreiben Sie laut, was Sie tun und warum, so als w\xfcrde Ihnen ein neuer Kollege \xfcber die Schulter schauen. Ihre Beschreibung dient Cephable als Grundlage f\xfcr die einzelnen Schritte.","example":"Ich \xf6ffne jetzt die Rechnung in Outlook, um die Bestellnummer zu finden."},"goSlow":{"title":"Klicken Sie bewusst, eine Sache nach der anderen.","body":"Warten Sie, bis jede Seite oder App vollst\xe4ndig geladen ist, bevor Sie den n\xe4chsten Klick ausf\xfchren, und benennen Sie, worauf Sie klicken. Lassen Sie alles Private weg \u2013 Passw\xf6rter und Kartennummern geh\xf6ren nicht in einen Skill.","example":"Ich klicke oben rechts auf \u201EGenehmigen\u201C und warte, bis die Best\xe4tigung erscheint."},"explainRules":{"title":"Sag die Regeln laut vor","body":"Nennen Sie alles, was sich von Lauf zu Lauf \xe4ndert und was Sie anders machen w\xfcrden, damit die Fertigkeit \xfcber den heutigen Tag hinaus Bestand hat.","example":"Wenn keine Bestellnummer vorhanden ist, \xfcberspringe ich die Tabelle und sende stattdessen eine E-Mail an den Lieferanten."},"comeBack":{"title":"Kehren Sie zur\xfcck und dr\xfccken Sie auf Stopp.","body":"Cephable zeichnet so lange auf, bis Sie die Aufnahme beenden. Sobald die Aufgabe abgeschlossen ist, kehren Sie zu diesem Fenster zur\xfcck und klicken Sie auf \u201EStoppen & Skill erstellen\u201C. Wenn eine Minute lang keine Klicks oder Ger\xe4usche erkannt werden, wird die Aufnahme automatisch beendet.","example":"Das war\'s \u2013 erledigt."}}},"idle":{"title":"Die Aufnahme l\xe4uft noch.","body":"Eine Weile keine Klicks und keine Sprachausgabe. Wenn Sie die Aufgabe abgeschlossen haben, dr\xfccken Sie auf \u201EStopp & F\xe4higkeit erstellen\u201C.","countdown":"Automatischer Stopp in {{seconds}}s.","keepGoing":"Ich bin noch am Arbeiten.","autoStopped":"Die Aufnahme stoppte nach einer Minute Stille von selbst."},"teachAction":"Lehren Sie Cephable einen Workflow"},"backgroundCapture":{"title":"Hintergrundinhalte","capturing":"Inhalte im Hintergrund speichern...","tooltip":"Inhalte, die nicht eingegeben werden konnten, werden f\xfcr die aktuelle Sitzung gespeichert. Sie werden beim Beenden von Cephable gel\xf6scht.","nothingToPaste":"Es ist kein Hintergrundinhalt zum Einf\xfcgen vorhanden.","pasteNotPermitted":"Einf\xfcgen nicht m\xf6glich. Aktion aufgrund des aktuellen Fokus nicht zul\xe4ssig.","pasteFailed":"Hintergrundinhalte konnten nicht eingef\xfcgt werden."}}');


var $00d894b7ec9a312b$exports = {};
$00d894b7ec9a312b$exports = JSON.parse('{"404":"Oh nein! Wir haben das ganze Meer abgesucht und k\xf6nnen die Seite nicht finden!","appError":{"title":"Etwas ist schiefgelaufen.","description":"Die App ist auf ein unerwartetes Problem gesto\xdfen. Versuchen Sie, die Seite neu zu laden oder zu Ihrem Arbeitsbereich zur\xfcckzukehren. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an den Support.","home":"Zur\xfcck zum Arbeitsbereich"}}');


var $a20b4edf601225c9$exports = {};
$a20b4edf601225c9$exports = JSON.parse('{"smartTasks":{"generate":{"focusApp":{"title":"Konzentrieren Sie sich auf die App","description":"Konzentrieren Sie sich auf die App, in der der generierte Text erscheinen soll. Klicken Sie auf \u201EGenerieren\u201C, um Text nahtlos an dieser Stelle zu generieren."}},"rewrite":{"focusApp":{"title":"Konzentrieren Sie sich auf die App","description":"Konzentrieren Sie sich auf die App, in der der umgeschriebene Text erscheinen soll. Klicken Sie auf \u201EGenerieren\u201C, um Text nahtlos an dieser Stelle zu generieren."}}},"customControls":{"tourLabel":"Immer verf\xfcgbare globale und Ger\xe4testeuerungen","rowDescription":"Globale und Ger\xe4testeuerungen sind immer verf\xfcgbar, wenn Ihr Mikrofon eingeschaltet ist, unabh\xe4ngig von der verwendeten App. Sie k\xf6nnen diese Steuerungen verwenden, um mit Ihrem Ger\xe4t zu interagieren, ohne neue App-Steuerungen erstellen zu m\xfcssen. Sie enthalten hilfreiche Befehle wie das Wechseln von Steuerungen oder Apps, das Generieren von Text, das Pausieren Ihres Mikrofons und mehr."},"profile":{"switch":{"title":"App-Steuerung umschalten","description":"Die Steuerelemente Ihrer App k\xf6nnen je nach verwendeter App automatisch umgeschaltet werden, oder Sie k\xf6nnen sie hier jederzeit manuell \xe4ndern."}},"dictation":{"tourLabel":"Diktat","learn":"Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freih\xe4ndig in Text umwandeln.","welcome":{"title":"Diktat","description":"Mit der Diktierfunktion k\xf6nnen Sie nat\xfcrlich sprechen und Ihre Worte direkt w\xe4hrend des Sprechens abtippen lassen. Es ist, als h\xe4tten Sie einen pers\xf6nlichen Assistenten, der alles tippt, was Sie sagen."},"microphone":{"title":"Schalten Sie Ihr Mikrofon ein","description":"Schalten Sie zun\xe4chst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."},"activate":{"title":"Diktiermodus starten","description":"Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie \u201EDiktat starten\u201C oder klicken Sie auf die Schaltfl\xe4che \u201EDiktieren\u201C. Schalten wir jetzt den Diktiermodus ein."},"focus":{"title":"Konzentrieren Sie sich auf ein Textfeld oder Dokument","description":"Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Klicken Sie auf das Textfeld oder Dokument, in das Sie diktieren m\xf6chten."},"speaking":{"title":"Fangen Sie an zu sprechen","description":"Jetzt k\xf6nnen Sie lossprechen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Sagen Sie beispielsweise: \u201EHallo, dies ist ein Test des Diktiermodus.\u201C"},"pauseResume":{"title":"Diktat pausieren","description":"Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach \u201EDiktat pausieren\u201C. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren. Sie k\xf6nnen die Funktion mit Ihren globalen Always-On- und Ger\xe4testeuerungen weiter anpassen."},"stop":{"title":"Diktat stoppen","description":"M\xf6chten Sie zur\xfcck zur App-Steuerung wechseln? Sagen Sie einfach \u201EDiktat beenden\u201C. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zur\xfcck. Sie k\xf6nnen jederzeit mit \u201EDiktat starten\u201C fortfahren."},"complete":{"description":"Das war\'s! Sie k\xf6nnen jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool f\xfcr freih\xe4ndiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen m\xfcssen."}},"microphone":{"tourLabel":"Sprachsteuerung","learn":"Erfahren Sie, wie Sie jede App mit Ihrer Stimme steuern und Ihre Worte per Diktierfunktion eintippen k\xf6nnen.","rowDescription":"Wenn das Mikrofon ausgeschaltet ist, h\xf6ren wir Ihre Sprachbefehle \xfcberhaupt nicht. Wenn Sie es jedoch einschalten, k\xf6nnen Sie globale Befehle verwenden, um Pause, Start und mehr umzuschalten. Schalten wir es ein.","tryOpen":{"title":"Versuchen Sie, \u201E\xd6ffne Spotify\u201C oder \u201E\xd6ffne Word\u201C zu sagen."},"finishedCommands":{"title":"Ausgezeichnet! Sie haben die Grundlagen der Sprachsteuerung gelernt.","description":"Sie k\xf6nnen die Tour jederzeit von der Support-Seite aus erneut aufrufen. Im n\xe4chsten Schritt erfahren Sie mehr \xfcber die Diktierfunktion. Sie k\xf6nnen die Tour von der Support-Seite aus starten."}},"tour":{"startTour":"Tour starten","finishTour":"Tour beenden","statusDialog":"Weitere Informationen finden Sie im Panel.","step":"Schritt {{step}} von {{total}}","skipTour":"Tour \xfcberspringen"},"onboarding":{"overview":"\xdcberblick","learn":"Informieren Sie sich \xfcber die Funktionen von Cephable und deren Verwendung.","start":"Sie scheinen gerade erst anzufangen. Hier sind einige Bereiche, die Ihnen dabei helfen werden.","dashboard":{"title":"Cephable-Arbeitsbereich","description":"Der Cephable-Arbeitsbereich ist Ihre zentrale Anlaufstelle f\xfcr die Verwaltung Ihres Ger\xe4ts, der App-Steuerung und der Einstellungen. Hier k\xf6nnen Sie Ihre Benutzererfahrung anpassen, aktive Befehle anzeigen und auf alle Funktionen von Cephable zugreifen."},"step1":{"title":"Willkommen bei Cephable","description":"Cephable ist Ihre pers\xf6nliche KI \u2013 entwickelt f\xfcr schnelle Aktionen, Sprachbefehle, Inhaltsgenerierung und intelligente Automatisierung Ihrer Tools. Sofort einsatzbereite Steuerung. Keine Cloud-Verarbeitung. Nur Produktivit\xe4t, die mit Ihnen mitgeht."},"finish":{"continueToApp":"Weiter zum Cephable Dashboard","keepExploring":"Weiter entdecken"},"useCaseSlider":{"context":"Ich m\xf6chte verwenden","control":"kontrollieren"}},"support":{"description":"Weitere Informationen zur Verwendung von Cephable, einschlie\xdflich weiterer Touren, Schritt-f\xfcr-Schritt-Anleitungen, Tutorials und Videos, finden Sie in unserem Support-Hub.","title":"Unterst\xfctzung"},"editingVideos":{"tourLabel":"Konzentrieren Sie sich auf die Geschichte, nicht auf die m\xfchsamen Klicks zur Videobearbeitung","learn":"Lernen Sie, wie Sie Sprachsteuerung und Diktierfunktion nutzen k\xf6nnen, um Videos schneller zu bearbeiten und die kognitive Belastung durch das Merken der richtigen Schaltfl\xe4chen w\xe4hrend der Bearbeitung zu reduzieren.","tryOpen":{"title":"Versuchen Sie, `CapCut \xf6ffnen` oder `iMovie \xf6ffnen` zu sagen."},"complete":{"description":"Sie wissen nun, wie Sie Sprachbefehle und Schnellaktionen nutzen, um in Ihren bevorzugten Videobearbeitungs-Apps die Wiedergabe zu starten, anzuhalten, Titel zu \xfcberspringen und die Lautst\xe4rke anzupassen. Entdecken Sie weitere Befehle oder erstellen Sie eigene Schnellaktionen f\xfcr eine noch komfortablere Videosteuerung."}},"congrats":"Gl\xfcckwunsch!","fpsGamePlay":{"tourLabel":"Spielen Sie FPS-Spiele mit Sprachsteuerung","learn":"Erfahren Sie, wie Sie Sprachsteuerung und Schnellaktionen zum Spielen von FPS-Spielen verwenden.","tryOpen":{"title":"Versuchen Sie, \u201E\xd6ffne Valorant\u201C oder \u201E\xd6ffne Battlefield\u201C zu sagen."},"complete":{"description":"Sie wissen jetzt, wie Sie Sprachbefehle und Schnellaktionen verwenden, um Ihren Charakter in FPS-Spielen zu bewegen, anzuhalten und zu steuern. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um ein noch fl\xfcssigeres und schnelleres Gameplay zu erzielen."}},"redo":"Onboarding wiederholen","title":"Lernen Sie Cephable kennen","description":"Lernen Sie Cephable kennen, Ihren pers\xf6nlichen KI-Assistenten, und teilen Sie Ihr Interesse an personalisierten Anwendungsf\xe4llen.","panel":{"description":"Dies ist das Bedienfeld, die zentrale Steuerungseinheit. Sie ist immer sichtbar und erm\xf6glicht die Steuerung Ihrer Apps per Sprachbefehl und vieles mehr. Beginnen wir mit dem Mikrofon."},"controlExpanded":{"tourLabel":"Kontrolle","description":"Die App-Steuerelemente sind vorkonfigurierte Steuerelemente, die Sie in einer gew\xfcnschten Anwendung verwenden k\xf6nnen. In diesem Abschnitt werden Ihnen alle verf\xfcgbaren Steuerelemente angezeigt, die Sie per Sprachbefehl, Tippen, Eingabe und mehr nutzen k\xf6nnen."},"submit":{"title":"Einreichen","description":"Der Inhalt wird an der Stelle ausgegeben, an der sich der Cursor befindet."},"tryOpen":{"description":"\u201E\xd6ffnen\u201C ist ein globaler Befehl, der die angegebene App \xf6ffnet und ihr den Fokus gibt. Wenn die automatische Steuerungsumschaltung aktiviert ist, wird automatisch auf die Steuerelemente umgeschaltet, die am besten zur aktuell verwendeten App passen."},"modeSelector":{"title":"Modus ausw\xe4hlen","description":"Falls verf\xfcgbar, k\xf6nnen Sie den Modus ausw\xe4hlen, in dem ich arbeiten soll. Verwenden Sie \u201ESteuerung\u201C f\xfcr die App, \xfcber die Sie Befehle senden m\xf6chten, \u201EErstellen\u201C f\xfcr generative Textinhalte wie \u201EZusammenfassen\u201C, \u201EUmschreiben\u201C und \u201E\xdcbersetzen\u201C. W\xe4hlen Sie \u201EAutomatisieren\u201C f\xfcr Desktop- oder app\xfcbergreifende Abl\xe4ufe."},"contextSelector":{"title":"Kontext ausw\xe4hlen","description":"Sofern verf\xfcgbar, k\xf6nnen Sie den Kontext ausw\xe4hlen, in dem ich arbeiten soll. Ich kann beispielsweise Ihre Zwischenablage oder markierten Text verwenden, und Sie k\xf6nnen mir auch Dateien oder Ordner anh\xe4ngen, mit denen ich arbeiten soll."},"panelInput":{"title":"Was soll ich tun?","description":"Sie k\xf6nnen mir Befehle erteilen, diese eintippen oder diktieren, was ich tun soll."},"figma":{"tourLabel":"Sprachbefehle f\xfcr Figma und Canva","learn":"Lernen Sie, wie Sie die Sprachsteuerung, die Sprachmaus, die Diktierfunktion und die KI-gest\xfctzte Inhaltsgenerierung von Controls nutzen k\xf6nnen, um Ihren Design-Workflow zu verbessern.","complete":{"description":"Sie wissen nun, wie Sie Designs steuern und erstellen, um Ihren Workflow zu optimieren. Entdecken Sie weitere Befehle f\xfcr eine noch reibungslosere Designsteuerung."},"tryOpen":{"title":"Versuchen Sie es mit `Figma \xf6ffnen` oder `Canva \xf6ffnen`."}},"voiceMouse":{"title":"Sprachmaus","description":"Um Schaltfl\xe4chen anhand ihres Namens anzuklicken, k\xf6nnen Sie die Sprachsteuerung verwenden. Sagen Sie dazu beispielsweise \u201ESpeichern tippen\u201C oder \u201EZu den Einstellungen\u201C."},"documentSummary":{"tourLabel":"Entwurf von Teamzusammenfassungen aus vertraulichen Berichten","learn":"Automatisieren Sie das Durchlesen von Abteilungsberichten, identifizieren Sie die richtigen Ansprechpartner und entwerfen Sie eine E-Mail \u2013 alles direkt auf dem Ger\xe4t, damit Ihre vertraulichen Daten privat bleiben.","congrats":{"description":"Sie wissen nun, wie Sie KI-Workflows nutzen k\xf6nnen, um vertrauliche Dokumente zu lesen und eine zusammenfassende E-Mail an Ihr Team zu verfassen \u2013 und das alles, ohne dass Ihre Daten Ihr Ger\xe4t verlassen."}},"extensions":{"tourLabel":"Erweiterungen","rowDescription":"Erweitere Cephable um zus\xe4tzliche Steuerungsm\xf6glichkeiten f\xfcr dein Ger\xe4t \u2013 wie Kamerasteuerung f\xfcr Gesichts- und Kopfbewegungen oder Gamepad-Unterst\xfctzung. Aktiviere hier die gew\xfcnschten Funktionen."},"developerBuildTests":{"tourLabel":"Automatisieren Sie Builds und Tests mit KI-Workflows","learn":"Cephable kann mehrstufige Terminalaufgaben \u2013 wie das Erstellen Ihres Projekts und das Ausf\xfchren seiner Tests \u2013 vollst\xe4ndig auf dem Ger\xe4t im Hintergrund ausf\xfchren, w\xe4hrend Sie weiterarbeiten.","complete":{"description":"Sie wissen nun, wie Sie KI-Workflows auf dem Ger\xe4t f\xfcr mehrstufige Build- und Testaufgaben ausf\xfchren, auf Berechtigungsanfragen reagieren und die Ergebnisse iterativ verbessern. Versuchen Sie, eine weitere wiederkehrende Entwicklungsaufgabe zu automatisieren."}},"classroomStudyTools":{"tourLabel":"Unterrichtsnotizen und Artikel in Lernhilfen und Unterrichtsmaterialien umwandeln","learn":"Cephable unterst\xfctzt Lehrer und Sch\xfcler mit Diktierfunktionen, ger\xe4teinternen Erstellungswerkzeugen und Automatisierungsfunktionen \u2013 direkt in den Apps, die Sie bereits verwenden, wobei alles privat bleibt und sich auf Ihrem Ger\xe4t befindet.","complete":{"description":"Sie wissen nun, wie Sie direkt in Ihre Dokumente diktieren, aus Ihren Notizen neue Lernmaterialien generieren und mit Automate im Hintergrund komplette Aufgaben erstellen k\xf6nnen \u2013 alles direkt auf Ihrem Ger\xe4t."}},"engineeringFlows":{"tourLabel":"Sprachsteuerung + KI-Automatisierungen f\xfcr Entwickler","learn":"Erfahren Sie, wie Sie Ihren Entwicklungs-Workflow mit sprachgesteuerten Entwicklerbefehlen, KI-gest\xfctztem Rewrite unter Verwendung Ihres eigenen Codes als Kontext und KI-Workflows im Hintergrund beschleunigen k\xf6nnen \u2013 alles direkt auf dem Ger\xe4t.","tryOpen":{"title":"Versuchen Sie, \u201EVisual Studio Code \xf6ffnen\u201C zu sagen."},"complete":{"description":"Sie wissen nun, wie Sie sprachgesteuerte Entwicklerbefehle, KI-Rewrite mit Ihrem eigenen Code als Kontext und KI-gest\xfctzte Hintergrund-Workflows nutzen k\xf6nnen, um Ihren Entwicklungsablauf zu beschleunigen."}},"meetingNotesToFiles":{"tourLabel":"Wandeln Sie Besprechungsnotizen in verwertbare Dateien um","learn":"Cephable kann Ihre Besprechungsnotizen in kleinere, \xfcberschaubare Dateien aufteilen, die Sie in Ihrem eigenen Tempo bearbeiten k\xf6nnen \u2013 komplett auf Ihrem Ger\xe4t.","complete":{"description":"Sie wissen nun, wie Sie KI-Workflows nutzen k\xf6nnen, um Besprechungsnotizen in kleinere, handhabbare Dateien aufzuteilen und die Konversation jederzeit \xfcber den KI-Verlauf wieder aufzunehmen."}},"notesToPresentation":{"tourLabel":"Vertrauliche Notizen zusammenfassen und eine Pr\xe4sentation erstellen \u2013 alles direkt auf dem Ger\xe4t.","learn":"Cephable kann Ihre vertraulichen Berichte und Notizen zusammenfassen und anschlie\xdfend mithilfe von KI-Workflows einen ganzen Ordner mit Dateien bearbeiten \u2013 und sogar eine Pr\xe4sentation aus den Ergebnissen erstellen. All dies l\xe4uft direkt auf Ihrem Ger\xe4t.","complete":{"description":"Sie wissen nun, wie Sie vertrauliche Dokumente zusammenfassen, mit KI-Workflows einen ganzen Ordner stapelweise zusammenfassen und die Ergebnisse in eine Pr\xe4sentation umwandeln k\xf6nnen \u2013 und das alles, ohne dass Ihre Daten Ihr Ger\xe4t verlassen."}},"organizeDownloads":{"tourLabel":"Dateien organisieren, aufr\xe4umen und Verlorene wiederfinden \u2013 mit KI-Workflows","learn":"Automate kann mehrstufige Dateiverwaltungsaufgaben \u2013 Kopieren, L\xf6schen und Suchen von Dateien \u2013 direkt \xfcber eine einfache Eingabeaufforderung ausf\xfchren.","complete":{"description":"Sie wissen nun, wie Sie KI-Workflows nutzen k\xf6nnen, um Dateien zu organisieren, sie mit Berechtigungspr\xfcfungen sicher zu bereinigen und Dateien zu finden, deren Speicherort Sie nicht mehr wissen."}},"outlookEmailProductivity":{"tourLabel":"Beschleunigen Sie E-Mails in Outlook mit Diktierfunktion, Schnellaktionen und KI.","learn":"Cephable Plus und Professional beinhalten intelligente Diktier- und Erstellungswerkzeuge zum Generieren und Bearbeiten von Inhalten \u2013 nutzen Sie diese direkt in Outlook, um E-Mails schneller zu beantworten und zu verfassen.","complete":{"description":"Sie wissen nun, wie Sie E-Mails per Diktierfunktion beantworten, Ihre eigenen Schnellschreibaktionen nutzen und mit den Funktionen \u201EZusammenfassen\u201C und \u201EGenerieren\u201C E-Mail-Inhalte entwerfen und verfeinern k\xf6nnen \u2013 alles direkt auf dem Ger\xe4t."}},"customizingGameControls":{"tourLabel":"Spiele Rollenspiele mit Sprachsteuerung","learn":"Lerne, wie du Sprachsteuerung und Schnellaktionen zum Spielen von Rollenspielen einsetzt.","tryOpen":{"title":"Versuche, \u201EMinecraft \xf6ffnen\u201C zu sagen."},"complete":{"description":"Du wei\xdft jetzt, wie du Sprachbefehle und Schnellaktionen nutzt, um deinen Charakter in Rollenspielen zu bewegen, anzuhalten und zu steuern. Entdecke weitere Befehle oder erstelle eigene Schnellaktionen f\xfcr ein noch fl\xfcssigeres und schnelleres Spielerlebnis."}},"voiceToTextSocialMedia":{"tourLabel":"Sprach-zu-Text-Funktion f\xfcr LinkedIn, Slack und Discord","learn":"Verwenden Sie die intelligente Diktierfunktion, um einen Beitrag nat\xfcrlich vorzulesen, und bearbeiten Sie ihn anschlie\xdfend, um den Tonfall anzupassen \u2013 funktioniert auf LinkedIn, Slack, Discord und anderen Plattformen gleicherma\xdfen.","complete":{"description":"Sie wissen nun, wie Sie einen Beitrag diktieren und ihn mit Rewrite verfeinern k\xf6nnen \u2013 und zwar auf LinkedIn, Slack, Discord und mehr."}},"aiDocumentTranslation":{"tourLabel":"Dokumente direkt auf dem Ger\xe4t in jede beliebige Sprache \xfcbersetzen","learn":"Cephable kann ein Dokument entweder in eine Sprache nach der anderen \xfcbersetzen oder mithilfe von KI-Workflows in mehrere Sprachen gleichzeitig \u2013 alles lokal ausgef\xfchrt.","complete":{"description":"Sie wissen nun, wie Sie ein Dokument per Diktierfunktion in eine einzige Sprache oder mithilfe von KI-Workflows in mehrere Sprachen gleichzeitig \xfcbersetzen k\xf6nnen \u2013 alles direkt auf dem Ger\xe4t."}},"excelAiAutomation":{"tourLabel":"Analysieren Sie Tabellenkalkulationen mit privater, ger\xe4teinterner KI","learn":"Cephable kann Ihre Excel-Dateien durchlesen, Fragen zu den Zahlen beantworten und noch tiefergehende Analysen durchf\xfchren \u2013 und das alles, ohne dass Ihre Daten Ihr Ger\xe4t verlassen.","complete":{"description":"Sie wissen nun, wie Sie KI-Workflows nutzen k\xf6nnen, um Ihre Tabellenkalkulationen zu hinterfragen, mit Nachfragen tiefergehende Informationen zu gewinnen und eine Zusammenfassung zu speichern \u2013 alles direkt auf dem Ger\xe4t."}},"handsFreeComputerControl":{"tourLabel":"Steuern Sie Ihren Computer per Sprache und Kamera","learn":"Mit Cephable k\xf6nnen Sie Ihren Computer freih\xe4ndig per Sprachbefehl, Voice Mouse und kamerabasierter Kopf- und Gesichtssteuerung bedienen.","tryOpenWord":{"title":"Versuchen Sie, \u201EOffenes Wort\u201C zu sagen."},"openExtensions":{"title":"\xd6ffnen Sie die Registerkarte \u201EErweiterungen\u201C.","description":"Um die Kamerasteuerung zu aktivieren, \xf6ffnen Sie die Registerkarte \u201EErweiterungen\u201C im Hauptfenster."},"turnOnCamera":{"title":"Kamerasteuerung einschalten","description":"Aktivieren Sie die Kamera. Neben Ihrem Mikrofonsymbol erscheint ein Kamerasymbol, und unter Einstellungen wird ein neuer Kamerabereich angezeigt."},"cameraInPanel":{"title":"Kamerasteuerung in Ihrem Bedienfeld","description":"Sobald Camera Controls aktiviert ist, erscheint der Kameraschalter auch in Ihrem Cephable-Panel \u2013 Cephable schaltet ihn hier f\xfcr Sie ein."},"openCameraSettings":{"title":"Kameraeinstellungen \xf6ffnen","description":"\xd6ffnen Sie die Kameraeinstellungen, um die Steuerung von Kopf und Gesicht individuell anzupassen."},"chooseHeadMouseMode":{"title":"W\xe4hlen Sie einen Kopfmausmodus.","description":"W\xe4hle aus, wie die Kopfbewegung deine Maus steuert: Stetiges Gleiten, Geschwindigkeitssteigerung oder Dynamisches Gleiten."},"complete":{"description":"Sie wissen nun, wie Sie Ihren Computer per Sprachsteuerung, Sprachmaus und kamerabasierten Kopf- und Gesichtsbefehlen bedienen. Erkunden Sie die Kameraeinstellungen weiter, um die Steuerung an Ihre Bed\xfcrfnisse anzupassen."}},"handsFreeTypingDocumentCreation":{"tourLabel":"Dokumente freih\xe4ndig erstellen und bearbeiten","learn":"Nutzen Sie die Funktionen Generieren, \xdcberarbeiten und die Sprachsteuerung zusammen, um ein Dokument \u2013 wie beispielsweise eine Rechnung \u2013 nahezu vollst\xe4ndig freih\xe4ndig zu erstellen und zu bearbeiten.","complete":{"description":"Sie wissen nun, wie Sie ein Dokument nahezu vollst\xe4ndig freih\xe4ndig mit Hilfe der Funktionen \u201EGenerieren\u201C, \u201EUmschreiben\u201C und Sprachbefehlen erstellen, umschreiben und bearbeiten k\xf6nnen."}},"webResearchCreateHtml":{"tourLabel":"Recherchiere im Web und erstelle daraus eine Website \u2013 alles direkt auf dem Ger\xe4t.","learn":"Cephable kann die Websites von Mitbewerbern durchsuchen und analysieren und anschlie\xdfend die gefundenen Informationen nutzen, um eine neue HTML-Seite f\xfcr Sie zu generieren \u2013 komplett auf Ihrem Ger\xe4t, sodass Ihre Recherchen privat bleiben.","complete":{"description":"Sie wissen nun, wie Sie KI-Workflows nutzen k\xf6nnen, um die Websites von Mitbewerbern zu analysieren und aus den Ergebnissen eine neue HTML-Seite zu generieren \u2013 und das alles, ohne dass Ihre Daten Ihr Ger\xe4t verlassen."}},"webResearchSummarize":{"tourLabel":"Vorschriften recherchieren und Ergebnisse zusammenfassen \u2013 alles auf dem Ger\xe4t","learn":"Cephable kann das Web durchsuchen, um \xc4nderungen wie neue Datenschutzgesetze zu recherchieren und die Ergebnisse anschlie\xdfend so zusammenzufassen, dass Ihr Team darauf reagieren kann \u2013 alles direkt auf dem Ger\xe4t, sodass Ihre Recherchen vertraulich bleiben.","complete":{"description":"Sie wissen nun, wie Sie KI-Workflows nutzen k\xf6nnen, um regulatorische \xc4nderungen zu recherchieren, die Umsetzung genauer zu analysieren und die Ergebnisse als E-Mail zu formulieren, die Ihr Team dann weiter bearbeiten kann \u2013 und das alles, ohne dass Ihre Daten Ihr Ger\xe4t verlassen."}},"stopListening":{"title":"Versuchen Sie, \u201EH\xf6r auf zuzuh\xf6ren\u201C zu sagen.","description":"Dadurch wird Ihr Mikrofon pausiert, ohne es vollst\xe4ndig auszuschalten. Sagen Sie \u201EZuh\xf6ren starten\u201C, sobald Sie bereit sind."}}');


var $9334e2246d11ce3e$exports = {};
$9334e2246d11ce3e$exports = JSON.parse('{"introduction":{"title":"Hallo, ich bin Cephable.","back":"Zur\xfcck zur Einleitung","description":"Ich bin Ihre pers\xf6nliche KI, die Ihnen hilft, Ihre gewohnten Tools zu steuern, zu erstellen und zu automatisieren \u2013 \xfcber alle Ihre Verbindungen hinweg. Es gibt ein paar Dinge, die Sie \xfcber mich wissen sollten.","action":"Lass uns anfangen!","recording":{"title":"Ihre Stimme und Ihr Video bleiben lokal.","description":"Ich nehme Ihre Audio- oder Videodaten niemals auf, streame sie nicht und sende sie auch nicht in die Cloud. Alle Eingaben werden auf dem Ger\xe4t verarbeitet \u2013 privat und sicher."},"data":{"title":"Ihre Daten geh\xf6ren Ihnen.","description":"Ich verwende Ihre Befehle oder Aktivit\xe4ten nicht, um Modelle f\xfcr andere zu trainieren. Alles bleibt privat \u2013 und Ihre App-Steuerelemente bleiben \xfcber alle Verbindungen hinweg mit Ihnen verbunden."},"offline":{"title":"Ich arbeite, wenn andere Tools nicht funktionieren.","description":"Intelligente Aufgaben wie das Erstellen von Inhalten, Umschreiben, \xdcbersetzen und Diktieren werden lokal ausgef\xfchrt. Keine Cloud erforderlich. Das bedeutet, ich arbeite auch, wenn Sie offline sind \u2013 und Ihre Daten verlassen Ihr Ger\xe4t nicht."},"empower":{"title":"Entwickelt, um zu st\xe4rken, nicht auszubeuten.","description":"Ich bin darauf ausgelegt, Ihre Kontrolle zu verbessern \u2013 nicht sie zu \xfcberwachen. Kein invasives Tracking. Keine gruselige Datenerfassung. Nur Eingaben, die f\xfcr Sie funktionieren."}},"my-capabilities":{"title":"Perfekt! So kann ich helfen.","back":"Zur\xfcck zu den Funktionen","actionTitle":"Sehen Sie mich in Aktion","description":"Hier sind die f\xfcr Ihren Workflow relevantesten Funktionen und M\xf6glichkeiten \u2013 geordnet nach den drei Gesch\xe4ftsbereichen von Cephable.","action":{"title":"Sehen Sie mich in Aktion","description":"Entdecken Sie einige Beispiele, wie ich Sie bei Ihren t\xe4glichen Aufgaben unterst\xfctzen kann."},"basedOnInterests":"Basierend auf Ihren Interessen","cta":{"eyebrow":"Bereit, wenn du es bist","title":"Sehen Sie, wie es in Ihren Apps funktioniert."}},"see-me":{"title":"M\xf6chten Sie sehen, wie ich anderen wie Ihnen geholfen habe?","back":"Zur\xfcck zu den Anwendungsf\xe4llen","description":"Sehen Sie sich einige Beispiele aus der Praxis an, wie ich Arbeitsabl\xe4ufe in verschiedenen Branchen und Rollen ver\xe4ndert habe."},"complete":{"title":"Bereit, mich zu verwenden?","description":"Sie haben gesehen, was ich kann! Jetzt richten wir alles ein und beginnen mit der Umgestaltung Ihres Workflows. Ich stehe Ihnen bei jedem Schritt zur Seite.","action":"Schlie\xdfen Sie die Einrichtung ab und beginnen Sie mit der Verwendung von Cephable"},"apps":{"title":"Ich unterst\xfctze die Tools, die Sie bereits lieben","description":"Mit vorkonfiguriertem Support f\xfcr \xfcber 200 Anwendungen \u2013 ich arbeite mit der Software, die Sie t\xe4glich verwenden. Keine Einrichtung erforderlich.","note":"Sie finden eine App, die Sie verwenden, nicht? Kein Problem \u2013 ich kann Steuerelemente generieren oder Ihnen beim Erstellen benutzerdefinierter Workflows helfen, die f\xfcr Sie funktionieren.","andMore":"Und mehr","eyebrow":"\xdcber 200 Apps, keine Einrichtung erforderlich"},"actions":{"ctaTry":"Jetzt testen","ctaWatch":"Demo ansehen","apps":"Ich bin kompatibel mit:","abilities":"Meine eingesetzten F\xe4higkeiten:"},"interests":{"title":"Wie kann ich Ihnen helfen?","back":"Zur\xfcck zu Interessen","description":"Ich kann Apps auf Ihrem Desktop und verbundenen Ger\xe4ten steuern. Lassen Sie uns Ihr Erlebnis personalisieren \u2013 welche Bereiche interessieren Sie am meisten?","note":"W\xe4hlen Sie alle zutreffenden Optionen aus und ich zeige Ihnen die relevantesten Funktionen und Beispiele f\xfcr Ihren Arbeitsablauf.","action":"Weiter mit {{count}} Interessen","empty":"W\xe4hlen Sie mindestens ein Interesse aus.","create_design":{"label":"Erstellen und Gestalten","shortLabel":"Design","description":"F\xfcr K\xfcnstler, Vermarkter und Content-Ersteller."},"analyze_report":{"label":"Analyse und Berichterstellung","shortLabel":"Analysieren","description":"F\xfcr Analysten, Forscher und Gesch\xe4ftsleute."},"communicate_collaborate":{"label":"Kommunizieren und zusammenarbeiten","shortLabel":"Kommunizieren","description":"F\xfcr Verk\xe4ufer, Meetings und Remote-Teams."},"build_develop":{"label":"Bauen und Entwickeln","shortLabel":"Entwickeln","description":"F\xfcr Entwickler, Ingenieure und technische Fachkr\xe4fte."},"game_play":{"label":"Spiel & Spa\xdf","shortLabel":"Spiele","description":"F\xfcr Gamer, Streamer und Mediensteuerungen."},"learn_teach":{"label":"Lernen & Lehren","shortLabel":"Lernen","description":"F\xfcr P\xe4dagogen, Sch\xfcler und den Unterricht."},"manage_organize":{"label":"Verwalten und Organisieren","shortLabel":"Organisieren","description":"F\xfcr Projektmanager, Koordinatoren und Organisatoren."},"adapt_access":{"label":"Anpassen und zugreifen","shortLabel":"Zug\xe4nglichkeit","description":"F\xfcr adaptive Steuerungen und personalisierte Zug\xe4nglichkeitsanforderungen."},"everything":{"label":"Von allem ein bisschen","shortLabel":"Alles","description":"F\xfcr allgemeine Computerbenutzer und Multitasker."},"filter":"Filtern nach Interessentyp"},"capabilities":{"title":"Meine wichtigsten KI-F\xe4higkeiten","description":"Ich kombiniere fortschrittliche KI mit leistungsstarken Eingabemethoden, um Ihnen nahtlose Kontrolle \xfcber Ihre Apps und Ger\xe4te zu erm\xf6glichen. Hier sind einige meiner M\xf6glichkeiten.","voice_controls":{"title":"Sprachsteuerung","description":"Ich verstehe nat\xfcrliche Sprachbefehle, sodass Sie jede App mit Ihrer Stimme steuern k\xf6nnen.","longDescription":"Ich lasse Sie nat\xfcrlich sprechen und trotzdem Dinge erledigen. Egal, ob Sie Apps \xf6ffnen, durch Men\xfcs navigieren oder Workflows ausl\xf6sen m\xf6chten, ich \xfcbersetze einfaches Englisch in freih\xe4ndige und zuverl\xe4ssige Aktionen."},"smart_dictation":{"title":"Intelligentes Diktieren","description":"Ich wandle Ihre Rede kontextbezogen und formatiert in Text um.","longDescription":"Ich h\xf6re aufmerksam zu und \xfcbertrage Ihre Worte pr\xe4zise. Ich f\xfcge Satzzeichen hinzu, korrigiere Gro\xdf- und Kleinschreibung und formatiere Ihren Text kontextbezogen, sodass er ohne zus\xe4tzlichen Aufwand professionell wirkt."},"ai_text_generation":{"title":"KI-Textgenerierung","description":"Ich kann im Handumdrehen E-Mails, Dokumente, Code und kreative Inhalte erstellen.","longDescription":"Ich helfe Ihnen beim Entwerfen, Zusammenfassen und Erweitern von Inhalten direkt in Ihren Apps. Von E-Mails und Notizen bis hin zu Codeausschnitten und Dokumenten \u2013 ich stelle sicher, dass Sie nie bei Null anfangen."},"head_face_controls":{"title":"Kopf- und Gesichtskontrolle","description":"Ich lasse Sie Aktionen mit Ihren Kopf- und Gesichtsbewegungen ausl\xf6sen.","longDescription":"Ich setze Ihre nat\xfcrlichen Kopfbewegungen und Mimik in pr\xe4zise Eingaben um. Sie k\xf6nnen mit einem L\xe4cheln eine E-Mail senden, mit einem Nicken eine Seite umbl\xe4ttern oder mit einem Hochziehen der Augenbrauen klicken."},"natural_language_voice_clicking":{"title":"Klicken mit nat\xfcrlicher Sprache","description":"Ich \xfcberlasse es Ihnen, zu sagen, was Sie sehen, um auf Schaltfl\xe4chen, Links und Men\xfcs auf dem Bildschirm zu klicken.","longDescription":"Wenn Sie den Namen eines Objekts auf Ihrem Bildschirm aussprechen, finde ich es und interagiere f\xfcr Sie damit. Keine auswendig gelernten Befehle \u2013 beschreiben Sie einfach, was Sie m\xf6chten, und ich k\xfcmmere mich um den Klick."},"keyboard_mouse_emulation":{"title":"Tastatur- und Mausemulation","description":"Ich emuliere Tasten, Klicks und Scrollen, sodass Sie Apps ohne Hardware steuern k\xf6nnen.","longDescription":"Ich sende Tastenanschl\xe4ge, Mausbewegungen, Klicks und Scroll-Ereignisse an die gew\xfcnschte Stelle. Kombinieren Sie mich mit Sprach- oder Kopfsteuerung, um herk\xf6mmliche Eingabeger\xe4te vollst\xe4ndig zu ersetzen oder zu verbessern."},"profiles_personalization":{"title":"Personalisierung","description":"Ich merke mir Ihre Pr\xe4ferenzen und passe sie an gespeicherte App-Steuerelemente an.","longDescription":"Ich behalte Ihre bevorzugten Apps, Befehle und Einstellungen im Auge. Wechseln Sie automatisch oder manuell zwischen den App-Steuerelementen. Ich zeige Ihnen immer die richtigen Steuerelemente f\xfcr Ihre aktuelle T\xe4tigkeit."},"cross_device_connectivity":{"title":"Ger\xe4te\xfcbergreifende Konnektivit\xe4t","description":"Ich erlaube Ihnen, mit Ihrem Telefon eine Automatisierung aus der Ferne zu starten.","longDescription":"Ich verbinde Ihr Mobilger\xe4t mit Ihrem Desktop, damit Sie problemlos Befehle ausf\xfchren, diktieren oder navigieren k\xf6nnen. Perfekt f\xfcr Pr\xe4sentationen, Remote-Sitzungen oder den gelegentlichen Gebrauch."},"quick_action_buttons":{"title":"Schnellaktionsschaltfl\xe4chen","description":"Ich gebe Ihnen App-f\xe4hige Schaltfl\xe4chen f\xfcr schnelle Aktionen.","longDescription":"Ich zeige kontextsensitive Schaltfl\xe4chen an, die sich an Ihre App anpassen. Egal, ob Sie an einem Meeting teilnehmen, eine Nachricht senden oder eine neue E-Mail erstellen m\xf6chten \u2013 komplexe Aufgaben sind mit nur einem Klick erledigt."},"ai_app_awareness":{"title":"KI-App-Bewusstsein","description":"Ich passe meine Steuerung an die von Ihnen verwendete App an.","longDescription":"Ich achte darauf, was auf Ihrem Bildschirm aktiv ist, damit ich Ihnen die richtigen Steuerelemente zum richtigen Zeitpunkt zur Verf\xfcgung stellen kann. Kein Durcheinander, kein R\xe4tselraten \u2013 genau das, was Sie brauchen, wenn Sie es brauchen. Alles auf Ihrem Ger\xe4t und ohne Daten in die Cloud zu senden."},"ai_rewrite":{"title":"KI-Neufassung","description":"Ich kann Ihren Text umschreiben, um den Ton zu verbessern, die Formatierung zu aktualisieren oder Details zu erweitern.","longDescription":"Ich bearbeite Texte direkt bei Ihnen. Ich kann sie freundlicher, formeller, k\xfcrzer, l\xe4nger oder detaillierter gestalten \u2013 ganz wie Sie es brauchen, um Ihre Botschaft besser r\xfcberzubringen."},"ai_translation":{"title":"KI-\xdcbersetzung","description":"Ich kann zwischen Sprachen oder sogar Programmiersprachen \xfcbersetzen.","longDescription":"Ich erm\xf6gliche Ihnen, Text in eine andere gesprochene Sprache umzuwandeln oder Code in eine andere Programmiersprache zu konvertieren. Ich arbeite vor Ort, sodass Sie die App, die Sie gerade verwenden, nicht verlassen m\xfcssen."},"head_mouse":{"title":"Kopfmaus","description":"Ich lasse Sie Ihren Mauszeiger mit Kopfbewegungen bewegen.","longDescription":"Ich setze Ihre Kopfbewegungen sanft in Cursorbewegungen um. Mit Funktionen wie Gleiten und Empfindlichkeitseinstellung erm\xf6gliche ich Ihnen eine pr\xe4zise, komfortable und freih\xe4ndige Steuerung."},"head_joystick":{"title":"Head Joystick","description":"Ich lasse Sie Ihren Kopf als Joystick f\xfcr Spiele oder Apps verwenden.","longDescription":"Ich bilde Ihre Kopfbewegungen auf Joystick-Achsen ab, damit Sie Spiele spielen oder kreative Software ohne Hardware steuern k\xf6nnen. Sie bewegen sich nat\xfcrlich und ich \xfcbersetze sie in analoge Eingaben."},"mcp_agent":{"title":"MCP-Agent","description":"Ich kann \xfcber das Model Context Protocol (MCP) eine Verbindung mit externen KI-Agenten herstellen.","longDescription":"Ich spreche das Model Context Protocol, das mir die Zusammenarbeit mit anderen KI-Agenten und -Tools erm\xf6glicht. Das bedeutet, dass ich Aufgaben koordinieren, Kontext austauschen und meine F\xe4higkeiten mit spezialisierten externen Systemen erweitern kann \u2013 und das alles, w\xe4hrend Sie die Kontrolle behalten."},"byo_ai_integration":{"title":"Bringen Sie Ihre eigene KI mit","description":"Ich lasse Sie meine vorhandene KI mit Ihren eigenen KI-Modellen oder -Diensten erweitern, um sie bei mir zu verwenden.","longDescription":"Wenn Sie bereits einen KI-Dienst, ein KI-Modell oder einen KI-Anbieter Ihres Vertrauens nutzen, integriere ich ihn gerne in meinen Workflow. Ich biete Ihnen die Flexibilit\xe4t, die Engine f\xfcr die Generierung, Umschreibung oder \xdcbersetzung auszuw\xe4hlen \u2013 ob Cloud, lokal oder benutzerdefiniert. Sollten Sie offline sein oder der Dienst nicht verf\xfcgbar sein, greife ich auf meine integrierten Funktionen zur\xfcck."},"workflows":{"title":"Workflows","description":"Ich helfe Ihnen, Aktionen zu wiederholbaren Arbeitsabl\xe4ufen zu verketten.","longDescription":"Ich \xfcbernehme die Gestaltung und Ausf\xfchrung mehrstufiger Prozesse, die verschiedene Eingaben, Befehle und Ausgaben miteinander verbinden. Mit Workflows k\xf6nnen Sie Routineaufgaben automatisieren oder komplexe Interaktionen erstellen \u2013 ausgel\xf6st durch Ihre Stimme oder Gesten. Die Schwerstarbeit \xfcbernehme ich f\xfcr Sie."},"showMore":"Mehr anzeigen","showLess":"Weniger anzeigen","background_creation":{"title":"Hintergrunderstellung","description":"Ich erstelle und bearbeite Inhalte im Hintergrund, w\xe4hrend Sie arbeiten.","longDescription":"Ich erstelle und bearbeite Inhalte im Hintergrund, w\xe4hrend Sie sich auf Ihre Arbeit konzentrieren. Wenn Sie die Inhalte ben\xf6tigen, stehen sie Ihnen in Ihrem Dateisystem zur Verf\xfcgung \u2013 ohne Unterbrechung Ihres Arbeitsablaufs oder l\xe4stiges Kopieren."},"ai_summary":{"title":"KI-Zusammenfassung","description":"Sammeln Sie Erkenntnisse aus l\xe4ngeren Texten und erstellen Sie kurze Zusammenfassungen oder Kernaussagen."}},"listing":{"title":"Anwendungsf\xe4lle","titleLong":"Entdecken Sie, wie ich Ihnen helfen kann","recommended":"F\xfcr Sie empfohlen","exploreMore":"Weitere Anwendungsf\xe4lle entdecken","description":"Entdecken Sie, wie ich Ihren Workflow verbessern kann. Von Produktivit\xe4tssteigerungen bis hin zu kreativer Unterst\xfctzung \u2013 finden Sie die perfekten Anwendungsf\xe4lle, die auf Ihre Bed\xfcrfnisse zugeschnitten sind.","all":"Alle","search":"Suchen Sie nach Anwendungsf\xe4llen, Apps oder Funktionen ...","noResults":"Es wurden keine Ergebnisse gefunden. Versuchen Sie, Ihre Suche oder Filter anzupassen.","emptyAction":"Mehr online ansehen"},"examples":{"universalAppControl":{"title":"Universelle App-Steuerung","description":"Steuern Sie jede Anwendung auf Ihrem Computer mit Sprachbefehlen und intelligenter Automatisierung","descriptionLong":"\xdcbernehmen Sie die Kontrolle \xfcber jede Anwendung mit leistungsstarken Sprachbefehlen und intelligenter Automatisierung. Unser universelles App-Steuerungssystem lernt Ihre Arbeitsweise und passt sich Ihren Bed\xfcrfnissen an. So werden komplexe Aufgaben vereinfacht und Routinevorg\xe4nge sofort erledigt. Von der Verwaltung Ihrer Produktivit\xe4tssuite bis hin zur Steuerung von Medien- und Spieleanwendungen \u2013 diese Funktion funktioniert in Ihrer gesamten digitalen Umgebung."},"documentSummary":{"title":"Privater KI-Desktop-Agent, der Ihre Dokumente liest, die Zusammenfassung schreibt und sie an Ihr Team sendet","description":"Nutzen Sie einen privaten Desktop-Agenten, um Dokumente zu lesen, Zusammenfassungen zu erstellen und diese freih\xe4ndig mit Ihrem Team zu teilen.","descriptionLong":"Weisen Sie Ihren KI-Assistenten auf ein Dokument hin und lassen Sie ihn es lesen, zusammenfassen und versenden. Alles l\xe4uft lokal und privat, w\xe4hrend Sie Ihre Arbeit erledigen, ohne einen Finger r\xfchren zu m\xfcssen."},"editingVideos":{"title":"Sprachbearbeitung in CapCut \u2013 Durch Zeitleisten navigieren, Clips schneiden und in der Geschichte bleiben","description":"Bearbeiten Sie Videos mithilfe von Sprachsteuerung und Diktierfunktion, um Clips freih\xe4ndig zu schneiden und anzuordnen.","descriptionLong":"Navigieren Sie durch Ihre Timeline, schneiden und teilen Sie Clips und gestalten Sie Ihren Schnitt allein mit Ihrer Stimme. Konzentrieren Sie sich auf die Geschichte, ohne durch Men\xfcs zu klicken oder die Maus zu benutzen."},"figma":{"description":"Bearbeiten Sie Bilder und Designs mithilfe von Sprachsteuerung und intelligenter Diktierfunktion f\xfcr schnellere Iterationen.","descriptionLong":"Erwecken Sie Ihre visuellen Ideen zum Leben \u2013 mit sprachgesteuerter Bildbearbeitung. Navigieren Sie schneller und optimieren Sie Ihre Designs, ohne sich durch komplexe Men\xfcs klicken zu m\xfcssen.","title":"Sprachbefehle f\xfcr Figma und Canva \u2013 Ebenen steuern, Werkzeuge wechseln und Text freih\xe4ndig eingeben"},"excelAnalysis":{"title":"Arbeiten und analysieren Sie schneller in Excel mit privater und lokaler KI-Automatisierung","description":"Analysieren Sie Tabellenkalkulationen und decken Sie Trends mithilfe privater, lokaler KI-Automatisierung auf \u2013 ganz ohne Ihr Zutun.","descriptionLong":"Analysieren Sie Trends in Ordnern oder Dokumenten, stellen Sie Fragen zu Finanzberichten und erstellen Sie eine abschlie\xdfende Zusammenfassung. Lassen Sie die Analyse von einer lokalen KI durchf\xfchren, w\xe4hrend Ihre Daten auf Ihrem eigenen Rechner privat bleiben."},"emailAutomation":{"title":"Automatisieren Sie Ihre E-Mails \u2013 Lokale KI-Workflows, die Ihren Posteingang lesen, Antworten entwerfen und vieles mehr!","description":"Lesen Sie Ihren Posteingang, entwerfen Sie Antworten und erstellen Sie Vorlagen mithilfe lokaler KI-Workflows und Diktierfunktionen.","descriptionLong":"Verfassen Sie eine E-Mail, die einen Artikel zusammenfasst und die wichtigsten technischen Details hervorhebt, oder erstellen Sie wiederverwendbare Vorlagen, um Ihren Posteingang schneller zu bearbeiten. Lassen Sie KI und Diktierfunktion das Lesen und Schreiben \xfcbernehmen und wahren Sie dabei Ihre Privatsph\xe4re."},"powerpointBuilder":{"description":"Verwandeln Sie Notizen, Dokumente und Tabellenkalkulationen mithilfe von KI-Workflows automatisch in eine fertige PowerPoint-Pr\xe4sentation.","descriptionLong":"Analysieren Sie eine Excel-Datei, um wichtige Verluste zu identifizieren, und lassen Sie anschlie\xdfend KI Ihre Notizen und Daten in eine professionelle Pr\xe4sentation umwandeln. Erstellen Sie Pr\xe4sentationen schneller, ohne sich durch Men\xfcs klicken oder von einem leeren Blatt beginnen zu m\xfcssen.","title":"KI-Workflows, die Ihre Notizen und Dokumente in eine fertige PowerPoint-Pr\xe4sentation verwandeln | KI-PowerPoint-Generator"},"socialDictation":{"description":"Posten und antworten Sie auf LinkedIn, Slack und Discord per Spracheingabe \u2013 kein Tippen erforderlich.","descriptionLong":"Verfassen Sie Beitr\xe4ge, antworten Sie direkt und bleiben Sie aktiv auf LinkedIn, Slack und Discord \u2013 ganz einfach per Sprachbefehl. F\xfchren Sie die Unterhaltung fort, ohne zur Tastatur greifen zu m\xfcssen.","title":"Spracherkennung f\xfcr LinkedIn, Slack und Discord | Posten und Antworten ohne zu tippen"},"developerTools":{"title":"Sprachsteuerung + KI-Automatisierung f\xfcr Entwickler | Kommentare, Dokumente und Commit-Nachrichten schreiben","description":"Schreiben Sie Kommentare, Dokumente und Commit-Nachrichten per Sprachsteuerung und KI-Automatisierung \u2013 ganz ohne H\xe4nde.","descriptionLong":"Fragen Sie, wie Sie den Code in einem Projektordner \xfcbersichtlicher gestalten k\xf6nnen, und diktieren Sie anschlie\xdfend Kommentare, Dokumentationen und Commit-Nachrichten, ohne sie einzutippen. Bleiben Sie im Arbeitsfluss, w\xe4hrend Sprachsteuerung und KI-Automatisierung die Routinearbeiten erledigen."},"terminalAgent":{"title":"KI-Desktop-Agent | Terminal-Builds und -Tests im Hintergrund ausf\xfchren, w\xe4hrend Sie weiter programmieren","description":"F\xfchren Sie Builds, Tests und Debugging im Hintergrund mit einem KI-Desktop-Agenten durch, w\xe4hrend Sie weiter programmieren.","descriptionLong":"Lassen Sie Ihren Agenten einen Projektordner \xfcberpr\xfcfen, ihn kompilieren, die Kompilierung best\xe4tigen und Testf\xe4lle ausf\xfchren. Sollte ein Fehler auftreten, durchsucht er die Git-Historie, um die Ursache zu finden und eine L\xf6sung vorzuschlagen \u2013 w\xe4hrend Sie sich weiterhin auf Ihre Arbeit konzentrieren k\xf6nnen."},"gamingFPS":{"description":"In Ego-Shootern wie Valorant kannst du mit Sprachsteuerung freih\xe4ndig zielen, schie\xdfen, nachladen und die Waffen wechseln.","descriptionLong":"Gib in FPS-Titeln wie Valorant per Sprachbefehle Befehle zum Schie\xdfen, Nachladen und Waffenwechsel. Mit Sprachsteuerung bleibst du im Spielgeschehen pr\xe4sent, ohne auf jede Taste angewiesen zu sein.","title":"Sprachsteuerung f\xfcr FPS, Valorant und mehr | Zielen, Schie\xdfen, Nachladen und Waffenwechsel freih\xe4ndig"},"gamingRPG":{"title":"RPG-Spielsteuerung f\xfcr Minecraft anpassen | Adaptive Steuerung f\xfcr Videospiele","description":"Passe die Spielsteuerung f\xfcr Minecraft und andere Rollenspiele individuell an deinen Spielstil an.","descriptionLong":"Richten Sie adaptive Steuerung f\xfcr Minecraft und andere Rollenspiele ein und belegen Sie Aktionen nach Ihren Bed\xfcrfnissen. Erstellen Sie ein Steuerungsschema, das zu Ihrem Spielstil passt, anstatt Ihre H\xe4nde dem Spiel anzupassen."},"educationTools":{"description":"Verwandeln Sie Notizen und Artikel mithilfe von KI direkt auf Ihrem Ger\xe4t in Lernhilfen und Lehrmaterialien \u2013 ganz ohne H\xe4nde.","descriptionLong":"Nehmen Sie einen Artikel und erstellen Sie daraus ein Word-Dokument mit Reflexionsfragen, die auf die jeweilige Klassenstufe zugeschnitten sind und eine kreative Schreibaufgabe unterst\xfctzen. Lassen Sie KI direkt auf dem Ger\xe4t Ihr Ausgangsmaterial in sofort einsatzbereite Unterrichtsmaterialien umwandeln \u2013 und das alles unter Wahrung Ihrer Privatsph\xe4re.","title":"Verwandeln Sie Unterrichtsnotizen und Artikel mithilfe von On-Device-KI in kreative Lernwerkzeuge oder Unterrichtsmaterialien."},"meetingNotes":{"title":"KI-Automatisierungen, die Besprechungsnotizen in kleinere Dateien umwandeln","description":"Verwandeln Sie Besprechungsnotizen mithilfe von KI-Automatisierungen automatisch in \xfcbersichtliche, umsetzbare Dateien.","descriptionLong":"Lesen Sie Ihre Besprechungsnotizen, um herauszufinden, was noch zu tun ist, wer daf\xfcr verantwortlich ist und wo es noch L\xfccken gibt. Lassen Sie die KI diese Informationen als separate Dateien auflisten und in einem Ordner organisieren, damit Sie sp\xe4ter alles \xfcberpr\xfcfen k\xf6nnen."},"fileManagement":{"description":"Organisieren Sie Downloads, finden Sie Dateien und r\xe4umen Sie Ihren PC auf \u2013 mit einem KI-gest\xfctzten Desktop-Agenten direkt auf Ihrem Ger\xe4t, ganz ohne Ihr Zutun.","descriptionLong":"Bitten Sie Ihren Agenten, Dateien aus Ihren Downloads in Ihr Produktdokumentationsverzeichnis zu kopieren oder Dateien auf Ihrem PC zu suchen und aufzur\xe4umen. Halten Sie Ihren Rechner mit ger\xe4teinterner KI \xfcbersichtlich, die Ihre Daten sch\xfctzt.","title":"On Device AI Desktop Agent | Organisieren Sie Ihre Downloads, finden Sie Dateien und bereinigen Sie Ihren PC"},"dictationWriting":{"title":"Freih\xe4ndiges Tippen und Erstellen von Dokumenten \u2013 Sprachdiktierfunktion, KI-Generierung und \xdcberarbeitung in jeder App","description":"Dokumente freih\xe4ndig per Spracheingabe und KI in jeder beliebigen App eingeben, generieren und \xfcberarbeiten.","descriptionLong":"Diktieren Sie Texte, erstellen Sie neue Inhalte und bearbeiten Sie Ihre Texte in jeder App \u2013 alles per Spracheingabe. Erstellen Sie Dokumente von Anfang bis Ende, ohne die Tastatur zu ber\xfchren."},"headMouseControl":{"title":"Freih\xe4ndige Computersteuerung mit Kopfmaus, Sprachsteuerung per Fingertipp | Adaptive Computersteuerung","description":"Steuern Sie Ihren Computer freih\xe4ndig mithilfe von Head-Tracking und der adaptiven Talk-to-Tap-Steuerung.","descriptionLong":"Bewegen Sie den Cursor per Kopfbewegungserkennung und klicken Sie mit der Talk-to-Tap-Funktion, um Ihren Computer komplett freih\xe4ndig zu bedienen. Richten Sie adaptive Steuerelemente ein, die Ihnen ein optimales Arbeitserlebnis erm\xf6glichen."},"documentTranslation":{"title":"KI-Dokument\xfcbersetzung f\xfcr alle, die sprach\xfcbergreifend arbeiten \u2013 Spanisch, Arabisch, Portugiesisch und mehr","description":"\xdcbersetzen Sie Dokumente mithilfe von KI freih\xe4ndig in Sprachen wie Spanisch, Arabisch und Portugiesisch.","descriptionLong":"\xdcbersetzen Sie Ihre Dokumente mit KI direkt auf Ihrem Ger\xe4t ins Spanische, Arabische, Portugiesische und weitere Sprachen. Arbeiten Sie souver\xe4n in verschiedenen Sprachen, ohne zwischen Tools wechseln oder Texte zwischen Apps kopieren zu m\xfcssen."},"websiteRedesign":{"description":"Analysiere Wettbewerber und erhalte automatisch Vorschl\xe4ge f\xfcr die Neugestaltung deiner Website mithilfe von KI.","descriptionLong":"Richten Sie die KI auf die Website von SafeDrive Auto Insurance und lassen Sie sie anschlie\xdfend die Websites von Mitbewerbern analysieren, um Unterschiede aufzudecken. Erhalten Sie konkrete Vorschl\xe4ge zur Modernisierung einer veralteten Website auf Basis realer Marktforschung.","title":"Private KI-Webrecherche + Automatisierungen | HTML durchsuchen, analysieren und erstellen"},"dataPrivacyResearch":{"description":"Informieren Sie sich \xfcber die neuesten Datenschutzgesetze und setzen Sie die Ergebnisse automatisch in Compliance-Ma\xdfnahmen um.","descriptionLong":"Recherchieren Sie die aktuellen Datenschutzgesetze von 2026 und deren Unterschiede zu denen von 2025 und ermitteln Sie, welche Ma\xdfnahmen Unternehmen ergreifen m\xfcssen. Lassen Sie KI eine Folge-E-Mail mit Beispielen erstellen, um Sie bei der Einhaltung der Vorschriften zu unterst\xfctzen.","title":"Durchsuchen, analysieren und zusammenfassen, ohne dass Ihre Daten Ihr Ger\xe4t verlassen | Private KI-Webrecherche"}},"control":{"title":"Kontrolle.","subtitle":"Ihre Software. Ihre Eingaben. Ihre Regeln.","description":"Sprachbefehle, Tastenkombinationen und Schnellzugriffsschaltfl\xe4chen \u2013 funktionieren in jeder App auf Ihrem Ger\xe4t. Keine Maus erforderlich. Keine Skripterstellung. Keine Einrichtung f\xfcr Hunderte von Apps, die Sie bereits verwenden.","titleAlt":"Kontrolle"},"create":{"title":"Erstellen.","subtitle":"Deine Worte. Deine Entw\xfcrfe. Deine Maschine.","description":"Entwerfen, \xfcberarbeiten, formatieren und \xfcbersetzen \u2013 direkt in der App, in der Sie gerade arbeiten. Keine Cloud. Kein Kopieren und Einf\xfcgen in ein anderes Tool. Keine Entw\xfcrfe, die das Modell eines anderen trainieren.","titleAlt":"Erstellen"},"automate":{"title":"Automatisieren.","subtitle":"Ein Satz. Jeder Schritt. Erledigt.","description":"Beschreiben Sie eine Aufgabe in einfacher Sprache, und Cephable erledigt sie. F\xfcr Ihre Anwendungen, Ihre Dateien und sogar die Kommandozeile. Es l\xe4uft im Hintergrund, w\xe4hrend Sie anderen T\xe4tigkeiten nachgehen, und es werden keine Daten von Ihrem Rechner gespeichert.","titleAlt":"Automatisieren"},"upgrade":{"subtitle":{"trial":"F\xfcr die n\xe4chsten {{days}} Tage sind meine KI-Funktionen freigeschaltet \u2013 Erstellen und Automatisieren, beide laufen auf einem einzigen Ger\xe4t. Aktivieren Sie sie, wann immer Sie bereit sind.","orgGeneric":"Ihre Organisation hat meine KI-Funktionen freigeschaltet \u2013 Erstellen und Automatisieren, die beide auf einem einzigen Ger\xe4t laufen. Aktivieren Sie sie, wann immer Sie bereit sind.","org":"Sie wurden der Organisation {{organization}} hinzugef\xfcgt, wodurch meine KI-Funktionen \u2013 Erstellen und Automatisieren \u2013 freigeschaltet werden, die beide auf einem einzigen Ger\xe4t ausgef\xfchrt werden. Aktivieren Sie sie, sobald Sie bereit sind."},"badge":{"trial":"Der Prozess endet in","trialDays_one":"{{count}} Tag","trialDays_other":"{{count}} Tage","org":"Freigeschaltet durch","orgGeneric":"Organisationslizenz"},"setup":{"eyebrow":"Richten Sie Ihre Pro-Funktionen ein.","title":"W\xe4hlen Sie aus, was eingeschaltet werden soll.","description":"Sie k\xf6nnen all dies sp\xe4ter in den Einstellungen \xe4ndern. Alles l\xe4uft lokal auf dem Ger\xe4t \u2013 Ihre Texte und Dateien bleiben bei Ihnen."},"enable":{"title":"KI-Funktionen aktivieren","description":"Ein einziger Schalter aktiviert sowohl \u201EErstellen\u201C als auch \u201EAutomatisieren\u201C. Beide Funktionen laufen auf demselben Ger\xe4t \u2013 eine separate Einrichtung ist nicht erforderlich.","model":{"label":"On-Device-KI-Modell","tag":"Gemeinsamer Motor","description":"Unterst\xfctzt sowohl die Erstellung als auch die Automatisierung. Gr\xf6\xdfere Modelle liefern bessere Ergebnisse, ben\xf6tigen aber mehr Ressourcen \u2013 die Software wird vollst\xe4ndig auf diesem Ger\xe4t heruntergeladen und ausgef\xfchrt."}},"create":{"title":"Erstellen","description":"Intelligente Textgenerierung und Diktierfunktion. Ich erstelle E-Mails, Dokumente, Code und kreative Inhalte \u2013 und wandle Ihre Sprache in formatierten Text f\xfcr jede beliebige App um.","locked":"Aktivieren Sie die oben genannten KI-Funktionen, und Create ist einsatzbereit."},"automate":{"title":"Automatisieren","description":"KI-Workflows. Beschreiben Sie eine Aufgabe in einem Satz, und ich plane und f\xfchre jeden Schritt aus \u2013 ich lese, schreibe und f\xfchre Befehle in Ihrem Namen aus.","locked":"Aktivieren Sie die oben genannten KI-Funktionen, und Automate ist einsatzbereit."},"status":{"on":"An","off":"L\xe4uft nicht."},"footer":"Alles l\xe4uft lokal auf dem Ger\xe4t. Nichts, was Sie erstellen oder automatisieren, verl\xe4sst Ihren Rechner.","cta":{"eyebrow":"Sie k\xf6nnen die KI jederzeit aktivieren.","title":"Mal sehen, ob es in euren Apps funktioniert.","action":"Erleben Sie mich in Aktion","back":"Zur\xfcck"},"pill":"{{license}} Entsperrt","title":"Sie wurden auf {{license}} hochgestuft."}}');


var $46e9372b918c82e5$exports = {};
$46e9372b918c82e5$exports = JSON.parse('{"recordWorkflow":{"title":"Record a Workflow","description":"Show Cephable how you do a task \u2014 narrate out loud as you click through it \u2014 and it becomes a reusable skill.","cardDescription":"Record yourself doing a task to teach Cephable how to do it.","goalLabel":"Recording description","goalPlaceholder":"What are you about to demonstrate? (optional)","start":"Start Recording","recording":"Recording your workflow","stepCount":"{{count}} steps","stopAndCreate":"Stop & Create Skill","creating":"Turning your recording into a skill\u2026","permissionNeeded":"Cephable needs Accessibility / Input Monitoring permission to record what you do. Grant it in System Settings, then start again.","noMic":"Microphone unavailable \u2014 recording your actions without narration.","startError":"Could not start recording.","noSteps":"No actions were captured to turn into a skill.","stopReminder":"Keep going as long as you need. When the task is done, come back here and press Stop & Create Skill.","callout":{"title":"Teach Cephable one of your tasks","description":"Do a task once while Cephable watches and narrate what you are doing. It turns into a skill you can run any time.","action":"Show me how","dismiss":"Not now","badge":"Try it","compactDescription":"Do a task once while Cephable watches and it becomes a skill you can run any time.","compactAction":"Record a workflow"},"coach":{"title":"Before you record","progress":"Tip {{current}} of {{total}}","ready":"I\'m ready","skip":"Skip the tips","reopen":"How this works","steps":{"pickTask":{"title":"Pick one real task","body":"Choose something you actually do, and plan to run it start to finish in one sitting. A short, complete task teaches far more than a long, half-finished one.","example":"This is how I file my weekly expense report \u2014 open it, fill it in, submit it."},"narrate":{"title":"Talk the whole way through","body":"Say what you are doing and why, out loud, the way you would if a new coworker were watching over your shoulder. Your narration is what Cephable turns into the steps.","example":"Now I\'m opening the invoice in Outlook so I can find the PO number."},"goSlow":{"title":"Click deliberately, one thing at a time","body":"Wait for each page or app to finish loading before the next click, and name what you are clicking. Skip anything private \u2014 passwords and card numbers do not belong in a skill.","example":"I\'m clicking Approve in the top right, and waiting for the confirmation to appear."},"explainRules":{"title":"Say the rules out loud","body":"Call out anything that changes from run to run and what you would do differently, so the skill can handle more than just today.","example":"If there\'s no PO number, I skip the spreadsheet and email the vendor instead."},"comeBack":{"title":"Come back and press Stop","body":"Cephable keeps recording until you say so. When the task is done, return to this panel and press Stop & Create Skill. If it hears nothing and sees no clicks for a minute, it will stop for you.","example":"That\'s the whole thing \u2014 done."}}},"idle":{"title":"Still recording","body":"No clicks and nothing said for a while. If you have finished the task, press Stop & Create Skill.","countdown":"Stopping automatically in {{seconds}}s.","keepGoing":"I\'m still working","autoStopped":"Recording stopped on its own after a minute of quiet."},"teachAction":"Teach Cephable a workflow"},"availableToInstall":"Available to install","deviceCommandThrottled":{"macroLength":"This connection does not allow long macros. Your macro has been shortened automatically.","commandCount":"This connection limits how fast you can send commands. Please wait and try again soon.","incompatibleActions":"This control contains actions that can\'t be used together and was not sent."},"logo":"Cephable logo","appControlsPanel":{"searchPlaceholder":"Search commands...","searchLabel":"Search commands","favorites":{"title":"Favorites","description":"Favorites are controls that you use often. You can mark a command as a favorite by clicking the star icon next to it."},"globalCommands":"Global","noCommandsFound":"No commands found","prefixCommandToast":"This is a prefix command \u2014 say or type the prefix followed by the phrase to trigger it."},"add":"Add","all":"All","edit":"Edit","create":"Create","delete":"Delete","previous":"Previous","next":"Next","collapse":"Collapse","sidebar":{"collapse":"Collapse sidebar","expand":"Expand sidebar"},"search":"Search","loading":"Loading...","reload":"Reload","cancel":"Cancel","copy":"Copy","send":"Send","save":"Save","reset":"Reset","deprecated":"Deprecated","saveAndFinish":"Save and Finish","saveAndContinue":"Save and Continue","saved":"Saved","saveError":"Error saving changes.","done":"Done","back":"Back","noResults":"No results","noResultsSearch":"No results found for your search.","interrupted":"Interrupted","play":"Play","pause":"Pause","resume":"Resume","success":"Success","continue":"Continue","options":"Options","share":"Share","finish":"Finish","error":"Error","description":"Description","expand":"Expand","expandMenu":"Expand Menu","finishEdit":"Finish Edit","advancedOptions":"View Advanced Options","authenticating":"Authenticating...","skipToMain":"Skip to Main Content","skip":"Skip","close":"Close","notFound":"Page Not Found","notFoundDescription":"Oh noes! We have searched the sea and we can\'t find thee page!","exitSetup":"Exit Setup","experimental":"Experimental","letGetStarted":"Let\'s get started!","exploreInputControls":"Explore Input Controls","when":"When I ...","thenMacro":"Cephable will run...","controls":"Controls","welcome":"Welcome.","beta":"beta","macroEmpty":"There are no macros matching this criteria.","you":"You","step":"Step","steps":"Steps","learnMore":"Learn More","dangerZone":"Danger Zone","connected":"Connected","notConnected":"Not Connected","connectAndLearn":"Connect & Learn","tryAgain":"Try Again","by":"By: {{value}}","noName":"- no name -","details":"Details","controlFeed":"Control Feed","upgrade":"Upgrade","purchase":"Purchase","results":"Results","explore":"Explore","created":"Created: {{value}}","updated":"Updated: {{value}}","deleted":"Deleted: {{value}}","expires":"Expires: {{value}}","expired":"Expired: {{value}}","used":"Used: {{value}}","uses":"Uses: {{value}}","generate":"Generate","stop":"Stop","on":"On","off":"Off","copied":"Copied","clear":"Clear","rewrite":"Rewrite","translate":"Translate","summarize":"Summarize","inputMethod":"Input Method: ","info":"More Information","view":"View","control":"Control","automate":"Automate","mobileApp":{"title":"Mobile App"},"dashboard":{"title":"Workspace"},"publicTag":"Public","invalidNumber":"N/A","wifi":{"disconnected":"Wi-Fi is disconnected.","connected":"Wi-Fi is connected.","description":"Connect to Wi-Fi to enable Cephable to work with your connections and software. You may have limited ability to use your current controls. "},"signalR":{"disconnected":"Syncing is disconnected.","description":"There appears to be a problem with Cephable syncing. This will cause issues saving your settings or communicating with other connections.","action":"Reconnect","disconnectedDevice":"Unable to sync with {{name}}.","disconnectedDeviceDescription":"There appears to be a problem with syncing either because of authentication or internet connectivity. You can not remotely send or receive data. You need to check both sides of the connection.","connected":"Syncing is connected.","connectedDescription":"Cephable is syncing properly and should be communicating with your connections and extensions as expected.","swap":"Swap to local device connection","unlinkedDevice":"Connection removed.","unlinkedDeviceDescription":"This connection has been unlinked from your account.","featureRestricted":"Create & Automate are unavailable for remote connections.","featureRestrictedDescription":"This feature is not currently available for remote connections. Please switch to the local device connection to get all of the power to create and automate your work."},"billing":{"title":"Billing","expires":"Next Billing: {{value}}","description":"Manage your organization billing, seats, subscription upgrades, renewal, or cancellation.","error":"Please contact your system administrator to manage your billing.","view":"Manage Billing","included":"Included with your {{licenseType}} license.","mostPopular":"Most Popular","upgrade":{"description":"Upgrade now and take your controls to the next level.","longDescription":"Upgrade to a paid license to unlock all of the features of Cephable. From multiple devices, to advanced controls, to custom integrations, Cephable has everything you need to take you to the next level of productivity.","action":"Upgrade Now","compare":"Compare Plans","error":"Error upgrading. Please try again later.","requiredDetail":"A {{licenseType}} license is required for this feature. You can always upgrade or start a free trial in your Account Settings.","enableTextGeneration":"Upgrade to generate, edit, and translate content using our Intelligent Tasks.","enableAiWorkflows":"Upgrade to automate your desktop and browser tasks with AI Workflows.","enableAiDictation":{"title":"Upgrade to Intelligent Dictation","description":"Upgrade to unlock AI enhanced dictation. I can add punctuation, fix capitalization, and adapt to your style so your writing looks polished without extra effort."}},"isPlusAccess":{"short":"Plus","title":"Plus","titleLong":"Cephable Plus","description":"Cephable Plus is for power users who want to push more with intelligent voice, intelligent dictation, 100\'s of app controls, and more.","supportedFeatures":{"tag":"Everything in Basic, plus","features":["Intelligent Voice Controls (Natural Language)","Intelligent Dictation (AI Enhanced)","Intelligent Tasks  (Generation, Translation, Rewriting)","100\'s of Pre-trained App Controls"]}},"isEmployeeAccess":{"short":"Pro","title":"Professional","titleLong":"Cephable Professional","description":"Cephable professional empowers users with more productivity power, extending the local, private AI to generative capabilities.","supportedFeatures":{"tag":"Everything in Plus, plus","features":["On-device AI Workflows","Enterprise organization management","Enterprise restrictions","Unlimited Device Installs","Unlimited Pre-trained App Controls"]}},"personal":{"short":"Basic","title":"Basic","titleLong":"Cephable Basic","description":"Cephable Basic is free forever and built to help you move faster, express yourself, and get stuff done\u2014your way. Features included in basic are available to all users.","upgrade":{"title":"Take your controls to the next level","description":"Upgrade to Plus or Pro to unlock all of my features. More accuracy. More connections. More controls. More power to take your productivity to the next level.","featureHeading":"Here\'s how I can help you:","control":"I move you through apps and tools faster using your voice or quick actions \u2014 no broken flow. With Intelligent Voice we can just chat.","create":"I rewrite, dictate, generate, and translate directly inside your apps \u2014 no copying, pasting, or screen switching needed.","automate":"I run intelligent tasks and quick actions that speed up your workflow. From simple commands to complex macros, I can do the heavy lifting so you can focus on the work that matters.","local":"All local AI. No cloud processing."}},"isDeveloperAccess":{"short":"SDK","title":"SDK","titleLong":"Cephable SDK","description":"Cephable SDKs let you integrate powerful adaptive controls\u2014 voice, face, head, and more into your software with minimal lift and maximum payoff.","supportedFeatures":{"tag":"Everything in Plus, plus","features":["Windows and MacOS support","Lightweight, embeddable SDKs for offline voice, face, head, and quick action input","API/webhook support for custom output actions","Developer docs","Sample projects","Turn commands into document automation and navigation","Developer Portal for managing your projects, auth clients, device types, and more"]}},"isStudentAccess":{"short":"Edu","title":"Student","titleLong":"Cephable Education","description":"Cephable Education supports personalized learning and inclusive classrooms. Cephable works offline, runs on-device, and requires no third-party integrations.","supportedFeatures":{"tag":"Everything in Plus, plus","features":["Unlimited device installs","Unlimited pre-trained app controls","Unlimited sharing of custom app controls"]}},"isResellerAccess":{"short":"Reseller","title":"Reseller","titleLong":"Cephable Reseller","description":"Cephable Reseller is a paid license that allows you to create new organizations and assign license keys. This includes using Cephable with your own software suite and improving your user experience."},"viewProducts":"View Products","subscription":{"options":"Subscription Options","monthly":"Pay Monthly","billedMonthly":"/month","yearly":"Pay Yearly","billedYearly":"/year"}},"organization":{"title":"Organization","titlePlural":"Organizations","titleLong":"Cephable Professional for Organizations","description":"Organizations are groups of users who can collaborate on projects and share resources. You can manage your team, team profiles, billing and more here.","viewOrganization":"View Organization","orgName":"Organization Name","orgCustomBillingUrl":{"title":"Custom Billing URL","description":"This is a custom URL that will be used to redirect the user to your (the reseller\'s) billing system. Should begin with \'https://\' or \'mailTo:\'"},"create":"Create New Organization","managed":{"title":"Managed Organization","titleShort":"Managed","titlePlural":"Managed Organizations","description":"Managed organizations are organizations that are managed by a Cephable Reseller. Resellers can manage your team, team profiles, billing and more here.","error":"Error loading managed organizations.","empty":{"title":"No managed organizations found.","description":"It doesn\'t look like there are managed organizations matching this criteria. Or your license keys have not been activated yet."}},"settings":{"title":"Organization Settings","description":"Manage your organization billing, name, description, and resources.","view":"View Settings","general":{"title":"General"},"resources":{"edit":"Edit Resources","description":"Use the Markdown editor on the left to update and format helpful resources for all members of the organization. As you type, the preview on the right will show how your content will appear to users. You can add headings, lists, links, and other formatting elements using Markdown syntax. Changes will be visible to members once saved."},"other":{"title":"Other Settings","description":"Manage your organization billing, name, description, and resources."},"managed":{"title":"Managed by Cephable","description":"These controls are set by Cephable for your organization. They are shown here so you can confirm the current values, and cannot be changed from the portal.","email":{"title":"Cephable email delivery","allowedDescription":"Cephable may send email to members of this organization, such as invitations, verification and password resets.","blockedDescription":"Cephable sends no email to members of this organization. Invitations, verification, password resets, magic links, onboarding and product emails are all suppressed."},"scim":{"title":"Automatic member provisioning (SCIM)","description":"Your identity provider creates and removes members in this organization. Invites cannot be sent from the portal."},"lockedNote":"Only Cephable can change these settings. Contact your Cephable representative if a value needs to be updated."}},"governance":{"title":"Governance","orgTitle":"{{value}} Governance","description":"Set the guardrails that guide how your team can use the Cephable assistant.","automation":{"title":"Automation rules","description":"Control where Cephable can automate and provide instructions that shape its behavior for your organization.","rulesTitle":"Rules","create":"Create automation rule","edit":"Edit automation rule","created":"Automation rule created.","updated":"Automation rule updated.","deleted":"Automation rule deleted.","loadError":"Unable to load automation rules.","saveError":"Unable to save the automation rule.","deleteError":"Unable to delete the automation rule.","searchPlaceholder":"Search rules by app, website, prompt, or scope","promptOnly":"Assistant instruction","editorDescription":"Choose the rule type, optionally target an app or website, and add clear instructions for Cephable.","validation":"Add an app or website, assistant instructions, or both.","appOrDomain":{"label":"App or website","helper":"Use a recognizable app name or domain, such as Slack, gmail.com, or github.com."},"prompt":{"label":"Assistant instructions","helper":"Describe what Cephable should or should not do. Keep instructions specific and actionable."},"type":{"label":"Rule type","block":"Block","allow":"Allow"},"scope":{"organization":"Organization-wide","organizationDescription":"Apply this rule to every current and future member.","members":"Specific members","membersDescription":"Save the rule, then assign it only to the members who need it."},"assign":"Assign members","delete":{"title":"Delete automation rule?","description":"This permanently removes the rule and any member assignments using it."},"empty":{"title":"No automation rules yet","description":"Create a rule to set your organization\u2019s first assistant guardrail."},"guidance":{"block":{"title":"Restrict apps and websites","description":"Use a Block rule with an app name or domain to stop Cephable from interacting with it."},"prompt":{"title":"Add assistant context","description":"Use assistant instructions to communicate policies, required checks, or safe ways of working."},"scope":{"title":"Choose the right scope","description":"Apply shared guardrails organization-wide, or keep exceptions limited to selected members."}},"assignment":{"title":"Assign rule to a member","description":"Manage the member-specific assignment for {{value}}.","memberLabel":"Member","apply":"Apply rule","remove":"Remove rule","assigned":"This rule is assigned to the selected member.","notAssigned":"This rule is not assigned to the selected member.","applied":"Rule applied to member.","removed":"Rule removed from member.","loadError":"Unable to load organization members.","statusError":"Unable to load this member\u2019s automation rules.","saveError":"Unable to update the member assignment."}},"tabs":{"automation":"Automation rules","permissions":"Extension permissions","skills":"Org skills","connectors":"Org connectors","usage":"Usage"},"extensions":{"permissions":{"orgTitle":"Organization-wide policy","orgDescription":"Control what members can enable across skills and connectors. These apply to everyone unless a member has an override below.","saved":"Organization policy updated.","saveError":"Unable to update the organization policy.","askAdmin":"Please contact your organization admin to enable this.","installBlocked":"Unable to install.","createBlocked":"Unable to add personal {{type}}.","useBlocked":"This {{type}} is no longer available to you."},"orgFlags":{"allowPublicSkills":{"title":"Allow public skills","description":"Members may publish or enable public skills available in the Cephable marketplace."},"allowMemberManagedSkills":{"title":"Allow personal skills","description":"Members may create and enable their own personal skills."},"allowPublicMcpServers":{"title":"Allow public connectors","description":"Members may publish or enable public connectors available in the Cephable marketplace."},"allowMemberManagedMcpServers":{"title":"Allow personal connectors","description":"Members may create and enable their own personal MCP connectors."}},"members":{"title":"Per-member overrides","description":"Grant an individual member the ability to share, manage, or use external skills and connectors.","memberLabel":"Member","saved":"Member permissions updated.","saveError":"Unable to update member permissions.","loadError":"Unable to load organization members.","adminNote":"This member is an organization admin and already has every extension permission."},"memberFlags":{"canShareSkillsWithOrganization":{"title":"Share skills with the organization","description":"Publish personal skills so other members can enable them."},"canManageOrganizationSkills":{"title":"Manage organization skills","description":"Create, edit, and remove skills shared with the organization."},"canUseExternalSkills":{"title":"Use external skills","description":"Enable public or personal skills even when the organization restricts them."},"canShareMcpServersWithOrganization":{"title":"Share connectors with the organization","description":"Publish personal connectors so other members can enable them."},"canManageOrganizationMcpServers":{"title":"Manage organization connectors","description":"Create, edit, and remove connectors shared with the organization."},"canUseExternalMcpServers":{"title":"Use external connectors","description":"Enable public or personal connectors even when the organization restricts them."}},"skills":{"title":"Organization skills","description":"Pre-configure skills for your organization. Members can discover and enable these from their apps.","create":"Create skill","edit":"Edit skill"},"connectors":{"title":"Organization connectors","description":"Pre-configure MCP connectors for your organization. Members supply their own credentials on their device when they enable one.","create":"Add connector","edit":"Edit connector"},"sort":{"label":"Sort by","recent":"Most recent","rating":"Highest rated","votes":"Most upvoted","installs":"Most installed"},"list":{"loadError":"Unable to load the list.","emptyTitle":"Nothing here yet","emptyDescription":"Create one to make it available to your organization\u2019s members."},"stats":{"rating":"Average rating","installs":"Members using this","votes":"Vote score","comments":"Comments"},"feedback":{"open":"Ratings & comments","description":"Ratings and comments are shared within your organization.","yourRating":"Your rating","upvote":"Upvote","downvote":"Downvote","comments":"Comments","commentPlaceholder":"Share how this works for your team\u2026","replyPlaceholder":"Write a reply\u2026","noComments":"No comments yet. Start the conversation.","member":"Member","deleted":"This comment was deleted.","reply":"Reply","loadError":"Unable to load comments.","rateError":"Unable to save your rating.","commentError":"Unable to post your comment.","deleteError":"Unable to delete the comment."},"usage":{"description":"See which members have enabled each org skill and connector.","skillsTitle":"Skill usage","connectorsTitle":"Connector usage","empty":"No members have enabled anything in this category yet.","installCount":"{{count}} member(s)","accountWide":"All devices","perDevice":"Single device","unnamed":"Untitled","loadError":"Unable to load usage."}}},"menu":{"title":"Organization Menu","view":"View Menu","expand":"Expand Menu"},"update":"Your organization has been updated! Refreshing the app.","noAccess":{"title":"Access denied.","description":"Your permissions have recently changed and you no longer have access to this feature. If you believe this is an error, please contact your organization administrator."},"noOrg":{"title":"No associated license.","description":"You are not currently associated with a license or developer group. The portal is limited to users with a paid Cephable License. To unlock the full potential of Cephable start a risk free trial."},"error":"Error loading Organization. Please try again later.","member":{"title":"Member","titlePlural":"Members","orgTitle":"{{value}} Members","me":"My Membership","aboutMe":"About Me","description":"Members are users who are part of your organization. They can be assigned to different roles and have access to different parts of the organization.","edit":"Edit Members","removed":"You have been removed from a team.","removedDescription":"You have been removed from the team. You can no longer access the organization. If you believe this is an error, please contact your organization admin.","updated":"Success, {{value}}\'s membership has been updated.","error":"Error updating {{value}}\'s membership.","delete":"Success, {{value}} has been removed.","deleteError":"Error removing {{value}}.","loadError":"Error loading organization members.","deleteConfirmation":{"title":"Are you sure you want to remove this member?","description":"Once you remove this member, they will no longer have access to the organization. You can always re-invite them later.","confirm":"Yes, remove member"},"viewAll":{"title":"View All Members","description":"View all members of your organization and manage their roles and permissions."},"seats":{"title":"Member Seats","description":"Every member in your organization counts as a seat. The type of permissions they have can be changed by the organization admin.","stats":"seats out of {{value}}","max":"Max seats","maxSeatValue":"Max seats: {{value}}","current":"Current Seats","limit":{"title":"Maximum Seats Reached","description":"Your current plan has reached its limit of {{ maxSeats }} available seats. You are unable to invite additional members. Please contact your administrator to upgrade the plan or manage your seat allocation."},"updateLimit":{"title":"Upgrade Your Plan to Add More Seats","description":"Your current plan has reached the maximum number of seats: {{ maxSeats }}. Upgrade now to unlock additional seats and ensure your team can continue to grow seamlessly.","action":"Upgrade Plan"}},"emailExists":"Email already exists in the organization. Please enter a different email address."},"invite":{"title":"Invite","titlePlural":"Invites","orgTitle":"{{ value }} Invites","description":"Invites are sent to users to join your organization. You can invite users to join your organization and assign them to different roles.","edit":"Add a Member","view":"View All Invites","viewDescription":"See all current invites that have not been accepted.","new":"Invite a Member","editDescription":"Create a new invite for a user to join your organization.","emailRequired":"Email is required","emailInvalid":"Email is invalid. Please enter a valid email address.","emailExists":"Email already has an organization invite. Please enter a different email address.","emailPlaceholder":"Enter email address","expiration":"Expires ","delete":"Delete Invite","confirm":"Are you sure you want to remove this invitation?","confirmLong":"Once you delete this invite, the user will no longer be able to join the organization. You can always re-invite them later.","accept":"Accept Invite","stat":"active invitations","error":"Error loading invites.","noInvites":{"title":"No invites.","description":"It looks like there are no active invites for your organization."},"acceptSuccess":{"title":"Welcome to the team.","description":"You have successfully joined the organization. ","action":"View your new organization"},"acceptError":{"title":"Oops. Looks like there is a problem.","description":"There was an error joining the organization. Please try again later. If the issue persists, please reach out to your organization admin. ","action":"Back to the homepage"},"send":{"title":"Send Invite","success":"Invite to {{value}} sent.","error":"Error sending invite to {{value}}."},"scimManaged":{"title":"Members are managed in your identity provider","description":"This organization uses automatic provisioning (SCIM), so membership is controlled by your internal identity system. Add or remove people there and the change syncs to Cephable automatically \u2014 invites cannot be sent from the portal."}},"role":{"title":"Role","titlePlural":"Roles","description":"Roles are the different levels of access that a user can have in your organization. You can assign different roles to users to control what they can do."},"isAdmin":{"title":"Admin","description":"Admins have full access to the organization and can manage all aspects of the organization.","conflict":"This member is an Admin. You do not have permission to edit their roles."},"canViewMembers":{"title":"View Members","description":"Users with this permission can view all members of the organization."},"canInviteMembers":{"title":"Invite Members","description":"Users with this permission can invite new members to the organization and manage existing invites."},"canChangeMemberPermissions":{"title":"Change Member Roles","description":"Users with this permission can change the role of other members in the organization."},"canRemoveMembers":{"title":"Remove Members","titleSingle":"Remove Member","action":"Remove","description":"Users with this permission can remove other members from the organization.","confirm":"Are you sure you want to remove this member from the organization?","confirmLong":"Once you remove this member, they will no longer have access to the organization. You can always re-invite them later."},"canCreateAuthClients":{"title":"Create Projects","description":"Users with this permission can create new auth clients and projects for the organization."},"canViewAuthClients":{"title":"View Projects","description":"Users with this permission can view auth clients and projects for the organization."},"canManageBilling":{"title":"Manage Billing","description":"Users with this permission can manage the billing settings for the organization.","error":"You do not have permission to manage billing for this organization."},"canManageChildOrganizations":{"title":"Manage Child Organizations","description":"Users with this permission can create and manage child organizations as an admin."},"canAccessOrganizationProfiles":{"title":"View Organization App Controls","description":"Users with this permission can view the organization app controls associated with this organization."},"canEditOrganizationProfiles":{"title":"Manage Organization App Controls","description":"Users with this permission can create, edit, and delete organization app controls associated with this organization."},"canManageGlobalAutomationRules":{"title":"Manage Governance","description":"Users with this permission can manage organization automation rules and member assignments."},"canViewAnalytics":{"title":"View Analytics","description":"Users with this permission can view the metrics and analytics for the organization."},"metrics":{"title":"Metrics","description":"Metrics are data points that help you understand how your organization is using Cephable.","view":"View Metrics","orgTitle":"{{ value }} Metrics","manage":{"title":"Performance Metrics","description":"Download or clear the performance metrics collected during model inference."},"download":{"button":"Download Metrics","success":"Metrics file has been saved to your Downloads folder.","error":"Failed to download metrics file.","noFile":"No metrics file found. Try running the model first."},"clear":{"button":"Clear Metrics","success":"Metrics have been cleared.","error":"Failed to clear metrics file.","confirm":{"title":"Clear Performance Metrics","description":"Are you sure you want to clear all recorded performance metrics? This action cannot be undone.","cancel":"Cancel","confirm":"Clear Metrics"}},"lineChart":{"title":"Average Concurrent Connections","description":"This chart shows the average concurrent connections for the organization and project data over time.","max":"Max Connections: {{maxConnections}}","project":"Project Total","org":"Organization Total"}},"profiles":{"titleShort":"App Controls","title":"Organization App Controls","description":"Organization App Controls are shared profiles for distributing app controls across your organization or to share with your integration users. ","view":"View Organization App Controls","editDescription":"Edit organization app controls to customize settings.","empty":"No organization app controls found. Create one to get started.","error":"Error loading organization app controls."},"projects":{"title":"Projects","description":"Use Projects to manage secure access, configure device interactions, and streamline how your apps send and receive commands across various platforms.","name":"App Name","view":"View Projects","error":"Error loading projects.","orgTitle":"{{ value }} Projects","stats":{"title":"Project Stats","connections":"Total Connections","all":{"title":"All Project Metrics","description":"Aggregated metrics for all projects associated with {{ orgName }}"},"card":"projects out of {{value}}","users":"total users since {{date}}","avgUsers":"monthly avg users.","concurrent":{"title":"Average Concurrent Connections Last {{days}} days","label":"Avg Concurrent","max":"Max Connections","overage":"Overage","description":"Concurrent connections are the number of users connected to your project at the same time. This metric helps you understand how many users are using your app simultaneously."}},"projectType":{"title":"Project Type","description":"Project Types are used to categorize your projects and help us choose the right SDKs for you."},"accessDenied":{"generic":"You do not have access to this project.","title":"Access Denied.","description":"You do not have access to view, create, edit or delete projects. Please reach out to your administrator for access."},"upgrade":{"title":"Upgrade to Cephable SDK","description":"Cephable can be integrated directly into your app, game, or service using our SDK\u2019s. Projects are not currently available with your account. If you think there is a mistake, please reach out to support@cephable.com.","shortDescription":"Projects are not currently available with your account. Reach out to upgrade."},"limit":{"title":"Want more projects?","error":"Project limit reached.","description":"You have reached the maximum number of projects for your organization. Please reach out to your administrator to upgrade your account."},"create":{"title":"Create Project","titleLong":"Let\u2019s get started.","first":{"title":"Get started with your project.","description":"It looks like you haven\'t created a project yet. Client keys and devices are essential for securing communication between your applications and our services. With a client key, you\u2019ll be able to integrate voice and head motion controls into your apps quickly and securely."},"details":{"title":"Project Details","description":"Create a new project to manage your application\u2019s authorization, device capabilities, and SDK integrations. Follow the steps below to set up secure, customizable interactions for your users."}},"sdk":{"title":"Download the SDK","description":"Get access to our powerful SDK developed to make adaptive controls easy. ","select":{"title":"Select SDK","description":"Select the SDK you\u2019d like to use for this project. Our SDKs enable seamless integration of adaptive voice and head motion controls across different platforms."}},"clients":{"title":"Authorization Clients","configure":"Configure Authorization Client","description":"Authorization Clients manage secure access for your applications. Define an authorization client to authenticate users and control interactions with your application.","settings":"Authorization Settings","create":"Create Authorization Client","max":"Max Projects: {{value}}"},"secret":{"title":"Client Secret","created":"Your client secret has been created.","description":"Your client secret will only be shown once. Copy it now and store it in a safe secure location. <br> <br> Only use this for your own development. Do not share it with third party services or applications.","copy":"Copy Secret","rotate":{"title":"Rotate Client Secret","description":"WARNING: This action will revoke your existing client secret and create a new client secret. This will require you to update all of your existing usage through out your apps. This action can not be reversed.","error":"Error rotating secret. Please try again later."}},"key":{"title":"Client Key","view":"View Client Key","copy":"Copy Key","delete":{"title":"Delete Client Key","description":"WARNING: This action will remove your existing client key and all related settings.This action can not be reversed.","error":"Error deleting your client key.","success":"You\'re project has been deleted. "}},"tokenRedirect":{"title":"Token Redirect URLs","description":"Token Redirect URLs are the endpoints where access tokens are sent after authentication is complete. These URLs allow your application to securely receive tokens needed to access user data and services."},"authRedirect":{"title":"Authorization Code Redirect URLs","description":"The AuthCode Redirect URL is the endpoint where authorization codes are sent after a user grants permission to your application. This URL is essential in OAuth flows, as it ensures the secure transmission of the authorization code from the authorization server to your app, allowing you to request access tokens on behalf of the user."},"originHost":{"title":"Origin Host","description":"The URL that will serve as the primary source for request and data during API interactions."},"scopes":{"title":"Scopes","configure":"Define Scopes","titleLong":"API Permission Scopes","manage":"Manage Authorization Scopes","description":"Scopes define the permissions that this authorization client will have. Set scopes to limit access to specific data and functionality, ensuring users only get the access they need."},"type":{"title":"Implementation Type"},"deviceScopes":{"title":"Associated Device Types","titles":"Associated Device Types","titleLong":"Allowed Device Types","configure":"Configure Allowable Device Types","descriptionShort":"Define which type of devices can access this project.","description":"Device Type defines the permissions and access levels that a device has within your application. By assigning specific devices types, you can control the actions and data that each device can access, ensuring that your application remains secure and compliant with your privacy policies.","action":"Add new device type"},"deviceType":{"title":"Device Types","description":"A DeviceType defines a category of devices, detailing their input/output capabilities and supported features (e.g., voice, gesture, controller types). It ensures that only authorized devices can interact with an application.","action":"Create Device Type","name":"Device Type Name","descriptionLong":"Device Type Description","id":"Device Type Id","features":{"title":"Supports Features","description":"Define the input and outputs that your app supports. This helps us optimize user experience across Cephable.","supportsVoiceInput":"Voice Input","supportsPhysicalInput":"Physical Input","supportsKeyboardOutput":"Keyboard Output","supportsPlayStationControllerOutput":"PlayStation Controller","supportsFaceInput":"Face Input","supportsGestureInput":"Gesture Input","supportsXboxControllerOutput":"Xbox Controller","supportsDigitalExtensions":"Digital Extensions","supportsPhysicalExtensions":"Physical Extensions","supportsNintendoControllerOutput":"Nintendo Controller","supportsGenericControllerOutput":"Generic Controller Output"},"canAutoStart":{"title":"Supports Automatic Control Starts","description":"[canAutoStart] if enabled, SDK\u2019s will check the user settings and attempt to immediately start camera, or microphone controls after user login."},"isSupported":{"title":"Active","description":"[isSupported]  If disabled, Cephable will no longer send, receive or  acknowledge any user devices associated with this. Equivalent to deprecated."},"throttleRules":{"title":"Command Throttle Rules","description":"Configure throttle rules to control command flow and input restrictions for this device type.","disableVoiceInput":"Disable Voice Input","disableHotkeyInput":"Disable Hotkey Input","disableCameraInput":"Disable Camera Input","disableMultiInputs":"Disable Multiple Inputs","maximumCommandsPerSecond":"Maximum Commands Per Second","maximumCommandsPerMinute":"Maximum Commands Per Minute","maximumMacroLength":"Maximum Macro Length","jitter":{"title":"Timing Jitter","description":"Add random variation to hold and pause durations to create more natural input patterns.","holdTimeJitterMin":"Hold Time Jitter Min (ms)","holdTimeJitterMax":"Hold Time Jitter Max (ms)","pauseTimeJitterMin":"Pause Time Jitter Min (ms)","pauseTimeJitterMax":"Pause Time Jitter Max (ms)"},"incompatibleActions":{"title":"Incompatible Action Groups","description":"Define groups of actions that cannot coexist in the same macro.","addGroup":"Add Group","removeGroup":"Remove Group","addAction":"Add Action","removeAction":"Remove Action","reason":"Reason","reasonPlaceholder":"Why these actions are incompatible","eventType":"Event Type","key":"Key","customActionId":"Custom Action ID","emptyGroup":"No actions in this group. Add at least two actions."},"requiredPause":{"title":"Required Pause Between Actions","description":"Define pairs of actions that require a minimum pause between them in the same macro.","addRule":"Add Rule","removeRule":"Remove Rule","actionA":"Action A","actionB":"Action B","minimumPause":"Minimum Pause (ms)","bidirectional":"Bidirectional","bidirectionalHelp":"When enabled, the pause is required in both directions (A\u2192B and B\u2192A)."},"macroStepRules":{"title":"Macro Step Rules","holdTimeJitterMin":"Hold Jitter Min (ms)","holdTimeJitterMax":"Hold Jitter Max (ms)"}},"locale":{"title":"Default Language","description":"[defaultLocale] The default locale for this device type. This will be used as the default language for the device.","support":"Supports Languages","warn":"** It looks like you have Custom Controls set up. Please make sure that you have updated the custom controls for the associated languages.**","name":"{{lang}} - Device Type Name","langDescription":"{{lang}} - Description"},"customControls":{"title":"Custom Controls","description":"Custom Controls are an advanced option for allowing users to manually set up and edit app controls associated with this device. If you are wanting users to control your device from Cephable directly, then you must register your device controls here. Please see Cephable API for complete details on the options.","object":"{{lang}} - Custom Controls Object","addControl":"Add Control","empty":"No custom controls yet. Use \\"Add Control\\" to create your first one.","untitled":"Untitled control","controlId":"Control ID","controlIdHelp":"Unique identifier for this control. Set it before saving \u2014 it cannot be changed afterward.","fallback":"Fallback","controlName":"Control Name","controlDescription":"Control Description","defaultCommandsLabel":"Default Voice Commands","defaultCommandsHelp":"These are the default voice triggers users see for this control in the current language.","sharedAcrossLanguages":"Shared across all languages","sharedAcrossLanguagesHelp":"Editing these fields updates the value for every language at once.","iconUrl":"Icon URL","contextGroupName":"Context Group","isProfileControl":"Profile Control","isPrefixVoiceCommand":"Prefix Voice Command","allowWhenDictating":"Allow When Dictating","allowsHold":"Allows Hold","isDeprecated":"Deprecated","requiresEmployeeAccess":"Requires Employee Access","requiresStudentAccess":"Requires Student Access","requiresGenericLicense":"Requires Generic License","requiresPlusAccess":"Requires Plus Access","allIncomplete":"All locales have incomplete custom controls. Please complete at least one locale before saving.","savedWithIncomplete":"Saved. Incomplete custom control locales not saved: {{incompleteLocales}}"},"success":{"title":"Success!","description":"You have created a new Device Type. {{name}} You can now update your authorization client device scope as needed."}}},"troubleshooting":{"title":"Troubleshooting","editorDescription":"[Optional] This is a section that is visible to all users via the connection details page in both the Cephable mobile and desktop apps.","description":"If you are experiencing issues with Cephable, try the steps below to resolve common problems."},"onboarding":{"title":"Onboarding","editorDescription":"[Optional] Onboarding is displayed to users when this device type is added to their account. This is a great place to provide instructions on how to set up and use the device type with your application."},"documents":"Documents","completionStatus":{"title":"Completion Status","error":"","complete":"Complete.","incomplete":"Incomplete."},"metadata":{"title":"Metadata","urlError":"URL must start with http:// or https://","metatitle":{"label":"Meta Title","placeholder":"Enter a short title"},"shortDescription":{"label":"Short Description","placeholder":"Enter a brief preview description (max 150 characters)"},"externalLink":{"label":"External Link URL","placeholder":"https://example.com/device-info","description":"A direct link to an external website or resource that provides more information about setting up this device for the first time. If you use this we will not use the client listing markdown."},"iconUrl":{"label":"Device Icon URL","placeholder":"https://example.com/device-icon.png","description":"A direct link to an image that represents this device type. This icon will be displayed in the Cephable app and on device listings."},"darkModeIconUrl":{"label":"Dark Mode Device Icon URL","placeholder":"https://example.com/device-icon-dark.png","description":"A direct link to an image that represents this device type in dark mode. This icon will be displayed in the Cephable app and on device listings when the user has dark mode enabled."},"editorDescription":"When your device is chosen to be featured in the Cephable app as an extension or connection, we use this information to display to users setting up new connections."},"client-listing":{"title":"Client Listing","editorDescription":"Detailed instructions for new users to set up new connections with this device type. This markdown content will be displayed in the Cephable app when users are adding a new connection."},"new":{"details":"Organization Details","name":{"label":"Organization Name","placeholder":"Enter the name of your organization"},"description":{"label":"Organization Description","placeholder":"What are your goals with using Cephable Professional?"}},"expired":{"title":"Your Cephable License has Expired","titlePlural":"Your Cephable Licenses have Expired","user":"It looks like your Cephable License has expired, so you\'ve been downgraded to the free Cephable Basic. To renew, please contact your organization administrator.","admin":"It looks like your Cephable License has expired, so you\'ve been downgraded to the free Cephable Basic. Please renew your license to continue using advanced features beyond Cephable Basic.","multiple":"It looks like your Cephable Licenses have expired, so you\'ve been downgraded to the free Cephable Basic. Please renew at least one of your licenses to continue using advanced features beyond Cephable Basic.","banner":"It looks like your Cephable License has expired, so you\'ve been downgraded to the free Cephable Basic. By renewing, gain access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.","dialog":{"title":"Select an Organization","description":"You have multiple organizations associated with your account. Please select the organization you would like to renew."}},"upgrade":{"existing":{"title":"You are part of an existing license.","description":"Please upgrade by clicking `{{action}}` on the side menu."}},"restrictions":{"isGenAIDisabled":{"title":"Generative AI Disabled","description":"Your organization has disabled access to Generative AI features. Please contact your organization administrator for more information."},"isRemoteControlDisabled":{"title":"Cross Device Syncing Disabled","description":"Your organization has disabled access to syncing, you will not be able to use our companion app or control external devices. Please contact your organization administrator for more information."}}},"developer":{"title":"Developer","titleLong":"Developer Resources","description":"Cephable can be integrated directly into your app, game, or service using our SDK\u2019s.","sdk":{"title":"Explore Our SDKs","description":"We provide first-class SDKs designed to seamlessly integrate voice recognition and adaptive controls into your applications. Our tools are crafted to enhance user interaction through intuitive controls and to foster accessibility, ensuring that your software can be operated more effectively by all users.","javascript":{"title":"JavaScript","subtitle":"Web","description":"Integrate voice and adaptive controls directly into your web applications.","action":"Get NPM Package"},"net":{"title":".NET","subtitle":"Windows Applications","description":"Leverage the power of .NET to create applications with our WPF and WinUI3 SDKs.","actionCore":"Get Core Package","actionWpf":"Get WPF Package"},"android":{"title":"Android","subtitle":"Mobile Devices","description":"Android applications designed to facilitate  voice and head motion capabilities.","action":"Get Android SDK"},"docs":{"title":"Documentation","description":"Explore detailed documentation, sample projects, and guides to start building with Cephable","action":"View Docs"},"more":{"title":"More","description":"Not finding what you need? Reach out and we can help you.","action":"Request a SDK"}},"demo":{"title":"Demos","samples":"Docs and Samples","titleLong":"Experience Our SDKs in Action","description":"Discover the power of our voice and head motion control technologies through our sample applications. From interactive games to dynamic web and mobile apps, each example demonstrates the versatility and effectiveness of our SDKs. Explore these examples to gain insights and inspiration for integrating enhanced accessibility and immersive experiences into your own projects.","game":{"title":"2048 Game","subtitle":"Web","description":"Elevate traditional gameplay with adaptive voice and head motion controls.","action":"Play the Game"},"other":{"title":"Other Demos","description":"Experience firsthand how Cephable can your enhance your application, game or device.","action":"View More Demos"},"web":{"title":"Web SDK Samples","subtitle":"Web","description":"Straightforward integration of all our core functionality into web applications.","action":"Experience the SDK"},"unity":{"title":"Unity","subtitle":"Game Development","description":"See how adaptive controls can be leveraged in gaming to provide a more engaging UX.","action":"Get the Sample"},"docs":{"title":"Developer Docs and Samples","description":"Explore detailed documentation, sample projects, and guides to start building with Cephable","action":"View Docs"}},"other":{"title":"Other Resources","description":"Not finding what you need in our SDK\u2019s try working directly with out API\u2019s or reach out the community for help, inspiration and support.","api":{"title":"API","description":"Our API\u2019s allow you to interact with Cephable directly. You can use our API\u2019s to create custom integrations."},"support":{"title":"Support","description":"Not finding what you need? Reach out to our community via Discord.","action":"Join Discord"}}},"customControls":{"title":"Global & Device Controls","warn":"Microphone has not been started. You must start your microphone to use global and device controls.","descriptionShort":"Global and device controls are always-available actions designed to work across any software. Global controls\u2014like \'Stop Camera\'\u2014are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls.","description":"Global and device controls are always-available actions designed to work across any software. Global controls\u2014like \'Stop Camera\'\u2014are system-wide and app-independent, while device controls are tailored to each device connection and unlock more advanced features than standard app controls. These controls are currently accessed as voice controls, however in the future we will add support for other inputs.","prefixDisclaimer":" This is a prefix control; it will listen to the words after the command and then search against the following phrase to find matches.","allowPausedDisclaimer":" This control will work even when the microphone is paused.","noDevice":"This step uses a custom extension that you haven\'t configured for your account. Add the extension to unlock this step.","resetControls":{"title":"Reset Controls","description":"Your voice language has changed since the last time you updated your controls. Note: This will reset your controls to match {{language}}, and you may lose any custom commands. Are you sure you want to reset?","confirm":"Yes, reset controls","error":"There was an error resetting your controls. Please try again later."},"conflictIndicators":{"warn":"Warning: ","title":"Input configuration conflicts detected","description":"Some of the inputs for your global & device controls you are using are also used in one or more of your app controls. This may cause conflicts when using Cephable. When this occurs we will always give preference to the app control over the global or device control.","item":"The input <strong> {{value}} </strong> is used in your app controls: ","globalControls":"Global Control Configuration Conflicts","deviceControls":"Device Control Configuration Conflicts","globalDescription":"The following global controls have conflicting inputs with your app controls.","deviceDescription":"The following device controls have conflicting inputs with your app controls.","usedInput":" is used as an input for "},"globalControls":{"title":"Global Controls","description":"Global controls are controls that are always available no matter what app controls or device you are using. Some even work when your microphone or camera controls are paused.","empty":"You have no global controls yet. Click below to create one.","edit":"Edit Global Controls"},"deviceControls":{"title":"Device Controls","description":"Device controls are tied to the specific device or connection you\'re using. They\u2019re available without needing to add them to your app controls and are especially useful for features or events that are only supported on certain devices.","empty":"You have no device controls yet. Click below to create one.","edit":"Edit Device Controls","controls":{"cephable-open-app":{"success":"Open app: {{value}}","error":"Unable to find app: {{value}}"},"cephable-close-app":{"commands":["close"],"name":"Close App By Name","description":"Use this command with voice controls to close an app on your computer by name.","success":"Close app: {{value}}","error":"Unable to find app: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimize"],"name":"Minimize the current app in focus.","description":"Use this command with voice controls to minimize the current app in focus.","success":"Minimize focused app success!","error":"Error minimizing focused app."},"cephable-maximize-focused-app":{"commands":["maximize"],"name":"Maximize the current app in focus.","description":"Use this command with voice controls to maximize the current app in focus.","success":"Maximize focused app success!","error":"Error minimizing focused app."},"cephable-close-focused-app":{"commands":["close current"],"name":"Close the current app in focus.","description":"Use this command with voice controls to close the current app in focus.","success":"Close current app success!","error":"Error closing current app."},"cephable-generate-text":{"commands":["generate"],"name":"Generate text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to generate some related text."},"cephable-rewrite-text":{"commands":["rewrite"],"name":"Rewrite text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to rewrite your current highlighted text."},"cephable-summarize-text":{"commands":["summarize"],"name":"Summarize text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to summarize your current highlighted text."},"cephable-translate-text":{"commands":["translate"],"name":"Translate text by providing the prompt following this command.","description":"Use this command with voice controls followed by your prompt to translate your current highlighted text."},"cephable-stop-generate-text":{"commands":["stop generate","stop generation","cancel generate","cancel generation"],"name":"Stop generating text.","description":"Use this command with voice controls to stop generating text"},"cephable-open-panel":{"commands":["show panel"],"name":"Open the Cephable panel","description":"Use this command with voice controls to open the Cephable panel."},"cephable-close-panel":{"commands":["hide panel"],"name":"Hide the Cephable panel","description":"Use this command with voice controls to hide or minimize the Cephable panel."},"cephable-click-by-name":{"commands":["tap","hit","navigate to","go to"],"name":"Tap Element By Name","description":"Tap something on the page by name, such as \\"tap save\\" to click a button named \\"save\\". This is the same as voice mouse, clicking things with voice commands instead of using a mouse."},"cephable-automate":{"commands":["automate","try to","have cephable","do a workflow to","work on"],"name":"Run an AI Workflow by describing a task after this command.","description":"Use this command with voice controls followed by a task, such as \\"automate sending an email to my team\\", and Cephable will carry it out as an AI Workflow."},"cephable-paste-background-entry":{"commands":["paste recent entry","paste last entry","paste last dictation","paste background content"],"name":"Paste the most recent background content.","description":"Use this command to paste the newest content stored in the background into the app in focus."}}},"changeProfile":{"success":"Change app controls: {{value}}","error":"Unable to find app controls: \'{{value}}\'"}},"notifications":{"title":"Notifications","center":"Notification Center","empty":"You have no notifications at this time. Check back another time.","seen":"Seen","markAsRead":"Mark as Read","view":"View All {{value}} Notifications"},"unsaved":{"title":"You have unsaved changes.","description":"You have unsaved changes. Are you sure you want to leave this page?","cancel":"Exit without saving","confirm":"Save and Exit"},"login":{"welcome":"Welcome to Cephable!","subtitle":"Control your technology on <strong>your</strong> terms.","description":"Control. Create. Automate. Cephable \u2014 your personal AI for fast commands, in-context drafting, and hands-off workflows. No cloud processing. Just seamless assistance that moves with you.","create":"Create Account","signIn":"Sign In","loading":"Redirecting to sign in...","error":"There was an error signing you in. Please sign in again.","existingAccount":"Already have an account?"},"home":{"title":"Home","startControls":"Turn it on!","manage":"Configure","profileGenerate":{"title":"Oops. Looks like you don\'t have any app controls yet.","description":"In order for Cephable to control your computer, we need to know what you want to control. You can create app controls from scratch or have us help you create one using our control generator."}},"workspace":{"title":"Workspace","badge":"On-device \xb7 private","badgeRemote":"Remote device \xb7 secure","subtitle":"Your AI assistant runs entirely on this device. Start controls, create, automate, or just chat.","subtitleRemote":"Everything you\u2019d click or type, at your command.","control":{"title":"Control","description":"Voice commands, keyboard shortcuts, and quick action buttons \u2014 working across every app on your device.","voice":{"title":"Voice controls","description":"Hands-free commands"},"dictation":{"title":"Dictation","description":"Speak to type"},"camera":{"title":"Camera controls","description":"Face and head gestures"},"quickActions":{"title":"Quick actions","description":"One-tap shortcuts"},"computerUse":{"title":"Computer use","description":"Let the assistant act"}},"browser":{"openButton":"Open Browser","windowTitle":"Cephable Browser","newTab":"New tab","reload":"Reload","forward":"Forward","openExternal":"Open in default browser","showWindow":"Show hidden browser","addressPlaceholder":"Search Google or type a URL","clearData":{"description":"Clear the Cephable browser\'s history, cookies, cached data, and saved logins. This signs you out of every site in the Cephable browser.","button":"Clear browser data","cleared":"Browser data cleared.","error":"Could not clear browser data.","confirmTitle":"Clear browser data?","confirmMessage":"Sign out of everything in the Cephable browser?","confirmDetail":"This permanently clears history, cookies, cached data, and saved logins for the Cephable browser. This can\'t be undone.","confirm":"Clear data","cancel":"Cancel"},"context":{"newTab":"New tab","reload":"Reload","duplicate":"Duplicate tab","close":"Close tab","closeOthers":"Close other tabs","closeRight":"Close tabs to the right","back":"Back","forward":"Forward","openLinkNewTab":"Open link in new tab","openLinkExternal":"Open link in default browser","openExternal":"Open in default browser","openAllExternal":"Open all tabs in default browser"},"home":{"tabTitle":"Home","title":"The Cephable Browser","tagline":"A separate browser Cephable can drive for you.","description":"This is where Cephable automates web tasks on your behalf. It runs independently from your everyday browser, so your normal tabs, logins, and browsing stay untouched while automations run here \u2014 even in the background.","searchPlaceholder":"Search Google or type a URL to get started","go":"Go","features":{"separate":{"title":"Runs on its own","description":"Kept separate from your default browser so automations never disrupt your personal browsing."},"automate":{"title":"Built for automation","description":"Cephable can open pages, fill forms, and gather information here, hands-free."},"handoff":{"title":"Hand off anytime","description":"Open any page in your default browser whenever you want to take over."}}}},"history":{"title":"Recent AI history","description":"Your latest intelligent tasks and automations.","viewAll":"View all history","empty":"Your recent AI tasks and automations will appear here."},"scheduledTasks":{"title":"Scheduled tasks","description":"Automations set to run at a time you choose \u2014 on this device.","viewAll":"View all scheduled","empty":"Schedule a prompt from the panel and it will show up here."},"create":{"title":"Create","description":"Draft, rewrite, reformat, and translate \u2014 right inside the app you\u2019re working in using copied and highlighted text.","contextRow":{"highlightedText":"Highlight / clipboard text","output":"Typing In: ","input":"Uses: ","background":"Background","currentapp":"Current app"},"items":{"draftEmail":"Draft an email","writeDocument":"Write a document","summarizeNotes":"Summarize into notes","polishWriting":"Polish my writing","translateText":"Translate text","socialPost":"Write a social post","cd_brief":"Draft a creative brief","cd_caption":"Write a caption & alt text","ar_insights":"Summarize findings into insights","ar_exec":"Write an executive summary","cc_followup":"Draft a follow-up email","cc_meetingNotes":"Turn notes into meeting minutes","bd_commit":"Write a commit message","bd_review":"Summarize a code review","gp_bio":"Write a stream bio","gp_recap":"Recap last night\'s session","lt_lesson":"Outline a lesson plan","lt_studyNotes":"Summarize into study notes","mo_agenda":"Draft a meeting agenda","mo_update":"Write a project update","aa_simplify":"Simplify to plain language","aa_describe":"Describe an image in words"},"prompts":{"draftEmail":"Draft a clear, professional email about this. ","writeDocument":"Write a document about this. ","summarizeNotes":"Summarize this into concise, well-organized bullet-point notes.","polishWriting":"Rewrite this to be clearer and more polished while keeping my meaning and tone.","socialPost":"Write a short, engaging social post about this. ","cd_brief":"Draft a creative brief for this project. ","ar_insights":"Summarize the key findings and insights from this data.","ar_exec":"Write a concise executive summary for this. ","cc_followup":"Draft a follow-up email about this. ","cc_meetingNotes":"Turn these notes into clear meeting minutes with action items.","bd_commit":"Write a clear commit message for these changes: ","bd_review":"Summarize this code review into key points and required changes.","gp_bio":"Write a punchy bio for my stream/profile.","lt_lesson":"Outline a lesson plan on this. ","lt_studyNotes":"Summarize this material into study notes I can review.","mo_agenda":"Draft a meeting agenda covering this.","mo_update":"Write a project status update for stakeholders based on this. ","aa_simplify":"Rewrite this in plain, easy-to-read language."}},"automate":{"title":"Automate","description":"Describe a job in plain language and Cephable carries it out across your apps, your files, even your command line.","items":{"summarizeSend":"Summarize & email","researchDoc":"Research & write a doc","organizeFiles":"Organize my files","cleanUp":"Clean up a folder","wordDoc":"Build a Word doc","triage":"Triage my inbox","cd_exportAssets":"Rename & file assets","cd_moodboard":"Collect references","ar_summarizeSend":"Summarize & email","ar_analyzeData":"Analyze a spreadsheet","ar_deck":"Build a deck from data","cc_triage":"Triage & draft replies","cc_summarizeEmail":"Summarize into an email","cc_recap":"Recap & send to team","cc_socialPost":"Post from a link","bd_buildTest":"Build & test a project","bd_cleanup":"Suggest code cleanups","bd_scaffold":"Scaffold a project","gp_schedule":"Plan a stream schedule","lt_studyMaterial":"Make study materials","lt_accommodation":"Make accessible notes","lt_handout":"Compile a handout","lt_research":"Research & compare","mo_meetingActions":"Turn notes into actions","mo_organizeFiles":"Organize my files","mo_cleanup":"Clean up Downloads","aa_translate":"Translate a document"},"prompts":{"summarizeSend":"Summarize the contents of <folder> and email it to <team email>.","researchDoc":"Research the trends in <folder or document> and write up what you find in a new document.","organizeFiles":"Copy the files from <source folder> into <destination folder>.","cleanUp":"Remove all the <file type, e.g. screenshots> from my <folder>.","wordDoc":"Use <article or notes> to create a Microsoft Word document that <does what>.","triage":"Go through my inbox and tell me what needs my attention, then draft replies where one is needed.","cd_exportAssets":"Rename the design assets in <folder> using this scheme \u2014 <naming scheme> \u2014 and sort them into folders.","cd_moodboard":"Find references for <idea> online and gather them into a document.","ar_summarizeSend":"Summarize the contents of <folder> and email it to <team email>.","ar_analyzeData":"Analyze <spreadsheet> and find <what to look for, e.g. key losses>.","ar_deck":"Turn the findings in <document or folder> into a PowerPoint that highlights <key points>.","cc_triage":"Read my inbox and draft replies to anything that needs one.","cc_summarizeEmail":"Draft an email summarizing <article or document> and point out the key technical details.","cc_recap":"Write a recap of <meeting notes> and email it to <team email>.","cc_socialPost":"Read <article or website> and write a <platform, e.g. Discord>-friendly post about it, then save it to a new note.","bd_buildTest":"Review the code in <project folder>, build it, and run the tests. If anything fails, check the git history and tell me what likely broke it.","bd_cleanup":"Look at the code in <project folder> and tell me how to make it cleaner.","bd_scaffold":"Scaffold a new <project type> project in <folder> with the starter files it needs.","gp_schedule":"Plan a streaming schedule for <time period> covering <games or activities>.","lt_studyMaterial":"Use <article or notes> to create a Word document for <grade level> students with <reflection questions or a study guide>.","lt_accommodation":"Create a Word document of lecture notes on <topic> formatted for a student with <accommodation>.","lt_handout":"Compile the readings in <folder> into a single handout document.","lt_research":"Find <topic, e.g. books on neurodiversity> online and create a document summarizing each so I can compare.","mo_meetingActions":"Read <meeting notes>: what\'s left to do, who\'s responsible, and what needs more research? Break it into files organized in a folder.","mo_organizeFiles":"Copy the files from <source folder> into <destination folder>.","mo_cleanup":"Remove all the <file type, e.g. installers> from my Downloads folder.","aa_translate":"Translate <document> into <language> and save it to <folder>."}},"suggestions":{"viewMore":"View more","viewMoreTooltip":"Browse every suggested prompt","dialogTitle":"All suggestions","dialogDescription":"Pick a starting point. It drops into the composer so you can edit it before running.","rotationLabel":"Suggested prompts","empty":"No suggestions available."}},"wizard":{"title":"Generate App Controls","titleLong":"Generate New App Controls","description":"Cephable will then use this information to generate controls for you to review and try!","includeDefaultKeysQuestion":"Include default voice commands for keys and mouse clicks?","try":"Try Control Generator","placeholder":"Make sure the voice commands are short.\\n\\nI want to be able to say \\"forward\\" to go to the next slide in the presentation\\n\\nI want to use head movement for moving the cursor and voice controls for editing shortcuts\\n\\nAdd quick action buttons for all my character movement and abilities.","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code, etc.","noOptionsText":"Begin typing to find an app you want to control","generate":"Generate Controls","complete":{"title":"Alright, we\'re done!","description":"Click the button below to view the controls we generated. You\'ll be able to manually edit, add to, or remove any aspects to perfect it for yourself.","viewControls":"See my controls"},"error":{"emptyInput":"Please select at least one input method","emptyApp":"Please enter at least one app name","generatingProfile":"Error generating app controls"},"loading":{"title":"We\'re putting together all the pieces","description":"This can take up to about a minute. Don\'t leave this page or go back or it will stop generating."},"selectedTips":{"title":"Tip #{{count}}","previous":"Previous Tip","next":"Next Tip","one":"Did you know you can use Cephable on one device to control another? Download Cephable to your mobile, tablet or even another computer and choose the connection you want to control (perhaps this one). Your personal and input profiles are consistent across them all! Just make sure Cephable is running on your device and connections.","two":"You can control the sensitivity of your inputs in the \\"Expression Control Settings\\" section of the main panel. This let\'s you further refine the ways Cephable interprets inputs specific to you. And Cephable get\'s better over time as it works with you!","three":"After we set this up you still have complete control over the configuration. We\'re giving you a baseline but at any point you can change the mapping between what you do and what it does on the computer.","four":"You can print out your controls to have a physical copy as you use Cephable. We know this is all new and takes some getting used to. Practice makes better!"},"steps":{"one":"Step 1. Type the name of an app you want to control.","two":"Step 2. Confirm the input controls you want to use:","three":"Step 3. (optional) ","threeContinued":"Describe any specific actions you\'d like to have setup for commands you commonly use or have a strong preference for. Please use plain english like the ones below"}},"profile":{"title":"App Controls","titlePlural":"App Controls","titlePreview":"Controls Preview","previous":"Previous App Controls","manage":"Manage App Controls","view":"View Controls","edit":"Edit App Controls","add":"Add App Controls","create":"Create App Controls","customize":"Customize App Controls","warn":"Camera or microphone must be started to use your app controls.","descriptionShort":"Discover the different ways Cephable helps you control your devices and software.","description":"App controls are a set of controls that you can use to control your device or connection. You can create multiple app controls and switch between them whenever you\'d like.","name":"App Name","nameQuestion":"What do you want to call these app controls?","newName":"New App Controls","search":"Search App Controls by Name","searchLong":"Search App Controls by Name or Description","keyboardAndMouse":"Keyboard and Mouse","genericController":"Gamepad Controller","keyboardMouseAndController":"Keyboard, Mouse, and Controller","permissionError":"You do not have permission to use these app controls.","custom":"{{name}} (Custom)","set":{"title":"It doesn\'t look like you have app controls set yet.","description":"App Controls are how Cephable knows what to listen for and what actions to take. You can swap control app controls whenever you\'d like from the homepage or by going to your connection settings.","cta":"Set App Controls","empty":{"auto":"Switch to another app to see controls","select":"Select a control to begin","none":"No app controls found"}},"summary":{"title":"App Controls Summary","descriptionLong":"Here are the details of these app controls. You can search controls, actions, and more to see what you can do with these app controls.","description":"Get a summary of these app controls including what controls there are, customizations, details, and more.","view":"View App Controls Summary","filter":"Filter by Input Type","placeholder":"Search control names..."},"copy":{"title":"Copy App Controls","duplicate":"Duplicate App Controls","question":"Create a copy?","description":"Want to create a new copy of these app controls? This will open a new window with these app controls copied but it won\'t be added to your account until you save it.","confirm":"Yes, create a copy","profileSuffix":"{{name}} (copy)"},"new":{"title":"Create New App Controls","description":"Craft controls from the ground up or let cutting-edge AI generate personalized controls, empowering you to navigate apps and software effortlessly using your voice, head, and face gestures.","note":"Recommended for advanced users.","scratch":"Create from Scratch"},"advancedOptions":"Advanced Control Options","delete":{"title":"Delete App Controls","titleLong":"Delete these app controls","description":"You can delete these app controls by clicking \'Delete App Controls\'.","confirm":"Are you sure you want to delete these app controls","confirmLong":"Once you delete these app controls, you won\'t be able to return to it. Are you sure you want to delete these app controls?","confirmButton":"Yes, delete these app controls"},"current":"Current Controls","loading":"Loading controls...","null":"You have no app controls yet. Click below to create one.","nullButton":"Create your first app controls","preview":"Preview","features":"Features","byline_public":"By: Cephable Team","byline_shared":"Shared by: Cephable Community","share":{"title":"Share App Controls","previewTitle":"Shared App Controls Preview","description":"Share these app controls with others so they can get a copy and personalize from there!","descriptionLong":"Share these app controls with others so they can get a copy and personalize from there! Choose how you want to share, then create a link to send to others.","add":"Create a Share Link","confirm":"Share this url","link":"Share Link","copy":"Copy Link","copied":"Copied!","usage":"Usage Amount","created":"Created {{value}}","expiration":{"title":"Expiration","once":"Only allow one use","unlimited":"Allow unlimited usage","no":"No expiration","date":"Expiration Date","dateDescription":"Expire at a specific date"},"manage":"Manage previous share links","empty":"No shares have been created for these app controls."},"swap":{"title":"Swap Controls","titleLong":"Swap your App Controls","descriptionShort":"Use different app controls to match the program or software you are using.","description":"You can swap between different app controls to match the program or software you are using."},"autoProfileSwitching":{"title":"Automatic Control Switching","description":"Automatic control switching allows Cephable to adapt to your workflow seamlessly. When turned on, Cephable will contextually adjust your app controls based on the program or software you\'re using. If turned off, you can manually switch app controls using the \'Swap Controls\' button or using global commands.","alerts":{"disabled":"Automatic Control Switching is turned off.","temporarilyDisabled":"Automatic Control Switching is temporarily turned off.","enabled":"Automatic Control Switching is turned on.","error":"Error saving automatic control switching preferences"},"associatedPrograms":{"add":"Add a New Associated Program","description":{"personal":"Choose the software or programs you want to connect to these controls. This supports Automatic Control Switching, where Cephable will automatically switch these app controls to match the current program you are using.","short":"Choose the software or programs you want to connect to these controls."},"edit":"Edit Associated Programs","noOptionsText":"Begin typing to find associated programs","profileLabel":"App Controls: ","remove":"Remove Associated Program","title":"Associated Programs","when":"Cephable will automatically switch my app controls to {{profileName}} when I use...","emptySearch":"There are no programs associated with these controls.","error":"Error saving associated programs. Please try again later.","emptyError":"Empty Associated Program detected, please remove before continuing."},"commandOverlay":{"command":"Switching App Controls: {{value}}"}},"error":{"noMatch":"No app controls match your search.","save":"Error saving app controls. Please try again.","conflicts":"Error saving app controls due to conflicts.","load":"Error loading app controls.","add":"Error adding app controls.","delete":"Error deleting app controls.","audioEventsWithEmptyCommands":"You have missing controls in your talk back. Check your talk back controls to make sure you fill it out completely.","device":"Invalid app control for this connection. Please try a different one."},"conflictIndicators":{"errorTitle":"Error saving app controls due to conflicts","warningTitle":"App controls saved with warnings","subtitle":"The app controls you created has some configurations that may conflict.","profileNameErrors":"App Controls name conflict","emptyControlsMapped":"Empty input names","emptyControlsMappedDescription":"Please add a voice command, facial expression, head tilt, or other command to your input.","emptyKeybindingControlsMapped":"Empty input names for keybindings","emptyKeybindingControlsMappedDescription":"Please add a voice command, facial expression, head tilt, or other command to your input for keybindings.","duplicateNameTitle":"Duplicate App Controls name","duplicateNameDescription":"You have a existing app controls with the same name. Please change the name before continuing.","emptyNameTitle":"Empty app controls name","emptyNameDescription":"The app controls must have a name for it. ie Game 1, Spotify, Word, etc.","macrosReleaseKeysMissingTitle":"Outputs with unreleased keys","macrosReleaseKeysMissingDescription":"Please add a release key or stop all step to prevent keys from getting stuck.","duplicateInputCommandMacroTitle":"Identical control inputs","duplicateCommandsDescription":"Please remove or change the duplicate input commands.","duplicateInputCommandBindingsTitle":"Identical control inputs for keybindings","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} with {{commandOrEventType}}","duplicateMacroNames":"Duplicate Control Names","duplicateMacroNamesDescription":"Please remove or change one of your identical control names.","warningIgnore":"Ignore","warningDoNotShowAgain":"Do not show warnings again","macrosVoiceCommandConflictWithDictationTitle":"Control voice commands same as dictation key words","keybindingsVoiceCommandConflictWithDictationTitle":"Keybindings voice commands same as dictation key words","macrosVoiceCommandConflictWithDictationDescription":"Your voice inputs will trigger dictation and voice commands.","keybindingsVoiceCommandConflictWithDictationDescription":"Your voice inputs will trigger dictation and key presses.","macrosVoiceCommandConflictWithGenerationTitle":"Control voice commands same as generation key words","keybindingsVoiceCommandConflictWithGenerationTitle":"Keybindings voice commands same as generation key words","macrosVoiceCommandConflictWithGenerationDescription":"Your voice inputs will trigger generation and voice commands.","keybindingsVoiceCommandConflictWithGenerationDescription":"Your voice inputs will trigger generation and key presses.","duplicateAssociatedProgramNames":"Duplicate associated program names","duplicateAssociatedProgramNamesDescription":"Please remove or change one of your identical associated programs.","emptyEvent":{"title":"Missing Steps","description":"There are missing steps in your controls. This could lead to Cephable not doing an action when you give a command."},"warningDetails":"View all conflicts"},"success":{"save":"App controls saved.","add":"App controls added.","delete":"App controls deleted.","share":"Share link created and copied to clipboard","shareDelete":"Share link deleted.","generate":"App controls generated."},"warning":"App controls saved with warnings"},"macros":{"title":"Control","titlePlural":"Controls","description":"Controls contain an input (action that you do like tilt your head) and steps that Cephable will do after that input action has been recorded. You can use controls to create a combination of steps that are triggered by a single input.","new":"Create a New Control","newDescription":"Create a new control to combine multiple steps and inputs.","add":"Add Control","create":"Create a Control","name":{"title":"Control Name","question":"What do you want to call this control?","description":"Give your control a name so you can easily find it later.","placeholder":"action this control is doing like \\"jump\\" or \\"zoom in\\""},"empty":"You have no controls yet. Click below to create one.","copySuffix":"{{name}}_copy"},"event":{"title":"Step","titlePlural":"Steps","previewSummaryPlural":"{{first}} and {{total}} more events","add":"Add Step","stepType":"Step Type","select":"Select the type of step you want to add.","question":"What type of actions do you want Cephable to perform?","setup":"Configure your Step","description":"Steps are the actions that Cephable will do after the input has been triggered. You can add multiple steps to a control to create a combination of actions.","expand":"Expand to see the rest of the steps","stepUp":"Move Step Up","stepDown":"Move Step Down","stepCopy":"Copy Step","stepRemove":"Remove Step","insertStep":"Insert Step Below","showOptions":"Show Options","hideOptions":"Hide Options","hold":"Hold time (in milliseconds)","error":"You must configure your step.","multiple":"Multiple Steps","deviceTypeCustomAction":{"title":"Custom Device Action"},"keyPress":{"title":"Press Key or Button ","short":"Press","fieldSet":"Keys or Button to Press","label":"Key or Button","holdTime":"Hold key time (in milliseconds)","description":"Press a keyboard key without using the keyboard.","longDescription":"This function simulates the pressing of a key on your keyboard. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \\"press\\" a key virtually.","example":"Say \\"Enter\\" to send an email without physically pressing the Enter key.","timing":"Key Press Timing","tap":"Tap","tapLong":"Tap Button","latch":"Latch","latchLong":"Hold until released","hold":"Hold","holdLong":"Hold for amount of time","toggle":"Toggle","toggleLong":"Toggle action","release":"Release","releaseLong":"Release action","latchLabel":"Hold <strong> {{value}} </strong> until released","tapLabel":"Tap <strong> {{value}} </strong>","pressLabel":"Press <strong> {{value}} </strong> for <strong> {{time}} </strong> milliseconds","remove":"Remove Key Press","add":"Add Key/Button to Press"},"keyRelease":{"title":"Release Key or Button","short":"Release","selected":"Selected Keys to Release","description":"Let go of a keyboard key you\'ve pressed and held.","longDescription":"This function simulates the release of a key on your keyboard. It should be used in conjunction with a key press that is held indefinitely. For instance, if you have difficulty pressing physical keys, you can use a voice command or another input method to \\"release\\" a key virtually.","example":"Say \'Stop\' after saying \'Toggle Run\' to stop running.","label":"Release <strong> {{value}} </strong>","add":"Add Key/Button to Release","remove":"Remove Key Release"},"keyToggle":{"title":"Toggle Key or Button","short":"Toggle","selected":"Selected Keys to Toggle","description":"Turn a keyboard key on or off like a light switch with a single control.","longDescription":"This turns a key\'s function on or off, like a switch. It\'s useful for keys that you want to hold for an indeterminate amount of time. You can use this to keep the same action for both key press and key release or stop.","example":"Say \'Toggle Run\' to start running. Say \'Toggle Run\' to stop running.","label":"Toggle <strong> {{value}} </strong>","add":"Add Key/Button to Toggle","remove":"Remove Key Toggle"},"pause":{"title":"Pause","description":"Add a brief delay between actions.","longDescription":"This function allows you to insert a brief delay between actions, which is essential in situations where one action must fully complete before the next begins. For example, if you\'re using a command to make text bold in a document, you might first need to open a context menu. The Pause function gives enough time for the context menu to open and become active before proceeding to the next step, ensuring smooth and error-free operation.","example":"Imagine you\'re editing a document using voice commands. You say \\"Format text,\\" which opens a context menu. Then, after a brief pause to allow the menu to fully appear, you say \\"Bold\\" to apply bold formatting to the selected text. The Pause function ensures the context menu is ready to receive your next command.","label":"Pause for <strong> {{value}} </strong> milliseconds"},"type":{"title":"Type","field":"Phrase to Type","placeholder":"typed phrase","question":"What text do you want to type?","description":"Write out text like using a keyboard.","longDescription":"This mimics typing a string of text, similar to typing on a keyboard. It\'s ideal for entering longer text without needing to press each key. If you want to dynamically enter text, you can use the Dictation function instead.","example":"Say \\"Name\\" to type \\"Hello, my name is Ellen Ripley.\\" in a chat window.","label":"Type <strong> {{value}} </strong>"},"mouseMove":{"title":"Move the Mouse","description":"Move the pointer on the screen.","longDescription":"Move your screen\'s cursor or pointer without a physical mouse. This is particularly helpful for users with limited hand mobility. This is useful for fine control of mouse movement that is needed in some games. If you want to simulate all mouse movement using your head movement, you can try the \'Head Movement for Mouse Control\' in the camera settings.","example":"Say \\"Move Mouse Right\\" to move the cursor to the right 100px.","moveX":"Mouse Move Left/Right Pixels","numberMoveX":"Number of pixels to Move Left/Right","moveY":"Mouse Move Up/Down Pixels","numberMoveY":"Number of pixels to Move Up/Down","label":"Move the mouse <strong> {{value}} </strong>","command":"Mouse Move: {{command}}","commandLabel":"Mouse Move","startCommand":"Mouse Move Start","stopCommand":"Mouse Move Stop"},"joystickMove":{"title":"Move Joysticks","description":"Use a joystick to move things on the screen.","longDescription":"This function simulates the movement of a joystick. For instance, if you have difficulty using a physical joystick, you can use a voice command or another input method to move a joystick virtually.","example":"Say \\"Move Joystick Left\\" to move the joystick to the left 100px.","prefix":"Move the left joystick","left":"Left Joystick","leftX":"Left X","leftY":"Left Y","right":"Right Joystick","rightX":"Right X","rightY":"Right Y","x":"X Axis Strength","y":"Y Axis Strength","moveXLabel":"Move X: {{value}}","moveYLabel":"Move Y: {{value}}","labelLeft":"Move the Left joystick ","labelRight":"Move the Right joystick ","latch":"Latch will hold the position until you release using a \'Stop All\' command."},"playAudio":{"title":"Play Audio","placeholder":"phrase of statement that Cephable will say","description":"Play a sound, word, or phrase.","longDescription":"This function enables users to convert typed phrases into spoken words. It\'s especially useful for individuals who may have difficulty speaking. By typing in a phrase, the PlayAudio feature will articulate the text aloud using synthesized speech. This can assist in communication or in situations where a user needs to relay information verbally but prefers or requires an alternative to using their own voice.","example":"Smile to play the word \\"Hello\\".","label":"Speak <strong>\\"{{value}}\\"</strong>"},"stopOutputs":{"title":"Stop All Outputs","titleLong":"Stop all outputs (release all keys and buttons, stop all mouse movements, stop all typing)","description":"Stop all ongoing actions like key press.","longDescription":"Immediately stop all ongoing outputs or actions. This is a safety or convenience feature to halt any process. We will automatically do this for you when you close, or pause the camera or microphone controls.","example":"Say \\"Stop\\" to stop all outputs.","label":"Stop all outputs and release keys"},"custom":{"title":"Custom"},"options":{"moveUp":"Move Up","moveDown":"Move Down","moveLeft":"Move Left","moveRight":"Move Right","copyStep":"Copy Step","removeStep":"Remove Step"},"directions":{"up":"Up","down":"Down","left":"Left","right":"Right"}},"expression":{"title":"Face Expression","titlePlural":"Face Expressions","label":"Expression / Gesture","description":"Elevate your digital experience with facial expressions. Use gestures like eyebrow raises, smiles, and other movements to seamlessly control your mouse pointer, perform actions, or customize your interactions.","start":"Start Expression Controls","startSmiling":{"title":"Start Smiling","description":"If you start not smiling and then start to smile, this control will trigger. Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."},"stopSmiling":{"title":"Stop Smilling","description":"If you are smiling and then stop smiling, this control will trigger.  Note: using this control in the same app controls as the Mouth Open / close control may cause conflicts."},"eyebrows":{"title":"Raise Eyebrows","description":"If you raise both your eyebrows from your baseline resting position, this control will trigger."},"openMouth":{"title":"Open Mouth","description":"If your mouth is closed (or if your baseline is slightly open), and you open your mouth more, this control will trigger.  Note: using this control in the same app controls as the smile control may cause conflicts."},"closeMouth":{"title":"Close Mouth","description":"If your mouth is open and you close it entirely, this control will trigger. Note: using this control in the same app controls as the smile control may cause conflicts."}},"head":{"title":"Head Movement","titlePlural":"Head Movements","label":"Head / Body Movement","question":"What type of movement do you want to use?","description":"Control your device or connection with head movements like tilting, nodding, or turning. Using your device\'s camera, Cephable ensures a private and intuitive experience for enhanced control or mouse navigation.","tilt":{"title":"Head Tilt","description":"Tilt your head to the left or right for enhanced control or mouse navigation.","left":{"title":"Tilt Head Left","description":"If you are looking at the camera and tilt your head to your left, this control will trigger."},"right":{"title":"Tilt Head Right","description":"If you are looking at the camera and tilt your head to your right, this control will trigger."},"back":{"title":"Tilt Head Back","description":"If you are looking at the camera and tilt your head back and look up, this control will trigger."},"forward":{"title":"Tilt Head Forward","description":"If you are looking at the camera and tilt your head forward and look down, this control will trigger."}},"turn":{"title":"Head Turn","description":"Turn your head to the left or right for enhanced control or mouse navigation.","left":{"title":"Turn Head Left","description":"If you are looking at the camera and turn your head and look to your left, this control will trigger."},"right":{"title":"Turn Head Right","description":"If you are looking at the camera and turn your head and look to your right, this control will trigger."}},"lean":{"title":"Head Lean","description":"Lean your head to the left or right for enhanced control or mouse navigation.","left":{"title":"Lean Head Left","description":"If you are looking at the camera and lean left so your face is further left in the camera frame, this control will trigger."},"right":{"title":"Lean Head Right","description":"If you are looking at the camera and lean right so your face is further right in the camera frame, this control will trigger."},"back":{"title":"Lean Head Back","description":"If you are looking at the camera and lean back so your face is further from the camera, this control will trigger."},"forward":{"title":"Lean Head Forward","description":"If you are looking at the camera and lean forward so your face is closer to the camera, this control will trigger."},"up":{"title":"Move Body Up","description":"If you are looking at the camera and move your head up by stretching your neck or moving your whole body up, this control will trigger."},"down":{"title":"Move Body Down","description":"If you are looking at the camera and move your head down by scrunching your neck, ducking, or lowering your whole body, this control will trigger."},"center":{"title":"Center your Head","description":"If you are looking at the camera and move your head back to the center position matching baseline, this control will trigger."}}},"voice":{"title":"Voice Control","titlePlural":"Voice Controls","placeholder":"Voice or phrase Cephable will listen for","question":"What statement or phrase do you want to say for this control?","when":"When I say...","say":"Say \'{{value}}\'","description":"Starting the microphone unlocks intelligent and natural voice commands, empowering users to seamlessly interact with their computer across applications and software. Speak naturally to execute commands or dictate text, creating an effortless and intuitive experience.","load":{"fail":{"title":"{{language}} Voice Controls Unavailable","description":"Oh no! We couldn\'t load {{language}} for voice controls. Please check your internet connection and try again. Using English (US) until connection is restored."}}},"hotkey":{"title":"Quick Action Button","titlePlural":"Quick Action Buttons","titlePanel":"Quick Actions","label":"Quick Action Button Display Name","placeholder":"Name to display","question":"What would you like to name this button?","when":"When I tap...","description":"Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. A single tap can run multiple steps or a single action.","usagePrompt":"Quick Action Buttons are customizable buttons that you can tap to do relevant actions on your app. You can add, remove, or edit the names from the main app control settings page.","reorder":"You can rearrange the order using the move up and down buttons.","emptySearch":"There are no quick actions matching this criteria.","empty":"It looks like you don\'t currently have any quick actions.","emptyLong":"No quick action buttons are configured in these app controls. Once you add quick action buttons or choose app controls with one, they\'ll appear here.","emptyTitle":"No Quick Action Buttons","edit":"Edit Quick Action Buttons","tap":"Tap {{value}}","copySuffix":"{{name}}_copy","hotkeysOnly":"Custom Buttons","allControls":"All App Controls","show":"Show Quick Action Buttons","deprecatedDialog":{"title":"Your app controls requires an update.","description1":"It looks like you\'re using older app controls with quick action buttons. We\'ve got some exciting updates in\\n            store for you! We\'ve revamped the system to make creating and editing quick action buttons a breeze, no\\n            more diving into advanced settings.","description2":"Just a quick update is all it takes\u2014literally a second\u2014and you\'ll be enjoying the seamless button\\n            customization experience. Say goodbye to the extra steps and hello to a more user-friendly\\n            interface. Ready to make the switch?","confirm":"Let\'s do it!"},"demo":{"title":"Demo Quick Action Buttons","description":"The demo area below will allow you to try quick action buttons. The demo is limited to specifically controlling this text area below.","step1":"Turn On Quick Action Buttons","step2":"Use the example prompts below to control the text block.","command1":"Press button 1 to \u201CMake text larger\u201D","command2":"Press button 2 to \u201Cbold text\u201D","command3":"","continue":"Continue with Quick Action Buttons"},"example":{"title":"Examples of Quick Action Buttons ","description":"These examples showcase the versatility of Quick Action Buttons in controlling your device or connection. They can be used to execute commands, navigate interfaces, or perform actions with a simple tap.","command1":"Tap Pause","example1":"Example \u201Cpause video\u201D","command2":"Tap Forward","example2":"Example \u201Czoom out\u201D","command3":"Tap Stop","example3":"Example \u201Cclose window\u201D"}},"motion":{"title":"Motion Control","titlePlural":"Motion Controls","question":"What type of motion with a phone or tablet do you want to use?","start":"Start Motion Controls","settings":"Motion Settings","descriptionShort":"Tilt, turn, or shake your connection to control Cephable.","description":"Motion controls let you turn your phone or tablet movement in the Companion App into controls for your connection. Tilt or shake your phone in different directions to create new outputs.","up":{"title":"Tilt Your Device Up","description":"If your device is flat on a surface and you tilt it up to face you, this control will trigger."},"down":{"title":"Tilt Your Device Down","description":"If your device is flat on a surface and you tilt it down to face away from you, this control will trigger."},"left":{"title":"Tilt Your Device Left","description":"If your device is flat on a surface and you tilt it left to face toward the left, this control will trigger."},"right":{"title":"Tilt Your Device Right","description":"If your device is flat on a surface and you tilt it right to face toward the right, this control will trigger."},"shake":{"title":"Shake Your Device","description":"If you shake your device, this control will trigger."},"edit":{"title":"Edit Motion Settings","description":"Change your motion control settings to adjust how much you need to move your phone while running to Companion App","sensitivity":{"title":"Motion Control Sensitivity Settings","description":"Sensitivity tells Cephable how far you need to tilt your device in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to tilt to trigger the control."},"tilt":{"title":"Tilt Sensitivity","description":"These values determine how far you need to tilt your device up, down, left, and right for an input to be recognized."},"mouse":{"title":"Motion Controls for Mouse Movement","description":"Determine if and how you want to use motion controls for moving your mouse instead of triggering controls","enable":{"title":"Enable Motion Controls for Mouse Movement","description":"If this is turned on, then some of your motion controls will be used to move your mouse instead of trigger controls.","option":"Use Motion Controls for Mouse Movement?"},"invert":{"title":"Invert Mouse Movement","description":"For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.","x":"Invert X-axis Mouse Movement?","y":"Invert Y-axis Mouse Movement?"}}}},"keys":{"title":"Key or Button","titlePlural":"Keys or Buttons","label":"External Key / Button","question":"What key or button do you want to press?","edit":"Edit Keys and Buttons","defaultOption":"Include default voice commands for keys and mouse clicks?","description":"Keys and buttons allow you to map your different input controls to keyboard and controller button presses.","then":"Cephable will press...","empty":"There are no key controls matching this criteria.","backspace":"Backspace","delete":"Delete","enter":"Enter","space":"Space Bar","tab":"Tab","shift":"Shift","ctrl":"Ctrl","leftCtrl":"Left Ctrl","rightCtrl":"Right Ctrl","leftShift":"Left Shift","rightShift":"Right Shift","alt":"Alt","leftAlt":"Left Alt","escape":"Escape","up":"Up Arrow","down":"Down Arrow","left":"Left Arrow","right":"Right Arrow","command":"Command","caps":"Caps Lock","reset":{"title":"Reset Keybindings","confirm":"Reset all keybindings?","confirmDescription":"Choose how you want to reset the keybindings. This action cannot be undone without saving.","confirmButton":"Reset Keybindings","defaultOption":"Reset to default values for the current language","emptyOption":"Reset to empty (clear all commands)"}},"talkback":{"title":"Talkback","question":"What do you want Cephable to say?","description":"Setup controls that will have Cephable speak for you. You can assign controls to different phrases you want to be spoken.","thenMacro":"then Cephable will say ...","empty":"There are no talkback controls matching this criteria.","deprecatedNotice":"Talkback is now integrated directly into the primary app controls. Your app controls has some older talkback events that need to be updated.","add":"Add a New Talkback Control","remove":"Remove Talkback Control","edit":"Edit Talkback Controls"},"dictation":{"title":"Dictation","question":"What phrase should trigger dictation mode?","description":"Dictation lets you speak naturally and have your words typed while you talk. It\'s like having a personal assistant who types everything you say.","thenMacro":"Cephable will...","empty":"There are no dictation controls matching this criteria.","type":"type","edit":"Edit Dictation Phrases","remove":"Remove Dictation Phrase","add":"Add a New Dictation Phrase","on":"Dictation","off":"Commands","onboarding":{"tourLabel":"Dictation","learn":"Learn how to use dictation mode to convert your speech to text hands-free.","welcome":{"title":"Dictation","description":"Dictation lets you speak naturally and have your words typed while you talk. It\'s like having a personal assistant who types everything you say."},"microphone":{"title":"Turn on Your Microphone","description":"First, turn on your microphone. Click the Microphone Toggle on the Cephable Panel."},"activate":{"title":"Start Dictation Mode","description":"Voice starts in command mode. To start dictation, say \\"Start dictation\\" or click the Dictation button. Lets turn on dictation mode now."},"speaking":{"title":"Click a Document or Field and Start Speaking","description":"Dictation will type out in real-time what you say. Click on a text field or document, then start speaking. For example, say: \\"This is how to use dictation mode.\\""},"pauseResume":{"title":"Pausing Dictation","description":"Need a break without turning off dictation? Just say \\"Pause dictation\\". You can resume anytime with \\"Start dictation.\\" again. You can customize this further with your always on global and device controls."},"stop":{"title":"Stopping Dictation","description":"Need to switch back to your app controls?  Just say \\"Stop dictation\\". This will stop dictation mode and return you to command mode. You can resume anytime with \\"Start dictation.\\" again."},"complete":{"title":"Congrats!","description":"That\'s it! You can now dictate, pause, resume, and swap between dictation and command modes. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."}},"settings":{"title":"Dictation","description":"How dictation starts and what happens to your words before they are typed."},"hold":{"enabled":{"option":"Hold to dictate","description":"Hold the keys below, and nothing else, to start dictating. Let go to type what you said."},"keys":{"title":"Keys to hold","description":"Pressing any other key while holding these cancels it, so your usual shortcuts keep working."},"duration":{"title":"Hold time","description":"How long to hold the keys before dictation starts."},"transcribing":"Transcribing...","aiRewriting":"AI rewriting...","typing":"Typing...","result":"{{words}} words in {{seconds}}s","resultRewritten":"{{words}} words in {{seconds}}s, AI {{rewriteSeconds}}s","permission":{"title":"Hold to dictate is waiting for permission","description":"Grant Cephable access under System Settings > Privacy & Security > {{pane}}. Hold to dictate starts working as soon as you do."},"unavailable":"Hold to dictate could not start listening for the keys. Restart Cephable to try again."},"aiRewrite":{"option":"AI rewrite for long dictation","description":"Before long dictation is typed, the on-device AI cleans up punctuation, filler words and corrections, and formats it for the app you are typing in. Short dictation is typed as you said it. Adds a short wait before typing."}},"suggestedPrompts":{"title":"Suggested Prompts","description":"Customize suggested prompts that appear in AI tasks to help you get started quickly.","edit":"Edit Suggested Prompts","generate":"Generate Text","rewrite":"Rewrite Text","addGenerate":"Add a Generate Prompt","addRewrite":"Add a Rewrite Prompt","remove":"Remove Prompt","generatePlaceholder":"Enter a prompt for text generation...","rewritePlaceholder":"Enter a prompt for text rewriting...","suggested":"Suggested prompts","suggestedFor":"Suggested for {{profileName}}","seeAll":"See all prompts","showLess":"Show less","allPrompts":"All Prompts","customFor":"Custom prompts for {{profileName}}","defaultPrompts":"Default prompts","defaultGenerate":["A professional email introducing our new product","A meeting agenda for next week\'s team discussion","A project proposal outline for a new initiative","A formal business letter template","A technical documentation section","A user manual introduction","A training document overview","A policy document draft","A follow-up email after a meeting","A thank you message to a client","A project status update email","An invitation to a company event","A reminder email for upcoming deadlines","A welcome email for new team members","An apology email for service interruption","A newsletter introduction","A brainstorming list for marketing campaigns","Creative solutions for improving team productivity","Ideas for a company retreat activities","Concepts for a new mobile app feature","Suggestions for improving customer experience","Innovation ideas for our product development","Content ideas for social media posts","Workshop topics for professional development","A function that validates user input","A database query for user management","Error handling code for API requests","A configuration file template","Comments explaining a complex algorithm","Unit test cases for a new feature","Documentation for API endpoints","A script for automated deployment"],"defaultRewrite":["Make this text more concise and to the point","Expand this summary with more detail","Reformat this as a numbered list","Convert this to bullet points","Restructure this into clear paragraphs","Make this text easier to scan quickly","Organize this information hierarchically","Format this as a step-by-step guide","Make this message more professional and formal","Rewrite this to sound more casual and friendly","Adjust the tone to be more encouraging","Make this sound more confident and assertive","Soften the tone to be more diplomatic","Add enthusiasm and energy to this text","Make this more empathetic and understanding","Rewrite with a more collaborative tone","Simplify this for a general audience","Make this explanation more technical and detailed","Break down this complex concept into simpler terms","Add more context and background information","Summarize this into key takeaways","Elaborate on the main points with examples","Make this more accessible to beginners","Condense this while keeping the essential information","Improve the clarity and readability","Make this more engaging and interesting","Adjust for better grammar and flow","Rewrite to emphasize the benefits"],"defaultSummarize":["Summarize in 3 bullet points","Extract key decisions","List the main action items","Provide a one-sentence summary","Highlight the most important facts","Summarize for a non-technical audience","Extract the key takeaways","Summarize in 5 bullet points","Identify the core problem and proposed solution","List all conclusions and recommendations","Provide an executive summary","Summarize the timeline of events","Extract all questions raised","List the pros and cons mentioned","Summarize the key arguments"]},"face":{"title":"Face Expression","titlePlural":"Face Expressions","try":"Try Face Expression Controls","question":"What type of face expression do you want to use?","descriptionShort":"Use different face movements for enhanced controls.","description":"Face expressions are part of Expression Controls. It lets you use different face movements for enhanced controls. You can use eyebrow movement, mouth movement, and more to create different outputs."},"other":{"title":"Other","titlePlural":"Other Controls","label":"Other Control","placeholder":"other experimental command","question":"What additional command would you like to use? These are typically for non-Cephable connections that don\'t fit into other categories. They may also function as voice commands when you speak the specified word or phrase. Note: These controls are experimental and may not be fully supported.","description":"Other controls are experimental and may not be fully supported. They can be used for non-Cephable connections or as voice commands when you speak the specified word or phrase."},"support":{"title":"Support","question":"Still not finding what you need?","more":"Learn more at Cephable.com with step-by-step guides, tutorials, videos, and more.","profiles":"Introduction to App Controls"},"community":{"title":"Join the Community","description":"Get support, share ideas, or become a member of Cephable\'s communities.","discord":"Discord Community","facebook":"Facebook Group"},"resources":{"title":"Helpful Resources","description":"Find answers to your questions about Cephable features and functions.","guides":"Step by Step Guides"},"feedback":{"title":"Feedback","description":"Tell us about your experience with Cephable.","contact":"Contact Us","feature":"Suggest a Feature","bug":"Report an Issue"},"settings":{"title":"Settings","advanced":{"title":"Advanced Settings","description":"Click here to get advanced settings for your AI settings, app controls, connections, extensions, and more."},"orgTitle":"{{ value }} Settings","general":"General App Settings","description":"This is your canvas for tailoring-your experience by fine-tuning your controls.","quick":"Here are contextual settings for the panel. Use this to fine tune your current experience."},"account":{"title":"Account","menu":"User Menu","settings":"Account Settings","description":"Update key information to stay connected with Cephable.","usernameLabel":"Username: ","emailLabel":"Email: ","delete":{"title":"Delete Account","description":"You can permanently delete your account and remove all reference to your personal information. When you delete your account, your connections will be removed, and will no longer work or be registered to your account, your app controls and all settings will be lost. This process can not be undone.","button":"Permanently Delete Account","confirmation":"Are you sure you want to delete your account?","note":"This action is irreversible.","confirm":"Yes, delete my account"},"password":{"change":"Change Password","description":"Update your password to keep your account secure.","old":"Old Password","current":"Your current password","new":"New Password","desired":"Your desired new password","confirm":"Confirm New Password","update":"Update Password"},"isEmailVerified":{"title":"Email is not verified.","titleAlt":"Verify your email address","description":"Your email is not verified. Please check your email for a verification link.","descriptionLong":"Welcome to Cephable! A verification email has been sent to {{email}}. Please check your inbox or spam folder and click on the link. If you don\'t see it, you can resend the verification email.","org":"Your email is not verified. It is required to access license details. Please check your email for a verification link.","resend":"Resend Email","success":"We have sent you a new verification email.","error":"There was an error sending the verification email. Please try again later.","appBlock":"You\'re almost there! A verification email has been sent to {{email}}. Please check your inbox and click the link to verify your email address. If you don\'t see it, check your spam folder."},"signout":{"title":"Sign Out","description":"Once you sign out, this connection will be removed from your account and no longer be visible from the Companion App or other connections.","question":"Are you sure you want to sign out?","confirm":"Yes, sign out","confirmDescription":"Signing you out and removing this connection","warn":{"title":"You\u2019re about to be signed out.","description":"It looks like you\u2019ve been inactive for a while. For security reasons, we\u2019ll sign you out in XX seconds. If you\u2019d like to stay logged in, click \u201CStay Logged In\u201D below.","confirm":"Stay Logged In","cancel":"Sign Out Now"}},"marketing":{"title":"Email Preferences","description":"Update your email preferences to receive updates and news from Cephable.","marketing":"Marketing Emails","optIn":"I would like to receive tutorials, tips, updates and newsletters to enhance my Cephable experience"},"error":{"save":"Error saving account settings.","password":"Error updating password.","signout":"Error signing out.","old":"Old password is required.","new":"New password is required.","match":"Passwords do not match.","marketing":"Error updating email preferences.","userPreferences":"Error saving user preferences."},"success":{"save":"Account settings saved.","password":"Password updated.","marketing":"Email preferences updated.","userPreferences":"User preferences updated."},"userPreferences":{"title":"User Preferences","description":"Update your preferences to create the Cephable experience that works for you.","warningOptOut":"Hide warnings when I save or update app controls","enableMetrics":"Enable usage metrics output for performance testing. You will be able to download the logs.","enableTranscribeTask":"Enable the experimental file transcriber task in the Cephable Panel","enableGamepadSupport":"Enable gamepad support for local driver and Xbox controller emulation","enableCameraControls":"Enable camera controls in the Cephable Panel","enableWorkflowRecording":"Enable the Record a Workflow preview in Automate and AI Skills"},"communication":{"title":"Communication Preferences"},"name":{"title":"Display Name"},"email":{"title":"Email Address","description":"Your registered email address"}},"license":{"titlePlural":"Licenses","trial":{"title":{"single":"You\'ve been upgraded to {{productName}} for free with {{days}} Days Remaining","multiple":"{{organization}} is on a Free Trial with {{days}} Days Remaining"},"subtitle":"You can invite {{count}} colleagues to try Cephable with you. ","noUsersSubtitle":"You have no trial users remaining. Upgrade to a paid license to add more users.","upgrade":"By upgrading, maintain your access to features like enhanced voice controls, AI Intelligent Tasks, and many prebuilt app controls.","expired":{"user":"Your free upgrade to {{productName}} expires on {{date}}. To upgrade, please contact your organization administrator - {{admin}}.","userLong":"It looks like your free upgrade to {{productName}} has expired. To upgrade, please contact your organization administrator - {{admin}}.","admin":"Your free upgrade to {{productName}} expires on {{date}}.","adminLong":"It looks like your free upgrade to {{productName}} has expired. You can upgrade your license to continue accessing advanced features not available in Cephable Basic."},"start":"Start a Free Trial"},"key":{"title":"License Key","titlePlural":"License Keys","details":"License Key Details","description":"A License Key is a unique identifier used to grant access to Cephable Professional, Education, or Developer features.","assigned":"Used on: {{date}}","expires":"Expires on: {{date}}","assign":"Assign Key to New Organization","error":"Error loading license key.","empty":{"title":"No License Keys found.","description":"It doesn\'t look like there are license keys matching this criteria. Or you have not purchased a license key yet."},"product":{"title":"Purchase","titleLong":"Purchase License Keys","description":"Purchase a license key to unlock the full potential of Cephable. View the different plans and pricing options available.","action":"Purchase Now","empty":{"title":"No Products Found.","description":"It looks like you don\'t have any products. Please reach out to our sales team or your representative to help resolve this."},"yearly":"Billed yearly","years":"Billed every {{value}} years","days":"Billed every {{value}} days","Subscription":{"title":"Subscription"},"MeteredConsumption":{"title":"Metered Consumption"},"PayDown":{"title":"Pay Down"},"OneTime":{"title":"One Time"}}},"upgrade":{"professional":"Upgrade to Cephable Professional License","generic":{"title":"Upgrade your Cephable Experience","description":"The Cephable Platform offers different products for commercial use at work, school, or integrated into native solutions."},"fallback":{"title":"Error Loading Billing Portal","description":"Unable to load the billing portal in app. Please click the button below to continue with the upgrade."}},"required":{"title":"Cephable Professional License is Required","description":"It looks like you are using Cephable Basic which does not support the commercial use of Cephable. Please upgrade to a professional license to continue using the app."},"activate":{"question":"Already have a license key?","button":"Activate","title":"Activate License Key","description":"Enter your license key to upgrade Cephable.","descriptionLong":"Enter your license key to upgrade Cephable. If you don\'t have one, start a free trial or purchase a license.","fieldLabel":"License Key","placeholder":"NkmurBfZzFrmm9Kx","invalid":{"empty":{"key":"Invalid key. Please make sure you have entered a value.","name":"Invalid Organization Name. Please make sure you have entered a value."},"key":"Invalid key. Please make sure you have entered the correct key."},"success":"Congrats. Your account has been upgraded to {{license}}!"},"welcome":{"title":"Welcome to {{license}}.","description":"You have successfully joined {{organization}}. {{description}}"},"redirect":{"title":"Redirecting","description":"You have been redirected to an external billing portal. This will open a new tab in your browser. If you are not redirected within a few seconds, please click the button below.","error":"Billing Redirect Error","external":"Redirected. Please check your browser."},"pro":{"tag":"Pro","detail":"This is a Cephable Professional only feature","requiredDetail":"A Cephable Professional License is required for this feature. You can upgrade or start a free trial in your Account Settings"}},"publicProfiles":{"toolbar":"Explore App Controls","title":"Explore App Controls","description":{"personal":"Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls from scratch.","pro":"Public app controls are available to help you quickly get started with Cephable on your favorite apps. You can use the default controls, customize them to your needs, or create entirely new custom app controls through the control generator."},"offline":{"title":"Unable to Load Public App Controls","description":"It looks like you are offline. You can still use your app controls, but you will not be able to load new public app controls.","confirm":"Okay"},"announcement":"{{count}} New App Controls have been loaded","team":"Cephable Team"},"device":{"title":"Connection","titlePlural":"Connections","titleShort":"Connect","titleLong":"Connections & Extensions","description":"Cephable supports multiple devices and connections. You can manage settings or select any of them all from here. You will always have this computer as your main connection. You can add more connections later.","viewAll":"View All Connections","new":"You have a new connection!","newLong":"You have a new connection! To start using it, select it from the menu below.","add":{"short":"Extend","title":"Add a New Connection or Extension","description":"Connections and extensions are additional ways you can enhance your Cephable experience. You can add new connections to connect to more devices, applications, or games. Take your Cephable experience to the next level by adding connections and extensions.","action":"Add a New Connection","notAvailable":"This connection or extension is not currently available to the public. This often occurs when working with user generated extensions. Please check back later.","isNotPublic":"PREVIEW: This extension is in developer preview and may be incomplete. Developers should complete all steps before public release. Users can check back later for the full version."},"swap":{"titlePlural":"Swap Connections","description":"Cephable supports multiple devices and connections. You can select any of them from here. This computer will always be your main connection. You can add more connections later."},"status":{"title":"Connection Status: ","connected":{"application":"Connected Application","connection":"Connected","device":"Connected Device","game":"Connected Game"},"disconnected":{"application":"Disconnected Application","connection":"Disconnected","device":"Disconnected Device","game":"Disconnected Game"}},"control":{"button":"Control {{name}}","generic":"Control Connection","description":{"application":"Control this connected application using your voice, quick actions, head movements, and more. For instance, if you say \'Save\' this will save on your running application.","connection":"Control this connected connection using your voice, quick actions, head movements, and more. For instance, if you say \'Save\' this will save on your running connection.","device":"Control this connected device using your voice, quick actions, head movements, and more. For instance, if you say \'Open Spotify\' this will open Spotify on running device.","game":"Control this connected game using your voice, quick actions, head movements, and more. For instance, if you say \'Go\' this will make the player move in running game."}},"running":"Running","offline":"Offline","otherDevices":"Other Output Connections","currentStatus":"Current Status: ","connectionStatus":"Connection Status: ","profileStatus":"Current App Controls: ","name":{"title":"Connection Name","question":"What do you want to call this connection?","description":"Give your connection a name so you can easily find it later.","placeholder":"connection name","edit":"Edit Connection Name"},"updates":{"title":"Connection Updates","settings":"Connection Update Settings","description":"Check for connection firmware updates and change auto-update settings","edit":"Edit Update Settings","check":{"title":"Check for Updates","processing":"Checking for updates! It may take a few minutes and your connection may restart during updates.","description":"Tap to check for updates for your connection. If there is an update available and your connection is active, it will start updating. Updates can take a few minutes."},"auto":{"title":"Automatically Update","description":"With this setting turned on, your connection will automatically update whenever it is plugged in, connected to wi-fi, and an update is available. If this is off, you need to tap the update button to get the latest.","option":"Use Auto-Update?"}},"delete":{"title":"Unlink {{name}}","titleLong":"Unlink From Account","description":"Unlinking disconnects Cephable from this computer or game and removes it from your account. You will no longer be able to connect to it, send commands, or update it. This can not be undone but you can create a new connection to the same computer or game if you want to use it again in the future.","confirm":"Are you sure you want to unlink this connection?","confirmLong":"Are you sure you want to deregister and reset this connection? You will no longer be able to connect to it, send commands, or update it. After this de-register and reset, anyone else can setup this connection from scratch.","confirmButton":"Yes, remove this connection."},"manage":{"title":"Click to view and manage details for your connections.","description":"","name":"Customize your connection name for easier management."},"error":{"save":"Error saving connection.","load":"Error loading connection.","add":"Error adding connection.","delete":"Error deleting connection.","updates":"Error checking for updates.","connection":"Connection is not established. Make sure it is connected before trying again.","deleteLong":"We were unable to delete this connection from your account. If you log in again to this account, you may need to manually delete this connection in the connection settings."},"success":{"save":"Connection saved.","add":"Connection added.","delete":"Connection deleted."},"selectDevice":"Select device"},"appSettings":{"title":"General App Settings","description":"These settings only apply to this app. If you want to change the settings of the Cephable app on another computer or mobile device, edit the settings in that app.","autostart":{"title":"Automatically Start Cephable","description":"With this setting turned on, the Cephable app will automatically start when you log in to your device. If you also have automatic voice and expression controls, those will also start right away.","question":"Autostart Cephable App?"},"automationBrowser":{"title":"Automation Browser Visibility","description":"When the AI agent uses the Cephable browser (web research, Google Docs/Sheets/Slides, Gmail, Drive), it normally runs hidden in the background so it doesn\'t interrupt you. Turn this on to watch it work.","question":"Show the automation browser while the AI works?"},"aiNewFiles":{"title":"Folder for New AI Files","description":"Choose where the AI agent saves new files by default, unless you tell it a specific location. If left as the default, new files are saved to a \\"Cephable-Work\\" folder in your home directory, which is created automatically the first time it is needed.","selectButton":"Select Folder","openButton":"Open Folder","openError":"Couldn\'t open the folder. It may have been moved or deleted.","clearButton":"Use Default Folder","current":"New files are saved to: {{folder}}","default":"New files are saved to the default \\"Cephable-Work\\" folder in your home directory."},"aiWorkspace":{"title":"AI Workspace Folder","description":"Choose a folder the on-device AI agent uses for finding, reading, and editing files and for running commands. By default the agent can access your whole computer.","selectButton":"Select Folder","clearButton":"Use Entire Computer","current":"Current workspace folder: ","none":"No workspace folder selected. The AI agent can access your entire computer.","restrictQuestion":"Restrict the AI agent to this folder only","restrictDescription":"When enabled, the AI agent\'s file and command tools cannot read or change anything outside the selected folder."},"documentTemplates":{"title":"Document Templates","description":"Choose a template file the AI agent starts from when it creates new documents. Leave a type on the Cephable default to apply built-in Cephable brand styling. Word, PowerPoint, and Excel each have their own template.","word":"Word Template","wordDescription":"Template the AI agent starts from for new Word documents (.docx).","powerpoint":"PowerPoint Template","powerpointDescription":"Template the AI agent starts from for new PowerPoint presentations (.pptx).","excel":"Excel Template","excelDescription":"Template the AI agent starts from for new Excel workbooks (.xlsx).","selectButton":"Choose File","clearButton":"Use Cephable Default","current":"Template: ","default":"Using the built-in Cephable default template with brand styling."},"overlay":{"title":"Command Feed","description":"The command feed will show the different controls you use and what controls were sent to your computer. It is click-through but will always be on top of other windows. With this setting turned on, the Cephable app will show and will always be on top of other windows and applications.","question":"Show Command Feed?"},"position":{"label":"Select Command Feed Position","description":"Select where you want the command feed to appear on your screen.","topLeft":"Top Left","top":"Top Center","topRight":"Top Right","bottom":"Bottom Center","bottomLeft":"Bottom Left","bottomRight":"Bottom Right"},"panelAutoHide":{"title":"Auto-Hide Cephable Panel","delay":"Delay before hiding","denominator":" seconds","time":"{{value}} seconds"},"transparent":{"title":"Command Feed Transparency","description":"The determines the opacity of the text. The lower the value, the more see-through the feed will be."},"micPosition":{"title":"Microphone Input Window Position","description":"Select where you want the microphone controls for voice and dictation to be positioned on your screen.","label":"Select Microphone Input Window Position"},"cameraPosition":{"title":"Camera Input Window Position","description":"Select where you want the camera controls for face and head movement to be positioned on your screen.","label":"Select Camera Input Window Position"},"theme":{"title":"Theme","description":"Choose a theme that suits your style.","label":"Select a Theme","light":"Light","dark":"Dark","system":"Use OS System settings"},"scale":{"description":"Adjust the text size across the app.","label":"Text Size","small":"Small","large":"Large"},"panelScale":{"description":"Adjust the size of the collapsed panel button.","label":"Panel Button Size"}},"shortcuts":{"title":"Global Shortcuts","description":"Customize keyboard shortcuts for quick access to Cephable controls from anywhere on your system.","info":"These shortcuts work globally and can be used even when Cephable is not the active window.","shortcut":"Shortcut","toggleMicrophone":"Toggle Microphone","toggleDictation":"Toggle Dictation Mode","toggleVoiceControl":"Toggle Voice Control Mode","togglePanel":"Toggle Panel","registrationFailed":"Some global shortcuts failed to register. They may be in use by another application:","record":{"title":"Record Shortcut","start":"Click to Record","listening":"Press your desired key combination...","pressKeys":"Press keys now"},"formatHint":"Select at least one modifier key ({{modifierKey}}, {{modifierKey2}}, Shift) and one other key."},"input":{"title":"Input","titlePlural":"Input Controls","explore":"Explore Input Controls","descriptionShort":"Explore the various input controls Cephable utilizes to create a better digital experience for you.","description":"Input controls are the different methods used to control your device. Such as your voice, head movement, face expressions, and additional connections. Explore the different input controls below to learn more.","typeLabel":"Input Control Type","toolTip":"This uses {{alt}}","remove":"Remove Input Control","filter":"Filter by Input Type","select":"Select an Input","question":"What type of input do you want to use?","add":"Add Input","addMore":"Add another input","removeItem":"Remove item {{index}}","item":"Item {{index}}: {{label}}","duplicate":"Duplicate items are not allowed.","maximum":"Maximum of {{maxItems}} items allowed."},"time":{"soon":"Coming Soon","now":"Now","today":"Today","yesterday":"Yesterday","minutesAgo":"{{count}} minute ago","minutesAgo_plural":"{{count}} minutes ago","daysAgo":"{{count}} days ago","daysAgo_plural":"{{count}} days ago","monthsAgo":"{{count}} month ago","monthsAgo_plural":"{{count}} months ago","yearsAgo":"{{count}} year ago","yearsAgo_plural":"{{count}} years ago","minutesAhead":"in {{count}} minutes","todayAhead":"later today","tomorrow":"tomorrow","daysAhead":"in {{count}} days","monthsAhead":"in {{count}} months","yearsAhead":"in {{count}} years"},"peripherals":{"empty":"No Peripherals Detected","switch":"Switch","keyboard":"Keyboard","gamepad":"Gamepad","companionApp":"Companion App","available":"Available to use","error":"Check your settings."},"textGeneration":{"settings":"Text Generation Settings","skipTyping":{"complete":"{{task}} completed and ready to be copied to your clipboard."},"edit":{"title":"Edit Text Generation Settings","description":"Cephable\'s intelligent text generation feature allows you to use the \\"generate\\" device control to create text in any app. You can generate emails, paragraphs, messages, code, and more. It will generate the text wherever your cursor is as if you were typing it yourself. This feature uses on-device generative AI, which means your content never leaves your machine but that you should check content for accuracy. Use these settings to edit your preferences for how Cephable loads AI models on your device and how it generates text for you.","autoStart":{"title":"Automatically Warm Up Text Generation","description":"With this setting turned on, Cephable AI will automatically warm up the AI models used for Create or Automate tasks. Warming up the models will make them perform faster, but will consume more resources on your computer. Turning this setting off will save resources, but may make the tasks slower.","option":"Auto warm up text-generation AI models?"},"enableTextGen":{"title":"Enable Intelligent Text Generation","description":"With this setting turned on, Cephable AI can draft, rewrite, summarize, and translate content, or automate desktop actions across your apps.","option":"Use Intelligent Text Generation?"},"modelSelection":{"title":"AI Model","description":"Choose the AI model family and size that runs on this device. Larger models produce better results but use more resources. Download more than one to switch between them quickly.","family":"Model Family","size":"Model Size","downloaded":"Downloaded","downloading":"Downloading\u2026","download":"Download","delete":"Delete download","unavailable":"Not supported on this device","notEnoughSpace":"Not enough space on device","notEnoughSpaceDetail":"Needs {{required}} but only {{free}} is free on this device. Free up space and try again.","requiresBetterDevice":"This model needs a more capable device to run.","selectPrompt":"Select a model","notDownloaded":"This model is selected but not downloaded yet. Click Download to use it.","readyToUse":"Downloaded \u2014 ready to use","noModels":"No compatible models are available for this device yet.","offlineNoModels":"You\'re offline and no models are saved on this device yet. Connect to the internet to see and download available models.","offlineDownloadUnavailable":"You\'re offline, so this model can\'t be downloaded. Connect to the internet to download it, or switch to a model you\'ve already downloaded.","deleteConfirm":{"title":"Delete downloaded model?","description":"This frees up disk space. You can download it again later."},"license":{"upgrade":"Requires a license upgrade","blockedNeedsDownload":"This model requires {{license}}. Download a lower model or upgrade to continue."},"fallback":{"alert":"{{fallback}} is being used instead of {{preferred}}, which requires an upgrade.","active":"{{preferred}} requires {{license}}. {{fallback}} is being used instead until you pick a different model or upgrade."}},"enableHistory":{"title":"Enable Text Generation History","description":"With this setting turned on, Cephable AI will use your text generation history to generate text with context of your previous action.","option":"Use Text Generaton History?"},"prompt":{"title":"Additional Information for Text Generation","description":"Enter additional details to be used with Cephable\'s AI to generate text. Use this field to enter preferences for your tone, style of writing, or any other details.","field":"Additional prompt","placeholder":"e.g. Use a friendly tone, write like a professional, be succint and to the point. When writing code, leave thoughtful comments but not too many, etc."},"terminate":{"title":"Clear AI Resources","description":"Click to clear the resources used for Create or Automate tasks. This will free up resources on your computer, but may make these tasks slower the next time you use them.","button":"Clear Resources","success":"Clearing text generation resources.","confirm":{"title":"Clear AI Resources","description":"Are you sure you want to clear the resources used for Create or Automate tasks? This will free up resources on your computer, but may make these tasks slower the next time you use them.","confirm":"Yes, clear resources","cancel":"Cancel"}},"clearModelCache":{"title":"Clear AI Models Cache","description":"This will free up storage on your computer and re-download the current selected model.","button":"Clear and Re-download","success":"Deleted local model files.","error":"Error deleting local model files.","confirm":{"title":"Clear and Re-download AI Model Cache","description":"Are you sure you want to clear the AI model cache and delete the files from your system? The current selected model will be re-downloaded automatically.","confirm":"Yes, clear and re-download","cancel":"Cancel"}}},"prompt":{"systemPrompt":"Generate ONLY the requested text\u2014no explanations, commentary, or fluff. No unprompted markdown or explanation. For code, output raw code only: no fences, no language tags, no explanation.","appName":"You are currently generating text for {{appName}}.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}."},"summarizePrompt":{"systemPrompt":"Summarize the provided text concisely. It may be part of a larger document. Do not use markdown formatting or code fences. Output ONLY the summary\u2014no preamble, labels, explanation, or commentary, and do not explain what you did.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}.","summarizeInstructions":"Instructions: {{summarizeInstructions}}.","userPrompt":"Summarize: {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"Rewrite or reformat the provided text as instructed. If reformatting (e.g. lists, tables, structure changes), preserve the original words exactly. If rewriting (e.g. tone, style, length), preserve the meaning but not necessarily the words. This may be part of a larger document. Match the input\'s formatting: if the source text is already markdown or code, preserve it. Otherwise do not introduce markdown formatting (headings, bold, bullets, code fences) unless the instructions explicitly request a list, table, or similar structure. Output ONLY the result\u2014no preamble, labels, headings, explanations, or commentary.","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}.","rewriteInstructions":"Instructions: {{rewriteInstructions}}."},"translatePrompt":{"systemPrompt":"Translate the following text into {{language}}. Output ONLY the translated text. No explanations, no preamble, no markdown formatting, no code fences, no notes, no parenthetical remarks about the translation. Retain formatting. For code: translate comments and strings only, preserve syntax exactly. ","userPreferences":"Respect these user preferences for how they want text generated: {{userPreferences}}.","genericUserPrompt":"Translate: {{userRequestText}}"},"disabled":{"title":"Intelligent Tasks is Disabled","description":"It looks like you have disabled intelligent tasks. Update to unlock text generation, rewriting, and more in your settings."}},"scheduledTasks":{"title":"Scheduled Tasks","description":"Automations set to run at a time you choose. Everything stays on this device.","hint":"Scheduled tasks run only while this app is running. If your PC is off or the app is closed at the scheduled time, the run is marked missed and you can run it later.","new":"New scheduled task","scheduleButton":"Schedule","skippedBusy":"Skipped because another workflow was already running.","create":{"title":"New scheduled task","description":"Set up a prompt to run automatically on a schedule.","saved":"Scheduled task created."},"composer":{"placeholder":"Describe what Cephable should do\u2026 Use / or @ to add skills and connectors."},"runHistory":{"title":"Run history","viewRun":"View run","noOutput":"No saved output","resolution":{"ignored":"Ignored","rerun":"Rerun","rescheduled":"Rescheduled"}},"badge":{"scheduled":"Scheduled","recurring":"Recurring"},"fromRun":{"scheduled":"This run is part of a scheduled task: {{name}}","recurring":"This run is part of a recurring task: {{name}}","view":"View scheduled task"},"search":{"placeholder":"Search scheduled tasks..."},"filter":{"label":"Filter","all":"All","enabled":"Active","paused":"Paused","missed":"Missed"},"empty":{"title":"No scheduled tasks yet","description":"Schedule a prompt by right-clicking the send button in the panel while in Auto or Automate mode."},"pagination":{"range":"{{start}}\u2013{{end}} of {{total}}"},"status":{"running":"Running","success":"Succeeded","failed":"Failed","missed":"Missed","paused":"Paused"},"summary":{"once":"Once on {{datetime}}","everyOne":"Every {{unit}}","everyN":"Every {{count}} {{unit}}","onDays":"on {{days}}","onDayOfMonth":"on day {{day}}","atTime":"at {{time}}","unit":{"minute":"minute","minute_other":"minutes","hour":"hour","hour_other":"hours","day":"day","day_other":"days","week":"week","week_other":"weeks","month":"month","month_other":"months"}},"card":{"nextRun":"Next run","viewLastRun":"View last successful run","noSuccessfulRun":"No successful run yet","runNow":"Run now","pause":"Pause","resume":"Resume","enabledToggle":"Enable or pause this task"},"missed":{"runNow":"Run now","reschedule":"Reschedule","ignore":"Ignore"},"runNow":{"started":"Running \\"{{name}}\\" now.","busy":"Another workflow is already running. Try again once it finishes."},"overlap":{"title":"Schedules overlap","description":"This runs within 5 minutes of \\"{{name}}\\" ({{time}}). Only one automation runs at a time, so one will wait for the other to finish. Schedule it anyway?","confirm":"Schedule anyway"},"delete":{"title":"Delete scheduled task?","description":"This permanently removes the scheduled task. This can\'t be undone."},"editor":{"kindLabel":"Schedule type","once":"One time","recurring":"Recurring","runAt":"Run at","frequency":"Repeats","every":"Every","interval":"Interval","units":"Units","onDays":"On days","dayOfMonth":"Day of month","atTime":"At time","startAt":"Starts","endsOn":"Ends on"},"edit":{"title":"Edit scheduled task","description":"Adjust the prompt and its schedule before it runs.","name":"Name","namePlaceholder":"Name this scheduled task","prompt":"Prompt","customContext":"Custom context","contextNote":{"generic":"This task\'s context is resolved when it runs.","highlighted":"This task uses the highlighted text in your active app at run time.","clipboard":"This task uses your clipboard contents at run time.","auto":"This task\'s context is resolved automatically when it runs."},"attachments":"Attached files & folders","skills":"Skills","connectors":"Connectors","schedule":"Schedule","goalRequired":"Enter a prompt for this task.","saved":"Scheduled task saved.","notFound":"This scheduled task no longer exists."},"schedulePrompt":{"menuItem":"Schedule this prompt\u2026","title":"Schedule this prompt","prompt":"Prompt","name":"Name (optional)","namePlaceholder":"Name this scheduled task","confirm":"Schedule","goalRequired":"Enter a prompt to schedule.","success":"Prompt scheduled.","error":"Couldn\'t schedule this prompt."},"notify":{"runStarted":{"title":"Scheduled task running","body":"\\"{{name}}\\" is running now."},"missed":{"title":"Missed scheduled task","bodyOne":"\\"{{name}}\\" was missed while the app wasn\'t running.","bodyMany":"{{count}} scheduled tasks were missed while the app wasn\'t running."}}},"aiHistory":{"title":"AI History","description":"View, search, and manage your local AI conversation history.","live":"Live","empty":{"title":"No AI History Yet","description":"Your AI conversation history will appear here after you use intelligent tasks."},"search":{"placeholder":"Search conversations..."},"pagination":{"range":"Showing {{start}}\u2013{{end}} of {{total}}"},"retention":{"note":"Keeping your {{count}} most recent conversations. Favorites are always kept.","label":"Keep"},"filter":{"label":"Filter by type","all":"All types"},"favorites":{"title":"Favorites","add":"Add to favorites","remove":"Remove from favorites"},"select":{"selectOne":"Select conversation","selected":"{{count}} selected","deleteSelected":"Delete selected","clear":"Clear","deleteTitle":"Delete selected conversations","deleteDescription":"Delete {{count}} selected conversation(s)? This cannot be undone."},"copy":{"label":"Copy","success":"Copied to clipboard.","error":"Failed to copy to clipboard."},"source":{"create":"Create","automate":"Automate"},"workflow":{"plan":"Plan","steps":"Steps","files":"Files","folders":"Folders","interruptedNotice":"Your workflow was interrupted. Please try again."},"trace":{"thinking":"Thinking","thought":"Thought","toolCalls":"Tool calls","action":"Action","parameters":"Parameters","result":"Result","reply":"You replied","sources":"Sources","roles":{"tool":"Tool result"}},"task":{"instructions":"Instructions","language":"Language","types":{"generate":"Generate","rewrite":"Rewrite","translate":"Translate","summarize":"Summarize"}},"session":{"messages":"messages","deleteTitle":"Delete Conversation","deleteDescription":"Are you sure you want to delete this conversation? This cannot be undone.","deleteConfirm":"Delete","deleteCancel":"Cancel"},"clear":{"title":"Clear AI History","description":"Delete all locally stored AI conversation history from this device.","confirm":{"title":"Clear AI History","description":"Are you sure you want to clear all AI conversation history? This cannot be undone.","confirm":"Clear All","cancel":"Cancel"},"success":"AI history cleared successfully.","error":"Failed to clear AI history."},"export":{"title":"Export","description":"Export your AI conversation history to a JSONL file.","success":"AI history exported successfully.","error":"Failed to export AI history.","session":{"title":"Export run","success":"Run exported successfully.","error":"Failed to export this run."}},"keychain":{"continue":"Continue","title":"Protect AI History","message":"Cephable encrypts your AI history, including workflow history, on this Mac.","detail":"macOS will next ask to allow access to \u201CCephable Safe Storage.\u201D It contains only the encryption key, not your workflow or task content. Choose \u201CAlways Allow\u201D to keep your encrypted history available without being asked again. Choosing \u201CAllow\u201D lets Cephable access it this time, but macOS may ask again on a future launch."},"rename":{"title":"Rename","label":"Conversation title"}},"aiWorkflows":{"settings":{"title":"Automate Settings","description":"Configure the AI models and devices used for AI Workflows. AI Workflows allow you to automate desktop and browser tasks using on-device AI.","configType":{"title":"Model Configuration Type","description":"Select the type of model configuration to use for AI Workflows. Different configurations are optimized for different models.","label":"Configuration Type"},"reasoningModel":{"title":"Reasoning Model","description":"Select the AI model to use for reasoning and planning tasks. The reasoning model analyzes your requests and creates action plans.","label":"Reasoning Model"},"reasoningDevice":{"label":"Reasoning Device"},"generationModel":{"title":"Generation Model","description":"Select the AI model to use for text generation tasks. The generation model creates text content when needed by workflows.","label":"Generation Model"},"generationDevice":{"label":"Generation Device"},"noModelsFound":"No models found","autoWarm":{"title":"Auto-Start AI Workflows","description":"Automatically initialize AI Workflow models when the app starts. Models will be pre-loaded so workflows can start immediately.","option":"Auto-start AI Workflow models on app launch"},"remoteWorkflows":{"title":"Run AI Workflows Across Your Devices","option":"Let my other devices start and follow automations on this device","description":"On by default. While on, you can start, monitor, and answer this device\'s automations from your other signed-in devices: the automation\'s progress (step titles and the AI\'s thinking) and any questions it asks you are sent in real time to those devices so you can respond from anywhere. This is shared only between your own devices and is never stored on Cephable\'s servers. Turn it off to keep Automations entirely on this device \u2014 automations still run here, but nothing is sent to your other devices and they cannot start an automation on this device."},"dynamicTools":{"option":"Smart Connector Tools Loading","description":"Start faster by loading only the tools you\'re using. When off, all tools load at once \u2014 useful if you want the model to decide what actions to take but it can be much slower and cause degraded results."},"prompt":{"title":"Additional Information for AI Workflows","description":"Enter additional details to be used with Cephable\'s AI when running workflows. Use this field to enter preferences for your tone, behavior, or any other details.","field":"Additional prompt","placeholder":"e.g. Always confirm before sending emails. Prefer concise responses. Use formal language in documents."},"thinkingLevel":{"field":"Reasoning effort","description":"How much the AI thinks through each step before acting. Higher levels help it choose and order actions more reliably on complex tasks, but make each step a little slower. Medium is recommended for most people.","low":"Low (fastest)","medium":"Medium (recommended)","high":"High","max":"Max (most thorough)"},"longTasks":{"field":"Long tasks","description":"How AI Workflows handle tasks that need to keep a lot in mind, like reading long documents. Automatic gives a task more room only when it needs it. Prioritize speed keeps every step quick, but very long tasks may forget their earliest steps. Always allow long tasks gives every task the most room, but steps that write text take a little longer. Only applies to computers with a separate graphics card.","auto":"Automatic (recommended)","speed":"Prioritize speed","long":"Always allow long tasks"},"terminate":{"title":"Clear Workflow Resources","description":"Click to terminate the workflow worker and free up resources. This will stop any running workflow and release memory used by the AI models.","button":"Terminate Workflow Worker","success":"Workflow worker terminated.","confirm":{"title":"Terminate Workflow Worker","description":"Are you sure you want to terminate the workflow worker? This will stop any running workflow and free up resources.","confirm":"Yes, terminate"}},"disableButtonNames":{"edit":"Block Button Interactions","description":"Control which buttons AI Workflows are allowed to interact with. By default, Cephable can click any button on your screen. Use this setting to prevent accidental actions (for example, \\"buy\\", \\"delete\\").","input":{"label":"Button Name","question":"Which buttons would you like to block? You can enter full or partial button names.","remove":"Remove Button Name"},"button":"Block Buttons"}}},"intelligentTasks":{"loading":{"loadingModels":"Loading AI Models...","extractingModels":"Extracting AI Models..."}},"camera":{"windowTitle":"Cephable Camera Controls","title":"Camera","extension":{"title":"Extension: Camera","enabledTitle":"Enable Camera Controls","enabledDescription":"With this setting turned on, Cephable will use your camera to detect your face and head movements to allow you to control your device with expressions and gestures including using your head movements as a mouse."},"titlePlural":"Cameras","settings":"Camera Settings","start":"Start Camera","stop":"Stop Camera","restart":"Restart Camera","show":"Show Camera","hide":"Hide Camera","descriptionShort":"Enables face expression and head movement.","description":"Use your camera to detect face expressions and body gestures as different controls.","select":"Select a camera you want to pair with for enhanced controls using your face and body.","empty":"No cameras found.","search":"Search by camera name","loading":"Loading Camera Controls...","live":"LIVE","paused":"Camera paused","error":"Unexpected error loading camera controls. Please check your camera and try again.","manage":{"title":"Click to view and manage details for your cameras.","description":""},"warn":"Camera controls have not been started, start your camera to allow face and body controls.","detected":{"face":"Face Detected.","noFace":"No Face Detected. Please adjust your camera or position and try again.","command":"Detected: {{command}}"},"permission":{"title":"Camera Permissions Required","description":"You need to give Cephable permission to use your camera to use face and body controls.","button":"Open Permission Settings","no":"No camera access","help":"Cephable needs access to your camera to use expression and head controls. Navigate to <strong>System Settings</strong> > <strong>Privacy & Security</strong> > <strong>{{pane}}</strong> and enable Cephable to access your camera."},"controls":{"startData":"Started recording face data. Press the shortcut again while in camera window to stop recording and download.","downloadData":"Stopped recording, downloading data","paused":"Paused camera controls.","pause":"Pause Camera Controls","resume":"Resume Camera Controls","resumed":"Resumed camera controls.","linesOn":"Turn face lines on","linesOff":"Turn face lines off","lines":"Face Lines","linesToggle":"Toggle draw face lines","noDeviceTitle":"No camera detected that can be used with Cephable.","noDeviceDescription":"You need to connect a camera that is compatible mobile apps.","noDeviceConnectedDescription":"The camera control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands."},"draw":{"error":"Error loading camera feed. Please check your camera and try again."},"switch":{"title":"Switch Camera","description":"Select a different camera to use for face and body controls.","select":"Select Camera","next":"Next Camera","nextLong":"Switch to the next camera","empty":"No other cameras found.","search":"Search by camera name"},"baseline":{"title":"Baseline","description":"The baseline is the default position of your face and body that Cephable uses to determine your movements. You can update and reset the baseline here.","update":"Update Baseline","reset":"Reset Baseline","updated":"Baseline Updated","tooltip":"Click to update your baseline to your current resting position."},"edit":{"title":"Edit Camera Settings","description":"You can refine the settings for your inputs that require a camera to better suit your needs.","autoStart":{"title":"Automatically Start Camera","description":"With this setting turned on, your controller will start your camera enabling you to use face expressions and head movement controls right when the app starts. If this is off, you need to tap the \\"Start Camera\\" button in your connection page.","option":"Autostart Camera and Head/Expression Controls?"},"head":{"title":"Head Movement Sensitivity","description":"Sensitivity tells Cephable how far you need to move in order to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.","tilt":{"title":"Head Tilt Sensitivity","description":"These values determine how far you need to tilt your head up, down, left, and right to trigger controls","up":"Tilt Up Sensitivity","down":"Tilt Down Sensitivity","left":"Tilt Left Sensitivity","right":"Tilt Right Sensitivity","scaleHigh":"Slight Tilt","scaleLow":"Large Tilt"},"turn":{"title":"Head Turn Sensitivity","description":"These values determine how far you need to turn your head left and right to trigger controls","left":"Turn Left Sensitivity","right":"Turn Right Sensitivity","scaleHigh":"Slight Turn","scaleLow":"Large Turn"},"lean":{"title":"Head Lean Sensitivity","description":"These values determine how far you need to lean your head forward and back to trigger controls","forward":"Lean Forward Sensitivity","back":"Lean Back Sensitivity","right":"Lean Right Sensitivity","left":"Lean Left Sensitivity","scaleHigh":"Slight Lean","scaleLow":"Large Lean"},"duck":{"title":"Head Duck/Rise Sensitivity","description":"These values determine how far you need to duck or rise your head to trigger controls","down":"Duck Down Sensitivity","up":"Rise Up Sensitivity","scaleHigh":"Slight Shift","scaleLow":"Large Shift"}},"face":{"title":"Face Expression Sensitivity","description":"Sensitivity tells Cephable how exaggerated of an expression you need to trigger a control. The larger the value (furthest right on the slider), the higher the sensitivity is, and therefore the less you need to move to trigger the control.","eyebrow":{"title":"Eyebrow Sensitivity","description":"These values determine how far you need to raise or lower your eyebrows to trigger controls","up":"Raise Eyebrow Sensitivity","scaleHigh":"Slight Raise","scaleLow":"Large Raise"},"mouth":{"title":"Mouth Sensitivity","description":"These values determine how far you need to open or close your mouth to trigger controls","open":"Open Mouth Sensitivity","close":"Close Mouth Sensitivity","smile":"Smile Sensitivity","scaleHigh":"Slight Open","scaleLow":"Large Open","closeScaleHigh":"Slight Closed","closeScaleLow":"Tightly Closed","smileScaleHigh":"Slight Smile","smileScaleLow":"Large Smile"}},"mouse":{"title":"Head Movement for Mouse Controls","disabled":"This feature is disabled for remote connections and extensions.","description":"Determine if and how you want to use head movements controls to move your mouse instead of triggering other outputs.","enable":{"title":"Enable Head Movement for Mouse Controls","description":"If this is turned on, then some of your head movement controls will be used to move your mouse instead of trigger controls.","option":"Use Head Controls for Mouse Movement?"},"input":{"title":"Mouse Input Type","description":"Select which type of head gestures you want to assign to mouse controls. For example, Head Tilting means you can tilt your head left and right to move your mouse left and right, Head Turning means you can turn your head left and right to move your mouse, and Head Leaning means you can lean left and right to move your mouse.","option":"Select Input Type","optionLong":"Select the type of head movement you want to use to control your mouse."},"invert":{"title":"Invert Mouse Movement","description":"If this is turned on, then the direction you move your head will be inverted from the direction your mouse moves. For X-axis: If this is turned on, then moving left will move your mouse right and moving right will move it left. For Y-axis: If this is turned on, then moving down will move your mouse up and moving up will move it down.","x":"Invert X-axis Mouse Movement?","y":"Invert Y-axis Mouse Movement?"},"mode":{"title":"Mouse Move Mode","description":"Select how you want the cursor to react to your head movements."},"speed":{"title":"Mouse Speed","description":"Determine the constant speed you want the cursor move.","fast":"Fast","slow":"Slow"},"linear":{"title":"Linear Mouse Movement","description":"If this is turned on, the cursor only moves in straight horizontal or vertical lines, making it easier to navigate in those specific directions without any diagonal drift.","option":"Use Linear Mouse Movement?"},"accelerationRate":{"title":"Mouse Acceleration Response Delay","description":"The number of milliseconds it takes for the mouse speed to increase."},"accelerationCurve":{"title":"Mouse Acceleration Curve","description":"Adjust the rate at which the cursor speed increases relative to head movement. ","linear":"Linear","exponential":"Exponential","sublinear":"Sub-linear"},"maximumSpeed":{"title":"Maximum Mouse Speed","description":"Determine maximum number of pixels the cursor can move per second."},"off":{"title":"Off","description":"Mouse movement is disabled."},"steadyGlide":{"title":"Steady Glide","description":"When you move your head past a certain point, the cursor glides continuously in that direction at a steady speed."},"speedBoost":{"title":"Speed Boost","description":"The cursor starts to move faster the longer you keep your head in one position. The longer you hold your head still, the quicker the cursor accelerates."},"dynamicGlide":{"title":"Dynamic Glide","description":"The cursor\'s speed increases based on how far you move your head. The further you move your head, the faster the cursor glides."},"proportionalSpeed":{"title":"Proportional Speed","description":"The cursor follows your nose tip proportional to your screen dimensions."}}}},"microphone":{"windowTitle":"Cephable Voice Controls","title":"Microphone","titlePlural":"Microphones","settings":"Microphone Settings","start":"Start Microphone","startDescription":"Turn on the microphone to start listening to commands.","stop":"Stop Microphone","descriptionShort":"Enables voice commands and dictation.","description":"Use your built in microphone to enable voice controls and dictation.","select":"Select a microphone you want to pair with for enhanced controls using your voice.","empty":"No microphones found.","search":"Search by microphone name","manage":{"title":"Click to view and manage details for your microphones.","description":""},"warn":"You microphone has not been started. Start the microphone to allow voice commands and dictation.","permission":{"title":"Microphone Permissions Required","description":"You need to give Cephable permission to use your microphone to use voice controls.","button":"Open Permission Settings","no":"No microphone access","help":"Cephable needs access to your microphone to use voice controls. Navigate to <strong>System Settings</strong> > <strong>Privacy & Security</strong> > <strong>{{pane}}</strong> and enable Cephable to access your microphone."},"controls":{"loadingDetail":"This may take a few minutes.","generatingTextDetail":"Stop generation by changing apps or saying \'stop generating\'","pause":"Pause Voice Controls","paused":"Paused controls.","resume":"Resume Voice Controls","dictationPlay":"Start Dictation Mode","dictationPause":"Stop Dictation Mode","prompt":"Start speaking to see your voice controls here...","dictationPrompt":"Start speaking to type what you say...","command":"Command","contextual":"Contextual","send":"Send","typedInputLabel":"Type a command or text to send","listeningPlaceholder":"Listening...","dictationListeningPlaceholder":"Listening...","pausedPlaceholder":"Voice paused...","latency":"High latency detected. Consider closing some applications that might be consuming too many resources.","noDeviceConnectedDescription":"The microphone control serves as a preview of the interface. No steps will be successfully executed. Connect this companion device to another, in order to initiate commands.","status":{"loadingModel":"Loading Voice Model...","loadingPhiModel":"Loading Text Generation Model...","preparingPhiModel":"Preparing Text Generation Model...","generatingText":"Generating...","thinking":"Thinking...","paused":"Paused.","dictating":"Dictating.","optimistic":"Optimistic:","listening":"Listening:","permission":"Checking microphone permissions...","typing":"Typing..."}},"edit":{"title":"Edit Microphone Settings","description":"Manage your voice commands and dictation settings for this connection.","input":{"title":"Microphone","description":"The microphone voice control and dictation listen to. Cephable remembers your choice and switches back to it whenever it is connected.","notConnected":"{{name}} (not connected)","systemDefault":"System default"},"autoStart":{"title":"Auto Start Microphone","description":"Automatically begins listening for voice controls when the device powers on. If disabled, tap `Start Listening` to begin.","option":"Auto Start Microphone"},"optimistic":{"title":"Optimistic Faster Voice Controls","description":"Makes voice controls faster and more responsive, but less forgiving. Use Standard mode if you want dictation support or more flexibility. Note: Optimistic mode may trigger accidentally if you don\'t say commands exactly.","option":"Optimistic Faster Voice Controls"},"aiCommands":{"title":"Intelligent Voice Commands","description":"Say commands naturally \u2014 Cephable AI figures out what you mean without needing an exact match.","option":"Intelligent Voice Commands"},"aiDictation":{"title":"Intelligent Dictation and Quick Type","description":"Enhanced voice-to-text with automatic punctuation, proper nouns, and sentence structure. Say `type [anything]` to use Quick Type for smarter, more natural dictation.","option":"Intelligent Dictation and Quick Type"},"confirm":{"title":"You have unsaved changes.","description":"Detected unsaved changes. Would you like to save before exiting?"}},"devices":{"error":"Microphone Input Device Not Found."},"context":{"add":"Add context","title":"Add context","highlighted":"Highlighted text","clipboard":"Clipboard","other":"Other\u2026","files":"Files\u2026","folders":"Folders\u2026","otherTitle":"Add custom context","otherLabel":"Custom context","otherPlaceholder":"Type or paste the context to use","otherConfirm":"Add","otherCancel":"Cancel","remove":"Remove context","removeAttachment":"Remove attachment","dropToAttach":"Drop files or folders to attach them as context","required":"Context is required for {{mode}}"}},"localization":{"title":"Language Settings","titleShort":"Language","select":"Select Language","description":"Choose your preferred language from a list of supported languages.","newUserDescription":"Please select a preferred language before continuing.","edit":"Update Language","profile":{"view":"Variants","title":"App Control Language","question":"What app control language would you like to edit?","description":"Some app controls have variants for different languages. Swap to another language to edit and personalize.","change":"Change Language"},"display":{"title":"Display Language","description":"Language that is displayed when using Cephable. This includes things like menus, notifications, and app controls being displayed in the language of your choice.."},"voice":{"title":"Voice Control Language","description":"This is the language that is used when recognizing dictation and voice commands. Specifying the language enhances the accuracy of your voice inputs.","settings":{"title":"Voice Recognition and Display Language","description":"Adjust your language settings for both display and voice controls. This option allows you to select your preferred languages for on-screen text and microphone interactions like voice controls and dictation."}},"unsupported":{"title":"Unsupported Language {{locale}}","description":"The selected language is not supported. Please choose a different language."},"locales":{"en":"English","en-us":"English (US)","en-gb":"English (UK)","en-in":"English (India)","es":"Espa\xf1ol \u2014 Spanish","fr":"Fran\xe7ais \u2014 French","it":"Italiano \u2014 Italian","de":"Deutsch \u2014 German","ja":"\u65E5\u672C\u8A9E \u2014 Japanese"},"localesShort":{"en":"English","en-us":"English (US)","en-gb":"English (UK)","en-in":"English (India)","es":"Spanish","fr":"French","it":"Italian","de":"German","ja":"Japanese"},"save":{"success":"User locale preferences saved!","error":"Error saving user locale preferences"}},"editor":{"title":"Markdown Editor","bold":"Bold","italic":"Italic","underline":"Underline","strikethrough":"Strikethrough","hr":"Horizontal Rule","link":"Link","quote":"Quote","code":"Code","codeBlock":"Code Block","comment":"Comment","image":"Image","table":"Table","unordered-list":"Unordered List","ordered-list":"Ordered List","checked-list":"Checked List","help":"Help","edit":"Edit","live":"Live","preview":"Preview","fullscreen":"Fullscreen","placeholder":"Please enter Markdown text here..."},"panel":{"title":"Cephable Panel","titleShort":"Panel","description":"This is the panel which is the main control center. It is always visible and allows you to control your apps using your voice, and more.","question":"Autostart Panel?","reconnecting":"Reconnecting\u2026","reconnectRetry":"Retry","position":{"top":"Top","right":"Right","left":"Left","bottom":"Bottom ","description":"Select where you want the Cephable Panel to appear on your screen.","label":"Position"},"sections":{"description":"Choose what sections in the panel are visible. You can hide sections based on your preferences to make the most of the panel space.","microphone":"Microphone and Voice Controls","camera":"Camera and Face/Head Controls","buttons":"Quick Action Buttons","tasks":"Intelligent Tasks","profile":"App Controls and Previews","globalControls":"Global and Device Controls"},"modes":{"title":"Mode","generate":{"label":"Generate","placeholder":"Describe what you want to generate"},"rewrite":{"label":"Rewrite","placeholder":"How should I rewrite the text?"},"translate":{"label":"Translate","placeholder":"Translate to which language?"},"automate":{"label":"Automate","placeholder":"Describe the steps you want to automate"},"auto":{"label":"Auto","placeholder":"Type anything \u2014 Cephable picks the best mode","upgrade":"Cephable needs {{tier}} to run that action."},"control":{"label":"Control","placeholder":"Type a command or text to send"},"summarize":{"label":"Summarize","placeholder":"How would you like to summarize or condense the text?"}}},"smartTasks":{"title":"Intelligent Tasks","show":"Show Intelligent Tasks","description":"Intelligent tasks are the different tasks that Cephable\'s AI can perform for you. These tasks are powered by on-device AI and can be used to create text, summarize, rewrite, translate and more.","clearCache":"Sorry, your request failed due to an unexpected issue. Please try again.","networkError":"Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.","genericError":"An unexpected error occurred. Please try again.","generatedByAI":"Powered by on-device AI, please review for accuracy.","runningInBackground":{"generate":"Generating in background...","rewrite":"Rewriting in background...","translate":"Translating in background...","summarize":"Summarizing in background...","generic":"Running in background..."},"processing":"Processing...","highlightText":{"title":"Use highlighted text","description":"Cephable can automatically use the text you have highlighted in any app to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.","label":"Enter text to use","placeholder":"You can also highlight text in another app and come back here to use it.","noTextFound":"No text found. Highlight text in another app or paste text into the field and try again."},"pasteText":{"title":"Paste text","description":"Cephable can automatically use the text you have copied to your clipboard to perform tasks like summarizing, rewriting, or translating. You can also enter text manually if you prefer.","label":"Enter text to use","placeholder":"You can also highlight text in another app and come back here to use it."},"generateText":{"title":"Generate Text","description":"Create text content based on your input or prompts.","label":"Describe what you want to generate"},"summarizeText":{"title":"Summarize Text","write":"Write Summary","description":"Gather insights from long text and create short summaries or key takeaways.","directions":"Enter the text to summarize, or Cephable will automatically use whatever text you have highlighted.","inputLabel":"Enter text to condense","outputLabel":"Your summary will appear here."},"rewriteText":{"title":"Rewrite Text","description":"Highlight text in another app where you are writing and then come back here and describe how you want it to be re-written.","label":"Describe how you want to rewrite the text","inputLabel":"Enter text to rewrite"},"translateText":{"title":"Translate Text","description":"Enter the text to translate, or Cephable will automatically use whatever text you have highlighted.","label":"Enter text to translate","languageLabel":"Language to translate to"},"transcribeAudio":{"title":"Transcribe Audio","description":"Convert audio or video files to text using AI transcription.","inputMethod":"Choose input method","localFile":"Local File","url":"URL","selectFile":"Select Audio/Video File","urlLabel":"Audio/Video URL","transcribe":"Transcribe","result":"Transcription Result","invalidFileType":"Please select a valid audio or video file (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Transcription error","history":{"title":"Transcription History","description":"View and manage your saved transcriptions.","viewHistory":"View History","empty":"No transcriptions yet. Start transcribing to build your history!","titleLabel":"Title (optional)","titlePlaceholder":"Enter a title for this transcription","textLabel":"Transcription Text","confirmDelete":"Are you sure you want to delete this transcription?"}},"noteTaker":{"title":"Note Taker","description":"Let Cephable locally record and transcribe your meetings or conversations"},"documentChat":{"title":"Document Chat","description":"Interact with and query documents for quick insights."},"download":{"title":"Download AI Models to Unlock More Capabilities","description":"To use Intelligent tasks, a local model needs to be downloaded to your device. This ensures your data stays private and is never sent to the cloud.","confirm":"Download","cancel":"Not now"},"aiWorkflows":{"title":"AI Workflows","description":"Automate your desktop and browser tasks with AI. Simply describe what you want to accomplish, and watch Cephable execute the actions for you.","prefix":"Workflow: ","label":"What can I help you do?","start":"Start","progress":"Working...","continue":{"label":"Continue","placeholder":"Ask Cephable to do more with this result\u2026"},"resume":{"title":"Continue a past chat","description":"Search your automation history and pick up where you left off.","searchPlaceholder":"Search past chats\u2026","noMatches":"No past chats match \\"{{query}}\\"","empty":"No past automations yet.","continuing":"Continuing chat","indicator":"Continuing \\"{{title}}\\" conversation","stopContinuing":"Start a new chat instead","clear":"Clear selected chat"},"context":{"approaching":"This conversation is getting long ({{percent}}% of the AI\'s memory used). Older messages may soon be dropped.","trimmed":"This conversation has reached the AI\'s memory limit, so it may start forgetting earlier messages. Start a new workflow to reset.","indicator":"{{percent}}% of working memory used","indicatorPending":"Working memory used for this workflow","indicatorTokens":"{{used}}/{{budget}} used"},"retry":{"label":"Retry"},"steps":{"error":"Error","thinking":"Thinking","tool":"Tool","details":"Details","output":"Output","showMore":"Show more","showLess":"Show less","chunkProgress":"part {{current}} of {{total}}","contentUsed":"Content used","contentSource":"Source content","contentTruncated":"Showing the first {{shown}} of {{total}} characters"},"files":{"sectionTitle":"Files","open":"Open","openFile":"Open file","openFolder":"Open folder","openError":"Couldn\'t open \\"{{name}}\\". It may have been moved or deleted."},"browser":{"sectionTitle":"Browser","view":"View browser","open":"Open","openError":"Couldn\'t open the browser."},"ready":{"waiting":"AI Workflows is ready. Waiting for your instructions.","execute":"AI Workflows is ready. Starting on your request..."},"input":{"other":"Other\u2026","otherPlaceholder":"Type your answer","submit":"Send"},"approval":{"title":"Confirm action","approve":"Approve","reject":"Reject","edit":"Edit","confirmDelete":"Delete","confirmRun":"Run command","confirmMove":"Move","badgeDestructive":"Destructive","badgeCaution":"Caution","deletePath":"Delete this file/folder? This is permanent.","runCommand":"Run this shell command?","movePath":"Move/rename this path? It may overwrite the destination."},"status":{"idle":"Waiting for your instructions...","initializing":"Getting things ready...","loadNotice":{"firstRunSetup":"Setting up on-device AI for the first time. This can take a few minutes, but it will be faster next time.","largeModel":"Loading {{model}} ({{size}} GB). Larger models can take a few minutes to load. For faster results, switch to a smaller model in Settings.","driverIssue":"Your graphics driver may be out of date, so on-device AI is using a slower mode. Updating your graphics driver can make it faster and more reliable.","longTask":"This task is getting long, so I\u2019m giving it more room to work. This can take up to a minute."},"planning":["Making a plan...","Breaking down your request...","Mapping out the steps...","Organizing the workflow...","Preparing the strategy...","Creating a plan of action...","Figuring out the best way to help you...","Determining how to approach this...","Analyzing your request...","Planning the execution..."],"thinking":["Thinking..."],"thinkingInteractive":["Considering the next step...","Reviewing what we\'ve done so far...","Deciding what to do next...","Analyzing the results...","Planning the continuation...","Evaluating the options...","Figuring out the best next step...","Working on the next part of your request...","Working on the next steps...","Processing the previous step\'s results..."],"waitingForUser":"Your input is needed to continue.","completed":"Success!","failed":"Your request failed.","networkError":"Connection lost while downloading the model. Please check your internet connection and try again by submitting a prompt or restarting the app.","unsupportedOSVersion":"You have an outdated MacOS System, please update and try again.","canceled":"Your request was canceled.","terminated":"Completed your request.","stopped":"Stopped.","executing-org-block":"Cannot {{params.toolName}} because interacting with {{params.appOrDomain}} is blocked by the organization.","executing-destructive-block":"Interacting with {{params.elementName}} is blocked. Please review and perform this action manually.","executing-type-focus-block":"I had an issue writing the content. It is copied to your clipboard, please paste it manually.","executing-permission-block":"I had an issue accessing the file.","tools":{"analyze_table":{"executing-start":"Analyzing the table...","executing-complete":"I analyzed the table."},"click_element_by_index":{"executing-start":"Clicking the relevant button...","executing-complete":"I clicked {{params.index}}."},"click_element":{"executing-start":"Clicking the highlighted number...","executing-complete":"I clicked {{params.elementName}}."},"copy_selection":{"executing-start":"Gathering context...","executing-complete":"I have context, ready for the next part of your request."},"append_to_file":{"executing-start":"Adding to the file...","executing-complete":"I added content to the file."},"copy_path":{"executing-start":"Copying...","executing-complete":"I copied it."},"create_directory":{"executing-start":"Creating the folder...","executing-complete":"I created the folder."},"delete_path":{"executing-start":"Deleting...","executing-complete":"I deleted it."},"draft_email":{"executing-start":"Drafting an email...","executing-complete":"I drafted an email about {{params.subject}}."},"execute_app_action":{"executing-start":"Running {{params.actionName}}...","executing-complete":"{{params.actionName}} completed."},"edit_user_file":{"executing-start":"Editing the file...","executing-complete":"I edited the file."},"find_all_text":{"executing-start":"Searching for all relevant context about {{params.searchText}}...","executing-complete":"I found all relevant context about {{params.searchText}}."},"find_and_select_text":{"executing-start":"Searching and selecting relevant context about {{params.searchText}}...","executing-complete":"I found and selected relevant context about {{params.searchText}}."},"generate_text":{"executing-start":"Creating content...","executing-progress":"Creating content...{{progress}}%","executing-complete":"I created the requested content."},"get_all_interactive_elements":{"executing-start":"Scanning to get more context...","executing-complete":"I understand what I can interact with."},"get_all_text_elements_content":{"executing-start":"Reading to get more context...","executing-complete":"I understand what text content is available."},"get_all_text_elements_names":{"executing-start":"Reading to get more context...","executing-complete":"I understand what text content is available."},"get_available_profile_actions":{"executing-start":"Checking what controls are available in this app...","executing-complete":"I understand what I can do in this app."},"get_document_content":{"executing-start":"Reading to get more context...","executing-complete":"I have context, ready for the next part of your request."},"get_file_info":{"executing-start":"Checking the file...","executing-complete":"I checked the file."},"get_installed_apps":{"executing-start":"Deciding which app is relevant to your request...","executing-complete":"I know which apps I can use."},"get_running_app_names":{"executing-start":"Deciding which app is relevant to your request...","executing-complete":"I know which apps I can use."},"get_selected_text":{"executing-start":"Reading the selected content...","executing-complete":"I have context on the selected content."},"get_stored_content":{"executing-start":"Gathering context...","executing-complete":"I have context, ready for the next part of your request."},"keyboard_shortcut":{"executing-start":"Gathering context...","executing-complete":"I have context, ready for the next part of your request."},"list_directory":{"executing-start":"Listing the folder...","executing-complete":"I listed the folder."},"move_path":{"executing-start":"Moving...","executing-complete":"I moved it."},"open_app":{"executing-start":"Opening {{params.appName}}...","executing-complete":"I opened {{params.appName}}."},"open_path":{"executing-start":"Opening...","executing-complete":"I opened it."},"open_webpage":{"executing-start":"Opening {{params.url}}...","executing-complete":"I opened {{params.url}}."},"paste_content":{"executing-start":"Writing...","executing-complete":"I finished writing."},"read_user_file":{"executing-start":"Reading the file...","executing-complete":"I read the file."},"respond_to_user":{"executing-start":"Completing your request...","executing-complete:":"I completed your request."},"run_command":{"executing-start":"Running a command...","executing-complete":"I ran the command."},"search_browser":{"executing-start":"Searching the web for {{params.query}}...","executing-complete":"I searched the web for {{params.query}}."},"search_files":{"executing-start":"Searching for files...","executing-complete":"I found matching files."},"search_in_files":{"executing-start":"Searching inside files...","executing-complete":"I searched inside the files."},"select_all_text":{"executing-start":"Selecting all the text...","executing-complete":"I selected all the text."},"summarize_text":{"executing-start":"Summarizing the text...","executing-progress":"Summarizing...{{progress}}%","executing-complete":"I summarized the text."},"translate_text":{"executing-start":"Translating the text to {{params.targetLanguage}}...","executing-progress":"Translating...{{progress}}%","executing-complete":"I translated the text to {{params.targetLanguage}}."},"rewrite_text":{"executing-progress":"Rewriting...{{progress}}%"},"type_stored_content":{"executing-start":"Writing...","executing-complete":"I finished writing."},"type_text":{"executing-start":"Writing...","executing-complete":"I finished writing."},"write_user_file":{"executing-start":"Writing the file...","executing-complete":"I wrote the file."},"unknown":{"executing-start":"Ran into a problem, trying a different strategy...","executing-complete":"I tried a different strategy."}}}}},"tray":{"panel":"Toggle Panel","dashboard":"Show Workspace","quit":"Quit Cephable"},"metrics":{"download":{"success":"Metrics file successfully accessed.","manualPath":"Metrics file available at: {{path}}","error":"Error downloading metrics file.","noFile":"No metrics file found."},"clear":{"success":"Metrics file cleared successfully.","error":"Error clearing metrics file.","noFile":"No metrics file found to clear.","confirm":"Are you sure you want to clear all metrics data? This cannot be undone."}},"gamepad":{"title":"Gamepad Support","description":"Configure gamepad and joystick output for PC gaming","driver":{"title":"Game Controller Driver","description":"To support game controller outputs, Cephable needs to download and install an external driver called ViGEm. This driver enables virtual Xbox 360 controller functionality that games recognize natively.","installed":"Game controller driver installed - You\'re ready to use gamepad outputs! If you\'re still facing issues, you can try reinstalling the driver.","notInstalled":"Game controller driver not installed","install":"Install Game Controller Driver","reinstall":"Reinstall Game Controller Driver","installing":"Installing ViGEm game controller driver...","installSuccess":"ViGEm game controller driver installed successfully! You can now use gamepad outputs in your controls.","installFailed":"Failed to install ViGEm driver. Please try again or install manually from the ViGEm website.","disclosure":{"title":"Install third-party gamepad driver?","description":"Gamepad support requires installing ViGEm, a third-party unofficial driver that lets Cephable emulate a virtual Xbox controller. Continue only if you want Cephable to install this driver.","confirm":"Install ViGEm driver"}},"platform":{"unsupported":"Platform not supported for gamepad features","unsupportedDescription":"Gamepad output functionality is currently only supported on Windows x64 systems. Mac and Windows ARM64 support is not yet available."},"usage":"Once the Game Controller driver is installed, you can use joystick movements and gamepad button presses in your macros and voice commands to control games."},"youtube":{"unavailable":{"title":"Video Unavailable","description":"This video is currently unavailable. Please check again later.","retry":"Retry"},"watch":{"title":"Oops.","description":"Looks like there was an issue loading the video. You can watch it directly on YouTube.","button":"Watch on YouTube"},"offline":{"title":"Video Unavailable","description":"This YouTube video requires an internet connection to load. Please check your connection and try again."}},"accessibilityService":{"error":{"generic":"Internal Error. Please try again later.","elementNotFound":"No result found. Please ensure the search exists and try again.","highlightOnConflict":"Multiple elements found. Please refine your command to specify which one you want to select.","clickNotInitialized":"Tapping by Name is not available at the moment. Please contact support if the issue persists.","platformUnsupported":"Tapping by Name is not supported on this platform.","permission":"Cephable does not have permission to read this app. Grant it under System Settings > Privacy & Security > {{pane}} \u2014 on a work-managed device this may be blocked by your administrator."},"clickWait":"Still initializing. Please wait a moment and try again."},"tos":{"title":"Terms of Service Update","description":"Our Terms of Service have been updated. Please review and accept the updated terms to continue using Cephable.","effectiveDate":"Effective date: {{date}}","accept":"Accept Terms of Service","loadError":"Unable to load Terms of Service. Please try again.","viewInBrowser":"View Terms of Service In Browser","acceptCheckbox":"I have read and accept the Terms of Service"},"sensitivityValues":{"verySensitive":"Very Sensitive","high":"High","medium":"Medium","low":"Low","notSensitive":"Not Sensitive"},"appearance":{"title":"Appearance"},"troubleshooting":{"title":"Troubleshooting"},"extensions":{"title":"Extensions","titleShort":"Extensions","description":"Enable features, connect companion apps, and extend what Cephable can do.","searchPlaceholder":"Search extensions","noResults":"No extensions match your search.","comingSoon":"Coming soon","stats":{"rating":"Rating","installs":"Installs","yourRating":"Your rating","rated":"Thanks for rating!","rateError":"Could not save your rating."},"nav":{"label":"Browse extensions","discover":"Discover","skills":"Skills","connectors":"Connectors","features":"Cephable features","installed":"Installed"},"type":{"skill":"Skill","tool":"Connector","input":"Input","build":"Build","app":"Companion App","feature":"Feature"},"done":"Done","getStarted":"Get started","viewDetails":"View details & settings","enable":"Enable","publisher":{"official":"Cephable","officialTitle":"Official \u2014 built and maintained by Cephable","byline":"By {{publisher}}","thirdPartyTitle":"Third-party integration by {{publisher}}"},"category":{"inputControls":{"title":"Input & Control","description":"Turn on the ways you control your device with Cephable."},"companionApps":{"title":"Companion Apps & Tools","description":"Extend Cephable with our mobile app and web-based creators."},"buildExtend":{"title":"Build & Extend","description":"Create your own extensions with the Cephable API and SDKs."},"previews":{"title":"Previews","description":"Try features that are on the way. Previews may change before they are released."},"marketplace":{"title":"Marketplace","description":"New skills, tools, and connections are on the way."}},"camera":{"title":"Camera Controls","description":"Control your device with face and head movements using your camera.","detail":"Camera controls let you use facial expressions and head movements \u2014 including head-as-mouse \u2014 to control your device. Enable them with the switch on the card, then fine-tune the behavior here.","settings":{"title":"Expressions & gestures","description":"Adjust which facial expressions and head movements map to actions in Settings."},"advancedSettings":"Open camera settings"},"gamepad":{"title":"Gamepad Support","description":"Emulate an Xbox controller so games recognize your Cephable inputs.","detail":"Gamepad support requires installing ViGEm, a third-party unofficial driver, to emulate a virtual Xbox controller that games recognize natively. Install or update the driver below. Available on Windows x64."},"mobile":{"title":"Cephable Mobile App","description":"Use your phone as a companion controller with the Cephable mobile app.","detail":"Get the Cephable mobile app to use your phone as a companion controller. Scan a code or use the links to download it on iOS or Android, then preview the app below.","screenshotsTitle":"Preview","screenshotPlaceholder":"Screenshot","screenshotAlt":"Cephable mobile app screenshot {{number}}","scanTitle":"Scan to download","ios":"iOS \u2014 App Store","android":"Android \u2014 Google Play","iosAction":"Get it on the App Store","androidAction":"Get it on Google Play"},"controllerCreator":{"title":"Custom Controller Creator","description":"Design your own on-screen controllers at controller.cephable.com.","detail":"The Custom Controller Creator lets you design and share your own on-screen controllers in the browser.","qrCaption":"controller.cephable.com","action":"Open Controller Creator","screenshotsTitle":"Preview","screenshotPlaceholder":"Controller creator screenshot","screenshotAlt":"Custom Controller Creator screenshot {{number}}"},"developer":{"title":"Build Your Own Extension","description":"Use the Cephable API and SDKs to build and share your own extensions.","detail":"Build your own extensions and integrations with Cephable. Explore the API and SDKs, then publish and share what you create at developers.cephable.com.","api":{"title":"Cephable API","description":"Programmatically manage profiles, devices, controls, and real-time events."},"sdk":{"title":"SDKs & samples","description":"Get started fast with our SDKs, samples, and integration guides."},"action":"Go to developers.cephable.com"},"automateHttpServer":{"title":"Automate HTTP Server","description":"Connect local services to Cephable\'s on-device Automate assistant over HTTP.","detail":"The Automate HTTP server lets local services, development tools, and evaluation runners use Cephable\'s shipping assistant. It accepts connections only from this device, requires the generated key on every request, and confines file operations to an isolated Automate workspace.","proRequired":"The Automate HTTP server is available with Cephable Professional.","running":"Running","stopped":"Stopped","port":"Port","endpoint":"Endpoint","portMoved":"Port {{preferredPort}} was already in use on this device, so the server started on port {{port}} instead. Use the endpoint above in your tools, not the default.","portMovedTitle":"Different port in use","api":{"title":"How to connect","description":"Use the server from a local script, desktop app, or automation tool running on this computer.","routes":{"chat":"Chat","run":"Automate run","health":"Health","models":"Models","modelMode":"Model mode (your own agent loop)","tools":"Built-in tools","speech":"Speech results","settings":"Settings"},"steps":{"enable":"Enable this extension from its card, leave Cephable open, and confirm that the status above says Running.","copyKey":"Copy the access key below. Send it on every request in the Authorization header as Bearer <access key>.","sendRequest":"Use the endpoint shown above and POST a JSON request to /v1/chat/completions. Existing OpenAI-compatible clients can use cephable-agent as the model name to run the full assistant, or cephable-model to use Cephable as the model inside their own agent.","readResponse":"Read the assistant reply from choices[0].message.content. If a client cannot connect, send GET /health with the same authorization header."}},"key":"Access key","keyDescription":"Use this key as the bearer token for local clients. It is encrypted with your operating system\'s secure storage and never synced to Cephable.","copyKey":"Copy access key","copyError":"Could not copy the Automate server access key.","regenerateKey":"Regenerate access key","keyRegenerated":"Automate server access key regenerated.","example":{"title":"Node.js request example","description":"This example already includes the endpoint and current access key. Copy it into a trusted local Node.js script and replace the sample prompt with your task.","copy":"Copy request example","copyError":"Could not copy the request example."},"useCases":{"title":"Ideas for using the server","description":"Anything that can make a local HTTP request can ask Cephable\'s on-device Automate assistant to help.","localAutomation":"Connect local scripts, shortcut tools, desktop utilities, or automation platforms to an Automate workflow.","privateText":"Rewrite, summarize, classify, or translate text inside an internal tool while keeping inference on this device.","accessibleInputs":"Let custom switches, sensors, or companion software turn an accessible input into a richer Automate task.","testing":"Run prompt and workflow regression suites against the same assistant, skills, tools, and local model used by the Cephable app."},"security":{"title":"Keep access local and secure","description":"The server listens only on 127.0.0.1, so remote and cloud services cannot connect directly. Treat the access key like a password and share it only with software you trust. Regenerating it immediately disconnects clients using the previous key."},"secureStorageUnavailable":"This server cannot be enabled because secure operating-system storage is unavailable.","error":"Could not update the Automate HTTP server."},"portal":{"title":"Projects & Teams","description":"Manage your projects and teams in the Cephable Portal.","detail":"Use the Cephable Portal to manage your projects, teams, and organization settings in one place.","projects":{"title":"Projects","description":"Create and manage projects, API keys, and integrations."},"teams":{"title":"Teams","description":"Invite members, assign roles, and manage access across your organization."},"action":"Open the Cephable Portal"},"mcpTools":{"title":"MCP Tools","description":"Connect Model Context Protocol tools to extend Cephable\'s capabilities."},"aiSkills":{"title":"AI Skills","description":"Add reusable AI skills that Cephable can trigger on demand."},"workflows":{"title":"Reusable Workflows","description":"Share and install prebuilt automation workflows."},"controlBundles":{"title":"Control Bundles","description":"Install curated bundles of app and game controls in one tap."},"connections":{"title":"Game & App Connections","description":"Discover games and apps you can control with Cephable, like Call of Duty: Black Ops 7."},"aiSkillsMarketplace":{"title":"AI Skills Marketplace","description":"Browse and install skills shared by the community."},"copyLink":"Copy link","detail":{"access":{"developer":"Developer","employee":"Employee","plus":"Plus","student":"Student"},"by":"by","categories":"Categories","featured":"Featured","installing":"Installing\u2026","size":"Download size","transport":"Transport","version":"Version"},"discover":{"connectors":"Connectors","coreDescription":"Cameras, gamepads, companion apps, and developer tools built into Cephable.","coreTitle":"Cephable features","description":"Official and community skills and connectors to extend the Cephable assistant.","empty":"Nothing to show yet. Browse Skills or Connectors to add your own.","exploreFeatures":"Explore features","featured":"Featured","newest":"New & noteworthy","skills":"Skills","title":"Discover","viewAll":"View all"},"features":{"description":"Built-in ways to control Cephable \u2014 cameras, controllers, companion apps, and developer tools.","title":"Cephable features","searchPlaceholder":"Search features\u2026"},"install":"Install","installError":"Could not install.","installed":"Installed","linkCopied":"Link copied","provenance":{"cephable":"Cephable","mine":"Mine","organization":"Your Organization","thirdParty":"Third Party"},"managedBy":"Managed by {{provenance}}","integrationType":{"cephable":"official integration","mine":"personal integration","organization":"organization integration","thirdParty":"third-party integration"},"installedPage":{"connectors":"Connectors","description":"Skills and connectors you\u2019ve added. Open one to manage or remove it.","empty":"You haven\u2019t added any skills or connectors yet.","manage":"Manage","skills":"Skills","title":"Installed","searchPlaceholder":"Search installed extensions\u2026"},"publish":{"title":{"mcp":"Share this MCP connector","skill":"Share this skill"},"shareWith":"Who can access this","target":{"organization":"People in my organization","public":"Everyone (public marketplace)"},"chooseOrganization":"Choose an organization","yourOrganization":"your organization","publicRestricted":"Publishing to Cephable marketplace for public use denied. Please share within your organization.","audience":{"public":"Once the Cephable team approves it, anyone using Cephable will be able to find, view, and install this. Choose your words and icons accordingly.","organization":"Everyone in {{org}} will be able to find and install this."},"displayName":"Display name","shortDescription":"Short description","shortDescriptionHelp":"A one-line summary shown in listings.","description":"Description","iconUrl":"Icon URL","darkModeIconUrl":"Dark mode icon URL","categories":"Categories","categoriesHelp":"Comma-separated (e.g. productivity, writing).","version":"Version","versionHelp":"Leave blank to bump automatically.","secretNote":{"mcp":"Only the non-secret connection details are shared. Your API keys, tokens, and other credentials stay on this device \u2014 people who install it enter their own.","skill":"The skill\u2019s files and instructions are shared as-is. Remove anything private before publishing."},"confirm":"Publish","submitConfirm":"Submit for review","reviewNote":"Public submissions are reviewed by the Cephable team before they appear in the marketplace. You\u2019ll see the status on your item, and we\u2019ll email you once it\u2019s been reviewed.","notes":"Notes for the reviewer (optional)","notesHelp":"Anything that helps us review \u2014 what it does, and what changed since last time.","inReview":"This is already awaiting review. Withdraw the current submission to make changes and submit it again.","withdraw":"Withdraw submission","resubmitConfirm":"Resubmit for review","resubmitNote":"This wasn\u2019t approved for public listing. Address the feedback below, then resubmit for review.","previousFeedback":"Reviewer feedback"},"reviewStatus":{"section":"Public marketplace review","reasonLabel":"Reviewer note","pending":"In review","published":"Published","rejected":"Changes requested","removed":"Removed","pendingTitle":"Awaiting Cephable review before it appears in the public marketplace.","publishedTitle":"Approved and listed in the public marketplace.","rejectedTitle":"Not approved for public listing \u2014 see the reviewer\u2019s note, then submit again.","removedTitle":"Removed from the public marketplace by a moderator.","notify":{"published":"\u201C{{name}}\u201D was approved and is now live in the marketplace.","rejected":"\u201C{{name}}\u201D needs changes before it can be published. Open it to see the reviewer\u2019s feedback.","removed":"\u201C{{name}}\u201D was removed from the public marketplace."}},"workflowRecording":{"title":"Record a Workflow","description":"Show Cephable how you do a task once, and it turns the recording into a skill it can run for you.","previewBadge":"Preview","detail":"Record a Workflow watches while you do a task yourself \u2014 the apps you switch to, the buttons and fields you click, what you type, and what you say out loud as you go. When you stop, Cephable turns the recording into an AI Skill you can review, edit, and save. The next time you ask Automate to do that kind of task, it uses the skill as a guide, taking the most direct route instead of repeating every click.","howItWorks":{"title":"How it works","record":"Start a recording from the Workspace, the Automate tab, or AI Skills, then do the task start to finish.","narrate":"Talk through what you are doing and why. Your narration becomes the reasoning behind each step.","review":"Stop the recording to get a draft skill. Review the steps and the description before you save it.","run":"Ask Automate to do the task again. It reads the recording for reference and adapts it to what you ask for."},"captured":{"title":"What gets recorded","description":"Your clicks, key presses, app switches, and the names and ids of the controls you use, plus your narration if a microphone is available. Everything is processed on this device. Steps that only get you somewhere, like opening a new browser tab and typing an address, are condensed into a single step. Avoid entering passwords or payment details while recording."},"whereToFind":{"title":"Where to find it","workspace":"Workspace: the Record a Workflow band under the Create and Automate suggestions.","automate":"Automate tab in the Cephable Panel: the \\"Teach Cephable a workflow\\" suggestion and composer menu.","skills":"Extensions \u2192 AI Skills: Create skill \u2192 Record what I do."},"previewNotice":"This is a preview feature. It may change before release, and your feedback helps shape it.","proRequired":"Record a Workflow is available with Cephable Professional.","startAction":"Record a workflow"}},"skills":{"intro":"Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.","teach":{"action":"Teach as skill","generating":"Teaching\u2026","title":"Teach a skill","heading":"Teach Cephable a new skill","subheading":"Cephable turned what you just did into a reusable skill. Review and tweak it below, then save so the assistant can do this again for you \u2014 and for anyone you share it with.","fromRun":"Based on: {{title}}","filesTitle":"Files to include","filesHelp":"These are files from your run that could make the skill repeatable. Keep the ones that should travel with the skill; turn off anything that was just this run\u2019s data.","detailsTitle":"Skill details","addFile":"Add another file\u2026","include":{"add":"Include","on":"Included \u2014 click to remove","off":"Excluded \u2014 click to include"},"included":"Included","origin":{"attached":"You provided","template":"Template","generated":"Run produced","observed":"Gathered","added":"Added by you"},"saved":"Skill saved. You can enable and share it below.","error":"Could not create a skill from this run.","filesError":"Some reference files could not be added: {{files}}","notFound":"This draft is no longer available.","backToSkills":"Back to skills"},"create":"Create skill","importFolder":"Import folder","importZip":"Import .zip","importError":"Could not import the skill.","enable":"Enable","openFolder":"Open folder","deleteConfirm":"Delete?","emptyTitle":"No skills yet","emptyBody":"Create your first skill or import one to get started.","sharingComingSoon":"Sharing skills with your organization and a skills marketplace are coming soon.","source":{"user":"Created by you","imported":"Imported","organization":"Organization","marketplace":"Marketplace"},"bestPractices":{"title":"Tips for great skills","description":"Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.","focused":"Keep instructions short and focused on one job. Use numbered steps in the order they should happen.","examples":"Add a short example of a request the skill handles and the ideal result.","keywords":"Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.","trust":"Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer.","activation":"Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. release-notes","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What the skill does and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use the skill. Be specific.","keywordsLabel":"Keywords (optional)","keywordsPlaceholder":"comma, separated, words","keywordsHelp":"Extra words that should trigger this skill (brand names, aliases, file types).","instructionsLabel":"Instructions (SKILL.md)","instructionsPlaceholder":"Step-by-step instructions for the assistant. Leave blank to start from a template.","save":"Save changes","create":"Create skill","saveError":"Could not save the skill.","activationLabel":"When should the assistant use this?"},"picker":{"title":"Skills","empty":"No matching skills","hint":"Type to filter skills"},"contextMenuItem":"Skill\u2026","chipRemove":"Remove skill","attached":"Attached skills","inUse":"Using skills:","section":{"title":"AI Skills","description":"Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."},"createDescription":"Build a reusable skill from scratch or a template.","import":"Import a skill","importDescription":"Add a skill from a folder or a .zip file.","copy":"Copy an existing skill","copyDescription":"Start from a copy of one of your skills.","copyShort":"Copy","editTitle":"Edit skill","newTitle":"New skill","templates":{"title":"Start from a template","start":"Start from a template\u2026","applied":"Template applied \u2014 edit the details below.","blank":{"title":"Blank","summary":"Start from an empty template."},"navigateApp":{"title":"Navigate an app (click in steps)","summary":"Tell Cephable where to click, step by step, to get through an app."},"writeText":{"title":"Write or insert text","summary":"Draft text a certain way and type it where I am working."},"fillForm":{"title":"Fill out a form","summary":"Fill a form field by field from details I give you."},"summarizeDoc":{"title":"Summarize a document","summary":"Read a file and give a short, structured summary."}},"activation":{"label":"Activation","auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant picks this skill on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never picks this on its own \u2014 it runs only when you attach it with / or @."},"mode":{"label":"How this skill is used","off":"Off","offTooltip":"Off \u2014 this skill is never used or shown in the picker."},"viewDetails":"View details","files":{"label":"Reference files & scripts","help":"Add files your skill uses \u2014 the assistant reads references and can run scripts. Mention them in your instructions above.","empty":"No files added yet.","add":"Add file\u2026","remove":"Remove file","addError":"Could not add the file.","kind":{"reference":"Reference file","script":"Script","asset":"Asset","referenceShort":"Reference","scriptShort":"Script","assetShort":"Asset"},"open":"Open file"},"scriptsSetting":{"label":"Let skills run scripts","help":"When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."},"capability":{"script":{"label":"Runs scripts","tooltip":"This skill can run programs on your computer \u2014 you approve each one before it runs. Only use skills you trust."},"reference":{"label":"Uses reference files","tooltip":"This skill includes reference files the assistant can read for detail. It does not run programs on your computer."},"basic":{"label":"Instructions only","tooltip":"This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."},"alsoReferences":"It also includes reference files it reads.","scriptsOff":"Script running is currently turned off in settings."},"actions":"Skill actions","body":{"empty":"No instructions added yet.","label":"Instructions (SKILL.md)"},"importTooltip":"Import a skill from a folder or .zip file","install":"Install","keywords":{"label":"Keywords"},"marketplace":{"description":"Public skills shared by the community that match your search.","title":"From the public marketplace"},"share":"Share","shareError":"Something went wrong.","sync":"Sync","updateAvailable":"A newer version is available.","searchPlaceholder":"Search skills\u2026","createTooltip":"Record yourself doing a task, or write the skill yourself","createRecord":"Record what I do","createScratch":"Start from scratch"},"mcp":{"section":{"title":"Tools","description":"Connect MCP servers to give the Cephable assistant extra tools. Use them in the panel by typing / or @."},"addServer":"Add a server","addServerDescription":"Connect an MCP server (command, HTTP, or SSE) to add its tools.","editTitle":"Edit server","newTitle":"Add server","deleteConfirm":"Delete?","contextMenuItem":"Tools\u2026","chipRemove":"Remove tools","inUse":"Using tools:","picker":{"title":"Skills & tools"},"mode":{"label":"How this server is used","off":"Off","offTooltip":"Off \u2014 this server is never used or shown in the picker."},"activation":{"auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant loads this server\'s tools on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never loads it on its own \u2014 only when you attach it with / or @."},"transport":{"stdio":"Command (stdio)","http":"HTTP","sse":"SSE"},"auth":{"none":"None","apiKey":"API key","headers":"Custom headers","oauth":"OAuth"},"requireApproval":{"short":"Approve calls","tooltip":"When on, you approve every tool call from this server before it runs."},"oauth":{"connect":"Connect","reconnect":"Reconnect","disconnect":"Disconnect","connecting":"Waiting for browser\u2026","connected":"Connected","notConnected":"Not connected","error":"Authorization failed."},"status":{"error":"Failed","label":"Connection","ok":"Connected","testing":"Connecting\u2026","toolsEnabledOf":"{{enabled}} of {{count}} tools","toolsFound":"{{count}} tools found","unknown":"Not tested"},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. filesystem","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What this server provides and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use it. Be specific.","transportLabel":"Connection type","commandLabel":"Command","argsLabel":"Arguments","argsHelp":"Space-separated arguments passed to the command.","envLabel":"Environment variables","envHelp":"One KEY=value per line.","urlLabel":"Server URL","authLabel":"Authentication","apiKeyHeaderLabel":"Header name","apiKeyPrefixLabel":"Value prefix","apiKeyLabel":"API key","secretSet":"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (stored \u2014 type to replace)","oauthClientIdLabel":"Client ID","oauthClientIdHelp":"Leave blank to auto-register if supported.","oauthClientSecretLabel":"Client secret","oauthScopesLabel":"Scopes","oauthScopesHelp":"Space-separated scopes to request.","oauthDiscoveryLabel":"Discovery URL (optional)","oauthAuthUrlLabel":"Authorization URL","oauthTokenUrlLabel":"Token URL","redirectLabel":"Redirect URI","redirectHelp":"Most servers register automatically \u2014 just leave Client ID blank and click Connect. If the provider asks for a redirect URI, pick the callback type it accepts and register the URI below.","redirectTypeLabel":"Callback type","redirectType":{"appCallback":"Web (https)","localhost":"Localhost"},"redirectPortLabel":"Port","redirectNotes":{"appCallback":"Signing in opens your browser, then hands control back to the Cephable app automatically.","localhost":"Signing in opens your browser and returns to Cephable through this port. It is open only while you sign in, and only on this device."},"headersHelp":"Custom header auth isn\'t editable here yet; use API key or OAuth for authenticated servers.","activationLabel":"When should the assistant use this?","requireApprovalLabel":"Require approval for each tool call","requireApprovalHelp":"When on, you approve every tool call from this server before it runs. Recommended for servers that can change data or spend money.","testConnection":"Test connection","save":"Save changes","create":"Add server","saveError":"Could not save the server.","oauthDiscoveryHelp":"Optional \u2014 leave blank to use the server\u2019s own discovery document.","oauthDiscoveryLabelShort":"Discovery URL","oauthOnDevice":"Each member completes OAuth sign-in on their own device when they enable this connector.","secretsOnDevice":"Each member enters their own API key on their device when they enable this connector \u2014 keys are never stored here.","noPermissions":"This server uses {{provenance}}\'s registered app. Click the button to customize, or Connect to start using.","altOptions":{"copy":"Use my own credentials","organization":"Cephable Portal"},"copyName":"{{name}}-copy"},"actions":"Server actions","marketplace":{"description":"Public connectors shared by the community that match your search.","title":"From the public marketplace"},"share":"Share","shareError":"Something went wrong.","sync":"Sync","tools":{"allToolsLabel":"for all tools","contextLabel":"of context","disableAll":"Disable all","disableSelected":"Disable selected","empty":"No tools yet \u2014 test the connection to discover them.","enableAll":"Enable all","enableSelected":"Enable selected","help":"Turn off tools you don\u2019t need. Fewer tools use less of the assistant\u2019s context window, which keeps it fast and focused.","label":"Tools","searchPlaceholder":"Search tools\u2026","tokens":"~{{tokens}} tok","tokensLabel":"tokens"},"updateAvailable":"An updated version is available.","searchPlaceholder":"Search connectors\u2026"},"menu":{"expand":"Expand menu"},"no":"No","rating":{"review":{"comment":"Comment","commentPlaceholder":"What did you like or dislike? How did you use it?","optional":"(optional)","submit":"Submit review","subtitle":"Share your experience with <strong>{{subject}}</strong>.","title":"Rate & review","write":"Write a review","yourRating":"Your rating"},"summary":{"comments":"comments","installs":"installs","noRatings":"No ratings yet","openReview":"Rate & review","ratingCount":"{{count}} ratings"}},"workflow":{"feedback":{"includeDetails":"Share my prompt and tool names to help diagnose this run","negative":"Thumbs down","placeholder":"Tell us more (optional)","positive":"Thumbs up","question":"How did this workflow go?","report":"Report an issue","send":"Send feedback","thanks":"Thanks for your feedback."}},"yes":"Yes","keyboardService":{"unavailable":{"title":"Keyboard and mouse control stopped","recovering":"Cephable is restarting it. Your commands will work again in a moment.","stalled":"Cephable could not restart it. Try your command again, or restart Cephable if it keeps failing.","permissionTitle":"Cephable cannot control this app","permission":"Grant Cephable access under System Settings > Privacy & Security > {{pane}}, then try your command again.","permissionWindows":"Windows blocks apps from controlling programs that run as an administrator. Close and reopen Cephable as an administrator, or reopen the other app without administrator rights. Windows security prompts and the lock screen can never be controlled. On a work device, your IT administrator may be blocking this."},"restored":"Keyboard and mouse control is working again."},"macPermissions":{"openSettings":"Open Settings","pane":{"accessibility":"Accessibility","deviceControl":"Device Control and Data Access","inputMonitoring":"Input Monitoring","filesAndFolders":"Files & Folders","fullDiskAccess":"Full Disk Access","camera":"Camera","microphone":"Microphone","screenRecording":"Screen Recording"}},"backgroundCapture":{"title":"Background Content","capturing":"Storing content in the background...","tooltip":"Content that couldn\'t be typed and is stored for the current session. It will disappear when you quit Cephable.","nothingToPaste":"There is no background content to paste.","pasteNotPermitted":"Unable to paste. Action not permitted due to the current focus.","pasteFailed":"Unable to paste background content."}}');


var $7cbcf568110a7c9e$exports = {};
$7cbcf568110a7c9e$exports = JSON.parse("{\"404\":\"Oh noes! We have searched the sea and we can't find thee page!\",\"appError\":{\"title\":\"Something went wrong\",\"description\":\"The app ran into an unexpected problem. Try reloading, or head back to your workspace. If this keeps happening, please contact support.\",\"home\":\"Back to Workspace\"}}");


var $2db1ccc6f838feb6$exports = {};
$2db1ccc6f838feb6$exports = JSON.parse('{"redo":"Redo Onboarding","title":"Meet Cephable","description":"Meet Cephable, your personal AI assistant and share your interest for personalized use cases.","congrats":"Congrats!","customControls":{"tourLabel":"Always Available Global & Device Controls","rowDescription":"Global and device controls are always available if your microphone is on, no matter what app you are using. You can use these controls to interact with your device without having to create new app controls. They contain helpful commands like swapping controls or apps, generating text, pausing your microphone and more."},"controlExpanded":{"tourLabel":"Control","description":"App controls are configured sets of controls that you can use on a desired application. This section shows you all the available controls you can use through voice commands, tapping, typing, and more."},"profile":{"switch":{"title":"Switch App Controls","description":"Your app controls can switch automatically based on the app you are using, or you can change them manually here anytime."}},"stopListening":{"title":"Try saying `Stop Listening`","description":"This pauses your microphone without turning it off completely. Say `Start Listening` again whenever you are ready."},"dictation":{"tourLabel":"Dictation","learn":"Learn how to use dictation mode to convert your speech to text hands-free.","welcome":{"title":"Dictation","description":"Dictation lets you speak naturally and have your words typed while you talk. It\'s like having a personal assistant who types everything you say."},"microphone":{"title":"Turn on Your Microphone","description":"First, turn on your microphone. Click the Microphone Toggle on the Cephable Panel."},"activate":{"title":"Start Dictation Mode","description":"Voice starts in command mode. To start dictation, say \\"Start dictation\\" or click the Dictation button. Lets turn on dictation mode now."},"focus":{"title":"Focus on a Text Field or Document","description":"Dictation works best when you focus on a text field or document. Click on a text field or document where you want to dictate."},"speaking":{"title":"Start Speaking","description":"Now you can start speaking. Everything you say will be typed in the text field or document you focused on. Try saying something like \\"Hello, this is a test of dictation mode.\\""},"pauseResume":{"title":"Pausing Dictation","description":"Need a break without turning off dictation? Just say \\"Stop Listening\\". You can resume anytime with \\"Start dictation.\\" again. You can customize this further with your always on global and device controls."},"stop":{"title":"Stopping Dictation","description":"Need to switch back to your app controls?  Just say \\"Stop dictation\\". This will stop dictation mode and return you to command mode. You can resume anytime with \\"Start dictation.\\" again."},"complete":{"description":"That\'s it! You can now dictate, pause, resume, and swap between dictation and command modes. Dictation is a powerful tool for hands-free typing. Use it to write emails, documents, or anything else you need to type out loud."}},"editingVideos":{"tourLabel":"Focus on the Story, Not the Tedious Clicks for Video Editing","learn":"Learn how to use voice controls and dictation to edit videos faster, and remove the cognitive load of remembering which buttons to click while editing.","tryOpen":{"title":"Try saying `Open CapCut` or `Open iMovie`."},"complete":{"description":"You now know how to use voice commands and quick actions to play, pause, skip tracks, and adjust volume in your favorite video editing apps. Try exploring more commands or customizing your own quick actions for even smoother video control."}},"fpsGamePlay":{"tourLabel":"Play FPS Games with Voice Controls","learn":"Learn how to use voice controls and quick actions to play FPS games.","tryOpen":{"title":"Try saying `Open Valorant` or `Open Battlefield`"},"complete":{"description":"You now know how to use voice commands and quick actions to move, stop, and control your character in FPS games. Try exploring more commands or customizing your own quick actions for even smoother and faster gameplay."}},"extensions":{"tourLabel":"Extensions","rowDescription":"Extend Cephable with more ways to control your device \u2014 like Camera Controls for face and head movement, or gamepad support. Turn on the ones you need here."},"microphone":{"tourLabel":"Voice Controls","learn":"Learn how you can use your voice to control any app and use dictation to type what you say.","rowDescription":"When the microphone is off, we will not listen to your voice commands at all but if you turn it on, you will be able to use global commands to toggle pause, start, and more. Let\'s turn it on.","tryOpen":{"title":"Try saying `Open Spotify` or `Open Word`"},"finishedCommands":{"title":"Excellent! You\'ve learned the basics of Voice Controls.","description":"You can always revisit the tour from the Support Page. The next step is to learn about Dictation. You can start the tour from the support page."}},"smartTasks":{"generate":{"focusApp":{"title":"Focus on the App","description":"Make sure you are focused on the app where you want the generated text to appear. You will be able to seamlessly generate text into that location when you click Generate."}},"rewrite":{"focusApp":{"title":"Focus on the App","description":"Make sure you are focused on the app where you want the rewritten text to appear. You will be able to seamlessly generate text into that location when you click Generate."}}},"tour":{"startTour":"Start Tour","finishTour":"Finish Tour","statusDialog":"Please check the panel for more information.","step":"Step {{step}} of {{total}}","skipTour":"Skip Tour"},"support":{"title":"Support","description":"You can visit our support hub for more information on how to use Cephable, including more tours, step-by-step guides, tutorials, and videos."},"onboarding":{"overview":"Overview","learn":"Learn about the features of Cephable and how to use them.","start":"Looks like you are just getting started. Here are some areas that will help you along the way.","dashboard":{"title":"Cephable Workspace","description":"The Cephable Workspace is your central hub for managing your device, app controls, and settings. From here, you can customize your experience, view active commands, and access all the features of Cephable."},"step1":{"title":"Welcome to Cephable","description":"Cephable is your personal AI \u2014 built for fast actions, voice commands, content generation, and smart automation across your tools. Out-of-the-box controls. No cloud processing. Just productivity that moves with you."},"finish":{"continueToApp":"Continue to Cephable Dashboard","keepExploring":"Keep Exploring"},"useCaseSlider":{"context":"I\'d like to use","control":"to control"}},"panel":{"description":"This is the panel which is the main control center. It is always visible and allows you to control your apps using your voice, and more. Let\'s start with the microphone."},"submit":{"title":"Submit","description":"The content will be outputted to where your cursor focus is."},"tryOpen":{"description":"`Open` is a global command that will open the app you specify and send focus to it. If you have automatic control switching enabled, it will also switch to the app controls that best match the app you are using."},"modeSelector":{"title":"Select Mode","description":"If available, you can select the mode in which I will operate. Use Control for the app you want to send commands through, Create for generative text content like summarize, rewrite, translate. Select Automate for desktop or cross-app flows."},"contextSelector":{"title":"Select Context","description":"If available, you can select the context in which I will operate. For example, I can use your clipboard or highlighted text, and you can also attach files or folders you would like me to work with."},"panelInput":{"title":"What do you want me to do?","description":"You can command, type, or dictate what you would like me to do."},"figma":{"tourLabel":"Voice Commands for Figma and Canva","learn":"Learn how to use Controls voice controls, voice mouse, dictation, and AI content generation to improve your design workflow.","tryOpen":{"title":"Try saying `Open Figma` or `Open Canva`"},"complete":{"description":"You now know how to Control and Create designs to enhance your workflow. Try exploring more commands for even smoother design control."}},"voiceMouse":{"title":"Voice Mouse","description":"For clicking buttons by name, you can use Voice Mouse. This can be used by saying `tap save` or `go to settings`."},"documentSummary":{"tourLabel":"Draft Team Summaries from Confidential Reports","learn":"Automate reading through department reports, identify the right people to inform, and draft an email \u2014 entirely on-device, so your confidential data stays private.","congrats":{"description":"You now know how to use AI Workflows to read through confidential documents and draft a summary email to your team \u2014 all without your data leaving your device."}},"developerBuildTests":{"tourLabel":"Automate Builds and Tests with AI Workflows","learn":"Cephable can run multi-step terminal tasks \u2014 like building your project and running its tests \u2014 entirely on-device, in the background, while you keep working.","complete":{"description":"You now know how to run on-device AI Workflows for multi-step build-and-test tasks, respond to permission requests, and keep iterating on the results. Try automating another repetitive dev task."}},"classroomStudyTools":{"tourLabel":"Turn Classroom Notes and Articles into Study Tools and Teaching Materials","learn":"Cephable supports teachers and students with dictation, on-device Create tools, and Automate \u2014 right in the apps you already use, keeping everything private and on your device.","complete":{"description":"You now know how to dictate directly into your documents, generate new study materials from your notes, and use Automate to create full assignments in the background \u2014 all on-device."}},"engineeringFlows":{"tourLabel":"Voice Controls + AI Automations for Developers","learn":"Learn how to speed up your engineering workflow with voice-controlled dev commands, AI Rewrite using your own code as context, and background AI Workflows \u2014 all running on-device.","tryOpen":{"title":"Try saying `Open Visual Studio Code`"},"complete":{"description":"You now know how to use voice-controlled dev commands, AI Rewrite with your own code as context, and background AI Workflows to speed up your engineering flow."}},"meetingNotesToFiles":{"tourLabel":"Turn Meeting Notes into Actionable Files","learn":"Cephable can break your meeting notes into smaller, actionable files you can work through at your own pace \u2014 entirely on-device.","complete":{"description":"You now know how to use AI Workflows to break meeting notes into smaller actionable files and pick the conversation back up anytime from AI History."}},"notesToPresentation":{"tourLabel":"Summarize Confidential Notes and Build a Presentation, All On-Device","learn":"Cephable can summarize your confidential reports and notes, then use AI Workflows to do it across a whole folder of files \u2014 and even build a presentation from the results. All of it runs on-device.","complete":{"description":"You now know how to summarize confidential documents, batch-summarize a whole folder with AI Workflows, and turn the results into a presentation \u2014 all without your data leaving your device."}},"organizeDownloads":{"tourLabel":"Organize Files, Clean Up, and Find What You Lost \u2014 with AI Workflows","learn":"Automate can handle multi-step file management tasks \u2014 copying, deleting, and finding files \u2014 right from a simple prompt.","complete":{"description":"You now know how to use AI Workflows to organize files, safely clean up with permission checks, and find files you can\'t remember the location of."}},"outlookEmailProductivity":{"tourLabel":"Speed Up Email in Outlook with Dictation, Quick Actions, and AI","learn":"Cephable Plus and Professional include intelligent Dictation and Create tools for generating and editing content \u2014 use them right inside Outlook to reply and draft emails faster.","complete":{"description":"You now know how to reply to emails with dictation, use your own Quick Type actions, and use Summarize and Generate to draft and refine email content \u2014 all on-device."}},"customizingGameControls":{"tourLabel":"Play RPG Games with Voice Controls","learn":"Learn how to use voice controls and quick actions to play RPG games.","tryOpen":{"title":"Try saying `Open Minecraft`"},"complete":{"description":"You now know how to use voice commands and quick actions to move, stop, and control your character in RPG games. Try exploring more commands or customizing your own quick actions for even smoother and faster gameplay."}},"voiceToTextSocialMedia":{"tourLabel":"Voice to Text for LinkedIn, Slack, and Discord","learn":"Use Intelligent Dictation to speak a post naturally, then Rewrite to adjust its tone \u2014 works the same way across LinkedIn, Slack, Discord, and more.","complete":{"description":"You now know how to dictate a post and refine it with Rewrite \u2014 across LinkedIn, Slack, Discord, and more."}},"aiDocumentTranslation":{"tourLabel":"Translate Documents Into Any Language, On-Device","learn":"Cephable can translate a document into one language at a time, or use AI Workflows to translate it into several languages at once \u2014 all running locally.","complete":{"description":"You now know how to translate a document into a single language with dictation, or into several languages at once with AI Workflows \u2014 all on-device."}},"excelAiAutomation":{"tourLabel":"Analyze Spreadsheets with Private, On-Device AI","learn":"Cephable can read through your Excel files, answer questions about the numbers, and keep going deeper \u2014 all without your data leaving your device.","complete":{"description":"You now know how to use AI Workflows to question your spreadsheets, dig deeper with follow-ups, and save a summary \u2014 all running on-device."}},"handsFreeComputerControl":{"tourLabel":"Control Your Computer with Voice and Camera","learn":"Cephable lets you control your computer hands-free using voice commands, Voice Mouse, and camera-based head and face controls.","tryOpenWord":{"title":"Try Saying `Open Word`"},"openExtensions":{"title":"Open the Extensions Tab","description":"To turn on camera controls, open the Extensions tab in the main window."},"turnOnCamera":{"title":"Turn on Camera Controls","description":"Toggle Camera on. A camera icon appears next to your microphone icon, and a new Camera section appears under Settings."},"cameraInPanel":{"title":"Camera Controls in Your Panel","description":"Now that Camera Controls is on, the camera toggle appears in your Cephable panel too \u2014 Cephable turns it on for you here."},"openCameraSettings":{"title":"Open Camera Settings","description":"Open Camera Settings to fine-tune how head and face controls work for you."},"chooseHeadMouseMode":{"title":"Choose a Head-Mouse Mode","description":"Pick how head movement controls your mouse: Steady Glide, Speed Boost, or Dynamic Glide."},"complete":{"description":"You now know how to control your computer with voice, Voice Mouse, and camera-based head and face commands. Explore Camera Settings further to build controls that fit you."}},"handsFreeTypingDocumentCreation":{"tourLabel":"Create and Edit Documents Hands-Free","learn":"Use Generate, Rewrite, and voice controls together to create and edit a document \u2014 like an invoice \u2014 almost entirely hands-free.","complete":{"description":"You now know how to generate, rewrite, and edit a document almost entirely hands-free using Generate, Rewrite, and voice commands."}},"webResearchCreateHtml":{"tourLabel":"Research the Web and Build a Site from It \u2014 All On-Device","learn":"Cephable can browse and analyze competitor websites, then use what it finds to generate a new HTML site for you \u2014 entirely on-device, so your research stays private.","complete":{"description":"You now know how to use AI Workflows to research competitor websites and generate a new HTML site from the findings \u2014 all without your data leaving your device."}},"webResearchSummarize":{"tourLabel":"Research Regulations and Summarize the Findings \u2014 All On-Device","learn":"Cephable can browse the web to research changes like new data protection laws, then summarize what it found into something your team can act on \u2014 entirely on-device, so your research stays private.","complete":{"description":"You now know how to use AI Workflows to research regulatory changes, dig deeper into implementation, and draft the findings as an email your team can iterate on \u2014 all without your data leaving your device."}}}');


var $f2a7e1c8dd4452db$exports = {};
$f2a7e1c8dd4452db$exports = JSON.parse('{"introduction":{"title":"Hi, I\'m Cephable.","back":"Back to introduction","description":"I\'m your personal AI to help you control, create, and automate using the tools you already love \u2014 across all your connections. There are a few things you should know about me.","action":"Let\'s get started!","recording":{"title":"Your voice and video stay local.","description":"I never record, stream, or send your audio or video to the cloud. All inputs are processed on-device \u2014 privately and securely."},"data":{"title":"Your data is yours.","description":"I don\'t use your commands or activity to train models for others. Everything stays private \u2014 and your app controls move with you across connections."},"offline":{"title":"I work when other tools don\'t.","description":"Intelligent Tasks like generating content, rewriting, translating, and dictation all run locally. No cloud required. That means I work even when you\'re offline \u2014 and your data doesn\'t leave your device."},"empower":{"title":"Built to empower, not exploit.","description":"I am designed to enhance your control \u2014 not monitor it. No invasive tracking. No creepy data collection. Just input that works for you."}},"my-capabilities":{"title":"Perfect! Here\'s how I can help.","back":"Back to capabilities","actionTitle":"See Me In Action","basedOnInterests":"Based on your interests","description":"Here are the features and capabilities most relevant to your workflow \u2014 organized across the three things Cephable does.","action":{"title":"See Me In Action","description":"Explore some examples of how I can assist you in your daily tasks."},"cta":{"eyebrow":"Ready when you are","title":"See it work in your apps"}},"upgrade":{"pill":"{{license}} Unlocked","title":"You\'ve been upgraded to {{license}}.","subtitle":{"trial":"For the next {{days}} days, my AI features are unlocked \u2014 Create and Automate, both running on one on-device model. Turn them on whenever you\'re ready.","org":"You\'ve been added to {{organization}} organization which unlocks my AI features \u2014 Create and Automate, both running on one on-device model. Turn them on whenever you\'re ready.","orgGeneric":"Your organization has unlocked my AI features \u2014 Create and Automate, both running on one on-device model. Turn them on whenever you\'re ready."},"badge":{"trial":"Trial ends in","trialDays_one":"{{count}} day","trialDays_other":"{{count}} days","org":"Unlocked by","orgGeneric":"Organization license"},"setup":{"eyebrow":"Set up your Pro features","title":"Choose what to turn on","description":"You can change any of this later in Settings. Everything runs on-device \u2014 your words and files stay with you."},"enable":{"title":"Enable AI features","description":"One switch turns on both Create and Automate. They run on the shared on-device model \u2014 no separate setup for each.","model":{"label":"On-device AI model","tag":"Shared engine","description":"Powers both Create and Automate. Larger models produce better results but use more resources \u2014 it downloads and runs entirely on this device."}},"create":{"title":"Create","description":"Intelligent text generation & dictation. I\'ll draft emails, documents, code, and creative content \u2014 and turn your speech into formatted text in any app.","locked":"Enable AI features above and Create is ready to use."},"automate":{"title":"Automate","description":"AI Workflows. Describe a task in one sentence and I\'ll plan and carry out every step \u2014 reading, writing, and running commands on your behalf.","locked":"Enable AI features above and Automate is ready to use."},"status":{"on":"On","off":"Won\'t run"},"footer":"Everything runs on-device. Nothing you create or automate leaves your machine.","cta":{"eyebrow":"You can enable AI anytime","title":"Let\'s see it work in your apps","action":"See Me In Action","back":"Back"}},"see-me":{"title":"Want to see how I\'ve helped others like you?","back":"Back to use cases","description":"Check out some real-world examples of how I\'ve transformed workflows across different industries and roles."},"complete":{"title":"Ready to Start Using Me?","description":"You\'ve seen what I can do! Now let\'s get you set up and start transforming your workflow. I\'ll be here to help you every step of the way.","action":"Complete Setup & Start Using Cephable"},"apps":{"eyebrow":"200+ Apps, Zero Setup","title":"I Support the Tools You Already Love","description":"With pre-configured support for 200+ applications \u2014 I work with the software you use every day. No setup required.","note":"Don\'t see an app you use? No problem \u2014 I can generate controls or help you create custom workflows that work for you.","andMore":"And More"},"actions":{"ctaTry":"Try it now","ctaWatch":"Watch demo","apps":"I am Compatible with:","abilities":"My abilities used:"},"interests":{"title":"What can I help you with?","back":"Back to interests","description":"I can control apps on your desktop and connected devices. Let\'s personalize your experience - what areas interest you most? ","note":"Select all that apply and I\'ll show you the most relevant features and examples for your workflow.","action":"Continue with {{count}} interests","empty":"Select at least one interest.","filter":"Filter by Interests Type","create_design":{"label":"Create & Design","shortLabel":"Design","description":"For artists, marketers, and content creators."},"analyze_report":{"label":"Analyze & Report","shortLabel":"Analyze","description":"For analysts, researchers, and business professionals."},"communicate_collaborate":{"label":"Communicate & Collaborate","shortLabel":"Communicate","description":"For sellers, meetings, and remote teams."},"build_develop":{"label":"Build & Develop","shortLabel":"Develop","description":"For developers, engineers, and technical professionals."},"game_play":{"label":"Game & Play","shortLabel":"Gaming","description":"For gamers, streamers, and media controls."},"learn_teach":{"label":"Learn & Teach","shortLabel":"Learning","description":"For educators, students, and instruction."},"manage_organize":{"label":"Manage & Organize","shortLabel":"Organizing","description":"For project managers, coordinators, and organizers."},"adapt_access":{"label":"Adapt & Access","shortLabel":"Accessibility","description":"For adaptive controls and personalized accessibility needs."},"everything":{"label":"A little bit of everything","shortLabel":"Everything","description":"For general computer users and multi-taskers."}},"control":{"title":"Control.","titleAlt":"Control","subtitle":"Your software. Your inputs. Your rules.","description":"Voice commands, keyboard shortcuts, and quick action buttons \u2014 working across every app on your device. No mouse required. No scripting. No setup for 100\'s of apps you already use."},"create":{"title":"Create.","titleAlt":"Create","subtitle":"Your words. Your drafts. Your machine.","description":"Draft, rewrite, reformat, and translate \u2014 right inside the app you\u2019re working in. No cloud. No copy-paste into another tool. No drafts training someone else\u2019s model."},"automate":{"title":"Automate.","titleAlt":"Automate","subtitle":"One sentence. Every step. Done.","description":"Describe a job in plain language and Cephable carries it out. Across your apps, your files, even your command line. It runs while you do something else, and nothing leaves your machine."},"capabilities":{"title":"My Core AI Capabilities","description":"I combine advanced AI with powerful input methods to give you seamless control over your apps and devices. Here are some of the things I can do.","voice_controls":{"title":"Voice Controls","description":"I understand natural language commands so you can control any app with your voice.","longDescription":"I let you speak naturally and still get things done. Whether you want to open apps, navigate menus, or trigger workflows, I translate plain English into hands-free and reliable actions."},"smart_dictation":{"title":"Intelligent Dictation","description":"I convert your speech to text with context awareness and formatting.","longDescription":"I listen carefully and capture your words accurately. I add punctuation, fix capitalization, and apply context-aware formatting, so your writing looks polished without extra effort."},"ai_text_generation":{"title":"AI Text Generation","description":"I can create emails, documents, code, and creative content on the fly.","longDescription":"I help you draft, summarize, or expand on anything directly in your apps. From emails and notes to code snippets and documents, I make sure you never start from a blank page."},"head_face_controls":{"title":"Head & Face Controls","description":"I let you trigger actions with your head and facial movements.","longDescription":"I translate your natural head movements and expressions into precise input. You can send an email with a smile, turn a page with a nod, or click with a raise of the eyebrows."},"natural_language_voice_clicking":{"title":"Natural Language Voice Clicking","description":"I let you say what you see to click buttons, links, and menus on screen.","longDescription":"When you speak the name of something on your screen, I find it and interact with it for you. No memorized commands \u2014 just describe what you want and I\u2019ll handle the click."},"keyboard_mouse_emulation":{"title":"Keyboard & Mouse Emulation","description":"I emulate keys, clicks, and scrolling so you can control apps without hardware.","longDescription":"I send keystrokes, mouse movements, clicks, and scroll events anywhere you need them. Combine me with voice or head controls to fully replace or enhance traditional input devices."},"profiles_personalization":{"title":"Personalization","description":"I remember your preferences and adapt with saved app controls.","longDescription":"I keep track of your favorite apps, commands, and preferences. Switch between app controls automatically or manually, and I\u2019ll always show the right controls for what you\u2019re doing."},"cross_device_connectivity":{"title":"Cross-Device Connectivity","description":"I let you use your phone to start an automation remotely.","longDescription":"I connect your mobile device to your desktop so you can launch commands, dictate, or navigate with ease. Perfect for presentations, remote sessions, or casual use."},"quick_action_buttons":{"title":"Quick Action Buttons","description":"I give you app-aware buttons for fast actions.","longDescription":"I surface context-sensitive buttons that adapt to your app. Whether it\u2019s joining a meeting, sending a message, or creating a new email, I make complex tasks just one click away."},"background_creation":{"title":"Background Creation","description":"I create and edit content in the background while you work.","longDescription":"I create and edit content in the background while you focus on your work. When you need it, the content is ready for you in your file system without any interruption to your workflow or having to copy."},"ai_app_awareness":{"title":"AI App Awareness","description":"I adjust my controls based on the app you\u2019re using.","longDescription":"I pay attention to what\u2019s active on your screen so I can give you the right controls at the right time. No clutter, no guesswork\u2014just what you need, when you need it. All on your device and without sending data to the cloud."},"ai_rewrite":{"title":"AI Rewrite","description":"I can rewrite your text to improve tone, update formatting, or expand on details.","longDescription":"I edit text right where you\u2019re working. I can make it friendlier, more formal, shorter, longer, or more detailed \u2014 whatever you need to get your point across better."},"ai_summary":{"title":"AI Summary","description":"Gather insights from long text and create short summaries or key takeaways."},"ai_translation":{"title":"AI Translation","description":"I can translate between languages or even programming languages.","longDescription":"I let you turn text into another spoken language or convert code into another programming language. I work in place, so you don\u2019t have to leave the app you\u2019re using."},"head_mouse":{"title":"Head Mouse","description":"I let you move your mouse cursor with head movements.","longDescription":"I smoothly translate your head motion into cursor motion. With features like glide and sensitivity tuning, I give you precise, comfortable, hands-free control."},"head_joystick":{"title":"Head Joystick","description":"I let you use your head as a joystick for games or apps.","longDescription":"I map your head movements onto joystick axes so you can play games or control creative software without hardware. You move naturally, and I translate it into analog input."},"mcp_agent":{"title":"MCP Agent","description":"I can connect with external AI agents through the Model Context Protocol (MCP).","longDescription":"I speak the Model Context Protocol, which lets me work alongside other AI agents and tools. That means I can coordinate tasks, exchange context, and extend my abilities with specialized external systems \u2014 all while keeping you in control."},"byo_ai_integration":{"title":"Bring Your Own AI","description":"I let you enhance my existing AI with your own AI models or services to use with me.","longDescription":"If you already have an AI service, model, or provider you trust, I can integrate it into my workflow. I give you the flexibility to choose the engine that powers generation, rewriting, or translation\u2014whether it\u2019s cloud, local, or custom. When you are offline or if the service is unavailable, I can fall back to my built-in capabilities."},"workflows":{"title":"Workflows","description":"I help you chain together actions into repeatable workflows.","longDescription":"I let you design and run multi-step processes that connect different inputs, commands, and outputs. With workflows, you can automate routine tasks or create complex interactions\u2014triggered by your voice, or gestures \u2014 so I do the heavy lifting for you."},"showMore":"Show More","showLess":"Show Less"},"listing":{"title":"Use Cases","titleLong":"Explore How I Can Help You","recommended":"Recommended For You","exploreMore":"Explore More Use Cases","description":"Discover everything I can do to enhance your workflow. From productivity boosts to creative assistance, find the perfect use cases tailored to your needs.","all":"All","search":"Search use cases, apps, or capabilities...","noResults":"No results found. Try adjusting your search or filters.","emptyAction":"View More Online"},"examples":{"universalAppControl":{"title":"Universal App Control","description":"Control any application on your computer with voice commands and smart automation","descriptionLong":"Take control of any application with powerful voice commands and intelligent automation. Our Universal App Control system learns how you work and adapts to your needs, making complex tasks simple and routine actions instant. From managing your productivity suite to controlling media and gaming applications, this feature works across your entire digital environment."},"editingVideos":{"title":"Voice Editing in CapCut \u2014 Navigate Timelines, Cut Clips, and Stay in the Story","description":"Edit video using voice controls and dictation, so you can cut and arrange clips hands-free.","descriptionLong":"Move through your timeline, trim and split clips, and shape your edit using just your voice. Stay focused on the story without clicking through menus or reaching for the mouse."},"figma":{"title":"Voice Commands for Figma and Canva \u2014 Control Layers, Switch Tools, and Type Copy Hands-Free","description":"Edit images and designs using voice controls and smart dictation, for faster iterations.","descriptionLong":"Bring your visual ideas to life with voice controlled image editing. Navigate faster, and iterate on designs without having to click through complex menus."},"documentSummary":{"title":"Private AI Desktop Agent That Reads Your Documents, Writes the Summary, and Sends It to Your Team","description":"Use a private desktop agent to read documents, draft summaries, and share them with your team hands-free.","descriptionLong":"Point your AI agent at a document and let it do the reading, summarizing, and sending for you. Keep everything running locally and private while you move through your work without lifting a finger."},"excelAnalysis":{"title":"Work Faster and Analyze in Excel with Private and Local AI Automation","description":"Analyze spreadsheets and surface trends using private, local AI automation, hands-free.","descriptionLong":"Research trends across a folder or document, ask questions against financial reports, and build toward a final summary. Let local AI handle the analysis while keeping your data private on your own machine."},"emailAutomation":{"title":"Automate Your Email \u2014 Local AI Workflows that Read Your Inbox, Draft Replies, and More!","description":"Read your inbox, draft replies, and build templates using local AI workflows and dictation.","descriptionLong":"Draft an email summarizing an article and call out the key technical details, or create reusable templates to move through your inbox faster. Let local AI and dictation handle the reading and writing while keeping everything private."},"powerpointBuilder":{"title":"AI Workflows That Turn Your Notes and Docs into a Finished PowerPoint | Ai Powerpoint Builder","description":"Turn notes, docs, and spreadsheets into a finished PowerPoint using AI workflows, hands-free.","descriptionLong":"Analyze an Excel document to find key losses, then let AI shape your notes and data into a polished presentation. Build slide decks faster without clicking through menus or starting from a blank page."},"socialDictation":{"title":"Voice to text for LinkedIn, Slack, and Discord | Post and Reply Without Typing","description":"Post and reply on LinkedIn, Slack, and Discord using voice to text, no typing required.","descriptionLong":"Draft posts, fire off replies, and stay active across LinkedIn, Slack, and Discord using just your voice. Keep the conversation going without reaching for the keyboard."},"developerTools":{"title":"Voice Controls + AI Automations for Developers | Write Comments, Docs, and Commit Messages","description":"Write comments, docs, and commit messages using voice controls and AI automations, hands-free.","descriptionLong":"Ask how to make the code in a project folder cleaner, then dictate comments, documentation, and commit messages without typing. Stay in flow while voice controls and AI automations handle the busywork."},"terminalAgent":{"title":"AI Desktop Agent | Run Terminal Builds and Tests in the Background While You Keep Coding","description":"Run builds, tests, and debugging in the background with an AI desktop agent while you keep coding.","descriptionLong":"Have your agent review a project folder, build it, confirm it compiles, and run test cases. If something breaks, it digs through git history to find the cause and suggests a fix, all while you stay focused on your work."},"gamingFPS":{"title":"Voice Controls for FPS and Valorant and more | Aim, Shoot, Reload, and Switch Weapons Hands-Free","description":"Aim, shoot, reload, and switch weapons in FPS games like Valorant using voice controls, hands-free.","descriptionLong":"Call out commands to shoot, reload, and swap weapons while you play FPS titles like Valorant. Add voice control to your setup and keep the action going without relying on every key and button."},"gamingRPG":{"title":"Customize RPG Game Controls for Minecraft | Adaptive Controls for Video Games","description":"Customize and adapt game controls for Minecraft and other RPGs to fit how you play.","descriptionLong":"Set up adaptive controls for Minecraft and other RPG-style games, mapping actions to suit your needs. Build a control scheme that fits how you play instead of forcing your hands to fit the game."},"educationTools":{"title":"Transform Classroom Notes and Articles into Creative Study Tools or Teaching Materials Using On Device AI","description":"Turn notes and articles into study tools and teaching materials using on-device AI, hands-free.","descriptionLong":"Take an article and create a Word document with reflection questions tailored to a student\'s grade level to support a creative writing assignment. Let on-device AI shape your source material into ready-to-use teaching resources while keeping everything private."},"meetingNotes":{"title":"AI Automations that Turn Meeting Notes into Smaller Files","description":"Turn meeting notes into organized, actionable files using AI automations, hands-free.","descriptionLong":"Read your meeting notes to surface what\'s left to do, who\'s responsible, and where the gaps are. Let AI outline these as separate files and organize them into a folder so you can review everything later."},"fileManagement":{"title":"On Device AI Desktop Agent | Organize Your Downloads, Find Files, and Clean Up Your PC","description":"Organize downloads, find files, and clean up your PC with an on-device AI desktop agent, hands-free.","descriptionLong":"Ask your agent to copy files from downloads into your product documentation directory, or have it find files and tidy up your PC. Keep your machine organized with on-device AI that keeps your data private."},"dictationWriting":{"title":"Hands-Free Typing and Document Creation \u2014 Voice Dictation, AI Generation, and Rewrite on Any App","description":"Type, generate, and rewrite documents hands-free using voice dictation and AI in any app.","descriptionLong":"Dictate text, generate new content, and rewrite what you\'ve written across any app using just your voice. Create documents from start to finish without touching the keyboard."},"headMouseControl":{"title":"Hands-Free Computer Control with Head Mouse, Talk to Tap | Adaptive Computer Controls","description":"Control your computer hands-free using head tracking and Talk to Tap adaptive controls.","descriptionLong":"Move the cursor with head tracking and click using Talk to Tap to navigate your computer entirely hands-free. Set up adaptive controls that let you work the way that fits you best."},"documentTranslation":{"title":"AI Document Translation for Anyone Working Across Languages \u2014 Spanish, Arabic, Portuguese and More","description":"Translate documents across languages like Spanish, Arabic, and Portuguese using AI, hands-free.","descriptionLong":"Translate your documents into Spanish, Arabic, Portuguese, and more with on-device AI. Work confidently across languages without switching tools or copying text between apps."},"websiteRedesign":{"title":"Private AI Web Research + Automations | Browse, Analyze, and Create HTML","description":"Research competitors and get suggestions for redesigning a website using AI, hands-free.","descriptionLong":"Point AI at the SafeDrive Auto Insurance website, then have it research competitors\' sites to spot the differences. Get concrete suggestions for modernizing an outdated site based on real market research."},"dataPrivacyResearch":{"title":"Browse, Analyze, and Summarize Without Your Data Leaving Your Device | Private AI Web Research ","description":"Research the latest data privacy laws and turn findings into compliance follow-ups, hands-free.","descriptionLong":"Research the most recent 2026 data privacy laws and how they differ from 2025, then surface what companies need to implement. Have AI draft a follow-up email with examples to help you meet compliance."}}}');


var $2e86342825d3cea0$exports = {};
$2e86342825d3cea0$exports = JSON.parse('{"logo":"logo Cephable","add":"Agregar","all":"Todo","edit":"Editar","create":"Crear","delete":"Borrar","next":"Pr\xf3ximo","previous":"Anterior","search":"Buscar","loading":"Cargando...","reload":"Recargar","cancel":"Cancelar","copy":"Copiar","save":"Listo","saveAndFinish":"Guardar y Finalizar","saveAndContinue":"Guardar y Continuar","saved":"Salvado","done":"Hecho","back":"Atr\xe1s","play":"Jugar","pause":"Pausa","success":"\xc9xito","continue":"Continuar","options":"Opciones","share":"Compartir","finish":"Finalizar","finishEdit":"Lo termin\xe9","advancedOptions":"Ver Opciones Avanzadas","authenticating":"Autenticando...","skip":"Omitir","close":"Cerca","notFound":"P\xe1gina no encontrada","notFoundDescription":"\xa1Oh, no! \xa1Hemos buscado por el mar y no encontramos tu p\xe1gina!","exitSetup":"Salir de la configuraci\xf3n","experimental":"Experimental","letGetStarted":"\xa1Empecemos!","exploreInputControls":"Explorar los controles de entrada","when":"Cuando yo ...","thenMacro":"Cephable ejecutar\xe1...","controls":"Los Controles","welcome":"Bienvenido.","beta":"beta","macroEmpty":"No hay macros que igualan con este criterio.","you":"T\xfa","step":"Paso","steps":"Pasos","learnMore":"Aprende M\xe1s","dangerZone":"Zona Peligrosa","connected":"Conectado","notConnected":"No conectado","connectAndLearn":"Con\xe9ctate y Aprende","tryAgain":"Probar otra vez","by":"Por {{value}}","noName":"- sin nombre -","details":"Detalles","controlFeed":"Controlar la alimentaci\xf3n","wifi":{"disconnected":"El wifi est\xe1 desconectado.","connected":"Wi-Fi est\xe1 conectado.","description":"Con\xe9ctese a una red Wi-Fi para que Cephable funcione con sus conexiones y software. Es posible que tenga limitaciones para usar sus controles actuales."},"signalR":{"disconnected":"La sincronizaci\xf3n est\xe1 desconectada.","action":"Reconectar","description":"Parece haber un problema con la sincronizaci\xf3n de Cephable. Esto causar\xe1 problemas al guardar la configuraci\xf3n o comunicarse con otras conexiones.","disconnectedDevice":"No se puede sincronizar con {{name}}.","disconnectedDeviceDescription":"Parece haber un problema con la sincronizaci\xf3n, ya sea por autenticaci\xf3n o por conexi\xf3n a internet. No se pueden enviar ni recibir datos de forma remota. Debe verificar ambos lados de la conexi\xf3n.","connected":"La sincronizaci\xf3n est\xe1 conectada.","connectedDescription":"Cephable se sincroniza correctamente y deber\xeda comunicarse con sus conexiones y extensiones como se espera.","swap":"Cambiar a la conexi\xf3n del dispositivo local","unlinkedDevice":"Conexi\xf3n eliminada.","unlinkedDeviceDescription":"Esta conexi\xf3n ha sido desvinculada de su cuenta.","featureRestricted":"Las funciones Crear y Automatizar no est\xe1n disponibles para conexiones remotas.","featureRestrictedDescription":"Esta funci\xf3n no est\xe1 disponible actualmente para conexiones remotas. Cambie a la conexi\xf3n del dispositivo local para aprovechar al m\xe1ximo las herramientas para crear y automatizar su trabajo."},"billing":{"title":"Facturaci\xf3n","expires":"Pr\xf3xima facturaci\xf3n: {{value}}","isEmployeeAccess":{"title":"Profesional","titleLong":"Cephable Profesional","short":"Pro","description":"Cephable Professional brinda a los usuarios mayor poder de productividad, extendiendo la IA local y privada a capacidades generativas.","supportedFeatures":{"tag":"Todo en Plus, m\xe1s","features":["Flujos de trabajo de IA en el dispositivo","gesti\xf3n de organizaciones empresariales","Restricciones empresariales","Instalaciones ilimitadas en dispositivos","Controles de aplicaci\xf3n preentrenados ilimitados"]}},"isDeveloperAccess":{"title":"Kit de desarrollo de software","titleLong":"Kit de desarrollo de software de Cephable","short":"Kit de desarrollo de software (SDK)","description":"Los SDK de Cephable le permiten integrar poderosos controles adaptativos (voz, rostro, cabeza y m\xe1s) en su software con un esfuerzo m\xednimo y un beneficio m\xe1ximo.","supportedFeatures":{"tag":"Todo en Plus, m\xe1s","features":["Compatibilidad con Windows y macOS","SDK livianos e integrables para entrada de voz, rostro, cabeza y acci\xf3n r\xe1pida sin conexi\xf3n","Compatibilidad de API/webhook para acciones de salida personalizadas","Documentaci\xf3n para desarrolladores","Proyectos de muestra","Convierta los comandos en automatizaci\xf3n y navegaci\xf3n de documentos","Portal para desarrolladores para administrar sus proyectos, clientes de autenticaci\xf3n, tipos de dispositivos y m\xe1s"]}},"isStudentAccess":{"title":"Alumno","titleLong":"Educaci\xf3n Cefaleable","short":"Educaci\xf3n","description":"Cephable Education promueve el aprendizaje personalizado y las aulas inclusivas. Cephable funciona sin conexi\xf3n, se ejecuta en el dispositivo y no requiere integraciones de terceros.","supportedFeatures":{"tag":"Todo en Plus, m\xe1s","features":["Instalaciones ilimitadas de dispositivos","Controles de aplicaci\xf3n ilimitados previamente entrenados","Uso compartido ilimitado de controles de aplicaciones personalizados"]}},"viewProducts":"Ver productos","description":"Administre la facturaci\xf3n de su organizaci\xf3n, asientos, actualizaciones de suscripciones, renovaciones o cancelaciones.","view":"Administrar la facturaci\xf3n","isResellerAccess":{"title":"Revendedor","titleLong":"Revendedor de Cephable","description":"Cephable Reseller es una licencia paga que le permite crear nuevas organizaciones y asignar claves de licencia. Esto incluye el uso de Cephable con su propio paquete de software y la mejora de su experiencia de usuario.","short":"Revendedor"},"error":"Comun\xedquese con el administrador del sistema para administrar su facturaci\xf3n.","included":"Incluido con su licencia {{licenseType}}.","upgrade":{"description":"Actual\xedzate ahora y lleva tus controles al siguiente nivel.","action":"Actualizar ahora","error":"Error al actualizar. Int\xe9ntalo de nuevo m\xe1s tarde.","requiredDetail":"Se requiere una licencia {{licenseType}} para esta funci\xf3n. Siempre puedes actualizarla o iniciar una prueba gratuita en la configuraci\xf3n de tu cuenta.","enableTextGeneration":"Genera contenido usando IA y tu voz.","longDescription":"Actualice a una licencia de pago para acceder a todas las funciones de Cephable. Desde m\xfaltiples dispositivos hasta controles avanzados e integraciones personalizadas, Cephable tiene todo lo que necesita para alcanzar el siguiente nivel de productividad.","compare":"Comparar planes","enableAiDictation":{"title":"Actualice al dictado inteligente","description":"Actual\xedzate para desbloquear el dictado mejorado con IA. Puedo a\xf1adir puntuaci\xf3n, corregir may\xfasculas y adaptarme a tu estilo para que tu escritura se vea impecable sin esfuerzo."},"enableAiWorkflows":"Actualiza tu sistema para automatizar las tareas de tu ordenador y navegador con flujos de trabajo de IA."},"isPlusAccess":{"title":"M\xe1s","titleLong":"Cephable Plus","short":"M\xe1s","description":"Cephable Plus es para usuarios avanzados que desean lograr m\xe1s con voz inteligente, dictado inteligente, cientos de controles de aplicaciones y m\xe1s.","supportedFeatures":{"tag":"Todo lo del B\xe1sico, m\xe1s","features":["Controles de voz inteligentes (lenguaje natural)","Dictado inteligente (mejorado con IA)","Tareas inteligentes (generaci\xf3n, traducci\xf3n, reescritura)","Cientos de controles de aplicaciones preentrenados"]}},"personal":{"short":"B\xe1sico","title":"B\xe1sico","titleLong":"Cephable Basic","description":"Cephable Basic es gratuito para siempre y est\xe1 dise\xf1ado para ayudarte a moverte m\xe1s r\xe1pido, expresarte y lograr tus objetivos a tu manera. Las funciones incluidas en la versi\xf3n b\xe1sica est\xe1n disponibles para todos los usuarios.","upgrade":{"title":"Lleva tus controles al siguiente nivel","description":"Actual\xedzate a Plus o Pro para desbloquear todas mis funciones. M\xe1s precisi\xf3n. M\xe1s conexiones. M\xe1s controles. M\xe1s potencia para llevar tu productividad al siguiente nivel.","featureHeading":"As\xed es como puedo ayudarte:","control":"Te muevo por las apps y herramientas m\xe1s r\xe1pido usando tu voz o acciones r\xe1pidas, sin interrupciones. Con Voz Inteligente, podemos simplemente chatear.","create":"Reescribo, dicto, genero y traduzco directamente dentro de tus aplicaciones, sin necesidad de copiar, pegar ni cambiar de pantalla.","automate":"Ejecuto tareas inteligentes y acciones r\xe1pidas que agilizan tu flujo de trabajo. Desde comandos sencillos hasta macros complejas, me encargo del trabajo pesado para que puedas concentrarte en el trabajo que importa.","local":"Toda la IA es local. Sin procesamiento en la nube."}},"mostPopular":"M\xe1s populares","subscription":{"options":"Opciones de suscripci\xf3n","monthly":"Pagar mensualmente","billedMonthly":"/mes","yearly":"Pagar anualmente","billedYearly":"/a\xf1o"}},"organization":{"title":"Organizaci\xf3n","titlePlural":"Organizaciones","titleLong":"Cephable Profesional para Organizaciones","description":"Las organizaciones son grupos de usuarios que pueden colaborar en proyectos y compartir recursos. Puede administrar tu equipo, perfiles de equipo, facturaci\xf3n y m\xe1s aqu\xed.","noAccess":{"title":"Acceso denegado.","description":"Tus permisos cambiaron recientemente y ya no tienes acceso a esta funci\xf3n. Si cree que se trata de un error, comun\xedquese con el administrador de tu organizaci\xf3n."},"member":{"title":"Miembro","titlePlural":"Miembros","me":"Mi membres\xeda","description":"Los miembros son usuarios que forman parte de tu organizaci\xf3n. Se les puede asignar roles diferentes y tener acceso a diferentes partes de la organizaci\xf3n.","edit":"Editar miembros","removed":"Has sido eliminado de un equipo.","removedDescription":"Has sido eliminado del equipo. Ya no puedes acceder a la organizaci\xf3n. Si cree que se trata de un error, comun\xedquese con el administrador de tu organizaci\xf3n.","updated":"\xc9xito, la membres\xeda de {{value}} ha sido actualizada.","error":"Error al actualizar la membres\xeda de {{value}}.","delete":"\xc9xito, {{value}} ha sido eliminado.","deleteError":"Error al eliminar {{value}}.","deleteConfirmation":{"title":"\xbfEst\xe1 seguro de que desea eliminar este miembro?","description":"Una vez que elimines a este miembro, ya no tendr\xe1 acceso a la organizaci\xf3n. Siempre podr\xe1s volver a invitarlo m\xe1s tarde.","confirm":"S\xed, eliminar miembro"},"viewAll":{"title":"Ver todos los miembros","description":"Vea todos los miembros de su organizaci\xf3n y administre sus roles y permisos."},"seats":{"title":"Asientos de miembros","description":"Cada miembro de tu organizaci\xf3n tiene un puesto. El administrador de la organizaci\xf3n puede cambiar el tipo de permisos que tienen.","stats":"asientos fuera de {{value}}","max":"M\xe1ximo de asientos","current":"Asientos actuales","limit":{"title":"Se alcanzaron los asientos m\xe1ximos","description":"Tu plan actual ha alcanzado el l\xedmite de {{ maxSeats }} asientos disponibles. No puedes invitar a m\xe1s miembros. Ponte en contacto con tu administrador para actualizar el plan o administrar la asignaci\xf3n de asientos."},"updateLimit":{"title":"Actualice su plan para agregar m\xe1s asientos","description":"Tu plan actual ha alcanzado la cantidad m\xe1xima de plazas: {{ maxSeats }}. Actualiza ahora para desbloquear plazas adicionales y garantizar que tu equipo pueda seguir creciendo sin problemas.","action":"Plan de actualizaci\xf3n"},"maxSeatValue":"M\xe1ximo de asientos: {{value}}"},"aboutMe":"Acerca de m\xed","loadError":"Error al cargar miembros de la organizaci\xf3n.","orgTitle":"Miembros de {{value}}","emailExists":"El correo electr\xf3nico ya existe en la organizaci\xf3n. Por favor escribe un correo electr\xf3nico diferente."},"invite":{"title":"Invitar","titlePlural":"invita","description":"Se env\xedan invitaciones a los usuarios para que puede particpan a tu organizaci\xf3n. Puede invitar a usuarios a participar a tu organizaci\xf3n y asignarles diferentes roles.","edit":"Crear nueva invitaci\xf3n","view":"Ver todas las invitaciones","emailRequired":"Correo Electronico es requerido","emailInvalid":"El correo electr\xf3nico es invalido. Por favor, escribe un correo electr\xf3nico v\xe1lida.","emailExists":"El correo electr\xf3nico ya tiene una invitaci\xf3n de la organizaci\xf3n. Por favor, escribe una direcci\xf3n de correo electr\xf3nico diferente.","emailPlaceholder":"Escribe tu correo electr\xf3nico","expiration":"Vence ","delete":"Eliminar invitaci\xf3n","confirm":"\xbfEst\xe1s seguro a eliminar esta invitaci\xf3n?","confirmLong":"Una vez que elimine esta invitaci\xf3n, el usuario ya no podr\xe1 participar en la organizaci\xf3n. Siempre puedes volver a invitarlos m\xe1s tarde.","accept":"Aceptar invitaci\xf3n","acceptSuccess":{"title":"Bienvenido al equipo.","description":"Te has unido exitosamente a la organizaci\xf3n. ","action":"Ver tu nueva organizaci\xf3n"},"acceptError":{"title":"Oops. Parece que hay un problema.","description":"Hubo un error al unirse a la organizaci\xf3n. Por favor, volver a probar m\xe1s tarde. Si el problema persiste, comun\xedquese con el administrador de tu organizaci\xf3n. ","action":"Volver a la p\xe1gina principal"},"send":{"success":"Invitaci\xf3n a {{value}} enviada.","error":"Error al enviar la invitaci\xf3n a {{value}}.","title":"Enviar invitaci\xf3n"},"viewDescription":"Ver todas las invitaciones actuales que no han sido aceptadas.","new":"Invitar a un miembro","stat":"invitaciones activas","noInvites":{"title":"Sin invitaciones.","description":"Parece que no hay invitaciones activas para tu organizaci\xf3n."},"error":"Error al cargar invitaciones.","orgTitle":"Invitaciones de {{ value }}","editDescription":"Crea una nueva invitaci\xf3n para que un usuario se una a tu organizaci\xf3n. Las invitaciones caducan autom\xe1ticamente a los 7 d\xedas.","scimManaged":{"title":"Los miembros se gestionan en su proveedor de identidad.","description":"Esta organizaci\xf3n utiliza el aprovisionamiento autom\xe1tico (SCIM), por lo que la membres\xeda se controla mediante su sistema de identidad interno. Al agregar o eliminar usuarios, el cambio se sincroniza autom\xe1ticamente con Cephable; no se pueden enviar invitaciones desde el portal."}},"role":{"title":"Role","titlePlural":"Roles","description":"Los roles son los diferentes niveles de acceso que puede tener un usuario en tu organizaci\xf3n. Puede asignar diferentes roles a los usuarios para controlar lo que pueden hacer."},"isAdmin":{"title":"Administraci\xf3n","description":"Los administradores tienen acceso completo a la organizaci\xf3n y pueden manager todos los aspectos de la organizaci\xf3n.","conflict":"Este miembro es un administrador. No tienes permiso para editar tus roles."},"canViewMembers":{"title":"Ver miembros","description":"Los usuarios con este permiso pueden ver a todos los miembros de la organizaci\xf3n."},"canInviteMembers":{"title":"Invitar a los miembros","description":"Los usuarios con este permiso pueden invitar a nuevos miembros a la organizaci\xf3n y administrar las invitaciones existentes."},"canChangeMemberPermissions":{"title":"Cambiar roles de miembros","description":"Los usuarios con este permiso pueden cambiar el role de otros miembros de la organizaci\xf3n."},"canRemoveMembers":{"title":"Eliminar miembros","titleSingle":"Eliminar miembro","action":"Eliminar","description":"Los usuarios con este permiso pueden eliminar a otros miembros de la organizaci\xf3n.","confirm":"\xbfEst\xe1 seguro a eliminar a este miembro de la organizaci\xf3n?","confirmLong":"Una vez que elimines a este miembro, ya no tendr\xe1 acceso a la organizaci\xf3n. Siempre puedes volver a invitarlos m\xe1s tarde."},"canCreateAuthClients":{"title":"Crear clientes de autenticaci\xf3n","description":"Los usuarios con este permiso pueden crear nuevos clientes de autenticaci\xf3n para la organizaci\xf3n."},"canManageBilling":{"title":"Administrar facturaci\xf3n","description":"Los usuarios con este permiso pueden administrar la configuraci\xf3n de facturaci\xf3n de la organizaci\xf3n.","error":"No tienes permiso para administrar la facturaci\xf3n de esta organizaci\xf3n."},"metrics":{"lineChart":{"title":"Promedio de Conexiones Concurrentes","description":"Este gr\xe1fico muestra las conexiones simult\xe1neas promedio para la organizaci\xf3n y los datos del proyecto a lo largo del tiempo.","max":"M\xe1ximo de Conexiones: {{maxConnections}}","project":"Total del Proyecto","org":"Organizaci\xf3n Total"},"title":"M\xe9trica","description":"Las m\xe9tricas son puntos de datos que le ayudan a comprender c\xf3mo su organizaci\xf3n utiliza Cephable.","view":"Ver m\xe9tricas","orgTitle":"M\xe9tricas de {{ value }}","manage":{"title":"M\xe9tricas de rendimiento","description":"Descargue o borre las m\xe9tricas de rendimiento recopiladas durante la inferencia del modelo."},"download":{"button":"Descargar m\xe9tricas","success":"El archivo de m\xe9tricas se ha guardado en su carpeta de Descargas.","error":"Error al descargar el archivo de m\xe9tricas.","noFile":"No se encontr\xf3 el archivo de m\xe9tricas. Intente ejecutar el modelo primero."},"clear":{"button":"M\xe9tricas claras","success":"Se han borrado las m\xe9tricas.","error":"No se pudo borrar el archivo de m\xe9tricas.","confirm":{"title":"M\xe9tricas de rendimiento claras","description":"\xbfSeguro que desea borrar todas las m\xe9tricas de rendimiento registradas? Esta acci\xf3n no se puede deshacer.","cancel":"Cancelar","confirm":"M\xe9tricas claras"}}},"noOrg":{"title":"Sin licencia asociada.","description":"Actualmente no est\xe1 asociado a ninguna licencia ni grupo de desarrolladores. El portal est\xe1 limitado a usuarios con una licencia de pago de Cephable. Para aprovechar al m\xe1ximo el potencial de Cephable, inicie una prueba gratuita."},"projects":{"title":"Proyectos","description":"Utilice Proyectos para administrar el acceso seguro, configurar las interacciones de los dispositivos y optimizar la forma en que sus aplicaciones env\xedan y reciben comandos en distintas plataformas.","name":"Nombre de la aplicaci\xf3n","stats":{"title":"Estad\xedsticas del proyecto","connections":"Conexiones totales","all":{"title":"Todas las m\xe9tricas del proyecto","description":"M\xe9tricas agregadas para todos los proyectos asociados con {{ orgName }}"},"card":"proyectos de {{value}}","users":"Total de usuarios desde {{date}}","avgUsers":"Promedio mensual de usuarios.","concurrent":{"title":"Promedio de conexiones simult\xe1neas \xdaltimos {{days}} d\xedas","label":"Promedio simult\xe1neo","max":"Conexiones m\xe1ximas","overage":"Exceso","description":"Las conexiones simult\xe1neas son la cantidad de usuarios conectados a tu proyecto al mismo tiempo. Esta m\xe9trica te ayuda a comprender cu\xe1ntos usuarios est\xe1n usando tu aplicaci\xf3n simult\xe1neamente."}},"projectType":{"title":"Tipo de proyecto","description":"Los tipos de proyecto se utilizan para categorizar sus proyectos y ayudarnos a elegir los SDK adecuados para usted."},"accessDenied":{"generic":"No tienes acceso a este proyecto.","title":"Acceso denegado.","description":"No tienes acceso para ver, crear, editar ni eliminar proyectos. Ponte en contacto con tu administrador para obtener acceso."},"upgrade":{"title":"Actualizaci\xf3n al SDK de Cephable","description":"Cephable se puede integrar directamente en su aplicaci\xf3n, juego o servicio mediante nuestros SDK. Los proyectos no est\xe1n disponibles actualmente con su cuenta. Si cree que hay un error, comun\xedquese con support@cephable.com.","shortDescription":"Los proyectos no est\xe1n disponibles actualmente en tu cuenta. Ponte en contacto con nosotros para actualizar."},"limit":{"title":"\xbfQuieres m\xe1s proyectos?","error":"Se alcanz\xf3 el l\xedmite del proyecto.","description":"Has alcanzado la cantidad m\xe1xima de proyectos para tu organizaci\xf3n. Ponte en contacto con tu administrador para actualizar tu cuenta."},"create":{"title":"Crear proyecto","titleLong":"Empecemos.","first":{"title":"Empiece con su proyecto.","description":"Parece que a\xfan no has creado un proyecto. Las claves y dispositivos de cliente son esenciales para proteger la comunicaci\xf3n entre tus aplicaciones y nuestros servicios. Con una clave de cliente, podr\xe1s integrar controles de voz y de movimiento de la cabeza en tus aplicaciones de forma r\xe1pida y segura."},"details":{"title":"Detalles del proyecto","description":"Cree un nuevo proyecto para administrar la autorizaci\xf3n de su aplicaci\xf3n, las capacidades de los dispositivos y las integraciones de SDK. Siga los pasos a continuaci\xf3n para configurar interacciones seguras y personalizables para sus usuarios."}},"sdk":{"title":"Descargar el SDK","description":"Obtenga acceso a nuestro potente SDK desarrollado para facilitar los controles adaptativos.","select":{"title":"Seleccionar SDK","description":"Seleccione el SDK que desea utilizar para este proyecto. Nuestros SDK permiten una integraci\xf3n perfecta de controles de voz y movimiento de la cabeza adaptables en diferentes plataformas."}},"clients":{"title":"Clientes de autorizaci\xf3n","description":"Los clientes de autorizaci\xf3n administran el acceso seguro a sus aplicaciones. Defina un cliente de autorizaci\xf3n para autenticar a los usuarios y controlar las interacciones con su aplicaci\xf3n.","settings":"Configuraci\xf3n de autorizaci\xf3n","configure":"Configurar el cliente de autorizaci\xf3n","create":"Crear cliente de autorizaci\xf3n","max":"M\xe1ximo de proyectos: {{value}}"},"secret":{"title":"Secreto del cliente","created":"Se ha creado su secreto de cliente.","description":"Su secreto de cliente solo se mostrar\xe1 una vez. C\xf3pielo ahora y gu\xe1rdelo en un lugar seguro. \xdaselo solo para su propio desarrollo. <br> <br> No lo comparta con servicios o aplicaciones de terceros.","copy":"Copiar secreto","rotate":{"title":"Rotar secreto de cliente","description":"ADVERTENCIA: Esta acci\xf3n revocar\xe1 su secreto de cliente existente y crear\xe1 uno nuevo. Para ello, deber\xe1 actualizar todos los datos de uso existentes en todas sus aplicaciones. Esta acci\xf3n no se puede revertir.","error":"Error al rotar el secreto. Int\xe9ntalo de nuevo m\xe1s tarde."}},"key":{"title":"Clave de cliente","view":"Ver clave de cliente","delete":{"title":"Eliminar clave de cliente","description":"ADVERTENCIA: Esta acci\xf3n eliminar\xe1 su clave de cliente existente y todas las configuraciones relacionadas. Esta acci\xf3n no se puede revertir.","error":"Error al eliminar su clave de cliente.","success":"Su proyecto ha sido eliminado."},"copy":"Copiar clave"},"tokenRedirect":{"title":"URL de redireccionamiento de tokens","description":"Las URL de redireccionamiento de tokens son los puntos finales a los que se env\xedan los tokens de acceso una vez completada la autenticaci\xf3n. Estas URL permiten que su aplicaci\xf3n reciba de forma segura los tokens necesarios para acceder a los datos y servicios del usuario."},"authRedirect":{"title":"URL de redireccionamiento de c\xf3digo de autorizaci\xf3n","description":"La URL de redireccionamiento de c\xf3digo de autorizaci\xf3n es el punto final donde se env\xedan los c\xf3digos de autorizaci\xf3n despu\xe9s de que un usuario otorga permiso a su aplicaci\xf3n. Esta URL es esencial en los flujos de OAuth, ya que garantiza la transmisi\xf3n segura del c\xf3digo de autorizaci\xf3n desde el servidor de autorizaci\xf3n a su aplicaci\xf3n, lo que le permite solicitar tokens de acceso en nombre del usuario."},"scopes":{"title":"\xc1mbitos","titleLong":"\xc1mbitos de permisos de API","configure":"Definir alcances","description":"Los \xe1mbitos definen los permisos que tendr\xe1 este cliente de autorizaci\xf3n. Establezca \xe1mbitos para limitar el acceso a datos y funciones espec\xedficos, garantizando que los usuarios solo obtengan el acceso que necesitan.","manage":"Administrar los \xe1mbitos de autorizaci\xf3n"},"deviceScopes":{"title":"Tipos de dispositivos asociados","titleLong":"Tipos de dispositivos permitidos","action":"Agregar nuevo tipo de dispositivo","configure":"Configurar los tipos de dispositivos permitidos","descriptionShort":"Define qu\xe9 tipo de dispositivos pueden acceder a este proyecto.","titles":"Tipos de dispositivos asociados","description":"El tipo de dispositivo define los permisos y niveles de acceso que tiene un dispositivo dentro de su aplicaci\xf3n. Al asignar tipos de dispositivos espec\xedficos, puede controlar las acciones y los datos a los que puede acceder cada dispositivo, lo que garantiza que su aplicaci\xf3n se mantenga segura y cumpla con sus pol\xedticas de privacidad."},"deviceType":{"title":"Tipos de dispositivos","description":"Un DeviceType define una categor\xeda de dispositivos, detallando sus capacidades de entrada/salida y las funciones admitidas (por ejemplo, voz, gestos, tipos de controlador). Garantiza que solo los dispositivos autorizados puedan interactuar con una aplicaci\xf3n, lo que permite un acceso limitado a trav\xe9s de configuraciones de dispositivos espec\xedficos, como Xbox o PlayStation.","action":"Crear tipo de dispositivo","name":"Nombre del tipo de dispositivo","descriptionLong":"Descripci\xf3n del tipo de dispositivo","features":{"title":"Funciones compatibles","description":"Define las entradas y salidas que admite tu aplicaci\xf3n. Esto nos ayuda a optimizar la experiencia del usuario en Cephable.","supportsVoiceInput":"Entrada de voz","supportsPhysicalInput":"Entrada f\xedsica","supportsKeyboardOutput":"Salida del teclado","supportsPlayStationControllerOutput":"Mando de PlayStation","supportsFaceInput":"Entrada de cara","supportsGestureInput":"Entrada de gestos","supportsXboxControllerOutput":"Mando Xbox","supportsDigitalExtensions":"Extensiones digitales","supportsPhysicalExtensions":"Extensiones f\xedsicas","supportsNintendoControllerOutput":"Mando de Nintendo","supportsGenericControllerOutput":"Salida del controlador gen\xe9rico"},"canAutoStart":{"title":"Admite arranques de control autom\xe1tico","description":"[canAutoStart] si est\xe1 habilitado, el SDK verificar\xe1 la configuraci\xf3n del usuario e intentar\xe1 iniciar inmediatamente los controles de la c\xe1mara o el micr\xf3fono despu\xe9s de que el usuario inicie sesi\xf3n."},"isSupported":{"title":"Activo","description":"[isSupported] Si est\xe1 deshabilitado, Cephable ya no enviar\xe1, recibir\xe1 ni reconocer\xe1 ning\xfan dispositivo de usuario asociado con esto. Equivale a obsoleto."},"locale":{"title":"Idioma predeterminado","description":"[defaultLocale] La configuraci\xf3n regional predeterminada para este tipo de dispositivo. Se utilizar\xe1 como idioma predeterminado para el dispositivo.","support":"Admite idiomas","warn":"**Parece que tienes configurados controles personalizados. Aseg\xfarate de haber actualizado los controles personalizados para los idiomas asociados.**","name":"{{lang}} - Nombre del tipo de dispositivo","langDescription":"{{lang}} - Descripci\xf3n"},"customControls":{"title":"Controles personalizados","object":"{{lang}} - Objeto de controles personalizados","description":"Los controles personalizados son una opci\xf3n avanzada que permite a los usuarios configurar y editar manualmente los controles de la aplicaci\xf3n asociados a este dispositivo. Si desea que los usuarios controlen su dispositivo directamente desde Cephable, debe registrar los controles de su dispositivo aqu\xed. Consulte la API de Cephable para obtener m\xe1s informaci\xf3n sobre las opciones.","addControl":"Agregar control","empty":"A\xfan no hay controles personalizados. Usa \\"Agregar control\\" para crear el primero.","untitled":"Control sin t\xedtulo","controlId":"ID de control","controlIdHelp":"Identificador \xfanico para este control. Config\xfarelo antes de guardar; no se podr\xe1 modificar posteriormente.","fallback":"Retroceder","controlName":"Nombre del control","controlDescription":"Descripci\xf3n del control","defaultCommandsLabel":"Comandos de voz predeterminados","defaultCommandsHelp":"Estos son los activadores de voz predeterminados que los usuarios ven para este control en el idioma actual.","sharedAcrossLanguages":"Compartido en todos los idiomas","sharedAcrossLanguagesHelp":"Al editar estos campos, se actualiza el valor para todos los idiomas a la vez.","iconUrl":"URL del icono","contextGroupName":"Grupo de contexto","isProfileControl":"Control de perfil","isPrefixVoiceCommand":"Comando de voz de prefijo","allowWhenDictating":"Permitir al dictar","allowsHold":"Permite retenci\xf3n","isDeprecated":"Obsoleto","requiresEmployeeAccess":"Requiere acceso de empleado","requiresStudentAccess":"Requiere acceso de estudiante","requiresGenericLicense":"Requiere licencia gen\xe9rica","requiresPlusAccess":"Requiere acceso Plus","allIncomplete":"Todas las configuraciones regionales tienen controles personalizados incompletos. Complete al menos una configuraci\xf3n regional antes de guardar.","savedWithIncomplete":"Guardado. No se guardaron las configuraciones regionales de los controles personalizados incompletos: {{incompleteLocales}}"},"success":{"title":"\xa1\xc9xito!","description":"Ha creado un nuevo tipo de dispositivo. {{name}} Ahora puede actualizar el alcance del dispositivo de su cliente de autorizaci\xf3n seg\xfan sea necesario."},"id":"Identificaci\xf3n del tipo de dispositivo","throttleRules":{"title":"Reglas del acelerador de comandos","description":"Configure reglas de limitaci\xf3n para controlar el flujo de comandos y las restricciones de entrada para este tipo de dispositivo.","disableVoiceInput":"Desactivar la entrada de voz","disableHotkeyInput":"Deshabilitar la entrada de teclas de acceso r\xe1pido","disableCameraInput":"Desactivar la entrada de la c\xe1mara","disableMultiInputs":"Deshabilitar entradas m\xfaltiples","maximumCommandsPerSecond":"M\xe1ximos comandos por segundo","maximumCommandsPerMinute":"M\xe1ximos comandos por minuto","maximumMacroLength":"Longitud m\xe1xima de macro","jitter":{"title":"fluctuaci\xf3n de tiempo","description":"A\xf1ade variaciones aleatorias a la duraci\xf3n de las pausas y las pulsaciones para crear patrones de entrada m\xe1s naturales.","holdTimeJitterMin":"Jitter de tiempo de retenci\xf3n (minutos) (ms)","holdTimeJitterMax":"Fluctuaci\xf3n m\xe1xima del tiempo de retenci\xf3n (ms)","pauseTimeJitterMin":"Fluctuaci\xf3n del tiempo de pausa (minutos)","pauseTimeJitterMax":"Fluctuaci\xf3n m\xe1xima del tiempo de pausa (ms)"},"incompatibleActions":{"title":"Grupos de acci\xf3n incompatibles","description":"Defina grupos de acciones que no pueden coexistir en la misma macro.","addGroup":"Agregar grupo","removeGroup":"Eliminar grupo","addAction":"Agregar acci\xf3n","removeAction":"Eliminar acci\xf3n","reason":"Raz\xf3n","reasonPlaceholder":"Por qu\xe9 estas acciones son incompatibles","eventType":"Tipo de evento","key":"Llave","customActionId":"ID de acci\xf3n personalizada","emptyGroup":"No hay acciones en este grupo. A\xf1ade al menos dos acciones."},"requiredPause":{"title":"Pausa obligatoria entre acciones","description":"Defina pares de acciones que requieran una pausa m\xednima entre ellas dentro de la misma macro.","addRule":"Agregar regla","removeRule":"Eliminar regla","actionA":"Acci\xf3n A","actionB":"Acci\xf3n B","minimumPause":"Pausa m\xednima (ms)","bidirectional":"Bidireccional","bidirectionalHelp":"Cuando est\xe1 habilitada, la pausa es necesaria en ambas direcciones (A\u2192B y B\u2192A)."},"macroStepRules":{"title":"Reglas de pasos macro","holdTimeJitterMin":"Jitter de retenci\xf3n (minutos) (ms)","holdTimeJitterMax":"Jitter m\xe1ximo de retenci\xf3n (ms)"}}},"view":"Ver proyectos","error":"Error al cargar proyectos.","type":{"title":"Tipo de implementaci\xf3n"},"originHost":{"title":"Origen del anfitri\xf3n","description":"La URL que servir\xe1 como fuente principal de solicitudes y datos durante las interacciones de la API."},"orgTitle":"Proyectos de {{ value }}"},"viewOrganization":"Ver Organizaci\xf3n","update":"\xa1Tu organizaci\xf3n ha sido actualizada! Actualizando la aplicaci\xf3n.","error":"Error al cargar la organizaci\xf3n. Int\xe9ntalo de nuevo m\xe1s tarde.","new":{"name":{"label":"Nombre de la organizaci\xf3n","placeholder":"Introduzca el nombre de su organizaci\xf3n"},"description":{"label":"Descripci\xf3n de la organizaci\xf3n","placeholder":"\xbfCu\xe1les son sus objetivos al utilizar Cephable Professional?"},"details":"Detalles de la organizaci\xf3n"},"expired":{"user":"Parece que su licencia de Cephable ha expirado, por lo que ha cambiado a la versi\xf3n gratuita de Cephable Basic. Para renovarla, p\xf3ngase en contacto con el administrador de su organizaci\xf3n.","admin":"Parece que su licencia de Cephable ha expirado, por lo que ha cambiado a la versi\xf3n gratuita de Cephable Basic. Renueve su licencia para seguir usando funciones avanzadas m\xe1s all\xe1 de Cephable Basic.","multiple":"Parece que sus licencias de Cephable han expirado, por lo que ha cambiado a la versi\xf3n gratuita de Cephable Basic. Renueve al menos una de sus licencias para seguir usando funciones avanzadas m\xe1s all\xe1 de Cephable Basic.","dialog":{"title":"Seleccione una organizaci\xf3n","description":"Tiene varias organizaciones asociadas a su cuenta. Seleccione la organizaci\xf3n que desea renovar."},"title":"Su licencia de Cephable ha expirado","titlePlural":"Sus licencias de Cephable han expirado","banner":"Parece que tu licencia de Cephable ha caducado, por lo que has cambiado a la versi\xf3n gratuita de Cephable Basic. Al renovarla, tendr\xe1s acceso a funciones como controles de voz mejorados, tareas inteligentes con IA y muchos controles de aplicaciones predefinidos."},"orgName":"Nombre de la organizaci\xf3n","menu":{"title":"Men\xfa de la organizaci\xf3n","view":"Ver Men\xfa","expand":"Expandir men\xfa"},"settings":{"title":"Configuraci\xf3n de la organizaci\xf3n","description":"Administre la facturaci\xf3n, el nombre, la descripci\xf3n y los recursos de su organizaci\xf3n.","view":"Ver configuraci\xf3n","general":{"title":"General"},"resources":{"edit":"Editar recursos","description":"Utilice el editor Markdown a la izquierda para actualizar y dar formato a recursos \xfatiles para todos los miembros de la organizaci\xf3n. A medida que escribe, la vista previa a la derecha mostrar\xe1 c\xf3mo se ver\xe1 su contenido para los usuarios. Puede agregar encabezados, listas, enlaces y otros elementos de formato utilizando la sintaxis Markdown. Los cambios ser\xe1n visibles para los miembros una vez guardados."},"other":{"title":"Otros ajustes","description":"Administre la facturaci\xf3n, el nombre, la descripci\xf3n y los recursos de su organizaci\xf3n."},"managed":{"title":"Gestionado por Cephable","description":"Estos controles los configura Cephable para su organizaci\xf3n. Se muestran aqu\xed para que pueda confirmar los valores actuales y no se pueden modificar desde el portal.","email":{"title":"Entrega de correo electr\xf3nico Cephable","allowedDescription":"Cephable podr\xe1 enviar correos electr\xf3nicos a los miembros de esta organizaci\xf3n, como invitaciones, verificaciones y restablecimientos de contrase\xf1a.","blockedDescription":"Cephable no env\xeda correos electr\xf3nicos a los miembros de esta organizaci\xf3n. Se suprimen las invitaciones, la verificaci\xf3n, los restablecimientos de contrase\xf1a, los enlaces m\xe1gicos, la incorporaci\xf3n de nuevos usuarios y los correos electr\xf3nicos sobre productos."},"scim":{"title":"Aprovisionamiento autom\xe1tico de miembros (SCIM)","description":"Tu proveedor de identidad crea y elimina miembros de esta organizaci\xf3n. No se pueden enviar invitaciones desde el portal."},"lockedNote":"Solo Cephable puede modificar estos ajustes. Si necesita actualizar alg\xfan valor, p\xf3ngase en contacto con su representante de Cephable."}},"managed":{"title":"Organizaci\xf3n administrada","titlePlural":"Organizaciones gestionadas","description":"Las organizaciones administradas son aquellas que est\xe1n a cargo de un revendedor de Cephable. Los revendedores pueden administrar su equipo, los perfiles del equipo, la facturaci\xf3n y m\xe1s aqu\xed.","error":"Error al cargar organizaciones administradas.","empty":{"title":"No se encontraron organizaciones administradas.","description":"Parece que no hay organizaciones administradas que cumplan con estos criterios o que sus claves de licencia a\xfan no se han activado."},"titleShort":"Administrado"},"canManageChildOrganizations":{"title":"Administrar organizaciones infantiles","description":"Los usuarios con este permiso pueden crear y administrar organizaciones secundarias como administrador."},"canViewAnalytics":{"title":"Ver Anal\xedtica","description":"Los usuarios con este permiso pueden ver las m\xe9tricas y los an\xe1lisis de la organizaci\xf3n."},"create":"Crear nueva organizaci\xf3n","orgCustomBillingUrl":{"title":"URL de facturaci\xf3n personalizada","description":"Esta es una URL personalizada que se utilizar\xe1 para redirigir al usuario a su sistema de facturaci\xf3n (el del revendedor). Debe comenzar con \\"https://\\" o \\"mailTo:\\""},"upgrade":{"existing":{"title":"Eres parte de una licencia existente.","description":"Actualice haciendo clic en `{{action}}` en el men\xfa lateral."}},"restrictions":{"isGenAIDisabled":{"title":"IA generativa deshabilitada","description":"Su organizaci\xf3n ha deshabilitado el acceso a las funciones de IA Generativa. Para m\xe1s informaci\xf3n, p\xf3ngase en contacto con el administrador de su organizaci\xf3n."},"isRemoteControlDisabled":{"title":"Sincronizaci\xf3n entre dispositivos deshabilitada","description":"Su organizaci\xf3n ha deshabilitado el acceso a la sincronizaci\xf3n; no podr\xe1 usar nuestra aplicaci\xf3n complementaria ni controlar dispositivos externos. Para obtener m\xe1s informaci\xf3n, p\xf3ngase en contacto con el administrador de su organizaci\xf3n."}},"troubleshooting":{"title":"Soluci\xf3n de problemas","editorDescription":"[Opcional] Esta es una secci\xf3n que es visible para todos los usuarios a trav\xe9s de la p\xe1gina de detalles de conexi\xf3n en las aplicaciones m\xf3viles y de escritorio de Cephable.","description":"Si tiene problemas con Cephable, pruebe los pasos a continuaci\xf3n para resolver problemas comunes."},"onboarding":{"title":"Incorporaci\xf3n","editorDescription":"[Opcional] La incorporaci\xf3n se muestra a los usuarios cuando se a\xf1ade este tipo de dispositivo a su cuenta. Este es un excelente lugar para proporcionar instrucciones sobre c\xf3mo configurar y usar el tipo de dispositivo con su aplicaci\xf3n."},"documents":"Documentos","completionStatus":{"title":"Estado de finalizaci\xf3n","error":"","complete":"Completo.","incomplete":"Incompleto."},"metadata":{"title":"Metadatos","urlError":"La URL debe comenzar con http:// o https://","metatitle":{"label":"Metat\xedtulo","placeholder":"Introduzca un t\xedtulo corto"},"shortDescription":{"label":"Descripci\xf3n breve","placeholder":"Ingrese una breve descripci\xf3n de vista previa (m\xe1ximo 150 caracteres)"},"externalLink":{"label":"URL del enlace externo","placeholder":"https://ejemplo.com/informaci\xf3n-del-dispositivo","description":"Un enlace directo a un sitio web o recurso externo que proporciona m\xe1s informaci\xf3n sobre c\xf3mo configurar este dispositivo por primera vez. Si lo usa, no usaremos el Markdown de la lista de clientes."},"iconUrl":{"label":"URL del icono del dispositivo","placeholder":"https://ejemplo.com/icono-de-dispositivo.png","description":"Un enlace directo a una imagen que representa este tipo de dispositivo. Este icono se mostrar\xe1 en la aplicaci\xf3n Cephable y en las listas de dispositivos."},"darkModeIconUrl":{"label":"URL del icono del dispositivo en modo oscuro","placeholder":"https://ejemplo.com/icono-de-dispositivo-oscuro.png","description":"Un enlace directo a una imagen que representa este tipo de dispositivo en modo oscuro. Este icono se mostrar\xe1 en la app Cephable y en las listas de dispositivos cuando el usuario tenga activado el modo oscuro."},"editorDescription":"Cuando su dispositivo es seleccionado para aparecer en la aplicaci\xf3n Cephable como una extensi\xf3n o conexi\xf3n, utilizamos esta informaci\xf3n para mostr\xe1rsela a los usuarios que configuran nuevas conexiones."},"client-listing":{"title":"Listado de clientes","editorDescription":"Instrucciones detalladas para que los nuevos usuarios configuren conexiones con este tipo de dispositivo. Este contenido de Markdown se mostrar\xe1 en la aplicaci\xf3n Cephable cuando los usuarios agreguen una nueva conexi\xf3n."},"canAccessOrganizationProfiles":{"title":"Ver controles de la aplicaci\xf3n de la organizaci\xf3n","description":"Los usuarios con este permiso pueden ver los controles de la aplicaci\xf3n de la organizaci\xf3n asociados con esta organizaci\xf3n."},"canEditOrganizationProfiles":{"title":"Administrar controles de aplicaciones de la organizaci\xf3n","description":"Los usuarios con este permiso pueden crear, editar y eliminar controles de aplicaciones de organizaci\xf3n asociados con esta organizaci\xf3n."},"profiles":{"title":"Controles de la aplicaci\xf3n de la organizaci\xf3n","description":"Los controles de aplicaciones de la organizaci\xf3n son perfiles compartidos para distribuir controles de aplicaciones en toda su organizaci\xf3n o para compartirlos con sus usuarios de integraci\xf3n.","view":"Ver controles de la aplicaci\xf3n de la organizaci\xf3n","editDescription":"Edite los controles de la aplicaci\xf3n de la organizaci\xf3n para personalizar la configuraci\xf3n.","empty":"No se encontraron controles de la aplicaci\xf3n de la organizaci\xf3n. Crea uno para empezar.","error":"Error al cargar los controles de la aplicaci\xf3n de la organizaci\xf3n.","titleShort":"Controles de la aplicaci\xf3n"},"canViewAuthClients":{"title":"Ver proyectos","description":"Los usuarios con este permiso pueden ver los clientes de autenticaci\xf3n y los proyectos de la organizaci\xf3n."},"governance":{"title":"Gobernancia","orgTitle":"Gobernanza {{valor}}","description":"Establece las pautas que gu\xeden c\xf3mo tu equipo puede usar el asistente de Cephable.","automation":{"title":"Reglas de automatizaci\xf3n","description":"Controla d\xf3nde puede automatizarse Cephable y proporciona instrucciones que moldeen su comportamiento para tu organizaci\xf3n.","rulesTitle":"Normas","create":"Crear regla de automatizaci\xf3n","edit":"Editar regla de automatizaci\xf3n","created":"Regla de automatizaci\xf3n creada.","updated":"Regla de automatizaci\xf3n actualizada.","deleted":"Regla de automatizaci\xf3n eliminada.","loadError":"No se pudieron cargar las reglas de automatizaci\xf3n.","saveError":"No se pudo guardar la regla de automatizaci\xf3n.","deleteError":"No se puede eliminar la regla de automatizaci\xf3n.","searchPlaceholder":"Reglas de b\xfasqueda por aplicaci\xf3n, sitio web, solicitud o alcance","promptOnly":"Instrucci\xf3n auxiliar","editorDescription":"Seleccione el tipo de regla, opcionalmente seleccione una aplicaci\xf3n o sitio web como objetivo y agregue instrucciones claras para Cephable.","validation":"A\xf1ade una aplicaci\xf3n o sitio web, instrucciones para el asistente o ambas cosas.","appOrDomain":{"label":"Aplicaci\xf3n o sitio web","helper":"Utilice un nombre de aplicaci\xf3n o dominio reconocible, como Slack, gmail.com o github.com."},"prompt":{"label":"Instrucciones del asistente","helper":"Describe qu\xe9 deber\xeda o no deber\xeda hacer Cephable. Las instrucciones deben ser espec\xedficas y pr\xe1cticas."},"type":{"label":"Tipo de regla","block":"Bloquear","allow":"Permitir"},"scope":{"organization":"A nivel de toda la organizaci\xf3n","organizationDescription":"Aplique esta regla a todos los miembros actuales y futuros.","members":"Miembros espec\xedficos","membersDescription":"Guarda la regla y as\xedgnala solo a los miembros que la necesiten."},"assign":"Asignar miembros","delete":{"title":"\xbfEliminar regla de automatizaci\xf3n?","description":"Esto elimina de forma permanente la regla y cualquier asignaci\xf3n de miembros que la utilice."},"empty":{"title":"A\xfan no hay reglas de automatizaci\xf3n","description":"Crea una regla para establecer las directrices de seguridad para el primer asistente de tu organizaci\xf3n."},"guidance":{"block":{"title":"Restringir aplicaciones y sitios web","description":"Utilice una regla de bloqueo con el nombre de la aplicaci\xf3n o el dominio para impedir que Cephable interact\xfae con ella."},"prompt":{"title":"Agregar contexto de asistente","description":"Utilice las instrucciones del asistente para comunicar pol\xedticas, controles obligatorios o m\xe9todos de trabajo seguros."},"scope":{"title":"Elige el alcance adecuado","description":"Aplique medidas de control comunes a toda la organizaci\xf3n, o limite las excepciones a miembros seleccionados."}},"assignment":{"title":"Asignar regla a un miembro","description":"Gestionar la asignaci\xf3n espec\xedfica de miembros para {{value}}.","memberLabel":"Miembro","apply":"Aplicar regla","remove":"Eliminar regla","assigned":"Esta regla se asigna al miembro seleccionado.","notAssigned":"Esta regla no est\xe1 asignada al miembro seleccionado.","applied":"Regla aplicada al miembro.","removed":"Regla eliminada del miembro.","loadError":"No se pudieron cargar los miembros de la organizaci\xf3n.","statusError":"No se pudieron cargar las reglas de automatizaci\xf3n de este miembro.","saveError":"No se pudo actualizar la asignaci\xf3n de miembros."}},"tabs":{"automation":"Reglas de automatizaci\xf3n","permissions":"Permisos de extensi\xf3n","skills":"Habilidades organizativas","connectors":"Conectores de organizaci\xf3n","usage":"Uso"},"extensions":{"permissions":{"orgTitle":"Pol\xedtica de toda la organizaci\xf3n","orgDescription":"Controla qu\xe9 funciones pueden habilitar los miembros en las distintas habilidades y conectores. Estas opciones se aplican a todos, a menos que un miembro tenga una excepci\xf3n que se indica m\xe1s abajo.","saved":"Se ha actualizado la pol\xedtica de la organizaci\xf3n.","saveError":"No se pudo actualizar la pol\xedtica de la organizaci\xf3n.","askAdmin":"P\xf3ngase en contacto con el administrador de su organizaci\xf3n para habilitar esta funci\xf3n.","installBlocked":"No se puede instalar.","createBlocked":"No se puede agregar personal {{type}}.","useBlocked":"Este {{type}} ya no est\xe1 disponible para usted."},"orgFlags":{"allowPublicSkills":{"title":"Permitir habilidades p\xfablicas","description":"Los miembros pueden publicar o habilitar habilidades p\xfablicas disponibles en el mercado de Cephable."},"allowMemberManagedSkills":{"title":"Permitir habilidades personales","description":"Los miembros pueden crear y potenciar sus propias habilidades personales."},"allowPublicMcpServers":{"title":"Permitir conectores p\xfablicos","description":"Los miembros pueden publicar o habilitar conectores p\xfablicos disponibles en el mercado de Cephable."},"allowMemberManagedMcpServers":{"title":"Permitir conectores personales","description":"Los miembros pueden crear y habilitar sus propios conectores MCP personales."}},"members":{"title":"Anulaciones por miembro","description":"Otorgar a un miembro individual la capacidad de compartir, gestionar o utilizar habilidades y contactos externos.","memberLabel":"Miembro","saved":"Permisos de miembro actualizados.","saveError":"No se pueden actualizar los permisos de los miembros.","loadError":"No se pudieron cargar los miembros de la organizaci\xf3n.","adminNote":"Este miembro es administrador de la organizaci\xf3n y ya tiene todos los permisos de extensi\xf3n."},"memberFlags":{"canShareSkillsWithOrganization":{"title":"Comparte tus habilidades con la organizaci\xf3n.","description":"Publica tus habilidades personales para que otros miembros puedan potenciarlas."},"canManageOrganizationSkills":{"title":"Gestionar las habilidades organizativas","description":"Crea, edita y elimina las habilidades compartidas con la organizaci\xf3n."},"canUseExternalSkills":{"title":"Utilizar habilidades externas","description":"Permitir el uso de habilidades p\xfablicas o personales incluso cuando la organizaci\xf3n las restrinja."},"canShareMcpServersWithOrganization":{"title":"Comparta los conectores con la organizaci\xf3n.","description":"Publica tus conectores personales para que otros miembros puedan activarlos."},"canManageOrganizationMcpServers":{"title":"Administrar conectores de la organizaci\xf3n","description":"Cree, edite y elimine conectores compartidos con la organizaci\xf3n."},"canUseExternalMcpServers":{"title":"Utilice conectores externos","description":"Permita el uso de conectores p\xfablicos o personales incluso cuando la organizaci\xf3n los restrinja."}},"skills":{"title":"Habilidades de organizaci\xf3n","description":"Preconfigura las habilidades para tu organizaci\xf3n. Los miembros pueden descubrirlas y activarlas desde sus aplicaciones.","create":"Crear habilidad","edit":"Habilidad de edici\xf3n"},"connectors":{"title":"Conectores de organizaci\xf3n","description":"Configure previamente los conectores MCP para su organizaci\xf3n. Los miembros deber\xe1n proporcionar sus propias credenciales en su dispositivo al habilitar uno.","create":"Agregar conector","edit":"Editar conector"},"sort":{"label":"Ordenar por","recent":"M\xe1s reciente","rating":"Mejor valorado","votes":"M\xe1s votado","installs":"La mayor\xeda instalada"},"list":{"loadError":"No se pudo cargar la lista.","emptyTitle":"Aqu\xed todav\xeda no hay nada","emptyDescription":"Crea uno para que est\xe9 disponible para los miembros de tu organizaci\xf3n."},"stats":{"rating":"Calificaci\xf3n promedio","installs":"Miembros que utilizan este","votes":"Puntuaci\xf3n de la votaci\xf3n","comments":"Comentarios"},"feedback":{"open":"Calificaciones y comentarios","description":"Las valoraciones y los comentarios se comparten dentro de su organizaci\xf3n.","yourRating":"Tu calificaci\xf3n","upvote":"Voto positivo","downvote":"Voto negativo","comments":"Comentarios","commentPlaceholder":"Comparte c\xf3mo funciona esto para tu equipo\u2026","replyPlaceholder":"Escribe una respuesta\u2026","noComments":"A\xfan no hay comentarios. Inicia la conversaci\xf3n.","member":"Miembro","deleted":"Este comentario fue eliminado.","reply":"Responder","loadError":"No se pudieron cargar los comentarios.","rateError":"No se pudo guardar tu calificaci\xf3n.","commentError":"No se pudo publicar tu comentario.","deleteError":"No se puede eliminar el comentario."},"usage":{"description":"Vea qu\xe9 miembros han habilitado cada habilidad y conector de la organizaci\xf3n.","skillsTitle":"Uso de habilidades","connectorsTitle":"Uso del conector","empty":"Ning\xfan miembro ha habilitado nada en esta categor\xeda todav\xeda.","installCount":"{{count}} miembro(s)","accountWide":"Todos los dispositivos","perDevice":"Dispositivo \xfanico","unnamed":"Intitulado","loadError":"No se pudo cargar el uso."}}},"canManageGlobalAutomationRules":{"title":"Gestionar la gobernanza","description":"Los usuarios con este permiso pueden administrar las reglas de automatizaci\xf3n de la organizaci\xf3n y las asignaciones de miembros."}},"customControls":{"title":"Controles Globales y Dispositivos","prefixDisclaimer":" Este es un control de prefijo; escuchar\xe1 las palabras despu\xe9s del comando y luego buscar\xe1 en la siguiente frase para encontrar coincidencias.","allowPausedDisclaimer":" Este control funcionar\xe1 incluso cuando el micr\xf3fono est\xe9 en pausa.","conflictIndicators":{"warn":"Atenci\xf3n: ","title":"Se detectaron conflictos de configuraci\xf3n de entrada","globalControls":"Conflictos de configuraci\xf3n de control global","deviceControls":"Conflictos de configuraci\xf3n de control de dispositivos","usedInput":" se utiliza como entrada para ","description":"Algunas de las entradas de los controles globales y de dispositivo que utiliza tambi\xe9n se utilizan en uno o m\xe1s controles de su aplicaci\xf3n. Esto puede causar conflictos al usar Cephable. En estos casos, siempre daremos prioridad al control de la aplicaci\xf3n sobre el control global o de dispositivo.","item":"La entrada <strong>{{value}}</strong> se utiliza en los controles de su aplicaci\xf3n: ","globalDescription":"Los siguientes controles globales tienen entradas en conflicto con los controles de su aplicaci\xf3n.","deviceDescription":"Los siguientes controles del dispositivo tienen entradas en conflicto con los controles de su aplicaci\xf3n."},"globalControls":{"title":"Controles Globales","empty":"T\xfa no tienes controles globales. Puede crear uno ahora.","edit":"Editar Controles Globales","description":"Los controles globales son controles que siempre est\xe1n disponibles, independientemente de la aplicaci\xf3n o el dispositivo que uses. Algunos incluso funcionan cuando los controles del micr\xf3fono o la c\xe1mara est\xe1n en pausa."},"deviceControls":{"title":"Controles del Dispositivo","empty":"T\xfa no tienes controles de dispositivo. Puede crear uno ahora.","edit":"Editar Controles del Dispositivo","controls":{"cephable-open-app":{"success":"Abrir aplicaci\xf3n: {{value}}","error":"No se puede encontrar la aplicaci\xf3n: {{value}}"},"cephable-close-app":{"commands":["cerca"],"name":"Cerrar aplicaci\xf3n por nombre","description":"Utilice este comando con controles de voz para cerrar una aplicaci\xf3n en su computadora por nombre.","success":"Cerrar aplicaci\xf3n: {{value}}","error":"No se puede encontrar la aplicaci\xf3n: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimizar"],"name":"Minimizar la aplicaci\xf3n actual en foco.","description":"Utilice este comando con controles de voz para minimizar la aplicaci\xf3n actual en foco.","success":"\xa1Minimiza el \xe9xito de las aplicaciones enfocadas!","error":"Error al minimizar la aplicaci\xf3n enfocada."},"cephable-maximize-focused-app":{"commands":["maximizar"],"name":"Maximizar la aplicaci\xf3n actual en foco.","description":"Utilice este comando con controles de voz para maximizar la aplicaci\xf3n actual en foco.","success":"\xa1Maximice el \xe9xito de su aplicaci\xf3n enfocada!","error":"Error al minimizar la aplicaci\xf3n enfocada."},"cephable-generate-text":{"commands":["generar"],"name":"Genere texto proporcionando el mensaje que sigue a este comando.","description":"Utilice este comando con controles de voz seguido de su mensaje para generar un texto relacionado."},"cephable-stop-generate-text":{"commands":["dejar de generar","detener la generaci\xf3n","cancelar generar","cancelar generaci\xf3n"],"name":"Deja de generar texto.","description":"Utilice este comando con controles de voz para dejar de generar texto"},"cephable-open-panel":{"commands":["panel de exhibici\xf3n"],"name":"Abra el panel de Cephable","description":"Utilice este comando con controles de voz para abrir el panel de Cephable."},"cephable-close-panel":{"commands":["ocultar panel"],"name":"Ocultar el panel Cephable","description":"Utilice este comando con controles de voz para ocultar o minimizar el panel de Cephable."},"cephable-close-focused-app":{"commands":["corriente cerrada"],"name":"Cierra la aplicaci\xf3n actual en foco.","description":"Utilice este comando con controles de voz para cerrar la aplicaci\xf3n actual en foco.","success":"Cerrar aplicaci\xf3n actual \xa1\xe9xito!","error":"Error al cerrar la aplicaci\xf3n actual."},"cephable-rewrite-text":{"commands":["volver a escribir"],"name":"Reescriba el texto proporcionando la indicaci\xf3n despu\xe9s de este comando.","description":"Utilice este comando con controles de voz seguido de su indicaci\xf3n para reescribir el texto resaltado actual."},"cephable-summarize-text":{"commands":["resumir"],"name":"Resuma el texto proporcionando la instrucci\xf3n siguiente a este comando.","description":"Utilice este comando con controles de voz seguido de su mensaje para resumir el texto resaltado actual."},"cephable-translate-text":{"commands":["traducir"],"name":"Traduzca el texto proporcionando la solicitud despu\xe9s de este comando.","description":"Utilice este comando con controles de voz seguido de su indicaci\xf3n para traducir el texto resaltado actual."},"cephable-click-by-name":{"commands":["grifo","golpear","navegar a","ir a"],"name":"Toque el elemento por nombre","description":"Pulsa el nombre de un elemento de la p\xe1gina, por ejemplo, \\"pulsa guardar\\" para hacer clic en el bot\xf3n \\"Guardar\\". Esto es similar al control por voz, que permite seleccionar elementos mediante comandos de voz en lugar de usar el rat\xf3n."},"cephable-automate":{"commands":["automatizar","intentar","tener cef\xe1lico","realizar un flujo de trabajo para","seguir trabajando"],"name":"Ejecute un flujo de trabajo de IA describiendo una tarea despu\xe9s de este comando.","description":"Utilice este comando con controles de voz seguido de una tarea, como por ejemplo \\"automatizar el env\xedo de un correo electr\xf3nico a mi equipo\\", y Cephable lo ejecutar\xe1 como un flujo de trabajo de IA."},"cephable-paste-background-entry":{"commands":["pegar entrada reciente","pegar \xfaltima entrada","pegar \xfaltimo dictado","pegar contenido de fondo"],"name":"Pegue el contenido de fondo m\xe1s reciente.","description":"Utilice este comando para pegar el contenido m\xe1s reciente almacenado en segundo plano en la aplicaci\xf3n activa."}},"description":"Los controles del dispositivo est\xe1n vinculados al dispositivo o conexi\xf3n espec\xedficos que uses. Est\xe1n disponibles sin necesidad de a\xf1adirlos a los controles de tu app y son especialmente \xfatiles para funciones o eventos que solo son compatibles con ciertos dispositivos."},"resetControls":{"title":"Restablecer Controles","description":"El idioma de tu voz ha cambiado desde la \xfaltima vez que actualizaste tus controles. Nota: Esto restablecer\xe1 tus controles para que coincidan con {{language}} y es posible que pierdas los comandos personalizados. \xbfEst\xe1s seguro de que deseas restablecerlos?","confirm":"S\xed, restablecer controles","error":"Se produjo un error al restablecer los controles. Int\xe9ntalo nuevamente m\xe1s tarde."},"warn":"El micr\xf3fono no se ha iniciado. Debe iniciarlo para usar los controles globales y del dispositivo.","changeProfile":{"success":"Cambiar los controles de la aplicaci\xf3n: {{value}}","error":"No se pueden encontrar los controles de la aplicaci\xf3n: \'{{value}}\'"},"descriptionShort":"Los controles globales y de dispositivo son acciones siempre disponibles, dise\xf1adas para funcionar en cualquier software. Los controles globales, como \\"Detener c\xe1mara\\", se aplican a todo el sistema y son independientes de la aplicaci\xf3n, mientras que los controles de dispositivo se adaptan a la conexi\xf3n de cada dispositivo y ofrecen funciones m\xe1s avanzadas que los controles est\xe1ndar de la aplicaci\xf3n.","description":"Los controles globales y de dispositivo son acciones siempre disponibles, dise\xf1adas para funcionar en cualquier software. Los controles globales, como \\"Detener c\xe1mara\\", son para todo el sistema e independientes de la aplicaci\xf3n, mientras que los controles de dispositivo se adaptan a la conexi\xf3n de cada dispositivo y ofrecen funciones m\xe1s avanzadas que los controles est\xe1ndar de la aplicaci\xf3n. Actualmente, se accede a estos controles mediante comandos de voz; sin embargo, pr\xf3ximamente a\xf1adiremos compatibilidad con otras entradas.","noDevice":"Este paso usa una extensi\xf3n personalizada que no has configurado para tu cuenta. Agrega la extensi\xf3n para desbloquear este paso."},"notifications":{"title":"Notificaciones","center":"Centro de notificaciones","empty":"No tienes notificaciones en este momento. Vuelve a consultar en otro momento.","seen":"Visto","markAsRead":"Marcar como le\xeddo","view":"Ver todas las notificaciones de {{value}}"},"unsaved":{"title":"Tiene cambios sin guardar.","description":"Tiene cambios sin guardar. \xbfEst\xe1s seguro de que quieres salir esta p\xe1gina?","cancel":"Salir sin guardar","confirm":"Guardar y Salir"},"login":{"welcome":"\xa1Bienvenidos a Cephable!","subtitle":"Controle tu tecnolog\xeda seg\xfan <strong>tus propios</strong> t\xe9rminos.","create":"Crear Una Cuenta","signIn":"Iniciar Sesi\xf3n","loading":"Redirigiendo para iniciar sesi\xf3n...","error":"Se produjo un error al iniciar sesi\xf3n. Inicie sesi\xf3n nuevamente.","existingAccount":"\xbfYa tienes una cuenta?","description":"Controla. Crea. Automatiza. Cephable: tu IA personal para comandos r\xe1pidos, redacci\xf3n contextual y flujos de trabajo automatizados. Sin procesamiento en la nube. Asistencia fluida que te acompa\xf1a en todo momento."},"home":{"title":"Principal","startControls":"\xa1Encenderlo!","manage":"Configurar","profileGenerate":{"title":"Ups. Parece que a\xfan no tienes ning\xfan control de aplicaci\xf3n.","description":"Para que Cephable controle tu ordenador, necesitamos saber qu\xe9 quieres controlar. Puedes crear controles de aplicaci\xf3n desde cero o pedirnos ayuda para crear uno con nuestro generador de controles."}},"wizard":{"description":"Luego, Cephable utilizar\xe1 esta informaci\xf3n para generar controles que usted podri\xe1 revisar y probar.","includeDefaultKeysQuestion":"\xbfIncluye comandos de voz predeterminados para teclas y clics del rat\xf3n?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code, etc.","generate":"Generar controles","complete":{"title":"\xa1Muy bien, hemos terminado!","description":"Haga clic en el bot\xf3n abjajo para ver los controles que generamos. Podr\xe1s editar, agregar o eliminar manualmente cualquier aspecto para perfeccionarlo.","viewControls":"Ver mis controles"},"error":{"emptyInput":"Seleccione al menos un m\xe9todo de entrada","emptyApp":"Por favor ingresa al menos el nombre de una aplicaci\xf3n","generatingProfile":"Error al generar controles de la aplicaci\xf3n"},"loading":{"title":"Estamos juntando todas las piezas","description":"Esto puede tardar hasta aproximadamente un minuto. No abandones esta p\xe1gina ni regreses o dejar\xe1 de generarse."},"selectedTips":{"title":"Consejo #{{count}}","previous":"Consejo anterior","next":"Siguiente consejo","two":"Puede controlar la sensibilidad de tus entradas en la secci\xf3n \\"Configuraci\xf3n de control de expresi\xf3n\\" del panel principal. Esto le permitir\xe1 refinar a\xfan m\xe1s las formas en que Cephable interpreta las entradas espec\xedficas para usted. \xa1Y Cephable mejora con el tiempo a medida que funciona contigo!","three":"Despu\xe9s de configurar esto, t\xfa tienes control total sobre la configuraci\xf3n. Le estamos brindando una l\xednea de base, pero en cualquier momento puede cambiar el mapeo entre lo que hace y lo que hace en la computadora.","four":"Puede imprimir tus controles para tener una copia f\xedsica mientras usa Cephable. Sabemos que todo esto es nuevo y requiere algo de tiempo para acostumbrarse. \xa1La pr\xe1ctica hace mejor!","one":"\xbfSab\xedas que puedes usar Cephable en un dispositivo para controlar otro? Descarga Cephable en tu m\xf3vil, tableta o incluso en otra computadora y elige la conexi\xf3n que quieres controlar (quiz\xe1s esta). \xa1Tus perfiles personales y de entrada son consistentes en todos! Solo aseg\xfarate de que Cephable se est\xe9 ejecutando en tu dispositivo y conexiones."},"steps":{"one":"Paso 1. Escribe el nombre de la aplicaci\xf3n que quieres controlar.","two":"Paso 2. Confirme los controles de entrada que quieres utilizar:","three":"Paso 3. (opcional) ","threeContinued":"Describe cualquier acci\xf3n espec\xedfica que te gustar\xeda configurar para los comandos que usas com\xfanmente o por los que tienes una fuerte preferencia. Utilice un ingl\xe9s sencillo como los que aparecen a continuaci\xf3n."},"noOptionsText":"Comience a escribir para encontrar una aplicaci\xf3n que quiere controlar.","title":"Generar controles de aplicaci\xf3n","titleLong":"Generar controles de aplicaci\xf3n","try":"Pruebe el generador de control","placeholder":"Aseg\xfarate de que los comandos de voz sean cortos.\\n\\nQuiero poder decir \\"adelante\\" para pasar a la siguiente diapositiva de la presentaci\xf3n.\\n\\nQuiero usar el movimiento de la cabeza para mover el cursor y los controles de voz para editar atajos.\\n\\nA\xf1adir botones de acci\xf3n r\xe1pida para todos los movimientos y habilidades de mi personaje."},"macros":{"title":"Control","titlePlural":"Control S","description":"Los controles contienen una entrada (acci\xf3n que le gusta inclinar la cabeza) y pasos que Cephable realizar\xe1 despu\xe9s de que se haya registrado esa acci\xf3n de entrada. Puede utilizar controles para crear una combinaci\xf3n de pasos que se activan con una \xfanica entrada.","new":"Crear un nuevo control","newDescription":"Cree un nuevo control para combinar m\xfaltiples pasos y entradas.","add":"Agregar control","create":"Crear un control","name":{"title":"Nombre del control","question":"\xbfC\xf3mo quieres llamar a este control?","description":"Asigne un nombre a tu control para que pueda encontrarlo f\xe1cilmente m\xe1s tarde.","placeholder":"acci\xf3n que este control est\xe1 haciendo como \\"saltar\\" o \\"acercar\\""},"empty":"A\xfan no tienes controles. Haga clic a continuaci\xf3n para crear uno.","copySuffix":"{{name}}_copia"},"event":{"title":"Paso","titlePlural":"Pasos","previewSummaryPlural":"{{first}} y {{total}} eventos m\xe1s","add":"Agregar paso","stepType":"Tipo de paso","select":"Seleccione el tipo de paso que desea agregar.","question":"\xbfQu\xe9 tipo de acciones quieres que realice Cephable?","setup":"Configura tu paso","description":"Los pasos son las acciones que Cephable realizar\xe1 despu\xe9s de que se haya activado la entrada. Puede agregar varios pasos a un control para crear una combinaci\xf3n de acciones.","expand":"Ampliar para ver el resto de pasos","stepUp":"Mueve Paso Arriba","stepDown":"Mueve paso Abajo","stepCopy":"Copia paso","stepRemove":"Elimine paso","insertStep":"Inserte paso abajo","showOptions":"Muestre opciones","hideOptions":"Ocuelte opciones","hold":"Tiempo de espera (en milisegundos)","error":"Debes configurar tu paso.","multiple":"M\xfaltiples pasos","deviceTypeCustomAction":{"title":"Acci\xf3n de dispositivo personalizada"},"keyPress":{"title":"Presione la tecla o el bot\xf3n ","short":"Prensa","fieldSet":"Teclas o bot\xf3n para presionar","label":"Tecla o Bot\xf3n","holdTime":"Tiempo de retenci\xf3n de la tecla (en milisegundos)","description":"Presione una tecla del teclado sin usar el teclado.","longDescription":"Esta funci\xf3n simula la pulsaci\xf3n de una tecla en tu teclado. Por ejemplo, si tiene dificultades para presionar teclas f\xedsicas, puede usar un comando de voz u otro m\xe9todo de entrada para \\"presionar\\" una tecla virtualmente.","example":"Diga \\"Intro\\" para enviar un correo electr\xf3nico sin presionar f\xedsicamente la tecla Intro.","timing":"Momento de pulsaci\xf3n de tecla","tap":"Grifo","tapLong":"Toque el bot\xf3n","latch":"Pestillo","latchLong":"Mantener hasta que se suelte","hold":"Sostener","holdLong":"Mantener por una cantidad de tiempo","toggle":"Alternar","toggleLong":"Alternar acci\xf3n","release":"Soltar","releaseLong":"Soltar acci\xf3n","latchLabel":"Mantenga presionado <strong>{{value}}</strong> hasta que se suelte","tapLabel":"Toca <strong>{{value}}</strong>","pressLabel":"Presione <strong>{{value}}</strong> durante <strong>{{time}}</strong> milisegundos","remove":"Eliminar pulsaci\xf3n de tecla","add":"Agregar tecla/bot\xf3n para presionar"},"keyRelease":{"title":"Soltar tecla o bot\xf3n","short":"Liberar","selected":"Claves seleccionadas para liberar","description":"Suelta una tecla del teclado que hayas presionado y mantenido.","longDescription":"Esta funci\xf3n simula la liberaci\xf3n de una tecla de tu teclado. Debe usarse junto con una pulsaci\xf3n de tecla que se mantiene indefinidamente. Por ejemplo, si tiene dificultades para presionar teclas f\xedsicas, puede usar un comando de voz u otro m\xe9todo de entrada para \\"soltar\\" una tecla virtualmente.","example":"Diga \\"Detener\\" despu\xe9s de decir \\"Activar\\" para detener la ejecuci\xf3n.","label":"Liberar <strong>{{value}}</strong>","add":"Agregar tecla/bot\xf3n para liberar","remove":"Quitar liberaci\xf3n de clave"},"keyToggle":{"title":"Alternar tecla o bot\xf3n","short":"Palanca","selected":"Teclas seleccionadas para alternar","description":"Enciende o apaga una tecla del teclado como un interruptor de luz con un solo control.","longDescription":"Esto activa o desactiva la funci\xf3n de una tecla, como un interruptor. Es \xfatil para claves que desea conservar durante un per\xedodo de tiempo indeterminado. Puede usar esto para mantener la misma acci\xf3n tanto al presionar como al soltar o detener la tecla.","example":"Diga \\"Alternar ejecuci\xf3n\\" para comenzar a ejecutar. Diga \\"Alternar ejecuci\xf3n\\" para detener la ejecuci\xf3n.","label":"Alternar <strong>{{value}}</strong>","add":"Agregar tecla/bot\xf3n para alternar","remove":"Quitar palanca de clave"},"pause":{"title":"Pausa","description":"Agregue un breve retraso entre acciones.","longDescription":"Esta funci\xf3n le permite insertar un breve retraso entre acciones, lo cual es esencial en situaciones en las que una acci\xf3n debe completarse por completo antes de que comience la siguiente. Por ejemplo, si est\xe1 utilizando un comando para poner el texto en negrita en un documento, es posible que primero deba abrir un men\xfa contextual. La funci\xf3n Pausa da tiempo suficiente para que el men\xfa contextual se abra y se active antes de continuar con el siguiente paso, lo que garantiza un funcionamiento fluido y sin errores.","example":"Imagina que est\xe1s editando un documento usando comandos de voz. Dices \\"Formate texto\\", lo que abre un men\xfa contextual. Luego, despu\xe9s de una breve pausa para permitir que el men\xfa aparezca por completo, dice \\"Negrita\\" para aplicar formato en negrita al texto seleccionado. La funci\xf3n Pausa garantiza que el men\xfa contextual est\xe9 listo para recibir tu siguiente comando.","label":"Pausa durante <strong>{{value}}</strong> milisegundos"},"type":{"title":"Escribir","field":"Frase a escribir","placeholder":"frase escrita","question":"\xbfQu\xe9 texto quieres escribir?","description":"Escriba texto como si usara un teclado.","longDescription":"Esto imita la escritura de una cadena de texto, similar a escribir en un teclado. Es ideal para ingresar texto m\xe1s largo sin necesidad de presionar cada tecla. Si desea ingresar texto din\xe1micamente, puede usar la funci\xf3n de Dictado.","example":"Diga \\"Nombre\\" para escribir \\"Hola, mi nombre es Ellen Ripley\\". en una ventana de chat.","label":"Escribe <strong>{{value}}</strong>"},"mouseMove":{"title":"Mueve el rat\xf3n","description":"Mueva el puntero en la pantalla.","longDescription":"Mueva el cursor o puntero de tu pantalla sin un rat\xf3n f\xedsico. Esto es especialmente \xfatil para usuarios con movilidad limitada de las manos. Esto es \xfatil para el control preciso del movimiento del rat\xf3n que se necesita en algunos juegos. Si desea simular todo el movimiento del rat\xf3n usando el movimiento de tu cabeza, puede probar el \'Movimiento de la cabeza para el control del rat\xf3n\' en la configuraci\xf3n de la c\xe1mara.","example":"Diga \\"Mueve rat\xf3n Derecha\\" para mover el cursor 100 p\xedxeles hacia la derecha.","moveX":"Mueve p\xedxeles hacia la izquierda/derecha con el rat\xf3n","numberMoveX":"N\xfamero de p\xedxeles para mover hacia la izquierda/derecha","moveY":"Mueve p\xedxeles hacia arriba/abajo con el rat\xf3n","numberMoveY":"N\xfamero de p\xedxeles para mover hacia arriba/abajo","label":"Mueve el rat\xf3n <strong>{{value}}</strong>","command":"Movimiento del rat\xf3n: {{command}}","commandLabel":"Movimiento del rat\xf3n","startCommand":"Inicio del movimiento del rat\xf3n","stopCommand":"Detener el movimiento del rat\xf3n"},"joystickMove":{"title":"Mover palancas de mando","description":"Utilice un joystick para mover cosas en la pantalla.","longDescription":"Esta funci\xf3n simula el movimiento de un joystick. Por ejemplo, si tiene dificultades para usar un joystick f\xedsico, puede usar un comando de voz u otro m\xe9todo de entrada para mover un joystick virtualmente.","example":"Diga \\"Mueve Joystick Izquierda\\" para mover el joystick hacia la izquierda 100 p\xedxeles.","prefix":"Mueva El Joystick Izquierda","left":"Palanca Izquierda","leftX":"X Izquierdo","leftY":"Y Izquierdo","right":"Palanca Derecha","rightX":"X Derecho","rightY":"Y Derecho","x":"Fuerza del eje X","y":"Fuerza del eje Y","moveXLabel":"Mueve X: {{value}}","moveYLabel":"Mueve Y: {{value}}","labelLeft":"Mueva el Joystick Izquierdo ","labelRight":"Mueva el joystick Derecho ","latch":"El pestillo mantendr\xe1 la posici\xf3n hasta que lo sueltes utilizando el comando \\"Detener todo\\"."},"playAudio":{"title":"Reproducir audio","placeholder":"frase de afirmacion que dira Cephable","description":"Reproduce un sonido, palabra o frase.","longDescription":"Esta funci\xf3n permite a los usuarios convertir frases escritas en palabras habladas. Es especialmente \xfatil para personas que pueden tener dificultades para hablar. Al escribir una frase, la funci\xf3n PlayAudio articular\xe1 el texto en voz alta mediante voz sintetizada. Esto puede ayudar en la comunicaci\xf3n o en situaciones en las que un usuario necesita transmitir informaci\xf3n verbalmente pero prefiere o requiere una alternativa al uso de tu propia voz.","example":"Sonr\xede para reproducir la palabra \\"Hola\\".","label":"Habla <strong>\\"{{value}}\\";</strong>"},"stopOutputs":{"title":"Detener todas las salidas","titleLong":"Detenga todas las salidas (suelte todas las teclas y botones, detenga todos los movimientos del rat\xf3n, deje de escribir)","description":"Detenga todas las acciones en curso, como presionar una tecla.","longDescription":"Detenga inmediatamente todos los resultados o acciones en curso. Esta es una caracter\xedstica de seguridad o conveniencia para detener cualquier proceso. Haremos esto autom\xe1ticamente cuando cierre o ponga en pausa los controles de la c\xe1mara o el micr\xf3fono.","example":"Diga \\"Detener\\" para detener todas las salidas.","label":"Detenga todas las salidas y suelte las teclas."},"custom":{"title":"Costumbre"},"options":{"moveUp":"Mueve Arriba","moveDown":"Mueve Abajo","moveLeft":"Mueve Izquierda","moveRight":"Mueve Derecha","copyStep":"Copia paso","removeStep":"Elimine paso"},"directions":{"up":"Arriba","down":"Abajo","left":"Izquierda","right":"Derecha"}},"expression":{"title":"Expresi\xf3n Facial","titlePlural":"Expresiones Faciales","label":"Expresi\xf3n / Gesto","start":"Iniciar controles de expresi\xf3n","startSmiling":{"title":"Empezar a sonre\xedr","description":"Si empiezas a sonre\xedr sin sonre\xedr y luego lo haces, se activar\xe1 este control. Nota: Usar este control en la misma aplicaci\xf3n que el control de apertura/cierre de boca puede causar conflictos."},"stopSmiling":{"title":"Deja de sonre\xedr","description":"Si sonr\xedes y luego dejas de sonre\xedr, se activar\xe1 este control. Nota: Usar este control en la misma aplicaci\xf3n que el control de apertura/cierre de boca puede generar conflictos."},"eyebrows":{"title":"Levantar las cejas","description":"Si levantas ambas cejas desde tu posici\xf3n inicial de reposo, este control se activar\xe1."},"openMouth":{"title":"Boca abierta","description":"Si tienes la boca cerrada (o si tu l\xednea base est\xe1 ligeramente abierta) y la abres m\xe1s, se activar\xe1 este control. Nota: Usar este control en la misma aplicaci\xf3n que el control de sonrisa puede causar conflictos."},"closeMouth":{"title":"Boca cerrada","description":"Si tienes la boca abierta y la cierras por completo, se activar\xe1 este control. Nota: Usar este control en la misma app que el control de sonrisa puede causar conflictos."},"description":"Mejora tu experiencia digital con expresiones faciales. Usa gestos como levantar las cejas, sonre\xedr y otros movimientos para controlar el puntero del rat\xf3n, realizar acciones o personalizar tus interacciones."},"head":{"title":"Movimiento de Cabeza","titlePlural":"Movimientos de Cabeza","label":"Movimiento de cabeza/cuerpo","question":"\xbfQu\xe9 tipo de movimiento quieres usar?","tilt":{"title":"Inclinaci\xf3n de Cabeza","left":{"title":"Incline la Cabeza Izquierda","description":"Si est\xe1s mirando a la c\xe1mara e inclinas la cabeza hacia la izquierda, este control se activar\xe1."},"right":{"title":"Incline la Cabeza Derecha","description":"Si est\xe1s mirando a la c\xe1mara e inclinas la cabeza hacia la derecha, este control se activar\xe1."},"back":{"title":"Incline la Cabeza Atr\xe1s","description":"Si est\xe1 mirando a la c\xe1mara e inclina la cabeza hacia atr\xe1s y mira hacia arriba, este control se activar\xe1."},"forward":{"title":"Incline la Cabeza Adelante","description":"Si est\xe1 mirando a la c\xe1mara e inclina la cabeza hacia adelante y mira hacia abajo, este control se activar\xe1."},"description":"Incline la cabeza hacia la izquierda o la derecha para un mejor control o navegaci\xf3n con el mouse."},"turn":{"title":"Giro de Cabeza","left":{"title":"Gire la Cabeza Izquierda","description":"Si est\xe1 mirando a la c\xe1mara, gira la cabeza y mira hacia la izquierda, este control se activar\xe1."},"right":{"title":"Gire la Cabeza Derecha","description":"Si est\xe1 mirando a la c\xe1mara, gira la cabeza y mira hacia la derecha, este control se activar\xe1."},"description":"Gire la cabeza hacia la izquierda o hacia la derecha para un mejor control o navegaci\xf3n con el mouse."},"lean":{"title":"Cabeza Inclinada","left":{"title":"Cabeza Inclinada Izquierda","description":"Si est\xe1 mirando a la c\xe1mara y se inclina hacia la izquierda para que tu cara quede m\xe1s a la izquierda en el marco de la c\xe1mara, este control se activar\xe1."},"right":{"title":"Cabeza Inclinada Derecha","description":"Si est\xe1s mirando a la c\xe1mara y te inclinas hacia la derecha para que tu cara est\xe9 m\xe1s a la derecha en el marco de la c\xe1mara, este control se activar\xe1."},"back":{"title":"Cabeza Inclinada Atr\xe1s","description":"Si est\xe1 mirando a la c\xe1mara y se inclina hacia atr\xe1s para que tu cara est\xe9 m\xe1s alejada de la c\xe1mara, este control se activar\xe1."},"forward":{"title":"Cabeza Inclinada Adelante","description":"Si est\xe1 mirando a la c\xe1mara y se inclina hacia adelante para que tu cara est\xe9 m\xe1s cerca de la c\xe1mara, este control se activar\xe1."},"up":{"title":"Mueve Cuerpo Arriba","description":"Si est\xe1s mirando a la c\xe1mara y mueves la cabeza hacia arriba estirando el cuello o moviendo todo el cuerpo hacia arriba, este control se activar\xe1."},"down":{"title":"Mueve Cuerpo Abajo","description":"Si est\xe1s mirando a la c\xe1mara y mueves la cabeza hacia abajo arrugando el cuello, agach\xe1ndote o bajando todo el cuerpo, este control se activar\xe1."},"center":{"title":"Centra tu Cabeza","description":"Si est\xe1 mirando a la c\xe1mara y mueve la cabeza hacia la posici\xf3n central que coincide con la l\xednea de base, este control se activar\xe1."},"description":"Incline la cabeza hacia la izquierda o la derecha para obtener un mejor control o navegaci\xf3n con el mouse."},"description":"Controla tu dispositivo o conexi\xf3n con movimientos de cabeza como inclinar, asentir o girar. Con la c\xe1mara de tu dispositivo, Cephable garantiza una experiencia privada e intuitiva para un control mejorado o navegaci\xf3n con el rat\xf3n."},"voice":{"title":"Control de Voz","titlePlural":"Controles de Voz","placeholder":"Voz o frase que Cephable escuchar\xe1","question":"\xbfQu\xe9 afirmaci\xf3n o frase quieres decir para este control?","when":"Cuando yo digo...","say":"Diga \'{{value}}\'","load":{"fail":{"title":"Controles de voz en {{language}} no disponibles","description":"\xa1Oh, no! No pudimos cargar {{language}} para los controles de voz. Por favor verifique tu conexi\xf3n a Internet y int\xe9ntelo nuevamente. Cambiando al Ingl\xe9s (Estados Unidos) hasta que hay conexi\xf3n de internet."}},"description":"Al activar el micr\xf3fono, se activan comandos de voz inteligentes y naturales, lo que permite a los usuarios interactuar fluidamente con su computadora en diferentes aplicaciones y software. Hable con naturalidad para ejecutar comandos o dictar texto, creando una experiencia intuitiva y sin esfuerzo."},"motion":{"title":"Control de Movimiento","titlePlural":"Controles de Movimiento","question":"\xbfQu\xe9 tipo de movimiento con un tel\xe9fono o tableta quieres usar?","start":"Iniciar Controles de Movimiento","settings":"Configuraci\xf3n de movimiento","descriptionShort":"Incline, gire o agite tu dispositivo para controlar Cephable.","description":"Los controles de movimiento le permiten convertir el movimiento de tu tel\xe9fono o tableta en la aplicaci\xf3n complementaria en controles para tu dispositivo. Incline o agite tu tel\xe9fono en diferentes direcciones para crear nuevas salidas.","up":{"title":"Incline Tu Dispositivo Arriba","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia usted, este control se activar\xe1."},"down":{"title":"Incline tu Dispositivo Abajo","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia abajo para mirar hacia afuera, este control se activar\xe1."},"left":{"title":"Incline Tu Dispositivo Izquierda","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia la izquierda, este control se activar\xe1."},"right":{"title":"Incline Tu Dispositivo Derecha","description":"Si tu dispositivo est\xe1 plano sobre una superficie y lo inclina hacia la derecha, este control se activar\xe1."},"shake":{"title":"Agite Tu Dispositivo","description":"Si agita tu dispositivo, este control se activar\xe1."},"edit":{"title":"Editar configuraci\xf3n de movimiento","description":"Cambie la configuraci\xf3n de control de movimiento para ajustar cu\xe1nto necesita mover tu tel\xe9fono mientras ejecuta la aplicaci\xf3n complementaria","sensitivity":{"title":"Configuraci\xf3n de sensibilidad del control de movimiento","description":"La sensibilidad le dice a Cephable hasta qu\xe9 punto debe inclinar tu dispositivo para activar un control. Cuanto mayor sea el valor (m\xe1s a la derecha en el control deslizante), mayor ser\xe1 la sensibilidad y, por lo tanto, menos necesitar\xe1 inclinarse para activar el control."},"tilt":{"title":"Sensibilidad de Inclinaci\xf3n","description":"Estos valores determinan cu\xe1nto debe inclinar tu dispositivo hacia arriba, abajo, izquierda y derecha para que se reconozca una entrada."},"mouse":{"title":"Controles de Movimiento para el Movimiento del Rat\xf3n","description":"Determine si desea utilizar los controles de movimiento para mover el rat\xf3n y c\xf3mo hacerlo en lugar de activar los controles.","enable":{"title":"Habilitar controles de movimiento para el movimiento del rat\xf3n","description":"Si esto est\xe1 activado, algunos de tus controles de movimiento se usar\xe1n para mover el rat\xf3n en lugar de los controles de activaci\xf3n.","option":"\xbfUtiliza controles de movimiento para el movimiento del rat\xf3n?"},"invert":{"title":"Invertir el movimiento del rat\xf3n","description":"Para el eje X: si esto est\xe1 activado, al moverlo hacia la izquierda se mover\xe1 el rat\xf3n hacia la derecha y si se mueve hacia la derecha lo mover\xe1 hacia la izquierda. Para el eje Y: si esto est\xe1 activado, al moverlo hacia abajo, el rat\xf3n se mover\xe1 hacia arriba y al moverlo hacia arriba, lo mover\xe1 hacia abajo.","x":"\xbfInvertir el movimiento del rat\xf3n en el eje X?","y":"\xbfInvertir el movimiento del rat\xf3n en el eje Y?"}}}},"keys":{"title":"Tecla o Bot\xf3n","titlePlural":"Teclas o botones","label":"Tecla/bot\xf3n externo","question":"\xbfQu\xe9 tecla o bot\xf3n quieres presionar?","edit":"Editar Teclas y Botones","defaultOption":"\xbfIncluye comandos de voz predeterminados para teclas y clics del rat\xf3n?","description":"Las teclas y botones le permiten asignar tus diferentes controles de entrada a las pulsaciones de botones del teclado y del controlador.","then":"Cephable presionar\xe1...","empty":"No hay controles clave que coincidan con este criterio.","backspace":"Retroceso","delete":"Borrar","enter":"Ingresar","space":"Barra espaciadora","tab":"Pesta\xf1a","shift":"Cambio","ctrl":"Control","leftCtrl":"Ctrl Izquierdo","rightCtrl":"Ctrl Derecho","leftShift":"Shift Izquierdo","rightShift":"Shift Derecha","alt":"Alt","leftAlt":"Alt Izquierda","escape":"Escapar","up":"Flecha Arriba","down":"Flecha Abajo","left":"Flecha Izquierda","right":"Flecha Derecha","command":"Dominio","caps":"Bloq May\xfas","reset":{"title":"Restablecer combinaciones de teclas","confirm":"\xbfRestablecer todas las combinaciones de teclas?","confirmDescription":"Elige c\xf3mo quieres restablecer las combinaciones de teclas. Esta acci\xf3n no se puede deshacer sin guardar.","confirmButton":"Restablecer la configuraci\xf3n de teclas","defaultOption":"Restablecer a los valores predeterminados para el idioma actual.","emptyOption":"Restablecer a vac\xedo (borrar todos los comandos)"}},"talkback":{"title":"Replicar","question":"\xbfQu\xe9 quieres que diga Cephable?","description":"Controles de configuraci\xf3n que har\xe1n que Cephable hable por usted. Puedes asignar controles a diferentes frases que quieras que se pronuncien.","thenMacro":"entonces Cephable dir\xe1...","empty":"No hay controles de talkback que coincidan con este criterio.","add":"Agregar un nuevo control de conversaci\xf3n","remove":"Quitar el control de conversaci\xf3n","edit":"Editar controles de conversaci\xf3n","deprecatedNotice":"Talkback ahora est\xe1 integrado directamente en los controles principales de la aplicaci\xf3n. Tus controles de la aplicaci\xf3n tienen algunos eventos de Talkback antiguos que deben actualizarse."},"dictation":{"title":"Dictado","question":"\xbfQu\xe9 frase deber\xeda activar el modo de dictado?","thenMacro":"Cephable voluntad...","empty":"No hay controles de dictado que coincidan con este criterio.","type":"escribir a m\xe1quina","edit":"Editar Frases de Dictado","remove":"Eliminar Frase de Dictado","add":"Agregar Nueva Frase de Dictado","on":"Dictado","off":"Comandos","onboarding":{"tourLabel":"Dictado","learn":"Aprenda a utilizar el modo de dictado para convertir su voz en texto sin necesidad de usar manos libres.","welcome":{"title":"Dictado","description":"El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."},"microphone":{"title":"Enciende tu micr\xf3fono","description":"Primero, activa el micr\xf3fono. Haz clic en el interruptor de micr\xf3fono en el panel de Cephable."},"activate":{"title":"Iniciar el modo de dictado","description":"La voz se inicia en modo comando. Para iniciar el dictado, diga \\"Iniciar dictado\\" o haga clic en el bot\xf3n Dictado. Activemos el modo de dictado."},"speaking":{"title":"Haga clic en un documento o campo y comience a hablar","description":"El dictado escribir\xe1 en tiempo real lo que digas. Haz clic en un campo de texto o documento y empieza a hablar. Por ejemplo, di: \\"As\xed se usa el modo de dictado\\"."},"pauseResume":{"title":"Pausa del dictado","description":"\xbfNecesitas un descanso sin desactivar el dictado? Simplemente di \\"Pausar dictado\\". Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\". Puedes personalizarlo a\xfan m\xe1s con los controles globales y del dispositivo siempre activos."},"stop":{"title":"Detener el dictado","description":"\xbfNecesitas volver a los controles de tu aplicaci\xf3n? Simplemente di \\"Detener dictado\\". Esto detendr\xe1 el modo de dictado y te permitir\xe1 volver al modo comando. Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\"."},"complete":{"title":"\xa1Felicitaciones!","description":"\xa1Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. \xdasalo para escribir correos electr\xf3nicos, documentos o cualquier otra cosa que necesites escribir en voz alta."}},"description":"El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices.","settings":{"title":"Dictado","description":"C\xf3mo comienza el dictado y qu\xe9 sucede con tus palabras antes de que se escriban."},"hold":{"enabled":{"option":"Mantener para dictar","description":"Mant\xe9n pulsadas las teclas de abajo, y ninguna otra, para empezar a dictar. Su\xe9ltalas para escribir lo que has dicho."},"keys":{"title":"Llaves para sostener","description":"Si pulsas cualquier otra tecla mientras mantienes pulsadas estas, se cancelar\xe1 la acci\xf3n, por lo que tus atajos habituales seguir\xe1n funcionando."},"duration":{"title":"Tiempo de espera","description":"\xbfCu\xe1nto tiempo hay que mantener pulsadas las teclas antes de que empiece el dictado?"},"transcribing":"Transcribir...","aiRewriting":"Reescritura por IA...","result":"{{palabras}} palabras en {{segundos}}s","resultRewritten":"{{words}} palabras en {{seconds}}s, IA {{rewriteSeconds}}s","typing":"Mecanograf\xeda...","permission":{"title":"Mantener pulsado para dictar est\xe1 esperando permiso","description":"Concede acceso a Cephable en Configuraci\xf3n del sistema > Privacidad y seguridad > {{pane}}. La funci\xf3n de dictado con la tecla pulsada comenzar\xe1 a funcionar en cuanto la pulses."},"unavailable":"Mantener pulsado para dictar: no se pudo iniciar la escucha de las teclas. Reinicia Cephable para intentarlo de nuevo."},"aiRewrite":{"option":"Reescritura por IA para dictados largos","description":"Antes de que se escriba el dictado, la IA del dispositivo corrige la puntuaci\xf3n, las palabras de relleno y las correcciones, y lo formatea para la aplicaci\xf3n en la que est\xe1s escribiendo. Los dictados cortos se escriben tal como los dijiste. A\xf1ade una breve espera antes de escribir."}},"face":{"title":"Expresi\xf3n Facial","titlePlural":"Expresiones Faciales","try":"Pruebe los controles de expresi\xf3n facial","question":"\xbfQu\xe9 tipo de expresi\xf3n facial quieres usar?","descriptionShort":"Utilice diferentes movimientos faciales para obtener mejores controles.","description":"Las expresiones faciales forman parte de los Controles de Expresi\xf3n. Permiten usar diferentes movimientos faciales para un control mejorado. Puedes usar movimientos de cejas, de boca y m\xe1s para crear diferentes resultados."},"other":{"title":"Otro Control","titlePlural":"Otros Controles","label":"Otros Controles","placeholder":"otro comando experimental","question":"\xbfQu\xe9 comando adicional le gustar\xeda usar? Estos suelen ser para conexiones que no son Cephable y que no encajan en otras categor\xedas. Tambi\xe9n pueden funcionar como comandos de voz al decir la palabra o frase especificada. Nota: Estos controles son experimentales y podr\xedan no ser totalmente compatibles.","description":"Otros controles son experimentales y podr\xedan no ser totalmente compatibles. Pueden usarse para conexiones que no sean Cephable o como comandos de voz al decir la palabra o frase especificada."},"support":{"title":"Apoyo","profiles":"Introducci\xf3n a los controles de la aplicaci\xf3n","question":"\xbfA\xfan no encuentras lo que necesitas?","more":"Obtenga m\xe1s informaci\xf3n en Cephable.com con gu\xedas paso a paso, tutoriales, videos y m\xe1s."},"community":{"title":"Unete a la communidad","description":"Obtenga apoyo, comparta ideas o convi\xe9rtase en miembro de las comunidades de Cephable.","discord":"Discord","facebook":"Facebook"},"resources":{"title":"Recursos \xfatiles","description":"Encuentre respuestas a tus preguntas sobre las caracter\xedsticas y funciones de Cephable.","guides":"Gu\xedas Paso a Paso"},"feedback":{"title":"Comentario","description":"Cu\xe9ntanos tu experiencia con Cephable.","contact":"Cont\xe1ctenos","feature":"Sugerir una Caracter\xedstica","bug":"Reportar un Problema"},"settings":{"title":"Ajustes","general":"Configuraci\xf3n General de Aplicaci\xf3n","description":"Este es tu lienzo para personalizar tu experiencia ajustando tus controles.","orgTitle":"Configuraci\xf3n de {{ value }}","advanced":{"title":"Configuraci\xf3n avanzada","description":"Haz clic aqu\xed para acceder a la configuraci\xf3n avanzada de tus ajustes de IA, controles de la aplicaci\xf3n, conexiones, extensiones y mucho m\xe1s."},"quick":"Aqu\xed encontrar\xe1 la configuraci\xf3n contextual del panel. \xdasela para ajustar su experiencia actual."},"account":{"title":"Cuenta","settings":"Configuraciones de la Cuenta","description":"Actualice informaci\xf3n clave para mantenerse conectado con Cephable.","usernameLabel":"Nombre de Usuario: ","emailLabel":"Correo Electr\xf3nico: ","password":{"change":"Cambiar la Contrase\xf1a","description":"Cambia tu contrase\xf1a para mantener tu cuenta segura.","old":"Contrase\xf1a Anterior","current":"Contrase\xf1a Actual","new":"Nueva Contrase\xf1a","desired":"tu nueva contrase\xf1a deseada","confirm":"Confirmar Nueva Contrase\xf1a","update":"Actualiza Contrase\xf1a"},"isEmailVerified":{"title":"Correo no Identificado.","description":"Tu correo electr\xf3nico no est\xe1 verificado. Por favor revise tu correo electr\xf3nico para obtener un enlace de verificaci\xf3n.","resend":"Reenviar Correo","success":"Te hemos enviado un nuevo correo electr\xf3nico de verificaci\xf3n.","error":"Hubo un error al enviar el correo electr\xf3nico de verificaci\xf3n. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.","org":"Su correo electr\xf3nico no est\xe1 verificado. Es necesario para acceder a los detalles de la licencia. Por favor, revise su correo electr\xf3nico para ver si hay un enlace de verificaci\xf3n.","titleAlt":"Verifique su direcci\xf3n de correo electr\xf3nico","descriptionLong":"\xa1Bienvenido a Cephable! Se ha enviado un correo electr\xf3nico de verificaci\xf3n a {{email}}. Revisa tu bandeja de entrada o correo no deseado y haz clic en el enlace. Si no lo ves, puedes reenviar el correo de verificaci\xf3n.","appBlock":"\xa1Ya casi terminas! Se ha enviado un correo electr\xf3nico de verificaci\xf3n a {{email}}. Revisa tu bandeja de entrada y haz clic en el enlace para verificar tu direcci\xf3n de correo electr\xf3nico. Si no lo ves, revisa tu carpeta de correo no deseado."},"signout":{"title":"Desconectar","question":"\xbfEst\xe1s seguro de que deseas cerrar sesi\xf3n?","confirm":"S\xed, cerrar sesi\xf3n","warn":{"title":"Est\xe1s a punto de cerrar tu sesi\xf3n.","description":"Parece que has estado inactivo durante un tiempo. Por razones de seguridad, cerraremos tu sesi\xf3n en XX segundos. Si deseas permanecer conectado, haz clic en \\"Permanecer conectado\\" a continuaci\xf3n.","confirm":"Mantenerse conectado","cancel":"Cerrar sesi\xf3n ahora"},"description":"Una vez que cierre la sesi\xf3n, esta conexi\xf3n se eliminar\xe1 de su cuenta y ya no ser\xe1 visible desde la aplicaci\xf3n complementaria ni desde otras conexiones.","confirmDescription":"Cerrar sesi\xf3n y eliminar esta conexi\xf3n"},"marketing":{"title":"Preferencias de Correo Electr\xf3nico","description":"Suscr\xedbase para recibir tutoriales, sugerencias, actualizaciones y boletines informativos para mejorar t\xfa experiencia con Cephable.","marketing":"Correos electr\xf3nicos de marketing","optIn":"Me gustar\xeda recibir tutoriales, consejos, actualizaciones y boletines para mejorar mi experiencia con Cephable."},"error":{"save":"Error al guardar la configuraci\xf3n de la cuenta.","password":"Error al actualizar la contrase\xf1a.","signout":"Error al cerrar sesi\xf3n.","old":"Se requiere contrase\xf1a anterior.","new":"Se requiere una nueva contrase\xf1a.","match":"Las contrase\xf1as no coinciden.","marketing":"Error al actualizar las preferencias de correo electr\xf3nico.","userPreferences":"Error al guardar las preferencias del usuario."},"success":{"save":"Configuraci\xf3n de la cuenta guardada.","password":"Contrase\xf1a actualiza.","marketing":"Preferencias de correo electr\xf3nico actualizadas.","userPreferences":"Preferencias de usuario actualizadas."},"userPreferences":{"title":"Preferencias del Usuario","description":"Actualice tus preferencias para crear la experiencia Cephable que funcione para usted.","warningOptOut":"Ocultar advertencias al guardar o actualizar los controles de la aplicaci\xf3n","enableTranscribeTask":"Habilite la tarea de transcripci\xf3n de archivos experimentales en el Panel de Cephable","enableGamepadSupport":"Habilitar la compatibilidad del gamepad para el controlador local y la emulaci\xf3n del controlador Xbox","enableMetrics":"Habilita la visualizaci\xf3n de m\xe9tricas de uso para las pruebas de rendimiento. Podr\xe1s descargar los registros.","enableCameraControls":"Habilitar los controles de la c\xe1mara en el panel Cephable.","enableWorkflowRecording":"Habilitar la vista previa de grabaci\xf3n de flujo de trabajo en Automatizar y Habilidades de IA."},"menu":"Men\xfa de usuario","delete":{"title":"Eliminar cuenta","description":"Puedes eliminar tu cuenta permanentemente y eliminar cualquier referencia a tu informaci\xf3n personal. Al eliminar tu cuenta, tus conexiones se eliminar\xe1n y dejar\xe1n de funcionar o estar registradas en tu cuenta. Se perder\xe1n los controles de la aplicaci\xf3n y toda la configuraci\xf3n. Este proceso es irreversible.","button":"Eliminar cuenta permanentemente","confirmation":"\xbfEst\xe1s seguro que deseas eliminar tu cuenta?","note":"Esta acci\xf3n es irreversible.","confirm":"S\xed, eliminar mi cuenta"},"communication":{"title":"Preferencias de comunicaci\xf3n"},"name":{"title":"Nombre para mostrar"},"email":{"title":"Direcci\xf3n de correo electr\xf3nico","description":"Tu direcci\xf3n de correo electr\xf3nico registrada"}},"appSettings":{"description":"Estas configuraciones solo se aplican a esta aplicaci\xf3n. Si desea cambiar la configuraci\xf3n de la aplicaci\xf3n Cephable en otra computadora o dispositivo m\xf3vil, edite la configuraci\xf3n en esa aplicaci\xf3n.","autostart":{"title":"Iniciar Cephable Autom\xe1ticamente","description":"Con esta configuraci\xf3n activada, la aplicaci\xf3n Cephable se iniciar\xe1 autom\xe1ticamente cuando inicie sesi\xf3n en tu dispositivo. Si tambi\xe9n tienes controles autom\xe1ticos de voz y expresi\xf3n, estos tambi\xe9n se iniciar\xe1n de inmediato.","question":"\xbfIniciar autom\xe1ticamente la aplicaci\xf3n Cephable?"},"position":{"topLeft":"Arriba a la Izquierda","top":"Arriba Centro","topRight":"Arriba a la Derecha","bottom":"Abajo Centro","bottomLeft":"Abajo a la Izquierda","bottomRight":"Abajo a la Derecha","label":"Seleccionar la posici\xf3n de alimentaci\xf3n del comando","description":"Selecciona d\xf3nde quieres que aparezca el feed de comandos en tu pantalla."},"micPosition":{"title":"Posici\xf3n de la Ventana de Entrada del <icr\xf3fono","description":"Seleccione d\xf3nde desea que se coloquen los controles del micr\xf3fono para voz y dictado en tu pantalla.","label":"Seleccione la posici\xf3n de la ventana de entrada del micr\xf3fono"},"cameraPosition":{"title":"Posici\xf3n de la Ventana de Entrada de C\xe1mara","description":"Seleccione d\xf3nde desea que se coloquen los controles de la c\xe1mara para el movimiento de la cara y la cabeza en tu pantalla.","label":"Seleccionar posici\xf3n de ventana de entrada de c\xe1mara"},"theme":{"title":"Pantalla y Brillo","description":"Elige un brilla que se ajuste a tu estilo.","light":"Claro","dark":"Oscuro","system":"Usar configuraci\xf3n del sistema operativo","label":"Selecciona un Tema"},"overlay":{"title":"Alimentaci\xf3n de comandos","description":"El feed de comandos mostrar\xe1 los diferentes controles que usas y los que se enviaron a tu computadora. Es f\xe1cil de navegar, pero siempre estar\xe1 sobre las dem\xe1s ventanas. Con esta configuraci\xf3n activada, la aplicaci\xf3n Cephable se mostrar\xe1 y siempre estar\xe1 sobre las dem\xe1s ventanas y aplicaciones.","question":"\xbfMostrar feed de comandos?"},"transparent":{"title":"Transparencia de la fuente de comandos","description":"Determina la opacidad del texto. Cuanto menor sea el valor, m\xe1s transparente ser\xe1 el texto."},"panelAutoHide":{"title":"Ocultar autom\xe1ticamente el panel Cephable","delay":"Retraso antes de esconderse","denominator":"segundos","time":"{{value}} segundos"},"title":"Configuraci\xf3n general de la aplicaci\xf3n","scale":{"description":"Ajusta el tama\xf1o del texto en toda la aplicaci\xf3n.","label":"Tama\xf1o del texto","small":"Peque\xf1o","large":"Grande"},"panelScale":{"description":"Ajusta el tama\xf1o del bot\xf3n del panel contra\xeddo.","label":"Tama\xf1o del bot\xf3n del panel"},"aiNewFiles":{"title":"Carpeta para nuevos archivos de IA","description":"Elija d\xf3nde guarda el agente de IA los archivos nuevos de forma predeterminada, a menos que le indique una ubicaci\xf3n espec\xedfica. Si se deja el valor predeterminado, los archivos nuevos se guardan en una carpeta \xabCephable-Work\xbb en su carpeta de inicio, que se crea autom\xe1ticamente la primera vez que se necesita.","selectButton":"Seleccionar carpeta","clearButton":"Usar carpeta predeterminada","current":"Los archivos nuevos se guardan en: {{folder}}","default":"Los archivos nuevos se guardan en la carpeta predeterminada \xabCephable-Work\xbb de su carpeta de inicio.","openButton":"Abrir carpeta","openError":"No se pudo abrir la carpeta. Es posible que se haya movido o eliminado."},"aiWorkspace":{"title":"Carpeta del espacio de trabajo de IA","description":"Seleccione una carpeta que el agente de IA del dispositivo utilizar\xe1 para buscar, leer y editar archivos, as\xed como para ejecutar comandos. De forma predeterminada, el agente puede acceder a todo su ordenador.","selectButton":"Seleccionar carpeta","clearButton":"Utilice todo el ordenador.","current":"Carpeta de espacio de trabajo actual:","none":"No se ha seleccionado ninguna carpeta de espacio de trabajo. El agente de IA puede acceder a todo su ordenador.","restrictQuestion":"Restringir el agente de IA solo a esta carpeta.","restrictDescription":"Cuando est\xe1 habilitada, las herramientas de archivos y comandos del agente de IA no pueden leer ni modificar nada fuera de la carpeta seleccionada."},"documentTemplates":{"title":"Plantillas de documentos","description":"Seleccione una plantilla que el agente de IA utilizar\xe1 al crear nuevos documentos. Deje la opci\xf3n \\"Predeterminado de Cephable\\" para aplicar el estilo de marca integrado de Cephable. Word, PowerPoint y Excel tienen sus propias plantillas.","word":"Plantilla de Word","wordDescription":"Plantilla que el agente de IA utiliza como punto de partida para los nuevos documentos de Word (.docx).","powerpoint":"Plantilla de PowerPoint","powerpointDescription":"Plantilla que el agente de IA utiliza como punto de partida para las nuevas presentaciones de PowerPoint (.pptx).","excel":"Plantilla de Excel","excelDescription":"Plantilla que el agente de IA utiliza como punto de partida para los nuevos libros de Excel (.xlsx).","selectButton":"Seleccionar archivo","clearButton":"Usar la configuraci\xf3n predeterminada de Cephable","current":"Plantilla: ","default":"Utilizando la plantilla predeterminada integrada de Cephable con el estilo de marca."},"automationBrowser":{"title":"Visibilidad del navegador de automatizaci\xf3n","description":"Cuando el agente de IA utiliza el navegador Cephable (b\xfasqueda en la web, Google Docs/Sheets/Slides, Gmail, Drive), normalmente se ejecuta en segundo plano para no interrumpirte. Activa esta opci\xf3n para ver c\xf3mo funciona.","question":"\xbfMostrar el navegador de automatizaci\xf3n mientras la IA trabaja?"}},"input":{"title":"Entradas","titlePlural":"Controles de Entradas","explore":"Explorar los Controles de Entradas","descriptionShort":"Explore los diversos controles de entrada que utiliza Cephable para crear una mejor experiencia digital para usted.","typeLabel":"Tipo de control de entrada","toolTip":"Esto usa {{alt}}","remove":"Eliminar control de entrada","filter":"Filtrar por tipo de entrada","select":"Seleccione una entrada","question":"\xbfQu\xe9 tipo de entrada quieres usar?","add":"Agregar Entrada","addMore":"Agregar Otra Entrada","removeItem":"Eliminar elemento {{index}}","item":"Art\xedculo {{index}}: {{label}}","duplicate":"No se permiten art\xedculos duplicados.","maximum":"Se permite un m\xe1ximo de {{maxItems}} art\xedculos.","description":"Los controles de entrada son los diferentes m\xe9todos que se utilizan para controlar el dispositivo, como la voz, el movimiento de la cabeza, las expresiones faciales y otras conexiones. Explora los diferentes controles de entrada a continuaci\xf3n para obtener m\xe1s informaci\xf3n."},"time":{"soon":"Muy pronto","now":"Ahora","today":"Hoy","yesterday":"Ayer","minutesAgo":"Hace {{count}} minuto","minutesAgo_plural":"Hace {{count}} minutos","daysAgo":"Hace {{count}} d\xeda","daysAgo_plural":"Hace {{count}} d\xedas","monthsAgo":"Hace {{count}} mes","monthsAgo_plural":"Hace {{count}} meses","yearsAgo":"Hace {{count}} a\xf1o","yearsAgo_plural":"Hace {{count}} a\xf1os","minutesAhead":"en {{count}} minutos","todayAhead":"mas tarde, hoy","tomorrow":"ma\xf1ana","daysAhead":"en {{count}} d\xedas","monthsAhead":"en {{count}} meses","yearsAhead":"en {{count}} a\xf1os"},"peripherals":{"empty":"No se detectaron perif\xe9ricos","switch":"Cambiar","keyboard":"Teclado","gamepad":"Mando de juegos","companionApp":"Aplicaci\xf3n complementaria","available":"Disponible","error":"Verifique tu configuraci\xf3n."},"camera":{"windowTitle":"Controles de C\xe1mara Compatibles","title":"C\xe1mara","titlePlural":"C\xe1maras","settings":"Configuraci\xf3n de C\xe1mara","start":"Iniciar C\xe1mara","restart":"Reiniciar C\xe1mara","descriptionShort":"Permite expresi\xf3n facial y movimiento de cabeza.","description":"Utilice tu c\xe1mara para detectar expresiones faciales y gestos corporales como controles diferentes.","empty":"No se encontraron c\xe1maras.","search":"Buscar por nombre de c\xe1mara","loading":"Cargando controles de la c\xe1mara...","error":"No se pudo cargar la c\xe1mara. Aseg\xfarese de que su c\xe1mara est\xe9 conectada y habilitada.","manage":{"title":"Haga clic para ver y administrar los detalles de tus c\xe1maras.","description":""},"detected":{"face":"Cara detectada.","noFace":"No se detect\xf3 ning\xfan expresiones faciales. Ajuste tu c\xe1mara o posici\xf3n e int\xe9ntelo de nuevo.","command":"Detectado: {{command}}"},"permission":{"title":"Permisos de c\xe1mara requeridos","description":"Debes darle permiso a Cephable para usar tu c\xe1mara y usar controles faciales y corporales.","button":"Abrir configuraci\xf3n de permisos","no":"Sin acceso a la c\xe1mara","help":"Cephable necesita acceso a tu c\xe1mara para usar los controles de expresiones faciales y movimientos de cabeza. Ve a <strong>Configuraci\xf3n del sistema</strong> &gt; <strong>Privacidad y seguridad</strong> &gt; <strong>{{pane}}</strong> y habilita el acceso de Cephable a tu c\xe1mara."},"controls":{"startData":"Comenz\xf3 a grabar datos faciales. Presione el acceso directo nuevamente mientras est\xe1 en la ventana de la c\xe1mara para detener la grabaci\xf3n y la descarga.","downloadData":"Se detuvo la grabaci\xf3n y la descarga de datos.","paused":"Controles de c\xe1mara en pausa.","pause":"Pausar controles de c\xe1mara","resume":"Reanudar los controles de la c\xe1mara","resumed":"Controles de c\xe1mara reanudados.","linesOn":"Activar l\xedneas faciales","linesOff":"Desactivar las l\xedneas de la cara","linesToggle":"Alternar dibujar l\xedneas de cara","noDeviceTitle":"No se detect\xf3 ninguna c\xe1mara que pueda usarse con Cephable.","noDeviceDescription":"Necesita conectar una c\xe1mara que sea compatible con aplicaciones m\xf3viles.","noDeviceConnectedDescription":"El control de la c\xe1mara sirve como vista previa de la interfaz. Ning\xfan paso se ejecutar\xe1 exitosamente. Conecte este dispositivo complementario a otro para iniciar comandos.","lines":"L\xedneas de la cara"},"switch":{"title":"Cambiar c\xe1mara","description":"Seleccione una c\xe1mara diferente para usarla en los controles faciales y corporales.","select":"Seleccionar c\xe1mara","next":"Siguiente c\xe1mara","nextLong":"Cambiar a la siguiente c\xe1mara","empty":"No se encontraron otras c\xe1maras.","search":"Buscar por nombre de c\xe1mara"},"baseline":{"title":"Base","description":"La l\xednea de base es la posici\xf3n predeterminada de tu cara y cuerpo que Cephable usa para determinar tus movimientos. Puede actualizar y restablecer la l\xednea base aqu\xed.","update":"Actualizar l\xednea base","reset":"Restablecer l\xednea base","updated":"L\xednea de base actualizada","tooltip":"Haga clic para actualizar tu l\xednea base a tu posici\xf3n de descanso actual."},"edit":{"title":"Editar la Configuraci\xf3n de la C\xe1mara","description":"Puede refinar la configuraci\xf3n de las entradas que requieren una c\xe1mara para que se adapten mejor a tus necesidades.","autoStart":{"title":"Iniciar C\xe1mara Autom\xe1ticamente","option":"\xbfInicio autom\xe1tico de la c\xe1mara y controles de cabeza/expresi\xf3n?","description":"Con esta configuraci\xf3n activada, el controlador iniciar\xe1 la c\xe1mara, lo que te permitir\xe1 usar expresiones faciales y controles de movimiento de cabeza al iniciar la aplicaci\xf3n. Si est\xe1 desactivada, debes pulsar el bot\xf3n \\"Iniciar c\xe1mara\\" en la p\xe1gina de conexi\xf3n."},"head":{"title":"Sensibilidad al Movimiento de Cabeza","description":"La sensibilidad le dice a Cephable qu\xe9 tan lejos debe moverse para activar un control. Cuanto mayor sea el valor (m\xe1s a la derecha en el control deslizante), mayor ser\xe1 la sensibilidad y, por lo tanto, menos necesitar\xe1 moverse para activar el control.","tilt":{"title":"Sensibilidad a la Inclinaci\xf3n de la Cabeza","description":"Estos valores determinan qu\xe9 tan lejos necesita inclinar la cabeza hacia arriba, abajo, izquierda y derecha para activar los controles.","up":"Sensibilidad de Inclinaci\xf3n Arriba","down":"Sensibilidad de Inclinaci\xf3n Abajo","left":"Sensibilidad de Inclinaci\xf3n Izquierda","right":"Sensibilidad de Inclinaci\xf3n Derecha","scaleHigh":"Ligera Inclinaci\xf3n","scaleLow":"Inclinaci\xf3n Grande"},"turn":{"title":"Sensibilidad al Giro de Cabeza","description":"Estos valores determinan cu\xe1nto debe girar la cabeza hacia la izquierda y hacia la derecha para activar los controles.","left":"Sensibilidad de Giro Izquierda","right":"Sensibilidad al Giro Derecha","scaleHigh":"Ligero Giro","scaleLow":"Giro Grande"},"lean":{"title":"Sensibilidad a la Inclinaci\xf3n de Cuerpo","description":"Estos valores determinan cu\xe1nto debe inclinar la cabeza hacia adelante y hacia atr\xe1s para activar los controles.","forward":"Sensibilidad Inclinada hacia Adelante","back":"Sensibilidad hacia Atr\xe1s","right":"Sensibilidad Ajustada a la Derecha","left":"Sensibilidad Magra Izquierda","scaleHigh":"Ligeramente Magro","scaleLow":"Grande Magro"},"duck":{"title":"Sensibilidad de Cabeza Agachada/Levantada","description":"Estos valores determinan qu\xe9 tan lejos debe agacharse o levantar la cabeza para activar los controles.","down":"Sensibilidad de Agacha","up":"Lev\xe1ntate la Sensibilidad","scaleHigh":"Ligero Turno","scaleLow":"Turno Grande"}},"face":{"title":"Sensibilidad a la Expresi\xf3n Facial","description":"La sensibilidad le dice a Cephable qu\xe9 tan exagerada es una expresi\xf3n que necesita para activar un control. Cuanto mayor sea el valor (m\xe1s a la derecha en el control deslizante), mayor ser\xe1 la sensibilidad y, por lo tanto, menos necesitar\xe1 moverse para activar el control.","eyebrow":{"title":"Sensibilidad de las Cejas","description":"Estos valores determinan cu\xe1nto debes levantar o bajar las cejas para activar los controles.","up":"Aumentar la Sensibilidad de las Cejas","scaleHigh":"Ligero Aumento","scaleLow":"Gran Aumento"},"mouth":{"title":"Sensibilidad Bucal","description":"Estos valores determinan cu\xe1nto necesitas abrir o cerrar la boca para activar los controles.","open":"Sensibilidad de la Boca Abierta","close":"Sensibilidad de la Boca Cerrada","smile":"Sensibilidad de la Sonrisa","scaleHigh":"Ligeramente Abierto","scaleLow":"Abierto Grande","smileScaleHigh":"Leve Sonrisa","smileScaleLow":"Gran Sonrisa","closeScaleHigh":"Ligeramente Cerrado","closeScaleLow":"Bien Cerrado"}},"mouse":{"title":"Movimiento de la Cabeza para los Controles del Rat\xf3n","description":"Determine si desea utilizar los controles de movimientos de la cabeza y c\xf3mo quiere mover el rat\xf3n en lugar de activar otras salidas.","enable":{"title":"Habilitar el Movimiento de la Cabeza para los Controles del Rat\xf3n","description":"Si esto est\xe1 activado, algunos de los controles de movimiento de tu cabeza se usar\xe1n para mover el rat\xf3n en lugar de los controles de activaci\xf3n.","option":"\xbfUtiliza controles de cabeza para el movimiento del rat\xf3n?"},"input":{"title":"Tipo de entrada del rat\xf3n","description":"Seleccione qu\xe9 tipo de gestos con la cabeza desea asignar a los controles del rat\xf3n. Por ejemplo, Inclinar la cabeza significa que puede inclinar la cabeza hacia la izquierda y hacia la derecha para mover el rat\xf3n hacia la izquierda y hacia la derecha, Girar la cabeza significa que puede girar la cabeza hacia la izquierda y hacia la derecha para mover el rat\xf3n y Inclinar la cabeza significa que puede inclinarse hacia la izquierda y hacia la derecha para moverse tu rat\xf3n.","option":"Seleccionar tipo de entrada","optionLong":"Seleccione el tipo de movimiento de la cabeza que desea utilizar para controlar el rat\xf3n."},"invert":{"title":"Invertir el Movimiento del Rat\xf3n","description":"Si esto est\xe1 activado, la direcci\xf3n en la que mueve la cabeza se invertir\xe1 respecto de la direcci\xf3n en la que mueve el rat\xf3n. Para el eje X: si esto est\xe1 activado, al moverlo hacia la izquierda se mover\xe1 el rat\xf3n hacia la derecha y si se mueve hacia la derecha lo mover\xe1 hacia la izquierda. Para el eje Y: si esto est\xe1 activado, al moverlo hacia abajo, el rat\xf3n se mover\xe1 hacia arriba y al moverlo hacia arriba, lo mover\xe1 hacia abajo.","x":"\xbfInvertir el movimiento del rat\xf3n en el eje X?","y":"\xbfInvertir el movimiento del rat\xf3n en el eje Y?"},"mode":{"title":"Modo de Movimiento del Rat\xf3n","description":"Selecciona c\xf3mo quieres que el cursor reaccione a los movimientos de tu cabeza."},"speed":{"title":"Velocidad del rat\xf3n","description":"Determina la velocidad constante a la que quieres que se mueva el cursor.","fast":"R\xe1pido","slow":"Lento"},"linear":{"title":"Movimiento Lineal del Rat\xf3n","description":"Si esta opci\xf3n est\xe1 activada, el cursor solo se mueve en l\xedneas rectas horizontales o verticales, lo que hace m\xe1s f\xe1cil navegar en esas direcciones espec\xedficas sin ninguna desviaci\xf3n diagonal.","option":"\xbfUtilizar el movimiento lineal del rat\xf3n?"},"accelerationRate":{"title":"Velocidad de Aceleraci\xf3n del Rat\xf3n","description":"Ajuste la velocidad con la que aumenta la velocidad del cursor cuanto m\xe1s tiempo mantenga la cabeza quieta."},"accelerationCurve":{"title":"Curva de Aceleraci\xf3n del Rat\xf3n","description":"Ajuste la velocidad a la que aumenta la velocidad del cursor en relaci\xf3n con el movimiento de la cabeza.","linear":"Lineal","exponential":"Exponencial","sublinear":"Sub-lineal"},"maximumSpeed":{"title":"Velocidad M\xe1xima del Rat\xf3n","description":"Determinar el n\xfamero m\xe1ximo de p\xedxeles que el cursor puede moverse por segundo."},"steadyGlide":{"title":"Deslizamiento Constante","description":"Cuando mueves la cabeza m\xe1s all\xe1 de un punto determinado, el cursor se desliza continuamente en esa direcci\xf3n a una velocidad constante."},"speedBoost":{"title":"Aumento de Velocidad","description":"El cursor comienza a moverse m\xe1s r\xe1pido cuanto m\xe1s tiempo mantienes la cabeza en una posici\xf3n. Cuanto m\xe1s tiempo mantengas la cabeza quieta, m\xe1s r\xe1pido se acelerar\xe1 el cursor."},"dynamicGlide":{"title":"Deslizamiento Din\xe1mico","description":"La velocidad del cursor aumenta seg\xfan cu\xe1nto mueves la cabeza. Cuanto m\xe1s mueves la cabeza, m\xe1s r\xe1pido se desliza el cursor."},"proportionalSpeed":{"title":"Velocidad Proporcional","description":"El cursor sigue la punta de su nariz en proporci\xf3n a las dimensiones de su pantalla."},"off":{"title":"Apagado","description":"El movimiento del mouse est\xe1 deshabilitado."},"disabled":"Esta funci\xf3n est\xe1 deshabilitada para conexiones y extensiones remotas."}},"stop":"Detener la c\xe1mara","show":"Mostrar c\xe1mara","hide":"Ocultar c\xe1mara","warn":"No se han iniciado los controles de la c\xe1mara. Inicie la c\xe1mara para permitir los controles de rostro y cuerpo.","draw":{"error":"Error al cargar la se\xf1al de la c\xe1mara. Revisa tu c\xe1mara y vuelve a intentarlo."},"select":"Seleccione una c\xe1mara que desee emparejar para obtener controles mejorados usando su rostro, cuerpo y botones de acci\xf3n r\xe1pida.","extension":{"title":"Extensi\xf3n: C\xe1mara","enabledTitle":"Habilitar controles de la c\xe1mara","enabledDescription":"Con esta configuraci\xf3n activada, Cephable utilizar\xe1 tu c\xe1mara para detectar los movimientos de tu rostro y cabeza, lo que te permitir\xe1 controlar tu dispositivo con expresiones y gestos, incluyendo el uso de los movimientos de tu cabeza como si fuera un rat\xf3n."},"live":"VIVIR","paused":"La c\xe1mara se detuvo"},"microphone":{"windowTitle":"Controles de Voz Compatibles","title":"Micr\xf3fono","titlePlural":"micr\xf3fonos","settings":"Configuraci\xf3n del Micr\xf3fono","start":"Iniciar Micr\xf3fono","stop":"Detener micr\xf3fono","descriptionShort":"Permite comandos de voz y dictado.","description":"Utilice tu micr\xf3fono incorporado para habilitar los controles de voz y el dictado.","select":"Seleccione el micr\xf3fono que desee emparejar para obtener controles mejorados usando tu voz.","empty":"No se encontraron micr\xf3fonos.","search":"Buscar por nombre de micr\xf3fono","manage":{"title":"Haga clic para ver y administrar los detalles de tus micr\xf3fonos.","description":""},"permission":{"title":"Permisos de micr\xf3fono requeridos","description":"Debe darle permiso a Cephable para usar tu micr\xf3fono y usar los controles de voz.","button":"Abrir configuraci\xf3n de permisos","no":"Sin acceso al micr\xf3fono","help":"Cephable necesita acceso a tu micr\xf3fono para usar los controles de voz. Ve a <strong>Configuraci\xf3n del sistema</strong> &gt; <strong>Privacidad y seguridad</strong> &gt; <strong>{{pane}}</strong> y habilita el acceso de Cephable a tu micr\xf3fono."},"controls":{"pause":"Pausar controles de voz","paused":"Controles en pausa.","resume":"Reanudar controles de voz","dictationPlay":"Iniciar modo de dictado","dictationPause":"Detener el modo de dictado","prompt":"Empieza a hablar para ver tus controles de voz aqu\xed...","dictationPrompt":"Empieza a hablar para escribir lo que dices...","latency":"Alta latencia detectada. Considere cerrar algunas aplicaciones que podr\xedan estar consumiendo demasiados recursos.","noDeviceConnectedDescription":"El control del micr\xf3fono sirve como vista previa de la interfaz. Ning\xfan paso se ejecutar\xe1 exitosamente. Conecte este dispositivo complementario a otro para iniciar comandos.","status":{"paused":"En pausa.","dictating":"Dictando.","optimistic":"Optimista:","listening":"Escuchando:","loadingModel":"Cargando modelo de voz...","thinking":"Pensamiento...","loadingPhiModel":"Cargando modelo de generaci\xf3n de texto...","generatingText":"Generando...","preparingPhiModel":"Preparando modelo de generaci\xf3n de texto...","permission":"Comprobando permisos del micr\xf3fono...","typing":"Mecanograf\xeda..."},"loadingDetail":"Esto puede tardar unos minutos.","generatingTextDetail":"Detenga la generaci\xf3n cambiando las aplicaciones o diciendo \\"deje de generar\\"","command":"Dominio","contextual":"Contextual","send":"Enviar","typedInputLabel":"Escribe un comando o texto para enviar","listeningPlaceholder":"Escuchando...","dictationListeningPlaceholder":"Escuchando...","pausedPlaceholder":"La voz se detuvo..."},"edit":{"title":"Editar la Configuraci\xf3n del Micr\xf3fono","autoStart":{"title":"Micr\xf3fono de arranque autom\xe1tico","option":"Micr\xf3fono de arranque autom\xe1tico","description":"Al encender el dispositivo, comienza a escuchar autom\xe1ticamente los comandos de voz. Si est\xe1 desactivada, pulse \xabIniciar escucha\xbb para comenzar."},"optimistic":{"title":"Controles de voz m\xe1s r\xe1pidos y optimistas","option":"Controles de voz m\xe1s r\xe1pidos y optimistas","description":"Mejora la velocidad y la capacidad de respuesta de los controles por voz, pero reduce la tolerancia a errores. Usa el modo est\xe1ndar si deseas compatibilidad con dictado o mayor flexibilidad. Nota: El modo optimista puede activarse accidentalmente si no pronuncias los comandos con exactitud."},"confirm":{"title":"Tiene cambios sin guardar.","description":"Se detectaron cambios sin guardar. \xbfDesea guardarlos antes de salir?"},"aiCommands":{"title":"Comandos de voz inteligentes","description":"Da \xf3rdenes con naturalidad: la IA de Cephable entiende lo que quieres decir sin necesidad de una coincidencia exacta.","option":"Comandos de voz inteligentes"},"aiDictation":{"title":"Dictado inteligente y escritura r\xe1pida","description":"Funci\xf3n de voz a texto mejorada con puntuaci\xf3n autom\xe1tica, nombres propios y estructura de oraciones. Di \xabescribe [cualquier cosa]\xbb para usar la funci\xf3n de escritura r\xe1pida y obtener un dictado m\xe1s inteligente y natural.","option":"Dictado inteligente y escritura r\xe1pida"},"description":"Administre sus comandos de voz y configuraciones de dictado para esta conexi\xf3n.","input":{"title":"Micr\xf3fono","description":"El micr\xf3fono permite controlar la voz y escuchar el dictado. Cephable recuerda tu elecci\xf3n y vuelve a ella cada vez que se conecta.","notConnected":"{{name}} (no conectado)","systemDefault":"Configuraci\xf3n predeterminada del sistema"}},"warn":"El micr\xf3fono no se ha activado. Activa el micr\xf3fono para permitir comandos de voz y dictado.","devices":{"error":"Dispositivo de entrada de micr\xf3fono no encontrado."},"startDescription":"Encienda el micr\xf3fono para comenzar a escuchar los comandos.","context":{"add":"Agregar contexto","title":"Agregar contexto","highlighted":"Texto resaltado","clipboard":"Portapapeles","other":"Otro\u2026","otherTitle":"Agregar contexto personalizado","otherPlaceholder":"Escriba o pegue el contexto que desea utilizar.","otherConfirm":"Agregar","otherCancel":"Cancelar","remove":"Eliminar contexto","required":"Se requiere contexto para {{mode}}","files":"Archivos\u2026","folders":"Carpetas\u2026","removeAttachment":"Retire el archivo adjunto","dropToAttach":"Arrastra archivos o carpetas para adjuntarlos como contexto.","otherLabel":"Contexto personalizado"}},"localization":{"title":"Preferencias de Idioma","titleShort":"El Idioma","description":"Elija tu idioma preferido de una lista de idiomas admitidos.","newUserDescription":"Seleccione un idioma preferido antes de continuar.","edit":"Actualizar Prefencias de Idioma","display":{"title":"Idioma de la pantalla","description":"Idioma que se muestra al usar Cephable. Esto incluye elementos como men\xfas, notificaciones y controles de aplicaciones, que se muestran en el idioma que prefieras."},"voice":{"title":"Idioma de control de voz","description":"Este es el idioma que se utiliza al reconocer dictados y comandos de voz. Especificar el idioma mejora la precisi\xf3n de tus entradas de voz.","settings":{"title":"Reconocimiento de Voz e Idioma de Pantalla","description":"Ajuste la configuraci\xf3n de idioma tanto para la pantalla como para los controles de voz. Esta opci\xf3n le permite seleccionar tus idiomas preferidos para las interacciones de texto y micr\xf3fono en pantalla, como controles de voz y dictado."}},"locales":{"en":"English \u2014 Ingl\xe9s","en-us":"English (US) \u2014 Ingl\xe9s (Estados Unidos)","es":"Espa\xf1ol","fr":"Fran\xe7ais \u2014 Franc\xe9s","it":"Italiano \u2014 Italiano","de":"Deutsch - Alem\xe1n","ja":"\u65E5\u672C\u8A9E - Japon\xe9s","en-gb":"English (UK) - Ingl\xe9s (Reino Unido)","en-in":"English (India) - Ingl\xe9s (India)"},"save":{"success":"\xa1Preferencias de idioma guardadas!","error":"Error al guardar las preferencias de idioma"},"profile":{"view":"Variantes","title":"Idioma de control de la aplicaci\xf3n","question":"\xbfQu\xe9 idioma de control de la aplicaci\xf3n te gustar\xeda editar?","description":"Algunos controles de la aplicaci\xf3n tienen variantes para diferentes idiomas. Cambia a otro idioma para editar y personalizar.","change":"Cambiar idioma"},"unsupported":{"title":"Idioma no compatible {{locale}}","description":"El idioma seleccionado no es compatible. Elija otro idioma."},"select":"Seleccionar idioma","localesShort":{"en":"Ingl\xe9s","en-us":"Ingl\xe9s (EE. UU.)","es":"Espa\xf1ol","fr":"Franc\xe9s","it":"italiano","de":"Alem\xe1n","ja":"japon\xe9s","en-gb":"Ingl\xe9s (Reino Unido)","en-in":"Ingl\xe9s (India)"}},"mobileApp":{"title":"Aplicaci\xf3n m\xf3vil"},"skipToMain":"Saltar al Contenido Principal","dashboard":{"title":"Panel"},"developer":{"title":"Revelador","titleLong":"Recursos para desarrolladores","description":"Cephable se puede integrar directamente en su aplicaci\xf3n, juego o servicio utilizando nuestros SDK.","sdk":{"title":"Explora nuestros SDK","description":"Ofrecemos SDK de primera clase dise\xf1ados para integrar sin problemas el reconocimiento de voz y los controles adaptativos en sus aplicaciones. Nuestras herramientas est\xe1n dise\xf1adas para mejorar la interacci\xf3n del usuario a trav\xe9s de controles intuitivos y fomentar la accesibilidad, lo que garantiza que todos los usuarios puedan utilizar su software de manera m\xe1s eficaz.","javascript":{"title":"JavaScript","subtitle":"Web","description":"Integre controles de voz y adaptativos directamente en sus aplicaciones web.","action":"Obtener el Paquete NPM"},"net":{"title":".NET","subtitle":"Aplicaciones de Windows","description":"Aproveche el poder de .NET para crear aplicaciones con nuestros SDK WPF y WinUI3.","actionCore":"Obtener el Paquete b\xe1sico","actionWpf":"Obtener el Paquete WPF"},"android":{"title":"Androide","subtitle":"Dispositivos m\xf3viles","description":"Aplicaciones de Android dise\xf1adas para facilitar las capacidades de voz y movimiento de la cabeza.","action":"Obtener el SDK de Android"},"more":{"title":"M\xe1s","description":"\xbfNo encuentras lo que necesitas? Cont\xe1ctanos y te ayudaremos.","action":"Solicitar un SDK"},"docs":{"title":"Documentaci\xf3n","description":"Explora la documentaci\xf3n detallada, los proyectos de ejemplo y las gu\xedas para empezar a construir con Cephable.","action":"Ver documentos"}},"demo":{"title":"Poblaci\xf3n","titleLong":"Experimente nuestros SDK en acci\xf3n","description":"Descubra el poder de nuestras tecnolog\xedas de control de voz y movimiento de la cabeza a trav\xe9s de nuestras aplicaciones de muestra. Desde juegos interactivos hasta aplicaciones web y m\xf3viles din\xe1micas, cada ejemplo demuestra la versatilidad y la eficacia de nuestros SDK. Explore estos ejemplos para obtener informaci\xf3n e inspiraci\xf3n para integrar una accesibilidad mejorada y experiencias inmersivas en sus propios proyectos.","game":{"title":"Juego 2048","subtitle":"Web","description":"Mejora el juego tradicional con controles adaptables de voz y movimiento de cabeza.","action":"Juega el juego"},"unity":{"title":"Unidad","subtitle":"Desarrollo de juegos","description":"Vea c\xf3mo se pueden aprovechar los controles adaptativos en los juegos para brindar una experiencia de usuario m\xe1s atractiva.","action":"Obtenga la muestra"},"samples":"Documentos y ejemplos","other":{"title":"Otras demostraciones","description":"Experimente de primera mano c\xf3mo Cephable puede mejorar su aplicaci\xf3n, juego o dispositivo.","action":"Ver m\xe1s demostraciones"},"web":{"title":"Ejemplos de SDK web","subtitle":"Web","description":"Integraci\xf3n sencilla de toda nuestra funcionalidad principal en aplicaciones web.","action":"Experimente el SDK"},"docs":{"title":"Documentaci\xf3n y ejemplos para desarrolladores","description":"Explora la documentaci\xf3n detallada, los proyectos de ejemplo y las gu\xedas para empezar a construir con Cephable.","action":"Ver documentos"}},"other":{"title":"Otros recursos","description":"Si no encuentra lo que necesita en nuestros SDK, intente trabajar directamente con nuestras API o comun\xedquese con la comunidad para obtener ayuda, inspiraci\xf3n y soporte.","api":{"title":"API","description":"Nuestras API le permiten interactuar con Cephable directamente. Puede usar nuestras API para crear integraciones personalizadas."},"support":{"title":"Apoyo","description":"\xbfNo encuentras lo que necesitas? Ponte en contacto con nuestra comunidad a trav\xe9s de Discord.","action":"\xdanete a Discord"}}},"invalidNumber":"N/A","upgrade":"Mejora","license":{"trial":{"subtitle":"Puedes invitar a {{count}} colegas a probar Cephable contigo.","noUsersSubtitle":"No tienes usuarios de prueba restantes. Actualiza a una licencia paga para agregar m\xe1s usuarios.","expired":{"user":"Su actualizaci\xf3n gratuita a {{productName}} vence el {{date}}. Para actualizar, contacte con el administrador de su organizaci\xf3n: {{admin}}.","admin":"Su actualizaci\xf3n gratuita a {{productName}} vence el {{date}}.","userLong":"Parece que tu actualizaci\xf3n gratuita a {{productName}} ha expirado. Para actualizar, contacta con el administrador de tu organizaci\xf3n: {{admin}}.","adminLong":"Parece que tu actualizaci\xf3n gratuita a {{productName}} ha expirado. Puedes actualizar tu licencia para seguir accediendo a funciones avanzadas que no est\xe1n disponibles en Cephable Basic."},"start":"Comience una prueba gratuita","title":{"single":"Se le ha actualizado a {{productName}} de forma gratuita con {{days}} d\xedas restantes","multiple":"{{organization}} est\xe1 en una prueba gratuita con {{days}} d\xedas restantes"},"upgrade":"Al actualizar, mantenga su acceso a funciones como controles de voz mejorados, tareas inteligentes de IA y muchos controles de aplicaciones predise\xf1ados."},"required":{"title":"Se requiere licencia profesional de Cephable","description":"Parece que est\xe1s usando Cephable Basic, que no es compatible con el uso comercial de Cephable. Actualiza a una licencia profesional para seguir usando la aplicaci\xf3n."},"upgrade":{"professional":"Actualizaci\xf3n a la Licencia Profesional de Cephable","generic":{"title":"Mejora tu experiencia con Cephable","description":"La plataforma Cephable ofrece diferentes productos para uso comercial en el trabajo, la escuela o integrados en soluciones nativas."},"fallback":{"title":"Error al cargar el portal de facturaci\xf3n","description":"No se pudo cargar el portal de facturaci\xf3n. Haga clic en el bot\xf3n a continuaci\xf3n para contactar a sales@cephable.com y continuar con la actualizaci\xf3n."}},"activate":{"question":"\xbfYa tienes una clave de licencia?","button":"Activar","title":"Activa Clave de Licencia","description":"Ingresa tu clave de licencia para actualizar Cephable. Si no tienes una, inicia una prueba gratuita o compra una licencia.","fieldLabel":"Clave de Licencia","placeholder":"NkmurBfZzFrmm9Kx","success":"\xa1Felicitaciones! \xa1Su cuenta ha sido actualizada a {{license}}!","invalid":{"key":"Clave no v\xe1lida. Aseg\xfarese de haber ingresado la clave correcta.","empty":{"key":"Clave no v\xe1lida. Aseg\xfarese de haber ingresado un valor.","name":"Nombre de organizaci\xf3n no v\xe1lido. Aseg\xfarese de haber ingresado un valor."}},"descriptionLong":"Ingresa tu clave de licencia para actualizar Cephable. Si no tienes una, inicia una prueba gratuita o compra una licencia."},"welcome":{"title":"Bienvenido a {{license}}.","description":"Te has unido a {{organization}} con \xe9xito. {{description}}"},"redirect":{"title":"Redireccionando","description":"Se le ha redirigido a un portal de facturaci\xf3n externo. Se abrir\xe1 una nueva pesta\xf1a en su navegador. Si no se le redirige en unos segundos, haga clic en el bot\xf3n que aparece a continuaci\xf3n.","error":"Error de redirecci\xf3n de facturaci\xf3n","external":"Redirigido. Por favor, revise su navegador."},"key":{"title":"Clave de licencia","titlePlural":"Claves de licencia","description":"Una clave de licencia es un identificador \xfanico que se utiliza para otorgar acceso a las funciones profesionales, educativas o para desarrolladores de Cephable.","details":"Detalles de la clave de licencia","assigned":"Usado el: {{date}}","expires":"Caduca el: {{date}}","assign":"Asignar clave a nueva organizaci\xf3n","error":"Error al cargar la clave de licencia.","empty":{"title":"No se encontraron claves de licencia.","description":"Parece que no hay claves de licencia que coincidan con estos criterios o que a\xfan no ha adquirido una clave de licencia."},"product":{"title":"Compra","titleLong":"Comprar claves de licencia","description":"Adquiera una clave de licencia para aprovechar todo el potencial de Cephable. Vea los diferentes planes y opciones de precios disponibles.","action":"Comprar ahora","empty":{"title":"No se encontraron productos.","description":"Parece que no tienes ning\xfan producto. Ponte en contacto con nuestro equipo de ventas o con tu representante para que te ayudemos a resolver este problema."},"yearly":"Facturaci\xf3n anual","years":"Facturado cada {{value}} a\xf1os","days":"Facturado cada {{value}} d\xedas","Subscription":{"title":"Suscripci\xf3n"},"MeteredConsumption":{"title":"Consumo medido"},"PayDown":{"title":"Pagar al contado"},"OneTime":{"title":"Una vez"}}},"pro":{"tag":"Pro","detail":"Esta es una funci\xf3n exclusiva de Cephable Professional","requiredDetail":"Se requiere una licencia profesional de Cephable para esta funci\xf3n. Puede actualizarla o iniciar una prueba gratuita en la configuraci\xf3n de su cuenta."},"titlePlural":"Licencias"},"purchase":"Compra","saveError":"Error al guardar los cambios.","description":"Descripci\xf3n","expand":"Expandir","expandMenu":"Expandir men\xfa","editor":{"title":"Editor de Markdown","bold":"Atrevido","italic":"It\xe1lico","underline":"Subrayar","hr":"Regla horizontal","link":"Enlace","quote":"Cita","code":"C\xf3digo","codeBlock":"Bloque de c\xf3digo","comment":"Comentario","image":"Imagen","table":"Mesa","unordered-list":"Lista desordenada","ordered-list":"Lista ordenada","checked-list":"Lista de comprobaci\xf3n","help":"Ayuda","edit":"Editar","live":"Vivir","preview":"Avance","fullscreen":"Pantalla completa","placeholder":"Por favor ingrese el texto de Markdown aqu\xed...","strikethrough":"Tachado"},"created":"Creado: {{value}}","updated":"Actualizado: {{value}}","deleted":"Eliminado: {{value}}","expires":"Caduca: {{value}}","expired":"Vencido: {{value}}","used":"Usado: {{value}}","results":"Resultados","panel":{"title":"Panel Cefaleable","question":"\xbfPanel de inicio autom\xe1tico?","position":{"top":"Arriba","right":"Bien","left":"Izquierda","bottom":"Abajo ","description":"Seleccione d\xf3nde desea que aparezca el Panel Cephable en su pantalla.","label":"Posici\xf3n"},"sections":{"description":"Elige qu\xe9 secciones del panel son visibles. Puedes ocultarlas seg\xfan tus preferencias para aprovechar al m\xe1ximo el espacio del panel.","microphone":"Controles de micr\xf3fono y voz","camera":"Controles de c\xe1mara y rostro/cabeza","profile":"Controles y vistas previas de la aplicaci\xf3n","globalControls":"Controles globales y de dispositivos","tasks":"Tareas inteligentes","buttons":"Botones de acci\xf3n r\xe1pida"},"titleShort":"Panel","description":"Este es el panel que funciona como centro de control principal. Siempre est\xe1 visible y te permite controlar tus aplicaciones con la voz, entre otras funciones.","reconnecting":"Reconectando\u2026","reconnectRetry":"Rever","modes":{"title":"Modo","generate":{"label":"Generar","placeholder":"Describe lo que quieres generar"},"rewrite":{"label":"Volver a escribir","placeholder":"\xbfC\xf3mo deber\xeda reescribir el texto?"},"translate":{"label":"Traducir","placeholder":"\xbfTraducir a qu\xe9 idioma?"},"automate":{"label":"Automatizar","placeholder":"Describe los pasos que deseas automatizar."},"auto":{"label":"Auto","placeholder":"Escribe cualquier cosa: Cephable elige el mejor modo.","upgrade":"Cephable necesita {{tier}} para ejecutar esa acci\xf3n."},"control":{"label":"Control","placeholder":"Escribe un comando o texto para enviar"},"summarize":{"label":"Resumir","placeholder":"\xbfC\xf3mo le gustar\xeda resumir o condensar el texto?"}}},"resume":"Reanudar","textGeneration":{"settings":"Configuraci\xf3n de generaci\xf3n de texto","edit":{"title":"Editar la configuraci\xf3n de generaci\xf3n de texto","description":"Puede refinar la configuraci\xf3n de Generaci\xf3n de texto inteligente para crear los mejores resultados para usted.","autoStart":{"title":"Generaci\xf3n de texto de calentamiento autom\xe1tico","description":"Con esta opci\xf3n activada, Cephable AI precalentar\xe1 autom\xe1ticamente los modelos de IA utilizados para las tareas de creaci\xf3n o automatizaci\xf3n. Este precalentamiento mejorar\xe1 su rendimiento, pero consumir\xe1 m\xe1s recursos del ordenador. Desactivar esta opci\xf3n ahorrar\xe1 recursos, pero podr\xeda ralentizar las tareas.","option":"\xbfModelos de IA de generaci\xf3n de texto de calentamiento autom\xe1tico?"},"prompt":{"title":"Informaci\xf3n adicional para la generaci\xf3n de texto","description":"Introduce informaci\xf3n adicional para usarla con la IA de Cephable para generar texto. Usa este campo para especificar tus preferencias de tono, estilo de escritura o cualquier otro detalle.","field":"Aviso adicional","placeholder":"Por ejemplo, usa un tono amable, escribe con profesionalismo, s\xe9 conciso y directo. Al escribir c\xf3digo, deja comentarios reflexivos, pero no demasiados, etc."},"enableTextGen":{"title":"Habilitar la generaci\xf3n de texto inteligente","description":"Con esta configuraci\xf3n activada, Cephable AI puede redactar, reescribir, resumir y traducir contenido, o automatizar acciones de escritorio en todas tus aplicaciones.","option":"\xbfUtilizar generaci\xf3n de texto inteligente?"},"terminate":{"title":"Recursos claros de IA","description":"Haz clic para liberar los recursos utilizados en las tareas de Crear o Automatizar. Esto liberar\xe1 recursos en tu ordenador, pero podr\xeda ralentizar estas tareas la pr\xf3xima vez que las uses.","button":"Recursos claros","success":"Limpieza de recursos de generaci\xf3n de texto.","confirm":{"title":"Recursos claros de IA","description":"\xbfEst\xe1 seguro de que desea liberar los recursos utilizados para las tareas de creaci\xf3n o automatizaci\xf3n? Esto liberar\xe1 recursos en su equipo, pero podr\xeda ralentizar estas tareas la pr\xf3xima vez que las utilice.","confirm":"S\xed, recursos claros","cancel":"Cancelar"}},"clearModelCache":{"title":"Borrar cach\xe9 de modelos de IA","description":"Esto liberar\xe1 espacio de almacenamiento en su ordenador y volver\xe1 a descargar el modelo seleccionado actualmente.","button":"Borrar y volver a descargar","success":"Se eliminaron archivos de modelo local.","confirm":{"title":"Borrar y volver a descargar la cach\xe9 del modelo de IA","description":"\xbfEst\xe1 seguro de que desea borrar la cach\xe9 del modelo de IA y eliminar los archivos de su sistema? El modelo seleccionado actualmente se descargar\xe1 autom\xe1ticamente de nuevo.","confirm":"S\xed, borrar y volver a descargar.","cancel":"Cancelar"},"error":"Error al eliminar archivos del modelo local."},"enableHistory":{"title":"Habilitar el historial de generaci\xf3n de texto","description":"Con esta configuraci\xf3n activada, Cephable AI utilizar\xe1 su historial de generaci\xf3n de texto para generar texto con el contexto de su acci\xf3n anterior.","option":"\xbfUtilizar el historial de generaci\xf3n de texto?"},"modelSelection":{"title":"Modelo de IA","description":"Selecciona la familia y el tama\xf1o del modelo de IA que se ejecuta en este dispositivo. Los modelos m\xe1s grandes ofrecen mejores resultados, pero consumen m\xe1s recursos. Descarga m\xe1s de uno para alternar entre ellos r\xe1pidamente.","family":"Familia modelo","size":"Tama\xf1o del modelo","downloaded":"Descargado","downloading":"Descargando\u2026","download":"Descargar","delete":"Eliminar descarga","unavailable":"No es compatible con este dispositivo.","requiresBetterDevice":"Este modelo necesita un dispositivo m\xe1s potente para funcionar.","selectPrompt":"Seleccione un modelo","noModels":"Todav\xeda no hay modelos compatibles disponibles para este dispositivo.","deleteConfirm":{"title":"\xbfEliminar el modelo descargado?","description":"Esto libera espacio en el disco. Podr\xe1s descargarlo de nuevo m\xe1s tarde."},"notDownloaded":"Este modelo est\xe1 seleccionado, pero a\xfan no se ha descargado. Haz clic en Descargar para usarlo.","readyToUse":"Descargado \u2014 listo para usar","offlineNoModels":"Est\xe1s sin conexi\xf3n y a\xfan no hay modelos guardados en este dispositivo. Con\xe9ctate a internet para ver y descargar los modelos disponibles.","offlineDownloadUnavailable":"Est\xe1s sin conexi\xf3n, por lo que este modelo no se puede descargar. Con\xe9ctate a internet para descargarlo o elige un modelo que ya hayas descargado.","license":{"upgrade":"Requiere una actualizaci\xf3n de licencia","blockedNeedsDownload":"Este modelo requiere {{license}}. Descargue un modelo anterior o actualice para continuar."},"notEnoughSpace":"No hay suficiente espacio en el dispositivo","notEnoughSpaceDetail":"Necesita {{required}} pero solo {{free}} es gratuito en este dispositivo. Libere espacio e int\xe9ntelo de nuevo.","fallback":{"alert":"Se est\xe1 utilizando {{fallback}} en lugar de {{preferred}}, lo que requiere una actualizaci\xf3n.","active":"{{preferred}} requiere {{license}}. Se est\xe1 utilizando {{fallback}} en su lugar hasta que elija un modelo diferente o actualice."}}},"prompt":{"systemPrompt":"Genera \xdaNICAMENTE el texto solicitado: sin explicaciones, comentarios ni relleno. No se permite formato Markdown ni explicaciones no solicitadas. En el caso del c\xf3digo, genera solo el c\xf3digo fuente: sin delimitadores, etiquetas de lenguaje ni explicaciones. No expliques lo que hiciste.","appName":"Actualmente est\xe1s generando texto para {{appName}}.","userPreferences":"Respete estas preferencias de usuario sobre c\xf3mo quieren que se genere el texto: {{userPreferences}}."},"translatePrompt":{"systemPrompt":"Traduzca el siguiente texto al idioma {{language}}. Imprima \xdaNICAMENTE el texto traducido. Sin explicaciones, sin pre\xe1mbulo, sin formato Markdown, sin delimitadores de c\xf3digo, sin notas, sin comentarios entre par\xe9ntesis sobre la traducci\xf3n. Conserve el formato. Para el c\xf3digo: traduzca solo los comentarios y las cadenas, conservando la sintaxis tal cual.","userPreferences":"Respete estas preferencias de usuario sobre c\xf3mo quieren que se genere el texto: {{userPreferences}}.","genericUserPrompt":"Traducir: {{userRequestText}}"},"disabled":{"title":"Las tareas inteligentes est\xe1n deshabilitadas","description":"Parece que has desactivado las tareas inteligentes. Actualiza para desbloquear la generaci\xf3n de texto, la reescritura y m\xe1s en tu configuraci\xf3n."},"skipTyping":{"complete":"{{tarea}} completada y lista para ser copiada al portapapeles."},"summarizePrompt":{"systemPrompt":"Resuma el texto proporcionado de forma concisa. Puede formar parte de un documento m\xe1s extenso. No utilice formato Markdown ni delimitadores de c\xf3digo. Genere \xdaNICAMENTE el resumen: sin pre\xe1mbulo, etiquetas, explicaciones ni comentarios, y no explique el procedimiento.","userPreferences":"Respete estas preferencias del usuario sobre c\xf3mo desea que se genere el texto: {{userPreferences}}.","summarizeInstructions":"Instrucciones: {{summarizeInstructions}}.","userPrompt":"Resumen: {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"Reescribe o reformatea el texto proporcionado seg\xfan las instrucciones. Si lo reformateas (por ejemplo, listas, tablas, cambios de estructura), conserva las palabras originales exactamente. Si lo reescribes (por ejemplo, tono, estilo, extensi\xf3n), conserva el significado, pero no necesariamente las palabras. Esto puede ser parte de un documento m\xe1s extenso. Adapta el formato de entrada: si el texto fuente ya est\xe1 en formato Markdown o c\xf3digo, cons\xe9rvalo. De lo contrario, no introduzcas formato Markdown (encabezados, negrita, vi\xf1etas, delimitadores de c\xf3digo) a menos que las instrucciones soliciten expl\xedcitamente una lista, tabla o estructura similar. Genera \xdaNICAMENTE el resultado; sin pre\xe1mbulo, etiquetas, encabezados, explicaciones ni comentarios.","userPreferences":"Respete estas preferencias del usuario sobre c\xf3mo desea que se genere el texto: {{userPreferences}}.","rewriteInstructions":"Instrucciones: {{rewriteInstructions}}."}},"profile":{"title":"Controles de la aplicaci\xf3n","titlePlural":"Controles de la aplicaci\xf3n","titlePreview":"Vista previa de los controles","previous":"Controles de aplicaciones anteriores","manage":"Administrar controles de aplicaciones","view":"Controles de vista","edit":"Editar controles de la aplicaci\xf3n","add":"Agregar controles de aplicaci\xf3n","create":"Crear controles de aplicaci\xf3n","warn":"La c\xe1mara o el micr\xf3fono deben estar iniciados para poder usar los controles de la aplicaci\xf3n.","descriptionShort":"Descubra las diferentes formas en que Cephable le ayuda a controlar sus dispositivos y software.","name":"Nombre de la aplicaci\xf3n","nameQuestion":"\xbfC\xf3mo quieres llamar a estos controles de la aplicaci\xf3n?","newName":"Nuevos controles de la aplicaci\xf3n","search":"Buscar controles de aplicaciones por nombre","searchLong":"Buscar controles de aplicaciones por nombre o descripci\xf3n","keyboardAndMouse":"Teclado y rat\xf3n","genericController":"Mando de gamepad","keyboardMouseAndController":"Teclado, rat\xf3n y controlador","permissionError":"No tienes permiso para usar estos controles de la aplicaci\xf3n.","set":{"title":"Parece que a\xfan no tienes configurados los controles de la aplicaci\xf3n.","cta":"Establecer controles de la aplicaci\xf3n","empty":{"auto":"Cambiar a otra aplicaci\xf3n para ver los controles","select":"Seleccione un control para comenzar","none":"No se encontraron controles de aplicaci\xf3n"},"description":"Los controles de la aplicaci\xf3n permiten a Cephable saber qu\xe9 detectar y qu\xe9 acciones realizar. Puedes cambiar los controles de la aplicaci\xf3n cuando quieras desde la p\xe1gina de inicio o en la configuraci\xf3n de tu conexi\xf3n."},"summary":{"title":"Resumen de los controles de la aplicaci\xf3n","descriptionLong":"Aqu\xed tienes los detalles de estos controles de la aplicaci\xf3n. Puedes buscar controles, acciones y m\xe1s para ver qu\xe9 puedes hacer con ellos.","description":"Obtenga un resumen de estos controles de la aplicaci\xf3n, incluidos qu\xe9 controles hay, personalizaciones, detalles y m\xe1s.","view":"Ver resumen de controles de la aplicaci\xf3n","filter":"Filtrar por tipo de entrada","placeholder":"Buscar nombres de controles..."},"copy":{"title":"Copiar controles de la aplicaci\xf3n","duplicate":"Controles de aplicaciones duplicados","question":"\xbfCrear una copia?","description":"\xbfQuieres crear una copia de estos controles de la aplicaci\xf3n? Se abrir\xe1 una nueva ventana con los controles copiados, pero no se a\xf1adir\xe1 a tu cuenta hasta que la guardes.","confirm":"S\xed, crea una copia","profileSuffix":"{{name}} (copia)"},"new":{"title":"Crear nuevos controles de aplicaci\xf3n","description":"Crea controles desde cero o deja que la IA de vanguardia genere controles personalizados, lo que te permitir\xe1 navegar por aplicaciones y software sin esfuerzo usando tu voz, cabeza y gestos faciales.","note":"Recomendado para usuarios avanzados.","scratch":"Crear desde cero"},"advancedOptions":"Opciones de control avanzadas","delete":{"title":"Eliminar controles de la aplicaci\xf3n","titleLong":"Eliminar estos controles de la aplicaci\xf3n","description":"Puede eliminar estos controles de aplicaci\xf3n haciendo clic en \\"Eliminar controles de aplicaci\xf3n\\".","confirm":"\xbfEst\xe1s seguro de que deseas eliminar estos controles de la aplicaci\xf3n?","confirmLong":"Una vez que elimines estos controles de la aplicaci\xf3n, no podr\xe1s volver a ellos. \xbfEst\xe1s seguro de que quieres eliminarlos?","confirmButton":"S\xed, elimine estos controles de la aplicaci\xf3n"},"current":"Controles actuales","loading":"Controles de carga...","null":"A\xfan no tienes controles de aplicaci\xf3n. Haz clic abajo para crear uno.","nullButton":"Crea tus primeros controles de aplicaci\xf3n","preview":"Avance","features":"Caracter\xedsticas","byline_public":"Por: Equipo Cephable","byline_shared":"Compartido por: Comunidad Cephable","share":{"title":"Controles de la aplicaci\xf3n para compartir","previewTitle":"Vista previa de los controles de aplicaciones compartidas","description":"\xa1Comparte estos controles de aplicaci\xf3n con otros para que puedan obtener una copia y personalizarlos desde all\xed!","descriptionLong":"Comparte estos controles de la aplicaci\xf3n para que puedan obtener una copia y personalizarlos desde ah\xed. Elige c\xf3mo quieres compartirlos y crea un enlace para enviarlos.","add":"Crear un enlace para compartir","confirm":"Comparte esta URL","link":"Compartir enlace","copy":"Copiar enlace","copied":"\xa1Copiado!","usage":"Cantidad de uso","created":"Creado {{value}}","expiration":{"title":"Vencimiento","once":"Solo se permite un uso","unlimited":"Permitir uso ilimitado","no":"Sin vencimiento","date":"Fecha de expiraci\xf3n","dateDescription":"Caduca en una fecha espec\xedfica"},"manage":"Administrar enlaces compartidos anteriores","empty":"No se han creado recursos compartidos para estos controles de aplicaci\xf3n."},"swap":{"title":"Controles de intercambio","titleLong":"Intercambia los controles de tu aplicaci\xf3n","descriptionShort":"Utilice diferentes controles de aplicaci\xf3n para que coincidan con el programa o software que est\xe1 utilizando.","description":"Puede alternar entre diferentes controles de aplicaciones para que coincidan con el programa o software que est\xe9 utilizando."},"autoProfileSwitching":{"title":"Conmutaci\xf3n autom\xe1tica de control","alerts":{"disabled":"El cambio autom\xe1tico de control est\xe1 desactivado.","temporarilyDisabled":"El cambio autom\xe1tico de control est\xe1 desactivado temporalmente.","enabled":"El cambio de control autom\xe1tico est\xe1 activado.","error":"Error al guardar las preferencias de cambio de control autom\xe1tico"},"associatedPrograms":{"add":"Agregar un nuevo programa asociado","description":{"personal":"Seleccione el software o los programas que desea conectar a estos controles. Esto permite el cambio autom\xe1tico de controles, donde Cephable cambiar\xe1 autom\xe1ticamente los controles de la aplicaci\xf3n para que coincidan con el programa que est\xe9 usando.","short":"Elija el software o programas que desea conectar a estos controles."},"edit":"Editar programas asociados","noOptionsText":"Comience a escribir para encontrar programas asociados","profileLabel":"Controles de la aplicaci\xf3n:","remove":"Eliminar programa asociado","title":"Programas asociados","when":"Cephable cambiar\xe1 autom\xe1ticamente los controles de mi aplicaci\xf3n a {{profileName}} cuando use...","emptySearch":"No hay programas asociados a estos controles.","error":"Error al guardar los programas asociados. Int\xe9ntalo de nuevo m\xe1s tarde.","emptyError":"Se detect\xf3 un programa asociado vac\xedo, elim\xednelo antes de continuar."},"commandOverlay":{"command":"Cambiar los controles de la aplicaci\xf3n: {{value}}"},"description":"El cambio autom\xe1tico de controles permite que Cephable se adapte a tu flujo de trabajo sin problemas. Al activarlo, Cephable ajustar\xe1 los controles de tu app seg\xfan el programa o software que uses. Si lo desactivas, puedes cambiar manualmente los controles de la app con el bot\xf3n \\"Intercambiar controles\\" o con comandos globales."},"error":{"noMatch":"No hay controles de aplicaci\xf3n que coincidan con tu b\xfasqueda.","load":"Error al cargar los controles de la aplicaci\xf3n.","add":"Error al agregar controles de la aplicaci\xf3n.","delete":"Error al eliminar los controles de la aplicaci\xf3n.","audioEventsWithEmptyCommands":"Faltan controles en tu respuesta. Revisa los controles para asegurarte de que est\xe9n completos.","conflicts":"Error al guardar los controles de la aplicaci\xf3n debido a conflictos.","save":"Error al guardar los controles de la aplicaci\xf3n. Int\xe9ntalo de nuevo.","device":"Control de aplicaci\xf3n no v\xe1lido para esta conexi\xf3n. Prueba con otro."},"conflictIndicators":{"errorTitle":"Error al guardar los controles de la aplicaci\xf3n debido a conflictos","warningTitle":"Controles de la aplicaci\xf3n guardados con advertencias","subtitle":"Los controles de la aplicaci\xf3n que creaste tienen algunas configuraciones que pueden entrar en conflicto.","profileNameErrors":"Conflicto de nombres en los controles de la aplicaci\xf3n","emptyControlsMapped":"Nombres de entrada vac\xedos","emptyControlsMappedDescription":"Agregue un comando de voz, expresi\xf3n facial, inclinaci\xf3n de cabeza u otro comando a su entrada.","emptyKeybindingControlsMapped":"Nombres de entrada vac\xedos para las combinaciones de teclas","emptyKeybindingControlsMappedDescription":"Agregue un comando de voz, expresi\xf3n facial, inclinaci\xf3n de cabeza u otro comando a su entrada para las combinaciones de teclas.","duplicateNameTitle":"Nombre de controles de aplicaci\xf3n duplicados","duplicateNameDescription":"Tienes controles de aplicaci\xf3n con el mismo nombre. C\xe1mbialo antes de continuar.","emptyNameTitle":"Nombre de controles de aplicaci\xf3n vac\xedos","emptyNameDescription":"Los controles de la aplicaci\xf3n deben tener un nombre, por ejemplo, Juego 1, Spotify, Palabra, etc.","macrosReleaseKeysMissingTitle":"Salidas con claves no liberadas","macrosReleaseKeysMissingDescription":"Agregue una clave de liberaci\xf3n o detenga todos los pasos para evitar que las claves se atasquen.","duplicateInputCommandMacroTitle":"Entradas de control id\xe9nticas","duplicateCommandsDescription":"Elimine o cambie los comandos de entrada duplicados.","duplicateInputCommandBindingsTitle":"Entradas de control id\xe9nticas para combinaciones de teclas","conflictIndicatorDisplayString":"{{container}}: {{commandOrKeyName}} con {{commandOrEventType}}","duplicateMacroNames":"Nombres de control duplicados","duplicateMacroNamesDescription":"Elimine o cambie uno de sus nombres de control id\xe9nticos.","warningIgnore":"Ignorar","warningDoNotShowAgain":"No volver a mostrar advertencias","macrosVoiceCommandConflictWithDictationTitle":"Controlar los comandos de voz igual que las palabras clave de dictado","keybindingsVoiceCommandConflictWithDictationTitle":"Combinaciones de teclas: comandos de voz iguales que las palabras clave de dictado","macrosVoiceCommandConflictWithDictationDescription":"Tus entradas de voz activar\xe1n el dictado y los comandos de voz.","keybindingsVoiceCommandConflictWithDictationDescription":"Tus entradas de voz activar\xe1n el dictado y las pulsaciones de teclas.","macrosVoiceCommandConflictWithGenerationTitle":"Los comandos de voz de control son los mismos que las palabras clave de generaci\xf3n","keybindingsVoiceCommandConflictWithGenerationTitle":"Las combinaciones de teclas de los comandos de voz son las mismas que las palabras clave de generaci\xf3n","macrosVoiceCommandConflictWithGenerationDescription":"Tus entradas de voz activar\xe1n la generaci\xf3n y los comandos de voz.","keybindingsVoiceCommandConflictWithGenerationDescription":"Tus entradas de voz activar\xe1n la generaci\xf3n y las pulsaciones de teclas.","duplicateAssociatedProgramNames":"Nombres de programas asociados duplicados","duplicateAssociatedProgramNamesDescription":"Elimine o cambie uno de sus programas asociados id\xe9nticos.","emptyEvent":{"title":"Pasos faltantes","description":"Faltan pasos en tus controles. Esto podr\xeda provocar que Cephable no realice una acci\xf3n al dar una orden."},"warningDetails":"Ver todos los conflictos"},"success":{"save":"Controles de la aplicaci\xf3n guardados.","add":"Se agregaron controles de aplicaci\xf3n.","delete":"Controles de la aplicaci\xf3n eliminados.","share":"Enlace compartido creado y copiado al portapapeles","shareDelete":"Enlace compartido eliminado.","generate":"Controles de aplicaci\xf3n generados."},"warning":"Controles de la aplicaci\xf3n guardados con advertencias","customize":"Personalizar los controles de la aplicaci\xf3n","custom":"{{name}} (Personalizado)","description":"Los controles de la aplicaci\xf3n son un conjunto de controles que puedes usar para controlar tu dispositivo o conexi\xf3n. Puedes crear varios controles de la aplicaci\xf3n y alternar entre ellos cuando quieras."},"publicProfiles":{"toolbar":"Explorar los controles de la aplicaci\xf3n","title":"Explorar los controles de la aplicaci\xf3n","offline":{"title":"No se pueden cargar los controles de la aplicaci\xf3n p\xfablica","description":"Parece que no tienes conexi\xf3n. Puedes seguir usando los controles de tu aplicaci\xf3n, pero no podr\xe1s cargar nuevos controles p\xfablicos.","confirm":"Bueno"},"announcement":"Se han cargado {{count}} nuevos controles de aplicaci\xf3n","description":{"personal":"Los controles p\xfablicos de aplicaciones est\xe1n disponibles para ayudarte a empezar a usar Cephable r\xe1pidamente en tus aplicaciones favoritas. Puedes usar los controles predeterminados, personalizarlos seg\xfan tus necesidades o crear controles de aplicaci\xf3n completamente nuevos y personalizados desde cero.","pro":"Los controles p\xfablicos de aplicaciones est\xe1n disponibles para ayudarte a empezar a usar Cephable r\xe1pidamente en tus aplicaciones favoritas. Puedes usar los controles predeterminados, personalizarlos seg\xfan tus necesidades o crear controles personalizados completamente nuevos mediante el generador de controles."},"team":"Equipo Cephable"},"publicTag":"P\xfablico","tray":{"panel":"Panel de alternancia","dashboard":"Mostrar panel de control","quit":"Salir de Cephable"},"generate":"Generar","stop":"Detener","clear":"Claro","rewrite":"Volver a escribir","translate":"Traducir","smartTasks":{"title":"Tareas inteligentes","show":"Mostrar tareas inteligentes","description":"Las tareas inteligentes son las diferentes tareas que la IA de Cephable puede realizar por ti. Estas tareas, impulsadas por la IA del dispositivo, permiten crear texto, resumir, reescribir, traducir, tomar notas y chatear con documentos.","generateText":{"title":"Generar texto","description":"Crea contenido de texto basado en tus aportaciones o indicaciones.","label":"Describe lo que quieres generar"},"summarizeText":{"title":"Resumir texto","description":"Extrae informaci\xf3n valiosa de textos extensos y crea res\xfamenes breves o ideas clave.","directions":"Ingrese el texto a resumir, o Cephable utilizar\xe1 autom\xe1ticamente el texto que haya resaltado.","write":"Escribir resumen","outputLabel":"Su resumen aparecer\xe1 aqu\xed.","inputLabel":"Introduzca el texto que desea condensar."},"rewriteText":{"title":"Reescribir texto","description":"Resalte el texto en otra aplicaci\xf3n donde est\xe9 escribiendo y luego regrese aqu\xed y describa c\xf3mo desea que se reescriba.","label":"Describe c\xf3mo quieres reescribir el texto.","inputLabel":"Introduzca el texto para reescribir"},"translateText":{"title":"Traducir texto","description":"Ingrese el texto a traducir o Cephable utilizar\xe1 autom\xe1ticamente el texto que haya resaltado.","label":"Introduzca el texto a traducir","languageLabel":"Idioma al que traducir"},"noteTaker":{"title":"Tomador de notas","description":"Deje que Cephable grabe y transcriba localmente sus reuniones o conversaciones"},"documentChat":{"title":"Chat de documentos","description":"Interact\xfae y consulte documentos para obtener informaci\xf3n r\xe1pidamente."},"highlightText":{"title":"Usar texto resaltado","description":"Cephable puede usar autom\xe1ticamente el texto que hayas resaltado en cualquier aplicaci\xf3n para realizar tareas como resumir, reescribir o traducir. Tambi\xe9n puedes introducir el texto manualmente si lo prefieres.","label":"Introduzca el texto a utilizar","placeholder":"Tambi\xe9n puedes resaltar texto en otra aplicaci\xf3n y volver aqu\xed para usarlo.","noTextFound":"No se encontr\xf3 texto. Seleccione el texto en otra aplicaci\xf3n o p\xe9guelo en el campo e int\xe9ntelo de nuevo."},"pasteText":{"title":"Pegar texto","description":"Cephable puede usar autom\xe1ticamente el texto que has copiado al portapapeles para realizar tareas como resumir, reescribir o traducir. Tambi\xe9n puedes introducir el texto manualmente si lo prefieres.","label":"Introduzca el texto a utilizar","placeholder":"Tambi\xe9n puedes resaltar texto en otra aplicaci\xf3n y volver aqu\xed para usarlo."},"clearCache":"Si observa problemas al generar el texto, borre la cach\xe9 y los recursos desde la configuraci\xf3n de generaci\xf3n de texto e int\xe9ntelo de nuevo.","transcribeAudio":{"title":"Transcribir audio","description":"Convierta archivos de audio o video en texto usando la transcripci\xf3n de IA.","inputMethod":"Elija el m\xe9todo de entrada","localFile":"Archivo local","url":"URL","selectFile":"Seleccionar archivo de audio/video","urlLabel":"URL de audio/v\xeddeo","transcribe":"Transcribir","result":"Resultado de la transcripci\xf3n","invalidFileType":"Seleccione un archivo de audio o v\xeddeo v\xe1lido (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Error de transcripci\xf3n","history":{"title":"Historial de transcripci\xf3n","description":"Vea y administre sus transcripciones guardadas.","viewHistory":"Ver historial","empty":"A\xfan no hay transcripciones. \xa1Empieza a transcribir para construir tu historia!","titleLabel":"T\xedtulo (opcional)","titlePlaceholder":"Introduzca un t\xedtulo para esta transcripci\xf3n","textLabel":"Texto de transcripci\xf3n","confirmDelete":"\xbfEst\xe1 seguro de que desea eliminar esta transcripci\xf3n?"}},"aiWorkflows":{"description":"Automatiza las tareas de tu escritorio y navegador con IA. Simplemente describe lo que quieres lograr y observa c\xf3mo Cephable ejecuta las acciones.","label":"Describe lo que quieres lograr","status":{"idle":"Esperando tus instrucciones...","initializing":"Preparando las cosas...","planning":["Haciendo un plan...","Desglosando su solicitud...","Trazando los pasos...","Organizando el flujo de trabajo...","Preparando la estrategia...","Creando un plan de acci\xf3n...","Descubriendo la mejor manera de ayudarte...","Determinar c\xf3mo abordar esto...","Analizando su solicitud...","Planificando la ejecuci\xf3n..."],"thinking":["Pensamiento..."],"waitingForUser":"Necesitamos su aportaci\xf3n para continuar.","completed":"\xa1\xc9xito!","failed":"Tu solicitud fall\xf3: {{message}}","canceled":"Su solicitud fue cancelada","terminated":"Detenido. Esperando sus instrucciones...","thinkingInteractive":["Considerando el siguiente paso...","Repasando lo que hemos hecho hasta ahora...","Decidir qu\xe9 hacer a continuaci\xf3n...","Analizando los resultados...","Planificando la continuaci\xf3n...","Evaluando las opciones...","Descubriendo cu\xe1l es el mejor siguiente paso...","Trabajando en la siguiente parte de tu solicitud...","Trabajando en los pr\xf3ximos pasos...","Procesando los resultados del paso anterior..."],"tools":{"click_element_by_index":{"executing-start":"Haciendo clic en el bot\xf3n correspondiente...","executing-complete":"Hice clic en {{params.index}}."},"click_element":{"executing-start":"Haciendo clic en el n\xfamero resaltado...","executing-complete":"Hice clic en {{params.elementName}}."},"copy_selection":{"executing-start":"Recopilando contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"draft_email":{"executing-start":"Redactar un correo electr\xf3nico...","executing-complete":"Redact\xe9 un correo electr\xf3nico sobre {{params.subject}}."},"execute_app_action":{"executing-start":"Ejecutando {{params.actionName}}...","executing-complete":"{{params.actionName}} completado."},"find_all_text":{"executing-start":"Buscando todo el contexto relevante sobre {{params.searchText}}...","executing-complete":"Encontr\xe9 todo el contexto relevante sobre {{params.searchText}}."},"find_and_select_text":{"executing-start":"Buscando y seleccionando contexto relevante sobre {{params.searchText}}...","executing-complete":"Encontr\xe9 y seleccion\xe9 contexto relevante sobre {{params.searchText}}."},"generate_text":{"executing-start":"Creando contenido...","executing-progress":"Creando contenido...{{progress}}%","executing-complete":"He creado el contenido solicitado."},"get_all_interactive_elements":{"executing-start":"Escaneando para obtener m\xe1s contexto...","executing-complete":"Entiendo con qu\xe9 puedo interactuar."},"get_all_text_elements_content":{"executing-start":"Leyendo para obtener m\xe1s contexto...","executing-complete":"Entiendo qu\xe9 contenido de texto est\xe1 disponible."},"get_all_text_elements_names":{"executing-start":"Leyendo para obtener m\xe1s contexto...","executing-complete":"Entiendo qu\xe9 contenido de texto est\xe1 disponible."},"get_available_profile_actions":{"executing-start":"Comprobando qu\xe9 controles est\xe1n disponibles en esta aplicaci\xf3n...","executing-complete":"Entiendo lo que puedo hacer en esta aplicaci\xf3n."},"get_document_content":{"executing-start":"Leyendo para obtener m\xe1s contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"get_installed_apps":{"executing-start":"Decidir qu\xe9 aplicaci\xf3n es relevante para su solicitud...","executing-complete":"S\xe9 qu\xe9 aplicaciones puedo usar."},"get_running_app_names":{"executing-start":"Decidir qu\xe9 aplicaci\xf3n es relevante para su solicitud...","executing-complete":"S\xe9 qu\xe9 aplicaciones puedo usar."},"get_selected_text":{"executing-start":"Leyendo el contenido seleccionado...","executing-complete":"Tengo contexto sobre el contenido seleccionado."},"get_stored_content":{"executing-start":"Recopilando contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"keyboard_shortcut":{"executing-start":"Recopilando contexto...","executing-complete":"Tengo el contexto, listo para la siguiente parte de tu solicitud."},"open_app":{"executing-start":"Abriendo {{params.appName}}...","executing-complete":"Abr\xed {{params.appName}}."},"open_webpage":{"executing-start":"Abriendo {{params.url}}...","executing-complete":"Abr\xed {{params.url}}."},"paste_content":{"executing-start":"Escribiendo...","executing-complete":"Termin\xe9 de escribir."},"respond_to_user":{"executing-start":"Completando su solicitud...","executing-complete:":"He completado tu solicitud."},"search_browser":{"executing-start":"Buscando en la web {{params.query}}...","executing-complete":"Busqu\xe9 en la web {{params.query}}."},"select_all_text":{"executing-start":"Seleccionando todo el texto...","executing-complete":"Seleccion\xe9 todo el texto."},"summarize_text":{"executing-start":"Resumiendo el texto...","executing-progress":"Resumiendo...{{progress}}%","executing-complete":"Resum\xed el texto."},"translate_text":{"executing-start":"Traduciendo el texto a {{params.targetLanguage}}...","executing-progress":"Traduciendo...{{progress}}%","executing-complete":"Traduje el texto a {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"Escribiendo...","executing-complete":"Termin\xe9 de escribir."},"type_text":{"executing-start":"Escribiendo...","executing-complete":"Termin\xe9 de escribir."},"unknown":{"executing-start":"Me encontr\xe9 con un problema y prob\xe9 una estrategia diferente...","executing-complete":"Prob\xe9 una estrategia diferente."},"append_to_file":{"executing-start":"A\xf1adiendo al archivo...","executing-complete":"Agregu\xe9 contenido al archivo."},"copy_path":{"executing-start":"Proceso de copiar...","executing-complete":"Lo copi\xe9."},"create_directory":{"executing-start":"Creando la carpeta...","executing-complete":"Yo cre\xe9 la carpeta."},"delete_path":{"executing-start":"Eliminando...","executing-complete":"Lo borr\xe9."},"edit_user_file":{"executing-start":"Editando el archivo...","executing-complete":"Edit\xe9 el archivo."},"get_file_info":{"executing-start":"Revisando el archivo...","executing-complete":"Revis\xe9 el archivo."},"list_directory":{"executing-start":"Listado de la carpeta...","executing-complete":"He enumerado la carpeta."},"move_path":{"executing-start":"Emocionante...","executing-complete":"Lo mov\xed."},"open_path":{"executing-start":"Apertura...","executing-complete":"Lo abr\xed."},"read_user_file":{"executing-start":"Leyendo el archivo...","executing-complete":"Le\xed el archivo."},"run_command":{"executing-start":"Ejecutando un comando...","executing-complete":"Ejecut\xe9 el comando."},"search_files":{"executing-start":"Buscando archivos...","executing-complete":"Encontr\xe9 archivos coincidentes."},"search_in_files":{"executing-start":"Buscando dentro de los archivos...","executing-complete":"Busqu\xe9 dentro de los archivos."},"write_user_file":{"executing-start":"Escribiendo el archivo...","executing-complete":"Yo escrib\xed el archivo."},"rewrite_text":{"executing-progress":"Reescritura...{{progreso}}%"},"analyze_table":{"executing-start":"Analizando la tabla...","executing-complete":"Analic\xe9 la tabla."}},"networkError":"Se perdi\xf3 la conexi\xf3n al descargar el modelo. Comprueba tu conexi\xf3n a internet y vuelve a intentarlo enviando un mensaje o reiniciando la aplicaci\xf3n.","executing-org-block":"No se puede {{params.toolName}} porque la interacci\xf3n con {{params.appOrDomain}} est\xe1 bloqueada por la organizaci\xf3n.","executing-destructive-block":"La interacci\xf3n con {{params.elementName}} est\xe1 bloqueada. Por favor, revise y realice esta acci\xf3n manualmente.","executing-type-focus-block":"Tuve un problema al escribir el contenido. Se copi\xf3 al portapapeles; por favor, p\xe9guelo manualmente.","executing-permission-block":"Tuve un problema al acceder al archivo.","stopped":"Interrumpido.","unsupportedOSVersion":"Tienes un sistema macOS obsoleto; actual\xedzalo e int\xe9ntalo de nuevo.","loadNotice":{"firstRunSetup":"Configurando la IA en el dispositivo por primera vez. Esto puede tardar unos minutos, pero la pr\xf3xima vez ser\xe1 m\xe1s r\xe1pido.","largeModel":"Cargando {{model}} ({{size}} GB). Los modelos m\xe1s grandes pueden tardar unos minutos en cargarse. Para una carga m\xe1s r\xe1pida, seleccione un modelo m\xe1s peque\xf1o en Configuraci\xf3n.","driverIssue":"Es posible que el controlador de gr\xe1ficos est\xe9 desactualizado, por lo que la IA del dispositivo funciona a un ritmo m\xe1s lento. Actualizar el controlador de gr\xe1ficos puede mejorar su velocidad y fiabilidad.","longTask":"Esta tarea se est\xe1 alargando, as\xed que le estoy dando m\xe1s tiempo para procesarse. Esto puede tardar hasta un minuto."}},"ready":{"waiting":"AI Workflows est\xe1 listo. Esperando tus instrucciones.","execute":"Los flujos de trabajo de IA est\xe1n listos. A partir de tu solicitud..."},"start":"Comenzar","progress":"Laboral...","title":"Sus flujos de trabajo de IA est\xe1n listos.","steps":{"thinking":"Pensamiento","tool":"Herramienta","details":"Detalles","chunkProgress":"parte {{current}} de {{total}}","output":"Producci\xf3n","showMore":"Mostrar m\xe1s","showLess":"Mostrar menos","contentUsed":"Contenido utilizado","contentSource":"Contenido de origen","contentTruncated":"Mostrando los primeros {{shown}} de {{total}} caracteres","error":"Error"},"prefix":"Flujo de trabajo:","files":{"sectionTitle":"Archivos","open":"Abierto","openFile":"Abrir archivo","openFolder":"Abrir carpeta","openError":"No se pudo abrir \\"{{name}}\\". Es posible que se haya movido o eliminado."},"input":{"other":"Otro\u2026","otherPlaceholder":"Escribe tu respuesta","submit":"Enviar"},"continue":{"label":"Continuar","placeholder":"P\xeddele a Cephable que haga m\xe1s con este resultado\u2026"},"retry":{"label":"Rever"},"context":{"approaching":"Esta conversaci\xf3n se est\xe1 alargando (se est\xe1 utilizando el {{percent}}% de la memoria de la IA). Es posible que los mensajes m\xe1s antiguos se eliminen pronto.","trimmed":"Esta conversaci\xf3n ha alcanzado el l\xedmite de memoria de la IA, por lo que podr\xeda empezar a olvidar mensajes anteriores. Inicie un nuevo flujo de trabajo para reiniciarlo.","indicator":"{{percent}}% de memoria de trabajo utilizada","indicatorPending":"Memoria de trabajo utilizada para este flujo de trabajo","indicatorTokens":"{{used}}/{{budge}} usado"},"approval":{"title":"Confirmar acci\xf3n","approve":"Aprobar","reject":"Rechazar","edit":"Editar","deletePath":"\xbfEliminar este archivo/carpeta? Esto es permanente.","runCommand":"\xbfEjecutar este comando de shell?","movePath":"\xbfMover o renombrar esta ruta? Podr\xeda sobrescribir la ruta de destino.","confirmDelete":"Borrar","confirmRun":"Ejecutar comando","confirmMove":"Mover","badgeDestructive":"Destructivo","badgeCaution":"Precauci\xf3n"},"browser":{"sectionTitle":"Navegador","view":"Ver navegador","open":"Abierto","openError":"No se pudo abrir el navegador."},"resume":{"title":"Continuar una conversaci\xf3n anterior","description":"Busca en tu historial de automatizaci\xf3n y retoma donde lo dejaste.","searchPlaceholder":"Buscar chats anteriores\u2026","noMatches":"No se encontraron chats anteriores que coincidan con \\"{{query}}\\"","empty":"A\xfan no hay automatizaciones anteriores.","continuing":"Continuar la conversaci\xf3n","stopContinuing":"Inicia un nuevo chat en su lugar.","indicator":"Continuando la conversaci\xf3n \\"{{title}}\\"","clear":"Borrar chat seleccionado"}},"generatedByAI":"Desarrollado con inteligencia artificial en el dispositivo, revise para verificar su precisi\xf3n.","networkError":"Se perdi\xf3 la conexi\xf3n al descargar el modelo. Comprueba tu conexi\xf3n a internet y vuelve a intentarlo enviando un mensaje o reiniciando la aplicaci\xf3n.","genericError":"Se ha producido un error inesperado. Por favor, int\xe9ntelo de nuevo.","download":{"title":"Descarga modelos de IA para desbloquear m\xe1s funcionalidades.","description":"Para usar las tareas inteligentes, es necesario descargar un modelo local en tu dispositivo. Esto garantiza que tus datos permanezcan privados y nunca se env\xeden a la nube.","confirm":"Descargar","cancel":"Ahora no"},"runningInBackground":{"generate":"Generando en segundo plano...","rewrite":"Reescritura en segundo plano...","translate":"Traduciendo en segundo plano...","summarize":"Resumiendo los antecedentes...","generic":"Ejecut\xe1ndose en segundo plano..."},"processing":"Tratamiento..."},"inputMethod":"M\xe9todo de entrada:","hotkey":{"title":"Bot\xf3n de acci\xf3n r\xe1pida","titlePlural":"Botones de acci\xf3n r\xe1pida","titlePanel":"Acciones r\xe1pidas","label":"Nombre para mostrar del bot\xf3n de acci\xf3n r\xe1pida","placeholder":"Nombre para mostrar","question":"\xbfC\xf3mo te gustar\xeda llamar a este bot\xf3n?","when":"Cuando toco...","description":"Los botones de acci\xf3n r\xe1pida son botones personalizables que puedes pulsar para realizar acciones relevantes en tu aplicaci\xf3n. Con una sola pulsaci\xf3n puedes ejecutar varios pasos o una sola acci\xf3n.","usagePrompt":"Los botones de acci\xf3n r\xe1pida son botones personalizables que puedes pulsar para realizar acciones relevantes en tu aplicaci\xf3n. Puedes a\xf1adir, eliminar o editar los nombres desde la p\xe1gina principal de configuraci\xf3n de controles de la aplicaci\xf3n.","reorder":"Puede reorganizar el orden utilizando los botones de subir y bajar.","emptyTitle":"Sin botones de acci\xf3n r\xe1pida","edit":"Editar botones de acci\xf3n r\xe1pida","tap":"Toque {{value}}","copySuffix":"{{name}}_copiar","hotkeysOnly":"Botones personalizados","allControls":"Todos los controles de la aplicaci\xf3n","show":"Mostrar botones de acci\xf3n r\xe1pida","deprecatedDialog":{"title":"Los controles de tu aplicaci\xf3n requieren una actualizaci\xf3n.","description2":"Solo necesitas una actualizaci\xf3n r\xe1pida (literalmente, un segundo) y disfrutar\xe1s de una experiencia de personalizaci\xf3n de botones impecable. Olv\xeddate de los pasos adicionales y dale la bienvenida a una interfaz m\xe1s intuitiva. \xbfListo para el cambio?","confirm":"\xa1Vamos a hacerlo!","description1":"Parece que est\xe1s usando controles de app antiguos con botones de acci\xf3n r\xe1pida. \xa1Tenemos novedades emocionantes para ti! Hemos renovado el sistema para que crear y editar botones de acci\xf3n r\xe1pida sea muy f\xe1cil, sin necesidad de tener que recurrir a ajustes avanzados."},"demo":{"title":"Botones de acci\xf3n r\xe1pida de demostraci\xf3n","step1":"Activar los botones de acci\xf3n r\xe1pida","step2":"Utilice los ejemplos que aparecen a continuaci\xf3n para controlar el bloque de texto.","command1":"Presione el bot\xf3n 1 para \u201CAgrandar el texto\u201D","command2":"Presione el bot\xf3n 2 para poner el texto en negrita","command3":"","continue":"Continuar con los botones de acci\xf3n r\xe1pida","description":"El \xe1rea de demostraci\xf3n a continuaci\xf3n le permitir\xe1 probar los botones de acci\xf3n r\xe1pida. La demostraci\xf3n se limita espec\xedficamente al control de esta \xe1rea de texto."},"example":{"title":"Ejemplos de botones de acci\xf3n r\xe1pida","command1":"Toque Pausa","example1":"Ejemplo de \u201Cpausar video\u201D","command2":"Toque hacia adelante","example2":"Ejemplo de \u201Calejar\u201D","command3":"Toque Detener","example3":"Ejemplo \u201Ccerrar ventana\u201D","description":"Estos ejemplos demuestran la versatilidad de los botones de acci\xf3n r\xe1pida para controlar tu dispositivo o conexi\xf3n. Permiten ejecutar comandos, navegar por interfaces o realizar acciones con un simple toque."},"emptySearch":"No hay acciones r\xe1pidas que coincidan con este criterio.","empty":"Parece que actualmente no tienes ninguna acci\xf3n r\xe1pida.","emptyLong":"No hay botones de acci\xf3n r\xe1pida configurados en estos controles de la aplicaci\xf3n. Una vez que los agregues o elijas controles con uno, aparecer\xe1n aqu\xed."},"reset":"Reiniciar","info":"M\xe1s informaci\xf3n","device":{"title":"Conexi\xf3n","titlePlural":"Conexiones","status":{"title":"Estado de la conexi\xf3n:","connected":{"application":"Aplicaci\xf3n conectada","connection":"Conectado","device":"Dispositivo conectado","game":"Juego conectado"},"disconnected":{"application":"Aplicaci\xf3n desconectada","connection":"Desconectado","device":"Dispositivo desconectado","game":"Juego desconectado"}},"running":"Correr","offline":"Desconectado","otherDevices":"Otras conexiones de salida","currentStatus":"Estado actual:","connectionStatus":"Estado de la conexi\xf3n:","profileStatus":"Controles de la aplicaci\xf3n actual:","name":{"title":"Nombre de la conexi\xf3n","question":"\xbfC\xf3mo quieres llamar a esta conexi\xf3n?","description":"Dale un nombre a tu conexi\xf3n para que puedas encontrarla f\xe1cilmente m\xe1s tarde.","placeholder":"nombre de la conexi\xf3n","edit":"Editar el nombre de la conexi\xf3n"},"updates":{"title":"Actualizaciones de conexi\xf3n","settings":"Configuraci\xf3n de actualizaci\xf3n de conexi\xf3n","description":"Verifique las actualizaciones del firmware de conexi\xf3n y cambie la configuraci\xf3n de actualizaci\xf3n autom\xe1tica","edit":"Editar la configuraci\xf3n de actualizaci\xf3n","check":{"title":"Buscar actualizaciones","processing":"\xa1Buscando actualizaciones! Puede tardar unos minutos y tu conexi\xf3n podr\xeda reiniciarse durante las actualizaciones.","description":"Pulsa para buscar actualizaciones para tu conexi\xf3n. Si hay una actualizaci\xf3n disponible y tu conexi\xf3n est\xe1 activa, empezar\xe1 a actualizarse. Las actualizaciones pueden tardar unos minutos."},"auto":{"title":"Actualizar autom\xe1ticamente","description":"Con esta configuraci\xf3n activada, tu conexi\xf3n se actualizar\xe1 autom\xe1ticamente al conectarte a la red el\xe9ctrica, a una red wifi y al tener una actualizaci\xf3n disponible. Si est\xe1 desactivada, debes pulsar el bot\xf3n de actualizaci\xf3n para obtener la \xfaltima versi\xf3n.","option":"\xbfUtilizar actualizaci\xf3n autom\xe1tica?"}},"delete":{"title":"Desvincular {{name}}","titleLong":"Desvincular de la cuenta","description":"Al desvincular Cephable, se desconecta de este ordenador o juego y se elimina de tu cuenta. Ya no podr\xe1s conectarte, enviar comandos ni actualizarlo. Esta acci\xf3n no se puede deshacer, pero puedes crear una nueva conexi\xf3n al mismo ordenador o juego si quieres volver a usarlo en el futuro.","confirm":"\xbfEst\xe1s seguro de que deseas desvincular esta conexi\xf3n?","confirmLong":"\xbfSeguro que desea cancelar y restablecer esta conexi\xf3n? Ya no podr\xe1 conectarse, enviar comandos ni actualizarla. Despu\xe9s de cancelar y restablecer esta conexi\xf3n, cualquier otra persona podr\xe1 configurarla desde cero.","confirmButton":"S\xed, elimine esta conexi\xf3n."},"manage":{"title":"Haga clic para ver y administrar los detalles de sus conexiones.","description":"","name":"Personalice el nombre de su conexi\xf3n para una gesti\xf3n m\xe1s sencilla."},"error":{"save":"Error al guardar la conexi\xf3n.","load":"Error al cargar la conexi\xf3n.","add":"Error al agregar conexi\xf3n.","delete":"Error al eliminar la conexi\xf3n.","updates":"Error al comprobar actualizaciones.","connection":"No se ha establecido la conexi\xf3n. Aseg\xfarate de que est\xe9 conectada antes de volver a intentarlo.","deleteLong":"No pudimos eliminar esta conexi\xf3n de tu cuenta. Si vuelves a iniciar sesi\xf3n, es posible que tengas que eliminarla manualmente en la configuraci\xf3n de conexi\xf3n."},"success":{"save":"Conexi\xf3n guardada.","add":"Conexi\xf3n agregada.","delete":"Conexi\xf3n eliminada."},"description":"Cephable admite m\xfaltiples dispositivos y conexiones. Puedes administrar la configuraci\xf3n o seleccionar cualquiera de ellas desde aqu\xed. Este ordenador siempre ser\xe1 tu conexi\xf3n principal. Puedes a\xf1adir m\xe1s conexiones posteriormente.","swap":{"titlePlural":"Conexiones de intercambio","description":"Cephable admite varios dispositivos y conexiones. Puedes seleccionar cualquiera de ellos aqu\xed. Este ordenador siempre ser\xe1 tu conexi\xf3n principal. Puedes a\xf1adir m\xe1s conexiones m\xe1s adelante."},"control":{"button":"Control {{name}}","description":{"application":"Controla esta aplicaci\xf3n conectada con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"Guardar\\", se guardar\xe1 en la aplicaci\xf3n en ejecuci\xf3n.","connection":"Controla esta conexi\xf3n con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"Guardar\\", se guardar\xe1 la conexi\xf3n activa.","device":"Controla este dispositivo conectado con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"Abrir Spotify\\", se abrir\xe1 Spotify en el dispositivo en funcionamiento.","game":"Controla este juego conectado con tu voz, acciones r\xe1pidas, movimientos de cabeza y m\xe1s. Por ejemplo, si dices \\"\xa1Ya!\\", el jugador se mover\xe1 en un juego de carrera."},"generic":"Conexi\xf3n de control"},"titleShort":"Conectar","titleLong":"Conexiones y extensiones","viewAll":"Ver todas las conexiones","add":{"short":"Extender","title":"Agregar una nueva conexi\xf3n o extensi\xf3n","description":"Las conexiones y extensiones son maneras adicionales de mejorar tu experiencia con Cephable. Puedes agregar nuevas conexiones para conectarte a m\xe1s dispositivos, aplicaciones o juegos. Lleva tu experiencia con Cephable al siguiente nivel agregando conexiones y extensiones.","action":"Agregar una nueva conexi\xf3n","notAvailable":"Esta conexi\xf3n o extensi\xf3n no est\xe1 disponible p\xfablicamente actualmente. Esto suele ocurrir al trabajar con extensiones generadas por el usuario. Vuelva a consultarla m\xe1s tarde.","isNotPublic":"VISTA PREVIA: Esta extensi\xf3n se encuentra en versi\xf3n preliminar para desarrolladores y podr\xeda estar incompleta. Los desarrolladores deben completar todos los pasos antes del lanzamiento p\xfablico. Los usuarios pueden consultar la versi\xf3n completa m\xe1s adelante."},"new":"\xa1Tienes una nueva conexi\xf3n!","newLong":"\xa1Tienes una nueva conexi\xf3n! Para empezar a usarla, selecci\xf3nala en el men\xfa de abajo.","selectDevice":"Seleccionar dispositivo"},"explore":"Explorar","shortcuts":{"title":"Atajos globales","description":"Personalice los atajos de teclado para acceder r\xe1pidamente a los controles de Cephable desde cualquier lugar de su sistema.","info":"Estos atajos funcionan globalmente y se pueden usar incluso cuando Cephable no es la ventana activa.","shortcut":"Atajo","toggleMicrophone":"Activar o desactivar el micr\xf3fono","toggleDictation":"Activar o desactivar el modo de dictado","toggleVoiceControl":"Activar o desactivar el modo de control por voz","togglePanel":"Panel de alternancia","registrationFailed":"Algunos accesos directos globales no se registraron. Es posible que otra aplicaci\xf3n los est\xe9 usando.","record":{"title":"Acceso directo a grabaciones","start":"Haga clic para grabar","listening":"Presione la combinaci\xf3n de teclas deseada...","pressKeys":"Presione las teclas ahora"},"formatHint":"Seleccione al menos una tecla modificadora ({{modifierKey}}, {{modifierKey2}}, Shift) y otra tecla."},"gamepad":{"title":"Compatibilidad con gamepad","description":"Configurar la salida del gamepad y joystick para juegos de PC","driver":{"description":"Para admitir las salidas de los mandos de juego, Cephable necesita descargar e instalar un controlador externo llamado ViGEm. Este controlador habilita la funcionalidad del mando virtual de Xbox 360, que los juegos reconocen de forma nativa.","installed":"Controlador de juego instalado: \xa1Listo para usar las salidas del gamepad! Si el problema persiste, puedes intentar reinstalar el controlador.","notInstalled":"El controlador del controlador de juego no est\xe1 instalado","install":"Instalar el controlador del controlador de juego","reinstall":"Reinstalar el controlador del controlador de juego","installing":"Instalaci\xf3n del controlador de juego ViGEm...","installSuccess":"\xa1El controlador del mando ViGEm se instal\xf3 correctamente! Ya puedes usar las salidas del mando en tus controles.","installFailed":"No se pudo instalar el controlador de ViGEm. Int\xe9ntelo de nuevo o inst\xe1lelo manualmente desde el sitio web de ViGEm.","title":"Controlador de mando de juegos","disclosure":{"title":"\xbfInstalar un controlador de mando de terceros?","description":"Para que Cephable sea compatible con mandos de videojuegos, es necesario instalar ViGEm, un controlador no oficial de terceros que permite emular un mando virtual de Xbox. Contin\xfaa solo si quieres que Cephable instale este controlador.","confirm":"Instalar el controlador ViGEm"}},"platform":{"unsupported":"Plataforma no compatible con las funciones del gamepad","unsupportedDescription":"La funcionalidad de salida de mando actualmente solo es compatible con sistemas Windows x64. La compatibilidad con Mac y Windows ARM64 a\xfan no est\xe1 disponible."},"usage":"Una vez instalado el controlador del controlador de juego, puedes usar los movimientos del joystick y las pulsaciones de los botones del gamepad en tus macros y comandos de voz para controlar los juegos."},"youtube":{"unavailable":{"title":"V\xeddeo no disponible","description":"Este v\xeddeo no est\xe1 disponible actualmente. Vuelve a comprobarlo m\xe1s tarde.","retry":"Rever"},"watch":{"title":"Ups.","description":"Parece que hubo un problema al cargar el video. Puedes verlo directamente en YouTube.","button":"Mira en YouTube"},"offline":{"title":"V\xeddeo no disponible","description":"Este video de YouTube requiere conexi\xf3n a internet para cargarse. Comprueba tu conexi\xf3n y vuelve a intentarlo."}},"metrics":{"download":{"success":"Se accedi\xf3 exitosamente al archivo de m\xe9tricas.","manualPath":"Archivo de m\xe9tricas disponible en: {{path}}","error":"Error al descargar el archivo de m\xe9tricas.","noFile":"No se encontr\xf3 ning\xfan archivo de m\xe9tricas."},"clear":{"success":"Archivo de m\xe9tricas borrado exitosamente.","error":"Error al borrar el archivo de m\xe9tricas.","noFile":"No se encontr\xf3 ning\xfan archivo de m\xe9tricas para borrar.","confirm":"\xbfSeguro que desea borrar todos los datos de m\xe9tricas? Esta acci\xf3n no se puede deshacer."}},"suggestedPrompts":{"title":"Indicaciones sugeridas","description":"Personalice las indicaciones sugeridas que aparecen en las tareas de IA para ayudarlo a comenzar r\xe1pidamente.","edit":"Editar indicaciones sugeridas","generate":"Generar texto","rewrite":"Reescribir texto","addGenerate":"Agregar un mensaje de generaci\xf3n","addRewrite":"Agregar una solicitud de reescritura","remove":"Eliminar mensaje","generatePlaceholder":"Introduzca un mensaje para generar texto...","rewritePlaceholder":"Introduzca un mensaje para reescribir el texto...","suggested":"Indicaciones sugeridas","suggestedFor":"Sugerido para {{profileName}}","seeAll":"Ver todas las indicaciones","showLess":"Mostrar menos","allPrompts":"Todas las indicaciones","customFor":"Avisos personalizados para {{profileName}}","defaultPrompts":"Indicaciones predeterminadas","defaultGenerate":["Un correo electr\xf3nico profesional presentando nuestro nuevo producto.","Una agenda de reuni\xf3n para la discusi\xf3n del equipo de la pr\xf3xima semana.","Esquema de propuesta de proyecto para una nueva iniciativa","Una plantilla de carta comercial formal","Una secci\xf3n de documentaci\xf3n t\xe9cnica","Introducci\xf3n al manual del usuario","Descripci\xf3n general del documento de capacitaci\xf3n","Un borrador de documento de pol\xedtica","Un correo electr\xf3nico de seguimiento despu\xe9s de una reuni\xf3n","Un mensaje de agradecimiento a un cliente","Un correo electr\xf3nico de actualizaci\xf3n del estado del proyecto","Una invitaci\xf3n a un evento de la empresa","Un correo electr\xf3nico recordatorio para las pr\xf3ximas fechas l\xedmite","Un correo electr\xf3nico de bienvenida para los nuevos miembros del equipo.","Un correo electr\xf3nico de disculpa por la interrupci\xf3n del servicio.","Introducci\xf3n a un bolet\xedn informativo","Una lista de ideas para campa\xf1as de marketing","Soluciones creativas para mejorar la productividad del equipo","Ideas para actividades de retiro de empresa","Conceptos para una nueva funci\xf3n de la aplicaci\xf3n m\xf3vil","Sugerencias para mejorar la experiencia del cliente","Ideas de innovaci\xf3n para el desarrollo de nuestros productos","Ideas de contenido para publicaciones en redes sociales","Temas de talleres para el desarrollo profesional","Una funci\xf3n que valida la entrada del usuario","Una consulta de base de datos para la gesti\xf3n de usuarios","C\xf3digo de manejo de errores para solicitudes de API","Una plantilla de archivo de configuraci\xf3n","Comentarios que explican un algoritmo complejo","Casos de prueba unitaria para una nueva caracter\xedstica","Documentaci\xf3n para puntos finales de API","Un script para la implementaci\xf3n automatizada"],"defaultRewrite":["Haz que este texto sea m\xe1s conciso y directo.","Ampliar este resumen con m\xe1s detalles","Reformatee esto como una lista numerada","Convertir esto en vi\xf1etas","Reestructura esto en p\xe1rrafos claros.","Haga que este texto sea m\xe1s f\xe1cil de escanear r\xe1pidamente","Organice esta informaci\xf3n jer\xe1rquicamente","Formatee esto como una gu\xeda paso a paso","Haz que este mensaje sea m\xe1s profesional y formal.","Reescribe esto para que suene m\xe1s informal y amigable.","Ajuste el tono para que sea m\xe1s alentador.","Haz que este sonido sea m\xe1s seguro y asertivo.","Suavizar el tono para ser m\xe1s diplom\xe1tico","A\xf1ade entusiasmo y energ\xeda a este texto.","Hazlo m\xe1s emp\xe1tico y comprensivo.","Reescribir con un tono m\xe1s colaborativo","Simplifique esto para una audiencia general.","Haga esta explicaci\xf3n m\xe1s t\xe9cnica y detallada.","Descomponga este concepto complejo en t\xe9rminos m\xe1s simples","A\xf1adir m\xe1s contexto e informaci\xf3n de fondo","Resuma esto en conclusiones clave","Desarrolle los puntos principales con ejemplos.","Hazlo m\xe1s accesible para principiantes.","Condense esto manteniendo la informaci\xf3n esencial.","Mejorar la claridad y la legibilidad","Hazlo m\xe1s atractivo e interesante.","Ajustar para una mejor gram\xe1tica y fluidez","Reescribir para enfatizar los beneficios"],"defaultSummarize":["Res\xfamelo en 3 puntos.","Extraer decisiones clave","Enumera los principales elementos de acci\xf3n.","Proporcione un resumen de una sola frase.","Resaltar los datos m\xe1s importantes","Res\xfamalo para un p\xfablico no t\xe9cnico.","Extraer las conclusiones clave","Res\xfamelo en 5 puntos.","Identificar el problema principal y la soluci\xf3n propuesta.","Enumere todas las conclusiones y recomendaciones.","Proporcione un resumen ejecutivo","Resuma la cronolog\xeda de los eventos.","Extraer todas las preguntas planteadas","Enumere las ventajas y desventajas mencionadas.","Resuma los argumentos clave."]},"accessibilityService":{"error":{"generic":"Error interno. Int\xe9ntelo de nuevo m\xe1s tarde.","elementNotFound":"No se encontr\xf3 ning\xfan resultado. Aseg\xfarese de que la b\xfasqueda exista y vuelva a intentarlo.","highlightOnConflict":"Se encontraron varios elementos. Refine su comando para especificar cu\xe1l desea seleccionar.","clickNotInitialized":"La funci\xf3n de b\xfasqueda por nombre no est\xe1 disponible por el momento. Si el problema persiste, p\xf3ngase en contacto con el servicio de asistencia.","platformUnsupported":"La funci\xf3n de selecci\xf3n por nombre no est\xe1 disponible en esta plataforma.","permission":"Cephable no tiene permiso para leer esta aplicaci\xf3n. Conc\xe9delo en Configuraci\xf3n del sistema > Privacidad y seguridad > {{pane}}. En un dispositivo administrado por tu empresa, es posible que tu administrador lo bloquee."},"clickWait":"Inicializando. Por favor, espere un momento y vuelva a intentarlo."},"deprecated":"Obsoleto","view":"Vista","aiWorkflows":{"settings":{"title":"Configuraci\xf3n automatizada","description":"Configure los modelos y dispositivos de IA utilizados para los flujos de trabajo de IA. Los flujos de trabajo de IA le permiten automatizar tareas de escritorio y navegador mediante IA en el dispositivo.","configType":{"title":"Tipo de configuraci\xf3n del modelo","description":"Seleccione el tipo de configuraci\xf3n de modelo que se usar\xe1 para los flujos de trabajo de IA. Cada configuraci\xf3n est\xe1 optimizada para distintos modelos.","label":"Tipo de configuraci\xf3n"},"reasoningModel":{"title":"Modelo de razonamiento","description":"Seleccione el modelo de IA que usar\xe1 para las tareas de razonamiento y planificaci\xf3n. El modelo de razonamiento analiza sus solicitudes y crea planes de acci\xf3n.","label":"Modelo de razonamiento"},"reasoningDevice":{"label":"Dispositivo de razonamiento"},"generationModel":{"title":"Modelo de generaci\xf3n","description":"Seleccione el modelo de IA que se usar\xe1 para las tareas de generaci\xf3n de texto. El modelo de generaci\xf3n crea contenido de texto cuando lo requieren los flujos de trabajo.","label":"Modelo de generaci\xf3n"},"generationDevice":{"label":"Dispositivo de generaci\xf3n"},"noModelsFound":"No se encontraron modelos","terminate":{"title":"Recursos de flujo de trabajo claros","description":"Haga clic para finalizar el flujo de trabajo y liberar recursos. Esto detendr\xe1 cualquier flujo de trabajo en ejecuci\xf3n y liberar\xe1 la memoria utilizada por los modelos de IA.","button":"Terminar trabajador de flujo de trabajo","success":"Trabajador de flujo de trabajo finalizado.","confirm":{"title":"Terminar trabajador de flujo de trabajo","description":"\xbfSeguro que desea finalizar el flujo de trabajo? Esto detendr\xe1 cualquier flujo de trabajo en ejecuci\xf3n y liberar\xe1 recursos.","confirm":"S\xed, terminar"}},"autoWarm":{"title":"Flujos de trabajo de IA de inicio autom\xe1tico","description":"Inicialice autom\xe1ticamente los modelos de flujo de trabajo de IA al iniciar la aplicaci\xf3n. Los modelos se precargar\xe1n para que los flujos de trabajo puedan iniciarse de inmediato.","option":"Iniciar autom\xe1ticamente modelos de flujo de trabajo de IA al iniciar la aplicaci\xf3n"},"prompt":{"title":"Informaci\xf3n adicional para flujos de trabajo de IA","description":"Introduzca detalles adicionales para usar con la IA de Cephable al ejecutar flujos de trabajo. Utilice este campo para especificar sus preferencias de tono, comportamiento o cualquier otro detalle.","field":"Aviso adicional","placeholder":"Por ejemplo, siempre confirme antes de enviar correos electr\xf3nicos. Prefiera respuestas concisas. Use un lenguaje formal en los documentos."},"disableButtonNames":{"edit":"Interacciones de botones de bloqueo","input":{"label":"Nombre del bot\xf3n","question":"\xbfQu\xe9 botones desea bloquear? Puede introducir el nombre completo o parcial de los botones.","remove":"Eliminar nombre del bot\xf3n"},"button":"Botones de bloque","description":"Controla con qu\xe9 botones pueden interactuar los flujos de trabajo de IA. Por defecto, Cephable puede hacer clic en cualquier bot\xf3n de la pantalla. Usa esta configuraci\xf3n para evitar acciones accidentales (por ejemplo, \\"comprar\\", \\"eliminar\\")."},"remoteWorkflows":{"title":"Ejecuta flujos de trabajo de IA en todos tus dispositivos.","option":"Permitir que mis otros dispositivos se inicien y sigan las automatizaciones de este dispositivo.","description":"Activada por defecto. Mientras est\xe1 activada, puedes iniciar, supervisar y responder a las automatizaciones de este dispositivo desde tus otros dispositivos con sesi\xf3n iniciada: el progreso de la automatizaci\xf3n (t\xedtulos de los pasos y razonamiento de la IA) y cualquier pregunta que te formule se env\xedan en tiempo real a esos dispositivos para que puedas responder desde cualquier lugar. Esta informaci\xf3n se comparte \xfanicamente entre tus propios dispositivos y nunca se almacena en los servidores de Cephable. Desact\xedvala para que las automatizaciones se ejecuten exclusivamente en este dispositivo: las automatizaciones seguir\xe1n funcionando aqu\xed, pero no se enviar\xe1 nada a tus otros dispositivos y estos no podr\xe1n iniciar una automatizaci\xf3n en este dispositivo."},"thinkingLevel":{"field":"Esfuerzo de razonamiento","description":"Indica cu\xe1nto tiempo dedica la IA a analizar cada paso antes de actuar. Los niveles superiores le permiten seleccionar y ordenar acciones de forma m\xe1s fiable en tareas complejas, pero ralentizan ligeramente cada paso. Se recomienda el nivel medio para la mayor\xeda de los usuarios.","low":"Bajo (m\xe1s r\xe1pido)","medium":"Medio (recomendado)","high":"Alto","max":"Max (el m\xe1s minucioso)"},"dynamicTools":{"option":"Cargando herramientas de conectores inteligentes","description":"Para empezar m\xe1s r\xe1pido, carga solo las herramientas que est\xe9s utilizando. Si est\xe1 desactivada, todas las herramientas se cargan a la vez; esto es \xfatil si quieres que el modelo decida qu\xe9 acciones tomar, pero puede ser mucho m\xe1s lento y provocar resultados deficientes."},"longTasks":{"field":"Tareas largas","description":"C\xf3mo los flujos de trabajo de IA gestionan tareas que requieren mucha atenci\xf3n, como la lectura de documentos extensos. El modo autom\xe1tico asigna m\xe1s tiempo a una tarea solo cuando es necesario. La prioridad a la velocidad mantiene cada paso r\xe1pido, pero las tareas muy largas pueden olvidar sus primeros pasos. La opci\xf3n \\"Permitir siempre tareas largas\\" otorga el m\xe1ximo tiempo a cada tarea, pero los pasos que implican escribir texto tardan un poco m\xe1s. Solo se aplica a ordenadores con tarjeta gr\xe1fica independiente.","auto":"Autom\xe1tico (recomendado)","speed":"Prioriza la velocidad","long":"Siempre permita tareas largas"}}},"control":"Control","automate":"Automatizar","deviceCommandThrottled":{"macroLength":"Esta conexi\xf3n no permite macros largas. Su macro se ha acortado autom\xe1ticamente.","commandCount":"Esta conexi\xf3n limita la velocidad de env\xedo de comandos. Espere y vuelva a intentarlo pronto.","incompatibleActions":"Este control contiene acciones que no se pueden usar juntas y no se envi\xf3."},"tos":{"title":"Actualizaci\xf3n de los T\xe9rminos de Servicio","description":"Nuestros T\xe9rminos de Servicio han sido actualizados. Lea y acepte los t\xe9rminos actualizados para continuar usando Cephable.","effectiveDate":"Fecha de entrada en vigor: {{date}}","accept":"Aceptar los T\xe9rminos de Servicio","loadError":"No se pueden cargar los T\xe9rminos de Servicio. Vuelva a intentarlo.","viewInBrowser":"Ver los T\xe9rminos de Servicio en el navegador","acceptCheckbox":"He le\xeddo y acepto los T\xe9rminos de Servicio"},"appearance":{"title":"Apariencia"},"troubleshooting":{"title":"Soluci\xf3n de problemas"},"extensions":{"title":"Extensiones","titleShort":"Extensiones","description":"Habilita funciones, conecta aplicaciones complementarias y ampl\xeda las capacidades de Cephable.","searchPlaceholder":"Extensiones de b\xfasqueda","noResults":"No se encontraron extensiones que coincidan con su b\xfasqueda.","comingSoon":"Muy pronto","done":"Hecho","getStarted":"Comience","viewDetails":"Ver detalles y configuraci\xf3n","enable":"Permitir","publisher":{"official":"Cef\xe1lico","officialTitle":"Oficial \u2014 construido y mantenido por Cephable","byline":"Por {{publisher}}","thirdPartyTitle":"Integraci\xf3n de terceros por parte de {{publisher}}"},"category":{"inputControls":{"title":"Entrada y control","description":"Activa las formas en que controlas tu dispositivo con Cephable."},"companionApps":{"title":"Aplicaciones y herramientas complementarias","description":"Ampl\xeda las funcionalidades de Cephable con nuestra aplicaci\xf3n m\xf3vil y nuestros creadores basados en la web."},"buildExtend":{"title":"Construir y ampliar","description":"Crea tus propias extensiones con la API y los SDK de Cephable."},"marketplace":{"title":"Mercado","description":"Se avecinan nuevas habilidades, herramientas y contactos."},"previews":{"title":"Avances","description":"Prueba las funciones que est\xe1n por llegar. Las versiones preliminares pueden cambiar antes de su lanzamiento."}},"camera":{"title":"Controles de la c\xe1mara","description":"Controla tu dispositivo con movimientos faciales y de cabeza usando la c\xe1mara.","detail":"Los controles de la c\xe1mara te permiten usar expresiones faciales y movimientos de cabeza (incluso usar la cabeza como rat\xf3n) para controlar tu dispositivo. Act\xedvalos con el interruptor de la tarjeta y luego ajusta su comportamiento aqu\xed.","settings":{"title":"Expresiones y gestos","description":"En la configuraci\xf3n, puedes ajustar qu\xe9 expresiones faciales y movimientos de cabeza se corresponden con las acciones."},"advancedSettings":"Abrir la configuraci\xf3n de la c\xe1mara"},"gamepad":{"title":"Compatibilidad con mandos","description":"Emula un mando de Xbox para que los juegos reconozcan tus entradas de Cephable.","detail":"Para usar gamepad, necesitas instalar ViGEm, un controlador no oficial de terceros, que emula un mando virtual de Xbox que los juegos reconocen de forma nativa. Instala o actualiza el controlador que se indica a continuaci\xf3n. Disponible para Windows x64."},"mobile":{"title":"Aplicaci\xf3n m\xf3vil Cephable","description":"Utiliza tu tel\xe9fono como mando complementario con la aplicaci\xf3n m\xf3vil de Cephable.","detail":"Descarga la aplicaci\xf3n m\xf3vil de Cephable para usar tu tel\xe9fono como mando complementario. Escanea un c\xf3digo o usa los enlaces para descargarla en iOS o Android, y luego prueba la aplicaci\xf3n a continuaci\xf3n.","screenshotsTitle":"Avance","screenshotPlaceholder":"Captura de pantalla","screenshotAlt":"Captura de pantalla de la aplicaci\xf3n m\xf3vil Cephable {{number}}","scanTitle":"Escanee para descargar","ios":"iOS \u2014 App Store","android":"Android \u2014 Google Play","iosAction":"Cons\xedguelo en la App Store.","androidAction":"Cons\xedguelo en Google Play"},"controllerCreator":{"title":"Creador de controladores personalizados","description":"Dise\xf1a tus propios controladores en pantalla en controller.cephable.com.","detail":"El creador de controladores personalizados te permite dise\xf1ar y compartir tus propios controladores en pantalla directamente en el navegador.","qrCaption":"controlador.cephable.com","action":"Creador de controladores abiertos","screenshotsTitle":"Avance","screenshotPlaceholder":"Captura de pantalla del creador del controlador","screenshotAlt":"Captura de pantalla del creador de controladores personalizados {{number}}"},"developer":{"title":"Construye tu propia extensi\xf3n","description":"Utilice la API y los SDK de Cephable para crear y compartir sus propias extensiones.","detail":"Crea tus propias extensiones e integraciones con Cephable. Explora la API y los SDK, y luego publica y comparte tus creaciones en developers.cephable.com.","api":{"title":"API de Cephable","description":"Gestiona mediante programaci\xf3n perfiles, dispositivos, controles y eventos en tiempo real."},"sdk":{"title":"SDK y ejemplos","description":"Empiece a trabajar r\xe1pidamente con nuestros SDK, ejemplos y gu\xedas de integraci\xf3n."},"action":"Visita developers.cephable.com"},"portal":{"title":"Proyectos y equipos","description":"Gestiona tus proyectos y equipos en el portal de Cephable.","detail":"Utilice el portal de Cephable para gestionar sus proyectos, equipos y la configuraci\xf3n de su organizaci\xf3n en un solo lugar.","projects":{"title":"Proyectos","description":"Crea y gestiona proyectos, claves API e integraciones."},"teams":{"title":"Equipos","description":"Invita a miembros, asigna roles y gestiona el acceso en toda tu organizaci\xf3n."},"action":"Abrir el portal cefalable"},"mcpTools":{"title":"Herramientas MCP","description":"Conecte las herramientas del Protocolo de Contexto de Modelo para ampliar las capacidades de Cephable."},"aiSkills":{"title":"Habilidades de IA","description":"A\xf1ade funcionalidades de IA reutilizables que Cephable pueda activar bajo demanda."},"workflows":{"title":"Flujos de trabajo reutilizables","description":"Comparta e instale flujos de trabajo de automatizaci\xf3n predefinidos."},"controlBundles":{"title":"Paquetes de control","description":"Instala paquetes seleccionados de controles para aplicaciones y juegos con un solo toque."},"connections":{"title":"Conexiones de juegos y aplicaciones","description":"Descubre juegos y aplicaciones que puedes controlar con Cephable, como Call of Duty: Black Ops 7."},"aiSkillsMarketplace":{"title":"AI Skills Marketplace","description":"Browse and install skills shared by the community."},"nav":{"label":"Explorar extensiones","discover":"Descubrir","skills":"Habilidades","connectors":"Conectores","features":"Caracter\xedsticas cefalables","installed":"Instalado"},"stats":{"rating":"Clasificaci\xf3n","installs":"Instala","rated":"\xa1Gracias por tu valoraci\xf3n!","rateError":"No se pudo guardar tu calificaci\xf3n.","yourRating":"Tu calificaci\xf3n"},"copyLink":"Copiar enlace","detail":{"access":{"developer":"Revelador","employee":"Empleado","plus":"M\xe1s","student":"Alumno"},"by":"por","categories":"Categor\xedas","featured":"Presentado","installing":"Instalando\u2026","size":"Tama\xf1o de descarga","transport":"Transporte","version":"Versi\xf3n"},"discover":{"connectors":"Conectores","coreDescription":"Cephable incluye c\xe1maras, mandos de juego, aplicaciones complementarias y herramientas para desarrolladores.","coreTitle":"Caracter\xedsticas cefalables","description":"Habilidades y contactos oficiales y comunitarios para ampliar el alcance del asistente Cephable.","empty":"A\xfan no hay nada que mostrar. Explora las Habilidades o los Conectores para a\xf1adir los tuyos.","exploreFeatures":"Explorar funciones","featured":"Presentado","newest":"Novedades y aspectos destacables","skills":"Habilidades","title":"Descubrir","viewAll":"Ver todo"},"features":{"description":"M\xe9todos integrados para controlar Cephable: c\xe1maras, controladores, aplicaciones complementarias y herramientas para desarrolladores.","title":"Caracter\xedsticas cefalables","searchPlaceholder":"Funciones de b\xfasqueda\u2026"},"install":"Instalar","installError":"No se pudo instalar.","installed":"Instalado","linkCopied":"Enlace copiado","provenance":{"cephable":"Cef\xe1lico","mine":"M\xedo","organization":"Su organizaci\xf3n","thirdParty":"Tercero"},"installedPage":{"connectors":"Conectores","description":"Habilidades y conectores que has a\xf1adido. Abre uno para gestionarlo o eliminarlo.","empty":"Todav\xeda no has a\xf1adido ninguna habilidad ni conector.","manage":"Administrar","skills":"Habilidades","title":"Instalado","searchPlaceholder":"Buscar extensiones instaladas\u2026"},"type":{"skill":"Habilidad","tool":"Conector","input":"Aporte","build":"Construir","app":"Aplicaci\xf3n complementaria","feature":"Caracter\xedstica"},"publish":{"title":{"mcp":"Comparte este conector MCP","skill":"Comparte esta habilidad"},"shareWith":"\xbfQui\xe9n puede acceder a esto?","target":{"organization":"Personas de mi organizaci\xf3n","public":"Todos (mercado p\xfablico)"},"chooseOrganization":"Elija una organizaci\xf3n","yourOrganization":"su organizaci\xf3n","audience":{"public":"Una vez que el equipo de Cephable lo apruebe, cualquier usuario de Cephable podr\xe1 encontrarlo, verlo e instalarlo. Elija las palabras y los iconos adecuados.","organization":"Todos en {{org}} podr\xe1n encontrar e instalar esto."},"displayName":"Nombre para mostrar","shortDescription":"Breve descripci\xf3n","shortDescriptionHelp":"Un resumen de una sola l\xednea que se muestra en los listados.","description":"Descripci\xf3n","iconUrl":"URL del icono","darkModeIconUrl":"URL del icono de modo oscuro","categories":"Categor\xedas","categoriesHelp":"Separados por comas (por ejemplo, productividad, escritura).","version":"Versi\xf3n","versionHelp":"D\xe9jelo en blanco para que se active autom\xe1ticamente.","secretNote":{"mcp":"Solo se comparten los detalles de conexi\xf3n no confidenciales. Tus claves API, tokens y dem\xe1s credenciales permanecen en este dispositivo; quienes lo instalen deber\xe1n introducir las suyas.","skill":"Los archivos e instrucciones de la habilidad se comparten tal cual. Elimine cualquier contenido privado antes de publicar."},"confirm":"Publicar","submitConfirm":"Enviar para revisi\xf3n","reviewNote":"Las propuestas p\xfablicas son revisadas por el equipo de Cephable antes de que aparezcan en el mercado. Ver\xe1s el estado de tu art\xedculo y te enviaremos un correo electr\xf3nico una vez que haya sido revisado.","notes":"Notas para el revisor (opcional)","notesHelp":"Cualquier cosa que nos ayude a repasar: qu\xe9 hace y qu\xe9 ha cambiado desde la \xfaltima vez.","inReview":"Esto ya est\xe1 pendiente de revisi\xf3n. Retire la solicitud actual para realizar los cambios y vuelva a enviarla.","withdraw":"Retirar la solicitud","resubmitConfirm":"Volver a enviar para revisi\xf3n","resubmitNote":"Esto no fue aprobado para su publicaci\xf3n. Responda a los comentarios a continuaci\xf3n y vuelva a enviarlo para su revisi\xf3n.","previousFeedback":"Comentarios de los revisores","publicRestricted":"Su organizaci\xf3n no permite la publicaci\xf3n en el mercado p\xfablico, por lo que esto solo se puede compartir dentro de su organizaci\xf3n."},"reviewStatus":{"section":"Revisi\xf3n del mercado p\xfablico","reasonLabel":"Nota del revisor","pending":"En revisi\xf3n","published":"Publicado","rejected":"Cambios solicitados","removed":"Remoto","pendingTitle":"Estamos a la espera de la revisi\xf3n de Cephable antes de que aparezca en el mercado p\xfablico.","publishedTitle":"Aprobado y listado en el mercado p\xfablico.","rejectedTitle":"No se ha aprobado su inclusi\xf3n en la lista p\xfablica; consulte la nota del revisor y vuelva a enviarla.","removedTitle":"Eliminado del mercado p\xfablico por un moderador.","notify":{"published":"\u201C{{name}}\u201D fue aprobado y ya est\xe1 disponible en el mercado.","rejected":"\u201C{{name}}\u201D necesita modificaciones antes de poder publicarse. \xc1brelo para ver los comentarios del revisor.","removed":"\u201C{{name}}\u201D fue retirado del mercado p\xfablico."}},"managedBy":"Gestionado por {{provenance}}","integrationType":{"cephable":"integraci\xf3n oficial","mine":"integraci\xf3n personal","organization":"integraci\xf3n organizacional","thirdParty":"integraci\xf3n de terceros"},"automateHttpServer":{"title":"Automatizar el servidor HTTP","description":"Conecta los servicios locales al asistente Automate de Cephable en el dispositivo a trav\xe9s de HTTP.","detail":"El servidor HTTP de Automate permite que los servicios locales, las herramientas de desarrollo y los ejecutores de evaluaci\xf3n utilicen el asistente de env\xedo de Cephable. Solo acepta conexiones desde este dispositivo, requiere la clave generada en cada solicitud y limita las operaciones de archivos a un espacio de trabajo aislado de Automate.","proRequired":"El servidor HTTP Automate est\xe1 disponible con Cephable Professional.","running":"Correr","stopped":"Interrumpido","port":"Puerto","endpoint":"Punto final","api":{"title":"C\xf3mo conectarse","description":"Utilice el servidor desde un script local, una aplicaci\xf3n de escritorio o una herramienta de automatizaci\xf3n que se ejecute en este equipo.","routes":{"chat":"Charlar","run":"Automatizar la ejecuci\xf3n","health":"Salud","models":"Modelos","modelMode":"Modo modelo (tu propio bucle de agente)","tools":"Herramientas integradas","speech":"Resultados del habla","settings":"Ajustes"},"steps":{"enable":"Habilita esta extensi\xf3n desde su tarjeta, deja Cephable abierto y confirma que el estado anterior indica \\"En ejecuci\xf3n\\".","copyKey":"Copia la clave de acceso que aparece a continuaci\xf3n. Env\xedala en cada solicitud en el encabezado de autorizaci\xf3n como Bearer <clave de acceso>.","sendRequest":"Utilice el punto final que se muestra arriba y env\xede una solicitud JSON mediante POST a /v1/chat/completions. Los clientes compatibles con OpenAI existentes pueden usar cephable-agent como nombre del modelo para ejecutar el asistente completo, o cephable-model para usar Cephable como modelo dentro de su propio agente.","readResponse":"Lee la respuesta del asistente desde choices[0].message.content. Si un cliente no puede conectarse, env\xeda GET /health con el mismo encabezado de autorizaci\xf3n."}},"key":"Clave de acceso","keyDescription":"Utilice esta clave como token de portador para clientes locales. Est\xe1 cifrada con el almacenamiento seguro de su sistema operativo y nunca se sincroniza con Cephable.","copyKey":"Copiar clave de acceso","copyError":"No se pudo copiar la clave de acceso del servidor Automate.","regenerateKey":"Regenerar clave de acceso","keyRegenerated":"Clave de acceso al servidor regenerada autom\xe1ticamente.","example":{"title":"Ejemplo de solicitud en Node.js","description":"Este ejemplo ya incluye el punto final y la clave de acceso actual. C\xf3pielo en un script local de Node.js de confianza y reemplace el mensaje de ejemplo con su tarea.","copy":"Ejemplo de solicitud de copia","copyError":"No se pudo copiar el ejemplo de solicitud."},"useCases":{"title":"Ideas para usar el servidor","description":"Cualquier dispositivo que pueda realizar una solicitud HTTP local puede pedir ayuda al asistente Automate de Cephable, integrado en el propio dispositivo.","localAutomation":"Conecte scripts locales, herramientas de acceso directo, utilidades de escritorio o plataformas de automatizaci\xf3n a un flujo de trabajo de Automate.","privateText":"Reescribe, resume, clasifica o traduce texto dentro de una herramienta interna manteniendo la inferencia en este dispositivo.","accessibleInputs":"Permita que interruptores personalizados, sensores o software complementario conviertan una entrada accesible en una tarea de automatizaci\xf3n m\xe1s completa.","testing":"Ejecute conjuntos de pruebas de regresi\xf3n de solicitudes y flujos de trabajo contra el mismo asistente, habilidades, herramientas y modelo local que utiliza la aplicaci\xf3n Cephable."},"security":{"title":"Mantenga el acceso local y seguro.","description":"El servidor solo escucha en 127.0.0.1, por lo que los servicios remotos y en la nube no pueden conectarse directamente. Trate la clave de acceso como una contrase\xf1a y comp\xe1rtala \xfanicamente con software de confianza. Regenerarla desconecta inmediatamente a los clientes que utilizan la clave anterior."},"secureStorageUnavailable":"Este servidor no se puede habilitar porque el almacenamiento seguro del sistema operativo no est\xe1 disponible.","error":"No se pudo actualizar el servidor HTTP de Automate.","portMoved":"El puerto {{preferredPort}} ya estaba en uso en este dispositivo, por lo que el servidor se inici\xf3 en el puerto {{port}}. Utilice el punto final indicado anteriormente en sus herramientas, no el predeterminado.","portMovedTitle":"Puerto diferente en uso"},"workflowRecording":{"title":"Registrar un flujo de trabajo","description":"Mu\xe9strale a Cephable c\xf3mo realizas una tarea una sola vez, y convertir\xe1 la grabaci\xf3n en una habilidad que podr\xe1 ejecutar por ti.","previewBadge":"Avance","detail":"La funci\xf3n \\"Grabar un flujo de trabajo\\" monitoriza la tarea que realizas: las aplicaciones a las que cambias, los botones y campos en los que pulsas, lo que escribes y lo que dices en voz alta. Al finalizar, Cephable convierte la grabaci\xf3n en una habilidad de IA que puedes revisar, editar y guardar. La pr\xf3xima vez que le pidas a Automate que realice una tarea similar, utilizar\xe1 la habilidad como gu\xeda, siguiendo la ruta m\xe1s directa en lugar de repetir cada clic.","howItWorks":{"title":"C\xf3mo funciona","record":"Inicie una grabaci\xf3n desde el Espacio de trabajo, la pesta\xf1a Automatizar o las Habilidades de IA, y luego realice la tarea de principio a fin.","narrate":"Explica detalladamente lo que est\xe1s haciendo y por qu\xe9. Tu explicaci\xf3n se convierte en el razonamiento detr\xe1s de cada paso.","review":"Det\xe9n la grabaci\xf3n para obtener una habilidad de borrador. Revisa los pasos y la descripci\xf3n antes de guardarla.","run":"P\xeddele a Automate que repita la tarea. Lee la grabaci\xf3n como referencia y la adapta a tus instrucciones."},"captured":{"title":"Lo que se graba","description":"Tus clics, pulsaciones de teclas, cambios de aplicaci\xf3n y los nombres e identificadores de los controles que uses, adem\xe1s de tu narraci\xf3n si hay un micr\xf3fono disponible, se procesan en este dispositivo. Los pasos que solo te llevan a alg\xfan sitio, como abrir una nueva pesta\xf1a del navegador y escribir una direcci\xf3n, se condensan en un solo paso. Evita introducir contrase\xf1as o datos de pago mientras grabas."},"whereToFind":{"title":"D\xf3nde encontrarlo","workspace":"Espacio de trabajo: la banda Grabar un flujo de trabajo que se encuentra en las sugerencias Crear y automatizar.","automate":"Pesta\xf1a Automatizar en el Panel de Cephable: la sugerencia \\"Ense\xf1ar a Cephable un flujo de trabajo\\" y el men\xfa de composici\xf3n.","skills":"Extensiones \u2192 Habilidades de IA: Crear habilidad \u2192 Registrar lo que hago."},"previewNotice":"Esta es una funci\xf3n en fase de vista previa. Puede sufrir cambios antes de su lanzamiento, y sus comentarios nos ayudan a perfeccionarla.","proRequired":"La funci\xf3n de grabaci\xf3n de flujos de trabajo est\xe1 disponible con Cephable Professional.","startAction":"Registrar un flujo de trabajo"}},"sensitivityValues":{"verySensitive":"Delicado","high":"Alto","medium":"Medio","low":"Bajo","notSensitive":"No sensible"},"summarize":"Resumir","appControlsPanel":{"searchPlaceholder":"Comandos de b\xfasqueda...","searchLabel":"Comandos de b\xfasqueda","favorites":{"title":"Favoritos","description":"Los comandos favoritos son aquellos que usas con frecuencia. Puedes marcar un comando como favorito haciendo clic en el icono de estrella que aparece junto a \xe9l."},"noCommandsFound":"No se encontraron comandos","globalCommands":"Global","prefixCommandToast":"Este es un comando de prefijo: diga o escriba el prefijo seguido de la frase para activarlo."},"collapse":"Colapsar","intelligentTasks":{"loading":{"loadingModels":"Cargando modelos de IA...","extractingModels":"Extracci\xf3n de modelos de IA..."}},"sidebar":{"collapse":"Contraer la barra lateral","expand":"Expandir barra lateral"},"workspace":{"title":"Espacio de trabajo","badge":"En el dispositivo \xb7 privado","subtitle":"Tu asistente de IA funciona completamente en este dispositivo. Inicia controles, crea, automatiza o simplemente chatea.","control":{"title":"Control","description":"Comandos de voz, atajos de teclado y botones de acci\xf3n r\xe1pida: funcionan en todas las aplicaciones de tu dispositivo.","voice":{"title":"Controles por voz","description":"Comandos manos libres"},"dictation":{"title":"Dictado","description":"Hablar para escribir"},"computerUse":{"title":"Uso de la computadora","description":"Deje que el asistente act\xfae"},"camera":{"title":"Controles de la c\xe1mara","description":"gestos faciales y de la cabeza"},"quickActions":{"title":"Acciones r\xe1pidas","description":"Accesos directos con un solo toque"}},"create":{"title":"Crear","description":"Redacta, reescribe, reformatea y traduce, directamente en la aplicaci\xf3n en la que est\xe1s trabajando, utilizando texto copiado y resaltado.","items":{"draftEmail":"Redacta un correo electr\xf3nico","writeDocument":"Escribe un documento","summarizeNotes":"Resumir en notas","polishWriting":"Perfeccionar mi escritura","translateText":"Traducir texto","socialPost":"Escribe una publicaci\xf3n en redes sociales","cd_brief":"Redacta un brief creativo","cd_caption":"Escribe un pie de foto y un texto alternativo.","ar_insights":"Resumir los hallazgos en conclusiones","ar_exec":"Redactar un resumen ejecutivo","cc_followup":"Redacta un correo electr\xf3nico de seguimiento","cc_meetingNotes":"Convierte tus notas en actas de reuniones.","bd_commit":"Escribe un mensaje de confirmaci\xf3n","bd_review":"Resumir una revisi\xf3n de c\xf3digo","gp_bio":"Escribe una biograf\xeda de streamer","gp_recap":"Repaso de la sesi\xf3n de anoche","lt_lesson":"Elaborar un plan de lecci\xf3n","lt_studyNotes":"Resumir en notas de estudio","mo_agenda":"Redactar un orden del d\xeda para la reuni\xf3n.","mo_update":"Redactar una actualizaci\xf3n del proyecto","aa_simplify":"Simplificar a un lenguaje sencillo","aa_describe":"Describe una imagen con palabras."},"contextRow":{"highlightedText":"Resaltar / texto del portapapeles","output":"Escribiendo:","input":"Usos:","background":"Fondo","currentapp":"Aplicaci\xf3n actual"},"prompts":{"draftEmail":"Redacta un correo electr\xf3nico claro y profesional al respecto.","writeDocument":"Redacte un documento sobre esto.","summarizeNotes":"Resume esto en notas concisas y bien organizadas, utilizando vi\xf1etas.","polishWriting":"Redacta esto para que sea m\xe1s claro y pulido, manteniendo mi significado y tono.","socialPost":"Escribe una publicaci\xf3n breve y atractiva en redes sociales sobre esto.","cd_brief":"Redacta un brief creativo para este proyecto.","ar_insights":"Resuma los hallazgos y conclusiones clave que se desprenden de estos datos.","ar_exec":"Redacte un resumen ejecutivo conciso para esto.","cc_followup":"Redacta un correo electr\xf3nico de seguimiento sobre este tema.","cc_meetingNotes":"Convierta estas notas en actas de reuni\xf3n claras con puntos de acci\xf3n.","bd_commit":"Escribe un mensaje de confirmaci\xf3n claro para estos cambios:","bd_review":"Resuma esta revisi\xf3n de c\xf3digo en puntos clave y cambios necesarios.","gp_bio":"Escribe una biograf\xeda impactante para mi canal/perfil.","lt_lesson":"Elabore un plan de lecci\xf3n sobre este tema.","lt_studyNotes":"Resume este material en apuntes de estudio que pueda repasar.","mo_agenda":"Elabore un orden del d\xeda para la reuni\xf3n que abarque este tema.","mo_update":"Redacte una actualizaci\xf3n del estado del proyecto para las partes interesadas bas\xe1ndose en esto.","aa_simplify":"Reescribe esto en un lenguaje sencillo y f\xe1cil de leer."}},"automate":{"title":"Automatizar","description":"Describe una tarea en lenguaje sencillo y Cephable la ejecutar\xe1 en todas tus aplicaciones, tus archivos e incluso en tu l\xednea de comandos.","items":{"triage":"Clasificar mi bandeja de entrada","cd_exportAssets":"Cambiar nombre y archivar archivos","cd_moodboard":"Recopilar referencias","cc_triage":"Clasificaci\xf3n y borrador de respuestas","cc_recap":"Resumen y env\xedo al equipo","bd_scaffold":"Estructurar un proyecto","gp_schedule":"Planifica un horario de transmisi\xf3n","lt_handout":"Elabora un folleto","summarizeSend":"Resumir y enviar por correo electr\xf3nico","researchDoc":"Investigar y redactar un documento","organizeFiles":"Organiza mis archivos","cleanUp":"Limpiar una carpeta","wordDoc":"Crear un documento de Word","ar_summarizeSend":"Resumir y enviar por correo electr\xf3nico","ar_analyzeData":"Analizar una hoja de c\xe1lculo","ar_deck":"Construye una presentaci\xf3n a partir de datos","cc_summarizeEmail":"Resumir en un correo electr\xf3nico","cc_socialPost":"Publicar desde un enlace","bd_buildTest":"Construye y prueba un proyecto","bd_cleanup":"Sugerir mejoras en el c\xf3digo","lt_studyMaterial":"Elaborar materiales de estudio","lt_accommodation":"Hacer notas accesibles","lt_research":"Investiga y compara","mo_meetingActions":"Convierte las notas en acciones","mo_organizeFiles":"Organizar mis archivos","mo_cleanup":"Limpiar descargas","aa_translate":"Traducir un documento"},"prompts":{"summarizeSend":"Resume el contenido de <carpeta> y env\xedalo por correo electr\xf3nico a <correo electr\xf3nico del equipo>.","researchDoc":"Investiga las tendencias en <carpeta o documento> y redacta un nuevo documento con tus hallazgos.","organizeFiles":"Copia los archivos de<source folder> en<destination folder> .","cleanUp":"Eliminar todos los archivos de tipo <por ejemplo, capturas de pantalla> de mi <carpeta>.","wordDoc":"Usar<article or notes> para crear un documento de Microsoft Word que<does what> .","triage":"Revisa mi bandeja de entrada y dime qu\xe9 necesita mi atenci\xf3n; luego, redacta las respuestas cuando sea necesario.","cd_exportAssets":"Cambie el nombre de los recursos de dise\xf1o en <carpeta> utilizando este esquema \u2014 <esquema de nomenclatura> \u2014 y organ\xedcelos en carpetas.","cd_moodboard":"Busca referencias para <idea> en l\xednea y recop\xedlalas en un documento.","ar_summarizeSend":"Resume el contenido de <carpeta> y env\xedalo por correo electr\xf3nico a <correo electr\xf3nico del equipo>.","ar_analyzeData":"Analiza <la hoja de c\xe1lculo> y encuentra <qu\xe9 buscar, por ejemplo, p\xe9rdidas clave>.","ar_deck":"Convierta los resultados del documento o carpeta en una presentaci\xf3n de PowerPoint que destaque los puntos clave.","cc_triage":"Lee mi bandeja de entrada y redacta respuestas a todo lo que lo requiera.","cc_summarizeEmail":"Redactar un correo electr\xf3nico que resuma<article or document> y se\xf1alar los detalles t\xe9cnicos clave.","cc_recap":"Redacta un resumen de las <notas de la reuni\xf3n> y env\xedalo por correo electr\xf3nico a <correo electr\xf3nico del equipo>.","cc_socialPost":"Leer<article or website> y escribir un<platform, e.g. Discord> -publica algo amigable al respecto y luego gu\xe1rdalo en una nueva nota.","bd_buildTest":"Revisa el c\xf3digo en la carpeta del proyecto, comp\xedlalo y ejecuta las pruebas. Si algo falla, consulta el historial de Git e ind\xedcame qu\xe9 pudo haberlo causado.","bd_cleanup":"Revisa el c\xf3digo en la carpeta del proyecto y dime c\xf3mo puedo mejorarlo.","bd_scaffold":"Crea un nuevo proyecto de tipo <proyecto> en <carpeta> con los archivos iniciales que necesita.","gp_schedule":"Planifica un horario de transmisi\xf3n para<time period> cubierta<games or activities> .","lt_studyMaterial":"Usar<article or notes> para crear un documento de Word para<grade level> estudiantes con<reflection questions or a study guide> .","lt_accommodation":"Crea un documento de Word con apuntes de clase sobre <tema> formateado para un estudiante con <adaptaci\xf3n>.","lt_handout":"Recopila las lecturas de <carpeta> en un \xfanico documento para entregar.","lt_research":"Busca <tema, por ejemplo, libros sobre neurodiversidad> en l\xednea y crea un documento que resuma cada uno para que pueda compararlos.","mo_meetingActions":"Lee las <notas de la reuni\xf3n>: \xbfqu\xe9 queda por hacer, qui\xe9n es el responsable y qu\xe9 necesita m\xe1s investigaci\xf3n? Organ\xedzalas en archivos y gu\xe1rdalos en una carpeta.","mo_organizeFiles":"Copia los archivos de<source folder> en<destination folder> .","mo_cleanup":"Eliminar todos los archivos de tipo <por ejemplo, instaladores> de mi carpeta Descargas.","aa_translate":"Traduce <documento> al <idioma> y gu\xe1rdalo en <carpeta>."}},"history":{"title":"Historia reciente de la IA","description":"Tus \xfaltimas tareas inteligentes y automatizaciones.","viewAll":"Ver todo el historial","empty":"Aqu\xed aparecer\xe1n tus tareas y automatizaciones recientes relacionadas con la IA."},"badgeRemote":"Dispositivo remoto \xb7 seguro","browser":{"openButton":"Abrir navegador","windowTitle":"Navegador Cephable","newTab":"Nueva pesta\xf1a","reload":"Recargar","forward":"Adelante","openExternal":"Abrir en el navegador predeterminado","showWindow":"Mostrar navegador oculto","addressPlaceholder":"Busca en Google o escribe una URL.","clearData":{"description":"Borra el historial, las cookies, los datos en cach\xe9 y las sesiones guardadas del navegador Cephable. Esto cerrar\xe1 tu sesi\xf3n en todos los sitios web que uses con el navegador Cephable.","button":"Borrar datos del navegador","cleared":"Se han borrado los datos del navegador.","error":"No se pudieron borrar los datos del navegador.","confirmTitle":"\xbfBorrar datos del navegador?","confirmMessage":"\xbfCerrar sesi\xf3n en todo el navegador Cephable?","confirmDetail":"Esto borra permanentemente el historial, las cookies, los datos en cach\xe9 y las sesiones guardadas del navegador Cephable. Esta acci\xf3n es irreversible.","confirm":"Datos claros","cancel":"Cancelar"},"context":{"newTab":"Nueva pesta\xf1a","reload":"Recargar","duplicate":"Pesta\xf1a duplicada","close":"Cerrar pesta\xf1a","closeOthers":"Cerrar otras pesta\xf1as","closeRight":"Cierra las pesta\xf1as de la derecha.","back":"Atr\xe1s","forward":"Adelante","openLinkNewTab":"Abrir enlace en una pesta\xf1a nueva","openLinkExternal":"Abrir el enlace en el navegador predeterminado","openExternal":"Abrir en el navegador predeterminado","openAllExternal":"Abrir todas las pesta\xf1as en el navegador predeterminado"},"home":{"tabTitle":"Hogar","title":"El navegador cefalable","tagline":"Cephable puede gestionar un navegador independiente por usted.","description":"Aqu\xed es donde Cephable automatiza las tareas web en tu nombre. Se ejecuta de forma independiente de tu navegador habitual, por lo que tus pesta\xf1as, inicios de sesi\xf3n y navegaci\xf3n normales permanecen intactos mientras las automatizaciones se ejecutan aqu\xed, incluso en segundo plano.","searchPlaceholder":"Busca en Google o escribe una URL para empezar.","go":"Ir","features":{"separate":{"title":"Funciona por s\xed solo","description":"Se mantiene separado de tu navegador predeterminado para que las automatizaciones nunca interrumpan tu navegaci\xf3n personal."},"automate":{"title":"Dise\xf1ado para la automatizaci\xf3n","description":"Cephable puede abrir p\xe1ginas, rellenar formularios y recopilar informaci\xf3n aqu\xed, sin necesidad de usar las manos."},"handoff":{"title":"Entregar en cualquier momento","description":"Abre cualquier p\xe1gina en tu navegador predeterminado cuando quieras tomar el control."}}}},"scheduledTasks":{"title":"Tareas programadas","description":"Automatizaciones configuradas para ejecutarse a la hora que usted elija, en este dispositivo.","viewAll":"Ver todos los programados","empty":"Programa una solicitud desde el panel y aparecer\xe1 aqu\xed."},"subtitleRemote":"Todo lo que har\xedas con un clic o escribir, a tu disposici\xf3n.","suggestions":{"viewMore":"Ver m\xe1s","viewMoreTooltip":"Explora todas las sugerencias","dialogTitle":"Todas las sugerencias","dialogDescription":"Elige un punto de partida. Se a\xf1adir\xe1 al compositor para que puedas editarlo antes de ejecutarlo.","rotationLabel":"Sugerencias","empty":"No hay sugerencias disponibles."}},"noResults":"No hay resultados","noResultsSearch":"No se encontraron resultados para su b\xfasqueda.","interrupted":"Interrumpido","aiHistory":{"title":"Historia de la IA","description":"Visualiza, busca y gestiona tu historial de conversaciones con IA local.","empty":{"title":"A\xfan no hay historial de IA","description":"Tu historial de conversaciones con la IA aparecer\xe1 aqu\xed despu\xe9s de que utilices tareas inteligentes."},"search":{"placeholder":"Buscar conversaciones..."},"pagination":{"range":"Mostrando {{start}}\u2013{{end}} de {{total}}"},"source":{"create":"Crear","automate":"Automatizar"},"workflow":{"plan":"Plan","steps":"Pasos","files":"Archivos","folders":"Carpetas","interruptedNotice":"Tu flujo de trabajo se ha interrumpido. Por favor, int\xe9ntalo de nuevo."},"trace":{"thinking":"Pensamiento","toolCalls":"Llamadas a herramientas","roles":{"tool":"Resultado de la herramienta"},"thought":"Pensamiento","action":"Acci\xf3n","parameters":"Par\xe1metros","result":"Resultado","reply":"Respondiste","sources":"Fuentes"},"task":{"instructions":"Instrucciones","language":"Idioma","types":{"generate":"Generar","rewrite":"Volver a escribir","translate":"Traducir","summarize":"Resumir"}},"session":{"messages":"mensajes","deleteTitle":"Eliminar conversaci\xf3n","deleteDescription":"\xbfSeguro que quieres borrar esta conversaci\xf3n? No se puede deshacer.","deleteConfirm":"Borrar","deleteCancel":"Cancelar"},"clear":{"title":"Historial de IA limpio","description":"Eliminar todo el historial de conversaciones con IA almacenado localmente en este dispositivo.","confirm":{"title":"Historial de IA limpio","description":"\xbfEst\xe1s seguro de que quieres borrar todo el historial de conversaciones con la IA? Esta acci\xf3n es irreversible.","confirm":"Borrar todo","cancel":"Cancelar"},"success":"El historial de IA se ha borrado correctamente.","error":"No se pudo borrar el historial de IA."},"export":{"title":"Exportar","description":"Exporta el historial de conversaciones con tu IA a un archivo JSONL.","success":"El historial de IA se export\xf3 correctamente.","error":"No se pudo exportar el historial de IA.","session":{"title":"Ejecuci\xf3n de exportaci\xf3n","success":"La ejecuci\xf3n se export\xf3 correctamente.","error":"No se pudo exportar esta ejecuci\xf3n."}},"retention":{"note":"Guardando tus {{count}} conversaciones m\xe1s recientes. Los favoritos siempre se conservan.","label":"Mantener"},"filter":{"label":"Filtrar por tipo","all":"Todo tipo"},"favorites":{"title":"Favoritos","add":"Agregar a favoritos","remove":"Eliminar de favoritos"},"select":{"selectOne":"Seleccionar conversaci\xf3n","selected":"{{count}} seleccionado","deleteSelected":"Eliminar seleccionado","clear":"Claro","deleteTitle":"Eliminar conversaciones seleccionadas","deleteDescription":"\xbfEliminar {{count}} conversaci\xf3n(es) seleccionada(s)? Esta acci\xf3n no se puede deshacer."},"copy":{"label":"Copiar","success":"Copiado al portapapeles.","error":"No se pudo copiar al portapapeles."},"live":"Vivir","keychain":{"continue":"Continuar","title":"Proteger el historial de IA","message":"Cephable cifra tu historial de IA, incluido el historial de flujo de trabajo, en este Mac.","detail":"macOS te pedir\xe1 permiso para acceder a \xabCephable Safe Storage\xbb. Este almacenamiento solo contiene la clave de cifrado, no el contenido de tus tareas ni de tu flujo de trabajo. Selecciona \xabPermitir siempre\xbb para que tu historial cifrado siga disponible sin que se te vuelva a preguntar. Al seleccionar \xabPermitir\xbb, Cephable accede a \xe9l esta vez, pero macOS podr\xeda volver a solicitarlo en un futuro reinicio."},"rename":{"title":"Rebautizar","label":"T\xedtulo de la conversaci\xf3n"}},"uses":"Usos: {{valor}}","skills":{"intro":"Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.","create":"Create skill","importFolder":"Import folder","importZip":"Import .zip","importError":"Could not import the skill.","enable":"Enable","openFolder":"Open folder","deleteConfirm":"Delete?","emptyTitle":"No skills yet","emptyBody":"Create your first skill or import one to get started.","sharingComingSoon":"Sharing skills with your organization and a skills marketplace are coming soon.","source":{"user":"Created by you","imported":"Imported","organization":"Organization","marketplace":"Marketplace"},"bestPractices":{"title":"Tips for great skills","description":"Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.","focused":"Keep instructions short and focused on one job. Use numbered steps in the order they should happen.","examples":"Add a short example of a request the skill handles and the ideal result.","keywords":"Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.","trust":"Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer.","activation":"Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. release-notes","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What the skill does and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use the skill. Be specific.","keywordsLabel":"Keywords (optional)","keywordsPlaceholder":"comma, separated, words","keywordsHelp":"Extra words that should trigger this skill (brand names, aliases, file types).","instructionsLabel":"Instructions (SKILL.md)","instructionsPlaceholder":"Step-by-step instructions for the assistant. Leave blank to start from a template.","save":"Save changes","create":"Create skill","saveError":"Could not save the skill.","activationLabel":"When should the assistant use this?"},"picker":{"title":"Skills","empty":"No matching skills","hint":"Type to filter skills"},"contextMenuItem":"Skill\u2026","chipRemove":"Remove skill","attached":"Attached skills","inUse":"Using skills:","section":{"title":"AI Skills","description":"Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."},"createDescription":"Build a reusable skill from scratch or a template.","import":"Import a skill","importDescription":"Add a skill from a folder or a .zip file.","copy":"Copy an existing skill","copyDescription":"Start from a copy of one of your skills.","copyShort":"Copy","editTitle":"Edit skill","newTitle":"New skill","templates":{"title":"Start from a template","blank":{"title":"Blank","summary":"Start from an empty template."},"navigateApp":{"title":"Navigate an app (click in steps)","summary":"Tell Cephable where to click, step by step, to get through an app."},"writeText":{"title":"Write or insert text","summary":"Draft text a certain way and type it where I am working."},"fillForm":{"title":"Fill out a form","summary":"Fill a form field by field from details I give you."},"summarizeDoc":{"title":"Summarize a document","summary":"Read a file and give a short, structured summary."},"start":"Comience con una plantilla\u2026","applied":"Plantilla aplicada: edite los detalles a continuaci\xf3n."},"activation":{"label":"Activation","auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant picks this skill on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never picks this on its own \u2014 it runs only when you attach it with / or @."},"mode":{"label":"How this skill is used","off":"Off","offTooltip":"Off \u2014 this skill is never used or shown in the picker."},"viewDetails":"View details","files":{"label":"Reference files & scripts","help":"Add files your skill uses \u2014 the assistant reads references and can run scripts. Mention them in your instructions above.","empty":"No files added yet.","add":"Add file\u2026","remove":"Remove file","addError":"Could not add the file.","kind":{"reference":"Reference file","script":"Script","asset":"Asset","referenceShort":"Reference","scriptShort":"Script","assetShort":"Asset"},"open":"Open file"},"scriptsSetting":{"label":"Let skills run scripts","help":"When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."},"capability":{"script":{"label":"Runs scripts","tooltip":"This skill can run programs on your computer \u2014 you approve each one before it runs. Only use skills you trust."},"reference":{"label":"Uses reference files","tooltip":"This skill includes reference files the assistant can read for detail. It does not run programs on your computer."},"basic":{"label":"Instructions only","tooltip":"This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."},"alsoReferences":"It also includes reference files it reads.","scriptsOff":"Script running is currently turned off in settings."},"teach":{"action":"Ense\xf1ar como habilidad","generating":"Ense\xf1anza\u2026","title":"Ense\xf1ar una habilidad","heading":"Ens\xe9\xf1ale a Cephable una nueva habilidad.","subheading":"Cephable convirti\xf3 tu acci\xf3n en una habilidad reutilizable. Rev\xedsala y modif\xedcala a continuaci\xf3n, luego gu\xe1rdala para que el asistente pueda repetirla por ti y por cualquier persona con quien la compartas.","fromRun":"Basado en: {{title}}","filesTitle":"Archivos a incluir","filesHelp":"Estos son archivos de tu partida que podr\xedan hacer que la habilidad sea repetible. Conserva los que deban transferirse con la habilidad; desactiva todo lo que sea solo datos de esta partida.","detailsTitle":"Detalles de la habilidad","addFile":"A\xf1ade otro archivo\u2026","include":{"add":"Incluir","on":"Incluido: haga clic para eliminar","off":"Excluidos \u2014 haga clic para incluir"},"included":"Incluido","origin":{"attached":"Usted proporcion\xf3","template":"Plantilla","generated":"Ejecuci\xf3n producida","observed":"Reunido","added":"A\xf1adido por ti"},"saved":"Habilidad guardada. Puedes activarla y compartirla a continuaci\xf3n.","error":"No se pudo crear una habilidad a partir de esta ejecuci\xf3n.","filesError":"No se pudieron agregar algunos archivos de referencia: {{files}}","notFound":"Este borrador ya no est\xe1 disponible.","backToSkills":"Volver a las habilidades"},"actions":"Acciones de habilidad","body":{"empty":"A\xfan no se han a\xf1adido instrucciones.","label":"Instrucciones (SKILL.md)"},"importTooltip":"Importa una habilidad desde una carpeta o un archivo .zip.","install":"Instalar","keywords":{"label":"Palabras clave"},"marketplace":{"description":"Habilidades p\xfablicas compartidas por la comunidad que coinciden con tu b\xfasqueda.","title":"Desde el mercado p\xfablico"},"share":"Compartir","shareError":"Algo sali\xf3 mal.","sync":"Sincronizar","updateAvailable":"Hay una versi\xf3n m\xe1s reciente disponible.","searchPlaceholder":"Habilidades de b\xfasqueda\u2026","createTooltip":"Gr\xe1bate a ti mismo realizando una tarea o escribe la habilidad que est\xe1s haciendo.","createRecord":"Grabo lo que hago","createScratch":"Empezar desde el principio"},"on":"En","off":"Apagado","copied":"Copiado","mcp":{"section":{"title":"Herramientas","description":"Conecta los servidores MCP para proporcionar al asistente de Cephable herramientas adicionales. \xdasalas en el panel escribiendo / o @."},"addServer":"Agregar un servidor","addServerDescription":"Conecte un servidor MCP (mediante comandos, HTTP o SSE) para agregar sus herramientas.","editTitle":"Editar servidor","newTitle":"Agregar servidor","deleteConfirm":"\xbfBorrar?","contextMenuItem":"Herramientas\u2026","chipRemove":"Retire las herramientas","inUse":"Uso de herramientas:","picker":{"title":"Habilidades y herramientas"},"mode":{"label":"C\xf3mo se utiliza este servidor","off":"Apagado","offTooltip":"Desactivado: este servidor nunca se utiliza ni se muestra en el selector."},"activation":{"auto":"Autom\xe1ticamente cuando sea apropiado","autoShort":"Auto","autoDescription":"El asistente carga autom\xe1ticamente las herramientas de este servidor cuando tu solicitud coincide, y a\xfan puedes seleccionarlo con / o @.","manual":"Solo cuando yo lo elijo","manualShort":"Manual","manualDescription":"El asistente nunca lo carga por s\xed solo, solo cuando lo adjuntas con / o @."},"transport":{"stdio":"Comando (stdio)","http":"HTTP","sse":"SSE"},"auth":{"none":"Ninguno","apiKey":"clave API","headers":"Encabezados personalizados","oauth":"OAuth"},"requireApproval":{"short":"Aprobar llamadas","tooltip":"Cuando est\xe1 activada, usted aprueba cada llamada de herramienta desde este servidor antes de que se ejecute."},"oauth":{"connect":"Conectar","reconnect":"Reconectar","disconnect":"Desconectar","connecting":"Esperando al navegador\u2026","connected":"Conectado","notConnected":"No conectado","error":"La autorizaci\xf3n ha fallado."},"status":{"ok":"Conectado","error":"Fallido","unknown":"No probado","testing":"Conectando\u2026","toolsFound":"Se encontraron {{count}} herramientas","label":"Conexi\xf3n","toolsEnabledOf":"{{habilitado}} de {{count}} herramientas"},"editor":{"nameLabel":"Nombre","namePlaceholder":"p. ej. sistema de archivos","nameHelp":"Solo letras min\xfasculas, n\xfameros y guiones.","descriptionLabel":"Descripci\xf3n","descriptionPlaceholder":"Qu\xe9 ofrece este servidor y cu\xe1ndo debe usarlo el asistente.","descriptionHelp":"As\xed es como el asistente decide cu\xe1ndo usarlo. Sea espec\xedfico.","transportLabel":"Tipo de conexi\xf3n","commandLabel":"Dominio","argsLabel":"Argumentos","argsHelp":"Argumentos separados por espacios que se pasan al comando.","envLabel":"Variables ambientales","envHelp":"Un valor CLAVE por l\xednea.","urlLabel":"URL del servidor","authLabel":"Autenticaci\xf3n","apiKeyHeaderLabel":"Nombre del encabezado","apiKeyPrefixLabel":"prefijo de valor","apiKeyLabel":"clave API","secretSet":"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (almacenado \u2014 tipo a reemplazar)","oauthClientIdLabel":"ID de cliente","oauthClientIdHelp":"D\xe9jelo en blanco para registrarse autom\xe1ticamente si es compatible.","oauthClientSecretLabel":"secreto del cliente","oauthScopesLabel":"Alcances","oauthScopesHelp":"Alcances separados por espacios para solicitar.","oauthDiscoveryLabel":"URL de descubrimiento (opcional)","oauthAuthUrlLabel":"URL de autorizaci\xf3n","oauthTokenUrlLabel":"URL del token","redirectLabel":"URI de redirecci\xf3n","redirectHelp":"La mayor\xeda de los servidores se registran autom\xe1ticamente; simplemente deje el ID de cliente en blanco y haga clic en Conectar. Si el proveedor solicita una URI de redireccionamiento, seleccione el tipo de devoluci\xf3n de llamada que acepta y registre la URI a continuaci\xf3n.","headersHelp":"La autenticaci\xf3n de encabezado personalizado a\xfan no se puede editar aqu\xed; utilice la clave API o OAuth para servidores autenticados.","activationLabel":"\xbfCu\xe1ndo deber\xeda usar esto el asistente?","requireApprovalLabel":"Se requiere aprobaci\xf3n para cada llamada a la herramienta.","requireApprovalHelp":"Cuando est\xe1 activada, usted aprueba cada llamada de herramienta desde este servidor antes de que se ejecute. Recomendada para servidores que pueden modificar datos o generar ingresos.","testConnection":"Probar la conexi\xf3n","save":"Guardar cambios","create":"Agregar servidor","saveError":"No se pudo guardar el servidor.","oauthDiscoveryHelp":"Opcional: deje este campo en blanco para utilizar el documento de descubrimiento del propio servidor.","oauthDiscoveryLabelShort":"URL de descubrimiento","oauthOnDevice":"Cada miembro completa el inicio de sesi\xf3n OAuth en su propio dispositivo cuando habilita este conector.","secretsOnDevice":"Cada miembro introduce su propia clave API en su dispositivo cuando habilita este conector; las claves nunca se almacenan aqu\xed.","noPermissions":"Este servidor utiliza la aplicaci\xf3n registrada de {{provenance}}. Haz clic en el bot\xf3n para personalizarla o en Conectar para empezar a usarla.","altOptions":{"copy":"Utiliza mis propias credenciales","organization":"Portal Cephable"},"copyName":"{{name}}-copia","redirectTypeLabel":"Tipo de devoluci\xf3n de llamada","redirectType":{"appCallback":"Web (https)","localhost":"Host local"},"redirectPortLabel":"Puerto","redirectNotes":{"appCallback":"Al iniciar sesi\xf3n, se abrir\xe1 su navegador y, a continuaci\xf3n, el control volver\xe1 autom\xe1ticamente a la aplicaci\xf3n Cephable.","localhost":"Al iniciar sesi\xf3n, se abrir\xe1 su navegador y volver\xe1 a Cephable a trav\xe9s de este puerto. Permanecer\xe1 abierto solo mientras est\xe9 conectado y \xfanicamente en este dispositivo."}},"actions":"Acciones del servidor","marketplace":{"description":"Conectores p\xfablicos compartidos por la comunidad que coinciden con tu b\xfasqueda.","title":"Desde el mercado p\xfablico"},"share":"Compartir","shareError":"Algo sali\xf3 mal.","sync":"Sincronizar","tools":{"allToolsLabel":"para todas las herramientas","contextLabel":"de contexto","disableAll":"Deshabilitar todo","empty":"A\xfan no hay herramientas disponibles; prueba la conexi\xf3n para descubrirlas.","enableAll":"Habilitar todo","help":"Desactiva las herramientas que no necesites. Menos herramientas ocupan menos espacio en la ventana de contexto del asistente, lo que lo mantiene r\xe1pido y enfocado.","label":"Herramientas","searchPlaceholder":"Herramientas de b\xfasqueda\u2026","tokens":"~{{tokens}} tom\xf3","tokensLabel":"fichas","disableSelected":"Deshabilitar seleccionado","enableSelected":"Habilitar seleccionado"},"updateAvailable":"Hay una versi\xf3n actualizada disponible.","searchPlaceholder":"Conectores de b\xfasqueda\u2026"},"send":"Enviar","availableToInstall":"Disponible para instalar","menu":{"expand":"Ampliar men\xfa"},"no":"No","rating":{"review":{"comment":"Comentario","commentPlaceholder":"\xbfQu\xe9 te gust\xf3 o te disgust\xf3? \xbfC\xf3mo lo usaste?","optional":"(opcional)","submit":"Enviar rese\xf1a","subtitle":"Comparte tu experiencia con <strong>{{subject}}</strong> .","title":"Valora y comenta","write":"Escribe una rese\xf1a","yourRating":"Tu calificaci\xf3n"},"summary":{"comments":"comentarios","installs":"instalaciones","noRatings":"A\xfan no hay valoraciones","openReview":"Valora y comenta","ratingCount":"{{count}} calificaciones"}},"workflow":{"feedback":{"includeDetails":"Comparta mi mensaje y los nombres de las herramientas para ayudar a diagnosticar esta ejecuci\xf3n.","negative":"Pulgar hacia abajo","placeholder":"Cu\xe9ntanos m\xe1s (opcional)","positive":"Pulgares hacia arriba","question":"\xbfC\xf3mo se desarroll\xf3 este flujo de trabajo?","send":"Enviar comentarios","thanks":"Gracias por sus comentarios.","report":"Informar de un problema"}},"yes":"S\xed","scheduledTasks":{"title":"Tareas programadas","description":"Automatizaciones configuradas para ejecutarse a la hora que elijas. Todo permanece en este dispositivo.","hint":"Las tareas programadas solo se ejecutan mientras esta aplicaci\xf3n est\xe1 en funcionamiento. Si su PC est\xe1 apagada o la aplicaci\xf3n est\xe1 cerrada a la hora programada, la tarea se marcar\xe1 como no ejecutable y podr\xe1 ejecutarla m\xe1s tarde.","new":"Nueva tarea programada","scheduleButton":"Cronograma","create":{"title":"Nueva tarea programada","description":"Configura una notificaci\xf3n para que se ejecute autom\xe1ticamente seg\xfan un horario programado.","saved":"Tarea programada creada."},"composer":{"placeholder":"Describe qu\xe9 deber\xeda hacer Cephable\u2026 Usa / o @ para a\xf1adir habilidades y conectores."},"runHistory":{"title":"Historial de ejecuci\xf3n","viewRun":"Ver ejecuci\xf3n","noOutput":"No se guard\xf3 ninguna salida","resolution":{"ignored":"Ignorado","rerun":"Repetici\xf3n","rescheduled":"Reprogramado"}},"badge":{"scheduled":"Programado","recurring":"Peri\xf3dico"},"fromRun":{"scheduled":"Esta ejecuci\xf3n forma parte de una tarea programada: {{name}}","recurring":"Esta ejecuci\xf3n forma parte de una tarea recurrente: {{name}}","view":"Ver tarea programada"},"search":{"placeholder":"Buscar tareas programadas..."},"filter":{"label":"Filtrar","all":"Todo","enabled":"Activo","paused":"Pausa","missed":"Omitido"},"empty":{"title":"A\xfan no hay tareas programadas.","description":"Programe una notificaci\xf3n haciendo clic con el bot\xf3n derecho en el bot\xf3n de env\xedo del panel mientras est\xe9 en modo Autom\xe1tico o Automatizar."},"pagination":{"range":"{{inicio}}\u2013{{fin}} de {{total}}"},"status":{"running":"Correr","success":"Tuvo \xe9xito","failed":"Fallido","missed":"Omitido","paused":"Pausa"},"summary":{"once":"Una vez en {{datetime}}","everyOne":"Cada {{unidad}}","everyN":"Cada {{count}} {{unit}}","onDays":"en {{d\xedas}}","onDayOfMonth":"el d\xeda {{day}}","atTime":"a las {{tiempo}}","unit":{"minute":"minuto","minute_other":"minutos","hour":"hora","hour_other":"horas","day":"d\xeda","day_other":"d\xedas","week":"semana","week_other":"semanas","month":"mes","month_other":"meses"}},"card":{"nextRun":"Pr\xf3xima carrera","runNow":"Corre ahora","pause":"Pausa","resume":"Reanudar","enabledToggle":"Habilitar o pausar esta tarea","viewLastRun":"Ver la \xfaltima ejecuci\xf3n exitosa","noSuccessfulRun":"A\xfan no se ha logrado ning\xfan \xe9xito."},"missed":{"runNow":"Corre ahora","reschedule":"Reprogramar","ignore":"Ignorar"},"runNow":{"started":"Ejecutando \\"{{name}}\\" ahora.","busy":"Ya hay otro proceso en ejecuci\xf3n. Int\xe9ntalo de nuevo cuando termine."},"delete":{"title":"\xbfEliminar tarea programada?","description":"Esto elimina permanentemente la tarea programada. Esta acci\xf3n no se puede deshacer."},"editor":{"kindLabel":"Tipo de horario","once":"Una vez","recurring":"Peri\xf3dico","runAt":"Lanzarse sobre","frequency":"Repeticiones","every":"Cada","interval":"Intervalo","onDays":"En los d\xedas","dayOfMonth":"D\xeda del mes","atTime":"En ese momento","startAt":"Comienza","endsOn":"Termina en","units":"Unidades"},"edit":{"title":"Editar tarea programada","description":"Ajusta la solicitud y su programaci\xf3n antes de que se ejecute.","name":"Nombre","namePlaceholder":"Nombra esta tarea programada","prompt":"Inmediato","customContext":"Contexto personalizado","contextNote":{"generic":"El contexto de esta tarea se resuelve cuando se ejecuta.","highlighted":"Esta tarea utiliza el texto resaltado en la aplicaci\xf3n activa durante su ejecuci\xf3n.","clipboard":"Esta tarea utiliza el contenido del portapapeles en tiempo de ejecuci\xf3n.","auto":"El contexto de esta tarea se resuelve autom\xe1ticamente cuando se ejecuta."},"attachments":"Archivos y carpetas adjuntos","skills":"Habilidades","connectors":"Conectores","schedule":"Cronograma","goalRequired":"Introduzca una solicitud para esta tarea.","saved":"Tarea programada guardada.","notFound":"Esta tarea programada ya no existe."},"schedulePrompt":{"menuItem":"Programa esta solicitud\u2026","title":"Programar esta solicitud","prompt":"Inmediato","name":"Nombre (opcional)","namePlaceholder":"Nombra esta tarea programada","confirm":"Cronograma","goalRequired":"Ingrese una solicitud para programar.","success":"Puntualidad programada.","error":"No se pudo programar esta solicitud."},"notify":{"runStarted":{"title":"Tarea programada en ejecuci\xf3n","body":"\\"{{name}}\\" se est\xe1 ejecutando ahora."},"missed":{"title":"Tarea programada no cumplida","bodyOne":"\\"{{name}}\\" no se detect\xf3 mientras la aplicaci\xf3n no estaba en funcionamiento.","bodyMany":"Se omitieron {{count}} tareas programadas mientras la aplicaci\xf3n no estaba en ejecuci\xf3n."}},"skippedBusy":"Se omiti\xf3 porque ya se estaba ejecutando otro proceso.","overlap":{"title":"Los horarios se superponen","description":"Esto se ejecuta dentro de los 5 minutos posteriores a \\"{{name}}\\" ({{time}}). Solo se ejecuta una automatizaci\xf3n a la vez, por lo que una esperar\xe1 a que la otra termine. \xbfDe todas formas quieres programarla?","confirm":"Programa de todos modos"}},"keyboardService":{"unavailable":{"title":"Se ha detenido el control del teclado y el rat\xf3n.","recovering":"Cephable lo est\xe1 reiniciando. Tus comandos volver\xe1n a funcionar en breve.","stalled":"Cephable no pudo reiniciarlo. Intente ejecutar el comando nuevamente o reinicie Cephable si el problema persiste.","permissionTitle":"Cephable no puede controlar su teclado ni su rat\xf3n.","permission":"Concede acceso a Cephable en Configuraci\xf3n del sistema > Privacidad y seguridad > {{pane}}, y luego intenta ejecutar el comando de nuevo.","permissionWindows":"Windows impide que las aplicaciones controlen los programas que se ejecutan como administrador. Cierra y vuelve a abrir Cephable como administrador, o abre la otra aplicaci\xf3n sin permisos de administrador. Las notificaciones de seguridad de Windows y la pantalla de bloqueo no se pueden controlar. En un dispositivo de trabajo, es posible que tu administrador de TI est\xe9 bloqueando esta funci\xf3n."},"restored":"El control mediante teclado y rat\xf3n vuelve a funcionar."},"error":"Error","macPermissions":{"openSettings":"Abrir configuraci\xf3n","pane":{"accessibility":"Accesibilidad","deviceControl":"Control de dispositivos y acceso a datos","inputMonitoring":"Monitoreo de entrada","filesAndFolders":"Archivos y carpetas","fullDiskAccess":"Acceso completo al disco","camera":"C\xe1mara","microphone":"Micr\xf3fono","screenRecording":"Grabaci\xf3n de pantalla"}},"recordWorkflow":{"title":"Registrar un flujo de trabajo","description":"Mu\xe9strale a Cephable c\xf3mo realizas una tarea \u2014narra en voz alta mientras haces clic\u2014 y se convertir\xe1 en una habilidad reutilizable.","cardDescription":"Gr\xe1bate realizando una tarea para ense\xf1arle a Cephable c\xf3mo hacerlo.","goalLabel":"Descripci\xf3n de la grabaci\xf3n","goalPlaceholder":"\xbfQu\xe9 vas a demostrar? (opcional)","start":"Iniciar grabaci\xf3n","recording":"Registrando tu flujo de trabajo","stepCount":"{{count}} pasos","stopAndCreate":"Detente y crea una habilidad","creating":"Convierte tu grabaci\xf3n en una habilidad\u2026","permissionNeeded":"Cephable necesita el permiso de Accesibilidad/Monitorizaci\xf3n de entrada para registrar tus acciones. Conc\xe9delo en la Configuraci\xf3n del sistema y vuelve a intentarlo.","noMic":"Micr\xf3fono no disponible: se grabar\xe1n tus acciones sin narraci\xf3n.","startError":"No se pudo iniciar la grabaci\xf3n.","noSteps":"No se registraron acciones para convertirlas en una habilidad.","stopReminder":"Contin\xfaa todo el tiempo que necesites. Cuando termines la tarea, regresa aqu\xed y presiona Detener y Crear habilidad.","callout":{"title":"Ens\xe9\xf1ale a Cephable una de tus tareas","description":"Realiza una tarea una vez mientras Cephable te observa y narra lo que haces. Se convertir\xe1 en una habilidad que podr\xe1s ejecutar en cualquier momento.","action":"Mu\xe9strame c\xf3mo","dismiss":"Ahora no","badge":"Pru\xe9balo","compactDescription":"Realiza una tarea una vez mientras Cephable te observa y se convertir\xe1 en una habilidad que podr\xe1s ejecutar en cualquier momento.","compactAction":"Registrar un flujo de trabajo"},"coach":{"title":"Antes de grabar","progress":"Propina {{current}} de {{total}}","ready":"Estoy listo","skip":"Saltarse los consejos","reopen":"C\xf3mo funciona esto","steps":{"pickTask":{"title":"Elige una tarea real","body":"Elige algo que hagas habitualmente y planea completarlo de principio a fin de una sola vez. Una tarea corta y completa ense\xf1a mucho m\xe1s que una larga y a medio terminar.","example":"As\xed es como presento mi informe semanal de gastos: lo abro, lo relleno y lo env\xedo."},"narrate":{"title":"Hablar durante todo el proceso","body":"Explica en voz alta lo que est\xe1s haciendo y por qu\xe9, como si un nuevo compa\xf1ero de trabajo te estuviera observando. Tu descripci\xf3n es lo que Cephable transforma en los pasos.","example":"Ahora estoy abriendo la factura en Outlook para poder encontrar el n\xfamero de pedido."},"goSlow":{"title":"Haz clic con cuidado, una cosa a la vez.","body":"Espera a que cada p\xe1gina o aplicaci\xf3n termine de cargarse antes de hacer clic de nuevo, e indica qu\xe9 est\xe1s pulsando. Evita cualquier informaci\xf3n privada: las contrase\xf1as y los n\xfameros de tarjeta no deben incluirse en una skill.","example":"Hago clic en Aprobar en la parte superior derecha y espero a que aparezca la confirmaci\xf3n."},"explainRules":{"title":"Di las reglas en voz alta","body":"Menciona cualquier cambio que observes entre una partida y otra y qu\xe9 har\xedas de forma diferente, para que la habilidad pueda desenvolverse en m\xe1s situaciones que solo la de hoy.","example":"Si no hay n\xfamero de pedido, omito la hoja de c\xe1lculo y, en su lugar, env\xedo un correo electr\xf3nico al proveedor."},"comeBack":{"title":"Vuelve y pulsa Detener.","body":"Cephable seguir\xe1 grabando hasta que lo indiques. Cuando la tarea haya terminado, regresa a este panel y pulsa Detener y Crear Habilidad. Si no detecta ning\xfan sonido ni clic durante un minuto, se detendr\xe1 autom\xe1ticamente.","example":"Eso es todo, listo."}}},"idle":{"title":"Todav\xeda grabando","body":"No se oyeron clics ni se dijo nada durante un rato. Cuando hayas terminado la tarea, pulsa Detener y Crear habilidad.","countdown":"Deteni\xe9ndose autom\xe1ticamente en {{seconds}}s.","keepGoing":"Todav\xeda estoy trabajando","autoStopped":"La grabaci\xf3n se detuvo sola despu\xe9s de un minuto de silencio."},"teachAction":"Ense\xf1ar a Cephable un flujo de trabajo"},"backgroundCapture":{"title":"Contenido de fondo","capturing":"Almacenando contenido en segundo plano...","tooltip":"Contenido que no se pudo escribir y que se almacena para la sesi\xf3n actual. Desaparecer\xe1 cuando cierres Cephable.","nothingToPaste":"No hay contenido de fondo para pegar.","pasteNotPermitted":"No se puede pegar. Acci\xf3n no permitida debido al foco actual.","pasteFailed":"No se puede pegar el contenido de fondo."}}');


var $f3b28415484efa10$exports = {};
$f3b28415484efa10$exports = JSON.parse('{"404":"\xa1Oh, no! \xa1Hemos buscado por el mar y no encontramos tu p\xe1gina!","appError":{"title":"Algo sali\xf3 mal","description":"La aplicaci\xf3n ha experimentado un problema inesperado. Intenta recargarla o regresa a tu espacio de trabajo. Si el problema persiste, ponte en contacto con el servicio de asistencia.","home":"Volver al espacio de trabajo"}}');


var $b575a9a6bac1cad6$exports = {};
$b575a9a6bac1cad6$exports = JSON.parse('{"smartTasks":{"generate":{"focusApp":{"title":"Conc\xe9ntrese en la aplicaci\xf3n","description":"Aseg\xfarate de estar enfocado en la aplicaci\xf3n donde quieres que aparezca el texto generado. Podr\xe1s generar texto sin problemas en esa ubicaci\xf3n al hacer clic en \\"Generar\\"."}},"rewrite":{"focusApp":{"title":"Conc\xe9ntrese en la aplicaci\xf3n","description":"Aseg\xfarate de estar enfocado en la aplicaci\xf3n donde quieres que aparezca el texto reescrito. Podr\xe1s generar texto sin problemas en esa ubicaci\xf3n al hacer clic en \\"Generar\\"."}}},"customControls":{"tourLabel":"Controles globales y de dispositivos siempre disponibles","rowDescription":"Los controles globales y del dispositivo siempre est\xe1n disponibles si el micr\xf3fono est\xe1 activado, independientemente de la aplicaci\xf3n que uses. Puedes usar estos controles para interactuar con tu dispositivo sin tener que crear nuevos controles para la aplicaci\xf3n. Incluyen comandos \xfatiles como intercambiar controles o aplicaciones, generar texto, pausar el micr\xf3fono y mucho m\xe1s."},"profile":{"switch":{"title":"Cambiar controles de la aplicaci\xf3n","description":"Los controles de tu aplicaci\xf3n pueden cambiar autom\xe1ticamente seg\xfan la aplicaci\xf3n que est\xe9s utilizando, o puedes modificarlos manualmente aqu\xed en cualquier momento."}},"dictation":{"tourLabel":"Dictado","learn":"Aprenda a utilizar el modo de dictado para convertir su voz en texto con manos libres.","welcome":{"title":"Dictado","description":"El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."},"microphone":{"title":"Enciende tu micr\xf3fono","description":"Primero, activa el micr\xf3fono. Haz clic en el interruptor de micr\xf3fono en el panel de Cephable."},"activate":{"title":"Iniciar el modo de dictado","description":"La voz se inicia en modo comando. Para iniciar el dictado, diga \\"Iniciar dictado\\" o haga clic en el bot\xf3n Dictado. Activemos el modo de dictado."},"focus":{"title":"Centrarse en un campo de texto o documento","description":"El dictado funciona mejor cuando te centras en un campo de texto o documento. Haz clic en el campo de texto o documento donde quieras dictar."},"speaking":{"title":"Empieza a hablar","description":"Ahora puedes empezar a hablar. Todo lo que digas se escribir\xe1 en el campo de texto o documento que hayas seleccionado. Intenta decir algo como \\"Hola, esta es una prueba del modo de dictado\\"."},"pauseResume":{"title":"Pausa del dictado","description":"\xbfNecesitas un descanso sin desactivar el dictado? Simplemente di \\"Pausar dictado\\". Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\". Puedes personalizarlo a\xfan m\xe1s con los controles globales y del dispositivo siempre activos."},"stop":{"title":"Detener el dictado","description":"\xbfNecesitas volver a los controles de tu aplicaci\xf3n? Simplemente di \\"Detener dictado\\". Esto detendr\xe1 el modo de dictado y te permitir\xe1 volver al modo comando. Puedes reanudarlo en cualquier momento con \\"Iniciar dictado\\"."},"complete":{"description":"\xa1Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. \xdasalo para escribir correos electr\xf3nicos, documentos o cualquier otra cosa que necesites escribir en voz alta."}},"microphone":{"tourLabel":"Controles de voz","learn":"Aprenda c\xf3mo puede usar su voz para controlar cualquier aplicaci\xf3n y usar el dictado para escribir lo que dice.","rowDescription":"Cuando el micr\xf3fono est\xe9 apagado, no escucharemos tus comandos de voz, pero si lo enciendes, podr\xe1s usar comandos globales para pausar, iniciar y m\xe1s. Vamos a encenderlo.","tryOpen":{"title":"Prueba a decir \xabAbrir Spotify\xbb o \xabAbrir Word\xbb."},"finishedCommands":{"title":"\xa1Excelente! Has aprendido lo b\xe1sico de los controles de voz.","description":"Siempre puedes volver a visitar el recorrido desde la p\xe1gina de soporte. El siguiente paso es aprender sobre Dictado. Puedes comenzar el recorrido desde la p\xe1gina de soporte."}},"tour":{"startTour":"Iniciar Tour","finishTour":"Finalizar el recorrido","statusDialog":"Por favor consulte el panel para obtener m\xe1s informaci\xf3n.","step":"Paso {{paso}} de {{total}}","skipTour":"Saltar el recorrido"},"onboarding":{"overview":"Descripci\xf3n general","learn":"Conozca las caracter\xedsticas de Cephable y c\xf3mo usarlas.","start":"Parece que apenas est\xe1s empezando. Aqu\xed tienes algunas \xe1reas que te ayudar\xe1n en el proceso.","dashboard":{"title":"Espacio de trabajo cefalable","description":"El espacio de trabajo de Cephable es tu centro de control para gestionar tu dispositivo, los controles de la aplicaci\xf3n y la configuraci\xf3n. Desde aqu\xed, puedes personalizar tu experiencia, ver los comandos activos y acceder a todas las funciones de Cephable."},"step1":{"title":"Bienvenido a Cephable","description":"Cephable es tu IA personal: dise\xf1ada para acciones r\xe1pidas, comandos de voz, generaci\xf3n de contenido y automatizaci\xf3n inteligente en todas tus herramientas. Controles preconfigurados. Sin procesamiento en la nube. Solo productividad que se mueve contigo."},"finish":{"continueToApp":"Continuar al panel de Cephable","keepExploring":"Sigue explorando"},"useCaseSlider":{"context":"Me gustar\xeda usar","control":"Para controlar"}},"support":{"description":"Puede visitar nuestro centro de soporte para obtener m\xe1s informaci\xf3n sobre c\xf3mo usar Cephable, incluidos m\xe1s recorridos, gu\xedas paso a paso, tutoriales y videos.","title":"Apoyo"},"editingVideos":{"tourLabel":"Conc\xe9ntrese en la historia, no en los tediosos clics de la edici\xf3n de video","learn":"Aprende a usar los controles de voz y el dictado para editar v\xeddeos m\xe1s r\xe1pido y elimina la carga cognitiva de recordar qu\xe9 botones pulsar durante la edici\xf3n.","tryOpen":{"title":"Prueba a decir `Abrir CapCut` o `Abrir iMovie`."},"complete":{"description":"Ahora ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para reproducir, pausar, saltar pistas y ajustar el volumen en tus aplicaciones de edici\xf3n de v\xeddeo favoritas. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para un control de v\xeddeo a\xfan m\xe1s fluido."}},"congrats":"\xa1Felicitaciones!","fpsGamePlay":{"tourLabel":"Juega juegos FPS con controles de voz","learn":"Aprende a usar controles de voz y acciones r\xe1pidas para jugar juegos FPS.","tryOpen":{"title":"Prueba a decir \xabAbrir Valorant\xbb o \xabAbrir Battlefield\xbb."},"complete":{"description":"Ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para moverte, detenerte y controlar a tu personaje en juegos FPS. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para disfrutar de una experiencia de juego a\xfan m\xe1s fluida y r\xe1pida."}},"redo":"Rehacer la incorporaci\xf3n","title":"Conoce a Cephable","description":"Conozca Cephable, su asistente personal de IA y comparta su inter\xe9s en casos de uso personalizados.","panel":{"description":"Este es el panel, el centro de control principal. Siempre est\xe1 visible y te permite controlar tus aplicaciones con la voz, entre otras funciones. Empecemos por el micr\xf3fono."},"controlExpanded":{"tourLabel":"Control","description":"Los controles de la aplicaci\xf3n son conjuntos de controles configurables que puedes usar en la aplicaci\xf3n que desees. Esta secci\xf3n te muestra todos los controles disponibles que puedes usar mediante comandos de voz, toques, escritura y m\xe1s."},"submit":{"title":"Entregar","description":"El contenido se mostrar\xe1 donde se encuentre el cursor."},"tryOpen":{"description":"`Open` es un comando global que abrir\xe1 la aplicaci\xf3n que especifiques y le asignar\xe1 el foco. Si tienes habilitada la opci\xf3n de cambio autom\xe1tico de controles, tambi\xe9n cambiar\xe1 a los controles de la aplicaci\xf3n que mejor se adapten a la que est\xe9s utilizando."},"modeSelector":{"title":"Seleccionar modo","description":"Si est\xe1 disponible, puedes seleccionar el modo en el que operar\xe9. Usa Control para la aplicaci\xf3n a trav\xe9s de la cual quieras enviar comandos, Crear para contenido de texto generativo como resumir, reescribir o traducir. Selecciona Automatizar para flujos de escritorio o entre aplicaciones."},"contextSelector":{"title":"Seleccionar contexto","description":"Si est\xe1 disponible, puede seleccionar el contexto en el que trabajar\xe9. Por ejemplo, puedo usar el contenido de su portapapeles o el texto resaltado, y tambi\xe9n puede adjuntar archivos o carpetas con los que desee que trabaje."},"panelInput":{"title":"\xbfQu\xe9 quieres que haga?","description":"Puedes darme \xf3rdenes, escribirlas o dictarme lo que quieres que haga."},"figma":{"tourLabel":"Comandos de voz para Figma y Canva","learn":"Aprende a usar los controles de voz, el rat\xf3n por voz, el dictado y la generaci\xf3n de contenido mediante IA de Controls para mejorar tu flujo de trabajo de dise\xf1o.","complete":{"description":"Ahora ya sabes c\xf3mo controlar y crear dise\xf1os para optimizar tu flujo de trabajo. Explora m\xe1s comandos para un control de dise\xf1o a\xfan m\xe1s fluido."},"tryOpen":{"title":"Prueba a decir `Abrir Figma` o `Abrir Canva`."}},"voiceMouse":{"title":"Rat\xf3n de voz","description":"Para hacer clic en los botones por su nombre, puede usar Voice Mouse. Para ello, diga \xabtoque guardar\xbb o \xabvaya a configuraci\xf3n\xbb."},"documentSummary":{"tourLabel":"Borradores de res\xfamenes de equipos a partir de informes confidenciales","learn":"Automatice la lectura de los informes departamentales, identifique a las personas adecuadas para informar y redacte un correo electr\xf3nico, todo ello desde su dispositivo, para que sus datos confidenciales permanezcan privados.","congrats":{"description":"Ahora ya sabes c\xf3mo usar los flujos de trabajo de IA para leer documentos confidenciales y redactar un correo electr\xf3nico de resumen para tu equipo, todo ello sin que tus datos salgan de tu dispositivo."}},"extensions":{"tourLabel":"Extensiones","rowDescription":"Ampl\xeda las funciones de Cephable con m\xe1s opciones para controlar tu dispositivo, como controles de c\xe1mara para el movimiento de la cara y la cabeza, o compatibilidad con mandos. Activa las que necesites aqu\xed."},"developerBuildTests":{"tourLabel":"Automatice las compilaciones y las pruebas con flujos de trabajo de IA.","learn":"Cephable puede ejecutar tareas de terminal de varios pasos, como compilar tu proyecto y ejecutar sus pruebas, completamente en el dispositivo, en segundo plano, mientras sigues trabajando.","complete":{"description":"Ahora ya sabes c\xf3mo ejecutar flujos de trabajo de IA en dispositivos para tareas de compilaci\xf3n y prueba de varios pasos, responder a solicitudes de permisos y seguir iterando sobre los resultados. Prueba a automatizar otra tarea de desarrollo repetitiva."}},"classroomStudyTools":{"tourLabel":"Convierte tus apuntes de clase y art\xedculos en herramientas de estudio y materiales did\xe1cticos.","learn":"Cephable ofrece a profesores y alumnos funciones de dictado, herramientas de creaci\xf3n en el dispositivo y automatizaci\xf3n, todo ello integrado en las aplicaciones que ya utilizas, manteniendo la privacidad de toda la informaci\xf3n en tu dispositivo.","complete":{"description":"Ahora ya sabes c\xf3mo dictar directamente en tus documentos, generar nuevos materiales de estudio a partir de tus apuntes y usar Automate para crear tareas completas en segundo plano, todo ello desde tu dispositivo."}},"engineeringFlows":{"tourLabel":"Controles por voz y automatizaci\xf3n con IA para desarrolladores","learn":"Aprende a agilizar tu flujo de trabajo de ingenier\xeda con comandos de desarrollo controlados por voz, reescritura de c\xf3digo mediante IA utilizando tu propio c\xf3digo como contexto y flujos de trabajo de IA en segundo plano, todo ello ejecut\xe1ndose en el dispositivo.","tryOpen":{"title":"Intenta decir `Abrir Visual Studio Code`."},"complete":{"description":"Ahora ya sabes c\xf3mo usar comandos de desarrollo controlados por voz, la funci\xf3n de reescritura de IA con tu propio c\xf3digo como contexto y flujos de trabajo de IA en segundo plano para acelerar tu proceso de ingenier\xeda."}},"meetingNotesToFiles":{"tourLabel":"Convierta las notas de las reuniones en archivos \xfatiles para la toma de decisiones.","learn":"Cephable puede dividir las notas de tus reuniones en archivos m\xe1s peque\xf1os y pr\xe1cticos con los que puedes trabajar a tu propio ritmo, todo ello directamente en tu dispositivo.","complete":{"description":"Ahora ya sabes c\xf3mo usar los flujos de trabajo de IA para dividir las notas de las reuniones en archivos m\xe1s peque\xf1os y pr\xe1cticos, y retomar la conversaci\xf3n en cualquier momento desde el historial de IA."}},"notesToPresentation":{"tourLabel":"Resume notas confidenciales y crea una presentaci\xf3n, todo desde tu dispositivo.","learn":"Cephable puede resumir tus informes y notas confidenciales, y luego usar flujos de trabajo de IA para hacerlo en toda una carpeta de archivos, e incluso crear una presentaci\xf3n a partir de los resultados. Todo se ejecuta en tu dispositivo.","complete":{"description":"Ahora ya sabes c\xf3mo resumir documentos confidenciales, resumir por lotes una carpeta completa con flujos de trabajo de IA y convertir los resultados en una presentaci\xf3n, todo ello sin que tus datos salgan de tu dispositivo."}},"organizeDownloads":{"tourLabel":"Organiza tus archivos, limpia y encuentra lo que perdiste con flujos de trabajo de IA.","learn":"Automate puede gestionar tareas de administraci\xf3n de archivos en varios pasos (copiar, eliminar y buscar archivos) directamente desde una simple solicitud.","complete":{"description":"Ahora ya sabes c\xf3mo usar los flujos de trabajo de IA para organizar archivos, limpiarlos de forma segura con comprobaciones de permisos y encontrar archivos cuya ubicaci\xf3n no recuerdas."}},"outlookEmailProductivity":{"tourLabel":"Agiliza el correo electr\xf3nico en Outlook con dictado, acciones r\xe1pidas e inteligencia artificial.","learn":"Cephable Plus y Professional incluyen herramientas inteligentes de dictado y creaci\xf3n para generar y editar contenido; \xfaselas directamente en Outlook para responder y redactar correos electr\xf3nicos m\xe1s r\xe1pidamente.","complete":{"description":"Ahora ya sabes c\xf3mo responder a correos electr\xf3nicos mediante dictado, usar tus propias acciones de Escritura r\xe1pida y utilizar las funciones Resumir y Generar para redactar y perfeccionar el contenido de los correos electr\xf3nicos, todo ello desde tu dispositivo."}},"customizingGameControls":{"tourLabel":"Juega a juegos de rol con control por voz.","learn":"Aprende a usar los controles de voz y las acciones r\xe1pidas para jugar a juegos de rol.","tryOpen":{"title":"Intenta decir `Abre Minecraft`"},"complete":{"description":"Ahora ya sabes c\xf3mo usar comandos de voz y acciones r\xe1pidas para mover, detener y controlar a tu personaje en juegos de rol. Explora m\xe1s comandos o personaliza tus propias acciones r\xe1pidas para una experiencia de juego a\xfan m\xe1s fluida y r\xe1pida."}},"voiceToTextSocialMedia":{"tourLabel":"Conversi\xf3n de voz a texto para LinkedIn, Slack y Discord.","learn":"Utiliza el Dictado Inteligente para redactar un mensaje de forma natural y, a continuaci\xf3n, la funci\xf3n Reescribir para ajustar el tono; funciona de la misma manera en LinkedIn, Slack, Discord y otras plataformas.","complete":{"description":"Ahora ya sabes c\xf3mo redactar una publicaci\xf3n y perfeccionarla con Rewrite, en LinkedIn, Slack, Discord y m\xe1s."}},"aiDocumentTranslation":{"tourLabel":"Traduce documentos a cualquier idioma, directamente en tu dispositivo.","learn":"Cephable puede traducir un documento a un idioma a la vez, o utilizar flujos de trabajo de IA para traducirlo a varios idiomas simult\xe1neamente, todo ello ejecut\xe1ndose localmente.","complete":{"description":"Ahora ya sabes c\xf3mo traducir un documento a un solo idioma mediante dictado, o a varios idiomas a la vez con flujos de trabajo de IA, todo ello desde tu dispositivo."}},"excelAiAutomation":{"tourLabel":"Analice hojas de c\xe1lculo con IA privada en su dispositivo.","learn":"Cephable puede leer tus archivos de Excel, responder preguntas sobre los n\xfameros e ir profundizando a\xfan m\xe1s, todo ello sin que tus datos salgan de tu dispositivo.","complete":{"description":"Ahora ya sabes c\xf3mo usar los flujos de trabajo de IA para cuestionar tus hojas de c\xe1lculo, profundizar en los datos con seguimientos y guardar un resumen, todo ello ejecut\xe1ndose en tu dispositivo."}},"handsFreeComputerControl":{"tourLabel":"Controla tu ordenador con voz y c\xe1mara.","learn":"Cephable te permite controlar tu ordenador sin usar las manos mediante comandos de voz, Voice Mouse y controles faciales y de cabeza basados en la c\xe1mara.","tryOpenWord":{"title":"Intenta decir \\"Palabra abierta\\""},"openExtensions":{"title":"Abre la pesta\xf1a Extensiones","description":"Para activar los controles de la c\xe1mara, abra la pesta\xf1a Extensiones en la ventana principal."},"turnOnCamera":{"title":"Activar los controles de la c\xe1mara","description":"Activa la c\xe1mara. Aparecer\xe1 un icono de c\xe1mara junto al icono del micr\xf3fono y una nueva secci\xf3n de C\xe1mara en Ajustes."},"cameraInPanel":{"title":"Controles de la c\xe1mara en su panel","description":"Ahora que los Controles de la c\xe1mara est\xe1n activados, el interruptor de la c\xe1mara tambi\xe9n aparece en tu panel de Cephable; Cephable lo activa autom\xe1ticamente desde aqu\xed."},"openCameraSettings":{"title":"Abrir la configuraci\xf3n de la c\xe1mara","description":"Abre la configuraci\xf3n de la c\xe1mara para ajustar con precisi\xf3n c\xf3mo funcionan los controles de cabeza y rostro."},"chooseHeadMouseMode":{"title":"Seleccione un modo de control con el rat\xf3n","description":"Elige c\xf3mo el movimiento de la cabeza controla el rat\xf3n: Deslizamiento constante, Aumento de velocidad o Deslizamiento din\xe1mico."},"complete":{"description":"Ahora ya sabes c\xf3mo controlar tu ordenador con la voz, el rat\xf3n por voz y los comandos de la c\xe1mara (cabeza y rostro). Explora la configuraci\xf3n de la c\xe1mara para personalizar los controles a tu gusto."}},"handsFreeTypingDocumentCreation":{"tourLabel":"Crea y edita documentos sin usar las manos.","learn":"Utilice las funciones Generar, Reescribir y los controles de voz de forma conjunta para crear y editar un documento, como una factura, pr\xe1cticamente sin usar las manos.","complete":{"description":"Ahora ya sabes c\xf3mo generar, reescribir y editar un documento pr\xe1cticamente sin usar las manos, mediante las funciones Generar, Reescribir y los comandos de voz."}},"webResearchCreateHtml":{"tourLabel":"Investiga en la web y crea un sitio web a partir de ella: todo desde tu dispositivo.","learn":"Cephable puede explorar y analizar los sitios web de la competencia y, a continuaci\xf3n, utilizar la informaci\xf3n que encuentre para generar un nuevo sitio HTML para usted, todo ello en su dispositivo, de modo que su investigaci\xf3n permanezca privada.","complete":{"description":"Ahora ya sabes c\xf3mo usar los flujos de trabajo de IA para investigar los sitios web de la competencia y generar un nuevo sitio HTML a partir de los resultados, todo ello sin que tus datos salgan de tu dispositivo."}},"webResearchSummarize":{"tourLabel":"Normativa de investigaci\xf3n y resumen de los resultados: todo en el dispositivo.","learn":"Cephable puede navegar por la web para investigar cambios como nuevas leyes de protecci\xf3n de datos y, a continuaci\xf3n, resumir los hallazgos en informaci\xf3n \xfatil para que tu equipo pueda actuar en consecuencia; todo ello directamente en el dispositivo, de modo que tu investigaci\xf3n se mantiene privada.","complete":{"description":"Ahora ya sabes c\xf3mo usar los flujos de trabajo de IA para investigar los cambios normativos, profundizar en la implementaci\xf3n y redactar los resultados en un correo electr\xf3nico que tu equipo pueda revisar, todo ello sin que tus datos salgan de tu dispositivo."}},"stopListening":{"title":"Intenta decir \\"Deja de escuchar\\".","description":"Esto pausa el micr\xf3fono sin apagarlo por completo. Di \xabEmpezar a escuchar\xbb de nuevo cuando est\xe9s listo."}}');


var $501d8d6df9954de7$exports = {};
$501d8d6df9954de7$exports = JSON.parse('{"introduction":{"title":"Hola, soy Cephable.","back":"Volver a la introducci\xf3n","description":"Soy tu IA personal para ayudarte a controlar, crear y automatizar las herramientas que ya te encantan, en todas tus conexiones. Hay algunas cosas que debes saber sobre m\xed.","action":"\xa1Comencemos!","recording":{"title":"Su voz y v\xeddeo permanecen locales.","description":"Nunca grabo, transmito ni env\xedo tu audio o video a la nube. Todas las entradas se procesan en el dispositivo de forma privada y segura."},"data":{"title":"Tus datos son tuyos.","description":"No uso tus comandos ni tu actividad para entrenar modelos para otros. Todo se mantiene privado y los controles de tu aplicaci\xf3n se mueven contigo entre conexiones."},"offline":{"title":"Trabajo cuando otras herramientas no lo hacen.","description":"Las tareas inteligentes, como generar contenido, reescribir, traducir y dictar, se ejecutan localmente. No se requiere la nube. Esto significa que trabajo incluso sin conexi\xf3n, y tus datos no salen de tu dispositivo."},"empower":{"title":"Creado para empoderar, no para explotar.","description":"Estoy dise\xf1ado para mejorar tu control, no para monitorearlo. Sin rastreo invasivo. Sin recopilaci\xf3n de datos intrusivos. Solo informaci\xf3n que te funcione."}},"my-capabilities":{"title":"\xa1Perfecto! As\xed es como puedo ayudarte.","back":"Volver a las capacidades","actionTitle":"M\xedrame en acci\xf3n","description":"Aqu\xed est\xe1n las caracter\xedsticas y capacidades m\xe1s relevantes para tu flujo de trabajo, organizadas en torno a las tres cosas que hace Cephable.","action":{"title":"M\xedrame en acci\xf3n","description":"Explora algunos ejemplos de c\xf3mo puedo ayudarte en tus tareas diarias."},"basedOnInterests":"Seg\xfan tus intereses","cta":{"eyebrow":"Listo cuando est\xe9s","title":"Compru\xe9belo en sus aplicaciones."}},"see-me":{"title":"\xbfQuieres ver c\xf3mo he ayudado a otros como t\xfa?","back":"Volver a los casos de uso","description":"Vea algunos ejemplos reales de c\xf3mo he transformado los flujos de trabajo en diferentes industrias y roles."},"complete":{"title":"\xbfEst\xe1s listo para comenzar a usarme?","description":"\xa1Ya viste lo que puedo hacer! Ahora, vamos a configurarlo y a empezar a transformar tu flujo de trabajo. Estar\xe9 aqu\xed para ayudarte en cada paso del proceso.","action":"Complete la configuraci\xf3n y comience a usar Cephable"},"apps":{"title":"Apoyo las herramientas que ya amas","description":"Con soporte preconfigurado para m\xe1s de 200 aplicaciones, trabajo con el software que usas a diario. No requiere configuraci\xf3n.","note":"\xbfNo encuentras una aplicaci\xf3n que uses? No hay problema: puedo generar controles o ayudarte a crear flujos de trabajo personalizados que se adapten a tus necesidades.","andMore":"Y m\xe1s","eyebrow":"M\xe1s de 200 aplicaciones, sin necesidad de configuraci\xf3n."},"actions":{"ctaTry":"Pru\xe9balo ahora","ctaWatch":"Ver demostraci\xf3n","apps":"Soy compatible con:","abilities":"Mis habilidades utilizadas:"},"interests":{"title":"\xbfEn qu\xe9 puedo ayudarte?","back":"Volver a los intereses","description":"Puedo controlar aplicaciones en tu escritorio y dispositivos conectados. Personalicemos tu experiencia: \xbfqu\xe9 te interesa m\xe1s?","note":"Seleccione todas las que correspondan y le mostrar\xe9 las caracter\xedsticas y ejemplos m\xe1s relevantes para su flujo de trabajo.","action":"Continuar con {{count}} intereses","empty":"Seleccione al menos un inter\xe9s.","create_design":{"label":"Crear y dise\xf1ar","shortLabel":"Dise\xf1o","description":"Para artistas, comercializadores y creadores de contenido."},"analyze_report":{"label":"Analizar e informar","shortLabel":"Analizar","description":"Para analistas, investigadores y profesionales de negocios."},"communicate_collaborate":{"label":"Comunicarse y colaborar","shortLabel":"Comunicar","description":"Para vendedores, reuniones y equipos remotos."},"build_develop":{"label":"Construir y desarrollar","shortLabel":"Desarrollar","description":"Para desarrolladores, ingenieros y profesionales t\xe9cnicos."},"game_play":{"label":"Juego y juego","shortLabel":"Juego de azar","description":"Para jugadores, streamers y controles multimedia."},"learn_teach":{"label":"Aprender y ense\xf1ar","shortLabel":"Aprendiendo","description":"Para educadores, estudiantes e instrucci\xf3n."},"manage_organize":{"label":"Administrar y organizar","shortLabel":"Organizando","description":"Para gerentes de proyectos, coordinadores y organizadores."},"adapt_access":{"label":"Adaptaci\xf3n y acceso","shortLabel":"Accesibilidad","description":"Para controles adaptativos y necesidades de accesibilidad personalizadas."},"everything":{"label":"Un poco de todo","shortLabel":"Todo","description":"Para usuarios de computadoras en general y que realizan m\xfaltiples tareas a la vez."},"filter":"Filtrar por tipo de inter\xe9s"},"capabilities":{"title":"Mis principales capacidades de IA","description":"Combino IA avanzada con potentes m\xe9todos de entrada para ofrecerte un control total sobre tus aplicaciones y dispositivos. Estas son algunas de mis funciones.","voice_controls":{"title":"Controles de voz","description":"Entiendo comandos de lenguaje natural para que puedas controlar cualquier aplicaci\xf3n con tu voz.","longDescription":"Te dejo hablar con naturalidad y aun as\xed lograr tus objetivos. Ya sea que quieras abrir aplicaciones, navegar por los men\xfas o iniciar flujos de trabajo, traduzco el ingl\xe9s sencillo a acciones fiables y sin intervenci\xf3n manual."},"smart_dictation":{"title":"Dictado inteligente","description":"Convierto tu discurso en texto con conocimiento del contexto y formato.","longDescription":"Escucho atentamente y capto tus palabras con precisi\xf3n. Agrego la puntuaci\xf3n, corrijo las may\xfasculas y aplico formato contextual para que tu texto luzca impecable sin esfuerzo adicional."},"ai_text_generation":{"title":"Generaci\xf3n de texto con IA","description":"Puedo crear correos electr\xf3nicos, documentos, c\xf3digos y contenido creativo sobre la marcha.","longDescription":"Te ayudo a redactar, resumir o ampliar cualquier contenido directamente en tus aplicaciones. Desde correos electr\xf3nicos y notas hasta fragmentos de c\xf3digo y documentos, me aseguro de que nunca empieces desde cero."},"head_face_controls":{"title":"Controles de cabeza y cara","description":"Te dejo provocar acciones con movimientos de cabeza y cara.","longDescription":"Traduzco tus movimientos y expresiones naturales de cabeza en informaci\xf3n precisa. Puedes enviar un correo electr\xf3nico con una sonrisa, pasar de p\xe1gina con un gesto de la cabeza o hacer clic levantando las cejas."},"natural_language_voice_clicking":{"title":"Clics de voz en lenguaje natural","description":"Te dejo decir lo que ves para hacer clic en botones, enlaces y men\xfas en la pantalla.","longDescription":"Cuando dices el nombre de algo en tu pantalla, lo encuentro e interact\xfao con \xe9l por ti. Sin comandos memorizados: solo describe lo que quieres y yo me encargo de hacer clic."},"keyboard_mouse_emulation":{"title":"Emulaci\xf3n de teclado y rat\xf3n","description":"Emulo teclas, clics y desplazamiento para que puedas controlar aplicaciones sin hardware.","longDescription":"Env\xedo pulsaciones de teclas, movimientos del rat\xf3n, clics y eventos de desplazamiento donde los necesites. Comb\xedname con controles de voz o de cabeza para reemplazar o mejorar por completo los dispositivos de entrada tradicionales."},"profiles_personalization":{"title":"Personalizaci\xf3n","description":"Recuerdo tus preferencias y me adapto con los controles de aplicaciones guardadas.","longDescription":"Monitoreo tus aplicaciones, comandos y preferencias favoritas. Cambia entre los controles de las aplicaciones de forma autom\xe1tica o manual, y siempre te mostrar\xe9 los controles adecuados para lo que est\xe9s haciendo."},"cross_device_connectivity":{"title":"Conectividad entre dispositivos","description":"Te permito usar tu tel\xe9fono para iniciar una automatizaci\xf3n de forma remota.","longDescription":"Conecto tu dispositivo m\xf3vil a tu escritorio para que puedas ejecutar comandos, dictar o navegar f\xe1cilmente. Perfecto para presentaciones, sesiones remotas o uso ocasional."},"quick_action_buttons":{"title":"Botones de acci\xf3n r\xe1pida","description":"Te doy botones compatibles con aplicaciones para acciones r\xe1pidas.","longDescription":"Muestro botones contextuales que se adaptan a tu app. Ya sea para unirte a una reuni\xf3n, enviar un mensaje o crear un correo electr\xf3nico, puedo realizar tareas complejas con solo un clic."},"ai_app_awareness":{"title":"Conciencia de las aplicaciones de IA","description":"Ajusto mis controles en funci\xf3n de la aplicaci\xf3n que est\xe9s usando.","longDescription":"Presto atenci\xf3n a lo que est\xe1 activo en tu pantalla para ofrecerte los controles adecuados en el momento oportuno. Sin desorden ni conjeturas: solo lo que necesitas, cuando lo necesitas. Todo en tu dispositivo y sin enviar datos a la nube."},"ai_rewrite":{"title":"Reescritura de IA","description":"Puedo reescribir su texto para mejorar el tono, actualizar el formato o ampliar los detalles.","longDescription":"Edito textos justo donde trabajas. Puedo hacerlos m\xe1s accesibles, m\xe1s formales, m\xe1s cortos, m\xe1s largos o m\xe1s detallados: lo que necesites para transmitir mejor tu mensaje."},"ai_translation":{"title":"Traducci\xf3n de IA","description":"Puedo traducir entre idiomas o incluso lenguajes de programaci\xf3n.","longDescription":"Te permito convertir texto a otro idioma hablado o c\xf3digo a otro lenguaje de programaci\xf3n. Trabajo desde el sitio, as\xed que no tienes que salir de la aplicaci\xf3n que est\xe1s usando."},"head_mouse":{"title":"Cabeza de rat\xf3n","description":"Te dejo mover el cursor del mouse con movimientos de la cabeza.","longDescription":"Convierto con fluidez el movimiento de tu cabeza en movimiento del cursor. Con funciones como deslizamiento y ajuste de sensibilidad, te ofrezco un control preciso, c\xf3modo y manos libres."},"head_joystick":{"title":"Joystick de cabeza","description":"Te dejo usar tu cabeza como joystick para juegos o aplicaciones.","longDescription":"Mapeo los movimientos de tu cabeza en los ejes del joystick para que puedas jugar o controlar software creativo sin necesidad de hardware. Te mueves con naturalidad y yo lo traduzco a una se\xf1al anal\xf3gica."},"mcp_agent":{"title":"Agente MCP","description":"Puedo conectarme con agentes de IA externos a trav\xe9s del Protocolo de Contexto de Modelo (MCP).","longDescription":"Domino el Protocolo de Contexto de Modelo, lo que me permite trabajar con otros agentes y herramientas de IA. Esto significa que puedo coordinar tareas, intercambiar contexto y ampliar mis capacidades con sistemas externos especializados, todo ello mientras te mantengo al mando."},"byo_ai_integration":{"title":"Trae tu propia IA","description":"Te permito mejorar mi IA existente con tus propios modelos o servicios de IA para usar conmigo.","longDescription":"Si ya cuenta con un servicio, modelo o proveedor de IA de confianza, puedo integrarlo en mi flujo de trabajo. Le doy la flexibilidad de elegir el motor que impulsa la generaci\xf3n, reescritura o traducci\xf3n, ya sea en la nube, local o personalizado. Si no tiene conexi\xf3n o el servicio no est\xe1 disponible, puedo recurrir a mis funciones integradas."},"workflows":{"title":"Flujos de trabajo","description":"Te ayudo a encadenar acciones en flujos de trabajo repetibles.","longDescription":"Te permito dise\xf1ar y ejecutar procesos de varios pasos que conectan diferentes entradas, comandos y salidas. Con los flujos de trabajo, puedes automatizar tareas rutinarias o crear interacciones complejas, activadas por tu voz o gestos, para que yo me encargue del trabajo pesado."},"showMore":"Mostrar m\xe1s","showLess":"Mostrar menos","background_creation":{"title":"Creaci\xf3n de fondos","description":"Yo creo y edito el contenido en segundo plano mientras t\xfa trabajas.","longDescription":"Creo y edito el contenido en segundo plano mientras usted se concentra en su trabajo. Cuando lo necesite, el contenido estar\xe1 listo en su sistema de archivos sin interrumpir su flujo de trabajo ni tener que copiarlo."},"ai_summary":{"title":"Resumen de IA","description":"Extrae informaci\xf3n valiosa de textos extensos y crea res\xfamenes breves o ideas clave."}},"listing":{"title":"Casos de uso","titleLong":"Explora c\xf3mo puedo ayudarte","recommended":"Recomendado para ti","exploreMore":"Explorar m\xe1s casos de uso","description":"Descubre todo lo que puedo hacer para optimizar tu flujo de trabajo. Desde mejoras de productividad hasta asistencia creativa, encuentra los casos de uso perfectos, adaptados a tus necesidades.","all":"Todo","search":"Buscar casos de uso, aplicaciones o capacidades...","noResults":"No se encontraron resultados. Intenta ajustar tu b\xfasqueda o filtros.","emptyAction":"Ver m\xe1s en l\xednea"},"examples":{"universalAppControl":{"title":"Control universal de aplicaciones","description":"Controle cualquier aplicaci\xf3n en su computadora con comandos de voz y automatizaci\xf3n inteligente","descriptionLong":"Controla cualquier aplicaci\xf3n con potentes comandos de voz y automatizaci\xf3n inteligente. Nuestro sistema Universal App Control aprende c\xf3mo trabajas y se adapta a tus necesidades, simplificando las tareas complejas e instant\xe1neamente las acciones rutinarias. Desde la gesti\xf3n de tu suite de productividad hasta el control de aplicaciones multimedia y de juegos, esta funci\xf3n funciona en todo tu entorno digital."},"documentSummary":{"title":"Agente de escritorio de IA privado que lee tus documentos, escribe el resumen y lo env\xeda a tu equipo.","description":"Utilice un agente de escritorio privado para leer documentos, redactar res\xfamenes y compartirlos con su equipo sin necesidad de usar las manos.","descriptionLong":"Dirige tu agente de IA hacia un documento y deja que lo lea, lo resuma y lo env\xede por ti. Mant\xe9n todo funcionando localmente y de forma privada mientras trabajas sin mover un dedo."},"editingVideos":{"title":"Edici\xf3n de voz en CapCut: navega por las l\xedneas de tiempo, corta clips y mantente en la historia.","description":"Edita v\xeddeos mediante comandos de voz y dictado, para que puedas cortar y organizar clips sin usar las manos.","descriptionLong":"Navega por la l\xednea de tiempo, recorta y divide clips, y da forma a tu edici\xf3n usando solo tu voz. Mantente concentrado en la historia sin tener que navegar por men\xfas ni usar el rat\xf3n."},"figma":{"description":"Edita im\xe1genes y dise\xf1os mediante comandos de voz y dictado inteligente para realizar iteraciones m\xe1s r\xe1pidas.","descriptionLong":"Da vida a tus ideas visuales con la edici\xf3n de im\xe1genes controlada por voz. Navega m\xe1s r\xe1pido y perfecciona tus dise\xf1os sin tener que navegar por men\xfas complejos.","title":"Comandos de voz para Figma y Canva: controla capas, cambia de herramienta y escribe y copia sin usar las manos."},"excelAnalysis":{"title":"Trabaje m\xe1s r\xe1pido y analice en Excel con la automatizaci\xf3n de IA privada y local.","description":"Analice hojas de c\xe1lculo y detecte tendencias utilizando automatizaci\xf3n de IA privada y local, sin necesidad de intervenci\xf3n manual.","descriptionLong":"Analice las tendencias en una carpeta o documento, formule preguntas sobre los informes financieros y elabore un resumen final. Deje que la IA local se encargue del an\xe1lisis, manteniendo sus datos privados en su propio equipo."},"emailAutomation":{"title":"\xa1Automatiza tu correo electr\xf3nico: flujos de trabajo de IA locales que leen tu bandeja de entrada, redactan respuestas y mucho m\xe1s!","description":"Lee tu bandeja de entrada, redacta respuestas y crea plantillas utilizando flujos de trabajo de IA locales y dictado.","descriptionLong":"Redacta un correo electr\xf3nico resumiendo un art\xedculo y destacando los detalles t\xe9cnicos clave, o crea plantillas reutilizables para gestionar tu bandeja de entrada m\xe1s r\xe1pidamente. Deja que la IA y el dictado locales se encarguen de la lectura y la escritura, manteniendo toda la privacidad."},"powerpointBuilder":{"description":"Convierte notas, documentos y hojas de c\xe1lculo en una presentaci\xf3n de PowerPoint terminada utilizando flujos de trabajo de IA, sin necesidad de intervenci\xf3n manual.","descriptionLong":"Analiza un documento de Excel para identificar las p\xe9rdidas clave y deja que la IA transforme tus notas y datos en una presentaci\xf3n impecable. Crea presentaciones m\xe1s r\xe1pido sin tener que navegar por men\xfas ni empezar desde cero.","title":"Flujos de trabajo de IA que convierten tus notas y documentos en una presentaci\xf3n de PowerPoint terminada | Creador de PowerPoint con IA"},"socialDictation":{"description":"Publica y responde en LinkedIn, Slack y Discord usando la funci\xf3n de voz a texto, sin necesidad de escribir.","descriptionLong":"Redacta publicaciones, responde mensajes y mantente activo en LinkedIn, Slack y Discord usando solo tu voz. Mant\xe9n la conversaci\xf3n sin necesidad de usar el teclado.","title":"Conversi\xf3n de voz a texto para LinkedIn, Slack y Discord | Publica y responde sin escribir"},"developerTools":{"title":"Controles por voz + Automatizaciones de IA para desarrolladores | Escribe comentarios, documentaci\xf3n y mensajes de confirmaci\xf3n","description":"Escribe comentarios, documentos y mensajes de confirmaci\xf3n mediante comandos de voz y automatizaciones de IA, sin usar las manos.","descriptionLong":"Pregunta c\xf3mo organizar mejor el c\xf3digo en la carpeta de un proyecto y luego dicta comentarios, documentaci\xf3n y mensajes de confirmaci\xf3n sin necesidad de escribir. Mant\xe9n la concentraci\xf3n mientras los comandos de voz y la automatizaci\xf3n con IA se encargan de las tareas tediosas."},"terminalAgent":{"title":"Agente de escritorio con IA | Ejecuta compilaciones y pruebas de terminal en segundo plano mientras sigues programando.","description":"Ejecuta compilaciones, pruebas y depuraci\xf3n en segundo plano con un agente de escritorio de IA mientras sigues programando.","descriptionLong":"Haz que tu agente revise la carpeta del proyecto, lo compile, confirme que se compila correctamente y ejecute las pruebas. Si algo falla, buscar\xe1 la causa en el historial de Git y sugerir\xe1 una soluci\xf3n, todo mientras t\xfa te concentras en tu trabajo."},"gamingFPS":{"description":"Apunta, dispara, recarga y cambia de arma en juegos FPS como Valorant usando controles de voz, sin necesidad de usar las manos.","descriptionLong":"Da \xf3rdenes para disparar, recargar y cambiar de arma mientras juegas a t\xedtulos FPS como Valorant. A\xf1ade control por voz a tu configuraci\xf3n y mant\xe9n la acci\xf3n sin depender de cada tecla y bot\xf3n.","title":"Controles por voz para FPS, Valorant y m\xe1s | Apunta, dispara, recarga y cambia de arma sin usar las manos"},"gamingRPG":{"title":"Personaliza los controles de juegos de rol para Minecraft | Controles adaptativos para videojuegos","description":"Personaliza y adapta los controles de Minecraft y otros juegos de rol para que se ajusten a tu estilo de juego.","descriptionLong":"Configura controles adaptativos para Minecraft y otros juegos de rol, asignando las acciones seg\xfan tus necesidades. Crea un esquema de control que se ajuste a tu forma de jugar, en lugar de forzar tus manos a adaptarse al juego."},"educationTools":{"description":"Convierte notas y art\xedculos en herramientas de estudio y materiales did\xe1cticos utilizando inteligencia artificial integrada en el dispositivo, sin necesidad de usar las manos.","descriptionLong":"Toma un art\xedculo y crea un documento de Word con preguntas de reflexi\xf3n adaptadas al nivel de cada estudiante para apoyar una actividad de escritura creativa. Deja que la IA integrada en el dispositivo transforme tu material original en recursos did\xe1cticos listos para usar, manteniendo toda la privacidad.","title":"Transforma apuntes y art\xedculos de clase en herramientas de estudio creativas o materiales did\xe1cticos mediante IA en el dispositivo."},"meetingNotes":{"title":"Automatizaciones de IA que convierten las notas de reuniones en archivos m\xe1s peque\xf1os.","description":"Convierta las notas de las reuniones en archivos organizados y pr\xe1cticos mediante automatizaciones de IA, sin necesidad de intervenci\xf3n manual.","descriptionLong":"Revisa las notas de tus reuniones para identificar qu\xe9 tareas quedan pendientes, qui\xe9n es el responsable y d\xf3nde hay deficiencias. Deja que la IA genere un resumen de estas tareas en archivos separados y los organice en una carpeta para que puedas revisarlos todos m\xe1s tarde."},"fileManagement":{"description":"Organiza tus descargas, encuentra archivos y limpia tu PC con un agente de escritorio con IA integrado en tu dispositivo, sin necesidad de usar las manos.","descriptionLong":"P\xeddele a tu agente que copie los archivos descargados en el directorio de documentaci\xf3n del producto, o que busque archivos y organice tu PC. Mant\xe9n tu equipo organizado con inteligencia artificial integrada que protege la privacidad de tus datos.","title":"Agente de escritorio con IA en el dispositivo | Organiza tus descargas, encuentra archivos y limpia tu PC"},"dictationWriting":{"title":"Escritura manos libres y creaci\xf3n de documentos: dictado por voz, generaci\xf3n por IA y reescritura en cualquier aplicaci\xf3n.","description":"Escribe, genera y reescribe documentos sin usar las manos mediante dictado por voz e inteligencia artificial en cualquier aplicaci\xf3n.","descriptionLong":"Dicta texto, genera contenido nuevo y reescribe lo que has escrito en cualquier aplicaci\xf3n usando solo tu voz. Crea documentos de principio a fin sin tocar el teclado."},"headMouseControl":{"title":"Control de ordenador manos libres con rat\xf3n de cabeza, funci\xf3n de voz para pulsar | Controles inform\xe1ticos adaptativos","description":"Controla tu ordenador sin usar las manos gracias al seguimiento de la cabeza y a los controles adaptativos Talk to Tap.","descriptionLong":"Mueve el cursor con el seguimiento de la cabeza y haz clic con la funci\xf3n Talk to Tap para navegar por tu ordenador sin usar las manos. Configura controles adaptativos que te permitan trabajar de la forma que mejor se ajuste a ti."},"documentTranslation":{"title":"Traducci\xf3n de documentos con IA para cualquier persona que trabaje con varios idiomas: espa\xf1ol, \xe1rabe, portugu\xe9s y m\xe1s.","description":"Traduce documentos a trav\xe9s de idiomas como espa\xf1ol, \xe1rabe y portugu\xe9s usando inteligencia artificial, sin necesidad de usar las manos.","descriptionLong":"Traduce tus documentos al espa\xf1ol, \xe1rabe, portugu\xe9s y otros idiomas con la IA integrada en tu dispositivo. Trabaja con confianza en diferentes idiomas sin cambiar de herramienta ni copiar texto entre aplicaciones."},"websiteRedesign":{"description":"Investiga a la competencia y obt\xe9n sugerencias para redise\xf1ar tu sitio web usando IA, sin necesidad de intervenci\xf3n manual.","descriptionLong":"Dirige la IA al sitio web de SafeDrive Auto Insurance y luego haz que investigue los sitios de la competencia para detectar las diferencias. Obt\xe9n sugerencias concretas para modernizar un sitio obsoleto basadas en estudios de mercado reales.","title":"Investigaci\xf3n web privada con IA + automatizaciones | Navegar, analizar y crear HTML"},"dataPrivacyResearch":{"description":"Investigue las \xfaltimas leyes de privacidad de datos y convierta los hallazgos en acciones de seguimiento para el cumplimiento normativo, sin necesidad de intervenci\xf3n manual.","descriptionLong":"Investiga las leyes de privacidad de datos m\xe1s recientes de 2026 y sus diferencias con las de 2025, y luego identifica las medidas que las empresas deben implementar. Utiliza IA para redactar un correo electr\xf3nico de seguimiento con ejemplos que te ayuden a cumplir con la normativa.","title":"Navega, analiza y resume sin que tus datos salgan de tu dispositivo | Investigaci\xf3n web privada con IA"}},"control":{"title":"Control.","subtitle":"Tu software. Tus datos de entrada. Tus reglas.","description":"Comandos de voz, atajos de teclado y botones de acci\xf3n r\xe1pida: funcionan en todas las aplicaciones de tu dispositivo. No necesitas rat\xf3n. No necesitas programar nada. No necesitas configurar nada para las cientos de aplicaciones que ya usas.","titleAlt":"Control"},"create":{"title":"Crear.","subtitle":"Tus palabras. Tus borradores. Tu m\xe1quina.","description":"Redacta, reescribe, reformatea y traduce, directamente en la aplicaci\xf3n en la que trabajas. Sin la nube. Sin copiar y pegar en otra herramienta. Sin borradores que entrenen el modelo de otra persona.","titleAlt":"Crear"},"automate":{"title":"Automatizar.","subtitle":"Una frase. Cada paso. Hecho.","description":"Describe una tarea en lenguaje sencillo y Cephable la ejecuta. En todas tus aplicaciones, archivos e incluso en la l\xednea de comandos. Se ejecuta mientras haces otras cosas y nada sale de tu m\xe1quina.","titleAlt":"Automatizar"},"upgrade":{"subtitle":{"trial":"Durante los pr\xf3ximos {{days}} d\xedas, mis funciones de IA estar\xe1n desbloqueadas: Crear y Automatizar, ambas funcionando en un mismo dispositivo. Act\xedvalas cuando quieras.","orgGeneric":"Tu organizaci\xf3n ha desbloqueado mis funciones de IA: Crear y Automatizar, ambas funcionando en un \xfanico dispositivo. Act\xedvalas cuando quieras.","org":"Te hemos a\xf1adido a la organizaci\xf3n {{organization}}, lo que desbloquea mis funciones de IA: Crear y Automatizar, ambas funcionando en un mismo dispositivo. Act\xedvalas cuando quieras."},"badge":{"trial":"El juicio termina en","trialDays_one":"{{count}} d\xeda","trialDays_other":"{{count}} d\xedas","org":"Desbloqueado por","orgGeneric":"Licencia de organizaci\xf3n"},"setup":{"eyebrow":"Configura tus funciones Pro","title":"Elige qu\xe9 encender","description":"Puedes modificar cualquiera de estas opciones m\xe1s adelante en Ajustes. Todo se ejecuta en el dispositivo: tus palabras y archivos permanecen contigo."},"enable":{"title":"Habilitar funciones de IA","description":"Un solo interruptor activa tanto Crear como Automatizar. Ambas funcionan con el modelo compartido en el dispositivo; no se requiere una configuraci\xf3n independiente para cada una.","model":{"label":"Modelo de IA en el dispositivo","tag":"Motor compartido","description":"Permite tanto la creaci\xf3n como la automatizaci\xf3n. Los modelos m\xe1s grandes ofrecen mejores resultados, pero consumen m\xe1s recursos; se descarga y ejecuta completamente en este dispositivo."}},"create":{"title":"Crear","description":"Generaci\xf3n inteligente de texto y dictado. Redactar\xe9 correos electr\xf3nicos, documentos, c\xf3digo y contenido creativo, y convertir\xe9 tu voz en texto formateado para cualquier aplicaci\xf3n.","locked":"Habilita las funciones de IA que aparecen arriba y Create estar\xe1 listo para usar."},"automate":{"title":"Automatizar","description":"Flujos de trabajo de IA. Describe una tarea en una sola frase y yo planificar\xe9 y llevar\xe9 a cabo cada paso: leer\xe9, escribir\xe9 y ejecutar\xe9 comandos en tu nombre.","locked":"Habilita las funciones de IA mencionadas anteriormente y Automate estar\xe1 listo para usar."},"status":{"on":"En","off":"No funciona"},"footer":"Todo se ejecuta en el dispositivo. Nada de lo que crees o automatices sale de tu m\xe1quina.","cta":{"eyebrow":"Puedes activar la IA en cualquier momento.","title":"Veamos c\xf3mo funciona en tus aplicaciones.","action":"M\xedrame en acci\xf3n","back":"Atr\xe1s"},"pill":"{{licencia}} Desbloqueado","title":"Se te ha actualizado a {{license}}."}}');


var $8adc0445bd2a69d3$exports = {};
$8adc0445bd2a69d3$exports = JSON.parse('{"logo":"Logo c\xe9phable","add":"Ajouter","all":"Tous","edit":"Modifier","create":"Cr\xe9er","delete":"Supprimer","next":"Suivant","previous":"Pr\xe9c\xe9dent","search":"Recherche","loading":"Chargement...","reload":"Recharger","cancel":"Annuler","copy":"Copie","save":"Sauvegarder","saveAndFinish":"Enregistrer et terminer","saveAndContinue":"Sauvegarder et continuer","saved":"Enregistr\xe9","done":"Fait","back":"Dos","play":"Jouer","pause":"Pause","success":"Succ\xe8s","continue":"Continuer","options":"Possibilit\xe9s","share":"Partager","finish":"Finition","finishEdit":"Terminer Modifier","advancedOptions":"Afficher les options avanc\xe9es","authenticating":"Authentification...","skip":"Sauter","close":"Fermer","notFound":"Page non trouv\xe9e","notFoundDescription":"Ah non ! Nous avons fouill\xe9 la mer et nous ne trouvons pas votre page\xa0!","exitSetup":"Quitter la configuration","experimental":"Exp\xe9rimental","letGetStarted":"Commen\xe7ons!","exploreInputControls":"Explorer les contr\xf4les de saisie","when":"Quand je ...","thenMacro":"Cephable fonctionnera...","controls":"Contr\xf4les","welcome":"Accueillir.","beta":"b\xeata","macroEmpty":"Aucune macro ne correspond \xe0 ces crit\xe8res.","you":"Toi","step":"\xc9tape","steps":"Pas","learnMore":"Apprendre encore plus","dangerZone":"Zone dangereuse","connected":"Connect\xe9","notConnected":"Pas connect\xe9","connectAndLearn":"Connectez-vous et apprenez","tryAgain":"Essayer \xe0 nouveau","by":"Par\xa0: {{value}}","noName":"- sans nom -","details":"D\xe9tails","controlFeed":"Alimentation de contr\xf4le","wifi":{"disconnected":"Le Wi-Fi est d\xe9connect\xe9.","connected":"Le Wi-Fi est connect\xe9.","description":"Connectez-vous au Wi-Fi pour permettre \xe0 Cephable de fonctionner avec vos connexions et logiciels. Vos capacit\xe9s d\'utilisation actuelles peuvent \xeatre limit\xe9es."},"signalR":{"disconnected":"La synchronisation est d\xe9connect\xe9e.","action":"Reconnecter","description":"Il semble y avoir un probl\xe8me de synchronisation avec Cephable. Cela pourrait entra\xeener des probl\xe8mes d\'enregistrement de vos param\xe8tres ou de communication avec d\'autres connexions.","disconnectedDevice":"Impossible de synchroniser avec {{name}}.","disconnectedDeviceDescription":"Il semble y avoir un probl\xe8me de synchronisation, probablement li\xe9 \xe0 l\'authentification ou \xe0 la connexion Internet. L\'envoi et la r\xe9ception de donn\xe9es \xe0 distance sont impossibles. Veuillez v\xe9rifier la connexion des deux c\xf4t\xe9s.","connected":"La synchronisation est \xe9tablie.","connectedDescription":"Cephable se synchronise correctement et devrait communiquer avec vos connexions et extensions comme pr\xe9vu.","swap":"Basculer vers la connexion \xe0 l\'appareil local","unlinkedDevice":"Connexion supprim\xe9e.","unlinkedDeviceDescription":"Cette connexion a \xe9t\xe9 dissoci\xe9e de votre compte.","featureRestricted":"Les fonctionnalit\xe9s Cr\xe9er et Automatiser ne sont pas disponibles pour les connexions \xe0 distance.","featureRestrictedDescription":"Cette fonctionnalit\xe9 n\'est actuellement pas disponible pour les connexions \xe0 distance. Veuillez utiliser la connexion \xe0 votre appareil local pour b\xe9n\xe9ficier de toutes les possibilit\xe9s de cr\xe9ation et d\'automatisation de vos t\xe2ches."},"billing":{"title":"Facturation","expires":"Prochaine facturation\xa0: {{value}}","isEmployeeAccess":{"title":"Professionnel","titleLong":"C\xe9phable Professionnel","short":"Pro","description":"Cephable Professional offre aux utilisateurs plus de puissance de productivit\xe9, en \xe9tendant l\'IA locale et priv\xe9e aux capacit\xe9s g\xe9n\xe9ratives.","supportedFeatures":{"tag":"Tout en Plus, plus","features":["Flux de travail d\'IA embarqu\xe9s","Gestion de l\'organisation d\'entreprise","Restrictions d\'entreprise","Installations illimit\xe9es sur les appareils","Commandes d\'application pr\xe9-entra\xeen\xe9es illimit\xe9es"]}},"isDeveloperAccess":{"title":"Kit de d\xe9veloppement logiciel (SDK)","titleLong":"Kit de d\xe9veloppement logiciel (SDK) Cephable","short":"SDK","description":"Les SDK Cephable vous permettent d\'int\xe9grer de puissants contr\xf4les adaptatifs (voix, visage, t\xeate, etc.) dans votre logiciel avec un minimum d\'effort et un gain maximal.","supportedFeatures":{"tag":"Tout en Plus, plus","features":["Prise en charge de Windows et MacOS","SDK l\xe9gers et int\xe9grables pour la saisie hors ligne de la voix, du visage, de la t\xeate et des actions rapides","Prise en charge API/webhook pour les actions de sortie personnalis\xe9es","Documentation du d\xe9veloppeur","Exemples de projets","Transformez les commandes en automatisation et navigation de documents","Portail des d\xe9veloppeurs pour g\xe9rer vos projets, vos clients d\'authentification, vos types d\'appareils, etc."]}},"isStudentAccess":{"title":"\xc9tudiant","titleLong":"\xc9ducation C\xe9phable","short":"\xc9ducation","description":"Cephable Education favorise l\'apprentissage personnalis\xe9 et les classes inclusives. Cephable fonctionne hors ligne, sur appareil et ne n\xe9cessite aucune int\xe9gration tierce.","supportedFeatures":{"tag":"Tout en Plus, plus","features":["Installations d\'appareils illimit\xe9es","Contr\xf4les d\'application pr\xe9-entra\xeen\xe9s illimit\xe9s","Partage illimit\xe9 des contr\xf4les d\'application personnalis\xe9s"]}},"viewProducts":"Voir les produits","description":"G\xe9rez la facturation de votre organisation, les si\xe8ges, les mises \xe0 niveau d\'abonnement, le renouvellement ou l\'annulation.","view":"G\xe9rer la facturation","isResellerAccess":{"title":"Revendeur","titleLong":"Revendeur Cephable","description":"Cephable Reseller est une licence payante qui vous permet de cr\xe9er de nouvelles organisations et d\'attribuer des cl\xe9s de licence. Cela inclut l\'utilisation de Cephable avec votre propre suite logicielle et l\'am\xe9lioration de votre exp\xe9rience utilisateur.","short":"Revendeur"},"error":"Veuillez contacter votre administrateur syst\xe8me pour g\xe9rer votre facturation.","included":"Inclus avec votre licence {{licenseType}}.","upgrade":{"description":"Effectuez une mise \xe0 niveau maintenant et faites passer vos commandes au niveau sup\xe9rieur.","action":"Mettre \xe0 niveau maintenant","error":"Erreur lors de la mise \xe0 jour. Veuillez r\xe9essayer ult\xe9rieurement.","requiredDetail":"Une licence {{licenseType}} est requise pour cette fonctionnalit\xe9. Vous pouvez passer \xe0 une version sup\xe9rieure ou d\xe9marrer un essai gratuit dans les param\xe8tres de votre compte.","enableTextGeneration":"G\xe9n\xe9rez du contenu en utilisant l\'IA et votre voix.","longDescription":"Passez \xe0 une licence payante pour acc\xe9der \xe0 toutes les fonctionnalit\xe9s de Cephable. Des appareils multiples aux commandes avanc\xe9es en passant par les int\xe9grations personnalis\xe9es, Cephable vous offre tout ce dont vous avez besoin pour atteindre un niveau de productivit\xe9 sup\xe9rieur.","compare":"Comparer les plans","enableAiDictation":{"title":"Passez \xe0 la dict\xe9e intelligente","description":"Effectuez une mise \xe0 niveau pour d\xe9bloquer la dict\xe9e am\xe9lior\xe9e par l\'IA. Je peux ajouter de la ponctuation, corriger les majuscules et m\'adapter \xe0 votre style pour une \xe9criture soign\xe9e sans effort suppl\xe9mentaire."},"enableAiWorkflows":"Passez \xe0 la version sup\xe9rieure pour automatiser vos t\xe2ches de bureau et de navigateur gr\xe2ce aux flux de travail d\'IA."},"isPlusAccess":{"title":"Plus","titleLong":"Cephable Plus","short":"Plus","description":"Cephable Plus est destin\xe9 aux utilisateurs exp\xe9riment\xe9s qui souhaitent aller plus loin avec une voix intelligente, une dict\xe9e intelligente, des centaines de commandes d\'applications et bien plus encore.","supportedFeatures":{"tag":"Tout dans Basic, plus","features":["Commandes vocales intelligentes (langage naturel)","Dict\xe9e intelligente (am\xe9lior\xe9e par l\'IA)","T\xe2ches intelligentes (G\xe9n\xe9ration, Traduction, R\xe9\xe9criture)","Des centaines de commandes d\'application pr\xe9-entra\xeen\xe9es"]}},"personal":{"short":"Basique","title":"Basique","titleLong":"C\xe9phable Basic","description":"Cephable Basic est gratuit \xe0 vie et con\xe7u pour vous aider \xe0 progresser plus rapidement, \xe0 vous exprimer et \xe0 accomplir vos t\xe2ches \xe0 votre fa\xe7on. Les fonctionnalit\xe9s incluses dans la version Basic sont accessibles \xe0 tous les utilisateurs.","upgrade":{"title":"Passez au niveau sup\xe9rieur en mati\xe8re de contr\xf4le","description":"Passez \xe0 la version Plus ou Pro pour d\xe9bloquer toutes mes fonctionnalit\xe9s. Plus de pr\xe9cision. Plus de connexions. Plus de contr\xf4le. Plus de puissance pour booster votre productivit\xe9.","featureHeading":"Voici comment je peux vous aider :","control":"Je vous guide plus rapidement entre les applications et les outils gr\xe2ce \xe0 votre voix ou \xe0 des actions rapides, sans interruption. Avec la Voix Intelligente, nous pouvons simplement discuter.","create":"Je r\xe9\xe9cris, dicte, g\xe9n\xe8re et traduis directement dans vos applications \u2014 sans copier, coller ni changer d\'\xe9cran.","automate":"J\'ex\xe9cute des t\xe2ches intelligentes et des actions rapides pour optimiser votre flux de travail. Des commandes simples aux macros complexes, je prends en charge les t\xe2ches fastidieuses pour que vous puissiez vous concentrer sur l\'essentiel.","local":"Intelligence artificielle enti\xe8rement locale. Aucun traitement dans le cloud."}},"mostPopular":"Le plus populaire","subscription":{"options":"Options d\'abonnement","monthly":"Payer mensuellement","billedMonthly":"/mois","yearly":"Paiement annuel","billedYearly":"/ann\xe9e"}},"organization":{"title":"Organisation","titlePlural":"Organisations","titleLong":"Professionnel c\xe9phable pour les organisations","description":"Les organisations sont des groupes d\'utilisateurs qui peuvent collaborer sur des projets et partager des ressources. Vous pouvez g\xe9rer votre \xe9quipe, les profils d\u2019\xe9quipe, la facturation et bien plus encore ici.","noAccess":{"title":"Acc\xe8s refus\xe9.","description":"Vos autorisations ont r\xe9cemment chang\xe9 et vous n\'avez plus acc\xe8s \xe0 cette fonctionnalit\xe9. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter l\'administrateur de votre organisation."},"member":{"title":"Membre","titlePlural":"Membres","me":"Mon adh\xe9sion","description":"Les membres sont des utilisateurs qui font partie de votre organisation. Ils peuvent \xeatre affect\xe9s \xe0 diff\xe9rents r\xf4les et avoir acc\xe8s \xe0 diff\xe9rentes parties de l\u2019organisation.","edit":"Modifier les membres","removed":"Vous avez \xe9t\xe9 supprim\xe9 d\'une \xe9quipe.","removedDescription":"Vous avez \xe9t\xe9 retir\xe9 de l\'\xe9quipe. Vous ne pouvez plus acc\xe9der \xe0 l\'organisation. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter l\'administrateur de votre organisation.","updated":"Bravo, l\'adh\xe9sion de {{value}} a \xe9t\xe9 mise \xe0 jour.","error":"Erreur lors de la mise \xe0 jour de l\'adh\xe9sion de {{value}}.","delete":"Succ\xe8s, {{value}} a \xe9t\xe9 supprim\xe9.","deleteError":"Erreur lors de la suppression de {{value}}.","deleteConfirmation":{"title":"Etes-vous s\xfbr de vouloir supprimer ce membre ?","description":"Une fois ce membre supprim\xe9, il n\'aura plus acc\xe8s \xe0 l\'organisation. Vous pourrez toujours le r\xe9inviter plus tard.","confirm":"Oui, supprimer le membre"},"viewAll":{"title":"Voir tous les membres","description":"Affichez tous les membres de votre organisation et g\xe9rez leurs r\xf4les et autorisations."},"seats":{"title":"Si\xe8ges des membres","description":"Chaque membre de votre organisation dispose d\'un si\xe8ge. Le type d\'autorisations dont ils disposent peut \xeatre modifi\xe9 par l\'administrateur de l\'organisation.","stats":"si\xe8ges sur {{value}}","max":"Nombre de places max.","current":"Si\xe8ges actuels","limit":{"title":"Nombre maximal de si\xe8ges atteint","description":"Votre forfait actuel a atteint sa limite de {{ maxSeats }} si\xe8ges disponibles. Vous ne pouvez pas inviter de membres suppl\xe9mentaires. Veuillez contacter votre administrateur pour mettre \xe0 niveau le forfait ou g\xe9rer votre attribution de si\xe8ges."},"updateLimit":{"title":"Mettez \xe0 niveau votre forfait pour ajouter plus de si\xe8ges","description":"Votre forfait actuel a atteint le nombre maximal de si\xe8ges\xa0: {{ maxSeats }}. Effectuez une mise \xe0 niveau d\xe8s maintenant pour d\xe9bloquer des si\xe8ges suppl\xe9mentaires et garantir que votre \xe9quipe puisse continuer \xe0 se d\xe9velopper en toute transparence.","action":"Plan de mise \xe0 niveau"},"maxSeatValue":"Nombre maximal de si\xe8ges\xa0: {{value}}"},"aboutMe":"Sur moi","loadError":"Erreur lors du chargement des membres de l\'organisation.","orgTitle":"Membres de {{value}} ","emailExists":"L\'e-mail existe d\xe9j\xe0 dans l\'organisation. Veuillez saisir une autre adresse e-mail."},"invite":{"title":"Inviter","titlePlural":"Invitations","description":"Des invitations sont envoy\xe9es aux utilisateurs pour qu\'ils rejoignent votre organisation. Vous pouvez inviter des utilisateurs \xe0 rejoindre votre organisation et leur attribuer diff\xe9rents r\xf4les.","edit":"Cr\xe9er une nouvelle invitation","view":"Afficher toutes les invitations","emailRequired":"L\'e-mail est requis","emailInvalid":"Le courriel est invalide. S\'il vous pla\xeet, mettez une adresse email valide.","emailExists":"L\'e-mail dispose d\xe9j\xe0 d\'une invitation d\'organisation. Veuillez saisir une autre adresse e-mail.","emailPlaceholder":"Entrer l\'adresse e-mail","expiration":"Expire ","delete":"Supprimer l\'invitation","confirm":"\xcates-vous s\xfbr de vouloir supprimer cette invitation\xa0?","confirmLong":"Une fois cette invitation supprim\xe9e, l\'utilisateur ne pourra plus rejoindre l\'organisation. Vous pourrez toujours les r\xe9inviter plus tard.","accept":"Accepter l\'invitation","acceptSuccess":{"title":"Bienvenue dans l\'\xe9quipe.","description":"Vous avez rejoint l\'organisation avec succ\xe8s. ","action":"Afficher votre nouvelle organisation"},"acceptError":{"title":"Oops. On dirait qu\'il y a un probl\xe8me.","description":"Une erreur s\'est produite lors de l\'adh\xe9sion \xe0 l\'organisation. Veuillez r\xe9essayer plus tard. Si le probl\xe8me persiste, veuillez contacter l\'administrateur de votre organisation. ","action":"Retour \xe0 la page d\'accueil"},"send":{"success":"Invitation \xe0 {{value}} envoy\xe9e.","error":"Erreur lors de l\'envoi de l\'invitation \xe0 {{value}}.","title":"Envoyer une invitation"},"viewDescription":"Voir toutes les invitations actuelles qui n\'ont pas \xe9t\xe9 accept\xe9es.","new":"Inviter un membre","stat":"invitations actives","noInvites":{"title":"Aucune invitation.","description":"Il semble qu\'il n\'y ait aucune invitation active pour votre organisation."},"error":"Erreur lors du chargement des invitations.","orgTitle":"Invitations de {{ value }}","editDescription":"Cr\xe9ez une nouvelle invitation pour qu\'un utilisateur rejoigne votre organisation.","scimManaged":{"title":"Les membres sont g\xe9r\xe9s par votre fournisseur d\'identit\xe9.","description":"Cette organisation utilise l\'approvisionnement automatique (SCIM)\xa0; les membres sont donc g\xe9r\xe9s par votre syst\xe8me d\'identit\xe9 interne. Toute modification apport\xe9e \xe0 un membre est automatiquement synchronis\xe9e avec Cephable\xa0; il est impossible d\'envoyer des invitations depuis le portail."}},"role":{"title":"R\xf4le","titlePlural":"Les r\xf4les","description":"Les r\xf4les correspondent aux diff\xe9rents niveaux d\'acc\xe8s dont un utilisateur peut disposer dans votre organisation. Vous pouvez attribuer diff\xe9rents r\xf4les aux utilisateurs pour contr\xf4ler ce qu\'ils peuvent faire."},"isAdmin":{"title":"Administrateur","description":"Les administrateurs ont un acc\xe8s complet \xe0 l\'organisation et peuvent g\xe9rer tous les aspects de l\'organisation.","conflict":"Ce membre est un administrateur. Vous n\'\xeates pas autoris\xe9 \xe0 modifier leurs r\xf4les."},"canViewMembers":{"title":"Afficher les membres","description":"Les utilisateurs disposant de cette autorisation peuvent voir tous les membres de l\'organisation."},"canInviteMembers":{"title":"Inviter des membres","description":"Les utilisateurs disposant de cette autorisation peuvent inviter de nouveaux membres dans l\'organisation et g\xe9rer les invitations existantes."},"canChangeMemberPermissions":{"title":"Modifier les r\xf4les des membres","description":"Les utilisateurs disposant de cette autorisation peuvent modifier le r\xf4le des autres membres de l\'organisation."},"canRemoveMembers":{"title":"Supprimer des membres","titleSingle":"Supprimer un membre","action":"Retirer","description":"Les utilisateurs disposant de cette autorisation peuvent supprimer d\'autres membres de l\'organisation.","confirm":"\xcates-vous s\xfbr de vouloir supprimer ce membre de l\'organisation?","confirmLong":"Une fois que vous aurez supprim\xe9 ce membre, il n\u2019aura plus acc\xe8s \xe0 l\u2019organisation. Vous pourrez toujours les r\xe9inviter plus tard."},"canCreateAuthClients":{"title":"Cr\xe9er des clients d\'authentification","description":"Les utilisateurs disposant de cette autorisation peuvent cr\xe9er de nouveaux clients d\'authentification pour l\'organisation."},"canManageBilling":{"title":"G\xe9rer la facturation","description":"Les utilisateurs disposant de cette autorisation peuvent g\xe9rer les param\xe8tres de facturation de l\'organisation.","error":"Vous n\'\xeates pas autoris\xe9 \xe0 g\xe9rer la facturation de cette organisation."},"metrics":{"lineChart":{"title":"Connexions Simultan\xe9es Moyennes","description":"Ce graphique montre les connexions simultan\xe9es moyennes pour l\'organisation et les donn\xe9es du projet au fil du temps.","max":"Connexions Max: {{maxConnections}}","project":"Total du Projet","org":"Organisation Total"},"title":"M\xe9trique","description":"Les m\xe9triques sont des points de donn\xe9es qui vous aident \xe0 comprendre comment votre organisation utilise Cephable.","view":"Afficher les m\xe9triques","orgTitle":"M\xe9triques de {{ valeur }}","manage":{"title":"Indicateurs de performance","description":"T\xe9l\xe9chargez ou effacez les mesures de performances collect\xe9es lors de l\u2019inf\xe9rence du mod\xe8le."},"download":{"button":"T\xe9l\xe9charger les m\xe9triques","success":"Le fichier de m\xe9triques a \xe9t\xe9 enregistr\xe9 dans votre dossier T\xe9l\xe9chargements.","error":"\xc9chec du t\xe9l\xe9chargement du fichier de m\xe9triques.","noFile":"Aucun fichier de m\xe9triques trouv\xe9. Essayez d\'abord d\'ex\xe9cuter le mod\xe8le."},"clear":{"button":"Des indicateurs clairs","success":"Les m\xe9triques ont \xe9t\xe9 effac\xe9es.","error":"\xc9chec de l\'effacement du fichier de m\xe9triques.","confirm":{"title":"Indicateurs de performance clairs","description":"Voulez-vous vraiment effacer tous les indicateurs de performance enregistr\xe9s\xa0? Cette action est irr\xe9versible.","cancel":"Annuler","confirm":"Des indicateurs clairs"}}},"noOrg":{"title":"Aucune licence associ\xe9e.","description":"Vous n\'\xeates actuellement associ\xe9 \xe0 aucune licence ni \xe0 aucun groupe de d\xe9veloppeurs. L\'acc\xe8s au portail est r\xe9serv\xe9 aux utilisateurs disposant d\'une licence Cephable payante. Pour exploiter pleinement le potentiel de Cephable, commencez un essai gratuit."},"projects":{"title":"Projets","description":"Utilisez des projets pour g\xe9rer l\'acc\xe8s s\xe9curis\xe9, configurer les interactions des appareils et rationaliser la mani\xe8re dont vos applications envoient et re\xe7oivent des commandes sur diff\xe9rentes plates-formes.","name":"Nom de l\'application","stats":{"title":"Statistiques du projet","connections":"Connexions totales","all":{"title":"Toutes les mesures du projet","description":"M\xe9triques agr\xe9g\xe9es pour tous les projets associ\xe9s \xe0 {{ orgName }}"},"card":"projets sur {{value}}","users":"nombre total d\'utilisateurs depuis {{date}}","avgUsers":"Nombre moyen mensuel d\'utilisateurs.","concurrent":{"title":"Nombre moyen de connexions simultan\xe9es au cours des {{days}} derniers jours","label":"Moy. simultan\xe9e","max":"Connexions maximales","overage":"Exc\xe9dent","description":"Les connexions simultan\xe9es correspondent au nombre d\'utilisateurs connect\xe9s \xe0 votre projet en m\xeame temps. Cette mesure vous aide \xe0 comprendre combien d\'utilisateurs utilisent votre application simultan\xe9ment."}},"projectType":{"title":"Type de projet","description":"Les types de projets sont utilis\xe9s pour cat\xe9goriser vos projets et nous aider \xe0 choisir les SDK qui vous conviennent."},"accessDenied":{"generic":"Vous n\'avez pas acc\xe8s \xe0 ce projet.","title":"Acc\xe8s refus\xe9.","description":"Vous n\'avez pas acc\xe8s aux projets pour les consulter, les cr\xe9er, les modifier ou les supprimer. Veuillez contacter votre administrateur pour y acc\xe9der."},"upgrade":{"title":"Mise \xe0 niveau vers le SDK Cephable","description":"Cephable peut \xeatre int\xe9gr\xe9 directement dans votre application, jeu ou service \xe0 l\'aide de nos SDK. Les projets ne sont actuellement pas disponibles avec votre compte. Si vous pensez qu\'il y a une erreur, veuillez contacter support@cephable.com.","shortDescription":"Les projets ne sont actuellement pas disponibles avec votre compte. Contactez-nous pour effectuer une mise \xe0 niveau."},"limit":{"title":"Vous voulez plus de projets ?","error":"Limite du projet atteinte.","description":"Vous avez atteint le nombre maximum de projets pour votre organisation. Veuillez contacter votre administrateur pour mettre \xe0 niveau votre compte."},"create":{"title":"Cr\xe9er un projet","titleLong":"Commen\xe7ons.","first":{"title":"D\xe9marrez votre projet.","description":"Il semble que vous n\'ayez pas encore cr\xe9\xe9 de projet. Les cl\xe9s et les appareils clients sont essentiels pour s\xe9curiser la communication entre vos applications et nos services. Avec une cl\xe9 client, vous pourrez int\xe9grer les commandes vocales et de mouvement de la t\xeate dans vos applications rapidement et en toute s\xe9curit\xe9."},"details":{"title":"D\xe9tails du projet","description":"Cr\xe9ez un nouveau projet pour g\xe9rer l\'autorisation de votre application, les fonctionnalit\xe9s de votre appareil et les int\xe9grations SDK. Suivez les \xe9tapes ci-dessous pour configurer des interactions s\xe9curis\xe9es et personnalisables pour vos utilisateurs."}},"sdk":{"title":"T\xe9l\xe9charger le SDK","description":"Acc\xe9dez \xe0 notre puissant SDK d\xe9velopp\xe9 pour faciliter les contr\xf4les adaptatifs.","select":{"title":"S\xe9lectionner le SDK","description":"S\xe9lectionnez le SDK que vous souhaitez utiliser pour ce projet. Nos SDK permettent une int\xe9gration transparente des commandes adaptatives de voix et de mouvement de la t\xeate sur diff\xe9rentes plateformes."}},"clients":{"title":"Autorisation des clients","description":"Les clients d\'autorisation g\xe8rent l\'acc\xe8s s\xe9curis\xe9 \xe0 vos applications. D\xe9finissez un client d\'autorisation pour authentifier les utilisateurs et contr\xf4ler les interactions avec votre application.","settings":"Param\xe8tres d\'autorisation","configure":"Configurer le client d\'autorisation","create":"Cr\xe9er un client d\'autorisation","max":"Projets max\xa0: {{value}}"},"secret":{"title":"Secret du client","created":"Votre secret client a \xe9t\xe9 cr\xe9\xe9.","description":"Votre secret client ne sera affich\xe9 qu\'une seule fois. Copiez-le maintenant et stockez-le dans un endroit s\xfbr et s\xe9curis\xe9. <br> <br> Utilisez-le uniquement pour votre propre d\xe9veloppement. Ne le partagez pas avec des services ou des applications tiers.","copy":"Copie secr\xe8te","rotate":{"title":"Faire pivoter le secret client","description":"AVERTISSEMENT\xa0: cette action r\xe9voquera votre secret client existant et cr\xe9era un nouveau secret client. Cela vous obligera \xe0 mettre \xe0 jour toutes vos utilisations existantes dans toutes vos applications. Cette action ne peut pas \xeatre annul\xe9e.","error":"Erreur lors de la rotation du secret. Veuillez r\xe9essayer plus tard."}},"key":{"title":"Cl\xe9 client","view":"Afficher la cl\xe9 client","delete":{"title":"Supprimer la cl\xe9 client","description":"AVERTISSEMENT\xa0: cette action supprimera votre cl\xe9 client existante et tous les param\xe8tres associ\xe9s. Cette action ne peut pas \xeatre annul\xe9e.","error":"Erreur lors de la suppression de votre cl\xe9 client.","success":"Votre projet a \xe9t\xe9 supprim\xe9."},"copy":"Copier la cl\xe9"},"tokenRedirect":{"title":"URL de redirection de jeton","description":"Les URL de redirection de jetons sont les points de terminaison o\xf9 les jetons d\'acc\xe8s sont envoy\xe9s une fois l\'authentification termin\xe9e. Ces URL permettent \xe0 votre application de recevoir en toute s\xe9curit\xe9 les jetons n\xe9cessaires pour acc\xe9der aux donn\xe9es et services utilisateur."},"authRedirect":{"title":"URL de redirection du code d\'autorisation","description":"L\'URL de redirection AuthCode est le point de terminaison o\xf9 les codes d\'autorisation sont envoy\xe9s apr\xe8s qu\'un utilisateur a accord\xe9 l\'autorisation \xe0 votre application. Cette URL est essentielle dans les flux OAuth, car elle garantit la transmission s\xe9curis\xe9e du code d\'autorisation du serveur d\'autorisation \xe0 votre application, vous permettant ainsi de demander des jetons d\'acc\xe8s au nom de l\'utilisateur."},"scopes":{"title":"Port\xe9es","titleLong":"Port\xe9es des autorisations API","configure":"D\xe9finir les p\xe9rim\xe8tres","description":"Les port\xe9es d\xe9finissent les autorisations dont disposera ce client d\'autorisation. D\xe9finissez des port\xe9es pour limiter l\'acc\xe8s \xe0 des donn\xe9es et fonctionnalit\xe9s sp\xe9cifiques, en veillant \xe0 ce que les utilisateurs n\'obtiennent que l\'acc\xe8s dont ils ont besoin.","manage":"G\xe9rer les port\xe9es d\'autorisation"},"deviceScopes":{"title":"Types d\'appareils associ\xe9s","titleLong":"Types d\'appareils autoris\xe9s","action":"Ajouter un nouveau type d\'appareil","configure":"Configurer les types d\'appareils autoris\xe9s","descriptionShort":"D\xe9finissez quel type d\u2019appareils peuvent acc\xe9der \xe0 ce projet.","titles":"Types d\'appareils associ\xe9s","description":"Le type d\'appareil d\xe9finit les autorisations et les niveaux d\'acc\xe8s dont dispose un appareil dans votre application. En attribuant des types d\'appareils sp\xe9cifiques, vous pouvez contr\xf4ler les actions et les donn\xe9es auxquelles chaque appareil peut acc\xe9der, garantissant ainsi que votre application reste s\xe9curis\xe9e et conforme \xe0 vos politiques de confidentialit\xe9."},"deviceType":{"title":"Types d\'appareils","description":"Un DeviceType d\xe9finit une cat\xe9gorie d\'appareils, d\xe9taillant leurs capacit\xe9s d\'entr\xe9e/sortie et les fonctionnalit\xe9s prises en charge (par exemple, la voix, les gestes, les types de contr\xf4leur). Il garantit que seuls les appareils autoris\xe9s peuvent interagir avec une application, permettant un acc\xe8s limit\xe9 via des configurations d\'appareils sp\xe9cifiques, telles que Xbox ou PlayStation.","action":"Cr\xe9er un type d\'appareil","name":"Nom du type d\'appareil","descriptionLong":"Description du type d\'appareil","features":{"title":"Fonctionnalit\xe9s prises en charge","description":"D\xe9finissez les entr\xe9es et les sorties prises en charge par votre application. Cela nous aide \xe0 optimiser l\'exp\xe9rience utilisateur sur Cephable.","supportsVoiceInput":"Saisie vocale","supportsPhysicalInput":"Entr\xe9e physique","supportsKeyboardOutput":"Sortie clavier","supportsPlayStationControllerOutput":"Manette PlayStation","supportsFaceInput":"Saisie faciale","supportsGestureInput":"Saisie gestuelle","supportsXboxControllerOutput":"Manette Xbox","supportsDigitalExtensions":"Extensions num\xe9riques","supportsPhysicalExtensions":"Extensions physiques","supportsNintendoControllerOutput":"Manette Nintendo","supportsGenericControllerOutput":"Sortie du contr\xf4leur g\xe9n\xe9rique"},"canAutoStart":{"title":"Prend en charge les d\xe9marrages \xe0 contr\xf4le automatique","description":"[canAutoStart] si activ\xe9, le SDK v\xe9rifiera les param\xe8tres utilisateur et tentera de d\xe9marrer imm\xe9diatement les commandes de la cam\xe9ra ou du microphone apr\xe8s la connexion de l\'utilisateur."},"isSupported":{"title":"Actif","description":"[isSupported] Si cette option est d\xe9sactiv\xe9e, Cephable n\'enverra, ne recevra et n\'accusera r\xe9ception d\'aucun appareil utilisateur associ\xe9 \xe0 cette option. \xc9quivalent \xe0 obsol\xe8te."},"locale":{"title":"Langue par d\xe9faut","description":"[defaultLocale] Param\xe8tres r\xe9gionaux par d\xe9faut pour ce type d\'appareil. Ils seront utilis\xe9s comme langue par d\xe9faut pour l\'appareil.","support":"Langues prises en charge","warn":"** Il semble que vous ayez configur\xe9 des contr\xf4les personnalis\xe9s. Veuillez vous assurer que vous avez mis \xe0 jour les contr\xf4les personnalis\xe9s pour les langues associ\xe9es.**","name":"{{lang}} - Nom du type d\'appareil","langDescription":"{{lang}} - Description"},"customControls":{"title":"Contr\xf4les personnalis\xe9s","object":"{{lang}} - Objet de contr\xf4les personnalis\xe9s","description":"Les contr\xf4les personnalis\xe9s sont une option avanc\xe9e permettant aux utilisateurs de configurer et de modifier manuellement les contr\xf4les d\'application associ\xe9s \xe0 cet appareil. Si vous souhaitez que les utilisateurs contr\xf4lent votre appareil directement depuis Cephable, vous devez enregistrer les contr\xf4les de votre appareil ici. Consultez l\'API Cephable pour plus de d\xe9tails sur les options.","addControl":"Ajouter un contr\xf4le","empty":"Aucun contr\xf4le personnalis\xe9 pour le moment. Utilisez \xab\xa0Ajouter un contr\xf4le\xa0\xbb pour cr\xe9er votre premier.","untitled":"Contr\xf4le sans titre","controlId":"ID de contr\xf4le","controlIdHelp":"Identifiant unique de ce contr\xf4le. D\xe9finissez-le avant d\'enregistrer\xa0; il ne pourra plus \xeatre modifi\xe9 par la suite.","fallback":"Retomber","controlName":"Nom du contr\xf4le","controlDescription":"Description du contr\xf4le","defaultCommandsLabel":"Commandes vocales par d\xe9faut","defaultCommandsHelp":"Voici les commandes vocales par d\xe9faut que les utilisateurs voient pour cette fonction dans la langue actuelle.","sharedAcrossLanguages":"Partag\xe9 dans toutes les langues","sharedAcrossLanguagesHelp":"La modification de ces champs met \xe0 jour la valeur pour toutes les langues simultan\xe9ment.","iconUrl":"URL de l\'ic\xf4ne","contextGroupName":"Groupe de contexte","isProfileControl":"Contr\xf4le du profil","isPrefixVoiceCommand":"Commande vocale pr\xe9fix\xe9e","allowWhenDictating":"Autoriser lors de la dict\xe9e","allowsHold":"Autorise la mise en attente","isDeprecated":"D\xe9pr\xe9ci\xe9","requiresEmployeeAccess":"N\xe9cessite un acc\xe8s employ\xe9","requiresStudentAccess":"N\xe9cessite un acc\xe8s \xe9tudiant","requiresGenericLicense":"N\xe9cessite une licence g\xe9n\xe9rique","requiresPlusAccess":"N\xe9cessite un abonnement Plus","allIncomplete":"Toutes les langues pr\xe9sentent des contr\xf4les personnalis\xe9s incomplets. Veuillez compl\xe9ter au moins une langue avant d\'enregistrer.","savedWithIncomplete":"Enregistr\xe9. Param\xe8tres r\xe9gionaux des contr\xf4les personnalis\xe9s incomplets non enregistr\xe9s\xa0: {{incompleteLocales}}"},"success":{"title":"Succ\xe8s!","description":"Vous avez cr\xe9\xe9 un nouveau type d\'appareil. {{name}} Vous pouvez d\xe9sormais mettre \xe0 jour la port\xe9e de votre appareil client d\'autorisation selon vos besoins."},"id":"ID du type d\'appareil","throttleRules":{"title":"R\xe8gles de commande des gaz","description":"Configurez les r\xe8gles de limitation pour contr\xf4ler le flux des commandes et les restrictions d\'entr\xe9e pour ce type de p\xe9riph\xe9rique.","disableVoiceInput":"D\xe9sactiver la saisie vocale","disableHotkeyInput":"D\xe9sactiver la saisie par raccourci clavier","disableCameraInput":"D\xe9sactiver l\'entr\xe9e cam\xe9ra","disableMultiInputs":"D\xe9sactiver les entr\xe9es multiples","maximumCommandsPerSecond":"Nombre maximal de commandes par seconde","maximumCommandsPerMinute":"Nombre maximal de commandes par minute","maximumMacroLength":"Longueur maximale des macros","jitter":{"title":"Gigue de synchronisation","description":"Ajoutez des variations al\xe9atoires aux dur\xe9es de maintien et de pause pour cr\xe9er des sch\xe9mas d\'entr\xe9e plus naturels.","holdTimeJitterMin":"Gigue du temps de maintien min (ms)","holdTimeJitterMax":"Gigue maximale du temps de maintien (ms)","pauseTimeJitterMin":"Temps de pause (ms)","pauseTimeJitterMax":"Temps de pause\xa0: gigue maximale (ms)"},"incompatibleActions":{"title":"Groupes d\'action incompatibles","description":"D\xe9finir des groupes d\'actions qui ne peuvent pas coexister dans la m\xeame macro.","addGroup":"Ajouter un groupe","removeGroup":"Supprimer le groupe","addAction":"Ajouter une action","removeAction":"Supprimer l\'action","reason":"Raison","reasonPlaceholder":"Pourquoi ces actions sont incompatibles","eventType":"Type d\'\xe9v\xe9nement","key":"Cl\xe9","customActionId":"ID d\'action personnalis\xe9e","emptyGroup":"Aucune action dans ce groupe. Ajoutez au moins deux actions."},"requiredPause":{"title":"Pause requise entre les actions","description":"D\xe9finissez des paires d\'actions qui n\xe9cessitent une pause minimale entre elles dans la m\xeame macro.","addRule":"Ajouter une r\xe8gle","removeRule":"Supprimer la r\xe8gle","actionA":"Action A","actionB":"Action B","minimumPause":"Pause minimale (ms)","bidirectional":"Bidirectionnel","bidirectionalHelp":"Lorsqu\'elle est activ\xe9e, la pause est requise dans les deux sens (A\u2192B et B\u2192A)."},"macroStepRules":{"title":"R\xe8gles des \xe9tapes de macro","holdTimeJitterMin":"Maintien de la gigue min (ms)","holdTimeJitterMax":"Maintien de la gigue max (ms)"}}},"view":"Voir les projets","error":"Erreur lors du chargement des projets.","type":{"title":"Type d\'impl\xe9mentation"},"originHost":{"title":"H\xf4te d\'origine","description":"L\'URL qui servira de source principale pour la demande et les donn\xe9es lors des interactions API."},"orgTitle":"Projets de {{ valeur }}"},"viewOrganization":"Voir L\'organisation","update":"Votre organisation a \xe9t\xe9 mise \xe0 jour\xa0! Actualisation de l\'application.","error":"Erreur lors du chargement de l\'organisation. Veuillez r\xe9essayer ult\xe9rieurement.","new":{"name":{"label":"Nom de l\'organisation","placeholder":"Entrez le nom de votre organisation"},"description":{"label":"Description de l\'organisation","placeholder":"Quels sont vos objectifs en utilisant Cephable Professional ?"},"details":"D\xe9tails de l\'organisation"},"expired":{"user":"Il semblerait que votre licence Cephable ait expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. Pour la renouveler, veuillez contacter l\'administrateur de votre organisation.","admin":"Il semblerait que votre licence Cephable ait expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. Veuillez renouveler votre licence pour continuer \xe0 utiliser les fonctionnalit\xe9s avanc\xe9es.","multiple":"Il semblerait que vos licences Cephable aient expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. Veuillez renouveler au moins une de vos licences pour continuer \xe0 utiliser les fonctionnalit\xe9s avanc\xe9es.","dialog":{"title":"S\xe9lectionnez une organisation","description":"Plusieurs organisations sont associ\xe9es \xe0 votre compte. Veuillez s\xe9lectionner l\'organisation que vous souhaitez renouveler."},"title":"Votre licence Cephable a expir\xe9","titlePlural":"Vos licences Cephable ont expir\xe9","banner":"Il semblerait que votre licence Cephable ait expir\xe9. Vous \xeates donc pass\xe9 \xe0 la version gratuite Cephable Basic. En renouvelant votre licence, vous b\xe9n\xe9ficierez de fonctionnalit\xe9s suppl\xe9mentaires telles que les commandes vocales am\xe9lior\xe9es, les t\xe2ches intelligentes bas\xe9es sur l\'IA et de nombreuses commandes d\'applications pr\xe9d\xe9finies."},"orgName":"Nom de l\'organisation","menu":{"title":"Menu Organisation","view":"Voir le menu","expand":"D\xe9velopper le menu"},"settings":{"title":"Param\xe8tres de l\'organisation","description":"G\xe9rez la facturation, le nom, la description et les ressources de votre organisation.","view":"Afficher les param\xe8tres","general":{"title":"G\xe9n\xe9ral"},"resources":{"edit":"Modifier les ressources","description":"Utilisez l\'\xe9diteur Markdown sur la gauche pour mettre \xe0 jour et formater des ressources utiles pour tous les membres de l\'organisation. Au fur et \xe0 mesure que vous saisissez du texte, l\'aper\xe7u sur la droite montre comment votre contenu appara\xeetra aux utilisateurs. Vous pouvez ajouter des titres, des listes, des liens et d\'autres \xe9l\xe9ments de mise en forme \xe0 l\'aide de la syntaxe Markdown. Les modifications seront visibles pour les membres une fois enregistr\xe9es."},"other":{"title":"Autres param\xe8tres","description":"G\xe9rez la facturation, le nom, la description et les ressources de votre organisation."},"managed":{"title":"G\xe9r\xe9 par Cephable","description":"Ces param\xe8tres sont d\xe9finis par Cephable pour votre organisation. Ils sont affich\xe9s ici \xe0 titre indicatif et ne peuvent \xeatre modifi\xe9s depuis le portail.","email":{"title":"Livraison de courriels Cephable","allowedDescription":"Cephable peut envoyer des courriels aux membres de cette organisation, tels que des invitations, des v\xe9rifications et des r\xe9initialisations de mot de passe.","blockedDescription":"Cephable n\'envoie aucun courriel aux membres de cette organisation. Les invitations, les v\xe9rifications, les r\xe9initialisations de mot de passe, les liens magiques, les courriels d\'int\xe9gration et les courriels relatifs aux produits sont tous bloqu\xe9s."},"scim":{"title":"Provisionnement automatique des membres (SCIM)","description":"Votre fournisseur d\'identit\xe9 cr\xe9e et supprime les membres de cette organisation. Il est impossible d\'envoyer des invitations depuis le portail."},"lockedNote":"Seul Cephable peut modifier ces param\xe8tres. Contactez votre repr\xe9sentant Cephable si une valeur doit \xeatre mise \xe0 jour."}},"managed":{"title":"Organisation g\xe9r\xe9e","titlePlural":"Organisations g\xe9r\xe9es","description":"Les organisations g\xe9r\xe9es sont des organisations g\xe9r\xe9es par un revendeur Cephable. Les revendeurs peuvent g\xe9rer votre \xe9quipe, les profils d\'\xe9quipe, la facturation et bien plus encore ici.","error":"Erreur lors du chargement des organisations g\xe9r\xe9es.","empty":{"title":"Aucune organisation g\xe9r\xe9e trouv\xe9e.","description":"Il ne semble pas qu\'aucune organisation g\xe9r\xe9e ne corresponde \xe0 ces crit\xe8res. Ou vos cl\xe9s de licence n\'ont pas encore \xe9t\xe9 activ\xe9es."},"titleShort":"G\xe9r\xe9"},"canManageChildOrganizations":{"title":"G\xe9rer les organisations pour enfants","description":"Les utilisateurs disposant de cette autorisation peuvent cr\xe9er et g\xe9rer des organisations enfants en tant qu\u2019administrateur."},"canViewAnalytics":{"title":"Voir les analyses","description":"Les utilisateurs disposant de cette autorisation peuvent afficher les mesures et les analyses de l\u2019organisation."},"create":"Cr\xe9er une nouvelle organisation","orgCustomBillingUrl":{"title":"URL de facturation personnalis\xe9e","description":"Il s\'agit d\'une URL personnalis\xe9e qui sera utilis\xe9e pour rediriger l\'utilisateur vers votre syst\xe8me de facturation (celui du revendeur). Doit commencer par \xab https:// \xbb ou \xab mailTo\xa0: \xbb"},"upgrade":{"existing":{"title":"Vous faites partie d\'une licence existante.","description":"Veuillez effectuer une mise \xe0 niveau en cliquant sur \xab\xa0{{action}}\xa0\xbb dans le menu lat\xe9ral."}},"restrictions":{"isGenAIDisabled":{"title":"IA g\xe9n\xe9rative d\xe9sactiv\xe9e","description":"Votre organisation a d\xe9sactiv\xe9 l\'acc\xe8s aux fonctionnalit\xe9s d\'IA g\xe9n\xe9rative. Veuillez contacter l\'administrateur de votre organisation pour plus d\'informations."},"isRemoteControlDisabled":{"title":"Synchronisation entre appareils d\xe9sactiv\xe9e","description":"Votre organisation a d\xe9sactiv\xe9 l\'acc\xe8s \xe0 la synchronisation. Vous ne pourrez donc pas utiliser notre application compagnon ni contr\xf4ler les appareils externes. Veuillez contacter l\'administrateur de votre organisation pour plus d\'informations."}},"troubleshooting":{"title":"D\xe9pannage","editorDescription":"[Facultatif] Cette section est visible par tous les utilisateurs via la page des d\xe9tails de connexion dans les applications mobiles et de bureau Cephable.","description":"Si vous rencontrez des probl\xe8mes avec Cephable, essayez les \xe9tapes ci-dessous pour r\xe9soudre les probl\xe8mes courants."},"onboarding":{"title":"Int\xe9gration","editorDescription":"[Facultatif] Un message d\'accueil s\'affiche lorsque ce type d\'appareil est ajout\xe9 \xe0 votre compte. C\'est l\'endroit id\xe9al pour fournir des instructions sur la configuration et l\'utilisation de cet appareil avec votre application."},"documents":"Documents","completionStatus":{"title":"\xc9tat d\'ach\xe8vement","error":"","complete":"Complet.","incomplete":"Incomplet."},"metadata":{"title":"M\xe9tadonn\xe9es","urlError":"L\'URL doit commencer par http:// ou https://","metatitle":{"label":"Meta Title","placeholder":"Saisissez un titre court"},"shortDescription":{"label":"Description courte","placeholder":"Saisissez une br\xe8ve description (150 caract\xe8res maximum)"},"externalLink":{"label":"URL du lien externe","placeholder":"https://example.com/device-info","description":"Un lien direct vers un site web ou une ressource externe fournissant des informations suppl\xe9mentaires sur la premi\xe8re configuration de cet appareil. Si vous utilisez ce lien, nous n\'utiliserons pas le balisage Markdown de la liste des clients."},"iconUrl":{"label":"URL de l\'ic\xf4ne de l\'appareil","placeholder":"https://example.com/device-icon.png","description":"Lien direct vers une image repr\xe9sentant ce type d\'appareil. Cette ic\xf4ne sera affich\xe9e dans l\'application Cephable et sur les listes d\'appareils."},"darkModeIconUrl":{"label":"URL de l\'ic\xf4ne de l\'appareil en mode sombre","placeholder":"https://example.com/device-icon-dark.png","description":"Lien direct vers une image repr\xe9sentant ce type d\'appareil en mode sombre. Cette ic\xf4ne s\'affichera dans l\'application Cephable et sur les listes d\'appareils lorsque le mode sombre est activ\xe9."},"editorDescription":"Lorsque votre appareil est s\xe9lectionn\xe9 pour figurer dans l\'application Cephable en tant qu\'extension ou connexion, nous utilisons ces informations pour les afficher aux utilisateurs qui configurent de nouvelles connexions."},"client-listing":{"title":"Liste des clients","editorDescription":"Instructions d\xe9taill\xe9es pour les nouveaux utilisateurs afin de configurer des connexions avec ce type d\'appareil. Ce texte s\'affichera dans l\'application Cephable lors de l\'ajout d\'une nouvelle connexion."},"canAccessOrganizationProfiles":{"title":"Afficher les commandes de l\'application Organisation","description":"Les utilisateurs disposant de cette autorisation peuvent consulter les commandes de l\'application d\'organisation associ\xe9es \xe0 cette organisation."},"canEditOrganizationProfiles":{"title":"G\xe9rer les contr\xf4les de l\'application de l\'organisation","description":"Les utilisateurs disposant de cette autorisation peuvent cr\xe9er, modifier et supprimer les contr\xf4les d\'application d\'organisation associ\xe9s \xe0 cette organisation."},"profiles":{"title":"Contr\xf4les de l\'application Organisation","description":"Les contr\xf4les d\'application d\'organisation sont des profils partag\xe9s permettant de distribuer les contr\xf4les d\'application au sein de votre organisation ou de les partager avec vos utilisateurs d\'int\xe9gration.","view":"Afficher les commandes de l\'application Organisation","editDescription":"Modifiez les commandes de l\'application d\'organisation pour personnaliser les param\xe8tres.","empty":"Aucune application de contr\xf4le d\'organisation trouv\xe9e. Cr\xe9ez-en une pour commencer.","error":"Erreur lors du chargement des commandes de l\'application d\'organisation.","titleShort":"Commandes de l\'application"},"canViewAuthClients":{"title":"Voir les projets","description":"Les utilisateurs disposant de cette autorisation peuvent consulter les clients d\'authentification et les projets de l\'organisation."},"governance":{"title":"Gouvernance","orgTitle":"{{valeur}} Gouvernance","description":"D\xe9finissez les r\xe8gles de s\xe9curit\xe9 qui encadrent l\'utilisation de l\'assistant Cephable par votre \xe9quipe.","automation":{"title":"R\xe8gles d\'automatisation","description":"Contr\xf4lez les domaines o\xf9 Cephable peut automatiser et fournissez des instructions qui fa\xe7onnent son comportement pour votre organisation.","rulesTitle":"R\xe8gles","create":"Cr\xe9er une r\xe8gle d\'automatisation","edit":"Modifier la r\xe8gle d\'automatisation","created":"R\xe8gle d\'automatisation cr\xe9\xe9e.","updated":"R\xe8gle d\'automatisation mise \xe0 jour.","deleted":"R\xe8gle d\'automatisation supprim\xe9e.","loadError":"Impossible de charger les r\xe8gles d\'automatisation.","saveError":"Impossible d\'enregistrer la r\xe8gle d\'automatisation.","deleteError":"Impossible de supprimer la r\xe8gle d\'automatisation.","searchPlaceholder":"R\xe8gles de recherche par application, site web, invite ou \xe9tendue","promptOnly":"l\'instruction d\'assistant","editorDescription":"Choisissez le type de r\xe8gle, ciblez \xe9ventuellement une application ou un site web, et ajoutez des instructions claires pour Cephable.","validation":"Ajoutez une application ou un site web, des instructions d\'assistance, ou les deux.","appOrDomain":{"label":"Application ou site web","helper":"Utilisez un nom d\'application ou un domaine reconnaissable, comme Slack, gmail.com ou github.com."},"prompt":{"label":"Instructions de l\'assistant","helper":"D\xe9crivez ce que Cephable doit ou ne doit pas faire. Veillez \xe0 ce que les instructions soient pr\xe9cises et applicables."},"type":{"label":"Type de r\xe8gle","block":"Bloc","allow":"Permettre"},"scope":{"organization":"\xc0 l\'\xe9chelle de l\'organisation","organizationDescription":"Appliquez cette r\xe8gle \xe0 tous les membres actuels et futurs.","members":"membres sp\xe9cifiques","membersDescription":"Enregistrez la r\xe8gle, puis attribuez-la uniquement aux membres qui en ont besoin."},"assign":"Attribuer des membres","delete":{"title":"Supprimer la r\xe8gle d\'automatisation\xa0?","description":"Cela supprime d\xe9finitivement la r\xe8gle et toutes les affectations de membres qui l\'utilisent."},"empty":{"title":"Aucune r\xe8gle d\'automatisation pour le moment.","description":"Cr\xe9ez une r\xe8gle pour d\xe9finir le premier garde-fou de votre organisation en mati\xe8re d\'assistance aux assistants."},"guidance":{"block":{"title":"Restreindre les applications et les sites web","description":"Utilisez une r\xe8gle de blocage avec un nom d\'application ou un domaine pour emp\xeacher Cephable d\'interagir avec celui-ci."},"prompt":{"title":"Ajouter le contexte de l\'assistant","description":"Utilisez les instructions de l\'assistant pour communiquer les politiques, les v\xe9rifications requises ou les m\xe9thodes de travail s\xe9curitaires."},"scope":{"title":"Choisissez la bonne lunette","description":"Appliquer des r\xe8gles de s\xe9curit\xe9 communes \xe0 l\'ensemble de l\'organisation, ou limiter les exceptions \xe0 certains membres."}},"assignment":{"title":"Attribuer une r\xe8gle \xe0 un membre","description":"G\xe9rer l\'affectation sp\xe9cifique au membre pour {{value}}.","memberLabel":"Membre","apply":"Appliquer la r\xe8gle","remove":"Supprimer la r\xe8gle","assigned":"Cette r\xe8gle est attribu\xe9e au membre s\xe9lectionn\xe9.","notAssigned":"Cette r\xe8gle n\'est pas attribu\xe9e au membre s\xe9lectionn\xe9.","applied":"R\xe8gle appliqu\xe9e au membre.","removed":"R\xe8gle supprim\xe9e pour le membre.","loadError":"Impossible de charger les membres de l\'organisation.","statusError":"Impossible de charger les r\xe8gles d\'automatisation de ce membre.","saveError":"Impossible de mettre \xe0 jour l\'affectation du membre."}},"tabs":{"automation":"R\xe8gles d\'automatisation","permissions":"Autorisations d\'extension","skills":"comp\xe9tences organisationnelles","connectors":"Connecteurs d\'organisation","usage":"Usage"},"extensions":{"permissions":{"orgTitle":"Politique \xe0 l\'\xe9chelle de l\'organisation","orgDescription":"Contr\xf4lez les fonctionnalit\xe9s que les membres peuvent activer pour chaque comp\xe9tence et connecteur. Ces param\xe8tres s\'appliquent \xe0 tous, sauf si un membre dispose d\'une autorisation sp\xe9ciale (voir ci-dessous).","saved":"Politique de l\'organisation mise \xe0 jour.","saveError":"Impossible de mettre \xe0 jour la politique de l\'organisation.","askAdmin":"Veuillez contacter l\'administrateur de votre organisation pour activer cette fonctionnalit\xe9.","installBlocked":"Impossible d\'installer.","createBlocked":"Impossible d\'ajouter un {{type}} personnel.","useBlocked":"Ce {{type}} n\'est plus disponible."},"orgFlags":{"allowPublicSkills":{"title":"Autoriser les comp\xe9tences publiques","description":"Les membres peuvent publier ou activer des comp\xe9tences publiques disponibles sur la plateforme Cephable."},"allowMemberManagedSkills":{"title":"Permettre les comp\xe9tences personnelles","description":"Les membres peuvent d\xe9velopper et mettre en \u0153uvre leurs propres comp\xe9tences personnelles."},"allowPublicMcpServers":{"title":"Autoriser les connecteurs publics","description":"Les membres peuvent publier ou activer des connecteurs publics disponibles sur la plateforme Cephable."},"allowMemberManagedMcpServers":{"title":"Autoriser les connecteurs personnels","description":"Les membres peuvent cr\xe9er et activer leurs propres connecteurs MCP personnels."}},"members":{"title":"Remplacements par membre","description":"Accorder \xe0 un membre la possibilit\xe9 de partager, de g\xe9rer ou d\'utiliser des comp\xe9tences et des connecteurs externes.","memberLabel":"Membre","saved":"Autorisations des membres mises \xe0 jour.","saveError":"Impossible de mettre \xe0 jour les autorisations des membres.","loadError":"Impossible de charger les membres de l\'organisation.","adminNote":"Ce membre est administrateur de l\'organisation et poss\xe8de d\xe9j\xe0 toutes les autorisations d\'extension."},"memberFlags":{"canShareSkillsWithOrganization":{"title":"Partager ses comp\xe9tences avec l\'organisation","description":"Publiez vos comp\xe9tences personnelles afin que les autres membres puissent les mettre \xe0 profit."},"canManageOrganizationSkills":{"title":"G\xe9rer les comp\xe9tences organisationnelles","description":"Cr\xe9er, modifier et supprimer les comp\xe9tences partag\xe9es avec l\'organisation."},"canUseExternalSkills":{"title":"Utiliser des comp\xe9tences externes","description":"Activer les comp\xe9tences publiques ou personnelles m\xeame lorsque l\'organisation les restreint."},"canShareMcpServersWithOrganization":{"title":"Partagez les connecteurs avec l\'organisation","description":"Publiez vos connecteurs personnels afin que les autres membres puissent les activer."},"canManageOrganizationMcpServers":{"title":"G\xe9rer les connecteurs d\'organisation","description":"Cr\xe9er, modifier et supprimer des connecteurs partag\xe9s avec l\'organisation."},"canUseExternalMcpServers":{"title":"Utilisez des connecteurs externes","description":"Autorisez les connecteurs publics ou personnels m\xeame si l\'organisation les restreint."}},"skills":{"title":"comp\xe9tences organisationnelles","description":"Pr\xe9configurez les comp\xe9tences pour votre organisation. Les membres peuvent les d\xe9couvrir et les activer depuis leurs applications.","create":"Cr\xe9er une comp\xe9tence","edit":"Comp\xe9tence de modification"},"connectors":{"title":"Connecteurs d\'organisation","description":"Pr\xe9configurez les connecteurs MCP pour votre organisation. Les membres fournissent leurs propres identifiants sur leur appareil lorsqu\'ils activent un connecteur.","create":"Ajouter un connecteur","edit":"Modifier le connecteur"},"sort":{"label":"Trier par","recent":"Plus r\xe9cent","rating":"Meilleure note","votes":"Les plus populaires","installs":"La plupart des installations"},"list":{"loadError":"Impossible de charger la liste.","emptyTitle":"Rien ici pour l\'instant","emptyDescription":"Cr\xe9ez-en une pour la mettre \xe0 la disposition des membres de votre organisation."},"stats":{"rating":"Note moyenne","installs":"Les membres qui utilisent ceci","votes":"Score du vote","comments":"Commentaires"},"feedback":{"open":"\xc9valuations et commentaires","description":"Les \xe9valuations et les commentaires sont partag\xe9s au sein de votre organisation.","yourRating":"Votre note","upvote":"Vote positif","downvote":"Vote n\xe9gatif","comments":"Commentaires","commentPlaceholder":"Partagez comment cela fonctionne pour votre \xe9quipe\u2026","replyPlaceholder":"R\xe9pondre\u2026","noComments":"Aucun commentaire pour l\'instant. Lancez la discussion.","member":"Membre","deleted":"Ce commentaire a \xe9t\xe9 supprim\xe9.","reply":"R\xe9pondre","loadError":"Impossible de charger les commentaires.","rateError":"Impossible d\'enregistrer votre note.","commentError":"Impossible de publier votre commentaire.","deleteError":"Impossible de supprimer le commentaire."},"usage":{"description":"Consultez la liste des membres qui ont activ\xe9 chaque comp\xe9tence et connecteur d\'organisation.","skillsTitle":"Utilisation des comp\xe9tences","connectorsTitle":"Utilisation du connecteur","empty":"Aucun membre n\'a encore activ\xe9 d\'\xe9l\xe9ment dans cette cat\xe9gorie.","installCount":"{{count}} membre(s)","accountWide":"Tous les appareils","perDevice":"Dispositif unique","unnamed":"Sans titre","loadError":"Impossible de charger les donn\xe9es d\'utilisation."}}},"canManageGlobalAutomationRules":{"title":"G\xe9rer la gouvernance","description":"Les utilisateurs disposant de cette autorisation peuvent g\xe9rer les r\xe8gles d\'automatisation de l\'organisation et les affectations des membres."}},"customControls":{"title":"Contr\xf4les globaux et des appareils","prefixDisclaimer":" Il s\'agit d\'un contr\xf4le de pr\xe9fixe\xa0; il \xe9coutera les mots apr\xe8s la commande, puis recherchera la phrase suivante pour trouver des correspondances.","allowPausedDisclaimer":" Cette commande fonctionnera m\xeame lorsque le microphone est en pause.","conflictIndicators":{"warn":"Avertissement: ","title":"Conflits de configuration d\'entr\xe9e d\xe9tect\xe9s","globalControls":"Conflits de configuration de contr\xf4le global","deviceControls":"Conflits de configuration du contr\xf4le des p\xe9riph\xe9riques","usedInput":" est utilis\xe9 comme entr\xe9e pour ","description":"Certaines entr\xe9es de vos contr\xf4les globaux et d\'appareil sont \xe9galement utilis\xe9es dans un ou plusieurs de vos contr\xf4les d\'application. Cela peut entra\xeener des conflits avec Cephable. Dans ce cas, nous privil\xe9gierons toujours le contr\xf4le d\'application par rapport au contr\xf4le global ou d\'appareil.","item":"L&#39;entr\xe9e <strong>{{value}}</strong> est utilis\xe9e dans les contr\xf4les de votre application\xa0: ","globalDescription":"Les contr\xf4les globaux suivants ont des entr\xe9es en conflit avec les contr\xf4les de votre application.","deviceDescription":"Les commandes de l\'appareil suivantes ont des entr\xe9es en conflit avec les commandes de votre application."},"globalControls":{"title":"Contr\xf4les globaux","empty":"Vous n\'avez pas encore de contr\xf4les globaux. Cliquez ci-dessous pour en cr\xe9er un.","edit":"Modifier les contr\xf4les globaux","description":"Les commandes globales sont toujours disponibles, quels que soient les contr\xf4les de l\'application ou l\'appareil utilis\xe9. Certaines fonctionnent m\xeame lorsque les commandes de votre microphone ou de votre appareil photo sont en pause."},"deviceControls":{"title":"Contr\xf4les des appareils","empty":"Vous n\'avez pas encore de commandes d\'appareil. Cliquez ci-dessous pour en cr\xe9er un.","edit":"Modifier les contr\xf4les de l\'appareil","controls":{"cephable-open-app":{"success":"Ouvrir l\'application\xa0: {{value}}","error":"Impossible de trouver l\'application\xa0: {{value}}"},"cephable-close-app":{"commands":["fermer"],"name":"Fermer l\'application par nom","description":"Utilisez cette commande avec les commandes vocales pour fermer une application sur votre ordinateur par son nom.","success":"Fermer l\'application\xa0: {{value}}","error":"Impossible de trouver l\'application\xa0: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimiser"],"name":"R\xe9duire l\'application actuellement s\xe9lectionn\xe9e.","description":"Utilisez cette commande avec les commandes vocales pour minimiser l\u2019application actuellement s\xe9lectionn\xe9e.","success":"Minimisez le succ\xe8s des applications cibl\xe9es\xa0!","error":"Erreur lors de la minimisation de l\'application focalis\xe9e."},"cephable-maximize-focused-app":{"commands":["maximiser"],"name":"Maximisez l\'application actuellement s\xe9lectionn\xe9e.","description":"Utilisez cette commande avec les commandes vocales pour maximiser l\'application actuellement s\xe9lectionn\xe9e.","success":"Maximisez le succ\xe8s de votre application cibl\xe9e\xa0!","error":"Erreur lors de la minimisation de l\'application focalis\xe9e."},"cephable-generate-text":{"commands":["g\xe9n\xe9rer"],"name":"G\xe9n\xe9rez du texte en fournissant l\'invite suivant cette commande.","description":"Utilisez cette commande avec des commandes vocales suivies de votre invite pour g\xe9n\xe9rer du texte associ\xe9."},"cephable-stop-generate-text":{"commands":["arr\xeater de g\xe9n\xe9rer","arr\xeater la g\xe9n\xe9ration","annuler g\xe9n\xe9rer","annuler la g\xe9n\xe9ration"],"name":"Arr\xeatez de g\xe9n\xe9rer du texte.","description":"Utilisez cette commande avec les commandes vocales pour arr\xeater de g\xe9n\xe9rer du texte"},"cephable-open-panel":{"commands":["afficher le panneau"],"name":"Ouvrir le panneau Cephable","description":"Utilisez cette commande avec les commandes vocales pour ouvrir le panneau Cephable."},"cephable-close-panel":{"commands":["masquer le panneau"],"name":"Masquer le panneau Cephable","description":"Utilisez cette commande avec les commandes vocales pour masquer ou r\xe9duire le panneau Cephable."},"cephable-close-focused-app":{"commands":["courant proche"],"name":"Fermez l\'application actuellement s\xe9lectionn\xe9e.","description":"Utilisez cette commande avec les commandes vocales pour fermer l\u2019application actuellement s\xe9lectionn\xe9e.","success":"Fermer l\'application actuelle avec succ\xe8s\xa0!","error":"Erreur lors de la fermeture de l\'application actuelle."},"cephable-rewrite-text":{"commands":["r\xe9crire"],"name":"R\xe9\xe9crivez le texte en fournissant l\'invite suivant cette commande.","description":"Utilisez cette commande avec les commandes vocales suivies de votre invite pour r\xe9\xe9crire votre texte en surbrillance actuel."},"cephable-summarize-text":{"commands":["r\xe9sumer"],"name":"R\xe9sumez le texte en fournissant l\u2019invite suivant cette commande.","description":"Utilisez cette commande avec les commandes vocales suivies de votre invite pour r\xe9sumer votre texte actuellement en surbrillance."},"cephable-translate-text":{"commands":["traduire"],"name":"Traduisez le texte en fournissant l\'invite suivant cette commande.","description":"Utilisez cette commande avec les commandes vocales suivies de votre invite pour traduire votre texte actuellement en surbrillance."},"cephable-click-by-name":{"commands":["robinet","frapper","naviguer vers","aller \xe0"],"name":"Appuyez sur l\'\xe9l\xe9ment par nom","description":"Touchez un \xe9l\xe9ment de la page par son nom, par exemple \xab\xa0toucher enregistrer\xa0\xbb, pour cliquer sur un bouton nomm\xe9 \xab\xa0Enregistrer\xa0\xbb. Cela revient \xe0 utiliser la souris vocale\xa0: cliquer sur des \xe9l\xe9ments par commandes vocales plut\xf4t qu\u2019avec une souris."},"cephable-automate":{"commands":["automatiser","essayer","avoir c\xe9phable","effectuer un flux de travail pour","travailler sur"],"name":"Ex\xe9cutez un flux de travail d\'IA en d\xe9crivant une t\xe2che apr\xe8s cette commande.","description":"Utilisez cette commande avec les commandes vocales, suivie d\'une t\xe2che, telle que \xab automatiser l\'envoi d\'un e-mail \xe0 mon \xe9quipe \xbb, et Cephable l\'ex\xe9cutera sous forme de flux de travail d\'IA."},"cephable-paste-background-entry":{"commands":["coller l\'entr\xe9e r\xe9cente","coller la derni\xe8re entr\xe9e","coller la derni\xe8re dict\xe9e","coller le contenu de fond"],"name":"Collez le contenu d\'arri\xe8re-plan le plus r\xe9cent.","description":"Utilisez cette commande pour coller le contenu le plus r\xe9cent stock\xe9 en arri\xe8re-plan dans l\'application active."}},"description":"Les commandes de l\'appareil sont li\xe9es \xe0 l\'appareil ou \xe0 la connexion que vous utilisez. Elles sont disponibles sans avoir \xe0 les ajouter aux commandes de votre application et sont particuli\xe8rement utiles pour les fonctionnalit\xe9s ou \xe9v\xe9nements uniquement pris en charge sur certains appareils."},"resetControls":{"title":"R\xe9initialiser les Commandes","description":"La langue de votre voix a chang\xe9 depuis la derni\xe8re mise \xe0 jour de vos commandes. Remarque\xa0: cette op\xe9ration r\xe9initialisera vos commandes pour qu\'elles correspondent \xe0 {{language}} et vous risquez de perdre toutes les commandes personnalis\xe9es. \xcates-vous s\xfbr de vouloir r\xe9initialiser\xa0?","confirm":"Oui, r\xe9initialiser les commandes","error":"Une erreur s\'est produite lors de la r\xe9initialisation de vos commandes. Veuillez r\xe9essayer ult\xe9rieurement."},"warn":"Le microphone n\'est pas activ\xe9. Vous devez activer votre microphone pour utiliser les commandes globales et celles de l\'appareil.","changeProfile":{"success":"Modifier les contr\xf4les de l\'application\xa0: {{value}}","error":"Impossible de trouver les contr\xf4les de l\'application\xa0: \xab\xa0{{value}}\xa0\xbb"},"descriptionShort":"Les commandes globales et d\'appareil sont des actions toujours disponibles, con\xe7ues pour fonctionner avec tous les logiciels. Les commandes globales, comme \xab\xa0Arr\xeater la cam\xe9ra\xa0\xbb, sont applicables \xe0 l\'ensemble du syst\xe8me et ind\xe9pendantes des applications, tandis que les commandes d\'appareil sont adapt\xe9es \xe0 chaque connexion et d\xe9bloquent des fonctionnalit\xe9s plus avanc\xe9es que les commandes d\'application standard.","description":"Les commandes globales et celles des appareils sont des actions toujours disponibles, con\xe7ues pour fonctionner avec tous les logiciels. Les commandes globales, comme \xab\xa0Arr\xeater la cam\xe9ra\xa0\xbb, sont applicables \xe0 l\'ensemble du syst\xe8me et ind\xe9pendantes des applications, tandis que les commandes des appareils sont adapt\xe9es \xe0 chaque connexion et d\xe9bloquent des fonctionnalit\xe9s plus avanc\xe9es que les commandes d\'application standard. Ces commandes sont actuellement accessibles par commande vocale, mais nous prendrons en charge d\'autres commandes ult\xe9rieurement.","noDevice":"Cette \xe9tape utilise une extension personnalis\xe9e que vous n\'avez pas configur\xe9e pour votre compte. Ajoutez l\'extension pour d\xe9bloquer cette \xe9tape."},"notifications":{"title":"Notifications","center":"Centre de notification","empty":"Vous n\'avez aucune notification pour le moment. Revenez une autre fois.","seen":"Vu","markAsRead":"Marquer comme lu","view":"Afficher toutes les notifications {{value}}"},"unsaved":{"title":"Vous avez des changements non enregistr\xe9s.","description":"Vous avez des changements non enregistr\xe9s. \xcates-vous s\xfbr de vouloir quitter cette page\xa0?","cancel":"Quitter sans sauvegarder","confirm":"Sauvegarder et quitter"},"login":{"welcome":"Bienvenue chez C\xe9phable !","subtitle":"Contr\xf4lez votre technologie selon <strong>vos</strong> conditions.","create":"Cr\xe9er un compte","signIn":"Se connecter","loading":"Redirection vers la connexion...","error":"Une erreur s\'est produite lors de votre connexion. Veuillez vous reconnecter.","existingAccount":"Vous avez d\xe9j\xe0 un compte?","description":"Contr\xf4lez. Cr\xe9ez. Automatisez. Cephable \u2014 votre IA personnelle pour des commandes rapides, la r\xe9daction contextuelle et des flux de travail enti\xe8rement automatis\xe9s. Aucun traitement dans le cloud. Une assistance fluide qui vous suit partout."},"home":{"title":"Maison","startControls":"Allume \xe7a!","manage":"Configurer","profileGenerate":{"title":"Oups. On dirait que vous n\'avez pas encore de contr\xf4les d\'application.","description":"Pour que Cephable puisse contr\xf4ler votre ordinateur, nous devons savoir ce que vous souhaitez contr\xf4ler. Vous pouvez cr\xe9er des contr\xf4les d\'application de A \xe0 Z ou nous demander de vous aider \xe0 en cr\xe9er un gr\xe2ce \xe0 notre g\xe9n\xe9rateur de contr\xf4les."}},"wizard":{"description":"Cephable utilisera ensuite ces informations pour g\xe9n\xe9rer des contr\xf4les que vous pourrez examiner et essayer\xa0!","includeDefaultKeysQuestion":"Inclure les commandes vocales par d\xe9faut pour les touches et les clics de souris\xa0?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Code, etc.","generate":"G\xe9n\xe9rer des contr\xf4les","complete":{"title":"Tr\xe8s bien, nous avons termin\xe9\xa0!","description":"Cliquez sur le bouton ci-dessous pour afficher les contr\xf4les que nous avons g\xe9n\xe9r\xe9s. Vous pourrez modifier, ajouter ou supprimer manuellement n\'importe quel aspect pour le perfectionner vous-m\xeame.","viewControls":"Voir mes contr\xf4les"},"error":{"emptyInput":"Veuillez s\xe9lectionner au moins une m\xe9thode de saisie","emptyApp":"Veuillez saisir au moins un nom d\'application","generatingProfile":"Erreur lors de la g\xe9n\xe9ration des contr\xf4les de l\'application"},"loading":{"title":"Nous rassemblons toutes les pi\xe8ces","description":"Cela peut prendre jusqu\'\xe0 environ une minute. Ne quittez pas cette page et ne revenez pas en arri\xe8re, sinon elle cessera de g\xe9n\xe9rer."},"selectedTips":{"title":"Conseil n\xb0\xa0{{count}}","previous":"Conseil pr\xe9c\xe9dent","next":"Prochain conseil","two":"Vous pouvez contr\xf4ler la sensibilit\xe9 de vos entr\xe9es dans la section \xab\xa0Param\xe8tres de contr\xf4le d\'expression\xa0\xbb du panneau principal. Cela vous permet d\'affiner davantage la mani\xe8re dont Cephable interpr\xe8te les entr\xe9es qui vous sont sp\xe9cifiques. Et Cephable s\'am\xe9liore avec le temps \xe0 mesure qu\'il fonctionne avec vous\xa0!","three":"Apr\xe8s avoir configur\xe9 cela, vous avez toujours un contr\xf4le total sur la configuration. Nous vous donnons une base de r\xe9f\xe9rence, mais \xe0 tout moment, vous pouvez modifier le mappage entre ce que vous faites et ce qu\'il fait sur l\'ordinateur.","four":"Vous pouvez imprimer vos contr\xf4les pour en avoir une copie physique lorsque vous utilisez Cephable. Nous savons que tout cela est nouveau et qu\u2019il faut un certain temps pour s\u2019y habituer. La pratique rend meilleur !","one":"Saviez-vous que vous pouvez utiliser Cephable sur un appareil pour en contr\xf4ler un autre\xa0? T\xe9l\xe9chargez Cephable sur votre mobile, votre tablette ou m\xeame un autre ordinateur et choisissez la connexion que vous souhaitez contr\xf4ler (peut-\xeatre celle-ci). Vos profils personnels et de saisie sont coh\xe9rents sur tous vos appareils\xa0! Assurez-vous simplement que Cephable est actif sur votre appareil et vos connexions."},"steps":{"one":"\xc9tape 1. Tapez le nom d\'une application que vous souhaitez contr\xf4ler.","two":"\xc9tape 2. Confirmez les contr\xf4les de saisie que vous souhaitez utiliser\xa0:","three":"\xc9tape 3. (facultatif) ","threeContinued":"D\xe9crivez toutes les actions sp\xe9cifiques que vous souhaiteriez configurer pour les commandes que vous utilisez couramment ou pour lesquelles vous avez une forte pr\xe9f\xe9rence. Veuillez utiliser un anglais simple comme ceux ci-dessous"},"noOptionsText":"Commencez \xe0 taper pour trouver une application que vous souhaitez contr\xf4ler","title":"G\xe9n\xe9rer des contr\xf4les d\'application","titleLong":"G\xe9n\xe9rer des contr\xf4les d\'application","try":"Essayez le g\xe9n\xe9rateur de contr\xf4le","placeholder":"Assurez-vous que les commandes vocales soient courtes.\\n\\nJe souhaite pouvoir dire \xab\xa0avancer\xa0\xbb pour passer \xe0 la diapositive suivante de la pr\xe9sentation.\\n\\nJe souhaite utiliser les mouvements de la t\xeate pour d\xe9placer le curseur et les commandes vocales pour modifier les raccourcis.\\n\\nAjouter des boutons d\'action rapide pour tous les mouvements et capacit\xe9s de mon personnage."},"macros":{"title":"Contr\xf4le","titlePlural":"Contr\xf4les","description":"Les contr\xf4les contiennent une entr\xe9e (action que vous faites comme incliner la t\xeate) et les \xe9tapes que Cephable effectuera apr\xe8s l\'enregistrement de cette action d\'entr\xe9e. Vous pouvez utiliser des contr\xf4les pour cr\xe9er une combinaison d\'\xe9tapes d\xe9clench\xe9es par une seule entr\xe9e.","new":"Cr\xe9er un nouveau contr\xf4le","newDescription":"Cr\xe9ez un nouveau contr\xf4le pour combiner plusieurs \xe9tapes et entr\xe9es.","add":"Ajouter un contr\xf4le","create":"Cr\xe9er un contr\xf4le","name":{"title":"Nom du contr\xf4le","question":"Comment voulez-vous appeler ce contr\xf4le\xa0?","description":"Donnez un nom \xe0 votre contr\xf4le afin de pouvoir le retrouver facilement plus tard.","placeholder":"action que ce contr\xf4le fait comme \\"sauter\\" ou \\"zoomer\\""},"empty":"Vous n\'avez pas encore de contr\xf4les. Cliquez ci-dessous pour en cr\xe9er un.","copySuffix":"{{name}}_copie"},"event":{"title":"\xc9tape","titlePlural":"Pas","previewSummaryPlural":"{{first}} et {{total}} autres \xe9v\xe9nements","add":"Ajouter une \xe9tape","stepType":"Type d\'\xe9tape","select":"S\xe9lectionnez le type d\'\xe9tape que vous souhaitez ajouter.","question":"Quel type d\u2019actions souhaitez-vous que Cephable effectue\xa0?","setup":"Configurez votre \xe9tape","description":"Les \xe9tapes sont les actions que Cephable effectuera une fois l\'entr\xe9e d\xe9clench\xe9e. Vous pouvez ajouter plusieurs \xe9tapes \xe0 un contr\xf4le pour cr\xe9er une combinaison d\'actions.","expand":"D\xe9veloppez pour voir le reste des \xe9tapes","stepUp":"Progresser","stepDown":"Descendre","stepCopy":"\xc9tape de copie","stepRemove":"Supprimer l\'\xe9tape","insertStep":"Ins\xe9rer l\'\xe9tape ci-dessous","showOptions":"Afficher les options","hideOptions":"Masquer les options","hold":"Temps de maintien (en millisecondes)","error":"Vous devez configurer votre \xe9tape.","multiple":"Plusieurs \xe9tapes","deviceTypeCustomAction":{"title":"Action personnalis\xe9e sur l\'appareil"},"keyPress":{"title":"Appuyez sur la touche ou le bouton ","short":"Presse","fieldSet":"Touches ou boutons sur lesquels appuyer","label":"Cl\xe9 ou bouton","holdTime":"Temps de maintien de la touche (en millisecondes)","description":"Appuyez sur une touche du clavier sans utiliser le clavier.","longDescription":"Cette fonction simule l\'appui sur une touche de votre clavier. Par exemple, si vous rencontrez des difficult\xe9s pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre m\xe9thode de saisie pour \xab\xa0appuyer\xa0\xbb virtuellement sur une touche.","example":"Dites \xab Entr\xe9e \xbb pour envoyer un e-mail sans appuyer physiquement sur la touche Entr\xe9e.","timing":"Synchronisation des touches","tap":"Robinet","tapLong":"Appuyez sur le bouton","latch":"Loquet","latchLong":"Tenir jusqu\'\xe0 ce qu\'il soit rel\xe2ch\xe9","hold":"Prise","holdLong":"Tenir pendant un certain temps","toggle":"Basculer","toggleLong":"Basculer l\'action","release":"Rel\xe2cher","releaseLong":"Rel\xe2cher l\'action","latchLabel":"Conservez <strong>{{value}}</strong> jusqu&#39;\xe0 ce qu&#39;il soit lib\xe9r\xe9","tapLabel":"Appuyez sur <strong>{{value}}</strong>","pressLabel":"Appuyez sur <strong>{{value}}</strong> pendant <strong>{{time}}</strong> millisecondes","remove":"Supprimer la touche enfonc\xe9e","add":"Ajouter une touche/un bouton sur lequel appuyer"},"keyRelease":{"title":"Rel\xe2cher la touche ou le bouton","short":"Lib\xe9rer","selected":"Cl\xe9s s\xe9lectionn\xe9es \xe0 lib\xe9rer","description":"L\xe2chez une touche du clavier que vous avez enfonc\xe9e et maintenue enfonc\xe9e.","longDescription":"Cette fonction simule le rel\xe2chement d\'une touche de votre clavier. Il doit \xeatre utilis\xe9 conjointement avec une pression sur une touche maintenue ind\xe9finiment. Par exemple, si vous rencontrez des difficult\xe9s pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre m\xe9thode de saisie pour \xab rel\xe2cher \xbb virtuellement une touche.","example":"Dites \xab Stop \xbb apr\xe8s avoir dit \xab Toggle Run \xbb pour arr\xeater de fonctionner.","label":"Lib\xe9rer <strong>{{value}}</strong>","add":"Ajouter une cl\xe9/un bouton pour lib\xe9rer","remove":"Supprimer la version de cl\xe9"},"keyToggle":{"title":"Touche ou bouton \xe0 bascule","short":"Basculer","selected":"Touches s\xe9lectionn\xe9es \xe0 basculer","description":"Allumez ou \xe9teignez une touche du clavier comme un interrupteur d\'\xe9clairage avec une seule commande.","longDescription":"Cela active ou d\xe9sactive la fonction d\'une touche, comme un interrupteur. C\'est utile pour les cl\xe9s que vous souhaitez conserver pendant une dur\xe9e ind\xe9termin\xe9e. Vous pouvez l\'utiliser pour conserver la m\xeame action pour l\'appui sur une touche et pour le rel\xe2chement ou l\'arr\xeat d\'une touche.","example":"Dites \xab Toggle Run \xbb pour commencer \xe0 courir. Dites \xab\xa0Toggle Run\xa0\xbb pour arr\xeater de fonctionner.","label":"Basculer <strong>{{value}}</strong>","add":"Ajouter une cl\xe9/un bouton pour basculer","remove":"Supprimer la bascule de cl\xe9"},"pause":{"title":"Pause","description":"Ajoutez un bref d\xe9lai entre les actions.","longDescription":"Cette fonction vous permet d\'ins\xe9rer un bref d\xe9lai entre les actions, ce qui est essentiel dans les situations o\xf9 une action doit \xeatre compl\xe8tement termin\xe9e avant que la suivante ne commence. Par exemple, si vous utilisez une commande pour mettre le texte en gras dans un document, vous devrez peut-\xeatre d\'abord ouvrir un menu contextuel. La fonction Pause donne suffisamment de temps pour que le menu contextuel s\'ouvre et devienne actif avant de passer \xe0 l\'\xe9tape suivante, garantissant ainsi un fonctionnement fluide et sans erreur.","example":"Imaginez que vous modifiez un document \xe0 l\'aide de commandes vocales. Vous dites \xab Formater le texte \xbb, ce qui ouvre un menu contextuel. Ensuite, apr\xe8s une br\xe8ve pause pour permettre au menu d\'appara\xeetre enti\xe8rement, vous dites \xab\xa0Gras\xa0\xbb pour appliquer une mise en forme en gras au texte s\xe9lectionn\xe9. La fonction Pause garantit que le menu contextuel est pr\xeat \xe0 recevoir votre prochaine commande.","label":"Pause pendant <strong>{{value}}</strong>\xa0millisecondes"},"type":{"title":"Taper","field":"Phrase \xe0 saisir","placeholder":"phrase dactylographi\xe9e","question":"Quel texte souhaitez-vous taper ?","description":"\xc9crivez du texte comme si vous utilisiez un clavier.","longDescription":"Cela imite la saisie d\u2019une cha\xeene de texte, comme si vous tapiez sur un clavier. C\'est id\xe9al pour saisir du texte plus long sans avoir besoin d\'appuyer sur chaque touche. Si vous souhaitez saisir du texte de mani\xe8re dynamique, vous pouvez utiliser la fonction Dict\xe9e.","example":"Dites \xab\xa0Nom\xa0\xbb pour saisir \xab\xa0Bonjour, je m\'appelle Ellen Ripley\xa0\xbb. dans une fen\xeatre de discussion.","label":"Tapez <strong>{{value}}</strong>"},"mouseMove":{"title":"D\xe9placez la souris","description":"D\xe9placez le pointeur sur l\'\xe9cran.","longDescription":"D\xe9placez le curseur ou le pointeur de votre \xe9cran sans souris physique. Ceci est particuli\xe8rement utile pour les utilisateurs ayant une mobilit\xe9 limit\xe9e des mains. Ceci est utile pour un contr\xf4le pr\xe9cis des mouvements de la souris, n\xe9cessaire dans certains jeux. Si vous souhaitez simuler tous les mouvements de la souris en utilisant le mouvement de votre t\xeate, vous pouvez essayer le \xab\xa0Mouvement de la t\xeate pour le contr\xf4le de la souris\xa0\xbb dans les param\xe8tres de la cam\xe9ra.","example":"Dites \xab\xa0D\xe9placer la souris vers la droite\xa0\xbb pour d\xe9placer le curseur vers la droite de 100\xa0px.","moveX":"D\xe9placement de la souris vers la gauche/droite","numberMoveX":"Nombre de pixels \xe0 d\xe9placer vers la gauche/droite","moveY":"D\xe9placement de la souris vers le haut/bas des pixels","numberMoveY":"Nombre de pixels \xe0 d\xe9placer vers le haut/bas","label":"D\xe9placez la souris <strong>{{value}}</strong>","command":"D\xe9placement de la souris\xa0: {{commande}}","commandLabel":"D\xe9placement de la souris","startCommand":"D\xe9placement de la souris D\xe9but","stopCommand":"Arr\xeater le d\xe9placement de la souris"},"joystickMove":{"title":"D\xe9placer les joysticks","description":"Utilisez un joystick pour d\xe9placer les \xe9l\xe9ments sur l\'\xe9cran.","longDescription":"Cette fonction simule le mouvement d\'un joystick. Par exemple, si vous rencontrez des difficult\xe9s pour utiliser un joystick physique, vous pouvez utiliser une commande vocale ou une autre m\xe9thode de saisie pour d\xe9placer virtuellement un joystick.","example":"Dites \xab\xa0D\xe9placer le joystick vers la gauche\xa0\xbb pour d\xe9placer le joystick vers la gauche de 100\xa0px.","prefix":"D\xe9placez le joystick gauche","left":"Manette gauche","leftX":"X gauche","leftY":"Y gauche","right":"Manette droite","rightX":"X droit","rightY":"Y droit","x":"Force de l\'axe X","y":"Force de l\'axe Y","moveXLabel":"D\xe9placer X\xa0:\xa0{{value}}","moveYLabel":"D\xe9placement Y\xa0:\xa0{{value}}","labelLeft":"D\xe9placez le joystick gauche ","labelRight":"D\xe9placez le joystick droit ","latch":"Le loquet maintiendra la position jusqu\'\xe0 ce que vous le rel\xe2chiez \xe0 l\'aide d\'une commande \xab\xa0Arr\xeater tout\xa0\xbb."},"playAudio":{"title":"Lire l\'audio","placeholder":"phrase de d\xe9claration que Cephable dira","description":"Jouez un son, un mot ou une phrase.","longDescription":"Cette fonction permet aux utilisateurs de convertir des phrases saisies en mots prononc\xe9s. C\'est particuli\xe8rement utile pour les personnes qui peuvent avoir des difficult\xe9s \xe0 parler. En tapant une phrase, la fonction PlayAudio articulera le texte \xe0 haute voix \xe0 l\'aide d\'une parole synth\xe9tis\xe9e. Cela peut faciliter la communication ou dans les situations o\xf9 un utilisateur a besoin de relayer des informations verbalement mais pr\xe9f\xe8re ou n\xe9cessite une alternative \xe0 l\'utilisation de sa propre voix.","example":"Souriez pour jouer le mot \xab\xa0Bonjour\xa0\xbb.","label":"Dites <strong>{{value}}</strong>"},"stopOutputs":{"title":"Arr\xeater toutes les sorties","titleLong":"Arr\xeatez toutes les sorties (rel\xe2chez toutes les touches et boutons, arr\xeatez tous les mouvements de la souris, arr\xeatez toute saisie)","description":"Arr\xeatez toutes les actions en cours comme l\'appui sur une touche.","longDescription":"Arr\xeatez imm\xe9diatement toutes les sorties ou actions en cours. Il s\'agit d\'une fonction de s\xe9curit\xe9 ou de commodit\xe9 permettant d\'arr\xeater tout processus. Nous le ferons automatiquement pour vous lorsque vous fermez ou mettez en pause les commandes de la cam\xe9ra ou du microphone.","example":"Dites \xab\xa0Stop\xa0\xbb pour arr\xeater toutes les sorties.","label":"Arr\xeatez toutes les sorties et rel\xe2chez les touches"},"custom":{"title":"Coutume"},"options":{"moveUp":"D\xe9placer vers le haut","moveDown":"Descendre","moveLeft":"Se d\xe9placer \xe0 gauche","moveRight":"D\xe9placer vers la droite","copyStep":"\xc9tape de copie","removeStep":"Supprimer l\'\xe9tape"},"directions":{"up":"En haut","down":"Vers le bas","left":"Gauche","right":"Droite"}},"expression":{"title":"Expression du visage","titlePlural":"Expressions du visage","label":"Expression / Geste","start":"D\xe9marrer les contr\xf4les d\u2019expression","startSmiling":{"title":"Commencez \xe0 sourire","description":"Si vous commencez \xe0 sourire sans sourire, puis \xe0 sourire, cette commande se d\xe9clenchera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande \xab\xa0Ouvrir/Fermer la bouche\xa0\xbb peut entra\xeener des conflits."},"stopSmiling":{"title":"Arr\xeatez de sourire","description":"Si vous souriez puis cessez, cette commande s\'activera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande \xab\xa0Ouvrir/Fermer la bouche\xa0\xbb peut entra\xeener des conflits."},"eyebrows":{"title":"L\xe8ve sourcils","description":"Si vous soulevez vos deux sourcils par rapport \xe0 votre position de repos de base, cette commande se d\xe9clenchera."},"openMouth":{"title":"Bouche ouverte","description":"Si votre bouche est ferm\xe9e (ou l\xe9g\xe8rement ouverte), et que vous l\'ouvrez davantage, cette commande se d\xe9clenchera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande du sourire peut entra\xeener des conflits."},"closeMouth":{"title":"Fermer la bouche","description":"Si votre bouche est ouverte et que vous la fermez compl\xe8tement, cette commande se d\xe9clenchera. Remarque\xa0: l\'utilisation de cette commande dans les m\xeames commandes d\'application que la commande de sourire peut entra\xeener des conflits."},"description":"Am\xe9liorez votre exp\xe9rience num\xe9rique gr\xe2ce aux expressions faciales. Utilisez des gestes comme lever les sourcils, sourires et autres mouvements pour contr\xf4ler facilement le pointeur de votre souris, effectuer des actions ou personnaliser vos interactions."},"head":{"title":"Mouvement de la t\xeate","titlePlural":"Mouvements de t\xeate","label":"Mouvement de la t\xeate/du corps","question":"Quel type de mouvement souhaitez-vous utiliser ?","tilt":{"title":"Inclinaison de la t\xeate","left":{"title":"Incliner la t\xeate vers la gauche","description":"Si vous regardez la cam\xe9ra et inclinez la t\xeate vers la gauche, cette commande se d\xe9clenchera."},"right":{"title":"Incliner la t\xeate vers la droite","description":"Si vous regardez la cam\xe9ra et inclinez la t\xeate vers la droite, cette commande se d\xe9clenchera."},"back":{"title":"Incliner la t\xeate vers l\'arri\xe8re","description":"Si vous regardez la cam\xe9ra, inclinez la t\xeate en arri\xe8re et regardez vers le haut, cette commande se d\xe9clenchera."},"forward":{"title":"Incliner la t\xeate vers l\'avant","description":"Si vous regardez la cam\xe9ra et inclinez la t\xeate vers l\u2019avant et regardez vers le bas, cette commande se d\xe9clenchera."},"description":"Inclinez votre t\xeate vers la gauche ou la droite pour un contr\xf4le am\xe9lior\xe9 ou une navigation avec la souris."},"turn":{"title":"Tour de t\xeate","left":{"title":"Tourner la t\xeate \xe0 gauche","description":"Si vous regardez la cam\xe9ra et tournez la t\xeate et regardez vers votre gauche, cette commande se d\xe9clenchera."},"right":{"title":"Tourner la t\xeate \xe0 droite","description":"Si vous regardez la cam\xe9ra et tournez la t\xeate et regardez vers votre droite, cette commande se d\xe9clenchera."},"description":"Tournez la t\xeate vers la gauche ou la droite pour un contr\xf4le am\xe9lior\xe9 ou une navigation avec la souris."},"lean":{"title":"T\xeate maigre","left":{"title":"Pencher la t\xeate \xe0 gauche","description":"Si vous regardez la cam\xe9ra et que vous vous penchez vers la gauche pour que votre visage soit plus \xe0 gauche dans le cadre de la cam\xe9ra, cette commande se d\xe9clenchera."},"right":{"title":"Pencher la t\xeate \xe0 droite","description":"Si vous regardez la cam\xe9ra et que vous vous penchez vers la droite pour que votre visage soit plus \xe0 droite dans le cadre de la cam\xe9ra, cette commande se d\xe9clenchera."},"back":{"title":"Pencher la t\xeate en arri\xe8re","description":"Si vous regardez la cam\xe9ra et que vous vous penchez en arri\xe8re pour que votre visage soit plus \xe9loign\xe9 de la cam\xe9ra, cette commande se d\xe9clenchera."},"forward":{"title":"Penchez-vous la t\xeate en avant","description":"Si vous regardez la cam\xe9ra et que vous vous penchez en avant pour que votre visage soit plus proche de la cam\xe9ra, cette commande se d\xe9clenchera."},"up":{"title":"D\xe9placer le corps vers le haut","description":"Si vous regardez la cam\xe9ra et que vous relevez la t\xeate en \xe9tirant votre cou ou en d\xe9pla\xe7ant tout votre corps vers le haut, cette commande se d\xe9clenchera."},"down":{"title":"Descendre le corps","description":"Si vous regardez la cam\xe9ra et baissez la t\xeate en froissant le cou, en vous baissant ou en abaissant tout votre corps, cette commande se d\xe9clenchera."},"center":{"title":"Centrez votre t\xeate","description":"Si vous regardez la cam\xe9ra et d\xe9placez votre t\xeate vers la position centrale correspondant \xe0 la ligne de base, cette commande se d\xe9clenchera."},"description":"Penchez votre t\xeate vers la gauche ou la droite pour un meilleur contr\xf4le ou une meilleure navigation avec la souris."},"description":"Contr\xf4lez votre appareil ou votre connexion par des mouvements de t\xeate comme incliner, hocher la t\xeate ou tourner. Gr\xe2ce \xe0 la cam\xe9ra de votre appareil, Cephable garantit une exp\xe9rience priv\xe9e et intuitive pour un contr\xf4le et une navigation optimis\xe9s."},"voice":{"title":"Commande vocale","titlePlural":"Commandes vocales","placeholder":"Voix ou phrase que Cephable \xe9coutera","question":"Quelle d\xe9claration ou expression voulez-vous dire pour ce contr\xf4le\xa0?","when":"Quand je dis...","say":"Dites \xab\xa0{{value}}\xa0\xbb","load":{"fail":{"title":"{{language}} Commandes vocales indisponibles","description":"Oh non! Nous n\'avons pas pu charger {{language}} pour les commandes vocales. S\'il vous pla\xeet, v\xe9rifiez votre connexion \xe0 internet et r\xe9essayez. Utiliser l\'anglais (\xc9tats-Unis) jusqu\'\xe0 ce que la connexion soit r\xe9tablie."}},"description":"Activer le microphone permet des commandes vocales intelligentes et naturelles, permettant aux utilisateurs d\'interagir facilement avec leur ordinateur, que ce soit pour les applications ou les logiciels. Ex\xe9cutez des commandes ou dictez du texte en parlant naturellement, pour une exp\xe9rience intuitive et intuitive."},"motion":{"title":"Contr\xf4le de mouvement","titlePlural":"Commandes de mouvement","question":"Quel type de mouvement avec un t\xe9l\xe9phone ou une tablette souhaitez-vous utiliser\xa0?","start":"D\xe9marrer les commandes de mouvement","settings":"Param\xe8tres de mouvement","descriptionShort":"Inclinez, tournez ou secouez votre appareil pour contr\xf4ler Cephable.","description":"Les commandes de mouvement vous permettent de transformer les mouvements de votre t\xe9l\xe9phone ou de votre tablette dans l\'application Companion en commandes pour votre appareil. Inclinez ou secouez votre t\xe9l\xe9phone dans diff\xe9rentes directions pour cr\xe9er de nouvelles sorties.","up":{"title":"Inclinez votre appareil vers le haut","description":"Si votre appareil est \xe0 plat sur une surface et que vous l\'inclinez vers vous, cette commande se d\xe9clenchera."},"down":{"title":"Inclinez votre appareil vers le bas","description":"Si votre appareil est \xe0 plat sur une surface et que vous l\'inclinez pour qu\'il soit face \xe0 vous, cette commande se d\xe9clenchera."},"left":{"title":"Inclinez votre appareil vers la gauche","description":"Si votre appareil est plat sur une surface et que vous l\'inclinez vers la gauche pour faire face vers la gauche, cette commande se d\xe9clenchera."},"right":{"title":"Inclinez votre appareil vers la droite","description":"Si votre appareil est plat sur une surface et que vous l\'inclinez vers la droite, cette commande se d\xe9clenchera."},"shake":{"title":"Secouez votre appareil","description":"Si vous secouez votre appareil, cette commande se d\xe9clenchera."},"edit":{"title":"Modifier les param\xe8tres de mouvement","description":"Modifiez vos param\xe8tres de contr\xf4le de mouvement pour ajuster la quantit\xe9 dont vous avez besoin pour d\xe9placer votre t\xe9l\xe9phone pendant l\'ex\xe9cution vers l\'application Companion.","sensitivity":{"title":"Param\xe8tres de sensibilit\xe9 du contr\xf4le de mouvement","description":"La sensibilit\xe9 indique \xe0 Cephable jusqu\'o\xf9 vous devez incliner votre appareil pour d\xe9clencher un contr\xf4le. Plus la valeur est grande (la plus \xe0 droite sur le curseur), plus la sensibilit\xe9 est \xe9lev\xe9e, et donc moins il faut incliner pour d\xe9clencher la commande."},"tilt":{"title":"Sensibilit\xe9 \xe0 l\'inclinaison","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez incliner votre appareil vers le haut, le bas, la gauche et la droite pour qu\'une entr\xe9e soit reconnue."},"mouse":{"title":"Commandes de mouvement pour le mouvement de la souris","description":"D\xe9terminez si et comment vous souhaitez utiliser les commandes de mouvement pour d\xe9placer votre souris au lieu de d\xe9clencher les commandes","enable":{"title":"Activer les commandes de mouvement pour le mouvement de la souris","description":"Si cette option est activ\xe9e, certaines de vos commandes de mouvement seront utilis\xe9es pour d\xe9placer votre souris au lieu de d\xe9clencher des commandes.","option":"Utiliser les commandes de mouvement pour les mouvements de la souris\xa0?"},"invert":{"title":"Inverser le mouvement de la souris","description":"Pour l\'axe X\xa0: si cette option est activ\xe9e, un d\xe9placement vers la gauche d\xe9placera votre souris vers la droite et un d\xe9placement vers la droite la d\xe9placera vers la gauche. Pour l\'axe Y\xa0: si cette option est activ\xe9e, le fait de descendre d\xe9placera votre souris vers le haut et le fait de monter la fera descendre.","x":"Inverser le mouvement de la souris sur l\'axe X\xa0?","y":"Inverser le mouvement de la souris sur l\'axe Y\xa0?"}}}},"keys":{"title":"Cl\xe9 ou bouton","titlePlural":"Touches ou boutons","label":"Cl\xe9/bouton externe","question":"Sur quelle touche ou bouton souhaitez-vous appuyer\xa0?","edit":"Modifier les touches et les boutons","defaultOption":"Inclure les commandes vocales par d\xe9faut pour les touches et les clics de souris\xa0?","description":"Les touches et les boutons vous permettent de mapper vos diff\xe9rentes commandes d\'entr\xe9e aux pressions du clavier et des boutons du contr\xf4leur.","then":"Cephable va appuyer...","empty":"Aucun contr\xf4le cl\xe9 ne correspond \xe0 ces crit\xe8res.","backspace":"Retour arri\xe8re","delete":"Supprimer","enter":"Entrer","space":"Barre d\'espace","tab":"Languette","shift":"Changement","ctrl":"Ctrl","leftCtrl":"Ctrl gauche","rightCtrl":"Ctrl droit","leftShift":"D\xe9calage \xe0 gauche","rightShift":"Maj droite","alt":"Tout","leftAlt":"Alt gauche","escape":"S\'\xe9chapper","up":"Fl\xe8che vers le haut","down":"Fl\xe8che vers le bas","left":"Fl\xe8che gauche","right":"Fl\xe8che droite","command":"Commande","caps":"Verrouillage des majuscules","reset":{"title":"R\xe9initialiser les raccourcis clavier","confirm":"R\xe9initialiser tous les raccourcis clavier\xa0?","confirmDescription":"Choisissez comment r\xe9initialiser les raccourcis clavier. Cette action est irr\xe9versible sans enregistrement.","confirmButton":"R\xe9initialiser les raccourcis clavier","defaultOption":"R\xe9tablir les valeurs par d\xe9faut pour la langue actuelle","emptyOption":"R\xe9initialiser \xe0 z\xe9ro (effacer toutes les commandes)"}},"talkback":{"title":"R\xe9pondre","question":"Que veux-tu que C\xe9phable dise ?","description":"Configurez des contr\xf4les qui permettront \xe0 Cephable de parler pour vous. Vous pouvez attribuer des commandes aux diff\xe9rentes phrases que vous souhaitez prononcer.","thenMacro":"alors C\xe9phable dira...","empty":"Il n\'existe aucun contr\xf4le de r\xe9ponse correspondant \xe0 ces crit\xe8res.","add":"Ajouter un nouveau contr\xf4le Talkback","remove":"Supprimer le contr\xf4le Talkback","edit":"Modifier les commandes Talkback","deprecatedNotice":"Talkback est d\xe9sormais int\xe9gr\xe9 directement aux commandes principales de l\'application. Vos commandes d\'application comportent d\'anciens \xe9v\xe9nements Talkback qui doivent \xeatre mis \xe0 jour."},"dictation":{"title":"Dictation","question":"Quelle phrase doit d\xe9clencher le mode dict\xe9e\xa0?","thenMacro":"C\xe9phable va...","empty":"Il n\'existe aucun contr\xf4le de dict\xe9e correspondant \xe0 ces crit\xe8res.","type":"taper","edit":"Modifier les phrases de dict\xe9e","remove":"Supprimer une phrase de dict\xe9e","add":"Ajouter une nouvelle phrase de dict\xe9e","on":"Dict\xe9e","off":"Commandes","onboarding":{"tourLabel":"Dict\xe9e","learn":"Apprenez \xe0 utiliser le mode dict\xe9e pour convertir votre discours en texte en mains libres.","welcome":{"title":"Dict\xe9e","description":"La dict\xe9e vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C\'est comme avoir un assistant personnel qui saisit tout ce que vous dites."},"microphone":{"title":"Allumez votre microphone","description":"Tout d\'abord, activez votre microphone. Cliquez sur l\'ic\xf4ne \xab\xa0Microphone\xa0\xbb dans le panneau Cephable."},"activate":{"title":"D\xe9marrer le mode dict\xe9e","description":"La voix d\xe9marre en mode commande. Pour lancer la dict\xe9e, dites \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb ou cliquez sur le bouton \xab\xa0Dict\xe9e\xa0\xbb. Activons maintenant le mode dict\xe9e."},"speaking":{"title":"Cliquez sur un document ou un champ et commencez \xe0 parler","description":"La dict\xe9e enregistre en temps r\xe9el ce que vous dites. Cliquez sur un champ de texte ou un document, puis commencez \xe0 parler. Par exemple, dites\xa0: \xab\xa0Voici comment utiliser le mode dict\xe9e.\xa0\xbb"},"pauseResume":{"title":"Pause de la dict\xe9e","description":"Besoin d\'une pause sans d\xe9sactiver la dict\xe9e\xa0? Dites simplement \xab\xa0Suspendre la dict\xe9e\xa0\xbb. Vous pouvez la reprendre \xe0 tout moment avec \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb. Vous pouvez personnaliser davantage cette option gr\xe2ce aux commandes globales et aux commandes de l\'appareil toujours actives."},"stop":{"title":"Arr\xeater la dict\xe9e","description":"Besoin de revenir aux commandes de votre application\xa0? Dites simplement \xab\xa0Arr\xeater la dict\xe9e\xa0\xbb. Cela arr\xeatera le mode dict\xe9e et vous ram\xe8nera au mode commande. Vous pouvez reprendre \xe0 tout moment en cliquant \xe0 nouveau sur \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb."},"complete":{"title":"Bravo!","description":"Et voil\xe0\xa0! Vous pouvez d\xe9sormais dicter, mettre en pause, reprendre et passer du mode dict\xe9e au mode commande. La dict\xe9e est un outil puissant pour la saisie mains libres. Utilisez-la pour r\xe9diger des e-mails, des documents ou tout ce que vous devez saisir \xe0 voix haute."}},"description":"La dict\xe9e vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C\'est comme avoir un assistant personnel qui saisit tout ce que vous dites.","settings":{"title":"Dict\xe9e","description":"Comment commence la dict\xe9e et que deviennent vos mots avant d\'\xeatre tap\xe9s."},"hold":{"enabled":{"option":"Tenir \xe0 dicter","description":"Maintenez enfonc\xe9es les touches ci-dessous, et rien d\'autre, pour commencer \xe0 dicter. Rel\xe2chez-les pour saisir votre texte."},"keys":{"title":"Cl\xe9s \xe0 tenir","description":"Appuyer sur n\'importe quelle autre touche tout en maintenant ces touches enfonc\xe9es annule l\'action\xa0; vos raccourcis habituels continuent donc de fonctionner."},"duration":{"title":"Temps d\'attente","description":"Combien de temps faut-il maintenir les touches enfonc\xe9es avant que la dict\xe9e ne commence\xa0?"},"transcribing":"Transcription...","aiRewriting":"R\xe9\xe9criture par IA...","result":"{{words}} mots en {{seconds}}s","resultRewritten":"{{words}} mots en {{seconds}}s, IA {{rewriteSeconds}}s","typing":"Dactylographie...","permission":{"title":"L\'obligation de dicter attend la permission","description":"Autorisez l\'acc\xe8s \xe0 Cephable dans Param\xe8tres syst\xe8me > Confidentialit\xe9 et s\xe9curit\xe9 > {{pane}}. Maintenez la pression pour dicter\xa0: la fonction d\xe9marre d\xe8s que vous le faites."},"unavailable":"La fonction \xab\xa0Maintenir pour dicter\xa0\xbb n\'a pas pu d\xe9marrer l\'\xe9coute des touches. Red\xe9marrez Cephable pour r\xe9essayer."},"aiRewrite":{"option":"R\xe9\xe9criture par IA des dict\xe9es longues","description":"Avant la saisie d\'une dict\xe9e longue, l\'IA int\xe9gr\xe9e \xe0 l\'appareil corrige la ponctuation, supprime les mots de remplissage et les erreurs, puis formate le texte pour l\'application utilis\xe9e. La dict\xe9e courte est retranscrite telle que vous l\'avez prononc\xe9e. Un court d\xe9lai est ajout\xe9 avant la saisie."}},"face":{"title":"Expression du visage","titlePlural":"Expressions du visage","try":"Essayez les contr\xf4les d\'expression du visage","question":"Quel type d\u2019expression de visage souhaitez-vous utiliser\xa0?","descriptionShort":"Utilisez diff\xe9rents mouvements du visage pour des contr\xf4les am\xe9lior\xe9s.","description":"Les expressions faciales font partie des Contr\xf4les d\'expression. Elles vous permettent d\'utiliser diff\xe9rents mouvements du visage pour des contr\xf4les am\xe9lior\xe9s. Vous pouvez utiliser les mouvements des sourcils, de la bouche, etc. pour cr\xe9er diff\xe9rents rendus."},"other":{"title":"Autre","titlePlural":"Autres contr\xf4les","label":"Autre contr\xf4le","placeholder":"autre commande exp\xe9rimentale","question":"Quelle commande suppl\xe9mentaire souhaitez-vous utiliser\xa0? Ces commandes sont g\xe9n\xe9ralement destin\xe9es aux connexions non Cephable qui ne correspondent pas aux autres cat\xe9gories. Elles peuvent \xe9galement fonctionner comme des commandes vocales lorsque vous prononcez le mot ou la phrase sp\xe9cifi\xe9. Remarque\xa0: ces commandes sont exp\xe9rimentales et peuvent ne pas \xeatre enti\xe8rement prises en charge.","description":"Les autres commandes sont exp\xe9rimentales et peuvent ne pas \xeatre enti\xe8rement prises en charge. Elles peuvent \xeatre utilis\xe9es pour des connexions non Cephable ou comme commandes vocales lorsque vous prononcez le mot ou la phrase sp\xe9cifi\xe9."},"support":{"title":"Soutien","profiles":"Introduction aux contr\xf4les d\'application","question":"Vous ne trouvez toujours pas ce dont vous avez besoin ?","more":"Apprenez-en plus sur Cephable.com avec des guides \xe9tape par \xe9tape, des tutoriels, des vid\xe9os et plus encore."},"community":{"title":"Rejoignez la communaut\xe9","description":"Obtenez du soutien, partagez des id\xe9es ou devenez membre des communaut\xe9s Cephable.","discord":"Communaut\xe9 Discorde","facebook":"Groupe Facebook"},"resources":{"title":"Ressources utiles","description":"Trouvez les r\xe9ponses \xe0 vos questions sur les caract\xe9ristiques et fonctions de Cephable.","guides":"Guides \xe9tape par \xe9tape"},"feedback":{"title":"Retour","description":"Parlez-nous de votre exp\xe9rience avec Cephable.","contact":"Contactez-nous","feature":"Sugg\xe9rer une fonctionnalit\xe9","bug":"Signaler un probl\xe8me"},"settings":{"title":"Param\xe8tres","general":"Param\xe8tres g\xe9n\xe9raux de l\'application","description":"Il s\'agit de votre canevas pour personnaliser votre exp\xe9rience en affinant vos commandes.","orgTitle":"Param\xe8tres de {{ value }}","advanced":{"title":"Param\xe8tres avanc\xe9s","description":"Cliquez ici pour acc\xe9der aux param\xe8tres avanc\xe9s de votre IA, aux commandes de l\'application, aux connexions, aux extensions et plus encore."},"quick":"Voici les param\xe8tres contextuels du panneau. Utilisez-les pour personnaliser votre exp\xe9rience."},"account":{"title":"Compte","settings":"Param\xe8tres du compte","description":"Mettez \xe0 jour les informations cl\xe9s pour rester connect\xe9 avec Cephable.","usernameLabel":"Nom d\'utilisateur: ","emailLabel":"E-mail: ","password":{"change":"Changer le mot de passe","description":"Mettez \xe0 jour votre mot de passe pour s\xe9curiser votre compte.","old":"ancien mot de passe","current":"Votre mot de passe actuel","new":"nouveau mot de passe","desired":"Votre nouveau mot de passe souhait\xe9","confirm":"Confirmer le nouveau mot de passe","update":"Mettre \xe0 jour le mot de passe"},"isEmailVerified":{"title":"L\'email n\'est pas verifi\xe9.","description":"Votre email n\'est pas v\xe9rifi\xe9. Veuillez v\xe9rifier votre courrier \xe9lectronique pour un lien de v\xe9rification.","resend":"R\xe9-envoyer l\'email","success":"Nous vous avons envoy\xe9 un nouvel e-mail de v\xe9rification.","error":"Une erreur s\'est produite lors de l\'envoi de l\'e-mail de v\xe9rification. Veuillez r\xe9essayer plus tard.","org":"Votre adresse e-mail n\'est pas v\xe9rifi\xe9e. Elle est requise pour acc\xe9der aux informations de la licence. Veuillez consulter votre adresse e-mail pour obtenir un lien de v\xe9rification.","titleAlt":"V\xe9rifiez votre adresse e-mail","descriptionLong":"Bienvenue sur Cephable\xa0! Un e-mail de v\xe9rification a \xe9t\xe9 envoy\xe9 \xe0 {{email}}. Veuillez v\xe9rifier votre bo\xeete de r\xe9ception ou votre dossier spam et cliquer sur le lien. Si vous ne le voyez pas, vous pouvez renvoyer l\'e-mail de v\xe9rification.","appBlock":"Vous y \xeates presque\xa0! Un e-mail de v\xe9rification a \xe9t\xe9 envoy\xe9 \xe0 {{email}}. Veuillez consulter votre bo\xeete de r\xe9ception et cliquer sur le lien pour v\xe9rifier votre adresse e-mail. Si vous ne le voyez pas, v\xe9rifiez vos spams."},"signout":{"title":"Se d\xe9connecter","question":"\xcates-vous certain de vouloir vous d\xe9connecter?","confirm":"Oui, d\xe9connectez-vous","warn":{"title":"Vous \xeates sur le point d\u2019\xeatre d\xe9connect\xe9.","description":"Il semblerait que vous ayez \xe9t\xe9 inactif pendant un certain temps. Pour des raisons de s\xe9curit\xe9, nous vous d\xe9connecterons dans XX secondes. Si vous souhaitez rester connect\xe9, cliquez sur \xab\xa0Rester connect\xe9\xa0\xbb ci-dessous.","confirm":"Rester connect\xe9","cancel":"D\xe9connectez-vous maintenant"},"description":"Une fois d\xe9connect\xe9, cette connexion sera supprim\xe9e de votre compte et ne sera plus visible depuis l\'application Companion ou d\'autres connexions.","confirmDescription":"Vous d\xe9connecter et supprimer cette connexion"},"marketing":{"title":"Pr\xe9f\xe9rences de messagerie","description":"Mettez \xe0 jour vos pr\xe9f\xe9rences de messagerie pour recevoir des mises \xe0 jour et des nouvelles de Cephable.","marketing":"E-mails marketing","optIn":"Je souhaite recevoir des tutoriels, des conseils, des mises \xe0 jour et des newsletters pour am\xe9liorer mon exp\xe9rience Cephable"},"error":{"save":"Erreur lors de l\'enregistrement des param\xe8tres du compte.","password":"Erreur lors de la mise \xe0 jour du mot de passe.","signout":"Erreur de d\xe9connexion.","old":"L\'ancien mot de passe est requis.","new":"Un nouveau mot de passe est requis.","match":"Les mots de passe ne correspondent pas.","marketing":"Erreur lors de la mise \xe0 jour des pr\xe9f\xe9rences de messagerie.","userPreferences":"Erreur lors de l\'enregistrement des pr\xe9f\xe9rences utilisateur."},"success":{"save":"Param\xe8tres du compte enregistr\xe9s.","password":"Mot de passe mis \xe0 jour.","marketing":"Pr\xe9f\xe9rences de courrier \xe9lectronique mises \xe0 jour.","userPreferences":"Pr\xe9f\xe9rences utilisateur mises \xe0 jour."},"userPreferences":{"title":"Pr\xe9f\xe9rences de l\'utilisateur","description":"Mettez \xe0 jour vos pr\xe9f\xe9rences pour cr\xe9er l\'exp\xe9rience Cephable qui vous convient.","warningOptOut":"Masquer les avertissements lorsque j\'enregistre ou mets \xe0 jour les contr\xf4les de l\'application","enableTranscribeTask":"Activer la t\xe2che de transcription de fichiers exp\xe9rimentaux dans le panneau Cephable","enableGamepadSupport":"Activer la prise en charge de la manette pour le pilote local et l\'\xe9mulation du contr\xf4leur Xbox","enableMetrics":"Activez l\'affichage des m\xe9triques d\'utilisation pour les tests de performance. Vous pourrez t\xe9l\xe9charger les journaux.","enableCameraControls":"Activez les commandes de la cam\xe9ra dans le panneau Cephable","enableWorkflowRecording":"Activer l\'aper\xe7u de l\'enregistrement d\'un flux de travail dans les comp\xe9tences d\'automatisation et d\'IA"},"menu":"Menu utilisateur","delete":{"title":"Supprimer le compte","description":"Vous pouvez supprimer d\xe9finitivement votre compte et effacer toute trace de vos informations personnelles. La suppression de votre compte entra\xeenera la suppression de vos connexions, qui ne seront plus actives ni associ\xe9es \xe0 votre compte. Vos param\xe8tres et commandes d\'application seront \xe9galement perdus. Cette action est irr\xe9versible.","button":"Supprimer d\xe9finitivement le compte","confirmation":"\xcates-vous s\xfbr de vouloir supprimer votre compte\xa0?","note":"Cette action est irr\xe9versible.","confirm":"Oui, supprimez mon compte"},"communication":{"title":"Pr\xe9f\xe9rences de communication"},"name":{"title":"Nom d\'affichage"},"email":{"title":"Adresse e-mail","description":"Votre adresse e-mail enregistr\xe9e"}},"appSettings":{"description":"Ces param\xe8tres s\'appliquent uniquement \xe0 cette application. Si vous souhaitez modifier les param\xe8tres de l\'application Cephable sur un autre ordinateur ou appareil mobile, modifiez les param\xe8tres dans cette application.","autostart":{"title":"D\xe9marrer automatiquement Cephable","description":"Avec ce param\xe8tre activ\xe9, l\'application Cephable d\xe9marrera automatiquement lorsque vous vous connecterez \xe0 votre appareil. Si vous disposez \xe9galement de commandes automatiques de voix et d\u2019expression, celles-ci d\xe9marreront \xe9galement imm\xe9diatement.","question":"D\xe9marrage automatique de l\'application Cephable\xa0?"},"position":{"topLeft":"En haut \xe0 gauche","top":"Centre sup\xe9rieur","topRight":"En haut \xe0 droite","bottom":"En bas au centre","bottomLeft":"En bas \xe0 gauche","bottomRight":"En bas \xe0 droite","label":"S\xe9lectionner la position d\'alimentation de commande","description":"S\xe9lectionnez l\u2019endroit o\xf9 vous souhaitez que le flux de commandes apparaisse sur votre \xe9cran."},"micPosition":{"title":"Position de la fen\xeatre d\'entr\xe9e du microphone","description":"S\xe9lectionnez l\'endroit o\xf9 vous souhaitez que les commandes du microphone pour la voix et la dict\xe9e soient positionn\xe9es sur votre \xe9cran.","label":"S\xe9lectionnez la position de la fen\xeatre d\u2019entr\xe9e du microphone"},"cameraPosition":{"title":"Position de la fen\xeatre d\'entr\xe9e de la cam\xe9ra","description":"S\xe9lectionnez l\'endroit o\xf9 vous souhaitez que les commandes de la cam\xe9ra pour les mouvements du visage et de la t\xeate soient positionn\xe9es sur votre \xe9cran.","label":"S\xe9lectionner la position de la fen\xeatre d\'entr\xe9e de la cam\xe9ra"},"theme":{"title":"Th\xe8me","description":"Choisissez un th\xe8me qui correspond \xe0 votre style.","label":"S\xe9lectionnez un th\xe8me","light":"Lumi\xe8re","dark":"Sombre","system":"Utiliser les param\xe8tres du syst\xe8me d\'exploitation"},"overlay":{"title":"Flux de commandes","description":"Le flux de commandes affiche les diff\xe9rentes commandes que vous utilisez et celles envoy\xe9es \xe0 votre ordinateur. Il est accessible par clic, mais il est toujours visible par-dessus les autres fen\xeatres. Lorsque ce param\xe8tre est activ\xe9, l\'application Cephable s\'affiche et est toujours visible par-dessus les autres fen\xeatres et applications.","question":"Afficher le flux de commandes\xa0?"},"transparent":{"title":"Transparence du flux de commandes","description":"D\xe9termine l\'opacit\xe9 du texte. Plus la valeur est faible, plus le flux sera transparent."},"panelAutoHide":{"title":"Masquer automatiquement le panneau Cephable","delay":"Attendre avant de se cacher","denominator":"secondes","time":"{{value}} secondes"},"title":"Param\xe8tres g\xe9n\xe9raux de l\'application","scale":{"description":"Ajustez la taille du texte dans toute l\'application.","label":"Taille du texte","small":"Petit","large":"Grand"},"panelScale":{"description":"Ajustez la taille du bouton du panneau r\xe9duit.","label":"Taille des boutons du panneau"},"aiNewFiles":{"title":"Dossier pour les nouveaux fichiers IA","description":"Choisissez l\'emplacement o\xf9 l\'agent IA enregistre les nouveaux fichiers par d\xe9faut, sauf si vous lui indiquez un emplacement pr\xe9cis. Si vous conservez la valeur par d\xe9faut, les nouveaux fichiers sont enregistr\xe9s dans un dossier \xab Cephable-Work \xbb de votre dossier personnel, cr\xe9\xe9 automatiquement lors de la premi\xe8re utilisation.","selectButton":"S\xe9lectionner un dossier","clearButton":"Utiliser le dossier par d\xe9faut","current":"Les nouveaux fichiers sont enregistr\xe9s dans : {{folder}}","default":"Les nouveaux fichiers sont enregistr\xe9s dans le dossier par d\xe9faut \xab Cephable-Work \xbb de votre dossier personnel.","openButton":"Ouvrir le dossier","openError":"Impossible d\'ouvrir le dossier. Il a peut-\xeatre \xe9t\xe9 d\xe9plac\xe9 ou supprim\xe9."},"aiWorkspace":{"title":"Dossier Espace de travail IA","description":"Choisissez un dossier que l\'agent IA embarqu\xe9 utilisera pour rechercher, lire et modifier des fichiers, ainsi que pour ex\xe9cuter des commandes. Par d\xe9faut, l\'agent a acc\xe8s \xe0 l\'int\xe9gralit\xe9 de votre ordinateur.","selectButton":"S\xe9lectionner un dossier","clearButton":"Utiliser l\'int\xe9gralit\xe9 de l\'ordinateur","current":"Dossier de l\'espace de travail actuel\xa0:","none":"Aucun dossier d\'espace de travail s\xe9lectionn\xe9. L\'agent IA peut acc\xe9der \xe0 l\'int\xe9gralit\xe9 de votre ordinateur.","restrictQuestion":"Limiter l\'agent IA \xe0 ce dossier uniquement.","restrictDescription":"Lorsqu\'elle est activ\xe9e, l\'interface d\'IA permet aux outils de fichiers et de commandes de l\'agent de lire ou de modifier tout \xe9l\xe9ment situ\xe9 en dehors du dossier s\xe9lectionn\xe9."},"documentTemplates":{"title":"Mod\xe8les de documents","description":"Choisissez un mod\xe8le de document que l\'agent IA utilisera pour cr\xe9er de nouveaux documents. Laissez le type par d\xe9faut Cephable pour appliquer le style de marque Cephable int\xe9gr\xe9. Word, PowerPoint et Excel poss\xe8dent chacun leur propre mod\xe8le.","word":"Mod\xe8le Word","wordDescription":"Mod\xe8le \xe0 partir duquel l\'agent d\'IA d\xe9marre pour les nouveaux documents Word (.docx).","powerpoint":"Mod\xe8le PowerPoint","powerpointDescription":"Mod\xe8le \xe0 partir duquel l\'agent d\'IA d\xe9marre pour les nouvelles pr\xe9sentations PowerPoint (.pptx).","excel":"Mod\xe8le Excel","excelDescription":"Mod\xe8le \xe0 partir duquel l\'agent d\'IA d\xe9marre pour les nouveaux classeurs Excel (.xlsx).","selectButton":"Choisir un fichier","clearButton":"Utiliser la valeur par d\xe9faut de Cephable","current":"Mod\xe8le: ","default":"Utilisation du mod\xe8le par d\xe9faut int\xe9gr\xe9 de Cephable avec le style de la marque."},"automationBrowser":{"title":"Visibilit\xe9 du navigateur d\'automatisation","description":"Lorsque l\'agent IA utilise le navigateur Cephable (recherche web, Google Docs/Sheets/Slides, Gmail, Drive), il fonctionne g\xe9n\xe9ralement en arri\xe8re-plan sans vous d\xe9ranger. Activez cette option pour observer son fonctionnement.","question":"Afficher le navigateur d\'automatisation pendant que l\'IA fonctionne\xa0?"}},"input":{"title":"Saisir","titlePlural":"Contr\xf4les d\'entr\xe9e","explore":"Explorer les contr\xf4les de saisie","descriptionShort":"Explorez les diff\xe9rents contr\xf4les d\'entr\xe9e utilis\xe9s par Cephable pour cr\xe9er une meilleure exp\xe9rience num\xe9rique pour vous.","typeLabel":"Type de contr\xf4le d\'entr\xe9e","toolTip":"Cela utilise {{alt}}","remove":"Supprimer le contr\xf4le d\'entr\xe9e","filter":"Filtrer par type d\'entr\xe9e","select":"S\xe9lectionnez une entr\xe9e","question":"Quel type d\'entr\xe9e souhaitez-vous utiliser\xa0?","add":"Ajouter une entr\xe9e","addMore":"Ajouter une autre entr\xe9e","removeItem":"Supprimer l\'\xe9l\xe9ment {{index}}","item":"Article {{index}}\xa0:\xa0{{label}}","duplicate":"Les articles en double ne sont pas autoris\xe9s.","maximum":"Maximum de {{maxItems}} \xe9l\xe9ments autoris\xe9s.","description":"Les commandes d\'entr\xe9e sont les diff\xe9rentes m\xe9thodes utilis\xe9es pour contr\xf4ler votre appareil. Elles incluent votre voix, les mouvements de la t\xeate, les expressions faciales et d\'autres connexions. Explorez les diff\xe9rentes commandes d\'entr\xe9e ci-dessous pour en savoir plus."},"time":{"soon":"\xc0 venir","now":"Maintenant","today":"Aujourd\'hui","yesterday":"Hier","minutesAgo":"il y a {{count}}\xa0minute","minutesAgo_plural":"il y a {{count}}\xa0minutes","daysAgo":"Il y a {{count}}\xa0jours","daysAgo_plural":"il y a {{count}}\xa0jours","monthsAgo":"il y a {{count}}\xa0mois","monthsAgo_plural":"il y a {{count}}\xa0mois","yearsAgo":"Il y a {{count}}\xa0an","yearsAgo_plural":"il y a {{count}} ans","minutesAhead":"dans {{count}}\xa0minutes","todayAhead":"plus tard aujourd\'hui","tomorrow":"demain","daysAhead":"dans {{count}}\xa0jours","monthsAhead":"dans {{count}}\xa0mois","yearsAhead":"dans {{count}} ans"},"peripherals":{"empty":"Aucun p\xe9riph\xe9rique d\xe9tect\xe9","switch":"Changer","keyboard":"Clavier","gamepad":"Manette de jeu","companionApp":"Application compagnon","available":"disponible \xe0 l\'emploi","error":"V\xe9rifiez vos param\xe8tres."},"camera":{"windowTitle":"Commandes de cam\xe9ra c\xe9phable","title":"Cam\xe9ra","titlePlural":"Appareils photo","settings":"Les param\xe8tres de la cam\xe9ra","start":"D\xe9marrer la cam\xe9ra","restart":"Red\xe9marrer la cam\xe9ra","descriptionShort":"Permet l\'expression du visage et le mouvement de la t\xeate.","description":"Utilisez votre appareil photo pour d\xe9tecter les expressions du visage et les gestes du corps comme diff\xe9rentes commandes.","empty":"Aucune cam\xe9ra trouv\xe9e.","search":"Rechercher par nom de cam\xe9ra","loading":"Chargement des commandes de la cam\xe9ra...","error":"Erreur inattendue lors du chargement des commandes de la cam\xe9ra. Veuillez v\xe9rifier votre cam\xe9ra et r\xe9essayer.","manage":{"title":"Cliquez pour afficher et g\xe9rer les d\xe9tails de vos cam\xe9ras.","description":""},"detected":{"face":"Visage d\xe9tect\xe9.","noFace":"Aucun visage d\xe9tect\xe9. Veuillez ajuster votre cam\xe9ra ou votre position et r\xe9essayer.","command":"D\xe9tect\xe9\xa0: {{commande}}"},"permission":{"title":"Autorisations de cam\xe9ra requises","description":"Vous devez autoriser Cephable \xe0 utiliser votre appareil photo pour utiliser les commandes du visage et du corps.","button":"Param\xe8tres d\'autorisation d\'ouverture","no":"Pas d\'acc\xe8s \xe0 la cam\xe9ra","help":"Cephable a besoin d&#39;acc\xe9der \xe0 votre cam\xe9ra pour utiliser les commandes d&#39;expression et de mouvement de la t\xeate. Acc\xe9dez \xe0 <strong>Param\xe8tres syst\xe8me</strong> &gt; <strong>Confidentialit\xe9 et s\xe9curit\xe9</strong> &gt; <strong>{{pane}}</strong> et autorisez Cephable \xe0 acc\xe9der \xe0 votre cam\xe9ra."},"controls":{"startData":"J\'ai commenc\xe9 \xe0 enregistrer les donn\xe9es du visage. Appuyez \xe0 nouveau sur le raccourci dans la fen\xeatre de l\'appareil photo pour arr\xeater l\'enregistrement et le t\xe9l\xe9chargement.","downloadData":"Enregistrement arr\xeat\xe9, t\xe9l\xe9chargement de donn\xe9es","paused":"Commandes de cam\xe9ra suspendues.","pause":"Suspendre les commandes de la cam\xe9ra","resume":"Reprendre les commandes de la cam\xe9ra","resumed":"Reprise des contr\xf4les de la cam\xe9ra.","linesOn":"Activer les lignes du visage","linesOff":"D\xe9sactiver les lignes du visage","linesToggle":"Activer/d\xe9sactiver le dessin des lignes du visage","noDeviceTitle":"Aucune cam\xe9ra d\xe9tect\xe9e pouvant \xeatre utilis\xe9e avec Cephable.","noDeviceDescription":"Vous devez connecter une cam\xe9ra compatible avec les applications mobiles.","noDeviceConnectedDescription":"Le contr\xf4le de la cam\xe9ra sert d\'aper\xe7u de l\'interface. Aucune \xe9tape ne sera ex\xe9cut\xe9e avec succ\xe8s. Connectez cet appareil compagnon \xe0 un autre, afin de lancer des commandes.","lines":"Lignes du visage"},"switch":{"title":"Changer de cam\xe9ra","description":"S\xe9lectionnez une autre cam\xe9ra \xe0 utiliser pour les commandes du visage et du corps.","select":"S\xe9lectionnez la cam\xe9ra","next":"Cam\xe9ra suivante","nextLong":"Passer \xe0 la cam\xe9ra suivante","empty":"Aucune autre cam\xe9ra trouv\xe9e.","search":"Rechercher par nom de cam\xe9ra"},"baseline":{"title":"R\xe9f\xe9rence","description":"La ligne de base est la position par d\xe9faut de votre visage et de votre corps que Cephable utilise pour d\xe9terminer vos mouvements. Vous pouvez mettre \xe0 jour et r\xe9initialiser la ligne de base ici.","update":"Mettre \xe0 jour la r\xe9f\xe9rence","reset":"R\xe9initialiser la ligne de base","updated":"Base de r\xe9f\xe9rence mise \xe0 jour","tooltip":"Cliquez pour mettre \xe0 jour votre ligne de base vers votre position de repos actuelle."},"edit":{"title":"Modifier les param\xe8tres de la cam\xe9ra","description":"Vous pouvez affiner les param\xe8tres de vos entr\xe9es n\xe9cessitant une cam\xe9ra pour mieux r\xe9pondre \xe0 vos besoins.","autoStart":{"title":"D\xe9marrer automatiquement la cam\xe9ra","option":"D\xe9marrage automatique de la cam\xe9ra et des commandes de t\xeate/expression\xa0?","description":"Lorsque ce param\xe8tre est activ\xe9, votre manette activera votre cam\xe9ra, vous permettant d\'utiliser les expressions faciales et les mouvements de la t\xeate d\xe8s le d\xe9marrage de l\'application. Si ce param\xe8tre est d\xe9sactiv\xe9, appuyez sur le bouton \xab\xa0D\xe9marrer la cam\xe9ra\xa0\xbb sur votre page de connexion."},"head":{"title":"Sensibilit\xe9 aux mouvements de la t\xeate","description":"La sensibilit\xe9 indique \xe0 Cephable jusqu\'o\xf9 vous devez vous d\xe9placer pour d\xe9clencher un contr\xf4le. Plus la valeur est grande (la plus \xe0 droite du curseur), plus la sensibilit\xe9 est \xe9lev\xe9e, et donc moins vous aurez besoin de vous d\xe9placer pour d\xe9clencher la commande.","tilt":{"title":"Sensibilit\xe9 \xe0 l\'inclinaison de la t\xeate","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez incliner la t\xeate vers le haut, le bas, la gauche et la droite pour d\xe9clencher les commandes.","up":"Sensibilit\xe9 \xe0 l\'inclinaison","down":"Sensibilit\xe9 d\'inclinaison vers le bas","left":"Sensibilit\xe9 d\'inclinaison \xe0 gauche","right":"Sensibilit\xe9 d\'inclinaison \xe0 droite","scaleHigh":"L\xe9g\xe8re inclinaison","scaleLow":"Grande inclinaison"},"turn":{"title":"Sensibilit\xe9 au tour de t\xeate","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez tourner la t\xeate vers la gauche et la droite pour d\xe9clencher les commandes.","left":"Tourner \xe0 gauche Sensibilit\xe9","right":"Tourner \xe0 droite Sensibilit\xe9","scaleHigh":"L\xe9ger virage","scaleLow":"Grand virage"},"lean":{"title":"Sensibilit\xe9 de la t\xeate maigre","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez pencher la t\xeate en avant et en arri\xe8re pour d\xe9clencher les commandes.","forward":"Sensibilit\xe9 \xe0 se pencher vers l\u2019avant","back":"Sensibilit\xe9 \xe0 se pencher en arri\xe8re","right":"Sensibilit\xe9 maigre \xe0 droite","left":"Sensibilit\xe9 maigre \xe0 gauche","scaleHigh":"L\xe9g\xe8rement pench\xe9","scaleLow":"Grand maigre"},"duck":{"title":"Sensibilit\xe9 t\xeate canard/mont\xe9e","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez baisser ou relever la t\xeate pour d\xe9clencher les commandes.","down":"Sensibilit\xe9 au duvet de canard","up":"Augmentez la sensibilit\xe9","scaleHigh":"L\xe9ger d\xe9calage","scaleLow":"Grand changement"}},"face":{"title":"Sensibilit\xe9 \xe0 l\'expression du visage","description":"La sensibilit\xe9 indique \xe0 Cephable \xe0 quel point une expression est exag\xe9r\xe9e dont vous avez besoin pour d\xe9clencher un contr\xf4le. Plus la valeur est grande (la plus \xe0 droite du curseur), plus la sensibilit\xe9 est \xe9lev\xe9e, et donc moins vous aurez besoin de vous d\xe9placer pour d\xe9clencher la commande.","eyebrow":{"title":"Sensibilit\xe9 des sourcils","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez lever ou baisser vos sourcils pour d\xe9clencher les commandes.","up":"Augmenter la sensibilit\xe9 des sourcils","scaleHigh":"L\xe9g\xe8re augmentation","scaleLow":"Augmentation importante"},"mouth":{"title":"Sensibilit\xe9 buccale","description":"Ces valeurs d\xe9terminent jusqu\'o\xf9 vous devez ouvrir ou fermer la bouche pour d\xe9clencher les commandes.","open":"Sensibilit\xe9 \xe0 la bouche ouverte","close":"Sensibilit\xe9 de la bouche ferm\xe9e","smile":"Sensibilit\xe9 du sourire","scaleHigh":"L\xe9g\xe8rement ouvert","scaleLow":"Grand Ouvert","closeScaleHigh":"L\xe9g\xe8rement ferm\xe9","closeScaleLow":"Bien ferm\xe9","smileScaleHigh":"L\xe9ger sourire","smileScaleLow":"Grand sourire"}},"mouse":{"title":"Mouvement de la t\xeate pour les commandes de la souris","description":"D\xe9terminez si et comment vous souhaitez utiliser les commandes de mouvements de la t\xeate pour d\xe9placer votre souris au lieu de d\xe9clencher d\'autres sorties.","enable":{"title":"Activer le mouvement de la t\xeate pour les commandes de la souris","description":"Si cette option est activ\xe9e, certaines de vos commandes de mouvement de la t\xeate seront utilis\xe9es pour d\xe9placer votre souris au lieu des commandes de d\xe9clenchement.","option":"Utiliser les commandes de la t\xeate pour le mouvement de la souris\xa0?"},"input":{"title":"Type d\'entr\xe9e de la souris","description":"S\xe9lectionnez le type de gestes de la t\xeate que vous souhaitez attribuer aux commandes de la souris. Par exemple, Head Tilting signifie que vous pouvez incliner votre t\xeate vers la gauche et la droite pour d\xe9placer votre souris vers la gauche et la droite, Head Turning signifie que vous pouvez tourner la t\xeate vers la gauche et la droite pour d\xe9placer votre souris et Head Leaning signifie que vous pouvez vous pencher vers la gauche et la droite pour bouger. votre souris.","option":"S\xe9lectionnez le type d\'entr\xe9e","optionLong":"S\xe9lectionnez le type de mouvement de t\xeate que vous souhaitez utiliser pour contr\xf4ler votre souris."},"invert":{"title":"Inverser le mouvement de la souris","description":"Si cette option est activ\xe9e, la direction dans laquelle vous d\xe9placez votre t\xeate sera invers\xe9e par rapport \xe0 la direction dans laquelle votre souris se d\xe9place. Pour l\'axe X\xa0: si cette option est activ\xe9e, un d\xe9placement vers la gauche d\xe9placera votre souris vers la droite et un d\xe9placement vers la droite la d\xe9placera vers la gauche. Pour l\'axe Y\xa0: si cette option est activ\xe9e, le fait de descendre d\xe9placera votre souris vers le haut et le fait de monter la fera descendre.","x":"Inverser le mouvement de la souris sur l\'axe X\xa0?","y":"Inverser le mouvement de la souris sur l\'axe Y\xa0?"},"mode":{"title":"Mode de d\xe9placement de la souris","description":"S\xe9lectionnez la mani\xe8re dont vous souhaitez que le curseur r\xe9agisse aux mouvements de votre t\xeate."},"speed":{"title":"Vitesse de la souris","description":"D\xe9terminez la vitesse constante \xe0 laquelle vous souhaitez que le curseur se d\xe9place.","fast":"Rapide","slow":"Lent"},"linear":{"title":"Mouvement lin\xe9aire de la souris","description":"Si cette option est activ\xe9e, le curseur se d\xe9place uniquement en lignes droites horizontales ou verticales, ce qui facilite la navigation dans ces directions sp\xe9cifiques sans aucune d\xe9rive diagonale.","option":"Utiliser le mouvement lin\xe9aire de la souris\xa0?"},"accelerationRate":{"title":"Taux d\'acc\xe9l\xe9ration de la souris","description":"Ajustez la vitesse \xe0 laquelle le curseur acc\xe9l\xe8re au fur et \xe0 mesure que vous maintenez votre t\xeate immobile."},"accelerationCurve":{"title":"Courbe d\'acc\xe9l\xe9ration de la souris","description":"Ajustez la vitesse \xe0 laquelle la vitesse du curseur augmente par rapport au mouvement de la t\xeate.","linear":"Lin\xe9aire","exponential":"Exponentiel","sublinear":"Sous-lin\xe9aire"},"maximumSpeed":{"title":"Vitesse maximale de la souris","description":"D\xe9terminez le nombre maximal de pixels que le curseur peut d\xe9placer par seconde."},"steadyGlide":{"title":"Glisse stable","description":"Lorsque vous d\xe9placez votre t\xeate au-del\xe0 d\u2019un certain point, le curseur glisse continuellement dans cette direction \xe0 une vitesse constante."},"speedBoost":{"title":"Augmentation de la vitesse","description":"Le curseur commence \xe0 se d\xe9placer plus rapidement \xe0 mesure que vous gardez la t\xeate dans la m\xeame position. Plus vous gardez la t\xeate immobile longtemps, plus le curseur acc\xe9l\xe8re rapidement."},"dynamicGlide":{"title":"Glisse dynamique","description":"La vitesse du curseur augmente en fonction de la distance \xe0 laquelle vous bougez la t\xeate. Plus vous bougez la t\xeate, plus le curseur glisse vite."},"proportionalSpeed":{"title":"Vitesse proportionnelle","description":"Le curseur suit le bout de votre nez proportionnellement aux dimensions de votre \xe9cran."},"off":{"title":"D\xe9sactiv\xe9","description":"Le mouvement de la souris est d\xe9sactiv\xe9."},"disabled":"Cette fonctionnalit\xe9 est d\xe9sactiv\xe9e pour les connexions et extensions distantes."}},"stop":"Arr\xeater la cam\xe9ra","show":"Afficher la cam\xe9ra","hide":"Masquer la cam\xe9ra","warn":"Les commandes de la cam\xe9ra n\'ont pas \xe9t\xe9 d\xe9marr\xe9es, d\xe9marrez votre cam\xe9ra pour autoriser les commandes du visage et du corps.","draw":{"error":"Erreur lors du chargement du flux de la cam\xe9ra. Veuillez v\xe9rifier votre cam\xe9ra et r\xe9essayer."},"select":"S\xe9lectionnez une cam\xe9ra avec laquelle vous souhaitez vous associer pour des commandes am\xe9lior\xe9es \xe0 l\'aide de votre visage, de votre corps et des boutons d\'action rapide.","extension":{"title":"Extension : Cam\xe9ra","enabledTitle":"Activer les commandes de la cam\xe9ra","enabledDescription":"Lorsque ce param\xe8tre est activ\xe9, Cephable utilise votre cam\xe9ra pour d\xe9tecter les mouvements de votre visage et de votre t\xeate afin de vous permettre de contr\xf4ler votre appareil par des expressions et des gestes, notamment en utilisant les mouvements de votre t\xeate comme une souris."},"live":"EN DIRECT","paused":"La cam\xe9ra s\'est arr\xeat\xe9e."},"microphone":{"windowTitle":"Commandes vocales c\xe9phables","title":"Microphone","titlePlural":"Micros","settings":"Param\xe8tres du microphone","start":"D\xe9marrer le microphone","stop":"Arr\xeater le microphone","descriptionShort":"Permet les commandes vocales et la dict\xe9e.","description":"Utilisez votre microphone int\xe9gr\xe9 pour activer les commandes vocales et la dict\xe9e.","select":"S\xe9lectionnez un microphone avec lequel vous souhaitez vous associer pour des commandes am\xe9lior\xe9es \xe0 l\'aide de votre voix.","empty":"Aucun microphone trouv\xe9.","search":"Rechercher par nom de microphone","manage":{"title":"Cliquez pour afficher et g\xe9rer les d\xe9tails de vos microphones.","description":""},"permission":{"title":"Autorisations de microphone requises","description":"Vous devez autoriser Cephable \xe0 utiliser votre microphone pour utiliser les commandes vocales.","button":"Param\xe8tres d\'autorisation d\'ouverture","no":"Pas d\'acc\xe8s au microphone","help":"Cephable a besoin d&#39;acc\xe9der \xe0 votre microphone pour utiliser les commandes vocales. Acc\xe9dez \xe0 <strong>Param\xe8tres syst\xe8me</strong> &gt; <strong>Confidentialit\xe9 et s\xe9curit\xe9</strong> &gt; <strong>{{pane}}</strong> et autorisez Cephable \xe0 acc\xe9der \xe0 votre microphone."},"controls":{"pause":"Suspendre les commandes vocales","paused":"Contr\xf4les suspendus.","resume":"Reprendre les commandes vocales","dictationPlay":"D\xe9marrer le mode dict\xe9e","dictationPause":"Arr\xeater le mode dict\xe9e","prompt":"Commencez \xe0 parler pour voir vos commandes vocales ici...","dictationPrompt":"Commencez \xe0 parler pour taper ce que vous dites...","latency":"Latence \xe9lev\xe9e d\xe9tect\xe9e. Pensez \xe0 fermer certaines applications susceptibles de consommer trop de ressources.","noDeviceConnectedDescription":"Le contr\xf4le du microphone sert d\'aper\xe7u de l\'interface. Aucune \xe9tape ne sera ex\xe9cut\xe9e avec succ\xe8s. Connectez cet appareil compagnon \xe0 un autre, afin de lancer des commandes.","status":{"paused":"En pause.","dictating":"Dicter.","optimistic":"Optimiste:","listening":"\xc9coute:","loadingModel":"Chargement du mod\xe8le vocal...","thinking":"Pens\xe9e...","loadingPhiModel":"Chargement du mod\xe8le de g\xe9n\xe9ration de texte...","generatingText":"G\xe9n\xe9rateur...","preparingPhiModel":"Pr\xe9paration du mod\xe8le de g\xe9n\xe9ration de texte...","permission":"V\xe9rification des autorisations du microphone...","typing":"Dactylographie..."},"loadingDetail":"Cela peut prendre quelques minutes.","generatingTextDetail":"Arr\xeatez la g\xe9n\xe9ration en changeant d\'application ou en disant \xab arr\xeatez de g\xe9n\xe9rer \xbb","command":"Commande","contextual":"Contextuel","send":"Envoyer","typedInputLabel":"Saisissez une commande ou un texte \xe0 envoyer","listeningPlaceholder":"\xc9coute...","dictationListeningPlaceholder":"\xc9coute...","pausedPlaceholder":"La voix s\'est interrompue..."},"edit":{"title":"Modifier les param\xe8tres du microphone","autoStart":{"title":"Microphone \xe0 d\xe9marrage automatique","option":"Microphone \xe0 d\xe9marrage automatique","description":"L\'\xe9coute des commandes vocales se lance automatiquement \xe0 la mise sous tension de l\'appareil. Si cette fonction est d\xe9sactiv\xe9e, appuyez sur \xab\xa0D\xe9marrer l\'\xe9coute\xa0\xbb pour l\'activer."},"optimistic":{"title":"Commandes vocales plus rapides et optimistes","option":"Commandes vocales plus rapides et optimistes","description":"Ce mode rend les commandes vocales plus rapides et plus r\xe9actives, mais moins tol\xe9rantes. Utilisez le mode Standard si vous souhaitez la dict\xe9e vocale ou une plus grande flexibilit\xe9. Remarque\xa0: le mode optimiste peut s\u2019activer accidentellement si vous ne prononcez pas les commandes exactement."},"confirm":{"title":"Vous avez des changements non enregistr\xe9s.","description":"Modifications non enregistr\xe9es d\xe9tect\xe9es. Souhaitez-vous enregistrer avant de quitter\xa0?"},"aiCommands":{"title":"Commandes vocales intelligentes","description":"\xc9noncez les commandes naturellement \u2014 l\'IA de Cephable comprend ce que vous voulez dire sans avoir besoin d\'une correspondance exacte.","option":"Commandes vocales intelligentes"},"aiDictation":{"title":"Dict\xe9e intelligente et saisie rapide","description":"\xc9coute vocale am\xe9lior\xe9e avec ponctuation automatique, noms propres et structure des phrases. Dites \xab\xa0tapez [quelque chose]\xa0\xbb pour utiliser la saisie rapide et obtenir une dict\xe9e plus intelligente et plus naturelle.","option":"Dict\xe9e intelligente et saisie rapide"},"description":"G\xe9rez vos commandes vocales et vos param\xe8tres de dict\xe9e pour cette connexion.","input":{"title":"Microphone","description":"Le microphone permet la commande vocale et la dict\xe9e. Cephable m\xe9morise votre choix et y revient automatiquement d\xe8s qu\'il est connect\xe9.","notConnected":"{{name}} (non connect\xe9)","systemDefault":"Valeurs par d\xe9faut du syst\xe8me"}},"warn":"Votre microphone n\'est pas activ\xe9. Activez-le pour autoriser les commandes vocales et la dict\xe9e.","devices":{"error":"P\xe9riph\xe9rique d\'entr\xe9e du microphone introuvable."},"startDescription":"Allumez le microphone pour commencer \xe0 \xe9couter les commandes.","context":{"add":"Ajouter du contexte","title":"Ajouter du contexte","highlighted":"Texte mis en \xe9vidence","clipboard":"presse-papiers","other":"Autre\u2026","otherTitle":"Ajouter un contexte personnalis\xe9","otherPlaceholder":"Saisissez ou collez le contexte \xe0 utiliser","otherConfirm":"Ajouter","otherCancel":"Annuler","remove":"Supprimer le contexte","required":"Le contexte est requis pour {{mode}}","files":"Fichiers\u2026","folders":"Dossiers\u2026","removeAttachment":"Supprimer la pi\xe8ce jointe","dropToAttach":"Glissez-d\xe9posez des fichiers ou des dossiers pour les joindre en tant que contexte","otherLabel":"Contexte personnalis\xe9"}},"localization":{"title":"Param\xe8tres de langue","titleShort":"Langue","description":"Choisissez votre langue pr\xe9f\xe9r\xe9e dans une liste de langues prises en charge.","newUserDescription":"Veuillez s\xe9lectionner une langue pr\xe9f\xe9r\xe9e avant de continuer.","edit":"Modifier les pr\xe9f\xe9rences","display":{"title":"Langue d\'affichage","description":"Langue d\'affichage lors de l\'utilisation de Cephable. Cela inclut les menus, les notifications et les commandes des applications, affich\xe9s dans la langue de votre choix."},"voice":{"title":"Langue de commande vocale","description":"C\'est la langue utilis\xe9e lors de la reconnaissance des dict\xe9es et des commandes vocales. La sp\xe9cification de la langue am\xe9liore la pr\xe9cision de vos saisies vocales.","settings":{"title":"Reconnaissance vocale et langue d\'affichage","description":"Ajustez vos param\xe8tres de langue pour l\'affichage et les commandes vocales. Cette option vous permet de s\xe9lectionner vos langues pr\xe9f\xe9r\xe9es pour le texte \xe0 l\'\xe9cran et les interactions avec le microphone, comme les commandes vocales et la dict\xe9e."}},"locales":{"en":"English - Anglais","en-us":"English (US) - Anglais (\xc9tats-Unis)","es":"Espa\xf1ol - Espagnol","fr":"Fran\xe7ais","it":"Italiano \u2014 Italien","de":"Deutsch - Allemand","ja":"\u65E5\u672C\u8A9E - Japonais","en-gb":"English (UK) - Anglais (Royaume-Uni)","en-in":"English (India) - Anglais (Inde)"},"save":{"success":"Pr\xe9f\xe9rences locales de l\'utilisateur enregistr\xe9es\xa0!","error":"Erreur lors de l\'enregistrement des pr\xe9f\xe9rences de param\xe8tres r\xe9gionaux de l\'utilisateur"},"profile":{"view":"Variantes","title":"Langue de contr\xf4le des applications","question":"Quelle langue de contr\xf4le d\'application souhaitez-vous modifier\xa0?","description":"Certaines commandes d\'application proposent des variantes linguistiques. Changez de langue pour les modifier et les personnaliser.","change":"Changer de langue"},"unsupported":{"title":"Langue non prise en charge {{locale}}","description":"La langue s\xe9lectionn\xe9e n\'est pas prise en charge. Veuillez choisir une autre langue."},"select":"S\xe9lectionner la langue","localesShort":{"en":"Anglais","en-us":"Anglais (\xc9tats-Unis)","es":"Espagnol","fr":"Fran\xe7ais","it":"italien","de":"Allemand","ja":"japonais","en-gb":"Anglais (Royaume-Uni)","en-in":"Anglais (Inde)"}},"mobileApp":{"title":"Application mobile"},"skipToMain":"Acc\xe9der au Contenu Principal","dashboard":{"title":"Tableau de bord"},"developer":{"title":"Promoteur","titleLong":"Ressources pour les d\xe9veloppeurs","description":"Cephable peut \xeatre int\xe9gr\xe9 directement dans votre application, jeu ou service \xe0 l\'aide de nos SDK.","sdk":{"title":"D\xe9couvrez nos SDK","description":"Nous fournissons des SDK de premier ordre con\xe7us pour int\xe9grer de mani\xe8re transparente la reconnaissance vocale et les contr\xf4les adaptatifs dans vos applications. Nos outils sont con\xe7us pour am\xe9liorer l\'interaction des utilisateurs gr\xe2ce \xe0 des commandes intuitives et pour favoriser l\'accessibilit\xe9, garantissant ainsi que votre logiciel peut \xeatre utilis\xe9 plus efficacement par tous les utilisateurs.","javascript":{"title":"JavaScript","subtitle":"Web","description":"Int\xe9grez les commandes vocales et adaptatives directement dans vos applications Web.","action":"Obtenir le Package NPM"},"net":{"title":".NET","subtitle":"Applications Windows","description":"Exploitez la puissance de .NET pour cr\xe9er des applications avec nos SDK WPF et WinUI3.","actionCore":"Obtenez le Package de base","actionWpf":"Obtenir le Package WPF"},"android":{"title":"Andro\xefde","subtitle":"Appareils mobiles","description":"Applications Android con\xe7ues pour faciliter les capacit\xe9s de voix et de mouvement de la t\xeate.","action":"Obtenir le SDK Android"},"more":{"title":"Plus","description":"Vous ne trouvez pas ce que vous cherchez ? Contactez-nous et nous pourrons vous aider.","action":"Demander un SDK"},"docs":{"title":"Documentation","description":"Explorez la documentation d\xe9taill\xe9e, les exemples de projets et les guides pour commencer \xe0 d\xe9velopper avec Cephable.","action":"Consulter les documents"}},"demo":{"title":"D\xe9mos","titleLong":"D\xe9couvrez nos SDK en action","description":"D\xe9couvrez la puissance de nos technologies de contr\xf4le de la voix et des mouvements de la t\xeate gr\xe2ce \xe0 nos exemples d\'applications. Des jeux interactifs aux applications Web et mobiles dynamiques, chaque exemple d\xe9montre la polyvalence et l\'efficacit\xe9 de nos SDK. Explorez ces exemples pour obtenir des informations et des id\xe9es pour int\xe9grer une accessibilit\xe9 am\xe9lior\xe9e et des exp\xe9riences immersives dans vos propres projets.","game":{"title":"Jeu 2048","subtitle":"Web","description":"Am\xe9liorez le gameplay traditionnel avec des commandes adaptatives de voix et de mouvement de la t\xeate.","action":"Jouer le jeu"},"unity":{"title":"Unit\xe9","subtitle":"D\xe9veloppement de jeux","description":"D\xe9couvrez comment les commandes adaptatives peuvent \xeatre exploit\xe9es dans les jeux pour offrir une exp\xe9rience utilisateur plus attrayante.","action":"Obtenir l\'\xe9chantillon"},"samples":"Documents et exemples","other":{"title":"Autres d\xe9mos","description":"D\xe9couvrez de premi\xe8re main comment Cephable peut am\xe9liorer votre application, votre jeu ou votre appareil.","action":"Voir plus de d\xe9mos"},"web":{"title":"Exemples de SDK Web","subtitle":"Web","description":"Int\xe9gration simple de toutes nos fonctionnalit\xe9s principales dans les applications Web.","action":"D\xe9couvrez le SDK"},"docs":{"title":"Documentation et exemples pour les d\xe9veloppeurs","description":"Explorez la documentation d\xe9taill\xe9e, les exemples de projets et les guides pour commencer \xe0 d\xe9velopper avec Cephable.","action":"Consulter les documents"}},"other":{"title":"Autres ressources","description":"Si vous ne trouvez pas ce dont vous avez besoin dans nos SDK, essayez de travailler directement avec nos API ou contactez la communaut\xe9 pour obtenir de l\'aide, de l\'inspiration et du soutien.","api":{"title":"API","description":"Nos API vous permettent d\'interagir directement avec Cephable. Vous pouvez utiliser nos API pour cr\xe9er des int\xe9grations personnalis\xe9es."},"support":{"title":"Soutien","description":"Vous ne trouvez pas ce que vous cherchez ? Contactez notre communaut\xe9 via Discord.","action":"Rejoignez Discord"}}},"invalidNumber":"N/A","upgrade":"Mise \xe0 niveau","license":{"trial":{"subtitle":"Vous pouvez inviter {{count}} coll\xe8gues \xe0 essayer Cephable avec vous.","noUsersSubtitle":"Il ne vous reste plus d\'utilisateurs d\'essai. Passez \xe0 une licence payante pour ajouter plus d\'utilisateurs.","expired":{"user":"Votre mise \xe0 niveau gratuite vers {{productName}} expire le {{date}}. Pour effectuer une mise \xe0 niveau, veuillez contacter l\'administrateur de votre organisation\xa0: {{admin}}.","admin":"Votre mise \xe0 niveau gratuite vers {{productName}} expire le {{date}}.","userLong":"Il semblerait que votre mise \xe0 niveau gratuite vers {{productName}} ait expir\xe9. Pour effectuer une mise \xe0 niveau, veuillez contacter l\'administrateur de votre organisation\xa0: {{admin}}.","adminLong":"Il semblerait que votre mise \xe0 niveau gratuite vers {{productName}} ait expir\xe9. Vous pouvez mettre \xe0 niveau votre licence pour continuer \xe0 acc\xe9der aux fonctionnalit\xe9s avanc\xe9es non disponibles dans Cephable Basic."},"start":"Commencez un essai gratuit","title":{"single":"Vous avez b\xe9n\xe9fici\xe9 d\'une mise \xe0 niveau gratuite vers {{productName}} avec {{days}} jours restants.","multiple":"{{organization}} est en essai gratuit avec {{days}} jours restants"},"upgrade":"En effectuant une mise \xe0 niveau, conservez votre acc\xe8s \xe0 des fonctionnalit\xe9s telles que les commandes vocales am\xe9lior\xe9es, les t\xe2ches intelligentes de l\'IA et de nombreuses commandes d\'applications pr\xe9d\xe9finies."},"required":{"title":"Une licence professionnelle Cephable est requise","description":"Il semble que vous utilisiez Cephable Basic, qui ne prend pas en charge l\'utilisation commerciale de Cephable. Veuillez passer \xe0 une licence professionnelle pour continuer \xe0 utiliser l\'application."},"upgrade":{"professional":"Mise \xe0 niveau vers la Licence Professionnelle Cephable","generic":{"title":"Am\xe9liorez Votre Exp\xe9rience Cephable","description":"La plateforme Cephable propose diff\xe9rents produits destin\xe9s \xe0 une utilisation commerciale au travail, \xe0 l\'\xe9cole ou int\xe9gr\xe9s dans des solutions natives."},"fallback":{"title":"Erreur lors du chargement du portail de facturation","description":"Impossible de charger le portail de facturation dans l\'application. Veuillez cliquer sur le bouton ci-dessous pour poursuivre la mise \xe0 jour."}},"activate":{"question":"Vous avez d\xe9j\xe0 une cl\xe9 de licence ?","button":"Activer","title":"Activer la Cl\xe9 de Licence","description":"Saisissez votre cl\xe9 de licence pour mettre \xe0 niveau Cephable. Si vous n\'en avez pas, d\xe9marrez un essai gratuit ou achetez une licence.","fieldLabel":"Cl\xe9 de Licence","placeholder":"NkmurBfZzFrmm9Kx","success":"F\xe9licitations. Votre compte a \xe9t\xe9 mis \xe0 niveau vers {{license}}\xa0!","invalid":{"key":"Cl\xe9 non valide. Veuillez vous assurer que vous avez saisi la bonne cl\xe9.","empty":{"key":"Cl\xe9 non valide. Veuillez v\xe9rifier la valeur saisie.","name":"Nom d\'organisation non valide. Veuillez v\xe9rifier la valeur saisie."}},"descriptionLong":"Saisissez votre cl\xe9 de licence pour mettre \xe0 niveau Cephable. Si vous n\'en avez pas, d\xe9marrez un essai gratuit ou achetez une licence."},"welcome":{"title":"Bienvenue chez {{license}}.","description":"Vous avez rejoint avec succ\xe8s {{organization}}. {{description}}"},"redirect":{"title":"Redirection","description":"Vous avez \xe9t\xe9 redirig\xe9 vers un portail de facturation externe. Cela ouvrira un nouvel onglet dans votre navigateur. Si vous n\'\xeates pas redirig\xe9 dans quelques secondes, veuillez cliquer sur le bouton ci-dessous.","error":"Erreur de redirection de facturation","external":"Redirection effectu\xe9e. Veuillez v\xe9rifier votre navigateur."},"key":{"title":"Cl\xe9 de licence","titlePlural":"Cl\xe9s de licence","description":"Une cl\xe9 de licence est un identifiant unique utilis\xe9 pour accorder l\'acc\xe8s aux fonctionnalit\xe9s Cephable Professional, Education ou Developer.","details":"D\xe9tails de la cl\xe9 de licence","assigned":"Utilis\xe9 le : {{date}}","expires":"Expire le\xa0: {{date}}","assign":"Attribuer une cl\xe9 \xe0 une nouvelle organisation","error":"Erreur lors du chargement de la cl\xe9 de licence.","empty":{"title":"Aucune cl\xe9 de licence trouv\xe9e.","description":"Il ne semble pas qu\'il existe de cl\xe9s de licence correspondant \xe0 ces crit\xe8res. Ou vous n\'avez pas encore achet\xe9 de cl\xe9 de licence."},"product":{"title":"Achat","titleLong":"Acheter des cl\xe9s de licence","description":"Achetez une cl\xe9 de licence pour exploiter tout le potentiel de Cephable. Consultez les diff\xe9rents plans et options de tarification disponibles.","action":"Achetez maintenant","empty":{"title":"Aucun produit trouv\xe9.","description":"Il semble que vous n\'ayez aucun produit. Veuillez contacter notre \xe9quipe commerciale ou votre repr\xe9sentant pour vous aider \xe0 r\xe9soudre ce probl\xe8me."},"yearly":"Factur\xe9 annuellement","years":"Factur\xe9 tous les {{value}} ans","days":"Factur\xe9 tous les {{value}} jours","Subscription":{"title":"Abonnement"},"MeteredConsumption":{"title":"Consommation mesur\xe9e"},"PayDown":{"title":"Payer"},"OneTime":{"title":"Une fois"}}},"pro":{"tag":"Pro","detail":"Il s\'agit d\'une fonctionnalit\xe9 r\xe9serv\xe9e \xe0 Cephable Professional","requiredDetail":"Une licence Cephable Professionnelle est requise pour cette fonctionnalit\xe9. Vous pouvez mettre \xe0 niveau ou d\xe9marrer un essai gratuit dans les param\xe8tres de votre compte."},"titlePlural":"Licences"},"purchase":"Achat","saveError":"Erreur lors de l\'enregistrement des modifications.","description":"Description","expand":"D\xe9velopper","expandMenu":"D\xe9velopper le menu","editor":{"title":"\xc9diteur Markdown","bold":"Audacieux","italic":"Italique","underline":"Souligner","hr":"R\xe8gle horizontale","link":"Lien","quote":"Citation","code":"Code","codeBlock":"Bloc de code","comment":"Commentaire","image":"Image","table":"Tableau","unordered-list":"Liste non ordonn\xe9e","ordered-list":"Liste ordonn\xe9e","checked-list":"Liste de contr\xf4le","help":"Aide","edit":"Modifier","live":"En direct","preview":"Aper\xe7u","fullscreen":"Plein \xe9cran","placeholder":"Veuillez saisir le texte Markdown ici...","strikethrough":"Barr\xe9"},"created":"Cr\xe9\xe9\xa0: {{value}}","updated":"Mis \xe0 jour\xa0: {{value}}","deleted":"Supprim\xe9\xa0: {{value}}","expires":"Expire\xa0: {{value}}","expired":"Expir\xe9\xa0: {{value}}","used":"Utilis\xe9\xa0: {{value}}","results":"R\xe9sultats","panel":{"title":"Panneau C\xe9phable","question":"Panneau de d\xe9marrage automatique ?","position":{"top":"Haut","right":"Droite","left":"Gauche","bottom":"Bas ","description":"S\xe9lectionnez l\'endroit o\xf9 vous souhaitez que le panneau Cephable apparaisse sur votre \xe9cran.","label":"Position"},"sections":{"description":"Choisissez les sections visibles du panneau. Vous pouvez masquer des sections selon vos pr\xe9f\xe9rences pour optimiser l\'espace du panneau.","microphone":"Microphone et commandes vocales","camera":"Commandes de la cam\xe9ra et du visage/de la t\xeate","profile":"Contr\xf4les et aper\xe7us de l\'application","globalControls":"Contr\xf4les globaux et de p\xe9riph\xe9rique","tasks":"T\xe2ches intelligentes","buttons":"Boutons d\'action rapide"},"titleShort":"Panneau","description":"Voici le panneau de contr\xf4le principal. Toujours visible, il vous permet de contr\xf4ler vos applications \xe0 la voix, et bien plus encore.","reconnecting":"Se reconnecter\u2026","reconnectRetry":"R\xe9essayer","modes":{"title":"Mode","generate":{"label":"G\xe9n\xe9rer","placeholder":"D\xe9crivez ce que vous souhaitez g\xe9n\xe9rer"},"rewrite":{"label":"R\xe9crire","placeholder":"Comment dois-je r\xe9\xe9crire le texte ?"},"translate":{"label":"Traduire","placeholder":"Traduire dans quelle langue ?"},"automate":{"label":"Automatiser","placeholder":"D\xe9crivez les \xe9tapes que vous souhaitez automatiser."},"auto":{"label":"Auto","placeholder":"Saisissez n\'importe quoi \u2014 Cephable choisit le meilleur mode","upgrade":"Cephable a besoin de {{tier}} pour ex\xe9cuter cette action."},"control":{"label":"Contr\xf4le","placeholder":"Saisissez une commande ou un texte \xe0 envoyer"},"summarize":{"label":"R\xe9sumer","placeholder":"Comment souhaitez-vous r\xe9sumer ou condenser le texte\xa0?"}}},"resume":"CV","textGeneration":{"settings":"Param\xe8tres de g\xe9n\xe9ration de texte","edit":{"title":"Modifier les param\xe8tres de g\xe9n\xe9ration de texte","description":"Vous pouvez affiner les param\xe8tres de votre g\xe9n\xe9ration de texte intelligente pour cr\xe9er les meilleures sorties pour vous.","autoStart":{"title":"G\xe9n\xe9ration automatique de texte de pr\xe9chauffage","description":"Lorsque cette option est activ\xe9e, Cephable AI effectue automatiquement un pr\xe9chauffage des mod\xe8les d\'IA utilis\xe9s pour les t\xe2ches de cr\xe9ation ou d\'automatisation. Ce pr\xe9chauffage am\xe9liore leur performance, mais consomme davantage de ressources syst\xe8me. D\xe9sactiver cette option permet d\'\xe9conomiser des ressources, mais peut ralentir l\'ex\xe9cution des t\xe2ches.","option":"Mod\xe8les d\'IA de g\xe9n\xe9ration de texte \xe0 pr\xe9chauffage automatique\xa0?"},"prompt":{"title":"Informations compl\xe9mentaires pour la g\xe9n\xe9ration de texte","description":"Saisissez les informations suppl\xe9mentaires \xe0 utiliser avec l\'IA de Cephable pour g\xe9n\xe9rer du texte. Utilisez ce champ pour indiquer vos pr\xe9f\xe9rences concernant le ton, le style d\'\xe9criture ou tout autre d\xe9tail.","field":"Invite suppl\xe9mentaire","placeholder":"Par exemple, adoptez un ton amical, \xe9crivez comme un professionnel, soyez concis et direct. Lorsque vous \xe9crivez du code, laissez des commentaires pertinents, mais pas trop nombreux, etc."},"enableTextGen":{"title":"Activer la g\xe9n\xe9ration de texte intelligente","description":"Lorsque ce param\xe8tre est activ\xe9, Cephable AI peut r\xe9diger, r\xe9\xe9crire, r\xe9sumer et traduire du contenu, ou automatiser des actions de bureau dans toutes vos applications.","option":"Utiliser la g\xe9n\xe9ration de texte intelligente ?"},"terminate":{"title":"Ressources d\'IA claires","description":"Cliquez pour lib\xe9rer les ressources utilis\xe9es par les t\xe2ches de cr\xe9ation ou d\'automatisation. Cela lib\xe9rera des ressources sur votre ordinateur, mais pourrait ralentir ces t\xe2ches lors de leur prochaine utilisation.","button":"Ressources claires","success":"Effacement des ressources de g\xe9n\xe9ration de texte.","confirm":{"title":"Ressources d\'IA claires","description":"\xcates-vous s\xfbr de vouloir lib\xe9rer les ressources utilis\xe9es pour les t\xe2ches de cr\xe9ation ou d\'automatisation\xa0? Cette action lib\xe9rera des ressources sur votre ordinateur, mais pourrait ralentir ces t\xe2ches lors de leur prochaine utilisation.","confirm":"Oui, des ressources claires","cancel":"Annuler"}},"clearModelCache":{"title":"Vider le cache des mod\xe8les d\'IA","description":"Cela lib\xe9rera de l\'espace de stockage sur votre ordinateur et t\xe9l\xe9chargera \xe0 nouveau le mod\xe8le actuellement s\xe9lectionn\xe9.","button":"Effacer et ret\xe9l\xe9charger","success":"Fichiers de mod\xe8le locaux supprim\xe9s.","confirm":{"title":"Vider et ret\xe9l\xe9charger le cache du mod\xe8le d\'IA","description":"\xcates-vous s\xfbr de vouloir vider le cache du mod\xe8le d\'IA et supprimer les fichiers de votre syst\xe8me\xa0? Le mod\xe8le actuellement s\xe9lectionn\xe9 sera ret\xe9l\xe9charg\xe9 automatiquement.","confirm":"Oui, effacer et ret\xe9l\xe9charger","cancel":"Annuler"},"error":"Erreur lors de la suppression des fichiers de mod\xe8le locaux."},"enableHistory":{"title":"Activer l\'historique de g\xe9n\xe9ration de texte","description":"Avec ce param\xe8tre activ\xe9, Cephable AI utilisera votre historique de g\xe9n\xe9ration de texte pour g\xe9n\xe9rer du texte avec le contexte de votre action pr\xe9c\xe9dente.","option":"Utiliser l\'historique de g\xe9n\xe9ration de texte\xa0?"},"modelSelection":{"title":"Mod\xe8le d\'IA","description":"Choisissez le mod\xe8le d\'IA (famille et taille) compatible avec cet appareil. Les mod\xe8les plus grands offrent de meilleurs r\xe9sultats, mais consomment davantage de ressources. T\xe9l\xe9chargez-en plusieurs pour pouvoir passer rapidement de l\'un \xe0 l\'autre.","family":"Mod\xe8le de famille","size":"Taille du mod\xe8le","downloaded":"T\xe9l\xe9charg\xe9","downloading":"T\xe9l\xe9chargement\u2026","download":"T\xe9l\xe9charger","delete":"Supprimer le t\xe9l\xe9chargement","unavailable":"Non pris en charge sur cet appareil","requiresBetterDevice":"Ce mod\xe8le n\xe9cessite un appareil plus performant pour fonctionner.","selectPrompt":"S\xe9lectionnez un mod\xe8le","noModels":"Aucun mod\xe8le compatible n\'est disponible pour cet appareil pour le moment.","deleteConfirm":{"title":"Supprimer le mod\xe8le t\xe9l\xe9charg\xe9\xa0?","description":"Cela lib\xe8re de l\'espace disque. Vous pourrez le t\xe9l\xe9charger \xe0 nouveau plus tard."},"notDownloaded":"Ce mod\xe8le est s\xe9lectionn\xe9 mais pas encore t\xe9l\xe9charg\xe9. Cliquez sur T\xe9l\xe9charger pour l\'utiliser.","readyToUse":"T\xe9l\xe9charg\xe9 \u2014 pr\xeat \xe0 l\'emploi","offlineNoModels":"Vous \xeates hors ligne et aucun mod\xe8le n\'est enregistr\xe9 sur cet appareil. Connectez-vous \xe0 Internet pour consulter et t\xe9l\xe9charger les mod\xe8les disponibles.","offlineDownloadUnavailable":"Vous \xeates hors ligne, ce mod\xe8le ne peut donc pas \xeatre t\xe9l\xe9charg\xe9. Connectez-vous \xe0 Internet pour le t\xe9l\xe9charger, ou choisissez un mod\xe8le que vous avez d\xe9j\xe0 t\xe9l\xe9charg\xe9.","license":{"upgrade":"N\xe9cessite une mise \xe0 niveau de licence","blockedNeedsDownload":"Ce mod\xe8le n\xe9cessite une licence. T\xe9l\xe9chargez un mod\xe8le inf\xe9rieur ou effectuez une mise \xe0 niveau pour continuer."},"notEnoughSpace":"Espace insuffisant sur l\'appareil","notEnoughSpaceDetail":"N\xe9cessite {{requis}} mais seul {{free}} est disponible sur cet appareil. Lib\xe9rez de l\'espace et r\xe9essayez.","fallback":{"alert":"{{fallback}} est utilis\xe9 \xe0 la place de {{preferred}}, ce qui n\xe9cessite une mise \xe0 niveau.","active":"{{preferred}} n\xe9cessite {{license}}. {{fallback}} est utilis\xe9 \xe0 la place jusqu\'\xe0 ce que vous choisissiez un autre mod\xe8le ou que vous effectuiez une mise \xe0 niveau."}}},"prompt":{"systemPrompt":"G\xe9n\xe9rez UNIQUEMENT le texte demand\xe9\xa0: aucune explication, aucun commentaire, aucun \xe9l\xe9ment superflu. Pas de mise en forme Markdown ni d\u2019explication non sollicit\xe9e. Pour le code, fournissez uniquement le code brut\xa0: sans balises, sans \xe9tiquettes de langage, sans explication. N\u2019expliquez pas votre d\xe9marche.","appName":"Vous g\xe9n\xe9rez actuellement du texte pour {{appName}}.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur quant \xe0 la mani\xe8re dont ils souhaitent que le texte soit g\xe9n\xe9r\xe9\xa0: {{userPreferences}}."},"translatePrompt":{"systemPrompt":"Traduisez le texte suivant en {{language}}. Affichez UNIQUEMENT le texte traduit. Sans explications, sans pr\xe9ambule, sans mise en forme Markdown, sans balises de code, sans notes, ni remarques entre parenth\xe8ses concernant la traduction. Conservez la mise en forme. Pour le code\xa0: traduisez uniquement les commentaires et les cha\xeenes de caract\xe8res, en pr\xe9servant la syntaxe \xe0 l\u2019identique.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur quant \xe0 la mani\xe8re dont ils souhaitent que le texte soit g\xe9n\xe9r\xe9\xa0: {{userPreferences}}.","genericUserPrompt":"Traduire\xa0: {{userRequestText}}"},"disabled":{"title":"Les t\xe2ches intelligentes sont d\xe9sactiv\xe9es","description":"Il semble que vous ayez d\xe9sactiv\xe9 les t\xe2ches intelligentes. Mettez \xe0 jour vos param\xe8tres pour d\xe9bloquer la g\xe9n\xe9ration et la r\xe9\xe9criture de texte, et bien plus encore."},"skipTyping":{"complete":"La t\xe2che {{task}} est termin\xe9e et pr\xeate \xe0 \xeatre copi\xe9e dans votre presse-papiers."},"summarizePrompt":{"systemPrompt":"R\xe9sumez le texte fourni de mani\xe8re concise. Il peut faire partie d\'un document plus long. N\'utilisez pas la mise en forme Markdown ni les balises de code. Ne fournissez que le r\xe9sum\xe9\xa0: pas de pr\xe9ambule, d\'\xe9tiquettes, d\'explications ni de commentaires, et n\'expliquez pas votre d\xe9marche.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur concernant la mani\xe8re dont le texte doit \xeatre g\xe9n\xe9r\xe9\xa0: {{userPreferences}}.","summarizeInstructions":"Instructions : {{summarizeInstructions}}.","userPrompt":"R\xe9sum\xe9 : {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"R\xe9\xe9crivez ou reformatez le texte fourni selon les instructions. En cas de reformatage (listes, tableaux, modifications de structure, etc.), conservez le texte original \xe0 l\'identique. En cas de r\xe9\xe9criture (ton, style, longueur, etc.), conservez le sens, mais pas n\xe9cessairement le vocabulaire. Ce texte peut faire partie d\'un document plus long. Respectez la mise en forme du texte source\xa0: s\'il est d\xe9j\xe0 au format Markdown ou sous forme de code, conservez-la. Sinon, n\'ajoutez pas de mise en forme Markdown (titres, gras, puces, balises de code) sauf si les instructions demandent explicitement une liste, un tableau ou une structure similaire. Affichez UNIQUEMENT le r\xe9sultat, sans pr\xe9ambule, \xe9tiquettes, titres, explications ni commentaires.","userPreferences":"Respectez ces pr\xe9f\xe9rences utilisateur concernant la mani\xe8re dont le texte doit \xeatre g\xe9n\xe9r\xe9\xa0: {{userPreferences}}.","rewriteInstructions":"Instructions : {{rewriteInstructions}}."}},"profile":{"title":"Contr\xf4les de l\'application","titlePlural":"Contr\xf4les de l\'application","titlePreview":"Aper\xe7u des commandes","previous":"Contr\xf4les de l\'application pr\xe9c\xe9dente","manage":"G\xe9rer les contr\xf4les des applications","view":"Contr\xf4les d\'affichage","edit":"Modifier les contr\xf4les de l\'application","add":"Ajouter des contr\xf4les d\'application","create":"Cr\xe9er des contr\xf4les d\'application","warn":"La cam\xe9ra ou le microphone doivent \xeatre d\xe9marr\xe9s pour utiliser les commandes de votre application.","descriptionShort":"D\xe9couvrez les diff\xe9rentes mani\xe8res dont Cephable vous aide \xe0 contr\xf4ler vos appareils et logiciels.","name":"Nom de l\'application","nameQuestion":"Comment souhaitez-vous appeler ces contr\xf4les d\u2019application\xa0?","newName":"Nouveaux contr\xf4les d\'application","search":"Rechercher les contr\xf4les d\'application par nom","searchLong":"Rechercher les contr\xf4les d\'application par nom ou description","keyboardAndMouse":"Clavier et souris","genericController":"Manette de jeu","keyboardMouseAndController":"Clavier, souris et contr\xf4leur","permissionError":"Vous n\'\xeates pas autoris\xe9 \xe0 utiliser ces contr\xf4les d\'application.","set":{"title":"Il semble que vous n\'ayez pas encore d\xe9fini de contr\xf4les d\'application.","cta":"D\xe9finir les contr\xf4les de l\'application","empty":{"auto":"Passez \xe0 une autre application pour voir les commandes","select":"S\xe9lectionnez un contr\xf4le pour commencer","none":"Aucun contr\xf4le d\'application trouv\xe9"},"description":"Les contr\xf4les d\'application permettent \xe0 Cephable de savoir ce qu\'il doit \xe9couter et quelles actions il doit entreprendre. Vous pouvez changer de contr\xf4le d\'application \xe0 tout moment depuis la page d\'accueil ou dans vos param\xe8tres de connexion."},"summary":{"title":"R\xe9sum\xe9 des contr\xf4les de l\'application","descriptionLong":"Voici les d\xe9tails de ces commandes d\'application. Vous pouvez rechercher des commandes, des actions et plus encore pour d\xe9couvrir leurs possibilit\xe9s.","description":"Obtenez un r\xe9sum\xe9 de ces contr\xf4les d\'application, y compris les contr\xf4les existants, les personnalisations, les d\xe9tails et plus encore.","view":"Afficher le r\xe9sum\xe9 des contr\xf4les de l\'application","filter":"Filtrer par type d\'entr\xe9e","placeholder":"Rechercher les noms de contr\xf4le..."},"copy":{"title":"Copier les contr\xf4les de l\'application","duplicate":"Contr\xf4les d\'application en double","question":"Cr\xe9er une copie ?","description":"Vous souhaitez cr\xe9er une copie de ces contr\xf4les d\'application\xa0? Une nouvelle fen\xeatre s\'ouvrira avec ces contr\xf4les copi\xe9s, mais ils ne seront ajout\xe9s \xe0 votre compte qu\'apr\xe8s leur enregistrement.","confirm":"Oui, cr\xe9er une copie","profileSuffix":"{{name}} (copie)"},"new":{"title":"Cr\xe9er de nouveaux contr\xf4les d\'application","description":"Cr\xe9ez des commandes personnalis\xe9es \xe0 partir de z\xe9ro ou laissez l\'IA de pointe g\xe9n\xe9rer des commandes personnalis\xe9es, vous permettant de naviguer sans effort dans les applications et les logiciels \xe0 l\'aide de votre voix, de votre t\xeate et de vos gestes du visage.","note":"Recommand\xe9 pour les utilisateurs avanc\xe9s.","scratch":"Cr\xe9er \xe0 partir de z\xe9ro"},"advancedOptions":"Options de contr\xf4le avanc\xe9es","delete":{"title":"Supprimer les contr\xf4les de l\'application","titleLong":"Supprimez ces contr\xf4les d\'application","description":"Vous pouvez supprimer ces contr\xf4les d\'application en cliquant sur \xab\xa0Supprimer les contr\xf4les d\'application\xa0\xbb.","confirm":"\xcates-vous s\xfbr de vouloir supprimer ces contr\xf4les d\'application\xa0?","confirmLong":"Une fois ces contr\xf4les supprim\xe9s, vous ne pourrez plus y revenir. \xcates-vous s\xfbr de vouloir supprimer ces contr\xf4les\xa0?","confirmButton":"Oui, supprimez ces contr\xf4les d\'application"},"current":"Contr\xf4les actuels","loading":"Chargement des commandes...","null":"Vous n\'avez pas encore de contr\xf4les d\'application. Cliquez ci-dessous pour en cr\xe9er un.","nullButton":"Cr\xe9ez vos premiers contr\xf4les d\'application","preview":"Aper\xe7u","features":"Caract\xe9ristiques","byline_public":"Par : l\'\xe9quipe Cephable","byline_shared":"Partag\xe9 par : Communaut\xe9 Cephable","share":{"title":"Partager les contr\xf4les de l\'application","previewTitle":"Aper\xe7u des contr\xf4les d\'applications partag\xe9es","description":"Partagez ces contr\xf4les d\u2019application avec d\u2019autres afin qu\u2019ils puissent en obtenir une copie et les personnaliser \xe0 partir de l\xe0\xa0!","descriptionLong":"Partagez ces commandes d\'application avec d\'autres personnes pour qu\'elles puissent en obtenir une copie et les personnaliser\xa0! Choisissez le mode de partage souhait\xe9, puis cr\xe9ez un lien \xe0 envoyer.","add":"Cr\xe9er un lien de partage","confirm":"Partager cette URL","link":"Partager le lien","copy":"Copier le lien","copied":"Copi\xe9!","usage":"Montant d\'utilisation","created":"Cr\xe9\xe9 {{value}}","expiration":{"title":"Expiration","once":"Autoriser une seule utilisation","unlimited":"Autoriser une utilisation illimit\xe9e","no":"Aucune expiration","date":"Date d\'expiration","dateDescription":"Expire \xe0 une date pr\xe9cise"},"manage":"G\xe9rer les liens de partage pr\xe9c\xe9dents","empty":"Aucun partage n\'a \xe9t\xe9 cr\xe9\xe9 pour ces contr\xf4les d\'application."},"swap":{"title":"Contr\xf4les d\'\xe9change","titleLong":"\xc9changez les commandes de votre application","descriptionShort":"Utilisez diff\xe9rents contr\xf4les d\u2019application pour correspondre au programme ou au logiciel que vous utilisez.","description":"Vous pouvez basculer entre diff\xe9rents contr\xf4les d\'application pour correspondre au programme ou au logiciel que vous utilisez."},"autoProfileSwitching":{"title":"Commutation de commande automatique","alerts":{"disabled":"La commutation de contr\xf4le automatique est d\xe9sactiv\xe9e.","temporarilyDisabled":"La commutation de contr\xf4le automatique est temporairement d\xe9sactiv\xe9e.","enabled":"La commutation de contr\xf4le automatique est activ\xe9e.","error":"Erreur lors de l\'enregistrement des pr\xe9f\xe9rences de commutation de contr\xf4le automatique"},"associatedPrograms":{"add":"Ajouter un nouveau programme associ\xe9","description":{"personal":"Choisissez les logiciels ou programmes que vous souhaitez connecter \xe0 ces commandes. Ce syst\xe8me prend en charge la commutation automatique des commandes\xa0: Cephable adapte automatiquement les commandes de ces applications au programme que vous utilisez.","short":"Choisissez le logiciel ou les programmes que vous souhaitez connecter \xe0 ces commandes."},"edit":"Modifier les programmes associ\xe9s","noOptionsText":"Commencez \xe0 taper pour trouver les programmes associ\xe9s","profileLabel":"Contr\xf4les de l\'application\xa0:","remove":"Supprimer le programme associ\xe9","title":"Programmes associ\xe9s","when":"Cephable basculera automatiquement les contr\xf4les de mon application sur {{profileName}} lorsque j\'utilise...","emptySearch":"Aucun programme n\'est associ\xe9 \xe0 ces contr\xf4les.","error":"Erreur lors de l\'enregistrement des programmes associ\xe9s. Veuillez r\xe9essayer ult\xe9rieurement.","emptyError":"Programme associ\xe9 vide d\xe9tect\xe9, veuillez le supprimer avant de continuer."},"commandOverlay":{"command":"Contr\xf4les de commutation d\'application\xa0: {{value}}"},"description":"Le changement automatique de contr\xf4le permet \xe0 Cephable de s\'adapter parfaitement \xe0 votre flux de travail. Lorsqu\'il est activ\xe9, Cephable ajuste les contr\xf4les de votre application en fonction du programme ou du logiciel utilis\xe9. S\'il est d\xe9sactiv\xe9, vous pouvez changer manuellement de contr\xf4le d\'application \xe0 l\'aide du bouton \xab\xa0Changer de contr\xf4le\xa0\xbb ou des commandes globales."},"error":{"noMatch":"Aucun contr\xf4le d\'application ne correspond \xe0 votre recherche.","load":"Erreur lors du chargement des contr\xf4les de l\'application.","add":"Erreur lors de l\'ajout des contr\xf4les d\'application.","delete":"Erreur lors de la suppression des contr\xf4les de l\'application.","audioEventsWithEmptyCommands":"Il manque des contr\xf4les dans votre r\xe9ponse. V\xe9rifiez-les pour vous assurer de les remplir compl\xe8tement.","conflicts":"Erreur lors de l\'enregistrement des contr\xf4les de l\'application en raison de conflits.","save":"Erreur lors de l\'enregistrement des commandes de l\'application. Veuillez r\xe9essayer.","device":"Contr\xf4le d\'application non valide pour cette connexion. Veuillez en essayer un autre."},"conflictIndicators":{"errorTitle":"Erreur lors de l\'enregistrement des contr\xf4les de l\'application en raison de conflits","warningTitle":"Contr\xf4les d\'application enregistr\xe9s avec des avertissements","subtitle":"Les contr\xf4les d\'application que vous avez cr\xe9\xe9s ont certaines configurations qui peuvent entrer en conflit.","profileNameErrors":"Conflit de nom des contr\xf4les d\'application","emptyControlsMapped":"Noms d\'entr\xe9e vides","emptyControlsMappedDescription":"Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la t\xeate ou une autre commande \xe0 votre entr\xe9e.","emptyKeybindingControlsMapped":"Noms d\'entr\xe9e vides pour les raccourcis clavier","emptyKeybindingControlsMappedDescription":"Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la t\xeate ou une autre commande \xe0 votre entr\xe9e pour les raccourcis clavier.","duplicateNameTitle":"Nom des contr\xf4les d\'application en double","duplicateNameDescription":"Vous disposez d\xe9j\xe0 d\'une application portant le m\xeame nom. Veuillez la modifier avant de continuer.","emptyNameTitle":"Nom des contr\xf4les d\'application vides","emptyNameDescription":"Les commandes de l\'application doivent avoir un nom, par exemple Jeu 1, Spotify, Word, etc.","macrosReleaseKeysMissingTitle":"Sorties avec des cl\xe9s non lib\xe9r\xe9es","macrosReleaseKeysMissingDescription":"Veuillez ajouter une cl\xe9 de d\xe9verrouillage ou arr\xeater toutes les \xe9tapes pour \xe9viter que les cl\xe9s ne se bloquent.","duplicateInputCommandMacroTitle":"Entr\xe9es de commande identiques","duplicateCommandsDescription":"Veuillez supprimer ou modifier les commandes d\'entr\xe9e en double.","duplicateInputCommandBindingsTitle":"Entr\xe9es de contr\xf4le identiques pour les raccourcis clavier","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} avec {{commandOrEventType}}","duplicateMacroNames":"Noms de contr\xf4le en double","duplicateMacroNamesDescription":"Veuillez supprimer ou modifier l\u2019un de vos noms de contr\xf4le identiques.","warningIgnore":"Ignorer","warningDoNotShowAgain":"Ne plus afficher les avertissements","macrosVoiceCommandConflictWithDictationTitle":"Contr\xf4lez les commandes vocales de la m\xeame mani\xe8re que les mots cl\xe9s de la dict\xe9e","keybindingsVoiceCommandConflictWithDictationTitle":"Les raccourcis clavier des commandes vocales sont identiques \xe0 ceux des mots cl\xe9s de la dict\xe9e","macrosVoiceCommandConflictWithDictationDescription":"Vos entr\xe9es vocales d\xe9clencheront la dict\xe9e et les commandes vocales.","keybindingsVoiceCommandConflictWithDictationDescription":"Vos entr\xe9es vocales d\xe9clencheront la dict\xe9e et les pressions sur les touches.","macrosVoiceCommandConflictWithGenerationTitle":"Contr\xf4ler les commandes vocales de la m\xeame mani\xe8re que les mots cl\xe9s de g\xe9n\xe9ration","keybindingsVoiceCommandConflictWithGenerationTitle":"Les commandes vocales des raccourcis clavier sont identiques aux mots cl\xe9s de g\xe9n\xe9ration","macrosVoiceCommandConflictWithGenerationDescription":"Vos entr\xe9es vocales d\xe9clencheront la g\xe9n\xe9ration et les commandes vocales.","keybindingsVoiceCommandConflictWithGenerationDescription":"Vos entr\xe9es vocales d\xe9clencheront la g\xe9n\xe9ration et les pressions sur les touches.","duplicateAssociatedProgramNames":"Noms de programmes associ\xe9s en double","duplicateAssociatedProgramNamesDescription":"Veuillez supprimer ou modifier l\'un de vos programmes associ\xe9s identiques.","emptyEvent":{"title":"\xc9tapes manquantes","description":"Il manque des \xe9tapes dans vos contr\xf4les. Cela pourrait emp\xeacher Cephable d\'ex\xe9cuter une action lorsque vous donnez une commande."},"warningDetails":"Afficher tous les conflits"},"success":{"save":"Contr\xf4les de l\'application enregistr\xe9s.","add":"Contr\xf4les d\'application ajout\xe9s.","delete":"Contr\xf4les de l\'application supprim\xe9s.","share":"Lien de partage cr\xe9\xe9 et copi\xe9 dans le presse-papiers","shareDelete":"Lien de partage supprim\xe9.","generate":"Contr\xf4les d\'application g\xe9n\xe9r\xe9s."},"warning":"Contr\xf4les d\'application enregistr\xe9s avec des avertissements","customize":"Personnaliser les contr\xf4les de l\'application","custom":"{{name}} (Personnalis\xe9)","description":"Les contr\xf4les d\'application sont un ensemble de commandes permettant de contr\xf4ler votre appareil ou votre connexion. Vous pouvez cr\xe9er plusieurs contr\xf4les d\'application et passer de l\'un \xe0 l\'autre \xe0 tout moment."},"publicProfiles":{"toolbar":"Explorer les commandes de l\'application","title":"Explorer les commandes de l\'application","offline":{"title":"Impossible de charger les contr\xf4les d\'application publics","description":"Il semble que vous soyez hors ligne. Vous pouvez toujours utiliser les commandes de votre application, mais vous ne pourrez pas charger de nouvelles commandes publiques.","confirm":"D\'accord"},"announcement":"{{count}} De nouveaux contr\xf4les d\'application ont \xe9t\xe9 charg\xe9s","description":{"personal":"Des contr\xf4les d\'application publics sont disponibles pour vous aider \xe0 d\xe9marrer rapidement avec Cephable sur vos applications pr\xe9f\xe9r\xe9es. Vous pouvez utiliser les contr\xf4les par d\xe9faut, les personnaliser selon vos besoins ou cr\xe9er de toutes nouvelles commandes personnalis\xe9es.","pro":"Des contr\xf4les d\'application publics sont disponibles pour vous aider \xe0 d\xe9marrer rapidement avec Cephable sur vos applications pr\xe9f\xe9r\xe9es. Vous pouvez utiliser les contr\xf4les par d\xe9faut, les personnaliser selon vos besoins ou cr\xe9er de nouveaux contr\xf4les d\'application personnalis\xe9s gr\xe2ce au g\xe9n\xe9rateur de contr\xf4les."},"team":"\xc9quipe Cephable"},"publicTag":"Publique","tray":{"panel":"Basculer le panneau","dashboard":"Afficher le tableau de bord","quit":"Quitter Cephable"},"generate":"G\xe9n\xe9rer","stop":"Arr\xeat","clear":"Clair","rewrite":"R\xe9crire","translate":"Traduire","smartTasks":{"title":"T\xe2ches intelligentes","show":"Afficher les t\xe2ches intelligentes","description":"Les t\xe2ches intelligentes sont les diff\xe9rentes t\xe2ches que l\'IA de Cephable peut effectuer pour vous. Ces t\xe2ches, aliment\xe9es par l\'IA int\xe9gr\xe9e \xe0 l\'appareil, peuvent \xeatre utilis\xe9es pour cr\xe9er du texte, r\xe9sumer, r\xe9\xe9crire, traduire, prendre des notes et discuter avec des documents.","generateText":{"title":"G\xe9n\xe9rer du texte","description":"Cr\xe9ez du contenu textuel en fonction de vos entr\xe9es ou de vos invites.","label":"D\xe9crivez ce que vous souhaitez g\xe9n\xe9rer"},"summarizeText":{"title":"R\xe9sumer un texte","description":"Extraire les informations pertinentes des textes longs et cr\xe9er de courts r\xe9sum\xe9s ou des points cl\xe9s \xe0 retenir.","directions":"Saisissez le texte \xe0 r\xe9sumer, ou Cephable utilisera automatiquement le texte que vous avez mis en \xe9vidence.","write":"R\xe9diger un r\xe9sum\xe9","outputLabel":"Votre r\xe9sum\xe9 appara\xeetra ici.","inputLabel":"Saisissez du texte \xe0 condenser"},"rewriteText":{"title":"R\xe9\xe9crire le texte","description":"Surlignez le texte dans une autre application dans laquelle vous \xe9crivez, puis revenez ici et d\xe9crivez comment vous souhaitez qu\'il soit r\xe9\xe9crit.","label":"D\xe9crivez comment vous souhaitez r\xe9\xe9crire le texte","inputLabel":"Saisissez le texte \xe0 r\xe9\xe9crire"},"translateText":{"title":"Traduire le texte","description":"Saisissez le texte \xe0 traduire, ou Cephable utilisera automatiquement le texte que vous avez mis en surbrillance.","label":"Entrez le texte \xe0 traduire","languageLabel":"Langue \xe0 traduire"},"noteTaker":{"title":"Preneur de notes","description":"Laissez Cephable enregistrer et transcrire localement vos r\xe9unions ou conversations"},"documentChat":{"title":"Discussion sur les documents","description":"Interagissez avec des documents et interrogez-les pour obtenir des informations rapides."},"highlightText":{"title":"Utiliser le texte en surbrillance","description":"Cephable peut utiliser automatiquement le texte surlign\xe9 dans n\'importe quelle application pour effectuer des t\xe2ches telles que la synth\xe8se, la r\xe9\xe9criture ou la traduction. Vous pouvez \xe9galement saisir du texte manuellement si vous le souhaitez.","label":"Entrez le texte \xe0 utiliser","placeholder":"Vous pouvez \xe9galement surligner du texte dans une autre application et revenir ici pour l\'utiliser.","noTextFound":"Texte introuvable. S\xe9lectionnez le texte dans une autre application ou collez-le dans le champ et r\xe9essayez."},"pasteText":{"title":"Coller du texte","description":"Cephable peut utiliser automatiquement le texte copi\xe9 dans votre presse-papiers pour effectuer des t\xe2ches telles que la synth\xe8se, la r\xe9\xe9criture ou la traduction. Vous pouvez \xe9galement saisir du texte manuellement si vous le souhaitez.","label":"Entrez le texte \xe0 utiliser","placeholder":"Vous pouvez \xe9galement surligner du texte dans une autre application et revenir ici pour l\'utiliser."},"clearCache":"Si vous rencontrez des probl\xe8mes lors de la g\xe9n\xe9ration, veuillez vider le cache et les ressources dans les param\xe8tres de g\xe9n\xe9ration de texte, puis r\xe9essayer.","transcribeAudio":{"title":"Transcrire l\'audio","description":"Convertissez des fichiers audio ou vid\xe9o en texte \xe0 l\'aide de la transcription IA.","inputMethod":"Choisissez la m\xe9thode de saisie","localFile":"Fichier local","url":"URL","selectFile":"S\xe9lectionner un fichier audio/vid\xe9o","urlLabel":"URL audio/vid\xe9o","transcribe":"Transcrire","result":"R\xe9sultat de la transcription","invalidFileType":"Veuillez s\xe9lectionner un fichier audio ou vid\xe9o valide (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Erreur de transcription","history":{"title":"Historique de la transcription","description":"Affichez et g\xe9rez vos transcriptions enregistr\xe9es.","viewHistory":"Afficher l\'historique","empty":"Aucune transcription pour le moment. Commencez \xe0 transcrire pour enrichir votre histoire\xa0!","titleLabel":"Titre (facultatif)","titlePlaceholder":"Entrez un titre pour cette transcription","textLabel":"Texte de transcription","confirmDelete":"\xcates-vous s\xfbr de vouloir supprimer cette transcription ?"}},"aiWorkflows":{"description":"Automatisez vos t\xe2ches de bureau et de navigation gr\xe2ce \xe0 l\'IA. D\xe9crivez simplement ce que vous souhaitez accomplir, et Cephable se chargera du reste.","label":"D\xe9crivez ce que vous souhaitez accomplir","status":{"idle":"Dans l\'attente de vos instructions...","initializing":"On pr\xe9pare tout...","planning":["\xc9laborer un plan...","Analyse de votre demande...","\xc9laboration des \xe9tapes...","Organisation du flux de travail...","Pr\xe9paration de la strat\xe9gie...","\xc9laboration d\'un plan d\'action...","Trouver la meilleure fa\xe7on de vous aider...","D\xe9terminer comment aborder cette question...","Analyse de votre demande...","Planification de l\'ex\xe9cution..."],"thinking":["Pens\xe9e..."],"waitingForUser":"Votre contribution est n\xe9cessaire pour continuer.","completed":"Succ\xe8s!","failed":"Votre requ\xeate a \xe9chou\xe9\xa0: {{message}}","canceled":"Votre demande a \xe9t\xe9 annul\xe9e.","terminated":"Votre demande a \xe9t\xe9 trait\xe9e.","thinkingInteractive":["Envisager la prochaine \xe9tape...","R\xe9capitulons ce que nous avons fait jusqu\'\xe0 pr\xe9sent...","D\xe9cider de la suite...","Analyse des r\xe9sultats...","Planification de la suite...","\xc9valuation des options...","D\xe9terminer la meilleure prochaine \xe9tape...","Je travaille sur la suite de votre demande...","Nous travaillons sur les prochaines \xe9tapes...","Traitement des r\xe9sultats de l\'\xe9tape pr\xe9c\xe9dente..."],"tools":{"click_element_by_index":{"executing-start":"Cliquer sur le bouton correspondant...","executing-complete":"J\'ai cliqu\xe9 sur {{params.index}}."},"click_element":{"executing-start":"Cliquer sur le num\xe9ro en surbrillance...","executing-complete":"J\'ai cliqu\xe9 sur {{params.elementName}}."},"copy_selection":{"executing-start":"Collecte du contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"draft_email":{"executing-start":"R\xe9diger un courriel...","executing-complete":"J\'ai r\xe9dig\xe9 un courriel concernant {{params.subject}}."},"execute_app_action":{"executing-start":"Ex\xe9cution de {{params.actionName}}...","executing-complete":"{{params.actionName}} termin\xe9."},"find_all_text":{"executing-start":"Recherche de tout le contexte pertinent concernant {{params.searchText}}...","executing-complete":"J\'ai trouv\xe9 tout le contexte pertinent concernant {{params.searchText}}."},"find_and_select_text":{"executing-start":"Recherche et s\xe9lection du contexte pertinent concernant {{params.searchText}}...","executing-complete":"J\'ai trouv\xe9 et s\xe9lectionn\xe9 le contexte pertinent concernant {{params.searchText}}."},"generate_text":{"executing-start":"Cr\xe9ation de contenu...","executing-progress":"Cr\xe9ation de contenu...{{progress}}%","executing-complete":"J\'ai cr\xe9\xe9 le contenu demand\xe9."},"get_all_interactive_elements":{"executing-start":"Recherche en cours pour obtenir plus de contexte...","executing-complete":"Je comprends avec quoi je peux interagir."},"get_all_text_elements_content":{"executing-start":"Je lis pour avoir plus de contexte...","executing-complete":"Je comprends quel contenu textuel est disponible."},"get_all_text_elements_names":{"executing-start":"Je lis pour avoir plus de contexte...","executing-complete":"Je comprends quel contenu textuel est disponible."},"get_available_profile_actions":{"executing-start":"V\xe9rification des commandes disponibles dans cette application...","executing-complete":"Je comprends ce que je peux faire dans cette application."},"get_document_content":{"executing-start":"Je lis pour avoir plus de contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"get_installed_apps":{"executing-start":"D\xe9terminer quelle application correspond \xe0 votre demande...","executing-complete":"Je sais quelles applications je peux utiliser."},"get_running_app_names":{"executing-start":"D\xe9terminer quelle application correspond \xe0 votre demande...","executing-complete":"Je sais quelles applications je peux utiliser."},"get_selected_text":{"executing-start":"Lecture du contenu s\xe9lectionn\xe9...","executing-complete":"J\'ai le contexte du contenu s\xe9lectionn\xe9."},"get_stored_content":{"executing-start":"Collecte du contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"keyboard_shortcut":{"executing-start":"Collecte du contexte...","executing-complete":"J\'ai le contexte, pr\xeat pour la suite de votre demande."},"open_app":{"executing-start":"Ouverture de {{params.appName}}...","executing-complete":"J\'ai ouvert {{params.appName}}."},"open_webpage":{"executing-start":"Ouverture de {{params.url}}...","executing-complete":"J\'ai ouvert {{params.url}}."},"paste_content":{"executing-start":"En \xe9crivant...","executing-complete":"J\'ai fini d\'\xe9crire."},"respond_to_user":{"executing-start":"Traitement de votre demande...","executing-complete:":"J\'ai trait\xe9 votre demande."},"search_browser":{"executing-start":"Recherche sur le Web de {{params.query}}...","executing-complete":"J\'ai cherch\xe9 sur le web {{params.query}}."},"select_all_text":{"executing-start":"S\xe9lectionner tout le texte...","executing-complete":"J\'ai s\xe9lectionn\xe9 tout le texte."},"summarize_text":{"executing-start":"En r\xe9sum\xe9, le texte\u2026","executing-progress":"En r\xe9sum\xe9...{{progress}}%","executing-complete":"J\'ai r\xe9sum\xe9 le texte."},"translate_text":{"executing-start":"Traduction du texte en {{params.targetLanguage}}...","executing-progress":"Traduction en cours...{{progress}}%","executing-complete":"J\'ai traduit le texte en {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"En \xe9crivant...","executing-complete":"J\'ai fini d\'\xe9crire."},"type_text":{"executing-start":"En \xe9crivant...","executing-complete":"J\'ai fini d\'\xe9crire."},"unknown":{"executing-start":"J\'ai rencontr\xe9 un probl\xe8me en essayant une strat\xe9gie diff\xe9rente...","executing-complete":"J\'ai essay\xe9 une strat\xe9gie diff\xe9rente."},"append_to_file":{"executing-start":"Ajout au fichier...","executing-complete":"J\'ai ajout\xe9 du contenu au fichier."},"copy_path":{"executing-start":"Copier...","executing-complete":"Je l\'ai copi\xe9."},"create_directory":{"executing-start":"Cr\xe9ation du dossier...","executing-complete":"J\'ai cr\xe9\xe9 le dossier."},"delete_path":{"executing-start":"Suppression en cours...","executing-complete":"Je l\'ai supprim\xe9."},"edit_user_file":{"executing-start":"Modification du fichier...","executing-complete":"J\'ai modifi\xe9 le fichier."},"get_file_info":{"executing-start":"V\xe9rification du fichier...","executing-complete":"J\'ai v\xe9rifi\xe9 le fichier."},"list_directory":{"executing-start":"Lister le dossier...","executing-complete":"J\'ai list\xe9 le dossier."},"move_path":{"executing-start":"Mobile...","executing-complete":"Je l\'ai d\xe9plac\xe9."},"open_path":{"executing-start":"Ouverture...","executing-complete":"Je l\'ai ouvert."},"read_user_file":{"executing-start":"Lecture du fichier...","executing-complete":"J\'ai lu le fichier."},"run_command":{"executing-start":"Ex\xe9cution d\'une commande...","executing-complete":"J\'ai ex\xe9cut\xe9 la commande."},"search_files":{"executing-start":"Recherche de fichiers...","executing-complete":"J\'ai trouv\xe9 des fichiers correspondants."},"search_in_files":{"executing-start":"Recherche dans les fichiers...","executing-complete":"J\'ai cherch\xe9 dans les fichiers."},"write_user_file":{"executing-start":"\xc9criture du fichier...","executing-complete":"J\'ai \xe9crit le fichier."},"rewrite_text":{"executing-progress":"R\xe9\xe9criture...{{progress}}%"},"analyze_table":{"executing-start":"Analyse du tableau...","executing-complete":"J\'ai analys\xe9 le tableau."}},"networkError":"Connexion interrompue lors du t\xe9l\xe9chargement du mod\xe8le. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer en envoyant une invite ou en red\xe9marrant l\'application.","executing-org-block":"Impossible d\'utiliser {{params.toolName}} car l\'interaction avec {{params.appOrDomain}} est bloqu\xe9e par l\'organisation.","executing-destructive-block":"Toute interaction avec {{params.elementName}} est bloqu\xe9e. Veuillez v\xe9rifier et effectuer cette action manuellement.","executing-type-focus-block":"J\'ai rencontr\xe9 un probl\xe8me lors de la saisie du contenu. Il a \xe9t\xe9 copi\xe9 dans votre presse-papiers\xa0; veuillez le coller manuellement.","executing-permission-block":"J\'ai eu un probl\xe8me pour acc\xe9der au fichier.","stopped":"Arr\xeat\xe9.","unsupportedOSVersion":"Votre syst\xe8me macOS est obsol\xe8te, veuillez le mettre \xe0 jour et r\xe9essayer.","loadNotice":{"firstRunSetup":"Configuration initiale de l\'IA embarqu\xe9e. Cela peut prendre quelques minutes, mais ce sera plus rapide la prochaine fois.","largeModel":"Chargement de {{model}} ({{size}} Go). Les mod\xe8les volumineux peuvent prendre quelques minutes \xe0 charger. Pour un chargement plus rapide, s\xe9lectionnez un mod\xe8le plus petit dans les param\xe8tres.","driverIssue":"Il se peut que votre pilote graphique soit obsol\xe8te, ce qui ralentit l\'IA embarqu\xe9e. La mise \xe0 jour de votre pilote graphique peut am\xe9liorer ses performances et sa fiabilit\xe9.","longTask":"Cette t\xe2che s\'allonge, je lui laisse donc plus de temps. Cela peut prendre jusqu\'\xe0 une minute."}},"ready":{"waiting":"AI Workflows est pr\xeat. Nous attendons vos instructions.","execute":"Les flux de travail IA sont pr\xeats. \xc0 partir de votre demande\u2026"},"start":"Commencer","progress":"Fonctionnement...","title":"Vos flux de travail d\'IA sont pr\xeats","steps":{"thinking":"Pens\xe9e","tool":"Outil","details":"D\xe9tails","chunkProgress":"partie {{current}} de {{total}}","output":"Sortir","showMore":"Afficher plus","showLess":"Afficher moins","contentUsed":"Contenu utilis\xe9","contentSource":"Contenu source","contentTruncated":"Affichage des {{shown}} premiers caract\xe8res sur {{total}}","error":"Erreur"},"prefix":"Flux de travail\xa0:","files":{"sectionTitle":"Fichiers","open":"Ouvrir","openFile":"Ouvrir le fichier","openFolder":"Ouvrir le dossier","openError":"Impossible d\'ouvrir \xab\xa0{{name}}\xa0\xbb. Ce fichier a peut-\xeatre \xe9t\xe9 d\xe9plac\xe9 ou supprim\xe9."},"input":{"other":"Autre\u2026","otherPlaceholder":"Saisissez votre r\xe9ponse","submit":"Envoyer"},"continue":{"label":"Continuer","placeholder":"Demandez \xe0 Cephable d\'exploiter davantage ce r\xe9sultat\u2026"},"retry":{"label":"R\xe9essayer"},"context":{"approaching":"Cette conversation est longue ({{percent}}% de la m\xe9moire de l\'IA utilis\xe9e). Les messages les plus anciens risquent d\'\xeatre supprim\xe9s.","trimmed":"Cette conversation a atteint la limite de m\xe9moire de l\'IA\xa0; elle risque donc d\'oublier les messages pr\xe9c\xe9dents. Veuillez d\xe9marrer un nouveau flux de travail pour r\xe9initialiser la conversation.","indicator":"{{percent}}% de la m\xe9moire de travail utilis\xe9e","indicatorPending":"M\xe9moire de travail utilis\xe9e pour ce flux de travail","indicatorTokens":"{{used}}/{{budget}} utilis\xe9"},"approval":{"title":"Confirmer l\'action","approve":"Approuver","reject":"Rejeter","edit":"Modifier","deletePath":"Supprimer ce fichier/dossier ? Cette action est d\xe9finitive.","runCommand":"Ex\xe9cuter cette commande shell\xa0?","movePath":"D\xe9placer/renommer ce chemin\xa0? Cela pourrait \xe9craser la destination.","confirmDelete":"Supprimer","confirmRun":"Ex\xe9cuter la commande","confirmMove":"Se d\xe9placer","badgeDestructive":"Destructeur","badgeCaution":"Prudence"},"browser":{"sectionTitle":"Navigateur","view":"Afficher le navigateur","open":"Ouvrir","openError":"Impossible d\'ouvrir le navigateur."},"resume":{"title":"Poursuivre une conversation pr\xe9c\xe9dente","description":"Consultez votre historique d\'automatisation et reprenez l\xe0 o\xf9 vous vous \xe9tiez arr\xeat\xe9.","searchPlaceholder":"Rechercher les conversations pr\xe9c\xe9dentes\u2026","noMatches":"Aucune conversation pass\xe9e ne correspond \xe0 \xab\xa0{{query}}\xa0\xbb","empty":"Aucune automatisation pass\xe9e pour le moment.","continuing":"Poursuite de la conversation","stopContinuing":"Lancez plut\xf4t une nouvelle conversation","indicator":"Poursuivre la conversation sur \xab\xa0{{title}}\xa0\xbb.","clear":"Effacer la conversation s\xe9lectionn\xe9e"}},"generatedByAI":"Fonctionne gr\xe2ce \xe0 l\'IA embarqu\xe9e, veuillez v\xe9rifier l\'exactitude des informations.","networkError":"Connexion interrompue lors du t\xe9l\xe9chargement du mod\xe8le. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer en envoyant une invite ou en red\xe9marrant l\'application.","genericError":"Une erreur inattendue s\'est produite. Veuillez r\xe9essayer.","download":{"title":"T\xe9l\xe9chargez des mod\xe8les d\'IA pour d\xe9bloquer davantage de fonctionnalit\xe9s","description":"Pour utiliser les t\xe2ches intelligentes, un mod\xe8le local doit \xeatre t\xe9l\xe9charg\xe9 sur votre appareil. Cela garantit la confidentialit\xe9 de vos donn\xe9es, qui ne sont jamais envoy\xe9es sur le cloud.","confirm":"T\xe9l\xe9charger","cancel":"Pas maintenant"},"runningInBackground":{"generate":"G\xe9n\xe9ration en arri\xe8re-plan...","rewrite":"R\xe9\xe9criture en arri\xe8re-plan...","translate":"Traduction en arri\xe8re-plan...","summarize":"En r\xe9sum\xe9...","generic":"Fonctionne en arri\xe8re-plan..."},"processing":"Traitement..."},"inputMethod":"M\xe9thode de saisie :","hotkey":{"title":"Bouton d\'action rapide","titlePlural":"Boutons d\'action rapide","titlePanel":"Actions rapides","label":"Nom d\'affichage du bouton d\'action rapide","placeholder":"Nom \xe0 afficher","question":"Comment souhaitez-vous nommer ce bouton ?","when":"Quand je tape...","description":"Les boutons d\'action rapide sont des boutons personnalisables qui permettent d\'effectuer des actions pertinentes dans votre application. Un simple clic peut ex\xe9cuter plusieurs \xe9tapes ou une seule action.","usagePrompt":"Les boutons d\'action rapide sont des boutons personnalisables qui permettent d\'effectuer des actions pertinentes dans votre application. Vous pouvez ajouter, supprimer ou modifier leur nom depuis la page principale des param\xe8tres de contr\xf4le de l\'application.","reorder":"Vous pouvez r\xe9organiser l\'ordre en utilisant les boutons de d\xe9placement vers le haut et vers le bas.","emptyTitle":"Pas de boutons d\'action rapide","edit":"Modifier les boutons d\'action rapide","tap":"Appuyez sur {{value}}","copySuffix":"{{name}}_copie","hotkeysOnly":"Boutons personnalis\xe9s","allControls":"Toutes les commandes de l\'application","show":"Afficher les boutons d\'action rapide","deprecatedDialog":{"title":"Les contr\xf4les de votre application n\xe9cessitent une mise \xe0 jour.","description2":"Une simple mise \xe0 jour suffit \u2013 une seconde \xe0 peine \u2013 et vous profiterez d\'une personnalisation fluide des boutons. Dites adieu aux \xe9tapes suppl\xe9mentaires et bonjour \xe0 une interface plus conviviale. Pr\xeat \xe0 passer \xe0 l\'action\xa0?","confirm":"Faisons-le!","description1":"Il semble que vous utilisiez d\'anciennes commandes d\'application avec des boutons d\'action rapide. Nous vous r\xe9servons des mises \xe0 jour int\xe9ressantes\xa0! Nous avons repens\xe9 le syst\xe8me pour simplifier la cr\xe9ation et la modification des boutons d\'action rapide, sans avoir \xe0 explorer les param\xe8tres avanc\xe9s."},"demo":{"title":"Boutons d\'action rapide de d\xe9monstration","step1":"Activer les boutons d\'action rapide","step2":"Utilisez les exemples d\u2019invite ci-dessous pour contr\xf4ler le bloc de texte.","command1":"Appuyez sur le bouton 1 pour \xab\xa0Agrandir le texte\xa0\xbb","command2":"Appuyez sur le bouton 2 pour \xab mettre le texte en gras \xbb","command3":"","continue":"Continuer avec les boutons d\'action rapide","description":"La zone de d\xe9monstration ci-dessous vous permettra d\'essayer les boutons d\'action rapide. Elle se limite au contr\xf4le sp\xe9cifique de la zone de texte ci-dessous."},"example":{"title":"Exemples de boutons d\'action rapide","command1":"Appuyez sur Pause","example1":"Exemple \xab\xa0mettre la vid\xe9o en pause\xa0\xbb","command2":"Appuyez sur Suivant","example2":"Exemple \xab\xa0zoom arri\xe8re\xa0\xbb","command3":"Appuyez sur Arr\xeater","example3":"Exemple \xab\xa0fermer la fen\xeatre\xa0\xbb","description":"Ces exemples illustrent la polyvalence des boutons d\'action rapide pour contr\xf4ler votre appareil ou votre connexion. Ils permettent d\'ex\xe9cuter des commandes, de naviguer dans les interfaces ou d\'effectuer des actions d\'un simple toucher."},"emptySearch":"Aucune action rapide ne correspond \xe0 ce crit\xe8re.","empty":"Il semble que vous n\'ayez actuellement aucune action rapide.","emptyLong":"Aucun bouton d\'action rapide n\'est configur\xe9 dans ces commandes d\'application. Une fois que vous aurez ajout\xe9 des boutons d\'action rapide ou choisi des commandes d\'application avec un bouton d\'action rapide, ils appara\xeetront ici."},"reset":"R\xe9initialiser","info":"Plus d\'informations","device":{"title":"Connexion","titlePlural":"Relations","status":{"title":"\xc9tat de la connexion\xa0:","connected":{"application":"Application connect\xe9e","connection":"Connect\xe9","device":"Appareil connect\xe9","game":"Jeu connect\xe9"},"disconnected":{"application":"Application d\xe9connect\xe9e","connection":"D\xe9connect\xe9","device":"Appareil d\xe9connect\xe9","game":"Jeu d\xe9connect\xe9"}},"running":"En cours d\'ex\xe9cution","offline":"Hors ligne","otherDevices":"Autres connexions de sortie","currentStatus":"Statut actuel :","connectionStatus":"\xc9tat de la connexion\xa0:","profileStatus":"Contr\xf4les actuels de l\'application\xa0:","name":{"title":"Nom de la connexion","question":"Comment voulez-vous appeler cette connexion ?","description":"Donnez un nom \xe0 votre connexion afin de pouvoir la retrouver facilement plus tard.","placeholder":"nom de la connexion","edit":"Modifier le nom de la connexion"},"updates":{"title":"Mises \xe0 jour de connexion","settings":"Param\xe8tres de mise \xe0 jour de la connexion","description":"V\xe9rifiez les mises \xe0 jour du micrologiciel de connexion et modifiez les param\xe8tres de mise \xe0 jour automatique","edit":"Modifier les param\xe8tres de mise \xe0 jour","check":{"title":"V\xe9rifier les mises \xe0 jour","processing":"V\xe9rification des mises \xe0 jour\xa0! Cela peut prendre quelques minutes et votre connexion peut red\xe9marrer pendant les mises \xe0 jour.","description":"Appuyez pour v\xe9rifier les mises \xe0 jour de votre connexion. Si une mise \xe0 jour est disponible et que votre connexion est active, la mise \xe0 jour commencera. Les mises \xe0 jour peuvent prendre quelques minutes."},"auto":{"title":"Mise \xe0 jour automatique","description":"Lorsque ce param\xe8tre est activ\xe9, votre connexion se met automatiquement \xe0 jour d\xe8s qu\'une mise \xe0 jour est disponible. Si ce param\xe8tre est d\xe9sactiv\xe9, appuyez sur le bouton de mise \xe0 jour pour obtenir la derni\xe8re version.","option":"Utiliser la mise \xe0 jour automatique\xa0?"}},"delete":{"title":"Dissocier {{name}}","titleLong":"Dissocier du compte","description":"La dissociation d\xe9connecte Cephable de cet ordinateur ou de ce jeu et le supprime de votre compte. Vous ne pourrez plus vous y connecter, lui envoyer de commandes ni le mettre \xe0 jour. Cette action est irr\xe9versible, mais vous pourrez cr\xe9er une nouvelle connexion avec le m\xeame ordinateur ou le m\xeame jeu si vous souhaitez l\'utiliser \xe0 nouveau ult\xe9rieurement.","confirm":"\xcates-vous s\xfbr de vouloir dissocier cette connexion\xa0?","confirmLong":"\xcates-vous s\xfbr de vouloir d\xe9senregistrer et r\xe9initialiser cette connexion\xa0? Vous ne pourrez plus vous y connecter, envoyer de commandes ni la mettre \xe0 jour. Apr\xe8s cette d\xe9sinscription et r\xe9initialisation, n\'importe qui pourra \xe9tablir cette connexion.","confirmButton":"Oui, supprimez cette connexion."},"manage":{"title":"Cliquez pour afficher et g\xe9rer les d\xe9tails de vos connexions.","description":"","name":"Personnalisez le nom de votre connexion pour une gestion plus facile."},"error":{"save":"Erreur lors de l\'enregistrement de la connexion.","load":"Erreur lors du chargement de la connexion.","add":"Erreur lors de l\'ajout de la connexion.","delete":"Erreur lors de la suppression de la connexion.","updates":"Erreur lors de la v\xe9rification des mises \xe0 jour.","connection":"La connexion n\'est pas \xe9tablie. V\xe9rifiez qu\'elle est bien \xe9tablie avant de r\xe9essayer.","deleteLong":"Nous n\'avons pas pu supprimer cette connexion de votre compte. Si vous vous reconnectez \xe0 ce compte, vous devrez peut-\xeatre la supprimer manuellement dans les param\xe8tres de connexion."},"success":{"save":"Connexion enregistr\xe9e.","add":"Connexion ajout\xe9e.","delete":"Connexion supprim\xe9e."},"description":"Cephable prend en charge plusieurs appareils et connexions. Vous pouvez g\xe9rer les param\xe8tres ou s\xe9lectionner l\'un d\'entre eux. Cet ordinateur sera toujours votre connexion principale. Vous pourrez ajouter d\'autres connexions ult\xe9rieurement.","swap":{"titlePlural":"Connexions d\'\xe9change","description":"Cephable prend en charge plusieurs appareils et connexions. Vous pouvez en s\xe9lectionner un ici. Cet ordinateur sera toujours votre connexion principale. Vous pourrez ajouter d\'autres connexions ult\xe9rieurement."},"control":{"button":"Contr\xf4le {{name}}","description":{"application":"Contr\xf4lez cette application connect\xe9e avec votre voix, des actions rapides, des mouvements de t\xeate, etc. Par exemple, si vous dites \xab\xa0Enregistrer\xa0\xbb, cela enregistrera l\'application en cours d\'ex\xe9cution.","connection":"Contr\xf4lez cette connexion avec votre voix, des actions rapides, des mouvements de t\xeate, etc. Par exemple, si vous dites \xab\xa0Enregistrer\xa0\xbb, votre connexion en cours sera sauvegard\xe9e.","device":"Contr\xf4lez cet appareil connect\xe9 avec votre voix, des actions rapides, des mouvements de t\xeate, etc. Par exemple, si vous dites \xab\xa0Ouvrir Spotify\xa0\xbb, Spotify s\'ouvrira sur l\'appareil en cours d\'ex\xe9cution.","game":"Contr\xf4lez ce jeu connect\xe9 avec votre voix, des actions rapides, des mouvements de t\xeate et bien plus encore. Par exemple, si vous dites \xab\xa0Go\xa0\xbb, le joueur se d\xe9placera en course."},"generic":"Connexion de contr\xf4le"},"titleShort":"Connecter","titleLong":"Connexions et extensions","viewAll":"Afficher toutes les connexions","add":{"short":"\xc9tendre","title":"Ajouter une nouvelle connexion ou extension","description":"Les connexions et les extensions vous permettent d\'enrichir votre exp\xe9rience Cephable. Vous pouvez ajouter de nouvelles connexions pour vous connecter \xe0 davantage d\'appareils, d\'applications ou de jeux. Passez \xe0 la vitesse sup\xe9rieure avec Cephable\xa0!","action":"Ajouter une nouvelle connexion","notAvailable":"Cette connexion ou extension n\'est pas accessible au public pour le moment. Cela se produit souvent avec les extensions cr\xe9\xe9es par les utilisateurs. Veuillez r\xe9essayer plus tard.","isNotPublic":"APER\xc7U\xa0: Cette extension est en version pr\xe9liminaire pour d\xe9veloppeurs et peut \xeatre incompl\xe8te. Les d\xe9veloppeurs doivent finaliser toutes les \xe9tapes avant sa publication publique. Les utilisateurs pourront consulter cette page ult\xe9rieurement pour obtenir la version compl\xe8te."},"new":"Vous avez une nouvelle connexion !","newLong":"Vous avez une nouvelle connexion ! Pour commencer \xe0 l\'utiliser, s\xe9lectionnez-la dans le menu ci-dessous.","selectDevice":"S\xe9lectionner l\'appareil"},"explore":"Explorer","shortcuts":{"title":"Raccourcis mondiaux","description":"Personnalisez les raccourcis clavier pour un acc\xe8s rapide aux commandes Cephable depuis n\'importe o\xf9 sur votre syst\xe8me.","info":"Ces raccourcis fonctionnent globalement et peuvent \xeatre utilis\xe9s m\xeame lorsque Cephable n\'est pas la fen\xeatre active.","shortcut":"Raccourci","toggleMicrophone":"Basculer le microphone","toggleDictation":"Basculer le mode dict\xe9e","toggleVoiceControl":"Basculer le mode de commande vocale","togglePanel":"Basculer le panneau","registrationFailed":"Certains raccourcis globaux n\'ont pas pu \xeatre enregistr\xe9s. Ils sont peut-\xeatre utilis\xe9s par une autre application\xa0:","record":{"title":"Raccourci d\'enregistrement","start":"Cliquez pour enregistrer","listening":"Appuyez sur la combinaison de touches souhait\xe9e...","pressKeys":"Appuyez sur les touches maintenant"},"formatHint":"S\xe9lectionnez au moins une touche de modification ({{modifierKey}}, {{modifierKey2}}, Shift) et une autre touche."},"gamepad":{"title":"Prise en charge de la manette de jeu","description":"Configurer la sortie du gamepad et du joystick pour les jeux sur PC","driver":{"description":"Pour prendre en charge les sorties de la manette de jeu, Cephable doit t\xe9l\xe9charger et installer un pilote externe appel\xe9 ViGEm. Ce pilote active la fonctionnalit\xe9 de manette virtuelle Xbox 360, reconnue nativement par les jeux.","installed":"Pilote de manette de jeu install\xe9\xa0: vous pouvez utiliser les sorties de la manette\xa0! Si vous rencontrez toujours des probl\xe8mes, vous pouvez essayer de r\xe9installer le pilote.","notInstalled":"Pilote du contr\xf4leur de jeu non install\xe9","install":"Installer le pilote du contr\xf4leur de jeu","reinstall":"R\xe9installer le pilote du contr\xf4leur de jeu","installing":"Installation du pilote du contr\xf4leur de jeu ViGEm...","installSuccess":"Le pilote de la manette de jeu ViGEm a \xe9t\xe9 install\xe9 avec succ\xe8s\xa0! Vous pouvez d\xe9sormais utiliser les sorties de la manette dans vos commandes.","installFailed":"\xc9chec de l\'installation du pilote ViGEm. Veuillez r\xe9essayer ou proc\xe9der \xe0 l\'installation manuelle depuis le site web de ViGEm.","title":"Pilote de manette de jeu","disclosure":{"title":"Installer un pilote de manette tiers\xa0?","description":"La prise en charge des manettes n\xe9cessite l\'installation de ViGEm, un pilote tiers non officiel permettant \xe0 Cephable d\'\xe9muler une manette Xbox virtuelle. Poursuivez uniquement si vous souhaitez que Cephable installe ce pilote.","confirm":"Installer le pilote ViGEm"}},"platform":{"unsupported":"Plateforme non prise en charge pour les fonctionnalit\xe9s de la manette","unsupportedDescription":"La fonctionnalit\xe9 de sortie manette est actuellement prise en charge uniquement sur les syst\xe8mes Windows x64. La prise en charge sur Mac et Windows ARM64 n\'est pas encore disponible."},"usage":"Une fois le pilote du contr\xf4leur de jeu install\xe9, vous pouvez utiliser les mouvements du joystick et les pressions sur les boutons de la manette dans vos macros et commandes vocales pour contr\xf4ler les jeux."},"youtube":{"unavailable":{"title":"Vid\xe9o indisponible","description":"Cette vid\xe9o est actuellement indisponible. Veuillez la r\xe9essayer ult\xe9rieurement.","retry":"R\xe9essayer"},"watch":{"title":"Oups.","description":"Il semble qu\'un probl\xe8me soit survenu lors du chargement de la vid\xe9o. Vous pouvez la regarder directement sur YouTube.","button":"Regarder sur YouTube"},"offline":{"title":"Vid\xe9o indisponible","description":"Cette vid\xe9o YouTube n\xe9cessite une connexion internet pour se charger. Veuillez v\xe9rifier votre connexion et r\xe9essayer."}},"metrics":{"download":{"success":"Acc\xe8s r\xe9ussi au fichier de m\xe9triques.","manualPath":"Fichier de m\xe9triques disponible \xe0\xa0: {{path}}","error":"Erreur lors du t\xe9l\xe9chargement du fichier de m\xe9triques.","noFile":"Aucun fichier de m\xe9triques trouv\xe9."},"clear":{"success":"Le fichier de m\xe9triques a \xe9t\xe9 effac\xe9 avec succ\xe8s.","error":"Erreur lors de l\'effacement du fichier de m\xe9triques.","noFile":"Aucun fichier de m\xe9triques n\'a \xe9t\xe9 trouv\xe9 pour \xeatre effac\xe9.","confirm":"Voulez-vous vraiment effacer toutes les donn\xe9es\xa0? Cette action est irr\xe9versible."}},"suggestedPrompts":{"title":"Suggestions d\'invites","description":"Personnalisez les invites sugg\xe9r\xe9es qui s\'affichent dans les t\xe2ches d\'IA pour vous aider \xe0 d\xe9marrer rapidement.","edit":"Modifier les invites sugg\xe9r\xe9es","generate":"G\xe9n\xe9rer du texte","rewrite":"R\xe9\xe9crire le texte","addGenerate":"Ajouter une invite de g\xe9n\xe9ration","addRewrite":"Ajouter une invite de r\xe9\xe9criture","remove":"Supprimer l\'invite","generatePlaceholder":"Entrez une invite pour la g\xe9n\xe9ration de texte...","rewritePlaceholder":"Entrez une invite pour la r\xe9\xe9criture du texte...","suggested":"Suggestions d\'invites","suggestedFor":"Sugg\xe9r\xe9 pour {{profileName}}","seeAll":"Voir toutes les invites","showLess":"Afficher moins","allPrompts":"Toutes les invites","customFor":"Invites personnalis\xe9es pour {{profileName}}","defaultPrompts":"Invites par d\xe9faut","defaultGenerate":["Un e-mail professionnel pr\xe9sentant notre nouveau produit","Un ordre du jour pour la discussion d\'\xe9quipe de la semaine prochaine","Un aper\xe7u de la proposition de projet pour une nouvelle initiative","Un mod\xe8le de lettre commerciale formelle","Une section de documentation technique","Introduction au manuel d\'utilisation","Un aper\xe7u du document de formation","Un projet de document de politique","Un e-mail de suivi apr\xe8s une r\xe9union","Un message de remerciement \xe0 un client","Un e-mail de mise \xe0 jour de l\'\xe9tat du projet","Une invitation \xe0 un \xe9v\xe9nement d\'entreprise","Un e-mail de rappel pour les \xe9ch\xe9ances \xe0 venir","Un e-mail de bienvenue pour les nouveaux membres de l\'\xe9quipe","Un e-mail d\'excuses pour l\'interruption de service","Une introduction \xe0 la newsletter","Une liste de brainstorming pour les campagnes marketing","Solutions cr\xe9atives pour am\xe9liorer la productivit\xe9 des \xe9quipes","Id\xe9es d\'activit\xe9s pour une retraite d\'entreprise","Concepts pour une nouvelle fonctionnalit\xe9 d\'application mobile","Suggestions pour am\xe9liorer l\'exp\xe9rience client","Id\xe9es d\'innovation pour le d\xe9veloppement de nos produits","Id\xe9es de contenu pour les publications sur les r\xe9seaux sociaux","Th\xe8mes d\'atelier pour le d\xe9veloppement professionnel","Une fonction qui valide la saisie de l\'utilisateur","Une requ\xeate de base de donn\xe9es pour la gestion des utilisateurs","Code de gestion des erreurs pour les requ\xeates API","Un mod\xe8le de fichier de configuration","Commentaires expliquant un algorithme complexe","Cas de tests unitaires pour une nouvelle fonctionnalit\xe9","Documentation pour les points de terminaison de l\'API","Un script pour un d\xe9ploiement automatis\xe9"],"defaultRewrite":["Rendre ce texte plus concis et pr\xe9cis","D\xe9veloppez ce r\xe9sum\xe9 avec plus de d\xe9tails","Reformater ceci comme une liste num\xe9rot\xe9e","Convertissez ceci en puces","Restructurez ceci en paragraphes clairs","Rendre ce texte plus facile \xe0 parcourir rapidement","Organiser ces informations de mani\xe8re hi\xe9rarchique","Formatez ceci comme un guide \xe9tape par \xe9tape","Rendez ce message plus professionnel et formel","R\xe9\xe9crivez ceci pour qu\'il paraisse plus d\xe9contract\xe9 et amical","Ajustez le ton pour \xeatre plus encourageant","Rendez ce son plus confiant et affirm\xe9","Adoucir le ton pour \xeatre plus diplomate","Ajoutez de l\'enthousiasme et de l\'\xe9nergie \xe0 ce texte","Rendez cela plus empathique et compr\xe9hensif","R\xe9\xe9crire avec un ton plus collaboratif","Simplifiez ceci pour un public g\xe9n\xe9ral","Rendre cette explication plus technique et d\xe9taill\xe9e","D\xe9composez ce concept complexe en termes plus simples","Ajoutez plus de contexte et d\'informations g\xe9n\xe9rales","R\xe9sumez ceci en points cl\xe9s \xe0 retenir","D\xe9veloppez les points principaux avec des exemples","Rendre cela plus accessible aux d\xe9butants","Condensez ceci tout en gardant les informations essentielles","Am\xe9liorer la clart\xe9 et la lisibilit\xe9","Rendez cela plus engageant et int\xe9ressant","Ajuster pour une meilleure grammaire et un meilleur flux","R\xe9\xe9crire pour mettre l\'accent sur les avantages"],"defaultSummarize":["R\xe9sumez en 3 points","Extraire les d\xe9cisions cl\xe9s","Liste des principales actions \xe0 entreprendre","Fournissez un r\xe9sum\xe9 en une phrase","Mettez en \xe9vidence les faits les plus importants","R\xe9sumer pour un public non sp\xe9cialis\xe9","Extraire les points cl\xe9s","R\xe9sumez en 5 points","Identifier le probl\xe8me principal et la solution propos\xe9e","\xc9num\xe9rer toutes les conclusions et recommandations","Fournir un r\xe9sum\xe9 ex\xe9cutif","R\xe9sumez la chronologie des \xe9v\xe9nements","Extraire toutes les questions pos\xe9es","\xc9num\xe9rez les avantages et les inconv\xe9nients mentionn\xe9s","R\xe9sumez les arguments principaux"]},"accessibilityService":{"error":{"generic":"Erreur interne. Veuillez r\xe9essayer plus tard.","elementNotFound":"Aucun r\xe9sultat trouv\xe9. Veuillez v\xe9rifier que la recherche existe et r\xe9essayer.","highlightOnConflict":"Plusieurs \xe9l\xe9ments ont \xe9t\xe9 trouv\xe9s. Veuillez pr\xe9ciser votre commande pour indiquer celui que vous souhaitez s\xe9lectionner.","clickNotInitialized":"La fonction \xab\xa0Appuyer par nom\xa0\xbb n\'est pas disponible pour le moment. Veuillez contacter l\'assistance si le probl\xe8me persiste.","platformUnsupported":"La saisie par nom n\'est pas prise en charge sur cette plateforme.","permission":"Cephable n\'est pas autoris\xe9 \xe0 lire cette application. Accordez-lui l\'autorisation dans Param\xe8tres syst\xe8me > Confidentialit\xe9 et s\xe9curit\xe9 > {{pane}} \u2014 sur un appareil g\xe9r\xe9 par l\'entreprise, cette option peut \xeatre bloqu\xe9e par votre administrateur."},"clickWait":"Initialisation en cours. Veuillez patienter un instant et r\xe9essayer."},"deprecated":"D\xe9pr\xe9ci\xe9","view":"Voir","aiWorkflows":{"settings":{"title":"Param\xe8tres automatis\xe9s","description":"Configurez les mod\xe8les d\'IA et les appareils utilis\xe9s pour les flux de travail d\'IA. Ces flux de travail vous permettent d\'automatiser les t\xe2ches de bureau et de navigateur gr\xe2ce \xe0 l\'IA embarqu\xe9e.","configType":{"title":"Type de configuration du mod\xe8le","description":"S\xe9lectionnez le type de configuration de mod\xe8le \xe0 utiliser pour les flux de travail d\'IA. Diff\xe9rentes configurations sont optimis\xe9es pour diff\xe9rents mod\xe8les.","label":"Type de configuration"},"reasoningModel":{"title":"Mod\xe8le de raisonnement","description":"S\xe9lectionnez le mod\xe8le d\'IA \xe0 utiliser pour les t\xe2ches de raisonnement et de planification. Ce mod\xe8le analysera vos demandes et cr\xe9era des plans d\'action.","label":"Mod\xe8le de raisonnement"},"reasoningDevice":{"label":"Dispositif de raisonnement"},"generationModel":{"title":"Mod\xe8le de g\xe9n\xe9ration","description":"S\xe9lectionnez le mod\xe8le d\'IA \xe0 utiliser pour les t\xe2ches de g\xe9n\xe9ration de texte. Ce mod\xe8le cr\xe9e du contenu textuel en fonction des besoins des flux de travail.","label":"Mod\xe8le de g\xe9n\xe9ration"},"generationDevice":{"label":"Dispositif de g\xe9n\xe9ration"},"noModelsFound":"Aucun mod\xe8le trouv\xe9","terminate":{"title":"Ressources de flux de travail clair","description":"Cliquez pour interrompre le processus et lib\xe9rer des ressources. Cela arr\xeatera tout flux de travail en cours et lib\xe9rera la m\xe9moire utilis\xe9e par les mod\xe8les d\'IA.","button":"Mettre fin au flux de travail","success":"Le processus de travail a \xe9t\xe9 interrompu.","confirm":{"title":"Mettre fin au flux de travail","description":"\xcates-vous s\xfbr de vouloir interrompre le processus de workflow\xa0? Cela arr\xeatera tout workflow en cours et lib\xe9rera des ressources.","confirm":"Oui, terminez"}},"autoWarm":{"title":"Flux de travail d\'IA \xe0 d\xe9marrage automatique","description":"Initialisation automatique des mod\xe8les de flux de travail d\'IA au d\xe9marrage de l\'application. Les mod\xe8les seront pr\xe9charg\xe9s afin que les flux de travail puissent d\xe9marrer imm\xe9diatement.","option":"D\xe9marrage automatique des mod\xe8les de flux de travail IA au lancement de l\'application"},"prompt":{"title":"Informations compl\xe9mentaires pour les flux de travail d\'IA","description":"Saisissez des informations suppl\xe9mentaires qui seront utilis\xe9es par l\'IA de Cephable lors de l\'ex\xe9cution des workflows. Utilisez ce champ pour indiquer vos pr\xe9f\xe9rences concernant le ton, le comportement ou tout autre d\xe9tail.","field":"Invite suppl\xe9mentaire","placeholder":"Par exemple, confirmez toujours avant d\'envoyer des courriels. Privil\xe9giez les r\xe9ponses concises. Utilisez un langage formel dans vos documents."},"disableButtonNames":{"edit":"Interactions avec le bouton Bloquer","input":{"label":"Nom du bouton","question":"Quels boutons souhaitez-vous bloquer\xa0? Vous pouvez saisir des noms de boutons complets ou partiels.","remove":"Supprimer le nom du bouton"},"button":"Bloquer les boutons","description":"Contr\xf4lez les boutons avec lesquels les flux de travail d\'IA sont autoris\xe9s \xe0 interagir. Par d\xe9faut, Cephable peut cliquer sur n\'importe quel bouton de votre \xe9cran. Utilisez ce param\xe8tre pour \xe9viter les actions accidentelles (par exemple, \xab\xa0acheter\xa0\xbb, \xab\xa0supprimer\xa0\xbb)."},"remoteWorkflows":{"title":"Ex\xe9cutez des flux de travail d\'IA sur tous vos appareils","option":"Autoriser mes autres appareils \xe0 d\xe9marrer et \xe0 suivre les automatisations sur cet appareil","description":"Activ\xe9 par d\xe9faut. Lorsqu\'il est activ\xe9, vous pouvez d\xe9marrer, suivre et r\xe9pondre aux automatisations de cet appareil depuis vos autres appareils connect\xe9s\xa0: la progression de l\'automatisation (titres des \xe9tapes et raisonnement de l\'IA) ainsi que les questions pos\xe9es sont envoy\xe9es en temps r\xe9el \xe0 ces appareils, vous permettant ainsi de r\xe9pondre o\xf9 que vous soyez. Ces donn\xe9es sont partag\xe9es uniquement entre vos appareils et ne sont jamais stock\xe9es sur les serveurs de Cephable. D\xe9sactivez cette option pour que les automatisations restent exclusivement sur cet appareil\xa0: elles continueront de s\'ex\xe9cuter, mais aucune donn\xe9e ne sera envoy\xe9e \xe0 vos autres appareils, et ces derniers ne pourront pas d\xe9marrer d\'automatisation sur cet appareil."},"thinkingLevel":{"field":"Effort de raisonnement","description":"Le niveau de r\xe9flexion de l\'IA avant chaque action est plus \xe9lev\xe9. Plus ce niveau est \xe9lev\xe9, plus elle choisit et ordonne les actions avec pr\xe9cision pour les t\xe2ches complexes, mais chaque \xe9tape est l\xe9g\xe8rement plus lente. Le niveau moyen est recommand\xe9 pour la plupart des utilisateurs.","low":"Bas (le plus rapide)","medium":"Moyen (recommand\xe9)","high":"Haut","max":"Max (le plus minutieux)"},"dynamicTools":{"option":"Chargement des outils Smart Connector","description":"Pour un d\xe9marrage plus rapide, chargez uniquement les outils que vous utilisez. Lorsqu\'ils sont d\xe9sactiv\xe9s, tous les outils se chargent simultan\xe9ment\xa0; c\'est pratique si vous souhaitez que le mod\xe8le d\xe9cide des actions \xe0 entreprendre, mais cela peut \xeatre beaucoup plus lent et entra\xeener des r\xe9sultats de moindre qualit\xe9."},"longTasks":{"field":"T\xe2ches longues","description":"Comment les flux de travail d\'IA g\xe8rent les t\xe2ches complexes, comme la lecture de longs documents\xa0? Le mode automatique alloue plus de ressources \xe0 une t\xe2che uniquement lorsque cela est n\xe9cessaire. Le mode \xab\xa0Prioriser la vitesse\xa0\xbb garantit une ex\xe9cution rapide, mais les t\xe2ches tr\xe8s longues risquent d\'oublier leurs premi\xe8res \xe9tapes. Le mode \xab\xa0Toujours autoriser les t\xe2ches longues\xa0\xbb alloue davantage de ressources \xe0 chaque t\xe2che, mais les \xe9tapes de saisie de texte prennent un peu plus de temps. Ceci s\'applique uniquement aux ordinateurs \xe9quip\xe9s d\'une carte graphique d\xe9di\xe9e.","auto":"Automatique (recommand\xe9)","speed":"Prioriser la vitesse","long":"Pr\xe9voyez toujours des t\xe2ches longues"}}},"control":"Contr\xf4le","automate":"Automatiser","deviceCommandThrottled":{"macroLength":"Cette connexion ne permet pas les macros longues. Votre macro a \xe9t\xe9 raccourcie automatiquement.","commandCount":"Cette connexion limite la vitesse d\'envoi des commandes. Veuillez patienter et r\xe9essayer ult\xe9rieurement.","incompatibleActions":"Ce contr\xf4le contient des actions qui ne peuvent pas \xeatre utilis\xe9es ensemble et n\'a pas \xe9t\xe9 envoy\xe9."},"tos":{"title":"Mise \xe0 jour des conditions d\'utilisation","description":"Nos conditions d\'utilisation ont \xe9t\xe9 mises \xe0 jour. Veuillez consulter et accepter les conditions mises \xe0 jour pour continuer \xe0 utiliser Cephable.","effectiveDate":"Date d\'entr\xe9e en vigueur : {{date}}","accept":"Accepter les conditions d\'utilisation","loadError":"Impossible de charger les conditions d\'utilisation. Veuillez r\xe9essayer.","viewInBrowser":"Afficher les conditions d\'utilisation dans le navigateur","acceptCheckbox":"J\'ai lu et j\'accepte les conditions d\'utilisation"},"appearance":{"title":"Apparence"},"troubleshooting":{"title":"D\xe9pannage"},"extensions":{"title":"Extensions","titleShort":"Extensions","description":"Activez les fonctionnalit\xe9s, connectez les applications compl\xe9mentaires et \xe9tendez les capacit\xe9s de Cephable.","searchPlaceholder":"Extensions de recherche","noResults":"Aucune extension ne correspond \xe0 votre recherche.","comingSoon":"\xc0 venir","done":"Fait","getStarted":"Commencer","viewDetails":"Afficher les d\xe9tails et les param\xe8tres","enable":"Activer","publisher":{"official":"C\xe9phable","officialTitle":"Officiel \u2014 construit et maintenu par Cephable","byline":"Par {{publisher}}","thirdPartyTitle":"Int\xe9gration tierce par {{publisher}}"},"category":{"inputControls":{"title":"Entr\xe9e et contr\xf4le","description":"Activez les modes de contr\xf4le de votre appareil avec Cephable."},"companionApps":{"title":"Applications et outils compl\xe9mentaires","description":"\xc9tendez les possibilit\xe9s de Cephable gr\xe2ce \xe0 notre application mobile et \xe0 nos cr\xe9ateurs web."},"buildExtend":{"title":"Construire et \xe9tendre","description":"Cr\xe9ez vos propres extensions avec l\'API et les SDK de Cephable."},"marketplace":{"title":"March\xe9","description":"De nouvelles comp\xe9tences, de nouveaux outils et de nouveaux contacts sont \xe0 venir."},"previews":{"title":"Aper\xe7us","description":"D\xe9couvrez les fonctionnalit\xe9s en cours de d\xe9veloppement. Les aper\xe7us sont susceptibles d\'\xe9voluer avant leur publication."}},"camera":{"title":"Commandes de la cam\xe9ra","description":"Contr\xf4lez votre appareil par les mouvements du visage et de la t\xeate gr\xe2ce \xe0 votre cam\xe9ra.","detail":"Les commandes de la cam\xe9ra vous permettent d\'utiliser les expressions faciales et les mouvements de la t\xeate (y compris la t\xeate comme souris) pour contr\xf4ler votre appareil. Activez-les \xe0 l\'aide du commutateur sur la carte, puis ajustez le comportement ici.","settings":{"title":"Expressions et gestes","description":"Dans les Param\xe8tres, vous pouvez associer des expressions faciales et des mouvements de t\xeate \xe0 des actions."},"advancedSettings":"Ouvrir les param\xe8tres de l\'appareil photo"},"gamepad":{"title":"Prise en charge des manettes de jeu","description":"\xc9mulez une manette Xbox pour que les jeux reconnaissent vos entr\xe9es Cephable.","detail":"La prise en charge des manettes n\xe9cessite l\'installation de ViGEm, un pilote tiers non officiel, pour \xe9muler une manette Xbox virtuelle reconnue nativement par les jeux. Installez ou mettez \xe0 jour le pilote ci-dessous. Disponible pour Windows x64."},"mobile":{"title":"Application mobile Cephable","description":"Utilisez votre t\xe9l\xe9phone comme manette avec l\'application mobile Cephable.","detail":"T\xe9l\xe9chargez l\'application mobile Cephable pour utiliser votre t\xe9l\xe9phone comme manette. Scannez un code ou utilisez les liens pour la t\xe9l\xe9charger sur iOS ou Android, puis pr\xe9visualisez l\'application ci-dessous.","screenshotsTitle":"Aper\xe7u","screenshotPlaceholder":"Capture d\'\xe9cran","screenshotAlt":"Capture d\'\xe9cran de l\'application mobile Cephable {{number}}","scanTitle":"Scannez pour t\xe9l\xe9charger","ios":"iOS \u2014 App Store","android":"Android \u2014 Google Play","iosAction":"T\xe9l\xe9chargez-la sur l\'App Store","androidAction":"T\xe9l\xe9chargez-le sur Google Play"},"controllerCreator":{"title":"Cr\xe9ateur de manettes personnalis\xe9es","description":"Concevez vos propres manettes \xe0 l\'\xe9cran sur controller.cephable.com.","detail":"Le cr\xe9ateur de manettes personnalis\xe9es vous permet de concevoir et de partager vos propres manettes \xe0 l\'\xe9cran dans le navigateur.","qrCaption":"contr\xf4leur.cephable.com","action":"Cr\xe9ateur de contr\xf4leurs ouverts","screenshotsTitle":"Aper\xe7u","screenshotPlaceholder":"Capture d\'\xe9cran du cr\xe9ateur de manette","screenshotAlt":"Capture d\'\xe9cran de Custom Controller Creator {{number}}"},"developer":{"title":"Cr\xe9ez votre propre extension","description":"Utilisez l\'API et les SDK de Cephable pour cr\xe9er et partager vos propres extensions.","detail":"Cr\xe9ez vos propres extensions et int\xe9grations avec Cephable. Explorez l\'API et les SDK, puis publiez et partagez vos cr\xe9ations sur developers.cephable.com.","api":{"title":"API Cephable","description":"G\xe9rez par programmation les profils, les appareils, les commandes et les \xe9v\xe9nements en temps r\xe9el."},"sdk":{"title":"Kits de d\xe9veloppement logiciel (SDK) et exemples","description":"D\xe9marrez rapidement gr\xe2ce \xe0 nos kits de d\xe9veloppement logiciel (SDK), nos exemples et nos guides d\'int\xe9gration."},"action":"Rendez-vous sur developers.cephable.com"},"portal":{"title":"Projets et \xe9quipes","description":"G\xe9rez vos projets et vos \xe9quipes dans le portail Cephable.","detail":"Utilisez le portail Cephable pour g\xe9rer vos projets, vos \xe9quipes et les param\xe8tres de votre organisation depuis un seul et m\xeame endroit.","projects":{"title":"Projets","description":"Cr\xe9er et g\xe9rer des projets, des cl\xe9s API et des int\xe9grations."},"teams":{"title":"\xc9quipes","description":"Invitez des membres, attribuez des r\xf4les et g\xe9rez les acc\xe8s au sein de votre organisation."},"action":"Ouvrir le portail Cephable"},"mcpTools":{"title":"Outils MCP","description":"Utilisez les outils du protocole MCP (Model Context Protocol) pour \xe9tendre les capacit\xe9s de Cephable."},"aiSkills":{"title":"Comp\xe9tences en IA","description":"Ajoutez des comp\xe9tences d\'IA r\xe9utilisables que Cephable peut d\xe9clencher \xe0 la demande."},"workflows":{"title":"Flux de travail r\xe9utilisables","description":"Partagez et installez des flux de travail d\'automatisation pr\xe9d\xe9finis."},"controlBundles":{"title":"Packs de contr\xf4le","description":"Installez des ensembles de contr\xf4les d\'applications et de jeux soigneusement s\xe9lectionn\xe9s en un seul clic."},"connections":{"title":"Connexions jeux et applications","description":"D\xe9couvrez les jeux et applications que vous pouvez contr\xf4ler avec Cephable, comme Call of Duty: Black Ops 7."},"aiSkillsMarketplace":{"title":"AI Skills Marketplace","description":"Browse and install skills shared by the community."},"nav":{"label":"Parcourir les extensions","discover":"D\xe9couvrir","skills":"Comp\xe9tences","connectors":"Connecteurs","features":"Caract\xe9ristiques Cephable","installed":"Install\xe9"},"stats":{"rating":"Notation","installs":"Installations","rated":"Merci pour votre \xe9valuation !","rateError":"Impossible d\'enregistrer votre \xe9valuation.","yourRating":"Votre note"},"copyLink":"Copier le lien","detail":{"access":{"developer":"Promoteur","employee":"Employ\xe9","plus":"Plus","student":"\xc9tudiant"},"by":"par","categories":"Cat\xe9gories","featured":"En vedette","installing":"Installation en cours\u2026","size":"Taille du t\xe9l\xe9chargement","transport":"Transport","version":"Version"},"discover":{"connectors":"Connecteurs","coreDescription":"Cam\xe9ras, manettes de jeu, applications compagnon et outils de d\xe9veloppement int\xe9gr\xe9s \xe0 Cephable.","coreTitle":"Caract\xe9ristiques Cephable","description":"Comp\xe9tences et liens officiels et communautaires pour \xe9tendre l\'assistant Cephable.","empty":"Rien \xe0 afficher pour le moment. Parcourez les comp\xe9tences ou les connecteurs pour ajouter les v\xf4tres.","exploreFeatures":"Explorez les fonctionnalit\xe9s","featured":"En vedette","newest":"Nouveaut\xe9s et points forts","skills":"Comp\xe9tences","title":"D\xe9couvrir","viewAll":"Afficher tout"},"features":{"description":"Des moyens int\xe9gr\xe9s pour contr\xf4ler Cephable\xa0: cam\xe9ras, manettes, applications compagnon et outils de d\xe9veloppement.","title":"Caract\xe9ristiques Cephable","searchPlaceholder":"Fonctionnalit\xe9s de recherche\u2026"},"install":"Installer","installError":"Impossible d\'installer.","installed":"Install\xe9","linkCopied":"Lien copi\xe9","provenance":{"cephable":"C\xe9phable","mine":"Le mien","organization":"Votre organisation","thirdParty":"Tierce personne"},"installedPage":{"connectors":"Connecteurs","description":"Comp\xe9tences et connecteurs que vous avez ajout\xe9s. Ouvrez-en un pour le g\xe9rer ou le supprimer.","empty":"Vous n\'avez ajout\xe9 aucune comp\xe9tence ni aucun connecteur pour le moment.","manage":"G\xe9rer","skills":"Comp\xe9tences","title":"Install\xe9","searchPlaceholder":"Rechercher les extensions install\xe9es\u2026"},"type":{"skill":"Comp\xe9tence","tool":"Connecteur","input":"Saisir","build":"Construire","app":"Application compagnon","feature":"Fonctionnalit\xe9"},"publish":{"title":{"mcp":"Partagez ce connecteur MCP","skill":"Partagez cette comp\xe9tence"},"shareWith":"Qui peut acc\xe9der \xe0 ceci","target":{"organization":"Les personnes de mon organisation","public":"Tout le monde (march\xe9 public)"},"chooseOrganization":"Choisissez une organisation","yourOrganization":"votre organisation","audience":{"public":"Une fois approuv\xe9e par l\'\xe9quipe Cephable, cette fonctionnalit\xe9 sera accessible \xe0 tous les utilisateurs de Cephable. Choisissez vos mots-cl\xe9s et ic\xf4nes en cons\xe9quence.","organization":"Tous les membres de {{org}} pourront trouver et installer ceci."},"displayName":"Nom d\'affichage","shortDescription":"Br\xe8ve description","shortDescriptionHelp":"Un r\xe9sum\xe9 d\'une ligne affich\xe9 dans les listes.","description":"Description","iconUrl":"URL de l\'ic\xf4ne","darkModeIconUrl":"URL de l\'ic\xf4ne du mode sombre","categories":"Cat\xe9gories","categoriesHelp":"S\xe9par\xe9s par des virgules (ex. productivit\xe9, \xe9criture).","version":"Version","versionHelp":"Laisser vide pour une mise \xe0 jour automatique.","secretNote":{"mcp":"Seules les informations de connexion non confidentielles sont partag\xe9es. Vos cl\xe9s API, jetons et autres identifiants restent sur cet appareil\xa0; les personnes qui installent l\u2019application saisissent les leurs.","skill":"Les fichiers et les instructions de cette comp\xe9tence sont partag\xe9s tels quels. Supprimez tout \xe9l\xe9ment priv\xe9 avant publication."},"confirm":"Publier","submitConfirm":"Soumettre pour examen","reviewNote":"Les articles soumis publiquement sont examin\xe9s par l\'\xe9quipe Cephable avant leur publication sur la plateforme. Vous pourrez consulter le statut de votre article et nous vous enverrons un courriel une fois l\'examen termin\xe9.","notes":"Notes \xe0 l\'attention du r\xe9viseur (facultatif)","notesHelp":"Tout ce qui peut nous aider \xe0 faire le point \u2014 sur son fonctionnement et sur les changements intervenus depuis la derni\xe8re fois.","inReview":"Cette demande est d\xe9j\xe0 en cours d\'examen. Veuillez retirer votre soumission actuelle pour y apporter des modifications, puis la soumettre \xe0 nouveau.","withdraw":"Retirer la soumission","resubmitConfirm":"Soumettre \xe0 nouveau pour examen","resubmitNote":"Cette publication n\'a pas \xe9t\xe9 approuv\xe9e. Veuillez tenir compte des commentaires ci-dessous, puis soumettez-la \xe0 nouveau pour examen.","previousFeedback":"Commentaires des \xe9valuateurs","publicRestricted":"Votre organisation n\'autorise pas la publication sur le march\xe9 public ; ce contenu ne peut donc \xeatre partag\xe9 qu\'en interne \xe0 votre organisation."},"reviewStatus":{"section":"Avis public sur le march\xe9","reasonLabel":"Note du r\xe9viseur","pending":"En revue","published":"Publi\xe9","rejected":"Modifications demand\xe9es","removed":"Supprim\xe9","pendingTitle":"Cephable est en attente d\'\xe9valuation avant sa mise sur le march\xe9.","publishedTitle":"Approuv\xe9 et r\xe9f\xe9renc\xe9 sur le march\xe9 public.","rejectedTitle":"Refus\xe9 pour publication \u2014 consultez la note du r\xe9viseur, puis soumettez \xe0 nouveau.","removedTitle":"Retir\xe9 du march\xe9 public par un mod\xe9rateur.","notify":{"published":"\xab {{name}} \xbb a \xe9t\xe9 approuv\xe9 et est d\xe9sormais disponible sur le march\xe9.","rejected":"Le document \xab\xa0{{name}}\xa0\xbb n\xe9cessite des modifications avant publication. Ouvrez-le pour consulter les commentaires du relecteur.","removed":"\xab\xa0{{name}}\xa0\xbb a \xe9t\xe9 retir\xe9 du march\xe9 public."}},"managedBy":"G\xe9r\xe9 par {{provenance}}","integrationType":{"cephable":"int\xe9gration officielle","mine":"int\xe9gration personnelle","organization":"int\xe9gration organisationnelle","thirdParty":"int\xe9gration tierce"},"automateHttpServer":{"title":"Automatisation du serveur HTTP","description":"Connectez les services locaux \xe0 l\'assistant Automate int\xe9gr\xe9 de Cephable via HTTP.","detail":"Le serveur HTTP Automate permet aux services locaux, aux outils de d\xe9veloppement et aux environnements d\'\xe9valuation d\'utiliser l\'assistant de d\xe9ploiement de Cephable. Il n\'accepte les connexions que depuis cet appareil, exige la cl\xe9 g\xe9n\xe9r\xe9e pour chaque requ\xeate et limite les op\xe9rations sur les fichiers \xe0 un espace de travail Automate isol\xe9.","proRequired":"Le serveur HTTP automatis\xe9 est disponible avec Cephable Professional.","running":"En cours d\'ex\xe9cution","stopped":"Arr\xeat\xe9","port":"Port","endpoint":"Point de terminaison","api":{"title":"Comment se connecter","description":"Utilisez le serveur \xe0 partir d\'un script local, d\'une application de bureau ou d\'un outil d\'automatisation ex\xe9cut\xe9 sur cet ordinateur.","routes":{"chat":"Chat","run":"Ex\xe9cuter automatiquement","health":"Sant\xe9","models":"Mod\xe8les","modelMode":"Mode mod\xe8le (votre propre boucle d\'agent)","tools":"Outils int\xe9gr\xe9s","speech":"R\xe9sultats vocaux","settings":"Param\xe8tres"},"steps":{"enable":"Activez cette extension depuis sa fiche, laissez Cephable ouvert et v\xe9rifiez que l\'\xe9tat ci-dessus indique \xab\xa0En cours d\'ex\xe9cution\xa0\xbb.","copyKey":"Copiez la cl\xe9 d\'acc\xe8s ci-dessous. Envoyez-la dans l\'en-t\xeate Authorization de chaque requ\xeate sous la forme Bearer <cl\xe9 d\'acc\xe8s>.","sendRequest":"Utilisez le point de terminaison indiqu\xe9 ci-dessus et envoyez une requ\xeate JSON \xe0 /v1/chat/completions. Les clients compatibles OpenAI existants peuvent utiliser \xab\xa0cephable-agent\xa0\xbb comme nom de mod\xe8le pour ex\xe9cuter l\'assistant complet, ou \xab\xa0cephable-model\xa0\xbb pour utiliser Cephable comme mod\xe8le au sein de leur propre agent.","readResponse":"Lisez la r\xe9ponse de l\'assistant dans choices[0].message.content. Si un client ne peut pas se connecter, envoyez une requ\xeate GET /health avec le m\xeame en-t\xeate d\'autorisation."}},"key":"Cl\xe9 d\'acc\xe8s","keyDescription":"Utilisez cette cl\xe9 comme jeton d\'authentification pour les clients locaux. Elle est chiffr\xe9e avec le stockage s\xe9curis\xe9 de votre syst\xe8me d\'exploitation et n\'est jamais synchronis\xe9e avec Cephable.","copyKey":"Copier la cl\xe9 d\'acc\xe8s","copyError":"Impossible de copier la cl\xe9 d\'acc\xe8s au serveur Automate.","regenerateKey":"R\xe9g\xe9n\xe9rer la cl\xe9 d\'acc\xe8s","keyRegenerated":"R\xe9g\xe9n\xe9ration automatique des cl\xe9s d\'acc\xe8s au serveur.","example":{"title":"Exemple de requ\xeate Node.js","description":"Cet exemple inclut d\xe9j\xe0 le point de terminaison et la cl\xe9 d\'acc\xe8s actuelle. Copiez-le dans un script Node.js local de confiance et remplacez l\'invite de commande par votre t\xe2che.","copy":"Exemple de demande de copie","copyError":"Impossible de copier l\'exemple de requ\xeate."},"useCases":{"title":"Id\xe9es d\'utilisation du serveur","description":"Tout appareil capable d\'effectuer une requ\xeate HTTP locale peut solliciter l\'aide de l\'assistant Automate int\xe9gr\xe9 \xe0 Cephable.","localAutomation":"Connectez des scripts locaux, des outils de raccourci, des utilitaires de bureau ou des plateformes d\'automatisation \xe0 un flux de travail Automate.","privateText":"R\xe9\xe9crire, r\xe9sumer, classer ou traduire du texte \xe0 l\'int\xe9rieur d\'un outil interne tout en conservant les inf\xe9rences sur cet appareil.","accessibleInputs":"Laissez des commutateurs personnalis\xe9s, des capteurs ou des logiciels associ\xe9s transformer une entr\xe9e accessible en une t\xe2che Automate plus riche.","testing":"Ex\xe9cutez des suites de tests de r\xe9gression d\'invites et de flux de travail sur le m\xeame assistant, les m\xeames comp\xe9tences, les m\xeames outils et le m\xeame mod\xe8le local que ceux utilis\xe9s par l\'application Cephable."},"security":{"title":"Conservez l\'acc\xe8s local et s\xe9curis\xe9","description":"Le serveur n\'\xe9coute que sur l\'adresse 127.0.0.1\xa0; les services distants et cloud ne peuvent donc pas s\'y connecter directement. Traitez la cl\xe9 d\'acc\xe8s comme un mot de passe et ne la partagez qu\'avec les logiciels de confiance. Sa r\xe9g\xe9n\xe9ration d\xe9connecte imm\xe9diatement les clients utilisant la cl\xe9 pr\xe9c\xe9dente."},"secureStorageUnavailable":"Ce serveur ne peut pas \xeatre activ\xe9 car le stockage s\xe9curis\xe9 du syst\xe8me d\'exploitation est indisponible.","error":"Impossible de mettre \xe0 jour le serveur HTTP automatis\xe9.","portMoved":"Le port {{preferredPort}} \xe9tant d\xe9j\xe0 utilis\xe9 sur cet appareil, le serveur a d\xe9marr\xe9 sur le port {{port}}. Veuillez utiliser le point de terminaison indiqu\xe9 ci-dessus dans vos outils, et non celui par d\xe9faut.","portMovedTitle":"Port diff\xe9rent utilis\xe9"},"workflowRecording":{"title":"Enregistrer un flux de travail","description":"Montrez une fois \xe0 Cephable comment effectuer une t\xe2che, et l\'application transforme cet enregistrement en une comp\xe9tence qu\'elle peut ex\xe9cuter pour vous.","previewBadge":"Aper\xe7u","detail":"L\'outil d\'enregistrement de flux de travail observe vos actions pendant que vous effectuez une t\xe2che\xa0: les applications que vous utilisez, les boutons et champs sur lesquels vous cliquez, ce que vous tapez et vos commentaires vocaux. Une fois la t\xe2che termin\xe9e, Cephable transforme l\'enregistrement en une comp\xe9tence d\'IA que vous pouvez consulter, modifier et sauvegarder. La prochaine fois que vous demanderez \xe0 Automate d\'effectuer ce type de t\xe2che, il utilisera cette comp\xe9tence comme guide, empruntant le chemin le plus direct au lieu de r\xe9p\xe9ter chaque clic.","howItWorks":{"title":"Comment \xe7a marche","record":"Lancez un enregistrement depuis l\'espace de travail, l\'onglet Automatisation ou les comp\xe9tences d\'IA, puis effectuez la t\xe2che du d\xe9but \xe0 la fin.","narrate":"Expliquez en d\xe9tail ce que vous faites et pourquoi. Votre r\xe9cit justifie chaque \xe9tape.","review":"Arr\xeatez l\'enregistrement pour obtenir un brouillon de la comp\xe9tence. Relisez les \xe9tapes et la description avant de l\'enregistrer.","run":"Demandez \xe0 Automate de r\xe9p\xe9ter la t\xe2che. Il consulte l\'enregistrement et l\'adapte \xe0 votre demande."},"captured":{"title":"Ce qui est enregistr\xe9","description":"Vos clics, frappes au clavier, changements d\'application, noms et identifiants des commandes utilis\xe9es, ainsi que votre narration si un microphone est disponible\xa0: tout est trait\xe9 sur cet appareil. Les actions qui ne font que vous propulser quelque part, comme ouvrir un nouvel onglet de navigateur et saisir une adresse, sont regroup\xe9es en une seule \xe9tape. \xc9vitez de saisir des mots de passe ou des informations de paiement pendant l\'enregistrement."},"whereToFind":{"title":"O\xf9 le trouver","workspace":"Espace de travail\xa0: la bande \xab\xa0Enregistrer un flux de travail\xa0\xbb sous les suggestions \xab\xa0Cr\xe9er et automatiser\xa0\xbb.","automate":"Onglet Automatisation dans le panneau Cephable\xa0: suggestion \xab\xa0Enseigner un flux de travail \xe0 Cephable\xa0\xbb et menu du compositeur.","skills":"Extensions \u2192 Comp\xe9tences IA : Cr\xe9er une comp\xe9tence \u2192 Enregistrer ce que je fais."},"previewNotice":"Il s\'agit d\'une fonctionnalit\xe9 en avant-premi\xe8re. Elle est susceptible d\'\xe9voluer avant sa sortie officielle, et vos commentaires nous aident \xe0 la perfectionner.","proRequired":"L\'enregistrement d\'un flux de travail est disponible avec Cephable Professional.","startAction":"Enregistrer un flux de travail"}},"sensitivityValues":{"verySensitive":"Tr\xe8s sensible","high":"Haut","medium":"Moyen","low":"Faible","notSensitive":"Non sensible"},"summarize":"R\xe9sumer","appControlsPanel":{"searchPlaceholder":"Commandes de recherche...","searchLabel":"Commandes de recherche","favorites":{"title":"Favoris","description":"Les favoris sont des commandes que vous utilisez fr\xe9quemment. Vous pouvez marquer une commande comme favorite en cliquant sur l\'ic\xf4ne en forme d\'\xe9toile situ\xe9e \xe0 c\xf4t\xe9."},"noCommandsFound":"Aucune commande trouv\xe9e","globalCommands":"Mondial","prefixCommandToast":"Il s\'agit d\'une commande par pr\xe9fixe\xa0: prononcez ou saisissez le pr\xe9fixe suivi de la phrase pour la d\xe9clencher."},"collapse":"Effondrement","intelligentTasks":{"loading":{"loadingModels":"Chargement des mod\xe8les d\'IA...","extractingModels":"Extraction de mod\xe8les d\'IA..."}},"sidebar":{"collapse":"R\xe9duire la barre lat\xe9rale","expand":"D\xe9velopper la barre lat\xe9rale"},"workspace":{"title":"Espace de travail","badge":"Sur l\'appareil \xb7 priv\xe9","subtitle":"Votre assistant IA fonctionne enti\xe8rement sur cet appareil. Lancez des commandes, cr\xe9ez, automatisez ou discutez simplement.","control":{"title":"Contr\xf4le","description":"Commandes vocales, raccourcis clavier et boutons d\'action rapide\xa0: fonctionnent dans toutes les applications de votre appareil.","voice":{"title":"commandes vocales","description":"Commandes mains libres"},"dictation":{"title":"Dict\xe9e","description":"Parlez au type"},"computerUse":{"title":"Utilisation de l\'ordinateur","description":"Laissez l\'assistant agir"},"camera":{"title":"Commandes de la cam\xe9ra","description":"Gestes du visage et de la t\xeate"},"quickActions":{"title":"Actions rapides","description":"Raccourcis en un clic"}},"create":{"title":"Cr\xe9er","description":"R\xe9digez, r\xe9\xe9crivez, reformatez et traduisez \u2014 directement dans l\'application que vous utilisez, en utilisant du texte copi\xe9 et surlign\xe9.","items":{"draftEmail":"R\xe9digez un courriel","writeDocument":"R\xe9digez un document","summarizeNotes":"R\xe9sumer en notes","polishWriting":"Corrigez mon \xe9criture","translateText":"Traduire le texte","socialPost":"R\xe9digez une publication pour les r\xe9seaux sociaux","cd_brief":"R\xe9diger un brief cr\xe9atif","cd_caption":"R\xe9digez une l\xe9gende et un texte alternatif","ar_insights":"Synth\xe9tiser les r\xe9sultats pour en tirer des enseignements","ar_exec":"R\xe9diger un r\xe9sum\xe9","cc_followup":"R\xe9digez un courriel de suivi","cc_meetingNotes":"Transformer les notes en compte-rendu de r\xe9union","bd_commit":"R\xe9digez un message de commit","bd_review":"R\xe9sumer une revue de code","gp_bio":"R\xe9digez une biographie de streamer","gp_recap":"R\xe9sum\xe9 de la session d\'hier soir","lt_lesson":"\xc9laborer un plan de le\xe7on","lt_studyNotes":"R\xe9sumer sous forme de notes de cours","mo_agenda":"\xc9laborer un ordre du jour de la r\xe9union","mo_update":"R\xe9diger une mise \xe0 jour du projet","aa_simplify":"Simplifiez en langage clair","aa_describe":"D\xe9crivez une image en mots"},"contextRow":{"highlightedText":"Surligner / texte du presse-papiers","output":"Saisie en cours\xa0:","input":"Utilisations :","background":"Arri\xe8re-plan","currentapp":"Application actuelle"},"prompts":{"draftEmail":"R\xe9digez un courriel clair et professionnel \xe0 ce sujet.","writeDocument":"R\xe9digez un document \xe0 ce sujet.","summarizeNotes":"R\xe9sumez cela en notes concises et bien organis\xe9es sous forme de points cl\xe9s.","polishWriting":"R\xe9\xe9crivez ceci pour que ce soit plus clair et plus soign\xe9, tout en conservant le sens et le ton.","socialPost":"R\xe9digez un court message attrayant pour les r\xe9seaux sociaux \xe0 ce sujet.","cd_brief":"R\xe9digez un brief cr\xe9atif pour ce projet.","ar_insights":"R\xe9sumez les principaux r\xe9sultats et enseignements tir\xe9s de ces donn\xe9es.","ar_exec":"R\xe9digez un r\xe9sum\xe9 concis pour ce sujet.","cc_followup":"R\xe9digez un courriel de suivi \xe0 ce sujet.","cc_meetingNotes":"Transformez ces notes en comptes rendus de r\xe9union clairs, comportant des points d\'action.","bd_commit":"R\xe9digez un message de commit clair pour ces modifications\xa0:","bd_review":"R\xe9sumez cette revue de code en points cl\xe9s et modifications requises.","gp_bio":"R\xe9digez une bio percutante pour mon stream/profil.","lt_lesson":"\xc9laborez un plan de le\xe7on sur ce sujet.","lt_studyNotes":"R\xe9sumez ces informations sous forme de notes d\'\xe9tude que je puisse consulter.","mo_agenda":"\xc9laborez un ordre du jour de r\xe9union couvrant ce sujet.","mo_update":"R\xe9digez une mise \xe0 jour de l\'\xe9tat d\'avancement du projet \xe0 l\'intention des parties prenantes en vous basant sur ces informations.","aa_simplify":"R\xe9\xe9crivez ceci dans un langage clair et facile \xe0 lire."}},"automate":{"title":"Automatiser","description":"D\xe9crivez une t\xe2che en langage clair et Cephable l\'ex\xe9cutera sur vos applications, vos fichiers, voire m\xeame votre ligne de commande.","items":{"triage":"Triez ma bo\xeete de r\xe9ception","cd_exportAssets":"Renommer et archiver les ressources","cd_moodboard":"Collectez des r\xe9f\xe9rences","cc_triage":"Tri et \xe9bauche des r\xe9ponses","cc_recap":"R\xe9capitulatif et envoi \xe0 l\'\xe9quipe","bd_scaffold":"\xc9chafauder un projet","gp_schedule":"Planifiez un horaire de diffusion","lt_handout":"Pr\xe9parer un document de travail","summarizeSend":"R\xe9sumer et envoyer par courriel","researchDoc":"Rechercher et r\xe9diger un document","organizeFiles":"Organiser mes fichiers","cleanUp":"Nettoyer un dossier","wordDoc":"Cr\xe9er un document Word","ar_summarizeSend":"R\xe9sumer et envoyer par courriel","ar_analyzeData":"Analyser une feuille de calcul","ar_deck":"Construisez un deck \xe0 partir de donn\xe9es","cc_summarizeEmail":"R\xe9sumez dans un e-mail","cc_socialPost":"Publier \xe0 partir d\'un lien","bd_buildTest":"Cr\xe9er et tester un projet","bd_cleanup":"Suggestions de nettoyage du code","lt_studyMaterial":"Cr\xe9er du mat\xe9riel d\'\xe9tude","lt_accommodation":"Prenez des notes accessibles","lt_research":"Rechercher et comparer","mo_meetingActions":"Transformer les notes en actions","mo_organizeFiles":"Organiser mes fichiers","mo_cleanup":"Nettoyer les t\xe9l\xe9chargements","aa_translate":"Traduire un document"},"prompts":{"summarizeSend":"R\xe9sumez le contenu du dossier <folder> et envoyez-le par courriel \xe0 <team email>.","researchDoc":"Analysez les tendances dans <dossier ou document> et r\xe9digez un compte rendu de vos d\xe9couvertes dans un nouveau document.","organizeFiles":"Copiez les fichiers depuis<source folder> dans<destination folder> .","cleanUp":"Supprimez tous les fichiers de type <type de fichier, par exemple des captures d\'\xe9cran> de mon <dossier>.","wordDoc":"Utiliser<article or notes> cr\xe9er un document Microsoft Word qui<does what> .","triage":"Veuillez consulter ma bo\xeete de r\xe9ception et me dire ce qui requiert mon attention, puis r\xe9diger des r\xe9ponses lorsque cela est n\xe9cessaire.","cd_exportAssets":"Renommez les ressources de conception dans <dossier> en utilisant ce sch\xe9ma \u2014 <sch\xe9ma de nommage> \u2014 et triez-les dans des dossiers.","cd_moodboard":"Trouvez des r\xe9f\xe9rences pour <id\xe9e> en ligne et rassemblez-les dans un document.","ar_summarizeSend":"R\xe9sumez le contenu du dossier <folder> et envoyez-le par courriel \xe0 <team email>.","ar_analyzeData":"Analysez la feuille de calcul et trouvez ce qu\'il faut rechercher, par exemple les pertes importantes.","ar_deck":"Transformez les r\xe9sultats contenus dans <document ou dossier> en une pr\xe9sentation PowerPoint mettant en \xe9vidence <points cl\xe9s>.","cc_triage":"Je consulte ma bo\xeete de r\xe9ception et je r\xe9dige des r\xe9ponses \xe0 tous les messages qui en n\xe9cessitent une.","cc_summarizeEmail":"R\xe9digez un courriel r\xe9capitulatif<article or document> et souligner les principaux d\xe9tails techniques.","cc_recap":"R\xe9digez un compte rendu de la r\xe9union et envoyez-le par courriel \xe0 l\'adresse \xe9lectronique de l\'\xe9quipe.","cc_socialPost":"Lire<article or website> et \xe9crire un<platform, e.g. Discord> -Publiez un message convivial \xe0 ce sujet, puis enregistrez-le dans une nouvelle note.","bd_buildTest":"Veuillez examiner le code dans le dossier du projet, le compiler et ex\xe9cuter les tests. En cas d\'erreur, consultez l\'historique Git et indiquez-moi la cause probable du probl\xe8me.","bd_cleanup":"Examinez le code dans <dossier du projet> et dites-moi comment le rendre plus propre.","bd_scaffold":"Cr\xe9ez un nouveau projet <type de projet> dans <dossier> avec les fichiers de d\xe9marrage n\xe9cessaires.","gp_schedule":"Planifiez un calendrier de diffusion en continu pour<time period> rev\xeatement<games or activities> .","lt_studyMaterial":"Utiliser<article or notes> cr\xe9er un document Word pour<grade level> \xe9tudiants avec<reflection questions or a study guide> .","lt_accommodation":"Cr\xe9ez un document Word de notes de cours sur <sujet> format\xe9 pour un \xe9tudiant b\xe9n\xe9ficiant d\'un <am\xe9nagement>.","lt_handout":"Compilez les lectures du dossier <folder> en un seul document \xe0 distribuer.","lt_research":"Trouvez en ligne des ouvrages sur le sujet <par exemple, des livres sur la neurodiversit\xe9> et cr\xe9ez un document r\xe9sumant chaque ouvrage afin que je puisse les comparer.","mo_meetingActions":"Lisez le compte rendu de la r\xe9union\xa0: que reste-t-il \xe0 faire, qui est responsable et quels \xe9l\xe9ments n\xe9cessitent des recherches suppl\xe9mentaires\xa0? R\xe9partissez-le dans des fichiers organis\xe9s dans un dossier.","mo_organizeFiles":"Copiez les fichiers depuis<source folder> dans<destination folder> .","mo_cleanup":"Supprimez tous les fichiers de type <ex. installateurs> de mon dossier T\xe9l\xe9chargements.","aa_translate":"Traduisez <document> en <langue> et enregistrez-le dans <dossier>."}},"history":{"title":"Histoire r\xe9cente de l\'IA","description":"Vos derni\xe8res t\xe2ches intelligentes et automatisations.","viewAll":"Afficher tout l\'historique","empty":"Vos t\xe2ches d\'IA et automatisations r\xe9centes appara\xeetront ici."},"badgeRemote":"Appareil distant \xb7 s\xe9curis\xe9","browser":{"openButton":"Ouvrir le navigateur","windowTitle":"Navigateur Cephable","newTab":"Nouvel onglet","reload":"Recharger","forward":"Avant","openExternal":"Ouvrir dans le navigateur par d\xe9faut","showWindow":"Afficher le navigateur cach\xe9","addressPlaceholder":"Recherchez sur Google ou saisissez une URL.","clearData":{"description":"Effacer l\'historique, les cookies, les donn\xe9es en cache et les identifiants enregistr\xe9s du navigateur Cephable. Vous serez ainsi d\xe9connect\xe9 de tous les sites web dans le navigateur Cephable.","button":"Effacer les donn\xe9es du navigateur","cleared":"Donn\xe9es de navigation effac\xe9es.","error":"Impossible d\'effacer les donn\xe9es du navigateur.","confirmTitle":"Effacer les donn\xe9es de navigation\xa0?","confirmMessage":"Se d\xe9connecter de tout dans le navigateur Cephable\xa0?","confirmDetail":"Cette action efface d\xe9finitivement l\'historique, les cookies, les donn\xe9es en cache et les identifiants enregistr\xe9s pour le navigateur Cephable. Cette action est irr\xe9versible.","confirm":"Donn\xe9es claires","cancel":"Annuler"},"context":{"newTab":"Nouvel onglet","reload":"Recharger","duplicate":"Onglet dupliqu\xe9","close":"Fermer l\'onglet","closeOthers":"Fermez les autres onglets","closeRight":"Fermez les onglets \xe0 droite","back":"Dos","forward":"Avant","openLinkNewTab":"Ouvrir le lien dans un nouvel onglet","openLinkExternal":"Ouvrir le lien dans le navigateur par d\xe9faut","openExternal":"Ouvrir dans le navigateur par d\xe9faut","openAllExternal":"Ouvrir tous les onglets dans le navigateur par d\xe9faut"},"home":{"tabTitle":"Maison","title":"Le navigateur Cephable","tagline":"Cephable peut piloter un navigateur distinct pour vous.","description":"C\'est ici que Cephable automatise les t\xe2ches web pour vous. Fonctionnant ind\xe9pendamment de votre navigateur habituel, il permet de garder vos onglets, connexions et navigations ouverts intacts pendant l\'ex\xe9cution des automatisations, m\xeame en arri\xe8re-plan.","searchPlaceholder":"Effectuez une recherche sur Google ou saisissez une URL pour commencer.","go":"Aller","features":{"separate":{"title":"Fonctionne de mani\xe8re autonome","description":"Conserv\xe9 s\xe9par\xe9ment de votre navigateur par d\xe9faut afin que les automatisations ne perturbent jamais votre navigation personnelle."},"automate":{"title":"Con\xe7u pour l\'automatisation","description":"Cephable permet d\'ouvrir des pages, de remplir des formulaires et de recueillir des informations ici, sans utiliser les mains."},"handoff":{"title":"Passez le relais \xe0 tout moment","description":"Ouvrez n\'importe quelle page dans votre navigateur par d\xe9faut lorsque vous souhaitez prendre le contr\xf4le."}}}},"scheduledTasks":{"title":"T\xe2ches planifi\xe9es","description":"Automatisations programm\xe9es pour s\'ex\xe9cuter \xe0 l\'heure de votre choix \u2014 sur cet appareil.","viewAll":"Voir tous les horaires","empty":"Programmez une invite depuis le panneau et elle appara\xeetra ici."},"subtitleRemote":"Tout ce sur quoi vous cliqueriez ou que vous taperiez, \xe0 votre disposition.","suggestions":{"viewMore":"Voir plus","viewMoreTooltip":"Parcourez chaque invite sugg\xe9r\xe9e","dialogTitle":"Toutes les suggestions","dialogDescription":"Choisissez un point de d\xe9part. Il est plac\xe9 dans le compositeur afin que vous puissiez le modifier avant l\'ex\xe9cution.","rotationLabel":"Suggestions de suggestions","empty":"Aucune suggestion disponible."}},"noResults":"Aucun r\xe9sultat","noResultsSearch":"Aucun r\xe9sultat trouv\xe9 pour votre recherche.","interrupted":"Interrompu","aiHistory":{"title":"Histoire de l\'IA","description":"Consultez, recherchez et g\xe9rez votre historique de conversations avec l\'IA locale.","empty":{"title":"Pas encore d\'histoire de l\'IA","description":"L\'historique de vos conversations avec l\'IA appara\xeetra ici apr\xe8s l\'utilisation de t\xe2ches intelligentes."},"search":{"placeholder":"Rechercher des conversations..."},"pagination":{"range":"Affichage de {{start}}\u2013{{end}} sur {{total}}"},"source":{"create":"Cr\xe9er","automate":"Automatiser"},"workflow":{"plan":"Plan","steps":"Mesures","files":"Fichiers","folders":"Dossiers","interruptedNotice":"Votre flux de travail a \xe9t\xe9 interrompu. Veuillez r\xe9essayer."},"trace":{"thinking":"Pens\xe9e","toolCalls":"Appels d\'outils","roles":{"tool":"R\xe9sultat de l\'outil"},"thought":"Pens\xe9e","action":"Action","parameters":"Param\xe8tres","result":"R\xe9sultat","reply":"Vous avez r\xe9pondu","sources":"Sources"},"task":{"instructions":"Instructions","language":"Langue","types":{"generate":"G\xe9n\xe9rer","rewrite":"R\xe9crire","translate":"Traduire","summarize":"R\xe9sumer"}},"session":{"messages":"messages","deleteTitle":"Supprimer la conversation","deleteDescription":"\xcates-vous s\xfbr de vouloir supprimer cette conversation\xa0? Cette action est irr\xe9versible.","deleteConfirm":"Supprimer","deleteCancel":"Annuler"},"clear":{"title":"Effacer l\'historique de l\'IA","description":"Supprimer tout l\'historique des conversations IA stock\xe9es localement sur cet appareil.","confirm":{"title":"Effacer l\'historique de l\'IA","description":"\xcates-vous s\xfbr de vouloir effacer tout l\'historique des conversations avec l\'IA\xa0? Cette action est irr\xe9versible.","confirm":"Effacer tout","cancel":"Annuler"},"success":"Historique de l\'IA effac\xe9 avec succ\xe8s.","error":"Impossible d\'effacer l\'historique de l\'IA."},"export":{"title":"Exporter","description":"Exportez l\'historique de vos conversations IA vers un fichier JSONL.","success":"Historique de l\'IA export\xe9 avec succ\xe8s.","error":"\xc9chec de l\'exportation de l\'historique de l\'IA.","session":{"title":"Ex\xe9cution d\'exportation","success":"Ex\xe9cution export\xe9e r\xe9ussie.","error":"\xc9chec de l\'exportation de cette ex\xe9cution."}},"retention":{"note":"Vos {{count}} conversations les plus r\xe9centes sont conserv\xe9es. Vos favoris sont toujours sauvegard\xe9s.","label":"Garder"},"filter":{"label":"Filtrer par type","all":"Tous types"},"favorites":{"title":"Favoris","add":"Ajouter aux favoris","remove":"Retirer des favoris"},"select":{"selectOne":"S\xe9lectionner la conversation","selected":"{{count}} s\xe9lectionn\xe9","deleteSelected":"Supprimer la s\xe9lection","clear":"Clair","deleteTitle":"Supprimer les conversations s\xe9lectionn\xe9es","deleteDescription":"Supprimer {{count}} conversation(s) s\xe9lectionn\xe9e(s)\xa0? Cette action est irr\xe9versible."},"copy":{"label":"Copie","success":"Copi\xe9 dans le presse-papiers.","error":"Impossible de copier dans le presse-papiers."},"live":"En direct","keychain":{"continue":"Continuer","title":"Prot\xe9ger l\'histoire de l\'IA","message":"Cephable chiffre votre historique d\'IA, y compris l\'historique des flux de travail, sur ce Mac.","detail":"macOS vous demandera ensuite l\'autorisation d\'acc\xe9der \xe0 \xab\xa0Cephable Safe Storage\xa0\xbb. Ce dernier contient uniquement la cl\xe9 de chiffrement, et non votre flux de travail ni le contenu de vos t\xe2ches. Choisissez \xab\xa0Toujours autoriser\xa0\xbb pour que votre historique chiffr\xe9 reste accessible sans que cette demande ne soit r\xe9p\xe9t\xe9e. En choisissant \xab\xa0Autoriser\xa0\xbb, Cephable y acc\xe8de cette fois-ci, mais macOS pourrait vous redemander l\'autorisation lors d\'un prochain lancement."},"rename":{"title":"Rebaptiser","label":"Titre de la conversation"}},"uses":"Utilisations : {{valeur}}","skills":{"intro":"Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.","create":"Create skill","importFolder":"Import folder","importZip":"Import .zip","importError":"Could not import the skill.","enable":"Enable","openFolder":"Open folder","deleteConfirm":"Delete?","emptyTitle":"No skills yet","emptyBody":"Create your first skill or import one to get started.","sharingComingSoon":"Sharing skills with your organization and a skills marketplace are coming soon.","source":{"user":"Created by you","imported":"Imported","organization":"Organization","marketplace":"Marketplace"},"bestPractices":{"title":"Tips for great skills","description":"Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.","focused":"Keep instructions short and focused on one job. Use numbered steps in the order they should happen.","examples":"Add a short example of a request the skill handles and the ideal result.","keywords":"Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.","trust":"Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer.","activation":"Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. release-notes","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What the skill does and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use the skill. Be specific.","keywordsLabel":"Keywords (optional)","keywordsPlaceholder":"comma, separated, words","keywordsHelp":"Extra words that should trigger this skill (brand names, aliases, file types).","instructionsLabel":"Instructions (SKILL.md)","instructionsPlaceholder":"Step-by-step instructions for the assistant. Leave blank to start from a template.","save":"Save changes","create":"Create skill","saveError":"Could not save the skill.","activationLabel":"When should the assistant use this?"},"picker":{"title":"Skills","empty":"No matching skills","hint":"Type to filter skills"},"contextMenuItem":"Skill\u2026","chipRemove":"Remove skill","attached":"Attached skills","inUse":"Using skills:","section":{"title":"AI Skills","description":"Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."},"createDescription":"Build a reusable skill from scratch or a template.","import":"Import a skill","importDescription":"Add a skill from a folder or a .zip file.","copy":"Copy an existing skill","copyDescription":"Start from a copy of one of your skills.","copyShort":"Copy","editTitle":"Edit skill","newTitle":"New skill","templates":{"title":"Start from a template","blank":{"title":"Blank","summary":"Start from an empty template."},"navigateApp":{"title":"Navigate an app (click in steps)","summary":"Tell Cephable where to click, step by step, to get through an app."},"writeText":{"title":"Write or insert text","summary":"Draft text a certain way and type it where I am working."},"fillForm":{"title":"Fill out a form","summary":"Fill a form field by field from details I give you."},"summarizeDoc":{"title":"Summarize a document","summary":"Read a file and give a short, structured summary."},"start":"Commencez par un mod\xe8le\u2026","applied":"Mod\xe8le appliqu\xe9 \u2014 modifiez les d\xe9tails ci-dessous."},"activation":{"label":"Activation","auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant picks this skill on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never picks this on its own \u2014 it runs only when you attach it with / or @."},"mode":{"label":"How this skill is used","off":"Off","offTooltip":"Off \u2014 this skill is never used or shown in the picker."},"viewDetails":"View details","files":{"label":"Reference files & scripts","help":"Add files your skill uses \u2014 the assistant reads references and can run scripts. Mention them in your instructions above.","empty":"No files added yet.","add":"Add file\u2026","remove":"Remove file","addError":"Could not add the file.","kind":{"reference":"Reference file","script":"Script","asset":"Asset","referenceShort":"Reference","scriptShort":"Script","assetShort":"Asset"},"open":"Open file"},"scriptsSetting":{"label":"Let skills run scripts","help":"When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."},"capability":{"script":{"label":"Runs scripts","tooltip":"This skill can run programs on your computer \u2014 you approve each one before it runs. Only use skills you trust."},"reference":{"label":"Uses reference files","tooltip":"This skill includes reference files the assistant can read for detail. It does not run programs on your computer."},"basic":{"label":"Instructions only","tooltip":"This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."},"alsoReferences":"It also includes reference files it reads.","scriptsOff":"Script running is currently turned off in settings."},"teach":{"action":"Enseigner comme une comp\xe9tence","generating":"Enseignement\u2026","title":"Enseigner une comp\xe9tence","heading":"Apprenez une nouvelle comp\xe9tence \xe0 Cephable","subheading":"Cephable a transform\xe9 votre action en une comp\xe9tence r\xe9utilisable. V\xe9rifiez et modifiez-la ci-dessous, puis enregistrez-la pour que l\'assistant puisse la reproduire pour vous et pour toutes les personnes avec qui vous la partagez.","fromRun":"Bas\xe9 sur : {{title}}","filesTitle":"Fichiers \xe0 inclure","filesHelp":"Ce sont des fichiers de votre partie qui pourraient permettre de reproduire la comp\xe9tence. Conservez ceux qui doivent \xeatre conserv\xe9s avec la comp\xe9tence\xa0; d\xe9sactivez ceux qui ne concernent que cette partie.","detailsTitle":"D\xe9tails des comp\xe9tences","addFile":"Ajouter un autre fichier\u2026","include":{"add":"Inclure","on":"Inclus \u2014 cliquez pour supprimer","off":"Exclus \u2014 cliquez pour inclure"},"included":"Compris","origin":{"attached":"Vous avez fourni","template":"Mod\xe8le","generated":"Run a produit","observed":"Rassembl\xe9","added":"Ajout\xe9 par vous"},"saved":"Comp\xe9tence enregistr\xe9e. Vous pouvez l\'activer et la partager ci-dessous.","error":"Impossible de cr\xe9er une comp\xe9tence \xe0 partir de cette partie.","filesError":"Certains fichiers de r\xe9f\xe9rence n\'ont pas pu \xeatre ajout\xe9s\xa0: {{files}}","notFound":"Ce brouillon n\'est plus disponible.","backToSkills":"Retour aux comp\xe9tences"},"actions":"Actions de comp\xe9tence","body":{"empty":"Aucune instruction ajout\xe9e pour le moment.","label":"Instructions (SKILL.md)"},"importTooltip":"Importer une comp\xe9tence \xe0 partir d\'un dossier ou d\'un fichier .zip","install":"Installer","keywords":{"label":"Mots cl\xe9s"},"marketplace":{"description":"Comp\xe9tences publiques partag\xe9es par la communaut\xe9 et correspondant \xe0 votre recherche.","title":"Du march\xe9 public"},"share":"Partager","shareError":"Quelque chose a mal fonctionn\xe9.","sync":"Synchronisation","updateAvailable":"Une version plus r\xe9cente est disponible.","searchPlaceholder":"Comp\xe9tences de recherche\u2026","createTooltip":"Enregistrez-vous en train d\'effectuer une t\xe2che, ou d\xe9crivez vous-m\xeame la comp\xe9tence.","createRecord":"Enregistrer ce que je fais","createScratch":"Partir de z\xe9ro"},"on":"Sur","off":"D\xe9sactiv\xe9","copied":"Copi\xe9","mcp":{"section":{"title":"Outils","description":"Connectez les serveurs MCP pour doter l\'assistant Cephable de fonctionnalit\xe9s suppl\xe9mentaires. Utilisez-les dans le panneau en tapant / ou @."},"addServer":"Ajouter un serveur","addServerDescription":"Connectez un serveur MCP (commande, HTTP ou SSE) pour ajouter ses outils.","editTitle":"Modifier le serveur","newTitle":"Ajouter un serveur","deleteConfirm":"Supprimer?","contextMenuItem":"Outils\u2026","chipRemove":"Retirer les outils","inUse":"Utilisation des outils\xa0:","picker":{"title":"Comp\xe9tences et outils"},"mode":{"label":"Comment ce serveur est utilis\xe9","off":"D\xe9sactiv\xe9","offTooltip":"D\xe9sactiv\xe9 \u2014 ce serveur n\'est jamais utilis\xe9 ni affich\xe9 dans le s\xe9lecteur."},"activation":{"auto":"Automatiquement quand cela convient","autoShort":"Auto","autoDescription":"L\'assistant charge automatiquement les outils de ce serveur lorsque votre requ\xeate correspond \u2014 et vous pouvez toujours le choisir avec / ou @.","manual":"Seulement quand je le choisis","manualShort":"Manuel","manualDescription":"L\'assistant ne le charge jamais de lui-m\xeame \u2014 seulement lorsque vous le joignez avec / ou @."},"transport":{"stdio":"Commande (stdio)","http":"HTTP","sse":"SSE"},"auth":{"none":"Aucun","apiKey":"Cl\xe9 API","headers":"En-t\xeates personnalis\xe9s","oauth":"OAuth"},"requireApproval":{"short":"Approuver les appels","tooltip":"Lorsque cette fonction est activ\xe9e, vous devez approuver chaque appel d\'outil provenant de ce serveur avant son ex\xe9cution."},"oauth":{"connect":"Connecter","reconnect":"Reconnect","disconnect":"D\xe9connecter","connecting":"En attente du navigateur\u2026","connected":"Connect\xe9","notConnected":"Non connect\xe9","error":"L\'autorisation a \xe9chou\xe9."},"status":{"ok":"Connect\xe9","error":"\xc9chou\xe9","unknown":"Non test\xe9","testing":"De liaison\u2026","toolsFound":"{{count}} outils trouv\xe9s","label":"Connexion","toolsEnabledOf":"{{activ\xe9}} des outils {{count}}"},"editor":{"nameLabel":"Nom","namePlaceholder":"par exemple, un syst\xe8me de fichiers","nameHelp":"Lettres minuscules, chiffres et traits d\'union uniquement.","descriptionLabel":"Description","descriptionPlaceholder":"Ce que ce serveur propose et quand l\'assistant doit l\'utiliser.","descriptionHelp":"Voici comment l\'assistant d\xe9cide quand l\'utiliser. Soyez pr\xe9cis.","transportLabel":"Type de connexion","commandLabel":"Commande","argsLabel":"Arguments","argsHelp":"Arguments s\xe9par\xe9s par des espaces et transmis \xe0 la commande.","envLabel":"Variables environnementales","envHelp":"Une paire cl\xe9-valeur par ligne.","urlLabel":"URL du serveur","authLabel":"Authentification","apiKeyHeaderLabel":"Nom de l\'en-t\xeate","apiKeyPrefixLabel":"Pr\xe9fixe de valeur","apiKeyLabel":"Cl\xe9 API","secretSet":"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (stock\xe9 \u2014 saisissez le texte \xe0 remplacer)","oauthClientIdLabel":"ID client","oauthClientIdHelp":"Laisser vide pour une inscription automatique si cette fonction est prise en charge.","oauthClientSecretLabel":"Secret client","oauthScopesLabel":"Lunettes de vis\xe9e","oauthScopesHelp":"Port\xe9es s\xe9par\xe9es par des espaces \xe0 demander.","oauthDiscoveryLabel":"URL de d\xe9couverte (facultatif)","oauthAuthUrlLabel":"URL d\'autorisation","oauthTokenUrlLabel":"URL du jeton","redirectLabel":"URI de redirection","redirectHelp":"La plupart des serveurs s\'enregistrent automatiquement\xa0: laissez le champ \xab\xa0ID client\xa0\xbb vide et cliquez sur \xab\xa0Se connecter\xa0\xbb. Si le fournisseur demande une URI de redirection, s\xe9lectionnez le type de rappel qu\'il accepte et enregistrez l\'URI ci-dessous.","headersHelp":"L\'authentification par en-t\xeate personnalis\xe9 n\'est pas encore modifiable ici\xa0; utilisez une cl\xe9 API ou OAuth pour les serveurs authentifi\xe9s.","activationLabel":"Quand l\'assistant doit-il utiliser ceci ?","requireApprovalLabel":"Exiger une approbation pour chaque appel d\'outil","requireApprovalHelp":"Lorsqu\'elle est activ\xe9e, vous devez approuver chaque appel d\'outil provenant de ce serveur avant son ex\xe9cution. Recommand\xe9e pour les serveurs susceptibles de modifier des donn\xe9es ou d\'effectuer des transactions financi\xe8res.","testConnection":"Test de connexion","save":"Enregistrer les modifications","create":"Ajouter un serveur","saveError":"Impossible de sauvegarder le serveur.","oauthDiscoveryHelp":"Facultatif \u2014 laisser vide pour utiliser le document de d\xe9couverte propre au serveur.","oauthDiscoveryLabelShort":"URL de d\xe9couverte","oauthOnDevice":"Chaque membre effectue une connexion OAuth sur son propre appareil lorsqu\'il active ce connecteur.","secretsOnDevice":"Chaque membre saisit sa propre cl\xe9 API sur son appareil lorsqu\'il active ce connecteur\xa0; les cl\xe9s ne sont jamais stock\xe9es ici.","noPermissions":"Ce serveur utilise l\'application enregistr\xe9e de {{provenance}}. Cliquez sur le bouton pour personnaliser ou connectez-vous pour commencer \xe0 l\'utiliser.","altOptions":{"copy":"Utilisez mes propres identifiants","organization":"Portail Cephable"},"copyName":"{{nom}}-copie","redirectTypeLabel":"Type de rappel","redirectType":{"appCallback":"Web (https)","localhost":"h\xf4te local"},"redirectPortLabel":"Port","redirectNotes":{"appCallback":"La connexion ouvre votre navigateur, puis redonne automatiquement le contr\xf4le \xe0 l\'application Cephable.","localhost":"La connexion ouvre votre navigateur et vous redirige vers Cephable via ce port. Ce port reste ouvert uniquement pendant votre connexion et uniquement sur cet appareil."}},"actions":"Actions du serveur","marketplace":{"description":"Connecteurs publics partag\xe9s par la communaut\xe9 et correspondant \xe0 votre recherche.","title":"Du march\xe9 public"},"share":"Partager","shareError":"Quelque chose a mal fonctionn\xe9.","sync":"Synchronisation","tools":{"allToolsLabel":"pour tous les outils","contextLabel":"du contexte","disableAll":"D\xe9sactiver tout","empty":"Aucun outil pour le moment \u2014 testez la connexion pour les d\xe9couvrir.","enableAll":"Tout activer","help":"D\xe9sactivez les outils dont vous n\'avez pas besoin. Moins d\'outils occupent l\'espace de la fen\xeatre contextuelle de l\'assistant, ce qui le rend plus rapide et plus performant.","label":"Outils","searchPlaceholder":"Outils de recherche\u2026","tokens":"~{{tokens}} a pris","tokensLabel":"jetons","disableSelected":"D\xe9sactiver la s\xe9lection","enableSelected":"Activer la s\xe9lection"},"updateAvailable":"Une version mise \xe0 jour est disponible.","searchPlaceholder":"Rechercher des connecteurs\u2026"},"send":"Envoyer","availableToInstall":"Disponible pour installation","menu":{"expand":"D\xe9velopper le menu"},"no":"Non","rating":{"review":{"comment":"Commentaire","commentPlaceholder":"Qu\'avez-vous aim\xe9 ou d\xe9test\xe9\xa0? Comment l\'avez-vous utilis\xe9\xa0?","optional":"(facultatif)","submit":"Soumettre un avis","subtitle":"Partagez votre exp\xe9rience avec <strong>{{subject}}</strong> .","title":"\xc9valuer et commenter","write":"R\xe9diger un avis","yourRating":"Votre note"},"summary":{"comments":"commentaires","installs":"installations","noRatings":"Aucune \xe9valuation pour le moment","openReview":"\xc9valuer et commenter","ratingCount":"{{count}} \xe9valuations"}},"workflow":{"feedback":{"includeDetails":"Partagez mon invite de commande et le nom de l\'outil pour faciliter le diagnostic de cette ex\xe9cution","negative":"Je d\xe9sapprouve","placeholder":"Dites-nous en plus (facultatif)","positive":"Bravo !","question":"Comment s\'est d\xe9roul\xe9 ce processus de travail\xa0?","send":"Envoyer des commentaires","thanks":"Merci pour vos commentaires.","report":"Signaler un probl\xe8me"}},"yes":"Oui","scheduledTasks":{"title":"T\xe2ches planifi\xe9es","description":"Automatisation programm\xe9e pour s\'ex\xe9cuter \xe0 l\'heure de votre choix. Tout reste sur cet appareil.","hint":"Les t\xe2ches planifi\xe9es s\'ex\xe9cutent uniquement lorsque cette application est en cours d\'ex\xe9cution. Si votre ordinateur est \xe9teint ou si l\'application est ferm\xe9e \xe0 l\'heure pr\xe9vue, l\'ex\xe9cution est annul\xe9e et vous pouvez la relancer ult\xe9rieurement.","new":"Nouvelle t\xe2che planifi\xe9e","scheduleButton":"Calendrier","create":{"title":"Nouvelle t\xe2che planifi\xe9e","description":"Configurez une invite pour qu\'elle s\'ex\xe9cute automatiquement selon un calendrier.","saved":"T\xe2che planifi\xe9e cr\xe9\xe9e."},"composer":{"placeholder":"D\xe9crivez ce que Cephable devrait faire\u2026 Utilisez / ou @ pour ajouter des comp\xe9tences et des connecteurs."},"runHistory":{"title":"Historique des courses","viewRun":"Afficher la course","noOutput":"Aucune sortie enregistr\xe9e","resolution":{"ignored":"Ignor\xe9","rerun":"Rediffusion","rescheduled":"report\xe9"}},"badge":{"scheduled":"Programm\xe9","recurring":"R\xe9current"},"fromRun":{"scheduled":"Cette ex\xe9cution fait partie d\'une t\xe2che planifi\xe9e\xa0: {{name}}","recurring":"Cette ex\xe9cution fait partie d\'une t\xe2che r\xe9currente\xa0: {{name}}","view":"Afficher la t\xe2che planifi\xe9e"},"search":{"placeholder":"Rechercher les t\xe2ches planifi\xe9es..."},"filter":{"label":"Filtre","all":"Tous","enabled":"Actif","paused":"En pause","missed":"Manqu\xe9"},"empty":{"title":"Aucune t\xe2che planifi\xe9e pour le moment","description":"Programmez une invite en cliquant avec le bouton droit sur le bouton Envoyer dans le panneau en mode Auto ou Automatisation."},"pagination":{"range":"{{d\xe9but}}\u2013{{fin}} de {{total}}"},"status":{"running":"En cours d\'ex\xe9cution","success":"R\xe9ussi","failed":"\xc9chou\xe9","missed":"Manqu\xe9","paused":"En pause"},"summary":{"once":"Une fois le {{datetime}}","everyOne":"Chaque {{unit\xe9}}","everyN":"Chaque {{count}} {{unit}}","onDays":"les {{jours}}","onDayOfMonth":"le jour {{day}}","atTime":"\xe0 {{time}}","unit":{"minute":"minute","minute_other":"minutes","hour":"heure","hour_other":"heures","day":"jour","day_other":"jours","week":"semaine","week_other":"semaines","month":"mois","month_other":"mois"}},"card":{"nextRun":"Prochaine course","runNow":"Courez maintenant","pause":"Pause","resume":"CV","enabledToggle":"Activer ou suspendre cette t\xe2che","viewLastRun":"Afficher la derni\xe8re ex\xe9cution r\xe9ussie","noSuccessfulRun":"Aucune course r\xe9ussie pour l\'instant"},"missed":{"runNow":"Courez maintenant","reschedule":"reprogrammer","ignore":"Ignorer"},"runNow":{"started":"Ex\xe9cution de \xab{{name}}\xbb en cours.","busy":"Un autre flux de travail est d\xe9j\xe0 en cours. Veuillez r\xe9essayer une fois qu\'il sera termin\xe9."},"delete":{"title":"Supprimer la t\xe2che planifi\xe9e\xa0?","description":"Cette action supprime d\xe9finitivement la t\xe2che planifi\xe9e. Elle est irr\xe9versible."},"editor":{"kindLabel":"Type d\'horaire","once":"Une fois","recurring":"R\xe9current","runAt":"Courir \xe0","frequency":"R\xe9p\xe9titions","every":"Chaque","interval":"Intervalle","onDays":"Les jours","dayOfMonth":"Jour du mois","atTime":"\xc0 l\'\xe9poque","startAt":"D\xe9but","endsOn":"Se termine le","units":"Unit\xe9s"},"edit":{"title":"Modifier la t\xe2che planifi\xe9e","description":"Modifiez l\'invite et sa planification avant son ex\xe9cution.","name":"Nom","namePlaceholder":"Nommez cette t\xe2che planifi\xe9e","prompt":"Rapide","customContext":"Contexte personnalis\xe9","contextNote":{"generic":"Le contexte de cette t\xe2che est r\xe9solu lors de son ex\xe9cution.","highlighted":"Cette t\xe2che utilise le texte mis en surbrillance dans votre application active lors de l\'ex\xe9cution.","clipboard":"Cette t\xe2che utilise le contenu de votre presse-papiers lors de son ex\xe9cution.","auto":"Le contexte de cette t\xe2che est r\xe9solu automatiquement lors de son ex\xe9cution."},"attachments":"Fichiers et dossiers joints","skills":"Comp\xe9tences","connectors":"Connecteurs","schedule":"Calendrier","goalRequired":"Saisissez une invite pour cette t\xe2che.","saved":"T\xe2che planifi\xe9e enregistr\xe9e.","notFound":"Cette t\xe2che planifi\xe9e n\'existe plus."},"schedulePrompt":{"menuItem":"Programmez cette invite\u2026","title":"Programmez cette invite","prompt":"Rapide","name":"Nom (facultatif)","namePlaceholder":"Nommez cette t\xe2che planifi\xe9e","confirm":"Calendrier","goalRequired":"Saisissez une invite pour planifier.","success":"Planifi\xe9 rapidement.","error":"Impossible de programmer cette invite."},"notify":{"runStarted":{"title":"T\xe2che planifi\xe9e en cours d\'ex\xe9cution","body":"\\"{{name}}\\" est en cours d\'ex\xe9cution."},"missed":{"title":"T\xe2che planifi\xe9e manqu\xe9e","bodyOne":"\\"{{name}}\\" a \xe9t\xe9 manqu\xe9 car l\'application n\'\xe9tait pas en cours d\'ex\xe9cution.","bodyMany":"{{count}} t\xe2ches planifi\xe9es ont \xe9t\xe9 manqu\xe9es pendant que l\'application n\'\xe9tait pas en cours d\'ex\xe9cution."}},"skippedBusy":"Ignor\xe9 car un autre flux de travail \xe9tait d\xe9j\xe0 en cours.","overlap":{"title":"Les horaires se chevauchent.","description":"Cette automatisation s\'ex\xe9cute dans les 5 minutes suivant l\'heure indiqu\xe9e par \xab\xa0{{name}}\xa0\xbb ({{time}}). Une seule automatisation s\'ex\xe9cute \xe0 la fois\xa0; l\'une attendra donc la fin de l\'autre. Voulez-vous quand m\xeame la programmer\xa0?","confirm":"Planifiez quand m\xeame"}},"keyboardService":{"unavailable":{"title":"Le contr\xf4le du clavier et de la souris s\'est arr\xeat\xe9","recovering":"Cephable est en train de red\xe9marrer. Vos commandes seront de nouveau fonctionnelles dans quelques instants.","stalled":"Cephable n\'a pas pu red\xe9marrer. Veuillez r\xe9essayer votre commande ou red\xe9marrer Cephable si l\'erreur persiste.","permissionTitle":"Cephable ne peut pas contr\xf4ler votre clavier et votre souris.","permission":"Accordez l\'acc\xe8s \xe0 Cephable dans Param\xe8tres syst\xe8me > Confidentialit\xe9 et s\xe9curit\xe9 > {{pane}}, puis r\xe9essayez votre commande.","permissionWindows":"Windows emp\xeache les applications de contr\xf4ler les programmes ex\xe9cut\xe9s en tant qu\'administrateur. Fermez puis rouvrez Cephable en tant qu\'administrateur, ou rouvrez l\'autre application sans droits d\'administrateur. Les messages de s\xe9curit\xe9 Windows et l\'\xe9cran de verrouillage ne peuvent jamais \xeatre contr\xf4l\xe9s. Sur un appareil professionnel, votre administrateur informatique peut bloquer cette fonctionnalit\xe9."},"restored":"Le contr\xf4le par clavier et souris fonctionne \xe0 nouveau."},"error":"Erreur","macPermissions":{"openSettings":"Ouvrir les param\xe8tres","pane":{"accessibility":"Accessibilit\xe9","deviceControl":"Contr\xf4le des appareils et acc\xe8s aux donn\xe9es","inputMonitoring":"Surveillance des entr\xe9es","filesAndFolders":"Fichiers et dossiers","fullDiskAccess":"Acc\xe8s complet au disque","camera":"Cam\xe9ra","microphone":"Microphone","screenRecording":"Enregistrement d\'\xe9cran"}},"recordWorkflow":{"title":"Enregistrer un flux de travail","description":"Montrez \xe0 Cephable comment vous effectuez une t\xe2che \u2014 d\xe9crivez-la \xe0 voix haute au fur et \xe0 mesure que vous cliquez \u2014 et elle deviendra une comp\xe9tence r\xe9utilisable.","cardDescription":"Enregistrez-vous en train d\'effectuer une t\xe2che pour apprendre \xe0 Cephable comment la r\xe9aliser.","goalLabel":"Description de l\'enregistrement","goalPlaceholder":"Qu\'allez-vous d\xe9montrer\xa0? (facultatif)","start":"D\xe9marrer l\'enregistrement","recording":"Enregistrement de votre flux de travail","stepCount":"{{count}} pas","stopAndCreate":"Arr\xeatez-vous et cr\xe9ez une comp\xe9tence","creating":"Transformer votre enregistrement en une comp\xe9tence\u2026","permissionNeeded":"Cephable a besoin de l\'autorisation d\'accessibilit\xe9/de surveillance des entr\xe9es pour enregistrer vos actions. Accordez-la dans les param\xe8tres syst\xe8me, puis recommencez.","noMic":"Microphone indisponible \u2014 vos actions sont enregistr\xe9es sans commentaire.","startError":"Impossible de d\xe9marrer l\'enregistrement.","noSteps":"Aucune action n\'a \xe9t\xe9 enregistr\xe9e pour \xeatre transform\xe9e en comp\xe9tence.","stopReminder":"Continuez aussi longtemps que n\xe9cessaire. Une fois la t\xe2che termin\xe9e, revenez ici et appuyez sur \xab\xa0Arr\xeater et cr\xe9er une comp\xe9tence\xa0\xbb.","callout":{"title":"Enseigne \xe0 Cephable une de tes t\xe2ches","description":"R\xe9alisez une t\xe2che une fois sous le regard de Cephable qui commente vos actions. Vous d\xe9velopperez ainsi une comp\xe9tence utilisable \xe0 tout moment.","action":"Montrez-moi comment","dismiss":"Pas maintenant","badge":"Essayez-le","compactDescription":"Accomplissez une t\xe2che une seule fois sous le regard de Cephable et elle deviendra une comp\xe9tence que vous pourrez utiliser \xe0 tout moment.","compactAction":"Enregistrer un flux de travail"},"coach":{"title":"Avant d\'enregistrer","progress":"Pourboire {{current}} sur {{total}}","ready":"Je suis pr\xeat","skip":"Passez les pourboires","reopen":"Comment \xe7a marche","steps":{"pickTask":{"title":"Choisissez une t\xe2che r\xe9elle","body":"Choisissez une activit\xe9 que vous pratiquez r\xe9guli\xe8rement et pr\xe9voyez de la r\xe9aliser enti\xe8rement en une seule fois. Une t\xe2che courte et compl\xe8te est bien plus instructive qu\'une t\xe2che longue et inachev\xe9e.","example":"Voici comment je remplis mon rapport de d\xe9penses hebdomadaire : je l\'ouvre, je le remplis, je le soumets."},"narrate":{"title":"Parlez tout au long du parcours","body":"Expliquez \xe0 voix haute ce que vous faites et pourquoi, comme si un nouveau coll\xe8gue vous observait. Cephable transforme ensuite votre description en \xe9tapes.","example":"J\'ouvre maintenant la facture dans Outlook pour pouvoir trouver le num\xe9ro de commande."},"goSlow":{"title":"Cliquez d\xe9lib\xe9r\xe9ment, une chose \xe0 la fois","body":"Attendez que chaque page ou application soit compl\xe8tement charg\xe9e avant de cliquer \xe0 nouveau, et indiquez le nom de l\'\xe9l\xe9ment sur lequel vous cliquez. \xc9vitez toute information confidentielle\xa0: les mots de passe et les num\xe9ros de carte bancaire n\'ont pas leur place dans une skill.","example":"Je clique sur \xab\xa0Approuver\xa0\xbb en haut \xe0 droite et j\u2019attends que la confirmation apparaisse."},"explainRules":{"title":"\xc9noncez les r\xe8gles \xe0 voix haute.","body":"Signalez tout ce qui change d\'une session \xe0 l\'autre et ce que vous feriez diff\xe9remment, afin que la comp\xe9tence puisse s\'appliquer \xe0 plus que la simple session d\'aujourd\'hui.","example":"S\'il n\'y a pas de num\xe9ro de bon de commande, je ne passe pas par le tableur et j\'envoie directement un e-mail au fournisseur."},"comeBack":{"title":"Revenez en arri\xe8re et appuyez sur Arr\xeater","body":"Cephable continue d\'enregistrer jusqu\'\xe0 ce que vous l\'arr\xeatiez. Une fois la t\xe2che termin\xe9e, retournez \xe0 ce panneau et appuyez sur \xab\xa0Arr\xeater et cr\xe9er une comp\xe9tence\xa0\xbb. Si l\'application ne d\xe9tecte aucun clic pendant une minute, elle s\'arr\xeatera automatiquement.","example":"Voil\xe0, c\'est termin\xe9."}}},"idle":{"title":"Enregistrement en cours","body":"Aucun clic ni message pendant un moment. Si vous avez termin\xe9 la t\xe2che, appuyez sur \xab\xa0Arr\xeater et cr\xe9er une comp\xe9tence\xa0\xbb.","countdown":"Arr\xeat automatique dans {{secondes}}s.","keepGoing":"Je travaille toujours","autoStopped":"L\'enregistrement s\'est arr\xeat\xe9 automatiquement apr\xe8s une minute de silence."},"teachAction":"Enseigner un flux de travail \xe0 Cephable"},"backgroundCapture":{"title":"Contexte","capturing":"Stockage du contenu en arri\xe8re-plan...","tooltip":"Contenu qui n\'a pas pu \xeatre saisi et qui est conserv\xe9 pour la session en cours. Il dispara\xeetra lorsque vous quitterez Cephable.","nothingToPaste":"Il n\'y a pas de contenu d\'arri\xe8re-plan \xe0 coller.","pasteNotPermitted":"Impossible de coller. Action non autoris\xe9e en raison du focus actuel.","pasteFailed":"Impossible de coller le contenu d\'arri\xe8re-plan."}}');


var $e182c8d7a6bdad6a$exports = {};
$e182c8d7a6bdad6a$exports = JSON.parse('{"404":"Ah non ! Nous avons fouill\xe9 la mer et nous ne trouvons pas votre page\xa0!","appError":{"title":"Quelque chose s\'est mal pass\xe9","description":"L\'application a rencontr\xe9 un probl\xe8me inattendu. Veuillez la recharger ou retourner \xe0 votre espace de travail. Si le probl\xe8me persiste, veuillez contacter l\'assistance.","home":"Retour \xe0 l\'espace de travail"}}');


var $647dd474a4538087$exports = {};
$647dd474a4538087$exports = JSON.parse('{"smartTasks":{"generate":{"focusApp":{"title":"Concentrez-vous sur l\'application","description":"Assurez-vous de s\xe9lectionner l\'application o\xf9 vous souhaitez que le texte g\xe9n\xe9r\xe9 apparaisse. Vous pourrez g\xe9n\xe9rer le texte \xe0 cet endroit en toute simplicit\xe9 en cliquant sur \xab\xa0G\xe9n\xe9rer\xa0\xbb."}},"rewrite":{"focusApp":{"title":"Concentrez-vous sur l\'application","description":"Assurez-vous de s\xe9lectionner l\'application o\xf9 vous souhaitez que le texte r\xe9\xe9crit apparaisse. Vous pourrez g\xe9n\xe9rer facilement le texte \xe0 cet endroit en cliquant sur \xab\xa0G\xe9n\xe9rer\xa0\xbb."}}},"customControls":{"tourLabel":"Contr\xf4les globaux et des appareils toujours disponibles","rowDescription":"Les commandes globales et celles de l\'appareil sont toujours disponibles si votre microphone est activ\xe9, quelle que soit l\'application utilis\xe9e. Vous pouvez utiliser ces commandes pour interagir avec votre appareil sans avoir \xe0 cr\xe9er de nouvelles commandes. Elles contiennent des commandes utiles comme changer de commande ou d\'application, g\xe9n\xe9rer du texte, mettre votre microphone en pause, et bien plus encore."},"profile":{"switch":{"title":"Commandes de l\'application Switch","description":"Les commandes de votre application peuvent basculer automatiquement en fonction de l\'application que vous utilisez, ou vous pouvez les modifier manuellement ici \xe0 tout moment."}},"dictation":{"tourLabel":"Dict\xe9e","learn":"Apprenez \xe0 utiliser le mode dict\xe9e pour convertir votre discours en texte en mains libres.","welcome":{"title":"Dict\xe9e","description":"La dict\xe9e vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C\'est comme avoir un assistant personnel qui saisit tout ce que vous dites."},"microphone":{"title":"Allumez votre microphone","description":"Tout d\'abord, activez votre microphone. Cliquez sur l\'ic\xf4ne \xab\xa0Microphone\xa0\xbb dans le panneau Cephable."},"activate":{"title":"D\xe9marrer le mode dict\xe9e","description":"La voix d\xe9marre en mode commande. Pour lancer la dict\xe9e, dites \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb ou cliquez sur le bouton \xab\xa0Dict\xe9e\xa0\xbb. Activons maintenant le mode dict\xe9e."},"focus":{"title":"Se concentrer sur un champ de texte ou un document","description":"La dict\xe9e est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Cliquez sur le champ de texte ou le document o\xf9 vous souhaitez dicter."},"speaking":{"title":"Commencez \xe0 parler","description":"Vous pouvez maintenant commencer \xe0 parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous \xeates concentr\xe9. Essayez de dire quelque chose comme\xa0: \xab\xa0Bonjour, ceci est un test du mode dict\xe9e.\xa0\xbb"},"pauseResume":{"title":"Pause de la dict\xe9e","description":"Besoin d\'une pause sans d\xe9sactiver la dict\xe9e\xa0? Dites simplement \xab\xa0Suspendre la dict\xe9e\xa0\xbb. Vous pouvez la reprendre \xe0 tout moment avec \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb. Vous pouvez personnaliser davantage cette option gr\xe2ce aux commandes globales et aux commandes de l\'appareil toujours actives."},"stop":{"title":"Arr\xeater la dict\xe9e","description":"Besoin de revenir aux commandes de votre application\xa0? Dites simplement \xab\xa0Arr\xeater la dict\xe9e\xa0\xbb. Cela arr\xeatera le mode dict\xe9e et vous ram\xe8nera au mode commande. Vous pouvez reprendre \xe0 tout moment en cliquant \xe0 nouveau sur \xab\xa0D\xe9marrer la dict\xe9e\xa0\xbb."},"complete":{"description":"Et voil\xe0\xa0! Vous pouvez d\xe9sormais dicter, mettre en pause, reprendre et passer du mode dict\xe9e au mode commande. La dict\xe9e est un outil puissant pour la saisie mains libres. Utilisez-la pour r\xe9diger des e-mails, des documents ou tout ce que vous devez saisir \xe0 voix haute."}},"microphone":{"tourLabel":"Commandes vocales","learn":"D\xe9couvrez comment utiliser votre voix pour contr\xf4ler n\u2019importe quelle application et utiliser la dict\xe9e pour taper ce que vous dites.","rowDescription":"Lorsque le microphone est d\xe9sactiv\xe9, nous n\'entendons pas vos commandes vocales. Cependant, si vous l\'activez, vous pourrez utiliser les commandes globales pour mettre en pause, d\xe9marrer, etc. Allumons-le.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Spotify\xa0\xbb ou \xab\xa0Ouvrir Word\xa0\xbb"},"finishedCommands":{"title":"Excellent\xa0! Vous avez appris les bases des commandes vocales.","description":"Vous pouvez toujours consulter la visite depuis la page d\'assistance. L\'\xe9tape suivante consiste \xe0 d\xe9couvrir la dict\xe9e. Vous pouvez commencer la visite depuis la page d\'assistance."}},"tour":{"startTour":"D\xe9marrer la visite","finishTour":"Terminer la tourn\xe9e","statusDialog":"Veuillez consulter le panneau pour plus d\'informations.","step":"\xc9tape {{step}} sur {{total}}","skipTour":"Skip Tour"},"onboarding":{"overview":"Aper\xe7u","learn":"D\xe9couvrez les fonctionnalit\xe9s de Cephable et comment les utiliser.","start":"On dirait que vous ne faites que commencer. Voici quelques pistes pour vous aider.","dashboard":{"title":"Espace de travail Cephable","description":"L\'espace de travail Cephable centralise la gestion de votre appareil, des commandes d\'applications et des param\xe8tres. Vous pouvez y personnaliser votre exp\xe9rience, consulter les commandes actives et acc\xe9der \xe0 toutes les fonctionnalit\xe9s de Cephable."},"step1":{"title":"Bienvenue chez Cephable","description":"Cephable est votre IA personnelle\xa0: con\xe7ue pour des actions rapides, des commandes vocales, la g\xe9n\xe9ration de contenu et une automatisation intelligente de vos outils. Des commandes pr\xeates \xe0 l\'emploi. Aucun traitement cloud. Juste une productivit\xe9 qui vous accompagne."},"finish":{"continueToApp":"Continuer vers le tableau de bord Cephable","keepExploring":"Continuez \xe0 explorer"},"useCaseSlider":{"context":"J\'aimerais utiliser","control":"contr\xf4ler"}},"support":{"description":"Vous pouvez visiter notre centre d\'assistance pour plus d\'informations sur l\'utilisation de Cephable, notamment des visites guid\xe9es, des guides \xe9tape par \xe9tape, des didacticiels et des vid\xe9os.","title":"Soutien"},"editingVideos":{"tourLabel":"Concentrez-vous sur l\'histoire, pas sur les clics fastidieux du montage vid\xe9o","learn":"Apprenez \xe0 utiliser les commandes vocales et la dict\xe9e pour monter vos vid\xe9os plus rapidement et \xe9liminez la charge cognitive li\xe9e \xe0 la m\xe9morisation des boutons sur lesquels cliquer pendant le montage.","tryOpen":{"title":"Essayez de dire \xab Ouvrir CapCut \xbb ou \xab Ouvrir iMovie \xbb."},"complete":{"description":"Vous savez d\xe9sormais comment utiliser les commandes vocales et les actions rapides pour lire, mettre en pause, passer \xe0 la piste suivante et r\xe9gler le volume dans vos applications de montage vid\xe9o pr\xe9f\xe9r\xe9es. Explorez d\'autres commandes ou personnalisez vos propres actions rapides pour un contr\xf4le vid\xe9o encore plus fluide."}},"congrats":"Bravo!","fpsGamePlay":{"tourLabel":"Jouez \xe0 des jeux FPS avec des commandes vocales","learn":"Apprenez \xe0 utiliser les commandes vocales et les actions rapides pour jouer \xe0 des jeux FPS.","tryOpen":{"title":"Essayez de dire \xab\xa0Ouvrir Valorant\xa0\xbb ou \xab\xa0Ouvrir Battlefield\xa0\xbb"},"complete":{"description":"Vous savez maintenant utiliser les commandes vocales et les actions rapides pour d\xe9placer, arr\xeater et contr\xf4ler votre personnage dans les jeux FPS. Explorez d\'autres commandes ou personnalisez vos actions rapides pour un gameplay encore plus fluide et rapide."}},"redo":"Refaire l\'int\xe9gration","title":"D\xe9couvrez Cephable","description":"D\xe9couvrez Cephable, votre assistant IA personnel et partagez votre int\xe9r\xeat pour les cas d\'utilisation personnalis\xe9s.","panel":{"description":"Voici le panneau de contr\xf4le principal. Toujours visible, il vous permet de contr\xf4ler vos applications \xe0 la voix, et bien plus encore. Commen\xe7ons par le microphone."},"controlExpanded":{"tourLabel":"Contr\xf4le","description":"Les commandes d\'application sont des ensembles de commandes configurables que vous pouvez utiliser dans une application donn\xe9e. Cette section pr\xe9sente toutes les commandes disponibles\xa0: commandes vocales, interactions tactiles, saisie au clavier, etc."},"submit":{"title":"Soumettre","description":"Le contenu sera affich\xe9 \xe0 l\'endroit o\xf9 se trouve le curseur."},"tryOpen":{"description":"`Open` est une commande globale qui ouvre l\'application sp\xe9cifi\xe9e et lui donne le focus. Si la commutation automatique des commandes est activ\xe9e, elle basculera \xe9galement vers les commandes les mieux adapt\xe9es \xe0 l\'application utilis\xe9e."},"modeSelector":{"title":"S\xe9lectionner le mode","description":"Si cette option est disponible, vous pouvez s\xe9lectionner le mode de fonctionnement. Utilisez \xab\xa0Contr\xf4le\xa0\xbb pour l\u2019application par laquelle vous souhaitez envoyer des commandes, \xab\xa0Cr\xe9er\xa0\xbb pour la g\xe9n\xe9ration de contenu textuel (r\xe9sum\xe9, r\xe9\xe9criture, traduction, etc.) et \xab\xa0Automatiser\xa0\xbb pour les flux de travail sur ordinateur ou entre applications."},"contextSelector":{"title":"S\xe9lectionner le contexte","description":"Si possible, vous pouvez s\xe9lectionner le contexte dans lequel je vais intervenir. Par exemple, je peux utiliser votre presse-papiers ou le texte s\xe9lectionn\xe9, et vous pouvez \xe9galement joindre des fichiers ou des dossiers sur lesquels vous souhaitez que je travaille."},"panelInput":{"title":"Que voulez-vous que je fasse ?","description":"Vous pouvez me donner des ordres, taper ou dicter ce que vous voulez que je fasse."},"figma":{"tourLabel":"Commandes vocales pour Figma et Canva","learn":"D\xe9couvrez comment utiliser les commandes vocales, la souris vocale, la dict\xe9e et la g\xe9n\xe9ration de contenu par IA de Controls pour am\xe9liorer votre flux de travail de conception.","complete":{"description":"Vous savez d\xe9sormais comment contr\xf4ler et cr\xe9er des designs pour optimiser votre flux de travail. Explorez d\'autres commandes pour un contr\xf4le encore plus fluide de vos cr\xe9ations."},"tryOpen":{"title":"Essayez de dire \xab Ouvrir Figma \xbb ou \xab Ouvrir Canva \xbb."}},"voiceMouse":{"title":"Souris vocale","description":"Pour cliquer sur les boutons par leur nom, vous pouvez utiliser la souris vocale. Pour cela, dites \xab\xa0appuyer sur enregistrer\xa0\xbb ou \xab\xa0aller dans les param\xe8tres\xa0\xbb."},"documentSummary":{"tourLabel":"R\xe9sum\xe9s des \xe9quipes de draft tir\xe9s de rapports confidentiels","learn":"Automatisez la lecture des rapports de service, identifiez les personnes \xe0 informer et r\xe9digez un e-mail, le tout sur votre appareil, pour que vos donn\xe9es confidentielles restent priv\xe9es.","congrats":{"description":"Vous savez d\xe9sormais comment utiliser les flux de travail d\'IA pour lire des documents confidentiels et r\xe9diger un courriel de synth\xe8se \xe0 votre \xe9quipe, le tout sans que vos donn\xe9es ne quittent votre appareil."}},"extensions":{"tourLabel":"Extensions","rowDescription":"\xc9tendez les possibilit\xe9s de Cephable avec davantage de moyens de contr\xf4ler votre appareil\xa0: commandes de la cam\xe9ra pour les mouvements du visage et de la t\xeate, compatibilit\xe9 avec les manettes de jeu, etc. Activez les options souhait\xe9es ici."},"developerBuildTests":{"tourLabel":"Automatisez les processus de compilation et de test gr\xe2ce aux flux de travail d\'IA","learn":"Cephable peut ex\xe9cuter des t\xe2ches terminales en plusieurs \xe9tapes \u2014 comme la compilation de votre projet et l\'ex\xe9cution de ses tests \u2014 enti\xe8rement sur l\'appareil, en arri\xe8re-plan, pendant que vous continuez \xe0 travailler.","complete":{"description":"Vous savez d\xe9sormais comment ex\xe9cuter des workflows d\'IA embarqu\xe9s pour des t\xe2ches de compilation et de test en plusieurs \xe9tapes, r\xe9pondre aux demandes d\'autorisation et it\xe9rer sur les r\xe9sultats. Essayez d\'automatiser une autre t\xe2che de d\xe9veloppement r\xe9p\xe9titive."}},"classroomStudyTools":{"tourLabel":"Transformer les notes de cours et les articles en outils d\'\xe9tude et en mat\xe9riel p\xe9dagogique","learn":"Cephable accompagne les enseignants et les \xe9l\xe8ves gr\xe2ce \xe0 la dict\xe9e, aux outils de cr\xe9ation int\xe9gr\xe9s et \xe0 l\'automatisation, directement dans les applications que vous utilisez d\xe9j\xe0, en pr\xe9servant la confidentialit\xe9 de toutes vos donn\xe9es sur votre appareil.","complete":{"description":"Vous savez d\xe9sormais comment dicter directement dans vos documents, g\xe9n\xe9rer de nouveaux supports d\'\xe9tude \xe0 partir de vos notes et utiliser Automate pour cr\xe9er des devoirs complets en arri\xe8re-plan, le tout sur votre appareil."}},"engineeringFlows":{"tourLabel":"Commandes vocales et automatisations IA pour les d\xe9veloppeurs","learn":"D\xe9couvrez comment acc\xe9l\xe9rer votre flux de travail d\'ing\xe9nierie gr\xe2ce aux commandes de d\xe9veloppement vocales, \xe0 la r\xe9\xe9criture par IA utilisant votre propre code comme contexte et aux flux de travail d\'IA en arri\xe8re-plan, le tout ex\xe9cut\xe9 sur l\'appareil.","tryOpen":{"title":"Essayez de dire \xab Ouvrir Visual Studio Code \xbb."},"complete":{"description":"Vous savez d\xe9sormais comment utiliser les commandes de d\xe9veloppement vocales, la r\xe9\xe9criture par IA avec votre propre code comme contexte et les flux de travail d\'IA en arri\xe8re-plan pour acc\xe9l\xe9rer votre flux d\'ing\xe9nierie."}},"meetingNotesToFiles":{"tourLabel":"Transformer les notes de r\xe9union en fichiers exploitables","learn":"Cephable vous permet de d\xe9couper vos notes de r\xe9union en fichiers plus petits et exploitables que vous pouvez traiter \xe0 votre rythme, directement sur votre appareil.","complete":{"description":"Vous savez d\xe9sormais comment utiliser les flux de travail d\'IA pour diviser les notes de r\xe9union en fichiers exploitables plus petits et reprendre la conversation \xe0 tout moment gr\xe2ce \xe0 l\'historique d\'IA."}},"notesToPresentation":{"tourLabel":"R\xe9sumez vos notes confidentielles et cr\xe9ez une pr\xe9sentation, le tout sur votre appareil.","learn":"Cephable peut synth\xe9tiser vos rapports et notes confidentiels, puis utiliser des flux de travail d\'IA pour traiter l\'ensemble d\'un dossier de fichiers, et m\xeame cr\xe9er une pr\xe9sentation \xe0 partir des r\xe9sultats. Le tout s\'ex\xe9cute directement sur votre appareil.","complete":{"description":"Vous savez d\xe9sormais comment r\xe9sumer des documents confidentiels, g\xe9n\xe9rer des r\xe9sum\xe9s par lots d\'un dossier entier gr\xe2ce aux flux de travail d\'IA et transformer les r\xe9sultats en une pr\xe9sentation, le tout sans que vos donn\xe9es ne quittent votre appareil."}},"organizeDownloads":{"tourLabel":"Organisez vos fichiers, faites le m\xe9nage et retrouvez ce que vous avez perdu \u2014 gr\xe2ce aux flux de travail d\'IA","learn":"Automate peut g\xe9rer des t\xe2ches de gestion de fichiers en plusieurs \xe9tapes (copie, suppression et recherche de fichiers) directement \xe0 partir d\'une simple invite de commande.","complete":{"description":"Vous savez d\xe9sormais comment utiliser les flux de travail d\'IA pour organiser les fichiers, les nettoyer en toute s\xe9curit\xe9 gr\xe2ce \xe0 des v\xe9rifications d\'autorisation et retrouver les fichiers dont vous ne vous souvenez plus de l\'emplacement."}},"outlookEmailProductivity":{"tourLabel":"Acc\xe9l\xe9rez la gestion de vos e-mails dans Outlook gr\xe2ce \xe0 la dict\xe9e, aux actions rapides et \xe0 l\'IA.","learn":"Cephable Plus et Professional incluent des outils intelligents de dict\xe9e et de cr\xe9ation pour g\xe9n\xe9rer et modifier du contenu\xa0; utilisez-les directement dans Outlook pour r\xe9pondre et r\xe9diger des e-mails plus rapidement.","complete":{"description":"Vous savez d\xe9sormais comment r\xe9pondre aux e-mails par dict\xe9e, utiliser vos propres actions Quick Type et utiliser les fonctions R\xe9sumer et G\xe9n\xe9rer pour r\xe9diger et peaufiner le contenu des e-mails, le tout sur votre appareil."}},"customizingGameControls":{"tourLabel":"Jouez \xe0 des jeux RPG avec commandes vocales","learn":"Apprenez \xe0 utiliser les commandes vocales et les actions rapides pour jouer aux jeux de r\xf4le.","tryOpen":{"title":"Essayez de dire \xab Ouvrir Minecraft \xbb."},"complete":{"description":"Vous savez d\xe9sormais utiliser les commandes vocales et les raccourcis pour d\xe9placer, arr\xeater et contr\xf4ler votre personnage dans les jeux de r\xf4le. Explorez d\'autres commandes ou personnalisez vos propres raccourcis pour une exp\xe9rience de jeu encore plus fluide et rapide."}},"voiceToTextSocialMedia":{"tourLabel":"Personnalisation vocale pour LinkedIn, Slack et Discord","learn":"Utilisez la dict\xe9e intelligente pour r\xe9diger un message naturellement, puis r\xe9\xe9crivez-le pour en ajuster le ton\xa0\u2014 cela fonctionne de la m\xeame mani\xe8re sur LinkedIn, Slack, Discord et bien plus encore.","complete":{"description":"Vous savez d\xe9sormais comment dicter un message et le peaufiner avec la fonction de r\xe9\xe9criture, sur LinkedIn, Slack, Discord et bien plus encore."}},"aiDocumentTranslation":{"tourLabel":"Traduisez des documents dans n\'importe quelle langue, directement sur votre appareil.","learn":"Cephable peut traduire un document dans une langue \xe0 la fois, ou utiliser des flux de travail d\'IA pour le traduire simultan\xe9ment dans plusieurs langues, le tout en local.","complete":{"description":"Vous savez d\xe9sormais comment traduire un document dans une seule langue par dict\xe9e, ou dans plusieurs langues simultan\xe9ment gr\xe2ce aux flux de travail d\'IA, le tout directement sur votre appareil."}},"excelAiAutomation":{"tourLabel":"Analysez vos feuilles de calcul gr\xe2ce \xe0 une IA priv\xe9e et embarqu\xe9e.","learn":"Cephable peut analyser vos fichiers Excel, r\xe9pondre aux questions concernant les chiffres et aller plus loin, le tout sans que vos donn\xe9es ne quittent votre appareil.","complete":{"description":"Vous savez d\xe9sormais comment utiliser les flux de travail d\'IA pour analyser vos feuilles de calcul, approfondir vos recherches gr\xe2ce \xe0 des suivis et enregistrer un r\xe9sum\xe9, le tout directement sur votre appareil."}},"handsFreeComputerControl":{"tourLabel":"Contr\xf4lez votre ordinateur par la voix et la cam\xe9ra","learn":"Cephable vous permet de contr\xf4ler votre ordinateur en mode mains libres gr\xe2ce aux commandes vocales, \xe0 la souris vocale et aux commandes faciales et de t\xeate bas\xe9es sur la cam\xe9ra.","tryOpenWord":{"title":"Essayez de dire \xab\xa0Open Word\xa0\xbb."},"openExtensions":{"title":"Ouvrez l\'onglet Extensions","description":"Pour activer les commandes de la cam\xe9ra, ouvrez l\'onglet Extensions dans la fen\xeatre principale."},"turnOnCamera":{"title":"Activer les commandes de la cam\xe9ra","description":"Activez la cam\xe9ra. Une ic\xf4ne de cam\xe9ra appara\xeet \xe0 c\xf4t\xe9 de l\'ic\xf4ne du microphone, et une nouvelle section Cam\xe9ra appara\xeet dans les Param\xe8tres."},"cameraInPanel":{"title":"Commandes de la cam\xe9ra dans votre panneau","description":"Maintenant que les commandes de la cam\xe9ra sont activ\xe9es, le bouton de basculement de la cam\xe9ra appara\xeet \xe9galement dans votre panneau Cephable\xa0; Cephable l\u2019active pour vous ici."},"openCameraSettings":{"title":"Ouvrir les param\xe8tres de l\'appareil photo","description":"Ouvrez les param\xe8tres de l\'appareil photo pour ajuster le fonctionnement des commandes de la t\xeate et du visage."},"chooseHeadMouseMode":{"title":"Choisissez un mode T\xeate-Souris","description":"Choisissez comment les mouvements de votre t\xeate contr\xf4lent votre souris\xa0: Glissement stable, Acc\xe9l\xe9ration ou Glissement dynamique."},"complete":{"description":"Vous savez d\xe9sormais comment contr\xf4ler votre ordinateur par la voix, la souris vocale et les commandes faciales et de la t\xeate via la cam\xe9ra. Explorez les param\xe8tres de la cam\xe9ra pour personnaliser vos commandes."}},"handsFreeTypingDocumentCreation":{"tourLabel":"Cr\xe9ez et modifiez des documents en mode mains libres","learn":"Utilisez conjointement les fonctions G\xe9n\xe9rer, R\xe9\xe9crire et les commandes vocales pour cr\xe9er et modifier un document (comme une facture) presque enti\xe8rement en mode mains libres.","complete":{"description":"Vous savez d\xe9sormais comment g\xe9n\xe9rer, r\xe9\xe9crire et modifier un document presque enti\xe8rement en mode mains libres gr\xe2ce aux fonctions G\xe9n\xe9rer, R\xe9\xe9crire et aux commandes vocales."}},"webResearchCreateHtml":{"tourLabel":"Faites des recherches sur le Web et cr\xe9ez un site web \xe0 partir de ces recherches, le tout sur votre appareil.","learn":"Cephable peut parcourir et analyser les sites web concurrents, puis utiliser les informations trouv\xe9es pour g\xe9n\xe9rer un nouveau site HTML pour vous \u2014 enti\xe8rement sur votre appareil, afin que vos recherches restent priv\xe9es.","complete":{"description":"Vous savez d\xe9sormais comment utiliser les flux de travail d\'IA pour analyser les sites web concurrents et g\xe9n\xe9rer un nouveau site HTML \xe0 partir des r\xe9sultats obtenus, le tout sans que vos donn\xe9es ne quittent votre appareil."}},"webResearchSummarize":{"tourLabel":"Recherchez les r\xe9glementations et r\xe9sumez les r\xe9sultats \u2014 le tout sur votre appareil","learn":"Cephable peut parcourir le web pour rechercher des changements tels que les nouvelles lois sur la protection des donn\xe9es, puis r\xe9sumer ses d\xe9couvertes en un document exploitable par votre \xe9quipe \u2014 le tout sur l\'appareil, garantissant ainsi la confidentialit\xe9 de vos recherches.","complete":{"description":"Vous savez d\xe9sormais comment utiliser les flux de travail d\'IA pour \xe9tudier les changements r\xe9glementaires, approfondir leur mise en \u0153uvre et r\xe9diger les conclusions sous forme d\'e-mail sur lequel votre \xe9quipe peut travailler, le tout sans que vos donn\xe9es ne quittent votre appareil."}},"stopListening":{"title":"Essayez de dire \xab Arr\xeate d\'\xe9couter \xbb.","description":"Cela met votre microphone en pause sans le couper compl\xe8tement. Dites de nouveau \xab\xa0\xc9couter\xa0\xbb lorsque vous serez pr\xeat."}}');


var $7d9261ac2fd5b6b6$exports = {};
$7d9261ac2fd5b6b6$exports = JSON.parse('{"introduction":{"title":"Salut, je suis Cephable.","back":"Retour \xe0 l\'introduction","description":"Je suis votre IA personnelle pour vous aider \xe0 contr\xf4ler, cr\xe9er et automatiser vos outils pr\xe9f\xe9r\xe9s, quel que soit votre r\xe9seau. Voici quelques informations \xe0 mon sujet.","action":"C\'est parti !","recording":{"title":"Votre voix et votre vid\xe9o restent locales.","description":"Je n\'enregistre, ne diffuse et n\'envoie jamais vos fichiers audio ou vid\xe9o vers le cloud. Toutes les entr\xe9es sont trait\xe9es sur l\'appareil, de mani\xe8re priv\xe9e et s\xe9curis\xe9e."},"data":{"title":"Vos donn\xe9es vous appartiennent.","description":"Je n\'utilise pas vos commandes ni votre activit\xe9 pour entra\xeener des mod\xe8les pour d\'autres. Tout reste priv\xe9 et les commandes de votre application se d\xe9placent avec vous d\'une connexion \xe0 l\'autre."},"offline":{"title":"Je travaille quand les autres outils ne fonctionnent pas.","description":"Les t\xe2ches intelligentes comme la g\xe9n\xe9ration de contenu, la r\xe9\xe9criture, la traduction et la dict\xe9e s\'ex\xe9cutent toutes en local. Aucun cloud requis. Je travaille donc m\xeame lorsque vous \xeates hors ligne, et vos donn\xe9es restent sur votre appareil."},"empower":{"title":"Con\xe7u pour responsabiliser, et non pour exploiter.","description":"Je suis con\xe7u pour am\xe9liorer votre contr\xf4le, et non pour le surveiller. Pas de suivi invasif. Pas de collecte de donn\xe9es suspectes. Juste les informations qui vous conviennent."}},"my-capabilities":{"title":"Parfait\xa0! Voici comment je peux vous aider.","back":"Retour aux capacit\xe9s","actionTitle":"Voyez-moi en action","description":"Voici les fonctionnalit\xe9s et capacit\xe9s les plus pertinentes pour votre flux de travail, organis\xe9es selon les trois domaines d\'activit\xe9 de Cephable.","action":{"title":"Voyez-moi en action","description":"D\xe9couvrez quelques exemples de la fa\xe7on dont je peux vous aider dans vos t\xe2ches quotidiennes."},"basedOnInterests":"En fonction de vos int\xe9r\xeats","cta":{"eyebrow":"Pr\xeat quand vous l\'\xeates","title":"Voyez-le fonctionner dans vos applications"}},"see-me":{"title":"Vous voulez voir comment j\'ai aid\xe9 d\'autres personnes comme vous ?","back":"Retour aux cas d\'utilisation","description":"D\xe9couvrez quelques exemples concrets de la mani\xe8re dont j\'ai transform\xe9 les flux de travail dans diff\xe9rents secteurs et r\xf4les."},"complete":{"title":"Pr\xeat \xe0 commencer \xe0 m\'utiliser ?","description":"Vous avez vu de quoi je suis capable\xa0! Maintenant, commen\xe7ons \xe0 configurer votre solution et \xe0 transformer votre flux de travail. Je serai l\xe0 pour vous accompagner \xe0 chaque \xe9tape.","action":"Configuration compl\xe8te et utilisation de Cephable"},"apps":{"title":"Je soutiens les outils que vous aimez d\xe9j\xe0","description":"Avec une prise en charge pr\xe9configur\xe9e de plus de 200 applications, je travaille avec les logiciels que vous utilisez au quotidien. Aucune configuration requise.","note":"Vous ne trouvez pas l\'application que vous utilisez\xa0? Aucun probl\xe8me\xa0: je peux g\xe9n\xe9rer des contr\xf4les ou vous aider \xe0 cr\xe9er des workflows personnalis\xe9s qui vous conviennent.","andMore":"Et plus","eyebrow":"Plus de 200 applications, aucune installation requise"},"actions":{"ctaTry":"Essayez-le maintenant","ctaWatch":"Regarder la d\xe9mo","apps":"Je suis compatible avec :","abilities":"Mes capacit\xe9s utilis\xe9es :"},"interests":{"title":"En quoi puis-je vous aider ?","back":"Retour aux int\xe9r\xeats","description":"Je peux contr\xf4ler les applications sur votre ordinateur et vos appareils connect\xe9s. Personnalisons votre exp\xe9rience\xa0: quels sont vos centres d\'int\xe9r\xeat\xa0?","note":"S\xe9lectionnez tout ce qui s\u2019applique et je vous montrerai les fonctionnalit\xe9s et les exemples les plus pertinents pour votre flux de travail.","action":"Continuer avec {{count}} int\xe9r\xeats","empty":"S\xe9lectionnez au moins un int\xe9r\xeat.","create_design":{"label":"Cr\xe9er et concevoir","shortLabel":"Conception","description":"Pour les artistes, les sp\xe9cialistes du marketing et les cr\xe9ateurs de contenu."},"analyze_report":{"label":"Analyser et signaler","shortLabel":"Analyser","description":"Pour les analystes, les chercheurs et les professionnels du monde des affaires."},"communicate_collaborate":{"label":"Communiquer et collaborer","shortLabel":"Communiquer","description":"Pour les vendeurs, les r\xe9unions et les \xe9quipes distantes."},"build_develop":{"label":"Construire et d\xe9velopper","shortLabel":"D\xe9velopper","description":"Pour les d\xe9veloppeurs, les ing\xe9nieurs et les professionnels techniques."},"game_play":{"label":"Jeu et jeu","shortLabel":"Jeux vid\xe9o","description":"Pour les joueurs, les streamers et les contr\xf4leurs multim\xe9dias."},"learn_teach":{"label":"Apprendre et enseigner","shortLabel":"Apprentissage","description":"Pour les \xe9ducateurs, les \xe9tudiants et l\u2019enseignement."},"manage_organize":{"label":"G\xe9rer et organiser","shortLabel":"Organisation","description":"Pour les chefs de projet, les coordinateurs et les organisateurs."},"adapt_access":{"label":"Adapter et acc\xe9der","shortLabel":"Accessibilit\xe9","description":"Pour des contr\xf4les adaptatifs et des besoins d\'accessibilit\xe9 personnalis\xe9s."},"everything":{"label":"Un peu de tout","shortLabel":"Tout","description":"Pour les utilisateurs g\xe9n\xe9raux d\'ordinateurs et les multit\xe2ches."},"filter":"Filtrer par type d\'int\xe9r\xeats"},"capabilities":{"title":"Mes principales capacit\xe9s d\'IA","description":"J\'associe une IA avanc\xe9e \xe0 des m\xe9thodes de saisie performantes pour vous offrir un contr\xf4le optimal de vos applications et appareils. Voici quelques exemples de mes comp\xe9tences.","voice_controls":{"title":"Commandes vocales","description":"Je comprends les commandes en langage naturel afin que vous puissiez contr\xf4ler n\'importe quelle application avec votre voix.","longDescription":"Je vous laisse parler naturellement tout en restant efficace. Que vous souhaitiez ouvrir des applications, naviguer dans les menus ou d\xe9clencher des workflows, je traduis un anglais simple en actions mains libres et fiables."},"smart_dictation":{"title":"Dict\xe9e intelligente","description":"Je convertis votre discours en texte en tenant compte du contexte et du formatage.","longDescription":"J\'\xe9coute attentivement et retranscris vos propos avec pr\xe9cision. J\'ajoute la ponctuation, corrige les majuscules et applique une mise en forme contextuelle pour un rendu impeccable, sans effort suppl\xe9mentaire."},"ai_text_generation":{"title":"G\xe9n\xe9ration de texte par IA","description":"Je peux cr\xe9er des e-mails, des documents, du code et du contenu cr\xe9atif \xe0 la vol\xe9e.","longDescription":"Je vous aide \xe0 r\xe9diger, synth\xe9tiser ou d\xe9velopper tout contenu directement dans vos applications. Des e-mails et notes aux extraits de code et documents, je veille \xe0 ce que vous ne partiez jamais de z\xe9ro."},"head_face_controls":{"title":"Commandes de la t\xeate et du visage","description":"Je vous laisse d\xe9clencher des actions avec vos mouvements de t\xeate et de visage.","longDescription":"Je traduis vos mouvements de t\xeate et expressions naturels en informations pr\xe9cises. Vous pouvez envoyer un e-mail avec un sourire, tourner une page d\'un hochement de t\xeate ou cliquer d\'un haussement de sourcils."},"natural_language_voice_clicking":{"title":"Clic vocal en langage naturel","description":"Je vous laisse dire ce que vous voyez en cliquant sur les boutons, les liens et les menus \xe0 l\'\xe9cran.","longDescription":"Lorsque vous prononcez le nom d\'un \xe9l\xe9ment \xe0 l\'\xe9cran, je le trouve et j\'interagis avec lui pour vous. Pas de commandes m\xe9moris\xe9es\xa0: d\xe9crivez simplement ce que vous voulez et je m\'occupe du clic."},"keyboard_mouse_emulation":{"title":"\xc9mulation du clavier et de la souris","description":"J\'\xe9mule les touches, les clics et le d\xe9filement pour que vous puissiez contr\xf4ler les applications sans mat\xe9riel.","longDescription":"J\'envoie les frappes, les mouvements de souris, les clics et les \xe9v\xe9nements de d\xe9filement o\xf9 vous le souhaitez. Combinez-les avec des commandes vocales ou de la t\xeate pour remplacer ou am\xe9liorer compl\xe8tement les p\xe9riph\xe9riques d\'entr\xe9e traditionnels."},"profiles_personalization":{"title":"Personnalisation","description":"Je me souviens de vos pr\xe9f\xe9rences et m\'adapte aux contr\xf4les d\'application enregistr\xe9s.","longDescription":"Je garde une trace de vos applications, commandes et pr\xe9f\xe9rences pr\xe9f\xe9r\xe9es. Passez d\'une application \xe0 l\'autre automatiquement ou manuellement, et j\'afficherai toujours les commandes adapt\xe9es \xe0 vos activit\xe9s."},"cross_device_connectivity":{"title":"Connectivit\xe9 entre appareils","description":"Je vous permets d\'utiliser votre t\xe9l\xe9phone pour d\xe9marrer une automatisation \xe0 distance.","longDescription":"Je connecte votre appareil mobile \xe0 votre ordinateur pour que vous puissiez lancer des commandes, dicter ou naviguer facilement. Id\xe9al pour les pr\xe9sentations, les sessions \xe0 distance ou une utilisation occasionnelle."},"quick_action_buttons":{"title":"Boutons d\'action rapide","description":"Je vous donne des boutons adapt\xe9s aux applications pour des actions rapides.","longDescription":"Je propose des boutons contextuels qui s\'adaptent \xe0 votre application. Qu\'il s\'agisse de rejoindre une r\xe9union, d\'envoyer un message ou de cr\xe9er un e-mail, je simplifie les t\xe2ches complexes en un seul clic."},"ai_app_awareness":{"title":"Sensibilisation aux applications d\'IA","description":"J\'ajuste mes commandes en fonction de l\'application que vous utilisez.","longDescription":"Je suis attentif \xe0 ce qui s\'affiche sur votre \xe9cran afin de vous offrir les commandes appropri\xe9es au bon moment. Pas de d\xe9sordre, pas d\'incertitude\xa0: juste ce dont vous avez besoin, quand vous en avez besoin. Tout cela sur votre appareil, sans transfert de donn\xe9es vers le cloud."},"ai_rewrite":{"title":"R\xe9\xe9criture de l\'IA","description":"Je peux r\xe9\xe9crire votre texte pour am\xe9liorer le ton, mettre \xe0 jour la mise en forme ou d\xe9velopper des d\xe9tails.","longDescription":"Je corrige votre texte directement sur place. Je peux le rendre plus convivial, plus formel, plus court, plus long ou plus d\xe9taill\xe9\xa0: tout ce dont vous avez besoin pour mieux faire passer votre message."},"ai_translation":{"title":"Traduction IA","description":"Je peux traduire entre les langues ou m\xeame les langages de programmation.","longDescription":"Je vous permet de convertir du texte en une autre langue parl\xe9e ou du code en un autre langage de programmation. Je travaille sur place, vous n\'avez donc pas besoin de quitter l\'application que vous utilisez."},"head_mouse":{"title":"T\xeate de souris","description":"Je vous laisse d\xe9placer le curseur de votre souris avec les mouvements de la t\xeate.","longDescription":"Je convertis vos mouvements de t\xeate en mouvements de curseur. Gr\xe2ce \xe0 des fonctionnalit\xe9s comme le glissement et le r\xe9glage de la sensibilit\xe9, je vous offre un contr\xf4le pr\xe9cis, confortable et mains libres."},"head_joystick":{"title":"Joystick de t\xeate","description":"Je vous laisse utiliser votre t\xeate comme un joystick pour des jeux ou des applications.","longDescription":"Je cartographie les mouvements de votre t\xeate sur les axes de votre joystick pour vous permettre de jouer \xe0 des jeux ou de contr\xf4ler des logiciels cr\xe9atifs sans mat\xe9riel. Vos mouvements sont naturels, et je les convertis en signaux analogiques."},"mcp_agent":{"title":"Agent MCP","description":"Je peux me connecter \xe0 des agents d\'IA externes via le protocole de contexte de mod\xe8le (MCP).","longDescription":"Je ma\xeetrise le protocole de contexte mod\xe8le, ce qui me permet de collaborer avec d\'autres agents et outils d\'IA. Cela signifie que je peux coordonner des t\xe2ches, \xe9changer du contexte et \xe9tendre mes capacit\xe9s avec des syst\xe8mes externes sp\xe9cialis\xe9s, tout en vous laissant le contr\xf4le."},"byo_ai_integration":{"title":"Apportez votre propre IA","description":"Je vous permets d\'am\xe9liorer mon IA existante avec vos propres mod\xe8les ou services d\'IA \xe0 utiliser avec moi.","longDescription":"Si vous disposez d\xe9j\xe0 d\'un service, d\'un mod\xe8le ou d\'un fournisseur d\'IA de confiance, je peux l\'int\xe9grer \xe0 mon flux de travail. Je vous offre la flexibilit\xe9 de choisir le moteur qui g\xe8re la g\xe9n\xe9ration, la r\xe9\xe9criture ou la traduction, qu\'il soit cloud, local ou personnalis\xe9. En cas d\'indisponibilit\xe9 du service ou de d\xe9connexion, je peux utiliser mes fonctionnalit\xe9s int\xe9gr\xe9es."},"workflows":{"title":"Flux de travail","description":"Je vous aide \xe0 encha\xeener des actions dans des workflows r\xe9p\xe9tables.","longDescription":"Je vous permet de concevoir et d\'ex\xe9cuter des processus en plusieurs \xe9tapes reliant diff\xe9rentes entr\xe9es, commandes et sorties. Gr\xe2ce aux workflows, vous pouvez automatiser des t\xe2ches routini\xe8res ou cr\xe9er des interactions complexes, d\xe9clench\xe9es par votre voix ou vos gestes. Je m\'occupe donc du gros du travail pour vous."},"showMore":"Afficher plus","showLess":"Afficher moins","background_creation":{"title":"Cr\xe9ation de l\'arri\xe8re-plan","description":"Je cr\xe9e et modifie le contenu en arri\xe8re-plan pendant que vous travaillez.","longDescription":"Je cr\xe9e et modifie le contenu en arri\xe8re-plan pendant que vous vous concentrez sur votre travail. Lorsque vous en avez besoin, le contenu est pr\xeat dans votre syst\xe8me de fichiers, sans aucune interruption de votre flux de travail ni besoin de le copier."},"ai_summary":{"title":"R\xe9sum\xe9 de l\'IA","description":"Extraire les informations pertinentes des textes longs et cr\xe9er de courts r\xe9sum\xe9s ou des points cl\xe9s \xe0 retenir."}},"listing":{"title":"Cas d\'utilisation","titleLong":"D\xe9couvrez comment je peux vous aider","recommended":"Recommand\xe9 pour vous","exploreMore":"Explorez davantage de cas d\'utilisation","description":"D\xe9couvrez tout ce que je peux faire pour optimiser votre flux de travail. De l\'am\xe9lioration de la productivit\xe9 \xe0 l\'assistance cr\xe9ative, trouvez les cas d\'utilisation adapt\xe9s \xe0 vos besoins.","all":"Tous","search":"Recherchez des cas d\'utilisation, des applications ou des fonctionnalit\xe9s...","noResults":"Aucun r\xe9sultat trouv\xe9. Essayez d\'ajuster votre recherche ou vos filtres.","emptyAction":"Voir plus en ligne"},"examples":{"universalAppControl":{"title":"Contr\xf4le universel des applications","description":"Contr\xf4lez n\'importe quelle application sur votre ordinateur avec des commandes vocales et une automatisation intelligente","descriptionLong":"Prenez le contr\xf4le de n\'importe quelle application gr\xe2ce \xe0 de puissantes commandes vocales et une automatisation intelligente. Notre syst\xe8me de contr\xf4le universel des applications apprend votre fa\xe7on de travailler et s\'adapte \xe0 vos besoins, simplifiant ainsi les t\xe2ches complexes et instantan\xe9isant les actions courantes. De la gestion de votre suite de productivit\xe9 au contr\xf4le des applications multim\xe9dias et de jeu, cette fonctionnalit\xe9 s\'applique \xe0 l\'ensemble de votre environnement num\xe9rique."},"documentSummary":{"title":"Agent de bureau IA priv\xe9 qui lit vos documents, r\xe9dige le r\xe9sum\xe9 et l\'envoie \xe0 votre \xe9quipe","description":"Utilisez un agent de bureau priv\xe9 pour lire des documents, r\xe9diger des r\xe9sum\xe9s et les partager avec votre \xe9quipe en mode mains libres.","descriptionLong":"Indiquez \xe0 votre agent IA de lire un document, de le r\xe9sumer et de l\'envoyer pour vous. Tout fonctionne en local et en toute confidentialit\xe9, vous permettant ainsi de travailler sans lever le petit doigt."},"editingVideos":{"title":"Montage audio dans CapCut\xa0: naviguez dans les chronologies, coupez les clips et restez dans le r\xe9cit.","description":"Montez vos vid\xe9os \xe0 l\'aide des commandes vocales et de la dict\xe9e, pour couper et agencer les clips en mode mains libres.","descriptionLong":"Naviguez dans votre timeline, d\xe9coupez et divisez vos clips, et peaufinez votre montage simplement avec votre voix. Restez concentr\xe9 sur l\'histoire sans avoir \xe0 naviguer dans les menus ni \xe0 utiliser la souris."},"figma":{"description":"Modifiez images et designs \xe0 l\'aide des commandes vocales et de la dict\xe9e intelligente, pour des it\xe9rations plus rapides.","descriptionLong":"Donnez vie \xe0 vos id\xe9es visuelles gr\xe2ce \xe0 l\'\xe9dition d\'images par commande vocale. Naviguez plus rapidement et it\xe9rez sur vos cr\xe9ations sans avoir \xe0 parcourir des menus complexes.","title":"Commandes vocales pour Figma et Canva\xa0: contr\xf4lez les calques, changez d\u2019outils et copiez du texte en mode mains libres."},"excelAnalysis":{"title":"Travaillez plus rapidement et analysez vos donn\xe9es dans Excel gr\xe2ce \xe0 l\'automatisation par IA priv\xe9e et locale.","description":"Analysez les feuilles de calcul et faites \xe9merger les tendances gr\xe2ce \xe0 une automatisation IA priv\xe9e et locale, sans intervention manuelle.","descriptionLong":"Analysez les tendances au sein d\'un dossier ou d\'un document, posez des questions sur les rapports financiers et \xe9laborez un r\xe9sum\xe9 final. Laissez l\'IA locale g\xe9rer l\'analyse tout en pr\xe9servant la confidentialit\xe9 de vos donn\xe9es sur votre machine."},"emailAutomation":{"title":"Automatisez vos e-mails \u2014 Des flux de travail d\'IA locaux qui lisent votre bo\xeete de r\xe9ception, r\xe9digent des brouillons de r\xe9ponses et bien plus encore !","description":"Consultez votre bo\xeete de r\xe9ception, r\xe9digez des r\xe9ponses et cr\xe9ez des mod\xe8les \xe0 l\'aide de flux de travail d\'IA locaux et de la dict\xe9e.","descriptionLong":"R\xe9digez un e-mail r\xe9sumant un article et mettant en \xe9vidence les points techniques cl\xe9s, ou cr\xe9ez des mod\xe8les r\xe9utilisables pour optimiser le traitement de vos e-mails. Laissez l\'IA locale et la dict\xe9e g\xe9rer la lecture et la r\xe9daction en toute confidentialit\xe9."},"powerpointBuilder":{"description":"Transformez vos notes, documents et feuilles de calcul en une pr\xe9sentation PowerPoint finalis\xe9e gr\xe2ce \xe0 des flux de travail d\'IA, le tout sans intervention manuelle.","descriptionLong":"Analysez un document Excel pour identifier les principales lacunes, puis laissez l\'IA transformer vos notes et donn\xe9es en une pr\xe9sentation soign\xe9e. Cr\xe9ez des diaporamas plus rapidement, sans avoir \xe0 naviguer dans des menus ni \xe0 partir d\'une page blanche.","title":"Des flux de travail IA qui transforment vos notes et documents en pr\xe9sentations PowerPoint finalis\xe9es | Cr\xe9ateur de pr\xe9sentations PowerPoint par IA"},"socialDictation":{"description":"Publiez et r\xe9pondez sur LinkedIn, Slack et Discord en utilisant la dict\xe9e vocale, sans avoir \xe0 saisir de texte.","descriptionLong":"R\xe9digez des messages, r\xe9pondez instantan\xe9ment et restez actif sur LinkedIn, Slack et Discord simplement \xe0 la voix. Poursuivez la conversation sans utiliser votre clavier.","title":"Conversion vocale en texte pour LinkedIn, Slack et Discord | Publiez et r\xe9pondez sans saisir de texte"},"developerTools":{"title":"Commandes vocales et automatisations IA pour les d\xe9veloppeurs | R\xe9diger des commentaires, de la documentation et des messages de commit","description":"R\xe9digez des commentaires, des documents et des messages de commit en utilisant les commandes vocales et l\'automatisation par IA, le tout en mains libres.","descriptionLong":"Demandez comment optimiser le code d\'un dossier de projet, puis dictez des commentaires, de la documentation et des messages de commit sans rien saisir. Restez concentr\xe9\xa0: la commande vocale et l\'automatisation par IA prennent en charge les t\xe2ches r\xe9p\xe9titives."},"terminalAgent":{"title":"Agent de bureau IA | Ex\xe9cutez des compilations et des tests en arri\xe8re-plan pendant que vous continuez \xe0 coder","description":"Ex\xe9cutez des compilations, des tests et des d\xe9bogages en arri\xe8re-plan gr\xe2ce \xe0 un agent de bureau IA pendant que vous continuez \xe0 coder.","descriptionLong":"Votre agent examine un dossier de projet, le compile, v\xe9rifie sa compilation et ex\xe9cute les tests. En cas de probl\xe8me, il explore l\'historique Git pour en trouver la cause et propose une solution, vous permettant ainsi de vous concentrer sur votre travail."},"gamingFPS":{"description":"Visez, tirez, rechargez et changez d\'armes dans les jeux FPS comme Valorant gr\xe2ce aux commandes vocales, en mode mains libres.","descriptionLong":"Donnez des ordres vocaux pour tirer, recharger et changer d\'arme pendant vos parties de FPS comme Valorant. Int\xe9grez la commande vocale \xe0 votre configuration et restez au c\u0153ur de l\'action sans avoir \xe0 utiliser chaque touche.","title":"Commandes vocales pour FPS, Valorant et plus encore | Visez, tirez, rechargez et changez d\'arme en mode mains libres"},"gamingRPG":{"title":"Personnaliser les commandes de jeu RPG pour Minecraft | Commandes adaptatives pour jeux vid\xe9o","description":"Personnalisez et adaptez les commandes de jeu de Minecraft et d\'autres RPG \xe0 votre style de jeu.","descriptionLong":"Configurez des commandes adaptatives pour Minecraft et autres jeux de r\xf4le, en attribuant les actions \xe0 vos besoins. Cr\xe9ez un syst\xe8me de contr\xf4le qui correspond \xe0 votre fa\xe7on de jouer, au lieu de contraindre vos mains \xe0 s\'adapter au jeu."},"educationTools":{"description":"Transformez vos notes et articles en outils d\'\xe9tude et en supports p\xe9dagogiques gr\xe2ce \xe0 l\'IA int\xe9gr\xe9e, le tout en mode mains libres.","descriptionLong":"\xc0 partir d\'un article, cr\xe9ez un document Word contenant des questions de r\xe9flexion adapt\xe9es au niveau scolaire de l\'\xe9l\xe8ve, afin de l\'aider dans un exercice d\'\xe9criture cr\xe9ative. Laissez l\'IA int\xe9gr\xe9e transformer votre texte source en ressources p\xe9dagogiques pr\xeates \xe0 l\'emploi, tout en garantissant la confidentialit\xe9 de vos donn\xe9es.","title":"Transformez vos notes de cours et articles en outils d\'\xe9tude cr\xe9atifs ou en supports p\xe9dagogiques gr\xe2ce \xe0 l\'IA embarqu\xe9e."},"meetingNotes":{"title":"Automatisation par IA pour transformer les notes de r\xe9union en fichiers plus petits","description":"Transformez vos notes de r\xe9union en fichiers organis\xe9s et exploitables gr\xe2ce \xe0 l\'automatisation par IA, le tout sans intervention manuelle.","descriptionLong":"Relisez vos notes de r\xe9union pour identifier les t\xe2ches restantes, les responsables et les points \xe0 am\xe9liorer. Laissez l\'IA les organiser dans des fichiers s\xe9par\xe9s et les classer dans un dossier pour faciliter leur consultation ult\xe9rieure."},"fileManagement":{"description":"Organisez vos t\xe9l\xe9chargements, trouvez des fichiers et nettoyez votre PC gr\xe2ce \xe0 un agent de bureau IA int\xe9gr\xe9, le tout en mode mains libres.","descriptionLong":"Demandez \xe0 votre agent de copier les fichiers t\xe9l\xe9charg\xe9s dans le r\xe9pertoire de documentation de votre produit, ou de rechercher et d\'organiser les fichiers sur votre PC. Gardez votre machine bien rang\xe9e gr\xe2ce \xe0 une IA embarqu\xe9e qui prot\xe8ge vos donn\xe9es.","title":"Agent IA int\xe9gr\xe9 \xe0 votre ordinateur | Organisez vos t\xe9l\xe9chargements, trouvez des fichiers et nettoyez votre PC"},"dictationWriting":{"title":"Saisie mains libres et cr\xe9ation de documents \u2014 Dict\xe9e vocale, g\xe9n\xe9ration par IA et r\xe9\xe9criture sur n\'importe quelle application","description":"Saisissez, g\xe9n\xe9rez et r\xe9\xe9crivez des documents en mode mains libres gr\xe2ce \xe0 la dict\xe9e vocale et \xe0 l\'IA dans n\'importe quelle application.","descriptionLong":"Dictez du texte, g\xe9n\xe9rez du contenu et r\xe9\xe9crivez vos \xe9crits dans n\'importe quelle application, simplement avec votre voix. Cr\xe9ez des documents de A \xe0 Z sans toucher au clavier."},"headMouseControl":{"title":"Contr\xf4le mains libres de l\'ordinateur avec souris de t\xeate, commande vocale | Commandes informatiques adaptatives","description":"Contr\xf4lez votre ordinateur en mode mains libres gr\xe2ce au suivi des mouvements de la t\xeate et aux commandes adaptatives Talk to Tap.","descriptionLong":"D\xe9placez le curseur gr\xe2ce au suivi des mouvements de la t\xeate et cliquez avec la commande vocale pour naviguer sur votre ordinateur en mode mains libres. Configurez des commandes adaptatives pour travailler comme vous le souhaitez."},"documentTranslation":{"title":"Traduction automatique de documents par IA pour tous ceux qui travaillent dans plusieurs langues \u2014 espagnol, arabe, portugais et plus encore","description":"Traduisez des documents dans des langues comme l\'espagnol, l\'arabe et le portugais gr\xe2ce \xe0 l\'IA, sans utiliser vos mains.","descriptionLong":"Traduisez vos documents en espagnol, arabe, portugais et bien plus encore gr\xe2ce \xe0 l\'IA int\xe9gr\xe9e. Travaillez en toute confiance dans plusieurs langues sans changer d\'outil ni copier de texte entre applications."},"websiteRedesign":{"description":"Analysez vos concurrents et obtenez des suggestions pour la refonte de votre site web gr\xe2ce \xe0 l\'IA, sans intervention manuelle.","descriptionLong":"Utilisez Point AI sur le site web de SafeDrive Auto Insurance, puis demandez-lui d\'analyser les sites concurrents afin d\'identifier les diff\xe9rences. Vous obtiendrez ainsi des suggestions concr\xe8tes pour moderniser un site obsol\xe8te, bas\xe9es sur une v\xe9ritable \xe9tude de march\xe9.","title":"Recherche Web IA priv\xe9e + automatisation | Navigation, analyse et cr\xe9ation HTML"},"dataPrivacyResearch":{"description":"Recherchez les derni\xe8res lois sur la protection des donn\xe9es et transformez vos d\xe9couvertes en actions de suivi de conformit\xe9, le tout sans intervention humaine.","descriptionLong":"Analysez les lois les plus r\xe9centes sur la protection des donn\xe9es (2026) et leurs diff\xe9rences avec celles de 2025, puis identifiez les mesures que les entreprises doivent mettre en \u0153uvre. Demandez \xe0 l\'IA de r\xe9diger un courriel de suivi contenant des exemples pour vous aider \xe0 vous conformer \xe0 la r\xe9glementation.","title":"Naviguez, analysez et synth\xe9tisez sans que vos donn\xe9es ne quittent votre appareil | Recherche Web priv\xe9e par IA"}},"control":{"title":"Contr\xf4le.","subtitle":"Votre logiciel. Vos entr\xe9es. Vos r\xe8gles.","description":"Commandes vocales, raccourcis clavier et boutons d\'acc\xe8s rapide\xa0: utilisables dans toutes les applications de votre appareil. Aucune souris requise. Aucun script. Aucune configuration n\xe9cessaire pour les centaines d\'applications que vous utilisez d\xe9j\xe0.","titleAlt":"Contr\xf4le"},"create":{"title":"Cr\xe9er.","subtitle":"Vos mots. Vos brouillons. Votre machine.","description":"R\xe9digez, r\xe9\xe9crivez, reformatez et traduisez directement dans l\'application que vous utilisez. Sans cloud. Sans copier-coller dans un autre outil. Sans brouillons servant \xe0 entra\xeener le mod\xe8le de quelqu\'un d\'autre.","titleAlt":"Cr\xe9er"},"automate":{"title":"Automatiser.","subtitle":"Une seule phrase. Chaque \xe9tape. Termin\xe9.","description":"D\xe9crivez une t\xe2che en langage clair et Cephable l\'ex\xe9cute. Cela fonctionne avec vos applications, vos fichiers et m\xeame votre ligne de commande. Le processus s\'ex\xe9cute pendant que vous effectuez d\'autres t\xe2ches, et aucune donn\xe9e ne quitte votre machine.","titleAlt":"Automatiser"},"upgrade":{"subtitle":{"trial":"Pendant les {{days}} prochains jours, mes fonctionnalit\xe9s d\'IA sont d\xe9bloqu\xe9es\xa0: Cr\xe9er et Automatiser, toutes deux fonctionnant sur un seul mod\xe8le int\xe9gr\xe9. Activez-les quand vous serez pr\xeat.","orgGeneric":"Votre organisation a d\xe9bloqu\xe9 mes fonctionnalit\xe9s d\'IA \u2014 Cr\xe9er et Automatiser \u2014 qui fonctionnent toutes deux sur un seul appareil. Activez-les quand vous serez pr\xeat.","org":"Vous avez \xe9t\xe9 ajout\xe9 \xe0 l\'organisation {{organization}}, ce qui d\xe9bloque mes fonctionnalit\xe9s d\'IA\xa0: Cr\xe9er et Automatiser, toutes deux ex\xe9cut\xe9es sur un seul appareil. Activez-les quand vous serez pr\xeat."},"badge":{"trial":"Le proc\xe8s se termine en","trialDays_one":"{{count}} jour","trialDays_other":"{{count}} jours","org":"D\xe9verrouill\xe9 par","orgGeneric":"Licence d\'organisation"},"setup":{"eyebrow":"Configurez vos fonctionnalit\xe9s Pro","title":"Choisissez ce que vous souhaitez activer","description":"Vous pourrez modifier ces param\xe8tres ult\xe9rieurement. Tout s\'ex\xe9cute sur votre appareil\xa0: vos textes et vos fichiers vous suivent partout."},"enable":{"title":"Activer les fonctionnalit\xe9s d\'IA","description":"Un seul interrupteur permet d\'activer simultan\xe9ment Create et Automate. Ces deux fonctions fonctionnent sur un mod\xe8le partag\xe9 au sein de l\'appareil\xa0; aucune configuration distincte n\'est requise pour chacune.","model":{"label":"Mod\xe8le d\'IA embarqu\xe9","tag":"Moteur partag\xe9","description":"Permet \xe0 la fois de cr\xe9er et d\'automatiser. Les mod\xe8les plus volumineux produisent de meilleurs r\xe9sultats, mais consomment davantage de ressources\xa0; ils sont t\xe9l\xe9charg\xe9s et ex\xe9cut\xe9s int\xe9gralement sur cet appareil."}},"create":{"title":"Cr\xe9er","description":"G\xe9n\xe9ration de texte intelligente et dict\xe9e. Je r\xe9dige des e-mails, des documents, du code et du contenu cr\xe9atif, et je transforme votre parole en texte format\xe9 compatible avec toutes les applications.","locked":"Activez les fonctionnalit\xe9s d\'IA ci-dessus et Create est pr\xeat \xe0 l\'emploi."},"automate":{"title":"Automatiser","description":"Flux de travail IA. D\xe9crivez une t\xe2che en une phrase et je planifierai et ex\xe9cuterai chaque \xe9tape \u2014 lecture, \xe9criture et ex\xe9cution de commandes pour vous.","locked":"Activez les fonctionnalit\xe9s d\'IA ci-dessus et Automate est pr\xeat \xe0 l\'emploi."},"status":{"on":"Sur","off":"Ne s\'enfuira pas"},"footer":"Tout s\'ex\xe9cute sur l\'appareil. Rien de ce que vous cr\xe9ez ou automatisez ne quitte votre machine.","cta":{"eyebrow":"Vous pouvez activer l\'IA \xe0 tout moment.","title":"Voyons comment cela fonctionne dans vos applications","action":"Voyez-moi en action","back":"Dos"},"pill":"{{license}} D\xe9verrouill\xe9","title":"Vous avez \xe9t\xe9 mis \xe0 niveau vers {{license}}."}}');


var $155a07bb3e087efa$exports = {};
$155a07bb3e087efa$exports = JSON.parse('{"logo":"Logo Cefabile","add":"Aggiungere","all":"Tutto","edit":"Modificare","create":"Creare","delete":"Eliminare","previous":"Precedente","next":"Prossimo","search":"Ricerca","loading":"Caricamento...","reload":"Ricaricare","cancel":"Cancellare","copy":"Copia","save":"Salva","saveAndFinish":"Salva e termina","saveAndContinue":"Salva e continua","saved":"Salvato","done":"Fatto","back":"Indietro","play":"Giocare","pause":"Pausa","success":"Successo","continue":"Continuare","options":"Opzioni","share":"Condividere","finish":"Fine","finishEdit":"Fine Modifica","advancedOptions":"Visualizza opzioni avanzate","authenticating":"Autenticazione in corso...","skipToMain":"Vai al contenuto principale","skip":"Saltare","close":"Vicino","notFound":"Pagina non trovata","notFoundDescription":"Oh no! Abbiamo cercato nel mare e non riusciamo a trovare la pagina!","exitSetup":"Esci dalla configurazione","experimental":"Sperimentale","letGetStarted":"Cominciamo!","exploreInputControls":"Esplora i controlli di input","when":"Quando io...","thenMacro":"Cephable correr\xe0...","controls":"Controlli","welcome":"Benvenuto.","beta":"beta","macroEmpty":"Non ci sono macro che corrispondono a questi criteri.","you":"Voi","step":"Fare un passo","steps":"Passi","learnMore":"Saperne di pi\xf9","dangerZone":"Zona pericolosa","connected":"Collegato","notConnected":"Non connesso","connectAndLearn":"Connettiti e impara","tryAgain":"Riprova","by":"Di: {{value}}","noName":"- nessun nome -","details":"Dettagli","controlFeed":"Controllo Feed","mobileApp":{"title":"Applicazione mobile"},"dashboard":{"title":"Pannello di controllo"},"wifi":{"disconnected":"Il Wi-Fi \xe8 disconnesso.","connected":"La connessione Wi-Fi \xe8 attiva.","description":"Connettiti al Wi-Fi per consentire a Cephable di funzionare con le tue connessioni e il tuo software. Potresti avere una capacit\xe0 limitata di utilizzare i tuoi controlli attuali."},"signalR":{"disconnected":"La sincronizzazione \xe8 interrotta.","action":"Riconnetti","description":"Sembra esserci un problema con la sincronizzazione di Cephable. Ci\xf2 causer\xe0 problemi nel salvataggio delle impostazioni o nella comunicazione con altre connessioni.","disconnectedDevice":"Impossibile sincronizzare con {{name}}.","disconnectedDeviceDescription":"Sembra che ci sia un problema di sincronizzazione dovuto all\'autenticazione o alla connettivit\xe0 Internet. Non \xe8 possibile inviare o ricevere dati in remoto. \xc8 necessario controllare entrambi i lati della connessione.","connected":"La sincronizzazione \xe8 connessa.","connectedDescription":"Cephable si sincronizza correttamente e dovrebbe comunicare con le tue connessioni ed estensioni come previsto.","swap":"Passa alla connessione del dispositivo locale","unlinkedDevice":"Connessione rimossa.","unlinkedDeviceDescription":"Questa connessione \xe8 stata scollegata dal tuo account.","featureRestricted":"Le funzionalit\xe0 Crea e automatizza non sono disponibili per le connessioni remote.","featureRestrictedDescription":"Questa funzionalit\xe0 non \xe8 attualmente disponibile per le connessioni remote. Passa alla connessione al dispositivo locale per sfruttare appieno le potenzialit\xe0 di creazione e automazione del tuo lavoro."},"billing":{"title":"Fatturazione","expires":"Prossima fatturazione: {{value}}","isEmployeeAccess":{"title":"Professionale","titleLong":"Professionista Cephable","short":"Professionista","description":"Cephable Professional offre agli utenti maggiore produttivit\xe0, estendendo l\'intelligenza artificiale locale e privata alle capacit\xe0 generative.","supportedFeatures":{"tag":"Tutto in Plus, plus","features":["Flussi di lavoro di intelligenza artificiale su dispositivo","Gestione dell\'organizzazione aziendale","restrizioni aziendali","Installazioni illimitate su diversi dispositivi.","Controlli dell\'app pre-addestrati illimitati"]}},"isDeveloperAccess":{"title":"Kit di sviluppo software","titleLong":"SDK cefalico","short":"Kit di sviluppo software","description":"Gli SDK di Cephable consentono di integrare potenti controlli adattivi (voce, viso, testa e altro) nel software con un impatto minimo e il massimo vantaggio.","supportedFeatures":{"tag":"Tutto in Plus, plus","features":["Supporto per Windows e MacOS","SDK leggeri e integrabili per input vocali, facciali, oculari e di azioni rapide offline","Supporto API/webhook per azioni di output personalizzate","Documentazione per sviluppatori","Progetti campione","Trasforma i comandi in automazione e navigazione dei documenti","Portale per sviluppatori per la gestione di progetti, client di autorizzazione, tipi di dispositivi e altro ancora"]}},"isStudentAccess":{"title":"Studente","titleLong":"Istruzione Cefabile","short":"Edu","description":"Cephable Education supporta l\'apprendimento personalizzato e le classi inclusive. Cephable funziona offline, funziona su dispositivo e non richiede integrazioni di terze parti.","supportedFeatures":{"tag":"Tutto in Plus, plus","features":["Installazioni di dispositivi illimitate","Controlli app pre-addestrati illimitati","Condivisione illimitata dei controlli delle app personalizzate"]}},"viewProducts":"Visualizza i prodotti","description":"Gestisci la fatturazione, i posti, gli upgrade degli abbonamenti, i rinnovi o le cancellazioni della tua organizzazione.","view":"Gestisci la fatturazione","isResellerAccess":{"title":"Rivenditore","titleLong":"Rivenditore Cephable","description":"Cephable Reseller \xe8 una licenza a pagamento che ti consente di creare nuove organizzazioni e assegnare chiavi di licenza. Ci\xf2 include l\'utilizzo di Cephable con la tua suite software e il miglioramento della tua esperienza utente.","short":"Rivenditore"},"error":"Contatta l\'amministratore di sistema per gestire la fatturazione.","included":"Incluso nella tua licenza {{licenseType}}.","upgrade":{"description":"Esegui subito l\'aggiornamento e porta i tuoi controlli a un livello superiore.","action":"Aggiorna ora","error":"Errore durante l\'aggiornamento. Riprova pi\xf9 tardi.","requiredDetail":"Per questa funzionalit\xe0 \xe8 richiesta una licenza {{licenseType}}. Puoi sempre effettuare l\'upgrade o iniziare una prova gratuita nelle Impostazioni Account.","enableTextGeneration":"Genera contenuti utilizzando l\'intelligenza artificiale e la tua voce.","longDescription":"Passa a una licenza a pagamento per sbloccare tutte le funzionalit\xe0 di Cephable. Dalla gestione di pi\xf9 dispositivi, ai controlli avanzati, alle integrazioni personalizzate, Cephable ha tutto ci\xf2 che ti serve per raggiungere il livello successivo di produttivit\xe0.","compare":"Confronta i piani","enableAiDictation":{"title":"Passa alla dettatura intelligente","description":"Esegui l\'upgrade per sbloccare la dettatura avanzata dell\'IA. Posso aggiungere punteggiatura, correggere le maiuscole e adattarmi al tuo stile, in modo che la tua scrittura risulti impeccabile senza sforzi aggiuntivi."},"enableAiWorkflows":"Aggiorna il tuo sistema per automatizzare le attivit\xe0 del desktop e del browser con i flussi di lavoro basati sull\'intelligenza artificiale."},"isPlusAccess":{"title":"Pi\xf9","titleLong":"Cephable Plus","short":"Pi\xf9","description":"Cephable Plus \xe8 pensato per gli utenti esperti che desiderano ottenere di pi\xf9 grazie a voce intelligente, dettatura intelligente, centinaia di controlli delle app e molto altro.","supportedFeatures":{"tag":"Tutto ci\xf2 che \xe8 in Basic, pi\xf9","features":["Comandi vocali intelligenti (linguaggio naturale)","Dettatura intelligente (potenziata dall\'IA)","Compiti intelligenti (Generazione, Traduzione, Riscrittura)","Centinaia di controlli per app pre-addestrati"]}},"personal":{"short":"Di base","title":"Di base","titleLong":"Cephable Basic","description":"Cephable Basic \xe8 gratuito per sempre ed \xe8 progettato per aiutarti a muoverti pi\xf9 velocemente, a esprimerti e a portare a termine i tuoi progetti, a modo tuo. Le funzionalit\xe0 incluse nella versione Basic sono disponibili per tutti gli utenti.","upgrade":{"title":"Porta i tuoi controlli a un livello superiore","description":"Passa a Plus o Pro per sbloccare tutte le mie funzionalit\xe0. Pi\xf9 precisione. Pi\xf9 connessioni. Pi\xf9 controlli. Pi\xf9 potenza per portare la tua produttivit\xe0 a un livello superiore.","featureHeading":"Ecco come posso aiutarti:","control":"Ti guido pi\xf9 velocemente tra app e strumenti usando la tua voce o azioni rapide, senza interruzioni. Con Intelligent Voice possiamo semplicemente chattare.","create":"Riscrivo, dettato, genero e traduco direttamente all\'interno delle tue app, senza dover copiare, incollare o cambiare schermata.","automate":"Eseguo attivit\xe0 intelligenti e azioni rapide che velocizzano il tuo flusso di lavoro. Dai comandi pi\xf9 semplici alle macro pi\xf9 complesse, posso occuparmi del lavoro pi\xf9 impegnativo, cos\xec puoi concentrarti sul lavoro che conta davvero.","local":"Tutta IA locale. Nessuna elaborazione cloud."}},"mostPopular":"I pi\xf9 popolari","subscription":{"options":"Opzioni di abbonamento","monthly":"Paga mensilmente","billedMonthly":"/mese","yearly":"Paga annualmente","billedYearly":"/anno"}},"organization":{"title":"Organizzazione","titlePlural":"Organizzazioni","titleLong":"Cephable Professional per le organizzazioni","description":"Le organizzazioni sono gruppi di utenti che possono collaborare a progetti e condividere risorse. Qui puoi gestire il tuo team, i profili del team, la fatturazione e altro ancora.","noAccess":{"title":"Accesso negato.","description":"I tuoi permessi sono cambiati di recente e non hai pi\xf9 accesso a questa funzionalit\xe0. Se ritieni che si tratti di un errore, contatta l\'amministratore della tua organizzazione."},"noOrg":{"title":"Nessuna licenza associata.","description":"Al momento non sei associato a una licenza o a un gruppo di sviluppatori. L\'accesso al portale \xe8 riservato agli utenti con una licenza Cephable a pagamento. Per sfruttare appieno il potenziale di Cephable, inizia una prova gratuita senza rischi."},"member":{"title":"Membro","titlePlural":"Membri","me":"La mia iscrizione","description":"I membri sono utenti che fanno parte della tua organizzazione. Possono essere assegnati a ruoli diversi e avere accesso a parti diverse dell\'organizzazione.","edit":"Modifica membri","removed":"Sei stato rimosso da una squadra.","removedDescription":"Sei stato rimosso dal team. Non puoi pi\xf9 accedere all\'organizzazione. Se ritieni che si tratti di un errore, contatta l\'amministratore della tua organizzazione.","updated":"Riuscito, l\'iscrizione di {{value}} \xe8 stata aggiornata.","error":"Errore durante l\'aggiornamento dell\'iscrizione a {{value}}.","delete":"Riuscito, {{value}} \xe8 stato rimosso.","deleteError":"Errore durante la rimozione di {{value}}.","deleteConfirmation":{"title":"Sei sicuro di voler rimuovere questo membro?","description":"Una volta rimosso questo membro, non avr\xe0 pi\xf9 accesso all\'organizzazione. Puoi sempre invitarlo di nuovo in seguito.","confirm":"S\xec, rimuovi membro"},"viewAll":{"title":"Visualizza tutti i membri","description":"Visualizza tutti i membri della tua organizzazione e gestisci i loro ruoli e autorizzazioni."},"seats":{"title":"Posti dei membri","description":"Ogni membro della tua organizzazione conta come un posto. Il tipo di permessi che hanno pu\xf2 essere modificato dall\'amministratore dell\'organizzazione.","stats":"posti su {{value}}","max":"Posti massimi","current":"Posti attuali","limit":{"title":"Raggiunto il numero massimo di posti","description":"Il tuo piano attuale ha raggiunto il limite di {{ maxSeats }} posti disponibili. Non puoi invitare altri membri. Contatta il tuo amministratore per aggiornare il piano o gestire l\'assegnazione dei posti."},"updateLimit":{"title":"Aggiorna il tuo piano per aggiungere pi\xf9 posti","description":"Il tuo piano attuale ha raggiunto il numero massimo di posti: {{ maxSeats }}. Esegui l\'upgrade ora per sbloccare posti aggiuntivi e garantire che il tuo team possa continuare a crescere senza problemi.","action":"Piano di aggiornamento"},"maxSeatValue":"Numero massimo di posti: {{value}}"},"aboutMe":"Su di me","loadError":"Errore durante il caricamento dei membri dell\'organizzazione.","orgTitle":"Membri di {{value}}","emailExists":"L\'email esiste gi\xe0 nell\'organizzazione. Inserisci un indirizzo email diverso."},"invite":{"title":"Invitare","titlePlural":"Invita","description":"Gli inviti vengono inviati agli utenti per unirsi alla tua organizzazione. Puoi invitare gli utenti a unirsi alla tua organizzazione e assegnare loro ruoli diversi.","edit":"Aggiungi un membro","view":"Visualizza tutti gli inviti","viewDescription":"Visualizza tutti gli inviti attuali che non sono stati accettati.","new":"Invita un membro","emailRequired":"L\'email \xe8 obbligatoria","emailInvalid":"L\'email non \xe8 valida. Inserisci un indirizzo email valido.","emailExists":"L\'email ha gi\xe0 un invito dell\'organizzazione. Inserisci un indirizzo email diverso.","emailPlaceholder":"Inserisci l\'indirizzo email","expiration":"Scade","delete":"Elimina invito","confirm":"Sei sicuro di voler rimuovere questo invito?","confirmLong":"Una volta eliminato questo invito, l\'utente non potr\xe0 pi\xf9 unirsi all\'organizzazione. Puoi sempre invitarlo di nuovo in seguito.","accept":"Accetta invito","stat":"inviti attivi","noInvites":{"title":"Nessun invito.","description":"Sembra che non ci siano inviti attivi per la tua organizzazione."},"acceptSuccess":{"title":"Benvenuti nel team.","description":"Ti sei unito con successo all\'organizzazione.","action":"Visualizza la tua nuova organizzazione"},"acceptError":{"title":"Oops. Sembra che ci sia un problema.","description":"Si \xe8 verificato un errore durante l\'adesione all\'organizzazione. Riprova pi\xf9 tardi. Se il problema persiste, contatta l\'amministratore della tua organizzazione.","action":"Torna alla homepage"},"send":{"success":"Invito a {{value}} inviato.","error":"Errore durante l\'invio dell\'invito a {{value}}.","title":"Invia invito"},"error":"Errore durante il caricamento degli inviti.","orgTitle":"Inviti di {{value}}","editDescription":"Crea un nuovo invito per un utente affinch\xe9 si unisca alla tua organizzazione.","scimManaged":{"title":"I membri vengono gestiti dal tuo provider di identit\xe0","description":"Questa organizzazione utilizza il provisioning automatico (SCIM), pertanto l\'appartenenza ai membri \xe8 controllata dal vostro sistema di identit\xe0 interno. Aggiungendo o rimuovendo persone da l\xec, la modifica viene sincronizzata automaticamente con Cephable; non \xe8 possibile inviare inviti dal portale."}},"role":{"title":"Ruolo","titlePlural":"Ruoli","description":"I ruoli sono i diversi livelli di accesso che un utente pu\xf2 avere nella tua organizzazione. Puoi assegnare ruoli diversi agli utenti per controllare cosa possono fare."},"isAdmin":{"title":"Amministratore","description":"Gli amministratori hanno pieno accesso all\'organizzazione e possono gestirne tutti gli aspetti.","conflict":"Questo membro \xe8 un amministratore. Non hai l\'autorizzazione per modificare i suoi ruoli."},"canViewMembers":{"title":"Visualizza i membri","description":"Gli utenti con questa autorizzazione possono visualizzare tutti i membri dell\'organizzazione."},"canInviteMembers":{"title":"Invita i membri","description":"Gli utenti con questa autorizzazione possono invitare nuovi membri all\'organizzazione e gestire gli inviti esistenti."},"canChangeMemberPermissions":{"title":"Cambia i ruoli dei membri","description":"Gli utenti con questa autorizzazione possono modificare il ruolo degli altri membri dell\'organizzazione."},"canRemoveMembers":{"title":"Rimuovi membri","titleSingle":"Rimuovi membro","action":"Rimuovere","description":"Gli utenti con questa autorizzazione possono rimuovere altri membri dall\'organizzazione.","confirm":"Vuoi davvero rimuovere questo membro dall\'organizzazione?","confirmLong":"Una volta rimosso questo membro, non avr\xe0 pi\xf9 accesso all\'organizzazione. Puoi sempre invitarlo di nuovo in seguito."},"canCreateAuthClients":{"title":"Crea progetti","description":"Gli utenti con questa autorizzazione possono creare nuovi client di autenticazione e progetti per l\'organizzazione."},"canManageBilling":{"title":"Gestisci la fatturazione","description":"Gli utenti con questa autorizzazione possono gestire le impostazioni di fatturazione per l\'organizzazione.","error":"Non hai l\'autorizzazione per gestire la fatturazione per questa organizzazione."},"metrics":{"title":"Metrica","description":"Le metriche sono punti dati che ti aiutano a capire come la tua organizzazione utilizza Cephable.","view":"Visualizza le metriche","lineChart":{"title":"Connessioni simultanee medie","description":"Questo grafico mostra la media delle connessioni contemporanee per i dati dell\'organizzazione e del progetto nel tempo.","max":"Numero massimo di connessioni: {{maxConnections}}","project":"Totale del progetto","org":"Organizzazione Totale"},"orgTitle":"Metriche di {{value}}","manage":{"title":"Metriche delle prestazioni","description":"Scarica o cancella le metriche delle prestazioni raccolte durante l\'inferenza del modello."},"download":{"button":"Scarica le metriche","success":"Il file delle metriche \xe8 stato salvato nella cartella Download.","error":"Impossibile scaricare il file delle metriche.","noFile":"Nessun file di metriche trovato. Prova prima a eseguire il modello."},"clear":{"button":"Metriche chiare","success":"Le metriche sono state cancellate.","error":"Impossibile cancellare il file delle metriche.","confirm":{"title":"Metriche di prestazione chiare","description":"Vuoi davvero cancellare tutte le metriche delle prestazioni registrate? Questa azione non pu\xf2 essere annullata.","cancel":"Cancellare","confirm":"Metriche chiare"}}},"projects":{"title":"Progetti","description":"Utilizza Progetti per gestire l\'accesso sicuro, configurare le interazioni con i dispositivi e semplificare il modo in cui le tue app inviano e ricevono comandi su diverse piattaforme.","name":"Nome dell\'app","view":"Visualizza i progetti","error":"Errore durante il caricamento dei progetti.","stats":{"title":"Statistiche del progetto","connections":"Connessioni totali","all":{"title":"Tutte le metriche del progetto","description":"Metriche aggregate per tutti i progetti associati a {{ orgName }}"},"card":"progetti su {{value}}","users":"utenti totali da {{date}}","avgUsers":"utenti medi mensili.","concurrent":{"title":"Media delle connessioni contemporanee negli ultimi {{days}} giorni","label":"Media simultanea","max":"Numero massimo di connessioni","overage":"Eccedenza","description":"Le connessioni simultanee sono il numero di utenti connessi al tuo progetto contemporaneamente. Questa metrica ti aiuta a capire quanti utenti stanno utilizzando la tua app contemporaneamente."}},"projectType":{"title":"Tipo di progetto","description":"I tipi di progetto vengono utilizzati per categorizzare i tuoi progetti e aiutarci a scegliere gli SDK pi\xf9 adatti a te."},"accessDenied":{"generic":"Non hai accesso a questo progetto.","title":"Accesso negato.","description":"Non hai accesso per visualizzare, creare, modificare o eliminare progetti. Contatta il tuo amministratore per ottenere l\'accesso."},"upgrade":{"title":"Aggiorna a Cephable SDK","description":"Cephable pu\xf2 essere integrato direttamente nella tua app, gioco o servizio usando i nostri SDK. I progetti non sono attualmente disponibili con il tuo account. Se pensi che ci sia un errore, contatta support@cephable.com.","shortDescription":"I progetti non sono attualmente disponibili con il tuo account. Contattaci per effettuare l\'upgrade."},"limit":{"title":"Vuoi altri progetti?","error":"Limite del progetto raggiunto.","description":"Hai raggiunto il numero massimo di progetti per la tua organizzazione. Contatta il tuo amministratore per aggiornare il tuo account."},"create":{"title":"Crea progetto","titleLong":"Cominciamo.","first":{"title":"Inizia il tuo progetto.","description":"Sembra che tu non abbia ancora creato un progetto. Le chiavi client e i dispositivi sono essenziali per proteggere la comunicazione tra le tue applicazioni e i nostri servizi. Con una chiave client, sarai in grado di integrare i controlli vocali e di movimento della testa nelle tue app in modo rapido e sicuro."},"details":{"title":"Dettagli del progetto","description":"Crea un nuovo progetto per gestire l\'autorizzazione della tua applicazione, le capacit\xe0 del dispositivo e le integrazioni SDK. Segui i passaggi sottostanti per impostare interazioni sicure e personalizzabili per i tuoi utenti."}},"sdk":{"title":"Scarica l\'SDK","description":"Accedi al nostro potente SDK sviluppato per semplificare i controlli adattivi.","select":{"title":"Seleziona SDK","description":"Seleziona l\'SDK che desideri utilizzare per questo progetto. I nostri SDK consentono un\'integrazione fluida di controlli vocali e di movimento della testa adattivi su diverse piattaforme."}},"clients":{"title":"Autorizzazione Clienti","configure":"Configurare il client di autorizzazione","description":"I client di autorizzazione gestiscono l\'accesso sicuro per le tue applicazioni. Definisci un client di autorizzazione per autenticare gli utenti e controllare le interazioni con la tua applicazione.","settings":"Impostazioni di autorizzazione","create":"Crea client di autorizzazione","max":"Progetti massimi: {{value}}"},"secret":{"title":"Segreto del cliente","created":"Il tuo segreto client \xe8 stato creato.","description":"Il tuo segreto client verr\xe0 mostrato solo una volta. Copialo ora e conservalo in un luogo sicuro.<br> <br> Utilizzalo solo per il tuo sviluppo personale. Non condividerlo con servizi o applicazioni di terze parti.","copy":"Copia segreto","rotate":{"title":"Ruota il segreto del cliente","description":"ATTENZIONE: questa azione revocher\xe0 il tuo segreto client esistente e ne creer\xe0 uno nuovo. Ci\xf2 richieder\xe0 di aggiornare tutto il tuo utilizzo esistente attraverso le tue app. Questa azione non pu\xf2 essere annullata.","error":"Errore durante la rotazione del segreto. Riprova pi\xf9 tardi."}},"key":{"title":"Chiave del cliente","view":"Visualizza la chiave del cliente","copy":"Copia chiave","delete":{"title":"Elimina la chiave client","description":"ATTENZIONE: questa azione rimuover\xe0 la chiave client esistente e tutte le impostazioni correlate. Questa azione non pu\xf2 essere annullata.","error":"Errore durante l\'eliminazione della chiave client.","success":"Il tuo progetto \xe8 stato eliminato."}},"tokenRedirect":{"title":"URL di reindirizzamento del token","description":"Gli URL di reindirizzamento token sono gli endpoint in cui vengono inviati i token di accesso dopo il completamento dell\'autenticazione. Questi URL consentono alla tua applicazione di ricevere in modo sicuro i token necessari per accedere ai dati e ai servizi utente."},"authRedirect":{"title":"URL di reindirizzamento del codice di autorizzazione","description":"L\'URL di reindirizzamento AuthCode \xe8 l\'endpoint in cui vengono inviati i codici di autorizzazione dopo che un utente concede l\'autorizzazione alla tua applicazione. Questo URL \xe8 essenziale nei flussi OAuth, poich\xe9 garantisce la trasmissione sicura del codice di autorizzazione dal server di autorizzazione alla tua app, consentendoti di richiedere token di accesso per conto dell\'utente."},"scopes":{"title":"Ambiti","configure":"Definisci gli ambiti","titleLong":"Ambiti di autorizzazione API","description":"Gli ambiti definiscono i permessi che questo client di autorizzazione avr\xe0. Imposta gli ambiti per limitare l\'accesso a dati e funzionalit\xe0 specifici, assicurando che gli utenti ottengano solo l\'accesso di cui hanno bisogno.","manage":"Gestisci gli ambiti di autorizzazione"},"type":{"title":"Tipo di implementazione"},"deviceScopes":{"title":"Tipi di dispositivi associati","titleLong":"Tipi di dispositivi consentiti","configure":"Configurare i tipi di dispositivi consentiti","action":"Aggiungi nuovo tipo di dispositivo","descriptionShort":"Definisci quali tipi di dispositivi possono accedere a questo progetto.","titles":"Tipi di dispositivi associati","description":"Il tipo di dispositivo definisce i permessi e i livelli di accesso che un dispositivo ha all\'interno della tua applicazione. Assegnando tipi di dispositivi specifici, puoi controllare le azioni e i dati a cui ogni dispositivo pu\xf2 accedere, assicurandoti che la tua applicazione rimanga sicura e conforme alle tue policy sulla privacy."},"deviceType":{"title":"Tipi di dispositivi","description":"Un DeviceType definisce una categoria di dispositivi, specificandone le capacit\xe0 di input/output e le funzionalit\xe0 supportate (ad esempio, voce, gesti, tipi di controller). Garantisce che solo i dispositivi autorizzati possano interagire con un\'applicazione.","action":"Crea tipo di dispositivo","name":"Nome del tipo di dispositivo","descriptionLong":"Descrizione del tipo di dispositivo","features":{"title":"Supporta le funzionalit\xe0","description":"Definisci gli input e gli output supportati dalla tua app. Questo ci aiuta a ottimizzare l\'esperienza utente su Cephable.","supportsVoiceInput":"Input vocale","supportsPhysicalInput":"Ingresso fisico","supportsKeyboardOutput":"Uscita tastiera","supportsPlayStationControllerOutput":"Controllore della PlayStation","supportsFaceInput":"Input facciale","supportsGestureInput":"Input gestuale","supportsXboxControllerOutput":"Controllore Xbox","supportsDigitalExtensions":"Estensioni digitali","supportsPhysicalExtensions":"Estensioni fisiche","supportsNintendoControllerOutput":"Controllore Nintendo","supportsGenericControllerOutput":"Uscita del controller generico"},"canAutoStart":{"title":"Supporta l\'avvio del controllo automatico","description":"[canAutoStart] se abilitato, gli SDK controlleranno le impostazioni utente e tenteranno di avviare immediatamente i controlli della telecamera o del microfono dopo l\'accesso dell\'utente."},"isSupported":{"title":"Attivo","description":"[isSupported] Se disabilitato, Cephable non invier\xe0, ricever\xe0 o riconoscer\xe0 pi\xf9 alcun dispositivo utente associato a questo. Equivale a deprecato."},"locale":{"title":"Lingua predefinita","description":"[defaultLocale] Le impostazioni locali predefinite per questo tipo di dispositivo. Verranno utilizzate come lingua predefinita per il dispositivo.","support":"Supporta le lingue","warn":"** Sembra che tu abbia impostato i Controlli personalizzati. Assicurati di aver aggiornato i controlli personalizzati per le lingue associate.**","name":"{{lang}} - Nome del tipo di dispositivo","langDescription":"{{lang}} - Descrizione"},"customControls":{"title":"Controlli personalizzati","object":"{{lang}} - Oggetto controlli personalizzati","description":"I controlli personalizzati sono un\'opzione avanzata che consente agli utenti di impostare e modificare manualmente i controlli delle app associati a questo dispositivo. Se desideri che gli utenti controllino il tuo dispositivo direttamente da Cephable, devi registrare i controlli del tuo dispositivo qui. Consulta Cephable API per i dettagli completi sulle opzioni.","addControl":"Aggiungi controllo","empty":"Nessun controllo personalizzato disponibile al momento. Utilizza \\"Aggiungi controllo\\" per crearne il primo.","untitled":"Controllo senza titolo","controlId":"ID di controllo","controlIdHelp":"Identificativo univoco per questo controllo. Impostalo prima di salvare: non potr\xe0 essere modificato in seguito.","fallback":"Ricaderci","controlName":"Nome di controllo","controlDescription":"Codice di controllo","defaultCommandsLabel":"Comandi vocali predefiniti","defaultCommandsHelp":"Questi sono i comandi vocali predefiniti visualizzati dagli utenti per questo controllo nella lingua corrente.","sharedAcrossLanguages":"Condiviso in tutte le lingue","sharedAcrossLanguagesHelp":"La modifica di questi campi aggiorna il valore per tutte le lingue contemporaneamente.","iconUrl":"URL dell\'icona","contextGroupName":"Gruppo di contesto","isProfileControl":"Controllo del profilo","isPrefixVoiceCommand":"Prefisso Comando vocale","allowWhenDictating":"Consenti durante la dettatura","allowsHold":"Consente di tenere premuto","isDeprecated":"Deprecato","requiresEmployeeAccess":"Richiede l\'accesso del dipendente","requiresStudentAccess":"Richiede l\'accesso per studenti","requiresGenericLicense":"Richiede licenza generica","requiresPlusAccess":"Richiede l\'accesso Plus","allIncomplete":"Tutte le impostazioni locali presentano controlli personalizzati incompleti. Completare almeno una impostazione locale prima di salvare.","savedWithIncomplete":"Salvato. Impostazioni locali dei controlli personalizzati incomplete non salvate: {{incompleteLocales}}"},"success":{"title":"Successo!","description":"Hai creato un nuovo tipo di dispositivo. {{name}} Ora puoi aggiornare l\'ambito del dispositivo client di autorizzazione in base alle tue esigenze."},"id":"ID tipo dispositivo","throttleRules":{"title":"Regole del comando dell\'acceleratore","description":"Configurare le regole di limitazione per controllare il flusso dei comandi e le restrizioni di input per questo tipo di dispositivo.","disableVoiceInput":"Disabilita l\'input vocale","disableHotkeyInput":"Disabilita l\'input tramite tasti di scelta rapida","disableCameraInput":"Disabilita l\'input della telecamera","disableMultiInputs":"Disabilitare pi\xf9 input","maximumCommandsPerSecond":"Comandi massimi al secondo","maximumCommandsPerMinute":"Comandi massimi al minuto","maximumMacroLength":"Lunghezza massima della macro","jitter":{"title":"Jitter temporale","description":"Aggiungi variazioni casuali alla durata delle pressioni prolungate e delle pause per creare schemi di input pi\xf9 naturali.","holdTimeJitterMin":"Variazione del tempo di mantenimento Min (ms)","holdTimeJitterMax":"Variazione massima del tempo di mantenimento (ms)","pauseTimeJitterMin":"Variazione del tempo di pausa Min (ms)","pauseTimeJitterMax":"Variazione massima del tempo di pausa (ms)"},"incompatibleActions":{"title":"Gruppi di azione incompatibili","description":"Definisci gruppi di azioni che non possono coesistere nella stessa macro.","addGroup":"Aggiungi gruppo","removeGroup":"Rimuovi gruppo","addAction":"Aggiungi azione","removeAction":"Rimuovi azione","reason":"Motivo","reasonPlaceholder":"Perch\xe9 queste azioni sono incompatibili","eventType":"Tipo di evento","key":"Chiave","customActionId":"ID azione personalizzata","emptyGroup":"Nessuna azione in questo gruppo. Aggiungi almeno due azioni."},"requiredPause":{"title":"Pausa necessaria tra le azioni","description":"Definisci coppie di azioni che richiedono una pausa minima tra di loro nella stessa macro.","addRule":"Aggiungi regola","removeRule":"Rimuovi regola","actionA":"Azione A","actionB":"Azione B","minimumPause":"Pausa minima (ms)","bidirectional":"Bidirezionale","bidirectionalHelp":"Quando abilitata, la pausa \xe8 necessaria in entrambe le direzioni (A\u2192B e B\u2192A)."},"macroStepRules":{"title":"Regole macro per i passaggi","holdTimeJitterMin":"Jitter di mantenimento Min (ms)","holdTimeJitterMax":"Jitter massimo di mantenimento (ms)"}}},"originHost":{"title":"Origine Host","description":"L\'URL che funger\xe0 da fonte primaria per le richieste e i dati durante le interazioni API."},"orgTitle":"Progetti di {{value}}"},"viewOrganization":"Visualizza Organizzazione","update":"La tua organizzazione \xe8 stata aggiornata! Aggiornamento dell\'app.","error":"Errore durante il caricamento dell\'organizzazione. Riprova pi\xf9 tardi.","new":{"name":{"label":"Nome dell\'organizzazione","placeholder":"Inserisci il nome della tua organizzazione"},"description":{"label":"Descrizione dell\'organizzazione","placeholder":"Quali sono i tuoi obiettivi con Cephable Professional?"},"details":"Dettagli dell\'organizzazione"},"expired":{"user":"Sembra che la tua licenza Cephable sia scaduta, quindi sei stato declassato alla versione gratuita Cephable Basic. Per rinnovarla, contatta l\'amministratore della tua organizzazione.","admin":"Sembra che la tua licenza Cephable sia scaduta, quindi sei stato declassato alla versione gratuita Cephable Basic. Rinnova la licenza per continuare a utilizzare le funzionalit\xe0 avanzate oltre a Cephable Basic.","multiple":"Sembra che le tue licenze Cephable siano scadute, quindi sei stato declassato alla versione gratuita Cephable Basic. Rinnova almeno una delle tue licenze per continuare a utilizzare le funzionalit\xe0 avanzate oltre a Cephable Basic.","dialog":{"title":"Seleziona un\'organizzazione","description":"Hai pi\xf9 organizzazioni associate al tuo account. Seleziona l\'organizzazione che desideri rinnovare."},"title":"La tua licenza Cephable \xe8 scaduta","titlePlural":"Le tue licenze Cephable sono scadute","banner":"Sembra che la tua licenza Cephable sia scaduta, quindi sei passato alla versione gratuita Cephable Basic. Rinnovandola, avrai accesso a funzionalit\xe0 come controlli vocali avanzati, attivit\xe0 intelligenti basate sull\'intelligenza artificiale e molti controlli predefiniti per le app."},"orgName":"Nome dell\'organizzazione","menu":{"title":"Menu Organizzazione","view":"Visualizza il menu","expand":"Espandi Menu"},"settings":{"title":"Impostazioni dell\'organizzazione","description":"Gestisci la fatturazione, il nome, la descrizione e le risorse della tua organizzazione.","view":"Visualizza impostazioni","general":{"title":"Generale"},"resources":{"edit":"Modifica risorse","description":"Utilizza l\'editor Markdown sulla sinistra per aggiornare e formattare risorse utili per tutti i membri dell\'organizzazione. Mentre digiti, l\'anteprima sulla destra mostrer\xe0 come il tuo contenuto apparir\xe0 agli utenti. Puoi aggiungere titoli, elenchi, link e altri elementi di formattazione utilizzando la sintassi Markdown. Le modifiche saranno visibili ai membri una volta salvate."},"other":{"title":"Altre impostazioni","description":"Gestisci la fatturazione, il nome, la descrizione e le risorse della tua organizzazione."},"managed":{"title":"Gestito da Cephable","description":"Questi controlli sono impostati da Cephable per la tua organizzazione. Vengono visualizzati qui per consentirti di verificarne i valori attuali e non possono essere modificati dal portale.","email":{"title":"Consegna email Cephable","allowedDescription":"Cephable potrebbe inviare email ai membri di questa organizzazione, ad esempio inviti, verifiche e richieste di reimpostazione della password.","blockedDescription":"Cephable non invia email ai membri di questa organizzazione. Inviti, verifiche, reimpostazioni password, link magici, email di benvenuto e email sui prodotti sono tutti bloccati."},"scim":{"title":"Gestione automatica dei membri (SCIM)","description":"Il tuo provider di identit\xe0 crea e rimuove i membri di questa organizzazione. Non \xe8 possibile inviare inviti tramite il portale."},"lockedNote":"Solo Cephable pu\xf2 modificare queste impostazioni. Contatta il tuo referente Cephable se \xe8 necessario aggiornare un valore."}},"managed":{"title":"Organizzazione gestita","titlePlural":"Organizzazioni gestite","description":"Le organizzazioni gestite sono organizzazioni gestite da un rivenditore Cephable. I rivenditori possono gestire il tuo team, i profili del team, la fatturazione e altro qui.","error":"Errore durante il caricamento delle organizzazioni gestite.","empty":{"title":"Nessuna organizzazione gestita trovata.","description":"Sembra che non ci siano organizzazioni gestite che corrispondono a questo criterio. Oppure le tue chiavi di licenza non sono ancora state attivate."},"titleShort":"Gestito"},"canManageChildOrganizations":{"title":"Gestire le organizzazioni secondarie","description":"Gli utenti con questa autorizzazione possono creare e gestire organizzazioni figlio come amministratori."},"canViewAnalytics":{"title":"Visualizza analisi","description":"Gli utenti con questa autorizzazione possono visualizzare le metriche e le analisi per l\'organizzazione."},"create":"Crea nuova organizzazione","orgCustomBillingUrl":{"title":"URL di fatturazione personalizzato","description":"Questo \xe8 un URL personalizzato che verr\xe0 utilizzato per reindirizzare l\'utente al tuo sistema di fatturazione (del rivenditore). Dovrebbe iniziare con \'https://\' o \'mailTo:\'"},"upgrade":{"existing":{"title":"Fai parte di una licenza esistente.","description":"Per effettuare l\'aggiornamento, clicca su `{{action}}` nel menu laterale."}},"restrictions":{"isGenAIDisabled":{"title":"AI generativa disabilitata","description":"La tua organizzazione ha disabilitato l\'accesso alle funzionalit\xe0 di IA generativa. Contatta l\'amministratore della tua organizzazione per ulteriori informazioni."},"isRemoteControlDisabled":{"title":"Sincronizzazione tra dispositivi disabilitata","description":"La tua organizzazione ha disabilitato l\'accesso alla sincronizzazione. Non potrai utilizzare la nostra app complementare n\xe9 controllare dispositivi esterni. Contatta l\'amministratore della tua organizzazione per ulteriori informazioni."}},"troubleshooting":{"title":"Risoluzione dei problemi","editorDescription":"[Facoltativo] Questa \xe8 una sezione visibile a tutti gli utenti tramite la pagina dei dettagli della connessione sia nell\'app mobile che in quella desktop di Cephable.","description":"Se riscontri problemi con Cephable, prova a seguire i passaggi indicati di seguito per risolvere i problemi pi\xf9 comuni."},"onboarding":{"title":"Onboarding","editorDescription":"[Facoltativo] L\'onboarding viene visualizzato agli utenti quando questo tipo di dispositivo viene aggiunto al loro account. Questa \xe8 un\'ottima opportunit\xe0 per fornire istruzioni su come configurare e utilizzare il tipo di dispositivo con la tua applicazione."},"documents":"Documenti","completionStatus":{"title":"Stato di completamento","error":"","complete":"Completare.","incomplete":"Incompleto."},"metadata":{"title":"Metadati","urlError":"L\'URL deve iniziare con http:// o https://","metatitle":{"label":"Meta titolo","placeholder":"Inserisci un titolo breve"},"shortDescription":{"label":"Breve descrizione","placeholder":"Inserisci una breve descrizione di anteprima (max 150 caratteri)"},"externalLink":{"label":"URL del collegamento esterno","placeholder":"https://example.com/device-info","description":"Un collegamento diretto a un sito web o a una risorsa esterna che fornisce maggiori informazioni sulla prima configurazione del dispositivo. Se lo utilizzi, non applicheremo il ribasso dell\'elenco clienti."},"iconUrl":{"label":"URL dell\'icona del dispositivo","placeholder":"https://example.com/device-icon.png","description":"Un collegamento diretto a un\'immagine che rappresenta questo tipo di dispositivo. Questa icona verr\xe0 visualizzata nell\'app Cephable e negli elenchi dei dispositivi."},"darkModeIconUrl":{"label":"URL dell\'icona del dispositivo in modalit\xe0 scura","placeholder":"https://example.com/device-icon-dark.png","description":"Un collegamento diretto a un\'immagine che rappresenta questo tipo di dispositivo in modalit\xe0 scura. Questa icona verr\xe0 visualizzata nell\'app Cephable e negli elenchi dei dispositivi quando l\'utente ha attivato la modalit\xe0 scura."},"editorDescription":"Quando il tuo dispositivo viene selezionato per essere inserito nell\'app Cephable come estensione o connessione, utilizziamo queste informazioni per mostrarle agli utenti che configurano nuove connessioni."},"client-listing":{"title":"Elenco clienti","editorDescription":"Istruzioni dettagliate per i nuovi utenti su come configurare nuove connessioni con questo tipo di dispositivo. Questo contenuto di markdown verr\xe0 visualizzato nell\'app Cephable quando gli utenti aggiungono una nuova connessione."},"canAccessOrganizationProfiles":{"title":"Visualizza i controlli dell\'app Organizzazione","description":"Gli utenti con questa autorizzazione possono visualizzare i controlli delle app dell\'organizzazione associati a questa organizzazione."},"canEditOrganizationProfiles":{"title":"Gestisci i controlli delle app dell\'organizzazione","description":"Gli utenti con questa autorizzazione possono creare, modificare ed eliminare i controlli delle app dell\'organizzazione associati a questa organizzazione."},"profiles":{"title":"Controlli dell\'app dell\'organizzazione","description":"I controlli app dell\'organizzazione sono profili condivisi per distribuire i controlli app all\'interno dell\'organizzazione o per condividerli con gli utenti dell\'integrazione.","view":"Visualizza i controlli dell\'app Organizzazione","editDescription":"Modifica i controlli dell\'app dell\'organizzazione per personalizzare le impostazioni.","empty":"Nessun controllo dell\'app dell\'organizzazione trovato. Creane uno per iniziare.","error":"Errore durante il caricamento dei controlli dell\'app dell\'organizzazione.","titleShort":"Controlli dell\'app"},"canViewAuthClients":{"title":"Visualizza i progetti","description":"Gli utenti con questa autorizzazione possono visualizzare i client e i progetti autenticati per l\'organizzazione."},"governance":{"title":"Governance","orgTitle":"Governance del valore","description":"Definisci le linee guida che regolano l\'utilizzo dell\'assistente Cephable da parte del tuo team.","automation":{"title":"Regole di automazione","description":"Controlla dove Cephable pu\xf2 automatizzare e fornisci istruzioni che ne modellano il comportamento per la tua organizzazione.","rulesTitle":"Regole","create":"Crea regola di automazione","edit":"Modifica regola di automazione","created":"Regola di automazione creata.","updated":"Regola di automazione aggiornata.","deleted":"Regola di automazione eliminata.","loadError":"Impossibile caricare le regole di automazione.","saveError":"Impossibile salvare la regola di automazione.","deleteError":"Impossibile eliminare la regola di automazione.","searchPlaceholder":"Regole di ricerca per app, sito web, richiesta o ambito","promptOnly":"Istruzioni per l\'assistente","editorDescription":"Scegli il tipo di regola, eventualmente seleziona come destinazione un\'app o un sito web e aggiungi istruzioni chiare per Cephable.","validation":"Aggiungi un\'app o un sito web, istruzioni per l\'assistente vocale o entrambi.","appOrDomain":{"label":"App o sito web","helper":"Utilizza un nome di app o un dominio riconoscibile, come Slack, gmail.com o github.com."},"prompt":{"label":"Istruzioni per l\'assistente","helper":"Descrivi cosa Cephable dovrebbe o non dovrebbe fare. Assicurati che le istruzioni siano specifiche e attuabili."},"type":{"label":"Tipo di regola","block":"Bloccare","allow":"Permettere"},"scope":{"organization":"A livello di organizzazione","organizationDescription":"Applica questa regola a tutti i membri, attuali e futuri.","members":"Membri specifici","membersDescription":"Salva la regola, quindi assegnala solo ai membri che ne hanno bisogno."},"assign":"Assegnare i membri","delete":{"title":"Eliminare la regola di automazione?","description":"Questa operazione rimuove definitivamente la regola e tutte le assegnazioni ai membri che la utilizzano."},"empty":{"title":"Nessuna regola di automazione ancora","description":"Crea una regola per definire i parametri di riferimento per il primo assistente della tua organizzazione."},"guidance":{"block":{"title":"Limita app e siti web","description":"Utilizza una regola di blocco con il nome dell\'app o il dominio per impedire a Cephable di interagire con essa."},"prompt":{"title":"Aggiungi il contesto dell\'assistente","description":"Utilizzare le istruzioni dell\'assistente per comunicare le politiche, i controlli richiesti o le modalit\xe0 di lavoro sicure."},"scope":{"title":"Scegliere l\'ambito appropriato","description":"Applicare linee guida condivise a tutta l\'organizzazione, oppure limitare le eccezioni a membri selezionati."}},"assignment":{"title":"Assegna la regola a un membro","description":"Gestisci l\'assegnazione specifica del membro per {{value}}.","memberLabel":"Membro","apply":"Applica la regola","remove":"Rimuovi la regola","assigned":"Questa regola \xe8 assegnata al membro selezionato.","notAssigned":"Questa regola non \xe8 assegnata al membro selezionato.","applied":"Regola applicata al membro.","removed":"Regola rimossa per il membro.","loadError":"Impossibile caricare i membri dell\'organizzazione.","statusError":"Impossibile caricare le regole di automazione di questo membro.","saveError":"Impossibile aggiornare l\'assegnazione del membro."}},"tabs":{"automation":"Regole di automazione","permissions":"autorizzazioni di estensione","skills":"competenze organizzative","connectors":"Connettori org","usage":"Utilizzo"},"extensions":{"permissions":{"orgTitle":"Politica a livello di organizzazione","orgDescription":"Controlla cosa i membri possono abilitare tra competenze e connettori. Queste impostazioni si applicano a tutti, a meno che un membro non abbia un\'eccezione specificata di seguito.","saved":"Politica aziendale aggiornata.","saveError":"Impossibile aggiornare le policy aziendali.","askAdmin":"Contatta l\'amministratore della tua organizzazione per abilitare questa funzione.","installBlocked":"Impossibile installare.","createBlocked":"Impossibile aggiungere il tipo personale {{type}}.","useBlocked":"Questo {{tipo}} non \xe8 pi\xf9 disponibile per te."},"orgFlags":{"allowPublicSkills":{"title":"Consentire competenze pubbliche","description":"I membri possono pubblicare o rendere disponibili pubblicamente le skill presenti nel marketplace di Cephable."},"allowMemberManagedSkills":{"title":"Consentire competenze personali","description":"I membri possono creare e attivare le proprie competenze personali."},"allowPublicMcpServers":{"title":"Consenti connettori pubblici","description":"I membri possono pubblicare o abilitare connettori pubblici disponibili nel marketplace di Cephable."},"allowMemberManagedMcpServers":{"title":"Consenti connettori personali","description":"I membri possono creare e attivare i propri connettori MCP personali."}},"members":{"title":"Sovrascritture per membro","description":"Concedere a un singolo membro la possibilit\xe0 di condividere, gestire o utilizzare competenze e connettori esterni.","memberLabel":"Membro","saved":"Permessi dei membri aggiornati.","saveError":"Impossibile aggiornare le autorizzazioni dei membri.","loadError":"Impossibile caricare i membri dell\'organizzazione.","adminNote":"Questo membro \xe8 un amministratore dell\'organizzazione e possiede gi\xe0 tutte le autorizzazioni per le estensioni."},"memberFlags":{"canShareSkillsWithOrganization":{"title":"Condividi le tue competenze con l\'organizzazione","description":"Pubblica le tue competenze personali in modo che gli altri membri possano metterle a frutto."},"canManageOrganizationSkills":{"title":"Capacit\xe0 organizzative di gestione","description":"Crea, modifica e rimuovi le competenze condivise con l\'organizzazione."},"canUseExternalSkills":{"title":"Utilizzare competenze esterne","description":"Valorizzate le competenze pubbliche o personali anche quando l\'organizzazione le limita."},"canShareMcpServersWithOrganization":{"title":"Condividi i connettori con l\'organizzazione","description":"Pubblica i connettori personali in modo che gli altri membri possano attivarli."},"canManageOrganizationMcpServers":{"title":"Gestisci i connettori dell\'organizzazione","description":"Creare, modificare e rimuovere i connettori condivisi con l\'organizzazione."},"canUseExternalMcpServers":{"title":"Utilizzare i tubi esterni","description":"Abilita i connettori pubblici o personali anche quando l\'organizzazione li limita."}},"skills":{"title":"Capacit\xe0 organizzative","description":"Preconfigura le funzionalit\xe0 per la tua organizzazione. I membri possono scoprirle e attivarle dalle loro app.","create":"Creare abilit\xe0","edit":"Abilit\xe0 di modifica"},"connectors":{"title":"Dispositivi di organizzazione","description":"Preconfigura i connettori MCP per la tua organizzazione. I membri inseriscono le proprie credenziali sul dispositivo quando ne abilitano uno.","create":"Aggiungi connettore","edit":"Connettore di modifica"},"sort":{"label":"Ordina per","recent":"Pi\xf9 recente","rating":"Valutazione pi\xf9 alta","votes":"Pi\xf9 votato","installs":"La maggior parte installata"},"list":{"loadError":"Impossibile caricare l\'elenco.","emptyTitle":"Ancora niente.","emptyDescription":"Creane uno da rendere disponibile ai membri della tua organizzazione."},"stats":{"rating":"Valutazione media","installs":"Membri che utilizzano questo","votes":"Punteggio di voto","comments":"Commenti"},"feedback":{"open":"Valutazioni e commenti","description":"Le valutazioni e i commenti vengono condivisi all\'interno della tua organizzazione.","yourRating":"La tua valutazione","upvote":"Voto positivo","downvote":"voto negativo","comments":"Commenti","commentPlaceholder":"Condividi come funziona per il tuo team\u2026","replyPlaceholder":"Scrivi una risposta\u2026","noComments":"Nessun commento ancora. Inizia la conversazione.","member":"Membro","deleted":"Questo commento \xe8 stato eliminato.","reply":"Rispondere","loadError":"Impossibile caricare i commenti.","rateError":"Impossibile salvare la tua valutazione.","commentError":"Impossibile pubblicare il commento.","deleteError":"Impossibile eliminare il commento."},"usage":{"description":"Scopri quali membri hanno abilitato ciascuna competenza e connettore dell\'organizzazione.","skillsTitle":"Utilizzo della chiave","connectorsTitle":"Utilizzo del connettore","empty":"Nessun membro ha ancora abilitato nulla in questa categoria.","installCount":"{{count}} membri(i)","accountWide":"Tutti i dispositivi","perDevice":"Dispositivo singolo","unnamed":"Senza titolo","loadError":"Impossibile caricare i dati di utilizzo."}}},"canManageGlobalAutomationRules":{"title":"Gestire la governance","description":"Gli utenti con questa autorizzazione possono gestire le regole di automazione dell\'organizzazione e le assegnazioni dei membri."}},"developer":{"title":"Sviluppatore","titleLong":"Risorse per sviluppatori","description":"Cephable pu\xf2 essere integrato direttamente nella tua app, gioco o servizio utilizzando i nostri SDK.","sdk":{"title":"Esplora i nostri SDK","description":"Forniamo SDK di prima classe progettati per integrare senza problemi il riconoscimento vocale e i controlli adattivi nelle tue applicazioni. I nostri strumenti sono realizzati per migliorare l\'interazione dell\'utente tramite controlli intuitivi e per promuovere l\'accessibilit\xe0, assicurando che il tuo software possa essere utilizzato in modo pi\xf9 efficace da tutti gli utenti.","javascript":{"title":"Javascript","subtitle":"Sito web","description":"Integra i controlli vocali e adattivi direttamente nelle tue applicazioni web.","action":"Ottieni il Pacchetto NPM"},"net":{"title":".NET","subtitle":"Applicazioni Windows","description":"Sfrutta la potenza di .NET per creare applicazioni con i nostri SDK WPF e WinUI3.","actionCore":"Ottieni il Pacchetto Core","actionWpf":"Ottieni il Pacchetto WPF"},"android":{"title":"Android","subtitle":"Dispositivi mobili","description":"Applicazioni Android progettate per facilitare le capacit\xe0 vocali e di movimento della testa.","action":"Ottieni Android SDK"},"more":{"title":"Di pi\xf9","description":"Non trovi quello che ti serve? Contattaci e ti aiuteremo.","action":"Richiedi un SDK"},"docs":{"title":"Documentazione","description":"Esplora la documentazione dettagliata, i progetti di esempio e le guide per iniziare a sviluppare con Cephable.","action":"Visualizza documenti"}},"demo":{"title":"Dimostrazioni","titleLong":"Prova i nostri SDK in azione","description":"Scopri la potenza delle nostre tecnologie di controllo vocale e dei movimenti della testa attraverso le nostre applicazioni campione. Dai giochi interattivi alle app dinamiche per dispositivi mobili e web, ogni esempio dimostra la versatilit\xe0 e l\'efficacia dei nostri SDK. Esplora questi esempi per ottenere spunti e ispirazione per integrare accessibilit\xe0 avanzata ed esperienze immersive nei tuoi progetti.","game":{"title":"Gioco 2048","subtitle":"Sito web","description":"Migliora il gameplay tradizionale con controlli vocali e movimenti della testa adattivi.","action":"Gioca al gioco"},"unity":{"title":"Unit\xe0","subtitle":"Sviluppo del gioco","description":"Scopri come i controlli adattivi possono essere sfruttati nei giochi per offrire un\'esperienza utente pi\xf9 coinvolgente.","action":"Ottieni il campione"},"samples":"Documenti ed esempi","other":{"title":"Altre demo","description":"Scopri in prima persona come Cephable pu\xf2 migliorare la tua applicazione, il tuo gioco o il tuo dispositivo.","action":"Visualizza altre demo"},"web":{"title":"Esempi di Web SDK","subtitle":"Sito web","description":"Integrazione semplice di tutte le nostre funzionalit\xe0 principali nelle applicazioni web.","action":"Prova l\'SDK"},"docs":{"title":"Documentazione per sviluppatori ed esempi","description":"Esplora la documentazione dettagliata, i progetti di esempio e le guide per iniziare a sviluppare con Cephable.","action":"Visualizza documenti"}},"other":{"title":"Altre risorse","description":"Se non trovi ci\xf2 di cui hai bisogno nei nostri SDK, prova a lavorare direttamente con le nostre API o contatta la community per ricevere aiuto, ispirazione e supporto.","api":{"title":"API","description":"Le nostre API ti consentono di interagire direttamente con Cephable. Puoi usare le nostre API per creare integrazioni personalizzate."},"support":{"title":"Supporto","description":"Non trovi ci\xf2 di cui hai bisogno? Contatta la nostra community tramite Discord.","action":"Unisciti a Discord"}}},"customControls":{"title":"Controlli globali e del dispositivo","prefixDisclaimer":"Questo \xe8 un controllo del prefisso: ascolter\xe0 le parole dopo il comando e poi cercher\xe0 le corrispondenze nella frase seguente.","allowPausedDisclaimer":"Questo controllo funziona anche quando il microfono \xe8 in pausa.","resetControls":{"title":"Ripristina controlli","description":"La lingua della tua voce \xe8 cambiata dall\'ultima volta che hai aggiornato i tuoi controlli. Nota: questo reimposter\xe0 i tuoi controlli in modo che corrispondano a {{language}} e potresti perdere tutti i comandi personalizzati. Vuoi davvero reimpostare?","confirm":"S\xec, ripristina i controlli","error":"Si \xe8 verificato un errore durante la reimpostazione dei controlli. Riprova pi\xf9 tardi."},"conflictIndicators":{"warn":"Avvertimento: ","title":"Rilevati conflitti nella configurazione di input","globalControls":"Conflitti di configurazione del controllo globale","deviceControls":"Conflitti di configurazione del controllo del dispositivo","usedInput":"viene utilizzato come input per","description":"Alcuni degli input per i controlli globali e dispositivo che stai utilizzando sono utilizzati anche in uno o pi\xf9 controlli app. Ci\xf2 potrebbe causare conflitti quando si utilizza Cephable. Quando ci\xf2 accade, daremo sempre la preferenza al controllo app rispetto al controllo globale o dispositivo.","item":"L&#39;input <strong>{{value}}</strong> viene utilizzato nei controlli dell&#39;app: ","globalDescription":"I seguenti controlli globali presentano input in conflitto con i controlli dell\'app.","deviceDescription":"I seguenti controlli del dispositivo presentano input in conflitto con i controlli dell\'app."},"globalControls":{"title":"Controlli globali","empty":"Non hai ancora controlli globali. Clicca qui sotto per crearne uno.","edit":"Modifica controlli globali","description":"I controlli globali sono controlli sempre disponibili, indipendentemente dai controlli dell\'app o dal dispositivo che stai utilizzando. Alcuni funzionano anche quando i controlli del microfono o della fotocamera sono in pausa."},"deviceControls":{"title":"Controlli del dispositivo","empty":"Non hai ancora controlli dispositivo. Fai clic qui sotto per crearne uno.","edit":"Modifica controlli dispositivo","controls":{"cephable-open-app":{"success":"Apri app: {{value}}","error":"Impossibile trovare l\'app: {{value}}"},"cephable-close-app":{"commands":["vicino"],"name":"Chiudi l\'app per nome","description":"Utilizza questo comando con i comandi vocali per chiudere un\'app sul tuo computer in base al nome.","success":"Chiudi app: {{value}}","error":"Impossibile trovare l\'app: {{value}}"},"cephable-minimize-focused-app":{"commands":["minimizzare"],"name":"Riduce a icona l\'app attualmente in evidenza.","description":"Utilizzare questo comando con i comandi vocali per ridurre a icona l\'app attualmente in evidenza.","success":"Riduci al minimo il successo delle app mirate!","error":"Errore durante la riduzione a icona dell\'app selezionata."},"cephable-maximize-focused-app":{"commands":["massimizzare"],"name":"Massimizza l\'app attualmente in evidenza.","description":"Utilizza questo comando con i comandi vocali per mettere a fuoco al massimo l\'app corrente.","success":"Massimizza il successo della tua app mirata!","error":"Errore durante la riduzione a icona dell\'app selezionata."},"cephable-generate-text":{"commands":["generare"],"name":"Generare il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dal tuo prompt per generare del testo correlato."},"cephable-stop-generate-text":{"commands":["interrompere la generazione","interrompere la generazione","annulla genera","annullare la generazione"],"name":"Interrompere la generazione del testo.","description":"Utilizzare questo comando con i controlli vocali per interrompere la generazione di testo"},"cephable-open-panel":{"commands":["mostra pannello"],"name":"Aprire il pannello Cephable","description":"Utilizzare questo comando con i comandi vocali per aprire il pannello Cephable."},"cephable-close-panel":{"commands":["nascondi pannello"],"name":"Nascondi il pannello Cephable","description":"Utilizzare questo comando con i comandi vocali per nascondere o ridurre a icona il pannello Cephable."},"cephable-close-focused-app":{"commands":["corrente di chiusura"],"name":"Chiude l\'app attualmente in evidenza.","description":"Utilizzare questo comando con i comandi vocali per chiudere l\'app attualmente in focus.","success":"Chiusura dell\'app corrente riuscita!","error":"Errore durante la chiusura dell\'app corrente."},"cephable-rewrite-text":{"commands":["riscrivere"],"name":"Riscrivi il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dal prompt per riscrivere il testo attualmente evidenziato."},"cephable-summarize-text":{"commands":["riassumere"],"name":"Riassumere il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dal prompt per riassumere il testo attualmente evidenziato."},"cephable-translate-text":{"commands":["tradurre"],"name":"Traduci il testo fornendo il prompt che segue questo comando.","description":"Utilizza questo comando con i comandi vocali seguito dalla tua richiesta per tradurre il testo attualmente evidenziato."},"cephable-click-by-name":{"commands":["rubinetto","colpo","navigare verso","andare a"],"name":"Tocca l\'elemento per nome","description":"Tocca un elemento sulla pagina in base al suo nome, ad esempio \\"tocca salva\\", per fare clic su un pulsante denominato \\"salva\\". Questo \xe8 equivalente al mouse vocale, che permette di cliccare sugli elementi tramite comandi vocali anzich\xe9 utilizzando il mouse."},"cephable-automate":{"commands":["automatizzare","provare a","avere cefabile","eseguire un flusso di lavoro per","lavorare su"],"name":"Avvia un flusso di lavoro AI descrivendo un\'attivit\xe0 dopo questo comando.","description":"Utilizza questo comando con i comandi vocali seguito da un\'attivit\xe0, come \\"automatizza l\'invio di un\'email al mio team\\", e Cephable la eseguir\xe0 come un flusso di lavoro basato sull\'intelligenza artificiale."},"cephable-paste-background-entry":{"commands":["formazione recente voce","incolla l\'ultima voce","incollare l\'ultima dettatura","incolla il contenuto di sfondo"],"name":"Incolla il contenuto di sfondo pi\xf9 recente.","description":"Utilizza questo comando per incollare nell\'app attiva i contenuti pi\xf9 recenti memorizzati in background."}},"description":"I controlli dispositivo sono legati al dispositivo o alla connessione specifici che stai utilizzando. Sono disponibili senza bisogno di aggiungerli ai controlli dell\'app e sono particolarmente utili per funzionalit\xe0 o eventi supportati solo su determinati dispositivi."},"warn":"Il microfono non \xe8 stato avviato. Devi avviare il microfono per usare i controlli globali e del dispositivo.","changeProfile":{"success":"Cambia i controlli dell\'app: {{value}}","error":"Impossibile trovare i controlli dell\'app: \'{{value}}\'"},"descriptionShort":"I controlli globali e dei dispositivi sono azioni sempre disponibili, progettate per funzionare su qualsiasi software. I controlli globali, come \\"Interrompi fotocamera\\", sono a livello di sistema e indipendenti dall\'app, mentre i controlli dei dispositivi sono personalizzati per ogni connessione e sbloccano funzionalit\xe0 pi\xf9 avanzate rispetto ai controlli delle app standard.","description":"I controlli globali e dei dispositivi sono azioni sempre disponibili, progettate per funzionare su qualsiasi software. I controlli globali, come \\"Interrompi fotocamera\\", sono a livello di sistema e indipendenti dall\'app, mentre i controlli dei dispositivi sono personalizzati in base alla connessione di ciascun dispositivo e sbloccano funzionalit\xe0 pi\xf9 avanzate rispetto ai controlli delle app standard. Attualmente, questi controlli sono accessibili tramite comandi vocali, ma in futuro aggiungeremo il supporto per altri input.","noDevice":"Questo passaggio utilizza un\'estensione personalizzata che non hai configurato per il tuo account. Aggiungi l\'estensione per sbloccare questo passaggio."},"notifications":{"title":"Notifiche","center":"Centro notifiche","empty":"Al momento non hai notifiche. Controlla di nuovo un\'altra volta.","seen":"Visto","markAsRead":"Segna come letto","view":"Visualizza tutte le notifiche {{value}}"},"unsaved":{"title":"Ci sono modifiche non salvate.","description":"Hai modifiche non salvate. Vuoi davvero uscire da questa pagina?","cancel":"Esci senza salvare","confirm":"Salva ed esci"},"login":{"welcome":"Benvenuti a Cephable!","subtitle":"Controlla la tua tecnologia alle <strong>tue</strong> condizioni.","create":"Creare un account","signIn":"Registrazione","loading":"Reindirizzamento per l\'accesso...","error":"Si \xe8 verificato un errore durante l\'accesso. Accedi di nuovo.","existingAccount":"Hai gi\xe0 un account?","description":"Controlla. Crea. Automatizza. Cephable: la tua IA personale per comandi rapidi, bozze contestualizzate e flussi di lavoro automatizzati. Nessun elaborazione cloud. Solo un\'assistenza impeccabile che ti segue ovunque."},"home":{"title":"Casa","startControls":"Accendilo!","manage":"Configurare","profileGenerate":{"title":"Oops. Sembra che non hai ancora alcun controllo app.","description":"Affinch\xe9 Cephable possa controllare il tuo computer, dobbiamo sapere cosa vuoi controllare. Puoi creare controlli app da zero o farti aiutare a crearne uno usando il nostro generatore di controlli."}},"wizard":{"description":"Cephable utilizzer\xe0 quindi queste informazioni per generare controlli che potrai esaminare e provare!","includeDefaultKeysQuestion":"Includere comandi vocali predefiniti per i tasti e i clic del mouse?","placeholderAppName":"Microsoft Word, Minecraft, YouTube, Codice, ecc.","noOptionsText":"Inizia a digitare per trovare un\'app che desideri controllare","generate":"Genera controlli","complete":{"title":"Bene, abbiamo finito!","description":"Fai clic sul pulsante qui sotto per visualizzare i controlli che abbiamo generato. Sarai in grado di modificare manualmente, aggiungere o rimuovere qualsiasi aspetto per perfezionarlo per te stesso.","viewControls":"Guarda i miei controlli"},"error":{"emptyInput":"Seleziona almeno un metodo di input","emptyApp":"Inserisci almeno un nome di app","generatingProfile":"Errore durante la generazione dei controlli dell\'app"},"loading":{"title":"Stiamo mettendo insieme tutti i pezzi","description":"Questo pu\xf2 richiedere fino a circa un minuto. Non lasciare questa pagina o tornare indietro, altrimenti smetter\xe0 di generare."},"selectedTips":{"title":"Suggerimento n. {{count}}","previous":"Suggerimento precedente","next":"Suggerimento successivo","two":"Puoi controllare la sensibilit\xe0 dei tuoi input nella sezione \\"Expression Control Settings\\" del pannello principale. Questo ti consente di perfezionare ulteriormente i modi in cui Cephable interpreta gli input specifici per te. E Cephable migliora nel tempo man mano che lavora con te!","three":"Dopo averlo impostato, hai ancora il controllo completo sulla configurazione. Ti diamo una baseline, ma in qualsiasi momento puoi cambiare la mappatura tra ci\xf2 che fai e ci\xf2 che fa sul computer.","four":"Puoi stampare i tuoi controlli per averne una copia fisica mentre usi Cephable. Sappiamo che \xe8 tutto nuovo e ci vuole un po\' per abituarsi. La pratica rende migliori!","one":"Sapevi che puoi usare Cephable su un dispositivo per controllarne un altro? Scarica Cephable sul tuo cellulare, tablet o anche su un altro computer e scegli la connessione che desideri controllare (magari questa). I tuoi profili personali e di input saranno identici su tutti! Assicurati solo che Cephable sia in esecuzione sul tuo dispositivo e sulle tue connessioni."},"steps":{"one":"Passaggio 1. Digita il nome dell\'app che desideri controllare.","two":"Passaggio 2. Conferma i controlli di input che desideri utilizzare:","three":"Passaggio 3. (facoltativo)","threeContinued":"Descrivi le azioni specifiche che vorresti impostare per i comandi che usi comunemente o per i quali hai una forte preferenza. Per favore usa un inglese semplice come quelli sottostanti"},"title":"Genera controlli app","titleLong":"Generare un controllo app","try":"Prova il generatore di controllo","placeholder":"Assicurati che i comandi vocali siano brevi.\\n\\nVoglio poter dire \\"avanti\\" per passare alla diapositiva successiva della presentazione.\\n\\nVoglio usare il movimento della testa per spostare il cursore e i comandi vocali per modificare le scorciatoie.\\n\\nAggiungi pulsanti di azione rapida per tutti i movimenti e le abilit\xe0 dei miei personaggi."},"macros":{"title":"Controllare","titlePlural":"Controlli","description":"I controlli contengono un input (un\'azione che fai come inclinare la testa) e i passaggi che Cephable eseguir\xe0 dopo che l\'azione di input \xe8 stata registrata. Puoi usare i controlli per creare una combinazione di passaggi che vengono attivati da un singolo input.","new":"Crea un nuovo controllo","newDescription":"Crea un nuovo controllo per combinare pi\xf9 passaggi e input.","add":"Aggiungi controllo","create":"Crea un controllo","name":{"title":"Nome del controllo","question":"Come vuoi chiamare questo controllo?","description":"Assegna un nome al tuo controllo, cos\xec potrai ritrovarlo facilmente in seguito.","placeholder":"azione che questo controllo sta eseguendo come \\"saltare\\" o \\"ingrandire\\""},"empty":"Non hai ancora alcun controllo. Clicca qui sotto per crearne uno.","copySuffix":"{{name}}_copia"},"event":{"title":"Fare un passo","titlePlural":"Passi","previewSummaryPlural":"{{first}} e {{total}} altri eventi","add":"Aggiungi passaggio","stepType":"Tipo di passo","select":"Seleziona il tipo di passaggio che desideri aggiungere.","question":"Che tipo di azioni vuoi che Cephable esegua?","setup":"Configura il tuo Step","description":"I passaggi sono le azioni che Cephable eseguir\xe0 dopo che l\'input \xe8 stato attivato. \xc8 possibile aggiungere pi\xf9 passaggi a un controllo per creare una combinazione di azioni.","expand":"Espandi per vedere il resto dei passaggi","stepUp":"Sposta il passo avanti","stepDown":"Spostare il passo verso il basso","stepCopy":"Copia passaggio","stepRemove":"Rimuovi passaggio","insertStep":"Inserisci il passaggio qui sotto","showOptions":"Mostra opzioni","hideOptions":"Nascondi opzioni","hold":"Tempo di attesa (in millisecondi)","error":"Devi configurare il tuo passaggio.","multiple":"Passaggi multipli","deviceTypeCustomAction":{"title":"Azione dispositivo personalizzata"},"keyPress":{"title":"Premere il tasto o il pulsante","short":"Premere","fieldSet":"Tasti o pulsanti da premere","label":"Tasto o pulsante","holdTime":"Tempo di mantenimento del tasto (in millisecondi)","description":"Premere un tasto della tastiera senza utilizzare la tastiera.","longDescription":"Questa funzione simula la pressione di un tasto sulla tastiera. Ad esempio, se hai difficolt\xe0 a premere i tasti fisici, puoi usare un comando vocale o un altro metodo di input per \\"premere\\" virtualmente un tasto.","example":"Pronuncia \\"Invio\\" per inviare un\'e-mail senza premere fisicamente il tasto Invio.","timing":"Tempo di pressione dei tasti","tap":"Rubinetto","tapLong":"Pulsante Tocca","latch":"Fermo","latchLong":"Tenere premuto fino al rilascio","hold":"Presa","holdLong":"Tenere premuto per un certo periodo di tempo","toggle":"Attiva/disattiva","toggleLong":"Attiva/disattiva azione","release":"Rilascia","releaseLong":"Rilascia azione","latchLabel":"Tieni premuto <strong>{{value}}</strong> finch\xe9 non viene rilasciato","tapLabel":"Tocca <strong>{{value}}</strong>","pressLabel":"Premi <strong>{{value}}</strong> per <strong>{{time}}</strong> millisecondi","remove":"Rimuovi pressione tasto","add":"Aggiungi tasto/pulsante da premere"},"keyRelease":{"title":"Rilasciare la chiave o il pulsante","short":"Pubblicazione","selected":"Chiavi selezionate per il rilascio","description":"Rilascia un tasto della tastiera che hai tenuto premuto.","longDescription":"Questa funzione simula il rilascio di un tasto sulla tastiera. Dovrebbe essere utilizzata insieme a una pressione di tasto mantenuta indefinitamente. Ad esempio, se hai difficolt\xe0 a premere tasti fisici, puoi usare un comando vocale o un altro metodo di input per \\"rilasciare\\" virtualmente un tasto.","example":"Per interrompere la corsa, pronunciare \\"Stop\\" dopo aver detto \\"Attiva/disattiva esecuzione\\".","label":"Rilascia <strong>{{value}}</strong>","add":"Aggiungi chiave/pulsante per rilasciare","remove":"Rimuovi rilascio chiave"},"keyToggle":{"title":"Tasto o pulsante di attivazione/disattivazione","short":"Attiva/disattiva","selected":"Tasti selezionati per attivare/disattivare","description":"Con un solo comando puoi accendere o spegnere un tasto della tastiera come se fosse un interruttore della luce.","longDescription":"Questo attiva o disattiva la funzione di un tasto, come un interruttore. \xc8 utile per i tasti che vuoi tenere premuti per un periodo di tempo indeterminato. Puoi usarlo per mantenere la stessa azione sia per la pressione del tasto che per il rilascio o l\'arresto del tasto.","example":"Pronuncia \\"Toggle Run\\" per iniziare a correre. Pronuncia \\"Toggle Run\\" per smettere di correre.","label":"Attiva/disattiva <strong>{{value}}</strong>","add":"Aggiungi tasto/pulsante per attivare/disattivare","remove":"Rimuovi tasto di attivazione/disattivazione"},"pause":{"title":"Pausa","description":"Aggiungere un breve ritardo tra le azioni.","longDescription":"Questa funzione consente di inserire un breve ritardo tra le azioni, essenziale in situazioni in cui un\'azione deve essere completata completamente prima che inizi la successiva. Ad esempio, se si utilizza un comando per rendere il testo in grassetto in un documento, potrebbe essere necessario aprire prima un menu contestuale. La funzione Pausa concede abbastanza tempo all\'apertura e all\'attivazione del menu contestuale prima di procedere al passaggio successivo, assicurando un funzionamento fluido e senza errori.","example":"Immagina di modificare un documento usando i comandi vocali. Dici \\"Formatta testo\\", che apre un menu contestuale. Quindi, dopo una breve pausa per consentire al menu di apparire completamente, dici \\"Grassetto\\" per applicare la formattazione in grassetto al testo selezionato. La funzione Pausa assicura che il menu contestuale sia pronto a ricevere il tuo comando successivo.","label":"Pausa per <strong>{{value}}</strong> millisecondi"},"type":{"title":"Tipo","field":"Frase da digitare","placeholder":"frase digitata","question":"Che testo vuoi digitare?","description":"Scrivi il testo come se usassi una tastiera.","longDescription":"Questo imita la digitazione di una stringa di testo, simile alla digitazione su una tastiera. \xc8 ideale per immettere testo pi\xf9 lungo senza dover premere ogni tasto. Se si desidera immettere testo in modo dinamico, \xe8 possibile utilizzare la funzione Dettatura.","example":"Pronuncia \\"Nome\\" per digitare \\"Ciao, mi chiamo Ellen Ripley.\\" in una finestra di chat.","label":"Tipo <strong> {{value}} </strong>"},"mouseMove":{"title":"Muovi il mouse","description":"Spostare il puntatore sullo schermo.","longDescription":"Sposta il cursore o il puntatore dello schermo senza un mouse fisico. Ci\xf2 \xe8 particolarmente utile per gli utenti con mobilit\xe0 limitata delle mani. Ci\xf2 \xe8 utile per il controllo preciso del movimento del mouse, necessario in alcuni giochi. Se vuoi simulare tutti i movimenti del mouse utilizzando il movimento della testa, puoi provare \'Movimento della testa per il controllo del mouse\' nelle impostazioni della telecamera.","example":"Pronuncia \\"Sposta il mouse a destra\\" per spostare il cursore a destra di 100 px.","moveX":"Spostamento del mouse a sinistra/destra dei pixel","numberMoveX":"Numero di pixel da spostare a sinistra/destra","moveY":"Spostamento del mouse su/gi\xf9 Pixel","numberMoveY":"Numero di pixel da spostare su/gi\xf9","label":"Sposta il mouse <strong> {{value}} </strong>","command":"Spostamento del mouse: {{command}}","commandLabel":"Movimento del mouse","startCommand":"Avvio movimento mouse","stopCommand":"Movimento del mouse Interrompi"},"joystickMove":{"title":"Spostare i joystick","description":"Usa un joystick per spostare gli oggetti sullo schermo.","longDescription":"Questa funzione simula il movimento di un joystick. Ad esempio, se hai difficolt\xe0 a usare un joystick fisico, puoi usare un comando vocale o un altro metodo di input per muovere virtualmente un joystick.","example":"Pronuncia \\"Sposta il joystick a sinistra\\" per spostare il joystick a sinistra di 100 px.","prefix":"Muovi il joystick sinistro","left":"Joystick sinistro","leftX":"X sinistro","leftY":"Y sinistro","right":"Joystick destro","rightX":"X destro","rightY":"Y destro","x":"Forza dell\'asse X","y":"Forza dell\'asse Y","moveXLabel":"Sposta X: {{value}}","moveYLabel":"Sposta Y: {{value}}","labelLeft":"Muovi il joystick sinistro","labelRight":"Muovi il joystick a destra","latch":"Latch manterr\xe0 la posizione finch\xe9 non la rilascerai utilizzando il comando \'Stop All\'."},"playAudio":{"title":"Riproduci audio","placeholder":"frase di affermazione che Cephable dir\xe0","description":"Riproduci un suono, una parola o una frase.","longDescription":"Questa funzione consente agli utenti di convertire frasi digitate in parole pronunciate. \xc8 particolarmente utile per le persone che potrebbero avere difficolt\xe0 a parlare. Digitando una frase, la funzione PlayAudio articola il testo ad alta voce utilizzando la sintesi vocale. Questo pu\xf2 aiutare nella comunicazione o in situazioni in cui un utente deve trasmettere informazioni verbalmente ma preferisce o richiede un\'alternativa all\'uso della propria voce.","example":"Sorridi per riprodurre la parola \\"Ciao\\".","label":"Pronuncia <strong>\\"{{value}}\\"</strong>"},"stopOutputs":{"title":"Interrompi tutte le uscite","titleLong":"Interrompere tutti gli output (rilasciare tutti i tasti e i pulsanti, interrompere tutti i movimenti del mouse, interrompere tutta la digitazione)","description":"Interrompere tutte le azioni in corso, come la pressione di tasti.","longDescription":"Interrompere immediatamente tutti gli output o le azioni in corso. Questa \xe8 una funzione di sicurezza o di comodit\xe0 per interrompere qualsiasi processo. Lo faremo automaticamente per te quando chiudi o metti in pausa i controlli della telecamera o del microfono.","example":"Pronunciare \\"Stop\\" per interrompere tutte le uscite.","label":"Arrestare tutte le uscite e rilasciare i tasti"},"custom":{"title":"Costume"},"options":{"moveUp":"Spostarsi verso l\'alto","moveDown":"Sposta gi\xf9","moveLeft":"Spostati a sinistra","moveRight":"Spostati a destra","copyStep":"Copia passaggio","removeStep":"Rimuovi passaggio"},"directions":{"up":"Su","down":"Gi\xf9","left":"Sinistra","right":"Giusto"}},"expression":{"title":"Espressione del viso","titlePlural":"Espressioni del viso","label":"Espressione / Gesto","start":"Avvia i controlli di espressione","startSmiling":{"title":"Inizia a sorridere","description":"Se inizi a non sorridere e poi inizi a sorridere, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo Apri/chiudi bocca potrebbe causare conflitti."},"stopSmiling":{"title":"Smettila di sorridere","description":"Se stai sorridendo e poi smetti di sorridere, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo Apri/chiudi bocca potrebbe causare conflitti."},"eyebrows":{"title":"Alza le sopracciglia","description":"Se sollevi entrambe le sopracciglia dalla posizione di riposo di base, questo controllo si attiver\xe0."},"openMouth":{"title":"Bocca aperta","description":"Se la tua bocca \xe8 chiusa (o se la tua linea di base \xe8 leggermente aperta) e apri di pi\xf9 la bocca, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo del sorriso potrebbe causare conflitti."},"closeMouth":{"title":"Chiudi la bocca","description":"Se la tua bocca \xe8 aperta e la chiudi completamente, questo controllo si attiver\xe0. Nota: usare questo controllo negli stessi controlli dell\'app del controllo del sorriso potrebbe causare conflitti."},"description":"Arricchisci la tua esperienza digitale con le espressioni facciali. Usa gesti come alzare le sopracciglia, sorridere e altri movimenti per controllare senza problemi il puntatore del mouse, eseguire azioni o personalizzare le tue interazioni."},"head":{"title":"Movimento della testa","titlePlural":"Movimenti della testa","label":"Movimento della testa/corpo","question":"Che tipo di movimento vuoi utilizzare?","tilt":{"title":"Inclinazione della testa","left":{"title":"Inclina la testa a sinistra","description":"Se si guarda la telecamera e si inclina la testa verso sinistra, questo controllo si attiver\xe0."},"right":{"title":"Inclina la testa a destra","description":"Se si guarda la telecamera e si inclina la testa verso destra, questo controllo si attiver\xe0."},"back":{"title":"Inclinare la testa all\'indietro","description":"Se si guarda la telecamera e si inclina la testa all\'indietro e si guarda in alto, questo controllo si attiver\xe0."},"forward":{"title":"Inclinare la testa in avanti","description":"Se si guarda la telecamera e si inclina la testa in avanti e si guarda verso il basso, questo controllo si attiver\xe0."},"description":"Inclina la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."},"turn":{"title":"Girare la testa","left":{"title":"Girare la testa a sinistra","description":"Se stai guardando la telecamera e giri la testa guardando verso sinistra, questo controllo si attiver\xe0."},"right":{"title":"Girare la testa a destra","description":"Se stai guardando la telecamera e giri la testa guardando verso destra, questo controllo si attiver\xe0."},"description":"Ruota la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."},"lean":{"title":"Testa inclinata","left":{"title":"Testa inclinata a sinistra","description":"Se stai guardando la telecamera e ti pieghi verso sinistra in modo che il tuo viso sia pi\xf9 a sinistra nell\'inquadratura, questo controllo si attiver\xe0."},"right":{"title":"Testa inclinata a destra","description":"Se stai guardando la telecamera e ti sporgi verso destra in modo che il tuo viso sia pi\xf9 a destra nell\'inquadratura, questo controllo si attiver\xe0."},"back":{"title":"Appoggia la testa all\'indietro","description":"Se stai guardando la telecamera e ti sporgi all\'indietro in modo che il tuo viso sia pi\xf9 lontano dalla telecamera, questo controllo si attiver\xe0."},"forward":{"title":"Piegare la testa in avanti","description":"Se stai guardando la telecamera e ti sporgi in avanti in modo che il tuo viso sia pi\xf9 vicino alla telecamera, questo controllo si attiver\xe0."},"up":{"title":"Muovi il corpo verso l\'alto","description":"Se stai guardando la telecamera e muovi la testa verso l\'alto allungando il collo o muovendo tutto il corpo verso l\'alto, questo controllo si attiver\xe0."},"down":{"title":"Sposta il corpo verso il basso","description":"Se stai guardando la telecamera e muovi la testa verso il basso, contraendo il collo, abbassandoti o abbassando tutto il corpo, questo controllo si attiver\xe0."},"center":{"title":"Centra la tua testa","description":"Se si guarda la telecamera e si riporta la testa nella posizione centrale, in corrispondenza della linea di base, questo controllo verr\xe0 attivato."},"description":"Inclina la testa verso sinistra o verso destra per un controllo migliore o per navigare con il mouse."},"description":"Controlla il tuo dispositivo o la tua connessione con movimenti della testa come inclinare, annuire o ruotare. Utilizzando la fotocamera del tuo dispositivo, Cephable garantisce un\'esperienza privata e intuitiva per un controllo avanzato o la navigazione tramite mouse."},"voice":{"title":"Controllo vocale","titlePlural":"Comandi vocali","placeholder":"La voce o la frase che Cephable ascolter\xe0","question":"Quale affermazione o frase vuoi dire per questo controllo?","when":"Quando dico...","say":"D\xec \'{{value}}\'","load":{"fail":{"title":"{{language}} Controlli vocali non disponibili","description":"Oh no! Non siamo riusciti a caricare {{language}} per i comandi vocali. Controlla la tua connessione Internet e riprova. Utilizzeremo l\'inglese (Stati Uniti) finch\xe9 la connessione non verr\xe0 ripristinata."}},"description":"L\'attivazione del microfono sblocca comandi vocali intelligenti e naturali, consentendo agli utenti di interagire senza problemi con il proprio computer attraverso applicazioni e software. \xc8 possibile parlare in modo naturale per eseguire comandi o dettare testo, creando un\'esperienza intuitiva e senza sforzo."},"motion":{"title":"Controllo del movimento","titlePlural":"Controlli di movimento","question":"Che tipo di movimento vuoi utilizzare con un telefono o un tablet?","start":"Avvia i controlli di movimento","settings":"Impostazioni di movimento","descriptionShort":"Inclina, ruota o agita il dispositivo per controllare Cephable.","description":"I controlli di movimento ti consentono di trasformare il movimento del tuo telefono o tablet nella Companion App in controlli per il tuo dispositivo. Inclina o scuoti il telefono in diverse direzioni per creare nuovi output.","up":{"title":"Inclina il tuo dispositivo verso l\'alto","description":"Se il dispositivo \xe8 appoggiato su una superficie e lo si inclina verso l\'alto, questo controllo si attiver\xe0."},"down":{"title":"Inclina il tuo dispositivo verso il basso","description":"Se il dispositivo \xe8 appoggiato su una superficie e lo si inclina verso il basso in modo che sia rivolto lontano da s\xe9, questo controllo si attiver\xe0."},"left":{"title":"Inclina il tuo dispositivo verso sinistra","description":"Se il dispositivo \xe8 appoggiato su una superficie piana e lo si inclina verso sinistra, questo controllo si attiver\xe0."},"right":{"title":"Inclina il tuo dispositivo verso destra","description":"Se il dispositivo \xe8 appoggiato su una superficie piana e lo si inclina verso destra, questo controllo si attiver\xe0."},"shake":{"title":"Scuoti il tuo dispositivo","description":"Se scuoti il dispositivo, questo controllo si attiver\xe0."},"edit":{"title":"Modifica impostazioni movimento","description":"Modifica le impostazioni del controllo del movimento per stabilire quanto devi muovere il telefono durante la corsa nell\'app complementare","sensitivity":{"title":"Impostazioni di sensibilit\xe0 del controllo del movimento","description":"La sensibilit\xe0 indica a Cephable quanto devi inclinare il tuo dispositivo per attivare un controllo. Maggiore \xe8 il valore (pi\xf9 a destra sul cursore), maggiore \xe8 la sensibilit\xe0 e quindi meno devi inclinare per attivare il controllo."},"tilt":{"title":"Sensibilit\xe0 all\'inclinazione","description":"Questi valori determinano quanto \xe8 necessario inclinare il dispositivo verso l\'alto, verso il basso, verso sinistra e verso destra affinch\xe9 un input venga riconosciuto."},"mouse":{"title":"Controlli di movimento per il movimento del mouse","description":"Determina se e come desideri utilizzare i controlli di movimento per muovere il mouse invece di attivare i controlli","enable":{"title":"Abilita i controlli di movimento per il movimento del mouse","description":"Se questa opzione \xe8 attivata, per muovere il mouse verranno utilizzati alcuni dei controlli di movimento anzich\xe9 i controlli di attivazione.","option":"Utilizzare i controlli di movimento per il movimento del mouse?"},"invert":{"title":"Inverti il movimento del mouse","description":"Per l\'asse X: se \xe8 attivato, spostando il mouse a sinistra si sposter\xe0 a destra e spostando il mouse a destra si sposter\xe0 a sinistra. Per l\'asse Y: se \xe8 attivato, spostando il mouse in basso si sposter\xe0 in alto e spostando il mouse in alto si sposter\xe0 in basso.","x":"Invertire il movimento del mouse sull\'asse X?","y":"Invertire il movimento del mouse sull\'asse Y?"}}}},"keys":{"title":"Tasto o pulsante","titlePlural":"Tasti o pulsanti","label":"Tasto/pulsante esterno","question":"Quale tasto o pulsante vuoi premere?","edit":"Modifica tasti e pulsanti","defaultOption":"Includere comandi vocali predefiniti per i tasti e i clic del mouse?","description":"I tasti e i pulsanti consentono di associare i diversi controlli di input alle pressioni dei pulsanti della tastiera e del controller.","then":"Cephable premer\xe0...","empty":"Non ci sono controlli chiave che corrispondono a questi criteri.","backspace":"Indietro","delete":"Eliminare","enter":"Entrare","space":"Barra spaziatrice","tab":"Scheda","shift":"Spostare","ctrl":"Ctrl","leftCtrl":"Ctrl sinistro","rightCtrl":"Ctrl destro","leftShift":"Spostamento a sinistra","rightShift":"Spostamento a destra","alt":"Tutto","leftAlt":"Alt sinistro","escape":"Fuga","up":"Freccia su","down":"Freccia gi\xf9","left":"Freccia sinistra","right":"Freccia a destra","command":"Comando","caps":"Blocco maiuscole","reset":{"title":"Reimposta le associazioni dei tasti","confirm":"Ripristinare tutte le associazioni dei tasti?","confirmDescription":"Scegli come ripristinare le associazioni dei tasti. Questa azione non pu\xf2 essere annullata senza salvare.","confirmButton":"Reimposta le associazioni dei tasti","defaultOption":"Ripristina i valori predefiniti per la lingua corrente","emptyOption":"Ripristina a vuoto (cancella tutti i comandi)"}},"talkback":{"title":"Risposta","question":"Cosa vuoi che dica Cephable?","description":"Imposta i controlli che faranno parlare Cephable per te. Puoi assegnare i controlli alle diverse frasi che vuoi che vengano pronunciate.","thenMacro":"allora Cefabile dir\xe0...","empty":"Non ci sono controlli Talkback che corrispondono a questi criteri.","add":"Aggiungi un nuovo controllo Talkback","remove":"Rimuovi controllo Talkback","edit":"Modifica controlli Talkback","deprecatedNotice":"Talkback \xe8 ora integrato direttamente nei controlli app primari. I controlli app hanno alcuni eventi talkback pi\xf9 vecchi che devono essere aggiornati."},"dictation":{"title":"Dettatura","question":"Quale frase dovrebbe attivare la modalit\xe0 dettatura?","thenMacro":"Cephable...","empty":"Non ci sono controlli di dettatura che corrispondono a questi criteri.","type":"tipo","edit":"Modifica frasi di dettatura","remove":"Rimuovi frase dettatura","add":"Aggiungi una nuova frase di dettatura","on":"Dettatura","off":"Comandi","onboarding":{"tourLabel":"Dettatura","learn":"Scopri come usare la modalit\xe0 dettatura per convertire i tuoi discorsi in testo senza usare le mani.","welcome":{"title":"Dettatura","description":"La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. \xc8 come avere un assistente personale che digita tutto quello che dici."},"microphone":{"title":"Accendi il microfono","description":"Per prima cosa, accendi il microfono. Fai clic sull\'interruttore del microfono nel pannello Cephable."},"activate":{"title":"Avvia la modalit\xe0 di dettatura","description":"La voce si avvia in modalit\xe0 comando. Per avviare la dettatura, pronuncia \\"Avvia dettatura\\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalit\xe0 dettatura."},"speaking":{"title":"Fai clic su un documento o un campo e inizia a parlare","description":"La dettatura trascriver\xe0 in tempo reale ci\xf2 che dici. Fai clic su un campo di testo o un documento e inizia a parlare. Ad esempio, pronuncia: \\"Ecco come usare la modalit\xe0 dettatura\\"."},"pauseResume":{"title":"Mettere in pausa la dettatura","description":"Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \\"Metti in pausa la dettatura\\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \\"Avvia dettatura\\". Puoi personalizzare ulteriormente questa funzione con i controlli globali e del dispositivo sempre attivi."},"stop":{"title":"Interruzione della dettatura","description":"Devi tornare ai controlli dell\'app? Basta dire \\"Interrompi dettatura\\". Questo interromper\xe0 la modalit\xe0 dettatura e ti riporter\xe0 alla modalit\xe0 comando. Puoi riprendere in qualsiasi momento premendo nuovamente \\"Avvia dettatura\\"."},"complete":{"title":"Congratulazioni!","description":"Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalit\xe0 dettatura a quella di comando. La dettatura \xe8 un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."}},"description":"La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. \xc8 come avere un assistente personale che digita tutto quello che dici.","settings":{"title":"Dettatura","description":"Come inizia un dettato e cosa succede alle tue parole prima che vengano digitate."},"hold":{"enabled":{"option":"Tieni premuto per dettare","description":"Tieni premuti i tasti sottostanti, e nient\'altro, per iniziare a dettare. Rilasciali per digitare ci\xf2 che hai detto."},"keys":{"title":"Chiavi da tenere","description":"Premendo un qualsiasi altro tasto mentre si tengono premuti questi, l\'azione viene annullata, quindi le normali scorciatoie continuano a funzionare."},"duration":{"title":"Tempo di mantenimento","description":"Per quanto tempo tenere premuti i tasti prima che inizi la dettatura."},"transcribing":"Trascrizione...","aiRewriting":"Riscrittura tramite IA...","result":"{{parole}} parole in {{secondi}} secondi","resultRewritten":"{{parole}} parole in {{secondi}}s, IA {{riscriviSecondi}}s","typing":"Sto scrivendo...","permission":{"title":"Tieni premuto per dettare, \xe8 in attesa di autorizzazione","description":"Concedi l\'accesso a Cephable in Impostazioni di sistema > Privacy e sicurezza > {{pane}}. La funzione \\"Tieni premuto per dettare\\" inizia a funzionare non appena la attivi."},"unavailable":"Tenendo premuto per dettare, non \xe8 stato possibile avviare l\'ascolto dei tasti. Riavviare Cephable per riprovare."},"aiRewrite":{"option":"Riscrittura automatica tramite intelligenza artificiale per dettati lunghi","description":"Prima di digitare un testo dettato lungo, l\'intelligenza artificiale integrata nel dispositivo corregge la punteggiatura, elimina le parole superflue e apporta le modifiche necessarie, formattandolo per l\'app in cui lo stai utilizzando. I testi dettati brevi vengono trascritti esattamente come sono stati pronunciati. Viene aggiunto un breve intervallo prima della digitazione."}},"face":{"title":"Espressione del viso","titlePlural":"Espressioni del viso","try":"Prova i controlli delle espressioni facciali","question":"Che tipo di espressione facciale vuoi usare?","descriptionShort":"Per controlli pi\xf9 efficaci, utilizza diversi movimenti del viso.","description":"Le espressioni facciali fanno parte dei Controlli Espressione. Ti permettono di usare diversi movimenti del viso per controlli avanzati. Puoi usare il movimento delle sopracciglia, della bocca e altro ancora per creare output diversi."},"other":{"title":"Altro","titlePlural":"Altri controlli","label":"Altro controllo","placeholder":"altro comando sperimentale","question":"Quale comando aggiuntivo desideri utilizzare? Questi comandi sono in genere per connessioni non Cephable che non rientrano in altre categorie. Possono anche funzionare come comandi vocali quando pronunci la parola o la frase specificata. Nota: questi controlli sono sperimentali e potrebbero non essere completamente supportati.","description":"Altri controlli sono sperimentali e potrebbero non essere completamente supportati. Possono essere utilizzati per connessioni non Cephable o come comandi vocali quando si pronuncia la parola o la frase specificata."},"support":{"title":"Supporto","profiles":"Introduzione ai controlli delle app","question":"Non hai ancora trovato quello che ti serve?","more":"Scopri di pi\xf9 su Cephable.com con guide dettagliate, tutorial, video e altro ancora."},"community":{"title":"Unisciti alla comunit\xe0","description":"Ottieni supporto, condividi idee o diventa membro delle community di Cephable.","discord":"Comunit\xe0 Discord","facebook":"Gruppo Facebook"},"resources":{"title":"Risorse utili","description":"Trova le risposte alle tue domande sulle caratteristiche e le funzioni di Cephable.","guides":"Guide passo dopo passo"},"feedback":{"title":"Feedback","description":"Raccontaci la tua esperienza con Cephable.","contact":"Contattaci","feature":"Suggerisci una funzionalit\xe0","bug":"Segnala un problema"},"settings":{"title":"Impostazioni","general":"Impostazioni generali dell\'app","description":"Questa \xe8 la tua tela su cui personalizzare la tua esperienza, perfezionando i tuoi controlli.","orgTitle":"Impostazioni di {{value}}","advanced":{"title":"Impostazioni avanzate","description":"Fai clic qui per accedere alle impostazioni avanzate per l\'IA, i controlli dell\'app, le connessioni, le estensioni e altro ancora."},"quick":"Ecco le impostazioni contestuali per il pannello. Utilizzale per personalizzare la tua esperienza attuale."},"account":{"title":"Account","menu":"Menu utente","settings":"Impostazioni dell\'account","description":"Aggiorna le informazioni chiave per rimanere in contatto con Cephable.","usernameLabel":"Nome utente:","emailLabel":"E-mail:","password":{"change":"Cambiare la password","description":"Aggiorna la tua password per proteggere il tuo account.","old":"Vecchia password","current":"La tua password attuale","new":"Nuova password","desired":"La nuova password desiderata","confirm":"Conferma la nuova password","update":"Aggiorna password"},"isEmailVerified":{"title":"L\'email non \xe8 verificata.","description":"La tua email non \xe8 verificata. Controlla la tua email per un link di verifica.","resend":"Invia di nuovo l\'email","success":"Ti abbiamo inviato una nuova email di verifica.","error":"Si \xe8 verificato un errore durante l\'invio dell\'email di verifica. Riprova pi\xf9 tardi.","org":"Il tuo indirizzo email non \xe8 verificato. \xc8 necessario per accedere ai dettagli della licenza. Controlla la tua email per un link di verifica.","titleAlt":"Verifica il tuo indirizzo email","descriptionLong":"Benvenuto su Cephable! Un\'email di verifica \xe8 stata inviata a {{email}}. Controlla la posta in arrivo o la cartella spam e clicca sul link. Se non lo vedi, puoi inviare nuovamente l\'email di verifica.","appBlock":"Ci sei quasi! Un\'email di verifica \xe8 stata inviata a {{email}}. Controlla la tua posta in arrivo e clicca sul link per verificare il tuo indirizzo email. Se non lo vedi, controlla la cartella spam."},"signout":{"title":"Disconnessione","question":"Sei sicuro di voler uscire?","confirm":"S\xec, esci","warn":{"title":"Stai per uscire.","description":"Sembra che tu sia stato inattivo per un po\'. Per motivi di sicurezza, ti disconnetteremo tra XX secondi. Se vuoi rimanere connesso, clicca su \\"Resta connesso\\" qui sotto.","confirm":"Rimani connesso","cancel":"Esci ora"},"description":"Una volta effettuata la disconnessione, questa connessione verr\xe0 rimossa dal tuo account e non sar\xe0 pi\xf9 visibile dall\'app complementare o da altre connessioni.","confirmDescription":"Ti disconnettiamo e rimuoviamo questa connessione"},"marketing":{"title":"Preferenze e-mail","description":"Aggiorna le tue preferenze e-mail per ricevere aggiornamenti e novit\xe0 da Cephable.","marketing":"Email di marketing","optIn":"Vorrei ricevere tutorial, suggerimenti, aggiornamenti e newsletter per migliorare la mia esperienza con Cephable"},"error":{"save":"Errore durante il salvataggio delle impostazioni dell\'account.","password":"Errore durante l\'aggiornamento della password.","signout":"Errore durante la disconnessione.","old":"\xc8 richiesta la vecchia password.","new":"\xc8 richiesta una nuova password.","match":"Le password non corrispondono.","marketing":"Errore durante l\'aggiornamento delle preferenze e-mail.","userPreferences":"Errore durante il salvataggio delle preferenze utente."},"success":{"save":"Impostazioni account salvate.","password":"Password aggiornata.","marketing":"Preferenze e-mail aggiornate.","userPreferences":"Preferenze utente aggiornate."},"userPreferences":{"title":"Preferenze utente","description":"Aggiorna le tue preferenze per creare l\'esperienza Cephable pi\xf9 adatta a te.","warningOptOut":"Nascondi gli avvisi quando salvo o aggiorno i controlli dell\'app","enableTranscribeTask":"Abilita l\'attivit\xe0 di trascrizione del file sperimentale nel pannello Cephable","enableGamepadSupport":"Abilita il supporto del gamepad per il driver locale e l\'emulazione del controller Xbox","enableMetrics":"Abilita l\'output delle metriche di utilizzo per i test delle prestazioni. Potrai scaricare i log.","enableCameraControls":"Abilita i controlli della fotocamera nel pannello Cephable","enableWorkflowRecording":"Abilita l\'anteprima di registrazione di un flusso di lavoro nelle funzionalit\xe0 di automazione e intelligenza artificiale."},"delete":{"title":"Elimina account","description":"Puoi eliminare definitivamente il tuo account e rimuovere ogni riferimento alle tue informazioni personali. Quando elimini il tuo account, le tue connessioni verranno rimosse e non funzioneranno pi\xf9 n\xe9 saranno pi\xf9 registrate sul tuo account; i controlli dell\'app e tutte le impostazioni andranno persi. Questa procedura non pu\xf2 essere annullata.","button":"Elimina definitivamente l\'account","confirmation":"Sei sicuro di voler eliminare il tuo account?","note":"Questa azione \xe8 irreversibile.","confirm":"S\xec, elimina il mio account"},"communication":{"title":"Preferenze di comunicazione"},"name":{"title":"Nome visualizzato"},"email":{"title":"Indirizzo email","description":"Il tuo indirizzo email registrato"}},"appSettings":{"description":"Queste impostazioni si applicano solo a questa app. Se vuoi modificare le impostazioni dell\'app Cephable su un altro computer o dispositivo mobile, modifica le impostazioni in quell\'app.","autostart":{"title":"Avvia automaticamente Cephable","description":"Con questa impostazione attivata, l\'app Cephable si avvier\xe0 automaticamente quando effettui l\'accesso al tuo dispositivo. Se hai anche controlli vocali ed espressivi automatici, anche questi si avvieranno subito.","question":"Avvio automatico dell\'app Cephable?"},"position":{"topLeft":"In alto a sinistra","top":"Centro superiore","topRight":"In alto a destra","bottom":"Centro in basso","bottomLeft":"In basso a sinistra","bottomRight":"In basso a destra","label":"Seleziona la posizione di avanzamento dei comandi","description":"Seleziona dove desideri che il feed dei comandi appaia sullo schermo."},"micPosition":{"title":"Posizione della finestra di input del microfono","description":"Seleziona la posizione sullo schermo in cui desideri posizionare i controlli del microfono per la voce e la dettatura.","label":"Seleziona la posizione della finestra di input del microfono"},"cameraPosition":{"title":"Posizione della finestra di input della telecamera","description":"Seleziona dove desideri posizionare sullo schermo i controlli della telecamera per il movimento del viso e della testa.","label":"Seleziona la posizione della finestra di input della telecamera"},"theme":{"title":"Tema","description":"Scegli un tema adatto al tuo stile.","label":"Seleziona un tema","light":"Leggero","dark":"Buio","system":"Utilizzare le impostazioni di sistema del sistema operativo"},"overlay":{"title":"Feed di comando","description":"Il feed di comando mostrer\xe0 i diversi controlli che usi e quali controlli sono stati inviati al tuo computer. \xc8 click-through ma sar\xe0 sempre in cima alle altre finestre. Con questa impostazione attivata, l\'app Cephable mostrer\xe0 e sar\xe0 sempre in cima alle altre finestre e applicazioni.","question":"Mostrare il feed dei comandi?"},"transparent":{"title":"Trasparenza del feed dei comandi","description":"Determina l\'opacit\xe0 del testo. Pi\xf9 basso \xe8 il valore, pi\xf9 trasparente sar\xe0 il feed."},"panelAutoHide":{"title":"Pannello Cephable con Nascondimento Automatico","delay":"Ritardo prima di nascondersi","denominator":"secondi","time":"{{value}} secondi"},"title":"Impostazioni generali dell\'app","scale":{"description":"Regola le dimensioni del testo in tutta l\'app.","label":"Dimensione del testo","small":"Piccolo","large":"Grande"},"panelScale":{"description":"Regola le dimensioni del pulsante del pannello compresso.","label":"Dimensioni del pulsante del pannello"},"aiNewFiles":{"title":"Cartella per i nuovi file AI","description":"Scegli dove l\'agente AI salva i nuovi file per impostazione predefinita, a meno che tu non indichi una posizione specifica. Se viene lasciata l\'impostazione predefinita, i nuovi file vengono salvati in una cartella \xabCephable-Work\xbb nella tua cartella home, creata automaticamente al primo utilizzo.","selectButton":"Seleziona la cartella","clearButton":"Usa la cartella predefinita","current":"I nuovi file vengono salvati in: {{folder}}","default":"I nuovi file vengono salvati nella cartella predefinita \xabCephable-Work\xbb nella tua cartella home.","openButton":"Apri la cartella","openError":"Impossibile aprire la cartella. Potrebbe essere stata spostata o eliminata."},"aiWorkspace":{"title":"Cartella dell\'area di lavoro AI","description":"Scegli una cartella che l\'agente AI sul dispositivo utilizzer\xe0 per trovare, leggere e modificare file e per eseguire comandi. Per impostazione predefinita, l\'agente pu\xf2 accedere all\'intero computer.","selectButton":"Seleziona la cartella","clearButton":"Utilizzare l\'intero computer","current":"Cartella corrente dell\'area di lavoro:","none":"Nessuna cartella di lavoro selezionata. L\'agente AI pu\xf2 accedere all\'intero computer.","restrictQuestion":"Limita l\'agente IA a questa sola cartella","restrictDescription":"Quando questa opzione \xe8 abilitata, gli strumenti di file e di comando dell\'agente AI non possono leggere o modificare alcun file al di fuori della cartella selezionata."},"documentTemplates":{"title":"Modelli di documenti","description":"Scegli un file modello da cui l\'agente AI partir\xe0 per creare nuovi documenti. Lascia l\'opzione predefinita di Cephable per applicare lo stile predefinito del marchio Cephable. Word, PowerPoint ed Excel hanno ciascuno il proprio modello.","word":"Modello Word","wordDescription":"Modello di partenza per l\'agente di intelligenza artificiale per i nuovi documenti Word (.docx).","powerpoint":"Modelli PowerPoint","powerpointDescription":"Modello di partenza per l\'agente di intelligenza artificiale per le nuove presentazioni PowerPoint (.pptx).","excel":"Modello Excel","excelDescription":"Modello di partenza per l\'agente di intelligenza artificiale per le nuove cartelle di lavoro di Excel (.xlsx).","selectButton":"Seleziona File","clearButton":"Utilizza le impostazioni predefinite di Cephable","current":"Modello: ","default":"Utilizzo del modello predefinito integrato di Cephable con lo stile del marchio."},"automationBrowser":{"title":"Visibilit\xe0 del browser di automazione","description":"Quando l\'agente AI utilizza il browser Cephable (ricerca web, Google Docs/Sheets/Slides, Gmail, Drive), normalmente viene eseguito in background in modo nascosto per non interromperti. Attiva questa opzione per vederlo in azione.","question":"Mostrare il browser di automazione mentre l\'IA \xe8 in funzione?"}},"input":{"title":"Ingresso","titlePlural":"Controlli di input","explore":"Esplora i controlli di input","descriptionShort":"Esplora i vari controlli di input che Cephable utilizza per creare un\'esperienza digitale migliore per te.","typeLabel":"Tipo di controllo di input","toolTip":"Questo utilizza {{alt}}","remove":"Rimuovi controllo input","filter":"Filtra per tipo di input","select":"Seleziona un input","question":"Che tipo di input vuoi utilizzare?","add":"Aggiungi input","addMore":"Aggiungi un altro input","removeItem":"Rimuovi elemento {{index}}","item":"Elemento {{index}}: {{label}}","duplicate":"Non sono ammessi elementi duplicati.","maximum":"Sono consentiti al massimo {{maxItems}} articoli.","description":"I controlli di input sono i diversi metodi utilizzati per controllare il dispositivo, come la voce, i movimenti della testa, le espressioni facciali e altre connessioni. Esplora i diversi controlli di input qui sotto per saperne di pi\xf9."},"time":{"soon":"Prossimamente","now":"Ora","today":"Oggi","yesterday":"Ieri","minutesAgo":"{{count}} minuto fa","minutesAgo_plural":"{{count}} minuti fa","daysAgo":"{{count}} giorni fa","daysAgo_plural":"{{count}} giorni fa","monthsAgo":"{{count}} mese fa","monthsAgo_plural":"{{count}} mesi fa","yearsAgo":"{{count}} anno fa","yearsAgo_plural":"{{count}} anni fa","minutesAhead":"in {{count}} minuti","todayAhead":"pi\xf9 tardi oggi","tomorrow":"Domani","daysAhead":"tra {{count}} giorni","monthsAhead":"tra {{count}} mesi","yearsAhead":"in {{count}} anni"},"peripherals":{"empty":"Nessuna periferica rilevata","switch":"Interruttore","keyboard":"Tastiera","gamepad":"Controllo dei giochi","companionApp":"App complementare","available":"Disponibile per l\'uso","error":"Controlla le tue impostazioni."},"camera":{"windowTitle":"Controlli della fotocamera Cephable","title":"Telecamera","titlePlural":"Telecamere","settings":"Impostazioni della fotocamera","start":"Avvia la fotocamera","restart":"Riavvia la fotocamera","descriptionShort":"Permette l\'espressione del viso e il movimento della testa.","description":"Utilizza la fotocamera per rilevare le espressioni del viso e i gesti del corpo come controlli diversi.","empty":"Nessuna telecamera trovata.","search":"Cerca per nome della telecamera","loading":"Caricamento dei controlli della telecamera...","error":"Errore imprevisto durante il caricamento dei controlli della fotocamera. Controlla la tua fotocamera e riprova.","manage":{"title":"Fai clic per visualizzare e gestire i dettagli delle tue telecamere.","description":""},"detected":{"face":"Volto rilevato.","noFace":"Nessun volto rilevato. Regola la telecamera o la posizione e riprova.","command":"Rilevato: {{command}}"},"permission":{"title":"Autorizzazioni della fotocamera richieste","description":"Devi autorizzare Cephable a utilizzare la tua fotocamera per usare i controlli del viso e del corpo.","button":"Apri Impostazioni Permessi","no":"Nessun accesso alla telecamera","help":"Cephable necessita dell&#39;accesso alla fotocamera per utilizzare i controlli di espressione e movimento della testa. Vai su <strong>Impostazioni di sistema</strong> &gt; <strong>Privacy e sicurezza</strong> &gt; <strong>{{pane}}</strong> e abilita l&#39;accesso di Cephable alla fotocamera."},"controls":{"startData":"Registrazione dei dati del viso avviata. Premi di nuovo la scorciatoia mentre sei nella finestra della fotocamera per interrompere la registrazione e scaricare.","downloadData":"Registrazione interrotta, download dei dati","paused":"Controlli della telecamera in pausa.","pause":"Pausa controlli telecamera","resume":"Riprendi i controlli della telecamera","resumed":"Ripristino dei controlli della telecamera.","linesOn":"Attiva le linee del viso","linesOff":"Disattiva le linee del viso","linesToggle":"Attiva/disattiva il disegno delle linee del viso","noDeviceTitle":"Nessuna telecamera rilevata che possa essere utilizzata con Cephable.","noDeviceDescription":"\xc8 necessario collegare una fotocamera compatibile con le app mobili.","noDeviceConnectedDescription":"Il controllo della telecamera serve come anteprima dell\'interfaccia. Nessun passaggio verr\xe0 eseguito correttamente. Collega questo dispositivo companion a un altro, per avviare i comandi.","lines":"Linee del viso"},"switch":{"title":"Cambia telecamera","description":"Seleziona una telecamera diversa da utilizzare per i controlli del viso e del corpo.","select":"Seleziona la fotocamera","next":"Prossima telecamera","nextLong":"Passa alla telecamera successiva","empty":"Non sono state trovate altre telecamere.","search":"Cerca per nome della telecamera"},"baseline":{"title":"Linea di base","description":"La linea di base \xe8 la posizione predefinita del tuo viso e del tuo corpo che Cephable usa per determinare i tuoi movimenti. Puoi aggiornare e reimpostare la linea di base qui.","update":"Aggiorna la linea di base","reset":"Ripristina linea di base","updated":"Baseline aggiornata","tooltip":"Fai clic per aggiornare la tua linea di base alla tua posizione di riposo attuale."},"edit":{"title":"Modifica impostazioni fotocamera","description":"Puoi perfezionare le impostazioni per gli input che richiedono una telecamera, in modo che si adattino meglio alle tue esigenze.","autoStart":{"title":"Avvia automaticamente la fotocamera","option":"Avvio automatico della telecamera e dei controlli della testa/espressione?","description":"Con questa impostazione attivata, il controller avvier\xe0 la fotocamera, consentendoti di utilizzare le espressioni facciali e i controlli dei movimenti della testa non appena l\'app si avvia. Se questa impostazione \xe8 disattivata, devi toccare il pulsante \\"Avvia fotocamera\\" nella pagina di connessione."},"head":{"title":"Sensibilit\xe0 al movimento della testa","description":"La sensibilit\xe0 indica a Cephable quanto lontano devi muoverti per attivare un controllo. Maggiore \xe8 il valore (pi\xf9 a destra sullo slider), maggiore \xe8 la sensibilit\xe0 e quindi meno devi muoverti per attivare il controllo.","tilt":{"title":"Sensibilit\xe0 all\'inclinazione della testa","description":"Questi valori determinano quanto \xe8 necessario inclinare la testa verso l\'alto, verso il basso, verso sinistra e verso destra per attivare i controlli","up":"Sensibilit\xe0 inclinazione verso l\'alto","down":"Sensibilit\xe0 inclinazione verso il basso","left":"Sensibilit\xe0 inclinazione a sinistra","right":"Sensibilit\xe0 inclinazione a destra","scaleHigh":"Leggera inclinazione","scaleLow":"Grande inclinazione"},"turn":{"title":"Sensibilit\xe0 alla rotazione della testa","description":"Questi valori determinano quanto \xe8 necessario girare la testa a sinistra e a destra per attivare i controlli","left":"Sensibilit\xe0 svolta a sinistra","right":"Sensibilit\xe0 di svolta a destra","scaleHigh":"Leggera svolta","scaleLow":"Grande svolta"},"lean":{"title":"Sensibilit\xe0 all\'inclinazione della testa","description":"Questi valori determinano quanto \xe8 necessario inclinare la testa in avanti e indietro per attivare i controlli","forward":"Sensibilit\xe0 di inclinazione in avanti","back":"Sensibilit\xe0 di appoggio","right":"Sensibilit\xe0 di inclinazione a destra","left":"Sensibilit\xe0 inclinata a sinistra","scaleHigh":"Leggera inclinazione","scaleLow":"Grande magro"},"duck":{"title":"Sensibilit\xe0 di inclinazione/salita della testa","description":"Questi valori determinano quanto \xe8 necessario abbassare o alzare la testa per attivare i controlli","down":"Sensibilit\xe0 al piumino d\'anatra","up":"Aumenta la sensibilit\xe0","scaleHigh":"Leggero spostamento","scaleLow":"Grande spostamento"}},"face":{"title":"Sensibilit\xe0 all\'espressione del viso","description":"La sensibilit\xe0 indica a Cephable quanto esagerata deve essere l\'espressione per attivare un controllo. Maggiore \xe8 il valore (pi\xf9 a destra sullo slider), maggiore \xe8 la sensibilit\xe0 e quindi meno \xe8 necessario muoversi per attivare il controllo.","eyebrow":{"title":"Sensibilit\xe0 delle sopracciglia","description":"Questi valori determinano quanto \xe8 necessario alzare o abbassare le sopracciglia per attivare i controlli","up":"Aumenta la sensibilit\xe0 delle sopracciglia","scaleHigh":"Lieve aumento","scaleLow":"Grande aumento"},"mouth":{"title":"Sensibilit\xe0 della bocca","description":"Questi valori determinano quanto \xe8 necessario aprire o chiudere la bocca per attivare i controlli","open":"Sensibilit\xe0 della bocca aperta","close":"Sensibilit\xe0 della bocca chiusa","smile":"Sensibilit\xe0 al sorriso","scaleHigh":"Leggermente aperto","scaleLow":"Grande Aperto","closeScaleHigh":"Leggermente Chiuso","closeScaleLow":"Ben chiuso","smileScaleHigh":"Un leggero sorriso","smileScaleLow":"Grande sorriso"}},"mouse":{"title":"Movimento della testa per i controlli del mouse","description":"Determina se e come desideri utilizzare i controlli dei movimenti della testa per muovere il mouse invece di attivare altri output.","enable":{"title":"Abilita il movimento della testa per i controlli del mouse","description":"Se questa opzione \xe8 attivata, per muovere il mouse verranno utilizzati alcuni controlli dei movimenti della testa anzich\xe9 i controlli dei trigger.","option":"Utilizzare i controlli della testa per il movimento del mouse?"},"input":{"title":"Tipo di input del mouse","description":"Seleziona il tipo di gesti della testa che vuoi assegnare ai controlli del mouse. Ad esempio, Inclinazione della testa significa che puoi inclinare la testa a sinistra e a destra per muovere il mouse a sinistra e a destra, Rotazione della testa significa che puoi girare la testa a sinistra e a destra per muovere il mouse e Inclinazione della testa significa che puoi inclinarti a sinistra e a destra per muovere il mouse.","option":"Seleziona il tipo di input","optionLong":"Seleziona il tipo di movimento della testa che desideri utilizzare per controllare il mouse."},"invert":{"title":"Inverti il movimento del mouse","description":"Se \xe8 attivato, la direzione in cui muovi la testa sar\xe0 invertita rispetto alla direzione in cui si muove il mouse. Per l\'asse X: se \xe8 attivato, spostandoti a sinistra sposterai il mouse a destra e spostandoti a destra lo sposterai a sinistra. Per l\'asse Y: se \xe8 attivato, spostandoti verso il basso sposterai il mouse verso l\'alto e spostandoti verso l\'alto lo sposterai verso il basso.","x":"Invertire il movimento del mouse sull\'asse X?","y":"Invertire il movimento del mouse sull\'asse Y?"},"mode":{"title":"Modalit\xe0 di spostamento del mouse","description":"Seleziona il modo in cui desideri che il cursore reagisca ai movimenti della testa."},"speed":{"title":"Velocit\xe0 del mouse","description":"Determina la velocit\xe0 costante a cui vuoi che si muova il cursore.","fast":"Veloce","slow":"Lento"},"linear":{"title":"Movimento lineare del mouse","description":"Se questa opzione \xe8 attivata, il cursore si muove solo lungo linee rette orizzontali o verticali, facilitando la navigazione in quelle specifiche direzioni senza alcuno spostamento diagonale.","option":"Utilizzare il movimento lineare del mouse?"},"accelerationRate":{"title":"Ritardo di risposta all\'accelerazione del mouse","description":"Numero di millisecondi necessari affinch\xe9 la velocit\xe0 del mouse aumenti."},"accelerationCurve":{"title":"Curva di accelerazione del mouse","description":"Regola la velocit\xe0 con cui la velocit\xe0 del cursore aumenta in relazione al movimento della testa.","linear":"Lineare","exponential":"Esponenziale","sublinear":"Sub-lineare"},"maximumSpeed":{"title":"Velocit\xe0 massima del mouse","description":"Determina il numero massimo di pixel che il cursore pu\xf2 spostare al secondo."},"off":{"title":"Spento","description":"Il movimento del mouse \xe8 disabilitato."},"steadyGlide":{"title":"Scivolata costante","description":"Quando si muove la testa oltre un certo punto, il cursore scivola continuamente in quella direzione a velocit\xe0 costante."},"speedBoost":{"title":"Aumento della velocit\xe0","description":"Il cursore inizia a muoversi pi\xf9 velocemente quanto pi\xf9 a lungo tieni la testa in una posizione. Pi\xf9 a lungo tieni ferma la testa, pi\xf9 velocemente il cursore accelera."},"dynamicGlide":{"title":"Scivolamento dinamico","description":"La velocit\xe0 del cursore aumenta in base a quanto muovi la testa. Pi\xf9 muovi la testa, pi\xf9 velocemente scivola il cursore."},"proportionalSpeed":{"title":"Velocit\xe0 proporzionale","description":"Il cursore segue la punta del tuo naso in modo proporzionale alle dimensioni dello schermo."},"disabled":"Questa funzionalit\xe0 \xe8 disabilitata per le connessioni e le estensioni remote."}},"stop":"Ferma la telecamera","show":"Mostra la telecamera","hide":"Nascondi telecamera","warn":"I controlli della fotocamera non sono stati avviati. Avvia la fotocamera per consentire i controlli del viso e del corpo.","draw":{"error":"Errore durante il caricamento del feed della telecamera. Controlla la telecamera e riprova."},"select":"Seleziona la telecamera che desideri associare per ottenere controlli avanzati tramite riconoscimento facciale, corpo e pulsanti di azione rapida.","extension":{"title":"Estensione: Fotocamera","enabledTitle":"Abilita i controlli della fotocamera","enabledDescription":"Con questa impostazione attivata, Cephable utilizzer\xe0 la fotocamera per rilevare i movimenti del viso e della testa, consentendoti di controllare il dispositivo con espressioni e gesti, incluso l\'utilizzo dei movimenti della testa come mouse."},"live":"VIVERE","paused":"La telecamera si \xe8 fermata"},"microphone":{"windowTitle":"Comandi vocali Cephable","title":"Microfono","titlePlural":"Microfoni","settings":"Impostazioni del microfono","start":"Avvia microfono","stop":"Ferma il microfono","descriptionShort":"Abilita comandi vocali e dettatura.","description":"Utilizza il microfono integrato per abilitare i comandi vocali e la dettatura.","select":"Seleziona il microfono che desideri associare per ottenere controlli avanzati tramite la voce.","empty":"Nessun microfono trovato.","search":"Cerca per nome del microfono","manage":{"title":"Fai clic per visualizzare e gestire i dettagli dei tuoi microfoni.","description":""},"permission":{"title":"Autorizzazioni microfono richieste","description":"Per utilizzare i comandi vocali, devi autorizzare Cephable a utilizzare il tuo microfono.","button":"Apri Impostazioni Permessi","no":"Nessun accesso al microfono","help":"Cephable necessita dell&#39;accesso al microfono per utilizzare i comandi vocali. Vai su <strong>Impostazioni di sistema</strong> &gt; <strong>Privacy e sicurezza</strong> &gt; <strong>{{pane}}</strong> e abilita l&#39;accesso di Cephable al microfono."},"controls":{"loadingDetail":"Potrebbero volerci alcuni minuti.","pause":"Pausa dei controlli vocali","paused":"Controlli in pausa.","resume":"Riprendi i controlli vocali","dictationPlay":"Avvia la modalit\xe0 di dettatura","dictationPause":"Interrompi modalit\xe0 dettatura","prompt":"Inizia a parlare per vedere i tuoi comandi vocali qui...","dictationPrompt":"Inizia a parlare per digitare ci\xf2 che dici...","latency":"Rilevata latenza elevata. Valuta la possibilit\xe0 di chiudere alcune applicazioni che potrebbero consumare troppe risorse.","noDeviceConnectedDescription":"Il controllo del microfono serve come anteprima dell\'interfaccia. Nessun passaggio verr\xe0 eseguito correttamente. Collega questo dispositivo companion a un altro, per avviare i comandi.","status":{"loadingModel":"Caricamento modello vocale...","paused":"In pausa.","dictating":"Dettare.","optimistic":"Ottimista:","listening":"Ascolto:","thinking":"Pensiero...","loadingPhiModel":"Caricamento del modello di generazione del testo...","generatingText":"Generazione in corso...","preparingPhiModel":"Preparazione del modello di generazione del testo...","permission":"Controllo delle autorizzazioni del microfono...","typing":"Sto scrivendo..."},"generatingTextDetail":"Interrompere la generazione cambiando app o dicendo \\"interrompi generazione\\"","command":"Comando","contextual":"Contestuale","send":"Inviare","typedInputLabel":"Digita un comando o un testo da inviare","listeningPlaceholder":"Ascolto...","dictationListeningPlaceholder":"Ascolto...","pausedPlaceholder":"Pausa vocale..."},"edit":{"title":"Modifica impostazioni microfono","autoStart":{"title":"Microfono ad avvio automatico","option":"Microfono ad avvio automatico","description":"All\'accensione del dispositivo, la funzione si attiva automaticamente per l\'ascolto dei comandi vocali. Se disattivata, toccare \\"Avvia ascolto\\" per attivarla."},"optimistic":{"title":"Comandi vocali pi\xf9 veloci e ottimistici","option":"Comandi vocali pi\xf9 veloci e ottimistici","description":"Rende i comandi vocali pi\xf9 veloci e reattivi, ma meno tolleranti. Utilizza la modalit\xe0 Standard se desideri il supporto per la dettatura o una maggiore flessibilit\xe0. Nota: la modalit\xe0 Ottimista potrebbe attivarsi accidentalmente se non pronunci i comandi in modo preciso."},"confirm":{"title":"Ci sono modifiche non salvate.","description":"Sono state rilevate modifiche non salvate. Vuoi salvare prima di uscire?"},"aiCommands":{"title":"Comandi vocali intelligenti","description":"Pronuncia i comandi in modo naturale: l\'IA di Cephable capisce cosa intendi senza bisogno di una corrispondenza esatta.","option":"Comandi vocali intelligenti"},"aiDictation":{"title":"Dettatura intelligente e digitazione rapida","description":"Funzione di riconoscimento vocale migliorata con punteggiatura automatica, nomi propri e struttura delle frasi. Pronuncia `digita [qualsiasi cosa]` per utilizzare la funzione Digitazione rapida e ottenere una dettatura pi\xf9 intelligente e naturale.","option":"Dettatura intelligente e digitazione rapida"},"description":"Gestisci i comandi vocali e le impostazioni di dettatura per questa connessione.","input":{"title":"Microfono","description":"Il microfono \xe8 dotato di controllo vocale e funzione di dettatura. Cephable memorizza la tua scelta e la ripristina automaticamente ogni volta che viene effettuato il collegamento.","notConnected":"{{name}} (non connesso)","systemDefault":"Impostazioni predefinite del sistema"}},"warn":"Il microfono non \xe8 stato avviato. Avviare il microfono per consentire i comandi vocali e la dettatura.","devices":{"error":"Dispositivo di input del microfono non trovato."},"startDescription":"Attiva il microfono per iniziare ad ascoltare i comandi.","context":{"add":"Aggiungi contesto","title":"Aggiungi contesto","highlighted":"Testo evidenziato","clipboard":"Appunti","other":"Altro\u2026","otherTitle":"Aggiungi contesto personalizzato","otherPlaceholder":"Digita o incolla il contesto da utilizzare","otherConfirm":"Aggiungere","otherCancel":"Cancellare","remove":"Rimuovi contesto","required":"Il contesto \xe8 necessario per {{mode}}","files":"File\u2026","folders":"Cartelle\u2026","removeAttachment":"Rimuovere l\'allegato","dropToAttach":"Trascina file o cartelle per allegarli come contesto","otherLabel":"Contesto personalizzato"}},"localization":{"title":"Impostazioni della lingua","titleShort":"Lingua","description":"Scegli la lingua preferita dall\'elenco delle lingue supportate.","newUserDescription":"Seleziona la lingua preferita prima di continuare.","edit":"Aggiorna lingua","display":{"title":"Lingua di visualizzazione","description":"Lingua visualizzata quando si usa Cephable. Ci\xf2 include elementi come menu, notifiche e controlli delle app visualizzati nella lingua scelta."},"voice":{"title":"Lingua del controllo vocale","description":"Questa \xe8 la lingua utilizzata per riconoscere dettati e comandi vocali. Specificare la lingua aumenta la precisione degli input vocali.","settings":{"title":"Riconoscimento vocale e lingua di visualizzazione","description":"Regola le impostazioni della lingua per i controlli di visualizzazione e vocali. Questa opzione ti consente di selezionare le lingue preferite per il testo sullo schermo e le interazioni con il microfono, come i controlli vocali e la dettatura."}},"locales":{"en":"English - Inglese","en-us":"English (US) - Inglese (Stati Uniti)","es":"Espa\xf1ol \u2014 Spagnolo","fr":"Fran\xe7ais \u2013 Francese","it":"Italiano","de":"Deutsch - Tedesco","ja":"\u65E5\u672C\u8A9E - Giapponese","en-gb":"English (UK) - Inglese (Regno Unito)","en-in":"English (India) - Inglese (India)"},"save":{"success":"Preferenze locali dell\'utente salvate!","error":"Errore durante il salvataggio delle preferenze locali dell\'utente"},"profile":{"view":"Varianti","title":"Linguaggio di controllo dell\'app","question":"Quale linguaggio di controllo dell\'app desideri modificare?","description":"Alcuni controlli delle app hanno varianti per lingue diverse. Passa a un\'altra lingua per modificare e personalizzare.","change":"Cambia lingua"},"unsupported":{"title":"Lingua non supportata {{locale}}","description":"La lingua selezionata non \xe8 supportata. Scegli una lingua diversa."},"select":"Seleziona la lingua","localesShort":{"en":"Inglese","en-us":"Inglese (Stati Uniti)","es":"spagnolo","fr":"francese","it":"Italiano","de":"tedesco","ja":"giapponese","en-gb":"Inglese (Regno Unito)","en-in":"Inglese (India)"}},"invalidNumber":"N / A","upgrade":"Aggiornamento","license":{"trial":{"subtitle":"Puoi invitare {{count}} colleghi a provare Cephable insieme a te.","noUsersSubtitle":"Non hai pi\xf9 utenti di prova. Esegui l\'upgrade a una licenza a pagamento per aggiungere altri utenti.","expired":{"user":"L\'aggiornamento gratuito a {{productName}} scade il giorno {{date}}. Per effettuare l\'aggiornamento, contatta l\'amministratore della tua organizzazione - {{admin}}.","admin":"L\'aggiornamento gratuito a {{productName}} scade il {{date}}.","userLong":"Sembra che il tuo upgrade gratuito a {{productName}} sia scaduto. Per effettuare l\'upgrade, contatta l\'amministratore della tua organizzazione - {{admin}}.","adminLong":"Sembra che il tuo aggiornamento gratuito a {{productName}} sia scaduto. Puoi aggiornare la tua licenza per continuare ad accedere alle funzionalit\xe0 avanzate non disponibili in Cephable Basic."},"start":"Inizia una prova gratuita","title":{"single":"Hai effettuato l\'upgrade gratuito a {{productName}} con {{days}} giorni rimanenti","multiple":"{{organization}} \xe8 in prova gratuita con {{days}} giorni rimanenti"},"upgrade":"Eseguendo l\'aggiornamento, potrai continuare ad accedere a funzionalit\xe0 quali controlli vocali avanzati, attivit\xe0 intelligenti basate sull\'intelligenza artificiale e numerosi controlli predefiniti delle app."},"required":{"title":"\xc8 richiesta la licenza professionale Cephable","description":"Sembra che tu stia utilizzando Cephable Basic, che non supporta l\'uso commerciale di Cephable. Aggiorna a una licenza professionale per continuare a utilizzare l\'app."},"upgrade":{"professional":"Aggiornamento alla Licenza Cephable Professional","generic":{"title":"Aggiorna la Tua Esperienza Cephable","description":"La piattaforma Cephable offre diversi prodotti per uso commerciale sul lavoro, a scuola o integrati in soluzioni native."},"fallback":{"title":"Errore durante il caricamento del portale di fatturazione","description":"Impossibile caricare il portale di fatturazione. Fare clic sul pulsante sottostante per contattare sales@cephable.com e procedere con l\'aggiornamento."}},"activate":{"question":"Hai gi\xe0 una chiave di licenza?","button":"Attivare","title":"Attiva la Chiave di Licenza","description":"Inserisci la tua chiave di licenza per aggiornare Cephable. Se non ne hai una, inizia una prova gratuita o acquista una licenza.","fieldLabel":"Chiave di Licenza","placeholder":"NkmurBfZzFrmm9Kx","success":"Congratulazioni. Il tuo account \xe8 stato aggiornato a {{license}}!","invalid":{"key":"Chiave non valida. Assicurati di aver inserito la chiave corretta.","empty":{"key":"Chiave non valida. Assicurati di aver inserito un valore.","name":"Nome dell\'organizzazione non valido. Assicurati di aver inserito un valore."}},"descriptionLong":"Inserisci la tua chiave di licenza per aggiornare Cephable. Se non ne hai una, inizia una prova gratuita o acquista una licenza."},"welcome":{"title":"Benvenuti a {{license}}.","description":"Ti sei unito con successo a {{organization}}. {{description}}"},"redirect":{"title":"Reindirizzamento","description":"Sei stato reindirizzato a un portale di fatturazione esterno. Si aprir\xe0 una nuova scheda nel tuo browser. Se non vieni reindirizzato entro pochi secondi, clicca sul pulsante qui sotto.","error":"Errore di reindirizzamento della fatturazione","external":"Reindirizzamento. Controlla il tuo browser."},"key":{"title":"Chiave di licenza","titlePlural":"Chiavi di licenza","description":"Una chiave di licenza \xe8 un identificatore univoco utilizzato per concedere l\'accesso alle funzionalit\xe0 Cephable Professional, Education o Developer.","details":"Dettagli della chiave di licenza","assigned":"Utilizzato il: {{date}}","expires":"Scade il: {{date}}","assign":"Assegna la chiave alla nuova organizzazione","error":"Errore durante il caricamento della chiave di licenza.","empty":{"title":"Nessuna chiave di licenza trovata.","description":"Sembra che non ci siano chiavi di licenza che corrispondono a questo criterio. Oppure non hai ancora acquistato una chiave di licenza."},"product":{"title":"Acquistare","titleLong":"Acquista chiavi di licenza","description":"Acquista una chiave di licenza per sbloccare il pieno potenziale di Cephable. Visualizza i diversi piani e le opzioni di prezzo disponibili.","action":"Acquista ora","empty":{"title":"Nessun prodotto trovato.","description":"Sembra che tu non abbia alcun prodotto. Contatta il nostro team di vendita o il tuo rappresentante per risolvere il problema."},"yearly":"Fatturato annualmente","years":"Fatturato ogni {{value}} anni","days":"Fatturato ogni {{value}} giorni","Subscription":{"title":"Sottoscrizione"},"MeteredConsumption":{"title":"Consumo misurato"},"PayDown":{"title":"Pagare in anticipo"},"OneTime":{"title":"Una volta"}}},"pro":{"tag":"Professionista","detail":"Questa \xe8 una funzionalit\xe0 esclusiva di Cephable Professional","requiredDetail":"Per questa funzionalit\xe0 \xe8 richiesta una licenza Cephable Professional. Puoi effettuare l\'upgrade o iniziare una prova gratuita nelle Impostazioni account"},"titlePlural":"Licenze"},"purchase":"Acquistare","saveError":"Errore durante il salvataggio delle modifiche.","description":"Descrizione","expand":"Espandere","expandMenu":"Espandi Menu","editor":{"title":"Editor di markdown","bold":"Grassetto","italic":"Corsivo","underline":"Sottolineare","hr":"Regola orizzontale","link":"Collegamento","quote":"Citazione","code":"Codice","codeBlock":"Blocco di codice","comment":"Commento","image":"Immagine","table":"Tavolo","unordered-list":"Elenco non ordinato","ordered-list":"Elenco ordinato","checked-list":"Elenco controllato","help":"Aiuto","edit":"Modificare","live":"Vivere","preview":"Anteprima","fullscreen":"A schermo intero","placeholder":"Inserisci qui il testo Markdown...","strikethrough":"Barrato"},"created":"Creato: {{value}}","updated":"Aggiornato: {{value}}","deleted":"Eliminato: {{value}}","expires":"Scade: {{value}}","expired":"Scaduto: {{value}}","used":"Utilizzato: {{value}}","results":"Risultati","panel":{"title":"Pannello Cefabile","question":"Pannello di avvio automatico?","position":{"top":"Superiore","right":"Giusto","left":"Sinistra","bottom":"Metter il fondo a ","description":"Seleziona dove desideri che il pannello Cephable venga visualizzato sullo schermo.","label":"Posizione"},"sections":{"description":"Scegli quali sezioni del pannello rendere visibili. Puoi nascondere le sezioni in base alle tue preferenze per sfruttare al meglio lo spazio del pannello.","microphone":"Microfono e controlli vocali","camera":"Controlli della telecamera e del viso/testa","profile":"Controlli e anteprime delle app","globalControls":"Controlli globali e del dispositivo","tasks":"Compiti intelligenti","buttons":"Pulsanti di azione rapida"},"titleShort":"Pannello","description":"Questo \xe8 il pannello che rappresenta il centro di controllo principale. \xc8 sempre visibile e ti consente di controllare le tue app tramite comandi vocali, e altro ancora.","reconnecting":"Riconnessione\u2026","reconnectRetry":"Riprova","modes":{"title":"Modalit\xe0","generate":{"label":"Generare","placeholder":"Descrivi cosa vuoi generare"},"rewrite":{"label":"Riscrivere","placeholder":"Come dovrei riscrivere il testo?"},"translate":{"label":"Tradurre","placeholder":"Tradurre in quale lingua?"},"automate":{"label":"Automatizzare","placeholder":"Descrivi i passaggi che desideri automatizzare"},"auto":{"label":"Auto","placeholder":"Digita qualsiasi cosa: Cephable sceglie la modalit\xe0 migliore","upgrade":"Cephable necessita di {{tier}} per eseguire tale azione."},"control":{"label":"Controllare","placeholder":"Digita un comando o un testo da inviare"},"summarize":{"label":"Riassumere","placeholder":"Come vorresti riassumere o condensare il testo?"}}},"resume":"Riprendere","textGeneration":{"settings":"Impostazioni di generazione del testo","edit":{"title":"Modifica impostazioni generazione testo","description":"Puoi perfezionare le impostazioni della Generazione intelligente di testo per ottenere gli output migliori per te.","autoStart":{"title":"Generazione automatica del testo di riscaldamento","description":"Con questa impostazione attivata, Cephable AI preriscalda automaticamente i modelli di intelligenza artificiale utilizzati per le attivit\xe0 di creazione o automazione. Il preriscaldamento dei modelli ne velocizzer\xe0 le prestazioni, ma consumer\xe0 pi\xf9 risorse del computer. Disattivando questa impostazione si risparmieranno risorse, ma le attivit\xe0 potrebbero risultare pi\xf9 lente.","option":"Modelli di intelligenza artificiale che generano testo con riscaldamento automatico?"},"prompt":{"title":"Informazioni aggiuntive per la generazione di testo","description":"Inserisci dettagli aggiuntivi da utilizzare con l\'IA di Cephable per generare testo. Utilizza questo campo per inserire le preferenze per il tono, lo stile di scrittura o altri dettagli.","field":"Richiesta aggiuntiva","placeholder":"ad esempio, usa un tono amichevole, scrivi come un professionista, sii succinto e diretto. Quando scrivi codice, lascia commenti ponderati ma non troppi, ecc."},"enableTextGen":{"title":"Abilita la generazione intelligente del testo","description":"Con questa impostazione attivata, Cephable AI pu\xf2 redigere, riscrivere, riassumere e tradurre contenuti, oppure automatizzare azioni desktop nelle tue applicazioni.","option":"Utilizzare la generazione intelligente di testo?"},"terminate":{"title":"Clear AI Resources","description":"Fai clic per cancellare le risorse utilizzate per le attivit\xe0 di creazione o automazione. In questo modo verranno liberate risorse sul computer, ma queste attivit\xe0 potrebbero risultare pi\xf9 lente al successivo utilizzo.","button":"Risorse chiare","success":"Cancellazione delle risorse di generazione del testo.","confirm":{"title":"Clear AI Resources","description":"Sei sicuro di voler cancellare le risorse utilizzate per le attivit\xe0 di creazione o automazione? In questo modo verranno liberate risorse sul computer, ma queste attivit\xe0 potrebbero risultare pi\xf9 lente al successivo utilizzo.","confirm":"S\xec, risorse chiare","cancel":"Cancellare"}},"clearModelCache":{"title":"Cancella la cache dei modelli di IA","description":"In questo modo verr\xe0 liberato spazio di archiviazione sul computer e verr\xe0 scaricato nuovamente il modello attualmente selezionato.","button":"Cancella e scarica di nuovo","success":"File del modello locale eliminati.","confirm":{"title":"Cancella e scarica nuovamente la cache del modello AI","description":"Sei sicuro di voler cancellare la cache del modello AI ed eliminare i file dal tuo sistema? Il modello attualmente selezionato verr\xe0 scaricato nuovamente automaticamente.","confirm":"S\xec, cancella e scarica di nuovo","cancel":"Cancellare"},"error":"Errore durante l\'eliminazione dei file del modello locale."},"enableHistory":{"title":"Abilita cronologia generazione testo","description":"Se questa impostazione \xe8 attivata, Cephable AI utilizzer\xe0 la cronologia di generazione del testo per generare testo con il contesto dell\'azione precedente.","option":"Utilizzare la cronologia di generazione del testo?"},"modelSelection":{"title":"Modello di intelligenza artificiale","description":"Scegli la famiglia di modelli di intelligenza artificiale e le dimensioni compatibili con questo dispositivo. I modelli pi\xf9 grandi producono risultati migliori, ma consumano pi\xf9 risorse. Scarica pi\xf9 modelli per passare rapidamente da uno all\'altro.","family":"Famiglia modello","size":"Dimensioni del modello","downloaded":"Scaricato","downloading":"Download in corso\u2026","download":"Scaricamento","delete":"Elimina il download","unavailable":"Non supportato su questo dispositivo","requiresBetterDevice":"Questo modello richiede un dispositivo pi\xf9 potente per funzionare.","selectPrompt":"Seleziona un modello","noModels":"Al momento non sono disponibili modelli compatibili con questo dispositivo.","deleteConfirm":{"title":"Eliminare il modello scaricato?","description":"In questo modo si libera spazio sul disco. Potrai scaricarlo di nuovo in seguito."},"notDownloaded":"Questo modello \xe8 stato selezionato ma non \xe8 ancora stato scaricato. Fai clic su Scarica per utilizzarlo.","readyToUse":"Scaricato \u2014 pronto all\'uso","offlineNoModels":"Non sei connesso a Internet e su questo dispositivo non sono ancora stati salvati modelli. Connettiti per visualizzare e scaricare i modelli disponibili.","offlineDownloadUnavailable":"Non sei connesso a Internet, quindi questo modello non pu\xf2 essere scaricato. Connettiti a Internet per scaricarlo oppure passa a un modello che hai gi\xe0 scaricato.","license":{"upgrade":"Richiede un aggiornamento della licenza","blockedNeedsDownload":"Questo modello richiede {{license}}. Scarica un modello precedente o esegui l\'aggiornamento per continuare."},"notEnoughSpace":"Spazio insufficiente sul dispositivo","notEnoughSpaceDetail":"Richiede {{required}} ma su questo dispositivo \xe8 disponibile solo {{free}}. Libera spazio e riprova.","fallback":{"alert":"Viene utilizzato {{fallback}} al posto di {{preferred}}, il che richiede un aggiornamento.","active":"{{preferred}} richiede {{license}}. {{fallback}} viene utilizzato al suo posto finch\xe9 non si sceglie un modello diverso o si effettua un aggiornamento."}}},"prompt":{"systemPrompt":"Genera SOLO il testo richiesto, senza spiegazioni, commenti o divagazioni. Non sono ammessi markdown o spiegazioni non richiesti. Per il codice, genera solo codice grezzo: senza delimitatori, tag di linguaggio o spiegazioni. Non spiegare cosa hai fatto.","appName":"Al momento stai generando testo per {{appName}}.","userPreferences":"Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}."},"translatePrompt":{"systemPrompt":"Traduci il seguente testo in {{language}}. Visualizza SOLO il testo tradotto. Nessuna spiegazione, nessun preambolo, nessuna formattazione Markdown, nessuna barriera di codice, nessuna nota, nessuna osservazione tra parentesi sulla traduzione. Mantieni la formattazione. Per il codice: traduci solo commenti e stringhe, preserva la sintassi esattamente.","userPreferences":"Rispettare le seguenti preferenze utente su come desidera che venga generato il testo: {{userPreferences}}.","genericUserPrompt":"Traduci: {{userRequestText}}"},"disabled":{"title":"Le attivit\xe0 intelligenti sono disabilitate","description":"Sembra che tu abbia disabilitato le attivit\xe0 intelligenti. Aggiorna per sbloccare la generazione di testo, la riscrittura e altro ancora nelle impostazioni."},"skipTyping":{"complete":"{{task}} completata e pronta per essere copiata negli appunti."},"summarizePrompt":{"systemPrompt":"Riassumi in modo conciso il testo fornito. Pu\xf2 far parte di un documento pi\xf9 ampio. Non utilizzare la formattazione Markdown o i blocchi di codice. Pubblica SOLO il riassunto: nessun preambolo, etichette, spiegazione o commento, e non descrivere le operazioni eseguite.","userPreferences":"Rispetta le preferenze dell\'utente relative alla modalit\xe0 di generazione del testo: {{userPreferences}}.","summarizeInstructions":"Istruzioni: {{summarizeInstructions}}.","userPrompt":"Riepilogo: {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"Riscrivi o riformatta il testo fornito come indicato. In caso di riformattazione (ad esempio, elenchi, tabelle, modifiche alla struttura), conserva esattamente le parole originali. In caso di riscrittura (ad esempio, tono, stile, lunghezza), conserva il significato ma non necessariamente le parole. Questo testo pu\xf2 far parte di un documento pi\xf9 ampio. Mantieni la formattazione del testo di partenza: se il testo sorgente \xe8 gi\xe0 in Markdown o codice, conservalo. Altrimenti, non introdurre la formattazione Markdown (titoli, grassetto, elenchi puntati, delimitatori di codice) a meno che le istruzioni non richiedano esplicitamente un elenco, una tabella o una struttura simile. Pubblica SOLO il risultato finale, senza preamboli, etichette, titoli, spiegazioni o commenti.","userPreferences":"Rispetta le preferenze dell\'utente relative alla modalit\xe0 di generazione del testo: {{userPreferences}}.","rewriteInstructions":"Istruzioni: {{rewriteInstructions}}."}},"profile":{"title":"Controlli dell\'app","titlePlural":"Controlli dell\'app","titlePreview":"Anteprima dei controlli","previous":"Controlli app precedenti","manage":"Gestisci i controlli delle app","view":"Visualizza controlli","edit":"Modifica controlli app","add":"Aggiungi controlli app","create":"Crea controlli app","warn":"Per poter utilizzare i controlli dell\'app, \xe8 necessario che la fotocamera o il microfono siano attivi.","descriptionShort":"Scopri i diversi modi in cui Cephable ti aiuta a controllare i tuoi dispositivi e software.","name":"Nome dell\'app","nameQuestion":"Come vuoi chiamare questi controlli dell\'app?","newName":"Nuovi controlli dell\'app","search":"Cerca i controlli dell\'app per nome","searchLong":"Cerca i controlli dell\'app per nome o descrizione","keyboardAndMouse":"Tastiera e mouse","genericController":"Controllore del gamepad","keyboardMouseAndController":"Tastiera, mouse e controller","permissionError":"Non hai l\'autorizzazione per utilizzare questi controlli dell\'app.","set":{"title":"Sembra che non hai ancora impostato i controlli dell\'app.","cta":"Imposta i controlli dell\'app","empty":{"auto":"Passa a un\'altra app per vedere i controlli","select":"Seleziona un controllo per iniziare","none":"Nessun controllo dell\'app trovato"},"description":"I controlli delle app consentono a Cephable di sapere cosa ascoltare e quali azioni intraprendere. Puoi cambiare i controlli delle app in qualsiasi momento dalla homepage o dalle impostazioni di connessione."},"summary":{"title":"Riepilogo dei controlli dell\'app","descriptionLong":"Ecco i dettagli di questi controlli app. Puoi cercare controlli, azioni e altro per vedere cosa puoi fare con questi controlli app.","description":"Ottieni un riepilogo di questi controlli dell\'app, inclusi i controlli disponibili, le personalizzazioni, i dettagli e altro ancora.","view":"Visualizza il riepilogo dei controlli dell\'app","filter":"Filtra per tipo di input","placeholder":"Cerca nomi di controllo..."},"copy":{"title":"Copia controlli app","duplicate":"Controlli app duplicati","question":"Creare una copia?","description":"Vuoi creare una nuova copia di questi controlli app? Si aprir\xe0 una nuova finestra con questi controlli app copiati, ma non verranno aggiunti al tuo account finch\xe9 non li salvi.","confirm":"S\xec, crea una copia","profileSuffix":"{{name}} (copia)"},"new":{"title":"Crea nuovi controlli app","description":"Crea controlli da zero o lascia che l\'intelligenza artificiale all\'avanguardia generi controlli personalizzati, consentendoti di usare app e software senza sforzo, usando la voce, i gesti della testa e del viso.","note":"Consigliato per utenti avanzati.","scratch":"Crea da zero"},"advancedOptions":"Opzioni di controllo avanzate","delete":{"title":"Elimina i controlli dell\'app","titleLong":"Elimina questi controlli dell\'app","description":"Puoi eliminare questi controlli app cliccando su \\"Elimina controlli app\\".","confirm":"Sei sicuro di voler eliminare questi controlli dell\'app?","confirmLong":"Una volta eliminati questi controlli app, non potrai pi\xf9 tornarci. Vuoi davvero eliminare questi controlli app?","confirmButton":"S\xec, elimina questi controlli dell\'app"},"current":"Controlli attuali","loading":"Caricamento controlli...","null":"Non hai ancora controlli app. Clicca qui sotto per crearne uno.","nullButton":"Crea i tuoi primi controlli app","preview":"Anteprima","features":"Caratteristiche","byline_public":"Di: Cephable Team","byline_shared":"Condiviso da: Comunit\xe0 Cephable","share":{"title":"Condividi i controlli dell\'app","previewTitle":"Anteprima dei controlli delle app condivise","description":"Condividi questi controlli dell\'app con altri in modo che possano averne una copia e personalizzarli!","descriptionLong":"Condividi questi controlli app con altri in modo che possano ottenere una copia e personalizzarli da l\xec! Scegli come vuoi condividere, quindi crea un collegamento da inviare ad altri.","add":"Crea un collegamento di condivisione","confirm":"Condividi questo URL","link":"Condividi collegamento","copy":"Copia collegamento","copied":"Copiato!","usage":"Quantit\xe0 di utilizzo","created":"Creato {{value}}","expiration":{"title":"Scadenza","once":"Consentire solo un utilizzo","unlimited":"Consentire un utilizzo illimitato","no":"Nessuna scadenza","date":"Data di scadenza","dateDescription":"Scadenza in una data specifica"},"manage":"Gestisci i link di condivisione precedenti","empty":"Non sono state create condivisioni per questi controlli dell\'app."},"swap":{"title":"Controlli di scambio","titleLong":"Scambia i controlli delle tue app","descriptionShort":"Utilizza diversi controlli dell\'app in base al programma o al software che stai utilizzando.","description":"\xc8 possibile alternare i diversi controlli delle app in base al programma o al software in uso."},"autoProfileSwitching":{"title":"Commutazione automatica del controllo","alerts":{"disabled":"La commutazione automatica del controllo \xe8 disattivata.","temporarilyDisabled":"La commutazione automatica del controllo \xe8 temporaneamente disattivata.","enabled":"La commutazione automatica del controllo \xe8 attivata.","error":"Errore durante il salvataggio delle preferenze di commutazione del controllo automatico"},"associatedPrograms":{"add":"Aggiungi un nuovo programma associato","description":{"personal":"Scegli il software o i programmi che vuoi connettere a questi controlli. Questo supporta la commutazione automatica dei controlli, in cui Cephable commuta automaticamente questi controlli delle app per adattarli al programma corrente che stai utilizzando.","short":"Seleziona il software o i programmi che desideri connettere a questi controlli."},"edit":"Modifica programmi associati","noOptionsText":"Inizia a digitare per trovare i programmi associati","profileLabel":"Controlli dell\'app:","remove":"Rimuovi programma associato","title":"Programmi associati","when":"Cephable cambier\xe0 automaticamente i controlli della mia app in {{profileName}} quando utilizzo...","emptySearch":"Non ci sono programmi associati a questi controlli.","error":"Errore durante il salvataggio dei programmi associati. Riprova pi\xf9 tardi.","emptyError":"Rilevato programma associato vuoto. Rimuoverlo prima di continuare."},"commandOverlay":{"command":"Cambiare i controlli dell\'app: {{value}}"},"description":"La commutazione automatica dei controlli consente a Cephable di adattarsi perfettamente al tuo flusso di lavoro. Se attivata, Cephable regoler\xe0 contestualmente i controlli dell\'app in base al programma o al software in uso. Se disattivata, puoi cambiare manualmente i controlli dell\'app utilizzando il pulsante \\"Cambia controlli\\" o i comandi globali."},"error":{"noMatch":"Nessun controllo app corrisponde alla tua ricerca.","load":"Errore durante il caricamento dei controlli dell\'app.","add":"Errore durante l\'aggiunta dei controlli dell\'app.","delete":"Errore durante l\'eliminazione dei controlli dell\'app.","audioEventsWithEmptyCommands":"Mancano dei controlli nel tuo talk back. Controlla i controlli del tuo talk back per assicurarti di compilarlo completamente.","conflicts":"Errore durante il salvataggio dei controlli dell\'app a causa di conflitti.","save":"Errore durante il salvataggio dei controlli dell\'app. Riprova.","device":"Controllo app non valido per questa connessione. Provane un altro."},"conflictIndicators":{"errorTitle":"Errore durante il salvataggio dei controlli dell\'app a causa di conflitti","warningTitle":"Controlli dell\'app salvati con avvisi","subtitle":"I controlli dell\'app creati presentano alcune configurazioni che potrebbero creare conflitti.","profileNameErrors":"Conflitto di nomi dei controlli app","emptyControlsMapped":"Nomi di input vuoti","emptyControlsMappedDescription":"Aggiungi un comando vocale, un\'espressione facciale, un\'inclinazione della testa o un altro comando al tuo input.","emptyKeybindingControlsMapped":"Nomi di input vuoti per le combinazioni di tasti","emptyKeybindingControlsMappedDescription":"Aggiungi un comando vocale, un\'espressione facciale, un\'inclinazione della testa o un altro comando all\'input per le associazioni di tasti.","duplicateNameTitle":"Nome dei controlli app duplicati","duplicateNameDescription":"Hai gi\xe0 un controllo app con lo stesso nome. Cambia il nome prima di continuare.","emptyNameTitle":"Nome dei controlli dell\'app vuoto","emptyNameDescription":"I controlli dell\'app devono avere un nome, ad esempio Gioco 1, Spotify, Word, ecc.","macrosReleaseKeysMissingTitle":"Uscite con tasti non rilasciati","macrosReleaseKeysMissingDescription":"Aggiungere una chiave di sblocco o interrompere tutti i passaggi per evitare che i tasti rimangano incastrati.","duplicateInputCommandMacroTitle":"Input di controllo identici","duplicateCommandsDescription":"Si prega di rimuovere o modificare i comandi di input duplicati.","duplicateInputCommandBindingsTitle":"Input di controllo identici per le associazioni di tasti","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} con {{commandOrEventType}}","duplicateMacroNames":"Nomi di controllo duplicati","duplicateMacroNamesDescription":"Si prega di rimuovere o modificare uno dei nomi di controllo identici.","warningIgnore":"Ignorare","warningDoNotShowAgain":"Non mostrare pi\xf9 gli avvisi","macrosVoiceCommandConflictWithDictationTitle":"Controlla i comandi vocali come le parole chiave della dettatura","keybindingsVoiceCommandConflictWithDictationTitle":"I comandi vocali delle associazioni di tasti sono gli stessi delle parole chiave della dettatura","macrosVoiceCommandConflictWithDictationDescription":"I tuoi input vocali attiveranno la dettatura e i comandi vocali.","keybindingsVoiceCommandConflictWithDictationDescription":"I tuoi input vocali attiveranno la dettatura e la pressione dei tasti.","macrosVoiceCommandConflictWithGenerationTitle":"I comandi vocali di controllo sono gli stessi delle parole chiave di generazione","keybindingsVoiceCommandConflictWithGenerationTitle":"I comandi vocali delle associazioni di tasti sono gli stessi delle parole chiave di generazione","macrosVoiceCommandConflictWithGenerationDescription":"I tuoi input vocali attiveranno la generazione e i comandi vocali.","keybindingsVoiceCommandConflictWithGenerationDescription":"I tuoi input vocali attiveranno la generazione e la pressione dei tasti.","duplicateAssociatedProgramNames":"Nomi di programmi associati duplicati","duplicateAssociatedProgramNamesDescription":"Si prega di rimuovere o modificare uno dei programmi identici associati.","emptyEvent":{"title":"Passaggi mancanti","description":"Ci sono dei passaggi mancanti nei tuoi controlli. Questo potrebbe portare Cephable a non eseguire un\'azione quando dai un comando."},"warningDetails":"Visualizza tutti i conflitti"},"success":{"save":"Controlli dell\'app salvati.","add":"Aggiunti controlli app.","delete":"Controlli dell\'app eliminati.","share":"Condividi il collegamento creato e copiato negli appunti","shareDelete":"Link di condivisione eliminato.","generate":"Controlli dell\'app generati."},"warning":"Controlli dell\'app salvati con avvisi","customize":"Personalizza i controlli dell\'app","custom":"{{name}} (personalizzato)","description":"I controlli app sono un insieme di controlli che puoi utilizzare per gestire il tuo dispositivo o la tua connessione. Puoi creare pi\xf9 controlli app e passare da uno all\'altro quando vuoi."},"publicProfiles":{"toolbar":"Esplora i controlli delle app","title":"Esplora i controlli delle app","offline":{"title":"Impossibile caricare i controlli dell\'app pubblica","description":"Sembra che tu sia offline. Puoi comunque usare i controlli dell\'app, ma non sarai in grado di caricare nuovi controlli dell\'app pubblici.","confirm":"Va bene"},"announcement":"{{count}} Sono stati caricati nuovi controlli app","description":{"personal":"Sono disponibili controlli app pubblici per aiutarti a iniziare rapidamente a usare Cephable sulle tue app preferite. Puoi usare i controlli predefiniti, personalizzarli in base alle tue esigenze o creare controlli app personalizzati completamente nuovi da zero.","pro":"Sono disponibili controlli app pubblici per aiutarti a iniziare rapidamente a usare Cephable sulle tue app preferite. Puoi usare i controlli predefiniti, personalizzarli in base alle tue esigenze o creare controlli app personalizzati completamente nuovi tramite il generatore di controlli."},"team":"Squadra Cefabile"},"publicTag":"Pubblico","tray":{"panel":"Pannello di attivazione/disattivazione","dashboard":"Mostra dashboard","quit":"Smettila di Cephable"},"generate":"Generare","stop":"Fermare","clear":"Chiaro","rewrite":"Riscrivere","translate":"Tradurre","smartTasks":{"title":"Compiti intelligenti","show":"Mostra attivit\xe0 intelligenti","description":"Le attivit\xe0 intelligenti sono le diverse attivit\xe0 che l\'intelligenza artificiale di Cephable pu\xf2 svolgere per te. Queste attivit\xe0 sono basate sull\'intelligenza artificiale integrata nel dispositivo e possono essere utilizzate per creare testi, riassumere, riscrivere, tradurre, prendere appunti e chattare con i documenti.","generateText":{"title":"Genera testo","description":"Crea contenuti di testo in base ai tuoi input o ai tuoi prompt.","label":"Descrivi cosa vuoi generare"},"summarizeText":{"title":"Riassumere il testo","description":"Ricava informazioni utili da testi lunghi e crea brevi riassunti o evidenzia i punti chiave.","directions":"Inserisci il testo da riassumere, altrimenti Cephable utilizzer\xe0 automaticamente il testo evidenziato.","write":"Scrivi un riassunto","outputLabel":"Il tuo riepilogo apparir\xe0 qui.","inputLabel":"Inserisci il testo da condensare"},"rewriteText":{"title":"Riscrivi il testo","description":"Evidenzia il testo in un\'altra app in cui stai scrivendo, quindi torna qui e descrivi come vuoi che venga riscritto.","label":"Descrivi come vuoi riscrivere il testo","inputLabel":"Inserisci il testo da riscrivere"},"translateText":{"title":"Traduci testo","description":"Inserisci il testo da tradurre, altrimenti Cephable utilizzer\xe0 automaticamente il testo evidenziato.","label":"Inserisci il testo da tradurre","languageLabel":"Lingua da tradurre"},"noteTaker":{"title":"Prenditore di appunti","description":"Lascia che Cephable registri e trascriva localmente le tue riunioni o conversazioni"},"documentChat":{"title":"Chat sui documenti","description":"Interagisci con i documenti e interrogali per ottenere informazioni rapide."},"highlightText":{"title":"Usa il testo evidenziato","description":"Cephable pu\xf2 utilizzare automaticamente il testo evidenziato in qualsiasi app per eseguire operazioni come riassumere, riscrivere o tradurre. Puoi anche inserire il testo manualmente, se preferisci.","label":"Inserisci il testo da utilizzare","placeholder":"Puoi anche evidenziare il testo in un\'altra app e tornare qui per utilizzarlo.","noTextFound":"Nessun testo trovato. Seleziona il testo in un\'altra app oppure incollalo nel campo e riprova."},"pasteText":{"title":"Incolla il testo","description":"Cephable pu\xf2 utilizzare automaticamente il testo copiato negli appunti per eseguire attivit\xe0 come riassumere, riscrivere o tradurre. Puoi anche inserire il testo manualmente, se preferisci.","label":"Inserisci il testo da utilizzare","placeholder":"Puoi anche evidenziare il testo in un\'altra app e tornare qui per utilizzarlo."},"clearCache":"Se riscontri problemi durante la generazione, cancella la cache e le risorse dalle impostazioni di generazione del testo e riprova.","transcribeAudio":{"title":"Trascrivi audio","description":"Converti file audio o video in testo utilizzando la trascrizione AI.","inputMethod":"Scegli il metodo di input","localFile":"File locale","url":"URL","selectFile":"Seleziona file audio/video","urlLabel":"URL audio/video","transcribe":"Trascrivere","result":"Risultato della trascrizione","invalidFileType":"Seleziona un file audio o video valido (mp3, wav, ogg, mp4, webm, mov, avi)","error":"Errore di trascrizione","history":{"title":"Cronologia della trascrizione","description":"Visualizza e gestisci le trascrizioni salvate.","viewHistory":"Visualizza cronologia","empty":"Nessuna trascrizione ancora. Inizia a trascrivere per costruire la tua storia!","titleLabel":"Titolo (facoltativo)","titlePlaceholder":"Inserisci un titolo per questa trascrizione","textLabel":"Testo di trascrizione","confirmDelete":"Sei sicuro di voler eliminare questa trascrizione?"}},"aiWorkflows":{"description":"Automatizza le attivit\xe0 del tuo desktop e del tuo browser con l\'intelligenza artificiale. Descrivi semplicemente cosa vuoi realizzare e guarda Cephable eseguire le azioni per te.","label":"Descrivi cosa vuoi realizzare","status":{"idle":"In attesa delle tue istruzioni...","initializing":"Preparando tutto...","planning":["Fare un piano...","Analizziamo la tua richiesta...","Mappatura dei passaggi...","Organizzazione del flusso di lavoro...","Preparazione della strategia...","Creare un piano d\'azione...","Scoprire il modo migliore per aiutarti...","Determinare come affrontare questo...","Analisi della tua richiesta in corso...","Pianificazione dell\'esecuzione..."],"thinking":["Pensiero..."],"waitingForUser":"Il tuo contributo \xe8 necessario per continuare.","completed":"Successo!","failed":"La tua richiesta non \xe8 andata a buon fine: {{message}}","canceled":"La tua richiesta \xe8 stata annullata.","terminated":"Fermo. Attendo istruzioni...","thinkingInteractive":["Considerando il passo successivo...","Rivediamo cosa abbiamo fatto finora...","Decidere cosa fare dopo...","Analizzando i risultati...","Pianificando la continuazione...","Valutando le opzioni...","Cercando di capire qual \xe8 il passo successivo migliore...","Stiamo lavorando alla parte successiva della tua richiesta...","Stiamo lavorando ai prossimi passi...","Elaborazione dei risultati del passaggio precedente..."],"tools":{"click_element_by_index":{"executing-start":"Cliccando sul pulsante corrispondente...","executing-complete":"Ho cliccato su {{params.index}}."},"click_element":{"executing-start":"Cliccando sul numero evidenziato...","executing-complete":"Ho cliccato su {{params.elementName}}."},"copy_selection":{"executing-start":"Raccolta del contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"draft_email":{"executing-start":"Bozza di un\'e-mail...","executing-complete":"Ho scritto una bozza di email su {{params.subject}}."},"execute_app_action":{"executing-start":"Esecuzione di {{params.actionName}}...","executing-complete":"{{params.actionName}} completato."},"find_all_text":{"executing-start":"Ricerca di tutto il contesto rilevante su {{params.searchText}}...","executing-complete":"Ho trovato tutto il contesto rilevante su {{params.searchText}}."},"find_and_select_text":{"executing-start":"Ricerca e selezione del contesto rilevante su {{params.searchText}}...","executing-complete":"Ho trovato e selezionato il contesto pertinente su {{params.searchText}}."},"generate_text":{"executing-start":"Creazione di contenuti...","executing-progress":"Creazione di contenuti...{{progress}}%","executing-complete":"Ho creato il contenuto richiesto."},"get_all_interactive_elements":{"executing-start":"Scansione per ottenere pi\xf9 contesto...","executing-complete":"Capisco con cosa posso interagire."},"get_all_text_elements_content":{"executing-start":"Leggendo per avere pi\xf9 contesto...","executing-complete":"Ho capito quali contenuti testuali sono disponibili."},"get_all_text_elements_names":{"executing-start":"Leggendo per avere pi\xf9 contesto...","executing-complete":"Ho capito quali contenuti testuali sono disponibili."},"get_available_profile_actions":{"executing-start":"Verifica quali controlli sono disponibili in questa app...","executing-complete":"Ho capito cosa posso fare con questa app."},"get_document_content":{"executing-start":"Leggendo per avere pi\xf9 contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"get_installed_apps":{"executing-start":"Decidere quale app \xe8 rilevante per la tua richiesta...","executing-complete":"So quali app posso usare."},"get_running_app_names":{"executing-start":"Decidere quale app \xe8 rilevante per la tua richiesta...","executing-complete":"So quali app posso usare."},"get_selected_text":{"executing-start":"Lettura del contenuto selezionato...","executing-complete":"Ho un contesto sul contenuto selezionato."},"get_stored_content":{"executing-start":"Raccolta del contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"keyboard_shortcut":{"executing-start":"Raccolta del contesto...","executing-complete":"Ho il contesto pronto per la parte successiva della tua richiesta."},"open_app":{"executing-start":"Apertura di {{params.appName}}...","executing-complete":"Ho aperto {{params.appName}}."},"open_webpage":{"executing-start":"Apertura di {{params.url}}...","executing-complete":"Ho aperto {{params.url}}."},"paste_content":{"executing-start":"Scrivere...","executing-complete":"Ho finito di scrivere."},"respond_to_user":{"executing-start":"Completamento della richiesta in corso...","executing-complete:":"Ho completato la tua richiesta."},"search_browser":{"executing-start":"Ricerca sul Web di {{params.query}}...","executing-complete":"Ho cercato sul web {{params.query}}."},"select_all_text":{"executing-start":"Selezione di tutto il testo...","executing-complete":"Ho selezionato tutto il testo."},"summarize_text":{"executing-start":"Riassumendo il testo...","executing-progress":"Riassumendo...{{progress}}%","executing-complete":"Ho riassunto il testo."},"translate_text":{"executing-start":"Traduzione del testo in {{params.targetLanguage}}...","executing-progress":"Traduzione in corso...{{progress}}%","executing-complete":"Ho tradotto il testo in {{params.targetLanguage}}."},"type_stored_content":{"executing-start":"Scrivere...","executing-complete":"Ho finito di scrivere."},"type_text":{"executing-start":"Scrivere...","executing-complete":"Ho finito di scrivere."},"unknown":{"executing-start":"Ho riscontrato un problema, provando una strategia diversa...","executing-complete":"Ho provato una strategia diversa."},"append_to_file":{"executing-start":"Aggiunta al file...","executing-complete":"Ho aggiunto del contenuto al file."},"copy_path":{"executing-start":"Copia in corso...","executing-complete":"L\'ho copiato."},"create_directory":{"executing-start":"Creazione della cartella in corso...","executing-complete":"Ho creato la cartella."},"delete_path":{"executing-start":"Eliminazione in corso...","executing-complete":"L\'ho cancellato."},"edit_user_file":{"executing-start":"Modifica del file in corso...","executing-complete":"Ho modificato il file."},"get_file_info":{"executing-start":"Controllo del file in corso...","executing-complete":"Ho controllato il file."},"list_directory":{"executing-start":"Elenco delle cartelle...","executing-complete":"Ho elencato la cartella."},"move_path":{"executing-start":"Trasloco...","executing-complete":"L\'ho spostato."},"open_path":{"executing-start":"Apertura...","executing-complete":"L\'ho aperto."},"read_user_file":{"executing-start":"Lettura del file in corso...","executing-complete":"Ho letto il file."},"run_command":{"executing-start":"Esecuzione di un comando...","executing-complete":"Ho eseguito il comando."},"search_files":{"executing-start":"Ricerca dei file in corso...","executing-complete":"Ho trovato i file corrispondenti."},"search_in_files":{"executing-start":"Ricerca all\'interno dei file...","executing-complete":"Ho cercato all\'interno dei file."},"write_user_file":{"executing-start":"Scrittura del file...","executing-complete":"Ho scritto il file."},"rewrite_text":{"executing-progress":"Riscrittura in corso...{{progress}}%"},"analyze_table":{"executing-start":"Analizzando la tabella...","executing-complete":"Ho analizzato la tabella."}},"networkError":"Connessione persa durante il download del modello. Controlla la tua connessione Internet e riprova inviando un messaggio o riavviando l\'app.","executing-org-block":"Impossibile utilizzare {{params.toolName}} perch\xe9 l\'interazione con {{params.appOrDomain}} \xe8 bloccata dall\'organizzazione.","executing-destructive-block":"L\'interazione con {{params.elementName}} \xe8 bloccata. Si prega di rivedere ed eseguire questa azione manualmente.","executing-type-focus-block":"Ho riscontrato un problema durante la scrittura del contenuto. \xc8 stato copiato negli appunti, si prega di incollarlo manualmente.","executing-permission-block":"Ho riscontrato un problema nell\'accesso al file.","stopped":"Fermato.","unsupportedOSVersion":"Il tuo sistema macOS \xe8 obsoleto, aggiornalo e riprova.","loadNotice":{"firstRunSetup":"Configurazione iniziale dell\'IA sul dispositivo. Questa operazione potrebbe richiedere alcuni minuti, ma sar\xe0 pi\xf9 veloce la prossima volta.","largeModel":"Caricamento di {{model}} ({{size}} GB). Il caricamento dei modelli pi\xf9 grandi pu\xf2 richiedere alcuni minuti. Per risultati pi\xf9 rapidi, passa a un modello pi\xf9 piccolo nelle Impostazioni.","driverIssue":"Il driver della tua scheda grafica potrebbe essere obsoleto, pertanto l\'intelligenza artificiale integrata nel dispositivo sta utilizzando una modalit\xe0 pi\xf9 lenta. Aggiornare il driver della scheda grafica pu\xf2 renderla pi\xf9 veloce e affidabile.","longTask":"Questa operazione si sta allungando, quindi le sto concedendo pi\xf9 tempo per essere completata. Potrebbe richiedere fino a un minuto."}},"ready":{"waiting":"AI Workflows \xe8 pronto. In attesa delle tue istruzioni.","execute":"AI Workflows \xe8 pronto. A partire dalla tua richiesta..."},"start":"Inizio","progress":"Lavorando...","title":"I tuoi flussi di lavoro di IA sono pronti","steps":{"thinking":"Pensiero","tool":"Attrezzo","details":"Dettagli","chunkProgress":"parte {{attuale}} del {{totale}}","output":"Produzione","showMore":"Mostra altro","showLess":"Mostra meno","contentUsed":"Contenuto utilizzato","contentSource":"Contenuto di origine","contentTruncated":"Mostra i primi {{shown}} di {{total}} caratteri","error":"Errore"},"prefix":"Flusso di lavoro:","files":{"sectionTitle":"File","open":"Aprire","openFile":"Apri il file","openFolder":"Apri la cartella","openError":"Impossibile aprire \\"{{name}}\\". Potrebbe essere stato spostato o eliminato."},"input":{"other":"Altro\u2026","otherPlaceholder":"Digita la tua risposta","submit":"Inviare"},"continue":{"label":"Continuare","placeholder":"Chiedi a Cephable di fare di pi\xf9 con questo risultato\u2026"},"retry":{"label":"Riprova"},"context":{"approaching":"Questa conversazione si sta allungando ({{percent}}% della memoria dell\'IA utilizzata). I messaggi pi\xf9 vecchi potrebbero essere presto eliminati.","trimmed":"Questa conversazione ha raggiunto il limite di memoria dell\'IA, quindi potrebbe iniziare a dimenticare i messaggi precedenti. Avvia un nuovo flusso di lavoro per ripristinare la situazione.","indicator":"{{percent}}% di memoria di lavoro utilizzata","indicatorPending":"Memoria di lavoro utilizzata per questo flusso di lavoro","indicatorTokens":"{{used}}/{{budget}} utilizzato"},"approval":{"title":"Conferma azione","approve":"Approvare","reject":"Rifiutare","edit":"Modificare","deletePath":"Eliminare questo file/cartella? Questa operazione \xe8 permanente.","runCommand":"Eseguire questo comando shell?","movePath":"Spostare/rinominare questo percorso? Potrebbe sovrascrivere la destinazione.","confirmDelete":"Eliminare","confirmRun":"Esegui il comando","confirmMove":"Mossa","badgeDestructive":"Distruttivo","badgeCaution":"Attenzione"},"browser":{"sectionTitle":"Sito web","view":"Visualizza il browser","open":"Aprire","openError":"Impossibile aprire il browser."},"resume":{"title":"Continua la conversazione precedente","description":"Consulta la cronologia delle tue automazioni e riprendi da dove avevi interrotto.","searchPlaceholder":"Cerca nelle chat precedenti\u2026","noMatches":"Nessuna chat precedente corrisponde a \\"{{query}}\\"","empty":"Nessuna automazione precedente ancora.","continuing":"Continua la chat","stopContinuing":"Avvia invece una nuova chat","indicator":"Continuando la conversazione su \\"{{title}}\\"","clear":"Cancella la chat selezionata"}},"generatedByAI":"Basato sull\'intelligenza artificiale integrata nel dispositivo, si prega di verificarne l\'accuratezza.","networkError":"Connessione persa durante il download del modello. Controlla la tua connessione Internet e riprova inviando un messaggio o riavviando l\'app.","genericError":"Si \xe8 verificato un errore imprevisto. Riprova.","download":{"title":"Scarica i modelli di intelligenza artificiale per sbloccare ulteriori funzionalit\xe0.","description":"Per utilizzare le attivit\xe0 intelligenti, \xe8 necessario scaricare un modello locale sul dispositivo. Questo garantisce che i dati rimangano privati e non vengano mai inviati al cloud.","confirm":"Scaricamento","cancel":"Non adesso"},"runningInBackground":{"generate":"Generazione in background...","rewrite":"Riscrittura in background...","translate":"Traduzione in background...","summarize":"Riassumendo il contesto...","generic":"In esecuzione in background..."},"processing":"Elaborazione in corso..."},"inputMethod":"Metodo di input:","hotkey":{"title":"Pulsante di azione rapida","titlePlural":"Pulsanti di azione rapida","titlePanel":"Azioni rapide","label":"Nome visualizzato del pulsante di azione rapida","placeholder":"Nome da visualizzare","question":"Come vorresti chiamare questo pulsante?","when":"Quando tocco...","description":"I pulsanti di azione rapida sono pulsanti personalizzabili che puoi toccare per eseguire azioni pertinenti nella tua app. Un singolo tocco pu\xf2 eseguire pi\xf9 passaggi o una singola azione.","usagePrompt":"I pulsanti di azione rapida sono pulsanti personalizzabili che puoi toccare per eseguire azioni pertinenti nella tua app. Puoi aggiungerli, rimuoverli o modificarne i nomi dalla pagina principale delle impostazioni dei controlli dell\'app.","reorder":"\xc8 possibile modificare l\'ordine utilizzando i pulsanti \\"Sposta su\\" e \\"Sposta gi\xf9\\".","emptyTitle":"Nessun pulsante di azione rapida","edit":"Modifica pulsanti di azione rapida","tap":"Tocca {{value}}","copySuffix":"{{name}}_copia","hotkeysOnly":"Pulsanti personalizzati","allControls":"Tutti i controlli delle app","show":"Mostra pulsanti di azione rapida","deprecatedDialog":{"title":"I controlli dell\'app richiedono un aggiornamento.","description2":"Basta un rapido aggiornamento, letteralmente un secondo, e potrai goderti un\'esperienza di personalizzazione dei pulsanti impeccabile. Di\' addio ai passaggi aggiuntivi e dai il benvenuto a un\'interfaccia pi\xf9 intuitiva. Pronto a cambiare?","confirm":"Facciamolo!","description1":"Sembra che tu stia utilizzando controlli dell\'app meno recenti con pulsanti di azione rapida. Abbiamo in serbo per te degli aggiornamenti entusiasmanti! Abbiamo rinnovato il sistema per semplificare la creazione e la modifica dei pulsanti di azione rapida, senza dover pi\xf9 immergersi nelle impostazioni avanzate."},"demo":{"title":"Pulsanti di azione rapida demo","step1":"Attiva i pulsanti di azione rapida","step2":"Utilizzare i prompt di esempio riportati di seguito per controllare il blocco di testo.","command1":"Premere il pulsante 1 per \u201CIngrandire il testo\u201D","command2":"Premere il pulsante 2 per \u201Cmettere in grassetto il testo\u201D","command3":"","continue":"Continua con i pulsanti di azione rapida","description":"L\'area demo qui sotto ti permetter\xe0 di provare i pulsanti di azione rapida. La demo \xe8 limitata al controllo specifico di quest\'area di testo qui sotto."},"example":{"title":"Esempi di pulsanti di azione rapida","command1":"Tocca Pausa","example1":"Esempio \\"metti in pausa il video\\"","command2":"Tocca Avanti","example2":"Esempio \\"zoom out\\"","command3":"Tocca Stop","example3":"Esempio \u201Cchiudi finestra\u201D","description":"Questi esempi mostrano la versatilit\xe0 dei pulsanti di azione rapida nel controllo del dispositivo o della connessione. Possono essere utilizzati per eseguire comandi, navigare tra le interfacce o eseguire azioni con un semplice tocco."},"emptySearch":"Non ci sono azioni rapide che corrispondono a questi criteri.","empty":"Sembra che al momento non siano disponibili azioni rapide.","emptyLong":"In questi controlli dell\'app non sono configurati pulsanti di azione rapida. Una volta aggiunti pulsanti di azione rapida o scelti controlli dell\'app che ne contengono uno, questi appariranno qui."},"reset":"Reset","info":"Ulteriori informazioni","device":{"title":"Connessione","titlePlural":"Connessioni","status":{"title":"Stato della connessione:","connected":{"application":"Applicazione connessa","connection":"Collegato","device":"Dispositivo connesso","game":"Gioco connesso"},"disconnected":{"application":"Applicazione disconnessa","connection":"Disconnesso","device":"Dispositivo disconnesso","game":"Gioco disconnesso"}},"running":"Corsa","offline":"Fuori linea","otherDevices":"Altre connessioni di uscita","currentStatus":"Stato attuale:","connectionStatus":"Stato della connessione:","profileStatus":"Controlli dell\'app corrente:","name":{"title":"Nome della connessione","question":"Come vuoi chiamare questa connessione?","description":"Assegna un nome alla tua connessione, cos\xec potrai ritrovarla facilmente in seguito.","placeholder":"nome della connessione","edit":"Modifica nome connessione"},"updates":{"title":"Aggiornamenti sulla connessione","settings":"Impostazioni di aggiornamento della connessione","description":"Verificare gli aggiornamenti del firmware di connessione e modificare le impostazioni di aggiornamento automatico","edit":"Modifica impostazioni di aggiornamento","check":{"title":"Controlla gli aggiornamenti","processing":"Controllo aggiornamenti in corso! Potrebbero volerci alcuni minuti e la connessione potrebbe riavviarsi durante gli aggiornamenti.","description":"Tocca per verificare la presenza di aggiornamenti per la tua connessione. Se \xe8 disponibile un aggiornamento e la tua connessione \xe8 attiva, l\'aggiornamento inizier\xe0. Gli aggiornamenti possono richiedere alcuni minuti."},"auto":{"title":"Aggiorna automaticamente","description":"Con questa impostazione attivata, la connessione verr\xe0 aggiornata automaticamente ogni volta che il dispositivo \xe8 collegato alla rete elettrica, connesso al Wi-Fi e disponibile un aggiornamento. Se questa impostazione \xe8 disattivata, \xe8 necessario toccare il pulsante di aggiornamento per ottenere l\'ultima versione.","option":"Utilizzare l\'aggiornamento automatico?"}},"delete":{"title":"Scollega {{name}}","titleLong":"Scollega dall\'account","description":"Scollegando Cephable, lo disconnetti da questo computer o gioco e lo rimuovi dal tuo account. Non potrai pi\xf9 connetterti, inviare comandi o aggiornarlo. Questa operazione non pu\xf2 essere annullata, ma puoi creare una nuova connessione allo stesso computer o gioco se desideri utilizzarlo di nuovo in futuro.","confirm":"Sei sicuro di voler scollegare questa connessione?","confirmLong":"Vuoi davvero annullare la registrazione e reimpostare questa connessione? Non potrai pi\xf9 connetterti, inviare comandi o aggiornarla. Dopo questa operazione di annullamento della registrazione e reimpostazione, chiunque altro potr\xe0 configurare questa connessione da zero.","confirmButton":"S\xec, rimuovi questa connessione."},"manage":{"title":"Fai clic per visualizzare e gestire i dettagli delle tue connessioni.","description":"","name":"Personalizza il nome della tua connessione per una gestione pi\xf9 semplice."},"error":{"save":"Errore durante il salvataggio della connessione.","load":"Errore durante il caricamento della connessione.","add":"Errore durante l\'aggiunta della connessione.","delete":"Errore durante l\'eliminazione della connessione.","updates":"Errore durante il controllo degli aggiornamenti.","connection":"La connessione non \xe8 stata stabilita. Assicurati che sia connessa prima di riprovare.","deleteLong":"Non siamo riusciti a eliminare questa connessione dal tuo account. Se accedi di nuovo a questo account, potresti dover eliminare manualmente questa connessione nelle impostazioni di connessione."},"success":{"save":"Connessione salvata.","add":"Connessione aggiunta.","delete":"Connessione eliminata."},"description":"Cephable supporta pi\xf9 dispositivi e connessioni. Puoi gestire le impostazioni o selezionarne una qualsiasi da qui. Questo computer sar\xe0 sempre la tua connessione principale. Puoi aggiungere altre connessioni in seguito.","swap":{"titlePlural":"Scambia connessioni","description":"Cephable supporta pi\xf9 dispositivi e connessioni. Puoi selezionarne uno qualsiasi da qui. Questo computer sar\xe0 sempre la tua connessione principale. Potrai aggiungere altre connessioni in seguito."},"control":{"button":"Controllo {{name}}","description":{"application":"Controlla questa applicazione connessa usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Salva\\", l\'operazione verr\xe0 salvata sull\'applicazione in esecuzione.","connection":"Controlla questa connessione tramite la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Salva\\", questa operazione verr\xe0 salvata sulla connessione in esecuzione.","device":"Controlla questo dispositivo connesso usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Apri Spotify\\", Spotify si aprir\xe0 sul dispositivo in esecuzione.","game":"Controlla questo gioco interattivo usando la voce, azioni rapide, movimenti della testa e altro ancora. Ad esempio, se dici \\"Vai\\", il giocatore si muover\xe0 in modalit\xe0 corsa."},"generic":"Collegamento di controllo"},"titleShort":"Collegare","titleLong":"Connessioni ed estensioni","viewAll":"Visualizza tutte le connessioni","add":{"short":"Estendere","title":"Aggiungi una nuova connessione o estensione","description":"Connessioni ed estensioni sono ulteriori modi per migliorare la tua esperienza Cephable. Puoi aggiungere nuove connessioni per connetterti a pi\xf9 dispositivi, applicazioni o giochi. Porta la tua esperienza Cephable a un livello superiore aggiungendo connessioni ed estensioni.","action":"Aggiungi una nuova connessione","notAvailable":"Questa connessione o estensione non \xe8 attualmente disponibile al pubblico. Questo problema si verifica spesso quando si utilizzano estensioni generate dagli utenti. Riprova pi\xf9 tardi.","isNotPublic":"ANTEPRIMA: Questa estensione \xe8 in anteprima per sviluppatori e potrebbe essere incompleta. Gli sviluppatori devono completare tutti i passaggi prima del rilascio pubblico. Gli utenti possono controllare pi\xf9 tardi per la versione completa."},"new":"Hai una nuova connessione!","newLong":"Hai una nuova connessione! Per iniziare a usarla, selezionala dal menu qui sotto.","selectDevice":"Seleziona il dispositivo"},"explore":"Esplorare","shortcuts":{"title":"Scorciatoie globali","description":"Personalizza le scorciatoie da tastiera per accedere rapidamente ai controlli Cephable da qualsiasi punto del sistema.","info":"Queste scorciatoie funzionano a livello globale e possono essere utilizzate anche quando Cephable non \xe8 la finestra attiva.","shortcut":"Scorciatoia","toggleMicrophone":"Attiva/disattiva microfono","toggleDictation":"Attiva/disattiva la modalit\xe0 di dettatura","toggleVoiceControl":"Attiva/disattiva la modalit\xe0 di controllo vocale","togglePanel":"Pannello di attivazione/disattivazione","registrationFailed":"Alcune scorciatoie globali non sono state registrate. Potrebbero essere utilizzate da un\'altra applicazione:","record":{"title":"Registra scorciatoia","start":"Clicca per registrare","listening":"Premi la combinazione di tasti desiderata...","pressKeys":"Premi i tasti ora"},"formatHint":"Selezionare almeno un tasto modificatore ({{modifierKey}}, {{modifierKey2}}, Maiusc) e un altro tasto."},"gamepad":{"title":"Supporto per gamepad","description":"Configura l\'uscita del gamepad e del joystick per i giochi su PC","driver":{"description":"Per supportare le uscite del controller di gioco, Cephable deve scaricare e installare un driver esterno chiamato ViGEm. Questo driver abilita la funzionalit\xe0 del controller virtuale Xbox 360, riconosciuta in modo nativo dai giochi.","installed":"Driver del controller di gioco installato: ora puoi utilizzare le uscite del gamepad! Se i problemi persistono, puoi provare a reinstallare il driver.","notInstalled":"Driver del controller di gioco non installato","install":"Installa il driver del controller di gioco","reinstall":"Reinstallare il driver del controller di gioco","installing":"Installazione del driver del controller di gioco ViGEm...","installSuccess":"Driver del controller di gioco ViGEm installato correttamente! Ora puoi utilizzare le uscite del gamepad nei tuoi controlli.","installFailed":"Impossibile installare il driver ViGEm. Riprovare o installarlo manualmente dal sito web di ViGEm.","title":"Driver del controller di gioco","disclosure":{"title":"Installare driver di terze parti per gamepad?","description":"Il supporto per il gamepad richiede l\'installazione di ViGEm, un driver non ufficiale di terze parti che permette a Cephable di emulare un controller Xbox virtuale. Prosegui solo se desideri che Cephable installi questo driver.","confirm":"Installa il driver ViGEm"}},"platform":{"unsupported":"Piattaforma non supportata per le funzionalit\xe0 del gamepad","unsupportedDescription":"La funzionalit\xe0 di output del gamepad \xe8 attualmente supportata solo sui sistemi Windows x64. Il supporto per Mac e Windows ARM64 non \xe8 ancora disponibile."},"usage":"Una volta installato il driver del Game Controller, puoi usare i movimenti del joystick e le pressioni dei pulsanti del gamepad nelle macro e nei comandi vocali per controllare i giochi."},"youtube":{"unavailable":{"title":"Video non disponibile","description":"Questo video non \xe8 al momento disponibile. Riprova pi\xf9 tardi.","retry":"Riprova"},"watch":{"title":"Ops.","description":"Sembra che si sia verificato un problema durante il caricamento del video. Puoi guardarlo direttamente su YouTube.","button":"Guarda su YouTube"},"offline":{"title":"Video non disponibile","description":"Questo video di YouTube richiede una connessione a Internet per essere caricato. Controlla la tua connessione e riprova."}},"metrics":{"download":{"success":"Accesso al file delle metriche riuscito.","manualPath":"File delle metriche disponibile all\'indirizzo: {{path}}","error":"Errore durante il download del file delle metriche.","noFile":"Nessun file di metriche trovato."},"clear":{"success":"File delle metriche cancellato correttamente.","error":"Errore durante la cancellazione del file delle metriche.","noFile":"Nessun file di metriche trovato da cancellare.","confirm":"Vuoi davvero cancellare tutti i dati delle metriche? Questa operazione non pu\xf2 essere annullata."}},"suggestedPrompts":{"title":"Suggerimenti suggeriti","description":"Personalizza i suggerimenti visualizzati nelle attivit\xe0 di intelligenza artificiale per aiutarti a iniziare rapidamente.","edit":"Modifica i prompt suggeriti","generate":"Genera testo","rewrite":"Riscrivi il testo","addGenerate":"Aggiungi un prompt di generazione","addRewrite":"Aggiungi un prompt di riscrittura","remove":"Rimuovi richiesta","generatePlaceholder":"Inserisci un prompt per la generazione del testo...","rewritePlaceholder":"Inserisci un prompt per la riscrittura del testo...","suggested":"Suggerimenti suggeriti","suggestedFor":"Suggerito per {{profileName}}","seeAll":"Visualizza tutti i prompt","showLess":"Mostra meno","allPrompts":"Tutti i prompt","customFor":"Prompt personalizzati per {{profileName}}","defaultPrompts":"Prompt predefiniti","defaultGenerate":["Un\'e-mail professionale che presenta il nostro nuovo prodotto","Un ordine del giorno per la discussione di gruppo della prossima settimana","Uno schema di proposta di progetto per una nuova iniziativa","Un modello di lettera commerciale formale","Una sezione di documentazione tecnica","Introduzione al manuale utente","Una panoramica del documento di formazione","Una bozza di documento politico","Un\'e-mail di follow-up dopo una riunione","Un messaggio di ringraziamento a un cliente","Un\'e-mail di aggiornamento sullo stato del progetto","Un invito a un evento aziendale","Un\'e-mail di promemoria per le prossime scadenze","Un\'e-mail di benvenuto per i nuovi membri del team","Un\'e-mail di scuse per l\'interruzione del servizio","Introduzione alla newsletter","Un elenco di brainstorming per campagne di marketing","Soluzioni creative per migliorare la produttivit\xe0 del team","Idee per attivit\xe0 di ritiro aziendale","Concetti per una nuova funzionalit\xe0 dell\'app mobile","Suggerimenti per migliorare l\'esperienza del cliente","Idee innovative per lo sviluppo dei nostri prodotti","Idee di contenuti per i post sui social media","Argomenti di workshop per lo sviluppo professionale","Una funzione che convalida l\'input dell\'utente","Una query di database per la gestione degli utenti","Codice di gestione degli errori per le richieste API","Un modello di file di configurazione","Commenti che spiegano un algoritmo complesso","Casi di test unitari per una nuova funzionalit\xe0","Documentazione per gli endpoint API","Uno script per la distribuzione automatizzata"],"defaultRewrite":["Rendi questo testo pi\xf9 conciso e diretto","Espandi questo riepilogo con maggiori dettagli","Riformattalo come un elenco numerato","Converti questo in punti elenco","Ristrutturalo in paragrafi chiari","Rendi questo testo pi\xf9 facile da leggere velocemente","Organizzare queste informazioni in modo gerarchico","Formattalo come una guida passo passo","Rendi questo messaggio pi\xf9 professionale e formale","Riscrivilo per renderlo pi\xf9 informale e amichevole","Adatta il tono per renderlo pi\xf9 incoraggiante","Rendi questo suono pi\xf9 sicuro e assertivo","Addolcisci il tono per essere pi\xf9 diplomatico","Aggiungi entusiasmo ed energia a questo testo","Rendilo pi\xf9 empatico e comprensivo","Riscrivi con un tono pi\xf9 collaborativo","Semplificare questo per un pubblico generale","Rendi questa spiegazione pi\xf9 tecnica e dettagliata","Scomporre questo concetto complesso in termini pi\xf9 semplici","Aggiungere pi\xf9 contesto e informazioni di base","Riassumiamo tutto questo in punti chiave","Elaborare i punti principali con esempi","Rendilo pi\xf9 accessibile ai principianti","Condensa questo mantenendo le informazioni essenziali","Migliorare la chiarezza e la leggibilit\xe0","Rendi questo pi\xf9 coinvolgente e interessante","Adatta per una grammatica e una fluidit\xe0 migliori","Riscrivi per enfatizzare i vantaggi"],"defaultSummarize":["Riassumi in 3 punti elenco","Estrarre le decisioni chiave","Elenca le principali azioni da intraprendere","Fornisci un riassunto in una frase","Evidenzia i fatti pi\xf9 importanti","Riassumere per un pubblico non tecnico","Estrarre i punti chiave","Riassumi in 5 punti elenco","Individuare il problema principale e proporre una soluzione.","Elenca tutte le conclusioni e le raccomandazioni","Fornire un riepilogo esecutivo","Riassumere la cronologia degli eventi","Estrarre tutte le domande sollevate","Elenca i pro e i contro menzionati","Riassumere gli argomenti principali"]},"accessibilityService":{"error":{"generic":"Errore interno. Riprova pi\xf9 tardi.","elementNotFound":"Nessun risultato trovato. Assicurati che la ricerca esista e riprova.","highlightOnConflict":"Sono stati trovati pi\xf9 elementi. Perfeziona il comando per specificare quale vuoi selezionare.","clickNotInitialized":"Al momento, la funzione \\"Tocca per nome\\" non \xe8 disponibile. Se il problema persiste, contatta l\'assistenza.","platformUnsupported":"La funzione \\"Tocca per nome\\" non \xe8 supportata su questa piattaforma.","permission":"Cephable non ha l\'autorizzazione per leggere questa app. Concedila in Impostazioni di sistema > Privacy e sicurezza > {{pane}} \u2014 su un dispositivo gestito dall\'azienda, questa opzione potrebbe essere bloccata dall\'amministratore."},"clickWait":"Inizializzazione in corso. Attendi un attimo e riprova."},"deprecated":"Obsoleto","view":"Visualizzazione","aiWorkflows":{"settings":{"title":"Impostazioni automatiche","description":"Configura i modelli di intelligenza artificiale e i dispositivi utilizzati per i flussi di lavoro di intelligenza artificiale. I flussi di lavoro di intelligenza artificiale consentono di automatizzare le attivit\xe0 su desktop e browser utilizzando l\'intelligenza artificiale sul dispositivo.","configType":{"title":"Tipo di configurazione del modello","description":"Seleziona il tipo di configurazione del modello da utilizzare per i flussi di lavoro AI. Diverse configurazioni sono ottimizzate per modelli diversi.","label":"Tipo di configurazione"},"reasoningModel":{"title":"Modello di ragionamento","description":"Seleziona il modello di intelligenza artificiale da utilizzare per le attivit\xe0 di ragionamento e pianificazione. Il modello di ragionamento analizza le tue richieste e crea piani d\'azione.","label":"Modello di ragionamento"},"reasoningDevice":{"label":"Dispositivo di ragionamento"},"generationModel":{"title":"Modello di generazione","description":"Seleziona il modello di intelligenza artificiale da utilizzare per le attivit\xe0 di generazione del testo. Il modello di generazione crea contenuti testuali quando necessario per i flussi di lavoro.","label":"Modello di generazione"},"generationDevice":{"label":"Dispositivo di generazione"},"noModelsFound":"Nessun modello trovato","terminate":{"title":"Risorse chiare del flusso di lavoro","description":"Fare clic per terminare il workflow worker e liberare risorse. Questo interromper\xe0 qualsiasi workflow in esecuzione e liberer\xe0 la memoria utilizzata dai modelli di intelligenza artificiale.","button":"Termina Workflow Worker","success":"Addetto al flusso di lavoro licenziato.","confirm":{"title":"Termina Workflow Worker","description":"Vuoi davvero terminare il workflow worker? Questo interromper\xe0 qualsiasi workflow in esecuzione e liberer\xe0 risorse.","confirm":"S\xec, terminare"}},"autoWarm":{"title":"Flussi di lavoro AI con avvio automatico","description":"Inizializza automaticamente i modelli di flusso di lavoro AI all\'avvio dell\'app. I modelli saranno precaricati in modo che i flussi di lavoro possano iniziare immediatamente.","option":"Avvia automaticamente i modelli di flusso di lavoro AI all\'avvio dell\'app"},"prompt":{"title":"Informazioni aggiuntive per i flussi di lavoro AI","description":"Inserisci dettagli aggiuntivi da utilizzare con l\'intelligenza artificiale di Cephable durante l\'esecuzione dei flussi di lavoro. Utilizza questo campo per inserire le tue preferenze relative a tono, comportamento o altri dettagli.","field":"Richiesta aggiuntiva","placeholder":"Ad esempio, confermare sempre prima di inviare e-mail. Preferire risposte concise. Utilizzare un linguaggio formale nei documenti."},"disableButtonNames":{"edit":"Interazioni con i pulsanti di blocco","input":{"label":"Nome del pulsante","question":"Quali pulsanti desideri bloccare? Puoi inserire il nome completo o parziale del pulsante.","remove":"Rimuovi il nome del pulsante"},"button":"Pulsanti di blocco","description":"Controlla con quali pulsanti i flussi di lavoro basati sull\'IA possono interagire. Per impostazione predefinita, Cephable pu\xf2 fare clic su qualsiasi pulsante sullo schermo. Utilizza questa impostazione per evitare azioni accidentali (ad esempio, \\"acquista\\", \\"elimina\\")."},"remoteWorkflows":{"title":"Esegui flussi di lavoro di intelligenza artificiale su tutti i tuoi dispositivi.","option":"Consenti agli altri miei dispositivi di avviarsi e di seguire le automazioni su questo dispositivo","description":"Attivata per impostazione predefinita. Quando \xe8 attiva, puoi avviare, monitorare e rispondere alle automazioni di questo dispositivo dagli altri dispositivi a cui hai effettuato l\'accesso: l\'avanzamento dell\'automazione (titoli dei passaggi e ragionamento dell\'IA) e le eventuali domande che ti vengono poste vengono inviate in tempo reale a questi dispositivi, consentendoti di rispondere ovunque ti trovi. Queste informazioni vengono condivise solo tra i tuoi dispositivi e non vengono mai memorizzate sui server di Cephable. Disattivala per mantenere le automazioni interamente su questo dispositivo: le automazioni continueranno a essere eseguite qui, ma nulla verr\xe0 inviato agli altri dispositivi e questi non potranno avviare un\'automazione su questo dispositivo."},"thinkingLevel":{"field":"Sforzo di ragionamento","description":"Quanto l\'IA riflette su ogni passaggio prima di agire. Livelli pi\xf9 elevati le consentono di scegliere e ordinare le azioni in modo pi\xf9 affidabile in compiti complessi, ma rendono ogni passaggio leggermente pi\xf9 lento. Il livello medio \xe8 consigliato alla maggior parte degli utenti.","low":"Basso (pi\xf9 veloce)","medium":"Medio (consigliato)","high":"Alto","max":"Massimo (il pi\xf9 accurato)"},"dynamicTools":{"option":"Caricamento degli strumenti Smart Connector","description":"Inizia pi\xf9 velocemente caricando solo gli strumenti che stai utilizzando. Quando \xe8 disattivato, tutti gli strumenti vengono caricati contemporaneamente: utile se vuoi che il modello decida quali azioni intraprendere, ma pu\xf2 essere molto pi\xf9 lento e causare risultati di qualit\xe0 inferiore."},"longTasks":{"field":"Compiti lunghi","description":"Come i flussi di lavoro basati sull\'IA gestiscono le attivit\xe0 che richiedono di tenere conto di molti elementi, come la lettura di documenti lunghi. L\'opzione \\"Automatico\\" concede pi\xf9 spazio a un\'attivit\xe0 solo quando necessario. L\'opzione \\"Priorit\xe0 alla velocit\xe0\\" mantiene ogni passaggio rapido, ma le attivit\xe0 molto lunghe potrebbero dimenticare i passaggi iniziali. L\'opzione \\"Consenti sempre attivit\xe0 lunghe\\" concede a ogni attivit\xe0 il massimo spazio possibile, ma i passaggi che richiedono la scrittura di testo richiedono un po\' pi\xf9 di tempo. Applicabile solo ai computer con scheda grafica dedicata.","auto":"Automatico (consigliato)","speed":"Dare priorit\xe0 alla velocit\xe0","long":"Consenti sempre compiti lunghi"}}},"control":"Controllare","automate":"Automatizzare","deviceCommandThrottled":{"macroLength":"Questa connessione non consente macro lunghe. La tua macro \xe8 stata abbreviata automaticamente.","commandCount":"Questa connessione limita la velocit\xe0 di invio dei comandi. Attendi e riprova pi\xf9 tardi.","incompatibleActions":"Questo controllo contiene azioni che non possono essere utilizzate insieme e non \xe8 stato inviato."},"tos":{"title":"Aggiornamento dei Termini di Servizio","description":"I nostri Termini di servizio sono stati aggiornati. Si prega di leggere e accettare i termini aggiornati per continuare a utilizzare Cephable.","effectiveDate":"Data di entrata in vigore: {{date}}","accept":"Accetta i Termini di Servizio","loadError":"Impossibile caricare i Termini di servizio. Riprova.","viewInBrowser":"Visualizza i Termini di servizio nel browser","acceptCheckbox":"Ho letto e accetto i Termini di servizio"},"appearance":{"title":"Aspetto"},"troubleshooting":{"title":"Risoluzione dei problemi"},"extensions":{"title":"Estensioni","titleShort":"Estensioni","description":"Abilita nuove funzionalit\xe0, connetti app complementari ed estendi le capacit\xe0 di Cephable.","searchPlaceholder":"Estensioni di ricerca","noResults":"Nessuna estensione corrisponde alla tua ricerca.","comingSoon":"Prossimamente","done":"Fatto","getStarted":"Inizia","viewDetails":"Visualizza dettagli e impostazioni","enable":"Abilitare","publisher":{"official":"Cefabile","officialTitle":"Ufficiale \u2014 creato e gestito da Cephable","byline":"A cura di {{editore}}","thirdPartyTitle":"Integrazione di terze parti da parte di {{publisher}}"},"category":{"inputControls":{"title":"Input e controllo","description":"Attiva le modalit\xe0 di controllo del tuo dispositivo con Cephable."},"companionApps":{"title":"App e strumenti complementari","description":"Amplia le funzionalit\xe0 di Cephable con la nostra app per dispositivi mobili e i nostri strumenti di creazione basati sul web."},"buildExtend":{"title":"Costruisci ed estendi","description":"Crea le tue estensioni personalizzate con le API e gli SDK di Cephable."},"marketplace":{"title":"Mercato","description":"Nuove competenze, strumenti e contatti sono in arrivo."},"previews":{"title":"Anteprime","description":"Prova le funzionalit\xe0 in arrivo. Le anteprime potrebbero subire modifiche prima del rilascio."}},"camera":{"title":"Comandi della fotocamera","description":"Controlla il tuo dispositivo con i movimenti del viso e della testa utilizzando la fotocamera.","detail":"I controlli della fotocamera consentono di utilizzare espressioni facciali e movimenti della testa, incluso il movimento della testa come mouse, per controllare il dispositivo. Attivali tramite l\'interruttore sulla scheda, quindi personalizza il comportamento qui.","settings":{"title":"Espressioni e gesti","description":"Regola le espressioni facciali e i movimenti della testa associati alle azioni nelle Impostazioni."},"advancedSettings":"Apri le impostazioni della fotocamera"},"gamepad":{"title":"Supporto per gamepad","description":"Emula un controller Xbox in modo che i giochi riconoscano i tuoi input Cephable.","detail":"Il supporto per gamepad richiede l\'installazione di ViGEm, un driver non ufficiale di terze parti, per emulare un controller Xbox virtuale riconosciuto nativamente dai giochi. Installa o aggiorna il driver qui sotto. Disponibile per Windows x64."},"mobile":{"title":"Applicazione mobile Cephable","description":"Utilizza il tuo telefono come controller complementare con l\'app mobile Cephable.","detail":"Scarica l\'app mobile Cephable per utilizzare il tuo telefono come controller aggiuntivo. Scansiona un codice o utilizza i link per scaricarla su iOS o Android, quindi visualizza l\'anteprima dell\'app qui sotto.","screenshotsTitle":"Anteprima","screenshotPlaceholder":"Screenshot","screenshotAlt":"Screenshot dell\'app mobile Cephable {{number}}","scanTitle":"Scansiona per scaricare","ios":"iOS \u2014 App Store","android":"Android \u2014 Google Play","iosAction":"Scaricala dall\'App Store","androidAction":"Scaricalo su Google Play"},"controllerCreator":{"title":"Creatore di controller personalizzati","description":"Progetta i tuoi controller su schermo personalizzati su controller.cephable.com.","detail":"Il Custom Controller Creator consente di progettare e condividere i propri controller su schermo direttamente nel browser.","qrCaption":"controller.cephable.com","action":"Creatore di controller aperti","screenshotsTitle":"Anteprima","screenshotPlaceholder":"Screenshot del creatore del controller","screenshotAlt":"Screenshot del creatore di controller personalizzati {{number}}"},"developer":{"title":"Crea la tua estensione","description":"Utilizza le API e gli SDK di Cephable per creare e condividere le tue estensioni.","detail":"Crea le tue estensioni e integrazioni con Cephable. Esplora le API e gli SDK, poi pubblica e condividi le tue creazioni su developers.cephable.com.","api":{"title":"API Cephable","description":"Gestisci a livello di programmazione profili, dispositivi, controlli ed eventi in tempo reale."},"sdk":{"title":"SDK ed esempi","description":"Inizia subito a lavorare con i nostri SDK, esempi e guide all\'integrazione."},"action":"Visita developers.cephable.com"},"portal":{"title":"Progetti e team","description":"Gestisci i tuoi progetti e i tuoi team nel portale Cephable.","detail":"Utilizza il portale Cephable per gestire progetti, team e impostazioni organizzative in un unico luogo.","projects":{"title":"Eventi","description":"Crea e gestisci progetti, chiavi API e integrazioni."},"teams":{"title":"Squadre","description":"Invita i membri, assegna i ruoli e gestisci gli accessi in tutta l\'organizzazione."},"action":"Apri il portale cefabile"},"mcpTools":{"title":"Strumenti MCP","description":"Collega gli strumenti del Model Context Protocol per estendere le funzionalit\xe0 di Cephable."},"aiSkills":{"title":"Competenze di intelligenza artificiale","description":"Aggiungi funzionalit\xe0 di intelligenza artificiale riutilizzabili che Cephable pu\xf2 attivare su richiesta."},"workflows":{"title":"Flussi di lavoro riutilizzabili","description":"Condividi e installa flussi di lavoro di automazione predefiniti."},"controlBundles":{"title":"Fasci di controllo","description":"Installa pacchetti selezionati di controlli per app e giochi con un solo tocco."},"connections":{"title":"Connessioni tra giochi e app","description":"Scopri giochi e app che puoi controllare con Cephable, come Call of Duty: Black Ops 7."},"aiSkillsMarketplace":{"title":"AI Skills Marketplace","description":"Browse and install skills shared by the community."},"nav":{"label":"Sfoglia le estensioni","discover":"Scoprire","skills":"Competenze","connectors":"Connettori","features":"Caratteristiche cefabili","installed":"Installato"},"stats":{"rating":"Valutazione","installs":"Installa","rated":"Grazie per la valutazione!","rateError":"Impossibile salvare la tua valutazione.","yourRating":"La tua valutazione"},"copyLink":"Copia il link","detail":{"access":{"developer":"Sviluppatore","employee":"Dipendente","plus":"Pi\xf9","student":"Studente"},"by":"di","categories":"Categorie","featured":"In primo piano","installing":"Installazione in corso\u2026","size":"Dimensioni di download","transport":"Trasporto","version":"Versione"},"discover":{"connectors":"Connettori","coreDescription":"Cephable include fotocamere, gamepad, app complementari e strumenti per sviluppatori.","coreTitle":"Caratteristiche cefabili","description":"Competenze e connettori ufficiali e della comunit\xe0 per ampliare le funzionalit\xe0 dell\'assistente Cephable.","empty":"Al momento non c\'\xe8 nulla da mostrare. Esplora le competenze o i connettori per aggiungerne di tuoi.","exploreFeatures":"Esplora le funzionalit\xe0","featured":"In primo piano","newest":"Novit\xe0 e degne di nota","skills":"Competenze","title":"Scoprire","viewAll":"Visualizza tutto"},"features":{"description":"Cephable offre diverse modalit\xe0 di controllo integrate: telecamere, controller, app complementari e strumenti per sviluppatori.","title":"Caratteristiche cefabili","searchPlaceholder":"Funzioni di ricerca\u2026"},"install":"Installare","installError":"Impossibile installare.","installed":"Installato","linkCopied":"Link copiato","provenance":{"cephable":"Cefabile","mine":"Mio","organization":"La tua organizzazione","thirdParty":"Terzo"},"installedPage":{"connectors":"Connettori","description":"Competenze e connettori che hai aggiunto. Aprine uno per gestirlo o rimuoverlo.","empty":"Non hai ancora aggiunto alcuna competenza o connettore.","manage":"Maneggio","skills":"Competenze","title":"Installato","searchPlaceholder":"Cerca le estensioni installate\u2026"},"type":{"skill":"Abilit\xe0","tool":"Connettore","input":"Ingresso","build":"Costruire","app":"App complementare","feature":"Caratteristica"},"publish":{"title":{"mcp":"Condividi questo connettore MCP","skill":"Condividi questa competenza"},"shareWith":"Chi pu\xf2 accedere a questo","target":{"organization":"Persone nella mia organizzazione","public":"Tutti (mercato pubblico)"},"chooseOrganization":"Scegli un\'organizzazione","yourOrganization":"la tua organizzazione","audience":{"public":"Una volta approvato dal team di Cephable, chiunque utilizzi Cephable potr\xe0 trovarlo, visualizzarlo e installarlo. Scegliete quindi parole e icone di conseguenza.","organization":"Tutti gli utenti di {{org}} potranno trovarlo e installarlo."},"displayName":"Nome da visualizzare","shortDescription":"Breve descrizione","shortDescriptionHelp":"Un breve riepilogo visualizzato negli elenchi.","description":"Descrizione","iconUrl":"URL dell\'icona","darkModeIconUrl":"URL dell\'icona della modalit\xe0 scura","categories":"Categorie","categoriesHelp":"Separati da virgole (ad esempio, produttivit\xe0, scrittura).","version":"Versione","versionHelp":"Lascia vuoto per visualizzare l\'anteprima automatica.","secretNote":{"mcp":"Vengono condivisi solo i dettagli di connessione non segreti. Le tue chiavi API, i token e le altre credenziali rimangono su questo dispositivo: chi lo installa inserisce le proprie.","skill":"I file e le istruzioni della skill vengono condivisi cos\xec come sono. Rimuovere qualsiasi contenuto privato prima della pubblicazione."},"confirm":"Pubblicare","submitConfirm":"Invia per la revisione","reviewNote":"Gli articoli inviati dal pubblico vengono esaminati dal team di Cephable prima di essere pubblicati sul marketplace. Potrai visualizzare lo stato del tuo articolo e riceverai un\'email non appena sar\xe0 stato esaminato.","notes":"Note per il revisore (facoltative)","notesHelp":"Qualsiasi cosa ci aiuti a rivedere: cosa fa e cosa \xe8 cambiato dall\'ultima volta.","inReview":"Questa richiesta \xe8 gi\xe0 in attesa di revisione. Ritira la richiesta attuale per apportare modifiche e inviala nuovamente.","withdraw":"Ritira la proposta","resubmitConfirm":"Invia nuovamente per la revisione","resubmitNote":"Questa richiesta non \xe8 stata approvata per la pubblicazione. Si prega di prendere in considerazione i commenti riportati di seguito, quindi di inviare nuovamente la richiesta per la revisione.","previousFeedback":"Feedback del recensore","publicRestricted":"La vostra organizzazione non consente la pubblicazione sul mercato pubblico, pertanto questo contenuto pu\xf2 essere condiviso solo internamente."},"reviewStatus":{"section":"Revisione del mercato pubblico","reasonLabel":"Nota del revisore","pending":"In revisione","published":"Pubblicato","rejected":"Modifiche richieste","removed":"RIMOSSO","pendingTitle":"In attesa della revisione di Cephable prima della sua pubblicazione sul mercato.","publishedTitle":"Approvato e quotato sul mercato pubblico.","rejectedTitle":"Non approvato per la pubblicazione: consultare la nota del revisore, quindi inviare nuovamente la richiesta.","removedTitle":"Rimosso dal mercato pubblico da un moderatore.","notify":{"published":"Il prodotto \u201C{{name}}\u201D \xe8 stato approvato ed \xe8 ora disponibile sul marketplace.","rejected":"Il documento \u201C{{name}}\u201D necessita di modifiche prima di poter essere pubblicato. Aprilo per visualizzare il feedback del revisore.","removed":"\u201C{{name}}\u201D \xe8 stato rimosso dal mercato pubblico."}},"managedBy":"Gestito da {{provenienza}}","integrationType":{"cephable":"integrazione ufficiale","mine":"integrazione personale","organization":"integrazione organizzativa","thirdParty":"integrazione di terze parti"},"automateHttpServer":{"title":"Automatizzare il server HTTP","description":"Collega i servizi locali all\'assistente Automate di Cephable installato sul dispositivo tramite HTTP.","detail":"Il server HTTP di Automate consente ai servizi locali, agli strumenti di sviluppo e ai runner di valutazione di utilizzare l\'assistente di distribuzione di Cephable. Accetta connessioni solo da questo dispositivo, richiede la chiave generata per ogni richiesta e limita le operazioni sui file a un\'area di lavoro Automate isolata.","proRequired":"Il server HTTP Automate \xe8 disponibile con Cephable Professional.","running":"Corsa","stopped":"Si \xe8 fermato","port":"Porta","endpoint":"Punto finale","api":{"title":"Come connettersi","description":"\xc8 possibile utilizzare il server da uno script locale, un\'applicazione desktop o uno strumento di automazione in esecuzione su questo computer.","routes":{"chat":"Chiacchierata","run":"Esecuzione automatizzata","health":"Salute","models":"Modelli","modelMode":"Modalit\xe0 modello (ciclo del tuo agente)","tools":"Strumenti integrati","speech":"Risultati del discorso","settings":"Impostazioni"},"steps":{"enable":"Attiva questa estensione dalla sua scheda, lascia Cephable aperto e verifica che lo stato visualizzato sopra indichi \\"In esecuzione\\".","copyKey":"Copia la chiave di accesso qui sotto. Inviala con ogni richiesta nell\'intestazione Authorization come Bearer <chiave di accesso>.","sendRequest":"Utilizza l\'endpoint mostrato sopra ed effettua una richiesta POST JSON a /v1/chat/completions. I client compatibili con OpenAI esistenti possono utilizzare cephable-agent come nome del modello per eseguire l\'assistente completo, oppure cephable-model per utilizzare Cephable come modello all\'interno del proprio agente.","readResponse":"Leggi la risposta dell\'assistente da choices[0].message.content. Se un client non riesce a connettersi, invia GET /health con la stessa intestazione di autorizzazione."}},"key":"Chiave di accesso","keyDescription":"Utilizza questa chiave come token di accesso per i client locali. \xc8 crittografata con la memoria sicura del tuo sistema operativo e non viene mai sincronizzata con Cephable.","copyKey":"Copia la chiave di accesso","copyError":"Impossibile copiare la chiave di accesso al server Automate.","regenerateKey":"Rigenera la chiave di accesso","keyRegenerated":"Chiave di accesso al server automatizzata rigenerata.","example":{"title":"Esempio di richiesta Node.js","description":"Questo esempio include gi\xe0 l\'endpoint e la chiave di accesso corrente. Copialo in uno script Node.js locale affidabile e sostituisci il prompt di esempio con la tua attivit\xe0.","copy":"Esempio di richiesta di copia","copyError":"Impossibile copiare l\'esempio di richiesta."},"useCases":{"title":"Idee per l\'utilizzo del server","description":"Qualsiasi dispositivo in grado di effettuare una richiesta HTTP locale pu\xf2 chiedere aiuto all\'assistente Automate integrato di Cephable.","localAutomation":"Collega script locali, strumenti di scelta rapida, utilit\xe0 desktop o piattaforme di automazione a un flusso di lavoro di Automate.","privateText":"Riscrivi, riassumi, classifica o traduci il testo all\'interno di uno strumento interno mantenendo l\'inferenza su questo dispositivo.","accessibleInputs":"Consentendo a interruttori personalizzati, sensori o software complementari di trasformare un input accessibile in un\'attivit\xe0 Automate pi\xf9 completa, un semplice input pu\xf2 essere aggiunto in modo pi\xf9 efficace.","testing":"Esegui suite di test di regressione per prompt e flussi di lavoro sullo stesso assistente, competenze, strumenti e modello locale utilizzati dall\'app Cephable."},"security":{"title":"Mantenere l\'accesso locale e sicuro","description":"Il server \xe8 in ascolto solo su 127.0.0.1, pertanto i servizi remoti e cloud non possono connettersi direttamente. Tratta la chiave di accesso come una password e condividila solo con software di cui ti fidi. La sua rigenerazione disconnette immediatamente i client che utilizzano la chiave precedente."},"secureStorageUnavailable":"Questo server non pu\xf2 essere abilitato perch\xe9 non \xe8 disponibile uno spazio di archiviazione sicuro per il sistema operativo.","error":"Impossibile aggiornare il server HTTP di Automate.","portMoved":"La porta {{preferredPort}} era gi\xe0 in uso su questo dispositivo, quindi il server \xe8 stato avviato sulla porta {{port}}. Utilizza l\'endpoint sopra indicato nei tuoi strumenti, non quello predefinito.","portMovedTitle":"Porta diversa in uso"},"workflowRecording":{"title":"Registra un flusso di lavoro","description":"Mostra a Cephable come esegui un\'attivit\xe0 una sola volta, e trasformer\xe0 la registrazione in un\'abilit\xe0 che potr\xe0 utilizzare al posto tuo.","previewBadge":"Anteprima","detail":"La funzione Registra flusso di lavoro osserva mentre svolgi un\'attivit\xe0: le app a cui passi, i pulsanti e i campi su cui fai clic, ci\xf2 che digiti e ci\xf2 che dici ad alta voce. Quando interrompi, Cephable trasforma la registrazione in una skill AI che puoi rivedere, modificare e salvare. La prossima volta che chiedi ad Automate di eseguire lo stesso tipo di attivit\xe0, utilizzer\xe0 la skill come guida, scegliendo il percorso pi\xf9 diretto invece di ripetere ogni clic.","howItWorks":{"title":"Come funziona","record":"Avvia una registrazione dall\'Area di lavoro, dalla scheda Automatizza o dalle Abilit\xe0 IA, quindi esegui l\'attivit\xe0 dall\'inizio alla fine.","narrate":"Descrivi nel dettaglio cosa stai facendo e perch\xe9. La tua narrazione diventer\xe0 la motivazione alla base di ogni passaggio.","review":"Interrompi la registrazione per ottenere una bozza. Rivedi i passaggi e la descrizione prima di salvarla.","run":"Chiedi ad Automate di ripetere l\'attivit\xe0. Il programma legge la registrazione come riferimento e la adatta alle tue richieste."},"captured":{"title":"Cosa viene registrato?","description":"I tuoi clic, le pressioni dei tasti, i passaggi tra le app, i nomi e gli ID dei controlli che utilizzi, oltre alla tua voce narrante se \xe8 disponibile un microfono. Tutto viene elaborato da questo dispositivo. Le azioni che ti portano da una posizione all\'altra, come aprire una nuova scheda del browser e digitare un indirizzo, vengono condensate in un unico passaggio. Evita di inserire password o dati di pagamento durante la registrazione."},"whereToFind":{"title":"Dove trovarlo","workspace":"Area di lavoro: la sezione \\"Registra un flusso di lavoro\\" sotto i suggerimenti \\"Crea e automatizza\\".","automate":"Nella scheda Automatizza del pannello di Cephable: il suggerimento \\"Insegna a Cephable un flusso di lavoro\\" e il menu di composizione.","skills":"Estensioni \u2192 Abilit\xe0 IA: Crea abilit\xe0 \u2192 Registra ci\xf2 che faccio."},"previewNotice":"Questa \xe8 una funzionalit\xe0 in anteprima. Potrebbe subire modifiche prima del rilascio e il tuo feedback ci aiuter\xe0 a definirla.","proRequired":"La funzione \\"Registra un flusso di lavoro\\" \xe8 disponibile con Cephable Professional.","startAction":"Registra un flusso di lavoro"}},"sensitivityValues":{"verySensitive":"Molto sensibile","high":"Alto","medium":"Mezzo","low":"Basso","notSensitive":"Non sensibile"},"summarize":"Riassumere","appControlsPanel":{"searchPlaceholder":"Comandi di ricerca...","searchLabel":"Comandi di ricerca","favorites":{"title":"Preferiti","description":"I comandi preferiti sono quelli che utilizzi pi\xf9 spesso. Puoi contrassegnare un comando come preferito facendo clic sull\'icona a forma di stella accanto ad esso."},"noCommandsFound":"Nessun comando trovato","globalCommands":"Globale","prefixCommandToast":"Questo \xe8 un comando con prefisso: pronuncia o digita il prefisso seguito dalla frase per attivarlo."},"collapse":"Crollo","intelligentTasks":{"loading":{"loadingModels":"Caricamento dei modelli di intelligenza artificiale...","extractingModels":"Estrazione di modelli di intelligenza artificiale..."}},"sidebar":{"collapse":"Comprimi la barra laterale","expand":"Espandi la barra laterale"},"workspace":{"title":"Spazio di lavoro","badge":"Sul dispositivo \xb7 privato","subtitle":"Il tuo assistente AI funziona interamente su questo dispositivo. Avvia i comandi, crea, automatizza o semplicemente chatta.","control":{"title":"Controllare","description":"Comandi vocali, scorciatoie da tastiera e pulsanti di azione rapida: funzionano con tutte le app del tuo dispositivo.","voice":{"title":"Comandi vocali","description":"Comandi a mani libere"},"dictation":{"title":"Dettatura","description":"Parlare al tipo"},"computerUse":{"title":"Uso del computer","description":"Lascia che l\'assistente agisca"},"camera":{"title":"Comandi della fotocamera","description":"gesti del viso e della testa"},"quickActions":{"title":"Azioni rapide","description":"Scorciatoie con un solo tocco"}},"create":{"title":"Creare","description":"Scrivi, riscrivi, riformatta e traduci, direttamente all\'interno dell\'app in cui stai lavorando, utilizzando il testo copiato ed evidenziato.","items":{"draftEmail":"Redigere una bozza di email","writeDocument":"Scrivi un documento","summarizeNotes":"Riassumere in appunti","polishWriting":"Perfeziona la mia scrittura","translateText":"Traduci il testo","socialPost":"Scrivi un post sui social","cd_brief":"Redigere un brief creativo","cd_caption":"Scrivi una didascalia e un testo alternativo","ar_insights":"Riassumere i risultati in spunti di riflessione","ar_exec":"Scrivi un riassunto esecutivo","cc_followup":"Redigere una bozza di email di follow-up","cc_meetingNotes":"Trasforma gli appunti in verbali di riunione","bd_commit":"Scrivi un messaggio di commit","bd_review":"Riassumere una revisione del codice","gp_bio":"Scrivi una biografia per il tuo stream","gp_recap":"Riepilogo della sessione di ieri sera","lt_lesson":"Delineare un piano di lezione","lt_studyNotes":"Riassumere in appunti di studio","mo_agenda":"Redigere un ordine del giorno della riunione","mo_update":"Scrivi un aggiornamento del progetto","aa_simplify":"Semplificare in linguaggio semplice","aa_describe":"Descrivi un\'immagine a parole"},"contextRow":{"highlightedText":"Evidenzia/appunta il testo","output":"Digitazione:","input":"Usi:","background":"Sfondo","currentapp":"Applicazione attuale"},"prompts":{"draftEmail":"Redigi una bozza di email chiara e professionale a riguardo.","writeDocument":"Scrivi un documento a riguardo.","summarizeNotes":"Riassumi il tutto in note concise e ben organizzate, utilizzando elenchi puntati.","polishWriting":"Riscrivi questo testo in modo che sia pi\xf9 chiaro e rifinito, mantenendo per\xf2 il significato e il tono originali.","socialPost":"Scrivi un breve post coinvolgente sui social media a riguardo.","cd_brief":"Redigere un brief creativo per questo progetto.","ar_insights":"Riassumere i principali risultati e le intuizioni emerse da questi dati.","ar_exec":"Scrivi un riassunto esecutivo conciso di questo documento.","cc_followup":"Scrivi una bozza di email di follow-up in merito.","cc_meetingNotes":"Trasforma questi appunti in verbali di riunione chiari e completi, con punti d\'azione da intraprendere.","bd_commit":"Scrivi un messaggio di commit chiaro per queste modifiche:","bd_review":"Riassumi questa revisione del codice evidenziando i punti chiave e le modifiche richieste.","gp_bio":"Scrivi una biografia incisiva per il mio canale/profilo.","lt_lesson":"Elabora un piano di lezione su questo argomento.","lt_studyNotes":"Riassumi questo materiale in appunti di studio che io possa consultare.","mo_agenda":"Redigere un ordine del giorno per la riunione che includa questo argomento.","mo_update":"Sulla base di quanto sopra, redigi un aggiornamento sullo stato di avanzamento del progetto per le parti interessate.","aa_simplify":"Riscrivi questo testo in un linguaggio semplice e di facile lettura."}},"automate":{"title":"Automatizzare","description":"Descrivi un\'attivit\xe0 in linguaggio semplice e Cephable la eseguir\xe0 nelle tue applicazioni, nei tuoi file e persino nella riga di comando.","items":{"triage":"Gestisci la mia casella di posta","cd_exportAssets":"Rinominare e archiviare le risorse","cd_moodboard":"Raccogli referenze","cc_triage":"Valutazione e bozze di risposte","cc_recap":"Riepilogo e invia al team","bd_scaffold":"Strutturare un progetto","gp_schedule":"Pianifica un programma di streaming","lt_handout":"Preparare un documento informativo","summarizeSend":"Riassumi e invia via email","researchDoc":"Ricerca e redigi un documento","organizeFiles":"Organizza i miei file","cleanUp":"Pulire una cartella","wordDoc":"Crea un documento Word","ar_summarizeSend":"Riassumi e invia via email","ar_analyzeData":"Analizzare un foglio di calcolo","ar_deck":"Costruisci un mazzo di carte dai dati","cc_summarizeEmail":"Riassumi in un\'e-mail","cc_socialPost":"Pubblica da un link","bd_buildTest":"Costruisci e testa un progetto","bd_cleanup":"Suggerisci interventi di pulizia del codice","lt_studyMaterial":"Creare materiale di studio","lt_accommodation":"Prendere appunti in modo accessibile","lt_research":"Ricerca e confronta","mo_meetingActions":"Trasformare gli appunti in azioni","mo_organizeFiles":"Organizza i miei file","mo_cleanup":"Pulizia dei download","aa_translate":"Tradurre un documento"},"prompts":{"summarizeSend":"Riassumi il contenuto della cartella <folder> e invialo via email all\'indirizzo <team email>.","researchDoc":"Analizza le tendenze presenti nella cartella o nel documento e trascrivi i risultati in un nuovo documento.","organizeFiles":"Copia i file da<source folder> in<destination folder> .","cleanUp":"Rimuovi tutti i file di tipo <ad esempio, screenshot> dalla mia <cartella>.","wordDoc":"Utilizzo<article or notes> per creare un documento di Microsoft Word che<does what> .","triage":"Esamina la mia casella di posta e dimmi cosa richiede la mia attenzione, poi prepara delle risposte laddove necessario.","cd_exportAssets":"Rinominare le risorse di progettazione in <cartella> utilizzando questo schema \u2014 <schema di denominazione> \u2014 e ordinarle in cartelle.","cd_moodboard":"Cerca online riferimenti per <idea> e raccoglili in un documento.","ar_summarizeSend":"Riassumi il contenuto della cartella <folder> e invialo via email all\'indirizzo <team email>.","ar_analyzeData":"Analizza il foglio di calcolo e individua gli elementi da cercare, ad esempio le perdite di dati chiave.","ar_deck":"Trasforma i risultati contenuti nel <documento o nella cartella> in una presentazione PowerPoint che evidenzi i <punti chiave>.","cc_triage":"Controllo la mia casella di posta e preparo risposte a tutto ci\xf2 che ne richiede una.","cc_summarizeEmail":"Redigere una bozza di email riassuntiva<article or document> e indicare i dettagli tecnici principali.","cc_recap":"Scrivi un riepilogo di <note della riunione> e invialo via email a <email del team>.","cc_socialPost":"Leggere<article or website> e scrivere un<platform, e.g. Discord> -pubblica un post amichevole al riguardo, poi salvalo in una nuova nota.","bd_buildTest":"Esamina il codice nella cartella <project folder>, compilalo ed esegui i test. Se qualcosa non funziona, controlla la cronologia di Git e dimmi cosa potrebbe aver causato il problema.","bd_cleanup":"Dai un\'occhiata al codice nella cartella <project folder> e dimmi come posso renderlo pi\xf9 pulito.","bd_scaffold":"Crea la struttura di base per un nuovo progetto <tipo di progetto> nella cartella <cartella> con i file iniziali necessari.","gp_schedule":"Pianifica un programma di streaming per<time period> copertura<games or activities> .","lt_studyMaterial":"Utilizzo<article or notes> per creare un documento Word per<grade level> studenti con<reflection questions or a study guide> .","lt_accommodation":"Crea un documento Word con gli appunti della lezione su <argomento> formattato per uno studente con <alloggio>.","lt_handout":"Raccogli i materiali di lettura presenti nella cartella <folder> in un unico documento distribuito.","lt_research":"Cerca online <argomento, ad esempio libri sulla neurodiversit\xe0> e crea un documento che riassuma ciascuno di essi, in modo che io possa confrontarli.","mo_meetingActions":"Leggi il verbale della riunione: cosa resta da fare, chi \xe8 responsabile e cosa richiede ulteriori ricerche? Suddividi il tutto in file organizzati in una cartella.","mo_organizeFiles":"Copia i file da<source folder> in<destination folder> .","mo_cleanup":"Rimuovi tutti i file di tipo <ad esempio, programmi di installazione> dalla mia cartella Download.","aa_translate":"Traduci <documento> in <lingua> e salvalo in <cartella>."}},"history":{"title":"Storia recente dell\'IA","description":"Le tue attivit\xe0 intelligenti e automazioni pi\xf9 recenti.","viewAll":"Visualizza tutta la cronologia","empty":"Qui verranno visualizzate le attivit\xe0 e le automazioni di intelligenza artificiale pi\xf9 recenti."},"badgeRemote":"Dispositivo remoto \xb7 sicuro","browser":{"openButton":"Open Browser","windowTitle":"Browser Cephable","newTab":"Nuova scheda","reload":"Ricaricare","forward":"Inoltrare","openExternal":"Apri nel browser predefinito","showWindow":"Mostra il browser nascosto","addressPlaceholder":"Cerca su Google o digita un URL","clearData":{"description":"Cancella la cronologia, i cookie, i dati memorizzati nella cache e le credenziali di accesso salvate del browser Cephable. In questo modo verrai disconnesso da tutti i siti web nel browser Cephable.","button":"Cancella i dati del browser","cleared":"Dati del browser cancellati.","error":"Impossibile cancellare i dati del browser.","confirmTitle":"Cancellare i dati del browser?","confirmMessage":"Disconnettersi completamente dal browser Cephable?","confirmDetail":"Questa operazione cancella definitivamente cronologia, cookie, dati memorizzati nella cache e credenziali di accesso salvate per il browser Cephable. \xc8 un\'operazione irreversibile.","confirm":"Dati chiari","cancel":"Cancellare"},"context":{"newTab":"Nuova scheda","reload":"Ricaricare","duplicate":"Scheda duplicata","close":"Chiudi la scheda","closeOthers":"Chiudi le altre schede","closeRight":"Chiudi le schede a destra","back":"Indietro","forward":"Inoltrare","openLinkNewTab":"Apri il link in una nuova scheda","openLinkExternal":"Apri il link nel browser predefinito","openExternal":"Apri nel browser predefinito","openAllExternal":"Apri tutte le schede nel browser predefinito"},"home":{"tabTitle":"Casa","title":"Il browser Cephable","tagline":"Cephable, un browser separato, pu\xf2 essere utilizzato al posto tuo.","description":"\xc8 qui che Cephable automatizza le attivit\xe0 web per tuo conto. Funziona indipendentemente dal tuo browser abituale, quindi le tue schede, gli accessi e la navigazione rimangono invariati mentre le automazioni vengono eseguite, anche in background.","searchPlaceholder":"Cerca su Google o digita un URL per iniziare","go":"Andare","features":{"separate":{"title":"Funziona da solo","description":"Mantenute separate dal browser predefinito, le automazioni non interferiscono mai con la tua navigazione personale."},"automate":{"title":"Progettato per l\'automazione","description":"Cephable pu\xf2 aprire pagine, compilare moduli e raccogliere informazioni qui, senza usare le mani."},"handoff":{"title":"Consegna in qualsiasi momento","description":"Apri una qualsiasi pagina nel tuo browser predefinito ogni volta che desideri prenderne il controllo."}}}},"scheduledTasks":{"title":"Attivit\xe0 programmate","description":"Automazioni programmate per essere eseguite all\'orario da te scelto, su questo dispositivo.","viewAll":"Visualizza tutti gli eventi programmati","empty":"Pianifica una richiesta dal pannello e verr\xe0 visualizzata qui."},"subtitleRemote":"Tutto ci\xf2 su cui cliccheresti o che digiteresti, a tua completa disposizione.","suggestions":{"viewMore":"Visualizza altro","viewMoreTooltip":"Esplora tutti i suggerimenti","dialogTitle":"Tutti i suggerimenti","dialogDescription":"Scegli un punto di partenza. Verr\xe0 inserito direttamente nel compositore, cos\xec potrai modificarlo prima di eseguirlo.","rotationLabel":"Suggerimenti suggeriti","empty":"Nessun suggerimento disponibile."}},"noResults":"Nessun risultato","noResultsSearch":"Nessun risultato trovato per la tua ricerca.","interrupted":"Interrotto","aiHistory":{"title":"Storia dell\'IA","description":"Visualizza, cerca e gestisci la cronologia delle tue conversazioni con l\'IA a livello locale.","empty":{"title":"Nessuna storia di IA ancora","description":"La cronologia delle tue conversazioni con l\'IA verr\xe0 visualizzata qui dopo aver utilizzato le attivit\xe0 intelligenti."},"search":{"placeholder":"Cerca conversazioni..."},"pagination":{"range":"Visualizzazione di {{inizio}}\u2013{{fine}} di {{totale}}"},"source":{"create":"Creare","automate":"Automatizzare"},"workflow":{"plan":"Piano","steps":"Passaggi","files":"File","folders":"Cartelle","interruptedNotice":"Il tuo flusso di lavoro \xe8 stato interrotto. Riprova."},"trace":{"thinking":"Pensiero","toolCalls":"Chiamate di aggancio","roles":{"tool":"Risultato dello strumento"},"thought":"Pensiero","action":"Azione","parameters":"Parametri","result":"Risultato","reply":"Hai risposto","sources":"Fonti"},"task":{"instructions":"Istruzioni","language":"Lingua","types":{"generate":"Generare","rewrite":"Riscrivere","translate":"Tradurre","summarize":"Riassumere"}},"session":{"messages":"messaggi","deleteTitle":"Elimina la conversazione","deleteDescription":"Sei sicuro di voler eliminare questa conversazione? Questa operazione \xe8 irreversibile.","deleteConfirm":"Eliminare","deleteCancel":"Cancellare"},"clear":{"title":"Cancella la cronologia dell\'IA","description":"Elimina tutta la cronologia delle conversazioni AI memorizzate localmente su questo dispositivo.","confirm":{"title":"Cancella la cronologia dell\'IA","description":"Sei sicuro di voler cancellare tutta la cronologia delle conversazioni con l\'IA? Questa operazione \xe8 irreversibile.","confirm":"Cancella tutto","cancel":"Cancellare"},"success":"Cronologia IA cancellata con successo.","error":"Impossibile cancellare la cronologia dell\'IA."},"export":{"title":"Esportare","description":"Esporta la cronologia delle tue conversazioni con l\'IA in un file JSONL.","success":"Cronologia dell\'IA esportata correttamente.","error":"Impossibile esportare la cronologia dell\'IA.","session":{"title":"Esecuzione dell\'esportazione","success":"Esecuzione esportata con successo.","error":"Impossibile esportare questa esecuzione."}},"retention":{"note":"Manteniamo le tue {{count}} conversazioni pi\xf9 recenti. I preferiti vengono sempre conservati.","label":"Mantenere"},"filter":{"label":"Filtra per tipo","all":"Tutti i tipi"},"favorites":{"title":"Preferiti","add":"Aggiungi ai preferiti","remove":"Rimuovi dai preferiti"},"select":{"selectOne":"Seleziona la conversazione","selected":"{{count}} selezionati","deleteSelected":"Elimina selezionati","clear":"Chiaro","deleteTitle":"Elimina le conversazioni selezionate","deleteDescription":"Eliminare {{count}} conversazioni selezionate? Questa operazione non pu\xf2 essere annullata."},"copy":{"label":"Copia","success":"Copiato negli appunti.","error":"Impossibile copiare negli appunti."},"live":"Vivere","keychain":{"continue":"Continuare","title":"Proteggere la cronologia dell\'IA","message":"Cephable crittografa la cronologia delle tue attivit\xe0 di intelligenza artificiale, inclusa la cronologia dei flussi di lavoro, su questo Mac.","detail":"Successivamente, macOS ti chieder\xe0 di autorizzare l\'accesso a \\"Archiviazione sicura di Cephable\\". Questa contiene solo la chiave di crittografia, non il contenuto del tuo flusso di lavoro o delle tue attivit\xe0. Seleziona \\"Consenti sempre\\" per mantenere la cronologia crittografata disponibile senza che ti venga chiesto di nuovo. Selezionando \\"Consenti\\", Cephable potr\xe0 accedervi questa volta, ma macOS potrebbe richiederlo nuovamente al successivo avvio."},"rename":{"title":"Rinominare","label":"Titolo della conversazione"}},"uses":"Usi: {{value}}","skills":{"intro":"Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.","create":"Create skill","importFolder":"Import folder","importZip":"Import .zip","importError":"Could not import the skill.","enable":"Enable","openFolder":"Open folder","deleteConfirm":"Delete?","emptyTitle":"No skills yet","emptyBody":"Create your first skill or import one to get started.","sharingComingSoon":"Sharing skills with your organization and a skills marketplace are coming soon.","source":{"user":"Created by you","imported":"Imported","organization":"Organization","marketplace":"Marketplace"},"bestPractices":{"title":"Tips for great skills","description":"Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.","focused":"Keep instructions short and focused on one job. Use numbered steps in the order they should happen.","examples":"Add a short example of a request the skill handles and the ideal result.","keywords":"Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.","trust":"Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer.","activation":"Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. release-notes","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What the skill does and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use the skill. Be specific.","keywordsLabel":"Keywords (optional)","keywordsPlaceholder":"comma, separated, words","keywordsHelp":"Extra words that should trigger this skill (brand names, aliases, file types).","instructionsLabel":"Instructions (SKILL.md)","instructionsPlaceholder":"Step-by-step instructions for the assistant. Leave blank to start from a template.","save":"Save changes","create":"Create skill","saveError":"Could not save the skill.","activationLabel":"When should the assistant use this?"},"picker":{"title":"Skills","empty":"No matching skills","hint":"Type to filter skills"},"contextMenuItem":"Skill\u2026","chipRemove":"Remove skill","attached":"Attached skills","inUse":"Using skills:","section":{"title":"AI Skills","description":"Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."},"createDescription":"Build a reusable skill from scratch or a template.","import":"Import a skill","importDescription":"Add a skill from a folder or a .zip file.","copy":"Copy an existing skill","copyDescription":"Start from a copy of one of your skills.","copyShort":"Copy","editTitle":"Edit skill","newTitle":"New skill","templates":{"title":"Start from a template","blank":{"title":"Blank","summary":"Start from an empty template."},"navigateApp":{"title":"Navigate an app (click in steps)","summary":"Tell Cephable where to click, step by step, to get through an app."},"writeText":{"title":"Write or insert text","summary":"Draft text a certain way and type it where I am working."},"fillForm":{"title":"Fill out a form","summary":"Fill a form field by field from details I give you."},"summarizeDoc":{"title":"Summarize a document","summary":"Read a file and give a short, structured summary."},"start":"Parti da un modello\u2026","applied":"Modello applicato: modifica i dettagli qui sotto."},"activation":{"label":"Activation","auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant picks this skill on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never picks this on its own \u2014 it runs only when you attach it with / or @."},"mode":{"label":"How this skill is used","off":"Off","offTooltip":"Off \u2014 this skill is never used or shown in the picker."},"viewDetails":"View details","files":{"label":"Reference files & scripts","help":"Add files your skill uses \u2014 the assistant reads references and can run scripts. Mention them in your instructions above.","empty":"No files added yet.","add":"Add file\u2026","remove":"Remove file","addError":"Could not add the file.","kind":{"reference":"Reference file","script":"Script","asset":"Asset","referenceShort":"Reference","scriptShort":"Script","assetShort":"Asset"},"open":"Open file"},"scriptsSetting":{"label":"Let skills run scripts","help":"When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."},"capability":{"script":{"label":"Runs scripts","tooltip":"This skill can run programs on your computer \u2014 you approve each one before it runs. Only use skills you trust."},"reference":{"label":"Uses reference files","tooltip":"This skill includes reference files the assistant can read for detail. It does not run programs on your computer."},"basic":{"label":"Instructions only","tooltip":"This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."},"alsoReferences":"It also includes reference files it reads.","scriptsOff":"Script running is currently turned off in settings."},"teach":{"action":"Insegnare come competenza","generating":"Insegnamento\u2026","title":"Insegnare un\'abilit\xe0","heading":"Insegna a Cefabile una nuova abilit\xe0","subheading":"Cephable ha trasformato ci\xf2 che hai appena fatto in una skill riutilizzabile. Rivedila e modificala qui sotto, quindi salvala in modo che l\'assistente possa ripeterla per te e per chiunque tu condivida.","fromRun":"Basato su: {{title}}","filesTitle":"File da includere","filesHelp":"Questi sono file relativi alla tua sessione di gioco che potrebbero rendere l\'abilit\xe0 ripetibile. Mantieni quelli che devono essere associati all\'abilit\xe0; disattiva tutto ci\xf2 che contiene solo i dati di questa sessione.","detailsTitle":"Dettagli di svolta","addFile":"Aggiungi un altro file\u2026","include":{"add":"Includi","on":"Incluso \u2014 clicca per rimuovere","off":"Escluso \u2014 clicca per includere"},"included":"Incluso","origin":{"attached":"Hai fornito","template":"Modello","generated":"Produzione di run","observed":"Riunito","added":"Aggiunto da te"},"saved":"Abilit\xe0 salvata. Puoi attivarla e condividerla qui sotto.","error":"Impossibile creare un\'abilit\xe0 da questa esecuzione.","filesError":"Non \xe8 stato possibile aggiungere alcuni file di riferimento: {{files}}","notFound":"Questa bozza non \xe8 pi\xf9 disponibile.","backToSkills":"Torna alle competenze"},"actions":"Azioni di turno","body":{"empty":"Non sono ancora state aggiunte istruzioni.","label":"Istruzioni (SKILL.md)"},"importTooltip":"Importa una skill da una cartella o da un file .zip","install":"Installare","keywords":{"label":"Parole chiave"},"marketplace":{"description":"Competenze pubbliche condivise dalla comunit\xe0 che corrispondono alla tua ricerca.","title":"Dal mercato pubblico"},"share":"Condividere","shareError":"Qualcosa \xe8 andato storto.","sync":"Sincronizzazione","updateAvailable":"\xc8 disponibile una versione pi\xf9 recente.","searchPlaceholder":"Capacit\xe0 di ricerca\u2026","createTooltip":"Registrati mentre svolgi un\'attivit\xe0 oppure descrivi tu stesso l\'abilit\xe0.","createRecord":"Registra ci\xf2 che faccio","createScratch":"Partire da zero"},"on":"SU","off":"Spento","copied":"Copiato","mcp":{"section":{"title":"Utensili","description":"Collega i server MCP per fornire all\'assistente Cephable strumenti aggiuntivi. Utilizzali nel pannello digitando / o @."},"addServer":"Aggiungi un server","addServerDescription":"Collega un server MCP (tramite comando, HTTP o SSE) per aggiungere i relativi strumenti.","editTitle":"Server di modifica","newTitle":"Aggiungi server","deleteConfirm":"Eliminare?","contextMenuItem":"Utensili\u2026","chipRemove":"Rimuovere gli strumenti","inUse":"Utilizzo degli strumenti:","picker":{"title":"Competenze e strumenti"},"mode":{"label":"Come viene utilizzato questo server","off":"Spento","offTooltip":"Disattivato: questo server non viene mai utilizzato n\xe9 visualizzato nel selettore."},"activation":{"auto":"Automaticamente quando \xe8 adatto","autoShort":"Auto","autoDescription":"L\'assistente carica automaticamente gli strumenti di questo server quando la tua richiesta corrisponde, ma puoi comunque selezionarli con / o @.","manual":"Solo quando lo scelgo io","manualShort":"Manuale","manualDescription":"L\'assistente non lo carica mai automaticamente, ma solo quando lo si allega con / o @."},"transport":{"stdio":"Comando (stdio)","http":"AMD","sse":"SSE"},"auth":{"none":"Nessuno","apiKey":"Chiave API","headers":"Intestazioni personalizzate","oauth":"OAuth"},"requireApproval":{"short":"Approvare le chiamate","tooltip":"Quando questa opzione \xe8 attiva, \xe8 necessario approvare ogni chiamata di strumento proveniente da questo server prima che venga eseguita."},"oauth":{"connect":"Collegare","reconnect":"Ricollega","disconnect":"Disconnetti","connecting":"In attesa del browser\u2026","connected":"Collegato","notConnected":"Non connesso","error":"Autorizzazione non riuscita."},"status":{"ok":"Collegato","error":"Fallito","unknown":"Non testato","testing":"Connessione\u2026","toolsFound":"{{count}} strumenti trovati","label":"Connessione","toolsEnabledOf":"{{abilitato}} di {{count}} strumenti"},"editor":{"nameLabel":"Nome","namePlaceholder":"ad esempio filesystem","nameHelp":"Solo lettere minuscole, numeri e trattini.","descriptionLabel":"Descrizione","descriptionPlaceholder":"Cosa offre questo server e quando l\'assistente dovrebbe utilizzarlo.","descriptionHelp":"\xc8 cos\xec che l\'assistente decide quando utilizzarlo. Sii preciso.","transportLabel":"Tipo di connessione","commandLabel":"Comando","argsLabel":"Argomentazioni","argsHelp":"Argomenti separati da spazi passati al comando.","envLabel":"Variabili ambientali","envHelp":"Una CHIAVE=valore per riga.","urlLabel":"URL del server","authLabel":"Autenticazione","apiKeyHeaderLabel":"Nome dell\'intestazione","apiKeyPrefixLabel":"Prefisso di valore","apiKeyLabel":"Chiave API","secretSet":"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022 (memorizzato \u2014 tipo da sostituire)","oauthClientIdLabel":"ID cliente","oauthClientIdHelp":"Lascia vuoto per attivare la registrazione automatica, se supportata.","oauthClientSecretLabel":"segreto del cliente","oauthScopesLabel":"Cannocchiali","oauthScopesHelp":"Oscilloscopi separati da spazi da richiedere.","oauthDiscoveryLabel":"URL di scoperta (facoltativo)","oauthAuthUrlLabel":"Autorizzazione DB","oauthTokenUrlLabel":"Token DB","redirectLabel":"URI di reindirizzamento","redirectHelp":"La maggior parte dei server si registra automaticamente: basta lasciare vuoto il campo ID client e fare clic su Connetti. Se il provider richiede un URI di reindirizzamento, selezionare il tipo di callback accettato e registrare l\'URI qui sotto.","headersHelp":"L\'autenticazione tramite header personalizzato non \xe8 ancora modificabile; utilizzare la chiave API o OAuth per i server autenticati.","activationLabel":"Quando dovrebbe usarlo l\'assistente?","requireApprovalLabel":"Richiedere l\'approvazione per ogni chiamata di strumento","requireApprovalHelp":"Quando questa opzione \xe8 attiva, \xe8 necessario approvare ogni chiamata di strumento proveniente da questo server prima che venga eseguita. Consigliata per server che possono modificare dati o effettuare transazioni finanziarie.","testConnection":"Verifica la connessione","save":"Salva le modifiche","create":"Aggiungi server","saveError":"Impossibile salvare il server.","oauthDiscoveryHelp":"Opzionale: lasciare vuoto per utilizzare il documento di individuazione del server.","oauthDiscoveryLabelShort":"URL di scoperta","oauthOnDevice":"Ciascun membro completa l\'accesso OAuth sul proprio dispositivo quando abilita questo connettore.","secretsOnDevice":"Ogni membro inserisce la propria chiave API sul proprio dispositivo quando abilita questo connettore; le chiavi non vengono mai memorizzate qui.","noPermissions":"Questo server utilizza l\'app registrata di {{provenance}}. Fai clic sul pulsante per personalizzarla oppure su Connetti per iniziare a usarla.","altOptions":{"copy":"Utilizza le mie credenziali","organization":"Portale Cephable"},"copyName":"{{name}}-copia","redirectTypeLabel":"Tipo di callback","redirectType":{"appCallback":"Web (https)","localhost":"Localhost"},"redirectPortLabel":"Porta","redirectNotes":{"appCallback":"Effettuando l\'accesso, il browser si aprir\xe0 e il controllo verr\xe0 automaticamente restituito all\'app Cephable.","localhost":"Effettuando l\'accesso, il browser si aprir\xe0 e si torner\xe0 a Cephable tramite questa porta. La pagina rimarr\xe0 aperta solo durante l\'accesso e solo su questo dispositivo."}},"actions":"Azioni del server","marketplace":{"description":"Connettori pubblici condivisi dalla community che corrispondono alla tua ricerca.","title":"Dal mercato pubblico"},"share":"Condividere","shareError":"Qualcosa \xe8 andato storto.","sync":"Sincronizzazione","tools":{"allToolsLabel":"per tutti gli strumenti","contextLabel":"di contesto","disableAll":"Disabilita tutto","empty":"Non sono ancora disponibili strumenti: testa la connessione per scoprirli.","enableAll":"Abilita tutto","help":"Disattiva gli strumenti che non ti servono. Un numero inferiore di strumenti occupa meno spazio nella finestra di dialogo dell\'assistente, mantenendolo veloce e concentrato.","label":"Utensili","searchPlaceholder":"Strumenti di ricerca\u2026","tokens":"~{{token}} hanno preso","tokensLabel":"token","disableSelected":"Disabilita selezionato","enableSelected":"Abilita selezionato"},"updateAvailable":"\xc8 disponibile una versione aggiornata.","searchPlaceholder":"Connettori di ricerca\u2026"},"send":"Inviare","availableToInstall":"Disponibile per l\'installazione","menu":{"expand":"Espandi menu"},"no":"NO","rating":{"review":{"comment":"Commento","commentPlaceholder":"Cosa ti \xe8 piaciuto o non ti \xe8 piaciuto? Come l\'hai utilizzato?","optional":"(opzionale)","submit":"Invia recensione","subtitle":"Condividi la tua esperienza con <strong>{{subject}}</strong> .","title":"Valuta e recensisci","write":"Scrivi una recensione","yourRating":"La tua valutazione"},"summary":{"comments":"commenti","installs":"installazioni","noRatings":"Nessuna valutazione ancora","openReview":"Valuta e recensisci","ratingCount":"{{count}} valutazioni"}},"workflow":{"feedback":{"includeDetails":"Condividi i nomi dei prompt e degli strumenti per aiutare a diagnosticare questo problema.","negative":"Pollice verso","placeholder":"Raccontaci di pi\xf9 (facoltativo)","positive":"Pollice su","question":"Come si \xe8 svolto questo flusso di lavoro?","send":"Invia feedback","thanks":"Grazie per il tuo feedback.","report":"Segnala un problema"}},"yes":"S\xcc","scheduledTasks":{"title":"Attivit\xe0 programmate","description":"Automazioni programmate per essere eseguite all\'orario da te scelto. Tutto rimane su questo dispositivo.","hint":"Le attivit\xe0 pianificate vengono eseguite solo quando questa app \xe8 in esecuzione. Se il PC \xe8 spento o l\'app \xe8 chiusa all\'orario pianificato, l\'esecuzione viene contrassegnata come persa e potrai eseguirla in un secondo momento.","new":"Nuova attivit\xe0 programmata","scheduleButton":"Programma","create":{"title":"Nuova attivit\xe0 programmata","description":"Imposta un prompt da eseguire automaticamente in base a una pianificazione.","saved":"Attivit\xe0 pianificata creata."},"composer":{"placeholder":"Descrivi cosa dovrebbe fare Cephable... Usa / o @ per aggiungere competenze e connettori."},"runHistory":{"title":"Cronologia delle esecuzioni","viewRun":"Visualizza l\'esecuzione","noOutput":"Nessun output salvato","resolution":{"ignored":"Ignorato","rerun":"Ripubblicare","rescheduled":"Riprogrammato"}},"badge":{"scheduled":"Programmato","recurring":"Ricorrente"},"fromRun":{"scheduled":"Questa esecuzione fa parte di un\'attivit\xe0 pianificata: {{name}}","recurring":"Questa esecuzione fa parte di un\'attivit\xe0 ricorrente: {{name}}","view":"Visualizza l\'attivit\xe0 pianificata"},"search":{"placeholder":"Cerca le attivit\xe0 pianificate..."},"filter":{"label":"Filtro","all":"Tutto","enabled":"Attivo","paused":"In pausa","missed":"Mancato"},"empty":{"title":"Nessuna attivit\xe0 programmata al momento","description":"Pianifica un promemoria facendo clic con il pulsante destro del mouse sul pulsante Invia nel pannello mentre sei in modalit\xe0 Automatica o Automatizzata."},"pagination":{"range":"{{inizio}}\u2013{{fine}} di {{totale}}"},"status":{"running":"Corsa","success":"Riuscito","failed":"Fallito","missed":"Mancato","paused":"In pausa"},"summary":{"once":"Una volta il {{datetime}}","everyOne":"Ogni {{unit\xe0}}","everyN":"Ogni {{count}} {{unit\xe0}}","onDays":"nei {{giorni}}","onDayOfMonth":"nel giorno {{day}}","atTime":"alle {{time}}","unit":{"minute":"minuto","minute_other":"minuti","hour":"ora","hour_other":"ore","day":"giorno","day_other":"giorni","week":"settimana","week_other":"settimane","month":"mese","month_other":"mesi"}},"card":{"nextRun":"Prossima corsa","runNow":"Corri adesso","pause":"Pausa","resume":"Riprendere","enabledToggle":"Attiva o metti in pausa questa attivit\xe0","viewLastRun":"Visualizza l\'ultima esecuzione riuscita","noSuccessfulRun":"Nessuna esecuzione riuscita finora"},"missed":{"runNow":"Corri adesso","reschedule":"Riprogrammare","ignore":"Ignorare"},"runNow":{"started":"Esecuzione di \\"{{name}}\\" in corso.","busy":"\xc8 gi\xe0 in esecuzione un altro flusso di lavoro. Riprova al termine."},"delete":{"title":"Eliminare l\'attivit\xe0 pianificata?","description":"Questa operazione rimuove definitivamente l\'attivit\xe0 pianificata. Non \xe8 possibile annullare l\'operazione."},"editor":{"kindLabel":"Tipo di programma","once":"Una volta","recurring":"Ricorrente","runAt":"Correre a","frequency":"difficolt\xe0","every":"Ogni","interval":"Intervallo","onDays":"Nei giorni","dayOfMonth":"Giorno del mese","atTime":"Al tempo","startAt":"Inizi","endsOn":"Termina il","units":"Unit\xe0"},"edit":{"title":"Modifica attivit\xe0 pianificata","description":"Regola il prompt e la sua pianificazione prima dell\'esecuzione.","name":"Nome","namePlaceholder":"Assegna un nome a questa attivit\xe0 pianificata","prompt":"Richiesta","customContext":"Contesto personalizzato","contextNote":{"generic":"Il contesto di questa attivit\xe0 viene risolto al momento dell\'esecuzione.","highlighted":"Questa attivit\xe0 utilizza il testo evidenziato nell\'app attiva al momento dell\'esecuzione.","clipboard":"Questa attivit\xe0 utilizza il contenuto degli appunti durante l\'esecuzione.","auto":"Il contesto di questa attivit\xe0 viene risolto automaticamente all\'avvio."},"attachments":"File e cartelle allegati","skills":"Competenze","connectors":"Connettori","schedule":"Programma","goalRequired":"Inserisci un prompt per questa attivit\xe0.","saved":"Attivit\xe0 pianificata salvata.","notFound":"Questa attivit\xe0 pianificata non esiste pi\xf9."},"schedulePrompt":{"menuItem":"Pianifica questo promemoria\u2026","title":"Pianifica questo promemoria","prompt":"Richiesta","name":"Nome (facoltativo)","namePlaceholder":"Assegna un nome a questa attivit\xe0 pianificata","confirm":"Programma","goalRequired":"Inserisci un prompt per programmare.","success":"Programmazione puntuale.","error":"Impossibile programmare questo prompt."},"notify":{"runStarted":{"title":"Esecuzione dell\'attivit\xe0 pianificata","body":"\\"{{name}}\\" \xe8 in esecuzione ora."},"missed":{"title":"Attivit\xe0 programmata mancata","bodyOne":"\\"{{name}}\\" \xe8 stato perso mentre l\'app non era in esecuzione.","bodyMany":"{{count}} attivit\xe0 programmate sono state saltate mentre l\'app non era in esecuzione."}},"skippedBusy":"Operazione saltata perch\xe9 era gi\xe0 in esecuzione un altro flusso di lavoro.","overlap":{"title":"Gli orari si sovrappongono","description":"Questa automazione viene eseguita entro 5 minuti da \\"{{name}}\\" ({{time}}). Solo un\'automazione alla volta \xe8 in esecuzione, quindi una attender\xe0 che l\'altra termini. Vuoi comunque programmarla?","confirm":"Programmare comunque"}},"keyboardService":{"unavailable":{"title":"Controllo tastiera e mouse interrotto","recovering":"Cephable lo sta riavviando. I comandi funzioneranno di nuovo tra un attimo.","stalled":"Cephable non \xe8 riuscito a riavviarsi. Riprova il comando oppure riavvia Cephable se continua a non funzionare.","permissionTitle":"Cephable non pu\xf2 controllare la tastiera e il mouse.","permission":"Concedi a Cephable l\'accesso in Impostazioni di sistema > Privacy e sicurezza > {{pane}}, quindi riprova a eseguire il comando.","permissionWindows":"Windows impedisce alle app di controllare i programmi eseguiti con i privilegi di amministratore. Chiudi e riapri Cephable come amministratore oppure riapri l\'altra app senza i diritti di amministratore. Le richieste di sicurezza di Windows e la schermata di blocco non possono essere controllate. Su un dispositivo aziendale, l\'amministratore IT potrebbe aver bloccato questa funzione."},"restored":"Il controllo tramite tastiera e mouse funziona di nuovo."},"error":"Errore","macPermissions":{"openSettings":"Apri le impostazioni","pane":{"accessibility":"Accessibilit\xe0","deviceControl":"Controllo del dispositivo e accesso ai dati","inputMonitoring":"Monitoraggio degli input","filesAndFolders":"File e cartelle","fullDiskAccess":"Accesso completo al disco","camera":"Telecamera","microphone":"Microfono","screenRecording":"Registrazione dello schermo"}},"recordWorkflow":{"title":"Registra un flusso di lavoro","description":"Mostra a Cephable come esegui un\'attivit\xe0 \u2014 descrivila a voce alta mentre clicchi \u2014 e diventer\xe0 un\'abilit\xe0 riutilizzabile.","cardDescription":"Registrati mentre esegui un\'attivit\xe0 per insegnare a Cephable come eseguirla.","goalLabel":"Descrizione della registrazione","goalPlaceholder":"Cosa stai per dimostrare? (facoltativo)","start":"Avvia la registrazione","recording":"Registrazione del flusso di lavoro","stepCount":"{{count}} passi","stopAndCreate":"Fermati e crea abilit\xe0","creating":"Trasformare la tua registrazione in un\'abilit\xe0...","permissionNeeded":"Cephable necessita dell\'autorizzazione Accessibilit\xe0/Monitoraggio input per registrare le tue azioni. Concedila nelle Impostazioni di sistema, quindi riavvia il sistema.","noMic":"Microfono non disponibile: le tue azioni verranno registrate senza commento audio.","startError":"Impossibile avviare la registrazione.","noSteps":"Non \xe8 stata registrata alcuna azione da trasformare in un\'abilit\xe0.","stopReminder":"Continua finch\xe9 ti serve. Quando l\'attivit\xe0 \xe8 terminata, torna qui e premi Interrompi e crea abilit\xe0.","callout":{"title":"Insegna a Cefabile uno dei tuoi compiti","description":"Esegui un\'attivit\xe0 una sola volta mentre Cephable osserva e descrivi a voce ci\xf2 che stai facendo. Si trasformer\xe0 in un\'abilit\xe0 che potrai utilizzare in qualsiasi momento.","action":"Mostrami come","dismiss":"Non adesso","badge":"Provalo","compactDescription":"Esegui un\'attivit\xe0 una sola volta mentre Cephable la osserva e diventer\xe0 un\'abilit\xe0 che potrai utilizzare in qualsiasi momento.","compactAction":"Registra un flusso di lavoro"},"coach":{"title":"Prima di registrare","progress":"Mancia {{attuale}} di {{totale}}","ready":"Sono pronto","skip":"Salta i consigli","reopen":"Come funziona","steps":{"pickTask":{"title":"Scegli un compito reale","body":"Scegli un\'attivit\xe0 che svolgi abitualmente e pianifica di portarla a termine dall\'inizio alla fine in un\'unica sessione. Un compito breve e completo insegna molto di pi\xf9 di uno lungo e incompiuto.","example":"Ecco come compilo il mio rapporto spese settimanale: lo apro, lo compilo e lo invio."},"narrate":{"title":"Parla per tutto il tempo","body":"Descrivi ad alta voce cosa stai facendo e perch\xe9, proprio come faresti se un nuovo collega ti stesse osservando. La tua descrizione \xe8 ci\xf2 che Cephable trasforma nei passaggi.","example":"Ora sto aprendo la fattura in Outlook per trovare il numero dell\'ordine di acquisto."},"goSlow":{"title":"Clicca con attenzione, una cosa alla volta.","body":"Attendi che ogni pagina o app abbia terminato il caricamento prima di fare clic sul successivo e dai un nome all\'elemento su cui stai cliccando. Evita di inserire informazioni private: password e numeri di carta di credito non sono adatti a una skill.","example":"Faccio clic su Approva in alto a destra e aspetto che appaia la conferma."},"explainRules":{"title":"Pronuncia le regole ad alta voce","body":"Segnala qualsiasi variazione da una sessione all\'altra e cosa faresti diversamente, in modo che l\'abilit\xe0 possa essere applicata anche in situazioni pi\xf9 complesse rispetto a oggi.","example":"Se non \xe8 presente un numero d\'ordine, salto il foglio di calcolo e invio un\'e-mail direttamente al fornitore."},"comeBack":{"title":"Torna indietro e premi Stop","body":"Cephable continua a registrare finch\xe9 non lo dici tu. Quando l\'attivit\xe0 \xe8 terminata, torna a questo pannello e premi Interrompi e crea skill. Se non rileva alcun suono o clic per un minuto, si fermer\xe0 automaticamente.","example":"Ecco fatto, \xe8 tutto."}}},"idle":{"title":"Registrazione ancora in corso","body":"Nessun clic e nessun commento per un po\'. Se hai terminato l\'attivit\xe0, premi Interrompi e crea abilit\xe0.","countdown":"Arresto automatico tra {{secondi}} secondi.","keepGoing":"Sto ancora lavorando","autoStopped":"La registrazione si \xe8 interrotta automaticamente dopo un minuto di silenzio."},"teachAction":"Insegna a Cephable un flusso di lavoro"},"backgroundCapture":{"title":"Contenuti di sfondo","capturing":"Archiviazione dei contenuti in background...","tooltip":"Contenuto che non \xe8 stato possibile digitare e che viene memorizzato per la sessione corrente. Scomparir\xe0 quando chiuderai Cephable.","nothingToPaste":"Non c\'\xe8 alcun contenuto di sfondo da incollare.","pasteNotPermitted":"Impossibile incollare. Azione non consentita a causa del focus corrente.","pasteFailed":"Impossibile incollare il contenuto di sfondo."}}');


var $b25c88c429ae6c78$exports = {};
$b25c88c429ae6c78$exports = JSON.parse('{"404":"Oh no! Abbiamo cercato nel mare e non riusciamo a trovare la pagina!","appError":{"title":"Qualcosa \xe8 andato storto","description":"L\'app ha riscontrato un problema imprevisto. Prova a ricaricarla o torna alla tua area di lavoro. Se il problema persiste, contatta l\'assistenza.","home":"Torna all\'area di lavoro"}}');


var $bd5ea8d28885a1b5$exports = {};
$bd5ea8d28885a1b5$exports = JSON.parse('{"smartTasks":{"generate":{"focusApp":{"title":"Concentrati sull\'app","description":"Assicurati di concentrarti sull\'app in cui desideri che appaia il testo generato. Potrai generare il testo in modo fluido in quella posizione cliccando su Genera."}},"rewrite":{"focusApp":{"title":"Concentrati sull\'app","description":"Assicurati di concentrarti sull\'app in cui desideri che appaia il testo riscritto. Potrai generare il testo in quella posizione senza problemi cliccando su \\"Genera\\"."}}},"customControls":{"tourLabel":"Controlli globali e dei dispositivi sempre disponibili","rowDescription":"I controlli globali e del dispositivo sono sempre disponibili se il microfono \xe8 attivo, indipendentemente dall\'app utilizzata. Puoi utilizzare questi controlli per interagire con il dispositivo senza dover creare nuovi controlli per le app. Contengono comandi utili come lo scambio di controlli o app, la generazione di testo, la messa in pausa del microfono e altro ancora."},"profile":{"switch":{"title":"Cambia i controlli dell\'app","description":"I controlli dell\'app possono cambiare automaticamente in base all\'app in uso, oppure puoi modificarli manualmente in qualsiasi momento qui."}},"dictation":{"tourLabel":"Dettatura","learn":"Scopri come usare la modalit\xe0 dettatura per convertire i tuoi discorsi in testo senza usare le mani.","welcome":{"title":"Dettatura","description":"La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. \xc8 come avere un assistente personale che digita tutto quello che dici."},"microphone":{"title":"Accendi il microfono","description":"Per prima cosa, accendi il microfono. Fai clic sull\'interruttore del microfono nel pannello Cephable."},"activate":{"title":"Avvia la modalit\xe0 di dettatura","description":"La voce si avvia in modalit\xe0 comando. Per avviare la dettatura, pronuncia \\"Avvia dettatura\\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalit\xe0 dettatura."},"focus":{"title":"Concentrati su un campo di testo o un documento","description":"La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Fare clic sul campo di testo o sul documento in cui si desidera dettare."},"speaking":{"title":"Inizia a parlare","description":"Ora puoi iniziare a parlare. Tutto ci\xf2 che dici verr\xe0 digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come \\"Ciao, questo \xe8 un test della modalit\xe0 dettatura\\"."},"pauseResume":{"title":"Mettere in pausa la dettatura","description":"Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \\"Metti in pausa la dettatura\\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \\"Avvia dettatura\\". Puoi personalizzare ulteriormente questa impostazione con i controlli globali e del dispositivo sempre attivi."},"stop":{"title":"Interruzione della dettatura","description":"Devi tornare ai controlli dell\'app? Basta dire \\"Interrompi dettatura\\". Questo interromper\xe0 la modalit\xe0 dettatura e ti riporter\xe0 alla modalit\xe0 comando. Puoi riprendere in qualsiasi momento premendo nuovamente \\"Avvia dettatura\\"."},"complete":{"description":"Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalit\xe0 dettatura a quella di comando. La dettatura \xe8 un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."}},"microphone":{"tourLabel":"Comandi vocali","learn":"Scopri come usare la voce per controllare qualsiasi app e come usare la dettatura per scrivere ci\xf2 che dici.","rowDescription":"Quando il microfono \xe8 disattivato, non ascolteremo affatto i tuoi comandi vocali, ma se lo attivi, potrai usare i comandi globali per attivare/disattivare pausa, avvio e altro ancora. Attiviamolo.","tryOpen":{"title":"Prova a dire `Apri Spotify` o `Apri Word`"},"finishedCommands":{"title":"Ottimo! Hai imparato le basi dei comandi vocali.","description":"Puoi sempre rivedere il tour dalla pagina di supporto. Il passo successivo \xe8 imparare a usare la dettatura. Puoi avviare il tour dalla pagina di supporto."}},"tour":{"startTour":"Inizia il tour","finishTour":"Fine del tour","statusDialog":"Per maggiori informazioni consultare il pannello.","step":"Passo {{step}} di {{total}}","skipTour":"Salta il tour"},"onboarding":{"overview":"Panoramica","learn":"Scopri le funzionalit\xe0 di Cephable e come utilizzarle.","start":"Sembra che tu abbia appena iniziato. Ecco alcuni aspetti che ti aiuteranno lungo il percorso.","dashboard":{"title":"Spazio di lavoro Cephable","description":"Cephable Workspace \xe8 il tuo centro di controllo per gestire il dispositivo, le app e le impostazioni. Da qui puoi personalizzare la tua esperienza, visualizzare i comandi attivi e accedere a tutte le funzionalit\xe0 di Cephable."},"step1":{"title":"Benvenuti a Cephable","description":"Cephable \xe8 la tua intelligenza artificiale personale, progettata per azioni rapide, comandi vocali, generazione di contenuti e automazione intelligente su tutti i tuoi strumenti. Controlli pronti all\'uso. Nessuna elaborazione cloud. Solo produttivit\xe0 che si muove con te."},"finish":{"continueToApp":"Continua alla dashboard di Cephable","keepExploring":"Continua a esplorare"},"useCaseSlider":{"context":"Vorrei usare","control":"controllare"}},"support":{"description":"Per maggiori informazioni su come utilizzare Cephable, tra cui ulteriori tour, guide dettagliate, tutorial e video, puoi visitare il nostro hub di supporto.","title":"Supporto"},"editingVideos":{"tourLabel":"Concentrati sulla storia, non sui noiosi clic per il montaggio video","learn":"Impara a usare i comandi vocali e la dettatura per modificare i video pi\xf9 velocemente ed eliminare lo sforzo cognitivo di dover ricordare quali pulsanti cliccare durante la modifica.","tryOpen":{"title":"Prova a dire \\"Apri CapCut\\" o \\"Apri iMovie\\"."},"complete":{"description":"Ora sai come usare i comandi vocali e le azioni rapide per riprodurre, mettere in pausa, saltare le tracce e regolare il volume nelle tue app di editing video preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo video ancora pi\xf9 fluido."}},"congrats":"Congratulazioni!","fpsGamePlay":{"tourLabel":"Gioca ai giochi FPS con i comandi vocali","learn":"Scopri come usare i comandi vocali e le azioni rapide per giocare ai giochi FPS.","tryOpen":{"title":"Prova a dire `Apri Valorant` o `Apri Battlefield`"},"complete":{"description":"Ora sai come usare i comandi vocali e le azioni rapide per muoverti, fermarti e controllare il tuo personaggio nei giochi FPS. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un gameplay ancora pi\xf9 fluido e veloce."}},"redo":"Ripeti l\'onboarding","title":"Incontra Cephable","description":"Incontra Cephable, il tuo assistente AI personale e condividi il tuo interesse per i casi d\'uso personalizzati.","panel":{"description":"Questo \xe8 il pannello, ovvero il centro di controllo principale. \xc8 sempre visibile e ti permette di controllare le tue app usando la voce, e altro ancora. Iniziamo con il microfono."},"controlExpanded":{"tourLabel":"Controllare","description":"I controlli dell\'app sono insiemi configurabili di controlli che \xe8 possibile utilizzare in una determinata applicazione. Questa sezione mostra tutti i controlli disponibili che \xe8 possibile utilizzare tramite comandi vocali, tocchi, digitazione e altro ancora."},"submit":{"title":"Invia","description":"Il contenuto verr\xe0 visualizzato nella posizione in cui si trova il cursore."},"tryOpen":{"description":"`Apri` \xe8 un comando globale che apre l\'app specificata e le assegna il focus. Se \xe8 abilitata la commutazione automatica dei controlli, verranno visualizzati anche i controlli dell\'app pi\xf9 adatti all\'app in uso."},"modeSelector":{"title":"Seleziona la modalit\xe0","description":"Se disponibile, puoi selezionare la modalit\xe0 in cui operer\xf2. Usa Controllo per l\'app tramite cui desideri inviare i comandi, Crea per contenuti di testo generativi come riassunto, riscrittura, traduzione. Seleziona Automatizza per flussi desktop o tra app."},"contextSelector":{"title":"Seleziona lo sfondo","description":"Se disponibile, puoi selezionare il contesto in cui operer\xf2. Ad esempio, posso utilizzare gli appunti o il testo evidenziato, e puoi anche allegare file o cartelle con cui desideri che io lavori."},"panelInput":{"title":"Cosa vuoi che faccia?","description":"Puoi impartire comandi, digitare o dettare ci\xf2 che desideri che io faccia."},"figma":{"tourLabel":"Comandi vocali per Figma e Canva","learn":"Scopri come utilizzare i comandi vocali, il mouse vocale, la dettatura e la generazione di contenuti tramite intelligenza artificiale di Controls per migliorare il tuo flusso di lavoro di progettazione.","complete":{"description":"Ora sai come controllare e creare progetti per ottimizzare il tuo flusso di lavoro. Prova a esplorare altri comandi per un controllo ancora pi\xf9 fluido dei tuoi progetti."},"tryOpen":{"title":"Prova a dire \\"Apri Figma\\" o \\"Apri Canvas\\"."}},"voiceMouse":{"title":"Voice Mouse","description":"Per cliccare sui pulsanti in base al nome, puoi usare Voice Mouse. Puoi attivarlo dicendo \\"tocca salva\\" o \\"vai alle impostazioni\\"."},"documentSummary":{"tourLabel":"Bozza di sintesi del team basata su rapporti riservati.","learn":"Automatizza la lettura dei report di reparto, identifica le persone giuste da informare e redigi un\'e-mail, il tutto direttamente sul dispositivo, garantendo cos\xec la privacy dei tuoi dati riservati.","congrats":{"description":"Ora sai come utilizzare i flussi di lavoro basati sull\'intelligenza artificiale per leggere documenti riservati e redigere un\'e-mail riassuntiva da inviare al tuo team, il tutto senza che i tuoi dati lascino il tuo dispositivo."}},"extensions":{"tourLabel":"Estensioni","rowDescription":"Estendi le funzionalit\xe0 di Cephable con ulteriori metodi di controllo del dispositivo, come i controlli della fotocamera per i movimenti del viso e della testa o il supporto per i gamepad. Attiva quelli che ti servono qui."},"developerBuildTests":{"tourLabel":"Automatizza build e test con flussi di lavoro basati sull\'intelligenza artificiale.","learn":"Cephable \xe8 in grado di eseguire attivit\xe0 da terminale composte da pi\xf9 fasi, come la compilazione del progetto e l\'esecuzione dei relativi test, interamente sul dispositivo, in background, mentre tu continui a lavorare.","complete":{"description":"Ora sai come eseguire flussi di lavoro AI sul dispositivo per attivit\xe0 di compilazione e test a pi\xf9 fasi, rispondere alle richieste di autorizzazione e continuare a iterare sui risultati. Prova ad automatizzare un\'altra attivit\xe0 di sviluppo ripetitiva."}},"classroomStudyTools":{"tourLabel":"Trasforma gli appunti e gli articoli presi in classe in strumenti di studio e materiali didattici","learn":"Cephable supporta insegnanti e studenti con la dettatura, strumenti di creazione integrati e funzionalit\xe0 di automazione, direttamente nelle app che gi\xe0 utilizzano, garantendo la privacy e la sicurezza dei dati sul proprio dispositivo.","complete":{"description":"Ora sai come dettare direttamente nei tuoi documenti, generare nuovi materiali di studio dai tuoi appunti e utilizzare Automate per creare compiti completi in background, tutto sul tuo dispositivo."}},"engineeringFlows":{"tourLabel":"Comandi vocali e automazioni basate sull\'intelligenza artificiale per sviluppatori.","learn":"Scopri come velocizzare il tuo flusso di lavoro di sviluppo con comandi vocali, la riscrittura automatica del codice tramite IA utilizzando il tuo codice come contesto e flussi di lavoro IA in background, il tutto in esecuzione direttamente sul dispositivo.","tryOpen":{"title":"Prova a dire \\"Apri Visual Studio Code\\"."},"complete":{"description":"Ora sai come utilizzare i comandi di sviluppo a controllo vocale, la funzione AI Rewrite con il tuo codice come contesto e i flussi di lavoro AI in background per velocizzare il tuo flusso di lavoro di sviluppo."}},"meetingNotesToFiles":{"tourLabel":"Trasforma gli appunti delle riunioni in file utilizzabili","learn":"Cephable pu\xf2 suddividere gli appunti delle riunioni in file pi\xf9 piccoli e gestibili, che puoi consultare al tuo ritmo, interamente sul tuo dispositivo.","complete":{"description":"Ora sai come utilizzare i flussi di lavoro basati sull\'IA per suddividere gli appunti delle riunioni in file pi\xf9 piccoli e gestibili, e riprendere la conversazione in qualsiasi momento dalla cronologia dell\'IA."}},"notesToPresentation":{"tourLabel":"Riassumi appunti riservati e crea una presentazione, tutto direttamente sul dispositivo.","learn":"Cephable \xe8 in grado di riassumere i tuoi report e appunti riservati, quindi utilizzare i flussi di lavoro basati sull\'intelligenza artificiale per farlo su un\'intera cartella di file e persino creare una presentazione dai risultati. Il tutto viene eseguito direttamente sul dispositivo.","complete":{"description":"Ora sai come riassumere documenti riservati, riassumere in blocco un\'intera cartella con i flussi di lavoro basati sull\'intelligenza artificiale e trasformare i risultati in una presentazione, il tutto senza che i tuoi dati lascino il tuo dispositivo."}},"organizeDownloads":{"tourLabel":"Organizza i file, fai pulizia e ritrova ci\xf2 che hai perso: con i flussi di lavoro basati sull\'intelligenza artificiale.","learn":"Automate \xe8 in grado di gestire attivit\xe0 di gestione dei file in pi\xf9 fasi, come la copia, l\'eliminazione e la ricerca di file, con un semplice comando.","complete":{"description":"Ora sai come utilizzare i flussi di lavoro basati sull\'intelligenza artificiale per organizzare i file, eliminarli in modo sicuro con controlli di autorizzazione e trovare i file di cui non ricordi la posizione."}},"outlookEmailProductivity":{"tourLabel":"Velocizza la posta elettronica in Outlook con la dettatura, le azioni rapide e l\'intelligenza artificiale.","learn":"Cephable Plus e Professional includono strumenti intelligenti di dettatura e creazione per generare e modificare contenuti: utilizzali direttamente in Outlook per rispondere e redigere email pi\xf9 velocemente.","complete":{"description":"Ora sai come rispondere alle email tramite dettatura, utilizzare le tue azioni di digitazione rapida e usare le funzioni Riepiloga e Genera per redigere e perfezionare il contenuto delle email, tutto direttamente sul dispositivo."}},"customizingGameControls":{"tourLabel":"Gioca ai giochi di ruolo con i comandi vocali","learn":"Impara a usare i comandi vocali e le azioni rapide per giocare ai giochi di ruolo.","tryOpen":{"title":"Prova a dire \\"Apri Minecraft\\"."},"complete":{"description":"Ora sai come usare i comandi vocali e le azioni rapide per muovere, fermare e controllare il tuo personaggio nei giochi di ruolo. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un\'esperienza di gioco ancora pi\xf9 fluida e veloce."}},"voiceToTextSocialMedia":{"tourLabel":"Sintesi vocale per LinkedIn, Slack e Discord","learn":"Utilizza la Dettatura Intelligente per leggere un post in modo naturale, poi riscrivilo per adattarne il tono: funziona allo stesso modo su LinkedIn, Slack, Discord e altre piattaforme.","complete":{"description":"Ora sai come dettare un post e perfezionarlo con Rewrite, su LinkedIn, Slack, Discord e altro ancora."}},"aiDocumentTranslation":{"tourLabel":"Traduci documenti in qualsiasi lingua, direttamente sul dispositivo.","learn":"Cephable \xe8 in grado di tradurre un documento in una lingua alla volta, oppure di utilizzare flussi di lavoro basati sull\'intelligenza artificiale per tradurlo contemporaneamente in pi\xf9 lingue, il tutto in locale.","complete":{"description":"Ora sai come tradurre un documento in una singola lingua tramite dettatura, oppure in pi\xf9 lingue contemporaneamente con i flussi di lavoro basati sull\'intelligenza artificiale, il tutto direttamente sul dispositivo."}},"excelAiAutomation":{"tourLabel":"Analizza i fogli di calcolo con l\'intelligenza artificiale privata integrata nel dispositivo.","learn":"Cephable \xe8 in grado di analizzare i tuoi file Excel, rispondere a domande sui dati numerici e approfondire ulteriormente l\'analisi, il tutto senza che i tuoi dati lascino il tuo dispositivo.","complete":{"description":"Ora sai come utilizzare i flussi di lavoro basati sull\'IA per analizzare i tuoi fogli di calcolo, approfondire le analisi con domande di follow-up e salvare un riepilogo, il tutto direttamente sul tuo dispositivo."}},"handsFreeComputerControl":{"tourLabel":"Controlla il tuo computer con la voce e la videocamera.","learn":"Cephable ti permette di controllare il computer a mani libere utilizzando comandi vocali, Voice Mouse e controlli basati su movimenti della testa e del viso tramite fotocamera.","tryOpenWord":{"title":"Prova a dire \\"Apri parola\\""},"openExtensions":{"title":"Apri la scheda Estensioni","description":"Per attivare i controlli della fotocamera, apri la scheda Estensioni nella finestra principale."},"turnOnCamera":{"title":"Attiva i controlli della fotocamera","description":"Attiva la fotocamera. Accanto all\'icona del microfono comparir\xe0 un\'icona a forma di fotocamera e nelle Impostazioni verr\xe0 visualizzata una nuova sezione \\"Fotocamera\\"."},"cameraInPanel":{"title":"Comandi della fotocamera nel pannello","description":"Ora che i controlli della fotocamera sono attivi, l\'interruttore della fotocamera appare anche nel pannello di Cephable: Cephable lo attiva automaticamente da qui."},"openCameraSettings":{"title":"Apri le impostazioni della fotocamera","description":"Apri le impostazioni della fotocamera per personalizzare il funzionamento dei controlli per la testa e il viso."},"chooseHeadMouseMode":{"title":"Scegli una modalit\xe0 mouse-testa","description":"Scegli come il movimento della testa controlla il mouse: Steady Glide, Speed Boost o Dynamic Glide."},"complete":{"description":"Ora sai come controllare il computer con la voce, il mouse vocale e i comandi basati su movimenti della testa e del viso tramite la fotocamera. Esplora ulteriormente le impostazioni della fotocamera per configurare i controlli pi\xf9 adatti alle tue esigenze."}},"handsFreeTypingDocumentCreation":{"tourLabel":"Crea e modifica documenti senza usare le mani","learn":"Utilizza le funzioni Genera, Riscrivi e i comandi vocali insieme per creare e modificare un documento, come una fattura, quasi completamente senza usare le mani.","complete":{"description":"Ora sai come generare, riscrivere e modificare un documento quasi completamente a mani libere utilizzando i comandi Genera, Riscrivi e i comandi vocali."}},"webResearchCreateHtml":{"tourLabel":"Ricerca sul Web e crea un sito web a partire dai risultati ottenuti, tutto direttamente sul dispositivo.","learn":"Cephable \xe8 in grado di esplorare e analizzare i siti web dei concorrenti, quindi utilizzare le informazioni raccolte per generare un nuovo sito HTML per te, il tutto direttamente sul dispositivo, garantendo cos\xec la privacy delle tue ricerche.","complete":{"description":"Ora sai come utilizzare i flussi di lavoro basati sull\'intelligenza artificiale per analizzare i siti web dei concorrenti e generare un nuovo sito HTML a partire dai risultati ottenuti, il tutto senza che i tuoi dati lascino il tuo dispositivo."}},"webResearchSummarize":{"tourLabel":"Regolamentazione della ricerca e riepilogo dei risultati \u2014 Tutto sul dispositivo","learn":"Cephable pu\xf2 navigare sul web per ricercare modifiche come le nuove leggi sulla protezione dei dati, quindi riassumere i risultati in un documento su cui il tuo team pu\xf2 intervenire, il tutto direttamente sul dispositivo, garantendo cos\xec la privacy delle tue ricerche.","complete":{"description":"Ora sai come utilizzare i flussi di lavoro basati sull\'IA per ricercare modifiche normative, approfondire l\'implementazione e redigere i risultati in un\'e-mail che il tuo team potr\xe0 modificare, il tutto senza che i tuoi dati lascino il tuo dispositivo."}},"stopListening":{"title":"Prova a dire \\"Smetti di ascoltare\\".","description":"In questo modo il microfono si mette in pausa senza essere disattivato completamente. Pronuncia di nuovo \\"Inizia ad ascoltare\\" quando sei pronto."}}');


var $8e153465ce61e1ac$exports = {};
$8e153465ce61e1ac$exports = JSON.parse('{"introduction":{"title":"Ciao, sono Cephable.","back":"Torna all\'introduzione","description":"Sono la tua intelligenza artificiale personale che ti aiuta a controllare, creare e automatizzare utilizzando gli strumenti che gi\xe0 ami, su tutte le tue connessioni. Ci sono alcune cose che dovresti sapere su di me.","action":"Cominciamo!","recording":{"title":"La tua voce e il tuo video restano locali.","description":"Non registro, trasmetto in streaming o invio mai audio o video al cloud. Tutti gli input vengono elaborati sul dispositivo, in modo privato e sicuro."},"data":{"title":"I tuoi dati sono tuoi.","description":"Non utilizzo i tuoi comandi o le tue attivit\xe0 per addestrare modelli per altri. Tutto rimane privato e i controlli della tua app si spostano con te tra le connessioni."},"offline":{"title":"Io lavoro quando gli altri strumenti non lo fanno.","description":"Attivit\xe0 intelligenti come la generazione di contenuti, la riscrittura, la traduzione e la dettatura vengono eseguite localmente. Non \xe8 necessario il cloud. Ci\xf2 significa che lavoro anche quando sei offline e i tuoi dati non lasciano il tuo dispositivo."},"empower":{"title":"Costruito per dare potere, non per sfruttare.","description":"Sono progettato per migliorare il tuo controllo, non per monitorarlo. Nessun tracciamento invasivo. Nessuna raccolta di dati inquietante. Solo input che funzionano per te."}},"my-capabilities":{"title":"Perfetto! Ecco come posso aiutarti.","back":"Torna alle capacit\xe0","actionTitle":"Guardami in azione","description":"Ecco le funzionalit\xe0 e le capacit\xe0 pi\xf9 rilevanti per il tuo flusso di lavoro, organizzate in base alle tre aree di competenza di Cephable.","action":{"title":"Guardami in azione","description":"Scopri alcuni esempi di come posso aiutarti nelle tue attivit\xe0 quotidiane."},"basedOnInterests":"In base ai tuoi interessi","cta":{"eyebrow":"Pronto quando lo sarai tu","title":"Vedilo in azione nelle tue app"}},"see-me":{"title":"Vuoi vedere come ho aiutato altre persone come te?","back":"Torna ai casi d\'uso","description":"Ecco alcuni esempi concreti di come ho trasformato i flussi di lavoro in diversi settori e ruoli."},"complete":{"title":"Pronto a iniziare a usarmi?","description":"Hai visto cosa so fare! Ora ti aiuter\xf2 a configurare il tutto e a trasformare il tuo flusso di lavoro. Sar\xf2 qui per aiutarti in ogni fase del percorso.","action":"Completa la configurazione e inizia a utilizzare Cephable"},"apps":{"title":"Supporto gli strumenti che gi\xe0 ami","description":"Con supporto preconfigurato per oltre 200 applicazioni, lavoro con il software che usi ogni giorno. Nessuna configurazione richiesta.","note":"Non vedi un\'app che usi? Nessun problema: posso generare controlli o aiutarti a creare flussi di lavoro personalizzati adatti alle tue esigenze.","andMore":"E altro ancora","eyebrow":"Oltre 200 app, nessuna configurazione"},"actions":{"ctaTry":"Provalo ora","ctaWatch":"Guarda la demo","apps":"Sono compatibile con:","abilities":"Le mie abilit\xe0 utilizzate:"},"interests":{"title":"Come posso aiutarti?","back":"Torna agli interessi","description":"Posso controllare le app sul tuo desktop e sui dispositivi connessi. Personalizziamo la tua esperienza: quali aree ti interessano di pi\xf9?","note":"Seleziona tutte le opzioni che ritieni appropriate e ti mostrer\xf2 le funzionalit\xe0 e gli esempi pi\xf9 pertinenti per il tuo flusso di lavoro.","action":"Continua con {{count}} interessi","empty":"Seleziona almeno un interesse.","create_design":{"label":"Crea e progetta","shortLabel":"Progetto","description":"Per artisti, addetti al marketing e creatori di contenuti."},"analyze_report":{"label":"Analizza e segnala","shortLabel":"Analizzare","description":"Per analisti, ricercatori e professionisti del settore."},"communicate_collaborate":{"label":"Comunicare e collaborare","shortLabel":"Comunicare","description":"Per venditori, riunioni e team remoti."},"build_develop":{"label":"Costruisci e sviluppa","shortLabel":"Sviluppare","description":"Per sviluppatori, ingegneri e professionisti tecnici."},"game_play":{"label":"Gioco e gioco","shortLabel":"Gioco d\'azzardo","description":"Per giocatori, streamer e controllori multimediali."},"learn_teach":{"label":"Impara e insegna","shortLabel":"Apprendimento","description":"Per educatori, studenti e docenti."},"manage_organize":{"label":"Gestisci e organizza","shortLabel":"Organizzazione","description":"Per project manager, coordinatori e organizzatori."},"adapt_access":{"label":"Adatta e accedi","shortLabel":"Accessibilit\xe0","description":"Per controlli adattivi ed esigenze di accessibilit\xe0 personalizzate."},"everything":{"label":"Un po\' di tutto","shortLabel":"Qualunque cosa","description":"Per utenti generici di computer e per chi svolge pi\xf9 attivit\xe0 contemporaneamente."},"filter":"Filtra per tipo di interessi"},"capabilities":{"title":"Le mie principali capacit\xe0 di intelligenza artificiale","description":"Combino l\'intelligenza artificiale avanzata con potenti metodi di input per offrirti un controllo impeccabile sulle tue app e sui tuoi dispositivi. Ecco alcune delle cose che posso fare.","voice_controls":{"title":"Comandi vocali","description":"Comprendo i comandi in linguaggio naturale, cos\xec puoi controllare qualsiasi app con la tua voce.","longDescription":"Ti lascio parlare in modo naturale e portare a termine le tue attivit\xe0. Che tu voglia aprire app, navigare nei menu o attivare flussi di lavoro, traduco il tuo inglese semplice in azioni affidabili e a mani libere."},"smart_dictation":{"title":"Dettatura intelligente","description":"Convertir\xf2 il tuo discorso in testo tenendo conto del contesto e della formattazione.","longDescription":"Ascolto attentamente e trascrivo le tue parole con precisione. Aggiungo la punteggiatura, correggo le maiuscole e applico una formattazione contestuale, in modo che il tuo testo risulti curato senza alcuno sforzo aggiuntivo."},"ai_text_generation":{"title":"Generazione di testo tramite intelligenza artificiale","description":"Posso creare e-mail, documenti, codici e contenuti creativi al volo.","longDescription":"Ti aiuto a scrivere bozze, riassumere o ampliare qualsiasi cosa direttamente nelle tue app. Dalle email alle note, dai frammenti di codice ai documenti, mi assicuro che tu non parta mai da una pagina vuota."},"head_face_controls":{"title":"Controlli per la testa e il viso","description":"Ti lascio innescare azioni con i movimenti della testa e del viso.","longDescription":"Traduco i movimenti naturali della testa e le espressioni in input precisi. Puoi inviare un\'e-mail con un sorriso, voltare pagina con un cenno del capo o cliccare alzando le sopracciglia."},"natural_language_voice_clicking":{"title":"Clic vocale in linguaggio naturale","description":"Ti lascio dire ci\xf2 che vedi per cliccare sui pulsanti, sui link e sui menu sullo schermo.","longDescription":"Quando pronunci il nome di qualcosa sullo schermo, lo trovo e interagisco con esso per te. Nessun comando memorizzato: descrivi semplicemente ci\xf2 che desideri e io mi occuper\xf2 del clic."},"keyboard_mouse_emulation":{"title":"Emulazione di tastiera e mouse","description":"Imito tasti, clic e scorrimento per consentirti di controllare le app senza hardware.","longDescription":"Invio sequenze di tasti, movimenti del mouse, clic e azioni di scorrimento ovunque tu ne abbia bisogno. Combinami con controlli vocali o gestuali per sostituire o potenziare completamente i dispositivi di input tradizionali."},"profiles_personalization":{"title":"Personalizzazione","description":"Ricordo le tue preferenze e le adatto ai controlli delle app salvati.","longDescription":"Tengo traccia delle tue app, dei tuoi comandi e delle tue preferenze preferite. Passa da un controllo app all\'altro automaticamente o manualmente e ti mostrer\xf2 sempre i comandi giusti per quello che stai facendo."},"cross_device_connectivity":{"title":"Connettivit\xe0 tra dispositivi","description":"Ti consento di utilizzare il tuo telefono per avviare un\'automazione da remoto.","longDescription":"Collego il tuo dispositivo mobile al tuo desktop in modo che tu possa lanciare comandi, dettare o navigare con facilit\xe0. Perfetto per presentazioni, sessioni remote o uso occasionale."},"quick_action_buttons":{"title":"Pulsanti di azione rapida","description":"Ti offro pulsanti sensibili alle app per azioni rapide.","longDescription":"Offro pulsanti contestuali che si adattano alla tua app. Che si tratti di partecipare a una riunione, inviare un messaggio o creare una nuova email, rendo le attivit\xe0 complesse a portata di clic."},"ai_app_awareness":{"title":"Consapevolezza delle app AI","description":"Modifico i miei controlli in base all\'app che stai utilizzando.","longDescription":"Presto attenzione a ci\xf2 che \xe8 attivo sul tuo schermo, cos\xec posso offrirti i comandi giusti al momento giusto. Niente confusione, niente supposizioni: solo ci\xf2 di cui hai bisogno, quando ne hai bisogno. Tutto sul tuo dispositivo e senza inviare dati al cloud."},"ai_rewrite":{"title":"Riscrittura dell\'IA","description":"Posso riscrivere il tuo testo per migliorarne il tono, aggiornarne la formattazione o ampliarne i dettagli.","longDescription":"Modifico il testo proprio dove stai lavorando. Posso renderlo pi\xf9 amichevole, pi\xf9 formale, pi\xf9 breve, pi\xf9 lungo o pi\xf9 dettagliato: qualsiasi cosa ti serva per trasmettere meglio il tuo messaggio."},"ai_translation":{"title":"Traduzione AI","description":"Posso tradurre tra lingue diverse o anche tra linguaggi di programmazione.","longDescription":"Ti permetto di trasformare il testo in un\'altra lingua parlata o di convertire il codice in un altro linguaggio di programmazione. Lavoro sul posto, cos\xec non devi uscire dall\'app che stai utilizzando."},"head_mouse":{"title":"Testa di topo","description":"Ti lascio muovere il cursore del mouse con i movimenti della testa.","longDescription":"Trasduco fluidamente i movimenti della testa in movimenti del cursore. Grazie a funzioni come lo scorrimento e la regolazione della sensibilit\xe0, ti offro un controllo preciso, comodo e a mani libere."},"head_joystick":{"title":"Joystick di testa","description":"Ti lascio usare la testa come un joystick per giochi o app.","longDescription":"Mappo i movimenti della tua testa sugli assi del joystick in modo che tu possa giocare o controllare software creativi senza hardware. Tu ti muovi in modo naturale e io traduco i tuoi movimenti in input analogico."},"mcp_agent":{"title":"Agente MCP","description":"Posso connettermi con agenti di intelligenza artificiale esterni tramite il Model Context Protocol (MCP).","longDescription":"Parlo il protocollo Model Context, che mi permette di lavorare insieme ad altri agenti e strumenti di intelligenza artificiale. Ci\xf2 significa che posso coordinare attivit\xe0, scambiare contesto ed estendere le mie capacit\xe0 con sistemi esterni specializzati, il tutto mantenendo il controllo a te."},"byo_ai_integration":{"title":"Porta la tua intelligenza artificiale","description":"Ti lascio potenziare la mia IA esistente con i tuoi modelli o servizi di IA da utilizzare insieme a me.","longDescription":"Se disponi gi\xe0 di un servizio, un modello o un fornitore di intelligenza artificiale di cui ti fidi, posso integrarlo nel mio flusso di lavoro. Ti offro la flessibilit\xe0 di scegliere il motore che alimenta la generazione, la riscrittura o la traduzione, che sia cloud, locale o personalizzato. Quando sei offline o se il servizio non \xe8 disponibile, posso ricorrere alle mie funzionalit\xe0 integrate."},"workflows":{"title":"Flussi di lavoro","description":"Ti aiuto a concatenare le azioni in flussi di lavoro ripetibili.","longDescription":"Ti lascio progettare ed eseguire processi multi-step che collegano diversi input, comandi e output. Con i flussi di lavoro, puoi automatizzare attivit\xe0 di routine o creare interazioni complesse, attivate dalla tua voce o dai tuoi gesti, lasciando che io faccia il lavoro pi\xf9 pesante per te."},"showMore":"Mostra altro","showLess":"Mostra meno","background_creation":{"title":"Creatore di sfondi","description":"Io creo e modifico i contenuti in background mentre tu lavori.","longDescription":"Creo e modifico i contenuti in background mentre tu ti concentri sul tuo lavoro. Quando ne avrai bisogno, i contenuti saranno pronti nel tuo file system senza alcuna interruzione del flusso di lavoro e senza che tu debba copiarli."},"ai_summary":{"title":"Riepilogo sull\'intelligenza artificiale","description":"Ricava informazioni utili da testi lunghi e crea brevi riassunti o evidenzia i punti chiave."}},"listing":{"title":"Casi d\'uso","titleLong":"Scopri come posso aiutarti","recommended":"Consigliato per te","exploreMore":"Esplora altri casi d\'uso","description":"Scopri tutto quello che posso fare per migliorare il tuo flusso di lavoro. Dall\'aumento della produttivit\xe0 all\'assistenza creativa, trova i casi d\'uso perfetti per le tue esigenze.","all":"Tutto","search":"Cerca casi d\'uso, app o funzionalit\xe0...","noResults":"Nessun risultato trovato. Prova a modificare la ricerca o i filtri.","emptyAction":"Visualizza altro online"},"examples":{"universalAppControl":{"title":"Controllo universale delle app","description":"Controlla qualsiasi applicazione sul tuo computer con comandi vocali e automazione intelligente","descriptionLong":"Assumi il controllo di qualsiasi applicazione con potenti comandi vocali e automazione intelligente. Il nostro sistema Universal App Control impara il tuo modo di lavorare e si adatta alle tue esigenze, semplificando le attivit\xe0 complesse e rendendo istantanee le azioni di routine. Dalla gestione della tua suite di produttivit\xe0 al controllo di applicazioni multimediali e di gioco, questa funzionalit\xe0 \xe8 compatibile con l\'intero ambiente digitale."},"documentSummary":{"title":"Un agente desktop basato sull\'intelligenza artificiale che legge i tuoi documenti, ne scrive un riassunto e lo invia al tuo team.","description":"Utilizza un agente desktop privato per leggere documenti, redigere riassunti e condividerli con il tuo team in modalit\xe0 automatica.","descriptionLong":"Indica al tuo agente di intelligenza artificiale un documento e lascia che si occupi della lettura, della sintesi e dell\'invio. Tutto funzioner\xe0 in locale e in modo privato, permettendoti di lavorare in tutta tranquillit\xe0, senza dover fare nulla."},"editingVideos":{"title":"Montaggio audio in CapCut: naviga nella timeline, taglia le clip e resta concentrato sulla storia.","description":"Modifica i video utilizzando i comandi vocali e la dettatura, in modo da poter tagliare e organizzare le clip senza usare le mani.","descriptionLong":"Scorri la timeline, taglia e dividi le clip e dai forma al tuo montaggio usando solo la voce. Rimani concentrato sulla storia senza dover cliccare sui menu o usare il mouse."},"figma":{"description":"Modifica immagini e disegni utilizzando i comandi vocali e la dettatura intelligente, per iterazioni pi\xf9 rapide.","descriptionLong":"Dai vita alle tue idee visive con la modifica delle immagini tramite comandi vocali. Naviga pi\xf9 velocemente e perfeziona i tuoi progetti senza dover cliccare su menu complessi.","title":"Comandi vocali per Figma e Canva: controlla i livelli, cambia gli strumenti e copia il testo a mani libere."},"excelAnalysis":{"title":"Lavora pi\xf9 velocemente e analizza i dati in Excel grazie all\'automazione AI privata e locale.","description":"Analizza i fogli di calcolo e individua le tendenze utilizzando l\'automazione AI locale e privata, senza alcun intervento manuale.","descriptionLong":"Analizza le tendenze all\'interno di una cartella o di un documento, poni domande sui report finanziari e elabora un riepilogo finale. Lascia che l\'intelligenza artificiale locale si occupi dell\'analisi, mantenendo i tuoi dati privati sul tuo computer."},"emailAutomation":{"title":"Automatizza la tua posta elettronica: flussi di lavoro basati sull\'intelligenza artificiale che leggono la tua casella di posta, scrivono bozze di risposta e molto altro!","description":"Leggi la tua casella di posta, scrivi bozze di risposte e crea modelli utilizzando flussi di lavoro di intelligenza artificiale locali e la dettatura.","descriptionLong":"Scrivi una bozza di email che riassuma un articolo, evidenziando i dettagli tecnici principali, oppure crea modelli riutilizzabili per gestire pi\xf9 velocemente la tua casella di posta. Lascia che l\'intelligenza artificiale e la dettatura locali si occupino della lettura e della scrittura, garantendo al contempo la massima privacy."},"powerpointBuilder":{"description":"Trasforma appunti, documenti e fogli di calcolo in una presentazione PowerPoint completa utilizzando flussi di lavoro basati sull\'intelligenza artificiale, in modo automatico.","descriptionLong":"Analizza un documento Excel per individuare le perdite principali, quindi lascia che l\'intelligenza artificiale trasformi appunti e dati in una presentazione professionale. Crea presentazioni pi\xf9 velocemente, senza dover navigare tra i menu o partire da una pagina vuota.","title":"Flussi di lavoro basati sull\'intelligenza artificiale che trasformano appunti e documenti in una presentazione PowerPoint completa | AI Powerpoint Builder"},"socialDictation":{"description":"Pubblica e rispondi su LinkedIn, Slack e Discord usando la dettatura vocale, senza bisogno di digitare.","descriptionLong":"Scrivi bozze di post, invia risposte e rimani attivo su LinkedIn, Slack e Discord usando solo la voce. Mantieni viva la conversazione senza dover ricorrere alla tastiera.","title":"Sintesi vocale per LinkedIn, Slack e Discord | Pubblica e rispondi senza digitare"},"developerTools":{"title":"Comandi vocali e automazioni basate sull\'IA per sviluppatori | Scrivi commenti, documentazione e messaggi di commit","description":"Scrivi commenti, documenti e messaggi di commit utilizzando comandi vocali e automazioni basate sull\'intelligenza artificiale, senza usare le mani.","descriptionLong":"Chiedi come rendere pi\xf9 ordinato il codice in una cartella di progetto, poi detta commenti, documentazione e messaggi di commit senza digitare. Mantieni il flusso di lavoro mentre i comandi vocali e le automazioni basate sull\'intelligenza artificiale si occupano delle attivit\xe0 ripetitive."},"terminalAgent":{"title":"Agente desktop basato sull\'IA | Esegui build e test da terminale in background mentre continui a programmare","description":"Esegui build, test e debug in background con un agente desktop basato sull\'intelligenza artificiale, mentre tu continui a programmare.","descriptionLong":"Fai in modo che il tuo agente esamini la cartella di progetto, la compili, verifichi che la compilazione vada a buon fine ed esegua i casi di test. Se qualcosa non funziona, analizza la cronologia di Git per individuarne la causa e suggerisce una soluzione, il tutto mentre tu rimani concentrato sul tuo lavoro."},"gamingFPS":{"description":"Mira, spara, ricarica e cambia arma nei giochi FPS come Valorant usando i comandi vocali, senza usare le mani.","descriptionLong":"Dai comandi vocali per sparare, ricaricare e cambiare arma mentre giochi a titoli FPS come Valorant. Aggiungi il controllo vocale alla tua configurazione e mantieni l\'azione senza dover usare ogni tasto e pulsante.","title":"Comandi vocali per FPS, Valorant e altri giochi | Mira, spara, ricarica e cambia arma a mani libere"},"gamingRPG":{"title":"Personalizza i comandi di gioco RPG per Minecraft | Comandi adattivi per videogiochi","description":"Personalizza e adatta i comandi di gioco di Minecraft e di altri giochi di ruolo in base al tuo stile di gioco.","descriptionLong":"Configura i comandi adattivi per Minecraft e altri giochi di ruolo, mappando le azioni in base alle tue esigenze. Crea uno schema di controllo che si adatti al tuo stile di gioco, invece di costringere le tue mani ad adattarsi al gioco."},"educationTools":{"description":"Trasforma appunti e articoli in strumenti di studio e materiali didattici grazie all\'intelligenza artificiale integrata nel dispositivo, senza usare le mani.","descriptionLong":"Prendi un articolo e crea un documento Word con domande di riflessione adatte al livello scolastico dello studente, per supportare un compito di scrittura creativa. Lascia che l\'intelligenza artificiale integrata nel dispositivo trasformi il tuo materiale di partenza in risorse didattiche pronte all\'uso, mantenendo al contempo la tua privacy.","title":"Trasforma appunti e articoli scolastici in strumenti di studio creativi o materiali didattici utilizzando l\'intelligenza artificiale integrata nel dispositivo."},"meetingNotes":{"title":"Automazioni basate sull\'intelligenza artificiale che trasformano gli appunti delle riunioni in file di dimensioni ridotte.","description":"Trasforma gli appunti delle riunioni in file organizzati e utilizzabili grazie all\'automazione tramite intelligenza artificiale, senza alcun intervento manuale.","descriptionLong":"Rileggi gli appunti della riunione per individuare cosa resta da fare, chi \xe8 responsabile e dove ci sono delle lacune. Lascia che l\'intelligenza artificiale elabori questi elementi in file separati e li organizzi in una cartella, cos\xec potrai rivederli in seguito."},"fileManagement":{"description":"Organizza i download, trova i file e pulisci il tuo PC con un agente desktop basato sull\'intelligenza artificiale, il tutto senza usare le mani.","descriptionLong":"Chiedi al tuo agente di copiare i file scaricati nella cartella della documentazione del prodotto, oppure di trovare i file e riordinare il tuo PC. Mantieni il tuo computer organizzato grazie all\'intelligenza artificiale integrata che protegge i tuoi dati.","title":"Agente desktop basato sull\'intelligenza artificiale | Organizza i tuoi download, trova i file e pulisci il tuo PC"},"dictationWriting":{"title":"Digitazione e creazione di documenti a mani libere: dettatura vocale, generazione tramite IA e riscrittura su qualsiasi app.","description":"Scrivi, genera e riscrivi documenti a mani libere utilizzando la dettatura vocale e l\'intelligenza artificiale in qualsiasi app.","descriptionLong":"Detta testi, genera nuovi contenuti e riscrivi ci\xf2 che hai scritto in qualsiasi app usando solo la tua voce. Crea documenti dall\'inizio alla fine senza toccare la tastiera."},"headMouseControl":{"title":"Controllo del computer a mani libere con mouse a testa, comando vocale | Controlli adattivi del computer","description":"Controlla il tuo computer a mani libere grazie al tracciamento del movimento della testa e ai comandi adattivi Talk to Tap.","descriptionLong":"Sposta il cursore con il tracciamento della testa e fai clic usando Talk to Tap per navigare nel computer completamente a mani libere. Configura i controlli adattivi che ti consentono di lavorare nel modo che preferisci."},"documentTranslation":{"title":"Traduzione automatica di documenti tramite IA per chiunque lavori in diverse lingue: spagnolo, arabo, portoghese e molte altre.","description":"Traduci documenti in diverse lingue, come spagnolo, arabo e portoghese, utilizzando l\'intelligenza artificiale, senza dover intervenire manualmente.","descriptionLong":"Traduci i tuoi documenti in spagnolo, arabo, portoghese e altre lingue grazie all\'intelligenza artificiale integrata nel dispositivo. Lavora con sicurezza in diverse lingue senza dover cambiare strumento o copiare il testo tra le app."},"websiteRedesign":{"description":"Analizza i concorrenti e ricevi suggerimenti per riprogettare un sito web utilizzando l\'intelligenza artificiale, in modo completamente automatico.","descriptionLong":"Punta l\'intelligenza artificiale sul sito web di SafeDrive Auto Insurance e falla analizzare i siti dei concorrenti per individuare le differenze. Ottieni suggerimenti concreti per modernizzare un sito obsoleto, basati su reali ricerche di mercato.","title":"Ricerca web privata basata sull\'intelligenza artificiale e automazioni | Esplora, analizza e crea codice HTML"},"dataPrivacyResearch":{"description":"Ricerca le pi\xf9 recenti leggi sulla privacy dei dati e trasforma i risultati in attivit\xe0 di follow-up per la conformit\xe0, in modo automatico.","descriptionLong":"Ricerca le leggi pi\xf9 recenti sulla privacy dei dati del 2026 e le differenze rispetto a quelle del 2025, quindi individua gli aspetti che le aziende devono implementare. Fai redigere all\'intelligenza artificiale un\'e-mail di follow-up con esempi per aiutarti a rispettare le normative.","title":"Esplora, analizza e riassumi i dati senza che questi lascino il tuo dispositivo | Ricerca web privata basata sull\'intelligenza artificiale"}},"control":{"title":"Controllare.","subtitle":"Il tuo software. I tuoi input. Le tue regole.","description":"Comandi vocali, scorciatoie da tastiera e pulsanti di azione rapida: funzionano con tutte le app del tuo dispositivo. Non serve il mouse. Non \xe8 necessario alcuno script. Non \xe8 richiesta alcuna configurazione per le centinaia di app che gi\xe0 utilizzi.","titleAlt":"Controllare"},"create":{"title":"Creare.","subtitle":"Le tue parole. Le tue bozze. La tua macchina.","description":"Scrivi, riscrivi, riformatta e traduci, direttamente all\'interno dell\'app che stai utilizzando. Niente cloud. Niente copia-incolla in un altro strumento. Niente bozze per addestrare il modello di qualcun altro.","titleAlt":"Creare"},"automate":{"title":"Automatizzare.","subtitle":"Una frase. Ogni passaggio. Fatto.","description":"Descrivi un\'attivit\xe0 in parole semplici e Cephable la eseguir\xe0. Nelle tue app, nei tuoi file, persino nella riga di comando. Funziona mentre fai altro, senza che nulla esca dal tuo computer.","titleAlt":"Automatizzare"},"upgrade":{"subtitle":{"trial":"Per i prossimi {{giorni}} giorni, le mie funzionalit\xe0 di intelligenza artificiale saranno sbloccate: Crea e Automatizza, entrambe in esecuzione su un unico modello sul dispositivo. Attivale quando sei pronto.","orgGeneric":"La tua organizzazione ha sbloccato le mie funzionalit\xe0 di intelligenza artificiale: Crea e Automatizza, entrambe in esecuzione su un unico dispositivo. Attivale quando sei pronto.","org":"Sei stato aggiunto all\'organizzazione {{organization}}, il che sblocca le mie funzionalit\xe0 di intelligenza artificiale: Crea e Automatizza, entrambe in esecuzione su un unico modello sul dispositivo. Attivale quando sei pronto."},"badge":{"trial":"Il processo termina in","trialDays_one":"{{count}} giorno","trialDays_other":"{{count}} giorni","org":"Sbloccato da","orgGeneric":"Licenza dell\'organizzazione"},"setup":{"eyebrow":"Configura le tue funzionalit\xe0 Pro","title":"Scegli cosa attivare","description":"Potrai modificare queste impostazioni in seguito nella sezione Impostazioni. Tutto viene eseguito sul dispositivo: i tuoi testi e i tuoi file rimarranno sempre con te."},"enable":{"title":"Abilita le funzionalit\xe0 di intelligenza artificiale","description":"Un singolo interruttore attiva sia la funzione Crea che la funzione Automatizza. Entrambe funzionano con un modello condiviso sullo stesso dispositivo, senza necessit\xe0 di configurazioni separate.","model":{"label":"Modello di intelligenza artificiale sul dispositivo","tag":"Motore condiviso","description":"Consente sia di creare che di automatizzare. I modelli pi\xf9 grandi producono risultati migliori ma utilizzano pi\xf9 risorse: il programma viene scaricato ed eseguito interamente su questo dispositivo."}},"create":{"title":"Creare","description":"Generazione e dettatura di testo intelligenti. Rediger\xf2 email, documenti, codice e contenuti creativi, trasformando il tuo parlato in testo formattato per qualsiasi applicazione.","locked":"Abilita le funzionalit\xe0 di intelligenza artificiale qui sopra e Create sar\xe0 pronto all\'uso."},"automate":{"title":"Automatizzare","description":"Flussi di lavoro basati sull\'intelligenza artificiale. Descrivi un\'attivit\xe0 in una sola frase e io pianificher\xf2 ed eseguir\xf2 ogni singolo passaggio: legger\xf2, scriver\xf2 ed eseguir\xf2 comandi per tuo conto.","locked":"Abilita le funzionalit\xe0 di intelligenza artificiale qui sopra e Automate sar\xe0 pronto all\'uso."},"status":{"on":"SU","off":"Non funzioner\xe0"},"footer":"Tutto viene eseguito sul dispositivo. Nulla di ci\xf2 che crei o automatizzi esce dalla tua macchina.","cta":{"eyebrow":"\xc8 possibile attivare l\'IA in qualsiasi momento","title":"Vediamo come funziona nelle tue app","action":"Guardatemi in azione","back":"Indietro"},"pill":"{{licenza}} Sbloccato","title":"La tua licenza \xe8 stata aggiornata a {{license}}."}}');


var $a02703834f50dafc$exports = {};
$a02703834f50dafc$exports = JSON.parse('{"logo":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30ED\u30B4","add":"\u8FFD\u52A0","all":"\u5168\u3066","edit":"\u7DE8\u96C6","create":"\u4F5C\u6210\u3059\u308B","delete":"\u6D88\u53BB","previous":"\u524D\u306E","next":"\u6B21","search":"\u691C\u7D22","loading":"\u8AAD\u307F\u8FBC\u307F\u4E2D...","reload":"\u30EA\u30ED\u30FC\u30C9","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","copy":"\u30B3\u30D4\u30FC","save":"\u4FDD\u5B58","saveAndFinish":"\u4FDD\u5B58\u3057\u3066\u7D42\u4E86","saveAndContinue":"\u4FDD\u5B58\u3057\u3066\u7D9A\u884C","saved":"\u4FDD\u5B58\u3057\u307E\u3057\u305F","saveError":"\u5909\u66F4\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","done":"\u7D42\u308F\u308A","back":"\u623B\u308B","play":"\u904A\u3076","pause":"\u4E00\u6642\u505C\u6B62","success":"\u6210\u529F","continue":"\u7D9A\u304F","options":"\u30AA\u30D7\u30B7\u30E7\u30F3","share":"\u5171\u6709","finish":"\u4ED5\u4E0A\u3052\u308B","description":"\u8AAC\u660E","expand":"\u62E1\u5927\u3059\u308B","expandMenu":"\u30E1\u30CB\u30E5\u30FC\u3092\u5C55\u958B","finishEdit":"\u7DE8\u96C6\u7D42\u4E86","advancedOptions":"\u8A73\u7D30\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8868\u793A","authenticating":"\u8A8D\u8A3C\u4E2D...","skipToMain":"\u30E1\u30A4\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4\u3078\u30B9\u30AD\u30C3\u30D7","skip":"\u30B9\u30AD\u30C3\u30D7","close":"\u8FD1\u3044","notFound":"\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093","notFoundDescription":"\u3042\u3042\u3001\u5927\u5909\uFF01\u6D77\u4E2D\u3092\u63A2\u3057\u305F\u306E\u3067\u3059\u304C\u3001\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\uFF01","exitSetup":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3092\u7D42\u4E86","experimental":"\u5B9F\u9A13\u7684","letGetStarted":"\u3055\u3042\u59CB\u3081\u307E\u3057\u3087\u3046\uFF01","exploreInputControls":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u308B","when":"\u79C1\u304C...","thenMacro":"Cephable \u306F\u5B9F\u884C\u3055\u308C\u307E\u3059...","controls":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","welcome":"\u3044\u3089\u3063\u3057\u3083\u3044\u307E\u305B\u3002","beta":"\u30D9\u30FC\u30BF","macroEmpty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30DE\u30AF\u30ED\u306F\u3042\u308A\u307E\u305B\u3093\u3002","you":"\u3042\u306A\u305F","step":"\u30B9\u30C6\u30C3\u30D7","steps":"\u624B\u9806","learnMore":"\u3082\u3063\u3068\u8A73\u3057\u304F\u77E5\u308B","dangerZone":"\u5371\u967A\u5730\u5E2F","connected":"\u63A5\u7D9A","notConnected":"\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093","connectAndLearn":"\u3064\u306A\u304C\u308B\uFF06\u5B66\u3076","tryAgain":"\u3082\u3046\u4E00\u5EA6\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044","by":"\u6295\u7A3F\u8005: {{value}}","noName":"- \u540D\u524D\u306A\u3057 -","details":"\u8A73\u7D30","controlFeed":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30D5\u30A3\u30FC\u30C9","upgrade":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","purchase":"\u8CFC\u5165","results":"\u7D50\u679C","created":"\u4F5C\u6210\u65E5: {{value}}","updated":"\u66F4\u65B0: {{value}}","deleted":"\u524A\u9664\u6E08\u307F: {{value}}","expires":"\u6709\u52B9\u671F\u9650: {{value}}","expired":"\u671F\u9650\u5207\u308C: {{value}}","used":"\u4F7F\u7528\u6E08\u307F: {{value}}","mobileApp":{"title":"\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA"},"dashboard":{"title":"\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9"},"invalidNumber":"\u8A72\u5F53\u306A\u3057","wifi":{"disconnected":"Wi-Fi\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002","connected":"Wi-Fi\u304C\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002","description":"Cephable \u304C\u304A\u4F7F\u3044\u306E\u63A5\u7D9A\u304A\u3088\u3073\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3068\u9023\u643A\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u306B\u306F\u3001Wi-Fi \u306B\u63A5\u7D9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u73FE\u5728\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4F7F\u7528\u306B\u5236\u9650\u304C\u751F\u3058\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"signalR":{"disconnected":"\u540C\u671F\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002","action":"\u518D\u63A5\u7D9A","description":"Cephable \u306E\u540C\u671F\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u8A2D\u5B9A\u306E\u4FDD\u5B58\u3084\u4ED6\u306E\u63A5\u7D9A\u3068\u306E\u901A\u4FE1\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3059\u3002","disconnectedDevice":"{{name}} \u3068\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3002","disconnectedDeviceDescription":"\u8A8D\u8A3C\u307E\u305F\u306F\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u306E\u3044\u305A\u308C\u304B\u304C\u539F\u56E0\u3067\u3001\u540C\u671F\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u30EA\u30E2\u30FC\u30C8\u3067\u30C7\u30FC\u30BF\u3092\u9001\u53D7\u4FE1\u3067\u304D\u307E\u305B\u3093\u3002\u63A5\u7D9A\u306E\u4E21\u5074\u3092\u78BA\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","connected":"\u540C\u671F\u304C\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F\u3002","connectedDescription":"Cephable \u306F\u6B63\u5E38\u306B\u540C\u671F\u3057\u3066\u304A\u308A\u3001\u671F\u5F85\u3069\u304A\u308A\u306B\u63A5\u7D9A\u304A\u3088\u3073\u62E1\u5F35\u6A5F\u80FD\u3068\u901A\u4FE1\u3059\u308B\u306F\u305A\u3067\u3059\u3002","swap":"\u30ED\u30FC\u30AB\u30EB\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A\u306B\u5207\u308A\u66FF\u3048\u308B","unlinkedDevice":"\u63A5\u7D9A\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","unlinkedDeviceDescription":"\u3053\u306E\u63A5\u7D9A\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u30EA\u30F3\u30AF\u89E3\u9664\u3055\u308C\u307E\u3057\u305F\u3002","featureRestricted":"\u30EA\u30E2\u30FC\u30C8\u63A5\u7D9A\u3067\u306F\u3001\u4F5C\u6210\u304A\u3088\u3073\u81EA\u52D5\u5316\u6A5F\u80FD\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002","featureRestrictedDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u73FE\u5728\u3001\u30EA\u30E2\u30FC\u30C8\u63A5\u7D9A\u3067\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u4F5C\u696D\u306E\u4F5C\u6210\u3068\u81EA\u52D5\u5316\u306B\u5FC5\u8981\u306A\u3059\u3079\u3066\u306E\u6A5F\u80FD\u3092\u5229\u7528\u3059\u308B\u306B\u306F\u3001\u30ED\u30FC\u30AB\u30EB\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044\u3002"},"billing":{"title":"\u8ACB\u6C42\u3059\u308B","expires":"\u6B21\u56DE\u306E\u8ACB\u6C42: {{value}}","description":"\u7D44\u7E54\u306E\u8ACB\u6C42\u3001\u30B7\u30FC\u30C8\u3001\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3001\u66F4\u65B0\u3001\u307E\u305F\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","error":"\u8ACB\u6C42\u3092\u7BA1\u7406\u3059\u308B\u306B\u306F\u3001\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","view":"\u8ACB\u6C42\u306E\u7BA1\u7406","isEmployeeAccess":{"title":"\u30D7\u30ED","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB","short":"\u30D7\u30ED","description":"Cephable Professional \u306F\u3001\u30ED\u30FC\u30AB\u30EB\u306E\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8 AI \u3092\u751F\u6210\u6A5F\u80FD\u306B\u62E1\u5F35\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u751F\u7523\u6027\u3092\u3055\u3089\u306B\u9AD8\u3081\u307E\u3059\u3002","supportedFeatures":{"tag":"\u30D7\u30E9\u30B9\u306E\u3059\u3079\u3066\u3001\u30D7\u30E9\u30B9","features":["\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC","\u4F01\u696D\u7D44\u7E54\u7BA1\u7406","\u4F01\u696D\u5236\u9650","\u30C7\u30D0\u30A4\u30B9\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6570\u306F\u7121\u5236\u9650\u3067\u3059\u3002","\u7121\u5236\u9650\u306E\u4E8B\u524D\u5B66\u7FD2\u6E08\u307F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"]}},"isDeveloperAccess":{"title":"\u958B\u767A\u30AD\u30C3\u30C8","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB SDK","short":"SDK","description":"Cephable SDK \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u97F3\u58F0\u3001\u9854\u3001\u982D\u306A\u3069\u306E\u5F37\u529B\u306A\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u7D71\u5408\u3067\u304D\u3001\u6700\u5C0F\u9650\u306E\u624B\u9593\u3067\u6700\u5927\u9650\u306E\u52B9\u679C\u304C\u5F97\u3089\u308C\u307E\u3059\u3002","supportedFeatures":{"tag":"\u30D7\u30E9\u30B9\u306E\u3059\u3079\u3066\u3001\u30D7\u30E9\u30B9","features":["Windows\u3068MacOS\u306E\u30B5\u30DD\u30FC\u30C8","\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u306E\u97F3\u58F0\u3001\u9854\u3001\u982D\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u5165\u529B\u306E\u305F\u3081\u306E\u8EFD\u91CF\u3067\u57CB\u3081\u8FBC\u307F\u53EF\u80FD\u306A SDK","\u30AB\u30B9\u30BF\u30E0\u51FA\u529B\u30A2\u30AF\u30B7\u30E7\u30F3\u306E API/Webhook \u30B5\u30DD\u30FC\u30C8","\u958B\u767A\u8005\u5411\u3051\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8","\u30B5\u30F3\u30D7\u30EB\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","\u30B3\u30DE\u30F3\u30C9\u3092\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u81EA\u52D5\u5316\u3068\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u306B\u5909\u63DB\u3059\u308B","\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3001\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u306A\u3069\u3092\u7BA1\u7406\u3059\u308B\u305F\u3081\u306E\u958B\u767A\u8005\u30DD\u30FC\u30BF\u30EB"]}},"isStudentAccess":{"title":"\u5B66\u751F","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u6559\u80B2","short":"\u6559\u80B2","description":"Cephable Education\u306F\u3001\u500B\u5225\u5B66\u7FD2\u3068\u30A4\u30F3\u30AF\u30EB\u30FC\u30B7\u30D6\u306A\u6388\u696D\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002Cephable\u306F\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u3082\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u52D5\u4F5C\u3057\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u3068\u306E\u9023\u643A\u306F\u4E0D\u8981\u3067\u3059\u3002","supportedFeatures":{"tag":"\u30D7\u30E9\u30B9\u306E\u3059\u3079\u3066\u3001\u30D7\u30E9\u30B9","features":["\u30C7\u30D0\u30A4\u30B9\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6570\u306F\u7121\u5236\u9650","\u7121\u5236\u9650\u306E\u4E8B\u524D\u5B66\u7FD2\u6E08\u307F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","\u30AB\u30B9\u30BF\u30E0\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u7121\u5236\u9650\u306E\u5171\u6709"]}},"isResellerAccess":{"title":"\u30EA\u30BB\u30E9\u30FC","titleLong":"Cephable \u518D\u8CA9\u696D\u8005","description":"Cephable Reseller \u306F\u3001\u65B0\u3057\u3044\u7D44\u7E54\u3092\u4F5C\u6210\u3057\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u6709\u6599\u30E9\u30A4\u30BB\u30F3\u30B9\u3067\u3059\u3002\u3053\u308C\u306B\u306F\u3001\u72EC\u81EA\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30B9\u30A4\u30FC\u30C8\u3067 Cephable \u3092\u4F7F\u7528\u3057\u3001\u30E6\u30FC\u30B6\u30FC \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5411\u4E0A\u3055\u305B\u308B\u3053\u3068\u304C\u542B\u307E\u308C\u307E\u3059\u3002","short":"\u30EA\u30BB\u30E9\u30FC"},"viewProducts":"\u88FD\u54C1\u3092\u898B\u308B","included":"{{licenseType}} \u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002","upgrade":{"description":"\u4ECA\u3059\u3050\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u307E\u3057\u3087\u3046\u3002","action":"\u4ECA\u3059\u3050\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","error":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","requiredDetail":"\u3053\u306E\u6A5F\u80FD\u306B\u306F{{licenseType}}\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u304B\u3089\u3044\u3064\u3067\u3082\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u307E\u305F\u306F\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002","enableTextGeneration":"AI\u3068\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u751F\u6210\u3057\u307E\u3059\u3002","longDescription":"\u6709\u6599\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001Cephable \u306E\u3059\u3079\u3066\u306E\u6A5F\u80FD\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u8907\u6570\u306E\u30C7\u30D0\u30A4\u30B9\u3001\u9AD8\u5EA6\u306A\u5236\u5FA1\u3001\u30AB\u30B9\u30BF\u30E0\u7D71\u5408\u306A\u3069\u3001Cephable \u306B\u306F\u751F\u7523\u6027\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u3082\u306E\u304C\u3059\u3079\u3066\u63C3\u3063\u3066\u3044\u307E\u3059\u3002","compare":"\u30D7\u30E9\u30F3\u3092\u6BD4\u8F03\u3059\u308B","enableAiDictation":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","description":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001AI\u306B\u3088\u308B\u9AD8\u5EA6\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u304C\u5229\u7528\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002\u53E5\u8AAD\u70B9\u306E\u8FFD\u52A0\u3001\u5927\u6587\u5B57\u306E\u4FEE\u6B63\u3001\u305D\u3057\u3066\u3042\u306A\u305F\u306E\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u308F\u305B\u305F\u8ABF\u6574\u304C\u3067\u304D\u308B\u306E\u3067\u3001\u4F59\u5206\u306A\u624B\u9593\u3092\u304B\u3051\u305A\u306B\u6D17\u7DF4\u3055\u308C\u305F\u6587\u7AE0\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"enableAiWorkflows":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6D3B\u7528\u3057\u3066\u3001\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u304A\u3088\u3073\u30D6\u30E9\u30A6\u30B6\u306E\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3057\u307E\u3057\u3087\u3046\u3002"},"isPlusAccess":{"title":"\u30D7\u30E9\u30B9","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D7\u30E9\u30B9","short":"\u30D7\u30E9\u30B9","description":"Cephable Plus \u306F\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3001\u6570\u767E\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u3092\u6D3B\u7528\u3057\u3066\u3001\u3088\u308A\u591A\u304F\u306E\u3053\u3068\u3092\u884C\u3044\u305F\u3044\u30D1\u30EF\u30FC\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u3067\u3059\u3002","supportedFeatures":{"tag":"\u30D9\u30FC\u30B7\u30C3\u30AF\u306E\u3059\u3079\u3066\u306B\u52A0\u3048\u3066","features":["\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\uFF08\u81EA\u7136\u8A00\u8A9E\uFF09","\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u8A8D\u8B58\uFF08AI\u5F37\u5316\u7248\uFF09","\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\uFF08\u751F\u6210\u3001\u7FFB\u8A33\u3001\u66F8\u304D\u63DB\u3048\uFF09","\u6570\u767E\u7A2E\u985E\u306E\u4E8B\u524D\u5B66\u7FD2\u6E08\u307F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"]}},"personal":{"short":"\u57FA\u672C","title":"\u57FA\u672C","titleLong":"\u30BB\u30D5\u30A1\u30D6\u30EB \u30D9\u30FC\u30B7\u30C3\u30AF","description":"Cephable Basic\u306F\u6C38\u4E45\u7121\u6599\u3067\u3001\u3088\u308A\u901F\u304F\u52D5\u304D\u3001\u81EA\u5206\u3089\u3057\u3055\u3092\u8868\u73FE\u3057\u3001\u81EA\u5206\u3089\u3057\u3044\u65B9\u6CD5\u3067\u7269\u4E8B\u3092\u6210\u3057\u9042\u3052\u3089\u308C\u308B\u3088\u3046\u8A2D\u8A08\u3055\u308C\u3066\u3044\u307E\u3059\u3002Basic\u306B\u542B\u307E\u308C\u308B\u6A5F\u80FD\u306F\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002","upgrade":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u3078","description":"Plus\u307E\u305F\u306FPro\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u3001\u3059\u3079\u3066\u306E\u6A5F\u80FD\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\u3088\u308A\u9AD8\u7CBE\u5EA6\u306B\u3002\u3088\u308A\u591A\u304F\u306E\u63A5\u7D9A\u3002\u3088\u308A\u591A\u304F\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3002\u751F\u7523\u6027\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u308B\u30D1\u30EF\u30FC\u3002","featureHeading":"\u79C1\u304C\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u3053\u3068\u306F\u4EE5\u4E0B\u306E\u901A\u308A\u3067\u3059:","control":"\u97F3\u58F0\u3084\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u30A2\u30D7\u30EA\u3084\u30C4\u30FC\u30EB\u3092\u7D20\u65E9\u304F\u5207\u308A\u66FF\u3048\u307E\u3059\u3002\u9014\u5207\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30DC\u30A4\u30B9\u306A\u3089\u3001\u30C1\u30E3\u30C3\u30C8\u3067\u7C21\u5358\u306B\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002","create":"\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u3001\u66F8\u304D\u76F4\u3057\u3001\u53E3\u8FF0\u3001\u751F\u6210\u3001\u7FFB\u8A33\u3092\u884C\u3044\u307E\u3059\u3002\u30B3\u30D4\u30FC\u3001\u8CBC\u308A\u4ED8\u3051\u3001\u753B\u9762\u306E\u5207\u308A\u66FF\u3048\u306F\u5FC5\u8981\u3042\u308A\u307E\u305B\u3093\u3002","automate":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u30B9\u30D4\u30FC\u30C9\u30A2\u30C3\u30D7\u3059\u308B\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30BF\u30B9\u30AF\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u30B7\u30F3\u30D7\u30EB\u306A\u30B3\u30DE\u30F3\u30C9\u304B\u3089\u8907\u96D1\u306A\u30DE\u30AF\u30ED\u307E\u3067\u3001\u9762\u5012\u306A\u4F5C\u696D\u306F\u79C1\u304C\u5F15\u304D\u53D7\u3051\u307E\u3059\u306E\u3067\u3001\u304A\u5BA2\u69D8\u306F\u91CD\u8981\u306A\u4F5C\u696D\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002","local":"\u3059\u3079\u3066\u30ED\u30FC\u30AB\u30EBAI\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E0D\u8981\u3002"}},"mostPopular":"\u6700\u3082\u4EBA\u6C17\u306E\u3042\u308B","subscription":{"options":"\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u30AA\u30D7\u30B7\u30E7\u30F3","monthly":"\u6708\u6255\u3044","billedMonthly":"/\u6708","yearly":"\u5E74\u6255\u3044","billedYearly":"/\u5E74"}},"organization":{"title":"\u7D44\u7E54","titlePlural":"\u7D44\u7E54","titleLong":"\u7D44\u7E54\u5411\u3051Cephable\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB","description":"\u7D44\u7E54\u3068\u306F\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u5171\u540C\u4F5C\u696D\u3057\u305F\u308A\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u5171\u6709\u3057\u305F\u308A\u3067\u304D\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u30B0\u30EB\u30FC\u30D7\u3067\u3059\u3002\u3053\u3053\u3067\u306F\u3001\u30C1\u30FC\u30E0\u3001\u30C1\u30FC\u30E0 \u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3001\u8ACB\u6C42\u306A\u3069\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","viewOrganization":"\u7D44\u7E54\u3092\u8868\u793A","orgName":"\u7D44\u7E54\u540D","orgCustomBillingUrl":{"title":"\u30AB\u30B9\u30BF\u30E0\u8ACB\u6C42 URL","description":"\u3053\u308C\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u3092\uFF08\u518D\u8CA9\u696D\u8005\u306E\uFF09\u8AB2\u91D1\u30B7\u30B9\u30C6\u30E0\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u308B\u30AB\u30B9\u30BF\u30E0 URL \u3067\u3059\u3002\u300Chttps://\u300D\u307E\u305F\u306F\u300CmailTo:\u300D\u3067\u59CB\u307E\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"},"create":"\u65B0\u3057\u3044\u7D44\u7E54\u3092\u4F5C\u6210\u3059\u308B","managed":{"title":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54","titleShort":"\u7BA1\u7406","titlePlural":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54","description":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54\u306F\u3001Cephable \u30EA\u30BB\u30E9\u30FC\u306B\u3088\u3063\u3066\u7BA1\u7406\u3055\u308C\u308B\u7D44\u7E54\u3067\u3059\u3002\u30EA\u30BB\u30E9\u30FC\u306F\u3053\u3053\u3067\u30C1\u30FC\u30E0\u3001\u30C1\u30FC\u30E0 \u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3001\u8ACB\u6C42\u306A\u3069\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","error":"\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","empty":{"title":"\u7BA1\u7406\u5BFE\u8C61\u306E\u7D44\u7E54\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","description":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u7BA1\u7406\u5BFE\u8C61\u7D44\u7E54\u304C\u5B58\u5728\u3057\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u307E\u305F\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u304C\u307E\u3060\u30A2\u30AF\u30C6\u30A3\u30D6\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"}},"settings":{"title":"\u7D44\u7E54\u8A2D\u5B9A","description":"\u7D44\u7E54\u306E\u8ACB\u6C42\u3001\u540D\u524D\u3001\u8AAC\u660E\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","view":"\u8868\u793A\u8A2D\u5B9A","general":{"title":"\u4E00\u822C\u7684\u306A"},"resources":{"edit":"\u30EA\u30BD\u30FC\u30B9\u3092\u7DE8\u96C6","description":"\u5DE6\u5074\u306E Markdown \u30A8\u30C7\u30A3\u30BF\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3001\u7D44\u7E54\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u5F79\u7ACB\u3064\u30EA\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u304A\u3088\u3073\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059\u3002\u5165\u529B\u3059\u308B\u3068\u3001\u53F3\u5074\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u304C\u30E6\u30FC\u30B6\u30FC\u306B\u3069\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u308B\u304B\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002Markdown \u69CB\u6587\u3092\u4F7F\u7528\u3057\u3066\u3001\u898B\u51FA\u3057\u3001\u30EA\u30B9\u30C8\u3001\u30EA\u30F3\u30AF\u3001\u305D\u306E\u4ED6\u306E\u66F8\u5F0F\u8A2D\u5B9A\u8981\u7D20\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002\u5909\u66F4\u306F\u4FDD\u5B58\u3059\u308B\u3068\u30E1\u30F3\u30D0\u30FC\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"other":{"title":"\u305D\u306E\u4ED6\u306E\u8A2D\u5B9A","description":"\u7D44\u7E54\u306E\u8ACB\u6C42\u3001\u540D\u524D\u3001\u8AAC\u660E\u3001\u30EA\u30BD\u30FC\u30B9\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002"},"managed":{"title":"Cephable\u306B\u3088\u3063\u3066\u7BA1\u7406\u3055\u308C\u3066\u3044\u307E\u3059","description":"\u3053\u308C\u3089\u306E\u8A2D\u5B9A\u306F\u3001Cephable\u306B\u3088\u3063\u3066\u304A\u5BA2\u69D8\u306E\u7D44\u7E54\u5411\u3051\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u306E\u306F\u3001\u73FE\u5728\u306E\u5024\u3092\u78BA\u8A8D\u3059\u308B\u305F\u3081\u3067\u3042\u308A\u3001\u30DD\u30FC\u30BF\u30EB\u304B\u3089\u5909\u66F4\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","email":{"title":"Cephable\u306E\u30E1\u30FC\u30EB\u914D\u4FE1","allowedDescription":"Cephable\u306F\u3001\u62DB\u5F85\u72B6\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u30E1\u30FC\u30EB\u306A\u3069\u3001\u3053\u306E\u7D44\u7E54\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","blockedDescription":"Cephable\u306F\u3053\u306E\u7D44\u7E54\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u305B\u3093\u3002\u62DB\u5F85\u72B6\u3001\u8A8D\u8A3C\u30E1\u30FC\u30EB\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u30E1\u30FC\u30EB\u3001\u30DE\u30B8\u30C3\u30AF\u30EA\u30F3\u30AF\u3001\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0\u30E1\u30FC\u30EB\u3001\u88FD\u54C1\u95A2\u9023\u30E1\u30FC\u30EB\u306F\u3059\u3079\u3066\u9001\u4FE1\u3055\u308C\u307E\u305B\u3093\u3002"},"scim":{"title":"\u81EA\u52D5\u30E1\u30F3\u30D0\u30FC\u30D7\u30ED\u30D3\u30B8\u30E7\u30CB\u30F3\u30B0\uFF08SCIM\uFF09","description":"\u3053\u306E\u7D44\u7E54\u306E\u30E1\u30F3\u30D0\u30FC\u306E\u4F5C\u6210\u3068\u524A\u9664\u306F\u3001\u3054\u5229\u7528\u306EID\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u304C\u884C\u3044\u307E\u3059\u3002\u30DD\u30FC\u30BF\u30EB\u304B\u3089\u62DB\u5F85\u72B6\u3092\u9001\u4FE1\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"},"lockedNote":"\u3053\u308C\u3089\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3067\u304D\u308B\u306E\u306FCephable\u306E\u307F\u3067\u3059\u3002\u5024\u3092\u66F4\u65B0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u306F\u3001Cephable\u306E\u62C5\u5F53\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"}},"menu":{"title":"\u7D44\u7E54\u30E1\u30CB\u30E5\u30FC","view":"\u8868\u793A\u30E1\u30CB\u30E5\u30FC","expand":"\u30E1\u30CB\u30E5\u30FC\u3092\u5C55\u958B"},"update":"\u7D44\u7E54\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA\u3092\u66F4\u65B0\u3057\u3066\u3044\u307E\u3059\u3002","noAccess":{"title":"\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u6700\u8FD1\u6A29\u9650\u304C\u5909\u66F4\u3055\u308C\u305F\u305F\u3081\u3001\u3053\u306E\u6A5F\u80FD\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002\u30A8\u30E9\u30FC\u3060\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"noOrg":{"title":"\u95A2\u9023\u3059\u308B\u30E9\u30A4\u30BB\u30F3\u30B9\u306F\u3042\u308A\u307E\u305B\u3093\u3002","description":"\u73FE\u5728\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u307E\u305F\u306F\u958B\u767A\u8005\u30B0\u30EB\u30FC\u30D7\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3053\u306E\u30DD\u30FC\u30BF\u30EB\u306F\u3001\u6709\u6599\u306ECephable\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u304A\u6301\u3061\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u307F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002Cephable\u306E\u6F5C\u5728\u80FD\u529B\u3092\u6700\u5927\u9650\u306B\u5F15\u304D\u51FA\u3059\u306B\u306F\u3001\u30EA\u30B9\u30AF\u30D5\u30EA\u30FC\u306E\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002"},"error":"\u7D44\u7E54\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","member":{"title":"\u30E1\u30F3\u30D0\u30FC","titlePlural":"\u30E1\u30F3\u30D0\u30FC","orgTitle":"{{value}} \u30E1\u30F3\u30D0\u30FC","me":"\u79C1\u306E\u4F1A\u54E1\u8CC7\u683C","aboutMe":"\u79C1\u306B\u3064\u3044\u3066","description":"\u30E1\u30F3\u30D0\u30FC\u3068\u306F\u3001\u7D44\u7E54\u306B\u6240\u5C5E\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u3067\u3059\u3002\u30E1\u30F3\u30D0\u30FC\u306B\u306F\u3055\u307E\u3056\u307E\u306A\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u3001\u7D44\u7E54\u306E\u3055\u307E\u3056\u307E\u306A\u90E8\u5206\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","edit":"\u30E1\u30F3\u30D0\u30FC\u3092\u7DE8\u96C6","removed":"\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","removedDescription":"\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002\u7D44\u7E54\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3057\u305F\u3002\u30A8\u30E9\u30FC\u3060\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002","updated":"\u6210\u529F\u3057\u307E\u3057\u305F\u3002{{value}} \u306E\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","error":"{{value}} \u306E\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u306E\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","delete":"\u6210\u529F\u3057\u307E\u3057\u305F\u3002{{value}} \u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","deleteError":"{{value}} \u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","loadError":"\u7D44\u7E54\u30E1\u30F3\u30D0\u30FC\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","deleteConfirmation":{"title":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","description":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u305D\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7D44\u7E54\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u5F8C\u304B\u3089\u3044\u3064\u3067\u3082\u518D\u5EA6\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u307E\u3059"},"viewAll":{"title":"\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A","description":"\u7D44\u7E54\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A\u3057\u3001\u305D\u306E\u5F79\u5272\u3068\u6A29\u9650\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002"},"seats":{"title":"\u4F1A\u54E1\u5E2D","description":"\u7D44\u7E54\u5185\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u304C\u30B7\u30FC\u30C8\u3068\u3057\u3066\u30AB\u30A6\u30F3\u30C8\u3055\u308C\u307E\u3059\u3002\u30E1\u30F3\u30D0\u30FC\u304C\u6301\u3064\u6A29\u9650\u306E\u7A2E\u985E\u306F\u3001\u7D44\u7E54\u7BA1\u7406\u8005\u304C\u5909\u66F4\u3067\u304D\u307E\u3059\u3002","stats":"{{value}} \u5E2D\u4E2D","max":"\u6700\u5927\u5EA7\u5E2D\u6570","maxSeatValue":"\u6700\u5927\u5EA7\u5E2D\u6570: {{value}}","current":"\u73FE\u5728\u306E\u5EA7\u5E2D","limit":{"title":"\u5EA7\u5E2D\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F","description":"\u73FE\u5728\u306E\u30D7\u30E9\u30F3\u306E\u5229\u7528\u53EF\u80FD\u306A\u5EA7\u5E2D\u6570\u306E\u4E0A\u9650\u3067\u3042\u308B {{ maxSeats }} \u306B\u9054\u3057\u307E\u3057\u305F\u3002\u8FFD\u52A0\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u30D7\u30E9\u30F3\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u304B\u3001\u5EA7\u5E2D\u306E\u5272\u308A\u5F53\u3066\u3092\u7BA1\u7406\u3059\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002"},"updateLimit":{"title":"\u30D7\u30E9\u30F3\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u5EA7\u5E2D\u6570\u3092\u5897\u3084\u3059","description":"\u73FE\u5728\u306E\u30D7\u30E9\u30F3\u306F\u6700\u5927\u30B7\u30FC\u30C8\u6570\u306B\u9054\u3057\u307E\u3057\u305F: {{ maxSeats }}\u3002\u4ECA\u3059\u3050\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u8FFD\u52A0\u30B7\u30FC\u30C8\u306E\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3057\u3001\u30C1\u30FC\u30E0\u304C\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u6210\u9577\u3057\u7D9A\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u30D7\u30E9\u30F3"}},"emailExists":"\u7D44\u7E54\u5185\u306B\u65E2\u306B\u96FB\u5B50\u30E1\u30FC\u30EB\u304C\u5B58\u5728\u3057\u307E\u3059\u3002\u5225\u306E\u96FB\u5B50\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"invite":{"title":"\u62DB\u5F85\u3059\u308B","titlePlural":"\u62DB\u5F85","orgTitle":"{{ value }} \u62DB\u5F85","description":"\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306E\u62DB\u5F85\u72B6\u304C\u30E6\u30FC\u30B6\u30FC\u306B\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u3088\u3046\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3001\u3055\u307E\u3056\u307E\u306A\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","edit":"\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0\u3059\u308B","view":"\u3059\u3079\u3066\u306E\u62DB\u5F85\u3092\u8868\u793A","viewDescription":"\u73FE\u5728\u627F\u8A8D\u3055\u308C\u3066\u3044\u306A\u3044\u3059\u3079\u3066\u306E\u62DB\u5F85\u3092\u8868\u793A\u3057\u307E\u3059\u3002","new":"\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3059\u308B","emailRequired":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u5FC5\u9808\u3067\u3059","emailInvalid":"\u96FB\u5B50\u30E1\u30FC\u30EB\u304C\u7121\u52B9\u3067\u3059\u3002\u6709\u52B9\u306A\u96FB\u5B50\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emailExists":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u306F\u65E2\u306B\u7D44\u7E54\u3078\u306E\u62DB\u5F85\u72B6\u304C\u3042\u308A\u307E\u3059\u3002\u5225\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emailPlaceholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","expiration":"\u671F\u9650\u5207\u308C","delete":"\u62DB\u5F85\u3092\u524A\u9664","confirm":"\u3053\u306E\u62DB\u5F85\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u306E\u62DB\u5F85\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u7D44\u7E54\u306B\u53C2\u52A0\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u5F8C\u304B\u3089\u3044\u3064\u3067\u3082\u518D\u5EA6\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002","accept":"\u62DB\u5F85\u3092\u627F\u8AFE","stat":"\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u62DB\u5F85","error":"\u62DB\u5F85\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","noInvites":{"title":"\u62DB\u5F85\u306F\u3042\u308A\u307E\u305B\u3093\u3002","description":"\u3042\u306A\u305F\u306E\u7D44\u7E54\u306B\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u62DB\u5F85\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002"},"acceptSuccess":{"title":"\u30C1\u30FC\u30E0\u3078\u3088\u3046\u3053\u305D\u3002","description":"\u7D44\u7E54\u3078\u306E\u53C2\u52A0\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","action":"\u65B0\u3057\u3044\u7D44\u7E54\u3092\u8868\u793A\u3059\u308B"},"acceptError":{"title":"\u304A\u3063\u3068\u3002\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u3088\u3046\u3067\u3059\u3002","description":"\u7D44\u7E54\u3078\u306E\u53C2\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306B\u623B\u308B"},"send":{"title":"\u62DB\u5F85\u3092\u9001\u4FE1","success":"{{value}} \u3078\u306E\u62DB\u5F85\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002","error":"{{value}} \u3078\u306E\u62DB\u5F85\u306E\u9001\u4FE1\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"editDescription":"\u30E6\u30FC\u30B6\u30FC\u304C\u7D44\u7E54\u306B\u53C2\u52A0\u3059\u308B\u305F\u3081\u306E\u65B0\u3057\u3044\u62DB\u5F85\u72B6\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","scimManaged":{"title":"\u30E1\u30F3\u30D0\u30FC\u306FID\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3067\u7BA1\u7406\u3055\u308C\u307E\u3059","description":"\u3053\u306E\u7D44\u7E54\u306F\u81EA\u52D5\u30D7\u30ED\u30D3\u30B8\u30E7\u30CB\u30F3\u30B0\uFF08SCIM\uFF09\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u30E1\u30F3\u30D0\u30FC\u30B7\u30C3\u30D7\u306F\u7D44\u7E54\u5185\u306EID\u30B7\u30B9\u30C6\u30E0\u306B\u3088\u3063\u3066\u7BA1\u7406\u3055\u308C\u307E\u3059\u3002\u305D\u3053\u3067\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0\u307E\u305F\u306F\u524A\u9664\u3059\u308B\u3068\u3001\u5909\u66F4\u306F\u81EA\u52D5\u7684\u306BCephable\u306B\u540C\u671F\u3055\u308C\u307E\u3059\u3002\u30DD\u30FC\u30BF\u30EB\u304B\u3089\u62DB\u5F85\u72B6\u3092\u9001\u4FE1\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"}},"role":{"title":"\u5F79\u5272","titlePlural":"\u5F79\u5272","description":"\u5F79\u5272\u3068\u306F\u3001\u7D44\u7E54\u5185\u3067\u30E6\u30FC\u30B6\u30FC\u304C\u6301\u3064\u3053\u3068\u304C\u3067\u304D\u308B\u3055\u307E\u3056\u307E\u306A\u30A2\u30AF\u30BB\u30B9 \u30EC\u30D9\u30EB\u3067\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u306B\u3055\u307E\u3056\u307E\u306A\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u5B9F\u884C\u3067\u304D\u308B\u64CD\u4F5C\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002"},"isAdmin":{"title":"\u7BA1\u7406\u8005","description":"\u7BA1\u7406\u8005\u306F\u7D44\u7E54\u3078\u306E\u5B8C\u5168\u306A\u30A2\u30AF\u30BB\u30B9\u6A29\u3092\u6301\u3061\u3001\u7D44\u7E54\u306E\u3042\u3089\u3086\u308B\u5074\u9762\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","conflict":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7BA1\u7406\u8005\u3067\u3059\u3002\u5F79\u5272\u3092\u7DE8\u96C6\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002"},"canViewMembers":{"title":"\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u8868\u793A\u3067\u304D\u307E\u3059\u3002"},"canInviteMembers":{"title":"\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306B\u65B0\u3057\u3044\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3057\u305F\u308A\u3001\u65E2\u5B58\u306E\u62DB\u5F85\u3092\u7BA1\u7406\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"canChangeMemberPermissions":{"title":"\u30E1\u30F3\u30D0\u30FC\u306E\u5F79\u5272\u3092\u5909\u66F4\u3059\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u5185\u306E\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u306E\u5F79\u5272\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002"},"canRemoveMembers":{"title":"\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664","titleSingle":"\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664","action":"\u53D6\u308A\u9664\u304F","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u304B\u3089\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3067\u304D\u307E\u3059\u3002","confirm":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u7D44\u7E54\u304B\u3089\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u305D\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7D44\u7E54\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u5F8C\u304B\u3089\u3044\u3064\u3067\u3082\u518D\u5EA6\u62DB\u5F85\u3067\u304D\u307E\u3059\u3002"},"canCreateAuthClients":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3059\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306B\u5BFE\u3057\u3066\u65B0\u3057\u3044\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"canManageBilling":{"title":"\u8ACB\u6C42\u306E\u7BA1\u7406","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u8AB2\u91D1\u8A2D\u5B9A\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","error":"\u3053\u306E\u7D44\u7E54\u306E\u8ACB\u6C42\u3092\u7BA1\u7406\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002"},"canManageChildOrganizations":{"title":"\u5B50\u7D44\u7E54\u306E\u7BA1\u7406","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7BA1\u7406\u8005\u3068\u3057\u3066\u5B50\u7D44\u7E54\u3092\u4F5C\u6210\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002"},"canViewAnalytics":{"title":"\u5206\u6790\u3092\u8868\u793A","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u6307\u6A19\u3068\u5206\u6790\u3092\u8868\u793A\u3067\u304D\u307E\u3059\u3002"},"metrics":{"title":"\u30E1\u30C8\u30EA\u30AF\u30B9","description":"\u30E1\u30C8\u30EA\u30C3\u30AF\u306F\u3001\u7D44\u7E54\u304C Cephable \u3092\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3057\u3066\u3044\u308B\u304B\u3092\u7406\u89E3\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3064\u30C7\u30FC\u30BF \u30DD\u30A4\u30F3\u30C8\u3067\u3059\u3002","view":"\u6307\u6A19\u3092\u8868\u793A","orgTitle":"{{ value }} \u30E1\u30C8\u30EA\u30C3\u30AF","lineChart":{"title":"\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570","description":"\u3053\u306E\u30B0\u30E9\u30D5\u306B\u306F\u3001\u7D44\u7E54\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C7\u30FC\u30BF\u306E\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570\u304C\u6642\u9593\u306E\u7D4C\u904E\u3068\u3068\u3082\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002","max":"\u6700\u5927\u63A5\u7D9A\u6570: {{maxConnections}}","project":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u5408\u8A08","org":"\u7D44\u7E54\u5408\u8A08"},"manage":{"title":"\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u30E1\u30C8\u30EA\u30C3\u30AF","description":"\u30E2\u30C7\u30EB\u63A8\u8AD6\u4E2D\u306B\u53CE\u96C6\u3055\u308C\u305F\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9 \u30E1\u30C8\u30EA\u30C3\u30AF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u307E\u305F\u306F\u30AF\u30EA\u30A2\u3057\u307E\u3059\u3002"},"download":{"button":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30E1\u30C8\u30EA\u30AF\u30B9","success":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9 \u30D5\u30A9\u30EB\u30C0\u30FC\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","noFile":"\u30E1\u30C8\u30EA\u30AF\u30B9\u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u307E\u305A\u306F\u30E2\u30C7\u30EB\u3092\u5B9F\u884C\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"clear":{"button":"\u660E\u78BA\u306A\u6307\u6A19","success":"\u30E1\u30C8\u30EA\u30C3\u30AF\u304C\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u30AF\u30EA\u30A2\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","confirm":{"title":"\u660E\u78BA\u306A\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9\u6307\u6A19","description":"\u8A18\u9332\u3055\u308C\u305F\u3059\u3079\u3066\u306E\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9 \u30E1\u30C8\u30EA\u30C3\u30AF\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","confirm":"\u660E\u78BA\u306A\u6307\u6A19"}}},"projects":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u5B89\u5168\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u7BA1\u7406\u3057\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u69CB\u6210\u3057\u3001\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u9593\u3067\u30A2\u30D7\u30EA\u304C\u30B3\u30DE\u30F3\u30C9\u3092\u9001\u53D7\u4FE1\u3059\u308B\u65B9\u6CD5\u3092\u52B9\u7387\u5316\u3057\u307E\u3059\u3002","name":"\u30A2\u30D7\u30EA\u540D","view":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u898B\u308B","error":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","orgTitle":"{{ value }} \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","stats":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u7D71\u8A08","connections":"\u5408\u8A08\u63A5\u7D9A\u6570","all":{"title":"\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6307\u6A19","description":"{{ orgName }} \u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u308B\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u96C6\u8A08\u30E1\u30C8\u30EA\u30C3\u30AF"},"card":"{{value}} \u500B\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u3046\u3061","users":"{{date}} \u4EE5\u964D\u306E\u5408\u8A08\u30E6\u30FC\u30B6\u30FC\u6570","avgUsers":"\u6708\u9593\u5E73\u5747\u30E6\u30FC\u30B6\u30FC\u6570\u3002","concurrent":{"title":"\u904E\u53BB {{days}} \u65E5\u9593\u306E\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570","label":"\u5E73\u5747\u540C\u6642\u63A5\u7D9A\u6570","max":"\u6700\u5927\u63A5\u7D9A\u6570","overage":"\u8D85\u904E\u6599\u91D1","description":"\u540C\u6642\u63A5\u7D9A\u3068\u306F\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u540C\u6642\u306B\u63A5\u7D9A\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u6570\u3067\u3059\u3002\u3053\u306E\u6307\u6A19\u306F\u3001\u540C\u6642\u306B\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u6570\u3092\u628A\u63E1\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002"}},"projectType":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30BF\u30A4\u30D7","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30BF\u30A4\u30D7\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u5206\u985E\u3057\u3001\u9069\u5207\u306A SDK \u3092\u9078\u629E\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"},"accessDenied":{"generic":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u6A29\u304C\u3042\u308A\u307E\u305B\u3093\u3002","title":"\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u8868\u793A\u3001\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u524A\u9664\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30A2\u30AF\u30BB\u30B9\u6A29\u306B\u3064\u3044\u3066\u306F\u7BA1\u7406\u8005\u306B\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002"},"upgrade":{"title":"Cephable SDK \u3078\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","description":"Cephable \u306F\u3001SDK \u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u3001\u30B2\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u306B\u76F4\u63A5\u7D71\u5408\u3067\u304D\u307E\u3059\u3002\u73FE\u5728\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u304A\u5BA2\u69D8\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u9593\u9055\u3044\u304C\u3042\u308B\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001support@cephable.com \u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","shortDescription":"\u73FE\u5728\u3001\u3042\u306A\u305F\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"limit":{"title":"\u3082\u3063\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u6B32\u3057\u3044\u3067\u3059\u304B?","error":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u5236\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u3002","description":"\u7D44\u7E54\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6570\u306E\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u3002\u7BA1\u7406\u8005\u306B\u9023\u7D61\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"create":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210","titleLong":"\u59CB\u3081\u307E\u3057\u3087\u3046\u3002","first":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002","description":"\u307E\u3060\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3057\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u3068\u30C7\u30D0\u30A4\u30B9\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u5F53\u793E\u306E\u30B5\u30FC\u30D3\u30B9\u9593\u306E\u901A\u4FE1\u3092\u5B89\u5168\u306B\u3059\u308B\u305F\u3081\u306B\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u97F3\u58F0\u3068\u30D8\u30C3\u30C9 \u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30A2\u30D7\u30EA\u306B\u8FC5\u901F\u304B\u3064\u5B89\u5168\u306B\u7D71\u5408\u3067\u304D\u307E\u3059\u3002"},"details":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8A73\u7D30","description":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u8A8D\u8A3C\u3001\u30C7\u30D0\u30A4\u30B9\u6A5F\u80FD\u3001SDK \u7D71\u5408\u3092\u7BA1\u7406\u3059\u308B\u306B\u306F\u3001\u65B0\u3057\u3044\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u624B\u9806\u306B\u5F93\u3063\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u306B\u5B89\u5168\u3067\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002"}},"sdk":{"title":"SDK\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","description":"\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7C21\u5358\u306B\u3059\u308B\u305F\u3081\u306B\u958B\u767A\u3055\u308C\u305F\u5F37\u529B\u306A SDK \u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","select":{"title":"SDK\u3092\u9078\u629E","description":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u4F7F\u7528\u3059\u308B SDK \u3092\u9078\u629E\u3057\u307E\u3059\u3002\u5F53\u793E\u306E SDK \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u9593\u3067\u9069\u5FDC\u578B\u97F3\u58F0\u304A\u3088\u3073\u30D8\u30C3\u30C9 \u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u7D71\u5408\u3067\u304D\u307E\u3059\u3002"}},"clients":{"title":"\u8A8D\u53EF\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8","configure":"\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u8A2D\u5B9A","description":"\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3078\u306E\u5B89\u5168\u306A\u30A2\u30AF\u30BB\u30B9\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3092\u5B9A\u7FA9\u3057\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u3092\u8A8D\u8A3C\u3057\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u306E\u3084\u308A\u53D6\u308A\u3092\u5236\u5FA1\u3057\u307E\u3059\u3002","settings":"\u8A8D\u8A3C\u8A2D\u5B9A","create":"\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u4F5C\u6210","max":"\u6700\u5927\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6570: {{value}}"},"secret":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8","created":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u306F 1 \u56DE\u3060\u3051\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u4ECA\u3059\u3050\u30B3\u30D4\u30FC\u3057\u3066\u3001\u5B89\u5168\u306A\u5834\u6240\u306B\u4FDD\u7BA1\u3057\u3066\u304F\u3060\u3055\u3044\u3002<br><br>\u3054\u81EA\u8EAB\u306E\u958B\u767A\u306B\u306E\u307F\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u30B5\u30FC\u30D3\u30B9\u3084\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","copy":"\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u3092\u30B3\u30D4\u30FC","rotate":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u306E\u30ED\u30FC\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u8B66\u544A: \u3053\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u3088\u308A\u3001\u65E2\u5B58\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u304C\u53D6\u308A\u6D88\u3055\u308C\u3001\u65B0\u3057\u3044\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA\u5168\u4F53\u3067\u65E2\u5B58\u306E\u4F7F\u7528\u72B6\u6CC1\u3092\u3059\u3079\u3066\u66F4\u65B0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","error":"\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u306E\u30ED\u30FC\u30C6\u30FC\u30B7\u30E7\u30F3\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"}},"key":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30AD\u30FC","view":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30AD\u30FC\u3092\u8868\u793A","copy":"\u30AD\u30FC\u3092\u30B3\u30D4\u30FC","delete":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30AD\u30FC\u306E\u524A\u9664","description":"\u8B66\u544A: \u3053\u306E\u64CD\u4F5C\u306B\u3088\u308A\u3001\u65E2\u5B58\u306E\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u3068\u95A2\u9023\u3059\u308B\u3059\u3079\u3066\u306E\u8A2D\u5B9A\u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u64CD\u4F5C\u3092\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","error":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 \u30AD\u30FC\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","success":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002"}},"tokenRedirect":{"title":"\u30C8\u30FC\u30AF\u30F3\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL","description":"\u30C8\u30FC\u30AF\u30F3 \u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL \u306F\u3001\u8A8D\u8A3C\u304C\u5B8C\u4E86\u3057\u305F\u5F8C\u306B\u30A2\u30AF\u30BB\u30B9 \u30C8\u30FC\u30AF\u30F3\u304C\u9001\u4FE1\u3055\u308C\u308B\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3067\u3059\u3002\u3053\u308C\u3089\u306E URL \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306F\u30E6\u30FC\u30B6\u30FC \u30C7\u30FC\u30BF\u3084\u30B5\u30FC\u30D3\u30B9\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u30C8\u30FC\u30AF\u30F3\u3092\u5B89\u5168\u306B\u53D7\u4FE1\u3067\u304D\u307E\u3059\u3002"},"authRedirect":{"title":"\u8A8D\u8A3C\u30B3\u30FC\u30C9\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL","description":"AuthCode \u30EA\u30C0\u30A4\u30EC\u30AF\u30C8 URL \u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u6A29\u9650\u3092\u4ED8\u4E0E\u3057\u305F\u5F8C\u306B\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u308B\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3067\u3059\u3002\u3053\u306E URL \u306F\u3001OAuth \u30D5\u30ED\u30FC\u306B\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u8A8D\u8A3C\u30B5\u30FC\u30D0\u30FC\u304B\u3089\u30A2\u30D7\u30EA\u3078\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u5B89\u5168\u306A\u9001\u4FE1\u3092\u4FDD\u8A3C\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u4EE3\u308F\u3063\u3066\u30A2\u30AF\u30BB\u30B9 \u30C8\u30FC\u30AF\u30F3\u3092\u8981\u6C42\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u305F\u3081\u3067\u3059\u3002"},"originHost":{"title":"\u5143\u306E\u30DB\u30B9\u30C8","description":"API \u306E\u3084\u308A\u53D6\u308A\u4E2D\u306B\u30EA\u30AF\u30A8\u30B9\u30C8\u3068\u30C7\u30FC\u30BF\u306E\u4E3B\u306A\u30BD\u30FC\u30B9\u3068\u3057\u3066\u6A5F\u80FD\u3059\u308B URL\u3002"},"scopes":{"title":"\u30B9\u30B3\u30FC\u30D7","configure":"\u30B9\u30B3\u30FC\u30D7\u3092\u5B9A\u7FA9\u3059\u308B","titleLong":"API \u6A29\u9650\u30B9\u30B3\u30FC\u30D7","manage":"\u627F\u8A8D\u30B9\u30B3\u30FC\u30D7\u306E\u7BA1\u7406","description":"\u30B9\u30B3\u30FC\u30D7\u306F\u3001\u3053\u306E\u627F\u8A8D\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u304C\u6301\u3064\u6A29\u9650\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002\u30B9\u30B3\u30FC\u30D7\u3092\u8A2D\u5B9A\u3057\u3066\u7279\u5B9A\u306E\u30C7\u30FC\u30BF\u3068\u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u5236\u9650\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u5FC5\u8981\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u307F\u3092\u53D6\u5F97\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002"},"type":{"title":"\u5B9F\u88C5\u30BF\u30A4\u30D7"},"deviceScopes":{"title":"\u95A2\u9023\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","titles":"\u95A2\u9023\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","titleLong":"\u8A31\u53EF\u3055\u308C\u308B\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","configure":"\u8A31\u53EF\u3055\u308C\u308B\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E\u3092\u8A2D\u5B9A\u3059\u308B","descriptionShort":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u30C7\u30D0\u30A4\u30B9\u306E\u30BF\u30A4\u30D7\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002","description":"\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u5185\u3067\u30C7\u30D0\u30A4\u30B9\u304C\u6301\u3064\u6A29\u9650\u3068\u30A2\u30AF\u30BB\u30B9 \u30EC\u30D9\u30EB\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002\u7279\u5B9A\u306E\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u3067\u3001\u5404\u30C7\u30D0\u30A4\u30B9\u304C\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u30A2\u30AF\u30B7\u30E7\u30F3\u3068\u30C7\u30FC\u30BF\u3092\u5236\u5FA1\u3067\u304D\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u7DAD\u6301\u3057\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC \u30DD\u30EA\u30B7\u30FC\u306B\u6E96\u62E0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","action":"\u65B0\u3057\u3044\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u8FFD\u52A0"},"deviceType":{"title":"\u30C7\u30D0\u30A4\u30B9\u306E\u7A2E\u985E","description":"DeviceType \u306F\u3001\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30C6\u30B4\u30EA\u3092\u5B9A\u7FA9\u3057\u3001\u305D\u306E\u5165\u51FA\u529B\u6A5F\u80FD\u3068\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u308B\u6A5F\u80FD (\u97F3\u58F0\u3001\u30B8\u30A7\u30B9\u30C1\u30E3\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u306E\u7A2E\u985E\u306A\u3069) \u3092\u8A73\u7D30\u306B\u8AAC\u660E\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u627F\u8A8D\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9\u306E\u307F\u304C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u5BFE\u8A71\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","action":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u306E\u4F5C\u6210","name":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u540D","descriptionLong":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u306E\u8AAC\u660E","id":"\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7ID","features":{"title":"\u30B5\u30DD\u30FC\u30C8\u6A5F\u80FD","description":"\u30A2\u30D7\u30EA\u304C\u30B5\u30DD\u30FC\u30C8\u3059\u308B\u5165\u529B\u3068\u51FA\u529B\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable \u5168\u4F53\u306E\u30E6\u30FC\u30B6\u30FC \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u6700\u9069\u5316\u3067\u304D\u307E\u3059\u3002","supportsVoiceInput":"\u97F3\u58F0\u5165\u529B","supportsPhysicalInput":"\u7269\u7406\u7684\u5165\u529B","supportsKeyboardOutput":"\u30AD\u30FC\u30DC\u30FC\u30C9\u51FA\u529B","supportsPlayStationControllerOutput":"\u30D7\u30EC\u30A4\u30B9\u30C6\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","supportsFaceInput":"\u9854\u5165\u529B","supportsGestureInput":"\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u5165\u529B","supportsXboxControllerOutput":"Xbox \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","supportsDigitalExtensions":"\u30C7\u30B8\u30BF\u30EB\u62E1\u5F35\u6A5F\u80FD","supportsPhysicalExtensions":"\u7269\u7406\u7684\u306A\u62E1\u5F35","supportsNintendoControllerOutput":"\u4EFB\u5929\u5802\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","supportsGenericControllerOutput":"\u6C4E\u7528\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u51FA\u529B"},"canAutoStart":{"title":"\u81EA\u52D5\u5236\u5FA1\u30B9\u30BF\u30FC\u30C8\u3092\u30B5\u30DD\u30FC\u30C8","description":"[canAutoStart] \u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001SDK \u306F\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u78BA\u8A8D\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u30ED\u30B0\u30A4\u30F3\u5F8C\u306B\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30DE\u30A4\u30AF\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3059\u3050\u306B\u958B\u59CB\u3057\u3088\u3046\u3068\u3057\u307E\u3059\u3002"},"isSupported":{"title":"\u30A2\u30AF\u30C6\u30A3\u30D6","description":"[isSupported] \u7121\u52B9\u306B\u3059\u308B\u3068\u3001Cephable \u306F\u3053\u308C\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u30C7\u30D0\u30A4\u30B9\u3092\u9001\u4FE1\u3001\u53D7\u4FE1\u3001\u307E\u305F\u306F\u78BA\u8A8D\u3057\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u975E\u63A8\u5968\u306B\u76F8\u5F53\u3057\u307E\u3059\u3002"},"locale":{"title":"\u30C7\u30D5\u30A9\u30EB\u30C8\u8A00\u8A9E","description":"[defaultLocale] \u3053\u306E\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30ED\u30B1\u30FC\u30EB\u3002\u3053\u308C\u306F\u30C7\u30D0\u30A4\u30B9\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u8A00\u8A9E\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","support":"\u30B5\u30DD\u30FC\u30C8\u8A00\u8A9E","warn":"** \u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u95A2\u9023\u3059\u308B\u8A00\u8A9E\u306E\u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u66F4\u65B0\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002**","name":"{{lang}} - \u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u540D","langDescription":"{{lang}} - \u8AAC\u660E"},"customControls":{"title":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","object":"{{lang}} - \u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8","description":"\u30AB\u30B9\u30BF\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u624B\u52D5\u3067\u8A2D\u5B9A\u304A\u3088\u3073\u7DE8\u96C6\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u9AD8\u5EA6\u306A\u30AA\u30D7\u30B7\u30E7\u30F3\u3067\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u304C Cephable \u304B\u3089\u76F4\u63A5\u30C7\u30D0\u30A4\u30B9\u3092\u5236\u5FA1\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u306B\u306F\u3001\u3053\u3053\u3067\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u767B\u9332\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001Cephable API \u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002","addControl":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B","empty":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u307E\u3060\u4F5C\u6210\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u300C\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0\u300D\u3092\u4F7F\u7528\u3057\u3066\u3001\u6700\u521D\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","untitled":"\u7121\u984C\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","controlId":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EBID","controlIdHelp":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E00\u610F\u306E\u8B58\u5225\u5B50\u3067\u3059\u3002\u4FDD\u5B58\u3059\u308B\u524D\u306B\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4FDD\u5B58\u5F8C\u306F\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002","fallback":"\u5F8C\u9000\u3059\u308B","controlName":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D","controlDescription":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAC\u660E","defaultCommandsLabel":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9","defaultCommandsHelp":"\u3053\u308C\u3089\u306F\u3001\u73FE\u5728\u306E\u8A00\u8A9E\u3067\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u969B\u306B\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u308B\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u97F3\u58F0\u30C8\u30EA\u30AC\u30FC\u3067\u3059\u3002","sharedAcrossLanguages":"\u3059\u3079\u3066\u306E\u8A00\u8A9E\u3067\u5171\u6709","sharedAcrossLanguagesHelp":"\u3053\u308C\u3089\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u7DE8\u96C6\u3059\u308B\u3068\u3001\u3059\u3079\u3066\u306E\u8A00\u8A9E\u306E\u5024\u304C\u4E00\u5EA6\u306B\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002","iconUrl":"\u30A2\u30A4\u30B3\u30F3URL","contextGroupName":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30B0\u30EB\u30FC\u30D7","isProfileControl":"\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","isPrefixVoiceCommand":"\u30D7\u30EC\u30D5\u30A3\u30C3\u30AF\u30B9\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9","allowWhenDictating":"\u97F3\u58F0\u5165\u529B\u6642\u306B\u8A31\u53EF\u3059\u308B","allowsHold":"\u30DB\u30FC\u30EB\u30C9\u3092\u8A31\u53EF\u3059\u308B","isDeprecated":"\u975E\u63A8\u5968","requiresEmployeeAccess":"\u5F93\u696D\u54E1\u30A2\u30AF\u30BB\u30B9\u304C\u5FC5\u8981\u3067\u3059","requiresStudentAccess":"\u5B66\u751F\u30A2\u30AF\u30BB\u30B9\u304C\u5FC5\u8981\u3067\u3059","requiresGenericLicense":"\u6C4E\u7528\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059","requiresPlusAccess":"Plus\u30A2\u30AF\u30BB\u30B9\u304C\u5FC5\u8981\u3067\u3059","allIncomplete":"\u3059\u3079\u3066\u306E\u5730\u57DF\u8A2D\u5B9A\u3067\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u672A\u5B8C\u6210\u3067\u3059\u3002\u4FDD\u5B58\u3059\u308B\u524D\u306B\u3001\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u5730\u57DF\u8A2D\u5B9A\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002","savedWithIncomplete":"\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002\u4E0D\u5B8C\u5168\u306A\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30ED\u30B1\u30FC\u30EB\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F: {{incompleteLocales}}"},"success":{"title":"\u6210\u529F\uFF01","description":"\u65B0\u3057\u3044\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002{{name}} \u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u30C7\u30D0\u30A4\u30B9 \u30B9\u30B3\u30FC\u30D7\u3092\u66F4\u65B0\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002"},"throttleRules":{"title":"\u30B3\u30DE\u30F3\u30C9\u30B9\u30ED\u30C3\u30C8\u30EB\u30EB\u30FC\u30EB","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9 \u30BF\u30A4\u30D7\u306E\u30B3\u30DE\u30F3\u30C9 \u30D5\u30ED\u30FC\u3068\u5165\u529B\u5236\u9650\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306E\u30B9\u30ED\u30C3\u30C8\u30EB \u30EB\u30FC\u30EB\u3092\u69CB\u6210\u3057\u307E\u3059\u3002","disableVoiceInput":"\u97F3\u58F0\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","disableHotkeyInput":"\u30DB\u30C3\u30C8\u30AD\u30FC\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","disableCameraInput":"\u30AB\u30E1\u30E9\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","disableMultiInputs":"\u8907\u6570\u5165\u529B\u3092\u7121\u52B9\u306B\u3059\u308B","maximumCommandsPerSecond":"1\u79D2\u3042\u305F\u308A\u306E\u6700\u5927\u30B3\u30DE\u30F3\u30C9\u6570","maximumCommandsPerMinute":"1\u5206\u3042\u305F\u308A\u306E\u6700\u5927\u30B3\u30DE\u30F3\u30C9\u6570","maximumMacroLength":"\u6700\u5927\u30DE\u30AF\u30ED\u9577","jitter":{"title":"\u30BF\u30A4\u30DF\u30F3\u30B0\u30B8\u30C3\u30BF\u30FC","description":"\u30DB\u30FC\u30EB\u30C9\u6642\u9593\u3068\u30DD\u30FC\u30BA\u6642\u9593\u306B\u30E9\u30F3\u30C0\u30E0\u306A\u5909\u5316\u3092\u52A0\u3048\u308B\u3053\u3068\u3067\u3001\u3088\u308A\u81EA\u7136\u306A\u5165\u529B\u30D1\u30BF\u30FC\u30F3\u3092\u4F5C\u308A\u51FA\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","holdTimeJitterMin":"\u30DB\u30FC\u30EB\u30C9\u30BF\u30A4\u30E0\u30B8\u30C3\u30BF\u30FC\u6700\u5C0F\u5024\uFF08ms\uFF09","holdTimeJitterMax":"\u30DB\u30FC\u30EB\u30C9\u30BF\u30A4\u30E0\u30B8\u30C3\u30BF\u30FC\u6700\u5927\u5024\uFF08ms\uFF09","pauseTimeJitterMin":"\u4E00\u6642\u505C\u6B62\u6642\u9593\u30B8\u30C3\u30BF\u30FC\uFF08\u5206\uFF09\uFF08\u30DF\u30EA\u79D2\uFF09","pauseTimeJitterMax":"\u4E00\u6642\u505C\u6B62\u6642\u9593\u30B8\u30C3\u30BF\u30FC\u6700\u5927\u5024\uFF08ms\uFF09"},"incompatibleActions":{"title":"\u76F8\u5BB9\u308C\u306A\u3044\u884C\u52D5\u30B0\u30EB\u30FC\u30D7","description":"\u540C\u3058\u30DE\u30AF\u30ED\u5185\u3067\u5171\u5B58\u3067\u304D\u306A\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u30B0\u30EB\u30FC\u30D7\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002","addGroup":"\u30B0\u30EB\u30FC\u30D7\u3092\u8FFD\u52A0","removeGroup":"\u30B0\u30EB\u30FC\u30D7\u3092\u524A\u9664","addAction":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0","removeAction":"\u524A\u9664\u30A2\u30AF\u30B7\u30E7\u30F3","reason":"\u7406\u7531","reasonPlaceholder":"\u3053\u308C\u3089\u306E\u884C\u52D5\u304C\u4E21\u7ACB\u3057\u306A\u3044\u7406\u7531","eventType":"\u30A4\u30D9\u30F3\u30C8\u30BF\u30A4\u30D7","key":"\u9375","customActionId":"\u30AB\u30B9\u30BF\u30E0\u30A2\u30AF\u30B7\u30E7\u30F3ID","emptyGroup":"\u3053\u306E\u30B0\u30EB\u30FC\u30D7\u306B\u306F\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u5C11\u306A\u304F\u3068\u30822\u3064\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"requiredPause":{"title":"\u52D5\u4F5C\u9593\u306E\u5FC5\u8981\u306A\u9593\u9694","description":"\u540C\u3058\u30DE\u30AF\u30ED\u5185\u3067\u3001\u52D5\u4F5C\u9593\u306B\u6700\u4F4E\u9650\u306E\u9593\u9694\u304C\u5FC5\u8981\u306A\u52D5\u4F5C\u306E\u30DA\u30A2\u3092\u5B9A\u7FA9\u3057\u307E\u3059\u3002","addRule":"\u30EB\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B","removeRule":"\u30EB\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B","actionA":"\u30A2\u30AF\u30B7\u30E7\u30F3A","actionB":"\u30A2\u30AF\u30B7\u30E7\u30F3B","minimumPause":"\u6700\u5C0F\u4E00\u6642\u505C\u6B62\u6642\u9593\uFF08\u30DF\u30EA\u79D2\uFF09","bidirectional":"\u53CC\u65B9\u5411","bidirectionalHelp":"\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u4E21\u65B9\u5411\uFF08A\u2192B\u3068B\u2192A\uFF09\u3067\u4E00\u6642\u505C\u6B62\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059\u3002"},"macroStepRules":{"title":"\u30DE\u30AF\u30ED\u30B9\u30C6\u30C3\u30D7\u30EB\u30FC\u30EB","holdTimeJitterMin":"\u30DB\u30FC\u30EB\u30C9\u30B8\u30C3\u30BF\u30FC\u6700\u5C0F\u5024\uFF08ms\uFF09","holdTimeJitterMax":"\u30DB\u30FC\u30EB\u30C9\u30B8\u30C3\u30BF\u30FC\u6700\u5927\u5024\uFF08ms\uFF09"}}}},"new":{"details":"\u7D44\u7E54\u306E\u8A73\u7D30","name":{"label":"\u7D44\u7E54\u540D","placeholder":"\u7D44\u7E54\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"description":{"label":"\u7D44\u7E54\u306E\u8AAC\u660E","placeholder":"Cephable Professional \u3092\u4F7F\u7528\u3059\u308B\u76EE\u7684\u306F\u4F55\u3067\u3059\u304B?"}},"expired":{"user":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002\u66F4\u65B0\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","admin":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002Cephable Basic\u3092\u8D85\u3048\u308B\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","multiple":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002Cephable Basic\u3092\u8D85\u3048\u308B\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","dialog":{"title":"\u7D44\u7E54\u3092\u9078\u629E","description":"\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u306F\u8907\u6570\u306E\u7D44\u7E54\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u3059\u3002\u66F4\u65B0\u3059\u308B\u7D44\u7E54\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"title":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F","titlePlural":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F","banner":"Cephable\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u305F\u3081\u3001\u7121\u6599\u306ECephable Basic\u306B\u30C0\u30A6\u30F3\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u66F4\u65B0\u3059\u308B\u3068\u3001\u5F37\u5316\u3055\u308C\u305F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001AI\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3001\u591A\u6570\u306E\u30D7\u30EA\u30D3\u30EB\u30C9\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u306E\u6A5F\u80FD\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"},"upgrade":{"existing":{"title":"\u3042\u306A\u305F\u306F\u65E2\u5B58\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u4E00\u90E8\u3067\u3059\u3002","description":"\u30B5\u30A4\u30C9\u30E1\u30CB\u30E5\u30FC\u306E `{{action}}` \u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"restrictions":{"isGenAIDisabled":{"title":"\u751F\u6210AI\u304C\u7121\u52B9","description":"\u7D44\u7E54\u3067\u306FGenerative AI\u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"isRemoteControlDisabled":{"title":"\u30AF\u30ED\u30B9\u30C7\u30D0\u30A4\u30B9\u540C\u671F\u304C\u7121\u52B9","description":"\u7D44\u7E54\u306B\u3088\u3063\u3066\u540C\u671F\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u306E\u4F7F\u7528\u3084\u5916\u90E8\u30C7\u30D0\u30A4\u30B9\u306E\u64CD\u4F5C\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u8A73\u3057\u304F\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"}},"troubleshooting":{"title":"\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0","editorDescription":"[\u30AA\u30D7\u30B7\u30E7\u30F3] \u3053\u308C\u306F\u3001Cephable \u30E2\u30D0\u30A4\u30EB \u30A2\u30D7\u30EA\u3068\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7 \u30A2\u30D7\u30EA\u306E\u4E21\u65B9\u306E\u63A5\u7D9A\u8A73\u7D30\u30DA\u30FC\u30B8\u3092\u901A\u3058\u3066\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u308B\u30BB\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002","description":"Cephable \u3067\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4EE5\u4E0B\u306E\u624B\u9806\u3092\u8A66\u3057\u3066\u4E00\u822C\u7684\u306A\u554F\u984C\u3092\u89E3\u6C7A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"onboarding":{"title":"\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0","editorDescription":"[\u30AA\u30D7\u30B7\u30E7\u30F3] \u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u304C\u30E6\u30FC\u30B6\u30FC\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u308B\u3068\u3001\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u6B04\u306F\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u8A2D\u5B9A\u3057\u3066\u4F7F\u7528\u3059\u308B\u65B9\u6CD5\u306B\u3064\u3044\u3066\u306E\u8AAC\u660E\u3092\u63D0\u4F9B\u3059\u308B\u306E\u306B\u6700\u9069\u3067\u3059\u3002"},"documents":"\u6587\u66F8","completionStatus":{"title":"\u5B8C\u4E86\u30B9\u30C6\u30FC\u30BF\u30B9","error":"","complete":"\u5B8C\u4E86\u3002","incomplete":"\u4E0D\u5B8C\u5168\u3002"},"metadata":{"title":"\u30E1\u30BF\u30C7\u30FC\u30BF","urlError":"URL \u306F http:// \u307E\u305F\u306F https:// \u3067\u59CB\u307E\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059","metatitle":{"label":"\u30E1\u30BF\u30BF\u30A4\u30C8\u30EB","placeholder":"\u77ED\u3044\u30BF\u30A4\u30C8\u30EB\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"shortDescription":{"label":"\u7C21\u5358\u306A\u8AAC\u660E","placeholder":"\u7C21\u5358\u306A\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u8AAC\u660E\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\uFF08\u6700\u5927 150 \u6587\u5B57\uFF09"},"externalLink":{"label":"\u5916\u90E8\u30EA\u30F3\u30AFURL","placeholder":"https://example.com/\u30C7\u30D0\u30A4\u30B9\u60C5\u5831","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u521D\u56DE\u8A2D\u5B9A\u306B\u95A2\u3059\u308B\u8A73\u7D30\u60C5\u5831\u3092\u63D0\u4F9B\u3059\u308B\u5916\u90E8\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u307E\u305F\u306F\u30EA\u30BD\u30FC\u30B9\u3078\u306E\u76F4\u63A5\u30EA\u30F3\u30AF\u3067\u3059\u3002\u3053\u308C\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30EA\u30B9\u30C8\u306E\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u306F\u4F7F\u7528\u3055\u308C\u307E\u305B\u3093\u3002"},"iconUrl":{"label":"\u30C7\u30D0\u30A4\u30B9\u30A2\u30A4\u30B3\u30F3URL","placeholder":"https://example.com/\u30C7\u30D0\u30A4\u30B9\u30A2\u30A4\u30B3\u30F3.png","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u8868\u3059\u753B\u50CF\u3078\u306E\u76F4\u63A5\u30EA\u30F3\u30AF\u3002\u3053\u306E\u30A2\u30A4\u30B3\u30F3\u306FCephable\u30A2\u30D7\u30EA\u3068\u30C7\u30D0\u30A4\u30B9\u30EA\u30B9\u30C8\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"darkModeIconUrl":{"label":"\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u30C7\u30D0\u30A4\u30B9\u30A2\u30A4\u30B3\u30F3URL","placeholder":"https://example.com/device-icon-dark.png","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3092\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u3067\u8868\u793A\u3059\u308B\u753B\u50CF\u3078\u306E\u76F4\u63A5\u30EA\u30F3\u30AF\u3067\u3059\u3002\u3053\u306E\u30A2\u30A4\u30B3\u30F3\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u3092\u6709\u52B9\u306B\u3057\u3066\u3044\u308B\u5834\u5408\u3001Cephable\u30A2\u30D7\u30EA\u3068\u30C7\u30D0\u30A4\u30B9\u30EA\u30B9\u30C8\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"editorDescription":"\u304A\u4F7F\u3044\u306E\u30C7\u30D0\u30A4\u30B9\u304C Cephable \u30A2\u30D7\u30EA\u3067\u62E1\u5F35\u6A5F\u80FD\u307E\u305F\u306F\u63A5\u7D9A\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u308B\u3088\u3046\u306B\u9078\u629E\u3055\u308C\u305F\u5834\u5408\u3001\u3053\u306E\u60C5\u5831\u306F\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8A2D\u5B9A\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"},"client-listing":{"title":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30EA\u30B9\u30C8","editorDescription":"\u65B0\u898F\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u30BF\u30A4\u30D7\u3067\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8A2D\u5B9A\u3059\u308B\u305F\u3081\u306E\u8A73\u7D30\u306A\u624B\u9806\u3002\u3053\u306E\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8FFD\u52A0\u3059\u308B\u3068\u304D\u306BCephable\u30A2\u30D7\u30EA\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"canAccessOrganizationProfiles":{"title":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u3053\u306E\u7D44\u7E54\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u308B\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A\u3067\u304D\u307E\u3059\u3002"},"canEditOrganizationProfiles":{"title":"\u7D44\u7E54\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7BA1\u7406\u3059\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u3053\u306E\u7D44\u7E54\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u524A\u9664\u3067\u304D\u307E\u3059\u3002"},"profiles":{"title":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u7D44\u7E54\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u7D44\u7E54\u5168\u4F53\u306B\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u914D\u5E03\u3057\u305F\u308A\u3001\u7D71\u5408\u30E6\u30FC\u30B6\u30FC\u3068\u5171\u6709\u3057\u305F\u308A\u3059\u308B\u305F\u3081\u306E\u5171\u6709\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3067\u3059\u3002","view":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A","editDescription":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3057\u3066\u8A2D\u5B9A\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3059\u3002","empty":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error":"\u7D44\u7E54\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","titleShort":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"},"canViewAuthClients":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u898B\u308B","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u8A8D\u8A3C\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u3068\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u95B2\u89A7\u3067\u304D\u307E\u3059\u3002"},"governance":{"title":"\u30AC\u30D0\u30CA\u30F3\u30B9","orgTitle":"{{value}} \u30AC\u30D0\u30CA\u30F3\u30B9","description":"\u30C1\u30FC\u30E0\u304CCephable\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3092\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3067\u304D\u308B\u304B\u3092\u898F\u5B9A\u3059\u308B\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002","automation":{"title":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB","description":"Cephable\u304C\u81EA\u52D5\u5316\u3067\u304D\u308B\u7BC4\u56F2\u3092\u5236\u5FA1\u3057\u3001\u7D44\u7E54\u306B\u5408\u308F\u305B\u3066\u52D5\u4F5C\u3092\u5F62\u4F5C\u308B\u6307\u793A\u3092\u63D0\u4F9B\u3067\u304D\u307E\u3059\u3002","rulesTitle":"\u30EB\u30FC\u30EB","create":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","edit":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u306E\u7DE8\u96C6","created":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002","updated":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","deleted":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","loadError":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002","saveError":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","deleteError":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","searchPlaceholder":"\u30A2\u30D7\u30EA\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3001\u307E\u305F\u306F\u7BC4\u56F2\u306B\u3088\u308B\u691C\u7D22\u30EB\u30FC\u30EB","promptOnly":"\u88DC\u52A9\u6307\u5C0E","editorDescription":"\u30EB\u30FC\u30EB\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u30A2\u30D7\u30EA\u307E\u305F\u306F\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3092\u30BF\u30FC\u30B2\u30C3\u30C8\u306B\u8A2D\u5B9A\u3057\u3001Cephable\u3078\u306E\u660E\u78BA\u306A\u6307\u793A\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002","validation":"\u30A2\u30D7\u30EA\u3084\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3001\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306E\u6307\u793A\u3001\u307E\u305F\u306F\u305D\u306E\u4E21\u65B9\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002","appOrDomain":{"label":"\u30A2\u30D7\u30EA\u307E\u305F\u306F\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8","helper":"Slack\u3001gmail.com\u3001github.com\u306A\u3069\u3001\u8A8D\u77E5\u5EA6\u306E\u9AD8\u3044\u30A2\u30D7\u30EA\u540D\u307E\u305F\u306F\u30C9\u30E1\u30A4\u30F3\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"prompt":{"label":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306E\u6307\u793A","helper":"Cephable\u304C\u5B9F\u884C\u3059\u3079\u304D\u3053\u3068\u3001\u5B9F\u884C\u3059\u3079\u304D\u3067\u306A\u3044\u3053\u3068\u3092\u8A18\u8FF0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u6307\u793A\u306F\u5177\u4F53\u7684\u304B\u3064\u5B9F\u884C\u53EF\u80FD\u306A\u3082\u306E\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"type":{"label":"\u30EB\u30FC\u30EB\u30BF\u30A4\u30D7","block":"\u30D6\u30ED\u30C3\u30AF","allow":"\u8A31\u53EF\u3059\u308B"},"scope":{"organization":"\u7D44\u7E54\u5168\u4F53","organizationDescription":"\u3053\u306E\u30EB\u30FC\u30EB\u306F\u3001\u73FE\u5728\u304A\u3088\u3073\u5C06\u6765\u306E\u3059\u3079\u3066\u306E\u4F1A\u54E1\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002","members":"\u7279\u5B9A\u306E\u30E1\u30F3\u30D0\u30FC","membersDescription":"\u30EB\u30FC\u30EB\u3092\u4FDD\u5B58\u3057\u305F\u3089\u3001\u305D\u308C\u3092\u5FC5\u8981\u3068\u3059\u308B\u30E1\u30F3\u30D0\u30FC\u306B\u306E\u307F\u5272\u308A\u5F53\u3066\u3066\u304F\u3060\u3055\u3044\u3002"},"assign":"\u30E1\u30F3\u30D0\u30FC\u3092\u5272\u308A\u5F53\u3066\u308B","delete":{"title":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","description":"\u3053\u308C\u306B\u3088\u308A\u3001\u30EB\u30FC\u30EB\u304A\u3088\u3073\u305D\u308C\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u3059\u3079\u3066\u306E\u30E1\u30F3\u30D0\u30FC\u5272\u308A\u5F53\u3066\u304C\u5B8C\u5168\u306B\u524A\u9664\u3055\u308C\u307E\u3059\u3002"},"empty":{"title":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093","description":"\u7D44\u7E54\u306E\u30D5\u30A1\u30FC\u30B9\u30C8\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306E\u884C\u52D5\u898F\u7BC4\u3092\u8A2D\u5B9A\u3059\u308B\u305F\u3081\u306E\u30EB\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"guidance":{"block":{"title":"\u30A2\u30D7\u30EA\u3068\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3092\u5236\u9650\u3059\u308B","description":"Cephable\u304C\u305D\u306E\u30A2\u30D7\u30EA\u3068\u3084\u308A\u53D6\u308A\u3057\u306A\u3044\u3088\u3046\u306B\u3059\u308B\u306B\u306F\u3001\u30A2\u30D7\u30EA\u540D\u307E\u305F\u306F\u30C9\u30E1\u30A4\u30F3\u3092\u6307\u5B9A\u3057\u3066\u30D6\u30ED\u30C3\u30AF\u30EB\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002"},"prompt":{"title":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0\u3059\u308B","description":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306E\u6307\u793A\u3092\u4F7F\u7528\u3057\u3066\u3001\u65B9\u91DD\u3001\u5FC5\u8981\u306A\u78BA\u8A8D\u4E8B\u9805\u3001\u307E\u305F\u306F\u5B89\u5168\u306A\u4F5C\u696D\u65B9\u6CD5\u3092\u4F1D\u9054\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"scope":{"title":"\u9069\u5207\u306A\u7BC4\u56F2\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u7D44\u7E54\u5168\u4F53\u3067\u5171\u901A\u306E\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u3092\u9069\u7528\u3059\u308B\u304B\u3001\u4F8B\u5916\u3092\u7279\u5B9A\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u9650\u5B9A\u3059\u308B\u304B\u306E\u3044\u305A\u308C\u304B\u3092\u9078\u629E\u3059\u308B\u3002"}},"assignment":{"title":"\u30E1\u30F3\u30D0\u30FC\u306B\u30EB\u30FC\u30EB\u3092\u5272\u308A\u5F53\u3066\u308B","description":"{{value}}\u306E\u30E1\u30F3\u30D0\u30FC\u56FA\u6709\u306E\u5272\u308A\u5F53\u3066\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","memberLabel":"\u30E1\u30F3\u30D0\u30FC","apply":"\u30EB\u30FC\u30EB\u3092\u9069\u7528\u3059\u308B","remove":"\u30EB\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B","assigned":"\u3053\u306E\u30EB\u30FC\u30EB\u306F\u9078\u629E\u3055\u308C\u305F\u30E1\u30F3\u30D0\u30FC\u306B\u5272\u308A\u5F53\u3066\u3089\u308C\u307E\u3059\u3002","notAssigned":"\u3053\u306E\u30EB\u30FC\u30EB\u306F\u9078\u629E\u3055\u308C\u305F\u30E1\u30F3\u30D0\u30FC\u306B\u306F\u5272\u308A\u5F53\u3066\u3089\u308C\u3066\u3044\u307E\u305B\u3093\u3002","applied":"\u3053\u306E\u898F\u5247\u306F\u4F1A\u54E1\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002","removed":"\u4F1A\u54E1\u304B\u3089\u30EB\u30FC\u30EB\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","loadError":"\u7D44\u7E54\u30E1\u30F3\u30D0\u30FC\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002","statusError":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u306E\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","saveError":"\u30E1\u30F3\u30D0\u30FC\u306E\u5272\u308A\u5F53\u3066\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002"}},"tabs":{"automation":"\u81EA\u52D5\u5316\u30EB\u30FC\u30EB","permissions":"\u62E1\u5F35\u6A5F\u80FD\u306E\u6A29\u9650","skills":"\u7D44\u7E54\u529B","connectors":"\u7D44\u7E54\u30B3\u30CD\u30AF\u30BF\u30FC","usage":"\u4F7F\u7528\u6CD5"},"extensions":{"permissions":{"orgTitle":"\u7D44\u7E54\u5168\u4F53\u306E\u65B9\u91DD","orgDescription":"\u30E1\u30F3\u30D0\u30FC\u304C\u30B9\u30AD\u30EB\u3084\u30B3\u30CD\u30AF\u30BF\u5168\u4F53\u3067\u6709\u52B9\u306B\u3067\u304D\u308B\u6A5F\u80FD\u3092\u5236\u5FA1\u3057\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u8A2D\u5B9A\u306F\u3001\u30E1\u30F3\u30D0\u30FC\u304C\u4EE5\u4E0B\u306E\u8A2D\u5B9A\u3067\u4E0A\u66F8\u304D\u3057\u306A\u3044\u9650\u308A\u3001\u5168\u54E1\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002","saved":"\u7D44\u7E54\u306E\u65B9\u91DD\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","saveError":"\u7D44\u7E54\u30DD\u30EA\u30B7\u30FC\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","askAdmin":"\u3053\u306E\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","installBlocked":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","createBlocked":"\u500B\u4EBA\u7528\u306E{{type}}\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002","useBlocked":"\u3053\u306E{{type}}\u306F\u73FE\u5728\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002"},"orgFlags":{"allowPublicSkills":{"title":"\u516C\u5171\u306E\u30B9\u30AD\u30EB\u3092\u8A31\u53EF\u3059\u308B","description":"\u30E1\u30F3\u30D0\u30FC\u306F\u3001Cephable\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u3067\u5229\u7528\u53EF\u80FD\u306A\u516C\u958B\u30B9\u30AD\u30EB\u3092\u516C\u958B\u307E\u305F\u306F\u6709\u52B9\u5316\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"allowMemberManagedSkills":{"title":"\u500B\u4EBA\u306E\u30B9\u30AD\u30EB\u3092\u8A31\u53EF\u3059\u308B","description":"\u4F1A\u54E1\u306F\u81EA\u8EAB\u306E\u500B\u4EBA\u7684\u30B9\u30AD\u30EB\u3092\u958B\u767A\u3057\u3001\u6D3B\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3002"},"allowPublicMcpServers":{"title":"\u30D1\u30D6\u30EA\u30C3\u30AF\u30B3\u30CD\u30AF\u30BF\u3092\u8A31\u53EF\u3059\u308B","description":"\u30E1\u30F3\u30D0\u30FC\u306F\u3001Cephable\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u3067\u5229\u7528\u53EF\u80FD\u306A\u30D1\u30D6\u30EA\u30C3\u30AF\u30B3\u30CD\u30AF\u30BF\u3092\u516C\u958B\u307E\u305F\u306F\u6709\u52B9\u5316\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"allowMemberManagedMcpServers":{"title":"\u500B\u4EBA\u7528\u30B3\u30CD\u30AF\u30BF\u3092\u8A31\u53EF\u3059\u308B","description":"\u30E1\u30F3\u30D0\u30FC\u306F\u3001\u72EC\u81EA\u306EMCP\u30B3\u30CD\u30AF\u30BF\u3092\u4F5C\u6210\u3057\u3066\u6709\u52B9\u5316\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"}},"members":{"title":"\u30E1\u30F3\u30D0\u30FC\u3054\u3068\u306E\u4E0A\u66F8\u304D","description":"\u500B\u3005\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u3001\u5916\u90E8\u306E\u30B9\u30AD\u30EB\u3084\u30B3\u30CD\u30AF\u30BF\u30FC\u3092\u5171\u6709\u3001\u7BA1\u7406\u3001\u307E\u305F\u306F\u4F7F\u7528\u3059\u308B\u6A29\u9650\u3092\u4ED8\u4E0E\u3059\u308B\u3002","memberLabel":"\u30E1\u30F3\u30D0\u30FC","saved":"\u30E1\u30F3\u30D0\u30FC\u306E\u6A29\u9650\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","saveError":"\u30E1\u30F3\u30D0\u30FC\u306E\u6A29\u9650\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","loadError":"\u7D44\u7E54\u30E1\u30F3\u30D0\u30FC\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002","adminNote":"\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u7D44\u7E54\u7BA1\u7406\u8005\u3067\u3042\u308A\u3001\u65E2\u306B\u3059\u3079\u3066\u306E\u62E1\u5F35\u6A5F\u80FD\u306E\u6A29\u9650\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u3002"},"memberFlags":{"canShareSkillsWithOrganization":{"title":"\u7D44\u7E54\u3068\u30B9\u30AD\u30EB\u3092\u5171\u6709\u3059\u308B","description":"\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u304C\u6D3B\u7528\u3067\u304D\u308B\u3088\u3046\u3001\u500B\u4EBA\u306E\u30B9\u30AD\u30EB\u3092\u516C\u958B\u3057\u307E\u3057\u3087\u3046\u3002"},"canManageOrganizationSkills":{"title":"\u7D44\u7E54\u7BA1\u7406\u30B9\u30AD\u30EB","description":"\u7D44\u7E54\u3068\u5171\u6709\u3059\u308B\u30B9\u30AD\u30EB\u3092\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u524A\u9664\u3057\u307E\u3059\u3002"},"canUseExternalSkills":{"title":"\u5916\u90E8\u306E\u30B9\u30AD\u30EB\u3092\u6D3B\u7528\u3059\u308B","description":"\u7D44\u7E54\u304C\u5236\u9650\u3057\u3066\u3044\u308B\u5834\u5408\u3067\u3082\u3001\u516C\u7684\u306A\u30B9\u30AD\u30EB\u3084\u500B\u4EBA\u7684\u306A\u30B9\u30AD\u30EB\u3092\u6D3B\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u3002"},"canShareMcpServersWithOrganization":{"title":"\u7D44\u7E54\u3068\u30B3\u30CD\u30AF\u30BF\u3092\u5171\u6709\u3059\u308B","description":"\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u304C\u6709\u52B9\u5316\u3067\u304D\u308B\u3088\u3046\u306B\u3001\u500B\u4EBA\u7528\u30B3\u30CD\u30AF\u30BF\u3092\u516C\u958B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"canManageOrganizationMcpServers":{"title":"\u7D44\u7E54\u30B3\u30CD\u30AF\u30BF\u306E\u7BA1\u7406","description":"\u7D44\u7E54\u3068\u5171\u6709\u3055\u308C\u3066\u3044\u308B\u30B3\u30CD\u30AF\u30BF\u3092\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u524A\u9664\u3057\u307E\u3059\u3002"},"canUseExternalMcpServers":{"title":"\u5916\u90E8\u30B3\u30CD\u30AF\u30BF\u3092\u4F7F\u7528\u3059\u308B","description":"\u7D44\u7E54\u304C\u5236\u9650\u3057\u3066\u3044\u308B\u5834\u5408\u3067\u3082\u3001\u30D1\u30D6\u30EA\u30C3\u30AF\u30B3\u30CD\u30AF\u30BF\u307E\u305F\u306F\u30D1\u30FC\u30BD\u30CA\u30EB\u30B3\u30CD\u30AF\u30BF\u3092\u6709\u52B9\u306B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"}},"skills":{"title":"\u7D44\u7E54\u529B","description":"\u7D44\u7E54\u5411\u3051\u306B\u30B9\u30AD\u30EB\u3092\u4E8B\u524D\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002\u30E1\u30F3\u30D0\u30FC\u306F\u30A2\u30D7\u30EA\u304B\u3089\u3053\u308C\u3089\u306E\u30B9\u30AD\u30EB\u3092\u898B\u3064\u3051\u3066\u6709\u52B9\u5316\u3067\u304D\u307E\u3059\u3002","create":"\u30B9\u30AD\u30EB\u3092\u4F5C\u6210\u3059\u308B","edit":"\u30B9\u30AD\u30EB\u3092\u7DE8\u96C6\u3059\u308B"},"connectors":{"title":"\u7D44\u7E54\u30B3\u30CD\u30AF\u30BF","description":"\u7D44\u7E54\u5411\u3051\u306BMCP\u30B3\u30CD\u30AF\u30BF\u3092\u4E8B\u524D\u306B\u8A2D\u5B9A\u3057\u307E\u3059\u3002\u30E1\u30F3\u30D0\u30FC\u306F\u3001\u30B3\u30CD\u30AF\u30BF\u3092\u6709\u52B9\u306B\u3059\u308B\u969B\u306B\u3001\u5404\u81EA\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u8A8D\u8A3C\u60C5\u5831\u3092\u5165\u529B\u3057\u307E\u3059\u3002","create":"\u30B3\u30CD\u30AF\u30BF\u3092\u8FFD\u52A0\u3059\u308B","edit":"\u30B3\u30CD\u30AF\u30BF\u3092\u7DE8\u96C6"},"sort":{"label":"\u4E26\u3079\u66FF\u3048","recent":"\u6700\u65B0","rating":"\u6700\u9AD8\u8A55\u4FA1","votes":"\u6700\u3082\u9AD8\u8A55\u4FA1\u3055\u308C\u305F","installs":"\u6700\u3082\u591A\u304F\u8A2D\u7F6E\u3055\u308C\u3066\u3044\u308B"},"list":{"loadError":"\u30EA\u30B9\u30C8\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002","emptyTitle":"\u307E\u3060\u3053\u3053\u306B\u306F\u4F55\u3082\u3042\u308A\u307E\u305B\u3093","emptyDescription":"\u7D44\u7E54\u306E\u30E1\u30F3\u30D0\u30FC\u304C\u5229\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u3001\u4E00\u3064\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"stats":{"rating":"\u5E73\u5747\u8A55\u4FA1","installs":"\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u3066\u3044\u308B\u30E1\u30F3\u30D0\u30FC","votes":"\u6295\u7968\u30B9\u30B3\u30A2","comments":"\u30B3\u30E1\u30F3\u30C8"},"feedback":{"open":"\u8A55\u4FA1\u3068\u30B3\u30E1\u30F3\u30C8","description":"\u8A55\u4FA1\u3068\u30B3\u30E1\u30F3\u30C8\u306F\u7D44\u7E54\u5185\u3067\u5171\u6709\u3055\u308C\u307E\u3059\u3002","yourRating":"\u3042\u306A\u305F\u306E\u8A55\u4FA1","upvote":"\u8CDB\u6210\u7968","downvote":"\u4F4E\u8A55\u4FA1","comments":"\u30B3\u30E1\u30F3\u30C8","commentPlaceholder":"\u3042\u306A\u305F\u306E\u30C1\u30FC\u30E0\u3067\u3069\u306E\u3088\u3046\u306B\u6A5F\u80FD\u3057\u3066\u3044\u308B\u304B\u3001\u305C\u3072\u5171\u6709\u3057\u3066\u304F\u3060\u3055\u3044\u3002","replyPlaceholder":"\u8FD4\u4FE1\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u2026","noComments":"\u307E\u3060\u30B3\u30E1\u30F3\u30C8\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u4F1A\u8A71\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002","member":"\u30E1\u30F3\u30D0\u30FC","deleted":"\u3053\u306E\u30B3\u30E1\u30F3\u30C8\u306F\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","reply":"\u8FD4\u4E8B","loadError":"\u30B3\u30E1\u30F3\u30C8\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002","rateError":"\u8A55\u4FA1\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","commentError":"\u30B3\u30E1\u30F3\u30C8\u3092\u6295\u7A3F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","deleteError":"\u30B3\u30E1\u30F3\u30C8\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002"},"usage":{"description":"\u3069\u306E\u30E1\u30F3\u30D0\u30FC\u304C\u5404\u7D44\u7E54\u30B9\u30AD\u30EB\u3068\u30B3\u30CD\u30AF\u30BF\u3092\u6709\u52B9\u306B\u3057\u3066\u3044\u308B\u304B\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002","skillsTitle":"\u30B9\u30AD\u30EB\u6D3B\u7528","connectorsTitle":"\u30B3\u30CD\u30AF\u30BF\u306E\u4F7F\u7528\u65B9\u6CD5","empty":"\u3053\u306E\u30AB\u30C6\u30B4\u30EA\u3067\u307E\u3060\u6709\u52B9\u5316\u3057\u3066\u3044\u308B\u30E1\u30F3\u30D0\u30FC\u306F\u3044\u307E\u305B\u3093\u3002","installCount":"{{count}}\u4EBA\u306E\u30E1\u30F3\u30D0\u30FC","accountWide":"\u3059\u3079\u3066\u306E\u30C7\u30D0\u30A4\u30B9","perDevice":"\u5358\u4E00\u30C7\u30D0\u30A4\u30B9","unnamed":"\u7121\u984C","loadError":"\u4F7F\u7528\u72B6\u6CC1\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002"}}},"canManageGlobalAutomationRules":{"title":"\u30AC\u30D0\u30CA\u30F3\u30B9\u306E\u7BA1\u7406","description":"\u3053\u306E\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u7D44\u7E54\u306E\u81EA\u52D5\u5316\u30EB\u30FC\u30EB\u3068\u30E1\u30F3\u30D0\u30FC\u306E\u5272\u308A\u5F53\u3066\u3092\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002"}},"developer":{"title":"\u958B\u767A\u8005","titleLong":"\u958B\u767A\u8005\u30EA\u30BD\u30FC\u30B9","description":"Cephable \u306F\u3001\u5F53\u793E\u306E SDK \u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u3001\u30B2\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u306B\u76F4\u63A5\u7D71\u5408\u3067\u304D\u307E\u3059\u3002","sdk":{"title":"SDK \u3092\u8A73\u3057\u304F\u898B\u308B","description":"\u5F53\u793E\u306F\u3001\u97F3\u58F0\u8A8D\u8B58\u3068\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u7D71\u5408\u3059\u308B\u3088\u3046\u306B\u8A2D\u8A08\u3055\u308C\u305F\u4E00\u6D41\u306E SDK \u3092\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002\u5F53\u793E\u306E\u30C4\u30FC\u30EB\u306F\u3001\u76F4\u611F\u7684\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u901A\u3058\u3066\u30E6\u30FC\u30B6\u30FC \u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u5F37\u5316\u3057\u3001\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3092\u4FC3\u9032\u3059\u308B\u3088\u3046\u306B\u4F5C\u6210\u3055\u308C\u3066\u304A\u308A\u3001\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u3088\u308A\u52B9\u7387\u7684\u306B\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","javascript":{"title":"JavaScript","subtitle":"\u30A6\u30A7\u30D6","description":"\u97F3\u58F0\u304A\u3088\u3073\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092 Web \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u76F4\u63A5\u7D71\u5408\u3057\u307E\u3059\u3002","action":"NPM \u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5165\u624B"},"net":{"title":"\u3002\u30CD\u30C3\u30C8","subtitle":"Windows \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3","description":".NET \u306E\u30D1\u30EF\u30FC\u3092\u6D3B\u7528\u3057\u3066\u3001WPF \u304A\u3088\u3073 WinUI3 SDK \u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","actionCore":"\u30B3\u30A2\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5165\u624B","actionWpf":"WPF \u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5165\u624B"},"android":{"title":"\u30A2\u30F3\u30C9\u30ED\u30A4\u30C9","subtitle":"\u30E2\u30D0\u30A4\u30EB\u30C7\u30D0\u30A4\u30B9","description":"\u97F3\u58F0\u3068\u982D\u306E\u52D5\u304D\u306E\u6A5F\u80FD\u3092\u5BB9\u6613\u306B\u3059\u308B\u305F\u3081\u306B\u8A2D\u8A08\u3055\u308C\u305F Android \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3002","action":"Android SDK\u3092\u5165\u624B"},"more":{"title":"\u3082\u3063\u3068","description":"\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u304B? \u3054\u9023\u7D61\u3044\u305F\u3060\u3051\u308C\u3070\u304A\u624B\u4F1D\u3044\u3044\u305F\u3057\u307E\u3059\u3002","action":"SDK\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B"},"docs":{"title":"\u6587\u66F8","description":"Cephable \u3092\u4F7F\u3063\u305F\u958B\u767A\u3092\u59CB\u3081\u308B\u306B\u306F\u3001\u8A73\u7D30\u306A\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B5\u30F3\u30D7\u30EB\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001\u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u8868\u793A"}},"demo":{"title":"\u30C7\u30E2","samples":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3068\u30B5\u30F3\u30D7\u30EB","titleLong":"\u5F53\u793E\u306ESDK\u3092\u5B9F\u969B\u306B\u4F53\u9A13\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u30B5\u30F3\u30D7\u30EB \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u901A\u3058\u3066\u3001\u97F3\u58F0\u304A\u3088\u3073\u30D8\u30C3\u30C9 \u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u306E\u5A01\u529B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6 \u30B2\u30FC\u30E0\u304B\u3089\u52D5\u7684\u306A Web \u30A2\u30D7\u30EA\u3084\u30E2\u30D0\u30A4\u30EB \u30A2\u30D7\u30EA\u307E\u3067\u3001\u305D\u308C\u305E\u308C\u306E\u4F8B\u3067 SDK \u306E\u6C4E\u7528\u6027\u3068\u6709\u52B9\u6027\u304C\u5B9F\u8A3C\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u4F8B\u3092\u8ABF\u3079\u3066\u3001\u5F37\u5316\u3055\u308C\u305F\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u3068\u6CA1\u5165\u578B\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u72EC\u81EA\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u7D71\u5408\u3059\u308B\u305F\u3081\u306E\u6D1E\u5BDF\u3068\u30A4\u30F3\u30B9\u30D4\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u5F97\u3066\u304F\u3060\u3055\u3044\u3002","game":{"title":"2048 \u30B2\u30FC\u30E0","subtitle":"\u30A6\u30A7\u30D6","description":"\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6\u97F3\u58F0\u3068\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u5F93\u6765\u306E\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u3092\u5411\u4E0A\u3055\u305B\u307E\u3059\u3002","action":"\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3059\u308B"},"other":{"title":"\u305D\u306E\u4ED6\u306E\u30C7\u30E2","description":"Cephable \u304C\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3001\u30B2\u30FC\u30E0\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u3069\u306E\u3088\u3046\u306B\u5F37\u5316\u3067\u304D\u308B\u304B\u3092\u76F4\u63A5\u4F53\u9A13\u3057\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u305D\u306E\u4ED6\u306E\u30C7\u30E2\u3092\u898B\u308B"},"web":{"title":"Web SDK \u30B5\u30F3\u30D7\u30EB","subtitle":"\u30A6\u30A7\u30D6","description":"\u3059\u3079\u3066\u306E\u30B3\u30A2\u6A5F\u80FD\u3092 Web \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u7C21\u5358\u306B\u7D71\u5408\u3057\u307E\u3059\u3002","action":"SDK\u3092\u4F53\u9A13\u3059\u308B"},"unity":{"title":"\u56E3\u7D50","subtitle":"\u30B2\u30FC\u30E0\u958B\u767A","description":"\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B2\u30FC\u30E0\u3067\u6D3B\u7528\u3057\u3066\u3001\u3088\u308A\u9B45\u529B\u7684\u306A UX \u3092\u63D0\u4F9B\u3059\u308B\u65B9\u6CD5\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","action":"\u30B5\u30F3\u30D7\u30EB\u3092\u5165\u624B"},"docs":{"title":"\u958B\u767A\u8005\u5411\u3051\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3068\u30B5\u30F3\u30D7\u30EB","description":"Cephable \u3092\u4F7F\u3063\u305F\u958B\u767A\u3092\u59CB\u3081\u308B\u306B\u306F\u3001\u8A73\u7D30\u306A\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B5\u30F3\u30D7\u30EB\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001\u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002","action":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u8868\u793A"}},"other":{"title":"\u305D\u306E\u4ED6\u306E\u30EA\u30BD\u30FC\u30B9","description":"\u5F0A\u793E\u306E SDK \u3067\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001API \u3092\u76F4\u63A5\u64CD\u4F5C\u3059\u308B\u304B\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u9023\u7D61\u3057\u3066\u30D8\u30EB\u30D7\u3001\u30A4\u30F3\u30B9\u30D4\u30EC\u30FC\u30B7\u30E7\u30F3\u3001\u30B5\u30DD\u30FC\u30C8\u3092\u6C42\u3081\u3066\u304F\u3060\u3055\u3044\u3002","api":{"title":"API","description":"\u5F53\u793E\u306E API \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001Cephable \u3068\u76F4\u63A5\u3084\u308A\u53D6\u308A\u3067\u304D\u307E\u3059\u3002\u5F53\u793E\u306E API \u3092\u4F7F\u7528\u3057\u3066\u30AB\u30B9\u30BF\u30E0\u7D71\u5408\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"support":{"title":"\u30B5\u30DD\u30FC\u30C8","description":"\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u304B? Discord \u7D4C\u7531\u3067\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002","action":"Discord\u306B\u53C2\u52A0\u3059\u308B"}}},"customControls":{"title":"\u30B0\u30ED\u30FC\u30D0\u30EB\u304A\u3088\u3073\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","prefixDisclaimer":"\u3053\u308C\u306F\u30D7\u30EC\u30D5\u30A3\u30C3\u30AF\u30B9\u5236\u5FA1\u3067\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306E\u5358\u8A9E\u3092\u30EA\u30C3\u30B9\u30F3\u3057\u3001\u6B21\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u691C\u7D22\u3057\u3066\u4E00\u81F4\u3059\u308B\u3082\u306E\u3092\u898B\u3064\u3051\u307E\u3059\u3002","allowPausedDisclaimer":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30DE\u30A4\u30AF\u304C\u4E00\u6642\u505C\u6B62\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u3067\u3082\u6A5F\u80FD\u3057\u307E\u3059\u3002","resetControls":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30EA\u30BB\u30C3\u30C8","description":"\u6700\u5F8C\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u66F4\u65B0\u3057\u3066\u304B\u3089\u97F3\u58F0\u8A00\u8A9E\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F\u3002\u6CE8: \u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C {{language}} \u306B\u4E00\u81F4\u3059\u308B\u3088\u3046\u306B\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u3001\u30AB\u30B9\u30BF\u30E0 \u30B3\u30DE\u30F3\u30C9\u304C\u5931\u308F\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirm":"\u306F\u3044\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059","error":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30EA\u30BB\u30C3\u30C8\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"conflictIndicators":{"warn":"\u8B66\u544A\uFF1A ","title":"\u5165\u529B\u69CB\u6210\u306E\u7AF6\u5408\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F","globalControls":"\u30B0\u30ED\u30FC\u30D0\u30EB\u5236\u5FA1\u69CB\u6210\u306E\u7AF6\u5408","deviceControls":"\u30C7\u30D0\u30A4\u30B9\u5236\u5FA1\u69CB\u6210\u306E\u7AF6\u5408","usedInput":"\u5165\u529B\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u308B","description":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5165\u529B\u306E\u4E00\u90E8\u306F\u30011 \u3064\u4EE5\u4E0A\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3082\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable \u306E\u4F7F\u7528\u6642\u306B\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u3088\u3046\u306A\u72B6\u6CC1\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u3001\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3088\u308A\u3082\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u5E38\u306B\u512A\u5148\u3055\u308C\u307E\u3059\u3002","item":"\u5165\u529B<strong>{{value}}</strong>\u306F\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3055\u308C\u307E\u3059: ","globalDescription":"\u6B21\u306E\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u7AF6\u5408\u3059\u308B\u5165\u529B\u304C\u3042\u308A\u307E\u3059\u3002","deviceDescription":"\u6B21\u306E\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u7AF6\u5408\u3059\u308B\u5165\u529B\u304C\u3042\u308A\u307E\u3059\u3002"},"globalControls":{"title":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","empty":"\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","edit":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6","description":"\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30C7\u30D0\u30A4\u30B9\u306B\u95A2\u4FC2\u306A\u304F\u3001\u5E38\u306B\u5229\u7528\u3067\u304D\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3059\u3002\u30DE\u30A4\u30AF\u3084\u30AB\u30E1\u30E9\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u4E00\u6642\u505C\u6B62\u3055\u308C\u3066\u3044\u308B\u3068\u304D\u3067\u3082\u6A5F\u80FD\u3059\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3082\u3042\u308A\u307E\u3059\u3002"},"deviceControls":{"title":"\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","empty":"\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","edit":"\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3059\u308B","controls":{"cephable-open-app":{"success":"\u30A2\u30D7\u30EA\u3092\u958B\u304F: {{value}}","error":"\u30A2\u30D7\u30EA\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093: {{value}}"},"cephable-close-app":{"commands":["\u8FD1\u3044"],"name":"\u540D\u524D\u3067\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u306E\u30A2\u30D7\u30EA\u3092\u540D\u524D\u3067\u9589\u3058\u307E\u3059\u3002","success":"\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B: {{value}}","error":"\u30A2\u30D7\u30EA\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093: {{value}}"},"cephable-minimize-focused-app":{"commands":["\u6700\u5C0F\u5316"],"name":"\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u6700\u5C0F\u5316\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u304C\u6700\u5C0F\u5316\u3055\u308C\u307E\u3059\u3002","success":"\u96C6\u4E2D\u3057\u305F\u30A2\u30D7\u30EA\u306E\u6210\u529F\u3092\u6700\u5C0F\u9650\u306B\u6291\u3048\u307E\u3059\u3002","error":"\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30A2\u30D7\u30EA\u3092\u6700\u5C0F\u5316\u3059\u308B\u3068\u304D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"cephable-maximize-focused-app":{"commands":["\u6700\u5927\u5316\u3059\u308B"],"name":"\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u6700\u5927\u5316\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u304C\u6700\u5927\u5316\u3055\u308C\u307E\u3059\u3002","success":"\u96C6\u4E2D\u7684\u306A\u30A2\u30D7\u30EA\u306E\u6210\u529F\u3092\u6700\u5927\u5316\u3057\u307E\u3057\u3087\u3046!","error":"\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u305F\u30A2\u30D7\u30EA\u3092\u6700\u5C0F\u5316\u3059\u308B\u3068\u304D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"cephable-generate-text":{"commands":["\u751F\u6210\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u6307\u5B9A\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3057\u3001\u305D\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u3001\u95A2\u9023\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002"},"cephable-stop-generate-text":{"commands":["\u751F\u6210\u3092\u505C\u6B62","\u751F\u6210\u3092\u505C\u6B62\u3059\u308B","\u30AD\u30E3\u30F3\u30BB\u30EB\u751F\u6210","\u751F\u6210\u3092\u30AD\u30E3\u30F3\u30BB\u30EB"],"name":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u3092\u505C\u6B62\u3057\u307E\u3059\u3002","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u304C\u505C\u6B62\u3057\u307E\u3059"},"cephable-open-panel":{"commands":["\u30D1\u30CD\u30EB\u3092\u8868\u793A"],"name":"Cephable\u30D1\u30CD\u30EB\u3092\u958B\u304F","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001Cephable \u30D1\u30CD\u30EB\u3092\u958B\u304D\u307E\u3059\u3002"},"cephable-close-panel":{"commands":["\u30D1\u30CD\u30EB\u3092\u975E\u8868\u793A"],"name":"Cephable\u30D1\u30CD\u30EB\u3092\u975E\u8868\u793A\u306B\u3059\u308B","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001Cephable \u30D1\u30CD\u30EB\u3092\u975E\u8868\u793A\u306B\u3057\u305F\u308A\u6700\u5C0F\u5316\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"cephable-close-focused-app":{"commands":["\u8FD1\u3044\u6D41\u308C"],"name":"\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u9589\u3058\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3057\u3066\u3001\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u3055\u308C\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u9589\u3058\u307E\u3059\u3002","success":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u3092\u6B63\u5E38\u306B\u9589\u3058\u307E\u3057\u305F!","error":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B\u3068\u304D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"cephable-rewrite-text":{"commands":["\u30EA\u30E9\u30A4\u30C8"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u6307\u5B9A\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u63DB\u3048\u307E\u3059\u3002","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u7D9A\u3044\u3066\u30D7\u30ED\u30F3\u30D7\u30C8\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u5F37\u8ABF\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u304C\u66F8\u304D\u63DB\u3048\u3089\u308C\u307E\u3059\u3002"},"cephable-summarize-text":{"commands":["\u8981\u7D04\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u6307\u5B9A\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3057\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3068\u3082\u306B\u4F7F\u7528\u3057\u3001\u305D\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u3001\u73FE\u5728\u5F37\u8ABF\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3057\u307E\u3059\u3002"},"cephable-translate-text":{"commands":["\u7FFB\u8A33\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3057\u307E\u3059\u3002","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u7D9A\u3044\u3066\u30D7\u30ED\u30F3\u30D7\u30C8\u3067\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u73FE\u5728\u5F37\u8ABF\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u304C\u7FFB\u8A33\u3055\u308C\u307E\u3059\u3002"},"cephable-click-by-name":{"commands":["\u30BF\u30C3\u30D7","\u6253\u3064","\u79FB\u52D5","\u884C\u304F"],"name":"\u540D\u524D\u3067\u8981\u7D20\u3092\u30BF\u30C3\u30D7","description":"\u30DA\u30FC\u30B8\u4E0A\u306E\u4F55\u304B\u3092\u540D\u524D\u3067\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u4FDD\u5B58\u3092\u30BF\u30C3\u30D7\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u3001\u300C\u4FDD\u5B58\u300D\u3068\u3044\u3046\u540D\u524D\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u97F3\u58F0\u30DE\u30A6\u30B9\u3068\u540C\u3058\u3067\u3001\u30DE\u30A6\u30B9\u3092\u4F7F\u308F\u305A\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3067\u64CD\u4F5C\u3057\u307E\u3059\u3002"},"cephable-automate":{"commands":["\u81EA\u52D5\u5316\u3059\u308B","\u8A66\u3057\u3066","\u982D\u90E8\u306B","\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5B9F\u884C\u3059\u308B","\u4F5C\u696D\u3059\u308B"],"name":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306E\u5F8C\u306B\u30BF\u30B9\u30AF\u3092\u8A18\u8FF0\u3059\u308B\u3053\u3068\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u7D44\u307F\u5408\u308F\u305B\u3066\u4F7F\u7528\u3057\u3001\u305D\u306E\u5F8C\u306B\u300C\u30C1\u30FC\u30E0\u3078\u306E\u30E1\u30FC\u30EB\u9001\u4FE1\u3092\u81EA\u52D5\u5316\u3059\u308B\u300D\u306A\u3069\u306E\u30BF\u30B9\u30AF\u3092\u6307\u5B9A\u3059\u308B\u3068\u3001Cephable\u304C\u305D\u308C\u3092AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3068\u3057\u3066\u5B9F\u884C\u3057\u307E\u3059\u3002"},"cephable-paste-background-entry":{"commands":["\u6700\u8FD1\u306E\u30A8\u30F3\u30C8\u30EA\u3092\u8CBC\u308A\u4ED8\u3051\u308B","\u6700\u5F8C\u306E\u30A8\u30F3\u30C8\u30EA\u3092\u8CBC\u308A\u4ED8\u3051\u308B","\u6700\u5F8C\u306E\u97F3\u58F0\u5165\u529B\u3092\u8CBC\u308A\u4ED8\u3051\u308B","\u80CC\u666F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8CBC\u308A\u4ED8\u3051\u308B"],"name":"\u6700\u65B0\u306E\u80CC\u666F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8CBC\u308A\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u306B\u4FDD\u5B58\u3055\u308C\u3066\u3044\u308B\u6700\u65B0\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u3001\u73FE\u5728\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u3063\u3066\u3044\u308B\u30A2\u30D7\u30EA\u306B\u8CBC\u308A\u4ED8\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"}},"description":"\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u7279\u5B9A\u306E\u30C7\u30D0\u30A4\u30B9\u307E\u305F\u306F\u63A5\u7D9A\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u8FFD\u52A0\u3057\u306A\u304F\u3066\u3082\u5229\u7528\u3067\u304D\u3001\u7279\u5B9A\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306E\u307F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u6A5F\u80FD\u3084\u30A4\u30D9\u30F3\u30C8\u306B\u7279\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002"},"warn":"\u30DE\u30A4\u30AF\u304C\u8D77\u52D5\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30B0\u30ED\u30FC\u30D0\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","changeProfile":{"success":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5909\u66F4: {{value}}","error":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093: \'{{value}}\'"},"descriptionShort":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u3042\u3089\u3086\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u52D5\u4F5C\u3059\u308B\u3088\u3046\u306B\u8A2D\u8A08\u3055\u308C\u305F\u3001\u3044\u3064\u3067\u3082\u5229\u7528\u53EF\u80FD\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002\u300C\u30AB\u30E1\u30E9\u3092\u505C\u6B62\u300D\u306A\u3069\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30B7\u30B9\u30C6\u30E0\u5168\u4F53\u306B\u9069\u7528\u3055\u308C\u3001\u30A2\u30D7\u30EA\u306B\u4F9D\u5B58\u3057\u307E\u305B\u3093\u3002\u4E00\u65B9\u3001\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5404\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3055\u308C\u3001\u6A19\u6E96\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3088\u308A\u3082\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","description":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u3042\u3089\u3086\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3067\u52D5\u4F5C\u3059\u308B\u3088\u3046\u306B\u8A2D\u8A08\u3055\u308C\u305F\u3001\u3044\u3064\u3067\u3082\u5229\u7528\u53EF\u80FD\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002\u300C\u30AB\u30E1\u30E9\u3092\u505C\u6B62\u300D\u306A\u3069\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30B7\u30B9\u30C6\u30E0\u5168\u4F53\u306B\u9069\u7528\u3055\u308C\u3001\u30A2\u30D7\u30EA\u306B\u4F9D\u5B58\u3057\u307E\u305B\u3093\u3002\u4E00\u65B9\u3001\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5404\u30C7\u30D0\u30A4\u30B9\u306E\u63A5\u7D9A\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3055\u308C\u3001\u6A19\u6E96\u7684\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3088\u308A\u3082\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u73FE\u5728\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3057\u3066\u30A2\u30AF\u30BB\u30B9\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001\u5C06\u6765\u7684\u306B\u306F\u4ED6\u306E\u5165\u529B\u306B\u3082\u5BFE\u5FDC\u3059\u308B\u4E88\u5B9A\u3067\u3059\u3002","noDevice":"\u3053\u306E\u30B9\u30C6\u30C3\u30D7\u3067\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u306A\u3044\u30AB\u30B9\u30BF\u30E0\u62E1\u5F35\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002\u3053\u306E\u30B9\u30C6\u30C3\u30D7\u306E\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3059\u308B\u306B\u306F\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"notifications":{"title":"\u901A\u77E5","center":"\u901A\u77E5\u30BB\u30F3\u30BF\u30FC","empty":"\u73FE\u6642\u70B9\u3067\u306F\u901A\u77E5\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","seen":"\u898B\u305F","markAsRead":"\u65E2\u8AAD\u306B\u3059\u308B","view":"\u3059\u3079\u3066\u306E {{value}} \u4EF6\u306E\u901A\u77E5\u3092\u8868\u793A"},"unsaved":{"title":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u5909\u66F4\u304C\u4FDD\u5B58\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3053\u306E\u30DA\u30FC\u30B8\u3092\u96E2\u308C\u307E\u3059\u304B?","cancel":"\u4FDD\u5B58\u305B\u305A\u306B\u7D42\u4E86","confirm":"\u4FDD\u5B58\u3057\u3066\u7D42\u4E86"},"login":{"welcome":"Cephable \u3078\u3088\u3046\u3053\u305D!","subtitle":"<strong>\u3042\u306A\u305F\u306E</strong>\u6761\u4EF6\u306B\u5408\u308F\u305B\u3066\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u307E\u3059\u3002","create":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B","signIn":"\u30B5\u30A4\u30F3\u30A4\u30F3","loading":"\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3057\u3066\u3044\u307E\u3059...","error":"\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002","existingAccount":"\u3059\u3067\u306B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u3059\u304B?","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3002\u4F5C\u6210\u3002\u81EA\u52D5\u5316\u3002Cephable\u306F\u3001\u7D20\u65E9\u3044\u30B3\u30DE\u30F3\u30C9\u5B9F\u884C\u3001\u72B6\u6CC1\u306B\u5FDC\u3058\u305F\u30C9\u30E9\u30D5\u30C8\u4F5C\u6210\u3001\u305D\u3057\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5B9F\u73FE\u3059\u308B\u3001\u3042\u306A\u305F\u5C02\u7528\u306EAI\u3067\u3059\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E0D\u8981\u3002\u3042\u306A\u305F\u3068\u5171\u306B\u9032\u5316\u3059\u308B\u3001\u30B7\u30FC\u30E0\u30EC\u30B9\u306A\u30B5\u30DD\u30FC\u30C8\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002"},"home":{"title":"\u5BB6","startControls":"\u96FB\u6E90\u3092\u5165\u308C\u3066\u304F\u3060\u3055\u3044\uFF01","manage":"\u8A2D\u5B9A","profileGenerate":{"title":"\u304A\u3063\u3068\u3002\u307E\u3060\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002","description":"Cephable \u304C\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u3092\u5236\u5FA1\u3059\u308B\u306B\u306F\u3001\u4F55\u3092\u5236\u5FA1\u3057\u305F\u3044\u306E\u304B\u3092\u77E5\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6700\u521D\u304B\u3089\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30B8\u30A7\u30CD\u30EC\u30FC\u30BF\u30FC\u3092\u4F7F\u7528\u3057\u3066\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"}},"wizard":{"description":"Cephable \u306F\u3053\u306E\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u3001\u78BA\u8A8D\u3057\u3066\u8A66\u3059\u305F\u3081\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3057\u307E\u3059\u3002","includeDefaultKeysQuestion":"\u30AD\u30FC\u3068\u30DE\u30A6\u30B9\u306E\u30AF\u30EA\u30C3\u30AF\u306B\u5BFE\u3059\u308B\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u542B\u3081\u307E\u3059\u304B?","placeholderAppName":"Microsoft Word\u3001Minecraft\u3001YouTube\u3001\u30B3\u30FC\u30C9\u306A\u3069\u3002","noOptionsText":"\u5236\u5FA1\u3057\u305F\u3044\u30A2\u30D7\u30EA\u3092\u898B\u3064\u3051\u308B\u305F\u3081\u306B\u5165\u529B\u3092\u59CB\u3081\u307E\u3059","generate":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3059\u308B","complete":{"title":"\u306F\u3044\u3001\u7D42\u308F\u308A\u307E\u3057\u305F\uFF01","description":"\u751F\u6210\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002 \u624B\u52D5\u3067\u7DE8\u96C6\u3001\u8FFD\u52A0\u3001\u307E\u305F\u306F\u524A\u9664\u3057\u3066\u3001\u81EA\u5206\u306B\u3068\u3063\u3066\u5B8C\u74A7\u306A\u3082\u306E\u306B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","viewControls":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u898B\u308B"},"error":{"emptyInput":"\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u5165\u529B\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","emptyApp":"\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u30A2\u30D7\u30EA\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","generatingProfile":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u751F\u6210\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"loading":{"title":"\u79C1\u305F\u3061\u306F\u3059\u3079\u3066\u306E\u30D4\u30FC\u30B9\u3092\u307E\u3068\u3081\u3066\u3044\u307E\u3059","description":"\u3053\u308C\u306B\u306F\u7D04 1 \u5206\u307B\u3069\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30DA\u30FC\u30B8\u3092\u96E2\u308C\u305F\u308A\u623B\u3063\u305F\u308A\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u305D\u3046\u3057\u306A\u3044\u3068\u751F\u6210\u304C\u505C\u6B62\u3057\u307E\u3059\u3002"},"selectedTips":{"title":"\u30D2\u30F3\u30C8 #{{count}}","previous":"\u524D\u306E\u30D2\u30F3\u30C8","next":"\u6B21\u306E\u30D2\u30F3\u30C8","two":"\u30E1\u30A4\u30F3 \u30D1\u30CD\u30EB\u306E\u300C\u8868\u73FE\u5236\u5FA1\u8A2D\u5B9A\u300D\u30BB\u30AF\u30B7\u30E7\u30F3\u3067\u3001\u5165\u529B\u306E\u611F\u5EA6\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable \u304C\u7279\u5B9A\u306E\u5165\u529B\u3092\u89E3\u91C8\u3059\u308B\u65B9\u6CD5\u3092\u3055\u3089\u306B\u7D30\u304B\u304F\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002\u307E\u305F\u3001Cephable \u306F\u30E6\u30FC\u30B6\u30FC\u3068\u9023\u643A\u3057\u3066\u6642\u9593\u306E\u7D4C\u904E\u3068\u3068\u3082\u306B\u6539\u5584\u3055\u308C\u307E\u3059\u3002","three":"\u3053\u308C\u3092\u8A2D\u5B9A\u3057\u305F\u5F8C\u3082\u3001\u69CB\u6210\u3092\u5B8C\u5168\u306B\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u3092\u63D0\u4F9B\u3057\u307E\u3059\u304C\u3001\u3044\u3064\u3067\u3082\u3001\u81EA\u5206\u306E\u64CD\u4F5C\u3068\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u3067\u306E\u52D5\u4F5C\u306E\u30DE\u30C3\u30D4\u30F3\u30B0\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002","four":"Cephable \u3092\u4F7F\u7528\u3059\u308B\u3068\u304D\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5370\u5237\u3057\u3066\u7269\u7406\u7684\u306A\u30B3\u30D4\u30FC\u3092\u7528\u610F\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u307E\u3063\u305F\u304F\u65B0\u3057\u3044\u3053\u3068\u306A\u306E\u3067\u3001\u6163\u308C\u308B\u307E\u3067\u306B\u5C11\u3057\u6642\u9593\u304C\u304B\u304B\u308B\u3053\u3068\u306F\u627F\u77E5\u3057\u3066\u3044\u307E\u3059\u3002\u7DF4\u7FD2\u3059\u308C\u3070\u4E0A\u9054\u3057\u307E\u3059!","one":"Cephable\u3092\u4F7F\u3063\u3066\u3001\u3042\u308B\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5225\u306E\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3053\u3068\u3092\u3054\u5B58\u77E5\u3067\u3059\u304B\uFF1F\u30E2\u30D0\u30A4\u30EB\u3001\u30BF\u30D6\u30EC\u30C3\u30C8\u3001\u3042\u308B\u3044\u306F\u5225\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306BCephable\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3001\u64CD\u4F5C\u3057\u305F\u3044\u63A5\u7D9A\uFF08\u3053\u306E\u63A5\u7D9A\u3082\u53EF\uFF09\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u500B\u4EBA\u8A2D\u5B9A\u3068\u5165\u529B\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u306F\u3001\u3059\u3079\u3066\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u5171\u901A\u3067\u3059\uFF01\u30C7\u30D0\u30A4\u30B9\u3068\u63A5\u7D9A\u3067Cephable\u304C\u52D5\u4F5C\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"steps":{"one":"\u30B9\u30C6\u30C3\u30D7 1. \u5236\u5FA1\u3059\u308B\u30A2\u30D7\u30EA\u306E\u540D\u524D\u3092\u5165\u529B\u3057\u307E\u3059\u3002","two":"\u30B9\u30C6\u30C3\u30D7 2. \u4F7F\u7528\u3059\u308B\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002","three":"\u30B9\u30C6\u30C3\u30D73.\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09","threeContinued":"\u3088\u304F\u4F7F\u7528\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u3084\u7279\u306B\u597D\u3093\u3067\u4F7F\u7528\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u306B\u8A2D\u5B9A\u3057\u305F\u3044\u7279\u5B9A\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u3064\u3044\u3066\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4EE5\u4E0B\u306E\u3088\u3046\u306A\u308F\u304B\u308A\u3084\u3059\u3044\u82F1\u8A9E\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3059\u308B","titleLong":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3059\u308B","try":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30B8\u30A7\u30CD\u30EC\u30FC\u30BF\u3092\u8A66\u3059","placeholder":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u77ED\u304F\u3057\u3066\u304F\u3060\u3055\u3044\u3002\\n\\n\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u306B\u9032\u3080\u306B\u306F\u3001\u300C\u9032\u3080\u300D\u3068\u8A00\u3048\u3070\u3044\u3044\u3068\u601D\u3044\u307E\u3059\u3002\\n\\n\u30AB\u30FC\u30BD\u30EB\u306E\u79FB\u52D5\u306B\u306F\u982D\u306E\u52D5\u304D\u3092\u3001\u7DE8\u96C6\u306E\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u306B\u306F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3044\u305F\u3044\u3067\u3059\u3002\\n\\n\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u306E\u52D5\u304D\u3084\u80FD\u529B\u3059\u3079\u3066\u306B\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"macros":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u5165\u529B (\u982D\u3092\u50BE\u3051\u308B\u306A\u3069\u306E\u30A2\u30AF\u30B7\u30E7\u30F3) \u3068\u3001\u305D\u306E\u5165\u529B\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u8A18\u9332\u3055\u308C\u305F\u5F8C\u306B Cephable \u304C\u5B9F\u884C\u3059\u308B\u624B\u9806\u304C\u542B\u307E\u308C\u307E\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u5358\u4E00\u306E\u5165\u529B\u306B\u3088\u3063\u3066\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u308B\u624B\u9806\u306E\u7D44\u307F\u5408\u308F\u305B\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","new":"\u65B0\u3057\u3044\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","newDescription":"\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7\u3068\u5165\u529B\u3092\u7D44\u307F\u5408\u308F\u305B\u308B\u305F\u3081\u306E\u65B0\u3057\u3044\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","add":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0","create":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","name":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D","question":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u4F55\u3068\u3044\u3046\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u304B?","description":"\u5F8C\u3067\u7C21\u5358\u306B\u898B\u3064\u3051\u3089\u308C\u308B\u3088\u3046\u306B\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u3002","placeholder":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u300C\u30B8\u30E3\u30F3\u30D7\u300D\u3084\u300C\u30BA\u30FC\u30E0\u30A4\u30F3\u300D\u306A\u3069\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u3066\u3044\u308B"},"empty":"\u307E\u3060\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","copySuffix":"{{name}}_\u30B3\u30D4\u30FC"},"event":{"title":"\u30B9\u30C6\u30C3\u30D7","titlePlural":"\u624B\u9806","previewSummaryPlural":"{{first}} \u304A\u3088\u3073 {{total}} \u4EF6\u306E\u4ED6\u306E\u30A4\u30D9\u30F3\u30C8","add":"\u30B9\u30C6\u30C3\u30D7\u3092\u8FFD\u52A0","stepType":"\u30B9\u30C6\u30C3\u30D7\u30BF\u30A4\u30D7","select":"\u8FFD\u52A0\u3059\u308B\u30B9\u30C6\u30C3\u30D7\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002","question":"Cephable \u306B\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3055\u305B\u305F\u3044\u3067\u3059\u304B?","setup":"\u30B9\u30C6\u30C3\u30D7\u3092\u8A2D\u5B9A\u3059\u308B","description":"\u30B9\u30C6\u30C3\u30D7\u306F\u3001\u5165\u529B\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u305F\u5F8C\u306B Cephable \u304C\u5B9F\u884C\u3059\u308B\u30A2\u30AF\u30B7\u30E7\u30F3\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u8FFD\u52A0\u3057\u3066\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u7D44\u307F\u5408\u308F\u305B\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","expand":"\u5C55\u958B\u3057\u3066\u6B8B\u308A\u306E\u624B\u9806\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044","stepUp":"\u30B9\u30C6\u30C3\u30D7\u30A2\u30C3\u30D7","stepDown":"\u30B9\u30C6\u30C3\u30D7\u30C0\u30A6\u30F3","stepCopy":"\u30B3\u30D4\u30FC\u30B9\u30C6\u30C3\u30D7","stepRemove":"\u30B9\u30C6\u30C3\u30D7\u3092\u524A\u9664","insertStep":"\u4EE5\u4E0B\u306B\u624B\u9806\u3092\u633F\u5165","showOptions":"\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8868\u793A","hideOptions":"\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u975E\u8868\u793A","hold":"\u30DB\u30FC\u30EB\u30C9\u6642\u9593\uFF08\u30DF\u30EA\u79D2\uFF09","error":"\u30B9\u30C6\u30C3\u30D7\u3092\u69CB\u6210\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","multiple":"\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7","deviceTypeCustomAction":{"title":"\u30AB\u30B9\u30BF\u30E0\u30C7\u30D0\u30A4\u30B9\u30A2\u30AF\u30B7\u30E7\u30F3"},"keyPress":{"title":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044","short":"\u30D7\u30EC\u30B9","fieldSet":"\u62BC\u3059\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","label":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","holdTime":"\u30AD\u30FC\u3092\u62BC\u3057\u7D9A\u3051\u308B\u6642\u9593\uFF08\u30DF\u30EA\u79D2\uFF09","description":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3092\u4F7F\u308F\u305A\u306B\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u62BC\u3059\u52D5\u4F5C\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u7269\u7406\u7684\u306A\u30AD\u30FC\u3092\u62BC\u3059\u306E\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u5225\u306E\u5165\u529B\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EEE\u60F3\u7684\u306B\u30AD\u30FC\u3092\u300C\u62BC\u3059\u300D\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u300CEnter\u300D\u3068\u8A00\u3048\u3070\u3001Enter \u30AD\u30FC\u3092\u7269\u7406\u7684\u306B\u62BC\u3055\u305A\u306B\u96FB\u5B50\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3067\u304D\u307E\u3059\u3002","timing":"\u30AD\u30FC\u3092\u62BC\u3059\u30BF\u30A4\u30DF\u30F3\u30B0","tap":"\u30BF\u30C3\u30D7","tapLong":"\u30BF\u30C3\u30D7\u30DC\u30BF\u30F3","latch":"\u30E9\u30C3\u30C1","latchLong":"\u89E3\u653E\u3055\u308C\u308B\u307E\u3067\u4FDD\u6301\u3059\u308B","hold":"\u6240\u6709","holdLong":"\u4E00\u5B9A\u6642\u9593\u4FDD\u6301\u3059\u308B","toggle":"\u5207\u308A\u66FF\u3048","toggleLong":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5207\u308A\u66FF\u3048","release":"\u30EA\u30EA\u30FC\u30B9","releaseLong":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30EA\u30EA\u30FC\u30B9","latchLabel":"\u89E3\u653E\u3055\u308C\u308B\u307E\u3067<strong>{{value}}</strong>\u3092\u4FDD\u6301\u3057\u307E\u3059","tapLabel":"<strong>{{value}}</strong>\u3092\u30BF\u30C3\u30D7","pressLabel":"<strong>{{value}}</strong>\u3092<strong>{{time}}</strong>\u30DF\u30EA\u79D2\u9593\u62BC\u3057\u307E\u3059","remove":"\u30AD\u30FC\u306E\u62BC\u4E0B\u3092\u89E3\u9664","add":"\u62BC\u3059\u30AD\u30FC/\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0"},"keyRelease":{"title":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3\u3092\u96E2\u3059","short":"\u30EA\u30EA\u30FC\u30B9","selected":"\u30EA\u30EA\u30FC\u30B9\u3059\u308B\u30AD\u30FC\u3092\u9078\u629E","description":"\u62BC\u3057\u305F\u307E\u307E\u306B\u3057\u3066\u3044\u305F\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u653E\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u653E\u3059\u52D5\u4F5C\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3057\u307E\u3059\u3002\u30AD\u30FC\u3092\u7121\u671F\u9650\u306B\u62BC\u3057\u7D9A\u3051\u308B\u64CD\u4F5C\u3068\u7D44\u307F\u5408\u308F\u305B\u3066\u4F7F\u7528\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u7269\u7406\u7684\u306A\u30AD\u30FC\u3092\u62BC\u3059\u306E\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u5225\u306E\u5165\u529B\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EEE\u60F3\u7684\u306B\u30AD\u30FC\u3092\u300C\u653E\u3059\u300D\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u5B9F\u884C\u3092\u505C\u6B62\u3059\u308B\u306B\u306F\u3001\u300CToggle Run\u300D\u3068\u8A00\u3063\u305F\u5F8C\u306B\u300CStop\u300D\u3068\u8A00\u3044\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u3092\u30EA\u30EA\u30FC\u30B9","add":"\u30EA\u30EA\u30FC\u30B9\u306B\u30AD\u30FC/\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0","remove":"\u30AD\u30FC\u30EA\u30EA\u30FC\u30B9\u3092\u524A\u9664\u3059\u308B"},"keyToggle":{"title":"\u30C8\u30B0\u30EB\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","short":"\u30C8\u30B0\u30EB","selected":"\u5207\u308A\u66FF\u3048\u308B\u30AD\u30FC\u3092\u9078\u629E","description":"\u5358\u4E00\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3001\u7167\u660E\u30B9\u30A4\u30C3\u30C1\u306E\u3088\u3046\u306B\u30AD\u30FC\u30DC\u30FC\u30C9\u306E\u30AD\u30FC\u3092\u30AA\u30F3\u307E\u305F\u306F\u30AA\u30D5\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3053\u308C\u306F\u3001\u30B9\u30A4\u30C3\u30C1\u306E\u3088\u3046\u306B\u3001\u30AD\u30FC\u306E\u6A5F\u80FD\u3092\u30AA\u30F3\u307E\u305F\u306F\u30AA\u30D5\u306B\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30AD\u30FC\u3092\u4E0D\u5B9A\u306E\u6642\u9593\u62BC\u3057\u305F\u307E\u307E\u306B\u3057\u3066\u304A\u304F\u5834\u5408\u306B\u4FBF\u5229\u3067\u3059\u3002\u3053\u308C\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30AD\u30FC\u306E\u62BC\u4E0B\u3068\u30AD\u30FC\u306E\u30EA\u30EA\u30FC\u30B9\u307E\u305F\u306F\u505C\u6B62\u306E\u4E21\u65B9\u306B\u5BFE\u3057\u3066\u540C\u3058\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u7DAD\u6301\u3067\u304D\u307E\u3059\u3002","example":"\u8D70\u308A\u59CB\u3081\u308B\u306B\u306F\u300CToggle Run\u300D\u3068\u8A00\u3044\u307E\u3059\u3002\u8D70\u308A\u3092\u6B62\u3081\u308B\u306B\u306F\u300CToggle Run\u300D\u3068\u8A00\u3044\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u3092\u5207\u308A\u66FF\u3048\u308B","add":"\u30C8\u30B0\u30EB\u306B\u30AD\u30FC/\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0","remove":"\u30AD\u30FC\u30C8\u30B0\u30EB\u306E\u524A\u9664"},"pause":{"title":"\u4E00\u6642\u505C\u6B62","description":"\u30A2\u30AF\u30B7\u30E7\u30F3\u9593\u306B\u77ED\u3044\u9045\u5EF6\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u9593\u306B\u77ED\u3044\u9045\u5EF6\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u6B21\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3059\u308B\u524D\u306B 1 \u3064\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B8C\u5168\u306B\u5B8C\u4E86\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u72B6\u6CC1\u3067\u306F\u4E0D\u53EF\u6B20\u3067\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5185\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u592A\u5B57\u306B\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u6700\u521D\u306B\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u4E00\u6642\u505C\u6B62\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u6B21\u306E\u624B\u9806\u306B\u9032\u3080\u524D\u306B\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u304C\u958B\u3044\u3066\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u308B\u307E\u3067\u306E\u5341\u5206\u306A\u6642\u9593\u3092\u78BA\u4FDD\u3067\u304D\u308B\u305F\u3081\u3001\u30B9\u30E0\u30FC\u30BA\u3067\u30A8\u30E9\u30FC\u306E\u306A\u3044\u64CD\u4F5C\u304C\u4FDD\u8A3C\u3055\u308C\u307E\u3059\u3002","example":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u7DE8\u96C6\u3057\u3066\u3044\u308B\u3068\u3057\u307E\u3059\u3002\u300C\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u5F0F\u8A2D\u5B9A\u300D\u3068\u8A00\u3046\u3068\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u304C\u958B\u304D\u307E\u3059\u3002\u6B21\u306B\u3001\u30E1\u30CB\u30E5\u30FC\u304C\u5B8C\u5168\u306B\u8868\u793A\u3055\u308C\u308B\u307E\u3067\u5C11\u3057\u5F85\u3063\u3066\u304B\u3089\u3001\u300C\u592A\u5B57\u300D\u3068\u8A00\u3046\u3068\u3001\u9078\u629E\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u306B\u592A\u5B57\u306E\u66F8\u5F0F\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u4E00\u6642\u505C\u6B62\u6A5F\u80FD\u306B\u3088\u308A\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8 \u30E1\u30CB\u30E5\u30FC\u304C\u6B21\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u53D7\u3051\u4ED8\u3051\u308B\u6E96\u5099\u304C\u6574\u3044\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u30DF\u30EA\u79D2\u9593\u4E00\u6642\u505C\u6B62\u3057\u307E\u3059"},"type":{"title":"\u30BF\u30A4\u30D7","field":"\u5165\u529B\u3059\u308B\u30D5\u30EC\u30FC\u30BA","placeholder":"\u5165\u529B\u3057\u305F\u30D5\u30EC\u30FC\u30BA","question":"\u3069\u306E\u3088\u3046\u306A\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u304B?","description":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3092\u4F7F\u7528\u3059\u308B\u306E\u3068\u540C\u3058\u3088\u3046\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u307E\u3059\u3002","longDescription":"\u3053\u308C\u306F\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u3067\u306E\u5165\u529B\u3068\u540C\u69D8\u306B\u3001\u30C6\u30AD\u30B9\u30C8\u6587\u5B57\u5217\u306E\u5165\u529B\u3092\u6A21\u5023\u3057\u307E\u3059\u3002\u5404\u30AD\u30FC\u3092\u62BC\u3055\u305A\u306B\u9577\u3044\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u306E\u306B\u6700\u9069\u3067\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u3092\u52D5\u7684\u306B\u5165\u529B\u3059\u308B\u5834\u5408\u306F\u3001\u4EE3\u308F\u308A\u306B\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u6A5F\u80FD\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","example":"\u300C\u540D\u524D\u300D\u3068\u8A00\u3046\u3068\u3001\u30C1\u30E3\u30C3\u30C8 \u30A6\u30A3\u30F3\u30C9\u30A6\u306B\u300C\u3053\u3093\u306B\u3061\u306F\u3001\u79C1\u306E\u540D\u524D\u306F Ellen Ripley \u3067\u3059\u3002\u300D\u3068\u5165\u529B\u3067\u304D\u307E\u3059\u3002","label":"<strong>{{value}}</strong>\u3068\u5165\u529B"},"mouseMove":{"title":"\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059","description":"\u753B\u9762\u4E0A\u3067\u30DD\u30A4\u30F3\u30BF\u30FC\u3092\u79FB\u52D5\u3057\u307E\u3059\u3002","longDescription":"\u7269\u7406\u7684\u306A\u30DE\u30A6\u30B9\u3092\u4F7F\u308F\u305A\u306B\u3001\u753B\u9762\u306E\u30AB\u30FC\u30BD\u30EB\u3084\u30DD\u30A4\u30F3\u30BF\u30FC\u3092\u79FB\u52D5\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u624B\u306E\u53EF\u52D5\u6027\u304C\u9650\u3089\u308C\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u306B\u3068\u3063\u3066\u7279\u306B\u4FBF\u5229\u3067\u3059\u3002\u3053\u308C\u306F\u3001\u4E00\u90E8\u306E\u30B2\u30FC\u30E0\u3067\u5FC5\u8981\u306A\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u306E\u7D30\u304B\u3044\u5236\u5FA1\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002\u982D\u306E\u52D5\u304D\u3092\u4F7F\u7528\u3057\u3066\u3059\u3079\u3066\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3059\u308B\u5834\u5408\u306F\u3001\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3067\u300C\u30DE\u30A6\u30B9\u5236\u5FA1\u306E\u305F\u3081\u306E\u982D\u306E\u52D5\u304D\u300D\u3092\u8A66\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u300C\u30DE\u30A6\u30B9\u3092\u53F3\u306B\u79FB\u52D5\u300D\u3068\u8A00\u3046\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u304C 100 \u30D4\u30AF\u30BB\u30EB\u53F3\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","moveX":"\u30DE\u30A6\u30B9\u3092\u5DE6/\u53F3\u306B\u30D4\u30AF\u30BB\u30EB\u79FB\u52D5","numberMoveX":"\u5DE6/\u53F3\u306B\u79FB\u52D5\u3059\u308B\u30D4\u30AF\u30BB\u30EB\u6570","moveY":"\u30DE\u30A6\u30B9\u3092\u4E0A\u4E0B\u306B\u30D4\u30AF\u30BB\u30EB\u79FB\u52D5","numberMoveY":"\u4E0A/\u4E0B\u306B\u79FB\u52D5\u3059\u308B\u30D4\u30AF\u30BB\u30EB\u6570","label":"\u30DE\u30A6\u30B9\u3092<strong>{{value}}</strong>\u56DE\u52D5\u304B\u3059","command":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5: {{command}}","commandLabel":"\u30DE\u30A6\u30B9\u79FB\u52D5","startCommand":"\u30DE\u30A6\u30B9\u79FB\u52D5\u958B\u59CB","stopCommand":"\u30DE\u30A6\u30B9\u79FB\u52D5\u505C\u6B62"},"joystickMove":{"title":"\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","description":"\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u4F7F\u7528\u3057\u3066\u753B\u9762\u4E0A\u306E\u3082\u306E\u3092\u79FB\u52D5\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u52D5\u304D\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30C8\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u7269\u7406\u7684\u306A\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u4F7F\u7528\u304C\u96E3\u3057\u3044\u5834\u5408\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u5225\u306E\u5165\u529B\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u4EEE\u60F3\u7684\u306B\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","example":"\u300C\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u5DE6\u306B\u52D5\u304B\u3057\u3066\u300D\u3068\u8A00\u3046\u3068\u3001\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u304C 100 \u30D4\u30AF\u30BB\u30EB\u5DE6\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","prefix":"\u5DE6\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","left":"\u5DE6\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF","leftX":"\u5DE6X","leftY":"\u5DE6Y","right":"\u53F3\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF","rightX":"\u53F3X","rightY":"\u53F3Y","x":"X\u8EF8\u306E\u5F37\u5EA6","y":"Y\u8EF8\u306E\u5F37\u5EA6","moveXLabel":"X \u306B\u79FB\u52D5: {{value}}","moveYLabel":"Y \u65B9\u5411\u306B\u79FB\u52D5: {{value}}","labelLeft":"\u5DE6\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","labelRight":"\u53F3\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3092\u52D5\u304B\u3059","latch":"\u30E9\u30C3\u30C1\u306F\u3001\u300C\u3059\u3079\u3066\u505C\u6B62\u300D\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u89E3\u653E\u3055\u308C\u308B\u307E\u3067\u4F4D\u7F6E\u3092\u4FDD\u6301\u3057\u307E\u3059\u3002"},"playAudio":{"title":"\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u518D\u751F","placeholder":"Cephable\u304C\u8A00\u3046\u3067\u3042\u308D\u3046\u767A\u8A00\u306E\u30D5\u30EC\u30FC\u30BA","description":"\u97F3\u3001\u5358\u8A9E\u3001\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA\u3092\u518D\u751F\u3057\u307E\u3059\u3002","longDescription":"\u3053\u306E\u6A5F\u80FD\u306B\u3088\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u5165\u529B\u3057\u305F\u30D5\u30EC\u30FC\u30BA\u3092\u97F3\u58F0\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u8A71\u3059\u3053\u3068\u304C\u56F0\u96E3\u306A\u4EBA\u306B\u3068\u3063\u3066\u7279\u306B\u4FBF\u5229\u3067\u3059\u3002\u30D5\u30EC\u30FC\u30BA\u3092\u5165\u529B\u3059\u308B\u3068\u3001PlayAudio \u6A5F\u80FD\u306B\u3088\u308A\u5408\u6210\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u30C6\u30AD\u30B9\u30C8\u304C\u8AAD\u307F\u4E0A\u3052\u3089\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3084\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u53E3\u982D\u3067\u60C5\u5831\u3092\u4F1D\u3048\u308B\u5FC5\u8981\u304C\u3042\u308B\u304C\u81EA\u5206\u306E\u58F0\u3092\u4F7F\u7528\u3059\u308B\u4EE3\u308F\u308A\u306B\u5225\u306E\u65B9\u6CD5\u3092\u597D\u3080\u3001\u307E\u305F\u306F\u5FC5\u8981\u3068\u3059\u308B\u72B6\u6CC1\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002","example":"\u7B11\u9854\u3067\u300CHello\u300D\u3068\u3044\u3046\u8A00\u8449\u3092\u6F14\u594F\u3057\u307E\u3059\u3002","label":"<strong>\\"{{value}}\\"</strong>\u3068\u767A\u97F3\u3059\u308B"},"stopOutputs":{"title":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62","titleLong":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62\u3057\u307E\u3059\uFF08\u3059\u3079\u3066\u306E\u30AD\u30FC\u3068\u30DC\u30BF\u30F3\u3092\u653E\u3057\u3001\u3059\u3079\u3066\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u505C\u6B62\u3057\u3001\u3059\u3079\u3066\u306E\u5165\u529B\u3092\u505C\u6B62\u3057\u307E\u3059\uFF09","description":"\u30AD\u30FC\u306E\u62BC\u4E0B\u306A\u3069\u3001\u9032\u884C\u4E2D\u306E\u3059\u3079\u3066\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u3057\u307E\u3059\u3002","longDescription":"\u9032\u884C\u4E2D\u306E\u51FA\u529B\u307E\u305F\u306F\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u3059\u3079\u3066\u76F4\u3061\u306B\u505C\u6B62\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30D7\u30ED\u30BB\u30B9\u3092\u505C\u6B62\u3059\u308B\u305F\u3081\u306E\u5B89\u5168\u6A5F\u80FD\u307E\u305F\u306F\u5229\u4FBF\u6027\u6A5F\u80FD\u3067\u3059\u3002\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30DE\u30A4\u30AF\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u9589\u3058\u308B\u304B\u4E00\u6642\u505C\u6B62\u3059\u308B\u3068\u3001\u81EA\u52D5\u7684\u306B\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002","example":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62\u3059\u308B\u306B\u306F\u3001\u300C\u505C\u6B62\u300D\u3068\u8A00\u3044\u307E\u3059\u3002","label":"\u3059\u3079\u3066\u306E\u51FA\u529B\u3092\u505C\u6B62\u3057\u3001\u30AD\u30FC\u3092\u653E\u3057\u307E\u3059"},"custom":{"title":"\u30AB\u30B9\u30BF\u30E0"},"options":{"moveUp":"\u4E0A\u3078\u79FB\u52D5","moveDown":"\u4E0B\u306B\u79FB\u52D5","moveLeft":"\u5DE6\u306B\u79FB\u52D5","moveRight":"\u53F3\u306B\u79FB\u52D5","copyStep":"\u30B3\u30D4\u30FC\u30B9\u30C6\u30C3\u30D7","removeStep":"\u30B9\u30C6\u30C3\u30D7\u3092\u524A\u9664"},"directions":{"up":"\u4E0A","down":"\u4E0B","left":"\u5DE6","right":"\u53F3"}},"expression":{"title":"\u8868\u60C5","titlePlural":"\u8868\u60C5","label":"\u8868\u60C5\u30FB\u8EAB\u632F\u308A","start":"\u5F0F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u958B\u59CB","startSmiling":{"title":"\u7B11\u9854\u3092\u59CB\u3081\u307E\u3057\u3087\u3046","description":"\u6700\u521D\u306F\u7B11\u3063\u3066\u3044\u306A\u304B\u3063\u305F\u306E\u306B\u3001\u305D\u306E\u5F8C\u7B11\u9854\u306B\u306A\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3001\u53E3\u306E\u958B\u9589\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"stopSmiling":{"title":"\u7B11\u3046\u306E\u3092\u3084\u3081\u3066","description":"\u7B11\u3063\u3066\u3044\u3066\u3001\u305D\u306E\u5F8C\u7B11\u9854\u3092\u3084\u3081\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3001\u53E3\u306E\u958B\u9589\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"eyebrows":{"title":"\u7709\u3092\u4E0A\u3052\u308B","description":"\u4E21\u65B9\u306E\u7709\u6BDB\u3092\u57FA\u672C\u306E\u4F11\u606F\u4F4D\u7F6E\u304B\u3089\u4E0A\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"openMouth":{"title":"\u53E3\u3092\u958B\u3051\u308B","description":"\u53E3\u304C\u9589\u3058\u3066\u3044\u308B\u5834\u5408\uFF08\u307E\u305F\u306F\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u304C\u308F\u305A\u304B\u306B\u958B\u3044\u3066\u3044\u308B\u5834\u5408\uFF09\u3001\u3055\u3089\u306B\u53E3\u3092\u958B\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B9\u30DE\u30A4\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"closeMouth":{"title":"\u53E3\u3092\u9589\u3058\u308B","description":"\u53E3\u304C\u958B\u3044\u3066\u3044\u308B\u72B6\u614B\u3067\u5B8C\u5168\u306B\u9589\u3058\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002\u6CE8\u610F: \u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B9\u30DE\u30A4\u30EB \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u540C\u3058\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F7F\u7528\u3059\u308B\u3068\u3001\u7AF6\u5408\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"description":"\u8868\u60C5\u3067\u30C7\u30B8\u30BF\u30EB\u4F53\u9A13\u3092\u30EF\u30F3\u30E9\u30F3\u30AF\u30A2\u30C3\u30D7\u3002\u7709\u3092\u4E0A\u3052\u308B\u3001\u7B11\u9854\u3092\u4F5C\u308B\u3001\u305D\u306E\u4ED6\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3092\u4F7F\u3063\u3066\u3001\u30DE\u30A6\u30B9\u30DD\u30A4\u30F3\u30BF\u30FC\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u64CD\u4F5C\u3057\u305F\u308A\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u305F\u308A\u3001\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"head":{"title":"\u982D\u306E\u52D5\u304D","titlePlural":"\u982D\u306E\u52D5\u304D","label":"\u982D/\u4F53\u306E\u52D5\u304D","question":"\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u52D5\u304D\u3092\u4F7F\u3044\u305F\u3044\u3067\u3059\u304B?","tilt":{"title":"\u982D\u3092\u50BE\u3051\u308B","left":{"title":"\u982D\u3092\u5DE6\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u5DE6\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u982D\u3092\u53F3\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u53F3\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"back":{"title":"\u982D\u3092\u5F8C\u308D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u982D\u3092\u5F8C\u308D\u306B\u50BE\u3051\u3066\u4E0A\u3092\u898B\u4E0A\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"forward":{"title":"\u982D\u3092\u524D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u982D\u3092\u524D\u306B\u50BE\u3051\u3066\u4E0B\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"description":"\u982D\u3092\u5DE6\u307E\u305F\u306F\u53F3\u306B\u50BE\u3051\u308B\u3068\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30DE\u30A6\u30B9\u306E\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u304C\u5F37\u5316\u3055\u308C\u307E\u3059\u3002"},"turn":{"title":"\u30D8\u30C3\u30C9\u30BF\u30FC\u30F3","left":{"title":"\u982D\u3092\u5DE6\u306B\u5411\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u56DE\u3057\u3066\u5DE6\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u982D\u3092\u53F3\u306B\u5411\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u982D\u3092\u56DE\u3057\u3066\u53F3\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30DE\u30A6\u30B9\u306E\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3092\u5F37\u5316\u3059\u308B\u306B\u306F\u3001\u982D\u3092\u5DE6\u307E\u305F\u306F\u53F3\u306B\u56DE\u3057\u307E\u3059\u3002"},"lean":{"title":"\u30D8\u30C3\u30C9\u30EA\u30FC\u30F3","left":{"title":"\u982D\u3092\u5DE6\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u5DE6\u306B\u50BE\u304D\u3001\u9854\u304C\u30AB\u30E1\u30E9 \u30D5\u30EC\u30FC\u30E0\u5185\u3067\u3055\u3089\u306B\u5DE6\u306B\u6765\u308B\u3088\u3046\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u982D\u3092\u53F3\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u53F3\u306B\u50BE\u304D\u3001\u9854\u304C\u30AB\u30E1\u30E9 \u30D5\u30EC\u30FC\u30E0\u5185\u3067\u3055\u3089\u306B\u53F3\u5074\u306B\u6765\u308B\u3088\u3046\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"back":{"title":"\u982D\u3092\u5F8C\u308D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3064\u3081\u3066\u3044\u308B\u3068\u304D\u306B\u3001\u5F8C\u308D\u306B\u50BE\u3044\u3066\u9854\u304C\u30AB\u30E1\u30E9\u304B\u3089\u9060\u3056\u304B\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"forward":{"title":"\u982D\u3092\u524D\u306B\u50BE\u3051\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u9854\u3092\u30AB\u30E1\u30E9\u306B\u8FD1\u3065\u3051\u308B\u305F\u3081\u306B\u524D\u306B\u50BE\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"up":{"title":"\u30DC\u30C7\u30A3\u3092\u4E0A\u306B\u79FB\u52D5","description":"\u30AB\u30E1\u30E9\u3092\u898B\u306A\u304C\u3089\u3001\u9996\u3092\u4F38\u3070\u3057\u305F\u308A\u3001\u4F53\u5168\u4F53\u3092\u4E0A\u306B\u52D5\u304B\u3057\u305F\u308A\u3057\u3066\u982D\u3092\u4E0A\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"down":{"title":"\u672C\u6587\u3092\u4E0B\u306B\u79FB\u52D5","description":"\u30AB\u30E1\u30E9\u3092\u898B\u306A\u304C\u3089\u3001\u9996\u3092\u3059\u304F\u3081\u305F\u308A\u3001\u3057\u3083\u304C\u3093\u3060\u308A\u3001\u4F53\u5168\u4F53\u3092\u4E0B\u3052\u305F\u308A\u3057\u3066\u982D\u3092\u4E0B\u3052\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"center":{"title":"\u982D\u3092\u96C6\u4E2D\u3055\u305B\u308B","description":"\u30AB\u30E1\u30E9\u3092\u898B\u3066\u3001\u982D\u3092\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u306B\u4E00\u81F4\u3059\u308B\u4E2D\u5FC3\u4F4D\u7F6E\u306B\u623B\u3059\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"description":"\u982D\u3092\u5DE6\u307E\u305F\u306F\u53F3\u306B\u50BE\u3051\u308B\u3068\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30DE\u30A6\u30B9\u64CD\u4F5C\u304C\u5F37\u5316\u3055\u308C\u307E\u3059\u3002"},"description":"\u982D\u3092\u50BE\u3051\u308B\u3001\u3046\u306A\u305A\u304F\u3001\u56DE\u3059\u3068\u3044\u3063\u305F\u52D5\u304D\u3067\u3001\u30C7\u30D0\u30A4\u30B9\u3084\u63A5\u7D9A\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002Cephable\u306F\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u3067\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u5B88\u308A\u306A\u304C\u3089\u76F4\u611F\u7684\u306A\u64CD\u4F5C\u6027\u3092\u5B9F\u73FE\u3057\u3001\u9AD8\u5EA6\u306A\u64CD\u4F5C\u3084\u30DE\u30A6\u30B9\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"voice":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","placeholder":"Cephable\u304C\u805E\u304D\u53D6\u308B\u97F3\u58F0\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA","question":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5BFE\u3057\u3066\u3069\u306E\u3088\u3046\u306A\u30B9\u30C6\u30FC\u30C8\u30E1\u30F3\u30C8\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA\u3092\u4F1D\u3048\u305F\u3044\u3067\u3059\u304B?","when":"\u79C1\u304C\u8A00\u3046\u3068...","say":"\u300C{{value}}\u300D\u3068\u767A\u97F3\u3059\u308B","load":{"fail":{"title":"{{language}} \u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093","description":"\u3042\u3042\u3001\u5927\u5909\uFF01\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u7528\u306E {{language}} \u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u63A5\u7D9A\u304C\u56DE\u5FA9\u3059\u308B\u307E\u3067\u82F1\u8A9E (\u7C73\u56FD) \u3092\u4F7F\u7528\u3057\u307E\u3059\u3002"}},"description":"\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3059\u308B\u3068\u3001\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u3067\u81EA\u7136\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u304C\u4F7F\u7528\u53EF\u80FD\u306B\u306A\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u554F\u308F\u305A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u81EA\u7136\u306A\u767A\u58F0\u3067\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3057\u305F\u308A\u3001\u30C6\u30AD\u30B9\u30C8\u3092\u97F3\u58F0\u5165\u529B\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u3067\u3001\u7C21\u5358\u304B\u3064\u76F4\u611F\u7684\u306A\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"motion":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","question":"\u643A\u5E2F\u96FB\u8A71\u3084\u30BF\u30D6\u30EC\u30C3\u30C8\u3067\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u305F\u3044\u3067\u3059\u304B?","start":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u958B\u59CB","settings":"\u30E2\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A","descriptionShort":"\u30C7\u30D0\u30A4\u30B9\u3092\u50BE\u3051\u305F\u308A\u3001\u56DE\u3057\u305F\u308A\u3001\u632F\u3063\u305F\u308A\u3057\u3066 Cephable \u3092\u5236\u5FA1\u3057\u307E\u3059\u3002","description":"\u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3 \u30A2\u30D7\u30EA\u3067\u306E\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3084\u30BF\u30D6\u30EC\u30C3\u30C8\u306E\u52D5\u304D\u3092\u30C7\u30D0\u30A4\u30B9\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u3055\u307E\u3056\u307E\u306A\u65B9\u5411\u306B\u50BE\u3051\u305F\u308A\u632F\u3063\u305F\u308A\u3057\u3066\u3001\u65B0\u3057\u3044\u51FA\u529B\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","up":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u4E0A\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u81EA\u5206\u306E\u65B9\u3092\u5411\u304F\u3088\u3046\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002"},"down":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u4E0B\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u81EA\u5206\u304B\u3089\u9060\u3056\u304B\u308B\u3088\u3046\u306B\u4E0B\u306B\u50BE\u3051\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002"},"left":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u5DE6\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u5DE6\u306B\u50BE\u3051\u3066\u5DE6\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"right":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u53F3\u306B\u50BE\u3051\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u304C\u5E73\u3089\u306A\u9762\u306B\u7F6E\u304B\u308C\u3001\u53F3\u306B\u50BE\u3051\u3066\u53F3\u3092\u5411\u304F\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002"},"shake":{"title":"\u30C7\u30D0\u30A4\u30B9\u3092\u632F\u308B","description":"\u30C7\u30D0\u30A4\u30B9\u3092\u632F\u308B\u3068\u3001\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002"},"edit":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A\u3092\u7DE8\u96C6","description":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u8A2D\u5B9A\u3092\u5909\u66F4\u3057\u3066\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u3067\u30E9\u30F3\u30CB\u30F3\u30B0\u4E2D\u306B\u643A\u5E2F\u96FB\u8A71\u3092\u3069\u308C\u3060\u3051\u52D5\u304B\u3059\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","sensitivity":{"title":"\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u611F\u5EA6\u8A2D\u5B9A","description":"\u611F\u5EA6\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u3069\u306E\u7A0B\u5EA6\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092 Cephable \u306B\u4F1D\u3048\u307E\u3059\u3002\u5024\u304C\u5927\u304D\u3044\u307B\u3069 (\u30B9\u30E9\u30A4\u30C0\u30FC\u306E\u53F3\u7AEF)\u3001\u611F\u5EA6\u304C\u9AD8\u304F\u306A\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u50BE\u3051\u308B\u5FC5\u8981\u304C\u5C11\u306A\u304F\u306A\u308A\u307E\u3059\u3002"},"tilt":{"title":"\u50BE\u304D\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u5165\u529B\u304C\u8A8D\u8B58\u3055\u308C\u308B\u305F\u3081\u306B\u30C7\u30D0\u30A4\u30B9\u3092\u4E0A\u4E0B\u5DE6\u53F3\u306B\u3069\u306E\u7A0B\u5EA6\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002"},"mouse":{"title":"\u30DE\u30A6\u30B9\u79FB\u52D5\u306E\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u305F\u3081\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u304B\u3069\u3046\u304B\u3001\u307E\u305F\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","enable":{"title":"\u30DE\u30A6\u30B9\u79FB\u52D5\u306E\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C8\u30EA\u30AC\u30FC \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4EE3\u308F\u308A\u306B\u3001\u4E00\u90E8\u306E\u30E2\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","option":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u30E2\u30FC\u30B7\u30E7\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"invert":{"title":"\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2","description":"X \u8EF8\u306E\u5834\u5408: \u3053\u308C\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u3001\u30DE\u30A6\u30B9\u3092\u5DE6\u306B\u52D5\u304B\u3059\u3068\u53F3\u306B\u79FB\u52D5\u3057\u3001\u53F3\u306B\u52D5\u304B\u3059\u3068\u5DE6\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002Y \u8EF8\u306E\u5834\u5408: \u3053\u308C\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u3001\u30DE\u30A6\u30B9\u3092\u4E0B\u306B\u52D5\u304B\u3059\u3068\u4E0A\u306B\u79FB\u52D5\u3057\u3001\u4E0A\u306B\u52D5\u304B\u3059\u3068\u4E0B\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","x":"X\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?","y":"Y\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?"}}}},"keys":{"title":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","titlePlural":"\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3","label":"\u5916\u90E8\u30AD\u30FC/\u30DC\u30BF\u30F3","question":"\u3069\u306E\u30AD\u30FC\u307E\u305F\u306F\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u307E\u3059\u304B?","edit":"\u30AD\u30FC\u3068\u30DC\u30BF\u30F3\u3092\u7DE8\u96C6\u3059\u308B","defaultOption":"\u30AD\u30FC\u3068\u30DE\u30A6\u30B9\u306E\u30AF\u30EA\u30C3\u30AF\u306B\u5BFE\u3059\u308B\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u542B\u3081\u307E\u3059\u304B?","description":"\u30AD\u30FC\u3068\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u306E\u30DC\u30BF\u30F3\u306E\u62BC\u4E0B\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3067\u304D\u307E\u3059\u3002","then":"Cephable \u306F... \u3092\u62BC\u3057\u307E\u3059\u3002","empty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30AD\u30FC\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","backspace":"\u30D0\u30C3\u30AF\u30B9\u30DA\u30FC\u30B9","delete":"\u6D88\u53BB","enter":"\u5165\u529B","space":"\u30B9\u30DA\u30FC\u30B9\u30D0\u30FC","tab":"\u30BF\u30D6","shift":"\u30B7\u30D5\u30C8","ctrl":"Ctrl","leftCtrl":"\u5DE6Ctrl","rightCtrl":"\u53F3Ctrl","leftShift":"\u5DE6\u30B7\u30D5\u30C8","rightShift":"\u53F3\u30B7\u30D5\u30C8","alt":"\u5168\u3066","leftAlt":"\u5DE6Alt","escape":"\u9003\u3052\u308B","up":"\u4E0A\u77E2\u5370","down":"\u4E0B\u77E2\u5370","left":"\u5DE6\u77E2\u5370","right":"\u53F3\u77E2\u5370","command":"\u6307\u793A","caps":"\u30AD\u30E3\u30C3\u30D7\u30B9\u30ED\u30C3\u30AF","reset":{"title":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B","confirm":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u3092\u3059\u3079\u3066\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059\u304B\uFF1F","confirmDescription":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u306E\u30EA\u30BB\u30C3\u30C8\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u64CD\u4F5C\u306F\u4FDD\u5B58\u3057\u306A\u3044\u3068\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","confirmButton":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B","defaultOption":"\u73FE\u5728\u306E\u8A00\u8A9E\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u5024\u306B\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059","emptyOption":"\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u7A7A\u306B\u3059\u308B\uFF08\u3059\u3079\u3066\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u30AF\u30EA\u30A2\u3059\u308B\uFF09"}},"talkback":{"title":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF","question":"Cephable \u306B\u4F55\u3092\u8A00\u3063\u3066\u3082\u3089\u3044\u305F\u3044\u3067\u3059\u304B?","description":"Cephable \u306B\u8A71\u3057\u304B\u3051\u308B\u305F\u3081\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002\u8A71\u3057\u304B\u3051\u305F\u3044\u3055\u307E\u3056\u307E\u306A\u30D5\u30EC\u30FC\u30BA\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5272\u308A\u5F53\u3066\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","thenMacro":"\u3059\u308B\u3068\u3001Cephable \u306F\u3053\u3046\u8A00\u3044\u307E\u3059...","empty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","add":"\u65B0\u3057\u3044\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B","remove":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664","edit":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6\u3059\u308B","deprecatedNotice":"Talkback \u306F\u3001\u4E3B\u8981\u306A\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u76F4\u63A5\u7D71\u5408\u3055\u308C\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u66F4\u65B0\u304C\u5FC5\u8981\u306A\u53E4\u3044 Talkback \u30A4\u30D9\u30F3\u30C8\u304C\u3044\u304F\u3064\u304B\u3042\u308A\u307E\u3059\u3002"},"dictation":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","question":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u30D5\u30EC\u30FC\u30BA\u306F\u4F55\u3067\u3059\u304B?","thenMacro":"Cephable \u306F...","empty":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","type":"\u30BF\u30A4\u30D7","edit":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30D5\u30EC\u30FC\u30BA\u3092\u7DE8\u96C6\u3059\u308B","remove":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30D5\u30EC\u30FC\u30BA\u3092\u524A\u9664","add":"\u65B0\u3057\u3044\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30D5\u30EC\u30FC\u30BA\u3092\u8FFD\u52A0\u3059\u308B","on":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","off":"\u30B3\u30DE\u30F3\u30C9","onboarding":{"tourLabel":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","learn":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u97F3\u58F0\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","welcome":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u81EA\u7136\u306A\u8A71\u3057\u65B9\u3067\u3001\u8A71\u3057\u306A\u304C\u3089\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u307E\u308B\u3067\u3001\u3042\u306A\u305F\u306E\u8A71\u3059\u8A00\u8449\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u308C\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u308B\u304B\u306E\u3088\u3046\u3067\u3059\u3002"},"microphone":{"title":"\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3059\u308B","description":"\u307E\u305A\u3001\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002Cephable\u30D1\u30CD\u30EB\u306E\u30DE\u30A4\u30AF\u5207\u308A\u66FF\u3048\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"activate":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u958B\u59CB","description":"\u97F3\u58F0\u306F\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u3067\u8D77\u52D5\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3046\u304B\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305D\u308C\u3067\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u30AA\u30F3\u306B\u3057\u307E\u3057\u3087\u3046\u3002"},"speaking":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u305F\u306F\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8AAD\u307F\u4E0A\u3052\u3092\u958B\u59CB\u3057\u307E\u3059","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u8A71\u3057\u305F\u5185\u5BB9\u3092\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u5165\u529B\u3057\u307E\u3059\u3002\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u8AAD\u307F\u4E0A\u3052\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4F8B\u3048\u3070\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u306E\u4F7F\u3044\u65B9\u306F\u6B21\u306E\u3068\u304A\u308A\u3067\u3059\u300D\u3068\u767A\u58F0\u3057\u307E\u3059\u3002"},"pauseResume":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u4E00\u6642\u505C\u6B62","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u305B\u305A\u306B\u4F11\u61A9\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4E00\u6642\u505C\u6B62\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u767A\u58F0\u3059\u308C\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u6A5F\u80FD\u306F\u3001\u5E38\u6642\u30AA\u30F3\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3055\u3089\u306B\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002"},"stop":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u3084\u3081\u308B","description":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u623B\u308A\u305F\u3044\u3067\u3059\u304B\uFF1F\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u300D\u3068\u8A00\u3046\u3060\u3051\u3067\u3059\u3002\u3053\u308C\u3067\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u505C\u6B62\u3057\u3001\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306B\u623B\u308A\u307E\u3059\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3048\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002"},"complete":{"title":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","description":"\u3053\u308C\u3067\u5B8C\u4E86\u3067\u3059\uFF01\u97F3\u58F0\u5165\u529B\u3001\u4E00\u6642\u505C\u6B62\u3001\u518D\u958B\u3001\u305D\u3057\u3066\u97F3\u58F0\u5165\u529B\u30E2\u30FC\u30C9\u3068\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u97F3\u58F0\u5165\u529B\u306F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u5165\u529B\u3092\u53EF\u80FD\u306B\u3059\u308B\u5F37\u529B\u306A\u30C4\u30FC\u30EB\u3067\u3059\u3002\u30E1\u30FC\u30EB\u3084\u6587\u66F8\u306E\u4F5C\u6210\u306A\u3069\u3001\u97F3\u58F0\u5165\u529B\u304C\u5FC5\u8981\u306A\u3042\u3089\u3086\u308B\u4F5C\u696D\u306B\u304A\u4F7F\u3044\u3044\u305F\u3060\u3051\u307E\u3059\u3002"}},"description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u81EA\u7136\u306B\u8A71\u3057\u306A\u304C\u3089\u3001\u8A71\u3057\u306A\u304C\u3089\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u307E\u308B\u3067\u3001\u3042\u306A\u305F\u306E\u8A71\u3059\u8A00\u8449\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u308C\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u308B\u304B\u306E\u3088\u3046\u3067\u3059\u3002","settings":{"title":"\u97F3\u58F0\u5165\u529B","description":"\u97F3\u58F0\u5165\u529B\u306F\u3069\u306E\u3088\u3046\u306B\u958B\u59CB\u3055\u308C\u3001\u5165\u529B\u3055\u308C\u305F\u8A00\u8449\u306F\u6587\u5B57\u5316\u3055\u308C\u308B\u524D\u306B\u3069\u306E\u3088\u3046\u306A\u51E6\u7406\u3092\u53D7\u3051\u308B\u306E\u304B\u3002"},"hold":{"enabled":{"option":"\u9577\u62BC\u3057\u3057\u3066\u97F3\u58F0\u5165\u529B","description":"\u97F3\u58F0\u5165\u529B\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u4EE5\u4E0B\u306E\u30AD\u30FC\u3092\u62BC\u3057\u7D9A\u3051\u3066\u304F\u3060\u3055\u3044\u3002\u4ED6\u306E\u30AD\u30FC\u306F\u62BC\u3055\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u97F3\u58F0\u5165\u529B\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u30AD\u30FC\u3092\u96E2\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u5165\u529B\u3057\u305F\u5185\u5BB9\u304C\u6587\u5B57\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002"},"keys":{"title":"\u9375\u3092\u63E1\u308B","description":"\u3053\u308C\u3089\u306E\u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u4ED6\u306E\u30AD\u30FC\u3092\u62BC\u3059\u3068\u3001\u3053\u308C\u3089\u306E\u30AD\u30FC\u306E\u7D44\u307F\u5408\u308F\u305B\u304C\u89E3\u9664\u3055\u308C\u308B\u305F\u3081\u3001\u901A\u5E38\u306E\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u30AD\u30FC\u306F\u5F15\u304D\u7D9A\u304D\u6A5F\u80FD\u3057\u307E\u3059\u3002"},"duration":{"title":"\u4FDD\u6301\u6642\u9593","description":"\u97F3\u58F0\u5165\u529B\u304C\u958B\u59CB\u3055\u308C\u308B\u307E\u3067\u3001\u30AD\u30FC\u3092\u62BC\u3057\u7D9A\u3051\u308B\u6642\u9593\u306F\u3069\u308C\u304F\u3089\u3044\u3067\u3059\u304B\u3002"},"transcribing":"\u6587\u5B57\u8D77\u3053\u3057\u4E2D...","aiRewriting":"AI\u304C\u66F8\u304D\u63DB\u3048\u308B\u2026","result":"{{\u79D2}}\u79D2\u3067{{\u5358\u8A9E}}\u8A9E","resultRewritten":"{{words}}\u8A9E\u3092{{seconds}}\u79D2\u3067\u8868\u793A\u3001AI\u306B\u3088\u308B{{rewriteSeconds}}\u79D2","typing":"\u30BF\u30A4\u30D4\u30F3\u30B0...","permission":{"title":"\u9577\u62BC\u3057\u3057\u3066\u97F3\u58F0\u5165\u529B\u3059\u308B\u3068\u8A31\u53EF\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","description":"\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A > \u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3 > {{pane}} \u3067 Cephable \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9577\u62BC\u3057\u3057\u3066\u97F3\u58F0\u5165\u529B\u3059\u308B\u3068\u3001\u3059\u3050\u306B\u52D5\u4F5C\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"unavailable":"\u9577\u62BC\u3057\u3057\u3066\u97F3\u58F0\u5165\u529B\u3092\u958B\u59CB\u3057\u3088\u3046\u3068\u3057\u305F\u306E\u3067\u3059\u304C\u3001\u30AD\u30FC\u5165\u529B\u306E\u8A8D\u8B58\u3092\u958B\u59CB\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002Cephable\u3092\u518D\u8D77\u52D5\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"aiRewrite":{"option":"\u9577\u6587\u97F3\u58F0\u5165\u529B\u306B\u5BFE\u3059\u308BAI\u306B\u3088\u308B\u66F8\u304D\u63DB\u3048","description":"\u9577\u3081\u306E\u97F3\u58F0\u5165\u529B\u306E\u5834\u5408\u3001\u5165\u529B\u524D\u306B\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u304C\u53E5\u8AAD\u70B9\u3001\u4E0D\u8981\u306A\u5358\u8A9E\u3001\u8AA4\u5B57\u8131\u5B57\u306A\u3069\u3092\u4FEE\u6B63\u3057\u3001\u5165\u529B\u5148\u306E\u30A2\u30D7\u30EA\u306B\u5408\u308F\u305B\u3066\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059\u3002\u77ED\u3081\u306E\u97F3\u58F0\u5165\u529B\u306F\u3001\u8A71\u3057\u305F\u3068\u304A\u308A\u306B\u305D\u306E\u307E\u307E\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u5165\u529B\u524D\u306B\u5C11\u3057\u5F85\u3061\u6642\u9593\u304C\u3042\u308A\u307E\u3059\u3002"}},"face":{"title":"\u8868\u60C5","titlePlural":"\u8868\u60C5","try":"\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A66\u3059","question":"\u3069\u306E\u3088\u3046\u306A\u8868\u60C5\u3092\u4F7F\u3044\u305F\u3044\u3067\u3059\u304B?","descriptionShort":"\u3055\u307E\u3056\u307E\u306A\u9854\u306E\u52D5\u304D\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5F37\u5316\u3057\u307E\u3059\u3002","description":"\u8868\u60C5\u306F\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E00\u90E8\u3067\u3059\u3002\u8868\u60C5\u3092\u69D8\u3005\u306A\u52D5\u304D\u3067\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002\u7709\u6BDB\u3084\u53E3\u306E\u52D5\u304D\u306A\u3069\u3001\u69D8\u3005\u306A\u8868\u60C5\u3092\u4F5C\u308A\u51FA\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"other":{"title":"\u4ED6\u306E","titlePlural":"\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","label":"\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","placeholder":"\u305D\u306E\u4ED6\u306E\u5B9F\u9A13\u30B3\u30DE\u30F3\u30C9","question":"\u3069\u306E\u3088\u3046\u306A\u8FFD\u52A0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B\uFF1F\u3053\u308C\u3089\u306F\u901A\u5E38\u3001\u4ED6\u306E\u30AB\u30C6\u30B4\u30EA\u306B\u5F53\u3066\u306F\u307E\u3089\u306A\u3044Cephable\u4EE5\u5916\u306E\u63A5\u7D9A\u3067\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u307E\u305F\u3001\u6307\u5B9A\u3055\u308C\u305F\u5358\u8A9E\u307E\u305F\u306F\u30D5\u30EC\u30FC\u30BA\u3092\u8A71\u3059\u3068\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u3057\u3066\u6A5F\u80FD\u3059\u308B\u5834\u5408\u3082\u3042\u308A\u307E\u3059\u3002\u6CE8\uFF1A\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8A66\u9A13\u6BB5\u968E\u3067\u3042\u308A\u3001\u5B8C\u5168\u306B\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8A66\u9A13\u6BB5\u968E\u3067\u3042\u308A\u3001\u5B8C\u5168\u306B\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002Cephable\u4EE5\u5916\u306E\u63A5\u7D9A\u3001\u307E\u305F\u306F\u6307\u5B9A\u3055\u308C\u305F\u5358\u8A9E\u3084\u30D5\u30EC\u30FC\u30BA\u3092\u8A71\u3059\u969B\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u3057\u3066\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"},"support":{"title":"\u30B5\u30DD\u30FC\u30C8","profiles":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981","question":"\u307E\u3060\u5FC5\u8981\u306A\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u304B?","more":"Cephable.com \u3067\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7\u306E\u30AC\u30A4\u30C9\u3001\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3001\u30D3\u30C7\u30AA\u306A\u3069\u306E\u8A73\u7D30\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"community":{"title":"\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u53C2\u52A0\u3059\u308B","description":"\u30B5\u30DD\u30FC\u30C8\u3092\u53D7\u3051\u305F\u308A\u3001\u30A2\u30A4\u30C7\u30A2\u3092\u5171\u6709\u3057\u305F\u308A\u3001Cephable \u306E\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u306A\u3063\u305F\u308A\u3067\u304D\u307E\u3059\u3002","discord":"Discord\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3","facebook":"Facebook\u30B0\u30EB\u30FC\u30D7"},"resources":{"title":"\u5F79\u7ACB\u3064\u30EA\u30BD\u30FC\u30B9","description":"Cephable \u306E\u7279\u5FB4\u3068\u6A5F\u80FD\u306B\u95A2\u3059\u308B\u8CEA\u554F\u3078\u306E\u56DE\u7B54\u3092\u898B\u3064\u3051\u307E\u3059\u3002","guides":"\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7\u30AC\u30A4\u30C9"},"feedback":{"title":"\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF","description":"Cephable \u306E\u4F7F\u7528\u7D4C\u9A13\u306B\u3064\u3044\u3066\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002","contact":"\u304A\u554F\u3044\u5408\u308F\u305B","feature":"\u6A5F\u80FD\u3092\u63D0\u6848\u3059\u308B","bug":"\u554F\u984C\u3092\u5831\u544A\u3059\u308B"},"settings":{"title":"\u8A2D\u5B9A","orgTitle":"{{ value }} \u8A2D\u5B9A","general":"\u4E00\u822C\u7684\u306A\u30A2\u30D7\u30EA\u8A2D\u5B9A","description":"\u3053\u308C\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5FAE\u8ABF\u6574\u3057\u3066\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u305F\u3081\u306E\u30AD\u30E3\u30F3\u30D0\u30B9\u3067\u3059\u3002","advanced":{"title":"\u8A73\u7D30\u8A2D\u5B9A","description":"AI\u8A2D\u5B9A\u3001\u30A2\u30D7\u30EA\u5236\u5FA1\u3001\u63A5\u7D9A\u3001\u62E1\u5F35\u6A5F\u80FD\u306A\u3069\u306E\u8A73\u7D30\u8A2D\u5B9A\u3092\u53D6\u5F97\u3059\u308B\u306B\u306F\u3001\u3053\u3061\u3089\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"quick":"\u4EE5\u4E0B\u306F\u3001\u30D1\u30CD\u30EB\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u8A2D\u5B9A\u3067\u3059\u3002\u3053\u308C\u3089\u3092\u4F7F\u7528\u3057\u3066\u3001\u73FE\u5728\u306E\u4F7F\u7528\u611F\u3092\u5FAE\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"account":{"title":"\u30A2\u30AB\u30A6\u30F3\u30C8","menu":"\u30E6\u30FC\u30B6\u30FC\u30E1\u30CB\u30E5\u30FC","settings":"\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A","description":"Cephable \u3068\u306E\u63A5\u7D9A\u3092\u7DAD\u6301\u3059\u308B\u306B\u306F\u3001\u91CD\u8981\u306A\u60C5\u5831\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","usernameLabel":"\u30E6\u30FC\u30B6\u30FC\u540D:","emailLabel":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9:","password":{"change":"\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3059\u308B","description":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5B89\u5168\u306B\u4FDD\u3064\u305F\u3081\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","old":"\u4EE5\u524D\u306E\u30D1\u30B9\u30EF\u30FC\u30C9","current":"\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9","new":"\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9","desired":"\u5E0C\u671B\u3059\u308B\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9","confirm":"\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D","update":"\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u66F4\u65B0"},"isEmailVerified":{"title":"\u96FB\u5B50\u30E1\u30FC\u30EB\u306F\u78BA\u8A8D\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","description":"\u3042\u306A\u305F\u306E\u30E1\u30FC\u30EB\u306F\u78BA\u8A8D\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u78BA\u8A8D\u30EA\u30F3\u30AF\u304C\u8A18\u8F09\u3055\u308C\u305F\u30E1\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","resend":"\u30E1\u30FC\u30EB\u3092\u518D\u9001\u4FE1","success":"\u65B0\u3057\u3044\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002","error":"\u78BA\u8A8D\u30E1\u30FC\u30EB\u306E\u9001\u4FE1\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","org":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u78BA\u8A8D\u304C\u307E\u3060\u5B8C\u4E86\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u8A73\u7D30\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u306B\u306F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u78BA\u8A8D\u30EA\u30F3\u30AF\u304C\u8A18\u8F09\u3055\u308C\u305F\u30E1\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","titleAlt":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044","descriptionLong":"Cephable\u3078\u3088\u3046\u3053\u305D\uFF01{{email}}\u306B\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u53D7\u4FE1\u30C8\u30EC\u30A4\u307E\u305F\u306F\u8FF7\u60D1\u30E1\u30FC\u30EB\u30D5\u30A9\u30EB\u30C0\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u518D\u9001\u4FE1\u3067\u304D\u307E\u3059\u3002","appBlock":"\u3082\u3046\u3059\u3050\u5B8C\u4E86\u3067\u3059\uFF01\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092{{email}}\u306B\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001\u8FF7\u60D1\u30E1\u30FC\u30EB\u30D5\u30A9\u30EB\u30C0\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"},"signout":{"title":"\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8","question":"\u672C\u5F53\u306B\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3057\u307E\u3059\u304B?","confirm":"\u306F\u3044\u3001\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3057\u307E\u3059","warn":{"title":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3059\u3002","description":"\u3057\u3070\u3089\u304F\u64CD\u4F5C\u304C\u884C\u308F\u308C\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E0A\u306E\u7406\u7531\u304B\u3089\u3001XX \u79D2\u5F8C\u306B\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u307E\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u307E\u307E\u306B\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u4E0B\u306E\u300C\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u307E\u307E\u306B\u3059\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","confirm":"\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u307E\u307E\u306B\u3059\u308B","cancel":"\u4ECA\u3059\u3050\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8"},"description":"\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u3059\u308B\u3068\u3001\u3053\u306E\u63A5\u7D9A\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u3001Companion \u30A2\u30D7\u30EA\u3084\u4ED6\u306E\u63A5\u7D9A\u304B\u3089\u306F\u8868\u793A\u3055\u308C\u306A\u304F\u306A\u308A\u307E\u3059\u3002","confirmDescription":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u3066\u3053\u306E\u63A5\u7D9A\u3092\u524A\u9664\u3057\u307E\u3059"},"marketing":{"title":"\u30E1\u30FC\u30EB\u8A2D\u5B9A","description":"Cephable \u304B\u3089\u306E\u66F4\u65B0\u60C5\u5831\u3084\u30CB\u30E5\u30FC\u30B9\u3092\u53D7\u3051\u53D6\u308B\u306B\u306F\u3001\u96FB\u5B50\u30E1\u30FC\u30EB\u306E\u8A2D\u5B9A\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","marketing":"\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u30E1\u30FC\u30EB","optIn":"Cephable \u4F53\u9A13\u3092\u5411\u4E0A\u3055\u305B\u308B\u305F\u3081\u306E\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3001\u30D2\u30F3\u30C8\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3001\u30CB\u30E5\u30FC\u30B9\u30EC\u30BF\u30FC\u3092\u53D7\u3051\u53D6\u308A\u305F\u3044"},"error":{"save":"\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","password":"\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","signout":"\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","old":"\u53E4\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002","new":"\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002","match":"\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002","marketing":"\u96FB\u5B50\u30E1\u30FC\u30EB\u8A2D\u5B9A\u306E\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","userPreferences":"\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"success":{"save":"\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","password":"\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","marketing":"\u96FB\u5B50\u30E1\u30FC\u30EB\u306E\u8A2D\u5B9A\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","userPreferences":"\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002"},"userPreferences":{"title":"\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A","description":"\u8A2D\u5B9A\u3092\u66F4\u65B0\u3057\u3066\u3001\u81EA\u5206\u306B\u5408\u3063\u305F Cephable \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3057\u3066\u304F\u3060\u3055\u3044\u3002","warningOptOut":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4FDD\u5B58\u307E\u305F\u306F\u66F4\u65B0\u3059\u308B\u3068\u304D\u306B\u8B66\u544A\u3092\u975E\u8868\u793A\u306B\u3059\u308B","enableTranscribeTask":"Cephable\u30D1\u30CD\u30EB\u3067\u5B9F\u9A13\u7684\u306A\u30D5\u30A1\u30A4\u30EB\u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30BF\u30FC\u30BF\u30B9\u30AF\u3092\u6709\u52B9\u306B\u3059\u308B","enableGamepadSupport":"\u30ED\u30FC\u30AB\u30EB\u30C9\u30E9\u30A4\u30D0\u30FC\u3068Xbox\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30A8\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3\u306E\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u30B5\u30DD\u30FC\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B","enableMetrics":"\u30D1\u30D5\u30A9\u30FC\u30DE\u30F3\u30B9 \u30C6\u30B9\u30C8\u306E\u305F\u3081\u306B\u3001\u4F7F\u7528\u72B6\u6CC1\u30E1\u30C8\u30EA\u30AF\u30B9\u306E\u51FA\u529B\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30ED\u30B0\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","enableCameraControls":"Cephable\u30D1\u30CD\u30EB\u3067\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6709\u52B9\u306B\u3059\u308B","enableWorkflowRecording":"Automate\u3068AI\u30B9\u30AD\u30EB\u3067\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u8A18\u9332\u30D7\u30EC\u30D3\u30E5\u30FC\u3092\u6709\u52B9\u306B\u3059\u308B"},"delete":{"title":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664","description":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5B8C\u5168\u306B\u524A\u9664\u3057\u3001\u500B\u4EBA\u60C5\u5831\u3078\u306E\u53C2\u7167\u3092\u3059\u3079\u3066\u524A\u9664\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u63A5\u7D9A\u304C\u524A\u9664\u3055\u308C\u3001\u6A5F\u80FD\u3057\u306A\u304F\u306A\u308A\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u767B\u9332\u3055\u308C\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3059\u3079\u3066\u306E\u8A2D\u5B9A\u3082\u5931\u308F\u308C\u307E\u3059\u3002\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","button":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5B8C\u5168\u306B\u524A\u9664\u3059\u308B","confirmation":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","note":"\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","confirm":"\u306F\u3044\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u307E\u3059"},"communication":{"title":"\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A"},"name":{"title":"\u8868\u793A\u540D"},"email":{"title":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","description":"\u767B\u9332\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"}},"license":{"trial":{"subtitle":"{{count}} \u4EBA\u306E\u540C\u50DA\u3092\u62DB\u5F85\u3057\u3066\u4E00\u7DD2\u306B Cephable \u3092\u8A66\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","noUsersSubtitle":"\u8A66\u7528\u7248\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u6B8B\u3063\u3066\u3044\u307E\u305B\u3093\u3002\u30E6\u30FC\u30B6\u30FC\u3092\u8FFD\u52A0\u3059\u308B\u306B\u306F\u3001\u6709\u6599\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","expired":{"user":"{{productName}} \u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306F {{date}} \u306B\u671F\u9650\u5207\u308C\u3068\u306A\u308A\u307E\u3059\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\uFF08{{admin}}\uFF09\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","userLong":"{{productName}}\u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u7D44\u7E54\u306E\u7BA1\u7406\u8005\uFF08{{admin}}\uFF09\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","admin":"{{productName}} \u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306F {{date}} \u306B\u671F\u9650\u5207\u308C\u3068\u306A\u308A\u307E\u3059\u3002","adminLong":"{{productName}}\u3078\u306E\u7121\u6599\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u305F\u3088\u3046\u3067\u3059\u3002\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001Cephable Basic\u3067\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u3044\u9AD8\u5EA6\u306A\u6A5F\u80FD\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002"},"start":"\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u59CB\u3081\u308B","title":{"single":"{{productName}} \u306B\u7121\u6599\u3067\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002\u6B8B\u308A {{days}} \u65E5\u3067\u3059","multiple":"{{organization}} \u306F\u6B8B\u308A {{days}} \u65E5\u9593\u306E\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u4E2D\u3067\u3059"},"upgrade":"\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u3068\u3001\u5F37\u5316\u3055\u308C\u305F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001AI \u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30BF\u30B9\u30AF\u3001\u591A\u6570\u306E\u4E8B\u524D\u69CB\u7BC9\u6E08\u307F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u306E\u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7DAD\u6301\u3055\u308C\u307E\u3059\u3002"},"key":{"title":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC","titlePlural":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC","details":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u306E\u8A73\u7D30","description":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u306F\u3001Cephable Professional\u3001Education\u3001\u307E\u305F\u306F Developer \u6A5F\u80FD\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u308B\u4E00\u610F\u306E\u8B58\u5225\u5B50\u3067\u3059\u3002","assigned":"\u4F7F\u7528\u65E5: {{date}}","expires":"\u6709\u52B9\u671F\u9650: {{date}}","assign":"\u65B0\u3057\u3044\u7D44\u7E54\u306B\u30AD\u30FC\u3092\u5272\u308A\u5F53\u3066\u308B","error":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","empty":{"title":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","description":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u307E\u305F\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u307E\u3060\u8CFC\u5165\u3057\u3066\u3044\u307E\u305B\u3093\u3002"},"product":{"title":"\u8CFC\u5165","titleLong":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u3092\u8CFC\u5165\u3059\u308B","description":"\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u8CFC\u5165\u3057\u3066\u3001Cephable \u306E\u6F5C\u5728\u80FD\u529B\u3092\u6700\u5927\u9650\u306B\u5F15\u304D\u51FA\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u5229\u7528\u53EF\u80FD\u306A\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30F3\u3068\u4FA1\u683C\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","action":"\u4ECA\u3059\u3050\u8CFC\u5165","empty":{"title":"\u5546\u54C1\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","description":"\u88FD\u54C1\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002\u3053\u306E\u554F\u984C\u3092\u89E3\u6C7A\u3059\u308B\u306B\u306F\u3001\u5F0A\u793E\u306E\u55B6\u696D\u30C1\u30FC\u30E0\u307E\u305F\u306F\u62C5\u5F53\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"},"yearly":"\u5E74\u6255\u3044","years":"{{value}} \u5E74\u3054\u3068\u306B\u8ACB\u6C42\u3055\u308C\u307E\u3059","days":"{{value}} \u65E5\u3054\u3068\u306B\u8ACB\u6C42\u3055\u308C\u307E\u3059","Subscription":{"title":"\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3"},"MeteredConsumption":{"title":"\u5F93\u91CF\u5236\u6D88\u8CBB"},"PayDown":{"title":"\u8FD4\u6E08\u3059\u308B"},"OneTime":{"title":"\u4E00\u5EA6"}}},"upgrade":{"professional":"Cephable\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u30E9\u30A4\u30BB\u30F3\u30B9\u3078\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","generic":{"title":"Cephable\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9","description":"Cephable \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306F\u3001\u8077\u5834\u3084\u5B66\u6821\u3067\u306E\u5546\u7528\u5229\u7528\u3084\u30CD\u30A4\u30C6\u30A3\u30D6 \u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3\u3078\u306E\u7D71\u5408\u306B\u9069\u3057\u305F\u3055\u307E\u3056\u307E\u306A\u88FD\u54C1\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002"},"fallback":{"title":"\u8ACB\u6C42\u30DD\u30FC\u30BF\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","description":"\u8ACB\u6C42\u30DD\u30FC\u30BF\u30EB\u3092\u8AAD\u307F\u8FBC\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3092\u7D9A\u884C\u3059\u308B\u306B\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066 sales@cephable.com \u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"}},"required":{"title":"Cephable\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059","description":"Cephable Basic \u3092\u3054\u5229\u7528\u306E\u3088\u3046\u3067\u3059\u304C\u3001\u3053\u308C\u306F Cephable \u306E\u5546\u7528\u5229\u7528\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30A2\u30D7\u30EA\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u30E9\u30A4\u30BB\u30F3\u30B9\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"activate":{"question":"\u3059\u3067\u306B\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u3092\u304A\u6301\u3061\u3067\u3059\u304B?","button":"\u6D3B\u6027\u5316","title":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC\u3092\u6709\u52B9\u5316","description":"Cephable \u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","descriptionLong":"Cephable \u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u306B\u306F\u3001\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30E9\u30A4\u30BB\u30F3\u30B9 \u30AD\u30FC\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u5834\u5408\u306F\u3001\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u958B\u59CB\u3059\u308B\u304B\u3001\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u8CFC\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002","fieldLabel":"\u30E9\u30A4\u30BB\u30F3\u30B9\u30AD\u30FC","placeholder":"\u7FFB\u8A33\u8005","invalid":{"key":"\u7121\u52B9\u306A\u30AD\u30FC\u3067\u3059\u3002\u6B63\u3057\u3044\u30AD\u30FC\u3092\u5165\u529B\u3057\u305F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","empty":{"key":"\u7121\u52B9\u306A\u30AD\u30FC\u3067\u3059\u3002\u5024\u3092\u5165\u529B\u3057\u305F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","name":"\u7D44\u7E54\u540D\u304C\u7121\u52B9\u3067\u3059\u3002\u5024\u3092\u5165\u529B\u3057\u305F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"success":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u306F {{license}} \u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002"},"welcome":{"title":"{{license}} \u3078\u3088\u3046\u3053\u305D\u3002","description":"{{organization}} \u306B\u6B63\u5E38\u306B\u53C2\u52A0\u3057\u307E\u3057\u305F\u3002{{description}}"},"redirect":{"title":"\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8","description":"\u5916\u90E8\u306E\u8ACB\u6C42\u30DD\u30FC\u30BF\u30EB\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3057\u305F\u3002\u30D6\u30E9\u30A6\u30B6\u306B\u65B0\u3057\u3044\u30BF\u30D6\u304C\u958B\u304D\u307E\u3059\u3002\u6570\u79D2\u4EE5\u5185\u306B\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error":"\u8ACB\u6C42\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u30A8\u30E9\u30FC","external":"\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u3055\u308C\u307E\u3057\u305F\u3002\u30D6\u30E9\u30A6\u30B6\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"},"pro":{"tag":"\u30D7\u30ED","detail":"\u3053\u308C\u306FCephable Professional\u306E\u307F\u306E\u6A5F\u80FD\u3067\u3059","requiredDetail":"\u3053\u306E\u6A5F\u80FD\u306B\u306FCephable Professional\u30E9\u30A4\u30BB\u30F3\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A\u3067\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u304B\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002"},"titlePlural":"\u30E9\u30A4\u30BB\u30F3\u30B9"},"appSettings":{"description":"\u3053\u308C\u3089\u306E\u8A2D\u5B9A\u306F\u3053\u306E\u30A2\u30D7\u30EA\u306B\u306E\u307F\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u5225\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u307E\u305F\u306F\u30E2\u30D0\u30A4\u30EB \u30C7\u30D0\u30A4\u30B9\u4E0A\u306E Cephable \u30A2\u30D7\u30EA\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001\u305D\u306E\u30A2\u30D7\u30EA\u3067\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3057\u3066\u304F\u3060\u3055\u3044\u3002","autostart":{"title":"Cephable \u3092\u81EA\u52D5\u7684\u306B\u8D77\u52D5\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u306B\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068 Cephable \u30A2\u30D7\u30EA\u304C\u81EA\u52D5\u7684\u306B\u8D77\u52D5\u3057\u307E\u3059\u3002\u81EA\u52D5\u97F3\u58F0\u304A\u3088\u3073\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3082\u8A2D\u5B9A\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u305D\u308C\u3089\u3082\u3059\u3050\u306B\u8D77\u52D5\u3057\u307E\u3059\u3002","question":"Cephable \u30A2\u30D7\u30EA\u3092\u81EA\u52D5\u8D77\u52D5\u3057\u307E\u3059\u304B?"},"position":{"topLeft":"\u5DE6\u4E0A","top":"\u4E0A\u4E2D\u592E","topRight":"\u53F3\u4E0A","bottom":"\u4E0B\u4E2D\u592E","bottomLeft":"\u5DE6\u4E0B","bottomRight":"\u53F3\u4E0B","label":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9\u4F4D\u7F6E\u3092\u9078\u629E","description":"\u30B3\u30DE\u30F3\u30C9 \u30D5\u30A3\u30FC\u30C9\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u8868\u793A\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"micPosition":{"title":"\u30DE\u30A4\u30AF\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E","description":"\u97F3\u58F0\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u7528\u306E\u30DE\u30A4\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u914D\u7F6E\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002","label":"\u30DE\u30A4\u30AF\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E\u3092\u9078\u629E"},"cameraPosition":{"title":"\u30AB\u30E1\u30E9\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E","description":"\u9854\u3068\u982D\u306E\u52D5\u304D\u306E\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u914D\u7F6E\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002","label":"\u30AB\u30E1\u30E9\u5165\u529B\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F4D\u7F6E\u3092\u9078\u629E"},"theme":{"title":"\u30C6\u30FC\u30DE","description":"\u3042\u306A\u305F\u306E\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u3063\u305F\u30C6\u30FC\u30DE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","label":"\u30C6\u30FC\u30DE\u3092\u9078\u629E","light":"\u30E9\u30A4\u30C8","dark":"\u6697\u3044","system":"OS\u306E\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A\u3092\u4F7F\u7528\u3059\u308B"},"overlay":{"title":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9","description":"\u30B3\u30DE\u30F3\u30C9 \u30D5\u30A3\u30FC\u30C9\u306B\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u3055\u307E\u3056\u307E\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u9001\u4FE1\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u30AF\u30EA\u30C3\u30AF\u30B9\u30EB\u30FC\u3067\u3059\u304C\u3001\u5E38\u306B\u4ED6\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3088\u308A\u3082\u624B\u524D\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable \u30A2\u30D7\u30EA\u304C\u8868\u793A\u3055\u308C\u3001\u5E38\u306B\u4ED6\u306E\u30A6\u30A3\u30F3\u30C9\u30A6\u3084\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3088\u308A\u3082\u624B\u524D\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002","question":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9\u3092\u8868\u793A\u3057\u307E\u3059\u304B?"},"transparent":{"title":"\u30B3\u30DE\u30F3\u30C9\u30D5\u30A3\u30FC\u30C9\u306E\u900F\u660E\u6027","description":"\u30C6\u30AD\u30B9\u30C8\u306E\u4E0D\u900F\u660E\u5EA6\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002\u5024\u304C\u4F4E\u3044\u307B\u3069\u3001\u30D5\u30A3\u30FC\u30C9\u304C\u900F\u3051\u3066\u898B\u3048\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"panelAutoHide":{"title":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30D1\u30CD\u30EB\u306E\u81EA\u52D5\u975E\u8868\u793A","delay":"\u96A0\u308C\u308B\u524D\u306B\u9045\u308C\u308B","denominator":"\u79D2","time":"{{value}} \u79D2"},"title":"\u4E00\u822C\u7684\u306A\u30A2\u30D7\u30EA\u8A2D\u5B9A","scale":{"description":"\u30A2\u30D7\u30EA\u5168\u4F53\u306E\u30C6\u30AD\u30B9\u30C8\u30B5\u30A4\u30BA\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","label":"\u30C6\u30AD\u30B9\u30C8\u30B5\u30A4\u30BA","small":"\u5C0F\u3055\u3044","large":"\u5927\u304D\u3044"},"panelScale":{"description":"\u6298\u308A\u305F\u305F\u307F\u30D1\u30CD\u30EB\u30DC\u30BF\u30F3\u306E\u30B5\u30A4\u30BA\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","label":"\u30D1\u30CD\u30EB\u30DC\u30BF\u30F3\u30B5\u30A4\u30BA"},"aiNewFiles":{"title":"\u65B0\u3057\u3044AI\u30D5\u30A1\u30A4\u30EB\u7528\u30D5\u30A9\u30EB\u30C0","description":"\u7279\u5B9A\u306E\u5834\u6240\u3092\u6307\u5B9A\u3057\u306A\u3044\u9650\u308A\u3001AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u65E2\u5B9A\u3067\u4FDD\u5B58\u3059\u308B\u5834\u6240\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u65E2\u5B9A\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u3001\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u306F\u30DB\u30FC\u30E0\u30D5\u30A9\u30EB\u30C0\u5185\u306E\u300CCephable-Work\u300D\u30D5\u30A9\u30EB\u30C0\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u306F\u521D\u3081\u3066\u5FC5\u8981\u306B\u306A\u3063\u305F\u3068\u304D\u306B\u81EA\u52D5\u7684\u306B\u4F5C\u6210\u3055\u308C\u307E\u3059\u3002","selectButton":"\u30D5\u30A9\u30EB\u30C0\u30FC\u3092\u9078\u629E","clearButton":"\u65E2\u5B9A\u306E\u30D5\u30A9\u30EB\u30C0\u3092\u4F7F\u7528\u3059\u308B","current":"\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u306E\u4FDD\u5B58\u5148: {{folder}}","default":"\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u306F\u30DB\u30FC\u30E0\u30D5\u30A9\u30EB\u30C0\u5185\u306E\u65E2\u5B9A\u306E\u300CCephable-Work\u300D\u30D5\u30A9\u30EB\u30C0\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","openButton":"\u30D5\u30A9\u30EB\u30C0\u30FC\u3092\u958B\u304F","openError":"\u30D5\u30A9\u30EB\u30C0\u3092\u958B\u3051\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u79FB\u52D5\u307E\u305F\u306F\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"aiWorkspace":{"title":"AI\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u30D5\u30A9\u30EB\u30C0","description":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u3001\u30D5\u30A1\u30A4\u30EB\u306E\u691C\u7D22\u3001\u8AAD\u307F\u53D6\u308A\u3001\u7DE8\u96C6\u3001\u304A\u3088\u3073\u30B3\u30DE\u30F3\u30C9\u306E\u5B9F\u884C\u306B\u4F7F\u7528\u3059\u308B\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u3067\u306F\u3001\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306F\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u5168\u4F53\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","selectButton":"\u30D5\u30A9\u30EB\u30C0\u30FC\u3092\u9078\u629E","clearButton":"\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u5168\u4F53\u3092\u4F7F\u7528\u3059\u308B","current":"\u73FE\u5728\u306E\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u30D5\u30A9\u30EB\u30C0:","none":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u30D5\u30A9\u30EB\u30C0\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306F\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u5168\u4F53\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","restrictQuestion":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3092\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u306E\u307F\u306B\u5236\u9650\u3059\u308B","restrictDescription":"\u6709\u52B9\u306B\u3059\u308B\u3068\u3001AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306E\u30D5\u30A1\u30A4\u30EB\u30C4\u30FC\u30EB\u3068\u30B3\u30DE\u30F3\u30C9\u30C4\u30FC\u30EB\u306F\u3001\u9078\u629E\u3057\u305F\u30D5\u30A9\u30EB\u30C0\u4EE5\u5916\u306E\u30D5\u30A1\u30A4\u30EB\u3084\u30D5\u30A1\u30A4\u30EB\u3092\u8AAD\u307F\u53D6\u3063\u305F\u308A\u5909\u66F4\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002"},"documentTemplates":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","description":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u65B0\u898F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u4F7F\u7528\u3059\u308B\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002Cephable\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u8A2D\u5B9A\u306E\u307E\u307E\u306B\u3057\u3066\u304A\u304F\u3068\u3001Cephable\u306E\u30D6\u30E9\u30F3\u30C9\u30B9\u30BF\u30A4\u30EB\u304C\u7D44\u307F\u8FBC\u307E\u308C\u3066\u3044\u307E\u3059\u3002Word\u3001PowerPoint\u3001Excel\u306B\u306F\u305D\u308C\u305E\u308C\u5C02\u7528\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u304C\u7528\u610F\u3055\u308C\u3066\u3044\u307E\u3059\u3002","word":"\u30EF\u30FC\u30C9\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","wordDescription":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u65B0\u3057\u3044Word\u6587\u66F8\uFF08.docx\uFF09\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u4F7F\u7528\u3059\u308B\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3002","powerpoint":"PowerPoint\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","powerpointDescription":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u65B0\u3057\u3044PowerPoint\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\uFF08.pptx\uFF09\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u4F7F\u7528\u3059\u308B\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3002","excel":"Excel\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","excelDescription":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304C\u65B0\u3057\u3044Excel\u30EF\u30FC\u30AF\u30D6\u30C3\u30AF\uFF08.xlsx\uFF09\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u4F7F\u7528\u3059\u308B\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3002","selectButton":"\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E","clearButton":"Cephable\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u8A2D\u5B9A\u3092\u4F7F\u7528\u3059\u308B","current":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\uFF1A ","default":"Cephable\u306B\u7D44\u307F\u8FBC\u307E\u308C\u3066\u3044\u308B\u30C7\u30D5\u30A9\u30EB\u30C8\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306B\u30D6\u30E9\u30F3\u30C9\u30B9\u30BF\u30A4\u30EB\u3092\u9069\u7528\u3057\u3066\u4F7F\u7528\u3057\u307E\u3059\u3002"},"automationBrowser":{"title":"\u81EA\u52D5\u5316\u30D6\u30E9\u30A6\u30B6\u306E\u53EF\u8996\u6027","description":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u304CCephable\u30D6\u30E9\u30A6\u30B6\uFF08\u30A6\u30A7\u30D6\u691C\u7D22\u3001Google\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8/\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8/\u30B9\u30E9\u30A4\u30C9\u3001Gmail\u3001\u30C9\u30E9\u30A4\u30D6\uFF09\u3092\u4F7F\u7528\u3059\u308B\u5834\u5408\u3001\u901A\u5E38\u306F\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u96A0\u308C\u3066\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u4F5C\u696D\u3092\u59A8\u3052\u307E\u305B\u3093\u3002\u3053\u306E\u6A5F\u80FD\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u52D5\u4F5C\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002","question":"AI\u304C\u52D5\u4F5C\u3057\u3066\u3044\u308B\u9593\u3001\u81EA\u52D5\u5316\u30D6\u30E9\u30A6\u30B6\u3092\u8868\u793A\u3057\u307E\u3059\u304B\uFF1F"}},"input":{"title":"\u5165\u529B","titlePlural":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","explore":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u308B","descriptionShort":"Cephable \u304C\u3088\u308A\u826F\u3044\u30C7\u30B8\u30BF\u30EB \u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u3079\u3066\u307F\u307E\u3057\u3087\u3046\u3002","typeLabel":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30BF\u30A4\u30D7","toolTip":"\u3053\u308C\u306F{{alt}}\u3092\u4F7F\u7528\u3057\u307E\u3059","remove":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664","filter":"\u5165\u529B\u30BF\u30A4\u30D7\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0","select":"\u5165\u529B\u3092\u9078\u629E","question":"\u3069\u306E\u3088\u3046\u306A\u30BF\u30A4\u30D7\u306E\u5165\u529B\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?","add":"\u5165\u529B\u3092\u8FFD\u52A0","addMore":"\u5225\u306E\u5165\u529B\u3092\u8FFD\u52A0\u3059\u308B","removeItem":"\u30A2\u30A4\u30C6\u30E0 {{index}} \u3092\u524A\u9664","item":"\u30A2\u30A4\u30C6\u30E0 {{index}}: {{label}}","duplicate":"\u91CD\u8907\u3057\u305F\u30A2\u30A4\u30C6\u30E0\u306F\u8A31\u53EF\u3055\u308C\u307E\u305B\u3093\u3002","maximum":"\u8A31\u53EF\u3055\u308C\u308B\u30A2\u30A4\u30C6\u30E0\u306E\u6700\u5927\u6570\u306F {{maxItems}} \u500B\u3067\u3059\u3002","description":"\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3059\u308B\u305F\u3081\u306E\u69D8\u3005\u306A\u65B9\u6CD5\u3092\u6307\u3057\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u97F3\u58F0\u3001\u982D\u306E\u52D5\u304D\u3001\u8868\u60C5\u3001\u305D\u306E\u4ED6\u306E\u63A5\u7D9A\u306A\u3069\u3067\u3059\u3002\u8A73\u3057\u304F\u306F\u3001\u4EE5\u4E0B\u306E\u69D8\u3005\u306A\u5165\u529B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"time":{"soon":"\u8FD1\u65E5\u516C\u958B","now":"\u4ECA","today":"\u4ECA\u65E5","yesterday":"\u6628\u65E5","minutesAgo":"{{count}} \u5206\u524D","minutesAgo_plural":"{{count}} \u5206\u524D","daysAgo":"{{count}}\u65E5\u524D","daysAgo_plural":"{{count}}\u65E5\u524D","monthsAgo":"{{count}} \u304B\u6708\u524D","monthsAgo_plural":"{{count}}\u304B\u6708\u524D","yearsAgo":"{{count}}\u5E74\u524D","yearsAgo_plural":"{{count}}\u5E74\u524D","minutesAhead":"{{count}}\u5206\u5F8C","todayAhead":"\u4ECA\u65E5\u9045\u304F","tomorrow":"\u660E\u65E5","daysAhead":"{{count}}\u65E5\u5F8C","monthsAhead":"{{count}}\u304B\u6708\u4EE5\u5185","yearsAhead":"{{count}}\u5E74"},"peripherals":{"empty":"\u5468\u8FBA\u6A5F\u5668\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F","switch":"\u30B9\u30A4\u30C3\u30C1","keyboard":"\u30AD\u30FC\u30DC\u30FC\u30C9","gamepad":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9","companionApp":"\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA","available":"\u4F7F\u7528\u53EF\u80FD","error":"\u8A2D\u5B9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"camera":{"windowTitle":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","title":"\u30AB\u30E1\u30E9","titlePlural":"\u30AB\u30E1\u30E9","settings":"\u30AB\u30E1\u30E9\u8A2D\u5B9A","start":"\u30AB\u30E1\u30E9\u3092\u8D77\u52D5","restart":"\u30AB\u30E1\u30E9\u3092\u518D\u8D77\u52D5","descriptionShort":"\u9854\u306E\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u53EF\u80FD\u306B\u3057\u307E\u3059\u3002","description":"\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3057\u3066\u3001\u9854\u306E\u8868\u60C5\u3084\u4F53\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3092\u3055\u307E\u3056\u307E\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u3057\u3066\u691C\u51FA\u3057\u307E\u3059\u3002","empty":"\u30AB\u30E1\u30E9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","search":"\u30AB\u30E1\u30E9\u540D\u3067\u691C\u7D22","loading":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","error":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u4E88\u671F\u3057\u306A\u3044\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9\u3092\u78BA\u8A8D\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","manage":{"title":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30AB\u30E1\u30E9\u306E\u8A73\u7D30\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","description":""},"detected":{"face":"\u9854\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002","noFace":"\u9854\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30AB\u30E1\u30E9\u307E\u305F\u306F\u4F4D\u7F6E\u3092\u8ABF\u6574\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","command":"\u691C\u51FA: {{command}}"},"permission":{"title":"\u30AB\u30E1\u30E9\u306E\u8A31\u53EF\u304C\u5FC5\u8981\u3067\u3059","description":"\u9854\u3068\u4F53\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001Cephable \u306B\u30AB\u30E1\u30E9\u306E\u4F7F\u7528\u8A31\u53EF\u3092\u4E0E\u3048\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","button":"\u6A29\u9650\u8A2D\u5B9A\u3092\u958B\u304F","no":"\u30AB\u30E1\u30E9\u30A2\u30AF\u30BB\u30B9\u4E0D\u53EF","help":"Cephable\u306F\u3001\u8868\u60C5\u3084\u982D\u90E8\u306E\u5236\u5FA1\u3092\u884C\u3046\u305F\u3081\u306B\u30AB\u30E1\u30E9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u5FC5\u8981\u3068\u3057\u307E\u3059\u3002<strong>\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A</strong>&gt;<strong>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3</strong>&gt; <strong>{{pane}}</strong>\u306B\u79FB\u52D5\u3057\u3001Cephable\u304C\u30AB\u30E1\u30E9\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"controls":{"startData":"\u9854\u30C7\u30FC\u30BF\u306E\u8A18\u9332\u3092\u958B\u59CB\u3057\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9 \u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u3082\u3046\u4E00\u5EA6\u62BC\u3059\u3068\u3001\u8A18\u9332\u304C\u505C\u6B62\u3057\u3001\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002","downloadData":"\u9332\u753B\u3092\u505C\u6B62\u3057\u307E\u3057\u305F\u3002\u30C7\u30FC\u30BF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3044\u307E\u3059","paused":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","pause":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62","resume":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u518D\u958B","resumed":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u518D\u958B\u3057\u307E\u3057\u305F\u3002","linesOn":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3\u3092\u30AA\u30F3\u306B\u3059\u308B","linesOff":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3\u3092\u6D88\u3059","linesToggle":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3\u306E\u63CF\u753B\u3092\u5207\u308A\u66FF\u3048\u308B","noDeviceTitle":"Cephable \u3067\u4F7F\u7528\u3067\u304D\u308B\u30AB\u30E1\u30E9\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002","noDeviceDescription":"\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3068\u4E92\u63DB\u6027\u306E\u3042\u308B\u30AB\u30E1\u30E9\u3092\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","noDeviceConnectedDescription":"\u30AB\u30E1\u30E9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30A4\u30B9\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u3068\u3057\u3066\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30B9\u30C6\u30C3\u30D7\u306F\u6B63\u5E38\u306B\u5B9F\u884C\u3055\u308C\u307E\u305B\u3093\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u3053\u306E\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3 \u30C7\u30D0\u30A4\u30B9\u3092\u5225\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u63A5\u7D9A\u3057\u307E\u3059\u3002","lines":"\u30D5\u30A7\u30A4\u30B9\u30E9\u30A4\u30F3"},"switch":{"title":"\u30AB\u30E1\u30E9\u3092\u5207\u308A\u66FF\u3048\u308B","description":"\u9854\u3068\u4F53\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u4F7F\u7528\u3059\u308B\u5225\u306E\u30AB\u30E1\u30E9\u3092\u9078\u629E\u3057\u307E\u3059\u3002","select":"\u30AB\u30E1\u30E9\u3092\u9078\u629E","next":"\u6B21\u306E\u30AB\u30E1\u30E9","nextLong":"\u6B21\u306E\u30AB\u30E1\u30E9\u306B\u5207\u308A\u66FF\u3048\u308B","empty":"\u4ED6\u306E\u30AB\u30E1\u30E9\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002","search":"\u30AB\u30E1\u30E9\u540D\u3067\u691C\u7D22"},"baseline":{"title":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3","description":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u306F\u3001Cephable \u304C\u52D5\u304D\u3092\u5224\u65AD\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u9854\u3068\u4F53\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u4F4D\u7F6E\u3067\u3059\u3002\u3053\u3053\u3067\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u3092\u66F4\u65B0\u304A\u3088\u3073\u30EA\u30BB\u30C3\u30C8\u3067\u304D\u307E\u3059\u3002","update":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u306E\u66F4\u65B0","reset":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u3092\u30EA\u30BB\u30C3\u30C8","updated":"\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F","tooltip":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30D9\u30FC\u30B9\u30E9\u30A4\u30F3\u304C\u73FE\u5728\u306E\u4F11\u606F\u4F4D\u7F6E\u306B\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002"},"edit":{"title":"\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3059\u308B","description":"\u30AB\u30E1\u30E9\u3092\u5FC5\u8981\u3068\u3059\u308B\u5165\u529B\u306E\u8A2D\u5B9A\u3092\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002","autoStart":{"title":"\u30AB\u30E1\u30E9\u3092\u81EA\u52D5\u7684\u306B\u8D77\u52D5","option":"\u30AB\u30E1\u30E9\u3068\u30D8\u30C3\u30C9/\u8868\u60C5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u81EA\u52D5\u8D77\u52D5\u3057\u307E\u3059\u304B?","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u8D77\u52D5\u6642\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u304C\u30AB\u30E1\u30E9\u3092\u8D77\u52D5\u3057\u3001\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u30AA\u30D5\u306E\u5834\u5408\u306F\u3001\u63A5\u7D9A\u30DA\u30FC\u30B8\u3067\u300C\u30AB\u30E1\u30E9\u3092\u8D77\u52D5\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"head":{"title":"\u982D\u306E\u52D5\u304D\u306E\u611F\u5EA6","description":"\u611F\u5EA6\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u3069\u308C\u3060\u3051\u79FB\u52D5\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092 Cephable \u306B\u4F1D\u3048\u307E\u3059\u3002\u5024\u304C\u5927\u304D\u3044\u307B\u3069 (\u30B9\u30E9\u30A4\u30C0\u30FC\u306E\u53F3\u7AEF)\u3001\u611F\u5EA6\u304C\u9AD8\u304F\u306A\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u79FB\u52D5\u304C\u5C11\u306A\u304F\u306A\u308A\u307E\u3059\u3002","tilt":{"title":"\u30D8\u30C3\u30C9\u30C6\u30A3\u30EB\u30C8\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u4E0A\u4E0B\u5DE6\u53F3\u306B\u3069\u308C\u3060\u3051\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","up":"\u4E0A\u65B9\u5411\u50BE\u659C\u611F\u5EA6","down":"\u30C1\u30EB\u30C8\u30C0\u30A6\u30F3\u611F\u5EA6","left":"\u5DE6\u50BE\u659C\u611F\u5EA6","right":"\u53F3\u50BE\u304D\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306B\u50BE\u304F","scaleLow":"\u5927\u304D\u306A\u50BE\u659C"},"turn":{"title":"\u30D8\u30C3\u30C9\u30BF\u30FC\u30F3\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u5DE6\u53F3\u306B\u3069\u308C\u3060\u3051\u56DE\u3059\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","left":"\u5DE6\u6298\u611F\u5EA6","right":"\u53F3\u6298\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306B\u66F2\u304C\u308B","scaleLow":"\u5927\u30BF\u30FC\u30F3"},"lean":{"title":"\u30D8\u30C3\u30C9\u30EA\u30FC\u30F3\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u524D\u5F8C\u306B\u3069\u308C\u3060\u3051\u50BE\u3051\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","forward":"\u524D\u50BE\u611F\u5EA6","back":"\u30EA\u30FC\u30F3\u30D0\u30C3\u30AF\u611F\u5EA6","right":"\u53F3\u50BE\u304D\u611F\u5EA6","left":"\u5DE6\u50BE\u304D\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306B\u50BE\u304F","scaleLow":"\u30E9\u30FC\u30B8\u30EA\u30FC\u30F3"},"duck":{"title":"\u30D8\u30C3\u30C9\u30C0\u30C3\u30AF/\u30E9\u30A4\u30BA\u611F\u5EA6","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u982D\u3092\u3069\u308C\u3060\u3051\u4E0B\u3052\u305F\u308A\u4E0A\u3052\u305F\u308A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","down":"\u30C0\u30C3\u30AF\u30C0\u30A6\u30F3\u611F\u5EA6","up":"\u30E9\u30A4\u30BA\u30A2\u30C3\u30D7\u611F\u5EA6","scaleHigh":"\u308F\u305A\u304B\u306A\u5909\u5316","scaleLow":"\u5927\u304D\u306A\u5909\u5316"}},"face":{"title":"\u8868\u60C5\u306E\u654F\u611F\u3055","description":"\u611F\u5EA6\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u8868\u73FE\u3092\u3069\u306E\u7A0B\u5EA6\u8A87\u5F35\u3059\u308B\u304B\u3092 Cephable \u306B\u4F1D\u3048\u307E\u3059\u3002\u5024\u304C\u5927\u304D\u3044\u307B\u3069 (\u30B9\u30E9\u30A4\u30C0\u30FC\u306E\u53F3\u7AEF)\u3001\u611F\u5EA6\u304C\u9AD8\u304F\u306A\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u52D5\u304D\u304C\u5C11\u306A\u304F\u306A\u308A\u307E\u3059\u3002","eyebrow":{"title":"\u7709\u6BDB\u306E\u654F\u611F\u3055","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u7709\u6BDB\u3092\u3069\u306E\u304F\u3089\u3044\u4E0A\u3052\u305F\u308A\u4E0B\u3052\u305F\u308A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","up":"\u7709\u6BDB\u306E\u611F\u5EA6\u3092\u9AD8\u3081\u308B","scaleHigh":"\u308F\u305A\u304B\u306B\u4E0A\u3052\u308B","scaleLow":"\u5927\u5E45\u306A\u5024\u4E0A\u3052"},"mouth":{"title":"\u53E3\u306E\u654F\u611F\u3055","description":"\u3053\u308C\u3089\u306E\u5024\u306F\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u305F\u3081\u306B\u53E3\u3092\u3069\u308C\u3060\u3051\u958B\u3044\u305F\u308A\u9589\u3058\u305F\u308A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","open":"\u53E3\u3092\u958B\u3051\u305F\u3068\u304D\u306E\u654F\u611F\u3055","close":"\u53E3\u3092\u9589\u3058\u308B\u611F\u899A","smile":"\u7B11\u9854\u306E\u654F\u611F\u3055","scaleHigh":"\u308F\u305A\u304B\u306B\u958B\u3044\u3066\u3044\u308B","scaleLow":"\u5927\u304D\u304F\u958B\u304F","closeScaleHigh":"\u308F\u305A\u304B\u306B\u9589\u3058\u305F","closeScaleLow":"\u3057\u3063\u304B\u308A\u3068\u9589\u3058\u305F","smileScaleHigh":"\u5FAE\u7B11\u307F","smileScaleLow":"\u5927\u304D\u306A\u7B11\u9854"}},"mouse":{"title":"\u30DE\u30A6\u30B9\u64CD\u4F5C\u306E\u305F\u3081\u306E\u982D\u306E\u52D5\u304D","description":"\u4ED6\u306E\u51FA\u529B\u3092\u30C8\u30EA\u30AC\u30FC\u3059\u308B\u4EE3\u308F\u308A\u306B\u3001\u30D8\u30C3\u30C9\u79FB\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u30DE\u30A6\u30B9\u3092\u79FB\u52D5\u3059\u308B\u304B\u3069\u3046\u304B\u3001\u307E\u305F\u305D\u306E\u5834\u5408\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","enable":{"title":"\u30DE\u30A6\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30D8\u30C3\u30C9\u79FB\u52D5\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30C8\u30EA\u30AC\u30FC \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4EE3\u308F\u308A\u306B\u3001\u30D8\u30C3\u30C9 \u30E0\u30FC\u30D6\u30E1\u30F3\u30C8 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E00\u90E8\u304C\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","option":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306B\u30D8\u30C3\u30C9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"input":{"title":"\u30DE\u30A6\u30B9\u5165\u529B\u30BF\u30A4\u30D7","description":"\u30DE\u30A6\u30B9 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u5272\u308A\u5F53\u3066\u308B\u30D8\u30C3\u30C9 \u30B8\u30A7\u30B9\u30C1\u30E3\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u305F\u3068\u3048\u3070\u3001\u300C\u982D\u3092\u50BE\u3051\u308B\u300D\u306F\u3001\u982D\u3092\u5DE6\u53F3\u306B\u50BE\u3051\u3066\u30DE\u30A6\u30B9\u3092\u5DE6\u53F3\u306B\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u3001\u300C\u982D\u3092\u56DE\u3059\u300D\u306F\u3001\u982D\u3092\u5DE6\u53F3\u306B\u56DE\u3057\u3066\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u3001\u300C\u982D\u3092\u50BE\u3051\u308B\u300D\u306F\u3001\u982D\u3092\u5DE6\u53F3\u306B\u50BE\u3051\u3066\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u3053\u3068\u304C\u3067\u304D\u308B\u3053\u3068\u3092\u610F\u5473\u3057\u307E\u3059\u3002","option":"\u5165\u529B\u30BF\u30A4\u30D7\u3092\u9078\u629E","optionLong":"\u30DE\u30A6\u30B9\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u30D8\u30C3\u30C9\u306E\u52D5\u304D\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"invert":{"title":"\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u982D\u3092\u52D5\u304B\u3059\u65B9\u5411\u304C\u30DE\u30A6\u30B9\u3092\u52D5\u304B\u3059\u65B9\u5411\u3068\u53CD\u8EE2\u3057\u307E\u3059\u3002X \u8EF8\u306E\u5834\u5408: \u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u5DE6\u306B\u52D5\u304B\u3059\u3068\u30DE\u30A6\u30B9\u306F\u53F3\u306B\u79FB\u52D5\u3057\u3001\u53F3\u306B\u52D5\u304B\u3059\u3068\u5DE6\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002Y \u8EF8\u306E\u5834\u5408: \u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u4E0B\u306B\u52D5\u304B\u3059\u3068\u30DE\u30A6\u30B9\u306F\u4E0A\u306B\u79FB\u52D5\u3057\u3001\u4E0A\u306B\u52D5\u304B\u3059\u3068\u4E0B\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002","x":"X\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?","y":"Y\u8EF8\u306E\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3092\u53CD\u8EE2\u3057\u307E\u3059\u304B?"},"mode":{"title":"\u30DE\u30A6\u30B9\u79FB\u52D5\u30E2\u30FC\u30C9","description":"\u982D\u306E\u52D5\u304D\u306B\u5BFE\u3057\u3066\u30AB\u30FC\u30BD\u30EB\u304C\u3069\u306E\u3088\u3046\u306B\u53CD\u5FDC\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"speed":{"title":"\u30DE\u30A6\u30B9\u306E\u901F\u5EA6","description":"\u30AB\u30FC\u30BD\u30EB\u3092\u79FB\u52D5\u3055\u305B\u305F\u3044\u4E00\u5B9A\u306E\u901F\u5EA6\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002","fast":"\u901F\u3044","slow":"\u9045\u3044"},"linear":{"title":"\u30DE\u30A6\u30B9\u306E\u76F4\u7DDA\u79FB\u52D5","description":"\u3053\u308C\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306F\u6C34\u5E73\u307E\u305F\u306F\u5782\u76F4\u306E\u76F4\u7DDA\u306E\u307F\u306B\u79FB\u52D5\u3059\u308B\u305F\u3081\u3001\u659C\u3081\u306B\u30C9\u30EA\u30D5\u30C8\u3059\u308B\u3053\u3068\u306A\u304F\u7279\u5B9A\u306E\u65B9\u5411\u306B\u7C21\u5358\u306B\u79FB\u52D5\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","option":"\u30DE\u30A6\u30B9\u306E\u76F4\u7DDA\u79FB\u52D5\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"accelerationRate":{"title":"\u30DE\u30A6\u30B9\u52A0\u901F\u5FDC\u7B54\u9045\u5EF6","description":"\u30DE\u30A6\u30B9\u306E\u901F\u5EA6\u304C\u4E0A\u304C\u308B\u307E\u3067\u306B\u304B\u304B\u308B\u30DF\u30EA\u79D2\u6570\u3002"},"accelerationCurve":{"title":"\u30DE\u30A6\u30B9\u52A0\u901F\u66F2\u7DDA","description":"\u982D\u306E\u52D5\u304D\u306B\u5FDC\u3058\u3066\u30AB\u30FC\u30BD\u30EB\u306E\u901F\u5EA6\u304C\u5897\u52A0\u3059\u308B\u901F\u5EA6\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","linear":"\u30EA\u30CB\u30A2","exponential":"\u6307\u6570\u95A2\u6570","sublinear":"\u30B5\u30D6\u30EA\u30CB\u30A2"},"maximumSpeed":{"title":"\u6700\u5927\u30DE\u30A6\u30B9\u901F\u5EA6","description":"\u30AB\u30FC\u30BD\u30EB\u304C 1 \u79D2\u9593\u306B\u79FB\u52D5\u3067\u304D\u308B\u6700\u5927\u30D4\u30AF\u30BB\u30EB\u6570\u3092\u6C7A\u5B9A\u3057\u307E\u3059\u3002"},"off":{"title":"\u30AA\u30D5","description":"\u30DE\u30A6\u30B9\u306E\u79FB\u52D5\u306F\u7121\u52B9\u3067\u3059\u3002"},"steadyGlide":{"title":"\u5B89\u5B9A\u3057\u305F\u6ED1\u7A7A","description":"\u982D\u3092\u7279\u5B9A\u306E\u30DD\u30A4\u30F3\u30C8\u3092\u8D85\u3048\u3066\u52D5\u304B\u3059\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306F\u4E00\u5B9A\u306E\u901F\u5EA6\u3067\u305D\u306E\u65B9\u5411\u306B\u9023\u7D9A\u7684\u306B\u52D5\u304D\u307E\u3059\u3002"},"speedBoost":{"title":"\u30B9\u30D4\u30FC\u30C9\u30D6\u30FC\u30B9\u30C8","description":"\u982D\u3092\u540C\u3058\u4F4D\u7F6E\u306B\u9577\u304F\u4FDD\u3064\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306E\u52D5\u304D\u304C\u901F\u304F\u306A\u308A\u307E\u3059\u3002\u982D\u3092\u52D5\u304B\u3055\u305A\u306B\u9577\u304F\u4FDD\u3064\u3068\u3001\u30AB\u30FC\u30BD\u30EB\u306E\u52A0\u901F\u3082\u901F\u304F\u306A\u308A\u307E\u3059\u3002"},"dynamicGlide":{"title":"\u30C0\u30A4\u30CA\u30DF\u30C3\u30AF\u30B0\u30E9\u30A4\u30C9","description":"\u30AB\u30FC\u30BD\u30EB\u306E\u901F\u5EA6\u306F\u3001\u982D\u3092\u52D5\u304B\u3059\u8DDD\u96E2\u306B\u5FDC\u3058\u3066\u5897\u52A0\u3057\u307E\u3059\u3002\u982D\u3092\u52D5\u304B\u3059\u8DDD\u96E2\u304C\u9577\u3044\u307B\u3069\u3001\u30AB\u30FC\u30BD\u30EB\u306E\u79FB\u52D5\u901F\u5EA6\u304C\u901F\u304F\u306A\u308A\u307E\u3059\u3002"},"proportionalSpeed":{"title":"\u6BD4\u4F8B\u901F\u5EA6","description":"\u30AB\u30FC\u30BD\u30EB\u306F\u753B\u9762\u306E\u30B5\u30A4\u30BA\u306B\u6BD4\u4F8B\u3057\u3066\u9F3B\u5148\u306B\u6CBF\u3063\u3066\u52D5\u304D\u307E\u3059\u3002"},"disabled":"\u3053\u306E\u6A5F\u80FD\u306F\u3001\u30EA\u30E2\u30FC\u30C8\u63A5\u7D9A\u304A\u3088\u3073\u62E1\u5F35\u6A5F\u80FD\u3067\u306F\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002"}},"stop":"\u30AB\u30E1\u30E9\u3092\u505C\u6B62","show":"\u30AB\u30E1\u30E9\u3092\u8868\u793A","hide":"\u30AB\u30E1\u30E9\u3092\u96A0\u3059","warn":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u958B\u59CB\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u9854\u3068\u4F53\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A31\u53EF\u3059\u308B\u306B\u306F\u3001\u30AB\u30E1\u30E9\u3092\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002","draw":{"error":"\u30AB\u30E1\u30E9\u30D5\u30A3\u30FC\u30C9\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9\u3092\u78BA\u8A8D\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"select":"\u9854\u3001\u4F53\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3 \u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u5F37\u5316\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u884C\u3046\u306B\u306F\u3001\u30DA\u30A2\u30EA\u30F3\u30B0\u3059\u308B\u30AB\u30E1\u30E9\u3092\u9078\u629E\u3057\u307E\u3059\u3002","extension":{"title":"\u62E1\u5F35\u6A5F\u80FD: \u30AB\u30E1\u30E9","enabledTitle":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6709\u52B9\u306B\u3059\u308B","enabledDescription":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable\u306F\u30AB\u30E1\u30E9\u3092\u4F7F\u7528\u3057\u3066\u9854\u3068\u982D\u306E\u52D5\u304D\u3092\u691C\u51FA\u3057\u3001\u8868\u60C5\u3084\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3067\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u306F\u3001\u982D\u306E\u52D5\u304D\u3092\u30DE\u30A6\u30B9\u306E\u3088\u3046\u306B\u4F7F\u3046\u3053\u3068\u3082\u542B\u307E\u308C\u307E\u3059\u3002"},"live":"\u30E9\u30A4\u30D6","paused":"\u30AB\u30E1\u30E9\u304C\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F"},"microphone":{"windowTitle":"\u982D\u3067\u8A8D\u8B58\u3067\u304D\u308B\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","title":"\u30DE\u30A4\u30AF\u30ED\u30D5\u30A9\u30F3","titlePlural":"\u30DE\u30A4\u30AF","settings":"\u30DE\u30A4\u30AF\u8A2D\u5B9A","start":"\u30DE\u30A4\u30AF\u3092\u958B\u59CB","stop":"\u30DE\u30A4\u30AF\u3092\u505C\u6B62","descriptionShort":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002","description":"\u5185\u8535\u30DE\u30A4\u30AF\u3092\u4F7F\u7528\u3057\u3066\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002","select":"\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u305F\u5236\u5FA1\u3092\u5F37\u5316\u3059\u308B\u305F\u3081\u306B\u3001\u30DA\u30A2\u30EA\u30F3\u30B0\u3059\u308B\u30DE\u30A4\u30AF\u3092\u9078\u629E\u3057\u307E\u3059\u3002","empty":"\u30DE\u30A4\u30AF\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","search":"\u30DE\u30A4\u30AF\u540D\u3067\u691C\u7D22","manage":{"title":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30DE\u30A4\u30AF\u306E\u8A73\u7D30\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","description":""},"permission":{"title":"\u30DE\u30A4\u30AF\u306E\u8A31\u53EF\u304C\u5FC5\u8981\u3067\u3059","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001Cephable \u306B\u30DE\u30A4\u30AF\u306E\u4F7F\u7528\u8A31\u53EF\u3092\u4E0E\u3048\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","button":"\u6A29\u9650\u8A2D\u5B9A\u3092\u958B\u304F","no":"\u30DE\u30A4\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093","help":"Cephable\u306F\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u305F\u3081\u306B\u30DE\u30A4\u30AF\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u5FC5\u8981\u3068\u3057\u307E\u3059\u3002<strong>\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A</strong>&gt;<strong>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3</strong>&gt; <strong>{{pane}}</strong>\u306B\u79FB\u52D5\u3057\u3001Cephable\u304C\u30DE\u30A4\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"controls":{"loadingDetail":"\u3053\u308C\u306B\u306F\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002","pause":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62","paused":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","resume":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u518D\u958B\u3059\u308B","dictationPlay":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u958B\u59CB","dictationPause":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u505C\u6B62","prompt":"\u8A71\u3057\u59CB\u3081\u308B\u3068\u3001\u3053\u3053\u3067\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059...","dictationPrompt":"\u8A71\u3057\u59CB\u3081\u308B\u3068\u3001\u8A71\u3057\u305F\u5185\u5BB9\u304C\u5165\u529B\u3055\u308C\u307E\u3059...","latency":"\u9AD8\u3044\u9045\u5EF6\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u30EA\u30BD\u30FC\u30B9\u3092\u904E\u5270\u306B\u6D88\u8CBB\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u9589\u3058\u308B\u3053\u3068\u3092\u691C\u8A0E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","noDeviceConnectedDescription":"\u30DE\u30A4\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30A4\u30B9\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u3068\u3057\u3066\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30B9\u30C6\u30C3\u30D7\u306F\u6B63\u5E38\u306B\u5B9F\u884C\u3055\u308C\u307E\u305B\u3093\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u3053\u306E\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3 \u30C7\u30D0\u30A4\u30B9\u3092\u5225\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u63A5\u7D9A\u3057\u307E\u3059\u3002","status":{"loadingModel":"\u97F3\u58F0\u30E2\u30C7\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","thinking":"\u8003\u3048...","paused":"\u4E00\u6642\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","dictating":"\u53E3\u8FF0\u3059\u308B\u3002","optimistic":"\u697D\u89B3\u7684\uFF1A","listening":"\u30EA\u30B9\u30CB\u30F3\u30B0\uFF1A","loadingPhiModel":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30E2\u30C7\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","generatingText":"\u751F\u6210\u4E2D...","preparingPhiModel":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30E2\u30C7\u30EB\u3092\u6E96\u5099\u3057\u3066\u3044\u307E\u3059...","permission":"\u30DE\u30A4\u30AF\u306E\u6A29\u9650\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...","typing":"\u30BF\u30A4\u30D4\u30F3\u30B0..."},"generatingTextDetail":"\u30A2\u30D7\u30EA\u3092\u5909\u66F4\u3059\u308B\u304B\u3001\u300C\u751F\u6210\u3092\u505C\u6B62\u300D\u3068\u8A00\u3063\u3066\u751F\u6210\u3092\u505C\u6B62\u3057\u307E\u3059","command":"\u6307\u793A","contextual":"\u6587\u8108\u7684","send":"\u9001\u4FE1","typedInputLabel":"\u9001\u4FE1\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","listeningPlaceholder":"\u30EA\u30B9\u30CB\u30F3\u30B0...","dictationListeningPlaceholder":"\u30EA\u30B9\u30CB\u30F3\u30B0...","pausedPlaceholder":"\u58F0\u304C\u9014\u5207\u308C\u305F\u2026"},"edit":{"title":"\u30DE\u30A4\u30AF\u306E\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3059\u308B","autoStart":{"title":"\u81EA\u52D5\u8D77\u52D5\u30DE\u30A4\u30AF","option":"\u81EA\u52D5\u8D77\u52D5\u30DE\u30A4\u30AF","description":"\u30C7\u30D0\u30A4\u30B9\u306E\u96FB\u6E90\u3092\u5165\u308C\u308B\u3068\u3001\u81EA\u52D5\u7684\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306E\u805E\u304D\u53D6\u308A\u3092\u958B\u59CB\u3057\u307E\u3059\u3002\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u300C\u805E\u304D\u53D6\u308A\u3092\u958B\u59CB\u300D\u3092\u30BF\u30C3\u30D7\u3057\u3066\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"optimistic":{"title":"\u697D\u89B3\u7684\u3001\u3088\u308A\u9AD8\u901F\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","option":"\u697D\u89B3\u7684\u3001\u3088\u308A\u9AD8\u901F\u306A\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u97F3\u58F0\u64CD\u4F5C\u306E\u901F\u5EA6\u3068\u5FDC\u7B54\u6027\u304C\u5411\u4E0A\u3057\u307E\u3059\u304C\u3001\u591A\u5C11\u306E\u30DF\u30B9\u306F\u8A31\u5BB9\u3055\u308C\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u97F3\u58F0\u5165\u529B\u6A5F\u80FD\u3084\u3088\u308A\u67D4\u8EDF\u306A\u64CD\u4F5C\u6027\u3092\u6C42\u3081\u308B\u5834\u5408\u306F\u3001\u6A19\u6E96\u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u6CE8\uFF1A\u30B3\u30DE\u30F3\u30C9\u3092\u6B63\u78BA\u306B\u767A\u97F3\u3057\u306A\u3044\u3068\u3001\u30AA\u30D7\u30C6\u30A3\u30DF\u30B9\u30C6\u30A3\u30C3\u30AF\u30E2\u30FC\u30C9\u304C\u610F\u56F3\u305B\u305A\u8D77\u52D5\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"confirm":{"title":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u7D42\u4E86\u3059\u308B\u524D\u306B\u4FDD\u5B58\u3057\u307E\u3059\u304B?"},"aiCommands":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9","description":"\u81EA\u7136\u306A\u8A00\u8449\u3067\u30B3\u30DE\u30F3\u30C9\u3092\u767A\u8A71\u3057\u3066\u304F\u3060\u3055\u3044\u3002Cephable AI\u306F\u3001\u6B63\u78BA\u306A\u4E00\u81F4\u3092\u6C42\u3081\u306A\u304F\u3066\u3082\u3001\u3042\u306A\u305F\u306E\u610F\u56F3\u3092\u7406\u89E3\u3057\u307E\u3059\u3002","option":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9"},"aiDictation":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7","description":"\u81EA\u52D5\u53E5\u8AAD\u70B9\u3001\u56FA\u6709\u540D\u8A5E\u3001\u6587\u69CB\u9020\u306B\u5BFE\u5FDC\u3057\u305F\u3001\u5F37\u5316\u3055\u308C\u305F\u97F3\u58F0\u8A8D\u8B58\u6A5F\u80FD\u3002\u3088\u308A\u30B9\u30DE\u30FC\u30C8\u3067\u81EA\u7136\u306A\u97F3\u58F0\u5165\u529B\u3092\u5B9F\u73FE\u3059\u308B\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u300C[\u4F55\u304B]\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002","option":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u5165\u529B\u3068\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D4\u30F3\u30B0"},"description":"\u3053\u306E\u63A5\u7D9A\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u8A2D\u5B9A\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002","input":{"title":"\u30DE\u30A4\u30AF\u30ED\u30D5\u30A9\u30F3","description":"\u30DE\u30A4\u30AF\u306E\u97F3\u58F0\u5236\u5FA1\u3068\u97F3\u58F0\u5165\u529B\u306F\u3001Cephable\u304C\u9078\u629E\u3057\u305F\u8A2D\u5B9A\u3092\u8A18\u61B6\u3057\u3001\u63A5\u7D9A\u3055\u308C\u308B\u305F\u3073\u306B\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002","notConnected":"{{name}}\uFF08\u672A\u63A5\u7D9A\uFF09","systemDefault":"\u30B7\u30B9\u30C6\u30E0\u30C7\u30D5\u30A9\u30EB\u30C8"}},"warn":"\u30DE\u30A4\u30AF\u304C\u8D77\u52D5\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u8A31\u53EF\u3059\u308B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002","devices":{"error":"\u30DE\u30A4\u30AF\u5165\u529B\u30C7\u30D0\u30A4\u30B9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"},"startDescription":"\u30B3\u30DE\u30F3\u30C9\u306E\u805E\u304D\u53D6\u308A\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002","context":{"add":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0\u3059\u308B","title":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0\u3059\u308B","highlighted":"\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8","clipboard":"\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9","other":"\u4ED6\u306E\u2026","otherTitle":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0\u3059\u308B","otherPlaceholder":"\u4F7F\u7528\u3059\u308B\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u307E\u305F\u306F\u8CBC\u308A\u4ED8\u3051\u308B","otherConfirm":"\u8FFD\u52A0","otherCancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","remove":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u524A\u9664","required":"{{mode}}\u306B\u306F\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u304C\u5FC5\u8981\u3067\u3059","files":"\u30D5\u30A1\u30A4\u30EB\u2026","folders":"\u30D5\u30A9\u30EB\u30C0\u30FC\u2026","removeAttachment":"\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664","dropToAttach":"\u30D5\u30A1\u30A4\u30EB\u3084\u30D5\u30A9\u30EB\u30C0\u3092\u30C9\u30E9\u30C3\u30B0\uFF06\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3068\u3057\u3066\u6DFB\u4ED8\u3057\u307E\u3059\u3002","otherLabel":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8"}},"localization":{"title":"\u8A00\u8A9E\u8A2D\u5B9A","titleShort":"\u8A00\u8A9E","description":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u8A00\u8A9E\u306E\u30EA\u30B9\u30C8\u304B\u3089\u5E0C\u671B\u306E\u8A00\u8A9E\u3092\u9078\u629E\u3057\u307E\u3059\u3002","newUserDescription":"\u7D9A\u884C\u3059\u308B\u524D\u306B\u3001\u5E0C\u671B\u3059\u308B\u8A00\u8A9E\u3092\u9078\u629E\u3057\u307E\u3059\u3002","edit":"\u8A00\u8A9E\u306E\u66F4\u65B0","display":{"title":"\u8868\u793A\u8A00\u8A9E","description":"Cephable \u306E\u4F7F\u7528\u6642\u306B\u8868\u793A\u3055\u308C\u308B\u8A00\u8A9E\u3002\u3053\u308C\u306B\u306F\u3001\u9078\u629E\u3057\u305F\u8A00\u8A9E\u3067\u8868\u793A\u3055\u308C\u308B\u30E1\u30CB\u30E5\u30FC\u3001\u901A\u77E5\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306A\u3069\u304C\u542B\u307E\u308C\u307E\u3059\u3002"},"voice":{"title":"\u97F3\u58F0\u5236\u5FA1\u8A00\u8A9E","description":"\u3053\u308C\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u8A8D\u8B58\u3059\u308B\u3068\u304D\u306B\u4F7F\u7528\u3055\u308C\u308B\u8A00\u8A9E\u3067\u3059\u3002\u8A00\u8A9E\u3092\u6307\u5B9A\u3059\u308B\u3068\u3001\u97F3\u58F0\u5165\u529B\u306E\u7CBE\u5EA6\u304C\u5411\u4E0A\u3057\u307E\u3059\u3002","settings":{"title":"\u97F3\u58F0\u8A8D\u8B58\u3068\u8868\u793A\u8A00\u8A9E","description":"\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u3068\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4E21\u65B9\u306E\u8A00\u8A9E\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002\u3053\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u753B\u9762\u4E0A\u306E\u30C6\u30AD\u30B9\u30C8\u3084\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u306E\u30DE\u30A4\u30AF\u306E\u64CD\u4F5C\u306B\u4F7F\u7528\u3059\u308B\u8A00\u8A9E\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002"}},"locales":{"en":"English - \u82F1\u8A9E","en-us":"English (US) - \u82F1\u8A9E\uFF08\u7C73\u56FD\uFF09","es":"Espa\xf1ol \u2014 \u30B9\u30DA\u30A4\u30F3\u8A9E","fr":"Fran\xe7ais \u2014 \u30D5\u30E9\u30F3\u30B9\u8A9E","it":"Italiano \u2014 \u30A4\u30BF\u30EA\u30A2\u8A9E","de":"Deutsch \u2014 \u30C9\u30A4\u30C4\u8A9E","ja":"\u65E5\u672C\u8A9E","en-gb":"English (UK) - \u82F1\u8A9E\uFF08\u82F1\u56FD\uFF09","en-in":"English (India) - \u82F1\u8A9E\uFF08\u30A4\u30F3\u30C9\uFF09"},"save":{"success":"\u30E6\u30FC\u30B6\u30FC\u306E\u30ED\u30B1\u30FC\u30EB\u8A2D\u5B9A\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E6\u30FC\u30B6\u30FC\u306E\u30ED\u30B1\u30FC\u30EB\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"profile":{"view":"\u5909\u7A2E","title":"\u30A2\u30D7\u30EA\u5236\u5FA1\u8A00\u8A9E","question":"\u3069\u306E\u30A2\u30D7\u30EA\u5236\u5FA1\u8A00\u8A9E\u3092\u7DE8\u96C6\u3057\u307E\u3059\u304B?","description":"\u4E00\u90E8\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u7570\u306A\u308B\u8A00\u8A9E\u306E\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3\u304C\u7528\u610F\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5225\u306E\u8A00\u8A9E\u306B\u5207\u308A\u66FF\u3048\u3066\u7DE8\u96C6\u3057\u3001\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u304F\u3060\u3055\u3044\u3002","change":"\u8A00\u8A9E\u3092\u5909\u66F4"},"unsupported":{"title":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u8A00\u8A9E {{locale}}","description":"\u9078\u629E\u3057\u305F\u8A00\u8A9E\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u5225\u306E\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"select":"\u8A00\u8A9E\u3092\u9078\u629E","localesShort":{"en":"\u82F1\u8A9E","en-us":"\u82F1\u8A9E\uFF08\u7C73\u56FD\uFF09","es":"\u30B9\u30DA\u30A4\u30F3\u8A9E","fr":"\u30D5\u30E9\u30F3\u30B9\u8A9E","it":"\u30A4\u30BF\u30EA\u30A2\u8A9E","de":"\u30C9\u30A4\u30C4\u8A9E","ja":"\u65E5\u672C\u8A9E","en-gb":"\u82F1\u8A9E\uFF08\u30A4\u30AE\u30EA\u30B9\uFF09","en-in":"\u82F1\u8A9E\uFF08\u30A4\u30F3\u30C9\uFF09"}},"editor":{"title":"\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u30A8\u30C7\u30A3\u30BF\u30FC","bold":"\u5927\u80C6\u306A","italic":"\u30A4\u30BF\u30EA\u30C3\u30AF","underline":"\u4E0B\u7DDA","strikethrough":"\u53D6\u308A\u6D88\u3057\u7DDA","hr":"\u6C34\u5E73\u7DDA","link":"\u30EA\u30F3\u30AF","quote":"\u5F15\u7528","code":"\u30B3\u30FC\u30C9","codeBlock":"\u30B3\u30FC\u30C9\u30D6\u30ED\u30C3\u30AF","comment":"\u30B3\u30E1\u30F3\u30C8","image":"\u753B\u50CF","table":"\u30C6\u30FC\u30D6\u30EB","unordered-list":"\u9806\u5E8F\u306A\u3057\u30EA\u30B9\u30C8","ordered-list":"\u9806\u5E8F\u4ED8\u304D\u30EA\u30B9\u30C8","checked-list":"\u30C1\u30A7\u30C3\u30AF\u30EA\u30B9\u30C8","help":"\u30D8\u30EB\u30D7","edit":"\u7DE8\u96C6","live":"\u30E9\u30A4\u30D6","preview":"\u30D7\u30EC\u30D3\u30E5\u30FC","fullscreen":"\u5168\u753B\u9762\u8868\u793A","placeholder":"\u3053\u3053\u306B Markdown \u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044..."},"resume":"\u518D\u958B\u3059\u308B","panel":{"title":"\u982D\u84CB\u9AA8\u30D1\u30CD\u30EB","question":"\u81EA\u52D5\u8D77\u52D5\u30D1\u30CD\u30EB?","position":{"top":"\u30C8\u30C3\u30D7","right":"\u53F3","left":"\u5DE6","bottom":"\u5E95 ","description":"Cephable \u30D1\u30CD\u30EB\u3092\u753B\u9762\u4E0A\u306E\u3069\u3053\u306B\u8868\u793A\u3059\u308B\u304B\u3092\u9078\u629E\u3057\u307E\u3059\u3002","label":"\u4F4D\u7F6E"},"sections":{"description":"\u30D1\u30CD\u30EB\u5185\u306E\u8868\u793A\u3059\u308B\u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u597D\u307F\u306B\u5FDC\u3058\u3066\u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u975E\u8868\u793A\u306B\u3059\u308B\u3053\u3068\u3067\u3001\u30D1\u30CD\u30EB\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u6700\u5927\u9650\u306B\u6D3B\u7528\u3067\u304D\u307E\u3059\u3002","microphone":"\u30DE\u30A4\u30AF\u3068\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","camera":"\u30AB\u30E1\u30E9\u3068\u9854/\u982D\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","profile":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30D7\u30EC\u30D3\u30E5\u30FC","globalControls":"\u30B0\u30ED\u30FC\u30D0\u30EB\u304A\u3088\u3073\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","tasks":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF","buttons":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3"},"titleShort":"\u30D1\u30CD\u30EB","description":"\u3053\u308C\u306F\u30E1\u30A4\u30F3\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30BB\u30F3\u30BF\u30FC\u3068\u306A\u308B\u30D1\u30CD\u30EB\u3067\u3059\u3002\u5E38\u306B\u8868\u793A\u3055\u308C\u3066\u304A\u308A\u3001\u97F3\u58F0\u3092\u4F7F\u3063\u3066\u30A2\u30D7\u30EA\u306A\u3069\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002","reconnecting":"\u518D\u63A5\u7D9A\u4E2D\u2026","reconnectRetry":"\u30EA\u30C8\u30E9\u30A4","modes":{"title":"\u30E2\u30FC\u30C9","generate":{"label":"\u751F\u6210\u3059\u308B","placeholder":"\u751F\u6210\u3057\u305F\u3044\u3082\u306E\u3092\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044"},"rewrite":{"label":"\u30EA\u30E9\u30A4\u30C8","placeholder":"\u6587\u7AE0\u3092\u3069\u306E\u3088\u3046\u306B\u66F8\u304D\u76F4\u305B\u3070\u826F\u3044\u3067\u3057\u3087\u3046\u304B\uFF1F"},"translate":{"label":"\u7FFB\u8A33\u3059\u308B","placeholder":"\u3069\u306E\u8A00\u8A9E\u306B\u7FFB\u8A33\u3057\u307E\u3059\u304B\uFF1F"},"automate":{"label":"\u81EA\u52D5\u5316\u3059\u308B","placeholder":"\u81EA\u52D5\u5316\u3057\u305F\u3044\u624B\u9806\u3092\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"auto":{"label":"\u81EA\u52D5","placeholder":"\u4F55\u3067\u3082\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002Cephable\u304C\u6700\u9069\u306A\u30E2\u30FC\u30C9\u3092\u9078\u629E\u3057\u307E\u3059\u3002","upgrade":"Cephable\u304C\u305D\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3059\u308B\u306B\u306F{{tier}}\u304C\u5FC5\u8981\u3067\u3059\u3002"},"control":{"label":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","placeholder":"\u9001\u4FE1\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u307E\u305F\u306F\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"summarize":{"label":"\u8981\u7D04\u3059\u308B","placeholder":"\u6587\u7AE0\u3092\u3069\u306E\u3088\u3046\u306B\u8981\u7D04\u307E\u305F\u306F\u7C21\u6F54\u306B\u307E\u3068\u3081\u305F\u3044\u3067\u3059\u304B\uFF1F"}}},"textGeneration":{"settings":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u8A2D\u5B9A","edit":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u8A2D\u5B9A\u306E\u7DE8\u96C6","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8 \u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306E\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u3066\u3001\u6700\u9069\u306A\u51FA\u529B\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","autoStart":{"title":"\u81EA\u52D5\u7684\u306B\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable AI \u306F\u4F5C\u6210\u30BF\u30B9\u30AF\u307E\u305F\u306F\u81EA\u52D5\u5316\u30BF\u30B9\u30AF\u3067\u4F7F\u7528\u3055\u308C\u308B AI \u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u7684\u306B\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u3057\u307E\u3059\u3002\u30E2\u30C7\u30EB\u3092\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u3067\u51E6\u7406\u901F\u5EA6\u306F\u5411\u4E0A\u3057\u307E\u3059\u304C\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30EA\u30BD\u30FC\u30B9\u6D88\u8CBB\u91CF\u304C\u5897\u52A0\u3057\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30D5\u306B\u3059\u308B\u3068\u30EA\u30BD\u30FC\u30B9\u306F\u7BC0\u7D04\u3067\u304D\u307E\u3059\u304C\u3001\u30BF\u30B9\u30AF\u306E\u51E6\u7406\u901F\u5EA6\u304C\u4F4E\u4E0B\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","option":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210 AI \u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7\u3057\u307E\u3059\u304B?"},"prompt":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306B\u95A2\u3059\u308B\u8FFD\u52A0\u60C5\u5831","description":"Cephable \u306E AI \u3067\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3059\u308B\u8FFD\u52A0\u306E\u8A73\u7D30\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C8\u30FC\u30F3\u3001\u66F8\u304D\u65B9\u3001\u305D\u306E\u4ED6\u306E\u8A73\u7D30\u306B\u95A2\u3059\u308B\u8A2D\u5B9A\u3092\u5165\u529B\u3057\u307E\u3059\u3002","field":"\u8FFD\u52A0\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","placeholder":"\u305F\u3068\u3048\u3070\u3001\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306A\u53E3\u8ABF\u3067\u3001\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306E\u3088\u3046\u306B\u3001\u7C21\u6F54\u304B\u3064\u8981\u70B9\u3092\u62BC\u3055\u3048\u3066\u66F8\u304D\u307E\u3059\u3002\u30B3\u30FC\u30C9\u3092\u66F8\u304F\u3068\u304D\u306F\u3001\u601D\u616E\u6DF1\u3044\u30B3\u30E1\u30F3\u30C8\u3092\u6B8B\u3057\u307E\u3059\u304C\u3001\u591A\u3059\u304E\u306A\u3044\u3088\u3046\u306B\u3057\u307E\u3059\u3002"},"enableTextGen":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable AI\u306F\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u8981\u7D04\u3001\u7FFB\u8A33\u3001\u307E\u305F\u306F\u30A2\u30D7\u30EA\u5168\u4F53\u306B\u308F\u305F\u308B\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u64CD\u4F5C\u306E\u81EA\u52D5\u5316\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","option":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"terminate":{"title":"\u30AF\u30EA\u30A2\u306AAI\u30EA\u30BD\u30FC\u30B9","description":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u4F5C\u6210\u30BF\u30B9\u30AF\u307E\u305F\u306F\u81EA\u52D5\u5316\u30BF\u30B9\u30AF\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u30EA\u30BD\u30FC\u30B9\u304C\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u304C\u3001\u6B21\u56DE\u3053\u308C\u3089\u306E\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3059\u308B\u969B\u306B\u51E6\u7406\u901F\u5EA6\u304C\u4F4E\u4E0B\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","button":"\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2","success":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3044\u307E\u3059\u3002","confirm":{"title":"\u30AF\u30EA\u30A2\u306AAI\u30EA\u30BD\u30FC\u30B9","description":"\u4F5C\u6210\u30BF\u30B9\u30AF\u307E\u305F\u306F\u81EA\u52D5\u5316\u30BF\u30B9\u30AF\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u3053\u308C\u306B\u3088\u308A\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30EA\u30BD\u30FC\u30B9\u306F\u89E3\u653E\u3055\u308C\u307E\u3059\u304C\u3001\u6B21\u56DE\u3053\u308C\u3089\u306E\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3059\u308B\u969B\u306B\u51E6\u7406\u901F\u5EA6\u304C\u4F4E\u4E0B\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u660E\u78BA\u306A\u30EA\u30BD\u30FC\u30B9","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB"}},"clearModelCache":{"title":"AI\u30E2\u30C7\u30EB\u306E\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3059\u308B","description":"\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306E\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u304C\u89E3\u653E\u3055\u308C\u3001\u73FE\u5728\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u30E2\u30C7\u30EB\u304C\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002","button":"\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","success":"\u30ED\u30FC\u30AB\u30EB \u30E2\u30C7\u30EB \u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002","confirm":{"title":"AI\u30E2\u30C7\u30EB\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B","description":"AI\u30E2\u30C7\u30EB\u306E\u30AD\u30E3\u30C3\u30B7\u30E5\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3001\u30B7\u30B9\u30C6\u30E0\u304B\u3089\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u73FE\u5728\u9078\u629E\u3055\u308C\u3066\u3044\u308B\u30E2\u30C7\u30EB\u306F\u81EA\u52D5\u7684\u306B\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u30AF\u30EA\u30A2\u3057\u3066\u518D\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB"},"error":"\u30ED\u30FC\u30AB\u30EB \u30E2\u30C7\u30EB \u30D5\u30A1\u30A4\u30EB\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"},"enableHistory":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u5C65\u6B74\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable AI \u306F\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u5C65\u6B74\u3092\u4F7F\u7528\u3057\u3066\u3001\u4EE5\u524D\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002","option":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u5C65\u6B74\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"},"modelSelection":{"title":"AI\u30E2\u30C7\u30EB","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u52D5\u4F5C\u3059\u308BAI\u30E2\u30C7\u30EB\u306E\u7A2E\u985E\u3068\u30B5\u30A4\u30BA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30E2\u30C7\u30EB\u304C\u5927\u304D\u3044\u307B\u3069\u7D50\u679C\u306F\u826F\u304F\u306A\u308A\u307E\u3059\u304C\u3001\u3088\u308A\u591A\u304F\u306E\u30EA\u30BD\u30FC\u30B9\u3092\u6D88\u8CBB\u3057\u307E\u3059\u3002\u8907\u6570\u306E\u30E2\u30C7\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304A\u3051\u3070\u3001\u7D20\u65E9\u304F\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","family":"\u6A21\u7BC4\u7684\u306A\u5BB6\u65CF","size":"\u30E2\u30C7\u30EB\u30B5\u30A4\u30BA","downloaded":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u6E08\u307F","downloading":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u2026","download":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","delete":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3092\u524A\u9664","unavailable":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093","requiresBetterDevice":"\u3053\u306E\u30E2\u30C7\u30EB\u3092\u52D5\u4F5C\u3055\u305B\u308B\u306B\u306F\u3001\u3088\u308A\u9AD8\u6027\u80FD\u306A\u30C7\u30D0\u30A4\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002","selectPrompt":"\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","noModels":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u5BFE\u5FDC\u3059\u308B\u6A5F\u7A2E\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002","deleteConfirm":{"title":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u30E2\u30C7\u30EB\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","description":"\u3053\u308C\u306B\u3088\u308A\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002\u5F8C\u3067\u518D\u5EA6\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002"},"notDownloaded":"\u3053\u306E\u30E2\u30C7\u30EB\u306F\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001\u307E\u3060\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u4F7F\u7528\u3059\u308B\u306B\u306F\u300C\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002","readyToUse":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u5B8C\u4E86 - \u3059\u3050\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059","offlineNoModels":"\u73FE\u5728\u30AA\u30D5\u30E9\u30A4\u30F3\u306E\u305F\u3081\u3001\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u306F\u307E\u3060\u30E2\u30C7\u30EB\u304C\u4FDD\u5B58\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306B\u63A5\u7D9A\u3057\u3066\u3001\u5229\u7528\u53EF\u80FD\u306A\u30E2\u30C7\u30EB\u3092\u8868\u793A\u304A\u3088\u3073\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","offlineDownloadUnavailable":"\u73FE\u5728\u30AA\u30D5\u30E9\u30A4\u30F3\u306E\u305F\u3081\u3001\u3053\u306E\u30E2\u30C7\u30EB\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u306B\u306F\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u304B\u3001\u65E2\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u6E08\u307F\u306E\u30E2\u30C7\u30EB\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044\u3002","license":{"upgrade":"\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059","blockedNeedsDownload":"\u3053\u306E\u30E2\u30C7\u30EB\u306B\u306F{{license}}\u304C\u5FC5\u8981\u3067\u3059\u3002\u4E0B\u4F4D\u30E2\u30C7\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u304B\u3001\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"notEnoughSpace":"\u30C7\u30D0\u30A4\u30B9\u306E\u7A7A\u304D\u5BB9\u91CF\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059","notEnoughSpaceDetail":"{{required}}\u304C\u5FC5\u8981\u3067\u3059\u304C\u3001\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306F{{free}}\u306E\u307F\u304C\u7121\u6599\u3067\u3059\u3002\u7A7A\u304D\u5BB9\u91CF\u3092\u78BA\u4FDD\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","fallback":{"alert":"{{fallback}} \u306F {{preferred}} \u306E\u4EE3\u308F\u308A\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001{{preferred}} \u306F\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002","active":"{{preferred}}\u306B\u306F{{license}}\u304C\u5FC5\u8981\u3067\u3059\u3002\u5225\u306E\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3059\u308B\u304B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3059\u308B\u307E\u3067\u306F\u3001\u4EE3\u308F\u308A\u306B{{fallback}}\u304C\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"}}},"prompt":{"systemPrompt":"\u8981\u6C42\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u306E\u307F\u3092\u751F\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8AAC\u660E\u3001\u89E3\u8AAC\u3001\u4F59\u8A08\u306A\u5185\u5BB9\u306F\u4E00\u5207\u542B\u3081\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u6307\u793A\u3055\u308C\u3066\u3044\u306A\u3044\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u3084\u8AAC\u660E\u3082\u4E0D\u8981\u3067\u3059\u3002\u30B3\u30FC\u30C9\u306B\u3064\u3044\u3066\u306F\u3001\u751F\u306E\u30B3\u30FC\u30C9\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D5\u30A7\u30F3\u30B9\u3001\u8A00\u8A9E\u30BF\u30B0\u3001\u8AAC\u660E\u306F\u4E00\u5207\u542B\u3081\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u4F55\u3092\u3057\u305F\u306E\u304B\u8AAC\u660E\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","appName":"\u73FE\u5728\u3001{{appName}} \u306E\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3057\u3066\u3044\u307E\u3059\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u307E\u3059: {{userPreferences}}\u3002"},"translatePrompt":{"systemPrompt":"\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u3092{{language}}\u306B\u7FFB\u8A33\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u7FFB\u8A33\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8AAC\u660E\u3001\u524D\u6587\u3001\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u66F8\u5F0F\u3001\u30B3\u30FC\u30C9\u30D5\u30A7\u30F3\u30B9\u3001\u6CE8\u91C8\u3001\u7FFB\u8A33\u306B\u95A2\u3059\u308B\u62EC\u5F27\u5185\u306E\u30B3\u30E1\u30F3\u30C8\u306F\u51FA\u529B\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u66F8\u5F0F\u306F\u4FDD\u6301\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B3\u30FC\u30C9\u306B\u3064\u3044\u3066\u306F\u3001\u30B3\u30E1\u30F3\u30C8\u3068\u6587\u5B57\u5217\u306E\u307F\u3092\u7FFB\u8A33\u3057\u3001\u69CB\u6587\u306F\u5B8C\u5168\u306B\u4FDD\u6301\u3057\u3066\u304F\u3060\u3055\u3044\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u307E\u3059: {{userPreferences}}\u3002","genericUserPrompt":"\u7FFB\u8A33: {{userRequestText}}"},"disabled":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3088\u3046\u3067\u3059\u3002\u8A2D\u5B9A\u3092\u66F4\u65B0\u3057\u3066\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u306A\u3069\u306E\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"skipTyping":{"complete":"{{task}} \u304C\u5B8C\u4E86\u3057\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002"},"summarizePrompt":{"systemPrompt":"\u63D0\u4F9B\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u7C21\u6F54\u306B\u8981\u7D04\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306F\u3088\u308A\u5927\u304D\u306A\u6587\u66F8\u306E\u4E00\u90E8\u3067\u3042\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u5F62\u5F0F\u3084\u30B3\u30FC\u30C9\u30D5\u30A7\u30F3\u30B9\u306F\u4F7F\u7528\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u8981\u7D04\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u524D\u6587\u3001\u30E9\u30D9\u30EB\u3001\u8AAC\u660E\u3001\u89E3\u8AAC\u306F\u4E0D\u8981\u3067\u3059\u3002\u307E\u305F\u3001\u884C\u3063\u305F\u51E6\u7406\u306B\u3064\u3044\u3066\u3082\u8AAC\u660E\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u3066\u304F\u3060\u3055\u3044: {{userPreferences}}\u3002","summarizeInstructions":"\u624B\u9806\uFF1A{{summarizeInstructions}}\u3002","userPrompt":"\u8981\u7D04: {{userRequestText}}"},"rewritePrompt":{"systemPrompt":"\u6307\u793A\u306B\u5F93\u3063\u3066\u3001\u63D0\u4F9B\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u63DB\u3048\u308B\u304B\u3001\u66F8\u5F0F\u3092\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u66F8\u5F0F\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\uFF08\u30EA\u30B9\u30C8\u3001\u8868\u3001\u69CB\u9020\u306E\u5909\u66F4\u306A\u3069\uFF09\u3001\u5143\u306E\u5358\u8A9E\u306F\u6B63\u78BA\u306B\u4FDD\u6301\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u66F8\u304D\u63DB\u3048\u308B\u5834\u5408\uFF08\u30C8\u30FC\u30F3\u3001\u30B9\u30BF\u30A4\u30EB\u3001\u9577\u3055\u306A\u3069\uFF09\u3001\u610F\u5473\u306F\u4FDD\u6301\u3057\u307E\u3059\u304C\u3001\u5FC5\u305A\u3057\u3082\u5358\u8A9E\u306F\u4FDD\u6301\u3059\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3053\u308C\u306F\u3001\u3088\u308A\u5927\u304D\u306A\u6587\u66F8\u306E\u4E00\u90E8\u3067\u3042\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u5165\u529B\u306E\u66F8\u5F0F\u306B\u5408\u308F\u305B\u307E\u3059\u3002\u30BD\u30FC\u30B9\u30C6\u30AD\u30B9\u30C8\u304C\u3059\u3067\u306B\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u307E\u305F\u306F\u30B3\u30FC\u30C9\u3067\u3042\u308B\u5834\u5408\u306F\u3001\u305D\u308C\u3092\u4FDD\u6301\u3057\u307E\u3059\u3002\u305D\u308C\u4EE5\u5916\u306E\u5834\u5408\u306F\u3001\u6307\u793A\u3067\u30EA\u30B9\u30C8\u3001\u8868\u3001\u307E\u305F\u306F\u540C\u69D8\u306E\u69CB\u9020\u304C\u660E\u793A\u7684\u306B\u8981\u6C42\u3055\u308C\u3066\u3044\u306A\u3044\u9650\u308A\u3001\u30DE\u30FC\u30AF\u30C0\u30A6\u30F3\u66F8\u5F0F\uFF08\u898B\u51FA\u3057\u3001\u592A\u5B57\u3001\u7B87\u6761\u66F8\u304D\u3001\u30B3\u30FC\u30C9\u30D5\u30A7\u30F3\u30B9\uFF09\u3092\u5C0E\u5165\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u7D50\u679C\u306E\u307F\u3092\u51FA\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u524D\u6587\u3001\u30E9\u30D9\u30EB\u3001\u898B\u51FA\u3057\u3001\u8AAC\u660E\u3001\u307E\u305F\u306F\u30B3\u30E1\u30F3\u30C8\u306F\u51FA\u529B\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","userPreferences":"\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306E\u8A2D\u5B9A\u3092\u5C0A\u91CD\u3057\u3066\u304F\u3060\u3055\u3044: {{userPreferences}}\u3002","rewriteInstructions":"\u624B\u9806: {{rewriteInstructions}}\u3002"}},"profile":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePlural":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titlePreview":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30D7\u30EC\u30D3\u30E5\u30FC","previous":"\u4EE5\u524D\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","manage":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u7BA1\u7406","view":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8868\u793A","edit":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7DE8\u96C6","add":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B","create":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","warn":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30AB\u30E1\u30E9\u307E\u305F\u306F\u30DE\u30A4\u30AF\u3092\u8D77\u52D5\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","descriptionShort":"Cephable \u304C\u30C7\u30D0\u30A4\u30B9\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u5236\u5FA1\u306B\u5F79\u7ACB\u3064\u3055\u307E\u3056\u307E\u306A\u65B9\u6CD5\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","name":"\u30A2\u30D7\u30EA\u540D","nameQuestion":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F55\u3068\u547C\u3073\u307E\u3059\u304B?","newName":"\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","search":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u540D\u524D\u3067\u691C\u7D22","searchLong":"\u540D\u524D\u307E\u305F\u306F\u8AAC\u660E\u3067\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u691C\u7D22\u3059\u308B","keyboardAndMouse":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9","genericController":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","keyboardMouseAndController":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3001\u30DE\u30A6\u30B9\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC","permissionError":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002","set":{"title":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u307E\u3060\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u306A\u3044\u3088\u3046\u3067\u3059\u3002","cta":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A2D\u5B9A\u3059\u308B","empty":{"auto":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u5225\u306E\u30A2\u30D7\u30EA\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044","select":"\u958B\u59CB\u3059\u308B\u306B\u306F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","none":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093"},"description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001Cephable\u304C\u4F55\u3092\u691C\u77E5\u3057\u3001\u3069\u306E\u3088\u3046\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3059\u308B\u304B\u3092\u5224\u65AD\u3059\u308B\u305F\u3081\u306E\u3082\u306E\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u307E\u305F\u306F\u63A5\u7D9A\u8A2D\u5B9A\u304B\u3089\u3044\u3064\u3067\u3082\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"summary":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981","descriptionLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8A73\u7D30\u306F\u6B21\u306E\u3068\u304A\u308A\u3067\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u306A\u3069\u3092\u691C\u7D22\u3057\u3066\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u4F55\u304C\u3067\u304D\u308B\u304B\u3092\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5185\u5BB9\u3001\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3001\u8A73\u7D30\u306A\u3069\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981\u3092\u53D6\u5F97\u3057\u307E\u3059\u3002","view":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u6982\u8981\u3092\u8868\u793A","filter":"\u5165\u529B\u30BF\u30A4\u30D7\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0","placeholder":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u3092\u691C\u7D22..."},"copy":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30B3\u30D4\u30FC","duplicate":"\u91CD\u8907\u3057\u305F\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","question":"\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059\u304B?","description":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u65B0\u3057\u3044\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059\u304B? \u3053\u3046\u3059\u308B\u3068\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u30B3\u30D4\u30FC\u3055\u308C\u305F\u65B0\u3057\u3044\u30A6\u30A3\u30F3\u30C9\u30A6\u304C\u958B\u304D\u307E\u3059\u304C\u3001\u4FDD\u5B58\u3059\u308B\u307E\u3067\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u305B\u3093\u3002","confirm":"\u306F\u3044\u3001\u30B3\u30D4\u30FC\u3092\u4F5C\u6210\u3057\u307E\u3059","profileSuffix":"{{name}} (\u30B3\u30D4\u30FC)"},"new":{"title":"\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4E00\u304B\u3089\u4F5C\u6210\u3059\u308B\u304B\u3001\u6700\u5148\u7AEF\u306E AI \u3067\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3057\u3066\u3001\u97F3\u58F0\u3001\u982D\u3001\u9854\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3092\u4F7F\u7528\u3057\u3066\u30A2\u30D7\u30EA\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u7C21\u5358\u306B\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","note":"\u4E0A\u7D1A\u30E6\u30FC\u30B6\u30FC\u306B\u304A\u3059\u3059\u3081\u3067\u3059\u3002","scratch":"\u30BC\u30ED\u304B\u3089\u4F5C\u6210"},"advancedOptions":"\u9AD8\u5EA6\u306A\u5236\u5FA1\u30AA\u30D7\u30B7\u30E7\u30F3","delete":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u524A\u9664","titleLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B","description":"\u300C\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3067\u304D\u307E\u3059\u3002","confirm":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmButton":"\u306F\u3044\u3001\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u524A\u9664\u3057\u307E\u3059"},"current":"\u73FE\u5728\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","loading":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","null":"\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","nullButton":"\u6700\u521D\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","preview":"\u30D7\u30EC\u30D3\u30E5\u30FC","features":"\u7279\u5FB4","byline_public":"\u8457\u8005: Cephable \u30C1\u30FC\u30E0","byline_shared":"\u5171\u6709\u8005: Cephable \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3","share":{"title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5171\u6709\u3059\u308B","previewTitle":"\u5171\u6709\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30D7\u30EC\u30D3\u30E5\u30FC","description":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u3068\u5171\u6709\u3059\u308B\u3068\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30B3\u30D4\u30FC\u3092\u53D6\u5F97\u3057\u3066\u305D\u3053\u304B\u3089\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","descriptionLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u3068\u5171\u6709\u3059\u308B\u3068\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30B3\u30D4\u30FC\u3092\u53D6\u5F97\u3057\u3066\u305D\u3053\u304B\u3089\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u5171\u6709\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u9001\u4FE1\u3059\u308B\u30EA\u30F3\u30AF\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","add":"\u5171\u6709\u30EA\u30F3\u30AF\u3092\u4F5C\u6210\u3059\u308B","confirm":"\u3053\u306EURL\u3092\u5171\u6709\u3059\u308B","link":"\u30EA\u30F3\u30AF\u3092\u5171\u6709","copy":"\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC","copied":"\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\uFF01","usage":"\u4F7F\u7528\u91CF","created":"{{value}} \u3092\u4F5C\u6210\u3057\u307E\u3057\u305F","expiration":{"title":"\u6709\u52B9\u671F\u9650","once":"1\u56DE\u306E\u307F\u4F7F\u7528\u53EF\u80FD","unlimited":"\u7121\u5236\u9650\u306E\u4F7F\u7528\u3092\u8A31\u53EF\u3059\u308B","no":"\u6709\u52B9\u671F\u9650\u306A\u3057","date":"\u6709\u52B9\u671F\u9650","dateDescription":"\u7279\u5B9A\u306E\u65E5\u4ED8\u306B\u671F\u9650\u5207\u308C\u306B\u306A\u308B"},"manage":"\u4EE5\u524D\u306E\u5171\u6709\u30EA\u30F3\u30AF\u3092\u7BA1\u7406\u3059\u308B","empty":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5171\u6709\u306F\u4F5C\u6210\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"},"swap":{"title":"\u30B9\u30EF\u30C3\u30D7\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","titleLong":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5165\u308C\u66FF\u3048\u308B","descriptionShort":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5408\u308F\u305B\u3066\u3001\u3055\u307E\u3056\u307E\u306A\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","description":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5408\u308F\u305B\u3066\u3001\u3055\u307E\u3056\u307E\u306A\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"autoProfileSwitching":{"title":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048","alerts":{"disabled":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u304C\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","temporarilyDisabled":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u304C\u4E00\u6642\u7684\u306B\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","enabled":"\u81EA\u52D5\u5236\u5FA1\u5207\u308A\u66FF\u3048\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","error":"\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u8A2D\u5B9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"associatedPrograms":{"add":"\u65B0\u3057\u3044\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u8FFD\u52A0\u3059\u308B","description":{"personal":"\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u63A5\u7D9A\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u307E\u305F\u306F\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u304A\u308A\u3001Cephable \u306F\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u73FE\u5728\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u306B\u5408\u308F\u305B\u3066\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u3048\u307E\u3059\u3002","short":"\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u63A5\u7D9A\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u307E\u305F\u306F\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"edit":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u7DE8\u96C6\u3059\u308B","noOptionsText":"\u95A2\u9023\u3059\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u691C\u7D22\u3059\u308B\u306B\u306F\u5165\u529B\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044","profileLabel":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB:","remove":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u524A\u9664\u3059\u308B","title":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0","when":"Cephable \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C {{profileName}} \u306B\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059...","emptySearch":"\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u30D7\u30ED\u30B0\u30E9\u30E0\u306F\u3042\u308A\u307E\u305B\u3093\u3002","error":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","emptyError":"\u7A7A\u306E\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3002\u7D9A\u884C\u3059\u308B\u524D\u306B\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"commandOverlay":{"command":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5207\u308A\u66FF\u3048: {{value}}"},"description":"\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u306B\u3088\u308A\u3001Cephable\u306F\u30E6\u30FC\u30B6\u30FC\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u9069\u5FDC\u3057\u307E\u3059\u3002\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001Cephable\u306F\u4F7F\u7528\u3057\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u5FDC\u3058\u3066\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002\u30AA\u30D5\u306B\u3057\u305F\u5834\u5408\u306F\u3001\u300C\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u5207\u308A\u66FF\u3048\u300D\u30DC\u30BF\u30F3\u307E\u305F\u306F\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u624B\u52D5\u3067\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"error":{"noMatch":"\u691C\u7D22\u306B\u4E00\u81F4\u3059\u308B\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002","load":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","add":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u8FFD\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","delete":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","audioEventsWithEmptyCommands":"\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30C8\u30FC\u30AF\u30D0\u30C3\u30AF \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30C1\u30A7\u30C3\u30AF\u3057\u3066\u3001\u5B8C\u5168\u306B\u5165\u529B\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","conflicts":"\u7AF6\u5408\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","save":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","device":"\u3053\u306E\u63A5\u7D9A\u3067\u306F\u7121\u52B9\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3059\u3002\u5225\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"conflictIndicators":{"errorTitle":"\u7AF6\u5408\u306B\u3088\u308A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","warningTitle":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8B66\u544A\u4ED8\u304D\u3067\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","subtitle":"\u4F5C\u6210\u3057\u305F\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u7AF6\u5408\u3059\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u69CB\u6210\u304C\u3044\u304F\u3064\u304B\u3042\u308A\u307E\u3059\u3002","profileNameErrors":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u540D\u524D\u306E\u7AF6\u5408","emptyControlsMapped":"\u5165\u529B\u540D\u304C\u7A7A\u3067\u3059","emptyControlsMappedDescription":"\u5165\u529B\u306B\u306F\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u8868\u60C5\u3001\u982D\u306E\u50BE\u304D\u3001\u305D\u306E\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyKeybindingControlsMapped":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u306E\u7A7A\u306E\u5165\u529B\u540D","emptyKeybindingControlsMappedDescription":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u306E\u5165\u529B\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u8868\u60C5\u3001\u982D\u306E\u50BE\u304D\u3001\u307E\u305F\u306F\u305D\u306E\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","duplicateNameTitle":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059","duplicateNameDescription":"\u540C\u3058\u540D\u524D\u306E\u65E2\u5B58\u306E\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u3042\u308A\u307E\u3059\u3002\u7D9A\u884C\u3059\u308B\u524D\u306B\u540D\u524D\u3092\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyNameTitle":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u304C\u7A7A\u3067\u3059","emptyNameDescription":"\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u540D\u524D\u3092\u4ED8\u3051\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u4F8B: Game 1\u3001Spotify\u3001Word \u306A\u3069\u3002","macrosReleaseKeysMissingTitle":"\u672A\u30EA\u30EA\u30FC\u30B9\u306E\u30AD\u30FC\u306E\u51FA\u529B","macrosReleaseKeysMissingDescription":"\u30AD\u30FC\u304C\u52D5\u304B\u306A\u304F\u306A\u308B\u306E\u3092\u9632\u3050\u306B\u306F\u3001\u30EA\u30EA\u30FC\u30B9 \u30AD\u30FC\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u3059\u3079\u3066\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u505C\u6B62\u3057\u3066\u304F\u3060\u3055\u3044\u3002","duplicateInputCommandMacroTitle":"\u540C\u4E00\u306E\u5236\u5FA1\u5165\u529B","duplicateCommandsDescription":"\u91CD\u8907\u3059\u308B\u5165\u529B\u30B3\u30DE\u30F3\u30C9\u3092\u524A\u9664\u3059\u308B\u304B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","duplicateInputCommandBindingsTitle":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C7\u30A3\u30F3\u30B0\u306E\u540C\u4E00\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5165\u529B","conflictIndicatorDisplayString":"{{container}} : {{commandOrKeyName}} \u3068 {{commandOrEventType}}","duplicateMacroNames":"\u91CD\u8907\u3057\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D","duplicateMacroNamesDescription":"\u540C\u4E00\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u540D\u306E\u3044\u305A\u308C\u304B\u3092\u524A\u9664\u3059\u308B\u304B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","warningIgnore":"\u7121\u8996\u3059\u308B","warningDoNotShowAgain":"\u518D\u5EA6\u8B66\u544A\u3092\u8868\u793A\u3057\u306A\u3044","macrosVoiceCommandConflictWithDictationTitle":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058\u3088\u3046\u306B\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3057\u307E\u3059","keybindingsVoiceCommandConflictWithDictationTitle":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058\u3067\u3059","macrosVoiceCommandConflictWithDictationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","keybindingsVoiceCommandConflictWithDictationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u30AD\u30FC\u306E\u62BC\u4E0B\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","macrosVoiceCommandConflictWithGenerationTitle":"\u751F\u6210\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u5236\u5FA1\u3059\u308B","keybindingsVoiceCommandConflictWithGenerationTitle":"\u30AD\u30FC\u30D0\u30A4\u30F3\u30C9\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u751F\u6210\u30AD\u30FC\u30EF\u30FC\u30C9\u3068\u540C\u3058","macrosVoiceCommandConflictWithGenerationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u751F\u6210\u3068\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","keybindingsVoiceCommandConflictWithGenerationDescription":"\u97F3\u58F0\u5165\u529B\u306B\u3088\u308A\u3001\u751F\u6210\u3068\u30AD\u30FC\u306E\u62BC\u4E0B\u304C\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u307E\u3059\u3002","duplicateAssociatedProgramNames":"\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059","duplicateAssociatedProgramNamesDescription":"\u540C\u4E00\u306E\u95A2\u9023\u30D7\u30ED\u30B0\u30E9\u30E0\u306E 1 \u3064\u3092\u524A\u9664\u3059\u308B\u304B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyEvent":{"title":"\u4E0D\u8DB3\u3057\u3066\u3044\u308B\u624B\u9806","description":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u4E0D\u8DB3\u3057\u3066\u3044\u308B\u624B\u9806\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30B3\u30DE\u30F3\u30C9\u3092\u767A\u884C\u3057\u3066\u3082 Cephable \u304C\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"warningDetails":"\u3059\u3079\u3066\u306E\u7AF6\u5408\u3092\u8868\u793A"},"success":{"save":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","add":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","delete":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","share":"\u5171\u6709\u30EA\u30F3\u30AF\u304C\u4F5C\u6210\u3055\u308C\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F","shareDelete":"\u5171\u6709\u30EA\u30F3\u30AF\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","generate":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u751F\u6210\u3055\u308C\u307E\u3057\u305F\u3002"},"warning":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u8B66\u544A\u4ED8\u304D\u3067\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","customize":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B","custom":"{{name}} (\u30AB\u30B9\u30BF\u30E0)","description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3084\u63A5\u7D9A\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3067\u304D\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u30BB\u30C3\u30C8\u3067\u3059\u3002\u8907\u6570\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3001\u3044\u3064\u3067\u3082\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"publicProfiles":{"toolbar":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u63A2\u7D22","title":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u63A2\u7D22","offline":{"title":"\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093","description":"\u30AA\u30D5\u30E9\u30A4\u30F3\u306E\u3088\u3046\u3067\u3059\u3002\u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5F15\u304D\u7D9A\u304D\u4F7F\u7528\u3067\u304D\u307E\u3059\u304C\u3001\u65B0\u3057\u3044\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8AAD\u307F\u8FBC\u3080\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002","confirm":"\u308F\u304B\u3063\u305F"},"announcement":"{{count}} \u500B\u306E\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u3057\u305F","description":{"personal":"\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u3067 Cephable \u3092\u3059\u3050\u306B\u4F7F\u3044\u59CB\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3053\u3068\u3082\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u3053\u3068\u3082\u3001\u307E\u3063\u305F\u304F\u65B0\u3057\u3044\u30AB\u30B9\u30BF\u30E0 \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6700\u521D\u304B\u3089\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","pro":"\u30D1\u30D6\u30EA\u30C3\u30AF \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u3067 Cephable \u3092\u3059\u3050\u306B\u4F7F\u3044\u59CB\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u305F\u308A\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30B8\u30A7\u30CD\u30EC\u30FC\u30BF\u30FC\u3092\u4F7F\u7528\u3057\u3066\u307E\u3063\u305F\u304F\u65B0\u3057\u3044\u30AB\u30B9\u30BF\u30E0 \u30A2\u30D7\u30EA \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"team":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30C1\u30FC\u30E0"},"publicTag":"\u516C\u5171","tray":{"panel":"\u30C8\u30B0\u30EB\u30D1\u30CD\u30EB","dashboard":"\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u3092\u8868\u793A","quit":"Cephable \u3092\u7D42\u4E86\u3059\u308B"},"generate":"\u751F\u6210\u3059\u308B","stop":"\u505C\u6B62","clear":"\u30AF\u30EA\u30A2","rewrite":"\u30EA\u30E9\u30A4\u30C8","translate":"\u7FFB\u8A33\u3059\u308B","smartTasks":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF","show":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u8868\u793A","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3068\u306F\u3001Cephable\u306EAI\u304C\u3042\u306A\u305F\u306B\u4EE3\u308F\u3063\u3066\u5B9F\u884C\u3067\u304D\u308B\u69D8\u3005\u306A\u30BF\u30B9\u30AF\u3067\u3059\u3002\u3053\u308C\u3089\u306E\u30BF\u30B9\u30AF\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u306B\u3088\u3063\u3066\u5B9F\u884C\u3055\u308C\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u4F5C\u6210\u3001\u8981\u7D04\u3001\u66F8\u304D\u76F4\u3057\u3001\u7FFB\u8A33\u3001\u30E1\u30E2\u306E\u4F5C\u6210\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F7F\u3063\u305F\u30C1\u30E3\u30C3\u30C8\u306A\u3069\u306B\u5229\u7528\u3067\u304D\u307E\u3059\u3002","generateText":{"title":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210","description":"\u5165\u529B\u307E\u305F\u306F\u30D7\u30ED\u30F3\u30D7\u30C8\u306B\u57FA\u3065\u3044\u3066\u30C6\u30AD\u30B9\u30C8 \u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","label":"\u4F55\u3092\u751F\u6210\u3057\u305F\u3044\u306E\u304B\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044"},"summarizeText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u8981\u7D04\u3059\u308B","description":"\u9577\u6587\u304B\u3089\u8981\u70B9\u3092\u62BD\u51FA\u3057\u3001\u77ED\u3044\u8981\u7D04\u3084\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u3002","directions":"\u8981\u7D04\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u304B\u3001\u5F37\u8ABF\u8868\u793A\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092 Cephable \u304C\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002","write":"\u8981\u7D04\u3092\u66F8\u304F","outputLabel":"\u3042\u306A\u305F\u306E\u8981\u7D04\u306F\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002","inputLabel":"\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u8981\u7D04\u3057\u307E\u3059"},"rewriteText":{"title":"\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048","description":"\u5225\u306E\u30A2\u30D7\u30EA\u3067\u66F8\u304D\u8FBC\u3093\u3067\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u8868\u793A\u3057\u3066\u304B\u3089\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u3001\u3069\u306E\u3088\u3046\u306B\u66F8\u304D\u76F4\u3057\u305F\u3044\u304B\u3092\u8AAC\u660E\u3057\u307E\u3059\u3002","label":"\u30C6\u30AD\u30B9\u30C8\u3092\u3069\u306E\u3088\u3046\u306B\u66F8\u304D\u76F4\u3057\u305F\u3044\u304B\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044","inputLabel":"\u66F8\u304D\u63DB\u3048\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"translateText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3059\u308B","description":"\u7FFB\u8A33\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u304B\u3001\u5F37\u8ABF\u8868\u793A\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092 Cephable \u304C\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002","label":"\u7FFB\u8A33\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","languageLabel":"\u7FFB\u8A33\u5148\u306E\u8A00\u8A9E"},"noteTaker":{"title":"\u30E1\u30E2\u30C6\u30A4\u30AB\u30FC","description":"Cephable\u3067\u4F1A\u8B70\u3084\u4F1A\u8A71\u3092\u30ED\u30FC\u30AB\u30EB\u3067\u9332\u97F3\u30FB\u66F8\u304D\u8D77\u3053\u3057\u307E\u3057\u3087\u3046"},"documentChat":{"title":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30C1\u30E3\u30C3\u30C8","description":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u64CD\u4F5C\u3057\u3066\u30AF\u30A8\u30EA\u3092\u5B9F\u884C\u3057\u3001\u3059\u3050\u306B\u6D1E\u5BDF\u3092\u5F97\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"highlightText":{"title":"\u5F37\u8ABF\u8868\u793A\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3059\u308B","description":"Cephable\u306F\u3001\u30A2\u30D7\u30EA\u3067\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u3066\u3001\u8981\u7D04\u3001\u66F8\u304D\u76F4\u3057\u3001\u7FFB\u8A33\u306A\u3069\u306E\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u624B\u52D5\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","label":"\u4F7F\u7528\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","placeholder":"\u5225\u306E\u30A2\u30D7\u30EA\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u4F7F\u7528\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","noTextFound":"\u30C6\u30AD\u30B9\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u5225\u306E\u30A2\u30D7\u30EA\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3059\u308B\u304B\u3001\u30C6\u30AD\u30B9\u30C8\u3092\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u8CBC\u308A\u4ED8\u3051\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"pasteText":{"title":"\u30C6\u30AD\u30B9\u30C8\u3092\u8CBC\u308A\u4ED8\u3051\u308B","description":"Cephable\u306F\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u81EA\u52D5\u7684\u306B\u4F7F\u7528\u3057\u3066\u3001\u8981\u7D04\u3001\u66F8\u304D\u76F4\u3057\u3001\u7FFB\u8A33\u306A\u3069\u306E\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001\u624B\u52D5\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","label":"\u4F7F\u7528\u3059\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","placeholder":"\u5225\u306E\u30A2\u30D7\u30EA\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u4F7F\u7528\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"},"clearCache":"\u751F\u6210\u6642\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u8A2D\u5B9A\u304B\u3089\u30AD\u30E3\u30C3\u30B7\u30E5\u3068\u30EA\u30BD\u30FC\u30B9\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","transcribeAudio":{"title":"\u97F3\u58F0\u3092\u66F8\u304D\u8D77\u3053\u3059","description":"AI \u30C8\u30E9\u30F3\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u3001\u30AA\u30FC\u30C7\u30A3\u30AA \u30D5\u30A1\u30A4\u30EB\u307E\u305F\u306F\u30D3\u30C7\u30AA \u30D5\u30A1\u30A4\u30EB\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","inputMethod":"\u5165\u529B\u65B9\u6CD5\u3092\u9078\u629E","localFile":"\u30ED\u30FC\u30AB\u30EB\u30D5\u30A1\u30A4\u30EB","url":"URL","selectFile":"\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E","urlLabel":"\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AAURL","transcribe":"\u8EE2\u5199","result":"\u8EE2\u5199\u7D50\u679C","invalidFileType":"\u6709\u52B9\u306A\u30AA\u30FC\u30C7\u30A3\u30AA\u307E\u305F\u306F\u30D3\u30C7\u30AA\u30D5\u30A1\u30A4\u30EB\uFF08mp3\u3001wav\u3001ogg\u3001mp4\u3001webm\u3001mov\u3001avi\uFF09\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","error":"\u8EE2\u8A18\u30A8\u30E9\u30FC","history":{"title":"\u8EE2\u5199\u5C65\u6B74","description":"\u4FDD\u5B58\u3057\u305F\u6587\u5B57\u8D77\u3053\u3057\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3057\u307E\u3059\u3002","viewHistory":"\u5C65\u6B74\u3092\u8868\u793A","empty":"\u307E\u3060\u66F8\u304D\u8D77\u3053\u3057\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u66F8\u304D\u8D77\u3053\u3057\u3092\u59CB\u3081\u3066\u3001\u6B74\u53F2\u3092\u7BC9\u304D\u307E\u3057\u3087\u3046\u3002","titleLabel":"\u30BF\u30A4\u30C8\u30EB\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09","titlePlaceholder":"\u3053\u306E\u8EE2\u5199\u306E\u30BF\u30A4\u30C8\u30EB\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","textLabel":"\u8EE2\u5199\u30C6\u30AD\u30B9\u30C8","confirmDelete":"\u3053\u306E\u8EE2\u5199\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?"}},"aiWorkflows":{"description":"AI\u3092\u6D3B\u7528\u3057\u3066\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u3068\u30D6\u30E9\u30A6\u30B6\u306E\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3002\u3084\u308A\u305F\u3044\u3053\u3068\u3092\u8AAC\u660E\u3059\u308B\u3060\u3051\u3067\u3001Cephable\u304C\u81EA\u52D5\u7684\u306B\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002","label":"\u9054\u6210\u3057\u305F\u3044\u3053\u3068\u3092\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044","status":{"idle":"\u3054\u6307\u793A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059...","initializing":"\u6E96\u5099\u4E2D\u3067\u3059...","planning":["\u8A08\u753B\u3092\u7ACB\u3066\u3066\u3044\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u8A73\u3057\u304F\u8AAC\u660E\u3057\u307E\u3059...","\u624B\u9806\u3092\u56F3\u89E3\u3057\u307E\u3059...","\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6574\u7406\u3057\u3066\u3044\u307E\u3059...","\u6226\u7565\u3092\u6E96\u5099\u4E2D...","\u884C\u52D5\u8A08\u753B\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059...","\u3042\u306A\u305F\u3092\u52A9\u3051\u308B\u305F\u3081\u306E\u6700\u5584\u306E\u65B9\u6CD5\u3092\u8003\u3048\u307E\u3059...","\u3053\u308C\u306B\u3069\u306E\u3088\u3046\u306B\u30A2\u30D7\u30ED\u30FC\u30C1\u3059\u308B\u304B\u3092\u6C7A\u5B9A\u3057\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5206\u6790\u3057\u3066\u3044\u307E\u3059...","\u5B9F\u884C\u3092\u8A08\u753B\u4E2D..."],"thinking":["\u8003\u3048..."],"waitingForUser":"\u7D9A\u884C\u3059\u308B\u306B\u306F\u3042\u306A\u305F\u306E\u5165\u529B\u304C\u5FC5\u8981\u3067\u3059\u3002","completed":"\u6210\u529F\uFF01","failed":"\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5931\u6557\u3057\u307E\u3057\u305F: {{message}}","canceled":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002","terminated":"\u505C\u6B62\u3057\u307E\u3057\u305F\u3002\u6307\u793A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059\u3002","thinkingInteractive":["\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u691C\u8A0E\u3057\u3066\u3044\u307E\u3059...","\u3053\u308C\u307E\u3067\u3084\u3063\u3066\u304D\u305F\u3053\u3068\u3092\u632F\u308A\u8FD4\u3063\u3066\u307F\u308B\u3068\u2026","\u6B21\u306B\u4F55\u3092\u3059\u308B\u304B\u6C7A\u3081\u3066\u3044\u307E\u3059...","\u7D50\u679C\u3092\u5206\u6790\u3057\u3066\u3044\u307E\u3059...","\u7D9A\u304D\u3092\u4F01\u753B\u4E2D\u2026","\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8A55\u4FA1\u3057\u3066\u3044\u307E\u3059...","\u6700\u5584\u306E\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u8003\u3048\u307E\u3059...","\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u53D6\u308A\u7D44\u3093\u3067\u3044\u307E\u3059...","\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u306B\u53D6\u308A\u7D44\u3093\u3067\u3044\u307E\u3059...","\u524D\u306E\u30B9\u30C6\u30C3\u30D7\u306E\u7D50\u679C\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059..."],"tools":{"click_element_by_index":{"executing-start":"\u8A72\u5F53\u3059\u308B\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068...","executing-complete":"{{params.index}}\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3057\u305F\u3002"},"click_element":{"executing-start":"\u30CF\u30A4\u30E9\u30A4\u30C8\u8868\u793A\u3055\u308C\u305F\u756A\u53F7\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068...","executing-complete":"{{params.elementName}}\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3057\u305F\u3002"},"copy_selection":{"executing-start":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53CE\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"draft_email":{"executing-start":"\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u4E2D\u3067\u3059...","executing-complete":"{{params.subject}} \u306B\u95A2\u3059\u308B\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002"},"execute_app_action":{"executing-start":"{{params.actionName}} \u3092\u5B9F\u884C\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.actionName}}\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002"},"find_all_text":{"executing-start":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u3059\u3079\u3066\u306E\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u691C\u7D22\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u3059\u3079\u3066\u306E\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u3002"},"find_and_select_text":{"executing-start":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u691C\u7D22\u3057\u3066\u9078\u629E\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.searchText}} \u306B\u95A2\u3059\u308B\u95A2\u9023\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u898B\u3064\u3051\u3066\u9078\u629E\u3057\u307E\u3057\u305F\u3002"},"generate_text":{"executing-start":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059...","executing-progress":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u4E2D...{{progress}}%","executing-complete":"\u8981\u6C42\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002"},"get_all_interactive_elements":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53D6\u5F97\u3059\u308B\u305F\u3081\u306B\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u4F55\u3068\u3084\u308A\u3068\u308A\u3067\u304D\u308B\u304B\u7406\u89E3\u3057\u307E\u3057\u305F\u3002"},"get_all_text_elements_content":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u6587\u8108\u3092\u7406\u89E3\u3059\u308B\u305F\u3081\u306B\u8AAD\u3093\u3067\u304F\u3060\u3055\u3044...","executing-complete":"\u5229\u7528\u53EF\u80FD\u306A\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002"},"get_all_text_elements_names":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u6587\u8108\u3092\u7406\u89E3\u3059\u308B\u305F\u3081\u306B\u8AAD\u3093\u3067\u304F\u3060\u3055\u3044...","executing-complete":"\u5229\u7528\u53EF\u80FD\u306A\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002"},"get_available_profile_actions":{"executing-start":"\u3053\u306E\u30A2\u30D7\u30EA\u3067\u4F7F\u7528\u3067\u304D\u308B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3053\u306E\u30A2\u30D7\u30EA\u3067\u4F55\u304C\u3067\u304D\u308B\u306E\u304B\u7406\u89E3\u3057\u307E\u3057\u305F\u3002"},"get_document_content":{"executing-start":"\u3088\u308A\u591A\u304F\u306E\u6587\u8108\u3092\u7406\u89E3\u3059\u308B\u305F\u3081\u306B\u8AAD\u3093\u3067\u304F\u3060\u3055\u3044...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"get_installed_apps":{"executing-start":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u95A2\u9023\u3059\u308B\u30A2\u30D7\u30EA\u3092\u6C7A\u5B9A\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3069\u306E\u30A2\u30D7\u30EA\u304C\u4F7F\u3048\u308B\u304B\u308F\u304B\u3063\u3066\u3044\u307E\u3059\u3002"},"get_running_app_names":{"executing-start":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u95A2\u9023\u3059\u308B\u30A2\u30D7\u30EA\u3092\u6C7A\u5B9A\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3069\u306E\u30A2\u30D7\u30EA\u304C\u4F7F\u3048\u308B\u304B\u308F\u304B\u3063\u3066\u3044\u307E\u3059\u3002"},"get_selected_text":{"executing-start":"\u9078\u629E\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","executing-complete":"\u9078\u629E\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u304C\u3042\u308A\u307E\u3059\u3002"},"get_stored_content":{"executing-start":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53CE\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"keyboard_shortcut":{"executing-start":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u53CE\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u6B21\u306E\u90E8\u5206\u306B\u5BFE\u5FDC\u3059\u308B\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u3059\u3002"},"open_app":{"executing-start":"{{params.appName}} \u3092\u958B\u3044\u3066\u3044\u307E\u3059...","executing-complete":"{{params.appName}}\u3092\u958B\u304D\u307E\u3057\u305F\u3002"},"open_webpage":{"executing-start":"{{params.url}} \u3092\u958B\u3044\u3066\u3044\u307E\u3059...","executing-complete":"{{params.url}}\u3092\u958B\u304D\u307E\u3057\u305F\u3002"},"paste_content":{"executing-start":"\u66F8\u304D\u8FBC\u307F...","executing-complete":"\u66F8\u304D\u7D42\u308F\u308A\u307E\u3057\u305F\u3002"},"respond_to_user":{"executing-start":"\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059...","executing-complete:":"\u3054\u8981\u671B\u306B\u304A\u5FDC\u3048\u3057\u307E\u3057\u305F\u3002"},"search_browser":{"executing-start":"{{params.query}} \u3092 Web \u3067\u691C\u7D22\u3057\u3066\u3044\u307E\u3059...","executing-complete":"{{params.query}}\u3092Web\u3067\u691C\u7D22\u3057\u307E\u3057\u305F\u3002"},"select_all_text":{"executing-start":"\u3059\u3079\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u3059\u3079\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3057\u307E\u3057\u305F\u3002"},"summarize_text":{"executing-start":"\u672C\u6587\u3092\u8981\u7D04\u3059\u308B\u3068\u2026","executing-progress":"\u8981\u7D04\u4E2D...{{\u9032\u6357}}%","executing-complete":"\u672C\u6587\u3092\u8981\u7D04\u3057\u307E\u3057\u305F\u3002"},"translate_text":{"executing-start":"\u30C6\u30AD\u30B9\u30C8\u3092 {{params.targetLanguage}} \u306B\u7FFB\u8A33\u3057\u3066\u3044\u307E\u3059...","executing-progress":"\u7FFB\u8A33\u4E2D...{{progress}}%","executing-complete":"\u30C6\u30AD\u30B9\u30C8\u3092 {{params.targetLanguage}} \u306B\u7FFB\u8A33\u3057\u307E\u3057\u305F\u3002"},"type_stored_content":{"executing-start":"\u66F8\u304D\u8FBC\u307F...","executing-complete":"\u66F8\u304D\u7D42\u308F\u308A\u307E\u3057\u305F\u3002"},"type_text":{"executing-start":"\u66F8\u304D\u8FBC\u307F...","executing-complete":"\u66F8\u304D\u7D42\u308F\u308A\u307E\u3057\u305F\u3002"},"unknown":{"executing-start":"\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u306E\u3067\u3001\u5225\u306E\u6226\u7565\u3092\u8A66\u3057\u307E\u3057\u305F...","executing-complete":"\u5225\u306E\u6226\u7565\u3092\u8A66\u3057\u3066\u307F\u307E\u3057\u305F\u3002"},"append_to_file":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u306B\u8FFD\u52A0\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A1\u30A4\u30EB\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002"},"copy_path":{"executing-start":"\u30B3\u30D4\u30FC\u4E2D...","executing-complete":"\u79C1\u306F\u305D\u308C\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002"},"create_directory":{"executing-start":"\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002"},"delete_path":{"executing-start":"\u524A\u9664\u4E2D...","executing-complete":"\u524A\u9664\u3057\u307E\u3057\u305F\u3002"},"edit_user_file":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u3092\u7DE8\u96C6\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A1\u30A4\u30EB\u3092\u7DE8\u96C6\u3057\u307E\u3057\u305F\u3002"},"get_file_info":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A1\u30A4\u30EB\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002"},"list_directory":{"executing-start":"\u30D5\u30A9\u30EB\u30C0\u306E\u4E00\u89A7\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A9\u30EB\u30C0\u3092\u4E00\u89A7\u8868\u793A\u3057\u307E\u3057\u305F\u3002"},"move_path":{"executing-start":"\u79FB\u52D5\u4E2D...","executing-complete":"\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002"},"open_path":{"executing-start":"\u958B\u5E97\u2026","executing-complete":"\u958B\u3051\u3066\u307F\u307E\u3057\u305F\u3002"},"read_user_file":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","executing-complete":"\u79C1\u306F\u305D\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u8AAD\u3093\u3060\u3002"},"run_command":{"executing-start":"\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u79C1\u306F\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3057\u307E\u3057\u305F\u3002"},"search_files":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u3092\u691C\u7D22\u4E2D...","executing-complete":"\u4E00\u81F4\u3059\u308B\u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u3002"},"search_in_files":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u5185\u3092\u691C\u7D22\u3057\u3066\u3044\u307E\u3059...","executing-complete":"\u30D5\u30A1\u30A4\u30EB\u306E\u4E2D\u3092\u691C\u7D22\u3057\u307E\u3057\u305F\u3002"},"write_user_file":{"executing-start":"\u30D5\u30A1\u30A4\u30EB\u3092\u66F8\u304D\u8FBC\u3093\u3067\u3044\u307E\u3059...","executing-complete":"\u79C1\u304C\u30D5\u30A1\u30A4\u30EB\u3092\u66F8\u304D\u8FBC\u307F\u307E\u3057\u305F\u3002"},"rewrite_text":{"executing-progress":"\u66F8\u304D\u63DB\u3048\u4E2D...{{\u9032\u884C\u72B6\u6CC1}}%"},"analyze_table":{"executing-start":"\u8868\u3092\u5206\u6790\u3059\u308B...","executing-complete":"\u79C1\u306F\u305D\u306E\u8868\u3092\u5206\u6790\u3057\u305F\u3002"}},"networkError":"\u30E2\u30C7\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u63A5\u7D9A\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u9001\u4FE1\u3059\u308B\u304B\u30A2\u30D7\u30EA\u3092\u518D\u8D77\u52D5\u3057\u3066\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","executing-org-block":"{{params.toolName}} \u306F\u3001{{params.appOrDomain}} \u3068\u306E\u3084\u308A\u53D6\u308A\u304C\u7D44\u7E54\u306B\u3088\u3063\u3066\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002","executing-destructive-block":"{{params.elementName}}\u3068\u306E\u3084\u308A\u53D6\u308A\u306F\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u624B\u52D5\u3067\u64CD\u4F5C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","executing-type-focus-block":"\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u5165\u529B\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u5185\u5BB9\u306F\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u3066\u3044\u307E\u3059\u306E\u3067\u3001\u624B\u52D5\u3067\u8CBC\u308A\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\u3002","executing-permission-block":"\u30D5\u30A1\u30A4\u30EB\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","stopped":"\u505C\u6B62\u3057\u307E\u3057\u305F\u3002","unsupportedOSVersion":"\u304A\u4F7F\u3044\u306EmacOS\u30B7\u30B9\u30C6\u30E0\u306F\u53E4\u3044\u30D0\u30FC\u30B8\u30E7\u30F3\u3067\u3059\u3002\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","loadNotice":{"firstRunSetup":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u3092\u521D\u3081\u3066\u8A2D\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u6B21\u56DE\u304B\u3089\u306F\u3088\u308A\u8FC5\u901F\u306B\u8A2D\u5B9A\u3067\u304D\u307E\u3059\u3002","largeModel":"{{model}} ({{size}} GB) \u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059\u3002\u5BB9\u91CF\u306E\u5927\u304D\u3044\u30E2\u30C7\u30EB\u306F\u8AAD\u307F\u8FBC\u307F\u306B\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3088\u308A\u65E9\u304F\u8AAD\u307F\u8FBC\u3080\u306B\u306F\u3001\u8A2D\u5B9A\u3067\u5BB9\u91CF\u306E\u5C0F\u3055\u3044\u30E2\u30C7\u30EB\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044\u3002","driverIssue":"\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u53E4\u3044\u305F\u3081\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u304C\u4F4E\u901F\u30E2\u30FC\u30C9\u3067\u52D5\u4F5C\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u66F4\u65B0\u3059\u308B\u3053\u3068\u3067\u3001\u52D5\u4F5C\u304C\u9AD8\u901F\u5316\u3055\u308C\u3001\u5B89\u5B9A\u6027\u304C\u5411\u4E0A\u3057\u307E\u3059\u3002","longTask":"\u3053\u306E\u4F5C\u696D\u306F\u6642\u9593\u304C\u304B\u304B\u308A\u305D\u3046\u306A\u306E\u3067\u3001\u3082\u3046\u5C11\u3057\u4F59\u88D5\u3092\u6301\u305F\u305B\u307E\u3059\u3002\u6700\u5927\u30671\u5206\u307B\u3069\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"}},"ready":{"waiting":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u6E96\u5099\u304C\u6574\u3044\u307E\u3057\u305F\u3002\u3054\u6307\u793A\u3092\u304A\u5F85\u3061\u3057\u3066\u3044\u307E\u3059\u3002","execute":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u6E96\u5099\u5B8C\u4E86\u3067\u3059\u3002\u3054\u8981\u671B\u306B\u5FDC\u3058\u3066\u958B\u59CB\u3057\u307E\u3059\u3002"},"start":"\u59CB\u3081\u308B","progress":"\u50CD\u304F...","title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u6E96\u5099\u304C\u6574\u3044\u307E\u3057\u305F","steps":{"thinking":"\u8003\u3048","tool":"\u9053\u5177","details":"\u8A73\u7D30","chunkProgress":"{{total}} \u306E {{current}} \u90E8\u5206","output":"\u51FA\u529B","showMore":"\u3082\u3063\u3068\u898B\u308B","showLess":"\u8868\u793A\u3092\u6E1B\u3089\u3059","contentUsed":"\u4F7F\u7528\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4","contentSource":"\u30BD\u30FC\u30B9\u30B3\u30F3\u30C6\u30F3\u30C4","contentTruncated":"{{total}}\u6587\u5B57\u306E\u3046\u3061\u3001\u6700\u521D\u306E{{shown}}\u6587\u5B57\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002","error":"\u30A8\u30E9\u30FC"},"prefix":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC:","files":{"sectionTitle":"\u30D5\u30A1\u30A4\u30EB","open":"\u958B\u3051\u308B","openFile":"\u30D5\u30A1\u30A4\u30EB\u3092\u958B\u304F","openFolder":"\u30D5\u30A9\u30EB\u30C0\u30FC\u3092\u958B\u304F","openError":"\u300C{{name}}\u300D\u3092\u958B\u3051\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u79FB\u52D5\u307E\u305F\u306F\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"input":{"other":"\u4ED6\u306E\u2026","otherPlaceholder":"\u56DE\u7B54\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","submit":"\u9001\u4FE1"},"continue":{"label":"\u7D9A\u304F","placeholder":"Cephable\u306B\u3053\u306E\u7D50\u679C\u3092\u3082\u3063\u3068\u6D3B\u7528\u3059\u308B\u3088\u3046\u4F9D\u983C\u3057\u3088\u3046\u2026"},"retry":{"label":"\u30EA\u30C8\u30E9\u30A4"},"context":{"approaching":"\u3053\u306E\u4F1A\u8A71\u306F\u9577\u304F\u306A\u3063\u3066\u304D\u307E\u3057\u305F\uFF08AI\u306E\u30E1\u30E2\u30EA\u4F7F\u7528\u91CF\u306E{{percent}}%\uFF09\u3002\u53E4\u3044\u30E1\u30C3\u30BB\u30FC\u30B8\u306F\u307E\u3082\u306A\u304F\u524A\u9664\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","trimmed":"\u3053\u306E\u4F1A\u8A71\u306FAI\u306E\u8A18\u61B6\u5BB9\u91CF\u306E\u4E0A\u9650\u306B\u9054\u3057\u305F\u305F\u3081\u3001\u4EE5\u524D\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u5FD8\u308C\u59CB\u3081\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u306B\u306F\u3001\u65B0\u3057\u3044\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002","indicator":"\u30EF\u30FC\u30AD\u30F3\u30B0\u30E1\u30E2\u30EA\u306E{{percent}}\uFF05\u304C\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B","indicatorPending":"\u3053\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u4F7F\u7528\u3055\u308C\u308B\u30EF\u30FC\u30AD\u30F3\u30B0\u30E1\u30E2\u30EA","indicatorTokens":"{{used}}/{{budget}}\u4F7F\u7528\u6E08\u307F"},"approval":{"title":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u78BA\u8A8D\u3059\u308B","approve":"\u627F\u8A8D\u3059\u308B","reject":"\u62D2\u5426\u3059\u308B","edit":"\u7DE8\u96C6","deletePath":"\u3053\u306E\u30D5\u30A1\u30A4\u30EB/\u30D5\u30A9\u30EB\u30C0\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F\u3053\u308C\u306F\u5B8C\u5168\u306B\u524A\u9664\u3055\u308C\u307E\u3059\u3002","runCommand":"\u3053\u306E\u30B7\u30A7\u30EB\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3057\u307E\u3059\u304B\uFF1F","movePath":"\u3053\u306E\u30D1\u30B9\u3092\u79FB\u52D5\u307E\u305F\u306F\u540D\u524D\u5909\u66F4\u3057\u307E\u3059\u304B\uFF1F\u5B9B\u5148\u304C\u4E0A\u66F8\u304D\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","confirmDelete":"\u6D88\u53BB","confirmRun":"\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3059\u308B","confirmMove":"\u52D5\u304F","badgeDestructive":"\u7834\u58CA\u7684","badgeCaution":"\u6CE8\u610F"},"browser":{"sectionTitle":"\u30D6\u30E9\u30A6\u30B6","view":"\u30D6\u30E9\u30A6\u30B6\u3092\u8868\u793A","open":"\u958B\u3051\u308B","openError":"\u30D6\u30E9\u30A6\u30B6\u3092\u958B\u3051\u307E\u305B\u3093\u3067\u3057\u305F\u3002"},"resume":{"title":"\u904E\u53BB\u306E\u30C1\u30E3\u30C3\u30C8\u3092\u7D9A\u3051\u308B","description":"\u81EA\u52D5\u5316\u306E\u5C65\u6B74\u3092\u691C\u7D22\u3057\u3066\u3001\u4E2D\u65AD\u3057\u305F\u3068\u3053\u308D\u304B\u3089\u518D\u958B\u3067\u304D\u307E\u3059\u3002","searchPlaceholder":"\u904E\u53BB\u306E\u30C1\u30E3\u30C3\u30C8\u3092\u691C\u7D22\u2026","noMatches":"\u300C{{query}}\u300D\u306B\u4E00\u81F4\u3059\u308B\u904E\u53BB\u306E\u30C1\u30E3\u30C3\u30C8\u306F\u3042\u308A\u307E\u305B\u3093","empty":"\u904E\u53BB\u306E\u81EA\u52D5\u5316\u8A2D\u5B9A\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002","continuing":"\u30C1\u30E3\u30C3\u30C8\u3092\u7D9A\u3051\u308B","stopContinuing":"\u4EE3\u308F\u308A\u306B\u65B0\u3057\u3044\u30C1\u30E3\u30C3\u30C8\u3092\u958B\u59CB\u3059\u308B","indicator":"\u300C{{title}}\u300D\u306E\u4F1A\u8A71\u3092\u7D9A\u3051\u308B","clear":"\u9078\u629E\u3057\u305F\u30C1\u30E3\u30C3\u30C8\u3092\u30AF\u30EA\u30A2\u3059\u308B"}},"generatedByAI":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u3092\u642D\u8F09\u3057\u3066\u3044\u307E\u3059\u3002\u6B63\u78BA\u6027\u306B\u3064\u3044\u3066\u306F\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","networkError":"\u30E2\u30C7\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u63A5\u7D9A\u304C\u5207\u65AD\u3055\u308C\u307E\u3057\u305F\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u9001\u4FE1\u3059\u308B\u304B\u30A2\u30D7\u30EA\u3092\u518D\u8D77\u52D5\u3057\u3066\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","genericError":"\u4E88\u671F\u305B\u306C\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","download":{"title":"AI\u30E2\u30C7\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3001\u3088\u308A\u591A\u304F\u306E\u6A5F\u80FD\u3092\u89E3\u304D\u653E\u3061\u307E\u3057\u3087\u3046","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u30ED\u30FC\u30AB\u30EB\u30E2\u30C7\u30EB\u3092\u30C7\u30D0\u30A4\u30B9\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u30C7\u30FC\u30BF\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u304C\u4FDD\u8B77\u3055\u308C\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","confirm":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","cancel":"\u4ECA\u3058\u3083\u306A\u3044"},"runningInBackground":{"generate":"\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u751F\u6210\u4E2D...","rewrite":"\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u66F8\u304D\u8FBC\u307F\u4E2D...","translate":"\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u7FFB\u8A33\u4E2D...","summarize":"\u80CC\u666F\u3092\u307E\u3068\u3081\u308B\u3068\u2026","generic":"\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u5B9F\u884C\u4E2D..."},"processing":"\u51E6\u7406..."},"inputMethod":"\u5165\u529B\u65B9\u6CD5:","hotkey":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","titlePlural":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","titlePanel":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3","label":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u8868\u793A\u540D","placeholder":"\u8868\u793A\u3059\u308B\u540D\u524D","question":"\u3053\u306E\u30DC\u30BF\u30F3\u306B\u3069\u3093\u306A\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u304B?","when":"\u30BF\u30C3\u30D7\u3059\u308B\u3068\u2026","description":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306F\u3001\u30A2\u30D7\u30EA\u4E0A\u3067\u95A2\u9023\u3059\u308B\u64CD\u4F5C\u3092\u5B9F\u884C\u3059\u308B\u305F\u3081\u306B\u30BF\u30C3\u30D7\u3067\u304D\u308B\u3001\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30DC\u30BF\u30F3\u3067\u3059\u30021\u56DE\u306E\u30BF\u30C3\u30D7\u3067\u8907\u6570\u306E\u624B\u9806\u3092\u5B9F\u884C\u3057\u305F\u308A\u3001\u5358\u4E00\u306E\u64CD\u4F5C\u3092\u5B9F\u884C\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002","usagePrompt":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306F\u3001\u30A2\u30D7\u30EA\u4E0A\u3067\u95A2\u9023\u3059\u308B\u64CD\u4F5C\u3092\u5B9F\u884C\u3059\u308B\u305F\u3081\u306B\u30BF\u30C3\u30D7\u3067\u304D\u308B\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u306A\u30DC\u30BF\u30F3\u3067\u3059\u3002\u30E1\u30A4\u30F3\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u8A2D\u5B9A\u30DA\u30FC\u30B8\u304B\u3089\u3001\u30DC\u30BF\u30F3\u306E\u8FFD\u52A0\u3001\u524A\u9664\u3001\u540D\u524D\u306E\u7DE8\u96C6\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","reorder":"\u4E0A\u3078\u79FB\u52D5\u30DC\u30BF\u30F3\u3068\u4E0B\u3078\u79FB\u52D5\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u9806\u5E8F\u3092\u4E26\u3079\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","emptyTitle":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306A\u3057","edit":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u7DE8\u96C6","tap":"{{value}}\u3092\u30BF\u30C3\u30D7","copySuffix":"{{name}}_\u30B3\u30D4\u30FC","hotkeysOnly":"\u30AB\u30B9\u30BF\u30E0\u30DC\u30BF\u30F3","allControls":"\u3059\u3079\u3066\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","show":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8868\u793A","deprecatedDialog":{"title":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u66F4\u65B0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","description2":"\u305F\u3063\u305F1\u79D2\u306E\u7C21\u5358\u306A\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3067\u3001\u30B7\u30FC\u30E0\u30EC\u30B9\u306A\u30DC\u30BF\u30F3\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u4F53\u9A13\u3092\u304A\u697D\u3057\u307F\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u9762\u5012\u306A\u624B\u9806\u306F\u3082\u3046\u4E0D\u8981\u3002\u3088\u308A\u30E6\u30FC\u30B6\u30FC\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306A\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9\u304C\u3042\u306A\u305F\u3092\u5F85\u3063\u3066\u3044\u307E\u3059\u3002\u3055\u3042\u3001\u4E57\u308A\u63DB\u3048\u306E\u6E96\u5099\u306F\u3067\u304D\u3066\u3044\u307E\u3059\u304B\uFF1F","confirm":"\u3084\u308A\u307E\u3057\u3087\u3046\uFF01","description1":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u4ED8\u304D\u306E\u53E4\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u3054\u5229\u7528\u306E\u3088\u3046\u3067\u3059\u306D\u3002\u30A8\u30AD\u30B5\u30A4\u30C6\u30A3\u30F3\u30B0\u306A\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u3054\u7528\u610F\u3057\u307E\u3057\u305F\uFF01\u30B7\u30B9\u30C6\u30E0\u3092\u5237\u65B0\u3057\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u4F5C\u6210\u3068\u7DE8\u96C6\u304C\u7C21\u5358\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u3082\u3046\u8A73\u7D30\u306A\u8A2D\u5B9A\u306B\u7169\u308F\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"demo":{"title":"\u30C7\u30E2\u306E\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","step1":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u30AA\u30F3\u306B\u3059\u308B","step2":"\u30C6\u30AD\u30B9\u30C8 \u30D6\u30ED\u30C3\u30AF\u3092\u5236\u5FA1\u3059\u308B\u306B\u306F\u3001\u4EE5\u4E0B\u306E\u30B5\u30F3\u30D7\u30EB \u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","command1":"\u30DC\u30BF\u30F31\u3092\u62BC\u3059\u3068\u300C\u6587\u5B57\u3092\u5927\u304D\u304F\u3059\u308B\u300D","command2":"\u30DC\u30BF\u30F32\u3092\u62BC\u3059\u3068\u300C\u592A\u5B57\u300D\u306B\u306A\u308A\u307E\u3059","command3":"","continue":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3067\u7D9A\u884C","description":"\u4EE5\u4E0B\u306E\u30C7\u30E2\u30A8\u30EA\u30A2\u3067\u306F\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8A66\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30C7\u30E2\u3067\u306F\u3001\u4EE5\u4E0B\u306E\u30C6\u30AD\u30B9\u30C8\u30A8\u30EA\u30A2\u306E\u64CD\u4F5C\u306E\u307F\u306B\u9650\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002"},"example":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u4F8B","command1":"\u4E00\u6642\u505C\u6B62\u3092\u30BF\u30C3\u30D7","example1":"\u4F8B\uFF1A\u300C\u30D3\u30C7\u30AA\u3092\u4E00\u6642\u505C\u6B62\u300D","command2":"\u300C\u9032\u3080\u300D\u3092\u30BF\u30C3\u30D7","example2":"\u300C\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8\u300D\u306E\u4F8B","command3":"\u30BF\u30C3\u30D7\u30B9\u30C8\u30C3\u30D7","example3":"\u4F8B\uFF1A\u300C\u30A6\u30A3\u30F3\u30C9\u30A6\u3092\u9589\u3058\u308B\u300D","description":"\u3053\u308C\u3089\u306E\u4F8B\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3084\u63A5\u7D9A\u3092\u5236\u5FA1\u3059\u308B\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306E\u6C4E\u7528\u6027\u3092\u793A\u3057\u3066\u3044\u307E\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u306E\u5B9F\u884C\u3001\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9\u306E\u64CD\u4F5C\u3001\u3042\u308B\u3044\u306F\u30BF\u30C3\u30D7\u3059\u308B\u3060\u3051\u3067\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002"},"emptySearch":"\u3053\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002","empty":"\u73FE\u5728\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u306A\u3044\u3088\u3046\u3067\u3059\u3002","emptyLong":"\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u542B\u3080\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"reset":"\u30EA\u30BB\u30C3\u30C8","info":"\u8A73\u7D30\u60C5\u5831","device":{"title":"\u7E4B\u304C\u308A","titlePlural":"\u63A5\u7D9A","status":{"title":"\u63A5\u7D9A\u30B9\u30C6\u30FC\u30BF\u30B9:","connected":{"application":"\u63A5\u7D9A\u3055\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3","connection":"\u63A5\u7D9A","device":"\u63A5\u7D9A\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9","game":"\u30B3\u30CD\u30AF\u30C6\u30C3\u30C9\u30B2\u30FC\u30E0"},"disconnected":{"application":"\u5207\u65AD\u3055\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3","connection":"\u5207\u65AD","device":"\u5207\u65AD\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9","game":"\u5207\u65AD\u3055\u308C\u305F\u30B2\u30FC\u30E0"}},"running":"\u30E9\u30F3\u30CB\u30F3\u30B0","offline":"\u30AA\u30D5\u30E9\u30A4\u30F3","otherDevices":"\u305D\u306E\u4ED6\u306E\u51FA\u529B\u63A5\u7D9A","currentStatus":"\u73FE\u5728\u306E\u30B9\u30C6\u30FC\u30BF\u30B9:","connectionStatus":"\u63A5\u7D9A\u30B9\u30C6\u30FC\u30BF\u30B9:","profileStatus":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB:","name":{"title":"\u63A5\u7D9A\u540D","question":"\u3053\u306E\u63A5\u7D9A\u3092\u4F55\u3068\u547C\u3073\u307E\u3059\u304B?","description":"\u5F8C\u3067\u7C21\u5358\u306B\u898B\u3064\u3051\u3089\u308C\u308B\u3088\u3046\u306B\u3001\u63A5\u7D9A\u306B\u540D\u524D\u3092\u4ED8\u3051\u307E\u3059\u3002","placeholder":"\u63A5\u7D9A\u540D","edit":"\u63A5\u7D9A\u540D\u3092\u7DE8\u96C6"},"updates":{"title":"\u63A5\u7D9A\u306E\u66F4\u65B0","settings":"\u63A5\u7D9A\u66F4\u65B0\u8A2D\u5B9A","description":"\u63A5\u7D9A\u30D5\u30A1\u30FC\u30E0\u30A6\u30A7\u30A2\u306E\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3001\u81EA\u52D5\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u8A2D\u5B9A\u3092\u5909\u66F4\u3057\u307E\u3059","edit":"\u66F4\u65B0\u8A2D\u5B9A\u3092\u7DE8\u96C6\u3059\u308B","check":{"title":"\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3059\u308B","processing":"\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u4E2D\u306B\u63A5\u7D9A\u304C\u518D\u958B\u3055\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002","description":"\u30BF\u30C3\u30D7\u3057\u3066\u63A5\u7D9A\u306E\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304C\u5229\u7528\u53EF\u80FD\u3067\u3001\u63A5\u7D9A\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u5834\u5408\u306F\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304C\u958B\u59CB\u3055\u308C\u307E\u3059\u3002\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u306B\u306F\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"auto":{"title":"\u81EA\u52D5\u66F4\u65B0","description":"\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u96FB\u6E90\u306B\u63A5\u7D9A\u3057\u3001Wi-Fi\u306B\u63A5\u7D9A\u3057\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u304C\u5229\u7528\u53EF\u80FD\u306A\u5834\u5408\u3001\u81EA\u52D5\u7684\u306B\u63A5\u7D9A\u304C\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u30AA\u30D5\u306E\u5834\u5408\u306F\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u6700\u65B0\u306E\u72B6\u614B\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","option":"\u81EA\u52D5\u66F4\u65B0\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B?"}},"delete":{"title":"{{name}} \u306E\u30EA\u30F3\u30AF\u3092\u89E3\u9664","titleLong":"\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30EA\u30F3\u30AF\u3092\u89E3\u9664","description":"\u30EA\u30F3\u30AF\u3092\u89E3\u9664\u3059\u308B\u3068\u3001Cephable\u3068\u3053\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u307E\u305F\u306F\u30B2\u30FC\u30E0\u306E\u63A5\u7D9A\u304C\u5207\u65AD\u3055\u308C\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u3082\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u63A5\u7D9A\u3001\u30B3\u30DE\u30F3\u30C9\u306E\u9001\u4FE1\u3001\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u306F\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u304C\u3001\u5C06\u6765\u518D\u3073\u4F7F\u7528\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u540C\u3058\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u307E\u305F\u306F\u30B2\u30FC\u30E0\u3078\u306E\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","confirm":"\u3053\u306E\u63A5\u7D9A\u3092\u89E3\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?","confirmLong":"\u3053\u306E\u63A5\u7D9A\u3092\u767B\u9332\u89E3\u9664\u3057\u3066\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F \u4ECA\u5F8C\u3001\u3053\u306E\u63A5\u7D9A\u306B\u63A5\u7D9A\u3057\u305F\u308A\u3001\u30B3\u30DE\u30F3\u30C9\u3092\u9001\u4FE1\u3057\u305F\u308A\u3001\u66F4\u65B0\u3057\u305F\u308A\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u767B\u9332\u89E3\u9664\u3068\u30EA\u30BB\u30C3\u30C8\u3092\u884C\u3046\u3068\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u306E\u63A5\u7D9A\u3092\u6700\u521D\u304B\u3089\u8A2D\u5B9A\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","confirmButton":"\u306F\u3044\u3001\u3053\u306E\u63A5\u7D9A\u3092\u524A\u9664\u3057\u307E\u3059\u3002"},"manage":{"title":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u63A5\u7D9A\u306E\u8A73\u7D30\u3092\u8868\u793A\u304A\u3088\u3073\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","description":"","name":"\u7BA1\u7406\u3092\u5BB9\u6613\u306B\u3059\u308B\u305F\u3081\u306B\u63A5\u7D9A\u540D\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3059\u3002"},"error":{"save":"\u63A5\u7D9A\u306E\u4FDD\u5B58\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","load":"\u63A5\u7D9A\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","add":"\u63A5\u7D9A\u306E\u8FFD\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","delete":"\u63A5\u7D9A\u306E\u524A\u9664\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","updates":"\u66F4\u65B0\u306E\u78BA\u8A8D\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","connection":"\u63A5\u7D9A\u304C\u78BA\u7ACB\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u518D\u8A66\u884C\u3059\u308B\u524D\u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","deleteLong":"\u3053\u306E\u63A5\u7D9A\u3092\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5834\u5408\u306F\u3001\u63A5\u7D9A\u8A2D\u5B9A\u3067\u3053\u306E\u63A5\u7D9A\u3092\u624B\u52D5\u3067\u524A\u9664\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"success":{"save":"\u63A5\u7D9A\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","add":"\u63A5\u7D9A\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","delete":"\u63A5\u7D9A\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002"},"description":"Cephable\u306F\u8907\u6570\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u63A5\u7D9A\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u3059\u3002\u8A2D\u5B9A\u3092\u7BA1\u7406\u3057\u305F\u308A\u3001\u3053\u3053\u304B\u3089\u3059\u3079\u3066\u3092\u9078\u629E\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306F\u5E38\u306B\u30E1\u30A4\u30F3\u306E\u63A5\u7D9A\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u63A5\u7D9A\u306F\u5F8C\u3067\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002","swap":{"titlePlural":"\u30B9\u30EF\u30C3\u30D7\u63A5\u7D9A","description":"Cephable\u306F\u8907\u6570\u306E\u30C7\u30D0\u30A4\u30B9\u3068\u63A5\u7D9A\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u3059\u3002\u3053\u3053\u304B\u3089\u3044\u305A\u308C\u304B\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u306F\u5E38\u306B\u30E1\u30A4\u30F3\u306E\u63A5\u7D9A\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u63A5\u7D9A\u306F\u5F8C\u304B\u3089\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002"},"control":{"button":"{{name}} \u3092\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":{"application":"\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u63A5\u7D9A\u3055\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u4FDD\u5B58\u300D\u3068\u8A00\u3046\u3068\u3001\u5B9F\u884C\u4E2D\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","connection":"\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u63A5\u7D9A\u4E2D\u306E\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300C\u4FDD\u5B58\u300D\u3068\u8A00\u3046\u3068\u3001\u63A5\u7D9A\u4E2D\u306E\u30C7\u30D0\u30A4\u30B9\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","device":"\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u30D8\u30C3\u30C9\u30E2\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3092\u4F7F\u3063\u3066\u3001\u63A5\u7D9A\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300CSpotify\u3092\u958B\u3044\u3066\u300D\u3068\u8A00\u3046\u3068\u3001\u8D77\u52D5\u4E2D\u306E\u30C7\u30D0\u30A4\u30B9\u3067Spotify\u304C\u958B\u304D\u307E\u3059\u3002","game":"\u3053\u306E\u63A5\u7D9A\u578B\u30B2\u30FC\u30E0\u306F\u3001\u97F3\u58F0\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u982D\u306E\u52D5\u304D\u306A\u3069\u3092\u4F7F\u3063\u3066\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u300CGo\u300D\u3068\u8A00\u3046\u3068\u3001\u30E9\u30F3\u30CB\u30F3\u30B0\u30B2\u30FC\u30E0\u3067\u30D7\u30EC\u30A4\u30E4\u30FC\u304C\u52D5\u304D\u307E\u3059\u3002"},"generic":"\u5236\u5FA1\u63A5\u7D9A"},"titleShort":"\u63A5\u7D9A\u3059\u308B","titleLong":"\u63A5\u7D9A\u3068\u62E1\u5F35\u6A5F\u80FD","viewAll":"\u3059\u3079\u3066\u306E\u63A5\u7D9A\u3092\u8868\u793A","add":{"short":"\u4F38\u3070\u3059","title":"\u65B0\u3057\u3044\u63A5\u7D9A\u307E\u305F\u306F\u62E1\u5F35\u6A5F\u80FD\u3092\u8FFD\u52A0\u3059\u308B","description":"\u63A5\u7D9A\u3068\u62E1\u5F35\u6A5F\u80FD\u306F\u3001Cephable\u306E\u4F53\u9A13\u3092\u3055\u3089\u306B\u5145\u5B9F\u3055\u305B\u308B\u65B9\u6CD5\u3067\u3059\u3002\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8FFD\u52A0\u3059\u308B\u3053\u3068\u3067\u3001\u3088\u308A\u591A\u304F\u306E\u30C7\u30D0\u30A4\u30B9\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3001\u30B2\u30FC\u30E0\u306B\u63A5\u7D9A\u3067\u304D\u307E\u3059\u3002\u63A5\u7D9A\u3068\u62E1\u5F35\u6A5F\u80FD\u3092\u8FFD\u52A0\u3059\u308B\u3053\u3068\u3067\u3001Cephable\u306E\u4F53\u9A13\u3092\u6B21\u306E\u30EC\u30D9\u30EB\u306B\u5F15\u304D\u4E0A\u3052\u307E\u3057\u3087\u3046\u3002","action":"\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u8FFD\u52A0\u3059\u308B","notAvailable":"\u3053\u306E\u63A5\u7D9A\u307E\u305F\u306F\u62E1\u5F35\u6A5F\u80FD\u306F\u73FE\u5728\u516C\u958B\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3053\u308C\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u4F5C\u6210\u3057\u305F\u62E1\u5F35\u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u5834\u5408\u306B\u3088\u304F\u767A\u751F\u3057\u307E\u3059\u3002\u5F8C\u307B\u3069\u518D\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","isNotPublic":"\u30D7\u30EC\u30D3\u30E5\u30FC\uFF1A\u3053\u306E\u62E1\u5F35\u6A5F\u80FD\u306F\u958B\u767A\u8005\u5411\u3051\u30D7\u30EC\u30D3\u30E5\u30FC\u6BB5\u968E\u3067\u3042\u308A\u3001\u672A\u5B8C\u6210\u306E\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u958B\u767A\u8005\u306E\u7686\u69D8\u306F\u3001\u4E00\u822C\u516C\u958B\u524D\u306B\u3059\u3079\u3066\u306E\u624B\u9806\u3092\u5B8C\u4E86\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u306F\u5F8C\u307B\u3069\u3001\u5B8C\u5168\u7248\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"},"new":"\u65B0\u3057\u3044\u63A5\u7D9A\u304C\u3067\u304D\u307E\u3057\u305F!","newLong":"\u65B0\u3057\u3044\u63A5\u7D9A\u304C\u3067\u304D\u307E\u3057\u305F\u3002\u4F7F\u7528\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u4E0B\u306E\u30E1\u30CB\u30E5\u30FC\u304B\u3089\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","selectDevice":"\u30C7\u30D0\u30A4\u30B9\u3092\u9078\u629E"},"explore":"\u63A2\u691C\u3059\u308B","shortcuts":{"title":"\u30B0\u30ED\u30FC\u30D0\u30EB\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8","description":"\u30AD\u30FC\u30DC\u30FC\u30C9 \u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u30B7\u30B9\u30C6\u30E0\u4E0A\u306E\u3069\u3053\u304B\u3089\u3067\u3082 Cephable \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u3059\u3070\u3084\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002","info":"\u3053\u308C\u3089\u306E\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u306F\u30B0\u30ED\u30FC\u30D0\u30EB\u306B\u6A5F\u80FD\u3057\u3001Cephable \u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u306A\u3044\u5834\u5408\u3067\u3082\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","shortcut":"\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8","toggleMicrophone":"\u30DE\u30A4\u30AF\u3092\u5207\u308A\u66FF\u3048\u308B","toggleDictation":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u5207\u308A\u66FF\u3048\u308B","toggleVoiceControl":"\u97F3\u58F0\u5236\u5FA1\u30E2\u30FC\u30C9\u3092\u5207\u308A\u66FF\u3048\u308B","togglePanel":"\u30C8\u30B0\u30EB\u30D1\u30CD\u30EB","registrationFailed":"\u4E00\u90E8\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u767B\u9332\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u4ED6\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002","record":{"title":"\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3092\u8A18\u9332","start":"\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8A18\u9332","listening":"\u5E0C\u671B\u3059\u308B\u30AD\u30FC\u306E\u7D44\u307F\u5408\u308F\u305B\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044...","pressKeys":"\u4ECA\u3059\u3050\u30AD\u30FC\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044"},"formatHint":"\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u4FEE\u98FE\u30AD\u30FC ({{modifierKey}}, {{modifierKey2}}, Shift) \u3068\u4ED6\u306E 1 \u3064\u306E\u30AD\u30FC\u3092\u9078\u629E\u3057\u307E\u3059\u3002"},"gamepad":{"title":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u30B5\u30DD\u30FC\u30C8","description":"PC\u30B2\u30FC\u30E0\u7528\u306E\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u3068\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u51FA\u529B\u3092\u69CB\u6210\u3059\u308B","driver":{"description":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u51FA\u529B\u3092\u30B5\u30DD\u30FC\u30C8\u3059\u308B\u306B\u306F\u3001Cephable \u3067 ViGEm \u3068\u547C\u3070\u308C\u308B\u5916\u90E8\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30C9\u30E9\u30A4\u30D0\u30FC\u306F\u3001\u30B2\u30FC\u30E0\u304C\u30CD\u30A4\u30C6\u30A3\u30D6\u306B\u8A8D\u8B58\u3059\u308B\u4EEE\u60F3 Xbox 360 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u307E\u3059\u3002","installed":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u307E\u3057\u305F\u3002\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u51FA\u529B\u304C\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u305D\u308C\u3067\u3082\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u518D\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","notInstalled":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u306E\u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u3066\u3044\u307E\u305B\u3093","install":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30C9\u30E9\u30A4\u30D0\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B","reinstall":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30C9\u30E9\u30A4\u30D0\u3092\u518D\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B","installing":"ViGEm \u30B2\u30FC\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC \u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u3044\u307E\u3059...","installSuccess":"ViGEm \u30B2\u30FC\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC \u30C9\u30E9\u30A4\u30D0\u30FC\u304C\u6B63\u5E38\u306B\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u307E\u3057\u305F\u3002\u3053\u308C\u3067\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u51FA\u529B\u3092\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002","installFailed":"ViGEm\u30C9\u30E9\u30A4\u30D0\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u3044\u305F\u3060\u304F\u304B\u3001ViGEm\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u304B\u3089\u624B\u52D5\u3067\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044\u3002","title":"\u30B2\u30FC\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30C9\u30E9\u30A4\u30D0\u30FC","disclosure":{"title":"\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u88FD\u306E\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059\u304B\uFF1F","description":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u30B5\u30DD\u30FC\u30C8\u306B\u306F\u3001Cephable\u304C\u4EEE\u60F3Xbox\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3092\u30A8\u30DF\u30E5\u30EC\u30FC\u30C8\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u88FD\u306E\u975E\u516C\u5F0F\u30C9\u30E9\u30A4\u30D0\u30FC\u3067\u3042\u308BViGEm\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u304C\u5FC5\u8981\u3067\u3059\u3002Cephable\u306B\u3053\u306E\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u305B\u305F\u3044\u5834\u5408\u306E\u307F\u3001\u7D9A\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","confirm":"ViGEm\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044"}},"platform":{"unsupported":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u6A5F\u80FD\u306F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306B\u3088\u3063\u3066\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093","unsupportedDescription":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u51FA\u529B\u6A5F\u80FD\u306F\u73FE\u5728\u3001Windows x64\u30B7\u30B9\u30C6\u30E0\u3067\u306E\u307F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u3059\u3002Mac\u304A\u3088\u3073Windows ARM64\u306F\u307E\u3060\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"},"usage":"\u30B2\u30FC\u30E0 \u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC \u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B\u3068\u3001\u30DE\u30AF\u30ED\u3084\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3067\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u52D5\u304D\u3084\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u30DC\u30BF\u30F3\u306E\u62BC\u4E0B\u3092\u4F7F\u7528\u3057\u3066\u30B2\u30FC\u30E0\u3092\u5236\u5FA1\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"youtube":{"unavailable":{"title":"\u30D3\u30C7\u30AA\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093","description":"\u3053\u306E\u52D5\u753B\u306F\u73FE\u5728\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u5F8C\u307B\u3069\u3082\u3046\u4E00\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","retry":"\u30EA\u30C8\u30E9\u30A4"},"watch":{"title":"\u304A\u3063\u3068\u3002","description":"\u52D5\u753B\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u3088\u3046\u3067\u3059\u3002YouTube\u3067\u76F4\u63A5\u8996\u8074\u3067\u304D\u307E\u3059\u3002","button":"YouTube\u3067\u898B\u308B"},"offline":{"title":"\u30D3\u30C7\u30AA\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093","description":"\u3053\u306EYouTube\u52D5\u753B\u3092\u8AAD\u307F\u8FBC\u3080\u306B\u306F\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u304C\u5FC5\u8981\u3067\u3059\u3002\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"}},"metrics":{"download":{"success":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306B\u6B63\u5E38\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3057\u305F\u3002","manualPath":"\u30E1\u30C8\u30EA\u30AF\u30B9\u30D5\u30A1\u30A4\u30EB\u306F {{path}} \u3067\u5165\u624B\u3067\u304D\u307E\u3059","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","noFile":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"},"clear":{"success":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u304C\u6B63\u5E38\u306B\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u306E\u6D88\u53BB\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","noFile":"\u30AF\u30EA\u30A2\u3059\u308B\u30E1\u30C8\u30EA\u30C3\u30AF \u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","confirm":"\u3059\u3079\u3066\u306E\u30E1\u30C8\u30EA\u30C3\u30AF\u30C7\u30FC\u30BF\u3092\u30AF\u30EA\u30A2\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"}},"suggestedPrompts":{"title":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8","description":"AI \u30BF\u30B9\u30AF\u306B\u8868\u793A\u3055\u308C\u308B\u63D0\u6848\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3059\u3050\u306B\u958B\u59CB\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","edit":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u7DE8\u96C6\u3059\u308B","generate":"\u30C6\u30AD\u30B9\u30C8\u3092\u751F\u6210\u3059\u308B","rewrite":"\u30C6\u30AD\u30B9\u30C8\u306E\u66F8\u304D\u63DB\u3048","addGenerate":"\u751F\u6210\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8FFD\u52A0\u3059\u308B","addRewrite":"\u66F8\u304D\u63DB\u3048\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8FFD\u52A0\u3059\u308B","remove":"\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u524A\u9664","generatePlaceholder":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044...","rewritePlaceholder":"\u30C6\u30AD\u30B9\u30C8\u66F8\u304D\u63DB\u3048\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044...","suggested":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8","suggestedFor":"{{profileName}} \u306B\u304A\u3059\u3059\u3081","seeAll":"\u3059\u3079\u3066\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8868\u793A","showLess":"\u8868\u793A\u3092\u6E1B\u3089\u3059","allPrompts":"\u3059\u3079\u3066\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","customFor":"{{profileName}} \u306E\u30AB\u30B9\u30BF\u30E0\u30D7\u30ED\u30F3\u30D7\u30C8","defaultPrompts":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","defaultGenerate":["\u65B0\u88FD\u54C1\u3092\u7D39\u4ECB\u3059\u308B\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306A\u30E1\u30FC\u30EB","\u6765\u9031\u306E\u30C1\u30FC\u30E0\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306E\u8B70\u984C","\u65B0\u3057\u3044\u53D6\u308A\u7D44\u307F\u306E\u305F\u3081\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u63D0\u6848\u306E\u6982\u8981","\u6B63\u5F0F\u306A\u30D3\u30B8\u30CD\u30B9\u30EC\u30BF\u30FC\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","\u6280\u8853\u6587\u66F8\u30BB\u30AF\u30B7\u30E7\u30F3","\u30E6\u30FC\u30B6\u30FC\u30DE\u30CB\u30E5\u30A2\u30EB\u306E\u7D39\u4ECB","\u30C8\u30EC\u30FC\u30CB\u30F3\u30B0\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u6982\u8981","\u653F\u7B56\u6587\u66F8\u306E\u8349\u6848","\u4F1A\u8B70\u5F8C\u306E\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30E1\u30FC\u30EB","\u9867\u5BA2\u3078\u306E\u611F\u8B1D\u306E\u30E1\u30C3\u30BB\u30FC\u30B8","\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u66F4\u65B0\u30E1\u30FC\u30EB","\u4F1A\u793E\u306E\u30A4\u30D9\u30F3\u30C8\u3078\u306E\u62DB\u5F85\u72B6","\u671F\u9650\u304C\u8FEB\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u77E5\u3089\u305B\u308B\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u30E1\u30FC\u30EB","\u65B0\u3057\u3044\u30C1\u30FC\u30E0\u30E1\u30F3\u30D0\u30FC\u3078\u306E\u6B53\u8FCE\u30E1\u30FC\u30EB","\u30B5\u30FC\u30D3\u30B9\u4E2D\u65AD\u306B\u95A2\u3059\u308B\u304A\u8A6B\u3073\u30E1\u30FC\u30EB","\u30CB\u30E5\u30FC\u30B9\u30EC\u30BF\u30FC\u306E\u7D39\u4ECB","\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306E\u305F\u3081\u306E\u30D6\u30EC\u30A4\u30F3\u30B9\u30C8\u30FC\u30DF\u30F3\u30B0\u30EA\u30B9\u30C8","\u30C1\u30FC\u30E0\u306E\u751F\u7523\u6027\u3092\u5411\u4E0A\u3055\u305B\u308B\u5275\u9020\u7684\u306A\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3","\u4F1A\u793E\u306E\u6170\u5B89\u65C5\u884C\u306E\u30A2\u30A4\u30C7\u30A2","\u65B0\u3057\u3044\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u6A5F\u80FD\u306E\u30B3\u30F3\u30BB\u30D7\u30C8","\u9867\u5BA2\u4F53\u9A13\u5411\u4E0A\u306E\u305F\u3081\u306E\u63D0\u6848","\u88FD\u54C1\u958B\u767A\u306E\u305F\u3081\u306E\u9769\u65B0\u7684\u306A\u30A2\u30A4\u30C7\u30A2","\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u6295\u7A3F\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u30A2\u30A4\u30C7\u30A2","\u5C02\u9580\u80FD\u529B\u958B\u767A\u306E\u305F\u3081\u306E\u30EF\u30FC\u30AF\u30B7\u30E7\u30C3\u30D7\u306E\u30C8\u30D4\u30C3\u30AF","\u30E6\u30FC\u30B6\u30FC\u5165\u529B\u3092\u691C\u8A3C\u3059\u308B\u95A2\u6570","\u30E6\u30FC\u30B6\u30FC\u7BA1\u7406\u306E\u305F\u3081\u306E\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u30AF\u30A8\u30EA","API\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u30A8\u30E9\u30FC\u51E6\u7406\u30B3\u30FC\u30C9","\u8A2D\u5B9A\u30D5\u30A1\u30A4\u30EB\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","\u8907\u96D1\u306A\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3092\u8AAC\u660E\u3059\u308B\u30B3\u30E1\u30F3\u30C8","\u65B0\u3057\u3044\u6A5F\u80FD\u306E\u30E6\u30CB\u30C3\u30C8\u30C6\u30B9\u30C8\u30B1\u30FC\u30B9","API\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8","\u81EA\u52D5\u5C55\u958B\u7528\u306E\u30B9\u30AF\u30EA\u30D7\u30C8"],"defaultRewrite":["\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u3082\u3063\u3068\u7C21\u6F54\u306B\u3001\u8981\u70B9\u3092\u62BC\u3055\u3048\u305F\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u3053\u306E\u8981\u7D04\u3092\u3055\u3089\u306B\u8A73\u3057\u304F\u8A18\u8FF0\u3059\u308B","\u3053\u308C\u3092\u756A\u53F7\u4ED8\u304D\u30EA\u30B9\u30C8\u3068\u3057\u3066\u518D\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059","\u3053\u308C\u3092\u7B87\u6761\u66F8\u304D\u306B\u5909\u63DB\u3059\u308B","\u3053\u308C\u3092\u660E\u78BA\u306A\u6BB5\u843D\u306B\u518D\u69CB\u6210\u3059\u308B","\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u7D20\u65E9\u304F\u30B9\u30AD\u30E3\u30F3\u3057\u3084\u3059\u304F\u3057\u307E\u3059","\u3053\u306E\u60C5\u5831\u3092\u968E\u5C64\u7684\u306B\u6574\u7406\u3059\u308B","\u3053\u308C\u3092\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7\u306E\u30AC\u30A4\u30C9\u3068\u3057\u3066\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u307E\u3059","\u3053\u306E\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u3088\u308A\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u3067\u30D5\u30A9\u30FC\u30DE\u30EB\u306A\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u3053\u308C\u3092\u3082\u3063\u3068\u30AB\u30B8\u30E5\u30A2\u30EB\u3067\u30D5\u30EC\u30F3\u30C9\u30EA\u30FC\u306A\u611F\u3058\u306B\u66F8\u304D\u76F4\u3057\u3066\u304F\u3060\u3055\u3044","\u3088\u308A\u52B1\u307E\u3057\u306B\u306A\u308B\u3088\u3046\u53E3\u8ABF\u3092\u8ABF\u6574\u3059\u308B","\u3082\u3063\u3068\u81EA\u4FE1\u3068\u65AD\u5B9A\u7684\u306A\u8A00\u3044\u65B9\u3092\u3057\u307E\u3057\u3087\u3046","\u5916\u4EA4\u7684\u306B\u53E3\u8ABF\u3092\u548C\u3089\u3052\u308B","\u3053\u306E\u30C6\u30AD\u30B9\u30C8\u306B\u71B1\u610F\u3068\u30A8\u30CD\u30EB\u30AE\u30FC\u3092\u52A0\u3048\u308B","\u3082\u3063\u3068\u5171\u611F\u7684\u3067\u7406\u89E3\u306E\u3042\u308B\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u3088\u308A\u5354\u529B\u7684\u306A\u53E3\u8ABF\u3067\u66F8\u304D\u76F4\u3059","\u4E00\u822C\u5411\u3051\u306B\u7C21\u7565\u5316\u3059\u308B","\u3053\u306E\u8AAC\u660E\u3092\u3088\u308A\u6280\u8853\u7684\u304B\u3064\u8A73\u7D30\u306B\u3057\u3066\u304F\u3060\u3055\u3044","\u3053\u306E\u8907\u96D1\u306A\u6982\u5FF5\u3092\u3088\u308A\u5358\u7D14\u306A\u8A00\u8449\u3067\u5206\u89E3\u3059\u308B","\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3068\u80CC\u666F\u60C5\u5831\u3092\u3082\u3063\u3068\u8FFD\u52A0\u3059\u308B","\u3053\u308C\u3092\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u306B\u307E\u3068\u3081\u308B","\u4F8B\u3092\u6319\u3052\u3066\u8981\u70B9\u3092\u8A73\u3057\u304F\u8AAC\u660E\u3059\u308B","\u521D\u5FC3\u8005\u306B\u3068\u3063\u3066\u3088\u308A\u30A2\u30AF\u30BB\u30B9\u3057\u3084\u3059\u3044\u3082\u306E\u306B\u3059\u308B","\u91CD\u8981\u306A\u60C5\u5831\u3092\u7DAD\u6301\u3057\u306A\u304C\u3089\u3053\u308C\u3092\u8981\u7D04\u3059\u308B","\u660E\u77AD\u6027\u3068\u8AAD\u307F\u3084\u3059\u3055\u3092\u5411\u4E0A\u3055\u305B\u308B","\u3082\u3063\u3068\u9B45\u529B\u7684\u3067\u8208\u5473\u6DF1\u3044\u3082\u306E\u306B\u3057\u307E\u3057\u3087\u3046","\u6587\u6CD5\u3068\u6D41\u308C\u3092\u6539\u5584\u3059\u308B","\u30E1\u30EA\u30C3\u30C8\u3092\u5F37\u8ABF\u3059\u308B\u3088\u3046\u306B\u66F8\u304D\u76F4\u3059"],"defaultSummarize":["3\u3064\u306E\u7B87\u6761\u66F8\u304D\u3067\u8981\u7D04\u3057\u3066\u304F\u3060\u3055\u3044","\u91CD\u8981\u306A\u6C7A\u5B9A\u4E8B\u9805\u3092\u62BD\u51FA\u3059\u308B","\u4E3B\u306A\u884C\u52D5\u9805\u76EE\u3092\u30EA\u30B9\u30C8\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002","\u4E00\u6587\u3067\u8981\u7D04\u3057\u3066\u304F\u3060\u3055\u3044","\u6700\u3082\u91CD\u8981\u306A\u4E8B\u5B9F\u3092\u5F37\u8ABF\u3059\u308B","\u6280\u8853\u7684\u306A\u77E5\u8B58\u306E\u306A\u3044\u8AAD\u8005\u5411\u3051\u306B\u8981\u7D04\u3059\u308B","\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u3092\u62BD\u51FA\u3059\u308B","5\u3064\u306E\u7B87\u6761\u66F8\u304D\u3067\u8981\u7D04\u3057\u3066\u304F\u3060\u3055\u3044","\u6839\u672C\u7684\u306A\u554F\u984C\u70B9\u3068\u63D0\u6848\u3055\u308C\u305F\u89E3\u6C7A\u7B56\u3092\u7279\u5B9A\u3059\u308B","\u7D50\u8AD6\u3068\u63D0\u8A00\u3092\u3059\u3079\u3066\u5217\u6319\u3057\u3066\u304F\u3060\u3055\u3044\u3002","\u8981\u7D04\u3092\u63D0\u4F9B\u3059\u308B","\u51FA\u6765\u4E8B\u306E\u6642\u7CFB\u5217\u3092\u8981\u7D04\u3059\u308B","\u63D0\u8D77\u3055\u308C\u305F\u3059\u3079\u3066\u306E\u8CEA\u554F\u3092\u62BD\u51FA\u3059\u308B","\u6319\u3052\u3089\u308C\u305F\u9577\u6240\u3068\u77ED\u6240\u3092\u30EA\u30B9\u30C8\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002","\u4E3B\u8981\u306A\u8AD6\u70B9\u3092\u8981\u7D04\u3059\u308B"]},"accessibilityService":{"error":{"generic":"\u5185\u90E8\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","elementNotFound":"\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u691C\u7D22\u304C\u5B58\u5728\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","highlightOnConflict":"\u8907\u6570\u306E\u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u3002\u9078\u629E\u3059\u308B\u8981\u7D20\u3092\u6307\u5B9A\u3059\u308B\u3088\u3046\u306B\u30B3\u30DE\u30F3\u30C9\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002","clickNotInitialized":"\u540D\u524D\u306B\u3088\u308B\u30BF\u30C3\u30D7\u306F\u73FE\u5728\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","platformUnsupported":"\u3053\u306E\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u306F\u3001\u540D\u524D\u306B\u3088\u308B\u30BF\u30C3\u30D7\u64CD\u4F5C\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","permission":"Cephable \u306B\u306F\u3053\u306E\u30A2\u30D7\u30EA\u3092\u8AAD\u307F\u53D6\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A > \u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3 > {{pane}} \u3067\u6A29\u9650\u3092\u4ED8\u4E0E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u8077\u5834\u3067\u7BA1\u7406\u3055\u308C\u3066\u3044\u308B\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u3001\u7BA1\u7406\u8005\u306B\u3088\u3063\u3066\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"clickWait":"\u521D\u671F\u5316\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u3044\u305F\u3060\u304D\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"deprecated":"\u975E\u63A8\u5968","view":"\u30D3\u30E5\u30FC","aiWorkflows":{"settings":{"title":"\u8A2D\u5B9A\u306E\u81EA\u52D5\u5316","description":"AI \u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u4F7F\u7528\u3059\u308B AI \u30E2\u30C7\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002AI \u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E AI \u3092\u4F7F\u7528\u3057\u3066\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u304A\u3088\u3073\u30D6\u30E9\u30A6\u30B6\u306E\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3067\u304D\u307E\u3059\u3002","configType":{"title":"\u30E2\u30C7\u30EB\u69CB\u6210\u30BF\u30A4\u30D7","description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u4F7F\u7528\u3059\u308B\u30E2\u30C7\u30EB\u69CB\u6210\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u30E2\u30C7\u30EB\u3054\u3068\u306B\u6700\u9069\u5316\u3055\u308C\u305F\u69CB\u6210\u304C\u7570\u306A\u308A\u307E\u3059\u3002","label":"\u69CB\u6210\u30BF\u30A4\u30D7"},"reasoningModel":{"title":"\u63A8\u8AD6\u30E2\u30C7\u30EB","description":"\u63A8\u8AD6\u304A\u3088\u3073\u8A08\u753B\u30BF\u30B9\u30AF\u306B\u4F7F\u7528\u3059\u308BAI\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u63A8\u8AD6\u30E2\u30C7\u30EB\u306F\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5206\u6790\u3057\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u30D7\u30E9\u30F3\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","label":"\u63A8\u8AD6\u30E2\u30C7\u30EB"},"reasoningDevice":{"label":"\u63A8\u8AD6\u88C5\u7F6E"},"generationModel":{"title":"\u4E16\u4EE3\u30E2\u30C7\u30EB","description":"\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u30BF\u30B9\u30AF\u306B\u4F7F\u7528\u3059\u308BAI\u30E2\u30C7\u30EB\u3092\u9078\u629E\u3057\u307E\u3059\u3002\u751F\u6210\u30E2\u30C7\u30EB\u306F\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u5FC5\u8981\u306A\u3068\u304D\u306B\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","label":"\u4E16\u4EE3\u30E2\u30C7\u30EB"},"generationDevice":{"label":"\u751F\u6210\u88C5\u7F6E"},"noModelsFound":"\u30E2\u30C7\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093","terminate":{"title":"\u660E\u78BA\u306A\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EA\u30BD\u30FC\u30B9","description":"\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u304C\u7D42\u4E86\u3057\u3001\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u5B9F\u884C\u4E2D\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u505C\u6B62\u3057\u3001AI\u30E2\u30C7\u30EB\u304C\u4F7F\u7528\u3057\u3066\u3044\u308B\u30E1\u30E2\u30EA\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002","button":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u3092\u7D42\u4E86\u3059\u308B","success":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC \u30EF\u30FC\u30AB\u30FC\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002","confirm":{"title":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u3092\u7D42\u4E86\u3059\u308B","description":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30EF\u30FC\u30AB\u30FC\u3092\u7D42\u4E86\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? \u3053\u308C\u306B\u3088\u308A\u3001\u5B9F\u884C\u4E2D\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u505C\u6B62\u3057\u3001\u30EA\u30BD\u30FC\u30B9\u304C\u89E3\u653E\u3055\u308C\u307E\u3059\u3002","confirm":"\u306F\u3044\u3001\u7D42\u4E86\u3057\u307E\u3059"}},"autoWarm":{"title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u81EA\u52D5\u958B\u59CB","description":"\u30A2\u30D7\u30EA\u8D77\u52D5\u6642\u306BAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u7684\u306B\u521D\u671F\u5316\u3057\u307E\u3059\u3002\u30E2\u30C7\u30EB\u306F\u4E8B\u524D\u306B\u8AAD\u307F\u8FBC\u307E\u308C\u308B\u305F\u3081\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u3059\u3050\u306B\u958B\u59CB\u3067\u304D\u307E\u3059\u3002","option":"\u30A2\u30D7\u30EA\u8D77\u52D5\u6642\u306B AI \u30EF\u30FC\u30AF\u30D5\u30ED\u30FC \u30E2\u30C7\u30EB\u3092\u81EA\u52D5\u958B\u59CB"},"prompt":{"title":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u95A2\u3059\u308B\u8FFD\u52A0\u60C5\u5831","description":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u5B9F\u884C\u6642\u306BCephable\u306EAI\u3067\u4F7F\u7528\u3059\u308B\u8FFD\u52A0\u60C5\u5831\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30C8\u30FC\u30F3\u3001\u52D5\u4F5C\u3001\u305D\u306E\u4ED6\u306E\u8A73\u7D30\u306B\u95A2\u3059\u308B\u8A2D\u5B9A\u3092\u5165\u529B\u3057\u307E\u3059\u3002","field":"\u8FFD\u52A0\u306E\u30D7\u30ED\u30F3\u30D7\u30C8","placeholder":"\u4F8B\uFF1A\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3059\u308B\u524D\u306B\u5FC5\u305A\u78BA\u8A8D\u3059\u308B\u3002\u8FD4\u4FE1\u306F\u7C21\u6F54\u306B\u3059\u308B\u3002\u6587\u66F8\u3067\u306F\u4E01\u5BE7\u306A\u8A00\u8449\u9063\u3044\u3092\u3059\u308B\u3002"},"disableButtonNames":{"edit":"\u30D6\u30ED\u30C3\u30AF\u30DC\u30BF\u30F3\u306E\u64CD\u4F5C","input":{"label":"\u30DC\u30BF\u30F3\u540D","question":"\u3069\u306E\u30DC\u30BF\u30F3\u3092\u975E\u8868\u793A\u306B\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F\u30DC\u30BF\u30F3\u540D\u306F\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u3092\u5165\u529B\u3067\u304D\u307E\u3059\u3002","remove":"\u30DC\u30BF\u30F3\u540D\u3092\u524A\u9664"},"button":"\u30D6\u30ED\u30C3\u30AF\u30DC\u30BF\u30F3","description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u64CD\u4F5C\u3067\u304D\u308B\u30DC\u30BF\u30F3\u3092\u5236\u5FA1\u3057\u307E\u3059\u3002\u30C7\u30D5\u30A9\u30EB\u30C8\u3067\u306F\u3001Cephable\u306F\u753B\u9762\u4E0A\u306E\u3069\u306E\u30DC\u30BF\u30F3\u3067\u3082\u30AF\u30EA\u30C3\u30AF\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u4F7F\u7528\u3057\u3066\u3001\u610F\u56F3\u3057\u306A\u3044\u64CD\u4F5C\uFF08\u4F8B\u3048\u3070\u3001\u300C\u8CFC\u5165\u300D\u3001\u300C\u524A\u9664\u300D\u306A\u3069\uFF09\u3092\u9632\u6B62\u3067\u304D\u307E\u3059\u3002"},"remoteWorkflows":{"title":"\u8907\u6570\u306E\u30C7\u30D0\u30A4\u30B9\u3067AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5B9F\u884C\u3059\u308B","option":"\u4ED6\u306E\u30C7\u30D0\u30A4\u30B9\u3082\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u81EA\u52D5\u5316\u8A2D\u5B9A\u306B\u5F93\u3063\u3066\u8D77\u52D5\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B","description":"\u30C7\u30D5\u30A9\u30EB\u30C8\u3067\u306F\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u3044\u308B\u4ED6\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u81EA\u52D5\u5316\u3092\u958B\u59CB\u3001\u76E3\u8996\u3001\u5FDC\u7B54\u3067\u304D\u307E\u3059\u3002\u81EA\u52D5\u5316\u306E\u9032\u884C\u72B6\u6CC1\uFF08\u30B9\u30C6\u30C3\u30D7\u306E\u30BF\u30A4\u30C8\u30EB\u3068AI\u306E\u601D\u8003\uFF09\u3068\u8CEA\u554F\u306F\u3001\u3053\u308C\u3089\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u9001\u4FE1\u3055\u308C\u308B\u305F\u3081\u3001\u3069\u3053\u304B\u3089\u3067\u3082\u5FDC\u7B54\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u81EA\u8EAB\u306E\u30C7\u30D0\u30A4\u30B9\u9593\u3067\u306E\u307F\u5171\u6709\u3055\u308C\u3001Cephable\u306E\u30B5\u30FC\u30D0\u30FC\u306B\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002\u81EA\u52D5\u5316\u3092\u5B8C\u5168\u306B\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u30AA\u30D5\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u81EA\u52D5\u5316\u306F\u5F15\u304D\u7D9A\u304D\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u5B9F\u884C\u3055\u308C\u307E\u3059\u304C\u3001\u4ED6\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u306F\u4F55\u3082\u9001\u4FE1\u3055\u308C\u305A\u3001\u4ED6\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u81EA\u52D5\u5316\u3092\u958B\u59CB\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"},"thinkingLevel":{"field":"\u63A8\u8AD6\u52AA\u529B","description":"AI\u304C\u884C\u52D5\u3092\u8D77\u3053\u3059\u524D\u306B\u5404\u30B9\u30C6\u30C3\u30D7\u3092\u3069\u308C\u3060\u3051\u6DF1\u304F\u691C\u8A0E\u3059\u308B\u304B\u3092\u793A\u3059\u6307\u6A19\u3067\u3059\u3002\u30EC\u30D9\u30EB\u304C\u9AD8\u3044\u307B\u3069\u3001\u8907\u96D1\u306A\u30BF\u30B9\u30AF\u306B\u304A\u3044\u3066\u3088\u308A\u78BA\u5B9F\u306B\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u30FB\u9806\u5E8F\u4ED8\u3051\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u304C\u3001\u5404\u30B9\u30C6\u30C3\u30D7\u306E\u51E6\u7406\u901F\u5EA6\u306F\u82E5\u5E72\u9045\u304F\u306A\u308A\u307E\u3059\u3002\u307B\u3068\u3093\u3069\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u306F\u300C\u4E2D\u300D\u30EC\u30D9\u30EB\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002","low":"\u4F4E\u901F\uFF08\u6700\u901F\uFF09","medium":"\u4E2D\u7A0B\u5EA6\uFF08\u63A8\u5968\uFF09","high":"\u9AD8\u3044","max":"\u30DE\u30C3\u30AF\u30B9\uFF08\u6700\u3082\u5FB9\u5E95\u7684\uFF09"},"dynamicTools":{"option":"\u30B9\u30DE\u30FC\u30C8\u30B3\u30CD\u30AF\u30BF\u30C4\u30FC\u30EB\u306E\u8AAD\u307F\u8FBC\u307F","description":"\u4F7F\u7528\u3059\u308B\u30C4\u30FC\u30EB\u306E\u307F\u3092\u8AAD\u307F\u8FBC\u3080\u3053\u3068\u3067\u3001\u3088\u308A\u8FC5\u901F\u306B\u8D77\u52D5\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u30AA\u30D5\u306B\u3059\u308B\u3068\u3001\u3059\u3079\u3066\u306E\u30C4\u30FC\u30EB\u304C\u4E00\u5EA6\u306B\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u30E2\u30C7\u30EB\u306B\u5B9F\u884C\u3059\u3079\u304D\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u6C7A\u5B9A\u3055\u305B\u305F\u3044\u5834\u5408\u306B\u4FBF\u5229\u3067\u3059\u304C\u3001\u51E6\u7406\u901F\u5EA6\u304C\u5927\u5E45\u306B\u4F4E\u4E0B\u3057\u3001\u7D50\u679C\u306E\u8CEA\u304C\u4F4E\u4E0B\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"longTasks":{"field":"\u9577\u6642\u9593\u306E\u4F5C\u696D","description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306F\u3001\u9577\u3044\u6587\u66F8\u306E\u95B2\u89A7\u306A\u3069\u3001\u591A\u304F\u306E\u3053\u3068\u3092\u8003\u616E\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u30BF\u30B9\u30AF\u3092\u3069\u306E\u3088\u3046\u306B\u51E6\u7406\u3059\u308B\u304B\u3092\u793A\u3057\u307E\u3059\u3002\u81EA\u52D5\u8A2D\u5B9A\u3067\u306F\u3001\u5FC5\u8981\u306A\u5834\u5408\u306B\u306E\u307F\u30BF\u30B9\u30AF\u306B\u4F59\u88D5\u3092\u4E0E\u3048\u307E\u3059\u3002\u901F\u5EA6\u512A\u5148\u8A2D\u5B9A\u3067\u306F\u3001\u3059\u3079\u3066\u306E\u30B9\u30C6\u30C3\u30D7\u304C\u8FC5\u901F\u306B\u884C\u308F\u308C\u307E\u3059\u304C\u3001\u975E\u5E38\u306B\u9577\u3044\u30BF\u30B9\u30AF\u3067\u306F\u6700\u521D\u306E\u30B9\u30C6\u30C3\u30D7\u304C\u5FD8\u308C\u3089\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u5E38\u306B\u9577\u3044\u30BF\u30B9\u30AF\u3092\u8A31\u53EF\u3059\u308B\u8A2D\u5B9A\u3067\u306F\u3001\u3059\u3079\u3066\u306E\u30BF\u30B9\u30AF\u306B\u6700\u5927\u9650\u306E\u4F59\u88D5\u3092\u4E0E\u3048\u307E\u3059\u304C\u3001\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u8FBC\u3080\u30B9\u30C6\u30C3\u30D7\u306B\u306F\u5C11\u3057\u6642\u9593\u304C\u304B\u304B\u308A\u307E\u3059\u3002\u3053\u308C\u306F\u3001\u72EC\u7ACB\u3057\u305F\u30B0\u30E9\u30D5\u30A3\u30C3\u30AF\u30AB\u30FC\u30C9\u3092\u642D\u8F09\u3057\u305F\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u306B\u306E\u307F\u9069\u7528\u3055\u308C\u307E\u3059\u3002","auto":"\u81EA\u52D5\uFF08\u63A8\u5968\uFF09","speed":"\u30B9\u30D4\u30FC\u30C9\u3092\u512A\u5148\u3059\u308B","long":"\u5E38\u306B\u9577\u6642\u9593\u306E\u4F5C\u696D\u3092\u8A31\u53EF\u3059\u308B"}}},"control":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","automate":"\u81EA\u52D5\u5316","deviceCommandThrottled":{"macroLength":"\u3053\u306E\u63A5\u7D9A\u3067\u306F\u9577\u3044\u30DE\u30AF\u30ED\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30DE\u30AF\u30ED\u306F\u81EA\u52D5\u7684\u306B\u77ED\u7E2E\u3055\u308C\u307E\u3057\u305F\u3002","commandCount":"\u3053\u306E\u63A5\u7D9A\u3067\u306F\u30B3\u30DE\u30F3\u30C9\u306E\u9001\u4FE1\u901F\u5EA6\u304C\u5236\u9650\u3055\u308C\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","incompatibleActions":"\u3053\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u306F\u3001\u540C\u6642\u306B\u4F7F\u7528\u3067\u304D\u306A\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u542B\u307E\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u9001\u4FE1\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002"},"tos":{"title":"\u5229\u7528\u898F\u7D04\u306E\u66F4\u65B0","description":"\u5229\u7528\u898F\u7D04\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002Cephable\u3092\u5F15\u304D\u7D9A\u304D\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u66F4\u65B0\u3055\u308C\u305F\u898F\u7D04\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","effectiveDate":"\u6709\u52B9\u65E5: {{date}}","accept":"\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3059\u308B","loadError":"\u5229\u7528\u898F\u7D04\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","viewInBrowser":"\u5229\u7528\u898F\u7D04\u3092\u30D6\u30E9\u30A6\u30B6\u3067\u8868\u793A\u3059\u308B","acceptCheckbox":"\u5229\u7528\u898F\u7D04\u3092\u8AAD\u307F\u3001\u540C\u610F\u3057\u307E\u3059\u3002"},"appearance":{"title":"\u5916\u89B3"},"troubleshooting":{"title":"\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0"},"extensions":{"title":"\u62E1\u5F35\u6A5F\u80FD","titleShort":"\u62E1\u5F35\u6A5F\u80FD","description":"\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u3001\u95A2\u9023\u30A2\u30D7\u30EA\u3092\u63A5\u7D9A\u3057\u3001Cephable\u306E\u6A5F\u80FD\u3092\u62E1\u5F35\u3057\u307E\u3059\u3002","searchPlaceholder":"\u691C\u7D22\u62E1\u5F35\u6A5F\u80FD","noResults":"\u691C\u7D22\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u62E1\u5F35\u6A5F\u80FD\u306F\u3042\u308A\u307E\u305B\u3093\u3002","comingSoon":"\u8FD1\u65E5\u516C\u958B","done":"\u7D42\u308F\u308A","getStarted":"\u3055\u3042\u59CB\u3081\u307E\u3057\u3087\u3046","viewDetails":"\u8A73\u7D30\u3068\u8A2D\u5B9A\u3092\u8868\u793A","enable":"\u6709\u52B9\u306B\u3059\u308B","publisher":{"official":"\u30BB\u30D5\u30A1\u30D6\u30EB","officialTitle":"\u516C\u5F0F \u2014 Cephable\u306B\u3088\u3063\u3066\u69CB\u7BC9\u304A\u3088\u3073\u7DAD\u6301\u3055\u308C\u3066\u3044\u307E\u3059","byline":"{{publisher}}\u306B\u3088\u308B","thirdPartyTitle":"{{publisher}}\u306B\u3088\u308B\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u7D71\u5408"},"category":{"inputControls":{"title":"\u5165\u529B\u3068\u5236\u5FA1","description":"Cephable\u3092\u4F7F\u3063\u3066\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u5236\u5FA1\u3059\u308B\u65B9\u6CD5\u3092\u81EA\u7531\u306B\u8A2D\u5B9A\u3057\u307E\u3057\u3087\u3046\u3002"},"companionApps":{"title":"\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u3068\u30C4\u30FC\u30EB","description":"Cephable\u306E\u6A5F\u80FD\u3092\u3001\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3068\u30A6\u30A7\u30D6\u30D9\u30FC\u30B9\u306E\u4F5C\u6210\u30C4\u30FC\u30EB\u3067\u62E1\u5F35\u3057\u307E\u3057\u3087\u3046\u3002"},"buildExtend":{"title":"\u69CB\u7BC9\u3068\u62E1\u5F35","description":"Cephable API\u3068SDK\u3092\u4F7F\u7528\u3057\u3066\u3001\u72EC\u81EA\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"marketplace":{"title":"\u5E02\u5834","description":"\u65B0\u305F\u306A\u30B9\u30AD\u30EB\u3001\u30C4\u30FC\u30EB\u3001\u305D\u3057\u3066\u4EBA\u8108\u304C\u9593\u3082\u306A\u304F\u624B\u306B\u5165\u308B\u3067\u3057\u3087\u3046\u3002"},"previews":{"title":"\u30D7\u30EC\u30D3\u30E5\u30FC","description":"\u4ECA\u5F8C\u5B9F\u88C5\u4E88\u5B9A\u306E\u6A5F\u80FD\u3092\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u30D7\u30EC\u30D3\u30E5\u30FC\u7248\u306F\u6B63\u5F0F\u30EA\u30EA\u30FC\u30B9\u524D\u306B\u5909\u66F4\u3055\u308C\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"}},"camera":{"title":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30AB\u30E1\u30E9\u3092\u4F7F\u3063\u3066\u3001\u9854\u3084\u982D\u306E\u52D5\u304D\u3067\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002","detail":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u6A5F\u80FD\u3092\u4F7F\u3046\u3068\u3001\u9854\u306E\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\uFF08\u982D\u3092\u30DE\u30A6\u30B9\u306E\u3088\u3046\u306B\u4F7F\u3046\u3053\u3068\u3082\u53EF\u80FD\uFF09\u3067\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30AB\u30FC\u30C9\u4E0A\u306E\u30B9\u30A4\u30C3\u30C1\u3067\u6709\u52B9\u306B\u3057\u3001\u3053\u3053\u3067\u52D5\u4F5C\u3092\u5FAE\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002","settings":{"title":"\u8868\u60C5\u3068\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC","description":"\u8A2D\u5B9A\u3067\u3001\u3069\u306E\u8868\u60C5\u3084\u982D\u306E\u52D5\u304D\u3092\u30A2\u30AF\u30B7\u30E7\u30F3\u306B\u5272\u308A\u5F53\u3066\u308B\u304B\u3092\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002"},"advancedSettings":"\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u958B\u304F"},"gamepad":{"title":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u5BFE\u5FDC","description":"Xbox\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3092\u30A8\u30DF\u30E5\u30EC\u30FC\u30C8\u3059\u308B\u3053\u3068\u3067\u3001\u30B2\u30FC\u30E0\u304CCephable\u306E\u5165\u529B\u3092\u8A8D\u8B58\u3059\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","detail":"\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u3092\u30B5\u30DD\u30FC\u30C8\u3059\u308B\u306B\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u88FD\u306E\u975E\u516C\u5F0F\u30C9\u30E9\u30A4\u30D0\u30FC\u3067\u3042\u308BViGEm\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u3001\u30B2\u30FC\u30E0\u304C\u30CD\u30A4\u30C6\u30A3\u30D6\u306B\u8A8D\u8B58\u3059\u308B\u4EEE\u60F3Xbox\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3092\u30A8\u30DF\u30E5\u30EC\u30FC\u30C8\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u4EE5\u4E0B\u306E\u30C9\u30E9\u30A4\u30D0\u30FC\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u307E\u305F\u306F\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002Windows x64\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u3059\u3002"},"mobile":{"title":"Cephable\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA","description":"Cephable\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3092\u4F7F\u3048\u3070\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3068\u3057\u3066\u5229\u7528\u3067\u304D\u307E\u3059\u3002","detail":"Cephable\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3068\u3057\u3066\u4F7F\u7528\u3057\u307E\u3057\u3087\u3046\u3002\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u304B\u3001\u30EA\u30F3\u30AF\u3092\u4F7F\u7528\u3057\u3066iOS\u307E\u305F\u306FAndroid\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3001\u4EE5\u4E0B\u306E\u30A2\u30D7\u30EA\u306E\u30D7\u30EC\u30D3\u30E5\u30FC\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","screenshotsTitle":"\u30D7\u30EC\u30D3\u30E5\u30FC","screenshotPlaceholder":"\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8","screenshotAlt":"Cephable\u30E2\u30D0\u30A4\u30EB\u30A2\u30D7\u30EA\u306E\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8 {{number}}","scanTitle":"\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9","ios":"iOS \u2014 App Store","android":"Android \u2014 Google Play","iosAction":"App Store\u3067\u5165\u624B","androidAction":"Google Play\u3067\u5165\u624B"},"controllerCreator":{"title":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u4F5C\u6210\u30C4\u30FC\u30EB","description":"controller.cephable.com\u3067\u3001\u72EC\u81EA\u306E\u753B\u9762\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3092\u30C7\u30B6\u30A4\u30F3\u3057\u307E\u3057\u3087\u3046\u3002","detail":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u4F5C\u6210\u30C4\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30D6\u30E9\u30A6\u30B6\u4E0A\u3067\u72EC\u81EA\u306E\u30AA\u30F3\u30B9\u30AF\u30EA\u30FC\u30F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3092\u30C7\u30B6\u30A4\u30F3\u3057\u3066\u5171\u6709\u3067\u304D\u307E\u3059\u3002","qrCaption":"controller.cephable.com","action":"Open Controller Creator","screenshotsTitle":"\u30D7\u30EC\u30D3\u30E5\u30FC","screenshotPlaceholder":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u4F5C\u6210\u30C4\u30FC\u30EB\u306E\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8","screenshotAlt":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30AF\u30EA\u30A8\u30FC\u30BF\u30FC\u306E\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8 {{number}}"},"developer":{"title":"\u72EC\u81EA\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u69CB\u7BC9","description":"Cephable API\u3068SDK\u3092\u4F7F\u7528\u3057\u3066\u3001\u72EC\u81EA\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u69CB\u7BC9\u304A\u3088\u3073\u5171\u6709\u3067\u304D\u307E\u3059\u3002","detail":"Cephable\u3092\u4F7F\u3063\u3066\u72EC\u81EA\u306E\u62E1\u5F35\u6A5F\u80FD\u3084\u7D71\u5408\u6A5F\u80FD\u3092\u69CB\u7BC9\u3057\u307E\u3057\u3087\u3046\u3002API\u3068SDK\u3092\u63A2\u7D22\u3057\u3001\u4F5C\u6210\u3057\u305F\u3082\u306E\u3092developers.cephable.com\u3067\u516C\u958B\u30FB\u5171\u6709\u3057\u3066\u304F\u3060\u3055\u3044\u3002","api":{"title":"Cephable API","description":"\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3001\u30C7\u30D0\u30A4\u30B9\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u304A\u3088\u3073\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u30A4\u30D9\u30F3\u30C8\u3092\u30D7\u30ED\u30B0\u30E9\u30E0\u3067\u7BA1\u7406\u3057\u307E\u3059\u3002"},"sdk":{"title":"SDK\u3068\u30B5\u30F3\u30D7\u30EB","description":"SDK\u3001\u30B5\u30F3\u30D7\u30EB\u3001\u7D71\u5408\u30AC\u30A4\u30C9\u3092\u6D3B\u7528\u3057\u3066\u3001\u3059\u3050\u306B\u958B\u767A\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002"},"action":"developers.cephable.com \u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"portal":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3068\u30C1\u30FC\u30E0","description":"Cephable\u30DD\u30FC\u30BF\u30EB\u3067\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3068\u30C1\u30FC\u30E0\u3092\u7BA1\u7406\u3057\u307E\u3057\u3087\u3046\u3002","detail":"Cephable\u30DD\u30FC\u30BF\u30EB\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001\u30C1\u30FC\u30E0\u3001\u7D44\u7E54\u8A2D\u5B9A\u30921\u304B\u6240\u3067\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","projects":{"title":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3001API\u30AD\u30FC\u3001\u304A\u3088\u3073\u7D71\u5408\u6A5F\u80FD\u3092\u4F5C\u6210\u304A\u3088\u3073\u7BA1\u7406\u3057\u307E\u3059\u3002"},"teams":{"title":"\u30C1\u30FC\u30E0","description":"\u7D44\u7E54\u5168\u4F53\u3067\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3057\u3001\u5F79\u5272\u3092\u5272\u308A\u5F53\u3066\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u7BA1\u7406\u3057\u307E\u3059\u3002"},"action":"Cephable\u30DD\u30FC\u30BF\u30EB\u3092\u958B\u304F"},"mcpTools":{"title":"MCP\u30C4\u30FC\u30EB","description":"Cephable\u306E\u6A5F\u80FD\u3092\u62E1\u5F35\u3059\u308B\u305F\u3081\u306B\u3001\u30E2\u30C7\u30EB\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30D7\u30ED\u30C8\u30B3\u30EB\u30C4\u30FC\u30EB\u3092\u63A5\u7D9A\u3057\u307E\u3059\u3002"},"aiSkills":{"title":"AI\u30B9\u30AD\u30EB","description":"Cephable\u304C\u30AA\u30F3\u30C7\u30DE\u30F3\u30C9\u3067\u8D77\u52D5\u3067\u304D\u308B\u3001\u518D\u5229\u7528\u53EF\u80FD\u306AAI\u30B9\u30AD\u30EB\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002"},"workflows":{"title":"\u518D\u5229\u7528\u53EF\u80FD\u306A\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC","description":"\u4E8B\u524D\u306B\u69CB\u7BC9\u3055\u308C\u305F\u81EA\u52D5\u5316\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5171\u6709\u304A\u3088\u3073\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059\u3002"},"controlBundles":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30D0\u30F3\u30C9\u30EB","description":"\u53B3\u9078\u3055\u308C\u305F\u30A2\u30D7\u30EA\u3084\u30B2\u30FC\u30E0\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u6A5F\u80FD\u3092\u30EF\u30F3\u30BF\u30C3\u30D7\u3067\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002"},"connections":{"title":"\u30B2\u30FC\u30E0\u3068\u30A2\u30D7\u30EA\u306E\u9023\u643A","description":"Cephable\u3067\u64CD\u4F5C\u3067\u304D\u308B\u30B2\u30FC\u30E0\u3084\u30A2\u30D7\u30EA\u3092\u63A2\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u4F8B\u3048\u3070\u3001\u300E\u30B3\u30FC\u30EB \u30AA\u30D6 \u30C7\u30E5\u30FC\u30C6\u30A3 \u30D6\u30E9\u30C3\u30AF\u30AA\u30D7\u30B97\u300F\u306A\u3069\u3002"},"aiSkillsMarketplace":{"title":"AI Skills Marketplace","description":"Browse and install skills shared by the community."},"nav":{"label":"\u62E1\u5F35\u6A5F\u80FD\u3092\u95B2\u89A7\u3059\u308B","discover":"\u767A\u898B\u3059\u308B","skills":"\u30B9\u30AD\u30EB","connectors":"\u30B3\u30CD\u30AF\u30BF","features":"Cephable\u306E\u7279\u5FB4","installed":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6E08\u307F"},"stats":{"rating":"\u8A55\u4FA1","installs":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB","rated":"\u8A55\u4FA1\u3057\u3066\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","rateError":"\u8A55\u4FA1\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","yourRating":"\u3042\u306A\u305F\u306E\u8A55\u4FA1"},"copyLink":"\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC","detail":{"access":{"developer":"\u958B\u767A\u8005","employee":"\u5F93\u696D\u54E1","plus":"\u30D7\u30E9\u30B9","student":"\u5B66\u751F"},"by":"\u306B\u3088\u308B","categories":"\u30AB\u30C6\u30B4\u30EA\u30FC","featured":"\u6CE8\u76EE\u306E","installing":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u4E2D\u2026","size":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30B5\u30A4\u30BA","transport":"\u8F38\u9001","version":"\u30D0\u30FC\u30B8\u30E7\u30F3"},"discover":{"connectors":"\u30B3\u30CD\u30AF\u30BF","coreDescription":"Cephable\u306B\u306F\u3001\u30AB\u30E1\u30E9\u3001\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u3001\u958B\u767A\u8005\u30C4\u30FC\u30EB\u304C\u7D44\u307F\u8FBC\u307E\u308C\u3066\u3044\u307E\u3059\u3002","coreTitle":"Cephable\u306E\u7279\u5FB4","description":"Cephable\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3092\u62E1\u5F35\u3059\u308B\u305F\u3081\u306E\u516C\u5F0F\u304A\u3088\u3073\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u30B9\u30AD\u30EB\u3068\u30B3\u30CD\u30AF\u30BF\u3002","empty":"\u307E\u3060\u8868\u793A\u3059\u308B\u3082\u306E\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u30B9\u30AD\u30EB\u307E\u305F\u306F\u30B3\u30CD\u30AF\u30BF\u3092\u53C2\u7167\u3057\u3066\u3001\u72EC\u81EA\u306E\u30B9\u30AD\u30EB\u3084\u30B3\u30CD\u30AF\u30BF\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","exploreFeatures":"\u6A5F\u80FD\u306E\u8A73\u7D30\u3092\u898B\u308B","featured":"\u6CE8\u76EE\u306E","newest":"\u65B0\u7740\uFF06\u6CE8\u76EE","skills":"\u30B9\u30AD\u30EB","title":"\u767A\u898B\u3059\u308B","viewAll":"\u3059\u3079\u3066\u8868\u793A"},"features":{"description":"Cephable\u3092\u5236\u5FA1\u3059\u308B\u305F\u3081\u306E\u7D44\u307F\u8FBC\u307F\u6A5F\u80FD \u2015 \u30AB\u30E1\u30E9\u3001\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u3001\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA\u3001\u958B\u767A\u8005\u30C4\u30FC\u30EB\u306A\u3069\u3002","title":"Cephable\u306E\u7279\u5FB4","searchPlaceholder":"\u691C\u7D22\u6A5F\u80FD\u2026"},"install":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB","installError":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","installed":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6E08\u307F","linkCopied":"\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F","provenance":{"cephable":"\u30BB\u30D5\u30A1\u30D6\u30EB","mine":"\u79C1\u306E","organization":"\u8CB4\u793E","thirdParty":"\u7B2C\u4E09\u8005"},"installedPage":{"connectors":"\u30B3\u30CD\u30AF\u30BF","description":"\u8FFD\u52A0\u3057\u305F\u30B9\u30AD\u30EB\u3068\u30B3\u30CD\u30AF\u30BF\u3002\u3044\u305A\u308C\u304B\u3092\u958B\u3044\u3066\u7BA1\u7406\u307E\u305F\u306F\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002","empty":"\u30B9\u30AD\u30EB\u3084\u30B3\u30CD\u30AF\u30BF\u30FC\u306F\u307E\u3060\u8FFD\u52A0\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","manage":"\u7BA1\u7406","skills":"\u30B9\u30AD\u30EB","title":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6E08\u307F","searchPlaceholder":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6E08\u307F\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u691C\u7D22\u2026"},"type":{"skill":"\u30B9\u30AD\u30EB","tool":"\u30B3\u30CD\u30AF\u30BF","input":"\u5165\u529B","build":"\u5EFA\u3066\u308B","app":"\u30B3\u30F3\u30D1\u30CB\u30AA\u30F3\u30A2\u30D7\u30EA","feature":"\u7279\u5FB4"},"publish":{"title":{"mcp":"\u3053\u306EMCP\u30B3\u30CD\u30AF\u30BF\u3092\u5171\u6709\u3059\u308B","skill":"\u3053\u306E\u30B9\u30AD\u30EB\u3092\u5171\u6709\u3059\u308B"},"shareWith":"\u8AB0\u304C\u3053\u308C\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u304B\uFF1F","target":{"organization":"\u79C1\u306E\u7D44\u7E54\u306E\u4EBA\u3005","public":"\u5168\u54E1\uFF08\u516C\u5171\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\uFF09"},"chooseOrganization":"\u7D44\u7E54\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","yourOrganization":"\u3042\u306A\u305F\u306E\u7D44\u7E54","audience":{"public":"Cephable\u30C1\u30FC\u30E0\u306E\u627F\u8A8D\u304C\u5F97\u3089\u308C\u308C\u3070\u3001Cephable\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3053\u308C\u3092\u691C\u7D22\u3001\u95B2\u89A7\u3001\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u9069\u5207\u306A\u8A00\u8449\u3068\u30A2\u30A4\u30B3\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","organization":"{{org}} \u306E\u8AB0\u3082\u304C\u3053\u308C\u3092\u898B\u3064\u3051\u3066\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002"},"displayName":"\u8868\u793A\u540D","shortDescription":"\u7C21\u5358\u306A\u8AAC\u660E","shortDescriptionHelp":"\u4E00\u89A7\u306B\u8868\u793A\u3055\u308C\u308B1\u884C\u306E\u8981\u7D04\u3002","description":"\u8AAC\u660E","iconUrl":"\u30A2\u30A4\u30B3\u30F3URL","darkModeIconUrl":"\u30C0\u30FC\u30AF\u30E2\u30FC\u30C9\u30A2\u30A4\u30B3\u30F3\u306EURL","categories":"\u30AB\u30C6\u30B4\u30EA\u30FC","categoriesHelp":"\u30AB\u30F3\u30DE\u533A\u5207\u308A\uFF08\u4F8B\uFF1A\u751F\u7523\u6027\u3001\u57F7\u7B46\uFF09\u3002","version":"\u30D0\u30FC\u30B8\u30E7\u30F3","versionHelp":"\u7A7A\u6B04\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u81EA\u52D5\u7684\u306B\u30D0\u30F3\u30D7\u3057\u307E\u3059\u3002","secretNote":{"mcp":"\u5171\u6709\u3055\u308C\u308B\u306E\u306F\u3001\u6A5F\u5BC6\u60C5\u5831\u3067\u306F\u306A\u3044\u63A5\u7D9A\u60C5\u5831\u306E\u307F\u3067\u3059\u3002API\u30AD\u30FC\u3001\u30C8\u30FC\u30AF\u30F3\u3001\u305D\u306E\u4ED6\u306E\u8A8D\u8A3C\u60C5\u5831\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306B\u4FDD\u5B58\u3055\u308C\u3001\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B\u30E6\u30FC\u30B6\u30FC\u306F\u5404\u81EA\u3067\u3053\u308C\u3089\u306E\u60C5\u5831\u3092\u5165\u529B\u3057\u307E\u3059\u3002","skill":"\u30B9\u30AD\u30EB\u306E\u30D5\u30A1\u30A4\u30EB\u3068\u624B\u9806\u306F\u73FE\u72B6\u306E\u307E\u307E\u5171\u6709\u3055\u308C\u307E\u3059\u3002\u516C\u958B\u3059\u308B\u524D\u306B\u3001\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u60C5\u5831\u306F\u3059\u3079\u3066\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"confirm":"\u516C\u958B","submitConfirm":"\u5BE9\u67FB\u306E\u305F\u3081\u306B\u63D0\u51FA\u3059\u308B","reviewNote":"\u4E00\u822C\u306E\u65B9\u304B\u3089\u3054\u6295\u7A3F\u3044\u305F\u3060\u3044\u305F\u5546\u54C1\u306F\u3001\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u306B\u63B2\u8F09\u3055\u308C\u308B\u524D\u306BCephable\u30C1\u30FC\u30E0\u306B\u3088\u308B\u5BE9\u67FB\u304C\u884C\u308F\u308C\u307E\u3059\u3002\u5546\u54C1\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u753B\u9762\u306B\u8868\u793A\u3055\u308C\u3001\u5BE9\u67FB\u304C\u5B8C\u4E86\u6B21\u7B2C\u30E1\u30FC\u30EB\u3067\u304A\u77E5\u3089\u305B\u3044\u305F\u3057\u307E\u3059\u3002","notes":"\u67FB\u8AAD\u8005\u3078\u306E\u6CE8\u8A18\uFF08\u4EFB\u610F\uFF09","notesHelp":"\u524D\u56DE\u306E\u898B\u76F4\u3057\u306B\u5F79\u7ACB\u3064\u3082\u306E\u306A\u3089\u4F55\u3067\u3082\u69CB\u3044\u307E\u305B\u3093\u3002\u305D\u306E\u6A5F\u80FD\u3084\u3001\u524D\u56DE\u304B\u3089\u306E\u5909\u66F4\u70B9\u306A\u3069\u3082\u542B\u3081\u3066\u304F\u3060\u3055\u3044\u3002","inReview":"\u65E2\u306B\u5BE9\u67FB\u5F85\u3061\u306E\u72B6\u614B\u3067\u3059\u3002\u5909\u66F4\u3092\u52A0\u3048\u308B\u306B\u306F\u3001\u73FE\u5728\u306E\u63D0\u51FA\u3092\u53D6\u308A\u4E0B\u3052\u3066\u518D\u5EA6\u63D0\u51FA\u3057\u3066\u304F\u3060\u3055\u3044\u3002","withdraw":"\u63D0\u51FA\u3092\u53D6\u308A\u4E0B\u3052\u308B","resubmitConfirm":"\u518D\u5BE9\u67FB\u306E\u305F\u3081\u306B\u63D0\u51FA\u3057\u3066\u304F\u3060\u3055\u3044\u3002","resubmitNote":"\u3053\u308C\u306F\u516C\u958B\u4E0A\u5834\u304C\u627F\u8A8D\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u4E0B\u8A18\u306E\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u306B\u5BFE\u5FDC\u306E\u4E0A\u3001\u518D\u5EA6\u5BE9\u67FB\u306B\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002","previousFeedback":"\u30EC\u30D3\u30E5\u30FC\u62C5\u5F53\u8005\u306E\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF","publicRestricted":"\u8CB4\u7D44\u7E54\u3067\u306F\u516C\u958B\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u3078\u306E\u516C\u958B\u304C\u8A31\u53EF\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u3053\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u7D44\u7E54\u5185\u3067\u306E\u307F\u5171\u6709\u53EF\u80FD\u3067\u3059\u3002"},"reviewStatus":{"section":"\u516C\u958B\u5E02\u5834\u30EC\u30D3\u30E5\u30FC","reasonLabel":"\u30EC\u30D3\u30E5\u30A2\u30FC\u306E\u30E1\u30E2","pending":"\u30EC\u30D3\u30E5\u30FC\u4E2D","published":"\u516C\u958B\u6E08\u307F","rejected":"\u5909\u66F4\u4F9D\u983C","removed":"\u524A\u9664\u6E08\u307F","pendingTitle":"Cephable\u306E\u5BE9\u67FB\u3092\u5F85\u3063\u3066\u304B\u3089\u3001\u4E00\u822C\u5E02\u5834\u306B\u767B\u5834\u3059\u308B\u4E88\u5B9A\u3067\u3059\u3002","publishedTitle":"\u627F\u8A8D\u3055\u308C\u3001\u516C\u958B\u5E02\u5834\u306B\u63B2\u8F09\u3055\u308C\u307E\u3057\u305F\u3002","rejectedTitle":"\u516C\u958B\u63B2\u8F09\u304C\u627F\u8A8D\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u5BE9\u67FB\u62C5\u5F53\u8005\u306E\u6CE8\u8A18\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u518D\u5EA6\u3054\u63D0\u51FA\u304F\u3060\u3055\u3044\u3002","removedTitle":"\u30E2\u30C7\u30EC\u30FC\u30BF\u30FC\u306B\u3088\u3063\u3066\u516C\u958B\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002","notify":{"published":"\u300C{{name}}\u300D\u306F\u627F\u8A8D\u3055\u308C\u3001\u73FE\u5728\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u3067\u5229\u7528\u53EF\u80FD\u3067\u3059\u3002","rejected":"\u300C{{name}}\u300D\u306F\u516C\u958B\u524D\u306B\u4FEE\u6B63\u304C\u5FC5\u8981\u3067\u3059\u3002\u958B\u3044\u3066\u30EC\u30D3\u30E5\u30FC\u62C5\u5F53\u8005\u306E\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","removed":"\u300C{{name}}\u300D\u306F\u516C\u958B\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002"}},"managedBy":"{{provenance}}\u306B\u3088\u3063\u3066\u7BA1\u7406\u3055\u308C\u3066\u3044\u307E\u3059","integrationType":{"cephable":"\u516C\u5F0F\u7D71\u5408","mine":"\u500B\u4EBA\u7D71\u5408","organization":"\u7D44\u7E54\u7D71\u5408","thirdParty":"\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u7D71\u5408"},"automateHttpServer":{"title":"HTTP\u30B5\u30FC\u30D0\u30FC\u3092\u81EA\u52D5\u5316\u3059\u308B","description":"\u30ED\u30FC\u30AB\u30EB\u30B5\u30FC\u30D3\u30B9\u3092HTTP\u7D4C\u7531\u3067Cephable\u306E\u30C7\u30D0\u30A4\u30B9\u5185Automate\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306B\u63A5\u7D9A\u3057\u307E\u3059\u3002","detail":"Automate HTTP\u30B5\u30FC\u30D0\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30ED\u30FC\u30AB\u30EB\u30B5\u30FC\u30D3\u30B9\u3001\u958B\u767A\u30C4\u30FC\u30EB\u3001\u8A55\u4FA1\u30E9\u30F3\u30CA\u30FC\u304CCephable\u306E\u51FA\u8377\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3092\u5229\u7528\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u306F\u3001\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u306E\u63A5\u7D9A\u306E\u307F\u3092\u53D7\u3051\u5165\u308C\u3001\u3059\u3079\u3066\u306E\u30EA\u30AF\u30A8\u30B9\u30C8\u3067\u751F\u6210\u3055\u308C\u305F\u30AD\u30FC\u3092\u8981\u6C42\u3057\u3001\u30D5\u30A1\u30A4\u30EB\u64CD\u4F5C\u3092\u9694\u96E2\u3055\u308C\u305FAutomate\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u5185\u306B\u9650\u5B9A\u3057\u307E\u3059\u3002","proRequired":"Automate HTTP\u30B5\u30FC\u30D0\u30FC\u306F\u3001Cephable Professional\u306B\u4ED8\u5C5E\u3057\u3066\u3044\u307E\u3059\u3002","running":"\u30E9\u30F3\u30CB\u30F3\u30B0","stopped":"\u505C\u6B62\u3057\u307E\u3057\u305F","port":"\u30DD\u30FC\u30C8","endpoint":"\u7D42\u70B9","api":{"title":"\u63A5\u7D9A\u65B9\u6CD5","description":"\u3053\u306E\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u3066\u3044\u308B\u30ED\u30FC\u30AB\u30EB\u30B9\u30AF\u30EA\u30D7\u30C8\u3001\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A2\u30D7\u30EA\u3001\u307E\u305F\u306F\u81EA\u52D5\u5316\u30C4\u30FC\u30EB\u304B\u3089\u30B5\u30FC\u30D0\u30FC\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","routes":{"chat":"\u30C1\u30E3\u30C3\u30C8","run":"\u5B9F\u884C\u3092\u81EA\u52D5\u5316\u3059\u308B","health":"\u5065\u5EB7","models":"\u30E2\u30C7\u30EB","modelMode":"\u30E2\u30C7\u30EB\u30E2\u30FC\u30C9\uFF08\u72EC\u81EA\u306E\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30EB\u30FC\u30D7\uFF09","tools":"\u7D44\u307F\u8FBC\u307F\u30C4\u30FC\u30EB","speech":"\u30B9\u30D4\u30FC\u30C1\u7D50\u679C","settings":"\u8A2D\u5B9A"},"steps":{"enable":"\u30AB\u30FC\u30C9\u304B\u3089\u3053\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u3001Cephable\u3092\u958B\u3044\u305F\u307E\u307E\u306B\u3057\u3066\u3001\u4E0A\u8A18\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u300C\u5B9F\u884C\u4E2D\u300D\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","copyKey":"\u4EE5\u4E0B\u306E\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u3092\u30B3\u30D4\u30FC\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B3\u30D4\u30FC\u3057\u305F\u30AD\u30FC\u3092\u3001Authorization\u30D8\u30C3\u30C0\u30FC\u306B\u300CBearer <\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC>\u300D\u3068\u3057\u3066\u542B\u3081\u3066\u3001\u3059\u3079\u3066\u306E\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002","sendRequest":"\u4E0A\u8A18\u306E\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001/v1/chat/completions \u306B JSON \u30EA\u30AF\u30A8\u30B9\u30C8\u3092 POST \u3057\u3066\u304F\u3060\u3055\u3044\u3002\u65E2\u5B58\u306E OpenAI \u4E92\u63DB\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306F\u3001\u30E2\u30C7\u30EB\u540D\u3068\u3057\u3066 cephable-agent \u3092\u4F7F\u7528\u3057\u3066\u5B8C\u5168\u306A\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3092\u5B9F\u884C\u3059\u308B\u304B\u3001cephable-model \u3092\u4F7F\u7528\u3057\u3066\u72EC\u81EA\u306E\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u5185\u3067 Cephable \u3092\u30E2\u30C7\u30EB\u3068\u3057\u3066\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","readResponse":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304B\u3089\u306E\u5FDC\u7B54\u3092 choices[0].message.content \u304B\u3089\u8AAD\u307F\u53D6\u308A\u307E\u3059\u3002\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u304C\u63A5\u7D9A\u3067\u304D\u306A\u3044\u5834\u5408\u306F\u3001\u540C\u3058\u8A8D\u8A3C\u30D8\u30C3\u30C0\u30FC\u3092\u4F7F\u7528\u3057\u3066 GET /health \u3092\u9001\u4FE1\u3057\u307E\u3059\u3002"}},"key":"\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC","keyDescription":"\u3053\u306E\u30AD\u30FC\u306F\u3001\u30ED\u30FC\u30AB\u30EB\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306E\u30D9\u30A2\u30E9\u30FC\u30C8\u30FC\u30AF\u30F3\u3068\u3057\u3066\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u30AD\u30FC\u306F\u30AA\u30DA\u30EC\u30FC\u30C6\u30A3\u30F3\u30B0\u30B7\u30B9\u30C6\u30E0\u306E\u30BB\u30AD\u30E5\u30A2\u30B9\u30C8\u30EC\u30FC\u30B8\u3067\u6697\u53F7\u5316\u3055\u308C\u3001Cephable\u3068\u306F\u540C\u671F\u3055\u308C\u307E\u305B\u3093\u3002","copyKey":"\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u3092\u30B3\u30D4\u30FC\u3059\u308B","copyError":"Automate\u30B5\u30FC\u30D0\u30FC\u306E\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u3092\u30B3\u30D4\u30FC\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","regenerateKey":"\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u3092\u518D\u751F\u6210\u3059\u308B","keyRegenerated":"\u30B5\u30FC\u30D0\u30FC\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u304C\u81EA\u52D5\u518D\u751F\u6210\u3055\u308C\u307E\u3057\u305F\u3002","example":{"title":"Node.js\u306E\u30EA\u30AF\u30A8\u30B9\u30C8\u4F8B","description":"\u3053\u306E\u4F8B\u306B\u306F\u65E2\u306B\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3068\u73FE\u5728\u306E\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u3092\u4FE1\u983C\u3067\u304D\u308B\u30ED\u30FC\u30AB\u30EB\u306ENode.js\u30B9\u30AF\u30EA\u30D7\u30C8\u306B\u30B3\u30D4\u30FC\u3057\u3001\u30B5\u30F3\u30D7\u30EB\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30BF\u30B9\u30AF\u306E\u5185\u5BB9\u306B\u7F6E\u304D\u63DB\u3048\u3066\u304F\u3060\u3055\u3044\u3002","copy":"\u30B3\u30D4\u30FC\u4F9D\u983C\u306E\u4F8B","copyError":"\u30EA\u30AF\u30A8\u30B9\u30C8\u4F8B\u3092\u30B3\u30D4\u30FC\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002"},"useCases":{"title":"\u30B5\u30FC\u30D0\u30FC\u306E\u5229\u7528\u306B\u95A2\u3059\u308B\u30A2\u30A4\u30C7\u30A2","description":"\u30ED\u30FC\u30AB\u30EBHTTP\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u5B9F\u884C\u3067\u304D\u308B\u3082\u306E\u3067\u3042\u308C\u3070\u3001Cephable\u306E\u30C7\u30D0\u30A4\u30B9\u5185\u81EA\u52D5\u5316\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306B\u652F\u63F4\u3092\u4F9D\u983C\u3067\u304D\u307E\u3059\u3002","localAutomation":"\u30ED\u30FC\u30AB\u30EB\u30B9\u30AF\u30EA\u30D7\u30C8\u3001\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u30C4\u30FC\u30EB\u3001\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30E6\u30FC\u30C6\u30A3\u30EA\u30C6\u30A3\u3001\u307E\u305F\u306F\u81EA\u52D5\u5316\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3092Automate\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u63A5\u7D9A\u3057\u307E\u3059\u3002","privateText":"\u5185\u90E8\u30C4\u30FC\u30EB\u5185\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u63DB\u3048\u3001\u8981\u7D04\u3001\u5206\u985E\u3001\u307E\u305F\u306F\u7FFB\u8A33\u3059\u308B\u3068\u540C\u6642\u306B\u3001\u63A8\u8AD6\u51E6\u7406\u306F\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u3044\u307E\u3059\u3002","accessibleInputs":"\u30AB\u30B9\u30BF\u30E0\u30B9\u30A4\u30C3\u30C1\u3001\u30BB\u30F3\u30B5\u30FC\u3001\u307E\u305F\u306F\u95A2\u9023\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A2\u30AF\u30BB\u30B9\u53EF\u80FD\u306A\u5165\u529B\u3092\u3088\u308A\u9AD8\u5EA6\u306AAutomate\u30BF\u30B9\u30AF\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002","testing":"Cephable\u30A2\u30D7\u30EA\u3067\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u3082\u306E\u3068\u540C\u3058\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3001\u30B9\u30AD\u30EB\u3001\u30C4\u30FC\u30EB\u3001\u304A\u3088\u3073\u30ED\u30FC\u30AB\u30EB\u30E2\u30C7\u30EB\u306B\u5BFE\u3057\u3066\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u304A\u3088\u3073\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u56DE\u5E30\u30C6\u30B9\u30C8\u30B9\u30A4\u30FC\u30C8\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002"},"security":{"title":"\u30A2\u30AF\u30BB\u30B9\u3092\u30ED\u30FC\u30AB\u30EB\u304B\u3064\u5B89\u5168\u306B\u4FDD\u3064","description":"\u30B5\u30FC\u30D0\u30FC\u306F127.0.0.1\u3067\u306E\u307F\u30EA\u30C3\u30B9\u30F3\u3059\u308B\u305F\u3081\u3001\u30EA\u30E2\u30FC\u30C8\u30B5\u30FC\u30D3\u30B9\u3084\u30AF\u30E9\u30A6\u30C9\u30B5\u30FC\u30D3\u30B9\u306F\u76F4\u63A5\u63A5\u7D9A\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u306F\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u540C\u69D8\u306B\u6271\u3044\u3001\u4FE1\u983C\u3067\u304D\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3068\u306E\u307F\u5171\u6709\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30A2\u30AF\u30BB\u30B9\u30AD\u30FC\u3092\u518D\u751F\u6210\u3059\u308B\u3068\u3001\u4EE5\u524D\u306E\u30AD\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u306F\u5373\u5EA7\u306B\u5207\u65AD\u3055\u308C\u307E\u3059\u3002"},"secureStorageUnavailable":"\u5B89\u5168\u306A\u30AA\u30DA\u30EC\u30FC\u30C6\u30A3\u30F3\u30B0\u30B7\u30B9\u30C6\u30E0\u30B9\u30C8\u30EC\u30FC\u30B8\u304C\u5229\u7528\u3067\u304D\u306A\u3044\u305F\u3081\u3001\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u3092\u6709\u52B9\u306B\u3067\u304D\u307E\u305B\u3093\u3002","error":"Automate HTTP\u30B5\u30FC\u30D0\u30FC\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","portMoved":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u30DD\u30FC\u30C8{{preferredPort}}\u304C\u65E2\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u30B5\u30FC\u30D0\u30FC\u306F\u4EE3\u308F\u308A\u306B\u30DD\u30FC\u30C8{{port}}\u3067\u8D77\u52D5\u3057\u307E\u3057\u305F\u3002\u30C4\u30FC\u30EB\u3067\u306F\u3001\u30C7\u30D5\u30A9\u30EB\u30C8\u3067\u306F\u306A\u304F\u4E0A\u8A18\u306E\u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002","portMovedTitle":"\u5225\u306E\u30DD\u30FC\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059"},"workflowRecording":{"title":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u8A18\u9332\u3059\u308B","description":"Cephable\u306B\u4E00\u5EA6\u4F5C\u696D\u306E\u3084\u308A\u65B9\u3092\u6559\u3048\u308C\u3070\u3001\u305D\u306E\u8A18\u9332\u304C\u30B9\u30AD\u30EB\u3068\u3057\u3066\u4FDD\u5B58\u3055\u308C\u3001\u81EA\u52D5\u7684\u306B\u5B9F\u884C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","previewBadge":"\u30D7\u30EC\u30D3\u30E5\u30FC","detail":"Record a Workflow\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3059\u308B\u69D8\u5B50\u3092\u9332\u753B\u3057\u307E\u3059\u3002\u5207\u308A\u66FF\u3048\u305F\u30A2\u30D7\u30EA\u3001\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u30DC\u30BF\u30F3\u3084\u30D5\u30A3\u30FC\u30EB\u30C9\u3001\u5165\u529B\u3057\u305F\u5185\u5BB9\u3001\u305D\u3057\u3066\u97F3\u58F0\u3067\u8A71\u3057\u305F\u5185\u5BB9\u306A\u3069\u3092\u8A18\u9332\u3057\u307E\u3059\u3002\u4F5C\u696D\u304C\u7D42\u4E86\u3059\u308B\u3068\u3001Cephable\u306F\u9332\u753B\u5185\u5BB9\u3092AI\u30B9\u30AD\u30EB\u306B\u5909\u63DB\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u305D\u308C\u3092\u78BA\u8A8D\u3001\u7DE8\u96C6\u3001\u4FDD\u5B58\u3067\u304D\u307E\u3059\u3002\u6B21\u56DEAutomate\u306B\u540C\u69D8\u306E\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3059\u308B\u3088\u3046\u6307\u793A\u3059\u308B\u3068\u3001Automate\u306F\u3053\u306E\u30B9\u30AD\u30EB\u3092\u30AC\u30A4\u30C9\u3068\u3057\u3066\u4F7F\u7528\u3057\u3001\u3059\u3079\u3066\u306E\u30AF\u30EA\u30C3\u30AF\u3092\u7E70\u308A\u8FD4\u3059\u306E\u3067\u306F\u306A\u304F\u3001\u6700\u3082\u76F4\u63A5\u7684\u306A\u30EB\u30FC\u30C8\u3092\u9078\u629E\u3057\u307E\u3059\u3002","howItWorks":{"title":"\u4ED5\u7D44\u307F","record":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u3001\u81EA\u52D5\u5316\u30BF\u30D6\u3001\u307E\u305F\u306FAI\u30B9\u30AD\u30EB\u304B\u3089\u9332\u753B\u3092\u958B\u59CB\u3057\u3001\u30BF\u30B9\u30AF\u3092\u6700\u521D\u304B\u3089\u6700\u5F8C\u307E\u3067\u5B9F\u884C\u3057\u307E\u3059\u3002","narrate":"\u81EA\u5206\u304C\u4F55\u3092\u3057\u3066\u3044\u308B\u306E\u304B\u3001\u305D\u3057\u3066\u306A\u305C\u305D\u3046\u3057\u3066\u3044\u308B\u306E\u304B\u3092\u8A00\u8449\u3067\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3042\u306A\u305F\u306E\u8AAC\u660E\u304C\u3001\u305D\u308C\u305E\u308C\u306E\u30B9\u30C6\u30C3\u30D7\u306E\u80CC\u5F8C\u306B\u3042\u308B\u7406\u7531\u3068\u306A\u308A\u307E\u3059\u3002","review":"\u9332\u753B\u3092\u505C\u6B62\u3057\u3066\u4E0B\u66F8\u304D\u30B9\u30AD\u30EB\u3092\u53D6\u5F97\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u4FDD\u5B58\u3059\u308B\u524D\u306B\u3001\u624B\u9806\u3068\u8AAC\u660E\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","run":"Automate\u306B\u30BF\u30B9\u30AF\u3092\u518D\u5EA6\u5B9F\u884C\u3059\u308B\u3088\u3046\u306B\u6307\u793A\u3057\u3066\u304F\u3060\u3055\u3044\u3002Automate\u306F\u9332\u753B\u3055\u308C\u305F\u30C7\u30FC\u30BF\u3092\u53C2\u7167\u3057\u3001\u3042\u306A\u305F\u306E\u6307\u793A\u306B\u5408\u308F\u305B\u3066\u51E6\u7406\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002"},"captured":{"title":"\u4F55\u304C\u8A18\u9332\u3055\u308C\u308B\u306E\u304B","description":"\u30AF\u30EA\u30C3\u30AF\u3001\u30AD\u30FC\u64CD\u4F5C\u3001\u30A2\u30D7\u30EA\u306E\u5207\u308A\u66FF\u3048\u3001\u4F7F\u7528\u3057\u305F\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u540D\u524D\u3068ID\u3001\u305D\u3057\u3066\u30DE\u30A4\u30AF\u304C\u5229\u7528\u53EF\u80FD\u306A\u5834\u5408\u306F\u30CA\u30EC\u30FC\u30B7\u30E7\u30F3\u306A\u3069\u3001\u3059\u3079\u3066\u304C\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u51E6\u7406\u3055\u308C\u307E\u3059\u3002\u65B0\u3057\u3044\u30D6\u30E9\u30A6\u30B6\u30BF\u30D6\u3092\u958B\u3044\u3066\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3059\u308B\u306A\u3069\u3001\u76EE\u7684\u3092\u9054\u6210\u3059\u308B\u305F\u3081\u3060\u3051\u306E\u64CD\u4F5C\u306F\u30011\u3064\u306E\u64CD\u4F5C\u306B\u307E\u3068\u3081\u3089\u308C\u307E\u3059\u3002\u9332\u97F3\u4E2D\u306F\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3084\u652F\u6255\u3044\u60C5\u5831\u3092\u5165\u529B\u3057\u306A\u3044\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"whereToFind":{"title":"\u3069\u3053\u3067\u898B\u3064\u3051\u3089\u308C\u308B\u304B","workspace":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\uFF1A[\u4F5C\u6210\u3068\u81EA\u52D5\u5316] \u306E\u5019\u88DC\u306E\u4E0B\u306B\u3042\u308B [\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u8A18\u9332] \u30D0\u30F3\u30C9\u3002","automate":"Cephable\u30D1\u30CD\u30EB\u306E\u300C\u81EA\u52D5\u5316\u300D\u30BF\u30D6\uFF1A\u300CCephable\u306B\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6559\u3048\u308B\u300D\u3068\u3044\u3046\u63D0\u6848\u3068\u30B3\u30F3\u30DD\u30FC\u30B6\u30FC\u30E1\u30CB\u30E5\u30FC\u3002","skills":"\u62E1\u5F35\u6A5F\u80FD \u2192 AI\u30B9\u30AD\u30EB\uFF1A\u30B9\u30AD\u30EB\u306E\u4F5C\u6210 \u2192 \u64CD\u4F5C\u5185\u5BB9\u306E\u8A18\u9332\u3002"},"previewNotice":"\u3053\u308C\u306F\u30D7\u30EC\u30D3\u30E5\u30FC\u7248\u306E\u6A5F\u80FD\u3067\u3059\u3002\u30EA\u30EA\u30FC\u30B9\u524D\u306B\u5909\u66F4\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u3001\u7686\u69D8\u304B\u3089\u306E\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u306F\u958B\u767A\u306B\u5F79\u7ACB\u3066\u3089\u308C\u307E\u3059\u3002","proRequired":"Cephable Professional\u3067\u306F\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u8A18\u9332\u6A5F\u80FD\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059\u3002","startAction":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u8A18\u9332\u3059\u308B"}},"sensitivityValues":{"verySensitive":"\u975E\u5E38\u306B\u654F\u611F","high":"\u9AD8\u3044","medium":"\u4E2D\u304F\u3089\u3044","low":"\u4F4E\u3044","notSensitive":"\u654F\u611F\u3067\u306F\u306A\u3044"},"summarize":"\u8981\u7D04\u3059\u308B","appControlsPanel":{"searchPlaceholder":"\u691C\u7D22\u30B3\u30DE\u30F3\u30C9...","searchLabel":"\u691C\u7D22\u30B3\u30DE\u30F3\u30C9","favorites":{"title":"\u304A\u6C17\u306B\u5165\u308A","description":"\u304A\u6C17\u306B\u5165\u308A\u3068\u306F\u3001\u3088\u304F\u4F7F\u3046\u64CD\u4F5C\u306E\u3053\u3068\u3067\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u306E\u6A2A\u306B\u3042\u308B\u661F\u306E\u30A2\u30A4\u30B3\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u305D\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u304A\u6C17\u306B\u5165\u308A\u3068\u3057\u3066\u767B\u9332\u3067\u304D\u307E\u3059\u3002"},"noCommandsFound":"\u30B3\u30DE\u30F3\u30C9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093","globalCommands":"\u30B0\u30ED\u30FC\u30D0\u30EB","prefixCommandToast":"\u3053\u308C\u306F\u63A5\u982D\u8F9E\u30B3\u30DE\u30F3\u30C9\u3067\u3059\u3002\u63A5\u982D\u8F9E\u306E\u5F8C\u306B\u30D5\u30EC\u30FC\u30BA\u3092\u8A00\u3046\u304B\u5165\u529B\u3059\u308B\u3053\u3068\u3067\u3001\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u304C\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002"},"collapse":"\u5D29\u58CA","intelligentTasks":{"loading":{"loadingModels":"AI\u30E2\u30C7\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...","extractingModels":"AI\u30E2\u30C7\u30EB\u3092\u62BD\u51FA\u4E2D..."}},"sidebar":{"collapse":"\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u6298\u308A\u305F\u305F\u3080","expand":"\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u5C55\u958B\u3059\u308B"},"workspace":{"title":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9","badge":"\u30C7\u30D0\u30A4\u30B9\u5185 \xb7 \u30D7\u30E9\u30A4\u30D9\u30FC\u30C8","subtitle":"AI\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306F\u3001\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u5168\u306B\u52D5\u4F5C\u3057\u307E\u3059\u3002\u64CD\u4F5C\u3092\u958B\u59CB\u3057\u305F\u308A\u3001\u4F5C\u6210\u3057\u305F\u308A\u3001\u81EA\u52D5\u5316\u3057\u305F\u308A\u3001\u3042\u308B\u3044\u306F\u5358\u306B\u30C1\u30E3\u30C3\u30C8\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002","control":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u306A\u3069\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3067\u5229\u7528\u3067\u304D\u307E\u3059\u3002","voice":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u64CD\u4F5C"},"dictation":{"title":"\u97F3\u58F0\u5165\u529B","description":"\u8A71\u3059\u30BF\u30A4\u30D7"},"computerUse":{"title":"\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u306E\u4F7F\u7528","description":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306B\u4EFB\u305B\u307E\u3057\u3087\u3046"},"camera":{"title":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u9854\u3068\u982D\u306E\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC"},"quickActions":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3","description":"\u30EF\u30F3\u30BF\u30C3\u30D7\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8"}},"create":{"title":"\u4F5C\u6210\u3059\u308B","description":"\u30B3\u30D4\u30FC\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3084\u30CF\u30A4\u30E9\u30A4\u30C8\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u3063\u3066\u3001\u4F5C\u696D\u4E2D\u306E\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u3001\u4E0B\u66F8\u304D\u3001\u66F8\u304D\u76F4\u3057\u3001\u66F8\u5F0F\u5909\u66F4\u3001\u7FFB\u8A33\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","items":{"draftEmail":"\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","writeDocument":"\u6587\u66F8\u3092\u4F5C\u6210\u3059\u308B","summarizeNotes":"\u30E1\u30E2\u306B\u307E\u3068\u3081\u308B","polishWriting":"\u6587\u7AE0\u3092\u78E8\u304F","translateText":"\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3059\u308B","socialPost":"\u30BD\u30FC\u30B7\u30E3\u30EB\u6295\u7A3F\u3092\u66F8\u304F","cd_brief":"\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30D6\u30EA\u30FC\u30D5\u3092\u4F5C\u6210\u3059\u308B","cd_caption":"\u30AD\u30E3\u30D7\u30B7\u30E7\u30F3\u3068\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8\u3092\u8A18\u8FF0\u3057\u3066\u304F\u3060\u3055\u3044","ar_insights":"\u8ABF\u67FB\u7D50\u679C\u3092\u8981\u7D04\u3057\u3066\u6D1E\u5BDF\u3092\u5F97\u308B","ar_exec":"\u30A8\u30B0\u30BC\u30AF\u30C6\u30A3\u30D6\u30B5\u30DE\u30EA\u30FC\u3092\u4F5C\u6210\u3059\u308B","cc_followup":"\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B","cc_meetingNotes":"\u30E1\u30E2\u3092\u4F1A\u8B70\u8B70\u4E8B\u9332\u306B\u5909\u63DB\u3059\u308B","bd_commit":"\u30B3\u30DF\u30C3\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u8A18\u8FF0\u3059\u308B","bd_review":"\u30B3\u30FC\u30C9\u30EC\u30D3\u30E5\u30FC\u3092\u8981\u7D04\u3059\u308B","gp_bio":"\u30B9\u30C8\u30EA\u30FC\u30E0\u306E\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u66F8\u304F","gp_recap":"\u6628\u591C\u306E\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u632F\u308A\u8FD4\u308A","lt_lesson":"\u6388\u696D\u8A08\u753B\u306E\u6982\u8981\u3092\u4F5C\u6210\u3059\u308B","lt_studyNotes":"\u5B66\u7FD2\u30CE\u30FC\u30C8\u306B\u307E\u3068\u3081\u308B","mo_agenda":"\u4F1A\u8B70\u306E\u8B70\u984C\u6848\u3092\u4F5C\u6210\u3059\u308B","mo_update":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u6700\u65B0\u60C5\u5831\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044","aa_simplify":"\u5E73\u6613\u306A\u8A00\u8449\u3067\u8AAC\u660E\u3059\u308B","aa_describe":"\u753B\u50CF\u3092\u8A00\u8449\u3067\u63CF\u5199\u3059\u308B"},"contextRow":{"highlightedText":"\u30CF\u30A4\u30E9\u30A4\u30C8\u8868\u793A\uFF0F\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u30C6\u30AD\u30B9\u30C8","output":"\u5165\u529B\u4E2D:","input":"\u7528\u9014\uFF1A","background":"\u80CC\u666F","currentapp":"\u73FE\u5728\u306E\u30A2\u30D7\u30EA"},"prompts":{"draftEmail":"\u3053\u306E\u4EF6\u306B\u3064\u3044\u3066\u3001\u660E\u78BA\u3067\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u306A\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","writeDocument":"\u3053\u308C\u306B\u3064\u3044\u3066\u6587\u66F8\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","summarizeNotes":"\u3053\u308C\u3092\u7C21\u6F54\u304B\u3064\u5206\u304B\u308A\u3084\u3059\u304F\u6574\u7406\u3055\u308C\u305F\u7B87\u6761\u66F8\u304D\u306E\u30E1\u30E2\u306B\u307E\u3068\u3081\u3066\u304F\u3060\u3055\u3044\u3002","polishWriting":"\u79C1\u306E\u610F\u56F3\u3068\u30C8\u30FC\u30F3\u3092\u7DAD\u6301\u3057\u3064\u3064\u3001\u3088\u308A\u660E\u78BA\u3067\u6D17\u7DF4\u3055\u308C\u305F\u6587\u7AE0\u306B\u66F8\u304D\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","socialPost":"\u3053\u308C\u306B\u3064\u3044\u3066\u3001\u77ED\u304F\u3066\u9B45\u529B\u7684\u306A\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u6295\u7A3F\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002","cd_brief":"\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30D6\u30EA\u30FC\u30D5\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ar_insights":"\u3053\u306E\u30C7\u30FC\u30BF\u304B\u3089\u5F97\u3089\u308C\u305F\u4E3B\u8981\u306A\u77E5\u898B\u3068\u6D1E\u5BDF\u3092\u8981\u7D04\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ar_exec":"\u3053\u308C\u306B\u3064\u3044\u3066\u7C21\u6F54\u306A\u8981\u7D04\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cc_followup":"\u3053\u306E\u4EF6\u306B\u3064\u3044\u3066\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cc_meetingNotes":"\u3053\u308C\u3089\u306E\u30E1\u30E2\u3092\u3001\u884C\u52D5\u9805\u76EE\u3092\u76DB\u308A\u8FBC\u3093\u3060\u660E\u78BA\u306A\u8B70\u4E8B\u9332\u306B\u307E\u3068\u3081\u307E\u3057\u3087\u3046\u3002","bd_commit":"\u3053\u308C\u3089\u306E\u5909\u66F4\u306B\u3064\u3044\u3066\u3001\u660E\u78BA\u306A\u30B3\u30DF\u30C3\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u8A18\u8FF0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","bd_review":"\u3053\u306E\u30B3\u30FC\u30C9\u30EC\u30D3\u30E5\u30FC\u306E\u8981\u70B9\u3068\u5FC5\u8981\u306A\u5909\u66F4\u70B9\u3092\u307E\u3068\u3081\u3066\u304F\u3060\u3055\u3044\u3002","gp_bio":"\u79C1\u306E\u914D\u4FE1\uFF0F\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u7528\u306B\u3001\u30A4\u30F3\u30D1\u30AF\u30C8\u306E\u3042\u308B\u81EA\u5DF1\u7D39\u4ECB\u6587\u3092\u66F8\u3044\u3066\u304F\u3060\u3055\u3044\u3002","lt_lesson":"\u3053\u308C\u306B\u95A2\u3059\u308B\u6388\u696D\u8A08\u753B\u306E\u6982\u8981\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lt_studyNotes":"\u3053\u306E\u5185\u5BB9\u3092\u8981\u7D04\u3057\u3066\u3001\u79C1\u304C\u5FA9\u7FD2\u3067\u304D\u308B\u5B66\u7FD2\u30CE\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","mo_agenda":"\u3053\u306E\u4EF6\u3092\u7DB2\u7F85\u3057\u305F\u4F1A\u8B70\u8B70\u984C\u6848\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","mo_update":"\u3053\u308C\u3092\u57FA\u306B\u3001\u95A2\u4FC2\u8005\u5411\u3051\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u9032\u6357\u72B6\u6CC1\u306B\u95A2\u3059\u308B\u5831\u544A\u66F8\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","aa_simplify":"\u3053\u308C\u3092\u5E73\u6613\u3067\u8AAD\u307F\u3084\u3059\u3044\u8A00\u8449\u3067\u66F8\u304D\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"automate":{"title":"\u81EA\u52D5\u5316\u3059\u308B","description":"\u30B8\u30E7\u30D6\u3092\u5E73\u6613\u306A\u8A00\u8449\u3067\u8AAC\u660E\u3059\u308C\u3070\u3001Cephable\u306F\u30A2\u30D7\u30EA\u3001\u30D5\u30A1\u30A4\u30EB\u3001\u3055\u3089\u306B\u306F\u30B3\u30DE\u30F3\u30C9\u30E9\u30A4\u30F3\u306B\u81F3\u308B\u307E\u3067\u3001\u305D\u306E\u30B8\u30E7\u30D6\u3092\u5B9F\u884C\u3057\u307E\u3059\u3002","items":{"triage":"\u53D7\u4FE1\u30C8\u30EC\u30A4\u306E\u30C8\u30EA\u30A2\u30FC\u30B8","cd_exportAssets":"\u30A2\u30BB\u30C3\u30C8\u306E\u540D\u524D\u5909\u66F4\u3068\u30D5\u30A1\u30A4\u30EB\u5316","cd_moodboard":"\u53C2\u8003\u6587\u732E\u3092\u96C6\u3081\u308B","cc_triage":"\u30C8\u30EA\u30A2\u30FC\u30B8\u3068\u8FD4\u4FE1\u6848\u306E\u4F5C\u6210","cc_recap":"\u8981\u7D04\u3057\u3066\u30C1\u30FC\u30E0\u306B\u9001\u4FE1","bd_scaffold":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u7D44\u307F\u7ACB\u3066\u308B","gp_schedule":"\u914D\u4FE1\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3092\u8A08\u753B\u3059\u308B","lt_handout":"\u914D\u5E03\u8CC7\u6599\u3092\u4F5C\u6210\u3059\u308B","summarizeSend":"\u8981\u7D04\u3057\u3066\u30E1\u30FC\u30EB\u3067\u9001\u4FE1","researchDoc":"\u8ABF\u67FB\u3057\u3066\u6587\u66F8\u3092\u4F5C\u6210\u3059\u308B","organizeFiles":"\u30D5\u30A1\u30A4\u30EB\u3092\u6574\u7406\u3059\u308B","cleanUp":"\u30D5\u30A9\u30EB\u30C0\u3092\u6574\u7406\u3059\u308B","wordDoc":"Word\u6587\u66F8\u3092\u4F5C\u6210\u3059\u308B","ar_summarizeSend":"\u8981\u7D04\u3057\u3066\u30E1\u30FC\u30EB\u3067\u9001\u4FE1","ar_analyzeData":"\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u5206\u6790\u3059\u308B","ar_deck":"\u30C7\u30FC\u30BF\u304B\u3089\u30C7\u30C3\u30AD\u3092\u4F5C\u6210\u3059\u308B","cc_summarizeEmail":"\u8981\u7D04\u3057\u3066\u30E1\u30FC\u30EB\u306B\u3059\u308B","cc_socialPost":"\u30EA\u30F3\u30AF\u304B\u3089\u306E\u6295\u7A3F","bd_buildTest":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u69CB\u7BC9\u3068\u30C6\u30B9\u30C8","bd_cleanup":"\u30B3\u30FC\u30C9\u306E\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7\u3092\u63D0\u6848\u3057\u307E\u3059","lt_studyMaterial":"\u5B66\u7FD2\u6559\u6750\u3092\u4F5C\u6210\u3059\u308B","lt_accommodation":"\u30A2\u30AF\u30BB\u30B9\u3057\u3084\u3059\u3044\u30E1\u30E2\u3092\u4F5C\u6210\u3059\u308B","lt_research":"\u8ABF\u67FB\u30FB\u6BD4\u8F03","mo_meetingActions":"\u30E1\u30E2\u3092\u884C\u52D5\u306B\u79FB\u3059","mo_organizeFiles":"\u30D5\u30A1\u30A4\u30EB\u3092\u6574\u7406\u3059\u308B","mo_cleanup":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u3092\u6574\u7406\u3059\u308B","aa_translate":"\u6587\u66F8\u3092\u7FFB\u8A33\u3059\u308B"},"prompts":{"summarizeSend":"<\u30D5\u30A9\u30EB\u30C0>\u306E\u5185\u5BB9\u3092\u8981\u7D04\u3057\u3066\u3001<\u30C1\u30FC\u30E0\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9>\u306B\u30E1\u30FC\u30EB\u3067\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002","researchDoc":"<\u30D5\u30A9\u30EB\u30C0\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8>\u5185\u306E\u50BE\u5411\u3092\u8ABF\u67FB\u3057\u3001\u767A\u898B\u3057\u305F\u5185\u5BB9\u3092\u65B0\u3057\u3044\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u307E\u3068\u3081\u3066\u304F\u3060\u3055\u3044\u3002","organizeFiles":"\u30D5\u30A1\u30A4\u30EB\u3092\u30B3\u30D4\u30FC<source folder>\u306E\u4E2D\u3078<destination folder>\u3002","cleanUp":"\u79C1\u306E<\u30D5\u30A9\u30EB\u30C0>\u304B\u3089\u3059\u3079\u3066\u306E<\u30D5\u30A1\u30A4\u30EB\u306E\u7A2E\u985E\u3001\u4F8B\uFF1A\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8>\u3092\u524A\u9664\u3057\u307E\u3059\u3002","wordDoc":"\u4F7F\u7528<article or notes>Microsoft Word \u6587\u66F8\u3092\u4F5C\u6210\u3059\u308B<does what>\u3002","triage":"\u79C1\u306E\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u78BA\u8A8D\u3057\u3066\u3001\u5BFE\u5FDC\u304C\u5FC5\u8981\u306A\u30E1\u30FC\u30EB\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002\u8FD4\u4FE1\u304C\u5FC5\u8981\u306A\u5834\u5408\u306F\u3001\u8FD4\u4FE1\u6587\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cd_exportAssets":"<\u30D5\u30A9\u30EB\u30C0>\u5185\u306E\u30C7\u30B6\u30A4\u30F3\u30A2\u30BB\u30C3\u30C8\u3092\u3001\u3053\u306E\u547D\u540D\u898F\u5247\uFF08<\u547D\u540D\u898F\u5247>\uFF09\u306B\u5F93\u3063\u3066\u540D\u524D\u5909\u66F4\u3057\u3001\u30D5\u30A9\u30EB\u30C0\u306B\u5206\u985E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cd_moodboard":"\u30AA\u30F3\u30E9\u30A4\u30F3\u3067<\u30A2\u30A4\u30C7\u30A2>\u306B\u95A2\u3059\u308B\u53C2\u8003\u6587\u732E\u3092\u63A2\u3057\u3001\u305D\u308C\u3089\u3092\u6587\u66F8\u306B\u307E\u3068\u3081\u3066\u304F\u3060\u3055\u3044\u3002","ar_summarizeSend":"<\u30D5\u30A9\u30EB\u30C0>\u306E\u5185\u5BB9\u3092\u8981\u7D04\u3057\u3066\u3001<\u30C1\u30FC\u30E0\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9>\u306B\u30E1\u30FC\u30EB\u3067\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ar_analyzeData":"\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u5206\u6790\u3057\u3001\u63A2\u3059\u3079\u304D\u9805\u76EE\uFF08\u4F8B\uFF1A\u30AD\u30FC\u306E\u7D1B\u5931\uFF09\u3092\u898B\u3064\u3051\u307E\u3059\u3002","ar_deck":"<\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u305F\u306F\u30D5\u30A9\u30EB\u30C0>\u306B\u3042\u308B\u8ABF\u67FB\u7D50\u679C\u3092\u3001<\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8>\u3092\u5F37\u8ABF\u3057\u305FPowerPoint\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u5909\u63DB\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cc_triage":"\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u8AAD\u3093\u3067\u3001\u8FD4\u4FE1\u304C\u5FC5\u8981\u306A\u3082\u306E\u306B\u306F\u8FD4\u4FE1\u306E\u4E0B\u66F8\u304D\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cc_summarizeEmail":"\u8981\u7D04\u3057\u305F\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B<article or document>\u305D\u3057\u3066\u3001\u91CD\u8981\u306A\u6280\u8853\u7684\u8A73\u7D30\u3092\u6307\u6458\u3059\u308B\u3002","cc_recap":"\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u306E\u8981\u7D04\u3092\u4F5C\u6210\u3057\u3001\u30C1\u30FC\u30E0\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u30E1\u30FC\u30EB\u3067\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002","cc_socialPost":"\u8AAD\u3080<article or website>\u305D\u3057\u3066\u66F8\u304F<platform, e.g. Discord>\u305D\u308C\u306B\u3064\u3044\u3066\u53CB\u597D\u7684\u306A\u6295\u7A3F\u3092\u3057\u3066\u304B\u3089\u3001\u65B0\u3057\u3044\u30E1\u30E2\u306B\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002","bd_buildTest":"<\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30D5\u30A9\u30EB\u30C0>\u5185\u306E\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D\u3057\u3001\u30D3\u30EB\u30C9\u3057\u3066\u30C6\u30B9\u30C8\u3092\u5B9F\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3082\u3057\u4F55\u304B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u306F\u3001Git\u306E\u5C65\u6B74\u3092\u78BA\u8A8D\u3057\u3001\u4F55\u304C\u539F\u56E0\u3060\u3063\u305F\u53EF\u80FD\u6027\u304C\u9AD8\u3044\u304B\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002","bd_cleanup":"<\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30D5\u30A9\u30EB\u30C0>\u5185\u306E\u30B3\u30FC\u30C9\u3092\u898B\u3066\u3001\u3069\u3046\u3059\u308C\u3070\u3082\u3063\u3068\u5206\u304B\u308A\u3084\u3059\u304F\u3067\u304D\u308B\u304B\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002","bd_scaffold":"\u5FC5\u8981\u306A\u30B9\u30BF\u30FC\u30BF\u30FC\u30D5\u30A1\u30A4\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001<\u30D5\u30A9\u30EB\u30C0>\u5185\u306B\u65B0\u3057\u3044<\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30BF\u30A4\u30D7>\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002","gp_schedule":"\u30B9\u30C8\u30EA\u30FC\u30DF\u30F3\u30B0\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3092\u8A08\u753B\u3059\u308B<time period>\u30AB\u30D0\u30FC<games or activities>\u3002","lt_studyMaterial":"\u4F7F\u7528<article or notes>Word\u6587\u66F8\u3092\u4F5C\u6210\u3059\u308B<grade level>\u5B66\u751F<reflection questions or a study guide>\u3002","lt_accommodation":"<\u30C8\u30D4\u30C3\u30AF>\u306B\u95A2\u3059\u308B\u8B1B\u7FA9\u30CE\u30FC\u30C8\u3092\u3001<\u7279\u5225\u306A\u914D\u616E>\u3092\u5FC5\u8981\u3068\u3059\u308B\u5B66\u751F\u5411\u3051\u306B\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3057\u305FWord\u6587\u66F8\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lt_handout":"<\u30D5\u30A9\u30EB\u30C0>\u5185\u306E\u8CC7\u6599\u3092\u307E\u3068\u3081\u3066\u30011\u3064\u306E\u914D\u5E03\u8CC7\u6599\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lt_research":"\u30AA\u30F3\u30E9\u30A4\u30F3\u3067<\u30C8\u30D4\u30C3\u30AF\u3001\u4F8B\uFF1A\u795E\u7D4C\u591A\u69D8\u6027\u306B\u95A2\u3059\u308B\u66F8\u7C4D>\u3092\u63A2\u3057\u3001\u305D\u308C\u305E\u308C\u3092\u8981\u7D04\u3057\u305F\u6587\u66F8\u3092\u4F5C\u6210\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305D\u3046\u3059\u308C\u3070\u6BD4\u8F03\u3067\u304D\u307E\u3059\u3002","mo_meetingActions":"\uFF1C\u4F1A\u8B70\u8B70\u4E8B\u9332\uFF1E\u3092\u8AAD\u3093\u3067\u3001\u6B8B\u308A\u306E\u4F5C\u696D\u5185\u5BB9\u3001\u62C5\u5F53\u8005\u3001\u3055\u3089\u306B\u8ABF\u67FB\u304C\u5FC5\u8981\u306A\u4E8B\u9805\u3092\u628A\u63E1\u3057\u307E\u3057\u3087\u3046\u3002\u8B70\u4E8B\u9332\u3092\u30D5\u30A9\u30EB\u30C0\u306B\u6574\u7406\u3057\u3066\u30D5\u30A1\u30A4\u30EB\u306B\u5206\u3051\u3066\u304F\u3060\u3055\u3044\u3002","mo_organizeFiles":"\u30D5\u30A1\u30A4\u30EB\u3092\u30B3\u30D4\u30FC<source folder>\u306E\u4E2D\u3078<destination folder>\u3002","mo_cleanup":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30D5\u30A9\u30EB\u30C0\u304B\u3089\u3059\u3079\u3066\u306E<\u30D5\u30A1\u30A4\u30EB\u306E\u7A2E\u985E\u3001\u4F8B\uFF1A\u30A4\u30F3\u30B9\u30C8\u30FC\u30E9\u30FC>\u3092\u524A\u9664\u3057\u307E\u3059\u3002","aa_translate":"<\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8>\u3092<\u8A00\u8A9E>\u306B\u7FFB\u8A33\u3057\u3001<\u30D5\u30A9\u30EB\u30C0>\u306B\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}},"history":{"title":"\u6700\u8FD1\u306EAI\u306E\u6B74\u53F2","description":"\u6700\u65B0\u306E\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30BF\u30B9\u30AF\u3068\u81EA\u52D5\u5316\u6A5F\u80FD\u3002","viewAll":"\u3059\u3079\u3066\u306E\u5C65\u6B74\u3092\u8868\u793A","empty":"\u3053\u3053\u306B\u306F\u3001\u6700\u8FD1\u5B9F\u884C\u3057\u305FAI\u30BF\u30B9\u30AF\u3068\u81EA\u52D5\u5316\u51E6\u7406\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"badgeRemote":"\u30EA\u30E2\u30FC\u30C8\u30C7\u30D0\u30A4\u30B9\u30FB\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3","browser":{"openButton":"\u30D6\u30E9\u30A6\u30B6\u3092\u958B\u304F","windowTitle":"Cephable\u30D6\u30E9\u30A6\u30B6","newTab":"\u65B0\u3057\u3044\u30BF\u30D6","reload":"\u30EA\u30ED\u30FC\u30C9","forward":"\u30D5\u30A9\u30EF\u30FC\u30C9","openExternal":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u958B\u304F","showWindow":"\u975E\u8868\u793A\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u8868\u793A\u3059\u308B","addressPlaceholder":"Google\u3067\u691C\u7D22\u3059\u308B\u304B\u3001URL\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","clearData":{"description":"Cephable\u30D6\u30E9\u30A6\u30B6\u306E\u5C65\u6B74\u3001Cookie\u3001\u30AD\u30E3\u30C3\u30B7\u30E5\u30C7\u30FC\u30BF\u3001\u4FDD\u5B58\u3055\u308C\u305F\u30ED\u30B0\u30A4\u30F3\u60C5\u5831\u3092\u3059\u3079\u3066\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306B\u3088\u308A\u3001Cephable\u30D6\u30E9\u30A6\u30B6\u3067\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u3044\u308B\u3059\u3079\u3066\u306E\u30B5\u30A4\u30C8\u304B\u3089\u30ED\u30B0\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3059\u3002","button":"\u30D6\u30E9\u30A6\u30B6\u30C7\u30FC\u30BF\u3092\u6D88\u53BB\u3059\u308B","cleared":"\u30D6\u30E9\u30A6\u30B6\u306E\u30C7\u30FC\u30BF\u304C\u6D88\u53BB\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30D6\u30E9\u30A6\u30B6\u30C7\u30FC\u30BF\u3092\u6D88\u53BB\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","confirmTitle":"\u30D6\u30E9\u30A6\u30B6\u306E\u30C7\u30FC\u30BF\u3092\u6D88\u53BB\u3057\u307E\u3059\u304B\uFF1F","confirmMessage":"Cephable\u30D6\u30E9\u30A6\u30B6\u306E\u3059\u3079\u3066\u306E\u8A2D\u5B9A\u304B\u3089\u30ED\u30B0\u30A2\u30A6\u30C8\u3057\u307E\u3059\u304B\uFF1F","confirmDetail":"\u3053\u308C\u306B\u3088\u308A\u3001Cephable\u30D6\u30E9\u30A6\u30B6\u306E\u5C65\u6B74\u3001Cookie\u3001\u30AD\u30E3\u30C3\u30B7\u30E5\u30C7\u30FC\u30BF\u3001\u4FDD\u5B58\u3055\u308C\u305F\u30ED\u30B0\u30A4\u30F3\u60C5\u5831\u304C\u5B8C\u5168\u306B\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","confirm":"\u30AF\u30EA\u30A2\u30C7\u30FC\u30BF","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB"},"context":{"newTab":"\u65B0\u3057\u3044\u30BF\u30D6","reload":"\u30EA\u30ED\u30FC\u30C9","duplicate":"\u91CD\u8907\u30BF\u30D6","close":"\u30BF\u30D6\u3092\u9589\u3058\u308B","closeOthers":"\u4ED6\u306E\u30BF\u30D6\u3092\u9589\u3058\u308B","closeRight":"\u53F3\u5074\u306E\u30BF\u30D6\u3092\u9589\u3058\u308B","back":"\u623B\u308B","forward":"\u30D5\u30A9\u30EF\u30FC\u30C9","openLinkNewTab":"\u30EA\u30F3\u30AF\u3092\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F","openLinkExternal":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u30EA\u30F3\u30AF\u3092\u958B\u304F","openExternal":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u958B\u304F","openAllExternal":"\u30C7\u30D5\u30A9\u30EB\u30C8\u30D6\u30E9\u30A6\u30B6\u3067\u5168\u3066\u306E\u30BF\u30D6\u3092\u958B\u304F"},"home":{"tabTitle":"\u5BB6","title":"Cephable\u30D6\u30E9\u30A6\u30B6","tagline":"Cephable\u306F\u5225\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u904B\u8EE2\u3092\u4EE3\u884C\u3067\u304D\u307E\u3059\u3002","description":"Cephable\u306F\u3053\u3053\u3067\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u4EE3\u308F\u3063\u3066\u30A6\u30A7\u30D6\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3057\u307E\u3059\u3002\u3053\u308C\u306F\u666E\u6BB5\u304A\u4F7F\u3044\u306E\u30D6\u30E9\u30A6\u30B6\u3068\u306F\u72EC\u7ACB\u3057\u3066\u52D5\u4F5C\u3059\u308B\u305F\u3081\u3001\u81EA\u52D5\u5316\u51E6\u7406\u304C\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u5B9F\u884C\u3055\u308C\u3066\u3044\u308B\u9593\u3082\u3001\u901A\u5E38\u306E\u30BF\u30D6\u3001\u30ED\u30B0\u30A4\u30F3\u3001\u30D6\u30E9\u30A6\u30B8\u30F3\u30B0\u306F\u5F71\u97FF\u3092\u53D7\u3051\u307E\u305B\u3093\u3002","searchPlaceholder":"Google\u3067\u691C\u7D22\u3059\u308B\u304B\u3001URL\u3092\u5165\u529B\u3057\u3066\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002","go":"\u884C\u304F","features":{"separate":{"title":"\u81EA\u52D5\u3067\u52D5\u4F5C\u3057\u307E\u3059","description":"\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D6\u30E9\u30A6\u30B6\u3068\u306F\u5225\u306B\u4FDD\u5B58\u3055\u308C\u308B\u305F\u3081\u3001\u81EA\u52D5\u5316\u306B\u3088\u3063\u3066\u500B\u4EBA\u306E\u30D6\u30E9\u30A6\u30B8\u30F3\u30B0\u304C\u59A8\u3052\u3089\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"automate":{"title":"\u81EA\u52D5\u5316\u5411\u3051\u306B\u8A2D\u8A08\u3055\u308C\u3066\u3044\u307E\u3059","description":"Cephable\u3092\u4F7F\u3048\u3070\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30DA\u30FC\u30B8\u3092\u958B\u3044\u305F\u308A\u3001\u30D5\u30A9\u30FC\u30E0\u306B\u5165\u529B\u3057\u305F\u308A\u3001\u60C5\u5831\u3092\u53CE\u96C6\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"handoff":{"title":"\u3044\u3064\u3067\u3082\u5F15\u304D\u7D99\u304E","description":"\u64CD\u4F5C\u3092\u5F15\u304D\u7D99\u304E\u305F\u3044\u3068\u304D\u306F\u3044\u3064\u3067\u3082\u3001\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D6\u30E9\u30A6\u30B6\u3067\u4EFB\u610F\u306E\u30DA\u30FC\u30B8\u3092\u958B\u3044\u3066\u304F\u3060\u3055\u3044\u3002"}}}},"scheduledTasks":{"title":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u3001\u6307\u5B9A\u3057\u305F\u6642\u9593\u306B\u5B9F\u884C\u3055\u308C\u308B\u81EA\u52D5\u5316\u6A5F\u80FD\u3002","viewAll":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u3059\u3079\u3066\u306E\u8868\u793A","empty":"\u30D1\u30CD\u30EB\u304B\u3089\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u8A2D\u5B9A\u3059\u308B\u3068\u3001\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"subtitleRemote":"\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u308A\u5165\u529B\u3057\u305F\u308A\u3059\u308B\u3059\u3079\u3066\u306E\u64CD\u4F5C\u3092\u3001\u3042\u306A\u305F\u306E\u6307\u793A\u306B\u5F93\u3063\u3066\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002","suggestions":{"viewMore":"\u3082\u3063\u3068\u898B\u308B","viewMoreTooltip":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u3059\u3079\u3066\u95B2\u89A7\u3059\u308B","dialogTitle":"\u3059\u3079\u3066\u306E\u63D0\u6848","dialogDescription":"\u958B\u59CB\u70B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9078\u629E\u3057\u305F\u5185\u5BB9\u306F\u30B3\u30F3\u30DD\u30FC\u30B6\u30FC\u306B\u53D6\u308A\u8FBC\u307E\u308C\u308B\u306E\u3067\u3001\u5B9F\u884C\u524D\u306B\u7DE8\u96C6\u3067\u304D\u307E\u3059\u3002","rotationLabel":"\u63D0\u6848\u3055\u308C\u305F\u30D7\u30ED\u30F3\u30D7\u30C8","empty":"\u63D0\u6848\u306F\u3042\u308A\u307E\u305B\u3093\u3002"}},"noResults":"\u691C\u7D22\u7D50\u679C\u306A\u3057","noResultsSearch":"\u691C\u7D22\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002","interrupted":"\u4E2D\u65AD","aiHistory":{"title":"AI\u306E\u6B74\u53F2","description":"\u30ED\u30FC\u30AB\u30EBAI\u3068\u306E\u4F1A\u8A71\u5C65\u6B74\u3092\u8868\u793A\u3001\u691C\u7D22\u3001\u7BA1\u7406\u3067\u304D\u307E\u3059\u3002","empty":{"title":"AI\u5C65\u6B74\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093","description":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u30BF\u30B9\u30AF\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001AI\u3068\u306E\u4F1A\u8A71\u5C65\u6B74\u304C\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"search":{"placeholder":"\u4F1A\u8A71\u3092\u691C\u7D22..."},"pagination":{"range":"{{start}}\uFF5E{{end}}\u3092\u8868\u793A\u4E2D\uFF08\u5168{{total}}\uFF09"},"source":{"create":"\u4F5C\u6210\u3059\u308B","automate":"\u81EA\u52D5\u5316\u3059\u308B"},"workflow":{"plan":"\u30D7\u30E9\u30F3","steps":"\u624B\u9806","files":"\u30D5\u30A1\u30A4\u30EB","folders":"\u30D5\u30A9\u30EB\u30C0\u30FC","interruptedNotice":"\u4F5C\u696D\u306E\u6D41\u308C\u304C\u4E2D\u65AD\u3055\u308C\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"trace":{"thinking":"\u8003\u3048","toolCalls":"\u30C4\u30FC\u30EB\u547C\u3073\u51FA\u3057","roles":{"tool":"\u30C4\u30FC\u30EB\u7D50\u679C"},"thought":"\u8003\u3048","action":"\u30A2\u30AF\u30B7\u30E7\u30F3","parameters":"\u30D1\u30E9\u30E1\u30FC\u30BF","result":"\u7D50\u679C","reply":"\u3042\u306A\u305F\u306F\u8FD4\u4FE1\u3057\u307E\u3057\u305F","sources":"\u60C5\u5831\u6E90"},"task":{"instructions":"\u8AAC\u660E\u66F8","language":"\u8A00\u8A9E","types":{"generate":"\u751F\u6210\u3059\u308B","rewrite":"\u30EA\u30E9\u30A4\u30C8","translate":"\u7FFB\u8A33\u3059\u308B","summarize":"\u8981\u7D04\u3059\u308B"}},"session":{"messages":"\u30E1\u30C3\u30BB\u30FC\u30B8","deleteTitle":"\u4F1A\u8A71\u3092\u524A\u9664","deleteDescription":"\u3053\u306E\u4F1A\u8A71\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","deleteConfirm":"\u6D88\u53BB","deleteCancel":"\u30AD\u30E3\u30F3\u30BB\u30EB"},"clear":{"title":"AI\u5C65\u6B74\u3092\u30AF\u30EA\u30A2","description":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u3001\u30ED\u30FC\u30AB\u30EB\u306B\u4FDD\u5B58\u3055\u308C\u3066\u3044\u308BAI\u3068\u306E\u4F1A\u8A71\u5C65\u6B74\u3092\u3059\u3079\u3066\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002","confirm":{"title":"AI\u5C65\u6B74\u3092\u30AF\u30EA\u30A2","description":"AI\u3068\u306E\u4F1A\u8A71\u5C65\u6B74\u3092\u3059\u3079\u3066\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002","confirm":"\u3059\u3079\u3066\u30AF\u30EA\u30A2","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB"},"success":"AI\u5C65\u6B74\u306E\u6D88\u53BB\u306B\u6210\u529F\u3057\u307E\u3057\u305F\u3002","error":"AI\u5C65\u6B74\u306E\u6D88\u53BB\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002"},"export":{"title":"\u8F38\u51FA","description":"AI\u3068\u306E\u4F1A\u8A71\u5C65\u6B74\u3092JSONL\u30D5\u30A1\u30A4\u30EB\u306B\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002","success":"AI\u5C65\u6B74\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u306B\u6210\u529F\u3057\u307E\u3057\u305F\u3002","error":"AI\u5C65\u6B74\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","session":{"title":"\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u5B9F\u884C","success":"\u5B9F\u884C\u7D50\u679C\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u306B\u6210\u529F\u3057\u307E\u3057\u305F\u3002","error":"\u4ECA\u56DE\u306E\u5B9F\u884C\u7D50\u679C\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002"}},"retention":{"note":"\u6700\u65B0\u306E\u4F1A\u8A71\u3092{{count}}\u4EF6\u4FDD\u5B58\u3057\u307E\u3059\u3002\u304A\u6C17\u306B\u5165\u308A\u306F\u5E38\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","label":"\u4FDD\u3064"},"filter":{"label":"\u30BF\u30A4\u30D7\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0","all":"\u5168\u7A2E\u985E"},"favorites":{"title":"\u304A\u6C17\u306B\u5165\u308A","add":"\u304A\u6C17\u306B\u5165\u308A\u306B\u8FFD\u52A0","remove":"\u304A\u6C17\u306B\u5165\u308A\u304B\u3089\u524A\u9664"},"select":{"selectOne":"\u4F1A\u8A71\u3092\u9078\u629E","selected":"{{count}} \u500B\u304C\u9078\u629E\u3055\u308C\u307E\u3057\u305F","deleteSelected":"\u9078\u629E\u3057\u305F\u9805\u76EE\u3092\u524A\u9664","clear":"\u30AF\u30EA\u30A2","deleteTitle":"\u9078\u629E\u3057\u305F\u4F1A\u8A71\u3092\u524A\u9664\u3059\u308B","deleteDescription":"\u9078\u629E\u3057\u305F\u4F1A\u8A71 {{count}} \u4EF6\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F\u3053\u306E\u64CD\u4F5C\u306F\u5143\u306B\u623B\u305B\u307E\u305B\u3093\u3002"},"copy":{"label":"\u30B3\u30D4\u30FC","success":"\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u3078\u306E\u30B3\u30D4\u30FC\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002"},"live":"\u30E9\u30A4\u30D6","keychain":{"continue":"\u7D9A\u304F","title":"AI\u5C65\u6B74\u3092\u4FDD\u8B77\u3059\u308B","message":"Cephable\u306F\u3001\u3053\u306EMac\u4E0A\u3067\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u5C65\u6B74\u3092\u542B\u3080AI\u5C65\u6B74\u3092\u6697\u53F7\u5316\u3057\u307E\u3059\u3002","detail":"\u6B21\u306BmacOS\u306F\u300CCephable Safe Storage\u300D\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3059\u308B\u304B\u3069\u3046\u304B\u3092\u5C0B\u306D\u307E\u3059\u3002\u3053\u3053\u306B\u306F\u6697\u53F7\u5316\u30AD\u30FC\u306E\u307F\u304C\u542B\u307E\u308C\u3066\u304A\u308A\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3084\u30BF\u30B9\u30AF\u306E\u5185\u5BB9\u306F\u542B\u307E\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u300C\u5E38\u306B\u8A31\u53EF\u300D\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u6697\u53F7\u5316\u3055\u308C\u305F\u5C65\u6B74\u3092\u518D\u5EA6\u78BA\u8A8D\u3055\u308C\u308B\u3053\u3068\u306A\u304F\u5229\u7528\u3067\u304D\u307E\u3059\u3002\u300C\u8A31\u53EF\u300D\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u4ECA\u56DE\u306FCephable\u304C\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u304C\u3001macOS\u306F\u4ECA\u5F8C\u306E\u8D77\u52D5\u6642\u306B\u518D\u5EA6\u30A2\u30AF\u30BB\u30B9\u3092\u6C42\u3081\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002"},"rename":{"title":"\u540D\u524D\u3092\u5909\u66F4\u3059\u308B","label":"\u4F1A\u8A71\u306E\u30BF\u30A4\u30C8\u30EB"}},"uses":"\u7528\u9014: {{value}}","skills":{"intro":"Skills teach the Cephable assistant how to do a specific task well. Create your own or import one, then use it in the panel by typing / or @.","create":"Create skill","importFolder":"Import folder","importZip":"Import .zip","importError":"Could not import the skill.","enable":"Enable","openFolder":"Open folder","deleteConfirm":"Delete?","emptyTitle":"No skills yet","emptyBody":"Create your first skill or import one to get started.","sharingComingSoon":"Sharing skills with your organization and a skills marketplace are coming soon.","source":{"user":"Created by you","imported":"Imported","organization":"Organization","marketplace":"Marketplace"},"bestPractices":{"title":"Tips for great skills","description":"Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.","focused":"Keep instructions short and focused on one job. Use numbered steps in the order they should happen.","examples":"Add a short example of a request the skill handles and the ideal result.","keywords":"Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.","trust":"Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer.","activation":"Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."},"editor":{"nameLabel":"Name","namePlaceholder":"e.g. release-notes","nameHelp":"Lowercase letters, numbers, and hyphens only.","descriptionLabel":"Description","descriptionPlaceholder":"What the skill does and when the assistant should use it.","descriptionHelp":"This is how the assistant decides when to use the skill. Be specific.","keywordsLabel":"Keywords (optional)","keywordsPlaceholder":"comma, separated, words","keywordsHelp":"Extra words that should trigger this skill (brand names, aliases, file types).","instructionsLabel":"Instructions (SKILL.md)","instructionsPlaceholder":"Step-by-step instructions for the assistant. Leave blank to start from a template.","save":"Save changes","create":"Create skill","saveError":"Could not save the skill.","activationLabel":"When should the assistant use this?"},"picker":{"title":"Skills","empty":"No matching skills","hint":"Type to filter skills"},"contextMenuItem":"Skill\u2026","chipRemove":"Remove skill","attached":"Attached skills","inUse":"Using skills:","section":{"title":"AI Skills","description":"Reusable instructions that teach the Cephable assistant how to do your tasks. Use them in the panel by typing / or @."},"createDescription":"Build a reusable skill from scratch or a template.","import":"Import a skill","importDescription":"Add a skill from a folder or a .zip file.","copy":"Copy an existing skill","copyDescription":"Start from a copy of one of your skills.","copyShort":"Copy","editTitle":"Edit skill","newTitle":"New skill","templates":{"title":"Start from a template","blank":{"title":"Blank","summary":"Start from an empty template."},"navigateApp":{"title":"Navigate an app (click in steps)","summary":"Tell Cephable where to click, step by step, to get through an app."},"writeText":{"title":"Write or insert text","summary":"Draft text a certain way and type it where I am working."},"fillForm":{"title":"Fill out a form","summary":"Fill a form field by field from details I give you."},"summarizeDoc":{"title":"Summarize a document","summary":"Read a file and give a short, structured summary."},"start":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u304B\u3089\u59CB\u3081\u307E\u3057\u3087\u3046\u2026","applied":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u304C\u9069\u7528\u3055\u308C\u307E\u3057\u305F\u3002\u4EE5\u4E0B\u306E\u8A73\u7D30\u3092\u7DE8\u96C6\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"activation":{"label":"Activation","auto":"Automatically when it fits","autoShort":"Auto","autoDescription":"The assistant picks this skill on its own when your request matches \u2014 and you can still choose it with / or @.","manual":"Only when I choose it","manualShort":"Manual","manualDescription":"The assistant never picks this on its own \u2014 it runs only when you attach it with / or @."},"mode":{"label":"How this skill is used","off":"Off","offTooltip":"Off \u2014 this skill is never used or shown in the picker."},"viewDetails":"View details","files":{"label":"Reference files & scripts","help":"Add files your skill uses \u2014 the assistant reads references and can run scripts. Mention them in your instructions above.","empty":"No files added yet.","add":"Add file\u2026","remove":"Remove file","addError":"Could not add the file.","kind":{"reference":"Reference file","script":"Script","asset":"Asset","referenceShort":"Reference","scriptShort":"Script","assetShort":"Asset"},"open":"Open file"},"scriptsSetting":{"label":"Let skills run scripts","help":"When off, the assistant will not run any script bundled in a skill on your computer (it can still follow instructions and read reference files). You always approve each script before it runs."},"capability":{"script":{"label":"Runs scripts","tooltip":"This skill can run programs on your computer \u2014 you approve each one before it runs. Only use skills you trust."},"reference":{"label":"Uses reference files","tooltip":"This skill includes reference files the assistant can read for detail. It does not run programs on your computer."},"basic":{"label":"Instructions only","tooltip":"This skill just guides the assistant with instructions. It does not read extra files or run programs on your computer."},"alsoReferences":"It also includes reference files it reads.","scriptsOff":"Script running is currently turned off in settings."},"teach":{"action":"\u30B9\u30AD\u30EB\u3068\u3057\u3066\u6559\u3048\u308B","generating":"\u6559\u80B2\u2026","title":"\u30B9\u30AD\u30EB\u3092\u6559\u3048\u308B","heading":"Cephable\u306B\u65B0\u3057\u3044\u30B9\u30AD\u30EB\u3092\u6559\u3048\u308B","subheading":"Cephable\u306F\u3001\u3042\u306A\u305F\u304C\u4ECA\u884C\u3063\u305F\u64CD\u4F5C\u3092\u518D\u5229\u7528\u53EF\u80FD\u306A\u30B9\u30AD\u30EB\u306B\u5909\u63DB\u3057\u307E\u3057\u305F\u3002\u4EE5\u4E0B\u3067\u5185\u5BB9\u3092\u78BA\u8A8D\u30FB\u8ABF\u6574\u3057\u3001\u4FDD\u5B58\u3059\u308C\u3070\u3001\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3042\u306A\u305F\u3060\u3051\u3067\u306A\u304F\u3001\u3042\u306A\u305F\u304C\u5171\u6709\u3057\u305F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u3082\u540C\u3058\u3088\u3046\u306B\u64CD\u4F5C\u3092\u5B9F\u884C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","fromRun":"\u57FA\u3068\u306A\u308B\u3082\u306E: {{title}}","filesTitle":"\u542B\u3081\u308B\u30D5\u30A1\u30A4\u30EB","filesHelp":"\u3053\u308C\u3089\u306F\u3001\u30B9\u30AD\u30EB\u3092\u518D\u73FE\u53EF\u80FD\u306B\u3059\u308B\u305F\u3081\u306B\u3001\u3042\u306A\u305F\u306E\u5B9F\u884C\u6642\u306B\u751F\u6210\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u3067\u3059\u3002\u30B9\u30AD\u30EB\u3068\u5171\u306B\u5F15\u304D\u7D99\u3050\u3079\u304D\u30D5\u30A1\u30A4\u30EB\u306F\u6B8B\u3057\u3001\u4ECA\u56DE\u306E\u5B9F\u884C\u30C7\u30FC\u30BF\u306E\u307F\u3092\u542B\u3080\u30D5\u30A1\u30A4\u30EB\u306F\u3059\u3079\u3066\u7121\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","detailsTitle":"\u30B9\u30AD\u30EB\u8A73\u7D30","addFile":"\u5225\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u8FFD\u52A0\u2026","include":{"add":"\u542B\u3080","on":"\u542B\u307E\u308C\u3066\u3044\u307E\u3059 \u2014 \u30AF\u30EA\u30C3\u30AF\u3057\u3066\u524A\u9664","off":"\u9664\u5916 \u2014 \u30AF\u30EA\u30C3\u30AF\u3057\u3066\u542B\u3081\u308B"},"included":"\u542B\u307E\u308C\u308B","origin":{"attached":"\u3042\u306A\u305F\u304C\u63D0\u4F9B\u3057\u305F\u3082\u306E","template":"\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8","generated":"\u751F\u7523\u3055\u308C\u305F","observed":"\u96C6\u307E\u3063\u305F","added":"\u3042\u306A\u305F\u304C\u8FFD\u52A0\u3057\u307E\u3057\u305F"},"saved":"\u30B9\u30AD\u30EB\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002\u4EE5\u4E0B\u304B\u3089\u6709\u52B9\u5316\u3057\u3066\u5171\u6709\u3067\u304D\u307E\u3059\u3002","error":"\u4ECA\u56DE\u306E\u5B9F\u884C\u3067\u306F\u30B9\u30AD\u30EB\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","filesError":"\u53C2\u7167\u30D5\u30A1\u30A4\u30EB\u306E\u4E00\u90E8\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F: {{files}}","notFound":"\u3053\u306E\u8349\u7A3F\u306F\u73FE\u5728\u5165\u624B\u3067\u304D\u307E\u305B\u3093\u3002","backToSkills":"\u30B9\u30AD\u30EB\u306B\u623B\u308B"},"actions":"\u30B9\u30AD\u30EB\u30A2\u30AF\u30B7\u30E7\u30F3","body":{"empty":"\u307E\u3060\u8AAC\u660E\u6587\u306F\u8FFD\u52A0\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","label":"\u624B\u9806\u66F8\uFF08SKILL.md\uFF09"},"importTooltip":"\u30D5\u30A9\u30EB\u30C0\u307E\u305F\u306F.zip\u30D5\u30A1\u30A4\u30EB\u304B\u3089\u30B9\u30AD\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B","install":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB","keywords":{"label":"\u30AD\u30FC\u30EF\u30FC\u30C9"},"marketplace":{"description":"\u3042\u306A\u305F\u306E\u691C\u7D22\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u304C\u5171\u6709\u3059\u308B\u516C\u958B\u30B9\u30AD\u30EB\u3002","title":"\u516C\u5171\u5E02\u5834\u304B\u3089"},"share":"\u5171\u6709","shareError":"\u4F55\u304B\u304C\u304A\u304B\u3057\u304F\u306A\u308A\u307E\u3057\u305F\u3002","sync":"\u540C\u671F","updateAvailable":"\u3088\u308A\u65B0\u3057\u3044\u30D0\u30FC\u30B8\u30E7\u30F3\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059\u3002","searchPlaceholder":"\u691C\u7D22\u30B9\u30AD\u30EB\u2026","createTooltip":"\u4F5C\u696D\u306E\u69D8\u5B50\u3092\u9332\u753B\u3059\u308B\u304B\u3001\u30B9\u30AD\u30EB\u3092\u81EA\u5206\u3067\u66F8\u304D\u51FA\u3057\u3066\u304F\u3060\u3055\u3044\u3002","createRecord":"\u79C1\u304C\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u8A18\u9332\u3059\u308B","createScratch":"\u30BC\u30ED\u304B\u3089\u59CB\u3081\u308B"},"on":"\u306E\u4E0A","off":"\u30AA\u30D5","copied":"\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F","mcp":{"section":{"title":"\u30C4\u30FC\u30EB","description":"Cephable\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306B\u30C4\u30FC\u30EB\u3092\u8FFD\u52A0\u3059\u308B\u306B\u306F\u3001MCP\u30B5\u30FC\u30D0\u30FC\u3092\u63A5\u7D9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D1\u30CD\u30EB\u3067\u300C/\u300D\u307E\u305F\u306F\u300C@\u300D\u3092\u5165\u529B\u3057\u3066\u4F7F\u7528\u3057\u307E\u3059\u3002"},"addServer":"\u30B5\u30FC\u30D0\u30FC\u3092\u8FFD\u52A0\u3059\u308B","addServerDescription":"MCP\u30B5\u30FC\u30D0\u30FC\uFF08\u30B3\u30DE\u30F3\u30C9\u3001HTTP\u3001\u307E\u305F\u306FSSE\uFF09\u3092\u63A5\u7D9A\u3057\u3066\u3001\u305D\u306E\u30C4\u30FC\u30EB\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002","editTitle":"\u30B5\u30FC\u30D0\u30FC\u3092\u7DE8\u96C6","newTitle":"\u30B5\u30FC\u30D0\u30FC\u3092\u8FFD\u52A0","deleteConfirm":"\u6D88\u53BB\uFF1F","contextMenuItem":"\u30C4\u30FC\u30EB\u2026","chipRemove":"\u30C4\u30FC\u30EB\u3092\u53D6\u308A\u5916\u3057\u307E\u3059","inUse":"\u30C4\u30FC\u30EB\u3092\u4F7F\u7528\u3059\u308B:","picker":{"title":"\u30B9\u30AD\u30EB\u3068\u30C4\u30FC\u30EB"},"mode":{"label":"\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u306E\u4F7F\u3044\u65B9","off":"\u30AA\u30D5","offTooltip":"\u30AA\u30D5 \u2014 \u3053\u306E\u30B5\u30FC\u30D0\u30FC\u306F\u4F7F\u7528\u3055\u308C\u305A\u3001\u9078\u629E\u753B\u9762\u306B\u3082\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002"},"activation":{"auto":"\u9069\u5408\u3059\u308B\u3068\u81EA\u52D5\u7684\u306B","autoShort":"\u81EA\u52D5","autoDescription":"\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u4E00\u81F4\u3059\u308B\u3068\u3001\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306F\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u306E\u30C4\u30FC\u30EB\u3092\u81EA\u52D5\u7684\u306B\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002\u307E\u305F\u3001/ \u307E\u305F\u306F @ \u3092\u4F7F\u7528\u3057\u3066\u9078\u629E\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002","manual":"\u79C1\u304C\u9078\u3093\u3060\u6642\u3060\u3051","manualShort":"\u30DE\u30CB\u30E5\u30A2\u30EB","manualDescription":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306F\u305D\u308C\u3092\u81EA\u52D5\u7684\u306B\u8AAD\u307F\u8FBC\u3080\u3053\u3068\u306F\u306A\u304F\u3001/ \u307E\u305F\u306F @ \u3067\u30A2\u30BF\u30C3\u30C1\u3057\u305F\u5834\u5408\u306B\u306E\u307F\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002"},"transport":{"stdio":"\u30B3\u30DE\u30F3\u30C9\uFF08stdio\uFF09","http":"HTTP","sse":"SSE"},"auth":{"none":"\u306A\u3057","apiKey":"API\u30AD\u30FC","headers":"\u30AB\u30B9\u30BF\u30E0\u30D8\u30C3\u30C0\u30FC","oauth":"OAuth"},"requireApproval":{"short":"\u901A\u8A71\u3092\u627F\u8A8D\u3059\u308B","tooltip":"\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u304B\u3089\u306E\u3059\u3079\u3066\u306E\u30C4\u30FC\u30EB\u547C\u3073\u51FA\u3057\u306F\u3001\u5B9F\u884C\u524D\u306B\u627F\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"},"oauth":{"connect":"\u63A5\u7D9A\u3059\u308B","reconnect":"\u518D\u63A5\u7D9A","disconnect":"\u5207\u65AD","connecting":"\u30D6\u30E9\u30A6\u30B6\u3092\u5F85\u3063\u3066\u3044\u307E\u3059\u2026","connected":"\u63A5\u7D9A\u6E08\u307F","notConnected":"\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093","error":"\u8A8D\u8A3C\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002"},"status":{"ok":"\u63A5\u7D9A\u6E08\u307F","error":"\u5931\u6557\u3057\u305F","unknown":"\u30C6\u30B9\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093","testing":"\u63A5\u7D9A\u4E2D\u2026","toolsFound":"{{count}}\u500B\u306E\u30C4\u30FC\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u3057\u305F","label":"\u7E4B\u304C\u308A","toolsEnabledOf":"{{count}}\u500B\u306E\u30C4\u30FC\u30EB\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059"},"editor":{"nameLabel":"\u540D\u524D","namePlaceholder":"\u4F8B\uFF1A\u30D5\u30A1\u30A4\u30EB\u30B7\u30B9\u30C6\u30E0","nameHelp":"\u5C0F\u6587\u5B57\u3001\u6570\u5B57\u3001\u30CF\u30A4\u30D5\u30F3\u306E\u307F\u4F7F\u7528\u53EF\u80FD\u3067\u3059\u3002","descriptionLabel":"\u8AAC\u660E","descriptionPlaceholder":"\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u304C\u63D0\u4F9B\u3059\u308B\u6A5F\u80FD\u3068\u3001\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u305D\u308C\u3092\u4F7F\u7528\u3059\u3079\u304D\u30BF\u30A4\u30DF\u30F3\u30B0\u3002","descriptionHelp":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u3064\u305D\u308C\u3092\u4F7F\u7528\u3059\u308B\u304B\u306F\u3001\u3053\u306E\u3088\u3046\u306B\u3057\u3066\u5224\u65AD\u3055\u308C\u307E\u3059\u3002\u5177\u4F53\u7684\u306B\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","transportLabel":"\u63A5\u7D9A\u30BF\u30A4\u30D7","commandLabel":"\u6307\u793A","argsLabel":"\u8B70\u8AD6","argsHelp":"\u30B3\u30DE\u30F3\u30C9\u306B\u6E21\u3055\u308C\u308B\u5F15\u6570\u306F\u3001\u30B9\u30DA\u30FC\u30B9\u3067\u533A\u5207\u3089\u308C\u3066\u3044\u307E\u3059\u3002","envLabel":"\u74B0\u5883\u5909\u6570","envHelp":"1\u884C\u306B1\u3064\u306E\u30AD\u30FC\u3068\u5024\u3092\u8A18\u8FF0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","urlLabel":"\u30B5\u30FC\u30D0\u30FCURL","authLabel":"\u8A8D\u8A3C","apiKeyHeaderLabel":"\u30D8\u30C3\u30C0\u30FC\u540D","apiKeyPrefixLabel":"\u5024\u63A5\u982D\u8F9E","apiKeyLabel":"API\u30AD\u30FC","secretSet":"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\uFF08\u4FDD\u5B58\u6E08\u307F - \u7F6E\u304D\u63DB\u3048\u308B\u30BF\u30A4\u30D7\uFF09","oauthClientIdLabel":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8ID","oauthClientIdHelp":"\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u306F\u81EA\u52D5\u767B\u9332\u3055\u308C\u308B\u305F\u3081\u3001\u7A7A\u6B04\u306E\u307E\u307E\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","oauthClientSecretLabel":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8","oauthScopesLabel":"\u30B9\u30B3\u30FC\u30D7","oauthScopesHelp":"\u30B9\u30DA\u30FC\u30B9\u533A\u5207\u308A\u3067\u30B9\u30B3\u30FC\u30D7\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002","oauthDiscoveryLabel":"\u767A\u898BURL\uFF08\u4EFB\u610F\uFF09","oauthAuthUrlLabel":"\u8A8D\u8A3CURL","oauthTokenUrlLabel":"\u30C8\u30FC\u30AF\u30F3URL","redirectLabel":"\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8URI","redirectHelp":"\u307B\u3068\u3093\u3069\u306E\u30B5\u30FC\u30D0\u30FC\u306F\u81EA\u52D5\u7684\u306B\u767B\u9332\u3055\u308C\u307E\u3059\u3002\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8ID\u3092\u7A7A\u6B04\u306E\u307E\u307E\u306B\u3057\u3066\u300C\u63A5\u7D9A\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u304B\u3089\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8URI\u3092\u6C42\u3081\u3089\u308C\u305F\u5834\u5408\u306F\u3001\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u304C\u53D7\u3051\u5165\u308C\u308B\u30B3\u30FC\u30EB\u30D0\u30C3\u30AF\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u3001\u4EE5\u4E0B\u306E\u6B04\u306BURI\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002","headersHelp":"\u30AB\u30B9\u30BF\u30E0\u30D8\u30C3\u30C0\u30FC\u8A8D\u8A3C\u306F\u3053\u3053\u3067\u306F\u307E\u3060\u7DE8\u96C6\u3067\u304D\u307E\u305B\u3093\u3002\u8A8D\u8A3C\u6E08\u307F\u30B5\u30FC\u30D0\u30FC\u306B\u306FAPI\u30AD\u30FC\u307E\u305F\u306FOAuth\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002","activationLabel":"\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306F\u3044\u3064\u3053\u308C\u3092\u4F7F\u3046\u3079\u304D\u3067\u3059\u304B\uFF1F","requireApprovalLabel":"\u30C4\u30FC\u30EB\u547C\u3073\u51FA\u3057\u3054\u3068\u306B\u627F\u8A8D\u304C\u5FC5\u8981","requireApprovalHelp":"\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u304B\u3089\u306E\u3059\u3079\u3066\u306E\u30C4\u30FC\u30EB\u547C\u3073\u51FA\u3057\u306F\u3001\u5B9F\u884C\u524D\u306B\u627F\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u30C7\u30FC\u30BF\u5909\u66F4\u3084\u8CBB\u7528\u304C\u767A\u751F\u3059\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u30B5\u30FC\u30D0\u30FC\u306B\u63A8\u5968\u3055\u308C\u307E\u3059\u3002","testConnection":"\u63A5\u7D9A\u30C6\u30B9\u30C8","save":"\u5909\u66F4\u3092\u4FDD\u5B58\u3059\u308B","create":"\u30B5\u30FC\u30D0\u30FC\u3092\u8FFD\u52A0","saveError":"\u30B5\u30FC\u30D0\u30FC\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","oauthDiscoveryHelp":"\u30AA\u30D7\u30B7\u30E7\u30F3 \u2014 \u30B5\u30FC\u30D0\u30FC\u72EC\u81EA\u306E\u691C\u51FA\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F7F\u7528\u3059\u308B\u5834\u5408\u306F\u3001\u7A7A\u6B04\u306E\u307E\u307E\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","oauthDiscoveryLabelShort":"\u767A\u898BURL","oauthOnDevice":"\u5404\u30E1\u30F3\u30D0\u30FC\u306F\u3001\u3053\u306E\u30B3\u30CD\u30AF\u30BF\u3092\u6709\u52B9\u306B\u3059\u308B\u969B\u306B\u3001\u5404\u81EA\u306E\u30C7\u30D0\u30A4\u30B9\u3067OAuth\u30B5\u30A4\u30F3\u30A4\u30F3\u3092\u5B8C\u4E86\u3057\u307E\u3059\u3002","secretsOnDevice":"\u5404\u30E1\u30F3\u30D0\u30FC\u306F\u3001\u3053\u306E\u30B3\u30CD\u30AF\u30BF\u3092\u6709\u52B9\u306B\u3059\u308B\u969B\u306B\u3001\u5404\u81EA\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u72EC\u81EA\u306EAPI\u30AD\u30FC\u3092\u5165\u529B\u3057\u307E\u3059\u3002\u30AD\u30FC\u306F\u3053\u3053\u306B\u4FDD\u5B58\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","noPermissions":"\u3053\u306E\u30B5\u30FC\u30D0\u30FC\u306F{{provenance}}\u306E\u767B\u9332\u6E08\u307F\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059\u3002\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u304B\u3001\u300C\u63A5\u7D9A\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u4F7F\u7528\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002","altOptions":{"copy":"\u81EA\u5206\u306E\u8A8D\u8A3C\u60C5\u5831\u3092\u4F7F\u7528\u3059\u308B","organization":"\u30BB\u30D5\u30A1\u30D6\u30EB\u30DD\u30FC\u30BF\u30EB"},"copyName":"{{name}}-\u30B3\u30D4\u30FC","redirectTypeLabel":"\u30B3\u30FC\u30EB\u30D0\u30C3\u30AF\u30BF\u30A4\u30D7","redirectType":{"appCallback":"\u30A6\u30A7\u30D6\uFF08https\uFF09","localhost":"\u30ED\u30FC\u30AB\u30EB\u30DB\u30B9\u30C8"},"redirectPortLabel":"\u30DD\u30FC\u30C8","redirectNotes":{"appCallback":"\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B\u3068\u30D6\u30E9\u30A6\u30B6\u304C\u958B\u304D\u3001\u305D\u306E\u5F8C\u81EA\u52D5\u7684\u306BCephable\u30A2\u30D7\u30EA\u306B\u5236\u5FA1\u304C\u623B\u3055\u308C\u307E\u3059\u3002","localhost":"\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B\u3068\u30D6\u30E9\u30A6\u30B6\u304C\u958B\u304D\u3001\u3053\u306E\u30DD\u30FC\u30C8\u3092\u4ECB\u3057\u3066Cephable\u306B\u623B\u308A\u307E\u3059\u3002\u3053\u306E\u30DD\u30FC\u30C8\u306F\u30B5\u30A4\u30F3\u30A4\u30F3\u3057\u3066\u3044\u308B\u9593\u306E\u307F\u3001\u304B\u3064\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306E\u307F\u958B\u304D\u307E\u3059\u3002"}},"actions":"\u30B5\u30FC\u30D0\u30FC\u30A2\u30AF\u30B7\u30E7\u30F3","marketplace":{"description":"\u691C\u7D22\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u304C\u5171\u6709\u3059\u308B\u516C\u958B\u30B3\u30CD\u30AF\u30BF\u3002","title":"\u516C\u5171\u5E02\u5834\u304B\u3089"},"share":"\u5171\u6709","shareError":"\u4F55\u304B\u304C\u304A\u304B\u3057\u304F\u306A\u308A\u307E\u3057\u305F\u3002","sync":"\u540C\u671F","tools":{"allToolsLabel":"\u3059\u3079\u3066\u306E\u30C4\u30FC\u30EB","contextLabel":"\u6587\u8108","disableAll":"\u3059\u3079\u3066\u7121\u52B9\u306B\u3059\u308B","empty":"\u307E\u3060\u30C4\u30FC\u30EB\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u63A5\u7D9A\u3092\u30C6\u30B9\u30C8\u3057\u3066\u898B\u3064\u3051\u3066\u304F\u3060\u3055\u3044\u3002","enableAll":"\u3059\u3079\u3066\u6709\u52B9\u306B\u3059\u308B","help":"\u4E0D\u8981\u306A\u30C4\u30FC\u30EB\u306F\u30AA\u30D5\u306B\u3057\u307E\u3057\u3087\u3046\u3002\u30C4\u30FC\u30EB\u306E\u6570\u3092\u6E1B\u3089\u305B\u3070\u3001\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u4F7F\u7528\u91CF\u304C\u6E1B\u308A\u3001\u52D5\u4F5C\u304C\u9AD8\u901F\u5316\u3055\u308C\u3001\u96C6\u4E2D\u529B\u3092\u7DAD\u6301\u3067\u304D\u307E\u3059\u3002","label":"\u30C4\u30FC\u30EB","searchPlaceholder":"\u691C\u7D22\u30C4\u30FC\u30EB\u2026","tokens":"~{{\u30C8\u30FC\u30AF\u30F3}}\u304C","tokensLabel":"\u30C8\u30FC\u30AF\u30F3","disableSelected":"\u9078\u629E\u3057\u305F\u9805\u76EE\u3092\u7121\u52B9\u306B\u3059\u308B","enableSelected":"\u9078\u629E\u3057\u305F\u9805\u76EE\u3092\u6709\u52B9\u306B\u3059\u308B"},"updateAvailable":"\u6700\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059\u3002","searchPlaceholder":"\u30B3\u30CD\u30AF\u30BF\u3092\u691C\u7D22\u2026"},"send":"\u9001\u4FE1","availableToInstall":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u53EF\u80FD","menu":{"expand":"\u30E1\u30CB\u30E5\u30FC\u3092\u5C55\u958B\u3059\u308B"},"no":"\u3044\u3044\u3048","rating":{"review":{"comment":"\u30B3\u30E1\u30F3\u30C8","commentPlaceholder":"\u6C17\u306B\u5165\u3063\u305F\u70B9\u3001\u6C17\u306B\u5165\u3089\u306A\u304B\u3063\u305F\u70B9\u306F\u4F55\u3067\u3059\u304B\uFF1F\u3069\u306E\u3088\u3046\u306B\u4F7F\u7528\u3057\u307E\u3057\u305F\u304B\uFF1F","optional":"\uFF08\u4EFB\u610F\uFF09","submit":"\u30EC\u30D3\u30E5\u30FC\u3092\u6295\u7A3F\u3059\u308B","subtitle":"<strong>{{subject}}</strong>\u306B\u95A2\u3059\u308B\u3042\u306A\u305F\u306E\u4F53\u9A13\u3092\u5171\u6709\u3057\u3066\u304F\u3060\u3055\u3044\u3002","title":"\u8A55\u4FA1\u3068\u30EC\u30D3\u30E5\u30FC","write":"\u30EC\u30D3\u30E5\u30FC\u3092\u66F8\u304F","yourRating":"\u3042\u306A\u305F\u306E\u8A55\u4FA1"},"summary":{"comments":"\u30B3\u30E1\u30F3\u30C8","installs":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB","noRatings":"\u307E\u3060\u8A55\u4FA1\u306F\u3042\u308A\u307E\u305B\u3093","openReview":"\u8A55\u4FA1\u3068\u30EC\u30D3\u30E5\u30FC","ratingCount":"{{count}}\u4EF6\u306E\u8A55\u4FA1"}},"workflow":{"feedback":{"includeDetails":"\u3053\u306E\u5B9F\u884C\u306E\u8A3A\u65AD\u306B\u5F79\u7ACB\u3064\u3088\u3046\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u540D\u3068\u30C4\u30FC\u30EB\u540D\u3092\u5171\u6709\u3057\u307E\u3059\u3002","negative":"\u89AA\u6307\u3092\u4E0B\u3052\u308B","placeholder":"\u3082\u3063\u3068\u8A73\u3057\u304F\u6559\u3048\u3066\u304F\u3060\u3055\u3044\uFF08\u4EFB\u610F\uFF09","positive":"\u3044\u3044\u305E","question":"\u3053\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306F\u3069\u3046\u3067\u3057\u305F\u304B\uFF1F","send":"\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3092\u9001\u4FE1","thanks":"\u3054\u610F\u898B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002","report":"\u554F\u984C\u3092\u5831\u544A\u3059\u308B"}},"yes":"\u306F\u3044","scheduledTasks":{"title":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF","description":"\u6307\u5B9A\u3057\u305F\u6642\u9593\u306B\u81EA\u52D5\u7684\u306B\u5B9F\u884C\u3055\u308C\u308B\u81EA\u52D5\u5316\u6A5F\u80FD\u3002\u3059\u3079\u3066\u306E\u30C7\u30FC\u30BF\u306F\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002","hint":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306F\u3001\u3053\u306E\u30A2\u30D7\u30EA\u304C\u5B9F\u884C\u3055\u308C\u3066\u3044\u308B\u9593\u306E\u307F\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u6642\u9593\u306BPC\u306E\u96FB\u6E90\u304C\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u308B\u304B\u3001\u30A2\u30D7\u30EA\u304C\u9589\u3058\u3066\u3044\u308B\u5834\u5408\u3001\u5B9F\u884C\u306F\u5931\u6557\u3068\u3057\u3066\u8A18\u9332\u3055\u308C\u3001\u5F8C\u3067\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002","new":"\u65B0\u3057\u3044\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF","scheduleButton":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB","create":{"title":"\u65B0\u3057\u3044\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF","description":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u306B\u57FA\u3065\u3044\u3066\u81EA\u52D5\u7684\u306B\u5B9F\u884C\u3055\u308C\u308B\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002","saved":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002"},"composer":{"placeholder":"Cephable \u304C\u884C\u3046\u3079\u304D\u3053\u3068\u3092\u8A18\u8FF0\u3057\u307E\u3059\u2026 / \u307E\u305F\u306F @ \u3092\u4F7F\u7528\u3057\u3066\u30B9\u30AD\u30EB\u3068\u30B3\u30CD\u30AF\u30BF\u3092\u8FFD\u52A0\u3057\u307E\u3059\u3002"},"runHistory":{"title":"\u5B9F\u884C\u5C65\u6B74","viewRun":"\u5B9F\u884C\u7D50\u679C\u3092\u898B\u308B","noOutput":"\u4FDD\u5B58\u3055\u308C\u305F\u51FA\u529B\u306F\u3042\u308A\u307E\u305B\u3093","resolution":{"ignored":"\u7121\u8996","rerun":"\u518D\u653E\u9001","rescheduled":"\u65E5\u7A0B\u5909\u66F4"}},"badge":{"scheduled":"\u4E88\u5B9A","recurring":"\u7E70\u308A\u8FD4\u3057"},"fromRun":{"scheduled":"\u3053\u306E\u5B9F\u884C\u306F\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306E\u4E00\u90E8\u3067\u3059: {{name}}","recurring":"\u3053\u306E\u5B9F\u884C\u306F\u3001\u5B9A\u671F\u7684\u306A\u30BF\u30B9\u30AF {{name}} \u306E\u4E00\u90E8\u3067\u3059\u3002","view":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u3092\u8868\u793A\u3059\u308B"},"search":{"placeholder":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u3092\u691C\u7D22\u3057\u307E\u3059..."},"filter":{"label":"\u30D5\u30A3\u30EB\u30BF\u30FC","all":"\u5168\u3066","enabled":"\u30A2\u30AF\u30C6\u30A3\u30D6","paused":"\u4E00\u6642\u505C\u6B62","missed":"\u898B\u9003\u3057\u305F"},"empty":{"title":"\u307E\u3060\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306F\u3042\u308A\u307E\u305B\u3093","description":"\u81EA\u52D5\u30E2\u30FC\u30C9\u307E\u305F\u306F\u81EA\u52D5\u5316\u30E2\u30FC\u30C9\u306E\u3068\u304D\u306B\u3001\u30D1\u30CD\u30EB\u5185\u306E\u9001\u4FE1\u30DC\u30BF\u30F3\u3092\u53F3\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u8A2D\u5B9A\u3057\u307E\u3059\u3002"},"pagination":{"range":"{{start}}\uFF5E{{end}} / {{total}}"},"status":{"running":"\u30E9\u30F3\u30CB\u30F3\u30B0","success":"\u6210\u529F\u3057\u305F","failed":"\u5931\u6557\u3057\u305F","missed":"\u898B\u9003\u3057\u305F","paused":"\u4E00\u6642\u505C\u6B62"},"summary":{"once":"{{datetime}}\u306B\u4E00\u5EA6","everyOne":"\u3059\u3079\u3066\u306E{{\u30E6\u30CB\u30C3\u30C8}}","everyN":"\u3059\u3079\u3066\u306E{{count}}\u5358\u4F4D","onDays":"{{\u65E5}}","onDayOfMonth":"{{day}}\u306E\u65E5","atTime":"{{time}}\u306B","unit":{"minute":"\u5206","minute_other":"\u5206","hour":"\u6642\u9593","hour_other":"\u55B6\u696D\u6642\u9593","day":"\u65E5","day_other":"\u65E5","week":"\u9031","week_other":"\u9031","month":"\u6708","month_other":"\u6570\u30F6\u6708"}},"card":{"nextRun":"\u6B21\u306E\u5B9F\u884C","runNow":"\u4ECA\u3059\u3050\u5B9F\u884C","pause":"\u4E00\u6642\u505C\u6B62","resume":"\u518D\u958B\u3059\u308B","enabledToggle":"\u3053\u306E\u30BF\u30B9\u30AF\u3092\u6709\u52B9\u5316\u307E\u305F\u306F\u4E00\u6642\u505C\u6B62\u3059\u308B","viewLastRun":"\u76F4\u8FD1\u306E\u6210\u529F\u5B9F\u884C\u3092\u8868\u793A\u3059\u308B","noSuccessfulRun":"\u307E\u3060\u5B9F\u884C\u306B\u6210\u529F\u3057\u3066\u3044\u307E\u305B\u3093"},"missed":{"runNow":"\u4ECA\u3059\u3050\u5B9F\u884C","reschedule":"\u65E5\u7A0B\u5909\u66F4","ignore":"\u7121\u8996\u3059\u308B"},"runNow":{"started":"\u73FE\u5728\u300C{{name}}\u300D\u3092\u5B9F\u884C\u4E2D\u3067\u3059\u3002","busy":"\u5225\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u65E2\u306B\u5B9F\u884C\u4E2D\u3067\u3059\u3002\u5B8C\u4E86\u3057\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"delete":{"title":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","description":"\u3053\u308C\u306B\u3088\u308A\u3001\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306F\u5B8C\u5168\u306B\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u5143\u306B\u623B\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"},"editor":{"kindLabel":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u30BF\u30A4\u30D7","once":"\u4E00\u5EA6","recurring":"\u7E70\u308A\u8FD4\u3057","runAt":"\u8D70\u308B","frequency":"\u7E70\u308A\u8FD4\u3057","every":"\u6BCE","interval":"\u9593\u9694","onDays":"\u3042\u308B\u65E5","dayOfMonth":"\u6708\u306E\u65E5","atTime":"\u305D\u306E\u6642","startAt":"\u958B\u59CB","endsOn":"\u7D42\u4E86\u65E5","units":"\u5358\u4F4D"},"edit":{"title":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u3092\u7DE8\u96C6\u3059\u308B","description":"\u5B9F\u884C\u524D\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u3068\u305D\u306E\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002","name":"\u540D\u524D","namePlaceholder":"\u3053\u306E\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306B\u540D\u524D\u3092\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044","prompt":"\u30D7\u30ED\u30F3\u30D7\u30C8","customContext":"\u30AB\u30B9\u30BF\u30E0\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8","contextNote":{"generic":"\u3053\u306E\u30BF\u30B9\u30AF\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3001\u5B9F\u884C\u6642\u306B\u89E3\u6C7A\u3055\u308C\u307E\u3059\u3002","highlighted":"\u3053\u306E\u30BF\u30B9\u30AF\u306F\u3001\u5B9F\u884C\u6642\u306B\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30A2\u30D7\u30EA\u5185\u3067\u30CF\u30A4\u30E9\u30A4\u30C8\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","clipboard":"\u3053\u306E\u30BF\u30B9\u30AF\u306F\u5B9F\u884C\u6642\u306B\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306E\u5185\u5BB9\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002","auto":"\u3053\u306E\u30BF\u30B9\u30AF\u306E\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u306F\u3001\u5B9F\u884C\u6642\u306B\u81EA\u52D5\u7684\u306B\u89E3\u6C7A\u3055\u308C\u307E\u3059\u3002"},"attachments":"\u6DFB\u4ED8\u30D5\u30A1\u30A4\u30EB\u3068\u30D5\u30A9\u30EB\u30C0","skills":"\u30B9\u30AD\u30EB","connectors":"\u30B3\u30CD\u30AF\u30BF","schedule":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB","goalRequired":"\u3053\u306E\u30BF\u30B9\u30AF\u306E\u6307\u793A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","saved":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F\u3002","notFound":"\u3053\u306E\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"},"schedulePrompt":{"menuItem":"\u3053\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u8A2D\u5B9A\u3059\u308B\u2026","title":"\u3053\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3059\u308B","prompt":"\u30D7\u30ED\u30F3\u30D7\u30C8","name":"\u540D\u524D\uFF08\u4EFB\u610F\uFF09","namePlaceholder":"\u3053\u306E\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306B\u540D\u524D\u3092\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044","confirm":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB","goalRequired":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3092\u8A2D\u5B9A\u3059\u308B\u306B\u306F\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","success":"\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u307E\u3057\u305F\u3002","error":"\u3053\u306E\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002"},"notify":{"runStarted":{"title":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u304C\u5B9F\u884C\u4E2D\u3067\u3059","body":"\u300C{{name}}\u300D\u304C\u73FE\u5728\u5B9F\u884C\u4E2D\u3067\u3059\u3002"},"missed":{"title":"\u4E88\u5B9A\u3055\u308C\u3066\u3044\u305F\u30BF\u30B9\u30AF\u3092\u9003\u3057\u307E\u3057\u305F","bodyOne":"\u30A2\u30D7\u30EA\u304C\u5B9F\u884C\u3055\u308C\u3066\u3044\u306A\u3044\u9593\u306B\u300C{{name}}\u300D\u304C\u898B\u843D\u3068\u3055\u308C\u307E\u3057\u305F\u3002","bodyMany":"\u30A2\u30D7\u30EA\u304C\u5B9F\u884C\u3055\u308C\u3066\u3044\u306A\u3044\u9593\u306B\u3001{{count}}\u500B\u306E\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3055\u308C\u305F\u30BF\u30B9\u30AF\u304C\u5B9F\u884C\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002"}},"skippedBusy":"\u5225\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u65E2\u306B\u5B9F\u884C\u4E2D\u3060\u3063\u305F\u305F\u3081\u3001\u30B9\u30AD\u30C3\u30D7\u3055\u308C\u307E\u3057\u305F\u3002","overlap":{"title":"\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u304C\u91CD\u8907\u3059\u308B","description":"\u3053\u308C\u306F\u300C{{name}}\u300D({{time}}) \u304B\u3089 5 \u5206\u4EE5\u5185\u306B\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002\u81EA\u52D5\u5316\u306F\u4E00\u5EA6\u306B 1 \u3064\u3057\u304B\u5B9F\u884C\u3055\u308C\u306A\u3044\u305F\u3081\u3001\u4E00\u65B9\u304C\u5B8C\u4E86\u3059\u308B\u307E\u3067\u3082\u3046\u4E00\u65B9\u306F\u5F85\u6A5F\u3057\u307E\u3059\u3002\u305D\u308C\u3067\u3082\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3057\u307E\u3059\u304B\uFF1F","confirm":"\u3068\u306B\u304B\u304F\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3092\u7D44\u3080"}},"keyboardService":{"unavailable":{"title":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9\u306E\u64CD\u4F5C\u304C\u505C\u6B62\u3057\u307E\u3057\u305F","recovering":"Cephable\u304C\u518D\u8D77\u52D5\u4E2D\u3067\u3059\u3002\u307E\u3082\u306A\u304F\u30B3\u30DE\u30F3\u30C9\u304C\u518D\u3073\u4F7F\u3048\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002","stalled":"Cephable\u3092\u518D\u8D77\u52D5\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u3082\u3046\u4E00\u5EA6\u5B9F\u884C\u3059\u308B\u304B\u3001\u305D\u308C\u3067\u3082\u5931\u6557\u3059\u308B\u5834\u5408\u306FCephable\u3092\u518D\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002","permissionTitle":"Cephable\u306F\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9\u3092\u5236\u5FA1\u3067\u304D\u307E\u305B\u3093","permission":"\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A > \u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3 > {{pane}} \u3067 Cephable \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u3066\u304B\u3089\u3001\u3082\u3046\u4E00\u5EA6\u30B3\u30DE\u30F3\u30C9\u3092\u5B9F\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","permissionWindows":"Windows\u3067\u306F\u3001\u7BA1\u7406\u8005\u6A29\u9650\u3067\u5B9F\u884C\u3055\u308C\u3066\u3044\u308B\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u30A2\u30D7\u30EA\u304C\u5236\u5FA1\u3059\u308B\u3053\u3068\u306F\u30D6\u30ED\u30C3\u30AF\u3055\u308C\u307E\u3059\u3002Cephable\u3092\u4E00\u5EA6\u9589\u3058\u3066\u304B\u3089\u7BA1\u7406\u8005\u6A29\u9650\u3067\u518D\u5EA6\u8D77\u52D5\u3059\u308B\u304B\u3001\u7BA1\u7406\u8005\u6A29\u9650\u306A\u3057\u3067\u4ED6\u306E\u30A2\u30D7\u30EA\u3092\u518D\u5EA6\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002Windows\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u8B66\u544A\u3068\u30ED\u30C3\u30AF\u753B\u9762\u306F\u5236\u5FA1\u3067\u304D\u307E\u305B\u3093\u3002\u8077\u5834\u306E\u30C7\u30D0\u30A4\u30B9\u3067\u306F\u3001IT\u7BA1\u7406\u8005\u304C\u3053\u308C\u3092\u30D6\u30ED\u30C3\u30AF\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"},"restored":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9\u306E\u64CD\u4F5C\u304C\u518D\u3073\u6B63\u5E38\u306B\u52D5\u4F5C\u3059\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002"},"error":"\u30A8\u30E9\u30FC","macPermissions":{"openSettings":"\u8A2D\u5B9A\u3092\u958B\u304F","pane":{"accessibility":"\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3","deviceControl":"\u30C7\u30D0\u30A4\u30B9\u5236\u5FA1\u3068\u30C7\u30FC\u30BF\u30A2\u30AF\u30BB\u30B9","inputMonitoring":"\u5165\u529B\u76E3\u8996","filesAndFolders":"\u30D5\u30A1\u30A4\u30EB\u3068\u30D5\u30A9\u30EB\u30C0","fullDiskAccess":"\u30D5\u30EB\u30C7\u30A3\u30B9\u30AF\u30A2\u30AF\u30BB\u30B9","camera":"\u30AB\u30E1\u30E9","microphone":"\u30DE\u30A4\u30AF\u30ED\u30D5\u30A9\u30F3","screenRecording":"\u753B\u9762\u9332\u753B"}},"recordWorkflow":{"title":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u8A18\u9332\u3059\u308B","description":"Cephable\u306B\u30BF\u30B9\u30AF\u306E\u3084\u308A\u65B9\u3092\u898B\u305B\u3066\u304F\u3060\u3055\u3044\u3002\u30AF\u30EA\u30C3\u30AF\u3057\u306A\u304C\u3089\u58F0\u306B\u51FA\u3057\u3066\u8AAC\u660E\u3059\u308C\u3070\u3001\u305D\u308C\u306F\u518D\u5229\u7528\u53EF\u80FD\u306A\u30B9\u30AD\u30EB\u306B\u306A\u308A\u307E\u3059\u3002","cardDescription":"Cephable\u306B\u305D\u306E\u4F5C\u696D\u306E\u3084\u308A\u65B9\u3092\u6559\u3048\u308B\u305F\u3081\u306B\u3001\u81EA\u5206\u304C\u4F5C\u696D\u3092\u884C\u3063\u3066\u3044\u308B\u69D8\u5B50\u3092\u9332\u753B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","goalLabel":"\u9332\u97F3\u306E\u8AAC\u660E","goalPlaceholder":"\u3053\u308C\u304B\u3089\u4F55\u3092\u5B9F\u6F14\u3059\u308B\u306E\u3067\u3059\u304B\uFF1F\uFF08\u4EFB\u610F\uFF09","start":"\u9332\u753B\u3092\u958B\u59CB","recording":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u8A18\u9332\u3059\u308B","stepCount":"{{count}}\u30B9\u30C6\u30C3\u30D7","stopAndCreate":"\u7ACB\u3061\u6B62\u307E\u3063\u3066\u30B9\u30AD\u30EB\u3092\u5275\u9020\u3059\u308B","creating":"\u9332\u97F3\u3092\u30B9\u30AD\u30EB\u306B\u5909\u3048\u308B\u2026","permissionNeeded":"Cephable\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u64CD\u4F5C\u3092\u8A18\u9332\u3059\u308B\u305F\u3081\u306B\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3/\u5165\u529B\u76E3\u8996\u306E\u6A29\u9650\u3092\u5FC5\u8981\u3068\u3057\u307E\u3059\u3002\u30B7\u30B9\u30C6\u30E0\u8A2D\u5B9A\u3067\u3053\u306E\u6A29\u9650\u3092\u4ED8\u4E0E\u3057\u3066\u304B\u3089\u3001\u518D\u5EA6\u8D77\u52D5\u3057\u3066\u304F\u3060\u3055\u3044\u3002","noMic":"\u30DE\u30A4\u30AF\u304C\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30CA\u30EC\u30FC\u30B7\u30E7\u30F3\u306A\u3057\u3067\u52D5\u4F5C\u3092\u9332\u753B\u3057\u307E\u3059\u3002","startError":"\u9332\u97F3\u3092\u958B\u59CB\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002","noSteps":"\u30B9\u30AD\u30EB\u306B\u5909\u63DB\u3067\u304D\u308B\u3088\u3046\u306A\u884C\u52D5\u306F\u8A18\u9332\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002","stopReminder":"\u5FC5\u8981\u306A\u3060\u3051\u7D9A\u3051\u3066\u304F\u3060\u3055\u3044\u3002\u4F5C\u696D\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u3053\u3053\u306B\u623B\u3063\u3066\u300C\u505C\u6B62\u3057\u3066\u30B9\u30AD\u30EB\u3092\u4F5C\u6210\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002","callout":{"title":"Cephable\u306B\u30BF\u30B9\u30AF\u306E1\u3064\u3092\u6559\u3048\u308B","description":"Cephable\u304C\u898B\u3066\u3044\u308B\u524D\u3067\u4E00\u5EA6\u4F5C\u696D\u3092\u884C\u3044\u3001\u305D\u306E\u5185\u5BB9\u3092\u30CA\u30EC\u30FC\u30B7\u30E7\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305D\u3046\u3059\u308B\u3068\u3001\u3044\u3064\u3067\u3082\u5B9F\u884C\u3067\u304D\u308B\u30B9\u30AD\u30EB\u3068\u3057\u3066\u7FD2\u5F97\u3067\u304D\u307E\u3059\u3002","action":"\u3084\u308A\u65B9\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044","dismiss":"\u4ECA\u3058\u3083\u306A\u3044","badge":"\u8A66\u3057\u3066\u307F\u3066","compactDescription":"Cephable\u304C\u76E3\u8996\u3057\u3066\u3044\u308B\u72B6\u614B\u3067\u4E00\u5EA6\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3059\u308B\u3068\u3001\u305D\u308C\u306F\u3044\u3064\u3067\u3082\u5B9F\u884C\u3067\u304D\u308B\u30B9\u30AD\u30EB\u306B\u306A\u308A\u307E\u3059\u3002","compactAction":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u8A18\u9332\u3059\u308B"},"coach":{"title":"\u9332\u97F3\u3059\u308B\u524D\u306B","progress":"{{current}} \u306E\u30C1\u30C3\u30D7\uFF08\u5408\u8A08\uFF09","ready":"\u6E96\u5099\u3067\u304D\u307E\u3057\u305F","skip":"\u30D2\u30F3\u30C8\u3092\u30B9\u30AD\u30C3\u30D7","reopen":"\u4ED5\u7D44\u307F","steps":{"pickTask":{"title":"\u5B9F\u969B\u306E\u30BF\u30B9\u30AF\u30921\u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","body":"\u666E\u6BB5\u304B\u3089\u884C\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u9078\u3073\u3001\u305D\u308C\u3092\u6700\u521D\u304B\u3089\u6700\u5F8C\u307E\u3067\u4E00\u6C17\u306B\u3084\u308A\u9042\u3052\u308B\u8A08\u753B\u3092\u7ACB\u3066\u307E\u3057\u3087\u3046\u3002\u77ED\u6642\u9593\u3067\u5B8C\u4E86\u3059\u308B\u4F5C\u696D\u306F\u3001\u9577\u6642\u9593\u3067\u4E2D\u9014\u534A\u7AEF\u306A\u4F5C\u696D\u3088\u308A\u3082\u306F\u308B\u304B\u306B\u591A\u304F\u306E\u3053\u3068\u3092\u5B66\u3079\u307E\u3059\u3002","example":"\u3053\u308C\u304C\u79C1\u306E\u9031\u6B21\u7D4C\u8CBB\u5831\u544A\u66F8\u306E\u63D0\u51FA\u65B9\u6CD5\u3067\u3059\u3002\u66F8\u985E\u3092\u958B\u3044\u3066\u3001\u8A18\u5165\u3057\u3066\u3001\u63D0\u51FA\u3059\u308B\u3060\u3051\u3067\u3059\u3002"},"narrate":{"title":"\u6700\u5F8C\u307E\u3067\u8A71\u3057\u307E\u3057\u3087\u3046","body":"\u307E\u308B\u3067\u65B0\u3057\u3044\u540C\u50DA\u304C\u3042\u306A\u305F\u306E\u4ED5\u4E8B\u3076\u308A\u3092\u9593\u8FD1\u3067\u898B\u3066\u3044\u308B\u304B\u306E\u3088\u3046\u306B\u3001\u81EA\u5206\u304C\u4F55\u3092\u3057\u3066\u3044\u308B\u306E\u304B\u3001\u305D\u3057\u3066\u306A\u305C\u305D\u3046\u3057\u3066\u3044\u308B\u306E\u304B\u3092\u58F0\u306B\u51FA\u3057\u3066\u8AAC\u660E\u3057\u3066\u304F\u3060\u3055\u3044\u3002Cephable\u306F\u3001\u3042\u306A\u305F\u306E\u8AAC\u660E\u3092\u624B\u9806\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","example":"\u4ECA\u3001Outlook\u3067\u8ACB\u6C42\u66F8\u3092\u958B\u3044\u3066\u3001\u767A\u6CE8\u756A\u53F7\u3092\u78BA\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002"},"goSlow":{"title":"\u614E\u91CD\u306B\u3001\u4E00\u5EA6\u306B\u4E00\u3064\u305A\u3064\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044","body":"\u6B21\u306E\u30AF\u30EA\u30C3\u30AF\u3092\u884C\u3046\u524D\u306B\u3001\u5404\u30DA\u30FC\u30B8\u307E\u305F\u306F\u30A2\u30D7\u30EA\u306E\u8AAD\u307F\u8FBC\u307F\u304C\u5B8C\u4E86\u3059\u308B\u307E\u3067\u5F85\u3061\u3001\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u5185\u5BB9\u3092\u660E\u8A18\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D1\u30B9\u30EF\u30FC\u30C9\u3084\u30AB\u30FC\u30C9\u756A\u53F7\u306A\u3069\u3001\u500B\u4EBA\u60C5\u5831\u3092\u542B\u3080\u3082\u306E\u306F\u30B9\u30AD\u30EB\u306B\u542B\u3081\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","example":"\u53F3\u4E0A\u306E\u300C\u627F\u8A8D\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u78BA\u8A8D\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u308B\u306E\u3092\u5F85\u3063\u3066\u3044\u307E\u3059\u3002"},"explainRules":{"title":"\u30EB\u30FC\u30EB\u3092\u58F0\u306B\u51FA\u3057\u3066\u8A00\u3063\u3066\u304F\u3060\u3055\u3044","body":"\u6BCE\u56DE\u7570\u306A\u308B\u70B9\u3084\u3001\u6B21\u56DE\u306F\u3069\u306E\u3088\u3046\u306B\u9055\u3046\u3053\u3068\u3092\u3059\u308B\u304B\u3092\u5177\u4F53\u7684\u306B\u8FF0\u3079\u3001\u305D\u306E\u30B9\u30AD\u30EB\u304C\u4ECA\u65E5\u3060\u3051\u3067\u306A\u304F\u3001\u5C06\u6765\u306B\u3082\u901A\u7528\u3059\u308B\u3088\u3046\u306B\u3057\u3066\u3044\u304D\u307E\u3057\u3087\u3046\u3002","example":"\u767A\u6CE8\u756A\u53F7\u304C\u306A\u3044\u5834\u5408\u306F\u3001\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u306F\u4F7F\u308F\u305A\u306B\u3001\u4EE3\u308F\u308A\u306B\u30D9\u30F3\u30C0\u30FC\u306B\u30E1\u30FC\u30EB\u3092\u9001\u308A\u307E\u3059\u3002"},"comeBack":{"title":"\u623B\u3063\u3066\u304D\u3066\u505C\u6B62\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044","body":"Cephable\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u505C\u6B62\u3092\u6307\u793A\u3059\u308B\u307E\u3067\u9332\u97F3\u3092\u7D9A\u3051\u307E\u3059\u3002\u4F5C\u696D\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u3053\u306E\u30D1\u30CD\u30EB\u306B\u623B\u308A\u3001\u300C\u505C\u6B62\u3057\u3066\u30B9\u30AD\u30EB\u3092\u4F5C\u6210\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u30021\u5206\u9593\u4F55\u3082\u805E\u3053\u3048\u305A\u3001\u30AF\u30EA\u30C3\u30AF\u97F3\u3082\u691C\u51FA\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u81EA\u52D5\u7684\u306B\u505C\u6B62\u3057\u307E\u3059\u3002","example":"\u3053\u308C\u3067\u5168\u3066\u5B8C\u4E86\u3067\u3059\u3002"}}},"idle":{"title":"\u9332\u97F3\u4E2D","body":"\u3057\u3070\u3089\u304F\u30AF\u30EA\u30C3\u30AF\u97F3\u3082\u97F3\u58F0\u3082\u805E\u3053\u3048\u307E\u305B\u3093\u3002\u30BF\u30B9\u30AF\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u300C\u505C\u6B62\u3057\u3066\u30B9\u30AD\u30EB\u3092\u4F5C\u6210\u300D\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002","countdown":"{{\u79D2}}\u79D2\u5F8C\u306B\u81EA\u52D5\u7684\u306B\u505C\u6B62\u3057\u307E\u3059\u3002","keepGoing":"\u79C1\u306F\u307E\u3060\u50CD\u3044\u3066\u3044\u307E\u3059","autoStopped":"1\u5206\u9593\u7121\u97F3\u72B6\u614B\u304C\u7D9A\u3044\u305F\u5F8C\u3001\u9332\u97F3\u306F\u81EA\u52D5\u7684\u306B\u505C\u6B62\u3057\u307E\u3057\u305F\u3002"},"teachAction":"Cephable\u306B\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6559\u3048\u308B"},"backgroundCapture":{"title":"\u80CC\u666F\u60C5\u5831","capturing":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u4FDD\u5B58\u3057\u3066\u3044\u307E\u3059...","tooltip":"\u5165\u529B\u3067\u304D\u306A\u304B\u3063\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u3001\u73FE\u5728\u306E\u30BB\u30C3\u30B7\u30E7\u30F3\u4E2D\u306E\u307F\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002Cephable\u3092\u7D42\u4E86\u3059\u308B\u3068\u6D88\u53BB\u3055\u308C\u307E\u3059\u3002","nothingToPaste":"\u8CBC\u308A\u4ED8\u3051\u308B\u80CC\u666F\u30B3\u30F3\u30C6\u30F3\u30C4\u304C\u3042\u308A\u307E\u305B\u3093\u3002","pasteNotPermitted":"\u8CBC\u308A\u4ED8\u3051\u3067\u304D\u307E\u305B\u3093\u3002\u73FE\u5728\u30D5\u30A9\u30FC\u30AB\u30B9\u304C\u5F53\u305F\u3063\u3066\u3044\u308B\u305F\u3081\u3001\u64CD\u4F5C\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","pasteFailed":"\u80CC\u666F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8CBC\u308A\u4ED8\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002"}}');


var $8e6856e76156b5da$exports = {};
$8e6856e76156b5da$exports = JSON.parse('{"404":"\u3042\u3042\u3001\u5927\u5909\uFF01\u6D77\u4E2D\u3092\u63A2\u3057\u305F\u306E\u3067\u3059\u304C\u3001\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\uFF01","appError":{"title":"\u4F55\u3089\u304B\u306E\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F","description":"\u30A2\u30D7\u30EA\u3067\u4E88\u671F\u305B\u306C\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA\u3092\u518D\u8AAD\u307F\u8FBC\u307F\u3059\u308B\u304B\u3001\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306B\u623B\u3063\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u554F\u984C\u304C\u7E70\u308A\u8FD4\u3057\u767A\u751F\u3059\u308B\u5834\u5408\u306F\u3001\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002","home":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306B\u623B\u308B"}}');


var $0fb65a16e8d9a99f$exports = {};
$0fb65a16e8d9a99f$exports = JSON.parse('{"smartTasks":{"generate":{"focusApp":{"title":"\u30A2\u30D7\u30EA\u306B\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u751F\u6210\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u8868\u793A\u3057\u305F\u3044\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u751F\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u305D\u306E\u5834\u6240\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u30C6\u30AD\u30B9\u30C8\u304C\u751F\u6210\u3055\u308C\u307E\u3059\u3002"}},"rewrite":{"focusApp":{"title":"\u30A2\u30D7\u30EA\u306B\u7126\u70B9\u3092\u5F53\u3066\u308B","description":"\u66F8\u304D\u63DB\u3048\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u8868\u793A\u3057\u305F\u3044\u30A2\u30D7\u30EA\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u751F\u6210\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u305D\u306E\u5834\u6240\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u30C6\u30AD\u30B9\u30C8\u304C\u751F\u6210\u3055\u308C\u307E\u3059\u3002"}}},"customControls":{"tourLabel":"\u5E38\u306B\u5229\u7528\u53EF\u80FD\u306A\u30B0\u30ED\u30FC\u30D0\u30EB\u304A\u3088\u3073\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","rowDescription":"\u30DE\u30A4\u30AF\u304C\u30AA\u30F3\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u3001\u3069\u306E\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3057\u3066\u3044\u3066\u3082\u3001\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u5E38\u306B\u5229\u7528\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3048\u3070\u3001\u65B0\u3057\u3044\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u306A\u304F\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30A2\u30D7\u30EA\u306E\u5207\u308A\u66FF\u3048\u3001\u30C6\u30AD\u30B9\u30C8\u306E\u751F\u6210\u3001\u30DE\u30A4\u30AF\u306E\u4E00\u6642\u505C\u6B62\u306A\u3069\u3001\u4FBF\u5229\u306A\u30B3\u30DE\u30F3\u30C9\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002"},"profile":{"switch":{"title":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5207\u308A\u66FF\u3048\u308B","description":"\u30A2\u30D7\u30EA\u306E\u64CD\u4F5C\u8A2D\u5B9A\u306F\u3001\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u306B\u57FA\u3065\u3044\u3066\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u308F\u308B\u5834\u5408\u3082\u3042\u308C\u3070\u3001\u3053\u3053\u3067\u3044\u3064\u3067\u3082\u624B\u52D5\u3067\u5909\u66F4\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"}},"dictation":{"tourLabel":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","learn":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3 \u30E2\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u97F3\u58F0\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","welcome":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u3048\u3070\u3001\u81EA\u7136\u306A\u8A71\u3057\u65B9\u3067\u3001\u8A71\u3057\u306A\u304C\u3089\u5165\u529B\u3067\u304D\u307E\u3059\u3002\u307E\u308B\u3067\u3001\u3042\u306A\u305F\u306E\u8A71\u3059\u8A00\u8449\u3092\u3059\u3079\u3066\u5165\u529B\u3057\u3066\u304F\u308C\u308B\u30D1\u30FC\u30BD\u30CA\u30EB\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u304C\u3044\u308B\u304B\u306E\u3088\u3046\u3067\u3059\u3002"},"microphone":{"title":"\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3059\u308B","description":"\u307E\u305A\u3001\u30DE\u30A4\u30AF\u3092\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002Cephable\u30D1\u30CD\u30EB\u306E\u30DE\u30A4\u30AF\u5207\u308A\u66FF\u3048\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"activate":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u958B\u59CB","description":"\u97F3\u58F0\u306F\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u3067\u8D77\u52D5\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3046\u304B\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u305D\u308C\u3067\u306F\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u3092\u30AA\u30F3\u306B\u3057\u307E\u3057\u3087\u3046\u3002"},"focus":{"title":"\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3059\u308B","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u5F53\u3066\u308B\u3068\u6700\u3082\u52B9\u679C\u7684\u306B\u6A5F\u80FD\u3057\u307E\u3059\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3057\u305F\u3044\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002"},"speaking":{"title":"\u8A71\u3057\u59CB\u3081\u308B","description":"\u3055\u3042\u3001\u8A71\u3057\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u8A71\u3057\u305F\u5185\u5BB9\u306F\u3059\u3079\u3066\u3001\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u305F\u30C6\u30AD\u30B9\u30C8\u30D5\u30A3\u30FC\u30EB\u30C9\u307E\u305F\u306F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u5165\u529B\u3055\u308C\u307E\u3059\u3002\u300C\u3053\u3093\u306B\u3061\u306F\u3002\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u306E\u30C6\u30B9\u30C8\u3067\u3059\u300D\u306E\u3088\u3046\u306B\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"pauseResume":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u4E00\u6642\u505C\u6B62","description":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u305B\u305A\u306B\u4F11\u61A9\u3057\u305F\u3044\u5834\u5408\u306F\u3001\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4E00\u6642\u505C\u6B62\u300D\u3068\u767A\u58F0\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u767A\u58F0\u3059\u308C\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u6A5F\u80FD\u306F\u3001\u5E38\u6642\u30AA\u30F3\u306E\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30C7\u30D0\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u3055\u3089\u306B\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002"},"stop":{"title":"\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u3084\u3081\u308B","description":"\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u623B\u308A\u305F\u3044\u3067\u3059\u304B\uFF1F\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u505C\u6B62\u300D\u3068\u8A00\u3046\u3060\u3051\u3067\u3059\u3002\u3053\u308C\u3067\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u30E2\u30FC\u30C9\u304C\u505C\u6B62\u3057\u3001\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306B\u623B\u308A\u307E\u3059\u3002\u300C\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u958B\u59CB\u300D\u3068\u8A00\u3048\u3070\u3044\u3064\u3067\u3082\u518D\u958B\u3067\u304D\u307E\u3059\u3002"},"complete":{"description":"\u3053\u308C\u3067\u5B8C\u4E86\u3067\u3059\uFF01\u97F3\u58F0\u5165\u529B\u3001\u4E00\u6642\u505C\u6B62\u3001\u518D\u958B\u3001\u305D\u3057\u3066\u97F3\u58F0\u5165\u529B\u30E2\u30FC\u30C9\u3068\u30B3\u30DE\u30F3\u30C9\u30E2\u30FC\u30C9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u97F3\u58F0\u5165\u529B\u306F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u5165\u529B\u3092\u53EF\u80FD\u306B\u3059\u308B\u5F37\u529B\u306A\u30C4\u30FC\u30EB\u3067\u3059\u3002\u30E1\u30FC\u30EB\u3084\u6587\u66F8\u306E\u4F5C\u6210\u306A\u3069\u3001\u97F3\u58F0\u5165\u529B\u304C\u5FC5\u8981\u306A\u3042\u3089\u3086\u308B\u4F5C\u696D\u306B\u304A\u4F7F\u3044\u3044\u305F\u3060\u3051\u307E\u3059\u3002"}},"microphone":{"tourLabel":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","learn":"\u97F3\u58F0\u3092\u4F7F\u7528\u3057\u3066\u4EFB\u610F\u306E\u30A2\u30D7\u30EA\u3092\u5236\u5FA1\u3057\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066\u8A71\u3057\u305F\u3053\u3068\u3092\u5165\u529B\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","rowDescription":"\u30DE\u30A4\u30AF\u304C\u30AA\u30D5\u306B\u306A\u3063\u3066\u3044\u308B\u3068\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u306F\u5168\u304F\u8A8D\u8B58\u3055\u308C\u307E\u305B\u3093\u3002\u3057\u304B\u3057\u3001\u30AA\u30F3\u306B\u3059\u308B\u3068\u3001\u4E00\u6642\u505C\u6B62\u3084\u958B\u59CB\u306A\u3069\u306E\u64CD\u4F5C\u3092\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30DE\u30F3\u30C9\u3067\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u3055\u3042\u3001\u30AA\u30F3\u306B\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002","tryOpen":{"title":"\u300CSpotify \u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CWord \u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044"},"finishedCommands":{"title":"\u7D20\u6674\u3089\u3057\u3044\uFF01\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306E\u57FA\u672C\u3092\u5B66\u7FD2\u3057\u307E\u3057\u305F\u3002","description":"\u30B5\u30DD\u30FC\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u3044\u3064\u3067\u3082\u30C4\u30A2\u30FC\u3092\u518D\u958B\u3067\u304D\u307E\u3059\u3002\u6B21\u306E\u30B9\u30C6\u30C3\u30D7\u306F\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u3064\u3044\u3066\u5B66\u3076\u3053\u3068\u3067\u3059\u3002\u30B5\u30DD\u30FC\u30C8\u30DA\u30FC\u30B8\u304B\u3089\u30C4\u30A2\u30FC\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002"}},"tour":{"startTour":"\u30C4\u30A2\u30FC\u3092\u958B\u59CB","finishTour":"\u30C4\u30A2\u30FC\u7D42\u4E86","statusDialog":"\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u30D1\u30CD\u30EB\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002","step":"{{step}} / {{total}} \u30B9\u30C6\u30C3\u30D7","skipTour":"\u30C4\u30A2\u30FC\u3092\u30B9\u30AD\u30C3\u30D7"},"onboarding":{"overview":"\u6982\u8981","learn":"Cephable \u306E\u6A5F\u80FD\u3068\u305D\u306E\u4F7F\u7528\u65B9\u6CD5\u306B\u3064\u3044\u3066\u5B66\u3073\u307E\u3059\u3002","start":"\u307E\u3060\u59CB\u307E\u3063\u305F\u3070\u304B\u308A\u306E\u3088\u3046\u3067\u3059\u306D\u3002\u3053\u308C\u304B\u3089\u5F79\u7ACB\u3064\u30D2\u30F3\u30C8\u3092\u3044\u304F\u3064\u304B\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","dashboard":{"title":"Cephable Workspace","description":"Cephable Workspace\u306F\u3001\u30C7\u30D0\u30A4\u30B9\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u304A\u3088\u3073\u8A2D\u5B9A\u3092\u7BA1\u7406\u3059\u308B\u305F\u3081\u306E\u4E2D\u5FC3\u7684\u306A\u30CF\u30D6\u3067\u3059\u3002\u3053\u3053\u304B\u3089\u3001\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3001\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30B3\u30DE\u30F3\u30C9\u3092\u8868\u793A\u3057\u305F\u308A\u3001Cephable\u306E\u3059\u3079\u3066\u306E\u6A5F\u80FD\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"step1":{"title":"Cephable\u3078\u3088\u3046\u3053\u305D","description":"Cephable\u306F\u3001\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EBAI\u3067\u3059\u3002\u7D20\u65E9\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u3001\u305D\u3057\u3066\u30C4\u30FC\u30EB\u5168\u4F53\u306E\u30B9\u30DE\u30FC\u30C8\u306A\u81EA\u52D5\u5316\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002\u3059\u3050\u306B\u4F7F\u3048\u308B\u64CD\u4F5C\u6027\u3002\u30AF\u30E9\u30A6\u30C9\u51E6\u7406\u306F\u4E0D\u8981\u3002\u3042\u306A\u305F\u306E\u79FB\u52D5\u306B\u5408\u308F\u305B\u3066\u751F\u7523\u6027\u3092\u5411\u4E0A\u3057\u307E\u3059\u3002"},"finish":{"continueToApp":"Cephable\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u306B\u9032\u3080","keepExploring":"\u63A2\u691C\u3092\u7D9A\u3051\u308B"},"useCaseSlider":{"context":"\u4F7F\u7528\u3057\u305F\u3044","control":"\u5236\u5FA1\u3059\u308B"}},"support":{"description":"Cephable \u306E\u4F7F\u7528\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u8A73\u7D30\u60C5\u5831\uFF08\u305D\u306E\u4ED6\u306E\u30C4\u30A2\u30FC\u3001\u30B9\u30C6\u30C3\u30D7\u30D0\u30A4\u30B9\u30C6\u30C3\u30D7 \u30AC\u30A4\u30C9\u3001\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3001\u30D3\u30C7\u30AA\u306A\u3069\uFF09\u306B\u3064\u3044\u3066\u306F\u3001\u30B5\u30DD\u30FC\u30C8 \u30CF\u30D6\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002","title":"\u30B5\u30DD\u30FC\u30C8"},"editingVideos":{"tourLabel":"\u52D5\u753B\u7DE8\u96C6\u306E\u9762\u5012\u306A\u30AF\u30EA\u30C3\u30AF\u3067\u306F\u306A\u304F\u3001\u30B9\u30C8\u30FC\u30EA\u30FC\u306B\u96C6\u4E2D\u3057\u307E\u3057\u3087\u3046","learn":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u97F3\u58F0\u5165\u529B\u3092\u4F7F\u3063\u3066\u52D5\u753B\u7DE8\u96C6\u3092\u3088\u308A\u901F\u304F\u884C\u3044\u3001\u7DE8\u96C6\u4E2D\u306B\u3069\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u304B\u3092\u899A\u3048\u308B\u3068\u3044\u3046\u8A8D\u77E5\u8CA0\u8377\u3092\u8EFD\u6E1B\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u3087\u3046\u3002","tryOpen":{"title":"\u300CCapCut\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CiMovie\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u3053\u308C\u3067\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u52D5\u753B\u7DE8\u96C6\u30A2\u30D7\u30EA\u3067\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u3001\u518D\u751F\u3001\u4E00\u6642\u505C\u6B62\u3001\u30C8\u30E9\u30C3\u30AF\u306E\u30B9\u30AD\u30C3\u30D7\u3001\u97F3\u91CF\u8ABF\u6574\u3092\u884C\u3046\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306A\u52D5\u753B\u64CD\u4F5C\u306E\u305F\u3081\u306B\u3001\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u72EC\u81EA\u306E\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"congrats":"\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","fpsGamePlay":{"tourLabel":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067FPS\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4","learn":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3057\u3066 FPS \u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002","tryOpen":{"title":"\u300CValorant\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CBattlefield\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044"},"complete":{"description":"FPS\u30B2\u30FC\u30E0\u3067\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u3092\u52D5\u304B\u3057\u305F\u308A\u3001\u505C\u6B62\u3057\u305F\u308A\u3001\u64CD\u4F5C\u3059\u308B\u65B9\u6CD5\u3092\u7FD2\u5F97\u3057\u307E\u3057\u305F\u3002\u3082\u3063\u3068\u591A\u304F\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u3066\u3001\u3088\u308A\u30B9\u30E0\u30FC\u30BA\u3067\u30B9\u30D4\u30FC\u30C7\u30A3\u30FC\u306A\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u3092\u5B9F\u73FE\u3057\u307E\u3057\u3087\u3046\u3002"}},"redo":"\u30AA\u30F3\u30DC\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u3084\u308A\u76F4\u3059","title":"Cephable\u306B\u3064\u3044\u3066","description":"\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EB AI \u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u3067\u3042\u308B Cephable \u3092\u4F53\u9A13\u3057\u3001\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3078\u306E\u95A2\u5FC3\u3092\u5171\u6709\u3057\u307E\u3057\u3087\u3046\u3002","panel":{"description":"\u3053\u308C\u306F\u30E1\u30A4\u30F3\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30BB\u30F3\u30BF\u30FC\u3068\u306A\u308B\u30D1\u30CD\u30EB\u3067\u3059\u3002\u5E38\u306B\u8868\u793A\u3055\u308C\u3066\u304A\u308A\u3001\u97F3\u58F0\u3092\u4F7F\u3063\u3066\u30A2\u30D7\u30EA\u306A\u3069\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u307E\u305A\u306F\u30DE\u30A4\u30AF\u304B\u3089\u59CB\u3081\u307E\u3057\u3087\u3046\u3002"},"controlExpanded":{"tourLabel":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u306F\u3001\u7279\u5B9A\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u4F7F\u7528\u3067\u304D\u308B\u8A2D\u5B9A\u6E08\u307F\u306E\u64CD\u4F5C\u30BB\u30C3\u30C8\u306E\u3053\u3068\u3067\u3059\u3002\u3053\u306E\u30BB\u30AF\u30B7\u30E7\u30F3\u3067\u306F\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30BF\u30C3\u30D7\u3001\u6587\u5B57\u5165\u529B\u306A\u3069\u3001\u3055\u307E\u3056\u307E\u306A\u65B9\u6CD5\u3067\u4F7F\u7528\u3067\u304D\u308B\u3059\u3079\u3066\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7D39\u4ECB\u3057\u307E\u3059\u3002"},"submit":{"title":"\u63D0\u51FA\u3059\u308B","description":"\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u30AB\u30FC\u30BD\u30EB\u304C\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u3066\u3044\u308B\u5834\u6240\u306B\u51FA\u529B\u3055\u308C\u307E\u3059\u3002"},"tryOpen":{"description":"`Open`\u306F\u3001\u6307\u5B9A\u3057\u305F\u30A2\u30D7\u30EA\u3092\u958B\u3044\u3066\u30D5\u30A9\u30FC\u30AB\u30B9\u3092\u79FB\u3059\u30B0\u30ED\u30FC\u30D0\u30EB\u30B3\u30DE\u30F3\u30C9\u3067\u3059\u3002\u81EA\u52D5\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5207\u308A\u66FF\u3048\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u4F7F\u7528\u4E2D\u306E\u30A2\u30D7\u30EA\u306B\u6700\u9069\u306A\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u81EA\u52D5\u7684\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002"},"modeSelector":{"title":"\u9078\u629E\u30E2\u30FC\u30C9","description":"\u5229\u7528\u53EF\u80FD\u306A\u5834\u5408\u306F\u3001\u64CD\u4F5C\u30E2\u30FC\u30C9\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u9001\u4FE1\u3059\u308B\u30A2\u30D7\u30EA\u306B\u306F\u300C\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u300D\u3092\u3001\u8981\u7D04\u3001\u66F8\u304D\u63DB\u3048\u3001\u7FFB\u8A33\u306A\u3069\u306E\u751F\u6210\u30C6\u30AD\u30B9\u30C8\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u306F\u300C\u4F5C\u6210\u300D\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u307E\u305F\u306F\u30A2\u30D7\u30EA\u9593\u30D5\u30ED\u30FC\u306B\u306F\u300C\u81EA\u52D5\u5316\u300D\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"contextSelector":{"title":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E","description":"\u53EF\u80FD\u3067\u3042\u308C\u3070\u3001\u79C1\u304C\u64CD\u4F5C\u3059\u308B\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u3084\u30CF\u30A4\u30E9\u30A4\u30C8\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u4F7F\u7528\u3057\u305F\u308A\u3001\u4F5C\u696D\u5BFE\u8C61\u3068\u3059\u308B\u30D5\u30A1\u30A4\u30EB\u3084\u30D5\u30A9\u30EB\u30C0\u3092\u6DFB\u4ED8\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"panelInput":{"title":"\u79C1\u306B\u4F55\u3092\u3057\u3066\u307B\u3057\u3044\u306E\u3067\u3059\u304B\uFF1F","description":"\u79C1\u306B\u4F55\u3092\u3057\u3066\u307B\u3057\u3044\u304B\u3001\u547D\u4EE4\u3057\u305F\u308A\u3001\u5165\u529B\u3057\u305F\u308A\u3001\u53E3\u8FF0\u3057\u305F\u308A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"figma":{"tourLabel":"Figma\u3068Canva\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9","learn":"Controls\u306E\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3001\u97F3\u58F0\u30DE\u30A6\u30B9\u3001\u97F3\u58F0\u5165\u529B\u3001AI\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u6A5F\u80FD\u3092\u6D3B\u7528\u3057\u3066\u3001\u30C7\u30B6\u30A4\u30F3\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u6539\u5584\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u3087\u3046\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u52B9\u7387\u5316\u3059\u308B\u305F\u3081\u306E\u30C7\u30B6\u30A4\u30F3\u306E\u5236\u5FA1\u3068\u4F5C\u6210\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u306A\u30C7\u30B6\u30A4\u30F3\u5236\u5FA1\u306E\u305F\u3081\u306B\u3001\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3082\u8A66\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"tryOpen":{"title":"\u300CFigma\u3092\u958B\u304F\u300D\u307E\u305F\u306F\u300CCanva\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"}},"voiceMouse":{"title":"\u30DC\u30A4\u30B9\u30DE\u30A6\u30B9","description":"\u30DC\u30BF\u30F3\u3092\u540D\u524D\u3067\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u306B\u306F\u3001\u97F3\u58F0\u30DE\u30A6\u30B9\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u300C\u4FDD\u5B58\u3092\u30BF\u30C3\u30D7\u300D\u307E\u305F\u306F\u300C\u8A2D\u5B9A\u3078\u79FB\u52D5\u300D\u3068\u8A00\u3046\u3053\u3068\u3067\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"},"documentSummary":{"tourLabel":"\u6A5F\u5BC6\u5831\u544A\u66F8\u304B\u3089\u306E\u30C1\u30FC\u30E0\u6982\u8981\u8349\u7A3F","learn":"\u90E8\u9580\u30EC\u30DD\u30FC\u30C8\u306E\u81EA\u52D5\u8AAD\u307F\u8FBC\u307F\u3001\u60C5\u5831\u63D0\u4F9B\u3059\u3079\u304D\u9069\u5207\u306A\u62C5\u5F53\u8005\u306E\u7279\u5B9A\u3001\u30E1\u30FC\u30EB\u306E\u4F5C\u6210\u307E\u3067\u3001\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u7D50\u3059\u308B\u305F\u3081\u3001\u6A5F\u5BC6\u30C7\u30FC\u30BF\u306F\u5B89\u5168\u306B\u4FDD\u8B77\u3055\u308C\u307E\u3059\u3002","congrats":{"description":"\u3053\u308C\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u6A5F\u5BC6\u6587\u66F8\u3092\u8AAD\u307F\u8FBC\u307F\u3001\u30C1\u30FC\u30E0\u5B9B\u3066\u306E\u8981\u7D04\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3057\u304B\u3082\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"}},"extensions":{"tourLabel":"\u62E1\u5F35\u6A5F\u80FD","rowDescription":"Cephable\u3092\u62E1\u5F35\u3057\u3066\u3001\u30C7\u30D0\u30A4\u30B9\u3092\u64CD\u4F5C\u3059\u308B\u305F\u3081\u306E\u3088\u308A\u591A\u304F\u306E\u65B9\u6CD5\u3092\u8FFD\u52A0\u3057\u307E\u3057\u3087\u3046\u3002\u4F8B\u3048\u3070\u3001\u9854\u3084\u982D\u306E\u52D5\u304D\u3092\u5236\u5FA1\u3059\u308B\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u3001\u30B2\u30FC\u30E0\u30D1\u30C3\u30C9\u306E\u30B5\u30DD\u30FC\u30C8\u306A\u3069\u3067\u3059\u3002\u5FC5\u8981\u306A\u6A5F\u80FD\u3092\u3053\u3053\u3067\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"developerBuildTests":{"tourLabel":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u30D3\u30EB\u30C9\u3068\u30C6\u30B9\u30C8\u3092\u81EA\u52D5\u5316\u3059\u308B","learn":"Cephable\u306F\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30D3\u30EB\u30C9\u3084\u30C6\u30B9\u30C8\u306E\u5B9F\u884C\u306A\u3069\u3001\u8907\u6570\u306E\u30B9\u30C6\u30C3\u30D7\u304B\u3089\u306A\u308B\u30BF\u30FC\u30DF\u30CA\u30EB\u30BF\u30B9\u30AF\u3092\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u5B8C\u5168\u306B\u5B9F\u884C\u3067\u304D\u308B\u305F\u3081\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u4F5C\u696D\u3092\u7D9A\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u8907\u6570\u30B9\u30C6\u30C3\u30D7\u306E\u30D3\u30EB\u30C9\u304A\u3088\u3073\u30C6\u30B9\u30C8\u30BF\u30B9\u30AF\u3092\u5B9F\u884C\u3059\u308B\u305F\u3081\u306E\u30C7\u30D0\u30A4\u30B9\u5185AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u5B9F\u884C\u65B9\u6CD5\u3001\u6A29\u9650\u8981\u6C42\u3078\u306E\u5BFE\u5FDC\u65B9\u6CD5\u3001\u305D\u3057\u3066\u7D50\u679C\u306E\u53CD\u5FA9\u7684\u306A\u6539\u5584\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u5225\u306E\u53CD\u5FA9\u7684\u306A\u958B\u767A\u30BF\u30B9\u30AF\u306E\u81EA\u52D5\u5316\u3092\u8A66\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"classroomStudyTools":{"tourLabel":"\u6388\u696D\u30CE\u30FC\u30C8\u3084\u8A18\u4E8B\u3092\u5B66\u7FD2\u30C4\u30FC\u30EB\u3084\u6559\u6750\u306B\u6D3B\u7528\u3057\u3088\u3046","learn":"Cephable\u306F\u3001\u97F3\u58F0\u5165\u529B\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u306E\u4F5C\u6210\u30C4\u30FC\u30EB\u3001\u81EA\u52D5\u5316\u6A5F\u80FD\u306A\u3069\u3092\u901A\u3058\u3066\u3001\u6559\u5E2B\u3068\u751F\u5F92\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u3053\u308C\u3089\u306F\u3059\u3079\u3066\u3001\u666E\u6BB5\u304A\u4F7F\u3044\u306E\u30A2\u30D7\u30EA\u5185\u3067\u5B8C\u7D50\u3057\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u4FDD\u8B77\u3057\u306A\u304C\u3089\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u7D50\u3057\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u76F4\u63A5\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u97F3\u58F0\u5165\u529B\u3059\u308B\u65B9\u6CD5\u3001\u30E1\u30E2\u304B\u3089\u65B0\u3057\u3044\u5B66\u7FD2\u6559\u6750\u3092\u751F\u6210\u3059\u308B\u65B9\u6CD5\u3001\u305D\u3057\u3066Automate\u3092\u4F7F\u7528\u3057\u3066\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u5B8C\u5168\u306A\u8AB2\u984C\u3092\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002"}},"engineeringFlows":{"tourLabel":"\u958B\u767A\u8005\u5411\u3051\u97F3\u58F0\u5236\u5FA1\uFF0BAI\u81EA\u52D5\u5316","learn":"\u97F3\u58F0\u5236\u5FA1\u306B\u3088\u308B\u958B\u767A\u30B3\u30DE\u30F3\u30C9\u3001\u72EC\u81EA\u306E\u30B3\u30FC\u30C9\u3092\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3068\u3057\u3066\u4F7F\u7528\u3059\u308BAI\u30EA\u30E9\u30A4\u30C8\u3001\u305D\u3057\u3066\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u52D5\u4F5C\u3059\u308BAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306A\u3069\u3001\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3067\u304D\u308B\u6A5F\u80FD\u3092\u6D3B\u7528\u3057\u3066\u3001\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u9AD8\u901F\u5316\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u3087\u3046\u3002","tryOpen":{"title":"\u300CVisual Studio Code\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u3053\u308C\u3067\u3001\u97F3\u58F0\u5236\u5FA1\u306B\u3088\u308B\u958B\u767A\u30B3\u30DE\u30F3\u30C9\u3001\u72EC\u81EA\u306E\u30B3\u30FC\u30C9\u3092\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3068\u3057\u3066\u4F7F\u7528\u3059\u308BAI\u66F8\u304D\u63DB\u3048\u3001\u304A\u3088\u3073\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0\u30D5\u30ED\u30FC\u3092\u9AD8\u901F\u5316\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002"}},"meetingNotesToFiles":{"tourLabel":"\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u3092\u5B9F\u7528\u7684\u306A\u30D5\u30A1\u30A4\u30EB\u306B\u5909\u63DB\u3059\u308B","learn":"Cephable\u3092\u4F7F\u3048\u3070\u3001\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u3092\u3088\u308A\u5C0F\u3055\u304F\u3001\u5B9F\u7528\u7684\u306A\u30D5\u30A1\u30A4\u30EB\u306B\u5206\u5272\u3067\u304D\u308B\u306E\u3067\u3001\u81EA\u5206\u306E\u30DA\u30FC\u30B9\u3067\u4F5C\u696D\u3092\u9032\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3057\u304B\u3082\u3001\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u7D50\u3057\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u3092\u3088\u308A\u5C0F\u3055\u306A\u5B9F\u884C\u53EF\u80FD\u306A\u30D5\u30A1\u30A4\u30EB\u306B\u5206\u5272\u3057\u3001AI\u5C65\u6B74\u304B\u3089\u3044\u3064\u3067\u3082\u4F1A\u8A71\u3092\u518D\u958B\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002"}},"notesToPresentation":{"tourLabel":"\u6A5F\u5BC6\u6587\u66F8\u306E\u8981\u7D04\u3068\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306E\u4F5C\u6210\u3092\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u3048\u307E\u3059\u3002","learn":"Cephable\u306F\u3001\u6A5F\u5BC6\u6027\u306E\u9AD8\u3044\u30EC\u30DD\u30FC\u30C8\u3084\u30E1\u30E2\u3092\u8981\u7D04\u3057\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u30D5\u30A9\u30EB\u30C0\u5185\u306E\u30D5\u30A1\u30A4\u30EB\u5168\u4F53\u306B\u308F\u305F\u3063\u3066\u8981\u7D04\u51E6\u7406\u3092\u884C\u3044\u3001\u3055\u3089\u306B\u305D\u306E\u7D50\u679C\u304B\u3089\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u6A5F\u80FD\u306F\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u52D5\u4F5C\u3057\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u6A5F\u5BC6\u6587\u66F8\u306E\u8981\u7D04\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u305F\u30D5\u30A9\u30EB\u30C0\u5168\u4F53\u306E\u4E00\u62EC\u8981\u7D04\u3001\u305D\u3057\u3066\u305D\u306E\u7D50\u679C\u3092\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u5909\u63DB\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3057\u304B\u3082\u3001\u3053\u308C\u3089\u306E\u64CD\u4F5C\u306F\u3059\u3079\u3066\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u6F0F\u308C\u308B\u3053\u3068\u306A\u304F\u884C\u3048\u307E\u3059\u3002"}},"organizeDownloads":{"tourLabel":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3067\u30D5\u30A1\u30A4\u30EB\u3092\u6574\u7406\u3057\u3001\u4E0D\u8981\u306A\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u3001\u7D1B\u5931\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u3092\u898B\u3064\u3051\u51FA\u305D\u3046","learn":"Automate\u306F\u3001\u30D5\u30A1\u30A4\u30EB\u306E\u30B3\u30D4\u30FC\u3001\u524A\u9664\u3001\u691C\u7D22\u3068\u3044\u3063\u305F\u8907\u6570\u30B9\u30C6\u30C3\u30D7\u306E\u30D5\u30A1\u30A4\u30EB\u7BA1\u7406\u30BF\u30B9\u30AF\u3092\u3001\u7C21\u5358\u306A\u30D7\u30ED\u30F3\u30D7\u30C8\u304B\u3089\u76F4\u63A5\u51E6\u7406\u3067\u304D\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u30D5\u30A1\u30A4\u30EB\u3092\u6574\u7406\u3057\u305F\u308A\u3001\u6A29\u9650\u30C1\u30A7\u30C3\u30AF\u3092\u884C\u3044\u5B89\u5168\u306B\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7\u3057\u305F\u308A\u3001\u5834\u6240\u304C\u601D\u3044\u51FA\u305B\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u898B\u3064\u3051\u305F\u308A\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002"}},"outlookEmailProductivity":{"tourLabel":"Outlook\u3067\u97F3\u58F0\u5165\u529B\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3001AI\u3092\u6D3B\u7528\u3057\u3066\u30E1\u30FC\u30EB\u306E\u51E6\u7406\u901F\u5EA6\u3092\u5411\u4E0A\u3055\u305B\u307E\u3057\u3087\u3046","learn":"Cephable Plus\u3068Professional\u306B\u306F\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3068\u7DE8\u96C6\u306B\u5F79\u7ACB\u3064\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u97F3\u58F0\u5165\u529B\u30C4\u30FC\u30EB\u3068\u4F5C\u6210\u30C4\u30FC\u30EB\u304C\u642D\u8F09\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30C4\u30FC\u30EB\u3092Outlook\u5185\u3067\u76F4\u63A5\u4F7F\u7528\u3059\u308B\u3053\u3068\u3067\u3001\u30E1\u30FC\u30EB\u306E\u8FD4\u4FE1\u3084\u4E0B\u66F8\u304D\u3092\u3088\u308A\u8FC5\u901F\u306B\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u97F3\u58F0\u5165\u529B\u3067\u30E1\u30FC\u30EB\u306B\u8FD4\u4FE1\u3059\u308B\u65B9\u6CD5\u3001\u72EC\u81EA\u306E\u30AF\u30A4\u30C3\u30AF\u30BF\u30A4\u30D7\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u7528\u3059\u308B\u65B9\u6CD5\u3001\u305D\u3057\u3066\u8981\u7D04\u3068\u751F\u6210\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u30E1\u30FC\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u30FB\u63A8\u6572\u3059\u308B\u65B9\u6CD5\u304C\u3001\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u64CD\u4F5C\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002"}},"customizingGameControls":{"tourLabel":"\u97F3\u58F0\u64CD\u4F5C\u3067RPG\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3057\u3088\u3046","learn":"\u97F3\u58F0\u64CD\u4F5C\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066RPG\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u3087\u3046\u3002","tryOpen":{"title":"\u300C\u30DE\u30A4\u30F3\u30AF\u30E9\u30D5\u30C8\u3092\u958B\u304F\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"complete":{"description":"\u3053\u308C\u3067\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u4F7F\u3063\u3066RPG\u30B2\u30FC\u30E0\u3067\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u3092\u79FB\u52D5\u3001\u505C\u6B62\u3001\u64CD\u4F5C\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3055\u3089\u306B\u30B9\u30E0\u30FC\u30BA\u3067\u30B9\u30D4\u30FC\u30C7\u30A3\u30FC\u306A\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u306E\u305F\u3081\u306B\u3001\u4ED6\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u8A66\u3057\u305F\u308A\u3001\u72EC\u81EA\u306E\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u305F\u308A\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002"}},"voiceToTextSocialMedia":{"tourLabel":"LinkedIn\u3001Slack\u3001Discord\u5411\u3051\u306E\u97F3\u58F0\u30C6\u30AD\u30B9\u30C8\u5909\u63DB\u6A5F\u80FD","learn":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u97F3\u58F0\u5165\u529B\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u81EA\u7136\u306A\u6587\u7AE0\u3092\u4F5C\u6210\u3057\u3001\u305D\u306E\u5F8C\u66F8\u304D\u63DB\u3048\u6A5F\u80FD\u3067\u30C8\u30FC\u30F3\u3092\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002LinkedIn\u3001Slack\u3001Discord\u306A\u3069\u3001\u69D8\u3005\u306A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u540C\u69D8\u306E\u64CD\u4F5C\u304C\u53EF\u80FD\u3067\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001LinkedIn\u3001Slack\u3001Discord\u306A\u3069\u3001\u3055\u307E\u3056\u307E\u306A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067Rewrite\u3092\u4F7F\u3063\u3066\u6295\u7A3F\u3092\u97F3\u58F0\u5165\u529B\u3057\u3001\u63A8\u6572\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002"}},"aiDocumentTranslation":{"tourLabel":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u6587\u66F8\u3092\u4EFB\u610F\u306E\u8A00\u8A9E\u306B\u7FFB\u8A33","learn":"Cephable\u306F\u3001\u6587\u66F8\u3092\u4E00\u5EA6\u306B1\u3064\u306E\u8A00\u8A9E\u306B\u7FFB\u8A33\u3059\u308B\u3053\u3068\u3082\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u8907\u6570\u306E\u8A00\u8A9E\u306B\u540C\u6642\u306B\u7FFB\u8A33\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002\u3053\u308C\u3089\u306F\u3059\u3079\u3066\u30ED\u30FC\u30AB\u30EB\u3067\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u97F3\u58F0\u5165\u529B\u3092\u4F7F\u3063\u3066\u6587\u66F8\u3092\u5358\u4E00\u306E\u8A00\u8A9E\u306B\u7FFB\u8A33\u3059\u308B\u65B9\u6CD5\u3001\u3042\u308B\u3044\u306FAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u3063\u3066\u8907\u6570\u306E\u8A00\u8A9E\u306B\u540C\u6642\u306B\u7FFB\u8A33\u3059\u308B\u65B9\u6CD5\u304C\u5206\u304B\u308A\u307E\u3057\u305F\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u7D50\u3057\u307E\u3059\u3002"}},"excelAiAutomation":{"tourLabel":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30AA\u30F3\u30C7\u30D0\u30A4\u30B9AI\u3067\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u5206\u6790","learn":"Cephable\u306F\u3001Excel\u30D5\u30A1\u30A4\u30EB\u3092\u8AAD\u307F\u8FBC\u307F\u3001\u6570\u5024\u306B\u95A2\u3059\u308B\u8CEA\u554F\u306B\u7B54\u3048\u3001\u3055\u3089\u306B\u8A73\u7D30\u306A\u5206\u6790\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3057\u304B\u3082\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","complete":{"description":"\u3053\u308C\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u306B\u8CEA\u554F\u3057\u305F\u308A\u3001\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u3067\u3055\u3089\u306B\u6DF1\u304F\u6398\u308A\u4E0B\u3052\u305F\u308A\u3001\u8981\u7D04\u3092\u4FDD\u5B58\u3057\u305F\u308A\u3059\u308B\u65B9\u6CD5\u3092\u7406\u89E3\u3057\u307E\u3057\u305F\u3002\u3053\u308C\u3089\u3059\u3079\u3066\u304C\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002"}},"handsFreeComputerControl":{"tourLabel":"\u97F3\u58F0\u3068\u30AB\u30E1\u30E9\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u64CD\u4F5C\u3059\u308B","learn":"Cephable\u3092\u4F7F\u3048\u3070\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30DC\u30A4\u30B9\u30DE\u30A6\u30B9\u3001\u30AB\u30E1\u30E9\u3092\u4F7F\u3063\u305F\u982D\u90E8\u3084\u9854\u306E\u5236\u5FA1\u306B\u3088\u3063\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002","tryOpenWord":{"title":"\u300COpen Word\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002"},"openExtensions":{"title":"\u62E1\u5F35\u6A5F\u80FD\u30BF\u30D6\u3092\u958B\u304F","description":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u6709\u52B9\u306B\u3059\u308B\u306B\u306F\u3001\u30E1\u30A4\u30F3\u30A6\u30A3\u30F3\u30C9\u30A6\u306E\u300C\u62E1\u5F35\u6A5F\u80FD\u300D\u30BF\u30D6\u3092\u958B\u304D\u307E\u3059\u3002"},"turnOnCamera":{"title":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30AA\u30F3\u306B\u3059\u308B","description":"\u30AB\u30E1\u30E9\u3092\u30AA\u30F3\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044\u3002\u30DE\u30A4\u30AF\u30A2\u30A4\u30B3\u30F3\u306E\u6A2A\u306B\u30AB\u30E1\u30E9\u30A2\u30A4\u30B3\u30F3\u304C\u8868\u793A\u3055\u308C\u3001\u300C\u8A2D\u5B9A\u300D\u306B\u65B0\u3057\u3044\u300C\u30AB\u30E1\u30E9\u300D\u30BB\u30AF\u30B7\u30E7\u30F3\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"cameraInPanel":{"title":"\u30D1\u30CD\u30EB\u5185\u306E\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u30AB\u30E1\u30E9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u6709\u52B9\u306B\u306A\u308B\u3068\u3001Cephable\u30D1\u30CD\u30EB\u306B\u3082\u30AB\u30E1\u30E9\u306E\u5207\u308A\u66FF\u3048\u30DC\u30BF\u30F3\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002Cephable\u304C\u81EA\u52D5\u7684\u306B\u3053\u3053\u3067\u30AA\u30F3\u306B\u3057\u307E\u3059\u3002"},"openCameraSettings":{"title":"\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u958B\u304F","description":"\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u958B\u3044\u3066\u3001\u982D\u3068\u9854\u306E\u64CD\u4F5C\u65B9\u6CD5\u3092\u7D30\u304B\u304F\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"chooseHeadMouseMode":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u30E2\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u982D\u306E\u52D5\u304D\u306B\u3088\u308B\u30DE\u30A6\u30B9\u64CD\u4F5C\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\uFF1A\u5B89\u5B9A\u30B0\u30E9\u30A4\u30C9\u3001\u30B9\u30D4\u30FC\u30C9\u30D6\u30FC\u30B9\u30C8\u3001\u30C0\u30A4\u30CA\u30DF\u30C3\u30AF\u30B0\u30E9\u30A4\u30C9\u3002"},"complete":{"description":"\u3053\u308C\u3067\u3001\u97F3\u58F0\u3001\u97F3\u58F0\u30DE\u30A6\u30B9\u3001\u30AB\u30E1\u30E9\u3092\u4F7F\u3063\u305F\u982D\u3084\u9854\u306E\u8A8D\u8B58\u306B\u3088\u308B\u64CD\u4F5C\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u30AB\u30E1\u30E9\u8A2D\u5B9A\u3092\u3055\u3089\u306B\u8A73\u3057\u304F\u8ABF\u3079\u3066\u3001\u81EA\u5206\u306B\u5408\u3063\u305F\u64CD\u4F5C\u65B9\u6CD5\u3092\u69CB\u7BC9\u3057\u307E\u3057\u3087\u3046\u3002"}},"handsFreeTypingDocumentCreation":{"tourLabel":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u30FB\u7DE8\u96C6","learn":"\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u7D44\u307F\u5408\u308F\u305B\u3066\u4F7F\u7528\u3059\u308B\u3053\u3068\u3067\u3001\u8ACB\u6C42\u66F8\u306A\u3069\u306E\u6587\u66F8\u3092\u307B\u307C\u5B8C\u5168\u306B\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u4F5C\u6210\u304A\u3088\u3073\u7DE8\u96C6\u3067\u304D\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3092\u4F7F\u3063\u3066\u3001\u307B\u307C\u5B8C\u5168\u306B\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u6587\u66F8\u3092\u4F5C\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u7DE8\u96C6\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002"}},"webResearchCreateHtml":{"tourLabel":"\u30A6\u30A7\u30D6\u3092\u8ABF\u67FB\u3057\u3001\u305D\u308C\u3092\u3082\u3068\u306B\u30B5\u30A4\u30C8\u3092\u69CB\u7BC9\u3059\u308B \u2015 \u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u7D50","learn":"Cephable\u306F\u7AF6\u5408\u4ED6\u793E\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3092\u95B2\u89A7\u30FB\u5206\u6790\u3057\u3001\u305D\u306E\u7D50\u679C\u306B\u57FA\u3065\u3044\u3066\u65B0\u3057\u3044HTML\u30B5\u30A4\u30C8\u3092\u751F\u6210\u3057\u307E\u3059\u3002\u3053\u306E\u51E6\u7406\u306F\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u8ABF\u67FB\u5185\u5BB9\u306F\u975E\u516C\u958B\u306B\u4FDD\u305F\u308C\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u7AF6\u5408\u4ED6\u793E\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3092\u8ABF\u67FB\u3057\u3001\u305D\u306E\u7D50\u679C\u306B\u57FA\u3065\u3044\u3066\u65B0\u3057\u3044HTML\u30B5\u30A4\u30C8\u3092\u751F\u6210\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3057\u304B\u3082\u3001\u3053\u308C\u3089\u306E\u64CD\u4F5C\u306F\u3059\u3079\u3066\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306A\u304F\u884C\u3048\u307E\u3059\u3002"}},"webResearchSummarize":{"tourLabel":"\u898F\u5236\u3092\u8ABF\u67FB\u3057\u3001\u8ABF\u67FB\u7D50\u679C\u3092\u8981\u7D04\u3059\u308B \u2014 \u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u65BD","learn":"Cephable\u306F\u30A6\u30A7\u30D6\u3092\u95B2\u89A7\u3057\u3066\u3001\u65B0\u3057\u3044\u30C7\u30FC\u30BF\u4FDD\u8B77\u6CD5\u306A\u3069\u306E\u5909\u66F4\u70B9\u3092\u8ABF\u67FB\u3057\u3001\u8ABF\u67FB\u7D50\u679C\u3092\u30C1\u30FC\u30E0\u304C\u5B9F\u884C\u3067\u304D\u308B\u5F62\u3067\u8981\u7D04\u3057\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u884C\u308F\u308C\u308B\u305F\u3081\u3001\u8ABF\u67FB\u5185\u5BB9\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u306F\u4FDD\u8B77\u3055\u308C\u307E\u3059\u3002","complete":{"description":"\u3053\u308C\u3067\u3001AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u898F\u5236\u5909\u66F4\u3092\u8ABF\u67FB\u3057\u3001\u5B9F\u88C5\u306E\u8A73\u7D30\u3092\u6398\u308A\u4E0B\u3052\u3001\u8ABF\u67FB\u7D50\u679C\u3092\u30C1\u30FC\u30E0\u304C\u7E70\u308A\u8FD4\u3057\u691C\u8A0E\u3067\u304D\u308B\u30E1\u30FC\u30EB\u3068\u3057\u3066\u4F5C\u6210\u3059\u308B\u65B9\u6CD5\u304C\u308F\u304B\u308A\u307E\u3057\u305F\u3002\u3057\u304B\u3082\u3001\u3053\u308C\u3089\u306E\u64CD\u4F5C\u306F\u3059\u3079\u3066\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306A\u304F\u884C\u3048\u307E\u3059\u3002"}},"stopListening":{"title":"\u300C\u805E\u304F\u306E\u3092\u3084\u3081\u3066\u300D\u3068\u8A00\u3063\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002","description":"\u3053\u308C\u306F\u30DE\u30A4\u30AF\u3092\u5B8C\u5168\u306B\u30AA\u30D5\u306B\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u4E00\u6642\u505C\u6B62\u3057\u307E\u3059\u3002\u6E96\u5099\u304C\u3067\u304D\u305F\u3089\u3001\u3082\u3046\u4E00\u5EA6\u300C\u518D\u751F\u958B\u59CB\u300D\u3068\u8A00\u3063\u3066\u304F\u3060\u3055\u3044\u3002"}}');


var $3a6703d76fc08995$exports = {};
$3a6703d76fc08995$exports = JSON.parse('{"introduction":{"title":"\u3053\u3093\u306B\u3061\u306F\u3001Cephable\u3067\u3059\u3002","back":"\u306F\u3058\u3081\u306B\u623B\u308B","description":"\u79C1\u306F\u3042\u306A\u305F\u306E\u30D1\u30FC\u30BD\u30CA\u30EBAI\u3067\u3059\u3002\u4F7F\u3044\u6163\u308C\u305F\u30C4\u30FC\u30EB\u3092\u4F7F\u3063\u3066\u3001\u3042\u3089\u3086\u308B\u63A5\u7D9A\u74B0\u5883\u306B\u304A\u3051\u308B\u5236\u5FA1\u3001\u4F5C\u6210\u3001\u81EA\u52D5\u5316\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u79C1\u306B\u3064\u3044\u3066\u3044\u304F\u3064\u304B\u77E5\u3063\u3066\u304A\u304F\u3079\u304D\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002","action":"\u3055\u3042\u3001\u59CB\u3081\u307E\u3057\u3087\u3046\uFF01","recording":{"title":"\u97F3\u58F0\u3068\u30D3\u30C7\u30AA\u306F\u30ED\u30FC\u30AB\u30EB\u306E\u307E\u307E\u3067\u3059\u3002","description":"\u3042\u306A\u305F\u306E\u97F3\u58F0\u3084\u52D5\u753B\u3092\u9332\u97F3\u3001\u30B9\u30C8\u30EA\u30FC\u30DF\u30F3\u30B0\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u9001\u4FE1\u3059\u308B\u3053\u3068\u306F\u4E00\u5207\u3042\u308A\u307E\u305B\u3093\u3002\u3059\u3079\u3066\u306E\u5165\u529B\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u51E6\u7406\u3055\u308C\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3068\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u304C\u78BA\u4FDD\u3055\u308C\u307E\u3059\u3002"},"data":{"title":"\u3042\u306A\u305F\u306E\u30C7\u30FC\u30BF\u306F\u3042\u306A\u305F\u306E\u3082\u306E\u3067\u3059\u3002","description":"\u3042\u306A\u305F\u306E\u30B3\u30DE\u30F3\u30C9\u3084\u30A2\u30AF\u30C6\u30A3\u30D3\u30C6\u30A3\u3092\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u30E2\u30C7\u30EB\u5B66\u7FD2\u306B\u5229\u7528\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3059\u3079\u3066\u306F\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306B\u4FDD\u305F\u308C\u3001\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306F\u63A5\u7D9A\u9593\u3067\u3082\u5171\u6709\u3055\u308C\u307E\u3059\u3002"},"offline":{"title":"\u4ED6\u306E\u30C4\u30FC\u30EB\u304C\u6A5F\u80FD\u3057\u306A\u3044\u3068\u304D\u306B\u3082\u6A5F\u80FD\u3057\u307E\u3059\u3002","description":"\u30B3\u30F3\u30C6\u30F3\u30C4\u751F\u6210\u3001\u30EA\u30E9\u30A4\u30C8\u3001\u7FFB\u8A33\u3001\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3\u3068\u3044\u3063\u305F\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30BF\u30B9\u30AF\u306F\u3059\u3079\u3066\u30ED\u30FC\u30AB\u30EB\u3067\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002\u30AF\u30E9\u30A6\u30C9\u306F\u4E0D\u8981\u3067\u3059\u3002\u3064\u307E\u308A\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u3082\u4F5C\u696D\u304C\u53EF\u80FD\u3067\u3001\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u6F0F\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"empower":{"title":"\u643E\u53D6\u3059\u308B\u305F\u3081\u3067\u306F\u306A\u304F\u3001\u529B\u3092\u4E0E\u3048\u308B\u305F\u3081\u306B\u69CB\u7BC9\u3055\u308C\u307E\u3057\u305F\u3002","description":"\u79C1\u306F\u3042\u306A\u305F\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u5F37\u5316\u3059\u308B\u305F\u3081\u306B\u8A2D\u8A08\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u76E3\u8996\u3059\u308B\u305F\u3081\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u4FB5\u5165\u7684\u306A\u8FFD\u8DE1\u3084\u4E0D\u6C17\u5473\u306A\u30C7\u30FC\u30BF\u53CE\u96C6\u306F\u4E00\u5207\u3042\u308A\u307E\u305B\u3093\u3002\u3042\u306A\u305F\u306B\u3068\u3063\u3066\u4F7F\u3044\u3084\u3059\u3044\u5165\u529B\u3060\u3051\u3092\u3002"}},"my-capabilities":{"title":"\u5B8C\u74A7\u3067\u3059\uFF01\u79C1\u304C\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u3053\u3068\u306F\u6B21\u306E\u3068\u304A\u308A\u3067\u3059\u3002","back":"\u6A5F\u80FD\u306B\u623B\u308B","actionTitle":"\u79C1\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","description":"Cephable\u304C\u63D0\u4F9B\u3059\u308B3\u3064\u306E\u6A5F\u80FD\u306B\u6CBF\u3063\u3066\u6574\u7406\u3057\u305F\u3001\u304A\u5BA2\u69D8\u306E\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u6700\u3082\u95A2\u9023\u6027\u306E\u9AD8\u3044\u6A5F\u80FD\u3068\u6027\u80FD\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","action":{"title":"\u79C1\u306E\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","description":"\u65E5\u3005\u306E\u696D\u52D9\u3067\u79C1\u304C\u3069\u306E\u3088\u3046\u306B\u30B5\u30DD\u30FC\u30C8\u3067\u304D\u308B\u304B\u3001\u3044\u304F\u3064\u304B\u306E\u4F8B\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"basedOnInterests":"\u3042\u306A\u305F\u306E\u8208\u5473\u306B\u57FA\u3065\u3044\u3066","cta":{"eyebrow":"\u6E96\u5099\u304C\u3067\u304D\u305F\u3089","title":"\u30A2\u30D7\u30EA\u3067\u306E\u52D5\u4F5C\u3092\u78BA\u8A8D"}},"see-me":{"title":"\u79C1\u304C\u3042\u306A\u305F\u306E\u3088\u3046\u306A\u4ED6\u306E\u4EBA\u9054\u3092\u3069\u306E\u3088\u3046\u306B\u52A9\u3051\u3066\u304D\u305F\u304B\u77E5\u308A\u305F\u3044\u3067\u3059\u304B?","back":"\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u306B\u623B\u308B","description":"\u3055\u307E\u3056\u307E\u306A\u696D\u754C\u3084\u5F79\u5272\u306B\u308F\u305F\u3063\u3066\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u3069\u306E\u3088\u3046\u306B\u5909\u9769\u3057\u305F\u304B\u3001\u5B9F\u969B\u306E\u4F8B\u3092\u3044\u304F\u3064\u304B\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"},"complete":{"title":"\u79C1\u3092\u4F7F\u3044\u59CB\u3081\u308B\u6E96\u5099\u306F\u3067\u304D\u307E\u3057\u305F\u304B?","description":"\u79C1\u306E\u5B9F\u529B\u3001\u3054\u89A7\u3044\u305F\u3060\u3051\u307E\u3057\u305F\u3067\u3057\u3087\u3046\u304B\uFF1F\u3055\u3042\u3001\u8A2D\u5B9A\u3092\u3057\u3066\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u5909\u9769\u3092\u59CB\u3081\u307E\u3057\u3087\u3046\u3002\u6700\u5F8C\u307E\u3067\u5168\u529B\u3067\u30B5\u30DD\u30FC\u30C8\u3044\u305F\u3057\u307E\u3059\u3002","action":"\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3092\u5B8C\u4E86\u3057\u3066Cephable\u306E\u4F7F\u7528\u3092\u958B\u59CB\u3059\u308B"},"apps":{"title":"\u3059\u3067\u306B\u611B\u7528\u3055\u308C\u3066\u3044\u308B\u30C4\u30FC\u30EB\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059","description":"200\u4EE5\u4E0A\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u4E8B\u524D\u8A2D\u5B9A\u6E08\u307F\u3067\u30B5\u30DD\u30FC\u30C8\u3002\u6BCE\u65E5\u4F7F\u7528\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u305D\u306E\u307E\u307E\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u8A2D\u5B9A\u306F\u4E0D\u8981\u3067\u3059\u3002","note":"\u304A\u4F7F\u3044\u306E\u30A2\u30D7\u30EA\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u3067\u3082\u3001\u554F\u984C\u3042\u308A\u307E\u305B\u3093\u3002\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u751F\u6210\u3057\u305F\u308A\u3001\u304A\u5BA2\u69D8\u306B\u6700\u9069\u306A\u30AB\u30B9\u30BF\u30E0\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306E\u4F5C\u6210\u3092\u304A\u624B\u4F1D\u3044\u3057\u307E\u3059\u3002","andMore":"\u305D\u306E\u4ED6","eyebrow":"200\u4EE5\u4E0A\u306E\u30A2\u30D7\u30EA\u3001\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u4E0D\u8981"},"actions":{"ctaTry":"\u4ECA\u3059\u3050\u8A66\u3059","ctaWatch":"\u30C7\u30E2\u3092\u898B\u308B","apps":"\u9069\u5408\u3059\u308B\u3082\u306E:","abilities":"\u4F7F\u7528\u3057\u305F\u80FD\u529B:"},"interests":{"title":"\u4F55\u3092\u304A\u624B\u4F1D\u3044\u3057\u307E\u3057\u3087\u3046\u304B\uFF1F","back":"\u8208\u5473\u306B\u623B\u308B","description":"\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u3084\u63A5\u7D9A\u3055\u308C\u305F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E\u30A2\u30D7\u30EA\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3057\u307E\u3057\u3087\u3046\u3002\u7279\u306B\u3054\u8208\u5473\u306E\u3042\u308B\u5206\u91CE\u306F\u4F55\u3067\u3059\u304B\uFF1F","note":"\u8A72\u5F53\u3059\u308B\u3082\u306E\u3092\u3059\u3079\u3066\u9078\u629E\u3059\u308B\u3068\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u6700\u3082\u95A2\u9023\u6027\u306E\u9AD8\u3044\u6A5F\u80FD\u3068\u4F8B\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002","action":"{{count}}\u4EF6\u306E\u8208\u5473\u3092\u7D99\u7D9A","empty":"\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u306E\u8208\u5473\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","create_design":{"label":"\u4F5C\u6210\u3068\u30C7\u30B6\u30A4\u30F3","shortLabel":"\u30C7\u30B6\u30A4\u30F3","description":"\u30A2\u30FC\u30C6\u30A3\u30B9\u30C8\u3001\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u62C5\u5F53\u8005\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u30AF\u30EA\u30A8\u30A4\u30BF\u30FC\u5411\u3051\u3002"},"analyze_report":{"label":"\u5206\u6790\u3068\u30EC\u30DD\u30FC\u30C8","shortLabel":"\u5206\u6790\u3059\u308B","description":"\u30A2\u30CA\u30EA\u30B9\u30C8\u3001\u7814\u7A76\u8005\u3001\u30D3\u30B8\u30CD\u30B9\u30D7\u30ED\u30D5\u30A7\u30C3\u30B7\u30E7\u30CA\u30EB\u5411\u3051\u3002"},"communicate_collaborate":{"label":"\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3068\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3","shortLabel":"\u901A\u4FE1\u3059\u308B","description":"\u8CA9\u58F2\u8005\u3001\u4F1A\u8B70\u3001\u30EA\u30E2\u30FC\u30C8 \u30C1\u30FC\u30E0\u5411\u3051\u3002"},"build_develop":{"label":"\u69CB\u7BC9\u3068\u958B\u767A","shortLabel":"\u958B\u767A\u3059\u308B","description":"\u958B\u767A\u8005\u3001\u30A8\u30F3\u30B8\u30CB\u30A2\u3001\u6280\u8853\u5C02\u9580\u5BB6\u5411\u3051\u3002"},"game_play":{"label":"\u30B2\u30FC\u30E0\u3068\u30D7\u30EC\u30A4","shortLabel":"\u30B2\u30FC\u30E0","description":"\u30B2\u30FC\u30DE\u30FC\u3001\u30B9\u30C8\u30EA\u30FC\u30DE\u30FC\u3001\u30E1\u30C7\u30A3\u30A2 \u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u5411\u3051\u3002"},"learn_teach":{"label":"\u5B66\u3076\uFF06\u6559\u3048\u308B","shortLabel":"\u5B66\u3076","description":"\u6559\u80B2\u8005\u3001\u5B66\u751F\u3001\u6307\u5C0E\u54E1\u5411\u3051\u3002"},"manage_organize":{"label":"\u7BA1\u7406\u3068\u6574\u7406","shortLabel":"\u7D44\u7E54\u5316","description":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DE\u30CD\u30FC\u30B8\u30E3\u30FC\u3001\u30B3\u30FC\u30C7\u30A3\u30CD\u30FC\u30BF\u30FC\u3001\u30AA\u30FC\u30AC\u30CA\u30A4\u30B6\u30FC\u5411\u3051\u3002"},"adapt_access":{"label":"\u9069\u5FDC\u3068\u30A2\u30AF\u30BB\u30B9","shortLabel":"\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3","description":"\u9069\u5FDC\u578B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30A2\u30AF\u30BB\u30B7\u30D3\u30EA\u30C6\u30A3\u306E\u30CB\u30FC\u30BA\u306B\u5BFE\u5FDC\u3057\u307E\u3059\u3002"},"everything":{"label":"\u3042\u3089\u3086\u308B\u3082\u306E\u3092\u5C11\u3057\u305A\u3064","shortLabel":"\u3059\u3079\u3066","description":"\u4E00\u822C\u7684\u306A\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u30E6\u30FC\u30B6\u30FC\u304A\u3088\u3073\u30DE\u30EB\u30C1\u30BF\u30B9\u30AF\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u3002"},"filter":"\u8208\u5473\u306E\u7A2E\u985E\u3067\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0"},"capabilities":{"title":"\u79C1\u306E\u30B3\u30A2AI\u6A5F\u80FD","description":"\u9AD8\u5EA6\u306AAI\u3068\u5F37\u529B\u306A\u5165\u529B\u65B9\u6CD5\u3092\u7D44\u307F\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u30A2\u30D7\u30EA\u3084\u30C7\u30D0\u30A4\u30B9\u3092\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u79C1\u304C\u3067\u304D\u308B\u3053\u3068\u306E\u4E00\u90E8\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002","voice_controls":{"title":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u81EA\u7136\u8A00\u8A9E\u30B3\u30DE\u30F3\u30C9\u3092\u7406\u89E3\u3057\u3066\u3044\u308B\u306E\u3067\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3092\u97F3\u58F0\u3067\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002","longDescription":"\u81EA\u7136\u306A\u8A71\u3057\u65B9\u3067\u3001\u7269\u4E8B\u3092\u30B9\u30E0\u30FC\u30BA\u306B\u9032\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30A2\u30D7\u30EA\u3092\u958B\u3044\u305F\u308A\u3001\u30E1\u30CB\u30E5\u30FC\u3092\u64CD\u4F5C\u3057\u305F\u308A\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u958B\u59CB\u3057\u305F\u308A\u3057\u305F\u3044\u6642\u3001\u5206\u304B\u308A\u3084\u3059\u3044\u82F1\u8A9E\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u78BA\u5B9F\u306A\u64CD\u4F5C\u306B\u5909\u63DB\u3057\u307E\u3059\u3002"},"smart_dictation":{"title":"\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u30C7\u30A3\u30AF\u30C6\u30FC\u30B7\u30E7\u30F3","description":"\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u8A8D\u8B58\u3068\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u3042\u306A\u305F\u306E\u30B9\u30D4\u30FC\u30C1\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","longDescription":"\u79C1\u306F\u3042\u306A\u305F\u306E\u8A00\u8449\u3092\u6CE8\u610F\u6DF1\u304F\u805E\u304D\u3001\u6B63\u78BA\u306B\u66F8\u304D\u7559\u3081\u307E\u3059\u3002\u53E5\u8AAD\u70B9\u3092\u8FFD\u52A0\u3057\u3001\u5927\u6587\u5B57\u5C0F\u6587\u5B57\u3092\u4FEE\u6B63\u3057\u3001\u6587\u8108\u306B\u5FDC\u3058\u305F\u66F8\u5F0F\u8A2D\u5B9A\u3092\u9069\u7528\u3059\u308B\u306E\u3067\u3001\u4F59\u8A08\u306A\u624B\u9593\u3092\u304B\u3051\u305A\u306B\u6D17\u7DF4\u3055\u308C\u305F\u6587\u7AE0\u306B\u4ED5\u4E0A\u304C\u308A\u307E\u3059\u3002"},"ai_text_generation":{"title":"AI\u30C6\u30AD\u30B9\u30C8\u751F\u6210","description":"\u30E1\u30FC\u30EB\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B3\u30FC\u30C9\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5373\u5EA7\u306B\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","longDescription":"\u30A2\u30D7\u30EA\u5185\u3067\u76F4\u63A5\u3001\u4E0B\u66F8\u304D\u3001\u8981\u7D04\u3001\u62E1\u5F35\u306A\u3069\u3001\u3042\u3089\u3086\u308B\u4F5C\u696D\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u30E1\u30FC\u30EB\u3084\u30E1\u30E2\u304B\u3089\u30B3\u30FC\u30C9\u30B9\u30CB\u30DA\u30C3\u30C8\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u307E\u3067\u3001\u767D\u7D19\u306E\u72B6\u614B\u304B\u3089\u59CB\u3081\u308B\u3053\u3068\u306A\u304F\u3001\u30B9\u30E0\u30FC\u30BA\u306B\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"head_face_controls":{"title":"\u30D8\u30C3\u30C9\uFF06\u30D5\u30A7\u30A4\u30B9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u982D\u3084\u9854\u306E\u52D5\u304D\u3067\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u8D77\u3053\u305B\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3042\u306A\u305F\u306E\u81EA\u7136\u306A\u982D\u306E\u52D5\u304D\u3084\u8868\u60C5\u3092\u3001\u6B63\u78BA\u306A\u5165\u529B\u306B\u5909\u63DB\u3057\u307E\u3059\u3002\u7B11\u9854\u3067\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u305F\u308A\u3001\u3046\u306A\u305A\u304D\u306A\u304C\u3089\u30DA\u30FC\u30B8\u3092\u3081\u304F\u3063\u305F\u308A\u3001\u7709\u3092\u4E0A\u3052\u3066\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002"},"natural_language_voice_clicking":{"title":"\u81EA\u7136\u8A00\u8A9E\u97F3\u58F0\u30AF\u30EA\u30C3\u30AF","description":"\u753B\u9762\u4E0A\u306E\u30DC\u30BF\u30F3\u3001\u30EA\u30F3\u30AF\u3001\u30E1\u30CB\u30E5\u30FC\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u304D\u306B\u3001\u898B\u305F\u3082\u306E\u3092\u305D\u306E\u307E\u307E\u767A\u97F3\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u753B\u9762\u4E0A\u306E\u4F55\u304B\u306E\u540D\u524D\u3092\u8A71\u3059\u3068\u3001\u79C1\u304C\u305D\u308C\u3092\u898B\u3064\u3051\u3066\u64CD\u4F5C\u3057\u307E\u3059\u3002\u30B3\u30DE\u30F3\u30C9\u3092\u899A\u3048\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u6B32\u3057\u3044\u3082\u306E\u3092\u8AAC\u660E\u3059\u308B\u3060\u3051\u3067\u3001\u30AF\u30EA\u30C3\u30AF\u306F\u79C1\u304C\u884C\u3044\u307E\u3059\u3002"},"keyboard_mouse_emulation":{"title":"\u30AD\u30FC\u30DC\u30FC\u30C9\u3068\u30DE\u30A6\u30B9\u306E\u30A8\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3","description":"\u30AD\u30FC\u3001\u30AF\u30EA\u30C3\u30AF\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u3092\u30A8\u30DF\u30E5\u30EC\u30FC\u30C8\u3059\u308B\u306E\u3067\u3001\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u306A\u3057\u3067\u30A2\u30D7\u30EA\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002","longDescription":"\u30AD\u30FC\u30B9\u30C8\u30ED\u30FC\u30AF\u3001\u30DE\u30A6\u30B9\u306E\u52D5\u304D\u3001\u30AF\u30EA\u30C3\u30AF\u3001\u30B9\u30AF\u30ED\u30FC\u30EB\u30A4\u30D9\u30F3\u30C8\u3092\u5FC5\u8981\u306A\u5834\u6240\u306B\u9001\u4FE1\u3057\u307E\u3059\u3002\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3084\u30D8\u30C3\u30C9\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u7D44\u307F\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u5F93\u6765\u306E\u5165\u529B\u30C7\u30D0\u30A4\u30B9\u3092\u5B8C\u5168\u306B\u7F6E\u304D\u63DB\u3048\u305F\u308A\u3001\u5F37\u5316\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002"},"profiles_personalization":{"title":"\u30D1\u30FC\u30BD\u30CA\u30E9\u30A4\u30BC\u30FC\u30B7\u30E7\u30F3","description":"\u3042\u306A\u305F\u306E\u597D\u307F\u3092\u8A18\u61B6\u3057\u3001\u4FDD\u5B58\u3055\u308C\u305F\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u306B\u9069\u5FDC\u3057\u307E\u3059\u3002","longDescription":"\u304A\u6C17\u306B\u5165\u308A\u306E\u30A2\u30D7\u30EA\u3001\u30B3\u30DE\u30F3\u30C9\u3001\u8A2D\u5B9A\u3092\u5E38\u306B\u8A18\u9332\u3057\u307E\u3059\u3002\u30A2\u30D7\u30EA\u306E\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u81EA\u52D5\u307E\u305F\u306F\u624B\u52D5\u3067\u5207\u308A\u66FF\u3048\u308B\u3068\u3001\u5E38\u306B\u3042\u306A\u305F\u306E\u4F5C\u696D\u306B\u6700\u9069\u306A\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"},"cross_device_connectivity":{"title":"\u30AF\u30ED\u30B9\u30C7\u30D0\u30A4\u30B9\u63A5\u7D9A","description":"\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u4F7F\u3063\u3066\u9060\u9694\u3067\u81EA\u52D5\u5316\u3092\u958B\u59CB\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3057\u305F\u3002","longDescription":"\u30E2\u30D0\u30A4\u30EB\u30C7\u30D0\u30A4\u30B9\u3092\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u306B\u63A5\u7D9A\u3059\u308C\u3070\u3001\u30B3\u30DE\u30F3\u30C9\u306E\u8D77\u52D5\u3001\u97F3\u58F0\u5165\u529B\u3001\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u304C\u7C21\u5358\u306B\u884C\u3048\u307E\u3059\u3002\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u3001\u30EA\u30E2\u30FC\u30C8\u30BB\u30C3\u30B7\u30E7\u30F3\u3001\u307E\u305F\u306F\u666E\u6BB5\u4F7F\u3044\u306B\u6700\u9069\u3067\u3059\u3002"},"quick_action_buttons":{"title":"\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3","description":"\u7D20\u65E9\u3044\u30A2\u30AF\u30B7\u30E7\u30F3\u306E\u305F\u3081\u306B\u30A2\u30D7\u30EA\u5BFE\u5FDC\u30DC\u30BF\u30F3\u3092\u7528\u610F\u3057\u307E\u3057\u305F\u3002","longDescription":"\u30A2\u30D7\u30EA\u306B\u5408\u308F\u305B\u3066\u72B6\u6CC1\u306B\u5FDC\u3058\u305F\u30DC\u30BF\u30F3\u3092\u914D\u7F6E\u3057\u307E\u3059\u3002\u4F1A\u8B70\u3078\u306E\u53C2\u52A0\u3001\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u9001\u4FE1\u3001\u30E1\u30FC\u30EB\u306E\u65B0\u898F\u4F5C\u6210\u306A\u3069\u3001\u8907\u96D1\u306A\u30BF\u30B9\u30AF\u3082\u30EF\u30F3\u30AF\u30EA\u30C3\u30AF\u3067\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002"},"ai_app_awareness":{"title":"AI\u30A2\u30D7\u30EA\u8A8D\u8B58","description":"\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u306B\u5FDC\u3058\u3066\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002","longDescription":"\u753B\u9762\u4E0A\u3067\u4F55\u304C\u30A2\u30AF\u30C6\u30A3\u30D6\u306B\u306A\u3063\u3066\u3044\u308B\u304B\u306B\u6CE8\u610F\u3092\u6255\u3044\u3001\u9069\u5207\u306A\u30BF\u30A4\u30DF\u30F3\u30B0\u3067\u9069\u5207\u306A\u64CD\u4F5C\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u7169\u96D1\u3055\u3084\u63A8\u6E2C\u306F\u4E00\u5207\u306A\u304F\u3001\u5FC5\u8981\u306A\u6642\u306B\u5FC5\u8981\u306A\u3082\u306E\u3060\u3051\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u30C7\u30FC\u30BF\u3092\u9001\u4FE1\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"ai_rewrite":{"title":"AI\u306B\u3088\u308B\u66F8\u304D\u63DB\u3048","description":"\u30C6\u30AD\u30B9\u30C8\u3092\u66F8\u304D\u76F4\u3057\u3066\u3001\u30C8\u30FC\u30F3\u3092\u6539\u5584\u3057\u305F\u308A\u3001\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3092\u66F4\u65B0\u3057\u305F\u308A\u3001\u8A73\u7D30\u3092\u62E1\u5F35\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002","longDescription":"\u4F5C\u696D\u4E2D\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u305D\u306E\u5834\u3067\u7DE8\u96C6\u3057\u307E\u3059\u3002\u3088\u308A\u89AA\u3057\u307F\u3084\u3059\u304F\u3001\u3088\u308A\u30D5\u30A9\u30FC\u30DE\u30EB\u306B\u3001\u3088\u308A\u77ED\u304F\u3001\u3088\u308A\u9577\u304F\u3001\u3088\u308A\u8A73\u7D30\u306B\u306A\u3069\u3001\u304A\u5BA2\u69D8\u306E\u3054\u8981\u671B\u306B\u5408\u308F\u305B\u3066\u3001\u3088\u308A\u52B9\u679C\u7684\u306B\u4F1D\u3048\u307E\u3059\u3002"},"ai_translation":{"title":"AI\u7FFB\u8A33","description":"\u8A00\u8A9E\u9593\u3001\u3055\u3089\u306B\u306F\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u9593\u306E\u7FFB\u8A33\u3082\u53EF\u80FD\u3067\u3059\u3002","longDescription":"\u30C6\u30AD\u30B9\u30C8\u3092\u5225\u306E\u97F3\u58F0\u8A00\u8A9E\u306B\u5909\u63DB\u3057\u305F\u308A\u3001\u30B3\u30FC\u30C9\u3092\u5225\u306E\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u8A00\u8A9E\u306B\u5909\u63DB\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u4F5C\u696D\u306F\u73FE\u5834\u3067\u884C\u3044\u307E\u3059\u306E\u3067\u3001\u73FE\u5728\u4F7F\u7528\u3057\u3066\u3044\u308B\u30A2\u30D7\u30EA\u3092\u96E2\u308C\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002"},"head_mouse":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9","description":"\u982D\u306E\u52D5\u304D\u306B\u5408\u308F\u305B\u3066\u30DE\u30A6\u30B9\u30AB\u30FC\u30BD\u30EB\u3092\u79FB\u52D5\u3055\u305B\u307E\u3059\u3002","longDescription":"\u982D\u306E\u52D5\u304D\u3092\u30B9\u30E0\u30FC\u30BA\u306B\u30AB\u30FC\u30BD\u30EB\u3078\u5909\u63DB\u3057\u307E\u3059\u3002\u30B0\u30E9\u30A4\u30C9\u6A5F\u80FD\u3084\u611F\u5EA6\u8ABF\u6574\u6A5F\u80FD\u306A\u3069\u306B\u3088\u308A\u3001\u6B63\u78BA\u3067\u5FEB\u9069\u306A\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u64CD\u4F5C\u3092\u5B9F\u73FE\u3057\u307E\u3059\u3002"},"head_joystick":{"title":"\u30D8\u30C3\u30C9\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF","description":"\u30B2\u30FC\u30E0\u3084\u30A2\u30D7\u30EA\u306E\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u3068\u3057\u3066\u982D\u3092\u4F7F\u3048\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3042\u306A\u305F\u306E\u982D\u306E\u52D5\u304D\u3092\u30B8\u30E7\u30A4\u30B9\u30C6\u30A3\u30C3\u30AF\u306E\u8EF8\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3059\u308B\u3053\u3068\u3067\u3001\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2\u3092\u4F7F\u308F\u305A\u306B\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3057\u305F\u308A\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u64CD\u4F5C\u3057\u305F\u308A\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002\u3042\u306A\u305F\u306E\u81EA\u7136\u306A\u52D5\u304D\u3092\u3001\u79C1\u304C\u30A2\u30CA\u30ED\u30B0\u5165\u529B\u306B\u5909\u63DB\u3057\u307E\u3059\u3002"},"mcp_agent":{"title":"MCP\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8","description":"\u30E2\u30C7\u30EB\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30D7\u30ED\u30C8\u30B3\u30EB (MCP) \u3092\u4ECB\u3057\u3066\u5916\u90E8 AI \u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306B\u63A5\u7D9A\u3067\u304D\u307E\u3059\u3002","longDescription":"\u79C1\u306F\u30E2\u30C7\u30EB\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u30D7\u30ED\u30C8\u30B3\u30EB\u3092\u8A71\u3057\u3001\u4ED6\u306EAI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3084\u30C4\u30FC\u30EB\u3068\u9023\u643A\u3057\u3066\u4F5C\u696D\u3067\u304D\u307E\u3059\u3002\u3064\u307E\u308A\u3001\u30BF\u30B9\u30AF\u3092\u8ABF\u6574\u3057\u3001\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u3092\u4EA4\u63DB\u3057\u3001\u5C02\u7528\u306E\u5916\u90E8\u30B7\u30B9\u30C6\u30E0\u3068\u9023\u643A\u3057\u3066\u80FD\u529B\u3092\u62E1\u5F35\u3067\u304D\u308B\u306E\u3067\u3059\u3002\u3057\u304B\u3082\u3001\u3059\u3079\u3066\u30E6\u30FC\u30B6\u30FC\u304C\u5236\u5FA1\u3067\u304D\u307E\u3059\u3002"},"byo_ai_integration":{"title":"\u72EC\u81EA\u306EAI\u3092\u5C0E\u5165\u3059\u308B","description":"\u65E2\u5B58\u306E AI \u3092\u3001\u72EC\u81EA\u306E AI \u30E2\u30C7\u30EB\u3084\u30B5\u30FC\u30D3\u30B9\u3067\u5F37\u5316\u3057\u3066\u3001\u4E00\u7DD2\u306B\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002","longDescription":"\u3059\u3067\u306B\u4FE1\u983C\u3067\u304D\u308BAI\u30B5\u30FC\u30D3\u30B9\u3001\u30E2\u30C7\u30EB\u3001\u307E\u305F\u306F\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3092\u304A\u6301\u3061\u306E\u5834\u5408\u306F\u3001\u305D\u308C\u3089\u3092\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u7D71\u5408\u3067\u304D\u307E\u3059\u3002\u751F\u6210\u3001\u66F8\u304D\u63DB\u3048\u3001\u7FFB\u8A33\u306B\u4F7F\u7528\u3059\u308B\u30A8\u30F3\u30B8\u30F3\u306F\u3001\u30AF\u30E9\u30A6\u30C9\u3001\u30ED\u30FC\u30AB\u30EB\u3001\u30AB\u30B9\u30BF\u30E0\u306A\u3069\u3001\u67D4\u8EDF\u306B\u304A\u9078\u3073\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u30AA\u30D5\u30E9\u30A4\u30F3\u306E\u5834\u5408\u3084\u30B5\u30FC\u30D3\u30B9\u304C\u5229\u7528\u3067\u304D\u306A\u3044\u5834\u5408\u306F\u3001\u7D44\u307F\u8FBC\u307F\u306E\u6A5F\u80FD\u306B\u30D5\u30A9\u30FC\u30EB\u30D0\u30C3\u30AF\u3067\u304D\u307E\u3059\u3002"},"workflows":{"title":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC","description":"\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u7E70\u308A\u8FD4\u3057\u53EF\u80FD\u306A\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u306B\u9023\u7D50\u3059\u308B\u304A\u624B\u4F1D\u3044\u3092\u3057\u307E\u3059\u3002","longDescription":"\u3055\u307E\u3056\u307E\u306A\u5165\u529B\u3001\u30B3\u30DE\u30F3\u30C9\u3001\u51FA\u529B\u3092\u9023\u643A\u3055\u305B\u308B\u8907\u6570\u30B9\u30C6\u30C3\u30D7\u306E\u30D7\u30ED\u30BB\u30B9\u3092\u8A2D\u8A08\u30FB\u5B9F\u884C\u3067\u304D\u307E\u3059\u3002\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u3048\u3070\u3001\u5B9A\u578B\u7684\u306A\u30BF\u30B9\u30AF\u3092\u81EA\u52D5\u5316\u3057\u305F\u308A\u3001\u97F3\u58F0\u3084\u30B8\u30A7\u30B9\u30C1\u30E3\u30FC\u3067\u30C8\u30EA\u30AC\u30FC\u3055\u308C\u308B\u8907\u96D1\u306A\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u3092\u4F5C\u6210\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u9762\u5012\u306A\u4F5C\u696D\u306F\u79C1\u304C\u4EE3\u308F\u308A\u306B\u884C\u3044\u307E\u3059\u3002"},"showMore":"\u3082\u3063\u3068\u898B\u308B","showLess":"\u8868\u793A\u3092\u6E1B\u3089\u3059","background_creation":{"title":"\u80CC\u666F\u4F5C\u6210","description":"\u3042\u306A\u305F\u304C\u4ED5\u4E8B\u3092\u3057\u3066\u3044\u308B\u9593\u3001\u79C1\u306F\u88CF\u3067\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3068\u7DE8\u96C6\u3092\u884C\u3044\u307E\u3059\u3002","longDescription":"\u3042\u306A\u305F\u304C\u4ED5\u4E8B\u306B\u96C6\u4E2D\u3057\u3066\u3044\u308B\u9593\u3001\u79C1\u306F\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3068\u7DE8\u96C6\u3092\u884C\u3044\u307E\u3059\u3002\u5FC5\u8981\u306A\u6642\u306B\u306F\u3001\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4E2D\u65AD\u3057\u305F\u308A\u30B3\u30D4\u30FC\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u3042\u306A\u305F\u306E\u30D5\u30A1\u30A4\u30EB\u30B7\u30B9\u30C6\u30E0\u306B\u30B3\u30F3\u30C6\u30F3\u30C4\u304C\u6E96\u5099\u3055\u308C\u3066\u3044\u307E\u3059\u3002"},"ai_summary":{"title":"AI\u306E\u6982\u8981","description":"\u9577\u6587\u304B\u3089\u8981\u70B9\u3092\u62BD\u51FA\u3057\u3001\u77ED\u3044\u8981\u7D04\u3084\u91CD\u8981\u306A\u30DD\u30A4\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u3002"}},"listing":{"title":"\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9","titleLong":"\u79C1\u304C\u3069\u306E\u3088\u3046\u306B\u304A\u624B\u4F1D\u3044\u3067\u304D\u308B\u304B\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","recommended":"\u3042\u306A\u305F\u306B\u304A\u3059\u3059\u3081","exploreMore":"\u305D\u306E\u4ED6\u306E\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u898B\u308B","description":"\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u5F37\u5316\u3059\u308B\u305F\u3081\u306B\u79C1\u304C\u3067\u304D\u308B\u3053\u3068\u3092\u3059\u3079\u3066\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002\u751F\u7523\u6027\u306E\u5411\u4E0A\u304B\u3089\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u306A\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3001\u304A\u5BA2\u69D8\u306E\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u305F\u6700\u9069\u306A\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3092\u898B\u3064\u3051\u3066\u304F\u3060\u3055\u3044\u3002","all":"\u5168\u3066","search":"\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u3001\u30A2\u30D7\u30EA\u3001\u307E\u305F\u306F\u6A5F\u80FD\u3092\u691C\u7D22...","noResults":"\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u691C\u7D22\u6761\u4EF6\u307E\u305F\u306F\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002","emptyAction":"\u30AA\u30F3\u30E9\u30A4\u30F3\u3067\u3055\u3089\u306B\u898B\u308B"},"examples":{"universalAppControl":{"title":"\u30E6\u30CB\u30D0\u30FC\u30B5\u30EB\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30B9\u30DE\u30FC\u30C8\u30AA\u30FC\u30C8\u30E1\u30FC\u30B7\u30E7\u30F3\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u4E0A\u306E\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u5236\u5FA1\u3067\u304D\u307E\u3059","descriptionLong":"\u5F37\u529B\u306A\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3068\u30A4\u30F3\u30C6\u30EA\u30B8\u30A7\u30F3\u30C8\u306A\u81EA\u52D5\u5316\u6A5F\u80FD\u3067\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u81EA\u5728\u306B\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3067\u304D\u307E\u3059\u3002\u30E6\u30CB\u30D0\u30FC\u30B5\u30EB\u30A2\u30D7\u30EA\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30B7\u30B9\u30C6\u30E0\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u4F5C\u696D\u65B9\u6CD5\u3092\u5B66\u7FD2\u3057\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u9069\u5FDC\u3059\u308B\u3053\u3068\u3067\u3001\u8907\u96D1\u306A\u30BF\u30B9\u30AF\u3092\u30B7\u30F3\u30D7\u30EB\u306B\u3001\u5B9A\u578B\u7684\u306A\u64CD\u4F5C\u3092\u77AC\u6642\u306B\u5B9F\u884C\u3057\u307E\u3059\u3002\u751F\u7523\u6027\u5411\u4E0A\u30B9\u30A4\u30FC\u30C8\u306E\u7BA1\u7406\u304B\u3089\u30E1\u30C7\u30A3\u30A2\u3084\u30B2\u30FC\u30E0\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u64CD\u4F5C\u307E\u3067\u3001\u3053\u306E\u6A5F\u80FD\u306F\u30C7\u30B8\u30BF\u30EB\u74B0\u5883\u5168\u4F53\u3067\u5229\u7528\u3067\u304D\u307E\u3059\u3002"},"documentSummary":{"title":"\u6587\u66F8\u3092\u8AAD\u307F\u8FBC\u307F\u3001\u8981\u7D04\u3092\u4F5C\u6210\u3057\u3001\u30C1\u30FC\u30E0\u306B\u9001\u4FE1\u3059\u308B\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8AI\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8","description":"\u5C02\u7528\u306E\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3092\u4F7F\u7528\u3059\u308C\u3070\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u6587\u66F8\u3092\u95B2\u89A7\u3057\u305F\u308A\u3001\u8981\u7D04\u3092\u4F5C\u6210\u3057\u305F\u308A\u3001\u30C1\u30FC\u30E0\u3068\u5171\u6709\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002","descriptionLong":"AI\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306B\u6587\u66F8\u3092\u6307\u5B9A\u3059\u308C\u3070\u3001\u3042\u3068\u306FAI\u304C\u8AAD\u307F\u4E0A\u3052\u3001\u8981\u7D04\u3057\u3001\u9001\u4FE1\u3057\u3066\u304F\u308C\u307E\u3059\u3002\u3059\u3079\u3066\u3092\u30ED\u30FC\u30AB\u30EB\u3067\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306B\u5B9F\u884C\u3067\u304D\u308B\u306E\u3067\u3001\u3042\u306A\u305F\u306F\u6307\u4E00\u672C\u52D5\u304B\u3059\u3053\u3068\u306A\u304F\u4F5C\u696D\u3092\u9032\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"editingVideos":{"title":"CapCut\u3067\u306E\u97F3\u58F0\u7DE8\u96C6 \u2015 \u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3092\u64CD\u4F5C\u3057\u3001\u30AF\u30EA\u30C3\u30D7\u3092\u30AB\u30C3\u30C8\u3057\u3001\u30B9\u30C8\u30FC\u30EA\u30FC\u306E\u6D41\u308C\u3092\u9014\u5207\u308C\u3055\u305B\u306A\u3044","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u97F3\u58F0\u5165\u529B\u3092\u4F7F\u3063\u3066\u52D5\u753B\u3092\u7DE8\u96C6\u3059\u308C\u3070\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30AF\u30EA\u30C3\u30D7\u306E\u30AB\u30C3\u30C8\u3084\u914D\u7F6E\u304C\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3092\u79FB\u52D5\u3057\u305F\u308A\u3001\u30AF\u30EA\u30C3\u30D7\u3092\u30C8\u30EA\u30DF\u30F3\u30B0\u3057\u305F\u308A\u5206\u5272\u3057\u305F\u308A\u3001\u97F3\u58F0\u3060\u3051\u3067\u7DE8\u96C6\u3092\u601D\u3044\u901A\u308A\u306B\u4ED5\u4E0A\u3052\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30E1\u30CB\u30E5\u30FC\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u308A\u30DE\u30A6\u30B9\u3092\u4F7F\u3063\u305F\u308A\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u30B9\u30C8\u30FC\u30EA\u30FC\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002"},"figma":{"description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068\u30B9\u30DE\u30FC\u30C8\u306A\u97F3\u58F0\u5165\u529B\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u753B\u50CF\u3084\u30C7\u30B6\u30A4\u30F3\u3092\u7DE8\u96C6\u3059\u308B\u3053\u3068\u3067\u3001\u3088\u308A\u8FC5\u901F\u306A\u53CD\u5FA9\u4F5C\u696D\u304C\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002","descriptionLong":"\u97F3\u58F0\u64CD\u4F5C\u306B\u3088\u308B\u753B\u50CF\u7DE8\u96C6\u3067\u3001\u3042\u306A\u305F\u306E\u30D3\u30B8\u30E5\u30A2\u30EB\u30A2\u30A4\u30C7\u30A2\u3092\u5F62\u306B\u3057\u307E\u3057\u3087\u3046\u3002\u8907\u96D1\u306A\u30E1\u30CB\u30E5\u30FC\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u3088\u308A\u8FC5\u901F\u306B\u64CD\u4F5C\u3057\u3001\u30C7\u30B6\u30A4\u30F3\u3092\u7E70\u308A\u8FD4\u3057\u4FEE\u6B63\u3067\u304D\u307E\u3059\u3002","title":"Figma\u3068Canva\u306E\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9 \u2014 \u30EC\u30A4\u30E4\u30FC\u306E\u64CD\u4F5C\u3001\u30C4\u30FC\u30EB\u306E\u5207\u308A\u66FF\u3048\u3001\u30C6\u30AD\u30B9\u30C8\u5165\u529B\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067"},"excelAnalysis":{"title":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u304A\u3088\u3073\u30ED\u30FC\u30AB\u30EBAI\u81EA\u52D5\u5316\u3067Excel\u3067\u306E\u4F5C\u696D\u3068\u5206\u6790\u3092\u9AD8\u901F\u5316","description":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u30ED\u30FC\u30AB\u30EBAI\u81EA\u52D5\u5316\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u5206\u6790\u3057\u3001\u50BE\u5411\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u628A\u63E1\u3057\u307E\u3059\u3002","descriptionLong":"\u30D5\u30A9\u30EB\u30C0\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5168\u4F53\u306E\u50BE\u5411\u3092\u8ABF\u67FB\u3057\u3001\u8CA1\u52D9\u5831\u544A\u66F8\u306B\u5BFE\u3057\u3066\u8CEA\u554F\u3092\u6295\u3052\u304B\u3051\u3001\u6700\u7D42\u7684\u306A\u8981\u7D04\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u30ED\u30FC\u30AB\u30EBAI\u304C\u5206\u6790\u3092\u62C5\u3044\u3001\u30C7\u30FC\u30BF\u306F\u3054\u81EA\u8EAB\u306E\u30DE\u30B7\u30F3\u4E0A\u3067\u5B89\u5168\u306B\u4FDD\u7BA1\u3055\u308C\u307E\u3059\u3002"},"emailAutomation":{"title":"\u30E1\u30FC\u30EB\u3092\u81EA\u52D5\u5316\u3057\u307E\u3057\u3087\u3046 \u2015 \u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u8AAD\u307F\u53D6\u308A\u3001\u8FD4\u4FE1\u306E\u4E0B\u66F8\u304D\u3092\u4F5C\u6210\u3059\u308B\u306A\u3069\u3001\u30ED\u30FC\u30AB\u30EBAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u304C\u5F79\u7ACB\u3061\u307E\u3059\uFF01","description":"\u30ED\u30FC\u30AB\u30EBAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3068\u97F3\u58F0\u5165\u529B\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u8AAD\u307F\u3001\u8FD4\u4FE1\u306E\u4E0B\u66F8\u304D\u3092\u4F5C\u6210\u3057\u3001\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u8A18\u4E8B\u306E\u8981\u7D04\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3057\u3001\u91CD\u8981\u306A\u6280\u8853\u7684\u8A73\u7D30\u3092\u76DB\u308A\u8FBC\u3093\u3060\u308A\u3001\u518D\u5229\u7528\u53EF\u80FD\u306A\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u3066\u53D7\u4FE1\u30C8\u30EC\u30A4\u306E\u51E6\u7406\u3092\u52B9\u7387\u5316\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u30ED\u30FC\u30AB\u30EBAI\u3068\u97F3\u58F0\u8A8D\u8B58\u6A5F\u80FD\u306B\u8AAD\u307F\u66F8\u304D\u3092\u4EFB\u305B\u308C\u3070\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3082\u4FDD\u8B77\u3055\u308C\u307E\u3059\u3002"},"powerpointBuilder":{"description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3001\u30E1\u30E2\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u5B8C\u6210\u5EA6\u306E\u9AD8\u3044PowerPoint\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","descriptionLong":"Excel\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u5206\u6790\u3057\u3066\u91CD\u8981\u306A\u640D\u5931\u7B87\u6240\u3092\u7279\u5B9A\u3057\u3001AI\u306B\u30E1\u30E2\u3084\u30C7\u30FC\u30BF\u3092\u6D17\u7DF4\u3055\u308C\u305F\u30D7\u30EC\u30BC\u30F3\u30C6\u30FC\u30B7\u30E7\u30F3\u306B\u4ED5\u4E0A\u3052\u3066\u3082\u3089\u3044\u307E\u3057\u3087\u3046\u3002\u30E1\u30CB\u30E5\u30FC\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u305F\u308A\u3001\u767D\u7D19\u306E\u72B6\u614B\u304B\u3089\u59CB\u3081\u305F\u308A\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u30B9\u30E9\u30A4\u30C9\u30C7\u30C3\u30AD\u3092\u3088\u308A\u8FC5\u901F\u306B\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","title":"\u30E1\u30E2\u3084\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u5B8C\u6210\u3055\u308C\u305FPowerPoint\u306B\u5909\u63DB\u3059\u308BAI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC | AI PowerPoint\u30D3\u30EB\u30C0\u30FC"},"socialDictation":{"description":"LinkedIn\u3001Slack\u3001Discord\u3078\u306E\u6295\u7A3F\u3084\u8FD4\u4FE1\u306F\u3001\u97F3\u58F0\u5165\u529B\u3067\u884C\u3048\u307E\u3059\u3002\u30BF\u30A4\u30D4\u30F3\u30B0\u306F\u4E0D\u8981\u3067\u3059\u3002","descriptionLong":"\u97F3\u58F0\u3060\u3051\u3067\u6295\u7A3F\u306E\u4E0B\u66F8\u304D\u3092\u4F5C\u6210\u3057\u305F\u308A\u3001\u8FD4\u4FE1\u3092\u9001\u4FE1\u3057\u305F\u308A\u3001LinkedIn\u3001Slack\u3001Discord\u3067\u6D3B\u767A\u306B\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u53D6\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u30AD\u30FC\u30DC\u30FC\u30C9\u306B\u624B\u3092\u4F38\u3070\u3059\u3053\u3068\u306A\u304F\u3001\u4F1A\u8A71\u3092\u7D9A\u3051\u307E\u3057\u3087\u3046\u3002","title":"LinkedIn\u3001Slack\u3001Discord\u306E\u97F3\u58F0\u30C6\u30AD\u30B9\u30C8\u5909\u63DB\uFF5C\u5165\u529B\u305B\u305A\u306B\u6295\u7A3F\u30FB\u8FD4\u4FE1"},"developerTools":{"title":"\u958B\u767A\u8005\u5411\u3051\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\uFF0BAI\u81EA\u52D5\u5316\uFF5C\u30B3\u30E1\u30F3\u30C8\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B3\u30DF\u30C3\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306E\u4F5C\u6210","description":"\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068AI\u306B\u3088\u308B\u81EA\u52D5\u5316\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30B3\u30E1\u30F3\u30C8\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B3\u30DF\u30C3\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30D5\u30A9\u30EB\u30C0\u5185\u306E\u30B3\u30FC\u30C9\u3092\u3088\u308A\u6574\u7406\u3059\u308B\u65B9\u6CD5\u3092\u5C0B\u306D\u3001\u30B3\u30E1\u30F3\u30C8\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30B3\u30DF\u30C3\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u30BF\u30A4\u30D4\u30F3\u30B0\u305B\u305A\u306B\u97F3\u58F0\u5165\u529B\u3057\u307E\u3057\u3087\u3046\u3002\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3068AI\u306B\u3088\u308B\u81EA\u52D5\u5316\u304C\u9762\u5012\u306A\u4F5C\u696D\u3092\u51E6\u7406\u3057\u3066\u304F\u308C\u308B\u306E\u3067\u3001\u4F5C\u696D\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002"},"terminalAgent":{"title":"AI\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\uFF5C\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u7D9A\u3051\u306A\u304C\u3089\u3001\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u30BF\u30FC\u30DF\u30CA\u30EB\u30D3\u30EB\u30C9\u3068\u30C6\u30B9\u30C8\u3092\u5B9F\u884C","description":"AI\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u30D3\u30EB\u30C9\u3001\u30C6\u30B9\u30C8\u3001\u30C7\u30D0\u30C3\u30B0\u3092\u30D0\u30C3\u30AF\u30B0\u30E9\u30A6\u30F3\u30C9\u3067\u5B9F\u884C\u3057\u306A\u304C\u3089\u3001\u30B3\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u7D9A\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30D5\u30A9\u30EB\u30C0\u3092\u30EC\u30D3\u30E5\u30FC\u3055\u305B\u3001\u30D3\u30EB\u30C9\u3057\u3001\u30B3\u30F3\u30D1\u30A4\u30EB\u3092\u78BA\u8A8D\u3057\u3001\u30C6\u30B9\u30C8\u30B1\u30FC\u30B9\u3092\u5B9F\u884C\u3055\u305B\u307E\u3059\u3002\u4F55\u304B\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u306F\u3001Git\u306E\u5C65\u6B74\u3092\u8ABF\u3079\u3066\u539F\u56E0\u3092\u7279\u5B9A\u3057\u3001\u4FEE\u6B63\u6848\u3092\u63D0\u6848\u3057\u307E\u3059\u3002\u305D\u306E\u9593\u3001\u3042\u306A\u305F\u306F\u81EA\u5206\u306E\u4F5C\u696D\u306B\u96C6\u4E2D\u3067\u304D\u307E\u3059\u3002"},"gamingFPS":{"description":"Valorant\u306E\u3088\u3046\u306AFPS\u30B2\u30FC\u30E0\u3067\u3001\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u4F7F\u3063\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u7167\u6E96\u3092\u5408\u308F\u305B\u3001\u5C04\u6483\u3057\u3001\u30EA\u30ED\u30FC\u30C9\u3057\u3001\u6B66\u5668\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","descriptionLong":"Valorant\u306E\u3088\u3046\u306AFPS\u30B2\u30FC\u30E0\u3092\u30D7\u30EC\u30A4\u3057\u306A\u304C\u3089\u3001\u5C04\u6483\u3001\u30EA\u30ED\u30FC\u30C9\u3001\u6B66\u5668\u306E\u5207\u308A\u66FF\u3048\u306A\u3069\u306E\u30B3\u30DE\u30F3\u30C9\u3092\u97F3\u58F0\u3067\u6307\u793A\u3067\u304D\u307E\u3059\u3002\u97F3\u58F0\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u306B\u8FFD\u52A0\u3059\u308C\u3070\u3001\u3059\u3079\u3066\u306E\u30AD\u30FC\u3084\u30DC\u30BF\u30F3\u306B\u983C\u308B\u3053\u3068\u306A\u304F\u3001\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u9014\u5207\u308C\u308B\u3053\u3068\u306A\u304F\u697D\u3057\u3081\u307E\u3059\u3002","title":"FPS\u3084Valorant\u306A\u3069\u306E\u30B2\u30FC\u30E0\u3067\u97F3\u58F0\u64CD\u4F5C\u304C\u53EF\u80FD | \u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u7167\u6E96\u3001\u5C04\u6483\u3001\u30EA\u30ED\u30FC\u30C9\u3001\u6B66\u5668\u5207\u308A\u66FF\u3048"},"gamingRPG":{"title":"Minecraft\u306ERPG\u30B2\u30FC\u30E0\u64CD\u4F5C\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA | \u30D3\u30C7\u30AA\u30B2\u30FC\u30E0\u306E\u9069\u5FDC\u578B\u64CD\u4F5C","description":"Minecraft\u3084\u305D\u306E\u4ED6\u306ERPG\u306E\u30B2\u30FC\u30E0\u64CD\u4F5C\u3092\u3001\u81EA\u5206\u306E\u30D7\u30EC\u30A4\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u304A\u3088\u3073\u8ABF\u6574\u3067\u304D\u307E\u3059\u3002","descriptionLong":"Minecraft\u3084\u305D\u306E\u4ED6\u306ERPG\u30B9\u30BF\u30A4\u30EB\u306E\u30B2\u30FC\u30E0\u5411\u3051\u306B\u3001\u64CD\u4F5C\u3092\u81EA\u5206\u597D\u307F\u306B\u30DE\u30C3\u30D4\u30F3\u30B0\u3059\u308B\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A2D\u5B9A\u3057\u307E\u3057\u3087\u3046\u3002\u30B2\u30FC\u30E0\u306B\u64CD\u4F5C\u3092\u5408\u308F\u305B\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u81EA\u5206\u306E\u30D7\u30EC\u30A4\u30B9\u30BF\u30A4\u30EB\u306B\u5408\u3063\u305F\u64CD\u4F5C\u65B9\u6CD5\u3092\u69CB\u7BC9\u3067\u304D\u307E\u3059\u3002"},"educationTools":{"description":"\u30E1\u30E2\u3084\u8A18\u4E8B\u3092\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u3092\u4F7F\u3063\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u5B66\u7FD2\u30C4\u30FC\u30EB\u3084\u6559\u6750\u306B\u5909\u63DB\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u8A18\u4E8B\u3092\u57FA\u306B\u3001\u751F\u5F92\u306E\u5B66\u5E74\u306B\u5408\u308F\u305B\u305F\u8003\u5BDF\u8CEA\u554F\u3092\u542B\u3080Word\u6587\u66F8\u3092\u4F5C\u6210\u3057\u3001\u5275\u4F5C\u8AB2\u984C\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u304C\u3001\u30BD\u30FC\u30B9\u7D20\u6750\u3092\u3059\u3050\u306B\u4F7F\u3048\u308B\u6559\u6750\u3078\u3068\u5909\u63DB\u3057\u3001\u540C\u6642\u306B\u3059\u3079\u3066\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u4FDD\u8B77\u3057\u307E\u3059\u3002","title":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u3092\u4F7F\u7528\u3057\u3066\u3001\u6388\u696D\u30CE\u30FC\u30C8\u3084\u8A18\u4E8B\u3092\u5275\u9020\u7684\u306A\u5B66\u7FD2\u30C4\u30FC\u30EB\u3084\u6559\u6750\u306B\u5909\u63DB\u3059\u308B"},"meetingNotes":{"title":"\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u3092\u3088\u308A\u5C0F\u3055\u306A\u30D5\u30A1\u30A4\u30EB\u306B\u5909\u63DB\u3059\u308BAI\u81EA\u52D5\u5316\u6A5F\u80FD","description":"AI\u306B\u3088\u308B\u81EA\u52D5\u5316\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u3092\u6574\u7406\u3055\u308C\u305F\u5B9F\u7528\u7684\u306A\u30D5\u30A1\u30A4\u30EB\u306B\u5909\u63DB\u3057\u307E\u3059\u3002\u4F5C\u696D\u306F\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u884C\u3048\u307E\u3059\u3002","descriptionLong":"\u4F1A\u8B70\u306E\u8B70\u4E8B\u9332\u3092\u8AAD\u3093\u3067\u3001\u6B8B\u308A\u306E\u4F5C\u696D\u3001\u62C5\u5F53\u8005\u3001\u305D\u3057\u3066\u4E0D\u8DB3\u3057\u3066\u3044\u308B\u70B9\u3092\u628A\u63E1\u3057\u307E\u3057\u3087\u3046\u3002AI\u304C\u3053\u308C\u3089\u306E\u60C5\u5831\u3092\u500B\u5225\u306E\u30D5\u30A1\u30A4\u30EB\u3068\u3057\u3066\u62BD\u51FA\u3057\u3001\u30D5\u30A9\u30EB\u30C0\u306B\u6574\u7406\u3057\u3066\u304F\u308C\u308B\u306E\u3067\u3001\u5F8C\u3067\u307E\u3068\u3081\u3066\u78BA\u8A8D\u3067\u304D\u307E\u3059\u3002"},"fileManagement":{"description":"\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u306E\u6574\u7406\u3001\u30D5\u30A1\u30A4\u30EB\u306E\u691C\u7D22\u3001PC\u306E\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7\u3092\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u3092\u4F7F\u3063\u3066\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u884C\u3048\u307E\u3059\u3002","descriptionLong":"\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306B\u3001\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u3092\u88FD\u54C1\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30C7\u30A3\u30EC\u30AF\u30C8\u30EA\u306B\u30B3\u30D4\u30FC\u3059\u308B\u3088\u3046\u4F9D\u983C\u3057\u305F\u308A\u3001PC\u4E0A\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u691C\u7D22\u3057\u3066\u6574\u7406\u3059\u308B\u3088\u3046\u4F9D\u983C\u3057\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u3067\u30C7\u30FC\u30BF\u3092\u4FDD\u8B77\u3057\u306A\u304C\u3089\u3001\u30DE\u30B7\u30F3\u3092\u6574\u7406\u6574\u9813\u3057\u307E\u3057\u3087\u3046\u3002","title":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8 | \u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306E\u6574\u7406\u3001\u30D5\u30A1\u30A4\u30EB\u306E\u691C\u7D22\u3001PC\u306E\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7"},"dictationWriting":{"title":"\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u5165\u529B\u3068\u6587\u66F8\u4F5C\u6210 \u2015 \u97F3\u58F0\u5165\u529B\u3001AI\u751F\u6210\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3067\u306E\u66F8\u304D\u63DB\u3048","description":"\u97F3\u58F0\u5165\u529B\u3068AI\u3092\u6D3B\u7528\u3057\u3066\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3067\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u6587\u66F8\u306E\u5165\u529B\u3001\u4F5C\u6210\u3001\u66F8\u304D\u63DB\u3048\u304C\u53EF\u80FD\u3067\u3059\u3002","descriptionLong":"\u97F3\u58F0\u3060\u3051\u3067\u3001\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u4E0A\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u305F\u308A\u3001\u65B0\u3057\u3044\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u751F\u6210\u3057\u305F\u308A\u3001\u65E2\u306B\u66F8\u3044\u305F\u5185\u5BB9\u3092\u66F8\u304D\u63DB\u3048\u305F\u308A\u3067\u304D\u307E\u3059\u3002\u30AD\u30FC\u30DC\u30FC\u30C9\u306B\u89E6\u308C\u308B\u3053\u3068\u306A\u304F\u3001\u6700\u521D\u304B\u3089\u6700\u5F8C\u307E\u3067\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"},"headMouseControl":{"title":"\u30D8\u30C3\u30C9\u30DE\u30A6\u30B9\u3068\u97F3\u58F0\u30BF\u30C3\u30D7\u306B\u3088\u308B\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u64CD\u4F5C\uFF5C\u9069\u5FDC\u578B\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u5236\u5FA1","description":"\u30D8\u30C3\u30C9\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u3068\u97F3\u58F0\u8A8D\u8B58\u306B\u3088\u308B\u30BF\u30C3\u30D7\u64CD\u4F5C\u3067\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002","descriptionLong":"\u30D8\u30C3\u30C9\u30C8\u30E9\u30C3\u30AD\u30F3\u30B0\u3067\u30AB\u30FC\u30BD\u30EB\u3092\u79FB\u52D5\u3057\u3001\u97F3\u58F0\u8A8D\u8B58\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u3067\u3001\u5B8C\u5168\u306B\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u3092\u64CD\u4F5C\u3067\u304D\u307E\u3059\u3002\u81EA\u5206\u306B\u6700\u9069\u306A\u64CD\u4F5C\u65B9\u6CD5\u306B\u5408\u308F\u305B\u3066\u3001\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3092\u8A2D\u5B9A\u3057\u307E\u3057\u3087\u3046\u3002"},"documentTranslation":{"title":"\u591A\u8A00\u8A9E\u5BFE\u5FDC\u306EAI\u6587\u66F8\u7FFB\u8A33\u30B5\u30FC\u30D3\u30B9 \u2015 \u30B9\u30DA\u30A4\u30F3\u8A9E\u3001\u30A2\u30E9\u30D3\u30A2\u8A9E\u3001\u30DD\u30EB\u30C8\u30AC\u30EB\u8A9E\u306A\u3069","description":"AI\u3092\u4F7F\u3063\u3066\u3001\u30B9\u30DA\u30A4\u30F3\u8A9E\u3001\u30A2\u30E9\u30D3\u30A2\u8A9E\u3001\u30DD\u30EB\u30C8\u30AC\u30EB\u8A9E\u306A\u3069\u306E\u8A00\u8A9E\u9593\u3067\u6587\u66F8\u3092\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u7FFB\u8A33\u3057\u307E\u3059\u3002","descriptionLong":"\u30C7\u30D0\u30A4\u30B9\u5185\u8535\u306EAI\u3092\u4F7F\u3063\u3066\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u30B9\u30DA\u30A4\u30F3\u8A9E\u3001\u30A2\u30E9\u30D3\u30A2\u8A9E\u3001\u30DD\u30EB\u30C8\u30AC\u30EB\u8A9E\u306A\u3069\u3001\u3055\u307E\u3056\u307E\u306A\u8A00\u8A9E\u306B\u7FFB\u8A33\u3067\u304D\u307E\u3059\u3002\u30C4\u30FC\u30EB\u3092\u5207\u308A\u66FF\u3048\u305F\u308A\u3001\u30A2\u30D7\u30EA\u9593\u3067\u30C6\u30AD\u30B9\u30C8\u3092\u30B3\u30D4\u30FC\u3057\u305F\u308A\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u8907\u6570\u306E\u8A00\u8A9E\u3067\u81EA\u4FE1\u3092\u6301\u3063\u3066\u4F5C\u696D\u3067\u304D\u307E\u3059\u3002"},"websiteRedesign":{"description":"\u7AF6\u5408\u4ED6\u793E\u3092\u8ABF\u67FB\u3057\u3001AI\u3092\u6D3B\u7528\u3057\u3066\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3092\u518D\u8A2D\u8A08\u3059\u308B\u305F\u3081\u306E\u63D0\u6848\u3092\u3001\u30CF\u30F3\u30BA\u30D5\u30EA\u30FC\u3067\u5165\u624B\u3067\u304D\u307E\u3059\u3002","descriptionLong":"AI\u3092SafeDrive\u81EA\u52D5\u8ECA\u4FDD\u967A\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306B\u5411\u3051\u3001\u7AF6\u5408\u4ED6\u793E\u306E\u30B5\u30A4\u30C8\u3092\u8ABF\u67FB\u3055\u305B\u3066\u9055\u3044\u3092\u898B\u3064\u3051\u51FA\u3055\u305B\u307E\u3057\u3087\u3046\u3002\u5B9F\u969B\u306E\u5E02\u5834\u8ABF\u67FB\u306B\u57FA\u3065\u304D\u3001\u6642\u4EE3\u9045\u308C\u306E\u30B5\u30A4\u30C8\u3092\u6700\u65B0\u5316\u3059\u308B\u305F\u3081\u306E\u5177\u4F53\u7684\u306A\u63D0\u6848\u304C\u5F97\u3089\u308C\u307E\u3059\u3002","title":"\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8AI\u30A6\u30A7\u30D6\u8ABF\u67FB\uFF0B\u81EA\u52D5\u5316\uFF5CHTML\u306E\u95B2\u89A7\u3001\u5206\u6790\u3001\u4F5C\u6210"},"dataPrivacyResearch":{"description":"\u6700\u65B0\u306E\u30C7\u30FC\u30BF\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u6CD5\u3092\u8ABF\u67FB\u3057\u3001\u305D\u306E\u7D50\u679C\u3092\u81EA\u52D5\u7684\u306B\u30B3\u30F3\u30D7\u30E9\u30A4\u30A2\u30F3\u30B9\u9075\u5B88\u306E\u305F\u3081\u306E\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u306B\u6D3B\u7528\u3057\u307E\u3059\u3002","descriptionLong":"2026\u5E74\u306B\u65BD\u884C\u3055\u308C\u305F\u6700\u65B0\u306E\u30C7\u30FC\u30BF\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u6CD5\u3092\u8ABF\u67FB\u3057\u30012025\u5E74\u3068\u306E\u9055\u3044\u3092\u660E\u78BA\u306B\u3057\u305F\u4E0A\u3067\u3001\u4F01\u696D\u304C\u5B9F\u65BD\u3059\u3079\u304D\u4E8B\u9805\u3092\u6D17\u3044\u51FA\u3057\u307E\u3057\u3087\u3046\u3002AI\u306B\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30E1\u30FC\u30EB\u3092\u4F5C\u6210\u3055\u305B\u3001\u30B3\u30F3\u30D7\u30E9\u30A4\u30A2\u30F3\u30B9\u9075\u5B88\u306B\u5F79\u7ACB\u3064\u4E8B\u4F8B\u3092\u76DB\u308A\u8FBC\u3093\u3067\u3082\u3089\u3044\u307E\u3057\u3087\u3046\u3002","title":"\u30C7\u30FC\u30BF\u304C\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u6F0F\u308C\u308B\u3053\u3068\u306A\u304F\u3001\u95B2\u89A7\u3001\u5206\u6790\u3001\u8981\u7D04\u304C\u53EF\u80FD\uFF5C\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8AI\u30A6\u30A7\u30D6\u8ABF\u67FB"}},"control":{"title":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u3002","subtitle":"\u3042\u306A\u305F\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3002\u3042\u306A\u305F\u306E\u5165\u529B\u3002\u3042\u306A\u305F\u306E\u30EB\u30FC\u30EB\u3002","description":"\u97F3\u58F0\u30B3\u30DE\u30F3\u30C9\u3001\u30AD\u30FC\u30DC\u30FC\u30C9\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u3001\u30AF\u30A4\u30C3\u30AF\u30A2\u30AF\u30B7\u30E7\u30F3\u30DC\u30BF\u30F3\u304C\u3001\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3067\u52D5\u4F5C\u3057\u307E\u3059\u3002\u30DE\u30A6\u30B9\u306F\u4E0D\u8981\u3002\u30B9\u30AF\u30EA\u30D7\u30C8\u3082\u4E0D\u8981\u3002\u666E\u6BB5\u304A\u4F7F\u3044\u306E\u6570\u767E\u3082\u306E\u30A2\u30D7\u30EA\u306E\u8A2D\u5B9A\u3082\u4E0D\u8981\u3067\u3059\u3002","titleAlt":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB"},"create":{"title":"\u4F5C\u6210\u3059\u308B\u3002","subtitle":"\u3042\u306A\u305F\u306E\u8A00\u8449\u3002\u3042\u306A\u305F\u306E\u539F\u7A3F\u3002\u3042\u306A\u305F\u306E\u6A5F\u68B0\u3002","description":"\u4E0B\u66F8\u304D\u3001\u66F8\u304D\u76F4\u3057\u3001\u66F8\u5F0F\u5909\u66F4\u3001\u7FFB\u8A33\u307E\u3067\u3001\u3059\u3079\u3066\u4F5C\u696D\u4E2D\u306E\u30A2\u30D7\u30EA\u5185\u3067\u5B8C\u7D50\u3057\u307E\u3059\u3002\u30AF\u30E9\u30A6\u30C9\u4E0D\u8981\u3002\u4ED6\u306E\u30C4\u30FC\u30EB\u3078\u306E\u30B3\u30D4\u30FC\uFF06\u30DA\u30FC\u30B9\u30C8\u3082\u4E0D\u8981\u3002\u4E0B\u66F8\u304D\u304C\u4ED6\u4EBA\u306E\u30E2\u30C7\u30EB\u3092\u5B66\u7FD2\u3055\u305B\u308B\u5FC5\u8981\u3082\u3042\u308A\u307E\u305B\u3093\u3002","titleAlt":"\u4F5C\u6210\u3059\u308B"},"automate":{"title":"\u81EA\u52D5\u5316\u3059\u308B\u3002","subtitle":"\u305F\u3063\u305F\u4E00\u6587\u3002\u3059\u3079\u3066\u306E\u624B\u9806\u3002\u5B8C\u4E86\u3002","description":"\u7C21\u5358\u306A\u8A00\u8449\u3067\u30B8\u30E7\u30D6\u3092\u8A18\u8FF0\u3059\u308C\u3070\u3001Cephable\u304C\u305D\u308C\u3092\u5B9F\u884C\u3057\u3066\u304F\u308C\u307E\u3059\u3002\u30A2\u30D7\u30EA\u3001\u30D5\u30A1\u30A4\u30EB\u3001\u30B3\u30DE\u30F3\u30C9\u30E9\u30A4\u30F3\u306A\u3069\u3001\u3042\u3089\u3086\u308B\u5834\u9762\u3067\u52D5\u4F5C\u3057\u307E\u3059\u3002\u4ED6\u306E\u4F5C\u696D\u3092\u3057\u3066\u3044\u308B\u9593\u3082\u5B9F\u884C\u3055\u308C\u3001\u30C7\u30FC\u30BF\u304C\u30DE\u30B7\u30F3\u304B\u3089\u5916\u90E8\u306B\u9001\u4FE1\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002","titleAlt":"\u81EA\u52D5\u5316\u3059\u308B"},"upgrade":{"subtitle":{"trial":"\u4ECA\u5F8C{{days}}\u65E5\u9593\u3001\u79C1\u306EAI\u6A5F\u80FD\uFF08\u4F5C\u6210\u3068\u81EA\u52D5\u5316\uFF09\u304C\u7121\u6599\u3067\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u3069\u3061\u3089\u3082\u540C\u4E00\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u52D5\u4F5C\u3057\u307E\u3059\u3002\u6E96\u5099\u304C\u3067\u304D\u305F\u3089\u3044\u3064\u3067\u3082\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","orgGeneric":"\u8CB4\u793E\u306F\u3001\u79C1\u306EAI\u6A5F\u80FD\u3067\u3042\u308B\u300C\u4F5C\u6210\u300D\u3068\u300C\u81EA\u52D5\u5316\u300D\u3092\u6709\u52B9\u5316\u3057\u307E\u3057\u305F\u3002\u3053\u308C\u3089\u306F\u3069\u3061\u3089\u3082\u5358\u4E00\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u52D5\u4F5C\u3057\u307E\u3059\u3002\u6E96\u5099\u304C\u6574\u3044\u6B21\u7B2C\u3001\u6709\u52B9\u5316\u3057\u3066\u304F\u3060\u3055\u3044\u3002","org":"\u3042\u306A\u305F\u306F{{organization}}\u7D44\u7E54\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u79C1\u306EAI\u6A5F\u80FD\u3067\u3042\u308B\u300C\u4F5C\u6210\u300D\u3068\u300C\u81EA\u52D5\u5316\u300D\u304C\u5229\u7528\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002\u3069\u3061\u3089\u3082\u5358\u4E00\u306E\u30C7\u30D0\u30A4\u30B9\u30E2\u30C7\u30EB\u3067\u52D5\u4F5C\u3057\u307E\u3059\u3002\u6E96\u5099\u304C\u3067\u304D\u305F\u3089\u3001\u3053\u308C\u3089\u306E\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"badge":{"trial":"\u88C1\u5224\u306F\u7D42\u4E86\u3057","trialDays_one":"{{count}}\u65E5","trialDays_other":"{{count}}\u65E5","org":"\u30ED\u30C3\u30AF\u89E3\u9664","orgGeneric":"\u7D44\u7E54\u30E9\u30A4\u30BB\u30F3\u30B9"},"setup":{"eyebrow":"\u30D7\u30ED\u6A5F\u80FD\u3092\u8A2D\u5B9A\u3059\u308B","title":"\u30AA\u30F3\u306B\u3059\u308B\u9805\u76EE\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","description":"\u3053\u308C\u3089\u306E\u8A2D\u5B9A\u306F\u5F8C\u3067\u300C\u8A2D\u5B9A\u300D\u304B\u3089\u5909\u66F4\u3067\u304D\u307E\u3059\u3002\u3059\u3079\u3066\u7AEF\u672B\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u308B\u305F\u3081\u3001\u3042\u306A\u305F\u306E\u6587\u7AE0\u3084\u30D5\u30A1\u30A4\u30EB\u306F\u7AEF\u672B\u306B\u4FDD\u5B58\u3055\u308C\u307E\u3059\u3002"},"enable":{"title":"AI\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3059\u308B","description":"\u30B9\u30A4\u30C3\u30C1\u30921\u3064\u30AA\u30F3\u306B\u3059\u308C\u3070\u3001Create\u3068Automate\u306E\u4E21\u65B9\u304C\u8D77\u52D5\u3057\u307E\u3059\u3002\u3053\u308C\u3089\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u306E\u5171\u6709\u30E2\u30C7\u30EB\u3067\u52D5\u4F5C\u3059\u308B\u305F\u3081\u3001\u305D\u308C\u305E\u308C\u500B\u5225\u306B\u8A2D\u5B9A\u3059\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002","model":{"label":"\u30C7\u30D0\u30A4\u30B9\u4E0A\u306EAI\u30E2\u30C7\u30EB","tag":"\u5171\u6709\u30A8\u30F3\u30B8\u30F3","description":"\u4F5C\u6210\u6A5F\u80FD\u3068\u81EA\u52D5\u5316\u6A5F\u80FD\u306E\u4E21\u65B9\u3092\u642D\u8F09\u3002\u5927\u898F\u6A21\u306A\u30E2\u30C7\u30EB\u307B\u3069\u512A\u308C\u305F\u7D50\u679C\u304C\u5F97\u3089\u308C\u307E\u3059\u304C\u3001\u3088\u308A\u591A\u304F\u306E\u30EA\u30BD\u30FC\u30B9\u3092\u6D88\u8CBB\u3057\u307E\u3059\u3002\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B8C\u5168\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u304A\u3088\u3073\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002"}},"create":{"title":"\u4F5C\u6210\u3059\u308B","description":"\u9AD8\u5EA6\u306A\u30C6\u30AD\u30B9\u30C8\u751F\u6210\u3068\u97F3\u58F0\u8A8D\u8B58\u3002\u30E1\u30FC\u30EB\u3001\u6587\u66F8\u3001\u30B3\u30FC\u30C9\u3001\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u306F\u3082\u3061\u308D\u3093\u3001\u3042\u306A\u305F\u306E\u97F3\u58F0\u3092\u3042\u3089\u3086\u308B\u30A2\u30D7\u30EA\u3067\u4F7F\u3048\u308B\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u6E08\u307F\u306E\u30C6\u30AD\u30B9\u30C8\u306B\u5909\u63DB\u3057\u307E\u3059\u3002","locked":"\u4E0A\u8A18\u306EAI\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001Create\u306F\u3059\u3050\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002"},"automate":{"title":"\u81EA\u52D5\u5316\u3059\u308B","description":"AI\u30EF\u30FC\u30AF\u30D5\u30ED\u30FC\u3002\u30BF\u30B9\u30AF\u30921\u6587\u3067\u8AAC\u660E\u3057\u3066\u3044\u305F\u3060\u3051\u308C\u3070\u3001\u79C1\u304C\u3059\u3079\u3066\u306E\u30B9\u30C6\u30C3\u30D7\u3092\u8A08\u753B\u3057\u3001\u5B9F\u884C\u3057\u307E\u3059\u3002\u8AAD\u307F\u66F8\u304D\u3001\u30B3\u30DE\u30F3\u30C9\u306E\u5B9F\u884C\u307E\u3067\u3001\u3059\u3079\u3066\u3042\u306A\u305F\u306B\u4EE3\u308F\u3063\u3066\u884C\u3044\u307E\u3059\u3002","locked":"\u4E0A\u8A18\u306EAI\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001Automate\u304C\u3059\u3050\u306B\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3059\u3002"},"status":{"on":"\u306E\u4E0A","off":"\u8D70\u3089\u306A\u3044"},"footer":"\u3059\u3079\u3066\u306F\u30C7\u30D0\u30A4\u30B9\u4E0A\u3067\u5B9F\u884C\u3055\u308C\u307E\u3059\u3002\u4F5C\u6210\u307E\u305F\u306F\u81EA\u52D5\u5316\u3057\u305F\u30C7\u30FC\u30BF\u306F\u3001\u3059\u3079\u3066\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u5916\u90E8\u306B\u6301\u3061\u51FA\u3055\u308C\u307E\u305B\u3093\u3002","cta":{"eyebrow":"AI\u306F\u3044\u3064\u3067\u3082\u6709\u52B9\u5316\u3067\u304D\u307E\u3059","title":"\u3042\u306A\u305F\u306E\u30A2\u30D7\u30EA\u3067\u5B9F\u969B\u306B\u52D5\u4F5C\u3059\u308B\u306E\u3092\u898B\u3066\u307F\u307E\u3057\u3087\u3046","action":"\u79C1\u306E\u6D3B\u8E8D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044","back":"\u623B\u308B"},"pill":"{{license}} \u30ED\u30C3\u30AF\u89E3\u9664\u6E08\u307F","title":"{{license}}\u306B\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002"}}');




const $1e580fbd50c9e2d3$var$isString = (obj)=>typeof obj === 'string';
const $1e580fbd50c9e2d3$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $1e580fbd50c9e2d3$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $1e580fbd50c9e2d3$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $1e580fbd50c9e2d3$var$lastOfPathSeparatorRegExp = /###/g;
const $1e580fbd50c9e2d3$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($1e580fbd50c9e2d3$var$lastOfPathSeparatorRegExp, '.') : key;
const $1e580fbd50c9e2d3$var$canNotTraverseDeeper = (object)=>!object || $1e580fbd50c9e2d3$var$isString(object);
const $1e580fbd50c9e2d3$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$1e580fbd50c9e2d3$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($1e580fbd50c9e2d3$var$canNotTraverseDeeper(object)) return {};
        const key = $1e580fbd50c9e2d3$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($1e580fbd50c9e2d3$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $1e580fbd50c9e2d3$var$cleanKey(stack[stackIndex])
    };
};
const $1e580fbd50c9e2d3$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $1e580fbd50c9e2d3$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $1e580fbd50c9e2d3$var$getLastOfPath(object, p, Object);
        if ((last === null || last === void 0 ? void 0 : last.obj) && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $1e580fbd50c9e2d3$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $1e580fbd50c9e2d3$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $1e580fbd50c9e2d3$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $1e580fbd50c9e2d3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $1e580fbd50c9e2d3$var$getPath(defaultData, key);
};
const $1e580fbd50c9e2d3$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($1e580fbd50c9e2d3$var$isString(target[prop]) || target[prop] instanceof String || $1e580fbd50c9e2d3$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $1e580fbd50c9e2d3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $1e580fbd50c9e2d3$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $1e580fbd50c9e2d3$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $1e580fbd50c9e2d3$var$escape = (data)=>{
    if ($1e580fbd50c9e2d3$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$1e580fbd50c9e2d3$var$_entityMap[s]);
    return data;
};
class $1e580fbd50c9e2d3$var$RegExpCache {
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
}
const $1e580fbd50c9e2d3$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $1e580fbd50c9e2d3$var$looksLikeObjectPathRegExpCache = new $1e580fbd50c9e2d3$var$RegExpCache(20);
const $1e580fbd50c9e2d3$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $1e580fbd50c9e2d3$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $1e580fbd50c9e2d3$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $1e580fbd50c9e2d3$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $1e580fbd50c9e2d3$var$getCleanedCode = (code)=>code === null || code === void 0 ? void 0 : code.replace(/_/g, '-');
const $1e580fbd50c9e2d3$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        var _console_type_apply, _console_type, _console;
        (_console = console) === null || _console === void 0 ? void 0 : (_console_type = _console[type]) === null || _console_type === void 0 ? void 0 : (_console_type_apply = _console_type.apply) === null || _console_type_apply === void 0 ? void 0 : _console_type_apply.call(_console_type, console, args);
    }
};
class $1e580fbd50c9e2d3$var$Logger {
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $1e580fbd50c9e2d3$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($1e580fbd50c9e2d3$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            prefix: `${this.prefix}:${moduleName}:`
        }, this.options));
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, options);
    }
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
}
var $1e580fbd50c9e2d3$var$baseLogger = new $1e580fbd50c9e2d3$var$Logger();
class $1e580fbd50c9e2d3$var$EventEmitter {
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
    constructor(){
        this.observers = {};
    }
}
class $1e580fbd50c9e2d3$var$ResourceStore extends $1e580fbd50c9e2d3$var$EventEmitter {
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        var _this_data_lng, _this_data;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($1e580fbd50c9e2d3$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $1e580fbd50c9e2d3$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$1e580fbd50c9e2d3$var$isString(key)) return result;
        return $1e580fbd50c9e2d3$var$deepFind((_this_data = this.data) === null || _this_data === void 0 ? void 0 : (_this_data_lng = _this_data[lng]) === null || _this_data_lng === void 0 ? void 0 : _this_data_lng[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $1e580fbd50c9e2d3$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($1e580fbd50c9e2d3$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $1e580fbd50c9e2d3$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $1e580fbd50c9e2d3$var$deepExtend(pack, resources, overwrite);
        else pack = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, pack, resources);
        $1e580fbd50c9e2d3$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
}
var $1e580fbd50c9e2d3$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            var _this_processors_processor;
            var _this_processors_processor_process;
            value = (_this_processors_processor_process = (_this_processors_processor = this.processors[processor]) === null || _this_processors_processor === void 0 ? void 0 : _this_processors_processor.process(value, key, options, translator)) !== null && _this_processors_processor_process !== void 0 ? _this_processors_processor_process : value;
        });
        return value;
    }
};
const $1e580fbd50c9e2d3$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $1e580fbd50c9e2d3$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        var _proxy_revoke;
        proxy === null || proxy === void 0 ? void 0 : (_proxy_revoke = proxy.revoke) === null || _proxy_revoke === void 0 ? void 0 : _proxy_revoke.call(proxy);
        if (key === $1e580fbd50c9e2d3$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$1e580fbd50c9e2d3$var$PATH_KEY]: path } = selector($1e580fbd50c9e2d3$var$createProxy());
    var _opts_keySeparator;
    const keySeparator = (_opts_keySeparator = opts === null || opts === void 0 ? void 0 : opts.keySeparator) !== null && _opts_keySeparator !== void 0 ? _opts_keySeparator : '.';
    var _opts_nsSeparator;
    const nsSeparator = (_opts_nsSeparator = opts === null || opts === void 0 ? void 0 : opts.nsSeparator) !== null && _opts_nsSeparator !== void 0 ? _opts_nsSeparator : ':';
    if (path.length > 1 && nsSeparator) {
        const ns = opts === null || opts === void 0 ? void 0 : opts.ns;
        const nsArray = Array.isArray(ns) ? ns : null;
        if (nsArray && nsArray.length > 1 && nsArray.slice(1).includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
    }
    return path.join(keySeparator);
}
const $1e580fbd50c9e2d3$var$checkedLoadedFor = {};
const $1e580fbd50c9e2d3$var$shouldHandleAsObject = (res)=>!$1e580fbd50c9e2d3$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $1e580fbd50c9e2d3$var$Translator extends $1e580fbd50c9e2d3$var$EventEmitter {
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, o);
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if ((resolved === null || resolved === void 0 ? void 0 : resolved.res) === undefined) return false;
        const isObject = $1e580fbd50c9e2d3$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$1e580fbd50c9e2d3$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $1e580fbd50c9e2d3$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $1e580fbd50c9e2d3$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, o) : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt);
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(keys, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, opt));
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, opt)) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if ((lng === null || lng === void 0 ? void 0 : lng.toLowerCase()) === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved === null || resolved === void 0 ? void 0 : resolved.res;
        const resUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.usedKey) || key;
        const resExactUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.exactUsedKey) || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$1e580fbd50c9e2d3$var$isString(opt.count);
        const hasDefaultValue = $1e580fbd50c9e2d3$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $1e580fbd50c9e2d3$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($1e580fbd50c9e2d3$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt), {
                    ns: namespaces
                })) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt), {
                        defaultValue: $1e580fbd50c9e2d3$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    }));
                    else copy[m] = this.translate(deepKey, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt), {
                        joinArrays: false,
                        ns: namespaces
                    }));
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $1e580fbd50c9e2d3$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt), {
                        keySeparator: false
                    }));
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    var _this_backendConnector;
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if ((_this_backendConnector = this.backendConnector) === null || _this_backendConnector === void 0 ? void 0 : _this_backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        var _this_i18nFormat;
        if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.parse) res = this.i18nFormat.parse(res, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options.interpolation.defaultVariables, opt), opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            var _opt_interpolation;
            if (opt.interpolation) this.interpolator.init((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt), {
                interpolation: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options.interpolation, opt.interpolation)
            }));
            const skipOnVariables = $1e580fbd50c9e2d3$var$isString(res) && ((opt === null || opt === void 0 ? void 0 : (_opt_interpolation = opt.interpolation) === null || _opt_interpolation === void 0 ? void 0 : _opt_interpolation.skipOnVariables) !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$1e580fbd50c9e2d3$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options.interpolation.defaultVariables, data);
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if ((lastKey === null || lastKey === void 0 ? void 0 : lastKey[0]) === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $1e580fbd50c9e2d3$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && (postProcessorNames === null || postProcessorNames === void 0 ? void 0 : postProcessorNames.length) && opt.applyPostProcessor !== false) res = $1e580fbd50c9e2d3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            i18nResolved: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, resolved), {
                usedParams: this.getUsedParamsDetails(opt)
            })
        }, opt) : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($1e580fbd50c9e2d3$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, opt)) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$1e580fbd50c9e2d3$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($1e580fbd50c9e2d3$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                var _this_utils, _this_utils1;
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] && ((_this_utils = this.utils) === null || _this_utils === void 0 ? void 0 : _this_utils.hasLoadedNamespace) && !((_this_utils1 = this.utils) === null || _this_utils1 === void 0 ? void 0 : _this_utils1.hasLoadedNamespace(usedNS))) {
                    $1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    var _this_i18nFormat;
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        var _this_i18nFormat;
        if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$1e580fbd50c9e2d3$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options.interpolation.defaultVariables, data);
        if (!useOptionsReplaceForData) {
            data = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data);
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
    constructor(services, options = {}){
        super();
        $1e580fbd50c9e2d3$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('translator');
    }
}
class $1e580fbd50c9e2d3$var$LanguageUtil {
    getScriptPartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($1e580fbd50c9e2d3$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($1e580fbd50c9e2d3$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($1e580fbd50c9e2d3$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($1e580fbd50c9e2d3$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('languageUtils');
    }
}
const $1e580fbd50c9e2d3$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $1e580fbd50c9e2d3$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $1e580fbd50c9e2d3$var$PluralResolver {
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $1e580fbd50c9e2d3$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $1e580fbd50c9e2d3$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $1e580fbd50c9e2d3$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return (rule === null || rule === void 0 ? void 0 : rule.resolvedOptions().pluralCategories.length) > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory1] - $1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
}
const $1e580fbd50c9e2d3$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $1e580fbd50c9e2d3$var$isString(key)) {
        path = $1e580fbd50c9e2d3$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $1e580fbd50c9e2d3$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $1e580fbd50c9e2d3$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $1e580fbd50c9e2d3$var$Interpolator {
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $1e580fbd50c9e2d3$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $1e580fbd50c9e2d3$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $1e580fbd50c9e2d3$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $1e580fbd50c9e2d3$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $1e580fbd50c9e2d3$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $1e580fbd50c9e2d3$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $1e580fbd50c9e2d3$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if ((existingRegExp === null || existingRegExp === void 0 ? void 0 : existingRegExp.source) === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        var _options_interpolation;
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options, data), {
                    interpolationkey: key
                })) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options, data), {
                interpolationkey: k
            }));
        };
        this.resetRegExp();
        const missingInterpolationHandler = (options === null || options === void 0 ? void 0 : options.missingInterpolationHandler) || this.options.missingInterpolationHandler;
        const skipOnVariables = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.skipOnVariables) !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$1e580fbd50c9e2d3$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $1e580fbd50c9e2d3$var$regexSafe(this.escape(val)) : $1e580fbd50c9e2d3$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $1e580fbd50c9e2d3$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$1e580fbd50c9e2d3$var$isString(value) && !this.useRawValueToEscape) value = $1e580fbd50c9e2d3$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${$1e580fbd50c9e2d3$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            var _matchedSingleQuotes_length, _matchedDoubleQuotes_length;
            if (((_matchedSingleQuotes_length = matchedSingleQuotes === null || matchedSingleQuotes === void 0 ? void 0 : matchedSingleQuotes.length) !== null && _matchedSingleQuotes_length !== void 0 ? _matchedSingleQuotes_length : 0) % 2 === 0 && !matchedDoubleQuotes || ((_matchedDoubleQuotes_length = matchedDoubleQuotes === null || matchedDoubleQuotes === void 0 ? void 0 : matchedDoubleQuotes.length) !== null && _matchedDoubleQuotes_length !== void 0 ? _matchedDoubleQuotes_length : 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, inheritedOptions, clonedOptions);
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options);
            clonedOptions = clonedOptions.replace && !$1e580fbd50c9e2d3$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$1e580fbd50c9e2d3$var$isString(value)) return value;
            if (!$1e580fbd50c9e2d3$var$isString(value)) value = $1e580fbd50c9e2d3$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                    interpolationkey: match[1].trim()
                })), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
    constructor(options = {}){
        var _options_interpolation;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.format) || ((value)=>value);
        this.init(options);
    }
}
const $1e580fbd50c9e2d3$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $1e580fbd50c9e2d3$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, optForCache), {
            [o.interpolationkey]: undefined
        });
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($1e580fbd50c9e2d3$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $1e580fbd50c9e2d3$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($1e580fbd50c9e2d3$var$getCleanedCode(l), o)(v);
class $1e580fbd50c9e2d3$var$Formatter {
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $1e580fbd50c9e2d3$var$createCachedFormatter : $1e580fbd50c9e2d3$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt), {
                    style: 'currency'
                }));
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $1e580fbd50c9e2d3$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $1e580fbd50c9e2d3$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    var _options_formatParams;
                    const valOptions = (options === null || options === void 0 ? void 0 : (_options_formatParams = options.formatParams) === null || _options_formatParams === void 0 ? void 0 : _options_formatParams[options.interpolationkey]) || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, formatOptions, options, valOptions));
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
    constructor(options = {}){
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
}
const $1e580fbd50c9e2d3$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $1e580fbd50c9e2d3$var$Connector extends $1e580fbd50c9e2d3$var$EventEmitter {
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $1e580fbd50c9e2d3$var$pushPath(q.loaded, [
                lng
            ], ns);
            $1e580fbd50c9e2d3$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($1e580fbd50c9e2d3$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($1e580fbd50c9e2d3$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        var _this_services_utils, _this_services, _this_services_utils1, _this_services1, _this_backend;
        if (((_this_services = this.services) === null || _this_services === void 0 ? void 0 : (_this_services_utils = _this_services.utils) === null || _this_services_utils === void 0 ? void 0 : _this_services_utils.hasLoadedNamespace) && !((_this_services1 = this.services) === null || _this_services1 === void 0 ? void 0 : (_this_services_utils1 = _this_services1.utils) === null || _this_services_utils1 === void 0 ? void 0 : _this_services_utils1.hasLoadedNamespace(namespace))) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if ((_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : _this_backend.create) {
            const opts = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                isUpdate: isUpdate
            });
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
    constructor(backend, store, services, options = {}){
        var _this_backend_init, _this_backend;
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        (_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : (_this_backend_init = _this_backend.init) === null || _this_backend_init === void 0 ? void 0 : _this_backend_init.call(_this_backend, services, options.backend, options);
    }
}
const $1e580fbd50c9e2d3$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($1e580fbd50c9e2d3$var$isString(args[1])) ret.defaultValue = args[1];
            if ($1e580fbd50c9e2d3$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $1e580fbd50c9e2d3$var$transformOptions = (options)=>{
    var _options_supportedLngs_indexOf, _options_supportedLngs;
    if ($1e580fbd50c9e2d3$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($1e580fbd50c9e2d3$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($1e580fbd50c9e2d3$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (((_options_supportedLngs = options.supportedLngs) === null || _options_supportedLngs === void 0 ? void 0 : (_options_supportedLngs_indexOf = _options_supportedLngs.indexOf) === null || _options_supportedLngs_indexOf === void 0 ? void 0 : _options_supportedLngs_indexOf.call(_options_supportedLngs, 'cimode')) < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $1e580fbd50c9e2d3$var$noop = ()=>{};
const $1e580fbd50c9e2d3$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
const $1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY = '__i18next_supportNoticeShown';
const $1e580fbd50c9e2d3$var$getSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined' && !!globalThis[$1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY]) return true;
    return false;
};
const $1e580fbd50c9e2d3$var$setSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined') globalThis[$1e580fbd50c9e2d3$var$SUPPORT_NOTICE_KEY] = true;
};
const $1e580fbd50c9e2d3$var$usesLocize = (inst)=>{
    var _inst_modules_backend_name, _inst_modules_backend, _inst_modules, _inst_modules_backend_constructor_name, _inst_modules_backend_constructor, _inst_modules_backend1, _inst_modules1, _inst_options_backend, _inst_options, _inst_options_backend1, _inst_options1, _inst_options_backend2, _inst_options2;
    if ((inst === null || inst === void 0 ? void 0 : (_inst_modules = inst.modules) === null || _inst_modules === void 0 ? void 0 : (_inst_modules_backend = _inst_modules.backend) === null || _inst_modules_backend === void 0 ? void 0 : (_inst_modules_backend_name = _inst_modules_backend.name) === null || _inst_modules_backend_name === void 0 ? void 0 : _inst_modules_backend_name.indexOf('Locize')) > 0) return true;
    if ((inst === null || inst === void 0 ? void 0 : (_inst_modules1 = inst.modules) === null || _inst_modules1 === void 0 ? void 0 : (_inst_modules_backend1 = _inst_modules1.backend) === null || _inst_modules_backend1 === void 0 ? void 0 : (_inst_modules_backend_constructor = _inst_modules_backend1.constructor) === null || _inst_modules_backend_constructor === void 0 ? void 0 : (_inst_modules_backend_constructor_name = _inst_modules_backend_constructor.name) === null || _inst_modules_backend_constructor_name === void 0 ? void 0 : _inst_modules_backend_constructor_name.indexOf('Locize')) > 0) return true;
    if (inst === null || inst === void 0 ? void 0 : (_inst_options = inst.options) === null || _inst_options === void 0 ? void 0 : (_inst_options_backend = _inst_options.backend) === null || _inst_options_backend === void 0 ? void 0 : _inst_options_backend.backends) {
        if (inst.options.backend.backends.some((b)=>{
            var _b_name, _b_constructor_name, _b_constructor;
            return (b === null || b === void 0 ? void 0 : (_b_name = b.name) === null || _b_name === void 0 ? void 0 : _b_name.indexOf('Locize')) > 0 || (b === null || b === void 0 ? void 0 : (_b_constructor = b.constructor) === null || _b_constructor === void 0 ? void 0 : (_b_constructor_name = _b_constructor.name) === null || _b_constructor_name === void 0 ? void 0 : _b_constructor_name.indexOf('Locize')) > 0;
        })) return true;
    }
    if (inst === null || inst === void 0 ? void 0 : (_inst_options1 = inst.options) === null || _inst_options1 === void 0 ? void 0 : (_inst_options_backend1 = _inst_options1.backend) === null || _inst_options_backend1 === void 0 ? void 0 : _inst_options_backend1.projectId) return true;
    if (inst === null || inst === void 0 ? void 0 : (_inst_options2 = inst.options) === null || _inst_options2 === void 0 ? void 0 : (_inst_options_backend2 = _inst_options2.backend) === null || _inst_options_backend2 === void 0 ? void 0 : _inst_options_backend2.backendOptions) {
        if (inst.options.backend.backendOptions.some((b)=>b === null || b === void 0 ? void 0 : b.projectId)) return true;
    }
    return false;
};
class $1e580fbd50c9e2d3$var$I18n extends $1e580fbd50c9e2d3$var$EventEmitter {
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($1e580fbd50c9e2d3$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $1e580fbd50c9e2d3$var$get();
        this.options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defOpts, this.options, $1e580fbd50c9e2d3$var$transformOptions(options));
        this.options.interpolation = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defOpts.interpolation, this.options.interpolation);
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        if (this.options.showSupportNotice !== false && !$1e580fbd50c9e2d3$var$usesLocize(this) && !$1e580fbd50c9e2d3$var$getSupportNoticeShown()) {
            if (typeof console !== 'undefined' && typeof console.info !== 'undefined') console.info("\uD83C\uDF10 i18next is made possible by our own product, Locize \u2014 consider powering your project with managed localization (AI, CDN, integrations): https://locize.com \uD83D\uDC99");
            $1e580fbd50c9e2d3$var$setSupportNoticeShown();
        }
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $1e580fbd50c9e2d3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $1e580fbd50c9e2d3$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $1e580fbd50c9e2d3$var$Formatter;
            const lu = new $1e580fbd50c9e2d3$var$LanguageUtil(this.options);
            this.store = new $1e580fbd50c9e2d3$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $1e580fbd50c9e2d3$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $1e580fbd50c9e2d3$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $1e580fbd50c9e2d3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $1e580fbd50c9e2d3$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $1e580fbd50c9e2d3$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $1e580fbd50c9e2d3$var$noop) {
        let usedCallback = callback;
        const usedLng = $1e580fbd50c9e2d3$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            var _this_options_preload_forEach, _this_options_preload;
            if ((usedLng === null || usedLng === void 0 ? void 0 : usedLng.toLowerCase()) === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            (_this_options_preload = this.options.preload) === null || _this_options_preload === void 0 ? void 0 : (_this_options_preload_forEach = _this_options_preload.forEach) === null || _this_options_preload_forEach === void 0 ? void 0 : _this_options_preload_forEach.call(_this_options_preload, (l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $1e580fbd50c9e2d3$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $1e580fbd50c9e2d3$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $1e580fbd50c9e2d3$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($1e580fbd50c9e2d3$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                var _this_services_languageDetector_cacheUserLanguage, _this_services_languageDetector;
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                (_this_services_languageDetector = this.services.languageDetector) === null || _this_services_languageDetector === void 0 ? void 0 : (_this_services_languageDetector_cacheUserLanguage = _this_services_languageDetector.cacheUserLanguage) === null || _this_services_languageDetector_cacheUserLanguage === void 0 ? void 0 : _this_services_languageDetector_cacheUserLanguage.call(_this_services_languageDetector, l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts);
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, o);
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $1e580fbd50c9e2d3$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($1e580fbd50c9e2d3$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        var _this_translator;
        return (_this_translator = this.translator) === null || _this_translator === void 0 ? void 0 : _this_translator.translate(...args);
    }
    exists(...args) {
        var _this_translator;
        return (_this_translator = this.translator) === null || _this_translator === void 0 ? void 0 : _this_translator.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($1e580fbd50c9e2d3$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if ($1e580fbd50c9e2d3$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        var _this_languages, _this_services;
        if (!lng) lng = this.resolvedLanguage || (((_this_languages = this.languages) === null || _this_languages === void 0 ? void 0 : _this_languages.length) > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = ((_this_services = this.services) === null || _this_services === void 0 ? void 0 : _this_services.languageUtils) || new $1e580fbd50c9e2d3$var$LanguageUtil($1e580fbd50c9e2d3$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $1e580fbd50c9e2d3$var$I18n(options, callback);
        instance.createInstance = $1e580fbd50c9e2d3$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $1e580fbd50c9e2d3$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, options), {
            isClone: true
        });
        const clone = new $1e580fbd50c9e2d3$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.services);
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.store.data[l]);
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev[l][n]);
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $1e580fbd50c9e2d3$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $1e580fbd50c9e2d3$var$get();
            const mergedInterpolation = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defOpts.interpolation, this.options.interpolation, options.interpolation);
            const mergedForInterpolator = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions), {
                interpolation: mergedInterpolation
            });
            clone.services.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $1e580fbd50c9e2d3$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
    constructor(options = {}, callback){
        super();
        this.options = $1e580fbd50c9e2d3$var$transformOptions(options);
        this.services = {};
        this.logger = $1e580fbd50c9e2d3$var$baseLogger;
        this.modules = {
            external: []
        };
        $1e580fbd50c9e2d3$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
}
const $1e580fbd50c9e2d3$export$2e2bcd8739ae039 = $1e580fbd50c9e2d3$var$I18n.createInstance();
const $1e580fbd50c9e2d3$export$99152e8d49ca4e7d = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.createInstance;
const $1e580fbd50c9e2d3$export$147ec2801e896265 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.dir;
const $1e580fbd50c9e2d3$export$2cd8252107eb640b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.init;
const $1e580fbd50c9e2d3$export$d3d08d944062d7e = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadResources;
const $1e580fbd50c9e2d3$export$a5d9bf5d83fcab09 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.reloadResources;
const $1e580fbd50c9e2d3$export$1f96ae73734a86cc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.use;
const $1e580fbd50c9e2d3$export$61465194746e7fd2 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.changeLanguage;
const $1e580fbd50c9e2d3$export$f90d180fc7da3b3b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.getFixedT;
const $1e580fbd50c9e2d3$export$625550452a3fa3ec = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.t;
const $1e580fbd50c9e2d3$export$f7e9f41ea797a17 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.exists;
const $1e580fbd50c9e2d3$export$2b4b218e406d2d00 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.setDefaultNamespace;
const $1e580fbd50c9e2d3$export$93d9ee97c1ad3f31 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.hasLoadedNamespace;
const $1e580fbd50c9e2d3$export$83be934b53fff43b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadNamespaces;
const $1e580fbd50c9e2d3$export$8cd7e7a54fa865bc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadLanguages;


const { slice: $f73f86de2138df56$var$slice, forEach: $f73f86de2138df56$var$forEach } = [];
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$forEach.call($f73f86de2138df56$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f73f86de2138df56$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $f73f86de2138df56$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $f73f86de2138df56$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $f73f86de2138df56$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $f73f86de2138df56$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            var _window_location_hash;
            let { search: search } = window.location;
            if (!window.location.search && ((_window_location_hash = window.location.hash) === null || _window_location_hash === void 0 ? void 0 : _window_location_hash.indexOf('?')) > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    var _language_index;
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return (_language_index = language[index]) === null || _language_index === void 0 ? void 0 : _language_index.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $f73f86de2138df56$var$hasLocalStorageSupport = null;
const $f73f86de2138df56$var$localStorageAvailable = ()=>{
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$f73f86de2138df56$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $f73f86de2138df56$var$hasSessionStorageSupport = null;
const $f73f86de2138df56$var$sessionStorageAvailable = ()=>{
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$f73f86de2138df56$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        var _language_index;
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return (_language_index = language[index]) === null || _language_index === void 0 ? void 0 : _language_index.replace('/', '');
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        var _window_location_hostname, _window_location;
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && ((_window_location = window.location) === null || _window_location === void 0 ? void 0 : (_window_location_hostname = _window_location.hostname) === null || _window_location_hostname === void 0 ? void 0 : _window_location_hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $f73f86de2138df56$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $f73f86de2138df56$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $f73f86de2138df56$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$f73f86de2138df56$var$canCookies) $f73f86de2138df56$var$order.splice(1, 1);
const $f73f86de2138df56$var$getDefaults = ()=>({
        order: $f73f86de2138df56$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $f73f86de2138df56$export$2e2bcd8739ae039 {
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($f73f86de2138df56$var$cookie$1);
        this.addDetector($f73f86de2138df56$var$querystring);
        this.addDetector($f73f86de2138df56$var$localStorage);
        this.addDetector($f73f86de2138df56$var$sessionStorage);
        this.addDetector($f73f86de2138df56$var$navigator$1);
        this.addDetector($f73f86de2138df56$var$htmlTag);
        this.addDetector($f73f86de2138df56$var$path);
        this.addDetector($f73f86de2138df56$var$subdomain);
        this.addDetector($f73f86de2138df56$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$f73f86de2138df56$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
}
$f73f86de2138df56$export$2e2bcd8739ae039.type = 'languageDetector';


function $5e94ee2b5c33482b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5e94ee2b5c33482b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5e94ee2b5c33482b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5e94ee2b5c33482b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5e94ee2b5c33482b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5e94ee2b5c33482b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5e94ee2b5c33482b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e94ee2b5c33482b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e94ee2b5c33482b$var$_typeof(o);
}
var $5e94ee2b5c33482b$var$arr = [];
var $5e94ee2b5c33482b$var$each = $5e94ee2b5c33482b$var$arr.forEach;
var $5e94ee2b5c33482b$var$slice = $5e94ee2b5c33482b$var$arr.slice;
var $5e94ee2b5c33482b$var$UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
function $5e94ee2b5c33482b$export$ebe90cb607ad99e(obj) {
    $5e94ee2b5c33482b$var$each.call($5e94ee2b5c33482b$var$slice.call(arguments, 1), function(source) {
        if (source) for(var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++){
            var prop = _Object$keys[_i];
            if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(prop) > -1) continue;
            if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $5e94ee2b5c33482b$var$isSafeUrlSegmentBase(v) {
    if (typeof v !== 'string') return false;
    if (v.length === 0 || v.length > 128) return false;
    if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(v) > -1) return false;
    if (v.indexOf('..') > -1) return false;
    if (v.indexOf('\\') > -1) return false;
    if (/[?#%\s@]/.test(v)) return false;
    if (/[\x00-\x1F\x7F]/.test(v)) return false;
    return true;
}
function $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa(v) {
    if (!$5e94ee2b5c33482b$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf('/') > -1) return false;
    return true;
}
function $5e94ee2b5c33482b$export$d8513ff071200f5b(v) {
    return $5e94ee2b5c33482b$var$isSafeUrlSegmentBase(v);
}
var $5e94ee2b5c33482b$export$fcec0b7704220ff2 = $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa;
var $5e94ee2b5c33482b$var$SAFETY_CHECK_BY_KEY = {
    lng: $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa,
    ns: $5e94ee2b5c33482b$export$d8513ff071200f5b
};
function $5e94ee2b5c33482b$export$b5ba5937b9227ae9(v) {
    if (typeof v !== 'string') return v;
    return v.replace(/[\r\n\x00-\x1F\x7F]/g, ' ');
}
function $5e94ee2b5c33482b$export$fee0a5152e4c950b(u) {
    if (typeof u !== 'string' || u.length === 0) return u;
    try {
        var parsed = new URL(u);
        if (parsed.username || parsed.password) {
            parsed.username = '';
            parsed.password = '';
            return parsed.toString();
        }
        return u;
    } catch (e) {
        return u.replace(/(\/\/)[^/@\s]+@/g, '$1');
    }
}
function $5e94ee2b5c33482b$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $5e94ee2b5c33482b$var$_typeof(XMLHttpRequest)) === 'object';
}
function $5e94ee2b5c33482b$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $5e94ee2b5c33482b$export$1625492ec82002b9(maybePromise) {
    if ($5e94ee2b5c33482b$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}
var $5e94ee2b5c33482b$var$interpolationRegexp = /\{\{(.+?)\}\}/g;
function $5e94ee2b5c33482b$export$89e29e4ab65e70a9(str, data) {
    return str.replace($5e94ee2b5c33482b$var$interpolationRegexp, function(match, key) {
        var k = key.trim();
        if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(k) > -1) return match;
        var value = data[k];
        return value != null ? value : match;
    });
}
function $5e94ee2b5c33482b$export$538bd54113066b32(str, data) {
    var unsafe = false;
    var result = str.replace($5e94ee2b5c33482b$var$interpolationRegexp, function(match, key) {
        var k = key.trim();
        if ($5e94ee2b5c33482b$var$UNSAFE_KEYS.indexOf(k) > -1) return match;
        var value = data[k];
        if (value == null) return match;
        var check = $5e94ee2b5c33482b$var$SAFETY_CHECK_BY_KEY[k] || $5e94ee2b5c33482b$export$d4b1d5d3c7993bfa;
        var segments = String(value).split('+');
        var _iterator = $5e94ee2b5c33482b$var$_createForOfIteratorHelper(segments), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var seg = _step.value;
                if (!check(seg)) {
                    unsafe = true;
                    return match;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return segments.join('+');
    });
    return unsafe ? null : result;
}



function $115a9e8b8151a003$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $115a9e8b8151a003$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $115a9e8b8151a003$var$ownKeys(Object(t), !0).forEach(function(r) {
            $115a9e8b8151a003$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $115a9e8b8151a003$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $115a9e8b8151a003$var$_defineProperty(e, r, t) {
    return (r = $115a9e8b8151a003$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $115a9e8b8151a003$var$_toPropertyKey(t) {
    var i = $115a9e8b8151a003$var$_toPrimitive(t, "string");
    return "symbol" == $115a9e8b8151a003$var$_typeof(i) ? i : i + "";
}
function $115a9e8b8151a003$var$_toPrimitive(t, r) {
    if ("object" != $115a9e8b8151a003$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $115a9e8b8151a003$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $115a9e8b8151a003$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $115a9e8b8151a003$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $115a9e8b8151a003$var$_typeof(o);
}
var $115a9e8b8151a003$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $115a9e8b8151a003$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $115a9e8b8151a003$var$fetchApi = window.fetch;
var $115a9e8b8151a003$var$XmlHttpRequestApi;
if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $115a9e8b8151a003$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $115a9e8b8151a003$var$fetchApi !== 'function') $115a9e8b8151a003$var$fetchApi = undefined;

if (!$115a9e8b8151a003$var$fetchApi && !$115a9e8b8151a003$var$XmlHttpRequestApi && !$115a9e8b8151a003$var$ActiveXObjectApi) try {
    (parcelRequire("5toGc")).then(function(mod) {
        $115a9e8b8151a003$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $115a9e8b8151a003$var$UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
var $115a9e8b8151a003$var$addQueryString = function addQueryString(url, params) {
    if (params && $115a9e8b8151a003$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++){
            var paramName = _Object$keys[_i];
            if ($115a9e8b8151a003$var$UNSAFE_KEYS.indexOf(paramName) > -1) continue;
            queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        }
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $115a9e8b8151a003$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $115a9e8b8151a003$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $115a9e8b8151a003$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    var headers = $115a9e8b8151a003$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $115a9e8b8151a003$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, options._omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback, altFetch);
            options._omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $115a9e8b8151a003$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $115a9e8b8151a003$var$_typeof(payload) === 'object') payload = $115a9e8b8151a003$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $115a9e8b8151a003$var$XmlHttpRequestApi ? new $115a9e8b8151a003$var$XmlHttpRequestApi() : new $115a9e8b8151a003$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var _i2 = 0, _Object$keys2 = Object.keys(h); _i2 < _Object$keys2.length; _i2++){
            var i = _Object$keys2[_i2];
            if ($115a9e8b8151a003$var$UNSAFE_KEYS.indexOf(i) > -1) continue;
            x.setRequestHeader(i, h[i]);
        }
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $115a9e8b8151a003$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($115a9e8b8151a003$var$fetchApi && url.indexOf('file:') !== 0) return $115a9e8b8151a003$var$requestWithFetch(options, url, payload, callback);
    if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $115a9e8b8151a003$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $115a9e8b8151a003$export$2e2bcd8739ae039 = $115a9e8b8151a003$var$request;


function $fcb831e2a23edeea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fcb831e2a23edeea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fcb831e2a23edeea$var$_typeof(o);
}
function $fcb831e2a23edeea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcb831e2a23edeea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcb831e2a23edeea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fcb831e2a23edeea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcb831e2a23edeea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fcb831e2a23edeea$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $fcb831e2a23edeea$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $fcb831e2a23edeea$var$_toPropertyKey(o.key), o);
    }
}
function $fcb831e2a23edeea$var$_createClass(e, r, t) {
    return r && $fcb831e2a23edeea$var$_defineProperties(e.prototype, r), t && $fcb831e2a23edeea$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $fcb831e2a23edeea$var$_defineProperty(e, r, t) {
    return (r = $fcb831e2a23edeea$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fcb831e2a23edeea$var$_toPropertyKey(t) {
    var i = $fcb831e2a23edeea$var$_toPrimitive(t, "string");
    return "symbol" == $fcb831e2a23edeea$var$_typeof(i) ? i : i + "";
}
function $fcb831e2a23edeea$var$_toPrimitive(t, r) {
    if ("object" != $fcb831e2a23edeea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fcb831e2a23edeea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fcb831e2a23edeea$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $fcb831e2a23edeea$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $115a9e8b8151a003$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $fcb831e2a23edeea$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $fcb831e2a23edeea$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $fcb831e2a23edeea$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $fcb831e2a23edeea$var$_objectSpread($fcb831e2a23edeea$var$_objectSpread($fcb831e2a23edeea$var$_objectSpread({}, $fcb831e2a23edeea$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($fcb831e2a23edeea$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $5e94ee2b5c33482b$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = (0, $5e94ee2b5c33482b$export$538bd54113066b32)(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    if (url == null) {
                        var safeLngs = languages.map((0, $5e94ee2b5c33482b$export$b5ba5937b9227ae9)).join(', ');
                        var safeNss = namespaces.map((0, $5e94ee2b5c33482b$export$b5ba5937b9227ae9)).join(', ');
                        return callback(new Error("i18next-http-backend: unsafe lng/ns value \u2014 refusing to build request URL for languages=[" + safeLngs + '] namespaces=[' + safeNss + ']'), false);
                    }
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                var safeUrl = (0, $5e94ee2b5c33482b$export$b5ba5937b9227ae9)((0, $5e94ee2b5c33482b$export$fee0a5152e4c950b)(url));
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + safeUrl + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + safeUrl + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + safeUrl + ': ' + (0, $5e94ee2b5c33482b$export$b5ba5937b9227ae9)(err.message), true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + safeUrl + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = (0, $5e94ee2b5c33482b$export$538bd54113066b32)(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    if (url == null) {
                        finished += 1;
                        if (callback && finished === languages.length) callback(dataArray, resArray);
                        return;
                    }
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$fcb831e2a23edeea$var$Backend.type = 'backend';
var $fcb831e2a23edeea$export$2e2bcd8739ae039 = $fcb831e2a23edeea$var$Backend;





var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
var $f1ee620f0561c02a$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $f1ee620f0561c02a$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3be60b4f29d3a6e3$var$e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($f1ee620f0561c02a$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$e), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var l = c[1].trim(), o = [
                l,
                ""
            ];
            l.indexOf("=") > -1 && (o = l.split("=")), r.attrs[o[0]] = o[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(t, e) {
    switch(e.type){
        case "text":
            return t + e.content;
        case "tag":
            return t += "<" + e.name + (e.attrs ? function(t) {
                var e = [];
                for(var n in t)e.push(n + '="' + t[n] + '"');
                return e.length ? " " + e.join(" ") : "";
            }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + e.name + ">";
        case "comment":
            return t + "\x3c!--" + e.comment + "--\x3e";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(t, e) {
        e || (e = {}), e.components || (e.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], l = [], o = -1, u = !1;
        if (0 !== t.indexOf("<")) {
            var h = t.indexOf("<");
            c.push({
                type: "text",
                content: -1 === h ? t : t.substring(0, h)
            });
        }
        for(var v, f = []; v = $3be60b4f29d3a6e3$var$r.exec(t);)f.push(v);
        return f.forEach(function(t, e) {
            var n = t[0];
            if (n && !n.startsWith("\x3c!--")) {
                for(var r = 0, i = 0, s = -1, a = null, c = 0; c < n.length; c++){
                    var l = n.charAt(c);
                    a ? l === a && (a = null) : '"' === l || "'" === l ? a = l : "<" === l ? 2 == ++r && (s = c) : ">" === l && i++;
                }
                var o = s > -1 && /[a-zA-Z0-9\-!/]/.test(n.charAt(s + 1));
                if (r > i && o) {
                    var u = n.substring(0, s), h = n.substring(u.length);
                    f[e][0] = h, f[e].index += u.length;
                }
            }
        }), f.forEach(function(r, s) {
            var h = r[0];
            if (h) {
                var v = r.index;
                if (u) {
                    if (h !== "</" + a.name + ">") return;
                    u = !1;
                }
                var m, d, p = "/" !== h.charAt(1), x = h.startsWith("\x3c!--"), g = v + h.length, y = t.charAt(g), E = f[s + 1];
                if ("<" === y && E) {
                    var A = t.substring(g, E.index);
                    m = A.split("<").length > A.split(">").length;
                }
                if (x) {
                    var b = $3be60b4f29d3a6e3$var$n(h);
                    if (o < 0) return c.push(b), c;
                    (d = l[o]).children.push(b);
                    var O = t.slice(g, E ? E.index : void 0);
                    return O.length > 0 && d.children.push({
                        type: "text",
                        content: O
                    }), c;
                }
                if (p && (o++, "tag" === (a = $3be60b4f29d3a6e3$var$n(h)).type && e.components[a.name] && (a.type = "component", u = !0), a.voidElement || u || !y || "<" === y || a.children.push({
                    type: "text",
                    content: t.slice(g, E ? E.index : void 0)
                }), 0 === o && c.push(a), (d = l[o - 1]) && d.children.push(a), l[o] = a), (!p || a.voidElement) && (o > -1 && (a.voidElement || a.name === h.slice(2, -1)) && (o--, a = -1 === o ? c : l[o]), !u && ("<" !== y || m) && y)) {
                    d = -1 === o ? c : l[o].children;
                    var W = E ? E.index : -1, j = t.slice(g, -1 === W ? void 0 : W);
                    $3be60b4f29d3a6e3$var$i.test(j) && (j = " "), (W > -1 && o + d.length >= 0 || " " !== j) && d.push({
                        type: "text",
                        content: j
                    });
                }
            }
        }), c;
    },
    stringify: function(t) {
        return t.reduce(function(t, e) {
            return t + $3be60b4f29d3a6e3$var$a("", e);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;



const $445d14444882807b$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    var _i18n_services_logger, _i18n_services, _i18n_services_logger1, _i18n_services1, _console;
    const args = [
        msg,
        (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            code: code
        }, rest || {})
    ];
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services = i18n.services) === null || _i18n_services === void 0 ? void 0 : (_i18n_services_logger = _i18n_services.logger) === null || _i18n_services_logger === void 0 ? void 0 : _i18n_services_logger.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($445d14444882807b$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services1 = i18n.services) === null || _i18n_services1 === void 0 ? void 0 : (_i18n_services_logger1 = _i18n_services1.logger) === null || _i18n_services_logger1 === void 0 ? void 0 : _i18n_services_logger1.warn) i18n.services.logger.warn(...args);
    else if ((_console = console) === null || _console === void 0 ? void 0 : _console.warn) console.warn(...args);
};
const $445d14444882807b$var$alreadyWarned = {};
const $445d14444882807b$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($445d14444882807b$export$844ec244b1367d54(msg) && $445d14444882807b$var$alreadyWarned[msg]) return;
    if ($445d14444882807b$export$844ec244b1367d54(msg)) $445d14444882807b$var$alreadyWarned[msg] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $445d14444882807b$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $445d14444882807b$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $445d14444882807b$var$loadedClb(i18n, cb));
};
const $445d14444882807b$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($445d14444882807b$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $445d14444882807b$var$loadedClb(i18n, cb));
};
const $445d14444882807b$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $445d14444882807b$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($445d14444882807b$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $445d14444882807b$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $445d14444882807b$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;



const $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $dbc236e0ae4b1bc0$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = (m)=>$dbc236e0ae4b1bc0$var$htmlEntities[m];
const $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = (text)=>text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);


let $ba1062cc0d1f4b93$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $dbc236e0ae4b1bc0$export$e8bacd2802a88316
};
const $ba1062cc0d1f4b93$export$2e2366488d12e20d = (options = {})=>{
    $ba1062cc0d1f4b93$var$defaultOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ba1062cc0d1f4b93$var$defaultOptions, options);
};
const $ba1062cc0d1f4b93$export$212bb2fc580a90a8 = ()=>$ba1062cc0d1f4b93$var$defaultOptions;


let $91a4dd25d142fe34$var$i18nInstance;
const $91a4dd25d142fe34$export$a039134f2fc7e0 = (instance)=>{
    $91a4dd25d142fe34$var$i18nInstance = instance;
};
const $91a4dd25d142fe34$export$64af334f494c2f47 = ()=>$91a4dd25d142fe34$var$i18nInstance;


const $1bd7e790a57f14c4$var$hasChildren = (node, checkLength)=>{
    var _node_props;
    if (!node) return false;
    var _node_props_children;
    const base = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $1bd7e790a57f14c4$var$getChildren = (node)=>{
    var _node_props, _node_props1;
    if (!node) return [];
    var _node_props_children;
    const children = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    return ((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.i18nIsDynamicList) ? $1bd7e790a57f14c4$var$getAsArray(children) : children;
};
const $1bd7e790a57f14c4$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $7fPBF.isValidElement));
const $1bd7e790a57f14c4$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $1bd7e790a57f14c4$var$mergeProps = (source, target)=>{
    const newTarget = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $1bd7e790a57f14c4$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $1bd7e790a57f14c4$var$getAsArray(children);
    var _i18nOptions_transKeepBasicHtmlNodesFor;
    const keepArray = (i18nOptions === null || i18nOptions === void 0 ? void 0 : i18nOptions.transSupportBasicHtmlNodes) ? (_i18nOptions_transKeepBasicHtmlNodesFor = i18nOptions.transKeepBasicHtmlNodesFor) !== null && _i18nOptions_transKeepBasicHtmlNodesFor !== void 0 ? _i18nOptions_transKeepBasicHtmlNodesFor : [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $445d14444882807b$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $7fPBF.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $445d14444882807b$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $1bd7e790a57f14c4$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $445d14444882807b$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(child)) {
            const { format: format } = child, clone = (0, $8901fc92b5563702$export$71511d61b312f219)(child, [
                "format"
            ]);
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $445d14444882807b$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $445d14444882807b$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $1bd7e790a57f14c4$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap !== null && knownComponentsMap !== void 0 ? knownComponentsMap : {};
    const getData = (childs)=>{
        const childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $445d14444882807b$export$844ec244b1367d54)(child)) return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(child) && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $3be60b4f29d3a6e3$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data, combinedTOpts);
    const renderInner = (child, node, rootReactNode)=>{
        var _child_props;
        const childs = $1bd7e790a57f14c4$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1bd7e790a57f14c4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || ((_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.i18nIsDynamicList) ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $7fPBF.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $7fPBF.Children).map([
            child
        ], (c)=>{
            const props = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c.props);
            delete props.i18nIsDynamicList;
            var _c_props_ref;
            return (0, $7fPBF.createElement)(c.type, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
                key: i,
                ref: (_c_props_ref = c.props.ref) !== null && _c_props_ref !== void 0 ? _c_props_ref : c.ref
            }), isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $1bd7e790a57f14c4$var$getAsArray(reactNode);
        const astNodes = $1bd7e790a57f14c4$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            var _node_children_, _node_children;
            const translationContent = ((_node_children = node.children) === null || _node_children === void 0 ? void 0 : (_node_children_ = _node_children[0]) === null || _node_children_ === void 0 ? void 0 : _node_children_.content) && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $1bd7e790a57f14c4$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $7fPBF.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $1bd7e790a57f14c4$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $445d14444882807b$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $445d14444882807b$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $445d14444882807b$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1bd7e790a57f14c4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1bd7e790a57f14c4$var$getAsArray(children || []));
    return $1bd7e790a57f14c4$var$getChildren(result[0]);
};
const $1bd7e790a57f14c4$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $7fPBF.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, comp);
    }
    return (0, $7fPBF.createElement)(Componentized, {
        key: componentKey
    });
};
const $1bd7e790a57f14c4$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$1bd7e790a57f14c4$var$fixComponentProps(c, index, translation));
const $1bd7e790a57f14c4$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $1bd7e790a57f14c4$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $1bd7e790a57f14c4$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $1bd7e790a57f14c4$var$generateArrayComponents(components, translation);
    if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(components)) return $1bd7e790a57f14c4$var$generateObjectComponents(components, translation);
    (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $1bd7e790a57f14c4$var$isComponentsMap = (object)=>{
    if (!(0, $445d14444882807b$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce(_param) {
    var { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape } = _param, additionalProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children",
        "count",
        "parent",
        "i18nKey",
        "context",
        "tOptions",
        "values",
        "defaults",
        "components",
        "ns",
        "i18n",
        "t",
        "shouldUnescape"
    ]);
    var _i18n_options, _i18n_options1, _i18n_options_interpolation, _i18n_options2, _i18n_options_interpolation1, _i18n_options3;
    const i18n = i18nFromProps || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)(), (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.react);
    let namespaces = ns || t.ns || ((_i18n_options1 = i18n.options) === null || _i18n_options1 === void 0 ? void 0 : _i18n_options1.defaultNS);
    namespaces = (0, $445d14444882807b$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if ((_i18n_options2 = i18n.options) === null || _i18n_options2 === void 0 ? void 0 : (_i18n_options_interpolation = _i18n_options2.interpolation) === null || _i18n_options_interpolation === void 0 ? void 0 : _i18n_options_interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, values, i18n.options.interpolation.defaultVariables) : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, i18n.options.interpolation.defaultVariables);
    const interpolationOverride = values || count !== undefined && !((_i18n_options3 = i18n.options) === null || _i18n_options3 === void 0 ? void 0 : (_i18n_options_interpolation1 = _i18n_options3.interpolation) === null || _i18n_options_interpolation1 === void 0 ? void 0 : _i18n_options_interpolation1.alwaysFormat) || !children ? tOptions.interpolation : {
        interpolation: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tOptions.interpolation), {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    const combinedTOpts = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tOptions), {
        context: context || tOptions.context,
        count: count
    }), values, interpolationOverride), {
        defaultValue: defaultValue,
        ns: namespaces
    });
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const generatedComponents = $1bd7e790a57f14c4$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($1bd7e790a57f14c4$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $1bd7e790a57f14c4$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== null && parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}




var $7fPBF = parcelRequire("7fPBF");




const $09536692873e4879$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $ba1062cc0d1f4b93$export$2e2366488d12e20d)(instance.options.react);
        (0, $91a4dd25d142fe34$export$a039134f2fc7e0)(instance);
    }
};


const $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
class $021c8539c0651064$export$ea171b67e3820290 {
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
    constructor(){
        this.usedNamespaces = {};
    }
}
const $021c8539c0651064$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        var _ForComponent_getInitialProps;
        var _ref;
        const componentsInitialProps = (_ref = await ((_ForComponent_getInitialProps = ForComponent.getInitialProps) === null || _ForComponent_getInitialProps === void 0 ? void 0 : _ForComponent_getInitialProps.call(ForComponent, ctx))) !== null && _ref !== void 0 ? _ref : {};
        const i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, componentsInitialProps, i18nInitialProps);
    };
const $021c8539c0651064$export$704200e5d0b9e8f = ()=>{
    var _i18n_reportNamespaces;
    const i18n = (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    var _i18n_reportNamespaces_getUsedNamespaces;
    const namespaces = (_i18n_reportNamespaces_getUsedNamespaces = (_i18n_reportNamespaces = i18n.reportNamespaces) === null || _i18n_reportNamespaces === void 0 ? void 0 : _i18n_reportNamespaces.getUsedNamespaces()) !== null && _i18n_reportNamespaces_getUsedNamespaces !== void 0 ? _i18n_reportNamespaces_getUsedNamespaces : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce(_param) {
    var { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape } = _param, additionalProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children",
        "count",
        "parent",
        "i18nKey",
        "context",
        "tOptions",
        "values",
        "defaults",
        "components",
        "ns",
        "i18n",
        "t",
        "shouldUnescape"
    ]);
    var _i18n_options;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    const t = tFromProps || (i18n === null || i18n === void 0 ? void 0 : i18n.t.bind(i18n));
    return (0, $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || (t === null || t === void 0 ? void 0 : t.ns) || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS),
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}





var $7fPBF = parcelRequire("7fPBF");


const $9c081519ec78392c$var$usePrevious = (value, ignore)=>{
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $9c081519ec78392c$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $9c081519ec78392c$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $7fPBF.useCallback)($9c081519ec78392c$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $9c081519ec78392c$export$9fc83ad70ead8663 = (ns, props = {})=>{
    var _i18n_options_react, _i18n_options, _i18n_reportNamespaces_addUsedNamespaces, _i18n_reportNamespaces;
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $021c8539c0651064$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $445d14444882807b$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $445d14444882807b$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $445d14444882807b$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if ((_i18n_options_react = i18n.options.react) === null || _i18n_options_react === void 0 ? void 0 : _i18n_options_react.wait) (0, $445d14444882807b$export$5b28268982f175ba)(i18n, 'DEPRECATED_OPTION', 'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)(), i18n.options.react, props);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS);
    namespaces = (0, $445d14444882807b$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    (_i18n_reportNamespaces_addUsedNamespaces = (_i18n_reportNamespaces = i18n.reportNamespaces).addUsedNamespaces) === null || _i18n_reportNamespaces_addUsedNamespaces === void 0 ? void 0 : _i18n_reportNamespaces_addUsedNamespaces.call(_i18n_reportNamespaces, namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $445d14444882807b$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $9c081519ec78392c$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$9c081519ec78392c$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $7fPBF.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $9c081519ec78392c$var$usePrevious(joinedNS);
    const isMounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $445d14444882807b$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n === null || i18n === void 0 ? void 0 : i18n.on(bindI18n, boundReset);
        if (bindI18nStore) i18n === null || i18n === void 0 ? void 0 : i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n && bindI18n) bindI18n === null || bindI18n === void 0 ? void 0 : bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $445d14444882807b$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};






var $7fPBF = parcelRequire("7fPBF");


const $1b9d18dce12af9e0$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation(_param) {
            var { forwardedRef: forwardedRef } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "forwardedRef"
            ]);
            const [t, i18n, ready] = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
                keyPrefix: options.keyPrefix
            }));
            const passDownProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7fPBF.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $7fPBF.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $7fPBF.forwardRef)(forwardRef) : I18nextWithTranslation;
    };




const $1123dfab2acde046$export$b63289fbda65eed1 = (_param)=>{
    var { ns: ns, children: children } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "ns",
        "children"
    ]);
    const [t, i18n, ready] = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $7fPBF = parcelRequire("7fPBF");

function $f40df753886fac13$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $7fPBF.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $7fPBF.createElement)((0, $021c8539c0651064$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

const $6dc6e4594d06aae3$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    var _i18n_options;
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $25e3a7ece768866e$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR(_param) {
            var { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "initialI18nStore",
                "initialLanguage"
            ]);
            (0, $6dc6e4594d06aae3$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $7fPBF.createElement)(WrappedComponent, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $021c8539c0651064$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2af286126fb112dc$export$324d90190a8b822a = ()=>'';
const $2af286126fb112dc$export$2da9be4cfdb689b1 = ()=>'';
const $2af286126fb112dc$export$98e628dec113755e = ()=>'';
const $2af286126fb112dc$export$2e6c959c16ff56b8 = ()=>'';
const $2af286126fb112dc$export$4e35d5c922a95490 = ()=>'';
const $2af286126fb112dc$export$720a3b9db04b7a0f = ()=>'';


const $4817740e8b777c73$export$d29cf4180255d829 = 'common';
const $4817740e8b777c73$export$41fc20bb625e8618 = [
    'common',
    'error',
    'tour',
    'usecases'
];
const $4817740e8b777c73$export$bc99aaabaf7b70a7 = {
    en: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($46e9372b918c82e5$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($7cbcf568110a7c9e$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($2db1ccc6f838feb6$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($f2a7e1c8dd4452db$exports)))
    },
    es: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($2e86342825d3cea0$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($f3b28415484efa10$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($b575a9a6bac1cad6$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($501d8d6df9954de7$exports)))
    },
    fr: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($8adc0445bd2a69d3$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($e182c8d7a6bdad6a$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($647dd474a4538087$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($7d9261ac2fd5b6b6$exports)))
    },
    it: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($155a07bb3e087efa$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($b25c88c429ae6c78$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($bd5ea8d28885a1b5$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($8e153465ce61e1ac$exports)))
    },
    de: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($3fc11051985d0b09$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($00d894b7ec9a312b$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($a20b4edf601225c9$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($9334e2246d11ce3e$exports)))
    },
    ja: {
        common: (0, (/*@__PURE__*/$parcel$interopDefault($a02703834f50dafc$exports))),
        error: (0, (/*@__PURE__*/$parcel$interopDefault($8e6856e76156b5da$exports))),
        tour: (0, (/*@__PURE__*/$parcel$interopDefault($0fb65a16e8d9a99f$exports))),
        usecases: (0, (/*@__PURE__*/$parcel$interopDefault($3a6703d76fc08995$exports)))
    }
};
// set to true to enable pseudo localization
const $4817740e8b777c73$var$pseudoEnabled = false; // process.env.ENABLED_ENVIRONMENT == "dev";
(0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039)// .use(
//     new Pseudo({
//         enabled: pseudoEnabled,
//         letterMultiplier: 1,
//     })
// )
.use((0, $09536692873e4879$export$ae7e14d40d89f296)).use((0, $fcb831e2a23edeea$export$2e2bcd8739ae039)).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).init({
    returnNull: false,
    defaultNS: $4817740e8b777c73$export$d29cf4180255d829,
    ns: $4817740e8b777c73$export$41fc20bb625e8618,
    resources: $4817740e8b777c73$export$bc99aaabaf7b70a7,
    interpolation: {
        escapeValue: false
    },
    debug: false,
    fallbackLng: (0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018),
    fallbackNS: $4817740e8b777c73$export$d29cf4180255d829,
    postProcess: [
        'pseudo'
    ],
    partialBundledLanguages: true,
    backend: {
        // HttpBackend options
        loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    detection: {
        order: [
            'localStorage',
            'navigator'
        ],
        lookupLocalStorage: 'displayLocale'
    },
    lowerCaseLng: true,
    load: 'languageOnly'
});
var $4817740e8b777c73$export$2e2bcd8739ae039 = (0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039);


var $f11ec298ebcca059$exports = {};
'use strict';
function $f11ec298ebcca059$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f11ec298ebcca059$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f11ec298ebcca059$var$checkDCE();

$f11ec298ebcca059$exports = (parcelRequire("a8X8z"));



/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/internal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 */ function $047add07c951d037$export$5201d50a34753d71(code, ...args) {
    const url = new URL('https://mui.com/x/production-error');
    url.searchParams.set('code', code.toString());
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `MUI X error #${code}; visit ${url} for the full message.`;
}



function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $7fPBF = parcelRequire("7fPBF");


function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;


function $0376810ac8b36fe3$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props);
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps[propName], output[propName]);
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, slotProps);
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $0376810ac8b36fe3$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.className, props === null || props === void 0 ? void 0 : props.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.style, props === null || props === void 0 ? void 0 : props.style);
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}


function $f4fc75fdffe6a8c3$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $0376810ac8b36fe3$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $7fPBF = parcelRequire("7fPBF");

'use client';
function $1ef5ad64b0a796d8$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1ef5ad64b0a796d8$var$useThemeWithoutDefault(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7));
    return !contextTheme || $1ef5ad64b0a796d8$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1ef5ad64b0a796d8$export$2e2bcd8739ae039 = $1ef5ad64b0a796d8$var$useThemeWithoutDefault;


'use client';
const $9da1e3d1169cfe7e$export$35e57303dbd8a66 = (0, $67f12c31e9ee9daa$export$2e2bcd8739ae039)();
function $9da1e3d1169cfe7e$var$useTheme(defaultTheme = $9da1e3d1169cfe7e$export$35e57303dbd8a66) {
    return (0, $1ef5ad64b0a796d8$export$2e2bcd8739ae039)(defaultTheme);
}
var $9da1e3d1169cfe7e$export$2e2bcd8739ae039 = $9da1e3d1169cfe7e$var$useTheme;


'use client';
function $fbaf90d7e3ed6403$export$2e2bcd8739ae039(params) {
    const { props: props, name: name, defaultTheme: defaultTheme, themeId: themeId } = params;
    let theme = (0, $9da1e3d1169cfe7e$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f4fc75fdffe6a8c3$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}



'use client';
const $7a5b46fd67f157c3$var$defaultTheme = (0, $1626f90a7ddd654a$export$2e2bcd8739ae039)();
var $7a5b46fd67f157c3$export$2e2bcd8739ae039 = $7a5b46fd67f157c3$var$defaultTheme;


var $3096faf8e377d232$export$2e2bcd8739ae039 = '$$material';


'use client';
function $3e8cc72401f6b742$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $fbaf90d7e3ed6403$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $7a5b46fd67f157c3$export$2e2bcd8739ae039,
        themeId: (0, $3096faf8e377d232$export$2e2bcd8739ae039)
    });
}



'use client';
const $9a7f2bc06270517e$var$_excluded = [
    "localeText"
];
const $9a7f2bc06270517e$export$41298298dbe382b = /*#__PURE__*/ $7fPBF.createContext(null);
const $9a7f2bc06270517e$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(inProps, $9a7f2bc06270517e$var$_excluded);
    var _React_useContext;
    const { adapter: parentAdapter, localeText: parentLocaleText } = (_React_useContext = $7fPBF.useContext($9a7f2bc06270517e$export$41298298dbe382b)) !== null && _React_useContext !== void 0 ? _React_useContext : {
        adapter: undefined,
        localeText: undefined
    };
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const adapter = $7fPBF.useMemo(()=>{
        if (!DateAdapter) {
            if (parentAdapter) return parentAdapter;
            return null;
        }
        const dateAdapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!dateAdapter.isMUIAdapter) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(143));
        return dateAdapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentAdapter
    ]);
    const defaultDates = $7fPBF.useMemo(()=>{
        if (!adapter) return null;
        return {
            minDate: adapter.date('1900-01-01T00:00:00.000'),
            maxDate: adapter.date('2099-12-31T00:00:00.000')
        };
    }, [
        adapter
    ]);
    const contextValue = $7fPBF.useMemo(()=>{
        return {
            adapter: adapter,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        adapter,
        localeText
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9a7f2bc06270517e$export$41298298dbe382b.Provider, {
        value: contextValue,
        children: children
    });
};





var $615652efb7481f32$exports = {};
!function(t, e) {
    $615652efb7481f32$exports = e();
}($615652efb7481f32$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $623ecd0fd8e4aed5$exports = {};
!function(e, t) {
    $623ecd0fd8e4aed5$exports = t();
}($623ecd0fd8e4aed5$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $f31b2d9172e2fa32$exports = {};
!function(e, t) {
    $f31b2d9172e2fa32$exports = t();
}($f31b2d9172e2fa32$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $7c31004894e2ce7c$exports = {};
!function(e, t) {
    $7c31004894e2ce7c$exports = t();
}($7c31004894e2ce7c$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $6a47e7d083ad10fd$exports = {};
!function(e, i) {
    $6a47e7d083ad10fd$exports = i();
}($6a47e7d083ad10fd$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $af0b8cdb79055738$exports = {};
!function(e, t) {
    $af0b8cdb79055738$exports = t();
}($af0b8cdb79055738$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7c31004894e2ce7c$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($623ecd0fd8e4aed5$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($6a47e7d083ad10fd$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($af0b8cdb79055738$exports))));
const $90896a2fcfe0b000$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $90896a2fcfe0b000$var$defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    dayOfMonthFull: 'Do',
    weekday: 'dddd',
    weekdayShort: 'dd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
function $90896a2fcfe0b000$var$throwMissingUTCPluginError() {
    throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(138));
}
function $90896a2fcfe0b000$var$throwMissingTimezonePluginError() {
    throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(139));
}
class $90896a2fcfe0b000$export$33545c6a80bae043 {
    getDayOfWeek(value) {
        return value.day() + 1;
    }
    constructor({ locale: locale, formats: formats } = {}){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isMUIAdapter", true);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isTimezoneCompatible", true);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "lib", 'dayjs');
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "escapedCharacters", {
            start: '[',
            end: ']'
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "formatTokenMap", $90896a2fcfe0b000$var$formatTokenMap);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setLocaleToValue", (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "hasUTCPlugin", ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc !== 'undefined');
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "hasTimezonePlugin", ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz !== 'undefined');
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isSame", (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        });
        /**
   * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "cleanTimezone", (timezone)=>{
            switch(timezone){
                case 'default':
                    return undefined;
                case 'system':
                    return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz.guess();
                default:
                    return timezone;
            }
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "createSystemDate", (value)=>{
            return this.setLocaleToValue((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "createUTCDate", (value)=>{
            /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) $90896a2fcfe0b000$var$throwMissingUTCPluginError();
            return this.setLocaleToValue((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(value));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "createTZDate", (value, timezone)=>{
            /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) $90896a2fcfe0b000$var$throwMissingUTCPluginError();
            /* v8 ignore next 3 */ if (!this.hasTimezonePlugin()) $90896a2fcfe0b000$var$throwMissingTimezonePluginError();
            const keepLocalTime = value !== undefined && !value.endsWith('Z');
            return this.setLocaleToValue((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value).tz(this.cleanTimezone(timezone), keepLocalTime));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getLocaleFormats", ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).Ls;
            const locale = this.locale || 'en';
            let localeObject = locales[locale];
            if (localeObject === undefined) /* v8 ignore stop */ localeObject = locales.en;
            return localeObject.formats;
        });
        /**
   * If the new day does not have the same offset as the old one (when switching to summer day time for example),
   * Then dayjs will not automatically adjust the offset (moment does).
   * We have to parse again the value to make sure the `fixOffset` method is applied.
   * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "adjustOffset", (value)=>{
            if (!this.hasTimezonePlugin()) return value;
            const timezone = this.getTimezone(value);
            if (timezone !== 'UTC') {
                const fixedValue = value.tz(this.cleanTimezone(timezone), true);
                var _value_$offset;
                // TODO: Simplify the case when we raise the `dayjs` peer dep to 1.11.12 (https://github.com/iamkun/dayjs/releases/tag/v1.11.12)
                /* v8 ignore next 3 */ // @ts-ignore
                if (fixedValue.$offset === ((_value_$offset = value.$offset) !== null && _value_$offset !== void 0 ? _value_$offset : 0)) return value;
                // Change only what is needed to avoid creating a new object with unwanted data
                // Especially important when used in an environment where utc or timezone dates are used only in some places
                // Reference: https://github.com/mui/mui-x/issues/13290
                // @ts-ignore
                value.$offset = fixedValue.$offset;
            }
            return value;
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "date", (value, timezone = 'default')=>{
            if (value === null) return null;
            if (timezone === 'UTC') return this.createUTCDate(value);
            if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) return this.createSystemDate(value);
            return this.createTZDate(value, timezone);
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getInvalidDate", ()=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(new Date('Invalid date')));
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getTimezone", (value)=>{
            if (this.hasTimezonePlugin()) {
                var _value_$x;
                // @ts-ignore
                const zone = (_value_$x = value.$x) === null || _value_$x === void 0 ? void 0 : _value_$x.$timezone;
                if (zone) return zone;
            }
            if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
            return 'system';
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setTimezone", (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === 'UTC') {
                /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) $90896a2fcfe0b000$var$throwMissingUTCPluginError();
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === 'system') return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === 'default') return value;
                /* v8 ignore next */ $90896a2fcfe0b000$var$throwMissingTimezonePluginError();
            }
            return this.setLocaleToValue((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).tz(value, this.cleanTimezone(timezone)));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "toJsDate", (value)=>{
            return value.toDate();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "parse", (value, format)=>{
            if (value === '') return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value, format, this.locale, true);
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getCurrentLocaleCode", ()=>{
            return this.locale || 'en';
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "is12HourCycleInCurrentLocale", ()=>{
            /* v8 ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "expandFormat", (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isValid", (value)=>{
            if (value == null) return false;
            return value.isValid();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "format", (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "formatByString", (value, formatString)=>{
            return this.setLocaleToValue(value).format(formatString);
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "formatNumber", (numberToFormat)=>{
            return numberToFormat;
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isEqual", (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return value.toDate().getTime() === comparing.toDate().getTime();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isSameYear", (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY');
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isSameMonth", (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM');
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isSameDay", (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM-DD');
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isSameHour", (value, comparing)=>{
            return value.isSame(comparing, 'hour');
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isAfter", (value, comparing)=>{
            return value > comparing;
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isAfterYear", (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isAfterDay", (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isBefore", (value, comparing)=>{
            return value < comparing;
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isBeforeYear", (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isBeforeDay", (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isWithinRange", (value, [start, end])=>{
            return value >= start && value <= end;
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "startOfYear", (value)=>{
            return this.adjustOffset(value.startOf('year'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "startOfMonth", (value)=>{
            return this.adjustOffset(value.startOf('month'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "startOfWeek", (value)=>{
            return this.adjustOffset(this.setLocaleToValue(value).startOf('week'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "startOfDay", (value)=>{
            return this.adjustOffset(value.startOf('day'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "endOfYear", (value)=>{
            return this.adjustOffset(value.endOf('year'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "endOfMonth", (value)=>{
            return this.adjustOffset(value.endOf('month'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "endOfWeek", (value)=>{
            return this.adjustOffset(this.setLocaleToValue(value).endOf('week'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "endOfDay", (value)=>{
            return this.adjustOffset(value.endOf('day'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addYears", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'year'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addMonths", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'month'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addWeeks", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'week'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addDays", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'day'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addHours", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'hour'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addMinutes", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'minute'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "addSeconds", (value, amount)=>{
            return this.adjustOffset(value.add(amount, 'second'));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getYear", (value)=>{
            return value.year();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getMonth", (value)=>{
            return value.month();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getDate", (value)=>{
            return value.date();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getHours", (value)=>{
            return value.hour();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getMinutes", (value)=>{
            return value.minute();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getSeconds", (value)=>{
            return value.second();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getMilliseconds", (value)=>{
            return value.millisecond();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setYear", (value, year)=>{
            return this.adjustOffset(value.set('year', year));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setMonth", (value, month)=>{
            return this.adjustOffset(value.set('month', month));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setDate", (value, date)=>{
            return this.adjustOffset(value.set('date', date));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setHours", (value, hours)=>{
            return this.adjustOffset(value.set('hour', hours));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setMinutes", (value, minutes)=>{
            return this.adjustOffset(value.set('minute', minutes));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setSeconds", (value, seconds)=>{
            return this.adjustOffset(value.set('second', seconds));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "setMilliseconds", (value, milliseconds)=>{
            return this.adjustOffset(value.set('millisecond', milliseconds));
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getDaysInMonth", (value)=>{
            return value.daysInMonth();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getWeekArray", (value)=>{
            const start = this.startOfWeek(this.startOfMonth(value));
            const end = this.endOfWeek(this.endOfMonth(value));
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getWeekNumber", (value)=>{
            return value.week();
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "getYearRange", ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        });
        this.locale = locale;
        this.formats = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $90896a2fcfe0b000$var$defaultFormats, formats);
        // Moved plugins to the constructor to allow for users to use options on the library
        // for reference: https://github.com/mui/mui-x/pull/11151
        (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($f31b2d9172e2fa32$exports))));
    }
}









var $7fPBF = parcelRequire("7fPBF");

// eslint-disable-next-line no-undef
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $2078ce513e00dfd7$var$isDevelopment = false;
var $2078ce513e00dfd7$var$testOmitPropsOnStringTag = (0, $742aea85e4e67b26$export$2e2bcd8739ae039);
var $2078ce513e00dfd7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $2078ce513e00dfd7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2078ce513e00dfd7$var$testOmitPropsOnStringTag : $2078ce513e00dfd7$var$testOmitPropsOnComponent;
};
var $2078ce513e00dfd7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2078ce513e00dfd7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $48e4b1fcfcd646c1$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $b2729db54ba7ee9b$export$db21c7ffa21794e7)(function() {
        return (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $2078ce513e00dfd7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2078ce513e00dfd7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2078ce513e00dfd7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $d62c6f18f523e962$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $d62c6f18f523e962$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2078ce513e00dfd7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($2078ce513e00dfd7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $2078ce513e00dfd7$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $2078ce513e00dfd7$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};







parcelRequire("7fPBF");

var $8de346382d86c747$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $8de346382d86c747$export$2e2bcd8739ae039 = (0, $2078ce513e00dfd7$export$2e2bcd8739ae039).bind(null);
$8de346382d86c747$var$tags.forEach(function(tagName) {
    $8de346382d86c747$export$2e2bcd8739ae039[tagName] = $8de346382d86c747$export$2e2bcd8739ae039(tagName);
});



let $19e0bc52fddd02b4$var$_ = (t)=>t, $19e0bc52fddd02b4$var$t, $19e0bc52fddd02b4$var$t1, $19e0bc52fddd02b4$var$t2, $19e0bc52fddd02b4$var$t3, $19e0bc52fddd02b4$var$t4, $19e0bc52fddd02b4$var$t5, $19e0bc52fddd02b4$var$t6;
const $19e0bc52fddd02b4$var$DefaultStyles = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($19e0bc52fddd02b4$var$t || ($19e0bc52fddd02b4$var$t = $19e0bc52fddd02b4$var$_`
    button,
    a {
        &:focus {
            outline: ${0} auto 2px;
        }
    }
    a {
        text-decoration: none;
    }
    * {
        font-family:
            'Archivo',
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            Ubuntu,
            'Helvetica Neue',
            Oxygen,
            Cantarell,
            sans-serif;
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).accent);
const $19e0bc52fddd02b4$export$87f1b08a59e6d1dd = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($19e0bc52fddd02b4$var$t1 || ($19e0bc52fddd02b4$var$t1 = $19e0bc52fddd02b4$var$_`
    &:focus-visible {
        outline: 2px dashed ${0} !important;
        outline-offset: 2px;
        z-index: 100;
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary);
const $19e0bc52fddd02b4$export$15b02e474f045d64 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($19e0bc52fddd02b4$var$t2 || ($19e0bc52fddd02b4$var$t2 = $19e0bc52fddd02b4$var$_`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    padding: 0;
    margin: 0;
`));
const $19e0bc52fddd02b4$var$fadeIn = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($19e0bc52fddd02b4$var$t3 || ($19e0bc52fddd02b4$var$t3 = $19e0bc52fddd02b4$var$_`
    from {
        opacity: 0;

    }
    to {
        opacity: 1;

    }
`));
const $19e0bc52fddd02b4$export$db407487374f02c9 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($19e0bc52fddd02b4$var$t4 || ($19e0bc52fddd02b4$var$t4 = $19e0bc52fddd02b4$var$_`
    animation: ${0} 0.5s ease-in-out;
`), $19e0bc52fddd02b4$var$fadeIn);
const $19e0bc52fddd02b4$export$29c8ed22df400735 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($19e0bc52fddd02b4$var$t5 || ($19e0bc52fddd02b4$var$t5 = $19e0bc52fddd02b4$var$_`
    animation: ${0} 0.1s ease-in-out;
`), $19e0bc52fddd02b4$var$fadeIn);
const $19e0bc52fddd02b4$export$ed89a9014ca4c6b4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($19e0bc52fddd02b4$var$t6 || ($19e0bc52fddd02b4$var$t6 = $19e0bc52fddd02b4$var$_`
    ${0};
`), $19e0bc52fddd02b4$export$db407487374f02c9);
var $19e0bc52fddd02b4$export$2e2bcd8739ae039 = $19e0bc52fddd02b4$var$DefaultStyles;










var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $05cea9a86bf43ec8$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $05cea9a86bf43ec8$export$2e2bcd8739ae039 = $05cea9a86bf43ec8$var$ThemeContext;



var $7fPBF = parcelRequire("7fPBF");

'use client';
function $84e9678b75f3bd5a$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $05cea9a86bf43ec8$export$2e2bcd8739ae039));
    return theme;
}


const $a2946eb48fcecaa6$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $a2946eb48fcecaa6$export$2e2bcd8739ae039 = $a2946eb48fcecaa6$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



// To support composition of theme.
function $46ba1d3dbca940af$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $46ba1d3dbca940af$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $84e9678b75f3bd5a$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, localTheme) : $46ba1d3dbca940af$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $a2946eb48fcecaa6$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $05cea9a86bf43ec8$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $46ba1d3dbca940af$export$2e2bcd8739ae039 = $46ba1d3dbca940af$var$ThemeProvider;








var $7fPBF = parcelRequire("7fPBF");


'use client';
const $e4363aeb0e09b377$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $e4363aeb0e09b377$var$RtlProvider(_param) {
    var { value: value } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "value"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e4363aeb0e09b377$var$RtlContext.Provider, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        value: value !== null && value !== void 0 ? value : true
    }, props));
}
const $e4363aeb0e09b377$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($e4363aeb0e09b377$var$RtlContext);
    return value !== null && value !== void 0 ? value : false;
};
var $e4363aeb0e09b377$export$2e2bcd8739ae039 = $e4363aeb0e09b377$var$RtlProvider;



var $7fPBF = parcelRequire("7fPBF");



'use client';
const $67ed59d14b557650$var$PropsContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $67ed59d14b557650$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67ed59d14b557650$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $67ed59d14b557650$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $0376810ac8b36fe3$export$2e2bcd8739ae039)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $0376810ac8b36fe3$export$2e2bcd8739ae039)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $67ed59d14b557650$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7fPBF.useContext($67ed59d14b557650$var$PropsContext);
    return $67ed59d14b557650$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $67ed59d14b557650$export$2e2bcd8739ae039 = $67ed59d14b557650$var$DefaultPropsProvider;



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $9a1cc0725facde24$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $9a1cc0725facde24$export$2e2bcd8739ae039 = $9a1cc0725facde24$var$useEnhancedEffect;




var $7fPBF = parcelRequire("7fPBF");
'use client';
let $f017d1fe847d8509$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $f017d1fe847d8509$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $f017d1fe847d8509$var$globalId += 1;
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setDefaultId(`mui-${$f017d1fe847d8509$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $f017d1fe847d8509$var$safeReact = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fPBF);
const $f017d1fe847d8509$var$maybeReactUseId = $f017d1fe847d8509$var$safeReact.useId;
function $f017d1fe847d8509$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($f017d1fe847d8509$var$maybeReactUseId !== undefined) {
        const reactId = $f017d1fe847d8509$var$maybeReactUseId();
        return idOverride !== null && idOverride !== void 0 ? idOverride : reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $f017d1fe847d8509$var$useGlobalId(idOverride);
}






'use client';
function $12af0d50914c2dfa$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $12af0d50914c2dfa$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($12af0d50914c2dfa$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84f3fdd51733d70b$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}

/**
 * @mui/styled-engine v9.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 




'use client';
// Re-export the public type surface of `@emotion/styled`. Explicit names rather
// than `export type *`: an `export *` (even type-only) is disallowed by the
// `'use client'` Next.js lint rule. Names locally redeclared below intentionally
// shadow Emotion's and are not re-exported here.
function $4840e3b66caa6fde$var$styled(tag, options) {
    // Emotion's `styled` overloads each expect a specific tag/component shape;
    // none accept the broadened `React.ElementType` union, so cast the passthrough.
    const stylesFactory = (0, $8de346382d86c747$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
var $4840e3b66caa6fde$export$2e2bcd8739ae039 = $4840e3b66caa6fde$var$styled;
function $4840e3b66caa6fde$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $4840e3b66caa6fde$var$wrapper = [];
function $4840e3b66caa6fde$export$13a2d3ef13012b32(styles) {
    $4840e3b66caa6fde$var$wrapper[0] = styles;
    return (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)($4840e3b66caa6fde$var$wrapper);
}
 // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // Omit variants as a key, because we have a special handling for it
 /** Same as StyledOptions but shouldForwardProp must be a type guard */  /**
 * @typeparam ComponentProps  Props which will be included when withComponent is called
 * @typeparam SpecificComponentProps  Props which will *not* be included when withComponent is called
 */ 



'use client';
function $d77204311b13899f$var$wrapGlobalLayer(styles) {
    const serialized = (0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $d77204311b13899f$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $9da1e3d1169cfe7e$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $d77204311b13899f$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $d77204311b13899f$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $d77204311b13899f$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12af0d50914c2dfa$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $d77204311b13899f$export$2e2bcd8739ae039 = $d77204311b13899f$var$GlobalStyles;




function $05278c69e732d572$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $1ef5ad64b0a796d8$export$2e2bcd8739ae039)();
    const id = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        var _head_querySelector;
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild_hasAttribute;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && ((_firstChild_hasAttribute = firstChild.hasAttribute) === null || _firstChild_hasAttribute === void 0 ? void 0 : _firstChild_hasAttribute.call(firstChild, 'data-mui-layer-order')) && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else (_head_querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) === null || _head_querySelector === void 0 ? void 0 : _head_querySelector.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d77204311b13899f$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



'use client';
const $8c6e379595036497$var$EMPTY_THEME = {};
function $8c6e379595036497$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, upperTheme), {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, upperTheme), {
            [themeId]: localTheme
        }) : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $8c6e379595036497$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $1ef5ad64b0a796d8$export$2e2bcd8739ae039)($8c6e379595036497$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $84e9678b75f3bd5a$export$2e2bcd8739ae039)() || $8c6e379595036497$var$EMPTY_THEME;
    const engineTheme = $8c6e379595036497$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $8c6e379595036497$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $05278c69e732d572$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46ba1d3dbca940af$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d62c6f18f523e962$export$971d5caa766a69d7).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4363aeb0e09b377$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $67ed59d14b557650$export$2e2bcd8739ae039), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $8c6e379595036497$export$2e2bcd8739ae039 = $8c6e379595036497$var$ThemeProvider;




'use client';
function $ee859591e81b9ff1$export$2e2bcd8739ae039(_param) {
    var { theme: themeInput } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "theme"
    ]);
    const scopedTheme = (0, $3096faf8e377d232$export$2e2bcd8739ae039) in themeInput ? themeInput[0, $3096faf8e377d232$export$2e2bcd8739ae039] : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c6e379595036497$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        themeId: scopedTheme ? (0, $3096faf8e377d232$export$2e2bcd8739ae039) : undefined,
        theme: scopedTheme || themeInput
    }));
}








var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");

'use client';
const $776c616707013838$export$ff0fa3047d11164c = 'mode';
const $776c616707013838$export$665054ea9d94dab9 = 'color-scheme';
const $776c616707013838$export$14ebe5b26ee7fb38 = 'data-color-scheme';
// React 17 has no `useSyncExternalStore`; spread into a plain object so reading the
// missing property returns `undefined` instead of throwing under strict ESM. See #41190 (comment).
const $776c616707013838$var$safeReact = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fPBF);
const $776c616707013838$var$maybeReactUseSyncExternalStore = $776c616707013838$var$safeReact.useSyncExternalStore;
const $776c616707013838$var$subscribe = ()=>()=>{};
/**
 * `true` during the server render and the matching hydration render, `false`
 * on every client render afterwards. React warns when a `<script>` is
 * created during a client render (such scripts never execute), so the inline
 * script is only emitted on the server pass and dropped after hydration — the
 * attribute it already set on the document persists. React <18 has no
 * `useSyncExternalStore` and no such warning, so the script is always emitted.
 */ function $776c616707013838$var$useIsServerRender() {
    if ($776c616707013838$var$maybeReactUseSyncExternalStore === undefined) return true;
    return $776c616707013838$var$maybeReactUseSyncExternalStore($776c616707013838$var$subscribe, ()=>false, ()=>true);
}
function $776c616707013838$export$5241b41d827c24d9(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $776c616707013838$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $776c616707013838$export$665054ea9d94dab9, attribute: initialAttribute = $776c616707013838$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else if (attribute !== '.%s') setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}
function $776c616707013838$export$2e2bcd8739ae039(options) {
    const isServerRender = $776c616707013838$var$useIsServerRender();
    if (!isServerRender) return null;
    return $776c616707013838$export$5241b41d827c24d9(options);
}





var $7fPBF = parcelRequire("7fPBF");

function $84ad506605d91a9e$var$noop() {}
const $84ad506605d91a9e$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch (e) {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch (e) {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $84ad506605d91a9e$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $84ad506605d91a9e$export$2e2bcd8739ae039 = $84ad506605d91a9e$var$localStorageManager;


'use client';
function $a8ebe4b6ccf20994$var$noop() {}
function $a8ebe4b6ccf20994$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $a8ebe4b6ccf20994$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $a8ebe4b6ccf20994$export$3caa7590cc1987bd(state) {
    return $a8ebe4b6ccf20994$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $a8ebe4b6ccf20994$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $776c616707013838$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $776c616707013838$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $84ad506605d91a9e$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $7fPBF.useMemo(()=>storageManager === null || storageManager === void 0 ? void 0 : storageManager({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $7fPBF.useMemo(()=>storageManager === null || storageManager === void 0 ? void 0 : storageManager({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $7fPBF.useMemo(()=>storageManager === null || storageManager === void 0 ? void 0 : storageManager({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const initialMode = (modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.get(defaultMode)) || defaultMode;
        const lightColorScheme = (lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.get(defaultLightColorScheme)) || defaultLightColorScheme;
        const darkColorScheme = (darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.get(defaultDarkColorScheme)) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $a8ebe4b6ccf20994$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $7fPBF.useState(noSsr || !isMultiSchemes);
    $7fPBF.useEffect(()=>{
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $a8ebe4b6ccf20994$export$3caa7590cc1987bd(state);
    const setMode = $7fPBF.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode !== null && mode !== void 0 ? mode : defaultMode;
            modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.set(newMode);
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentState), {
                mode: newMode,
                systemMode: $a8ebe4b6ccf20994$export$ab3d447356dfa3e5(newMode)
            });
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $7fPBF.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.set(defaultLightColorScheme);
            darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.set(defaultDarkColorScheme);
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentState), {
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            });
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentState);
                $a8ebe4b6ccf20994$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentState);
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $7fPBF.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = (event === null || event === void 0 ? void 0 : event.matches) ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentState), {
                systemMode: systemMode
            });
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $7fPBF.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $7fPBF.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $7fPBF.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = (modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            })) || $a8ebe4b6ccf20994$var$noop;
            const unsubscribeLight = (lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            })) || $a8ebe4b6ccf20994$var$noop;
            const unsubscribeDark = (darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            })) || $a8ebe4b6ccf20994$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    });
}



'use client';
const $08eca1fcd7a6d5bc$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $08eca1fcd7a6d5bc$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $776c616707013838$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $776c616707013838$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
    const useColorScheme = ()=>$7fPBF.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        var _colorSchemes_restThemeProp_defaultColorScheme_palette, _colorSchemes_restThemeProp_defaultColorScheme, _restThemeProp_palette, _memoTheme_generateStyleSheets;
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $7fPBF.useRef(false);
        const upperTheme = (0, $84e9678b75f3bd5a$export$2e2bcd8739ae039)();
        const ctx = $7fPBF.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $7fPBF.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $7fPBF.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : ((_colorSchemes_restThemeProp_defaultColorScheme = colorSchemes[restThemeProp.defaultColorScheme]) === null || _colorSchemes_restThemeProp_defaultColorScheme === void 0 ? void 0 : (_colorSchemes_restThemeProp_defaultColorScheme_palette = _colorSchemes_restThemeProp_defaultColorScheme.palette) === null || _colorSchemes_restThemeProp_defaultColorScheme_palette === void 0 ? void 0 : _colorSchemes_restThemeProp_defaultColorScheme_palette.mode) || ((_restThemeProp_palette = restThemeProp.palette) === null || _restThemeProp_palette === void 0 ? void 0 : _restThemeProp_palette.mode);
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $a8ebe4b6ccf20994$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $7fPBF.useMemo(()=>{
            var _restThemeProp_generateThemeVars;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = ((_restThemeProp_generateThemeVars = restThemeProp.generateThemeVars) === null || _restThemeProp_generateThemeVars === void 0 ? void 0 : _restThemeProp_generateThemeVars.call(restThemeProp)) || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restThemeProp), {
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            });
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme[schemeKey], scheme[schemeKey]);
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $7fPBF.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($08eca1fcd7a6d5bc$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $7fPBF.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $7fPBF.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && (upperTheme === null || upperTheme === void 0 ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c6e379595036497$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12af0d50914c2dfa$export$2e2bcd8739ae039), {
                    styles: ((_memoTheme_generateStyleSheets = memoTheme.generateStyleSheets) === null || _memoTheme_generateStyleSheets === void 0 ? void 0 : _memoTheme_generateStyleSheets.call(memoTheme)) || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $776c616707013838$export$5241b41d827c24d9)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey
        }, params));
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}








const $ed332032b6b2f0de$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $ed332032b6b2f0de$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $ed332032b6b2f0de$export$f84bd70098573c5c.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $ed332032b6b2f0de$export$f84bd70098573c5c.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $ed332032b6b2f0de$export$f84bd70098573c5c.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $ed332032b6b2f0de$export$f84bd70098573c5c.colorSchemeStorageKey, attribute: initialAttribute = $ed332032b6b2f0de$export$f84bd70098573c5c.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $776c616707013838$export$2e2bcd8739ae039), {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $ed332032b6b2f0de$export$2e2bcd8739ae039 = $ed332032b6b2f0de$var$InitColorSchemeScript;



'use client';
const { CssVarsProvider: $9eaa789a0fe6a8c7$var$InternalCssVarsProvider, useColorScheme: $9eaa789a0fe6a8c7$export$6343629ee1b29116, getInitColorSchemeScript: $9eaa789a0fe6a8c7$var$deprecatedGetInitColorSchemeScript } = (0, $08eca1fcd7a6d5bc$export$2e2bcd8739ae039)({
    themeId: (0, $3096faf8e377d232$export$2e2bcd8739ae039),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $1626f90a7ddd654a$export$2e2bcd8739ae039)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $ed332032b6b2f0de$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $ed332032b6b2f0de$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $ed332032b6b2f0de$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $ed332032b6b2f0de$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme), {
            typography: (0, $321a94afd28e6be3$export$2e2bcd8739ae039)(theme.palette, theme.typography)
        });
        newTheme.unstable_sx = function sx(props) {
            return (0, $06ba45f570780ba8$export$2e2bcd8739ae039)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $9eaa789a0fe6a8c7$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $9eaa789a0fe6a8c7$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9eaa789a0fe6a8c7$var$InternalCssVarsProvider, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
}
let $9eaa789a0fe6a8c7$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $9eaa789a0fe6a8c7$export$f9a57b4a2abf8ed = (params)=>{
    if (!$9eaa789a0fe6a8c7$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $9eaa789a0fe6a8c7$var$warnedInitScriptOnce = true;
    }
    return $9eaa789a0fe6a8c7$var$deprecatedGetInitColorSchemeScript(params);
};
const $9eaa789a0fe6a8c7$export$50ec01b133c61652 = $9eaa789a0fe6a8c7$var$InternalCssVarsProvider;




'use client';
function $5faddabad8e8da3c$export$2e2bcd8739ae039(_param) {
    var { theme: theme } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "theme"
    ]);
    const noVarsTheme = $7fPBF.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $3096faf8e377d232$export$2e2bcd8739ae039) in theme ? theme[0, $3096faf8e377d232$export$2e2bcd8739ae039] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme), {
                vars: null
            });
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee859591e81b9ff1$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        theme: noVarsTheme
    }, props));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9eaa789a0fe6a8c7$export$50ec01b133c61652), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        theme: theme
    }, props));
}



var $7fPBF = parcelRequire("7fPBF");



'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $b731c43f7abf86cf$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $b731c43f7abf86cf$var$safeReact = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fPBF);
const $b731c43f7abf86cf$var$maybeReactUseSyncExternalStore = $b731c43f7abf86cf$var$safeReact.useSyncExternalStore;
function $b731c43f7abf86cf$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $b731c43f7abf86cf$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $b731c43f7abf86cf$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $1ef5ad64b0a796d8$export$2e2bcd8739ae039)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const fallbackMatchMedia = supportMatchMedia ? window.matchMedia : null;
        const { defaultMatches: defaultMatches = false, matchMedia: customMatchMedia, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $f4fc75fdffe6a8c3$export$2e2bcd8739ae039)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        const matchMedia = $7fPBF.useMemo(()=>{
            if (customMatchMedia !== undefined) return customMatchMedia;
            if (fallbackMatchMedia === null) return null;
            return fallbackMatchMedia.bind(window);
        }, [
            customMatchMedia,
            fallbackMatchMedia
        ]);
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $b731c43f7abf86cf$var$maybeReactUseSyncExternalStore !== undefined ? $b731c43f7abf86cf$var$useMediaQueryNew : $b731c43f7abf86cf$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $b731c43f7abf86cf$var$useMediaQuery = $b731c43f7abf86cf$export$96d7927a982220b5();
var $b731c43f7abf86cf$export$2e2bcd8739ae039 = $b731c43f7abf86cf$var$useMediaQuery;



const $ec3395cd7fe43d7a$var$useMediaQuery = (0, $b731c43f7abf86cf$export$96d7927a982220b5)({
    themeId: (0, $3096faf8e377d232$export$2e2bcd8739ae039)
});
var $ec3395cd7fe43d7a$export$2e2bcd8739ae039 = $ec3395cd7fe43d7a$var$useMediaQuery;



var $7fPBF = parcelRequire("7fPBF");
const $1c78e537a9e9e9b0$export$a49f528ae1a4d0ed = (0, $7fPBF.createContext)({
    color: "currentColor",
    size: "1em",
    weight: "regular",
    mirrored: !1
});



const $640cd3167d5819eb$export$ce2efe5baec76fba = {
    mode: 'light',
    panelPosition: 'right',
    panelOrientation: 'vertical',
    spacing: 'comfortable',
    scaleSize: 16,
    panelButtonScaleSize: 18,
    color: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        card: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2,
        cardHover: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light,
        accentCard: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        textBody: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
        textBodyLight: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_dark,
        error: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_dark,
        neutral: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
        link: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        accent: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        tint: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        danger: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
        warning: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
        secondary: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        sidebarDivider: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
        indicator: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        waveVoice: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_dark,
        waveDictation: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
        remoteDevice: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_dark,
        remoteDeviceText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        licenseHighlight: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_dark,
        control: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        create: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
        automate: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_dark
    },
    input: {
        text: '#1A1C1E',
        placeholder: '#54606F',
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_primary
    },
    dialog: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
        warn: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success_light,
        remote: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
    },
    tag: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
    },
    banner: {
        default: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverBackground: `#fdf3db`
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            buttonText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            linkHoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light
        },
        error: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).error}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).error}15`
        },
        warning: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`
        },
        success: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`
        },
        info: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`
        }
    },
    button: {
        primary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border
        },
        secondary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2
        },
        simple: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            border: 'none',
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        },
        quick: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        disabled: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1
        },
        // Round shell/panel control: card surface, accent icon (mirrors color.card/accent/border/cardHover).
        footer: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_2,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light
        },
        // Accent-filled primary action (e.g. send).
        send: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary
        },
        // Destructive action: error-red, fills red with white content on hover.
        danger: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            background: 'transparent',
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).error,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
        },
        warn: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            hoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`
        }
    }
};
const $640cd3167d5819eb$export$86c8e15b70e05cb1 = {
    mode: 'dark',
    panelPosition: 'right',
    panelOrientation: 'vertical',
    spacing: 'comfortable',
    scaleSize: 16,
    panelButtonScaleSize: 18,
    color: {
        // background: color.primary_intense,
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
        card: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
        cardHover: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light,
        accentCard: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
        textBody: (0, $8951886a6b49e92a$export$35e9368ef982300f).diminished_dark,
        textBodyLight: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        error: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light,
        neutral: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral,
        link: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        accent: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
        tint: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
        danger: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
        warning: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success_light,
        secondary: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        sidebarDivider: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light + '20',
        indicator: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
        waveVoice: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
        waveDictation: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        remoteDevice: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        remoteDeviceText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
        licenseHighlight: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        control: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        create: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        automate: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_light
    },
    input: {
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
        placeholder: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_dark,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_dark,
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_dark
    },
    dialog: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
        warn: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
        success: (0, $8951886a6b49e92a$export$35e9368ef982300f).success_light,
        remote: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
        border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
    },
    tag: {
        background: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
        text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
    },
    banner: {
        default: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverBackground: `#fdf3db`
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
            body: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border,
            buttonText: '#20214d',
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).secondary}70`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            linkHoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium
        },
        error: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            linkHoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            buttonText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark
        },
        warning: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}25`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`,
            buttonText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        success: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).success,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}15`
        },
        info: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_card_border,
            buttonText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
            background: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent}15`,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            linkText: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            linkBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`,
            linkHoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1,
            linkHoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_accent_1}15`
        }
    },
    button: {
        primary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverBackground: 'transparent'
        },
        secondary: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light
        },
        accent: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
        },
        simple: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
            background: 'transparent',
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).border,
            border: 'none',
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark
        },
        quick: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        disabled: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_dark,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_medium,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).neutral_dark
        },
        // Round shell/panel control: card surface, accent icon (mirrors color.card/accent/border/cardHover).
        footer: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light
        },
        // Accent-filled primary action (e.g. send).
        send: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_dark,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light
        },
        // Destructive action: error-red, fills red with white content on hover.
        danger: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light,
            background: 'transparent',
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).dark_text,
            hoverBackground: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light
        },
        warn: {
            text: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            background: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            icon: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            border: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2,
            hoverText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            hoverBackground: `${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2}15`
        }
    }
};






const $6efd2a8884b3d0c5$var$darkInputColor = (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_medium;
const $6efd2a8884b3d0c5$var$commonSettings = {
    typography: {
        fontFamily: 'Archivo, sans-serif'
    },
    components: {
        // add fontWeight 400 to all input labels and switch labels for better readability
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 400
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    fontWeight: 400
                }
            }
        },
        /**
         * Helper text is a footnote to its field, not a line of body copy: small, tight, and pulled up
         * against the input's bottom edge, with its left edge on the input's text so it reads as attached.
         * Error helpers keep their own colour — `.Mui-error` outranks this rule.
         */ MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '0.6875rem',
                    lineHeight: 1.35,
                    margin: '0.2rem 0 0 0.75rem'
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                indeterminate: {
                    color: 'red'
                }
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '0.5rem'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: (0, $8951886a6b49e92a$export$7536ca5ba8ef94f0).font_sm,
                    lineHeight: (0, $8951886a6b49e92a$export$aa43e0cf17fdb070).font_xs
                }
            },
            defaultProps: {
                enterDelay: 800,
                leaveDelay: 200,
                enterNextDelay: 400
            }
        },
        MuiRadio: {
            defaultProps: {
                disableRipple: true
            }
        }
    }
};
const $6efd2a8884b3d0c5$export$c2e730548983f1c2 = (0, $1626f90a7ddd654a$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings), {
    palette: {
        mode: 'light',
        text: {
            primary: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        primary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).border
        },
        secondary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
        },
        error: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
        },
        background: {
            paper: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        },
        info: {
            light: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium,
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary,
            dark: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        }
    },
    components: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components), {
        MuiInputLabel: {
            styleOverrides: {
                root: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components.MuiInputLabel.styleOverrides.root), {
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium
                })
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components.MuiFormHelperText.styleOverrides.root), {
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium
                })
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: '0.75rem',
                    '&::placeholder': {
                        color: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light,
                        fontWeight: 400,
                        fontSize: '0.75rem',
                        opacity: 1
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: '#706FA0'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components.MuiTooltip.styleOverrides.tooltip), {
                    backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_medium_light,
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                }),
                arrow: {
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
                }
            }
        }
    })
}));
const $6efd2a8884b3d0c5$export$faedaf67268e9c67 = (0, $1626f90a7ddd654a$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings), {
    palette: {
        mode: 'dark',
        text: {
            primary: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        },
        primary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light
        },
        secondary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
        },
        error: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).error_light
        },
        background: {
            paper: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
        },
        info: {
            light: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_dark,
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).accent,
            dark: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
            contrastText: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
        }
    },
    components: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components), {
        MuiInputLabel: {
            styleOverrides: {
                root: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components.MuiInputLabel.styleOverrides.root), {
                    color: $6efd2a8884b3d0c5$var$darkInputColor
                })
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components.MuiFormHelperText.styleOverrides.root), {
                    color: $6efd2a8884b3d0c5$var$darkInputColor
                })
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: '0.75rem',
                    '&::placeholder': {
                        color: $6efd2a8884b3d0c5$var$darkInputColor,
                        fontWeight: 400,
                        fontSize: '0.75rem',
                        opacity: 1
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: $6efd2a8884b3d0c5$var$darkInputColor
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $6efd2a8884b3d0c5$var$commonSettings.components.MuiTooltip.styleOverrides.tooltip), {
                    backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                }),
                arrow: {
                    color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark
                }
            }
        }
    })
}));


const $4a3c7ab711a29dd4$export$959de94a57794f15 = 'USER';
const $4a3c7ab711a29dd4$export$d7b509e53699b6f9 = 'USER_ACCESS';
const $4a3c7ab711a29dd4$export$a1ad07ee66337027 = 'DEVICE_CURRENT_PROFILE';
const $4a3c7ab711a29dd4$export$e51ceeb4d2d72ad4 = 'appSettings';
const $4a3c7ab711a29dd4$export$7e1b78538df536d8 = 'DEVICES';
const $4a3c7ab711a29dd4$export$e0520dc8c020e730 = 'VIRTUAL_DEVICE';
const $4a3c7ab711a29dd4$export$c66d0139ef02a287 = 'VIRTUAL_DEVICE_ID';
const $4a3c7ab711a29dd4$export$e79477942e3c1f1 = 'VIRTUAL_DEVICE_TOKEN';
const $4a3c7ab711a29dd4$export$ee420f2304181127 = 'cephable_upgrade_modal_dismissed';
const $4a3c7ab711a29dd4$export$59915694013eef2b = 14;
const $4a3c7ab711a29dd4$export$59dcb33d1d7504ec = 'AUTOMATION_RULES';
const $4a3c7ab711a29dd4$export$41795e2f8c266016 = 'ai_intro_choice';
const $4a3c7ab711a29dd4$export$c2f218fd6b629f5c = 'record_workflow_coach';




var $7fPBF = parcelRequire("7fPBF");
const $c6dc2c2d62651942$var$defaultThemeContext = {
    theme: 'light',
    setThemeDirectly: ()=>{},
    spacing: 'comfortable',
    setSpacing: ()=>{},
    scaleSize: 16,
    setScaleSize: ()=>{},
    panelButtonScaleSize: 16,
    setPanelButtonScaleSize: ()=>{},
    panelPosition: 'right',
    setPanelPosition: ()=>{}
};
const $c6dc2c2d62651942$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $7fPBF.createContext)($c6dc2c2d62651942$var$defaultThemeContext);
const $c6dc2c2d62651942$export$c507fb1c2e1ac13a = ()=>{
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84f3fdd51733d70b$export$98f03c5d19621d70), {
        styles: {
            html: {
                fontSize: `${theme.scaleSize}px`
            },
            body: {
                color: theme.color.text,
                ':not(:has(#command-overlay, #panel-overlay))': {
                    backgroundColor: theme.color.background
                }
            },
            // for storybook
            '.light-theme': {
                color: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark,
                backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light
            },
            '.dark-theme': {
                color: (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light,
                backgroundColor: (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_intense
            }
        }
    });
};
const $c6dc2c2d62651942$export$e6cf561029f29d90 = ({ children: children })=>{
    const prefersDarkMode = (0, $ec3395cd7fe43d7a$export$2e2bcd8739ae039)('(prefers-color-scheme: dark)');
    const [theme, setTheme] = (0, $7fPBF.useState)(prefersDarkMode ? 'dark' : 'light');
    const [spacing, setSpacing] = (0, $7fPBF.useState)('comfortable');
    const [scaleSize, setScaleSize] = (0, $7fPBF.useState)(()=>{
        try {
            const stored = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e51ceeb4d2d72ad4));
            if (stored) {
                const settings = JSON.parse(stored);
                if (settings.uiScaleSize) return settings.uiScaleSize;
            }
        } catch (e) {
        // ignore
        }
        return 16;
    });
    const [panelButtonScaleSize, setPanelButtonScaleSize] = (0, $7fPBF.useState)(()=>{
        try {
            const stored = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e51ceeb4d2d72ad4));
            if (stored) {
                const settings = JSON.parse(stored);
                if (settings.panelButtonScaleSize) return settings.panelButtonScaleSize;
            }
        } catch (e) {
        // ignore
        }
        return 16;
    });
    const [panelPosition, setPanelPosition] = (0, $7fPBF.useState)('left'); // Default
    (0, $7fPBF.useEffect)(()=>{
        setTheme(prefersDarkMode ? 'dark' : 'light');
    }, [
        prefersDarkMode
    ]);
    const muiThemeObject = (0, $7fPBF.useMemo)(()=>theme === 'light' ? (0, $6efd2a8884b3d0c5$export$c2e730548983f1c2) : (0, $6efd2a8884b3d0c5$export$faedaf67268e9c67), [
        theme
    ]);
    const emotionThemeObject = (0, $7fPBF.useMemo)(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme === 'light' ? (0, $640cd3167d5819eb$export$ce2efe5baec76fba) : (0, $640cd3167d5819eb$export$86c8e15b70e05cb1)), {
            mode: theme,
            spacing: spacing,
            scaleSize: scaleSize,
            panelButtonScaleSize: panelButtonScaleSize,
            panelPosition: panelPosition,
            panelOrientation: panelPosition === 'left' || panelPosition === 'right' ? 'vertical' : 'horizontal'
        }), [
        theme,
        spacing,
        scaleSize,
        panelButtonScaleSize,
        panelPosition
    ]);
    const setThemeDirectly = (0, $7fPBF.useCallback)((theme)=>{
        setTheme(theme);
    }, []);
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            theme: theme,
            setThemeDirectly: setThemeDirectly,
            spacing: spacing,
            setSpacing: setSpacing,
            scaleSize: scaleSize,
            setScaleSize: setScaleSize,
            panelButtonScaleSize: panelButtonScaleSize,
            setPanelButtonScaleSize: setPanelButtonScaleSize,
            panelPosition: panelPosition,
            setPanelPosition: setPanelPosition
        }), [
        theme,
        setThemeDirectly,
        spacing,
        setSpacing,
        scaleSize,
        setScaleSize,
        panelButtonScaleSize,
        setPanelButtonScaleSize,
        panelPosition,
        setPanelPosition
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c78e537a9e9e9b0$export$a49f528ae1a4d0ed).Provider, {
        value: {
            weight: 'regular'
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c6dc2c2d62651942$export$2c657da244d00bd6.Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d62c6f18f523e962$export$407448d2b89b1813), {
                theme: emotionThemeObject,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c6dc2c2d62651942$export$c507fb1c2e1ac13a, {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5faddabad8e8da3c$export$2e2bcd8739ae039), {
                        theme: muiThemeObject,
                        children: children
                    })
                ]
            })
        })
    });
};






function $13d0c8a27a7be22f$export$6b17a39e52c8ee53(request, baseUrl = '', locale) {
    const params = new URLSearchParams();
    if (locale) request = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, request), {
        locale: locale
    });
    if (!request) return baseUrl;
    Object.entries(request).forEach(([key, value])=>{
        if (value == null) return;
        if (Array.isArray(value) && value.length > 0) value.forEach((item)=>params.append(key, item));
        else if (value.toString().trim() !== '') params.append(key, value.toString());
    });
    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
function $13d0c8a27a7be22f$export$990cf17cc7759dd4(path, newParams, additionalParams, locale) {
    const merged = {};
    // A caller may hand us a path that already carries a query (e.g. `/extensions/skills?teachDraft=id`).
    // Fold those into the merge (lowest priority) instead of letting buildQueryString append a second `?`,
    // which would glue the added params onto the last existing value.
    const queryStart = path.indexOf('?');
    const basePath = queryStart >= 0 ? path.slice(0, queryStart) : path;
    if (queryStart >= 0) {
        const existing = new URLSearchParams(path.slice(queryStart + 1));
        for (const key of new Set(existing.keys())){
            const values = existing.getAll(key);
            merged[key] = values.length > 1 ? values : values[0];
        }
    }
    // Safely spread existing params (if any)
    Object.entries(additionalParams || {}).forEach(([key, value])=>{
        merged[key] = value;
    });
    // Override or add new ones
    Object.assign(merged, newParams);
    return $13d0c8a27a7be22f$export$6b17a39e52c8ee53(merged, basePath, locale);
}


// constants for keys
const $db3063bd3b6d501e$export$d975f71e6c6b349c = 'ENABLED_ACCESS_TOKEN';
const $db3063bd3b6d501e$export$f849a8e4906d2051 = 'ENABLED_REFRESH_TOKEN';
const $db3063bd3b6d501e$export$302657547b2577c2 = 'ENABLED_USER';
const $db3063bd3b6d501e$export$ccdad49998c6d6ff = 'ENABLED_ACCESS_EXPIRATION';
const $db3063bd3b6d501e$export$7b02f2982f8105ff = 'CUSTOM_CONTROLS';
const $db3063bd3b6d501e$export$12eec5e996d6e961 = 'GENAI_MODEL_CONFIGS';
const $db3063bd3b6d501e$export$8c08620bc77b45c8 = 'GENAI_MODEL_FAMILIES';
function $db3063bd3b6d501e$export$5dbf9a24b655dde4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $db3063bd3b6d501e$export$666167f3cc1c081a = ()=>{
    if (window.ADMIN_ENVIRONMENT) return $db3063bd3b6d501e$var$getAdminClientId();
    if (!window.WEB_ENVIRONMENT || window.DESKTOP_ENVIRONMENT) return '8b70d50a-3428-48dc-bc21-dc6807258aa4';
    if (window.ENABLED_ENVIRONMENT == 'dev') return 'bc55094d-6cea-446e-a44a-e61c9d2c07e2';
    if (window.ENABLED_ENVIRONMENT == 'beta') return 'cc55094d-6cea-446e-a44a-e61c9d2c07e2';
    return '8b70d50a-3428-48dc-bc21-dc6807258aa4'; // production
};
const $db3063bd3b6d501e$export$abb5e0783f1a4f17 = ()=>{
    if (window.ADMIN_ENVIRONMENT) return $db3063bd3b6d501e$var$getAdminClientSecret();
    if (!window.WEB_ENVIRONMENT || window.DESKTOP_ENVIRONMENT) return 'AmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExZDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw==';
    if (window.ENABLED_ENVIRONMENT == 'dev') return 'Fg709dBr0DMOxlWDIfX27gJKDCQz5TnfyVkUh8WzM7YCpmmPM37j3UQtkal1';
    if (window.ENABLED_ENVIRONMENT == 'beta') return 'Fg709dBr0DMOxlWDIfX27gJKDCQz5TnfyVkUh8WzM7YCpmmPM37j3UQtkal1';
    return 'AmZiNDUxOGM1ZGFiNDhlNmE5MjY2ZjBiYzliNDUxMmQ1OGExZDAxZjU0ZWI0ODU5YmRhN2VkYTc0OTA1M2M4Nw=='; // production
};
const $db3063bd3b6d501e$var$getAdminClientId = ()=>{
    const environment = "production";
    if (environment == 'dev') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    if (environment == 'staging') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    if (environment == 'beta') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    if (environment == 'staging-local') return 'a2409dc9-b495-4b14-ac38-6c288b7871bd';
    return '3c8de27c-e1d7-4565-a4f2-e5de5f5a0e63'; // production
};
const $db3063bd3b6d501e$var$getAdminClientSecret = ()=>{
    const environment = "production";
    if (environment == 'production') return 'V7xGFh85f0FlwKN5WWmPfgWHrrrGy96WV6QM4jisQA46SQkUmRF5xIdaJEg0ftlv';
    if (environment == 'dev') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    if (environment == 'staging') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    if (environment == 'beta') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    if (environment == 'staging-local') return 'MftKwkGoysYJjTMnZo2Greym7jf0gQpu 2Ry4tpZBLuGkQU83WXl0Qb4cYkqS273O';
    return 'V7xGFh85f0FlwKN5WWmPfgWHrrrGy96WV6QM4jisQA46SQkUmRF5xIdaJEg0ftlv'; // production
};
const $db3063bd3b6d501e$export$94d1d6411b964f7 = ()=>{
    return $db3063bd3b6d501e$export$666167f3cc1c081a() === $db3063bd3b6d501e$var$getAdminClientId() ? 'admin' : 'desktop';
};


const $903f4d089c887be1$var$DESKTOP_ENVIRONMENTS = {
    production: {
        environment: 'production',
        displayName: 'Cephable',
        // Keep this identifier stable so production upgrades retain their install, updates, and local data.
        appId: 'com.enabledplay.desktop',
        installerName: 'enabled_play',
        deepLinkScheme: 'cephable',
        legacyDeepLinkSchemes: [
            'enabledplay'
        ]
    },
    beta: {
        environment: 'beta',
        displayName: 'Cephable Beta',
        appId: 'com.enabledplay.desktop.beta',
        installerName: 'enabled_play_beta',
        deepLinkScheme: 'cephable-beta',
        outlineColor: '#7553D6',
        userDataDirectory: 'Cephable Beta'
    },
    staging: {
        environment: 'staging',
        displayName: 'Cephable Staging',
        appId: 'com.enabledplay.desktop.staging',
        installerName: 'enabled_play_staging',
        deepLinkScheme: 'cephable-staging',
        outlineColor: '#D66D16',
        userDataDirectory: 'Cephable Staging'
    },
    develop: {
        environment: 'develop',
        displayName: 'Cephable Develop',
        appId: 'com.enabledplay.desktop.develop',
        installerName: 'enabled_play_develop',
        deepLinkScheme: 'cephable-develop',
        outlineColor: '#007F71',
        legacyDeepLinkSchemes: [
            'cephable-dev'
        ],
        userDataDirectory: 'Cephable Develop'
    }
};
function $903f4d089c887be1$export$44346ce667e47cad(environment = "production") {
    switch(environment){
        case 'dev':
        case 'develop':
            return 'develop';
        case 'beta':
        case 'staging':
            return environment;
        default:
            return 'production';
    }
}
function $903f4d089c887be1$export$3793ce603e4e3d02(environment) {
    return $903f4d089c887be1$var$DESKTOP_ENVIRONMENTS[$903f4d089c887be1$export$44346ce667e47cad(environment)];
}
function $903f4d089c887be1$export$bc2f30c822502963(environment) {
    return $903f4d089c887be1$export$3793ce603e4e3d02(environment).deepLinkScheme;
}
function $903f4d089c887be1$export$754d83315bad1981(environment) {
    const identity = $903f4d089c887be1$export$3793ce603e4e3d02(environment);
    var _identity_legacyDeepLinkSchemes;
    return [
        identity.deepLinkScheme,
        ...(_identity_legacyDeepLinkSchemes = identity.legacyDeepLinkSchemes) !== null && _identity_legacyDeepLinkSchemes !== void 0 ? _identity_legacyDeepLinkSchemes : []
    ];
}
function $903f4d089c887be1$export$61e948fd263f912f(environment = "production") {
    switch($903f4d089c887be1$export$44346ce667e47cad(environment)){
        case 'develop':
            return 'dev';
        case 'staging':
            return 'staging';
        default:
            return 'production';
    }
}


const $07546889aef07ebc$export$28c8b26d57cb9668 = 'https://apps.apple.com/us/app/cephable/id1608826085';
const $07546889aef07ebc$export$cfa0ee4e03ad34b8 = 'https://play.google.com/store/apps/details?id=com.enabledplay.app&hl=en_US';
const $07546889aef07ebc$export$856e343366abd942 = 'https://controller.cephable.com';
const $07546889aef07ebc$export$bfebd0c8eb2f9c7f = 'https://developers.cephable.com';
const $07546889aef07ebc$export$54a6821013ea7657 = 'https://portal.cephable.com';
const $07546889aef07ebc$export$df8e085683bf7fe4 = ()=>{
    const environment = "production";
    if (environment == 'dev' || environment == 'develop') return 'http://localhost:3002';
    else if (environment == 'staging') return 'https://enabled-dev.azurewebsites.net';
    else if (environment == 'production') return 'https://services.cephable.com';
    else if (environment == 'staging-local') return 'https://enabled-dev.azurewebsites.net';
    return 'https://services.cephable.com';
};
const $07546889aef07ebc$export$b0c2c82d7aa8a735 = ()=>{
    if (window.ADMIN_ENVIRONMENT) return $07546889aef07ebc$export$3fbde059e3192133();
    if (!window.WEB_ENVIRONMENT || window.DESKTOP_ENVIRONMENT) return `${(0, $903f4d089c887be1$export$bc2f30c822502963)()}://authcallback`;
    if (window.ENABLED_ENVIRONMENT == 'dev') return 'http://localhost:3000/authcallback';
    else if (window.ENABLED_ENVIRONMENT == 'staging') return 'https://enableddevportal.z13.web.core.windows.net/authcallback';
    else if (window.ENABLED_ENVIRONMENT == 'production') return 'https://portal.cephable.com/authcallback';
    else if (window.ENABLED_ENVIRONMENT == 'staging-local') // for parity to desktop app development
    return 'https://dev-app.cephable.com/authcallback';
    return 'https://portal.cephable.com/authcallback';
};
const $07546889aef07ebc$export$3fbde059e3192133 = ()=>{
    const environment = "production";
    if (environment == 'dev' || environment == 'develop') return 'http://localhost:3004/';
    else if (environment == 'staging') return 'https://enableddevportal.z13.web.core.windows.net/';
    else if (environment == 'production') return 'https://portal.cephable.com/';
    else if (environment == 'staging-local') // for parity to desktop app development
    return 'http://localhost:3004/';
    return 'https://portal.cephable.com/';
};
const $07546889aef07ebc$export$db48712d9b7c9727 = ()=>{
    const environment = "production";
    if (environment == 'dev' || environment == 'develop') return 'http://localhost:3003';
    else if (environment == 'staging' || environment == 'staging-local') return 'https://enabled-dev-analytics.azurewebsites.net';
    else if (environment == 'production') return 'https://analytics.cephable.com';
    return 'https://analytics.cephable.com';
};
const $07546889aef07ebc$export$7d7db16d3fe379f6 = ()=>{
    return `${(0, $903f4d089c887be1$export$bc2f30c822502963)()}://app/open`;
};
const $07546889aef07ebc$export$63c7d63fd659c02 = ()=>{
    return `${$07546889aef07ebc$export$df8e085683bf7fe4()}/app/open`;
};


class $6340c001daecf2cb$export$2e2bcd8739ae039 {
    constructor(error){
        this.resultType = 'Invalid';
        this.errors = [
            error
        ];
    }
}


class $be7228f0da37b2ae$export$2e2bcd8739ae039 {
    constructor(){
        this.resultType = 'NoResponse';
        this.errors = [
            'The server did not respond.'
        ];
    }
}


class $206736819695f5cd$export$2e2bcd8739ae039 {
    constructor(error = 'Unable to find the given resource.'){
        this.resultType = 'NotFound';
        this.errors = [
            error
        ];
    }
}


class $6d6350e3c807681d$export$2e2bcd8739ae039 {
    constructor(){
        this.resultType = 'Offline';
        this.errors = [
            'Network is offline. Please check your connection.'
        ];
    }
}


class $84d8c1f6f6e5603d$export$2e2bcd8739ae039 {
    constructor(data){
        this.resultType = 'Ok';
        this.errors = [];
        this.data = data;
    }
}


class $eb323d7d149f5b89$export$2e2bcd8739ae039 {
    constructor(error = 'Your session has expired. Please sign in and try again.'){
        this.resultType = 'Unauthorized';
        this.errors = [
            error
        ];
    }
}


class $5f3c730b3d8aae7c$export$2e2bcd8739ae039 {
    constructor(){
        this.resultType = 'Unexpected';
        this.errors = [
            'An unexpected error has occurred. Please try again later.'
        ];
    }
}


'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $77146a31cb578292$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($77146a31cb578292$var$hasOwnProperty(obj, prop)) return true;
        obj = $77146a31cb578292$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $77146a31cb578292$var$getSafeProp = (obj, prop)=>obj != null && $77146a31cb578292$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if (!$77146a31cb578292$var$isObject(val)) return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $77146a31cb578292$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$toStringTag) && !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $77146a31cb578292$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $77146a31cb578292$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
const $77146a31cb578292$var$isSet = $77146a31cb578292$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $77146a31cb578292$var$G = $77146a31cb578292$var$getGlobal();
const $77146a31cb578292$var$FormDataCtor = typeof $77146a31cb578292$var$G.FormData !== 'undefined' ? $77146a31cb578292$var$G.FormData : undefined;
const $77146a31cb578292$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($77146a31cb578292$var$FormDataCtor && thing instanceof $77146a31cb578292$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $77146a31cb578292$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$77146a31cb578292$var$isFunction(thing.append)) return false;
    const kind = $77146a31cb578292$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $77146a31cb578292$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $77146a31cb578292$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($77146a31cb578292$var$isPlainObject(existing) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(existing, val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $77146a31cb578292$var$isBuffer(source)) continue;
        $77146a31cb578292$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $77146a31cb578292$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($77146a31cb578292$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $77146a31cb578292$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($77146a31cb578292$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $77146a31cb578292$var$isArray(source) ? [] : {};
                    $77146a31cb578292$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $77146a31cb578292$var$isSafeIterable = (thing)=>thing != null && $77146a31cb578292$var$hasOwnInPrototypeChain(thing, $77146a31cb578292$var$iterator) && $77146a31cb578292$var$isIterable(thing);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isReactNativeBlob: $77146a31cb578292$var$isReactNativeBlob,
    isReactNative: $77146a31cb578292$var$isReactNative,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    hasOwnInPrototypeChain: $77146a31cb578292$var$hasOwnInPrototypeChain,
    getSafeProp: $77146a31cb578292$var$getSafeProp,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable,
    isSafeIterable: $77146a31cb578292$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $77146a31cb578292$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp($cf2275aca40d6d88$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $f0ca37af3d81c31b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f0ca37af3d81c31b$var$sanitizeValue(value, invalidChars) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$f0ca37af3d81c31b$var$sanitizeValue(item, invalidChars));
    return $f0ca37af3d81c31b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f0ca37af3d81c31b$export$9e344cffce061a22 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f0ca37af3d81c31b$export$59dd66c2a12d8f62 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f0ca37af3d81c31b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f0ca37af3d81c31b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : (0, $f0ca37af3d81c31b$export$9e344cffce061a22)(String(value));
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $c7e8ef3e2bb241a6$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $c7e8ef3e2bb241a6$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $c7e8ef3e2bb241a6$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $c7e8ef3e2bb241a6$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(0, equals));
        if (!$c7e8ef3e2bb241a6$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $c7e8ef3e2bb241a6$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $77146a31cb578292$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $cf2275aca40d6d88$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(header) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $c7e8ef3e2bb241a6$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $77146a31cb578292$export$2e2bcd8739ae039).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;


'use strict';
const $b9cc6960093b095e$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $b9cc6960093b095e$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source) && $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $b9cc6960093b095e$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $b9cc6960093b095e$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $b9cc6960093b095e$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $b9cc6960093b095e$var$stringifySafely(entry.message) : $b9cc6960093b095e$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $b9cc6960093b095e$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $b9cc6960093b095e$var$aggregateErrorMessage(error);
        const axiosError = new $b9cc6960093b095e$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $b9cc6960093b095e$var$redactConfig(config, redactKeys) : (0, $77146a31cb578292$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$b9cc6960093b095e$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$b9cc6960093b095e$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$b9cc6960093b095e$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$b9cc6960093b095e$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$b9cc6960093b095e$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$b9cc6960093b095e$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$b9cc6960093b095e$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$b9cc6960093b095e$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$b9cc6960093b095e$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$b9cc6960093b095e$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;


// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;



'use strict';
const $19044a9fa7281693$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject((0, $77146a31cb578292$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $19044a9fa7281693$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) && (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039).from(value);
            throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNative(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $77146a31cb578292$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $19044a9fa7281693$export$2e2bcd8739ae039)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $a2774d1dd3bec636$var$encode) : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;


'use strict';
function $4a4d655613ae826e$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $4a4d655613ae826e$export$c564cdbbe6da493;
    const serializeFn = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a2774d1dd3bec636$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ec4d8e24b0699790$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;





'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};








'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $a2774d1dd3bec636$export$2e2bcd8739ae039);


'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9a13f762833a66d0$export$2e2bcd8739ae039,
        FormData: $16325b87e107b4bc$export$2e2bcd8739ae039,
        Blob: $650c3d387ae3fbd4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $1bbd8fa0325c4f9a$exports = {};

$parcel$export($1bbd8fa0325c4f9a$exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export($1bbd8fa0325c4f9a$exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export($1bbd8fa0325c4f9a$exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $f9f874191f496b63$export$2e2bcd8739ae039 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $1bbd8fa0325c4f9a$exports, (0, $e4489594588108ef$export$2e2bcd8739ae039));


'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(data, new (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        visitor: function(value, key, path, helpers) {
            if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).isNode && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}






'use strict';
const $24febbb5d340c733$var$MAX_DEPTH = (0, $19044a9fa7281693$export$659081b45d03227d);
function $24febbb5d340c733$var$throwIfDepthExceeded(index) {
    if (index > $24febbb5d340c733$var$MAX_DEPTH) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $24febbb5d340c733$var$MAX_DEPTH, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $24febbb5d340c733$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $24febbb5d340c733$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;


'use strict';
const $a5e696f232d0dc12$var$own = (obj, key)=>obj != null && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $7e146da7bba06216$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $24febbb5d340c733$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isFile(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $a5e696f232d0dc12$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f1a69cd24a140b61$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $a5e696f232d0dc12$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $a5e696f232d0dc12$var$own(this, 'transitional') || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $a5e696f232d0dc12$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isResponse(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $a5e696f232d0dc12$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $a5e696f232d0dc12$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;



'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $f6ac833a4b31e3dc$var$CanceledError extends (0, $b9cc6960093b095e$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;







'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;



const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d592abf0a04957f1$export$2e2bcd8739ae039)(50, 250);
    return (0, $5603d643a9d93c92$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn, scheduler = (0, $77146a31cb578292$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin), (0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}


'use strict';
const $2ec1d7b86495f966$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $2ec1d7b86495f966$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $2ec1d7b86495f966$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $2ec1d7b86495f966$var$normalizeURLForProtocolCheck(url) {
    return $2ec1d7b86495f966$var$stripLeadingC0ControlOrSpace(url).replace($2ec1d7b86495f966$var$httpProtocolControlCharacters, '');
}
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $2ec1d7b86495f966$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $b9cc6960093b095e$export$6acd2efa8ac62a1b}`;
    });
}
function $2ec1d7b86495f966$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $b9cc6960093b095e$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $b9cc6960093b095e$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$2ec1d7b86495f966$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $2ec1d7b86495f966$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $2ec1d7b86495f966$var$normalizeURLForProtocolCheck(url);
        if ($2ec1d7b86495f966$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($2ec1d7b86495f966$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $2ec1d7b86495f966$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $12188e34b7070552$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $2ec1d7b86495f966$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $f55e71b6c54c4376$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}





'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, thing) : thing;
const $3d132bbf7812485b$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(target) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($3d132bbf7812485b$var$ownEnumerableKeys((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2db7806979b02fe9$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $b00a7ead3edff84a$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $b00a7ead3edff84a$var$resolveConfig(config) {
    const newConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4a4d655613ae826e$export$2e2bcd8739ae039)((0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $b00a7ead3edff84a$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        (0, $2db7806979b02fe9$export$2e2bcd8739ae039)(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $82d74b1a5a0a01da$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $534b3794da5c002d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $b00a7ead3edff84a$export$2e2bcd8739ae039 = $b00a7ead3edff84a$var$resolveConfig;



const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request aborted', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(msg, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach((0, $f0ca37af3d81c31b$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $2ecf5cf4c0202afd$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $f9f874191f496b63$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039) ? err : new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;


const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $ca979531ea712187$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $ca979531ea712187$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 1)) && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 2));
const $ca979531ea712187$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $ca979531ea712187$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $ca979531ea712187$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $ca979531ea712187$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $ca979531ea712187$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $ca979531ea712187$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            code = $ca979531ea712187$var$hexValue(body.charCodeAt(i + 1)) * 16 + $ca979531ea712187$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($ca979531ea712187$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$ca979531ea712187$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $ca979531ea712187$var$estimateBase64BufferAllocation(body);
    return $ca979531ea712187$var$base64Bytes(significant);
};
const $ca979531ea712187$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $ca979531ea712187$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $ca979531ea712187$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $ca979531ea712187$var$estimatePercentDecodedBase64Bytes);
}
function $ca979531ea712187$export$1f39e64b554a246f(url) {
    return $ca979531ea712187$var$estimateDataURLBytes(url, $ca979531ea712187$var$estimateBase64BufferAllocation);
}


const $95be4ecd446de127$export$a4ad2735b021c132 = "1.19.0";



const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $77146a31cb578292$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $c2191f87f9ef3849$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $c2191f87f9ef3849$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    const globalObject = (0, $77146a31cb578292$export$2e2bcd8739ae039).global !== undefined && (0, $77146a31cb578292$export$2e2bcd8739ae039).global !== null ? (0, $77146a31cb578292$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $c2191f87f9ef3849$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $62bdf0498e608a4a$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $77146a31cb578292$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($c2191f87f9ef3849$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($c2191f87f9ef3849$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $ca979531ea712187$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $c626b6acbc30fe14$export$b0119225647bd83)(stream, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(requestContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $95be4ecd446de127$export$a4ad2735b021c132), false);
            const resolvedOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f0ca37af3d81c31b$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(responseContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $c626b6acbc30fe14$export$b0119225647bd83)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $2c92173995cdc070$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Network Error', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $c036c406f3928265$var$knownAdapters = {
    http: (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039),
    xhr: (0, $2cabe869ce51dbf6$export$2e2bcd8739ae039),
    fetch: {
        get: $c2191f87f9ef3849$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $c036c406f3928265$var$getAdapter(adapters, config) {
    adapters = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $c036c406f3928265$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $c036c406f3928265$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $36f1aa490c1da053$export$2e2bcd8739ae039)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $95be4ecd446de127$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('options must be an object', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};




'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $1ad671c27810423e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            legacyInterceptorReqResOrdering: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            advertiseZstdAcceptEncoding: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            validateStatusUndefinedResolves: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $4a4d655613ae826e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)(),
            response: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;






'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)((0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $a5e696f232d0dc12$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.CancelToken = (0, $f4994f37c883aea2$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.isCancel = (0, $36f1aa490c1da053$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.VERSION = (0, $95be4ecd446de127$export$a4ad2735b021c132);
$747d656b899e6115$var$axios.toFormData = (0, $19044a9fa7281693$export$2e2bcd8739ae039);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $b9cc6960093b095e$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $8145c4b68bfee186$export$2e2bcd8739ae039);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $ec03acb464b74212$export$2e2bcd8739ae039);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $24febbb5d340c733$export$2e2bcd8739ae039)((0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $a9353565c2e0947e$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a, create: $c6ba0193c6fadd6f$export$185802fd694ee1f5 } = (0, $747d656b899e6115$export$2e2bcd8739ae039);


const $7353c99a37ec31b7$export$4a68059d3a005c64 = async (url, body, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).post(fullUrl, body);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$e9845906888b3aa9 = async (url, body, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).post(fullUrl, body, {
            responseType: 'blob'
        });
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$a5575dbeeffdad98 = async (url, file, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        let formData = new FormData();
        formData.append('file', file);
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).post(fullUrl, formData);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$bcf74ec8477a7e2 = async (url, file, progressCallback)=>{
    try {
        let instance = (0, $747d656b899e6115$export$2e2bcd8739ae039).create();
        instance.defaults.headers.common = {};
        const response = await instance.put(url, file, {
            headers: {
                'Content-Type': $7353c99a37ec31b7$var$getFileType(file.type)
            },
            onUploadProgress: (progressEvent)=>{
                if (progressCallback && progressEvent.total) progressCallback(Math.floor(progressEvent.loaded * 100 / progressEvent.total));
            }
        });
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$var$getFileType = (fileType)=>{
    // override file type for content type since certain browsers just make up their own rules
    if (fileType == 'audio/mpeg') return 'audio/mp3';
    return fileType;
};
const $7353c99a37ec31b7$export$f8781c51b9396ab9 = async (url, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).get(fullUrl);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$409e9b97a28ed92d = async (url, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).get(fullUrl, {
            responseType: 'blob'
        });
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$991733b4d823dec6 = async (url, body, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).put(fullUrl, body);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$21a4386506d04384 = async (url, baseUrl)=>{
    let fullUrl = (baseUrl === undefined ? (0, $07546889aef07ebc$export$df8e085683bf7fe4)() : baseUrl) + url;
    try {
        $7353c99a37ec31b7$var$setToken();
        const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).delete(fullUrl);
        return $7353c99a37ec31b7$var$handleResponse(response);
    } catch (error) {
        return $7353c99a37ec31b7$var$handleResponse(error.response);
    }
};
const $7353c99a37ec31b7$export$b0d93e0dab97a966 = (model)=>{
    let stringArray = [];
    for(let property in model)if (Object.prototype.hasOwnProperty.call(model, property) && model[property] != null) stringArray.push(encodeURIComponent(property) + '=' + encodeURIComponent(model[property]));
    return stringArray.join('&');
};
const $7353c99a37ec31b7$var$setToken = ()=>{
    // pull token from local store
    const accessToken = sessionStorage.getItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c));
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    // set to default header
    if (accessToken !== undefined) (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};
const $7353c99a37ec31b7$export$4ee989d074b27610 = (token)=>{
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = `Bearer ${token}`;
};
const $7353c99a37ec31b7$export$ea8b7c0df46197b5 = (token)=>{
    (0, $747d656b899e6115$export$2e2bcd8739ae039).defaults.headers.common['X-COMMAND-TOKEN'] = token;
};
// maps an axios response to a result
const $7353c99a37ec31b7$var$handleResponse = (response)=>{
    if (!navigator.onLine) return new (0, $6d6350e3c807681d$export$2e2bcd8739ae039)();
    if (!response) return new (0, $be7228f0da37b2ae$export$2e2bcd8739ae039)();
    if (response.status === 200 || response.status === 204) {
        if (response.data === undefined) return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)({});
        return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(response.data);
    } else if (response.status === 400) {
        let errors = response.data;
        let error = errors[0];
        if (error == undefined) {
            let attributeErrorNames = Object.getOwnPropertyNames(errors);
            if (attributeErrorNames[0] != undefined && errors[attributeErrorNames[0]] != null) error = errors[attributeErrorNames[0]];
            else error = response.data['Responses[0].Content'][0];
        }
        return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)(error);
    } else if (response.status === 404) return new (0, $206736819695f5cd$export$2e2bcd8739ae039)();
    else if (response.status === 403) return new (0, $eb323d7d149f5b89$export$2e2bcd8739ae039)();
    return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
};


const $1a4c36336f303477$export$c542b5e295206b2a = (clientId, clientSecret, refreshToken)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/signin/token?client_id=${clientId}&client_secret=${clientSecret}&refresh_token=${refreshToken}&grant_type=refresh_token`, null);
};
const $1a4c36336f303477$export$257b2d10b709d8ef = (clientId, code, redirectUri)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/signin/token?client_id=${clientId}&code=${code}&redirect_uri=${encodeURI(redirectUri)}&grant_type=code`, null);
};
const $1a4c36336f303477$export$5a6314a822d8df05 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)('/api/Authentication/AuthClient/FeatureAccess');
};
const $1a4c36336f303477$export$376a941b4307217d = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ClientOnboarding/status/current`);
};
const $1a4c36336f303477$export$63e184abc187829a = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/ClientOnboarding/status/current`, request);
};
const $1a4c36336f303477$export$b77d91733b0be1c3 = (deviceTypeId, name, hardwareId, platform)=>{
    let paramsObj = {};
    if (name) paramsObj.name = name;
    if (hardwareId) paramsObj.hardwareId = hardwareId;
    if (platform) paramsObj.platform = platform;
    const params = new URLSearchParams(paramsObj);
    const queryString = params.toString();
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/device/userDevices/new/${deviceTypeId}?${queryString !== null && queryString !== void 0 ? queryString : ''}`, null);
};
const $1a4c36336f303477$export$7d50e0ca36e10692 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices`);
};
const $1a4c36336f303477$export$bcdfb52e5b6fae71 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/deviceTypes`);
};
const $1a4c36336f303477$export$1550d2bbaae6a36d = (locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/Device/deviceTypes/public/clientListings/locale?locale=${locale}`);
};
const $1a4c36336f303477$export$9c71b804c7d56d57 = (deviceTypeId, locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/deviceTypes/${deviceTypeId}/clientListing?locale=${locale}`);
};
const $1a4c36336f303477$export$fb1c38ee1d8d29f5 = (deviceTypeId, locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/deviceTypes/${deviceTypeId}/customControls?locale=${locale}`);
};
const $1a4c36336f303477$export$7c456bfd2296405b = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices/${userDeviceId}`);
};
const $1a4c36336f303477$export$d11b3391d3492ee8 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices/${userDeviceId}/tokens`);
};
const $1a4c36336f303477$export$d90355b21d70c45b = (userDeviceId, options)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/device/userDevices/${userDeviceId}/tokens`, options);
};
const $1a4c36336f303477$export$600b579bd3ac45b1 = (userDeviceId, locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/device/userDevices/${userDeviceId}/customControls?locale=${locale}`);
};
const $1a4c36336f303477$export$b9a2c62bbb3b9917 = (userDeviceTypeId, configuration, locale)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceTypeId}/customControls?locale=${locale}`, configuration);
};
const $1a4c36336f303477$export$acdb1997acaa39c3 = (userDeviceId, controls, locale)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/customControls/default?locale=${locale}`, controls);
};
const $1a4c36336f303477$export$4ff3dab44ee74505 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/device/userDevices/${userDeviceId}/tokens/command`, null);
};
const $1a4c36336f303477$export$4ec306b864d03d47 = (userDeviceId, profileId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/setprofile/${profileId}`, null);
};
const $1a4c36336f303477$export$c35b3a8741882c0 = (userDeviceId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/setProfile/v2`, request);
};
const $1a4c36336f303477$export$3620b5cb1c7d18ec = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/private`);
};
const $1a4c36336f303477$export$5bd7a6effa9290bc = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/${profileId}`);
};
const $1a4c36336f303477$export$dda1c3bd332d195f = (request)=>{
    const params = new URLSearchParams();
    // build the query string
    Object.entries(request).forEach(([key, value])=>{
        if (value == null) return;
        if (Array.isArray(value)) value.forEach((item)=>params.append(key, item));
        else params.append(key, value.toString());
    });
    let queryString = params.toString();
    queryString = queryString ? `?${queryString}` : '';
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/public${queryString}`);
};
const $1a4c36336f303477$export$fb988fbe57f9c402 = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/public/${profileId}`);
};
const $1a4c36336f303477$export$6660b028f5be10a7 = (configuration)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/v2`, configuration);
};
const $1a4c36336f303477$export$5880729c5d131040 = (profileId, configuration)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/deviceProfile/v2/${profileId}`, configuration);
};
const $1a4c36336f303477$export$29d101fdcde3d3d3 = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/deviceProfile/${profileId}`);
};
const $1a4c36336f303477$export$2fbfcdb28574a0 = (userDeviceId, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/listen/start`, null);
};
const $1a4c36336f303477$export$8f1ea12fa311585e = (userDeviceId, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/listen/stop`, null);
};
const $1a4c36336f303477$export$18c61c16dde23826 = (userDeviceId, model)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}`, model);
};
const $1a4c36336f303477$export$7cbb8f3d5a86c9b4 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/device/userDevices/${userDeviceId}`);
};
const $1a4c36336f303477$export$c25252bb8cefd145 = (userDeviceId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/device/userDevices/${userDeviceId}/disable`, null);
};
const $1a4c36336f303477$export$52e3a002786737fb = (userDeviceId, command, token, macro)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/command?command=${command}`, macro);
};
const $1a4c36336f303477$export$24fb0aee8e6ea00f = (userDeviceId, phrase, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/type?phrase=${phrase}`, null);
};
const $1a4c36336f303477$export$e5712e6cd1606beb = (userDeviceId, token)=>{
    (0, $7353c99a37ec31b7$export$ea8b7c0df46197b5)(token);
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceCommand/${userDeviceId}/firmware/update`, null);
};
const $1a4c36336f303477$export$e5432d4c8eb97ea7 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user`);
};
const $1a4c36336f303477$export$160fb9e4529c1fb8 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/config/tos`);
};
const $1a4c36336f303477$export$c2c1fd00af0fe210 = (request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/User/tos-acceptance`, request);
};
const $1a4c36336f303477$export$423f8e8c6cce5fd3 = ()=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/user/deleteCurrentUser`);
};
const $1a4c36336f303477$export$99d837dc30eb1ef7 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/changePassword`, request);
};
const $1a4c36336f303477$export$ca144d7073999c98 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/locales`, request);
};
const $1a4c36336f303477$export$a5fa6ef87cbd9c24 = ()=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/locales/reset`, null);
};
const $1a4c36336f303477$export$4cedc5ba9e15b997 = ()=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/user/requestEmailVerification`, null);
};
const $1a4c36336f303477$export$2892959f926e8bd6 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user/licenseAccess`);
};
const $1a4c36336f303477$export$6dcf149406a53b24 = (profileId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/${profileId}/share`, request);
};
const $1a4c36336f303477$export$c7b3bc714f32d7a9 = (profileId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/${profileId}/shares`);
};
const $1a4c36336f303477$export$80c41221f92ef9be = (shareId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/deviceProfile/shares/${shareId}/disable`, null);
};
const $1a4c36336f303477$export$e5888858f383ec64 = (shareAccessCode)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/deviceProfile/shares/preview/${shareAccessCode}`);
};
const $1a4c36336f303477$export$827ad3bf4ce3bb83 = (shareAccessCode)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/shares/accept/${shareAccessCode}`, null);
};
const $1a4c36336f303477$export$8cf7ec95b3fb64ef = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/capabilityFacets`);
};
const $1a4c36336f303477$export$d12f355dc16ebf93 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user/CapabilitySettings`);
};
const $1a4c36336f303477$export$78668e730a02e76 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/CapabilitySettings`, request);
};
const $1a4c36336f303477$export$8fe3f057eebad1bc = (request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/deviceProfile/generate`, request);
};
const $1a4c36336f303477$export$e212b208cbec5050 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/SystemNotifications/scoped/all`);
};
const $1a4c36336f303477$export$1cfb7ff6a4b15ea = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/SystemNotifications/scoped/unread`);
};
const $1a4c36336f303477$export$49199adf1afcc108 = (notificationId)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/SystemNotifications/${notificationId}/read`, null);
};
const $1a4c36336f303477$export$f4d031e4baefbd82 = (notification)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/SystemNotifications/scoped`, notification);
};
const $1a4c36336f303477$export$7320d6eeb2c8ac54 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/emailPreferences`, request);
};
const $1a4c36336f303477$export$2a6c232d8be225a8 = (request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/UserPreferences`, request);
};
const $1a4c36336f303477$export$ae3f5fa351e2f57a = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)('/api/user/UserPreferences');
};
const $1a4c36336f303477$export$3c6d5a5870f12c81 = (locale)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/user/AppInterfaceControls?locale=${locale}`);
};
const $1a4c36336f303477$export$1ac6c99dd884ccad = (interfaceControl, locale)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/user/AppInterfaceControls?locale=${locale}`, interfaceControl);
};
const $1a4c36336f303477$export$a751a00626fa5d99 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/Scope`);
};
const $1a4c36336f303477$export$760587335e9aead6 = (inviteCode)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/invitation/accept?inviteCode=${inviteCode}`, null);
};
const $1a4c36336f303477$export$bc4193cb9cb5ffbf = (inviteCode)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/invitation/reject?inviteCode=${inviteCode}`, null);
};
const $1a4c36336f303477$export$723853a93f25bfc8 = (invitationId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/invitation/${invitationId}`);
};
const $1a4c36336f303477$export$ca73d6dfa029e755 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/invite`, request);
};
const $1a4c36336f303477$export$7e61d855c21d0cf9 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}`);
};
const $1a4c36336f303477$export$9fa0549694b5b397 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/members`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$e826230d7947b0b6 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/joined`);
};
const $1a4c36336f303477$export$99736a1ab639617d = (organizationMemberId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/members/${organizationMemberId}`);
};
const $1a4c36336f303477$export$f49c5f59ccb70c7 = (organizationMemberId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/members/${organizationMemberId}`);
};
const $1a4c36336f303477$export$9e3347137373e17d = (organizationMemberId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/members/${organizationMemberId}`, request);
};
const $1a4c36336f303477$export$fc5cc62c84093276 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/invite`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$244d7766d2df1442 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/deviceProfiles`);
};
const $1a4c36336f303477$export$3f4430ea1068bd7f = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}`, request);
};
const $1a4c36336f303477$export$671500b18c6f825a = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}`);
};
const $1a4c36336f303477$export$3c51bcb045a4dcf7 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/authClients`);
};
const $1a4c36336f303477$export$1dd21c4331ea2afe = (organizationId, authClientId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/authClients/${authClientId}`);
};
const $1a4c36336f303477$export$882babc7ce0168b1 = (organizationId, authClientId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/authClients/${authClientId}`, request);
};
const $1a4c36336f303477$export$6273d0fdd20ec2b = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/authClients`, request);
};
const $1a4c36336f303477$export$fb8fa300ccf972f1 = (organizationId, authClientId)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/authClients/${authClientId}/rotateSecret`, null);
};
const $1a4c36336f303477$export$9d046100115f8eb6 = (organizationId, authClientId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/authClients/${authClientId}`);
};
const $1a4c36336f303477$export$1349a2482875cb46 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/deviceTypes`);
};
const $1a4c36336f303477$export$283d103ee023ff02 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}`, request);
};
const $1a4c36336f303477$export$56b000d2f0c12703 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/deviceTypes`, request);
};
const $1a4c36336f303477$export$564a73641b2b83a = (organizationId, deviceTypeId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}`);
};
const $1a4c36336f303477$export$b7d20456d96f632 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/throttleRules`, request);
};
const $1a4c36336f303477$export$fa9b0f7297241009 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/customControls`, request);
};
const $1a4c36336f303477$export$ae6dfd1cb318a3be = (organizationId, deviceTypeId, locale, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/customControls?locale=${locale}`, request);
};
const $1a4c36336f303477$export$f942174137d3f696 = (organizationId, deviceTypeId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/clientListings`);
};
const $1a4c36336f303477$export$a1d716d9f71fe1c5 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/clientListings`, request);
};
const $1a4c36336f303477$export$2fbd549f3e7afb42 = (organizationId, deviceTypeId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/deviceTypes/${deviceTypeId}/clientListings`, request);
};
const $1a4c36336f303477$export$3459b02a7394388f = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/managedLicenseKeys`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$c9479eea2fe9bdb4 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/managedLicenseKeys/available`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$9b109560db3e5fa8 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/managedLicenseKeys/used`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$c2666d621521d258 = (organizationId, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/managedOrganizations`);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$cbe92e1dd502f37 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/managedOrganizations`, request);
};
const $1a4c36336f303477$export$e8e91c27f56f2528 = (organizationId, managedOrgId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/managedOrganizations/${managedOrgId}/billing/link`);
};
const $1a4c36336f303477$export$e57608268c048777 = (organizationId, locale, search)=>{
    const url = (0, $13d0c8a27a7be22f$export$6b17a39e52c8ee53)(search !== null && search !== void 0 ? search : {}, `/api/organization/${organizationId}/products`, locale);
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(url);
};
const $1a4c36336f303477$export$8c8a9832b60f1887 = (organizationId, productId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/products/${productId}/link`);
};
const $1a4c36336f303477$export$520abd51d5e65c96 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/members/me`);
};
const $1a4c36336f303477$export$f7fea89e235b5345 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/memberships`);
};
const $1a4c36336f303477$export$8c7a465b3f0d49dd = (organizationId, trialId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/trial/${trialId}/upgradeLink`);
};
const $1a4c36336f303477$export$912fe73bbf623b0f = (organizationId, trialId, productId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/trial/${trialId}/upgradeLink/product/${productId}`);
};
const $1a4c36336f303477$export$dabcd4edef40b727 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/billing/link`);
};
const $1a4c36336f303477$export$7c5bc9294ee86597 = (organizationId, productId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/billing/link/product/${productId}`);
};
const $1a4c36336f303477$export$a465a1c9c4acd44f = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/automationRules`);
};
const $1a4c36336f303477$export$f242f627e9439409 = (organizationId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/automationRules/member`);
};
const $1a4c36336f303477$export$26cbfe4feb76f571 = (organizationId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/automationRules/${ruleId}`);
};
const $1a4c36336f303477$export$fb336c06cd332913 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/automationRules`, request);
};
const $1a4c36336f303477$export$79317fff3103dbad = (organizationId, ruleId, request)=>{
    return (0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/organization/${organizationId}/automationRules/${ruleId}`, request);
};
const $1a4c36336f303477$export$2a08cd7e8e594692 = (organizationId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/automationRules/${ruleId}`);
};
const $1a4c36336f303477$export$b9df2887c5fea5c = (organizationId, organizationMemberId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/organization/${organizationId}/members/${organizationMemberId}/automationRules/${ruleId}`, null);
};
const $1a4c36336f303477$export$ba7b32392a99780c = (organizationId, organizationMemberId, ruleId)=>{
    return (0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/organization/${organizationId}/members/${organizationMemberId}/automationRules/${ruleId}`);
};
const $1a4c36336f303477$export$a6f9b5388d528cec = (organizationId, organizationMemberId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/organization/${organizationId}/members/${organizationMemberId}/automationRules`);
};
const $1a4c36336f303477$export$2e4ad76cf0d49052 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/License/products/public`);
};
const $1a4c36336f303477$export$dd3c078d2eaaeb12 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/genai`);
};
const $1a4c36336f303477$export$3004a9a7f8c0092f = (params)=>{
    const queryParams = new URLSearchParams();
    if (params.ramMb != null) queryParams.set('ramMb', String(params.ramMb));
    if (params.hasGpu != null) queryParams.set('hasGpu', String(params.hasGpu));
    if (params.hasNpu != null) queryParams.set('hasNpu', String(params.hasNpu));
    if (params.gpuType) queryParams.set('gpuType', params.gpuType);
    if (params.npuType) queryParams.set('npuType', params.npuType);
    if (params.vramMb != null) queryParams.set('vramMb', String(params.vramMb));
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/genai/available?${queryParams.toString()}`);
};
const $1a4c36336f303477$export$1bdc0cd6d1410276 = (params)=>{
    const queryParams = new URLSearchParams();
    if (params.ramMb != null) queryParams.set('ramMb', String(params.ramMb));
    if (params.hasGpu != null) queryParams.set('hasGpu', String(params.hasGpu));
    if (params.hasNpu != null) queryParams.set('hasNpu', String(params.hasNpu));
    if (params.gpuType) queryParams.set('gpuType', params.gpuType);
    if (params.npuType) queryParams.set('npuType', params.npuType);
    if (params.vramMb != null) queryParams.set('vramMb', String(params.vramMb));
    if (params.inferencePlatform) queryParams.set('inferencePlatform', params.inferencePlatform);
    if (params.fileFormat) queryParams.set('fileFormat', params.fileFormat);
    // Returns ALL models for the platform/format (not just runnable ones); each model carries
    // `isAvailableForDevice` so the UI can show what this device can run vs. what a more
    // capable device could.
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/genai/families?${queryParams.toString()}`);
};
const $1a4c36336f303477$export$4f1930389137b6da = (request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/License/activate`, request);
};
const $1a4c36336f303477$export$68ccee5da54c27c3 = (organizationId, request)=>{
    return (0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/License/activate/${organizationId}`, request);
};
const $1a4c36336f303477$export$18169adbba1e88bc = (licenseKey)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/License/validate/${licenseKey}`);
};
const $1a4c36336f303477$export$4e97a7883c500e67 = (organizationId, licenseKey)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/License/validate/${organizationId}/${licenseKey}`);
};
const $1a4c36336f303477$export$5a3de2615974c687 = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/voice`);
};
const $1a4c36336f303477$export$f97d6f9131c89174 = (modelId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/voice/${modelId}`);
};
const $1a4c36336f303477$export$78ac26d691c779f4 = (locale, fileFormat)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/voice/locale/${locale}?fileFormat=${fileFormat}`);
};
const $1a4c36336f303477$export$1ac08db9e5a63db = ()=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/vision`);
};
const $1a4c36336f303477$export$9f3370c4c207cc54 = (modelId)=>{
    return (0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/ModelReference/vision/${modelId}`);
};



const $4c9078e3f4d4e7ac$export$fec487fd88f90673 = 'left_eyebrow_raise';
const $4c9078e3f4d4e7ac$export$e29bd3f870e59532 = 'right_eyebrow_raise';
const $4c9078e3f4d4e7ac$export$1bcbc534e3cad6ca = 'eyebrows_raised';
const $4c9078e3f4d4e7ac$export$8c373650910b3bac = 'left_eyebrow_lower';
const $4c9078e3f4d4e7ac$export$5e8f0e6a41a5a9f0 = 'right_eyebrow_lower';
const $4c9078e3f4d4e7ac$export$ae6877785f945029 = 'eyebrows_lower';
const $4c9078e3f4d4e7ac$export$8bc8e7800890a14c = 'smile';
const $4c9078e3f4d4e7ac$export$81ed1df06f5efbb1 = 'stop_smile';
const $4c9078e3f4d4e7ac$export$964c1b24697b74c8 = 'mouth_open';
const $4c9078e3f4d4e7ac$export$5aa1ceccf76c493d = 'mouth_close';
const $4c9078e3f4d4e7ac$export$e9fd9bbd349f12e = 'mouth_pucker';
const $4c9078e3f4d4e7ac$export$c9933241f376f0db = 'left_eye_close';
const $4c9078e3f4d4e7ac$export$743a943ffb348687 = 'right_eye_close';
const $4c9078e3f4d4e7ac$export$eca640d50ff796d5 = 'left_eye_open';
const $4c9078e3f4d4e7ac$export$a938ee9b6fd7a635 = 'right_eye_open';
const $4c9078e3f4d4e7ac$export$7f9a6c987783536c = 'both_eyes_close';
const $4c9078e3f4d4e7ac$export$a903f8481631e4eb = 'both_eyes_open';
const $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf = [
    $4c9078e3f4d4e7ac$export$fec487fd88f90673,
    $4c9078e3f4d4e7ac$export$e29bd3f870e59532,
    $4c9078e3f4d4e7ac$export$1bcbc534e3cad6ca,
    $4c9078e3f4d4e7ac$export$8c373650910b3bac,
    $4c9078e3f4d4e7ac$export$5e8f0e6a41a5a9f0,
    $4c9078e3f4d4e7ac$export$ae6877785f945029,
    $4c9078e3f4d4e7ac$export$8bc8e7800890a14c,
    $4c9078e3f4d4e7ac$export$81ed1df06f5efbb1,
    $4c9078e3f4d4e7ac$export$964c1b24697b74c8,
    $4c9078e3f4d4e7ac$export$5aa1ceccf76c493d,
    $4c9078e3f4d4e7ac$export$c9933241f376f0db,
    $4c9078e3f4d4e7ac$export$743a943ffb348687,
    $4c9078e3f4d4e7ac$export$eca640d50ff796d5,
    $4c9078e3f4d4e7ac$export$a938ee9b6fd7a635,
    $4c9078e3f4d4e7ac$export$7f9a6c987783536c,
    $4c9078e3f4d4e7ac$export$a903f8481631e4eb
];
const $4c9078e3f4d4e7ac$var$createFaceCommand = (value, title, description)=>{
    return {
        value: value,
        title: title,
        description: description
    };
};
const $4c9078e3f4d4e7ac$export$66556ffb0952dbd1 = [
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$8bc8e7800890a14c, 'common:expression.startSmiling.title', 'common:expression.startSmiling.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$81ed1df06f5efbb1, 'common:expression.stopSmiling.title', 'common:expression.stopSmiling.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$1bcbc534e3cad6ca, 'common:expression.eyebrows.title', 'common:expression.eyebrows.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$964c1b24697b74c8, 'common:expression.openMouth.title', 'common:expression.openMouth.description'),
    $4c9078e3f4d4e7ac$var$createFaceCommand($4c9078e3f4d4e7ac$export$5aa1ceccf76c493d, 'common:expression.closeMouth.title', 'common:expression.closeMouth.description')
];


const $36ef3dc0587051fc$export$d94f9a81f26f28d7 = 'head_tilt_left';
const $36ef3dc0587051fc$export$4c0c3d8967111e99 = 'head_tilt_right';
const $36ef3dc0587051fc$export$cb516a1825b74c73 = 'head_tilt_back';
const $36ef3dc0587051fc$export$51b0ed0abf71f56b = 'head_tilt_forward';
const $36ef3dc0587051fc$export$ce9364ff9e3ce20f = 'head_turn_left';
const $36ef3dc0587051fc$export$97a51662dd806ec0 = 'head_turn_right';
const $36ef3dc0587051fc$export$e20c154cab65adce = 'head_lean_left';
const $36ef3dc0587051fc$export$520abd32623264d3 = 'head_lean_right';
const $36ef3dc0587051fc$export$78319fa5fd133058 = 'head_lean_back';
const $36ef3dc0587051fc$export$18c969b8ac64ef37 = 'head_lean_forward';
const $36ef3dc0587051fc$export$9a70b70b3792325c = 'head_move_up';
const $36ef3dc0587051fc$export$c9a7f673431c7a0f = 'head_move_down';
const $36ef3dc0587051fc$export$6a9d09a2b2e2f93f = 'head_center';
const $36ef3dc0587051fc$export$b83c6ea936a344b9 = [
    $36ef3dc0587051fc$export$d94f9a81f26f28d7,
    $36ef3dc0587051fc$export$4c0c3d8967111e99,
    $36ef3dc0587051fc$export$cb516a1825b74c73,
    $36ef3dc0587051fc$export$51b0ed0abf71f56b,
    $36ef3dc0587051fc$export$ce9364ff9e3ce20f,
    $36ef3dc0587051fc$export$97a51662dd806ec0,
    $36ef3dc0587051fc$export$e20c154cab65adce,
    $36ef3dc0587051fc$export$520abd32623264d3,
    $36ef3dc0587051fc$export$78319fa5fd133058,
    $36ef3dc0587051fc$export$18c969b8ac64ef37,
    $36ef3dc0587051fc$export$c9a7f673431c7a0f,
    $36ef3dc0587051fc$export$9a70b70b3792325c,
    $36ef3dc0587051fc$export$6a9d09a2b2e2f93f
];
const $36ef3dc0587051fc$var$createHeadCommand = (value, title, description)=>{
    return {
        value: value,
        title: title,
        description: description
    };
};
const $36ef3dc0587051fc$export$d58460d69cd22e7b = [
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$d94f9a81f26f28d7, 'common:head.tilt.left.title', 'common:head.tilt.left.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$4c0c3d8967111e99, 'common:head.tilt.right.title', 'common:head.tilt.right.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$cb516a1825b74c73, 'common:head.tilt.back.title', 'common:head.tilt.back.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$51b0ed0abf71f56b, 'common:head.tilt.forward.title', 'common:head.tilt.forward.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$ce9364ff9e3ce20f, 'common:head.turn.left.title', 'common:head.turn.left.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$97a51662dd806ec0, 'common:head.turn.right.title', 'common:head.turn.right.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$78319fa5fd133058, 'common:head.lean.back.title', 'common:head.lean.back.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$18c969b8ac64ef37, 'common:head.lean.forward.title', 'common:head.lean.forward.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$e20c154cab65adce, 'common:head.lean.left.title', 'common:head.lean.left.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$520abd32623264d3, 'common:head.lean.right.title', 'common:head.lean.right.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$9a70b70b3792325c, 'common:head.lean.up.title', 'common:head.lean.up.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$c9a7f673431c7a0f, 'common:head.lean.down.title', 'common:head.lean.down.description'),
    $36ef3dc0587051fc$var$createHeadCommand($36ef3dc0587051fc$export$6a9d09a2b2e2f93f, 'common:head.lean.center.title', 'common:head.lean.center.description')
];




const $8b57d7f20ec64936$var$createExternalKeyboardCommand = (value, title, translationKey)=>{
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        value: value,
        title: title
    }, translationKey ? {
        translationKey: translationKey
    } : {}), {
        isExternalKeyboard: true
    });
};
const $8b57d7f20ec64936$export$2f33dbd1b958ee82 = [
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_backtick', '`'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_1', '1'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_2', '2'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_3', '3'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_4', '4'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_5', '5'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_6', '6'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_7', '7'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_8', '8'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_9', '9'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_0', '0'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_minus', '-'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_equal', '='),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_backspace', 'Backspace', 'common:keys.backspace'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_delete', 'Delete'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_tab', 'Tab'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_q', 'q'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_w', 'w'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_e', 'e'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_r', 'r'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_t', 't'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_y', 'y'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_u', 'u'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_i', 'i'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_o', 'o'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_p', 'p'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_leftbrace', '['),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_rightbrace', ']'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_capslock', 'Caps', 'common:keys.caps'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_a', 'a'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_s', 's'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_d', 'd'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f', 'f'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_g', 'g'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_h', 'h'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_j', 'j'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_k', 'k'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_l', 'l'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_semicolon', ';'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_singlequote', "'"),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_enter', 'Enter', 'common:keys.enter'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_shift', 'Left Shift', 'common:keys.leftShift'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_z', 'z'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_x', 'x'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_c', 'c'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_v', 'v'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_b', 'b'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_n', 'n'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_m', 'm'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_comma', ','),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_period', '.'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_slash', '/'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_controls', 'Left Ctrl', 'common:keys.leftCtrl'),
    //createExternalKeyboardCommand("fn"),
    //createExternalKeyboardCommand("keyboard_windows", "win"),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_command', 'Command', 'common:keys.command'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_alt', 'Left Alt', 'common:keys.leftAlt'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_space', 'Space Bar', 'common:keys.space'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_left', 'Left Arrow', 'common:keys.left'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_up', 'Up Arrow'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_down', 'Down Arrow'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_right', 'Right Arrow'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_tilde', '~'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_at', '@'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_pound', '#'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_dollar', '$'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_percent', '%'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_caret', '^'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_ampersand', '&'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_asterisk', '*'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_leftparenthesis', '('),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_rightparenthesis', ')'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_underscore', '_'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_plus', '+'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_leftbracket', '{'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_rightbracket', '}'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_backslash', '\\'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_pipe', '|'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_colon', ':'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_quote', '"'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_lessthan', '<'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_greaterthan', '>'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_question', '?'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_escape', 'Escape'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f1', 'F1'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f2', 'F2'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f3', 'F3'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f4', 'F4'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f5', 'F5'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f6', 'F6'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f7', 'F7'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f8', 'F8'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f9', 'F9'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f10', 'F10'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f11', 'F11'),
    $8b57d7f20ec64936$var$createExternalKeyboardCommand('keyboard_f12', 'F12')
];


const $404e806b46f153e3$export$46f94b06a762d5ba = 'tiltleft';
const $404e806b46f153e3$export$6f9656353bf603ba = 'tiltright';
const $404e806b46f153e3$export$7d85f18c9dd87007 = 'tiltdown';
const $404e806b46f153e3$export$41960994f2211016 = 'tiltup';
const $404e806b46f153e3$export$8f4f878545c604f9 = 'shake';
const $404e806b46f153e3$export$27ae0cf28d39b9f3 = [
    $404e806b46f153e3$export$8f4f878545c604f9,
    $404e806b46f153e3$export$41960994f2211016,
    $404e806b46f153e3$export$7d85f18c9dd87007,
    $404e806b46f153e3$export$6f9656353bf603ba,
    $404e806b46f153e3$export$46f94b06a762d5ba
];
const $404e806b46f153e3$export$26e9961207366bf5 = (command)=>$404e806b46f153e3$export$27ae0cf28d39b9f3.indexOf(command) > -1;
const $404e806b46f153e3$var$createTiltCommand = (value, title, description)=>{
    return {
        value: value,
        title: title,
        description: description
    };
};
const $404e806b46f153e3$export$11fae295fa56fc7a = [
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$41960994f2211016, 'common:motion.up.title', 'common:motion.up.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$7d85f18c9dd87007, 'common:motion.down.title', 'common:motion.down.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$46f94b06a762d5ba, 'common:motion.left.title', 'common:motion.left.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$6f9656353bf603ba, 'common:motion.right.title', 'common:motion.right.description'),
    $404e806b46f153e3$var$createTiltCommand($404e806b46f153e3$export$8f4f878545c604f9, 'common:motion.shake.title', 'common:motion.shake.description')
];


const $f44f3a5bc46b1c4c$export$57362fc655624cdd = [
    ...(0, $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf),
    ...(0, $36ef3dc0587051fc$export$b83c6ea936a344b9)
];
const $f44f3a5bc46b1c4c$export$5c8cf246d7d853ae = (command)=>$f44f3a5bc46b1c4c$export$57362fc655624cdd.indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$8f4c3955f61548f = (command)=>(0, $404e806b46f153e3$export$27ae0cf28d39b9f3).indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$3ef50a29b2ee6c06 = (command)=>(0, $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf).indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$f5a21b27ff68bc03 = (command)=>(0, $36ef3dc0587051fc$export$b83c6ea936a344b9).indexOf(command) > -1;
const $f44f3a5bc46b1c4c$export$dca0f63ee9e3d900 = (command)=>(command === null || command === void 0 ? void 0 : command.startsWith('hotkey')) == true;
const $f44f3a5bc46b1c4c$export$5417e47c2f21e675 = (command)=>(command === null || command === void 0 ? void 0 : command.startsWith('mouse_move')) == true;
const $f44f3a5bc46b1c4c$export$946f15e1943cbe85 = (command)=>(command === null || command === void 0 ? void 0 : command.startsWith('joystick_move')) == true;
const $f44f3a5bc46b1c4c$export$152edcbfa0aee749 = (command)=>(command === null || command === void 0 ? void 0 : command.startsWith('keyboard_')) == true;
const $f44f3a5bc46b1c4c$export$8c2b4826af6cc511 = 'stop_all_outputs';
const $f44f3a5bc46b1c4c$export$b617c310e3426257 = 'hotkey_';
const $f44f3a5bc46b1c4c$export$2edc7d5e93b11fea = 'mouse_move';
const $f44f3a5bc46b1c4c$export$5c5d516f10138ecd = ()=>(0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039).t('common:event.mouseMove.commandLabel');
const $f44f3a5bc46b1c4c$export$9eb602ebf7336a9a = ()=>(0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039).t('common:event.mouseMove.startCommand');
const $f44f3a5bc46b1c4c$export$62c4a01fc6ffed62 = ()=>(0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039).t('common:event.mouseMove.stopCommand');
const $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df = (command)=>{
    if ($f44f3a5bc46b1c4c$export$3ef50a29b2ee6c06(command)) return 'expression';
    if ($f44f3a5bc46b1c4c$export$f5a21b27ff68bc03(command)) return 'head';
    if ($f44f3a5bc46b1c4c$export$8f4c3955f61548f(command)) return 'tilt';
    if ($f44f3a5bc46b1c4c$export$dca0f63ee9e3d900(command)) return 'hotkey';
    if ($f44f3a5bc46b1c4c$export$152edcbfa0aee749(command)) return 'external_keyboard';
    if (command.includes('_')) return 'other';
    return 'voice';
};
const $f44f3a5bc46b1c4c$export$6c5a93cb3986a928 = [
    'voice',
    'head',
    'expression',
    'hotkey',
    'other'
];
const $f44f3a5bc46b1c4c$export$31469898f99e9a2 = {
    hotkey: {
        title: 'common:hotkey.titlePanel',
        description: 'common:hotkey.description',
        question: 'common:hotkey.question',
        icon: 'virtualButton',
        alt: 'Virtual Buttons'
    },
    //TODO: we need to double check this spoken was used for voice controls in some places but not others
    spoken: {
        title: 'common:talkback.title',
        description: 'common:talkback.description',
        question: 'common:talkback.question',
        icon: 'speaker',
        alt: 'Talkback'
    },
    voice: {
        title: 'common:voice.titlePlural',
        description: 'common:voice.description',
        question: 'common:voice.question',
        icon: 'voiceControl',
        alt: 'Voice Control'
    },
    expression: {
        title: 'common:expression.titlePlural',
        description: 'common:expression.description',
        question: 'common:face.question',
        icon: 'faceExpression',
        alt: 'Facial Expression Control'
    },
    head: {
        title: 'common:head.titlePlural',
        description: 'common:head.description',
        question: 'common:head.question',
        icon: 'headMovement',
        alt: 'Head Movement Control'
    },
    tilt: {
        title: 'common:motion.titlePlural',
        description: 'common:motion.description',
        question: 'common:motion.question',
        icon: 'motionControl',
        alt: 'Motion Control'
    },
    //TODO: We need to double check this - I believe this is Remap Keyboard and not Virtual Buttons (hotkeys)
    external_keyboard: {
        title: 'common:keys.titlePlural',
        description: 'common:keys.description',
        question: 'common:keys.question',
        icon: 'virtualButton',
        alt: 'Keys & Buttons'
    },
    //TODO: We need to double check this - I believe this is a dupe of Tilt
    motion: {
        title: 'common:motion.titlePlural',
        description: 'common:motion.description',
        question: 'common:motion.question',
        icon: 'motionControl',
        alt: 'Motion Control'
    },
    dictation: {
        title: 'common:dictation.title',
        description: 'common:dictation.description',
        question: 'common:dictation.question',
        icon: 'dictationPlay',
        alt: 'Dictation Control'
    },
    //TODO: Practically speaking, this is the same as voice but it is treated distinctly elsewhere. We might need to change how we assign voice and other -- e.g. check for underscore and not associated with other commandtypes
    other: {
        title: 'common:other.title',
        description: 'common:other.description',
        question: 'common:other.question',
        icon: 'voiceControl',
        alt: 'Other Control'
    },
    smartTasks: {
        title: 'common:smartTasks.title',
        description: 'common:smartTasks.description',
        question: 'common:smartTasks.title',
        icon: 'ai',
        alt: 'Smart Tasks Control'
    }
};
const $f44f3a5bc46b1c4c$export$6ed006bdf26d1b97 = (0, $404e806b46f153e3$export$11fae295fa56fc7a);
const $f44f3a5bc46b1c4c$export$f1577663de47cd5e = [
    ...(0, $36ef3dc0587051fc$export$d58460d69cd22e7b),
    ...(0, $4c9078e3f4d4e7ac$export$66556ffb0952dbd1)
];
const $f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f = (0, $8b57d7f20ec64936$export$2f33dbd1b958ee82);
const $f44f3a5bc46b1c4c$export$b47f0ea920cae9ed = (0, $36ef3dc0587051fc$export$d58460d69cd22e7b);
const $f44f3a5bc46b1c4c$export$c64c937c3a3522ea = (0, $4c9078e3f4d4e7ac$export$66556ffb0952dbd1);
const $f44f3a5bc46b1c4c$export$48c02457e332140e = [
    ...$f44f3a5bc46b1c4c$export$6ed006bdf26d1b97,
    ...$f44f3a5bc46b1c4c$export$f1577663de47cd5e,
    ...$f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f
];
const $f44f3a5bc46b1c4c$export$72d891864ef26d3d = (command)=>{
    if (!command) return null;
    if (command.startsWith('mouse_move')) return 'mouse';
    if ($f44f3a5bc46b1c4c$export$c64c937c3a3522ea.find((c)=>c.value == command)) return 'faceExpression';
    if ($f44f3a5bc46b1c4c$export$b47f0ea920cae9ed.find((c)=>c.value == command)) return 'headMovement';
    if ($f44f3a5bc46b1c4c$export$6ed006bdf26d1b97.find((c)=>c.value == command)) return 'motionControl';
    if ($f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f.find((c)=>c.value == command)) return 'keyboard';
    if (command.startsWith($f44f3a5bc46b1c4c$export$b617c310e3426257)) return 'virtualButton';
    return 'voiceControl';
};


const $14e4f1609944ac39$export$18d6475ce2e9bfe8 = 'main-content';
const $14e4f1609944ac39$export$53ee1da10d1b10bc = 'swap-profile';
const $14e4f1609944ac39$export$a9a172bf96c7a4ed = 'profile-name-input';
const $14e4f1609944ac39$export$78fc16d191511ade = 'profile-conflict-indicators';
const $14e4f1609944ac39$export$3bb7f768b4d19e3a = 'panel-composer-input';
const $14e4f1609944ac39$export$a69706f15b935dce = 'workflow-continuation-textarea';



function $eeb1a4bb5a11a603$export$894a92ec5bebf83(locale) {
    return (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).voice.includes(locale);
}
function $eeb1a4bb5a11a603$export$5aa7fdaae13057ac(locale) {
    if ($eeb1a4bb5a11a603$export$894a92ec5bebf83(locale)) return `common:localization.locales.${locale}`;
    return 'common:localization.unsupported.title';
}
const $eeb1a4bb5a11a603$export$d44f5da3b0eb939f = (locale)=>{
    return locale.toLowerCase().split('-')[0];
};
const $eeb1a4bb5a11a603$export$e88b669f03544b69 = (locale, variant)=>{
    let result = null;
    if (locale) {
        const localeOptions = (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed)[variant];
        const localeLower = locale.toLowerCase();
        const languageOnly = $eeb1a4bb5a11a603$export$d44f5da3b0eb939f(locale);
        if (localeOptions.includes(localeLower)) result = localeLower;
        else if (localeOptions.includes(languageOnly)) result = languageOnly;
        else if (localeLower.startsWith('en') && variant == 'voice') result = 'en-us'; // exception for English Voice because the base is en-us
    }
    return result;
};
const $eeb1a4bb5a11a603$export$635ddbacad8e65bf = (locale)=>{
    const language = $eeb1a4bb5a11a603$export$e88b669f03544b69(locale, 'voice');
    let result = (0, $3ecd3f7dea3d56de$export$e471f5ee496a5676)['en-us'];
    if (language) result = (0, $3ecd3f7dea3d56de$export$e471f5ee496a5676)[language];
    return result;
};



const $9a9874d925dad9cc$export$1042f3e960dd652b = (key, displayName, icon = 'keySpace', defaultCommand, alternateKeys = [], platform = 'generic')=>({
        commands: [
            {
                command: defaultCommand !== null && defaultCommand !== void 0 ? defaultCommand : key,
                commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(defaultCommand !== null && defaultCommand !== void 0 ? defaultCommand : key)
            }
        ],
        key: key,
        displayName: displayName !== null && displayName !== void 0 ? displayName : key,
        alternateKeys: alternateKeys,
        icon: icon,
        platform: platform
    });
const $9a9874d925dad9cc$export$e4e98b6e2a74daae = (model, locale, alternateKeys = [], platform)=>{
    const defaultKeyMapping = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale, platform);
    const keyMapping = defaultKeyMapping.find((v)=>v.key == model.key);
    var _keyMapping_displayName, _keyMapping_platform;
    return {
        commands: model.commands.map((c)=>({
                command: c,
                commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(c)
            })),
        key: model.key,
        displayName: (_keyMapping_displayName = keyMapping === null || keyMapping === void 0 ? void 0 : keyMapping.displayName) !== null && _keyMapping_displayName !== void 0 ? _keyMapping_displayName : model.key,
        alternateKeys: alternateKeys,
        icon: $9a9874d925dad9cc$export$fbe8b56204f00600(model.key, locale),
        platform: (_keyMapping_platform = keyMapping === null || keyMapping === void 0 ? void 0 : keyMapping.platform) !== null && _keyMapping_platform !== void 0 ? _keyMapping_platform : 'generic'
    };
};
const $9a9874d925dad9cc$export$d8fdbd751da3b492 = {
    en: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Mouse Button 1 (Left Click)', 'mouseLeftClick', 'click', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Mouse Button 2 (Right Click)', 'mouseRightClick', 'right click'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Mouse Button 3 (Middle Click)', 'mouseMiddleClick', 'middle click'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'one', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'two', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'three', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'four', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'five', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'six', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'seven', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'eight', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'nine', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'zero', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'a', 'keyA'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'b', 'keyB'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'c', 'keyC'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'd', 'keyD'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'e', 'keyE'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'f', 'keyF'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'g', 'keyG'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'h', 'keyH'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'i', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'j', 'keyJ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'k', 'keyK'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'l', 'keyL'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'm', 'keyM'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'n', 'keyN'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'o', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'p', 'keyP'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'q', 'keyQ', 'q'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'r', 'keyR'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 's', 'keyS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 't', 'keyT'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'u', 'keyU'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'v', 'keyV'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'w', 'keyW'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'x', 'keyX'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'y', 'keyY'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'z', 'keyZ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'underscore'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, 'dash', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'comma', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'semi colon'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, 'colin'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, 'question mark'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'period'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'quote'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, 'open parenthesis'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, 'close parenthesis'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'open brace'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, 'close brace'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'open bracket'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'close bracket'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, 'exclamation'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'at sign'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'asterisk', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'forward slash', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'backslash'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'ampersand'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'lb'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'percent'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, 'back tick'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, 'carrot'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', undefined, 'plus', [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'less than'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'equals'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'greater than'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'pipe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, 'dollar sign'),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'single quote'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Backspace', 'keyDelete', 'back space', [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Caps', 'keyCapsLock', 'caps lock', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', undefined, 'num lock', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Scroll Lock', undefined, 'scroll lock', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Command', 'keyCommand', 'command', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Right Command', 'keyCommand', 'right command', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Delete', 'keyDelete'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Down Arrow', 'keyPageDownButton', 'move down', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Left Arrow', 'keyHomeButton', 'move left', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Right Arrow', 'keyEndButton', 'move right', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Up Arrow', 'keyPageUpButton', 'move up', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Enter', 'keyEnterMac', 'enter', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Escape', 'keyEsc', 'escape', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Left Alt', 'keyAlt', 'alt', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Left Ctrl', 'keyCtrl', 'control', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Left Shift', 'shift', 'shift', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', 'option', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Right Ctrl', 'keyCtrl', 'right control'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Right Shift', 'shift', 'right shift'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Space Bar', 'keySpace', 'space', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', 'windows', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Function', 'keyFn', 'function', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, 'print screen', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, 'insert'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, 'home', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'end', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Page Up', undefined, 'page up', [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Page Down', undefined, 'page down', [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', 'num pad zero'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', 'num pad one'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', 'num pad two'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', 'num pad three'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', 'num pad four'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', 'num pad five'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', 'num pad six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', 'num pad seven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', 'num pad eight'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', 'num pad nine'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimal', 'keyDot', 'num pad decimal'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'function one'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'function two'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'function three'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'function four'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', 'function five'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'function six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'function seven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'function eight'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'function nine'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'function ten'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'function eleven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', 'function twelve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Mute Audio', undefined, 'mute audio', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', 'Volume Down', undefined, 'volume down', [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Up', undefined, 'volume up', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Play Audio', undefined, 'play audio', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Stop Audio', undefined, 'stop audio', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', undefined, 'pause audio', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Previous Track', undefined, 'previous track', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Next Track', undefined, 'next track', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Rewind Track', undefined, 'rewind track', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Forward Track', undefined, 'forward track', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Repeat Track', undefined, 'repeat track', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Shuffle Tracks', undefined, 'shuffle tracks', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', 'Controller Button 1 (A)', 'joystick', 'button one'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', 'Controller Button 2 (B)', 'joystick', 'button two'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', 'Controller Button 3 (X)', 'joystick', 'button three'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', 'Controller Button 4 (Y)', 'joystick', 'button four'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', 'Controller Button 5 (LB)', 'joystick', 'button five'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', 'Controller Button 6 (RB)', 'joystick', 'button six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', 'Controller Button 7 (LT)', 'joystick', 'button seven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', 'Controller Button 8 (RT)', 'joystick', 'button eight'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', 'Controller Button 9 (Options)', 'joystick', 'button nine'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', 'Controller Button 10 (Pause)', 'joystick', 'button ten'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', 'Controller Button 11 (L3)', 'joystick', 'button eleven'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', 'Controller Button 12 (R3)', 'joystick', 'button twelve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-Pad Up', 'joystick', 'direction up'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', 'Controller D-Pad Down', 'joystick', 'direction down'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-Pad Left', 'joystick', 'direction left'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-Pad Right', 'joystick', 'direction right')
    ],
    es: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', "Bot\xf3n 1 del Rat\xf3n (Clic Izquierdo)", 'mouseLeftClick', 'cliq', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', "Bot\xf3n 2 del Rat\xf3n (Clic Derecha)", 'mouseRightClick', 'cliq derecha'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', "Bot\xf3n 3 del Rat\xf3n (Clic Centro)", 'mouseMiddleClick', 'cliq centro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'uno', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'dos', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'tres', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'cuatro', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'cinco', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'seis', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'siete', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'ocho', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'nueve', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'cero', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'a', 'keyA'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'b', 'keyB', 'be'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'c', 'keyC', 'se'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'd', 'keyD', 'de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'e', 'keyE', 'eh'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'f', 'keyF', 'efe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'g', 'keyG', 'je'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'h', 'keyH', 'hace'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'i', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'j', 'keyJ', 'jota'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'k', 'keyK', 'ca'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'l', 'keyL', 'ele'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'm', 'keyM', 'eh me'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'n', 'keyN', 'en e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'o', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'p', 'keyP', 'pe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'q', 'keyQ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'r', 'keyR', 'eh rey'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 's', 'keyS', 'ese'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 't', 'keyT', 'te'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'u', 'keyU'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'v', 'keyV', 've'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'w', 'keyW', 'doble ve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'x', 'keyX', 'equis'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'y', 'keyY'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'z', 'keyZ', 'zeta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'guion bajo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, "gui\xf3n", [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'coma', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'punto y coma'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, 'colon'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, 'interrogante'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'punto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'comilla doble'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, "par\xe9ntesis abierto"),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, "par\xe9ntesis cerrado"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'corchete abierto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, 'corchete cerrado'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'llave abierto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'llave cerrado'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, "exclamaci\xf3n"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'signo de a'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'asterisco', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'barra inclinada', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'barra invertida'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'signo commercial'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', "signo de n\xfamero"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'por ciento'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, 'grave'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, "signo de intercalaci\xf3n"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keyPlus', "m\xe1s", [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'menos que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'igual'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'mas grande que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'linea vertical'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, "d\xf3lar"),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'comilla simple'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Backspace', 'keyDelete', 'retroceso', [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Caps', 'keyCapsLock', "bloq may\xfas", [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', undefined, 'bloqueo numerico', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Scroll Lock', undefined, 'bloqueo desplazamiento', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Command', 'keyCommand', 'command', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Right Command', 'keyCommand', 'command derecha', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Delete', 'keyDelete', 'borrar'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Flecha Abajo', 'keyPageDownButton', 'abajo', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Flecha Izquierdo', 'keyHomeButton', 'izquierda', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Flecha Derecha', 'keyEndButton', 'derecha', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Flecha Arriba', 'keyPageUpButton', 'arriba', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Enter', 'keyEnterMac', 'entrar', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Esc', 'keyEsc', 'escapar', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Alt Izquierda', 'keyAlt', 'alt', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Ctrl Izquierda', 'keyCtrl', 'control', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Shift Izquierda', 'shift', 'cambio', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', "opci\xf3n", [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Ctrl Derecha', 'keyCtrl', 'control derecha'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Shift Derecha', 'shift', 'cambio derecha'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Espacio', 'keySpace', 'espacio', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', "pesta\xf1a"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Win', 'keyWindows', 'windows', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Function', 'keyFn', "funci\xf3n", [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, 'imprimir pantalla', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, 'insertar'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, 'inicio', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'finalizar', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Page Up', undefined, "p\xe1gina arriba", [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Page Down', undefined, "p\xe1gina abajo", [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', "n\xfamero cero"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', "n\xfamero uno"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', "n\xfamero dos"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', "n\xfamero tres"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', "n\xfamero cuatro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', "n\xfamero cinco"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', "n\xfamero seis"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', "n\xfamero siete"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', "n\xfamero ocho"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', "n\xfamero nueve"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimal', 'keyDot', "n\xfamero decimal"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', "funci\xf3n uno"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', "funci\xf3n dos"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', "funci\xf3n tres"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', "funci\xf3n cuatro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', "funci\xf3n cinco"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', "funci\xf3n seis"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', "funci\xf3n siete"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', "funci\xf3n ocho"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', "funci\xf3n nueve"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', "funci\xf3n diez"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', "funci\xf3n once"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', "funci\xf3n doce"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Mute Audio', undefined, 'silenciar', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', 'Volume Down', undefined, 'baja volumen', [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Up', undefined, 'sube volumen', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Play Audio', undefined, 'reproduce audio', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Stop Audio', undefined, 'detener audio', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', undefined, 'pausa audio', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Previous Track', undefined, 'pista anterior', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Next Track', undefined, 'siguiente pista', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Rewind Track', undefined, 'rebobinar pista', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Forward Track', undefined, 'avance pista', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Repeat Track', undefined, 'repita', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Shuffle Tracks', undefined, 'aleatoriamente pistas', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', "Bot\xf3n 1 del Controlador (A)", 'joystick', "bot\xf3n uno"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', "Bot\xf3n 2 del Controlador (B)", 'joystick', "bot\xf3n dos"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', "Bot\xf3n 3 del Controlador (X)", 'joystick', "bot\xf3n tres"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', "Bot\xf3n 4 del Controlador (Y)", 'joystick', "bot\xf3n cuatro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', "Bot\xf3n 5 del Controlador (LB)", 'joystick', "bot\xf3n cinco"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', "Bot\xf3n 6 del Controlador (RB)", 'joystick', "bot\xf3n seis"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', "Bot\xf3n 7 del Controlador (LT)", 'joystick', "bot\xf3n siete"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', "Bot\xf3n 8 del Controlador (RT)", 'joystick', "bot\xf3n ocho"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', "Bot\xf3n 8 del Controlador (Options)", 'joystick', "bot\xf3n nueve"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', "Bot\xf3n 10 del Controlador (Pause)", 'joystick', "bot\xf3n diez"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', "Bot\xf3n 11 del Controlador (L3)", 'joystick', "bot\xf3n once"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', "Bot\xf3n 12 del Controlador(R3)", 'joystick', "bot\xf3n doce"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-Pad Arriba', 'joystick', "direcci\xf3n arriba"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', 'Controller D-Pad Abajo', 'joystick', "direcci\xf3n abajo"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-Pad Izquierda', 'joystick', "direcci\xf3n izquierda"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-Pad Derecha', 'joystick', "direcci\xf3n derecha")
    ],
    fr: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Bouton 1 de la Souris (Clic Gauche)', 'mouseLeftClick', 'cliquez', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Bouton 2 de la Souris (Clic Droit)', 'mouseRightClick', 'cli droit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Bouton 3 de la Souris (Clic Central)', 'mouseMiddleClick', 'clic central'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'un', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'deux', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'trois', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'quatre', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'cinq', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'six', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'sept', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'huit', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'neuf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', "z\xe9ro", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'a', 'keyA', 'a'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'b', 'keyB'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'c', 'keyC'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'd', 'keyD'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'e', 'keyE'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'f', 'keyF', 'effe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'g', 'keyG'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'h', 'keyH', 'hache'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'i', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'j', 'keyJ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'k', 'keyK', 'ca'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'l', 'keyL'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'm', 'keyM', 'eh me'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'n', 'keyN', 'en e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'o', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'p', 'keyP', 'pe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'q', 'keyQ', 'qu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'r', 'keyR', 'eh re'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 's', 'keyS', 'ese'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 't', 'keyT', 'te'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'u', 'keyU', 'u'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'v', 'keyV', 've'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'w', 'keyW', 'doble ve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'x', 'keyX', 'ics'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'y', 'keyY', 'i grec'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'z', 'keyZ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'souligner'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, 'tiret', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'virgule', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'point virgule'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, "c\xf4lon"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, "point d'interrogation"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', "p\xe9riode"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'citation'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, "parenth\xe8se ouverte"),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, "fermer la parenth\xe8se"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'accolade ouverte'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, "fermer \u013Eaccolade"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'crochet ouvert'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'fermer le crochet'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, 'exclamation'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'arobase'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', "ast\xe9risque", [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'barre oblique', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'barre oblique inverse'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'esperluette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'hash tag'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'pour cent'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, "tique arri\xe8r"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, 'carotte'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keyPlus', 'plus'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'moins que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', "est \xe9gal \xe0"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'plus grand que'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'tuyau'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, 'signe dollar'),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'guillemet simple'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Backspace', 'keyDelete', "retour arri\xe8re", [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Caps', 'keyCapsLock', 'verrouillage des majuscules', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', undefined, "verrouillage num\xe9rique", [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Scroll Lock', undefined, "verrouillage du d\xe9filement", [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Command', 'keyCommand', 'commande', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Right Command', 'keyCommand', 'commande droite', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Delete', 'keyDelete', 'supprimer'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Down Arrow', 'keyPageDownButton', 'descendre', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Left Arrow', 'keyHomeButton', 'gauche', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Right Arrow', 'keyEndButton', 'droite', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Up Arrow', 'keyPageUpButton', 'monter', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Enter', 'keyEnterMac', 'entrer', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Escape', 'keyEsc', "s\xe9chapper", [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Left Alt', 'keyAlt', 'alt', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Left Ctrl', 'keyCtrl', "contr\xf4le", [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Left Shift', 'shift', 'changement', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', 'option', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Right Ctrl', 'keyCtrl', "contr\xf4le droit"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Right Shift', 'shift', 'changement droit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Space Bar', 'keySpace', 'espace', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', 'languette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', "fen\xeatres", [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Function', 'keyFn', 'fonction', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, "\xe9cran d'impression", [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, "ins\xe9rer"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, "d'accueil", [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'fin', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Page Up', undefined, "page pr\xe9c\xe9dente", [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Page Down', undefined, 'page suivante', [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', "pav\xe9 num\xe9rique z\xe9ro"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', "pav\xe9 num\xe9rique un"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', "pav\xe9 num\xe9rique deux"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', "pav\xe9 num\xe9rique trois"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', "pav\xe9 num\xe9rique quatre"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', "pav\xe9 num\xe9rique cinq"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', "pav\xe9 num\xe9rique six"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', "pav\xe9 num\xe9rique sept"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', "pav\xe9 num\xe9rique huit"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', "pav\xe9 num\xe9rique neuf"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimal', 'keyDot', "pav\xe9 num\xe9rique d\xe9cimal"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'fonction un'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'fonction deux'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'fonction trois'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'fonction quatre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', 'fonction cinq'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'fonction six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'fonction sept'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'fonction huit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'fonction neuf'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'fonction dix'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'fonction onze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', 'fonction douze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Mute Audio', undefined, 'couper son', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', 'Volume Down', undefined, 'baisser volume', [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Up', undefined, 'augmenter volume', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Play Audio', undefined, 'lire son', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Stop Audio', undefined, "arr\xeater son", [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', undefined, 'mettre son pause', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Previous Track', undefined, "piste pr\xe9c\xe9dente", [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Next Track', undefined, 'piste suivante', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Rewind Track', undefined, 'rembobiner piste', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Forward Track', undefined, 'piste avant', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Repeat Track', undefined, "r\xe9p\xe9ter piste", [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Shuffle Tracks', undefined, "m\xe9langer pistes", [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', "Bouton du Contr\xf4leur 1 (A)", 'joystick', 'bouton un'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', "Bouton du Contr\xf4leur 2 (B)", 'joystick', 'bouton deux'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', "Bouton du Contr\xf4leur 3 (X)", 'joystick', 'bouton trois'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', "Bouton du Contr\xf4leur 4 (Y)", 'joystick', 'bouton quatre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', "Bouton du Contr\xf4leur 5 (LB)", 'joystick', 'bouton cinq'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', "Bouton du Contr\xf4leur 6 (RB)", 'joystick', 'bouton six'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', "Bouton du Contr\xf4leur 7 (LT)", 'joystick', 'bouton sept'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', "Bouton du Contr\xf4leur 8 (RT)", 'joystick', 'bouton huit'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', "Bouton du Contr\xf4leur 9 (Options)", 'joystick', 'bouton neuf'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', "Bouton du Contr\xf4leur 10 (Pause)", 'joystick', 'bouton dix'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', "Bouton du Contr\xf4leur 11 (L3)", 'joystick', 'bouton onze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', "Bouton du Contr\xf4leur 12 (R3)", 'joystick', 'bouton douze'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', "Contr\xf4leur D-Pad En Haut", 'joystick', 'direction vers haut'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', "Contr\xf4leur D-Pad Vers le Bas", 'joystick', 'direction vers bas'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', "Contr\xf4leur D-Pad Gauche", 'joystick', 'direction gauche'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', "Contr\xf4leur D-Pad Droit", 'joystick', "direction \xe0 droite")
    ],
    it: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Pulsante 1 Del Mouse (Clic Sinistro)', 'mouseLeftClick', 'clic', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Pulsante 2 Del Mouse (Clic Destro)', 'mouseRightClick', 'clic destro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Pulsante 3 Del Mouse (Clic Centrale)', 'mouseMiddleClick', 'clic centrale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'uno', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'due', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'tre', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'quattro', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', 'cinque', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'sei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'sette', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'otto', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'nove', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'zero', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'A', 'keyA'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'B', 'keyB', 'bi'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'C', 'keyC', 'si'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'D', 'keyD', 'di'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'E', 'keyE'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'F', 'keyF', 'efe'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'G', 'keyG', 'ji'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'H', 'keyH', 'acca'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'I', 'keyI'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'J', 'keyJ'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'K', 'keyK'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'L', 'keyL', 'ele'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'M', 'keyM', 'eh me'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'N', 'keyN', 'en e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'O', 'keyO'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'P', 'keyP', 'pi'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'Q', 'keyQ', 'cu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'R', 'keyR', 'eh re'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 'S', 'keyS', 'ese'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 'T', 'keyT', 'ti'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'U', 'keyU'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'V', 'keyV', 've'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'W', 'keyW', 'doppia ve'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'X', 'keyX', 'ics'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'Y', 'keyY', 'ipsilon'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'Z', 'keyZ', 'zeta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', undefined, 'trattino basso'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', undefined, 'trattino', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', undefined, 'virgola', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', undefined, 'punto e virgola'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', undefined, 'due punti'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', undefined, 'punto interrogativo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'punto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', undefined, 'virgolette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', undefined, 'parentesi aperta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', undefined, 'parentesi chiusa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', undefined, 'parentesi quadra aperta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', undefined, 'parentesi quadra chiusa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', undefined, 'parentesi graffa aperta'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', undefined, 'parentesi graffa chiusa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', undefined, 'punto esclamativo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', undefined, 'chiocciola'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'asterisco', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', 'barra', [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', undefined, 'barra inversa'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', '&', undefined, 'e'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'cancelletto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', undefined, 'percentuale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', undefined, 'accento grave'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', undefined, 'accento circonflesso'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', undefined, "pi\xf9", [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'minore di'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'uguale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', 'maggiore di'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', undefined, 'barra verticale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', undefined, 'til de'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', undefined, 'dollaro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", undefined, 'apostrofo'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', 'Indietro', 'keyDelete', 'indietro', [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Blocco Maiuscole', 'keyCapsLock', 'blocco maiuscole', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Blocco Numerico', undefined, 'blocco numerico', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Blocco Scorrimento', undefined, 'blocco scorrimento', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Comando', 'keyCommand', 'comando', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Comando Destro', 'keyCommand', 'comando destro', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', 'Cancella', 'keyDelete', 'eliminare'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', "Freccia Gi\xf9", 'keyPageDownButton', 'giu', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Freccia Sinistra', 'keyHomeButton', 'sinistra', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Freccia Destra', 'keyEndButton', 'destra', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Freccia Su', 'keyPageUpButton', 'su', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Entrare', 'keyEnterMac', 'entrare', [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Fuga', 'keyEsc', 'fuga', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Alt Sinistra', 'keyAlt', 'altra', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Ctrl Sinistra', 'keyCtrl', 'controllo', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Shift Sinistra', 'shift', 'spostare', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Opzione', 'keyOption', 'opzione', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Ctrl Destra', 'keyCtrl', 'control destra'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Shift Destra', 'shift', 'spostamento destra'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Barra Spaziatrice', 'keySpace', 'spazio', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', 'scheda'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', 'finestre', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Funzione', 'keyFn', 'funzione', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Menu', undefined, 'menu'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Print Screen', undefined, 'stampa schermo', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', 'Insert', undefined, 'inserisci'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Home', undefined, 'iniziale', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'End', undefined, 'fine', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Pagina Su', undefined, 'pagina su', [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', "Pagina Gi\xf9", undefined, "pagina gi\xf9", [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', 'tastierino numerico zero'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', 'tastierino numerico uno'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', 'tastierino numerico due'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', 'tastierino numerico tre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', 'tastierino numerico quattro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', 'tastierino numerico cinque'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', 'tastierino numerico sei'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', 'tastierino numerico sette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', 'tastierino numerico otto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', 'tastierino numerico nove'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Decimale', 'keyDot', 'tastierino numerico decimale'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'funzione uno'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'funzione due'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'funzione tre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'funzione quattro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', 'funzione cinque'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'funzione sei'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'funzione sette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'funzione otto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'funzione nove'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'funzione dieci'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'funzione undici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', 'funzione dodici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Disattiva Audio', undefined, 'disattiva audio', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', "Volume Gi\xf9", undefined, "volume gi\xf9", [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', 'Volume Su', undefined, 'volume su', [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Riproduci Audio', undefined, 'riproduci audio', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Ferma Audio', undefined, 'ferma audio', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pausa Audio', undefined, 'pausa audio', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Traccia Precedente', undefined, 'traccia precedente', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', 'Traccia Successiva', undefined, 'traccia successiva', [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', 'Riavvolgi Traccia', undefined, 'riavvolgi traccia', [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', 'Avanza Traccia', undefined, 'avanza traccia', [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Ripeti Traccia', undefined, 'ripeti traccia', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Riproduzione Casuale', undefined, 'riproduzione casuale', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', 'Pulsante 1 Del Controller (A)', 'joystick', 'pulsante uno'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', 'Pulsante 2 Del Controller (B)', 'joystick', 'pulsante due'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', 'Pulsante 3 Del Controller (X)', 'joystick', 'pulsante tre'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', 'Pulsante 4 Del Controller (Y)', 'joystick', 'pulsante quattro'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', 'Pulsante 5 Del Controller (LB)', 'joystick', 'pulsante cinque'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', 'Pulsante 6 Del Controller (RB)', 'joystick', 'pulsante sei'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', 'Pulsante 7 Del Controller (LT)', 'joystick', 'pulsante sette'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', 'Pulsante 8 Del Controller (RT)', 'joystick', 'pulsante otto'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', 'Pulsante 9 Del Controller (Opzioni)', 'joystick', 'pulsante nove'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', 'Pulsante 10 Del Controller (Pausa)', 'joystick', 'pulsante dieci'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', 'Pulsante 11 Del Controller (L3)', 'joystick', 'pulsante undici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', 'Pulsante 12 Del Controller (R3)', 'joystick', 'pulsante dodici'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-Pad Su', 'joystick', 'direzione su'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', "Controller D-Pad Gi\xf9", 'joystick', "direzione gi\xf9"),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-Pad Sinistra', 'joystick', 'direzione sinistra'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-Pad Destra', 'joystick', 'direzione destra')
    ],
    de: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', 'Maustaste 1 (linksklick)', 'mouseLeftClick', 'klicken', [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', 'Maustaste 2 (rechtsklick)', 'mouseRightClick', 'rechtsklick', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', 'Maustaste 3 (mittlerer Klick)', 'mouseMiddleClick', 'mittlerer klick', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', 'eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', 'zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', 'drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', 'vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', "f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', 'sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', 'sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', 'acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', 'neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', 'null', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'A', 'keyA', 'a', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'B', 'keyB', 'b', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'C', 'keyC', 'c', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'D', 'keyD', 'd', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'Und', 'keyE', 'e', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'F', 'keyF', 'ef', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'G', 'keyG', 'ge', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'H', 'keyH', 'ha', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'Ich', 'keyI', 'ee', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'J', 'keyJ', 'yot', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'K', 'keyK', 'ca', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'M', 'keyL', 'l', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'M', 'keyM', 'em', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'N', 'keyN', 'n', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'Die', 'keyO', 'oh', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'P', 'keyP', 'p', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'Q', 'keyQ', 'koo', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'R', 'keyR', 'r', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 'S', 'keyS', 's', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 'T', 'keyT', 't', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'In', 'keyU', 'u', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'V', 'keyV', 'vow', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'In', 'keyW', 'vee', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'X', 'keyX', 'iks', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'Und', 'keyY', 'oopsilohn', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'Mit', 'keyZ', 'zet', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', 'keySpace', 'unterstreichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', 'keySpace', 'bindestrich', [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', ',', 'keySpace', 'komma', [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', 'keySpace', 'semi kolon', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', 'keySpace', 'doppelpunkt', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', 'keySpace', 'fragezeichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', 'zeitraum', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', 'keySpace', 'zitat', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', '(', 'keySpace', "\xf6ffnende klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', ')', 'keySpace', "schlie\xdfende klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', 'keySpace', "\xf6ffnende eckige klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', 'keySpace', "schlie\xdfende eckige klammer", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', 'keySpace', "offene st\xfctzstrebe", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', 'keySpace', "schlie\xdfen st\xfctzbandage", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', '!', 'keySpace', 'ausruf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', 'keySpace', 'at zeichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', 'sternchen', [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', "schr\xe4gstrich", [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', 'keySpace', "umgekehrter schr\xe4gstrich", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', 'Und', 'keySpace', "kaufm\xe4nnisches und zeichen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', 'pfund', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', 'keySpace', 'prozent', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', 'keySpace', "zur\xfcck h\xe4kchen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', 'keySpace', 'karotte', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keySpace', 'plus', [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', 'weniger als', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', 'ist gleich', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', "gr\xf6\xdfer als", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', 'keySpace', 'rohr', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', '~', 'keySpace', 'zu ihnen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', 'keySpace', 'dollarzeichen', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", 'keySpace', "einfaches anf\xfchrungszeichen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', "R\xfccktaste", 'keyDelete', "r\xfccktaste", [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', 'Kappen', 'keyCapsLock', 'feststelltaste', [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', 'Num Lock', 'keySpace', 'zahlenschloss', [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', 'Rollen-taste', 'keySpace', 'rollen taste', [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', 'Befehl', 'keyCommand', 'befehl', [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', 'Richtiger Befehl', 'keyCommand', 'richtiger befehl', [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', "L\xf6schen", 'keyDelete', "l\xf6schen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', 'Pfeil Nach Unten', 'keyPageDownButton', 'nach unten', [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', 'Pfeil Nach Links', 'keyHomeButton', 'nach links gehen', [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', 'Pfeil Nach Rechts', 'keyEndButton', 'nach rechts gehen', [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', 'Pfeil Nach Oben', 'keyPageUpButton', 'nach oben', [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', 'Eingeben', 'keyEnterMac', 'eingeben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', 'Flucht', 'keyEsc', 'flucht', [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', 'Linke Alt-taste', 'keyAlt', 'alle', [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', 'Linke Strg-taste', 'keyCtrl', 'kontrolle', [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', 'Linksverschiebung', 'shift', 'schicht', [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', 'Option', 'keyOption', 'option', [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', 'Rechte Strg-taste', 'keyCtrl', 'rechte kontrolle', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', 'Rechtsverschiebung', 'shift', 'rechtsverschiebung', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', 'Leertaste', 'keySpace', 'raum', [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', 'Tab', 'keyTab', 'tab', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', 'Windows', 'keyWindows', 'fenster', [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', 'Funktion', 'keyFn', 'funktion', [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', 'Speisekarte', 'keySpace', 'speisekarte', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', 'Bildschirm Drucken', 'keySpace', 'bildschirm drucken', [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', "Einf\xfcgen", 'keySpace', "einf\xfcgen", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', 'Heim', 'keySpace', 'heim', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', 'Ende', 'keySpace', 'ende', [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', 'Bild Nach Oben', 'keySpace', 'bild nach oben', [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', 'Bild Ab', 'keySpace', 'bild ab', [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', 'Numpad 0', 'key0', 'nummernblock null', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', 'Numpad 1', 'key1', 'nummernblock eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', 'Numpad 2', 'key2', 'nummernblock zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', 'Numpad 3', 'key3', 'nummernblock drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', 'Numpad 4', 'key4', 'nummernblock vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', 'Numpad 5', 'key5', "nummernblock f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', 'Numpad 6', 'key6', 'nummernblock sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', 'Numpad 7', 'key7', 'nummernblock sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', 'Numpad 8', 'key8', 'nummernblock acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', 'Numpad 9', 'key9', 'nummernblock neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', 'Numpad Dezimal', 'keyDot', 'nummernblock dezimal', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', 'funktion eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', 'funktion zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', 'funktion drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', 'funktion vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', "funktion f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', 'funktion sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', 'funktion sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', 'funktion acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', 'funktion neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', 'funktion zehn', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', 'funktion elf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', "funktion zw\xf6lf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', 'Audio Stumm Schalten', 'keySpace', 'audio stumm schalten', [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', "Lautst\xe4rke Verringern", 'keySpace', "lautst\xe4rke verringern", [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', "Lautst\xe4rke Erh\xf6hen", 'keySpace', "lautst\xe4rke erh\xf6hen", [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', 'Audio Abspielen', 'keySpace', 'audio abspielen', [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', 'Audio Stoppen', 'keySpace', 'audio stoppen', [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', 'Pause Audio', 'keySpace', 'audio anhalten', [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', 'Vorheriger Titel', 'keySpace', 'vorheriger titel', [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', "N\xe4chster Titel", 'keySpace', "n\xe4chstes st\xfcck", [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', "Titel Zur\xfcckspulen", 'keySpace', "titel zur\xfcckspulen", [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', "Vorw\xe4rts-track", 'keySpace', "vorw\xe4rts verfolgen", [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', 'Titel Wiederholen', 'keySpace', 'titel wiederholen', [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', 'Zufallswiedergabe Von Titeln', 'keySpace', 'zufallswiedergabe von titeln', [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', 'Controller-taste 1 (a)', 'joystick', 'taste eins', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', 'Controller-taste 2 (b)', 'joystick', 'taste zwei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', 'Controller-taste 3 (x)', 'joystick', 'taste drei', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', 'Controller-taste 4 (y)', 'joystick', 'taste vier', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', 'Controller-taste 5 (lb)', 'joystick', "taste f\xfcnf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', 'Controller-taste 6 (rb)', 'joystick', 'taste sechs', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', 'Controller-taste 7 (lt)', 'joystick', 'taste sieben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', 'Controller-taste 8 (rt)', 'joystick', 'taste acht', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', 'Controller-taste 9 (optionen)', 'joystick', 'taste neun', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', 'Controller-taste 10 (pause)', 'joystick', 'taste zehn', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', 'Controller-taste 11 (l3)', 'joystick', 'taste elf', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', 'Controller-taste 12 (r3)', 'joystick', "taste zw\xf6lf", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', 'Controller D-pad Nach Oben', 'joystick', 'richtung nach oben', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', 'Controller D-pad Nach Unten', 'joystick', 'richtung nach unten', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', 'Controller D-pad Links', 'joystick', 'richtung links', []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', 'Controller D-pad Rechts', 'joystick', 'richtung rechts', [])
    ],
    ja: [
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_1', "\u30DE\u30A6\u30B9\u30DC\u30BF\u30F31\uFF08\u5DE6\u30AF\u30EA\u30C3\u30AF\uFF09", 'mouseLeftClick', "\u30AF\u30EA\u30C3\u30AF", [
            'click',
            'left click'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_2', "\u30DE\u30A6\u30B9\u30DC\u30BF\u30F32\uFF08\u53F3\u30AF\u30EA\u30C3\u30AF\uFF09", 'mouseRightClick', "\u53F3\u30AF\u30EA\u30C3\u30AF", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('mouse_button_3', "\u30DE\u30A6\u30B9\u30DC\u30BF\u30F33\uFF08\u4E2D\u592E\u30AF\u30EA\u30C3\u30AF\uFF09", 'mouseMiddleClick', "\u4E2D\u30AF\u30EA\u30C3\u30AF", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('1', '1', 'key1', "\u3044\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('2', '2', 'key2', "\u306B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('3', '3', 'key3', "\u3055\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('4', '4', 'key4', "\u3088\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('5', '5', 'key5', "\u3054", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('6', '6', 'key6', "\u308D\u304F", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('7', '7', 'key7', "\u306A\u306A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('8', '8', 'key8', "\u306F\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('9', '9', 'key9', "\u304D\u3085\u3046", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('0', '0', 'key0', "\u305C\u308D", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('a', 'A', 'keyA', "\u3048\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('b', 'B', 'keyB', "\u3073\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('c', 'C', 'keyC', "\u3057\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('d', 'D', 'keyD', "\u3067\u3043\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('e', 'E', 'keyE', "\u3044\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f', 'F', 'keyF', "\u3048\u3075", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('g', 'G', 'keyG', "\u3058\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('h', 'H', 'keyH', "\u3048\u3044\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('i', 'I', 'keyI', "\u3042\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('j', 'J', 'keyJ', "\u3058\u3047\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('k', 'K', 'keyK', "\u3051\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('l', 'L', 'keyL', "\u3048\u308B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('m', 'M', 'keyM', "\u3048\u3080", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('n', 'N', 'keyN', "\u3048\u306C", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('o', 'O', 'keyO', "\u304A\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('p', 'P', 'keyP', "\u3074\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('q', 'Q', 'keyQ', "\u304D\u3085\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('r', 'R', 'keyR', "\u3042\u30FC\u308B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('s', 'S', 'keyS', "\u3048\u3059", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('t', 'T', 'keyT', "\u3066\u3043\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('u', 'U', 'keyU', "\u3086\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('v', 'V', 'keyV', "\u3076\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('w', 'W', 'keyW', "\u3060\u3076\u308A\u3085\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('x', 'X', 'keyX', "\u3048\u3063\u304F\u3059", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('y', 'Y', 'keyY', "\u308F\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('z', 'Z', 'keyZ', "\u305C\u3063\u3068", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('_', '_', 'keySpace', "\u30A2\u30F3\u30C0\u30FC\u30B9\u30B3\u30A2", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('-', '-', 'keySpace', "\u30C0\u30C3\u30B7\u30E5", [
            'subtract'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(',', "\u3001", 'keySpace', "\u30B3\u30F3\u30DE", [
            'comma',
            'Comma (,)',
            ','
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b(';', ';', 'keySpace', "\u30BB\u30DF\u30B3\u30ED\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(':', ':', 'keySpace', "\u30B3\u30EA\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('?', '?', 'keySpace', "\u306F\u3066\u306A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('.', '.', 'keyDot', "\u30D4\u30EA\u30AA\u30C9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('"', '"', 'keySpace', "\u30AF\u30A9\u30FC\u30C6\u30FC\u30B7\u30E7\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('(', "\uFF08", 'keySpace', "\u304B\u3063\u3053", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(')', "\uFF09", 'keySpace', "\u9589\u3058\u308B\u304B\u3063\u3053", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('[', '[', 'keySpace', "\u958B\u304F\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b(']', ']', 'keySpace', "\u9589\u3058\u308B\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('{', '{', 'keySpace', "\u958B\u304F\u30AB\u30FC\u30EA\u30FC\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('}', '}', 'keySpace', "\u9589\u3058\u308B\u30AB\u30FC\u30EA\u30FC\u30D6\u30E9\u30B1\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('!', "\uFF01", 'keySpace', "\u3073\u3063\u304F\u308A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('@', '@', 'keySpace', "\u30A2\u30C3\u30C8\u30DE\u30FC\u30AF", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('*', '*', 'keyAsterisk', "\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF", [
            'multiply'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('/', '/', 'keySolidus', "\u30B9\u30E9\u30C3\u30B7\u30E5", [
            'divide'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('\\', '\\', 'keySpace', "\u30D0\u30C3\u30AF\u30B9\u30E9\u30C3\u30B7\u30E5", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('&', "\uFF06", 'keySpace', "\u30A2\u30F3\u30D1\u30B5\u30F3\u30C9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('#', '#', 'keyHashtag', "\u30B7\u30E3\u30FC\u30D7", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('%', '%', 'keySpace', "\u30D1\u30FC\u30BB\u30F3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('`', '`', 'keySpace', "\u30D0\u30C3\u30AF\u30AF\u30A9\u30FC\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('^', '^', 'keySpace', "\u30AD\u30E3\u30EC\u30C3\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('+', '+', 'keySpace', "\u30D7\u30E9\u30B9", [
            'add'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('<', '<', 'keyLeftAngleParentheses', "\u3088\u308A\u5C0F\u3055\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('=', '=', 'keyEqual', "\u30A4\u30B3\u30FC\u30EB", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('>', '>', 'keyRightAngleParentheses', "\u3088\u308A\u5927\u304D\u3044", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('|', '|', 'keySpace', "\u30D1\u30A4\u30D7", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('~', "\u301C", 'keySpace', "\u30C1\u30EB\u30C0", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('$', '$', 'keySpace', "\u30C9\u30EB\u8A18\u53F7", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b("'", "'", 'keySpace', "\u30C9\u30EB", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('backspace', "\u30D0\u30C3\u30AF\u30B9\u30DA\u30FC\u30B9", 'keyDelete', "\u30D0\u30C3\u30AF\u30B9\u30DA\u30FC\u30B9", [
            'back space',
            'backspace'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('capslock', "\u30AD\u30E3\u30D7\u30B9\u30ED\u30C3\u30AF", 'keyCapsLock', "\u30AD\u30E3\u30C3\u30D7\u30B9\u30ED\u30C3\u30AF", [
            'caps lock',
            'caps'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numlock', "\u30CA\u30E0\u30ED\u30C3\u30AF", 'keySpace', "num\u30ED\u30C3\u30AF", [
            'num lock'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('scrolllock', "\u30B9\u30AF\u30ED\u30FC\u30EB\u30ED\u30C3\u30AF", 'keySpace', "\u30B9\u30AF\u30ED\u30FC\u30EB\u30ED\u30C3\u30AF", [
            'scroll lock'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('cmd', "\u30B3\u30DE\u30F3\u30C9", 'keyCommand', "\u30B3\u30DE\u30F3\u30C9", [
            'leftcmd',
            'command'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcmd', "\u53F3\u30B3\u30DE\u30F3\u30C9", 'keyCommand', "\u53F3\u30B3\u30DE\u30F3\u30C9", [], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('delete', "\u30C7\u30EA\u30FC\u30C8", 'keyDelete', "\u30C7\u30EA\u30FC\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('down', "\u3057\u305F", 'keyPageDownButton', "\u3057\u305F", [
            'down arrow',
            'downarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('left', "\u3072\u3060\u308A", 'keyHomeButton', "\u3072\u3060\u308A", [
            'left arrow',
            'leftarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('right', "\u307F\u304E", 'keyEndButton', "\u307F\u304E", [
            'right arrow',
            'rightarrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('up', "\u3046\u3048", 'keyPageUpButton', "\u3046\u3048", [
            'up arrow',
            'uparrow'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('enter', "\u5165\u529B", 'keyEnterMac', "\u5165\u529B", [
            'return'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('escape', "\u30A8\u30B9\u30B1\u30FC\u30D7", 'keyEsc', "\u30A8\u30B9\u30B1\u30FC\u30D7", [
            'esc'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftalt', "\u5DE6\u30AA\u30EB\u30C8", 'keyAlt', "\u5DE6\u30AA\u30EB\u30C8", [
            'alt'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftcontrol', "\u5DE6\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", 'keyCtrl', "\u5DE6\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", [
            'ctrl',
            'control'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('leftshift', "\u5DE6\u30B7\u30D5\u30C8", 'shift', "\u5DE6\u30B7\u30D5\u30C8", [
            'shift'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('option', "\u30AA\u30D7\u30B7\u30E7\u30F3", 'keyOption', "\u30AA\u30D7\u30B7\u30E7\u30F3", [
            'opt'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightcontrol', "\u53F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", 'keyCtrl', "\u53F3\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('rightshift', "\u53F3\u30B7\u30D5\u30C8", 'shift', "\u53F3\u30B7\u30D5\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('space', "\u30B9\u30DA\u30FC\u30B9", 'keySpace', "\u30B9\u30DA\u30FC\u30B9", [
            'space bar',
            'spacebar'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('tab', "\u30BF\u30D6", 'keyTab', "\u30BF\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('win', "\u30A6\u30A3\u30F3\u30C9\u30A6\u30BA", 'keyWindows', "\u30A6\u30A3\u30F3\u30C9\u30A6\u30BA", [
            'windows'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('fn', "\u30D5\u30A1\u30F3\u30AF\u30B7\u30E7\u30F3", 'keyFn', "\u30D5\u30A1\u30F3\u30AF\u30B7\u30E7\u30F3", [
            'function',
            'fn'
        ], 'MacOS'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('menu', "\u30E1\u30CB\u30E5\u30FC", 'keySpace', "\u30E1\u30CB\u30E5\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('printscreen', "\u30D7\u30EA\u30F3\u30C8\u30B9\u30AF\u30EA\u30FC\u30F3", 'keySpace', "\u30D7\u30EA\u30F3\u30C8\u30B9\u30AF\u30EA\u30FC\u30F3", [
            'print screen'
        ], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('insert', "\u30A4\u30F3\u30B5\u30FC\u30C8", 'keySpace', "\u30A4\u30F3\u30B5\u30FC\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('home', "\u30DB\u30FC\u30E0", 'keySpace', "\u30DB\u30FC\u30E0", [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('end', "\u30A8\u30F3\u30C9", 'keySpace', "\u30A8\u30F3\u30C9", [], 'Windows'),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pageup', "\u30DA\u30FC\u30B8\u30A2\u30C3\u30D7", 'keySpace', "\u30DA\u30FC\u30B8\u30A2\u30C3\u30D7", [
            'page up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('pagedown', "\u30DA\u30FC\u30B8\u30C0\u30A6\u30F3", 'keySpace', "\u30DA\u30FC\u30B8\u30C0\u30A6\u30F3", [
            'page down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_0', "\u30C6\u30F3\u30AD\u30FC0", 'key0', "\u30C6\u30F3\u30AD\u30FC\u30BC\u30ED", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_1', "\u30C6\u30F3\u30AD\u30FC1", 'key1', "\u30C6\u30F3\u30AD\u30FC\u3044\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_2', "\u30C6\u30F3\u30AD\u30FC2", 'key2', "\u30C6\u30F3\u30AD\u30FC\u306B", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_3', "\u30C6\u30F3\u30AD\u30FC3", 'key3', "\u30C6\u30F3\u30AD\u30FC\u3055\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_4', "\u30C6\u30F3\u30AD\u30FC4", 'key4', "\u30C6\u30F3\u30AD\u30FC\u3088\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_5', "\u30C6\u30F3\u30AD\u30FC5", 'key5', "\u30C6\u30F3\u30AD\u30FC\u3054", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_6', "\u30C6\u30F3\u30AD\u30FC6", 'key6', "\u30C6\u30F3\u30AD\u30FC\u308D\u304F", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_7', "\u30C6\u30F3\u30AD\u30FC7", 'key7', "\u30C6\u30F3\u30AD\u30FC\u306A\u306A", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_8', "\u30C6\u30F3\u30AD\u30FC8", 'key8', "\u30C6\u30F3\u30AD\u30FC\u306F\u3061", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_9', "\u30C6\u30F3\u30AD\u30FC9", 'key9', "\u30C6\u30F3\u30AD\u30FC\u304D\u3085\u3046", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('numpad_decimal', "\u30C6\u30F3\u30AD\u30FC\u5C0F\u6570\u70B9", 'keyDot', "\u30C6\u30F3\u30AD\u30FC\u3057\u3087\u3046\u3059\u3046\u3066\u3093", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f1', 'F1', 'keyF1', "\u30A8\u30D5\u30EF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f2', 'F2', 'keyF2', "\u30A8\u30D5\u30C4\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f3', 'F3', 'keyF3', "\u30A8\u30D5\u30B9\u30EA\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f4', 'F4', 'keyF4', "\u30A8\u30D5\u30D5\u30A9\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f5', 'F5', 'keyF5', "\u30A8\u30D5\u30D5\u30A1\u30A4\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f6', 'F6', 'keyF6', "\u30A8\u30D5\u30B7\u30C3\u30AF\u30B9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f7', 'F7', 'keyF7', "\u30A8\u30D5\u30BB\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f8', 'F8', 'keyF8', "\u30A8\u30D5\u30A8\u30A4\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f9', 'F9', 'keyF9', "\u30A8\u30D5\u30CA\u30A4\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f10', 'F10', 'keyF10', "\u30A8\u30D5\u30C6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f11', 'F11', 'keyF11', "\u30A8\u30D5\u30A4\u30EC\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('f12', 'F12', 'keyF12', "\u30A8\u30D5\u30C8\u30A5\u30A8\u30EB\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_mute', "\u97F3\u58F0\u3092\u30DF\u30E5\u30FC\u30C8\u3059\u308B", 'keySpace', "\u30DF\u30E5\u30FC\u30C8", [
            'mute',
            'mute audio',
            'audio mute'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_down', "\u97F3\u91CF\u3092\u4E0B\u3052\u308B", 'keySpace', "\u30DC\u30EA\u30E5\u30FC\u30E0\u30C0\u30A6\u30F3", [
            'volume down'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_vol_up', "\u97F3\u91CF\u3092\u4E0A\u3052\u308B", 'keySpace', "\u30DC\u30EA\u30E5\u30FC\u30E0\u30A2\u30C3\u30D7", [
            'volume up'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_play', "\u30AA\u30FC\u30C7\u30A3\u30AA\u3092\u518D\u751F", 'keySpace', "\u518D\u751F", [
            'play'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_stop', "\u97F3\u58F0\u3092\u505C\u6B62", 'keySpace', "\u505C\u6B62", [
            'stop'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_pause', "\u97F3\u58F0\u3092\u4E00\u6642\u505C\u6B62", 'keySpace', "\u97F3\u58F0\u3092\u4E00\u6642\u505C\u6B62", [
            'pause'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_prev', "\u524D\u306E\u30C8\u30E9\u30C3\u30AF", 'keySpace', "\u524D\u306E\u30C8\u30E9\u30C3\u30AF", [
            'previous',
            'audio_prev'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_next', "\u6B21\u306E\u30C8\u30E9\u30C3\u30AF", 'keySpace', "\u6B21\u306E\u30C8\u30E9\u30C3\u30AF", [
            'next'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_rewind', "\u30C8\u30E9\u30C3\u30AF\u3092\u5DFB\u304D\u623B\u3059", 'keySpace', "\u5DFB\u304D\u623B\u3057", [
            'rewind'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_forward', "\u524D\u9032\u8ECC\u9053", 'keySpace', "\u65E9\u9001\u308A", [
            'forward'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_repeat', "\u30C8\u30E9\u30C3\u30AF\u3092\u7E70\u308A\u8FD4\u3059", 'keySpace', "\u30EA\u30D4\u30FC\u30C8", [
            'repeat'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('audio_random', "\u30C8\u30E9\u30C3\u30AF\u3092\u30B7\u30E3\u30C3\u30D5\u30EB", 'keySpace', "\u30B7\u30E3\u30C3\u30D5\u30EB", [
            'shuffle',
            'random'
        ]),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_1', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F31 (a)", 'joystick', "\u30DC\u30BF\u30F3\u30EF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_2', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F32 (b)", 'joystick', "\u30DC\u30BF\u30F3\u30C4\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_3', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F33 (x)", 'joystick', "\u30DC\u30BF\u30F3\u30B9\u30EA\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_4', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F34 (y)", 'joystick', "\u30DC\u30BF\u30F3\u30D5\u30A9\u30FC", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_5', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F35\uFF08lb\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30D5\u30A1\u30A4\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_6', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F36 (rb)", 'joystick', "\u30DC\u30BF\u30F3\u30B7\u30C3\u30AF\u30B9", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_7', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F37 (lt)", 'joystick', "\u30DC\u30BF\u30F3\u30BB\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_8', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F38 (rt)", 'joystick', "\u30DC\u30BF\u30F3\u30A8\u30A4\u30C8", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_9', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F39\uFF08\u30AA\u30D7\u30B7\u30E7\u30F3\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30CA\u30A4\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_10', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F310\uFF08\u4E00\u6642\u505C\u6B62\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30C6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_11', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F311\uFF08l3\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30A4\u30EC\u30D6\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_12', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u30DC\u30BF\u30F312\uFF08r3\uFF09", 'joystick', "\u30DC\u30BF\u30F3\u30C8\u30A5\u30A8\u30EB\u30D6", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_13', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u306E\u5341\u5B57\u30DC\u30BF\u30F3\u4E0A", 'joystick', "\u4E0A\u30DC\u30BF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_14', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC\u306Ed\u30D1\u30C3\u30C9\u3092\u4E0B", 'joystick', "\u4E0B\u30DC\u30BF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_15', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC D\u30D1\u30C3\u30C9 \u5DE6", 'joystick', "\u5DE6\u30DC\u30BF\u30F3", []),
        $9a9874d925dad9cc$export$1042f3e960dd652b('gamepad_button_16', "\u30B3\u30F3\u30C8\u30ED\u30FC\u30E9\u30FC D\u30D1\u30C3\u30C9\u53F3", 'joystick', "\u53F3\u30DC\u30BF\u30F3", [])
    ]
};
const $9a9874d925dad9cc$export$2f002ae08ac7e997 = (locale, platform)=>{
    const language = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(locale, 'display');
    let result = [];
    var _defaultKeyMappings_language;
    if (language) result = (_defaultKeyMappings_language = $9a9874d925dad9cc$export$d8fdbd751da3b492[language]) !== null && _defaultKeyMappings_language !== void 0 ? _defaultKeyMappings_language : [];
    if (platform && platform !== 'generic') // filter by platform. generic profiles get all of the keybindings
    result = result.filter((kcd)=>!kcd.platform || kcd.platform === 'generic' || kcd.platform === platform);
    return result;
};
const $9a9874d925dad9cc$export$a23a68036192c276 = (key, locale)=>{
    var _getDefaultKeyMapping_find;
    var _getDefaultKeyMapping_find_displayName;
    const keyName = (_getDefaultKeyMapping_find_displayName = (_getDefaultKeyMapping_find = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale).find((v)=>v.key == key)) === null || _getDefaultKeyMapping_find === void 0 ? void 0 : _getDefaultKeyMapping_find.displayName) !== null && _getDefaultKeyMapping_find_displayName !== void 0 ? _getDefaultKeyMapping_find_displayName : key;
    if ((keyName === null || keyName === void 0 ? void 0 : keyName.length) == 1) return keyName.toUpperCase();
    return keyName;
};
const $9a9874d925dad9cc$export$fbe8b56204f00600 = (key, locale)=>{
    var _getDefaultKeyMapping_find;
    const newKey = $9a9874d925dad9cc$export$38eb86f225c9e34c(key, locale);
    var _getDefaultKeyMapping_find_icon;
    const keyIcon = (_getDefaultKeyMapping_find_icon = (_getDefaultKeyMapping_find = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale).find((v)=>v.key == newKey)) === null || _getDefaultKeyMapping_find === void 0 ? void 0 : _getDefaultKeyMapping_find.icon) !== null && _getDefaultKeyMapping_find_icon !== void 0 ? _getDefaultKeyMapping_find_icon : newKey;
    return keyIcon;
};
const $9a9874d925dad9cc$export$38eb86f225c9e34c = (value, locale)=>{
    var _defaultKeyMapping_find, _defaultKeyMapping_find1, _defaultKeyMapping_find2;
    const defaultKeyMapping = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale);
    const key = (_defaultKeyMapping_find = defaultKeyMapping.find((v)=>v.key == value)) === null || _defaultKeyMapping_find === void 0 ? void 0 : _defaultKeyMapping_find.key;
    if (key) return key;
    const keyFromDisplayName = (_defaultKeyMapping_find1 = defaultKeyMapping.find((v)=>v.displayName == value)) === null || _defaultKeyMapping_find1 === void 0 ? void 0 : _defaultKeyMapping_find1.key;
    if (keyFromDisplayName) return keyFromDisplayName;
    const keyFromAlias = (_defaultKeyMapping_find2 = defaultKeyMapping.find((v)=>{
        var _v_alternateKeys;
        return (_v_alternateKeys = v.alternateKeys) === null || _v_alternateKeys === void 0 ? void 0 : _v_alternateKeys.includes(value);
    })) === null || _defaultKeyMapping_find2 === void 0 ? void 0 : _defaultKeyMapping_find2.key;
    if (keyFromAlias) return keyFromAlias;
    return value;
};
const $9a9874d925dad9cc$export$c59c56a4092c247a = (key, locale)=>{
    var _getDefaultKeyMapping_find;
    const newKey = $9a9874d925dad9cc$export$38eb86f225c9e34c(key, locale);
    var _getDefaultKeyMapping_find_platform;
    const keyPlatform = (_getDefaultKeyMapping_find_platform = (_getDefaultKeyMapping_find = $9a9874d925dad9cc$export$2f002ae08ac7e997(locale).find((v)=>v.key == newKey)) === null || _getDefaultKeyMapping_find === void 0 ? void 0 : _getDefaultKeyMapping_find.platform) !== null && _getDefaultKeyMapping_find_platform !== void 0 ? _getDefaultKeyMapping_find_platform : 'generic';
    return keyPlatform;
};







var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");
const $fadcf04f5e0ec6ac$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $fadcf04f5e0ec6ac$export$2e2bcd8739ae039 = {
    randomUUID: $fadcf04f5e0ec6ac$var$randomUUID
};


let $2bcaa466815aa8a5$var$getRandomValues;
const $2bcaa466815aa8a5$var$rnds8 = new Uint8Array(16);
function $2bcaa466815aa8a5$export$2e2bcd8739ae039() {
    if (!$2bcaa466815aa8a5$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $2bcaa466815aa8a5$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $2bcaa466815aa8a5$var$getRandomValues($2bcaa466815aa8a5$var$rnds8);
}


var $7709510a2fca9f72$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $8df89a4d60889f85$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7709510a2fca9f72$export$2e2bcd8739ae039).test(uuid);
}
var $8df89a4d60889f85$export$2e2bcd8739ae039 = $8df89a4d60889f85$var$validate;


const $ee13ceee8d9f46c4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$ee13ceee8d9f46c4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset = 0) {
    return ($ee13ceee8d9f46c4$var$byteToHex[arr[offset + 0]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 1]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 2]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 3]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 4]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 5]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 6]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 7]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 8]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 9]] + '-' + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 10]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 11]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 12]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 13]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 14]] + $ee13ceee8d9f46c4$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $ee13ceee8d9f46c4$var$stringify(arr, offset = 0) {
    const uuid = $ee13ceee8d9f46c4$export$8fb373d660548968(arr, offset);
    if (!(0, $8df89a4d60889f85$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $ee13ceee8d9f46c4$export$2e2bcd8739ae039 = $ee13ceee8d9f46c4$var$stringify;


function $6810e10b84975c3e$var$v4(options, buf, offset) {
    var _options_rng;
    if ((0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $fadcf04f5e0ec6ac$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var _options_random, _ref;
    const rnds = (_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, $2bcaa466815aa8a5$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $ee13ceee8d9f46c4$export$8fb373d660548968)(rnds);
}
var $6810e10b84975c3e$export$2e2bcd8739ae039 = $6810e10b84975c3e$var$v4;



var $7fPBF = parcelRequire("7fPBF");
const $977ce2c2c06356d2$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $977ce2c2c06356d2$export$f51a9068ac82ea43 = (createState)=>createState ? $977ce2c2c06356d2$var$createStoreImpl(createState) : $977ce2c2c06356d2$var$createStoreImpl;


const $368cd3e6bcd15ad5$var$identity = (arg)=>arg;
function $368cd3e6bcd15ad5$export$6ccbb43953eebf8(api, selector = $368cd3e6bcd15ad5$var$identity) {
    const slice = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useSyncExternalStore(api.subscribe, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useDebugValue(slice);
    return slice;
}
const $368cd3e6bcd15ad5$var$createImpl = (createState)=>{
    const api = (0, $977ce2c2c06356d2$export$f51a9068ac82ea43)(createState);
    const useBoundStore = (selector)=>$368cd3e6bcd15ad5$export$6ccbb43953eebf8(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $368cd3e6bcd15ad5$export$185802fd694ee1f5 = (createState)=>createState ? $368cd3e6bcd15ad5$var$createImpl(createState) : $368cd3e6bcd15ad5$var$createImpl;


// src/utils/env.ts


var $f36abaf9e6893e6c$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $f36abaf9e6893e6c$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $f36abaf9e6893e6c$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $f36abaf9e6893e6c$var$errors = [];
function $f36abaf9e6893e6c$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $f36abaf9e6893e6c$var$O = Object;
var $f36abaf9e6893e6c$var$getPrototypeOf = $f36abaf9e6893e6c$var$O.getPrototypeOf;
var $f36abaf9e6893e6c$var$CONSTRUCTOR = "constructor";
var $f36abaf9e6893e6c$var$PROTOTYPE = "prototype";
var $f36abaf9e6893e6c$var$CONFIGURABLE = "configurable";
var $f36abaf9e6893e6c$var$ENUMERABLE = "enumerable";
var $f36abaf9e6893e6c$var$WRITABLE = "writable";
var $f36abaf9e6893e6c$var$VALUE = "value";
var $f36abaf9e6893e6c$export$541ac630993a4c84 = (value)=>!!value && !!value[$f36abaf9e6893e6c$var$DRAFT_STATE];
function $f36abaf9e6893e6c$export$16e3aed3edb85946(value) {
    var _value_CONSTRUCTOR;
    if (!value) return false;
    return $f36abaf9e6893e6c$var$isPlainObject(value) || $f36abaf9e6893e6c$var$isArray(value) || !!value[$f36abaf9e6893e6c$export$6ee2082928bcb0ee] || !!((_value_CONSTRUCTOR = value[$f36abaf9e6893e6c$var$CONSTRUCTOR]) === null || _value_CONSTRUCTOR === void 0 ? void 0 : _value_CONSTRUCTOR[$f36abaf9e6893e6c$export$6ee2082928bcb0ee]) || $f36abaf9e6893e6c$var$isMap(value) || $f36abaf9e6893e6c$var$isSet(value);
}
var $f36abaf9e6893e6c$var$objectCtorString = $f36abaf9e6893e6c$var$O[$f36abaf9e6893e6c$var$PROTOTYPE][$f36abaf9e6893e6c$var$CONSTRUCTOR].toString();
var $f36abaf9e6893e6c$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $f36abaf9e6893e6c$var$isPlainObject(value) {
    if (!value || !$f36abaf9e6893e6c$var$isObjectish(value)) return false;
    const proto = $f36abaf9e6893e6c$var$getPrototypeOf(value);
    if (proto === null || proto === $f36abaf9e6893e6c$var$O[$f36abaf9e6893e6c$var$PROTOTYPE]) return true;
    const Ctor = $f36abaf9e6893e6c$var$O.hasOwnProperty.call(proto, $f36abaf9e6893e6c$var$CONSTRUCTOR) && proto[$f36abaf9e6893e6c$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$f36abaf9e6893e6c$var$isFunction(Ctor)) return false;
    let ctorString = $f36abaf9e6893e6c$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $f36abaf9e6893e6c$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $f36abaf9e6893e6c$var$objectCtorString;
}
function $f36abaf9e6893e6c$export$22e8af3f75a010e3(value) {
    if (!$f36abaf9e6893e6c$export$541ac630993a4c84(value)) $f36abaf9e6893e6c$var$die(15, value);
    return value[$f36abaf9e6893e6c$var$DRAFT_STATE].base_;
}
function $f36abaf9e6893e6c$var$each(obj, iter, strict = true) {
    if ($f36abaf9e6893e6c$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $f36abaf9e6893e6c$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $f36abaf9e6893e6c$var$getArchtype(thing) {
    const state = thing[$f36abaf9e6893e6c$var$DRAFT_STATE];
    return state ? state.type_ : $f36abaf9e6893e6c$var$isArray(thing) ? 1 /* Array */  : $f36abaf9e6893e6c$var$isMap(thing) ? 2 /* Map */  : $f36abaf9e6893e6c$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $f36abaf9e6893e6c$var$has = (thing, prop, type = $f36abaf9e6893e6c$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $f36abaf9e6893e6c$var$O[$f36abaf9e6893e6c$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $f36abaf9e6893e6c$var$get = (thing, prop, type = $f36abaf9e6893e6c$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $f36abaf9e6893e6c$var$set = (thing, propOrOldValue, value, type = $f36abaf9e6893e6c$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $f36abaf9e6893e6c$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $f36abaf9e6893e6c$var$isArray = Array.isArray;
var $f36abaf9e6893e6c$var$isMap = (target)=>target instanceof Map;
var $f36abaf9e6893e6c$var$isSet = (target)=>target instanceof Set;
var $f36abaf9e6893e6c$var$isObjectish = (target)=>typeof target === "object";
var $f36abaf9e6893e6c$var$isFunction = (target)=>typeof target === "function";
var $f36abaf9e6893e6c$var$isBoolean = (target)=>typeof target === "boolean";
function $f36abaf9e6893e6c$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $f36abaf9e6893e6c$var$getProxyDraft = (value)=>{
    if (!$f36abaf9e6893e6c$var$isObjectish(value)) return null;
    return value === null || value === void 0 ? void 0 : value[$f36abaf9e6893e6c$var$DRAFT_STATE];
};
var $f36abaf9e6893e6c$var$latest = (state)=>state.copy_ || state.base_;
var $f36abaf9e6893e6c$var$getValue = (value)=>{
    const proxyDraft = $f36abaf9e6893e6c$var$getProxyDraft(value);
    var _proxyDraft_copy_;
    return proxyDraft ? (_proxyDraft_copy_ = proxyDraft.copy_) !== null && _proxyDraft_copy_ !== void 0 ? _proxyDraft_copy_ : proxyDraft.base_ : value;
};
var $f36abaf9e6893e6c$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $f36abaf9e6893e6c$var$shallowCopy(base, strict) {
    if ($f36abaf9e6893e6c$var$isMap(base)) return new Map(base);
    if ($f36abaf9e6893e6c$var$isSet(base)) return new Set(base);
    if ($f36abaf9e6893e6c$var$isArray(base)) return Array[$f36abaf9e6893e6c$var$PROTOTYPE].slice.call(base);
    const isPlain = $f36abaf9e6893e6c$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $f36abaf9e6893e6c$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$f36abaf9e6893e6c$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$f36abaf9e6893e6c$var$WRITABLE] === false) {
                desc[$f36abaf9e6893e6c$var$WRITABLE] = true;
                desc[$f36abaf9e6893e6c$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$f36abaf9e6893e6c$var$CONFIGURABLE]: true,
                [$f36abaf9e6893e6c$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$f36abaf9e6893e6c$var$ENUMERABLE]: desc[$f36abaf9e6893e6c$var$ENUMERABLE],
                [$f36abaf9e6893e6c$var$VALUE]: base[key]
            };
        }
        return $f36abaf9e6893e6c$var$O.create($f36abaf9e6893e6c$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $f36abaf9e6893e6c$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, base);
        const obj = $f36abaf9e6893e6c$var$O.create(proto);
        return $f36abaf9e6893e6c$var$O.assign(obj, base);
    }
}
function $f36abaf9e6893e6c$export$792f3d81ea979f55(obj, deep = false) {
    if ($f36abaf9e6893e6c$var$isFrozen(obj) || $f36abaf9e6893e6c$export$541ac630993a4c84(obj) || !$f36abaf9e6893e6c$export$16e3aed3edb85946(obj)) return obj;
    if ($f36abaf9e6893e6c$var$getArchtype(obj) > 1) $f36abaf9e6893e6c$var$O.defineProperties(obj, {
        set: $f36abaf9e6893e6c$var$dontMutateMethodOverride,
        add: $f36abaf9e6893e6c$var$dontMutateMethodOverride,
        clear: $f36abaf9e6893e6c$var$dontMutateMethodOverride,
        delete: $f36abaf9e6893e6c$var$dontMutateMethodOverride
    });
    $f36abaf9e6893e6c$var$O.freeze(obj);
    if (deep) $f36abaf9e6893e6c$var$each(obj, (_key, value)=>{
        $f36abaf9e6893e6c$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $f36abaf9e6893e6c$var$dontMutateFrozenCollections() {
    $f36abaf9e6893e6c$var$die(2);
}
var $f36abaf9e6893e6c$var$dontMutateMethodOverride = {
    [$f36abaf9e6893e6c$var$VALUE]: $f36abaf9e6893e6c$var$dontMutateFrozenCollections
};
function $f36abaf9e6893e6c$var$isFrozen(obj) {
    if (obj === null || !$f36abaf9e6893e6c$var$isObjectish(obj)) return true;
    return $f36abaf9e6893e6c$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $f36abaf9e6893e6c$var$PluginMapSet = "MapSet";
var $f36abaf9e6893e6c$var$PluginPatches = "Patches";
var $f36abaf9e6893e6c$var$PluginArrayMethods = "ArrayMethods";
var $f36abaf9e6893e6c$var$plugins = {};
function $f36abaf9e6893e6c$var$getPlugin(pluginKey) {
    const plugin = $f36abaf9e6893e6c$var$plugins[pluginKey];
    if (!plugin) $f36abaf9e6893e6c$var$die(0, pluginKey);
    return plugin;
}
var $f36abaf9e6893e6c$var$isPluginLoaded = (pluginKey)=>!!$f36abaf9e6893e6c$var$plugins[pluginKey];
function $f36abaf9e6893e6c$var$loadPlugin(pluginKey, implementation) {
    if (!$f36abaf9e6893e6c$var$plugins[pluginKey]) $f36abaf9e6893e6c$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $f36abaf9e6893e6c$var$currentScope;
var $f36abaf9e6893e6c$var$getCurrentScope = ()=>$f36abaf9e6893e6c$var$currentScope;
var $f36abaf9e6893e6c$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $f36abaf9e6893e6c$var$isPluginLoaded($f36abaf9e6893e6c$var$PluginMapSet) ? $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $f36abaf9e6893e6c$var$isPluginLoaded($f36abaf9e6893e6c$var$PluginArrayMethods) ? $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginArrayMethods) : void 0
    });
function $f36abaf9e6893e6c$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $f36abaf9e6893e6c$var$revokeScope(scope) {
    $f36abaf9e6893e6c$var$leaveScope(scope);
    scope.drafts_.forEach($f36abaf9e6893e6c$var$revokeDraft);
    scope.drafts_ = null;
}
function $f36abaf9e6893e6c$var$leaveScope(scope) {
    if (scope === $f36abaf9e6893e6c$var$currentScope) $f36abaf9e6893e6c$var$currentScope = scope.parent_;
}
var $f36abaf9e6893e6c$var$enterScope = (immer2)=>$f36abaf9e6893e6c$var$currentScope = $f36abaf9e6893e6c$var$createScope($f36abaf9e6893e6c$var$currentScope, immer2);
function $f36abaf9e6893e6c$var$revokeDraft(draft) {
    const state = draft[$f36abaf9e6893e6c$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $f36abaf9e6893e6c$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$f36abaf9e6893e6c$var$DRAFT_STATE].modified_) {
            $f36abaf9e6893e6c$var$revokeScope(scope);
            $f36abaf9e6893e6c$var$die(4);
        }
        if ($f36abaf9e6893e6c$export$16e3aed3edb85946(result)) result = $f36abaf9e6893e6c$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$f36abaf9e6893e6c$var$DRAFT_STATE].base_, result, scope);
    } else result = $f36abaf9e6893e6c$var$finalize(scope, baseDraft);
    $f36abaf9e6893e6c$var$maybeFreeze(scope, result, true);
    $f36abaf9e6893e6c$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $f36abaf9e6893e6c$export$45b790e32b2810ee ? result : void 0;
}
function $f36abaf9e6893e6c$var$finalize(rootScope, value) {
    if ($f36abaf9e6893e6c$var$isFrozen(value)) return value;
    const state = value[$f36abaf9e6893e6c$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $f36abaf9e6893e6c$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$f36abaf9e6893e6c$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $f36abaf9e6893e6c$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $f36abaf9e6893e6c$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $f36abaf9e6893e6c$export$792f3d81ea979f55(value, deep);
}
function $f36abaf9e6893e6c$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $f36abaf9e6893e6c$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $f36abaf9e6893e6c$var$EMPTY_LOCATIONS_RESULT = [];
function $f36abaf9e6893e6c$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $f36abaf9e6893e6c$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $f36abaf9e6893e6c$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $f36abaf9e6893e6c$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $f36abaf9e6893e6c$var$each(parentCopy, (key, value)=>{
            if ($f36abaf9e6893e6c$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    var _parent_draftLocations__get;
    const locations = (_parent_draftLocations__get = parent.draftLocations_.get(draftValue)) !== null && _parent_draftLocations__get !== void 0 ? _parent_draftLocations__get : $f36abaf9e6893e6c$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$f36abaf9e6893e6c$var$set(parentCopy, location, finalizedValue, parentType);
}
function $f36abaf9e6893e6c$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _rootScope_mapSetPlugin_;
        const state = child;
        if (!state || !$f36abaf9e6893e6c$var$isSameScope(state, rootScope)) return;
        (_rootScope_mapSetPlugin_ = rootScope.mapSetPlugin_) === null || _rootScope_mapSetPlugin_ === void 0 ? void 0 : _rootScope_mapSetPlugin_.fixSetContents(state);
        const finalizedValue = $f36abaf9e6893e6c$var$getFinalValue(state);
        var _state_draft_;
        $f36abaf9e6893e6c$var$updateDraftInParent(parent, (_state_draft_ = state.draft_) !== null && _state_draft_ !== void 0 ? _state_draft_ : state, finalizedValue, key);
        $f36abaf9e6893e6c$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $f36abaf9e6893e6c$var$generatePatchesAndFinalize(state, rootScope) {
    var _state_assigned_;
    var _state_assigned__size;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_state_assigned__size = (_state_assigned_ = state.assigned_) === null || _state_assigned_ === void 0 ? void 0 : _state_assigned_.size) !== null && _state_assigned__size !== void 0 ? _state_assigned__size : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $f36abaf9e6893e6c$var$markStateFinalized(state);
    }
}
function $f36abaf9e6893e6c$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($f36abaf9e6893e6c$export$541ac630993a4c84(value)) {
        const state = value[$f36abaf9e6893e6c$var$DRAFT_STATE];
        if ($f36abaf9e6893e6c$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $f36abaf9e6893e6c$var$prepareCopy(target);
            const finalizedValue = $f36abaf9e6893e6c$var$getFinalValue(state);
            $f36abaf9e6893e6c$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($f36abaf9e6893e6c$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $f36abaf9e6893e6c$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $f36abaf9e6893e6c$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            var _target_assigned__get;
            if ($f36abaf9e6893e6c$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_target_assigned__get = target.assigned_.get(key)) !== null && _target_assigned__get !== void 0 ? _target_assigned__get : false) === true && target.copy_) $f36abaf9e6893e6c$var$handleValue($f36abaf9e6893e6c$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $f36abaf9e6893e6c$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($f36abaf9e6893e6c$export$541ac630993a4c84(target) || handledSet.has(target) || !$f36abaf9e6893e6c$export$16e3aed3edb85946(target) || $f36abaf9e6893e6c$var$isFrozen(target)) return target;
    handledSet.add(target);
    $f36abaf9e6893e6c$var$each(target, (key, value)=>{
        if ($f36abaf9e6893e6c$export$541ac630993a4c84(value)) {
            const state = value[$f36abaf9e6893e6c$var$DRAFT_STATE];
            if ($f36abaf9e6893e6c$var$isSameScope(state, rootScope)) {
                const updatedValue = $f36abaf9e6893e6c$var$getFinalValue(state);
                $f36abaf9e6893e6c$var$set(target, key, updatedValue, target.type_);
                $f36abaf9e6893e6c$var$markStateFinalized(state);
            }
        } else if ($f36abaf9e6893e6c$export$16e3aed3edb85946(value)) $f36abaf9e6893e6c$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $f36abaf9e6893e6c$var$createProxyProxy(base, parent) {
    const baseIsArray = $f36abaf9e6893e6c$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $f36abaf9e6893e6c$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $f36abaf9e6893e6c$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $f36abaf9e6893e6c$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $f36abaf9e6893e6c$var$objectTraps = {
    get (state, prop) {
        if (prop === $f36abaf9e6893e6c$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin === null || arrayPlugin === void 0 ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $f36abaf9e6893e6c$var$latest(state);
        if (!$f36abaf9e6893e6c$var$has(source, prop, state.type_)) return $f36abaf9e6893e6c$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$f36abaf9e6893e6c$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin === null || arrayPlugin === void 0 ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $f36abaf9e6893e6c$var$isArrayIndex(prop)) return value;
        if (value === $f36abaf9e6893e6c$var$peek(state.base_, prop) || $f36abaf9e6893e6c$var$isRelocatedBaseRef(state, prop, value)) {
            $f36abaf9e6893e6c$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $f36abaf9e6893e6c$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $f36abaf9e6893e6c$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($f36abaf9e6893e6c$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $f36abaf9e6893e6c$var$getDescriptorFromProto($f36abaf9e6893e6c$var$latest(state), prop);
        if (desc === null || desc === void 0 ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $f36abaf9e6893e6c$var$peek($f36abaf9e6893e6c$var$latest(state), prop);
            const currentState = current2 === null || current2 === void 0 ? void 0 : current2[$f36abaf9e6893e6c$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($f36abaf9e6893e6c$var$is(value, current2) && (value !== void 0 || $f36abaf9e6893e6c$var$has(state.base_, prop, state.type_))) return true;
            $f36abaf9e6893e6c$var$prepareCopy(state);
            $f36abaf9e6893e6c$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $f36abaf9e6893e6c$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $f36abaf9e6893e6c$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $f36abaf9e6893e6c$var$prepareCopy(state);
        if ($f36abaf9e6893e6c$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $f36abaf9e6893e6c$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $f36abaf9e6893e6c$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$f36abaf9e6893e6c$var$WRITABLE]: true,
            [$f36abaf9e6893e6c$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$f36abaf9e6893e6c$var$ENUMERABLE]: desc[$f36abaf9e6893e6c$var$ENUMERABLE],
            [$f36abaf9e6893e6c$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $f36abaf9e6893e6c$var$die(11);
    },
    getPrototypeOf (state) {
        return $f36abaf9e6893e6c$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $f36abaf9e6893e6c$var$die(12);
    }
};
var $f36abaf9e6893e6c$var$arrayTraps = {};
for(let key in $f36abaf9e6893e6c$var$objectTraps){
    let fn = $f36abaf9e6893e6c$var$objectTraps[key];
    $f36abaf9e6893e6c$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$f36abaf9e6893e6c$var$arrayTraps.deleteProperty = function(state, prop) {
    return $f36abaf9e6893e6c$var$arrayTraps.set.call(this, state, prop, void 0);
};
$f36abaf9e6893e6c$var$arrayTraps.set = function(state, prop, value) {
    return $f36abaf9e6893e6c$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $f36abaf9e6893e6c$var$peek(draft, prop) {
    const state = draft[$f36abaf9e6893e6c$var$DRAFT_STATE];
    const source = state ? $f36abaf9e6893e6c$var$latest(state) : draft;
    return source[prop];
}
function $f36abaf9e6893e6c$var$isRelocatedBaseRef(state, prop, value) {
    var _state_assigned_;
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || ((_state_assigned_ = state.assigned_) === null || _state_assigned_ === void 0 ? void 0 : _state_assigned_.get(prop)) || !$f36abaf9e6893e6c$export$16e3aed3edb85946(value) || value[$f36abaf9e6893e6c$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $f36abaf9e6893e6c$var$readPropFromProto(state, source, prop) {
    var // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    _desc_get;
    const desc = $f36abaf9e6893e6c$var$getDescriptorFromProto(source, prop);
    return desc ? $f36abaf9e6893e6c$var$VALUE in desc ? desc[$f36abaf9e6893e6c$var$VALUE] : (_desc_get = desc.get) === null || _desc_get === void 0 ? void 0 : _desc_get.call(state.draft_) : void 0;
}
function $f36abaf9e6893e6c$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $f36abaf9e6893e6c$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $f36abaf9e6893e6c$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $f36abaf9e6893e6c$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $f36abaf9e6893e6c$var$markChanged(state.parent_);
    }
}
function $f36abaf9e6893e6c$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $f36abaf9e6893e6c$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $f36abaf9e6893e6c$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$f36abaf9e6893e6c$export$16e3aed3edb85946(base)) $f36abaf9e6893e6c$var$die(8);
        if ($f36abaf9e6893e6c$export$541ac630993a4c84(base)) base = $f36abaf9e6893e6c$export$97aac956da55dae9(base);
        const scope = $f36abaf9e6893e6c$var$enterScope(this);
        const proxy = $f36abaf9e6893e6c$var$createProxy(scope, base, void 0);
        proxy[$f36abaf9e6893e6c$var$DRAFT_STATE].isManual_ = true;
        $f36abaf9e6893e6c$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$f36abaf9e6893e6c$var$DRAFT_STATE];
        if (!state || !state.isManual_) $f36abaf9e6893e6c$var$die(9);
        const { scope_: scope } = state;
        $f36abaf9e6893e6c$var$usePatchesInScope(scope, patchListener);
        return $f36abaf9e6893e6c$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginPatches).applyPatches_;
        if ($f36abaf9e6893e6c$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($f36abaf9e6893e6c$var$isFunction(base) && !$f36abaf9e6893e6c$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$f36abaf9e6893e6c$var$isFunction(recipe)) $f36abaf9e6893e6c$var$die(6);
            if (patchListener !== void 0 && !$f36abaf9e6893e6c$var$isFunction(patchListener)) $f36abaf9e6893e6c$var$die(7);
            let result;
            if ($f36abaf9e6893e6c$export$16e3aed3edb85946(base)) {
                const scope = $f36abaf9e6893e6c$var$enterScope(this);
                const proxy = $f36abaf9e6893e6c$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $f36abaf9e6893e6c$var$revokeScope(scope);
                    else $f36abaf9e6893e6c$var$leaveScope(scope);
                }
                $f36abaf9e6893e6c$var$usePatchesInScope(scope, patchListener);
                return $f36abaf9e6893e6c$var$processResult(result, scope);
            } else if (!base || !$f36abaf9e6893e6c$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $f36abaf9e6893e6c$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $f36abaf9e6893e6c$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $f36abaf9e6893e6c$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($f36abaf9e6893e6c$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($f36abaf9e6893e6c$var$isBoolean(config === null || config === void 0 ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($f36abaf9e6893e6c$var$isBoolean(config === null || config === void 0 ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($f36abaf9e6893e6c$var$isBoolean(config === null || config === void 0 ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
};
function $f36abaf9e6893e6c$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $f36abaf9e6893e6c$var$isMap(value) ? $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginMapSet).proxyMap_(value, parent) : $f36abaf9e6893e6c$var$isSet(value) ? $f36abaf9e6893e6c$var$getPlugin($f36abaf9e6893e6c$var$PluginMapSet).proxySet_(value, parent) : $f36abaf9e6893e6c$var$createProxyProxy(value, parent);
    var _parent_scope_;
    const scope = (_parent_scope_ = parent === null || parent === void 0 ? void 0 : parent.scope_) !== null && _parent_scope_ !== void 0 ? _parent_scope_ : $f36abaf9e6893e6c$var$getCurrentScope();
    scope.drafts_.push(draft);
    var _parent_callbacks_;
    state.callbacks_ = (_parent_callbacks_ = parent === null || parent === void 0 ? void 0 : parent.callbacks_) !== null && _parent_callbacks_ !== void 0 ? _parent_callbacks_ : [];
    state.key_ = key;
    if (parent && key !== void 0) $f36abaf9e6893e6c$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _rootScope2_mapSetPlugin_;
        (_rootScope2_mapSetPlugin_ = rootScope2.mapSetPlugin_) === null || _rootScope2_mapSetPlugin_ === void 0 ? void 0 : _rootScope2_mapSetPlugin_.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $f36abaf9e6893e6c$export$97aac956da55dae9(value) {
    if (!$f36abaf9e6893e6c$export$541ac630993a4c84(value)) $f36abaf9e6893e6c$var$die(10, value);
    return $f36abaf9e6893e6c$var$currentImpl(value);
}
function $f36abaf9e6893e6c$var$currentImpl(value) {
    if (!$f36abaf9e6893e6c$export$16e3aed3edb85946(value) || $f36abaf9e6893e6c$var$isFrozen(value)) return value;
    const state = value[$f36abaf9e6893e6c$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $f36abaf9e6893e6c$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $f36abaf9e6893e6c$var$shallowCopy(value, true);
    $f36abaf9e6893e6c$var$each(copy, (key, childValue)=>{
        $f36abaf9e6893e6c$var$set(copy, key, $f36abaf9e6893e6c$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $f36abaf9e6893e6c$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            var _state_parent__copy_;
            const parentCopy = (_state_parent__copy_ = state.parent_.copy_) !== null && _state_parent__copy_ !== void 0 ? _state_parent__copy_ : state.parent_.base_;
            const proxyDraft = $f36abaf9e6893e6c$var$getProxyDraft($f36abaf9e6893e6c$var$get(parentCopy, state.key_));
            const valueAtKey = $f36abaf9e6893e6c$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $f36abaf9e6893e6c$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $f36abaf9e6893e6c$var$get(current2, key);
            if (!$f36abaf9e6893e6c$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ === null || assigned_ === void 0 ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem === null || copiedItem === void 0 ? void 0 : copiedItem[$f36abaf9e6893e6c$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $f36abaf9e6893e6c$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $f36abaf9e6893e6c$var$get(base_, key, type_);
            const value = $f36abaf9e6893e6c$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $f36abaf9e6893e6c$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $f36abaf9e6893e6c$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $f36abaf9e6893e6c$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $f36abaf9e6893e6c$var$CONSTRUCTOR)) $f36abaf9e6893e6c$var$die(errorOffset + 3);
                if ($f36abaf9e6893e6c$var$isFunction(base) && p === $f36abaf9e6893e6c$var$PROTOTYPE) $f36abaf9e6893e6c$var$die(errorOffset + 3);
                base = $f36abaf9e6893e6c$var$get(base, p);
                if (base === null || !$f36abaf9e6893e6c$var$isObjectish(base)) $f36abaf9e6893e6c$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $f36abaf9e6893e6c$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $f36abaf9e6893e6c$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $f36abaf9e6893e6c$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$f36abaf9e6893e6c$export$16e3aed3edb85946(obj)) return obj;
        if ($f36abaf9e6893e6c$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($f36abaf9e6893e6c$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($f36abaf9e6893e6c$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($f36abaf9e6893e6c$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($f36abaf9e6893e6c$var$has(obj, $f36abaf9e6893e6c$export$6ee2082928bcb0ee)) cloned[$f36abaf9e6893e6c$export$6ee2082928bcb0ee] = obj[$f36abaf9e6893e6c$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($f36abaf9e6893e6c$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $f36abaf9e6893e6c$var$loadPlugin($f36abaf9e6893e6c$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $f36abaf9e6893e6c$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $f36abaf9e6893e6c$var$latest(this[$f36abaf9e6893e6c$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $f36abaf9e6893e6c$var$latest(this[$f36abaf9e6893e6c$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$f36abaf9e6893e6c$var$latest(state).has(key) || $f36abaf9e6893e6c$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $f36abaf9e6893e6c$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $f36abaf9e6893e6c$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $f36abaf9e6893e6c$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f36abaf9e6893e6c$var$latest(state).size) {
                prepareMapCopy(state);
                $f36abaf9e6893e6c$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $f36abaf9e6893e6c$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            $f36abaf9e6893e6c$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $f36abaf9e6893e6c$var$latest(state).get(key);
            if (state.finalized_ || !$f36abaf9e6893e6c$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $f36abaf9e6893e6c$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $f36abaf9e6893e6c$var$latest(this[$f36abaf9e6893e6c$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($f36abaf9e6893e6c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$f36abaf9e6893e6c$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f36abaf9e6893e6c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
    }
    function iteratorFrom(iterable) {
        if (typeof Iterator !== "undefined") return Iterator.from(iterable);
        const iterator = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, iterable), {
            [Symbol.iterator]: ()=>iterator
        });
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$f36abaf9e6893e6c$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $f36abaf9e6893e6c$var$latest(this[$f36abaf9e6893e6c$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $f36abaf9e6893e6c$var$markChanged(state);
                state.copy_.add(value);
                $f36abaf9e6893e6c$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $f36abaf9e6893e6c$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f36abaf9e6893e6c$var$latest(state).size) {
                prepareSetCopy(state);
                $f36abaf9e6893e6c$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$f36abaf9e6893e6c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($f36abaf9e6893e6c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$f36abaf9e6893e6c$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f36abaf9e6893e6c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$f36abaf9e6893e6c$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($f36abaf9e6893e6c$export$16e3aed3edb85946(value)) {
                    const draft = $f36abaf9e6893e6c$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $f36abaf9e6893e6c$var$die(3, JSON.stringify($f36abaf9e6893e6c$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($f36abaf9e6893e6c$var$getValue(value));
            });
        }
    }
    $f36abaf9e6893e6c$var$loadPlugin($f36abaf9e6893e6c$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $f36abaf9e6893e6c$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $f36abaf9e6893e6c$var$prepareCopy(state);
        const result = operation();
        $f36abaf9e6893e6c$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $f36abaf9e6893e6c$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            var _args_;
                            const startIndex = normalizeSliceIndex((_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $f36abaf9e6893e6c$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            var _args_;
            const rawStart = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : 0;
            var _args_1;
            const rawEnd = (_args_1 = args[1]) !== null && _args_1 !== void 0 ? _args_1 : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $f36abaf9e6893e6c$var$loadPlugin($f36abaf9e6893e6c$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $f36abaf9e6893e6c$var$immer = new $f36abaf9e6893e6c$export$aaadc6ff0f822719();
var $f36abaf9e6893e6c$export$b46cabe22e78bc00 = $f36abaf9e6893e6c$var$immer.produce;
var $f36abaf9e6893e6c$export$4da66d41c9492c78 = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.produceWithPatches.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$573f26f60825c493 = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.setAutoFreeze.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$333ce65961cbe047 = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.setUseStrictShallowCopy.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$1045b3be3904c489 = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.setUseStrictIteration.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.applyPatches.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$3c3214997190395f = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.createDraft.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$c60f5e69c521b528 = /* @__PURE__ */ $f36abaf9e6893e6c$var$immer.finishDraft.bind($f36abaf9e6893e6c$var$immer);
var $f36abaf9e6893e6c$export$c05b21e3257751e5 = (value)=>value;
var $f36abaf9e6893e6c$export$20f911b3f8cf0b74 = (value)=>value;


const $d50bbc3134998c1f$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...args)=>{
            const nextState = typeof updater === "function" ? (0, $f36abaf9e6893e6c$export$b46cabe22e78bc00)(updater) : updater;
            return set(nextState, replace, ...args);
        };
        return initializer(store.setState, get, store);
    };
const $d50bbc3134998c1f$export$428de7ec69ac95c = $d50bbc3134998c1f$var$immerImpl;


// Pre-initialize the listeners object for every event in EventMap,
// with explicit type assertions for each empty array.
const $e7df95de73caec26$var$listeners = {
    accessibilityAppChange: [],
    accessibilityFocusChange: [],
    accessibilityMethodRequest: [],
    accessibilityMethodResponse: [],
    accessibilityViewChange: [],
    accessibilityAnchorChange: [],
    stopAnchorTracking: [],
    analyticsTrackEvent: [],
    alertSuccess: [],
    alertError: [],
    alertWarning: [],
    audioStream: [],
    blurPanelNoReset: [],
    hotkeyCommand: [],
    stopListening: [],
    userProfileAdded: [],
    userProfileUpdated: [],
    userProfileDeleted: [],
    profileDeleted: [],
    voiceCommandFinal: [],
    voiceCommandPartial: [],
    voiceCommandPaused: [],
    voiceCommandDictation: [],
    voiceCommandHandled: [],
    cameraCommandHandled: [],
    voiceStopped: [],
    nowPlaying: [],
    updateUserLicenseAccess: [],
    userLicenseChangeLocal: [],
    userLocalePreferencesUpdated: [],
    userFeatureFlagsUpdated: [],
    userUpdated: [],
    whisperInitialize: [],
    whisperStart: [],
    whisperStop: [],
    whisperTerminate: [],
    currentDeviceUpdated: [],
    favoritesNeedSave: [],
    requestPanelFavorites: [],
    panelFavoritesResponse: [],
    remoteDeviceCommand: [],
    navigateTo: [],
    tourStarted: [],
    tourEnded: [],
    tourStepChanged: [],
    tourPaused: [],
    tourFocusSource: [],
    // from IPC events
    'force-reconnect': [],
    'license-trial-started': [],
    'default-profiles-updated': [],
    'update-voice-dictation-controls': [],
    'remove-device': [],
    'device-added': []
};
// A helper function to narrow the type of the listeners array for a given event key
function $e7df95de73caec26$var$getListeners(event) {
    return $e7df95de73caec26$var$listeners[event];
}
function $e7df95de73caec26$export$ec068583843480e7(event, callback) {
    // Add the callback to the event's listener array
    $e7df95de73caec26$var$getListeners(event).push(callback);
    // Instead of reassigning listeners[event] with a filtered array,
    // we remove the callback from the existing array in place.
    return ()=>{
        const arr = $e7df95de73caec26$var$getListeners(event);
        const index = arr.indexOf(callback);
        if (index !== -1) arr.splice(index, 1);
    };
}
function $e7df95de73caec26$export$89b472e03be495df(event, ...payload) {
    var _listeners_event;
    const data = payload[0];
    (_listeners_event = $e7df95de73caec26$var$listeners[event]) === null || _listeners_event === void 0 ? void 0 : _listeners_event.forEach((cb)=>cb(data));
}
function $e7df95de73caec26$var$hasInitiator(obj) {
    return !!obj && typeof obj === 'object' && 'initiator' in obj;
}
function $e7df95de73caec26$export$8f65b2710ad2adaf(eventNames, initiatorRef, sendFn) {
    const unsubscribers = eventNames.map((eventName)=>$e7df95de73caec26$export$ec068583843480e7(eventName, (event)=>{
            if ($e7df95de73caec26$var$hasInitiator(event) && event.initiator === initiatorRef.current) sendFn(eventName, event);
        }));
    return ()=>unsubscribers.forEach((unsub)=>unsub());
}


const $15df2073755d9d49$export$eb5036441d82cea3 = (c, hotkeys)=>{
    if (c.hotkeyLocalId !== undefined) return c.hotkeyLocalId;
    const matchingHotkey = hotkeys.find((hotkey)=>hotkey.command === c.command);
    if (matchingHotkey) return matchingHotkey === null || matchingHotkey === void 0 ? void 0 : matchingHotkey.localId;
};
const $15df2073755d9d49$export$8887ad9c8dfc8e0a = (hotkey, macros)=>{
    const matchingMacro = macros.find((macro)=>macro.commands.some((macroCommand)=>macroCommand.command === hotkey.command));
    if (!matchingMacro) return;
    const i = macros.indexOf(matchingMacro);
    return {
        m: matchingMacro,
        index: i
    };
};
const $15df2073755d9d49$export$bb07e30d9b3432d = (c, hotkeys)=>{
    const matchingHotkey = hotkeys.find((hotkey)=>hotkey.command === c.command);
    if (!matchingHotkey) return;
    const i = hotkeys.indexOf(matchingHotkey);
    return {
        match: matchingHotkey,
        index: i
    };
};






const $03a56fb167cf9474$export$caaa93ee9052213c = [
    {
        eventType: 'KeyPress',
        displayName: 'common:event.keyPress.title'
    },
    {
        eventType: 'KeyRelease',
        displayName: 'common:event.keyRelease.title'
    },
    {
        eventType: 'KeyToggle',
        displayName: 'common:event.keyToggle.title'
    },
    {
        eventType: 'Pause',
        displayName: 'common:event.pause.title'
    },
    {
        eventType: 'Type',
        displayName: 'common:event.type.title'
    },
    {
        eventType: 'MouseMove',
        displayName: 'common:event.mouseMove.title'
    },
    {
        eventType: 'JoysticksMove',
        displayName: 'common:event.joystickMove.title'
    },
    {
        eventType: 'PlayAudio',
        displayName: 'common:event.playAudio.title'
    },
    {
        eventType: 'StopOutputs',
        displayName: 'common:event.stopOutputs.title'
    },
    {
        eventType: 'DeviceTypeCustomAction',
        displayName: 'common:event.custom.title'
    }
];
const $03a56fb167cf9474$export$7e8bcaa1250bba4e = (macroEvent)=>{
    return macroEvent.eventType == 'KeyPress' && macroEvent.holdTimeMilliseconds != null || macroEvent.eventType == 'Pause';
};


const $9d76aba0a210d2c6$export$ec2c4b4373af4b61 = (params)=>{
    const { macros: macros, dictationCommands: dictationCommands, profileId: profileId, t: t } = params;
    const macrosWithVoiceCommands = macros.filter((m)=>m.commands.some((c)=>c.commandType === 'voice' && c.command !== ''));
    const nonEmptyDictationCommands = dictationCommands.filter((c)=>c !== '').map((c)=>c.toLowerCase());
    const conflictingVoiceCommands = [];
    macrosWithVoiceCommands.forEach((macro)=>{
        macro.commands.forEach((c)=>{
            if (nonEmptyDictationCommands.includes(c.command.toLowerCase())) {
                var _macro_name;
                const macroName = (_macro_name = macro.name) !== null && _macro_name !== void 0 ? _macro_name : $9d76aba0a210d2c6$export$61a248617ae833c4(c.command, t);
                conflictingVoiceCommands.push({
                    key: 'MacroVoiceCommandWithDictation',
                    scrollID: macro.id,
                    displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(macroName, c.command, c.commandType, t),
                    pageLink: `/profiles/edit/${profileId}`
                });
            }
        });
    });
    return conflictingVoiceCommands;
};
const $9d76aba0a210d2c6$export$845f2f159de600e0 = (params)=>{
    const { commandKeyMappings: commandKeyMappings, dictationCommands: dictationCommands, profileId: profileId, t: t } = params;
    const keybindingsWithVoiceCommands = commandKeyMappings.filter((c)=>c.commands.some((c)=>c.commandType === 'voice' && c.command !== ''));
    const nonEmptyDictationCommands = dictationCommands.filter((c)=>c !== '').map((c)=>c.toLowerCase());
    const conflictingVoiceCommands = [];
    keybindingsWithVoiceCommands.forEach((keybinding)=>{
        keybinding.commands.forEach((c)=>{
            if (nonEmptyDictationCommands.includes(c.command.toLowerCase())) conflictingVoiceCommands.push({
                key: 'KeybindingVoiceCommandWithDictation',
                scrollID: keybinding.key,
                displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(keybinding.displayName, c.command, c.commandType, t),
                pageLink: `/profiles/edit/${profileId}/advanced/keybindings`
            });
        });
    });
    return conflictingVoiceCommands;
};
const $9d76aba0a210d2c6$export$eb3146089825fa9d = (params)=>{
    const { commandKeyMappings: commandKeyMappings, profileId: profileId, t: t } = params;
    const commands = [];
    commandKeyMappings.forEach((keyCommand)=>{
        const nonEmptyCommands = keyCommand.commands.filter((c)=>c.command !== '');
        const transformedCommands = nonEmptyCommands.map((commandModel)=>{
            let commandName = $9d76aba0a210d2c6$export$a9e54ec0b37334dc(commandModel.command, t);
            if (commandModel.commandType === 'voice') commandName = commandName.toLowerCase();
            return {
                commandDisplayName: commandName,
                commandType: commandModel.commandType,
                macroOrKeyName: keyCommand.displayName,
                macroOrKeyId: keyCommand.key,
                pageLink: `/profiles/edit/${profileId}/advanced/keybindings`
            };
        });
        commands.push(...transformedCommands);
    });
    return $9d76aba0a210d2c6$export$69d072b3a37082dd(commands, 'DuplicateKeybindingInputCommands', t);
};
const $9d76aba0a210d2c6$export$69d072b3a37082dd = (allCommands, key, t)=>{
    const alreadySeen = {};
    const duplicated = [];
    // Create a map of command input names and control type to a list of macros or keybindings
    allCommands.forEach((commandModel)=>{
        const keyStr = `${commandModel.commandDisplayName}_${commandModel.commandType}`;
        if (!alreadySeen[keyStr]) alreadySeen[keyStr] = [];
        alreadySeen[keyStr].push({
            id: commandModel.macroOrKeyId,
            name: commandModel.macroOrKeyName,
            pageLink: commandModel.pageLink
        });
    });
    // Create the duplicate conflicting commands list
    for(const commandModelKey in alreadySeen)if (alreadySeen[commandModelKey].length > 1) {
        const [inputName, controlType] = commandModelKey.split('_');
        alreadySeen[commandModelKey].forEach((conflictDetail)=>{
            duplicated.push({
                key: key,
                scrollID: conflictDetail.id,
                displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(conflictDetail.name, inputName, controlType, t),
                pageLink: conflictDetail.pageLink
            });
        });
    }
    return duplicated;
};
const $9d76aba0a210d2c6$export$4a2e027df0dfc855 = (params)=>{
    const { associatedPrograms: associatedPrograms, profileId: profileId } = params;
    const uniqueNames = new Set();
    const duplicatedNames = [];
    associatedPrograms.forEach((name, idx)=>{
        const lowerCaseName = name.toLowerCase();
        if (lowerCaseName === '') return;
        if (uniqueNames.has(lowerCaseName)) duplicatedNames.push({
            displayString: name,
            key: 'DuplicateAssociatedProgramsName',
            pageLink: `/profiles/edit/${profileId}`,
            scrollID: `${idx}_associated_program_field`
        });
        else uniqueNames.add(lowerCaseName);
    });
    return duplicatedNames;
};
const $9d76aba0a210d2c6$export$1d55b5fa728affd1 = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const emptyCommands = [];
    const emptyCommandName = t('common:noName');
    macros.forEach((macro)=>{
        macro.commands.forEach((c)=>{
            if (!c.command) {
                var _macro_name;
                const macroName = (_macro_name = macro.name) !== null && _macro_name !== void 0 ? _macro_name : t('common:noName');
                emptyCommands.push({
                    key: 'EmptyMacroInputs',
                    scrollID: macro.id,
                    displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(macroName, emptyCommandName, c.commandType, t),
                    pageLink: `/profiles/edit/${profileId}`
                });
            }
        });
    });
    return emptyCommands;
};
const $9d76aba0a210d2c6$export$639d475f7be72f7d = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const commands = [];
    macros.forEach((macro)=>{
        const nonEmptyCommands = macro.commands.filter((c)=>c.command !== '');
        const transformedCommands = nonEmptyCommands.map((commandModel)=>{
            let commandName = $9d76aba0a210d2c6$export$a9e54ec0b37334dc(commandModel.command, t);
            if (commandModel.commandType === 'voice') commandName = commandName.toLowerCase();
            var _macro_name;
            return {
                commandDisplayName: commandName,
                commandType: commandModel.commandType,
                macroOrKeyName: (_macro_name = macro.name) !== null && _macro_name !== void 0 ? _macro_name : $9d76aba0a210d2c6$export$61a248617ae833c4(commandModel.command, t),
                macroOrKeyId: macro.id,
                pageLink: `/profiles/edit/${profileId}`
            };
        });
        commands.push(...transformedCommands);
    });
    return $9d76aba0a210d2c6$export$69d072b3a37082dd(commands, 'DuplicateMacroInputCommands', t);
};
const $9d76aba0a210d2c6$export$b59cab01f4e26d1b = (params)=>{
    const { macros: macros, profileId: profileId, defaultLocale: defaultLocale, t: t } = params;
    const unreleasedLatchedKeys = [];
    // Filter on macros with latched keys and those with release or toggle event key types
    const macrosWithLatchedKeys = macros.filter((macro)=>macro.events.some((event)=>event.isKeyLatch));
    const macrosWithReleaseKeys = macros.filter((macro)=>macro.events.some((event)=>event.eventType === 'KeyRelease' || event.eventType === 'KeyToggle'));
    const stopAllMacros = macros.filter((macro)=>macro.events.some((event)=>event.eventType === 'StopOutputs'));
    // StopOutputs trumps all other key release types
    if (stopAllMacros.length === 0) {
        // Flatten release keys to an array of strings
        const releaseKeysPerMacro = macrosWithReleaseKeys.flatMap((macro)=>macro.events.map((event)=>event.keys));
        const releaseKeys = releaseKeysPerMacro.flat();
        // Iterate through each latched macro and find a release key
        macrosWithLatchedKeys.forEach((macro)=>{
            macro.events.forEach((event)=>{
                if (event.isKeyLatch && event.keys) for (const latchKey of event.keys){
                    const hasReleasedKey = releaseKeys.length > 0 && releaseKeys.includes(latchKey);
                    if (!hasReleasedKey) {
                        var _macro_commands_, _macro_commands;
                        const eventTypeDisplayName = t($9d76aba0a210d2c6$export$be0c0c806bbe3773(event.eventType));
                        var _macro_name;
                        unreleasedLatchedKeys.push({
                            key: 'UnreleasedLatchedKey',
                            scrollID: macro.id,
                            displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27((_macro_name = macro.name) !== null && _macro_name !== void 0 ? _macro_name : $9d76aba0a210d2c6$export$61a248617ae833c4((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command, t), (0, $9a9874d925dad9cc$export$a23a68036192c276)(latchKey, defaultLocale), eventTypeDisplayName, t),
                            pageLink: `/profiles/edit/${profileId}`
                        });
                    }
                }
            });
        });
    }
    return unreleasedLatchedKeys;
};
const $9d76aba0a210d2c6$export$134d4256d4cafcf4 = (params)=>{
    const { commandKeyMappings: commandKeyMappings, profileId: profileId, t: t } = params;
    const emptyCommands = [];
    const emptyCommandName = t('common:noName');
    commandKeyMappings.forEach((mapping)=>{
        mapping.commands.forEach((c)=>{
            if (!c.command) emptyCommands.push({
                key: 'EmptyKeybindingInputs',
                scrollID: mapping.key,
                displayString: $9d76aba0a210d2c6$export$a507c6cda418ed27(mapping.displayName, emptyCommandName, c.commandType, t),
                pageLink: `/profiles/edit/${profileId}/advanced/keybindings`
            });
        });
    });
    return emptyCommands;
};
const $9d76aba0a210d2c6$export$7b817b6bf4f2cb70 = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const uniqueNames = new Set();
    const duplicatedNames = [];
    const noNameText = t('common:noName');
    macros.forEach((macro)=>{
        var _macro_commands_, _macro_commands;
        var _macro_name;
        const macroName = (_macro_name = macro.name) !== null && _macro_name !== void 0 ? _macro_name : $9d76aba0a210d2c6$export$61a248617ae833c4((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command, t);
        if (macroName === noNameText) return;
        if (uniqueNames.has(macroName)) duplicatedNames.push({
            displayString: macroName,
            key: 'DuplicateMacroName',
            pageLink: `/profiles/edit/${profileId}`,
            scrollID: macro.id
        });
        else uniqueNames.add(macroName);
    });
    return duplicatedNames;
};
const $9d76aba0a210d2c6$export$a634520ef9a79c74 = (params)=>{
    const { macros: macros, profileId: profileId, t: t } = params;
    const emptyKeyConflicts = [];
    const eventTypeKey = [
        'KeyPress',
        'KeyRelease',
        'KeyToggle'
    ];
    const eventTypeTextInput = [
        'Type',
        'PlayAudio'
    ];
    const isEmptyEvent = (event)=>{
        const isKeyEventEmpty = eventTypeKey.includes(event.eventType) && (!event.keys || event.keys.length === 0 || event.keys.some((key)=>!key));
        const isFreeFormEventEmpty = eventTypeTextInput.includes(event.eventType) && !(event.typedPhrase || event.outputSpeech || event.additionalInputContent);
        return isKeyEventEmpty || isFreeFormEventEmpty;
    };
    macros.forEach((macro)=>{
        var _macro_commands_;
        var _macro_name;
        const macroName = (_macro_name = macro.name) !== null && _macro_name !== void 0 ? _macro_name : $9d76aba0a210d2c6$export$61a248617ae833c4((_macro_commands_ = macro.commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command, t);
        macro.events.forEach((event)=>{
            const eventTypeDisplayName = t($9d76aba0a210d2c6$export$be0c0c806bbe3773(event.eventType));
            if (isEmptyEvent(event)) emptyKeyConflicts.push({
                displayString: `${macroName}: ${eventTypeDisplayName}`,
                key: 'EmptyEvent',
                pageLink: `/profiles/edit/${profileId}`,
                scrollID: macro.id
            });
        });
    });
    return emptyKeyConflicts;
};
const $9d76aba0a210d2c6$export$be0c0c806bbe3773 = (eventType)=>{
    var _macroEventTypes_find;
    return (_macroEventTypes_find = (0, $03a56fb167cf9474$export$caaa93ee9052213c).find((macroDisplayType)=>macroDisplayType.eventType === eventType)) === null || _macroEventTypes_find === void 0 ? void 0 : _macroEventTypes_find.displayName;
};
const $9d76aba0a210d2c6$export$d1b24cb1984823a4 = (keybinds)=>{
    return keybinds.map((k)=>({
            commands: k.commands.map((c)=>c.command),
            key: k.key
        }));
};
const $9d76aba0a210d2c6$export$f31ec4fcec40d1f9 = (defaultKeybindings, profileKeybindings = [])=>{
    const profileBindingsMap = Object.fromEntries(profileKeybindings.map((k)=>[
            k.key,
            k
        ]));
    // Union of default and profile keybindings. Priority to profile keybindings, but following the order of default keybindings for consistency
    const unionKeybindings = defaultKeybindings.map((defaultKey)=>profileBindingsMap[defaultKey.key] || defaultKey);
    if (!(profileKeybindings === null || profileKeybindings === void 0 ? void 0 : profileKeybindings.length) || profileKeybindings.every((k)=>k.commands.length === 0)) // no command keys or empty commands in profile keybindings
    return unionKeybindings.map((k)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
            commands: []
        }));
    return unionKeybindings;
};
const $9d76aba0a210d2c6$export$9f33ffede7fa8708 = (title, items, conflictList, subtitle)=>{
    if (items.length > 0) conflictList.push({
        title: title,
        items: items,
        subtitle: subtitle
    });
};
function $9d76aba0a210d2c6$export$a9e54ec0b37334dc(command, t) {
    if (!command) return t('common:noName');
    if (command.startsWith('mouse_move')) return t('common:event.mouseMove.command', 'Move mouse', {
        command: command.replace('mouse_move', '')
    });
    const commandControl = (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((c)=>c.value === command);
    if (commandControl) {
        var _commandControl_translationKey;
        if (commandControl.isExternalKeyboard) return (_commandControl_translationKey = commandControl.translationKey) !== null && _commandControl_translationKey !== void 0 ? _commandControl_translationKey : commandControl.title;
        else return t(commandControl.title);
    }
    if (command.startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257))) return t('common:hotkey.tap', 'Tap', {
        value: command.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '')
    });
    return t('common:voice.say', 'Say', {
        value: command
    });
}
const $9d76aba0a210d2c6$export$61a248617ae833c4 = (command, t)=>{
    if (!command) return t('common:noName');
    const commandControl = (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((c)=>c.value === command);
    if (commandControl) {
        var _commandControl_translationKey;
        if (commandControl.isExternalKeyboard) return (_commandControl_translationKey = commandControl.translationKey) !== null && _commandControl_translationKey !== void 0 ? _commandControl_translationKey : commandControl.title;
        else return t(commandControl.title ? commandControl.title : 'common:noName');
    }
    return command;
};
const $9d76aba0a210d2c6$export$a507c6cda418ed27 = (macroOrBindingName, commandOrKeyName, commandOrEventType, t)=>{
    return t('common:profile.conflictIndicators.conflictIndicatorDisplayString', `${macroOrBindingName} : ${commandOrKeyName} with ${commandOrEventType}`, {
        container: macroOrBindingName,
        commandOrKeyName: commandOrKeyName,
        commandOrEventType: commandOrEventType
    });
};







const $eec5c3b697f8e81e$export$19e7a64c17ac6a78 = 'enableHeadMouseMode';
const $eec5c3b697f8e81e$export$cc151e4b60d415ed = 'enableCephablePanel';
const $eec5c3b697f8e81e$export$47004e5aac15b5cd = 'enableAutomaticProfileSwitching';
const $eec5c3b697f8e81e$export$ff16be44cd4b36c3 = 'enableTextGeneration';
const $eec5c3b697f8e81e$export$e76346433d751760 = 'enableWizard';
const $eec5c3b697f8e81e$export$489136a71f0926f1 = 'EnableAiCommands';
const $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0 = 'enableAiDictation';
const $eec5c3b697f8e81e$export$57439186bae3e5ef = 'enableTranscribeTask';
const $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef = 'enableClickByName';
const $eec5c3b697f8e81e$export$16bd572ace4b0246 = 'enableGamepadSupport';
const $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce = 'enableMetrics';
const $eec5c3b697f8e81e$export$68822a6b235e54e4 = 'enableAiWorkflows';
const $eec5c3b697f8e81e$export$f351df74bb42c5a0 = 'enableCameraControls';
const $eec5c3b697f8e81e$export$a03beec7b09ea513 = 'enableAutomateHttpServer';
const $eec5c3b697f8e81e$export$1c029ef4161fe2e4 = 'enableAiSkills';
const $eec5c3b697f8e81e$export$ae2452952df1e5a2 = 'enableAiSkillSharing';
const $eec5c3b697f8e81e$export$110d1b5f34449692 = 'enableMcpServers';
const $eec5c3b697f8e81e$export$509495694e43d6c0 = 'enableMcpServerSharing';
const $eec5c3b697f8e81e$export$e0d688bebf509f71 = 'enableWorkflowRecording';
const $eec5c3b697f8e81e$export$9338f61da19c4759 = {
    personal: [
        $eec5c3b697f8e81e$export$16bd572ace4b0246,
        $eec5c3b697f8e81e$export$f351df74bb42c5a0
    ],
    isPlusAccess: [
        $eec5c3b697f8e81e$export$16bd572ace4b0246,
        $eec5c3b697f8e81e$export$f351df74bb42c5a0
    ],
    isEmployeeAccess: [
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$f351df74bb42c5a0,
        $eec5c3b697f8e81e$export$1c029ef4161fe2e4,
        $eec5c3b697f8e81e$export$110d1b5f34449692,
        $eec5c3b697f8e81e$export$e0d688bebf509f71
    ],
    isStudentAccess: [
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$f351df74bb42c5a0
    ],
    isDeveloperAccess: [
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$f351df74bb42c5a0,
        $eec5c3b697f8e81e$export$1c029ef4161fe2e4,
        $eec5c3b697f8e81e$export$110d1b5f34449692
    ]
};
const $eec5c3b697f8e81e$export$97f1def75ed4b43c = [
    ...new Set(Object.values($eec5c3b697f8e81e$export$9338f61da19c4759).flat())
]; // All unique beta feature flags for all license types
const $eec5c3b697f8e81e$export$89398edf022c69af = [
    $eec5c3b697f8e81e$export$47004e5aac15b5cd,
    $eec5c3b697f8e81e$export$cc151e4b60d415ed,
    $eec5c3b697f8e81e$export$19e7a64c17ac6a78,
    $eec5c3b697f8e81e$export$16bd572ace4b0246
];
const $eec5c3b697f8e81e$export$9e1a6fca7c3450cd = [
    'isPlusAccess',
    'isEmployeeAccess',
    'isDeveloperAccess',
    'isStudentAccess'
];
const $eec5c3b697f8e81e$export$59d8b275b5119f03 = [
    'isEmployeeAccess',
    'isDeveloperAccess',
    'isStudentAccess',
    'isPlusAccess',
    'personal'
];
const $eec5c3b697f8e81e$export$edc04589e178d7ee = {
    isEmployeeAccess: [
        $eec5c3b697f8e81e$export$ff16be44cd4b36c3,
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0,
        $eec5c3b697f8e81e$export$68822a6b235e54e4,
        $eec5c3b697f8e81e$export$cbbbf2d12e5a7bce,
        $eec5c3b697f8e81e$export$16bd572ace4b0246,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef,
        $eec5c3b697f8e81e$export$a03beec7b09ea513
    ],
    isDeveloperAccess: [
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0,
        $eec5c3b697f8e81e$export$16bd572ace4b0246,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef
    ],
    isStudentAccess: [
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0,
        $eec5c3b697f8e81e$export$16bd572ace4b0246,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef
    ],
    isPlusAccess: [
        $eec5c3b697f8e81e$export$ff16be44cd4b36c3,
        $eec5c3b697f8e81e$export$489136a71f0926f1,
        $eec5c3b697f8e81e$export$e76346433d751760,
        $eec5c3b697f8e81e$export$c51d6dbcab7ae7e0,
        $eec5c3b697f8e81e$export$16bd572ace4b0246,
        $eec5c3b697f8e81e$export$a82e5a6dbb0cf7ef
    ]
};
const $eec5c3b697f8e81e$export$a231937237d0f395 = (flag)=>{
    if ($eec5c3b697f8e81e$export$89398edf022c69af.includes(flag)) return 'personal';
    for (const licenseType of $eec5c3b697f8e81e$export$9e1a6fca7c3450cd){
        const flags = $eec5c3b697f8e81e$export$edc04589e178d7ee[licenseType];
        if (flags && flags.includes(flag)) return licenseType;
    }
    for (const licenseType of Object.keys($eec5c3b697f8e81e$export$9338f61da19c4759)){
        const flags = $eec5c3b697f8e81e$export$9338f61da19c4759[licenseType];
        if (flags && flags.includes(flag)) return licenseType;
    }
    return;
};
const $eec5c3b697f8e81e$export$aca9a606a8b2695d = (flags)=>{
    if (!flags || flags.length === 0) return;
    const licenseTypesFound = new Set();
    for (const flag of flags){
        const licenseType = $eec5c3b697f8e81e$export$a231937237d0f395(flag);
        if (licenseType) licenseTypesFound.add(licenseType);
    }
    if (licenseTypesFound.size === 0) return; // No valid license types found
    for (const licenseType of $eec5c3b697f8e81e$export$59d8b275b5119f03){
        if (licenseTypesFound.has(licenseType)) return licenseType;
    }
    return;
};










const $8a1185b15e8317ab$export$f0a7cfd15e08fac3 = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
var $cfd4b075d263c876$exports = {};
$cfd4b075d263c876$exports = $parcel$resolve("dHypX");


// ---- Derived-state helpers (pure functions, no store dependency) ----
function $8a1185b15e8317ab$var$computeUserLicenseType(access) {
    if (access === null || access === void 0 ? void 0 : access.isEmployeeAccess) return 'isEmployeeAccess';
    if (access === null || access === void 0 ? void 0 : access.isStudentAccess) return 'isStudentAccess';
    if (access === null || access === void 0 ? void 0 : access.isDeveloperAccess) return 'isDeveloperAccess';
    if (access === null || access === void 0 ? void 0 : access.isPlusAccess) return 'isPlusAccess';
    return 'personal';
}
function $8a1185b15e8317ab$var$computeUserBetaFeatureFlags(access) {
    const result = [
        ...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['personal']
    ];
    if (access === null || access === void 0 ? void 0 : access.isEmployeeAccess) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isEmployeeAccess']);
    if (access === null || access === void 0 ? void 0 : access.isStudentAccess) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isStudentAccess']);
    if (access === null || access === void 0 ? void 0 : access.isDeveloperAccess) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isDeveloperAccess']);
    if (access === null || access === void 0 ? void 0 : access.isPlusAccess) result.push(...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['isPlusAccess']);
    return [
        ...new Set(result)
    ];
}
function $8a1185b15e8317ab$var$computeHasNoOrgMemberships(access) {
    var _access_organizationLicenses;
    var _access_organizationLicenses_length;
    return ((_access_organizationLicenses_length = access === null || access === void 0 ? void 0 : (_access_organizationLicenses = access.organizationLicenses) === null || _access_organizationLicenses === void 0 ? void 0 : _access_organizationLicenses.length) !== null && _access_organizationLicenses_length !== void 0 ? _access_organizationLicenses_length : 0) === 0;
}
function $8a1185b15e8317ab$var$computeIsLicenseExpired(access) {
    return (access === null || access === void 0 ? void 0 : access.licenseExpirationDate) ? new Date(access.licenseExpirationDate) < new Date() : false;
}
const $8a1185b15e8317ab$var$defaultLocalePrefs = {
    defaultLocale: (0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018),
    defaultVoiceLocale: (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec)
};
const $8a1185b15e8317ab$export$887dff289a6ce108 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((set, get)=>{
    const getValidatedUserLocales = (request)=>{
        var _getSupportedLocale;
        const defaultLocale = (_getSupportedLocale = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(request.defaultLocale, 'display')) !== null && _getSupportedLocale !== void 0 ? _getSupportedLocale : (0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018);
        var _getSupportedLocale1;
        const defaultVoiceLocale = (_getSupportedLocale1 = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(request.defaultVoiceLocale, 'voice')) !== null && _getSupportedLocale1 !== void 0 ? _getSupportedLocale1 : (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
        return {
            defaultLocale: defaultLocale,
            defaultVoiceLocale: defaultVoiceLocale
        };
    };
    const changeAppLanguage = (displayLocale)=>{
        if ((0, $4817740e8b777c73$export$2e2bcd8739ae039).language !== displayLocale) (0, $4817740e8b777c73$export$2e2bcd8739ae039).changeLanguage(displayLocale, (error)=>{
            if (error) console.error(`Unsupported language ${displayLocale}. Defaulting to ${(0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018)}`);
            else localStorage.setItem('displayLocale', displayLocale);
        });
    };
    const informUserOfFallbackModel = (modelUrl, voiceLocale)=>{
        if (voiceLocale !== (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec) && modelUrl === $cfd4b075d263c876$exports) set({
            showUserFallbackDialog: true
        });
    };
    const updateVoiceModelUrl = (modelUrl)=>{
        if (modelUrl !== get().voiceModelUrl) {
            localStorage.setItem('VOICE_MODEL_URL', modelUrl);
            set({
                voiceModelUrl: modelUrl
            });
        }
    };
    const loadVoiceModelUrl = async (voiceLocale, isMainWindow, requestUrl)=>{
        var _ref;
        let modelUrl = (_ref = requestUrl !== null && requestUrl !== void 0 ? requestUrl : localStorage.getItem('VOICE_MODEL_URL')) !== null && _ref !== void 0 ? _ref : $cfd4b075d263c876$exports;
        try {
            set({
                isLoading: true
            });
            if (isMainWindow) {
                const result = await $1a4c36336f303477$export$78ac26d691c779f4(voiceLocale, 'tar.gz');
                if (result.resultType === 'Ok' && result.data) modelUrl = result.data.fileUrl;
            }
        } catch (error) {
            set({
                errors: [
                    `Error loading voice model. ${error}`
                ]
            });
        } finally{
            updateVoiceModelUrl(modelUrl);
            informUserOfFallbackModel(modelUrl, voiceLocale);
            set({
                isLoading: false
            });
        }
        return modelUrl;
    };
    const setShowUserFallbackDialog = (v)=>set({
            showUserFallbackDialog: v
        });
    const setSignalRConnected = (v)=>set({
            signalRConnected: v
        });
    const setPendingTosConfig = (config)=>set({
            pendingTosConfig: config
        });
    const isFreeUser = ()=>{
        const acc = get().userLicenseAccess;
        return !((acc === null || acc === void 0 ? void 0 : acc.isDeveloperAccess) || (acc === null || acc === void 0 ? void 0 : acc.isEmployeeAccess) || (acc === null || acc === void 0 ? void 0 : acc.isStudentAccess) || (acc === null || acc === void 0 ? void 0 : acc.isPlusAccess));
    };
    const isProUser = ()=>{
        var _get_userLicenseAccess;
        return (_get_userLicenseAccess = get().userLicenseAccess) === null || _get_userLicenseAccess === void 0 ? void 0 : _get_userLicenseAccess.isEmployeeAccess;
    };
    const isEduUser = ()=>{
        var _get_userLicenseAccess;
        return (_get_userLicenseAccess = get().userLicenseAccess) === null || _get_userLicenseAccess === void 0 ? void 0 : _get_userLicenseAccess.isStudentAccess;
    };
    const isSdkUser = ()=>{
        var _get_userLicenseAccess;
        return (_get_userLicenseAccess = get().userLicenseAccess) === null || _get_userLicenseAccess === void 0 ? void 0 : _get_userLicenseAccess.isDeveloperAccess;
    };
    const isPlusUser = ()=>{
        var _get_userLicenseAccess;
        return (_get_userLicenseAccess = get().userLicenseAccess) === null || _get_userLicenseAccess === void 0 ? void 0 : _get_userLicenseAccess.isPlusAccess;
    };
    const isTrialUser = ()=>{
        const acc = get().userLicenseAccess;
        return (acc === null || acc === void 0 ? void 0 : acc.licenseExpirationDate) !== undefined && acc.hasLicense === false && !!acc.licenseExpirationDate && new Date(acc.licenseExpirationDate) > new Date();
    };
    const getUserFeatureFlags = ()=>{
        var _currentUser_userPreferences;
        const { userLicenseAccess: userLicenseAccess, currentUser: currentUser } = get();
        const userFlags = [
            ...(0, $eec5c3b697f8e81e$export$89398edf022c69af)
        ];
        if (userLicenseAccess) {
            for (const licenseKey of Object.keys((0, $eec5c3b697f8e81e$export$edc04589e178d7ee)))if (userLicenseAccess[licenseKey]) userFlags.push(...(0, $eec5c3b697f8e81e$export$edc04589e178d7ee)[licenseKey]);
        }
        if (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_userPreferences = currentUser.userPreferences) === null || _currentUser_userPreferences === void 0 ? void 0 : _currentUser_userPreferences.featureFlags) {
            for (const flag of currentUser.userPreferences.featureFlags)if ((0, $eec5c3b697f8e81e$export$97f1def75ed4b43c).includes(flag)) userFlags.push(flag);
        }
        return [
            ...new Set(userFlags)
        ];
    };
    const isUserLicensedForAllFeatureFlags = (flagNames)=>{
        if (!get().userLicenseAccess) return false;
        return flagNames.every((flag)=>get().isFeatureFlagEnabled(flag));
    };
    const isFeatureFlagEnabled = (flagName)=>{
        var _get_currentUser_userPreferences_featureFlags, _get_currentUser_userPreferences, _get_currentUser;
        if ((0, $eec5c3b697f8e81e$export$89398edf022c69af).includes(flagName)) return true;
        const acc = get().userLicenseAccess;
        if (acc) for (const licenseKey of Object.keys((0, $eec5c3b697f8e81e$export$edc04589e178d7ee))){
            if (acc[licenseKey] && (0, $eec5c3b697f8e81e$export$edc04589e178d7ee)[licenseKey].includes(flagName)) return true;
        }
        if (!(0, $eec5c3b697f8e81e$export$97f1def75ed4b43c).includes(flagName)) return false;
        var _get_currentUser_userPreferences_featureFlags_includes;
        return (_get_currentUser_userPreferences_featureFlags_includes = (_get_currentUser = get().currentUser) === null || _get_currentUser === void 0 ? void 0 : (_get_currentUser_userPreferences = _get_currentUser.userPreferences) === null || _get_currentUser_userPreferences === void 0 ? void 0 : (_get_currentUser_userPreferences_featureFlags = _get_currentUser_userPreferences.featureFlags) === null || _get_currentUser_userPreferences_featureFlags === void 0 ? void 0 : _get_currentUser_userPreferences_featureFlags.includes(flagName)) !== null && _get_currentUser_userPreferences_featureFlags_includes !== void 0 ? _get_currentUser_userPreferences_featureFlags_includes : false;
    };
    const initializeFromStorage = async (isMainWindow = true)=>{
        try {
            console.log('INITIALIZING USER FROM STORAGE');
            const storedUser = localStorage.getItem((0, $4a3c7ab711a29dd4$export$959de94a57794f15));
            if (storedUser) {
                const currentUserModel = JSON.parse(storedUser);
                set({
                    currentUser: currentUserModel
                });
                await get().updateUserLocales({
                    defaultLocale: currentUserModel.defaultLocale,
                    defaultVoiceLocale: currentUserModel.defaultVoiceLocale
                }, isMainWindow);
                var _currentUserModel_isApprovedDomain;
                const userPermission = (_currentUserModel_isApprovedDomain = currentUserModel.isApprovedDomain) !== null && _currentUserModel_isApprovedDomain !== void 0 ? _currentUserModel_isApprovedDomain : false;
                var _currentUserModel_isEmailVerified;
                set({
                    isApprovedDomain: userPermission,
                    isEmailVerified: (_currentUserModel_isEmailVerified = currentUserModel.isEmailVerified) !== null && _currentUserModel_isEmailVerified !== void 0 ? _currentUserModel_isEmailVerified : false
                });
                (0, $e7df95de73caec26$export$89b472e03be495df)('userUpdated', {
                    user: currentUserModel
                });
            }
            get().loadUserLicenseAccessFromStorage();
        } catch (e) {
            console.log(e);
        }
    };
    const deleteCurrentUser = async ()=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$423f8e8c6cce5fd3();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                localStorage.removeItem((0, $4a3c7ab711a29dd4$export$959de94a57794f15));
                set({
                    currentUser: null
                });
            }
            set({
                isLoading: false
            });
            return result;
        } catch (e) {
            console.log(e);
            set({
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadCurrentUser = async ()=>{
        try {
            set({
                isLoading: true
            });
            const userAuthPermissions = await $1a4c36336f303477$export$5a6314a822d8df05();
            let userPermission = false;
            if (userAuthPermissions.resultType !== 'Ok' && (userAuthPermissions === null || userAuthPermissions === void 0 ? void 0 : userAuthPermissions.errors) != null && userAuthPermissions.errors.length > 0) set({
                errors: [
                    ...userAuthPermissions.errors
                ]
            });
            else if ((userAuthPermissions === null || userAuthPermissions === void 0 ? void 0 : userAuthPermissions.resultType) === 'Ok') userPermission = true;
            set({
                isApprovedDomain: userPermission
            });
            const result = await $1a4c36336f303477$export$d12f355dc16ebf93();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                get().handleUpdateUser(result.data);
                await get().updateUserLocales({
                    defaultLocale: result.data.defaultLocale,
                    defaultVoiceLocale: result.data.defaultVoiceLocale
                });
            } else if ((result === null || result === void 0 ? void 0 : result.errors) != null && result.errors.length > 0) set({
                errors: [
                    ...result.errors
                ]
            });
            set({
                isLoading: false
            });
            return result;
        } catch (e) {
            set({
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updatePassword = async (oldPassword, newPassword, confirmNewPassword)=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$99d837dc30eb1ef7({
                oldPassword: oldPassword,
                newPassword: newPassword,
                newPasswordConfirmation: confirmNewPassword
            });
            set({
                isLoading: false
            });
            return result;
        } catch (e) {
            set({
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadCapabilityFacetGroups = async ()=>{
        try {
            set({
                isLoadingFacets: true
            });
            const result = await $1a4c36336f303477$export$8cf7ec95b3fb64ef();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) set({
                capabilityFacetGroups: result.data
            });
            set({
                isLoadingFacets: false
            });
            return result;
        } catch (e) {
            set({
                isLoadingFacets: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateUserCapabilities = async (request)=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$78668e730a02e76(request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) get().handleUpdateUser(result.data);
            set({
                isLoading: false
            });
            return result;
        } catch (e) {
            set({
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateEmailPreferences = async (request)=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$7320d6eeb2c8ac54(request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                const updatedUser = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, get().currentUser, result.data);
                get().handleUpdateUser(updatedUser);
            }
            set({
                isLoading: false
            });
            return result;
        } catch (e) {
            set({
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateUserPreferences = async (request)=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$2a6c232d8be225a8(request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                const updatedUser = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, get().currentUser, result.data);
                get().handleUpdateUser(updatedUser);
            } else if (result.errors != null && result.errors.length > 0) set({
                errors: [
                    ...result.errors
                ]
            });
            set({
                isLoading: false
            });
            return result;
        } catch (error) {
            set({
                errors: [
                    String(error)
                ],
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getUserPreferences = async ()=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$ae3f5fa351e2f57a();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                set({
                    isLoading: false
                });
                return result;
            } else if (result.errors != null && result.errors.length > 0) set({
                errors: [
                    ...result.errors
                ]
            });
        } catch (error) {
            set({
                errors: [
                    String(error)
                ],
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const requestEmailVerificationResend = async ()=>{
        try {
            const result = await $1a4c36336f303477$export$4cedc5ba9e15b997();
            if (result.errors != null && result.errors.length > 0) set({
                errors: [
                    ...result.errors
                ]
            });
            return result;
        } catch (error) {
            set({
                errors: [
                    String(error)
                ]
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const clearCurrentUser = ()=>{
        set({
            currentUser: null
        });
    };
    const updateUserLocales = async (request, isMainWindow = true)=>{
        const localePreferences = getValidatedUserLocales(request);
        changeAppLanguage(localePreferences.defaultLocale);
        const modelUrl = await loadVoiceModelUrl(localePreferences.defaultVoiceLocale, isMainWindow, localePreferences.voiceModelUrl);
        const current = get().userLocalePreferences;
        const hasChanges = localePreferences.defaultLocale !== current.defaultLocale || localePreferences.defaultVoiceLocale !== current.defaultVoiceLocale;
        if (hasChanges) {
            const updated = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, localePreferences), {
                voiceModelUrl: modelUrl
            });
            set({
                userLocalePreferences: updated
            });
            (0, $e7df95de73caec26$export$89b472e03be495df)('userLocalePreferencesUpdated', {
                localePreferences: localePreferences
            });
        }
    };
    const saveUserLocales = async (request)=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$ca144d7073999c98(request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                await get().updateUserLocales(request);
                const updatedUser = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, get().currentUser, result.data);
                get().handleUpdateUser(updatedUser);
            } else if (result.errors != null && result.errors.length > 0) set({
                errors: [
                    ...result.errors
                ]
            });
            set({
                isLoading: false
            });
            return result;
        } catch (error) {
            set({
                errors: [
                    String(error)
                ],
                isLoading: false
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleUpdateUser = (user)=>{
        const updatedUser = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, user), {
            isApprovedDomain: get().isApprovedDomain
        });
        set({
            currentUser: updatedUser
        });
        localStorage.setItem((0, $4a3c7ab711a29dd4$export$959de94a57794f15), JSON.stringify(updatedUser));
        if (updatedUser.isEmailVerified !== get().isEmailVerified) set({
            isEmailVerified: updatedUser.isEmailVerified
        });
        (0, $e7df95de73caec26$export$89b472e03be495df)('userUpdated', {
            user: updatedUser
        });
    };
    const updateUserLicenseAccess = async (access, updateLocal)=>{
        const currentAccess = get().userLicenseAccess;
        const hasChanged = !currentAccess || JSON.stringify(currentAccess) !== JSON.stringify(access);
        if (!hasChanged) return;
        const licenseType = $8a1185b15e8317ab$var$computeUserLicenseType(access);
        set({
            userLicenseAccess: access,
            userLicenseType: licenseType,
            userBetaFeatureFlags: $8a1185b15e8317ab$var$computeUserBetaFeatureFlags(access),
            hasNoOrgMemberships: $8a1185b15e8317ab$var$computeHasNoOrgMemberships(access),
            isLicenseExpired: $8a1185b15e8317ab$var$computeIsLicenseExpired(access)
        });
        if (updateLocal) localStorage.setItem((0, $4a3c7ab711a29dd4$export$d7b509e53699b6f9), JSON.stringify({
            access: access,
            type: licenseType
        }));
        (0, $e7df95de73caec26$export$89b472e03be495df)('userLicenseChangeLocal', {
            access: access,
            type: licenseType
        });
    };
    const loadUserLicenseAccess = async ()=>{
        try {
            const result = await $1a4c36336f303477$export$2892959f926e8bd6();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) await get().updateUserLicenseAccess(result.data, true);
            else if (result.errors != null && result.errors.length > 0) {
                set({
                    errors: [
                        ...result.errors
                    ]
                });
                get().loadUserLicenseAccessFromStorage();
            }
        } catch (error) {
            set({
                errors: [
                    error
                ]
            });
            get().loadUserLicenseAccessFromStorage();
        }
    };
    const loadUserLicenseAccessFromStorage = ()=>{
        const userAccess = localStorage.getItem((0, $4a3c7ab711a29dd4$export$d7b509e53699b6f9));
        if (userAccess) {
            const { access: access, type: type } = JSON.parse(userAccess);
            get().updateUserLicenseAccess(access, false);
            return {
                access: access,
                type: type
            };
        }
    };
    const updateUserPermissions = (value)=>{
        set({
            isApprovedDomain: value
        });
        const currUser = get().currentUser;
        if (currUser) get().handleUpdateUser(currUser);
    };
    const checkAndUpdatePendingTos = async ()=>{
        try {
            const tosResult = await $1a4c36336f303477$export$160fb9e4529c1fb8();
            if ((tosResult === null || tosResult === void 0 ? void 0 : tosResult.resultType) === 'Ok' && tosResult.data) {
                var _get_currentUser;
                const acceptedVersion = (_get_currentUser = get().currentUser) === null || _get_currentUser === void 0 ? void 0 : _get_currentUser.acceptedTosVersion;
                const requiredVersion = tosResult.data.requiredVersion;
                if (!acceptedVersion || acceptedVersion < requiredVersion) set({
                    pendingTosConfig: tosResult.data
                });
            }
        } catch (error) {
            console.error('Error checking TOS config:', error);
        }
    };
    const addUpgradeBanner = (newBanner, duration)=>{
        const currentMap = get().upgradeBannerMap;
        const updatedMap = new Map(currentMap);
        // clear existing timeout if banner already present
        const existing = updatedMap.get(newBanner.id);
        if (existing === null || existing === void 0 ? void 0 : existing.timeout) clearTimeout(existing.timeout);
        let timeout;
        if (duration !== undefined) timeout = setTimeout(()=>{
            get().removeUpgradeBanner(newBanner.id);
        }, duration);
        updatedMap.set(newBanner.id, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, newBanner), {
            timeout: timeout
        }));
        set({
            upgradeBannerMap: updatedMap,
            upgradeBannersArray: Array.from(updatedMap.values())
        });
    };
    const removeUpgradeBanner = (id)=>{
        const currentMap = get().upgradeBannerMap;
        const updatedMap = new Map(currentMap);
        const banner = updatedMap.get(id);
        if (banner === null || banner === void 0 ? void 0 : banner.timeout) clearTimeout(banner.timeout);
        updatedMap.delete(id);
        set({
            upgradeBannerMap: updatedMap,
            upgradeBannersArray: Array.from(updatedMap.values())
        });
    };
    return {
        // State
        capabilityFacetGroups: [],
        currentUser: null,
        errors: [],
        hasNoOrgMemberships: true,
        isApprovedDomain: false,
        isEmailVerified: false,
        isLicenseExpired: false,
        isLoading: false,
        isLoadingFacets: false,
        pendingTosConfig: null,
        showUserFallbackDialog: false,
        signalRConnected: true,
        upgradeBannerMap: new Map(),
        upgradeBannersArray: [],
        userBetaFeatureFlags: [
            ...(0, $eec5c3b697f8e81e$export$9338f61da19c4759)['personal']
        ],
        userLicenseAccess: null,
        userLicenseType: 'personal',
        userLocalePreferences: $8a1185b15e8317ab$var$defaultLocalePrefs,
        voiceModelUrl: $cfd4b075d263c876$exports,
        addUpgradeBanner: // Actions
        addUpgradeBanner,
        checkAndUpdatePendingTos: checkAndUpdatePendingTos,
        clearCurrentUser: clearCurrentUser,
        deleteCurrentUser: deleteCurrentUser,
        getUserFeatureFlags: getUserFeatureFlags,
        getUserPreferences: getUserPreferences,
        handleUpdateUser: handleUpdateUser,
        initializeFromStorage: initializeFromStorage,
        isEduUser: isEduUser,
        isFeatureFlagEnabled: isFeatureFlagEnabled,
        isFreeUser: isFreeUser,
        isPlusUser: isPlusUser,
        isProUser: isProUser,
        isSdkUser: isSdkUser,
        isTrialUser: isTrialUser,
        isUserLicensedForAllFeatureFlags: isUserLicensedForAllFeatureFlags,
        loadCapabilityFacetGroups: loadCapabilityFacetGroups,
        loadCurrentUser: loadCurrentUser,
        loadUserLicenseAccess: loadUserLicenseAccess,
        loadUserLicenseAccessFromStorage: loadUserLicenseAccessFromStorage,
        removeUpgradeBanner: removeUpgradeBanner,
        requestEmailVerificationResend: requestEmailVerificationResend,
        saveUserLocales: saveUserLocales,
        setPendingTosConfig: setPendingTosConfig,
        setShowUserFallbackDialog: setShowUserFallbackDialog,
        setSignalRConnected: setSignalRConnected,
        updateEmailPreferences: updateEmailPreferences,
        updatePassword: updatePassword,
        updateUserCapabilities: updateUserCapabilities,
        updateUserLicenseAccess: updateUserLicenseAccess,
        updateUserLocales: updateUserLocales,
        updateUserPermissions: updateUserPermissions,
        updateUserPreferences: updateUserPreferences
    };
});
// Module-level subscribe: re-publish feature flags whenever user or license changes
$8a1185b15e8317ab$export$887dff289a6ce108.subscribe((state, prevState)=>{
    if (state.currentUser !== prevState.currentUser || state.userLicenseAccess !== prevState.userLicenseAccess) {
        const featureFlags = $8a1185b15e8317ab$export$887dff289a6ce108.getState().getUserFeatureFlags();
        (0, $e7df95de73caec26$export$89b472e03be495df)('userFeatureFlagsUpdated', {
            featureFlags: featureFlags
        });
    }
});
// Replace the buggy no-dep-array useEffect with a single module-level subscription
(0, $e7df95de73caec26$export$ec068583843480e7)('updateUserLicenseAccess', async ()=>{
    await $8a1185b15e8317ab$export$887dff289a6ce108.getState().loadUserLicenseAccess();
});







const $2616fe0411c33582$export$5a74056075e3647e = (customControl)=>{
    return customControl.requiresEmployeeAccess || customControl.requiresGenericLicense || customControl.requiresPlusAccess || customControl.requiresStudentAccess;
};
const $2616fe0411c33582$export$82e40272e8bb746b = (deviceControls, controlOverrides)=>{
    const result = [];
    const controlIds = new Set();
    for (const control of deviceControls){
        var _control_defaultCommands;
        result.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control), {
            commands: (_control_defaultCommands = control.defaultCommands) !== null && _control_defaultCommands !== void 0 ? _control_defaultCommands : []
        }));
        controlIds.add(control.id);
    }
    // take override over the defaults if available
    for (const override of controlOverrides)if (controlIds.has(override.deviceTypeCustomControlId)) {
        var _override_commands;
        const control = result.find((c)=>c.id === override.deviceTypeCustomControlId);
        var _override_commands_length;
        if (control && ((_override_commands_length = (_override_commands = override.commands) === null || _override_commands === void 0 ? void 0 : _override_commands.length) !== null && _override_commands_length !== void 0 ? _override_commands_length : 0) > 0) control.commands = override.commands;
    // todo: hotkey
    }
    return result;
};













const $28343ab509e453ee$export$513d3938ac2af8f0 = (profile)=>{
    if (!profile) return false;
    return profile.requiresGenericLicense || profile.requiresEmployeeAccess || profile.requiresStudentAccess || profile.requiresPlusAccess;
};
const $28343ab509e453ee$export$6ff753f9d38ae18d = (profile, licenseAccess)=>{
    if (!$28343ab509e453ee$export$513d3938ac2af8f0(profile)) return true;
    if (!licenseAccess || licenseAccess.type === 'personal') return false;
    if (!licenseAccess.access.isEmployeeAccess && profile.requiresEmployeeAccess) return false;
    if (!licenseAccess.access.isStudentAccess && profile.requiresStudentAccess) return false;
    if (!licenseAccess.access.isPlusAccess && profile.requiresPlusAccess) return false;
    // profile has generic license or specific profile license
    return true;
};






var $gSkQi = parcelRequire("gSkQi");


const $43d630686eddb628$export$21b1c44aa0aad518 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((set, get)=>{
    const snapshotState = (profile)=>{
        localStorage.setItem((0, $4a3c7ab711a29dd4$export$a1ad07ee66337027), JSON.stringify(profile));
    };
    // Maps macro id -> isFavorite for every macro in the profile that has an id.
    const buildFavoritesMap = (profile)=>{
        var _profile_configuration;
        const favorites = {};
        var _profile_configuration_macros;
        for (const macro of (_profile_configuration_macros = profile === null || profile === void 0 ? void 0 : (_profile_configuration = profile.configuration) === null || _profile_configuration === void 0 ? void 0 : _profile_configuration.macros) !== null && _profile_configuration_macros !== void 0 ? _profile_configuration_macros : [])if (macro.id) favorites[macro.id] = !!macro.isFavorite;
        return favorites;
    };
    const updateLocalState = (device, newProfile)=>{
        var _incomingProfile_configuration;
        const previousProfile = get().currentProfile;
        const favoritesDirty = get().favoritesDirty;
        const existingProfileStr = JSON.stringify(previousProfile);
        // Preserve unsaved session favorites against same-profile syncs: an incoming sync
        // replaces `currentProfile` wholesale and would otherwise drop the toggled isFavorite
        // flags before we get a chance to persist them. Merge them back in by macro id.
        let incomingProfile = newProfile;
        const isSameProfile = !!(newProfile === null || newProfile === void 0 ? void 0 : newProfile.id) && newProfile.id === (previousProfile === null || previousProfile === void 0 ? void 0 : previousProfile.id);
        if (favoritesDirty && isSameProfile && (incomingProfile === null || incomingProfile === void 0 ? void 0 : (_incomingProfile_configuration = incomingProfile.configuration) === null || _incomingProfile_configuration === void 0 ? void 0 : _incomingProfile_configuration.macros)) {
            const favorites = buildFavoritesMap(previousProfile);
            incomingProfile = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, incomingProfile), {
                configuration: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, incomingProfile.configuration), {
                    macros: incomingProfile.configuration.macros.map((m)=>m.id && m.id in favorites ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                            isFavorite: favorites[m.id]
                        }) : m)
                })
            });
        }
        const newProfileStr = JSON.stringify(incomingProfile);
        let updatedProfile = previousProfile;
        if (existingProfileStr !== newProfileStr) {
            if (incomingProfile && (0, $28343ab509e453ee$export$6ff753f9d38ae18d)(incomingProfile, get().userLicenseAccess)) updatedProfile = incomingProfile;
            else updatedProfile = null;
            snapshotState(updatedProfile);
        }
        var _previousProfile_id, _updatedProfile_id;
        // When switching to a different profile, flush the outgoing profile's unsaved favorite
        // changes so the main window can persist them via the API (handled over IPC in the panel).
        const isProfileSwitch = ((_previousProfile_id = previousProfile === null || previousProfile === void 0 ? void 0 : previousProfile.id) !== null && _previousProfile_id !== void 0 ? _previousProfile_id : null) !== ((_updatedProfile_id = updatedProfile === null || updatedProfile === void 0 ? void 0 : updatedProfile.id) !== null && _updatedProfile_id !== void 0 ? _updatedProfile_id : null);
        if (favoritesDirty && isProfileSwitch && (previousProfile === null || previousProfile === void 0 ? void 0 : previousProfile.id)) (0, $e7df95de73caec26$export$89b472e03be495df)('favoritesNeedSave', {
            profileId: previousProfile.id,
            favorites: buildFavoritesMap(previousProfile)
        });
        set((state)=>{
            var _device_device;
            return {
                device: device,
                id: device === null || device === void 0 ? void 0 : device.id,
                deviceTypeId: device === null || device === void 0 ? void 0 : (_device_device = device.device) === null || _device_device === void 0 ? void 0 : _device_device.deviceType.id,
                currentProfile: updatedProfile,
                // The dirty flag belongs to the profile we were on; reset it on a profile switch.
                favoritesDirty: isProfileSwitch ? false : state.favoritesDirty
            };
        });
        (0, $e7df95de73caec26$export$89b472e03be495df)('currentDeviceUpdated', {
            device: device,
            profile: updatedProfile
        });
        return true;
    };
    const setIsLoading = (v)=>set({
            isLoading: v
        });
    const setPreviousProfileId = (id)=>set({
            previousProfileId: id
        });
    const setFavoritesDirty = (v)=>set({
            favoritesDirty: v
        });
    // Snapshot of the current profile's favorite flags, for relaying to the main window
    // (the single API writer) so it can persist them. Returns null if there is no profile id.
    const getFavoritesPayload = ()=>{
        const profile = get().currentProfile;
        if (!(profile === null || profile === void 0 ? void 0 : profile.id)) return null;
        return {
            profileId: profile.id,
            favorites: buildFavoritesMap(profile)
        };
    };
    const setInstalledAppNames = (names)=>set({
            installedAppNames: names
        });
    const setPhiNativeResult = (v)=>set({
            phiNativeResult: v
        });
    const setPhiNativeStatus = (v)=>set({
            phiNativeStatus: v
        });
    const updatePhiResult = (token)=>{
        const newVal = get().phiNativeResult + token;
        set({
            phiNativeResult: newVal
        });
    };
    const setCurrentDomain = (v)=>set({
            currentDomain: v
        });
    const resetPhiResult = ()=>set({
            phiNativeResult: ''
        });
    const updateAppTracking = (currentApp, previousApp, currentDomain)=>set(()=>({
                previousApp: previousApp,
                currentApp: currentApp,
                currentDomain: currentDomain
            }));
    const setUserLicenseAccess = (access)=>set({
            userLicenseAccess: access
        });
    const addTryCommandHandler = (handler)=>set((state)=>({
                tryCommandHandlers: [
                    ...state.tryCommandHandlers,
                    handler
                ]
            }));
    const setLoadInstalledAppNamesHandler = (handler)=>{
        set({
            loadInstalledAppNamesHandler: handler
        });
    };
    const loadInstalledAppNames = ()=>{
        const handler = get().loadInstalledAppNamesHandler;
        if (handler) handler();
    };
    const updateDeviceState = (device, newProfile)=>{
        const currentState = get(); // Get current Zustand state (source of truth)
        let isDeviceEqual = false;
        if (device && currentState.device) {
            const isIdEqual = device.id === currentState.device.id;
            const isModifiedDateEqual = device.modifiedDate === currentState.device.modifiedDate;
            isDeviceEqual = isIdEqual && isModifiedDateEqual;
        }
        const isProfileEqual = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isEqual(newProfile, currentState.currentProfile);
        if (isDeviceEqual && isProfileEqual) return false;
        return updateLocalState(device, newProfile);
    };
    const tryDeviceCommand = async (command, additionalInputContent)=>{
        const { tryCommandHandlers: tryCommandHandlers } = get();
        const currentProfile = get().currentProfile;
        if (!command || !currentProfile) return false; // If command or profile is not available, cannot execute command
        if (currentProfile && get().id && get().device) {
            if (!currentProfile) return false;
            for (const handler of tryCommandHandlers){
                if (handler(command, currentProfile)) return true;
            }
        }
        return false;
    };
    const stopAllOutputs = async ()=>{
        return await get().tryDeviceCommand((0, $f44f3a5bc46b1c4c$export$8c2b4826af6cc511));
    };
    // Session-only favorites toggle: flips `isFavorite` on the macro inside `currentProfile`.
    // Intentionally does NOT snapshot to localStorage — favorites live only for the session and
    // are persisted to the API on profile switch / sign-out / edit (see `favoritesDirty`).
    // `updateLocalState` merges these flags back in by macro id on same-profile syncs so they
    // are not dropped by incoming SignalR updates before they can be saved.
    const toggleMacroFavorite = (macroId)=>{
        var _currentProfile_configuration;
        const currentProfile = get().currentProfile;
        const macros = currentProfile === null || currentProfile === void 0 ? void 0 : (_currentProfile_configuration = currentProfile.configuration) === null || _currentProfile_configuration === void 0 ? void 0 : _currentProfile_configuration.macros;
        if (!currentProfile || !macros) return;
        set({
            currentProfile: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentProfile), {
                configuration: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentProfile.configuration), {
                    macros: macros.map((m)=>m.id === macroId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                            isFavorite: !m.isFavorite
                        }) : m)
                })
            }),
            favoritesDirty: true
        });
    };
    const resetCurrentProfile = async ()=>{
        const id = get().id;
        if (!id || !get().device) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device ID is not set');
        const currentDeviceProfile = get().currentProfile;
        let result;
        if (currentDeviceProfile === null || currentDeviceProfile === void 0 ? void 0 : currentDeviceProfile.isPublic) result = await $1a4c36336f303477$export$c35b3a8741882c0(id, {
            defaultProfileId: null
        });
        else result = await $1a4c36336f303477$export$c35b3a8741882c0(id, {
            customProfileId: null
        });
        if (result.resultType === 'Ok' && result.data) updateLocalState(result.data, null);
        else if (result.resultType !== 'Ok') {
            const currentDevice = get().device;
            if (!currentDevice) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device not found');
            const updatedDeviceState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentDevice);
            if (currentDeviceProfile === null || currentDeviceProfile === void 0 ? void 0 : currentDeviceProfile.isPublic) updatedDeviceState.defaultProfileId = null;
            else updatedDeviceState.currentProfile = null;
            updateLocalState(updatedDeviceState, null);
            result = new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(updatedDeviceState);
        }
        return result;
    };
    const clearListeners = ()=>set({
            tryCommandHandlers: []
        });
    const clearAll = ()=>{
        set({
            device: undefined,
            currentProfile: null,
            previousProfileId: null,
            errors: [],
            favoritesDirty: false,
            id: undefined,
            deviceTypeId: undefined,
            isLoading: false,
            installedAppNames: [],
            tryCommandHandlers: [],
            loadInstalledAppNamesHandler: null,
            currentApp: undefined,
            currentDomain: undefined,
            previousApp: undefined,
            phiNativeResult: '',
            phiNativeStatus: '',
            userLicenseAccess: undefined
        });
        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$a1ad07ee66337027));
    };
    return {
        // State
        device: undefined,
        isLoading: false,
        previousProfileId: null,
        errors: [],
        favoritesDirty: false,
        id: undefined,
        deviceTypeId: undefined,
        currentProfile: null,
        currentApp: undefined,
        currentDomain: undefined,
        previousApp: undefined,
        installedAppNames: [],
        tryCommandHandlers: [],
        loadInstalledAppNamesHandler: null,
        phiNativeResult: '',
        phiNativeStatus: '',
        userLicenseAccess: undefined,
        addTryCommandHandler: // Actions
        addTryCommandHandler,
        clearAll: clearAll,
        clearListeners: clearListeners,
        getFavoritesPayload: getFavoritesPayload,
        loadInstalledAppNames: loadInstalledAppNames,
        resetCurrentProfile: resetCurrentProfile,
        resetPhiResult: resetPhiResult,
        setCurrentDomain: setCurrentDomain,
        setFavoritesDirty: setFavoritesDirty,
        updateAppTracking: updateAppTracking,
        setInstalledAppNames: setInstalledAppNames,
        setIsLoading: setIsLoading,
        setLoadInstalledAppNamesHandler: setLoadInstalledAppNamesHandler,
        setPhiNativeResult: setPhiNativeResult,
        setPhiNativeStatus: setPhiNativeStatus,
        setPreviousProfileId: setPreviousProfileId,
        setUserLicenseAccess: setUserLicenseAccess,
        stopAllOutputs: stopAllOutputs,
        toggleMacroFavorite: toggleMacroFavorite,
        tryDeviceCommand: tryDeviceCommand,
        updateDeviceState: updateDeviceState,
        updatePhiResult: updatePhiResult
    };
});
// Module-level event subscriptions (replace useEffect([], []))
(0, $e7df95de73caec26$export$ec068583843480e7)('userLicenseChangeLocal', async (data)=>{
    if (data) {
        $43d630686eddb628$export$21b1c44aa0aad518.getState().setUserLicenseAccess(data);
        if (data.type === 'personal' && (0, $28343ab509e453ee$export$513d3938ac2af8f0)($43d630686eddb628$export$21b1c44aa0aad518.getState().currentProfile)) await $43d630686eddb628$export$21b1c44aa0aad518.getState().resetCurrentProfile();
    }
});
(0, $e7df95de73caec26$export$ec068583843480e7)('profileDeleted', async (data)=>{
    var _data_profile, _useCurrentDeviceStore_getState_currentProfile;
    if (data && ((_data_profile = data.profile) === null || _data_profile === void 0 ? void 0 : _data_profile.id) === ((_useCurrentDeviceStore_getState_currentProfile = $43d630686eddb628$export$21b1c44aa0aad518.getState().currentProfile) === null || _useCurrentDeviceStore_getState_currentProfile === void 0 ? void 0 : _useCurrentDeviceStore_getState_currentProfile.id)) await $43d630686eddb628$export$21b1c44aa0aad518.getState().resetCurrentProfile();
});






const $2e1b9b7946b06a36$export$e57a519b54d74351 = '3ae3d1ed-97b7-4572-a57a-00d4724270a0';







const $488d70defc02145b$export$3674500df62ac424 = (device)=>{
    var _device_device;
    const deviceType = (_device_device = device.device) === null || _device_device === void 0 ? void 0 : _device_device.deviceType;
    if (!deviceType) return 'application';
    if (deviceType.id === (0, $2e1b9b7946b06a36$export$e57a519b54d74351)) return 'device';
    if (deviceType.supportsGenericControllerOutput || deviceType.supportsXboxControllerOutput || deviceType.supportsNintendoControllerOutput || deviceType.supportsPlayStationControllerOutput) return 'game';
    return 'application';
};
const $488d70defc02145b$export$e9455858f5005fb = (command, profile)=>{
    var _profile_configuration_audioEvents, _profile_configuration, _profile_configuration_macros, _profile_configuration1, _profile_configuration_commandKeyMappings, _profile_configuration2;
    if (!profile) return false;
    // check profile configuration
    if (command.toLowerCase().startsWith((0, $f44f3a5bc46b1c4c$export$2edc7d5e93b11fea)) || command.toLowerCase().startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257))) return true;
    if (profile === null || profile === void 0 ? void 0 : (_profile_configuration = profile.configuration) === null || _profile_configuration === void 0 ? void 0 : (_profile_configuration_audioEvents = _profile_configuration.audioEvents) === null || _profile_configuration_audioEvents === void 0 ? void 0 : _profile_configuration_audioEvents.some((a)=>{
        var _a_commands;
        return (_a_commands = a.commands) === null || _a_commands === void 0 ? void 0 : _a_commands.some((c)=>c.toLowerCase() == command.toLowerCase());
    })) return true;
    if (profile === null || profile === void 0 ? void 0 : (_profile_configuration1 = profile.configuration) === null || _profile_configuration1 === void 0 ? void 0 : (_profile_configuration_macros = _profile_configuration1.macros) === null || _profile_configuration_macros === void 0 ? void 0 : _profile_configuration_macros.some((m)=>m.commands.some((c)=>c.toLowerCase() == command.toLowerCase()))) return true;
    if (profile === null || profile === void 0 ? void 0 : (_profile_configuration2 = profile.configuration) === null || _profile_configuration2 === void 0 ? void 0 : (_profile_configuration_commandKeyMappings = _profile_configuration2.commandKeyMappings) === null || _profile_configuration_commandKeyMappings === void 0 ? void 0 : _profile_configuration_commandKeyMappings.some((c)=>{
        var _c_commands;
        return (_c_commands = c.commands) === null || _c_commands === void 0 ? void 0 : _c_commands.some((cc)=>cc.toLowerCase() == command.toLowerCase());
    })) return true;
    return false;
};




function $b903537072c9f7db$var$randomJitter(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $b903537072c9f7db$var$actionMatchesRef(event, ref) {
    var _event_keys;
    if (event.eventType !== ref.eventType) return false;
    if (ref.deviceTypeCustomActionId) return event.deviceTypeCustomActionId === ref.deviceTypeCustomActionId;
    var _event_keys_includes;
    if (ref.key) return (_event_keys_includes = (_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : _event_keys.includes(ref.key)) !== null && _event_keys_includes !== void 0 ? _event_keys_includes : false;
    return true;
}
function $b903537072c9f7db$export$e03905f1a6ff1d64(events, rules) {
    return events.map((event)=>{
        const updated = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event);
        if (event.holdTimeMilliseconds != null && event.holdTimeMilliseconds > 0) {
            var _rules_macroStepRules;
            let jitterMin;
            let jitterMax;
            const stepRule = (_rules_macroStepRules = rules.macroStepRules) === null || _rules_macroStepRules === void 0 ? void 0 : _rules_macroStepRules.find((sr)=>{
                var _event_keys;
                return sr.eventType === event.eventType && (sr.key == null || ((_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : _event_keys.includes(sr.key))) && (sr.deviceTypeCustomActionId == null || sr.deviceTypeCustomActionId === event.deviceTypeCustomActionId);
            });
            if ((stepRule === null || stepRule === void 0 ? void 0 : stepRule.holdTimeJitterMinMilliseconds) != null && (stepRule === null || stepRule === void 0 ? void 0 : stepRule.holdTimeJitterMaxMilliseconds) != null) {
                jitterMin = stepRule.holdTimeJitterMinMilliseconds;
                jitterMax = stepRule.holdTimeJitterMaxMilliseconds;
            } else if (event.eventType === 'Pause') {
                if (rules.pauseTimeJitterMinMilliseconds != null && rules.pauseTimeJitterMaxMilliseconds != null) {
                    jitterMin = rules.pauseTimeJitterMinMilliseconds;
                    jitterMax = rules.pauseTimeJitterMaxMilliseconds;
                }
            } else if (rules.holdTimeJitterMinMilliseconds != null && rules.holdTimeJitterMaxMilliseconds != null) {
                jitterMin = rules.holdTimeJitterMinMilliseconds;
                jitterMax = rules.holdTimeJitterMaxMilliseconds;
            }
            if (jitterMin != null && jitterMax != null && jitterMax > 0) {
                const jitter = $b903537072c9f7db$var$randomJitter(jitterMin, jitterMax);
                updated.holdTimeMilliseconds = Math.max(0, event.holdTimeMilliseconds + jitter);
            }
        }
        return updated;
    });
}
function $b903537072c9f7db$export$d9bacc24f8864304(events, groups) {
    for (const group of groups){
        const allPresent = group.actions.every((ref)=>events.some((e)=>$b903537072c9f7db$var$actionMatchesRef(e, ref)));
        if (allPresent) return group;
    }
    return undefined;
}
function $b903537072c9f7db$export$3c1f0d172b774752(events, pauseRules) {
    if (events.length < 2) return events;
    const result = [
        events[0]
    ];
    for(let i = 1; i < events.length; i++){
        const prev = events[i - 1];
        const curr = events[i];
        let maxRequiredPause = 0;
        for (const rule of pauseRules){
            const prevMatchesA = $b903537072c9f7db$var$actionMatchesRef(prev, rule.actionA);
            const currMatchesB = $b903537072c9f7db$var$actionMatchesRef(curr, rule.actionB);
            const forwardMatch = prevMatchesA && currMatchesB;
            const reverseMatch = rule.bidirectional && $b903537072c9f7db$var$actionMatchesRef(prev, rule.actionB) && $b903537072c9f7db$var$actionMatchesRef(curr, rule.actionA);
            if (forwardMatch || reverseMatch) maxRequiredPause = Math.max(maxRequiredPause, rule.minimumPauseMilliseconds);
        }
        if (maxRequiredPause > 0) {
            var _prev_holdTimeMilliseconds;
            const existingPause = prev.eventType === 'Pause' ? (_prev_holdTimeMilliseconds = prev.holdTimeMilliseconds) !== null && _prev_holdTimeMilliseconds !== void 0 ? _prev_holdTimeMilliseconds : 0 : 0;
            if (existingPause < maxRequiredPause) {
                if (prev.eventType === 'Pause') result[result.length - 1] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                    holdTimeMilliseconds: maxRequiredPause
                });
                else result.push({
                    eventType: 'Pause',
                    holdTimeMilliseconds: maxRequiredPause
                });
            }
        }
        result.push(curr);
    }
    return result;
}







const $57ef534a0961ba07$export$f5365bff27c1f155 = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
const $57ef534a0961ba07$var$currentAppNameRef = {
    current: null
};
const $57ef534a0961ba07$var$userLicenseAccessRef = {
    current: undefined
};
const $57ef534a0961ba07$var$deviceThrottleStateRef = {
    current: {}
};
const $57ef534a0961ba07$var$throttleWarningHandlersRef = {
    current: []
};
const $57ef534a0961ba07$var$computeConnectedDevices = (devices, virtualDeviceId)=>devices.filter((d)=>d.id === virtualDeviceId || d.isConnected);
const $57ef534a0961ba07$export$2b13470419707314 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((set, get)=>{
    const removeThrottleWarningHandlers = ()=>set({
            throttleWarningHandlers: []
        });
    const removeTryCommandHandler = ()=>set({
            tryCommandHandlers: []
        });
    const removeTryGlobalControlHandler = ()=>set({
            tryGlobalControlHandlers: []
        });
    const getDeviceToken = async (userDeviceId)=>{
        const { virtualDeviceId: virtualDeviceId, virtualDeviceToken: virtualDeviceToken, deviceCommandTokens: deviceCommandTokens } = get();
        if (userDeviceId === virtualDeviceId) return virtualDeviceToken;
        const existingToken = deviceCommandTokens.find((x)=>x.userDeviceId === userDeviceId && !x.token.isDisabled);
        if (existingToken) return existingToken.token;
        const result = await $1a4c36336f303477$export$4ff3dab44ee74505(userDeviceId);
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
            set((state)=>({
                    deviceCommandTokens: [
                        ...state.deviceCommandTokens,
                        {
                            userDeviceId: userDeviceId,
                            token: result.data
                        }
                    ]
                }));
            return result.data;
        }
    };
    const snapshotState = (devices, virtualDeviceId, virtualDeviceToken)=>{
        if ((devices === null || devices === void 0 ? void 0 : devices.length) > 0) localStorage.setItem((0, $4a3c7ab711a29dd4$export$7e1b78538df536d8), JSON.stringify(devices));
        if (virtualDeviceId) localStorage.setItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287), virtualDeviceId);
        if (virtualDeviceToken) localStorage.setItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1), JSON.stringify(virtualDeviceToken));
    };
    // Falls back to localStorage because this can be called before the store is
    // hydrated (e.g. during initializeVirtualController at app startup).
    const getLocalVirtualDevice = ()=>{
        const { virtualDeviceId: virtualDeviceId, devices: devices } = get();
        if (virtualDeviceId) {
            const device = devices === null || devices === void 0 ? void 0 : devices.find((d)=>d.id === virtualDeviceId);
            if (device) return device;
        }
        const storedVirtualDevice = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
        const storedVirtualDeviceId = localStorage.getItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
        const device = storedVirtualDevice ? JSON.parse(storedVirtualDevice) : null;
        if (device) return device;
        if (!storedVirtualDeviceId) return null;
        var _devices_find;
        return (_devices_find = devices === null || devices === void 0 ? void 0 : devices.find((d)=>d.id === storedVirtualDeviceId)) !== null && _devices_find !== void 0 ? _devices_find : null;
    };
    // Falls back to localStorage because this can be called before the store is
    // hydrated (e.g. during initializeVirtualController at app startup).
    const getLocalVirtualDeviceToken = ()=>{
        const { virtualDeviceToken: virtualDeviceToken } = get();
        if (virtualDeviceToken) return virtualDeviceToken;
        const virtualDeviceTokenLocal = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1));
        if (virtualDeviceTokenLocal) return JSON.parse(virtualDeviceTokenLocal);
        return null;
    };
    const isDeviceEqual = (a, b)=>{
        return JSON.stringify(a) === JSON.stringify(b);
    };
    const updateLocalDevice = (device)=>{
        const { devices: currentDevices, virtualDeviceId: virtualDeviceId, virtualDeviceToken: virtualDeviceToken } = get();
        const index = currentDevices.findIndex((x)=>x.id === device.id);
        // Skip update if device hasn't actually changed
        if (index > -1 && isDeviceEqual(currentDevices[index], device)) return;
        const updatedDevices = index > -1 ? currentDevices.map((d, i)=>i === index ? device : d) : [
            ...currentDevices,
            device
        ];
        set({
            devices: updatedDevices,
            connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(updatedDevices, virtualDeviceId)
        });
        snapshotState(updatedDevices, virtualDeviceId, virtualDeviceToken);
    };
    const updateDevicePlatform = async (device, platform = 'generic')=>{
        if ((device === null || device === void 0 ? void 0 : device.platform) === platform) return;
        await get().updateDevice(device.id, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, device), {
            platform: platform
        }));
    };
    const setDevices = (devices)=>{
        const currentDevices = get().devices;
        // Skip update if devices array hasn't actually changed
        if (currentDevices.length === devices.length && devices.every((d, i)=>isDeviceEqual(currentDevices[i], d))) return;
        set((state)=>({
                devices: devices,
                connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(devices, state.virtualDeviceId)
            }));
    };
    const addTryCommandHandler = (handler)=>set((state)=>({
                tryCommandHandlers: [
                    ...state.tryCommandHandlers,
                    handler
                ]
            }));
    const addTryGlobalControlHandler = (handler)=>set((state)=>({
                tryGlobalControlHandlers: [
                    ...state.tryGlobalControlHandlers,
                    handler
                ]
            }));
    const addThrottleWarningHandler = (handler)=>{
        $57ef534a0961ba07$var$throttleWarningHandlersRef.current = [
            ...$57ef534a0961ba07$var$throttleWarningHandlersRef.current,
            handler
        ];
        set((state)=>({
                throttleWarningHandlers: [
                    ...state.throttleWarningHandlers,
                    handler
                ]
            }));
    };
    const initializeFromStorage = ()=>{
        try {
            set({
                isInitialized: false
            });
            const localDevices = localStorage.getItem((0, $4a3c7ab711a29dd4$export$7e1b78538df536d8));
            let storedDevices = [];
            if (localDevices) storedDevices = JSON.parse(localDevices);
            // Resolve virtual device directly from storedDevices + localStorage
            // so we don't depend on store state which is still empty at this point.
            const storedVirtualDeviceRaw = localStorage.getItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
            const storedVirtualDeviceId = localStorage.getItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
            var _storedDevices_find, _ref;
            const virtualDevice = (_ref = storedVirtualDeviceRaw ? JSON.parse(storedVirtualDeviceRaw) : null) !== null && _ref !== void 0 ? _ref : storedVirtualDeviceId ? (_storedDevices_find = storedDevices.find((d)=>d.id === storedVirtualDeviceId)) !== null && _storedDevices_find !== void 0 ? _storedDevices_find : null : null;
            const virtualDeviceToken = getLocalVirtualDeviceToken();
            set((state)=>{
                var _virtualDevice_id, _virtualDevice_id1;
                return {
                    devices: storedDevices,
                    connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(storedDevices, (_virtualDevice_id = virtualDevice === null || virtualDevice === void 0 ? void 0 : virtualDevice.id) !== null && _virtualDevice_id !== void 0 ? _virtualDevice_id : null),
                    virtualDeviceId: (_virtualDevice_id1 = virtualDevice === null || virtualDevice === void 0 ? void 0 : virtualDevice.id) !== null && _virtualDevice_id1 !== void 0 ? _virtualDevice_id1 : null,
                    virtualDeviceToken: virtualDeviceToken,
                    isInitialized: true
                };
            });
        } catch (e) {
            console.log('Error loading devices from storage', e);
            set({
                isInitialized: true
            });
        }
    };
    const initializeFromRemote = async (computerName, hardwareId, platform = 'generic')=>{
        try {
            var _virtualResult_errors;
            set({
                isInitialized: false
            });
            const virtualResult = await get().initializeVirtualController(computerName, hardwareId, platform);
            const deviceLoadResult = await get().getDevices();
            var _virtualResult_errors_;
            if (!get().virtualDeviceId) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)((_virtualResult_errors_ = virtualResult === null || virtualResult === void 0 ? void 0 : (_virtualResult_errors = virtualResult.errors) === null || _virtualResult_errors === void 0 ? void 0 : _virtualResult_errors[0]) !== null && _virtualResult_errors_ !== void 0 ? _virtualResult_errors_ : 'Unable to register this device');
            return deviceLoadResult;
        } catch (error) {
            console.error('[ERROR initializeFromRemote]', error);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set({
                isInitialized: true,
                isLoading: false
            });
        }
    };
    const registerNewVirtualDevice = async (computerName, hardwareId, platform = 'generic')=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$b77d91733b0be1c3((0, $2e1b9b7946b06a36$export$e57a519b54d74351), computerName, hardwareId, platform);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                const tokenResult = await $1a4c36336f303477$export$d90355b21d70c45b(result.data.id, {
                    includeUserEvents: true
                });
                const token = tokenResult.resultType === 'Ok' && tokenResult.data ? tokenResult.data : null;
                set((state)=>({
                        // Track the newly registered device locally right away so it survives the
                        // isVerified filter in getDevices() and is available for spec/OEM reporting.
                        devices: state.devices.some((d)=>d.id === result.data.id) ? state.devices : [
                            ...state.devices,
                            result.data
                        ],
                        virtualDeviceId: result.data.id,
                        virtualDeviceToken: token
                    }));
                snapshotState(get().devices, result.data.id, token);
                return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)([
                    result.data,
                    token
                ]);
            } else if (result.errors != null && result.errors.length > 0) set({
                errors: [
                    ...result.errors
                ]
            });
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result), {
                data: [
                    null,
                    null
                ]
            });
        } catch (error) {
            set({
                errors: [
                    error
                ]
            });
            console.debug('[ERROR registerNewVirtualDevice]', error);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set({
                isLoading: false
            });
        }
    };
    const initializeVirtualController = async (computerName, hardwareId, platform = 'generic')=>{
        try {
            const existingVirtualDevice = getLocalVirtualDevice();
            const existingToken = getLocalVirtualDeviceToken();
            if (existingVirtualDevice && existingToken) {
                set({
                    virtualDeviceId: existingVirtualDevice.id,
                    virtualDeviceToken: existingToken
                });
                await updateDevicePlatform(existingVirtualDevice, platform);
                return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)([
                    existingVirtualDevice,
                    existingToken
                ]);
            }
            return await get().registerNewVirtualDevice(computerName, hardwareId, platform);
        } catch (error) {
            set({
                errors: [
                    error
                ]
            });
            console.debug('[ERROR initializeVirtualController]', error);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getDevices = async ()=>{
        try {
            set({
                isLoading: true
            });
            const result = await $1a4c36336f303477$export$7d50e0ca36e10692();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                const { virtualDeviceId: virtualDeviceId, virtualDeviceToken: virtualDeviceToken, devices: prevDevices } = get();
                const loadedDevices = result.data.filter((d)=>d.isVerified);
                // Always keep this machine's own (virtual) device locally, even if the backend
                // hasn't marked it verified yet — e.g. a brand-new registration. Without this the
                // just-created device is filtered out, so features keyed off the virtual device
                // (device spec / OEM reporting) never run on a new user's first session.
                if (virtualDeviceId && !loadedDevices.some((d)=>d.id === virtualDeviceId)) {
                    var _result_data_find;
                    const virtualDevice = (_result_data_find = result.data.find((d)=>d.id === virtualDeviceId)) !== null && _result_data_find !== void 0 ? _result_data_find : prevDevices.find((d)=>d.id === virtualDeviceId);
                    if (virtualDevice) loadedDevices.push(virtualDevice);
                }
                set({
                    devices: loadedDevices,
                    connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(loadedDevices, virtualDeviceId)
                });
                snapshotState(loadedDevices, virtualDeviceId, virtualDeviceToken);
                return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(loadedDevices);
            }
            return result;
        } catch (e) {
            set({
                errors: [
                    'Error getting devices'
                ]
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set({
                isLoading: false
            });
        }
    };
    const getDeviceDetails = async (userDeviceId)=>{
        try {
            const result = await $1a4c36336f303477$export$7c456bfd2296405b(userDeviceId);
            let device = get().getLocalDevice(userDeviceId);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                updateLocalDevice(result.data);
                device = result.data;
            }
            return device;
        } catch (e) {
            return null;
        }
    };
    const getLocalDevice = (userDeviceId)=>{
        var _get_devices;
        if (!userDeviceId) return null;
        var _get_devices_find;
        return (_get_devices_find = (_get_devices = get().devices) === null || _get_devices === void 0 ? void 0 : _get_devices.find((d)=>d.id === userDeviceId)) !== null && _get_devices_find !== void 0 ? _get_devices_find : null;
    };
    const getDeviceName = (deviceId)=>{
        var _device_device, _device_device_deviceType;
        const device = get().getLocalDevice(deviceId);
        var _device_nameOverride, _ref, _ref1;
        if (device) return (_ref1 = (_ref = (_device_nameOverride = device.nameOverride) !== null && _device_nameOverride !== void 0 ? _device_nameOverride : (_device_device = device.device) === null || _device_device === void 0 ? void 0 : _device_device.name) !== null && _ref !== void 0 ? _ref : (_device_device_deviceType = device.device.deviceType) === null || _device_device_deviceType === void 0 ? void 0 : _device_device_deviceType.name) !== null && _ref1 !== void 0 ? _ref1 : '-';
        return '-';
    };
    const updateVirtualDevice = (device)=>updateLocalDevice(device);
    const updateDevice = async (userDeviceId, update)=>{
        const result = await $1a4c36336f303477$export$18c61c16dde23826(userDeviceId, update);
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) updateLocalDevice(result.data);
        return result;
    };
    const deleteDevice = async (userDeviceId)=>{
        try {
            const result = await $1a4c36336f303477$export$7cbb8f3d5a86c9b4(userDeviceId);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                const { devices: devices, virtualDeviceId: virtualDeviceId, virtualDeviceToken: virtualDeviceToken, outputDeviceId: outputDeviceId } = get();
                const updatedDevices = devices.filter((d)=>d.id !== userDeviceId);
                const isVirtualDevice = virtualDeviceId === userDeviceId;
                if (isVirtualDevice) {
                    set({
                        virtualDeviceId: null,
                        virtualDeviceToken: null
                    });
                    localStorage.removeItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
                    localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1));
                    localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
                }
                if (outputDeviceId === userDeviceId) set({
                    outputDeviceId: null
                });
                const newVirtualId = isVirtualDevice ? null : virtualDeviceId;
                set({
                    devices: updatedDevices,
                    connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(updatedDevices, newVirtualId)
                });
                snapshotState(updatedDevices, newVirtualId, isVirtualDevice ? null : virtualDeviceToken);
            }
            return result;
        } catch (e) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const disableDevice = async (userDeviceId)=>{
        try {
            const result = await $1a4c36336f303477$export$c25252bb8cefd145(userDeviceId);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                const { devices: devices, virtualDeviceId: virtualDeviceId, virtualDeviceToken: virtualDeviceToken, outputDeviceId: outputDeviceId } = get();
                const deviceIndex = devices.findIndex((x)=>x.id === userDeviceId);
                if (deviceIndex !== -1) {
                    const updatedDevices = devices.filter((_, i)=>i !== deviceIndex);
                    const isVirtualDevice = virtualDeviceId === userDeviceId;
                    if (isVirtualDevice) {
                        set({
                            virtualDeviceId: null,
                            virtualDeviceToken: null
                        });
                        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$c66d0139ef02a287));
                        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e79477942e3c1f1));
                        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$e0520dc8c020e730));
                    }
                    if (outputDeviceId === userDeviceId) set({
                        outputDeviceId: null
                    });
                    const newVirtualId = isVirtualDevice ? null : virtualDeviceId;
                    set({
                        devices: updatedDevices,
                        connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(updatedDevices, newVirtualId)
                    });
                    snapshotState(updatedDevices, newVirtualId, isVirtualDevice ? null : virtualDeviceToken);
                }
            }
            return result;
        } catch (e) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const removeLocalDevice = (userDeviceId)=>{
        const { devices: devices, virtualDeviceId: virtualDeviceId, virtualDeviceToken: virtualDeviceToken } = get();
        const updatedDevices = devices.filter((d)=>d.id !== userDeviceId);
        const isVirtualDevice = virtualDeviceId === userDeviceId;
        const newVirtualId = isVirtualDevice ? null : virtualDeviceId;
        set({
            devices: updatedDevices,
            connectedDevices: $57ef534a0961ba07$var$computeConnectedDevices(updatedDevices, newVirtualId)
        });
        snapshotState(updatedDevices, newVirtualId, virtualDeviceToken);
    };
    const checkForUpdates = async (userDeviceId)=>{
        const token = await getDeviceToken(userDeviceId);
        if (!token) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        return await $1a4c36336f303477$export$e5712e6cd1606beb(userDeviceId, token.token);
    };
    const setDeviceProfile = async (deviceId, profile)=>{
        try {
            var _get_devices;
            if (!deviceId) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device ID is required to set profile');
            const device = (_get_devices = get().devices) === null || _get_devices === void 0 ? void 0 : _get_devices.find((d)=>d.id === deviceId);
            if (!device) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device not found');
            if (!(0, $28343ab509e453ee$export$6ff753f9d38ae18d)(profile, $57ef534a0961ba07$var$userLicenseAccessRef.current)) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Invalid permissions. Cannot set device profile');
            let result = new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            let updatedDevice = device;
            const profileUpdate = profile.isPublic ? {
                customProfileId: null,
                defaultProfileId: profile.id
            } : {
                customProfileId: profile.id
            };
            result = await $1a4c36336f303477$export$c35b3a8741882c0(deviceId, profileUpdate);
            if (result.resultType === 'Ok' && result.data) updatedDevice = result.data;
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'NoResponse' || (result === null || result === void 0 ? void 0 : result.resultType) === 'Offline') {
                updatedDevice = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, device);
                if (profile.isPublic) {
                    updatedDevice.currentProfile = null;
                    updatedDevice.defaultProfileId = profile.id;
                } else updatedDevice.currentProfile = profile;
                result = new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(updatedDevice);
            }
            updateLocalDevice(updatedDevice);
            return result;
        } catch (e) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const resetDeviceProfile = async (deviceId, profile)=>{
        var _get_devices;
        if (!deviceId) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device ID is not set');
        const device = (_get_devices = get().devices) === null || _get_devices === void 0 ? void 0 : _get_devices.find((d)=>d.id === deviceId);
        if (!device) return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)('Device not found');
        let result;
        if (profile === null || profile === void 0 ? void 0 : profile.isPublic) result = await $1a4c36336f303477$export$c35b3a8741882c0(deviceId, {
            defaultProfileId: null
        });
        else result = await $1a4c36336f303477$export$c35b3a8741882c0(deviceId, {
            customProfileId: null
        });
        let updatedDevice = device;
        if (result.resultType === 'Ok' && result.data) updatedDevice = result.data;
        else if (result.resultType !== 'Ok') {
            updatedDevice = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, device);
            if (profile === null || profile === void 0 ? void 0 : profile.isPublic) updatedDevice.defaultProfileId = null;
            else updatedDevice.currentProfile = null;
            result = new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(updatedDevice);
        }
        updateLocalDevice(updatedDevice);
        return result;
    };
    const startListening = async (userDeviceId)=>{
        const token = await getDeviceToken(userDeviceId);
        if (!token) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        return await $1a4c36336f303477$export$2fbfcdb28574a0(userDeviceId, token.token);
    };
    const stopListening = async (userDeviceId)=>{
        var _get_devices;
        const token = await getDeviceToken(userDeviceId);
        if (!token) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        const device = (_get_devices = get().devices) === null || _get_devices === void 0 ? void 0 : _get_devices.find((d)=>d.id === userDeviceId);
        if (!device || !device.isListening) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        return await $1a4c36336f303477$export$8f1ea12fa311585e(userDeviceId, token.token);
    };
    const stopAllOutputs = async (userDeviceId, profile)=>{
        await get().tryDeviceCommand(userDeviceId, (0, $f44f3a5bc46b1c4c$export$8c2b4826af6cc511), profile);
    };
    const tryDeviceCommand = async (userDeviceId, command, profile, additionalInputContent)=>{
        const { tryCommandHandlers: tryCommandHandlers, tryGlobalControlHandlers: tryGlobalControlHandlers, virtualDeviceId: virtualDeviceId, devices: devices } = get();
        if (userDeviceId === virtualDeviceId) {
            if (profile) for (const handler of tryCommandHandlers){
                if (handler(command, profile)) return true;
            }
        } else {
            var _device_currentProfile_configuration_macros, _device_currentProfile_configuration, _device_currentProfile, _device_currentProfile_configuration1, _device_currentProfile1;
            const device = devices === null || devices === void 0 ? void 0 : devices.find((d)=>d.id === userDeviceId);
            if (device && profile && !(0, $488d70defc02145b$export$e9455858f5005fb)(command, profile)) {
                for (const handler of tryGlobalControlHandlers){
                    if (handler(command, userDeviceId)) return true;
                }
                return false;
            }
            let macro = device === null || device === void 0 ? void 0 : (_device_currentProfile = device.currentProfile) === null || _device_currentProfile === void 0 ? void 0 : (_device_currentProfile_configuration = _device_currentProfile.configuration) === null || _device_currentProfile_configuration === void 0 ? void 0 : (_device_currentProfile_configuration_macros = _device_currentProfile_configuration.macros) === null || _device_currentProfile_configuration_macros === void 0 ? void 0 : _device_currentProfile_configuration_macros.find((m)=>m.commands.some((c)=>c.toLowerCase() === command.toLowerCase()));
            const keybinding = device === null || device === void 0 ? void 0 : (_device_currentProfile1 = device.currentProfile) === null || _device_currentProfile1 === void 0 ? void 0 : (_device_currentProfile_configuration1 = _device_currentProfile1.configuration) === null || _device_currentProfile_configuration1 === void 0 ? void 0 : _device_currentProfile_configuration1.commandKeyMappings.find((k)=>k.commands.some((c)=>c.toLowerCase() === command.toLowerCase()));
            if (!macro && keybinding && keybinding.key) macro = {
                id: 'keybind' + keybinding.key,
                name: 'keybind',
                commands: [
                    command
                ],
                events: [
                    {
                        keys: [
                            keybinding.key
                        ],
                        eventType: 'KeyPress',
                        isKeyLatch: false,
                        holdTimeMilliseconds: 0
                    }
                ]
            };
            return await get().sendDeviceCommand(userDeviceId, command, macro);
        }
        return false;
    };
    const tryDeviceTypeCommand = async (userDeviceId, phrase)=>{
        var _get_devices;
        const device = (_get_devices = get().devices) === null || _get_devices === void 0 ? void 0 : _get_devices.find((d)=>d.id === userDeviceId);
        if (device) {
            const token = await getDeviceToken(userDeviceId);
            if (token) {
                await $1a4c36336f303477$export$24fb0aee8e6ea00f(userDeviceId, phrase, token.token);
                return true;
            }
        }
        return false;
    };
    const sendDeviceCommand = async (userDeviceId, command, macro)=>{
        var _get_devices, _device_device_deviceType, _device_device;
        const device = (_get_devices = get().devices) === null || _get_devices === void 0 ? void 0 : _get_devices.find((d)=>d.id === userDeviceId);
        if (!device) return false;
        const throttleRules = (_device_device = device.device) === null || _device_device === void 0 ? void 0 : (_device_device_deviceType = _device_device.deviceType) === null || _device_device_deviceType === void 0 ? void 0 : _device_device_deviceType.commandThrottleRules;
        let macroToSend = macro ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro) : undefined;
        if (macroToSend && (throttleRules === null || throttleRules === void 0 ? void 0 : throttleRules.maximumMacroLength) != null && throttleRules.maximumMacroLength > 0) {
            if (macroToSend.events && macroToSend.events.length > throttleRules.maximumMacroLength) {
                var _throttleWarningHandlersRef_current;
                macroToSend.events = macroToSend.events.slice(0, throttleRules.maximumMacroLength);
                (_throttleWarningHandlersRef_current = $57ef534a0961ba07$var$throttleWarningHandlersRef.current) === null || _throttleWarningHandlersRef_current === void 0 ? void 0 : _throttleWarningHandlersRef_current.forEach((handler)=>handler('macroLength'));
            }
        }
        if ((macroToSend === null || macroToSend === void 0 ? void 0 : macroToSend.events) && throttleRules) {
            var _throttleRules_incompatibleActionGroups, _throttleRules_requiredPauseBetweenRules;
            if ((_throttleRules_incompatibleActionGroups = throttleRules.incompatibleActionGroups) === null || _throttleRules_incompatibleActionGroups === void 0 ? void 0 : _throttleRules_incompatibleActionGroups.length) {
                const violation = (0, $b903537072c9f7db$export$d9bacc24f8864304)(macroToSend.events, throttleRules.incompatibleActionGroups);
                if (violation) {
                    var _throttleWarningHandlersRef_current1;
                    (_throttleWarningHandlersRef_current1 = $57ef534a0961ba07$var$throttleWarningHandlersRef.current) === null || _throttleWarningHandlersRef_current1 === void 0 ? void 0 : _throttleWarningHandlersRef_current1.forEach((handler)=>handler('incompatibleActions'));
                    return false;
                }
            }
            if ((_throttleRules_requiredPauseBetweenRules = throttleRules.requiredPauseBetweenRules) === null || _throttleRules_requiredPauseBetweenRules === void 0 ? void 0 : _throttleRules_requiredPauseBetweenRules.length) macroToSend.events = (0, $b903537072c9f7db$export$3c1f0d172b774752)(macroToSend.events, throttleRules.requiredPauseBetweenRules);
            macroToSend.events = (0, $b903537072c9f7db$export$e03905f1a6ff1d64)(macroToSend.events, throttleRules);
        }
        if (macroToSend) macroToSend.issuedAt = new Date().toISOString();
        const now = Date.now();
        if (!$57ef534a0961ba07$var$deviceThrottleStateRef.current[userDeviceId]) $57ef534a0961ba07$var$deviceThrottleStateRef.current[userDeviceId] = {
            perSecond: [],
            perMinute: []
        };
        const state = $57ef534a0961ba07$var$deviceThrottleStateRef.current[userDeviceId];
        state.perSecond = state.perSecond.filter((ts)=>now - ts < 1000);
        state.perMinute = state.perMinute.filter((ts)=>now - ts < 60000);
        const maxPerSecond = (throttleRules === null || throttleRules === void 0 ? void 0 : throttleRules.maximumCommandsPerSecond) && throttleRules.maximumCommandsPerSecond > 0 ? throttleRules.maximumCommandsPerSecond : null;
        if (maxPerSecond && state.perSecond.length >= maxPerSecond) {
            var _throttleWarningHandlersRef_current2;
            (_throttleWarningHandlersRef_current2 = $57ef534a0961ba07$var$throttleWarningHandlersRef.current) === null || _throttleWarningHandlersRef_current2 === void 0 ? void 0 : _throttleWarningHandlersRef_current2.forEach((handler)=>handler('commandCount'));
            return false;
        }
        const maxPerMinute = (throttleRules === null || throttleRules === void 0 ? void 0 : throttleRules.maximumCommandsPerMinute) && throttleRules.maximumCommandsPerMinute > 0 ? throttleRules.maximumCommandsPerMinute : null;
        if (maxPerMinute && state.perMinute.length >= maxPerMinute) {
            var _throttleWarningHandlersRef_current3;
            (_throttleWarningHandlersRef_current3 = $57ef534a0961ba07$var$throttleWarningHandlersRef.current) === null || _throttleWarningHandlersRef_current3 === void 0 ? void 0 : _throttleWarningHandlersRef_current3.forEach((handler)=>handler('commandCount'));
            return false;
        }
        state.perSecond.push(now);
        state.perMinute.push(now);
        const token = await getDeviceToken(userDeviceId);
        if (token) {
            await $1a4c36336f303477$export$52e3a002786737fb(userDeviceId, command, token.token, macroToSend);
            return true;
        }
        return false;
    };
    const updateCurrentAppName = (appName)=>{
        if (appName !== $57ef534a0961ba07$var$currentAppNameRef.current) {
            $57ef534a0961ba07$var$currentAppNameRef.current = appName;
            get().fallbackToDeviceSwitching();
            return true;
        }
        return false;
    };
    const updateOutputDeviceId = async (deviceId)=>{
        const { connectedDevices: connectedDevices, outputDeviceId: outputDeviceId, virtualDeviceId: virtualDeviceId } = get();
        if (deviceId !== outputDeviceId) {
            var _device_device_deviceType, _device_device;
            set({
                outputDeviceId: deviceId
            });
            const device = deviceId ? await get().getDeviceDetails(deviceId) : null;
            if (connectedDevices.length > 1 && device) (0, $e7df95de73caec26$export$89b472e03be495df)('analyticsTrackEvent', {
                eventName: 'output_device_switched',
                data: {
                    deviceTypeId: device === null || device === void 0 ? void 0 : (_device_device = device.device) === null || _device_device === void 0 ? void 0 : (_device_device_deviceType = _device_device.deviceType) === null || _device_device_deviceType === void 0 ? void 0 : _device_device_deviceType.id
                }
            });
        }
        if (deviceId === virtualDeviceId) get().fallbackToDeviceSwitching();
    };
    const fallbackToDeviceSwitching = ()=>{
        set({
            isSwitchingTempDisabled: false
        });
    };
    const overrideAppSwitching = ()=>{
        if (!get().isSwitchingTempDisabled) set({
            isSwitchingTempDisabled: true
        });
    };
    const isAutoProfileSwitchingDisabled = ()=>{
        const { outputDeviceId: outputDeviceId, devices: devices, isSwitchingTempDisabled: isSwitchingTempDisabled } = get();
        if (!outputDeviceId) return true;
        const device = devices === null || devices === void 0 ? void 0 : devices.find((d)=>d.id === outputDeviceId);
        return !get().isDeviceVirtualController(outputDeviceId) || !(device === null || device === void 0 ? void 0 : device.isAutoProfileSwitchingEnabled) || isSwitchingTempDisabled;
    };
    const isDeviceVirtualController = (deviceId)=>deviceId === get().virtualDeviceId;
    const isDesktopApp = (deviceTypeId)=>deviceTypeId === (0, $2e1b9b7946b06a36$export$e57a519b54d74351);
    const clearDevices = ()=>{
        set({
            devices: [],
            connectedDevices: [],
            virtualDeviceId: null,
            virtualDeviceToken: null,
            outputDeviceId: null,
            deviceTypeClientList: []
        });
        snapshotState([], null, null);
    };
    const initializeDeviceTypesClientList = async (locale)=>{
        set({
            deviceTypesInitializing: true
        });
        try {
            const result = await $1a4c36336f303477$export$1550d2bbaae6a36d(locale);
            if (result && result.data) set({
                deviceTypeClientList: result.data
            });
        } catch (e) {
            set({
                deviceTypeClientList: []
            });
        } finally{
            set({
                deviceTypesInitializing: false
            });
        }
    };
    return {
        // State
        connectedDevices: [],
        deviceCommandTokens: [],
        devices: [],
        deviceTypeClientList: [],
        deviceTypesInitializing: true,
        errors: [],
        isInitialized: false,
        isLoading: true,
        isSwitchingTempDisabled: false,
        outputDeviceId: null,
        throttleWarningHandlers: [],
        tryCommandHandlers: [],
        tryGlobalControlHandlers: [],
        virtualDeviceId: null,
        virtualDeviceToken: null,
        throttleWarningHandlersRef: // Refs
        $57ef534a0961ba07$var$throttleWarningHandlersRef,
        addThrottleWarningHandler: // Actions
        addThrottleWarningHandler,
        addTryCommandHandler: addTryCommandHandler,
        addTryGlobalControlHandler: addTryGlobalControlHandler,
        removeThrottleWarningHandlers: removeThrottleWarningHandlers,
        removeTryGlobalControlHandler: removeTryGlobalControlHandler,
        removeTryCommandHandler: removeTryCommandHandler,
        checkForUpdates: checkForUpdates,
        clearDevices: clearDevices,
        deleteDevice: deleteDevice,
        disableDevice: disableDevice,
        fallbackToDeviceSwitching: fallbackToDeviceSwitching,
        getDeviceName: getDeviceName,
        getDevices: getDevices,
        getLocalDevice: getLocalDevice,
        initializeDeviceTypesClientList: initializeDeviceTypesClientList,
        initializeFromRemote: initializeFromRemote,
        initializeFromStorage: initializeFromStorage,
        initializeVirtualController: initializeVirtualController,
        isAutoProfileSwitchingDisabled: isAutoProfileSwitchingDisabled,
        isDesktopApp: isDesktopApp,
        isDeviceVirtualController: isDeviceVirtualController,
        overrideAppSwitching: overrideAppSwitching,
        getDeviceDetails: getDeviceDetails,
        registerNewVirtualDevice: registerNewVirtualDevice,
        removeLocalDevice: removeLocalDevice,
        resetDeviceProfile: resetDeviceProfile,
        sendDeviceCommand: sendDeviceCommand,
        setDeviceProfile: setDeviceProfile,
        setDevices: setDevices,
        startListening: startListening,
        stopAllOutputs: stopAllOutputs,
        stopListening: stopListening,
        tryDeviceCommand: tryDeviceCommand,
        tryDeviceTypeCommand: tryDeviceTypeCommand,
        updateCurrentAppName: updateCurrentAppName,
        updateDevice: updateDevice,
        updateLocalDevice: updateLocalDevice,
        updateOutputDeviceId: updateOutputDeviceId,
        updateVirtualDevice: updateVirtualDevice
    };
});
// Module-level event subscriptions (replace useEffect([], []))
(0, $e7df95de73caec26$export$ec068583843480e7)('userLicenseChangeLocal', async (data)=>{
    if (data) $57ef534a0961ba07$var$userLicenseAccessRef.current = data;
});
(0, $e7df95de73caec26$export$ec068583843480e7)('device-added', (data)=>{
    $57ef534a0961ba07$export$2b13470419707314.getState().updateLocalDevice(data.device);
});
(0, $e7df95de73caec26$export$ec068583843480e7)('remove-device', (data)=>{
    $57ef534a0961ba07$export$2b13470419707314.getState().removeLocalDevice(data.device.id);
});


const $b8d2d4cc121e033d$var$computeCurrentDeviceControls = (available, currentDeviceId)=>{
    var _available_find, _available_find1;
    const global = available === null || available === void 0 ? void 0 : (_available_find = available.find((d)=>d.deviceId === 'global')) === null || _available_find === void 0 ? void 0 : _available_find.controls;
    const device = available === null || available === void 0 ? void 0 : (_available_find1 = available.find((d)=>d.deviceId === currentDeviceId)) === null || _available_find1 === void 0 ? void 0 : _available_find1.controls;
    return {
        global: global,
        device: device
    };
};
const $b8d2d4cc121e033d$export$5c51a4b25a3f0496 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const handleVoiceDictationControlsUpdate = (dictationControls)=>{
        set((state)=>{
            state.voiceDictationCustomControls = dictationControls;
        });
        (0, $e7df95de73caec26$export$89b472e03be495df)('update-voice-dictation-controls', dictationControls);
    };
    const snapshotState = ()=>{
        const state = get();
        localStorage.setItem((0, $db3063bd3b6d501e$export$7b02f2982f8105ff), JSON.stringify({
            available: state.availableCustomControls,
            profile: state.profileCustomControls,
            paused: [
                ...state.voicePausedCustomControls
            ],
            dictation: [
                ...state.voiceDictationCustomControls
            ],
            prefix: [
                ...state.voicePrefixCustomControls
            ]
        }));
    };
    const resetVoiceCustomControls = ()=>{
        var _get_availableCustomControls;
        const paused = [];
        const dictation = [];
        const prefix = [];
        (_get_availableCustomControls = get().availableCustomControls) === null || _get_availableCustomControls === void 0 ? void 0 : _get_availableCustomControls.forEach((deviceControls)=>{
            if (deviceControls.deviceId !== deviceControls.deviceTypeId || deviceControls.deviceId === 'global') {
                deviceControls.controls.filter((c)=>c.allowWhenVoicePaused).forEach((c)=>{
                    if (c.commands) paused.push(...c.commands);
                });
                deviceControls.controls.filter((c)=>c.allowWhenDictating).forEach((c)=>{
                    if (c.commands) dictation.push(...c.commands);
                });
                deviceControls.controls.filter((c)=>c.isPrefixVoiceCommand).forEach((c)=>{
                    if (c.commands) prefix.push(...c.commands);
                });
            }
        });
        set((state)=>{
            state.voicePausedCustomControls = new Set(paused);
            state.voicePrefixCustomControls = new Set(prefix);
        });
        handleVoiceDictationControlsUpdate(new Set(dictation));
    };
    const setAvailableControlsState = (available, profile)=>{
        const currentDeviceId = (0, $43d630686eddb628$export$21b1c44aa0aad518).getState().id;
        const deviceControls = $b8d2d4cc121e033d$var$computeCurrentDeviceControls(available, currentDeviceId);
        set((state)=>{
            state.availableCustomControls = available;
            state.currentDeviceControls = deviceControls;
            if (profile !== undefined) state.profileCustomControls = profile;
        });
    };
    const updateAvailableCustomControls = (index, controls, deviceId, deviceTypeId, name)=>{
        const current = get().availableCustomControls;
        if (current) {
            let updated;
            if (index < 0) updated = [
                ...current,
                {
                    deviceId: deviceId,
                    deviceTypeId: deviceTypeId,
                    name: name,
                    controls: controls
                }
            ];
            else updated = current.map((d, i)=>i === index ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, d), {
                    controls: controls
                }) : d);
            setAvailableControlsState(updated);
        }
        resetVoiceCustomControls();
        snapshotState();
    };
    const cleanCommand = (command)=>command.toLowerCase().trim();
    const separatePrefixCommand = (command)=>{
        const voicePrefixCustomControls = get().voicePrefixCustomControls;
        if (!voicePrefixCustomControls || !command) return undefined;
        const lowered = command.toLowerCase();
        for (const prefix of voicePrefixCustomControls){
            const candidate = prefix.toLowerCase();
            // The trigger has to be a whole word at the head of the phrase, or "opening the door"
            // reads as the `open` prefix with "ing the door" as its input.
            if (lowered !== candidate && !lowered.startsWith(candidate + ' ')) continue;
            let idx = candidate.length;
            while(command[idx] === ' ')idx++;
            return {
                prefix: prefix,
                phrase: command.substring(idx)
            };
        }
        return undefined;
    };
    const findCustomControl = (command, currentDeviceId, isEligibleControl, additionalInputContent)=>{
        const availableCustomControls = get().availableCustomControls;
        if (!availableCustomControls) return null;
        for (const deviceControls of availableCustomControls){
            if (deviceControls.deviceId === currentDeviceId || deviceControls.deviceId === 'global') for (const control of deviceControls.controls){
                var _control_commands;
                if (isEligibleControl(control) && ((_control_commands = control.commands) === null || _control_commands === void 0 ? void 0 : _control_commands.includes(command))) return convertCustomControlToMacro(deviceControls, control, additionalInputContent);
            }
        }
        return null;
    };
    const convertCustomControlToMacro = (customControls, control, additionalInputContent)=>({
            id: control.id,
            name: control.name,
            commands: control.commands || [],
            events: [
                {
                    eventType: 'DeviceTypeCustomAction',
                    additionalInputContent: additionalInputContent,
                    deviceTypeCustomActionId: control.id,
                    deviceTypeId: customControls.deviceId
                }
            ]
        });
    const setResetDeviceControls = (v)=>set((state)=>{
            state.resetDeviceControls = v;
        });
    const setAvailableCustomControls = (controls)=>setAvailableControlsState(controls);
    const initializeFromStorage = (localePreferences)=>{
        try {
            set((state)=>{
                state.isLoading = true;
            });
            const storedControls = localStorage.getItem((0, $db3063bd3b6d501e$export$7b02f2982f8105ff));
            if (storedControls) {
                const parsedControls = JSON.parse(storedControls);
                const devices = (0, $57ef534a0961ba07$export$2b13470419707314).getState().devices;
                const available = [];
                if (devices) for (const device of devices){
                    var _device_device_deviceType, _device_device;
                    const storedDeviceControls = parsedControls.available.find((d)=>d.deviceId === device.id);
                    if (storedDeviceControls) available.push({
                        deviceId: device.id,
                        deviceTypeId: ((_device_device = device.device) === null || _device_device === void 0 ? void 0 : (_device_device_deviceType = _device_device.deviceType) === null || _device_device_deviceType === void 0 ? void 0 : _device_device_deviceType.id) || device.id,
                        name: (0, $57ef534a0961ba07$export$2b13470419707314).getState().getDeviceName(device.id),
                        controls: storedDeviceControls.controls
                    });
                }
                const globalControls = parsedControls.available.find((d)=>d.deviceId === 'global');
                if (globalControls) available.push({
                    deviceId: 'global',
                    deviceTypeId: 'global',
                    name: 'Cephable',
                    controls: globalControls.controls
                });
                setAvailableControlsState(available, parsedControls.profile);
                set((state)=>{
                    state.customControlsLocale = localePreferences.defaultVoiceLocale;
                    state.voicePausedCustomControls = new Set(parsedControls.paused);
                    state.voicePrefixCustomControls = new Set(parsedControls.prefix);
                });
                handleVoiceDictationControlsUpdate(new Set(parsedControls.dictation));
            }
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Failed to parse custom controls from local storage.'
                ];
            });
        } finally{
            set((state)=>{
                state.isLoading = false;
            });
        }
    };
    const initializeFromRemote = async (localePreferences, virtualDeviceId)=>{
        try {
            set((state)=>{
                state.isLoading = true;
                state.userLocale = localePreferences.defaultVoiceLocale;
                state.customControlsLocale = localePreferences.defaultVoiceLocale;
            });
            const locale = localePreferences.defaultVoiceLocale;
            const interfaceResult = await $1a4c36336f303477$export$3c6d5a5870f12c81(locale);
            const virtualDeviceResult = virtualDeviceId ? await $1a4c36336f303477$export$600b579bd3ac45b1(virtualDeviceId, locale) : new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            const available = [];
            const profile = [];
            const devices = (0, $57ef534a0961ba07$export$2b13470419707314).getState().devices;
            if (devices) for (const device of devices){
                var _device_device;
                if (device.isVerified === false) continue;
                const deviceType = (_device_device = device.device) === null || _device_device === void 0 ? void 0 : _device_device.deviceType;
                if (deviceType && device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) {
                    const dtResult = await $1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceType.id, locale);
                    if ((dtResult === null || dtResult === void 0 ? void 0 : dtResult.resultType) === 'Ok' && dtResult.data) device.customControls = dtResult.data.controls.map((c)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c), {
                            isDeviceTypeControl: true
                        }));
                }
                if (device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) continue;
                const deviceId = device.id;
                const deviceName = (0, $57ef534a0961ba07$export$2b13470419707314).getState().getDeviceName(deviceId);
                const isPrivate = deviceType === null || deviceType === void 0 ? void 0 : deviceType.isPrivate;
                let controls;
                if (deviceId === virtualDeviceId && (virtualDeviceResult === null || virtualDeviceResult === void 0 ? void 0 : virtualDeviceResult.resultType) === 'Ok' && virtualDeviceResult.data) controls = virtualDeviceResult.data.controls;
                else controls = (0, $2616fe0411c33582$export$82e40272e8bb746b)(device.customControls, device.customDeviceTypeControlOverrides);
                available.push({
                    deviceId: deviceId,
                    deviceTypeId: deviceType.id,
                    name: deviceName,
                    isPrivate: isPrivate,
                    controls: controls
                });
                const profileControls = controls.filter((c)=>c.isProfileControl);
                if (profileControls.length > 0) profile.push({
                    deviceId: deviceId,
                    deviceTypeId: deviceType.id,
                    name: deviceName,
                    isPrivate: isPrivate,
                    controls: profileControls
                });
            }
            if ((interfaceResult === null || interfaceResult === void 0 ? void 0 : interfaceResult.resultType) === 'Ok' && interfaceResult.data) {
                const globalDevice = {
                    deviceId: 'global',
                    deviceTypeId: 'global',
                    name: 'Cephable',
                    isPrivate: false,
                    controls: interfaceResult.data.controls
                };
                available.push(globalDevice);
                const profileInterface = interfaceResult.data.controls.filter((c)=>c.isProfileControl);
                if (profileInterface.length > 0) profile.push(globalDevice);
            }
            setAvailableControlsState(available, profile);
            resetVoiceCustomControls();
            snapshotState();
            return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(true);
        } catch (error) {
            console.log(error);
            set((state)=>{
                state.errors = [
                    String(error)
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set((state)=>{
                state.isLoading = false;
            });
        }
    };
    const getDeviceCustomControls = async (userDeviceId)=>{
        try {
            const locale = get().customControlsLocale;
            return await $1a4c36336f303477$export$600b579bd3ac45b1(userDeviceId, locale);
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error getting device custom controls'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getDeviceControlName = (controlId)=>{
        const availableCustomControls = get().availableCustomControls;
        if (!availableCustomControls) return controlId;
        for (const deviceCtrl of availableCustomControls)for (const control of deviceCtrl.controls){
            if (control.id === controlId) return control.name;
        }
        return controlId;
    };
    const getFinalControlMacro = (command, currentDeviceId, additionalInputContent, isEligibleControl)=>{
        const cleanedCommand = cleanCommand(command);
        if (cleanedCommand.length === 0) return null;
        const prefixResult = separatePrefixCommand(command);
        let effectiveCommand = cleanedCommand;
        let effectiveInput = additionalInputContent;
        if (prefixResult) {
            effectiveCommand = prefixResult.prefix;
            effectiveInput = prefixResult.phrase;
        }
        const isEligible = isEligibleControl !== null && isEligibleControl !== void 0 ? isEligibleControl : ()=>true;
        return findCustomControl(effectiveCommand, currentDeviceId, isEligible, effectiveInput);
    };
    const getFinalDictationControlMacro = (command, currentDeviceId, isPaused, additionalInputContent)=>{
        const cleanedCommand = cleanCommand(command);
        if (cleanedCommand.length === 0) return null;
        const prefixResult = separatePrefixCommand(command);
        let effectiveCommand = cleanedCommand;
        let effectiveInput = additionalInputContent;
        if (prefixResult) {
            effectiveCommand = prefixResult.prefix;
            effectiveInput = prefixResult.phrase;
        }
        const state = get();
        if (isPaused) {
            if (!state.voicePausedCustomControls.has(effectiveCommand)) return null;
        } else {
            if (!state.voiceDictationCustomControls.has(effectiveCommand)) return null;
        }
        return findCustomControl(effectiveCommand, currentDeviceId, ()=>true, effectiveInput);
    };
    const getPartialControlMacro = (command, currentDeviceId, additionalInputContent, isEligibleControl)=>{
        const cleanedCommand = cleanCommand(command);
        if (cleanedCommand.length === 0) return null;
        const isEligible = isEligibleControl !== null && isEligibleControl !== void 0 ? isEligibleControl : ()=>true;
        return findCustomControl(cleanedCommand, currentDeviceId, (control)=>!control.isPrefixVoiceCommand && !control.allowWhenDictating && isEligible(control), additionalInputContent);
    };
    const getAllCustomCommandsMap = ()=>{
        const map = new Map();
        const availableCustomControls = get().availableCustomControls;
        if (!availableCustomControls) return map;
        for (const deviceControls of availableCustomControls){
            if (deviceControls.controls) for (const control of deviceControls.controls){
                if (control.commands) for (const command of control.commands){
                    const key = deviceControls.deviceId + (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
                    map.set(key, {
                        id: control.id,
                        source: deviceControls.deviceId,
                        value: command.toLowerCase(),
                        name: control.name,
                        deviceName: deviceControls.name
                    });
                }
            }
        }
        return map;
    };
    const updateAppInterfaceControls = async (overrides)=>{
        var _availableCustomControls_find;
        const availableCustomControls = get().availableCustomControls;
        const allControls = (availableCustomControls === null || availableCustomControls === void 0 ? void 0 : (_availableCustomControls_find = availableCustomControls.find((d)=>d.deviceId === 'global')) === null || _availableCustomControls_find === void 0 ? void 0 : _availableCustomControls_find.controls) || [];
        const sendControls = allControls.map((c)=>{
            const override = overrides.find((o)=>o.appInterfaceControlId === c.id);
            return {
                appInterfaceControlId: c.id,
                commands: (override === null || override === void 0 ? void 0 : override.commands) || (c === null || c === void 0 ? void 0 : c.commands) || []
            };
        });
        try {
            const locale = get().customControlsLocale;
            const result = await $1a4c36336f303477$export$1ac6c99dd884ccad(sendControls, locale);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                get().updateLocalAppInterfaceControls(result.data);
                return result;
            }
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error updating app interface controls'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateLocalAppInterfaceControls = (appInterfaceControls)=>{
        if (!appInterfaceControls) return;
        const availableCustomControls = get().availableCustomControls;
        const deviceIndex = availableCustomControls === null || availableCustomControls === void 0 ? void 0 : availableCustomControls.findIndex((d)=>d.deviceId === 'global');
        if (deviceIndex == null) return;
        updateAvailableCustomControls(deviceIndex, appInterfaceControls.controls, 'global', 'global', 'Cephable');
    };
    const updateDeviceCustomControls = async (deviceId, overrides)=>{
        var _availableCustomControls_find;
        const availableCustomControls = get().availableCustomControls;
        if (!availableCustomControls) return;
        const allDeviceControls = (_availableCustomControls_find = availableCustomControls.find((d)=>d.deviceId === deviceId)) === null || _availableCustomControls_find === void 0 ? void 0 : _availableCustomControls_find.controls;
        if (!allDeviceControls) return;
        const sendControls = allDeviceControls.map((c)=>{
            const override = overrides.find((o)=>o.deviceTypeCustomControlId === c.id);
            return {
                deviceTypeCustomControlId: c.id,
                commands: (override === null || override === void 0 ? void 0 : override.commands) || (c === null || c === void 0 ? void 0 : c.commands) || []
            };
        });
        try {
            const locale = get().customControlsLocale;
            const result = await $1a4c36336f303477$export$b9a2c62bbb3b9917(deviceId, sendControls, locale);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                get().updateLocalDeviceCustomControls(result.data);
                return result;
            }
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error updating device custom controls'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const updateLocalDeviceCustomControls = (deviceCustomControls)=>{
        const deviceId = deviceCustomControls === null || deviceCustomControls === void 0 ? void 0 : deviceCustomControls.userDeviceId;
        if (!deviceId) return;
        const availableCustomControls = get().availableCustomControls;
        const deviceIndex = availableCustomControls === null || availableCustomControls === void 0 ? void 0 : availableCustomControls.findIndex((d)=>d.deviceId === deviceId);
        const deviceName = (0, $57ef534a0961ba07$export$2b13470419707314).getState().getDeviceName(deviceId);
        if (deviceIndex == null) return;
        updateAvailableCustomControls(deviceIndex, deviceCustomControls.controls, deviceId, deviceId, deviceName);
    };
    const updateCustomUserDeviceControls = async (deviceId, controlsToUpdate, locale)=>{
        if (!deviceId || !controlsToUpdate) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        if (controlsToUpdate.length === 0) return;
        try {
            await $1a4c36336f303477$export$acdb1997acaa39c3(deviceId, controlsToUpdate, locale);
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error updating device custom controls'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const clear = ()=>{
        setAvailableControlsState([], []);
        set((state)=>{
            state.voicePausedCustomControls = new Set();
            state.voicePrefixCustomControls = new Set();
        });
        handleVoiceDictationControlsUpdate(new Set());
        localStorage.removeItem('CUSTOM_CONTROLS');
    };
    const resetCustomControls = async (localePreferences)=>{
        const locale = localePreferences.defaultVoiceLocale;
        set((state)=>{
            state.customControlsLocale = locale;
        });
        const interfaceResult = await $1a4c36336f303477$export$1ac6c99dd884ccad([], locale);
        if ((interfaceResult === null || interfaceResult === void 0 ? void 0 : interfaceResult.resultType) === 'Ok' && interfaceResult.data) get().updateLocalAppInterfaceControls(interfaceResult.data);
        const devices = (0, $57ef534a0961ba07$export$2b13470419707314).getState().devices;
        if (devices) for (const device of devices){
            if (device.isVerified === false) continue;
            const result = await $1a4c36336f303477$export$b9a2c62bbb3b9917(device.id, [], locale);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                set((state)=>{
                    state.resetDeviceControls = true;
                });
                get().updateLocalDeviceCustomControls(result.data);
            }
        }
    };
    const removeDeviceControls = (deviceId)=>{
        var _state_availableCustomControls, _state_profileCustomControls;
        const state = get();
        const updatedAvailable = ((_state_availableCustomControls = state.availableCustomControls) === null || _state_availableCustomControls === void 0 ? void 0 : _state_availableCustomControls.filter((d)=>d.deviceId !== deviceId)) || null;
        const updatedProfile = ((_state_profileCustomControls = state.profileCustomControls) === null || _state_profileCustomControls === void 0 ? void 0 : _state_profileCustomControls.filter((d)=>d.deviceId !== deviceId)) || null;
        setAvailableControlsState(updatedAvailable, updatedProfile);
        resetVoiceCustomControls();
        snapshotState();
    };
    const addDeviceControls = async (device)=>{
        const locale = get().customControlsLocale;
        try {
            var _device_device;
            set((state)=>{
                state.isLoading = true;
            });
            const deviceType = (_device_device = device.device) === null || _device_device === void 0 ? void 0 : _device_device.deviceType;
            if (deviceType && device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) {
                const dtResult = await $1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceType.id, locale);
                if ((dtResult === null || dtResult === void 0 ? void 0 : dtResult.resultType) === 'Ok' && dtResult.data) device.customControls = dtResult.data.controls.map((c)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c), {
                        isDeviceTypeControl: true
                    }));
            }
            if (device.customControls.length === 0 && device.customDeviceTypeControlOverrides.length === 0) return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(true);
            const deviceId = device.id;
            const deviceName = (0, $57ef534a0961ba07$export$2b13470419707314).getState().getDeviceName(deviceId);
            const controls = (0, $2616fe0411c33582$export$82e40272e8bb746b)(device.customControls, device.customDeviceTypeControlOverrides);
            const newEntry = {
                deviceId: deviceId,
                deviceTypeId: deviceType.id,
                name: deviceName,
                isPrivate: deviceType === null || deviceType === void 0 ? void 0 : deviceType.isPrivate,
                controls: controls
            };
            const state = get();
            var _state_availableCustomControls;
            const currentAvailable = (_state_availableCustomControls = state.availableCustomControls) !== null && _state_availableCustomControls !== void 0 ? _state_availableCustomControls : [];
            var _state_profileCustomControls;
            const currentProfile = (_state_profileCustomControls = state.profileCustomControls) !== null && _state_profileCustomControls !== void 0 ? _state_profileCustomControls : [];
            const profileControls = controls.filter((c)=>c.isProfileControl);
            const newProfile = profileControls.length > 0 ? [
                ...currentProfile,
                (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, newEntry), {
                    controls: profileControls
                })
            ] : currentProfile;
            setAvailableControlsState([
                ...currentAvailable,
                newEntry
            ], newProfile);
            snapshotState();
            return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(true);
        } catch (error) {
            console.log(error);
            set((state)=>{
                state.errors = [
                    String(error)
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set((state)=>{
                state.isLoading = false;
            });
        }
    };
    return {
        // State
        availableCustomControls: null,
        currentDeviceControls: {
            global: undefined,
            device: undefined
        },
        customControlsLocale: (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec),
        errors: [],
        isLoading: false,
        profileCustomControls: null,
        resetDeviceControls: false,
        userLocale: (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec),
        voiceDictationCustomControls: new Set(),
        voicePausedCustomControls: new Set(),
        voicePrefixCustomControls: new Set(),
        setResetDeviceControls: // Actions
        setResetDeviceControls,
        setAvailableCustomControls: setAvailableCustomControls,
        snapshotState: snapshotState,
        resetVoiceCustomControls: resetVoiceCustomControls,
        initializeFromStorage: initializeFromStorage,
        initializeFromRemote: initializeFromRemote,
        getDeviceCustomControls: getDeviceCustomControls,
        getDeviceControlName: getDeviceControlName,
        getFinalControlMacro: getFinalControlMacro,
        getFinalDictationControlMacro: getFinalDictationControlMacro,
        getPartialControlMacro: getPartialControlMacro,
        getAllCustomCommandsMap: getAllCustomCommandsMap,
        updateAppInterfaceControls: updateAppInterfaceControls,
        updateLocalAppInterfaceControls: updateLocalAppInterfaceControls,
        updateDeviceCustomControls: updateDeviceCustomControls,
        updateLocalDeviceCustomControls: updateLocalDeviceCustomControls,
        updateCustomUserDeviceControls: updateCustomUserDeviceControls,
        clear: clear,
        resetCustomControls: resetCustomControls,
        removeDeviceControls: removeDeviceControls,
        addDeviceControls: addDeviceControls
    };
}));
// Module-level event subscriptions (replace useEffect([], []))
(0, $e7df95de73caec26$export$ec068583843480e7)('device-added', (data)=>{
    $b8d2d4cc121e033d$export$5c51a4b25a3f0496.getState().addDeviceControls(data.device);
});
(0, $e7df95de73caec26$export$ec068583843480e7)('remove-device', (data)=>{
    $b8d2d4cc121e033d$export$5c51a4b25a3f0496.getState().removeDeviceControls(data.device.id);
});
// Keep currentDeviceControls in sync when current device changes
(0, $43d630686eddb628$export$21b1c44aa0aad518).subscribe((state, prevState)=>{
    if (state.id !== prevState.id) {
        const available = $b8d2d4cc121e033d$export$5c51a4b25a3f0496.getState().availableCustomControls;
        const deviceControls = $b8d2d4cc121e033d$var$computeCurrentDeviceControls(available, state.id);
        $b8d2d4cc121e033d$export$5c51a4b25a3f0496.setState({
            currentDeviceControls: deviceControls
        });
    }
});


function $31424fe514516834$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function getGlobalEditProfileConflicts(macros, dictationCommands, keyCommands, profileId) {
        var _useCurrentUserStore_getState_currentUser_userPreferences, _useCurrentUserStore_getState_currentUser;
        const deviceIntersectionMap = new Map([]);
        const globalIntersections = [];
        let deviceCommandConflictDisplay = [];
        let globalCommandConflictDisplay = [];
        const editProfileCommandsMap = new Map();
        if ((_useCurrentUserStore_getState_currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().currentUser) === null || _useCurrentUserStore_getState_currentUser === void 0 ? void 0 : (_useCurrentUserStore_getState_currentUser_userPreferences = _useCurrentUserStore_getState_currentUser.userPreferences) === null || _useCurrentUserStore_getState_currentUser_userPreferences === void 0 ? void 0 : _useCurrentUserStore_getState_currentUser_userPreferences.isWarningConflictIndicatorsOptOut) return {
            globalCommandConflictDisplay: globalCommandConflictDisplay,
            deviceCommandConflictDisplay: deviceCommandConflictDisplay
        };
        const addCommandsToMap = (commandsMap, commands, macroOrKeyId, macroOrKeyName, pageLink)=>{
            for (const command of commands){
                const normalizedCommand = command.command.trim().toLowerCase();
                if (!normalizedCommand) continue;
                if (!commandsMap.has(normalizedCommand)) commandsMap.set(normalizedCommand, []);
                commandsMap.get(normalizedCommand).push({
                    macroOrKeyName: macroOrKeyName ? macroOrKeyName : t('common:noName'),
                    commandDisplayName: command === null || command === void 0 ? void 0 : command.command,
                    macroOrKeyId: macroOrKeyId,
                    pageLink: pageLink
                });
            }
        };
        if (macros) for (const macro of macros)addCommandsToMap(editProfileCommandsMap, macro.commands, macro.id, macro.name ? macro.name : t('common:noName'), `/profiles/edit/${profileId}`);
        if (keyCommands) for (const keyCommand of keyCommands)addCommandsToMap(editProfileCommandsMap, keyCommand.commands, keyCommand.key, `${t('common:keys.title')}: ${keyCommand.displayName}`, `/profiles/edit/${profileId}/advanced/keybindings`);
        if (dictationCommands) addCommandsToMap(editProfileCommandsMap, dictationCommands.map((command)=>({
                command: command,
                commandType: 'dictationCommand'
            })), 'dictation', t('common:dictation.title'), `/profiles/edit/${profileId}/advanced/dictation`);
        const customCommandsMap = (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496).getState().getAllCustomCommandsMap();
        // Iterate through custom commands and check for intersections
        for (const [customValue, customDetails] of customCommandsMap){
            const normalizedCustomValue = customDetails.value.trim().toLowerCase();
            if (editProfileCommandsMap.has(normalizedCustomValue)) {
                const profileDetailsArray = editProfileCommandsMap.get(normalizedCustomValue);
                if (!profileDetailsArray) continue;
                for (const profileDetails of profileDetailsArray)if (customDetails.source === 'global') globalIntersections.push({
                    key: (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)(),
                    scrollID: profileDetails.macroOrKeyId,
                    displayString: `"${normalizedCustomValue}" ${t('common:customControls.conflictIndicators.usedInput')} ${customDetails.deviceName}: ${customDetails.name} & ${profileDetails.macroOrKeyName}`,
                    pageLink: profileDetails.pageLink
                });
                else {
                    if (!deviceIntersectionMap.has(customDetails.source)) deviceIntersectionMap.set(customDetails.source, []);
                    deviceIntersectionMap.get(customDetails.source).push({
                        key: (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)(),
                        scrollID: profileDetails.macroOrKeyId,
                        displayString: `"${normalizedCustomValue}" ${t('common:customControls.conflictIndicators.usedInput')} ${customDetails.deviceName}: ${customDetails.name} & ${profileDetails.macroOrKeyName} `,
                        pageLink: profileDetails.pageLink
                    });
                }
            }
        }
        deviceCommandConflictDisplay = [
            ...deviceIntersectionMap.values()
        ].flat();
        globalCommandConflictDisplay = globalIntersections;
        return {
            deviceCommandConflictDisplay: deviceCommandConflictDisplay,
            globalCommandConflictDisplay: globalCommandConflictDisplay
        };
    }
    return getGlobalEditProfileConflicts;
}






class $e46dfbc23b659948$export$2e2bcd8739ae039 {
    static getDescendantProperty(object, path, list = []) {
        let firstSegment;
        let remaining;
        let dotIndex;
        let value;
        let index;
        let length;
        if (path) {
            dotIndex = path.indexOf('.');
            if (dotIndex === -1) firstSegment = path;
            else {
                firstSegment = path.slice(0, dotIndex);
                remaining = path.slice(dotIndex + 1);
            }
            value = object[firstSegment];
            if (value !== null && typeof value !== 'undefined') {
                if (!remaining && (typeof value === 'string' || typeof value === 'number')) list.push(value);
                else if (Object.prototype.toString.call(value) === '[object Array]') for(index = 0, length = value.length; index < length; index++)$e46dfbc23b659948$export$2e2bcd8739ae039.getDescendantProperty(value[index], remaining, list);
                else if (remaining) $e46dfbc23b659948$export$2e2bcd8739ae039.getDescendantProperty(value, remaining, list);
            }
        } else list.push(object);
        return list;
    }
}


class $666c2eeb26cf6d23$export$2e2bcd8739ae039 {
    search(query = '') {
        if (query === '') return this.haystack;
        const results = [];
        for(let i = 0; i < this.haystack.length; i++){
            const item = this.haystack[i];
            if (this.keys.length === 0) {
                const score = $666c2eeb26cf6d23$export$2e2bcd8739ae039.isMatch(item, query, this.options.caseSensitive);
                if (score) results.push({
                    item: item,
                    score: score
                });
            } else for(let y = 0; y < this.keys.length; y++){
                const propertyValues = (0, $e46dfbc23b659948$export$2e2bcd8739ae039).getDescendantProperty(item, this.keys[y]);
                let found = false;
                for(let z = 0; z < propertyValues.length; z++){
                    const score = $666c2eeb26cf6d23$export$2e2bcd8739ae039.isMatch(propertyValues[z], query, this.options.caseSensitive);
                    if (score) {
                        found = true;
                        results.push({
                            item: item,
                            score: score
                        });
                        break;
                    }
                }
                if (found) break;
            }
        }
        if (this.options.sort) results.sort((a, b)=>a.score - b.score);
        return results.map((result)=>result.item);
    }
    static isMatch(item, query, caseSensitive) {
        item = String(item);
        query = String(query);
        if (!caseSensitive) {
            item = item.toLocaleLowerCase();
            query = query.toLocaleLowerCase();
        }
        const indexes = $666c2eeb26cf6d23$export$2e2bcd8739ae039.nearestIndexesFor(item, query);
        if (!indexes) return false;
        // Exact matches should be first.
        if (item === query) return 1;
        // If we have more than 2 letters, matches close to each other should be first.
        if (indexes.length > 1) return 2 + (indexes[indexes.length - 1] - indexes[0]);
        // Matches closest to the start of the string should be first.
        return 2 + indexes[0];
    }
    static nearestIndexesFor(item, query) {
        const letters = query.split('');
        let indexes = [];
        const indexesOfFirstLetter = $666c2eeb26cf6d23$export$2e2bcd8739ae039.indexesOfFirstLetter(item, query);
        indexesOfFirstLetter.forEach((startingIndex, loopingIndex)=>{
            let index = startingIndex + 1;
            indexes[loopingIndex] = [
                startingIndex
            ];
            for(let i = 1; i < letters.length; i++){
                const letter = letters[i];
                index = item.indexOf(letter, index);
                if (index === -1) {
                    indexes[loopingIndex] = false;
                    break;
                }
                indexes[loopingIndex].push(index);
                index++;
            }
        });
        indexes = indexes.filter((letterIndexes)=>letterIndexes !== false);
        if (!indexes.length) return false;
        return indexes.sort((a, b)=>{
            if (a.length === 1) return a[0] - b[0];
            a = a[a.length - 1] - a[0];
            b = b[b.length - 1] - b[0];
            return a - b;
        })[0];
    }
    static indexesOfFirstLetter(item, query) {
        const match = query[0];
        return item.split('').map((letter, index)=>{
            if (letter !== match) return false;
            return index;
        }).filter((index)=>index !== false);
    }
    constructor(haystack = [], keys = [], options = {}){
        if (!Array.isArray(keys)) {
            options = keys;
            keys = [];
        }
        this.haystack = haystack;
        this.keys = keys;
        this.options = Object.assign({
            caseSensitive: false,
            sort: false
        }, options);
    }
}



var $gSkQi = parcelRequire("gSkQi");



const $60065a32b4a31650$var$getSortedProfiles = (newProfiles)=>newProfiles.slice().sort((a, b)=>a.name.localeCompare(b.name));
const $60065a32b4a31650$var$getAssociationsFromProfiles = (localProfiles)=>{
    const associations = {};
    const sortedProfiles = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(localProfiles);
    sortedProfiles.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(a.modifiedDate) > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(b.modifiedDate) ? -1 : 1);
    sortedProfiles.forEach((profile)=>{
        var _profile_configuration_associatedPrograms;
        (_profile_configuration_associatedPrograms = profile.configuration.associatedPrograms) === null || _profile_configuration_associatedPrograms === void 0 ? void 0 : _profile_configuration_associatedPrograms.forEach((appName)=>{
            const cleansedAppName = appName.trim().toLowerCase();
            if (cleansedAppName === '') return;
            if (!(cleansedAppName in associations)) associations[cleansedAppName] = [];
            if (profile.id) associations[cleansedAppName].push({
                id: profile.id,
                name: profile.name,
                isPublic: profile.isPublic,
                platform: profile.platform
            });
        });
    });
    return associations;
};
const $60065a32b4a31650$export$8689cd9d602d0ad = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const setLocalProfiles = (newProfiles, ignoreLocalStorage = false)=>{
        const sortedProfiles = $60065a32b4a31650$var$getSortedProfiles(newProfiles);
        set((state)=>{
            state.profiles = sortedProfiles;
        });
        if (!ignoreLocalStorage) localStorage.setItem('DEVICE_PROFILES', JSON.stringify(sortedProfiles));
        // Replaces the useEffect([profiles]) that combined custom + public profiles
        const { allProfiles: allProfiles } = get();
        const publicProfiles = allProfiles.filter((p)=>p.isPublic);
        updateCombinedProfiles([
            ...sortedProfiles,
            ...publicProfiles
        ]);
    };
    const updateCombinedProfiles = (localProfiles)=>{
        const { allProfiles: allProfiles } = get();
        const hasNewModifications = ()=>{
            if (allProfiles.length === 0) return true;
            if (allProfiles.length !== localProfiles.length) return true;
            return localProfiles.some((localProfile)=>{
                const existingProfile = allProfiles.find((p)=>p.id === localProfile.id);
                if (!existingProfile) return true;
                return !(0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isEqual(existingProfile.configuration, localProfile.configuration) || existingProfile.name !== localProfile.name || existingProfile.description !== localProfile.description;
            });
        };
        if (hasNewModifications()) {
            set((state)=>{
                state.lastModifiedDate = new Date();
                state.allProfiles = localProfiles;
            });
            const associations = $60065a32b4a31650$var$getAssociationsFromProfiles(localProfiles);
            const appNames = Object.keys(associations);
            set((state)=>{
                state.associatedProgramsList = associations;
                state.associatedProgramsAppNames = appNames;
            });
        }
    };
    const isPlatformCompatible = (devicePlatform, profilePlatform = 'generic')=>{
        const normalizedDevicePlatform = devicePlatform === null || devicePlatform === void 0 ? void 0 : devicePlatform.toLowerCase();
        if (!devicePlatform || normalizedDevicePlatform === 'generic') return true;
        const normalizedProfilePlatform = profilePlatform.toLowerCase();
        return normalizedDevicePlatform === normalizedProfilePlatform || normalizedProfilePlatform === 'generic';
    };
    const getIndicatorName = (name, isPublic)=>!isPublic ? (0, $4817740e8b777c73$export$2e2bcd8739ae039).t('common:profile.custom', {
            name: name
        }) : name;
    const setOrganizationProfiles = (profiles)=>set((state)=>{
            state.organizationProfiles = profiles;
        });
    const initializeFromStorage = ()=>{
        try {
            const localProfiles = localStorage.getItem('DEVICE_PROFILES');
            if (localProfiles) setLocalProfiles(JSON.parse(localProfiles), true);
        } catch (e) {
            console.log(e);
        }
    };
    const getProfiles = async ()=>{
        try {
            set((state)=>{
                state.isLoading = true;
            });
            const result = await $1a4c36336f303477$export$3620b5cb1c7d18ec();
            set((state)=>{
                state.isLoading = false;
            });
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) setLocalProfiles(result.data);
            return result;
        } catch (e) {
            set((state)=>{
                state.isLoading = false;
                state.errors = [
                    'Error getting profiles'
                ];
            });
            console.log(e);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const deleteProfile = async (profileId, isHidden)=>{
        try {
            const result = await $1a4c36336f303477$export$29d101fdcde3d3d3(profileId);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                const currentProfiles = get().profiles;
                const newProfiles = currentProfiles.filter((x)=>x.id !== profileId);
                const profile = currentProfiles.find((x)=>x.id === profileId);
                (0, $e7df95de73caec26$export$89b472e03be495df)('profileDeleted', {
                    profile: profile
                });
                setLocalProfiles(newProfiles);
                if (!isHidden) (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                    message: (0, $4817740e8b777c73$export$2e2bcd8739ae039).t('common:profile.success.delete'),
                    timeout: 5000
                });
            }
            return result;
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error deleting profile'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const addProfile = (profile)=>{
        const currentProfiles = get().profiles;
        if (currentProfiles.find((x)=>x.id === profile.id)) get().updateProfile(profile);
        else setLocalProfiles([
            ...currentProfiles,
            profile
        ]);
    };
    const updateProfile = (profile)=>{
        const currentProfiles = get().profiles;
        const existingProfile = currentProfiles.find((x)=>x.id === profile.id);
        if (existingProfile && (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isEqual(existingProfile, profile)) return;
        const newProfiles = currentProfiles.map((x)=>x.id === profile.id ? profile : x);
        setLocalProfiles(newProfiles);
    };
    const removeLocalProfile = (profileId)=>{
        const newProfiles = get().profiles.filter((x)=>x.id !== profileId);
        setLocalProfiles(newProfiles);
    };
    const createShareLink = async (profileId, isSingleUse, expirationDate)=>{
        if (!profileId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            const result = await $1a4c36336f303477$export$6dcf149406a53b24(profileId, {
                expirationDate: expirationDate === null || expirationDate === void 0 ? void 0 : expirationDate.toISOString(),
                isSingleUse: isSingleUse,
                isPublic: true
            });
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: (0, $4817740e8b777c73$export$2e2bcd8739ae039).t('common:profile.success.share'),
                timeout: 5000
            });
            return result;
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error creating share link'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getShares = async (profileId)=>{
        if (!profileId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            return await $1a4c36336f303477$export$c7b3bc714f32d7a9(profileId);
        } catch (e) {
            set((state)=>{
                state.errors = [
                    'Error getting shares'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const deleteShare = async (shareId)=>{
        try {
            const result = await $1a4c36336f303477$export$80c41221f92ef9be(shareId);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: (0, $4817740e8b777c73$export$2e2bcd8739ae039).t('common:profile.success.shareDelete'),
                timeout: 5000
            });
            return result;
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error deleting share link'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const generateProfile = async (request)=>{
        try {
            const result = await $1a4c36336f303477$export$8fe3f057eebad1bc(request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: (0, $4817740e8b777c73$export$2e2bcd8739ae039).t('common:profile.success.generate'),
                timeout: 5000
            });
            return result;
        } catch (e) {
            console.log(e);
            set((state)=>{
                state.errors = [
                    'Error generating profile'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const clearProfiles = ()=>{
        set((state)=>{
            state.profiles = [];
            state.allProfiles = [];
        });
        localStorage.removeItem('DEVICE_PROFILES');
    };
    const fuzzySearchProfiles = (search)=>{
        const searcher = new (0, $666c2eeb26cf6d23$export$2e2bcd8739ae039)(get().allProfiles, [
            'name',
            'description',
            'configuration.associatedPrograms'
        ], {
            sort: true,
            caseSensitive: false
        });
        return searcher.search(search);
    };
    const isPlatformSupportedProfile = (profile, os)=>{
        if (!profile) return false;
        return !profile.platform || profile.platform === os || profile.platform === 'generic';
    };
    const filterProfiles = (search, platform, userVoiceLocale, selectedInterest)=>{
        const normalizedFilter = search.toLowerCase().trim();
        const normalizedInterest = selectedInterest === null || selectedInterest === void 0 ? void 0 : selectedInterest.toLowerCase().trim();
        const { allProfiles: allProfiles } = get();
        return allProfiles.filter((profile)=>{
            var _profile_description, _profile_configuration_associatedPrograms, _originated_description, _originated_configuration_associatedPrograms;
            if (!profile || !isPlatformCompatible(platform, profile.platform)) return false;
            if (profile.deviceProfileGroupId && profile.defaultLocale !== userVoiceLocale && !profile.isDefaultInGroup) return false;
            if (profile.deviceProfileGroupId && profile.isDefaultInGroup && profile.defaultLocale !== userVoiceLocale) {
                var _profile_deviceProfileGroup;
                const hasCurrentLocale = (_profile_deviceProfileGroup = profile.deviceProfileGroup) === null || _profile_deviceProfileGroup === void 0 ? void 0 : _profile_deviceProfileGroup.some((m)=>m.locale === userVoiceLocale);
                if (hasCurrentLocale) return false;
            }
            const fields = [
                getIndicatorName(profile.name, profile.isPublic).toLowerCase(),
                ((_profile_description = profile.description) === null || _profile_description === void 0 ? void 0 : _profile_description.toLowerCase()) || '',
                ...((_profile_configuration_associatedPrograms = profile.configuration.associatedPrograms) === null || _profile_configuration_associatedPrograms === void 0 ? void 0 : _profile_configuration_associatedPrograms.map((p)=>p.toLowerCase())) || []
            ];
            const originated = allProfiles.find((p)=>p.id === profile.originatedByProfileId);
            if (originated) fields.push(getIndicatorName(originated.name, originated.isPublic).toLowerCase(), ((_originated_description = originated.description) === null || _originated_description === void 0 ? void 0 : _originated_description.toLowerCase()) || '', ...((_originated_configuration_associatedPrograms = originated.configuration.associatedPrograms) === null || _originated_configuration_associatedPrograms === void 0 ? void 0 : _originated_configuration_associatedPrograms.map((p)=>p.toLowerCase())) || []);
            const matchesFilter = fields.some((field)=>field.includes(normalizedFilter));
            const matchesInterest = !normalizedInterest || profile.interests.map((i)=>i.toLowerCase()).includes(normalizedInterest);
            return matchesFilter && matchesInterest;
        });
    };
    return {
        // State
        profiles: [],
        allProfiles: [],
        organizationProfiles: [],
        isLoading: false,
        errors: [],
        // Associated programs data
        associatedProgramsList: {},
        associatedProgramsAppNames: [],
        lastModifiedDate: null,
        addProfile: // Actions
        addProfile,
        clearProfiles: clearProfiles,
        createShareLink: createShareLink,
        deleteProfile: deleteProfile,
        deleteShare: deleteShare,
        filterProfiles: filterProfiles,
        fuzzySearchProfiles: fuzzySearchProfiles,
        generateProfile: generateProfile,
        getIndicatorName: getIndicatorName,
        getProfiles: getProfiles,
        getShares: getShares,
        initializeFromStorage: initializeFromStorage,
        isPlatformSupportedProfile: isPlatformSupportedProfile,
        removeLocalProfile: removeLocalProfile,
        setOrganizationProfiles: setOrganizationProfiles,
        updateProfile: updateProfile
    };
}));
// Module-level event subscriptions (replace useEffect([], []))
(0, $e7df95de73caec26$export$ec068583843480e7)('default-profiles-updated', (data)=>{
    const store = $60065a32b4a31650$export$8689cd9d602d0ad.getState();
    const combined = [
        ...store.profiles,
        ...data
    ];
    const associations = $60065a32b4a31650$var$getAssociationsFromProfiles(combined);
    const appNames = Object.keys(associations);
    $60065a32b4a31650$export$8689cd9d602d0ad.setState((state)=>{
        state.allProfiles = combined;
        state.associatedProgramsList = associations;
        state.associatedProgramsAppNames = appNames;
    });
});
(0, $e7df95de73caec26$export$ec068583843480e7)('userProfileAdded', (data)=>{
    $60065a32b4a31650$export$8689cd9d602d0ad.getState().addProfile(data.profile);
});
(0, $e7df95de73caec26$export$ec068583843480e7)('userProfileUpdated', (data)=>{
    $60065a32b4a31650$export$8689cd9d602d0ad.getState().updateProfile(data.profile);
});
(0, $e7df95de73caec26$export$ec068583843480e7)('userProfileDeleted', (data)=>{
    $60065a32b4a31650$export$8689cd9d602d0ad.getState().deleteProfile(data.profileId, true);
});


var $3a3153321729209f$exports = {};
// shim for using process in browser
var $3a3153321729209f$var$process = $3a3153321729209f$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = 'browser';
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ''; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3a3153321729209f$var$process.cwd = function() {
    return '/';
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};


let $697752726c88b03c$var$globalConflictsGetter = null;
const $697752726c88b03c$export$9ebe82a12f9194e3 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const t = (0, $4817740e8b777c73$export$2e2bcd8739ae039).t.bind((0, $4817740e8b777c73$export$2e2bcd8739ae039));
    // ---- Helpers ----
    const addNewProfileConflictModel = (title, items, conflictList, subtitle)=>{
        if (items.length > 0) conflictList.push({
            title: title,
            items: items,
            subtitle: subtitle
        });
    };
    const getEditProfilePath = ()=>{
        const orgId = get().organizationId;
        if (orgId && get().id) return `/org/${orgId}/profiles/edit/${get().id}`;
        if (orgId && !get().id) return ``;
        return `/profiles/edit/${get().id}`;
    };
    const isDuplicateName = (inputName)=>{
        var _duplicateNames_;
        const benchmarkName = inputName !== null && inputName !== void 0 ? inputName : get().name;
        const duplicateNames = getDuplicateProfiles(benchmarkName);
        if (((_duplicateNames_ = duplicateNames[0]) === null || _duplicateNames_ === void 0 ? void 0 : _duplicateNames_.id) === get().id) return false;
        return duplicateNames.length > 0;
    };
    const getDuplicateProfiles = (inputName)=>{
        return (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().profiles.filter((p)=>p.name === inputName);
    };
    const getPublicProfileNameIfDuplicate = (inputName)=>{
        const defaultName = inputName !== null && inputName !== void 0 ? inputName : get().name;
        const exactDuplicates = getDuplicateProfiles(defaultName);
        if (exactDuplicates.length > 0) {
            const existingDuplicates = (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().profiles.filter((p)=>p.name.startsWith(`${defaultName} #`));
            if (existingDuplicates.length > 0) {
                const lastProfileNumber = Math.max(...existingDuplicates.map((p)=>{
                    const lastChar = p.name.at(-1);
                    return lastChar ? parseInt(lastChar) : NaN;
                }));
                return `${defaultName} #${lastProfileNumber + 1}`;
            }
            return `${defaultName} #1`;
        }
        return defaultName;
    };
    const getProfileConfigFromState = ()=>{
        const state = get();
        return {
            commandKeyMappings: (0, $9d76aba0a210d2c6$export$d1b24cb1984823a4)(state.commandKeyMappings),
            macros: state.macros.map((m)=>{
                var _m_id;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                    id: (_m_id = m.id) !== null && _m_id !== void 0 ? _m_id : (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
                    commands: m.commands.map((c)=>c.command)
                });
            }),
            hotkeys: state.hotkeys,
            audioEvents: state.audioEvents.map((a)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a), {
                    commands: a.commands.map((c)=>c.command)
                })),
            dictationCommands: state.dictationCommands,
            suggestedGeneratePrompts: state.suggestedGeneratePrompts,
            suggestedRewritePrompts: state.suggestedRewritePrompts,
            associatedPrograms: state.associatedPrograms,
            profileType: 'Default'
        };
    };
    const validateProfileName = (conflictErrors)=>{
        let title = '';
        let desc = '';
        let validName = true;
        const name = get().name;
        if (name === '') {
            title = t('common:profile.conflictIndicators.emptyNameTitle');
            desc = t('common:profile.conflictIndicators.emptyNameDescription');
            validName = false;
        } else if (isDuplicateName()) {
            title = t('common:profile.conflictIndicators.duplicateNameTitle');
            desc = t('common:profile.conflictIndicators.duplicateNameDescription');
            validName = false;
        }
        if (!validName) addNewProfileConflictModel(t('common:profile.conflictIndicators.profileNameErrors'), [
            {
                displayString: title,
                key: 'ProfileNameConflict',
                scrollID: (0, $14e4f1609944ac39$export$a9a172bf96c7a4ed),
                pageLink: getEditProfilePath()
            }
        ], conflictErrors, desc);
    };
    const validateProfileItems = (conflictErrors)=>{
        const s = get();
        addNewProfileConflictModel(t('common:profile.conflictIndicators.emptyControlsMapped'), (0, $9d76aba0a210d2c6$export$1d55b5fa728affd1)({
            macros: s.macros,
            profileId: s.id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.emptyControlsMappedDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateInputCommandMacroTitle'), (0, $9d76aba0a210d2c6$export$639d475f7be72f7d)({
            macros: s.macros,
            profileId: s.id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.duplicateCommandsDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.macrosReleaseKeysMissingTitle'), (0, $9d76aba0a210d2c6$export$b59cab01f4e26d1b)({
            macros: s.macros,
            profileId: s.id,
            defaultLocale: s.defaultLocale,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.macrosReleaseKeysMissingDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.macrosVoiceCommandConflictWithDictationTitle'), (0, $9d76aba0a210d2c6$export$ec2c4b4373af4b61)({
            macros: s.macros,
            dictationCommands: s.dictationCommands,
            profileId: s.id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.macrosVoiceCommandConflictWithDictationDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.emptyKeybindingControlsMapped'), (0, $9d76aba0a210d2c6$export$134d4256d4cafcf4)({
            commandKeyMappings: s.commandKeyMappings,
            profileId: s.id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.emptyKeybindingControlsMappedDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateInputCommandBindingsTitle'), (0, $9d76aba0a210d2c6$export$eb3146089825fa9d)({
            commandKeyMappings: s.commandKeyMappings,
            profileId: s.id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.duplicateCommandsDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.keybindingsVoiceCommandConflictWithDictationTitle'), (0, $9d76aba0a210d2c6$export$845f2f159de600e0)({
            commandKeyMappings: s.commandKeyMappings,
            dictationCommands: s.dictationCommands,
            profileId: s.id,
            t: t
        }), conflictErrors, t('common:profile.conflictIndicators.keybindingsVoiceCommandConflictWithDictationDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateAssociatedProgramNames'), (0, $9d76aba0a210d2c6$export$4a2e027df0dfc855)({
            associatedPrograms: s.associatedPrograms,
            profileId: s.id
        }), conflictErrors, t('common:profile.conflictIndicators.duplicateAssociatedProgramsDescription'));
    };
    const detectConflictWarnings = (conflictWarnings)=>{
        const s = get();
        if (!s.id) return;
        if ($697752726c88b03c$var$globalConflictsGetter) {
            const { deviceCommandConflictDisplay: deviceCommandConflictDisplay, globalCommandConflictDisplay: globalCommandConflictDisplay } = $697752726c88b03c$var$globalConflictsGetter(s.macros, s.dictationCommands, s.commandKeyMappings, s.id);
            if ((globalCommandConflictDisplay === null || globalCommandConflictDisplay === void 0 ? void 0 : globalCommandConflictDisplay.length) > 0) addNewProfileConflictModel(t('common:customControls.conflictIndicators.globalControls'), globalCommandConflictDisplay, conflictWarnings, t('common:customControls.conflictIndicators.description'));
            if ((deviceCommandConflictDisplay === null || deviceCommandConflictDisplay === void 0 ? void 0 : deviceCommandConflictDisplay.length) > 0) addNewProfileConflictModel(t('common:customControls.conflictIndicators.deviceControls'), deviceCommandConflictDisplay, conflictWarnings, t('common:customControls.conflictIndicators.description'));
        }
        addNewProfileConflictModel(t('common:profile.conflictIndicators.duplicateMacroNames'), (0, $9d76aba0a210d2c6$export$7b817b6bf4f2cb70)({
            macros: s.macros,
            profileId: s.id,
            t: t
        }), conflictWarnings, t('common:profile.conflictIndicators.duplicateMacroNamesDescription'));
        addNewProfileConflictModel(t('common:profile.conflictIndicators.emptyEvent.title'), (0, $9d76aba0a210d2c6$export$a634520ef9a79c74)({
            macros: s.macros,
            profileId: s.id,
            t: t
        }), conflictWarnings, t('common:profile.conflictIndicators.emptyEvent.description'));
        set((state)=>{
            state.profileConflictWarnings = conflictWarnings;
        });
    };
    const isValidProfile = ()=>{
        const conflictErrors = [];
        validateProfileName(conflictErrors);
        validateProfileItems(conflictErrors);
        set((state)=>{
            state.profileConflictErrors = conflictErrors;
        });
        const audioEventsWithEmptyCommands = get().audioEvents.filter((a)=>a.commands.some((c)=>!c.command));
        if (audioEventsWithEmptyCommands.length > 0) {
            (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
                message: t('common:profile.error.audioEventsWithEmptyCommands'),
                timeout: 5000
            });
            return false;
        }
        if (conflictErrors.length > 0) (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.conflicts'),
            timeout: 5000
        });
        return conflictErrors.length === 0;
    };
    const getProfileCreateUpdateModel = ()=>{
        var _s_originalProfile, _s_originalProfile1, _s_originalProfile2, _s_originalProfile3, _s_originalProfile4, _s_originalProfile5;
        const s = get();
        var _s_description, _s_originalProfile_requiresEmployeeAccess, _s_originalProfile_requiresStudentAccess, _s_originalProfile_requiresGenericLicense, _s_originalProfile_requiresPlusAccess, _s_originalProfile_platform, _s_originalProfile_interests, _s_organizationId;
        return {
            name: s.name,
            description: (_s_description = s.description) !== null && _s_description !== void 0 ? _s_description : '',
            profileType: 'Default',
            configuration: getProfileConfigFromState(),
            defaultLocale: s.defaultLocale,
            originatedByProfileId: s.originatedByProfileId,
            requiresEmployeeAccess: (_s_originalProfile_requiresEmployeeAccess = (_s_originalProfile = s.originalProfile) === null || _s_originalProfile === void 0 ? void 0 : _s_originalProfile.requiresEmployeeAccess) !== null && _s_originalProfile_requiresEmployeeAccess !== void 0 ? _s_originalProfile_requiresEmployeeAccess : false,
            requiresStudentAccess: (_s_originalProfile_requiresStudentAccess = (_s_originalProfile1 = s.originalProfile) === null || _s_originalProfile1 === void 0 ? void 0 : _s_originalProfile1.requiresStudentAccess) !== null && _s_originalProfile_requiresStudentAccess !== void 0 ? _s_originalProfile_requiresStudentAccess : false,
            requiresGenericLicense: (_s_originalProfile_requiresGenericLicense = (_s_originalProfile2 = s.originalProfile) === null || _s_originalProfile2 === void 0 ? void 0 : _s_originalProfile2.requiresGenericLicense) !== null && _s_originalProfile_requiresGenericLicense !== void 0 ? _s_originalProfile_requiresGenericLicense : false,
            requiresPlusAccess: (_s_originalProfile_requiresPlusAccess = (_s_originalProfile3 = s.originalProfile) === null || _s_originalProfile3 === void 0 ? void 0 : _s_originalProfile3.requiresPlusAccess) !== null && _s_originalProfile_requiresPlusAccess !== void 0 ? _s_originalProfile_requiresPlusAccess : false,
            platform: (_s_originalProfile_platform = (_s_originalProfile4 = s.originalProfile) === null || _s_originalProfile4 === void 0 ? void 0 : _s_originalProfile4.platform) !== null && _s_originalProfile_platform !== void 0 ? _s_originalProfile_platform : 'generic',
            interests: (_s_originalProfile_interests = (_s_originalProfile5 = s.originalProfile) === null || _s_originalProfile5 === void 0 ? void 0 : _s_originalProfile5.interests) !== null && _s_originalProfile_interests !== void 0 ? _s_originalProfile_interests : [],
            organizationId: (_s_organizationId = s.organizationId) !== null && _s_organizationId !== void 0 ? _s_organizationId : undefined
        };
    };
    const saveChanges = async ()=>{
        if (!isValidProfile()) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        const conflictWarnings = [];
        detectConflictWarnings(conflictWarnings);
        const profileCreateUpdateModel = getProfileCreateUpdateModel();
        const s = get();
        const result = s.id ? await $1a4c36336f303477$export$5880729c5d131040(s.id, profileCreateUpdateModel) : await $1a4c36336f303477$export$6660b028f5be10a7(profileCreateUpdateModel);
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
            set((state)=>{
                state.hasChanges = false;
            });
            if (conflictWarnings.length > 0) {
                (0, $e7df95de73caec26$export$89b472e03be495df)('alertWarning', {
                    message: t('common:profile.warning'),
                    timeout: 5000
                });
                result.resultType = 'OkWithWarnings';
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.save'),
                timeout: 5000
            });
            if (!s.id) {
                (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileAdded', {
                    profile: result.data
                });
                set((state)=>{
                    state.id = result.data.id;
                });
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileUpdated', {
                profile: result.data
            });
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.save'),
            timeout: 5000
        });
        return result;
    };
    const setFilter = (filter)=>set((state)=>{
            state.filter = filter;
        });
    const setHasChanges = (hasChanges)=>set((state)=>{
            state.hasChanges = hasChanges;
        });
    const setId = (id)=>set((state)=>{
            state.id = id;
        });
    const setIsDeprecatedHotkey = (v)=>set((state)=>{
            state.isDeprecatedHotkey = v;
        });
    const setIsDefaultBindingsIncluded = (v)=>set((state)=>{
            state.isDefaultBindingsIncluded = v;
        });
    const setIsPreview = (v)=>set((state)=>{
            state.isPreview = v;
        });
    const setIsConflictsAcknowledged = (v)=>set((state)=>{
            state.isProfileConflictsAcknowledged = v;
        });
    const setAvailableCustomControls = (controls)=>set((state)=>{
            state.availableCustomControls = controls;
        });
    const setOrganizationId = (id)=>set((state)=>{
            state.organizationId = id;
        });
    const updateAssociatedPrograms = (programs)=>set((state)=>{
            state.associatedPrograms = programs;
        });
    const updateAudioEvents = (events)=>set((state)=>{
            state.audioEvents = events;
        });
    const updateCommandKeyMappings = (keybindings)=>set((state)=>{
            state.commandKeyMappings = keybindings;
        });
    const resetKeybindingsToDefault = ()=>{
        const { originalProfile: originalProfile, defaultLocale: defaultLocale } = get();
        const defaultKeyBindings = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(defaultLocale, originalProfile === null || originalProfile === void 0 ? void 0 : originalProfile.platform);
        set((state)=>{
            state.commandKeyMappings = defaultKeyBindings;
            state.hasChanges = true;
        });
    };
    const resetKeybindingsToEmpty = ()=>{
        const { originalProfile: originalProfile, defaultLocale: defaultLocale } = get();
        const defaultKeyBindings = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(defaultLocale, originalProfile === null || originalProfile === void 0 ? void 0 : originalProfile.platform);
        const emptyKeyBindings = defaultKeyBindings.map((k)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
                commands: []
            }));
        set((state)=>{
            state.commandKeyMappings = emptyKeyBindings;
            state.hasChanges = true;
        });
    };
    const updateDictationCommands = (commands)=>set((state)=>{
            state.dictationCommands = commands;
        });
    const updateSuggestedGeneratePrompts = (prompts)=>set((state)=>{
            state.suggestedGeneratePrompts = prompts;
        });
    const updateSuggestedRewritePrompts = (prompts)=>set((state)=>{
            state.suggestedRewritePrompts = prompts;
        });
    const updateHotkeys = (hotkeys)=>set((state)=>{
            state.hotkeys = hotkeys;
        });
    const updateMacros = (macros)=>set((state)=>{
            state.macros = macros;
        });
    const updateName = (name)=>set((state)=>{
            state.name = name;
        });
    const updateDescription = (description)=>set((state)=>{
            state.description = description;
        });
    const handleLocaleChange = (value)=>set((state)=>{
            state.defaultLocale = value;
            state.hasChanges = true;
        });
    const getClonedProfile = (profile, originatedById, nameOverride)=>{
        const clonedProfile = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profile);
        const duplicateName = getPublicProfileNameIfDuplicate(profile.name);
        Object.assign(clonedProfile, {
            profileType: 'Default',
            id: undefined,
            name: nameOverride !== null && nameOverride !== void 0 ? nameOverride : duplicateName,
            originatedByProfileId: originatedById
        });
        return clonedProfile;
    };
    const getUserDeviceProfileFromState = ()=>{
        var _s_originalProfile, _s_originalProfile1, _s_originalProfile2, _s_originalProfile3, _s_originalProfile4;
        const s = get();
        const now = new Date();
        var _s_originalProfile_requiresEmployeeAccess, _s_originalProfile_requiresStudentAccess, _s_originalProfile_requiresGenericLicense, _s_originalProfile_requiresPlusAccess, _s_originalProfile_interests;
        const profileConfig = {
            id: s.id,
            name: s.name,
            description: s.description,
            profileType: 'Default',
            configuration: getProfileConfigFromState(),
            createdDate: now.toISOString(),
            modifiedDate: now.toISOString(),
            defaultLocale: s.defaultLocale,
            requiresEmployeeAccess: (_s_originalProfile_requiresEmployeeAccess = (_s_originalProfile = s.originalProfile) === null || _s_originalProfile === void 0 ? void 0 : _s_originalProfile.requiresEmployeeAccess) !== null && _s_originalProfile_requiresEmployeeAccess !== void 0 ? _s_originalProfile_requiresEmployeeAccess : false,
            requiresStudentAccess: (_s_originalProfile_requiresStudentAccess = (_s_originalProfile1 = s.originalProfile) === null || _s_originalProfile1 === void 0 ? void 0 : _s_originalProfile1.requiresStudentAccess) !== null && _s_originalProfile_requiresStudentAccess !== void 0 ? _s_originalProfile_requiresStudentAccess : false,
            requiresGenericLicense: (_s_originalProfile_requiresGenericLicense = (_s_originalProfile2 = s.originalProfile) === null || _s_originalProfile2 === void 0 ? void 0 : _s_originalProfile2.requiresGenericLicense) !== null && _s_originalProfile_requiresGenericLicense !== void 0 ? _s_originalProfile_requiresGenericLicense : false,
            requiresPlusAccess: (_s_originalProfile_requiresPlusAccess = (_s_originalProfile3 = s.originalProfile) === null || _s_originalProfile3 === void 0 ? void 0 : _s_originalProfile3.requiresPlusAccess) !== null && _s_originalProfile_requiresPlusAccess !== void 0 ? _s_originalProfile_requiresPlusAccess : false,
            interests: (_s_originalProfile_interests = (_s_originalProfile4 = s.originalProfile) === null || _s_originalProfile4 === void 0 ? void 0 : _s_originalProfile4.interests) !== null && _s_originalProfile_interests !== void 0 ? _s_originalProfile_interests : []
        };
        if ($3a3153321729209f$exports.platform === 'darwin') profileConfig.platform = 'MacOS';
        else if ($3a3153321729209f$exports.platform === 'win32') profileConfig.platform = 'Windows';
        return profileConfig;
    };
    const loadPreview = async (shareCode)=>{
        set((state)=>{
            state.isLoading = true;
        });
        const result = await $1a4c36336f303477$export$e5888858f383ec64(shareCode);
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
            get().updateProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result.data), {
                name: result.data.profileName,
                id: result.data.id,
                userId: undefined,
                profileType: result.data.configuration.profileType,
                defaultLocale: result.data.defaultLocale,
                originatedByProfileId: result.data.userDeviceProfileId,
                interests: []
            }));
            set((state)=>{
                state.isPreview = true;
            });
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.load'),
            timeout: 5000
        });
        set((state)=>{
            state.isLoading = false;
        });
        return result;
    };
    const loadPublicPreview = async (profileId)=>{
        set((state)=>{
            state.isLoading = true;
        });
        const result = await $1a4c36336f303477$export$5bd7a6effa9290bc(profileId);
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
            get().updateProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result.data), {
                userId: undefined,
                profileType: result.data.configuration.profileType,
                originatedByProfileId: result.data.originatedByProfileId
            }));
            set((state)=>{
                state.isPreview = true;
            });
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.load'),
            timeout: 5000
        });
        set((state)=>{
            state.isLoading = false;
        });
    };
    const loadOrgPreview = async (profileId)=>{
        set((state)=>{
            state.isLoading = true;
        });
        try {
            const result = await $1a4c36336f303477$export$5bd7a6effa9290bc(profileId !== null && profileId !== void 0 ? profileId : '');
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                get().updateProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result.data), {
                    userId: undefined,
                    profileType: result.data.configuration.profileType,
                    originatedByProfileId: result.data.originatedByProfileId
                }));
                set((state)=>{
                    state.isPreview = true;
                });
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
                message: t('common:profile.error.load'),
                timeout: 5000
            });
        } catch (error) {
            (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
                message: t('common:profile.error.load'),
                timeout: 5000
            });
        } finally{
            set((state)=>{
                state.isLoading = false;
            });
        }
    };
    const addPreview = async (shareCode)=>{
        set((state)=>{
            state.isLoading = true;
        });
        const result = await $1a4c36336f303477$export$827ad3bf4ce3bb83(shareCode);
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
            (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileAdded', {
                profile: result.data
            });
            (0, $e7df95de73caec26$export$89b472e03be495df)('alertSuccess', {
                message: t('common:profile.success.add'),
                timeout: 5000
            });
        } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', {
            message: t('common:profile.error.add'),
            timeout: 5000
        });
        set((state)=>{
            state.isLoading = false;
        });
        return result;
    };
    const setDefaultProfile = (locale)=>{
        var _getSupportedLocale;
        const language = (_getSupportedLocale = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(locale, 'voice')) !== null && _getSupportedLocale !== void 0 ? _getSupportedLocale : (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
        let keyBindings = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(language);
        if (!get().isDefaultBindingsIncluded) keyBindings = keyBindings.map((k)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
                commands: []
            }));
        set((state)=>{
            state.organizationId = null;
            state.defaultLocale = language;
            state.description = undefined;
            state.imageUri = undefined;
            state.hasChanges = false;
            state.name = '';
            state.isDeprecatedHotkey = false;
            state.id = undefined;
            state.macros = [];
            state.hotkeys = [];
            state.dictationCommands = (0, $eeb1a4bb5a11a603$export$635ddbacad8e65bf)(language);
            state.associatedPrograms = [];
            state.audioEvents = [];
            state.commandKeyMappings = keyBindings;
            state.profileConflictErrors = [];
            state.profileConflictWarnings = [];
            state.isProfileConflictsAcknowledged = false;
            state.originatedByProfileId = undefined;
        });
    };
    const updateProfileState = (profile, isInitial)=>{
        const clonedProfile = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profile);
        set((state)=>{
            state.originalProfile = clonedProfile;
        });
        if (!profile.configuration) return;
        var _profile_defaultLocale, _getSupportedLocale;
        const language = (_getSupportedLocale = (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)((_profile_defaultLocale = profile.defaultLocale) !== null && _profile_defaultLocale !== void 0 ? _profile_defaultLocale : (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec), 'voice')) !== null && _getSupportedLocale !== void 0 ? _getSupportedLocale : (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
        const { hotkeys: hotkeys, macros: macros, commandKeyMappings: profileKeybindings, audioEvents: audioEvents, dictationCommands: dictationCommands, suggestedGeneratePrompts: suggestedGeneratePrompts, suggestedRewritePrompts: suggestedRewritePrompts, associatedPrograms: associatedPrograms } = profile.configuration;
        var _macros_map;
        const updatedMacros = (_macros_map = macros === null || macros === void 0 ? void 0 : macros.map((a)=>{
            var _a_id;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a), {
                id: (_a_id = a.id) !== null && _a_id !== void 0 ? _a_id : (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
                commands: a.commands.map((c)=>({
                        command: c,
                        commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(c)
                    }))
            });
        })) !== null && _macros_map !== void 0 ? _macros_map : [];
        let isDeprecated = false;
        const updatedHotkeys = (hotkeys !== null && hotkeys !== void 0 ? hotkeys : []).map((h)=>{
            var _getMacroForHotkey_m, _getMacroForHotkey;
            var _h_localId;
            const localId = (_h_localId = h.localId) !== null && _h_localId !== void 0 ? _h_localId : (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
            var _h_macroLocalId;
            const macroLocalId = (_h_macroLocalId = h.macroLocalId) !== null && _h_macroLocalId !== void 0 ? _h_macroLocalId : (_getMacroForHotkey = (0, $15df2073755d9d49$export$8887ad9c8dfc8e0a)(h, updatedMacros)) === null || _getMacroForHotkey === void 0 ? void 0 : (_getMacroForHotkey_m = _getMacroForHotkey.m) === null || _getMacroForHotkey_m === void 0 ? void 0 : _getMacroForHotkey_m.id;
            const deprecated = !h.command.startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257));
            if (deprecated) isDeprecated = true;
            return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, h), {
                localId: localId,
                macroLocalId: macroLocalId
            }), deprecated && !h.macroName ? {
                macroName: 'Deprecated Hotkey'
            } : {});
        });
        const updatedAudioEvents = (audioEvents || []).map((a)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a), {
                commands: (a.commands || []).map((c)=>({
                        command: c,
                        commandType: (0, $f44f3a5bc46b1c4c$export$e9c0f8ebac1b37df)(c)
                    }))
            }));
        let keybindings = (0, $9d76aba0a210d2c6$export$f31ec4fcec40d1f9)((0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(language, profile.platform), profileKeybindings === null || profileKeybindings === void 0 ? void 0 : profileKeybindings.map((k)=>(0, $9a9874d925dad9cc$export$e4e98b6e2a74daae)(k, language, [], profile.platform)));
        if (!get().isDefaultBindingsIncluded && !profile.id && !profileKeybindings) keybindings = keybindings.map((k)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
                commands: []
            }));
        const programs = associatedPrograms !== null && associatedPrograms !== void 0 ? associatedPrograms : [];
        const dictCmds = dictationCommands !== null && dictationCommands !== void 0 ? dictationCommands : (0, $eeb1a4bb5a11a603$export$635ddbacad8e65bf)(language);
        const genPrompts = suggestedGeneratePrompts !== null && suggestedGeneratePrompts !== void 0 ? suggestedGeneratePrompts : [];
        const rewritePrompts = suggestedRewritePrompts !== null && suggestedRewritePrompts !== void 0 ? suggestedRewritePrompts : [];
        set((state)=>{
            state.defaultLocale = language;
            state.macros = updatedMacros;
            state.isDeprecatedHotkey = isDeprecated;
            state.hotkeys = updatedHotkeys;
            state.audioEvents = updatedAudioEvents;
            state.dictationCommands = dictCmds;
            state.suggestedGeneratePrompts = genPrompts;
            state.suggestedRewritePrompts = rewritePrompts;
            state.associatedPrograms = programs;
            state.id = profile.id;
            state.name = profile.name;
            state.description = profile.description;
            state.imageUri = profile.imageUrl;
            state.originatedByProfileId = profile.originatedByProfileId;
            state.commandKeyMappings = keybindings;
            state.isProfileConflictsAcknowledged = false;
            state.profileConflictErrors = [];
            state.profileConflictWarnings = [];
        });
    };
    const updateDeprecatedHotkey = (hotkey, macrosArg)=>{
        const newCommand = {
            command: (0, $f44f3a5bc46b1c4c$export$b617c310e3426257) + hotkey.displayName,
            commandType: 'hotkey',
            hotkeyLocalId: hotkey.localId
        };
        const currentHotkeys = get().hotkeys;
        const macroId = hotkey.macroLocalId ? hotkey.macroLocalId : (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
        const updatedHotkey = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, hotkey), {
            command: (0, $f44f3a5bc46b1c4c$export$b617c310e3426257) + hotkey.displayName,
            macroLocalId: macroId
        });
        const hotkeyIndex = currentHotkeys.indexOf(hotkey);
        const linkedMacro = macrosArg.find((m)=>m.id === hotkey.macroLocalId);
        const updatedMacros = [
            ...macrosArg
        ];
        const updatedHotkeys = [
            ...currentHotkeys
        ];
        if (linkedMacro) {
            const indexOfLinkedMacro = macrosArg.indexOf(linkedMacro);
            updatedMacros[indexOfLinkedMacro] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, linkedMacro), {
                commands: [
                    ...linkedMacro.commands,
                    newCommand
                ]
            });
            updatedHotkeys[hotkeyIndex] = updatedHotkey;
        } else updatedHotkeys.splice(hotkeyIndex, 1);
        set((state)=>{
            state.macros = updatedMacros;
            state.hotkeys = updatedHotkeys;
        });
    };
    const removeHotkeyFromMacro = (command)=>{
        const updated = get().hotkeys.filter((h)=>h.command !== command.command);
        set((state)=>{
            state.hotkeys = updated;
        });
    };
    const updateHotkeyFromMacro = (value, macro, index, originalValue)=>{
        const currentHotkeys = get().hotkeys;
        const matchHotkey = currentHotkeys.find((h)=>h.command === originalValue);
        if (matchHotkey) {
            const hotkeyIndex = currentHotkeys.indexOf(matchHotkey);
            const updatedHotkey = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, matchHotkey), {
                displayName: value.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), ''),
                command: value
            });
            const updated = [
                ...currentHotkeys
            ];
            updated[hotkeyIndex] = updatedHotkey;
            set((state)=>{
                state.hotkeys = updated;
            });
            var _matchHotkey_localId;
            return (_matchHotkey_localId = matchHotkey.localId) !== null && _matchHotkey_localId !== void 0 ? _matchHotkey_localId : '';
        } else return get().addHotkeyCommandForMacro(macro, currentHotkeys, value);
    };
    const addHotkeyCommandForMacro = (macro, hotkeys, command)=>{
        const newHotkey = {
            command: command,
            displayName: command.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), ''),
            localId: (0, $6810e10b84975c3e$export$2e2bcd8739ae039)(),
            macroId: macro.id,
            macroName: macro.name
        };
        set((state)=>{
            state.hotkeys = [
                ...hotkeys,
                newHotkey
            ];
        });
        return newHotkey.localId;
    };
    const resetPreviewStatus = ()=>set((state)=>{
            state.isPreview = false;
        });
    return {
        // State
        associatedPrograms: [],
        audioEvents: [],
        availableCustomControls: [],
        commandKeyMappings: [],
        defaultLocale: (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec),
        description: undefined,
        dictationCommands: [],
        errors: [],
        filter: '',
        hasChanges: false,
        hotkeys: [],
        id: undefined,
        imageUri: undefined,
        isDefaultBindingsIncluded: false,
        isDeprecatedHotkey: false,
        isLoading: false,
        isPreview: false,
        isProfileConflictsAcknowledged: false,
        macros: [],
        name: '',
        organizationId: null,
        originalProfile: null,
        originatedByProfileId: undefined,
        profileConflictErrors: [],
        profileConflictWarnings: [],
        suggestedGeneratePrompts: [],
        suggestedRewritePrompts: [],
        saveChanges: // Actions
        saveChanges,
        setFilter: setFilter,
        setHasChanges: setHasChanges,
        setId: setId,
        setIsDeprecatedHotkey: setIsDeprecatedHotkey,
        setIsDefaultBindingsIncluded: setIsDefaultBindingsIncluded,
        setIsPreview: setIsPreview,
        setIsConflictsAcknowledged: setIsConflictsAcknowledged,
        setAvailableCustomControls: setAvailableCustomControls,
        setOrganizationId: setOrganizationId,
        updateAssociatedPrograms: updateAssociatedPrograms,
        updateAudioEvents: updateAudioEvents,
        updateCommandKeyMappings: updateCommandKeyMappings,
        resetKeybindingsToDefault: resetKeybindingsToDefault,
        resetKeybindingsToEmpty: resetKeybindingsToEmpty,
        updateDictationCommands: updateDictationCommands,
        updateSuggestedGeneratePrompts: updateSuggestedGeneratePrompts,
        updateSuggestedRewritePrompts: updateSuggestedRewritePrompts,
        updateHotkeys: updateHotkeys,
        updateMacros: updateMacros,
        updateName: updateName,
        updateDescription: updateDescription,
        handleLocaleChange: handleLocaleChange,
        getClonedProfile: getClonedProfile,
        getProfileConfigFromState: getProfileConfigFromState,
        getPublicProfileNameIfDuplicate: getPublicProfileNameIfDuplicate,
        getUserDeviceProfileFromState: getUserDeviceProfileFromState,
        isDuplicateName: isDuplicateName,
        loadPreview: loadPreview,
        loadPublicPreview: loadPublicPreview,
        loadOrgPreview: loadOrgPreview,
        addPreview: addPreview,
        setDefaultProfile: setDefaultProfile,
        updateProfileState: updateProfileState,
        updateDeprecatedHotkey: updateDeprecatedHotkey,
        removeHotkeyFromMacro: removeHotkeyFromMacro,
        updateHotkeyFromMacro: updateHotkeyFromMacro,
        addHotkeyCommandForMacro: addHotkeyCommandForMacro,
        resetPreviewStatus: resetPreviewStatus
    };
}));
function $697752726c88b03c$export$a1250c97601dad3d() {
    const getGlobalConflicts = (0, $31424fe514516834$export$2e2bcd8739ae039)();
    (0, $7fPBF.useEffect)(()=>{
        $697752726c88b03c$var$globalConflictsGetter = getGlobalConflicts;
        return ()=>{
            $697752726c88b03c$var$globalConflictsGetter = null;
        };
    }, [
        getGlobalConflicts
    ]);
}

















let $30af349a5a5f3e57$var$_ = (t)=>t, $30af349a5a5f3e57$var$t;
/**
 * SrOnlyText.tsx
 * This is a styled component that is used to hide text from everyone but the screen reader.
 * It should be used with caution as it is always better to have text visible to everyone.
 * However, there are some cases where text is not needed for the user but is needed for the screen reader.
 * In these cases, this component should be used.
 */ const $30af349a5a5f3e57$var$SrOnlyText = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($30af349a5a5f3e57$var$t || ($30af349a5a5f3e57$var$t = $30af349a5a5f3e57$var$_`
    position: absolute !important;
    width: 0px !important;
    height: 0px !important;
    padding: 0 !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
    border: 0 !important;
`));
var $30af349a5a5f3e57$export$2e2bcd8739ae039 = $30af349a5a5f3e57$var$SrOnlyText;



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

const $57773c22414cc39f$export$2e2bcd8739ae039 = $7fPBF.forwardRef((s, a)=>{
    const { alt: n, color: r, size: t, weight: o, mirrored: c, children: i, weights: m } = s, x = (0, $8901fc92b5563702$export$71511d61b312f219)(s, [
        "alt",
        "color",
        "size",
        "weight",
        "mirrored",
        "children",
        "weights"
    ]), _e_useContext = $7fPBF.useContext((0, $1c78e537a9e9e9b0$export$a49f528ae1a4d0ed)), { color: d = "currentColor", size: l, weight: f = "regular", mirrored: g = !1 } = _e_useContext, w = (0, $8901fc92b5563702$export$71511d61b312f219)(_e_useContext, [
        "color",
        "size",
        "weight",
        "mirrored"
    ]);
    return /* @__PURE__ */ $7fPBF.createElement("svg", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a,
        xmlns: "http://www.w3.org/2000/svg",
        width: t != null ? t : l,
        height: t != null ? t : l,
        fill: r != null ? r : d,
        viewBox: "0 0 256 256",
        transform: c || g ? "scale(-1, 1)" : void 0
    }, w, x), !!n && /* @__PURE__ */ $7fPBF.createElement("title", null, n), i, m.get(o != null ? o : f));
});
$57773c22414cc39f$export$2e2bcd8739ae039.displayName = "IconBase";



var $7fPBF = parcelRequire("7fPBF");
const $ed3120622883ea3f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212ZM60,92a16,16,0,1,1,16,16A16,16,0,0,1,60,92Zm48,0a16,16,0,1,1,16,16A16,16,0,0,1,108,92Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM68,96A12,12,0,1,1,80,84,12,12,0,0,1,68,96Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2ZM78,84A10,10,0,1,1,68,74,10,10,0,0,1,78,84Zm40,0a10,10,0,1,1-10-10A10,10,0,0,1,118,84Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4ZM76,84a8,8,0,1,1-8-8A8,8,0,0,1,76,84Zm40,0a8,8,0,1,1-8-8A8,8,0,0,1,116,84Z"
        }))
    ]
]);


const $dfac1a9d177543ce$export$73674ec7e4bd2217 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $ed3120622883ea3f$export$2e2bcd8739ae039)
    })));
$dfac1a9d177543ce$export$73674ec7e4bd2217.displayName = "AppWindowIcon";
const $dfac1a9d177543ce$export$8bd6e8b7c946a046 = $dfac1a9d177543ce$export$73674ec7e4bd2217;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b74537f7813f836d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,44H32A20,20,0,0,0,12,64V88a20,20,0,0,0,16,19.6V192a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V107.6A20,20,0,0,0,244,88V64A20,20,0,0,0,224,44ZM36,68H220V84H36ZM52,188V108H204v80Zm112-52a12,12,0,0,1-12,12H104a12,12,0,0,1,0-24h48A12,12,0,0,1,164,136Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V88a16,16,0,0,0,16,16v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM208,192H48V104H208ZM224,88H32V64H224V88ZM96,136a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,136Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V88a16,16,0,0,0,16,16v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm-72,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm72-56H32V64H224V88Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,50H32A14,14,0,0,0,18,64V88a14,14,0,0,0,14,14h2v90a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V102h2a14,14,0,0,0,14-14V64A14,14,0,0,0,224,50ZM210,192a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V102H210ZM226,88a2,2,0,0,1-2,2H32a2,2,0,0,1-2-2V64a2,2,0,0,1,2-2H224a2,2,0,0,1,2,2ZM98,136a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H104A6,6,0,0,1,98,136Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V88a16,16,0,0,0,16,16v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM208,192H48V104H208ZM224,88H32V64H224V88ZM96,136a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,136Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,52H32A12,12,0,0,0,20,64V88a12,12,0,0,0,12,12h4v92a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V100h4a12,12,0,0,0,12-12V64A12,12,0,0,0,224,52ZM212,192a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V100H212ZM228,88a4,4,0,0,1-4,4H32a4,4,0,0,1-4-4V64a4,4,0,0,1,4-4H224a4,4,0,0,1,4,4ZM100,136a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H104A4,4,0,0,1,100,136Z"
        }))
    ]
]);


const $d648a03dbd4f3269$export$64abfa02d870a554 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $b74537f7813f836d$export$2e2bcd8739ae039)
    })));
$d648a03dbd4f3269$export$64abfa02d870a554.displayName = "ArchiveIcon";
const $d648a03dbd4f3269$export$767c3cfd836ab901 = $d648a03dbd4f3269$export$64abfa02d870a554;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9e5b8dd6cfd61d7a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204,32V176a12,12,0,0,1-12,12H77l27.52,27.51a12,12,0,0,1-17,17l-48-48a12,12,0,0,1,0-17l48-48a12,12,0,1,1,17,17L77,164H180V32a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,128v96L48,176Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,24a8,8,0,0,0-8,8V168H104V128a8,8,0,0,0-13.66-5.66l-48,48a8,8,0,0,0,0,11.32l48,48A8,8,0,0,0,104,224V184h88a8,8,0,0,0,8-8V32A8,8,0,0,0,192,24ZM88,204.69,59.31,176,88,147.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32V176a8,8,0,0,1-8,8H104v40a8,8,0,0,1-13.66,5.66l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,104,128v40h80V32a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198,32V176a6,6,0,0,1-6,6H62.49l37.75,37.76a6,6,0,1,1-8.48,8.48l-48-48a6,6,0,0,1,0-8.48l48-48a6,6,0,1,1,8.48,8.48L62.49,170H186V32a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32V176a8,8,0,0,1-8,8H67.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48a8,8,0,0,1,11.32,11.32L67.31,168H184V32a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196,32V176a4,4,0,0,1-4,4H57.66l41.17,41.17a4,4,0,0,1-5.66,5.66l-48-48a4,4,0,0,1,0-5.66l48-48a4,4,0,1,1,5.66,5.66L57.66,172H188V32a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $67b9a227b3b8fac0$export$13cb63b08462037d = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, e), {
        weights: (0, $9e5b8dd6cfd61d7a$export$2e2bcd8739ae039)
    })));
$67b9a227b3b8fac0$export$13cb63b08462037d.displayName = "ArrowElbowDownLeftIcon";
const $67b9a227b3b8fac0$export$ced96cfba709fc2c = $67b9a227b3b8fac0$export$13cb63b08462037d;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d8816807b786f33b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.49,184.49l-48,48a12,12,0,0,1-17-17L187,188H72a12,12,0,0,1-12-12V32a12,12,0,0,1,24,0V164H187l-27.52-27.51a12,12,0,1,1,17-17l48,48A12,12,0,0,1,224.49,184.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,176l-48,48V128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,170.34l-48-48A8,8,0,0,0,160,128v40H80V32a8,8,0,0,0-16,0V176a8,8,0,0,0,8,8h88v40a8,8,0,0,0,13.66,5.66l48-48A8,8,0,0,0,221.66,170.34ZM176,204.69V147.31L204.69,176Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,181.66l-48,48A8,8,0,0,1,160,224V184H72a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8,8,0,0,1,13.66-5.66l48,48A8,8,0,0,1,221.66,181.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.24,180.24l-48,48a6,6,0,0,1-8.48-8.48L201.51,182H72a6,6,0,0,1-6-6V32a6,6,0,0,1,12,0V170H201.51l-37.75-37.76a6,6,0,1,1,8.48-8.48l48,48A6,6,0,0,1,220.24,180.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,181.66l-48,48a8,8,0,0,1-11.32-11.32L196.69,184H72a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168H196.69l-34.35-34.34a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,221.66,181.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M218.83,178.83l-48,48a4,4,0,0,1-5.66-5.66L206.34,180H72a4,4,0,0,1-4-4V32a4,4,0,0,1,8,0V172H206.34l-41.17-41.17a4,4,0,1,1,5.66-5.66l48,48A4,4,0,0,1,218.83,178.83Z"
        }))
    ]
]);


const $6637b5fdc104c1c9$export$56519a0a31438e20 = $7fPBF.forwardRef((t, w)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: w
    }, t), {
        weights: (0, $d8816807b786f33b$export$2e2bcd8739ae039)
    })));
$6637b5fdc104c1c9$export$56519a0a31438e20.displayName = "ArrowElbowDownRightIcon";
const $6637b5fdc104c1c9$export$677a03fdc17dcb49 = $6637b5fdc104c1c9$export$56519a0a31438e20;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c1220d732e68f3d1$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,111.51l-96-96a12,12,0,0,0-17,0l-96,96A12,12,0,0,0,32,132H68v4a12,12,0,0,0,12,12h96a12,12,0,0,0,12-12v-4h36a12,12,0,0,0,8.49-20.49ZM176,108a12,12,0,0,0-12,12v4H92v-4a12,12,0,0,0-12-12H61l67-67,67,67Zm12,108a12,12,0,0,1-12,12H80a12,12,0,0,1,0-24h96A12,12,0,0,1,188,216Zm0-40a12,12,0,0,1-12,12H80a12,12,0,0,1,0-24h96A12,12,0,0,1,188,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,120H176v32H80V120H32l96-96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,114.34l-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v24a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V128h40a8,8,0,0,0,5.66-13.66ZM176,112a8,8,0,0,0-8,8v24H88V120a8,8,0,0,0-8-8H51.31L128,35.31,204.69,112Zm8,104a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,216Zm0-32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,216a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,216Zm45.66-101.66-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v24a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V128h40a8,8,0,0,0,5.66-13.66ZM176,176H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,115.76l-96-96a6,6,0,0,0-8.48,0l-96,96A6,6,0,0,0,32,126H74v26a6,6,0,0,0,6,6h96a6,6,0,0,0,6-6V126h42a6,6,0,0,0,4.24-10.24ZM176,114a6,6,0,0,0-6,6v26H86V120a6,6,0,0,0-6-6H46.49L128,32.49,209.51,114Zm6,102a6,6,0,0,1-6,6H80a6,6,0,0,1,0-12h96A6,6,0,0,1,182,216Zm0-32a6,6,0,0,1-6,6H80a6,6,0,0,1,0-12h96A6,6,0,0,1,182,184Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,114.34l-96-96a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,32,128H72v24a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V128h40a8,8,0,0,0,5.66-13.66ZM176,112a8,8,0,0,0-8,8v24H88V120a8,8,0,0,0-8-8H51.31L128,35.31,204.69,112Zm8,104a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,216Zm0-32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,117.17l-96-96a4,4,0,0,0-5.66,0l-96,96A4,4,0,0,0,32,124H76v28a4,4,0,0,0,4,4h96a4,4,0,0,0,4-4V124h44a4,4,0,0,0,2.83-6.83ZM176,116a4,4,0,0,0-4,4v28H84V120a4,4,0,0,0-4-4H41.66L128,29.66,214.34,116Zm4,100a4,4,0,0,1-4,4H80a4,4,0,0,1,0-8h96A4,4,0,0,1,180,216Zm0-32a4,4,0,0,1-4,4H80a4,4,0,0,1,0-8h96A4,4,0,0,1,180,184Z"
        }))
    ]
]);


const $77361cab3d35eb70$export$d4c1fa49fa5d23e1 = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, e), {
        weights: (0, $c1220d732e68f3d1$export$2e2bcd8739ae039)
    })));
$77361cab3d35eb70$export$d4c1fa49fa5d23e1.displayName = "ArrowFatLinesUpIcon";
const $77361cab3d35eb70$export$9cba9f8b627cd7c4 = $77361cab3d35eb70$export$d4c1fa49fa5d23e1;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $92d218368e7786d0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M87.51,64.49a12,12,0,0,1,0-17l32-32a12,12,0,0,1,17,0l32,32a12,12,0,0,1-17,17L140,53V96a12,12,0,0,1-24,0V53L104.49,64.49A12,12,0,0,1,87.51,64.49Zm64,127L140,203V160a12,12,0,0,0-24,0v43l-11.51-11.52a12,12,0,0,0-17,17l32,32a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Zm89-72-32-32a12,12,0,0,0-17,17L203,116H160a12,12,0,0,0,0,24h43l-11.52,11.51a12,12,0,0,0,17,17l32-32A12,12,0,0,0,240.49,119.51ZM53,140H96a12,12,0,0,0,0-24H53l11.52-11.51a12,12,0,1,0-17-17l-32,32a12,12,0,0,0,0,17l32,32a12,12,0,1,0,17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128,128,232,24,128,128,24Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90.34,61.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V96a8,8,0,0,1-16,0V43.31L101.66,61.66A8,8,0,0,1,90.34,61.66Zm64,132.68L136,212.69V160a8,8,0,0,0-16,0v52.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm83.32-72-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160a8,8,0,0,0,0,16h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34ZM43.31,136H96a8,8,0,0,0,0-16H43.31l18.35-18.34A8,8,0,0,0,50.34,90.34l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,136H64v24a8,8,0,0,1-13.66,5.66l-32-32a8,8,0,0,1,0-11.32l32-32A8,8,0,0,1,64,96v24H96a8,8,0,0,1,0,16Zm0-72h24V96a8,8,0,0,0,16,0V64h24a8,8,0,0,0,5.66-13.66l-32-32a8,8,0,0,0-11.32,0l-32,32A8,8,0,0,0,96,64Zm141.66,58.34-32-32A8,8,0,0,0,192,96v24H160a8,8,0,0,0,0,16h32v24a8,8,0,0,0,13.66,5.66l32-32A8,8,0,0,0,237.66,122.34ZM160,192H136V160a8,8,0,0,0-16,0v32H96a8,8,0,0,0-5.66,13.66l32,32a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,160,192Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M91.76,60.24a6,6,0,0,1,0-8.48l32-32a6,6,0,0,1,8.48,0l32,32a6,6,0,1,1-8.48,8.48L134,38.49V96a6,6,0,0,1-12,0V38.49L100.24,60.24A6,6,0,0,1,91.76,60.24Zm64,135.52L134,217.51V160a6,6,0,0,0-12,0v57.51l-21.76-21.75a6,6,0,0,0-8.48,8.48l32,32a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Zm80.48-72-32-32a6,6,0,0,0-8.48,8.48L217.51,122H160a6,6,0,0,0,0,12h57.51l-21.75,21.76a6,6,0,1,0,8.48,8.48l32-32A6,6,0,0,0,236.24,123.76ZM38.49,134H96a6,6,0,0,0,0-12H38.49l21.75-21.76a6,6,0,0,0-8.48-8.48l-32,32a6,6,0,0,0,0,8.48l32,32a6,6,0,0,0,8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90.34,61.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V96a8,8,0,0,1-16,0V43.31L101.66,61.66A8,8,0,0,1,90.34,61.66Zm64,132.68L136,212.69V160a8,8,0,0,0-16,0v52.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm83.32-72-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160a8,8,0,0,0,0,16h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34ZM43.31,136H96a8,8,0,0,0,0-16H43.31l18.35-18.34A8,8,0,0,0,50.34,90.34l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M93.17,58.83a4,4,0,0,1,0-5.66l32-32a4,4,0,0,1,5.66,0l32,32a4,4,0,0,1-5.66,5.66L132,33.66V96a4,4,0,0,1-8,0V33.66L98.83,58.83A4,4,0,0,1,93.17,58.83Zm64,138.34L132,222.34V160a4,4,0,0,0-8,0v62.34L98.83,197.17a4,4,0,0,0-5.66,5.66l32,32a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Zm77.66-72-32-32a4,4,0,0,0-5.66,5.66L222.34,124H160a4,4,0,0,0,0,8h62.34l-25.17,25.17a4,4,0,0,0,5.66,5.66l32-32A4,4,0,0,0,234.83,125.17ZM33.66,132H96a4,4,0,0,0,0-8H33.66L58.83,98.83a4,4,0,0,0-5.66-5.66l-32,32a4,4,0,0,0,0,5.66l32,32a4,4,0,1,0,5.66-5.66Z"
        }))
    ]
]);


const $262c01eb267814c7$export$a851e5e12081274c = $7fPBF.forwardRef((a, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, a), {
        weights: (0, $92d218368e7786d0$export$2e2bcd8739ae039)
    })));
$262c01eb267814c7$export$a851e5e12081274c.displayName = "ArrowsOutCardinalIcon";
const $262c01eb267814c7$export$5c8fcb1141eeb696 = $262c01eb267814c7$export$a851e5e12081274c;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5edf2742067d7e74$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM104.49,56.48,116,45V88a12,12,0,0,0,24,0V45l11.51,11.51a12,12,0,0,0,17-17l-32-32a12,12,0,0,0-17,0l-32,32a12,12,0,0,0,17,17Zm47,143L140,211V168a12,12,0,0,0-24,0v43l-11.51-11.52a12,12,0,0,0-17,17l32,32a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32V224a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V32A16,16,0,0,1,56,16H200A16,16,0,0,1,216,32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88.61,51.06a8,8,0,0,1,1.73-8.72l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,160,56H136V96a8,8,0,0,1-16,0V56H96A8,8,0,0,1,88.61,51.06ZM216,120H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-56,80H136V160a8,8,0,0,0-16,0v40H96a8,8,0,0,0-5.66,13.66l32,32a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,160,200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM100.24,52.24,122,30.49V96a6,6,0,0,0,12,0V30.49l21.76,21.75a6,6,0,0,0,8.48-8.48l-32-32a6,6,0,0,0-8.48,0l-32,32a6,6,0,0,0,8.48,8.48Zm55.52,151.52L134,225.51V160a6,6,0,0,0-12,0v65.51l-21.76-21.75a6,6,0,0,0-8.48,8.48l32,32a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM101.66,53.66,120,35.31V96a8,8,0,0,0,16,0V35.31l18.34,18.35a8,8,0,0,0,11.32-11.32l-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32Zm52.68,148.68L136,220.69V160a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM98.83,50.83,124,25.66V96a4,4,0,0,0,8,0V25.66l25.17,25.17a4,4,0,1,0,5.66-5.66l-32-32a4,4,0,0,0-5.66,0l-32,32a4,4,0,0,0,5.66,5.66Zm58.34,154.34L132,230.34V160a4,4,0,0,0-8,0v70.34L98.83,205.17a4,4,0,0,0-5.66,5.66l32,32a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Z"
        }))
    ]
]);


const $c1cd2f9ed3ccb6f1$export$83609ace955a79f = $7fPBF.forwardRef((o, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, o), {
        weights: (0, $5edf2742067d7e74$export$2e2bcd8739ae039)
    })));
$c1cd2f9ed3ccb6f1$export$83609ace955a79f.displayName = "ArrowsOutLineVerticalIcon";
const $c1cd2f9ed3ccb6f1$export$720d58d5890ffa04 = $c1cd2f9ed3ccb6f1$export$83609ace955a79f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5a58d2012a64e35d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM87.51,144.49a12,12,0,1,1,17-17L116,139V88a12,12,0,0,1,24,0v51l11.51-11.52a12,12,0,1,1,17,17l-32,32a12,12,0,0,1-17,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-42.34-77.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35A8,8,0,0,1,165.66,130.34Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM165.66,141.66l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-45.76-76.24a6,6,0,0,1,0,8.48l-32,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48L122,153.51V88a6,6,0,0,1,12,0v65.51l21.76-21.75A6,6,0,0,1,164.24,131.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-42.34-77.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35A8,8,0,0,1,165.66,130.34Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-49.17-74.83a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66,0l-32-32a4,4,0,0,1,5.66-5.66L124,158.34V88a4,4,0,0,1,8,0v70.34l25.17-25.17A4,4,0,0,1,162.83,133.17Z"
        }))
    ]
]);


const $31ad35f89b420139$export$39cd7ca4553bb068 = $7fPBF.forwardRef((e, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, e), {
        weights: (0, $5a58d2012a64e35d$export$2e2bcd8739ae039)
    })));
$31ad35f89b420139$export$39cd7ca4553bb068.displayName = "ArrowSquareDownIcon";
const $31ad35f89b420139$export$b18b91a77b42e903 = $31ad35f89b420139$export$39cd7ca4553bb068;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $26dc86d55555543b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,104a12,12,0,0,1-24,0V69l-59.51,59.51a12,12,0,0,1-17-17L187,52H152a12,12,0,0,1,0-24h64a12,12,0,0,1,12,12Zm-44,24a12,12,0,0,0-12,12v64H52V84h64a12,12,0,0,0,0-24H48A20,20,0,0,0,28,80V208a20,20,0,0,0,20,20H176a20,20,0,0,0,20-20V140A12,12,0,0,0,184,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,80V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H176A8,8,0,0,1,184,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,136v72a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64h72a8,8,0,0,1,0,16H48V208H176V136a8,8,0,0,1,16,0Zm32-96a8,8,0,0,0-8-8H152a8,8,0,0,0-5.66,13.66L172.69,72l-42.35,42.34a8,8,0,0,0,11.32,11.32L184,83.31l26.34,26.35A8,8,0,0,0,224,104Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,104a6,6,0,0,1-12,0V54.49l-69.75,69.75a6,6,0,0,1-8.48-8.48L201.51,46H152a6,6,0,0,1,0-12h64a6,6,0,0,1,6,6Zm-38,26a6,6,0,0,0-6,6v72a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V80a2,2,0,0,1,2-2h72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,80V208a14,14,0,0,0,14,14H176a14,14,0,0,0,14-14V136A6,6,0,0,0,184,130Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,104a4,4,0,0,1-8,0V49.66l-73.16,73.17a4,4,0,0,1-5.66-5.66L206.34,44H152a4,4,0,0,1,0-8h64a4,4,0,0,1,4,4Zm-36,28a4,4,0,0,0-4,4v72a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,80V208a12,12,0,0,0,12,12H176a12,12,0,0,0,12-12V136A4,4,0,0,0,184,132Z"
        }))
    ]
]);


const $2c52d04e0b586f6c$export$8a7958b7fd68e86d = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, e), {
        weights: (0, $26dc86d55555543b$export$2e2bcd8739ae039)
    })));
$2c52d04e0b586f6c$export$8a7958b7fd68e86d.displayName = "ArrowSquareOutIcon";
const $2c52d04e0b586f6c$export$1453825ca7ef66c = $2c52d04e0b586f6c$export$8a7958b7fd68e86d;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $dce9f61ad8b609ff$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM87.51,128.49a12,12,0,0,1,0-17l32-32a12,12,0,0,1,17,0l32,32a12,12,0,0,1-17,17L140,117v51a12,12,0,0,1-24,0V117l-11.51,11.52A12,12,0,0,1,87.51,128.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208ZM90.34,125.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35A8,8,0,0,1,90.34,125.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-42.34,93.66a8,8,0,0,1-11.32,0L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,165.66,125.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-45.76-92.24a6,6,0,1,1-8.48,8.48L134,102.49V168a6,6,0,0,1-12,0V102.49l-21.76,21.75a6,6,0,0,1-8.48-8.48l32-32a6,6,0,0,1,8.48,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208ZM90.34,125.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,107.31V168a8,8,0,0,1-16,0V107.31l-18.34,18.35A8,8,0,0,1,90.34,125.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-49.17-90.83a4,4,0,0,1-5.66,5.66L132,97.66V168a4,4,0,0,1-8,0V97.66L98.83,122.83a4,4,0,0,1-5.66-5.66l32-32a4,4,0,0,1,5.66,0Z"
        }))
    ]
]);


const $618411f7e75dbf5e$export$877fb05cb295590c = $7fPBF.forwardRef((e, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, e), {
        weights: (0, $dce9f61ad8b609ff$export$2e2bcd8739ae039)
    })));
$618411f7e75dbf5e$export$877fb05cb295590c.displayName = "ArrowSquareUpIcon";
const $618411f7e75dbf5e$export$426afd5b5ba0f986 = $618411f7e75dbf5e$export$877fb05cb295590c;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f6cae62af08afbdc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.23,159.2a196.66,196.66,0,0,0-18-31.2,196.66,196.66,0,0,0,18-31.2c11.84-26.31,11.69-47.48-.43-59.6s-33.29-12.27-59.6-.43a196.66,196.66,0,0,0-31.2,18,196.66,196.66,0,0,0-31.2-18c-26.31-11.84-47.48-11.69-59.6.43s-12.27,33.29-.43,59.6a196.66,196.66,0,0,0,18,31.2,196.66,196.66,0,0,0-18,31.2c-11.84,26.31-11.69,47.48.43,59.6h0C43.33,224.93,51.78,228,62,228c10,0,21.77-2.92,34.76-8.77a196.66,196.66,0,0,0,31.2-18,196.66,196.66,0,0,0,31.2,18c13,5.85,24.74,8.77,34.76,8.77,10.26,0,18.71-3.07,24.84-9.2h0C230.92,206.68,231.07,185.51,219.23,159.2Zm-17.41-105c5.25,5.26,1.79,26-16,53.78-5.61-6.66-11.65-13.25-18.07-19.67S154.7,75.83,148,70.22C175.82,52.39,196.56,48.93,201.82,54.18ZM171.24,128a288.6,288.6,0,0,1-20.51,22.73A288.6,288.6,0,0,1,128,171.24a288.6,288.6,0,0,1-22.73-20.51A288.6,288.6,0,0,1,84.76,128,298.55,298.55,0,0,1,128,84.76a286.83,286.83,0,0,1,22.73,20.51A286.83,286.83,0,0,1,171.24,128ZM54.18,54.18c1.46-1.45,4.1-2.24,7.75-2.24,9.53,0,25.94,5.39,46,18.28-6.66,5.61-13.25,11.65-19.67,18.07S75.83,101.3,70.22,108C52.39,80.18,48.93,59.44,54.18,54.18Zm0,147.64c-5.25-5.26-1.79-26,16-53.78,5.61,6.66,11.65,13.25,18.07,19.67s13,12.46,19.67,18.07C80.18,203.61,59.44,207.07,54.18,201.82Zm147.64,0c-5.26,5.25-26,1.79-53.78-16,6.66-5.61,13.25-11.65,19.67-18.07s12.46-13,18.07-19.67C203.61,175.82,207.07,196.56,201.82,201.82ZM144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.26,210.26c-17.23,17.23-68-5.63-113.46-51.06S28.51,63,45.74,45.74s68,5.63,113.46,51.06S227.49,193,210.26,210.26Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.12,128c24.65-34.61,37.22-70.38,19.74-87.86S162.61,35.23,128,59.88C93.39,35.23,57.62,22.66,40.14,40.14S35.23,93.39,59.88,128c-24.65,34.61-37.22,70.38-19.74,87.86h0c5.63,5.63,13.15,8.14,21.91,8.14,18.48,0,42.48-11.17,66-27.88C151.47,212.83,175.47,224,194,224c8.76,0,16.29-2.52,21.91-8.14h0C233.34,198.38,220.77,162.61,196.12,128Zm8.43-76.55c7.64,7.64,2.48,32.4-18.52,63.28a300.33,300.33,0,0,0-21.19-23.57A300.33,300.33,0,0,0,141.27,70C172.15,49,196.91,43.8,204.55,51.45ZM176.29,128a289.14,289.14,0,0,1-22.76,25.53A289.14,289.14,0,0,1,128,176.29a289.14,289.14,0,0,1-25.53-22.76A289.14,289.14,0,0,1,79.71,128,298.62,298.62,0,0,1,128,79.71a289.14,289.14,0,0,1,25.53,22.76A289.14,289.14,0,0,1,176.29,128ZM51.45,51.45c2.2-2.21,5.83-3.35,10.62-3.35C73.89,48.1,92.76,55,114.72,70A304,304,0,0,0,91.16,91.16,300.33,300.33,0,0,0,70,114.73C49,83.85,43.81,59.09,51.45,51.45Zm0,153.1C43.81,196.91,49,172.15,70,141.27a300.33,300.33,0,0,0,21.19,23.57A304.18,304.18,0,0,0,114.73,186C83.85,207,59.09,212.2,51.45,204.55Zm153.1,0c-7.64,7.65-32.4,2.48-63.28-18.52a304.18,304.18,0,0,0,23.57-21.19A300.33,300.33,0,0,0,186,141.27C207,172.15,212.19,196.91,204.55,204.55ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.12,128c24.65-34.61,37.22-70.38,19.74-87.86S162.61,35.23,128,59.88C93.39,35.23,57.62,22.66,40.14,40.14S35.23,93.39,59.88,128c-24.65,34.61-37.22,70.38-19.74,87.86h0c5.63,5.63,13.15,8.14,21.91,8.14,18.47,0,42.48-11.17,66-27.88C151.47,212.83,175.47,224,194,224c8.76,0,16.29-2.52,21.91-8.14h0C233.34,198.38,220.77,162.61,196.12,128Zm8.43-76.55c7.64,7.64,2.48,32.4-18.52,63.28a300.33,300.33,0,0,0-21.19-23.57A302.47,302.47,0,0,0,141.27,70C172.15,49,196.91,43.81,204.55,51.45Zm-153.1,0c2.2-2.21,5.83-3.35,10.62-3.35C73.89,48.1,92.76,55,114.72,70A304,304,0,0,0,91.16,91.16,300.33,300.33,0,0,0,70,114.73C49,83.85,43.81,59.09,51.45,51.45Zm0,153.1C43.81,196.91,49,172.15,70,141.27a300.33,300.33,0,0,0,21.19,23.57A304.18,304.18,0,0,0,114.73,186C83.85,207,59.09,212.19,51.45,204.55ZM128,140a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm76.55,64.56c-7.64,7.65-32.4,2.48-63.28-18.52a304.18,304.18,0,0,0,23.57-21.19A300.33,300.33,0,0,0,186,141.27C207,172.15,212.19,196.91,204.55,204.55Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M193.83,128a195.73,195.73,0,0,0,19.9-33.65c10.74-23.88,11-42.66.8-52.88s-29-9.94-52.88.8A195.73,195.73,0,0,0,128,62.17a195.73,195.73,0,0,0-33.65-19.9c-23.88-10.74-42.66-11-52.88-.8s-9.94,29,.8,52.88A195.73,195.73,0,0,0,62.17,128a195.73,195.73,0,0,0-19.9,33.65c-10.74,23.88-11,42.66-.8,52.88h0c5,5,12,7.47,20.63,7.47,9.1,0,20-2.76,32.25-8.27A195.73,195.73,0,0,0,128,193.83a195.73,195.73,0,0,0,33.65,19.9C173.9,219.24,184.8,222,193.9,222c8.64,0,15.65-2.49,20.63-7.47h0c10.23-10.22,9.94-29-.8-52.88A195.73,195.73,0,0,0,193.83,128ZM206,50c9.28,9.28,2.36,36.29-19.8,68a306.2,306.2,0,0,0-22.78-25.45A306.2,306.2,0,0,0,138,69.76C169.75,47.61,196.77,40.68,206,50Zm-27.19,78A289.17,289.17,0,0,1,155,155a289.17,289.17,0,0,1-27,23.88A289.17,289.17,0,0,1,101,155a290.62,290.62,0,0,1-23.88-27A297.06,297.06,0,0,1,128,77.14,290.74,290.74,0,0,1,155,101,289.17,289.17,0,0,1,178.85,128ZM50,50c2.68-2.69,6.84-4,12.17-4,13.11,0,33.3,8,55.87,23.81A302.94,302.94,0,0,0,92.54,92.54,306.2,306.2,0,0,0,69.76,118C47.6,86.25,40.68,59.24,50,50ZM50,206h0c-9.28-9.28-2.35-36.29,19.8-68a306.2,306.2,0,0,0,22.78,25.45A306.2,306.2,0,0,0,118,186.24C86.25,208.4,59.24,215.32,50,206ZM206,206c-9.28,9.28-36.29,2.35-68-19.81a304.26,304.26,0,0,0,25.45-22.77A306.2,306.2,0,0,0,186.24,138C208.4,169.75,215.32,196.76,206,206Zm-68-78a10,10,0,1,1-10-10A10,10,0,0,1,138,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.12,128c24.65-34.61,37.22-70.38,19.74-87.86S162.61,35.23,128,59.88C93.39,35.23,57.62,22.66,40.14,40.14S35.23,93.39,59.88,128c-24.65,34.61-37.22,70.38-19.74,87.86h0c5.63,5.63,13.15,8.14,21.91,8.14,18.48,0,42.48-11.17,66-27.88C151.47,212.83,175.47,224,194,224c8.76,0,16.29-2.52,21.91-8.14h0C233.34,198.38,220.77,162.61,196.12,128Zm8.43-76.55c7.64,7.64,2.48,32.4-18.52,63.28a300.33,300.33,0,0,0-21.19-23.57A300.33,300.33,0,0,0,141.27,70C172.15,49,196.91,43.8,204.55,51.45ZM176.29,128a289.14,289.14,0,0,1-22.76,25.53A289.14,289.14,0,0,1,128,176.29a289.14,289.14,0,0,1-25.53-22.76A289.14,289.14,0,0,1,79.71,128,298.62,298.62,0,0,1,128,79.71a289.14,289.14,0,0,1,25.53,22.76A289.14,289.14,0,0,1,176.29,128ZM51.45,51.45c2.2-2.21,5.83-3.35,10.62-3.35C73.89,48.1,92.76,55,114.72,70A304,304,0,0,0,91.16,91.16,300.33,300.33,0,0,0,70,114.73C49,83.85,43.81,59.09,51.45,51.45Zm0,153.1C43.81,196.91,49,172.15,70,141.27a300.33,300.33,0,0,0,21.19,23.57A304.18,304.18,0,0,0,114.73,186C83.85,207,59.09,212.2,51.45,204.55Zm153.1,0c-7.64,7.65-32.4,2.48-63.28-18.52a304.18,304.18,0,0,0,23.57-21.19A300.33,300.33,0,0,0,186,141.27C207,172.15,212.19,196.91,204.55,204.55ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M211.89,162.47A195.58,195.58,0,0,0,191.36,128a195.58,195.58,0,0,0,20.53-34.47c10.38-23.06,10.81-41,1.21-50.63s-27.57-9.17-50.63,1.21A195.58,195.58,0,0,0,128,64.64,195.58,195.58,0,0,0,93.53,44.11C70.47,33.73,52.49,33.3,42.9,42.9s-9.17,27.57,1.21,50.63A195.58,195.58,0,0,0,64.64,128a195.58,195.58,0,0,0-20.53,34.47c-10.38,23.06-10.81,41-1.21,50.63h0C47.5,217.7,54,220,62.12,220c8.78,0,19.41-2.71,31.41-8.11A195.58,195.58,0,0,0,128,191.36a195.58,195.58,0,0,0,34.47,20.53c12,5.4,22.63,8.11,31.41,8.11,8.09,0,14.62-2.3,19.22-6.9h0C222.7,203.51,222.27,185.53,211.89,162.47ZM207.45,48.55c10.27,10.28,3.14,39.05-21.1,72.84A301,301,0,0,0,162,94a301,301,0,0,0-27.43-24.31C168.4,45.4,197.17,38.27,207.45,48.55Zm-26,79.45a293.16,293.16,0,0,1-25,28.38,291.82,291.82,0,0,1-28.38,25,291.82,291.82,0,0,1-28.38-25,293.16,293.16,0,0,1-25-28.38A302.36,302.36,0,0,1,128,74.58a295.83,295.83,0,0,1,28.37,25A293.16,293.16,0,0,1,181.41,128ZM48.55,48.55c3.05-3,7.71-4.55,13.64-4.55,14.11,0,35.41,8.59,59.19,25.65a304.89,304.89,0,0,0-51.73,51.74C45.41,87.6,38.28,58.83,48.55,48.55Zm0,158.9c-10.27-10.28-3.14-39,21.1-72.84A301,301,0,0,0,94,162a301,301,0,0,0,27.43,24.31C87.6,210.59,58.83,217.72,48.55,207.45Zm158.9,0c-10.28,10.27-39,3.14-72.84-21.1A301,301,0,0,0,162,162a301,301,0,0,0,24.31-27.43C210.59,168.4,217.72,197.17,207.45,207.45ZM136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Z"
        }))
    ]
]);


const $f8d2c170e0262ea2$export$c4a25ec2a3f59ed3 = $7fPBF.forwardRef((m, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, m), {
        weights: (0, $f6cae62af08afbdc$export$2e2bcd8739ae039)
    })));
$f8d2c170e0262ea2$export$c4a25ec2a3f59ed3.displayName = "AtomIcon";
const $f8d2c170e0262ea2$export$80986e6afdd7e0cb = $f8d2c170e0262ea2$export$c4a25ec2a3f59ed3;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $69e3a2c3922c842b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.29,165.93C216.61,151,212,129.57,212,104a84,84,0,0,0-168,0c0,25.58-4.59,47-13.27,61.93A20.08,20.08,0,0,0,30.66,186,19.77,19.77,0,0,0,48,196H84.18a44,44,0,0,0,87.64,0H208a19.77,19.77,0,0,0,17.31-10A20.08,20.08,0,0,0,225.29,165.93ZM128,212a20,20,0,0,1-19.6-16h39.2A20,20,0,0,1,128,212ZM54.66,172C63.51,154,68,131.14,68,104a60,60,0,0,1,120,0c0,27.13,4.48,50,13.33,68Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,192H48a8,8,0,0,1-6.88-12C47.71,168.6,56,139.81,56,104a72,72,0,0,1,144,0c0,35.82,8.3,64.6,14.9,76A8,8,0,0,1,208,192Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.07,176.94C214.41,167.2,206,139.73,206,104a78,78,0,1,0-156,0c0,35.74-8.42,63.2-14.08,72.94A14,14,0,0,0,48,198H90.48a38,38,0,0,0,75,0H208a14,14,0,0,0,12.06-21.06ZM128,218a26,26,0,0,1-25.29-20h50.58A26,26,0,0,1,128,218Zm81.71-33a1.9,1.9,0,0,1-1.7,1H48a1.9,1.9,0,0,1-1.7-1,2,2,0,0,1,0-2C53.87,170,62,139.69,62,104a66,66,0,1,1,132,0c0,35.68,8.14,65.95,15.71,79A2,2,0,0,1,209.71,185Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M218.35,178C212.58,168,204,140.13,204,104a76,76,0,1,0-152,0c0,36.13-8.59,64-14.36,73.95A12,12,0,0,0,48,196H92.23a36,36,0,0,0,71.54,0H208A12,12,0,0,0,218.35,178ZM128,220a28,28,0,0,1-27.71-24h55.42A28,28,0,0,1,128,220Zm83.45-34a3.91,3.91,0,0,1-3.44,2H48a3.91,3.91,0,0,1-3.44-2,4,4,0,0,1,0-4C52,169.17,60,139.32,60,104a68,68,0,1,1,136,0c0,35.31,8,65.17,15.44,78A4,4,0,0,1,211.45,186Z"
        }))
    ]
]);


const $19062bd64dded0d3$export$2235404cc2cfe93c = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $69e3a2c3922c842b$export$2e2bcd8739ae039)
    })));
$19062bd64dded0d3$export$2235404cc2cfe93c.displayName = "BellIcon";
const $19062bd64dded0d3$export$84dc348f90a995ec = $19062bd64dded0d3$export$2235404cc2cfe93c;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $4cce3d1130cf8b91$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.29,165.93C216.61,151,212,129.57,212,104a84,84,0,0,0-168,0c0,25.58-4.59,47-13.27,61.93A20.08,20.08,0,0,0,30.66,186,19.77,19.77,0,0,0,48,196H208a19.77,19.77,0,0,0,17.31-10A20.08,20.08,0,0,0,225.29,165.93ZM54.66,172C63.51,154,68,131.14,68,104a60,60,0,0,1,120,0c0,27.13,4.48,50,13.33,68ZM172,224a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,224Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,192H48a8,8,0,0,1-6.88-12C47.71,168.6,56,139.81,56,104a72,72,0,0,1,144,0c0,35.82,8.3,64.6,14.9,76A8,8,0,0,1,208,192Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.85-32A15.8,15.8,0,0,1,208,200H48a16,16,0,0,1-13.8-24.06C39.75,166.38,48,139.34,48,104a80,80,0,1,1,160,0c0,35.33,8.26,62.38,13.81,71.94A15.89,15.89,0,0,1,221.84,192ZM208,184c-7.73-13.27-16-43.95-16-80a64,64,0,1,0-128,0c0,36.06-8.28,66.74-16,80Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.81-48.06C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H208a16,16,0,0,0,13.8-24.06Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,224a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,224Zm54.11-33a13.83,13.83,0,0,1-12.1,7H48a14,14,0,0,1-12.06-21.06C41.59,167.2,50,139.74,50,104a78,78,0,1,1,156,0c0,35.73,8.42,63.2,14.08,72.94A13.9,13.9,0,0,1,220.11,191Zm-10.41-8C202.13,170,194,139.68,194,104a66,66,0,1,0-132,0c0,35.69-8.14,66-15.71,79a2,2,0,0,0,0,2,1.9,1.9,0,0,0,1.7,1H208a1.9,1.9,0,0,0,1.7-1A2,2,0,0,0,209.7,183Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.85-32A15.8,15.8,0,0,1,208,200H48a16,16,0,0,1-13.8-24.06C39.75,166.38,48,139.34,48,104a80,80,0,1,1,160,0c0,35.33,8.26,62.38,13.81,71.94A15.89,15.89,0,0,1,221.84,192ZM208,184c-7.73-13.27-16-43.95-16-80a64,64,0,1,0-128,0c0,36.06-8.28,66.74-16,80Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,224a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,224Zm54.38-34A11.84,11.84,0,0,1,208,196H48A12,12,0,0,1,37.65,178C43.42,168,52,140.13,52,104a76,76,0,1,1,152,0c0,36.13,8.59,64,14.36,73.95A11.92,11.92,0,0,1,218.38,190Zm-6.95-8C204,169.17,196,139.31,196,104a68,68,0,1,0-136,0c0,35.32-8,65.17-15.44,78a4,4,0,0,0,0,4A3.91,3.91,0,0,0,48,188H208a3.91,3.91,0,0,0,3.44-2A4,4,0,0,0,211.43,182Z"
        }))
    ]
]);


const $59680ec94e4e297e$export$d7b686e8afc4bc7e = $7fPBF.forwardRef((l, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: m
    }, l), {
        weights: (0, $4cce3d1130cf8b91$export$2e2bcd8739ae039)
    })));
$59680ec94e4e297e$export$d7b686e8afc4bc7e.displayName = "BellSimpleIcon";
const $59680ec94e4e297e$export$6f47cc5865c763be = $59680ec94e4e297e$export$d7b686e8afc4bc7e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6091c3ffa0dc6a23$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M199.2,166.4,148,128l51.2-38.4a12,12,0,0,0,0-19.2l-64-48A12,12,0,0,0,116,32v72L71.2,70.4A12,12,0,0,0,56.8,89.6L108,128,56.8,166.4a12,12,0,1,0,14.4,19.2L116,152v72a12,12,0,0,0,19.2,9.6l64-48a12,12,0,0,0,0-19.2ZM140,56l32,24-32,24Zm0,144V152l32,24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,80l-64,48V32ZM128,224l64-48-64-48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.8,169.6,141.33,128,196.8,86.4a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,120,32v80L68.8,73.6a8,8,0,0,0-9.6,12.8L114.67,128,59.2,169.6a8,8,0,1,0,9.6,12.8L120,144v80a8,8,0,0,0,12.8,6.4l64-48a8,8,0,0,0,0-12.8ZM136,48l42.67,32L136,112Zm0,160V144l42.67,32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,176a8,8,0,0,1-3.2,6.4l-64,48A8,8,0,0,1,128,232a8,8,0,0,1-8-8V144L68.8,182.4a8,8,0,0,1-9.6-12.8L114.67,128,59.2,86.4a8,8,0,0,1,9.6-12.8L120,112V32a8,8,0,0,1,12.8-6.4l64,48a8,8,0,0,1,0,12.8L141.33,128l55.47,41.6A8,8,0,0,1,200,176Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M195.6,171.2,138,128l57.6-43.2a6,6,0,0,0,0-9.6l-64-48A6,6,0,0,0,122,32v84L67.6,75.2a6,6,0,0,0-7.2,9.6L118,128,60.4,171.2a6,6,0,1,0,7.2,9.6L122,140v84a6,6,0,0,0,9.6,4.8l64-48a6,6,0,0,0,0-9.6ZM134,44l48,36-48,36Zm0,168V140l48,36Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.8,169.6,141.33,128,196.8,86.4a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,120,32v80L68.8,73.6a8,8,0,0,0-9.6,12.8L114.67,128,59.2,169.6a8,8,0,1,0,9.6,12.8L120,144v80a8,8,0,0,0,12.8,6.4l64-48a8,8,0,0,0,0-12.8ZM136,48l42.67,32L136,112Zm0,160V144l42.67,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M194.4,172.8,134.67,128,194.4,83.2a4,4,0,0,0,0-6.4l-64-48A4,4,0,0,0,124,32v88L66.4,76.8a4,4,0,0,0-4.8,6.4L121.33,128,61.6,172.8a4,4,0,0,0,4.8,6.4L124,136v88a4,4,0,0,0,6.4,3.2l64-48a4,4,0,0,0,0-6.4ZM132,40l53.33,40L132,120Zm0,176V136l53.33,40Z"
        }))
    ]
]);


const $0589edc71e767746$export$263c50ea203500d6 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $6091c3ffa0dc6a23$export$2e2bcd8739ae039)
    })));
$0589edc71e767746$export$263c50ea203500d6.displayName = "BluetoothIcon";
const $0589edc71e767746$export$3f015ab66c3e5653 = $0589edc71e767746$export$263c50ea203500d6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c277c708123709f8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,160a12,12,0,0,0,0-24H212V120h12a12,12,0,0,0,0-24H210.45a83.7,83.7,0,0,0-18.78-38.7l16.82-16.81a12,12,0,1,0-17-17l-18,18a83.7,83.7,0,0,0-91.1,0l-18-18a12,12,0,0,0-17,17L64.33,57.3A83.7,83.7,0,0,0,45.55,96H32a12,12,0,0,0,0,24H44v16H32a12,12,0,0,0,0,24H44a83.55,83.55,0,0,0,1.55,16H32a12,12,0,0,0,0,24H54.15a84,84,0,0,0,147.7,0H224a12,12,0,0,0,0-24H210.45A83.55,83.55,0,0,0,212,160ZM128,52a60.1,60.1,0,0,1,57.82,44H70.18A60.1,60.1,0,0,1,128,52Zm12,166.79V148a12,12,0,0,0-24,0v70.79A60.09,60.09,0,0,1,68,160V120H188v40A60.09,60.09,0,0,1,140,218.79Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,112v48a72,72,0,0,1-72,72h0a72,72,0,0,1-72-72V112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,152h16a8,8,0,0,0,0-16H208V120h16a8,8,0,0,0,0-16H207.6a79.76,79.76,0,0,0-21.44-46.85l19.5-19.49a8,8,0,0,0-11.32-11.32l-20.29,20.3a79.74,79.74,0,0,0-92.1,0L61.66,26.34A8,8,0,0,0,50.34,37.66l19.5,19.49A79.76,79.76,0,0,0,48.4,104H32a8,8,0,0,0,0,16H48v16H32a8,8,0,0,0,0,16H48v8c0,2.7.14,5.37.4,8H32a8,8,0,0,0,0,16H51.68a80,80,0,0,0,152.64,0H224a8,8,0,0,0,0-16H207.6c.26-2.63.4-5.3.4-8ZM128,48a64.07,64.07,0,0,1,63.48,56h-127A64.07,64.07,0,0,1,128,48Zm8,175.48V144a8,8,0,0,0-16,0v79.48A64.07,64.07,0,0,1,64,160V120H192v40A64.07,64.07,0,0,1,136,223.48Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,120H208V104h16a8,8,0,0,1,0,16ZM32,104a8,8,0,0,0,0,16H48V104Zm176,56c0,2.7-.14,5.37-.4,8H224a8,8,0,0,1,0,16H204.32a80,80,0,0,1-152.64,0H32a8,8,0,0,1,0-16H48.4c-.26-2.63-.4-5.3-.4-8v-8H32a8,8,0,0,1,0-16H48V120H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0ZM69.84,57.15A79.76,79.76,0,0,0,48.4,104H207.6a79.76,79.76,0,0,0-21.44-46.85l19.5-19.49a8,8,0,0,0-11.32-11.32l-20.29,20.3a79.74,79.74,0,0,0-92.1,0L61.66,26.34A8,8,0,0,0,50.34,37.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M206,150h18a6,6,0,0,0,0-12H206V118h18a6,6,0,0,0,0-12H205.75a77.81,77.81,0,0,0-22.38-48.88l20.87-20.88a6,6,0,1,0-8.48-8.48L174.27,49.25a77.8,77.8,0,0,0-92.53,0L60.24,27.76a6,6,0,0,0-8.48,8.48L72.64,57.12A77.76,77.76,0,0,0,50.25,106H32a6,6,0,0,0,0,12H50v20H32a6,6,0,0,0,0,12H50v10a78.6,78.6,0,0,0,.66,10H32a6,6,0,0,0,0,12H53.18a78,78,0,0,0,149.64,0H224a6,6,0,0,0,0-12H205.34a78.6,78.6,0,0,0,.66-10ZM128,46a66.07,66.07,0,0,1,65.71,60H62.29A66.07,66.07,0,0,1,128,46Zm6,179.71V144a6,6,0,0,0-12,0v81.71A66.07,66.07,0,0,1,62,160V118H194v42A66.07,66.07,0,0,1,134,225.71Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,152h16a8,8,0,0,0,0-16H208V120h16a8,8,0,0,0,0-16H207.6a79.76,79.76,0,0,0-21.44-46.85l19.5-19.49a8,8,0,0,0-11.32-11.32l-20.29,20.3a79.74,79.74,0,0,0-92.1,0L61.66,26.34A8,8,0,0,0,50.34,37.66l19.5,19.49A79.76,79.76,0,0,0,48.4,104H32a8,8,0,0,0,0,16H48v16H32a8,8,0,0,0,0,16H48v8c0,2.7.14,5.37.4,8H32a8,8,0,0,0,0,16H51.68a80,80,0,0,0,152.64,0H224a8,8,0,0,0,0-16H207.6c.26-2.63.4-5.3.4-8ZM128,48a64.07,64.07,0,0,1,63.48,56h-127A64.07,64.07,0,0,1,128,48Zm8,175.48V144a8,8,0,0,0-16,0v79.48A64.07,64.07,0,0,1,64,160V120H192v40A64.07,64.07,0,0,1,136,223.48Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204,148h20a4,4,0,0,0,0-8H204V116h20a4,4,0,0,0,0-8H203.89a75.8,75.8,0,0,0-23.37-50.86l22.31-22.31a4,4,0,1,0-5.66-5.66L174.44,51.9a75.77,75.77,0,0,0-92.88,0L58.83,29.17a4,4,0,0,0-5.66,5.66L75.48,57.14A75.8,75.8,0,0,0,52.11,108H32a4,4,0,0,0,0,8H52v24H32a4,4,0,0,0,0,8H52v12a75.41,75.41,0,0,0,1,12H32a4,4,0,0,0,0,8H54.69a76,76,0,0,0,146.62,0H224a4,4,0,0,0,0-8H203a75.41,75.41,0,0,0,1-12ZM128,44a68.08,68.08,0,0,1,67.87,64H60.13A68.08,68.08,0,0,1,128,44Zm4,183.87V144a4,4,0,0,0-8,0v83.87A68.08,68.08,0,0,1,60,160V116H196v44A68.08,68.08,0,0,1,132,227.87Z"
        }))
    ]
]);


const $c308ce43177e2521$export$3724a79860e51b2a = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, t), {
        weights: (0, $c277c708123709f8$export$2e2bcd8739ae039)
    })));
$c308ce43177e2521$export$3724a79860e51b2a.displayName = "BugBeetleIcon";
const $c308ce43177e2521$export$c8b6e8f31cd340e = $c308ce43177e2521$export$3724a79860e51b2a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $8425c6e39340bfa4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148,152a20,20,0,1,1-20-20A20,20,0,0,1,148,152ZM228,48V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28H68V24a12,12,0,0,1,24,0v4h72V24a12,12,0,0,1,24,0v4h20A20,20,0,0,1,228,48ZM52,52V76H204V52H188a12,12,0,0,1-24,0H92a12,12,0,0,1-24,0ZM204,204V100H52V204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-64-56a16,16,0,1,1-16-16A16,16,0,0,1,144,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,168a16,16,0,1,1,16-16A16,16,0,0,1,128,168Zm80-88H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H182V24a6,6,0,0,0-12,0V34H86V24a6,6,0,0,0-12,0V34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM48,46H74V56a6,6,0,0,0,12,0V46h84V56a6,6,0,0,0,12,0V46h26a2,2,0,0,1,2,2V82H46V48A2,2,0,0,1,48,46ZM208,210H48a2,2,0,0,1-2-2V94H210V208A2,2,0,0,1,208,210Zm-66-58a14,14,0,1,1-14-14A14,14,0,0,1,142,152Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-64-56a16,16,0,1,1-16-16A16,16,0,0,1,144,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4,4,0,0,1,4,4V84H44V48A4,4,0,0,1,48,44ZM208,212H48a4,4,0,0,1-4-4V92H212V208A4,4,0,0,1,208,212Zm-68-60a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z"
        }))
    ]
]);


const $aa0c2f4db5eff029$export$6a0cf186e5c8acd9 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $8425c6e39340bfa4$export$2e2bcd8739ae039)
    })));
$aa0c2f4db5eff029$export$6a0cf186e5c8acd9.displayName = "CalendarDotIcon";
const $aa0c2f4db5eff029$export$ec265c51c1bac016 = $aa0c2f4db5eff029$export$6a0cf186e5c8acd9;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9f87ebbf8e1049b8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H188V24a12,12,0,0,0-24,0v4H92V24a12,12,0,0,0-24,0v4H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM68,52a12,12,0,0,0,24,0h72a12,12,0,0,0,24,0h16V76H52V52ZM52,204V100H204V204Zm92-76a16,16,0,1,1-16-16A16,16,0,0,1,144,128Zm48,0a16,16,0,1,1-16-16A16,16,0,0,1,192,128ZM96,176a16,16,0,1,1-16-16A16,16,0,0,1,96,176Zm48,0a16,16,0,1,1-16-16A16,16,0,0,1,144,176Zm48,0a16,16,0,1,1-16-16A16,16,0,0,1,192,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-68-76a12,12,0,1,1-12-12A12,12,0,0,1,140,132Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,132ZM96,172a12,12,0,1,1-12-12A12,12,0,0,1,96,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,172Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM84,184a12,12,0,1,1,12-12A12,12,0,0,1,84,184Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,128,184Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,128,144Zm44,40a12,12,0,1,1,12-12A12,12,0,0,1,172,184Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,172,144Zm36-64H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H182V24a6,6,0,0,0-12,0V34H86V24a6,6,0,0,0-12,0V34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM48,46H74V56a6,6,0,0,0,12,0V46h84V56a6,6,0,0,0,12,0V46h26a2,2,0,0,1,2,2V82H46V48A2,2,0,0,1,48,46ZM208,210H48a2,2,0,0,1-2-2V94H210V208A2,2,0,0,1,208,210Zm-70-78a10,10,0,1,1-10-10A10,10,0,0,1,138,132Zm44,0a10,10,0,1,1-10-10A10,10,0,0,1,182,132ZM94,172a10,10,0,1,1-10-10A10,10,0,0,1,94,172Zm44,0a10,10,0,1,1-10-10A10,10,0,0,1,138,172Zm44,0a10,10,0,1,1-10-10A10,10,0,0,1,182,172Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-68-76a12,12,0,1,1-12-12A12,12,0,0,1,140,132Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,132ZM96,172a12,12,0,1,1-12-12A12,12,0,0,1,96,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,172Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4,4,0,0,1,4,4V84H44V48A4,4,0,0,1,48,44ZM208,212H48a4,4,0,0,1-4-4V92H212V208A4,4,0,0,1,208,212Zm-72-80a8,8,0,1,1-8-8A8,8,0,0,1,136,132Zm44,0a8,8,0,1,1-8-8A8,8,0,0,1,180,132ZM92,172a8,8,0,1,1-8-8A8,8,0,0,1,92,172Zm44,0a8,8,0,1,1-8-8A8,8,0,0,1,136,172Zm44,0a8,8,0,1,1-8-8A8,8,0,0,1,180,172Z"
        }))
    ]
]);


const $a85869910c19ec6f$export$282abcbd253822f3 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $9f87ebbf8e1049b8$export$2e2bcd8739ae039)
    })));
$a85869910c19ec6f$export$282abcbd253822f3.displayName = "CalendarDotsIcon";
const $a85869910c19ec6f$export$682d1f47b0a6d27f = $a85869910c19ec6f$export$282abcbd253822f3;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d7bd9c45db31d082$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H188V24a12,12,0,0,0-24,0v4H92V24a12,12,0,0,0-24,0v4H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM68,52a12,12,0,0,0,24,0h72a12,12,0,0,0,24,0h16V76H52V52ZM52,204V100H204V204Zm60-80v56a12,12,0,0,1-24,0V143.32a12,12,0,0,1-9.37-22l16-8A12,12,0,0,1,112,124Zm61.49,33.88L163.9,168H168a12,12,0,0,1,0,24H136a12,12,0,0,1-8.71-20.25L155.45,142a4,4,0,0,0,.55-2,4,4,0,0,0-7.47-2,12,12,0,0,1-20.78-12A28,28,0,0,1,180,140a27.77,27.77,0,0,1-5.64,16.86A10.63,10.63,0,0,1,173.49,157.88Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V88H40V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM112,184a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm56-8a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136a23.76,23.76,0,0,1-4.84,14.45L152,176ZM48,80V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H182V24a6,6,0,0,0-12,0V34H86V24a6,6,0,0,0-12,0V34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM48,46H74V56a6,6,0,0,0,12,0V46h84V56a6,6,0,0,0,12,0V46h26a2,2,0,0,1,2,2V82H46V48A2,2,0,0,1,48,46ZM208,210H48a2,2,0,0,1-2-2V94H210V208A2,2,0,0,1,208,210Zm-98-90v64a6,6,0,0,1-12,0V129.71l-7.32,3.66a6,6,0,1,1-5.36-10.74l16-8A6,6,0,0,1,110,120Zm59.57,29.25L148,178h20a6,6,0,0,1,0,12H136a6,6,0,0,1-4.8-9.6L160,142a10,10,0,1,0-16.65-11A6,6,0,1,1,133,125a22,22,0,1,1,36.62,24.26Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H180V24a4,4,0,0,0-8,0V36H84V24a4,4,0,0,0-8,0V36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM48,44H76V56a4,4,0,0,0,8,0V44h88V56a4,4,0,0,0,8,0V44h28a4,4,0,0,1,4,4V84H44V48A4,4,0,0,1,48,44ZM208,212H48a4,4,0,0,1-4-4V92H212V208A4,4,0,0,1,208,212ZM108,120v64a4,4,0,0,1-8,0V126.47l-10.21,5.11a4,4,0,0,1-3.58-7.16l16-8A4,4,0,0,1,108,120Zm60,28-24,32h24a4,4,0,0,1,0,8H136a4,4,0,0,1-3.2-6.4l28.78-38.37A11.88,11.88,0,0,0,164,136a12,12,0,0,0-22.4-6,4,4,0,0,1-6.92-4A20,20,0,0,1,172,136,19.79,19.79,0,0,1,168,148Z"
        }))
    ]
]);


const $8abaaeeab67664a2$export$5fda1783bb83f57b = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $d7bd9c45db31d082$export$2e2bcd8739ae039)
    })));
$8abaaeeab67664a2$export$5fda1783bb83f57b.displayName = "CalendarIcon";
const $8abaaeeab67664a2$export$e1aef45b828286de = $8abaaeeab67664a2$export$5fda1783bb83f57b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0e126998741e0efb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,52H182.42L170,33.34A12,12,0,0,0,160,28H96a12,12,0,0,0-10,5.34L73.57,52H48A28,28,0,0,0,20,80V192a28,28,0,0,0,28,28H208a28,28,0,0,0,28-28V80A28,28,0,0,0,208,52Zm4,140a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4H80a12,12,0,0,0,10-5.34L102.42,52h51.15L166,70.66A12,12,0,0,0,176,76h32a4,4,0,0,1,4,4Zm-32-92v20a12,12,0,0,1-12,12H148a12,12,0,0,1-7.76-21.14,28.07,28.07,0,0,0-29,2.73A12,12,0,0,1,96.79,94.4a52.28,52.28,0,0,1,61.14-.91A12,12,0,0,1,180,100Zm-18.41,52.8a12,12,0,0,1-2.38,16.8,51.71,51.71,0,0,1-31.13,10.34,52.3,52.3,0,0,1-30-9.44A12,12,0,0,1,76,164V144a12,12,0,0,1,12-12h20a12,12,0,0,1,7.76,21.14,28.07,28.07,0,0,0,29-2.73A12,12,0,0,1,161.59,152.8Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80V192a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32A16,16,0,0,1,224,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56H180.28L166.65,35.56A8,8,0,0,0,160,32H96a8,8,0,0,0-6.65,3.56L75.71,56H48A24,24,0,0,0,24,80V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V80A24,24,0,0,0,208,56Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H80a8,8,0,0,0,6.66-3.56L100.28,48h55.43l13.63,20.44A8,8,0,0,0,176,72h32a8,8,0,0,1,8,8ZM176,96v24a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h5.15a32.12,32.12,0,0,0-40.34-1.61A8,8,0,0,1,99.19,97.6,48.21,48.21,0,0,1,160,100.23V96a8,8,0,0,1,16,0Zm-17.61,59.2a8,8,0,0,1-1.58,11.2A48.21,48.21,0,0,1,96,163.77V168a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16h-5.15a32.12,32.12,0,0,0,40.34,1.61A8,8,0,0,1,158.39,155.2Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56H180.28L166.65,35.56A8,8,0,0,0,160,32H96a8,8,0,0,0-6.65,3.56L75.71,56H48A24,24,0,0,0,24,80V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V80A24,24,0,0,0,208,56ZM156.81,166.4A48.21,48.21,0,0,1,96,163.77V168a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16h-5.15a32.12,32.12,0,0,0,40.34,1.61,8,8,0,0,1,9.62,12.79ZM176,120a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h5.15a32.12,32.12,0,0,0-40.34-1.61A8,8,0,0,1,99.19,97.6,48.21,48.21,0,0,1,160,100.23V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,58H179.21L165,36.67A6,6,0,0,0,160,34H96a6,6,0,0,0-5,2.67L76.78,58H48A22,22,0,0,0,26,80V192a22,22,0,0,0,22,22H208a22,22,0,0,0,22-22V80A22,22,0,0,0,208,58Zm10,134a10,10,0,0,1-10,10H48a10,10,0,0,1-10-10V80A10,10,0,0,1,48,70H80a6,6,0,0,0,5-2.67L99.21,46h57.57L171,67.33A6,6,0,0,0,176,70h32a10,10,0,0,1,10,10ZM174,96v24a6,6,0,0,1-6,6H144a6,6,0,0,1,0-12h10l-2-2.09a34.12,34.12,0,0,0-44.38-3.12,6,6,0,1,1-7.22-9.59,46.2,46.2,0,0,1,60.14,4.27.47.47,0,0,0,.1.1L162,105V96a6,6,0,0,1,12,0Zm-17.2,60.4a6,6,0,0,1-1.19,8.4,46.18,46.18,0,0,1-60.14-4.27l-.1-.1L94,159v9a6,6,0,0,1-12,0V144a6,6,0,0,1,6-6h24a6,6,0,0,1,0,12H102l2,2.09a34.12,34.12,0,0,0,44.38,3.12A6,6,0,0,1,156.8,156.4Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56H180.28L166.65,35.56A8,8,0,0,0,160,32H96a8,8,0,0,0-6.65,3.56L75.71,56H48A24,24,0,0,0,24,80V192a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V80A24,24,0,0,0,208,56Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H80a8,8,0,0,0,6.66-3.56L100.28,48h55.43l13.63,20.44A8,8,0,0,0,176,72h32a8,8,0,0,1,8,8ZM176,96v24a8,8,0,0,1-8,8H144a8,8,0,0,1,0-16h5.15a32.12,32.12,0,0,0-40.34-1.61A8,8,0,0,1,99.19,97.6,48.21,48.21,0,0,1,160,100.23V96a8,8,0,0,1,16,0Zm-17.61,59.2a8,8,0,0,1-1.58,11.2A48.21,48.21,0,0,1,96,163.77V168a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16h-5.15a32.12,32.12,0,0,0,40.34,1.61A8,8,0,0,1,158.39,155.2Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,60H178.13L163.32,37.78A4,4,0,0,0,160,36H96a4,4,0,0,0-3.32,1.78L77.85,60H48A20,20,0,0,0,28,80V192a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V80A20,20,0,0,0,208,60Zm12,132a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V80A12,12,0,0,1,48,68H80a4,4,0,0,0,3.33-1.78L98.13,44h59.72l14.82,22.22A4,4,0,0,0,176,68h32a12,12,0,0,1,12,12ZM172,96v24a4,4,0,0,1-4,4H144a4,4,0,0,1,0-8h14.66l-5.27-5.52a36.12,36.12,0,0,0-47-3.29,4,4,0,1,1-4.8-6.39,44.17,44.17,0,0,1,57.51,4.09L164,110V96a4,4,0,0,1,8,0Zm-16.8,61.6a4,4,0,0,1-.8,5.6,44.15,44.15,0,0,1-57.51-4.09L92,154v14a4,4,0,0,1-8,0V144a4,4,0,0,1,4-4h24a4,4,0,0,1,0,8H97.34l5.27,5.52a36.12,36.12,0,0,0,47,3.29A4,4,0,0,1,155.2,157.6Z"
        }))
    ]
]);


const $940356a37dfbb440$export$7b925291abba066b = $7fPBF.forwardRef((o, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, o), {
        weights: (0, $0e126998741e0efb$export$2e2bcd8739ae039)
    })));
$940356a37dfbb440$export$7b925291abba066b.displayName = "CameraRotateIcon";
const $940356a37dfbb440$export$4bbb8c37660b6717 = $940356a37dfbb440$export$7b925291abba066b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $2643605d26f5be01$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,96H48a20,20,0,0,0-20,20v84a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V116A20,20,0,0,0,208,96Zm-4,100H52V120H204ZM44,68A12,12,0,0,1,56,56H200a12,12,0,0,1,0,24H56A12,12,0,0,1,44,68ZM60,28A12,12,0,0,1,72,16H184a12,12,0,0,1,0,24H72A12,12,0,0,1,60,28Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,104v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H208A8,8,0,0,1,216,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H48a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,112H48V104H208v96ZM48,64a8,8,0,0,1,8-8H200a8,8,0,0,1,0,16H56A8,8,0,0,1,48,64ZM64,32a8,8,0,0,1,8-8H184a8,8,0,0,1,0,16H72A8,8,0,0,1,64,32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104v96a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V104A16,16,0,0,1,48,88H208A16,16,0,0,1,224,104ZM56,72H200a8,8,0,0,0,0-16H56a8,8,0,0,0,0,16ZM72,40H184a8,8,0,0,0,0-16H72a8,8,0,0,0,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,90H48a14,14,0,0,0-14,14v96a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V104A14,14,0,0,0,208,90Zm2,110a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V104a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2ZM50,64a6,6,0,0,1,6-6H200a6,6,0,0,1,0,12H56A6,6,0,0,1,50,64ZM66,32a6,6,0,0,1,6-6H184a6,6,0,0,1,0,12H72A6,6,0,0,1,66,32Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H48a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,112H48V104H208v96ZM48,64a8,8,0,0,1,8-8H200a8,8,0,0,1,0,16H56A8,8,0,0,1,48,64ZM64,32a8,8,0,0,1,8-8H184a8,8,0,0,1,0,16H72A8,8,0,0,1,64,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,92H48a12,12,0,0,0-12,12v96a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V104A12,12,0,0,0,208,92Zm4,108a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V104a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4ZM52,64a4,4,0,0,1,4-4H200a4,4,0,0,1,0,8H56A4,4,0,0,1,52,64ZM68,32a4,4,0,0,1,4-4H184a4,4,0,0,1,0,8H72A4,4,0,0,1,68,32Z"
        }))
    ]
]);


const $bbcdd9ecba689979$export$2bc1d0180119f574 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, o), {
        weights: (0, $2643605d26f5be01$export$2e2bcd8739ae039)
    })));
$bbcdd9ecba689979$export$2bc1d0180119f574.displayName = "CardsThreeIcon";
const $bbcdd9ecba689979$export$13d1513b60ca1919 = $bbcdd9ecba689979$export$2bc1d0180119f574;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $43b3b75f290c6bfc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,96l-80,80L48,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z"
        }))
    ]
]);


const $8d78174bfef35f91$export$73a4c78a4a00962 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $43b3b75f290c6bfc$export$2e2bcd8739ae039)
    })));
$8d78174bfef35f91$export$73a4c78a4a00962.displayName = "CaretDownIcon";
const $8d78174bfef35f91$export$14643e45770079c3 = $8d78174bfef35f91$export$73a4c78a4a00962;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $90708e3e8c4a10f7$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,48V208L80,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z"
        }))
    ]
]);


const $2fa01b25bab55864$export$810196a5854768f3 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $90708e3e8c4a10f7$export$2e2bcd8739ae039)
    })));
$2fa01b25bab55864$export$810196a5854768f3.displayName = "CaretLeftIcon";
const $2fa01b25bab55864$export$9de62fa342934f27 = $2fa01b25bab55864$export$810196a5854768f3;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $749a178e5963403e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152.49,119.51a12,12,0,0,1,0,17l-80,80a12,12,0,0,1-17-17L127,128,55.51,56.49a12,12,0,0,1,17-17ZM184,36a12,12,0,0,0-12,12V208a12,12,0,0,0,24,0V48A12,12,0,0,0,184,36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,128,64,208V48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M69.66,42.34A8,8,0,0,0,56,48V208a8,8,0,0,0,13.66,5.66l80-80a8,8,0,0,0,0-11.32ZM72,188.69V67.31L132.69,128ZM192,48V208a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,122.34a8,8,0,0,1,0,11.32l-80,80A8,8,0,0,1,56,208V48a8,8,0,0,1,13.66-5.66ZM184,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,184,40Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148.24,123.76a6,6,0,0,1,0,8.48l-80,80a6,6,0,0,1-8.48-8.48L135.51,128,59.76,52.24a6,6,0,0,1,8.48-8.48ZM184,42a6,6,0,0,0-6,6V208a6,6,0,0,0,12,0V48A6,6,0,0,0,184,42Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,122.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32-11.32L132.69,128,58.34,53.66A8,8,0,0,1,69.66,42.34ZM184,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,184,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.83,125.17a4,4,0,0,1,0,5.66l-80,80a4,4,0,0,1-5.66-5.66L138.34,128,61.17,50.83a4,4,0,0,1,5.66-5.66ZM184,44a4,4,0,0,0-4,4V208a4,4,0,0,0,8,0V48A4,4,0,0,0,184,44Z"
        }))
    ]
]);


const $26629d2c54ba0e90$export$2e28bad6de91f83d = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $749a178e5963403e$export$2e2bcd8739ae039)
    })));
$26629d2c54ba0e90$export$2e28bad6de91f83d.displayName = "CaretLineRightIcon";
const $26629d2c54ba0e90$export$ca4804c692a5f0a5 = $26629d2c54ba0e90$export$2e28bad6de91f83d;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6d3de71f942312b8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,128,96,208V48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z"
        }))
    ]
]);


const $cf227e7e52862ade$export$5e4a7579d3e78657 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $6d3de71f942312b8$export$2e2bcd8739ae039)
    })));
$cf227e7e52862ade$export$5e4a7579d3e78657.displayName = "CaretRightIcon";
const $cf227e7e52862ade$export$98ac0f496a0846de = $cf227e7e52862ade$export$5e4a7579d3e78657;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $71bf1e9ef2637518$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,160H48l80-80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z"
        }))
    ]
]);


const $f193c00afed960f7$export$7d1b8b90f61377d1 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $71bf1e9ef2637518$export$2e2bcd8739ae039)
    })));
$f193c00afed960f7$export$7d1b8b90f61377d1.displayName = "CaretUpIcon";
const $f193c00afed960f7$export$b67edd7bdacb81b5 = $f193c00afed960f7$export$7d1b8b90f61377d1;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cb65ce36cf0f87ae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,196h-4V40a12,12,0,0,0-12-12H152a12,12,0,0,0-12,12V76H96A12,12,0,0,0,84,88v36H48a12,12,0,0,0-12,12v60H32a12,12,0,0,0,0,24H224a12,12,0,0,0,0-24ZM164,52h32V196H164Zm-56,48h32v96H108ZM60,148H84v48H60Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40V208H152V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16h8V136a8,8,0,0,1,8-8H72a8,8,0,0,1,8,8v64H96V88a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8V200h16V40a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8V200h8A8,8,0,0,1,232,208Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,202H214V40a6,6,0,0,0-6-6H152a6,6,0,0,0-6,6V82H96a6,6,0,0,0-6,6v42H48a6,6,0,0,0-6,6v66H32a6,6,0,0,0,0,12H224a6,6,0,0,0,0-12ZM158,46h44V202H158ZM102,94h44V202H102ZM54,142H90v60H54Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,204H212V40a4,4,0,0,0-4-4H152a4,4,0,0,0-4,4V84H96a4,4,0,0,0-4,4v44H48a4,4,0,0,0-4,4v68H32a4,4,0,0,0,0,8H224a4,4,0,0,0,0-8ZM156,44h48V204H156ZM100,92h48V204H100ZM52,140H92v64H52Z"
        }))
    ]
]);


const $352ea393a631b359$export$9da4f9d7ed027300 = $7fPBF.forwardRef((o, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, o), {
        weights: (0, $cb65ce36cf0f87ae$export$2e2bcd8739ae039)
    })));
$352ea393a631b359$export$9da4f9d7ed027300.displayName = "ChartBarIcon";
const $352ea393a631b359$export$315c6d0a25056c5d = $352ea393a631b359$export$9da4f9d7ed027300;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $09c48903b64b5253$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,0,0,31.85,177.23L21,209.66A20,20,0,0,0,46.34,235l32.43-10.81A108,108,0,1,0,128,20Zm0,192a84,84,0,0,1-42.06-11.27,12,12,0,0,0-6-1.62,12.1,12.1,0,0,0-3.8.62l-29.79,9.93,9.93-29.79a12,12,0,0,0-1-9.81A84,84,0,1,1,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128A96,96,0,0,1,79.93,211.11h0L42.54,223.58a8,8,0,0,1-10.12-10.12l12.47-37.39h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,0,0,38.35,176.69L26.73,211.56a14,14,0,0,0,17.71,17.71l34.87-11.62A102,102,0,1,0,128,26Zm0,192a90,90,0,0,1-45.06-12.08,6.09,6.09,0,0,0-3-.81,6.2,6.2,0,0,0-1.9.31L40.65,217.88a2,2,0,0,1-2.53-2.53L50.58,178a6,6,0,0,0-.5-4.91A90,90,0,1,1,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,0,0,40.53,176.5l-11.9,35.69a12,12,0,0,0,15.18,15.18l35.69-11.9A100,100,0,1,0,128,28Zm0,192a92,92,0,0,1-46.07-12.35,4.05,4.05,0,0,0-2-.54,3.93,3.93,0,0,0-1.27.21L41.28,219.78a4,4,0,0,1-5.06-5.06l12.46-37.38a4,4,0,0,0-.33-3.27A92,92,0,1,1,128,220Z"
        }))
    ]
]);


const $ffea4d92108488a3$export$9a3f119425fb8c38 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $09c48903b64b5253$export$2e2bcd8739ae039)
    })));
$ffea4d92108488a3$export$9a3f119425fb8c38.displayName = "ChatCircleIcon";
const $ffea4d92108488a3$export$462e72eb5fb8428c = $ffea4d92108488a3$export$9a3f119425fb8c38;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $510bd3db97d89352$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,128a16,16,0,1,1,16,16A16,16,0,0,1,88,128Zm64,16a16,16,0,1,0-16-16A16,16,0,0,0,152,144Zm84-80V192a20,20,0,0,1-20,20H84.47L53,239.17l-.12.11A19.91,19.91,0,0,1,40.05,244a20.14,20.14,0,0,1-8.49-1.9A19.82,19.82,0,0,1,20,224V64A20,20,0,0,1,40,44H216A20,20,0,0,1,236,64Zm-24,4H44V215.23l28.16-24.32A11.93,11.93,0,0,1,80,188H212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64V192a8,8,0,0,1-8,8H80L45.15,230.11A8,8,0,0,1,32,224V64a8,8,0,0,1,8-8H216A8,8,0,0,1,224,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,128a12,12,0,1,1,12,12A12,12,0,0,1,116,128ZM84,140a12,12,0,1,0-12-12A12,12,0,0,0,84,140Zm88,0a12,12,0,1,0-12-12A12,12,0,0,0,172,140Zm60-76V192a16,16,0,0,1-16,16H83l-32.6,28.16-.09.07A15.89,15.89,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48H216A16,16,0,0,1,232,64ZM40,224h0ZM216,64H40V224l34.77-30A8,8,0,0,1,80,192H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H40A16,16,0,0,0,24,64V224a15.84,15.84,0,0,0,9.25,14.5A16.05,16.05,0,0,0,40,240a15.89,15.89,0,0,0,10.25-3.78l.09-.07L83,208H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,172,140Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M138,128a10,10,0,1,1-10-10A10,10,0,0,1,138,128ZM84,118a10,10,0,1,0,10,10A10,10,0,0,0,84,118Zm88,0a10,10,0,1,0,10,10A10,10,0,0,0,172,118Zm58-54V192a14,14,0,0,1-14,14H82.23L49.07,234.64l-.06.05A13.87,13.87,0,0,1,40,238a14.11,14.11,0,0,1-5.95-1.33A13.88,13.88,0,0,1,26,224V64A14,14,0,0,1,40,50H216A14,14,0,0,1,230,64Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V224a2,2,0,0,0,3.26,1.55l34.82-30.08A6,6,0,0,1,80,194H216a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,128a12,12,0,1,1,12,12A12,12,0,0,1,116,128ZM84,140a12,12,0,1,0-12-12A12,12,0,0,0,84,140Zm88,0a12,12,0,1,0-12-12A12,12,0,0,0,172,140Zm60-76V192a16,16,0,0,1-16,16H83l-32.6,28.16-.09.07A15.89,15.89,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48H216A16,16,0,0,1,232,64ZM40,224h0ZM216,64H40V224l34.77-30A8,8,0,0,1,80,192H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-52-8a8,8,0,1,0,8,8A8,8,0,0,0,84,120Zm88,0a8,8,0,1,0,8,8A8,8,0,0,0,172,120Zm56-56V192a12,12,0,0,1-12,12H81.49L47.76,233.13l0,0A11.89,11.89,0,0,1,40,236a12.17,12.17,0,0,1-5.1-1.14A11.89,11.89,0,0,1,28,224V64A12,12,0,0,1,40,52H216A12,12,0,0,1,228,64Zm-8,0a4,4,0,0,0-4-4H40a4,4,0,0,0-4,4V224a4,4,0,0,0,6.56,3.08L77.38,197A4,4,0,0,1,80,196H216a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $32c43b5d35c7f6a5$export$2aab0b35a50deea3 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, a), {
        weights: (0, $510bd3db97d89352$export$2e2bcd8739ae039)
    })));
$32c43b5d35c7f6a5$export$2aab0b35a50deea3.displayName = "ChatDotsIcon";
const $32c43b5d35c7f6a5$export$bf6e891555e140d1 = $32c43b5d35c7f6a5$export$2aab0b35a50deea3;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3b183db6a49d61ab$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.34,187.09A84,84,0,0,0,172.29,68.9,84,84,0,0,0,19.66,139.09l-6.84,23.26a20,20,0,0,0,24.83,24.83l23.26-6.84a83.94,83.94,0,0,0,22.76,6.74,84.06,84.06,0,0,0,111.42,41.26l23.26,6.84a20,20,0,0,0,24.83-24.83ZM62,155.5a11.88,11.88,0,0,0-3.39.49l-20.72,6.09L44,141.35a12,12,0,0,0-.93-9A60,60,0,1,1,67.7,156.92,12,12,0,0,0,62,155.5Zm150.89,24.8a12,12,0,0,0-.93,9l6.09,20.73L197.36,204a12,12,0,0,0-9.06.93A60,60,0,0,1,111,186.63a83.93,83.93,0,0,0,68.55-91.37,60,60,0,0,1,33.38,85Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.66,213.73a8,8,0,0,1-9.93,9.93L194,215.5A72.05,72.05,0,0,1,92.06,175.89h0c1.31.07,2.62.11,3.94.11a72,72,0,0,0,67.93-95.88h0A72,72,0,0,1,223.5,186Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86ZM62,159.5a8.28,8.28,0,0,0-2.26.32L32,168l8.17-27.76a8,8,0,0,0-.63-6,64,64,0,1,1,26.26,26.26A8,8,0,0,0,62,159.5Zm153.79,28.73L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86Zm-16.25,1.47L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.93,186.58A78,78,0,0,0,168.16,74.42,78,78,0,1,0,26.07,138.58L18.58,164A14,14,0,0,0,36,181.42l25.46-7.49a78,78,0,0,0,26.39,7.63,78,78,0,0,0,106.77,40.37L220,229.42A14,14,0,0,0,237.42,212ZM62,161.5a6.05,6.05,0,0,0-1.69.24l-27.77,8.17a2,2,0,0,1-2.48-2.48l8.17-27.77a6.05,6.05,0,0,0-.47-4.53,66,66,0,1,1,27.08,27.08A6,6,0,0,0,62,161.5Zm155.71,26.16,8.17,27.77a2,2,0,0,1-2.48,2.48l-27.77-8.17a6.06,6.06,0,0,0-4.53.47,66,66,0,0,1-90-28.4,77.92,77.92,0,0,0,71-94.68,66,66,0,0,1,46.07,96A6.05,6.05,0,0,0,217.74,187.66Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86ZM62,159.5a8.28,8.28,0,0,0-2.26.32L32,168l8.17-27.76a8,8,0,0,0-.63-6,64,64,0,1,1,26.26,26.26A8,8,0,0,0,62,159.5Zm153.79,28.73L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.79,186.39a76,76,0,0,0-61-110.07A76,76,0,1,0,28.21,138.39L20.5,164.6a12,12,0,0,0,14.9,14.9l26.21-7.71a75.93,75.93,0,0,0,27.6,7.9,76,76,0,0,0,105.18,40.1l26.21,7.71a12,12,0,0,0,14.9-14.9ZM60.9,163.66l-27.76,8.17a4,4,0,0,1-5-5l8.17-27.76a4.07,4.07,0,0,0-.31-3A68,68,0,1,1,63.92,164,4.06,4.06,0,0,0,60.9,163.66Zm165.92,55.16a4,4,0,0,1-4,1l-27.76-8.17a4.07,4.07,0,0,0-3,.31A68,68,0,0,1,98,180a76,76,0,0,0,71.5-95.28A68,68,0,0,1,220,184.08a4.07,4.07,0,0,0-.31,3l8.17,27.76A4,4,0,0,1,226.82,218.82Z"
        }))
    ]
]);


const $137fb85d062916e7$export$932ca73f3598151a = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $3b183db6a49d61ab$export$2e2bcd8739ae039)
    })));
$137fb85d062916e7$export$932ca73f3598151a.displayName = "ChatsCircleIcon";
const $137fb85d062916e7$export$780ef68a19ac1891 = $137fb85d062916e7$export$932ca73f3598151a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5abba7d5db964d4b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,31.93A12,12,0,0,0,36.8,44.28,20,20,0,0,0,20,64V224A19.82,19.82,0,0,0,31.56,242.1a20.14,20.14,0,0,0,8.49,1.9,19.91,19.91,0,0,0,12.82-4.72l.12-.11L84.47,212H188.15l11,12.07a12,12,0,0,0,17.76-16.15ZM80,188a11.93,11.93,0,0,0-7.84,2.92L44,215.23V68H57.24L166.33,188ZM236,64V174.12a12,12,0,0,1-24,0V68H116.6a12,12,0,0,1,0-24H216A20,20,0,0,1,236,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64V192a8,8,0,0,1-8,8H80L45.15,230.11A8,8,0,0,1,32,224V64a8,8,0,0,1,8-8H216A8,8,0,0,1,224,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L44.46,48H40A16,16,0,0,0,24,64V224a15.85,15.85,0,0,0,9.24,14.5A16.13,16.13,0,0,0,40,240a15.94,15.94,0,0,0,10.26-3.78l.08-.07L83,208H189.92l12.16,13.38a8,8,0,1,0,11.84-10.76ZM80,192a8,8,0,0,0-5.23,1.95L40,224V64H59L175.37,192ZM232,64V186a8,8,0,0,1-16,0V64H105.79a8,8,0,0,1,0-16H216A16,16,0,0,1,232,64Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,210.61a8,8,0,1,1-11.84,10.76L189.92,208H83l-32.6,28.16-.08.07A15.94,15.94,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48h4.46l-2.38-2.62A8,8,0,1,1,53.92,34.62ZM216,48H96.75a4,4,0,0,0-3,6.69L225,199.06a4,4,0,0,0,7-2.69V64A16,16,0,0,0,216,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M52.44,36A6,6,0,0,0,43.56,44L49,50H40A14,14,0,0,0,26,64V224a13.86,13.86,0,0,0,8.09,12.69,13.89,13.89,0,0,0,15-2L82.23,206H190.8l12.76,14a6,6,0,1,0,8.88-8.07ZM80,194a6,6,0,0,0-3.92,1.46l-34.79,30A2,2,0,0,1,38,224V64a2,2,0,0,1,2-2H59.89l120,132ZM230,64V186a6,6,0,0,1-12,0V64a2,2,0,0,0-2-2H105.79a6,6,0,0,1,0-12H216A14,14,0,0,1,230,64Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L44.46,48H40A16,16,0,0,0,24,64V224a15.85,15.85,0,0,0,9.24,14.5A16.13,16.13,0,0,0,40,240a15.94,15.94,0,0,0,10.26-3.78l.08-.07L83,208H189.92l12.16,13.38a8,8,0,1,0,11.84-10.76ZM80,192a8,8,0,0,0-5.23,1.95L40,224V64H59L175.37,192ZM232,64V186a8,8,0,0,1-16,0V64H105.79a8,8,0,0,1,0-16H216A16,16,0,0,1,232,64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M51,37.31A4,4,0,0,0,45,42.69L53.5,52H40A12,12,0,0,0,28,64V224a11.89,11.89,0,0,0,6.93,10.88A12.09,12.09,0,0,0,40,236a12,12,0,0,0,7.74-2.87L81.49,204H191.68L205,218.69a4,4,0,0,0,3,1.31,4,4,0,0,0,3-6.69ZM80,196a4,4,0,0,0-2.61,1L42.57,227A4,4,0,0,1,36,224V64a4,4,0,0,1,4-4H60.78L184.41,196ZM228,64V186a4,4,0,0,1-8,0V64a4,4,0,0,0-4-4H105.79a4,4,0,0,1,0-8H216A12,12,0,0,1,228,64Z"
        }))
    ]
]);


const $1498f3d123581ef7$export$d9c1abf94e64825b = $7fPBF.forwardRef((t, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, t), {
        weights: (0, $5abba7d5db964d4b$export$2e2bcd8739ae039)
    })));
$1498f3d123581ef7$export$d9c1abf94e64825b.displayName = "ChatSlashIcon";
const $1498f3d123581ef7$export$c636dc4beb98032e = $1498f3d123581ef7$export$d9c1abf94e64825b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f6e732a5308dce0a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $07440da420a178a0$export$f6dd727656c97851 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $f6e732a5308dce0a$export$2e2bcd8739ae039)
    })));
$07440da420a178a0$export$f6dd727656c97851.displayName = "CheckCircleIcon";
const $07440da420a178a0$export$c20155506fb9b45c = $07440da420a178a0$export$f6dd727656c97851;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7050190286d58198$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z"
        }))
    ]
]);


const $0a50b2f774bdffff$export$7dd004358974b05d = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $7050190286d58198$export$2e2bcd8739ae039)
    })));
$0a50b2f774bdffff$export$7dd004358974b05d.displayName = "CheckIcon";
const $0a50b2f774bdffff$export$60bffc6e2a50e7f9 = $0a50b2f774bdffff$export$7dd004358974b05d;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9f7121a1062dd511$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152.41,88.56l-89.6,88a12,12,0,0,1-16.82,0L7.59,138.85a12,12,0,0,1,16.82-17.13l30,29.46,81.19-79.74a12,12,0,0,1,16.82,17.12Zm96.15-17a12,12,0,0,0-17-.15L150.4,151.18l-7.88-7.74a12,12,0,0,0-16.82,17.12l16.29,16a12,12,0,0,0,16.82,0l89.6-88A12,12,0,0,0,248.56,71.59Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,64V192a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V64A16,16,0,0,1,32,48H224A16,16,0,0,1,240,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Zm96.1-11.32a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM72,168a8,8,0,0,1-5.66-2.34l-24-24a8,8,0,0,1,11.32-11.32L72,148.69l58.34-58.35a8,8,0,0,1,11.32,11.32l-64,64A8,8,0,0,1,72,168Zm141.66-66.34-64,64a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,11.32-11.32L144,148.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148.2,84.28l-89.6,88a6,6,0,0,1-8.4,0L11.8,134.57A6,6,0,1,1,20.2,126l34.2,33.58,85.4-83.87a6,6,0,1,1,8.4,8.56Zm96.08-8.48a6,6,0,0,0-8.48-.08l-85.4,83.87-20.23-19.87a6,6,0,1,0-8.41,8.56l24.44,24a6,6,0,0,0,8.4,0l89.6-88A6,6,0,0,0,244.28,75.8Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Zm96.1-11.32a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.8,82.85l-89.6,88a4,4,0,0,1-5.6,0L13.2,133.14a4,4,0,0,1,5.6-5.71l35.6,35,86.8-85.24a4,4,0,0,1,5.6,5.7Zm96-5.65a4,4,0,0,0-5.65,0l-86.8,85.24-21.63-21.24a4,4,0,1,0-5.61,5.7l24.44,24a4,4,0,0,0,5.6,0l89.6-88A4,4,0,0,0,242.85,77.2Z"
        }))
    ]
]);


const $c629337a707d5c1c$export$e7072e36fe002dd0 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $9f7121a1062dd511$export$2e2bcd8739ae039)
    })));
$c629337a707d5c1c$export$e7072e36fe002dd0.displayName = "ChecksIcon";
const $c629337a707d5c1c$export$e9b38990dca3b63b = $c629337a707d5c1c$export$e7072e36fe002dd0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e46f00882ed4cde2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z"
        }))
    ]
]);


const $8671267bc76a08e9$export$9c1c3f5a4a271817 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $e46f00882ed4cde2$export$2e2bcd8739ae039)
    })));
$8671267bc76a08e9$export$9c1c3f5a4a271817.displayName = "CircleIcon";
const $8671267bc76a08e9$export$c89a927ffc67e6fa = $8671267bc76a08e9$export$9c1c3f5a4a271817;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $184f50840d9ba1a5$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,128a108,108,0,0,1-216,0c0-42.52,24.73-81.34,63-98.9A12,12,0,1,1,93,50.91C63.24,64.57,44,94.83,44,128a84,84,0,0,0,168,0c0-33.17-19.24-63.43-49-77.09A12,12,0,1,1,173,29.1C211.27,46.66,236,85.48,236,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,176A72,72,0,0,1,92,65.64a8,8,0,0,1,8,13.85,56,56,0,1,0,56,0,8,8,0,0,1,8-13.85A72,72,0,0,1,128,200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230,128a102,102,0,0,1-204,0c0-40.18,23.35-76.86,59.5-93.45a6,6,0,0,1,5,10.9C58.61,60.09,38,92.49,38,128a90,90,0,0,0,180,0c0-35.51-20.61-67.91-52.5-82.55a6,6,0,0,1,5-10.9C206.65,51.14,230,87.82,230,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,128a100,100,0,0,1-200,0c0-39.4,22.9-75.37,58.33-91.63a4,4,0,1,1,3.34,7.27C57.07,58.6,36,91.71,36,128a92,92,0,0,0,184,0c0-36.29-21.07-69.4-53.67-84.36a4,4,0,1,1,3.34-7.27C205.1,52.63,228,88.6,228,128Z"
        }))
    ]
]);


const $bd90a784cc828027$export$14e2ba5030ceec95 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $184f50840d9ba1a5$export$2e2bcd8739ae039)
    })));
$bd90a784cc828027$export$14e2ba5030ceec95.displayName = "CircleNotchIcon";
const $bd90a784cc828027$export$3764e814a607ca9b = $bd90a784cc828027$export$14e2ba5030ceec95;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7ba036b5ce8417bd$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM52,52H76v95.22a24,24,0,1,0,24,0V125l40,40v39H52ZM204,204H164V160a12,12,0,0,0-3.51-8.49L100,91V52h24V72a12,12,0,0,0,3.51,8.49l17.31,17.3a24,24,0,1,0,17-17L148,67V52h56Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM88,184a16,16,0,1,1,16-16A16,16,0,0,1,88,184Zm80-64a16,16,0,1,1,16-16A16,16,0,0,1,168,120Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88,160a8,8,0,1,1-8,8A8,8,0,0,1,88,160ZM48,48H80v97.38a24,24,0,1,0,16,0V115.31l48,48V208H48ZM208,208H160V160a8,8,0,0,0-2.34-5.66L96,92.69V48h32V72a8,8,0,0,0,2.34,5.66l16,16A23.74,23.74,0,0,0,144,104a24,24,0,1,0,24-24,23.74,23.74,0,0,0-10.34,2.35L144,68.69V48h64V208ZM168,96a8,8,0,1,1-8,8A8,8,0,0,1,168,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,111.31l48,48V220a4,4,0,0,1-4,4H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H68a4,4,0,0,1,4,4V153.38a24,24,0,1,0,16,0ZM80,184a8,8,0,1,0-8-8A8,8,0,0,0,80,184Zm104-80a8,8,0,1,0-8,8A8,8,0,0,0,184,104Zm24-72H156a4,4,0,0,0-4,4V68.69l13.66,13.66a24,24,0,1,1-11.31,11.31l-16-16A8,8,0,0,1,136,72V36a4,4,0,0,0-4-4H92a4,4,0,0,0-4,4V88.69l61.66,61.65A8,8,0,0,1,152,156v64a4,4,0,0,0,4,4h52a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34ZM88,158a10,10,0,1,1-10,10A10,10,0,0,1,88,158ZM46,208V48a2,2,0,0,1,2-2H82V146.84a22,22,0,1,0,12,0V110.49l52,52V210H48A2,2,0,0,1,46,208Zm164,0a2,2,0,0,1-2,2H158V160a6,6,0,0,0-1.76-4.24L94,93.51V46h36V72a6,6,0,0,0,1.76,4.24l17,17a22,22,0,1,0,8.48-8.48L142,69.51V46h66a2,2,0,0,1,2,2ZM168,94a10,10,0,1,1-10,10A10,10,0,0,1,168,94Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88,160a8,8,0,1,1-8,8A8,8,0,0,1,88,160ZM48,48H80v97.38a24,24,0,1,0,16,0V115.31l48,48V208H48ZM208,208H160V160a8,8,0,0,0-2.34-5.66L96,92.69V48h32V72a8,8,0,0,0,2.34,5.66l16,16A23.74,23.74,0,0,0,144,104a24,24,0,1,0,24-24,23.74,23.74,0,0,0-10.34,2.35L144,68.69V48h64V208ZM168,96a8,8,0,1,1-8,8A8,8,0,0,1,168,96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36ZM88,156a12,12,0,1,1-12,12A12,12,0,0,1,88,156ZM44,208V48a4,4,0,0,1,4-4H84V148.4a20,20,0,1,0,8,0V105.66l56,56V212H48A4,4,0,0,1,44,208Zm168,0a4,4,0,0,1-4,4H156V160a4,4,0,0,0-1.17-2.83L92,94.34V44h40V72a4,4,0,0,0,1.17,2.83L151.33,93A20,20,0,1,0,157,87.33l-17-17V44h68a4,4,0,0,1,4,4ZM168,92a12,12,0,1,1-12,12A12,12,0,0,1,168,92Z"
        }))
    ]
]);


const $b2c91a69e5d67ec9$export$ae8a512ee3f09294 = $7fPBF.forwardRef((t, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: i
    }, t), {
        weights: (0, $7ba036b5ce8417bd$export$2e2bcd8739ae039)
    })));
$b2c91a69e5d67ec9$export$ae8a512ee3f09294.displayName = "CircuitryIcon";
const $b2c91a69e5d67ec9$export$aef0eb479eab3688 = $b2c91a69e5d67ec9$export$ae8a512ee3f09294;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e0d88aab804f6cdc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,164a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,164Zm-12-52H96a12,12,0,0,0,0,24h64a12,12,0,0,0,0-24Zm60-64V216a20,20,0,0,1-20,20H56a20,20,0,0,1-20-20V48A20,20,0,0,1,56,28H90.53a51.88,51.88,0,0,1,74.94,0H200A20,20,0,0,1,220,48ZM100.29,60h55.42a28,28,0,0,0-55.42,0ZM196,52H178.59A52.13,52.13,0,0,1,180,64v8a12,12,0,0,1-12,12H88A12,12,0,0,1,76,72V64a52.13,52.13,0,0,1,1.41-12H60V212H196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96a39.83,39.83,0,0,0-8,24v8h80V64a39.83,39.83,0,0,0-8-24h40A8,8,0,0,1,208,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,152a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,152Zm-6-38H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Zm54-66V216a14,14,0,0,1-14,14H56a14,14,0,0,1-14-14V48A14,14,0,0,1,56,34H93.17a45.91,45.91,0,0,1,69.66,0H200A14,14,0,0,1,214,48ZM94,64v2h68V64a34,34,0,0,0-68,0ZM202,48a2,2,0,0,0-2-2H170.33A45.77,45.77,0,0,1,174,64v8a6,6,0,0,1-6,6H88a6,6,0,0,1-6-6V64a45.77,45.77,0,0,1,3.67-18H56a2,2,0,0,0-2,2V216a2,2,0,0,0,2,2H200a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,152a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,152Zm-4-36H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Zm52-68V216a12,12,0,0,1-12,12H56a12,12,0,0,1-12-12V48A12,12,0,0,1,56,36H94.08a44,44,0,0,1,67.84,0H200A12,12,0,0,1,212,48ZM92,64v4h72V64a36,36,0,0,0-72,0ZM204,48a4,4,0,0,0-4-4H167.17A43.71,43.71,0,0,1,172,64v8a4,4,0,0,1-4,4H88a4,4,0,0,1-4-4V64a43.71,43.71,0,0,1,4.83-20H56a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H200a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $79c58fd630e9f542$export$5ea4e40e738fba70 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $e0d88aab804f6cdc$export$2e2bcd8739ae039)
    })));
$79c58fd630e9f542$export$5ea4e40e738fba70.displayName = "ClipboardTextIcon";
const $79c58fd630e9f542$export$f3f2822f093d328a = $79c58fd630e9f542$export$5ea4e40e738fba70;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a8e7aeed175cfea2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,137A108.13,108.13,0,1,1,119,20,12,12,0,0,1,121,44,84.12,84.12,0,1,0,212,135,12,12,0,1,1,236,137ZM116,76v52a12,12,0,0,0,12,12h52a12,12,0,0,0,0-24H140V76a12,12,0,0,0-24,0Zm92,20a16,16,0,1,0-16-16A16,16,0,0,0,208,96ZM176,64a16,16,0,1,0-16-16A16,16,0,0,0,176,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,136.66A104.12,104.12,0,1,1,119.34,24,8,8,0,0,1,120.66,40,88.12,88.12,0,1,0,216,135.34,8,8,0,0,1,232,136.66ZM120,72v56a8,8,0,0,0,8,8h56a8,8,0,0,0,0-16H136V72a8,8,0,0,0-16,0Zm40-24a12,12,0,1,0-12-12A12,12,0,0,0,160,48Zm36,24a12,12,0,1,0-12-12A12,12,0,0,0,196,72Zm24,36a12,12,0,1,0-12-12A12,12,0,0,0,220,108Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,96a12,12,0,1,1,12,12A12,12,0,0,1,208,96ZM196,72a12,12,0,1,0-12-12A12,12,0,0,0,196,72Zm28.66,56a8,8,0,0,0-8.63,7.31A88.12,88.12,0,1,1,120.66,40,8,8,0,0,0,119.34,24,104.12,104.12,0,1,0,232,136.66,8,8,0,0,0,224.66,128ZM128,56a72,72,0,1,1-72,72A72.08,72.08,0,0,1,128,56Zm-8,72a8,8,0,0,0,8,8h48a8,8,0,0,0,0-16H136V80a8,8,0,0,0-16,0Zm40-80a12,12,0,1,0-12-12A12,12,0,0,0,160,48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230,136.49A102.12,102.12,0,1,1,119.51,26a6,6,0,0,1,1,12A90.13,90.13,0,1,0,218,135.51a6,6,0,1,1,12,1ZM122,72v56a6,6,0,0,0,6,6h56a6,6,0,0,0,0-12H134V72a6,6,0,0,0-12,0Zm38-26a10,10,0,1,0-10-10A10,10,0,0,0,160,46Zm36,24a10,10,0,1,0-10-10A10,10,0,0,0,196,70Zm24,36a10,10,0,1,0-10-10A10,10,0,0,0,220,106Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,136.66A104.12,104.12,0,1,1,119.34,24,8,8,0,0,1,120.66,40,88.12,88.12,0,1,0,216,135.34,8,8,0,0,1,232,136.66ZM120,72v56a8,8,0,0,0,8,8h56a8,8,0,0,0,0-16H136V72a8,8,0,0,0-16,0Zm40-24a12,12,0,1,0-12-12A12,12,0,0,0,160,48Zm36,24a12,12,0,1,0-12-12A12,12,0,0,0,196,72Zm24,36a12,12,0,1,0-12-12A12,12,0,0,0,220,108Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,136.33A100.13,100.13,0,1,1,119.67,28a4,4,0,1,1,.66,8A92.13,92.13,0,1,0,220,135.67a4,4,0,1,1,8,.66ZM128,132h56a4,4,0,0,0,0-8H132V72a4,4,0,0,0-8,0v56A4,4,0,0,0,128,132Zm32-88a8,8,0,1,0-8-8A8,8,0,0,0,160,44Zm36,24a8,8,0,1,0-8-8A8,8,0,0,0,196,68Zm24,36a8,8,0,1,0-8-8A8,8,0,0,0,220,104Z"
        }))
    ]
]);


const $f2df690f830f6bfe$export$b4de5782c179f82b = $7fPBF.forwardRef((n, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, n), {
        weights: (0, $a8e7aeed175cfea2$export$2e2bcd8739ae039)
    })));
$f2df690f830f6bfe$export$b4de5782c179f82b.displayName = "ClockCountdownIcon";
const $f2df690f830f6bfe$export$1f9ca49f6870089b = $f2df690f830f6bfe$export$b4de5782c179f82b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $943d4f3999f47169$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,80v41.21l34.17,20.5a12,12,0,1,1-12.34,20.58l-40-24A12,12,0,0,1,116,128V80a12,12,0,0,1,24,0ZM128,28A99.38,99.38,0,0,0,57.24,57.34c-4.69,4.74-9,9.37-13.24,14V64a12,12,0,0,0-24,0v40a12,12,0,0,0,12,12H72a12,12,0,0,0,0-24H57.77C63,86,68.37,80.22,74.26,74.26a76,76,0,1,1,1.58,109,12,12,0,0,0-16.48,17.46A100,100,0,1,0,128,28Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128A96,96,0,0,1,62.11,197.82a8,8,0,1,1,11-11.64A80,80,0,1,0,71.43,71.43C67.9,75,64.58,78.51,61.35,82L77.66,98.34A8,8,0,0,1,72,112H32a8,8,0,0,1-8-8V64a8,8,0,0,1,13.66-5.66L50,70.7c3.22-3.49,6.54-7,10.06-10.55A96,96,0,0,1,224,128ZM128,72a8,8,0,0,0-8,8v48a8,8,0,0,0,3.88,6.86l40,24a8,8,0,1,0,8.24-13.72L136,123.47V80A8,8,0,0,0,128,72Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M134,80v44.6l37.09,22.25a6,6,0,0,1-6.18,10.3l-40-24A6,6,0,0,1,122,128V80a6,6,0,0,1,12,0Zm-6-46A93.4,93.4,0,0,0,61.51,61.56c-8.58,8.68-16,17-23.51,25.8V64a6,6,0,0,0-12,0v40a6,6,0,0,0,6,6H72a6,6,0,0,0,0-12H44.73C52.86,88.29,60.79,79.35,70,70a82,82,0,1,1,1.7,117.62,6,6,0,1,0-8.24,8.72A94,94,0,1,0,128,34Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M132,80v45.74l38.06,22.83a4,4,0,0,1-4.12,6.86l-40-24A4,4,0,0,1,124,128V80a4,4,0,0,1,8,0Zm-4-44A91.42,91.42,0,0,0,62.93,63C53.05,73,44.66,82.47,36,92.86V64a4,4,0,0,0-8,0v40a4,4,0,0,0,4,4H72a4,4,0,0,0,0-8H40.47C49.61,89,58.3,79,68.6,68.6a84,84,0,1,1,1.75,120.49,4,4,0,1,0-5.5,5.82A92,92,0,1,0,128,36Z"
        }))
    ]
]);


const $85bbabb726c65e23$export$92c4ba459e027921 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $943d4f3999f47169$export$2e2bcd8739ae039)
    })));
$85bbabb726c65e23$export$92c4ba459e027921.displayName = "ClockCounterClockwiseIcon";
const $85bbabb726c65e23$export$92d3cd829f6fde6c = $85bbabb726c65e23$export$92c4ba459e027921;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a402008e197ce5fc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,140H164V116h16a40,40,0,1,0-40-40V92H116V76a40,40,0,1,0-40,40H92v24H76a40,40,0,1,0,40,40V164h24v16a40,40,0,1,0,40-40ZM164,76a16,16,0,1,1,16,16H164ZM60,76a16,16,0,0,1,32,0V92H76A16,16,0,0,1,60,76ZM92,180a16,16,0,1,1-16-16H92Zm24-64h24v24H116Zm64,80a16,16,0,0,1-16-16V164h16a16,16,0,0,1,0,32Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,76h0a28,28,0,0,1-28,28H152V76a28,28,0,0,1,28-28h0A28,28,0,0,1,208,76ZM76,48h0A28,28,0,0,0,48,76h0a28,28,0,0,0,28,28h28V76A28,28,0,0,0,76,48ZM180,152H152v28a28,28,0,0,0,28,28h0a28,28,0,0,0,28-28h0A28,28,0,0,0,180,152ZM48,180h0a28,28,0,0,0,28,28h0a28,28,0,0,0,28-28V152H76A28,28,0,0,0,48,180Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,144H160V112h20a36,36,0,1,0-36-36V96H112V76a36,36,0,1,0-36,36H96v32H76a36,36,0,1,0,36,36V160h32v20a36,36,0,1,0,36-36ZM160,76a20,20,0,1,1,20,20H160ZM56,76a20,20,0,0,1,40,0V96H76A20,20,0,0,1,56,76ZM96,180a20,20,0,1,1-20-20H96Zm16-68h32v32H112Zm68,88a20,20,0,0,1-20-20V160h20a20,20,0,0,1,0,40Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,116h24v24H116ZM86,72a14,14,0,0,0,0,28h14V86A14,14,0,0,0,86,72Zm98,14a14,14,0,0,0-28,0v14h14A14,14,0,0,0,184,86ZM72,170a14,14,0,0,0,28,0V156H86A14,14,0,0,0,72,170ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-68,92V116h14a30,30,0,1,0-30-30v14H116V86a30,30,0,1,0-30,30h14v24H86a30,30,0,1,0,30,30V156h24v14a30,30,0,1,0,30-30Zm0,30a14,14,0,1,0,14-14H156Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,146H158V110h22a34,34,0,1,0-34-34V98H110V76a34,34,0,1,0-34,34H98v36H76a34,34,0,1,0,34,34V158h36v22a34,34,0,1,0,34-34ZM158,76a22,22,0,1,1,22,22H158ZM54,76a22,22,0,0,1,44,0V98H76A22,22,0,0,1,54,76ZM98,180a22,22,0,1,1-22-22H98Zm12-70h36v36H110Zm70,92a22,22,0,0,1-22-22V158h22a22,22,0,0,1,0,44Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,144H160V112h20a36,36,0,1,0-36-36V96H112V76a36,36,0,1,0-36,36H96v32H76a36,36,0,1,0,36,36V160h32v20a36,36,0,1,0,36-36ZM160,76a20,20,0,1,1,20,20H160ZM56,76a20,20,0,0,1,40,0V96H76A20,20,0,0,1,56,76ZM96,180a20,20,0,1,1-20-20H96Zm16-68h32v32H112Zm68,88a20,20,0,0,1-20-20V160h20a20,20,0,0,1,0,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,148H156V108h24a32,32,0,1,0-32-32v24H108V76a32,32,0,1,0-32,32h24v40H76a32,32,0,1,0,32,32V156h40v24a32,32,0,1,0,32-32ZM156,76a24,24,0,1,1,24,24H156ZM52,76a24,24,0,0,1,48,0v24H76A24,24,0,0,1,52,76Zm48,104a24,24,0,1,1-24-24h24Zm8-72h40v40H108Zm72,96a24,24,0,0,1-24-24V156h24a24,24,0,0,1,0,48Z"
        }))
    ]
]);


const $ce7a829edce56cbe$export$76bfbab5e3f9a6a3 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, a), {
        weights: (0, $a402008e197ce5fc$export$2e2bcd8739ae039)
    })));
$ce7a829edce56cbe$export$76bfbab5e3f9a6a3.displayName = "CommandIcon";
const $ce7a829edce56cbe$export$cc7e12c76513e857 = $ce7a829edce56cbe$export$76bfbab5e3f9a6a3;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $19e26159d964e9d2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M84,76A12,12,0,0,1,96,64h64a12,12,0,0,1,0,24H96A12,12,0,0,1,84,76Zm12,52h64a12,12,0,0,0,0-24H96a12,12,0,0,0,0,24ZM212,40V216a20,20,0,0,1-20,20H64a20,20,0,0,1-20-20V40A20,20,0,0,1,64,20H192A20,20,0,0,1,212,40Zm-24,4H68V212H188ZM128,168a16,16,0,1,0,16,16A16,16,0,0,0,128,168Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40V216a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H192A8,8,0,0,1,200,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,72a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,72Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16ZM208,40V216a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V40A16,16,0,0,1,64,24H192A16,16,0,0,1,208,40Zm-16,0H64V216H192ZM128,168a12,12,0,1,0,12,12A12,12,0,0,0,128,168Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,24H64A16,16,0,0,0,48,40V216a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V40A16,16,0,0,0,192,24ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm32-80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166,72a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,72Zm-6,26H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Zm46-58V216a14,14,0,0,1-14,14H64a14,14,0,0,1-14-14V40A14,14,0,0,1,64,26H192A14,14,0,0,1,206,40Zm-12,0a2,2,0,0,0-2-2H64a2,2,0,0,0-2,2V216a2,2,0,0,0,2,2H192a2,2,0,0,0,2-2ZM128,170a10,10,0,1,0,10,10A10,10,0,0,0,128,170Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,72a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,72Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16ZM208,40V216a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V40A16,16,0,0,1,64,24H192A16,16,0,0,1,208,40Zm-16,0H64V216H192ZM128,168a12,12,0,1,0,12,12A12,12,0,0,0,128,168Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,72a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,72Zm-4,28H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Zm44-60V216a12,12,0,0,1-12,12H64a12,12,0,0,1-12-12V40A12,12,0,0,1,64,28H192A12,12,0,0,1,204,40Zm-8,0a4,4,0,0,0-4-4H64a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H192a4,4,0,0,0,4-4ZM128,172a8,8,0,1,0,8,8A8,8,0,0,0,128,172Z"
        }))
    ]
]);


const $79c2550b6d641714$export$a0dda6738dfadcc6 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $19e26159d964e9d2$export$2e2bcd8739ae039)
    })));
$79c2550b6d641714$export$a0dda6738dfadcc6.displayName = "ComputerTowerIcon";
const $79c2550b6d641714$export$4a6c7b5b3bb8a314 = $79c2550b6d641714$export$a0dda6738dfadcc6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $64d8f6dbf0ee66d8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,28H88A12,12,0,0,0,76,40V76H40A12,12,0,0,0,28,88V216a12,12,0,0,0,12,12H168a12,12,0,0,0,12-12V180h36a12,12,0,0,0,12-12V40A12,12,0,0,0,216,28ZM156,204H52V100H156Zm48-48H180V88a12,12,0,0,0-12-12H100V52H204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40V168H168V88H88V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Zm-8,128H176V88a8,8,0,0,0-8-8H96V48H208Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,34H88a6,6,0,0,0-6,6V82H40a6,6,0,0,0-6,6V216a6,6,0,0,0,6,6H168a6,6,0,0,0,6-6V174h42a6,6,0,0,0,6-6V40A6,6,0,0,0,216,34ZM162,210H46V94H162Zm48-48H174V88a6,6,0,0,0-6-6H94V46H210Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H88a4,4,0,0,0-4,4V84H40a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H168a4,4,0,0,0,4-4V172h44a4,4,0,0,0,4-4V40A4,4,0,0,0,216,36ZM164,212H44V92H164Zm48-48H172V88a4,4,0,0,0-4-4H92V44H212Z"
        }))
    ]
]);


const $db96a5dcfc35585c$export$51b6cd98f8778f0d = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $64d8f6dbf0ee66d8$export$2e2bcd8739ae039)
    })));
$db96a5dcfc35585c$export$51b6cd98f8778f0d.displayName = "CopyIcon";
const $db96a5dcfc35585c$export$92ce62e1201c4fc0 = $db96a5dcfc35585c$export$51b6cd98f8778f0d;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bc46e1eba941e29a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,64H40A12,12,0,0,0,28,76V216a12,12,0,0,0,12,12H180a12,12,0,0,0,12-12V76A12,12,0,0,0,180,64ZM168,204H52V88H168ZM228,40V180a12,12,0,0,1-24,0V52H76a12,12,0,0,1,0-24H216A12,12,0,0,1,228,40Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,72V216H40V72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,64H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V72A8,8,0,0,0,184,64Zm-8,144H48V80H176ZM224,40V184a8,8,0,0,1-16,0V48H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,72V216a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H184A8,8,0,0,1,192,72Zm24-40H72a8,8,0,0,0,0,16H208V184a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,66H40a6,6,0,0,0-6,6V216a6,6,0,0,0,6,6H184a6,6,0,0,0,6-6V72A6,6,0,0,0,184,66Zm-6,144H46V78H178ZM222,40V184a6,6,0,0,1-12,0V46H72a6,6,0,0,1,0-12H216A6,6,0,0,1,222,40Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,64H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V72A8,8,0,0,0,184,64Zm-8,144H48V80H176ZM224,40V184a8,8,0,0,1-16,0V48H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,68H40a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H184a4,4,0,0,0,4-4V72A4,4,0,0,0,184,68Zm-4,144H44V76H180ZM220,40V184a4,4,0,0,1-8,0V44H72a4,4,0,0,1,0-8H216A4,4,0,0,1,220,40Z"
        }))
    ]
]);


const $c7cfe8b811c67a0e$export$2f845a994f66da8f = $7fPBF.forwardRef((m, p)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: p
    }, m), {
        weights: (0, $bc46e1eba941e29a$export$2e2bcd8739ae039)
    })));
$c7cfe8b811c67a0e$export$2f845a994f66da8f.displayName = "CopySimpleIcon";
const $c7cfe8b811c67a0e$export$580df7a3d0dd33ae = $c7cfe8b811c67a0e$export$2f845a994f66da8f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cbcfe2eea08b9f7d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M252,80a32,32,0,1,0-60,15.45l-20.86,25.66L150.82,74.4a32,32,0,1,0-45.64,0L84.87,121.11,64,95.45a32,32,0,1,0-35,15.78l14,84.06A19.94,19.94,0,0,0,62.78,212H193.22A19.94,19.94,0,0,0,213,195.29l14-84.06A32.05,32.05,0,0,0,252,80Zm-32-8a8,8,0,1,1-8,8A8,8,0,0,1,220,72ZM128,44a8,8,0,1,1-8,8A8,8,0,0,1,128,44ZM36,72a8,8,0,1,1-8,8A8,8,0,0,1,36,72ZM189.83,188H66.17L55.29,122.78l23.4,28.79A12,12,0,0,0,88,156a12.87,12.87,0,0,0,1.63-.11,12,12,0,0,0,9.37-7.1L127.18,84l.82,0,.82,0L157,148.79a12,12,0,0,0,9.37,7.1A12.87,12.87,0,0,0,168,156a12,12,0,0,0,9.31-4.43l23.4-28.79Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.71,99.73l-15.6,93.59a8,8,0,0,1-7.89,6.68H62.78a8,8,0,0,1-7.89-6.68L39.29,99.73l.08,0a19.82,19.82,0,0,0,9.22-4.16h0L88,144l32-73.65h0a20,20,0,0,0,15.92,0h0L168,144l39.39-48.48h0a19.82,19.82,0,0,0,9.22,4.16Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM193.22,192H62.78L48.86,108.52,81.79,149A8,8,0,0,0,88,152a7.83,7.83,0,0,0,1.08-.07,8,8,0,0,0,6.26-4.74l29.3-67.4a27,27,0,0,0,6.72,0l29.3,67.4a8,8,0,0,0,6.26,4.74A7.83,7.83,0,0,0,168,152a8,8,0,0,0,6.21-3l32.93-40.52ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M246,80a26,26,0,1,0-46.6,15.84l-29.83,36.72-26-59.76a26,26,0,1,0-31.16,0l-26,59.76L56.6,95.84a26,26,0,1,0-22.36,10.09L49,194.3A14,14,0,0,0,62.78,206H193.22A14,14,0,0,0,207,194.3l14.73-88.37A26,26,0,0,0,246,80ZM128,38a14,14,0,1,1-14,14A14,14,0,0,1,128,38ZM22,80A14,14,0,1,1,36,94,14,14,0,0,1,22,80ZM195.2,192.33a2,2,0,0,1-2,1.67H62.78a2,2,0,0,1-2-1.67L46.08,104l1.22-.55,36,44.36A6,6,0,0,0,88,150a5.52,5.52,0,0,0,.81-.06,6,6,0,0,0,4.69-3.55l29.92-68.8a25.79,25.79,0,0,0,9.16,0l29.92,68.8a6,6,0,0,0,4.69,3.55,5.52,5.52,0,0,0,.81.06,6,6,0,0,0,4.66-2.22l36-44.36,1.22.55ZM220,94a14,14,0,1,1,14-14A14,14,0,0,1,220,94Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM193.22,192H62.78L48.86,108.52,81.79,149A8,8,0,0,0,88,152a7.83,7.83,0,0,0,1.08-.07,8,8,0,0,0,6.26-4.74l29.3-67.4a27,27,0,0,0,6.72,0l29.3,67.4a8,8,0,0,0,6.26,4.74A7.83,7.83,0,0,0,168,152a8,8,0,0,0,6.21-3l32.93-40.52ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244,80a24,24,0,1,0-42,15.83L169,136.37,141.1,72.09a24,24,0,1,0-26.2,0L87,136.37,54,95.83A24,24,0,1,0,35.94,104l15,90a12,12,0,0,0,11.84,10H193.22a12,12,0,0,0,11.84-10l15-90A24,24,0,0,0,244,80ZM128,36a16,16,0,1,1-16,16A16,16,0,0,1,128,36ZM20,80A16,16,0,1,1,36,96,16,16,0,0,1,20,80ZM197.17,192.66a4,4,0,0,1-3.95,3.34H62.78a4,4,0,0,1-4-3.34l-15-90a23.41,23.41,0,0,0,4-1.8L84.9,146.52A4,4,0,0,0,88,148a3.27,3.27,0,0,0,.54,0,4,4,0,0,0,3.13-2.37l30.56-70.3a23.8,23.8,0,0,0,11.54,0l30.56,70.3a4,4,0,0,0,3.13,2.37,3.27,3.27,0,0,0,.54,0,4,4,0,0,0,3.1-1.48l37.09-45.64a23.41,23.41,0,0,0,4,1.8ZM220,96a16,16,0,1,1,16-16A16,16,0,0,1,220,96Z"
        }))
    ]
]);


const $78e34b15ecf2a54e$export$338dfc3083a3d7f0 = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, e), {
        weights: (0, $cbcfe2eea08b9f7d$export$2e2bcd8739ae039)
    })));
$78e34b15ecf2a54e$export$338dfc3083a3d7f0.displayName = "CrownIcon";
const $78e34b15ecf2a54e$export$f3f7b84d2fde9b9e = $78e34b15ecf2a54e$export$338dfc3083a3d7f0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $33b6aa192f910fc4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,48V88a12,12,0,0,1-24,0V60H184a12,12,0,0,1,0-24h40A12,12,0,0,1,236,48ZM72,196H44V168a12,12,0,0,0-24,0v40a12,12,0,0,0,12,12H72a12,12,0,0,0,0-24Zm152-40a12,12,0,0,0-12,12v28H184a12,12,0,0,0,0,24h40a12,12,0,0,0,12-12V168A12,12,0,0,0,224,156ZM32,100A12,12,0,0,0,44,88V60H72a12,12,0,0,0,0-24H32A12,12,0,0,0,20,48V88A12,12,0,0,0,32,100Zm158,70.42-56,32a12,12,0,0,1-11.9,0l-56-32A12,12,0,0,1,60,160V96a12,12,0,0,1,6-10.42l56-32a12,12,0,0,1,11.9,0l56,32A12,12,0,0,1,196,96v64A12,12,0,0,1,190,170.42ZM96.19,96,128,114.18,159.81,96,128,77.82ZM84,153l32,18.28V135L84,116.68Zm88,0V116.68L140,135v36.36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,96v64l-56,32L72,160V96l56-32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM188,167l-56,32a8,8,0,0,1-7.94,0L68,167A8,8,0,0,1,64,160V96a8,8,0,0,1,4-7l56-32a8,8,0,0,1,7.94,0l56,32a8,8,0,0,1,4,7v64A8,8,0,0,1,188,167ZM88.12,96,128,118.79,167.88,96,128,73.21ZM80,155.36l40,22.85V132.64L80,109.79Zm96,0V109.79l-40,22.85v45.57Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM177.92,83.31,132,57.05a8,8,0,0,0-7.94,0L78.08,83.31a4,4,0,0,0,0,7L128,118.79l49.92-28.53A4,4,0,0,0,177.92,83.31ZM64,107.53V160A8,8,0,0,0,68,167l46,26.27a4,4,0,0,0,6-3.47V132.64L70,104.06A4,4,0,0,0,64,107.53ZM192,160V107.53a4,4,0,0,0-6-3.47l-50,28.58v57.11a4,4,0,0,0,6,3.47L188,167A8,8,0,0,0,192,160Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230,48V88a6,6,0,0,1-12,0V54H184a6,6,0,0,1,0-12h40A6,6,0,0,1,230,48ZM72,202H38V168a6,6,0,0,0-12,0v40a6,6,0,0,0,6,6H72a6,6,0,0,0,0-12Zm152-40a6,6,0,0,0-6,6v34H184a6,6,0,0,0,0,12h40a6,6,0,0,0,6-6V168A6,6,0,0,0,224,162ZM32,94a6,6,0,0,0,6-6V54H72a6,6,0,0,0,0-12H32a6,6,0,0,0-6,6V88A6,6,0,0,0,32,94Zm155,71.21-56,32a6,6,0,0,1-6,0l-56-32A6,6,0,0,1,66,160V96a6,6,0,0,1,3-5.21l56-32a6,6,0,0,1,6,0l56,32A6,6,0,0,1,190,96v64A6,6,0,0,1,187,165.21ZM84.09,96,128,121.09,171.91,96,128,70.91ZM78,156.52l44,25.14V131.48L78,106.34Zm100,0V106.34l-44,25.14v50.18Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,48V88a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h40A8,8,0,0,1,232,48ZM72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Zm152-40a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160ZM32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96ZM188,167l-56,32a8,8,0,0,1-7.94,0L68,167A8,8,0,0,1,64,160V96a8,8,0,0,1,4-7l56-32a8,8,0,0,1,7.94,0l56,32a8,8,0,0,1,4,7v64A8,8,0,0,1,188,167ZM88.12,96,128,118.79,167.88,96,128,73.21ZM80,155.36l40,22.85V132.64L80,109.79Zm96,0V109.79l-40,22.85v45.57Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,48V88a4,4,0,0,1-8,0V52H184a4,4,0,0,1,0-8h40A4,4,0,0,1,228,48ZM72,204H36V168a4,4,0,0,0-8,0v40a4,4,0,0,0,4,4H72a4,4,0,0,0,0-8Zm152-40a4,4,0,0,0-4,4v36H184a4,4,0,0,0,0,8h40a4,4,0,0,0,4-4V168A4,4,0,0,0,224,164ZM32,92a4,4,0,0,0,4-4V52H72a4,4,0,0,0,0-8H32a4,4,0,0,0-4,4V88A4,4,0,0,0,32,92Zm154,71.47-56,32a4,4,0,0,1-4,0l-56-32A4,4,0,0,1,68,160V96a4,4,0,0,1,2-3.47l56-32a4,4,0,0,1,4,0l56,32A4,4,0,0,1,188,96v64A4,4,0,0,1,186,163.47ZM80.06,96,128,123.39,175.94,96,128,68.61ZM76,157.68l48,27.43V130.32L76,102.89Zm104,0V102.89l-48,27.43v54.79Z"
        }))
    ]
]);


const $341dc8bc46d90b3a$export$2acbef2959ecd829 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $33b6aa192f910fc4$export$2e2bcd8739ae039)
    })));
$341dc8bc46d90b3a$export$2acbef2959ecd829.displayName = "CubeFocusIcon";
const $341dc8bc46d90b3a$export$57a6c4aa55e25a32 = $341dc8bc46d90b3a$export$2acbef2959ecd829;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $8870271a336384d8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.15,179.17l-46.82-46.82,37.92-13.51c.26-.09.51-.19.76-.3a20,20,0,0,0-1.76-37.27L54.16,29A20,20,0,0,0,29,54.16L81.27,214.24A20,20,0,0,0,118.54,216c.11-.25.21-.5.3-.76l13.51-37.92,46.83,46.82a20,20,0,0,0,28.28,0l16.69-16.68A20,20,0,0,0,224.15,179.17Zm-30.83,25.17-48.48-48.48A20,20,0,0,0,130.7,150a20.47,20.47,0,0,0-3.73.35A20,20,0,0,0,112.35,162c-.11.25-.2.5-.3.76L100.4,195.5,54.29,54.29,195.5,100.4l-32.71,11.65c-.25.09-.51.19-.76.3a20,20,0,0,0-6.16,32.48h0l48.48,48.48ZM84,16V12a12,12,0,0,1,24,0v4a12,12,0,0,1-24,0ZM12,108a12,12,0,0,1,0-24h4a12,12,0,0,1,0,24ZM120.62,24.21l4-12a12,12,0,0,1,22.77,7.58l-4,12a12,12,0,0,1-22.77-7.58Zm-81.23,104a12,12,0,0,1-7.59,15.17l-12,4a12,12,0,1,1-7.59-22.76l12-4A12,12,0,0,1,39.39,128.21Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,201,201,213.66a8,8,0,0,1-11.31,0l-51.31-51.31a8,8,0,0,0-13,2.46l-17.82,46.41a8,8,0,0,1-14.85-.71L40.41,50.44a8,8,0,0,1,10-10L210.51,92.68a8,8,0,0,1,.71,14.85l-46.41,17.82a8,8,0,0,0-2.46,13l51.31,51.31A8,8,0,0,1,213.66,201Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,24V16a8,8,0,0,1,16,0v8a8,8,0,0,1-16,0ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31ZM219.31,184a16,16,0,0,1,0,22.63l-12.68,12.68a16,16,0,0,1-22.63,0L132.7,168,115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13L168,132.69ZM208,195.31,156.69,144h0a16,16,0,0,1,4.93-26l.32-.14,45.95-17.64L48,48l52.2,159.86,17.65-46c0-.11.08-.22.13-.33a16,16,0,0,1,11.69-9.34,16.72,16.72,0,0,1,3-.28,16,16,0,0,1,11.3,4.69L195.31,208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.49,190.83a12,12,0,0,1,0,17L207.8,220.49a12,12,0,0,1-17,0l-56.56-56.57L115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13-50.17,19.27ZM96,32a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0v8A8,8,0,0,0,96,32ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90,24V16a6,6,0,0,1,12,0v8a6,6,0,0,1-12,0ZM16,102h8a6,6,0,0,0,0-12H16a6,6,0,0,0,0,12ZM125.32,37.37a6,6,0,0,0,8.05-2.69l8-16a6,6,0,0,0-10.74-5.37l-8,16A6,6,0,0,0,125.32,37.37Zm-96,85.26-16,8a6,6,0,0,0,5.36,10.74l16-8a6,6,0,1,0-5.36-10.74ZM217.9,185.41a14,14,0,0,1,0,19.8L205.21,217.9a14,14,0,0,1-19.8,0L134.1,166.59a2,2,0,0,0-3.21.54l-17.75,46.24a2.44,2.44,0,0,0-.1.24A13.85,13.85,0,0,1,100.26,222c-.23,0-.45,0-.68,0A13.85,13.85,0,0,1,87,212.38L34.7,52.3A14,14,0,0,1,52.3,34.7L212.38,87A14,14,0,0,1,213.61,113l-.24.09-46.25,17.76a2,2,0,0,0-.53,3.21Zm-8.49,8.49L158.1,142.59h0a14,14,0,0,1,4.32-22.74l.24-.1L208.91,102a2,2,0,0,0-.26-3.61L48.58,46.11a2.33,2.33,0,0,0-.65-.11,2,2,0,0,0-1.82,2.58L98.38,208.65a1.84,1.84,0,0,0,1.77,1.35,1.81,1.81,0,0,0,1.84-1.09l17.76-46.25.1-.24a14,14,0,0,1,22.74-4.32l51.31,51.31a2,2,0,0,0,2.83,0l12.68-12.68A2,2,0,0,0,209.41,193.9Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,24V16a8,8,0,0,1,16,0v8a8,8,0,0,1-16,0ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31ZM219.31,184a16,16,0,0,1,0,22.63l-12.68,12.68a16,16,0,0,1-22.63,0L132.7,168,115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13L168,132.69ZM208,195.31,156.69,144h0a16,16,0,0,1,4.93-26l.32-.14,45.95-17.64L48,48l52.2,159.86,17.65-46c0-.11.08-.22.13-.33a16,16,0,0,1,11.69-9.34,16.72,16.72,0,0,1,3-.28,16,16,0,0,1,11.3,4.69L195.31,208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M92,24V16a4,4,0,0,1,8,0v8a4,4,0,0,1-8,0ZM16,100h8a4,4,0,0,0,0-8H16a4,4,0,0,0,0,8ZM126.21,35.58a4,4,0,0,0,5.37-1.79l8-16a4,4,0,0,0-7.16-3.58l-8,16A4,4,0,0,0,126.21,35.58Zm-96,88.84-16,8a4,4,0,0,0,3.58,7.16l16-8a4,4,0,1,0-3.58-7.16Zm186.28,62.41a12,12,0,0,1,0,17L203.8,216.49a12,12,0,0,1-17,0l-51.31-51.31a3.93,3.93,0,0,0-3.58-1.11,4,4,0,0,0-2.89,2.27l-17.78,46.31a.77.77,0,0,1-.07.16A11.85,11.85,0,0,1,100.26,220h-.59a11.88,11.88,0,0,1-10.8-8.23L36.6,51.68A12,12,0,0,1,51.68,36.6L211.76,88.87a12,12,0,0,1,1.05,22.33l-.16.07-46.31,17.78a4,4,0,0,0-1.17,6.47Zm-5.66,5.66-51.31-51.32a12,12,0,0,1,3.7-19.49l.16-.06,46.31-17.79a3.95,3.95,0,0,0-.42-7.35L49.2,44.21a4,4,0,0,0-5,5L96.48,209.27a4,4,0,0,0,7.36.42l17.78-46.31a1.11,1.11,0,0,1,.07-.16,12,12,0,0,1,8.76-7,12.21,12.21,0,0,1,2.24-.21,12,12,0,0,1,8.49,3.52l51.31,51.31a4,4,0,0,0,5.65,0l12.69-12.69A4,4,0,0,0,210.83,192.49Z"
        }))
    ]
]);


const $499cedc40c55e7cb$export$e9e98f64fb597ccd = $7fPBF.forwardRef((c, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, c), {
        weights: (0, $8870271a336384d8$export$2e2bcd8739ae039)
    })));
$499cedc40c55e7cb$export$e9e98f64fb597ccd.displayName = "CursorClickIcon";
const $499cedc40c55e7cb$export$58b4366001b3caa8 = $499cedc40c55e7cb$export$e9e98f64fb597ccd;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c5adf7b1ae7a3737$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.15,179.17l-46.83-46.82,37.93-13.51.76-.3a20,20,0,0,0-1.76-37.27L54.16,29A20,20,0,0,0,29,54.16L81.27,214.24A20,20,0,0,0,118.54,216c.11-.25.21-.5.3-.76l13.51-37.92,46.83,46.82a20,20,0,0,0,28.28,0l16.69-16.68A20,20,0,0,0,224.15,179.17Zm-30.83,25.17-48.48-48.48A20,20,0,0,0,130.7,150a20.66,20.66,0,0,0-3.74.35A20,20,0,0,0,112.35,162c-.11.25-.21.5-.3.76L100.4,195.5,54.29,54.29l141.21,46.1-32.71,11.66c-.26.09-.51.19-.76.3a20,20,0,0,0-6.17,32.48h0l48.49,48.48Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,201,201,213.66a8,8,0,0,1-11.31,0l-51.31-51.31a8,8,0,0,0-13,2.46l-17.82,46.41a8,8,0,0,1-14.85-.71L40.41,50.44a8,8,0,0,1,10-10L210.51,92.68a8,8,0,0,1,.71,14.85l-46.41,17.82a8,8,0,0,0-2.46,13l51.31,51.31A8,8,0,0,1,213.66,201Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.49,207.8,207.8,220.49a12,12,0,0,1-17,0l-56.57-56.57L115,214.08l-.13.33A15.84,15.84,0,0,1,100.26,224l-.78,0a15.82,15.82,0,0,1-14.41-11L32.8,52.92A15.95,15.95,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.33.13-50.16,19.27,56.57,56.56A12,12,0,0,1,220.49,207.8Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M166.59,134.1a1.91,1.91,0,0,1-.55-1.79,2,2,0,0,1,1.08-1.42l46.25-17.76.24-.1A14,14,0,0,0,212.38,87L52.29,34.7A13.95,13.95,0,0,0,34.7,52.29L87,212.38a13.82,13.82,0,0,0,12.6,9.6c.23,0,.46,0,.69,0A13.84,13.84,0,0,0,113,213.61a2.44,2.44,0,0,0,.1-.24l17.76-46.25a2,2,0,0,1,3.21-.53l51.31,51.31a14,14,0,0,0,19.8,0l12.69-12.69a14,14,0,0,0,0-19.8Zm42.82,62.63-12.68,12.68a2,2,0,0,1-2.83,0L142.59,158.1a14,14,0,0,0-22.74,4.32,2.44,2.44,0,0,0-.1.24L102,208.91a2,2,0,0,1-3.61-.26L46.11,48.57a1.87,1.87,0,0,1,.47-2A1.92,1.92,0,0,1,47.93,46a2.22,2.22,0,0,1,.64.1L208.65,98.38a2,2,0,0,1,.26,3.61l-46.25,17.76-.24.1a14,14,0,0,0-4.32,22.74h0l51.31,51.31A2,2,0,0,1,209.41,196.73Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.17,135.51a4,4,0,0,1,1.17-6.46l46.31-17.79.16-.06a12,12,0,0,0-1.05-22.33L51.67,36.6A12,12,0,0,0,36.6,51.67L88.87,211.76A11.86,11.86,0,0,0,99.67,220h.58a11.86,11.86,0,0,0,11-7.19l.06-.16,17.79-46.31a4,4,0,0,1,6.47-1.17l51.31,51.32a12,12,0,0,0,17,0l12.69-12.69a12,12,0,0,0,0-17Zm45.66,62.63-12.69,12.69a4,4,0,0,1-5.66,0l-51.31-51.31a12,12,0,0,0-8.48-3.52,12.13,12.13,0,0,0-2.24.21,12,12,0,0,0-8.77,7l-.06.16-17.79,46.31a4,4,0,0,1-7.36-.42L44.2,49.19a4,4,0,0,1,5-5L209.27,96.47a4,4,0,0,1,.42,7.36l-46.31,17.78-.16.07a12,12,0,0,0-3.71,19.49l51.32,51.31A4,4,0,0,1,210.83,198.14Z"
        }))
    ]
]);


const $eba72b294d6f09da$export$8ce9a6eef5b50cda = $7fPBF.forwardRef((e, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, e), {
        weights: (0, $c5adf7b1ae7a3737$export$2e2bcd8739ae039)
    })));
$eba72b294d6f09da$export$8ce9a6eef5b50cda.displayName = "CursorIcon";
const $eba72b294d6f09da$export$b6a79797ad180576 = $eba72b294d6f09da$export$8ce9a6eef5b50cda;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $11919b7ee5692f59$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M188,208a12,12,0,0,1-12,12H160a43.86,43.86,0,0,1-32-13.85A43.86,43.86,0,0,1,96,220H80a12,12,0,0,1,0-24H96a20,20,0,0,0,20-20V140H104a12,12,0,0,1,0-24h12V80A20,20,0,0,0,96,60H80a12,12,0,0,1,0-24H96a43.86,43.86,0,0,1,32,13.85A43.86,43.86,0,0,1,160,36h16a12,12,0,0,1,0,24H160a20,20,0,0,0-20,20v36h12a12,12,0,0,1,0,24H140v36a20,20,0,0,0,20,20h16A12,12,0,0,1,188,208Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,48V208H160a32,32,0,0,1-32-32,32,32,0,0,1-32,32H80V48H96a32,32,0,0,1,32,32,32,32,0,0,1,32-32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-64,88a8,8,0,0,1,0,16h-8v24a16,16,0,0,0,16,16h8a8,8,0,0,1,0,16h-8a31.92,31.92,0,0,1-24-10.87A31.92,31.92,0,0,1,104,192H96a8,8,0,0,1,0-16h8a16,16,0,0,0,16-16V136h-8a8,8,0,0,1,0-16h8V96a16,16,0,0,0-16-16H96a8,8,0,0,1,0-16h8a31.92,31.92,0,0,1,24,10.87A31.92,31.92,0,0,1,152,64h8a8,8,0,0,1,0,16h-8a16,16,0,0,0-16,16v24Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M182,208a6,6,0,0,1-6,6H160a38,38,0,0,1-32-17.55A38,38,0,0,1,96,214H80a6,6,0,0,1,0-12H96a26,26,0,0,0,26-26V134H104a6,6,0,0,1,0-12h18V80A26,26,0,0,0,96,54H80a6,6,0,0,1,0-12H96a38,38,0,0,1,32,17.55A38,38,0,0,1,160,42h16a6,6,0,0,1,0,12H160a26,26,0,0,0-26,26v42h18a6,6,0,0,1,0,12H134v42a26,26,0,0,0,26,26h16A6,6,0,0,1,182,208Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,208a4,4,0,0,1-4,4H160a36,36,0,0,1-32-19.54A36,36,0,0,1,96,212H80a4,4,0,0,1,0-8H96a28,28,0,0,0,28-28V132H104a4,4,0,0,1,0-8h20V80A28,28,0,0,0,96,52H80a4,4,0,0,1,0-8H96a36,36,0,0,1,32,19.54A36,36,0,0,1,160,44h16a4,4,0,0,1,0,8H160a28,28,0,0,0-28,28v44h20a4,4,0,0,1,0,8H132v44a28,28,0,0,0,28,28h16A4,4,0,0,1,180,208Z"
        }))
    ]
]);


const $991a051c44f6b41d$export$d665abe9390574dd = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, e), {
        weights: (0, $11919b7ee5692f59$export$2e2bcd8739ae039)
    })));
$991a051c44f6b41d$export$d665abe9390574dd.displayName = "CursorTextIcon";
const $991a051c44f6b41d$export$e024e28c94cb249a = $991a051c44f6b41d$export$d665abe9390574dd;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $22c2d7917fb17b0a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A28,28,0,0,0,20,64V172a28,28,0,0,0,28,28h68v12H96a12,12,0,0,0,0,24h64a12,12,0,0,0,0-24H140V200h68a28,28,0,0,0,28-28V64A28,28,0,0,0,208,36ZM48,60H208a4,4,0,0,1,4,4v72H44V64A4,4,0,0,1,48,60ZM208,176H48a4,4,0,0,1-4-4V160H212v12A4,4,0,0,1,208,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64v88H32V64A16,16,0,0,1,48,48H208A16,16,0,0,1,224,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A24,24,0,0,0,24,64V176a24,24,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24,24,0,0,0,24-24V64A24,24,0,0,0,208,40ZM48,56H208a8,8,0,0,1,8,8v80H40V64A8,8,0,0,1,48,56ZM208,184H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A24,24,0,0,0,24,64V176a24,24,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24,24,0,0,0,24-24V64A24,24,0,0,0,208,40Zm0,144H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,42H48A22,22,0,0,0,26,64V176a22,22,0,0,0,22,22h74v20H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12H134V198h74a22,22,0,0,0,22-22V64A22,22,0,0,0,208,42ZM48,54H208a10,10,0,0,1,10,10v82H38V64A10,10,0,0,1,48,54ZM208,186H48a10,10,0,0,1-10-10V158H218v18A10,10,0,0,1,208,186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A24,24,0,0,0,24,64V176a24,24,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24,24,0,0,0,24-24V64A24,24,0,0,0,208,40ZM48,56H208a8,8,0,0,1,8,8v80H40V64A8,8,0,0,1,48,56ZM208,184H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,44H48A20,20,0,0,0,28,64V176a20,20,0,0,0,20,20h76v24H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8H132V196h76a20,20,0,0,0,20-20V64A20,20,0,0,0,208,44ZM48,52H208a12,12,0,0,1,12,12v84H36V64A12,12,0,0,1,48,52ZM208,188H48a12,12,0,0,1-12-12V156H220v20A12,12,0,0,1,208,188Z"
        }))
    ]
]);


const $db0aecd837df835e$export$78a6319cfd8cd037 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, t), {
        weights: (0, $22c2d7917fb17b0a$export$2e2bcd8739ae039)
    })));
$db0aecd837df835e$export$78a6319cfd8cd037.displayName = "DesktopIcon";
const $db0aecd837df835e$export$eb8deef317734844 = $db0aecd837df835e$export$78a6319cfd8cd037;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a7304b870f6f9cb3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,12H80A28,28,0,0,0,52,40V216a28,28,0,0,0,28,28h96a28,28,0,0,0,28-28V40A28,28,0,0,0,176,12Zm4,204a4,4,0,0,1-4,4H80a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h96a4,4,0,0,1,4,4ZM164,64a12,12,0,0,1-12,12H104a12,12,0,0,1,0-24h48A12,12,0,0,1,164,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,40V216a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V40A16,16,0,0,1,80,24h96A16,16,0,0,1,192,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16Zm8,200a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8ZM168,56a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM160,64H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,18H80A22,22,0,0,0,58,40V216a22,22,0,0,0,22,22h96a22,22,0,0,0,22-22V40A22,22,0,0,0,176,18Zm10,198a10,10,0,0,1-10,10H80a10,10,0,0,1-10-10V40A10,10,0,0,1,80,30h96a10,10,0,0,1,10,10ZM166,56a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,56Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16Zm8,200a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8ZM168,56a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,20H80A20,20,0,0,0,60,40V216a20,20,0,0,0,20,20h96a20,20,0,0,0,20-20V40A20,20,0,0,0,176,20Zm12,196a12,12,0,0,1-12,12H80a12,12,0,0,1-12-12V40A12,12,0,0,1,80,28h96a12,12,0,0,1,12,12ZM164,56a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,56Z"
        }))
    ]
]);


const $32f3456307b486ee$export$86748a064d6b172 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $a7304b870f6f9cb3$export$2e2bcd8739ae039)
    })));
$32f3456307b486ee$export$86748a064d6b172.displayName = "DeviceMobileSpeakerIcon";
const $32f3456307b486ee$export$381410f2d0f9f87b = $32f3456307b486ee$export$86748a064d6b172;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e638bac1ebea6382$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H212V64a28,28,0,0,0-28-28H40A28,28,0,0,0,12,64v88a28,28,0,0,0,28,28h96v12a28,28,0,0,0,28,28h60a28,28,0,0,0,28-28V100A28,28,0,0,0,224,72ZM40,156a4,4,0,0,1-4-4V64a4,4,0,0,1,4-4H184a4,4,0,0,1,4,4v8H164a28,28,0,0,0-28,28v56Zm188,36a4,4,0,0,1-4,4H164a4,4,0,0,1-4-4V100a4,4,0,0,1,4-4h60a4,4,0,0,1,4,4ZM124,208a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h24A12,12,0,0,1,124,208Zm88-84a12,12,0,0,1-12,12H188a12,12,0,0,1,0-24h12A12,12,0,0,1,212,124Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,64V80H176a16,16,0,0,0-16,16v80H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H184A16,16,0,0,1,200,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H208V64a24,24,0,0,0-24-24H40A24,24,0,0,0,16,64v96a24,24,0,0,0,24,24H152v8a24,24,0,0,0,24,24h48a24,24,0,0,0,24-24V96A24,24,0,0,0,224,72ZM40,168a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v8H176a24,24,0,0,0-24,24v72Zm192,24a8,8,0,0,1-8,8H176a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Zm-96,16a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h40A8,8,0,0,1,136,208Zm80-96a8,8,0,0,1-8,8H192a8,8,0,0,1,0-16h16A8,8,0,0,1,216,112Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H208V64a24,24,0,0,0-24-24H40A24,24,0,0,0,16,64v96a24,24,0,0,0,24,24H152v8a24,24,0,0,0,24,24h48a24,24,0,0,0,24-24V96A24,24,0,0,0,224,72Zm8,120a8,8,0,0,1-8,8H176a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Zm-96,16a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h40A8,8,0,0,1,136,208Zm80-96a8,8,0,0,1-8,8H192a8,8,0,0,1,0-16h16A8,8,0,0,1,216,112Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,74H206V64a22,22,0,0,0-22-22H40A22,22,0,0,0,18,64v96a22,22,0,0,0,22,22H154v10a22,22,0,0,0,22,22h48a22,22,0,0,0,22-22V96A22,22,0,0,0,224,74ZM40,170a10,10,0,0,1-10-10V64A10,10,0,0,1,40,54H184a10,10,0,0,1,10,10V74H176a22,22,0,0,0-22,22v74Zm194,22a10,10,0,0,1-10,10H176a10,10,0,0,1-10-10V96a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10ZM134,208a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h40A6,6,0,0,1,134,208Zm80-96a6,6,0,0,1-6,6H192a6,6,0,0,1,0-12h16A6,6,0,0,1,214,112Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,72H208V64a24,24,0,0,0-24-24H40A24,24,0,0,0,16,64v96a24,24,0,0,0,24,24H152v8a24,24,0,0,0,24,24h48a24,24,0,0,0,24-24V96A24,24,0,0,0,224,72ZM40,168a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v8H176a24,24,0,0,0-24,24v72Zm192,24a8,8,0,0,1-8,8H176a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Zm-96,16a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h40A8,8,0,0,1,136,208Zm80-96a8,8,0,0,1-8,8H192a8,8,0,0,1,0-16h16A8,8,0,0,1,216,112Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,76H204V64a20,20,0,0,0-20-20H40A20,20,0,0,0,20,64v96a20,20,0,0,0,20,20H156v12a20,20,0,0,0,20,20h48a20,20,0,0,0,20-20V96A20,20,0,0,0,224,76ZM40,172a12,12,0,0,1-12-12V64A12,12,0,0,1,40,52H184a12,12,0,0,1,12,12V76H176a20,20,0,0,0-20,20v76Zm196,20a12,12,0,0,1-12,12H176a12,12,0,0,1-12-12V96a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12ZM132,208a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h40A4,4,0,0,1,132,208Zm80-96a4,4,0,0,1-4,4H192a4,4,0,0,1,0-8h16A4,4,0,0,1,212,112Z"
        }))
    ]
]);


const $0536198cc436fd7c$export$ba4cac3c471c5034 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $e638bac1ebea6382$export$2e2bcd8739ae039)
    })));
$0536198cc436fd7c$export$ba4cac3c471c5034.displayName = "DevicesIcon";
const $0536198cc436fd7c$export$5dedfd1a2dcba3c6 = $0536198cc436fd7c$export$ba4cac3c471c5034;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $141ac8d6fc74c419$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M124,60.78V16a12,12,0,0,0-24,0V60.78a92,92,0,1,0,24,0ZM178.92,140h-23.4c-1.64-20.74-7.36-37-13.81-49.15A68.23,68.23,0,0,1,178.92,140ZM112,215c-7-8.62-17-25.09-19.45-51h38.9C129,189.9,119,206.37,112,215ZM92.55,140C95,114.1,105,97.63,112,89c7,8.62,17,25.09,19.45,51ZM82.29,90.85C75.84,103,70.12,119.26,68.48,140H45.08A68.23,68.23,0,0,1,82.29,90.85ZM45.08,164h23.4c1.64,20.74,7.36,37,13.81,49.15A68.23,68.23,0,0,1,45.08,164Zm96.63,49.15c6.45-12.15,12.17-28.41,13.81-49.15h23.4A68.23,68.23,0,0,1,141.71,213.15ZM256,88a12,12,0,0,1-12,12h-4v4a12,12,0,0,1-24,0v-4h-4a12,12,0,0,1,0-24h4V72a12,12,0,0,1,24,0v4h4A12,12,0,0,1,256,88ZM148,36a12,12,0,0,1,12-12h8V16a12,12,0,0,1,24,0v8h8a12,12,0,0,1,0,24h-8v8a12,12,0,0,1-24,0V48h-8A12,12,0,0,1,148,36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,152a80,80,0,0,1-80,80s32-24,32-80ZM112,72S80,96,80,152h64C144,96,112,72,112,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,64.37V16a8,8,0,0,0-16,0V64.37a88,88,0,1,0,16,0ZM183.54,144H151.77c-1.51-28.36-10.79-48.36-19.44-61.06A72.16,72.16,0,0,1,183.54,144Zm-95.3,16h47.52c-2,33.52-16.13,52.95-23.76,61.08C104.36,212.93,90.23,193.51,88.24,160Zm0-16c2-33.52,16.13-52.95,23.76-61.08,7.64,8.15,21.77,27.57,23.76,61.08Zm3.43-61.06C83,95.64,73.74,115.64,72.23,144H40.46A72.16,72.16,0,0,1,91.67,82.94ZM40.46,160H72.23c1.51,28.36,10.79,48.36,19.44,61.06A72.16,72.16,0,0,1,40.46,160Zm91.87,61.06c8.65-12.7,17.93-32.7,19.44-61.06h31.77A72.16,72.16,0,0,1,132.33,221.06ZM256,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,256,88ZM152,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H192V64a8,8,0,0,1-16,0V48H160A8,8,0,0,1,152,40Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,64.37V16a8,8,0,0,0-16,0V64.37a88,88,0,1,0,16,0ZM183.54,144H151.77c-1.51-28.36-10.79-48.36-19.44-61.06A72.16,72.16,0,0,1,183.54,144Zm-47.78,16c-2,33.52-16.13,52.95-23.76,61.08-7.64-8.15-21.77-27.57-23.76-61.08ZM91.67,82.94C83,95.64,73.74,115.64,72.23,144H40.46A72.16,72.16,0,0,1,91.67,82.94ZM40.46,160H72.23c1.51,28.36,10.79,48.36,19.44,61.06A72.16,72.16,0,0,1,40.46,160ZM256,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,256,88ZM152,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H192V64a8,8,0,0,1-16,0V48H160A8,8,0,0,1,152,40Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M118,66.23V16a6,6,0,0,0-12,0V66.23a86,86,0,1,0,12,0ZM185.74,146H149.87c-1.3-32.59-13-54.15-22.36-66.35A74.15,74.15,0,0,1,185.74,146Zm-99.6,12h51.72c-1.63,37.69-18.33,58.46-25.86,66C104.46,216.45,87.77,195.67,86.14,158Zm0-12c1.63-37.69,18.33-58.46,25.86-66,7.54,7.51,24.23,28.29,25.86,66ZM96.49,79.65C87.11,91.85,75.43,113.41,74.13,146H38.26A74.15,74.15,0,0,1,96.49,79.65ZM38.26,158H74.13c1.3,32.59,13,54.15,22.36,66.35A74.15,74.15,0,0,1,38.26,158Zm89.25,66.35c9.38-12.2,21.06-33.76,22.36-66.35h35.87A74.15,74.15,0,0,1,127.51,224.35ZM254,88a6,6,0,0,1-6,6H238v10a6,6,0,0,1-12,0V94H216a6,6,0,0,1,0-12h10V72a6,6,0,0,1,12,0V82h10A6,6,0,0,1,254,88ZM208,46H190V64a6,6,0,0,1-12,0V46H160a6,6,0,0,1,0-12h18V16a6,6,0,0,1,12,0V34h18a6,6,0,0,1,0,12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,64.37V16a8,8,0,0,0-16,0V64.37a88,88,0,1,0,16,0ZM183.54,144H151.77c-1.51-28.36-10.79-48.36-19.44-61.06A72.16,72.16,0,0,1,183.54,144Zm-95.3,16h47.52c-2,33.52-16.13,52.95-23.76,61.08C104.36,212.93,90.23,193.51,88.24,160Zm0-16c2-33.52,16.13-52.95,23.76-61.08,7.64,8.15,21.77,27.57,23.76,61.08Zm3.43-61.06C83,95.64,73.74,115.64,72.23,144H40.46A72.16,72.16,0,0,1,91.67,82.94ZM40.46,160H72.23c1.51,28.36,10.79,48.36,19.44,61.06A72.16,72.16,0,0,1,40.46,160Zm91.87,61.06c8.65-12.7,17.93-32.7,19.44-61.06h31.77A72.16,72.16,0,0,1,132.33,221.06ZM256,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,256,88ZM152,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H192V64a8,8,0,0,1-16,0V48H160A8,8,0,0,1,152,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,68.1V16a4,4,0,0,0-8,0V68.1a84,84,0,1,0,8,0ZM187.89,148h-40c-1-37.34-15.73-60.22-25.35-71.25A76.12,76.12,0,0,1,187.89,148ZM112,226.68C105,220,85.26,197.61,84.06,156h55.88C138.74,197.61,119,220,112,226.68ZM84.06,148c1.2-41.61,21-64,27.94-70.68,7,6.64,26.74,29.07,27.94,70.68Zm17.36-71.25c-9.62,11-24.35,33.91-25.35,71.25h-40A76.12,76.12,0,0,1,101.42,76.75ZM36.11,156h40c1,37.34,15.73,60.22,25.35,71.25A76.12,76.12,0,0,1,36.11,156Zm86.47,71.25c9.62-11,24.35-33.91,25.35-71.25h40A76.12,76.12,0,0,1,122.58,227.25ZM252,88a4,4,0,0,1-4,4H236v12a4,4,0,0,1-8,0V92H216a4,4,0,0,1,0-8h12V72a4,4,0,0,1,8,0V84h12A4,4,0,0,1,252,88ZM212,40a4,4,0,0,1-4,4H188V64a4,4,0,0,1-8,0V44H160a4,4,0,0,1,0-8h20V16a4,4,0,0,1,8,0V36h20A4,4,0,0,1,212,40Z"
        }))
    ]
]);


const $8140d5c711c8dac2$export$f8943b539a4bce42 = $7fPBF.forwardRef((c, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, c), {
        weights: (0, $141ac8d6fc74c419$export$2e2bcd8739ae039)
    })));
$8140d5c711c8dac2$export$f8943b539a4bce42.displayName = "DiscoBallIcon";
const $8140d5c711c8dac2$export$4edc83027ccd2aaa = $8140d5c711c8dac2$export$f8943b539a4bce42;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e15b8534886ff13b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-16-84a16,16,0,1,1-16-16A16,16,0,0,1,112,128Zm64,0a16,16,0,1,1-16-16A16,16,0,0,1,176,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm56-88a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm-44,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm44,0a12,12,0,1,1,12-12A12,12,0,0,1,172,140Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm10-90a10,10,0,1,1-10-10A10,10,0,0,1,138,128Zm-44,0a10,10,0,1,1-10-10A10,10,0,0,1,94,128Zm88,0a10,10,0,1,1-10-10A10,10,0,0,1,182,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm8-92a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-44,0a8,8,0,1,1-8-8A8,8,0,0,1,92,128Zm88,0a8,8,0,1,1-8-8A8,8,0,0,1,180,128Z"
        }))
    ]
]);


const $88db7d04aef0c70c$export$fc32f3c5f46e7c02 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $e15b8534886ff13b$export$2e2bcd8739ae039)
    })));
$88db7d04aef0c70c$export$fc32f3c5f46e7c02.displayName = "DotsThreeCircleIcon";
const $88db7d04aef0c70c$export$f88267bb2bc25651 = $88db7d04aef0c70c$export$fc32f3c5f46e7c02;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6ebd1719734e5ea6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0Zm-108.49,8.49a12,12,0,0,0,17,0l40-40a12,12,0,0,0-17-17L140,115V32a12,12,0,0,0-24,0v83L96.49,95.51a12,12,0,0,0-17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,168,96H136V32a8,8,0,0,0-16,0V96H88a8,8,0,0,0-5.66,13.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0Zm-98.24,4.24a6,6,0,0,0,8.48,0l40-40a6,6,0,0,0-8.48-8.48L134,129.51V32a6,6,0,0,0-12,0v97.51L92.24,99.76a6,6,0,0,0-8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0Zm-94.83,2.83a4,4,0,0,0,5.66,0l40-40a4,4,0,1,0-5.66-5.66L132,134.34V32a4,4,0,0,0-8,0V134.34L90.83,101.17a4,4,0,0,0-5.66,5.66Z"
        }))
    ]
]);


const $3d7aae5ab6f8c20e$export$5e12dc2d5a33c663 = $7fPBF.forwardRef((a, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: m
    }, a), {
        weights: (0, $6ebd1719734e5ea6$export$2e2bcd8739ae039)
    })));
$3d7aae5ab6f8c20e$export$5e12dc2d5a33c663.displayName = "DownloadSimpleIcon";
const $3d7aae5ab6f8c20e$export$4386181bcb914e5a = $3d7aae5ab6f8c20e$export$5e12dc2d5a33c663;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9796377d97a00c44$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,44H32A12,12,0,0,0,20,56V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A12,12,0,0,0,224,44Zm-96,83.72L62.85,68h130.3ZM92.79,128,44,172.72V83.28Zm17.76,16.28,9.34,8.57a12,12,0,0,0,16.22,0l9.34-8.57L193.15,188H62.85ZM163.21,128,212,83.28v89.44Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56l-96,88L32,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,52H32a4,4,0,0,0-4,4V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A4,4,0,0,0,224,52Zm-96,86.57L42.28,60H213.72ZM104.63,128,36,190.91V65.09Zm5.92,5.43L125.3,147a4,4,0,0,0,5.4,0l14.75-13.52L213.72,196H42.28ZM151.37,128,220,65.09V190.91Z"
        }))
    ]
]);


const $356076885242800f$export$ea4109706c07d076 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $9796377d97a00c44$export$2e2bcd8739ae039)
    })));
$356076885242800f$export$ea4109706c07d076.displayName = "EnvelopeIcon";
const $356076885242800f$export$4e2d65a9843399df = $356076885242800f$export$ea4109706c07d076;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $19561994e6e96aa0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,112v96a20,20,0,0,1-20,20H56a20,20,0,0,1-20-20V112A20,20,0,0,1,56,92H76a12,12,0,0,1,0,24H60v88H196V116H180a12,12,0,0,1,0-24h20A20,20,0,0,1,220,112ZM96.49,72.49,116,53v83a12,12,0,0,0,24,0V53l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,104V216H48V104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96H80a8,8,0,0,1,0,16H56v96H200V112H176a8,8,0,0,1,0-16h24A16,16,0,0,1,216,112ZM93.66,69.66,120,43.31V136a8,8,0,0,0,16,0V43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96h64v48a8,8,0,0,0,16,0V96h64A16,16,0,0,1,216,112ZM136,43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66L120,43.31V96h16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M214,112v96a14,14,0,0,1-14,14H56a14,14,0,0,1-14-14V112A14,14,0,0,1,56,98H80a6,6,0,0,1,0,12H56a2,2,0,0,0-2,2v96a2,2,0,0,0,2,2H200a2,2,0,0,0,2-2V112a2,2,0,0,0-2-2H176a6,6,0,0,1,0-12h24A14,14,0,0,1,214,112ZM92.24,68.24,122,38.49V136a6,6,0,0,0,12,0V38.49l29.76,29.75a6,6,0,1,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,1,0,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96H80a8,8,0,0,1,0,16H56v96H200V112H176a8,8,0,0,1,0-16h24A16,16,0,0,1,216,112ZM93.66,69.66,120,43.31V136a8,8,0,0,0,16,0V43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212,112v96a12,12,0,0,1-12,12H56a12,12,0,0,1-12-12V112a12,12,0,0,1,12-12H80a4,4,0,0,1,0,8H56a4,4,0,0,0-4,4v96a4,4,0,0,0,4,4H200a4,4,0,0,0,4-4V112a4,4,0,0,0-4-4H176a4,4,0,0,1,0-8h24A12,12,0,0,1,212,112ZM90.83,66.83,124,33.66V136a4,4,0,0,0,8,0V33.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z"
        }))
    ]
]);


const $424c21aaeac80038$export$e9c88b7c429dba64 = $7fPBF.forwardRef((t, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, t), {
        weights: (0, $19561994e6e96aa0$export$2e2bcd8739ae039)
    })));
$424c21aaeac80038$export$e9c88b7c429dba64.displayName = "ExportIcon";
const $424c21aaeac80038$export$f883e605db67eacf = $424c21aaeac80038$export$e9c88b7c429dba64;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $edb6dda74892d4bb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251,123.13c-.37-.81-9.13-20.26-28.48-39.61C196.63,57.67,164,44,128,44S59.37,57.67,33.51,83.52C14.16,102.87,5.4,122.32,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212s68.63-13.66,94.48-39.51c19.36-19.35,28.12-38.79,28.49-39.61A12.08,12.08,0,0,0,251,123.13Zm-46.06,33C183.47,177.27,157.59,188,128,188s-55.47-10.73-76.91-31.88A130.36,130.36,0,0,1,29.52,128,130.45,130.45,0,0,1,51.09,99.89C72.54,78.73,98.41,68,128,68s55.46,10.73,76.91,31.89A130.36,130.36,0,0,1,226.48,128,130.45,130.45,0,0,1,204.91,156.12ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245.48,125.57c-.34-.78-8.66-19.23-27.24-37.81C201,70.54,171.38,50,128,50S55,70.54,37.76,87.76c-18.58,18.58-26.9,37-27.24,37.81a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206s73-20.53,90.24-37.75c18.58-18.58,26.9-37,27.24-37.8A6,6,0,0,0,245.48,125.57ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.77,134.77,0,0,1,22.69,128,134.56,134.56,0,0,1,46.55,95.94C69.22,73.42,96.62,62,128,62s58.78,11.42,81.45,33.94A134.56,134.56,0,0,1,233.31,128C226.94,140.21,195,194,128,194Zm0-112a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.66,126.38c-.34-.76-8.52-18.89-26.83-37.2C199.87,72.22,170.7,52,128,52S56.13,72.22,39.17,89.18c-18.31,18.31-26.49,36.44-26.83,37.2a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17s71.87-20.21,88.83-37.17c18.31-18.31,26.49-36.43,26.83-37.2A4.08,4.08,0,0,0,243.66,126.38Zm-32.7,35c-23.07,23-51,34.62-83,34.62s-59.89-11.65-83-34.62A135.71,135.71,0,0,1,20.44,128,135.69,135.69,0,0,1,45,94.62C68.11,71.65,96,60,128,60s59.89,11.65,83,34.62A135.79,135.79,0,0,1,235.56,128,135.71,135.71,0,0,1,211,161.38ZM128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z"
        }))
    ]
]);


const $41331bef289ddf9d$export$4b2c798a70974642 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $edb6dda74892d4bb$export$2e2bcd8739ae039)
    })));
$41331bef289ddf9d$export$4b2c798a70974642.displayName = "EyeIcon";
const $41331bef289ddf9d$export$c42ab4f9cd72fed3 = $41331bef289ddf9d$export$4b2c798a70974642;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6d5e934c9d793b75$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,31.93A12,12,0,1,0,39.12,48.07l16,17.65C20.67,88.66,5.72,121.58,5,123.13a12.08,12.08,0,0,0,0,9.75c.37.82,9.13,20.26,28.49,39.61C59.37,198.34,92,212,128,212a131.34,131.34,0,0,0,51-10l20.09,22.1a12,12,0,0,0,17.76-16.14ZM128,188c-29.59,0-55.47-10.73-76.91-31.88A130.69,130.69,0,0,1,29.52,128c5.27-9.31,18.79-29.9,42-44.29l90.09,99.11A109.33,109.33,0,0,1,128,188Zm123-55.12c-.36.81-9,20-28,39.16a12,12,0,1,1-17-16.9A130.48,130.48,0,0,0,226.48,128a130.36,130.36,0,0,0-21.57-28.12C183.46,78.73,157.59,68,128,68c-3.35,0-6.7.14-10,.42a12,12,0,1,1-2-23.91c3.93-.34,8-.51,12-.51,36,0,68.63,13.67,94.49,39.52,19.35,19.35,28.11,38.8,28.48,39.61A12.08,12.08,0,0,1,251,132.88Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.68,57.87a4,4,0,0,1,2.08-6.6A130.13,130.13,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41a8,8,0,0,1,0,6.5c-.35.79-8.82,19.57-27.65,38.4q-4.28,4.26-8.79,8.07a4,4,0,0,1-5.55-.36ZM213.92,210.62a8,8,0,1,1-11.84,10.76L180,197.13A127.21,127.21,0,0,1,128,208c-34.88,0-66.57-13.26-91.66-38.34C17.51,150.83,9,132.05,8.69,131.26a8,8,0,0,1,0-6.5C9,124,17.51,105.18,36.34,86.35a135,135,0,0,1,25-19.78L42.08,45.38A8,8,0,1,1,53.92,34.62Zm-65.49-48.25-52.69-58a40,40,0,0,0,52.69,58Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M52.44,36A6,6,0,0,0,43.56,44L64.44,67c-37.28,21.9-53.23,57-53.92,58.57a6,6,0,0,0,0,4.88c.34.77,8.66,19.22,27.24,37.8C55,185.47,84.62,206,128,206a124.91,124.91,0,0,0,52.57-11.25l23,25.29a6,6,0,0,0,8.88-8.08Zm48.62,71.32,45,49.52a34,34,0,0,1-45-49.52ZM128,194c-31.38,0-58.78-11.42-81.45-33.93A134.57,134.57,0,0,1,22.69,128c4.29-8.2,20.1-35.18,50-51.91L92.89,98.3a46,46,0,0,0,61.35,67.48l17.81,19.6A113.47,113.47,0,0,1,128,194Zm6.4-99.4a6,6,0,0,1,2.25-11.79,46.17,46.17,0,0,1,37.15,40.87,6,6,0,0,1-5.42,6.53l-.56,0a6,6,0,0,1-6-5.45A34.1,34.1,0,0,0,134.4,94.6Zm111.08,35.85c-.41.92-10.37,23-32.86,43.12a6,6,0,1,1-8-8.94A134.07,134.07,0,0,0,233.31,128a134.67,134.67,0,0,0-23.86-32.07C186.78,73.42,159.38,62,128,62a120.19,120.19,0,0,0-19.69,1.6,6,6,0,1,1-2-11.83A131.12,131.12,0,0,1,128,50c43.38,0,73,20.54,90.24,37.76,18.58,18.58,26.9,37,27.24,37.81A6,6,0,0,1,245.48,130.45Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M51,37.31A4,4,0,0,0,45,42.69L67.59,67.5C29.34,89,13,124.81,12.34,126.38a4.08,4.08,0,0,0,0,3.25c.34.77,8.52,18.89,26.83,37.2,17,17,46.14,37.17,88.83,37.17a122.59,122.59,0,0,0,53.06-11.69l24,26.38a4,4,0,1,0,5.92-5.38ZM149.1,157.16A36,36,0,0,1,101,104.22ZM128,196c-32,0-59.89-11.65-83-34.62A135.81,135.81,0,0,1,20.44,128c3.65-7.23,20.09-36.81,52.68-54.43l22.45,24.7a44,44,0,0,0,59,64.83l20.89,23A114.94,114.94,0,0,1,128,196Zm6.78-103.36a4,4,0,0,1,1.49-7.86,44.15,44.15,0,0,1,35.54,39.09,4,4,0,0,1-3.61,4.35l-.38,0a4,4,0,0,1-4-3.63A36.1,36.1,0,0,0,134.78,92.64Zm108.88,37c-.41.91-10.2,22.58-32.38,42.45a4,4,0,0,1-2.67,1,4,4,0,0,1-2.67-7A136.71,136.71,0,0,0,235.56,128,136.07,136.07,0,0,0,211,94.62C187.89,71.65,160,60,128,60a122,122,0,0,0-20,1.63,4,4,0,0,1-1.32-7.89A129.3,129.3,0,0,1,128,52c42.7,0,71.87,20.22,88.83,37.18,18.31,18.31,26.49,36.44,26.83,37.2A4.08,4.08,0,0,1,243.66,129.63Z"
        }))
    ]
]);


const $0987fb0e4a894127$export$a3d42ccaf02d165b = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, a), {
        weights: (0, $6d5e934c9d793b75$export$2e2bcd8739ae039)
    })));
$0987fb0e4a894127$export$a3d42ccaf02d165b.displayName = "EyeSlashIcon";
const $0987fb0e4a894127$export$540b644af6247088 = $0987fb0e4a894127$export$a3d42ccaf02d165b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e082f86fccbcbc1f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM183,80H160V57ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Zm96.48-48.49a36,36,0,1,0-17,17l12,12a12,12,0,0,0,17-17ZM112,148a12,12,0,1,1,12,12A12,12,0,0,1,112,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-45.54-48.85a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM104,148a20,20,0,1,1,20,20A20,20,0,0,1,104,148Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,148a20,20,0,1,1-20-20A20,20,0,0,1,144,148Zm72-60V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88Zm-50.34,90.34-11.2-11.19a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM196,88,152,44V88Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Zm-48.11-50.59a34.05,34.05,0,1,0-8.48,8.48l12.35,12.35a6,6,0,0,0,8.48-8.48ZM102,148a22,22,0,1,1,22,22A22,22,0,0,1,102,148Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-45.54-48.85a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM104,148a20,20,0,1,1,20,20A20,20,0,0,1,104,148Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Zm-50.74-52.39a32.05,32.05,0,1,0-5.65,5.65l13.56,13.57a4,4,0,0,0,5.66-5.66ZM100,148a24,24,0,1,1,24,24A24,24,0,0,1,100,148Z"
        }))
    ]
]);


const $7a2cae967b7bcae2$export$588b3e9b8e13e2d4 = $7fPBF.forwardRef((i, o)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: o
    }, i), {
        weights: (0, $e082f86fccbcbc1f$export$2e2bcd8739ae039)
    })));
$7a2cae967b7bcae2$export$588b3e9b8e13e2d4.displayName = "FileMagnifyingGlassIcon";
const $7a2cae967b7bcae2$export$bbd58d203031cfb1 = $7a2cae967b7bcae2$export$588b3e9b8e13e2d4;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9fa701b2d2a478cb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,152v56a12,12,0,0,1-24,0V190.07l-6.17,8.81a12,12,0,0,1-19.66,0L44,190.07V208a12,12,0,0,1-24,0V152a12,12,0,0,1,21.83-6.88L60,171.07l18.17-25.95A12,12,0,0,1,100,152Zm84,28a40,40,0,0,1-40,40H128a12,12,0,0,1-12-12V152a12,12,0,0,1,12-12h16A40,40,0,0,1,184,180Zm-24,0a16,16,0,0,0-16-16h-4v32h4A16,16,0,0,0,160,180Zm60-92V224a12,12,0,0,1-24,0V104H148a12,12,0,0,1-12-12V44H60v64a12,12,0,0,1-24,0V40A20,20,0,0,1,56,20h96a12,12,0,0,1,8.49,3.52l56,56A12,12,0,0,1,220,88Zm-60-8h23L160,57Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V224a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM144,144H128a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h16a36,36,0,0,0,0-72Zm0,56h-8V160h8a20,20,0,0,1,0,40Zm-40-48v56a8,8,0,0,1-16,0V177.38L74.55,196.59a8,8,0,0,1-13.1,0L48,177.38V208a8,8,0,0,1-16,0V152a8,8,0,0,1,14.55-4.59L68,178.05l21.45-30.64A8,8,0,0,1,104,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v76a4,4,0,0,0,4,4H196a4,4,0,0,1,4,4V224a8,8,0,0,0,9.19,7.91,8.15,8.15,0,0,0,6.81-8.16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Zm-8,56H128a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h15.32c19.66,0,36.21-15.48,36.67-35.13A36,36,0,0,0,144,144Zm-.49,56H136V160h8a20,20,0,0,1,20,20.77C163.58,191.59,154.34,200,143.51,200ZM104,152v55.73A8.17,8.17,0,0,1,96.53,216,8,8,0,0,1,88,208V177.38l-13.32,19a8.3,8.3,0,0,1-4.2,3.2,8,8,0,0,1-9-3L48,177.38v30.35A8.17,8.17,0,0,1,40.53,216,8,8,0,0,1,32,208V152.31a8.27,8.27,0,0,1,4.56-7.53,8,8,0,0,1,10,2.63L68,178.05l21.27-30.39a8.28,8.28,0,0,1,8.06-3.55A8,8,0,0,1,104,152Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40v72a6,6,0,0,0,12,0V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V224a6,6,0,0,0,12,0V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM144,146H128a6,6,0,0,0-6,6v56a6,6,0,0,0,6,6h16a34,34,0,0,0,0-68Zm0,56H134V158h10a22,22,0,0,1,0,44Zm-42-50v56a6,6,0,0,1-12,0V171L72.92,195.44a6,6,0,0,1-9.84,0L46,171v37a6,6,0,0,1-12,0V152a6,6,0,0,1,10.92-3.44l23.08,33,23.08-33A6,6,0,0,1,102,152Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V224a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM144,144H128a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8h16a36,36,0,0,0,0-72Zm0,56h-8V160h8a20,20,0,0,1,0,40Zm-40-48v56a8,8,0,0,1-16,0V177.38L74.55,196.59a8,8,0,0,1-13.1,0L48,177.38V208a8,8,0,0,1-16,0V152a8,8,0,0,1,14.55-4.59L68,178.05l21.45-30.64A8,8,0,0,1,104,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40v72a4,4,0,0,0,8,0V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V224a4,4,0,0,0,8,0V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM144,148H128a4,4,0,0,0-4,4v56a4,4,0,0,0,4,4h16a32,32,0,0,0,0-64Zm0,56H132V156h12a24,24,0,0,1,0,48Zm-44-52v56a4,4,0,0,1-8,0V164.69l-20.72,29.6a4,4,0,0,1-6.56,0L44,164.69V208a4,4,0,0,1-8,0V152a4,4,0,0,1,7.28-2.29L68,185l24.72-35.31A4,4,0,0,1,100,152Z"
        }))
    ]
]);


const $494752190a3820c3$export$88937d130805b394 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $9fa701b2d2a478cb$export$2e2bcd8739ae039)
    })));
$494752190a3820c3$export$88937d130805b394.displayName = "FileMdIcon";
const $494752190a3820c3$export$d249491e34f19cbe = $494752190a3820c3$export$88937d130805b394;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d212d505b6449501$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,79.51l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.51ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Zm104-60a12,12,0,0,1-12,12H140v12a12,12,0,0,1-24,0V164H104a12,12,0,0,1,0-24h12V128a12,12,0,0,1,24,0v12h12A12,12,0,0,1,164,152Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,160H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Zm0-72V43.31L196.69,88Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Zm-42-66a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V158H104a6,6,0,0,1,0-12h18V128a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,152Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Zm-44-68a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V156H104a4,4,0,0,1,0-8h20V128a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,152Z"
        }))
    ]
]);


const $34d18705d2aaa06f$export$ca191b730434e9b4 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $d212d505b6449501$export$2e2bcd8739ae039)
    })));
$34d18705d2aaa06f$export$ca191b730434e9b4.displayName = "FilePlusIcon";
const $34d18705d2aaa06f$export$399db72a3873366e = $34d18705d2aaa06f$export$ca191b730434e9b4;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $093434f6cb31b9bc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.49,59.51l-40-40A12,12,0,0,0,172,16H92A20,20,0,0,0,72,36V56H56A20,20,0,0,0,36,76V216a20,20,0,0,0,20,20H164a20,20,0,0,0,20-20V196h20a20,20,0,0,0,20-20V68A12,12,0,0,0,220.49,59.51ZM160,212H60V80h67l33,33Zm40-40H184V108a12,12,0,0,0-3.51-8.49l-40-40A12,12,0,0,0,132,56H96V40h71l33,33Zm-56-28a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h44A12,12,0,0,1,144,144Zm0,40a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h44A12,12,0,0,1,144,184Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,72V184a8,8,0,0,1-8,8H176V104L136,64H80V40a8,8,0,0,1,8-8h80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM168,216H56V72h76.69L168,107.31v84.53c0,.06,0,.11,0,.16s0,.1,0,.16V216Zm32-32H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Zm-56-32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,152Zm0,32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM136,192H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm64,24H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,67.76l-40-40A6,6,0,0,0,168,26H88A14,14,0,0,0,74,40V58H56A14,14,0,0,0,42,72V216a14,14,0,0,0,14,14H168a14,14,0,0,0,14-14V198h18a14,14,0,0,0,14-14V72A6,6,0,0,0,212.24,67.76ZM170,216a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V72a2,2,0,0,1,2-2h77.51L170,106.49Zm32-32a2,2,0,0,1-2,2H182V104a6,6,0,0,0-1.76-4.24l-40-40A6,6,0,0,0,136,58H86V40a2,2,0,0,1,2-2h77.51L202,74.49Zm-60-32a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h48A6,6,0,0,1,142,152Zm0,32a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h48A6,6,0,0,1,142,184Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM168,216H56V72h76.69L168,107.31v84.53c0,.06,0,.11,0,.16s0,.1,0,.16V216Zm32-32H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Zm-56-32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,152Zm0,32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,69.17l-40-40A4,4,0,0,0,168,28H88A12,12,0,0,0,76,40V60H56A12,12,0,0,0,44,72V216a12,12,0,0,0,12,12H168a12,12,0,0,0,12-12V196h20a12,12,0,0,0,12-12V72A4,4,0,0,0,210.83,69.17ZM172,216a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V72a4,4,0,0,1,4-4h78.34L172,105.66Zm32-32a4,4,0,0,1-4,4H180V104a4,4,0,0,0-1.17-2.83l-40-40A4,4,0,0,0,136,60H84V40a4,4,0,0,1,4-4h78.34L204,73.66Zm-64-32a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h48A4,4,0,0,1,140,152Zm0,32a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h48A4,4,0,0,1,140,184Z"
        }))
    ]
]);


const $250558ea9b1ae473$export$e08f3be1829716d = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $093434f6cb31b9bc$export$2e2bcd8739ae039)
    })));
$250558ea9b1ae473$export$e08f3be1829716d.displayName = "FilesIcon";
const $250558ea9b1ae473$export$9330ab61a7e5c11b = $250558ea9b1ae473$export$e08f3be1829716d;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3d1caf2a7b22e970$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Zm112-80a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,132Zm0,40a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,172Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88H152V32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,168Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,176H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm-8-56V44l44,44Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Zm-34-82a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,136Zm0,32a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,168Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,168Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Zm-36-84a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,136Zm0,32a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,168Z"
        }))
    ]
]);


const $3f0996278d9b7033$export$605674723bcc715c = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, t), {
        weights: (0, $3d1caf2a7b22e970$export$2e2bcd8739ae039)
    })));
$3f0996278d9b7033$export$605674723bcc715c.displayName = "FileTextIcon";
const $3f0996278d9b7033$export$1f1995cbd0e38792 = $3f0996278d9b7033$export$605674723bcc715c;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0e93dfc4cb9b014e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M40.14,46.88A12,12,0,0,0,36,56V224a12,12,0,0,0,24,0V181.72c22.84-17.12,42.1-9.12,70.68,5,16.23,8,34.74,17.2,54.8,17.2,14.72,0,30.28-4.94,46.38-18.88A12,12,0,0,0,236,176V56a12,12,0,0,0-19.86-9.07c-24.71,21.41-44.53,13.31-74.82-1.68C113.19,31.27,78.17,13.94,40.14,46.88ZM212,170.26c-22.84,17.13-42.1,9.11-70.68-5C118.16,153.76,90.33,140,60,153.87V61.69c22.84-17.12,42.1-9.12,70.68,5,16.23,8,34.74,17.2,54.8,17.2A63,63,0,0,0,212,78.08Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V176c-64,55.43-112-55.43-176,0V56C112,.57,160,111.43,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M42.76,50A8,8,0,0,0,40,56V224a8,8,0,0,0,16,0V179.77c26.79-21.16,49.87-9.75,76.45,3.41,16.4,8.11,34.06,16.85,53,16.85,13.93,0,28.54-4.75,43.82-18a8,8,0,0,0,2.76-6V56A8,8,0,0,0,218.76,50c-28,24.23-51.72,12.49-79.21-1.12C111.07,34.76,78.78,18.79,42.76,50ZM216,172.25c-26.79,21.16-49.87,9.74-76.45-3.41-25-12.35-52.81-26.13-83.55-8.4V59.79c26.79-21.16,49.87-9.75,76.45,3.4,25,12.35,52.82,26.13,83.55,8.4Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,56V176a8,8,0,0,1-2.76,6c-15.28,13.23-29.89,18-43.82,18-18.91,0-36.57-8.74-53-16.85C105.87,170,82.79,158.61,56,179.77V224a8,8,0,0,1-16,0V56a8,8,0,0,1,2.77-6h0c36-31.18,68.31-15.21,96.79-1.12C167,62.46,190.79,74.2,218.76,50A8,8,0,0,1,232,56Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M44.08,51.37A6,6,0,0,0,42,55.9V224a6,6,0,0,0,12,0V178.78c28.08-22.79,51.88-11,79.34,2.57,16.12,8,33.49,16.58,52,16.58,13.57,0,27.76-4.6,42.56-17.42A6,6,0,0,0,230,176V55.9a6,6,0,0,0-9.93-4.54c-29,25.12-53.28,13.09-81.41-.84C110.77,36.71,79,21.16,44.08,51.37ZM218,173.17c-28.08,22.8-51.88,11-79.34-2.58C113.4,158.08,85.09,144.07,54,164V58.72c28.08-22.8,51.88-11,79.34,2.56C158.6,73.79,186.91,87.8,218,67.91Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M42.76,50A8,8,0,0,0,40,56V224a8,8,0,0,0,16,0V179.77c26.79-21.16,49.87-9.75,76.45,3.41,16.4,8.11,34.06,16.85,53,16.85,13.93,0,28.54-4.75,43.82-18a8,8,0,0,0,2.76-6V56A8,8,0,0,0,218.76,50c-28,24.23-51.72,12.49-79.21-1.12C111.07,34.76,78.78,18.79,42.76,50ZM216,172.25c-26.79,21.16-49.87,9.74-76.45-3.41-25-12.35-52.81-26.13-83.55-8.4V59.79c26.79-21.16,49.87-9.75,76.45,3.4,25,12.35,52.82,26.13,83.55,8.4Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M45.39,53.06a4,4,0,0,0-1.39,3V224a4,4,0,0,0,8,0V177.87c29.41-24.39,55.08-11.69,82.23,1.73,16.5,8.17,33.33,16.5,51.13,16.5,13.14,0,26.81-4.55,41.26-17.06a4,4,0,0,0,1.38-3v-120a4,4,0,0,0-6.62-3c-30,26-56,13.07-83.61-.57C109.07,38.28,79.4,23.62,45.39,53.06ZM220,174.17c-29.41,24.4-55.08,11.7-82.23-1.73-26.82-13.27-54.5-27-85.77-4.66V57.92c29.41-24.4,55.08-11.7,82.23,1.73,26.82,13.27,54.5,27,85.77,4.66Z"
        }))
    ]
]);


const $6633ea98f1283125$export$4fd8d63cb0915eb0 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $0e93dfc4cb9b014e$export$2e2bcd8739ae039)
    })));
$6633ea98f1283125$export$4fd8d63cb0915eb0.displayName = "FlagIcon";
const $6633ea98f1283125$export$48ea269755562084 = $6633ea98f1283125$export$4fd8d63cb0915eb0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a4dd6699f2d4b74c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.14,69.17,186.83,33.86A19.86,19.86,0,0,0,172.69,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V83.31A19.86,19.86,0,0,0,222.14,69.17ZM164,204H92V160h72Zm40,0H188V156a20,20,0,0,0-20-20H88a20,20,0,0,0-20,20v48H52V52H171l33,33ZM164,84a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h56A12,12,0,0,1,164,84Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,83.31V208a8,8,0,0,1-8,8H176V152a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v64H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H172.69a8,8,0,0,1,5.65,2.34l35.32,35.32A8,8,0,0,1,216,83.31Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM208,208H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M217.9,73.42,182.58,38.1a13.9,13.9,0,0,0-9.89-4.1H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V83.31A13.9,13.9,0,0,0,217.9,73.42ZM170,210H86V152a2,2,0,0,1,2-2h80a2,2,0,0,1,2,2Zm40-2a2,2,0,0,1-2,2H182V152a14,14,0,0,0-14-14H88a14,14,0,0,0-14,14v58H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H172.69a2,2,0,0,1,1.41.58L209.42,81.9a2,2,0,0,1,.58,1.41ZM158,72a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h56A6,6,0,0,1,158,72Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,74.83,181.17,39.51A11.93,11.93,0,0,0,172.69,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V83.31A11.93,11.93,0,0,0,216.49,74.83ZM172,212H84V152a4,4,0,0,1,4-4h80a4,4,0,0,1,4,4Zm40-4a4,4,0,0,1-4,4H180V152a12,12,0,0,0-12-12H88a12,12,0,0,0-12,12v60H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H172.69a4,4,0,0,1,2.82,1.17l35.32,35.32A4,4,0,0,1,212,83.31ZM156,72a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h56A4,4,0,0,1,156,72Z"
        }))
    ]
]);


const $d09bbb62b804b286$export$72eeb4bb593c0c95 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $a4dd6699f2d4b74c$export$2e2bcd8739ae039)
    })));
$d09bbb62b804b286$export$72eeb4bb593c0c95.displayName = "FloppyDiskIcon";
const $d09bbb62b804b286$export$5df7d345a432f343 = $d09bbb62b804b286$export$72eeb4bb593c0c95;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c5e3b6b3c3abd376$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $a9d524fe12241a80$export$b7c13c52029a403 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $c5e3b6b3c3abd376$export$2e2bcd8739ae039)
    })));
$a9d524fe12241a80$export$b7c13c52029a403.displayName = "FolderIcon";
const $a9d524fe12241a80$export$80729fed35a16515 = $a9d524fe12241a80$export$b7c13c52029a403;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $1f892b5f8d056b10$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248.23,112.31A20,20,0,0,0,232,104H220V88a20,20,0,0,0-20-20H132L105.34,48a20.12,20.12,0,0,0-12-4H40A20,20,0,0,0,20,64V208a12,12,0,0,0,12,12H211.1a12,12,0,0,0,11.33-8l28.49-81.47.06-.17A20,20,0,0,0,248.23,112.31ZM92,68l28.8,21.6A12,12,0,0,0,128,92h68v12H69.77a20,20,0,0,0-18.94,13.58L44,137.15V68ZM202.59,196H48.89l23.72-68H226.37Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,88v24H69.77a8,8,0,0,0-7.59,5.47L32,208V64a8,8,0,0,1,8-8H93.33a8,8,0,0,1,4.8,1.6L128,80h72A8,8,0,0,1,208,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245,110.64A16,16,0,0,0,232,104H216V88a16,16,0,0,0-16-16H130.67L102.94,51.2a16.14,16.14,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V208a8,8,0,0,0,8,8H211.1a8,8,0,0,0,7.59-5.47l28.49-85.47A16.05,16.05,0,0,0,245,110.64ZM93.34,64,123.2,86.4A8,8,0,0,0,128,88h72v16H69.77a16,16,0,0,0-15.18,10.94L40,158.7V64Zm112,136H43.1l26.67-80H232Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245,110.64A16,16,0,0,0,232,104H216V88a16,16,0,0,0-16-16H130.67L102.94,51.2a16.14,16.14,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V208h0a8,8,0,0,0,8,8H211.1a8,8,0,0,0,7.59-5.47l28.49-85.47A16.05,16.05,0,0,0,245,110.64ZM93.34,64,123.2,86.4A8,8,0,0,0,128,88h72v16H69.77a16,16,0,0,0-15.18,10.94L40,158.7V64Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.36,111.81A14,14,0,0,0,232,106H214V88a14,14,0,0,0-14-14H130L101.74,52.8a14.06,14.06,0,0,0-8.4-2.8H40A14,14,0,0,0,26,64V208a6,6,0,0,0,6,6H211.1a6,6,0,0,0,5.69-4.1l28.49-85.47A14,14,0,0,0,243.36,111.81ZM40,62H93.34a2,2,0,0,1,1.2.4L124.4,84.8A6,6,0,0,0,128,86h72a2,2,0,0,1,2,2v18H69.77a14,14,0,0,0-13.28,9.57L38,171V64A2,2,0,0,1,40,62Zm193.9,58.63L206.78,202H40.33l27.54-82.63a2,2,0,0,1,1.9-1.37H232a2,2,0,0,1,1.9,2.63Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245,110.64A16,16,0,0,0,232,104H216V88a16,16,0,0,0-16-16H130.67L102.94,51.2a16.14,16.14,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V208h0a8,8,0,0,0,8,8H211.1a8,8,0,0,0,7.59-5.47l28.49-85.47A16.05,16.05,0,0,0,245,110.64ZM93.34,64,123.2,86.4A8,8,0,0,0,128,88h72v16H69.77a16,16,0,0,0-15.18,10.94L40,158.7V64Zm112,136H43.1l26.67-80H232Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M241.72,113a11.88,11.88,0,0,0-9.73-5H212V88a12,12,0,0,0-12-12H129.33l-28.8-21.6a12.05,12.05,0,0,0-7.2-2.4H40A12,12,0,0,0,28,64V208a4,4,0,0,0,4,4H211.09a4,4,0,0,0,3.79-2.74l28.49-85.47A11.86,11.86,0,0,0,241.72,113ZM40,60H93.33a4,4,0,0,1,2.4.8L125.6,83.2a4,4,0,0,0,2.4.8h72a4,4,0,0,1,4,4v20H69.76a12,12,0,0,0-11.38,8.21L36,183.35V64A4,4,0,0,1,40,60Zm195.78,61.26L208.2,204H37.55L66,118.74A4,4,0,0,1,69.76,116H232a4,4,0,0,1,3.79,5.26Z"
        }))
    ]
]);


const $c752b0dc2a4fd996$export$d2044f064f31dbdd = $7fPBF.forwardRef((r, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: n
    }, r), {
        weights: (0, $1f892b5f8d056b10$export$2e2bcd8739ae039)
    })));
$c752b0dc2a4fd996$export$d2044f064f31dbdd.displayName = "FolderOpenIcon";
const $c752b0dc2a4fd996$export$6032e6db9bc400f5 = $c752b0dc2a4fd996$export$d2044f064f31dbdd;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3981f303804dc6f5$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,68H132L105.33,48a20.12,20.12,0,0,0-12-4H40A20,20,0,0,0,20,64V200a20,20,0,0,0,20,20H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68Zm-4,128H44V68H92l28.8,21.6A12,12,0,0,0,128,92h84Zm-84-88a12,12,0,0,1,12,12v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120A12,12,0,0,1,128,108Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,88V200.89a7.11,7.11,0,0,1-7.11,7.11H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33a8,8,0,0,1,4.8,1.6L128,80h88A8,8,0,0,1,224,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm0,128H40V64H93.33L123.2,86.4A8,8,0,0,0,128,88h88Zm-56-56a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,144Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm-64,80H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,74H130L101.73,52.8a14,14,0,0,0-8.4-2.8H40A14,14,0,0,0,26,64V200a14,14,0,0,0,14,14H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74Zm2,126.89a1.11,1.11,0,0,1-1.11,1.11H40a2,2,0,0,1-2-2V64a2,2,0,0,1,2-2H93.33a2,2,0,0,1,1.2.4L124.4,84.8A6,6,0,0,0,128,86h88a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm0,128H40V64H93.33L123.2,86.4A8,8,0,0,0,128,88h88Zm-56-56a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,144Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,76H129.33l-28.8-21.6a12.05,12.05,0,0,0-7.2-2.4H40A12,12,0,0,0,28,64V200a12,12,0,0,0,12,12H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76Zm4,124.89a3.12,3.12,0,0,1-3.11,3.11H40a4,4,0,0,1-4-4V64a4,4,0,0,1,4-4H93.33a4,4,0,0,1,2.4.8L125.6,83.2a4,4,0,0,0,2.4.8h88a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z"
        }))
    ]
]);


const $b689941a4e3d9043$export$73cbd9fbc6f9a78e = $7fPBF.forwardRef((r, l)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: l
    }, r), {
        weights: (0, $3981f303804dc6f5$export$2e2bcd8739ae039)
    })));
$b689941a4e3d9043$export$73cbd9fbc6f9a78e.displayName = "FolderSimplePlusIcon";
const $b689941a4e3d9043$export$659fd1c84f158069 = $b689941a4e3d9043$export$73cbd9fbc6f9a78e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $69911170e32027f2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,116H152a12,12,0,0,1,0-24h24a12,12,0,0,1,0,24ZM104,92h-4V88a12,12,0,0,0-24,0v4H72a12,12,0,0,0,0,24h4v4a12,12,0,0,0,24,0v-4h4a12,12,0,0,0,0-24ZM244.76,202.94a40,40,0,0,1-61,5.35,7,7,0,0,1-.53-.56L144.67,164H111.33L72.81,207.73c-.17.19-.35.38-.53.56A40,40,0,0,1,4.62,173.05a1.18,1.18,0,0,1,0-.2L21,88.79A63.88,63.88,0,0,1,83.88,36H172a64.08,64.08,0,0,1,62.93,52.48,1.8,1.8,0,0,1,0,.19l16.36,84.17a1.77,1.77,0,0,1,0,.2A39.74,39.74,0,0,1,244.76,202.94ZM172,140a40,40,0,0,0,0-80H83.89A39.9,39.9,0,0,0,44.62,93.06a1.55,1.55,0,0,0,0,.21l-16.34,84a16,16,0,0,0,13,18.44,16.07,16.07,0,0,0,13.86-4.21L96.9,144.07a12,12,0,0,1,9-4.07Zm55.76,37.31-7-35.95a63.84,63.84,0,0,1-44.27,22.46l24.41,27.72a16,16,0,0,0,26.85-14.23Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.86,207.57a28,28,0,0,1-24.66-7.77L150.09,152H172a51.94,51.94,0,0,0,51.2-61h0l16.36,84.17A28,28,0,0,1,216.86,207.57Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,112H152a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16ZM104,96H96V88a8,8,0,0,0-16,0v8H72a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16ZM241.48,200.65a36,36,0,0,1-54.94,4.81c-.12-.12-.24-.24-.35-.37L146.48,160h-37L69.81,205.09l-.35.37A36.08,36.08,0,0,1,44,216,36,36,0,0,1,8.56,173.75a.68.68,0,0,1,0-.14L24.93,89.52A59.88,59.88,0,0,1,83.89,40H172a60.08,60.08,0,0,1,59,49.25c0,.06,0,.12,0,.18l16.37,84.17a.68.68,0,0,1,0,.14A35.74,35.74,0,0,1,241.48,200.65ZM172,144a44,44,0,0,0,0-88H83.89A43.9,43.9,0,0,0,40.68,92.37l0,.13L24.3,176.59A20,20,0,0,0,58,194.3l41.92-47.59a8,8,0,0,1,6-2.71Zm59.7,32.59-8.74-45A60,60,0,0,1,172,160h-4.2L198,194.31a20.09,20.09,0,0,0,17.46,5.39,20,20,0,0,0,16.23-23.11Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.44,173.75a.68.68,0,0,0,0-.14L231.05,89.44c0-.06,0-.12,0-.18A60.08,60.08,0,0,0,172,40H83.89a59.88,59.88,0,0,0-59,49.52L8.58,173.61a.68.68,0,0,0,0,.14,36,36,0,0,0,60.9,31.71l.35-.37L109.52,160h37l39.71,45.09c.11.13.23.25.35.37A36.08,36.08,0,0,0,212,216a36,36,0,0,0,35.43-42.25ZM104,112H96v8a8,8,0,0,1-16,0v-8H72a8,8,0,0,1,0-16h8V88a8,8,0,0,1,16,0v8h8a8,8,0,0,1,0,16Zm40-8a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16H152A8,8,0,0,1,144,104Zm84.37,87.47a19.84,19.84,0,0,1-12.9,8.23A20.09,20.09,0,0,1,198,194.31L167.8,160H172a60,60,0,0,0,51-28.38l8.74,45A19.82,19.82,0,0,1,228.37,191.47Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,110H152a6,6,0,0,1,0-12h24a6,6,0,0,1,0,12ZM104,98H94V88a6,6,0,0,0-12,0V98H72a6,6,0,0,0,0,12H82v10a6,6,0,0,0,12,0V110h10a6,6,0,0,0,0-12ZM239.84,199.5A34,34,0,0,1,212,214,34.11,34.11,0,0,1,188,204.05l-.26-.28L147.38,158H108.62L68.31,203.76,68,204A34,34,0,0,1,44,214a34,34,0,0,1-33.46-39.91s0-.06,0-.1L26.9,89.88A57.89,57.89,0,0,1,83.89,42H172a58.07,58.07,0,0,1,57.05,47.63c0,.07,0,.12,0,.19L245.46,174s0,.07,0,.11A33.75,33.75,0,0,1,239.84,199.5ZM172,146a46,46,0,0,0,0-92H83.89A45.9,45.9,0,0,0,38.71,92a.36.36,0,0,0,0,.1L22.33,176.23a22,22,0,0,0,37.11,19.45l42-47.65a6,6,0,0,1,4.5-2Zm61.67,30.23-9.79-50.35A58.06,58.06,0,0,1,172,158h-8.63l33.19,37.68a22,22,0,0,0,37.11-19.45Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,112H152a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16ZM104,96H96V88a8,8,0,0,0-16,0v8H72a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16ZM241.48,200.65a36,36,0,0,1-54.94,4.81c-.12-.12-.24-.24-.35-.37L146.48,160h-37L69.81,205.09l-.35.37A36.08,36.08,0,0,1,44,216,36,36,0,0,1,8.56,173.75a.68.68,0,0,1,0-.14L24.93,89.52A59.88,59.88,0,0,1,83.89,40H172a60.08,60.08,0,0,1,59,49.25c0,.06,0,.12,0,.18l16.37,84.17a.68.68,0,0,1,0,.14A35.74,35.74,0,0,1,241.48,200.65ZM172,144a44,44,0,0,0,0-88H83.89A43.9,43.9,0,0,0,40.68,92.37l0,.13L24.3,176.59A20,20,0,0,0,58,194.3l41.92-47.59a8,8,0,0,1,6-2.71Zm59.7,32.59-8.74-45A60,60,0,0,1,172,160h-4.2L198,194.31a20.09,20.09,0,0,0,17.46,5.39,20,20,0,0,0,16.23-23.11Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,108H152a4,4,0,0,1,0-8h24a4,4,0,0,1,0,8Zm-72-8H92V88a4,4,0,0,0-8,0v12H72a4,4,0,0,0,0,8H84v12a4,4,0,0,0,8,0V108h12a4,4,0,0,0,0-8Zm134.21,98.36a32,32,0,0,1-48.84,4.27l-.17-.18L148.29,156H107.72L66.81,202.44l-.18.19A32.08,32.08,0,0,1,44,212a32,32,0,0,1-31.5-37.56L28.87,90.21A55.87,55.87,0,0,1,83.89,44H172a56.07,56.07,0,0,1,55.1,46.1.29.29,0,0,1,0,.1l16.37,84.16A31.86,31.86,0,0,1,238.21,198.36ZM172,148a48,48,0,1,0,0-96H83.9A47.9,47.9,0,0,0,36.74,91.67L20.36,175.9a24,24,0,0,0,19.48,27.73,24,24,0,0,0,21-6.58l42-47.69a4,4,0,0,1,3-1.36Zm63.63,27.83-11-56.66A56.09,56.09,0,0,1,172,156H159l36.16,41.06a24,24,0,0,0,40.52-21.23Z"
        }))
    ]
]);


const $07eb5346ad9d064e$export$67c6cd66cb8e49db = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $69911170e32027f2$export$2e2bcd8739ae039)
    })));
$07eb5346ad9d064e$export$67c6cd66cb8e49db.displayName = "GameControllerIcon";
const $07eb5346ad9d064e$export$f3f3f6c0124f08de = $07eb5346ad9d064e$export$67c6cd66cb8e49db;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6c6004cf2e0c084c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M209.88,69.83A115.19,115.19,0,0,0,128,36h-.41C63.85,36.22,12,88.76,12,153.13V176a20,20,0,0,0,20,20H224a20,20,0,0,0,20-20V152A115.25,115.25,0,0,0,209.88,69.83ZM220,172H127.32l46.44-65A12,12,0,1,0,154.24,93L97.82,172H36V153.13c0-1.72,0-3.43.14-5.13H56a12,12,0,0,0,0-24H40.62c10.91-33.39,40-58.52,75.38-63.21V80a12,12,0,0,0,24,0V60.8A92,92,0,0,1,215.66,124H200a12,12,0,0,0,0,24h19.9c.06,1.33.1,2.66.1,4Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,152v24a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V153.13C24,95.65,70.15,48.2,127.63,48A104,104,0,0,1,232,152Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M207.06,72.67A111.24,111.24,0,0,0,128,40h-.4C66.07,40.21,16,91,16,153.13V176a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V152A111.25,111.25,0,0,0,207.06,72.67ZM224,176H119.71l54.76-75.3a8,8,0,0,0-12.94-9.42L99.92,176H32V153.13c0-3.08.15-6.12.43-9.13H56a8,8,0,0,0,0-16H35.27c10.32-38.86,44-68.24,84.73-71.66V80a8,8,0,0,0,16,0V56.33A96.14,96.14,0,0,1,221,128H200a8,8,0,0,0,0,16h23.67c.21,2.65.33,5.31.33,8Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,152v24a16,16,0,0,1-16,16H115.93a4,4,0,0,1-3.24-6.35L174.27,101a8.21,8.21,0,0,0-1.37-11.3,8,8,0,0,0-11.37,1.61l-72,99.06A4,4,0,0,1,86.25,192H32a16,16,0,0,1-16-16V153.13c0-1.79,0-3.57.13-5.33a4,4,0,0,1,4-3.8H48a8,8,0,0,0,8-8.53A8.17,8.17,0,0,0,47.73,128H23.92a4,4,0,0,1-3.87-5c12-43.84,49.66-77.13,95.52-82.28a4,4,0,0,1,4.43,4V72a8,8,0,0,0,8.53,8A8.17,8.17,0,0,0,136,71.73V44.67a4,4,0,0,1,4.43-4A112.18,112.18,0,0,1,236.23,123a4,4,0,0,1-3.88,5H208.27a8.17,8.17,0,0,0-8.25,7.47,8,8,0,0,0,8,8.53h27.92a4,4,0,0,1,4,3.86C240,149.23,240,150.61,240,152Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M205.65,74.08A109.26,109.26,0,0,0,128,42h-.39C67.17,42.21,18,92.06,18,153.13V176a14,14,0,0,0,14,14H224a14,14,0,0,0,14-14V152A109.3,109.3,0,0,0,205.65,74.08ZM226,176a2,2,0,0,1-2,2H115.78l57.07-78.47a6,6,0,0,0-9.7-7.06L100.94,178H32a2,2,0,0,1-2-2V153.13A102.36,102.36,0,0,1,30.62,142H56a6,6,0,0,0,0-12H32.71C42.6,88.4,78.53,56.86,122,54.19V80a6,6,0,0,0,12,0V54.19A98.05,98.05,0,0,1,223.53,130H200a6,6,0,0,0,0,12h25.5c.33,3.3.5,6.64.5,10Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M207.06,72.67A111.24,111.24,0,0,0,128,40h-.4C66.07,40.21,16,91,16,153.13V176a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V152A111.25,111.25,0,0,0,207.06,72.67ZM224,176H119.71l54.76-75.3a8,8,0,0,0-12.94-9.42L99.92,176H32V153.13c0-3.08.15-6.12.43-9.13H56a8,8,0,0,0,0-16H35.27c10.32-38.86,44-68.24,84.73-71.66V80a8,8,0,0,0,16,0V56.33A96.14,96.14,0,0,1,221,128H200a8,8,0,0,0,0,16h23.67c.21,2.65.33,5.31.33,8Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204.23,75.5A107.37,107.37,0,0,0,127.62,44C68.28,44.21,20,93.16,20,153.13V176a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V152A107.25,107.25,0,0,0,204.23,75.5ZM228,176a4,4,0,0,1-4,4H111.85l59.38-81.65a4,4,0,1,0-6.46-4.7L102,180H32a4,4,0,0,1-4-4V153.13A103.42,103.42,0,0,1,28.84,140H56a4,4,0,0,0,0-8H30.21C39.59,87.66,77.84,53.93,124,52.09V80a4,4,0,0,0,8,0V52.08A100.08,100.08,0,0,1,226,132H200a4,4,0,0,0,0,8h27.29a101.6,101.6,0,0,1,.71,12Z"
        }))
    ]
]);


const $d545586961bd20bd$export$5ff880ebd1cf0b62 = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, a), {
        weights: (0, $6c6004cf2e0c084c$export$2e2bcd8739ae039)
    })));
$d545586961bd20bd$export$5ff880ebd1cf0b62.displayName = "GaugeIcon";
const $d545586961bd20bd$export$be3aa080178503e1 = $d545586961bd20bd$export$5ff880ebd1cf0b62;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b7a637587bfcf43a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,116H219.22A91.1,91.1,0,0,0,213,92.79l11.08-6.4a12,12,0,1,0-12-20.78L201,72a92.85,92.85,0,0,0-17-17l6.41-11.11a12,12,0,1,0-20.78-12L163.21,43A91.1,91.1,0,0,0,140,36.78V24a12,12,0,0,0-24,0V36.78A91.1,91.1,0,0,0,92.79,43l-6.4-11.08a12,12,0,0,0-20.78,12L72,55A92.85,92.85,0,0,0,55,72L43.93,65.61a12,12,0,0,0-12,20.78L43,92.79A91.1,91.1,0,0,0,36.78,116H24a12,12,0,0,0,0,24H36.78A91.1,91.1,0,0,0,43,163.21l-11.08,6.4a12,12,0,1,0,12,20.78L55,184a92.85,92.85,0,0,0,17,17l-6.41,11.11a12,12,0,1,0,20.78,12L92.79,213A91.1,91.1,0,0,0,116,219.22V232a12,12,0,0,0,24,0V219.22A91.1,91.1,0,0,0,163.21,213l6.4,11.08a12,12,0,0,0,20.78-12L184,201a92.85,92.85,0,0,0,17-17l11.11,6.41a12,12,0,1,0,12-20.78L213,163.21A91.1,91.1,0,0,0,219.22,140H232a12,12,0,0,0,0-24ZM128,60a68.1,68.1,0,0,1,66.92,56h-60l-30-52A67.61,67.61,0,0,1,128,60ZM60,128A67.9,67.9,0,0,1,84.16,76.07l30,51.93-30,51.93A67.9,67.9,0,0,1,60,128Zm68,68a67.61,67.61,0,0,1-23.07-4l30-52h60A68.1,68.1,0,0,1,128,196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,128a80,80,0,1,1-80-80A80,80,0,0,1,208,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,120H215.63a87.27,87.27,0,0,0-7.74-28.88l14.18-8.19a8,8,0,0,0-8-13.86l-14.2,8.2a88.78,88.78,0,0,0-21.14-21.14l8.2-14.2a8,8,0,0,0-13.86-8l-8.19,14.18A87.27,87.27,0,0,0,136,40.37V24a8,8,0,0,0-16,0V40.37a87.27,87.27,0,0,0-28.88,7.74L82.93,33.93a8,8,0,0,0-13.86,8l8.2,14.2A88.78,88.78,0,0,0,56.13,77.27l-14.2-8.2a8,8,0,0,0-8,13.86l14.18,8.19A87.27,87.27,0,0,0,40.37,120H24a8,8,0,0,0,0,16H40.37a87.27,87.27,0,0,0,7.74,28.88l-14.18,8.19a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l14.2-8.2a88.78,88.78,0,0,0,21.14,21.14l-8.2,14.2a8,8,0,0,0,13.86,8l8.19-14.18A87.27,87.27,0,0,0,120,215.63V232a8,8,0,0,0,16,0V215.63a87.27,87.27,0,0,0,28.88-7.74l8.19,14.18a8,8,0,0,0,13.86-8l-8.2-14.2a88.78,88.78,0,0,0,21.14-21.14l14.2,8.2A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-14.18-8.19A87.27,87.27,0,0,0,215.63,136H232a8,8,0,0,0,0-16ZM85.31,185.94a71.92,71.92,0,0,1,0-115.88L118.76,128ZM128,200A71.58,71.58,0,0,1,99.16,194L132.62,136h66.92A72.08,72.08,0,0,1,128,200Zm4.62-80L99.16,62.05a71.94,71.94,0,0,1,100.38,58Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,120h-8.34a95.07,95.07,0,0,0-8.82-32.9l7.23-4.17a8,8,0,0,0-8-13.86l-7.25,4.19a97,97,0,0,0-24.08-24.08l4.19-7.25a8,8,0,0,0-13.86-8l-4.17,7.23A95.07,95.07,0,0,0,136,32.34V24a8,8,0,0,0-16,0v8.34a95.07,95.07,0,0,0-32.9,8.82l-4.17-7.23a8,8,0,0,0-13.86,8l4.19,7.25A97,97,0,0,0,49.18,73.26l-7.25-4.19a8,8,0,0,0-8,13.86l7.23,4.17A95.07,95.07,0,0,0,32.34,120H24a8,8,0,0,0,0,16h8.34a95.07,95.07,0,0,0,8.82,32.9l-7.23,4.17a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l7.25-4.19a97,97,0,0,0,24.08,24.08l-4.19,7.25a8,8,0,0,0,13.86,8l4.17-7.23a95.07,95.07,0,0,0,32.9,8.82V232a8,8,0,0,0,16,0v-8.34a95.07,95.07,0,0,0,32.9-8.82l4.17,7.23a8,8,0,0,0,13.86-8l-4.19-7.25a97,97,0,0,0,24.08-24.08l7.25,4.19A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-7.23-4.17a95.07,95.07,0,0,0,8.82-32.9H232a8,8,0,0,0,0-16ZM72,128A55.91,55.91,0,0,1,93.38,84l25.38,44L93.38,172A55.91,55.91,0,0,1,72,128Zm56,56a55.67,55.67,0,0,1-20.78-4l25.4-44h50.8A56.09,56.09,0,0,1,128,184Zm4.62-64-25.4-44a56,56,0,0,1,76.2,44Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,122H213.77a85.56,85.56,0,0,0-8.49-31.69l15.79-9.11a6,6,0,0,0-6-10.4l-15.8,9.12a86.72,86.72,0,0,0-23.19-23.19l9.12-15.8a6,6,0,0,0-10.4-6l-9.11,15.79A85.56,85.56,0,0,0,134,42.23V24a6,6,0,0,0-12,0V42.23a85.56,85.56,0,0,0-31.69,8.49L81.2,34.93a6,6,0,0,0-10.4,6l9.12,15.8A86.72,86.72,0,0,0,56.73,79.92L40.93,70.8a6,6,0,0,0-6,10.4l15.79,9.11A85.56,85.56,0,0,0,42.23,122H24a6,6,0,0,0,0,12H42.23a85.56,85.56,0,0,0,8.49,31.69L34.93,174.8a6,6,0,0,0,6,10.4l15.8-9.12a86.72,86.72,0,0,0,23.19,23.19l-9.12,15.8a6,6,0,0,0,10.4,6l9.11-15.79A85.56,85.56,0,0,0,122,213.77V232a6,6,0,0,0,12,0V213.77a85.56,85.56,0,0,0,31.69-8.49l9.11,15.79a6,6,0,0,0,5.21,3,5.93,5.93,0,0,0,3-.81,6,6,0,0,0,2.2-8.19l-9.12-15.8a86.72,86.72,0,0,0,23.19-23.19l15.8,9.12a6,6,0,0,0,6-10.4l-15.79-9.11A85.56,85.56,0,0,0,213.77,134H232a6,6,0,0,0,0-12ZM86,188.84A73.9,73.9,0,0,1,86,67.16L121.07,128ZM128,202a73.5,73.5,0,0,1-31.67-7.14L131.46,134h70.28A74.09,74.09,0,0,1,128,202Zm3.46-80L96.33,61.14A73.95,73.95,0,0,1,201.74,122Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,120H215.63a87.27,87.27,0,0,0-7.74-28.88l14.18-8.19a8,8,0,0,0-8-13.86l-14.2,8.2a88.78,88.78,0,0,0-21.14-21.14l8.2-14.2a8,8,0,0,0-13.86-8l-8.19,14.18A87.27,87.27,0,0,0,136,40.37V24a8,8,0,0,0-16,0V40.37a87.27,87.27,0,0,0-28.88,7.74L82.93,33.93a8,8,0,0,0-13.86,8l8.2,14.2A88.78,88.78,0,0,0,56.13,77.27l-14.2-8.2a8,8,0,0,0-8,13.86l14.18,8.19A87.27,87.27,0,0,0,40.37,120H24a8,8,0,0,0,0,16H40.37a87.27,87.27,0,0,0,7.74,28.88l-14.18,8.19a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l14.2-8.2a88.78,88.78,0,0,0,21.14,21.14l-8.2,14.2a8,8,0,0,0,13.86,8l8.19-14.18A87.27,87.27,0,0,0,120,215.63V232a8,8,0,0,0,16,0V215.63a87.27,87.27,0,0,0,28.88-7.74l8.19,14.18a8,8,0,0,0,13.86-8l-8.2-14.2a88.78,88.78,0,0,0,21.14-21.14l14.2,8.2A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-14.18-8.19A87.27,87.27,0,0,0,215.63,136H232a8,8,0,0,0,0-16ZM128,56a72.08,72.08,0,0,1,71.54,64H132.62L99.16,62.05A71.58,71.58,0,0,1,128,56ZM56,128A72,72,0,0,1,85.31,70.06L118.76,128,85.31,185.94A72,72,0,0,1,56,128Zm72,72A71.58,71.58,0,0,1,99.16,194L132.62,136h66.92A72.08,72.08,0,0,1,128,200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,124H211.9a83.35,83.35,0,0,0-9.27-34.47l17.44-10.07a4,4,0,0,0-4-6.92L198.62,82.61a84.54,84.54,0,0,0-25.23-25.23l10.07-17.45a4,4,0,0,0-6.92-4L166.47,53.37A83.35,83.35,0,0,0,132,44.1V24a4,4,0,0,0-8,0V44.1a83.35,83.35,0,0,0-34.47,9.27L79.46,35.93a4,4,0,0,0-6.92,4L82.61,57.38A84.54,84.54,0,0,0,57.38,82.61L39.93,72.54a4,4,0,1,0-4,6.92L53.37,89.53A83.35,83.35,0,0,0,44.1,124H24a4,4,0,0,0,0,8H44.1a83.35,83.35,0,0,0,9.27,34.47L35.93,176.54a4,4,0,0,0,2,7.46,3.9,3.9,0,0,0,2-.54l17.45-10.07a84.54,84.54,0,0,0,25.23,25.23L72.54,216.07A4,4,0,0,0,74,221.53a4,4,0,0,0,5.46-1.46l10.07-17.44A83.35,83.35,0,0,0,124,211.9V232a4,4,0,0,0,8,0V211.9a83.35,83.35,0,0,0,34.47-9.27l10.07,17.44a4,4,0,0,0,6.92-4l-10.07-17.45a84.54,84.54,0,0,0,25.23-25.23l17.45,10.07a3.9,3.9,0,0,0,2,.54,4,4,0,0,0,2-7.46l-17.44-10.07A83.35,83.35,0,0,0,211.9,132H232a4,4,0,0,0,0-8ZM128,52a76.09,76.09,0,0,1,75.89,72H130.31L93.53,60.3A75.59,75.59,0,0,1,128,52ZM52,128A76,76,0,0,1,86.61,64.31L123.38,128,86.61,191.69A76,76,0,0,1,52,128Zm76,76a75.59,75.59,0,0,1-34.47-8.3L130.31,132h73.58A76.09,76.09,0,0,1,128,204Z"
        }))
    ]
]);


const $27341b9e147c07ff$export$9d72c0eeb3943e75 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $b7a637587bfcf43a$export$2e2bcd8739ae039)
    })));
$27341b9e147c07ff$export$9d72c0eeb3943e75.displayName = "GearFineIcon";
const $27341b9e147c07ff$export$69d762f03497352 = $27341b9e147c07ff$export$9d72c0eeb3943e75;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7fac16834f0e6b11$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,76a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,76Zm0,80a28,28,0,1,1,28-28A28,28,0,0,1,128,156Zm92-27.21v-1.58l14-17.51a12,12,0,0,0,2.23-10.59A111.75,111.75,0,0,0,225,71.89,12,12,0,0,0,215.89,66L193.61,63.5l-1.11-1.11L190,40.1A12,12,0,0,0,184.11,31a111.67,111.67,0,0,0-27.23-11.27A12,12,0,0,0,146.3,22L128.79,36h-1.58L109.7,22a12,12,0,0,0-10.59-2.23A111.75,111.75,0,0,0,71.89,31.05,12,12,0,0,0,66,40.11L63.5,62.39,62.39,63.5,40.1,66A12,12,0,0,0,31,71.89,111.67,111.67,0,0,0,19.77,99.12,12,12,0,0,0,22,109.7l14,17.51v1.58L22,146.3a12,12,0,0,0-2.23,10.59,111.75,111.75,0,0,0,11.29,27.22A12,12,0,0,0,40.11,190l22.28,2.48,1.11,1.11L66,215.9A12,12,0,0,0,71.89,225a111.67,111.67,0,0,0,27.23,11.27A12,12,0,0,0,109.7,234l17.51-14h1.58l17.51,14a12,12,0,0,0,10.59,2.23A111.75,111.75,0,0,0,184.11,225a12,12,0,0,0,5.91-9.06l2.48-22.28,1.11-1.11L215.9,190a12,12,0,0,0,9.06-5.91,111.67,111.67,0,0,0,11.27-27.23A12,12,0,0,0,234,146.3Zm-24.12-4.89a70.1,70.1,0,0,1,0,8.2,12,12,0,0,0,2.61,8.22l12.84,16.05A86.47,86.47,0,0,1,207,166.86l-20.43,2.27a12,12,0,0,0-7.65,4,69,69,0,0,1-5.8,5.8,12,12,0,0,0-4,7.65L166.86,207a86.47,86.47,0,0,1-10.49,4.35l-16.05-12.85a12,12,0,0,0-7.5-2.62c-.24,0-.48,0-.72,0a70.1,70.1,0,0,1-8.2,0,12.06,12.06,0,0,0-8.22,2.6L99.63,211.33A86.47,86.47,0,0,1,89.14,207l-2.27-20.43a12,12,0,0,0-4-7.65,69,69,0,0,1-5.8-5.8,12,12,0,0,0-7.65-4L49,166.86a86.47,86.47,0,0,1-4.35-10.49l12.84-16.05a12,12,0,0,0,2.61-8.22,70.1,70.1,0,0,1,0-8.2,12,12,0,0,0-2.61-8.22L44.67,99.63A86.47,86.47,0,0,1,49,89.14l20.43-2.27a12,12,0,0,0,7.65-4,69,69,0,0,1,5.8-5.8,12,12,0,0,0,4-7.65L89.14,49a86.47,86.47,0,0,1,10.49-4.35l16.05,12.85a12.06,12.06,0,0,0,8.22,2.6,70.1,70.1,0,0,1,8.2,0,12,12,0,0,0,8.22-2.6l16.05-12.85A86.47,86.47,0,0,1,166.86,49l2.27,20.43a12,12,0,0,0,4,7.65,69,69,0,0,1,5.8,5.8,12,12,0,0,0,7.65,4L207,89.14a86.47,86.47,0,0,1,4.35,10.49l-12.84,16.05A12,12,0,0,0,195.88,123.9Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M207.86,123.18l16.78-21a99.14,99.14,0,0,0-10.07-24.29l-26.7-3a81,81,0,0,0-6.81-6.81l-3-26.71a99.43,99.43,0,0,0-24.3-10l-21,16.77a81.59,81.59,0,0,0-9.64,0l-21-16.78A99.14,99.14,0,0,0,77.91,41.43l-3,26.7a81,81,0,0,0-6.81,6.81l-26.71,3a99.43,99.43,0,0,0-10,24.3l16.77,21a81.59,81.59,0,0,0,0,9.64l-16.78,21a99.14,99.14,0,0,0,10.07,24.29l26.7,3a81,81,0,0,0,6.81,6.81l3,26.71a99.43,99.43,0,0,0,24.3,10l21-16.77a81.59,81.59,0,0,0,9.64,0l21,16.78a99.14,99.14,0,0,0,24.29-10.07l3-26.7a81,81,0,0,0,6.81-6.81l26.71-3a99.43,99.43,0,0,0,10-24.3l-16.77-21A81.59,81.59,0,0,0,207.86,123.18ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.29,107.29,0,0,0-26.25-10.86,8,8,0,0,0-7.06,1.48L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8.06,8.06,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8.06,8.06,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,130.16q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.29,107.29,0,0,0-26.25-10.86,8,8,0,0,0-7.06,1.48L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162ZM214,130.84c.06-1.89.06-3.79,0-5.68L229.33,106a6,6,0,0,0,1.11-5.29A105.34,105.34,0,0,0,219.76,74.9a6,6,0,0,0-4.53-3l-24.45-2.71q-1.93-2.07-4-4l-2.72-24.46a6,6,0,0,0-3-4.53,105.65,105.65,0,0,0-25.77-10.66A6,6,0,0,0,150,26.68l-19.2,15.37c-1.89-.06-3.79-.06-5.68,0L106,26.67a6,6,0,0,0-5.29-1.11A105.34,105.34,0,0,0,74.9,36.24a6,6,0,0,0-3,4.53L69.23,65.22q-2.07,1.94-4,4L40.76,72a6,6,0,0,0-4.53,3,105.65,105.65,0,0,0-10.66,25.77A6,6,0,0,0,26.68,106l15.37,19.2c-.06,1.89-.06,3.79,0,5.68L26.67,150.05a6,6,0,0,0-1.11,5.29A105.34,105.34,0,0,0,36.24,181.1a6,6,0,0,0,4.53,3l24.45,2.71q1.94,2.07,4,4L72,215.24a6,6,0,0,0,3,4.53,105.65,105.65,0,0,0,25.77,10.66,6,6,0,0,0,5.29-1.11L125.16,214c1.89.06,3.79.06,5.68,0l19.21,15.38a6,6,0,0,0,3.75,1.31,6.2,6.2,0,0,0,1.54-.2,105.34,105.34,0,0,0,25.76-10.68,6,6,0,0,0,3-4.53l2.71-24.45q2.07-1.93,4-4l24.46-2.72a6,6,0,0,0,4.53-3,105.49,105.49,0,0,0,10.66-25.77,6,6,0,0,0-1.11-5.29Zm-3.1,41.63-23.64,2.63a6,6,0,0,0-3.82,2,75.14,75.14,0,0,1-6.31,6.31,6,6,0,0,0-2,3.82l-2.63,23.63A94.28,94.28,0,0,1,155.14,218l-18.57-14.86a6,6,0,0,0-3.75-1.31h-.36a78.07,78.07,0,0,1-8.92,0,6,6,0,0,0-4.11,1.3L100.87,218a94.13,94.13,0,0,1-17.34-7.17L80.9,187.21a6,6,0,0,0-2-3.82,75.14,75.14,0,0,1-6.31-6.31,6,6,0,0,0-3.82-2l-23.63-2.63A94.28,94.28,0,0,1,38,155.14l14.86-18.57a6,6,0,0,0,1.3-4.11,78.07,78.07,0,0,1,0-8.92,6,6,0,0,0-1.3-4.11L38,100.87a94.13,94.13,0,0,1,7.17-17.34L68.79,80.9a6,6,0,0,0,3.82-2,75.14,75.14,0,0,1,6.31-6.31,6,6,0,0,0,2-3.82l2.63-23.63A94.28,94.28,0,0,1,100.86,38l18.57,14.86a6,6,0,0,0,4.11,1.3,78.07,78.07,0,0,1,8.92,0,6,6,0,0,0,4.11-1.3L155.13,38a94.13,94.13,0,0,1,17.34,7.17l2.63,23.64a6,6,0,0,0,2,3.82,75.14,75.14,0,0,1,6.31,6.31,6,6,0,0,0,3.82,2l23.63,2.63A94.28,94.28,0,0,1,218,100.86l-14.86,18.57a6,6,0,0,0-1.3,4.11,78.07,78.07,0,0,1,0,8.92,6,6,0,0,0,1.3,4.11L218,155.13A94.13,94.13,0,0,1,210.85,172.47Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.21,107.21,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.71,107.71,0,0,0-26.25-10.87,8,8,0,0,0-7.06,1.49L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.21,107.21,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8,8,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8,8,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Zm83.93-32.49q.13-3.51,0-7l15.83-19.79a4,4,0,0,0,.75-3.53A103.64,103.64,0,0,0,218,75.9a4,4,0,0,0-3-2l-25.19-2.8c-1.58-1.71-3.24-3.37-4.95-4.95L182.07,41a4,4,0,0,0-2-3A104,104,0,0,0,154.82,27.5a4,4,0,0,0-3.53.74L131.51,44.07q-3.51-.14-7,0L104.7,28.24a4,4,0,0,0-3.53-.75A103.64,103.64,0,0,0,75.9,38a4,4,0,0,0-2,3l-2.8,25.19c-1.71,1.58-3.37,3.24-4.95,4.95L41,73.93a4,4,0,0,0-3,2A104,104,0,0,0,27.5,101.18a4,4,0,0,0,.74,3.53l15.83,19.78q-.14,3.51,0,7L28.24,151.3a4,4,0,0,0-.75,3.53A103.64,103.64,0,0,0,38,180.1a4,4,0,0,0,3,2l25.19,2.8c1.58,1.71,3.24,3.37,4.95,4.95l2.8,25.2a4,4,0,0,0,2,3,104,104,0,0,0,25.28,10.46,4,4,0,0,0,3.53-.74l19.78-15.83q3.51.13,7,0l19.79,15.83a4,4,0,0,0,2.5.88,4,4,0,0,0,1-.13A103.64,103.64,0,0,0,180.1,218a4,4,0,0,0,2-3l2.8-25.19c1.71-1.58,3.37-3.24,4.95-4.95l25.2-2.8a4,4,0,0,0,3-2,104,104,0,0,0,10.46-25.28,4,4,0,0,0-.74-3.53Zm.17,42.83-24.67,2.74a4,4,0,0,0-2.55,1.32,76.2,76.2,0,0,1-6.48,6.48,4,4,0,0,0-1.32,2.55l-2.74,24.66a95.45,95.45,0,0,1-19.64,8.15l-19.38-15.51a4,4,0,0,0-2.5-.87h-.24a73.67,73.67,0,0,1-9.16,0,4,4,0,0,0-2.74.87l-19.37,15.5a95.33,95.33,0,0,1-19.65-8.13l-2.74-24.67a4,4,0,0,0-1.32-2.55,76.2,76.2,0,0,1-6.48-6.48,4,4,0,0,0-2.55-1.32l-24.66-2.74a95.45,95.45,0,0,1-8.15-19.64l15.51-19.38a4,4,0,0,0,.87-2.74,77.76,77.76,0,0,1,0-9.16,4,4,0,0,0-.87-2.74l-15.5-19.37A95.33,95.33,0,0,1,43.9,81.66l24.67-2.74a4,4,0,0,0,2.55-1.32,76.2,76.2,0,0,1,6.48-6.48,4,4,0,0,0,1.32-2.55l2.74-24.66a95.45,95.45,0,0,1,19.64-8.15l19.38,15.51a4,4,0,0,0,2.74.87,73.67,73.67,0,0,1,9.16,0,4,4,0,0,0,2.74-.87l19.37-15.5a95.33,95.33,0,0,1,19.65,8.13l2.74,24.67a4,4,0,0,0,1.32,2.55,76.2,76.2,0,0,1,6.48,6.48,4,4,0,0,0,2.55,1.32l24.66,2.74a95.45,95.45,0,0,1,8.15,19.64l-15.51,19.38a4,4,0,0,0-.87,2.74,77.76,77.76,0,0,1,0,9.16,4,4,0,0,0,.87,2.74l15.5,19.37A95.33,95.33,0,0,1,212.1,174.34Z"
        }))
    ]
]);


const $8dd1c6f3efdeb55a$export$70208e77f6c45b17 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $7fac16834f0e6b11$export$2e2bcd8739ae039)
    })));
$8dd1c6f3efdeb55a$export$70208e77f6c45b17.displayName = "GearIcon";
const $8dd1c6f3efdeb55a$export$e5cc6136f1e14be3 = $8dd1c6f3efdeb55a$export$70208e77f6c45b17;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $01aa45825f23224d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,187a113.4,113.4,0,0,1-20.39-35h40.82a116.94,116.94,0,0,1-10,20.77A108.61,108.61,0,0,1,128,207Zm-26.49-59a135.42,135.42,0,0,1,0-40h53a135.42,135.42,0,0,1,0,40ZM44,128a83.49,83.49,0,0,1,2.43-20H77.25a160.63,160.63,0,0,0,0,40H46.43A83.49,83.49,0,0,1,44,128Zm84-79a113.4,113.4,0,0,1,20.39,35H107.59a116.94,116.94,0,0,1,10-20.77A108.61,108.61,0,0,1,128,49Zm50.73,59h30.82a83.52,83.52,0,0,1,0,40H178.75a160.63,160.63,0,0,0,0-40Zm20.77-24H173.71a140.82,140.82,0,0,0-15.5-34.36A84.51,84.51,0,0,1,199.52,84ZM97.79,49.64A140.82,140.82,0,0,0,82.29,84H56.48A84.51,84.51,0,0,1,97.79,49.64ZM56.48,172H82.29a140.82,140.82,0,0,0,15.5,34.36A84.51,84.51,0,0,1,56.48,172Zm101.73,34.36A140.82,140.82,0,0,0,173.71,172h25.81A84.51,84.51,0,0,1,158.21,206.36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm78.36,64H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM216,128a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM128,43a115.27,115.27,0,0,1,26,45H102A115.11,115.11,0,0,1,128,43ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48Zm50.35,61.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm81.57,64H169.19a132.58,132.58,0,0,0-25.73-50.67A90.29,90.29,0,0,1,209.57,90ZM218,128a89.7,89.7,0,0,1-3.83,26H171.81a155.43,155.43,0,0,0,0-52h42.36A89.7,89.7,0,0,1,218,128Zm-90,87.83a110,110,0,0,1-15.19-19.45A124.24,124.24,0,0,1,99.35,166h57.3a124.24,124.24,0,0,1-13.46,30.38A110,110,0,0,1,128,215.83ZM96.45,154a139.18,139.18,0,0,1,0-52h63.1a139.18,139.18,0,0,1,0,52ZM38,128a89.7,89.7,0,0,1,3.83-26H84.19a155.43,155.43,0,0,0,0,52H41.83A89.7,89.7,0,0,1,38,128Zm90-87.83a110,110,0,0,1,15.19,19.45A124.24,124.24,0,0,1,156.65,90H99.35a124.24,124.24,0,0,1,13.46-30.38A110,110,0,0,1,128,40.17Zm-15.46-.84A132.58,132.58,0,0,0,86.81,90H46.43A90.29,90.29,0,0,1,112.54,39.33ZM46.43,166H86.81a132.58,132.58,0,0,0,25.73,50.67A90.29,90.29,0,0,1,46.43,166Zm97,50.67A132.58,132.58,0,0,0,169.19,166h40.38A90.29,90.29,0,0,1,143.46,216.67Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28h0A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,190.61c-6.33-6.09-23-24.41-31.27-54.61h62.54C151,194.2,134.33,212.52,128,218.61ZM94.82,156a140.42,140.42,0,0,1,0-56h66.36a140.42,140.42,0,0,1,0,56ZM128,37.39c6.33,6.09,23,24.41,31.27,54.61H96.73C105,61.8,121.67,43.48,128,37.39ZM169.41,100h46.23a92.09,92.09,0,0,1,0,56H169.41a152.65,152.65,0,0,0,0-56Zm43.25-8h-45a129.39,129.39,0,0,0-29.19-55.4A92.25,92.25,0,0,1,212.66,92ZM117.54,36.6A129.39,129.39,0,0,0,88.35,92h-45A92.25,92.25,0,0,1,117.54,36.6ZM40.36,100H86.59a152.65,152.65,0,0,0,0,56H40.36a92.09,92.09,0,0,1,0-56Zm3,64h45a129.39,129.39,0,0,0,29.19,55.4A92.25,92.25,0,0,1,43.34,164Zm95.12,55.4A129.39,129.39,0,0,0,167.65,164h45A92.25,92.25,0,0,1,138.46,219.4Z"
        }))
    ]
]);


const $b80ecb83ad6de581$export$a70e2e549144f66 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $01aa45825f23224d$export$2e2bcd8739ae039)
    })));
$b80ecb83ad6de581$export$a70e2e549144f66.displayName = "GlobeIcon";
const $b80ecb83ad6de581$export$3bc50e457b7f164b = $b80ecb83ad6de581$export$a70e2e549144f66;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $4bc0af47ad615b1e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.8,85.49l-116-64a12,12,0,0,0-11.6,0l-116,64a12,12,0,0,0,0,21l21.8,12v47.76a19.89,19.89,0,0,0,5.09,13.32C46.63,194.7,77,220,128,220a136.88,136.88,0,0,0,40-5.75V240a12,12,0,0,0,24,0V204.12a119.53,119.53,0,0,0,30.91-24.51A19.89,19.89,0,0,0,228,166.29V118.53l21.8-12a12,12,0,0,0,0-21ZM128,45.71,219.16,96,186,114.3a1.88,1.88,0,0,1-.18-.12l-52-28.69a12,12,0,0,0-11.6,21l39,21.49L128,146.3,36.84,96ZM128,196c-40.42,0-64.65-19.07-76-31.27v-33l70.2,38.74a12,12,0,0,0,11.6,0L168,151.64v37.23A110.46,110.46,0,0,1,128,196Zm76-31.27a93.21,93.21,0,0,1-12,10.81V138.39l12-6.62Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,113.07v53.22a8,8,0,0,1-2,5.31c-11.3,12.59-38.9,36.4-86,36.4s-74.68-23.81-86-36.4a8,8,0,0,1-2-5.31V113.07L128,160Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.76,88.94l-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V240a8,8,0,0,0,16,0V199.51a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12ZM128,200c-43.27,0-68.72-21.14-80-33.71V126.4l76.24,40.66a8,8,0,0,0,7.52,0L176,143.47v46.34C163.4,195.69,147.52,200,128,200Zm80-33.75a97.83,97.83,0,0,1-16,14.25V134.93l16-8.53ZM188,118.94l-.22-.13-56-29.87a8,8,0,0,0-7.52,14.12L171,128l-43,22.93L25,96,128,41.07,231,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,207.24a119,119,0,0,0,16-7.73V240a8,8,0,0,1-16,0Zm11.76-88.43-56-29.87a8,8,0,0,0-7.52,14.12L171,128l17-9.06Zm64-29.87-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V130.67L171,128l-43,22.93L43.83,106l0,0L25,96,128,41.07,231,96l-18.78,10-.06,0L188,118.94a8,8,0,0,1,4,6.93v73.64a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.82,90.71l-120-64a5.94,5.94,0,0,0-5.64,0l-120,64a6,6,0,0,0,0,10.58L34,116.67v49.62a14,14,0,0,0,3.55,9.32C50.42,189.94,79.29,214,128,214a127.21,127.21,0,0,0,50-9.73V240a6,6,0,0,0,12,0V198.35a113.18,113.18,0,0,0,28.45-22.75,13.91,13.91,0,0,0,3.55-9.31V116.67l28.82-15.38a6,6,0,0,0,0-10.58ZM128,202c-44,0-70-21.56-81.52-34.41a2,2,0,0,1-.48-1.3V123.07l79.18,42.22a6,6,0,0,0,5.64,0L178,140.13v51C165,197.35,148.45,202,128,202Zm82-35.71a2,2,0,0,1-.48,1.3A100.25,100.25,0,0,1,190,184.3V133.73l20-10.66Zm-22.15-45a6.27,6.27,0,0,0-1-.71l-56-29.86a6,6,0,0,0-5.64,10.58L175.25,128,128,153.2,20.75,96,128,38.8,235.25,96Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.76,88.94l-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V240a8,8,0,0,0,16,0V199.51a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12ZM128,200c-43.27,0-68.72-21.14-80-33.71V126.4l76.24,40.66a8,8,0,0,0,7.52,0L176,143.47v46.34C163.4,195.69,147.52,200,128,200Zm80-33.75a97.83,97.83,0,0,1-16,14.25V134.93l16-8.53ZM188,118.94l-.22-.13-56-29.87a8,8,0,0,0-7.52,14.12L171,128l-43,22.93L25,96,128,41.07,231,96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.88,92.47l-120-64a4,4,0,0,0-3.76,0l-120,64a4,4,0,0,0,0,7.06L36,115.47v50.82a11.92,11.92,0,0,0,3,8c12.65,14.09,41,37.73,89,37.73,21,0,38.2-4.52,52-10.79V240a4,4,0,0,0,8,0V197.18a111.64,111.64,0,0,0,29-22.91,11.94,11.94,0,0,0,3-8V115.47l29.88-15.94a4,4,0,0,0,0-7.06ZM128,204c-44.83,0-71.25-22-83-35.08a3.92,3.92,0,0,1-1-2.63V119.73l82.12,43.8a4,4,0,0,0,3.76,0L180,136.8v55.53C166.58,199,149.39,204,128,204Zm84-37.71a4,4,0,0,1-1,2.64,103.32,103.32,0,0,1-23,19v-55.4l24-12.8Zm-24.59-42.51a4,4,0,0,0-1.53-1.44l-56-29.87a4,4,0,0,0-3.76,7.06L179.5,128,128,155.47,16.5,96,128,36.53,239.5,96Z"
        }))
    ]
]);


const $862061e2a830a35b$export$3ac311e31945509f = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $4bc0af47ad615b1e$export$2e2bcd8739ae039)
    })));
$862061e2a830a35b$export$3ac311e31945509f.displayName = "GraduationCapIcon";
const $862061e2a830a35b$export$c94f95e8e2d2bae0 = $862061e2a830a35b$export$3ac311e31945509f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $07d194764b1c387c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.18,105.17,186.71,41.25a100.11,100.11,0,0,0-141.43,0l-.13.14L31.37,55.61a12,12,0,1,0,17.24,16.7L62.32,58.16A75.68,75.68,0,0,1,77.49,46.43L119,88,25.85,181.16a20,20,0,0,0,0,28.29l20.69,20.69a20,20,0,0,0,28.28,0L168,137l1.51,1.51h0l23.65,23.66a20,20,0,0,0,28.29,0l28.69-28.7A20,20,0,0,0,250.18,105.17ZM60.68,210.34l-15-15L108,133l15,15ZM140,131l-15-15,19.51-19.51a12,12,0,0,0,0-17L102.24,37.24a75.94,75.94,0,0,1,67.47,20.95l31.44,31.67L178,113l-1.51-1.51a12,12,0,0,0-17,0Zm67.32,11.31L195,130l23.09-23.09,12.3,12.39Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245.66,129,217,157.66a8,8,0,0,1-11.3,0L168.1,120l-28,28-32-32,28-28L80,31.78a87.81,87.81,0,0,1,98.31,18l67.35,67.89A8,8,0,0,1,245.66,129Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.34,112,183.88,44.08a96.1,96.1,0,0,0-135.77,0l-.09.09L34.25,58.4A8,8,0,0,0,45.74,69.53L59.47,55.35a79.92,79.92,0,0,1,18.71-13.9L124.68,88l-96,96a16,16,0,0,0,0,22.63l20.69,20.69a16,16,0,0,0,22.63,0l96-96,14.34,14.34h0L200,163.3a16,16,0,0,0,22.63,0l28.69-28.69A16,16,0,0,0,251.34,112ZM60.68,216,40,195.31l68-68L128.68,148ZM162.34,114.32,140,136.67,119.31,116l22.35-22.35a8,8,0,0,0,0-11.32L94.32,35a80,80,0,0,1,78.23,20.41l44.22,44.51L188,128.66l-14.34-14.34A8,8,0,0,0,162.34,114.32Zm49,37.66-12-12L228,111.25l12,12Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.34,112,183.88,44.08a96.1,96.1,0,0,0-135.77,0l-.09.09L34.25,58.4A8,8,0,0,0,45.74,69.53L59.47,55.35a79.92,79.92,0,0,1,18.71-13.9L124.68,88l-96,96a16,16,0,0,0,0,22.63l20.69,20.69a16,16,0,0,0,22.63,0l96-96,32,32a16,16,0,0,0,22.63,0l28.69-28.69A16,16,0,0,0,251.34,112Zm-89,2.33L140,136.67,119.31,116l22.35-22.35a8,8,0,0,0,0-11.32L94.32,35a80,80,0,0,1,78.23,20.41l44.22,44.51L188,128.66l-14.34-14.34A8,8,0,0,0,162.34,114.32Zm49,37.66-12-12L228,111.25l12,12Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.92,113.4,182.47,45.49a94.12,94.12,0,0,0-133,.06L35.68,59.78a6,6,0,0,0,8.63,8.35L58,54A82,82,0,0,1,78.55,39l49,49L30.09,185.4a14,14,0,0,0,0,19.81L50.78,225.9a14,14,0,0,0,19.8,0L168,128.46l33.42,33.42a14,14,0,0,0,19.8,0l28.68-28.69A14,14,0,0,0,249.92,113.4ZM62.1,217.41a2,2,0,0,1-2.83,0L38.58,196.72a2,2,0,0,1,0-2.83L108,124.46,131.51,148ZM163.76,115.73,140,139.49,116.48,116l23.76-23.76a6,6,0,0,0,0-8.49L90.54,34A82.07,82.07,0,0,1,174,54l45.62,45.93L188,131.49l-15.76-15.76A6,6,0,0,0,163.76,115.73Zm77.66,9-28.69,28.7a2,2,0,0,1-2.83,0L196.49,140l31.56-31.57,13.37,13.46A2,2,0,0,1,241.42,124.7Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.34,112,183.88,44.08a96.1,96.1,0,0,0-135.77,0l-.09.09L34.25,58.4A8,8,0,0,0,45.74,69.53L59.47,55.35a79.92,79.92,0,0,1,18.71-13.9L124.68,88l-96,96a16,16,0,0,0,0,22.63l20.69,20.69a16,16,0,0,0,22.63,0l96-96,14.34,14.34h0L200,163.3a16,16,0,0,0,22.63,0l28.69-28.69A16,16,0,0,0,251.34,112ZM60.68,216,40,195.31l68-68L128.68,148ZM162.34,114.32,140,136.67,119.31,116l22.35-22.35a8,8,0,0,0,0-11.32L94.32,35a80,80,0,0,1,78.23,20.41l44.22,44.51L188,128.66l-14.34-14.34A8,8,0,0,0,162.34,114.32Zm49,37.66-12-12L228,111.25l12,12Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M248.5,114.81,181.05,46.9A92.1,92.1,0,0,0,50.9,47L37.12,61.18a4,4,0,1,0,5.75,5.56L56.6,52.56a83.75,83.75,0,0,1,22.34-16L130.34,88,31.51,186.82a12,12,0,0,0,0,17L52.2,224.48a12,12,0,0,0,17,0L168,125.63l17.17,17.18h0l17.66,17.66a12,12,0,0,0,17,0l28.69-28.69A12,12,0,0,0,248.5,114.81Zm-185,104a4,4,0,0,1-5.66,0L37.17,198.14a4,4,0,0,1,0-5.66L108,121.63,134.34,148ZM165.17,117.15,140,142.32,113.65,116,138.83,90.8a4,4,0,0,0,0-5.66l-52-52a84.11,84.11,0,0,1,88.52,19.38l47,47.35L188,134.32l-17.17-17.17A4,4,0,0,0,165.17,117.15Zm77.66,9-28.68,28.69a4,4,0,0,1-5.66,0L193.66,140l34.39-34.4,14.78,14.88A4,4,0,0,1,242.83,126.12Z"
        }))
    ]
]);


const $4d330376fb0bcf89$export$57e3e6ad9de04bb9 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $07d194764b1c387c$export$2e2bcd8739ae039)
    })));
$4d330376fb0bcf89$export$57e3e6ad9de04bb9.displayName = "HammerIcon";
const $4d330376fb0bcf89$export$f8f0760d4a67552c = $4d330376fb0bcf89$export$57e3e6ad9de04bb9;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $64163963d624efaa$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,156v36c0,13.85-1.63,26.52-4.58,35.68a12,12,0,1,1-22.84-7.36c2.14-6.65,3.42-17.24,3.42-28.32V156a8,8,0,0,0-16,0v4a12,12,0,0,1-24,0V140a8,8,0,0,0-16,0v12a12,12,0,0,1-24,0V84a8,8,0,0,0-16,0V192a12,12,0,0,1-22.18,6.34l-18.68-30-.21-.34A8,8,0,0,0,53,175.92L78.27,217.8a12,12,0,0,1-20.56,12.39l-25.31-42-.12-.2A32,32,0,0,1,84,150.83V84a32,32,0,0,1,64,0v25a32,32,0,0,1,36.78,17A32,32,0,0,1,228,156ZM56,96A12,12,0,0,0,68,84a48,48,0,0,1,96,0,12,12,0,0,0,24,0A72,72,0,0,0,44,84,12,12,0,0,0,56,96Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,148v36c0,24-8,40-8,40H72L42.68,174a20,20,0,0,1,34.64-20L96,184V76a20,20,0,0,1,40,0v56a20,20,0,0,1,40,0v16a20,20,0,0,1,40,0Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56,76a60,60,0,0,1,120,0,8,8,0,0,1-16,0,44,44,0,0,0-88,0,8,8,0,1,1-16,0Zm140,44a27.9,27.9,0,0,0-13.36,3.39A28,28,0,0,0,144,106.7V76a28,28,0,0,0-56,0v80l-3.82-6.13a28,28,0,0,0-48.41,28.17l29.32,50A8,8,0,1,0,78.89,220L49.6,170a12,12,0,1,1,20.78-12l.14.23,18.68,30A8,8,0,0,0,104,184V76a12,12,0,0,1,24,0v68a8,8,0,1,0,16,0V132a12,12,0,0,1,24,0v20a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v36c0,21.61-7.1,36.3-7.16,36.42a8,8,0,0,0,3.58,10.73A7.9,7.9,0,0,0,208,232a8,8,0,0,0,7.16-4.42c.37-.73,8.85-18,8.85-43.58V148A28,28,0,0,0,196,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M64,64a48,48,0,0,1,96,0,8,8,0,0,1-16,0,32,32,0,0,0-64,0,8,8,0,0,1-16,0Zm143.23,56c-8.61.4-15.23,7.82-15.23,16.43v7.28a8.17,8.17,0,0,1-7.47,8.25,8,8,0,0,1-8.53-8V120.45c0-8.61-6.62-16-15.23-16.43A16,16,0,0,0,144,120v15.73a8.17,8.17,0,0,1-7.47,8.25,8,8,0,0,1-8.53-8V64.45c0-8.61-6.62-16-15.23-16.43A16,16,0,0,0,96,64V183.74a8.19,8.19,0,0,1-6.72,8.16l-.12,0a6.09,6.09,0,0,1-6-3.09l-21-36.44c-4.3-7.46-13.74-10.57-21.4-6.62A16,16,0,0,0,34.15,168L65.1,228.05A8,8,0,0,0,72,232H208a8,8,0,0,0,7.16-4.42c.36-.72,8.84-15.06,8.84-40.65V136A16,16,0,0,0,207.23,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M58,76a58,58,0,0,1,116,0,6,6,0,0,1-12,0,46,46,0,0,0-92,0,6,6,0,0,1-12,0Zm138,46a25.87,25.87,0,0,0-14.59,4.49A26,26,0,0,0,142,110.1V76a26,26,0,0,0-52,0v87l-7.53-12.1a26,26,0,0,0-45,26.13l29.32,50A6,6,0,0,0,77.16,221L47.87,171a14,14,0,0,1,24.25-14,1,1,0,0,0,.1.17l18.68,30A6,6,0,0,0,102,184V76a14,14,0,0,1,28,0v68a6,6,0,0,0,12,0V132a14,14,0,0,1,28,0v20a6,6,0,0,0,12,0v-4a14,14,0,0,1,28,0v36c0,22.13-7.3,37.18-7.37,37.32a6,6,0,0,0,2.69,8A5.83,5.83,0,0,0,208,230a6,6,0,0,0,5.38-3.32c.35-.7,8.63-17.55,8.63-42.68V148A26,26,0,0,0,196,122Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56,76a60,60,0,0,1,120,0,8,8,0,0,1-16,0,44,44,0,0,0-88,0,8,8,0,1,1-16,0Zm140,44a27.9,27.9,0,0,0-13.36,3.39A28,28,0,0,0,144,106.7V76a28,28,0,0,0-56,0v80l-3.82-6.13a28,28,0,0,0-48.41,28.17l29.32,50A8,8,0,1,0,78.89,220L49.6,170a12,12,0,1,1,20.78-12l.14.23,18.68,30A8,8,0,0,0,104,184V76a12,12,0,0,1,24,0v68a8,8,0,1,0,16,0V132a12,12,0,0,1,24,0v20a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v36c0,21.61-7.1,36.3-7.16,36.42a8,8,0,0,0,3.58,10.73A7.9,7.9,0,0,0,208,232a8,8,0,0,0,7.16-4.42c.37-.73,8.85-18,8.85-43.58V148A28,28,0,0,0,196,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M60,76a56,56,0,0,1,112,0,4,4,0,0,1-8,0,48,48,0,0,0-96,0,4,4,0,1,1-8,0Zm136,48a23.88,23.88,0,0,0-16.07,6.19A24,24,0,0,0,140,114.13V76a24,24,0,0,0-48,0v94L80.74,151.94A24,24,0,0,0,39.22,176l29.32,50a4,4,0,0,0,6.9-4L46.13,172a16,16,0,0,1,27.72-16l.07.12,18.68,30A4,4,0,0,0,100,184V76a16,16,0,0,1,32,0v68a4,4,0,0,0,8,0V132a16,16,0,0,1,32,0v20a4,4,0,0,0,8,0v-4a16,16,0,0,1,32,0v36c0,22.66-7.51,38.06-7.58,38.21a4,4,0,0,0,1.79,5.37A4.05,4.05,0,0,0,208,228a4,4,0,0,0,3.58-2.21c.34-.69,8.42-17.13,8.42-41.79V148A24,24,0,0,0,196,124Z"
        }))
    ]
]);


const $1ba208388ac239df$export$7caf2e6d06b0e274 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $64163963d624efaa$export$2e2bcd8739ae039)
    })));
$1ba208388ac239df$export$7caf2e6d06b0e274.displayName = "HandTapIcon";
const $1ba208388ac239df$export$bb33fcc3181d329 = $1ba208388ac239df$export$7caf2e6d06b0e274;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0eebba49a7def99a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.84,54.13A62.07,62.07,0,0,0,138.32,54L128,63.58,117.68,54a62,62,0,0,0-87.58,87.8l89.35,90.65a12,12,0,0,0,17.1,0l89.29-90.59a62,62,0,0,0,0-87.7Zm-17,70.79L128,206.9,47.13,124.85a38,38,0,0,1,53.74-53.74c.1.1.2.2.31.29l18.64,17.36a12,12,0,0,0,16.36,0L154.82,71.4c.11-.09.21-.19.31-.29a38,38,0,1,1,53.68,53.81Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M217.36,133.36,128,224,38.64,133.36a50,50,0,0,1,70.72-70.72L128,80l18.64-17.36a50,50,0,1,1,70.72,70.72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223,57a58.07,58.07,0,0,0-81.92-.1L128,69.05,114.91,56.86A58,58,0,0,0,33,139l89.35,90.66a8,8,0,0,0,11.4,0L223,139a58,58,0,0,0,0-82Zm-11.35,70.76L128,212.6,44.3,127.68a42,42,0,0,1,59.4-59.4l.2.2,18.65,17.35a8,8,0,0,0,10.9,0L152.1,68.48l.2-.2a42,42,0,1,1,59.36,59.44Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,98a57.63,57.63,0,0,1-17,41L133.7,229.62a8,8,0,0,1-11.4,0L33,139a58,58,0,0,1,82-82.1L128,69.05l13.09-12.19A58,58,0,0,1,240,98Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.6,58.38a56.06,56.06,0,0,0-79.12-.08L128,71.78,113.52,58.3a56,56,0,0,0-79.15,79.25l89.36,90.66a6,6,0,0,0,8.54,0l89.33-90.62a56,56,0,0,0,0-79.21Zm-8.52,70.75L128,215.45,42.89,129.1a44,44,0,0,1,62.22-62.23,1.07,1.07,0,0,0,.16.14l18.64,17.36a6,6,0,0,0,8.18,0L150.73,67a1.07,1.07,0,0,0,.16-.14,44,44,0,1,1,62.19,62.26Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223,57a58.07,58.07,0,0,0-81.92-.1L128,69.05,114.91,56.86A58,58,0,0,0,33,139l89.35,90.66a8,8,0,0,0,11.4,0L223,139a58,58,0,0,0,0-82Zm-11.35,70.76L128,212.6,44.3,127.68a42,42,0,0,1,59.4-59.4l.2.2,18.65,17.35a8,8,0,0,0,10.9,0L152.1,68.48l.2-.2a42,42,0,1,1,59.36,59.44Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.18,59.79a54.05,54.05,0,0,0-76.31,0L128,74.51,112.13,59.74A54,54,0,0,0,35.8,136.15l89.35,90.66a4,4,0,0,0,5.7,0l89.33-90.64a54,54,0,0,0,0-76.38Zm-5.67,70.74L128,218.3,41.47,130.51a46,46,0,0,1,65.06-65.06l.1.1,18.64,17.36a4,4,0,0,0,5.46,0l18.64-17.36.1-.1a46,46,0,1,1,65,65.08Z"
        }))
    ]
]);


const $daf0af796c7daf33$export$44fb2b0459be5849 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, a), {
        weights: (0, $0eebba49a7def99a$export$2e2bcd8739ae039)
    })));
$daf0af796c7daf33$export$44fb2b0459be5849.displayName = "HeartStraightIcon";
const $daf0af796c7daf33$export$9245b4499dccac79 = $daf0af796c7daf33$export$44fb2b0459be5849;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cece1c6e7dde4801$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.14,105.85l-80-80a20,20,0,0,0-28.28,0l-80,80A19.86,19.86,0,0,0,28,120v96a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V164h24v52a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V120A19.86,19.86,0,0,0,222.14,105.85ZM204,204H164V152a12,12,0,0,0-12-12H104a12,12,0,0,0-12,12v52H52V121.65l76-76,76,76Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,120v96H152V152H104v64H40V120a8,8,0,0,1,2.34-5.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,216,120Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M217.9,110.1l-80-80a14,14,0,0,0-19.8,0l-80,80A13.92,13.92,0,0,0,34,120v96a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V158h36v58a6,6,0,0,0,6,6h64a6,6,0,0,0,6-6V120A13.92,13.92,0,0,0,217.9,110.1ZM210,210H158V152a6,6,0,0,0-6-6H104a6,6,0,0,0-6,6v58H46V120a2,2,0,0,1,.58-1.42l80-80a2,2,0,0,1,2.84,0l80,80A2,2,0,0,1,210,120Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.49,111.51l-80-80a12,12,0,0,0-17,0l-80,80A12,12,0,0,0,36,120v96a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V156h40v60a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4V120A12,12,0,0,0,216.49,111.51ZM212,212H156V152a4,4,0,0,0-4-4H104a4,4,0,0,0-4,4v60H44V120a4,4,0,0,1,1.17-2.83l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,212,120Z"
        }))
    ]
]);


const $7f183d9af8860529$export$f8c453d4287040a2 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $cece1c6e7dde4801$export$2e2bcd8739ae039)
    })));
$7f183d9af8860529$export$f8c453d4287040a2.displayName = "HouseIcon";
const $7f183d9af8860529$export$1027d4534a5ce60b = $7f183d9af8860529$export$f8c453d4287040a2;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a09f93ef63827300$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V40A20,20,0,0,0,200,20Zm-4,192H60V44H196ZM84,68A12,12,0,0,1,96,56h64a12,12,0,0,1,0,24H96A12,12,0,0,1,84,68Zm8.8,127.37a48,48,0,0,1,70.4,0,12,12,0,0,0,17.6-16.32,72,72,0,0,0-19.21-14.68,44,44,0,1,0-67.19,0,72.12,72.12,0,0,0-19.2,14.68,12,12,0,0,0,17.6,16.32ZM128,116a20,20,0,1,1-20,20A20,20,0,0,1,128,116Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32ZM128,168a32,32,0,1,1,32-32A32,32,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M75.19,198.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,155,165.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,73.6,187.2,8,8,0,0,0,75.19,198.4ZM128,112a24,24,0,1,1-24,24A24,24,0,0,1,128,112Zm72-88H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM88,64a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM96,48h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm84.81,150.4a8,8,0,0,1-11.21-1.6,52,52,0,0,0-83.2,0,8,8,0,1,1-12.8-9.6A67.88,67.88,0,0,1,101,165.51a40,40,0,1,1,53.94,0A67.88,67.88,0,0,1,182.4,187.2,8,8,0,0,1,180.81,198.4ZM152,136a24,24,0,1,1-24-24A24,24,0,0,1,152,136Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M151.11,166.13a38,38,0,1,0-46.22,0A65.75,65.75,0,0,0,75.2,188.4a6,6,0,0,0,9.6,7.2,54,54,0,0,1,86.4,0,6,6,0,0,0,9.6-7.2A65.75,65.75,0,0,0,151.11,166.13ZM128,110a26,26,0,1,1-26,26A26,26,0,0,1,128,110Zm72-84H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V40A14,14,0,0,0,200,26Zm2,190a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2H200a2,2,0,0,1,2,2ZM90,64a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H96A6,6,0,0,1,90,64Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M75.19,198.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,155,165.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,73.6,187.2,8,8,0,0,0,75.19,198.4ZM128,112a24,24,0,1,1-24,24A24,24,0,0,1,128,112Zm72-88H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM88,64a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.7,166.75a36,36,0,1,0-37.4,0A63.61,63.61,0,0,0,76.8,189.6a4,4,0,0,0,6.4,4.8,56,56,0,0,1,89.6,0,4,4,0,0,0,6.4-4.8A63.65,63.65,0,0,0,146.7,166.75ZM100,136a28,28,0,1,1,28,28A28,28,0,0,1,100,136ZM200,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V40A12,12,0,0,0,200,28Zm4,188a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4H200a4,4,0,0,1,4,4ZM92,64a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H96A4,4,0,0,1,92,64Z"
        }))
    ]
]);


const $866da9b1db75c8ee$export$5039d390f8f90df = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, t), {
        weights: (0, $a09f93ef63827300$export$2e2bcd8739ae039)
    })));
$866da9b1db75c8ee$export$5039d390f8f90df.displayName = "IdentificationBadgeIcon";
const $866da9b1db75c8ee$export$53bf5a6fb4ebd92 = $866da9b1db75c8ee$export$5039d390f8f90df;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $8f7038799074ac70$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $ad77d9dd26a095a7$export$2957fc44b3d2481 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $8f7038799074ac70$export$2e2bcd8739ae039)
    })));
$ad77d9dd26a095a7$export$2957fc44b3d2481.displayName = "InfoIcon";
const $ad77d9dd26a095a7$export$c4868e4a24d48fad = $ad77d9dd26a095a7$export$2957fc44b3d2481;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0c0657dd86cc9c0e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144H140V98.32a44,44,0,1,0-24,0V144H48a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V164A20,20,0,0,0,208,144ZM108,56a20,20,0,1,1,20,20A20,20,0,0,1,108,56Zm96,148H52V168H204ZM172,104h32a12,12,0,0,1,0,24H172a12,12,0,0,1,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,160v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V160a8,8,0,0,1,8-8H208A8,8,0,0,1,216,160ZM128,88A32,32,0,1,0,96,56,32,32,0,0,0,128,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,160v48a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V160a16,16,0,0,1,16-16h72V95.19a40,40,0,1,1,16,0V144h72A16,16,0,0,1,224,160Zm-64-40a8,8,0,0,0,8,8h32a8,8,0,0,0,0-16H168A8,8,0,0,0,160,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,146H134V93.52a38,38,0,1,0-12,0V146H48a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V160A14,14,0,0,0,208,146ZM102,56a26,26,0,1,1,26,26A26,26,0,0,1,102,56ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V160a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-42-94h32a6,6,0,0,1,0,12H168a6,6,0,0,1,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,148H132V91.77a36,36,0,1,0-8,0V148H48a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V160A12,12,0,0,0,208,148ZM100,56a28,28,0,1,1,28,28A28,28,0,0,1,100,56ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V160a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-48-88a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H168A4,4,0,0,1,164,120Z"
        }))
    ]
]);


const $6234b88ab556c79a$export$da69e29052e4731 = $7fPBF.forwardRef((c, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, c), {
        weights: (0, $0c0657dd86cc9c0e$export$2e2bcd8739ae039)
    })));
$6234b88ab556c79a$export$da69e29052e4731.displayName = "JoystickIcon";
const $6234b88ab556c79a$export$41026bc5091240de = $6234b88ab556c79a$export$da69e29052e4731;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $1ce9eef6e2ab403c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,44H32A20,20,0,0,0,12,64V192a20,20,0,0,0,20,20H224a20,20,0,0,0,20-20V64A20,20,0,0,0,224,44Zm-4,144H36V68H220ZM52,128a12,12,0,0,1,12-12H192a12,12,0,0,1,0,24H64A12,12,0,0,1,52,128Zm0-36A12,12,0,0,1,64,80H192a12,12,0,0,1,0,24H64A12,12,0,0,1,52,92Zm0,72a12,12,0,0,1,12-12h8a12,12,0,0,1,0,24H64A12,12,0,0,1,52,164Zm108,0a12,12,0,0,1-12,12H108a12,12,0,0,1,0-24h40A12,12,0,0,1,160,164Zm44,0a12,12,0,0,1-12,12h-8a12,12,0,0,1,0-24h8A12,12,0,0,1,204,164Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,64V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H224A8,8,0,0,1,232,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224V192Zm-16-64a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,128Zm0-32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM72,160a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16h8A8,8,0,0,1,72,160Zm96,0a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,160Zm40,0a8,8,0,0,1-8,8h-8a8,8,0,0,1,0-16h8A8,8,0,0,1,208,160Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM64,168H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16Zm96,0H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm48,0H192a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H208a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H208a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,50H32A14,14,0,0,0,18,64V192a14,14,0,0,0,14,14H224a14,14,0,0,0,14-14V64A14,14,0,0,0,224,50Zm2,142a2,2,0,0,1-2,2H32a2,2,0,0,1-2-2V64a2,2,0,0,1,2-2H224a2,2,0,0,1,2,2Zm-20-64a6,6,0,0,1-6,6H56a6,6,0,0,1,0-12H200A6,6,0,0,1,206,128Zm0-32a6,6,0,0,1-6,6H56a6,6,0,0,1,0-12H200A6,6,0,0,1,206,96ZM70,160a6,6,0,0,1-6,6H56a6,6,0,0,1,0-12h8A6,6,0,0,1,70,160Zm96,0a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,160Zm40,0a6,6,0,0,1-6,6h-8a6,6,0,0,1,0-12h8A6,6,0,0,1,206,160Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224V192Zm-16-64a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,128Zm0-32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM72,160a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16h8A8,8,0,0,1,72,160Zm96,0a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,160Zm40,0a8,8,0,0,1-8,8h-8a8,8,0,0,1,0-16h8A8,8,0,0,1,208,160Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,52H32A12,12,0,0,0,20,64V192a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V64A12,12,0,0,0,224,52Zm4,140a4,4,0,0,1-4,4H32a4,4,0,0,1-4-4V64a4,4,0,0,1,4-4H224a4,4,0,0,1,4,4Zm-24-64a4,4,0,0,1-4,4H56a4,4,0,0,1,0-8H200A4,4,0,0,1,204,128Zm0-32a4,4,0,0,1-4,4H56a4,4,0,0,1,0-8H200A4,4,0,0,1,204,96ZM68,160a4,4,0,0,1-4,4H56a4,4,0,0,1,0-8h8A4,4,0,0,1,68,160Zm96,0a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,160Zm40,0a4,4,0,0,1-4,4h-8a4,4,0,0,1,0-8h8A4,4,0,0,1,204,160Z"
        }))
    ]
]);


const $3977927b8e8acd3c$export$97dac707ecee26f6 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $1ce9eef6e2ab403c$export$2e2bcd8739ae039)
    })));
$3977927b8e8acd3c$export$97dac707ecee26f6.displayName = "KeyboardIcon";
const $3977927b8e8acd3c$export$16e4d70cc375e707 = $3977927b8e8acd3c$export$97dac707ecee26f6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b91bd6ee26a2f073$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196,76a16,16,0,1,1-16-16A16,16,0,0,1,196,76Zm48,22.74A84.3,84.3,0,0,1,160.11,180H160a83.52,83.52,0,0,1-23.65-3.38l-7.86,7.87A12,12,0,0,1,120,188H108v12a12,12,0,0,1-12,12H84v12a12,12,0,0,1-12,12H40a20,20,0,0,1-20-20V187.31a19.86,19.86,0,0,1,5.86-14.14l53.52-53.52A84,84,0,1,1,244,98.74ZM202.43,53.57A59.48,59.48,0,0,0,158,36c-32,1-58,27.89-58,59.89a59.69,59.69,0,0,0,4.2,22.19,12,12,0,0,1-2.55,13.21L44,189v23H60V200a12,12,0,0,1,12-12H84V176a12,12,0,0,1,12-12h19l9.65-9.65a12,12,0,0,1,13.22-2.55A59.58,59.58,0,0,0,160,156h.08c32,0,58.87-26.07,59.89-58A59.55,59.55,0,0,0,202.43,53.57Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,98.36C230.73,136.92,198.67,168,160.09,168a71.68,71.68,0,0,1-26.92-5.17h0L120,176H96v24H72v24H40a8,8,0,0,1-8-8V187.31a8,8,0,0,1,2.34-5.65l58.83-58.83h0A71.68,71.68,0,0,1,88,95.91c0-38.58,31.08-70.64,69.64-71.87A72,72,0,0,1,232,98.36Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM180,92a16,16,0,1,1,16-16A16,16,0,0,1,180,92Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.15,40.85A78,78,0,0,0,86.2,121.31l-56.1,56.1a13.94,13.94,0,0,0-4.1,9.9V216a14,14,0,0,0,14,14H72a6,6,0,0,0,6-6V206H96a6,6,0,0,0,6-6V182h18a6,6,0,0,0,4.24-1.76l10.45-10.44A77.59,77.59,0,0,0,160,174h.1A78,78,0,0,0,215.15,40.85ZM226,98.16c-1.12,35.16-30.67,63.8-65.88,63.84a65.93,65.93,0,0,1-24.51-4.67,6,6,0,0,0-6.64,1.26L117.51,170H96a6,6,0,0,0-6,6v18H72a6,6,0,0,0-6,6v18H40a2,2,0,0,1-2-2V187.31a2,2,0,0,1,.58-1.41l58.83-58.83a6,6,0,0,0,1.26-6.64A65.61,65.61,0,0,1,94,95.92C94,60.71,122.68,31.16,157.83,30A66,66,0,0,1,226,98.16ZM190,76a10,10,0,1,1-10-10A10,10,0,0,1,190,76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.74,42.26A76,76,0,0,0,88.51,121.84l-57,57A11.93,11.93,0,0,0,28,187.31V216a12,12,0,0,0,12,12H72a4,4,0,0,0,4-4V204H96a4,4,0,0,0,4-4V180h20a4,4,0,0,0,2.83-1.17l11.33-11.34A75.72,75.72,0,0,0,160,172h.1A76,76,0,0,0,213.74,42.26Zm14.22,56c-1.15,36.22-31.6,65.72-67.87,65.77H160a67.52,67.52,0,0,1-25.21-4.83,4,4,0,0,0-4.45.83l-12,12H96a4,4,0,0,0-4,4v20H72a4,4,0,0,0-4,4v20H40a4,4,0,0,1-4-4V187.31a4.06,4.06,0,0,1,1.17-2.83L96,125.66a4,4,0,0,0,.83-4.45A67.51,67.51,0,0,1,92,95.91C92,59.64,121.55,29.19,157.77,28A68,68,0,0,1,228,98.23ZM188,76a8,8,0,1,1-8-8A8,8,0,0,1,188,76Z"
        }))
    ]
]);


const $9991baf035cb3560$export$3dc0fe769dc7dcac = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $b91bd6ee26a2f073$export$2e2bcd8739ae039)
    })));
$9991baf035cb3560$export$3dc0fe769dc7dcac.displayName = "KeyIcon";
const $9991baf035cb3560$export$cd0f44441c3b7719 = $9991baf035cb3560$export$3dc0fe769dc7dcac;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b2857ed63604d24d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,156h-4V72a28,28,0,0,0-28-28H56A28,28,0,0,0,28,72v84H24a12,12,0,0,0-12,12v24a28,28,0,0,0,28,28H216a28,28,0,0,0,28-28V168A12,12,0,0,0,232,156ZM52,72a4,4,0,0,1,4-4H200a4,4,0,0,1,4,4v84H52ZM220,192a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V180H220ZM156,96a12,12,0,0,1-12,12H112a12,12,0,0,1,0-24h32A12,12,0,0,1,156,96Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,72V176H40V72A16,16,0,0,1,56,56H200A16,16,0,0,1,216,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,168h-8V72a24,24,0,0,0-24-24H56A24,24,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V176A8,8,0,0,0,232,168ZM48,72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8v96H48ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224ZM152,88a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,168h-8V72a24,24,0,0,0-24-24H56A24,24,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V176A8,8,0,0,0,232,168ZM112,72h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,170H222V72a22,22,0,0,0-22-22H56A22,22,0,0,0,34,72v98H24a6,6,0,0,0-6,6v16a22,22,0,0,0,22,22H216a22,22,0,0,0,22-22V176A6,6,0,0,0,232,170ZM46,72A10,10,0,0,1,56,62H200a10,10,0,0,1,10,10v98H46ZM226,192a10,10,0,0,1-10,10H40a10,10,0,0,1-10-10V182H226ZM150,88a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h32A6,6,0,0,1,150,88Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,168h-8V72a24,24,0,0,0-24-24H56A24,24,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24,24,0,0,0,24,24H216a24,24,0,0,0,24-24V176A8,8,0,0,0,232,168ZM48,72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8v96H48ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224ZM152,88a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,172H220V72a20,20,0,0,0-20-20H56A20,20,0,0,0,36,72V172H24a4,4,0,0,0-4,4v16a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V176A4,4,0,0,0,232,172ZM44,72A12,12,0,0,1,56,60H200a12,12,0,0,1,12,12V172H44ZM228,192a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V180H228ZM148,88a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4,4,0,0,1,148,88Z"
        }))
    ]
]);


const $5a4a10635b84b894$export$b94473071ddf9fbf = $7fPBF.forwardRef((a, p)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: p
    }, a), {
        weights: (0, $b2857ed63604d24d$export$2e2bcd8739ae039)
    })));
$5a4a10635b84b894$export$b94473071ddf9fbf.displayName = "LaptopIcon";
const $5a4a10635b84b894$export$650c7f4d72afd4aa = $5a4a10635b84b894$export$b94473071ddf9fbf;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0edb934884d7da7c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,232a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,232Zm40-128a92.47,92.47,0,0,1-37,73.73,7.81,7.81,0,0,0-3,6.27,20,20,0,0,1-20,20H96a20,20,0,0,1-20-20v-.23a7.76,7.76,0,0,0-3.25-6.2,91.36,91.36,0,0,1-36.75-73C35.73,54.69,76,13.2,125.79,12A92,92,0,0,1,220,104Zm-24,0a68,68,0,0,0-69.65-68C89.56,36.89,59.8,67.56,60,104.39a67.52,67.52,0,0,0,27.18,54h0A32.14,32.14,0,0,1,99.77,180H116V149L87.51,120.49a12,12,0,0,1,17-17L128,127l23.51-23.51a12,12,0,0,1,17,17L140,149v31h16.25a31.89,31.89,0,0,1,12.41-21.49A67.45,67.45,0,0,0,196,104Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,104a79.86,79.86,0,0,1-30.59,62.92A24.29,24.29,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6a24.11,24.11,0,0,0-9.3-19A79.87,79.87,0,0,1,48,104.45C47.76,61.09,82.72,25,126.07,24A80,80,0,0,1,208,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-50.34,2.34a8,8,0,0,0-11.32,0L128,132.69l-26.34-26.35a8,8,0,0,0-11.32,11.32L120,147.31V184a8,8,0,0,0,16,0V147.31l29.66-29.65A8,8,0,0,0,165.66,106.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M174,232a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,232Zm40-128a85.56,85.56,0,0,1-32.88,67.64A18.23,18.23,0,0,0,174,186v6a14,14,0,0,1-14,14H96a14,14,0,0,1-14-14v-6a18,18,0,0,0-7-14.23h0a85.59,85.59,0,0,1-33-67.25C41.74,57.91,79.39,19.12,125.93,18A86,86,0,0,1,214,104Zm-12,0a74,74,0,0,0-75.79-74C86.17,31,53.78,64.34,54,104.42a73.67,73.67,0,0,0,28.4,57.87A29.92,29.92,0,0,1,94,186v6a2,2,0,0,0,2,2h26V146.49L91.76,116.24a6,6,0,0,1,8.48-8.48L128,135.52l27.76-27.76a6,6,0,0,1,8.48,8.48L134,146.49V194h26a2,2,0,0,0,2-2v-6a30.18,30.18,0,0,1,11.7-23.78A73.59,73.59,0,0,0,202,104Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,232a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,232Zm40-128a83.59,83.59,0,0,1-32.11,66.06A20.2,20.2,0,0,0,172,186v6a12,12,0,0,1-12,12H96a12,12,0,0,1-12-12v-6a20,20,0,0,0-7.76-15.81A83.58,83.58,0,0,1,44,104.47C43.75,59,80.52,21.09,126,20a84,84,0,0,1,86,84Zm-8,0a76,76,0,0,0-77.84-76C85,29,51.77,63.27,52,104.43a75.62,75.62,0,0,0,29.17,59.43A28,28,0,0,1,92,186v6a4,4,0,0,0,4,4h28V145.66L93.17,114.83a4,4,0,0,1,5.66-5.66L128,138.34l29.17-29.17a4,4,0,1,1,5.66,5.66L132,145.66V196h28a4,4,0,0,0,4-4v-6a28.14,28.14,0,0,1,10.94-22.2A75.62,75.62,0,0,0,204,104Z"
        }))
    ]
]);


const $885e936d56aff1b9$export$f678a184393c5940 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, o), {
        weights: (0, $0edb934884d7da7c$export$2e2bcd8739ae039)
    })));
$885e936d56aff1b9$export$f678a184393c5940.displayName = "LightbulbFilamentIcon";
const $885e936d56aff1b9$export$799e16ecf3c4889e = $885e936d56aff1b9$export$f678a184393c5940;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $93b42e4cb2afcb64$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.71,117.38a12,12,0,0,0-7.25-8.52L161.28,88.39l10.59-70.61a12,12,0,0,0-20.64-10l-112,120a12,12,0,0,0,4.31,19.33l51.18,20.47L84.13,238.22a12,12,0,0,0,20.64,10l112-120A12,12,0,0,0,219.71,117.38ZM113.6,203.55l6.27-41.77a12,12,0,0,0-7.41-12.92L68.74,131.37,142.4,52.45l-6.27,41.77a12,12,0,0,0,7.41,12.92l43.72,17.49Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,240l16-80L48,136,160,16,144,96l64,24Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.85,125.46l-112,120a8,8,0,0,1-13.69-7l14.66-73.33L45.19,143.49a8,8,0,0,1-3-13l112-120a8,8,0,0,1,13.69,7L153.18,90.9l57.63,21.61a8,8,0,0,1,3,12.95Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.84,118.63a6,6,0,0,0-3.73-4.25L150.88,92.17l15-75a6,6,0,0,0-10.27-5.27l-112,120a6,6,0,0,0,2.28,9.71l59.23,22.21-15,75a6,6,0,0,0,3.14,6.52A6.07,6.07,0,0,0,96,246a6,6,0,0,0,4.39-1.91l112-120A6,6,0,0,0,213.84,118.63ZM106,220.46l11.85-59.28a6,6,0,0,0-3.77-6.8l-55.6-20.85,91.46-98L138.12,94.82a6,6,0,0,0,3.77,6.8l55.6,20.85Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.79,118.17a8,8,0,0,0-5-5.66L153.18,90.9l14.66-73.33a8,8,0,0,0-13.69-7l-112,120a8,8,0,0,0,3,13l57.63,21.61L88.16,238.43a8,8,0,0,0,13.69,7l112-120A8,8,0,0,0,215.79,118.17ZM109.37,214l10.47-52.38a8,8,0,0,0-5-9.06L62,132.71l84.62-90.66L136.16,94.43a8,8,0,0,0,5,9.06l52.8,19.8Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M211.89,119.09a4,4,0,0,0-2.49-2.84l-60.81-22.8,15.33-76.67a4,4,0,0,0-6.84-3.51l-112,120a4,4,0,0,0-1,3.64,4,4,0,0,0,2.49,2.84l60.81,22.8L92.08,239.22a4,4,0,0,0,6.84,3.51l112-120A4,4,0,0,0,211.89,119.09ZM102.68,227l13.24-66.2a4,4,0,0,0-2.52-4.53L55,134.36,153.32,29l-13.24,66.2a4,4,0,0,0,2.52,4.53L201,121.64Z"
        }))
    ]
]);


const $66907d3d09578e84$export$b9beba9ac1b19787 = $7fPBF.forwardRef((n, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: i
    }, n), {
        weights: (0, $93b42e4cb2afcb64$export$2e2bcd8739ae039)
    })));
$66907d3d09578e84$export$b9beba9ac1b19787.displayName = "LightningIcon";
const $66907d3d09578e84$export$71809dd4a5478fb0 = $66907d3d09578e84$export$b9beba9ac1b19787;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $461317875df4d2f6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M195.8,60.2a28,28,0,0,0-39.51-.09L144.68,72.28a12,12,0,1,1-17.36-16.56L139,43.43l.2-.2a52,52,0,0,1,73.54,73.54l-.2.2-12.29,11.71a12,12,0,0,1-16.56-17.36l12.17-11.61A28,28,0,0,0,195.8,60.2ZM111.32,183.72,99.71,195.89a28,28,0,0,1-39.6-39.6l12.17-11.61a12,12,0,0,0-16.56-17.36L43.43,139l-.2.2a52,52,0,0,0,73.54,73.54l.2-.2,11.71-12.29a12,12,0,1,0-17.36-16.56ZM216,148H192a12,12,0,0,0,0,24h24a12,12,0,0,0,0-24ZM40,108H64a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24Zm120,72a12,12,0,0,0-12,12v24a12,12,0,0,0,24,0V192A12,12,0,0,0,160,180ZM96,76a12,12,0,0,0,12-12V40a12,12,0,0,0-24,0V64A12,12,0,0,0,96,76Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204.28,108.28l-96,96a40,40,0,0,1-56.56-56.56l96-96a40,40,0,0,1,56.56,56.56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198.63,57.37a32,32,0,0,0-45.19-.06L141.79,69.52a8,8,0,0,1-11.58-11l11.72-12.29a1.59,1.59,0,0,1,.13-.13,48,48,0,0,1,67.88,67.88,1.59,1.59,0,0,1-.13.13l-12.29,11.72a8,8,0,0,1-11-11.58l12.21-11.65A32,32,0,0,0,198.63,57.37ZM114.21,186.48l-11.65,12.21a32,32,0,0,1-45.25-45.25l12.21-11.65a8,8,0,0,0-11-11.58L46.19,141.93a1.59,1.59,0,0,0-.13.13,48,48,0,0,0,67.88,67.88,1.59,1.59,0,0,0,.13-.13l11.72-12.29a8,8,0,1,0-11.58-11ZM216,152H192a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM40,104H64a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm120,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V192A8,8,0,0,0,160,184ZM96,72a8,8,0,0,0,8-8V40a8,8,0,0,0-16,0V64A8,8,0,0,0,96,72Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM96,64a8,8,0,0,1,16,0V80a8,8,0,0,1-16,0ZM64,96H80a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm64.08,85.66-7.21,7.21a38,38,0,1,1-53.74-53.74l7.21-7.21a8,8,0,1,1,11.32,11.31l-7.22,7.21a22,22,0,0,0,31.12,31.12l7.21-7.22a8,8,0,1,1,11.31,11.32ZM160,192a8,8,0,0,1-16,0V176a8,8,0,0,1,16,0Zm32-32H176a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm-3.13-39.13-7.21,7.21a8,8,0,1,1-11.32-11.31l7.22-7.21a22,22,0,0,0-31.12-31.12l-7.21,7.22a8,8,0,1,1-11.31-11.32l7.21-7.21a38,38,0,1,1,53.74,53.74Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56a34,34,0,0,0-48-.05L140.34,68.14a6,6,0,1,1-8.68-8.28l11.71-12.28.1-.11a46,46,0,0,1,65.06,65.06l-.11.1-12.28,11.71a6,6,0,1,1-8.28-8.68L200.09,104A34,34,0,0,0,200,56Zm-84.38,131.9L104,200.09A34,34,0,0,1,55.91,152l12.23-11.67a6,6,0,0,0-8.28-8.68L47.58,143.37l-.11.1a46,46,0,0,0,65.06,65.06l.1-.11,11.71-12.28a6,6,0,1,0-8.68-8.28ZM216,154H192a6,6,0,0,0,0,12h24a6,6,0,0,0,0-12ZM40,102H64a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12Zm120,84a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V192A6,6,0,0,0,160,186ZM96,70a6,6,0,0,0,6-6V40a6,6,0,0,0-12,0V64A6,6,0,0,0,96,70Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198.63,57.37a32,32,0,0,0-45.19-.06L141.79,69.52a8,8,0,0,1-11.58-11l11.72-12.29a1.59,1.59,0,0,1,.13-.13,48,48,0,0,1,67.88,67.88,1.59,1.59,0,0,1-.13.13l-12.29,11.72a8,8,0,0,1-11-11.58l12.21-11.65A32,32,0,0,0,198.63,57.37ZM114.21,186.48l-11.65,12.21a32,32,0,0,1-45.25-45.25l12.21-11.65a8,8,0,0,0-11-11.58L46.19,141.93a1.59,1.59,0,0,0-.13.13,48,48,0,0,0,67.88,67.88,1.59,1.59,0,0,0,.13-.13l11.72-12.29a8,8,0,1,0-11.58-11ZM216,152H192a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM40,104H64a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm120,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V192A8,8,0,0,0,160,184ZM96,72a8,8,0,0,0,8-8V40a8,8,0,0,0-16,0V64A8,8,0,0,0,96,72Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M201.46,54.54a36.06,36.06,0,0,0-50.92,0L138.89,66.76a4,4,0,0,1-5.78-5.52L144.82,49a44,44,0,1,1,62.29,62.15l-12.35,11.78a4,4,0,0,1-5.52-5.78l12.28-11.72A36,36,0,0,0,201.46,54.54Zm-84.35,134.7-11.65,12.22a36,36,0,0,1-51-50.85l12.28-11.72a4,4,0,0,0-5.52-5.78L48.89,144.89A44,44,0,1,0,111.18,207l11.71-12.28a4,4,0,1,0-5.78-5.52ZM216,156H192a4,4,0,0,0,0,8h24a4,4,0,0,0,0-8ZM40,100H64a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8Zm120,88a4,4,0,0,0-4,4v24a4,4,0,0,0,8,0V192A4,4,0,0,0,160,188ZM96,68a4,4,0,0,0,4-4V40a4,4,0,0,0-8,0V64A4,4,0,0,0,96,68Z"
        }))
    ]
]);


const $a7ac72ddd488c3fa$export$3cf6c022d9395be8 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $461317875df4d2f6$export$2e2bcd8739ae039)
    })));
$a7ac72ddd488c3fa$export$3cf6c022d9395be8.displayName = "LinkBreakIcon";
const $a7ac72ddd488c3fa$export$a720e9411394ceb = $a7ac72ddd488c3fa$export$3cf6c022d9395be8;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $fd0b224f747c6f70$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.18,188.74a12,12,0,0,1,0,17l-5.12,5.12A58.26,58.26,0,0,1,70.6,228h0A58.62,58.62,0,0,1,29.14,127.92L63.89,93.17a58.64,58.64,0,0,1,98.56,28.11,12,12,0,1,1-23.37,5.44,34.65,34.65,0,0,0-58.22-16.58L46.11,144.89A34.62,34.62,0,0,0,70.57,204h0a34.41,34.41,0,0,0,24.49-10.14l5.11-5.12A12,12,0,0,1,117.18,188.74ZM226.83,45.17a58.65,58.65,0,0,0-82.93,0l-5.11,5.11a12,12,0,0,0,17,17l5.12-5.12a34.63,34.63,0,1,1,49,49L175.1,145.86A34.39,34.39,0,0,1,150.61,156h0a34.63,34.63,0,0,1-33.69-26.72,12,12,0,0,0-23.38,5.44A58.64,58.64,0,0,0,150.56,180h.05a58.28,58.28,0,0,0,41.47-17.17l34.75-34.75a58.62,58.62,0,0,0,0-82.91Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M218.34,119.6,183.6,154.34a46.58,46.58,0,0,1-44.31,12.26c-.31.34-.62.67-.95,1L103.6,202.34A46.63,46.63,0,1,1,37.66,136.4L72.4,101.66A46.6,46.6,0,0,1,116.71,89.4c.31-.34.62-.67,1-1L152.4,53.66a46.63,46.63,0,0,1,65.94,65.94Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,88.23a54.43,54.43,0,0,1-16,37L189.25,160a54.27,54.27,0,0,1-38.63,16h-.05A54.63,54.63,0,0,1,96,119.84a8,8,0,0,1,16,.45A38.62,38.62,0,0,0,150.58,160h0a38.39,38.39,0,0,0,27.31-11.31l34.75-34.75a38.63,38.63,0,0,0-54.63-54.63l-11,11A8,8,0,0,1,135.7,59l11-11A54.65,54.65,0,0,1,224,48,54.86,54.86,0,0,1,240,88.23ZM109,185.66l-11,11A38.41,38.41,0,0,1,70.6,208h0a38.63,38.63,0,0,1-27.29-65.94L78,107.31A38.63,38.63,0,0,1,144,135.71a8,8,0,0,0,7.78,8.22H152a8,8,0,0,0,8-7.78A54.86,54.86,0,0,0,144,96a54.65,54.65,0,0,0-77.27,0L32,130.75A54.62,54.62,0,0,0,70.56,224h0a54.28,54.28,0,0,0,38.64-16l11-11A8,8,0,0,0,109,185.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM115.7,192.49a43.31,43.31,0,0,1-55-66.43l25.37-25.37a43.35,43.35,0,0,1,61.25,0,42.9,42.9,0,0,1,9.95,15.43,8,8,0,1,1-15,5.6A27.33,27.33,0,0,0,97.37,112L72,137.37a27.32,27.32,0,0,0,34.68,41.91,8,8,0,1,1,9,13.21Zm79.61-62.55-25.37,25.37A43,43,0,0,1,139.32,168h0a43.35,43.35,0,0,1-40.53-28.12,8,8,0,1,1,15-5.6A27.35,27.35,0,0,0,139.28,152h0a27.14,27.14,0,0,0,19.32-8L184,118.63a27.32,27.32,0,0,0-34.68-41.91,8,8,0,1,1-9-13.21,43.32,43.32,0,0,1,55,66.43Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238,88.18a52.42,52.42,0,0,1-15.4,35.66l-34.75,34.75A52.28,52.28,0,0,1,150.62,174h-.05A52.63,52.63,0,0,1,98,119.9a6,6,0,0,1,6-5.84h.17a6,6,0,0,1,5.83,6.16A40.62,40.62,0,0,0,150.58,162h0a40.4,40.4,0,0,0,28.73-11.9l34.75-34.74A40.63,40.63,0,0,0,156.63,57.9l-11,11a6,6,0,0,1-8.49-8.49l11-11a52.62,52.62,0,0,1,74.43,0A52.83,52.83,0,0,1,238,88.18Zm-127.62,98.9-11,11A40.36,40.36,0,0,1,70.6,210h0a40.63,40.63,0,0,1-28.7-69.36L76.62,105.9A40.63,40.63,0,0,1,146,135.77a6,6,0,0,0,5.83,6.16H152a6,6,0,0,0,6-5.84A52.63,52.63,0,0,0,68.14,97.42L33.38,132.16A52.63,52.63,0,0,0,70.56,222h0a52.26,52.26,0,0,0,37.22-15.42l11-11a6,6,0,1,0-8.49-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,88.23a54.43,54.43,0,0,1-16,37L189.25,160a54.27,54.27,0,0,1-38.63,16h-.05A54.63,54.63,0,0,1,96,119.84a8,8,0,0,1,16,.45A38.62,38.62,0,0,0,150.58,160h0a38.39,38.39,0,0,0,27.31-11.31l34.75-34.75a38.63,38.63,0,0,0-54.63-54.63l-11,11A8,8,0,0,1,135.7,59l11-11A54.65,54.65,0,0,1,224,48,54.86,54.86,0,0,1,240,88.23ZM109,185.66l-11,11A38.41,38.41,0,0,1,70.6,208h0a38.63,38.63,0,0,1-27.29-65.94L78,107.31A38.63,38.63,0,0,1,144,135.71a8,8,0,0,0,16,.45A54.86,54.86,0,0,0,144,96a54.65,54.65,0,0,0-77.27,0L32,130.75A54.62,54.62,0,0,0,70.56,224h0a54.28,54.28,0,0,0,38.64-16l11-11A8,8,0,0,0,109,185.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,88.12a50.44,50.44,0,0,1-14.81,34.31l-34.75,34.74A50.33,50.33,0,0,1,150.62,172h-.05A50.63,50.63,0,0,1,100,120a4,4,0,0,1,4-3.89h.11a4,4,0,0,1,3.89,4.11A42.64,42.64,0,0,0,150.58,164h0a42.32,42.32,0,0,0,30.14-12.49l34.75-34.74a42.63,42.63,0,1,0-60.29-60.28l-11,11a4,4,0,0,1-5.66-5.65l11-11A50.64,50.64,0,0,1,236,88.12ZM111.78,188.49l-11,11A42.33,42.33,0,0,1,70.6,212h0a42.63,42.63,0,0,1-30.11-72.77l34.75-34.74A42.63,42.63,0,0,1,148,135.82a4,4,0,0,0,8,.23A50.64,50.64,0,0,0,69.55,98.83L34.8,133.57A50.63,50.63,0,0,0,70.56,220h0a50.33,50.33,0,0,0,35.81-14.83l11-11a4,4,0,1,0-5.65-5.66Z"
        }))
    ]
]);


const $9c3d003be71bd9c3$export$69387b41dfc808f7 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $fd0b224f747c6f70$export$2e2bcd8739ae039)
    })));
$9c3d003be71bd9c3$export$69387b41dfc808f7.displayName = "LinkIcon";
const $9c3d003be71bd9c3$export$a6c7ac8248d6e38a = $9c3d003be71bd9c3$export$69387b41dfc808f7;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bc8e1fdf833b7515$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76,64A12,12,0,0,1,88,52H216a12,12,0,0,1,0,24H88A12,12,0,0,1,76,64Zm140,52H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Zm0,64H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM44,112a16,16,0,1,0,16,16A16,16,0,0,0,44,112Zm0-64A16,16,0,1,0,60,64,16,16,0,0,0,44,48Zm0,128a16,16,0,1,0,16,16A16,16,0,0,0,44,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,64V192H88V64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM68,188a12,12,0,1,1,12-12A12,12,0,0,1,68,188Zm0-48a12,12,0,1,1,12-12A12,12,0,0,1,68,140Zm0-48A12,12,0,1,1,80,80,12,12,0,0,1,68,92Zm124,92H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M82,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H88A6,6,0,0,1,82,64Zm134,58H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Zm0,64H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM44,54A10,10,0,1,0,54,64,10,10,0,0,0,44,54Zm0,128a10,10,0,1,0,10,10A10,10,0,0,0,44,182Zm0-64a10,10,0,1,0,10,10A10,10,0,0,0,44,118Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M84,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H88A4,4,0,0,1,84,64Zm132,60H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Zm0,64H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM44,120a8,8,0,1,0,8,8A8,8,0,0,0,44,120Zm0-64a8,8,0,1,0,8,8A8,8,0,0,0,44,56Zm0,128a8,8,0,1,0,8,8A8,8,0,0,0,44,184Z"
        }))
    ]
]);


const $e1f565be31fe1992$export$70784bf0c528892c = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, o), {
        weights: (0, $bc8e1fdf833b7515$export$2e2bcd8739ae039)
    })));
$e1f565be31fe1992$export$70784bf0c528892c.displayName = "ListBulletsIcon";
const $e1f565be31fe1992$export$ab6272c0151aba3a = $e1f565be31fe1992$export$70784bf0c528892c;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bf915eef26b93a50$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,128a12,12,0,0,1-12,12H128a12,12,0,0,1,0-24h88A12,12,0,0,1,228,128ZM128,76h88a12,12,0,0,0,0-24H128a12,12,0,0,0,0,24Zm88,104H128a12,12,0,0,0,0,24h88a12,12,0,0,0,0-24ZM79.51,39.51,56,63l-7.51-7.52a12,12,0,0,0-17,17l16,16a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Zm0,64L56,127l-7.51-7.52a12,12,0,1,0-17,17l16,16a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Zm0,64L56,191l-7.51-7.52a12,12,0,1,0-17,17l16,16a12,12,0,0,0,17,0l32-32a12,12,0,0,0-17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,64V192H128V64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM117.66,149.66l-32,32a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,11.32-11.32L80,164.69l26.34-26.35a8,8,0,0,1,11.32,11.32Zm0-64-32,32a8,8,0,0,1-11.32,0l-16-16A8,8,0,0,1,69.66,90.34L80,100.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM192,168H144a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-64H144a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,128a6,6,0,0,1-6,6H128a6,6,0,0,1,0-12h88A6,6,0,0,1,222,128ZM128,70h88a6,6,0,0,0,0-12H128a6,6,0,0,0,0,12Zm88,116H128a6,6,0,0,0,0,12h88a6,6,0,0,0,0-12ZM83.76,43.76,56,71.51,44.24,59.76a6,6,0,0,0-8.48,8.48l16,16a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Zm0,64L56,135.51,44.24,123.76a6,6,0,1,0-8.48,8.48l16,16a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Zm0,64L56,199.51,44.24,187.76a6,6,0,0,0-8.48,8.48l16,16a6,6,0,0,0,8.48,0l32-32a6,6,0,0,0-8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,128a4,4,0,0,1-4,4H128a4,4,0,0,1,0-8h88A4,4,0,0,1,220,128ZM128,68h88a4,4,0,0,0,0-8H128a4,4,0,0,0,0,8Zm88,120H128a4,4,0,0,0,0,8h88a4,4,0,0,0,0-8ZM85.17,45.17,56,74.34,42.83,61.17a4,4,0,0,0-5.66,5.66l16,16a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Zm0,64L56,138.34,42.83,125.17a4,4,0,1,0-5.66,5.66l16,16a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Zm0,64L56,202.34,42.83,189.17a4,4,0,0,0-5.66,5.66l16,16a4,4,0,0,0,5.66,0l32-32a4,4,0,0,0-5.66-5.66Z"
        }))
    ]
]);


const $ca64e21eb0b03905$export$35749e1285046a5a = $7fPBF.forwardRef((s, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, s), {
        weights: (0, $bf915eef26b93a50$export$2e2bcd8739ae039)
    })));
$ca64e21eb0b03905$export$35749e1285046a5a.displayName = "ListChecksIcon";
const $ca64e21eb0b03905$export$3f1aeee1f1adc472 = $ca64e21eb0b03905$export$35749e1285046a5a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $fbed39eee33f9ed3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M28,64A12,12,0,0,1,40,52H216a12,12,0,0,1,0,24H40A12,12,0,0,1,28,64Zm12,76h64a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24Zm80,40H40a12,12,0,0,0,0,24h80a12,12,0,0,0,0-24Zm120.49,20.49a12,12,0,0,1-17,0l-18.08-18.08a44,44,0,1,1,17-17l18.08,18.07A12,12,0,0,1,240.49,200.49ZM184,164a20,20,0,1,0-20-20A20,20,0,0,0,184,164Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,144a32,32,0,1,1-32-32A32,32,0,0,1,216,144Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72h72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm88,48H40a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16Zm109.66,13.66a8,8,0,0,1-11.32,0L206,177.36A40,40,0,1,1,217.36,166l20.3,20.3A8,8,0,0,1,237.66,197.66ZM184,168a24,24,0,1,0-24-24A24,24,0,0,0,184,168Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72h72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm88,48H40a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16Zm109.66,2.34L217.36,166A40,40,0,1,0,206,177.36l20.3,20.3a8,8,0,0,0,11.32-11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M34,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H40A6,6,0,0,1,34,64Zm6,70h72a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12Zm88,52H40a6,6,0,0,0,0,12h88a6,6,0,0,0,0-12Zm108.24,10.24a6,6,0,0,1-8.48,0l-21.49-21.48a38.06,38.06,0,1,1,8.49-8.49l21.48,21.49A6,6,0,0,1,236.24,196.24ZM184,170a26,26,0,1,0-26-26A26,26,0,0,0,184,170Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72h72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm88,48H40a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16Zm109.66,13.66a8,8,0,0,1-11.32,0L206,177.36A40,40,0,1,1,217.36,166l20.3,20.3A8,8,0,0,1,237.66,197.66ZM184,168a24,24,0,1,0-24-24A24,24,0,0,0,184,168Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M36,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H40A4,4,0,0,1,36,64Zm4,68h72a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8Zm88,56H40a4,4,0,0,0,0,8h88a4,4,0,0,0,0-8Zm106.83,6.83a4,4,0,0,1-5.66,0l-22.72-22.72a36.06,36.06,0,1,1,5.66-5.66l22.72,22.72A4,4,0,0,1,234.83,194.83ZM184,172a28,28,0,1,0-28-28A28,28,0,0,0,184,172Z"
        }))
    ]
]);


const $b70a64411fa68f1f$export$c4110d37f1233070 = $7fPBF.forwardRef((i, o)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: o
    }, i), {
        weights: (0, $fbed39eee33f9ed3$export$2e2bcd8739ae039)
    })));
$b70a64411fa68f1f$export$c4110d37f1233070.displayName = "ListMagnifyingGlassIcon";
const $b70a64411fa68f1f$export$36aa412d9eb61ee5 = $b70a64411fa68f1f$export$c4110d37f1233070;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $1ca88c68007b06ee$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z"
        }))
    ]
]);


const $5394ccda98b8b514$export$f7658c347b037c3f = $7fPBF.forwardRef((s, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: n
    }, s), {
        weights: (0, $1ca88c68007b06ee$export$2e2bcd8739ae039)
    })));
$5394ccda98b8b514$export$f7658c347b037c3f.displayName = "MagnifyingGlassIcon";
const $5394ccda98b8b514$export$bdf537af43a20db5 = $5394ccda98b8b514$export$f7658c347b037c3f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5792d4d40bf644fc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,96A92,92,0,1,0,68,165.69V240a12,12,0,0,0,17.37,10.73L128,229.42l42.64,21.31A12,12,0,0,0,188,240V165.69A91.86,91.86,0,0,0,220,96ZM60,96a68,68,0,1,1,68,68A68.07,68.07,0,0,1,60,96ZM164,220.59l-30.64-15.32a12,12,0,0,0-10.74,0L92,220.58V180.66a92,92,0,0,0,72,0ZM128,148A52,52,0,1,0,76,96,52.06,52.06,0,0,0,128,148Zm0-80a28,28,0,1,1-28,28A28,28,0,0,1,128,68Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,96a48,48,0,1,1-48-48A48,48,0,0,1,176,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96ZM168,227.06l-36.43-18.21a8,8,0,0,0-7.16,0L88,227.06V174.37a87.89,87.89,0,0,0,80,0ZM128,152A56,56,0,1,0,72,96,56.06,56.06,0,0,0,128,152Zm0-96A40,40,0,1,1,88,96,40,40,0,0,1,128,56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96Zm16,0a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M214,96A86,86,0,1,0,74,162.87V240a6,6,0,0,0,2.85,5.1A5.93,5.93,0,0,0,80,246a6,6,0,0,0,2.68-.63L128,222.71l45.33,22.66A6,6,0,0,0,182,240V162.87A85.87,85.87,0,0,0,214,96ZM54,96a74,74,0,1,1,74,74A74.09,74.09,0,0,1,54,96ZM170,230.29l-39.33-19.66a6,6,0,0,0-5.36,0L86,230.29V171a85.75,85.75,0,0,0,84,0ZM128,150A54,54,0,1,0,74,96,54.06,54.06,0,0,0,128,150Zm0-96A42,42,0,1,1,86,96,42,42,0,0,1,128,54Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96ZM168,227.06l-36.43-18.21a8,8,0,0,0-7.16,0L88,227.06V174.37a87.89,87.89,0,0,0,80,0ZM128,152A56,56,0,1,0,72,96,56.06,56.06,0,0,0,128,152Zm0-96A40,40,0,1,1,88,96,40,40,0,0,1,128,56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212,96A84,84,0,1,0,76,161.9V240a4,4,0,0,0,4,4,4.05,4.05,0,0,0,1.79-.42L128,220.47l46.22,23.11A4,4,0,0,0,180,240V161.9A83.89,83.89,0,0,0,212,96ZM172,233.53l-42.22-21.11a4,4,0,0,0-3.58,0L84,233.53v-66a83.8,83.8,0,0,0,88,0ZM128,172a76,76,0,1,1,76-76A76.08,76.08,0,0,1,128,172Zm0-128a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,44Zm0,96a44,44,0,1,1,44-44A44.05,44.05,0,0,1,128,140Z"
        }))
    ]
]);


const $a04767458aa408f3$export$f8328d6431f0c3df = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, a), {
        weights: (0, $5792d4d40bf644fc$export$2e2bcd8739ae039)
    })));
$a04767458aa408f3$export$f8328d6431f0c3df.displayName = "MedalIcon";
const $a04767458aa408f3$export$f75a880bcbff3a85 = $a04767458aa408f3$export$f8328d6431f0c3df;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7989cf3dc1bdd743$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,180a52.06,52.06,0,0,0,52-52V64A52,52,0,0,0,76,64v64A52.06,52.06,0,0,0,128,180ZM100,64a28,28,0,0,1,56,0v64a28,28,0,0,1-56,0Zm40,155.22V240a12,12,0,0,1-24,0V219.22A92.14,92.14,0,0,1,36,128a12,12,0,0,1,24,0,68,68,0,0,0,136,0,12,12,0,0,1,24,0A92.14,92.14,0,0,1,140,219.22Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,64v64a40,40,0,0,1-40,40h0a40,40,0,0,1-40-40V64a40,40,0,0,1,40-40h0A40,40,0,0,1,168,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,128V64a48,48,0,0,1,96,0v64a48,48,0,0,1-96,0Zm128,0a8,8,0,0,0-16,0,64,64,0,0,1-128,0,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.6A80.11,80.11,0,0,0,208,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,174a46.06,46.06,0,0,0,46-46V64a46,46,0,0,0-92,0v64A46.06,46.06,0,0,0,128,174ZM94,64a34,34,0,0,1,68,0v64a34,34,0,0,1-68,0Zm40,141.75V240a6,6,0,0,1-12,0V205.75A78.09,78.09,0,0,1,50,128a6,6,0,0,1,12,0,66,66,0,0,0,132,0,6,6,0,0,1,12,0A78.09,78.09,0,0,1,134,205.75Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,172a44.05,44.05,0,0,0,44-44V64a44,44,0,0,0-88,0v64A44.05,44.05,0,0,0,128,172ZM92,64a36,36,0,0,1,72,0v64a36,36,0,0,1-72,0Zm40,139.89V240a4,4,0,0,1-8,0V203.89A76.09,76.09,0,0,1,52,128a4,4,0,0,1,8,0,68,68,0,0,0,136,0,4,4,0,0,1,8,0A76.09,76.09,0,0,1,132,203.89Z"
        }))
    ]
]);


const $09b782f8de8a3c61$export$d2834cd4e399cf8b = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $7989cf3dc1bdd743$export$2e2bcd8739ae039)
    })));
$09b782f8de8a3c61$export$d2834cd4e399cf8b.displayName = "MicrophoneIcon";
const $09b782f8de8a3c61$export$df91f3efeb156795 = $09b782f8de8a3c61$export$d2834cd4e399cf8b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0cf5baa2ddd482e9$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,39.93A12,12,0,1,0,39.12,56.07L76,96.64V128a52,52,0,0,0,72.11,48l11.26,12.39A67.34,67.34,0,0,1,128,196a68.07,68.07,0,0,1-68-68,12,12,0,0,0-24,0,92.14,92.14,0,0,0,80,91.22V240a12,12,0,0,0,24,0V219.23a90.39,90.39,0,0,0,35.92-12.68l23.2,25.52a12,12,0,0,0,17.76-16.14ZM128,156a28,28,0,0,1-28-28v-5l29.9,32.89C129.27,156,128.64,156,128,156Zm63-2.42A67.63,67.63,0,0,0,196,128a12,12,0,0,1,24,0,91.48,91.48,0,0,1-6.74,34.61,12,12,0,0,1-22.23-9ZM85.7,33.75A52,52,0,0,1,180,64v56.54a12,12,0,0,1-24,0V64a28,28,0,0,0-50.79-16.28,12,12,0,0,1-19.51-14Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,64v64a40,40,0,0,1-40,40h0a40,40,0,0,1-40-40V64a40,40,0,0,1,40-40h0A40,40,0,0,1,168,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,218.62l-160-176A8,8,0,0,0,42.08,53.38L80,95.09V128a48,48,0,0,0,69.11,43.12l11.1,12.2A63.41,63.41,0,0,1,128,192a64.07,64.07,0,0,1-64-64,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.59a78.83,78.83,0,0,0,35.16-12.22l30.92,34a8,8,0,1,0,11.84-10.76ZM128,160a32,32,0,0,1-32-32V112.69l41.66,45.82A32,32,0,0,1,128,160Zm57.52-3.91A63.32,63.32,0,0,0,192,128a8,8,0,0,1,16,0,79.16,79.16,0,0,1-8.11,35.12,8,8,0,0,1-7.19,4.49,7.88,7.88,0,0,1-3.51-.82A8,8,0,0,1,185.52,156.09ZM84,44.87A48,48,0,0,1,176,64v64a49.19,49.19,0,0,1-.26,5,8,8,0,0,1-8,7.17,8.13,8.13,0,0,1-.84,0,8,8,0,0,1-7.12-8.79c.11-1.1.17-2.24.17-3.36V64A32,32,0,0,0,98.64,51.25,8,8,0,1,1,84,44.87Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.38,229.92a8,8,0,0,1-11.3-.54l-30.92-34A78.83,78.83,0,0,1,136,207.59V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64.07,64.07,0,0,0,64,64,63.41,63.41,0,0,0,32.21-8.68l-11.1-12.2A48,48,0,0,1,80,128V95.09L42.08,53.38A8,8,0,0,1,53.92,42.62l160,176A8,8,0,0,1,213.38,229.92Zm-24.19-63.13a7.88,7.88,0,0,0,3.51.82,8,8,0,0,0,7.19-4.49A79.16,79.16,0,0,0,208,128a8,8,0,0,0-16,0,63.32,63.32,0,0,1-6.48,28.09A8,8,0,0,0,189.19,166.79Zm-27.33-29.22A8,8,0,0,0,175.74,133a49.49,49.49,0,0,0,.26-5V64A48,48,0,0,0,84,44.87a8,8,0,0,0,1.41,8.57Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212.44,220,52.44,44A6,6,0,0,0,43.56,52L82,94.32V128a46,46,0,0,0,67.56,40.64l13.75,15.12A65.26,65.26,0,0,1,128,194a66.08,66.08,0,0,1-66-66,6,6,0,0,0-12,0,78.09,78.09,0,0,0,72,77.75V240a6,6,0,0,0,12,0V205.77a76.93,76.93,0,0,0,37.48-13L203.56,228a6,6,0,0,0,8.88-8.08ZM128,162a34,34,0,0,1-34-34V107.52l47.12,51.84A33.82,33.82,0,0,1,128,162Zm59.32-5A65.38,65.38,0,0,0,194,128a6,6,0,0,1,12,0,77.33,77.33,0,0,1-7.9,34.25A6,6,0,1,1,187.32,157ZM85.8,45.67A46,46,0,0,1,174,64v64a45.17,45.17,0,0,1-.25,4.81,6,6,0,0,1-6,5.38q-.31,0-.63,0a6,6,0,0,1-5.34-6.59A35.41,35.41,0,0,0,162,128V64A34,34,0,0,0,96.8,50.45a6,6,0,0,1-11-4.78Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M213.92,218.62l-160-176A8,8,0,0,0,42.08,53.38L80,95.09V128a48,48,0,0,0,69.11,43.12l11.1,12.2A63.41,63.41,0,0,1,128,192a64.07,64.07,0,0,1-64-64,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.59a78.83,78.83,0,0,0,35.16-12.22l30.92,34a8,8,0,1,0,11.84-10.76ZM128,160a32,32,0,0,1-32-32V112.69l41.66,45.82A32,32,0,0,1,128,160Zm57.52-3.91A63.32,63.32,0,0,0,192,128a8,8,0,0,1,16,0,79.16,79.16,0,0,1-8.11,35.12,8,8,0,0,1-7.19,4.49,7.88,7.88,0,0,1-3.51-.82A8,8,0,0,1,185.52,156.09ZM84,44.87A48,48,0,0,1,176,64v64a49.19,49.19,0,0,1-.26,5,8,8,0,0,1-8,7.17,8.13,8.13,0,0,1-.84,0,8,8,0,0,1-7.12-8.79c.11-1.1.17-2.24.17-3.36V64A32,32,0,0,0,98.64,51.25,8,8,0,1,1,84,44.87Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M211,221.31,51,45.31A4,4,0,0,0,45,50.69L84,93.55V128a44,44,0,0,0,66,38.12l16.38,18A67.21,67.21,0,0,1,128,196a68.07,68.07,0,0,1-68-68,4,4,0,0,0-8,0,76.09,76.09,0,0,0,72,75.89V240a4,4,0,0,0,8,0V203.89a75.1,75.1,0,0,0,39.79-13.77L205,226.69a4,4,0,1,0,5.92-5.38ZM128,164a36,36,0,0,1-36-36V102.35L144.43,160A35.83,35.83,0,0,1,128,164Zm61.12-6.15A67.44,67.44,0,0,0,196,128a4,4,0,0,1,8,0,75.28,75.28,0,0,1-7.7,33.37,4,4,0,0,1-7.18-3.52ZM87.63,46.46A44,44,0,0,1,172,64v64a44.2,44.2,0,0,1-.24,4.61,4,4,0,0,1-4,3.58l-.42,0a4,4,0,0,1-3.57-4.39A36.67,36.67,0,0,0,164,128V64A36,36,0,0,0,95,49.66a4,4,0,0,1-7.34-3.2Z"
        }))
    ]
]);


const $2bb6ac751b7724ae$export$8d1357c8e3c4bfd6 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $0cf5baa2ddd482e9$export$2e2bcd8739ae039)
    })));
$2bb6ac751b7724ae$export$8d1357c8e3c4bfd6.displayName = "MicrophoneSlashIcon";
const $2bb6ac751b7724ae$export$ea06b1d4f312e4a2 = $2bb6ac751b7724ae$export$8d1357c8e3c4bfd6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $458c858cb1919c5a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,52H16A12,12,0,0,0,4,64V192a12,12,0,0,0,12,12H240a12,12,0,0,0,12-12V64A12,12,0,0,0,240,52ZM181.21,180H74.79A60.18,60.18,0,0,0,28,133.21V122.79A60.18,60.18,0,0,0,74.79,76H181.21A60.18,60.18,0,0,0,228,122.79v10.42A60.18,60.18,0,0,0,181.21,180ZM228,97.94A36.23,36.23,0,0,1,206.06,76H228ZM49.94,76A36.23,36.23,0,0,1,28,97.94V76ZM28,158.06A36.23,36.23,0,0,1,49.94,180H28ZM206.06,180A36.23,36.23,0,0,1,228,158.06V180ZM128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,56a16,16,0,1,1,16-16A16,16,0,0,1,128,144Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,128a32,32,0,1,1-32-32A32,32,0,0,1,160,128Zm40-64a48.85,48.85,0,0,0,40,40V64Zm0,128h40V152A48.85,48.85,0,0,0,200,192ZM16,152v40H56A48.85,48.85,0,0,0,16,152Zm0-48A48.85,48.85,0,0,0,56,64H16Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM24,72H45.37A40.81,40.81,0,0,1,24,93.37Zm0,112V162.63A40.81,40.81,0,0,1,45.37,184Zm208,0H210.63A40.81,40.81,0,0,1,232,162.63Zm0-38.35A56.78,56.78,0,0,0,193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35Zm0-52.28A40.81,40.81,0,0,1,210.63,72H232Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,128a40,40,0,1,1-40-40A40,40,0,0,1,168,128Zm80-64V192a8,8,0,0,1-8,8H16a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H240A8,8,0,0,1,248,64Zm-16,46.35A56.78,56.78,0,0,1,193.65,72H62.35A56.78,56.78,0,0,1,24,110.35v35.3A56.78,56.78,0,0,1,62.35,184h131.3A56.78,56.78,0,0,1,232,145.65Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,166a38,38,0,1,0-38-38A38,38,0,0,0,128,166Zm0-64a26,26,0,1,1-26,26A26,26,0,0,1,128,102ZM240,58H16a6,6,0,0,0-6,6V192a6,6,0,0,0,6,6H240a6,6,0,0,0,6-6V64A6,6,0,0,0,240,58ZM22,108.82A54.73,54.73,0,0,0,60.82,70H195.18A54.73,54.73,0,0,0,234,108.82v38.36A54.73,54.73,0,0,0,195.18,186H60.82A54.73,54.73,0,0,0,22,147.18ZM234,96.29A42.8,42.8,0,0,1,207.71,70H234ZM48.29,70A42.8,42.8,0,0,1,22,96.29V70ZM22,159.71A42.8,42.8,0,0,1,48.29,186H22ZM207.71,186A42.8,42.8,0,0,1,234,159.71V186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35v35.3A56.78,56.78,0,0,0,193.65,184ZM232,93.37A40.81,40.81,0,0,1,210.63,72H232ZM45.37,72A40.81,40.81,0,0,1,24,93.37V72ZM24,162.63A40.81,40.81,0,0,1,45.37,184H24ZM210.63,184A40.81,40.81,0,0,1,232,162.63V184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,164a36,36,0,1,0-36-36A36,36,0,0,0,128,164Zm0-64a28,28,0,1,1-28,28A28,28,0,0,1,128,100ZM240,60H16a4,4,0,0,0-4,4V192a4,4,0,0,0,4,4H240a4,4,0,0,0,4-4V64A4,4,0,0,0,240,60ZM20,107.26A52.75,52.75,0,0,0,59.26,68H196.74A52.75,52.75,0,0,0,236,107.26v41.48A52.75,52.75,0,0,0,196.74,188H59.26A52.75,52.75,0,0,0,20,148.74ZM236,99a44.8,44.8,0,0,1-31-31h31ZM51,68A44.8,44.8,0,0,1,20,99V68ZM20,157a44.8,44.8,0,0,1,31,31H20Zm185,31a44.8,44.8,0,0,1,31-31v31Z"
        }))
    ]
]);


const $67a91f296d46ab80$export$fb505dcffad77432 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $458c858cb1919c5a$export$2e2bcd8739ae039)
    })));
$67a91f296d46ab80$export$fb505dcffad77432.displayName = "MoneyIcon";
const $67a91f296d46ab80$export$d26bcf891bc220f6 = $67a91f296d46ab80$export$fb505dcffad77432;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $32aea46de550f8dd$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,68v20H140V36h4A44.05,44.05,0,0,1,188,80ZM112,36h4v64H68V80A44.05,44.05,0,0,1,112,36Zm32,184H112a44.05,44.05,0,0,1-44-44V124H188v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,112v64a56,56,0,0,1-56,56H112a56,56,0,0,1-56-56V112Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H134V30h10A50.06,50.06,0,0,1,194,80ZM112,30h10v76H62V80A50.06,50.06,0,0,1,112,30Zm32,196H112a50.06,50.06,0,0,1-50-50V118H194v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H132V28h12A52.06,52.06,0,0,1,196,80ZM112,28h12v80H60V80A52.06,52.06,0,0,1,112,28Zm32,200H112a52.06,52.06,0,0,1-52-52V116H196v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $91081726855ec7c6$export$53ac786375585ec0 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $32aea46de550f8dd$export$2e2bcd8739ae039)
    })));
$91081726855ec7c6$export$53ac786375585ec0.displayName = "MouseIcon";
const $91081726855ec7c6$export$7caecd373b84cec3 = $91081726855ec7c6$export$53ac786375585ec0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $67ed3f61d2e76f0b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,68v20H140V36h4A44.05,44.05,0,0,1,188,80ZM68,80a43.63,43.63,0,0,1,2-13L103,100H68Zm48-44V79L83.49,46.52A43.83,43.83,0,0,1,112,36Zm28,184H112a44.05,44.05,0,0,1-44-44V124H188v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24v88H56V80a56,56,0,0,1,56-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80Zm-76.69,24-46-46A48.49,48.49,0,0,1,80.51,43.82L120,83.31V104ZM64,80c0-1.51.08-3,.22-4.47L92.69,104H64Zm56-48V60.69L94.59,35.28A47.73,47.73,0,0,1,112,32Zm24,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H128V32h16A48.05,48.05,0,0,1,192,80ZM144,224H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H134V30h10A50.06,50.06,0,0,1,194,80ZM122,30V65.51L91.09,34.6A49.74,49.74,0,0,1,112,30ZM80.62,41.11,122,82.49V106h-7.51L66.9,58.42A50.3,50.3,0,0,1,80.62,41.11ZM62,80a50.17,50.17,0,0,1,.78-8.73L97.51,106H62Zm82,146H112a50.06,50.06,0,0,1-50-50V118H194v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80Zm-76.69,24-46-46A48.49,48.49,0,0,1,80.51,43.82L120,83.31V104ZM64,80c0-1.51.08-3,.22-4.47L92.69,104H64Zm56-48V60.69L94.59,35.28A47.73,47.73,0,0,1,112,32Zm24,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H132V28h12A52.06,52.06,0,0,1,196,80ZM124,28V70.34L87.7,34.05A51.61,51.61,0,0,1,112,28ZM80.78,38.44,124,81.66V108H113.66L64.51,58.85A52.5,52.5,0,0,1,80.78,38.44ZM60,80a51.55,51.55,0,0,1,1.59-12.75L102.34,108H60Zm84,148H112a52.06,52.06,0,0,1-52-52V116H196v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $35ad9356e9e5ec61$export$6b5f666f729352a = $7fPBF.forwardRef((t, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, t), {
        weights: (0, $67ed3f61d2e76f0b$export$2e2bcd8739ae039)
    })));
$35ad9356e9e5ec61$export$6b5f666f729352a.displayName = "MouseLeftClickIcon";
const $35ad9356e9e5ec61$export$e0e176aecccaff7a = $35ad9356e9e5ec61$export$6b5f666f729352a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $515823200a95cddf$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,68v20H160V88a20,20,0,0,0-20-20V36h4A44.05,44.05,0,0,1,188,80ZM120,92h16v40H120Zm-8-56h4V68A20,20,0,0,0,96,88v12H68V80A44.05,44.05,0,0,1,112,36Zm32,184H112a44.05,44.05,0,0,1-44-44V124H96v12a20,20,0,0,0,20,20h24a20,20,0,0,0,20-20V124h28v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,88v48a8,8,0,0,1-8,8H120a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h16A8,8,0,0,1,144,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H152V88a16,16,0,0,0-16-16V32h8A48.05,48.05,0,0,1,192,80Zm-56,56H120V88h16v23.9a.51.51,0,0,0,0,.2ZM112,32h8V72a16,16,0,0,0-16,16v16H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120h40v16a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V120h40v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H152V88a16,16,0,0,0-16-16V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8V72a16,16,0,0,0-16,16v16H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120h40v16a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V120h40v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H150V88a14,14,0,0,0-14-14h-2V30h10A50.06,50.06,0,0,1,194,80Zm-76,8a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v48a2,2,0,0,1-2,2H120a2,2,0,0,1-2-2Zm-6-58h10V74h-2a14,14,0,0,0-14,14v18H62V80A50.06,50.06,0,0,1,112,30Zm32,196H112a50.06,50.06,0,0,1-50-50V118h44v18a14,14,0,0,0,14,14h16a14,14,0,0,0,14-14V118h44v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H152V88a16,16,0,0,0-16-16V32h8A48.05,48.05,0,0,1,192,80Zm-56,56H120V88h16v23.9a.51.51,0,0,0,0,.2ZM112,32h8V72a16,16,0,0,0-16,16v16H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120h40v16a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V120h40v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H148V88a12,12,0,0,0-12-12h-4V28h12A52.06,52.06,0,0,1,196,80Zm-80,8a4,4,0,0,1,4-4h16a4,4,0,0,1,4,4v48a4,4,0,0,1-4,4H120a4,4,0,0,1-4-4Zm-4-60h12V76h-4a12,12,0,0,0-12,12v20H60V80A52.06,52.06,0,0,1,112,28Zm32,200H112a52.06,52.06,0,0,1-52-52V116h48v20a12,12,0,0,0,12,12h16a12,12,0,0,0,12-12V116h48v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $d85af3025ef534f2$export$5963dbb4ba2dab8b = $7fPBF.forwardRef((i, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, i), {
        weights: (0, $515823200a95cddf$export$2e2bcd8739ae039)
    })));
$d85af3025ef534f2$export$5963dbb4ba2dab8b.displayName = "MouseMiddleClickIcon";
const $d85af3025ef534f2$export$b6d8397e1cc3732d = $d85af3025ef534f2$export$5963dbb4ba2dab8b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $ebd2a6ece19ff66d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm42,55a43.63,43.63,0,0,1,2,13v20H153ZM172.51,46.52,140,79V36h4A43.83,43.83,0,0,1,172.51,46.52ZM112,36h4v64H68V80A44.05,44.05,0,0,1,112,36Zm32,184H112a44.05,44.05,0,0,1-44-44V124H188v52A44.05,44.05,0,0,1,144,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,80v32H128V24h16A56,56,0,0,1,200,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,64v24H136V32h8A48.05,48.05,0,0,1,192,80ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16ZM112,32h16v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,62v26H158.49l34.73-34.73A50.17,50.17,0,0,1,194,80Zm-4.9-21.58L141.51,106H134V82.49l41.38-41.38A50.3,50.3,0,0,1,189.1,58.42ZM164.91,34.6,134,65.51V30h10A49.74,49.74,0,0,1,164.91,34.6ZM112,30h10v76H62V80A50.06,50.06,0,0,1,112,30Zm32,196H112a50.06,50.06,0,0,1-50-50V118H194v58A50.06,50.06,0,0,1,144,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm-8,67.31,39.49-39.49A48.49,48.49,0,0,1,186.66,58l-46,46H136Zm55.78-7.78c.14,1.47.22,3,.22,4.47v24H163.31ZM161.41,35.28,136,60.69V32h8A47.73,47.73,0,0,1,161.41,35.28ZM112,32h8v72H64V80A48.05,48.05,0,0,1,112,32Zm32,192H112a48.05,48.05,0,0,1-48-48V120H192v56A48.05,48.05,0,0,1,144,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,60v28H153.66l40.75-40.75A51.55,51.55,0,0,1,196,80Zm-4.51-21.15L142.34,108H132V81.66l43.22-43.22A52.5,52.5,0,0,1,191.49,58.85ZM168.3,34.05,132,70.34V28h12A51.61,51.61,0,0,1,168.3,34.05ZM112,28h12v80H60V80A52.06,52.06,0,0,1,112,28Zm32,200H112a52.06,52.06,0,0,1-52-52V116H196v60A52.06,52.06,0,0,1,144,228Z"
        }))
    ]
]);


const $3f8122a9e58d3677$export$50d995ce278ebfd9 = $7fPBF.forwardRef((t, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: i
    }, t), {
        weights: (0, $ebd2a6ece19ff66d$export$2e2bcd8739ae039)
    })));
$3f8122a9e58d3677$export$50d995ce278ebfd9.displayName = "MouseRightClickIcon";
const $3f8122a9e58d3677$export$c28954299062c2b4 = $3f8122a9e58d3677$export$50d995ce278ebfd9;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cded396d2abdab0e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,12H112A68.07,68.07,0,0,0,44,80v96a68.07,68.07,0,0,0,68,68h32a68.07,68.07,0,0,0,68-68V80A68.07,68.07,0,0,0,144,12Zm44,164a44.05,44.05,0,0,1-44,44H112a44.05,44.05,0,0,1-44-44V80a44.05,44.05,0,0,1,44-44h32a44.05,44.05,0,0,1,44,44ZM140,93V163l3.51-3.52a12,12,0,0,1,17,17l-24,24a12,12,0,0,1-17,0l-24-24a12,12,0,0,1,17-17L116,163V93l-3.51,3.52a12,12,0,0,1-17-17l24-24a12,12,0,0,1,17,0l24,24a12,12,0,0,1-17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,80v96a56,56,0,0,1-56,56H112a56,56,0,0,1-56-56V80a56,56,0,0,1,56-56h32A56,56,0,0,1,200,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,160a48.05,48.05,0,0,1-48,48H112a48.05,48.05,0,0,1-48-48V80a48.05,48.05,0,0,1,48-48h32a48.05,48.05,0,0,1,48,48ZM136,83.31v89.38l10.34-10.35a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm2.34,146.34a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32L136,83.31v89.38Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,18H112A62.07,62.07,0,0,0,50,80v96a62.07,62.07,0,0,0,62,62h32a62.07,62.07,0,0,0,62-62V80A62.07,62.07,0,0,0,144,18Zm50,158a50.06,50.06,0,0,1-50,50H112a50.06,50.06,0,0,1-50-50V80a50.06,50.06,0,0,1,50-50h32a50.06,50.06,0,0,1,50,50ZM134,78.49v99l13.76-13.75a6,6,0,0,1,8.48,8.48l-24,24a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L122,177.51v-99L108.24,92.24a6,6,0,0,1-8.48-8.48l24-24a6,6,0,0,1,8.48,0l24,24a6,6,0,1,1-8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,160a48.05,48.05,0,0,1-48,48H112a48.05,48.05,0,0,1-48-48V80a48.05,48.05,0,0,1,48-48h32a48.05,48.05,0,0,1,48,48ZM136,83.31v89.38l10.34-10.35a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,20H112A60.07,60.07,0,0,0,52,80v96a60.07,60.07,0,0,0,60,60h32a60.07,60.07,0,0,0,60-60V80A60.07,60.07,0,0,0,144,20Zm52,156a52.06,52.06,0,0,1-52,52H112a52.06,52.06,0,0,1-52-52V80a52.06,52.06,0,0,1,52-52h32a52.06,52.06,0,0,1,52,52ZM132,73.66V182.34l17.17-17.17a4,4,0,0,1,5.66,5.66l-24,24a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L124,182.34V73.66L106.83,90.83a4,4,0,0,1-5.66-5.66l24-24a4,4,0,0,1,5.66,0l24,24a4,4,0,0,1-5.66,5.66Z"
        }))
    ]
]);


const $8fa60ad372f26f07$export$f0907b1c06628174 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $cded396d2abdab0e$export$2e2bcd8739ae039)
    })));
$8fa60ad372f26f07$export$f0907b1c06628174.displayName = "MouseScrollIcon";
const $8fa60ad372f26f07$export$569bc5a16e16ae2a = $8fa60ad372f26f07$export$f0907b1c06628174;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $717c67a0383cc585$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,108H140V92h4a20,20,0,0,0,20-20V40a20,20,0,0,0-20-20H112A20,20,0,0,0,92,40V72a20,20,0,0,0,20,20h4v16H24a12,12,0,0,0,0,24H52v24H48a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20H80a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20H76V132H180v24h-4a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20h32a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20h-4V132h28a12,12,0,0,0,0-24ZM116,44h24V68H116ZM76,204H52V180H76Zm128,0H180V180h24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152,40V72a8,8,0,0,1-8,8H112a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h32A8,8,0,0,1,152,40ZM80,168H48a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H80a8,8,0,0,0,8-8V176A8,8,0,0,0,80,168Zm128,0H176a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V176A8,8,0,0,0,208,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,120a8,8,0,0,1-8,8H200v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H176a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h96V88h-8A16,16,0,0,1,96,72V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16h-8v24h96A8,8,0,0,1,240,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,114H134V86h10a14,14,0,0,0,14-14V40a14,14,0,0,0-14-14H112A14,14,0,0,0,98,40V72a14,14,0,0,0,14,14h10v28H24a6,6,0,0,0,0,12H58v36H48a14,14,0,0,0-14,14v32a14,14,0,0,0,14,14H80a14,14,0,0,0,14-14V176a14,14,0,0,0-14-14H70V126H186v36H176a14,14,0,0,0-14,14v32a14,14,0,0,0,14,14h32a14,14,0,0,0,14-14V176a14,14,0,0,0-14-14H198V126h34a6,6,0,0,0,0-12ZM110,72V40a2,2,0,0,1,2-2h32a2,2,0,0,1,2,2V72a2,2,0,0,1-2,2H112A2,2,0,0,1,110,72ZM82,176v32a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V176a2,2,0,0,1,2-2H80A2,2,0,0,1,82,176Zm128,0v32a2,2,0,0,1-2,2H176a2,2,0,0,1-2-2V176a2,2,0,0,1,2-2h32A2,2,0,0,1,210,176Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v32h-8a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm128,0H176V176h32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,116H132V84h12a12,12,0,0,0,12-12V40a12,12,0,0,0-12-12H112a12,12,0,0,0-12,12V72a12,12,0,0,0,12,12h12v32H24a4,4,0,0,0,0,8H60v40H48a12,12,0,0,0-12,12v32a12,12,0,0,0,12,12H80a12,12,0,0,0,12-12V176a12,12,0,0,0-12-12H68V124H188v40H176a12,12,0,0,0-12,12v32a12,12,0,0,0,12,12h32a12,12,0,0,0,12-12V176a12,12,0,0,0-12-12H196V124h36a4,4,0,0,0,0-8ZM108,72V40a4,4,0,0,1,4-4h32a4,4,0,0,1,4,4V72a4,4,0,0,1-4,4H112A4,4,0,0,1,108,72ZM84,176v32a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V176a4,4,0,0,1,4-4H80A4,4,0,0,1,84,176Zm128,0v32a4,4,0,0,1-4,4H176a4,4,0,0,1-4-4V176a4,4,0,0,1,4-4h32A4,4,0,0,1,212,176Z"
        }))
    ]
]);


const $6e819780b9c1274e$export$303836f55ddf2d4b = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $717c67a0383cc585$export$2e2bcd8739ae039)
    })));
$6e819780b9c1274e$export$303836f55ddf2d4b.displayName = "NetworkIcon";
const $6e819780b9c1274e$export$95be4ae94445245a = $6e819780b9c1274e$export$303836f55ddf2d4b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7ad6262ed34ba9ef$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M56.88,31.93A12,12,0,1,0,39.12,48.07L93.6,108H24a12,12,0,0,0,0,24H52v24H48a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20H80a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20H76V132h39.42l83.7,92.07a12,12,0,0,0,17.76-16.14ZM76,204H52V180H76ZM92,42.14V40a20,20,0,0,1,20-20h32a20,20,0,0,1,20,20V72a20,20,0,0,1-20,20h-5.58a12,12,0,1,1,0-24H140V44H115.86A12,12,0,0,1,92,42.14ZM244,120a12,12,0,0,1-12,12H204v6.94a12,12,0,0,1-24,0V132h-5.21a12,12,0,1,1,0-24H232A12,12,0,0,1,244,120Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,176v32a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V176a8,8,0,0,1,8-8H80A8,8,0,0,1,88,176ZM144,32H112a8,8,0,0,0-8,8V72a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V40A8,8,0,0,0,144,32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,54V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16H127.61a8,8,0,0,1,0-16H144V40H112V54a8,8,0,0,1-16,0ZM213.92,210.62a8,8,0,1,1-11.84,10.76L117.19,128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h78.64L42.08,45.38A8,8,0,1,1,53.92,34.62ZM80,176H48v32H80Zm152-64H164a8,8,0,0,0,0,16h20v22.83a8,8,0,1,0,16,0V128h32a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M98.08,59.41A8,8,0,0,1,96,54V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16H127.61a8,8,0,0,1-5.92-2.62ZM53.92,34.62A8,8,0,1,0,42.08,45.38L102.64,112H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128h45.19l84.89,93.38a8,8,0,1,0,11.84-10.76ZM232,112H164a8,8,0,0,0,0,16h20v22.83a8,8,0,1,0,16,0V128h32a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M98,54V40a14,14,0,0,1,14-14h32a14,14,0,0,1,14,14V72a14,14,0,0,1-14,14H127.61a6,6,0,0,1,0-12H144a2,2,0,0,0,2-2V40a2,2,0,0,0-2-2H112a2,2,0,0,0-2,2V54a6,6,0,0,1-12,0ZM212.44,212a6,6,0,0,1-8.88,8.08l-85.49-94H70v36H80a14,14,0,0,1,14,14v32a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V176a14,14,0,0,1,14-14H58V126H24a6,6,0,0,1,0-12h83.16L43.56,44A6,6,0,0,1,52.44,36ZM80,174H48a2,2,0,0,0-2,2v32a2,2,0,0,0,2,2H80a2,2,0,0,0,2-2V176A2,2,0,0,0,80,174Zm152-60H164a6,6,0,0,0,0,12h22v24.83a6,6,0,1,0,12,0V126h34a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,54V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16H127.61a8,8,0,0,1,0-16H144V40H112V54a8,8,0,0,1-16,0ZM213.92,210.62a8,8,0,1,1-11.84,10.76L117.19,128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h78.64L42.08,45.38A8,8,0,1,1,53.92,34.62ZM80,176H48v32H80Zm152-64H164a8,8,0,0,0,0,16h20v22.83a8,8,0,1,0,16,0V128h32a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,54V40a12,12,0,0,1,12-12h32a12,12,0,0,1,12,12V72a12,12,0,0,1-12,12H127.61a4,4,0,0,1,0-8H144a4,4,0,0,0,4-4V40a4,4,0,0,0-4-4H112a4,4,0,0,0-4,4V54a4,4,0,0,1-8,0ZM211,213.31a4,4,0,1,1-5.92,5.38L119,124H68v40H80a12,12,0,0,1,12,12v32a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V176a12,12,0,0,1,12-12H60V124H24a4,4,0,0,1,0-8h87.68L45,42.69A4,4,0,0,1,51,37.31ZM80,172H48a4,4,0,0,0-4,4v32a4,4,0,0,0,4,4H80a4,4,0,0,0,4-4V176A4,4,0,0,0,80,172Zm152-56H164a4,4,0,0,0,0,8h24v26.83a4,4,0,1,0,8,0V124h36a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $f2584623c5b466be$export$40ca6aea9c29b1cf = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $7ad6262ed34ba9ef$export$2e2bcd8739ae039)
    })));
$f2584623c5b466be$export$40ca6aea9c29b1cf.displayName = "NetworkSlashIcon";
const $f2584623c5b466be$export$c26f2f747fc00de7 = $f2584623c5b466be$export$40ca6aea9c29b1cf;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c125d905142f537c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,108H140V92h4a20,20,0,0,0,20-20V40a20,20,0,0,0-20-20H112A20,20,0,0,0,92,40V72a20,20,0,0,0,20,20h4v16H24a12,12,0,0,0,0,24H52v24H48a20,20,0,0,0-20,20v32a20,20,0,0,0,20,20H80a20,20,0,0,0,20-20V176a20,20,0,0,0-20-20H76V132H180v8a12,12,0,0,0,24,0v-8h28a12,12,0,0,0,0-24ZM116,44h24V68H116ZM76,204H52V180H76Zm148.49-27.51L209,192l15.52,15.51a12,12,0,0,1-17,17L192,209l-15.51,15.52a12,12,0,0,1-17-17L175,192l-15.52-15.51a12,12,0,0,1,17-17L192,175l15.51-15.52a12,12,0,0,1,17,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152,40V72a8,8,0,0,1-8,8H112a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h32A8,8,0,0,1,152,40ZM80,168H48a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H80a8,8,0,0,0,8-8V176A8,8,0,0,0,80,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v16a8,8,0,0,0,16,0V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm141.65-34.34L203.31,192l18.35,18.34a8,8,0,0,1-11.32,11.32L192,203.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L180.69,192l-18.35-18.34a8,8,0,0,1,11.32-11.32L192,180.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,120a8,8,0,0,1-8,8H200v16a8,8,0,0,1-16,0V128H72v32h8a16,16,0,0,1,16,16v32a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V176a16,16,0,0,1,16-16h8V128H24a8,8,0,0,1,0-16h96V88h-8A16,16,0,0,1,96,72V40a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V72a16,16,0,0,1-16,16h-8v24h96A8,8,0,0,1,240,120Zm-18.34,42.34a8,8,0,0,0-11.32,0L192,180.69l-18.34-18.35a8,8,0,0,0-11.32,11.32L180.69,192l-18.35,18.34a8,8,0,0,0,11.32,11.32L192,203.31l18.34,18.35a8,8,0,0,0,11.32-11.32L203.31,192l18.35-18.34A8,8,0,0,0,221.66,162.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,114H134V86h10a14,14,0,0,0,14-14V40a14,14,0,0,0-14-14H112A14,14,0,0,0,98,40V72a14,14,0,0,0,14,14h10v28H24a6,6,0,0,0,0,12H58v36H48a14,14,0,0,0-14,14v32a14,14,0,0,0,14,14H80a14,14,0,0,0,14-14V176a14,14,0,0,0-14-14H70V126H186v18a6,6,0,0,0,12,0V126h34a6,6,0,0,0,0-12ZM110,72V40a2,2,0,0,1,2-2h32a2,2,0,0,1,2,2V72a2,2,0,0,1-2,2H112A2,2,0,0,1,110,72ZM82,176v32a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V176a2,2,0,0,1,2-2H80A2,2,0,0,1,82,176Zm138.24-3.76L200.48,192l19.76,19.76a6,6,0,1,1-8.48,8.48L192,200.48l-19.76,19.76a6,6,0,0,1-8.48-8.48L183.52,192l-19.76-19.76a6,6,0,0,1,8.48-8.48L192,183.52l19.76-19.76a6,6,0,0,1,8.48,8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,112H136V88h8a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H112A16,16,0,0,0,96,40V72a16,16,0,0,0,16,16h8v24H24a8,8,0,0,0,0,16H56v32H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16H72V128H184v16a8,8,0,0,0,16,0V128h32a8,8,0,0,0,0-16ZM112,40h32V72H112ZM80,208H48V176H80Zm141.65-34.34L203.31,192l18.35,18.34a8,8,0,0,1-11.32,11.32L192,203.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L180.69,192l-18.35-18.34a8,8,0,0,1,11.32-11.32L192,180.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,116H132V84h12a12,12,0,0,0,12-12V40a12,12,0,0,0-12-12H112a12,12,0,0,0-12,12V72a12,12,0,0,0,12,12h12v32H24a4,4,0,0,0,0,8H60v40H48a12,12,0,0,0-12,12v32a12,12,0,0,0,12,12H80a12,12,0,0,0,12-12V176a12,12,0,0,0-12-12H68V124H188v20a4,4,0,0,0,8,0V124h36a4,4,0,0,0,0-8ZM108,72V40a4,4,0,0,1,4-4h32a4,4,0,0,1,4,4V72a4,4,0,0,1-4,4H112A4,4,0,0,1,108,72ZM84,176v32a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V176a4,4,0,0,1,4-4H80A4,4,0,0,1,84,176Zm134.83-5.17L197.66,192l21.17,21.17a4,4,0,0,1-5.66,5.66L192,197.66l-21.17,21.17a4,4,0,0,1-5.66-5.66L186.34,192l-21.17-21.17a4,4,0,0,1,5.66-5.66L192,186.34l21.17-21.17a4,4,0,0,1,5.66,5.66Z"
        }))
    ]
]);


const $22492976e1d4d968$export$55653f8b5a32ba35 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $c125d905142f537c$export$2e2bcd8739ae039)
    })));
$22492976e1d4d968$export$55653f8b5a32ba35.displayName = "NetworkXIcon";
const $22492976e1d4d968$export$4317df0e74bb0904 = $22492976e1d4d968$export$55653f8b5a32ba35;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7ebbc860b68e7970$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M108,108a12,12,0,0,1,12-12h56a12,12,0,0,1,0,24H120A12,12,0,0,1,108,108Zm68,28H120a12,12,0,0,0,0,24h56a12,12,0,0,0,0-24Zm52-88V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28H208A20,20,0,0,1,228,48ZM52,204H68V52H52ZM204,52H92V204H204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,40V216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,208H48V48H80Zm96-56H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M182,112a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h64A6,6,0,0,1,182,112Zm-6,26H112a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12Zm46-90V208a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V48A14,14,0,0,1,48,34H208A14,14,0,0,1,222,48ZM48,210H74V46H48a2,2,0,0,0-2,2V208A2,2,0,0,0,48,210ZM210,48a2,2,0,0,0-2-2H86V210H208a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,112a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8h64A4,4,0,0,1,180,112Zm-4,28H112a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8Zm44-92V208a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V48A12,12,0,0,1,48,36H208A12,12,0,0,1,220,48ZM48,212H76V44H48a4,4,0,0,0-4,4V208A4,4,0,0,0,48,212ZM212,48a4,4,0,0,0-4-4H84V212H208a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $da973a188202d04f$export$efdad510605bf5b6 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, t), {
        weights: (0, $7ebbc860b68e7970$export$2e2bcd8739ae039)
    })));
$da973a188202d04f$export$efdad510605bf5b6.displayName = "NotebookIcon";
const $da973a188202d04f$export$9d9b3a199c5437eb = $da973a188202d04f$export$efdad510605bf5b6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5106b66d9e325f91$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,55.51l-32-32a12,12,0,0,0-17,0l-96,96A12,12,0,0,0,84,128v32a12,12,0,0,0,12,12h32a12,12,0,0,0,8.49-3.51l96-96A12,12,0,0,0,232.49,55.51ZM192,49l15,15L196,75,181,60Zm-69,99H108V133l56-56,15,15Zm105-7.43V208a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V48A20,20,0,0,1,48,28h67.43a12,12,0,0,1,0,24H52V204H204V140.57a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,88l-72,72H96V128l72-72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Zm5.66-58.34-96,96A8,8,0,0,1,128,168H96a8,8,0,0,1-8-8V128a8,8,0,0,1,2.34-5.66l96-96a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,229.66,69.66Zm-17-5.66L192,43.31,179.31,56,200,76.69Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,59.76l-32-32a6,6,0,0,0-8.48,0l-96,96A6,6,0,0,0,90,128v32a6,6,0,0,0,6,6h32a6,6,0,0,0,4.24-1.76l96-96A6,6,0,0,0,228.24,59.76ZM125.51,154H102V130.49l66-66L191.51,88ZM200,79.51,176.49,56,192,40.49,215.51,64ZM222,128v80a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V48A14,14,0,0,1,48,34h80a6,6,0,0,1,0,12H48a2,2,0,0,0-2,2V208a2,2,0,0,0,2,2H208a2,2,0,0,0,2-2V128a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,61.17l-32-32a4,4,0,0,0-5.66,0l-96,96A4,4,0,0,0,92,128v32a4,4,0,0,0,4,4h32a4,4,0,0,0,2.83-1.17l96-96A4,4,0,0,0,226.83,61.17ZM126.34,156H100V129.66l68-68L194.34,88ZM200,82.34,173.66,56,192,37.66,218.34,64ZM220,128v80a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V48A12,12,0,0,1,48,36h80a4,4,0,0,1,0,8H48a4,4,0,0,0-4,4V208a4,4,0,0,0,4,4H208a4,4,0,0,0,4-4V128a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $69972f0aea86b6a2$export$d07ff5a8e7869743 = $7fPBF.forwardRef((t, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, t), {
        weights: (0, $5106b66d9e325f91$export$2e2bcd8739ae039)
    })));
$69972f0aea86b6a2$export$d07ff5a8e7869743.displayName = "NotePencilIcon";
const $69972f0aea86b6a2$export$2fc869517b304253 = $69972f0aea86b6a2$export$d07ff5a8e7869743;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f27dcf753f4fdcae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76,128a52,52,0,1,0,52-52A52.05,52.05,0,0,0,76,128Zm80,0a28,28,0,1,1-28-28A28,28,0,0,1,156,128Zm69.6-65.36-88-48.17a19.91,19.91,0,0,0-19.2,0l-88,48.17A20,20,0,0,0,20,80.19v95.62a20,20,0,0,0,10.4,17.55l88,48.17a19.89,19.89,0,0,0,19.2,0l88-48.17h0A20,20,0,0,0,236,175.81V80.19A20,20,0,0,0,225.6,62.64ZM212,173.44l-84,46-84-46V82.56l84-46,84,46Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.84,73.16,131.84,25a8,8,0,0,0-7.68,0l-88,48.18a8,8,0,0,0-4.16,7v95.64a8,8,0,0,0,4.16,7l88,48.18a8,8,0,0,0,7.68,0l88-48.18a8,8,0,0,0,4.16-7V80.18A8,8,0,0,0,219.84,73.16ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.06,48.06,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm95.68-93.85L135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17h0a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,224,40,175.82V80.18L128,32l88,48.17v95.63Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Zm94.72-94.09-88-48.18a13.9,13.9,0,0,0-13.44,0l-88,48.18A14,14,0,0,0,26,80.18v95.64a14,14,0,0,0,7.28,12.27l88,48.18a13.92,13.92,0,0,0,13.44,0l88-48.18A14,14,0,0,0,230,175.82V80.18A14,14,0,0,0,222.72,67.91ZM218,175.82a2,2,0,0,1-1,1.75l-88,48.18a2,2,0,0,1-1.92,0L39,177.57a2,2,0,0,1-1-1.75V80.18a2,2,0,0,1,1-1.75l88-48.18a2,2,0,0,1,1.92,0l88,48.18a2,2,0,0,1,1,1.75Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,80a48,48,0,1,0,48,48A48.06,48.06,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm95.68-93.85L135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17h0a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,224,40,175.82V80.18L128,32l88,48.17v95.64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Zm93.76-94.34-88-48.18a12,12,0,0,0-11.52,0l-88,48.18A12,12,0,0,0,28,80.18v95.64a12,12,0,0,0,6.24,10.52l88,48.18a11.95,11.95,0,0,0,11.52,0l88-48.18h0A12,12,0,0,0,228,175.82V80.18A12,12,0,0,0,221.76,69.66ZM220,175.82a4,4,0,0,1-2.08,3.5l-88,48.18a4,4,0,0,1-3.84,0l-88-48.17A4,4,0,0,1,36,175.82V80.18a4,4,0,0,1,2.08-3.5l88-48.18a3.94,3.94,0,0,1,3.84,0l88,48.18a4,4,0,0,1,2.08,3.5Z"
        }))
    ]
]);


const $25483bd4b980c997$export$49b63808e7fc4751 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $f27dcf753f4fdcae$export$2e2bcd8739ae039)
    })));
$25483bd4b980c997$export$49b63808e7fc4751.displayName = "NutIcon";
const $25483bd4b980c997$export$d3159630907da707 = $25483bd4b980c997$export$49b63808e7fc4751;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $51f23cd55de05d2f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.88,113.61A60,60,0,0,0,166,33.42,60,60,0,0,0,65.1,47.83a60,60,0,0,0-38,94.56A60.08,60.08,0,0,0,83.6,223a57.83,57.83,0,0,0,6.45-.36A60,60,0,0,0,190.9,208.17a60,60,0,0,0,38-94.56ZM181.81,58.3a36,36,0,0,1,26.58,37.6L170,73.73a12,12,0,0,0-12,0L120,95.67V81.81L154.5,61.9A35.74,35.74,0,0,1,181.81,58.3ZM136,123.38v9.24l-8,4.62-8-4.62v-9.24l8-4.62ZM84,72a36,36,0,0,1,56.39-29.67L102,64.49a12,12,0,0,0-6,10.39v43.88l-12-6.93ZM44.33,88.93A35.81,35.81,0,0,1,60,74.43v44.33a12,12,0,0,0,6,10.4l38,21.93L92,158,57.5,138.1A36,36,0,0,1,44.33,88.93ZM74.19,197.7a36,36,0,0,1-26.58-37.6L86,182.27a12,12,0,0,0,12,0l38-21.94v13.86L101.5,194.1A35.74,35.74,0,0,1,74.19,197.7ZM172,184a36,36,0,0,1-56.39,29.67L154,191.51a12,12,0,0,0,6-10.39V137.24l12,6.93Zm39.67-16.93A35.81,35.81,0,0,1,196,181.57V137.24a12,12,0,0,0-6-10.4l-38-21.93L164,98l34.5,19.92A36,36,0,0,1,211.67,167.07Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96,174.19l56-32.33v36.95L107.5,204.5a48,48,0,0,1-66.4-64.08h0A48,48,0,0,0,51.5,148.5ZM204.5,107.5,160,81.81l-32,18.48,56,32.33V184a48,48,0,0,1-1.81,13h0A48,48,0,0,0,204.5,107.5ZM104,77.19,148.5,51.5a47.77,47.77,0,0,1,12.19-5v0A48,48,0,0,0,72,72v51.38l32,18.48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32ZM182.85,54.43a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43ZM144,137.24l-16,9.24-16-9.24V118.76l16-9.24,16,9.24ZM80,72a40,40,0,0,1,67.53-29c-1,.51-2,1-3,1.62L100,70.27a8,8,0,0,0-4,6.92V128l-16-9.24ZM40.86,86.93A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM73.15,201.57a40,40,0,0,1-28.56-48c.95.63,1.91,1.24,2.91,1.81L92,181.12a8,8,0,0,0,8,0l44-25.41v18.48l-40.5,23.38A39.76,39.76,0,0,1,73.15,201.57ZM176,184a40,40,0,0,1-67.52,29.05c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24Zm39.14-14.93a39.75,39.75,0,0,1-23.26,18.36c.07-1.14.12-2.28.12-3.43V132.62a8,8,0,0,0-4-6.93l-44-25.4,16-9.24,40.5,23.38A40,40,0,0,1,215.14,169.07Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32Zm-80.32,23-16,9.24-16-9.24V118.76l16-9.24,16,9.24Zm38.85-82.81a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43Zm-142,32.5A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM136,224a39.79,39.79,0,0,1-27.52-10.95c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24V184A40,40,0,0,1,136,224Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,114.56a54,54,0,0,0-58.67-74.73,54,54,0,0,0-94,13.46A54,54,0,0,0,34,141.44a54,54,0,0,0,35.56,73.65A54.54,54.54,0,0,0,83.59,217a52.86,52.86,0,0,0,9.06-.78,54,54,0,0,0,94-13.46A54,54,0,0,0,222,114.56ZM183.37,52.5a42,42,0,0,1,29.21,53.14,54.84,54.84,0,0,0-5.08-3.33L163,76.62a6,6,0,0,0-6,0l-47,27.13V80.66l41.5-24A41.73,41.73,0,0,1,183.37,52.5ZM146,138.39l-18,10.39-18-10.39V117.61l18-10.39,18,10.39ZM78,72a42,42,0,0,1,72.92-28.43,56.18,56.18,0,0,0-5.42,2.74L101,72a6,6,0,0,0-3,5.19v54.27L78,119.92ZM39.13,85.93a41.75,41.75,0,0,1,27.22-20A55.09,55.09,0,0,0,66,72v51.38a6,6,0,0,0,3,5.2l47,27.13L96,167.26l-41.5-24A42,42,0,0,1,39.13,85.93ZM72.63,203.5a42,42,0,0,1-29.21-53.14,54.84,54.84,0,0,0,5.08,3.33L93,179.38a6,6,0,0,0,6,0l47-27.13v23.09l-41.5,24A41.73,41.73,0,0,1,72.63,203.5ZM178,184a42,42,0,0,1-72.92,28.43,56.18,56.18,0,0,0,5.42-2.74L155,184a6,6,0,0,0,3-5.19V124.54l20,11.54Zm38.87-13.93a41.75,41.75,0,0,1-27.22,20A55.09,55.09,0,0,0,190,184V132.62a6,6,0,0,0-3-5.2l-47-27.13,20-11.55,41.5,24A42,42,0,0,1,216.87,170.07Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32ZM182.85,54.43a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43ZM144,137.24l-16,9.24-16-9.24V118.76l16-9.24,16,9.24ZM80,72a40,40,0,0,1,67.53-29c-1,.51-2,1-3,1.62L100,70.27a8,8,0,0,0-4,6.92V128l-16-9.24ZM40.86,86.93A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM73.15,201.57a40,40,0,0,1-28.56-48c.95.63,1.91,1.24,2.91,1.81L92,181.12a8,8,0,0,0,8,0l44-25.41v18.48l-40.5,23.38A39.76,39.76,0,0,1,73.15,201.57ZM176,184a40,40,0,0,1-67.52,29.05c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24Zm39.14-14.93a39.75,39.75,0,0,1-23.26,18.36c.07-1.14.12-2.28.12-3.43V132.62a8,8,0,0,0-4-6.93l-44-25.4,16-9.24,40.5,23.38A40,40,0,0,1,215.14,169.07Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.68,114.91A52,52,0,0,0,162.49,42,52,52,0,0,0,70.82,55.15a52,52,0,0,0-34.5,85.94A52,52,0,0,0,70,213.16,52.33,52.33,0,0,0,83.59,215a51.66,51.66,0,0,0,9.93-1,52,52,0,0,0,91.66-13.13,52,52,0,0,0,34.5-85.94Zm-35.8-64.34a44,44,0,0,1,29.66,58.36,51.84,51.84,0,0,0-7-4.89L162,78.35a4,4,0,0,0-4,0l-50,28.87V79.5L150.5,55A43.69,43.69,0,0,1,183.88,50.57Zm-35.88,89-20,11.54-20-11.54v-23.1l20-11.54,20,11.54ZM76,72a44,44,0,0,1,78.25-27.62A52.08,52.08,0,0,0,146.5,48L102,73.73a4,4,0,0,0-2,3.46v57.74L76,121.07ZM37.4,84.93A43.72,43.72,0,0,1,68.71,63.46,52.26,52.26,0,0,0,68,72v51.38a4,4,0,0,0,2,3.46l50,28.87L96,169.57,53.5,145A44,44,0,0,1,37.4,84.93Zm34.72,120.5a44,44,0,0,1-29.66-58.36,51.84,51.84,0,0,0,7,4.89L94,177.65a4,4,0,0,0,4,0l50-28.87V176.5L105.5,201A43.69,43.69,0,0,1,72.12,205.43ZM180,184a44,44,0,0,1-78.26,27.61A51.66,51.66,0,0,0,109.5,208L154,182.27a4,4,0,0,0,2-3.46V121.07l24,13.86Zm38.6-12.93a43.72,43.72,0,0,1-31.31,21.47A52.26,52.26,0,0,0,188,184V132.62a4,4,0,0,0-2-3.46l-50-28.87,24-13.86L202.5,111A44,44,0,0,1,218.6,171.07Z"
        }))
    ]
]);


const $58461f01577d65e9$export$526f06eba48e24ab = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $51f23cd55de05d2f$export$2e2bcd8739ae039)
    })));
$58461f01577d65e9$export$526f06eba48e24ab.displayName = "OpenAiLogoIcon";
const $58461f01577d65e9$export$9a82f9e7e505c6ca = $58461f01577d65e9$export$526f06eba48e24ab;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0b315445029b3b3c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M203.57,51A107.9,107.9,0,0,0,20,128c0,44.72,27.6,82.25,72,97.94A36,36,0,0,0,140,192a12,12,0,0,1,12-12h46.21a35.79,35.79,0,0,0,35.1-28A108.6,108.6,0,0,0,236,127.09,107.23,107.23,0,0,0,203.57,51Zm6.34,95.67a11.91,11.91,0,0,1-11.7,9.3H152a36,36,0,0,0-36,36,12,12,0,0,1-16,11.3c-16.65-5.88-30.65-15.76-40.48-28.56A76,76,0,0,1,44,128a84,84,0,0,1,83.13-84H128a84.35,84.35,0,0,1,84,83.29A84.72,84.72,0,0,1,209.91,146.71ZM144,76a16,16,0,1,1-16-16A16,16,0,0,1,144,76Zm-44,24A16,16,0,1,1,84,84,16,16,0,0,1,100,100Zm0,56a16,16,0,1,1-16-16A16,16,0,0,1,100,156Zm88-56a16,16,0,1,1-16-16A16,16,0,0,1,188,100Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,127.17a96.48,96.48,0,0,1-2.39,22.18A24,24,0,0,1,198.21,168H152a24,24,0,0,0-24,24,24,24,0,0,1-32,22.61C58.73,201.44,32,169.81,32,128a96,96,0,0,1,95-96C179.84,31.47,223.55,74.35,224,127.17Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89Zm13,93.71A15.89,15.89,0,0,1,198.21,160H152a32,32,0,0,0-32,32,16,16,0,0,1-21.31,15.07C62.49,194.3,40,164,40,128a88,88,0,0,1,87.09-88h.9a88.35,88.35,0,0,1,88,87.25A88.86,88.86,0,0,1,213.81,147.6ZM140,76a12,12,0,1,1-12-12A12,12,0,0,1,140,76ZM96,100A12,12,0,1,1,84,88,12,12,0,0,1,96,100Zm0,56a12,12,0,1,1-12-12A12,12,0,0,1,96,156Zm88-56a12,12,0,1,1-12-12A12,12,0,0,1,184,100Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89ZM84,168a12,12,0,1,1,12-12A12,12,0,0,1,84,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,84,112Zm44-24a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm44,24a12,12,0,1,1,12-12A12,12,0,0,1,172,112Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M199.37,55.31A101.32,101.32,0,0,0,128,26h-1A102,102,0,0,0,26,128c0,42.09,26.07,77.44,68,92.26A30.21,30.21,0,0,0,104.11,222,30.06,30.06,0,0,0,134,192a18,18,0,0,1,18-18h46.21a29.82,29.82,0,0,0,29.25-23.31A102.71,102.71,0,0,0,230,127.11,101.25,101.25,0,0,0,199.37,55.31ZM215.76,148a17.89,17.89,0,0,1-17.55,14H152a30,30,0,0,0-30,30,18,18,0,0,1-24,17C61,195.86,38,164.85,38,128a90,90,0,0,1,89.07-90H128a90.34,90.34,0,0,1,90,89.22A90.46,90.46,0,0,1,215.76,148ZM138,76a10,10,0,1,1-10-10A10,10,0,0,1,138,76ZM94,100A10,10,0,1,1,84,90,10,10,0,0,1,94,100Zm0,56a10,10,0,1,1-10-10A10,10,0,0,1,94,156Zm88-56a10,10,0,1,1-10-10A10,10,0,0,1,182,100Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200.77,53.89A103.27,103.27,0,0,0,128,24h-1.07A104,104,0,0,0,24,128c0,43,26.58,79.06,69.36,94.17A32,32,0,0,0,136,192a16,16,0,0,1,16-16h46.21a31.81,31.81,0,0,0,31.2-24.88,104.43,104.43,0,0,0,2.59-24A103.28,103.28,0,0,0,200.77,53.89Zm13,93.71A15.89,15.89,0,0,1,198.21,160H152a32,32,0,0,0-32,32,16,16,0,0,1-21.31,15.07C62.49,194.3,40,164,40,128a88,88,0,0,1,87.09-88h.9a88.35,88.35,0,0,1,88,87.25A88.86,88.86,0,0,1,213.81,147.6ZM140,76a12,12,0,1,1-12-12A12,12,0,0,1,140,76ZM96,100A12,12,0,1,1,84,88,12,12,0,0,1,96,100Zm0,56a12,12,0,1,1-12-12A12,12,0,0,1,96,156Zm88-56a12,12,0,1,1-12-12A12,12,0,0,1,184,100Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M198,56.74A99.31,99.31,0,0,0,128,28h-1A100,100,0,0,0,28,128c0,41.22,25.55,75.85,66.69,90.38a28.34,28.34,0,0,0,9.42,1.63A28,28,0,0,0,132,192a20,20,0,0,1,20-20h46.21a27.84,27.84,0,0,0,27.3-21.76,100.37,100.37,0,0,0,2.49-23.1A99.26,99.26,0,0,0,198,56.74Zm19.74,91.72A19.89,19.89,0,0,1,198.21,164H152a28,28,0,0,0-28,28,20,20,0,0,1-26.64,18.83C59.51,197.46,36,165.72,36,128a92,92,0,0,1,91.05-92H128a92,92,0,0,1,89.72,112.46ZM136,76a8,8,0,1,1-8-8A8,8,0,0,1,136,76ZM92,100a8,8,0,1,1-8-8A8,8,0,0,1,92,100Zm0,56a8,8,0,1,1-8-8A8,8,0,0,1,92,156Zm88-56a8,8,0,1,1-8-8A8,8,0,0,1,180,100Z"
        }))
    ]
]);


const $2a77e4a11253c5e2$export$c142a38f581c8178 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, o), {
        weights: (0, $0b315445029b3b3c$export$2e2bcd8739ae039)
    })));
$2a77e4a11253c5e2$export$c142a38f581c8178.displayName = "PaletteIcon";
const $2a77e4a11253c5e2$export$e2fbaa661ec19dbf = $2a77e4a11253c5e2$export$c142a38f581c8178;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $2086e41f7cf61ce8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M233.86,110.48,65.8,14.58A20,20,0,0,0,37.15,38.64L67.33,128,37.15,217.36A20,20,0,0,0,56,244a20.1,20.1,0,0,0,9.81-2.58l.09-.06,168-96.07a20,20,0,0,0,0-34.81ZM63.19,215.26,88.61,140H144a12,12,0,0,0,0-24H88.61L63.18,40.72l152.76,87.17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.91,134.86,59.93,231a8,8,0,0,1-11.44-9.67L80,128,48.49,34.72a8,8,0,0,1,11.44-9.67l168,95.85A8,8,0,0,1,227.91,134.86Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.87,114l-168-95.89A16,16,0,0,0,40.92,37.34L71.55,128,40.92,218.67A16,16,0,0,0,56,240a16.15,16.15,0,0,0,7.93-2.1l167.92-96.05a16,16,0,0,0,.05-27.89ZM56,224a.56.56,0,0,0,0-.12L85.74,136H144a8,8,0,0,0,0-16H85.74L56.06,32.16A.46.46,0,0,0,56,32l168,95.83Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,127.89a16,16,0,0,1-8.18,14L63.9,237.9A16.15,16.15,0,0,1,56,240a16,16,0,0,1-15-21.33l27-79.95A4,4,0,0,1,71.72,136H144a8,8,0,0,0,8-8.53,8.19,8.19,0,0,0-8.26-7.47h-72a4,4,0,0,1-3.79-2.72l-27-79.94A16,16,0,0,1,63.84,18.07l168,95.89A16,16,0,0,1,240,127.89Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.88,115.69l-168-95.88a14,14,0,0,0-20,16.87L73.66,128,42.81,219.33A14,14,0,0,0,56,238a14.15,14.15,0,0,0,6.93-1.83L230.84,140.1a14,14,0,0,0,0-24.41Zm-5.95,14L57,225.73a2,2,0,0,1-2.86-2.42.42.42,0,0,0,0-.1L84.3,134H144a6,6,0,0,0,0-12H84.3L54.17,32.8a.3.3,0,0,0,0-.1,1.87,1.87,0,0,1,.6-2.2A1.85,1.85,0,0,1,57,30.25l168,95.89a1.93,1.93,0,0,1,1,1.74A2,2,0,0,1,224.93,129.66Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.87,114l-168-95.89A16,16,0,0,0,40.92,37.34L71.55,128,40.92,218.67A16,16,0,0,0,56,240a16.15,16.15,0,0,0,7.93-2.1l167.92-96.05a16,16,0,0,0,.05-27.89ZM56,224a.56.56,0,0,0,0-.12L85.74,136H144a8,8,0,0,0,0-16H85.74L56.06,32.16A.46.46,0,0,0,56,32l168,95.83Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.89,117.43l-168-95.88A12,12,0,0,0,44.7,36l31.08,92L44.71,220A12,12,0,0,0,56,236a12.13,12.13,0,0,0,5.93-1.57l167.94-96.08a12,12,0,0,0,0-20.92Zm-4,14L58,227.47a4,4,0,0,1-5.72-4.83l0-.07L82.87,132H144a4,4,0,0,0,0-8H82.87L52.26,33.37A3.89,3.89,0,0,1,53.44,29,4.13,4.13,0,0,1,56,28a3.88,3.88,0,0,1,1.93.54l168,95.87a4,4,0,0,1,0,7Z"
        }))
    ]
]);


const $a5b6c5e30bc6121e$export$6d66b94e76150c22 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $2086e41f7cf61ce8$export$2e2bcd8739ae039)
    })));
$a5b6c5e30bc6121e$export$6d66b94e76150c22.displayName = "PaperPlaneRightIcon";
const $a5b6c5e30bc6121e$export$1dc00410424012fd = $a5b6c5e30bc6121e$export$6d66b94e76150c22;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cd78364deaeaa2fc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.14,25.86a20,20,0,0,0-19.57-5.11l-.22.07L18.44,79a20,20,0,0,0-3.06,37.25L99,157l40.71,83.65a19.81,19.81,0,0,0,18,11.38c.57,0,1.15,0,1.73-.07A19.82,19.82,0,0,0,177,237.56L235.18,45.65a1.42,1.42,0,0,0,.07-.22A20,20,0,0,0,230.14,25.86ZM156.91,221.07l-34.37-70.64,46-45.95a12,12,0,0,0-17-17l-46,46L34.93,99.09,210,46Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.69,42.18l-58.22,192a8,8,0,0,1-14.92,1.25L108,148,20.58,105.45a8,8,0,0,1,1.25-14.92l192-58.22A8,8,0,0,1,223.69,42.18Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.32,28.68a16,16,0,0,0-15.66-4.08l-.15,0L19.57,82.84a16,16,0,0,0-2.49,29.8L102,154l41.3,84.87A15.86,15.86,0,0,0,157.74,248q.69,0,1.38-.06a15.88,15.88,0,0,0,14-11.51l58.2-191.94c0-.05,0-.1,0-.15A16,16,0,0,0,227.32,28.68ZM157.83,231.85l-.05.14,0-.07-40.06-82.3,48-48a8,8,0,0,0-11.31-11.31l-48,48L24.08,98.25l-.07,0,.14,0L216,40Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.4,44.34s0,.1,0,.15l-58.2,191.94a15.88,15.88,0,0,1-14,11.51q-.69.06-1.38.06a15.86,15.86,0,0,1-14.42-9.15L107,164.15a4,4,0,0,1,.77-4.58l57.92-57.92a8,8,0,0,0-11.31-11.31L96.43,148.26a4,4,0,0,1-4.58.77L17.08,112.64a16,16,0,0,1,2.49-29.8l191.94-58.2.15,0A16,16,0,0,1,231.4,44.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.88,30.12a13.83,13.83,0,0,0-13.7-3.58l-.11,0L20.14,84.77A14,14,0,0,0,18,110.85l85.56,41.64L145.12,238a13.87,13.87,0,0,0,12.61,8c.4,0,.81,0,1.21-.05a13.9,13.9,0,0,0,12.29-10.09l58.2-191.93,0-.11A13.83,13.83,0,0,0,225.88,30.12Zm-8,10.4L159.73,232.43l0,.11a2,2,0,0,1-3.76.26l-40.68-83.58,49-49a6,6,0,1,0-8.49-8.49l-49,49L23.15,100a2,2,0,0,1,.31-3.74l.11,0L215.48,38.08a1.94,1.94,0,0,1,1.92.52A2,2,0,0,1,217.92,40.52Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.32,28.68a16,16,0,0,0-15.66-4.08l-.15,0L19.57,82.84a16,16,0,0,0-2.49,29.8L102,154l41.3,84.87A15.86,15.86,0,0,0,157.74,248q.69,0,1.38-.06a15.88,15.88,0,0,0,14-11.51l58.2-191.94c0-.05,0-.1,0-.15A16,16,0,0,0,227.32,28.68ZM157.83,231.85l-.05.14,0-.07-40.06-82.3,48-48a8,8,0,0,0-11.31-11.31l-48,48L24.08,98.25l-.07,0,.14,0L216,40Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.47,31.52a11.87,11.87,0,0,0-11.82-3L20.74,86.67a12,12,0,0,0-1.91,22.38L105,151l41.92,86.15A11.88,11.88,0,0,0,157.74,244c.34,0,.69,0,1,0a11.89,11.89,0,0,0,10.52-8.63l58.21-192,0-.08A11.85,11.85,0,0,0,224.47,31.52Zm-4.62,9.54-58.23,192a4,4,0,0,1-7.48.59l-41.3-84.86,50-50a4,4,0,1,0-5.66-5.66l-50,50-84.9-41.31a3.88,3.88,0,0,1-2.27-4,3.93,3.93,0,0,1,3-3.54L214.9,36.16A3.93,3.93,0,0,1,216,36a4,4,0,0,1,2.79,1.19A3.93,3.93,0,0,1,219.85,41.06Z"
        }))
    ]
]);


const $e100296a4b3103b5$export$2b1f3042fe58a494 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $cd78364deaeaa2fc$export$2e2bcd8739ae039)
    })));
$e100296a4b3103b5$export$2b1f3042fe58a494.displayName = "PaperPlaneTiltIcon";
const $e100296a4b3103b5$export$53fed2f463499b53 = $e100296a4b3103b5$export$2b1f3042fe58a494;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b88211d875b75024$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,164a36.07,36.07,0,0,0-33.94,24H72a28,28,0,0,1,0-56h96a44,44,0,0,0,0-88H72a12,12,0,0,0,0,24h96a20,20,0,0,1,0,40H72a52,52,0,0,0,0,104h94.06A36,36,0,1,0,200,164Zm0,48a12,12,0,1,1,12-12A12,12,0,0,1,200,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,200a24,24,0,1,1-24-24A24,24,0,0,1,224,200Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,168a32.06,32.06,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,200,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,200a28,28,0,0,1-54.83,8H72a48,48,0,0,1,0-96h96a24,24,0,0,0,0-48H72a8,8,0,0,1,0-16h96a40,40,0,0,1,0,80H72a32,32,0,0,0,0,64H173.17A28,28,0,0,1,228,200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,170a30.05,30.05,0,0,0-29.4,24H72a34,34,0,0,1,0-68h96a38,38,0,0,0,0-76H72a6,6,0,0,0,0,12h96a26,26,0,0,1,0,52H72a46,46,0,0,0,0,92h98.6A30,30,0,1,0,200,170Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,200,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,168a32.06,32.06,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,200,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,172a28,28,0,0,0-27.71,24H72a36,36,0,0,1,0-72h96a36,36,0,0,0,0-72H72a4,4,0,0,0,0,8h96a28,28,0,0,1,0,56H72a44,44,0,0,0,0,88H172.29A28,28,0,1,0,200,172Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,200,220Z"
        }))
    ]
]);


const $45c37c8e5c384c5e$export$c6d97cdd83a3ef7a = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, a), {
        weights: (0, $b88211d875b75024$export$2e2bcd8739ae039)
    })));
$45c37c8e5c384c5e$export$c6d97cdd83a3ef7a.displayName = "PathIcon";
const $45c37c8e5c384c5e$export$4b2950bdac9b6ee9 = $45c37c8e5c384c5e$export$c6d97cdd83a3ef7a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $82241e5135dfa7e2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212ZM116,96v64a12,12,0,0,1-24,0V96a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V96a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM112,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218ZM110,96v64a6,6,0,0,1-12,0V96a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V96a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM112,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220ZM108,96v64a4,4,0,0,1-8,0V96a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V96a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $67a070e95907d9d1$export$75886cde6273c22e = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $82241e5135dfa7e2$export$2e2bcd8739ae039)
    })));
$67a070e95907d9d1$export$75886cde6273c22e.displayName = "PauseCircleIcon";
const $67a070e95907d9d1$export$b5279a29eac7a382 = $67a070e95907d9d1$export$75886cde6273c22e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d783a5f5e3b289b6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,28H160a20,20,0,0,0-20,20V208a20,20,0,0,0,20,20h40a20,20,0,0,0,20-20V48A20,20,0,0,0,200,28Zm-4,176H164V52h32ZM96,28H56A20,20,0,0,0,36,48V208a20,20,0,0,0,20,20H96a20,20,0,0,0,20-20V48A20,20,0,0,0,96,28ZM92,204H60V52H92Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,48V208a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h40A8,8,0,0,1,208,48ZM96,40H56a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H96a8,8,0,0,0,8-8V48A8,8,0,0,0,96,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H160a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,176H160V48h40ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Zm0,176H56V48H96Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V208a16,16,0,0,1-16,16H160a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h40A16,16,0,0,1,216,48ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,34H160a14,14,0,0,0-14,14V208a14,14,0,0,0,14,14h40a14,14,0,0,0,14-14V48A14,14,0,0,0,200,34Zm2,174a2,2,0,0,1-2,2H160a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2ZM96,34H56A14,14,0,0,0,42,48V208a14,14,0,0,0,14,14H96a14,14,0,0,0,14-14V48A14,14,0,0,0,96,34Zm2,174a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H96a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,32H160a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,176H160V48h40ZM96,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V48A16,16,0,0,0,96,32Zm0,176H56V48H96Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,36H160a12,12,0,0,0-12,12V208a12,12,0,0,0,12,12h40a12,12,0,0,0,12-12V48A12,12,0,0,0,200,36Zm4,172a4,4,0,0,1-4,4H160a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4ZM96,36H56A12,12,0,0,0,44,48V208a12,12,0,0,0,12,12H96a12,12,0,0,0,12-12V48A12,12,0,0,0,96,36Zm4,172a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H96a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $282419a8b70eaf27$export$9b47433640e5db3a = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, a), {
        weights: (0, $d783a5f5e3b289b6$export$2e2bcd8739ae039)
    })));
$282419a8b70eaf27$export$9b47433640e5db3a.displayName = "PauseIcon";
const $282419a8b70eaf27$export$59704c468e1a1527 = $282419a8b70eaf27$export$9b47433640e5db3a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $75f0d0c7c3c88455$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.14,70.54,185.46,25.85a20,20,0,0,0-28.29,0L33.86,149.17A19.85,19.85,0,0,0,28,163.31V208a20,20,0,0,0,20,20H92.69a19.86,19.86,0,0,0,14.14-5.86L230.14,98.82a20,20,0,0,0,0-28.28ZM91,204H52V165l84-84,39,39ZM192,103,153,64l18.34-18.34,39,39Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.66,90.34,192,120,136,64l29.66-29.66a8,8,0,0,1,11.31,0L221.66,79A8,8,0,0,1,221.66,90.34Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM192,108.68,147.31,64l24-24L216,84.68Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M225.9,74.78,181.21,30.09a14,14,0,0,0-19.8,0L38.1,153.41a13.94,13.94,0,0,0-4.1,9.9V208a14,14,0,0,0,14,14H92.69a13.94,13.94,0,0,0,9.9-4.1L225.9,94.58a14,14,0,0,0,0-19.8ZM94.1,209.41a2,2,0,0,1-1.41.59H48a2,2,0,0,1-2-2V163.31a2,2,0,0,1,.59-1.41L136,72.48,183.51,120ZM217.41,86.1,192,111.51,144.49,64,169.9,38.58a2,2,0,0,1,2.83,0l44.68,44.69a2,2,0,0,1,0,2.83Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.49,76.2,179.8,31.51a12,12,0,0,0-17,0L133.17,61.17h0L39.52,154.83A11.9,11.9,0,0,0,36,163.31V208a12,12,0,0,0,12,12H92.69a12,12,0,0,0,8.48-3.51L224.48,93.17a12,12,0,0,0,0-17Zm-129,134.63A4,4,0,0,1,92.69,212H48a4,4,0,0,1-4-4V163.31a4,4,0,0,1,1.17-2.83L136,69.65,186.34,120ZM218.83,87.51,192,114.34,141.66,64l26.82-26.83a4,4,0,0,1,5.66,0l44.69,44.68a4,4,0,0,1,0,5.66Z"
        }))
    ]
]);


const $9bcf07f234bdd453$export$97ae7c994680a9ed = $7fPBF.forwardRef((i, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: m
    }, i), {
        weights: (0, $75f0d0c7c3c88455$export$2e2bcd8739ae039)
    })));
$9bcf07f234bdd453$export$97ae7c994680a9ed.displayName = "PencilSimpleIcon";
const $9bcf07f234bdd453$export$489de2fc36740036 = $9bcf07f234bdd453$export$97ae7c994680a9ed;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $19cf1837247d50a6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,154.8l-47.09-21.11-.18-.08a19.94,19.94,0,0,0-19,1.75,13.08,13.08,0,0,0-1.12.84l-22.31,19c-13-7.05-26.43-20.37-33.49-33.21l19.06-22.66a11.76,11.76,0,0,0,.85-1.15,20,20,0,0,0,1.66-18.83,1.42,1.42,0,0,1-.08-.18L101.2,32A20.06,20.06,0,0,0,80.42,20.15,60.27,60.27,0,0,0,28,80c0,81.61,66.39,148,148,148a60.27,60.27,0,0,0,59.85-52.42A20.06,20.06,0,0,0,224,154.8ZM176,204A124.15,124.15,0,0,1,52,80,36.29,36.29,0,0,1,80.48,44.46l18.82,42L80.14,109.28a12,12,0,0,0-.86,1.16A20,20,0,0,0,78,130.08c9.42,19.28,28.83,38.56,48.31,48A20,20,0,0,0,146,176.63a11.63,11.63,0,0,0,1.11-.85l22.43-19.07,42,18.81A36.29,36.29,0,0,1,176,204Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.94,174.08A48.33,48.33,0,0,1,176,216,136,136,0,0,1,40,80,48.33,48.33,0,0,1,81.92,32.06a8,8,0,0,1,8.3,4.8l21.13,47.2a8,8,0,0,1-.66,7.53L89.32,117a7.93,7.93,0,0,0-.54,7.81c8.27,16.93,25.77,34.22,42.75,42.41a7.92,7.92,0,0,0,7.83-.59l25-21.3a8,8,0,0,1,7.59-.69l47.16,21.13A8,8,0,0,1,223.94,174.08Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.88,175.08A56.26,56.26,0,0,1,176,224C96.6,224,32,159.4,32,80A56.26,56.26,0,0,1,80.92,24.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,117.39,96c-.18.27-.37.52-.57.77L96,121.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,231.88,175.08Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.59,160.3l-47.24-21.17a14,14,0,0,0-13.28,1.22,4.81,4.81,0,0,0-.56.42l-24.69,21a1.88,1.88,0,0,1-1.68.06c-15.87-7.66-32.31-24-40-39.65a1.91,1.91,0,0,1,0-1.68l21.07-25a6.13,6.13,0,0,0,.42-.58,14,14,0,0,0,1.12-13.27L95.73,34.49a14,14,0,0,0-14.56-8.38A54.24,54.24,0,0,0,34,80c0,78.3,63.7,142,142,142a54.25,54.25,0,0,0,53.89-47.17A14,14,0,0,0,221.59,160.3ZM176,210C104.32,210,46,151.68,46,80A42.23,42.23,0,0,1,82.67,38h.23a2,2,0,0,1,1.84,1.31l21.1,47.11a2,2,0,0,1,0,1.67L84.73,113.15a4.73,4.73,0,0,0-.43.57,14,14,0,0,0-.91,13.73c8.87,18.16,27.17,36.32,45.53,45.19a14,14,0,0,0,13.77-1c.19-.13.38-.27.56-.42l24.68-21a1.92,1.92,0,0,1,1.6-.1l47.25,21.17a2,2,0,0,1,1.21,2A42.24,42.24,0,0,1,176,210Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220.78,162.13,173.56,141A12,12,0,0,0,162.18,142a3.37,3.37,0,0,0-.38.28L137,163.42a3.93,3.93,0,0,1-3.7.21c-16.24-7.84-33.05-24.52-40.89-40.57a3.9,3.9,0,0,1,.18-3.69l21.2-25.21c.1-.12.19-.25.28-.38a12,12,0,0,0,1-11.36L93.9,35.28a12,12,0,0,0-12.48-7.19A52.25,52.25,0,0,0,36,80c0,77.2,62.8,140,140,140a52.25,52.25,0,0,0,51.91-45.42A12,12,0,0,0,220.78,162.13ZM220,173.58A44.23,44.23,0,0,1,176,212C103.22,212,44,152.78,44,80A44.23,44.23,0,0,1,82.42,36a3.87,3.87,0,0,1,.48,0,4,4,0,0,1,3.67,2.49l21.11,47.14a4,4,0,0,1-.23,3.6l-21.19,25.2c-.1.13-.2.25-.29.39a12,12,0,0,0-.78,11.75c8.69,17.79,26.61,35.58,44.6,44.27a12,12,0,0,0,11.79-.87l.37-.28,24.83-21.12a3.93,3.93,0,0,1,3.57-.27l47.21,21.16A4,4,0,0,1,220,173.58Z"
        }))
    ]
]);


const $f9242fb59a025a53$export$54336acd81078d46 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $19cf1837247d50a6$export$2e2bcd8739ae039)
    })));
$f9242fb59a025a53$export$54336acd81078d46.displayName = "PhoneIcon";
const $f9242fb59a025a53$export$2de540f0cd7c073a = $f9242fb59a025a53$export$54336acd81078d46;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f6f26805e5c51ab3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234.49,111.07,90.41,22.94A20,20,0,0,0,60,39.87V216.13a20,20,0,0,0,30.41,16.93l144.08-88.13a19.82,19.82,0,0,0,0-33.86ZM84,208.85V47.15L216.16,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.23,134.69,84.15,222.81A8,8,0,0,1,72,216.12V39.88a8,8,0,0,1,12.15-6.69l144.08,88.12A7.82,7.82,0,0,1,228.23,134.69Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231.36,116.19,87.28,28.06a14,14,0,0,0-14.18-.27A13.69,13.69,0,0,0,66,39.87V216.13a13.69,13.69,0,0,0,7.1,12.08,14,14,0,0,0,14.18-.27l144.08-88.13a13.82,13.82,0,0,0,0-23.62Zm-6.26,13.38L81,217.7a2,2,0,0,1-2.06,0,1.78,1.78,0,0,1-1-1.61V39.87a1.78,1.78,0,0,1,1-1.61A2.06,2.06,0,0,1,80,38a2,2,0,0,1,1,.31L225.1,126.43a1.82,1.82,0,0,1,0,3.14Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.32,117.9,86.24,29.79a11.91,11.91,0,0,0-12.17-.23A11.71,11.71,0,0,0,68,39.89V216.11a11.71,11.71,0,0,0,6.07,10.33,11.91,11.91,0,0,0,12.17-.23L230.32,138.1a11.82,11.82,0,0,0,0-20.2Zm-4.18,13.37L82.06,219.39a4,4,0,0,1-4.07.07,3.77,3.77,0,0,1-2-3.35V39.89a3.77,3.77,0,0,1,2-3.35,4,4,0,0,1,4.07.07l144.08,88.12a3.8,3.8,0,0,1,0,6.54Z"
        }))
    ]
]);


const $3771d59d9595d59e$export$a6630b90defda83f = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $f6f26805e5c51ab3$export$2e2bcd8739ae039)
    })));
$3771d59d9595d59e$export$a6630b90defda83f.displayName = "PlayIcon";
const $3771d59d9595d59e$export$480db61f4dcd7727 = $3771d59d9595d59e$export$a6630b90defda83f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $da07f206d2d84597$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M137,168l11.52-11.51a12,12,0,0,0-17-17L120,151l-15-15,11.52-11.51a12,12,0,0,0-17-17L88,119,72.49,103.51a12,12,0,0,0-17,17L59,124,38.54,144.49a36,36,0,0,0,0,50.91l2.55,2.54L15.51,223.51a12,12,0,0,0,17,17l25.57-25.58,2.54,2.55a36.06,36.06,0,0,0,50.91,0L132,197l3.51,3.52a12,12,0,0,0,17-17ZM94.54,200.49a12,12,0,0,1-17,0L55.51,178.43a12,12,0,0,1,0-17L76,141l39,39Zm146-185a12,12,0,0,0-17,0L197.94,41.09l-2.54-2.55a36.05,36.05,0,0,0-50.91,0L124,59l-3.51-3.52a12,12,0,0,0-17,17l80,80a12,12,0,0,0,17-17L197,132l20.49-20.49a36,36,0,0,0,0-50.91l-2.55-2.54,25.58-25.57A12,12,0,0,0,240.49,15.51Zm-40,79L180,115,141,76l20.49-20.49a12,12,0,0,1,17,0l22.06,22.06a12,12,0,0,1,0,17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76,124l56,56-29,29a24,24,0,0,1-33.94,0L47,186.91A24,24,0,0,1,47,153ZM209,69.09,186.91,47A24,24,0,0,0,153,47L124,76l56,56,29-29A24,24,0,0,0,209,69.09Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,138.34a8,8,0,0,0-11.32,0L120,156.69,99.31,136l18.35-18.34a8,8,0,0,0-11.32-11.32L88,124.69,69.66,106.34a8,8,0,0,0-11.32,11.32L64.69,124,41.37,147.31a32,32,0,0,0,0,45.26l5.38,5.37-28.41,28.4a8,8,0,0,0,11.32,11.32l28.4-28.41,5.37,5.38a32,32,0,0,0,45.26,0L132,191.31l6.34,6.35a8,8,0,0,0,11.32-11.32L131.31,168l18.35-18.34A8,8,0,0,0,149.66,138.34Zm-52.29,65a16,16,0,0,1-22.62,0L52.69,181.25a16,16,0,0,1,0-22.62L76,135.31,120.69,180Zm140.29-185a8,8,0,0,0-11.32,0l-28.4,28.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L124,64.69l-6.34-6.35a8,8,0,0,0-11.32,11.32l80,80a8,8,0,0,0,11.32-11.32L191.31,132l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,28.41-28.4A8,8,0,0,0,237.66,18.34Zm-34.35,79L180,120.69,135.31,76l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,203.31,97.37Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,149.66,131.31,168l18.35,18.34a8,8,0,0,1-11.32,11.32L132,191.31l-23.31,23.32a32.06,32.06,0,0,1-45.26,0l-5.37-5.38-28.4,28.41a8,8,0,0,1-11.32-11.32l28.41-28.4-5.38-5.37a32,32,0,0,1,0-45.26L64.69,124l-6.35-6.34a8,8,0,0,1,11.32-11.32L88,124.69l18.34-18.35a8,8,0,0,1,11.32,11.32L99.31,136,120,156.69l18.34-18.35a8,8,0,0,1,11.32,11.32Zm88-131.32a8,8,0,0,0-11.32,0l-28.4,28.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L124,64.69l-6.34-6.35a8,8,0,0,0-11.32,11.32l80,80a8,8,0,0,0,11.32-11.32L191.31,132l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,28.41-28.4A8,8,0,0,0,237.66,18.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148.24,139.76a6,6,0,0,0-8.48,0L120,159.51,96.49,136l19.75-19.76a6,6,0,0,0-8.48-8.48L88,127.51,68.24,107.76a6,6,0,0,0-8.48,8.48L67.51,124,42.79,148.73a30,30,0,0,0,0,42.42l6.78,6.79L19.76,227.76a6,6,0,1,0,8.48,8.48l29.82-29.81,6.79,6.78a30,30,0,0,0,42.42,0L132,188.49l7.76,7.75a6,6,0,0,0,8.48-8.48L128.49,168l19.75-19.76A6,6,0,0,0,148.24,139.76Zm-49.45,65a18,18,0,0,1-25.46,0L51.27,182.67a18,18,0,0,1,0-25.46L76,132.49,123.51,180Zm137.45-185a6,6,0,0,0-8.48,0L197.94,49.57l-6.79-6.78a30,30,0,0,0-42.42,0L124,67.51l-7.76-7.75a6,6,0,0,0-8.48,8.48l80,80a6,6,0,0,0,8.48-8.48L188.49,132l24.72-24.73a30,30,0,0,0,0-42.42l-6.78-6.79,29.81-29.82A6,6,0,0,0,236.24,19.76Zm-31.51,79L180,123.51,132.49,76l24.72-24.73a18,18,0,0,1,25.46,0l22.06,22.06a18,18,0,0,1,0,25.46Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M149.66,138.34a8,8,0,0,0-11.32,0L120,156.69,99.31,136l18.35-18.34a8,8,0,0,0-11.32-11.32L88,124.69,69.66,106.34a8,8,0,0,0-11.32,11.32L64.69,124,41.37,147.31a32,32,0,0,0,0,45.26l5.38,5.37-28.41,28.4a8,8,0,0,0,11.32,11.32l28.4-28.41,5.37,5.38a32,32,0,0,0,45.26,0L132,191.31l6.34,6.35a8,8,0,0,0,11.32-11.32L131.31,168l18.35-18.34A8,8,0,0,0,149.66,138.34Zm-52.29,65a16,16,0,0,1-22.62,0L52.69,181.25a16,16,0,0,1,0-22.62L76,135.31,120.69,180Zm140.29-185a8,8,0,0,0-11.32,0l-28.4,28.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L124,64.69l-6.34-6.35a8,8,0,0,0-11.32,11.32l80,80a8,8,0,0,0,11.32-11.32L191.31,132l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,28.41-28.4A8,8,0,0,0,237.66,18.34Zm-34.35,79L180,120.69,135.31,76l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,203.31,97.37Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M146.83,141.17a4,4,0,0,0-5.66,0L120,162.34,93.66,136l21.17-21.17a4,4,0,0,0-5.66-5.66L88,130.34,66.83,109.17a4,4,0,0,0-5.66,5.66L70.34,124,44.2,150.14a28,28,0,0,0,0,39.6l8.2,8.2L21.17,229.17a4,4,0,0,0,5.66,5.66L58.06,203.6l8.2,8.2a28,28,0,0,0,39.6,0L132,185.66l9.17,9.17a4,4,0,0,0,5.66-5.66L125.66,168l21.17-21.17A4,4,0,0,0,146.83,141.17Zm-46.63,65a20,20,0,0,1-28.28,0L49.86,184.08a20,20,0,0,1,0-28.28L76,129.66,126.34,180Zm134.63-185a4,4,0,0,0-5.66,0L197.94,52.4l-8.2-8.2a28,28,0,0,0-39.6,0L124,70.34l-9.17-9.17a4,4,0,0,0-5.66,5.66l80,80a4,4,0,0,0,5.66-5.66L185.66,132l26.14-26.14a28,28,0,0,0,0-39.6l-8.2-8.2,31.23-31.23A4,4,0,0,0,234.83,21.17ZM212,86.06a19.86,19.86,0,0,1-5.86,14.14L180,126.34,129.66,76,155.8,49.86a20,20,0,0,1,28.28,0l22.06,22.06A19.85,19.85,0,0,1,212,86.06Z"
        }))
    ]
]);


const $6f9f0c9fbec8b58a$export$5bdc63ba07f7b8a8 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $da07f206d2d84597$export$2e2bcd8739ae039)
    })));
$6f9f0c9fbec8b58a$export$5bdc63ba07f7b8a8.displayName = "PlugsIcon";
const $6f9f0c9fbec8b58a$export$3700b6024640cab7 = $6f9f0c9fbec8b58a$export$5bdc63ba07f7b8a8;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b7c084f51671cbc2$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm52-84a12,12,0,0,1-12,12H140v28a12,12,0,0,1-24,0V140H88a12,12,0,0,1,0-24h28V88a12,12,0,0,1,24,0v28h28A12,12,0,0,1,180,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24Zm40,112H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm46-90a6,6,0,0,1-6,6H134v34a6,6,0,0,1-12,0V134H88a6,6,0,0,1,0-12h34V88a6,6,0,0,1,12,0v34h34A6,6,0,0,1,174,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm44-92a4,4,0,0,1-4,4H132v36a4,4,0,0,1-8,0V132H88a4,4,0,0,1,0-8h36V88a4,4,0,0,1,8,0v36h36A4,4,0,0,1,172,128Z"
        }))
    ]
]);


const $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $b7c084f51671cbc2$export$2e2bcd8739ae039)
    })));
$dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5.displayName = "PlusCircleIcon";
const $dd4d57083c8a9ad0$export$d8dd5a6f368a4f30 = $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e29098ab702c51e5$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,136H136v48a8,8,0,0,1-16,0V136H72a8,8,0,0,1,0-16h48V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,128a6,6,0,0,1-6,6H134v82a6,6,0,0,1-12,0V134H40a6,6,0,0,1,0-12h82V40a6,6,0,0,1,12,0v82h82A6,6,0,0,1,222,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,128a4,4,0,0,1-4,4H132v84a4,4,0,0,1-8,0V132H40a4,4,0,0,1,0-8h84V40a4,4,0,0,1,8,0v84h84A4,4,0,0,1,220,128Z"
        }))
    ]
]);


const $788766255439a751$export$f21ab0717a89c77f = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $e29098ab702c51e5$export$2e2bcd8739ae039)
    })));
$788766255439a751$export$f21ab0717a89c77f.displayName = "PlusIcon";
const $788766255439a751$export$2d9ac7aa84f97a08 = $788766255439a751$export$f21ab0717a89c77f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $f2725e8c66d6888f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H140V24a12,12,0,0,0-24,0V36H40A20,20,0,0,0,20,56V176a20,20,0,0,0,20,20H71l-16.4,20.5a12,12,0,0,0,18.74,15l28.4-35.5h52.46l28.4,35.5a12,12,0,0,0,18.74-15L185,196h31a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,136H44V60H212ZM104,120v24a12,12,0,0,1-24,0V120a12,12,0,0,1,24,0Zm24-28a12,12,0,0,1,12,12v40a12,12,0,0,1-24,0V104A12,12,0,0,1,128,92Zm24,52V88a12,12,0,0,1,24,0v56a12,12,0,0,1-24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V176a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,144a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,42H134V24a6,6,0,0,0-12,0V42H40A14,14,0,0,0,26,56V176a14,14,0,0,0,14,14H83.52L59.31,220.25a6,6,0,0,0,9.38,7.5L98.88,190h58.24l30.19,37.75a6,6,0,0,0,9.38-7.5L172.48,190H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,134a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2ZM102,120v24a6,6,0,0,1-12,0V120a6,6,0,0,1,12,0Zm32-16v40a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm32-16v56a6,6,0,0,1-12,0V88a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,44H132V24a4,4,0,0,0-8,0V44H40A12,12,0,0,0,28,56V176a12,12,0,0,0,12,12H87.68l-26.8,33.5a4,4,0,1,0,6.24,5L97.92,188h60.16l30.8,38.5a4,4,0,0,0,6.24-5L168.32,188H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,132a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4ZM100,120v24a4,4,0,0,1-8,0V120a4,4,0,0,1,8,0Zm32-16v40a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm32-16v56a4,4,0,0,1-8,0V88a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $bbd40d632367bb70$export$efe9d8422aa89449 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $f2725e8c66d6888f$export$2e2bcd8739ae039)
    })));
$bbd40d632367bb70$export$efe9d8422aa89449.displayName = "PresentationChartIcon";
const $bbd40d632367bb70$export$a5e1f3e20d9ba748 = $bbd40d632367bb70$export$efe9d8422aa89449;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $048f1d3f3954f21a$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm84,108a83.6,83.6,0,0,1-16.75,50.28L77.72,60.75A84,84,0,0,1,212,128ZM44,128A83.6,83.6,0,0,1,60.75,77.72L178.28,195.25A84,84,0,0,1,44,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,128a71.69,71.69,0,0,1-15.78,44.91L83.09,71.78A71.95,71.95,0,0,1,200,128ZM56,128a71.95,71.95,0,0,0,116.91,56.22L71.78,83.09A71.69,71.69,0,0,0,56,128Zm180,0A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-20,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm90,102a89.6,89.6,0,0,1-22.29,59.22L68.78,60.29A89.95,89.95,0,0,1,218,128ZM38,128A89.6,89.6,0,0,1,60.29,68.78L187.22,195.71A89.95,89.95,0,0,1,38,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm92,100a91.67,91.67,0,0,1-24.21,62.13L65.87,60.21A92,92,0,0,1,220,128ZM36,128A91.67,91.67,0,0,1,60.21,65.87L190.13,195.79A92,92,0,0,1,36,128Z"
        }))
    ]
]);


const $7425fd815e1431db$export$852d83c83fe09d93 = $7fPBF.forwardRef((t, i)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: i
    }, t), {
        weights: (0, $048f1d3f3954f21a$export$2e2bcd8739ae039)
    })));
$7425fd815e1431db$export$852d83c83fe09d93.displayName = "ProhibitIcon";
const $7425fd815e1431db$export$7891ead8a87bdea = $7425fd815e1431db$export$852d83c83fe09d93;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $27859a1fbdea2097$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm92-52A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128ZM128,64c-24.26,0-44,17.94-44,40v4a12,12,0,0,0,24,0v-4c0-8.82,9-16,20-16s20,7.18,20,16-9,16-20,16a12,12,0,0,0-12,12v8a12,12,0,0,0,23.73,2.56C158.31,137.88,172,122.37,172,104,172,81.94,152.26,64,128,64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M138,180a10,10,0,1,1-10-10A10,10,0,0,1,138,180ZM128,74c-21,0-38,15.25-38,34v4a6,6,0,0,0,12,0v-4c0-12.13,11.66-22,26-22s26,9.87,26,22-11.66,22-26,22a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-2.42c18.11-2.58,32-16.66,32-33.58C166,89.25,149,74,128,74Zm102,54A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,180a8,8,0,1,1-8-8A8,8,0,0,1,136,180ZM128,76c-19.85,0-36,14.36-36,32v4a4,4,0,0,0,8,0v-4c0-13.23,12.56-24,28-24s28,10.77,28,24-12.56,24-28,24a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-4.2c18-1.77,32-15.36,32-31.8C164,90.36,147.85,76,128,76Zm100,52A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $2322f0f5c675ac09$export$f314ed182f5da2a0 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, t), {
        weights: (0, $27859a1fbdea2097$export$2e2bcd8739ae039)
    })));
$2322f0f5c675ac09$export$f314ed182f5da2a0.displayName = "QuestionIcon";
const $2322f0f5c675ac09$export$38435c7d2fecd2f = $2322f0f5c675ac09$export$f314ed182f5da2a0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a32ef7baedc9256e$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M68,100A12,12,0,0,1,80,88h96a12,12,0,0,1,0,24H80A12,12,0,0,1,68,100Zm12,52h96a12,12,0,0,0,0-24H80a12,12,0,0,0,0,24ZM236,56V208a12,12,0,0,1-17.37,10.73L192,205.42l-26.63,13.31a12,12,0,0,1-10.74,0L128,205.42l-26.63,13.31a12,12,0,0,1-10.74,0L64,205.42,37.37,218.73A12,12,0,0,1,20,208V56A20,20,0,0,1,40,36H216A20,20,0,0,1,236,56Zm-24,4H44V188.58l14.63-7.31a12,12,0,0,1,10.74,0L96,194.58l26.63-13.31a12,12,0,0,1,10.74,0L160,194.58l26.63-13.31a12,12,0,0,1,10.74,0L212,188.58Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V208l-32-16-32,16-32-16L96,208,64,192,32,208V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72,104a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,104Zm8,40h96a8,8,0,0,0,0-16H80a8,8,0,0,0,0,16ZM232,56V208a8,8,0,0,1-11.58,7.15L192,200.94l-28.42,14.21a8,8,0,0,1-7.16,0L128,200.94,99.58,215.15a8,8,0,0,1-7.16,0L64,200.94,35.58,215.15A8,8,0,0,1,24,208V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V195.06l20.42-10.22a8,8,0,0,1,7.16,0L96,199.06l28.42-14.22a8,8,0,0,1,7.16,0L160,199.06l28.42-14.22a8,8,0,0,1,7.16,0L216,195.06Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V208a8,8,0,0,0,11.58,7.15L64,200.94l28.42,14.21a8,8,0,0,0,7.16,0L128,200.94l28.42,14.21a8,8,0,0,0,7.16,0L192,200.94l28.42,14.21A8,8,0,0,0,232,208V56A16,16,0,0,0,216,40ZM176,144H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Zm0-32H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M182,104a6,6,0,0,1-6,6H80a6,6,0,0,1,0-12h96A6,6,0,0,1,182,104Zm-6,26H80a6,6,0,0,0,0,12h96a6,6,0,0,0,0-12Zm54-74V208a6,6,0,0,1-2.85,5.1,5.93,5.93,0,0,1-3.15.9,6,6,0,0,1-2.68-.63L192,198.71l-29.32,14.66a6,6,0,0,1-5.36,0L128,198.71,98.68,213.37a6,6,0,0,1-5.36,0L64,198.71,34.68,213.37A6,6,0,0,1,26,208V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V198.29l23.32-11.66a6,6,0,0,1,5.36,0L96,201.29l29.32-14.66a6,6,0,0,1,5.36,0L160,201.29l29.32-14.66a6,6,0,0,1,5.36,0L218,198.29Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72,104a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,104Zm8,40h96a8,8,0,0,0,0-16H80a8,8,0,0,0,0,16ZM232,56V208a8,8,0,0,1-11.58,7.15L192,200.94l-28.42,14.21a8,8,0,0,1-7.16,0L128,200.94,99.58,215.15a8,8,0,0,1-7.16,0L64,200.94,35.58,215.15A8,8,0,0,1,24,208V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V195.06l20.42-10.22a8,8,0,0,1,7.16,0L96,199.06l28.42-14.22a8,8,0,0,1,7.16,0L160,199.06l28.42-14.22a8,8,0,0,1,7.16,0L216,195.06Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M180,104a4,4,0,0,1-4,4H80a4,4,0,0,1,0-8h96A4,4,0,0,1,180,104Zm-4,28H80a4,4,0,0,0,0,8h96a4,4,0,0,0,0-8Zm52-76V208a4,4,0,0,1-4,4,4.05,4.05,0,0,1-1.79-.42L192,196.47l-30.21,15.11a4,4,0,0,1-3.58,0L128,196.47,97.79,211.58a4,4,0,0,1-3.58,0L64,196.47,33.79,211.58A4,4,0,0,1,28,208V56A12,12,0,0,1,40,44H216A12,12,0,0,1,228,56Zm-8,0a4,4,0,0,0-4-4H40a4,4,0,0,0-4,4V201.53l26.21-13.11a4,4,0,0,1,3.58,0L96,203.53l30.21-15.11a4,4,0,0,1,3.58,0L160,203.53l30.21-15.11a4,4,0,0,1,3.58,0L220,201.53Z"
        }))
    ]
]);


const $fd6772777789f3b6$export$174e4a35fe496af8 = $7fPBF.forwardRef((t, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, t), {
        weights: (0, $a32ef7baedc9256e$export$2e2bcd8739ae039)
    })));
$fd6772777789f3b6$export$174e4a35fe496af8.displayName = "ReceiptIcon";
const $fd6772777789f3b6$export$953430523d182974 = $fd6772777789f3b6$export$174e4a35fe496af8;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3d7d3c27e9d1b273$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M20,128A76.08,76.08,0,0,1,96,52h99l-3.52-3.51a12,12,0,1,1,17-17l24,24a12,12,0,0,1,0,17l-24,24a12,12,0,0,1-17-17L195,76H96a52.06,52.06,0,0,0-52,52,12,12,0,0,1-24,0Zm204-12a12,12,0,0,0-12,12,52.06,52.06,0,0,1-52,52H61l3.52-3.51a12,12,0,1,0-17-17l-24,24a12,12,0,0,0,0,17l24,24a12,12,0,1,0,17-17L61,204h99a76.08,76.08,0,0,0,76-76A12,12,0,0,0,224,116Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,64v64a64,64,0,0,1-64,64H32V128A64,64,0,0,1,96,64Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,128A72.08,72.08,0,0,1,96,56h96V40a8,8,0,0,1,13.66-5.66l24,24a8,8,0,0,1,0,11.32l-24,24A8,8,0,0,1,192,88V72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H64V168a8,8,0,0,0-13.66-5.66l-24,24a8,8,0,0,0,0,11.32l24,24A8,8,0,0,0,64,216V200h96a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M26,128A70.08,70.08,0,0,1,96,58H209.51L195.76,44.24a6,6,0,0,1,8.48-8.48l24,24a6,6,0,0,1,0,8.48l-24,24a6,6,0,0,1-8.48-8.48L209.51,70H96a58.07,58.07,0,0,0-58,58,6,6,0,0,1-12,0Zm198-6a6,6,0,0,0-6,6,58.07,58.07,0,0,1-58,58H46.49l13.75-13.76a6,6,0,0,0-8.48-8.48l-24,24a6,6,0,0,0,0,8.48l24,24a6,6,0,0,0,8.48-8.48L46.49,198H160a70.08,70.08,0,0,0,70-70A6,6,0,0,0,224,122Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M28,128A68.07,68.07,0,0,1,96,60H214.34L197.17,42.83a4,4,0,0,1,5.66-5.66l24,24a4,4,0,0,1,0,5.66l-24,24a4,4,0,0,1-5.66-5.66L214.34,68H96a60.07,60.07,0,0,0-60,60,4,4,0,0,1-8,0Zm196-4a4,4,0,0,0-4,4,60.07,60.07,0,0,1-60,60H41.66l17.17-17.17a4,4,0,0,0-5.66-5.66l-24,24a4,4,0,0,0,0,5.66l24,24a4,4,0,1,0,5.66-5.66L41.66,196H160a68.07,68.07,0,0,0,68-68A4,4,0,0,0,224,124Z"
        }))
    ]
]);


const $510c9fc2f66cce3f$export$e5f174c029ba02b2 = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, t), {
        weights: (0, $3d7d3c27e9d1b273$export$2e2bcd8739ae039)
    })));
$510c9fc2f66cce3f$export$e5f174c029ba02b2.displayName = "RepeatIcon";
const $510c9fc2f66cce3f$export$f9d61a2a6155ab51 = $510c9fc2f66cce3f$export$e5f174c029ba02b2;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $069363012ea1cf6c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72,104a16,16,0,1,1,16,16A16,16,0,0,1,72,104Zm96,16a16,16,0,1,0-16-16A16,16,0,0,0,168,120Zm68-40V192a36,36,0,0,1-36,36H56a36,36,0,0,1-36-36V80A36,36,0,0,1,56,44h60V16a12,12,0,0,1,24,0V44h60A36,36,0,0,1,236,80Zm-24,0a12,12,0,0,0-12-12H56A12,12,0,0,0,44,80V192a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12Zm-12,82a30,30,0,0,1-30,30H86a30,30,0,0,1,0-60h84A30,30,0,0,1,200,162Zm-80-6v12h16V156ZM86,168H96V156H86a6,6,0,0,0,0,12Zm90-6a6,6,0,0,0-6-6H160v12h10A6,6,0,0,0,176,162Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56H56A24,24,0,0,0,32,80V192a24,24,0,0,0,24,24H200a24,24,0,0,0,24-24V80A24,24,0,0,0,200,56ZM164,184H92a20,20,0,0,1,0-40h72a20,20,0,0,1,0,40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48Zm16,144a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V80A16,16,0,0,1,56,64H200a16,16,0,0,1,16,16ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Zm4,28H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-24,16v24H116V152ZM80,164a12,12,0,0,1,12-12h8v24H92A12,12,0,0,1,80,164Zm84,12h-8V152h8a12,12,0,0,1,0,24Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48ZM172,96a12,12,0,1,1-12,12A12,12,0,0,1,172,96ZM96,184H80a16,16,0,0,1,0-32H96ZM84,120a12,12,0,1,1,12-12A12,12,0,0,1,84,120Zm60,64H112V152h32Zm32,0H160V152h16a16,16,0,0,1,0,32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,50H134V16a6,6,0,0,0-12,0V50H56A30,30,0,0,0,26,80V192a30,30,0,0,0,30,30H200a30,30,0,0,0,30-30V80A30,30,0,0,0,200,50Zm18,142a18,18,0,0,1-18,18H56a18,18,0,0,1-18-18V80A18,18,0,0,1,56,62H200a18,18,0,0,1,18,18ZM74,108a10,10,0,1,1,10,10A10,10,0,0,1,74,108Zm88,0a10,10,0,1,1,10,10A10,10,0,0,1,162,108Zm2,30H92a26,26,0,0,0,0,52h72a26,26,0,0,0,0-52Zm-22,12v28H114V150ZM78,164a14,14,0,0,1,14-14h10v28H92A14,14,0,0,1,78,164Zm86,14H154V150h10a14,14,0,0,1,0,28Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48Zm16,144a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V80A16,16,0,0,1,56,64H200a16,16,0,0,1,16,16Zm-52-56H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-24,16v24H116V152ZM80,164a12,12,0,0,1,12-12h8v24H92A12,12,0,0,1,80,164Zm84,12h-8V152h8a12,12,0,0,1,0,24ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,52H132V16a4,4,0,0,0-8,0V52H56A28,28,0,0,0,28,80V192a28,28,0,0,0,28,28H200a28,28,0,0,0,28-28V80A28,28,0,0,0,200,52Zm20,140a20,20,0,0,1-20,20H56a20,20,0,0,1-20-20V80A20,20,0,0,1,56,60H200a20,20,0,0,1,20,20ZM76,108a8,8,0,1,1,8,8A8,8,0,0,1,76,108Zm88,0a8,8,0,1,1,8,8A8,8,0,0,1,164,108Zm0,32H92a24,24,0,0,0,0,48h72a24,24,0,0,0,0-48Zm-20,8v32H112V148ZM76,164a16,16,0,0,1,16-16h12v32H92A16,16,0,0,1,76,164Zm88,16H152V148h12a16,16,0,0,1,0,32Z"
        }))
    ]
]);


const $b6b769c496a9d5ca$export$5db83f67d50796e6 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $069363012ea1cf6c$export$2e2bcd8739ae039)
    })));
$b6b769c496a9d5ca$export$5db83f67d50796e6.displayName = "RobotIcon";
const $b6b769c496a9d5ca$export$20db0c138a037d2a = $b6b769c496a9d5ca$export$5db83f67d50796e6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b0cbad97fe96559c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.85,46.89a20,20,0,0,0-18.74-18.74c-13.13-.77-46.65.42-74.48,28.24L131,60H74.36a19.83,19.83,0,0,0-14.14,5.86L25.87,100.19a20,20,0,0,0,11.35,33.95l37.14,5.18,42.32,42.32,5.19,37.18A19.88,19.88,0,0,0,135.34,235a20.13,20.13,0,0,0,6.37,1,19.9,19.9,0,0,0,14.1-5.87l34.34-34.35A19.85,19.85,0,0,0,196,181.64V125l3.6-3.59C227.43,93.54,228.62,60,227.85,46.89ZM76,84h31L75.75,115.28l-27.23-3.8ZM151.6,73.37A72.27,72.27,0,0,1,204,52a72.17,72.17,0,0,1-21.38,52.41L128,159,97,128ZM172,180l-27.49,27.49-3.8-27.23L172,149Zm-72,22c-8.71,11.85-26.19,26-60,26a12,12,0,0,1-12-12c0-33.84,14.12-51.32,26-60A12,12,0,1,1,68.18,175.3C62.3,179.63,55.51,187.8,53,203c15.21-2.51,23.37-9.3,27.7-15.18A12,12,0,1,1,100,202Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M184,120v61.65a8,8,0,0,1-2.34,5.65l-34.35,34.35a8,8,0,0,1-13.57-4.53L128,176ZM136,72H74.35a8,8,0,0,0-5.65,2.34L34.35,108.69a8,8,0,0,0,4.53,13.57L80,128ZM40,216c37.65,0,50.69-19.69,54.56-28.18L68.18,161.44C59.69,165.31,40,178.35,40,216Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.85,47.12a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.41,27.07L132.69,64H74.36A15.91,15.91,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A15.91,15.91,0,0,0,192,181.64V123.31l4.77-4.77C223.45,91.86,224.6,59.71,223.85,47.12ZM74.36,80h42.33L77.16,119.52,40,114.34Zm74.41-9.45a76.65,76.65,0,0,1,59.11-22.47,76.46,76.46,0,0,1-22.42,59.16L128,164.68,91.32,128ZM176,181.64,141.67,216l-5.19-37.17L176,139.31Zm-74.16,9.5C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M101.85,191.14C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Zm122-144a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.4,27.07h0L88,108.7A8,8,0,0,1,76.67,97.39l26.56-26.57A4,4,0,0,0,100.41,64H74.35A15.9,15.9,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A16,16,0,0,0,192,181.65V155.59a4,4,0,0,0-6.83-2.82l-26.57,26.56a8,8,0,0,1-11.71-.42,8.2,8.2,0,0,1,.6-11.1l49.27-49.27h0C223.45,91.86,224.6,59.71,223.85,47.12Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M221.86,47.24a14,14,0,0,0-13.11-13.1c-12.31-.73-43.77.39-69.88,26.5L133.52,66H74.35a13.9,13.9,0,0,0-9.89,4.1L30.11,104.44a14,14,0,0,0,7.94,23.76l39.13,5.46,45.16,45.16L127.8,218a14,14,0,0,0,23.76,7.92l34.35-34.35a13.91,13.91,0,0,0,4.1-9.89V122.48l5.35-5.35h0C221.46,91,222.59,59.56,221.86,47.24ZM38.11,115a2,2,0,0,1,.49-2L72.94,78.58A2,2,0,0,1,74.35,78h47.17L77.87,121.64l-38.14-5.32A1.93,1.93,0,0,1,38.11,115ZM178,181.65a2,2,0,0,1-.59,1.41L143.08,217.4a2,2,0,0,1-3.4-1.11l-5.32-38.16L178,134.48Zm8.87-73h0L128,167.51,88.49,128l58.87-58.88a78.47,78.47,0,0,1,60.69-23A2,2,0,0,1,209.88,48,78.47,78.47,0,0,1,186.88,108.64ZM100,190.31C95.68,199.84,81.13,222,40,222a6,6,0,0,1-6-6c0-41.13,22.16-55.68,31.69-60a6,6,0,1,1,5,10.92c-7,3.17-22.53,13.52-24.47,42.91,29.39-1.94,39.74-17.52,42.91-24.47a6,6,0,1,1,10.92,5Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.85,47.12a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.41,27.07L132.69,64H74.36A15.91,15.91,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A15.91,15.91,0,0,0,192,181.64V123.31l4.77-4.77C223.45,91.86,224.6,59.71,223.85,47.12ZM74.36,80h42.33L77.16,119.52,40,114.34Zm74.41-9.45a76.65,76.65,0,0,1,59.11-22.47,76.46,76.46,0,0,1-22.42,59.16L128,164.68,91.32,128ZM176,181.64,141.67,216l-5.19-37.17L176,139.31Zm-74.16,9.5C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M219.86,47.36a12,12,0,0,0-11.22-11.22c-12-.71-42.82.38-68.35,25.91L134.35,68h-60a11.9,11.9,0,0,0-8.48,3.52L31.52,105.85a12,12,0,0,0,6.81,20.37l39.79,5.55,46.11,46.11,5.55,39.81a12,12,0,0,0,20.37,6.79l34.34-34.35a11.9,11.9,0,0,0,3.52-8.48v-60l5.94-5.94C219.48,90.18,220.57,59.41,219.86,47.36ZM36.21,115.6a3.94,3.94,0,0,1,1-4.09L71.53,77.17A4,4,0,0,1,74.35,76h52L78.58,123.76,39.44,118.3A3.94,3.94,0,0,1,36.21,115.6ZM180,181.65a4,4,0,0,1-1.17,2.83l-34.35,34.34a4,4,0,0,1-6.79-2.25l-5.46-39.15L180,129.65Zm-52-11.31L85.66,128l60.28-60.29c23.24-23.24,51.25-24.23,62.22-23.58a3.93,3.93,0,0,1,3.71,3.71c.65,11-.35,39-23.58,62.22ZM98.21,189.48C94,198.66,80,220,40,220a4,4,0,0,1-4-4c0-40,21.34-54,30.52-58.21a4,4,0,0,1,3.32,7.28c-7.46,3.41-24.43,14.66-25.76,46.85,32.19-1.33,43.44-18.3,46.85-25.76a4,4,0,1,1,7.28,3.32Z"
        }))
    ]
]);


const $47547f2fd2eb2527$export$ccc8b9cc502aea29 = $7fPBF.forwardRef((e, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, e), {
        weights: (0, $b0cbad97fe96559c$export$2e2bcd8739ae039)
    })));
$47547f2fd2eb2527$export$ccc8b9cc502aea29.displayName = "RocketLaunchIcon";
const $47547f2fd2eb2527$export$a45823549b138975 = $47547f2fd2eb2527$export$ccc8b9cc502aea29;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $3082ee5400a1a3c8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,40V68a12,12,0,0,1-24,0V52H188a12,12,0,0,1,0-24h28A12,12,0,0,1,228,40ZM216,176a12,12,0,0,0-12,12v16H188a12,12,0,0,0,0,24h28a12,12,0,0,0,12-12V188A12,12,0,0,0,216,176ZM68,204H52V188a12,12,0,0,0-24,0v28a12,12,0,0,0,12,12H68a12,12,0,0,0,0-24ZM40,80A12,12,0,0,0,52,68V52H68a12,12,0,0,0,0-24H40A12,12,0,0,0,28,40V68A12,12,0,0,0,40,80Zm88,128a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,208Zm56-80a56,56,0,1,0-56,56A56.06,56.06,0,0,0,184,128Zm-80-24a16,16,0,1,0,16,16A16,16,0,0,0,104,104Zm48,0a16,16,0,1,0,16,16A16,16,0,0,0,152,104Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,128a64,64,0,1,1-64-64A64,64,0,0,1,192,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,40V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h36A8,8,0,0,1,224,40Zm-8,132a8,8,0,0,0-8,8v28H180a8,8,0,0,0,0,16h36a8,8,0,0,0,8-8V180A8,8,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v36a8,8,0,0,0,8,8H76a8,8,0,0,0,0-16ZM40,84a8,8,0,0,0,8-8V48H76a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V76A8,8,0,0,0,40,84Zm88,116a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,200Zm56-72a56,56,0,1,0-56,56A56.06,56.06,0,0,0,184,128Zm-68-12a12,12,0,1,0-12,12A12,12,0,0,0,116,116Zm36-12a12,12,0,1,0,12,12A12,12,0,0,0,152,104Zm-5.29,42c-3.81,3.37-12,6-18.71,6s-14.9-2.63-18.71-6a8,8,0,1,0-10.58,12c7.83,6.91,20.35,10,29.29,10s21.46-3.09,29.29-10a8,8,0,1,0-10.58-12Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,40V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h36A8,8,0,0,1,224,40Zm-8,132a8,8,0,0,0-8,8v28H180a8,8,0,0,0,0,16h36a8,8,0,0,0,8-8V180A8,8,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v36a8,8,0,0,0,8,8H76a8,8,0,0,0,0-16ZM40,84a8,8,0,0,0,8-8V48H76a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V76A8,8,0,0,0,40,84Zm88,116a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,200Zm-24-72a12,12,0,1,0-12-12A12,12,0,0,0,104,128Zm54,18.71a8,8,0,0,0-11.29-.71c-3.81,3.37-12,6-18.71,6s-14.9-2.63-18.71-6a8,8,0,1,0-10.58,12c7.83,6.91,20.35,10,29.29,10s21.46-3.09,29.29-10A8,8,0,0,0,158,146.71ZM164,116a12,12,0,1,0-12,12A12,12,0,0,0,164,116Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,40V76a6,6,0,0,1-12,0V46H180a6,6,0,0,1,0-12h36A6,6,0,0,1,222,40Zm-6,134a6,6,0,0,0-6,6v30H180a6,6,0,0,0,0,12h36a6,6,0,0,0,6-6V180A6,6,0,0,0,216,174ZM76,210H46V180a6,6,0,0,0-12,0v36a6,6,0,0,0,6,6H76a6,6,0,0,0,0-12ZM40,82a6,6,0,0,0,6-6V46H76a6,6,0,0,0,0-12H40a6,6,0,0,0-6,6V76A6,6,0,0,0,40,82Zm88,116a70,70,0,1,1,70-70A70.08,70.08,0,0,1,128,198Zm58-70a58,58,0,1,0-58,58A58.07,58.07,0,0,0,186,128Zm-72-12a10,10,0,1,0-10,10A10,10,0,0,0,114,116Zm38-10a10,10,0,1,0,10,10A10,10,0,0,0,152,106Zm-4,41.5c-4.2,3.71-12.81,6.5-20,6.5s-15.83-2.79-20-6.5a6,6,0,0,0-7.94,9c7.44,6.56,19.41,9.5,28,9.5s20.53-2.94,28-9.5a6,6,0,1,0-7.94-9Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,40V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h36A8,8,0,0,1,224,40Zm-8,132a8,8,0,0,0-8,8v28H180a8,8,0,0,0,0,16h36a8,8,0,0,0,8-8V180A8,8,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v36a8,8,0,0,0,8,8H76a8,8,0,0,0,0-16ZM40,84a8,8,0,0,0,8-8V48H76a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V76A8,8,0,0,0,40,84Zm88,116a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,200Zm56-72a56,56,0,1,0-56,56A56.06,56.06,0,0,0,184,128Zm-68-12a12,12,0,1,0-12,12A12,12,0,0,0,116,116Zm36-12a12,12,0,1,0,12,12A12,12,0,0,0,152,104Zm-5.29,42c-3.81,3.37-12,6-18.71,6s-14.9-2.63-18.71-6a8,8,0,1,0-10.58,12c7.83,6.91,20.35,10,29.29,10s21.46-3.09,29.29-10a8,8,0,1,0-10.58-12Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,40V76a4,4,0,0,1-8,0V44H180a4,4,0,0,1,0-8h36A4,4,0,0,1,220,40Zm-4,136a4,4,0,0,0-4,4v32H180a4,4,0,0,0,0,8h36a4,4,0,0,0,4-4V180A4,4,0,0,0,216,176ZM76,212H44V180a4,4,0,0,0-8,0v36a4,4,0,0,0,4,4H76a4,4,0,0,0,0-8ZM40,80a4,4,0,0,0,4-4V44H76a4,4,0,0,0,0-8H40a4,4,0,0,0-4,4V76A4,4,0,0,0,40,80Zm88,116a68,68,0,1,1,68-68A68.07,68.07,0,0,1,128,196Zm60-68a60,60,0,1,0-60,60A60.07,60.07,0,0,0,188,128Zm-76-12a8,8,0,1,0-8,8A8,8,0,0,0,112,116Zm40-8a8,8,0,1,0,8,8A8,8,0,0,0,152,108Zm-2.65,41c-4.52,4-13.7,7-21.35,7s-16.83-3-21.35-7a4,4,0,0,0-5.3,6c6,5.3,17,9,26.65,9s20.64-3.7,26.65-9a4,4,0,1,0-5.3-6Z"
        }))
    ]
]);


const $32f3c95d33b86bb3$export$15406caa0ed774d4 = $7fPBF.forwardRef((a, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: m
    }, a), {
        weights: (0, $3082ee5400a1a3c8$export$2e2bcd8739ae039)
    })));
$32f3c95d33b86bb3$export$15406caa0ed774d4.displayName = "ScanSmileyIcon";
const $32f3c95d33b86bb3$export$5fb06c97db84b620 = $32f3c95d33b86bb3$export$15406caa0ed774d4;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $78cae717afeec851$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M156,80H48a20,20,0,0,0-20,20V208a20,20,0,0,0,20,20H156a20,20,0,0,0,20-20V100A20,20,0,0,0,156,80Zm-4,124H52V104H152ZM132,40a12,12,0,0,1,12-12h16a12,12,0,0,1,0,24H144A12,12,0,0,1,132,40Zm96,8v8a12,12,0,0,1-24,0V52h-4a12,12,0,0,1,0-24h8A20,20,0,0,1,228,48Zm0,48v16a12,12,0,0,1-24,0V96a12,12,0,0,1,24,0Zm0,56v8a20,20,0,0,1-20,20h-8a12,12,0,0,1,0-24h4v-4a12,12,0,0,1,24,0ZM76,56V48A20,20,0,0,1,96,28h8a12,12,0,0,1,0,24h-4v4a12,12,0,0,1-24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V160a8,8,0,0,1-8,8H168V96a8,8,0,0,0-8-8H88V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16V96A16,16,0,0,0,160,80Zm0,128H48V96H160ZM136,40a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,40Zm88,8v8a8,8,0,0,1-16,0V48h-8a8,8,0,0,1,0-16h8A16,16,0,0,1,224,48Zm0,48v16a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm0,56v8a16,16,0,0,1-16,16h-8a8,8,0,0,1,0-16h8v-8a8,8,0,0,1,16,0ZM80,56V48A16,16,0,0,1,96,32h8a8,8,0,0,1,0,16H96v8a8,8,0,0,1-16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72,112h72v72H72ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM96,72a8,8,0,0,0,16,0h16a8,8,0,0,0,0-16H112A16,16,0,0,0,96,72Zm64,40a16,16,0,0,0-16-16H72a16,16,0,0,0-16,16v72a16,16,0,0,0,16,16h72a16,16,0,0,0,16-16Zm40,16a8,8,0,0,0-16,0v16a8,8,0,0,0,0,16,16,16,0,0,0,16-16Zm0-56a16,16,0,0,0-16-16H168a8,8,0,0,0,0,16h16V88a8,8,0,0,0,16,0Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H160a14,14,0,0,0,14-14V96A14,14,0,0,0,160,82Zm2,126a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H160a2,2,0,0,1,2,2ZM138,40a6,6,0,0,1,6-6h16a6,6,0,0,1,0,12H144A6,6,0,0,1,138,40Zm84,8v8a6,6,0,0,1-12,0V48a2,2,0,0,0-2-2h-8a6,6,0,0,1,0-12h8A14,14,0,0,1,222,48Zm0,48v16a6,6,0,0,1-12,0V96a6,6,0,0,1,12,0Zm0,56v8a14,14,0,0,1-14,14h-8a6,6,0,0,1,0-12h8a2,2,0,0,0,2-2v-8a6,6,0,0,1,12,0ZM82,56V48A14,14,0,0,1,96,34h8a6,6,0,0,1,0,12H96a2,2,0,0,0-2,2v8a6,6,0,0,1-12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16V96A16,16,0,0,0,160,80Zm0,128H48V96H160ZM136,40a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,40Zm88,8v8a8,8,0,0,1-16,0V48h-8a8,8,0,0,1,0-16h8A16,16,0,0,1,224,48Zm0,48v16a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm0,56v8a16,16,0,0,1-16,16h-8a8,8,0,0,1,0-16h8v-8a8,8,0,0,1,16,0ZM80,56V48A16,16,0,0,1,96,32h8a8,8,0,0,1,0,16H96v8a8,8,0,0,1-16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,84H48A12,12,0,0,0,36,96V208a12,12,0,0,0,12,12H160a12,12,0,0,0,12-12V96A12,12,0,0,0,160,84Zm4,124a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H160a4,4,0,0,1,4,4ZM140,40a4,4,0,0,1,4-4h16a4,4,0,0,1,0,8H144A4,4,0,0,1,140,40Zm80,8v8a4,4,0,0,1-8,0V48a4,4,0,0,0-4-4h-8a4,4,0,0,1,0-8h8A12,12,0,0,1,220,48Zm0,48v16a4,4,0,0,1-8,0V96a4,4,0,0,1,8,0Zm0,56v8a12,12,0,0,1-12,12h-8a4,4,0,0,1,0-8h8a4,4,0,0,0,4-4v-8a4,4,0,0,1,8,0ZM84,56V48A12,12,0,0,1,96,36h8a4,4,0,0,1,0,8H96a4,4,0,0,0-4,4v8a4,4,0,0,1-8,0Z"
        }))
    ]
]);


const $ba5cf70b83cf27ea$export$62a30a6e7319c2c6 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $78cae717afeec851$export$2e2bcd8739ae039)
    })));
$ba5cf70b83cf27ea$export$62a30a6e7319c2c6.displayName = "SelectionBackgroundIcon";
const $ba5cf70b83cf27ea$export$90cf9bd0b30506e5 = $ba5cf70b83cf27ea$export$62a30a6e7319c2c6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b6ea1055a398c666$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M156,40a12,12,0,0,1-12,12H112a12,12,0,0,1,0-24h32A12,12,0,0,1,156,40ZM144,204H112a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24ZM208,28H184a12,12,0,0,0,0,24h20V72a12,12,0,0,0,24,0V48A20,20,0,0,0,208,28Zm8,72a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V112A12,12,0,0,0,216,100Zm0,72a12,12,0,0,0-12,12v20H184a12,12,0,0,0,0,24h24a20,20,0,0,0,20-20V184A12,12,0,0,0,216,172ZM40,156a12,12,0,0,0,12-12V112a12,12,0,0,0-24,0v32A12,12,0,0,0,40,156Zm32,48H52V184a12,12,0,0,0-24,0v24a20,20,0,0,0,20,20H72a12,12,0,0,0,0-24ZM72,28H48A20,20,0,0,0,28,48V72a12,12,0,0,0,24,0V52H72a12,12,0,0,0,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40V216H40V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152,40a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16,16,0,0,0,32,48V72a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM104,200H72a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Zm0-128H72v32a8,8,0,0,1-16,0V72A16,16,0,0,1,72,56h32a8,8,0,0,1,0,16Zm96,112a16,16,0,0,1-16,16H152a8,8,0,0,1,0-16h32V152a8,8,0,0,1,16,0Zm0-80a8,8,0,0,1-16,0V72H152a8,8,0,0,1,0-16h32a16,16,0,0,1,16,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M150,40a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h32A6,6,0,0,1,150,40Zm-6,170H112a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12ZM208,34H184a6,6,0,0,0,0,12h24a2,2,0,0,1,2,2V72a6,6,0,0,0,12,0V48A14,14,0,0,0,208,34Zm8,72a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V112A6,6,0,0,0,216,106Zm0,72a6,6,0,0,0-6,6v24a2,2,0,0,1-2,2H184a6,6,0,0,0,0,12h24a14,14,0,0,0,14-14V184A6,6,0,0,0,216,178ZM40,150a6,6,0,0,0,6-6V112a6,6,0,0,0-12,0v32A6,6,0,0,0,40,150Zm32,60H48a2,2,0,0,1-2-2V184a6,6,0,0,0-12,0v24a14,14,0,0,0,14,14H72a6,6,0,0,0,0-12ZM72,34H48A14,14,0,0,0,34,48V72a6,6,0,0,0,12,0V48a2,2,0,0,1,2-2H72a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M152,40a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16,16,0,0,0,32,48V72a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M148,40a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4,4,0,0,1,148,40Zm-4,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4,4,0,0,1,4,4V72a4,4,0,0,0,8,0V48A12,12,0,0,0,208,36Zm8,72a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V112A4,4,0,0,0,216,108Zm0,72a4,4,0,0,0-4,4v24a4,4,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12,12,0,0,0,12-12V184A4,4,0,0,0,216,180ZM40,148a4,4,0,0,0,4-4V112a4,4,0,0,0-8,0v32A4,4,0,0,0,40,148Zm32,64H48a4,4,0,0,1-4-4V184a4,4,0,0,0-8,0v24a12,12,0,0,0,12,12H72a4,4,0,0,0,0-8ZM72,36H48A12,12,0,0,0,36,48V72a4,4,0,0,0,8,0V48a4,4,0,0,1,4-4H72a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $80401d3fb267975d$export$20f327b9bcd226d8 = $7fPBF.forwardRef((t, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, t), {
        weights: (0, $b6ea1055a398c666$export$2e2bcd8739ae039)
    })));
$80401d3fb267975d$export$20f327b9bcd226d8.displayName = "SelectionIcon";
const $80401d3fb267975d$export$52baac22726c72bf = $80401d3fb267975d$export$20f327b9bcd226d8;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $ac84e7289768c099$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,40a12,12,0,0,1,12-12h32a12,12,0,0,1,0,24H112A12,12,0,0,1,100,40Zm44,164H112a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24ZM208,28H184a12,12,0,0,0,0,24h20V72a12,12,0,0,0,24,0V48A20,20,0,0,0,208,28Zm8,72a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V112A12,12,0,0,0,216,100ZM40,156a12,12,0,0,0,12-12V112a12,12,0,0,0-24,0v32A12,12,0,0,0,40,156Zm32,48H52V184a12,12,0,0,0-24,0v24a20,20,0,0,0,20,20H72a12,12,0,0,0,0-24ZM56.88,31.93A12,12,0,1,0,39.12,48.07l160,176a12,12,0,0,0,17.76-16.14Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40V216H40V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.92,34.62A8,8,0,1,0,42.08,45.38l160,176a8,8,0,1,0,11.84-10.76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM152,56h32a16,16,0,0,1,16,16v32a8,8,0,0,1-16,0V72H152a8,8,0,0,1,0-16ZM104,200H72a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Zm101.66,5.66a8,8,0,0,1-11.32,0L188.69,200H152a8,8,0,0,1,0-16h20.69L72,83.31V104a8,8,0,0,1-16,0V67.31l-5.66-5.65A8,8,0,0,1,61.66,50.34l8,8h0l136,136A8,8,0,0,1,205.66,205.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M106,40a6,6,0,0,1,6-6h32a6,6,0,0,1,0,12H112A6,6,0,0,1,106,40Zm38,170H112a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12ZM208,34H184a6,6,0,0,0,0,12h24a2,2,0,0,1,2,2V72a6,6,0,0,0,12,0V48A14,14,0,0,0,208,34Zm8,72a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V112A6,6,0,0,0,216,106ZM40,150a6,6,0,0,0,6-6V112a6,6,0,0,0-12,0v32A6,6,0,0,0,40,150Zm32,60H48a2,2,0,0,1-2-2V184a6,6,0,0,0-12,0v24a14,14,0,0,0,14,14H72a6,6,0,0,0,0-12ZM52.44,36A6,6,0,0,0,43.56,44l160,176a6,6,0,0,0,8.88-8.08Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.92,34.62A8,8,0,1,0,42.08,45.38l160,176a8,8,0,1,0,11.84-10.76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M108,40a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H112A4,4,0,0,1,108,40Zm36,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4,4,0,0,1,4,4V72a4,4,0,0,0,8,0V48A12,12,0,0,0,208,36Zm8,72a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V112A4,4,0,0,0,216,108ZM40,148a4,4,0,0,0,4-4V112a4,4,0,0,0-8,0v32A4,4,0,0,0,40,148Zm32,64H48a4,4,0,0,1-4-4V184a4,4,0,0,0-8,0v24a12,12,0,0,0,12,12H72a4,4,0,0,0,0-8ZM51,37.31A4,4,0,0,0,45,42.69l160,176a4,4,0,1,0,5.92-5.38Z"
        }))
    ]
]);


const $8d0ede6d22577f4c$export$b5014a80f94eec28 = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, t), {
        weights: (0, $ac84e7289768c099$export$2e2bcd8739ae039)
    })));
$8d0ede6d22577f4c$export$b5014a80f94eec28.displayName = "SelectionSlashIcon";
const $8d0ede6d22577f4c$export$44ea98972205d552 = $8d0ede6d22577f4c$export$b5014a80f94eec28;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6fe7ec134a2e7491$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,112.49l-48,48a12,12,0,0,1-17-17L195,116H165a84,84,0,0,0-81.36,63,12,12,0,1,1-23.24-6A107.94,107.94,0,0,1,165,92H195L167.51,64.48a12,12,0,0,1,17-17l48,48A12,12,0,0,1,232.49,112.49ZM192,204H44V88a12,12,0,0,0-24,0V216a12,12,0,0,0,12,12H192a12,12,0,0,0,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,104l-48,48V56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,98.34l-48-48A8,8,0,0,0,168,56V96h-3A103.94,103.94,0,0,0,64.25,174a8,8,0,0,0,15.5,4A88,88,0,0,1,165,112h3v40a8,8,0,0,0,13.66,5.66l48-48A8,8,0,0,0,229.66,98.34ZM184,132.69V75.31L212.69,104ZM200,216a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0V208H192A8,8,0,0,1,200,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,109.66l-48,48A8,8,0,0,1,168,152V112h-3a88,88,0,0,0-85.23,66,8,8,0,0,1-15.5-4A103.94,103.94,0,0,1,165,96h3V56a8,8,0,0,1,13.66-5.66l48,48A8,8,0,0,1,229.66,109.66ZM192,208H40V88a8,8,0,0,0-16,0V216a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.24,108.24l-48,48a6,6,0,0,1-8.48-8.48L209.51,110H165a89.94,89.94,0,0,0-87.17,67.5,6,6,0,0,1-11.62-3A101.94,101.94,0,0,1,165,98h44.53L171.76,60.24a6,6,0,0,1,8.48-8.48l48,48A6,6,0,0,1,228.24,108.24ZM192,210H38V88a6,6,0,0,0-12,0V216a6,6,0,0,0,6,6H192a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.66,109.66l-48,48a8,8,0,0,1-11.32-11.32L204.69,112H165a88,88,0,0,0-85.23,66,8,8,0,0,1-15.5-4A103.94,103.94,0,0,1,165,96h39.71L170.34,61.66a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,229.66,109.66ZM192,208H40V88a8,8,0,0,0-16,0V216a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.83,106.83l-48,48a4,4,0,0,1-5.66-5.66L214.34,108H165a92,92,0,0,0-89.11,69A4,4,0,0,1,72,180a3.87,3.87,0,0,1-1-.13A4,4,0,0,1,68.13,175,99.93,99.93,0,0,1,165,100h49.36L173.17,58.83a4,4,0,0,1,5.66-5.66l48,48A4,4,0,0,1,226.83,106.83ZM192,212H36V88a4,4,0,0,0-8,0V216a4,4,0,0,0,4,4H192a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $281c4dbdb34445c4$export$40148c7db598e4e0 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $6fe7ec134a2e7491$export$2e2bcd8739ae039)
    })));
$281c4dbdb34445c4$export$40148c7db598e4e0.displayName = "ShareIcon";
const $281c4dbdb34445c4$export$c9915453de10000b = $281c4dbdb34445c4$export$40148c7db598e4e0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $4858b0c107c10dbf$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,36H48A20,20,0,0,0,28,56v56c0,54.29,26.32,87.22,48.4,105.29,23.71,19.39,47.44,26,48.44,26.29a12.1,12.1,0,0,0,6.32,0c1-.28,24.73-6.9,48.44-26.29,22.08-18.07,48.4-51,48.4-105.29V56A20,20,0,0,0,208,36Zm-4,76c0,35.71-13.09,64.69-38.91,86.15A126.28,126.28,0,0,1,128,219.38a126.14,126.14,0,0,1-37.09-21.23C65.09,176.69,52,147.71,52,112V60H204ZM79.51,144.49a12,12,0,1,1,17-17L112,143l47.51-47.52a12,12,0,0,1,17,17l-56,56a12,12,0,0,1-17,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56v56c0,96-88,120-88,120S40,208,40,112V56a8,8,0,0,1,8-8H208A8,8,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm0,72c0,37.07-13.66,67.16-40.6,89.42A129.3,129.3,0,0,1,128,223.62a128.25,128.25,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56,160,0ZM82.34,141.66a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32l-56,56a8,8,0,0,1-11.32,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm-34.32,69.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,42H48A14,14,0,0,0,34,56v56c0,51.94,25.12,83.4,46.2,100.64,22.73,18.6,45.27,24.89,46.22,25.15a6,6,0,0,0,3.16,0c.95-.26,23.49-6.55,46.22-25.15C196.88,195.4,222,163.94,222,112V56A14,14,0,0,0,208,42Zm2,70c0,37.76-13.94,68.39-41.44,91.06A131.17,131.17,0,0,1,128,225.72a130.94,130.94,0,0,1-40.56-22.66C59.94,180.39,46,149.76,46,112V56a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm0,72c0,37.07-13.66,67.16-40.6,89.42A129.3,129.3,0,0,1,128,223.62a128.25,128.25,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56,160,0ZM82.34,141.66a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32l-56,56a8,8,0,0,1-11.32,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,44H48A12,12,0,0,0,36,56v56c0,51.16,24.73,82.12,45.47,99.1,22.4,18.32,44.55,24.5,45.48,24.76a4,4,0,0,0,2.1,0c.93-.26,23.08-6.44,45.48-24.76,20.74-17,45.47-47.94,45.47-99.1V56A12,12,0,0,0,208,44Zm4,68c0,38.44-14.23,69.63-42.29,92.71A132.45,132.45,0,0,1,128,227.82a132.23,132.23,0,0,1-41.71-23.11C58.23,181.63,44,150.44,44,112V56a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-41.17-10.83a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17Z"
        }))
    ]
]);


const $b8a6231e5abb5624$export$da01a61080044588 = $7fPBF.forwardRef((c, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, c), {
        weights: (0, $4858b0c107c10dbf$export$2e2bcd8739ae039)
    })));
$b8a6231e5abb5624$export$da01a61080044588.displayName = "ShieldCheckIcon";
const $b8a6231e5abb5624$export$ff080d18434a146e = $b8a6231e5abb5624$export$da01a61080044588;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0b4cfe2f4b3c9a9c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M76.86,115.54a12,12,0,0,1,15.6-6.68L116,118.28V96a12,12,0,0,1,24,0v22.28l23.54-9.42a12,12,0,0,1,8.92,22.28L147,141.33,161.6,160.8a12,12,0,1,1-19.2,14.4L128,156l-14.4,19.2a12,12,0,1,1-19.2-14.4L109,141.33,83.54,131.14A12,12,0,0,1,76.86,115.54ZM228,56v56c0,54.29-26.32,87.22-48.4,105.29-23.71,19.39-47.44,26-48.44,26.29a12.1,12.1,0,0,1-6.32,0c-1-.28-24.73-6.9-48.44-26.29C54.32,199.22,28,166.29,28,112V56A20,20,0,0,1,48,36H208A20,20,0,0,1,228,56Zm-24,4H52v52c0,35.71,13.09,64.69,38.91,86.15A126.14,126.14,0,0,0,128,219.38a126.28,126.28,0,0,0,37.09-21.23C190.91,176.69,204,147.71,204,112Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56v56c0,96-88,120-88,120S40,208,40,112V56a8,8,0,0,1,8-8H208A8,8,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80.57,117A8,8,0,0,1,91,112.57l29,11.61V96a8,8,0,0,1,16,0v28.18l29-11.61A8,8,0,1,1,171,127.43l-30.31,12.12L158.4,163.2a8,8,0,1,1-12.8,9.6L128,149.33,110.4,172.8a8,8,0,1,1-12.8-9.6l17.74-23.65L85,127.43A8,8,0,0,1,80.57,117ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.27,47,25.53a8,8,0,0,0,4.2,0c1-.26,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm-37,87.43-30.31,12.12L158.4,163.2a8,8,0,1,1-12.8,9.6L128,149.33,110.4,172.8a8,8,0,1,1-12.8-9.6l17.74-23.65L85,127.43A8,8,0,1,1,91,112.57l29,11.61V96a8,8,0,0,1,16,0v28.18l29-11.61A8,8,0,1,1,171,127.43Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M173.57,117.77a6,6,0,0,1-3.34,7.8L137.5,138.66l19.3,25.74a6,6,0,0,1-9.6,7.2L128,146l-19.2,25.6a6,6,0,1,1-9.6-7.2l19.3-25.74L85.77,125.57a6,6,0,0,1,4.46-11.14L122,127.14V96a6,6,0,0,1,12,0v31.14l31.77-12.71A6,6,0,0,1,173.57,117.77ZM222,56v56c0,51.94-25.12,83.4-46.2,100.64-22.73,18.6-45.27,24.89-46.22,25.15a6,6,0,0,1-3.16,0c-1-.26-23.49-6.55-46.22-25.15C59.12,195.4,34,163.94,34,112V56A14,14,0,0,1,48,42H208A14,14,0,0,1,222,56Zm-12,0a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2v56c0,37.75,13.94,68.39,41.44,91.06A130.94,130.94,0,0,0,128,225.72a131.17,131.17,0,0,0,40.56-22.66C196.06,180.39,210,149.75,210,112Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80.57,117A8,8,0,0,1,91,112.57l29,11.61V96a8,8,0,0,1,16,0v28.18l29-11.61A8,8,0,1,1,171,127.43l-30.31,12.12L158.4,163.2a8,8,0,1,1-12.8,9.6L128,149.33,110.4,172.8a8,8,0,1,1-12.8-9.6l17.74-23.65L85,127.43A8,8,0,0,1,80.57,117ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M171.71,118.51a4,4,0,0,1-2.22,5.2l-35.16,14.07L155.2,165.6a4,4,0,1,1-6.4,4.8L128,142.67,107.2,170.4a4,4,0,0,1-6.4-4.8l20.87-27.82L86.51,123.71a4,4,0,1,1,3-7.42L124,130.09V96a4,4,0,0,1,8,0v34.09l34.51-13.8A4,4,0,0,1,171.71,118.51ZM220,56v56c0,51.16-24.73,82.12-45.47,99.1-22.4,18.32-44.55,24.5-45.48,24.76a4,4,0,0,1-2.1,0c-.93-.26-23.08-6.44-45.48-24.76C60.73,194.12,36,163.16,36,112V56A12,12,0,0,1,48,44H208A12,12,0,0,1,220,56Zm-8,0a4,4,0,0,0-4-4H48a4,4,0,0,0-4,4v56c0,38.44,14.23,69.63,42.29,92.71A132.23,132.23,0,0,0,128,227.82a132.45,132.45,0,0,0,41.71-23.11C197.77,181.63,212,150.44,212,112Z"
        }))
    ]
]);


const $380b00235de4079c$export$2d4a0edcdd78d72c = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $0b4cfe2f4b3c9a9c$export$2e2bcd8739ae039)
    })));
$380b00235de4079c$export$2d4a0edcdd78d72c.displayName = "ShieldStarIcon";
const $380b00235de4079c$export$b6b65c1d96069232 = $380b00235de4079c$export$2d4a0edcdd78d72c;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $42ffe9de9dab4fec$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36ZM44,60H76V196H44ZM212,196H100V60H212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M88,48V208H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H80V200H40ZM216,200H96V56H216V200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H88V56H216V200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42ZM38,200V56a2,2,0,0,1,2-2H82V202H40A2,2,0,0,1,38,200Zm180,0a2,2,0,0,1-2,2H94V54H216a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H80V200H40ZM216,200H96V56H216V200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44ZM36,200V56a4,4,0,0,1,4-4H84V204H40A4,4,0,0,1,36,200Zm184,0a4,4,0,0,1-4,4H92V52H216a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $275efacd365e2acb$export$717f5d3c6bfa9f5e = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $42ffe9de9dab4fec$export$2e2bcd8739ae039)
    })));
$275efacd365e2acb$export$717f5d3c6bfa9f5e.displayName = "SidebarSimpleIcon";
const $275efacd365e2acb$export$746d1bc00421e1a1 = $275efacd365e2acb$export$717f5d3c6bfa9f5e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $27387059d51822ae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M124,216a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V40A12,12,0,0,1,48,28h64a12,12,0,0,1,0,24H60V204h52A12,12,0,0,1,124,216Zm108.49-96.49-40-40a12,12,0,0,0-17,17L195,116H112a12,12,0,0,0,0,24h83l-19.52,19.51a12,12,0,0,0,17,17l40-40A12,12,0,0,0,232.49,119.51Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V200a16,16,0,0,1-16,16H48V40H208A16,16,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40A8,8,0,0,0,176,88v32H112a8,8,0,0,0,0,16h64v32a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,229.66,122.34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M118,216a6,6,0,0,1-6,6H48a6,6,0,0,1-6-6V40a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H54V210h58A6,6,0,0,1,118,216Zm110.24-92.24-40-40a6,6,0,0,0-8.48,8.48L209.51,122H112a6,6,0,0,0,0,12h97.51l-29.75,29.76a6,6,0,1,0,8.48,8.48l40-40A6,6,0,0,0,228.24,123.76Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,216a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H52V212h60A4,4,0,0,1,116,216Zm110.83-90.83-40-40a4,4,0,0,0-5.66,5.66L214.34,124H112a4,4,0,0,0,0,8H214.34l-33.17,33.17a4,4,0,0,0,5.66,5.66l40-40A4,4,0,0,0,226.83,125.17Z"
        }))
    ]
]);


const $91f7b26fb1a24ddc$export$5bb2595dc31bfece = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $27387059d51822ae$export$2e2bcd8739ae039)
    })));
$91f7b26fb1a24ddc$export$5bb2595dc31bfece.displayName = "SignOutIcon";
const $91f7b26fb1a24ddc$export$8bdd9b9a27ab4764 = $91f7b26fb1a24ddc$export$5bb2595dc31bfece;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9bf2e1cb9d8049c3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M199,125.31l-49.88-18.39L130.69,57a19.92,19.92,0,0,0-37.38,0L74.92,106.92,25,125.31a19.92,19.92,0,0,0,0,37.38l49.88,18.39L93.31,231a19.92,19.92,0,0,0,37.38,0l18.39-49.88L199,162.69a19.92,19.92,0,0,0,0-37.38Zm-63.38,35.16a12,12,0,0,0-7.11,7.11L112,212.28l-16.47-44.7a12,12,0,0,0-7.11-7.11L43.72,144l44.7-16.47a12,12,0,0,0,7.11-7.11L112,75.72l16.47,44.7a12,12,0,0,0,7.11,7.11L180.28,144ZM140,40a12,12,0,0,1,12-12h12V16a12,12,0,0,1,24,0V28h12a12,12,0,0,1,0,24H188V64a12,12,0,0,1-24,0V52H152A12,12,0,0,1,140,40ZM252,88a12,12,0,0,1-12,12h-4v4a12,12,0,0,1-24,0v-4h-4a12,12,0,0,1,0-24h4V72a12,12,0,0,1,24,0v4h4A12,12,0,0,1,252,88Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M194.82,151.43l-55.09,20.3-20.3,55.09a7.92,7.92,0,0,1-14.86,0l-20.3-55.09-55.09-20.3a7.92,7.92,0,0,1,0-14.86l55.09-20.3,20.3-55.09a7.92,7.92,0,0,1,14.86,0l20.3,55.09,55.09,20.3A7.92,7.92,0,0,1,194.82,151.43Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,144a15.78,15.78,0,0,1-10.42,14.94L146,178l-19,51.62a15.92,15.92,0,0,1-29.88,0L78,178l-51.62-19a15.92,15.92,0,0,1,0-29.88L78,110l19-51.62a15.92,15.92,0,0,1,29.88,0L146,110l51.62,19A15.78,15.78,0,0,1,208,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.89,130.94,144.4,111.6,125.06,59.11a13.92,13.92,0,0,0-26.12,0L79.6,111.6,27.11,130.94a13.92,13.92,0,0,0,0,26.12L79.6,176.4l19.34,52.49a13.92,13.92,0,0,0,26.12,0L144.4,176.4l52.49-19.34a13.92,13.92,0,0,0,0-26.12Zm-4.15,14.86-55.08,20.3a6,6,0,0,0-3.56,3.56l-20.3,55.08a1.92,1.92,0,0,1-3.6,0L89.9,169.66a6,6,0,0,0-3.56-3.56L31.26,145.8a1.92,1.92,0,0,1,0-3.6l55.08-20.3a6,6,0,0,0,3.56-3.56l20.3-55.08a1.92,1.92,0,0,1,3.6,0l20.3,55.08a6,6,0,0,0,3.56,3.56l55.08,20.3a1.92,1.92,0,0,1,0,3.6ZM146,40a6,6,0,0,1,6-6h18V16a6,6,0,0,1,12,0V34h18a6,6,0,0,1,0,12H182V64a6,6,0,0,1-12,0V46H152A6,6,0,0,1,146,40ZM246,88a6,6,0,0,1-6,6H230v10a6,6,0,0,1-12,0V94H208a6,6,0,0,1,0-12h10V72a6,6,0,0,1,12,0V82h10A6,6,0,0,1,246,88Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M196.2,132.81l-53.36-19.65L123.19,59.8a11.93,11.93,0,0,0-22.38,0L81.16,113.16,27.8,132.81a11.93,11.93,0,0,0,0,22.38l53.36,19.65,19.65,53.36a11.93,11.93,0,0,0,22.38,0l19.65-53.36,53.36-19.65a11.93,11.93,0,0,0,0-22.38Zm-2.77,14.87L138.35,168a4,4,0,0,0-2.37,2.37l-20.3,55.08a3.92,3.92,0,0,1-7.36,0L88,170.35A4,4,0,0,0,85.65,168l-55.08-20.3a3.92,3.92,0,0,1,0-7.36L85.65,120A4,4,0,0,0,88,117.65l20.3-55.08a3.92,3.92,0,0,1,7.36,0L136,117.65a4,4,0,0,0,2.37,2.37l55.08,20.3a3.92,3.92,0,0,1,0,7.36ZM148,40a4,4,0,0,1,4-4h20V16a4,4,0,0,1,8,0V36h20a4,4,0,0,1,0,8H180V64a4,4,0,0,1-8,0V44H152A4,4,0,0,1,148,40Zm96,48a4,4,0,0,1-4,4H228v12a4,4,0,0,1-8,0V92H208a4,4,0,0,1,0-8h12V72a4,4,0,0,1,8,0V84h12A4,4,0,0,1,244,88Z"
        }))
    ]
]);


const $8899997e3fc20429$export$1019ff5537a7252e = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $9bf2e1cb9d8049c3$export$2e2bcd8739ae039)
    })));
$8899997e3fc20429$export$1019ff5537a7252e.displayName = "SparkleIcon";
const $8899997e3fc20429$export$d350d3100fdc0b49 = $8899997e3fc20429$export$1019ff5537a7252e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e0d4ef5bb1c55d5b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M157.27,21.22a12,12,0,0,0-12.64,1.31L75.88,76H32A20,20,0,0,0,12,96v64a20,20,0,0,0,20,20H75.88l68.75,53.47A12,12,0,0,0,164,224V32A12,12,0,0,0,157.27,21.22ZM36,100H68v56H36Zm104,99.46L92,162.13V93.87l48-37.33ZM212,128a44,44,0,0,1-11,29.11,12,12,0,1,1-18-15.88,20,20,0,0,0,0-26.43,12,12,0,0,1,18-15.86A43.94,43.94,0,0,1,212,128Zm40,0a83.87,83.87,0,0,1-21.39,56,12,12,0,0,1-17.89-16,60,60,0,0,0,0-80,12,12,0,1,1,17.88-16A83.87,83.87,0,0,1,252,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,88v80H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M155.51,24.81a8,8,0,0,0-8.42.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V32A8,8,0,0,0,155.51,24.81ZM32,96H72v64H32ZM144,207.64,88,164.09V91.91l56-43.55Zm54-106.08a40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.58,24,24,0,0,0,0-31.72,8,8,0,0,1,12-10.58ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,32.25V223.69a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.57-51A4,4,0,0,1,80,176.16V79.84a4,4,0,0,1,1.55-3.15l65.57-51a8,8,0,0,1,10,.16A8.27,8.27,0,0,1,160,32.25ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Zm126.77,20.84a8,8,0,0,0-.72,11.3,24,24,0,0,1,0,31.72,8,8,0,1,0,12,10.58,40,40,0,0,0,0-52.88A8,8,0,0,0,186.74,100.84Zm40.89-26.17a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M154.64,26.61a6,6,0,0,0-6.32.65L77.94,82H32A14,14,0,0,0,18,96v64a14,14,0,0,0,14,14H77.94l70.38,54.74A6,6,0,0,0,158,224V32A6,6,0,0,0,154.64,26.61ZM30,160V96a2,2,0,0,1,2-2H74v68H32A2,2,0,0,1,30,160Zm116,51.73L86,165.07V90.93l60-46.66Zm50.53-108.85a38,38,0,0,1,0,50.24,6,6,0,1,1-9-7.94,26,26,0,0,0,0-34.37,6,6,0,0,1,9-7.93ZM246,128a77.86,77.86,0,0,1-19.86,52,6,6,0,1,1-8.94-8,66,66,0,0,0,0-88,6,6,0,1,1,8.94-8A77.86,77.86,0,0,1,246,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M155.51,24.81a8,8,0,0,0-8.42.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V32A8,8,0,0,0,155.51,24.81ZM32,96H72v64H32ZM144,207.64,88,164.09V91.91l56-43.55Zm54-106.08a40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.58,24,24,0,0,0,0-31.72,8,8,0,0,1,12-10.58ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M153.76,28.41a4,4,0,0,0-4.22.43L78.63,84H32A12,12,0,0,0,20,96v64a12,12,0,0,0,12,12H78.63l70.91,55.16A4.07,4.07,0,0,0,152,228a3.92,3.92,0,0,0,1.76-.41A4,4,0,0,0,156,224V32A4,4,0,0,0,153.76,28.41ZM28,160V96a4,4,0,0,1,4-4H76v72H32A4,4,0,0,1,28,160Zm120,55.82L84,166V90l64-49.78Zm47-111.61a36,36,0,0,1,0,47.59,4,4,0,1,1-6-5.3,28,28,0,0,0,0-37,4,4,0,0,1,6-5.28ZM244,128a75.88,75.88,0,0,1-19.35,50.67,4,4,0,0,1-6-5.34,68,68,0,0,0,0-90.66,4,4,0,0,1,6-5.34A75.88,75.88,0,0,1,244,128Z"
        }))
    ]
]);


const $0972bbebf39666e5$export$951b168b9ecc05fb = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $e0d4ef5bb1c55d5b$export$2e2bcd8739ae039)
    })));
$0972bbebf39666e5$export$951b168b9ecc05fb.displayName = "SpeakerHighIcon";
const $0972bbebf39666e5$export$72b5f9f618bcd07d = $0972bbebf39666e5$export$951b168b9ecc05fb;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7fa1d8e4c3340448$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,36H56A20,20,0,0,0,36,56V200a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-60,64h56v16H140Zm0,40h56v16H140Zm56-64H140V60h56ZM60,60h56V196H60Zm80,136V180h56v16Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56V200a8,8,0,0,1-8,8H128V48h72A8,8,0,0,1,208,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40ZM56,56h64V200H56ZM200,200H136V56h64V200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40ZM56,56h72V200H56Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,42H56A14,14,0,0,0,42,56V200a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm-66,76h68v20H134Zm0-12V86h68v20Zm0,44h68v20H134Zm68-94V74H134V54h66A2,2,0,0,1,202,56ZM54,200V56a2,2,0,0,1,2-2h66V202H56A2,2,0,0,1,54,200Zm146,2H134V182h68v18A2,2,0,0,1,200,202Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm-64,80h64v16H136Zm0-16V88h64v16Zm0,48h64v16H136Zm64-80H136V56h64ZM56,56h64V200H56ZM200,200H136V184h64v16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,44H56A12,12,0,0,0,44,56V200a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm-68,72h72v24H132Zm0-8V84h72v24Zm0,40h72v24H132Zm72-92V76H132V52h68A4,4,0,0,1,204,56ZM52,200V56a4,4,0,0,1,4-4h68V204H56A4,4,0,0,1,52,200Zm148,4H132V180h72v20A4,4,0,0,1,200,204Z"
        }))
    ]
]);


const $5fffe8c4dc33c750$export$8e4e0663d737f944 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $7fa1d8e4c3340448$export$2e2bcd8739ae039)
    })));
$5fffe8c4dc33c750$export$8e4e0663d737f944.displayName = "SquareHalfIcon";
const $5fffe8c4dc33c750$export$4f91063f4b4992b2 = $5fffe8c4dc33c750$export$8e4e0663d737f944;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $cad6c7dad7d6db52$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100,36H56A20,20,0,0,0,36,56v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,100,36ZM96,96H60V60H96ZM200,36H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,60H160V60h36Zm-96,40H56a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,100,136Zm-4,60H60V160H96Zm104-60H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,200,136Zm-4,60H160V160h36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M112,56v48a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h48A8,8,0,0,1,112,56Zm88-8H152a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V56A8,8,0,0,0,200,48Zm-96,96H56a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V152A8,8,0,0,0,104,144Zm96,0H152a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V152A8,8,0,0,0,200,144Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,136H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48v48ZM104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-96,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,56v48a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40h48A16,16,0,0,1,120,56Zm80-16H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm-96,96H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm96,0H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,42H56A14,14,0,0,0,42,56v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V56A14,14,0,0,0,104,42Zm2,62a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm94-62H152a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm2,62a2,2,0,0,1-2,2H152a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm-98,34H56a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V152A14,14,0,0,0,104,138Zm2,62a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V152a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Zm94-62H152a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14h48a14,14,0,0,0,14-14V152A14,14,0,0,0,200,138Zm2,62a2,2,0,0,1-2,2H152a2,2,0,0,1-2-2V152a2,2,0,0,1,2-2h48a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,40H56A16,16,0,0,0,40,56v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,104,40Zm0,64H56V56h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,64H152V56h48v48Zm-96,32H56a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,104,136Zm0,64H56V152h48v48Zm96-64H152a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V152A16,16,0,0,0,200,136Zm0,64H152V152h48v48Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M104,44H56A12,12,0,0,0,44,56v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V56A12,12,0,0,0,104,44Zm4,60a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Zm92-60H152a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm4,60a4,4,0,0,1-4,4H152a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4ZM104,140H56a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V152A12,12,0,0,0,104,140Zm4,60a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V152a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Zm92-60H152a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12h48a12,12,0,0,0,12-12V152A12,12,0,0,0,200,140Zm4,60a4,4,0,0,1-4,4H152a4,4,0,0,1-4-4V152a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $ffc30300995f8d60$export$aa8679e33ed2ffa0 = $7fPBF.forwardRef((e, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, e), {
        weights: (0, $cad6c7dad7d6db52$export$2e2bcd8739ae039)
    })));
$ffc30300995f8d60$export$aa8679e33ed2ffa0.displayName = "SquaresFourIcon";
const $ffc30300995f8d60$export$efa0fa8f18fa8e5a = $ffc30300995f8d60$export$aa8679e33ed2ffa0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $890b1c36b36ed348$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234.36,170A12,12,0,0,1,230,186.37l-96,56a12,12,0,0,1-12.1,0l-96-56a12,12,0,0,1,12.09-20.74l90,52.48L218,165.63A12,12,0,0,1,234.36,170ZM218,117.63,128,170.11,38.05,117.63A12,12,0,0,0,26,138.37l96,56a12,12,0,0,0,12.1,0l96-56A12,12,0,0,0,218,117.63ZM20,80a12,12,0,0,1,6-10.37l96-56a12.06,12.06,0,0,1,12.1,0l96,56a12,12,0,0,1,0,20.74l-96,56a12,12,0,0,1-12.1,0l-96-56A12,12,0,0,1,20,80Zm35.82,0L128,122.11,200.18,80,128,37.89Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80l-96,56L32,80l96-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,172A8,8,0,0,1,228,182.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,169.09l92,53.65,92-53.65A8,8,0,0,1,230.91,172ZM220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,169.09l-92,53.65L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,169.09Z"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09Z"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M28,86.91l96,56a8,8,0,0,0,8.06,0l96-56a8,8,0,0,0,0-13.82l-96-56a8,8,0,0,0-8.06,0l-96,56a8,8,0,0,0,0,13.82Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.18,173a6,6,0,0,1-2.16,8.2l-96,56a6,6,0,0,1-6,0l-96-56a6,6,0,0,1,6-10.36l93,54.23,93-54.23A6,6,0,0,1,229.18,173ZM221,122.82l-93,54.23L35,122.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l96-56a6,6,0,0,0-6-10.36ZM26,80a6,6,0,0,1,3-5.18l96-56a6,6,0,0,1,6,0l96,56a6,6,0,0,1,0,10.36l-96,56a6,6,0,0,1-6,0l-96-56A6,6,0,0,1,26,80Zm17.91,0L128,129.05,212.09,80,128,31Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,172A8,8,0,0,1,228,182.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,169.09l92,53.65,92-53.65A8,8,0,0,1,230.91,172ZM220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.45,174a4,4,0,0,1-1.44,5.48l-96,56a4,4,0,0,1-4,0l-96-56a4,4,0,0,1,4-6.92l94,54.83,94-54.83A4,4,0,0,1,227.45,174ZM222,124.54l-94,54.83L34,124.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l96-56a4,4,0,0,0-4-6.92ZM28,80a4,4,0,0,1,2-3.46l96-56a4,4,0,0,1,4,0l96,56a4,4,0,0,1,0,6.92l-96,56a4,4,0,0,1-4,0l-96-56A4,4,0,0,1,28,80Zm11.94,0L128,131.37,216.06,80,128,28.63Z"
        }))
    ]
]);


const $23259387cb66f7b3$export$f95b8a41f9121b54 = $7fPBF.forwardRef((a, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, a), {
        weights: (0, $890b1c36b36ed348$export$2e2bcd8739ae039)
    })));
$23259387cb66f7b3$export$f95b8a41f9121b54.displayName = "StackIcon";
const $23259387cb66f7b3$export$694e0d28c7ffc90c = $23259387cb66f7b3$export$f95b8a41f9121b54;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $55de31233c3e3c07$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a12,12,0,0,1-12,12H188a12,12,0,0,1,0-24h40A12,12,0,0,1,240,200ZM218,117.63,128,170.11,38.05,117.63A12,12,0,0,0,26,138.37l96,56a12,12,0,0,0,12.1,0l96-56A12,12,0,1,0,218,117.63ZM20,80a12,12,0,0,1,6-10.37l96-56a12.06,12.06,0,0,1,12.1,0l96,56a12,12,0,0,1,0,20.74l-96,56a12,12,0,0,1-12.1,0l-96-56A12,12,0,0,1,20,80Zm35.82,0L128,122.11,200.18,80,128,37.89ZM138,212.3,128,218.11,38.05,165.63A12,12,0,0,0,26,186.37l96,56a12,12,0,0,0,12.1,0l16-9.34A12,12,0,1,0,138,212.3Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80l-96,56L32,80l96-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16h48A8,8,0,0,1,240,200Zm-20-78.91-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM140,215.76l-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM28,86.91l96,56a8,8,0,0,0,8.06,0l96-56a8,8,0,0,0,0-13.82l-96-56a8,8,0,0,0-8.06,0l-96,56a8,8,0,0,0,0,13.82ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238,200a6,6,0,0,1-6,6H184a6,6,0,0,1,0-12h48A6,6,0,0,1,238,200Zm-17-77.18-93,54.23L35,122.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l96-56a6,6,0,0,0-6-10.36ZM26,80a6,6,0,0,1,3-5.18l96-56a6,6,0,0,1,6,0l96,56a6,6,0,0,1,0,10.36l-96,56a6,6,0,0,1-6,0l-96-56A6,6,0,0,1,26,80Zm17.91,0L128,129.05,212.09,80,128,31ZM141,217.48l-13,7.57L35,170.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l16-9.33a6,6,0,0,0-6-10.37Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,200a4,4,0,0,1-4,4H184a4,4,0,0,1,0-8h48A4,4,0,0,1,236,200Zm-14-75.46-94,54.83L34,124.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l96-56a4,4,0,1,0-4-6.92ZM28,80a4,4,0,0,1,2-3.46l96-56a4,4,0,0,1,4,0l96,56a4,4,0,0,1,0,6.92l-96,56a4,4,0,0,1-4,0l-96-56A4,4,0,0,1,28,80Zm11.94,0L128,131.37,216.06,80,128,28.63ZM142,219.21l-14,8.16L34,172.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l16-9.34a4,4,0,1,0-4-6.91Z"
        }))
    ]
]);


const $543fda4ac58ac75f$export$12a3823f287db803 = $7fPBF.forwardRef((a, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, a), {
        weights: (0, $55de31233c3e3c07$export$2e2bcd8739ae039)
    })));
$543fda4ac58ac75f$export$12a3823f287db803.displayName = "StackMinusIcon";
const $543fda4ac58ac75f$export$1fcf57074d882402 = $543fda4ac58ac75f$export$12a3823f287db803;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $064bc1fef11ad125$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a12,12,0,0,1-12,12h-8v8a12,12,0,0,1-24,0v-8h-8a12,12,0,0,1,0-24h8v-8a12,12,0,0,1,24,0v8h8A12,12,0,0,1,240,200ZM218,117.63,128,170.11,38.05,117.63A12,12,0,0,0,26,138.37l96,56a12,12,0,0,0,12.1,0l96-56A12,12,0,1,0,218,117.63ZM20,80a12,12,0,0,1,6-10.37l96-56a12.06,12.06,0,0,1,12.1,0l96,56a12,12,0,0,1,0,20.74l-96,56a12,12,0,0,1-12.1,0l-96-56A12,12,0,0,1,20,80Zm35.82,0L128,122.11,200.18,80,128,37.89ZM138,212.3,128,218.11,38.05,165.63A12,12,0,0,0,26,186.37l96,56a12,12,0,0,0,12.1,0l16-9.34A12,12,0,1,0,138,212.3Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,80l-96,56L32,80l96-56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240,200a8,8,0,0,1-8,8H216v16a8,8,0,0,1-16,0V208H184a8,8,0,0,1,0-16h16V176a8,8,0,0,1,16,0v16h16A8,8,0,0,1,240,200Zm-20-78.91-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM140,215.76l-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm196,41.09-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238,200a6,6,0,0,1-6,6H214v18a6,6,0,0,1-12,0V206H184a6,6,0,0,1,0-12h18V176a6,6,0,0,1,12,0v18h18A6,6,0,0,1,238,200Zm-17-77.18-93,54.23L35,122.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l96-56a6,6,0,0,0-6-10.36ZM26,80a6,6,0,0,1,3-5.18l96-56a6,6,0,0,1,6,0l96,56a6,6,0,0,1,0,10.36l-96,56a6,6,0,0,1-6,0l-96-56A6,6,0,0,1,26,80Zm17.91,0L128,129.05,212.09,80,128,31ZM141,217.48l-13,7.57L35,170.82a6,6,0,0,0-6,10.36l96,56a6,6,0,0,0,6,0l16-9.33a6,6,0,0,0-6-10.37Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236,200a4,4,0,0,1-4,4H212v20a4,4,0,0,1-8,0V204H184a4,4,0,0,1,0-8h20V176a4,4,0,0,1,8,0v20h20A4,4,0,0,1,236,200Zm-14-75.46-94,54.83L34,124.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l96-56a4,4,0,1,0-4-6.92ZM28,80a4,4,0,0,1,2-3.46l96-56a4,4,0,0,1,4,0l96,56a4,4,0,0,1,0,6.92l-96,56a4,4,0,0,1-4,0l-96-56A4,4,0,0,1,28,80Zm11.94,0L128,131.37,216.06,80,128,28.63ZM142,219.21l-14,8.16L34,172.54a4,4,0,0,0-4,6.92l96,56a4,4,0,0,0,4,0l16-9.34a4,4,0,1,0-4-6.91Z"
        }))
    ]
]);


const $3ae7f63f5859902d$export$64702cae849e08a7 = $7fPBF.forwardRef((a, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, a), {
        weights: (0, $064bc1fef11ad125$export$2e2bcd8739ae039)
    })));
$3ae7f63f5859902d$export$64702cae849e08a7.displayName = "StackPlusIcon";
const $3ae7f63f5859902d$export$25792c5f07b8abcb = $3ae7f63f5859902d$export$64702cae849e08a7;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b8bda78a70ac8cd8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243,96a20.33,20.33,0,0,0-17.74-14l-56.59-4.57L146.83,24.62a20.36,20.36,0,0,0-37.66,0L87.35,77.44,30.76,82A20.45,20.45,0,0,0,19.1,117.88l43.18,37.24-13.2,55.7A20.37,20.37,0,0,0,79.57,233L128,203.19,176.43,233a20.39,20.39,0,0,0,30.49-22.15l-13.2-55.7,43.18-37.24A20.43,20.43,0,0,0,243,96ZM172.53,141.7a12,12,0,0,0-3.84,11.86L181.58,208l-47.29-29.08a12,12,0,0,0-12.58,0L74.42,208l12.89-54.4a12,12,0,0,0-3.84-11.86L41.2,105.24l55.4-4.47a12,12,0,0,0,10.13-7.38L128,41.89l21.27,51.5a12,12,0,0,0,10.13,7.38l55.4,4.47Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M229.06,108.79l-48.7,42,14.88,62.79a8.4,8.4,0,0,1-12.52,9.17L128,189.09,73.28,222.74a8.4,8.4,0,0,1-12.52-9.17l14.88-62.79-48.7-42A8.46,8.46,0,0,1,31.73,94L95.64,88.8l24.62-59.6a8.36,8.36,0,0,1,15.48,0l24.62,59.6L224.27,94A8.46,8.46,0,0,1,229.06,108.79Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234.29,114.85l-45,38.83L203,211.75a16.4,16.4,0,0,1-24.5,17.82L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,59,4.76a16.46,16.46,0,0,1,9.37,28.86Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M237.28,97.87A14.18,14.18,0,0,0,224.76,88l-60.25-4.87-23.22-56.2a14.37,14.37,0,0,0-26.58,0L91.49,83.11,31.24,88a14.18,14.18,0,0,0-12.52,9.89A14.43,14.43,0,0,0,23,113.32L69,152.93l-14,59.25a14.4,14.4,0,0,0,5.59,15,14.1,14.1,0,0,0,15.91.6L128,196.12l51.58,31.71a14.1,14.1,0,0,0,15.91-.6,14.4,14.4,0,0,0,5.59-15l-14-59.25L233,113.32A14.43,14.43,0,0,0,237.28,97.87Zm-12.14,6.37-48.69,42a6,6,0,0,0-1.92,5.92l14.88,62.79a2.35,2.35,0,0,1-.95,2.57,2.24,2.24,0,0,1-2.6.1L131.14,184a6,6,0,0,0-6.28,0L70.14,217.61a2.24,2.24,0,0,1-2.6-.1,2.35,2.35,0,0,1-1-2.57l14.88-62.79a6,6,0,0,0-1.92-5.92l-48.69-42a2.37,2.37,0,0,1-.73-2.65,2.28,2.28,0,0,1,2.07-1.65l63.92-5.16a6,6,0,0,0,5.06-3.69l24.63-59.6a2.35,2.35,0,0,1,4.38,0l24.63,59.6a6,6,0,0,0,5.06,3.69l63.92,5.16a2.28,2.28,0,0,1,2.07,1.65A2.37,2.37,0,0,1,225.14,104.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M235.36,98.49A12.21,12.21,0,0,0,224.59,90l-61.47-5L139.44,27.67a12.37,12.37,0,0,0-22.88,0L92.88,85,31.41,90a12.45,12.45,0,0,0-7.07,21.84l46.85,40.41L56.87,212.64a12.35,12.35,0,0,0,18.51,13.49L128,193.77l52.62,32.36a12.12,12.12,0,0,0,13.69-.51,12.28,12.28,0,0,0,4.82-13l-14.32-60.42,46.85-40.41A12.29,12.29,0,0,0,235.36,98.49Zm-8.93,7.26-48.68,42a4,4,0,0,0-1.28,3.95l14.87,62.79a4.37,4.37,0,0,1-1.72,4.65,4.24,4.24,0,0,1-4.81.18L130.1,185.67a4,4,0,0,0-4.2,0L71.19,219.32a4.24,4.24,0,0,1-4.81-.18,4.37,4.37,0,0,1-1.72-4.65L79.53,151.7a4,4,0,0,0-1.28-3.95l-48.68-42A4.37,4.37,0,0,1,28.25,101a4.31,4.31,0,0,1,3.81-3L96,92.79a4,4,0,0,0,3.38-2.46L124,30.73a4.35,4.35,0,0,1,8.08,0l24.62,59.6A4,4,0,0,0,160,92.79l63.9,5.15a4.31,4.31,0,0,1,3.81,3A4.37,4.37,0,0,1,226.43,105.75Z"
        }))
    ]
]);


const $9564cc79ecb90f47$export$2ee28caa7f1e962e = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, t), {
        weights: (0, $b8bda78a70ac8cd8$export$2e2bcd8739ae039)
    })));
$9564cc79ecb90f47$export$2ee28caa7f1e962e.displayName = "StarIcon";
const $9564cc79ecb90f47$export$1644ba17714857f1 = $9564cc79ecb90f47$export$2ee28caa7f1e962e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b3a9c91e7b72c1a6$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,36H56A20,20,0,0,0,36,56V200a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,160H60V60H196Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,160H56V56H200V200Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,42H56A14,14,0,0,0,42,56V200a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm2,158a2,2,0,0,1-2,2H56a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H200a2,2,0,0,1,2,2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,160H56V56H200V200Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,44H56A12,12,0,0,0,44,56V200a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm4,156a4,4,0,0,1-4,4H56a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H200a4,4,0,0,1,4,4Z"
        }))
    ]
]);


const $9eef48aaff177bbc$export$dc6949a98411e916 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $b3a9c91e7b72c1a6$export$2e2bcd8739ae039)
    })));
$9eef48aaff177bbc$export$dc6949a98411e916.displayName = "StopIcon";
const $9eef48aaff177bbc$export$ac4156b3386a7c70 = $9eef48aaff177bbc$export$dc6949a98411e916;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $361a2e96ed7b58a9$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228,48V152a20,20,0,0,1-20,20H112.92a12,12,0,0,1-17.41,16.49l-20-20a12,12,0,0,1,0-17l20-20A12,12,0,0,1,112.92,148H204V52H100a12,12,0,0,1-24,0V48A20,20,0,0,1,96,28H208A20,20,0,0,1,228,48ZM168,192a12,12,0,0,0-12,12H52V108h91.08a12,12,0,0,0,17.41,16.49l20-20a12,12,0,0,0,0-17l-20-20A12,12,0,0,0,143.08,84H48a20,20,0,0,0-20,20V208a20,20,0,0,0,20,20H160a20,20,0,0,0,20-20v-4A12,12,0,0,0,168,192Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48V152a8,8,0,0,1-8,8H168v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H88V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48V152a16,16,0,0,1-16,16H112v16a8,8,0,0,1-13.66,5.66l-24-24a8,8,0,0,1,0-11.32l24-24A8,8,0,0,1,112,136v16h96V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104h96v16a8,8,0,0,0,13.66,5.66l24-24a8,8,0,0,0,0-11.32l-24-24A8,8,0,0,0,144,72V88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M222,48V152a14,14,0,0,1-14,14H94.49l13.75,13.76a6,6,0,1,1-8.48,8.48l-24-24a6,6,0,0,1,0-8.48l24-24a6,6,0,0,1,8.48,8.48L94.49,154H208a2,2,0,0,0,2-2V48a2,2,0,0,0-2-2H96a2,2,0,0,0-2,2v8a6,6,0,0,1-12,0V48A14,14,0,0,1,96,34H208A14,14,0,0,1,222,48ZM168,194a6,6,0,0,0-6,6v8a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V104a2,2,0,0,1,2-2H161.51l-13.75,13.76a6,6,0,1,0,8.48,8.48l24-24a6,6,0,0,0,0-8.48l-24-24a6,6,0,0,0-8.48,8.48L161.51,90H48a14,14,0,0,0-14,14V208a14,14,0,0,0,14,14H160a14,14,0,0,0,14-14v-8A6,6,0,0,0,168,194Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M220,48V152a12,12,0,0,1-12,12H89.66l17.17,17.17a4,4,0,0,1-5.66,5.66l-24-24a4,4,0,0,1,0-5.66l24-24a4,4,0,0,1,5.66,5.66L89.66,156H208a4,4,0,0,0,4-4V48a4,4,0,0,0-4-4H96a4,4,0,0,0-4,4v8a4,4,0,0,1-8,0V48A12,12,0,0,1,96,36H208A12,12,0,0,1,220,48ZM168,196a4,4,0,0,0-4,4v8a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V104a4,4,0,0,1,4-4H166.34l-17.17,17.17a4,4,0,0,0,5.66,5.66l24-24a4,4,0,0,0,0-5.66l-24-24a4,4,0,0,0-5.66,5.66L166.34,92H48a12,12,0,0,0-12,12V208a12,12,0,0,0,12,12H160a12,12,0,0,0,12-12v-8A4,4,0,0,0,168,196Z"
        }))
    ]
]);


const $0626899a8774a822$export$67f45bdc93ca8e23 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $361a2e96ed7b58a9$export$2e2bcd8739ae039)
    })));
$0626899a8774a822$export$67f45bdc93ca8e23.displayName = "SwapIcon";
const $0626899a8774a822$export$bdb5f0a1b77546f4 = $0626899a8774a822$export$67f45bdc93ca8e23;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c1eea9897ed09900$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,137,48,201A12,12,0,1,1,32,183l61.91-55L32,73A12,12,0,1,1,48,55l72,64A12,12,0,0,1,120,137Zm96,43H120a12,12,0,0,0,0,24h96a12,12,0,0,0,0-24Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,80V192H40V64H200A16,16,0,0,1,216,80Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.31,134l-72,64a8,8,0,1,1-10.63-12L100,128,34.69,70A8,8,0,1,1,45.32,58l72,64a8,8,0,0,1,0,12ZM216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM77.66,173.66a8,8,0,0,1-11.32-11.32L100.69,128,66.34,93.66A8,8,0,0,1,77.66,82.34l40,40a8,8,0,0,1,0,11.32ZM192,176H128a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,132.48l-72,64a6,6,0,0,1-8-9L103,128,36,68.49a6,6,0,0,1,8-9l72,64a6,6,0,0,1,0,9ZM216,186H120a6,6,0,0,0,0,12h96a6,6,0,0,0,0-12Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.31,134l-72,64a8,8,0,1,1-10.63-12L100,128,34.69,70A8,8,0,1,1,45.32,58l72,64a8,8,0,0,1,0,12ZM216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,128a4,4,0,0,1-1.34,3l-72,64a4,4,0,1,1-5.32-6L106,128,37.34,67a4,4,0,0,1,5.32-6l72,64A4,4,0,0,1,116,128Zm100,60H120a4,4,0,0,0,0,8h96a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $af5f4727f2779cea$export$9ff5547afd06adf7 = $7fPBF.forwardRef((r, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, r), {
        weights: (0, $c1eea9897ed09900$export$2e2bcd8739ae039)
    })));
$af5f4727f2779cea$export$9ff5547afd06adf7.displayName = "TerminalIcon";
const $af5f4727f2779cea$export$8dd80f06eb58bfe1 = $af5f4727f2779cea$export$9ff5547afd06adf7;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $9883eaaf5e477b05$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M72.5,150.63,100.79,128,72.5,105.37a12,12,0,1,1,15-18.74l40,32a12,12,0,0,1,0,18.74l-40,32a12,12,0,0,1-15-18.74ZM144,172h32a12,12,0,0,0,0-24H144a12,12,0,0,0,0,24ZM236,56V200a20,20,0,0,1-20,20H40a20,20,0,0,1-20-20V56A20,20,0,0,1,40,36H216A20,20,0,0,1,236,56Zm-24,4H44V196H212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,128a8,8,0,0,1-3,6.25l-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32A8,8,0,0,1,128,128Zm48,24H136a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm56-96V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-91,94.25-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32a8,8,0,0,1,0,12.5ZM176,168H136a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M126,128a6,6,0,0,1-2.25,4.69l-40,32a6,6,0,0,1-7.5-9.38L110.4,128,76.25,100.69a6,6,0,1,1,7.5-9.38l40,32A6,6,0,0,1,126,128Zm50,26H136a6,6,0,0,0,0,12h40a6,6,0,0,0,0-12Zm54-98V200a14,14,0,0,1-14,14H40a14,14,0,0,1-14-14V56A14,14,0,0,1,40,42H216A14,14,0,0,1,230,56Zm-12,0a2,2,0,0,0-2-2H40a2,2,0,0,0-2,2V200a2,2,0,0,0,2,2H216a2,2,0,0,0,2-2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,128a8,8,0,0,1-3,6.25l-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32A8,8,0,0,1,128,128Zm48,24H136a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm56-96V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M122.5,124.88a4,4,0,0,1,0,6.24l-40,32a4,4,0,0,1-5-6.24L113.6,128,77.5,99.12a4,4,0,0,1,5-6.24ZM176,156H136a4,4,0,0,0,0,8h40a4,4,0,0,0,0-8ZM228,56V200a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V56A12,12,0,0,1,40,44H216A12,12,0,0,1,228,56Zm-8,0a4,4,0,0,0-4-4H40a4,4,0,0,0-4,4V200a4,4,0,0,0,4,4H216a4,4,0,0,0,4-4Z"
        }))
    ]
]);


const $e673841d74d2fd8a$export$8ee6b256df317f28 = $7fPBF.forwardRef((r, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: n
    }, r), {
        weights: (0, $9883eaaf5e477b05$export$2e2bcd8739ae039)
    })));
$e673841d74d2fd8a$export$8ee6b256df317f28.displayName = "TerminalWindowIcon";
const $e673841d74d2fd8a$export$6d10593dc8290a13 = $e673841d74d2fd8a$export$8ee6b256df317f28;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $646424caf90d5bb4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M90.86,50.89a12,12,0,0,0-21.72,0l-64,136a12,12,0,0,0,21.71,10.22L42.44,164h75.12l15.58,33.11a12,12,0,0,0,21.72-10.22ZM53.74,140,80,84.18,106.27,140ZM200,84c-13.85,0-24.77,3.86-32.45,11.48a12,12,0,1,0,16.9,17c3-3,8.26-4.52,15.55-4.52,11,0,20,7.18,20,16v4.39A47.28,47.28,0,0,0,200,124c-24.26,0-44,17.94-44,40s19.74,40,44,40a47.18,47.18,0,0,0,22-5.38A12,12,0,0,0,244,192V124C244,101.94,224.26,84,200,84Zm0,96c-11,0-20-7.18-20-16s9-16,20-16,20,7.18,20,16S211,180,200,180Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,164c0,15.46-14.33,28-32,28s-32-12.54-32-28,14.33-28,32-28S232,148.54,232,164ZM34.82,152h90.36L80,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M87.24,52.59a8,8,0,0,0-14.48,0l-64,136a8,8,0,1,0,14.48,6.81L39.9,160h80.2l16.66,35.4a8,8,0,1,0,14.48-6.81ZM47.43,144,80,74.79,112.57,144ZM200,96c-12.76,0-22.73,3.47-29.63,10.32a8,8,0,0,0,11.26,11.36c3.8-3.77,10-5.68,18.37-5.68,13.23,0,24,9,24,20v3.22A42.76,42.76,0,0,0,200,128c-22.06,0-40,16.15-40,36s17.94,36,40,36a42.73,42.73,0,0,0,24-7.25,8,8,0,0,0,16-.75V132C240,112.15,222.06,96,200,96Zm0,88c-13.23,0-24-9-24-20s10.77-20,24-20,24,9,24,20S213.23,184,200,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,156c0,6.5-7.33,12-16,12s-16-5.5-16-12,7.33-12,16-12S200,149.5,200,156ZM232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM143.37,172.88l-44-104a8,8,0,0,0-14.74,0l-44,104a8,8,0,0,0,14.74,6.24L66.84,152h50.32l11.47,27.12a8,8,0,0,0,14.74-6.24ZM216,124c0-15.44-14.36-28-32-28a34.86,34.86,0,0,0-20.78,6.68,8,8,0,0,0,9.56,12.83A18.84,18.84,0,0,1,184,112c8.56,0,15.8,5.36,16,11.76v8A35.24,35.24,0,0,0,184,128c-17.64,0-32,12.56-32,28s14.36,28,32,28a35.13,35.13,0,0,0,16.93-4.26A8,8,0,0,0,216,176ZM73.61,136h36.78L92,92.53Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M85.43,53.45a6,6,0,0,0-10.86,0l-64,136a6,6,0,1,0,10.86,5.11L38.63,158h82.74l17.2,36.55a6,6,0,1,0,10.86-5.11ZM44.28,146,80,70.09,115.72,146ZM200,98c-12.21,0-21.71,3.28-28.23,9.74a6,6,0,0,0,8.46,8.52c4.18-4.15,10.84-6.26,19.77-6.26,14.34,0,26,9.87,26,22v7.24A40.36,40.36,0,0,0,200,130c-20.95,0-38,15.25-38,34s17.05,34,38,34a40.36,40.36,0,0,0,26-9.24V192a6,6,0,0,0,12,0V132C238,113.25,221,98,200,98Zm0,88c-14.34,0-26-9.87-26-22s11.66-22,26-22,26,9.87,26,22S214.34,186,200,186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M87.24,52.59a8,8,0,0,0-14.48,0l-64,136a8,8,0,1,0,14.48,6.81L39.9,160h80.2l16.66,35.4a8,8,0,1,0,14.48-6.81ZM47.43,144,80,74.79,112.57,144ZM200,96c-12.76,0-22.73,3.47-29.63,10.32a8,8,0,0,0,11.26,11.36c3.8-3.77,10-5.68,18.37-5.68,13.23,0,24,9,24,20v3.22A42.76,42.76,0,0,0,200,128c-22.06,0-40,16.15-40,36s17.94,36,40,36a42.73,42.73,0,0,0,24-7.25,8,8,0,0,0,16-.75V132C240,112.15,222.06,96,200,96Zm0,88c-13.23,0-24-9-24-20s10.77-20,24-20,24,9,24,20S213.23,184,200,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M83.62,54.3a4,4,0,0,0-7.24,0l-64,136a4,4,0,0,0,7.24,3.4L37.36,156h85.28l17.74,37.7a4,4,0,1,0,7.24-3.4ZM41.13,148,80,65.39,118.87,148ZM200,100c-11.67,0-20.69,3.08-26.82,9.16a4,4,0,1,0,5.64,5.68c4.57-4.54,11.7-6.84,21.18-6.84,15.44,0,28,10.77,28,24v11.92A37.78,37.78,0,0,0,200,132c-19.85,0-36,14.35-36,32s16.15,32,36,32a37.78,37.78,0,0,0,28-11.92V192a4,4,0,0,0,8,0V132C236,114.36,219.85,100,200,100Zm0,88c-15.44,0-28-10.77-28-24s12.56-24,28-24,28,10.77,28,24S215.44,188,200,188Z"
        }))
    ]
]);


const $f15fbbae0cbab63b$export$65c346b6dab7f802 = $7fPBF.forwardRef((t, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, t), {
        weights: (0, $646424caf90d5bb4$export$2e2bcd8739ae039)
    })));
$f15fbbae0cbab63b$export$65c346b6dab7f802.displayName = "TextAaIcon";
const $f15fbbae0cbab63b$export$dfd974484d385cca = $f15fbbae0cbab63b$export$65c346b6dab7f802;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $08f48df2deddffcb$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M212,56V88a12,12,0,0,1-24,0V68H140V188h20a12,12,0,0,1,0,24H96a12,12,0,0,1,0-24h20V68H68V88a12,12,0,0,1-24,0V56A12,12,0,0,1,56,44H200A12,12,0,0,1,212,56Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56V184a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,96a8,8,0,0,1-16,0V88H136v88h12a8,8,0,0,1,0,16H108a8,8,0,0,1,0-16h12V88H88v8a8,8,0,0,1-16,0V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M206,56V88a6,6,0,0,1-12,0V62H134V194h26a6,6,0,0,1,0,12H96a6,6,0,0,1,0-12h26V62H62V88a6,6,0,0,1-12,0V56a6,6,0,0,1,6-6H200A6,6,0,0,1,206,56Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204,56V88a4,4,0,0,1-8,0V60H132V196h28a4,4,0,0,1,0,8H96a4,4,0,0,1,0-8h28V60H60V88a4,4,0,0,1-8,0V56a4,4,0,0,1,4-4H200A4,4,0,0,1,204,56Z"
        }))
    ]
]);


const $f3551c25430464ec$export$e667e191e6c30e84 = $7fPBF.forwardRef((t, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, t), {
        weights: (0, $08f48df2deddffcb$export$2e2bcd8739ae039)
    })));
$f3551c25430464ec$export$e667e191e6c30e84.displayName = "TextTIcon";
const $f3551c25430464ec$export$b68024eefe1542ec = $f3551c25430464ec$export$e667e191e6c30e84;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c03d13faea819647$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.78,156.53l-12-96A28,28,0,0,0,204,36H32A20,20,0,0,0,12,56v88a20,20,0,0,0,20,20H72.58l36.69,73.37A12,12,0,0,0,120,244a44.05,44.05,0,0,0,44-44V188h52a28,28,0,0,0,27.78-31.47ZM68,140H36V60H68Zm151,22.65a4,4,0,0,1-3,1.35H152a12,12,0,0,0-12,12v24a20,20,0,0,1-13.18,18.8L92,149.17V60H204a4,4,0,0,1,4,3.5l12,96A4,4,0,0,1,219,162.65Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,48V152H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M239.82,157l-12-96A24,24,0,0,0,204,40H32A16,16,0,0,0,16,56v88a16,16,0,0,0,16,16H75.06l37.78,75.58A8,8,0,0,0,120,240a40,40,0,0,0,40-40V184h56a24,24,0,0,0,23.82-27ZM72,144H32V56H72Zm150,21.29a7.88,7.88,0,0,1-6,2.71H152a8,8,0,0,0-8,8v24a24,24,0,0,1-19.29,23.54L88,150.11V56H204a8,8,0,0,1,7.94,7l12,96A7.87,7.87,0,0,1,222,165.29Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M239.82,157l-12-96A24,24,0,0,0,204,40H32A16,16,0,0,0,16,56v88a16,16,0,0,0,16,16H75.06l37.78,75.58A8,8,0,0,0,120,240a40,40,0,0,0,40-40V184h56a24,24,0,0,0,23.82-27ZM72,144H32V56H72Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M237.83,157.27l-12-96A22,22,0,0,0,204,42H32A14,14,0,0,0,18,56v88a14,14,0,0,0,14,14H76.29l38.34,76.68A6,6,0,0,0,120,238a38,38,0,0,0,38-38V182h58a22,22,0,0,0,21.83-24.73ZM74,146H32a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H74Zm149.5,20.62A9.89,9.89,0,0,1,216,170H152a6,6,0,0,0-6,6v24a26,26,0,0,1-22.42,25.75L86,150.58V54H204a10,10,0,0,1,9.92,8.76l12,96A9.89,9.89,0,0,1,223.5,166.62Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M239.82,157l-12-96A24,24,0,0,0,204,40H32A16,16,0,0,0,16,56v88a16,16,0,0,0,16,16H75.06l37.78,75.58A8,8,0,0,0,120,240a40,40,0,0,0,40-40V184h56a24,24,0,0,0,23.82-27ZM72,144H32V56H72Zm150,21.29a7.88,7.88,0,0,1-6,2.71H152a8,8,0,0,0-8,8v24a24,24,0,0,1-19.29,23.54L88,150.11V56H204a8,8,0,0,1,7.94,7l12,96A7.87,7.87,0,0,1,222,165.29Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M235.85,157.52l-12-96A20,20,0,0,0,204,44H32A12,12,0,0,0,20,56v88a12,12,0,0,0,12,12H77.53l38.89,77.79A4,4,0,0,0,120,236a36,36,0,0,0,36-36V180h60a20,20,0,0,0,19.85-22.48ZM76,148H32a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H76Zm149,19.94a12,12,0,0,1-9,4.06H152a4,4,0,0,0-4,4v24a28,28,0,0,1-25.58,27.9L84,151.06V52H204a12,12,0,0,1,11.91,10.51l12,96A12,12,0,0,1,225,167.94Z"
        }))
    ]
]);


const $b88431c71b28a7d6$export$d97232a1783d37ec = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $c03d13faea819647$export$2e2bcd8739ae039)
    })));
$b88431c71b28a7d6$export$d97232a1783d37ec.displayName = "ThumbsDownIcon";
const $b88431c71b28a7d6$export$abf0aca3dc085270 = $b88431c71b28a7d6$export$d97232a1783d37ec;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $d7ed4fa5062fa2c3$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M237,77.47A28,28,0,0,0,216,68H164V56a44.05,44.05,0,0,0-44-44,12,12,0,0,0-10.73,6.63L72.58,92H32a20,20,0,0,0-20,20v88a20,20,0,0,0,20,20H204a28,28,0,0,0,27.78-24.53l12-96A28,28,0,0,0,237,77.47ZM36,116H68v80H36ZM220,96.5l-12,96a4,4,0,0,1-4,3.5H92V106.83L126.82,37.2A20,20,0,0,1,140,56V80a12,12,0,0,0,12,12h64a4,4,0,0,1,4,4.5Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M80,104V208H32a8,8,0,0,1-8-8V112a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234,80.12A24,24,0,0,0,216,72H160V56a40,40,0,0,0-40-40,8,8,0,0,0-7.16,4.42L75.06,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H204a24,24,0,0,0,23.82-21l12-96A24,24,0,0,0,234,80.12ZM32,112H72v88H32ZM223.94,97l-12,96a8,8,0,0,1-7.94,7H88V105.89l36.71-73.43A24,24,0,0,1,144,56V80a8,8,0,0,0,8,8h64a8,8,0,0,1,7.94,9Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234,80.12A24,24,0,0,0,216,72H160V56a40,40,0,0,0-40-40,8,8,0,0,0-7.16,4.42L75.06,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H204a24,24,0,0,0,23.82-21l12-96A24,24,0,0,0,234,80.12ZM32,112H72v88H32Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232.49,81.44A22,22,0,0,0,216,74H158V56a38,38,0,0,0-38-38,6,6,0,0,0-5.37,3.32L76.29,98H32a14,14,0,0,0-14,14v88a14,14,0,0,0,14,14H204a22,22,0,0,0,21.83-19.27l12-96A22,22,0,0,0,232.49,81.44ZM30,200V112a2,2,0,0,1,2-2H74v92H32A2,2,0,0,1,30,200ZM225.92,97.24l-12,96A10,10,0,0,1,204,202H86V105.42l37.58-75.17A26,26,0,0,1,146,56V80a6,6,0,0,0,6,6h64a10,10,0,0,1,9.92,11.24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M234,80.12A24,24,0,0,0,216,72H160V56a40,40,0,0,0-40-40,8,8,0,0,0-7.16,4.42L75.06,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H204a24,24,0,0,0,23.82-21l12-96A24,24,0,0,0,234,80.12ZM32,112H72v88H32ZM223.94,97l-12,96a8,8,0,0,1-7.94,7H88V105.89l36.71-73.43A24,24,0,0,1,144,56V80a8,8,0,0,0,8,8h64a8,8,0,0,1,7.94,9Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M231,82.76A20,20,0,0,0,216,76H156V56a36,36,0,0,0-36-36,4,4,0,0,0-3.58,2.21L77.53,100H32a12,12,0,0,0-12,12v88a12,12,0,0,0,12,12H204a20,20,0,0,0,19.85-17.52l12-96A20,20,0,0,0,231,82.76ZM76,204H32a4,4,0,0,1-4-4V112a4,4,0,0,1,4-4H76ZM227.91,97.49l-12,96A12,12,0,0,1,204,204H84V104.94L122.42,28.1A28,28,0,0,1,148,56V80a4,4,0,0,0,4,4h64a12,12,0,0,1,11.91,13.49Z"
        }))
    ]
]);


const $175455dd9719881a$export$9e47e8f2c540d668 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $d7ed4fa5062fa2c3$export$2e2bcd8739ae039)
    })));
$175455dd9719881a$export$9e47e8f2c540d668.displayName = "ThumbsUpIcon";
const $175455dd9719881a$export$3058ab2b4b055ec4 = $175455dd9719881a$export$9e47e8f2c540d668;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a85de379556b6dc8$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,44a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,44Zm0,168a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,212ZM164.49,99.51a12,12,0,0,1,0,17l-28,28a12,12,0,0,1-17-17l28-28A12,12,0,0,1,164.49,99.51ZM92,16A12,12,0,0,1,104,4h48a12,12,0,0,1,0,24H104A12,12,0,0,1,92,16Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,136a88,88,0,1,1-88-88A88,88,0,0,1,216,136Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm45.66,61.66-40,40a8,8,0,0,1-11.32-11.32l40-40a8,8,0,0,1,11.32,11.32ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,42a94,94,0,1,0,94,94A94.11,94.11,0,0,0,128,42Zm0,176a82,82,0,1,1,82-82A82.1,82.1,0,0,1,128,218ZM172.24,91.76a6,6,0,0,1,0,8.48l-40,40a6,6,0,1,1-8.48-8.48l40-40A6,6,0,0,1,172.24,91.76ZM98,16a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H104A6,6,0,0,1,98,16Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,44a92,92,0,1,0,92,92A92.1,92.1,0,0,0,128,44Zm0,176a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,220ZM170.83,93.17a4,4,0,0,1,0,5.66l-40,40a4,4,0,1,1-5.66-5.66l40-40A4,4,0,0,1,170.83,93.17ZM100,16a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H104A4,4,0,0,1,100,16Z"
        }))
    ]
]);


const $ec3dc4d0853d94d0$export$579848c7cccecf3f = $7fPBF.forwardRef((r, m)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: m
    }, r), {
        weights: (0, $a85de379556b6dc8$export$2e2bcd8739ae039)
    })));
$ec3dc4d0853d94d0$export$579848c7cccecf3f.displayName = "TimerIcon";
const $ec3dc4d0853d94d0$export$c57e9b2d8b9e4de = $ec3dc4d0853d94d0$export$579848c7cccecf3f;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $bde6d6167681f1b4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.73,210.63l-56-112a12,12,0,0,0-21.46,0l-20.52,41A84.2,84.2,0,0,1,114,126.22,107.48,107.48,0,0,0,139.33,68H160a12,12,0,0,0,0-24H108V32a12,12,0,0,0-24,0V44H32a12,12,0,0,0,0,24h83.13A83.69,83.69,0,0,1,96,110.35,84,84,0,0,1,83.6,91a12,12,0,1,0-21.81,10A107.55,107.55,0,0,0,78,126.24,83.54,83.54,0,0,1,32,140a12,12,0,0,0,0,24,107.47,107.47,0,0,0,64-21.07,108.4,108.4,0,0,0,45.39,19.44l-24.13,48.26a12,12,0,1,0,21.46,10.73L151.41,196h65.17l12.68,25.36a12,12,0,1,0,21.47-10.73ZM163.41,172,184,130.83,204.58,172Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,184H144l40-80ZM96,127.56h0A95.78,95.78,0,0,0,128,56H64A95.78,95.78,0,0,0,96,127.56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,108,126.93,103.65,103.65,0,0,0,135.69,64H160a8,8,0,0,0,0-16H104V32a8,8,0,0,0-16,0V48H32a8,8,0,0,0,0,16h87.63A87.7,87.7,0,0,1,96,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,84,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L148.94,192h70.11l13.79,27.58A8,8,0,0,0,240,224a8,8,0,0,0,7.15-11.58ZM156.94,176,184,121.89,211.05,176Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M160,129.89,175.06,160H144.94l6.36-12.7v0ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM207.16,188.42l-40-80a8,8,0,0,0-14.32,0L139.66,134.8a62.31,62.31,0,0,1-23.61-10A79.61,79.61,0,0,0,135.6,80H152a8,8,0,0,0,0-16H112V56a8,8,0,0,0-16,0v8H56a8,8,0,0,0,0,16h63.48a63.73,63.73,0,0,1-15.3,34.05,65.93,65.93,0,0,1-9-13.61,8,8,0,0,0-14.32,7.12,81.75,81.75,0,0,0,11.4,17.15A63.62,63.62,0,0,1,56,136a8,8,0,0,0,0,16,79.56,79.56,0,0,0,48.11-16.13,78.33,78.33,0,0,0,28.18,13.66l-19.45,38.89a8,8,0,0,0,14.32,7.16L136.94,176h46.12l9.78,19.58a8,8,0,1,0,14.32-7.16Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M245.37,213.32l-56-112a6,6,0,0,0-10.74,0l-22.3,44.6A90,90,0,0,1,105,127.19,101.73,101.73,0,0,0,133.82,62H160a6,6,0,0,0,0-12H102V32a6,6,0,0,0-12,0V50H32a6,6,0,0,0,0,12h89.79A89.71,89.71,0,0,1,96,119.23,89.81,89.81,0,0,1,75.11,86,6,6,0,1,0,63.8,90,101.66,101.66,0,0,0,87,127.2,89.56,89.56,0,0,1,32,146a6,6,0,0,0,0,12,101.55,101.55,0,0,0,64-22.63,102.11,102.11,0,0,0,54.53,22.17l-27.89,55.78a6,6,0,0,0,10.74,5.36L147.71,190h72.58l14.34,28.68A6,6,0,0,0,240,222a5.87,5.87,0,0,0,2.68-.64A6,6,0,0,0,245.37,213.32ZM153.71,178,184,117.42,214.29,178Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,108,126.93,103.65,103.65,0,0,0,135.69,64H160a8,8,0,0,0,0-16H104V32a8,8,0,0,0-16,0V48H32a8,8,0,0,0,0,16h87.63A87.76,87.76,0,0,1,96,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,84,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L148.94,192h70.11l13.79,27.58A8,8,0,0,0,240,224a8,8,0,0,0,7.15-11.58ZM156.94,176,184,121.89,211.05,176Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.58,214.21l-56-112a4,4,0,0,0-7.16,0L157.55,148A92.05,92.05,0,0,1,102,127.36,99.68,99.68,0,0,0,131.91,60H160a4,4,0,0,0,0-8H100V32a4,4,0,0,0-8,0V52H32a4,4,0,0,0,0,8h91.91A91.8,91.8,0,0,1,96,122.05,92,92,0,0,1,73.23,86.67a4,4,0,1,0-7.54,2.66,99.59,99.59,0,0,0,24.3,38A91.59,91.59,0,0,1,32,148a4,4,0,0,0,0,8,99.54,99.54,0,0,0,64-23.21,100.09,100.09,0,0,0,57.66,23l-29.22,58.43a4,4,0,1,0,7.16,3.58L146.47,188h75.06l14.89,29.79A4,4,0,0,0,240,220a4.12,4.12,0,0,0,1.79-.42A4,4,0,0,0,243.58,214.21ZM150.47,180,184,112.94,217.53,180Z"
        }))
    ]
]);


const $e0cac562beb02fd2$export$d1fe1d52e2885c4e = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $bde6d6167681f1b4$export$2e2bcd8739ae039)
    })));
$e0cac562beb02fd2$export$d1fe1d52e2885c4e.displayName = "TranslateIcon";
const $e0cac562beb02fd2$export$9db2ba50894db2b9 = $e0cac562beb02fd2$export$d1fe1d52e2885c4e;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c36618c05307c46b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,50H174V40a22,22,0,0,0-22-22H104A22,22,0,0,0,82,40V50H40a6,6,0,0,0,0,12H50V208a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V62h10a6,6,0,0,0,0-12ZM94,40a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10V50H94ZM194,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V62H194ZM110,104v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,52H172V40a20,20,0,0,0-20-20H104A20,20,0,0,0,84,40V52H40a4,4,0,0,0,0,8H52V208a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V60h12a4,4,0,0,0,0-8ZM92,40a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12V52H92ZM196,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V60H196ZM108,104v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Z"
        }))
    ]
]);


const $9819cc275a023cc4$export$d23329de703dffc4 = $7fPBF.forwardRef((a, e)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: e
    }, a), {
        weights: (0, $c36618c05307c46b$export$2e2bcd8739ae039)
    })));
$9819cc275a023cc4$export$d23329de703dffc4.displayName = "TrashIcon";
const $9819cc275a023cc4$export$99442c433de1441d = $9819cc275a023cc4$export$d23329de703dffc4;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $85c705298dad0e62$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M92.38,38.05A12,12,0,0,1,101,23.42a108,108,0,0,1,54,0,12,12,0,1,1-6,23.23,84,84,0,0,0-42,0A12,12,0,0,1,92.38,38.05ZM32.29,113.87a12.2,12.2,0,0,0,3.2.43,12,12,0,0,0,11.56-8.8,84,84,0,0,1,21-36.35A12,12,0,1,0,50.94,52.34a108.1,108.1,0,0,0-27,46.76A12,12,0,0,0,32.29,113.87ZM149,209.35a84,84,0,0,1-42,0,12,12,0,1,0-6,23.23,108,108,0,0,0,54,0,12,12,0,1,0-6-23.23Zm59.95-103.83a12,12,0,0,0,23.12-6.42,108,108,0,0,0-27-46.78A12,12,0,1,0,188,69.15,84,84,0,0,1,208.94,105.52Zm23.15,51.39a107.86,107.86,0,0,1-31.86,51.38,12,12,0,0,1-18.72-3.48,60,60,0,0,0-107,0,12,12,0,0,1-8.5,6.36,12.48,12.48,0,0,1-2.19.2,12,12,0,0,1-8-3.08A107.85,107.85,0,0,1,23.91,156.9,12,12,0,0,1,47,150.49,83.58,83.58,0,0,0,62,180a83.46,83.46,0,0,1,29-23.47,52,52,0,1,1,74,0A83.59,83.59,0,0,1,194,180a83.73,83.73,0,0,0,15-29.49,12,12,0,0,1,23.13,6.42ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.79,55.14a104,104,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-5.67,4.23,8.11,8.11,0,0,1-1.46.14,8,8,0,0,1-5.35-2.05,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,88,88,0,0,1,22-38.09A8,8,0,0,0,53.79,55.14a104.05,104.05,0,0,0-26,45A8,8,0,0,0,33.35,110Zm179.44-5.56a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.22A88,88,0,0,1,212.79,104.45ZM222.66,146a8,8,0,0,0-9.85,5.58,87.61,87.61,0,0,1-19,34.83A79.75,79.75,0,0,0,172,165.11a4,4,0,0,0-4.83.31,59.81,59.81,0,0,1-78.27,0,4,4,0,0,0-4.84-.31,79.52,79.52,0,0,0-22,21.12,87.7,87.7,0,0,1-18.83-34.67,8,8,0,0,0-15.42,4.28,104.07,104.07,0,0,0,200.46,0A8,8,0,0,0,222.66,146ZM128,164a44,44,0,1,0-44-44A44.05,44.05,0,0,0,128,164Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M98.19,36.54a6,6,0,0,1,4.31-7.31,102,102,0,0,1,51,0,6,6,0,1,1-3,11.61,90,90,0,0,0-45,0A6,6,0,0,1,98.19,36.54Zm-64.3,71.54a5.88,5.88,0,0,0,1.6.22,6,6,0,0,0,5.78-4.4A90,90,0,0,1,63.78,65a6,6,0,1,0-8.56-8.41A102.12,102.12,0,0,0,29.7,100.7,6,6,0,0,0,33.89,108.08ZM150.5,215.15a90,90,0,0,1-45,0,6,6,0,1,0-3,11.61,102,102,0,0,0,51,0,6,6,0,0,0-3-11.62Zm64.22-111.24a6,6,0,0,0,5.78,4.4,5.88,5.88,0,0,0,1.6-.22,6,6,0,0,0,4.18-7.38,102,102,0,0,0-25.49-44.18,6,6,0,0,0-8.55,8.41A90.11,90.11,0,0,1,214.72,103.91ZM226.3,155.3a101.75,101.75,0,0,1-30.08,48.53,6,6,0,0,1-9.37-1.74,66,66,0,0,0-117.7,0,6,6,0,0,1-4.26,3.18,5.74,5.74,0,0,1-1.09.1,6,6,0,0,1-4-1.54A101.74,101.74,0,0,1,29.7,155.3a6,6,0,1,1,11.56-3.21,89.79,89.79,0,0,0,21.2,37.59,77.56,77.56,0,0,1,40-31.43,46,46,0,1,1,51,0,77.56,77.56,0,0,1,40,31.43,89.7,89.7,0,0,0,21.2-37.58,6,6,0,1,1,11.56,3.2ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.8,55.14a103.92,103.92,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-12.48,2.32,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M100.13,36A4,4,0,0,1,103,31.17a100.09,100.09,0,0,1,50,0,4,4,0,0,1-1,7.88,4.36,4.36,0,0,1-1-.13,92,92,0,0,0-46,0A4,4,0,0,1,100.13,36ZM34.42,106.16a4,4,0,0,0,4.92-2.79,91.92,91.92,0,0,1,23-39.82,4,4,0,0,0-5.71-5.61,100.15,100.15,0,0,0-25,43.3A4,4,0,0,0,34.42,106.16ZM151,217.09a92,92,0,0,1-46,0,4,4,0,0,0-2,7.75,100,100,0,0,0,50,0,4,4,0,1,0-2-7.74Zm65.65-113.71a4,4,0,1,0,7.7-2.14,100.08,100.08,0,0,0-25-43.31,4,4,0,1,0-5.71,5.61A92,92,0,0,1,216.65,103.38Zm7.73,51.39a99.77,99.77,0,0,1-29.5,47.57,4,4,0,0,1-6.24-1.16,68,68,0,0,0-121.28,0,4,4,0,0,1-2.83,2.12,3.61,3.61,0,0,1-.73.07,4,4,0,0,1-2.68-1,99.8,99.8,0,0,1-29.5-47.58,4,4,0,1,1,7.71-2.13A91.89,91.89,0,0,0,62.8,192.91a75.66,75.66,0,0,1,44.54-34.08,44,44,0,1,1,41.32,0,75.66,75.66,0,0,1,44.54,34.08,91.83,91.83,0,0,0,23.47-40.28,4,4,0,0,1,7.71,2.14ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Z"
        }))
    ]
]);


const $e71b30b7f3057cfb$export$1ce52e77d13914c6 = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, o), {
        weights: (0, $85c705298dad0e62$export$2e2bcd8739ae039)
    })));
$e71b30b7f3057cfb$export$1ce52e77d13914c6.displayName = "UserCircleDashedIcon";
const $e71b30b7f3057cfb$export$74ffb04a319734b0 = $e71b30b7f3057cfb$export$1ce52e77d13914c6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $7338905cfd832840$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M169.57,46.11a12,12,0,0,1,15.12-7.7L188,39.48V36a12,12,0,0,1,24,0v3.48l3.31-1.07a12,12,0,1,1,7.42,22.82l-3.31,1.08,2,2.82a12,12,0,1,1-19.41,14.1L200,76.42,198,79.23a12,12,0,1,1-19.41-14.1l2-2.82-3.31-1.08A12,12,0,0,1,169.57,46.11ZM236,128A108,108,0,1,1,128,20a109.19,109.19,0,0,1,18,1.49,12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.48,83.48,0,0,1,29,23.42A83.57,83.57,0,0,0,212,128a85.2,85.2,0,0,0-1.16-14,12,12,0,0,1,23.67-4A109,109,0,0,1,236,128ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,0,1,184.92,50.69a16,16,0,0,0,20.39,20.39A95.61,95.61,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM192,56a8,8,0,1,1,8,8A8,8,0,0,1,192,56Zm29.35,48.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41,79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM200,64a8,8,0,1,1,8-8A8,8,0,0,1,200,64ZM128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm102.56,34.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.71,79.71,0,0,1,84,165.1a4,4,0,0,1,4.83.32,59.81,59.81,0,0,0,78.27,0,4,4,0,0,1,4.84-.32,79.86,79.86,0,0,1,21.79,21.31A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.25,64.8l-5.92-3.41a22,22,0,0,0,0-10.78l5.92-3.41a6,6,0,0,0-6-10.4l-5.93,3.43A22,22,0,0,0,206,34.84V28a6,6,0,0,0-12,0v6.84a22,22,0,0,0-9.32,5.39l-5.93-3.43a6,6,0,0,0-6,10.4l5.92,3.41a22,22,0,0,0,0,10.78l-5.92,3.41a6,6,0,0,0,6,10.4l5.93-3.43A22,22,0,0,0,194,77.16V84a6,6,0,0,0,12,0V77.16a22,22,0,0,0,9.32-5.39l5.93,3.43a6,6,0,0,0,6-10.4ZM200,66a10,10,0,1,1,10-10A10,10,0,0,1,200,66Zm21.68,40.08a6,6,0,0,0-4.92,6.91A91.76,91.76,0,0,1,218,128a89.65,89.65,0,0,1-24.49,61.64,77.53,77.53,0,0,0-40-31.38,46,46,0,1,0-51,0,77.53,77.53,0,0,0-40,31.38A89.95,89.95,0,0,1,128,38a91.66,91.66,0,0,1,15,1.24,6,6,0,1,0,2-11.83,102,102,0,1,0,50,177.44c.65,1.36,1.68,0,2.34-2.11A102,102,0,0,0,228.59,111,6,6,0,0,0,221.68,106.08ZM94,120a34,34,0,1,1,34,34A34,34,0,0,1,94,120ZM71.44,198a66,66,0,0,1,113.12,0,89.8,89.8,0,0,1-113.12,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM192,56a8,8,0,1,1,8,8A8,8,0,0,1,192,56Zm29.35,48.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41,79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.25,66.54,219,62.33a19.78,19.78,0,0,0,0-12.66l7.29-4.21a4,4,0,0,0-4-6.92l-7.31,4.21A20,20,0,0,0,204,36.4V28a4,4,0,0,0-8,0v8.4a20,20,0,0,0-10.94,6.35l-7.31-4.21a4,4,0,1,0-4,6.92L181,49.67a19.78,19.78,0,0,0,0,12.66l-7.29,4.21a4,4,0,0,0,2,7.46,3.92,3.92,0,0,0,2-.54l7.31-4.21A20,20,0,0,0,196,75.6V84a4,4,0,0,0,8,0V75.6a20,20,0,0,0,10.94-6.35l7.31,4.21a3.92,3.92,0,0,0,2,.54,4,4,0,0,0,2-7.46ZM200,68a12,12,0,1,1,12-12A12,12,0,0,1,200,68Zm22,40.06a4,4,0,0,0-3.28,4.6A93.58,93.58,0,0,1,220,128a91.69,91.69,0,0,1-26.83,64.87,75.61,75.61,0,0,0-44.51-34,44,44,0,1,0-41.32,0,75.61,75.61,0,0,0-44.51,34A92,92,0,0,1,128,36a93.4,93.4,0,0,1,15.34,1.27,4,4,0,0,0,1.32-7.89,99.89,99.89,0,1,0,82,82A4,4,0,0,0,222,108.06ZM92,120a36,36,0,1,1,36,36A36,36,0,0,1,92,120ZM68.87,198.42a68,68,0,0,1,118.27,0,91.81,91.81,0,0,1-118.27,0Z"
        }))
    ]
]);


const $2f437e07b97666ee$export$3006507487a721d3 = $7fPBF.forwardRef((o, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, o), {
        weights: (0, $7338905cfd832840$export$2e2bcd8739ae039)
    })));
$2f437e07b97666ee$export$3006507487a721d3.displayName = "UserCircleGearIcon";
const $2f437e07b97666ee$export$6ceef15b42e6d619 = $2f437e07b97666ee$export$3006507487a721d3;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a70125795049fe98$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20ZM79.57,196.57a60,60,0,0,1,96.86,0,83.72,83.72,0,0,1-96.86,0ZM100,120a28,28,0,1,1,28,28A28,28,0,0,1,100,120ZM194,179.94a83.48,83.48,0,0,0-29-23.42,52,52,0,1,0-74,0,83.48,83.48,0,0,0-29,23.42,84,84,0,1,1,131.9,0Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,120a44,44,0,1,1-44-44A44.05,44.05,0,0,1,172,120Zm60,8A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88.09,88.09,0,0,0-91.47-87.93C77.43,41.89,39.87,81.12,40,128.25a87.65,87.65,0,0,0,22.24,58.16A79.71,79.71,0,0,1,84,165.1a4,4,0,0,1,4.83.32,59.83,59.83,0,0,0,78.28,0,4,4,0,0,1,4.83-.32,79.71,79.71,0,0,1,21.79,21.31A87.62,87.62,0,0,0,216,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26ZM71.44,198a66,66,0,0,1,113.12,0,89.8,89.8,0,0,1-113.12,0ZM94,120a34,34,0,1,1,34,34A34,34,0,0,1,94,120Zm99.51,69.64a77.53,77.53,0,0,0-40-31.38,46,46,0,1,0-51,0,77.53,77.53,0,0,0-40,31.38,90,90,0,1,1,131,0Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28ZM68.87,198.42a68,68,0,0,1,118.26,0,91.8,91.8,0,0,1-118.26,0Zm124.3-5.55a75.61,75.61,0,0,0-44.51-34,44,44,0,1,0-41.32,0,75.61,75.61,0,0,0-44.51,34,92,92,0,1,1,130.34,0ZM128,156a36,36,0,1,1,36-36A36,36,0,0,1,128,156Z"
        }))
    ]
]);


const $0c61379047732f24$export$9daf73c3c6a408a2 = $7fPBF.forwardRef((o, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, o), {
        weights: (0, $a70125795049fe98$export$2e2bcd8739ae039)
    })));
$0c61379047732f24$export$9daf73c3c6a408a2.displayName = "UserCircleIcon";
const $0c61379047732f24$export$33256dee473898a = $0c61379047732f24$export$9daf73c3c6a408a2;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $27244bf9a945b438$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,56a12,12,0,0,1,12-12h48a12,12,0,0,1,0,24H176A12,12,0,0,1,164,56Zm65.85,36A108,108,0,1,1,128,20a109.19,109.19,0,0,1,18,1.49,12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.36,83.36,0,0,1,29,23.42A83.94,83.94,0,0,0,207.22,100a12,12,0,0,1,22.63-8ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H176A8,8,0,0,1,168,56Zm58.08,37.33a103.93,103.93,0,1,1-80.76-67.89,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A88,88,0,0,0,211,98.67a8,8,0,0,1,15.09-5.34ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h48a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Zm39.87,24.46A8,8,0,0,0,211,98.67a88,88,0,0,1-17.23,87.74A79.86,79.86,0,0,0,172,165.1a4,4,0,0,0-4.84.32,59.81,59.81,0,0,1-78.27,0A4,4,0,0,0,84,165.1a79.71,79.71,0,0,0-21.79,21.31A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.9,103.9,0,1,0,80.76,67.89A8,8,0,0,0,215.87,88.46Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M170,56a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H176A6,6,0,0,1,170,56Zm54.19,38A101.9,101.9,0,1,1,145,27.41a6,6,0,1,1-2,11.83A91.66,91.66,0,0,0,128,38,89.95,89.95,0,0,0,62.49,189.64a77.53,77.53,0,0,1,40-31.38,46,46,0,1,1,51,0,77.53,77.53,0,0,1,40,31.38A90,90,0,0,0,212.88,98a6,6,0,1,1,11.31-4ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Zm0,64A89.58,89.58,0,0,0,184.56,198a66,66,0,0,0-113.12,0A89.58,89.58,0,0,0,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H176A8,8,0,0,1,168,56Zm58.08,37.33a103.93,103.93,0,1,1-80.76-67.89,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A88,88,0,0,0,211,98.67a8,8,0,0,1,15.09-5.34ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,56a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H176A4,4,0,0,1,172,56Zm50.31,38.67A100,100,0,1,1,128,28a100.69,100.69,0,0,1,16.66,1.38,4,4,0,0,1-1.32,7.89A93.4,93.4,0,0,0,128,36,92,92,0,0,0,62.83,192.87a75.61,75.61,0,0,1,44.51-34,44,44,0,1,1,41.32,0,75.61,75.61,0,0,1,44.51,34,92,92,0,0,0,21.6-95.54,4,4,0,1,1,7.54-2.66ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Zm0,64a91.61,91.61,0,0,0,59.14-21.58,68,68,0,0,0-118.27,0A91.56,91.56,0,0,0,128,220Z"
        }))
    ]
]);


const $43867aff44220ee6$export$dcdebfa7a96805c0 = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, o), {
        weights: (0, $27244bf9a945b438$export$2e2bcd8739ae039)
    })));
$43867aff44220ee6$export$dcdebfa7a96805c0.displayName = "UserCircleMinusIcon";
const $43867aff44220ee6$export$7eba70a43e762324 = $43867aff44220ee6$export$dcdebfa7a96805c0;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $6bc3436cf394e344$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164,56a12,12,0,0,1,12-12h12V32a12,12,0,0,1,24,0V44h12a12,12,0,0,1,0,24H212V80a12,12,0,0,1-24,0V68H176A12,12,0,0,1,164,56Zm70.51,54A107.88,107.88,0,1,1,146,21.49a12,12,0,0,1-4,23.67A85,85,0,0,0,128,44,83.94,83.94,0,0,0,62.05,179.94a83.48,83.48,0,0,1,29-23.42,52,52,0,1,1,74,0,83.36,83.36,0,0,1,29,23.42A83.52,83.52,0,0,0,212,128a85.2,85.2,0,0,0-1.16-14,12,12,0,0,1,23.67-4ZM128,148a28,28,0,1,0-28-28A28,28,0,0,0,128,148Zm0,64a83.53,83.53,0,0,0,48.43-15.43,60,60,0,0,0-96.86,0A83.53,83.53,0,0,0,128,212Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a95.76,95.76,0,0,1-31.8,71.37A72,72,0,0,0,128,160a40,40,0,1,0-40-40,40,40,0,0,0,40,40,72,72,0,0,0-64.2,39.37h0A96,96,0,1,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.35,40.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41A79.86,79.86,0,0,0,172,165.1a4,4,0,0,0-4.84.32,59.81,59.81,0,0,1-78.27,0A4,4,0,0,0,84,165.1a79.71,79.71,0,0,0-21.79,21.31A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M170,56a6,6,0,0,1,6-6h18V32a6,6,0,0,1,12,0V50h18a6,6,0,0,1,0,12H206V80a6,6,0,0,1-12,0V62H176A6,6,0,0,1,170,56Zm58.59,55A101.9,101.9,0,1,1,145,27.41a6,6,0,1,1-2,11.83A91.66,91.66,0,0,0,128,38,89.95,89.95,0,0,0,62.49,189.64a77.53,77.53,0,0,1,40-31.38,46,46,0,1,1,51,0,77.53,77.53,0,0,1,40,31.38A89.65,89.65,0,0,0,218,128a91.76,91.76,0,0,0-1.24-15,6,6,0,1,1,11.83-2ZM128,154a34,34,0,1,0-34-34A34,34,0,0,0,128,154Zm0,64A89.58,89.58,0,0,0,184.56,198a66,66,0,0,0-113.12,0A89.58,89.58,0,0,0,128,218Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M172,56a4,4,0,0,1,4-4h20V32a4,4,0,0,1,8,0V52h20a4,4,0,0,1,0,8H204V80a4,4,0,0,1-8,0V60H176A4,4,0,0,1,172,56Zm54.62,55.34a99.89,99.89,0,1,1-82-82,4,4,0,0,1-1.32,7.89A93.4,93.4,0,0,0,128,36,92,92,0,0,0,62.83,192.87a75.61,75.61,0,0,1,44.51-34,44,44,0,1,1,41.32,0,75.61,75.61,0,0,1,44.51,34A91.69,91.69,0,0,0,220,128a93.58,93.58,0,0,0-1.27-15.34,4,4,0,0,1,7.89-1.32ZM128,156a36,36,0,1,0-36-36A36,36,0,0,0,128,156Zm0,64a91.61,91.61,0,0,0,59.14-21.58,68,68,0,0,0-118.27,0A91.56,91.56,0,0,0,128,220Z"
        }))
    ]
]);


const $3a96a83bceac7286$export$237d26d4b8472a = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, o), {
        weights: (0, $6bc3436cf394e344$export$2e2bcd8739ae039)
    })));
$3a96a83bceac7286$export$237d26d4b8472a.displayName = "UserCirclePlusIcon";
const $3a96a83bceac7286$export$66630ebdd93d8756 = $3a96a83bceac7286$export$237d26d4b8472a;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e60adf923457164b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M125.18,156.94a64,64,0,1,0-82.36,0,100.23,100.23,0,0,0-39.49,32,12,12,0,0,0,19.35,14.2,76,76,0,0,1,122.64,0,12,12,0,0,0,19.36-14.2A100.33,100.33,0,0,0,125.18,156.94ZM44,108a40,40,0,1,1,40,40A40,40,0,0,1,44,108Zm206.1,97.67a12,12,0,0,1-16.78-2.57A76.31,76.31,0,0,0,172,172a12,12,0,0,1,0-24,40,40,0,1,0-10.3-78.67,12,12,0,1,1-6.16-23.19,64,64,0,0,1,57.64,110.8,100.23,100.23,0,0,1,39.49,32A12,12,0,0,1,250.1,205.67Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,108A52,52,0,1,1,84,56,52,52,0,0,1,136,108Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.47,195.63a8,8,0,0,1-6.7,12.37H10.23a8,8,0,0,1-6.7-12.37,95.83,95.83,0,0,1,47.22-37.71,60,60,0,1,1,66.5,0A95.83,95.83,0,0,1,164.47,195.63Zm87.91-.15a95.87,95.87,0,0,0-47.13-37.56A60,60,0,0,0,144.7,54.59a4,4,0,0,0-1.33,6A75.83,75.83,0,0,1,147,150.53a4,4,0,0,0,1.07,5.53,112.32,112.32,0,0,1,29.85,30.83,23.92,23.92,0,0,1,3.65,16.47,4,4,0,0,0,3.95,4.64h60.3a8,8,0,0,0,7.73-5.93A8.22,8.22,0,0,0,252.38,195.48Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M112.6,158.43a58,58,0,1,0-57.2,0A93.83,93.83,0,0,0,5.21,196.72a6,6,0,0,0,10.05,6.56,82,82,0,0,1,137.48,0,6,6,0,0,0,10-6.56A93.83,93.83,0,0,0,112.6,158.43ZM38,108a46,46,0,1,1,46,46A46.06,46.06,0,0,1,38,108Zm211,97a6,6,0,0,1-8.3-1.74A81.8,81.8,0,0,0,172,166a6,6,0,0,1,0-12,46,46,0,1,0-17.08-88.73,6,6,0,1,1-4.46-11.14,58,58,0,0,1,50.14,104.3,93.83,93.83,0,0,1,50.19,38.29A6,6,0,0,1,249,205Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M107.19,159a56,56,0,1,0-46.38,0A91.83,91.83,0,0,0,6.88,197.81a4,4,0,1,0,6.7,4.37,84,84,0,0,1,140.84,0,4,4,0,1,0,6.7-4.37A91.83,91.83,0,0,0,107.19,159ZM36,108a48,48,0,1,1,48,48A48.05,48.05,0,0,1,36,108Zm212,95.35a4,4,0,0,1-5.53-1.17A83.81,83.81,0,0,0,172,164a4,4,0,0,1,0-8,48,48,0,1,0-17.82-92.58,4,4,0,1,1-3-7.43,56,56,0,0,1,44,103,91.83,91.83,0,0,1,53.93,38.86A4,4,0,0,1,248,203.35Z"
        }))
    ]
]);


const $dc77a89d27a4c55c$export$4e04c809deb7a605 = $7fPBF.forwardRef((r, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, r), {
        weights: (0, $e60adf923457164b$export$2e2bcd8739ae039)
    })));
$dc77a89d27a4c55c$export$4e04c809deb7a605.displayName = "UsersIcon";
const $dc77a89d27a4c55c$export$a69f017b19597ff5 = $dc77a89d27a4c55c$export$4e04c809deb7a605;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0d21f9db5f9b92df$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.38,181.1a52,52,0,1,0-72.76,0,75.89,75.89,0,0,0-30,28.89,12,12,0,0,0,20.78,12,53,53,0,0,1,91.22,0,12,12,0,1,0,20.78-12A75.89,75.89,0,0,0,164.38,181.1ZM100,144a28,28,0,1,1,28,28A28,28,0,0,1,100,144Zm147.21,9.59a12,12,0,0,1-16.81-2.39c-8.33-11.09-19.85-19.59-29.33-21.64a12,12,0,0,1-1.82-22.91,20,20,0,1,0-24.78-28.3,12,12,0,1,1-21-11.6,44,44,0,1,1,73.28,48.35,92.18,92.18,0,0,1,22.85,21.69A12,12,0,0,1,247.21,153.59Zm-192.28-24c-9.48,2.05-21,10.55-29.33,21.65A12,12,0,0,1,6.41,136.79,92.37,92.37,0,0,1,29.26,115.1a44,44,0,1,1,73.28-48.35,12,12,0,1,1-21,11.6,20,20,0,1,0-24.78,28.3,12,12,0,0,1-1.82,22.91Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168,144a40,40,0,1,1-40-40A40,40,0,0,1,168,144ZM64,56A32,32,0,1,0,96,88,32,32,0,0,0,64,56Zm128,0a32,32,0,1,0,32,32A32,32,0,0,0,192,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1,0-16,24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.85,8,57,57,0,0,0-98.15,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M64.12,147.8a4,4,0,0,1-4,4.2H16a8,8,0,0,1-7.8-6.17,8.35,8.35,0,0,1,1.62-6.93A67.79,67.79,0,0,1,37,117.51a40,40,0,1,1,66.46-35.8,3.94,3.94,0,0,1-2.27,4.18A64.08,64.08,0,0,0,64,144C64,145.28,64,146.54,64.12,147.8Zm182-8.91A67.76,67.76,0,0,0,219,117.51a40,40,0,1,0-66.46-35.8,3.94,3.94,0,0,0,2.27,4.18A64.08,64.08,0,0,1,192,144c0,1.28,0,2.54-.12,3.8a4,4,0,0,0,4,4.2H240a8,8,0,0,0,7.8-6.17A8.33,8.33,0,0,0,246.17,138.89Zm-89,43.18a48,48,0,1,0-58.37,0A72.13,72.13,0,0,0,65.07,212,8,8,0,0,0,72,224H184a8,8,0,0,0,6.93-12A72.15,72.15,0,0,0,157.19,182.07Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M243.6,148.8a6,6,0,0,1-8.4-1.2A53.58,53.58,0,0,0,192,126a6,6,0,0,1,0-12,26,26,0,1,0-25.18-32.5,6,6,0,0,1-11.62-3,38,38,0,1,1,59.91,39.63A65.69,65.69,0,0,1,244.8,140.4,6,6,0,0,1,243.6,148.8ZM189.19,213a6,6,0,0,1-2.19,8.2,5.9,5.9,0,0,1-3,.81,6,6,0,0,1-5.2-3,59,59,0,0,0-101.62,0,6,6,0,1,1-10.38-6A70.1,70.1,0,0,1,103,182.55a46,46,0,1,1,50.1,0A70.1,70.1,0,0,1,189.19,213ZM128,178a34,34,0,1,0-34-34A34,34,0,0,0,128,178ZM70,120a6,6,0,0,0-6-6A26,26,0,1,1,89.18,81.49a6,6,0,1,0,11.62-3,38,38,0,1,0-59.91,39.63A65.69,65.69,0,0,0,11.2,140.4a6,6,0,1,0,9.6,7.2A53.58,53.58,0,0,1,64,126,6,6,0,0,0,70,120Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M237,147.44a4,4,0,0,1-5.48-1.4c-8.33-14-20.93-22-34.56-22a4,4,0,0,1-1.2-.2,36.76,36.76,0,0,1-3.8.2,4,4,0,0,1,0-8,28,28,0,1,0-27.12-35,4,4,0,0,1-7.75-2,36,36,0,1,1,54,39.48c10.81,3.85,20.51,12,27.31,23.48A4,4,0,0,1,237,147.44ZM187.46,214a4,4,0,0,1-1.46,5.46,3.93,3.93,0,0,1-2,.54,4,4,0,0,1-3.46-2,61,61,0,0,0-105.08,0,4,4,0,0,1-6.92-4,68.35,68.35,0,0,1,39.19-31,44,44,0,1,1,40.54,0A68.35,68.35,0,0,1,187.46,214ZM128,180a36,36,0,1,0-36-36A36,36,0,0,0,128,180ZM64,116A28,28,0,1,1,91.12,81a4,4,0,0,0,7.75-2A36,36,0,1,0,45.3,118.75,63.55,63.55,0,0,0,12.8,141.6a4,4,0,0,0,6.4,4.8A55.55,55.55,0,0,1,64,124a4,4,0,0,0,0-8Z"
        }))
    ]
]);


const $e0b8800b731f944b$export$31f7e9379e51640b = $7fPBF.forwardRef((o, s)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: s
    }, o), {
        weights: (0, $0d21f9db5f9b92df$export$2e2bcd8739ae039)
    })));
$e0b8800b731f944b$export$31f7e9379e51640b.displayName = "UsersThreeIcon";
const $e0b8800b731f944b$export$3a0328dbf8744009 = $e0b8800b731f944b$export$31f7e9379e51640b;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $92e6d9f4f0966d7b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.45,69.31a12,12,0,0,0-12.51,1L212,88.43V72a20,20,0,0,0-20-20H32A20,20,0,0,0,12,72V184a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V167.57l24.94,18.14A12,12,0,0,0,256,176V80A12,12,0,0,0,249.45,69.31ZM188,180H36V76H188Zm44-27.57-20-14.54V118.11l20-14.54Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,72V184a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H192A8,8,0,0,1,200,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.77,73a8,8,0,0,0-8.21.39L208,97.05V72a16,16,0,0,0-16-16H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V159l35.56,23.71A8,8,0,0,0,248,184a8,8,0,0,0,8-8V80A8,8,0,0,0,251.77,73ZM192,184H32V72H192V184Zm48-22.95-32-21.33V116.28L240,95Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M192,72V184a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V72A16,16,0,0,1,32,56H176A16,16,0,0,1,192,72Zm58,.25a8.23,8.23,0,0,0-6.63,1.22L209.78,95.86A4,4,0,0,0,208,99.19v57.62a4,4,0,0,0,1.78,3.33l33.78,22.52a8,8,0,0,0,8.58.19,8.33,8.33,0,0,0,3.86-7.17V80A8,8,0,0,0,250,72.25Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.83,74.71a6,6,0,0,0-6.16.3L206,100.79V72a14,14,0,0,0-14-14H32A14,14,0,0,0,18,72V184a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V155.21L244.67,181a6,6,0,0,0,9.33-5V80A6,6,0,0,0,250.83,74.71ZM194,184a2,2,0,0,1-2,2H32a2,2,0,0,1-2-2V72a2,2,0,0,1,2-2H192a2,2,0,0,1,2,2Zm48-19.21-36-24V115.21l36-24Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.77,73a8,8,0,0,0-8.21.39L208,97.05V72a16,16,0,0,0-16-16H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V159l35.56,23.71A8,8,0,0,0,248,184a8,8,0,0,0,8-8V80A8,8,0,0,0,251.77,73ZM192,184H32V72H192V184Zm48-22.95-32-21.33V116.28L240,95Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.89,76.47a4,4,0,0,0-4.11.2L204,104.53V72a12,12,0,0,0-12-12H32A12,12,0,0,0,20,72V184a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V151.47l41.78,27.86A4,4,0,0,0,252,176V80A4,4,0,0,0,249.89,76.47ZM196,184a4,4,0,0,1-4,4H32a4,4,0,0,1-4-4V72a4,4,0,0,1,4-4H192a4,4,0,0,1,4,4Zm48-15.47-40-26.67V114.14l40-26.67Z"
        }))
    ]
]);


const $c1ef82a974bad340$export$bed1a57ff13393e9 = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, a), {
        weights: (0, $92e6d9f4f0966d7b$export$2e2bcd8739ae039)
    })));
$c1ef82a974bad340$export$bed1a57ff13393e9.displayName = "VideoCameraIcon";
const $c1ef82a974bad340$export$af6fbc3d5e506b68 = $c1ef82a974bad340$export$bed1a57ff13393e9;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $c8e1cb9275e810e4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.45,69.31a12,12,0,0,0-12.51,1L212,88.43V72a20,20,0,0,0-20-20H123.88a12,12,0,0,0,0,24H188v68a12,12,0,0,0,4.46,9.33c.15.13.31.25.48.38l44,32A12,12,0,0,0,256,176V80A12,12,0,0,0,249.45,69.31ZM232,152.43l-20-14.54V118.11l20-14.54ZM56.88,31.93A12,12,0,1,0,39.12,48.07L42.69,52H32A20,20,0,0,0,12,72V184a20,20,0,0,0,20,20H180.87l18.25,20.07a12,12,0,0,0,17.76-16.14ZM36,180V76H64.51l94.55,104Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,72V184a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H192A8,8,0,0,1,200,72Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.77,73a8,8,0,0,0-8.21.39L208,97.05V72a16,16,0,0,0-16-16H113.06a8,8,0,0,0,0,16H192v87.63a8,8,0,0,0,16,0V159l35.56,23.71A8,8,0,0,0,248,184a8,8,0,0,0,8-8V80A8,8,0,0,0,251.77,73ZM240,161.05l-32-21.33V116.28L240,95ZM53.92,34.62A8,8,0,1,0,42.08,45.38L51.73,56H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H182.64l19.44,21.38a8,8,0,1,0,11.84-10.76ZM32,184V72H66.28L168.1,184Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M256,80.23v95.45a8.33,8.33,0,0,1-3.86,7.17,8,8,0,0,1-8.58-.19l-33.78-22.52a4,4,0,0,1-1.78-3.33V99.19a4,4,0,0,1,1.78-3.32l33.78-22.53a8,8,0,0,1,9.73.66A8.23,8.23,0,0,1,256,80.23ZM53.92,34.62A8,8,0,1,0,42.08,45.38L51.73,56H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H182.64l19.44,21.38a8,8,0,1,0,11.84-10.76ZM185,155.07a4,4,0,0,0,7-2.7V72a16,16,0,0,0-16-16H104a4,4,0,0,0-3,6.69Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M250.83,74.71a6,6,0,0,0-6.16.3L206,100.79V72a14,14,0,0,0-14-14H113.06a6,6,0,0,0,0,12H192a2,2,0,0,1,2,2v87.63a6,6,0,0,0,12,0v-4.42L244.67,181a6,6,0,0,0,9.33-5V80A6,6,0,0,0,250.83,74.71ZM242,164.79l-36-24V115.21l36-24ZM52.44,36A6,6,0,0,0,43.56,44L56.25,58H32A14,14,0,0,0,18,72V184a14,14,0,0,0,14,14H183.53l20,22a6,6,0,0,0,8.88-8.08ZM32,186a2,2,0,0,1-2-2V72a2,2,0,0,1,2-2H67.16L172.62,186Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M251.77,73a8,8,0,0,0-8.21.39L208,97.05V72a16,16,0,0,0-16-16H113.06a8,8,0,0,0,0,16H192v87.63a8,8,0,0,0,16,0V159l35.56,23.71A8,8,0,0,0,248,184a8,8,0,0,0,8-8V80A8,8,0,0,0,251.77,73ZM240,161.05l-32-21.33V116.28L240,95ZM53.92,34.62A8,8,0,1,0,42.08,45.38L51.73,56H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H182.64l19.44,21.38a8,8,0,1,0,11.84-10.76ZM32,184V72H66.28L168.1,184Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M249.89,76.47a4,4,0,0,0-4.11.2L204,104.53V72a12,12,0,0,0-12-12H113.06a4,4,0,0,0,0,8H192a4,4,0,0,1,4,4v87.63a4,4,0,0,0,8,0v-8.16l41.78,27.86A4,4,0,0,0,252,176V80A4,4,0,0,0,249.89,76.47ZM244,168.53l-40-26.67V114.14l40-26.67ZM51,37.31A4,4,0,0,0,45,42.69L60.78,60H32A12,12,0,0,0,20,72V184a12,12,0,0,0,12,12H184.41L205,218.69a4,4,0,1,0,5.92-5.38ZM32,188a4,4,0,0,1-4-4V72a4,4,0,0,1,4-4H68.05L177.14,188Z"
        }))
    ]
]);


const $0eee0b1d53174355$export$e227a0e5d7fa29a5 = $7fPBF.forwardRef((o, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, o), {
        weights: (0, $c8e1cb9275e810e4$export$2e2bcd8739ae039)
    })));
$0eee0b1d53174355$export$e227a0e5d7fa29a5.displayName = "VideoCameraSlashIcon";
const $0eee0b1d53174355$export$189fd573e21c4133 = $0eee0b1d53174355$export$e227a0e5d7fa29a5;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $10b2d763e3e38d62$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm-6-82V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,172Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm-4-84V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,172Z"
        }))
    ]
]);


const $a44ba7e85f055b31$export$9f0af3ec4c4725c2 = $7fPBF.forwardRef((o, n)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: n
    }, o), {
        weights: (0, $10b2d763e3e38d62$export$2e2bcd8739ae039)
    })));
$a44ba7e85f055b31$export$9f0af3ec4c4725c2.displayName = "WarningCircleIcon";
const $a44ba7e85f055b31$export$66bc182bb95bd3c2 = $a44ba7e85f055b31$export$9f0af3ec4c4725c2;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $86f7d1e867e705bf$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z"
        }))
    ]
]);


const $e0770788fd5741d9$export$f7dc499a72baa103 = $7fPBF.forwardRef((n, a)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: a
    }, n), {
        weights: (0, $86f7d1e867e705bf$export$2e2bcd8739ae039)
    })));
$e0770788fd5741d9$export$f7dc499a72baa103.displayName = "WarningIcon";
const $e0770788fd5741d9$export$c688898c4e3580ee = $e0770788fd5741d9$export$f7dc499a72baa103;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $b20dc302f7630ea4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M116,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0ZM236,91.55v72.9a19.86,19.86,0,0,1-5.86,14.14l-51.55,51.55A19.85,19.85,0,0,1,164.45,236H91.55a19.85,19.85,0,0,1-14.14-5.86L25.86,178.59A19.86,19.86,0,0,1,20,164.45V91.55a19.86,19.86,0,0,1,5.86-14.14L77.41,25.86A19.85,19.85,0,0,1,91.55,20h72.9a19.85,19.85,0,0,1,14.14,5.86l51.55,51.55A19.86,19.86,0,0,1,236,91.55Zm-24,1.66L162.79,44H93.21L44,93.21v69.58L93.21,212h69.58L212,162.79ZM128,156a16,16,0,1,0,16,16A16,16,0,0,0,128,156Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,91.55v72.9a8,8,0,0,1-2.34,5.66l-51.55,51.55a8,8,0,0,1-5.66,2.34H91.55a8,8,0,0,1-5.66-2.34L34.34,170.11A8,8,0,0,1,32,164.45V91.55a8,8,0,0,1,2.34-5.66L85.89,34.34A8,8,0,0,1,91.55,32h72.9a8,8,0,0,1,5.66,2.34l51.55,51.55A8,8,0,0,1,224,91.55Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M122,136V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0ZM230,91.55v72.9a13.92,13.92,0,0,1-4.1,9.9L174.35,225.9a13.92,13.92,0,0,1-9.9,4.1H91.55a13.92,13.92,0,0,1-9.9-4.1L30.1,174.35a13.92,13.92,0,0,1-4.1-9.9V91.55a13.92,13.92,0,0,1,4.1-9.9L81.65,30.1a13.92,13.92,0,0,1,9.9-4.1h72.9a13.92,13.92,0,0,1,9.9,4.1L225.9,81.65A13.92,13.92,0,0,1,230,91.55Zm-12,0a2,2,0,0,0-.59-1.42L165.87,38.59a2,2,0,0,0-1.42-.59H91.55a2,2,0,0,0-1.41.59L38.58,90.13A2,2,0,0,0,38,91.55v72.9a2,2,0,0,0,.59,1.42l51.54,51.54a2,2,0,0,0,1.42.59h72.9a2,2,0,0,0,1.41-.59l51.56-51.54a2,2,0,0,0,.58-1.42ZM128,162a10,10,0,1,0,10,10A10,10,0,0,0,128,162Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M124,136V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0ZM228,91.55v72.9a12,12,0,0,1-3.51,8.49l-51.55,51.55a12,12,0,0,1-8.49,3.51H91.55a12,12,0,0,1-8.49-3.51L31.51,172.94A12,12,0,0,1,28,164.45V91.55a12,12,0,0,1,3.51-8.49L83.06,31.51A12,12,0,0,1,91.55,28h72.9a12,12,0,0,1,8.49,3.51l51.55,51.55A12,12,0,0,1,228,91.55Zm-8,0a4,4,0,0,0-1.17-2.83L167.28,37.17A4.06,4.06,0,0,0,164.45,36H91.55a4.06,4.06,0,0,0-2.83,1.17L37.17,88.72A4,4,0,0,0,36,91.55v72.9a4,4,0,0,0,1.17,2.83l51.55,51.55A4.06,4.06,0,0,0,91.55,220h72.9a4.06,4.06,0,0,0,2.83-1.17l51.55-51.55a4,4,0,0,0,1.17-2.83ZM128,164a8,8,0,1,0,8,8A8,8,0,0,0,128,164Z"
        }))
    ]
]);


const $dd4997cb53138a7f$export$d724908cf9d2c1d6 = $7fPBF.forwardRef((a, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, a), {
        weights: (0, $b20dc302f7630ea4$export$2e2bcd8739ae039)
    })));
$dd4997cb53138a7f$export$d724908cf9d2c1d6.displayName = "WarningOctagonIcon";
const $dd4997cb53138a7f$export$b3ab82ed3bd4a42 = $dd4997cb53138a7f$export$d724908cf9d2c1d6;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $e7a8b8d2e369a10f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,84a36,36,0,1,0-36-36A36,36,0,0,0,176,84Zm0-48a12,12,0,1,1-12,12A12,12,0,0,1,176,36Zm29.28,96.39a12,12,0,0,1,2.49,10l-16,80A12,12,0,0,1,180,232a11.87,11.87,0,0,1-2.36-.23,12,12,0,0,1-9.42-14.12L181.36,152H124a12,12,0,0,1-10.4-18l17.92-31.2a76.1,76.1,0,0,0-79.88,10.55A12,12,0,0,1,36.36,94.86a100,100,0,0,1,118.19-6.68,12,12,0,0,1,3.85,16L144.74,128H196A12,12,0,0,1,205.28,132.39Zm-41.47,44.52a64,64,0,1,1-73.64-68.16,12,12,0,0,1,3.66,23.72,40,40,0,1,0,46.05,42.62,12,12,0,1,1,23.93,1.82Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M200,48a24,24,0,1,1-24-24A24,24,0,0,1,200,48Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,80a32,32,0,1,0-32-32A32,32,0,0,0,176,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,176,32Zm-8,136a64,64,0,1,1-64-64,8,8,0,0,1,0,16,48,48,0,1,0,48,48,8,8,0,0,1,16,0Zm38.19-37.07a8,8,0,0,1,1.65,6.64l-16,80A8,8,0,0,1,184,224a7.77,7.77,0,0,1-1.58-.16,8,8,0,0,1-6.27-9.41L190.24,144H128a8,8,0,0,1-6.94-12l20.06-34.9a80.09,80.09,0,0,0-88,9.17A8,8,0,1,1,42.91,94a96,96,0,0,1,113.46-6.42,8,8,0,0,1,2.57,10.69L141.82,128H200A8,8,0,0,1,206.19,130.93Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,48a32,32,0,1,1,32,32A32,32,0,0,1,144,48Zm16,112a8,8,0,0,0-8,8,48,48,0,1,1-48-48,8,8,0,0,0,0-16,64,64,0,1,0,64,64A8,8,0,0,0,160,160Zm40-32H141.82l17.12-29.78a8,8,0,0,0-2.57-10.69A96,96,0,0,0,42.91,94a8,8,0,1,0,10.18,12.33,80.09,80.09,0,0,1,88-9.17L121.06,132A8,8,0,0,0,128,144h62.24l-14.08,70.43a8,8,0,0,0,6.27,9.41A7.77,7.77,0,0,0,184,224a8,8,0,0,0,7.83-6.43l16-80A8,8,0,0,0,200,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,78a30,30,0,1,0-30-30A30,30,0,0,0,176,78Zm0-48a18,18,0,1,1-18,18A18,18,0,0,1,176,30ZM166,168a62,62,0,1,1-62-62,6,6,0,0,1,0,12,50,50,0,1,0,50,50,6,6,0,0,1,12,0Zm38.64-35.8a6,6,0,0,1,1.24,5l-16,80A6,6,0,0,1,184,222a6.08,6.08,0,0,1-1.19-.12,6,6,0,0,1-4.7-7.06L192.68,142H128a6,6,0,0,1-5.2-9l21.07-36.68a82.05,82.05,0,0,0-92.05,8.41,6,6,0,1,1-7.64-9.25,94,94,0,0,1,111.1-6.28,6,6,0,0,1,1.92,8L138.37,130H200A6,6,0,0,1,204.64,132.2Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,80a32,32,0,1,0-32-32A32,32,0,0,0,176,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,176,32Zm-8,136a64,64,0,1,1-64-64,8,8,0,0,1,0,16,48,48,0,1,0,48,48,8,8,0,0,1,16,0Zm38.19-37.07a8,8,0,0,1,1.65,6.64l-16,80A8,8,0,0,1,184,224a7.77,7.77,0,0,1-1.58-.16,8,8,0,0,1-6.27-9.41L190.24,144H128a8,8,0,0,1-6.94-12l20.06-34.9a80.09,80.09,0,0,0-88,9.17A8,8,0,1,1,42.91,94a96,96,0,0,1,113.46-6.42,8,8,0,0,1,2.57,10.69L141.82,128H200A8,8,0,0,1,206.19,130.93Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M176,76a28,28,0,1,0-28-28A28,28,0,0,0,176,76Zm0-48a20,20,0,1,1-20,20A20,20,0,0,1,176,28ZM164,168a60,60,0,1,1-60-60,4,4,0,0,1,0,8,52,52,0,1,0,52,52,4,4,0,0,1,8,0Zm39.09-34.54a4,4,0,0,1,.83,3.32l-16,80A4,4,0,0,1,184,220a3.44,3.44,0,0,1-.78-.08,4,4,0,0,1-3.14-4.7l15-75.22H128a4,4,0,0,1-3.47-6l22.08-38.42a84.05,84.05,0,0,0-96.06,7.61A4,4,0,0,1,45.45,97a92,92,0,0,1,108.73-6.15,4,4,0,0,1,1.29,5.34L134.91,132H200A4,4,0,0,1,203.09,133.46Z"
        }))
    ]
]);


const $47d7fdd528e7358c$export$70f2a162da142226 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $e7a8b8d2e369a10f$export$2e2bcd8739ae039)
    })));
$47d7fdd528e7358c$export$70f2a162da142226.displayName = "WheelchairMotionIcon";
const $47d7fdd528e7358c$export$e9d9aed032f78cf2 = $47d7fdd528e7358c$export$70f2a162da142226;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $dc69b3668a951ff0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M144,204a16,16,0,1,1-16-16A16,16,0,0,1,144,204ZM239.61,83.91a176,176,0,0,0-223.22,0,12,12,0,1,0,15.23,18.55,152,152,0,0,1,192.76,0,12,12,0,1,0,15.23-18.55Zm-32.16,35.73a128,128,0,0,0-158.9,0,12,12,0,0,0,14.9,18.81,104,104,0,0,1,129.1,0,12,12,0,0,0,14.9-18.81ZM175.07,155.3a80.05,80.05,0,0,0-94.14,0,12,12,0,0,0,14.14,19.4,56,56,0,0,1,65.86,0,12,12,0,1,0,14.14-19.4Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M238.2,87.69l-104,125.43a8,8,0,0,1-12.3,0L17.8,87.69a7.79,7.79,0,0,1,1.31-11.21,180.75,180.75,0,0,1,217.78,0A7.79,7.79,0,0,1,238.2,87.69Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M247.89,80.91a15.93,15.93,0,0,0-6.17-10.81A186.67,186.67,0,0,0,128,32,186.67,186.67,0,0,0,14.28,70.1,15.93,15.93,0,0,0,8.11,80.91,15.65,15.65,0,0,0,11.65,92.8l104,125.43A15.93,15.93,0,0,0,128,224h0a15.93,15.93,0,0,0,12.31-5.77l104-125.43A15.65,15.65,0,0,0,247.89,80.91ZM128,208,24.09,82.74A170.76,170.76,0,0,1,128,48,170.76,170.76,0,0,1,231.91,82.74Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M244.35,92.8l-104,125.43A15.93,15.93,0,0,1,128,224h0a15.93,15.93,0,0,1-12.31-5.77L11.65,92.8A15.65,15.65,0,0,1,8.11,80.91,15.93,15.93,0,0,1,14.28,70.1,186.67,186.67,0,0,1,128,32,186.67,186.67,0,0,1,241.72,70.1a15.93,15.93,0,0,1,6.17,10.81A15.65,15.65,0,0,1,244.35,92.8Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M138,204a10,10,0,1,1-10-10A10,10,0,0,1,138,204ZM235.81,88.55a170,170,0,0,0-215.62,0,6,6,0,1,0,7.62,9.27,158,158,0,0,1,200.38,0,6,6,0,1,0,7.62-9.27Zm-32.08,35.79a122,122,0,0,0-151.46,0,6,6,0,0,0,7.46,9.41,110,110,0,0,1,136.54,0A6,6,0,0,0,200,135a6,6,0,0,0,3.73-10.7Zm-32.2,35.81a74,74,0,0,0-87.06,0,6,6,0,0,0,7.06,9.7,62,62,0,0,1,72.94,0,6,6,0,0,0,8.38-1.32A6,6,0,0,0,171.53,160.15Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M140,204a12,12,0,1,1-12-12A12,12,0,0,1,140,204ZM237.08,87A172,172,0,0,0,18.92,87,8,8,0,0,0,29.08,99.37a156,156,0,0,1,197.84,0A8,8,0,0,0,237.08,87ZM205,122.77a124,124,0,0,0-153.94,0A8,8,0,0,0,61,135.31a108,108,0,0,1,134.06,0,8,8,0,0,0,11.24-1.3A8,8,0,0,0,205,122.77Zm-32.26,35.76a76.05,76.05,0,0,0-89.42,0,8,8,0,0,0,9.42,12.94,60,60,0,0,1,70.58,0,8,8,0,1,0,9.42-12.94Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M136,204a8,8,0,1,1-8-8A8,8,0,0,1,136,204ZM234.54,90.1a168,168,0,0,0-213.08,0,4,4,0,1,0,5.08,6.18,160,160,0,0,1,202.92,0,4,4,0,0,0,5.08-6.18Zm-32.06,35.81a120,120,0,0,0-149,0,4,4,0,0,0,5,6.27,112,112,0,0,1,139,0,4,4,0,0,0,5-6.27Zm-32.13,35.86a72,72,0,0,0-84.7,0,4,4,0,1,0,4.7,6.46,64.07,64.07,0,0,1,75.3,0,4,4,0,0,0,5.58-.87A4,4,0,0,0,170.35,161.77Z"
        }))
    ]
]);


const $e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5 = $7fPBF.forwardRef((e, r)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: r
    }, e), {
        weights: (0, $dc69b3668a951ff0$export$2e2bcd8739ae039)
    })));
$e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5.displayName = "WifiHighIcon";
const $e1dc4c4bf0ea2b94$export$d379813183cf10c8 = $e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $747258aaf7db1bda$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M230.47,67.5a12,12,0,0,0-19.26-4.32L172.43,99l-12.68-2.72L157,83.57l35.79-38.78a12,12,0,0,0-4.32-19.26A76.07,76.07,0,0,0,88.41,121.64L30.92,174.18a4.68,4.68,0,0,0-.39.38,36,36,0,0,0,50.91,50.91l.38-.39,52.54-57.49A76.05,76.05,0,0,0,230.47,67.5ZM160,148a51.5,51.5,0,0,1-23.35-5.52,12,12,0,0,0-14.26,2.62L64.31,208.66a12,12,0,0,1-17-17l63.55-58.07a12,12,0,0,0,2.62-14.26A51.5,51.5,0,0,1,108,96a52.06,52.06,0,0,1,52-52h.89L135.17,71.87a12,12,0,0,0-2.91,10.65l5.66,26.35a12,12,0,0,0,9.21,9.21l26.35,5.66a12,12,0,0,0,10.65-2.91L212,95.12c0,.3,0,.59,0,.89A52.06,52.06,0,0,1,160,148Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,96a64,64,0,0,1-94.94,56L73,217A24,24,0,0,1,39,183L104,126.94a64,64,0,0,1,80-90.29L144,80l5.66,26.34L176,112l43.35-40A63.8,63.8,0,0,1,224,96Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M232,96a72,72,0,0,1-100.94,66L79,222.22c-.12.14-.26.29-.39.42a32,32,0,0,1-45.26-45.26c.14-.13.28-.27.43-.39L94,124.94a72.07,72.07,0,0,1,83.54-98.78,8,8,0,0,1,3.93,13.19L144,80l5.66,26.35L176,112l40.65-37.52a8,8,0,0,1,13.19,3.93A72.6,72.6,0,0,1,232,96Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224.91,69.75a6,6,0,0,0-9.63-2.16l-41.07,37.9L154.7,101.3l-4.19-19.51,37.9-41.07a6,6,0,0,0-2.16-9.63,70,70,0,0,0-89.77,94.39l-61.39,53c-.11.09-.21.19-.32.3A30,30,0,0,0,77.2,221.23c.11-.11.21-.21.3-.32l53-61.39a70,70,0,0,0,94.39-89.77ZM160,154a58,58,0,0,1-28-7.22,6,6,0,0,0-7.45,1.33L68.57,212.88a18,18,0,0,1-25.45-25.45l64.76-55.94A6,6,0,0,0,109.2,124a58,58,0,0,1,64-84.53L139.58,75.93a6,6,0,0,0-1.45,5.33l5.65,26.35a6,6,0,0,0,4.61,4.61l26.35,5.65a6,6,0,0,0,5.33-1.45L216.49,82.8A58.06,58.06,0,0,1,160,154Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M223.05,70.5a4,4,0,0,0-6.42-1.44l-41.82,38.6L153,103l-4.68-21.79,38.6-41.82a4,4,0,0,0-1.44-6.43A68,68,0,0,0,98.94,126L36.4,180l-.21.2a28,28,0,0,0,39.6,39.6l.2-.21,54-62.54A68,68,0,0,0,228,96,67.51,67.51,0,0,0,223.05,70.5ZM160,156a60,60,0,0,1-29-7.47,4,4,0,0,0-5,.89L70,214.25A20,20,0,0,1,41.75,186l64.82-56a4,4,0,0,0,.89-5,60,60,0,0,1,69.46-86.59L141.05,77.29a4,4,0,0,0-1,3.55l5.66,26.35a4,4,0,0,0,3.07,3.07l26.35,5.66a4,4,0,0,0,3.55-1l38.87-35.87A60.05,60.05,0,0,1,160,156Z"
        }))
    ]
]);


const $52a0c24a3d3e2214$export$bc176c2a10341979 = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $747258aaf7db1bda$export$2e2bcd8739ae039)
    })));
$52a0c24a3d3e2214$export$bc176c2a10341979.displayName = "WrenchIcon";
const $52a0c24a3d3e2214$export$4421f7c88022a750 = $52a0c24a3d3e2214$export$bc176c2a10341979;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $a0c0ddd5f94cc7bc$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M168.49,104.49,145,128l23.52,23.51a12,12,0,0,1-17,17L128,145l-23.51,23.52a12,12,0,0,1-17-17L111,128,87.51,104.49a12,12,0,0,1,17-17L128,111l23.51-23.52a12,12,0,0,1,17,17ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,130.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M164.24,100.24,136.48,128l27.76,27.76a6,6,0,1,1-8.48,8.48L128,136.48l-27.76,27.76a6,6,0,0,1-8.48-8.48L119.52,128,91.76,100.24a6,6,0,0,1,8.48-8.48L128,119.52l27.76-27.76a6,6,0,0,1,8.48,8.48ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M162.83,98.83,133.66,128l29.17,29.17a4,4,0,0,1-5.66,5.66L128,133.66,98.83,162.83a4,4,0,0,1-5.66-5.66L122.34,128,93.17,98.83a4,4,0,0,1,5.66-5.66L128,122.34l29.17-29.17a4,4,0,1,1,5.66,5.66ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z"
        }))
    ]
]);


const $99a54942b2884ad1$export$a5090bbd7fc88fde = $7fPBF.forwardRef((r, c)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: c
    }, r), {
        weights: (0, $a0c0ddd5f94cc7bc$export$2e2bcd8739ae039)
    })));
$99a54942b2884ad1$export$a5090bbd7fc88fde.displayName = "XCircleIcon";
const $99a54942b2884ad1$export$b60d12aebd1d3ca4 = $99a54942b2884ad1$export$a5090bbd7fc88fde;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $21df6df7a27c94c9$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("path", {
            d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"
        }))
    ]
]);


const $b8682947bc7c82d8$export$5e658a8851ae9322 = $7fPBF.forwardRef((r, t)=>/* @__PURE__ */ $7fPBF.createElement((0, $57773c22414cc39f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: t
    }, r), {
        weights: (0, $21df6df7a27c94c9$export$2e2bcd8739ae039)
    })));
$b8682947bc7c82d8$export$5e658a8851ae9322.displayName = "XIcon";
const $b8682947bc7c82d8$export$78acf4525d8a74c4 = $b8682947bc7c82d8$export$5e658a8851ae9322;





parcelRequire("7fPBF");
const $00b3ccebbd02c720$var$SvgAirbnb = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 3c-2.722 0-5.478 1.427-6.9 4.215a1470.458 1470.458 0 0 0-8.717 17.172 395.607 395.607 0 0 0-3.174 6.498c-.82 1.731-1.347 2.88-1.563 3.566l-.001.002v.002c-.287.932-.594 2.026-.594 3.256C4.05 42.832 8.23 47 13.359 47c5.674 0 9.677-4.539 11.553-6.69l.088.114.088-.113C26.964 42.46 30.968 47 36.64 47c5.128 0 9.308-4.168 9.308-9.29 0-1.229-.307-2.323-.594-3.255v-.002l-.001-.002c-.216-.686-.743-1.835-1.563-3.566a395.62 395.62 0 0 0-3.174-6.498c-2.52-5.066-5.71-11.335-8.717-17.172l-.002-.002C30.476 4.427 27.721 3 25 3zm0 2c2.038 0 4.042 1.013 5.12 3.125v.002h.001a1470.142 1470.142 0 0 1 8.707 17.15 393.642 393.642 0 0 1 3.156 6.463c.81 1.71 1.358 2.984 1.46 3.305.273.888.505 1.776.505 2.666A7.281 7.281 0 0 1 36.641 45c-4.577 0-8.45-4.147-10.332-6.252l1.058-1.353C29.07 35.216 32 31.09 32 26.959 32 23.127 28.848 20 25 20s-7 3.127-7 6.959c0 4.14 2.932 8.263 4.633 10.437l1.058 1.354C21.808 40.855 17.935 45 13.36 45a7.281 7.281 0 0 1-7.308-7.29c0-.89.232-1.777.506-2.665.1-.32.65-1.596 1.459-3.305.81-1.71 1.899-3.936 3.156-6.463a1470.142 1470.142 0 0 1 8.707-17.15h.002v-.002C20.958 6.013 22.96 5 25 5zm0 17c2.77 0 5 2.219 5 4.959 0 3.111-2.609 7.157-4.209 9.205L25 37.178l-.793-1.014C22.608 34.12 20 30.083 20 26.96 20 24.219 22.23 22 25 22z"
        })
    }));
var $00b3ccebbd02c720$export$2e2bcd8739ae039 = $00b3ccebbd02c720$var$SvgAirbnb;





parcelRequire("7fPBF");
const $c8355b7723d13ecc$var$SvgAmazon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.406 3c-6.101 0-12.82 2.313-14.218 9.813-.2.8.406 1.18.906 1.28l6.219.595c.601 0 .988-.586 1.187-1.188.5-2.602 2.695-3.906 5.094-3.906 1.3 0 2.793.52 3.593 1.719.899 1.3.72 3.093.72 4.593v.906c-3.7.399-8.5.688-12 2.188-4 1.7-6.813 5.207-6.813 10.406 0 6.602 4.199 9.907 9.5 9.907 4.5 0 7-1.118 10.5-4.72 1.199 1.7 1.617 2.512 3.718 4.313.2.102.395.188.594.188.301 0 .606-.082.907-.282v.094c1.3-1.101 3.574-3.21 4.874-4.312.5-.399.399-1.086 0-1.688-1.199-1.5-2.374-2.906-2.374-5.906v-9.906c0-4.2.289-8.102-2.813-11C32.5 3.793 28.508 3 25.406 3Zm0 2c2.7 0 6.188.695 8.188 2.594 2.101 2 2.218 4.5 2.218 8.5V27c0 3.3 1.274 5.094 2.376 6.594-.301.199-.575.511-.876.812v-.093l-2.906 2.593c-1.101-1-1.52-1.593-2.218-2.593-.102-.2-.301-.418-.5-.72l-1.375-2-1.72 1.72c-3.1 3.199-5.1 4.093-9 4.093-4.698 0-7.5-3.008-7.5-7.906 0-4 1.993-6.992 5.595-8.594 2.601-1.101 6.3-1.511 9.5-1.812.699-.102 1.304-.086 1.906-.188l1.812-.218V15.5c0-1.602.008-3.488-1.093-5.187-1.102-1.602-3.02-2.626-5.22-2.626-3.398 0-6.105 1.907-6.905 4.907l-4.188-.406C15.102 5.988 21.605 5 25.406 5Zm1.688 15c-7.899.5-9.594 4.805-9.594 8.406C17.398 32.305 19.813 35 23.313 35c2.5 0 4.789-1.508 6.187-3.906 1.398-2.5 1.406-4.79 1.406-7.188V20Zm0 2h1.812v1.406c0 2.5.082 4.489-1.218 6.688-1 1.8-2.676 2.906-4.375 2.906-2.399 0-3.907-1.793-3.907-4.594 0-4.699 3.688-6.105 7.688-6.406Zm17.594 14.594c-1.602 0-3.477.406-4.876 1.406-.398.3-.406.688.094.688 1.602-.2 5.207-.68 5.907.218.601.801-.711 4.18-1.313 5.782-.2.5.195.613.594.312 2.699-2.3 3.406-6.992 2.906-7.594-.3-.5-1.71-.812-3.312-.812ZM2.313 37.5c-.301 0-.524.512-.126.813C8.188 43.71 16.2 47 25 47c6.3 0 13.586-1.988 18.688-5.687.8-.602.113-1.618-.688-1.22-5.7 2.4-11.805 3.594-17.406 3.594-8.301 0-16.282-2.3-22.781-6-.2-.199-.399-.187-.5-.187Z"
        })
    }));
var $c8355b7723d13ecc$export$2e2bcd8739ae039 = $c8355b7723d13ecc$var$SvgAmazon;





parcelRequire("7fPBF");
const $5433efa7792edf57$var$SvgAmazonMusic = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm20 12.01a1 1 0 0 0 0 2 1 1 0 0 0 0-2zm-24.75 3v7h1.5v-5.14c.493-.12.987-.234 1.477-.364.5-.136.975.234 1.017.66l.008 4.844h1.5l.002-2.5.006-1.25-.006-.625-.004-.317a2.47 2.47 0 0 0-.06-.433c.512-.124 1.027-.244 1.537-.38.5-.136.975.236 1.017.661l.008 4.844h1.5l.002-2.5.006-1.25-.006-.625-.004-.317a2.223 2.223 0 0 0-1.158-1.879 2.179 2.179 0 0 0-1.733-.14c-.566.193-1.127.402-1.69.61a2.178 2.178 0 0 0-.577-.47 2.179 2.179 0 0 0-1.733-.14c-.371.127-.74.266-1.109.4v-.69h-1.5zm12.5 0-1.498.002.002 2.42c-.01.823-.017 1.577.01 2.457.043.614.376 1.173.818 1.529.445.361.991.55 1.533.586a2.776 2.776 0 0 0 1.516-.344c.04-.02.079-.045.119-.066v.234h1.5v-6.816h-1.5v5.353c-.212.074-.425.143-.633.225-.352.149-.579.174-.885.14-.574-.07-1.011-.527-.976-.918.009-.732.012-1.592-.002-2.382l-.004-2.42zm11.5 0v7h1.5v-7h-1.5zm5.975.004c-.355.02-.71.1-1.036.24-1.32.578-1.969 1.937-1.939 3.148.01.568.1 1.163.35 1.75.26.57.72 1.137 1.35 1.463.62.335 1.32.43 1.95.383.38-.037.75-.103 1.1-.215V26.76c-.89.14-1.77.14-2.33-.242-.63-.391-.93-1.23-.92-2.133-.02-.82.38-1.603 1.06-1.977.64-.345 1.47-.205 2.19.29v-1.231c-.23-.14-.47-.25-.74-.334a3.025 3.025 0 0 0-1.035-.12zm-9.52.011a3.707 3.707 0 0 0-.785.157c-.883.278-1.515.873-1.602 1.482-.162 1.14.672 1.806 1.082 1.99.41.222.78.32 1.12.416.69.165 1.128.352 1.287.598a.675.675 0 0 1 .123.418c0 .18-.04.341-.23.457-.39.213-1.06.29-1.67.223-.61-.058-1.39-.33-2.03-.59v1.074c.59.367 1.22.562 1.87.678.77.106 1.56.174 2.45-.213.43-.174.951-.563.951-1.621 0-1.104-.8-1.59-1.2-1.783-.4-.203-.77-.3-1.11-.407-.33-.107-1.201-.249-1.201-1 0-.313.33-.487.58-.564.84-.28 1.83-.065 2.66.361v-1.238a4.447 4.447 0 0 0-2.295-.438zm9.899 9.985c-1.111 0-2.43.28-3.403.98-.278.21-.278.49.069.49 1.11-.14 3.611-.49 4.097.14.417.56-.485 2.942-.902 4.062-.14.35.14.419.418.209 1.875-1.611 2.361-4.903 2.013-5.323-.208-.349-1.181-.558-2.292-.558zm-30.641.761a.249.249 0 0 0-.147.088.253.253 0 0 0 .038.354c2.06 1.668 4.39 2.94 6.857 3.93 2.474.958 5.097 1.614 7.785 1.794a25.292 25.292 0 0 0 7.986-.73c2.597-.672 5.072-1.705 7.286-3.275a.5.5 0 0 0-.498-.862l-.04.018c-2.265 1.043-4.727 1.775-7.17 2.28-2.451.51-4.964.703-7.449.616-2.49-.1-4.965-.597-7.398-1.289-2.414-.74-4.82-1.671-7.068-2.888l-.016-.01a.248.248 0 0 0-.166-.026z"
        })
    }));
var $5433efa7792edf57$export$2e2bcd8739ae039 = $5433efa7792edf57$var$SvgAmazonMusic;





parcelRequire("7fPBF");
const $a3a92e462d72dd79$var$SvgAndroidOs = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16.375-.031c-.043.008-.086.02-.125.031a1.004 1.004 0 0 0-.719.621.99.99 0 0 0 .125.942l2.125 3.187c-3.597 1.89-6.18 5.152-6.781 9.031V14c-.004.05-.004.105 0 .156v1.406A3.93 3.93 0 0 0 9 15c-2.2 0-4 1.8-4 4v12c0 2.2 1.8 4 4 4a3.93 3.93 0 0 0 2-.562V37c0 1.645 1.355 3 3 3h1v6c0 2.2 1.8 4 4 4s4-1.8 4-4v-6h4v6c0 2.2 1.8 4 4 4s4-1.8 4-4v-6h1c1.645 0 3-1.355 3-3v-2.562A3.93 3.93 0 0 0 41 35c2.2 0 4-1.8 4-4V19c0-2.2-1.8-4-4-4a3.93 3.93 0 0 0-2 .563v-1.376a1.13 1.13 0 0 0 0-.28v-.063c-.582-3.906-3.164-7.196-6.781-9.094l2.125-3.187a.993.993 0 0 0 .023-1.137 1 1 0 0 0-1.68.012l-2.343 3.468C28.695 3.312 26.883 3 25 3c-1.883 0-3.695.313-5.344.906L17.313.438c-.2-.32-.563-.5-.938-.47ZM25 5c1.879 0 3.64.367 5.188 1.031a.879.879 0 0 0 .093.032C33.411 7.433 35.688 10 36.563 13H13.436c.864-2.957 3.094-5.492 6.157-6.875a.842.842 0 0 0 .187-.094C21.336 5.36 23.11 5 25 5Zm-5.5 3c-.832 0-1.5.672-1.5 1.5 0 .832.668 1.5 1.5 1.5a1.5 1.5 0 0 0 0-3Zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 15h24v22c0 .563-.437 1-1 1h-7.812a1.016 1.016 0 0 0-.407 0H16.188a1.016 1.016 0 0 0-.407 0H14c-.562 0-1-.437-1-1Zm-4 2c1.117 0 2 .883 2 2v12c0 1.117-.883 2-2 2s-2-.883-2-2V19c0-1.117.883-2 2-2Zm32 0c1.117 0 2 .883 2 2v12c0 1.117-.883 2-2 2s-2-.883-2-2V19c0-1.117.883-2 2-2ZM17 40h4v6c0 1.117-.883 2-2 2s-2-.883-2-2Zm12 0h4v6c0 1.117-.883 2-2 2s-2-.883-2-2Z"
        })
    }));
var $a3a92e462d72dd79$export$2e2bcd8739ae039 = $a3a92e462d72dd79$var$SvgAndroidOs;





parcelRequire("7fPBF");
const $319817bcb0975b64$var$SvgAndroidTablet = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6.906 7.969A.88.88 0 0 0 6.813 8H3c-1.645 0-3 1.355-3 3v28c0 1.645 1.355 3 3 3h44c1.645 0 3-1.355 3-3V11c0-1.645-1.355-3-3-3h-2.812a.972.972 0 0 0-.282-.031c-.043.008-.086.02-.125.031H7.22a.936.936 0 0 0-.313-.031ZM3 10h3v30H3c-.555 0-1-.445-1-1V11c0-.555.445-1 1-1Zm5 0h35v30H8Zm37 0h2c.555 0 1 .445 1 1v28c0 .555-.445 1-1 1h-2Zm-22.594 6.969a.311.311 0 0 0-.062.031.498.498 0 0 0-.309.293.493.493 0 0 0 .027.426l.532 1.093a3.967 3.967 0 0 0-1.563 2.907c-.004.054-.031.101-.031.156A.668.668 0 0 0 21 22v6c0 .523.184 1.059.563 1.438.128.128.28.226.437.312V32c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-2h2v2c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-2.25c.156-.086.309-.184.438-.312.378-.38.562-.915.562-1.438v-5.844c.004-.05.004-.105 0-.156v-.125c0-.055-.027-.102-.031-.156a3.967 3.967 0 0 0-1.563-2.907l.532-1.093a.5.5 0 0 0-.563-.719.496.496 0 0 0-.312.281l-.5 1.032A4.013 4.013 0 0 0 25 18c-.55 0-1.082.11-1.562.313l-.5-1.032a.496.496 0 0 0-.47-.312h-.062ZM25 20c.809 0 1.43.387 1.75 1h-3.5c.32-.613.941-1 1.75-1Zm-21.094.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 3 22v6c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-6a1 1 0 0 0-1.094-1.031Zm15 0c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 18 22v5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-5a1 1 0 0 0-1.094-1.031Zm12 0c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 30 22v5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-5a1 1 0 0 0-1.094-1.031ZM23 23h4v4.969h-.094a.88.88 0 0 0-.093.031h-3.594a1.019 1.019 0 0 0-.219-.031Z"
        })
    }));
var $319817bcb0975b64$export$2e2bcd8739ae039 = $319817bcb0975b64$var$SvgAndroidTablet;





parcelRequire("7fPBF");
const $7562bb96cc645793$var$SvgAppleFitness = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.51 0-10 4.49-10 10v22c0 5.51 4.49 10 10 10h22c5.51 0 10-4.49 10-10v-22c0-5.51-4.49-10-10-10H14zm0 2h22c4.41 0 8 3.59 8 8v22c0 4.41-3.59 8-8 8H14c-4.41 0-8-3.59-8-8v-22c0-4.41 3.59-8 8-8zM25 8C15.63 8 8 15.63 8 25c0 9.37 7.63 17 17 17 .81 0 1.6-.06 2.38-.17C35.63 40.67 42 33.56 42 25c0-8.56-6.37-15.67-14.62-16.83.38.51.62 1.15.62 1.83 0 .85-.36 1.62-.93 2.17C33.26 13.16 38 18.53 38 25s-4.74 11.84-10.93 12.83c-.68.11-1.37.17-2.07.17-7.17 0-13-5.83-13-13s5.83-13 13-13c1.1 0 2-.9 2-2s-.9-2-2-2zm0 5c-6.62 0-12 5.38-12 12s5.38 12 12 12c.07 0 .14 0 .2-.01.76 0 1.5-.09 2.22-.23h.01C32.89 35.63 37 30.79 37 25s-4.11-10.63-9.57-11.76c.36.5.57 1.11.57 1.76 0 .89-.4 1.7-1.02 2.25C30.44 18.14 33 21.28 33 25c0 3.72-2.56 6.86-6.02 7.75-.63.16-1.3.25-1.98.25-4.41 0-8-3.59-8-8s3.59-8 8-8c1.1 0 2-.9 2-2 0-.13-.01-.25-.04-.38v-.02c-.02-.11-.05-.21-.09-.31-.03-.09-.08-.17-.12-.25-.04-.08-.09-.15-.14-.22-.12-.16-.25-.3-.41-.42-.01 0-.01-.01-.02-.02-.07-.05-.15-.09-.23-.14-.14-.07-.29-.13-.44-.17-.1-.03-.2-.05-.31-.06-.06-.01-.13-.01-.2-.01zm0 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.07 0 .14 0 .21-.01h.02c.01 0 .03 0 .04-.01h.02c.82-.02 1.59-.19 2.31-.49A6.99 6.99 0 0 0 32 25a6.99 6.99 0 0 0-4.4-6.49c.25.44.4.95.4 1.49 0 1.04-.54 1.96-1.34 2.5.8.54 1.34 1.46 1.34 2.5s-.54 1.96-1.34 2.5c-.48.31-1.05.5-1.66.5-1.65 0-3-1.35-3-3s1.35-3 3-3c1.1 0 2-.9 2-2 0-.13-.01-.25-.04-.38v-.02c-.02-.11-.05-.21-.09-.31-.01-.02-.02-.05-.03-.07-.04-.1-.09-.19-.14-.27-.05-.08-.1-.15-.16-.22a2.32 2.32 0 0 0-.32-.31c-.04-.04-.09-.06-.13-.09-.05-.03-.09-.06-.14-.09-.08-.04-.16-.07-.24-.11l-.21-.06c-.06-.02-.14-.04-.21-.05h-.02c-.01-.01-.03-.01-.04-.01h-.02C25.14 18 25.07 18 25 18z"
        })
    }));
var $7562bb96cc645793$export$2e2bcd8739ae039 = $7562bb96cc645793$var$SvgAppleFitness;





parcelRequire("7fPBF");
const $960c6f50f044d54a$var$SvgAppleLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M33.375 0c-2.836.191-5.871 1.879-7.75 4.156-1.645 2.004-3.023 4.946-2.5 8-.469-.144-.895-.16-1.406-.344-1.395-.496-2.989-1.03-4.969-1.03-3.934 0-7.96 2.34-10.5 6.25C2.555 22.71 3.297 32.706 8.906 41.25c.989 1.5 2.14 3.137 3.563 4.438 1.422 1.3 3.14 2.292 5.156 2.312 1.723.02 2.922-.555 4-1.031 1.078-.477 2.082-.899 3.969-.907h.031c1.879-.015 2.852.399 3.906.876 1.055.476 2.242 1.078 3.969 1.062 2.055-.016 3.8-1.14 5.25-2.531 1.45-1.39 2.64-3.098 3.625-4.594 1.41-2.148 1.977-3.32 3.063-5.719a1.001 1.001 0 0 0-.562-1.344c-3.556-1.343-5.583-4.488-5.876-7.812-.293-3.324 1.113-6.746 4.656-8.687.262-.141.446-.387.508-.676a1.007 1.007 0 0 0-.195-.825c-2.543-3.16-6.121-5.03-9.625-5.03-2.235 0-3.875.527-5.219 1.03-.223.086-.387.079-.594.157 1.364-.719 2.567-1.715 3.469-2.875 1.64-2.106 2.906-5.102 2.438-8.25A.999.999 0 0 0 33.375 0Zm-1.062 2.375c-.067 2.02-.758 3.996-1.907 5.469-1.203 1.547-3.226 2.617-5.187 2.937.035-1.941.8-3.953 1.968-5.375 1.227-1.484 3.258-2.554 5.125-3.031ZM16.75 12.781c1.613 0 2.906.418 4.281.906 1.375.489 2.824 1.063 4.532 1.063 1.667 0 2.988-.578 4.28-1.062 1.294-.485 2.583-.907 4.5-.907 2.505 0 5.212 1.301 7.344 3.563-3.414 2.41-5.011 6.168-4.687 9.812.324 3.684 2.543 7.18 6.188 9-.79 1.719-1.31 2.856-2.47 4.625-.956 1.457-2.093 3.051-3.343 4.25-1.25 1.2-2.574 1.957-3.906 1.969-1.285.012-2.016-.371-3.125-.875-1.11-.504-2.543-1.082-4.75-1.062-2.203.011-3.657.566-4.782 1.062-1.125.496-1.863.887-3.156.875-1.367-.012-2.636-.676-3.843-1.781-1.208-1.106-2.297-2.614-3.25-4.063-5.25-8-5.672-17.398-2.657-22.031 2.211-3.402 5.723-5.344 8.844-5.344Z"
        })
    }));
var $960c6f50f044d54a$export$2e2bcd8739ae039 = $960c6f50f044d54a$var$SvgAppleLogo;





parcelRequire("7fPBF");
const $c05f531d54f5030b$var$SvgAppleNews = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.49-10 10v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10v-22c0-5.51-4.489-10-10-10H14zm0 2h22c4.431 0 8 3.57 8 8v22c0 4.431-3.569 8-8 8H14c-4.431 0-8-3.569-8-8v-22c0-4.43 3.569-8 8-8zm-.25 6.26c-.827 0-1.5.673-1.5 1.5v6.31c0 .405.158.783.443 1.067l16.178 16.18c.285.286.664.443 1.068.443h6.311c.827 0 1.5-.673 1.5-1.5v-6.38c0-.398-.158-.774-.443-1.058l-16.121-16.12a1.487 1.487 0 0 0-1.055-.442H13.75zm13.12 0c-.604 0-1.145.362-1.397.963a1.514 1.514 0 0 0 .338 1.594l.18.14a28.377 28.377 0 0 1 9.062 9.065l.138.174c.283.284.661.435 1.057.435.192 0 .39-.035.58-.11.56-.235.92-.777.92-1.38V13.75c0-.827-.673-1.5-1.5-1.5h-9.379zm-12.62 2h5.666L35.75 30.084v5.666h-5.605L14.25 19.855V14.25zm14.299 0h7.201v7.203a30.219 30.219 0 0 0-7.201-7.203zM13.615 25.385a1.627 1.627 0 0 0-.445.103c-.56.236-.92.778-.92 1.381v9.381c0 .827.673 1.5 1.5 1.5h9.38a1.5 1.5 0 0 0 1.382-.922l.015-.04a1.514 1.514 0 0 0-.338-1.595l-.18-.14a28.377 28.377 0 0 1-9.062-9.065l-.138-.174a1.488 1.488 0 0 0-1.194-.43zm.635 3.162a30.219 30.219 0 0 0 7.201 7.203H14.25v-7.203z"
        })
    }));
var $c05f531d54f5030b$export$2e2bcd8739ae039 = $c05f531d54f5030b$var$SvgAppleNews;





parcelRequire("7fPBF");
const $596bbe84e95bafd3$var$SvgApplePay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9.984 15.002c-.835.04-1.866.571-2.455 1.318-.54.644-1.001 1.69-.884 2.672.943.082 1.885-.492 2.474-1.219.58-.747.963-1.748.865-2.771zM18 17v15h2.375v-5h3.25c2.983 0 5.125-2.075 5.125-5s-2.103-5-5.047-5H18zm-8.266 2c-.8 0-1.465.214-1.95.395-.487.18-.855.27-.745.27.099 0-.241-.083-.678-.259-.436-.176-1.021-.402-1.738-.402-1.625 0-3.087.966-3.88 2.371-.799 1.383-.869 2.992-.61 4.467.259 1.474.845 2.844 1.556 3.879.317.465.684.983 1.176 1.43.492.445 1.167.841 1.979.841H4.88c.638-.024 1.12-.237 1.424-.361.304-.124.456-.19.845-.19.383 0 .54.07.873.205.334.136.86.354 1.541.354.803 0 1.478-.405 1.938-.854.46-.447.782-.948 1.082-1.388l.002-.002a8.858 8.858 0 0 0 1.127-2.37l.248-.882-.86-.322s-1.27-.372-1.283-1.989v-.002a2.087 2.087 0 0 1 .512-1.412 2.689 2.689 0 0 1 .518-.478c.033-.023-.04.04.12-.084l.749-.572-.526-.782C12.088 19.224 10.405 19 9.734 19zm10.641 0h2.75c2.047 0 3.25 1.105 3.25 3s-1.193 3-3.25 3h-2.75v-6zm-10.64 2c.133 0 .62.143 1.115.443-.023.026-.04.035-.063.063a4.184 4.184 0 0 0-.969 2.705c.015 1.805.928 2.69 1.686 3.227-.123.338-.18.62-.57 1.19l-.002.003c-.307.45-.586.852-.825 1.084-.238.232-.357.285-.543.285-.305 0-.435-.062-.787-.205-.351-.143-.907-.354-1.627-.354-.703 0-1.252.196-1.601.338-.338.138-.468.194-.719.207-.173-.003-.354-.074-.621-.316-.273-.247-.577-.648-.867-1.074v-.002l-.002-.002c-.527-.766-1.032-1.932-1.236-3.096-.205-1.164-.11-2.296.37-3.125l.005-.006.001-.004c.455-.806 1.354-1.357 2.143-1.357.271 0 .609.104.99.258.382.154.755.402 1.426.402.674 0 1.033-.243 1.441-.394.41-.152.81-.27 1.254-.27zm24.464 0c-2.489 0-4.328 1.395-4.396 3.314h2.11c.173-.912 1.036-1.51 2.218-1.51 1.433 0 2.242.657 2.242 1.864l.002.832-2.932.154c-2.72.161-4.193 1.255-4.193 3.155 0 1.919 1.52 3.193 3.7 3.193 1.471 0 2.837-.732 3.456-1.89h.05v1.775h2.167v-7.371c.001-2.14-1.74-3.516-4.424-3.516zm5.301 0 4.008 10.95-.215.665c-.362 1.13-.948 1.563-1.994 1.563-.18 0-.518-.018-.674-.037v1.804c.158.035.708.055.879.055 2.307 0 3.393-.868 4.342-3.502L50 21h-2.404l-2.787 8.885h-.05L41.974 21H39.5zm-3.125 6-.008.867c0 1.387-1.2 2.375-2.789 2.375-1.249 0-2.043-.588-2.043-1.49 0-.931.766-1.473 2.229-1.559L36.375 27z"
        })
    }));
var $596bbe84e95bafd3$export$2e2bcd8739ae039 = $596bbe84e95bafd3$var$SvgApplePay;





parcelRequire("7fPBF");
const $3079e7169fff8540$var$SvgAppleTv = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm9.076 12c-.705.097-1.51.483-2.014 1.064-.504.58-.807 1.259-.605 1.936.805 0 1.512-.388 2.016-.969.403-.484.704-1.257.603-2.031zm8.725 0L25 18.5V21h-1.5v1.375H25V27.6c0 1.2.2 2 .7 2.6.5.5 1.2.8 2 .8.7 0 1.3-.1 1.6-.2l-.1-1.4c-.2.1-.5.1-1 .1-1.1 0-1.4-.7-1.4-1.9v-5.225h2.6V21h-2.6v-3zm-13.46 3c-1.007 0-2.015.6-2.72 1.6-1.007 1.5-.806 4.3.705 6.6.504.9 1.21 1.8 2.217 1.8.907.1 1.107-.5 2.316-.5 1.108-.1 1.31.5 2.217.5s1.713-1.1 2.317-1.9c.303-.6.504-.9.906-1.6-2.216-.9-2.619-4-.403-5.2-.705-.8-1.61-1.3-2.517-1.3-1.208 0-1.714.6-2.52.6s-1.51-.6-2.517-.6zm17.284 0 3.79 10h1.694L40 21h-1.895l-1.894 5.6c-.3 1-.6 1.8-.799 2.6h-.1c-.2-.9-.497-1.7-.796-2.6L32.52 21h-1.895z"
        })
    }));
var $3079e7169fff8540$export$2e2bcd8739ae039 = $3079e7169fff8540$var$SvgAppleTv;





parcelRequire("7fPBF");
const $9d1f4a65eeeeac6d$var$SvgAppleWatch = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.063 0C22.5 0 20.59.09 19.156.406c-.718.16-1.332.387-1.843.75-.512.364-.918.926-1 1.563-.051.379-.06.367-.157.656-.097.29-.218.754-.375 1.688-.476 2.863-1.976 2.558-3.281 4.093C10.996 10.25 10 12.008 10 14v22c0 1.992.996 3.75 2.5 4.844l.031.031c.043.031.082.066.125.094 1.25 1.343 2.606 1.234 3.125 4 .156.84.29 1.261.375 1.531.086.27.098.34.157.781.078.617.472 1.168.968 1.532.496.363 1.078.585 1.782.75 1.406.328 3.308.437 5.875.437 2.562 0 4.472-.09 5.906-.406.718-.16 1.332-.387 1.843-.75.512-.364.918-.926 1-1.563.051-.379.06-.367.157-.656.097-.29.218-.754.375-1.687.457-2.762 1.851-2.606 3.125-3.97.043-.027.082-.062.125-.093l.031-.031C39.004 39.75 40 37.992 40 36v-2c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1v-3a2.17 2.17 0 0 0 2-2.156v-3.688A2.17 2.17 0 0 0 40 15v-1c0-1.992-.996-3.75-2.5-4.844l-.031-.031c-.043-.031-.082-.066-.125-.094-1.25-1.344-2.606-1.234-3.125-4-.157-.84-.29-1.261-.375-1.531-.086-.27-.098-.34-.157-.781-.078-.617-.472-1.168-.968-1.531-.496-.364-1.078-.586-1.782-.75C29.532.108 27.63 0 25.063 0Zm0 2c2.503 0 4.343.121 5.437.375.547.129.871.29 1.031.406.16.117.145.14.157.219.07.535.167.836.25 1.094.082.258.167.535.312 1.312A6.769 6.769 0 0 0 33.313 8H16.719a6.544 6.544 0 0 0 1.031-2.625c.145-.867.238-1.156.313-1.375.074-.219.183-.496.25-1 .011-.086-.012-.098.156-.219.168-.12.527-.281 1.093-.406 1.13-.25 2.993-.375 5.5-.375ZM16 10h18c2.219 0 4 1.781 4 4v2.156c-.332.617-.562 1.508-.562 2.844 0 1.332.234 2.223.562 2.844V36c0 2.219-1.781 4-4 4H16c-2.219 0-4-1.781-4-4V14c0-2.219 1.781-4 4-4Zm23.844 7c.101 0 .156.055.156.156v3.688c0 .101-.055.156-.156.156h-.032c-.011-.016-.015-.008-.03-.031-.134-.215-.344-.762-.344-1.969s.242-1.758.374-1.969c.02-.031.016-.011.032-.031ZM16.688 42H33.28a6.544 6.544 0 0 0-1.031 2.625c-.145.867-.238 1.156-.312 1.375-.075.219-.184.496-.25 1-.012.086.011.098-.157.219-.168.12-.527.281-1.093.406-1.13.25-2.993.375-5.5.375-2.504 0-4.344-.121-5.438-.375-.547-.129-.871-.29-1.031-.406-.16-.117-.145-.14-.157-.219-.07-.535-.167-.836-.25-1.094-.082-.258-.167-.535-.312-1.312A6.769 6.769 0 0 0 16.688 42Z"
        })
    }));
var $9d1f4a65eeeeac6d$export$2e2bcd8739ae039 = $9d1f4a65eeeeac6d$var$SvgAppleWatch;





parcelRequire("7fPBF");
const $d7ddc2c7594bdb77$var$SvgAppStore = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.489-10 10v22c0 5.512 4.489 10 10 10h22c5.511 0 10-4.488 10-10v-22c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8v-22c0-4.43 3.57-8 8-8zm8.572 5.903A2.001 2.001 0 0 0 20.72 14.9l1.811 3.09L16.666 28H12a2 2 0 0 0 0 4h15.412a3.328 3.328 0 0 0-.379-2.355l-.004-.004A4.911 4.911 0 0 0 25.48 28h-4.177l7.676-13.102a2 2 0 0 0-3.452-2.021l-.677 1.156-.678-1.156a1.998 1.998 0 0 0-1.6-.984zm5.739 8.048-.827 1.373a4.99 4.99 0 0 0-.107 4.942l6.297 10.746c.372.636 1.04.988 1.726.988a1.998 1.998 0 0 0 1.723-3.01L35.377 32H38a2 2 0 0 0 0-4h-4.967l-4.722-8.059zM14.625 34.004a4.895 4.895 0 0 0-1.613.232l-.446.758a2 2 0 1 0 3.452 2.022l1.076-1.836a3.334 3.334 0 0 0-2.463-1.176h-.006z"
        })
    }));
var $d7ddc2c7594bdb77$export$2e2bcd8739ae039 = $d7ddc2c7594bdb77$var$SvgAppStore;





parcelRequire("7fPBF");
const $63c6023a46e87011$var$SvgAtlassianConfluence = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M37.047 2.988c-1.5.1-1.735 1.858-2.658 3.057-4.1 7.309-7.903 5.192-14.366 2.19L10.61 4.13a1.465 1.465 0 0 0-1.966.728L4.12 14.705a1.46 1.46 0 0 0 .73 1.912c1.987.934 5.939 2.795 9.495 4.51 13.85 6.941 25.32 4.993 33.449-10.1a1.458 1.458 0 0 0-.488-1.984l-9.495-5.838a1.456 1.456 0 0 0-.765-.217zm.182 2.207 8.564 5.266C34.741 30.079 21.715 22.61 6.176 15.029l4.072-8.873 8.943 3.899c7.667 4.012 12.847 4.552 16.924-3.004.41-.678.769-1.278 1.114-1.856zM21.48 25c-7.716-.274-14.573 5.235-19.277 13.96a1.459 1.459 0 0 0 .49 1.985l9.494 5.838c1.933.953 2.437-1.488 3.424-2.838 4.1-7.309 7.903-5.192 14.366-2.19l9.414 4.104a1.464 1.464 0 0 0 1.964-.73l4.522-9.846a1.46 1.46 0 0 0-.73-1.912c-1.987-.934-5.939-2.793-9.495-4.508C30.618 26.42 25.88 25 21.48 25zm0 2c3.871 0 8.221 1.198 13.303 3.664 3.445 1.661 7.28 3.468 9.041 4.297l-4.072 8.871-8.943-3.896c-7.667-4.012-12.847-4.554-16.924 3.002-.408.676-.767 1.277-1.112 1.855l-8.566-5.266C8.239 32.04 14.487 26.715 21.48 27z"
        })
    }));
var $63c6023a46e87011$export$2e2bcd8739ae039 = $63c6023a46e87011$var$SvgAtlassianConfluence;





parcelRequire("7fPBF");
const $d3c505b5d5c9a2b9$var$SvgAudible = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 10c-8.086 0-15.266 4.625-18.758 11.36-.015.019-.035.03-.05.05l.007.008c-.023.047-.066.082-.09.129a.999.999 0 0 0 .371 1.305c.442.27 1.02.156 1.329-.262C11.16 17.98 15.539 15 24 15c5.367 0 8.977 2.055 11.332 4.16 2.355 2.106 3.414 4.281 3.477 4.414.113.242.32.43.574.516.254.09.535.07.773-.05l2.89-1.446c.24-.121.423-.332.505-.59a1.006 1.006 0 0 0-.07-.774C39.964 14.625 33.01 10 25 10Zm0 2c6.871 0 12.793 3.832 16.11 9.324l-1.016.512c-.516-.91-1.453-2.402-3.426-4.168C34.028 15.308 29.883 13 24 13c-2.71 0-4.984.402-7.074.98C19.418 12.812 22.106 12 25 12Zm0 5c-4.914 0-9.48 2.2-12.844 7.46-.27.423-.183.981.2 1.306a1 1 0 0 0 1.32-.028C16.906 22.781 20.09 22 23 22c4.453 0 7.852 1.547 9.906 4.676.278.426.828.574 1.282.351L37.3 25.47c.25-.125.437-.352.515-.625.075-.27.032-.563-.117-.801C35.047 19.82 30.352 17 25 17Zm0 2c4.246 0 7.926 2.094 10.297 5.234l-1.324.66C31.473 21.665 27.59 20 23 20c-1.363 0-2.824.23-4.312.66C20.62 19.52 22.723 19 25 19ZM2.047 23A1 1 0 0 0 1 24v4c0 .387.223.734.57.902l22.996 11c.274.13.594.13.868 0l23-11c.343-.168.566-.515.566-.902v-4c0-.27-.11-.527-.305-.719a.995.995 0 0 0-1.129-.183L25 33.89 2.43 23.098A.99.99 0 0 0 2.047 23ZM25 24c-2.746 0-5.371 1.227-6.832 3.45a.994.994 0 0 0 .129 1.253c.332.336.86.39 1.254.129C20.41 28.27 21.707 28 23 28a5.95 5.95 0 0 1 4.227 1.746c.304.3.77.375 1.152.18l2.605-1.301a.992.992 0 0 0 .344-1.504A7.976 7.976 0 0 0 25 24ZM3 25.59l21.566 10.312c.274.13.594.13.868 0L47 25.59v1.781l-22 10.52L3 27.37ZM25 26c1.469 0 2.707.637 3.746 1.512l-.762.379c-1.105-.907-2.441-1.473-3.922-1.676.325-.047.602-.215.938-.215Z"
        })
    }));
var $d3c505b5d5c9a2b9$export$2e2bcd8739ae039 = $d3c505b5d5c9a2b9$var$SvgAudible;





parcelRequire("7fPBF");
const $18f555e019f9ab0b$var$SvgBing = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 4c3.148.96 6.3 1.922 9.445 2.89-.004 7.774.008 15.548-.004 23.32-3.058 2.708-6.101 5.435-9.152 8.153 7.457-3.918 14.91-7.843 22.367-11.77-2.07-.94-4.14-1.866-6.21-2.812-1.391-3.035-2.794-6.062-4.188-9.097 6.914 2.113 13.828 4.234 20.742 6.355v10.137c-7.867 4.691-15.742 9.375-23.61 14.066-3.128-2.191-6.257-4.387-9.39-6.578V4m0-2a2 2 0 0 0-2 2v34.66c0 .656.316 1.266.852 1.64 2.128 1.49 4.257 2.981 6.382 4.473l3.008 2.11a2.008 2.008 0 0 0 2.172.078c4.348-2.594 8.695-5.184 13.047-7.773l10.562-6.293c.606-.36.977-1.012.977-1.72V26.11l-.004-5.07c0-.879-.57-1.652-1.41-1.91l-4.582-1.406c-5.387-1.653-10.777-3.305-16.164-4.95a2.027 2.027 0 0 0-1.395.082v-5.96c0-.88-.57-1.653-1.41-1.915-3.148-.968-6.3-1.933-9.453-2.89A1.865 1.865 0 0 0 10 2Zm11.441 28.238v-.027c.004-4.164.004-8.332.004-12.5.25.535.496 1.074.746 1.61l2.438 5.296c.2.438.55.79.988.988l2.485 1.125-1.645.868-5.016 2.64Z"
        })
    }));
var $18f555e019f9ab0b$export$2e2bcd8739ae039 = $18f555e019f9ab0b$var$SvgBing;





parcelRequire("7fPBF");
const $4b6a21eb2740d1a0$var$SvgCallOfDutyBlackOps3 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M4 5v8.334l3 4v15.332l-3 4V45h13V5H4zm15 0v40h12V5H19zm14 0v40h13v-8.334l-3-4V17.334l3-4V5H33zM6 7h9v36H6v-5.666l3-4V16.666l-3-4V7zm15 0h8v36h-8V7zm14 0h9v5.666l-3 4v16.668l3 4V43h-9V7z"
        })
    }));
var $4b6a21eb2740d1a0$export$2e2bcd8739ae039 = $4b6a21eb2740d1a0$var$SvgCallOfDutyBlackOps3;





parcelRequire("7fPBF");
const $65c1d56f8fc276a2$var$SvgCallOfDutyMobile = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M24.523.686A1 1 0 0 0 24 .818L3.5 12.654a1 1 0 0 0-.5.867v23.67a1 1 0 0 0 .5.868L24 49.895a1 1 0 0 0 1 0l20.5-11.836a1 1 0 0 0 .5-.868v-23.67a1 1 0 0 0-.5-.867L25 .818a1 1 0 0 0-.477-.132zM24.5 2.84 44 14.098v22.517L24.5 47.873 5 36.615V14.098L24.5 2.84zM14.041 13a1 1 0 0 0-.555.143l-3 1.796a1 1 0 0 0-.486.86v20.01a1 1 0 0 0 .52.877l4 2.191a1 1 0 0 0 1.08-.076l4-3A1 1 0 0 0 20 35v-5.168l3.945 2.537a1 1 0 0 0 .026.016l.015.01a1 1 0 0 0 1.006.013l.016-.008a1 1 0 0 0 .05-.03L29 29.833V35a1 1 0 0 0 .4.8l4 3a1 1 0 0 0 1.08.077l4-2.191a1 1 0 0 0 .52-.877v-20.01a1 1 0 0 0-.486-.86l-3-1.796a1 1 0 0 0-1.028 0l-4.98 2.988a1 1 0 0 0-.02.012 1 1 0 0 0-.004.002L24.5 19.15l-4.945-2.982a1 1 0 0 0-.04-.023 1 1 0 0 0-.001-.002l-5-3A1 1 0 0 0 14.04 13zM14 15.166l4 2.4V34.5l-3.084 2.313L12 35.217V16.365l2-1.199zm21 0 2 1.2v18.85l-2.916 1.596L31 34.5V17.566l4-2.4zM20 18.77l3.984 2.406a1 1 0 0 0 1.034 0L29 18.77v8.684l-4.498 2.895L20 27.455V18.77z"
        })
    }));
var $65c1d56f8fc276a2$export$2e2bcd8739ae039 = $65c1d56f8fc276a2$var$SvgCallOfDutyMobile;





parcelRequire("7fPBF");
const $c435ded412ce4cee$var$SvgChrome = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c7.988 0 14.926 4.445 18.477 11H25a1 1 0 0 0-.113.006c-5.148.058-9.375 4.03-9.84 9.072L8.035 12.65C11.852 7.414 18.015 4 25 4zM6.824 14.502l9.653 15.728a1 1 0 0 0 .115.159 1 1 0 0 0 .002.004C18.375 33.159 21.474 35 25 35a9.926 9.926 0 0 0 3.977-.83L22.32 45.824C11.98 44.51 4 35.701 4 25c0-3.83 1.038-7.408 2.824-10.498zM25 17c4.43 0 8 3.57 8 8 0 1.421-.37 2.752-1.016 3.906a1 1 0 0 0-.002.002 1 1 0 0 0-.035.059A7.978 7.978 0 0 1 25 33c-4.43 0-8-3.57-8-8s3.57-8 8-8zm5.973 0h13.449A20.965 20.965 0 0 1 46 25c0 11.61-9.39 21-21 21-.158 0-.314-.008-.47-.012l9.154-16.029a1 1 0 0 0 .058-.117A9.928 9.928 0 0 0 35 25c0-3.271-1.589-6.174-4.027-8z"
        })
    }));
var $c435ded412ce4cee$export$2e2bcd8739ae039 = $c435ded412ce4cee$var$SvgChrome;





parcelRequire("7fPBF");
const $46a011279831d90c$var$SvgChromebook = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5.951 4.006c-1.051 0-1.945.86-1.945 1.926v25.08c0 .358.096.684.252.968a1.853 1.853 0 0 0-.168.374.896.896 0 0 0-.002.001l-2.822 8.997A.98.98 0 0 0 1.02 42v3c0 1.06.855 1.98 1.937 1.98h44.084c1.082 0 1.94-.92 1.94-1.98v-3a.98.98 0 0 0-.247-.648l-2.822-8.997a1.839 1.839 0 0 0-.17-.376c.156-.285.252-.61.252-.967V5.932c0-1.065-.894-1.926-1.945-1.926H5.95zm.043 1.988h38.012v25.018c0-.098-.079-.006-.006-.006h-4.898A1 1 0 0 0 39 31H11a1 1 0 0 0-.1.006H6c.073 0-.006-.092-.006.006V5.994zM25 10c-4.959 0-9 4.041-9 9 0 3.193 1.68 5.997 4.197 7.596a1 1 0 0 0 .684.396A8.928 8.928 0 0 0 25 28c4.959 0 9-4.041 9-9s-4.041-9-9-9zm0 2a6.979 6.979 0 0 1 5.748 3h-5.605a1 1 0 0 0-.086.004c-.012 0-.022-.004-.034-.004-1.271 0-2.394.621-3.123 1.563l-1.445-2.89A6.97 6.97 0 0 1 25 12zm-5.957 3.324 2.047 4.092a4.022 4.022 0 0 0 2.437 3.281l-2.547 2.037A6.979 6.979 0 0 1 18 19c0-1.352.385-2.608 1.043-3.676zM25.023 17c1.1 0 1.977.88 1.977 2s-.877 2-1.977 2-1.976-.88-1.976-2 .877-2 1.976-2zm3.418 0h3.266c.188.634.293 1.304.293 2 0 3.878-3.122 7-7 7a7.036 7.036 0 0 1-2.025-.299l3.65-2.92a1 1 0 0 0 .23-.256C28.122 21.853 29 20.528 29 19c0-.73-.213-1.408-.559-2zM5.771 32.973h.014c.002.007.01.004.018.002.066.006.129.02.197.02h3.72l-.69 2.763A1 1 0 0 0 10 37h30a1 1 0 0 0 .97-1.242l-.69-2.764H44c.067 0 .129-.012.193-.017.01.004.021.005.024-.004h.012l2.525 8.047H3.246l2.525-8.047zm6.01.027H38.22l.5 2H11.28l.5-2zM21 38l-1 2h10l-1-2h-8zM2.98 42.98h44.04V45c0 .045 0 .02.021.02H2.979L2.98 45v-2.02z"
        })
    }));
var $46a011279831d90c$export$2e2bcd8739ae039 = $46a011279831d90c$var$SvgChromebook;





parcelRequire("7fPBF");
const $1421cc100a791107$var$SvgCnn = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.148 4C8.103 4 4 8.103 4 13.148v23.704C4 41.897 8.103 46 13.148 46h23.704C41.897 46 46 41.897 46 36.852V13.148C46 8.103 41.897 4 36.852 4H13.148zm0 2h23.704A7.156 7.156 0 0 1 44 13.148v23.704A7.156 7.156 0 0 1 36.852 44H13.148A7.156 7.156 0 0 1 6 36.852V13.148A7.156 7.156 0 0 1 13.148 6zm16.45 11.941a2.578 2.578 0 0 0-.856.135c-1.059.356-1.742 1.346-1.742 2.52v2.908l-3.107-4.3c-.813-1.075-2.02-1.506-3.15-1.128-1.06.356-1.743 1.346-1.743 2.52V28h-3.5a2.503 2.503 0 0 1-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5h2.346v-2H15.5a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5H21v-9.404c0-.31.142-.543.379-.623.297-.1.636.067.906.422L29 29.688v-9.092c0-.31.142-.543.379-.625.297-.1.637.067.906.422L37 29.686V18.393h-2v5.11l-3.107-4.3c-.61-.805-1.441-1.25-2.295-1.262zM15.5 18C11.364 18 8 21.364 8 25.5s3.364 7.5 7.5 7.5H21c1.654 0 3-1.346 3-3v-2.17l2.838 3.932c.757 1.09 2.038 1.548 3.266 1.164 1.15-.36 1.896-1.35 1.896-2.522V27.83l2.838 3.932c.579.835 1.464 1.297 2.398 1.297.287 0 .579-.043.868-.133 1.15-.36 1.896-1.35 1.896-2.522v-12.01h-2v12.01c0 .425-.377.577-.492.614-.145.045-.647.15-1.037-.413L30 21.643v8.761c0 .425-.377.577-.492.614-.145.045-.648.15-1.037-.413L22 21.643V30c0 .551-.449 1-1 1h-5.5a5.506 5.506 0 0 1-5.5-5.5c0-3.033 2.467-5.5 5.5-5.5h2.441v-2H15.5z"
        })
    }));
var $1421cc100a791107$export$2e2bcd8739ae039 = $1421cc100a791107$var$SvgCnn;





parcelRequire("7fPBF");
const $1cce39a8b578ff0a$var$SvgContacts = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V13c0-4.959-4.041-9-9-9H13zm0 2h24c.355 0 .66.15 1 .201V43.8c-.34.05-.645.201-1 .201H13c-3.877 0-7-3.123-7-7V13c0-3.877 3.123-7 7-7zm27 .73c2.352 1.126 4 3.48 4 6.27v1h-4V6.73zM22 12c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13zm0 2c6.087 0 11 4.913 11 11 0 2.822-1.065 5.383-2.805 7.328C28.17 30.272 25.24 29 22 29c-3.241 0-6.166 1.277-8.191 3.334A10.95 10.95 0 0 1 11 25c0-6.087 4.913-11 11-11zm18 2h4v8h-4v-8zm-18 2c-1.583 0-2.898.63-3.748 1.586C17.402 20.542 17 21.778 17 23s.402 2.458 1.252 3.414S20.417 28 22 28c1.583 0 2.898-.63 3.748-1.586C26.598 25.458 27 24.222 27 23s-.402-2.458-1.252-3.414S23.583 18 22 18zm0 2c1.083 0 1.769.37 2.252.914.483.544.748 1.308.748 2.086 0 .778-.265 1.542-.748 2.086-.483.544-1.169.914-2.252.914-1.083 0-1.769-.37-2.252-.914C19.265 24.542 19 23.778 19 23c0-.778.265-1.542.748-2.086C20.231 20.37 20.917 20 22 20zm18 6h4v8h-4v-8zm-18 5c2.694 0 5.093 1.056 6.73 2.695A10.949 10.949 0 0 1 22 36c-2.538 0-4.866-.863-6.725-2.3C16.913 32.06 19.305 31 22 31zm18 5h4v1c0 2.79-1.648 5.144-4 6.27V36z"
        })
    }));
var $1cce39a8b578ff0a$export$2e2bcd8739ae039 = $1cce39a8b578ff0a$var$SvgContacts;





parcelRequire("7fPBF");
const $e4698ad62cc1274e$var$SvgCounterStrike = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27.635 4.041c-.284-.046-.6.03-.908.072a1 1 0 0 0-.373.002c-.027.005-.043.028-.069.033-.028.01-.053-.004-.082.006a1 1 0 0 0-.351.203c-1.03.371-1.854 1.104-2.27 2.036-.285.637-.368 1.342-.324 2.048a5.62 5.62 0 0 0-.822.106 1 1 0 0 0-.086.025c-1.483.5-2.336 1.793-2.766 3.016-.417 1.132-.431 2.264-.357 3.348-.242.01-.512.007-.88.134a1 1 0 0 0-.67.909c-.036.998-.1 1.968-.265 2.9a1 1 0 0 0-.006.037c-.035.257-.173.762.063 1.387a1 1 0 0 0 .314.427c-.113 1.306.137 2.34.213 3.276-.19.185-.367.384-.432.553-.17.447-.167.78-.181.847a1 1 0 0 0 .066.608 1 1 0 0 0 .002.533c.002.005.012.167.055.463.016.11.172.278.226.427-.167 1.036-.359 2.097-.474 3.2-.056.435.04.73.07.879.012.059.01.07.012.078-.035.098-.272.498-.45 1.004-.498.592-.832 1.23-1.08 1.7-.41.736-.353 1.312-.392 1.667-.258.403-.788 1.025-.773 2.037-.004.112-.028.308.003.605.011.102.137.233.176.356-.213 1.057-.538 2.138-.81 3.3a1 1 0 0 0-.022.13c-.046.475-.131 1.172.238 1.904a1 1 0 0 0 .62.512c1.153.328 2.218.163 3.093.095a1 1 0 0 0 .912-.845c.066-.43.092-1.009-.154-1.592-.225-.802-.003-1.795.467-2.647.168-.136.423-.205.52-.355.223-.347.31-.668.376-.91a1 1 0 0 0 .002-.004c.195-.714.844-1.556 1.106-2.83a1 1 0 0 0 .01-.057c.058-.402-.025-.66-.045-.773.15-.333.217-.45.129-.393.526-.344.727-.803.865-1.144.098-.064.39-.205.623-.612.26-.452.295-.875.326-1.148.031-.274.06-.407.076-.438a1 1 0 0 0 .028-.054c.339-.796.51-1.326.77-1.663a1 1 0 0 0 .075.038c.276.119.36.074.543.085.541.795 1.078 1.594 1.617 2.397l-.023-.04c.36.59.92.785 1.498.825-.018.164-.034.328-.049.506-.261.372-.47.824-.363 1.39l-.012-.07c.08.688.144 1.382.198 2.078a1 1 0 0 0 .011.092c.122.712.286 1.052.274 1.178a1 1 0 0 0 .28.791c.025.637.09 1.25.05 1.633-.37.85-.397 1.627-.533 2.146a1 1 0 0 0 .209.905c.454.529 1.154.671 1.6.664.426-.008.718-.063.845-.065.32.054.913.42 1.894.367.731-.008 1.59.076 2.551-.101a1 1 0 0 0 .803-.803c.066-.36.124-.868-.096-1.412a1 1 0 0 0-.385-.467 5.598 5.598 0 0 0-1.435-.658 1 1 0 0 0-.041-.012c.041.01-.121-.152-.455-.506-.342-.443-.487-.62-.483-.578a1 1 0 0 0 0-.004c-.054-.498-.032-1.067-.013-1.672.085-.111.248-.36.265-.904.061-.448.027-.861-.02-1.119-.054-.3-.061-.45-.05-.502a1 1 0 0 0 .01-.055c.212-1.348.389-2.75.343-4.197a1 1 0 0 0-.181-.545l-.059-.084-.04-.402a1 1 0 0 0-.546-.79h-.002a34.297 34.297 0 0 0-1.297-3.1 1 1 0 0 0-.017-.036c-.485-.916-1.114-1.712-1.768-2.46.265-.058.566-.199.758-.417a1 1 0 0 0 .086-.115c.35-.536.715-1.247.668-2.121v.05c-.003-.676.185-1.607.11-2.658.547.24 1.12.467 1.788.532.67.088 1.279-.218 1.608-.479.333-.264.529-.463.601-.506a1 1 0 0 0 .079-.049c.627-.446.85-1.135.945-1.609.055-.276.08-.382.113-.555l.06-.017a1 1 0 0 0 .712-1.12c-.107-.67-.212-1.063-.26-1.439.202-.162.36-.404.54-.678l.03-.013c.963-.01 1.942.005 2.947-.008l-.064-.002c.284.015.719-.129.947-.39.037-.043.02-.062.047-.102.156-.012.323.103.467.062a1 1 0 0 0 .041-.013c.194-.064.628-.027 1.238-.05h.03c.223.005.377-.004.437-.001a1 1 0 0 0 .738.164c.314-.054.698-.054 1.147-.047a1 1 0 0 0 1.014-.965l.019-.531a1 1 0 0 0-1.002-1.04c-.28.002-.565.006-.85.01l-.138-.054a1 1 0 0 0-.924.105c-.37.018-.79.014-1.205.008-.07-.156-.038-.305-.17-.427a1 1 0 0 0-.107-.084L41.6 8.94a1 1 0 0 0-1.016-.994c-.088.002-.215.004-.303.008a1 1 0 0 0-.957 1.002v.117c-2.284-.015-4.56-.004-6.828-.011a1 1 0 0 0-.336-.198c-.04-.158.007-.252-.092-.426a1 1 0 0 0-1.07-.482 4.286 4.286 0 0 0-.24-1.46 1 1 0 0 0-.096-.69c-.043-.081-.116-.21-.137-.248a1 1 0 0 0-.529-.467c-.312-.118-.654-.33-1.055-.588a1 1 0 0 0-.097-.057 4.34 4.34 0 0 0-1.21-.406zm-.563 1.969c.242-.008.558.068.887.23.219.141.509.277.775.42a1 1 0 0 0 .063.195c.226.515.244.967.172 1.336-.05.012.021-.038-.233.047a1 1 0 0 0-.681.946c-.002.474.064.866.091 1.183a1 1 0 0 0 .838.9c.584.095 1.053-.063 1.36-.16.306-.096.464-.129.525-.125a1 1 0 0 0 .44-.072 1 1 0 0 0 .521.15c1.363.008 2.712.01 4.068.008l-.015.008a1 1 0 0 0-.512.582c-.012.038-.221.26-.615.555a1 1 0 0 0-.078.066c-.038-.15-.049-.298-.112-.447a1 1 0 0 0-.939-.611c-.164.003-.325.007-.48.008a1 1 0 0 0-.518.148c-.128.079-.355.156-.598.553-.034.056-.02.162-.047.236.08-.065-.02-.013-.242.123-.12.073-.282.18-.44.404a1.353 1.353 0 0 0-.204.91 1 1 0 0 0 .136.364c.17.273.316.558.436.853a1 1 0 0 0 1.56.397c.492-.404.846-.913 1.125-1.446l.112-.113c.038.264.053.492.11.707a1 1 0 0 0-.43.48c-.241.568-.253 1.044-.313 1.342-.06.3-.088.331-.145.372l.079-.05c-.453.264-.694.549-.842.667-.149.118-.064.078-.092.074a1 1 0 0 0-.057-.008c-.926-.082-1.952-.747-3.152-1.363a1 1 0 0 0-1.445.725 8.27 8.27 0 0 1-.196.826 1 1 0 0 0 .78 1.25c.05.01.042.009.04.01.089.666-.145 1.538-.14 2.667a1 1 0 0 0 .002.05c.007.122-.117.313-.178.472-.08-.02-.057-.033-.172-.049a1 1 0 0 0-1.029.533c-.074.145-.147.287-.217.428a1 1 0 0 0-.076.678c.068.28.103.702.277 1.21a1 1 0 0 0 .206.346c.655.724 1.232 1.493 1.668 2.313.48 1.003.912 2.03 1.287 3.078l-.041-.16c.055.308.262.52.443.695l.025.248a1 1 0 0 0 .168.463l.016.024c.013 1.164-.107 2.35-.299 3.568l.01-.055c-.118.547-.016.989.037 1.281.053.293.057.435.045.487a1 1 0 0 0-.025.281c-.01-.172-.04-.112-.235.416a1 1 0 0 0-.062.316c-.019.624-.055 1.314.025 2.051.103.976.763 1.428.91 1.62a1 1 0 0 0 .067.076c.102.108.307.37.603.63-.045 0-.071.004-.117.004a1 1 0 0 0-.04.002c-.233.013-.717-.263-1.612-.367a1 1 0 0 0-.09-.006c-.278-.007-.397.018-.573.04.066-.345.136-.804.245-1.014a1 1 0 0 0 .1-.315c.151-1.042-.08-1.852-.048-2.406a1 1 0 0 0-.357-.826l-.025-.022c-.08-.378-.143-.85-.176-1.01a55.957 55.957 0 0 0-.2-2.091c.004 0 .01-.008.047-.043a1 1 0 0 0 .315-.674c.019-.343.069-.722.11-1.139a1 1 0 0 0-.022-.322c-.148-.64-.482-.904-.51-.951a1 1 0 0 0-1.244-.408c-.039.016-.105-.023-.049.07a1 1 0 0 0-.023-.037c-.618-.918-1.235-1.839-1.864-2.758a1 1 0 0 0-.76-.434c-.182-.012-.137-.002-.203-.005-.073-.124-.135-.226-.277-.504a1 1 0 0 0-1.637-.21c-.297.335-.378.65-.431.798-.026.07-.039.094-.04.097-.878.856-1.04 1.892-1.294 2.49l.025-.054c-.227.452-.248.852-.277 1.107-.024.21-.044.27-.059.31l-.021.016c-.148.099-.515.342-.676.826l.02-.056c-.113.28-.194.365-.182.357a1 1 0 0 0-.004.002c-.737.482-.832 1.183-.914 1.371a1 1 0 0 0 0 .002c-.187.433-.124.825-.09 1.024.03.173.025.186.033.134-.152.686-.736 1.474-1.062 2.67v-.004a1.757 1.757 0 0 1-.117.323 1 1 0 0 0-.588.468c-.651 1.163-1.031 2.624-.66 4.086-.268.01-.544.014-.778-.007 0-.103-.021-.131-.01-.266.264-1.105.621-2.248.854-3.488a1 1 0 0 0-.2-.805c0-.051.004-.14.007-.33a1 1 0 0 0 0-.03c-.003-.161.215-.492.576-1.12a1 1 0 0 0 .111-.291c.154-.73.144-1.146.225-1.29a1 1 0 0 0 .011-.021c.35-.66.595-1.196.9-1.498a1 1 0 0 0 .274-.498c.016-.072.281-.383.498-1.047.164-.457.094-.86.051-1.078-.044-.222-.043-.3-.05-.238a1 1 0 0 0 .003-.024c.112-1.08.313-2.186.494-3.326a1 1 0 0 0-.254-.836c-.005-.039-.036-.195-.043-.28.015-.028.023-.056.04-.085a1 1 0 0 0 .064-.861 1 1 0 0 0 .488-.829c.04-1.378-.238-2.421-.24-3.369.057-.017.119-.054.174-.064a1 1 0 0 0-.055-1.973c-.156-.02-.353-.073-.523-.11.129-.76.166-1.504.209-2.247.286-.016.668-.031 1.1-.237a1 1 0 0 0 .562-1.025c-.15-1.208-.163-2.37.2-3.352a1 1 0 0 0 .007-.017c.295-.844.828-1.537 1.502-1.776.202-.044.39-.076.46-.074a1 1 0 0 0 1.432.09l.305-.281a1 1 0 0 0 .215-1.186c-.252-.501-.242-1.218.027-1.82.269-.601.736-1.02 1.297-1.123l.002-.002a1 1 0 0 0 .084-.018 1 1 0 0 0 .014-.003 1 1 0 0 0 .052-.018.734.734 0 0 1 .215-.035zm7.385 7.592.002.005-.045.065c.012-.024.031-.046.043-.07zM5 20a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2 1 1 0 0 0-1-1H6v-7h8a1 1 0 0 0 1-1 2 2 0 0 0-2-2H5zm32 0a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h7v2h-8a1 1 0 0 0-1 1 2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1h-8.23v-2H46a1 1 0 0 0 1-1 2 2 0 0 0-2-2h-8z"
        })
    }));
var $e4698ad62cc1274e$export$2e2bcd8739ae039 = $e4698ad62cc1274e$var$SvgCounterStrike;





const $b4c041254446cc77$var$SvgDictationPause = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 256 256"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "dictation-pause_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "none",
                        d: "M0 256V0h256v187.392c0-5.222-3.994-9.216-9.216-9.216h-12.288c-5.222 0-9.216 3.994-9.216 9.216 0-5.222-3.994-9.216-9.216-9.216h-12.288c-5.222 0-9.216 3.994-9.216 9.216v55.296c0 5.222 3.994 9.216 9.216 9.216h12.288c5.222 0 9.216-3.994 9.216-9.216 0 5.222 3.994 9.216 9.216 9.216h12.288c5.222 0 9.216-3.994 9.216-9.216V256z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                strokeMiterlimit: 10,
                fontFamily: "none",
                fontSize: "none",
                fontWeight: "none",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        fill: "none",
                        clipPath: "url(#dictation-pause_svg__a)",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            fill: "currentColor",
                            d: "M189.12 14.56c0 15.84-3.7 22.84-8.48 26.72-4.78 3.88-12.06 5.1-20.32 6.24-8.26 1.14-17.48 2.2-25.12 8.32-6.34 5.08-10.72 13.48-12 26.08H20.48C9.22 81.92 0 91.14 0 102.4v102.4c0 11.26 9.22 20.48 20.48 20.48h215.04c11.26 0 20.48-9.22 20.48-20.48V102.4c0-11.26-9.22-20.48-20.48-20.48H133.6c1.1-9.92 4.18-15.02 8-18.08 4.76-3.82 11.88-4.94 20.16-6.08 8.28-1.14 17.64-2.26 25.28-8.48 7.64-6.22 12.32-17.18 12.32-34.72zM20.48 92.16h215.04c5.72 0 10.24 4.52 10.24 10.24v102.4c0 5.72-4.52 10.24-10.24 10.24H20.48c-5.72 0-10.24-4.52-10.24-10.24V102.4c0-5.72 4.52-10.24 10.24-10.24zm5.12 20.48v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zM25.6 143.36v20.48h35.84v-20.48zm46.08 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h35.84v-20.48zM25.6 174.08v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h81.92v-20.48zm92.16 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M5 0H1C.4 0 0 .4 0 1v18c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM4 18H2V2h2zM15 0h-4c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 18h-2V2h2z",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        transform: "translate(200.704 184.32)scale(3.072)"
                    })
                ]
            })
        ]
    }));
var $b4c041254446cc77$export$2e2bcd8739ae039 = $b4c041254446cc77$var$SvgDictationPause;





const $7bd416e9f38b8977$var$SvgDictationPlay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 256 256"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "dictation-play_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "none",
                        d: "M0 256V0h256v256zm243.37-53.59-48.127-23.893c-1.366-.682-3.072-1.024-4.438-1.024-7.509 0-13.312 6.144-13.312 13.312v48.128c0 7.51 5.803 13.654 13.312 13.654 1.707 0 3.072-.342 4.438-1.024l47.786-23.894c6.144-2.73 9.558-7.168 9.558-12.629 0-6.144-4.779-10.581-9.216-12.63z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                strokeMiterlimit: 10,
                fontFamily: "none",
                fontSize: "none",
                fontWeight: "none",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        fill: "none",
                        clipPath: "url(#dictation-play_svg__a)",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            fill: "currentColor",
                            d: "M189.12 14.56c0 15.84-3.7 22.84-8.48 26.72-4.78 3.88-12.06 5.1-20.32 6.24-8.26 1.14-17.48 2.2-25.12 8.32-6.34 5.08-10.72 13.48-12 26.08H20.48C9.22 81.92 0 91.14 0 102.4v102.4c0 11.26 9.22 20.48 20.48 20.48h215.04c11.26 0 20.48-9.22 20.48-20.48V102.4c0-11.26-9.22-20.48-20.48-20.48H133.6c1.1-9.92 4.18-15.02 8-18.08 4.76-3.82 11.88-4.94 20.16-6.08 8.28-1.14 17.64-2.26 25.28-8.48 7.64-6.22 12.32-17.18 12.32-34.72zM20.48 92.16h215.04c5.72 0 10.24 4.52 10.24 10.24v102.4c0 5.72-4.52 10.24-10.24 10.24H20.48c-5.72 0-10.24-4.52-10.24-10.24V102.4c0-5.72 4.52-10.24 10.24-10.24zm5.12 20.48v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zM25.6 143.36v20.48h35.84v-20.48zm46.08 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48zm30.72 0v20.48h35.84v-20.48zM25.6 174.08v20.48h20.48v-20.48zm30.72 0v20.48H76.8v-20.48zm30.72 0v20.48h81.92v-20.48zm92.16 0v20.48h20.48v-20.48zm30.72 0v20.48h20.48v-20.48z"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M1.9 18c-1 0-1.9-.9-1.9-1.9V1.9C0 .9.8 0 1.9 0c.1 0 .3 0 .4.1l14.1 7c.4.2 1.6.8 1.6 1.9 0 1.1-1.2 1.7-1.6 1.9l-14.1 7c-.1.1-.3.1-.4.1zM2 2.2v13.7l13.6-6.7c.1 0 .1-.1.2-.1-.1 0-.1-.1-.2-.1z",
                        style: {
                            mixBlendMode: 'normal'
                        },
                        transform: "translate(184.32 184.32)scale(3.41333)"
                    })
                ]
            })
        ]
    }));
var $7bd416e9f38b8977$export$2e2bcd8739ae039 = $7bd416e9f38b8977$var$SvgDictationPlay;





parcelRequire("7fPBF");
const $f3679bbefd6a2cdc$var$SvgDiscord = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M18.906 7s-6.367.438-10.531 3.781a.466.466 0 0 0-.062.031C7.59 11.48 7.047 12.517 6.375 14c-.672 1.484-1.383 3.395-2.031 5.531C3.05 23.81 2 29.06 2 34a.971.971 0 0 0 .125.5c1.46 2.566 4.148 4.117 6.656 5.094 2.508.976 4.824 1.367 6 1.406.332.012.649-.14.844-.406l2.438-3.375c1.964.465 4.269.781 6.937.781s4.973-.316 6.938-.781l2.437 3.375c.195.265.512.418.844.406 1.176-.04 3.492-.43 6-1.406 2.508-.977 5.195-2.528 6.656-5.094A.971.971 0 0 0 48 34c0-4.941-1.05-10.191-2.344-14.469-.648-2.136-1.36-4.047-2.031-5.531-.672-1.484-1.215-2.52-1.937-3.187a.466.466 0 0 0-.063-.032C37.461 7.437 31.094 7 31.094 7a1.024 1.024 0 0 0-.219 0 1 1 0 0 0-.781.594s-.34.746-.563 1.812C27.582 9.094 25.941 9 25 9c-.941 0-2.582.094-4.531.406-.223-1.066-.563-1.812-.563-1.812a1.002 1.002 0 0 0-1-.594Zm-.625 2.156c.074.203.125.395.188.625-2.254.524-4.723 1.38-7.032 2.813a1.004 1.004 0 0 0-.613.898c-.008.39.215.754.567.926.355.168.777.117 1.078-.137C17.102 11.411 22.996 11 25 11c2.004 0 7.898.41 12.531 3.281.301.254.723.305 1.078.137.352-.172.575-.535.567-.926a1.004 1.004 0 0 0-.614-.898c-2.308-1.434-4.777-2.29-7.03-2.813.062-.23.113-.422.187-.625 1.14.14 5.574.739 8.593 3.125.196.18.876 1.18 1.5 2.563.626 1.383 1.282 3.183 1.907 5.25 1.218 4.031 2.203 9.004 2.25 13.562-1.137 1.84-3.27 3.207-5.469 4.063-2 .777-3.867 1.125-4.844 1.218l-1.687-2.28a24.85 24.85 0 0 0 2.312-.876c2.524-1.11 3.875-2.281 3.875-2.281a1.007 1.007 0 0 0-1.343-1.5s-1.047.957-3.344 1.969c-.844.37-1.867.738-3.032 1.062-.269-.031-.539.047-.75.219-1.863.453-4.078.75-6.687.75-2.629 0-4.848-.324-6.719-.781a.996.996 0 0 0-.718-.157 22.582 22.582 0 0 1-3.032-1.093C12.234 32.957 11.187 32 11.187 32a.996.996 0 0 0-.843-.25.999.999 0 0 0-.5 1.75s1.351 1.172 3.875 2.281c.68.297 1.453.598 2.312.875l-1.687 2.282c-.977-.094-2.844-.442-4.844-1.22-2.2-.855-4.332-2.222-5.469-4.062.047-4.558 1.032-9.531 2.25-13.562.625-2.067 1.282-3.867 1.907-5.25.624-1.383 1.304-2.383 1.5-2.563 3.019-2.386 7.453-2.984 8.593-3.125ZM18.5 21c-2.55 0-4.5 2.316-4.5 5s1.95 5 4.5 5 4.5-2.316 4.5-5-1.95-5-4.5-5Zm13 0c-2.55 0-4.5 2.316-4.5 5s1.95 5 4.5 5 4.5-2.316 4.5-5-1.95-5-4.5-5Zm-13 2c1.316 0 2.5 1.266 2.5 3s-1.184 3-2.5 3-2.5-1.266-2.5-3 1.184-3 2.5-3Zm13 0c1.316 0 2.5 1.266 2.5 3s-1.184 3-2.5 3-2.5-1.266-2.5-3 1.184-3 2.5-3Z"
        })
    }));
var $f3679bbefd6a2cdc$export$2e2bcd8739ae039 = $f3679bbefd6a2cdc$var$SvgDiscord;





parcelRequire("7fPBF");
const $c67d20bd69d9f8ef$var$SvgDisneyMovies = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.848 8c-.047.016-.094.066-.133.086-.242.121-.477.273-.715.414v.117c.238.121.477.25.719.36.093.043.195.054.246-.188a1.59 1.59 0 0 0 .004-.637c-.032-.136-.074-.164-.121-.152Zm-.328 2c-.782 1.656-1.641 3.281-2.52 4.918.29.062.535.078.781.082h3.516c.8-.008.84-.05.508-.715-.68-1.36-1.38-2.71-2.07-4.066-.044-.078-.06-.18-.215-.219Zm-5.536 5.086c-.023 0-.047 0-.07.004C10.641 16.148 1 26.46 1 39v2h.832c.11.02.219.02.324 0H3v-2c0-11.516 8.828-20.95 20.086-21.918a1 1 0 0 0-.102-1.996Zm7.086.918s-2.55-.012-3.07.008c-.441.015-.54.133-.55.593-.012.29-.02.582-.227.805-.262.285-.278.602-.13.934.255.562.485.582.794.601.937.059 1.875.078 2.812.055.746-.02.926-.363 1.067-.531.312-.36.289-.746.07-1.14-.145-.263-.29-.524-.277-.833.007-.363-.172-.492-.489-.492Zm3.934.82a.994.994 0 0 0-.996.797c-.098.473.156.945.601 1.129C41.477 22.098 47 29.898 47 39v2h.832c.11.02.219.02.324 0H49v-2c0-9.914-6.02-18.437-14.61-22.094a1.01 1.01 0 0 0-.386-.082ZM23.89 18a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm2.437 2c-.215-.004-.305.07-.328.266-.04.32 0 .547 0 .84 0 .273-.035.199-.035.695 0 .25-.914.21-1.176.199-.277 0-.352-.105-.367-.258-.3-.836-.242-.601-.563-1.324-.093-.211-.234-.426-.468-.418-.227.012-.352.25-.407.45-.199.76-.402.905-.765 1.722-.004.11-.082.215-.14.312-.145.254-.095.399.19.442.294.043.59.07.887.074h7.578c.11 0 .274.055.266-.168-.02-.676.098-2.219 0-2.566-.055-.203-.14-.266-.344-.266-.941.012-3.386.016-4.328 0Zm6.563 0a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm-16 1a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141ZM33 22c-.027.094-.95 2.594-.965 2.648-.055.13-.035.258-.015.387.14.934.183.969 1.093.965h.45c.214 0 .347-.074.39-.328.05-.297.074-.582-.012-.875-.058-.207-.18-.629-.18-.629l-.003-.012c-.024-.09-.656-2.004-.758-2.156Zm-16.621 1c-.195.012-.383.133-.488.363-.34.735-.618 1.508-.864 2.301-.058.188-.027.258.141.277.437.055.875.055 1.316.059.418-.008.84.012 1.258-.047.301-.047.309-.043.172-.402-.191-.5-.402-.988-.602-1.48-.109-.274-.218-.548-.382-.778-.149-.207-.356-.305-.551-.293Zm4.016 0c-.075-.004-.09.14-.106.238-.11.625-.18 1.266-.242 1.907-.09.87-.09.87.437.851.106 0 .215-.004.317 0 .183 0 .234-.113.176-.422-.149-.793-.301-1.582-.493-2.351-.023-.082-.027-.22-.09-.223Zm16.496 0a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm-14.532 1c-.195 0-.257.05-.25.246.028.602-.027.469-.09 1.067-.054.578-.03.683.544.687h8.734c.398-.016.285-.445.285-.445s.02-.371-.14-.93c-.165-.562-.157-.613-.743-.625Zm14.657 1.008c-.09-.016-.114.117-.141.207a144.11 144.11 0 0 0-.898 3.52c-.032.152 0 .21.148.226.29.031.582.055.875.039.21 0 .422.012.629-.004.371-.027.375-.031.293-.402a6.807 6.807 0 0 0-.113-.469c-.059-.187-.625-2.383-.715-2.89-.012-.09-.008-.212-.078-.227ZM19.684 27c-.2 0-.305.059-.391.234-.125.27-.27.532-.477.746-.128.133-.27.325-.48.196-.219-.133-.184-.356-.113-.567.023-.062.054-.117.086-.172.195-.367.164-.433-.243-.437h-3.898c-.16 0-.2.008-.148.172.148.43.207.883.214 1.34.004.468.008.488.47.488h20.058c.199-.004.293-.094.175-.316-.19-.368-.32-.762-.44-1.153-.095-.312-.286-.52-.626-.531Zm-8.793 1a.266.266 0 0 0-.133.031c-.254.106-.504.23-.758.344v.148c.242.141.48.29.723.415.09.046.218.144.25-.079.035-.222.03-.488.004-.718-.012-.098-.047-.133-.086-.141Zm3.64 2c-.234 0-.351.074-.41.285-.152.555-.086.844-.121 1.418-.016.238.059.3.297.297 1.375-.02 25.375 0 25.375 0 .36-.004.394-.047.246-.379-.16-.355-.11-.652-.23-1.023a1.091 1.091 0 0 0-.297-.442c-.192-.183-.383-.21-.582-.015-.125.117-.204.234-.332.343-.114.102-.243.121-.317-.03-.172-.356-.48-.45-.82-.454 0 0-16.531.012-22.809 0Zm-3.656 0a.409.409 0 0 0-.328.242c-.219.465-.379.953-.531 1.445-.043.141-.012.22.156.254.289.059.574.051.89.059.243-.016.516.008.786-.047.117-.023.187-.058.132-.203-.21-.54-.44-1.07-.75-1.562a.395.395 0 0 0-.355-.188Zm-1.367 3c-.149 0-.281.031-.387.184-.32.457-.668.894-.996 1.351-.195.278-.176.426.172.465h14.418c.77-.613 1.73-1 2.785-1 1.059 0 2.016.383 2.785 1h11.262c.793 0 1.324.02 2.113-.062.356-.036.414-.133.246-.442-.195-.367-.457-.687-.703-1.016-.226-.308-.516-.48-.894-.48Zm19.726 3c.391.582.633 1.27.715 2h11.207c.242.004.305-.05.266-.3-.059-.368-.23-1.048-.223-1.415.004-.258-.09-.285-.308-.285ZM9.063 36c-.22 0-.317.027-.31.285.009.367-.163 1.05-.222 1.414-.039.25.028.305.266.301H21.05c.082-.73.324-1.418.715-2Zm-.547 3c-.184.004-.282.098-.313.3-.062.388-.144 1.009-.23 1.388-.047.218-.02.316.246.312H21v-2ZM30 39v2h11.734c.266.004.293-.094.246-.312-.085-.38-.167-1-.23-1.387-.027-.203-.129-.297-.312-.301Z"
        })
    }));
var $c67d20bd69d9f8ef$export$2e2bcd8739ae039 = $c67d20bd69d9f8ef$var$SvgDisneyMovies;





parcelRequire("7fPBF");
const $92aaa8e9b3c9a4fd$var$SvgDoomLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m48.994 9.965-6 .037a1 1 0 0 0-.924.629L41 13.309l-1.07-2.68A1.001 1.001 0 0 0 39 10h-4v1l-.408-.408a2.02 2.02 0 0 0-1.43-.592h-7.16c-.641 0-1.256.254-1.709.707L24 11l-.3-.3a2.385 2.385 0 0 0-1.688-.7H13v1l-.293-.293A2.411 2.411 0 0 0 11.002 10H1a1 1 0 0 0-.707 1.707L2 13.414V36a1 1 0 0 0 1.613.79l9-7c.032-.027.064-.053.094-.083.401-.401.67-.747.861-1.064l6.014 4.334a1.003 1.003 0 0 0 1.186-.01L24 30.54l3.232 2.426a.997.997 0 0 0 1.186.01l6.57-4.737L38.4 30.8A1 1 0 0 0 40 30v-2l.977 1.953h.046L42 28v5c0 .314.148.61.4.799l4 3.002A1 1 0 0 0 48 36V13.408l1.713-1.744a1 1 0 0 0 .209-1.09 1 1 0 0 0-.922-.61h-.006zm-2.392 2.014-.315.32A1 1 0 0 0 46 13v21l-2-1.5V25a1 1 0 0 0-1.895-.447L41 26.763l-1.105-2.21A1 1 0 0 0 38 25v3l-2-1.5V12h2.322l1.748 4.371c.153.38.521.629.93.629.409 0 .777-.25.93-.629l1.75-4.375 2.922-.017zM3.414 12H11c.432 0 1 .629 1 1v14c0 .37 0 .577-.664 1.25L4 33.955V13a.997.997 0 0 0-.293-.707L3.414 12zM14 12h9v16.793l-2.846 2.133L14 26.488V12zm11 0h9v14.488l-6.154 4.438L25 28.793V12zM7 15v10l3-2v-8H7zm10 0v8l3 2V15h-3zm11 0v10l3-2v-8h-3z"
        })
    }));
var $92aaa8e9b3c9a4fd$export$2e2bcd8739ae039 = $92aaa8e9b3c9a4fd$var$SvgDoomLogo;





const $0b863f60fd8ea76e$var$SvgEduLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "eduLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "eduLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#eduLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#eduLogoTransparent_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#eduLogoTransparent_svg__c)",
                mask: "url(#eduLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    }));
var $0b863f60fd8ea76e$export$2e2bcd8739ae039 = $0b863f60fd8ea76e$var$SvgEduLogo;





const $793a6d9e0f3eb994$var$SvgEduLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "eduLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "eduLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#eduLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#eduLogoWhite_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#eduLogoWhite_svg__c)",
                mask: "url(#eduLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    }));
var $793a6d9e0f3eb994$export$2e2bcd8739ae039 = $793a6d9e0f3eb994$var$SvgEduLogoWhite;





parcelRequire("7fPBF");
const $512b1d6277a77d97$var$SvgEpicGames = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 3C6.698 3 4 5.698 4 9v32.244l21 6.3 21-6.3V9c0-3.302-2.698-6-6-6H10zm0 2h30c2.22 0 4 1.78 4 4v30.756l-19 5.7-19-5.7V9c0-2.22 1.78-4 4-4zm1 3a3 3 0 0 0-3 3v17a3 3 0 0 0 3 3h4v-3h-4v-7h3v-3h-3v-7h4V8h-4zm6 0v23h3V21h3a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-6zm11 0v23h3V8h-3zm8 0a3 3 0 0 0-3 3v17a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-4h-3v4h-3V11h3v4h3v-4a3 3 0 0 0-3-3h-3zm-16 3h3v7h-3v-7zM9 33a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h-2v1h1v.75a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-3.5a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25V35h1v-1a1 1 0 0 0-1-1H9zm9 0-3 6h1l.5-1h4l.5 1h1l-3-6h-1zm5 0v6h1v-4l1.5 3h1l1.5-3v4h1v-6h-1l-2 4-2-4h-1zm7 0v6h5v-1h-4v-1.5h2v-1h-2V34h4v-1h-5zm7 0a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h3.75a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-.25h-1v.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1h-3.75a.25.25 0 0 1-.25-.25v-1a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v.25h1V34a1 1 0 0 0-1-1h-4zm-18.5 1 1.5 3h-3l1.5-3z"
        })
    }));
var $512b1d6277a77d97$export$2e2bcd8739ae039 = $512b1d6277a77d97$var$SvgEpicGames;





parcelRequire("7fPBF");
const $f83f391ed40890b1$var$SvgExpression = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 90 100"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M8.555 37.947C10.52 31.708 16.908 23.08 29.73 23.08c3.41 0 6.37.528 8.927 1.416.89-.45 1.834-.85 2.837-1.193-3.226-1.468-7.12-2.383-11.764-2.383-14.015 0-21.07 9.503-23.235 16.378-.721 2.29-.537 4.668-.186 6.827L8.476 57.46a25.082 25.082 0 0 0 9.593 15.956l1.95 1.48a17.809 17.809 0 0 0 9.37 3.568c.108.036.222.055.341.055.176 0 .352-.003.528-.008.176.005.352.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.372-3.569l.662-.503a16.878 16.878 0 0 1-.489-.357l-1.306-.992-.173.132a15.648 15.648 0 0 1-8.934 3.175 15.649 15.649 0 0 1-8.934-3.175l-1.95-1.48a22.922 22.922 0 0 1-8.766-14.582L8.441 43.78c-.336-2.069-.451-4.037.114-5.832Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M32.204 65.008c-4.015.533-7.459-.92-9.514-2.528a1.35 1.35 0 0 0-1.664 2.126c2.74 2.144 7.424 4.005 12.743 2.876a24.013 24.013 0 0 1-1.565-2.474Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M61.481 24.491c2.411-.885 5.184-1.411 8.349-1.411 13.811 0 20.272 8.664 22.231 14.868.567 1.793.45 3.761.114 5.83l-2.167 13.336a22.922 22.922 0 0 1-8.767 14.582l-1.95 1.48a15.65 15.65 0 0 1-8.933 3.175 15.65 15.65 0 0 1-8.934-3.175l-.223-.17-1.356 1.03c-.145.11-.29.216-.438.32l.711.54a17.81 17.81 0 0 0 9.371 3.57c.107.035.222.054.34.054.177 0 .353-.003.529-.008.175.005.351.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.371-3.569l1.95-1.48a25.082 25.082 0 0 0 9.593-15.955l2.167-13.336c.35-2.158.537-4.538-.186-6.828C91.94 30.388 84.772 20.92 69.83 20.92c-4.393 0-8.103.934-11.192 2.428 1.005.33 1.952.715 2.843 1.143Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M68.124 65.343h9.984a1.35 1.35 0 1 0 0-2.7h-8.659c-.385.928-.828 1.83-1.325 2.7Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.858 23.35c-12.673 0-18.978 8.519-20.918 14.678-.546 1.733-.439 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.664 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.652 22.652 0 0 0 8.663-14.41l2.167-13.336c.334-2.058.443-3.974-.104-5.706C69.9 31.913 63.528 23.35 49.858 23.35Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.695-16.128l2.167-13.336c.353-2.168.549-4.6-.194-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.166 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.482 3.62c.124.038.256.058.393.058.176 0 .352-.003.528-.008.175.005.351.008.528.008.136 0 .268-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M45.75 62.476c-1.142.684-1.542 1.442-1.542 2.024 0 .582.4 1.34 1.541 2.024 1.114.669 2.74 1.126 4.609 1.126 1.868 0 3.495-.457 4.609-1.126 1.14-.684 1.54-1.442 1.54-2.024 0-.582-.4-1.34-1.54-2.024-1.114-.669-2.74-1.126-4.61-1.126-1.867 0-3.494.457-4.608 1.126Zm-1.39-2.316c1.6-.96 3.724-1.51 5.998-1.51s4.397.55 5.998 1.51c1.573.945 2.852 2.437 2.852 4.34s-1.279 3.395-2.852 4.34c-1.6.96-3.724 1.51-5.998 1.51s-4.397-.55-5.998-1.51c-1.574-.945-2.852-2.437-2.852-4.34s1.278-3.395 2.852-4.34Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $f83f391ed40890b1$export$2e2bcd8739ae039 = $f83f391ed40890b1$var$SvgExpression;





parcelRequire("7fPBF");
const $878338a7c05872f6$var$SvgEyebrowRaise = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m63.321 77.626-2.384 1.81a20.461 20.461 0 0 1-11.726 4.152 20.462 20.462 0 0 1-11.725-4.153l-2.385-1.81a29.356 29.356 0 0 1-11.227-18.674l-2.65-16.311c-.42-2.585-.604-5.243.183-7.741 2.526-8.02 10.747-19.107 27.159-19.107 17.584 0 25.917 11.088 28.45 19.107.789 2.497.603 5.156.183 7.741l-2.65 16.31A29.357 29.357 0 0 1 63.32 77.627Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M48.566 17.442c-15.5 0-23.212 10.42-25.584 17.953-.668 2.12-.537 4.464-.128 6.98l2.65 16.31A27.706 27.706 0 0 0 36.1 76.31l2.384 1.81a18.81 18.81 0 0 0 10.727 3.816 18.81 18.81 0 0 0 10.727-3.816l2.385-1.81a27.705 27.705 0 0 0 10.595-17.625l2.65-16.31c.41-2.517.543-4.861-.126-6.98-2.363-7.48-10.157-17.953-26.876-17.953Zm1.771 67.736a22.112 22.112 0 0 0 11.598-4.428l2.384-1.81a31.008 31.008 0 0 0 11.86-19.725l2.65-16.31c.43-2.653.67-5.628-.238-8.504-2.704-8.557-11.577-20.26-30.025-20.26-17.324 0-26.055 11.756-28.734 20.262-.906 2.875-.67 5.848-.238 8.502l2.65 16.31a31.007 31.007 0 0 0 11.86 19.725l2.383 1.81c3.374 2.56 7.4 4.091 11.598 4.429.152.046.313.07.48.07.216 0 .431-.002.646-.009.215.007.43.01.646.01.167 0 .328-.025.48-.072Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M38.956 36.628c-1.327.051-2.902.893-4.966 2.958a1.651 1.651 0 0 1-2.336-2.336c2.217-2.216 4.556-3.82 7.174-3.922 2.69-.104 5.114 1.387 7.452 3.985a1.651 1.651 0 1 1-2.455 2.21c-2.064-2.295-3.615-2.944-4.87-2.895ZM58.525 36.628c-1.327.051-2.902.893-4.966 2.958a1.651 1.651 0 0 1-2.335-2.336c2.216-2.216 4.555-3.82 7.173-3.922 2.69-.104 5.114 1.387 7.452 3.985a1.651 1.651 0 0 1-2.454 2.21c-2.065-2.295-3.616-2.944-4.87-2.895Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $878338a7c05872f6$export$2e2bcd8739ae039 = $878338a7c05872f6$var$SvgEyebrowRaise;





parcelRequire("7fPBF");
const $a6e3afa557217638$var$SvgFacebook = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h16.832a1 1 0 0 0 .326 0h5.674a1 1 0 0 0 .326 0H41c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3h-8V30h3.82l1.4-7H33v-2c0-.557.053-.601.24-.723.187-.121.766-.277 1.76-.277h3v-5.63l-.57-.272S35.133 13 32 13c-2.25 0-4.098.896-5.281 2.375C25.536 16.854 25 18.833 25 21v2h-3v7h3v14H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm23 9c2.08 0 3.387.458 4 .701V18h-1c-1.15 0-2.073.095-2.85.6-.776.504-1.15 1.461-1.15 2.4v4h4.78l-.6 3H31v16h-4V28h-3v-3h3v-4c0-1.833.464-3.354 1.281-4.375S30.25 15 32 15z"
        })
    }));
var $a6e3afa557217638$export$2e2bcd8739ae039 = $a6e3afa557217638$var$SvgFacebook;





parcelRequire("7fPBF");
const $0de5ad6202c372c1$var$SvgFacebookMessenger = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.348 2 2 11.598 2 23.5c0 6.508 3.133 12.285 8 16.219v8.937l1.469-.781 7.219-3.75C20.703 44.665 22.8 45 25 45c12.652 0 23-9.598 23-21.5S37.652 2 25 2Zm0 2c11.645 0 21 8.758 21 19.5S36.645 43 25 43c-2.164 0-4.258-.312-6.219-.875l-.375-.094-.343.188L12 45.375v-6.562l-.375-.282C6.961 34.941 4 29.54 4 23.5 4 12.758 13.355 4 25 4Zm-2.281 13.719-12.032 12.75L21.5 24.406l5.781 6.188 11.875-12.875-10.531 5.906Z"
        })
    }));
var $0de5ad6202c372c1$export$2e2bcd8739ae039 = $0de5ad6202c372c1$var$SvgFacebookMessenger;





parcelRequire("7fPBF");
const $e8f8716714af8e2c$var$SvgFaceExpression = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M8.555 37.947C10.52 31.708 16.908 23.08 29.73 23.08c3.41 0 6.37.528 8.927 1.416.89-.45 1.834-.85 2.837-1.193-3.226-1.468-7.12-2.383-11.764-2.383-14.015 0-21.07 9.503-23.235 16.378-.721 2.29-.537 4.668-.186 6.827L8.476 57.46a25.082 25.082 0 0 0 9.593 15.956l1.95 1.48a17.809 17.809 0 0 0 9.37 3.568c.108.036.222.055.341.055.176 0 .352-.003.528-.008.176.005.352.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.372-3.569l.662-.503a16.878 16.878 0 0 1-.489-.357l-1.306-.992-.173.132a15.648 15.648 0 0 1-8.934 3.175 15.649 15.649 0 0 1-8.934-3.175l-1.95-1.48a22.922 22.922 0 0 1-8.766-14.582L8.441 43.78c-.336-2.069-.451-4.037.114-5.832Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M32.204 65.008c-4.015.533-7.459-.92-9.514-2.528a1.35 1.35 0 0 0-1.664 2.126c2.74 2.144 7.424 4.005 12.743 2.876a24.013 24.013 0 0 1-1.565-2.474Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#B6B7BD",
                fillRule: "evenodd",
                d: "M61.481 24.491c2.411-.885 5.184-1.411 8.349-1.411 13.811 0 20.272 8.664 22.231 14.868.567 1.793.45 3.761.114 5.83l-2.167 13.336a22.922 22.922 0 0 1-8.767 14.582l-1.95 1.48a15.65 15.65 0 0 1-8.933 3.175 15.65 15.65 0 0 1-8.934-3.175l-.223-.17-1.356 1.03c-.145.11-.29.216-.438.32l.711.54a17.81 17.81 0 0 0 9.371 3.57c.107.035.222.054.34.054.177 0 .353-.003.529-.008.175.005.351.008.528.008.119 0 .233-.02.34-.055a17.81 17.81 0 0 0 9.371-3.569l1.95-1.48a25.082 25.082 0 0 0 9.593-15.955l2.167-13.336c.35-2.158.537-4.538-.186-6.828C91.94 30.388 84.772 20.92 69.83 20.92c-4.393 0-8.103.934-11.192 2.428 1.005.33 1.952.715 2.843 1.143Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M68.124 65.343h9.984a1.35 1.35 0 1 0 0-2.7h-8.659c-.385.928-.828 1.83-1.325 2.7Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.858 23.35c-12.673 0-18.978 8.519-20.918 14.678-.546 1.733-.439 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.664 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.652 22.652 0 0 0 8.663-14.41l2.167-13.336c.334-2.058.443-3.974-.104-5.706C69.9 31.913 63.528 23.35 49.858 23.35Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.695-16.128l2.167-13.336c.353-2.168.549-4.6-.194-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.166 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.482 3.62c.124.038.256.058.393.058.176 0 .352-.003.528-.008.175.005.351.008.528.008.136 0 .268-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M45.75 62.476c-1.142.684-1.542 1.442-1.542 2.024 0 .582.4 1.34 1.541 2.024 1.114.669 2.74 1.126 4.609 1.126 1.868 0 3.495-.457 4.609-1.126 1.14-.684 1.54-1.442 1.54-2.024 0-.582-.4-1.34-1.54-2.024-1.114-.669-2.74-1.126-4.61-1.126-1.867 0-3.494.457-4.608 1.126Zm-1.39-2.316c1.6-.96 3.724-1.51 5.998-1.51s4.397.55 5.998 1.51c1.573.945 2.852 2.437 2.852 4.34s-1.279 3.395-2.852 4.34c-1.6.96-3.724 1.51-5.998 1.51s-4.397-.55-5.998-1.51c-1.574-.945-2.852-2.437-2.852-4.34s1.278-3.395 2.852-4.34Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $e8f8716714af8e2c$export$2e2bcd8739ae039 = $e8f8716714af8e2c$var$SvgFaceExpression;





parcelRequire("7fPBF");
const $27eac4e6b224d0c7$var$SvgFacetime = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 5c-4.953 0-9 4.047-9 9v22c0 4.953 4.047 9 9 9h22c4.953 0 9-4.047 9-9V14c0-4.953-4.047-9-9-9H14zm0 2h22c3.869 0 7 3.131 7 7v22c0 3.869-3.131 7-7 7H14c-3.869 0-7-3.131-7-7V14c0-3.869 3.131-7 7-7zm.025 9A4.042 4.042 0 0 0 10 20.025v9.95A4.042 4.042 0 0 0 14.025 34h11.95A4.042 4.042 0 0 0 30 29.975v-9.95A4.042 4.042 0 0 0 25.975 16h-11.95zm24.065 1.012c-.457 0-.925.19-1.256.486L32 21.812v6.375l4.836 4.315v.002c.33.294.797.484 1.254.484.95 0 1.91-.793 1.91-1.904V18.916c0-1.111-.96-1.904-1.91-1.904zM14.025 18h11.95C27.1 18 28 18.9 28 20.025v9.95C28 31.1 27.1 32 25.975 32h-11.95C12.9 32 12 31.1 12 29.975v-9.95C12 18.9 12.9 18 14.025 18zM38 19.14v11.721l-4-3.57v-4.584l4-3.566z"
        })
    }));
var $27eac4e6b224d0c7$export$2e2bcd8739ae039 = $27eac4e6b224d0c7$var$SvgFacetime;





parcelRequire("7fPBF");
const $25abb7d8311d1b5e$var$SvgFindIphone = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm11 2C15.623 8 8 15.623 8 25c0 9.377 7.623 17 17 17 9.377 0 17-7.623 17-17 0-9.377-7.623-17-17-17zm0 2c2.379 0 4.617.567 6.613 1.549l-4.705 8.836C26.328 20.163 25.703 20 25 20c-.703 0-1.328.163-1.908.385l-4.705-8.836A14.936 14.936 0 0 1 25 10zm-8.354 2.535 1.877 3.524C15.786 18.06 14 21.29 14 24.934c0 6.063 4.937 11 11 11s11-4.937 11-11c0-3.643-1.785-6.873-4.521-8.875l1.875-3.524A14.972 14.972 0 0 1 40 25c0 8.296-6.704 15-15 15s-15-6.704-15-15c0-5.201 2.636-9.775 6.646-12.465zm2.825 5.303 1.935 3.637c-.043.044-.113.065-.154.11C20.402 22.543 20 23.779 20 25s.402 2.458 1.252 3.414S23.417 30 25 30c1.583 0 2.898-.63 3.748-1.586C29.598 27.458 30 26.222 30 25s-.402-2.458-1.252-3.414c-.041-.046-.111-.067-.154-.111l1.935-3.637A8.975 8.975 0 0 1 34 24.934c0 4.982-4.017 9-9 9s-9-4.018-9-9c0-2.89 1.362-5.45 3.47-7.096zM25 22c1.083 0 1.769.37 2.252.914.483.544.748 1.308.748 2.086 0 .778-.265 1.542-.748 2.086-.483.544-1.169.914-2.252.914-1.083 0-1.769-.37-2.252-.914C22.265 26.542 22 25.778 22 25c0-.778.265-1.542.748-2.086C23.231 22.37 23.917 22 25 22z"
        })
    }));
var $25abb7d8311d1b5e$export$2e2bcd8739ae039 = $25abb7d8311d1b5e$var$SvgFindIphone;





parcelRequire("7fPBF");
const $4d66404571458338$var$SvgFireTv = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 4c-1.093 0-2 .907-2 2v38c0 1.093.907 2 2 2h38c1.093 0 2-.907 2-2V6c0-1.093-.907-2-2-2H6zm0 2h38v38H6V6zm6.898 9c-.64 0-1.184.22-1.617.648-.43.43-.648 1.015-.648 1.74v.852H9.52v1.276h1.113v5.566h1.431v-5.566h1.53V18.24h-1.53v-.8c0-1.05.513-1.17.899-1.17.227 0 .42.046.594.146l.297.166v-1.4l-.124-.051c-.21-.088-.484-.131-.832-.131zm2.155.26a.876.876 0 0 0-.621.248.838.838 0 0 0-.256.62c0 .246.085.456.258.622a.856.856 0 0 0 .615.244.87.87 0 0 0 .625-.252.832.832 0 0 0 .262-.613.828.828 0 0 0-.262-.621.893.893 0 0 0-.621-.248zm17.418 1-1.442.457v1.523H29.91v1.276h1.12v3.619c0 1.725 1.04 2.088 1.91 2.088.43 0 .79-.079 1.068-.229l.103-.053V23.55l-.318.238a.91.91 0 0 1-.563.17c-.279 0-.474-.065-.582-.201-.08-.1-.177-.323-.177-.803v-3.437h1.64V18.24h-1.64v-1.98zm-7.885 1.826a2.97 2.97 0 0 0-2.287 1.018c-.606.664-.914 1.532-.914 2.582 0 1.106.284 1.982.84 2.603.564.626 1.344.945 2.318.945.978 0 1.782-.22 2.387-.656l.082-.058v-1.475l-.32.25c-.584.455-1.205.676-1.901.676-.603 0-1.06-.173-1.396-.526-.302-.314-.478-.763-.522-1.33h4.592v-.738c0-1.012-.253-1.82-.748-2.402-.506-.59-1.221-.89-2.131-.89zm-4.143.039c-.422 0-.807.144-1.15.428-.142.12-.27.258-.38.414v-.727h-1.44v6.842h1.44v-3.484c0-.675.137-1.21.41-1.584.261-.365.574-.543.956-.543.298 0 .523.056.668.166l.319.244v-1.6l-.123-.05c-.172-.07-.402-.106-.7-.106zm-6.127.115v6.842h1.442V18.24h-1.442zm20.016 0 2.62 6.842h1.294L41 18.24h-1.533l-1.778 4.842a2.348 2.348 0 0 0-.037.11c-.014-.044-.03-.087-.047-.133l-1.7-4.819h-1.573zm-9.766 1.112c.453 0 .792.141 1.043.43.22.254.35.612.381 1.064h-3.076c.093-.414.275-.76.541-1.032a1.488 1.488 0 0 1 1.111-.462zm13.809 8.804c-1.109.017-2.417.286-3.41 1.053-.304.235-.25.56.088.516 1.118-.147 3.607-.477 4.05.148.448.623-.488 3.203-.908 4.354-.127.348.143.488.428.224 1.86-1.71 2.342-5.3 1.961-5.818-.19-.257-1.1-.494-2.209-.477zm-29.143.686c-.232.034-.335.339-.091.582C13.3 33.532 18.8 36 24.904 36c4.357 0 9.412-1.495 12.903-4.312.576-.466.083-1.167-.506-.895-3.913 1.816-8.165 2.693-12.03 2.693-5.734 0-11.28-1.723-15.769-4.58a.396.396 0 0 0-.27-.064z"
        })
    }));
var $4d66404571458338$export$2e2bcd8739ae039 = $4d66404571458338$var$SvgFireTv;





parcelRequire("7fPBF");
const $195bb2aa60406de1$var$SvgFortnite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm8 3v3h-7l1 8-1 18 7-2v6l9-2v-5l14 1-1-17 1-7h-7.666L33 9H17zm2 2h11.508l-1.112 5H24v7h5v5h-5v10.396l-5 1.112V11zm-6.734 3H17v19.92l-4.848 1.385.856-15.373L12.266 14zm19.623 0h5.804l-.7 4.916.876 14.928L26 33v-3h5v-9h-5v-3h5l.889-4z"
        })
    }));
var $195bb2aa60406de1$export$2e2bcd8739ae039 = $195bb2aa60406de1$var$SvgFortnite;





parcelRequire("7fPBF");
const $3e61990689ecc79a$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.311 2 2 12.311 2 25s10.311 23 23 23 23-10.311 23-23S37.689 2 25 2zm0 2c11.607 0 21 9.393 21 21 0 .071-.005.142-.006.213a39.758 39.758 0 0 0-2.318-.149 59.326 59.326 0 0 0-4.903.061c.07-.49.12-.988.122-1.498.096-1.873-.532-3.625-1.555-5.172.247-.854.537-1.94.61-3.172.082-1.404-.04-2.961-1.167-4.013l-.289-.27H36.1c-2.683 0-4.52 1.123-5.643 2.014A15.026 15.026 0 0 0 25 12a15.82 15.82 0 0 0-5.553 1.018C18.325 12.127 16.487 11 13.801 11h-.393l-.289.268c-1.098 1.02-1.2 2.534-1.13 3.931.06 1.233.333 2.353.575 3.248-1.04 1.578-1.664 3.375-1.664 5.153 0 .511.048 1.01.118 1.502-1.806-.084-3.416-.1-4.694-.055-.94.033-1.679.089-2.318.148 0-.065-.006-.13-.006-.195C4 13.393 13.393 4 25 4zm-10.604 9.13c2.018.192 3.536 1.093 4.239 1.718l.469.414.578-.237C21.263 14.375 23.027 14 25 14c1.973 0 3.737.376 5.2 1.016l.585.257.479-.425c.703-.625 2.223-1.526 4.242-1.717.268.445.501 1.078.445 2.035-.067 1.146-.374 2.394-.605 3.135l-.15.482.298.408c.99 1.35 1.494 2.81 1.408 4.354l-.002.027v.028c0 2.495-.898 4.492-2.812 5.972C32.174 31.052 29.153 32 24.9 32c-4.252 0-7.275-.948-9.19-2.428-1.913-1.48-2.81-3.477-2.81-5.972 0-1.465.53-3.076 1.506-4.409l.293-.398-.14-.475c-.232-.788-.516-2.064-.573-3.216-.047-.96.18-1.565.41-1.971zM8.885 26.022c.706.01 1.516.048 2.328.088.077.312.166.619.273.918-3.307.07-5.781.403-7.306.688-.065-.5-.116-1.005-.145-1.516a44.845 44.845 0 0 1 4.85-.178zm32.23.016c2.133-.027 3.72.071 4.848.178-.029.503-.08 1-.143 1.494-1.58-.29-4.12-.622-7.513-.676.105-.293.193-.595.27-.9a64.2 64.2 0 0 1 2.538-.096zM11.912 28.02a9.029 9.029 0 0 0 2.576 3.134c1.54 1.192 3.544 2.024 5.989 2.469-.32.329-.611.69-.87 1.07l-.06-.052c.005-.007-.497.245-1.248.312S16.622 35 15.8 35c-1.225 0-1.765-.579-2.627-1.633a7.098 7.098 0 0 0-1.625-1.56c-.579-.406-1.073-.691-1.684-.793L9.783 31H9.7c-.466 0-.918.034-1.34.516-.21.24-.356.687-.261 1.064.094.378.333.61.547.752 1.366.911 1.608 2.715 2.464 4.318.8 1.594 2.527 2.35 4.291 2.35H18v4.803c-7.032-2.482-12.335-8.598-13.668-16.1 1.53-.288 4.095-.635 7.58-.683zm25.97.007c3.564.03 6.199.377 7.788.67C44.339 36.202 39.034 42.32 32 44.803V39.6c0-1.585-.52-3.332-1.426-4.79a7.52 7.52 0 0 0-.959-1.236c2.315-.457 4.217-1.275 5.698-2.42a9.004 9.004 0 0 0 2.57-3.127zM23.7 34.1H26.5c.813 0 1.68.647 2.375 1.765C29.57 36.983 30 38.485 30 39.6v5.798a21.078 21.078 0 0 1-10 0V39.6c0-1.091.468-2.589 1.209-3.711.741-1.123 1.677-1.79 2.49-1.79zM12.31 35.28C13.174 36.18 14.223 37 15.8 37c.779 0 1.751.028 2.676-.055l.01-.002c-.122.35-.213.703-.29 1.057H15.4c-1.233 0-2.104-.446-2.505-1.248l-.008-.014-.006-.011c-.165-.306-.38-.916-.572-1.446z"
        })
    }));
var $3e61990689ecc79a$export$2e2bcd8739ae039 = $3e61990689ecc79a$var$SvgGithub;





parcelRequire("7fPBF");
const $792bc4d5598bcd37$var$SvgGmail = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M43.754 6.402A5.478 5.478 0 0 0 40.27 7.47l-2.746 2.027L25 18.756 12.592 9.584a1 1 0 0 0-.643-.283h.25L9.734 7.477a5.48 5.48 0 0 0-3.486-1.07 5.034 5.034 0 0 0-3.34 1.439A6.403 6.403 0 0 0 1 12.41v3.434a1 1 0 0 0 0 .295V39.5C1 41.421 2.579 43 4.5 43H12a1 1 0 0 0 1-1V25.373l11.406 8.432a1 1 0 0 0 1.188 0L37 25.373V42a1 1 0 0 0 1 1h7.5c1.921 0 3.5-1.579 3.5-3.5V16.12a1 1 0 0 0 0-.26v-3.45a6.414 6.414 0 0 0-1.902-4.566 1 1 0 0 0-.006-.006 5.037 5.037 0 0 0-3.338-1.436zm-.11 1.998c.757.03 1.49.317 2.045.864l.024.023A4.402 4.402 0 0 1 47 12.41v3.086l-8 5.912V11a1 1 0 0 0-.004-.102l2.463-1.82a1 1 0 0 0 .002 0 3.461 3.461 0 0 1 2.184-.678zm-37.287.006a3.464 3.464 0 0 1 2.188.678l2.459 1.818A1 1 0 0 0 11 11v10.408l-8-5.912V12.41c0-1.236.502-2.341 1.313-3.14a3.059 3.059 0 0 1 2.044-.864zM37 12.371v10.516l-12 8.869-12-8.87V12.374l11.406 8.432a1 1 0 0 0 1.188 0L37 12.37zM3 17.982l8 5.914V41H4.5c-.84 0-1.5-.66-1.5-1.5V17.982zm44 0V39.5c0 .84-.66 1.5-1.5 1.5H39V23.896l8-5.914z"
        })
    }));
var $792bc4d5598bcd37$export$2e2bcd8739ae039 = $792bc4d5598bcd37$var$SvgGmail;





parcelRequire("7fPBF");
const $75745da5fba927e0$var$SvgGmailLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5.5 7C3.031 7 1.012 9.016 1 11.484V38.5C1 40.973 3.027 43 5.5 43h39c2.473 0 4.5-2.027 4.5-4.5V11.484C48.988 9.016 46.969 7 44.5 7Zm2.602 2h33.8L25 20.781Zm-3.329.117L25 23.22 45.23 9.117A2.477 2.477 0 0 1 47 11.488c-.004.211-.219.633-.531.973-.317.344-.625.559-.625.559l-.004.007L25 27.777 4.16 13.027l-.004-.007s-.308-.215-.625-.56c-.312-.339-.527-.76-.531-.972a2.476 2.476 0 0 1 1.773-2.37ZM3 14.652l.008.008.008.004v.004L6 16.778V41h-.5C4.11 41 3 39.89 3 38.5Zm44 0V38.5c0 1.39-1.11 2.5-2.5 2.5H44V16.777l2.984-2.109v-.004l.016-.012Zm-39 3.54 17 12.03 17-12.03V41H8Z"
        })
    }));
var $75745da5fba927e0$export$2e2bcd8739ae039 = $75745da5fba927e0$var$SvgGmailLogo;





parcelRequire("7fPBF");
const $c6371eb2aedbedde$var$SvgGoogle = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M26 2C13.309 2 3 12.309 3 25s10.309 23 23 23c9.918 0 15.973-4.562 19.125-10.219 3.152-5.656 3.55-12.3 2.594-16.843l-.188-.782h-.781L26 20.125h-1v10.406h11.438c-1.727 4-5.243 6.75-10.438 6.75-6.79 0-12.281-5.492-12.281-12.281 0-6.79 5.492-12.281 12.281-12.281 3.05 0 5.82 1.129 7.969 2.969l.718.593 6.844-6.843.719-.75L41.5 8C37.414 4.277 31.96 2 26 2Zm0 2c5.074 0 9.652 1.855 13.281 4.844l-4.812 4.812c-2.38-1.777-5.27-2.937-8.469-2.937-7.871 0-14.281 6.41-14.281 14.281S18.129 39.281 26 39.281c6.55 0 11.262-4.015 12.938-9.468l.406-1.282H27v-6.406l18.844.031c.664 4.035.222 9.828-2.469 14.657C40.515 41.937 35.32 46 26 46 14.387 46 5 36.61 5 25S14.387 4 26 4Z"
        })
    }));
var $c6371eb2aedbedde$export$2e2bcd8739ae039 = $c6371eb2aedbedde$var$SvgGoogle;





parcelRequire("7fPBF");
const $d6a3e630182db681$var$SvgGoogleCalendar = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9.66 5.959c-1.442 0-2.642 1.183-2.642 2.627v4.678A4.439 4.439 0 0 0 5.02 14.65a4.418 4.418 0 0 0-.91 3.686L6.414 29.49 4.12 40.615c-.27 1.31.068 2.671.914 3.705a4.476 4.476 0 0 0 3.46 1.635h32.91a4.531 4.531 0 0 0 3.501-1.654h.002a4.495 4.495 0 0 0 .926-3.754l-2.281-11.059c.048-.235 1.37-6.662 2.299-11.162a4.405 4.405 0 0 0-2.852-5.043V8.586c0-1.444-1.2-2.627-2.643-2.627H9.66zm0 2h30.695c.372 0 .643.275.643.627v4.437H9.018V8.586c0-.352.27-.627.642-.627zm-1.197 7.064h33.045c.733 0 1.425.326 1.887.89v.001c.462.564.642 1.3.496 2.01h.002L41.55 29.287l-.041.201.04.203 2.323 11.258a2.485 2.485 0 0 1-.514 2.082 2.527 2.527 0 0 1-1.957.924H8.492a2.469 2.469 0 0 1-1.912-.902 2.431 2.431 0 0 1-.502-2.033L8.414 29.69l.041-.203-.04-.2S7.016 22.512 6.07 17.931a2.406 2.406 0 0 1 .498-2.014l.002-.002a2.445 2.445 0 0 1 1.893-.893zm11.525 6.88c-4.429 0-4.824 4.021-4.847 5h1.873c.028-.675.338-3.298 2.974-3.298 2.468 0 2.81 1.702 2.81 2.553 0 .426-.256 2.553-2.98 2.553h-.765v1.617c.34-.085.68-.086 1.105-.086.425 0 3.32.087 3.32 2.98 0 2.809-2.979 3.063-3.404 3.063-1.509 0-3.257-.916-3.31-3.383h-1.88c.018 1.227.39 5 5.19 5 .936 0 5.362-.254 5.362-4.765 0-2.808-1.873-3.66-2.809-3.83v-.084c.596-.34 2.129-1.364 2.129-3.15 0-.682-.172-4.17-4.768-4.17zm12.557.113c-.25 1.1-.746 1.855-1.486 2.265-.74.41-1.74.615-3.002.615v1.409h3.916v11.287h2.045V22.016h-1.473z"
        })
    }));
var $d6a3e630182db681$export$2e2bcd8739ae039 = $d6a3e630182db681$var$SvgGoogleCalendar;





parcelRequire("7fPBF");
const $b2a655191d7c12f7$var$SvgGoogleClassroom = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 5C3.8 5 2 6.8 2 9v32c0 2.2 1.8 4 4 4h38c2.2 0 4-1.8 4-4V9c0-2.2-1.8-4-4-4Zm0 2h38c1.117 0 2 .883 2 2v32c0 1.117-.883 2-2 2H6c-1.117 0-2-.883-2-2V9c0-1.117.883-2 2-2Zm.813 2A1 1 0 0 0 6 10v30c0 .55.45 1 1 1h36.094A.996.996 0 0 0 44 40V10c0-.55-.45-1-1-1H6.813ZM8 11h34v28h-4v-2h-9v2H8Zm17 6c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Zm0 2c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2Zm-8 2c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm16 0c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm-16 2c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm16 0c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm-8 3c-2.727 0-4.918 1.262-5.969 2A6.446 6.446 0 0 0 17 27.656c-2.707 0-4.656 1.782-4.656 1.782L12 29.75V33h26v-3.25l-.344-.312S35.707 27.656 33 27.656c-.746 0-1.43.145-2.031.344-1.051-.738-3.242-2-5.969-2Zm0 2c2.613 0 4.55 1.457 5 1.813V31H20v-1.187c.45-.356 2.387-1.813 5-1.813Zm-8 1.656c.348 0 .676.074 1 .157V31h-4v-.281c.406-.301 1.508-1.063 3-1.063Zm16 0c1.492 0 2.594.762 3 1.063V31h-4v-1.187c.324-.083.652-.157 1-.157Z"
        })
    }));
var $b2a655191d7c12f7$export$2e2bcd8739ae039 = $b2a655191d7c12f7$var$SvgGoogleClassroom;





parcelRequire("7fPBF");
const $713e9c2c47877792$var$SvgGoogleDocs = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM17 24v2h16v-2Zm0 4v2h16v-2Zm0 4v2h16v-2Zm0 4v2h9v-2Z"
        })
    }));
var $713e9c2c47877792$export$2e2bcd8739ae039 = $713e9c2c47877792$var$SvgGoogleDocs;





parcelRequire("7fPBF");
const $e950c6997d469e51$var$SvgGoogleDrawing = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM21 22c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6Zm0 2c2.223 0 4 1.777 4 4s-1.777 4-4 4-4-1.777-4-4 1.777-4 4-4Zm7.406 7A7.979 7.979 0 0 1 25 34.906V40h9v-9Z"
        })
    }));
var $e950c6997d469e51$export$2e2bcd8739ae039 = $e950c6997d469e51$var$SvgGoogleDrawing;





parcelRequire("7fPBF");
const $28402c28da4b8b2b$var$SvgGoogleDrive = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16.406 4a1.009 1.009 0 0 0-.656.469l-15.594 25a.996.996 0 0 0-.062.968l7.812 16c.168.348.52.567.907.563h31.5c.367-.004.703-.207.874-.531l8.688-16a1.005 1.005 0 0 0-.031-1l-15.594-25A.993.993 0 0 0 33.406 4H16.406Zm.875 2h15.563L47.53 29.563 29.406 24Zm-.343.375 4.156 17.031L9.375 44.938 2.156 30.062Zm7.875 15.031L29.688 29h-9.375Zm23 8.657L39.719 45H9.938L25 31.5Z"
        })
    }));
var $28402c28da4b8b2b$export$2e2bcd8739ae039 = $28402c28da4b8b2b$var$SvgGoogleDrive;





parcelRequire("7fPBF");
const $52d4718a69ac94c7$var$SvgGoogleEarth = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2a22.87 22.87 0 0 0-12.68 3.82c-.209.12-.417.24-.613.375a1 1 0 0 0-.228.213C5.739 10.593 2 17.363 2 25c0 12.689 10.311 23 23 23 6.151 0 11.727-2.44 15.855-6.383a1 1 0 0 0 .307-.297c3.541-3.51 5.964-8.145 6.639-13.336a1 1 0 0 0 .017-.152c.115-.929.182-1.873.182-2.832 0-2.16-.304-4.25-.863-6.234a1 1 0 0 0-.084-.293 1 1 0 0 0-.004-.008C44.228 8.954 35.419 2 25 2zm0 2c9.251 0 17.089 5.969 19.893 14.268l-.014.021c-.064.105-.111.19-.158.266-.189.304-.194.445-.721.445-.638 0-1.536-.642-2.646-1.982-1.11-1.341-2.37-3.228-3.918-5.147-2.968-3.678-7.145-7.522-13.588-7.838C24.229 4.013 24.613 4 25 4zm-4 1.996A1 1 0 0 0 21 6a1 1 0 0 0 1 1 1 1 0 0 0 1-1c1.543 0 2.933.217 4.2.6a1 1 0 0 0 .001 0A1 1 0 0 0 28 7a1 1 0 0 0 .248-.033c.812.32 1.567.71 2.277 1.154A1 1 0 0 0 30 9a1 1 0 0 0 1 1 1 1 0 0 0 .988-.846A20.434 20.434 0 0 1 33.994 11 1 1 0 0 0 33 12a1 1 0 0 0 1 1 1 1 0 0 0 .996-.914c.3.345.599.691.883 1.043.255.316.494.632.736.947A1 1 0 0 0 36 15a1 1 0 0 0 1 1 1 1 0 0 0 .78-.375c.473.643.929 1.256 1.376 1.836A1 1 0 0 0 39 18a1 1 0 0 0 1 1 1 1 0 0 0 .377-.074c.56.62 1.137 1.173 1.775 1.545A1 1 0 0 0 42 21a1 1 0 0 0 1 1 1 1 0 0 0 1-1c.645 0 1.13-.225 1.512-.506.179.82.305 1.66.386 2.512A1 1 0 0 0 45 24a1 1 0 0 0 1 1c0 .562-.029 1.117-.072 1.668-1.358-.27-3.142-1.105-5.008-2.28A1 1 0 0 0 41 24a1 1 0 0 0-1-1 1 1 0 0 0-.707.295 52.774 52.774 0 0 1-1.873-1.389A1 1 0 0 0 38 21a1 1 0 0 0-1-1 1 1 0 0 0-.979.795 84.57 84.57 0 0 1-2.126-1.8A1 1 0 0 0 34 19a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 .027.232c-.778-.685-1.612-1.491-2.474-2.337A1 1 0 0 0 31 16a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 .117.465c-1.398-1.375-2.89-2.837-4.494-4.17C22.805 8.953 19.618 7 16 7c-.58 0-1.115.032-1.627.08.312-.117.644-.22.984-.316A1 1 0 0 0 16 7a1 1 0 0 0 .912-.596c.71-.133 1.428-.234 2.11-.297.738-.067 1.389-.095 1.978-.11zM25 8a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-9 1c2.886 0 5.68 1.621 8.344 3.834 2.663 2.213 5.135 4.963 7.459 6.99 2.267 2.026 4.923 4.223 7.535 5.94 2.196 1.443 4.334 2.575 6.338 2.904-.12.681-.273 1.35-.457 2.008-7.316-.215-12.785-4.076-17.781-8.106C22.298 18.424 17.704 14 12 14c-2.46 0-4.435.882-5.912 1.912a20.977 20.977 0 0 1 3.025-4.627 1 1 0 0 0 .211-.193s.326-.432 1.367-.975C11.733 9.575 13.424 9 16 9zm12 2a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-16 5c1.456 0 2.883.391 4.318 1.055A1 1 0 0 0 16 17a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-.436-.824c3.048 1.473 6.14 4.147 9.618 6.951a74.639 74.639 0 0 0 3.82 2.912A1 1 0 0 0 31 28a1 1 0 0 0 .348-.064c.67.438 1.359.856 2.064 1.255A1 1 0 0 0 33 30a1 1 0 0 0 1 1 1 1 0 0 0 .998-.95c2.204 1.09 4.59 1.927 7.209 2.343A1 1 0 0 0 42 33a1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-.086-.402c.215.018.426.042.645.054a20.88 20.88 0 0 1-1.766 3.471C42.535 36.258 39.132 38 35 38c-5.075 0-8.941-.705-12.06-1.662A1 1 0 0 0 23 36a1 1 0 0 0-1-1 1 1 0 0 0-.951.697 39.949 39.949 0 0 1-2.688-1.107c-1.763-.805-3.248-1.633-4.656-2.299a1 1 0 0 0-.633-.289h-.002C11.714 31.407 10.413 31 9 31c-1.7 0-2.907.773-3.6 1.545a21.076 21.076 0 0 1-.627-1.912A1 1 0 0 0 5 30a1 1 0 0 0-.59-.91A20.976 20.976 0 0 1 4 25a1 1 0 0 0 1-1 1 1 0 0 0-.896-.994c.088-.927.23-1.838.433-2.727a1 1 0 0 0 .078-.11S7.221 16 12 16zm-2 1a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-3 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-9 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zM7 26a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-15 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-9 3a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zM9 33c2.187 0 4.617 1.623 8.531 3.41C21.446 38.197 26.82 40 35 40c2.088 0 3.98-.4 5.492-.852-.254.279-.516.549-.785.813C39.417 40.118 35.831 42 30 42c-2.998 0-5.342-.706-7.38-1.441C20.58 39.823 18.856 39 17 39c-1.164 0-2.172.54-2.572 1.379-.4.838-.288 1.69-.104 2.447.026.106.066.2.096.303a21.093 21.093 0 0 1-8.043-8.44c.029-.085.144-.397.492-.793C7.27 33.443 7.852 33 9 33zm19 2a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-23 6c1.204 0 2.824.677 4.941 1.441C24.06 43.206 26.685 44 30 44c1.792 0 3.39-.182 4.797-.437-.901.478-1.843.89-2.817 1.236A1 1 0 0 0 31 44a1 1 0 0 0-1 1 1 1 0 0 0 .072.373c-1.624.405-3.32.627-5.072.627a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 .924.998 21.002 21.002 0 0 1-4.996-.627A1 1 0 0 0 20 45a1 1 0 0 0-1-1 1 1 0 0 0-.98.805 20.77 20.77 0 0 1-.875-.338c-.12-.214-.437-.807-.704-1.572A1 1 0 0 0 17 42a1 1 0 0 0-.627-.928c.095-.044.27-.072.627-.072z"
        })
    }));
var $52d4718a69ac94c7$export$2e2bcd8739ae039 = $52d4718a69ac94c7$var$SvgGoogleEarth;





parcelRequire("7fPBF");
const $6ee8c38486294b4f$var$SvgGoogleForms = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM17 25c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 0v2h12v-2Zm-4 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 0v2h12v-2Zm-4 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm4 0v2h12v-2Z"
        })
    }));
var $6ee8c38486294b4f$export$2e2bcd8739ae039 = $6ee8c38486294b4f$var$SvgGoogleForms;





parcelRequire("7fPBF");
const $11b2a8be749657ee$var$SvgGoogleMeet = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.97 6a1 1 0 0 0-.07.006 1 1 0 0 0-.082.012 1 1 0 0 0-.025.003 1 1 0 0 0-.068.018 1 1 0 0 0-.036.012 1 1 0 0 0-.025.01 1 1 0 0 0-.08.03 1 1 0 0 0-.063.032 1 1 0 0 0-.06.035 1 1 0 0 0-.047.031 1 1 0 0 0-.006.004 1 1 0 0 0-.068.057 1 1 0 0 0-.047.043 1 1 0 0 0-.01.01l-9.99 9.99a1 1 0 0 0-.004.004 1 1 0 0 0-.045.05 1 1 0 0 0-.021.024 1 1 0 0 0-.034.045 1 1 0 0 0-.027.037 1 1 0 0 0-.017.031 1 1 0 0 0-.036.063 1 1 0 0 0-.035.08 1 1 0 0 0-.021.06 1 1 0 0 0-.014.04 1 1 0 0 0-.002.005 1 1 0 0 0-.02.084 1 1 0 0 0-.013.098A1 1 0 0 0 2 17a1 1 0 0 0 0 .016V40c0 2.197 1.803 4 4 4h29c2.197 0 4-1.803 4-4v-4.336l6.703 5.697c1.244 1.059 3.297.11 3.297-1.523V10.162c0-1.225-1.154-2.064-2.256-1.96a1.86 1.86 0 0 0-1.04.437L39 14.336V10c0-2.197-1.803-4-4-4H13a1 1 0 0 0-.008 0 1 1 0 0 0-.021 0zM14 8h21c1.117 0 2 .883 2 2v6.037l-8 6.8V17a1 1 0 0 0-1-1H14V8zm-2 1.414V16H5.414L12 9.414zm35 .748v29.676l-8-6.8V16.962l8-6.8zM4 18h8v14H4V18zm10 0h13v14H14V18zm23 .662v12.676L29.545 25 37 18.662zm-8 8.5 8 6.8V40c0 1.117-.883 2-2 2H14v-8h14a1 1 0 0 0 1-1v-5.838zM4 34h8v8H6c-1.117 0-2-.883-2-2v-6z"
        })
    }));
var $11b2a8be749657ee$export$2e2bcd8739ae039 = $11b2a8be749657ee$var$SvgGoogleMeet;





parcelRequire("7fPBF");
const $611cb8c6b8793355$var$SvgGooglePixel6 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 1c-1.645 0-3 1.355-3 3v42c0 1.645 1.355 3 3 3h20c1.645 0 3-1.355 3-3V4c0-1.645-1.355-3-3-3H15zm0 2h20c.565 0 1 .435 1 1v42c0 .565-.435 1-1 1H15c-.565 0-1-.435-1-1V4c0-.565.435-1 1-1zm10 2a1 1 0 0 0 0 2 1 1 0 0 0 0-2z"
        })
    }));
var $611cb8c6b8793355$export$2e2bcd8739ae039 = $611cb8c6b8793355$var$SvgGooglePixel6;





parcelRequire("7fPBF");
const $480150230dd592ca$var$SvgGooglePlay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6.781 2c-.011.004-.02.027-.031.031-.027.004-.066-.008-.094 0-.21.024-.406.11-.562.25C5.422 2.648 5 3.402 5 4.22V46c0 .621.273 1.273.781 1.656.235.262.59.38.938.313.457.023.937-.078 1.343-.313.848-.492 18.157-10.5 18.157-10.5l9.031-5.218a.466.466 0 0 0 .063-.032l.124-.062s.122-.063.126-.063l.03-.031 8.688-5c.703-.406 1.262-1.066 1.25-1.875-.011-.809-.582-1.437-1.218-1.781a372.197 372.197 0 0 1-4.75-2.719c-2.118-1.227-4.126-2.406-4.126-2.406l-9.218-5.313-17.75-10.25c-.348-.199-.742-.36-1.125-.406a1.939 1.939 0 0 0-.563 0ZM7 4.688l20.375 20.218L7 45.125Zm4.75 1.906c5.086 2.937 13.469 7.781 13.469 7.781l8.062 4.656-4.5 4.469Zm23.313 13.468c.48.282 1.703.993 3.5 2.032 2.117 1.226 4.289 2.468 4.812 2.75.05.027.035.043.063.062-.04.028-.051.035-.157.094-.96.555-7.191 4.172-8.187 4.75l-4.907-4.844Zm-6.282 6.22 4.532 4.5-8.094 4.656s-8.164 4.71-13.438 7.75Z"
        })
    }));
var $480150230dd592ca$export$2e2bcd8739ae039 = $480150230dd592ca$var$SvgGooglePlay;





parcelRequire("7fPBF");
const $f49bc59318865ee6$var$SvgGooglePlayMusic = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M7.385 1c-.939 0-1.843.34-2.463 1.008C4.302 2.675 4 3.607 4 4.635v40.728c0 1.029.302 1.962.922 2.63C5.542 48.66 6.446 49 7.385 49c.991 0 1.827-.284 2.63-.748l18.131-10.377 4.354-2.49 12.27-7.024h.001C45.865 27.731 47 26.626 47 25c0-1.626-1.134-2.732-2.232-3.363l-2.565-1.475C39.901 12.565 32.842 7.02 24.5 7.02c-1.497 0-2.945.198-4.34.535L10.016 1.748C9.213 1.284 8.376 1 7.385 1zm0 2c.676 0 .99.11 1.629.48h.002l8.558 4.897C10.796 11.124 6 17.764 6 25.52c0 7.357 4.305 13.717 10.54 16.695L9.017 46.52h-.002c-.641.37-.955.48-1.631.48-.493 0-.782-.138-.996-.37C6.174 46.4 6 46.014 6 45.364V4.635c0-.65.174-1.035.389-1.266.214-.23.503-.369.996-.369zM24.5 9.02c9.125 0 16.5 7.375 16.5 16.5 0 .974-.104 1.92-.266 2.847l-5.191 2.97A12.415 12.415 0 0 0 37 25.5C37 18.608 31.392 13 24.5 13S12 18.608 12 25.5c0 6.706 5.315 12.182 11.951 12.473l-5.242 3C12.456 38.629 8 32.603 8 25.52c0-9.125 7.375-16.5 16.5-16.5zm0 5.98C30.31 15 35 19.69 35 25.5S30.31 36 24.5 36 14 31.31 14 25.5 18.69 15 24.5 15zm.5 4v7.045a2.704 2.704 0 0 0-1.344-.371A2.654 2.654 0 0 0 21 28.336C21 29.826 22.168 31 23.625 31c1.486 0 2.875-1.164 2.875-2.625v-6.5H29V19h-4zm17.777 3.799.994.572C44.595 23.844 45 24.23 45 25s-.405 1.153-1.227 1.627l-.845.484c.044-.525.072-1.055.072-1.591 0-.927-.09-1.83-.223-2.721z"
        })
    }));
var $f49bc59318865ee6$export$2e2bcd8739ae039 = $f49bc59318865ee6$var$SvgGooglePlayMusic;





parcelRequire("7fPBF");
const $a80e63067819b2a7$var$SvgGooglePlus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M17.188 10.938C9.422 10.938 3.124 17.234 3.124 25c0 7.766 6.297 14.063 14.063 14.063 7.765 0 14.062-6.297 14.062-14.063 0-.965-.105-1.906-.29-2.812l-.077-.313H17.188v4.688h9.375c-.747 4.433-4.731 7.812-9.375 7.812A9.372 9.372 0 0 1 7.813 25a9.372 9.372 0 0 1 9.375-9.375c2.343 0 4.48.867 6.125 2.29l3.359-3.29a13.997 13.997 0 0 0-9.484-3.687Zm21.875 6.25v4.687h-4.688V25h4.688v4.688h3.124V25h4.688v-3.125h-4.687v-4.687Z"
        })
    }));
var $a80e63067819b2a7$export$2e2bcd8739ae039 = $a80e63067819b2a7$var$SvgGooglePlus;





parcelRequire("7fPBF");
const $2e1061f35716bd07$var$SvgGoogleSheets = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM17 24v14h16V24Zm2 2h5v2h-5Zm7 0h5v2h-5Zm-7 4h5v2h-5Zm7 0h5v2h-5Zm-7 4h5v2h-5Zm7 0h5v2h-5Z"
        })
    }));
var $2e1061f35716bd07$export$2e2bcd8739ae039 = $2e1061f35716bd07$var$SvgGoogleSheets;





parcelRequire("7fPBF");
const $e30adf1bb2f794b5$var$SvgGoogleSlides = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.906 1.969c-.043.008-.086.02-.125.031H11.5C9.586 2 8 3.559 8 5.469v38.437C8 46.16 9.867 48 12.125 48h25.75C40.133 48 42 46.16 42 43.906V15.188a1.016 1.016 0 0 0 0-.407V14.5a.99.99 0 0 0-.281-.719l-11.5-11.5A.99.99 0 0 0 29.5 2h-.312a.972.972 0 0 0-.282-.031ZM11.5 4H28v8.344A3.666 3.666 0 0 0 31.656 16H40v27.906C40 45.074 39.055 46 37.875 46h-25.75C10.945 46 10 45.074 10 43.906V5.47C10 4.645 10.66 4 11.5 4Zm18.5.938L39.063 14h-7.407A1.633 1.633 0 0 1 30 12.344ZM18.938 22A2.952 2.952 0 0 0 16 24.938v12.125A2.95 2.95 0 0 0 18.938 40h12.125A2.95 2.95 0 0 0 34 37.063V24.937A2.952 2.952 0 0 0 31.063 22Zm0 2h12.125a.92.92 0 0 1 .937.938V26H18v-1.062a.92.92 0 0 1 .938-.938ZM18 28h14v6H18Zm0 8h14v1.063a.92.92 0 0 1-.937.937H18.938a.92.92 0 0 1-.938-.937Z"
        })
    }));
var $e30adf1bb2f794b5$export$2e2bcd8739ae039 = $e30adf1bb2f794b5$var$SvgGoogleSlides;





parcelRequire("7fPBF");
const $a3ace68bbd1278b8$var$SvgGrammarly = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm0 8c-7.162 0-13 5.838-13 13s5.838 13 13 13c4.017 0 7.615-1.834 10-4.709V36.5a1.5 1.5 0 0 0 3 0V29a1 1 0 0 0-1-1h-7.5a1.5 1.5 0 0 0 0 3h3.484c-1.821 2.426-4.707 4-7.984 4-5.54 0-10-4.46-10-10s4.46-10 10-10c3.433 0 6.438 1.724 8.242 4.35a1.5 1.5 0 1 0 2.473-1.7C33.373 14.242 29.44 12 25 12z"
        })
    }));
var $a3ace68bbd1278b8$export$2e2bcd8739ae039 = $a3ace68bbd1278b8$var$SvgGrammarly;





parcelRequire("7fPBF");
const $13c1584923501bf3$var$SvgHboMax = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.49-10 10v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10v-22c0-5.51-4.489-10-10-10H14zm0 2h22c4.431 0 8 3.57 8 8v22c0 4.431-3.569 8-8 8H14c-4.431 0-8-3.569-8-8v-22c0-4.43 3.569-8 8-8zm-1.613 7.823v10.923h2.73v-4.095h2.047v4.095h2.732V13.813h-2.732v4.095h-2.047v-4.096h-2.73zm8.191 0v10.921h2.64v.002h1.98c1.98 0 3.3-1.213 3.3-2.73 0-.35-.05-.681-.135-.988a5.434 5.434 0 0 0 5.176 3.718A5.44 5.44 0 0 0 39 19.273a5.438 5.438 0 0 0-5.46-5.46 5.432 5.432 0 0 0-5.157 3.666c.07-.292.115-.606.115-.936 0-1.517-1.32-2.73-3.3-2.73h-4.62zm2.73 2.732h1.495c.478 0 .894.396.894.851 0 .455-.416.856-.894.856h-1.494v-1.707zm10.23 0a2.706 2.706 0 0 1 2.732 2.73 2.706 2.706 0 0 1-2.733 2.73 2.704 2.704 0 0 1-2.73-2.73 2.704 2.704 0 0 1 2.73-2.73zm0 1.057c-.937 0-1.673.734-1.673 1.671s.736 1.672 1.672 1.672c.936 0 1.674-.735 1.674-1.672 0-.936-.738-1.671-1.674-1.671zm-5.263.222a5.53 5.53 0 0 0-.199 1.45c0 .538.08 1.057.223 1.548-.313-.917-.975-1.549-1.781-1.549.823.001 1.445-.587 1.757-1.449zM23.31 20.3h1.494c.478 0 .894.4.894.853 0 .454-.416.854-.894.854h-1.494v-1.707zm3.412 5.273c-2.574 0-4.666 2.38-4.666 5.307 0 2.927 2.093 5.307 4.666 5.307 1.21 0 2.31-.531 3.14-1.393v.248c0 .528.427.955.955.955h.957V25.758h-.957a.954.954 0 0 0-.955.955v.248c-.83-.86-1.931-1.389-3.14-1.389zm5.234.188 3.229 4.375c.355.482.355 1.139 0 1.62l-3.08 4.175h1.685a1.37 1.37 0 0 0 1.1-.555l1.752-2.373a.41.41 0 0 1 .66 0l1.752 2.373c.258.349.665.555 1.1.555h1.683l-3.078-4.174a1.368 1.368 0 0 1-.002-1.621l3.226-4.375H40.3a1.37 1.37 0 0 0-1.1.554l-1.898 2.573a.41.41 0 0 1-.66 0l-1.9-2.573a1.363 1.363 0 0 0-1.098-.554h-1.688zm-14.209.068a3.969 3.969 0 0 0-.9.072c-.852.165-1.57.637-2.102 1.27a3.822 3.822 0 0 0-3.658-1.27c-1.82.355-3.068 2.061-3.068 3.916v5.227c0 .528.429.955.957.955h.955v-6.336c0-1.06.862-1.924 1.922-1.924s1.923.863 1.923 1.924v5.381c0 .528.43.955.957.955h.954v-6.336c0-1.06.862-1.924 1.923-1.924 1.06 0 1.924.863 1.924 1.924v5.381c0 .528.428.955.957.955h.955v-6.336a3.838 3.838 0 0 0-3.699-3.834zm8.975 1.654c1.519 0 2.758 1.523 2.758 3.397 0 1.874-1.237 3.394-2.758 3.394s-2.754-1.52-2.754-3.394c0-1.873 1.235-3.397 2.754-3.397z"
        })
    }));
var $13c1584923501bf3$export$2e2bcd8739ae039 = $13c1584923501bf3$var$SvgHboMax;





parcelRequire("7fPBF");
const $a40ac44443616e4e$var$SvgHeadMovement = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m60.786 78.88-1.175.892a16.729 16.729 0 0 1-9.587 3.396c-.97-.03-1.932-.146-2.874-.341a22.922 22.922 0 0 1-16.298-4.14L19.89 70.789c-1.7-1.225-3.175-2.534-4.043-4.203-3.001-5.773-4.56-16.467 5.207-26.233 3.98-3.98 8.259-5.908 12.298-6.562a21.803 21.803 0 0 1 3.096-2.425c-5.385.051-11.43 1.968-16.921 7.46C8.96 49.392 10.588 61.154 13.93 67.582c1.107 2.13 2.923 3.682 4.697 4.96l10.961 7.897a25.082 25.082 0 0 0 18.066 4.5l2.425-.333a17.81 17.81 0 0 0 9.15-4.103c.1-.05.196-.118.28-.202.124-.124.247-.25.367-.378.128-.12.255-.243.38-.368.083-.084.15-.179.201-.28.111-.13.22-.262.328-.395Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.496 29.086c-12.673 0-18.978 8.52-20.917 14.678-.546 1.733-.44 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.663 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.653 22.653 0 0 0 8.664-14.41l2.166-13.336c.335-2.058.443-3.974-.104-5.706-1.931-6.116-8.303-14.679-21.974-14.679Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.696-16.128l2.167-13.336c.352-2.168.548-4.6-.195-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.167 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.481 3.62c.125.038.257.058.393.058.176 0 .352-.002.528-.008.176.006.352.008.528.008.137 0 .269-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M53.182 82.765a16.73 16.73 0 0 1-3.158.403 16.73 16.73 0 0 1-8.236-2.471 17.81 17.81 0 0 0 8.92 3.91l2.425.332a25.082 25.082 0 0 0 18.065-4.5l10.962-7.897c1.773-1.278 3.59-2.83 4.697-4.96 3.342-6.428 4.97-18.19-5.596-28.756-5.831-5.832-12.286-7.632-17.913-7.448a22.078 22.078 0 0 1 3.05 2.271c4.338.48 9.013 2.381 13.335 6.704 9.767 9.766 8.209 20.46 5.207 26.233-.867 1.669-2.342 2.978-4.043 4.203l-10.962 7.897a22.922 22.922 0 0 1-16.51 4.112l-.243-.033Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $a40ac44443616e4e$export$2e2bcd8739ae039 = $a40ac44443616e4e$var$SvgHeadMovement;





parcelRequire("7fPBF");
const $f3215e388a4926a3$var$SvgHeadMovement1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m62.192 82.689-1.328 1.008a18.905 18.905 0 0 1-10.833 3.837 18.897 18.897 0 0 1-3.248-.386c-6.507.83-13.09-.84-18.417-4.678L15.98 73.545c-1.922-1.384-3.588-2.863-4.568-4.749-3.392-6.523-5.152-18.608 5.884-29.643 4.497-4.498 9.332-6.676 13.896-7.416a24.636 24.636 0 0 1 3.499-2.74c-6.086.058-12.916 2.224-19.121 8.43-11.94 11.94-10.1 25.231-6.324 32.495 1.252 2.407 3.303 4.16 5.307 5.604L26.94 84.45a28.343 28.343 0 0 0 20.414 5.084l2.74-.375a20.125 20.125 0 0 0 10.34-4.636 1.22 1.22 0 0 0 .315-.229c.141-.14.28-.283.416-.428.144-.136.287-.274.428-.415a1.22 1.22 0 0 0 .228-.316c.126-.147.25-.296.37-.447Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.434 26.421c-14.32 0-21.445 9.627-23.637 16.586-.617 1.96-.496 4.125-.118 6.45l2.448 15.069a25.597 25.597 0 0 0 9.79 16.283l2.203 1.672a17.38 17.38 0 0 0 9.91 3.526 17.38 17.38 0 0 0 9.911-3.526l2.203-1.672a25.597 25.597 0 0 0 9.79-16.283l2.448-15.07c.378-2.325.501-4.49-.117-6.447-2.183-6.912-9.384-16.588-24.83-16.588Zm1.637 62.582a20.43 20.43 0 0 0 10.715-4.091l2.203-1.672a28.648 28.648 0 0 0 10.956-18.225l2.449-15.07c.398-2.45.62-5.198-.22-7.855-2.497-7.907-10.695-18.72-27.74-18.72-16.005 0-24.072 10.863-26.547 18.72-.837 2.657-.618 5.404-.22 7.856l2.449 15.07A28.648 28.648 0 0 0 36.072 83.24l2.203 1.672a20.43 20.43 0 0 0 10.715 4.09c.14.044.29.067.444.067.2 0 .398-.003.597-.01.198.007.397.01.596.01.154 0 .304-.023.444-.066Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m4.71 24.817-.248-4.476a1.526 1.526 0 1 0-3.046.17l.461 8.311 8.686 1.829a1.525 1.525 0 1 0 .629-2.986l-4.134-.87c5.588-5.253 20.43-14.37 42.322-14.37 21.696 0 37.422 9.415 43.394 14.395l-4.016.845a1.525 1.525 0 1 0 .629 2.986l8.686-1.829.462-8.312a1.526 1.526 0 1 0-3.047-.169l-.254 4.567C89.145 19.62 72.48 9.374 49.38 9.374c-22.972 0-38.676 9.664-44.67 15.443Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M53.6 87.079a18.91 18.91 0 0 1-3.57.455 18.906 18.906 0 0 1-9.306-2.793 20.125 20.125 0 0 0 10.08 4.418l2.74.375a28.343 28.343 0 0 0 20.413-5.084l12.387-8.924c2.004-1.444 4.056-3.197 5.308-5.604 3.776-7.264 5.616-20.556-6.324-32.495-6.59-6.59-13.882-8.624-20.24-8.416a24.95 24.95 0 0 1 3.446 2.567c4.901.541 10.184 2.69 15.068 7.575 11.036 11.035 9.276 23.12 5.884 29.643-.98 1.886-2.646 3.365-4.568 4.75L72.53 82.47a25.902 25.902 0 0 1-18.657 4.646l-.275-.037Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $f3215e388a4926a3$export$2e2bcd8739ae039 = $f3215e388a4926a3$var$SvgHeadMovement1;





parcelRequire("7fPBF");
const $8cbedcd5de46db09$var$SvgHeadTurning = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                clipPath: "url(#Head-Turning_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeOpacity: 0.3,
                        strokeWidth: 2.16,
                        d: "M41.407 30.004c-12.382-4.311-21.141 1.038-25.315 6.123-1.655 2.017-2.154 4.667-2.206 7.275l-.077 3.888a6.918 6.918 0 0 1-1.36 3.983l-5.276 7.118c-1.358 1.831.019 4.419 2.297 4.315a2.706 2.706 0 0 1 2.789 2.24l.473 2.724.945 4.535c.162.78.4 1.543.708 2.278l.672 1.598a8.52 8.52 0 0 0 6.415 5.098l.701.12c1.065.183 2.145.264 3.225.244l.056-.001a17.716 17.716 0 0 0 5.158-.872l3.954-1.29a25.2 25.2 0 0 0 14.347-11.97l5.657-10.462c1.016-1.878 1.872-3.879 1.922-6.014.154-6.571-3.086-16.752-15.085-20.93Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeOpacity: 0.3,
                        strokeWidth: 2.16,
                        d: "M58.843 30.004c12.382-4.311 21.141 1.038 25.314 6.123 1.656 2.017 2.155 4.667 2.207 7.275l.077 3.888a6.918 6.918 0 0 0 1.36 3.983l5.276 7.118c1.358 1.831-.019 4.419-2.297 4.315a2.706 2.706 0 0 0-2.79 2.24l-.472 2.724-.945 4.535c-.162.78-.4 1.543-.708 2.278l-.672 1.598a8.52 8.52 0 0 1-6.415 5.098l-.702.12a17.133 17.133 0 0 1-3.224.244l-.056-.001a17.715 17.715 0 0 1-5.158-.872l-3.955-1.29a25.2 25.2 0 0 1-14.346-11.97L45.68 56.948c-1.016-1.878-1.872-3.879-1.922-6.014-.154-6.571 3.086-16.752 15.084-20.93Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#FBFDFE",
                        d: "m61.186 76.942-1.95 1.48a16.73 16.73 0 0 1-9.586 3.396 16.73 16.73 0 0 1-9.587-3.396l-1.95-1.48a24.002 24.002 0 0 1-9.18-15.268l-2.166-13.336c-.343-2.114-.493-4.287.15-6.33 2.065-6.556 8.786-15.622 22.205-15.622 14.377 0 21.19 9.066 23.261 15.622.645 2.042.493 4.216.15 6.33l-2.167 13.335a24.002 24.002 0 0 1-9.18 15.27Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: 2.7,
                        d: "M49.122 81.826v0c3.653 0 7.205-1.195 10.115-3.404l1.95-1.48a24.002 24.002 0 0 0 9.179-15.268l2.167-13.336c.343-2.114.495-4.288-.15-6.33-2.07-6.556-8.884-15.622-23.26-15.622-13.42 0-20.141 9.066-22.206 15.622-.643 2.043-.493 4.216-.15 6.33l2.167 13.335a24.002 24.002 0 0 0 9.18 15.27l1.95 1.48a16.73 16.73 0 0 0 10.114 3.403v0"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#E51546",
                        d: "M3.293 15.293a1 1 0 0 0 0 1.414l6.364 6.364a1 1 0 0 0 1.414-1.414L5.414 16l5.657-5.657A1 1 0 1 0 9.657 8.93l-6.364 6.364Zm93.414 1.414a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 0 0-1.414 1.414L94.586 16l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM4 17h92v-2H4v2Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "Head-Turning_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h100v100H0z"
                    })
                })
            })
        ]
    }));
var $8cbedcd5de46db09$export$2e2bcd8739ae039 = $8cbedcd5de46db09$var$SvgHeadTurning;





parcelRequire("7fPBF");
const $95fa162f48833150$var$SvgHeadUpAndDown = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                opacity: 0.9,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeOpacity: 0.3,
                        strokeWidth: 2.16,
                        d: "M49.872 72.44v0a16.73 16.73 0 0 0 10.115-3.404l1.95-1.48a24.002 24.002 0 0 0 9.179-15.269l2.167-13.335c.343-2.114.495-4.288-.15-6.33C71.064 26.066 64.25 17 49.873 17c-13.42 0-20.141 9.066-22.206 15.622-.643 2.042-.493 4.216-.15 6.33l2.167 13.335a24.002 24.002 0 0 0 9.18 15.27l1.95 1.479a16.729 16.729 0 0 0 10.114 3.404v0"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "#FBFDFE",
                        d: "m38.856 77.942 1.95 1.48a16.73 16.73 0 0 0 9.587 3.396 16.73 16.73 0 0 0 9.587-3.396l1.95-1.48a24.002 24.002 0 0 0 9.179-15.268l2.166-13.336c.344-2.114.494-4.287-.15-6.33-2.064-6.556-8.786-15.622-22.204-15.622-14.377 0-21.19 9.066-23.262 15.622-.645 2.042-.492 4.216-.15 6.33l2.168 13.335a24.002 24.002 0 0 0 9.18 15.27Z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeWidth: 2.7,
                        d: "M50.92 82.826v0a16.729 16.729 0 0 1-10.114-3.404l-1.95-1.48a24.002 24.002 0 0 1-9.18-15.268L27.51 49.338c-.344-2.114-.496-4.288.15-6.33 2.07-6.556 8.884-15.622 23.26-15.622 13.42 0 20.14 9.066 22.206 15.622.643 2.043.493 4.216.15 6.33l-2.167 13.335a24.002 24.002 0 0 1-9.18 15.27l-1.95 1.48a16.73 16.73 0 0 1-10.114 3.403v0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 3,
                d: "M8 78.116v-47M3 32.884l4.864-4.367 5.136 4.6M92 28v47M87 73.232l4.864 4.367L97 73"
            })
        ]
    }));
var $95fa162f48833150$export$2e2bcd8739ae039 = $95fa162f48833150$var$SvgHeadUpAndDown;





parcelRequire("7fPBF");
const $d6570d7c790cde0b$var$SvgHealth = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.489-10 10v22c0 5.512 4.489 10 10 10h22c5.511 0 10-4.488 10-10v-22c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8v-22c0-4.43 3.57-8 8-8zm10.453 5.188C22.055 11.335 20 13.163 20 16.154c0 4.158 3.265 8.787 9.008 11.729.305.156.678.156.984 0C35.735 24.942 39 20.313 39 16.154c0-4.786-5.26-6.594-8.771-3.345a1.067 1.067 0 0 1-1.458 0c-1.317-1.219-2.879-1.726-4.318-1.631z"
        })
    }));
var $d6570d7c790cde0b$export$2e2bcd8739ae039 = $d6570d7c790cde0b$var$SvgHealth;





parcelRequire("7fPBF");
const $32705bcb0cd360a7$var$SvgHulu = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M33.816 16.836V32h-3.64V16.836h3.64m-28.175 0v4.941s.105-.043.32-.105l.918-.11h2.523c.707 0 1.356.13 1.95.387.617.254 1.105.66 1.488 1.211.363.578.555 1.32.555 2.238V32H9.754v-6.133c-.024-.258-.11-.512-.3-.683a1.036 1.036 0 0 0-.68-.278h-2.13c-.3 0-.511.11-.703.278-.195.171-.277.425-.3.683V32H2V16.836h3.64M48 21.566v6.43c0 .766-.148 1.469-.445 2.067a3.284 3.284 0 0 1-1.239 1.406c-.55.316-1.21.488-1.976.488V32H40.78a5.108 5.108 0 0 1-2.191-.469c-.621-.297-1.086-.746-1.45-1.343-.363-.594-.511-1.34-.535-2.192v-6.43h3.665v6.11c0 .277.105.512.277.703.172.172.406.258.703.277h2.129c.277-.02.512-.105.684-.277.167-.192.277-.426.277-.703v-6.11H48m-20.594 0v6.43c-.02.766-.172 1.469-.445 2.067a3.516 3.516 0 0 1-1.258 1.406c-.535.316-1.191.488-1.96.488V32h-3.579a5.044 5.044 0 0 1-2.191-.469 3.259 3.259 0 0 1-1.45-1.343c-.34-.594-.511-1.34-.511-2.192v-6.43h3.644v6.11c.02.277.106.512.297.703.168.172.406.258.68.277h2.133a1.15 1.15 0 0 0 .703-.277 1.15 1.15 0 0 0 .273-.703v-6.11h3.664m6.41-6.73h-3.64c-1.106 0-2 .894-2 2v2.883a1.946 1.946 0 0 0-.77-.153h-3.664c-1.105 0-2 .895-2 2v5.09h-.09v-5.09c0-1.105-.894-2-2-2h-3.64c-1.063 0-1.93.825-1.996 1.868a5.295 5.295 0 0 0-1.903-1.332c-.812-.356-1.734-.54-2.71-.54H7.64v-2.726c0-1.106-.895-2-2-2H2c-1.105 0-2 .894-2 2V32c0 1.105.895 2 2 2h3.64c1.106 0 2-.895 2-2v-5.094h.114V32c0 1.105.894 2 2 2h3.64c1.09 0 1.981-.875 2-1.965a5.24 5.24 0 0 0 1.711 1.297c.97.453 1.961.668 3.06.668h3.577c.168 0 .328-.02.485-.059.93-.066 1.77-.32 2.503-.757a5.441 5.441 0 0 0 1.445-1.309V32c0 1.105.895 2 2 2h3.641c1.106 0 2-.895 2-2v-.21a5.276 5.276 0 0 0 1.903 1.542A7.18 7.18 0 0 0 40.78 34h3.559c.164 0 .328-.02.484-.059a5.695 5.695 0 0 0 2.492-.742l.082-.047a5.272 5.272 0 0 0 1.957-2.222c.426-.867.645-1.856.645-2.934v-6.433c0-1.102-.895-2-2-2h-3.664c-1.106 0-2 .898-2 2v5.093h-.066v-5.093c0-1.102-.895-2-2-2h-3.665c-.28 0-.546.058-.789.164v-2.891c0-1.106-.894-2-2-2Z"
        })
    }));
var $32705bcb0cd360a7$export$2e2bcd8739ae039 = $32705bcb0cd360a7$var$SvgHulu;





parcelRequire("7fPBF");
const $45cda0bdf909d545$var$SvgIcloud = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.5 11c-4.291 0-8.021 2.22-10.27 5.521-.715-.25-1.428-.521-2.23-.521-3.336 0-6.056 2.386-6.748 5.523C5.645 22.698 3 26.012 3 30c0 4.959 4.041 9 9 9h27c4.406 0 8-3.594 8-8 0-3.705-2.581-6.723-6.012-7.625C40.92 16.542 35.348 11 28.5 11zm0 2C34.31 13 39 17.69 39 23.5c0 .125-.017.297-.027.527a1 1 0 0 0 .861 1.04A5.984 5.984 0 0 1 45 31c0 3.326-2.674 6-6 6H12c-3.877 0-7-3.123-7-7a6.988 6.988 0 0 1 5.295-6.781 1 1 0 0 0 .75-.846 4.986 4.986 0 0 1 7.148-3.86 1 1 0 0 0 1.3-.384C21.326 15.06 24.66 13 28.5 13z"
        })
    }));
var $45cda0bdf909d545$export$2e2bcd8739ae039 = $45cda0bdf909d545$var$SvgIcloud;





parcelRequire("7fPBF");
const $0fa071542d1ff183$var$SvgImovie = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.031 1a1 1 0 0 0-.974.668L18.293 18H1a1 1 0 0 0-.617 1.787l13.445 10.565-5.777 17.332a1 1 0 0 0 1.515 1.14L25 38.213l15.434 10.611a1 1 0 0 0 1.515-1.14l-5.777-17.332 13.445-10.565A1 1 0 0 0 49 18H31.707L25.943 1.668A1 1 0 0 0 25.031 1zM25 5.004l5.057 14.328A1 1 0 0 0 31 20h15.107l-11.724 9.213a1 1 0 0 0-.332 1.103l5.056 15.168-13.54-9.308a1 1 0 0 0-1.133 0l-13.541 9.308 5.056-15.168a1 1 0 0 0-.332-1.103L3.893 20H19a1 1 0 0 0 .943-.668L25 5.004zM20 22c-1.093 0-2 .907-2 2h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v4c0 1.093.907 2 2 2h8c1.093 0 2-.907 2-2v-2l3 2v-6l-3 2v-2c0-1.093-.907-2-2-2h-8zm0 2h8v6h-8v-6z"
        })
    }));
var $0fa071542d1ff183$export$2e2bcd8739ae039 = $0fa071542d1ff183$var$SvgImovie;





parcelRequire("7fPBF");
const $655e3e5c364148e2$var$SvgInstagram = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16 3C8.832 3 3 8.832 3 16v18c0 7.168 5.832 13 13 13h18c7.168 0 13-5.832 13-13V16c0-7.168-5.832-13-13-13H16zm0 2h18c6.086 0 11 4.914 11 11v18c0 6.086-4.914 11-11 11H16C9.914 45 5 40.086 5 34V16C5 9.914 9.914 5 16 5zm21 6a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2zm-12 3c-6.063 0-11 4.937-11 11s4.937 11 11 11 11-4.937 11-11-4.937-11-11-11zm0 2c4.982 0 9 4.018 9 9s-4.018 9-9 9-9-4.018-9-9 4.018-9 9-9z"
        })
    }));
var $655e3e5c364148e2$export$2e2bcd8739ae039 = $655e3e5c364148e2$var$SvgInstagram;





parcelRequire("7fPBF");
const $9bb0f831af78c332$var$SvgIosLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 3C8.385 3 3 8.385 3 15v20c0 6.615 5.385 12 12 12h20c6.615 0 12-5.385 12-12V15c0-6.615-5.385-12-12-12H15zm0 2h20c5.535 0 10 4.465 10 10v20c0 5.535-4.465 10-10 10H15C9.465 45 5 40.535 5 35V15C5 9.465 9.465 5 15 5zm-3.385 13.066c-.703 0-1.22.502-1.22 1.16 0 .65.517 1.151 1.22 1.151s1.223-.5 1.223-1.15c0-.66-.52-1.16-1.223-1.16zm10.422.57c-3.639 0-5.924 2.55-5.924 6.645 0 4.087 2.241 6.653 5.924 6.653 3.674 0 5.906-2.575 5.906-6.653 0-4.087-2.25-6.643-5.906-6.644zm12.93 0c-2.768 0-4.615 1.503-4.615 3.762 0 1.863 1.045 2.972 3.34 3.508l1.634.397c1.68.395 2.418.974 2.418 1.941 0 1.125-1.16 1.942-2.742 1.942-1.695 0-2.873-.764-3.041-1.967h-1.953c.14 2.268 2.03 3.717 4.842 3.717 3.006 0 4.886-1.52 4.886-3.946 0-1.907-1.072-2.962-3.673-3.568l-1.397-.344c-1.652-.387-2.32-.905-2.32-1.81 0-1.143 1.037-1.89 2.593-1.89 1.477 0 2.495.728 2.68 1.897h1.916c-.114-2.136-1.993-3.638-4.568-3.638zm-12.93 1.837c2.41 0 3.895 1.864 3.895 4.808 0 2.926-1.487 4.817-3.895 4.817-2.434 0-3.91-1.89-3.91-4.817 0-2.944 1.52-4.807 3.91-4.808zm-11.361 1.584v9.57h1.88v-9.57h-1.88z"
        })
    }));
var $9bb0f831af78c332$export$2e2bcd8739ae039 = $9bb0f831af78c332$var$SvgIosLogo;





parcelRequire("7fPBF");
const $142e6c76da9ebc8b$var$SvgIosPhotos = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 1c-3.566 0-6.566 2.36-7.594 5.594a7.984 7.984 0 0 0-3.718-.907c-2.051 0-4.098.786-5.657 2.344a8.019 8.019 0 0 0-1.437 9.375C3.359 18.434 1 21.434 1 25c0 3.57 2.355 6.602 5.594 7.625-1.567 3.016-1.086 6.82 1.437 9.344 2.524 2.523 6.328 3.004 9.344 1.437C18.398 46.645 21.43 49 25 49c3.57 0 6.602-2.355 7.625-5.594 3.016 1.567 6.82 1.086 9.344-1.437a8.019 8.019 0 0 0 1.437-9.375C46.641 31.566 49 28.566 49 25c0-3.566-2.36-6.566-5.594-7.594.004-.008-.004-.023 0-.031 1.567-3.016 1.086-6.82-1.437-9.344a7.977 7.977 0 0 0-9.344-1.437c0-.004-.031.004-.031 0C31.566 3.359 28.566 1 25 1Zm0 2a5.97 5.97 0 0 1 5.875 4.813c-.074.07-.145.144-.219.218l-4.25 4.25A8.04 8.04 0 0 0 25 14.156a8.04 8.04 0 0 0-1.406-1.875l-4.25-4.25c-.074-.074-.145-.148-.219-.219A5.97 5.97 0 0 1 25 3ZM13.688 7.688C14.836 7.688 16 8 17 8.656c-.004.114 0 .227 0 .344v6c0 .828.14 1.625.375 2.375A7.952 7.952 0 0 0 15 17H9c-.117 0-.23-.004-.344 0a6.012 6.012 0 0 1 5.031-9.312Zm22.624 0A6.012 6.012 0 0 1 41.344 17c-.113-.005-.226-.001-.343-.001h-6c-.828 0-1.625.14-2.375.375.234-.75.375-1.547.375-2.375V9c0-.117.004-.23 0-.344 1-.656 2.164-.969 3.313-.969ZM19 10.5l3.188 3.188a5.982 5.982 0 0 1 1.062 7.03A5.966 5.966 0 0 1 19 15Zm12 0V15c0 2.71-1.79 4.973-4.25 5.719a5.98 5.98 0 0 1 1.063-7.032ZM10.5 19H15c2.71 0 4.973 1.79 5.719 4.25a5.98 5.98 0 0 1-7.032-1.062ZM35 19h4.5l-3.187 3.188a5.982 5.982 0 0 1-7.032 1.062A5.966 5.966 0 0 1 35 19Zm-27.219.125c.012-.004.02.004.032 0 .07.074.144.145.218.219l4.25 4.25A8.04 8.04 0 0 0 14.156 25a8.151 8.151 0 0 0-1.875 1.406l-4.25 4.25c-.074.074-.148.145-.219.219A5.97 5.97 0 0 1 3 25a5.977 5.977 0 0 1 4.781-5.875Zm34.407 0A5.97 5.97 0 0 1 47 25a5.97 5.97 0 0 1-4.812 5.875c-.07-.074-.145-.145-.22-.219l-4.25-4.25A8.151 8.151 0 0 0 35.845 25a8.04 8.04 0 0 0 1.875-1.406l4.25-4.25c.074-.074.148-.145.218-.219Zm-18 3.844c.269.027.535.031.812.031s.543-.004.813-.031c.18.222.386.418.593.625.207.207.403.414.625.593-.027.27-.031.536-.031.813 0 .277.004.543.031.813-.222.18-.418.386-.625.593-.207.207-.414.403-.593.625A7.983 7.983 0 0 0 25 27c-.277 0-.543.004-.812.031-.18-.222-.387-.418-.594-.625-.207-.207-.403-.414-.625-.593.027-.27.031-.536.031-.813 0-.277-.004-.543-.031-.812.222-.18.418-.387.625-.594.207-.207.414-.403.593-.625Zm-6.25 3.093c.957 0 1.917.231 2.78.688A5.966 5.966 0 0 1 15 31h-4.5l3.188-3.187a5.98 5.98 0 0 1 4.25-1.75Zm14.125 0a5.98 5.98 0 0 1 4.25 1.75L39.5 31H35a5.966 5.966 0 0 1-5.719-4.25 5.991 5.991 0 0 1 2.782-.687Zm-8.844 3.22c.008-.005.023.003.031 0a5.98 5.98 0 0 1-1.062 7.03L19 39.5V35a5.976 5.976 0 0 1 4.219-5.719Zm3.531 0A5.966 5.966 0 0 1 31 35v4.5l-3.187-3.187a5.982 5.982 0 0 1-1.063-7.032Zm-9.375 3.343A7.952 7.952 0 0 0 17 35v6c0 .117-.004.23 0 .344a6.012 6.012 0 0 1-7.562-.782A6.012 6.012 0 0 1 8.656 33c.114.004.227 0 .344 0h6c.828 0 1.625-.14 2.375-.375Zm15.25 0c.75.234 1.547.375 2.375.375h6c.117 0 .23.004.344 0a6.012 6.012 0 0 1-.782 7.563 6.012 6.012 0 0 1-7.562.78c.004-.113 0-.226 0-.343v-6c0-.828-.14-1.625-.375-2.375ZM25 35.844a8.04 8.04 0 0 0 1.406 1.875l4.25 4.25c.074.074.145.148.219.218A5.97 5.97 0 0 1 25 47a5.97 5.97 0 0 1-5.875-4.812c.074-.07.145-.145.219-.22l4.25-4.25A8.04 8.04 0 0 0 25 35.845Z"
        })
    }));
var $142e6c76da9ebc8b$export$2e2bcd8739ae039 = $142e6c76da9ebc8b$var$SvgIosPhotos;





parcelRequire("7fPBF");
const $37d29f22d8db03a3$var$SvgItunes = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm9.053 8a1.012 1.012 0 0 0-.227.016l-13.695 2.593A1.366 1.366 0 0 0 19 15.955v13.268a1 1 0 0 1-.754.968l-3.445.88-.291.07a3.513 3.513 0 0 0-2.47 3.882C12.311 36.786 13.98 38 15.765 38h.1C18.7 38 21 35.7 21 32.865V22.328c0-.676.485-1.254 1.15-1.371l9.676-1.883A1 1 0 0 1 33 20.06v6.164a1 1 0 0 1-.754.968l-3.445.88-.291.07a3.513 3.513 0 0 0-2.47 3.882C26.311 33.786 27.98 35 29.765 35h.1C32.7 35 35 32.7 35 29.865V13a1 1 0 0 0-.947-1z"
        })
    }));
var $37d29f22d8db03a3$export$2e2bcd8739ae039 = $37d29f22d8db03a3$var$SvgItunes;





const $c25bb468cbb9a994$var$SvgJavaScript = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M13.336 8C10.414 8 8 10.414 8 13.336v73.328C8 89.586 10.414 92 13.336 92h73.328C89.586 92 92 89.594 92 86.664V13.336C92 10.414 89.594 8 86.664 8zm0 4h73.328A1.33 1.33 0 0 1 88 13.336v73.328A1.33 1.33 0 0 1 86.664 88H13.336A1.33 1.33 0 0 1 12 86.664V13.336A1.33 1.33 0 0 1 13.336 12M46 46v25.148C46 75.008 44.54 76 42 76c-2.656 0-4.5-1.656-5.719-3.805L30 76c1.82 3.852 6.281 8 12.469 8C49.312 84 54 80.36 54 72.367V46zm24.906 0c-6.812 0-11.18 4.36-11.18 10.086 0 6.21 3.665 9.148 9.172 11.492l1.907.82C74.28 69.922 76 70.852 76 73.468c0 2.18-1.656 3.759-4.82 3.759-3.766 0-5.547-2.555-7.18-5.227l-6 4c2.242 4.43 6.266 8 13.352 8C78.602 84 84 80.234 84 73.367c0-6.375-3.656-9.21-10.148-11.992l-1.907-.812c-3.273-1.422-4.695-2.344-4.695-4.633 0-1.852 1.422-3.274 3.656-3.274 2.196 0 3.602.93 4.906 3.274l5.946-3.813c-2.508-4.43-6-6.117-10.852-6.117"
        })
    }));
var $c25bb468cbb9a994$export$2e2bcd8739ae039 = $c25bb468cbb9a994$var$SvgJavaScript;





parcelRequire("7fPBF");
const $c44bfc9fc6a27ffb$var$SvgJira = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 44.343 46"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M22.156 0a1 1 0 0 0-.691.293l-.02.02L.88 20.879a3.015 3.015 0 0 0 0 4.242l20.586 20.586a1 1 0 0 0 1.414 0l.02-.02 20.566-20.566a3.015 3.015 0 0 0 0-4.242L22.879.293A1 1 0 0 0 22.156 0zm.078 2.477 19.817 19.816a.985.985 0 0 1 0 1.414L25.934 39.824c.118-.582.204-1.172.236-1.771a1 1 0 0 0 0-.106 12.046 12.046 0 0 0-2.633-6.896l7.342-7.344a1 1 0 0 0 0-1.414l-7.98-7.98A10.036 10.036 0 0 1 20.181 8a10.048 10.048 0 0 1 2.052-5.523zM18.41 6.176a12.023 12.023 0 0 0-.236 1.771 1 1 0 0 0 0 .106 12.044 12.044 0 0 0 2.635 6.896l-7.344 7.344a1 1 0 0 0 0 1.414l8 8.002A10.036 10.036 0 0 1 24.162 38a10.048 10.048 0 0 1-2.053 5.523L2.293 23.707a.985.985 0 0 1 0-1.414L18.41 6.176zm3.762 10.238L28.758 23l-6.586 6.586L15.586 23l6.586-6.586z"
        })
    }));
var $c44bfc9fc6a27ffb$export$2e2bcd8739ae039 = $c44bfc9fc6a27ffb$var$SvgJira;





parcelRequire("7fPBF");
const $a632d8591d1e8129$var$SvgKey0 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.394 7.945c-1.531 0-2.746.543-3.644 1.63C20.449 16.66 20 18.206 20 20.214v3.523c0 2.016.453 3.567 1.355 4.645.899 1.078 2.122 1.617 3.66 1.617 1.536 0 2.75-.54 3.641-1.613.895-1.075 1.344-2.625 1.344-4.649v-3.523c0-2.008-.45-3.555-1.355-4.64-.903-1.087-2.122-1.63-3.653-1.63Zm.004 1.672c.805 0 1.426.36 1.86 1.082.43.723.648 1.79.648 3.207v4.133c0 1.422-.215 2.496-.645 3.223-.43.726-1.043 1.086-1.843 1.086-.805 0-1.426-.364-1.86-1.094-.43-.727-.644-1.797-.644-3.211v-4.137c0-1.41.21-2.476.633-3.203.425-.723 1.043-1.086 1.851-1.086ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $a632d8591d1e8129$export$2e2bcd8739ae039 = $a632d8591d1e8129$var$SvgKey0;





parcelRequire("7fPBF");
const $8df11c1882a1a51b$var$SvgKey1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.941 9.152c-.43 2.399-2.14 2.91-4.539 3v1.54h4.11v11.222h1.886V15.152ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $8df11c1882a1a51b$export$2e2bcd8739ae039 = $8df11c1882a1a51b$var$SvgKey1;





parcelRequire("7fPBF");
const $1e1ea149a9060c6a$var$SvgKey2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.793 9c-4.621 0-5.047 3.89-4.965 5.707h1.887c0-.52.167-3.977 3.078-3.977 2.738 0 3.082 2.422 3.082 2.852C28.473 24.426 20 24.254 20 31h10.266v-1.73H22.14c.425-3.547 8.214-4.239 8.214-9.688 0-.777-.343-4.582-4.964-4.582ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $1e1ea149a9060c6a$export$2e2bcd8739ae039 = $1e1ea149a9060c6a$var$SvgKey2;





parcelRequire("7fPBF");
const $f0c42c8087af715b$var$SvgKey3 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.453 8c-4.426 0-4.824 4.023-4.848 5h1.875c.027-.676.34-3.297 2.973-3.297 2.469 0 2.808 1.703 2.808 2.55 0 .43-.254 2.556-2.976 2.556h-.766v1.617c.34-.086.68-.086 1.106-.086.425 0 3.32.086 3.32 2.976 0 2.809-2.98 3.067-3.402 3.067-1.512 0-3.258-.914-3.313-3.383H19.95c.016 1.227.39 5 5.192 5 .933 0 5.359-.254 5.359-4.766 0-2.808-1.871-3.66-2.809-3.828v-.09c.598-.34 2.125-1.359 2.125-3.144 0-.684-.168-4.172-4.765-4.172ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $f0c42c8087af715b$export$2e2bcd8739ae039 = $f0c42c8087af715b$var$SvgKey3;





parcelRequire("7fPBF");
const $d4f76112c461b32f$var$SvgKey4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm12.707 8L19 24.172V26h7.047v4h1.824v-4H30v-1.652h-2.129V14Zm-.176 3v7.262H21ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $d4f76112c461b32f$export$2e2bcd8739ae039 = $d4f76112c461b32f$var$SvgKey4;





parcelRequire("7fPBF");
const $02bb6564be985baa$var$SvgKey5 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6ZM22 14.855l-1.5 8.301 1.598.098c.3-.5 1.3-1.5 2.902-1.5.8 0 3.598.402 3.598 3.605 0 .696-.2 3.797-3.399 3.797-1.5 0-3.398-.898-3.398-2.797H20c0 1.297.898 4.594 5.098 4.594 1.804 0 5.5-.898 5.5-5.2 0-.796-.399-5.398-5.196-5.398-1.804 0-2.601.7-2.902 1.098l-.098-.098.899-4.601 6.5-.195v-1.704ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $02bb6564be985baa$export$2e2bcd8739ae039 = $02bb6564be985baa$var$SvgKey5;





parcelRequire("7fPBF");
const $11ba4ce477af0c9a$var$SvgKey6 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm12.218 8.953c-5.902 0-5.816 7.363-5.816 8.473 0 6.59 3.168 7.527 5.39 7.527 4.192 0 5.305-3.25 5.305-5.3.004-.77-.258-5.137-4.789-5.137-2.484 0-3.508 1.37-3.937 2.054l-.086-.086c0-.597 0-5.988 3.851-5.988 2.121 0 2.559 1.598 2.649 2.457h1.883c-.09-1.289-.79-4-4.45-4Zm-.253 7.106c2.996 0 3.167 3.078 3.167 3.593 0 1.114-.515 3.508-3.168 3.508-1.027 0-3.25-.598-3.25-3.508 0-.43.172-3.507 3.25-3.593ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $11ba4ce477af0c9a$export$2e2bcd8739ae039 = $11ba4ce477af0c9a$var$SvgKey6;





parcelRequire("7fPBF");
const $2d8a61a07fbe0860$var$SvgKey7 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6ZM20 14v2h8c-5.922 6.277-5.91 12.586-6 14h2c.09-1.324.344-7.902 6-14v-2ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $2d8a61a07fbe0860$export$2e2bcd8739ae039 = $2d8a61a07fbe0860$var$SvgKey7;





parcelRequire("7fPBF");
const $cb6bb042edf63b5c$var$SvgKey8 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.535 8c-3.594 0-4.617 2.566-4.617 4.02 0 1.968 1.539 2.996 2.222 3.253-.855.344-2.738 1.286-2.738 3.934C20 27.434 21.371 30 25.39 30c1.54 0 5.22-.77 5.22-4.793 0-2.734-1.883-3.676-2.825-3.934.598-.257 2.137-1.285 2.137-3.253 0-.77-.254-4.02-4.79-4.02Zm.086 1.715c2.308 0 2.652 1.62 2.652 2.394 0 .856-.426 2.567-2.566 2.567-2.653 0-2.825-2.14-2.825-2.567 0-.343.172-2.394 2.739-2.394Zm.086 6.586c2.566 0 3.25 2.308 3.25 2.996 0 1.453-1.11 3.078-3.25 3.078-1.625 0-3.336-.855-3.336-3.078 0-1.285.855-2.996 3.336-2.996ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $cb6bb042edf63b5c$export$2e2bcd8739ae039 = $cb6bb042edf63b5c$var$SvgKey8;





parcelRequire("7fPBF");
const $0440a6aa4628c945$var$SvgKey9 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6Zm11.62 8C20.942 14 20 17.422 20 19.137c0 4.277 3.078 5.3 4.965 5.3 2.137 0 3.336-1.453 3.676-2.136l.09.086c-.09 2.054-.43 6.074-3.594 6.074-1.79 0-2.813-1.102-2.907-2.461h-1.886c.097 1.965 1.383 4 4.793 4 2.82 0 5.472-1.71 5.472-8.469 0-1.457.086-7.531-5.39-7.531Zm-.081 1.797c2.992 0 3.25 3.078 3.25 3.594 0 .855-.516 3.507-3.25 3.507a3.218 3.218 0 0 1-3.082-3.335c0-.516.086-3.766 3.082-3.766ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z"
        })
    }));
var $0440a6aa4628c945$export$2e2bcd8739ae039 = $0440a6aa4628c945$var$SvgKey9;





parcelRequire("7fPBF");
const $d905b0a6418e110d$var$SvgKeyA = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm10.423 8.08-5.845 15.854h2.076l1.594-4.538h6.306l1.592 4.538h2.078L25.98 14.08h-1.956zm.891 2.56h.176l2.482 7.075h-5.14l2.482-7.074zM7 36.903A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $d905b0a6418e110d$export$2e2bcd8739ae039 = $d905b0a6418e110d$var$SvgKeyA;





parcelRequire("7fPBF");
const $30670d6961572f0f$var$SvgKeyAlt = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4c-4.957 0-9 4.043-9 9v24c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V13c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v24c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V13c0-3.879 3.121-7 7-7Zm17.375 13.344v10.343h1.688V19.345Zm-7.094.5-3.5 9.843h1.813l.843-2.5h3.625l.844 2.5h1.875l-3.5-9.843Zm11.469.593v1.844h-1.219v1.344h1.219v4.094c0 1.449.691 2.031 2.406 2.031.328 0 .637-.047.875-.094v-1.343c-.199.019-.324.062-.562.062-.711 0-1.032-.355-1.032-1.094v-3.656h1.626v-1.344h-1.626v-1.843ZM20.188 21.72h.125l1.343 4.062h-2.812Z"
        })
    }));
var $30670d6961572f0f$export$2e2bcd8739ae039 = $30670d6961572f0f$var$SvgKeyAlt;





parcelRequire("7fPBF");
const $93014453a15abd8b$var$SvgKeyAltgr = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4c-4.957 0-9 4.043-9 9v24c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V13c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v24c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V13c0-3.879 3.121-7 7-7Zm9.219 13.344v10.343h1.687V19.345Zm13.718.25c-2.808 0-4.593 2.031-4.593 5.187 0 3.2 1.77 5.157 4.625 5.157 2.633 0 4.312-1.625 4.312-4.188V24.5h-4.093v1.406h2.374v.188c-.027 1.36-1.058 2.281-2.562 2.281-1.758 0-2.875-1.383-2.875-3.625 0-2.215 1.09-3.594 2.813-3.594 1.265 0 2.144.63 2.5 1.75h1.75c-.317-2.015-1.973-3.312-4.25-3.312Zm-20.812.25-3.5 9.843h1.781l.875-2.5h3.625l.813 2.5h1.906l-3.5-9.843Zm11.469.593v1.844h-1.219v1.344h1.219v4.094c0 1.449.691 2.031 2.406 2.031.328 0 .637-.047.875-.094v-1.343c-.2.019-.324.062-.562.062-.711 0-1.032-.355-1.032-1.094v-3.656h1.625v-1.344h-1.625v-1.843ZM12.03 21.72h.125L13.5 25.78h-2.812Zm29.813.375c-.957 0-1.735.543-1.938 1.281h-.125v-1.156h-1.625v7.468h1.688v-4.312c0-1.047.758-1.719 1.843-1.719.266 0 .747.047.876.094v-1.562a3.118 3.118 0 0 0-.72-.094Z"
        })
    }));
var $93014453a15abd8b$export$2e2bcd8739ae039 = $93014453a15abd8b$var$SvgKeyAltgr;





parcelRequire("7fPBF");
const $9c3c343fdfab7ac2$var$SvgKeyAsterisk = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zM24 13v7.227l-6.186-3.739-1.035 1.713L23.064 22l-6.285 3.799 1.035 1.713L24 23.773V31h2v-7.227l6.186 3.739 1.035-1.713L26.936 22l6.285-3.799-1.035-1.713L26 20.227V13h-2zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $9c3c343fdfab7ac2$export$2e2bcd8739ae039 = $9c3c343fdfab7ac2$var$SvgKeyAsterisk;





parcelRequire("7fPBF");
const $8df7a3bd0475c986$var$SvgKeyB = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.029 8.08v15.856h6.185c3.372 0 5.372-1.66 5.372-4.452 0-2.098-1.374-3.58-3.538-3.855v-.176c1.526-.275 2.737-1.77 2.737-3.418 0-2.428-1.78-3.955-4.692-3.955H19.63zm1.976 1.746h3.67c1.965 0 3.11.936 3.11 2.551 0 1.682-1.22 2.537-3.615 2.537h-3.165v-5.088zm.002 6.79h3.725c2.526 0 3.822.934 3.822 2.769s-1.252 2.802-3.636 2.802v-.001h-3.91v-5.57zM7 36.901A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $8df7a3bd0475c986$export$2e2bcd8739ae039 = $8df7a3bd0475c986$var$SvgKeyB;





parcelRequire("7fPBF");
const $027d46a574c94474$var$SvgKeyBackspace = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 7c-4.957 0-9 4.043-9 9v18c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V16c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v18c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V16c0-3.879 3.121-7 7-7Zm11.375 6.5a1.008 1.008 0 0 0-.594.281l-8.5 8.5a.999.999 0 0 0 0 1.438l8.5 8.5c.399.398 1.04.398 1.438 0a1.014 1.014 0 0 0 0-1.438L14.437 26H40c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H14.438l6.78-6.781c.325-.301.41-.778.216-1.172a.996.996 0 0 0-1.059-.547Z"
        })
    }));
var $027d46a574c94474$export$2e2bcd8739ae039 = $027d46a574c94474$var$SvgKeyBackspace;





parcelRequire("7fPBF");
const $4348b719525840f3$var$SvgKeyC = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.742 7.705c-4.306 0-6.988 3.188-6.988 8.307 0 5.109 2.693 8.296 7 8.295 3.373 0 5.877-1.88 6.404-4.791h-2.012c-.505 1.835-2.185 2.966-4.394 2.966-3.054 0-4.965-2.492-4.965-6.47 0-3.976 1.912-6.483 4.955-6.483 2.186 0 3.877 1.287 4.404 3.33h2.012c-.473-3.054-3.076-5.154-6.416-5.154zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $4348b719525840f3$export$2e2bcd8739ae039 = $4348b719525840f3$var$SvgKeyC;





parcelRequire("7fPBF");
const $6921955218308c40$var$SvgKeyCapsLock = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm7.504 8.293a1 1 0 0 0-.725.305l-5.5 5.709A1 1 0 0 0 13 25h2v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3h2a1 1 0 0 0 .72-1.693l-5.5-5.71a1 1 0 0 0-.716-.304zm-.004 2.441L21.646 23H21a1 1 0 0 0-1 1v3h-3v-3a1 1 0 0 0-1-1h-.646l3.146-3.266zM16 31a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-5zm1 2h3v2h-3v-2z"
        })
    }));
var $6921955218308c40$export$2e2bcd8739ae039 = $6921955218308c40$var$SvgKeyCapsLock;





parcelRequire("7fPBF");
const $31e3b501c850f2fe$var$SvgKeyCapslockText = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 8C5.862 8 2 11.862 2 16.6v17.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V16.6c0-4.738-3.862-8.6-8.6-8.6H10.6zm0 2h28.8c3.656 0 6.6 2.943 6.6 6.6v10.8c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 27.4V16.6c0-3.657 2.943-6.6 6.6-6.6zm6.416 3.78c-1.842 0-2.975 1.268-2.975 3.33 0 2.065 1.138 3.335 2.975 3.335 1.529 0 2.645-.943 2.755-2.314H18.48c-.127.699-.698 1.146-1.46 1.146-1.001 0-1.62-.832-1.62-2.168 0-1.336.619-2.162 1.617-2.162.756 0 1.332.48 1.459 1.21h1.293c-.097-1.38-1.25-2.378-2.752-2.378zm5.892 1.55c-1.217 0-2.04.563-2.123 1.46h1.18c.105-.29.412-.448.873-.448.527 0 .818.229.818.633v.394l-1.174.07c-1.204.07-1.877.58-1.877 1.46 0 .887.656 1.458 1.588 1.458.628 0 1.156-.263 1.407-.707h.078v.633h1.24v-3.308c0-1.038-.727-1.645-2.01-1.645zm10.99 0c-1.208 0-2.015.611-2.017 1.53 0 .746.457 1.195 1.396 1.402l.88.197c.425.093.61.238.61.475 0 .312-.342.52-.84.52-.51 0-.82-.19-.917-.52h-1.248c.088.932.861 1.455 2.14 1.455 1.27 0 2.135-.633 2.135-1.6 0-.725-.422-1.12-1.361-1.326l-.91-.2c-.448-.1-.655-.245-.655-.482 0-.307.338-.513.795-.513.475 0 .771.191.836.503h1.184c-.07-.927-.798-1.44-2.028-1.44zm-4.925.025c-.668 0-1.217.33-1.48.875h-.08v-.794h-1.24v6.363h1.28v-2.26h.078c.238.514.77.818 1.463.818 1.213 0 1.957-.936 1.957-2.5 0-1.568-.751-2.5-1.978-2.502zm-.43 1.075c.681 0 1.094.54 1.094 1.427 0 .897-.409 1.432-1.1 1.432-.677 0-1.098-.54-1.098-1.428 0-.888.422-1.431 1.104-1.431zm-4.887 1.74v.355c0 .493-.449.87-1.04.87-.445 0-.757-.22-.757-.58 0-.348.268-.545.817-.585l.98-.06zm7.32 4.416v6.697h1.28v-1.607l.351-.362 1.414 1.97h1.516l-1.973-2.768 1.846-2.08h-1.455l-1.623 1.894h-.076v-3.744h-1.28zm-15.912.355v6.342h4.149V28.13H16.39V22.94h-1.327zm7.155 1.39c-1.477 0-2.387.957-2.387 2.526 0 1.587.897 2.533 2.387 2.532 1.49 0 2.386-.946 2.386-2.532 0-1.573-.91-2.527-2.386-2.527zm5.558 0c-1.516 0-2.369.91-2.369 2.519 0 1.626.857 2.539 2.37 2.539 1.26 0 2.05-.699 2.156-1.784h-1.196c-.097.48-.439.735-.96.735-.686 0-1.079-.523-1.079-1.49 0-.954.388-1.47 1.078-1.47.545 0 .873.305.961.766h1.196c-.105-1.103-.874-1.816-2.157-1.816zm-5.558 1.046c.676 0 1.072.548 1.072 1.48 0 .941-.392 1.486-1.072 1.485-.685 0-1.073-.54-1.073-1.485 0-.932.39-1.48 1.073-1.48zM4 32.902A8.585 8.585 0 0 0 10.6 36h28.8a8.587 8.587 0 0 0 6.6-3.098V34.4c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 34.4v-1.498z"
        })
    }));
var $31e3b501c850f2fe$export$2e2bcd8739ae039 = $31e3b501c850f2fe$var$SvgKeyCapslockText;





parcelRequire("7fPBF");
const $e784f7a02803758d$var$SvgKeyCmd = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.598 4C5.863 4 2 7.863 2 12.598v25.804C2 43.137 5.863 47 10.598 47h28.804C44.137 47 48 43.137 48 38.402V12.598C48 7.863 44.137 4 39.402 4Zm0 2h28.804A6.582 6.582 0 0 1 46 12.598v18.804A6.582 6.582 0 0 1 39.402 38H10.598A6.582 6.582 0 0 1 4 31.402V12.598A6.582 6.582 0 0 1 10.598 6Zm3.812 11.285c-2.543 0-4.605 2.39-4.605 5.34 0 2.945 2.062 5.336 4.605 5.336 2.219 0 4.508-1.438 4.512-4.242h-1.64c-.352 1.62-1.169 2.808-2.766 2.804-1.59-.003-2.88-1.75-2.88-3.902s1.29-3.91 2.88-3.902c1.375.008 2.023.808 2.515 2h1.684c-.184-2.18-2.34-3.434-4.305-3.434Zm22.942.227v3.758c-.606-.77-1.461-1.254-2.414-1.254-1.829 0-3.317 1.793-3.317 3.996 0 2.199 1.488 3.988 3.317 3.988.949 0 1.808-.48 2.414-1.25v.969H39V17.512Zm-13.723 2.61c-.926.03-1.535.53-1.992 1.19v-.992H20v7.399h1.637v-4.895l.004.535c.086-1.03.437-1.84 1.652-1.949.977-.101 1.246.695 1.316 1.395v4.914h1.547v-4.383l.02.023c.086-1.027.375-1.91 1.59-1.941 1.57-.043 1.328 1.879 1.343 2.309l.024-.02v4.012h1.574v-5.387l.027-.02s.133-2.316-2.629-2.183c-.898-.067-1.664.574-2.171 1.172-.192-.43-.754-1.235-2.305-1.18Zm11.723 1.194c.984 0 1.808.918 2 2.137v1.07c-.192 1.215-1.016 2.133-2 2.133-1.125 0-2.04-1.199-2.04-2.672 0-1.468.915-2.668 2.04-2.668ZM4 36.902A8.585 8.585 0 0 0 10.598 40h28.804A8.585 8.585 0 0 0 46 36.902v1.5A6.582 6.582 0 0 1 39.402 45H10.598A6.582 6.582 0 0 1 4 38.402Z"
        })
    }));
var $e784f7a02803758d$export$2e2bcd8739ae039 = $e784f7a02803758d$var$SvgKeyCmd;





parcelRequire("7fPBF");
const $d5b77224cfca79fc$var$SvgKeyCoinsButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm7.9 5c-5.235 0-9.5 4.265-9.5 9.5s4.265 9.5 9.5 9.5a9.42 9.42 0 0 0 4.037-.914 6.515 6.515 0 0 0 2.71 3.043 1 1 0 0 0 .001 0A6.49 6.49 0 0 0 31.5 33c3.578 0 6.5-2.922 6.5-6.5S35.078 20 31.5 20c-.179 0-.349.029-.523.043C30.735 15.021 26.58 11 21.5 11zm0 2c4.154 0 7.5 3.346 7.5 7.5S25.654 28 21.5 28a7.485 7.485 0 0 1-7.5-7.5c0-4.154 3.346-7.5 7.5-7.5zm-1.805 3.412-.808 4.543h1.502c.165-.228.512-.658 1.256-.658.266 0 1.42.104 1.42 1.539 0 .509-.303 1.582-1.42 1.582-1.04 0-1.311-.857-1.35-1.232h-1.668c-.016.987.696 2.593 3.053 2.593 2.239 0 3.05-1.861 3.05-2.943 0-.568-.299-2.795-2.535-2.795-.945 0-1.381.408-1.607.635l-.026-.026.329-1.863h3.394v-1.375h-4.59zM31.5 22c2.496 0 4.5 2.004 4.5 4.5S33.996 31 31.5 31c-.824 0-1.588-.22-2.252-.604a4.521 4.521 0 0 1-1.975-2.373 9.497 9.497 0 0 0 3.588-5.97c.21-.03.423-.053.639-.053zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $d5b77224cfca79fc$export$2e2bcd8739ae039 = $d5b77224cfca79fc$var$SvgKeyCoinsButton;





parcelRequire("7fPBF");
const $0606a21a12ea54c0$var$SvgKeyCommand = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm16 4c-1.645 0-3 1.355-3 3s1.355 3 3 3h1v2h-1c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3v-1h2v1c0 1.645 1.355 3 3 3s3-1.355 3-3-1.355-3-3-3h-1v-2h1c1.645 0 3-1.355 3-3s-1.355-3-3-3-3 1.355-3 3v1h-2v-1c0-1.645-1.355-3-3-3zm0 2c.565 0 1 .435 1 1v1h-1c-.565 0-1-.435-1-1s.435-1 1-1zm8 0c.565 0 1 .435 1 1s-.435 1-1 1h-1v-1c0-.565.435-1 1-1zm-5 4h2v2h-2v-2zm-3 4h1v1c0 .565-.435 1-1 1s-1-.435-1-1 .435-1 1-1zm7 0h1c.565 0 1 .435 1 1s-.435 1-1 1-1-.435-1-1v-1z"
        })
    }));
var $0606a21a12ea54c0$export$2e2bcd8739ae039 = $0606a21a12ea54c0$var$SvgKeyCommand;





parcelRequire("7fPBF");
const $49250ec78a20638c$var$SvgKeyControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm19.984 4a1 1 0 0 0-.691.293l-6 6a1 1 0 1 0 1.414 1.414L31 15.414l5.293 5.293a1 1 0 1 0 1.414-1.414l-6-6a1 1 0 0 0-.723-.293z"
        })
    }));
var $49250ec78a20638c$export$2e2bcd8739ae039 = $49250ec78a20638c$var$SvgKeyControl;





parcelRequire("7fPBF");
const $1940e6fd7db13266$var$SvgKeyCtrl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4c-4.957 0-9 4.043-9 9v24c0 4.957 4.043 9 9 9h32c4.957 0 9-4.043 9-9V13c0-4.957-4.043-9-9-9Zm0 2h32c3.879 0 7 3.121 7 7v24c0 3.879-3.121 7-7 7H9c-3.879 0-7-3.121-7-7V13c0-3.879 3.121-7 7-7Zm25.906 13.344v10.343h1.688V19.345Zm-17.281.25c-2.797 0-4.531 1.98-4.531 5.187 0 3.192 1.734 5.157 4.531 5.157 2.277 0 3.957-1.36 4.188-3.375h-1.75c-.239 1.109-1.188 1.812-2.438 1.812-1.684 0-2.719-1.367-2.719-3.594 0-2.222 1.043-3.625 2.719-3.625 1.242 0 2.191.785 2.438 1.969h1.718c-.203-2.059-1.914-3.531-4.156-3.531Zm6.5.843v1.844h-1.219v1.344h1.219v4.094c0 1.449.691 2.031 2.406 2.031.328 0 .637-.047.875-.094v-1.343c-.199.019-.324.062-.562.062-.711 0-1.032-.355-1.032-1.094v-3.656h1.625v-1.344h-1.625v-1.843Zm8.688 1.657c-.958 0-1.766.543-1.97 1.281h-.093v-1.156h-1.656v7.468h1.718v-4.312c0-1.047.758-1.719 1.844-1.719.266 0 .715.047.844.094v-1.562a2.837 2.837 0 0 0-.687-.094Z"
        })
    }));
var $1940e6fd7db13266$export$2e2bcd8739ae039 = $1940e6fd7db13266$var$SvgKeyCtrl;





parcelRequire("7fPBF");
const $4b9831ccf8f478fd$var$SvgKeyD = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.255 8.08v15.854h5.438c4.712 0 7.48-2.933 7.48-7.932 0-4.988-2.778-7.922-7.48-7.922h-5.438zm1.977 1.78h3.328c3.516 0 5.594 2.285 5.594 6.163 0 3.867-2.057 6.131-5.594 6.131h-3.328V15.86zM7 36.901A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $4b9831ccf8f478fd$export$2e2bcd8739ae039 = $4b9831ccf8f478fd$var$SvgKeyD;





parcelRequire("7fPBF");
const $a0e0005e3eb8a47f$var$SvgKeyDelete = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm19.859 10.365v10.37h1.695v-10.37H33.46zm-18.498.506v9.865h3.697c2.954 0 4.643-1.811 4.643-4.976 0-3.097-1.71-4.889-4.643-4.889h-3.697zm1.764 1.524h1.703c1.934 0 3.076 1.237 3.076 3.39 0 2.201-1.114 3.426-3.076 3.426h-1.703v-6.816zm11.552.71c-2.167 0-3.513 1.512-3.513 3.918s1.326 3.862 3.527 3.862c1.763 0 3.001-.847 3.322-2.207h-1.605c-.246.553-.827.86-1.668.86-1.114 0-1.832-.778-1.873-2.022v-.09h5.222v-.547c0-2.358-1.279-3.774-3.412-3.774zm-.006 1.348c1.02 0 1.69.711 1.723 1.818h-3.521c.075-1.094.786-1.818 1.798-1.818zM7 36.903A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $a0e0005e3eb8a47f$export$2e2bcd8739ae039 = $a0e0005e3eb8a47f$var$SvgKeyDelete;





parcelRequire("7fPBF");
const $b6575f368334c18a$var$SvgKeyDelete2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm14.57 15a1 1 0 0 0-.767.361l-4.573 5.5a1 1 0 0 0 0 1.278l4.573 5.5a1 1 0 0 0 .767.361H37a1 1 0 0 0 1-1V25a1 1 0 0 0-1-1H25.57zm.471 2H36v9h-9.959l-3.74-4.5 3.74-4.5zm1.95.99a1 1 0 0 0-.698 1.717l1.793 1.793-1.793 1.793a1 1 0 1 0 1.414 1.414l1.793-1.793 1.793 1.793a1 1 0 1 0 1.414-1.414L31.914 30.5l1.793-1.793a1 1 0 0 0-.727-1.717 1 1 0 0 0-.687.303L30.5 29.086l-1.793-1.793a1 1 0 0 0-.717-.303z"
        })
    }));
var $b6575f368334c18a$export$2e2bcd8739ae039 = $b6575f368334c18a$var$SvgKeyDelete2;





parcelRequire("7fPBF");
const $335196af04c84a31$var$SvgKeyDot = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zM25 20.5a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $335196af04c84a31$export$2e2bcd8739ae039 = $335196af04c84a31$var$SvgKeyDot;





parcelRequire("7fPBF");
const $fbebede1d622f77a$var$SvgKeyE = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.72 8.08v15.854h9.823v-1.78h-7.846v-5.449h7.437v-1.758h-7.437V15.86h7.846V14.08H20.32zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $fbebede1d622f77a$export$2e2bcd8739ae039 = $fbebede1d622f77a$var$SvgKeyE;





parcelRequire("7fPBF");
const $22a251f88571b84a$var$SvgKeyEndButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm30.03 11A1 1 0 0 0 38 18v14a1 1 0 0 0 1 1 1 1 0 0 0 1-1V18a1 1 0 0 0-.97-1zm-10.046 2.004A1 1 0 0 0 28 20v4H11a1 1 0 0 0 0 2h17v4a1 1 0 0 0 1.555.832l6-5a1.021 1.021 0 0 0 .117-.1l.047-.04a1 1 0 0 0 .181-.274c.011-.023.019-.046.028-.07a.9.9 0 0 0 0-.696c-.01-.024-.017-.047-.028-.07a1 1 0 0 0-.185-.273c-.015-.015-.03-.025-.045-.04a1.021 1.021 0 0 0-.117-.1l-6-5a1 1 0 0 0-.569-.165z"
        })
    }));
var $22a251f88571b84a$export$2e2bcd8739ae039 = $22a251f88571b84a$var$SvgKeyEndButton;





parcelRequire("7fPBF");
const $ebbe86d494ff9bbc$var$SvgKeyEnter = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2c-2.75 0-5 2.25-5 5v13H7c-2.75 0-5 2.25-5 5v18c0 2.75 2.25 5 5 5h36c2.75 0 5-2.25 5-5V7c0-2.75-2.25-5-5-5Zm0 2h18c1.668 0 3 1.332 3 3v36c0 1.668-1.332 3-3 3H7c-1.668 0-3-1.332-3-3V25c0-1.668 1.332-3 3-3h13c1.094 0 2-.906 2-2V7c0-1.668 1.332-3 3-3Zm8.906 10.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 33 16v12c0 2.773-2.227 5-5 5H13.438l4.28-4.281c.325-.301.41-.778.216-1.172A.996.996 0 0 0 16.875 27a1.008 1.008 0 0 0-.594.281l-5.843 5.875a.954.954 0 0 0-.157.125.472.472 0 0 0-.062.063 1.204 1.204 0 0 0-.156.25v.031a.466.466 0 0 0-.032.063c-.011.039-.023.082-.031.124a1.048 1.048 0 0 0 0 .313v.093c.008.02.02.044.031.063v.032c.008.019.02.042.031.062.008.02.02.043.032.063v.03c.035.067.078.13.125.188a.472.472 0 0 0 .156.125l5.906 5.938c.399.398 1.04.398 1.438 0a1.014 1.014 0 0 0 0-1.438L13.437 35H28c3.855 0 7-3.145 7-7V16a1 1 0 0 0-1.094-1.031Z"
        })
    }));
var $ebbe86d494ff9bbc$export$2e2bcd8739ae039 = $ebbe86d494ff9bbc$var$SvgKeyEnter;





parcelRequire("7fPBF");
const $37dbda8c254edf97$var$SvgKeyEnterMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm23 16a1 1 0 1 0 0 2h2v4h-9.586l2.293-2.293a1 1 0 0 0-.727-1.717 1 1 0 0 0-.687.303l-3.912 3.912a1 1 0 0 0-.004 1.588 1 1 0 0 0 .006.004l3.91 3.91a1 1 0 1 0 1.414-1.414L26.414 33H37a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-3z"
        })
    }));
var $37dbda8c254edf97$export$2e2bcd8739ae039 = $37dbda8c254edf97$var$SvgKeyEnterMac;





parcelRequire("7fPBF");
const $487d6e36dcafcb2d$var$SvgKeyEqual = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm3.433 12v2h15.942v-2H17.033zm.057 6v2h15.943v-2H17.09zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $487d6e36dcafcb2d$export$2e2bcd8739ae039 = $487d6e36dcafcb2d$var$SvgKeyEqual;





parcelRequire("7fPBF");
const $c6d465961f631267$var$SvgKeyEsc = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM14 17v9.863h6.385V25.34h-4.621v-2.762h4.369v-1.435h-4.37v-2.62h4.622V17H14zm11.219 2.236c-1.764 0-2.995.936-2.996 2.29 0 1.127.677 1.79 2.113 2.119l1.324.306c.711.158 1.033.426 1.033.85 0 .554-.595.93-1.449.93-.848 0-1.375-.33-1.539-.883h-1.674c.13 1.36 1.305 2.168 3.172 2.168 1.867 0 3.186-.959 3.186-2.395 0-1.1-.663-1.714-2.092-2.035l-1.318-.303c-.752-.17-1.108-.43-1.108-.853 0-.54.582-.909 1.354-.909.793 0 1.293.336 1.416.862h1.591c-.123-1.36-1.236-2.147-3.013-2.147zm8.086 0c-2.25 0-3.569 1.442-3.569 3.87 0 2.46 1.326 3.91 3.575 3.91 1.894 0 3.068-1.055 3.253-2.62h-1.613c-.177.78-.764 1.198-1.646 1.198-1.156 0-1.854-.917-1.854-2.489 0-1.55.692-2.447 1.854-2.447.929 0 1.49.52 1.646 1.244h1.613c-.178-1.572-1.338-2.666-3.26-2.666zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    }));
var $c6d465961f631267$export$2e2bcd8739ae039 = $c6d465961f631267$var$SvgKeyEsc;





parcelRequire("7fPBF");
const $e0708247861041f7$var$SvgKeyEscMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm14.096 11.967c-.982 0-1.744.246-2.285.74-.541.495-.813 1.085-.813 1.773 0 .583.175 1.03.522 1.34.346.314.942.577 1.789.787 1.177.278 1.855.474 2.037.588a.552.552 0 0 1 .273.498c0 .228-.113.4-.34.514-.227.114-.532.172-.916.172-.656 0-1.104-.13-1.347-.39-.138-.146-.227-.392-.268-.739h-1.977c0 .766.28 1.396.84 1.89.56.495 1.426.743 2.6.743 1.15 0 2.002-.234 2.553-.701.55-.468.824-1.071.824-1.809 0-.56-.191-1.026-.574-1.4-.388-.37-.97-.645-1.744-.828-1.165-.255-1.845-.436-2.036-.54a.508.508 0 0 1-.287-.486c0-.178.092-.333.272-.465.18-.132.483-.197.908-.197.517 0 .88.132 1.096.397.114.146.186.342.213.593h1.949c-.087-.91-.425-1.553-1.012-1.924-.587-.372-1.345-.556-2.277-.556zm-7.545.013c-1.092 0-1.98.345-2.664 1.034-.684.689-1.026 1.677-1.026 2.968 0 1.377.379 2.372 1.137 2.983a4.064 4.064 0 0 0 2.625.918c1.201 0 2.136-.363 2.803-1.088.43-.456.67-.906.722-1.348H19.16c-.116.22-.25.39-.4.514-.277.228-.64.342-1.082.342-.42 0-.777-.093-1.074-.28-.49-.3-.75-.825-.78-1.572h5.428c.01-.644-.011-1.136-.064-1.478a3.657 3.657 0 0 0-.594-1.541 3.022 3.022 0 0 0-1.287-1.104c-.52-.233-1.105-.349-1.756-.348zm15.572.02c-1.1 0-1.962.357-2.588 1.068-.626.711-.937 1.705-.937 2.983 0 1.133.283 2.054.85 2.765.564.711 1.447 1.067 2.646 1.067 1.2 0 2.106-.425 2.717-1.278.383-.529.598-1.088.644-1.681h-1.988c-.041.392-.16.71-.352.957-.193.246-.515.367-.972.367-.643 0-1.084-.31-1.317-.93-.128-.332-.19-.768-.19-1.314 0-.572.062-1.031.19-1.377.243-.652.694-.979 1.352-.979.46 0 .801.15 1.021.452.15.224.244.474.281.752h1.997c-.11-1.062-.461-1.804-1.057-2.223-.595-.42-1.361-.629-2.297-.629zm-15.568 1.586c.46 0 .843.132 1.154.4.311.27.484.66.52 1.178h-3.356c.071-.485.245-.868.52-1.152.275-.284.663-.426 1.162-.426z"
        })
    }));
var $e0708247861041f7$export$2e2bcd8739ae039 = $e0708247861041f7$var$SvgKeyEscMac;





parcelRequire("7fPBF");
const $97c5c43afd0584a8$var$SvgKeyF = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.986 8.08v15.854h1.977v-6.868h7.021V21.31h-7.021v-5.45h7.646V14.08h-9.623zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $97c5c43afd0584a8$export$2e2bcd8739ae039 = $97c5c43afd0584a8$var$SvgKeyF;





parcelRequire("7fPBF");
const $d770639ab656fa18$var$SvgKeyF1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm5.878 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm15.7.079c-.227 1-.677 1.688-1.35 2.06-.674.374-1.584.561-2.73.561v1.28h3.56v10.26h1.86V14.958h-1.34zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $d770639ab656fa18$export$2e2bcd8739ae039 = $d770639ab656fa18$var$SvgKeyF1;





parcelRequire("7fPBF");
const $332524047e7a4ac5$var$SvgKeyF10 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm-1.243 8.74v14.24h1.881V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64H9.36zm26.541.06c-.707 0-1.329.102-1.869.302s-.975.491-1.308.878a5.75 5.75 0 0 0-.82 1.23c-.215.434-.371.96-.471 1.58-.1.62-.167 1.178-.2 1.67-.033.494-.05 1.073-.05 1.74 0 .773.026 1.457.08 2.05.053.594.176 1.22.369 1.88.193.66.458 1.205.79 1.632.335.426.803.782 1.41 1.068.605.287 1.322.432 2.15.432.785 0 1.467-.141 2.04-.42.573-.28 1.027-.637 1.36-1.07.334-.435.596-.978.789-1.631.193-.653.32-1.28.38-1.88.06-.6.09-1.274.09-2.02 0-.814-.02-1.51-.06-2.09-.04-.58-.153-1.235-.34-1.962-.187-.727-.439-1.316-.76-1.77-.32-.452-.784-.836-1.39-1.15-.607-.313-1.336-.468-2.19-.468zm-10.84.018c-.226 1-.676 1.69-1.35 2.063-.673.373-1.584.558-2.73.558v1.282h3.56v10.26h1.86V14.817h-1.34zm10.838 1.502c.413 0 .781.078 1.1.23.321.155.58.33.78.524.2.2.374.494.52.881.148.386.252.714.311.98a8.9 8.9 0 0 1 .15 1.14c.04.493.06.841.06 1.04v1c0 .427-.003.75-.01.97-.007.22-.028.56-.061 1.02-.033.46-.082.829-.148 1.102a8.384 8.384 0 0 1-.313.961c-.14.367-.309.649-.51.85a2.668 2.668 0 0 1-.77.52c-.312.147-.67.22-1.07.22-.465 0-.877-.083-1.23-.25a1.9 1.9 0 0 1-.828-.74 6.927 6.927 0 0 1-.5-.98c-.133-.327-.226-.736-.28-1.23a19.711 19.711 0 0 1-.101-1.199c-.013-.306-.02-.693-.02-1.16v-1.03c0-.206.02-.56.06-1.06.04-.5.089-.881.15-1.148.06-.266.163-.596.31-.99s.322-.693.522-.893c.2-.199.459-.374.779-.527a2.52 2.52 0 0 1 1.1-.23zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $332524047e7a4ac5$export$2e2bcd8739ae039 = $332524047e7a4ac5$var$SvgKeyF10;





parcelRequire("7fPBF");
const $ca5f38dbd83f3721$var$SvgKeyF11 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm.318 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm15.7.079c-.228 1-.677 1.688-1.35 2.06-.674.374-1.585.561-2.73.561v1.28h3.56v10.26h1.86V14.958h-1.34zm11.12 0c-.228 1-.677 1.688-1.351 2.06-.672.374-1.583.561-2.729.561v1.28h3.56v10.26h1.86V14.958h-1.34zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $ca5f38dbd83f3721$export$2e2bcd8739ae039 = $ca5f38dbd83f3721$var$SvgKeyF11;





parcelRequire("7fPBF");
const $e9a184e77d9537a4$var$SvgKeyF12 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zM9.57 14.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64H9.57zm26.44.06c-1.374 0-2.478.426-3.31 1.279-.834.854-1.25 1.98-1.25 3.38v.381h1.72c.027-1.028.25-1.876.67-2.55.42-.673 1.116-1.01 2.09-1.01.812 0 1.471.25 1.978.75.507.5.762 1.143.762 1.93 0 .892-.373 1.706-1.12 2.44-.36.36-1.115.898-2.26 1.618-.734.453-1.3.834-1.7 1.14-.4.309-.81.698-1.23 1.17a4.617 4.617 0 0 0-.93 1.593c-.2.587-.32 1.272-.36 2.058h9.24V27.58h-7.28c.145-.613.473-1.167.98-1.66.36-.36 1.085-.867 2.18-1.52a43.74 43.74 0 0 0 1.26-.79 15.52 15.52 0 0 0 1.109-.83c.446-.362.779-.7 1-1.02a5.6 5.6 0 0 0 .6-1.19c.18-.474.27-.976.27-1.51 0-1.253-.399-2.253-1.199-3-.8-.746-1.874-1.12-3.22-1.12zm-10.74.019c-.227 1-.677 1.688-1.35 2.06-.673.374-1.585.561-2.73.561v1.28h3.56v10.26h1.86V14.958h-1.34zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $e9a184e77d9537a4$export$2e2bcd8739ae039 = $e9a184e77d9537a4$var$SvgKeyF12;





parcelRequire("7fPBF");
const $377584932bdac7fe$var$SvgKeyF1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 400 400"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M77.974 32.072C50.09 34.552 26.957 53.788 18.171 81.8l-2.155 6.872v230.469l2.155 6.872c7.744 24.69 25.529 41.905 50.06 48.456l6.378 1.703h250.782l6.378-1.703c24.531-6.551 42.316-23.766 50.06-48.456l2.155-6.872V90.234l-1.767-6.64c-7.655-28.772-31.59-48.921-61.228-51.545-10.462-.926-232.582-.905-243.015.023m248.175 17.546c19.117 4.05 35.054 19.598 40.03 39.054 2.132 8.333 2.157 166.725.028 174.609-5.316 19.687-21.496 35.38-40.426 39.208-8.909 1.801-246.374 1.478-253.125-.345-19.241-5.195-33.667-19.621-38.863-38.863-2.129-7.884-2.104-166.276.028-174.609 4.95-19.352 20.782-34.925 39.673-39.021 7.735-1.678 244.745-1.708 252.655-.033M120.313 176.172v57.422h16.406v-53.125h52.344V167.188h-52.344v-34.375h59.375V118.75h-75.781v57.422m111.718-55.578c-15.064 4.101-25 17.715-25 34.258v5.304H220.904l.891-5.989c2.364-15.897 9.688-22.815 23.24-21.954 20.859 1.325 26.233 27.07 8.646 41.428-1.81 1.477-9.45 6.762-16.979 11.744-23.978 15.866-32.796 28.083-32.796 45.441v2.768h74.219V220.313h-28.906c-15.899 0-28.906-.215-28.906-.477 0-5.617 8.804-14.088 25.461-24.496 27.887-17.427 35.561-28.708 33.063-48.605-2.527-20.127-24.277-32.274-46.806-26.141M46.824 309.005c7.405 4.79 15.411 8.088 23.878 9.835 10.906 2.252 247.69 2.252 258.596 0 12.703-2.621 24.905-9.045 34.021-17.91l4.65-4.522-.006 4.726c-.035 27.405-12.435 46.778-35.513 55.483l-6.278 2.367-123.828.23c-137.644.255-128.85.568-140.235-4.983-18.689-9.111-28.553-25.164-29.8-48.495l-.511-9.555 4.767 4.635c2.621 2.55 7.238 6.235 10.259 8.189"
        })
    }));
var $377584932bdac7fe$export$2e2bcd8739ae039 = $377584932bdac7fe$var$SvgKeyF1;





parcelRequire("7fPBF");
const $fd4b812de9ff4851$var$SvgKeyF3 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.337 8.74v14.24h1.881V22.4h6.602v-1.58H16.82v-4.44h7.48v-1.64h-9.36zm15.301.06c-1.4 0-2.49.4-3.27 1.2-.78.8-1.19 1.933-1.23 3.4h1.658c.027-1 .281-1.77.76-2.31.48-.54 1.146-.81 2-.81.747 0 1.345.213 1.791.64.447.427.67.987.67 1.68 0 .72-.256 1.29-.77 1.71-.513.42-1.21.63-2.09.63-.2 0-.392-.007-.58-.02v1.44c.374-.054.68-.08.92-.08.96 0 1.723.247 2.29.74s.85 1.152.85 1.978c0 .813-.284 1.477-.85 1.99-.567.514-1.303.772-2.21.772-.947 0-1.687-.274-2.22-.82-.534-.548-.82-1.326-.86-2.34h-1.68v.261c0 1.347.43 2.418 1.29 3.211.859.794 2.01 1.19 3.45 1.19 1.452 0 2.636-.402 3.55-1.21.912-.806 1.364-1.862 1.35-3.17 0-.866-.234-1.609-.7-2.222-.466-.613-1.097-1.01-1.898-1.197a3.031 3.031 0 0 0 1.43-1.172c.34-.526.51-1.122.51-1.789 0-1.107-.38-2.002-1.14-2.682-.76-.68-1.767-1.02-3.02-1.02zM4 36.903A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $fd4b812de9ff4851$export$2e2bcd8739ae039 = $fd4b812de9ff4851$var$SvgKeyF3;





parcelRequire("7fPBF");
const $6b573a3566bd3206$var$SvgKeyF4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.308 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm16.88.06-6.44 9.16v1.6h6.22v3.42h1.6V25.7h1.92v-1.44h-1.92v-9.32h-1.38zm-.22 2.5v6.82h-4.72l4.72-6.82zM4 36.901A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $6b573a3566bd3206$export$2e2bcd8739ae039 = $6b573a3566bd3206$var$SvgKeyF4;





parcelRequire("7fPBF");
const $41d8574f644e60ac$var$SvgKeyF5 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.369 8.74v14.24h1.879V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm12.3.32-1.32 7.362 1.46.1c.64-.92 1.547-1.381 2.72-1.381.92 0 1.667.31 2.24.93.573.62.86 1.423.86 2.41 0 .946-.292 1.74-.88 2.38-.586.64-1.32.96-2.2.96-.788 0-1.446-.247-1.98-.74-.532-.494-.834-1.134-.9-1.92h-1.72c.04 1.24.477 2.233 1.31 2.98.833.747 1.923 1.12 3.27 1.12 1.453 0 2.635-.466 3.54-1.4.907-.933 1.358-2.121 1.358-3.56 0-1.373-.41-2.492-1.236-3.352-.828-.859-1.91-1.289-3.242-1.289-1.214 0-2.167.373-2.86 1.12l.84-4.22h5.739v-1.5H27.27zM4 36.903A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $41d8574f644e60ac$export$2e2bcd8739ae039 = $41d8574f644e60ac$var$SvgKeyF5;





parcelRequire("7fPBF");
const $62856496d756886b$var$SvgKeyF6 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.267 8.74v14.24h1.881V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm15.799.063c-.8 0-1.51.149-2.13.449-.62.301-1.115.69-1.49 1.17a5.967 5.967 0 0 0-.91 1.728 10.15 10.15 0 0 0-.48 1.99 15.77 15.77 0 0 0-.13 2.08c0 4.694 1.648 7.042 4.94 7.042 1.414 0 2.543-.455 3.391-1.362.846-.906 1.27-2.059 1.27-3.459 0-1.36-.404-2.457-1.211-3.29-.806-.834-1.87-1.25-3.19-1.25-1.572 0-2.746.62-3.519 1.86.026-.426.053-.79.08-1.09.026-.3.08-.691.16-1.171.08-.48.2-.887.36-1.22a6.74 6.74 0 0 1 .59-.99c.232-.327.54-.577.92-.75.38-.174.81-.26 1.29-.26.693 0 1.244.196 1.65.59.408.392.659.93.75 1.61h1.739c-.093-1.16-.499-2.064-1.219-2.709-.72-.647-1.674-.968-2.861-.968zm-.238 6.578c.893 0 1.6.288 2.12.867.52.58.78 1.366.78 2.352 0 .96-.265 1.725-.79 2.29-.528.568-1.216.85-2.07.85-.88 0-1.59-.294-2.13-.88-.54-.588-.81-1.366-.81-2.34 0-.934.266-1.692.8-2.272.533-.579 1.233-.867 2.1-.867zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $62856496d756886b$export$2e2bcd8739ae039 = $62856496d756886b$var$SvgKeyF6;





parcelRequire("7fPBF");
const $47c4a943b3e5ccd3$var$SvgKeyF7 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.418 8.88v14.24h1.88v-6.58h6.6v-1.58h-6.6v-4.439h7.48v-1.64h-9.36zm10.798.32v1.62h7.42a22.9 22.9 0 0 0-3.83 5.8c-.993 2.145-1.568 4.312-1.728 6.5h1.88c.522-4.774 2.326-8.927 5.42-12.46V15.2h-9.162zM4 36.901A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $47c4a943b3e5ccd3$export$2e2bcd8739ae039 = $47c4a943b3e5ccd3$var$SvgKeyF7;





parcelRequire("7fPBF");
const $9e8ae470d5334fbf$var$SvgKeyF8 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.308 8.74v14.24h1.88V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm15.44.06c-1.24 0-2.253.338-3.04 1.01-.786.674-1.181 1.543-1.181 2.61 0 .694.17 1.297.512 1.81.34.514.823.903 1.449 1.17-.8.294-1.417.75-1.85 1.37-.433.62-.65 1.356-.65 2.21 0 1.293.432 2.33 1.29 3.11.86.779 1.996 1.17 3.41 1.17 1.466 0 2.632-.396 3.5-1.19.866-.793 1.302-1.864 1.302-3.21 0-1.72-.835-2.873-2.502-3.46 1.294-.6 1.94-1.621 1.94-3.06 0-1.04-.392-1.89-1.17-2.55-.782-.66-1.783-.99-3.01-.99zm0 1.518c.746 0 1.34.202 1.779.602.44.4.66.94.66 1.617 0 .667-.224 1.205-.67 1.611-.447.407-1.037.61-1.77.61-.746 0-1.347-.203-1.8-.61-.453-.406-.68-.944-.68-1.61 0-.667.227-1.202.68-1.608.453-.407 1.054-.612 1.8-.612zm-.06 5.823c.892 0 1.62.259 2.18.779.56.519.839 1.2.839 2.04 0 .84-.276 1.527-.829 2.06-.553.533-1.27.8-2.15.8-.866 0-1.578-.27-2.13-.81-.555-.54-.83-1.23-.83-2.07 0-.815.272-1.484.82-2.01.546-.526 1.245-.79 2.1-.79zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $9e8ae470d5334fbf$export$2e2bcd8739ae039 = $9e8ae470d5334fbf$var$SvgKeyF8;





parcelRequire("7fPBF");
const $f638f7603c3f0297$var$SvgKeyF9 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.602 4C5.862 4 2 7.862 2 12.602v25.796C2 43.138 5.862 47 10.602 47h28.796C44.138 47 48 43.138 48 38.398V12.602C48 7.862 44.138 4 39.398 4H10.602zm0 2h28.796A6.584 6.584 0 0 1 46 12.602v18.796A6.584 6.584 0 0 1 39.398 38H10.602A6.584 6.584 0 0 1 4 31.398V12.602A6.584 6.584 0 0 1 10.602 6zm4.337 8.74v14.24h1.881V22.4h6.6v-1.58h-6.6v-4.44h7.48v-1.64h-9.36zm15.24.06c-1.386 0-2.511.44-3.378 1.32-.867.878-1.301 2.028-1.301 3.44 0 1.374.4 2.484 1.2 3.33.8.848 1.847 1.27 3.14 1.27 1.506 0 2.66-.646 3.46-1.94 0 .347-.013.661-.038.94-.254 3.08-1.308 4.62-3.162 4.62-.72 0-1.31-.197-1.77-.59-.46-.395-.737-.936-.83-1.63h-1.68c.08 1.16.503 2.065 1.27 2.72.766.652 1.75.98 2.95.98.785 0 1.484-.16 2.09-.48a4.044 4.044 0 0 0 1.448-1.24 6.638 6.638 0 0 0 .883-1.79c.227-.687.383-1.353.47-2 .087-.646.13-1.322.13-2.03 0-4.612-1.628-6.92-4.881-6.92zm-.08 1.52c.868 0 1.567.293 2.1.88.533.586.799 1.366.799 2.34 0 .933-.265 1.683-.799 2.25-.533.567-1.232.85-2.1.85-.892 0-1.583-.296-2.07-.89-.487-.593-.728-1.343-.728-2.25 0-.96.255-1.73.77-2.31.512-.58 1.189-.87 2.029-.87zM4 36.902A8.589 8.589 0 0 0 10.602 40h28.796A8.588 8.588 0 0 0 46 36.902v1.496A6.584 6.584 0 0 1 39.398 45H10.602A6.584 6.584 0 0 1 4 38.398v-1.496z"
        })
    }));
var $f638f7603c3f0297$export$2e2bcd8739ae039 = $f638f7603c3f0297$var$SvgKeyF9;





parcelRequire("7fPBF");
const $1253f9538fc416fa$var$SvgKeyFn = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zm7.14 10.871v9.863h1.764v-3.998h4.137v-1.47h-4.137v-2.871h4.525V16.87H17.74zm12.162 2.234c-1.122 0-1.996.512-2.351 1.346h-.117v-1.195H25.8v7.476h1.695V22.38c0-1.101.683-1.799 1.777-1.799 1.025 0 1.545.575 1.545 1.717v4.437h1.688v-4.84c0-1.783-.936-2.789-2.604-2.789zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    }));
var $1253f9538fc416fa$export$2e2bcd8739ae039 = $1253f9538fc416fa$var$SvgKeyFn;





parcelRequire("7fPBF");
const $e7c04b832cc34ee7$var$SvgKeyFunctionMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm4.469 17.783c-1.08 0-1.76.224-2.043.67-.27.3-.405.849-.405 1.647v.478h-1.066v1.375h1.096v6.01h1.933v-6.01h1.28v-1.375h-1.28v-.629a.62.62 0 0 1 .149-.398c.098-.12.274-.178.531-.17.257.006.442.015.55.03v-1.587a31.08 31.08 0 0 0-.41-.03 4.254 4.254 0 0 0-.335-.01zm6.043 2.551c-.613 0-1.12.15-1.52.451-.223.17-.457.443-.707.826v-1.086h-1.887v7.438h1.948V32.93c0-.46.063-.84.19-1.135.244-.561.695-.842 1.35-.842.534 0 .897.191 1.087.574.104.21.156.51.156.903v4.533h1.994v-5.02c0-.935-.242-1.604-.73-2.006-.488-.404-1.115-.604-1.881-.603z"
        })
    }));
var $e7c04b832cc34ee7$export$2e2bcd8739ae039 = $e7c04b832cc34ee7$var$SvgKeyFunctionMac;





parcelRequire("7fPBF");
const $721bb2247b62229e$var$SvgKeyG = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.591 7.705c-4.339 0-7.183 3.287-7.183 8.297 0 5.076 2.8 8.305 7.183 8.305 4.055 0 6.737-2.592 6.737-6.502v-1.936h-6.426v1.736h4.459v.385c0 2.681-1.924 4.494-4.758 4.494-3.186 0-5.164-2.483-5.164-6.482 0-3.945 2.01-6.47 5.152-6.47 2.352 0 3.945 1.13 4.627 3.273h2.01c-.573-3.142-3.12-5.1-6.637-5.1zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $721bb2247b62229e$export$2e2bcd8739ae039 = $721bb2247b62229e$var$SvgKeyG;





parcelRequire("7fPBF");
const $40c08a9bfd143af3$var$SvgKeyH = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.072 8.08v15.854h1.978v-7.217h8.702v7.217h1.976V14.08h-1.976v6.856H20.65V14.08h-1.978zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $40c08a9bfd143af3$export$2e2bcd8739ae039 = $40c08a9bfd143af3$var$SvgKeyH;





parcelRequire("7fPBF");
const $9df36942c9a98cf6$var$SvgKeyHashtag = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm7.357 7-.338 4h-3.762l-.107 2h3.7l-.507 6h-3.836L16 27h3.773l-.337 4h2.005l.338-4h6.03l-.338 4h2.008l.337-4h3.327l.107-2h-3.264l.506-6h3.4L34 17h-3.338L31 13h-2.008l-.338 4h-6.027l.338-4h-2.008zm1.5 6h6.027l-.505 6h-6.03l.508-6zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $9df36942c9a98cf6$export$2e2bcd8739ae039 = $9df36942c9a98cf6$var$SvgKeyHashtag;





parcelRequire("7fPBF");
const $e90a70d42b6dc2e5$var$SvgKeyHomeButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm2 11a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V18a1 1 0 0 0-1-1zm9.97 2a1 1 0 0 0-.525.168l-6 5a1.021 1.021 0 0 0-.117.1l-.047.04a1 1 0 0 0-.181.274c-.011.023-.019.046-.028.07a.9.9 0 0 0 0 .696c.01.024.017.047.028.07a1 1 0 0 0 .185.273c.015.015.03.025.045.04a1.021 1.021 0 0 0 .117.1l6 5A1 1 0 0 0 22 30v-4h17a1 1 0 0 0 0-2H22v-4a1 1 0 0 0-1.03-1z"
        })
    }));
var $e90a70d42b6dc2e5$export$2e2bcd8739ae039 = $e90a70d42b6dc2e5$var$SvgKeyHomeButton;





parcelRequire("7fPBF");
const $31af271f439f7f10$var$SvgKeyI = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm10.414 8.08v15.854h1.976V14.08h-1.976zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $31af271f439f7f10$export$2e2bcd8739ae039 = $31af271f439f7f10$var$SvgKeyI;





parcelRequire("7fPBF");
const $c2e5ff91a41ba25e$var$SvgKeyJ = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm13.455 8.08v11.426c0 1.944-.957 2.976-2.649 2.976-1.493 0-2.504-.92-2.549-2.25h-1.964c0 2.428 1.868 4.077 4.527 4.077 2.867 0 4.611-1.77 4.611-4.791V14.08h-1.976zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $c2e5ff91a41ba25e$export$2e2bcd8739ae039 = $c2e5ff91a41ba25e$var$SvgKeyJ;





parcelRequire("7fPBF");
const $eed7a945fc76c2bd$var$SvgKeyK = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.011 8.08v15.854h1.979v-5.538l1.898-2.097 5.725 7.635h2.56l-6.921-9.008 6.34-6.846h-2.483l-6.943 7.701h-.176v-7.7H19.61zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $eed7a945fc76c2bd$export$2e2bcd8739ae039 = $eed7a945fc76c2bd$var$SvgKeyK;





parcelRequire("7fPBF");
const $babff20b0d4654ba$var$SvgKeyL = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm7.033 8.08v15.854h9.625v-1.78H22.61V14.08h-1.978zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $babff20b0d4654ba$export$2e2bcd8739ae039 = $babff20b0d4654ba$var$SvgKeyL;





parcelRequire("7fPBF");
const $28380b67fbfe727d$var$SvgKeyLeftAngleParentheses = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm16.416 8.498-12.032 6.959v1.941l12.032 6.96v-2.544l-9.68-5.277v-.219l9.68-5.277v-2.543zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $28380b67fbfe727d$export$2e2bcd8739ae039 = $28380b67fbfe727d$var$SvgKeyLeftAngleParentheses;





parcelRequire("7fPBF");
const $eeaf776f967e20c6$var$SvgKeyM = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm3.588 8.08v15.854h1.845V17.826h.133l4.998 11.998h1.672l4.998-11.998h.13v12.108h1.847V14.08h-2.295l-5.428 13.117h-.176L19.484 14.08h-2.297zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $eeaf776f967e20c6$export$2e2bcd8739ae039 = $eeaf776f967e20c6$var$SvgKeyM;





parcelRequire("7fPBF");
const $dcb0c3efc1457ecf$var$SvgKeyMinus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.643 4c-4.738 0-8.6 3.862-8.6 8.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6c0-4.738-3.862-8.6-8.6-8.6h-22.8zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6V12.6c0-3.657 2.943-6.6 6.6-6.6zm3.4 15v2h16v-2h-16zm-10 15.902a8.588 8.588 0 0 0 6.6 3.098h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6v-1.498z"
        })
    }));
var $dcb0c3efc1457ecf$export$2e2bcd8739ae039 = $dcb0c3efc1457ecf$var$SvgKeyMinus;





parcelRequire("7fPBF");
const $e13a1775e3b494bc$var$SvgKeyN = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.072 8.08v15.854h1.955V17.64h.176l8.603 12.293h1.922V14.08h-1.955v12.338h-.176L20.596 14.08h-1.924zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $e13a1775e3b494bc$export$2e2bcd8739ae039 = $e13a1775e3b494bc$var$SvgKeyN;





parcelRequire("7fPBF");
const $4c0f13b7e9c863f6$var$SvgKeyO = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.418 7.705c-4.482 0-7.286 3.199-7.286 8.297 0 5.076 2.737 8.305 7.286 8.305 4.526 0 7.25-3.241 7.25-8.305 0-5.086-2.746-8.296-7.25-8.297zm0 1.824c3.24 0 5.216 2.507 5.216 6.473 0 3.933-1.964 6.48-5.216 6.48-3.296 0-5.252-2.547-5.252-6.48 0-3.965 2.02-6.472 5.252-6.473zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $4c0f13b7e9c863f6$export$2e2bcd8739ae039 = $4c0f13b7e9c863f6$var$SvgKeyO;





parcelRequire("7fPBF");
const $f785a1fe04b59464$var$SvgKeyOption = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm11 4a1 1 0 1 0 0 2h2.213l3.75 7H37a1 1 0 1 0 0-2h-7.84l-3.75-7H22zm6.563 0a1 1 0 1 0 0 2H37a1 1 0 1 0 0-2h-8.437z"
        })
    }));
var $f785a1fe04b59464$export$2e2bcd8739ae039 = $f785a1fe04b59464$var$SvgKeyOption;





parcelRequire("7fPBF");
const $f857acdec584cd37$var$SvgKeyP = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.273 8.08v15.854h1.979v-5.659h3.988c2.978 0 5.098-2.098 5.098-5.064 0-3.021-2.078-5.13-5.077-5.13h-5.988zm1.98 1.758h3.493c2.297 0 3.56 1.198 3.56 3.373 0 2.098-1.307 3.307-3.56 3.307h-3.492v-6.68zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $f857acdec584cd37$export$2e2bcd8739ae039 = $f857acdec584cd37$var$SvgKeyP;





parcelRequire("7fPBF");
const $e99cc5022343e76f$var$SvgKeyPageDownButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm15.97 4a1 1 0 0 0-.97 1v17h-4a1 1 0 0 0-.832 1.555l5 6a1.021 1.021 0 0 0 .1.117c.014.015.026.033.04.047a.978.978 0 0 0 .274.183.707.707 0 0 0 .07.028.9.9 0 0 0 .694 0 .707.707 0 0 0 .068-.028.978.978 0 0 0 .275-.183c.015-.014.027-.032.041-.047a1.021 1.021 0 0 0 .1-.117l5-6a1 1 0 0 0 .053-1.028A1 1 0 0 0 30 28h-4V11a1 1 0 0 0-1.03-1zM17.96 38A1 1 0 0 0 18 40h14a1 1 0 0 0 0-2H18a1 1 0 0 0-.041 0z"
        })
    }));
var $e99cc5022343e76f$export$2e2bcd8739ae039 = $e99cc5022343e76f$var$SvgKeyPageDownButton;





parcelRequire("7fPBF");
const $2a844d4ba0847ea6$var$SvgKeyPageUpButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a9.017 9.017 0 0 0-9 9v24a9.017 9.017 0 0 0 9 9h32a9.017 9.017 0 0 0 9-9V13a9.017 9.017 0 0 0-9-9H9zm0 2h32a6.983 6.983 0 0 1 7 7v24a6.983 6.983 0 0 1-7 7H9a6.983 6.983 0 0 1-7-7V13a6.983 6.983 0 0 1 7-7zm8.959 4A1 1 0 0 0 18 12h14a1 1 0 0 0 0-2H18a1 1 0 0 0-.041 0zm6.99 4.002a.961.961 0 0 0-.728.398c-.014.02-.04.025-.053.045l-5 6A1 1 0 0 0 20 22h4v17a1 1 0 0 0 2 0V22h4a1 1 0 0 0 .832-1.555l-5-6c-.013-.02-.039-.026-.053-.045a.961.961 0 0 0-.83-.398z"
        })
    }));
var $2a844d4ba0847ea6$export$2e2bcd8739ae039 = $2a844d4ba0847ea6$var$SvgKeyPageUpButton;





parcelRequire("7fPBF");
const $5047847f9449d0d7$var$SvgKeyPlus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.664 4c-4.737 0-8.6 3.862-8.6 8.6v25.8c0 4.738 3.863 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6c0-4.738-3.862-8.6-8.6-8.6h-22.8zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6V12.6c0-3.657 2.944-6.6 6.6-6.6zm10.4 8v7h-7v2h7v7h2v-7h7v-2h-7v-7h-2zm-17 22.902a8.588 8.588 0 0 0 6.6 3.098h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6v-1.498z"
        })
    }));
var $5047847f9449d0d7$export$2e2bcd8739ae039 = $5047847f9449d0d7$var$SvgKeyPlus;





parcelRequire("7fPBF");
const $6604f2ab651791da$var$SvgKeyQ = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.416 7.705c-4.482 0-7.284 3.188-7.284 8.307 0 5.142 2.768 8.295 7.284 8.295 1.022 0 1.988-.165 2.834-.483l1.396 1.9h2.219l-2.01-2.79c1.801-1.297 2.813-3.77 2.813-6.922 0-5.11-2.792-8.307-7.252-8.307zm0 1.826c3.208 0 5.218 2.504 5.218 6.48 0 2.418-.691 4.309-1.933 5.298l-1.44-1.913h-2.24l2.098 2.846c-.55.165-1.11.24-1.692.24-3.252 0-5.263-2.471-5.263-6.47 0-3.987 2.022-6.48 5.252-6.48zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $6604f2ab651791da$export$2e2bcd8739ae039 = $6604f2ab651791da$var$SvgKeyQ;





parcelRequire("7fPBF");
const $756d3ddc5105ca4d$var$SvgKeyR = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.072 8.08v15.854h1.976v-6.272h3.9l3.395 6.274h2.319l-3.67-6.582c1.99-.627 3.187-2.341 3.187-4.55 0-2.856-2-4.724-5.054-4.724h-6.053zm1.978 1.76h3.813c2.043 0 3.271 1.13 3.271 3.031 0 1.944-1.153 3.031-3.185 3.031H21.65V15.84zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $756d3ddc5105ca4d$export$2e2bcd8739ae039 = $756d3ddc5105ca4d$var$SvgKeyR;





parcelRequire("7fPBF");
const $cdc0aa5cadea8c33$var$SvgKeyRightAngleParentheses = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm6.384 8.498v2.543l9.68 5.277v.22l-9.68 5.276v2.543l12.032-6.959v-1.941l-12.032-6.959zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $cdc0aa5cadea8c33$export$2e2bcd8739ae039 = $cdc0aa5cadea8c33$var$SvgKeyRightAngleParentheses;





parcelRequire("7fPBF");
const $39f8b5dc7ed29ffc$var$SvgKeyS = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm11.56 7.707c-3.35 0-5.603 1.825-5.603 4.516 0 2.252 1.241 3.548 4.109 4.273l2.031.527c2.187.55 3.176 1.406 3.176 2.758 0 1.572-1.57 2.725-3.701 2.725-2.252 0-3.834-1.054-4.076-2.713v-.002h-1.998c.208 2.736 2.526 4.516 5.888 4.516 3.625 0 5.92-1.856 5.92-4.768 0-2.329-1.317-3.604-4.601-4.428l-1.66-.437c-2.187-.56-3.055-1.276-3.055-2.518 0-1.604 1.397-2.658 3.506-2.658 1.978 0 3.317.968 3.592 2.594h1.988c-.164-2.56-2.45-4.385-5.516-4.385zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $39f8b5dc7ed29ffc$export$2e2bcd8739ae039 = $39f8b5dc7ed29ffc$var$SvgKeyS;





parcelRequire("7fPBF");
const $8378efa8f631e6e6$var$SvgKeySolidus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm12.347 7.512-4.13 17.04h2.197l4.17-17.04h-2.237zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $8378efa8f631e6e6$export$2e2bcd8739ae039 = $8378efa8f631e6e6$var$SvgKeySolidus;





parcelRequire("7fPBF");
const $20566c6a075b51f1$var$SvgKeySpace = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 12c-3.302 0-6 2.698-6 6v15c0 3.302 2.698 6 6 6h38c3.302 0 6-2.698 6-6V18c0-3.302-2.698-6-6-6H6zm0 2h38c2.22 0 4 1.78 4 4v10c0 2.22-1.78 4-4 4H6c-2.22 0-4-1.78-4-4V18c0-2.22 1.78-4 4-4zM2 32.455A5.967 5.967 0 0 0 6 34h38a5.967 5.967 0 0 0 4-1.545V33c0 2.22-1.78 4-4 4H6c-2.22 0-4-1.78-4-4v-.545z"
        })
    }));
var $20566c6a075b51f1$export$2e2bcd8739ae039 = $20566c6a075b51f1$var$SvgKeySpace;





parcelRequire("7fPBF");
const $441acdbafb1bd1ee$var$SvgKeyT = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.304 8.08v1.78h5.11v14.074h1.976V15.859h5.11V14.08H18.904zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $441acdbafb1bd1ee$export$2e2bcd8739ae039 = $441acdbafb1bd1ee$var$SvgKeyT;





parcelRequire("7fPBF");
const $eb7fda30618d887d$var$SvgKeyTab = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM32 12v8h2v-8h-2zm0 4a.57.57 0 0 0-.043-.217c-.006-.015-.01-.028-.018-.043a.624.624 0 0 0-.115-.172c-.009-.009-.02-.014-.03-.023a.628.628 0 0 0-.071-.065l-3.752-3.125a.626.626 0 0 0-.971.518V15H16v2h11v2.127a.625.625 0 0 0 .973.52l3.752-3.126a.628.628 0 0 0 .072-.064c.009-.009.02-.014.03-.023a.633.633 0 0 0 .112-.172c.007-.014.012-.03.018-.045A.57.57 0 0 0 32 16zm-16 7v8h2v-8h-2zm2 4a.57.57 0 0 0 .043.217c.006.015.01.028.018.043a.624.624 0 0 0 .115.172c.009.009.02.014.03.023a.628.628 0 0 0 .071.065l3.752 3.125a.626.626 0 0 0 .971-.518V28h11v-2H23v-2.127a.625.625 0 0 0-.973-.52l-3.752 3.126a.628.628 0 0 0-.072.064c-.009.009-.02.014-.03.023a.633.633 0 0 0-.112.172c-.007.014-.012.03-.018.045A.57.57 0 0 0 18 27zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    }));
var $eb7fda30618d887d$export$2e2bcd8739ae039 = $eb7fda30618d887d$var$SvgKeyTab;





parcelRequire("7fPBF");
const $0674e1fc2efa4c50$var$SvgKeyU = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.105 8.08v10.404c0 3.384 2.364 5.825 6.297 5.825 3.934 0 6.295-2.44 6.295-5.825V14.08h-1.979v10.274c0 2.395-1.569 4.13-4.316 4.13-2.746 0-4.318-1.735-4.318-4.13V14.08h-1.979zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $0674e1fc2efa4c50$export$2e2bcd8739ae039 = $0674e1fc2efa4c50$var$SvgKeyU;





parcelRequire("7fPBF");
const $300d4a3a425ff969$var$SvgKeyV = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm4.578 8.08 5.845 15.854h1.956l5.843-15.854h-2.076l-4.658 13.293h-.176L20.254 14.08h-2.076zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $300d4a3a425ff969$export$2e2bcd8739ae039 = $300d4a3a425ff969$var$SvgKeyV;





parcelRequire("7fPBF");
const $673e0b4aaae7ef63$var$SvgKeyW = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm1.502 8.08 4.318 15.854h1.865l3.649-12.514h.13l3.649 12.514h1.867l4.318-15.854h-2.066L29.68 26.97h-.131L26 14.08h-2L20.451 26.97h-.133L17.166 14.08h-2.064zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $673e0b4aaae7ef63$export$2e2bcd8739ae039 = $673e0b4aaae7ef63$var$SvgKeyW;





parcelRequire("7fPBF");
const $cfc8508a0d8a5a06$var$SvgKeyWindows = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zm16.998 10.166c-.615 0-1.045.398-1.045.938 0 .54.429.935 1.045.935.622 0 1.047-.394 1.047-.935s-.425-.938-1.047-.938zm-15.217.705 2.646 9.863h1.66l1.995-6.986h.103l2.01 6.986h1.654l2.647-9.863H23.27l-1.688 7.342h-.096l-1.968-7.342H17.95l-1.94 7.342h-.103l-1.687-7.342h-1.84zm22.265 2.234c-1.122 0-1.996.512-2.351 1.346h-.117v-1.195h-1.633v7.476h1.695V22.38c0-1.101.684-1.799 1.778-1.799 1.025 0 1.544.575 1.544 1.717v4.437h1.688v-4.84c0-1.783-.936-2.789-2.604-2.789zm-7.888.15v7.48h1.687v-7.48h-1.687zM4 36.903A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    }));
var $cfc8508a0d8a5a06$export$2e2bcd8739ae039 = $cfc8508a0d8a5a06$var$SvgKeyWindows;





parcelRequire("7fPBF");
const $bded3da25f49952b$var$SvgKeyX = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm4.82 8.08 5.361 7.877-5.426 7.977h2.24l4.231-6.25h.176l4.152 6.25h2.373l-5.373-7.887 5.494-7.967h-2.252l-4.242 6.307h-.175l-4.174-6.307H18.42zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $bded3da25f49952b$export$2e2bcd8739ae039 = $bded3da25f49952b$var$SvgKeyX;





parcelRequire("7fPBF");
const $d240e40e324119ef$var$SvgKeyY = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm4.789 8.08 5.625 9.031v6.823h1.974V23.11l5.625-9.03h-2.252l-4.271 7.042h-.178l-4.271-7.043h-2.252zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $d240e40e324119ef$export$2e2bcd8739ae039 = $d240e40e324119ef$var$SvgKeyY;





parcelRequire("7fPBF");
const $1401a11666a30a5e$var$SvgKeyZ = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.847 8.08v1.78h8.668v.175l-8.974 12.492v1.407h11.722v-1.78h-9.119v-.175l8.932-12.493V14.08H19.447zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z"
        })
    }));
var $1401a11666a30a5e$export$2e2bcd8739ae039 = $1401a11666a30a5e$var$SvgKeyZ;





parcelRequire("7fPBF");
const $46e8d4dadea67077$var$SvgLeanFrontToBack = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#fff",
                d: "m65.164 45.724-1.322 1.01a11.015 11.015 0 0 1-6.342 2.26 11.015 11.015 0 0 1-6.342-2.26l-1.322-1.01a15.93 15.93 0 0 1-6.05-10.117l-1.276-7.921c-.339-2.098-.504-4.275.284-6.248C44.488 17.194 48.915 12 57.15 12c8.824 0 13.347 5.195 15.055 9.438.793 1.972.624 4.15.285 6.248l-1.277 7.92a15.93 15.93 0 0 1-6.05 10.118Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 2.16,
                d: "M57.15 49v0c2.42 0 4.77-.796 6.692-2.266l1.322-1.01a15.93 15.93 0 0 0 6.05-10.117l1.276-7.921c.339-2.098.508-4.276-.285-6.248C70.497 17.195 65.975 12 57.15 12c-8.235 0-12.662 5.194-14.356 9.438-.788 1.973-.623 4.15-.284 6.248l1.277 7.92a15.93 15.93 0 0 0 6.05 10.118l1.321 1.01A11.015 11.015 0 0 0 57.85 49v0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#fff",
                d: "m56.177 63.81-1.712 1.322a13.752 13.752 0 0 1-7.965 2.861 13.752 13.752 0 0 1-7.965-2.86l-1.712-1.322a20.09 20.09 0 0 1-7.56-12.734L27.5 40.042c-.332-2.079-.484-4.22.19-6.214C29.558 28.31 35.156 21 46.06 21c11.685 0 17.374 7.31 19.25 12.828.677 1.993.522 4.135.19 6.214l-1.763 11.035a20.09 20.09 0 0 1-7.56 12.734Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 2.16,
                d: "M46.06 68v0c3.042 0 5.998-1.008 8.405-2.868l1.712-1.321a20.09 20.09 0 0 0 7.56-12.734L65.5 40.042c.332-2.079.487-4.221-.19-6.214C63.433 28.31 57.744 21 46.06 21c-10.905 0-16.503 7.31-18.37 12.828-.674 1.994-.522 4.135-.19 6.214l1.763 11.035a20.09 20.09 0 0 0 7.56 12.734l1.712 1.321A13.752 13.752 0 0 0 46.94 68v0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m45.936 82.556-1.95 1.48a16.73 16.73 0 0 1-9.586 3.396 16.73 16.73 0 0 1-9.587-3.396l-1.95-1.48a24.002 24.002 0 0 1-9.179-15.269l-2.167-13.335c-.343-2.114-.493-4.288.15-6.33C13.732 41.066 20.454 32 33.872 32c14.377 0 21.19 9.066 23.262 15.622.645 2.042.492 4.216.149 6.33l-2.167 13.335a24.002 24.002 0 0 1-9.18 15.27Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 2.7,
                d: "M33.872 87.44v0a16.73 16.73 0 0 0 10.115-3.404l1.95-1.48a24.002 24.002 0 0 0 9.179-15.269l2.167-13.335c.343-2.114.495-4.288-.15-6.33C55.064 41.066 48.25 32 33.874 32c-13.42 0-20.141 9.066-22.206 15.622-.643 2.042-.493 4.216-.15 6.33l2.167 13.335a24.002 24.002 0 0 0 9.18 15.27l1.95 1.479a16.73 16.73 0 0 0 10.114 3.404v0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M67.072 82.874a1 1 0 0 0 1.302.554l8.348-3.363a1 1 0 0 0-.747-1.855l-7.421 2.989-2.989-7.42a1 1 0 0 0-1.855.746l3.362 8.349Zm23.356-51.248a1 1 0 0 0-1.302-.554l-8.348 3.363a1 1 0 0 0 .747 1.855l7.421-2.989 2.989 7.42a1 1 0 0 0 1.855-.746l-3.362-8.349ZM68.92 82.892l21.5-50.5-1.84-.784-21.5 50.5 1.84.784Z"
            })
        ]
    }));
var $46e8d4dadea67077$export$2e2bcd8739ae039 = $46e8d4dadea67077$var$SvgLeanFrontToBack;





parcelRequire("7fPBF");
const $788da9ed54ecd493$var$SvgLinkedin = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm5 5.012c-1.095 0-2.08.327-2.81.941a3.297 3.297 0 0 0-1.178 2.514c0 1.867 1.62 3.323 3.68 3.467a.988.988 0 0 0 .003.002.988.988 0 0 0 .305.052c2.273 0 3.988-1.592 3.988-3.521a.988.988 0 0 0-.002-.053c-.101-1.9-1.796-3.402-3.986-3.402zm0 1.976c1.392 0 1.942.622 2.002 1.504-.012.856-.542 1.52-2.002 1.52-1.385 0-2.012-.71-2.012-1.545 0-.418.153-.733.473-1.002.32-.27.834-.477 1.539-.477zM11 19a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1h-6zm9 0a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V29c0-.83.226-1.655.625-2.195.399-.54.901-.865 1.857-.848.986.017 1.508.355 1.903.885S32 28.167 32 29v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V28.262c0-2.962-.877-5.308-2.38-6.895C36.114 19.78 34.023 19 31.812 19A8.729 8.729 0 0 0 27 20.424V20a1 1 0 0 0-1-1h-6zm-8 2h4v17h-4V21zm9 0h4v1.56a1 1 0 0 0 1.799.602S28.369 21 31.813 21c1.753 0 3.256.583 4.355 1.742 1.099 1.16 1.832 2.946 1.832 5.52V38h-4v-9c0-1.167-.28-2.373-1.01-3.354-.73-.98-1.958-1.663-3.472-1.689-1.522-.027-2.77.67-3.502 1.662C25.284 26.611 25 27.83 25 29v9h-4V21z"
        })
    }));
var $788da9ed54ecd493$export$2e2bcd8739ae039 = $788da9ed54ecd493$var$SvgLinkedin;





const $0e324a98afaf32e9$var$SvgComponent = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 1",
        viewBox: "0 0 500 500"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M382.92 279.27c12.57-6.76 27.45-5.52 31.84 2.65.58 1.07.96 2.23 1.16 3.47 1.12 7.19-4.19 17.93-16.5 24.55-12.57 6.76-27.45 5.51-31.85-2.65-.57-1.06-.96-2.23-1.15-3.46-1.12-7.19 4.19-17.94 16.5-24.56Zm-97.19 76.18c1.47 2.87 5 3.91 6.98 4.27 4.66.85 10.21-.14 15.25-2.72 8.71-4.46 13.12-12.18 12.36-17.08-.1-.67-.3-1.28-.61-1.87-1.47-2.87-5-3.91-6.98-4.27-4.66-.85-10.22.14-15.26 2.72-8.71 4.46-13.11 12.19-12.35 17.09.1.67.29 1.28.6 1.86Zm173.51-75.68a50.45 50.45 0 0 0-4.83-.16H454.26c-1.12.02-2.19.07-3.19.15h-.12c-.97.08-1.88.18-2.71.29h-.05c-.04 0-.08.01-.12.02-3.4.46-5.51 1.09-5.51 1.09-3.45-11.48-9.94-18.47-17.1-22.33-.04-.02-.07-.05-.11-.07-3.6-1.92-7.37-3.06-11-3.57-1.82-.26-3.6-.36-5.31-.33-1.71.03-3.35.2-4.88.47-.04 0-.07.02-.11.03-4.1.76-7.76 2.42-10.56 4.02-1.31.75-.6 2.75.89 2.55 1-.14 2.09-.25 3.23-.33.09 0 .18-.02.28-.02.06 0 .12 0 .19-.01h.03c.67-.04 1.39-.03 2.09-.04h.1c.63 0 1.24-.04 1.89-.02s.02 0 .03 0c.06 0 .11.01.17.01 1.12.04 2.28.14 3.44.29.59.08 1.17.2 1.76.3.71.13 1.42.28 2.14.46.82.2 1.62.44 2.43.72.59.2 1.17.46 1.75.7.58.23 1.15.45 1.72.74.69.35 1.38.73 2.05 1.14 3.4 2.15 6.48 5.25 8.82 9.69.03.06.07.14.11.21.01.03.03.06.04.09.57 1.1 1.39 2.84 2.12 5.07.12.36.23.7.34 1.08.22.77.42 1.59.58 2.46.01.06.03.12.04.18.01.06.02.13.04.19.15.84.27 1.71.35 2.62v.03c.05.57.04 1.17.05 1.77v.05c.03 1.86-.16 3.85-.6 5.91-.06.27-.1.53-.17.8-.11.45-.23.91-.38 1.37-.46 1.51-1.12 3.05-1.92 4.61-.01.02-.02.05-.03.07-.54 1.04-1.17 2.09-1.89 3.15-.19.28-.38.56-.58.84-.71.99-1.52 1.98-2.4 2.98-.07.07-.13.15-.19.22a46.354 46.354 0 0 1-4.74 4.59c-.05.05-.1.1-.16.15-1.83 1.52-3.9 3.04-6.23 4.54h-.01c-1.26.81-2.61 1.62-4.03 2.42-.02 0-.03.02-.04.03-.37.21-.67.42-1.06.63-.09.05-.18.09-.28.13-.79.43-1.59.71-2.39 1.08-1.16.55-2.32 1.14-3.5 1.59-1.34.51-2.67.88-4.01 1.26h-.03c-.72.21-1.45.44-2.17.61h-.02c-1.02.24-2.03.45-3.05.62-.94.15-1.87.25-2.81.35-1.2.12-2.38.25-3.56.28h-.01c-.11 0-.22-.01-.33-.01h-.01c-2.55.03-5.01-.21-7.4-.65-.1-.02-.19-.04-.28-.06-2.01-.38-3.92-.92-5.76-1.62h-.02c-1.83-.7-3.55-1.55-5.16-2.56-.15-.09-.29-.2-.43-.29-1.24-.81-2.44-1.66-3.51-2.65-.27-.24-.5-.54-.74-.81-.63-.63-1.25-1.27-1.81-1.97-.27-.27-.55-.53-.78-.84-2.39 1.44-4.79 2.9-7.22 4.37-2.96 1.79-5.95 3.59-9.01 5.42 0 0 0-.01-.01-.02-14.34-20.24-34.02-12.63-43.31-6.21-.01 0-.03.02-.04.02-.02.01-.03.03-.04.04-1.19.89-.27 2.81 1.2 2.42a49.71 49.71 0 0 1 7.44-1.4c.22-.02.44-.05.66-.07h.01c.17-.02.35 0 .53-.02 1.42-.11 2.87-.14 4.34-.08h.05c1.46.06 2.92.23 4.38.52.32.06.63.16.94.25 1.13.27 2.25.57 3.35 1.01.34.14.65.34.98.49 0 0 .01 0 .02.01 1.02.47 2.04.96 3 1.62.46.32.88.74 1.32 1.12.82.67 1.64 1.32 2.39 2.16.73.82 1.42 1.74 2.08 2.72.31.47.62.91.91 1.42.1.17.16.35.25.53.53 1.08.93 2.19 1.25 3.32.2.68.33 1.37.45 2.07.18 1.06.32 2.12.32 3.2 0 .66-.08 1.32-.16 1.99-.06.55-.17 1.45-.27 1.99-.18.95-.38 1.9-.67 2.85-.29.94-.63 1.86-1.03 2.78-.42.97-.91 1.91-1.44 2.85-.18.31-.37.62-.56.93-1.8 2.98-4.13 5.78-6.97 8.31-.7.61-1.38 1.23-2.13 1.81-2.03 1.58-4.19 3.05-6.6 4.28l-.06.03c-1.4.71-2.82 1.35-4.26 1.95-.07.03-.13.06-.2.08-2.99 1.23-6.02 2.18-9.01 2.79-.11.02-.23.04-.34.07-2.16.42-4.28.66-6.34.7h-.11c-.65 0-1.29 0-1.93-.04-.11 0-.21-.02-.31-.02-1.86-.12-3.64-.43-5.34-.94-.18-.05-.36-.11-.54-.17-.52-.17-1.03-.35-1.53-.57-.17-.07-.33-.16-.49-.24-.92-.42-1.79-.92-2.63-1.5-.19-.13-.38-.24-.56-.38-.36-.27-.7-.56-1.04-.86-.26-.23-.51-.46-.76-.71-.28-.28-.57-.54-.83-.84l-.12-.15c-.07-.08-.13-.18-.2-.26-.68-.81-1.3-1.72-1.87-2.7-.07-.11-.13-.23-.2-.35-.09-.16-.18-.3-.26-.46-.24-.47-.47-.96-.7-1.45-.33-.75-.65-1.5-.91-2.33 0-.01 0-.02-.01-.03-6.51 2.37-13.08 4.52-19.73 6.25-1.44-5.51-3.71-9.64-6.44-12.74s-.02-.03-.03-.04c-.51-.58-1.02-1.14-1.56-1.64-.13-.12-.27-.23-.41-.35a22.868 22.868 0 0 0-5-3.39c-.07-.03-.14-.07-.21-.11-.68-.33-1.36-.62-2.05-.88h-.02c-.01 0-.03-.01-.04-.02-1.13-.42-2.27-.77-3.42-1.02l-.19-.03h-.01c-.85-.18-1.7-.31-2.55-.4h-.07c-.92-.1-1.82-.14-2.71-.15h-.03c-1.28 0-2.52.06-3.7.2h-.03c-1.22.15-2.38.36-3.45.64h-.02c-.35.09-.6.3-.76.54-.52.78-.14 2.05 1.01 2.15.08 0 .16.02.23.02.02 0 .04 0 .06.01 1.91.18 4.02.54 6.17 1.12s.09.01.13.02c.08.02.16.06.24.09.96.27 1.92.61 2.87.99.04.02.08.03.12.05.94.39 1.86.84 2.77 1.35h.02a19.62 19.62 0 0 1 5.06 4.09c.28.32.55.64.82.98.85 1.12 1.63 2.33 2.24 3.74 0 0 0 .01.01.02.01.03.03.06.05.09.01.03.03.06.04.08l.03.09c0 .03.02.06.03.09v.01c.3.75.56 1.59.77 2.49.17.75.32 1.52.4 2.35v.08c.08.77.09 1.57.07 2.39 0 .2-.03.4-.04.6-.04.65-.11 1.31-.22 1.97-.04.21-.07.41-.11.62-.16.77-.36 1.55-.63 2.33-.03.08-.04.15-.07.23-.65 1.81-1.65 3.6-3.05 5.3-.06.08-.13.15-.2.23-.67.79-1.43 1.56-2.29 2.3-.06.05-.12.1-.18.16-1.9 1.6-4.28 3.04-7.23 4.24-.2.08-.43.16-.64.24h-.02c-1.27.49-2.64.93-4.12 1.32-.44.12-.87.24-1.33.35-1.82.43-3.73.81-5.86 1.08-2.37.3-4.73.32-7.05.22-.23-.01-.45-.04-.67-.06a36.23 36.23 0 0 1-6.51-1h-.01c-.24-.06-.48-.11-.71-.18-1.42-.39-2.75-.87-4.04-1.44-.17-.08-.34-.15-.51-.23-1.18-.55-2.28-1.16-3.32-1.86-.22-.15-.42-.31-.64-.46-.98-.71-1.89-1.47-2.7-2.33-.16-.17-.29-.36-.44-.53-.81-.92-1.55-1.88-2.14-2.96-.18-.33-.3-.68-.44-1.03-.55-1.18-.99-2.42-1.25-3.78-.29-1.27-.48-2.59-.44-4.04-3.78-.58-7.55-1.34-11.3-2.23-2.96-.69-5.91-1.5-8.84-2.42-.29-.09-.58-.17-.87-.26v-.01c1.79-4.32 2.41-8.26 2.24-11.83-.05-1.06-.16-2.1-.35-3.09-.03-.14-.07-.28-.1-.42-.22-1.02-.52-2-.86-2.95l-.06-.15c-.07-.18-.14-.37-.21-.55-.33-.81-.7-1.6-1.1-2.35-.07-.13-.14-.27-.21-.41l-.03-.06c-.57-.99-1.21-1.93-1.89-2.81l-.12-.15c-.03-.04-.06-.08-.1-.12l-.02-.02c-.45-.56-.91-1.11-1.39-1.62s-.06-.06-.08-.09c-.2-.21-.4-.43-.61-.64-1.92-1.93-4.03-3.5-6.1-4.71-.03-.02-.06-.03-.08-.05 0 0-.02 0-.03-.01-.99-.57-1.96-1.08-2.89-1.48-1.43-.62-2.66 1.21-1.5 2.26.36.32.73.69 1.09 1.04.5.49 1 1.01 1.5 1.55.05.06.11.12.16.17 0 .01.02.02.03.03.59.65 1.17 1.35 1.72 2.08 0 0 0 .01.01.02.55.73 1.08 1.5 1.58 2.31.07.11.15.22.22.33.44.74.84 1.51 1.2 2.31.35.77.65 1.56.91 2.38.16.51.3 1.02.42 1.55l.09.41c.15.68.26 1.38.35 2.09.08.81.15 1.62.12 2.46-.01.14-.07.25-.08.4-.18 1.84-.52 3.56-1.07 5.1-.44 1.24-1.09 2.29-1.73 3.34 0 0 0 .02-.02.03-.2.31-.32.69-.54.99-.5.7-1.1 1.27-1.69 1.88v.01c-.45.46-.88.92-1.38 1.32-.64.52-1.3.98-2 1.4-.6.36-1.24.67-1.88.96-.7.31-1.37.65-2.11.88-.59.19-1.23.26-1.84.4-1.28.28-2.56.5-3.93.56H142c-1.17.06-2.35.05-3.56-.06-.62-.06-1.23-.16-1.86-.26-.41-.06-.82-.19-1.23-.28-2.59-.52-5.2-1.39-7.8-2.64-.55-.26-1.09-.41-1.64-.71-1.45-.79-2.82-1.69-4.15-2.63-.39-.28-.75-.57-1.13-.85-.96-.73-1.86-1.51-2.73-2.31h-.01c-3.01-2.81-5.4-6.04-6.87-9.53v-.02c-.46-1.1-.97-2.97-1.26-4.12l-.04-.17c-.25-1.42-.4-2.85-.31-4.32v-.06c0-.02.01-.05.01-.08 0-.04.02-.08.02-.11.12-1.57.42-3.15.98-4.75.15-.44.37-.89.57-1.33.52-1.2 1.14-2.41 1.94-3.62a86.592 86.592 0 0 1-3.11-3.22c-.04-.04-.07-.08-.1-.12-3.08-3.35-6.01-7.01-8.81-10.87v-.01c-.75-1.02-1.5-2.04-2.21-3.07-.36-.53-.7-1.07-1.06-1.61v-.02c-1.03-1.54-2.03-3.09-2.98-4.68-2.2-3.63-4.24-7.41-6.15-11.28-.17-.35-.35-.7-.52-1.06-1.89-3.9-3.63-7.86-5.19-11.89-.07-.17-.14-.33-.21-.5-.73-1.91-1.43-3.83-2.08-5.76-.36-1.07-.69-2.13-1.01-3.2-.3-1.05-.61-2.13-.9-3.27-.22-.84-.42-1.67-.62-2.51v-.02c-.14-.6-.26-1.22-.39-1.84-3.19-14.67-2.92-29.19.31-42.73l.03-.13c.53-2.2 1.13-4.37 1.81-6.52.05-.17.12-.35.17-.52v-.01c.81-2.5 1.73-4.96 2.74-7.37s.04-.09.05-.13c1.66-3.95 3.58-7.76 5.76-11.43.03-.04.05-.08.08-.13 2.15-3.61 4.52-7.09 7.15-10.38.06-.08.11-.15.16-.23.18-.23.37-.46.56-.69.53-.62 1.11-1.26 1.64-1.89.64-.74 1.26-1.5 1.92-2.22 1.03-1.12 2.16-2.25 3.33-3.39.7-.69 1.41-1.38 2.14-2.05 1.16-1.07 2.36-2.12 3.63-3.18.27-.22.52-.47.79-.69.5-.41 1-.73 1.5-1.12 1.53-1.2 3.06-2.38 4.74-3.54 2.53-1.76 5.04-3.37 7.54-4.79 1.83-1.02 3.71-2 5.67-2.91.93-.45 1.86-.85 2.78-1.25 0 0 .02 0 .02-.01.01 0 .02 0 .04-.01.55-.24 1.12-.46 1.68-.69 2.09-.85 4.16-1.61 6.21-2.26h.02c.34-.11.68-.22 1.02-.32h.01c2.02-.61 4.02-1.13 5.99-1.57h.04c1.94-.43 3.86-.78 5.75-1.05l.22-.03c1.85-.26 3.66-.46 5.45-.59.11 0 .21-.01.32-.02 1.8-.12 3.56-.19 5.3-.2h.25c2.35 0 4.65.09 6.87.27h.01l.82.06c3.01.28 5.87.7 8.59 1.22.17.03.34.06.51.1 2.69.53 5.23 1.13 7.6 1.8.08.02.15.04.23.07 1.92.54 3.73 1.11 5.41 1.69.08.03.17.05.25.08 1.49.51 2.91 1.03 4.18 1.52.02 0 .04.02.07.02.02 0 .04.02.06.02 3 1.17 2.48 4.05-.92 3.35-18.69-3.74-38.26-.81-51.97 8.37-43.51 29.14-36.41 72.13-23.51 97.69 12.33 24.45 42.87 47.58 80.01 47.49 25.37-.06 56.37-10.12 103.87-46.19C364.65 227.26 411.88 210.8 455.3 210c.66-.01 1.31-.12 1.95-.08 1.72.09 3-.6 2.3-3.32-.1-.39-.16-.78-.25-1.17-4.56-21.44-12.23-41.51-22.49-59.78h-.06c-4.06.94-48.43 11.56-94.46 41.41-22.62 14.67-41.24 30.33-58.33 44.5-7.15 5.93-14.06 11.63-20.84 16.85-20.92 15.68-43.1 32.92-68.06 32.42-5.76-.12-11.67-1.18-17.75-3.42-21.13-7.46-33.06-30.23-35.93-52.21a84.69 84.69 0 0 1-.48-4.69c-.11-1.56-.18-3.1-.2-4.63 0-.04.01-.08.01-.12 5.13 17.55 18.21 37.44 35.3 43.47 32.42 11.96 57.93-13.5 83.68-32.81 22.99-17.68 47.08-40.53 79.17-61.35 29.15-18.91 67.34-33.2 85.35-39.1-31.04-43.1-77.55-73.75-129.93-84.62-24.36-5.05-50.02-5.93-76.05-1.87-13.98 2.18-27.41 5.7-40.22 10.36 0 0-27.22 9.59-49.45 25.77-2.49 1.82-5.49 4.25-8.59 6.89-4.96 4.23-1.4 12.29 5.06 11.45 13.13-1.69 30.76-1.56 51.26 4.59 38.69 11.6 58.76 39.32 68.38 57.77 5.23 10.03-4.54 14.39-10.13 8.78-17.71-17.77-71.61-50.63-134.91-17.29-41.83 22.03-57.62 60.83-60.33 93.14-4.11 49 14.04 92.27 26.36 114.02 30.11 53.14 81.98 91.02 141.76 103.53 24.47 5.12 50.25 6.03 76.41 1.95 48.01-7.48 89.73-30.48 120.92-63.06a214.286 214.286 0 0 0 33.49-45.86c11.56-21.27 19.57-44.57 23.34-69.04.21-1.37-.81-2.65-2.19-2.77ZM199.94 372l.02.1c.59 3.75 7.41 8.42 16.79 7.21 4.76-.62 9.08-2.67 11.85-5.63.85-.91 2.8-3.3 2.46-5.82-.58-3.75-7.41-8.42-16.79-7.21-4.76.62-9.08 2.67-11.84 5.63-.85.91-2.8 3.3-2.47 5.72Zm-72.9-33.74c-1.07.1-3.65.48-4.64 2.04-.14.22-.56.87-.48 2.31.18 3.4 2.94 8.46 8.7 12.11 3.86 2.45 8.2 3.66 11.9 3.33 1.07-.09 3.66-.48 4.65-2.05.13-.22.55-.87.48-2.3-.18-3.39-2.94-8.45-8.7-12.11-3.86-2.45-8.2-3.66-11.9-3.33Z",
            style: {
                fill: 'currentColor',
                strokeWidth: 0
            }
        })
    }));
var $0e324a98afaf32e9$export$2e2bcd8739ae039 = $0e324a98afaf32e9$var$SvgComponent;





parcelRequire("7fPBF");
const $4c0ef6c1c64a1357$var$SvgLogo2KLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4a1 1 0 0 0-.982.809l-8 41A1 1 0 0 0 1 47h40a1 1 0 0 0 .982-.809l8-41A1 1 0 0 0 49 4H9zm.824 2h37.961l-7.61 39H2.216l7.61-39zM21 8c-3.774 0-6.54 1.231-8.338 2.848C10.864 12.464 10 14.393 10 16a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1c0 .093-.013-.41.404-.895C17.822 14.62 18.723 14 21 14c.886 0 1.778.168 2.342.42.282.126.472.27.562.373.013.015.004.017.014.03l-.002.001c-.24.14-.687.318-1.201.479-1.028.32-2.317.59-3.213.818-2.22.563-4.874 1.19-7.12 2.406-2.245 1.217-4.136 3.179-4.359 6.114a1 1 0 0 0 0 .002c-.054.741-.023 2.37-.023 2.37A1 1 0 0 0 9 28h12.865l-2.842 12.783A1 1 0 0 0 20 42h5a1 1 0 0 0 .977-.783l1.03-4.647.766-.67 3.37 5.614A1 1 0 0 0 32 42h6a1 1 0 0 0 .863-1.504l-5.521-9.467 8.316-7.277A1 1 0 0 0 41 22h-6a1 1 0 0 0-.633.227l-5.097 4.17.707-3.18A1 1 0 0 0 29 22h-8.207c.08-.02.105-.042.186-.062 1.917-.487 4.284-1.01 6.275-1.971.995-.481 1.909-1.078 2.603-1.893A4.71 4.71 0 0 0 31 15c0-2.567-1.56-4.449-3.521-5.518C25.517 8.414 23.136 8 21 8zm0 2c1.864 0 3.983.4 5.521 1.238C28.061 12.077 29 13.196 29 15c0 .735-.227 1.264-.664 1.777-.438.514-1.114.984-1.951 1.389-1.675.81-3.942 1.335-5.899 1.832-2.51.637-4.643 1.21-6.222 2.14A1 1 0 0 0 14.77 24H27.754l-1.063 4.783a1 1 0 0 0 1.61.99L35.357 24h2.983l-6.936 6.068a1 1 0 0 0-.207 1.256L36.26 40h-3.694l-3.693-6.154a1 1 0 0 0-1.516-.239l-1.912 1.674a1 1 0 0 0-.318.535L24.197 40h-2.95l2.84-12.783A1 1 0 0 0 23.112 26H10.008c0-.534-.007-.988.01-1.207v-.002c.166-2.188 1.41-3.473 3.316-4.506 1.907-1.033 4.424-1.657 6.66-2.224.81-.206 2.146-.482 3.319-.848.586-.183 1.13-.382 1.609-.66.24-.14.466-.299.674-.535.207-.237.404-.597.404-1.018 0-.582-.244-1.13-.592-1.525-.347-.396-.782-.67-1.25-.88C23.222 12.177 22.114 12 21 12c-2.666 0-4.265.817-5.111 1.8-.366.426-.532.834-.659 1.2h-2.949a5.84 5.84 0 0 1 1.717-2.664C15.42 11.057 17.655 10 21 10z"
        })
    }));
var $4c0ef6c1c64a1357$export$2e2bcd8739ae039 = $4c0ef6c1c64a1357$var$SvgLogo2KLogo;





parcelRequire("7fPBF");
const $dc242ec31876a589$var$SvgMastercard = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h40c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5Zm0 2h40c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H5c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3Zm12 4c-6.617 0-12 5.383-12 12s5.383 12 12 12c3.078 0 5.875-1.184 8-3.094C27.125 35.816 29.926 37 33 37c6.617 0 12-5.383 12-12s-5.383-12-12-12c-3.074 0-5.875 1.184-8 3.094C22.875 14.184 20.078 13 17 13Zm0 2c.785 0 1.55.11 2.281.281-.18.18-.281.442-.281.719 0 .55.45 1 1 1s1-.45 1-1c0-.059-.023-.102-.031-.156 1.09.476 2.09 1.125 2.937 1.937a.993.993 0 0 0 .782.782 9.867 9.867 0 0 1 1.5 2.5C26.12 21.047 26.07 21 26 21c-.55 0-1 .45-1 1s.45 1 1 1c.277 0 .54-.102.719-.281.168.738.281 1.492.281 2.281 0 .79-.11 1.543-.281 2.281A1.016 1.016 0 0 0 26 27c-.55 0-1 .45-1 1s.45 1 1 1c.066 0 .125-.02.188-.031a10.09 10.09 0 0 1-1.532 2.468.993.993 0 0 0-.75.782 9.916 9.916 0 0 1-2.968 1.968c.015-.066.062-.117.062-.187 0-.55-.45-1-1-1s-1 .45-1 1c0 .293.113.566.313.75-.743.176-1.52.25-2.313.25-.793 0-1.57-.074-2.312-.25.199-.184.312-.457.312-.75 0-.55-.45-1-1-1s-1 .45-1 1c0 .07.047.121.063.188a9.945 9.945 0 0 1-5.25-5.25c.066.015.117.062.187.062.55 0 1-.45 1-1s-.45-1-1-1c-.293 0-.566.113-.75.313A10.04 10.04 0 0 1 7 25c0-.793.074-1.57.25-2.312.184.199.457.312.75.312.55 0 1-.45 1-1s-.45-1-1-1c-.07 0-.121.047-.187.063a9.945 9.945 0 0 1 5.25-5.25c-.016.066-.063.117-.063.187 0 .55.45 1 1 1s1-.45 1-1c0-.293-.113-.566-.312-.75A10.04 10.04 0 0 1 17 15Zm16 0c5.535 0 10 4.465 10 10s-4.465 10-10 10c-2.555 0-4.89-.934-6.656-2.5A11.95 11.95 0 0 0 29 25a11.95 11.95 0 0 0-2.656-7.5C28.109 15.934 30.445 15 33 15Zm-22 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-9 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
    }));
var $dc242ec31876a589$export$2e2bcd8739ae039 = $dc242ec31876a589$var$SvgMastercard;





parcelRequire("7fPBF");
const $3fbee013cad25ded$var$SvgMessages = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm11 5c-8.194 0-15 5.724-15 12.963 0 4.46 2.681 8.282 6.572 10.598a15.462 15.462 0 0 1-2.271 2.824 1 1 0 0 0 .873 1.699c2.308-.41 4.72-1.258 6.705-2.486 1.007.188 2.04.328 3.121.328 8.194 0 15-5.725 15-12.963C40 16.724 33.194 11 25 11zm0 2c7.27 0 13 4.99 13 10.963 0 5.973-5.73 10.963-13 10.963-1.064 0-2.095-.12-3.096-.328a1 1 0 0 0-.756.146c-.926.613-2.052 1.118-3.236 1.535.367-.497.753-.985 1.01-1.543a1 1 0 0 0-.465-1.314C14.552 31.494 12 27.968 12 23.962 12 17.99 17.73 13 25 13z"
        })
    }));
var $3fbee013cad25ded$export$2e2bcd8739ae039 = $3fbee013cad25ded$var$SvgMessages;





parcelRequire("7fPBF");
const $a0ca46ae71da4c2a$var$SvgMicrosoftEdge = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M24.375 2c-5.68 0-9.965 1.98-13.062 4.344-7.86 5.992-8.625 16.125-8.625 16.125a1.001 1.001 0 0 0 1.843.625s2.887-4.469 7.907-7.594c1.699-1.059 3.867-1.832 6.062-2.375-.867.387-3.863 1.836-6.687 5.125-2.551 2.969-4 7.012-4 11.25 0 1.066-.02 3.113.593 5.281.57 2.02 1.672 3.98 2.688 5.469 2.941 4.305 7.265 6.105 9.344 6.781 2.394.778 4.855.969 7.125.969 8.128 0 13.562-3.344 13.562-3.344a1 1 0 0 0 .469-.875v-9.25a1 1 0 0 0-1.563-.843s-2.133 1.453-4.187 2.062c-1.547.46-2.809 1.063-7.125 1.063-6.11 0-8.692-2.118-9.938-4.157-.793-1.3-1-2.363-1.062-3.125h26.594c.55 0 1-.449 1-1v-4.625s-.09-3.566-.844-6.656c-.403-1.648-1.02-3.34-1.844-4.719-1.773-2.976-3.523-5.203-7.5-7.656C31.015 2.34 26.539 2 24.375 2Zm0 2c1.93 0 6.066.36 9.688 2.594 3.757 2.316 5.132 4.101 6.843 6.969.68 1.144 1.262 2.675 1.625 4.156.676 2.77.782 6.218.782 6.218v3.594H16.687a1 1 0 0 0-1 .938s-.218 2.613 1.376 5.218c1.593 2.606 5.058 5.126 11.656 5.126 4.523 0 6.328-.754 7.687-1.157 1.2-.355 2.32-.902 3.188-1.375v6.875C38.937 43.54 34.598 46 27.562 46c-2.156 0-4.394-.191-6.5-.875-1.851-.602-5.746-2.242-8.312-6-.93-1.363-1.96-3.187-2.437-4.875-.52-1.84-.5-3.672-.5-4.75 0-3.781 1.296-7.402 3.5-9.969 1.078-1.258 2.214-2.18 3.28-2.937-.015.031-.015.027-.03.062-.848 2-1.063 3.969-1.063 3.969a.999.999 0 0 0 1 1.094h15.594a.998.998 0 0 0 1-.875s.261-2.555-.844-5.157c-1.105-2.601-3.809-5.28-9-5.28-3.902 0-8.512 1.312-11.875 3.406-2.453 1.527-4.352 3.312-5.781 4.843.926-3.187 2.789-7.558 6.937-10.718C15.36 5.78 19.156 4 24.375 4Zm-1.125 8.406c4.55 0 6.281 2.004 7.156 4.063a8.37 8.37 0 0 1 .688 3.25H17.78c.114-.637.149-1.157.625-2.282.703-1.66 1.875-3.062 1.875-3.062a.997.997 0 0 0-.187-1.5c1.078-.187 2.18-.469 3.156-.469Z"
        })
    }));
var $a0ca46ae71da4c2a$export$2e2bcd8739ae039 = $a0ca46ae71da4c2a$var$SvgMicrosoftEdge;





parcelRequire("7fPBF");
const $073cb9bb3a09c7d7$var$SvgMicrosoftExcel = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-5h17c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188V6.53a1.01 1.01 0 0 0 0 .875v35.407a1.016 1.016 0 0 0 0 .406v4.593L2 42.845V7.156ZM30 8h17v34H30v-5h4v-2h-4v-6h4v-2h-4v-5h4v-2h-4v-5h4v-2h-4Zm6 5v2h8v-2ZM6.688 15.688l5.468 9.343-5.969 9.344h5l3.25-6.031c.227-.582.376-1.028.438-1.313h.031c.13.61.254 1.024.375 1.25l3.25 6.094H23.5l-5.75-9.437 5.594-9.25h-4.688l-2.968 5.53a20.942 20.942 0 0 0-.594 1.657h-.031a9.492 9.492 0 0 0-.563-1.594l-2.687-5.593ZM36 20v2h8v-2Zm0 7v2h8v-2Zm0 8v2h8v-2Z"
        })
    }));
var $073cb9bb3a09c7d7$export$2e2bcd8739ae039 = $073cb9bb3a09c7d7$var$SvgMicrosoftExcel;





parcelRequire("7fPBF");
const $c9b5ae76a6c0d9c1$var$SvgMicrosoftOnenote = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-3h18c1.094 0 2-.906 2-2V33c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V20c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V7c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v3.5a1.025 1.025 0 0 0 0 .593v38.532a1.016 1.016 0 0 0 0 .406v2.593L2 42.845V7.156ZM30 7h18v11h-4.094a1 1 0 0 0-.812.5v.031c-.13.227-.16.496-.094.75v12.407a1.025 1.025 0 0 0 0 .593V44H30v-7h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8ZM6.531 15.688V34.25h3.5V24.031c0-1.347-.031-2.343-.094-3H10c.152.348.414.88.813 1.563l6.75 11.656h3.75V15.688h-3.5v10.25c0 1.269.03 2.128.093 2.562h-.031c-.25-.5-.547-.992-.844-1.5l-6.5-11.312ZM45 20h3v11h-3Zm0 13h3v11h-3Z"
        })
    }));
var $c9b5ae76a6c0d9c1$export$2e2bcd8739ae039 = $c9b5ae76a6c0d9c1$var$SvgMicrosoftOnenote;





parcelRequire("7fPBF");
const $ddc5edcab4e76c4a$var$SvgMicrosoftOnenote2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-3h18c1.094 0 2-.906 2-2V33c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V20c0-.36-.11-.707-.281-1 .172-.293.281-.64.281-1V7c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v3.5a1.025 1.025 0 0 0 0 .593v38.532a1.016 1.016 0 0 0 0 .406v2.593L2 42.845V7.156ZM30 7h18v11h-4.094a1 1 0 0 0-.812.5v.031c-.13.227-.16.496-.094.75v12.407a1.025 1.025 0 0 0 0 .593V44H30v-7h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8v-3h8v-2h-8ZM6.531 15.688V34.25h3.5V24.031c0-1.347-.031-2.343-.094-3H10c.152.348.414.88.813 1.563l6.75 11.656h3.75V15.688h-3.5v10.25c0 1.269.03 2.128.093 2.562h-.031c-.25-.5-.547-.992-.844-1.5l-6.5-11.312ZM45 20h3v11h-3Zm0 13h3v11h-3Z"
        })
    }));
var $ddc5edcab4e76c4a$export$2e2bcd8739ae039 = $ddc5edcab4e76c4a$var$SvgMicrosoftOnenote2;





parcelRequire("7fPBF");
const $9b7e1a52af65fadf$var$SvgMicrosoftOutlook = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762V38h4.063c-.043.332-.063.66-.063 1 0 4.406 3.594 8 8 8 4.406 0 8-3.594 8-8 0-1.39-.371-2.703-1-3.844.004-.05.004-.105 0-.156V17.656a.991.991 0 0 0 0-.687V12c0-.55-.45-1-1-1H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v9.5a1.025 1.025 0 0 0 0 .593v24.407a1.025 1.025 0 0 0 0 .593v10.532l-26-4.97V7.157ZM30 13h17v3.781l-13.25 7.844L30 21.531Zm-15.156 2.531c-2.52 0-4.535.875-6.063 2.656-1.527 1.782-2.281 4.118-2.281 7 0 2.731.746 4.958 2.25 6.657 1.504 1.699 3.457 2.562 5.844 2.562 2.449 0 4.414-.902 5.937-2.656 1.524-1.758 2.282-4.07 2.282-6.937 0-2.79-.72-5.012-2.188-6.72-1.469-1.702-3.402-2.562-5.781-2.562Zm-.094 3.531c1.277 0 2.293.543 3.031 1.594.739 1.051 1.094 2.516 1.094 4.407 0 1.816-.398 3.23-1.156 4.25-.762 1.023-1.77 1.53-3.063 1.53-1.258 0-2.285-.511-3.062-1.562-.774-1.05-1.156-2.508-1.156-4.312 0-1.782.378-3.2 1.156-4.282.773-1.082 1.84-1.625 3.156-1.625Zm32.25.063v13.656A7.982 7.982 0 0 0 42 31c-3.34 0-6.21 2.082-7.406 5H30V24.094l3.031 2.5a1 1 0 0 0 1.157.093ZM42 33c3.324 0 6 2.676 6 6s-2.676 6-6 6-6-2.676-6-6 2.676-6 6-6Zm-1 1v7h5v-2h-3v-5Z"
        })
    }));
var $9b7e1a52af65fadf$export$2e2bcd8739ae039 = $9b7e1a52af65fadf$var$SvgMicrosoftOutlook;





parcelRequire("7fPBF");
const $043753d569a8f872$var$SvgMicrosoftPowerpoint = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-5h17c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v4.5a1.025 1.025 0 0 0 0 .593v35.532a1.016 1.016 0 0 0 0 .406v4.593L2 42.845V7.156ZM30 8h17v34H30v-5h10v-2H30v-5.562c.922.367 1.95.562 3 .562 4.406 0 8-3.594 8-8v-1h-7v-7h-1c-1.059 0-2.07.191-3 .563Zm5 3v9h9v-1c0-4.406-3.594-8-8-8Zm2 2.188A5.84 5.84 0 0 1 41.813 18H37ZM8.156 15.656v18.719h4.219v-6.437h2c2.262 0 4.086-.59 5.438-1.75 1.351-1.16 2.03-2.684 2.03-4.563 0-3.977-2.378-5.969-7.093-5.969ZM32 16.25V23h6.813c-.489 2.828-2.84 5-5.813 5a5.956 5.956 0 0 1-2.875-.75 1.243 1.243 0 0 0-.125-.062V16.813c.031-.02.063-.04.094-.063.566-.316 1.246-.383 1.906-.5Zm-19.625 2.656h1.656c2.242 0 3.375.953 3.375 2.875 0 1.965-1.133 2.938-3.375 2.938h-1.656Z"
        })
    }));
var $043753d569a8f872$export$2e2bcd8739ae039 = $043753d569a8f872$var$SvgMicrosoftPowerpoint;





parcelRequire("7fPBF");
const $d612a33d3bd29557$var$SvgMicrosoftTeams2019 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27 4c-3.854 0-7 3.146-7 7 0 .694.11 1.364.299 2H5c-1.645 0-3 1.355-3 3v18c0 1.645 1.355 3 3 3h11.05c.509 5.596 5.224 10 10.95 10 5.12 0 9.241-3.59 10.46-8.336C38.644 39.441 39.985 40 41.5 40c4.13 0 7.5-3.37 7.5-7.5V21a1 1 0 0 0-1-1H26v-2.076c.328.047.66.076 1 .076 3.854 0 7-3.146 7-7s-3.146-7-7-7zm0 2c2.774 0 5 2.226 5 5s-2.226 5-5 5a5.02 5.02 0 0 1-1.012-.111C25.928 14.295 24.607 13 23 13h-.578A4.953 4.953 0 0 1 22 11c0-2.774 2.226-5 5-5zm15 2c-1.583 0-2.898.63-3.748 1.586C37.402 10.542 37 11.778 37 13s.402 2.458 1.252 3.414S40.417 18 42 18c1.583 0 2.898-.63 3.748-1.586C46.598 15.458 47 14.222 47 13s-.402-2.458-1.252-3.414S43.583 8 42 8zm0 2c1.083 0 1.769.37 2.252.914.483.544.748 1.308.748 2.086 0 .778-.265 1.542-.748 2.086-.483.544-1.169.914-2.252.914-1.083 0-1.769-.37-2.252-.914C39.265 14.542 39 13.778 39 13c0-.778.265-1.542.748-2.086C40.231 10.37 40.917 10 42 10zM5 15h18c.565 0 1 .435 1 1v.365a1 1 0 0 0 0 .555v3.912a1 1 0 0 0 0 .326V34c0 .565-.435 1-1 1h-5.832a1 1 0 0 0-.326 0H5c-.565 0-1-.435-1-1V16c0-.565.435-1 1-1zm4 4v2h4v10h2V21h4v-2H9zm17 3h10v14c0 4.983-4.017 9-9 9a8.981 8.981 0 0 1-8.941-8H23c1.645 0 3-1.355 3-3V22zm12 0h9v10.5c0 3.05-2.45 5.5-5.5 5.5-1.403 0-2.649-.549-3.62-1.408.013-.207.12-.382.12-.592V22z"
        })
    }));
var $d612a33d3bd29557$export$2e2bcd8739ae039 = $d612a33d3bd29557$var$SvgMicrosoftTeams2019;





parcelRequire("7fPBF");
const $4690868c4c694c15$var$SvgMicrosoftToDoApp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M39.672 7.01c-.697 0-1.394.264-1.916.793l-16.912 17.16-8.58-8.705a2.745 2.745 0 0 0-1.961-.815c-.714 0-1.426.272-1.961.815H8.34l-6.533 6.63a2.817 2.817 0 0 0 0 3.938L18.88 44.152c.016.017.036.027.053.043.12.116.244.223.378.313 1.05.73 2.525.628 3.452-.313l.04-.043 5.66-5.74.878-.89 18.873-19.149a2.752 2.752 0 0 0-.002-3.846h.002l-6.63-6.724a2.676 2.676 0 0 0-1.913-.793zm0 1.98c.174 0 .348.073.49.217l6.627 6.725h.002a.737.737 0 0 1-.002 1.039L27.918 36.119l-.002-.002-6.535 6.631a.724.724 0 0 1-1.053.014l-6.598-6.696a.735.735 0 0 1 0-1.037L39.18 9.207a.69.69 0 0 1 .492-.217zm-29.37 8.434c.192 0 .383.079.538.236l8.6 8.727-7.133 7.238h-.002a2.674 2.674 0 0 0-.422.578l-8.653-8.78a.803.803 0 0 1 0-1.13v-.002l6.536-6.63a.753.753 0 0 1 .537-.237z"
        })
    }));
var $4690868c4c694c15$export$2e2bcd8739ae039 = $4690868c4c694c15$var$SvgMicrosoftToDoApp;





parcelRequire("7fPBF");
const $be2fbecbfbe47448$var$SvgMicrosoftWord = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M28.875 0a.466.466 0 0 0-.062.031l-28 5.313a1 1 0 0 0-.813 1v37.312a1 1 0 0 0 .813 1l28 5.313c.289.054.59-.02.82-.207.226-.188.363-.465.367-.762v-5h17c1.094 0 2-.906 2-2V8c0-1.094-.906-2-2-2H30V1a1.004 1.004 0 0 0-1.125-1ZM28 2.188v4.5a1.025 1.025 0 0 0 0 .593v35.532a1.016 1.016 0 0 0 0 .406v4.593L2 42.845V7.156ZM30 8h17v34H30v-5h14v-2H30v-6h14v-2H30v-5h14v-2H30v-5h14v-2H30ZM4.625 15.656l3.813 18.688h3.75l2.468-11.969c.114-.55.219-1.273.281-2.125h.032c.027.773.09 1.5.219 2.125l2.406 11.969h3.625l3.843-18.688H21.75l-2 12.469a16.853 16.853 0 0 0-.219 2.094H19.5c-.066-.88-.133-1.54-.219-2l-2.375-12.563h-3.5l-2.625 12.407c-.168.792-.285 1.519-.312 2.187h-.063c-.039-.895-.097-1.625-.187-2.156L8.188 15.656Z"
        })
    }));
var $be2fbecbfbe47448$export$2e2bcd8739ae039 = $be2fbecbfbe47448$var$SvgMicrosoftWord;





parcelRequire("7fPBF");
const $a9622dbe0a0baaaf$var$SvgMotionControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 100 100"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                d: "m23.528 38.31 7.865-2.689.667 1.95-7.865 2.69-.667-1.95Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m48.63 77 19.197 6.563a4.26 4.26 0 0 0 5.41-2.653L86.572 41.9a4.26 4.26 0 0 0-2.653-5.409L63.353 29.46c.393.556.63 1.232.646 1.964l19.388 6.628a2.611 2.611 0 0 1 1.626 3.316l-13.337 39.01a2.611 2.611 0 0 1-3.315 1.626L53.727 77h-5.098Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M35.498 29.716A3.431 3.431 0 0 0 35 31.5v.129L16.213 38.05a2.611 2.611 0 0 0-1.626 3.316l13.337 39.01a2.611 2.611 0 0 0 3.316 1.626L45.873 77h5.098l-19.198 6.563a4.26 4.26 0 0 1-5.41-2.653L13.028 41.9a4.26 4.26 0 0 1 2.653-5.409l19.818-6.776Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34.34 32.483c0-2.467 2-4.467 4.466-4.467h21.988c2.467 0 4.466 2 4.466 4.467V73.71c0 2.466-2 4.466-4.466 4.466H38.806c-2.466 0-4.466-2-4.466-4.466V32.483Zm4.466-2.405a2.405 2.405 0 0 0-2.405 2.405V73.71a2.405 2.405 0 0 0 2.405 2.404h21.988a2.405 2.405 0 0 0 2.405-2.404V32.483a2.405 2.405 0 0 0-2.405-2.405H38.806Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M44.99 32.483h9.62v2.06h-9.62v-2.06Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $a9622dbe0a0baaaf$export$2e2bcd8739ae039 = $a9622dbe0a0baaaf$var$SvgMotionControl;





const $0fccc9e464ae15bb$var$SvgMotionControl1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                x: 22.4,
                y: 35.269,
                fill: "#FBFDFE",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 1.92,
                rx: 4,
                transform: "rotate(-18.875 22.4 35.27)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                fillOpacity: 0.3,
                d: "m35.012 35.185 9.157-3.13.776 2.27-9.157 3.131z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                x: 48.8,
                y: 24.4,
                fill: "#FBFDFE",
                stroke: "#141526",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                rx: 4
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                d: "M60 28.4h11.2v2.4H60z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "M20 21c3.532-3.333 14.89-10 32.07-10C69.252 11 71.5 12.5 82 17.5"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "m18 15.6.4 7.2 7.6 1.6"
            })
        ]
    }));
var $0fccc9e464ae15bb$export$2e2bcd8739ae039 = $0fccc9e464ae15bb$var$SvgMotionControl1;





parcelRequire("7fPBF");
const $9ca35a7fde0d51c6$var$SvgComponent = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                fill: "#FBFDFE",
                stroke: "#141526",
                strokeLinecap: "round",
                strokeOpacity: 0.3,
                strokeWidth: 1.92,
                rx: 4,
                transform: "scale(-1 1) rotate(-18.875 67.294 251.063)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                fillOpacity: 0.3,
                d: "m64.988 35.185-9.157-3.13-.776 2.27 9.156 3.13z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 33.6,
                height: 56,
                fill: "#FBFDFE",
                stroke: "#141526",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                rx: 4,
                transform: "matrix(-1 0 0 1 51.2 24.4)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#141526",
                d: "M40 28.4H28.8v2.4H40z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "M80 21c-3.532-3.333-14.89-10-32.07-10C30.748 11 28.5 12.5 18 17.5"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: "#E51546",
                strokeLinecap: "round",
                strokeWidth: 2.4,
                d: "m82 15.6-.4 7.2-7.6 1.6"
            })
        ]
    }));
var $9ca35a7fde0d51c6$export$2e2bcd8739ae039 = $9ca35a7fde0d51c6$var$SvgComponent;





parcelRequire("7fPBF");
const $311040ba1740986f$var$SvgMusic = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V13c0-4.959-4.041-9-9-9H13zm0 2h24c3.877 0 7 3.123 7 7v24c0 3.877-3.123 7-7 7H13c-3.877 0-7-3.123-7-7V13c0-3.877 3.123-7 7-7zm20.56 5.002a1.44 1.44 0 0 0-.335.023h-.002L20.63 13.387A2.012 2.012 0 0 0 19 15.354v13.632A1 1 0 0 0 19 29c0 1.117-.883 2-2 2h-1.83c-2.123 0-4.05 1.594-4.164 3.787C10.886 37.074 12.732 39 15 39h.5c3.026 0 5.5-2.474 5.5-5.5V20.455l12-2.25V26c0 1.117-.883 2-2 2h-1.83c-2.123 0-4.05 1.594-4.164 3.787C24.886 34.074 26.732 36 29 36h.5c3.026 0 5.5-2.474 5.5-5.5v-18c0-.803-.668-1.46-1.44-1.498zM33 13.104v3.066l-12 2.25v-3.066l12-2.25zm0 16.277V30.5c0 1.944-1.556 3.5-3.5 3.5H29a1.984 1.984 0 0 1-1.998-2.11c.055-1.052 1.043-1.89 2.168-1.89H31c.743 0 1.402-.262 2-.62zm-14 3V33.5c0 1.944-1.556 3.5-3.5 3.5H15a1.984 1.984 0 0 1-1.998-2.11c.055-1.052 1.043-1.89 2.168-1.89H17c.743 0 1.402-.262 2-.62z"
        })
    }));
var $311040ba1740986f$export$2e2bcd8739ae039 = $311040ba1740986f$var$SvgMusic;





parcelRequire("7fPBF");
const $9cedd24a1acdd63f$var$SvgNetflix = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27 6v10.75L23.48 6H14v38.15l9-1.28V32.58l3.24 10.34 6.14.72 3.62.51V6h-9zm2 2h5v30.13l-5-15.27V8zM17.39 8h4.64l.97 2.96 4 12.22 2 6.12 4.06 12.4-.54-.06-4.76-.56-.76-2.42-4-12.76-2-6.38L17.39 8zM21 41.13l-5 .72V10.24l5 15.96v14.93z"
        })
    }));
var $9cedd24a1acdd63f$export$2e2bcd8739ae039 = $9cedd24a1acdd63f$var$SvgNetflix;





parcelRequire("7fPBF");
const $7e5ab08ff1b567f0$var$SvgNewYorkTimes = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 48 48"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12 3c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V12c0-4.959-4.041-9-9-9H12zm0 2h24c3.877 0 7 3.123 7 7v24c0 3.877-3.123 7-7 7H12c-3.877 0-7-3.123-7-7V12c0-3.877 3.123-7 7-7zm18 3v2c.913 0 1.29.686 1.346.828-.014.012-.018.019-.069.05-.154.098-.475.206-.877.206-.768 0-3.34-.622-5.072-1.252h-.002c-2.152-.828-4.184-1.537-6.086-1.537-1.814 0-3.56.457-4.922 1.406C12.957 10.651 12 12.171 12 14c0 1.542.949 2.67 1.898 3.326a7.26 7.26 0 0 0 2.03.965c-2.53 2.312-4.252 5.547-4.252 9.219 0 7.111 5.874 12.49 12.49 12.49 7.095 0 11.83-5.73 11.83-11.67v-1H32.94l-.205.73c-.283 1.016-.649 1.86-1.074 2.567v-3.34l2.778-2.258v-1.111L31.66 21.66v-3.81c.994-.177 1.954-.56 2.756-1.211 1.139-.926 1.906-2.405 1.906-4.227 0-1.932-1.043-3.292-2.34-3.853C32.686 7.997 31.25 8 30 8zm-10.76 2.295c1.375 0 3.278.6 5.385 1.41l.01.002.008.004c1.878.684 4.228 1.373 5.757 1.373.728 0 1.392-.168 1.94-.512.548-.343 1.03-.942 1.03-1.697 0-.187-.19-.31-.23-.488.012.004.036 0 .047.006.75.324 1.135.668 1.135 2.02 0 1.295-.46 2.098-1.168 2.673-.707.574-1.718.887-2.754.887h-.412c-1.326-.166-3.703-.455-5.879-1.077-2.604-.814-4.578-1.513-6.345-1.513-.872 0-1.545.025-2.192.33-.554.261-.91.899-1.017 1.51-.32-.336-.555-.709-.555-1.223 0-1.171.523-2.004 1.46-2.658.94-.654 2.313-1.047 3.78-1.047zm-1.476 5.088c.532 0 1.244.137 2.084.347-.573.25-1.13.546-1.67.874l-.768-.454s-.306-.182-.596-.418c-.098-.08-.163-.152-.232-.224.16-.048.502-.125 1.182-.125zm5.629 1.387c.054.017.089.025.144.043l.012.003.012.004c2.348.67 4.77.962 6.1 1.127v3.698l-2.645 2.293v1.072l2.644 2.293v5.453c-1.103.72-2.351 1.007-3.611 1.025a8.685 8.685 0 0 1-3.867-.875 6.436 6.436 0 0 1-1.327-.869l5.143-2.51V18.324l-6.77 2.969c.75-1.078 1.937-2.113 3.772-3.041l.809-.41-.416-1.072zm-3.768 1.396c-2.835 2.373-3.706 5.322-3.502 7.83.128 1.572.585 2.968 1.045 4.025.435 1.002.794 1.574 1.062 1.932.6 1.16 1.707 2.077 3.069 2.748a10.574 10.574 0 0 0 4.78 1.078c2.7-.04 5.524-1.365 7.32-4.345C32.163 35.052 28.884 38 24.165 38c-5.534 0-10.49-4.48-10.49-10.49 0-4.018 2.621-7.466 5.949-9.344zM24 21.201v7.301l-2 .977v-7.4l2-.878zm-4 1.754v7.5l-.281.137a10.174 10.174 0 0 1-.715-1.367c-.396-.911-.785-2.114-.889-3.391a7.961 7.961 0 0 1 .096-2.094L20 22.955zm10.66.47 1.291 1.05-1.29 1.046-1.21-1.046 1.21-1.05z"
        })
    }));
var $7e5ab08ff1b567f0$export$2e2bcd8739ae039 = $7e5ab08ff1b567f0$var$SvgNewYorkTimes;





parcelRequire("7fPBF");
const $2081ab8da1be49dc$var$SvgNintendoSwitchLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14.53 4c-3.584 0-6.32 1.058-8.071 3.11C4.708 9.16 4 12.048 4 15.524v20C4 41.545 8.41 46 14.53 46H24V4h-9.47zM26 4v42h9.47C41.59 46 46 41.546 46 35.525v-20c0-3.476-.708-6.364-2.459-8.416C41.79 5.058 39.054 4 35.471 4H26zM14.53 6H22v38h-7.47C9.332 44 6 40.617 6 35.525v-20c0-3.203.663-5.575 1.979-7.117C9.295 6.867 11.324 6 14.529 6zM28 6h7.47c3.206 0 5.235.867 6.551 2.408C43.337 9.95 44 12.322 44 15.525v20C44 40.617 40.667 44 35.47 44H28V6zm-13.5 4c-1.417 0-2.606.567-3.373 1.43C10.36 12.292 10 13.403 10 14.5c0 1.097.36 2.208 1.127 3.07.767.863 1.956 1.43 3.373 1.43 1.417 0 2.606-.567 3.373-1.43C18.64 16.708 19 15.597 19 14.5c0-1.097-.36-2.208-1.127-3.07-.767-.863-1.956-1.43-3.373-1.43zm0 2c.917 0 1.477.308 1.877.758.4.45.623 1.09.623 1.742 0 .653-.223 1.292-.623 1.742-.4.45-.96.758-1.877.758s-1.477-.308-1.877-.758c-.4-.45-.623-1.09-.623-1.742 0-.653.223-1.292.623-1.742.4-.45.96-.758 1.877-.758zm21 12c-1.417 0-2.606.567-3.373 1.43C31.36 26.292 31 27.403 31 28.5c0 1.097.36 2.208 1.127 3.07.767.863 1.956 1.43 3.373 1.43 1.417 0 2.606-.567 3.373-1.43C39.64 30.708 40 29.597 40 28.5c0-1.097-.36-2.208-1.127-3.07-.767-.863-1.956-1.43-3.373-1.43zm0 2c.917 0 1.477.308 1.877.758.4.45.623 1.09.623 1.742 0 .653-.223 1.292-.623 1.742-.4.45-.96.758-1.877.758s-1.477-.308-1.877-.758c-.4-.45-.623-1.09-.623-1.742 0-.653.223-1.292.623-1.742.4-.45.96-.758 1.877-.758z"
        })
    }));
var $2081ab8da1be49dc$export$2e2bcd8739ae039 = $2081ab8da1be49dc$var$SvgNintendoSwitchLogo;





parcelRequire("7fPBF");
const $0b823c4a4b1403fe$var$SvgNod = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 90 100 "
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m60.786 78.88-1.175.892a16.729 16.729 0 0 1-9.587 3.396c-.97-.03-1.932-.146-2.874-.341a22.922 22.922 0 0 1-16.298-4.14L19.89 70.789c-1.7-1.225-3.175-2.534-4.043-4.203-3.001-5.773-4.56-16.467 5.207-26.233 3.98-3.98 8.259-5.908 12.298-6.562a21.803 21.803 0 0 1 3.096-2.425c-5.385.051-11.43 1.968-16.921 7.46C8.96 49.392 10.588 61.154 13.93 67.582c1.107 2.13 2.923 3.682 4.697 4.96l10.961 7.897a25.082 25.082 0 0 0 18.066 4.5l2.425-.333a17.81 17.81 0 0 0 9.15-4.103c.1-.05.196-.118.28-.202.124-.124.247-.25.367-.378.128-.12.255-.243.38-.368.083-.084.15-.179.201-.28.111-.13.22-.262.328-.395Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.496 29.086c-12.673 0-18.978 8.52-20.917 14.678-.546 1.733-.44 3.65-.105 5.707l2.167 13.336a22.652 22.652 0 0 0 8.663 14.41l1.95 1.48a15.38 15.38 0 0 0 8.77 3.12 15.38 15.38 0 0 0 8.77-3.12l1.95-1.48a22.653 22.653 0 0 0 8.664-14.41l2.166-13.336c.335-2.058.443-3.974-.104-5.706-1.931-6.116-8.303-14.679-21.974-14.679Zm1.449 55.382a18.079 18.079 0 0 0 9.482-3.62l1.95-1.48a25.352 25.352 0 0 0 9.696-16.128l2.167-13.336c.352-2.168.548-4.6-.195-6.952-2.21-6.997-9.465-16.566-24.549-16.566-14.164 0-21.303 9.613-23.493 16.567-.74 2.35-.547 4.781-.194 6.951l2.167 13.336a25.352 25.352 0 0 0 9.696 16.128l1.95 1.48a18.079 18.079 0 0 0 9.481 3.62c.125.038.257.058.393.058.176 0 .352-.002.528-.008.176.006.352.008.528.008.137 0 .269-.02.393-.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M53.182 82.765a16.73 16.73 0 0 1-3.158.403 16.73 16.73 0 0 1-8.236-2.471 17.81 17.81 0 0 0 8.92 3.91l2.425.332a25.082 25.082 0 0 0 18.065-4.5l10.962-7.897c1.773-1.278 3.59-2.83 4.697-4.96 3.342-6.428 4.97-18.19-5.596-28.756-5.831-5.832-12.286-7.632-17.913-7.448a22.077 22.077 0 0 1 3.05 2.271c4.338.48 9.013 2.381 13.335 6.704 9.767 9.766 8.209 20.46 5.207 26.233-.867 1.669-2.342 2.978-4.043 4.203l-10.962 7.897a22.922 22.922 0 0 1-16.51 4.112l-.243-.033Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $0b823c4a4b1403fe$export$2e2bcd8739ae039 = $0b823c4a4b1403fe$var$SvgNod;





parcelRequire("7fPBF");
const $85b17b826eab10ce$var$SvgOctopus = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 100,
        height: 100,
        viewBox: "0 0 500 500"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "octopus_svg__linear-gradient",
                        x1: 87.69,
                        x2: 445.37,
                        y1: 515.02,
                        y2: 376.71,
                        gradientTransform: "rotate(-8.86 -1005.607 449.555)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "octopus_svg__linear-gradient-2",
                        x1: -1214.8,
                        x2: -1320.26,
                        y1: -1720.35,
                        y2: -1993.07,
                        gradientTransform: "rotate(81.14 -1702.827 77.309)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "octopus_svg__luminosity-invert",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.octopus_svg__cls-8{stroke-width:0}.octopus_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.octopus_svg__cls-8{fill:currentColor}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "octopus_svg__mask",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 386,
                            height: 388,
                            style: {
                                filter: 'url(#octopus_svg__luminosity-invert)'
                            },
                            transform: "translate(57.27 56.08)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "octopus_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 250,
                            cy: 250,
                            r: 218.04,
                            style: {
                                fill: 'none',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'currentColor'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#octopus_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                                className: "octopus_svg__cls-10",
                                style: {
                                    fill: 'currentColor',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M282.16 344.9c1.32 2.58 4.5 3.52 6.28 3.84 4.19.77 9.19-.13 13.73-2.45 7.84-4.01 11.81-10.96 11.12-15.38-.09-.6-.27-1.15-.55-1.68-1.32-2.58-4.5-3.52-6.28-3.84-4.19-.77-9.19.13-13.73 2.45-7.84 4.01-11.8 10.97-11.11 15.38.09.6.27 1.15.54 1.67ZM204.94 359.8v.09c.54 3.38 6.68 7.58 15.12 6.49 4.29-.56 8.17-2.41 10.67-5.07.77-.82 2.52-2.97 2.21-5.23-.53-3.37-6.67-7.58-15.11-6.49-4.29.56-8.17 2.41-10.66 5.07-.77.82-2.52 2.97-2.23 5.14ZM135.15 331.26c-.13.2-.5.79-.43 2.08.16 3.06 2.65 7.61 7.83 10.9 3.47 2.2 7.38 3.3 10.71 3 .96-.08 3.29-.44 4.18-1.84.12-.2.5-.78.43-2.07-.16-3.05-2.65-7.61-7.83-10.9-3.47-2.2-7.38-3.3-10.71-3-.96.09-3.29.44-4.17 1.83ZM354.77 298.44c.17 1.11.52 2.16 1.03 3.12 3.96 7.35 17.35 8.47 28.67 2.39 11.08-5.96 15.86-15.63 14.85-22.1a9.572 9.572 0 0 0-1.04-3.12c-3.95-7.35-17.34-8.47-28.66-2.39-11.08 5.96-15.86 15.63-14.85 22.1Z",
                            className: "octopus_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M332.91 193.39c-28.88 18.73-50.56 39.3-71.26 55.21-23.17 17.37-48.06 36.86-77.23 26.1-21.74-7.68-32.65-33.34-32.94-55.39.97-24.09 12.32-42.76 51.67-46.63-16.82-3.36-34.43-.73-46.78 7.54-39.16 26.22-32.77 64.92-21.16 87.92 11.09 22 38.58 42.82 72.01 42.74 22.84-.06 50.73-9.11 93.49-41.57 52.34-39.73 94.85-54.55 133.93-55.27.59-.01 1.18-.11 1.75-.07 1.55.08 2.7-.54 2.07-2.99-.09-.35-.15-.7-.22-1.05-4.11-19.3-11.01-37.36-20.24-53.81-2.25.51-42.83 9.87-85.07 37.27Z",
                            style: {
                                fill: 'currentColor',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M258.57 228.81c-23.17 17.37-46.14 40.29-75.31 29.52-15.38-5.43-27.15-23.33-31.77-39.13 0 .04 0 .07-.01.11.02 1.38.08 2.77.18 4.17.1 1.4.24 2.81.43 4.22 2.58 19.78 13.32 40.27 32.34 46.99 5.47 2.02 10.79 2.97 15.97 3.08 22.47.45 42.43-15.06 61.26-29.17 6.11-4.7 12.33-9.82 18.76-15.16 15.38-12.76 32.13-26.84 52.49-40.05 41.43-26.87 81.37-36.42 85.02-37.26v-.11a191.01 191.01 0 0 0-11.29-17.62c-16.21 5.31-50.57 18.18-76.81 35.19-28.88 18.73-50.56 39.29-71.25 55.21Z",
                            style: {
                                fill: 'currentColor',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M99.69 189.16c-13.2 15.05-31.43 60.23-13.11 104.52 4.7 11.37 11.11 24.1 21.23 34.37-.64 3.74-.68 7.44-.12 11.05 3.05 19.55 22.46 29.74 23.45 30.25 19.15 9.13 33.08 3.38 38.85-.06l10.79 3.27c7.88 22.93 39.73 20.67 41.12 20.56 23.42-1.76 33-14.04 36.22-19.78l7.55-2.49c20.74 19.19 51.76 1.14 53.12.33 21.54-12.7 24.48-31.1 24.62-39.32l1.83-1.06c26.46 16.4 56.87-2.77 57.87-3.43 17.86-9.84 24.13-25.13 26.15-32.16 2.45-.6 5.42-.59 7.91-.37 1.24-5.12 2.29-10.3 3.11-15.55.19-1.24-.73-2.39-1.98-2.49-1.35-.11-2.65-.15-3.89-.14-.17 0-.36-.01-.53 0-.48 0-.92.04-1.38.07-.52.02-1.08.03-1.56.07-.19.01-.34.04-.53.06-.71.06-1.41.13-2.04.22-1.2.16-2.16.34-2.96.51-.28.06-.58.12-.81.17-.82.19-1.29.33-1.29.33-.71-2.34-1.59-4.42-2.55-6.36-.29-.58-.6-1.11-.91-1.66-.76-1.35-1.57-2.6-2.43-3.75-.34-.45-.68-.93-1.03-1.35-2.57-3.05-5.48-5.38-8.55-7.02a29.867 29.867 0 0 0-9.9-3.21c-1.63-.23-3.24-.32-4.78-.29-1.54.03-3.02.18-4.39.43-1.53.28-2.93.76-4.29 1.25-.82.31-1.64.63-2.4.98-1.01.46-2.05.92-2.9 1.41-.01 0-.01.02-.02.03-.36.23-.5.57-.53.91v.24c.05.35.19.7.5.91.14.09.34.09.53.11.12.02.2.09.33.07.96-.13 2.04-.23 3.16-.3h.2c.6-.04 1.25-.02 1.88-.03h.09c.57 0 1.11-.04 1.7-.02s.02 0 .02 0c.05 0 .1.01.15.01 1.01.04 2.05.13 3.1.26.53.07 1.05.18 1.58.27.64.12 1.28.25 1.92.41.73.18 1.45.39 2.19.65.53.18 1.05.42 1.58.63s1.04.4 1.55.66c1.19.6 2.36 1.28 3.47 2.13 2.42 1.85 4.59 4.33 6.32 7.61.04.07.09.2.14.28.51.99 1.25 2.55 1.9 4.56.1.32.21.63.3.97.2.7.37 1.43.53 2.21.02.08.04.16.06.25.14.78.26 1.6.33 2.46v.02c.04.51.04 1.06.05 1.59v.04c.03 1.68-.14 3.46-.54 5.32-.05.24-.09.48-.15.72-.1.41-.21.82-.34 1.23-.42 1.36-1.01 2.75-1.73 4.15l-.03.06c-.49.94-1.05 1.88-1.7 2.84-.17.26-.34.51-.52.76-.64.89-1.37 1.78-2.16 2.68-.06.07-.12.13-.17.2a41.236 41.236 0 0 1-4.27 4.13c-.05.04-.09.09-.14.13a58.12 58.12 0 0 1-5.6 4.09h-.01c-1.13.73-2.35 1.45-3.63 2.18-.01 0-.03.01-.04.02-.33.19-.61.38-.95.57-.08.04-.17.08-.25.11-.71.38-1.43.64-2.15.98-1.05.5-2.09 1.02-3.15 1.43-1.2.46-2.4.79-3.61 1.14h-.02c-.65.19-1.3.4-1.95.55h-.02c-.92.22-1.83.4-2.75.56-.85.14-1.69.23-2.53.31-1.08.11-2.15.23-3.2.25h-.01c-.1 0-.2-.01-.3-.01-2.3.02-4.51-.19-6.66-.58-.09-.02-.17-.04-.25-.05-1.81-.34-3.53-.83-5.18-1.46h-.02a26.38 26.38 0 0 1-4.64-2.3c-.13-.08-.26-.18-.39-.27-1.12-.73-2.19-1.49-3.16-2.38-.25-.22-.45-.48-.67-.73-.57-.57-1.13-1.14-1.63-1.77-.24-.25-.5-.48-.7-.76-4.76 2.88-9.59 5.81-14.61 8.81-.07-.1-.14-.17-.21-.27-.07-.08-.13-.16-.2-.25-.78-1.06-1.57-2.04-2.38-2.93-.38-.42-.77-.78-1.15-1.16a30.6 30.6 0 0 0-1.81-1.66c-.43-.35-.85-.69-1.28-1.01-.6-.44-1.21-.83-1.81-1.2-.2-.12-.41-.24-.61-.36-.01 0-.03-.01-.04-.02-.2-.12-.4-.25-.61-.36-.76-.4-1.52-.73-2.29-1.02-2.14-.83-4.29-1.31-6.41-1.48h-.03c-1.61-.12-3.2-.08-4.75.1s-.01 0-.02 0c-.62.07-1.22.18-1.83.29-.06 0-.13.02-.19.03-.3.05-.6.1-.89.16l-.22.06c-.13.03-.25.07-.38.1-1.02.25-2.02.55-2.98.88-.03 0-.05.02-.08.03-.13.04-.26.09-.39.13-1.29.47-2.52 1-3.68 1.57-.07.03-.14.07-.22.11-.05.02-.09.04-.14.07-1.57.8-3 1.64-4.23 2.48-.03.02-.05.03-.08.05-.04.03-.08.05-.12.08-.27.19-.42.44-.49.7-.04.15 0 .29.02.44v.08c0 .05 0 .09.02.14.07.19.19.37.35.52.12.12.27.21.43.28h.09c.12.03.25.05.39.04.07 0 .13.02.2 0 .87-.23 1.83-.45 2.81-.65.18-.04.34-.09.52-.12 1.07-.21 2.22-.36 3.38-.48l.59-.06c.16-.01.32 0 .48-.02 1.28-.1 2.58-.13 3.91-.07h.04c1.31.06 2.63.21 3.94.46.28.06.56.14.84.22 1.02.24 2.03.52 3.01.91.3.12.59.3.88.44h.02c.92.43 1.83.87 2.7 1.46.42.28.79.67 1.19 1.01.74.6 1.48 1.19 2.15 1.94.97 1.08 1.89 2.28 2.69 3.72.62 1.11 1.01 2.29 1.34 3.48.18.61.3 1.23.41 1.86.16.95.29 1.9.29 2.88 0 .6-.07 1.19-.14 1.79-.06.49-.15 1.3-.24 1.79-.16.86-.34 1.71-.6 2.57-.26.84-.56 1.67-.92 2.5-.37.87-.82 1.72-1.29 2.57-.16.28-.33.56-.5.84-1.62 2.68-3.72 5.2-6.27 7.48-.63.55-1.24 1.11-1.92 1.63-1.83 1.42-3.77 2.75-5.94 3.85s-.01.01-.02.01c-1.27.65-2.56 1.22-3.85 1.76-.05.02-.11.04-.16.07h-.01c-2.69 1.11-5.42 1.96-8.12 2.51h-.01c-.09.02-.19.04-.28.05-5.24 1.03-10.29.87-14.5-.94-.15-.06-.28-.14-.43-.21-.83-.38-1.62-.83-2.37-1.35-.16-.11-.34-.22-.5-.34a16.09 16.09 0 0 1-2.37-2.17c-.1-.12-.19-.25-.29-.37-.61-.73-1.17-1.55-1.68-2.43-.14-.24-.28-.47-.41-.72-.55-1.05-1.06-2.17-1.46-3.43-5.86 2.13-11.77 4.07-17.76 5.63s0-.03-.01-.04c0-.02-.01-.04-.02-.06-1.08-4.1-2.72-7.27-4.63-9.85-.2-.27-.37-.61-.57-.89-.18-.24-.37-.43-.56-.63s-.04-.05-.07-.07c-.45-.51-.9-1-1.37-1.44-.31-.29-.63-.54-.94-.8-.39-.32-.78-.64-1.18-.92-.34-.24-.68-.47-1.02-.68-.41-.26-.83-.5-1.24-.72-.16-.09-.32-.17-.48-.25-.18-.09-.35-.19-.53-.27-.5-.23-1.01-.43-1.52-.63-.02 0-.04-.02-.07-.02-.01 0-.02 0-.03-.01-.22-.08-.43-.18-.65-.25-.79-.26-1.58-.48-2.37-.65l-.17-.03h-.06c-.75-.15-1.51-.27-2.25-.35h-.12c-.07 0-.15-.01-.22-.02-.73-.07-1.45-.11-2.16-.11h-.19c-.79 0-1.56.03-2.31.1h-.13c-.25.02-.5.05-.75.08-.98.12-1.91.29-2.78.51-.12.03-.25.05-.37.08-.32.08-.54.27-.69.49-.14.21-.2.46-.19.72v.01c0 .07.02.15.04.22.03.16.1.3.19.44.05.08.1.15.17.22.03.02.07.03.11.05.07.05.16.08.25.12.07.04.13.08.21.1.05.01.09.05.14.05.08 0 .17.04.25.05 1.72.17 3.62.49 5.55 1.01s.08 0 .12.02c.07.02.15.06.22.08.87.25 1.73.55 2.59.89.04.01.07.03.11.05.85.35 1.68.75 2.49 1.21h.02c1.67.95 3.21 2.16 4.55 3.68.25.29.5.57.73.88.77 1.01 1.46 2.1 2.02 3.37s0 0 0 .02c.02.05.06.09.08.14.02.05.04.12.06.17.27.67.51 1.43.7 2.24.16.67.29 1.37.36 2.11v.08c.07.69.08 1.41.06 2.15 0 .18-.02.36-.03.54-.03.58-.1 1.17-.2 1.77-.03.19-.06.37-.1.56-.14.7-.33 1.39-.57 2.09l-.06.21c-.59 1.63-1.49 3.24-2.74 4.77-.06.07-.12.14-.18.2-.6.71-1.29 1.4-2.06 2.07-.06.05-.11.09-.16.14-1.71 1.44-3.85 2.74-6.5 3.82-.18.07-.39.14-.58.21h-.02c-1.14.44-2.38.83-3.71 1.19-.4.11-.79.21-1.2.31-1.64.38-3.36.73-5.28.97-2.13.27-4.25.29-6.35.2-.21-.01-.4-.04-.61-.05-2.03-.13-3.98-.43-5.86-.9h-.01c-.21-.05-.43-.1-.64-.16-1.27-.35-2.47-.79-3.63-1.29-.16-.07-.31-.13-.46-.2a22.76 22.76 0 0 1-2.99-1.67c-.2-.13-.38-.28-.57-.41-.88-.64-1.7-1.33-2.43-2.1-.14-.15-.26-.32-.4-.48-.73-.83-1.4-1.69-1.93-2.66-.16-.29-.27-.62-.4-.93-.49-1.07-.89-2.18-1.13-3.4-.26-1.14-.44-2.33-.4-3.64-3.4-.53-6.8-1.21-10.17-2.01-2.93-.68-5.84-1.48-8.74-2.41s0 0 0-.01c.8-1.94 1.34-3.78 1.67-5.55v-.03c.32-1.77.42-3.46.34-5.07-.05-.96-.15-1.89-.32-2.79-.02-.13-.06-.25-.09-.38-.2-.92-.46-1.79-.77-2.64-.02-.04-.03-.09-.05-.13-.06-.17-.13-.33-.19-.5-.3-.73-.63-1.44-1-2.12-.06-.12-.12-.25-.19-.37l-.03-.06c-.45-.79-.95-1.54-1.48-2.25-.11-.14-.22-.28-.33-.41-.03-.04-.06-.07-.09-.11-.41-.51-.83-1.01-1.27-1.48-.02-.03-.05-.05-.08-.08-.18-.19-.36-.39-.55-.57-.43-.43-.87-.83-1.31-1.22-.08-.07-.17-.15-.25-.23l-.3-.27c-.58-.48-1.16-.91-1.75-1.33-.12-.09-.24-.16-.37-.24l-.54-.36c-.32-.21-.64-.41-.96-.59-.03-.01-.05-.03-.08-.04-.24-.14-.47-.27-.71-.4l-.21-.12c-.29-.16-.58-.29-.87-.43-.28-.13-.56-.28-.83-.4-.3-.13-.59-.12-.85-.05-.05.01-.09.04-.13.06-.11.05-.19.14-.28.22-.07.06-.16.09-.21.17-.03.04-.07.08-.09.12-.13.22-.21.47-.19.72.02.14.14.27.21.4.07.13.08.28.2.39.3.27.61.59.92.89.01.01.03.03.05.04.46.45.91.92 1.37 1.42l.02.02c.04.05.09.1.13.15 1.07 1.18 2.09 2.51 2.98 3.96.06.1.13.19.19.3.4.67.75 1.36 1.08 2.08.06.12.14.24.19.37.02.04.02.09.04.13.41.96.72 1.99.97 3.04.03.12.05.24.08.37.28 1.3.46 2.65.42 4.07v.02c-.01.13-.06.23-.08.36-.16 1.66-.47 3.2-.97 4.59-.39 1.12-.98 2.06-1.56 3.01 0 0 0 .02-.01.03-.18.28-.29.62-.48.89-.45.63-.99 1.15-1.52 1.69-.4.41-.8.83-1.24 1.19-.57.47-1.17.88-1.8 1.26-.54.33-1.11.6-1.69.87-.63.28-1.23.58-1.9.8-.53.17-1.11.23-1.66.36-1.15.25-2.31.45-3.53.5h-.02c-1.05.05-2.11.05-3.21-.05-.56-.05-1.11-.14-1.67-.23-.37-.06-.74-.17-1.11-.25-2.33-.47-4.68-1.25-7.02-2.38-.49-.23-.99-.37-1.47-.64-1.3-.71-2.54-1.52-3.74-2.37-.35-.25-.68-.51-1.01-.77-.86-.66-1.68-1.36-2.46-2.08-2.71-2.53-4.86-5.44-6.18-8.58v-.02c-.41-.99-.88-2.67-1.14-3.71l-.04-.16c-.23-1.28-.36-2.58-.28-3.91s0-.02 0-.03c0-.02.01-.04.01-.07 0-.03.02-.07.02-.1.11-1.41.38-2.84.89-4.27.52-1.48 1.26-2.97 2.25-4.46-3.83-3.77-7.44-8.11-10.82-12.78-.67-.91-1.35-1.83-1.99-2.76-.32-.48-.63-.97-.95-1.45-.92-1.4-1.82-2.8-2.67-4.23-1.98-3.27-3.81-6.67-5.53-10.15-.16-.32-.31-.63-.47-.95-1.7-3.51-3.27-7.07-4.67-10.7-.1-.25-.21-.47-.31-.73-1.03-2.52-2.32-6.21-3.47-10.73-.2-.75-.38-1.5-.56-2.26v-.02c-.12-.54-.24-1.1-.35-1.66-2.87-13.2-2.63-26.27.28-38.46 0-.04.02-.08.03-.12a89.26 89.26 0 0 1 1.63-5.87c.05-.16.1-.31.16-.47.73-2.25 1.56-4.46 2.47-6.64s.03-.08.05-.12c1.5-3.55 3.22-6.99 5.18-10.29.02-.04.05-.07.07-.11 1.94-3.25 4.07-6.38 6.43-9.35.1-.13.18-.26.28-.39.54-.68 1.25-1.43 1.85-2.14.58-.67 1.13-1.35 1.73-1.99.92-1.01 1.95-2.02 2.99-3.05.63-.62 1.27-1.24 1.92-1.85 1.04-.96 2.12-1.91 3.27-2.86.24-.2.47-.42.71-.62.45-.37.9-.66 1.35-1.01 1.38-1.08 2.76-2.15 4.26-3.19 2.27-1.58 4.54-3.03 6.78-4.31 1.65-.92 3.34-1.8 5.1-2.62.84-.4 1.67-.76 2.5-1.12h.02s.02-.02.03-.02c.5-.21 1.01-.41 1.51-.62 1.88-.77 3.74-1.44 5.59-2.03s0 0 .01 0c.31-.1.61-.2.92-.29h.01a71.54 71.54 0 0 1 5.39-1.41h.03c1.75-.38 3.47-.7 5.17-.94.07 0 .13-.02.2-.03 1.66-.23 3.3-.41 4.91-.53.1 0 .19-.01.28-.02 1.62-.11 3.21-.17 4.77-.18h.22c2.12 0 4.18.08 6.18.25.25.02.49.03.74.05 2.71.25 5.28.63 7.73 1.1.15.03.3.06.46.09 2.42.48 4.71 1.02 6.84 1.62l.21.06c1.73.49 3.36 1 4.87 1.52.08.02.15.05.23.07 1.34.46 2.62.92 3.77 1.37l.11.04c-27.53-17.76-77.17-11.4-104.28 19.49Z",
                            className: "octopus_svg__cls-10",
                            style: {
                                fill: 'currentColor',
                                strokeWidth: 0
                            }
                        })
                    ]
                })
            })
        ]
    }));
var $85b17b826eab10ce$export$2e2bcd8739ae039 = $85b17b826eab10ce$var$SvgOctopus;





parcelRequire("7fPBF");
const $4262604d9c082a54$var$SvgOffice365 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M31.547 2a1 1 0 0 0-.283.055l-25.59 8.799A1 1 0 0 0 5 11.8v26.398a1 1 0 0 0 .006.1 1 1 0 0 0 0 .002 1 1 0 0 0 .039.193 1 1 0 0 0 0 .002 1 1 0 0 0 .078.184 1 1 0 0 0 .18.236 1 1 0 0 0 .076.066 1 1 0 0 0 .168.11 1 1 0 0 0 .09.04 1 1 0 0 0 .002 0 1 1 0 0 0 .035.014l25.59 8.8a1 1 0 0 0 .582.02l12.412-3.3a1 1 0 0 0 .742-.967V6.301a1 1 0 0 0-.742-.967l-12.412-3.3a1 1 0 0 0-.3-.034zm.078 2.045L43 7.068v35.864l-11.375 3.023-15.871-5.459 15.115 1.996A1 1 0 0 0 32 41.5V9.6a1 1 0 0 0-1.201-.979l-16 3.299a1 1 0 0 0-.799.98v21.301L7 36.77V12.514l24.625-8.47zM30 10.828V40.36L10.158 37.74l5.186-1.9A1 1 0 0 0 16 34.9V13.715l14-2.887z"
        })
    }));
var $4262604d9c082a54$export$2e2bcd8739ae039 = $4262604d9c082a54$var$SvgOffice365;





parcelRequire("7fPBF");
const $97f91bf195707c03$var$SvgOpenCloseMouth = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m64.11 77.485-2.385 1.81A20.462 20.462 0 0 1 50 83.448a20.462 20.462 0 0 1-11.726-4.153l-2.384-1.81A29.356 29.356 0 0 1 24.662 58.81l-2.65-16.31c-.42-2.585-.603-5.244.183-7.742 2.526-8.019 10.747-19.107 27.159-19.107 17.584 0 25.917 11.088 28.45 19.107.79 2.497.603 5.157.183 7.742l-2.65 16.31a29.356 29.356 0 0 1-11.228 18.675Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M49.354 17.302c-15.5 0-23.211 10.42-25.584 17.953-.668 2.12-.537 4.464-.128 6.98l2.65 16.31A27.705 27.705 0 0 0 36.888 76.17l2.384 1.81A18.81 18.81 0 0 0 50 81.796a18.81 18.81 0 0 0 10.727-3.816l2.384-1.81a27.705 27.705 0 0 0 10.596-17.625l2.65-16.31c.41-2.517.542-4.861-.127-6.98-2.363-7.48-10.157-17.953-26.876-17.953Zm1.772 67.736a22.113 22.113 0 0 0 11.597-4.428l2.385-1.81a31.007 31.007 0 0 0 11.858-19.725l2.65-16.31c.432-2.653.671-5.628-.237-8.504C76.676 25.703 67.803 14 49.354 14 32.03 14 23.299 25.757 20.62 34.262c-.905 2.876-.669 5.849-.238 8.502l2.65 16.311A31.007 31.007 0 0 0 34.893 78.8l2.384 1.81c3.373 2.56 7.4 4.091 11.597 4.428.152.047.314.072.48.072.216 0 .432-.004.646-.01.215.006.43.01.646.01.167 0 .329-.025.48-.072Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M44.485 65.156c-1.396.837-1.885 1.764-1.885 2.476s.49 1.638 1.885 2.476c1.362.817 3.351 1.376 5.637 1.376 2.285 0 4.274-.559 5.636-1.376 1.396-.838 1.886-1.764 1.886-2.476s-.49-1.639-1.886-2.476c-1.362-.818-3.351-1.377-5.636-1.377-2.286 0-4.275.56-5.637 1.377Zm-1.7-2.832c1.958-1.174 4.556-1.847 7.337-1.847 2.78 0 5.378.673 7.336 1.847 1.924 1.155 3.488 2.98 3.488 5.308s-1.564 4.153-3.488 5.307c-1.958 1.175-4.555 1.848-7.336 1.848-2.781 0-5.379-.673-7.336-1.848-1.925-1.154-3.489-2.98-3.489-5.307 0-2.328 1.564-4.153 3.489-5.308Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $97f91bf195707c03$export$2e2bcd8739ae039 = $97f91bf195707c03$var$SvgOpenCloseMouth;





parcelRequire("7fPBF");
const $6e649c234c8975d4$var$SvgPandoraApp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 6a1 1 0 0 0-1 1v36a1 1 0 0 0 1 1h8c1.645 0 3-1.355 3-3v-6h6.12c7.78 0 14.497-5.991 14.864-13.8C42.376 12.89 35.728 6 27.5 6H10zm1 2h16.5a12.483 12.483 0 0 1 12.486 13.105C39.67 27.818 33.876 33 27.12 33H20a1 1 0 0 0-1 1v7c0 .565-.435 1-1 1h-7V8z"
        })
    }));
var $6e649c234c8975d4$export$2e2bcd8739ae039 = $6e649c234c8975d4$var$SvgPandoraApp;





parcelRequire("7fPBF");
const $6efa39f11e16b5aa$var$SvgPaypal = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.438 2c-1.051 0-1.934.762-2.157 1.719v.031S3.406 30.715 2.25 36.094v.031c-.172.86 0 1.691.5 2.219.5.527 1.133.656 1.656.656h8.563c-.27 1.219-.57 2.559-.781 3.531-.192.88-.356 1.594-.47 2.125-.113.532-.155.774-.187.938-.082.433-.062.93.281 1.468.344.54 1.098.938 1.938.938h8.938c1.074 0 1.933-.75 2.156-1.75 0 0 .535-2.41 1.062-4.844.262-1.218.512-2.426.719-3.375.207-.949.375-1.687.375-1.687.05-.215.094-.309.094-.313 0-.004-.098-.031.187-.031h5.125C39.79 36 46 31.555 47.656 23.813c.934-4.38-.183-7.711-2.312-9.813-1.88-1.855-4.461-2.738-6.938-2.937-.297-2.973-1.71-5.293-3.625-6.782C32.77 2.72 30.277 2 27.906 2Zm0 2h16.468c1.953 0 4.051.625 5.657 1.875 1.464 1.14 2.449 2.836 2.75 5.125H20.937c-.261 0-.55-.031-1 .094-.449.125-1 .648-1.125 1.187l-3.25 14.625v.063L13.313 37H4.406c-.152 0-.226-.04-.218-.031.007.008-.032-.07.03-.438.005-.027-.007 0 0-.031 1.16-5.39 7.02-32.262 7.032-32.312v-.032c.031-.101.09-.156.188-.156Zm9.25 9c.085-.004.082 0 .25 0h15.468a14.977 14.977 0 0 1-.312 2.188c-.742 3.476-2.246 5.851-4.438 7.437C29.465 24.211 26.52 25 22.938 25H18.53c-.152 0-.34.043-.531.063Zm17.625.156c2.066.184 4.18.856 5.624 2.281 1.653 1.633 2.579 4.086 1.75 7.97C44.208 30.32 39.017 34 32.408 34H27.28c-.746 0-1.398.332-1.75.781-.351.45-.43.926-.468 1.094-.047.191-.168.77-.375 1.719-.208.949-.489 2.187-.75 3.406-.528 2.434-1.032 4.813-1.032 4.813-.02.082-.183.187-.218.187H13.75c-.168 0-.227-.023-.25-.031l.188-.875c.113-.532.277-1.278.468-2.157.38-1.761.875-4.07 1.375-6.374 1-4.61 2-9.188 2-9.188.047-.145.082-.18.25-.25.188-.078.508-.125.75-.125h4.407c3.878 0 7.253-.855 9.875-2.75 2.62-1.895 4.425-4.805 5.25-8.656.187-.88.199-1.649.25-2.438Z"
        })
    }));
var $6efa39f11e16b5aa$export$2e2bcd8739ae039 = $6efa39f11e16b5aa$var$SvgPaypal;





const $2f65eb00043ec877$var$SvgPersonalLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "personalLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 88.734H899.28V380.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "personalLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#personalLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#personalLogoTransparent_svg__b)",
                                transform: "matrix(.97644 0 0 .97594 -38.322 87.774)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#personalLogoTransparent_svg__c)",
                mask: "url(#personalLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97644 0 0 .97594 -38.322 87.774)"
                })
            })
        ]
    }));
var $2f65eb00043ec877$export$2e2bcd8739ae039 = $2f65eb00043ec877$var$SvgPersonalLogo;





const $710403c951aed9ee$var$SvgPersonalLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "personalLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "personalLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#personalLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#personalLogoWhite_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#personalLogoWhite_svg__c)",
                mask: "url(#personalLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAEsCAIAAADfJw44AAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOzde5ylV1kn+t/zrPW+e1dVV19yJ9xMDPcgIYIBBZUE5IAcZlDnOOjxg3g544zoGccZP3LUYXTmI+pnjuPH4zjqzPHICModvBAkhIuIkAghCAmEJIQknU6n73Xf+33Xep7n/LHevWtX3+huurqrqp/vp9Kp3r1rX9b7VtVvr/2sZwHOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzjnnnHPOOeecc84555xzzm06dL4fwAXNzM73QzgNRH62OOecc86dN3y+H4BzzjnnnHPu6/Pg7pxzzjnn3Cbgwd0555xzzrlNwIO7c84555xzm4AHd+ecc8455zYBD+7OOeecc85tAh7cnXPOOeec2wS8M/eZ2Fz9188X7/vunHPOOXcW+Yy7c84555xzm4AHd+ecc8455zYBD+7OOeecc85tAh7cnXPOOeec2wQ8uDvnnHPOObcJeHB3zjnnnHNuE/Dgvp4M8L6RzjnnnHPubPBO28BZ7cuuAMavh8qt0gn+9VTY8T5OdM1j0cQnkx+Y+GTD8L7vzjnnnHMnEc/3A9hSdJSfdW0619Ena/51FOvNzMyY1+R5kZbBxBFqaAQKSLkhhhEOHmx3765DBQAl73a3Vj43MCNnPOdbAAUZyECKyKgDAoEMRFArX2IQMyOiU47OjDN4EeKcc845574BHtzXGa0GXD3RVYjICAIAUEANaiEziOWBrx3a/eiBhx4ZzC8uH5prFpYOPvpoXXJzlioE7l4KGCbeN6hiJOa2bcXMetTbNjOza0c1O/34q7/Jpqorn/ykqac+FdPTABAIFYiZVMBAJMBOZSb+RM/FOeecc86tEy9OANapVGY0od5dckzZDAAYVFqmCGO0hkHCg48c/sr9hx7ac+Bruw888ijUauJoZKKkBrUqBEgmoipEImIDGcxMCTqK00ScUgpEWXOoGaRiZoTMSCKZjDhuu/jS3vadT376Ux5/7dPxzU/CjhlMRUiLfkQYPz5e83To6Lx+dqfbvVTGOeecc+4kPCoBZzW4j25x4nOauGRcK1OqalRhhN177rvjC498+SsPf/Ge6YR+Ri2oW+1TMLVeVWvObCAikAKIIRKTZTUzNjCRERQw6rJvltzr9aTNqqnXD6JZVbMKMSURMyOOjZLGOGRbYW3ruP3Ky6559jMve8qTd3z7CxABAgLADF5TDe/B3TnnnHPufPGoBJyt4H7sbYgCXfxVVWaGAVmRCSsJd9939yc/fd+dX8zLQ2rSVBWrZMEQFMFQcVcGwwCDJ4P7WACN/1QC1mZfBgA1k/Kv3ay82ejKrAQhGGFg2QiZIMwrRldd+6xn3HB9//pr8bhdIMFUMBOikGE0vrs193J2eHB3zjnnnDsJj0rAWQ/u4yl2A9RABAaSQAwU0xe/8sW/+9TXPnfX4LFDO6iuh20PITJHYoaSgdeEbwYQaDWgW1dz0yXmEuhpdNd8bPYdZX0xAyDHvLwQmBFMS6DnQVKpq0N5kGbqK697xtNecP0l1z0Ll1yEirqpdxFUwYO7c84559w55lEJONulMmvarSgghqHg0OKDH/nE7R/+qM4t1QOZrevctlOxnjIOpqWxTMURQEnhVVg9NCW4g8eXKI0n448O7scL0qQAVPW4z7QEdzHrpuGNWtOWtSWzuk4MifTkZz/rmS97CZ79DEwRAhCgtFr4frZ4cHfOOeecO4kLKyqd9UWoOGbKWce9EhUYCmJIX7rv9ls+dt/f37FDQz1MMck0WFKKdV2FIE0TQByYiGKI5dbIUAUaza2PEm3pF0mCUbgvK1OZeBzciY89oDr53M26v5YbVyqdIKFmRgAgRiklriKY2iSxVw/aJtXVfB1nnvS4573yxtkXvwCVdXXwpRT+eNPueryROf5Vvx4P9M4555xz8OB+ZkpTdSupFQbA1CIzADMhMJSwJPmOu2591/sPPfRoT7TKWgmCIZj2KIbSNd26KfPIgYgCWSmVYaIKAAQAEZcimWND+epE+8me1vE7N5pZKXMHoGY6mvUHoAQVFdioTaWJUWZuSYcRSzWe98qbHv/Km3DFxbAWbAIKVU9VGQyDEZQAAq1tR1PaXYbTz+4e3J1zzjnn4MH9zIxjaOm5wijN1wEjMNDYwx/86N+9/2Y6vNwb5iniSsCGYACUDSGGAApgqAIYpXYi0wAipoBS7y6l9KVUrh+bXyfz+gmzOx0d3Ed/Z4yWtAIwM9Puv/LXsp51XBnPxmImjGHEYg/D2erpL37hNa/+Hly8E5rR7xkREZcSeiMoA+WFjQd355xzzrmz4cKKROtRKoNxbYwALVY+ftsH/+w9C/sO1tmmEWojqNSxqonJwFAAFUc2EE/OuDMANjAocgCUTCLBzDh0lTDHLjylY4L7cTLuMcF99PhX8/N4rr18YqplDes4uwtMR6talSCBllS0F9NU/YyXvPDxr/le7JpCzWDqNnYlSKnrOaYHvJfKOOecc86dmQsrEp3NRajjDZUUSIBg4fbPf+qvPnTgrntnNVKTmIiyxhCqfi81g+mqFxTExKYlr3MIJbWXspmS2gMxEbEpSAMM6PI91jm4T35S0ruYYtSFRmBZtdxLSfNgSpKlVy9UdqhH13//K69+zfeCFIHBALMyYRzTj7v51Cnz4O6cc845Bw/uZ04NBgRCA3xt3y1/9JaHvnBPL+kMV5WADLGkbWYljRz6IQZFafjYLUJVK3XtzExqAKoQGURqgHKAWfdPa5IrrVldCqzpKnMcJwjurEfPfR8V38eT7gBMjaFmqgQFWsliZqYZ1AQMIw8qVFdcctPrfwjPfQZqoCprV7ub6h7/mcZ3D+7OOeecc/DgfoZ0FEMT7vif77rrg3+b981t53oqVqpKhgpdGYwSuOIA6nEICoKyIcZIBjMLIGKLxGZGhirEACoPkgPM5KwH99VSeFsN7sTEtjo4Wnq6TwZ3MyqrVwlKyCrZtFTRZBMDa+CVyI/q8uNf8Nzv+Okfw0XbEQKYYIbwjZ5jHtydc8455+DB/QwJsKK498H3/eFbDj+we7vFKltNLG1mZgBlA9TITCGAjQylxp3Y2FCFiFEzxxDAoPLXyCGMjgixAVoy69q58dUgThPlMV2pzInbQRYTa1jX3Opk9O8CunYNIpW1bM9kZiBVQFVK9/esSgaBZZAwhqrLgdKuqRf98x+Yfel3YiqADAxhRbcN1XFq3L9u7bsHd+ecc845bNXgfnY3VFpjtAj1jre84+/fd/NFWlWt1kaRunIXAIEoKMhQVRVRqYLvgnugriQGo+AeGaXAHeiCOxlAWiL22Q3uazvPTMy4HzNaRrBxy3fq1qqKWVlcm7UrmzHqvlZhXQP4ujePfLii+pnf/LJ/89OYnUJUTEUBjg3uRy/wPU1bL9Cv43k7YeuNm9tczuw89/N2szi7P8c273H3cXDrZGueCmfxGyYlCRw4wDIoAgo8vPC2N715Zc+BfkalGhQRVJaZdn+im0SvqgoAkbEhgoICpGyoqtD1kwEC88SMO4XRN2cpfznqe5UBIjtuYcxkKD9efD9aOJ1BUEI2Gf+19I7MpmaqopioqEmwBFkhzJHSZbte+rp/Hr/j+ZgNqpk5jBbzAl21EetkS83TtPV+kHlwdxcCD+5bmwfWwsfBrZOteSqcxW+YrIg8SpsZzT0P/fGv/EZvbti3EAxsytb1ewkgNoSJnusxVjwR3Nm6poi9GACU7B6Zx0XqkSmAus1TTxDcGcd/ausa3AFkE117q2amoqqiZjraucnMsmombYnaftzP+Zkv/+6nvO61mK1AgAlGj60E9+4Be3AH4MHdXRg8uG9tHlgLHwe3TrbmqXAWN1oiQMveSQ0e+MuPvP+//clsi529ac0CnDC4j2fc2UBkVHq0G4iNDFUVSp0MGziMNka1LriXuw4bPrhjNPWuqgJFyeJm2VTMWsuNoa1o2KvC4y6+8effgKsuR3+cz88gqB9t6/0g8+DuLgQe3Lc2D6yFj4NbJ1vzVDiLwT0bagISHrj103/1X/5oV0NTFjRnhACATQEEIrIuuJdSmTKJ3osVSoinrgk6ETE0xoqhXXZnDqMi9cg0LpsJEwUx4+/Y8xvcj7pktQsNQaWrgzeCiGRTCiywNumQta3i0o7eK/7Pn8S3PBVTNQK69xW8v/taHtzdhcCD+9bmgbXwcXDr5CxMfG5hDNTlmyXhU7d8hAfKQm3bEpGK5JSyCQc2tZxSiapK3IhlRah6wzanJDmnnEQFYqQEBbc5JVExMmIxZO3+KauIqcKUIEZmpYSEzah8qNqkczkUkcL4I4ACKBKXjwCK3H1Sdn6NxGbChj7TjIXtGqYOrNz8678/+MCn0DLabhtWg8EMatBz+lycc8455zajeL4fwEYnrYQ6wNDmTFUgCQxbado4VSPUIGtEY8UaYgpQEFSJQYwkGQQxA4yIVIWYQzYlCmQCmGUBRQoKC0RGFIhgSgaAmRhHbWAEAAzYUR0ez7sAKm8xqCrMALIQzFRVGcwozyFODfSTb3nn4x5+6Nqffj1MUTNZN91utEXf+nHOOeecO3t8xv2kDCEEZKCPG//JK3ONuXZpyJZrbipepDxv7UrQpaCDmua0WWZtWSwisw6sTSTGKjCBKcFUs4mqZlNVLTsaZZOyk5GqqqioqplssGgOgCY/7OgPlBL/UvZDyrBIIRAxlIhSytFoysLUiuy99R+++Bt/gCMNclcqUzZ1cs4555xzJ7e5E9O6l4sYYKMehorHbrn9039zK7JeddVVYbqfoBfv2vG4x10ZiIaD4aOPPDJcWelTPPDo3oMHD80fOJQGw2hUgYKiNgqKiNJhhrnUxJMxERMFEBEHsrLUNYB6VVzdG5Vp/Hkgo3GD9XHt+9phWI8a98lbND36dUW3VVPp/q553PddVUoVUBKrq34yG+R8qIJdfcXLf+Xf4OIZVAyGMGjUTgfYOrXv57icaZ1snPF0W4PX/m5tvlan8HFw62RzH/JzGowMyBNVKjQxeLb2ajb65ODckYd2P/ClLx188JF99zxo8yvTCFW2KeNKAbUqMNiIKGKc3YkNDAoBVVjtFDlewNp1mxlNck/csR533jqc4Lua6PhvtrCd+WT/eMsmJSQRMxN0nd4FZkpGyMRDwqAfh5due9mbfh5X7EKEQhBrlDeAbG1wP/0zdOP8IPPg7tyxPLhvbR5YCx8Ht0429yHfBMEoA6JIhhzwlQfuve2z933+rrlH9lbJeuDaqCYKZNEoEDFCAAcQSAOMA6oQx80iR9ldwzjNj1rQKEHp+IH7vAR3AALLqiW7m6mYdReCymLchT6Wn3zxK//DL+LSWUAQQ9mMac1LI3hwP/82zni6rcGD+9bmgbXwcXDrZHMf8g0ZjFYfkubE3cagBGWIIjCWWxxeuPPmW+//zOfzgfnZVqfEiMbBnQI4kBG0MuLAFccw2i01EJXgjlJoTqslNBstuGMiu5cSmtIwRwQCSpKXRJamYv+aJ37Xm34Ou6bRI9B4up3POLVjI/0g25Dn52nbOOPptgYP7lubB9bCx8Gtk819yDdkMJoI7ipEXWN3AKrKzAAwEFgAMP+x2z/1FzfPP/xYX6mvVFtXM8Pg2oyhAcSBq8AB45oZO2qbp5LdN2Bwxyi7l08AKKxtW4QIpuWm1ao+SBnXXP7yX/zXuPIiVKuP4hs5MTfOD7INeX6eto0znm5r8OC+tXlgLXwc3DrZ3Id8QwajEz2kiaHW0RUFaGXuc3fd9t4PHrj7qxdZVSWzNm3r9/ohBNMyEx9AkQORkaGkeYwS+XibphN9904G8RMtWp0M8d9IcKfR0wIA1bJitVuoOlquKpIzLDOSmCkNVBaCzn7LU17wpp/Djj40SyTqXpDw6o2e1sPYMD/INuT5edo2zni6rcGD+9bmgbXwcXDrZHMf8g0ZjI5+SF3p9tqhFnQPPYKw3KIJ+MJXbn7rO+cf3LMd1YxR3yyONlst2xtFJiIiaOlIg7XZfQMGdwBG3TEqDTEBJElJsxCLGZSSaCN6uM9X3PRt173hx9Ez9KJCGYAH941h44yn2xo8uG9tHlgLHwe3Tjb3Id+AwUi7vHmsNUNdKr8BqGgVAhKgwFDu+8CHb3/nX88sNruUp5UBBFBkCsyBETkwGU+sTB1XwpyouOTcB/fuCU60jCx7wZZinmza5mRmoKBGSSyZrBDm6vC477juuf/2J1ErYgR5cN8oNs54uq3Bg/vW5oG18HFw62RzH/INGYxOoVRm4pHbODWXoJuA+x79+P/7Z4e/+JXtyn2lYIiEyCHCqhBCN+/eTcZ3jWU2fHAHoKRKUFgS0ZwVrAQ1EpgQL6stztTPfd0/ufRVL0FFCIDxmp6bp/4wzvkPsg15Hq47/4XhzowH963NA2vh4+DWyeY+5FswMJVu8S0efe8Hb/2f77ok0VRGv4rBtIcQQFTHEAKDSk93Khs5TRS74+jv5NUAzROXT17jdIP7yU+ayd2gyn6xpWBGCUpQMzVLklVVCUYQMwENs82ldmlb/Zpf+Gm84FpMc3nEZ3CKenA/N/wXhjszHty3Ng+shY+DWycnKOtw5wsBFdDHla96yQ/+4s8s75wazlTDCItBCI3mNufWZFR8AoFlUzGzzfDNW/aFBcDMR/24qUPc1Z+5TKpb/vBP8eghtAZmdHuwOuecc845D+7nhU18HFcAdvV7L7zun/37n8NVl80jDySlAGG0kJRyVlGYqWH0glvVNua8LzEDoBEuHxPBnZiIaJiGgZlzxqHFD//W72MhQ4AYNvl7Qs4555xzZ40H9w0qq6IGnvbEV/zSz/WedNlcpQMSIahZNmlyFpFsqptkrn1SKbVn5snSnX5Vm2Q21KK699CX/+QdGMjJXts455xzzl1gPLifOR2tvxRYEgGgaz8w6l/eXS1L9ydh9eMEIjMCoR9x2ewr/uO/6z39yUumTe7u0cyyqSnMSFQFBjAhwBjGptR9rJ2DL/Xl5WPy8omLz3xlKkolzPFzNq9+GMO6T9So9NZhA4MCEcfIzLTcfObmW/bf+kksCwySRfUbemDOOeecc1uAB/czVLZBVVUzC4oqBCh4FF67CGsIGcgGAIYQg4mGGE7pDkoCDkDFuHj7K37hZ6pvuny5Ty2bmgm0ZHcpk+4jx9wIb+RDHJg5MEaLeIapnVtenFuYX15YtMXBe/7gT3BwARkhhm7HWeecc865C5jnoTPFXLI7GcEIQ0UGVhRDYDDxkQiJMDQ0CUDZE/Tr17iPr6MMAqLh0m0v//c/p9906TJ1c89Z1cxEVcvi1BNl9w3MzHKWtm1XmuG+wwcPLS0MtUEVWgjU4pHld//6b0Ohqm3bnu8H65xzzjl3nm2O+uhznUcn743WXl6KYMoVMkDYe8cXBovLe3c/wmKP7n4krQwmb+miiy7auXNnnOo9+dqnbrtoZ++JTwAM3AV4MBBO8OppXBvCKtIGBCy3eHDvu970n3cs6ZRSrRQINXGEReJoMRCVzu6TDVuIbbIj5Fg4QQ+pU3k74CQnzVG9IFFegFj3VwOUkMmyajZdGQ5bSW07HKbcqrRELakYGbGYhbo6GPUVv/Avr7npxdhWWwaFr3f3J3/Y33DbrM31uuh88fZk7uS8HeTW5m0QCx8Ht042xyE/F98A5R4IMEAUkaGwnFDF7hujARSIwFf2fe0f77r3C3fv3f3IwX37+6EyEaixGKlhtBcSj7qolJsPVVgeLoeZ/o7LLrnmWU9/0jdfdcW1z8TlF6MGKgIDTGAqs/jWJqorAEBX3M0ABGgVn7vnLf/pty9NcVZDHxRhPXAEBQ4BREyM1V2ZANhpBvfJK6/t73709Y7z9Ws3jTUCEZWByCKSczZtyZalHeR2mNNKahQGNTNTIJMpWGBqMBNlHQZe3jHzs//9v+GyneiVe9XRHZ/2m0Ue3M8N/0XiTs6D+9bmgbXwcXDrZHMc8nMamGw0KlaysiAGCOa+9MDnPv6pu2+7Y3hwrm/cA1PODAQQGZsoG8wsYLXx4fgm2crWQ2KRtQpDyzmQxbD9ysuuu+lFz/iOG3DlJUiCSOixNS1VlQYygKDjR8QAMrCSv/r+D33uzz9wcYs+UBt64MooMhPxZHY/v8G99LoRqJhRCEmzZGkhi8PBQNNQshCGksotl+2ZBGYEMbJSxg8kxoDDs172khe98V9jCoBOrOj14L5B+S8Sd3Ie3Lc2D6yFj4NbJ5vjkK/zN8BqVcr4vkioK4l58PCn/+bWz3/qM8PDC1hpprhigEGkFkt0VDMztm7v0hKdj70LUmEyhWXVqq6T5F6vN8itVSSBLn3yE2646bsue8H1uGwH+oxAZa59/DYAY6Imflk/8sbfXLr7q7u4mgLVRhU4EEUKRBRoddIdp18qc+rBfVJ3W8arV2NqIY1Kq5nqaiU1C4OVYduMC2aU0OYS3LkL7mbGKmXprRLAQtBocxW97s2/uuuG5yDkibh+2utuPbifG/6LxJ2cB/etzQNr4ePg1snmOOTnLrjbqJC9xd7Pfen2Wz7x+b/91M44TcPcQ+wbm+Ykua5rk1xVFaAppRBDCaxsJxpQDWSqORDHGKFWc0g5kyEEKFMKWCIJF29/6guvf/4rbqRvegJiVwGv43zavRVAyMBjK+/4Vz+/c0V2KNXGFXHA6qR7ye5MRHaOgjvKQxvNuBvBIg8lDSUPJR1eWkhkQl1zzHHj+bZtiQhgM4OxQIw1wTKQQZliZs51OKDt9muf+m9/780ggDO6IfHgvkH5LxJ3ch7ctzYPrIWPg1snm+OQr983gJmtOe8bQHDgM1/6q7e+67H7H+oJB+FgYAMZBxBDAZCBkccZl4jKQkw2VMRViNaVbY+VyhclQyAOIKiZKalxIDBlgjASQyu2Ol5z/bNf8MM/gCddhmkGFGoiOYSoKmYWqh4Wmn23/N0n/+Ctl6Vqhqt+iGoSQCGEMt1eFqqygen4wX0yiK99i+CMZtyZwATjLFlFNdBCbpZzszIcJhXloAQN1HXCKW9SZEWJ+OUtDuO2bXtTdcs21zRpqn8k60pdPdqmI4wD2v6LN/zU63/kVVBTFu4qZjy4b0T+i8SdnAf3rc0Da+Hj4NbJ5jjk6/QNUFK7mZERMpAh+xb+8Lf+y8F7Huq31leyZFWsxgGxi8IGkNYRGHVmFDMASmUjIUBNZW1WJq0jA8oAi/VCxYZSzWIY7dxEABCYU07Siws9PO+VN173v70as33M1MhSFrCaKHGAAgvtx/6v3xx+5aGLqBfa3K8rAJGZiQNxoK5aJpDR8bZVOrvBXaACM7AxDdtmYbCymJtEZgRjMnBWFVg2MUDNSl27mQlMCAlolajfX26bNvCwqh48cnC5il+bX9jbNMO61xI98fGX/OMn3keKjNbM6tA7+cE9lgf3c8N/kbiT8+C+tXlgLXwc3DrZHId83WfcBdhvH/7T937ybz40Y5EG7XTdgxqbUlaMUjURcRdhtaR2JQWwtLLctT4kRAqD4UBE6qpevRtSQHt17FdVn2IFrkA1xwAqqzDLl8cYoNaLlZg1kKYmnZ161etfO/ui56NSTNddkbsqmGGEex595xt/9dJl7LQqmJbymMihBPfyMuMsBvfxewiTlxNTVkkijWaL1eJgeSU1SlhpGyUQMZgElFUUNn59UoJ7Nm1NhiZLTHP96YXYOzgcNnX9jw892AROkXhqaiG1wyS9eirq8M2/8u9e/9pXTQzr6fHgfm74LxJ3ch7ctzYPrIWPg1snm+OQn8E3wGoXxRNdUkrGEwDs+cxX3vY7bxnune+Llv7oJsIxam4jBzYtcROhFHUAwPLSkpIqQVjbnIShBCFwxUrYvn37pZdeOnnnqml5cWlhbj4kiYqZUE9XvZq4Zo6GoCDDVL/fNs1UrJumAWCRqV/PhXzFdU9/6Rt+EpfMwhKqgMACDW0L9O/8r//fY7fcvnOIPnFFfG6Cu03sY0phtZZ9cTA0pmTS5kxcCmM0K5QAY2Mtwd2IhTgxD4BFyJK0cxz2qN1/+PAigvSn5iVJjEmEIuecRYSZK82Xz/Y+eevNj5ulicL/0+DB/dzYquO8VZ/X2XLq4+PjcHIbc3z8+BYbbRz8fLsAbY6hOd0T6+h+LBOXBECzcAwyzIEjWnzg/3nrJz/wse1WV4qgYIOaMRGAEJm41HVIlpwtLw8GVRXbttXAqMKwHVhEyzZ7yc7n3PC8J15z9ZVXPeEJ3/oc8Kib5HgJJRmMoGgefvTBe+/fc98D93zu83vue2BHqHbG/sXVVA9BxLo2jmpsKK8KhDBkw46pV77+h7bf+EJMERiCZGaRajw2/4Gf/uVth4bbue5xYBATB+6WqJba+uMG9xOZXLRagjubjiN7eYfBCGrdMtMB6UIzWGzbQdswAjEZk4oKyFQFFrgCWEREUpKMOq6AVqo4R2E/Y0/T7h2sHBHJVd0YMlEC1CybKsHUAGTJCmPYdKBf/eVf+LEfvKk+gwr3rfsDbqPZquO8VZ/X2bLRAs35slXPEz++xUYbBz/fLkCbY2jOOLiHiUtK9owY9Y0hDO47+Lu/9p8Huz0djm8AACAASURBVA9jKc3W/agAQEzMoWtDbmbIOSeVVkVVc6vZSFuyYeQU9NLLL/vOm77rRd/zkvrqKxFG9ze5++i4K7wCgAmorKsUIAEZD3z4k1+5/bP333bnzlDNUKwUUCG1OlYYBWWIoFcdqfT6//Wmp/3w92E2glLXqH1Zvvxb/+PgbXdtE+6BIwUebZ4aiNj0RItTT+QkwV0JgBpBYALLqsnswPLi0PLQBCFWRmamZtlEjWz0BWrUmglhEChNTR0R2TtY2b28Ml9VcyEsMg85GGBmoqP7UjU1NWNoVklQIkJKVz3h8ts/+mcVUG/d4L5+P7A2y+Pfqr9INubzOls2WqA5X7bqeeLHt9ho4+Dn2wUonu8HsC6OrocZZfVVgiN37fmdX/p1LDSVgMs0dylkB4igQJacRIbaqGbVFBRVYCIaSEpT8aKnPeH7X/fDz3rRDRBFn2FAmNi5iQwgyyCC8moL9ozucQQgVECFq7/3RVd/z4vQYP6jn/38X9+ysnsvQYmsJgBQYgB1CJJMs975ng8tHzhy/U/+EC6fQTCYIsarn/HUx26/S2n0YuVsUyplNSqjJ4YQB+3gyGB5uWlbEw1sIaA0YlfNUCVuRQELCnBomJeYDzMfruJusX2NLmbQ7M6FpkngrMQEMOXSXobYTInIYEykAIVAamZGgR9+ZPefv/fW133fSzfiTxrnnHPOufW0NYM7cHSKXdM+MOGzf/X3b/2d/74thb7ydK+v1Bogo22EFJZTalObJGVLZdo7BR0iNZyvec4zXvnaH7j6u29ABCqU1uLZrCZiQAyBAJAYsmHfvvTgw7v375s7sH/+kYf2mFmEUVbKaiIk7bba6raZBV5w1dO2TW9LIaRWt81MS5sAMEAGSamua9OgWe7/xD/s27v3FW/8GeyaBhOUDz3ymOXMOONFm6c4nGwwJRjhwOHDQ8sDk8xsIRCTmFqWrqCG2MAZlokt8DDyAocDoo+l9rGm3UNhWFUWZrLkMDWjZjAlM9HugJUZ97L1rKnBGKRd8x8io/C7v/cHr/2+l/LaNzacc84557a8zfFmxGm/lTPeZJRgKPO4o4n3jDve96m3/9c/6Q3R4yooQLlrJU4UYyDipmlSSjk3ZiaaA8MqLGoz+/hLfuxnf+op33MDMhC7VwMCCAADqYVACmTD/n34zGe/eveX7l9cGTbNgCmEqtY2T7WpGi7Paq6Gy6Ft6nbIg5VekiC5b+gbKlWGBkUgA2BMmFhIKgTUvGhp5kmXv/gVL4vfet2BD33kjnd/8GKpeqUXJCgQR+JxqQytVgmd0ntPYZSHibh0zjFTMQPTIMuKpKVmMMitUFlmitYgppkMaixGahpCgmXYHNl+DvspHORwxLCsGFIYMDfluYiWYS/LXpMmdLvQmmm5365fpJkIRDVBiZFJhu/40/9x0/Of0WcASClVVXUqJ8VmeUvRS2W26lu3G/N5nS0brYTgfNmq54kf32KjjYOfbxegzTE0Zx7cGQAkS4gBYkh0+/s+8We//yc7qB8aY2Y2lGhLgc1MVVNKbduWog8l5YDWklR42fe/6tU/8xOoCb3R3p0EwBRgUAvUQCO498Hl227/wj337Alxtk3EYjVSpdlyU+dULa/Q/JHecNBvB5U0fckzYj0LFYMNxjbqA4NoimOCO4BYhRVpG2gTkGuuBLsSV61O9+sACuCjatzPOLgDACkRExGYllJabIcLzWAxDSgEJZSq9ESaVc1KExvOoBWmAYcls4Nqj7Id4DjP1QpxEksAmLOadWU1Nj6yqqkkdQA559GFWoK7kqqmSFXKDbR99cu/822/+x9Zlfk0Ct03yw84D+5b9RfJxnxeZ8tGCzTny1Y9T/z4FhttHPx8uwBtjqE5kxPLUCI5SnpXoJXbb/7bP/+9t9OiTffroBj3YQSpBlPVtm3btlUtX6fC2kSdvWzn6372XzzzxhvAQBxHdnQT+EBGpcDhI7j5Q5/58lcfTplVq36cNtGqGfYWF2cGi/XiPls4HNq8LcQZDixSZtb7asG6FpNcEYAAY4BM2UqXFmAiu2dLFEJmNJJQBahti73aKJgGcCBiEBvOSnC3kZbsscHCirStiEIVrAQ1U1YpDTUzA5yoXmI+UOmB0NuP/hHDsmpL2hJlUFYVkCKqqWhmNlEVyOQUe/kzi5hq6V1Tpt0NqRS5q4pqS+383Z/4m6uvvKQ8zmNbfx7XZvkB58F9q/4i2ZjP62zZaIHmfNmq54kf32KjjYOfbxegrVvjPjroDCADhH1feuBtv/cWzGFbb6fkxIEUICqBjwfDgUBM1AgKGJfUnq+45om/+n//Bi6bQQXYsfEwKgjAl+9bfu/7P7LSkOgMFMG4anO1tBiXF6v5w72lw9uahW2WKwWlZirWAGAMIBjCaNlsjYDRy43AxAYy8NoZdwpRRaKijj0osimrEYdgKKl98sEpdVXyp6trqkNo27zSDAaS5/NKjgwGURBRE8tkqmpsCs4hJq7nhI9w2AvdBzoS6xVE02yWzQzlR4MRCExsTAARWTASAphVpHuCRIE5qwJgIum+kIk05cTMoeqRTf31LR/52R/9wdN+Ym4j2Zi/ME7kRI/Wf8EUPj6ny8//zWjjj8PmOq9OZOOP83m0OYbgDE/E8TY9GfLI8s+/7l+FFe7zDMClV0qvqkk1Z2nawXKzAlI2BrTXq5Zkue3lb73x23/q196ICLCOWkwyxssiDUYYCP7ylvvuuOMeWK1Koqg5VE2aXRn0Hn1oauEIy3IvN9tgUcGGiigyl2oWAIGIDZFWI3ssryTKnZVKd5Pxc+o6vFAZEyWiEJjBtXUT7QDC+LCSEtlxp6LLxLwec/zZ0OasBFRhpU1NaldS06i0psIw0mwCNQBNaZdJ2oQ4F3pHQv8A1QfB84xl5sxVa1BVQM1UVUW1pHAKrOUCE3Tz+qIqNlqfKhBRVRUAYtRNupsIzEyJmNFe9biLbrvlHdOA5pZjPTrUJ9uZabPMTFw4M+5b4xfMhfZ8T9ex47O1x+FCOx8utON7IudrHC608ffgjq08445RpTsBLX7zl99cN71tvZm2lVHlu1rULNK0TdJRUTUpgKU8sOnwgz/xwy/9odeg0m7XIaAkfoCl9KghLLT403fcfv+DRyzMBpDmNBWrethMD1fkoQe2Ly9ODxZAbS9QJWBD4BBAJffz+HUAAHST6+PLabS4FmvP1PJZQLfklpkJHEDdzk0TXwUAxiDTY/q4d5tSHe/8b02pF9V0kJu5leVGpdGsgUFspK2ZGTFIYC14wDbgein0Dof+4bp3kMMiwgCUycRKv5jyhLTUxAPAxC6tTKTdjxgmMrCW7E5MbGTEZro66Y7SHJLNFBS/uvuxz9/32POfckUV6+4Z2WZ5Heqcc845dya2cnDXkhJbvPd33n7gvv09rtusXTwmAEgiTdtkaXIWUFcLLoymth/68R+58Yf/KWK5HACH7ssEgIIF2DOHd/7l7Xv2Llk9G0IlIr1+FZrhTDuID311+9z+vkm0HEIIYCJlplKz3m1EumarIyIC2bgP/HGUzVy7a3SrQbn8R0SQ437RCUeGCEdVz5cuMVaHocriYGluaSkTlFmroASBippaAKCqLdES05HQ31dPz8V6icJyCAMOGaSaYTZ62bRaXk9EPNFNn8pOVGajlyU0OU1Qrm/WvWkwjuREBLBpBvjt73z3c3/pDafUUMY555xzbvM73d0nN41cEqLh3tvu+dgHPkYpalIKa55v0zSSc84i0gJQQqlrf82PvvbG1/5TBKAK2lW282isuMy4H1rBH77lAw/vW0o0baFOYkSUlxdmm4E8/LX+3IHZtBKlCZEih9AF0bM8Ibya2s+Ijb5OR70dE+PQ8uL++SPz7QD9KDHkSMIQRlITIyPOHBdidTD2DlTbHutte6w3va+eOhzrJYqJWYlZmdE9ZS5daSb+GA9Fty3r2o1aqczHGxN3XwOAeTK1g4iM2Th86JaP6uSrHDqNDWKdc8455zadLTvjzgxW5MfyH//OH5NUFJhgucmlwSIRVCVJTpINhhCUzAhDtM/7rm//3h//Z6gAhpnYatlJmfblDMwnvP3mzy3ajHGPLKq0ZFpxtZ3Y7v/yzMF9VbtslqjXA3GABSYyJqJSD1NXNUaV6F1JzDGT7CWkjiMrSmN1lP6TiLEcuFEzFsNJy0SO8/LMGFzefSCknDVQNltJ6eDyUtej3SyrJDOFqVJOVvWmmjRcifWh/vTh2D8Y+0uxWiYIMRgMhRiU6tBTwlAaQAAys4BgYCZVqEBILYCsrDMwHTX/CUC33RIgKMNFREDZSHU8LGZGFMTy3gOHv3z/3muveVz/1E8L55xzzrlNa8vOuLMaGtzy3g/P712EcWnhMq7qNlUVTTl3CyI5JFFhPPEZ3/wvf+2NiLBgwiajZoqKLjxnYDHjnX/xmQcfW8jcQ4gcQIECaTVcxJF98fCBmWaxNqk4Utfnkc+gr8t6U9Gsmk2zqQZqyebawb6FIy1pIs2kCdpCVVXVMiiF6rDY/OyOPfXU/v6Off3th/rT81W/5ZhCWRugTFYqjsyM106olyl2DqM59VNYYlLm6MvnzEdfmWOtHP7y5g95qYxzzjnnLhBbNLgbwLSwZ/49b/sLpBpgZRUzgYAZzAJrNauZEcBUlk5SP/yH3/ttbAOCrV24yQAEGALLwK23Pbz7YGNUhxAokrBaRCTpLx3RfbtZF4klxsiBo2kwwKKhPvlQE48LSL5OnA0hhBBOfp1TGqGuVwsl0NDswNLivuW5AUkyldICpmyPpGZmwliq4v7p6a/NXvTVHRftmZ6d6/VzqIjJOBBCeeBGCjZhBRuPa2WOyu68mt25K9OfePajv018SVcwU65bPjGCGLLio3/7idQ9Ia+Tcc4559wWt0VLZQxIeNsf/TmlECkColTKTlgJYiqmjWRQSYEmrE0tb3zTG7GDkcwqjBoLMo+qWBRIwH0PDe780kOtTSsrjFVNRGKk2mxqZaE5sr+vEiIzuNS0TFptx94VhExcfkxcLyU6SuWr+ATBdPXyyVca4/DPtto+8qhHImpGyGSZsf/w4RVJbSCwqXRdd8QMxkI0CFiKUwfj1OL2nY9yb6mqBdEMVjrHjJqzAwQTdJ1ktJSim0rpBVOuSUQEZoZCTY2IcNLGVUQUjMQMBmYy4a6bjlkdowJfvveB/QvyhO2B1w7pcZ16X9it3U7r3Nva4+n9ht2kC+182Nrf3afOx+HcuNC+v45rqwX30m4FjIV7lz/78Ttrnh42w6leDwYFg1QlZ9MmNSJ5uq7atgXQcHrhq7/76d9zPXjU93HU/ZwIqsrMCiTFhz9xd9Ip5QqmZiQkxLECeikNvvq1i5q2T8YWjAzGRGAEYiOAEZkmMrqxQtnAJWarGVCmom3UA3LicwWYTQGoxfELAGIbZ3ejyWhv4/+FUgtUOsYwlSgfGTBroHO5PTi/ZGbCDEgSKVuXwliJTW0Q64O96UP96UO97Uv1VOLIzCLW9ewhMEgNQA0zI9XVlyvKzKYBLKxQ0nGb9qOQMcxKhbvAwBKMDdp1rycqrTJNFUQwFhgRZNiqSu7V//CPd1/54m8pk/gKLU3wv5FTyDnnnHNuY9pSEUd1tIpxiHe/9T19noHoaB1nWdnJAkvSimYAbduaWSahqfijb/gJBKScsLacOg0TcxRDI7jtc3PLTUhamkRyaVLOAEmaMfTaZto0Ggci6ua5+diSm1NktDrpPka2ZhfV437J5EdpF7NmiAgCW9HcQJctHWmWByKpbKVkBiUzE9PEPAxxsbftcH/H4emdR/oXzfdml2M/cTzOsyhLCIyZItGaMh5iXm0Rc0yd+gmeRrcgoawQCKCyRxUAQigvPNgQY9w2Pa1in77ts6M2+zzR/GcToBM49/d4dq3f43fOOecucJsm5ZyYAlqahpciDACH98x99CMf11F5BrpVkqVOxrJliJAhZ0Eg6fGP/B+v7188bWZVdfRax9irxWCElvCFex9YzmpMqhmkJaWQ6TS4XZqHaKn2LncXwqmOrY1myLvm57TaqPEbV5o5jsdBzVYgC5oPqxxYGQyScmCFKcxE2QBj5XoQ+EjV27Pz4t07Lz04felSf0ei1TdnSh/6ktI4ME8WqU/kNi77Q416OJbsflR3yPEfmIyVTEQMJiMY2CgYB+MIUmIjMkDN0kqzooJPf/K28t4EFFA+tj+Pc84559zWsAWC+ypVBQMN/uLdH4gUVRWAqkwWaSRty+UA6l5srZ3aNX3T970c3EXbUjwzVrJoC9x+5+75QWt1zb2qlQyAoWwIBrSDub2PMcq2ouNGKF9/CenkjPh6BE4jiJGYCUNgiKFlW7G8YnZoaWm5yQCYKzETIwMrYsP1cpw+XO/YP7XzwNTOw1PbF3tTbazk1M4UnlhaWtDa7H5Uyh9n95Pf6GpfzNK4hhSBY4ix6t1zz73dK58tdS4755xzzh1tq9S4GzBa9ogaH/ubvw0UYIAxcyi5LoSo2qa2BSlTIGiTGuvh1a99Dbat3lJd15M3LIZEaIHP3/fQkGtlEpG634MazEBaB55pdXH+SC9WaWW5ClzCvpkdN48S01EpvWR3Nki53AxAGD8vnLRF+9cdGIKUMM2UVOcHg4Vm0GYxUQLUrE1DMQKIuS+xWhSb780e3H7xyradwxCFWAwKi4ii3WrUGKKo2qicnZhMjYkEtjrpbgwgQAnlJQFKCx9Q2eK1VLGDQELEgBGZWWn2DlC5nhkbyIiMrewsK1nYLKkYhcDRREPgv//MXd/+vGt7gBrY47tzzjnntqjNHtx11FaFAWTVoPzpm+/MK1aPnhoRjafeRWT8lUbgXh13hFe89lU48eR4ICTgq49isQ3KMcGIwCGo5RKng2rPpMoJWRgB4/Wtp/tM6CSP4syZkjGpSZPyILdLaThQAcMMAZZNRJEBoWpoWFJemd05P7VjaWbnoJ4SM4UaFAYODKBkd2IKYNGuZoaZS5eYco9MLLY6zkR07Crw8YVEhO4TBrRsJaWiXQN8qMKCkZqQpUCWkChY0Bzqvskw57ZiUZPyYuEU3uRwzjnnnNusNntwx6hvIwBEZgAfv/UTlJgCY6I/OgARadu2WzYKGGOYmp/4338c9QlvGoCZMdH9ew5ob9ZyZjVFAEXkTEQMCqZ9Ys4ZmqvT77A+LmcnWy2bOckK1NPFzNl0IHmxHa5o0+aUTRUIgbJmUVXALAzI5qf6h3vbhrsuX65n28CmxgCMM2AQYCK7YzW7lxdOJbszqKwPLgO+2gKSiMEKLT1/GFAGGYPU1IgJCgak9PNhUiOA6lAFWJDh5Zdd9MQnPv6yS3ZeecVlvZqf8+xnVb3YWEopVUYvfP51YdRSU7Nw9PDunHPOua1pYwX3M+qEulobYQpS3HXnlyQDgTHqvUhMAhOVNpc1lgziTNqy3PTq/wXjJpLHfUhEy4ZHD8wttaM6DApGpRRES5F6BaOcIRNVImXfUDu27rrMx/Po9cba1uNdM/Lulo/p+85GqseJ9cfr8j5qZ4lATcqL7XApNQ0EDBWk1OYYS+LOiAuZVvozS7suarddNOjvaqnKlpGVjAFlQ/c8SEt2Lx3cjzPvPlo8cLxJ96Mf9HjSPZAI5aASSMzU1F50w/Me/8Qrn/60pz3pCVc877orKoBGhzkAybqK9xZtRJA85NgLRFDz1O6c25i8z7dz7qzYWMH99HWtA0t2JcWnbvm8NDbd22ZdDYZplhCjqjYqqCJV1crKUh2pzfmGG1+AXYQIOnEV+dBwZBn7jxwJ1c4kWbs7DSGq5mxMGqjJqapiu9wmUL/rO172YuXSbJ0AEMNYSYOxkAawQcu+RTT6ec6w8noAYBjBupceSsbGSsrGZjpOxDRK5wwSjHomGqoqpqRZBRXNDxYX2+FybhooApfNkJirrADXwrxE9aGZbc2uS4YXX7zMvWEmNSIExGDZACZIMLHRRk4cOGTV0asdpQCwWbdal8jEQGwEw6ipezNs+lN9ZGRtxSTGgISUc1XFpI3IYFuPr3/mN9/wrddd++xrn3vdN41fiBhWy4fGL4HqrmU7+qgBxNi177GTHEXnnHPOuc1vswf3tRR33Xk3UTBVoILBTAlmZgITWDZpV9pApEAm+bYXf9vJ68oViIT9R5YRa2KGMIHMGASiABIwDJxU2qQWK80KI5BRl9rXKMmypHWBdWtmrbwzsDpl3uV4YiWw6Si7g0d/0jETNwpmsjIZb4QmCQKDw4qkhTRcyk2CipmpQhSWTSmHqqW4wv250Gsvefzytp1LHBNHJaVRixZjhVqZGideLVUnYowm1JlIJmaSiAilroZYIOWhTk1P5ZSZmY1NEyzDZKYX+lP4zhd/9w03XH/9/8/em4dbdlXl3u8Yc6619t6nSzWppNpUKn1XlYaEQEICJHShFbwQOkXkivdTrt1FfZ774ffoVVHUe68NKCqPiqKioiKICNJIE4IYmjSkJy2pJNVXnXP23mvNOd7vj7n2OafaVEgIVafm79lP6tQ5p9Zea669d9411jvesen04yfgCIutQH/MFtP9fyEniB/jHP4LYHHXPvM6JI61dTjWjvdg5HV4asjr/D1kcQn3BrfcfHsMDIR3SG4TAoFm0YJZMCu9B6yxxnfcFc959mP2kRqwc3pGfWFULTQGk+QNUVHnYghUGRIzsV7hS8RgcoD8dkpr2mm1O+a0u2C/UnFyvR/iPTGf8r7gl1pln/7iMLR6ejDcOZgdSFOL0RgYGQgYjBSdJXcCM1NL3cqT6qLb0AnEi0TEuc1ShGAKbGT7RiUAdUrOF91FBFDSVJUc9ZICEKZhqCTUuyY0RKxKdCv3jGdc+KzLLr3yGeeYoVBoOhSBeljMPaaZTCaTyWQyB+DoF+5z4pWo+7jv3m9X2nWuSJHuc47wwBgYATQxEo0r9YR1q/S4x3BXGDAAoN4EJFQ1ttrYMBd9qDIEBzTxAhWT+SFKBhWhQV0KSxFokulMrZxpaxQizQ1qL0xlbhwT2hlSSMmNArFDSHoTQGBAzWb3YHb3bL9mNMcIwqLRIkl1VB06P110bPkqW7Jmtx+j70RSSQARe3nTRQUpnJ5CzrvV9yu6Y+G/mguKIRtFTOE/lHrTprNfcNVlz7t6oxcQKNsuVVggYFo45GSYTCaTyWQymYNw9Av3uVQZ4tabH2hqcQC8M6YcQyHEqQyamoJIRqtFGYwbLzgfeGxPhgJbtm03SpLdzquRAhqhSnWO0aGqZsnpuj+mQhqppmImIkYqlREiQkeLgKNQTCgRphQKQcTkbZ+zrM97uxUAzVLqDChxQWuqLOhJ1Whwbiixtrh1184IMzEKY4RIai+VBq4WH3xnVzFWr1ozGFuKzhKBa1hDIAIHNHsffhsC014ESbpcacNhJBnmMVd0F5Wmrn3h634tzonCkSJ1t5IXPf+Ka1549do1427Bkqczp4ArBHALkz0zmUwmk8lkMvtw1Av3hVrvqzfcKFII3GAwqIrSmVLMqEJEkqSRzvmGA1V33vnnQQ5pSRltP4gG1aSTRURkLjweqeIuVc+Pjc1s3xrLDuFNoAIDVWALAtqTdWdB3b19ivS1PTHFak5NODMcbJ/dEwURhNBIS2OdBCZuqH4Xy1ntTZxy5vTY1KyrxBxNKC4Z0yl7JcAkaY4DGdRERbiv051G55yIlKUf1jNlwbVrl73mVS97zhVn0dAt2sNNG8DCyB0CEhZsPmv3TCaTyWQymX056oX7Qh7e/GjpKgvwviCNBGEEaDCzCIuMRakxCsnzNm1coNp5QAnP1hMDAiYQFQHEC5J1JkXGqLIsJk9Y0X/0oT6tU43PRzGO2H+40j4Npkm7p8mpraP8ICzMfZx3CQki4449u3cP+1FBlUgSJBiE6UCGTnaKmx1bUqw5dWs53tfK4FXS0SmgkCCApINMm6Uln4xSrG2ObX3tc0V3QlI0pLReGm3qoXPN5Ref8oIXXHHl0880LDx2ArC2IVfbA2p7cxdegh34dGQymUwmk8kcyywi4U7s3L4rBqmKwsMhRBMDoES0mCJlAMRo4v2A/c5yB9cmLx56wyMZrQQoUUXMEcQoxcX1oePHr9ylN+4ZDCc6kyKtd0dTO+feRvo2HXL/3RfM9ZdS2gJ8W4wfleqR3CpJOidH+6jndfOOnU0MkULRYBYJMsXpSFAdOD/tO/3ekuKEk/rdqb4UUXyrn9sMSgAKMVGZm4EKQEW4oOau1Nh63A1piBIiQKE5ic5FkXjWpjNf8dKrNm1cWqQLnqZRdaLtvs8ffArSSUo+8z3lye36/17F++TsgsyxTH79H5t8r857fr19D1kMwr2NO4+4+467EX2ARVpP27K3CYyce5EZ2Fh9yhnr4FNhN3WxHticIUABdJxzwmDmFQoHjU5dUIMJaOYcxye7K1Y9FH0/1ltndh8/uUQJRjqICGLyhUOF0upymqbW09Y+DpW5SrO26eeSmkUNgEtm9gUjmQLNjChdE2MdmplBfzrWNBE61jSlgUoxIECnpdhZTcalK3XF6mntEKUThSmhQkDgwGhNaj/VkdGeZISJiEtCHUL4KHCkOmfW1GHWVz7W4oQWmsLVZ5+5/mUvueqSC1c3Boek0um9b48srajsF5Ope/0xWvhMJpPJZDKZzF4c9cJdIYDQIIrBoC5dNSoktx2rEDMSVBUPCdHqslOW3fJwDj21Tq48fnnxyEMd70NofdgUJ0KqpNp038S7sjhuSb0jzMTYqwd0RQk1M1VEIPlIBCBocz2oj4e5DHgHiFOnKk6GsemHenYwmG2aSIGoQkkGo4lFIKjbrX532dOVJzcTy2f8WJTSpSFSpm0Jv7150B6xKOcq7iKapqKKOJLJOiTiLEaalb6Ioe4UGAymT1q74mUvfd6Vl59SKAQodd/L8bkIy30luWBvyZ6r75nMU8RBx0XnWtp3gf1X+uc51gAAIABJREFUO6/zEyEP7sgcsxz1wj1JPxI7twWnbi7MMHm8ozB9Os4JRxVHi8uXL3/MBPeEA2IzZGy07LXPJw5KcY4hJE+LE0FVrjjltC3/uV2t7tfDTuXgXIzRqypTrGNSvm2+4xxpL9rIeUu+eQAQztfXZfSHikShCc1CQ+6Zme6Hug5Go0JN0IAmMCqBqNhTlNvHlnTXbRhUk7XrRHju3Rc7v4ijD0GS6hSARROVFIijgKmAcKbGSKMXNQuFoizrN1z78he/cBMILzAzi0G9/06r5rktNZPJZDKZTObALALhDgNUcf/99wNJ+1IgJnAHkubO+f5wsHzZCkQcemwqRhX3E1csLe542ApvIVjcK0+mzVoXmLplp2x44Oav94ZxZtivxJW9IhLBDKoglWQb9gJHHWUhzheY95mKmlR7Er+U9vcbmHo3CPXsYDBs6n49pIDqoIIAkkEYRAzaaNn3uqvsjZ927g6pzHUaOLKNt6HAxPZvosV+ZYwFRfc2bUbBomDTzDqJV17xtNe9/tlFiRDghHAiNIEyGqApo+bQK5z8+of+TiaTyWQymUwGi0C4BzNVBdA0TbQ4J0VpEiFpZml/WEMlGaybGMqybEJzmBVhAcYqeMVMPSgKV1vqFTWkXk6AQAjmxsb2zO4OS5YMt9V1DLuHQxE3XhQgjFaKCghCVEEIzEv61+3+CtsuUQE0DSwFhTARAGVZDodDs8ACwzDcM5jt9/vDpoZTgcICCVIoINmIG/pyB0oevyoed/wOTDTwjJ6iAgBmC9tDqQBExCUzjMCYOgKoTlP8u1FJs2CAFYUDhc30BRs3vPral6xd41Mrgab7CBEiHtLe3hA89l2NhZX+9HUW7plMJpPJZDIH5KgX7vtgtNToaQKlQpB6QDHSkqpOhGOd3mG6qUlMdjHe6cwMQYj33jhKMFQRA0F1WgPdJUtPufiS+//1n8Yr35jsGswqOihSvTzJWHUGiEQyeU/maDU12sxFXfA1gOn+jCsKODeMzfbBTD8ODIbCW6vEY7oACJQ+3LS4ftntrjl1undcXY5FlFHas9wObKK2iS6HZG4AalpX50lryH6vo695wyuf9az1qmm3DTCIb9eTQCu7yUPK732Ueqrok1TNbplMJpPJZDKZA7DYhDsAajtXyUZi3UaDlnTkfR8MBofpplaiKzjx+OVbv709gqpqEoyAUoxUBaUQN2yGNTG5fFn3+OX11kdgVsfGDWmCrhYmXg0OiKIgPNqBULog+iZ5YxZOa7I2Yd1MtInNzGBmT3+2LlhbI4B3nmS0SNIsimnjq35nfE9vonfyGdNlb7qJTp2JayMYxZK2FuKAJpk55greSUw7EQLDMHR+cP75G173upevmGq3R1Da7lKDKve6HHiMgvs+9XWzICKqQkbs5djJOj6TyWQymUwGWFzCXSOo0gaaUA8wxsigFgLQPLpt6wKD+6GGljqgAU5cPnnLfQ/DexFR7y0EUE0oIhAEi84XdDoMnePPPuuBL27rDvrjjoPYYGBRu+MeDl4B1VTwpoNE0GheFmp3FViS7HM1eECn+zMzg/6wGQQ10dKYrEFBnRJCoFHXN8dqSb30eEwtnR6b2hXY7Y7Z3FyjtsS+QFnLqPp+cBxEQKKhDI+bxBt/8PXnnrei40CYA6EC6oIkdmOa5zT/FPP9tfNwNNcqXUUEQHHfV7/WhOG6dSeVxx8vAJy27QW6mHX7wTIlvntOoZxikcl8r8jvvkwm86SwCIT7vLIj1AQOCoi1n5IEGFOaSwot9wXVtmzZhgjo3D8+qHY3oIlYsxzjFXdFg3pAVbw1kFQtFoOaERAXqk735NOKbz/U3H4bh1ELF4X9MAghStUjioIWwTL1zgIp5V0JRgAIoRER50VFh2iGTaxDbJomGCJgzkUADSE+gvDar5tgdM7NSLl7YkVn9QZdtjSor1k4782ScjaFITWYYjTDqTXnpzBIFTiIpcZYoSOlqeuy9LQw6O/qdMKFF5z+lh95foreRLtsNj+2aeHayV4XB/tK0DQRVYBd9Y6v3vwfH/vE/bfftXXr1m5ZkRwOh1VVTS5buuGs059z7atw9kmoA0qFIobo/OFdaWUymUwmk8ksUhaBcJ8nphlCMMjILgOAimR2JyBGqGoxHDSHKf1EMKaYdFh1XG/PtmiiqV4s4ggDCBVjGwgTnNuuxeoLLr7n4UeaPbubphZjSrfZMb276ztV4bu+NNCJiNDDKcSN9rSoPI21hcCmHwZ1iCFEiprBEE0jSZgBoDKa1lrGstxF+GVrJtedNeN7Q6cBEqkKFSpgwgPZ2TnS4PtV3H3hwzB6L81wpiiGq07svvbal56zcalrfz8tCr5D5SwAsPXO+/7yf79n+q4H/a6ZCVcudV0bhjisx8XLMDS7Nn/zgUe//rkvnXnF01/0xldjzUpUzhUpSP4pyu7N+daZI5/cw53I65DJZI4pFpVwt5TXPhJXcz2pnFfx8KUCes+37oWlOMjHEKDJsrIEOGvdyru232diJoAKVNVoqc9TFDQK4LwVvTBZrLvsud/69Ce1abzVMIVCfNG3pt8fTEM6zlW+KErvLMqoR1WJZjAkaRaiRZs/jAhBRIxsTKBQpSLQVAe+M9OZqNZuaCaWDarx2TrSrNvp1XWAoZ3SuqAH1trJSqPRVHO0RholGZugToTRd+M556197bXPm5iYi6Uc/f4h5etjKnpzsnPP7rXr16Hfrwq/Z2Z6++ZHxr2vaysjOq6IlDLI3Z+87revu+GaN7/2tFdcA6GUDrBU59fDep5MJpPJZDKZRcWiEu4pliSCoGmafDTCzCAGGE2iNYA+es+uFadNHVYoJOGJ9cf70movVS0KutbSHWkCSUV3gqJwfibE7rITVl10ydbrPquwkvQxxojG1CsgOj3oD13tg6t80TTN3M4rDIAqRMQEJNuOVW1lOAWBNJHg/KzrhKXH91au708s6WsRQHrnIXVdp1o791HbCxbjIIepImZWwwadMVx99WXPveoUbdPq45PlN4/gig3rfuF9v49BAAhRKBBsxxeu++rnrrv1hpsGe/odczqIY0Rg89E//POz77r7BT//Eyif+JNnMplMJpPJHMUc9cLdK+KBC8BqYq0ud8rYlo3rpvbOxyFvvunW555y6WNrUQKEAyYVZ65dccO9W7VzXN+MKkqlUgwigKjBlBBxrqgi3NjJp8XpPbvvuLkzs7vXWKkKQaAJ4Z1GEEmyz410haSCePLCJLNPI0YSlm4HlzQ2kN2Q6Wqst/5UXb5yj+sElKZqECgQ22ZRShuqI1xQZZ9j7zjIGExEyVAUoq5euWrs2tdfc9KayojU6isUyJOg2tOVFVRQpCgaAgEKdHXJcy++6qpnXLV9z7++909v+8SXxk1IqLGYGd70yX9ftnL50970WlQCJ6O8mr1uGTzxfctkMplMJpM5wlkUfoMICFavXs0R+/zcORXR9KPCF867oujdcuNt6ac0WDz4xqUt1TvggtOWTRXR4gCjyaki0kpkFWmlrZmTWFb1+MTx51+wZNNFu6qxmaIcCKMiCBpYEEZBIxzGpokhPYYWAuPcI30zhhAsRtEBdDdlq7nt5Vhzwuol5z0tHL9qd9EbuDKqEmpQUNsQyZGOnZPv+x4RMBfsQhN14j3LyiB7Lnn66W972/etW1M1oVFEwCTNS30yEJE0sSkqUSgqh0pQODhBr0RXccLUC97+tpf+yBunK2kYFdKD7zb4+Pv/Zvt1N8BEHytlMpPJZDKZTGaxctQL90iIAIaVq3siQpU2FxzRwDQGVNWpmz/S4Wwf0G/eclszAAgq4qG0oAIKUQWOr3DW6uWVBOdFU0eUahoepKoUmFh0IWoIanVRbC/Hx8/edMrVL9h93FS/8EPE4NAoamEtrB1q4RDWjB4BDGCQGMAIkoSRlCFle+TWbmd27drmnE3FuZdMTyztSyXiFSpqKlZAnIiIQCQqTIzSSnOTVqQzafqFDan0Io6MJv1Od3jta69+zeueVnVBwvtCxO0fqbkv3FdI24G9OAYYGRuryeggIBCGsJB2DYihGUCBjm541Quf99bXW6+MIZjFjslxtfzV7/wBRAGhhVxiz2QymUwmcwxy1FtlnABu5MEGQIUKOT/SKCEiAgcCxqLomMX77v12f7rxnUI91B1SCLbTnLQLXHjqipsf3FZrEaUwpzFGdU5IkKoEnFEMVLVgGp2nYHLVmvNe/NJ7v/CF7Q9vdjFUkCqGEvTtY9QyChgk9bpSBPSmMEFQnXFF98RVS1euihOTM9X4TnoHxzQHam4f2WYkmprYXNFd969PUyDzw1MNYt43q1dPXXvti05cCQc0sSl9QQPl0MNPDx9DBIKJoQiGosRMH488CgXGO5icQOmg9FQIIcR4efb3XXPrv395y013VqZi7Kqb3rb7pr/5x/O+/yVSFogNXPHk7Fomc3Ty1M8ByGQymcz3nCPrI/47j9uLgOGHr/31e+/Z6p0fDGbGqsqNRgM5YV0PYjMUpVhMZovo6h/9yTe+8gevwWEpwAioQfrAv9+560u3Phh7y4b0g/7Qq5NAjSSjMSKGyEaiCCFGCeasrmLokfWO7Y/eddf0tx8o9+wZj03XmsqCi1GZZrsKgCjRYmzggh+bFZGJ8YlVayZXrx1qORQXxTcQQo2ihNmc6UVpSbjvZY1RgjYamwogjnLYgRiHohQadHD55We/+MUXVF24NjSTe13ztCb5/V4q+5yr+YlRo+eYowkwxe4GX/761ptvm35468yjWzSSlH5T91YsOe7UdSuvuBjnnoZKkfLa+xG3P/h/fuynx4csowGYKWGrlv34+9+LDlAoQsrd0Tab8glcgR6+0Hlq4iCP9gFM++//sRmj+b1ahyf++nly9/O7vQ5H2vFmnhryec8s5JgqWBz1FfcWBYjueKeJjRS+6HRBUCzlq4BKCilCAZKfXYV68zdufWW4hgI5rGUwhesAl5w2tfmRbXds26md47wKAFVnFiACCkRdKCgRpKjAaxPLIL4vKJedcOLUsnDyKd1+f/jI5u333/PIo1vHfCUwppJ+MZrMqm7lhjOWdCcwOT5wfpu4IJ7JSt+W2blAoc+JZMNoxlH7d5n/WrhQaZtoJIbdMbn22pdt3DjhFWlpDjBv9juirf83EYMaQ+74zBfv+8z15fbpXpCqiVPRpAGgpuXgoZmdj9z04C13nPmiKyZe8mwQUAcRnLL2tGdc+MDnvlJGmKCImH105+zn/qP3zAvRn9l8+51CgBoVq887F1O9w7sAyyxa8v/IM5lM5sklf64egRxZ1yjf+QkmEPGuX/rQxz7yOYPCpOsLT0sVaC8yrPuxbtSZYAgA9CbmOsO//egHxla5w9h6KiW7YBgqtjT4u8/eub0ug/raVKSIganpFBbVokVjjDAqAKNFEzMwOjMfo6sbbRppGjTBNcERJgagDo2IaOEFjvCmRePQZ4xGIZxBSFDTKhkpC7wyey1dqsRTgTaqJp3m9vepkNDYjrPPXvv9r3nO8qUAIYQRAEW4MFp+joO+e+dHMo2eHAAQ4rB0FXYH3PPw7X/y13hoWzW0HgSMGqMa1RTQCIsCln7Wml3HdTa+9dX6tI2oFACauOsrN/7p239xcgioBLCGuapAVQyHQ2sIwERrhxPOPv3N//fX4IiO7LMzh0OuuD+55EpzIq9DIlfcM98N8nl/ajha1jlX3I9OBGNjVbRGtCrLAgaDKkAYRefm9izwvmto+MmPf/rl1z5PeofY7sLXHL2KgFNOnnnuKf/2n7f3ped9FVPiOkGqE4OKQg0gohlVRUxMQKgphoCWXnyHZSOEj1TCSIzSEoM1YiLUGGigK8pQ1z7Zfp7AG0AJIggMYtDB97/8qmc+a7UvEFmrOVFXKOpgC7t4D4v93iwKgCjNYbau//0/b/zbj01t7y+XQgJhIWXSp52hiUWoU63tOJOwu777+q+ddsEmNEQhZDO16ZzGIYAqIoYu1A/JwbBrtNi6gvoFHrn7XgAQGdX5M5lMJpPJZBYhi0DmzM8YveTSC4tCRGXQrykOgEEBFXFFUUJdE0nonMkkBv3kJz4jHQAHzBhcGJiSdH8EgkOcUpy3Up91zjpnQ1840eicic7no9veFei5WEaKAhoVQWHOmXONdwOVoBpUo3PROWhh6ijQQrx4BlRSKjzoRYp0OEj5kyNwwMtNMQDOexE3HDQiBIYq0yed1PmJ//5fnvuc1Z0CHqikcI5OzADvnUAE4iAOIns/xWPTLpihiZgFP//1W/7iIyt2NpNwjAEwURaUgvP77L14UGMofdER/9Atd6IfYQApZQEva08+yVIcp9BTNNIZHEQdVFUVqjqxdEnrsDceYfeQMplMJpPJZJ40FkXFXQxUCNauXdkf7Kk6naLwAEycMqUTKsU7VxobQAlL1hRS7rj97gdu37L2rOMP53nm6rkKK4I+bcPY1sHKmx7cGsSZqIgSiKAKyDZ7UQTClK1uphSmUJeF21SqRFLS7FWkeMtoiO1zpe+3GY4HGXp6IEgCMQYKrPBGTve68fnPv+KKK05ye592nd/y476QO3A3agBuuvPLH/iHNUNUg8Z5VUL23nkRhYCj71m0oNYtJ6Ctc4kCSZc9JEbrkJaOI+sPqCa27MTlAOCgRZbtmUwmk8lkFi2LoOIOoK0un7BKJo6bIJmmEaWBRIAjqeLEKUWtzWU3iKkDjO99zx8B+1TcOWrynHskNEIN3qCFQw+48uyJjWvGur5JVwIiIk6hIirS/kfgCKU5MGlPZfqRg1fxUFkY2CIiqpQ5d7kYxASmNBWYmKoDTPWxT1yqlPtSnG/Kbv+U05f99P943XOeM1Lte+Wv6+jxOJjLa+eCJgAQiILtu2/724+unKGra18UcycIMNtnJpRYVIuKWuNQ44oN61C0HbVJozvCwbkUyalGNbi0PgaAalGx4ewz9jpLmUwmk8lkMouRRVFxTwjEY92Gld+88WE1Z84LTQymMCjEKM650hgNqjAAKmLmPv+Z63fcP1yyujq8p9Gk6J2AwFLg2WevGIi7/aEdsyEG9QBIEVh7vQADnCidiYmKQC1CoBj5TwgAIkLQRv2g1BTGPsqmF1ANAKx13UiSv3MTUucaSZkc5qOZSxJi7C9b2nvZS198zjlTpYIG2Xf2aLshfVz1/AOSKuQNdtxwS/PAI0sHBFD1inrQjG4y7HNtYCYmogGGwtclNpxzGooInau3q1Lbew5plUb3KxQALYpGwdpTN6AgjIgKPeoVfG6Z+s44/Fzzxb3CeR0yxwL5df7UkOdFHIEsgor7qFosgGLT+WcQjXMuxgAoBTSkGrx4l8rhJgjiTTRGwKTC2F/+6QcBWASISBgEYDvQc69nUge4uVlPgAA94BVnLXv+ORuO87VHv/AeqsZYlh6O5tREVcoCvqQ4M6/ihBRQnKXivFKUKfgdYm2p3qkJgsBUgoBeKY6uMKj6kqLqyygaRYOqqXOFF5HkgBdVatAyFJ2ZF73o/P/xU6/cdO5UUvaSdn2fGwn7LuXjWnc4pLUHADTEDO7//Fd6lGT67/dnnMFZurRIQlyVWGCdt6oqAojxsfLijehoexWiDsN68+aHRSUueAYASpSuSIk9dV2vOu9sCHPRPZPJZDKZzOLmyBLuchAO998rzjz3VDIGmkEjaSQFcSTAxXmDpg5RUL0rFE7o/+Wjn5zZ2ihg1kYptitzyAt1BRxCB1YC556gL770jOVlKMN0xUZhgC3ws6igEHGAtqV+kdYEr5wvIS9cClXd+8CTsdsEBk05lxQQbWBOiBEAJNBmRGZFps/fuOZnfuIHXnDVuWNdqLRzjb5L7HWgD22J2/c4A2ALj8Bkr0MkGSEiStquwezOjm58+QvRU2MDrzAi4pZPfNqGNTCv8uec7gIU0ELdmrWrMDUGJR4rD+eJvroymUzmSCV/sh2b5PN+DHLUW2Vsrz/14ksu0EKdKRZ0MZJmIiqiqfGRrSukrpui8CIMw+Yv/vRvf/jHX+fHDnYpc5C5oQKFFeSkuDOmsOy5Z3/x6w/cvXnHHi33zPZ7nXHGOnk+zDmTghCxCAXTUFMBDCoASaEjJTViAgKaUqOhzV8RwCBIByCiIISqBKhEJEUQvRs6N7t21dTLXv7CdWvH5sw2AGKg89/dt7SZqShm+/VguM/CUdoFi62DXdM0qUBTV9h40XvamXjO0zCujQSJTYkSM7jx3z7vW3VvMqfaRRywpNeD+qHDyRdeCAFU5s5IJpPJZDKZzKLkqBfuCzAAExO6avWJmx+cEXrAgUxi10jRpLY1Rb8A6HbH+v2ZsW63MfvHD33smpe+aO2pS0yohRy61r4ABSCkgj2REwtcc/Ha2x9d88nrv1F2yhAHIgggBYSnCiiW1LYaCbEImKhEYv+JpSKavtva15OHXExTwgxVGQETCY7mXGNx9ozT1j77WReedVqXaVoTDGgr7d9t1d4SDN0KheN8Xv7e4ZgCZbIiQcpyehAwXnH9CSe/4VXoASoFKnVAjfs+8q9bbv1Wx0wJESjhICAFEMIRIloXsmLt6ra7N0v2TCaTyWQyi5ojyyrzBFBAiegcLr5kU7QhxSigaIoxoSCSUCl8a1kB1CKKomya6KUa7g5//O4/YwOFIB7GE863dKqpowgBBxTAWSvkh645//mb1o/bzJhj5eic0AZe6ZxLTnSoFwdzYk6iQEVFBCpUSXub7DRJknovFKOjIULZWB0Js0jGopSyE5zfdcmFa9/6lmve8kOXbTi5a8nLngLZDwMLsZ2bmmaymtnIMFTX9eGfAxGBAutP9EsnjAYzxlh43zAGi7QmWhMYzQmhwxB39Qd7emX59HNP/rEfwPJJlD6mZgUTPLLln9//V50mFgaBJdUuhBOxEJdOLSnojZx1svw5l2fJnslkMplM5lhgMVXcNeWfX3nlZX/3wY+r68TWKSOiApoDowDOq5lZAEFQ4EDGyNJ1PvupL37581df+oJzD0u4A/t7MxQoAQKlx9T63slrL7z+64/eevf9M8GcK5pQM6qTgqlwrEpQTAFSQUJICkGmsjSFImKIERCoJsGPoM4cAjQGm53sdi666NxnXHLSkkkIQANYK8rHt3Cq6QpBRDBs1HmIoAFiLOEQwdhIWTzmdkQEpSBg49XPuuOD/1TAKuieZugKrwQJAwcKcxYdBqXq8snzXv1yXHouxhw8CXUg6ohHdr73f/5y2L5zAo60dhoUoYAQ3bJyIqoSlZNrTsDU2BMKos9kMplMJpM5SlgEwn1+zL1CI3DpZSdOTvVmZsxxZDJJhWSBA5wW0DYvhgyqnmhIKllp8d53/8mlV/1Wu2F5LCkorVpUwVwuerKneKgnlglecdGKKy9Y8Y3bt3/tjnt2D+J0HaMF9R2Ixja1XUGAVBETExIgyXRUFIqA0QjxaVBoaEofVPtnn37SxvNOPfP0CbUk6FEbIVYVZbsih65Dc2E8vbR/JeAKDIk6QgTqIEATpVvs9fuHQICC5eXnnx5mb/zYJ3u767IvpYoSCjQqs4JpF8fXr1mz8eypK56OpZMoFMohgxfnomLbrj/+uf+vuWfzUtfhYOCc+HTfgEajUzfW7aoqyKHamRdtRNfN2Yy48NWQyWQymUwms7hYBMIdc2otpqmjgvMvOPOLX7jTRJVmArQG99ZZreqpsEBASRMRUkmqlt++f8t73vXX/8/br02/CDEcQLGOvsOF32mRFI9IgtIDmoZLCrnsrKXnn7X0kT246+6td9z9wK49042ppUhyusAoTJNFY7oA4MiMT4nQyNB4hYoWynPPXH/maWs3nttToAmQCOfaJfBqAkGaIvu4aAgRRNz5uetuuv4r377znkfve9AGtSuLyWVLTjxp7ekXnnfJq18JvyALc+GhLxy/5AUO8FY++9KnXbjJrv/ao3fdy0GdpLVXnLFhvZ5xKtavxHiFjhpNvQKo0l2CBx7+o1/4VTy0vZwdmku19nZVOboAq6oKRCPsSzz5wnOhEdqm12fRntmfnOKcyOuwuMnnN5HX4anhSFvn7/b+HFFxPUfQrhyCwzwlZpYK2H//oet//Vc+CBsXjQ4UpYOo0EGdiKNZqC00iI0ohTY3hhOw6Orf/+PfOO2C1aNI833q7gTCKL78EHu819+iwICINhp+6048unX35ke2bNs+/ci23f1BaJpAphFLNLNoxlD3xrpLJrpj3XLD2lUrjl+ybs1Ut9PulMxl2rRfcN9X1dwOHPIMD4fDih7R3fqhj/7rhz48/eh2NVNCI4UwJ64oAs2cdCfGXv3WN69+yRXwiLF2rgSIENFEoJj9xq3XX3/9c//rG9EpEGp4D2M7W3WfqU4kCoUQIaBTkCKiqAMGzY4vf+0D//s9fnrYjSiSyd5MRNsEeqDUYqzsdKoKQACHKydf+O5fwlQFMt3BSEtyMPH+xN94R9pH1ZFJHoCSyOuQ+G6vQ35fZ45l8ufMU0MW7o+bw38hJu2+bStf9Lwfj2HK4rDbrRSWhLsSTtRBGBsLDa0Ra1QIWLLDQwxSn7BuyR/8yW/3lio8DiLcARzE832IPRVLY4hIREIVEWgILxhEbNuGfr/23leVFgWmpuAWzDYSwsuhlkIOdiof6wzf+41vvu8X32WP7upGlRCrqjIzC8GaqCKVL4SIIdR1HcerjS+88mVv/+8YV8QIKGrDzukPv/uPbvr0F1xRnH75xa96x89CIhBR+AUTkfbX0gQEgRBBTWzb+ak/+rNbP3fd2FCLEB1N9z7KlAXZK7q9qlM4F8C+45nXXLn+v74SY0Wqyz8Fwv1gHJsflIe/nnl9EnkdElm4ZxYf36v3e/6ceWo4ooT74rDKtJBUVQDHLZGLn77xK/9xd1mUqgIDmfwnAiqE6hwYjYpR1jsAiAmNgi2bt/3Wr//uO975EyPzxUIPhnyHiyYwJEdHKu+nsHZnmT7wAAAgAElEQVSoQIAJh/EVkFFTqQIN2x+59DUQmSrL85vUJ/D2ZGydRPfce8+MhZNOW7/xrHOC2YazTt+2fdvmBx+aeWTbnTd8Q0LUSCfS6XZBufGfPxN2z77yf/0cCsWewc0f/pd/+eCHbMf0RABnh/d95vp/mvmll739bZjqtpcd6apHDDI/iNYl58uwAQrMhns//m8f/tM/L/p1MVOzjkXVbVfZYLQ0OEoju77ouaIS50wasT1o1l/5TJQFSRmlQeaPq0wmk8lkMouYI+ga4hA83ivIpsHH/+X2X/lf71FWKgUsKqEiDqlLUp3QrLE4ZGyEjSTriZjQIKEOoRjTN/+317/mTS+GS12qh22ePuCeSqtgR8q1VbGRVo6UeBqQRFsozQnQDFRxEABNjLpgPuhC4f6dVNyJNJkKDdAYRODaaVGAIACbt37p7//pC5/4tM0MXDBPmDF2i0tefvVlVz7rr977J5vv+FbZsIroiBORQaxDx9mSsate84pzXvWKeTORjm4cAGgadCpM19i89Suf+PR//ttn6i07K5PCTAdhoujAaGpp1hJGl7kauWzquILOeQ9gB+r+6qmX/favYsrBtYX90Z2Rg56pXHF/cskV90OTK2GJXHHPHAvkivvi5oiquB9Bu3IIHu8L0YimxvOf9+ODPYVFVxWlEip0EKUqoEpYKJzG0G9CbdaMxnMaYM65iGaI6V/6tXc860UXxAj3eIrs1lC9zGXOtMk2utB2vtD6fYBNK/c2qY/K1elsHViZHmyF5NA/BgAMa4jAuZF9p4EQrkADiO6+8dbffscvd/bUVcNmMPRViUJMUECcwRkc4SAkTczAIAgO7rjx9aefevrGc45fdeLU+ZvQ62B6un7wwcGu6Vu++vUbr/uP4Y7dlYmnKTTFtDtaGVUJE6PASDHruKIUP151ur4MwZzTQQzbKm56w8tOetWL0HNAe3qycH+KycL90OT/oSaycM8cC2ThvrjJwv1x87iFOxACfu2dH/jIh74oHCvUOxGhiYqja5tOxSoPWgj1bBOGIqKEEAqrQxCh+aackN989zvP2rROH6c7hmG+cJ523XTecCPzbZt6KOHO0ZineeFuBxWmT0S4m0EdSDQRcHACBWhIUZVDTt90++/93C9W000R4YiivYAQGdXF0w0BUwPgDEm+W6H0bogYwSZGqHhFSfERVYSnOkKJqKAKYM5QmIoxIiQVXkDHfJVUuxOJlKGFRrFj0r/8D96JEyfRDFB20tFl4f4Uk4X7ocn/Q01k4Z45FsjCfXFzRAn3RRufV3r8wJuujYgko9k+i06BSjueVH0hbuTqoAfL0pWkOFTDGbztx97+zVsebGpYO5VpTlMfhIjdO2YWTixNT2wLUxMBQBV6UJUpc02p8zYbAZ6k82XJDRPmUxwFg4A9DfpAH5g2DMLI+2+oZPzMU173Yz8yLCQwCuEgBcUZ2ko5JNF+7cQXrlKtmljMDCZnw5IhV1qxIrjJfuzM1J1hKEL0MShNHRTU+W5Uo5KqXt2kryaLznhVdgvvIQAibQgblrJ+01lYPgUxegeGJ2NNMplMJpPJZI50FlVz6hwKGHDSWnf2OafecesWixbMBHSmhJiI0iLEqyCqiHeuiDZME5oMYIzOi1cfrYkNrv/il885d828Fk8KngSkjX1ZwGc/9dlff+dvXH3Fs3/6p39aug4KKE0ByJwUH+nvQ6rw0WYXpik+GbKdo02ZAmiAAOwZNDd989u33jWcHlgI1eT4mvPOLC88Bx2HUiFAr1h39ZVTH/xQuO9RGcQ0car1oKuAHN1JSMdJEL1Od9gfEE3hi2YwVGfiHFAkha6y142ANBU1bVCJwvvKFeOuLNU51/r7Y4zDuokd1/c49/JnwNFAHC33jDKZTCaTyWSeMItTuKMdyISXvPjqX/36ews3TqIUjaDIfM9kaEwApXrXcQ79mWk4iFG8ARZi7ZQT490f/qFX2dy/oqAG+gNA4YnKoRCIEAJAIE+78JI1S1Z++Z+/8KPX3fb//uovrL3wpJQ0uf/kovn9PPwjOgSPIWDbH0cYQAeCAbXg3i27P/HFb33hhl4wITxRVd09g9l7vnwbTrrujB//AUx69Log0dWLn33ll/7iQybRnBjgDA4iikq9hQjACFE6igJhMHQi4jyMVVUtOIz2SsTQRv0UhXOi9WBYqHMiHjLZGyvFFxAYATGBEwIqqv2mrtasd5dsAkTSyRxdAyzam0eZTCaTyWQyABaxcIfBIr7/VRe8/8+XPPLQENCImHooCVC9wCLTqFGvDElRqhiF8xOOYM+87BKp4BQMEAEe2nXvxz/VbNk+GMxMrVi+7vyzcc5ZmOxIjKYQ78aX9n7/3e950yvesPPhbe/4mf/5i7/1yyddvP6JH02rSvef4vp4IKMTDWxgRIP4mS/d9A+f7G2ZWT3UKsLEAKA/0zFyONgaN2/+9OdXft/zUTfoFIhYteGkYdN4wARKUEBjoQ7GiaJDskYTzJy0NXLgAHub0m+Ybm6oIBqaaIwTZUdC7BTleHeskHQeABUKAAaaibqqiGKXvuDZqAS0I6fYfjD32+LwGj5xb19en2OBvA6HJnuRM08Nx9rn7eI4rsfF4i1TKrSEePzQD7161AaqAAIYRSkwgQmIua8V6gyakmXY/o5dcvnFyZwuAuzEdb/zvp2f/g989bbONx/Y85mv3v3ef7znV96Lb25GrUoYAIVfXv7MO36u6JXD3dPv+Kmfe/Suh5/YcSxQ7TzQLNLDRkTMoheHITf/4d/c+oF/nto+nGy0sLkLFSjRcUUBol9vuf/bEI+qSOunVeGrAkDBBb52gw9c0uktqXrHlb2eK+Z+pBCFUzgVURFRERVoO75WxHlKqa7ryzFfTrlq9eSyFRNLCoODaNL3JGOAxUgLsBmG3srly6++EjraY81aIZPJZDKZzLHC4hXuQF0HAlc99wKVgSIAZqKARjAYIyHiqJLkuyENSFKjmCQ/h5qg0y1AQIEIKNxsPTFolgzCkr6t6GNiyzRue+Brv/5ufPHr6DcakprEBc+7aOOlF4La393/zV96F+ITGA6UxHoAmgWPetRbeshG2f0QNWDA4Re++vAXvr5kVyx29IvGUvl8jqZposWi8qvXroFFBCAY+ox1MxwOe1VHiPRoNwqMlZ2xopqsupO+0xHvCEf4uUdqY7X5RxFRRLjGevBLyu4JY1PLuxMlxTWxct6nGyMkSZiJGYDGYbaSy17xEhSAO9DBZTKZTCaTySxqFq9VBlaWCuC4pXjjG1/5l3/5sbqRsugZ4ahJdRopIMEIc74E+iZAKvRSIoykS+VtAxzgseyMk7l1O2eHzpcwkDYefWdP/Pr7/ub83utx0TkAoIjCV73pNdd/9vpKyvtuuefbX71n9UUnf4fWDgI1/vZ3/+D+m2/riO/PDsenJjeccdqFl126fNOZcEBxuP6ZGBtnBbYPbv+HTy2ptRNMyqq9UTAywESLFHVVuasZnHrReSiIIl0n2P2339WrOqzNsW3/daIkq7SRYGNlMdYtrDdBwWw9jBZjbKLF0IS5q4vS+7IsO2WlhFfxok5EiNg0rUHJMIhhrpSe7ofEJtRF0Rw/0Xv+5fBCUdF8Yz6TyWQymcyxxSIW7glT6Jve9Px/+PA/97fHYCigJKMQIEQUMLb3HVLVOVKcqEkbf3LjN265+PLz23UqcOo1V3/ja7dUQ+s25mERKMzKYRxrwg1/+Y8XbViPZWNWiDk75ayTp5YeN9g+qwH/+pFPvPnCt37nx7B7z0c/+tGiH7rqObSqKG//2o0f+bu/X7Vh/Wve8oMbLr8I5WFtx7kSNXHdDW7LdKeBG4lpkwVfeNd4txX9s15wJVYvR6kAUqD7LdffEAa1SKmAQlUlTU0qnBPCi6bQRjWYoDc2GWFkXOg/k1FujBJGOiFG3apx711N/0pESJgZCjerdvkrr4GPUC/Of+eGoUwmk8lkMpmjk0VrlbHWHK4Axifxhje8uOy2bZHJ3W4AaUYjjSRFRYQy3/pgAlD/6cMfgyDWNDMoseK4Td//ks0dHXg1gcIABMYxV/qtu/GfN4JUByeEx+pVqwtf0eSu2791SEPLIc0uCj1u4s8+/dFfef8fvuFnf/KcKy8dOotN6ARsufP+3/z5X/z8X3wYM4epY4nh8J6bb/WR6QDTo/2ZICoCbIc04YwTey+9ApOddo6UAHfft/VbD/TUK+HEedVCtIJWJhOuVKD0BbRNcy8ocVhLHX1gSVn46EBLioeUowlVMfWeqkaBCcI+L0njoKmnGTorlqx49jNROTh5AsajTCaTyWQymaOVRSvcF0LgTW9+/tRk2cQ9EU1ENDKCtrfZgurA+UZQAIDO7g4f//AXQFFVE2Dc4fJLLnnL6zdP6Nae7qx0T6kzBWbVULj+7AxiYzAZzROanZlR6r333XfIvXus/fcwwwlnrnv6y67+b7/6C7/3wQ8843nP6TdNQe0EfPAP/+T6D31s35L1gREURTkxFpw0bv6JCQTFwOl0qY92Zfz80zf91FuxYgrDIWgA0ODv3vf+rkmpvigKFUmXN0IUkI4rYHRO0yBVIWBMvnav6sUJoZEaKUY2kdHSQ4wk5y4e5r6QBbk06kutejucXflfXoFeB2KAmB3W0WYymUwmk8ksJhatcJ+bxAmFK+A8fvJtb+5VzaDeadL4wpnN16hNQNI7vzDEBYCIG/b1937rD/c8WqMPhSHWqCKu2HTxu35+xatf8OgJU4/03I7xaktPZ1ZOVaesQadQCE1AbN+xVUVKX0izfyPpXhNYLX1tjE2TvhPBCAKIIYpCHQDEEFACx4+/9ld+9hU/+oPTEpzznVr++j1/fNtnvgwi5akDQJizrgOAmZkZQChWX3jO7GRnlhZVYzAjasEesT1dt2v5xPpXv3TN296CJVOIAvEwxRC3feQT3775tiqamBljBA0RSjh2yqoqyqqqYhyNYVWDa287MJqFIBYBE5rQRDj3mDtTSnA0PJVkOzeWsEiLbnfEik0byyueAS9QD1DVYf6Oyj6PXIzPZDKZTCazODm6G/wOld/ZRp4nNakAEPHmH37nDV+7ryqmGLRwzisUJjSFiQhgsQmx6acIGoGJiFKj9VetW/o77/2NZau6VEjyuxsxJGaBbz2IYYPK49S1mFIIo8BBtt+9/Udf/daidgqsPPnEd/3d/0UBYG7J999zMppAIA7BEAgKItsBQzR4RaGt2z4CAZ/6o7/+xF99iLuHRa/snbLyf77vd9EDAAwaVAXmrhaSoPUwmlKwY4Ab77j5Ix+vH9lRQQEMYcvXr1n3tI0470ysWoESkP+/vTuPs+yq6gX+W2vtc+6toQfSmRgSIpABkiZAIGF8TMnnPZS8gIjigOLn6UdRMEyC4BNQUDCC+t5DxdkPPgcc4CmgKOKQCEQTMAkkhtAhJCEhcw9JV9e95+y13h/7nFu3u9NzN6nq+n0/+aRu3aq6de++59z+3V1rr41uF9kW93/hug/8zM/PbRnNhVWmJqLhJqKqA5fjB/PrhnOVWmTvatbh2LXZqmOpNf70tVHeMuWIDEe3LDjg4RFt5AbSoLqzjpe+5yfxxMegnr6JPR66K7ef9DenHy3HZ++O3Pgc3vv/UPUzXrnHz0rB5/HgHOnza7VZKcfhSrmfh9HRuzh1t/00W+C1r/uhV73qre6uap5RuhoCkREGJKtCPTTBJ83SVbUC8I3bt1782p/+4O/+8vyxk9sXVMB6wZknwQMqGAjacZiaJDT4g1/7gyoG3jY6kBNPejh0l6j5IAeBiGBhEWPDbffd8y+fae/e+o1NNyL7cM3c8Y9+1Iazz8S5T8ScYlghKYAXfvd3Xfa3n2oWN2vjd15/4/WfuuyMFz8HAqQKDZCx5fPX/+unPn3F1Vf91P/5xZmTjlFRBPCwGTzzrLOedTZ2jLB5G+bmMTcDz7BAlbr7lYBRwGXLFVf/zs+/f34h11BVUZVun9iABlR0OBwCiAgzxUFVsLggh+dSS9+GZ8+IDG/DRyr3V3HWBc/GWY85ig9VIiIiov2xWtJQDqjh8U847nu++yV/8eFPR2hV1dnbQChCQjJEMkwT1HNuMVk62baAqFY333jHD7/q4re9/Y0bzz05N7ABkAQAZgWQaCEGSC0AApuu2PS5f7q8GldVqptmtHHj2XAgA9L/N21SNWOGbYu3fPgT91z15eG2HWtRHb9jXGkabdm87c6tt111rX32s2e+8UcwGKABFBjKBRe9+G9+9498x3jNYOafP/rxM573HBjuvP6Gf/z4Jzdd9aVtt90z67oo/g9/+tcX/virMAsIQkOG5kBbV/X648q9yq6tolZI2auqAULuvPTffu+X/vf8os9mCYhCJKCluAWwgJU1qa27e1VVB1F63k2xd89RSIQAEZ4RrcQOQ3vs/KmvuAgI7rVEREREq9zKDkP7+ScSn3wMvedufN8r3nzvPTvqNC9iGoC0CleYQUwQucnNDo+xhIuGoo2IkMqRx+PFakZeeP6zX/+GV685rp/Ll74sx7pPL//Y5379vR/M2z2FNc3YBnjGc575/Be94PHPfgIUmAcWAUWkybsDAI6xY+TX//JvNtfc+PAYxmJTar5dEAIHXLB5RtPTzjz9x16FBFSA4vbLv/K+H/vJ4Tjq+cFibjc+9Sm3fP3W++/bLAFzJFf1aN19zfAdv/ZL9oQTYYhRFgUq64YwB4Amt3Vdd/U7o8Ao/vU3fu+yj/7dbOgQSCFJTQJJkRyDZDUUHhvm165NA3NEhEL2XCoDLJXKTC0tQGR0dTJZ1N0jcmQft40L3OTuAV7006+vnnQGZhJS2Spr35svLas/aR2QVfgnvwOy0seHpTK0P/g8HhyWyhxeK+U4XCn38zBaRnflIBxwcId6g3/77Dde99q3t81gOLMOgKKVQJJUgjti7HmU2zEiQ1qTXII7AFNr8yKknZ2TJz7p9G9/2bc97bxzMCx3BRBc//lNf/4nH/73Sy+fjzW+6KpWDatmPB7MDZrcuLSnnXHaqWee+qRzn3zWOWdhDeBAQtbQcBlnXPXVK9//wYdvj7WNAghBK1r6V5ZuLZtn9ObjZl/wi+/EvABABWzDxc+96Ng0k9sckcuxlVS1z7cacHc3GT782Dd98JdwwiwCXbV9ZHipoTc0GZWhCYhc8Scf+ee//DjuuX+20TokKURERJOowCvHQMUcx6572Eyq65CyR5UEDjS45/CMyOEu8JA2PCJnz2I2Qt5mvm7jqef9zBswX0MQChcBg/sh4/jsHYP7gf5eOrz4PB4cBvfDa6Uchyvlfh5Gy+iuHIQDe8LK9wo8493v/NNPfOwy1bWAargABjGISagAedS0o/AxusaOHhEiYmaGgLRNO7JoS0597GNOHQwGuWk2bdo0qFL4GDnP6rw3AQ1RUVc1zcghbklHox2D2TpnX7d+zct+4Dtf+D0XtCkEbjvy1z/whwuXX7d+oR00IVZ5+fXSl9uH3j2r7dNPO+vVr8R8igwRbL3hzne/8rWDhWY4U4dHdjdVFUmi5qoBqIpK27aL0trxa176g9/3+AufjxrIAQFE0DoCUI0bbr7sbz919WeuaLZux6hJOYZiVUhlCiBUTMTcK8hQdKaqj1mzLkFSG+UvA4cS3CMih2REG23rOYffp82WY4ff8yu/gBM25Fr7p06krFqIvR25y+oEOyCr8AXogKz08WFwp/3B5/HgMLgfXivlOFwp9/MwWi017hNl2elb3vqK//jCF++4YxFRJsxRSq0dIiLQStVzlH6ELqJdfbp7kz3CK61m0pyGt23c/JXbJbJCBjpTtZLDTarcxqCuR82iQETMYGYpIptHslnLksfNwh3333PLXUvdZVSG69ffLXlYp2QafXdFBxpDqzoybJ7BM15+IYY2eRNy03VfrswGleRxVhURqVMVOU8q0QNoRuOqqmRxh2xe+ND7PzD40Ic2nnfOyaecfPKjT7777ru/ccvX77v9zlu+cuPCvVuGDWZD67a004ElUTUVaOna7rBApTaoqrXz85EzYtclt/sj+p/IETkcQOuOricksmMBvjisX37xq3Hcehii/K2k9Ig8lOeeiIgeIt+cgEUr3d6Pk2UVoB8qqym4C1BaIyq0wjt+7o0/8Zp3bd28dVDV87NzzeIIqgGLgCJVtVUYejtucxNokQWQCFdNGi6BduwiZhIQE5gG1JDhYjUCVqUWsKoWQKP0YHcTICKJwj2piektX/sqGsBCVFDZsReev3nLlruuuLYZtUPR1LqFZ9PFWu6UhROeetYzXvESPGItKskIawVjXPGPl6LJqpVVtXs7tARAFQiHdT3cq0ECYjg76+FrkPK9C1/8m3++tp8mV8AgKXStWEIkUU3dOlCDmogKSsW8eCRgILphfq15aePeJenpVo8OBSBluMXR99Tv87q6IDwyogUiJCNCumn01tHUacHSE57/9OrMM1FV5YYMkOkVATxziYiIaPVZTcF9QqAJT9x4zI/9+Cvf997fSqkej8cBzSGGyIColcIaTXWylHMTaCVaCZOcAVOEagW4iEi4QiAuUIgggHBXaEAkSUC09E+UKG3UJSKgJqPR4nVXf/Gum247/vRHdq3W182c+qPfj+fcuOVzVz5wx7133X6HOTY84sQTTz7xMU9+PM4+FbVAMhBlY9Eb/+WK66/84qyrqABIkrBbu/TJ21ODWEgFQwZgiDxV4lK2QhWDmPaROyDl7w8IAN7mmVStGQ7nZ2fLlkkHF56XUntkj3CEIwLhQOsxFlkQ2EnHn/FD348hAgERjdXyJnuVPMyDxvHZO47P0YHP46Hg6B0uK2UkV8r9PIxW9gM+mD+9xdQFxVvf9DuXfvqadlylNGMwkTCJpAK4BFQDcEerAW8b8QwPRKsBK0UwEmX/JqC0Vkep4S7BelDV2iVpFw9E7rYi0nBvw90HOO2c03/qV9+BGlCgzfAGSbEwQlRINQCMxxjW3f6iqpAo26gu3njXL7zubfnuhWoxZqo63AGolAoZlwcNu7JUXy4S2s+XK8QgImVKu1SoqwbUVFUBT4G5SGvq4fzscFDVaJoS3DW6R1reLYguPR02NeO+0/B7ZIR7zhG5pPaI1rMLFlvPg2rb2uq/v+sn8dhHoLbsWU0P9LRchacxrQiswaXVbBXWItNBYKnMPq3sITjIF4LJDwng+N6Xv+vmm+6LPCOoVEPglalGt9lnye4CiLfwHN6Kh4RrQDQMInANh3gSnVSGiKgEZgZ1P6vt4uHIEdm9FRE1qMjYm9bapzznaT9xyRtQIcYhAwCNh4snQKMr75G+17uUNvC3fuZLH7zkV8Z3brWRrxusUSDc4ZFUNGBR3nWIRFeg0sVnWVo2KhplJlv73ZRES/AubwBUpEzAK8RTyIlrHjZbDUyiPHyLrgBmT8G9G4edrwkgu7eRu/iOyBHuuQ1HlRYk7kLzXW95LZ6xEXN20AcnT2xanhjcaTVjcKf9weC+Tyt7CA7qhcABRd8iHY6tm/Hyb3/N1vtkUK2LiK5buVo/J+0AkqhKmITCo3Vvx5Ed4gZRuER3GfA6VZWlqkoaqDSpiIoIPLdt045zHre5ERGRABDqi81imqlOfuxJr3nLxRtOPb7skYTWEQEzKML7J6kBgPFX7vjz3/+jL1z6b4MMzT7QOqWqBHf1kPCZVM9UqTIbSErJ7l/cMW6bpm0BpLT0dJc7IKIKKKbKUcQnUX4m1YOqGtap1jRntQZKh5vSh2efwX0XKpIR7m3rXZFM695G9uxu0prda/7UV1500ktehNnSzZLBnY4qDO60mjG40/5gcN+nlT0EBxvcUdqTlF4lOePaa+67+DXvGC/W4Ybo2ilWpiXFakAhCgyqJN4KoOEGXZpxhwNe2pwbBOJJTAMqogFVLV1ZRuMd4/FimxtR6dvbwAyLzSi0bczPfPrZ5z3n3Oc+/9m6dgYV0AACDIAWN3/+P6+5/Mrrrrz61i/fNHSZi1paF5VkpmrirqLiXqvOVYO5qhqoVZZEpAlfbMbNeNy0zeSAD4FHi34gDFqStwbcm8rS0FJlac3M7EBSXakGymrUfn3ovoO740GemvDIaLN7mWtvI7t7jmiSba7wiPM2nvumV2NN6uv0GdzpqMLgTqsZgzvtDwb3fVrZQ3AIwb3o4jscn/zEdW//6Usk5qo0J55MQq1NqkkGGpBwBeqkpbod7oOqBvoZ9xLc1TS8n5OGQUwkSZeJrbZxs7i4uDgeL0IcpcAGpXzFYTFqx7Bwb6yytevmjzlmg5mOx+Md2xc233PvoKrHOxYH1QBNnq0GqXENwHSQKguHezK1wGw1WDOcmVFLkAoCoFG07hExHo93LG5fGoKpshmDTN5mrKvqWlNdV5WlVCrdy18e+rbv5T5PIrpNHULlsZfinPDyJwUpz1FEN+zZ20lde0a07iJyX43Zp57x/J96DeYHEId2vWoO/MkFeGLTcsXgTqsZgzvtDwb3fVrZQ3Bowd0BGbWjKg3DVYCP/NmVl7z3g/DZhBkRMc2qqKwuuVYClZlJGFThpbwkqZbFqSJhIiZQRFlNaYikWn4QQFVVEXk03rFjcSHncZlxD2QJhDiA7O1MPQhvREJFx+MxgMpsUNUAkFtRyTkDGFZ1s31HVVmVUlLT3AowtCqFzM3MrhnMDKSbIEfp4tLdvrv75OEvjHagf48xNzPbvbtwrBsMLKAQ9HPqZdHtdHDXWFp1arscQv3108HdPXcjLnBvJ6k9R4w1FmvRk0+44F1vxrGzSAmQpb2yDgpPbFqeGNxpNWMf9/3xUG2stlLwdQ+rMrhPeP/jihBRIPCRP7/m/Zf8to+T2bDUrCfzpGIwcU2qZXdVCSS1/nLXVcYkDGGlDUrApAvugCtUAVWNyONm4f4HtgJuBjXJ/VR0aQXThWl4xNKOpKqmfeAu96GbxocPUjV98M0AABPVSURBVJUUKeug1bUzczPDeuntRGkaYwp0E+TWPdulB05X9SLRLVQtfwFQ2KQ1e7cTaiz1yQG6ruro90IKnT6EprrWeADIcAAZXXAvc//u2T1aiTbarXXYqQ9/0dvegOPWYlj1qf2QDkue2LQ8MbjTasYAuj8Y3PeOr3tY6X3c9/QU7t+Brkv9ZSQA5JBv/44nfuWGF3zkw58U10E15+HhoxYOSSZovcxea0KER5RZaYGXNayhrqH9zTrUAUg3b43QyG4mw2ooa2M02pHz2HNoXzYupZdLl569dI+RAKTMeetkmSwAhQp8kIZtHucWA7O1M3MDqzW00tKMXgF3IAWA7malf9gAzMs2SQ7A8tL1+zwpSpOdvS5DBUoVPBA5MkLKIgD30ggyIrJEo9gmefAtj7jgZ9+MtUMMbGqufb/wBCYiIqJVZWUH98On7DGKHPaWt71025atn7n0qsXxQpLaUIe7I1RV4BHwcBdVCKCu6LfzVJew6GtMxCeh0kUFCngArWc1GcrQEKOR5Jy9m3F3DRWFRukpqdM9XqAlKJtE12Fd4Boa2WtPM4Nq/dz8ICpz3bmCf68PWKDRTW6HQKKL2tPhfvo7J49nEtnLb5rO2tMLUktRe/Rl747IkOzuEoFwwXiuspOOv+Cdb8a6AaryjoHzCkRERER7dHTOWe7nn5amvs3bPE4pCRIg0eBDv3/Zr3/gQ8nWJNQGK90ek4pCNNQgtfVlMyJJS4dEF5GkZggFRKKvgIeImrsCQAYgaM0kIvK42b5wf7kHCpd+xh3iYoouJXtS7aewYZBSv27h87Nzs3U1rOoKqlkqM8C9zX1V+lJJTLlZ67rCOwDVNPmeUhJTMrbsViozvaVUYdL1iwSAqVKZ7A0AUQUQ7hkRESXNlx4yOSIiGkMzU42Pm3vxz74Zx85jIGNv6mpm6pnZr8OSM+60srBUhlYzlnzsD5bK7B1f97DKg/vOltpEAogWf/WRL7zvkt9EDNVrAEnUIEmtaw0plqBlTWpSTFq5l9p3ACZRur8DMIGWTZEAIFfW1b2Uovac26YZIyK3Y3hA3N2TlUpyCDw8TEJVTTSJDq2qK02ic4OBORRuDiuV5+KlDz32FdyjvDNAt5NUuScaELGyDhWAIZa+vw/oGihV/pOhXpqML7cSnRLTQ9Dk1qUrlQGwY6bKjzvhwrdejGPXogK0HIZyoEcjT2BaWRjcaTVjAN0fDO57x9c9sFRmylJ5SNPkZHbhRU8BfvgX3/NrjhmLWqs5z7n1nNQUAZgLrHRKkS58hiCgDlG4Q3OIiAiQwyGqcA8oDBBEl3LVNKnWqYrcYjAUzx7u3pb7MwnfIkiqKjFIVYWyTDY0VOEaB1AhM620sS+PYlItY/v8KYGUxzvZxGrypa7zYziibLEEQYa7IFTaNo812tmhPHLDhf/z9Vg/RD096jwbiYiIiPbm6ExLhzjjHg4pW5YGLrvspve861e3bwNylaTsHtomlYFUCSYSBk1apqVdRZIkK91cREpHSJEQ+PSke6VWgq+GQ1qDqJXuMWVBqcOjqir0BeWRW1FJAhNJISaqkQGolM2hXKIvZTmQGffy/dp3lUF3O9Z1s9ltxr00aC8lNEuV7lEW6S59FhHu4QgXZHjr7hlt5GRps7UPf+45T3/jj2BQ9rXa59uEveE7b1pZOONOqxlnjvcHZ9z3jq97YHCfsnOpjMM9LEnb4tov3v3z7/yV227dVsmcwRRjCQx0mEJEwxBl66VSKmOSTEQDIlJZqa4pebpkd1jsFNwjskqYqfYp2aDlpia7mYqKIdTUgGjaEpoVnqqq7+HY9ZUvbdSTYlL6oqZ9W0lX7Wvop45+hYtIX7rjk+COvvSlu9mpWnaFTNpTTobagekCmZLaPXtGjEUWox1V8rQLL3j0/3g5hoCV+6HATgthDwhPYFpZGNxpNWMApUPH1z0wuO/7phwCbLkPb3rDu6+/9k71GvCh1SlSUjXJImIQk24npiSpEi2bqppoUkhfBK+AQSVQISah3JKUaW8NN1UN70rPS+v3qS2QpJ9B72bHgTS1j2lSkUD/5qFbVCoB7T8rAb1vNwmR6VIcYNIacuqQWOr5KF7Z0ux49nbypdKvvWwY2/i4r28PB0ykHY2lrjZjPF4/PO87X/zol70ICqRDSOtTeALTysLgTqsZgzsdOr7u4WgN7ntycC8cuQ1LAsd7fu7Dn/j4PyYMNVKFQRI1CdEwlOwOCVQQE7VuTWpXSNNndyiQQkupScnTKZWFmSV8d9PwCnT/PVhwx1TgLmG9BPdyOyJS2tr03WAMfT161z2mK5vZd3CflnQpx2dvJ9dPgnsIxiW4e0REG1lTanK7LZo1p5703370B/D4kzE0mB1oaueJSkcHbuVNqxmDOx06vk6CwX0/OKCR4Rmq+Jd/uv797/2t++9rKp2pUJkmlVC0BhExg1p4JbBSsw43iChKe5kk3SR6VWppykR4JX1f9gcJ7kBXCj6pQe93PO2+H0uhX7rrRaZr0w9XcNep9a8ReWp4oqR2F+R2HBGl0H0xN6NKttVx8jlnPe91P4INc6gAz5A9/YY94olKRwcGd1rNGNzp0PF1Egzu+/uDpbu6AoEtd+Etb3jvpi/fmjBMmFER1axlWSekKhPtChXpy2NCRZPCIKXQxVQ0ULK7VmXHplL6omWlqYb3tTdA2S217MSEUk6DMpteZsGluyxdLbuGQfqf9Z2Du5T0D/iBBveIPJkoL/3aUfZX8uguCBpvxMPDG4kFC3/Y3PNe8ZIT/utzMaewgIcjROxATzyeqHR0YHCn1YzBnQ4dXyfB4H4gPzx1IeOPf/8f/uz/fnz7AzFTzYW3kbOpzQyG0roFVMJKx0ag1LunrqujJFVzN9E+IruoGEQhJmGQMoOu6HZl3anry6517f0iVCBNdYmxrqyldIwRCSC07AlVVppKQCQmfdwt6eT6PQ9dniqVWQrubbiZufvCaFGTOKJ1XxjI8LRHvfT1r8bJJyDGqFNpNwngIDrJ8ESlowODO61mDO506Pg6CQb3g7oVIIAW99yOd779kq/d+HVvxMLgIo7ZamBQKSUrCoN07Rq7enc1iEoYRAMqXcTWgIqUWfmyvVFfMFM6S5bv2amuHZMZ9+5626WrTL8rqgAQn7qdsnPqVDlNKbOZ2hPqQYduqa7d+xp3F+Q2w1QiRt7ukLattZmpnveyCx910fmoAnODNtpypnXVQQzutFoxuNNqxuBOh46vk2BwP6hbAQC03Q5GH/7DT/7FH31sYatX1do89ho6UBPt+p0n0TJfbuEGEdGkmhAaMIiIiCoAQ5S+6UnVJBTSt5cp2d1LlUu3a6lIV9YiYeiqX6y7rV3bQUppHxMqAS07pJbe7bJ0uczZ91U0exq6pbp2nwrxbdtGBFTyIG1NzbozTvm2n/hhPPI4DATRFfKXDVO7Sh5hcKdVisGdVjMGdzp0fJ0Eg/te7bIdaV/jXSa2QxGAAhmjrXjfe3/7M5d9PsZaRVVLncxKkxkT6ZrPTNaqiqa+KgYo4b2bZTcpdfAwEUVo9OtTAVXpF5VG1+K99Hrvq2hMRLEU3DFZhIoy2700415Cv/SbKAk8Iib94Pc4FtPB3duyYWoImtwu5ibqlNcOv+0HX7Huhc/EILoNeVXLuxwGdyIwuNPqxuBOh46vk2Bw3w87bcy08831HzMk4dqrv/Z7v/GHN151e/IZeCRJ4jHQpJBBSgDgGV0PdTFA+8heymPKrkYGLfP0WlpGiigggsl8eb+7U0hf+97N6JdrBJPKdQASkMmi1UC/+WkJ7t2GTRrwUr/ezb7v9tjFAfjU0IV7G14N6gea0WJyWT/75PP/yxO+9Xwcv670aA89nGcXT1Q6OjC402rG4E6Hjq+TWG3BfU/2+oKy5+COMvu+0/defenNl7z7f22+Z8vccM48SYMkqbLatNsA1aPL2QAMagrr43sJ62XevdTBl/nypBLhAhfRJCoekxr6MlkuKkkAj523QUX5FZN7P13X3tWdl0fXvaPYfbrdXboREO++6oImfKwxTrI1j855wbOe8arvxfoZDATWtZ4pbzn2Z+Sn8YQkIjpaMbgfCbv/u3lw43y4budIY04Ag3txiAeou6sqAG+gBgQ+8WeX/eWf/L/7793hizpfr22arCpWtmES0XDpCtYlRVmxGqU8xkQ0XKXrSFO2ZRWNyXy5Qcss++QakakZ975ypiR1iX5mvetOs7Swtb/eNeDIkxaT5Zu9713jACQDEA8NuKBRbI3xwmw6/ZnnnP/yi/DoE2HoVuyalL6Q2HNbyb3gCUlEdLRankFwpWNwX4U4BMChHaARERGlVH3pWgdGuPTvr/mbv/r7G677qmQzmIokMRNJAgv0jWWk7zaza3bX8L5URro1qeF9qUwpuYmpEpoS5bt1q6VmXaIUxwP9LHg/Ge8ytZFTRCv95aVHIIhSJFNm+COyolEsJjzzWy848/xn45QTIcBwMhBABIM7ERHtbnkGwZWOwX0V4hAAh7fbzORyAC1guOG6u//ijz96xaVXWk4DNbhUoRaorfY2J6sUYoKkquFlDasEapNJhbpIaRoTGuhq3/vqdgmoQNC9DSjXdBFcXAIqthTcJ/3gA908PFyBiDzpBx8eANKgvn/7A5Igom00XqftmtOGtd/63d/xqGeei9mEylABsscaom40DuT44glJRHS0Wp5BcKVjcF+FOATA4Q3upeFM0e2wBG8w3oa//atPf+wv/7pZGMcY0qK2gbgYLElSCYMqcum/LkBtKtHNW5fpdhMA6OvgS7V6AJNyedGdq9j7RjEJfbo27NRVBrvVuLtg3DZiasN65Hkxxm7iFmc/49ynPO9ZcxvPwEyFAbqmMQC8f4yT42iXgWRwJyKi5RoEVzoG91WIQwAcsQM0t9mSNU1TpSoyRIAGt26685Mf/bsrP/cf92/ejkZnMFtJSlNbNZV59yqp9hXqojGpdLeuL83SjHvXVQayS6f2MrO+84w7Jps0Tfdx72bcxUOQk44TtnszHti3nH36E5/1tMc9++moE0wwBNqp1L6nMZuea2dwJyKi5RoEVzoG91WIQwAckQPUAbg74KppNN4xqGsgdQO+CAhu/uJdf/+JT111+TXb73vA1Gqolqr0gDkqS6UCHkApf9+pVEa0ayDTx3frozz6Du5lNt1gmHSYmdqBNQxAV8WeUfqye6tYkOb0J23ceN45p5z3VBw/DwMq5ByWZPLAlqpj9jlsDO5ERLRcgyAVDO4rCIcAOGIHaERE5HKc9Uebdh0kS3NFB4B7Nz3w75/93HVXfem6q/8zWk1h0vpcPUTjlSXP2UQne6lKoDIztchNF9wlCbyy0gsyAOzYsX12bha5jQgJLa1ptN9ESTyHCixa5DbJSNqo7JhHHnfaxrNOOf0xpzzvPGhfvC5TF448npBEREer5RkEqWBwX0E4BHtziAfu9I8/+NEW/aS1A2NAcfuX7rz5plu+/KXrb7ph0ze+fluSZAFkSWpJ1RziETknsZRMIYAaFN4q2kB5k+AiknNjyTT6+XGPjEhJHQi0Ib7muA2Pftwpj3rsKSc97pRjT3ss1g1RA23GcLd+MIf7GOGJR0S02hzpDciWZ9BcKRjcVxAOwd4c8eBe5H5iu+0/BWAAcMt1X7vj1ju++uVN27ctbL3n3u1bHrj71juSVBrI7hoQFQsTeCmDKTPujqymbW5KZfyatWs3HH/c3Pq1jzzl5GNO2PDIk05ad8IxetI6NEANjADr74DutqUUGNyJiOhQMbgvZwzuKwiHYG++OcHdmwCglSDQjts0SADcW9UED5TO7JMCmwZw4N7RbbfcKqrqWnq9t+MG4ioCeEaowt0f8eQnQPveL/3uqTAgoUHXaz3tdF8CkEPpDLM/eOIREa02DO7LGYP7CsIh2Jsje+DG1P8L2Y8nxHcusHlQ5XZ2v2UBxMuvyNDy09p/vbu8+yNmcCciokPD4L6cMbivIGnf30LfHLumdp/6IJPPRQWTXouTr01uYenzqVC/1FfeAXjfGObBt06SB8vuRERERPRQY3B/6OzW6dx3ulj+04D20+GCXUK1BEJ2CeCOpV6QABDTT3GZZVfsNo2u079cuu9hgiciIiJaPhjcH2K+00fd6ToAU9Xp2P1rKB3aZeqrS/P0OrnBmLrtB6N7rLkhIiIiouWCwf0hprt83Omy7valnT/ZrdhLd43nuksFzh7S+x6uZi0ZERER0bLBaHY4Lc/FHEcaF4sQEdFD6+D+/T1y/34drvuz3B7Xnhze/MNcsRd7rp8gIiIiIqJlg8GdiIiIiGgFYHAnIiIiIloBGNyJiIiIiFYABnciIiIiohWAwZ2IiIiIaAVgcCciIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiKio9n/B2yvU0d+ChMiAAAAAElFTkSuQmCC",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    }));
var $710403c951aed9ee$export$2e2bcd8739ae039 = $710403c951aed9ee$var$SvgPersonalLogoWhite;





parcelRequire("7fPBF");
const $dc51cba71cb43570$var$SvgPlaystation = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M18.813 4A1 1 0 0 0 18 5v21l-2.844 1.063-9.281 3.28-.031.032-1.594.594a.466.466 0 0 0-.062.031C1.59 32.191 0 33.82 0 35.688c0 1.484.438 2.835 1.313 3.843s2.136 1.657 3.656 1.969c3.035.625 7.148.031 12.343-1.75.215-.07.38-.14.688-.25v2.094c-.004.449.29.843.719.968l7.718 2.313a.879.879 0 0 0 .094.031c.09.047.184.078.282.094.093.012.187.012.28 0h.032c.074-.012.148-.035.219-.062.043-.008.086-.02.125-.032l.031-.031 6.125-2.125 10.813-3.812c.03-.008.062-.02.093-.032l1.219-.562c.027-.012.035-.02.063-.032 1.32-.511 2.332-1.05 3.062-1.718.746-.684 1.2-1.614 1.125-2.563-.082-.96-.684-1.773-1.5-2.375-.816-.601-1.875-1.078-3.187-1.5-3.036-1.047-6.043-1.355-8.75-1.25-2.56.102-5.239.5-7.907 1.313l-.062.031-.594.156V13.531c.578.317 1 .82 1 1.469v11.094c-.004.336.16.652.438.843 0 0 .457.305 1.218.563.762.258 1.883.5 3.344.5 2.71 0 4.426-1.645 5.188-3.469.761-1.824.812-3.836.812-5.125 0-6.086-3.68-10.25-8.719-11.75l-12-3.625A1.012 1.012 0 0 0 18.906 4h-.093ZM20 6.344l10.719 3.218C35.079 10.864 38 14.095 38 19.407c0 1.211-.094 2.992-.656 4.344C36.78 25.102 35.988 26 34 26c-1.238 0-2.121-.215-2.687-.406-.235-.078-.196-.07-.313-.125V15c0-1.629-1.094-2.96-2.531-3.5-.016-.004-.016-.027-.032-.031-1.175-.446-2.437.465-2.437 1.719v18.374a1.024 1.024 0 0 0 0 .22v4.624a1.016 1.016 0 0 0 0 .407v2.437a1.025 1.025 0 0 0 0 .594v2.812l-6-1.781v-2.531a1.025 1.025 0 0 0 0-.594v-3.187a1.014 1.014 0 0 0 0-.813v-2.062a1.01 1.01 0 0 0 0-.875v-4a1.048 1.048 0 0 0 0-.313Zm-2 21.781v2.469c-.473.164-1.398.5-2.875 1.031-.906.324-1.82.676-2.562.938-.743.261-1.376.449-1.438.468a.466.466 0 0 0-.062.032c-1.434.53-2.356 1.054-2.938 1.656-.293.3-.535.64-.594 1.125-.043.36.254.676.5.968l-.125.094s.172.149.282.25c.085.078.101.117.218.188.27.168.653.316 1.156.406 1 .176 2.465.059 4.657-.719.011-.004.02.004.031 0 1.262-.441 2.664-.96 3.75-1.375v1.719c-.457.16-.934.344-1.312.469-5.008 1.718-8.899 2.187-11.313 1.687-1.207-.25-2.031-.703-2.562-1.312C2.28 37.609 2 36.8 2 35.687c0-.535.828-1.867 3.031-2.874l1.5-.563h.032l9.28-3.312Zm18.625 2.781c2.496-.097 5.297.172 8.063 1.125v.032c1.187.378 2.09.789 2.624 1.187.536.398.668.7.688.938.027.351-.04.542-.469.937-.43.395-1.261.867-2.5 1.344a.466.466 0 0 0-.062.031l-1.188.563-.093.03-10.72 3.75L28 42.594v-2.406c.984-.355 9.043-3.273 10.844-3.937 1.511-.555 2.453-.937 3.093-1.281.32-.172.57-.324.813-.594.242-.27.414-.812.313-1.219a1.028 1.028 0 0 0-.126-.312c-.312-.469-1-.785-1.75-.938l.032-.062s-.137-.02-.188-.032c-.097-.023-.18-.046-.375-.062a7.132 7.132 0 0 0-1.25.031c-1.14.11-2.922.457-5.625 1.375a384.404 384.404 0 0 0-5.781 2V32.47l1.156-.313h.032a29.21 29.21 0 0 1 7.437-1.25ZM18 32.75v.781c-.79.301-2.816 1.059-4.437 1.625-1.797.64-2.81.688-3.407.625.34-.238.668-.484 1.531-.812.036-.012.028-.02.063-.032a33.14 33.14 0 0 0 1.469-.5c.75-.261 1.687-.582 2.594-.906 1.12-.402 1.523-.539 2.187-.781Zm21.594 1.031c-.473.192-.684.317-1.438.594-1.668.613-8.379 3.043-10.156 3.688v-.75c.621-.231 2.188-.817 6.406-2.25 2.598-.883 4.254-1.192 5.188-1.282Z"
        })
    }));
var $dc51cba71cb43570$export$2e2bcd8739ae039 = $dc51cba71cb43570$var$SvgPlaystation;





parcelRequire("7fPBF");
const $4a9ffda3eb6c05e1$var$SvgPlaystore = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2c-4.066 0-7.437 3.066-7.937 7H8c-.55 0-1 .45-1 1v37c0 .55.45 1 1 1h34.094A.996.996 0 0 0 43 47V10c0-.55-.45-1-1-1h-9.062c-.5-3.934-3.872-7-7.938-7Zm0 2a5.97 5.97 0 0 1 5.906 5H19.094A5.97 5.97 0 0 1 25 4ZM9 11h8v2.281c-.598.348-1 .98-1 1.719a1.999 1.999 0 1 0 4 0c0-.738-.402-1.371-1-1.719V11h12v2.281c-.598.348-1 .98-1 1.719a1.999 1.999 0 1 0 4 0c0-.738-.402-1.371-1-1.719V11h8v35H9Zm10.844 11A.998.998 0 0 0 19 23v14a.997.997 0 0 0 .496.871.993.993 0 0 0 1.004.004l12-7c.316-.176.516-.512.516-.875s-.2-.7-.516-.875l-12-7a.99.99 0 0 0-.656-.125ZM21 24.75 30 30l-9 5.25Z"
        })
    }));
var $4a9ffda3eb6c05e1$export$2e2bcd8739ae039 = $4a9ffda3eb6c05e1$var$SvgPlaystore;





parcelRequire("7fPBF");
const $b0f91621c24890df$var$SvgCephLogoPlusSvg = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 150,
        height: 50,
        viewBox: "0 0 112.5 37.5"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__a",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M23.945 2h87.567v33.559H23.945Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.492 6H26v25H.492Zm0 0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__a)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__b)",
                    transform: "matrix(.18873 0 0 .18915 -.627 1.514)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAC0CAIAAADHHcVbAAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOy9+Y8cSZbn931m7h535J28Mslkkawjs46+pqequmc6Zqd37l3MaoctAVpgS5CwkiDoF/0DlSVgf9QBLFYXBKlXCwFCF2ZnV7Oa2Qamp6OmZ7qra7r6qKpkdVd1s8giWSQzybwjwt3N7D39YO6RkcnMZPJm9foHRNDTw8Pd3Mzdnr1n7z0DCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoeIPSoC3A3CIBWCxMTl6amLq+vA5i6fHn60iWcO7d10Ozspenpy1NTAKaazenLl7G0hHb7U3nDBQUFBQUPjOBRF+BA9CUf5uYAoN1Gu435+WngzcuXAbz00kv45je3/ebcuemvfe3NhQUAL01PY2gI8/OYnRV/hoUFLzULuVhQUFDw7zmPtSCQ+flsK5d8/q+bb/6op8tSrq7VGuvdGMDwxvrQ5gaWlvzvAGB8Yq3RWGs0QNSslJubG+G1y4e/+xfZSfxnq9U//2NdEQUFBQUFD4zHsf+X/lar5WXVhXd/ZjgoIaDxyTS1na7pBYQUNmaJUwXocqiIhESBwCwEInKpcc5pUhwFFMEE+vDazWolIBCWlsJLF0oTI82//3f78tXzONZIQUFBQcED4zHq9gVoo+W3W2gDuPgH/3FyZNrBXT9Ww9uflLiMMOA4gUlVFBEg1kpqSKBJEQGU348AgAizMJRSUUiBhhN2KYWBCgNK2VDwq3/+zz55+XdQq1UWfjTyyXlgS/TSdulYUFBQUPDLyuMiCPta4GuYf+mpK0dLVxHyjee+GKwtu9gFLOwcjNOBhnPkHIEUoEAgKBABCiDKRKFk5xPx2+I3wCIINBSJc1QuAQSxuqzKi4uV9aUw7ZWPHxn7tS9kltjHp3YKCgoKCh4Yj7ir36EFvnXsN1fGn1h/8u+OdP6KHGtrIQpstBMCaYgSUoo09SUfKYAAokwhpAGVUACICEQAYhGAIZzvYYAB0eTlpy5Hhk2tFECVGyvXTnz7/wFaQAsAYf4RVE1BQUFBwUPhUQrCb5w9O7uwMHfu3GuYf/mJ96rjsj52VPe6RJpEyDkSaEhAShNpIgWlCUSkRBQREZQQZYKMCCABEYRA0r85ERERgAQC9jqiiADMIhAWcSJCcOSFIpySxJxodn40ctOcPP/FXBoWxtKCgoKCX04ejSCcn58HMLG4OLG0VPupI0SYmkC3B2bFUCKaSANaKa1Ig3JBSApQXgvMLaKUW0RV/34ItGVrzeyi2R+5OiiZsVRYwBDHzMJO4CBMIkozeLVy/ejVQ8eGxsd/o14YSwsKCgp+WVEP+Xp+ru6PvvENAPW1NOhW7MlhO1Iz65tsnWJoIFA6VDrQQUAqgAqUCpTWpLTKt5UKSQXk/1QBqYCU7n8i2w5IBaQDpcLsGAqVCpXO/6mQVKhUpFRJByUdlAJdVroEFTpWhkc2JjoNe7W5/uH7N25SDQBaLSn0woKCgoJfLvTDvJhXBGcuXJhcWuqF4xIm0fqQiolYFEtAXvPLDKH5ttKKFEgTBSBNSgOalCKvGpIiUlDecUZRhgINzBoSeT2SSHnLKmjg55mKqaD8zzWyAgBEShmLbmLTzcQ8M9v89V9Fuz1/4cI88NrDrLiCgoKCggfGw8ssI0C73X6j1Qq7Kuwph8nyMou1YlkDmrQieImVW0FJeYEH0oRc5pHfk8u5vi3UC67MckneVyb70+8W8ccK8v+zmcPMRkpgEU3CJCykRAXCVtg6Zqju0EQ3wMbCjUlVHwXQakmrVcwaFhQUFPwS8PDmvPxE3b/9za/1olpoy5IyjPHTgYoo8J8gRQhA+U6lM0FImqCINGjb7CCkL/28sPNThn63UCYpBULS95/JZgzFS0YfXQGwZHOHTracaJywFbHCTpEEmjXV1q4P1Wnqy5/xs4bFlGFBQUHBp52H1JP/r5//J091PupVG93xCTHEqSFmDdIETaRBXhHUIE2SWUe3diK3lEIRkTeBeikIeAmXq4ZEIv6/TCEkZJsklKmA/aD7bU406PvOeEG4JQvFMVthC3FaISBTSg/3Oie/9ccPuxILCu6VVv45/yhL8Wllfo/tx5NW/jn/KEvxKeEh9eFf/9J/kcQ8PKqRWDZWZ86fW0KO+tIO0ITcU1Tl0hEK0KpvHSUSL90kUwolUw379+Pj6kEgEhISCCHblUlQyoMsJAvA9w6mXhx6pZAhToSZLcQxG2ZLwoo4pObNq5OX3x9bvOCT0fwSmUlngTlgbmDPArAAnNvzFwWPKzMzrfVkpRw143hV0s7KynlgHrOLmFsCgNdff9QFfNw59PxvxWvXK2GTnEP80tWrDQDAArD02MmYs2fLN13kCJcvm9UrvZuXP22S+1HyYJ1lBJgHzp7+4uLI0WpNc+JcahWglA//E58KZmu2L9uggU8fHeFD5smHzGfTgSLeLErkpaD0M6x5vY+2fyVZxCFkYH6RMtmYTzr6y+QGWGR+N32nGyKCsADUq9XjUiN5cnao9eLC4mJrZub1c586UTGP2VmURjFVyvOVA1gCvrb9sElgoMecnUXpc5j6bSz9PtB+SCUtuGPmgRbVkqHIJo3hE6PPnD//F+Hki5WJa6WmTkcYCxNY+n2gVTTi7pw9i7k5ZVChMpXLx6pnFt0NqW6o8GPu/THwCoA850b7ERazT01XesfHKp/YxvDo8gdvBhMvlsZuRI3QbNQBPFZFfQx5sIJwHgCwMnLoxuEZZ52JU9Wfw8uPkdzImf+F/OtMSAEABrW9QVm4ZRHNhGJ2SBZcD8knDDN5l3nWSO5aI33/muy828Sholww+/3esRQExxCYam1JyksbnQ97ywDOzs19emShV/tmsFTDb6/jjTcqY1OVsenK2PGw9mTU7ERNiZqdqNkJG5ulxkdhc7x2+FDU/JWw/HT60V/jtz+HN07mp5oBLjy6GynYixaAoL7uDnHHJNfNSuXoGSkHQa18+HCPVqGdSq+NAO2i+XZnbg5A0HUwumfd9WRZSoai9epEQKUZXf5YBXWOKwAeEwFTbk5M9fSm4/VON5o8TZWIqjg0XZHqEgXGbtaLtt6HhyEIb44eiYebPRsKc1+kMYBcpgkgAhGRzL3Tf4dcXUSeKibTE/saWq6jZTIv94/xZ87PQVuCT/pnHfAyzUTp4ERjfqV+tH4/f1v/06cuDUMdswtEx4HFp0AWtoAqsAQsAa/UZm6WzlxTl9aCsaH40k8n51q6Nl5qVstDHA51o+Zm1OyUGt2wactDVVVvjk4dv/bjJypPVaNFW5vZKEVpsvoc8HWgBbzymHQHBTktAKrek8o6s2Nm51gEiqjbCQJR9Ugk+Chd/YtHXc7Hlbk5ADqB7jpmts455wQAWFd0aSikKFGRsZveWNp+hCX1VKOhUu1YT9ha65gBEKk46QYlEzZMUF8T6XF8/lEX8zHlYYRPBLAbNgIkiAKwKJAits4KEWmtBETE1jiHkIgFxMxEAUGIhMSBAiihPEOoynTFrenAvuqYzwTumPkUIWSOo3lS7i3VsS8zCSJC/jK51ZS8bVUIiiAEITCgSBExSNgYKZPW5RJ6slqJZycmZH7+MZ4vbAPz1UN/oQKt6j+sP3k4vr4R1EjL0eoX/t5ad9PfuhpIzAMAEAYg6G7+fPQLFwWhZgl1XHtmDaVLSeUfOiHzEzwOfUHBTgQRKQsgH+ClxijnhLUNbHWyrEpfipc+SpY/ebTFfJzRpIyIAIoIImlqlWIOtK5u1odM2Nx0G43uY1F/ClvdGBERO06ZmTnUHA73nHZSfs5effdRl/Nx5MEKwkza/OKdd1yY+6Mgd1qRfvAfCXrDw/zi6ZsXEKdOObBWhtmJKOcCIlEipMQrZkxQChBA5Xm3vblTZMBGmgUJ9mUkkY+X6EtDyRxn+jI0N5YOxCMic8nJtUiAoAhMAJSGENgZw3rdVFlGoqG5yUm023KLJH6kzANtL6Uqh16Omj9ojB9xSqdxvHnpCkRSa7zYY2bJlq/aeQP9eExrLQBFKnRB75oKhkulkBe/+sJo5RN83Ci608cN2v6/f0WYOUnZGCuC8vAEi6hKo3flZ4+slI8xtH3Ddw7MnKasrAJQarKrb4Ke6V55/1EVchDmzFiWOcULjLHWuhLCSr3Rq50JCPaTQhbu5CEF1D934e3bHPExLrq1teDU2NraZnVEH206HULAqbUMZsckTEoUiZBX+wEGkZJckuW+o1uirv/p16EgZGJSICSUx9QP9vm5MM2tswMziNjKR6dyy64CCZjFsQ7CZIN/8Z2FU+02BlXOR08baJXHORwytaPHXGK7aWqMsc46xwMhJNgyCu9RdBHxxiEHNtYSUWCsVmrk/307CNT0kSO61lpb+jBdvfLA76ngThiwnWzZ/lmk14uZORyeiIYmtNKblx5nq/6jpP9GbKtA5riXSiSlckU3xh5h8QZRvpPK9QFkf0kSpyIyVrreaUxg+Kt21T52Xq+PlIeXWea2nFh4+wTefg3zr2L+8tozSanaqY8uT51xVsSxsczM4iBKCQOKxAsmL9D6031eyPXnCrcbQbP4ebplpDzgPgpk3jfSl4he3ObapAB9WegLI8KwonRwvdSUp188/dM38RjJwnZtujY0+XRMi73NnjXWWutVv9xVdgvZ/v7c8s3Og1NjCVCp0UHw8+BK0BiJ9EmqVZMrH+ZeavMP6rYKDoDsPabxz3gvTpVS1VrFNsYfbtE+XWxTqSV/fUQkSVKlVWn8SPrUZ5Of/eiRFnKALZsWJNMRJEmMCMJqjUZrdvXpYi5jkIckCA8iEvzahH+Ebyxgdu5KNjj9QZk3hw6FtXKchOwoTZ2wEyUiOp8wzISYyhxpMimYZ1Lbckv1sg3oi8lMY5QdSmFfv8xFo2wZSEltHaY0WKBEQQBhZxOjmS4fnhZOznzwaF+JeW8OrR59WjcmwiptuEvOsrWu/w7743ZIvj2k4C7fDApGFmFjrLVhYMPKkB4fUvpk7+OX85LM3887K7gjSCRkmFt2ZyM9AqQXJ1rrcORo+dCX4+t/XTg97cOgRtgXinGcKqLk+dOhOWLOdx/Z+G/XBRS2zRqJSY1yXKrDjv65Wf7+wy7hY8zDXn1iHwj4DbSfxbm5gdjtL7z1rTe+9OSKTjSvIyAuB2mgE2bDzvqELz75i19xV/J0apKtUe/9XvKpr2xLICIkuRSU3E91h4+IlxjYPgakfr6bPN4/IPJrYgQApVym2pWjQxdPPo0dHicPj3kAQKt+4ndGTzyHcrOTpHEvNcb2Z9GRJ9PZW/Ldhnwidkuz9ApiL0553ZWHw9Kxvn/a/D3eT8HdQwOfO77JZSGLJEmqnaXRkaKxDs5WBTKnxk5eZKWP5vlcHgUaGN5d5egXVQBmduJ03T7s4j3ePEaCsM9WJAPQbrX+6Bvf+IM/+b/f+NJTF47VNmuBRMooJM6lYCPshJ1kWWAkyx/qzyJ+zaftIYqURx5C8slFP4c4KAtloAPJ/Ej9SDBTgzJxuJUWDhQopZUKiMihFMysjR33hZ9/2B6k2eVqJy5WD0drnc0kSdi5PNpkl+nPe4G2m4xyPwKbOBuMLYZHvSxs3/uFCh4E/fkE62xi0t6z5dLptx51oR5L9nhX+i+Rta6XpoHzqvfCQyrVDvYNhduShSLW2crEE6XDTz+skn0KeARzhL4nXpidPTc3d25ubse3swsLftl6+Mev3Rag3WrNLiycm5vrfhQcWd1ojtrUAhbQ2YK8lLkOE3x4ReYRszU/mIVE9Fel2DKI5rm3d3vYc/vqrVOJmUTNJCL8YsKKvX+rU72ho3/5lT/8TuszaGMe8/MPZ6B99iwWFnFusnb8UjS+nKY2NaZv/BxUB+87g5dgEXZOiwrHFpW6mlxuP4grFtwXfJM5J87Yqevhcqi8d1UxfMm43evSVwqFXf3wutt8N17840dSgbJr6NgA/XffOU5Nj4LSQynXp4OHpBEK8G203sPst3PTwdy5c7dKQQDn5ubm8pj0b6P1bbRew/xvtNv+4BtcfveHE6ubAdfEaqTChtmIVw3FCbMPy/e2z3x1+kz8AUBmMZdcDdwhAOWWDWyPr8CAUphrruTzsWkgIBUSiXEdy6tGTXzr+kN8HeaxMIG5pdoLH9bGVyEcJ4Z5m133gCfa7kq688992Jp5EjjnIFI9VKkcf/6ObqPgYZI/FaK1slYpRcA8pooucoBgP2k44FguNhUa7T2yChTFtnqQA5UiInFpDQAw+0AL9WnhgS/MK7m1bgYX/mf8V6/g6+8//fylo6c+OPVcdcMSl+sbtr5uGxu2sWEaG+bUz6/cGD0iFLownO299y/wClp4dQYzFy688vWvv3GhNTG7WD29bG7Wqk3FVkQkjybM880A/aQw+Uemw2WR+NSPr/Cbg5oesOVhk2/0TaP+lvJs3X4SmnMRaUR6zq6a5GbaW7PGaYV1Z5w2vXILrfZDEIlLc7VwrRzEDmkvjp3jAZ+IPbn1gEELKnaToPucc/CKzCxAZWRSBWWzdu0ub6rgLmkBCBobYWPDWvZDor0OFUEQaB0EaalmXroGTODyY+MA+aiYmwMQxhzG4pzzb9O+PxCAbKXhvrT4SCqwPHS4PHQoSRMf2rT/wcLMnYS7/1meQPzfdx6gadTbA9tot9AG8O2pr74Ufv+PG/8hP8WVeGQjDQOjDl9PxJEC+9SgAZhtbbV+fPUz03/wp//bd2Z++1cr710Mpt74cuvV+fl2rk0uLUwsnZv89a+uSK3LMaWGiaGUJogSoTygAj7kIff/RB4kJyDKoiz6upL0fWd2epDm6Wa8VPURid4bR3IBmjKv2WTNph2TJuKseM1UqbqLJhe7N4e/gocQZd+OnhutRtrYOE7SO5WCO9Q+rVQ/2oyZB7/qzzXeVhaKiDXW6nRo8mnXqcY3vnuvt1jwoBAIFBSaCUCYXsebj7pEnzZYAHJoxkD02FbgwDQhszAwX2iEngciCAenxNbH6z+ofn61PnrpxNOSptqIXg67qSFOnNaWDAhKAIgiGHivJqdT/W/+zn9O1lLAR6rrx//qk2/+xh/qcymu4yvn2gAwOzf35bkfLfCasxZQhpUoRaKECYp8IhgfUShbstDnmqFcy8uj8KUvCweDD7f6ei8KQcgX7/W3ZkU6zqyaZMOmXeesZPHpCiQkbJ0T2hxef2ni37WWHvhroec+l/7D5+N/9aYxzvFtpGD/q0HDaaC10goiTrgchDoIBDDGWOuUUiAYYyW/x/yHu19hUBamqenQZnzjt8LGUbNxowgufJx5PCJfP708+rDsg7YgCWQRQLG8muc+zxF6l8s/wjcARKPd+pmb549M/+2Jz54fP2U3Uk5gUk46CRvnLLvEmDix3cT0EttL/YZJrThxqTW91BjnUsKyGFcz4fDNo1MvHf/xnI+vmMPCwsKxmxdqG9cl0FaTYedDKdgvK5j7i/b9SGkgvjjLQLNN/GXh+H0puPUtkYCkLwSAlN3NNL7U27jYW19Ke11nOcvm5vOhZllRtZUjRm8OOwALmH2gLjNBdXzoT/42Te2BpaBXbEUrFZXCciWKyuV6tTRcb3Tf/ebLn3+WfZbCqHL0+JP1ar1UKleicqlUCoNgMAptrwnE/jHWWmPSyS/8OBxuFF4Yjy/eIFKwE4HwnsmWduHTMpagO7mpX37u5xBmHvPeEDqHc+9MvfPJ8KFSPQXIJgTlSISyjNki/VXmKdupsidIssCJ/J1kywIQk6SoVFI7M/zD2lfSKr45Nze7sHD2L//04n/wjxKdVtcj2zOaWWutRBSJ2lqMPvs/O2OuFGYKSxZuisxoitxOmHfk6EcnAgRK2K2aeDlNes5acZLLExYwxIqwtzIJqkBXeEkFbx05+R1zZPjC5+5jVe+gcfoF5aqp6XLmq3IbiyiQrU2lFIVRVArCZ+ur716e2uj1Pvf84X/8X/43//Z//+/9GU7/7n+9evFdUyunG8tUrkflZpA6ZYyxdsATZ08bqf+0lnsmjsZWbHctvdkuxGFBwaNlIDVIAXAfBaEAbbTfQCs5rM2Qujo+qoy1rLyQE0a2yq0POQAAsLD3VTHsRIREQlKKoIi0N8ZlCz74WAWCwFm5OnGSQn76nStK9Gvz868Cb/34Fx0KlIJmF4jSIIb4xSYkE2/eLDqQgHSr86YB2ZjnbvemUwAQzr1mYueWTbxikp5zXuEUwHkdVMRBRCQQsZCOyGXCh4oWkvQ6G0rDI2PHJLnZvDp2vzOtzAPt5hPlqc82Pv7Zhssn8/aZj+xbLBURKaUUmRUTUbpw/fTNS1MAvnNl/jvA//W//A/++J//+T/Lfnn2LF5/3T75maA6EpUaRJQYI7ks3F/7FBFrOKhw2DDpzflCCj6GEKD0p0efeSzR+HRpWZ+msj5o7oMg7NtTWmh/fPrI+0dOARGshV+lgTAQciBOfFIYl7Kx7Byc91PRWnvhp0ABSKeuRLqkdEnpkPwqE5mzC5wQhUNramPUPX955bWpkVf/9b/87pf/QVIdt7E4YfaWTH9wBu2UDVteon6mK/OmyfxBiSTXBAEk7JbTeNnEsXMMAcR5LxIRJyLCJKIhm5ALwAeC90CXjOtAUhAZVxZwsBgMjfzw6n3PzNsGWkHjw6sfbTjLgzN/ux49KAWDULOISVfNxe/HW7J5YXd1bXYW3/sepqbSD36cnj3LSybsliNBP05xL1m4FbrE7KyrN0fl8FL3WquYKXw8KbrGXTlotWhVVOGnlHsVhH1z6L8b+sxHEyd7R8dYAOvgRMFHKRApYhHDJnZp6oxh69UypSmqlFJmZ6VSrypdMlqFSvVsYja6lTAsK0W9XkOHNRWEAu3XhxeBBcDDK8N2ef2lC1deP3v2mZ8eutpMlCbHzNCCrQTZuf4nW8ve59OCkjvU9JOsCQlALJmFNmG3ZpKbadxzlrPpAsm0QBaAiTkhug55Pwjft3xR0ZpjYRZQJBKSsiTOcWzsqVrYPfr28icb91jh22mXJy3KJ1xsnXN+114yaUsKKhWFgYpU3InM0RQrLSy1byOZ+qsNz87i0qV4epo+DJoNyDqneea2217XsTPhelAnYOIeb3sgkVW7v2um9cr61Q+ciW3SERCR4ufnZGY6nmjgtdcGfjsLTD5Wkrgx8yxBiCECVa2gFNWfOnb59dfz71v5RvtBlmLXHnw+v2526dnW2eXrnzibpGkvDzai1Y/ee5AF87Tyjfbg3vrxWUWAkBIA0OWyLoX1w9Pn/+L17T9/4I1O2/7r08o32v6/J756duPqx2ytS3qqVKEgKB8+euVbf3JLUdsPqJwPlKN/7590Lr7PceK6nWwWUkGBNi7seEIeu3fwngRh3xz6zuGJv76GL7xwSBiSWhLWWUQfMbhn09imqTPMrBTpKCQFXQqlUUqnp/CLj0uOXbXJtSaXGzGUM9bWDSR+8YnuxQUxrGLhkg21A0GIFMDiWJgCpXVpaOry9LPvvppU/2l36JKkW5nTJNfxaMBjFBiIE/SzgH33UX8QBIATWbfJUtLrOONEAHj7pzeEgpnB66CPgvA9Ffyc1LKThFgJRySOiEmxn2RXxI4tu0tqCSOb+KR97202SGkkDRDH1sn2GL6dLTWgC5aisFQNNj8ZTS7OoHcBcxfQbh/0xTt3DmfPYmGid26Spi+URlKn2G2Pr9jBYBqqMHSs43D4O2bV3eGN7qANzA/NfJeC500vpbCEsLq2sTx05Mlub9kHMwuXwm7wyT//78p/+J+o4y+IjYWITZwungO+dk8dzec/X7qxoVU95DIQunSTbc9/o4KKjuoAlGLmpDZ+6JO3/3TXc9QOzVBUhi4hrKrGeK1Zj2CpF3SA6LjtXk4aT35J0s0wIrHl1fMvPqIuow20jp6qIvjcRioqqt7YTMYPHe24Uk0nAEgHa2udRtiUtCsmBsT2Nh7MMr9tYH58+j0JX+4myyooq6iK6ggpqtYrZQ3qBQCkYlWA1dW4ceZlMV0xiVLCJu5cu+dGv4diDz3xfRV81qRCUXVtLR46ctwlTkUlcdZo210z9TMvw3RhEklHOku/dU9t/XA10ubxZyks2aRDQRlhtXt9qXbimXT1hkpLAKRiQwSd9c1qUIfpwSZKgdO4e/1RNcee3JMgnAfm0f7p6SPXpyaeO0VJ6six9tHtRBBJ2HRsnLhUmJWioBwF5cBFwXe+cuLL71+tK50E5D73JcN66OOfLE6cUI0xFYab60ncSW8myb/8YLlqmg3uHQnNSA1BL4F1eay8CLO1IkRJ48oPf+WfgixAqh9CD+xwk6HBZ8Q7wfgVCgEfLih5DpqY7VLSXbOJ8XofMiuoE4EIC68QfRCUz+noI+h1ZhIhuBIRC22l9QQpEEQJibGW2S1PSDR9Or3083up84G6bzdnShNPqOVF0xdF+8T2+Y0gCMJSGC9XexdnAODCDC58/c6u/PrrwDyw0L00B7oSjQSpsQcJWxQRZ11Q3TQlBXzrrl1mSqPHVPnZsPbmxGm9ufJEJCQsVmyapIs3riqifK3ItNND+bnfjXQQTpwEgTU7VdL1p639gdiGvdvuOrjZTcYbE71GptrWJnc9LKzECUv5yFPx1Z/li1K1gXZp/EQ0NDE2PdXrKQZb4xJjVm+sqqzmpPM+tNal4UmSCUVu7EQZ0VvJzZd7Sw8wEHObw+iid6xH/VhlZOKDF8/U2hzaLzEAACAASURBVB+frBFYXBynF28aRZ0sly/AQKk5FuojEBZyvbXlYPiwJJ3u/VvptzRyTJWfrVZ/8uz0C+/0uIxDgYMTts4aY9fXNjf7pe9llp+oOR4EGqQ1XKksuj4r9i3Y6sbl+1WofckrsDr+cnnsbw8/X1+8OBOBHFzcTa8nGwSC+METsXBlaJKUooAbSXij/v1048X4xkOIQ7x7J+Hy2DFVqgfVodGp2SRdd04YxMYkvWT1o0uKAPQAoIuOAJCgMR6GGkQaulpxN+vPRPyOsuNLl+7Trdwz95RZ5g2AT//a8uHjgdPOMJx4RVCBGNwx8brpxtYQIYiisFJGI/hv/84TX9xcefnqtSeoe/WZk2n1TFWwWZtcm3g6jZqxKsUUMqOytjq2fP1Isn6Mu0e5N+pMyTkt0CBNys8makWaiByIlSmtulInsAhBoVKaSJFSeR40ItCAl8xgphgvVvu2USe8nMZX4s01a7wLqBMxIlkAHfOKoh9H1b8sNd4OKtcpcECwJXVzV9fc0SYLqSA4ZhAm0Eziml35BdACLtxLzQMAWuXxK6zrSRwfKJeEiFIqLEW2s5oupa53Hpi527FnG5gEvq70c41myipk5ttOFmaRFqS4s+E6/ynw1oFTWvhCXgBQOvJkODpdOzQCLZvrlFrX6yWpMdZYn/7DOWbH7DeYhZmdM86maeqMU2wpovJQ0K0fCaYPY6Qhi1eBFvDKwaRyC7iganP1aMhQmJJxlFqVWGWtMlYZq7NPo5wVJqXt5k27eROYAWaaJ6/Vjh+rjp2SsNLp2jhOktRYa611zC6HnS+zsakx1mF9xQSRHpoclcqwsOV482AFbuEOMstIFIZRFKbapRWF1VVcutQ48ZnhqSMxxT+/kaRp0u0laWqMtc4565y1zjrnK91al6RpmhonQmG53BgOqhOlymi8ctdiZx6Ab/HykSej0ena+LCNzJXeFbYm6capNcZa3+hbNTeIdWlqkiQxxqUpVImqI9XqUES1EWHn4o3b1+FWZhlmFuvc/q+YIgrD0Cpr6yH+7M/CkSPN4y8cOnqyq+K1mybuxXGapmlefQMws3UuTVOb2lgMqmporEn1cRWW7ebywR/O8tCh8tChxKTG7NcbZF+RSHdVequ3PW3OPICsRQ4/GY1ON4+cTFWpG3fTxPbiuP9s7IDZMTM7NsaaNDXWpKmgpMOGnjv0XK8cprZ34Ef6AXJPGuGvTX9OT53iGMY6BSFSfo7NiN1Iu4lLiEUpQqRNiTaH3WZv+NV2Mt/+F6/Nz19bSc3GkGmOxtWSZVjHrKIw6U4sXjm6+PFQZ61qY03w8kyBlMCvfOT1QeTrbPnEomClmAKikJRCnhYlI3MZzd1jsg7be5VkmWIgBMRsF5PeiomdsKDvDgpmhrh10u9XGu+U6p+QNizELhTnQEzKn9IviOgjQwQ+NoEFiiBExI5j50LSPcwD37iXagcALALzoN9z1lh7oNlBAIFSURhuXqumy98EcG+PXRuYTZY/u9n4bjACpRVbhz1U0q2kayIRkQlqwDzQOnAwbxtoRWNx0EjLh6bTXrq52RFxzLw98m33159F4BwAZljrlCJnXV1fEpbOH/39QI7bhc8cuComgHlK3za2Z/k2A2qlVLkaoNnEVQCtxqkLU59rXP1F0Em61rrBfD23lrtfZuccETmtYmPC+mgghOg5s/hg1np0wNoaHOub65XTL1VGD290u77r3j/lXv9erHNKkUmN0sH0kWesjTc//tGdL9Hsj2xFk0lQT6ujx4zlTq/jRNi5HZW+V4/ft5E451JjtFKpsaHWujEWMBDOpYtfur/drgBwrAzj/PnohRfDnqLmyNXuTT+ywb4V6LK2hgGUUimZoNwYaYwiONm7/PIDEQ9yp+ETbaAVjnaDuqmOzxgbr21sWsd8y7TIri3CW83BxlillLXm7fStoBoF4ydRmjPXv/xoLaV3oxH6wPDPjT1/ZGI0kiF22YJEBChSlu1qspk4kwUuaMVlvbLSSz6mmXdPzMyc+jev/Ovw0tsLN94pn/g9p8qOyT/d44uXnvrZD45fPT/U60QipEKv+2mlNekg1/O0GlwRkPziRyGpQOmQdKBIEynqu6l6LSQbBVE/zC6/l36M4KpNrvQ212zK3ognbAEnQmw3CQuV5rfrEz8pDa2RVgLt7aiZJriVlHubtaGvHgqIwMw6VKV64MyS7fzVvSmFLeBvq4deHn+iGSecpMbf4m1zniml0xUTX34JWLwfCQbngK/ryqlKI2JIXynctQBbf4iIbIqzkh7cw+JCZbrUODLEUTVNjLWW2eV5bQbZZSgg+ZobfUTEK4riJDp3pRwRVdfACSfn97r8AF8DoKpW19dk59W3FwUgolCHTrP99S9G5nxQ3Vy5kRhj/fLIOw4eLPmOb7MCO2YWXa7qaqTCxG0MA+19H6EW7lQjDMI07qVvfTuceCoqDyepSUzqu7Ad5Rk81a2lFRFh3nCbQXWYwhm7/mt5edoHqGHPTHXmYuNM2XHoF1Fx+dN1a2vetsXJr4jC7BVZFVVKjQjBBbfxrf2KcBcaYRCQdRFKlVKNpWxSa6ztZ2Latcy7Pp++xROWsFGi4IJd37ecOblGmBxIIwRJd1V6Kwc5M4Bw+HT5aKc2rrlcT9PEq+J33SIi3lLDzomKylEj0LV1SMLxQd7BB8IdC0IvBWcwM3SqVmtU2YrKBY8i5diuph3DNotD0KqrhEzp6MIz/+PGP59p/WNqvbJO718NMPJES1TohYh2dvrn75758EfNuEdBoLRWSgf9ZW9J+e3+v/4V822lSQX5SrkKRERKZQKPiDK7qDeIStZLwVsLiVjkaty5mnRjdgJxwlZgBWBr2Z0v1b49dPRH1bENCpVwkE0jAtl/slP0ZQJxMLkNvAuOiOhISZqkq/8IuHAPgvBXgK+VRrtcVnEcu9u9oh6lVBgG6Yrlzv8BzN0P2+wFzM6qGqNSCxysc3umXBv0HRXRYR1mnDvnDzIaiEaOlqefjUYbqbGpMdv75Z2S79ar7/VO5mkQmFmiKkuzg1pVVm/c7pZbAKi6RpW1/U3BAJSiMAy5VNLrNgq0s25wbeR9Sk57iBlvYgq0RM0eBRdv1z+2cGeCMIiCwMRJMvGFekklaWqcRV7Vg6XdcZ5dSysi7FhIqmMVCoxZG7qd2B7kQnkqKo0lpheb1Hltaau9966rvfbsbHRmFq40S6o2qspVt3lz91LcuSAshxEJAgmdQWIMM+8qHvYp/7YKZCaScrOsa6MQ5vg2Dud3LgiXD2gaHTr0TGm0rIdUbJy1dvAdvPX5v+N30DGBwqqDXoEwx5sHKdJ95y5No91TmzLOkijJxQugDNu1pOPEKe+gGQZJJEEcLT7Ve+vJTqv6f86cfKUbfeDkk9rkGFiJYyhSxk598OOpj36mgoADHUL8RKACBQQfX++j8hWRgmShOoRsuYl+xD1lKyLRYIyED6TIc6XlSUMz1xgidJy5GnfWbSoQztZyEhYGu6Ug/PHQoQ+joS7pgK2COFIMARSRkG/NzBAKEiiobK+XxFCSt7n/SgRKgqBab04trl9u3YMpYA4Au4lAL4GwT4/cH40C0FqZzbIkyX1N7NJKn1kKPwhCtaG1Zrvnstf9smmlSmXqwVtHb7OEaePEk7oxqcqjaWoG11bEwOt0R8WlfIKY8pEQs3POlsPm2hcO61rFvXffFg0QgXVGOyKQn0gDtq57wJJnx8O/ZyQixloQSuMR4bnepXdvVwg6UA6RfL1WimpD1DWpdcwqLypol95tv2vmD6Q4dqkrT95kcyX+pH3An5emn40mAuOVDuadLX7wcuT0346BRmfj0nBoImyOK1K9T35652fdBQNXFtujILX2tkO0fehXoLVOKRMNHSIis3JffXFpP0/vQYamPnOseeZaJTVp4o3kO1rkjq98S3NY50AIm+O+6zarV+/0nPfOnVmKvTrYOdZZHV5nC5vPkwiIRdbTbspWACboaiSNcn1x9NA7T0wsTHTO/kr7669cnPm5iz5BvS4qYAAEUWr84w8PX/xQaa1IaZAmrbz+pzJVT+VqnyLKtUGloAa2fY4UH2aovEgUgQgJkQBbidQIQvApQ0Vk1SQXumsrNmFhy2xZDDOziyHvNca/Ofnk+7VDTkcRMKCFKgIRqdz8qigrW3+Dsq+RffoVokgpEUlTUx+yuhJn1XkvLVeN08T0e4pdn8j+yEspAkTiul37tYHYpntm/Rd4fQ7peqkcKpWbxfYD8GmGhpsAMDW1z7kPnfnVQ7OnVGksSdIkSfu9Q//W7q7I/d/1X2NjjDV2+HzPPXM6eOJ+LtstjnRISthaO1j+O5bf2Bp9M0uaWudsdfKJ2vHP3OaHAqQHcg9kgXMMsDG273uVy56Dlrb/KG4VNUmZOWh2w5GvHmSmsDz9XHlyxqQuTU3mipzns73rFh/8bb8V0tRaY4MgCBv3J82FAArokk6N9UYakQPU+27l7FegiCRJam1aGp7M1/Vs3beJ4QNUZ3jsBRqfuV5JkzRJUnP/3sGdzWGMdcZFzYlg7HgwdOTuTnsv3E3GOTNmq+WqNcwsUMRCAuqYOHYpgZiZgsDqMLgZNS5MAjh39uy5s2d//XuXT1y4jFqTSQsRKZIgqG2sTF74QAlI6UznU7lc8UZNeJnnt/vqFuXvZ75Ebr7fhwvKwKSd9IMDCSJggUAMu+tJ91Jvo+usiFi/ui87x+56VP6b8ZNvjj2xHtWDbPHCrACZG44vRF6qARmZ64J9WTggERUp79htmbmRAsDs4l012TyA2vHrlamOddba27xyXv6HQRAFgThvCbmNHnYHXE6A+XIXGoFSSmuttcr/7UIQKJUpGsDZ/YoxPvX5Z4797tJV6vV6aT4Juv8IdK9K2Gv/4AlTY01qRs73gvpEOPKb96W7IaBUCol1anfmHLjTou4ocNaPO1c/fKY8/dn9CnGwrpgAQIIgsM4acxvfqwOdMO/QrXM2NWFtRI9P3XYEVp15oTL5hI2tNZlVViDYL3/fnqc6UKOnqUnS6ujRxonbjCcOiGNOErNDCt5jWwNIkjRN09Lk8fLMbz/MPL168ikz9KRF2o17aWqQj6rv9B3c5063v4MmNSaojwdjx+9L+e+IOzCNnj17dnFhkcoqbAYmEbESZFEJZNl2bM+7mQRaSznUm0H5WhNA+9WvtOdbAJ64sh5PDVsjjEyVEsHwx78oddahQ29jVCC/fnJm+cz2oB8E6OuUc58nb/yUvlNMjneNyScUcq9REREhIBa3mHRW0sQJi4hfs0LYJYo+Gpo8NzS1GlbhXCDOkSIBEWeGUEXEyu8SkBIlWXZvL9ilf2N9wenfYy+olVLMImxtdwVnF7BwVwlWZhdxbpIm1lWSqjz07DZjdgIArji4KHfXvF+0AQTqZnOtGtdKQRiCGb7VfOEGvJJ8EjtxVhxR2eH1ub2GAtHIUdUYe2ft7SS1/RnQvWy//Z393qf/KFC+/9aDB3/SFy0QKpeadrxpVp669+6GRZI0YSfWsbpllmirqNJvP9qnqLcWOElTpVXcOB0eOmyu9+5ReBvrNntdYx2wTWbvw237xEzhtk4HHDcjffSG+2R8N2fXeaBdmS7XZhrxSqc/N5lrz3tdlPyk4dabnymO+Xd7lHBbHRqjkqQxPm27ld7S9+5BzJAIx6npW7AxMBrYra13mVvdp5xpakIE5ZkKd99JF9sPQRyGI0dVc7IabaaJ7ZudDv4OZl+hH6K2y8GDP+nrhSISNibk2LPJlYeQrmiLO5sjXJpbqlwZq3RBkuUp8bbHrk0sMxEEQqUorQWLV5eeWz4GwEvBL//k+pHNXqoiC+e1N1G6nHQbN66T92fsq1ZZUjYAfQcXEREGKcpyxVBu7eznC/XBFHnqGK8FyeBC8l4QEqFj7bVkc8Mk7JPFMDtA2KwH0QfjJ843DsfQITtHxFCkRPk1g3Nhlok6EgViHzEpeeCEImLytwMRIkWQbOIQREJKyDm2Dp2f/n9h+pQp31UQZ2kdZ5fceTHGp3nzt3i7X5GknXq69Bymerj8zbu57t6MVaY7IUcWsU9nkOUwlzxbTy4FAWHOWnCpDgDndg9FL43PcK3c6yUHkYKDL55Wymdr90+DiHjftqwO9pjb3+pujCFCeSQ2h7+bXGvvdb8EKGCfOZYBWWXgp5T3KKrvKn2aBsuu//0+oqj/lXMuTdKJmop51Fw/c9c9Y27G5ISZtlfIvr+7jX7g9Tl/Zmtts3w1Do7skU+oDbSi5k/tZsfeoj3fWlTpP0/wOYozrwD/7LFwP95jh0zaVrb8rk2apvUqjY1gaf7u6lC868HWKuBbl/Dbikhrvc9jCex+v4PldMap1VTXHPaPv7p7+/E2wtHj0dBIEsf7SMEdlezpv4PZMSzWbTX7bd9B5xgw5bGTYpJ08cP7czMH4KCCcB7ziwuLGyJLJpgaATE0+eePDNueSxlQAlIqJr6xdPVPP/6zm1jFq68CePZy58wnXYmqaWxBIEUQsA5KnyxFmxuktB/Dwft7evXNGz59GlA/rtp6C0gAUBYgny01T3lmNa94kOR5YzJ/TQAKWDPJ1Xiz56z3DnXsV2A3i7XhhckzN6qj7FwgjpUiFgIpKEeihEBKIEoUfD+fhTPmjjNe4RPvLKMIokgxmJBtZ3qhUgCLyMSv/N7GR8vm/Jt3M7KbXsfSujQass7G7OmcMohWikhJr4qzC/jeLHCfBeG5c6/f/qADUznyVGXocCfp2e0zVTsOG+wulaIg0MIIlNKhVpo0KWGxjo1zgBhjmWWvHnbbmNRa6fVUfVMP/aZbc3uqWQrYO0ncjqv0t/1IKggCpUgrHWilAk0MFmZhYxyLWGt9eOT+stBvGGsTY0bGxU6+17tbRaF/IRosbWbVgFIq0AEpnyVDIGKtc+xzzt/OXp3nNGTHoRUl6W4HtYB2ZXy0VjYb1vVT5u6neUjmAk1EWlEYBH3TCESMs9ZGIi41JveVlYFVR7Hj/NZZk5juc7XQvGV+cYd1l5/Ky0Jg63H1n0GgA6WhEGqtAgIpcRBnLQszG5vFwt5i0tp+cggRWeckkfJwyR36m/T6g11NNxw9Xm4e6vZ6W2Zeor0exfwdhNaBAIHSURjk5g0xJg1YA7BuK+Ji/3fQOkcwujkRmk2z8pAcZw4qCNtot861Lh756dBY3dhypJR4HxkgYWPZKRALi6AXJFhWLbTaaLda3wbw+XeSUzFWnGIQKQVxYEKgw/U1FfckLFOWn9WPmSDkJ/mQLxqYPyiUJ8724+itFxHZb0VyPTJXCWUr38tS2r2WdCyzAI7FAsLWsL0wfuLDQ091dUk7AyIWRXCZCiikSDkSwCuHvCXwstYXRwRkclFBCTH1paPkSqSfFCX46BmtSjrUtxnZ7cWlJk6X8HMBpQJzkF+QolBrA8Lrc5hau+MrPkRK48fC4UMJJ8Zkt+Ybecdhgy9SoHUYhRpojo7fWI2TzZLaKHsNodGIf/P57rcuxFopY61J99Q2BobeYowNKkOjh2pLa8/uXsoDDLq3riL9uS4QkVK6EoalIFhbaiRJhfJ+OqzZydPV5eULQarixDjntlQu3GIfHHQsNHaztx40GYvzd52oYYfM9gN8RVSKAqWCUAVhOesonOM0NcIcp4lzjNsI7GzDMTtrVXkzGP5ru3rr6G1eV99MKbKp3Uu49vf4jagUlUr6xAuHf/Ed01mLciEkIoga8dTz3esfpYAkad97U25ttn6LW2MmLkfr4z38oo3Z2a0U8/dQgURUisIwUqWotHG1240jUocAQIAgVZVOWE9I28Ggmj2HFHnZWcRYDppdpEfSPSSEugOVcAL4CJjdkdcirI+Z5Y+TY89wbo/ZtVSDj0oQ6CDURHTsVPXyTyqdxUq/sapV/sz0sR9v/hBOkzF275vdpheyqwyPuvEa3nzMBCGAecz/g9J/pHTkXU58/hTH3POxByAQLHG0Up67MgegjfbiBOZfw7tfQaeb5Z4hRWAlJIFCFTbzYcnN5oOjon6AOuXyD/1QCCFk8YD+V5lSmKU/zPqOrUGWE15Kuktpl0UEuTnUmZ7WPzv23OWJU8wSOJ/GtC+3coEHUqQgcH5k5t1hQOI/RSkSCLOf0My97PIeEIEKHDsRhjDled4CGKB+h9lVcpYm8KMhefI8V+I9h5HbIQCkaGMDAC4/nGSLd0lp9FhlbKKz3r29fcx31lqHWqV2Iwj0jaizeQZ4/WT/yC7w1+ZaOL6+wTYMUyBO95WFQN5bCs8dvfFe9zs3Lt99cvDBFxtAoLVWavO9F/Hk9zvieh+9sON4Hr5EEqcu1WGdgH4I+dbTf2tps4F2WDoUpOvvJIvn7mX2aKBmoIiCKKgHwbqtpL2a6hFtlAWQeg9RgtJ6hChJfLg97dVSg+e0LGEttuUuVr+7Xdi0Ro/dlOoIc2e7tXDnSbwlTikVaOUi0Ejp/Dm7+v6JHVfsAlL7ma51mRGw9kPP/RVrETZpQp0Kzp7F99bv+JXMC4m80ZVSpTAoV8JeutG9eSX+6Mc77ArhyIop3VBIddgNAZ9paK9qHHyQ2NnK8Gji4r0E4R0yf+vgqTl+hp760ka3J/ngYp930Fs4dKDT5eEoLF3+QbT+0eHBI3vAe0PXFCYSt14KWWs96AG++zsIiIgxnP7Bl4LNZfve2/fjTm/DQb1G22g/d+xz1UMaICglAANCSNkatt4zkyEfD8WLazfa/lUUATD/KkbXjWWfEjsLDIRWylmdxLxVEVkCbIG3mJMI/ESkeAtnbilln7DGB0hk+7K1dzmbKoD4XBIiIoidu9zbWEy6PkbQMFsRZ9PlSuPdU1+8Mvm0kjy+IXdVJVI+DEP5Eme7suSl/q/cNZQG3EdJK0UCrZQ312ityuVStRo0KhgOoqHR9SdLmtY/WbvygYvfyer1Trk8BAAdsmJvN4uT1yyRUproxkFC9x4R80CrPPpbKqy41PaTxu3ffwWhbtRriWz23n1j4/TY5hCwMLFD5b16/vD1t57sPilpE7VGuVQKb9Nrg0SEWX6y2tS1jXt0SehfJYrCSqWcLq6rI9/svVDvffhntzbERqe0fnI4fucNxxu1ei0IsinkHR4hO84vItZZl4gKBZi/6yWuBvumMAhKoUKJVtLG5k9mu89tbp47vnFpcvPSZOf9E50nTTIapiVEpSAMg4FJi/1qQCAiDB3g7FmUSgOHzFPtB2NDyjjLe98mAAG0UlGoJW4knbGlBlaWy7sev7ZcWtYdW3LVoVIYBP2xyF5Yx2y5XBrG63NonjpAbe3Ejx76UrAcBuSGNnqNjdPj8c9+DMzuaG6zMpK8c6b3FGwjjKJGqVxSSg0Om3atAQCOmR1RqRmNzdxyFAPgO0ulPb99uzVx/OxzM79jdk5h7lKe7FGJolKpYW5MxhfPrP/8+A4p6LkRq+VT67135lJp1uqVUinaMUYcpL9frBv50x8E9ym45bYcSCP0ds6TwRmicVEigED5+LyUDYv4uS9WauiS/NnVP2+hNY/5VvvVdgu//zebxxLT0Uqsdy4RKAIUp4ntbIC8idVPNZNQHvnXj3snr30KMlNn5i1DkvnM5M4yuYcGkKW6hgika81i0tmwCQAn7CDCbMUtDR++MPX8RmUksMZral6TU6QA9H1BRfLEobmep0CMQY+YXEaCrBUVhFqJ0jwdVX96LVxbCzbsMuG68HUd6Wq3es2trFz4yT232leAWGHxgI88ESmlQD6n2oOdXbgHWqpyrdJY7PT2zJWTtS6RiARalcu6k0Tx04dRexELC5ibw7n/6ZYfzWN2EZeaven14FpaqZQdO2t21/P6F2VmJ9xDuTI23bt5lxny+690EATlchTfvJIuvg0A35vC7CzOvQ5sn1udO4uFBbz4Yjx9CD9TQZgE3quCdvcK7otzZiYQRc27Kye2j/qVonIp6tbQO1TGwjBmF/G9KUytZSOwqTUsTNi5JdsIoism6llAfMQF3ToRt+MaDqLGsbQEzAE+cUELaDs7th520ZO9Osd+vxlFYRSUNysl9+4TkEXMLe3W4sBMC4sTyeRScLMRBDYI9G1n00nRKVU/f+ztlXN3s2JoX5MmoiDQE8dOX3sPvUtjWP5erv6e297c2WMZT6+T4nJaCZ1LkjSfDNp72hVI07Q6epI36iku7DAAqKB7J6W+tUNohY3r55L3fMYlHxm8lzoIQGtdDsPuYiO+PBjwML/zOnNnsTCBFy91p52+6sIwSI0Vt3tq4m0in0mv9cKJo2bpQSzstY07cJb5UfhRt+ciUkKKiRTBiVh27CfmSDmXdnrr85j/Br4BYGIJ86/h2rMuDS1ApEg0ERQEJMxB0AuDJnMmCAEGdL4tgIiwj0X34i6fj87Mn6DtObTzZXdFRLxDn6yk8VLSSdhKvo4S///cvWmQZNd1Jvade+97L5fK2rN6X9BAg2AVCZAASRCUBKSC4qaFCkpu/NDIsiJmwuGwNSH/cITssGwk/MPzwzE/PBEOW7Y8Di9hjdgzo1kkcUiRUpKCCIJYSAKswtJAo9Fd3dVda9aSme+9uxz/uC+zspbMyqruxjB8oqK7KvO9e8+779577tm+42wqaOHYxZsnptOgqKy2QnjR7ABqpzoIEg7wgo5B25GfJETHBgIKlGJ2ATltE2L3kfGl195e2dhYL+SKV8NINj+5erUAlIE/8WPYA8rpsFTFc5w8X8lN/hoG8xEyA+zuUTTZfaJZYCYopLGzujeGeMc3LAQFSsZL460PLmJlHU8Bly/3cO1UMQdfQzFVMdItlVPW9KuVkalZOp2YPLnWGAJuHMHeuFPBkhTCbAXZd72s074S76VLeHEjnn8qd/77wahi1ta2/QE97EjWOq1tNN40m2+ky//iCNxS26MjhAhk0Ejq8YXjADCzhMs7pbXnfeYSZssuao6PYK2+g/vMmAAAIABJREFUZO0BEG4Eso7hUm4leL2Ccoe9RaCapt8J7ZSP+ezj4fJI+k2t4kdSrK1jbmp/KQigVkO5grkKX/x+OJpzlg9cJ4Log9xtim4DLx907X7Ujm4PlFIh3b5T37rxIADMP9UjNq09LW/caJ05I95byedK1jpjTC8cn21ViRmmzpzba+BxpgBsHIV/AKiF4/kGJpS1RpvMUdDfKCplczlu3Tjr12/P7J3OxJ6dTeSQiZXMDXNvaOJOR8baYGrCbi5p3HdBOKhp9NXzV4YvlInIeVUJYJBhpzuSTJALnTa6iuoUpgCcngeA4S1wIEEEIUiQ9z+AgCBsBmFqjY+48fDsLnvPvn3At+xffzsUpg0Z44NnCB3zqY9LZjCg2d1JmgvJVstZy/CQMdaalqDrZz5+6+wTNixJn5HRNnLSTiNnW9XzlRVpO8GfSEoZhmEUBvlIRDl+6S//h9vvvrSx8ONXf3Llvdf/eunaqx+89b23X/+rd98tAABmgel7/NLm/OjcZW3bnym6XDz2nbFTjpj7xA0iUwqhlIQKNTcBYP57uzfrfZq/jLm55PWzSIbyQRB0rI77rXO0v0tM7HgTqAKHhj7oNCylUFK2butk8csDzYTLlz1MgdvaCIJAtS17/TdH5yzQEhMtoIrT0d4r+xBnuUVMgpSUaV3HP/1bvLiRMdOLybmprR+dX73hre79TlnZIdV79htbQBVLnfGcAqrgojWpJBGEUkkRBDIIZBCoIFD+d6VEEMggVCTYNDdweQbDyQFJk2YRqEIqJeUgDgQHoiCK7VGALrkN4ugBJVLd3HowxukXARzA5OXL2NjA5cu2sYqApRQdhXhftTjrzrk0TcMhv73MdF1yFHSULqoFhetyiMn1K7XdYUNKISU0N4Aq8MLBOayXL2Oumb7xQ9csSknbgb49emFmZ61sEthb++/1LrqTBtIIa6h9Sn2x1DyjFLO13pLJBOOcZUsEx3DWbq03v7/2/dM47X2EG8OYP42TTCUhtGAI5/MOvEGRlWoFUcOlRS/GfCP+lyzm08+JLB+QM9xstLMmyIEFUSdQ1GWKGlrOLsabGyZxDG7Dh7KzDRXOP/CpjWMX4Vg6Y0kIOG4HvHAnTGZnnGcn/jPzEQr/BFAhrq/fWV29PjJ55tZ7L+03bNV79pb2EsE9+rOt4x2CpoE5ClSr2bCJPSgCiH2aklXOPBnhenXgXmpAhWw0NBJuNeOsrX5qlm0msSiOHDGmqZ0ZJqQ0Uc62Ng/TTg2YTpd/EJe+HE0ERhvbY0y6lUJnGGEJl2Yxu9fL1W9It7c2IZSSJt0Aqpj/Oi4fzKpuhtEwAiV9BGn/9gVRcSRZXUbXINQAMF+Nl590RtgkyATAflPb0BKb23rlh0CMuUrXNxWgjHIZpzdwYhXXrmFuDmtzuHRJvbecatn/8XfxOuiVO27alg1BPkxbG7h8GdOD5SnNzQGI3/6x1FKNHieNPnhyfkb5ok6nHm3Cvrz+buMIDO9HPna0nBPxZis9UFcjIklIJJsnT+A6gAEjd64BVZi/E1Z0Xso+fbVt7L5GBQmPS1y7r26dQU2jjdZmK01hrYJwRILBTJadYxAgBTEQJrlLuLSBjXnMA9gYBoAkRyUl2PqwSsGCfX4dEdHE5FYghm0aBDkHdgCDHWf5sd5SgswtCM4yBsn5xL4OngwBDOtx1Yg3TXo73mpZTYBj5zlkk9RHJm+c/0w8ekr6WoMkCI6R5cLbzO1HJAQ5+OQ/AO28QAgBSURkGCIX2c36/Aph9lMnUP2j+/Vm+tDly8ClAUNGMyJxKB/6h0szwLPMP2VY7azrykDf9+pASSUFHMm3VtKPfo42BnTqlCl6LRwvbTZaQvTzxPjPHTNBlj5y0qWPNq/VjvxsQpJeJZPwIS2WM8CznPwEbIUUfU7onpxz1rEaahUaUXNmadeOceCr75hwA5KxOTaYzJ4FZgK5jDBQKQ9ipSfQ5x+/OFvOzf1gR/n11q13gN868HbgDFAFfhXY2jmSNaCKJWBmDsVyRGPyxDRGSriySPnRSITpQOm2d7U+vFVZSZnWV3jpfQCHzcEI4EIVamGcM+gRq9n5hEgs3pKkyB/vdozGEZ9jBngW/IZj9Mm4bbunAGZr2QlEV5dp/zXYsVd1w4aUKXpVhMeMWHY628D3WYI+3YXIWWe0UYWxaPwHyerRnmtQGlQQOmajNQyUkl4bs4BxNkv4E0RSlql8DqfWsf5NfBPA8AY2hhGloDwJ6ZPLCcLjjgmwo+MndaG4sb6ZV5EASbAjcvCBKt5T2Bkr4k6avM8wRSYg0U6zccz1tLWUNrSz8KlLYOecs3q1fPbmg0/p3Ii0BgA64GftMk2inX7DmboqQI44S5MgBimQtTqedDb30OlrEw+eqFarmJ5GpYJa7T68lz5UAZ4Ny//A7a5R2pMYcLBAGXhrb9rQzwDNAGCeELSYRQceVO5AKDFWNysjE4VCiMPEiJh8YzJv2RaNbVh7QMgMObRurQl1Hnj98I63zLTvnEOzblYOW151BkBQOKbCW9YeHOvh2c5FUfLeB3j7h4fpaEcTyz96PHjgBzg2jbkDuV0CqkHuq+V8dCsdsJQBzQJjFy5gpyDsTdeAEFDAFHAL+F+7rCxVAE888R8v1N9M7Vis3+BCgTfLMC01NJWXF0xxjQ252DWp0SsY9Z6TEEgjka7eOkIyItn0+OjQWxtb/bUxTzpJVaSSzX3chHdDjjnR2vbG8e+WjpZcWmiNbZZpuNcaXAXG935qgzW7SblcLklSZrev+p/ljgMEkRuB3ZT7iPx7SoMKwlwwJFXg2DnAx/kyYOExvogZlhEhB2AEI/6W+dN46ge4/pQYAkMISOFxYEgKZibHdmhET5S3VpbzOp4ICxYsmZ0XQUAHNy1LHPTho2h7CtEOIgQTkDq7HDfquuUnvWXnwGy1FuLOmZnlc4+zzEmrmchrl0TkYWIsmJChh3r7Zxa4BQIIgoRjIU3SGq+vnHrpha9Uq88DqNVqlUqlVqsdIff2rqkMVEE/Il8MapBFzg7WMU+2l83PmiCcBWYcL7ZSD1h8wNXWWmvk6rAiFyNtdZ6/MxLdI9JpzMM3I8bSumCXtCOq+pG2WkWxaawdCfqAAA6CYEhFG9YnrhzeyWHCkdFzi60M7+Qgg5WlVmKS5NC9tNklh+hTbyYPlICZASZ2DUAQrjbxEKg1YB/5sbFGui++THW/P69l2h4QTbwf5L7CeIO5zFiUwZdFtLHAyydGP3pbLUsw3IYTrBsE1rFY5abz+DfMbD2wX99QHDFoVaKeJARZFkiGjpaMuPbBrBY5yk+ILPy23zKw7JDw4WxCB9AscDnI/apz1EaT2d9O7FHilFRhIAt1wWixa3Vh3rWJAUhgHUAbKqz9EmIIpv5Gjm2HKNjAMOfvd+rXoIKwVJyAUqy1AxyTIHJgy+wyFy052v1kSYTqc/idv4ZyOS0SUAbSycwQAs5QFOLCQ/a9d+pJIxJyOMhZMLETTpBgIjgfxckQHZWwLf0c4PMkCNw0ejltNEzsk5Us2MGxMa0od+fMx+rHPkpCkbNMgryBdRtTigQLB0se26b9CbJIHChhT07ID24e/+a//p1q9fmzJ7ZqtWcqle/W2lpg/5l4X5x45TKWgGJRKEt2IIg1MNgyl9qVj37mUur9IvxlZ9n2TitGWxIY62yc0N0Zs/pEjXbIOTbWAbxbjB3UcVezbHOsQm84OtTOWAWqG9fGEVxHkfqz6odCa7OxIVzrUAH026SUlKEUI+lhQDaqcbPeunMHh4vOGYRqQCVXVir/ZXavQ47Kwnh+LJUJYrVIbMlFhMmY0ytm3mrnI9qYXWps52i4nQmHDvRtz/76B1UPInECFeTDQLcmcPk8Tq8fAchQtzaK46eardjjCvW5kggkCbx4xAPWPjRXOvbQiRNTS62lThd7yYfvg8kY46zF3axBPgBH0JPRJlQpwxdmmtmdcXTvaNBJPzl6ntrgZ/5fLwh9GrsDjONdx4JaBZUaWhTozQQlZIogO/jcCyEA2DMXbHkqXVhYkQ1FohREPlYc3g9JbbAZRls7hM8ZJUAQDNt62qqnLe1slnHhy45bvTE8vnThU83hUwQvUtEBgO4cDSnTEEWWw0hE7EvbC+Z0iHhp7fiNJh5/9K1IXvYisFqt9jKFfvfppwE8873vdT7xvN9jcXh6AzNzqI+zMwPOQgZr/64uzeLFfiUAj0iVSu52XWgrE9tHYQEAIgQ5iECUTtR//K/a382NHL9YnhpbTrNc+J47flce7l0ehg9cgZ5ZBZXuk27VF3K7Ox/RchhzVDy+idePxqduBMUxZbTuZJXsonYyDxyzEnYbh/0wxACRUEJR31i+vVS/Npo7vRYGFr0V1u7PW2trMgj2XrOLwnEVjl2VufFiuWVjsnZVG500ASLbctqY9jHIB+H7szGwc611M9M/xXEAOnhUiWCZxV3gNwkhhBqoL2RIk/cyM5ii3CY2pexXCaA7D/7uDc6DrEFfLB18Bzj+M6ER+uhJx3CUST7RxnMBfBIe7d7ziSpVBkL9oKIhIyUbx2CGFMTMUpBxPD6pPzIjFxcTo5ewCaCkQgHhGHanXPXCK7OuAswcG11PGw2bOnZgOGbnoefBK8cvrJx9zBTHhXPdkFzUGf1MEnop6NoFJQRJMFuQu/Huxds3T757ZaZSqQFvzczM7SsCZ89OQwh2vDI68vYjj4ytrX3vo58e2dxczwdR2nryg3drqFRRqd7bCNJyGXVrmaUU7qAwCgDWOWLIfNyn8tHdUH6h3joxeiIdl5ZIqr1WRyIBJEiAKLLkmg2t6yNt89fXgTkRnlFDkuqD7lUHOlHuERHk/sns/amzvJn54dITVzdfODIHgkgKSUIw72807gTcA2B1l3rykR5WHyDYtl8WA4DVB4TVRMc/okaS3EjdOt5YNdZpApsuVW/f9vflu/MiBpgwd7utMxAoatFRzeC+EaYBGaFeuRJHXRkObOWBxwVqZ24fsZejEMM7pO9rBsXAwTLtPAbHxOSzF8ibjUQW1SKSUoI7WD+93jG+zU5jZg4ro2pKCW2cL8YAbxplgBxA7pGPp1eviOvXYhJ3WhtpmB8NcjkREFMmYQEmCGZBZAFmTky6aZKGTixbgH2+PIOdNXEQrpz7+MbJaYhAOK+8d+Efe0jSLkNJFjWDDF6fBNZX6qk98ULtC/4RarVKrfaLu0bDz9WfPvSJN85MS6MpjJqNZvTqQpPwbuFYMH5WSr4iVt8V5959/xeeQa1vovAhaWkJP3qKHv5hbijUxgySUe9B6saKLE69tDU3mDvnUGTsqdZ4U2utTc8l4k/tJhVEUige1oCvrTgDPMt4czNJwAcP0j1cgoM0RQ4i3B/HaxCy7F69+o3N6/tm1xyGBnEEA7D7wZIOQPdVWdo+9Wfd9Ituis58PHfsotNxs5k6a72G6+/r9b76GY0PMVt6XUm9Zc4uPsAupH3tB4MRM7tD6Vm7Wfb+oiP0DPiQDCEdDvYx30MpONAaFCyURwn4GUif8MARDiQAx74UH2exnUwMsEPCyeyl2eEXtyf6UhnV5/Crr8jjW1EgrXbETOQEC5BjlpKM4bFx++mnzPKiiBMt1WrSaJpkOIgKMsxJGZKw5HHYnGOXOtMyaWxTw9bjqTmPOcrWGbs1Vl564PF4/Ix0DHacHRWz0r3eutoFzg0AIAgIACwB06qv5qUqf3Lm7Stvzc7NzWRX9KDV/CiiUDNxnBKTdv5EB9PUVuC8GG6MNx/Rf1uZr6G/p/5QNJ8AVax+jkungCyLqK+FIQMLj61hhXsdfDUNzIlkLBWU6jRJ9IG51VLKfCRdHLTttDMAHE8Kt3z3p/J7TczEIireRQvUaN61Cn4oa+eHPoR+EQ5EDsBMFkCxh9TYiWDibDA8kcQN16X/iU7cRI9Jfo/ORj0G7nA5SvvGAR2CBbZu8BCYPTGd7pAQazvv5nYI/s8aOYjc0P3uZFAwAuvYWA8BAws4zvx0DHJE1jIb1woTXMbG8DbGT62C6Vn8+aei24xASCIBISDacGuC4PHsLjySfupzhp1la4HY6uWkcatVv9ms32zVb7bWbzbX51vrN5r1hdbGum6lzjpmA9Zgw2x10hLyzgMfX3j0l5LJc5IdfNY+smj8rpq9WfDYdryMtyyxzanbQ6XNmem3/tmf/Hat9syzz/5z7DX27qTRRj2OQaEgqCiIdChlpFQQMDtrrNMsdLA+QS+cyar53KM5VgOmk+Xvxytb3rHZ387uc3J0apqtprX2Hqf5nz4DVF2pxMwegfxAAsDkGIu4PAPMte3+i8wHwwXftWfw0MSMoDS5+8OBd37Akbr3kST707+/LeyQEZcjO/+sAhUA4eS5YKSsE2vblXq2lyeAHgKvg8PSf24MMHN6r/TBItLaeutdhXBhgGBmT3tdebQdT3HEzhEPlHJ6xPaPTETh/YfeHlQjXKpfGy+dtQxBJBnOAwH7gJYM35NtjPeHbzTnusDuiKb+hp99Hu8/LZUTgaDYgaQvMyEgGD6CRgjzxFOtuJX/4QtEjoNAAZY5tiZ1IIIACCTBbVnGDGbnYI0DN8aOrT/4ydbkeeFYWNNBHW2D0mQRMr60QOa6aTtXrLNW62YraImJBx+8Mjs7XanU9jWHdogB4Dlg7tGrl+uFkeuTZ6WiWOscSWKXVyohWG2tc4Ikga6cfDBQwZPv/2gW0z8FZtoK/l2cY7Ns6yCwzjhteq5UbpeGsc4JJxENq9EXTf3oHe9Dl2bd65wmSa+0vA4nfiNzzM6aqIEEVcxXfMgocUXI8b0x2HtaQFdgxIdBgijdWDr67RBBaSLMfaJ+7cf3kKv/H1EVAFApnI1yI2GSaGOMl3i93Hu7jn07r+m5Sw8Sl7E/DT7X7npWEpEUEoP5eXuHbB5xX/Grr//NXeEWHxIRIAWSjXuE09ybBhWEW82VkeIpx8wE5wM4CYBoR2KSlIHJt4bDiVfwA1+twt9Y+S5qz6DM6vqQKG8KQY6FIMHsCEKAmaQAWxEE7nOfj4dH3A9fCDfWIaUTUoG8O9GnDjqA4NgxMcNqJ0VaGl0/+9HWiYc4KEhrM8DE7QWRxYainRvYjhjNoGqsc1YnxaGN06dvV6vPVSo1HxfaZxzaU+B5gDdm/nBm4r1HJo4LhpPYFGax1VhsbOnEkgg40c45QVKxuH78oSVz/NUbTz537xQyIlKKkjbiQH8oCgCOnRqGa9A9tY7O4vI8PVZhV+gDsoVsJ/KwrThjSjf0jipUTEuhPsX7VzDvaiE733xooTLEzNw7ErbnjV2gYlOnLibaHlkQMg4DIXmQYvSzSfmTC7kTORNrjxtAe6SdJ26Xd0BviSeEyOQIM4AwUEJIbYw2vb3X95a4DLx5RNgKIiE8EPNAPuF7+6YJ4NCi1T+Oevs8cd9Hs228sw53DaN6MA0qCFt6yzprHVmRWQwFCEI6SwALkHPOQlIgq6jWujbZatUf48Onr5rzG6yFTR08vgwzEQt2HuzTkpLuE59tHTttZ18Lrr4dNLaYWXoMULAPGfXKnlVBOnWudfx8MnXWhiXBjqzL9sjtc40XEciyU5m7RSAYzpo/+l/+g7/3239w+nR+EEVwx2hc+N1k6r+sn6e8OyMSRiAkcwGBHZIfUWPXmmubJW2vCZc6ZnbW6dA0yhOfyL3212llkhfZp4Bcf/OQL6tDS0B1ZOiXUxsIIfoDknWImSU1RZ6OlB6+L1UwXwvKn5W5YYoHQrEiolCp62sbW4tvdwtjm8br+ZRj12F1/8dhhkcC44DIMLMmCoEUCLPv2/M53Hljih0YYNm3fcMd2YGEbkinD+342Y4albTR0mjcPmwLADzOALs7qbHO9cQZ6JIIPEgI8X2hI25TVQDRRD0YXSeL/oXauwNx0XXUkEJKKRjsrGO4MAilErAOlk0+edievSkW7CBHmR6S9VChKy712bpVnH4R84cShNPAHLjsxGAShtk5t0sU8gCxZn1IBsVAozWYQ1oq7+dQmS2XRMeoG3CXTOksw/YC1HtWnQ535tPsMA6HIAKpI6zBw9KggpCIDEkhM3AYl0lriSytkOEgpMrlJt4tL1aWKrU9Csf3LhSObfLFZWtZW5Hhy7DPKWRiFsSWjMWxU3psUj80HS4tiNs35cqScsYbxC2EKw67qePp0IQeKbuwQNYJ6zoQeFlETFcBgbYymX2fpVAI59i88io9+uj/dfGhqwB8dsQg49B45CldPh2fGpXaDMdEDE41pcTgSMlHZGHVbo5HsrmZCKmkZGets46NikZsYyjXQuE2jiVOC9BdCMIaUCHDnz8f/tV7Lk31QCdIZmtcUM7ZrW/qpXsVf1WV+RdD7RJr+wjjbjMXkUjTYCdOxHTjzhwXLtJBmePt5lCfzhfm2K3VWTc0LRFgMu8MbSfy0Pb1YG6HdrW/ol0X7ekDIJmHCFXxzGFL83T4V0JGsrW5lQdweC18Frgsc1+2KRnbp3w5MxPAQgjpHAe5fw9FSQaUv2IfgSlzrWg0TprGtItQ9pKCXgQqKYUUSkkwjGOpqJCLXAoXma35VhyvCSJgkTGZD8dulNZd0d6l7jTgeHrcZXaTuDSLFwdD3N6mKeBZlt83euDCuuTAZeDtbe2ThTMF0BHLMLkkdumYdVnBo/7LUIBGwmh9I9CNTTZb7dKGIIYBdZLTsp/2AvQvwnQvTSIQdWnr3Q9PAFFQECoMx8813j8qcOBgNHAeoUAhCpPUOuPaEaQASRAxEyMrz7yU34pMAKCK6nbyXNu3c20i+oVbxevhomPLgkgIln6MAMfsIT+thZR86rw+doYvJi6OA5Mop60TBgpCkVQOBGNFBhzaVgS7AkHb9hXOOofXRgBf2d6aN+cuvPLyEwDGxw82hwLgahVA82aruZA4JcIWkbawrtM3AUiMFDReKL3XujEWTow/oq7+eIUAYnbW2a2WM85H8AT5oJdtZ3BauPrk98JXqKSkFL6ke/+MZmY2xuasVkOpXgIwDTx79NiZS5cwW1b0vkhK1rSc7afMbZsKhVBSJrvFzwzwrG3+OBrR1pHtgaHaeQrLPPJWsxUfS2997P6W+MjolSPfyY7TxNq0fngtvALU8uXPjZTzW0mmy/bYmDITkgqkDPMKY3rASgA/G0QqdSmb7eTC3eHVnfcuhVCBDIOomMvfOGlzbwms5a1dN7Qko02bxvHNtzwiDwDgSoLq8PkXh3JhfBcBLIPfqY1RKqVccrRs3Wj8ByI/GrfWHPcDV2pzxWAfTlvtmleHVMy5DLzflqOVzZs1Ds+K4YN7B2AdVpsWjTi99XMfwhpsvH/XCUgH0cAaoaA0MpzAAgIQgAMESQjFNuX2GbukcpvFuFcjL59Wn3y7NQlokBME4WtJEDFBiKyoIBjsyFqAKQilDCwXrWVYB+fIORgr2DG8O7CdG7+9fBjcDhJt20H9O3VgKcyd22PXrh5/+eWP+qsHMYcygFoNlUq6noKdSomcZW4bbdtbkfcpCRV8fOxji271rat1CCIHAXDH+eEcE4WWyptLXW7Mo1F1Y+MrxeGiUtoYy73jyDsz21qrU5OfPCldeeuDz/pGjjSPq5hdxMxSOK/VVqKN7Q+NhvZ2FihltWOjOrGCAHwGBdFUIO9o0t3X73oK/4sgkAAJDQBjv4S1bx+efwz21INc04+0MVJKN1Q6fC2nMlAVwes6y046mAhyojSxtrnc/eGA+/h99St2Hfd39VPLjYYyGjNGdyFP7nOKYmZBFEVBoFSS1JdRz19JW/aTmJ8C0PWaKsDX2zv7E0DV6a8hNEg/FL8pAxBK0+j5en1u6jB3VoCayH1laFxuNoTTB+vXSikZEZE4bJp517sQWTHIDHy4DFRN/Hp+wkpjTG8YIwKYYa0VxDb1EKBPAK8OzkMXVe/RNfeABhSEla3W2NptCqUOhHASjskCRFJSoKGBdqqe4XcfWFpvLkbXd4pDIjBXajj5Qj6+oKncJCKWgh17N2HbQOoBXpidoKxeryPnMruW/1cQLHyeKzsv5LYBlDI0PJ8wse1NYLAlo2UUJ/FQRwoeQgzVag1ZTuREQCGR4zYsbnZcbXcMgEAm1PENpAuWxhQZg3bxbvI2JCIWvNkcAlA7etBKDYCNf5psPihzJSGEc26QTFetjZRi9GTJNpdbS5OYXsTMpYML2+6gKgDMTUVqK5cPWy42GUrvAadIKQQR6c2xdOVBQHXBBs4CMySW22BhQG+hDg8BylbkElyaxYsSa4fhHSie+gjjPPNPmMuZrXRXXKK3LtASqS8JuaxKx9ff+ItdjYjBcwaIk8eGAvNRfbV2GDZnACAYtXZ5wNITxLy0dr3xzou7Sh8M6F25f7EPXQn13QKpAtRk/svFot40WYH7PlNIBUoJFSf1rQnRrvfyJQDtwtf+eWvbN5RLWKq6wve1zX84YTKO2Vg7MRXWxU18+iZwqGVVpeCHqd3sMLq/aaf9mpQUIQfNw0Os7RxhL623ATyFEIGktA1j1PMwykxESgoUY7NcPULAgRyekvmPA68RHUM7dKNjysO2irBE4VeglkxzI11457C9HIoGTp9Yemwounp8ogwIyxDkAWUgRMgUO7YCxGABnLs1dk2+/d7eM0KGuIbc1WHHnE61mIgluyxwlMGU/bgMiRTsmwQ6INtOgFyWj8/IsHazmMQMTZSzkBpiBsExOcf26pVTTuuf//lv/2T9TIehQR7cv5TmsYfiBsnhNoZVZ9XS9sbtpaN15uXGTXwH4aOq0WwFSmQZwR6bCMxE2hiR5p9Hdfru0PPS1Rvh2HE1Mk5pko1Q76TjjokpTU1DNFtLk/LBeTuzjhc3DuG+unQJs4uYm5JDG7SOmFftQcDf2yA+UiipWlseBKAbP3cJqOaCryJQyogs+LePIGRnjcjl2fyooee/eRjfWxUARVeL5bqdAhD1AAAgAElEQVR1ls1txywE70nKsh4aQYnIpMfN1kT7WFrd5mGAzvxoa22n3rfr8gHgzUFZvXQJs4uBaFLadDxQCIwggoRphbtKHzAQDpwId1QaOK+y+6rTEearPPyylo51v0xBT1IIlZOcStT+BuUylpYO1hUqNTcfantE/NXBadtob8zGxqLhFiYmMTvg0q4CCCdWRX6IXaujiu1dAl4b84dd53hjlWzrLHBs94zq+6y9R3gWuCzwtKQTmXHvIAuTdm7kgdH11uvp4txh1mAFqFH0saAMoSxwU0IiK5Yqt227WYg5SOZSe8LFk8A797UM04Bm5UWgmpg1KA/p6YvokgNIBIKUP1gzETMFrN57/9VPDn2msgdjs1rNRrbw/kh4J680KxJCCvYY3ILIvwQhIID2h6AdP9z1O5H3/fkq8u04CQ+L6tixBdiMiHo9961vfObb3/45D5zdN0pifzKl8WZpioRoyzN05mlmLvAKn6QtGx9bLdIzcuoj42EgaWeQmw96LIjgXp1R07VbrbUlpUSXqNv/yk4kgrU2SczYJ1610Xr4VoD5p9oJFZUuc+VeqgAVzJYxsxRdvGG3hqOxFdeOkekPc+W/lVIsv/KvXLJ3ytUwPY3RxgNmUig5wKshxzZONqVmoAoM6I+pZjdHSZy6uJW2kjjRSZykcRLv/EmTJE2SxBgb5ENVPEpMZMcHzOy0TZXxrJYHMvXMzmJmSY2uqmIrTVPXrg/XpxchRBgq5MZxeQbDOyrU3+94uyMKmdOncWmWR0pusGAUIpxOyjkfkbh0UGbnpUs4vY5ajcKGs7ZPom2H7kZUdt6OdS42bIzF5csYHsalSwPcXQMgojejsabpUv33d7S3faUE0s311spT+3FztIeYA+DS66SbQRh0QpP20ja+AdBY3VKF1iHXYBmoyrzQTuhU60QnOkmTNE102r0G0yRO4jiOrdFRLucevXi/baQDLvI5AIw7Dd0wzjmGAyzDMSCElDkHckRZWKYTX3ji741OnKjst6tuy8JrI5Ee+cc/PCGdkCTaYk9AECR5kcOC4H+85BMEASIi4WtFAB3558tiZCGs/nUZEcQi2ho2tx45/8Pp6VkAtVqlExfDvX/2kiOIvKAsLrWtwmehs8TMfoYmkt/YMHfGGxTxwsIaSeGnL0DEGFbhufzIiaERAIVi/ByqZRw9WdtTunrTpc0gyHfBxvdc1J3Qc21MYtKRqDmkGsXzL+VPfCkaiw46cNWAyvDw1sSyHhlfGvnkK6k2tnekX3ePAJRSQRDlTz+tNz/WKTLXTWsPj79vPxBEsh1buHcpdj5xjuFcfnIoOv6id/UftE6yb8fOLeSGjbM21dpYa4zVxvo8s64fa4y11jogPFY2WytHOIe2B4Scc8bZ3FiueP56ZvDsx2oVqGBuLnjzmkittdp0RSHt20vbMCGS9RzfKANAl4MqCyG7zz6yoyRtnNkAgFJCrufRrZuYsFJKGecH8GpX8OIGHnqo8OjTUThijXdkHIHFrt4HuIaInHNsXSgL+UefxpkzmD3w3FMBAFRlTtqYrd1OINmHh64Po3yeDfZv/Ojverq5dG1zzSDTSPanzpRzzjnrioWhqHyoNThTvDBfPFGURMYY61yPNWhSY7QxzLz8wtc5eARA32P63dIhTrvN1nLa3BBSOMAxHNiBLEPKUAjlGB5ohi0HrOKT4QenVgDsLbzgZWHtGfz3Xyv8Nx9Lzi3lpDWKhBSCpGAibotAass/7lYHhce08RqhQFv4kSAhSQgI4hzr96+cePv1UxP5d4bUAoBuyLRe0q5DvOcXmTZiMtndvE0+LJiInBTNgP7z6NZr3zlmbg2FzpG2MFYQCRDAkmhYhZGSEURxOIwfzb/42c9W7oWmb+q3k41VGSjsDDTfS52viEhrkyRpapJgjIZOD4dTo4UzP8if+FI4dmrvjeMPf2z8o786+pGXTp9puQbFidVpatpJyn0iYDvLJgikGhtic7znarl8OUYrFxSEUp1797bWffrW6RZFS3LocaDS9hVV9rRbAaZ9qsbEuYULk6x1kiVu9yYAUoqAxOZbrzeu/dt9JfeBxG0oHK0NC5M/tVy8cGMnV9003eazEo39UtSSYUrGWtc7CqlLHSShyLaK6doYgJ2s8oA64YcQT7IjjeHGMABsRDxg+pvDll5ttDxk/It9L61h/qni26oYjlrHvnyV96AcnQa7l4isMcbwUL5ceEe1TySV/d71JeCSP1wWzn45N543Pk2buo1NXf132V2kFM3VO5z8NHvYbbrLLNIpoGpipwQpJTv97vuc2bfONeSmHGmosc8ftAazD4sXFoYeSkyq/cP2I0BJqaTMf+E/0f9m6WhrcHAavAhnZX29Nlp6ulgkciwkhC/GBBApJfKJ2yRAkLBslZXjdqg+0jx3c2JvQiG2s+zxwkRU+Wn0wLvB7/2j0n/1Z9c0Sw6gjQdt6zKBCgIDviZ7OzsCftJIEgwSUjBLwU4nb7158sb7Ez99/RwAm6S9siNuP/aZdRltLa36kmZSCCGoqOOHF97de3Hpg9mV84+48fNCM+0sm8lKskAD7v2bmHllZuyJhfLJYPkW2dQIEplCyCjIICLBUjjJI631xnAe9yhCQa/dpGg4Kp0MQmv6ZiVjhw5B1jprnbHC2gblKF8MiILWxnk5NMYmbdeC5Ghk9IGnP3HzRwuJFfNXtox1Rm9nDQ6SPhgoFcqgNU/x7en99c65OQDu+vuNYxTkh40WveyBHUHOzMbaYOx4/MFfhpNhuvyDHrpCzX8+dG4rf3LovaSZJLqPdOmQIBEGYXPtaLnwwA5btItjHbEqnN1w9kW9UjBblT2sznk+CyfqangsGso34tSYfnx2PhRCSAnX2hfMesCI07ukARvwl60DwPw8fvAUP/wSFQ+u/QPAWKtiYTgFZvun6OXLT6mhl/JhvpnoNNXdhbj7dXB36UzeCkVEDBhjm81GPnD5h9+1G6P125X93vWzAMJxo0o/yJcjY3WaduKl9xmPDvNEFAZhsnYrWb255yIPun3kB6kANdcKWhvLMj/iASv2n3htTpxzwlEwMsKiQOHf6Tt/1WcNBqOr4dRqNMbxUj1NOttUFtu4L0NSShFE9OYHwB/dV3UQhxGEi0DV6B8LOoaAnWVLvhIFHEGqiGyL2fowFZ3aUMhGsfGNyb9+afl7+7dHBMCHz6xEpX/6n8WfuTHxtX9Y+q//5QehEIbIsM1CZ6wPF3XtuoFMUghJcAzLoYBjltro+spbxYeuL06+8a874TD7ZEdUq9W//N4r+eLwLz7x8Le+83Y6dDZpxVbrKJcvFEOj9ZXx0yc3F3F9DsDsA4/VCyM5m2oVXqsvyCnxtDgvKCI4b4yFgNFmKbdVni8880pp8yO3caK1tBDrWAt4FGqAWRKVVCBIWMBKzqXJpct/Pjt9z8prpbffFMH54vGgYZ3H/BxAFmary1rnXArABhKcIiqGpVFFsh2Qy4bNm393nQR8VZxuaI8+mYudjoQgqWS8tZreaQDX+xhg49UbavRYrjSetussZgFRXT1QV9yatRYpjzz2yzIMWsUvuuSbME+65IreXPUXl07PQJ5LW9+k3BeCyXAzbqapNubgxG0iUopuv/wvwj2I24eizplDa83spDbROFof/Fnu+G2JnzsxZceGSkbx2+9eZy6z+yuR++JQOTC21Yh1L1Swbib98IYqXHvl36rSb9wNqx8KMTCblWGaT4CqW/maLuguf2pPcWWMTYjC4dieWbfDX2Is29kd4XilMzOQIZMYPX66EbcacVMbM6gU7Cc9GGT7S5dO6Ph2PJo2hJYqmAdLhXdzLyfx5wphDJ2sLszmjp0jdZrtaxQOR+PsLMVJaswBqDroTFei0KpWvE/WfAa6fXSBXgWQrEGOPB4Wx6SQxprdve98ZICssUhIFZrIRyL6oou/RfiCjd+wG9kJsnD8IqnzFt+nXEkNxTqFTlK7DRCBXVKwe2IHUiZrd2x8FcD9C5PxNLggnAKqQ0O/FVlKA3JwzHCA83KIVKDyqd4SIIJwbE3iIs4nRWAZp0+ffuqppy7vF0xcrVK1ygBulHM3VnP1fx7LE+OLK80J1wgDxc5ppKnVXikkSAaRI6VYkhBgYUzCW0ESwtrbMyN/8fc/uXNUdw4xAODfvfCTl57+1AMv3vzf/vpqmlq2mh2DScfJZqqlpMWx8q2hiT8+NU0QrwjK5yJruBDhvfqdP7x8+f945jdBpc+OFZ0KbRA/+v/+z39aufRgafSDxvpPHl1sjRm9YmxqhHNCdFRXjKioIJUTQoTBaF6eTANUKjO9St0fhSrxjSdF+GZQsqTJmMz011+Z6IhDP9fTNLvL2DQL/yEAxDsDF7tFYJ+duvNLEKggX2gsvpesvQWg/4TW9YVWVJDRsC/E2kvcMrL6Ita6mFNlLQ1TXo0FCksvvyQnLgAcFEcnLjzWqC+jVHJMSRxb5zqK5r4j0/lbCCFlGE6cTVeu9+G2D3UzDz+qxlrrjKChj31ZSahImDT8lS9+4v/8zuuFBx6RmxxLZm23YmvbFtF9+dz1WqWQkjh3/Ivx7UcBfGh5VztpMKNcxrLfxGtAxSZi48efGnr0JbI952pnZ9TaOOFEKQxFuPmbv6Y4pGXvYucgPzLxwKONrdUk0aub69ZmM7Yzt9FXyh7Icx/hskuAdctCY+2b4roaEdHEeOjsKXHGDk+FJyZ5c8NZm9qlNIVl181q79WazSIhxFZrMV75oCc/d23kNvWFROVVfsS6nnBRXUcxGG2cdVIINSzE+JhLmZvnkB+DSWSuWJo4YcNckmiLrTSB7UBQdcNBd5jvnthSRgFt3LmdrMzv6f/e0+CCsHb69JcefVy//46WFLKAdezjNQkQQKAK1ibOaUkECOucMHy8dObnp790Yma4PFvegTXT3W7tFxcXF2dmLi0toYKqnM398XOlr/ztxtlbdnLJBc6tTjh2rXPXGjhXbNZTMoHQoQCWy7w4aeMoePKlkxDPLzz4DKrAc8Dz6GOrGV9bevjVzc3UsLG5KG+dEYJMnOgkNcZYw86qMJLs4NFQNzebVpskik7lJ5577JduNJpPl09v2qBE9P3Fhf/xc7/yxuqKiV2U5zhQrmnYWOnBc302BXNRBmNBBICJQVQqhVOPfQYA3VNBCNTSFRnwVjhcJkC3ZSH65lTs/Tbzfe53Zfc1/feUzgVSiCBQzZub8a23BnmMZPUm5YeGLkxaq3VqevVFWa6od9pz6gwROcutFkeP/JJn3xEv3LlBJJi5E0DfZ0C6djQIwtbKDX1UKYg9+1qncWvZWmecIG23WP+jP30BDuxLYhrhnNs+gGeIDT359JcJKZOtuotz7dDfnWwc+QE+DKrYLYTHbwophbDektFH8HtjOBE514r+9PtSjNDUCAQJZu3swsK8R23syBXsOZP14+Wo4qObvaylne/aWkGaYuY1usokW3fqxCChd7zr3nMyE4PsYwcpX6St5fz+ZhV7Vw/SobS+IKKhXHGsu0Rv/wOZc845J/xqZIfcsIxKAEBY0yxMixmdw3Tnxl7vg5mlFKEMWhtrzYV3AIw/9BByZZvGaVMDDEgV5qSKiqOTm8s3RT5vrSmcvXDnW//39PSlO40bxpk4MBzI9EQJg22zgwtCDA8/ePny1GefXBYcOvaLVjiCI7KAIApVMU7Xs3VNbIyVUhYwJuaiqbmpGmrPAdVKBYuLmJpCreYHolarVavVarVaQQWo1Z6rTM/iG78wXH0+6/fsOqrP4dJfLMxc2SxgCvGo//zEPP7o7wPA0ObszNwzle9+t/b8L+7D9046d+38Z179x89XfveZ8OK8vdkiy45zhaIUpLVx2lpjNSjISRjWJoVzEjBxIqw8NzQuAyyLzd+MvvyXS98+VSg2nRqnxJm02WJwSoDyBlEGETnmHImpMK9IameECqzUxY0tYGzwYR+MqgBMHYQTLhmOJgPn3C60lwNdTX2u2fVNnz2luztmtnCN23F68+eBeEDjRnzzbchQjp0F2V2b/g62Aex8ut11oDwAAxwGeMbucz0RmrlILOzC7T4c7docd8nF3ZU6shwC281qT89JN7dCRCra2lxM6z7duLb34vueR3h3Oy/nkm7z974za8c09uKBLe8s3cdg2B0D2LkRe8b/8Fz2/qb9LlwbD4J2Gt53p4F6hiy6r+mveHXCuoRC42aa3v4FAPsLwvq9CXqK71xxMqTx02gbZvYdwK4lQwAcZ69g2+PKALNtX9z/YXcsGaKCovp6lpURHLtYGkZ940SAZWdKAISKcm4zTpKhsWMt5AoTObPemPjEr9V1cqx4ZiGPogpX8zfV/OqAk/8QgnBubgrA0lL0+BPvfvD+Q45gwcQeAIYssZRRqIqp2aIst56d5UAGTdl89fQrtfnaMwBqNVSrqFYxPc1TU3/49vx7H3v8lW+9+jtP/u6Fl86j9t1K7btVfq5Sw+w0ZuYAYHYalRou/8qJy3TS21E9zU5jehZzM7h8aebywFP82EoC8FdXf3/99J1P5ydzob0Tx1dumKZBdMzo1cQmKaxzCcg5iXZhFAaMY8swMk4b//vy142xuViFwsIYNiwAAX+pN+XDgQtKTYX5UEjtHKR0ispp4/hf/DMElzAzM/jID066viD1ieTmV4cefYm1yaJC0PbkH7QX9P52oD1k9+4vpN1asTdfA8yhkmHj628EIieGxrmvgRR9T9P7MtZZtL2+VUrmw4K7M6JXnwDyR/ZM+AallGBYt1PC9eW2822fa9pSkKQKqNlIbvcD3bjvuP0A7qLugTPB5shWaa3orHW9Z2nnRSN7/N0Bjd3D2329kgKgfcGPdqjsPR9t0AdRUjKY3W698G7edXcjQkm7fieZ/xGw4GNtdpE/XLkDo3647bDpS+mt2SDIq+Ikw2cS7X+YyP5k+CLh/brt+7C7Vmig1Nqd91vtiW0M3boJuFtgCFl3bAnkggBMW9YyGrzUkkxEKiV3TWxKTawx1CjE6aCgr4cQhD7J6b2rlVxuqDRETghrOUNCI7ZMBA6CPNhq2xTIVCLHUMgdOxb/wdhnjq+tLTz2KffCq+Fv/Uflhx9AtfrMR/6gFTWNIkvBxkc2h98u1VADVWsAuqBHtjmo9py4A67Fdyaj1onfXx9//fTwZ/OCCTSSCx8u5P7ye1PHnrieG6bYORhD1gkSkqidu9heYdqyNiEQApQahpEgaovA9qyAAEZUNBnmJJF3QkIKIcPcxhqqVXz963Q4VLNDkG28Ji6MbP3GM6U/eyVJYm/rQ3sK3tW5uDftOjYqJUlKo41t+irAtcNKFLt6nZNHgsklZ6xHj+vD/IFP1GsF7lQXoJSQQjQWG3r+MQD9hXcfja1DSoowChuNVidO9UBuD9o3uzNSgk+Pf/r1K/+mT2vc9S8OkMH3JYFih7ja3UMVqNr5M9HQpii0SEjYA3zbO7/taa7vLFclRRhJo7FXWTzEQtipU+y6scOPJLAkNmQP8vl139vrq12HV6FULixtNXy9mrl9PcEW2FVye3/jB3lI54PJrc0HMudKI0TbaMb7z+GOAtCb+gv77VmtVCBlazlNbv50+9G0EsIZ69g5YzQJKaRihyAUScw6SUA0UhwaLoTrW8RpEpuUiIIwR7Het9O9dATUjOrKisoVQiEzOef/ZWYHMIkgKEgRMuCRuI1jOPdHF3K/fOri55/86rXC8Y2pR2ZHiy9/cwHgK/HtfKQotba+3jzVmHvwpzXU9kLSDEIHZgcCeO3Ew3+y/P+cuBh+bOwzY4nLxy7X4nJMJ8fTL392fbQYCkFBGAgSXgpKIglBgE/0DoQIhAyFioSMhAyFDLIfobzUBCTRkApO5oaOR4VASJf53AhKbprNwKaoVjF1KEzeQ5O7+jfqWy/oiWJUyAdBwO3UR3ROyvdo1/NtdittQogoDKJc4LZW3Mr7bvnqER9h447b2Gq98Y0gDIQQ/gGoHTXABx57B2N+xwoMgiBQ6cr1eP5bbflXvdsuwIHkKAhE12mXD889MyPzFrWPGoGM8uOvf/Ct1ZuvDd5O1nv21tott3mFvcskgu35gMw2vivk1/83vPOmmru9alv1XBQopbaPJj34R48tdZdtgBlSykhKNlBCCiG6uNo+/QzwTIRtqIrdNg9uT0tmhgAb6rziw3Sxg7Lo0y5RGoRBVCi1Fhu6d4wM2gFLHYHUZixjsvP0gy8eu3Gbt5bP6kIYhUEgO2vwXp2kedsHmnEbhoEKonilnNz8uW6HtxJiNJ+fHD6lghBEQtDU2GmbRk2tfBNCiNTq//DzH431FnPb+cpucE4PpRECqAHTt++cGh5eGBkdZ0GWnSDhAEtEDAeWJCGUc0mGd8YktP0HN+mrx3NnnbsoIjI0tTS0edIS6J8M/55trBdypdb6lm3FYydLvxH/+qM3P3kgHy999OfYWmYG3ND4yLhpnXr176o9LvYvvnHxs3LizH/6qV9TmmFSf0j0x5xIivzw5mQJ+uTInVeXnM/OBwQokjInVOKM87Nz1yLtAhwSRDmSQ0FYUoEkYdkaZj+tWRJLcfrOrZM/+hsAA/pv74bM978tTjxsChPR8Amgycw2G67s+NY5ch6tfc4SG/zt24pgqIJ8mNu4c6V1/fW7fATX+DNZ/M10uZw/Vjc61Tptd9reI9DDp3QQ55391A+Iz0CIclHj9rvJTQ8RWbs34dpMMGJ0uFTf2kiSpCuOY4+QGIBhz62UQsogP3y8Mf9664ODSkSRh+3dAU/T2WF3bYmH2DZ6dLbnLLrzMZmAGeBG1wVVALoONfRI/thx2hAx2Oe3UPv+Q41S56GCQIVBZI2WQgghyOxWH9GlUR5KXHm9vJux7HaWIG6lopgXNgMm2iEUB38KdLkzgjDI53KN21vxjSeB5oHTktsnxa63jG5v46GeeHPxrXmCGC6HpVEi7Ysndz/O0SxMPvZnuzyQx/tWMgjzrTvNeP48gG57THr7pCs4I9aN8AF0brV+R+UiRGzWLQAhhU71//TnrzliKURUyLfipI3yPBAdVhDC51E0mr89WZ6wBtayZFiAiB3g2quBQc77CQFyydux+nW5saBH1WbLP/lwIK9/7ff/6dpPLtK5H29sygBpYrGFqdL4y2MvNtaSPhz8k6/8w78Dgnxet1qOTS6Qv/fE5B9b+fyP98lZ7LxxPXn25PhJ6Ry8mt8pE8pwcI1QERlZr0MIL+4ESBAKKjgZDSXObpokcdayY2bnjVSAVxwVUU6oogzyUkoSFuy875zZAY4AKV0pGm9nPN970+R+5PHazRe+pr/1jdHHf91Y7denPxb69YY9m2OfBrt3z+6tGQQpZCCVCuTEMbP09lbzrqWgJ9v4lyI4qTfORyPHQGSNcc62vemHYx7ZoYV33RgoJZXMh4Wt21utG2/cE7a3ichKFadxKQoBlybaZ2L6U3X3brWHVe4I6u4xl0KEQTg2Nrn8wRsHS8GdDXbO8r36FTyIuXf/5ncdiXY1ns0Tge08wp3Umn9LyHyh+FCYB+Kkk//TLbP7GRJ3OpKDQIWhStYX3dYaShM0PNnZBnY14teyINHTN97+xTkWojPr0C0L2cNxBMLCRjkRBaNW13VqjDGd19j/KXbKrYxVJaWUMgiGGrffaV3/CdAa0NHemS1dPWb/t9V0f+EicBYH4f5v3HlLNZZU62Su/ABBGGs6R+qdXQxEncnvp4pvRCmpAhWKqHGnGd/4d0C8C7BtY34KQHCyFYxJzdoxEt2gPNOWZV8JMoykIsMEtoV8DkCzFQsPDT0YHUEQ1gDE8Sv1usrnjzvLFkyAc7AZ4hkc4G05DkQEG4Sbrei33kubD4pQC9KWBVFqh1j+zugn3knWrsi0BbFpnTWWi+mt/K0fre2/JXG1isXFdzbkN1fs5lrdsXNpupXo5xdWiqMX/rsLMa/f+W9XPsiOPUCtUrlWx/kf1+KPfyWZPBsQKEk7UWoMEDOkdCGNG7sUx0lDOad9wTsiEkQBZChkXgZjQaTZpc5a5ywzgQVBkQhIBEJIEgA7ZssO3D4jEpxjFgKSSrDHv/QLiOyHoA52k/6rP1O/9l/o8x8fu/3ORhxLY3xAaXc08/bw9p7TnfW5S5AIQYFSSqh8UIxbt+7MRpvXfw5I7lUCrK7f0vVbfPaX8yfG0rTutPCx2nsP2n12GWSLFp3lJ4QgglIqCEOzubZxx7YWPgu0DsH2gFJDsA6gRPp4vvnqWpGs8aPfrb70aH9HqS8hSCkpZcCtjaUr7zduDlbcoG3Ds9Y5x0LQLumCjiXz6BohCUhm64uA7t3QnXMMCBL+JOLM/uE7jQ9+JM6JiamPr/AqUYbegL7Kxy7lnjwoV6ik/P/aO7MgSa7rPP/n3JuZtfY23T0LZ4ABiIWcBgGKi0wSFFkMUZYVYdmy5VFICoftCIWf7AdH2C/2g9kKPzocfrFlvcim5JAeCDkk2XRYXGQ2RZGUKYKrZgACg0HPglm6ptfq2jLvPccPN6u6Z+/BbFjuFx1AT3VV5c3Mqjx5zz3n/02+2S5WzxTrF23zE+Fb7r1jNrvmRKVYIhQw4/zwDU6HJcoV4Q6M2PBOLNx1AIkskR82+vOrciEtDn10qvNdYnajgrXrx7z7kfI47sqfM3OWZI1qtv7Gq/2zPwSwlywFmYR8LqoialSZedddFFRVRBVqiENtB7AI3F4Z3G2vuu1VoiPVQ9M83PKu8HKttsbIvWxPa4HhEWYybJhNlpjh9sZ2pza4+PFRefmN9tSlzFoWIpISMSY9rRNUickVAhSqqqR57sa3fXvkTQRCAFhdfTnL9jUa+8XBixg2AiLS0EcBsFK5IkvKXu1UnvzBS4/9wfcWz/7iv6gbonAb5qSiuEhUYbOFXtAPZc5uuD5QPra0hFbrqfaJorHwR+uvEZS8+qAV5l124Ol/c/o7X/3g85ctQoQAACAASURBVP85f264lb1w/vzxpRd+c3Hxc1MtX7mQZqkOhuFcjXMjyuRY3/Ddoepar1AhnztbXi6IQVVjDTERGFxlUzdJmSAtk/kh7kERSmIUwQgKKhg5dRBRVWbWMywBrdY9bR/cE+6LLzq09NC+ysz6zJGtSxcT9s4LqWIcUXDNJO86rvmrYQ7JesOmWrX9FbfWOTu48q1RZr91T5UgWv2zPy3uspkQMzHAYGjEi+huiyIi0vENyLVDD1KTo5EbDsJ31iYzU7Prl2Sw0ivWx/eh93DYJUV3Y/29+7o/Ws5owNUZz+y97O4svn7Yu482M1s2bEgN8k7NXekXG3uJgieABdKVpFAHMoavuUSNt0kjIQ/DRFtbmJ7CuXM3esObbILaVGpHXDcFBML4R79Rvn2gN3/T7vvOmRfFD7g5Z9NGUGsM53k8yOsP1O5Pb2JtknBi6/3NNF/tF+sXASjKLlJms/sAUOncXcZRItJiKGbXETp3DkeO0OamaIOZjNl5+fUpYABELMMOlloFFm3v7GBitlqtQFU9uV33bTfci3F4YGZjmMgYw76/sb6y0t1bAy4ASRqS9zyEidhcEwbK35lHRUYqZHvA4p4/8Mf6535a3YppClUG1gy8U2gZD0d7AeBW93a7754NMzGMsXMH5MqZer7Szze+BAxv8R0cLYVoSKqqNYQasAoFjCHnhsNhkiQGvvBOVb3cQYbD3P4pN6HTOZdms5XqnAhAxFRqWoe7WC85qYKgKmA+2DDAiZXt184/d+RnfN0ipK41t3zK2FfWVrho9POCwJk1TvXU2umjU0c3BjtlUIsAgO5TPzUosg5N9/rbaxYrml9Rd7A2IST5sIDI/3viI9b75tPu/F8eaWP+4t848tGN4eHnm5sbNQ9HIizB/5eISI3J2Z/a2E6n80u22y1Q9D05TYgtswElbGbTWsWYoJe2c9sTEvFXfx10tBTjNUwN1at6QI1OXqk89c1ZLIOWFt/0Ab8L/gmAotPor8z1t1fRJ1/MVCcsSy5KUDAzjRqe6CbsfFGZFZSktpYlw3XntzrD1Wbvwodd778DAJbv2QLb1eP3nUZxZVaGK9JfVWeTZkaioqXf7+5czTWEs8TMIVVimI2puM1p7aB72W2feVoGp4Hl0chvTQsA1za5tjlecbnFjacxJkmTvLtafP3LQ9be2VekmIGmaT0T5zFOS9zsaBODKWGerKT99SJvV4dvfGA02tsyD3ze1g5zjZ0KFMYwjdZ1w4HZfYgSaxM2g80L7ht/homJ21sdjTZh6kdMg1VFQ331Dc8CMxGY6fLffDrpUv9737zZOxZb7fzKsi+OQabShlPx2HVArj2zIbFmLFiJqJ5Whuuuv5L0z71/fJSqjzyn8F50ZPJ2w7FRwryuFzn3fm204xMT+PrX7b6DqbAQvFceH0AiJWUoERMRGIaY2Pp177d/BzgmWz9y7dd8PgXNuGHFOWJmIhlVwVyzFwCMYSKwsVliig2Xt9f6579VdK7s4SyU8MxjveZ7ebjhxXOQ9CAChIOH+ci5J6g3kJIWs7I9Bxzd27f1nwFw2/VidVYaZ8R0qZolZaK1dKsYr1ncmHD1ICamhI2p2GJtRrdd54LtvP6Mv813cA6Yt43TSUO9eEuGDWdJJiqa5ypabVScF/WaJnZuX3Nje6hekjTTYcdtXd7L0XvzgRCAtZXpA0+oI5XRCgSBiAzYS6EaFr1VAVhzbGZm//7D+zvDuYnqVupz8LopzjId/5//aeHQM8pJPvRESCqJCo4v/Oofv/zHYSsKLAL9Q0923/eJ3E5s2glbmJpN96f0q4NTv16bbYLsVNUPpcgLZupm073NajY7sPv6zUPJec+dU/V2mg8LSlMiIvVeDLnMdtQVTrbhL3Jv8oMrG6enZOCswrKxRARM2GxfWjXBCKPcOeJrTi9G91ijJQdBCIFaqAprvbP6nnMb9d6rwNHfvM+KeTdhaSQ7suS2/7To/JrbnNHZLY+UOZ2bqpJ3hqwxNk2sMdawMWwMs2Fj2BoGW5OytZYMo2Hqrg/XaQyv9IeXvuy3f8P3fhtYARb2doG+q/FL7//I9m/4zf8q+eOGpw4cnnG+b8gwmcRYY3bGbDgxlpnYWBPqBhs10/nhnyq+7DY6xeXnXGe/6/4WgDu0Fb3jQFi0zxdbV9DrAS3p/5zb/B0/nAJV00YD6pKQy7OcJMZaY8iGHTCGYc2/Pv7xl06ev3JOBpc+Lv3fvpPRLgOwdfbTE5KoVCCJSqaSXveTCCqQYnuwcWHw2o+APRj+7doE2cdc1lTDWh9KqpLiBptIVV3NNWb4tPY+NHm71YGW9D/mN2d8vkIo0qkKlK3lNLGjE2yMMYmxlilhthV+1E1udzrdNg0ufsz3/svuo6T4tGMvhqU2vOHAJFWtmSJ1Jq0XpsDFi+Uo2m0APMiLauKo0Eay6wCKphjvqaYQV3PDTDb7MjiN0lutPNcynGKqVGuZWrKADZ/TMcyJYWJKkmym2Rysbg1WOL/0Cen//t5OwQ7y3l/gtnhDZEgbuaSqmWoKTSGpatjZwihIenWhCroT0v+Pe/7kL+18B9e/6j/907g46VemjWazc8mgGKYEttYYw8yWKbGWjTFkjWVrbGLAbAzMRGUiz9S5rXw7yV9/rtg6WGzv5VM9D3zeNo9kk4aNsdZCkVhTdbmwsYllrRTOpZmpmGS7n3uFYZtY+GGv2Lh487fd4W7rNo48+vOzM8+JU0OcEFkiQ7Ag9YO82GIVJiXxieFGLZlLk6HKs/N8JMEBRu71W2vttlozdWDt3JrrFxDJaraW1TpuU8Sf3z73tZ98J2yo/alfyWcOVSghEHIHqGZJQXK2v/mtZOV0Vw4N53pbHUArtcrsbG1r28N5UrHMFbJsqhdk38/WB/mk/3dP1T/3cuepbT+w/Yv58OIgHxQ8YPiBM7nL2FhmQ5QQH642p20GCiYbRKHacjT3LasvVEbBT0TViTgVp1KIOIOC6bHTa0fP/PE9ONb3hhYwByzg2AoW2nhhoX7w22QvFsNeMG2jJOO0buozo+er667psKtuCCiDCZDhzHDzEWABOAGcAObvtyTu1eMPQXcBONE4vAKzmQ+2oSBb4SyMPKRE1HXXJO9qMQTABHXPaL6/6KwBL4yWRtp3OPJFAGb2rJ0960WZb1UpoKppmtYaSffcK73zL49evlQefyza6UcoyaDKaYWzum3OAIDCdVYl70oxPDA3k2D69IkJ4AXg2Js8zq3WXp/5JpP2iwDQ2sNrl1o7z7/tG45+t/seIZsBYJuZrM6N8pPpt1d10FU/yGwNbnLr8sGbHKW9DW9uDgBu1t27l2N47d4t7j7XycwRspkCbDOu1E1jHwCo+u6aDLbV5TarwU/2Lhy4q3O9l51dmkOrvedzcSNKt4BW8JmqHvwWmQtF3gfCd7Bm6/vCtQSA767JcLv8DoIJpPPTg/cfwQt3/B2sHHwyO/AktLwG1w0VCq/qYUJ+liGGSVQLL8Gmzxpaf/GLe3nzu704NxpHtrfPPffsvyIlS5wQhSpKA3XFtnM9Q2AIiRhGo5o2K3Yy0099sPoXf9334p59L/9oORl0i/5WX50zQK2RUULVjKea1c5679nLp//RK0sbzzy/8oGPzQ6Yhg67lbSY+xXzHvsffvns85+oPb25sS3OV+tVBtR5qPq8YEP1em1yjvv9arM67Q42Sak37DRX2pWi//7JwV+uVHwhkjvjfcLWEqVMIOxLKu+pTITuQEJZJhrWB3ic1lfVUCODMgp6lUKlEO+YxKC5nn7w+wfC/dRbIxCOOH4cJ4KP68k7/8qNXcfmH5LK8+LIFHspuEbvmbHjxx29avd2x4FQQnfa9YFwXC2Spmm1Xu2dP9E7/5Or32QJWNnbGO5ywHsOhCsr6PWwvHznG1jE0WXUupi/5TxyZQ69OpaP7vkDs3iPjtIehpdlMAb1+o0D4dGjqNVu0/t7071bfKDn+rY7u5IBQHsOdXsn5+Im2ypZurMLyNh15+Sb3s17zz24OO/b97ceffRZCEHUgMK80DKR+KLoqAwZMFBSIWhiKEuMgVSzJEm4P+wbMT536rxlMgBBmSmrWBIxhIm6XWif+dmD+7H/aLo91H4Ow0CoUwEzDarpoT/697/8sec/2Xj/5pWO994wGRCJEIGJoMqJybK0UUkrB2vvqz8D4PT6y0V3qz/wru/EFfAyzogmTExUY3ukOlEzFuW6Omhc+DtK9IcyB1FViFfxKk60UHEhCiamso79tcZhM4El0MMJGJF7yyIAM3vGzp67RSAMqGqaJo1G1jn7k94bey15iEQiD567WiMEALT6/U8m9kCtsUHEo8VChKXRxCQiTtWDiIkZpKrOeefUe8lz74fic89Ehg2XS3EEhcsLXziAsnrtcmNydnauaRMjMCJQkCoZJmuKir3iux86/IhINUHFFx6ilpjBhtkwE8pSClf4PC+Krfzi6vk3Vs72O/3u9qDoDcWLEQ0tEJbIMhNxRuZgpdGwKUIU1HKPQhgcDTJUf6lgXBoDD3UqDqqJNRazh2uPfnQSRx9WjUzkntNCuUa4cbM1wp36QICIE8qGj827Uy89jNFGIpE98SYk1q6hBejZc/98azM1RGRKxbVQOQkylXQyMVUoaWhiJ2M4MWxVSJwSjLGW2YZAOSqsNcZYNlYV2/1htcEvdQfkfCc1vVomlUwrSV5Ne7VkxUtG6ezk3Gc+9MhwmHvvLVtmNkyGmEPxJ7NlkxCT16KfD7YHw+5w2O1r4VkpASfGhqcZZoCqbN9TnWimFQGUKOjJqpKWBfoICdGQlR4ViMKphqVBJyrWCHOjkT3+9NTdn6HIWw7FzRp1d08QCRDvrnz3f3j71kqKRyKRa3iTfYS7WAQ+B1Cn828PH0m2N/sC9Qoi8qoMMHGWToik3vVVilJ6hka6JqN6SyJOjYWISAEChWVVkWLg1la5Q739FXMkS+ar9pVBPoHJP8SJn8nnegUuDvNNkrw99EMxysw0bpgq2zlCfyIpwEHliQAOP0QG4HIVEAyaTCr7s3rFWoWE2vZSpGjUok8hHI50jKRcrRUPdaFShqGGGxuXDjiPpR+j1aLFxbs+yJG3EjTyfruaa/RBiCi1iX7m7xZLt9LFjkTeBhw/DgDnJrCV4eTDqgy4j9x9IATwm0Dr8grX68XsXOHVilfRUmiGVYlgbCU1GaSA5OILJiUoA5ZgiTO2FZtVrSURL8XQ9QufEwkZqJOiV5iK/fblzt/57CO/9712PiTPF5t+8s/zrTnD6z7xhfhBAQ9mDglYA9Rs0rSZqHSKvqgQESl4dyCkcvEPgCGum2Q6zaZsxTCNZYjG+kHjFplxN2zZLA/xKhKioEquosTi8ukrZ2b/6vvAvXXfjbxFIBgmubYxfHcUBCCqxAmdjEnRyFuH1qiQ9WacuFUZ55EtvHBf/OMeOvckECKsnZx+PRGRg/PI4b0XZvbjyZYCxNZWDCoGMPAMGCCUaFoiS8RQNpqaNDXJ5mBdg2gtk3jp9wvN7L/80jkPN13JmLjT7xuYFbJFPiQnLEgMG2IGAdpMq/srDUPEioZNO3l/IIWgjL5lLCQwIWNTN+mETes2SUZtj6MFHh2JCoKgICq9vsoQqKIqqg7qVQqRQkStEWSHtH309e/fowMbedsw1tRQVYDSxLjtKzLsPtxRRSK7WLrdZG5hpLsWAt4igJknfmF4biiWZFDFB16lldpgT03qbyfuVSBcDIds+UxWzYbTk1QAToTCvFBJAI/QdQBDRGQNYIgMyrikwFj8LOG0ZmvdojtqWiCI5H0HqDHouCETSUHeF568UTVElpmJQo1ozWYzacPAEAREdZvVTOLEDcV58QIhwBJlZCrGVNhkxpgg3RNECVHaoGhoGBzNDsvlwZARLQOheBWn6kUK8ZIYa83BufTJpxZAbSy9xfolIvef8aTQEDeostV53W1eeNiDikQAIJt/UvRRxfcUsyOZuNESVZCFhJKuwP2i2xhP+xYB9HuvVq+sST0R7hoSN7sWA+EtWAxHbXubJ5piEtZCvAiNNMCJIAArhCAgDxBICMGhogyE5WRM62kDhH7RZQ3CkKwQViURN/AhsWlhGbBMZkfgjRpJZa7SSMmAQDDhJBuilE0dGQAmJVWm0QIhMNYGKn8pS0LL9cvwLylF9MayohIsJpyKF3EqYg0l6fx89uQTk8DD0RSNPDiuFlTcLShMRNYYa5Ot9mDQfvVhDTAS2aHVAqCbSc2lfT8Eny0flwRACgDIuYAkbPJk6If1l3x32m8cwOFNnJ+UyWLAKsVAVRk8mU18uLW49M6qhL+HgRAhEJ67gG7/fVMTjx7c/5zPSUQ8g5VEd2wLGTBUOlRoCJCAEikgpb2RaaZNS9wveqoegAku8MrEygRSGCjvCoEp80RanU6rCbGGqhjstMAHOexyXXBU2BfmdoQgm69Bs2B0VSvL4ENCFYpgKlGKqJUFMuK8d4Ba45gOz6VlFARigcy7CtrRYqU0SW2S9S9PDi4cBfIHqLkTidyE4RBZpuJ6BaAKr6NbtwKE0sTdASjE05AtTaxWplaLySsuq8vx8/ITb4RdkRMRWN83tVCrrTzU/bn33NtAWLK2/vLa+stQ3b/vWRB5FQJTaWwLATyBlUBgqAdYyRMxVMrHSaFM3EgbVZvlRb+Q3KsjVYISKY1KXRhkCBVj6yZp2KxqEhNynBTSnKoj34GRg9joF+wkPykYsoShl9nQIOKzK01aisaXRkujpKj3BCRWGPUmnn6ybJaIUfDdQPhw7A6Bxpg0SUyW9C70B+efA3Cf7CwikTuDGZ2O54Yp/TyEiIlBipEo/dUIFQrb7EqtI+0hVavY9GGNiEBzcyeGwwlgpLkD3EST6BjmMmDhRio2QVxtAjgPTGCuDRxDvXfXYjdvnvsSCAOnz34ZcnB+Zo6Dkb2CwT5M4ARMYMCDCBQeFIBBUuqZkQCkSE1WMSnU+1K2xQM6KrRBxqbCNjWcMJvS7ViVSEPzH5WxEOUvZcpzlxOTlnGwNBRVDZNC0pG3xMi2DCooLXld0BRV8VBNrKbIeXDF9JorZmF+PkbBdzzl0m/olAWstYbJsE2NWX2ikv3w1eHZH1xvLhqJPEyaTdpUJvKqRMHYizlMKUaTABHvRUL+TEWdK7hDNmdSD2tJHEb+U5ubpwBgebkU8LvxMtBJtI+jdX6kaxpYBACsAG1gC/g4sIj2IlpLWGoBJx7WveN9DIRA6/T5x6an1xOQiiEOIZCImQl+dEEpW/1Uy2oa7OiZCeChIFgyltkgDf1/BsqkQY/NEjiUqpeTPGjoARzd7Oio4kURbKEwbogYLeqUM8RQFaPjMlGUc0PV4NwnIxEZcSJOPQwRzEZdhXoATrbbz/zWb93P4xl5S0BpbgyJEjNDYY1JM5tvVbtZar+7Onz9BwDugxdVJPJmSRIAYA4mwsGU0LP3RRN5Bd06wpXTbfr1Z8xT3xivHDE0LSyTFRUivsaHkQ6/jy71AdB7P0Tr627t9Z2/7XucaI7qF+j1eTz5Y9qYcm2M7wupeonSbdgG8E3C30b9z/X0fhw5JecW3oEzQqB17NjK4+9rn375YJoQwXgRKkMTjX6YVX3QVlNyoUxUEQyUx4EttC+P7NswTrEyIKVpAnaUX8IsjyAhmqoalOowQShGQePXcshvQRUQVS6rQzFKfSmgoiLBYkLFQ1yIiEQZV96Yz049PTm3wnPt9q/cTLo+8s6CrEMKIkqT5JEnGmdfQy9P5MpssT4DvPGwRxeJ3IqRNIjKsO4Pb1w9XTsCLOrGZ+20CEhV2ZhqlgyGXtUSuVE+Ddvb27zvcVt7xIs3xjB7lz0B/OOdraQv6cRaYgD0DODSV4FW6eQ88bJunUkfmfC0wUqEoSgxrYlhc+iCdj/iNr/74A7HiLuXWLsFiwsL7RMn5l788Ux7bZUncmPgVb14J96JBK+GUHjpQ7JR1Y0sbUVVCCFoKZESiVIorlFAtIynCghIlURVEJ4WlGDCn0YlqUpKEC0nfEEyLQRBLc3mSVR9aSURVNOCm5IvRArVQiUXP/TeQTUxU9010cunnp4E0J6fj1Hw3cEisGj3rRZrl3TjArbOnztzcfu9GP74qWI92AO1HurwIpHbEKoFGUBewVILjc6uP/4FcBy+rSPTVS/a6/VVx6bjJS+++CLZTFmZSUU8ifqr51TeGnHqBeLVe3UNYAlY4PlXef5y8tS0VyIN1ZECgpKSeDNpqvsb9rGH0LN/X2eEeOGFF4IRyanlpV7/5y9c/vhnP9IVUeeFWAkcEkykCGYRNHa4LhsaKMwFQx0NEcIanpJCSaA0nuRpGTLL2aSWNaJhaVAUPNZJ03D8qXyrskpGqUyMhroZlbIyJhjtSiiQEVIlZZtMr71x5MLJA+3XmVa/3motxnXBdxO9738l/FIAyI7hxLM4tvKO1J2KvPMo1S0ZISOK7ebO53bup9D+qtafz0USKLEZGQsoXT9j8sNgDFjWWPjsqr+6BEoiwsyiUNcDjlPjS9yskWFVFVFjyLARESKE5XYBCpu4546xHpbl4YNcZb+/gRDAeE8uXP7SdLN3vv34kQPzIBVVJz5EqxD7wDSyPCqhUc+nD6FvZ1mRiJS1bL0Iq38aSjtLFbQQ5EbTwXLiGDKuyorgGjGqKS2XAykIY5VLxUFJVERVxAsDhpXRrKX5a6sfffl/hxG2lpY+E/sF382cPHkX7nGRyMNAAWGyxbWP19ex0KJzXYuGaMGqROSVuXSfu/bpxCoju6HrxHcJRiHl7FNsFXiB6p+EhSqc95bBXgeNo2i+gmXYigneRCKovbSVTzYFH8fRZSzfp0NwLQ8gEO6w3vnGeucbefGJ+cnHp+r7QSQqrgx2DKHybiW0+unYCR4hM+0RAheNtbNl3AE/aoeQIIyNUOdZ1sMIAGjo5Q/xMvTRUyklo2HqOJJRU9VRjaiIkFJiyDK8TG+3+2fpG699gNFqvdWMdiORSGQvBKWstIMDp5AImscBwA2RDGjFUTYJ75lIVRlkmZ2S42uVdQFAubxg7lyod23Cm1FGjzjNse85MdMWfa9imNJBnjfraL6C7YQmBsgBSsaKJrRp0VrCiWPXb/M+8UADYeD0hW8d7e+fOMCd2QEGqQp7VagHSDWUlpazw5F0Y+h2GD+gQf1fSzdFHU0TlUCy84iGIqdgghH6IRilGnJQ3w5lUQBQxkpRDTIyEjS11YCMoYQS1DcmfKLFz/7V/yKsfh2tz8SawEgk8nYkSGVVOjCbqM2VD9oM3S01KVsFxIswMVScV3ACd31u9JYTAQWMV9n5FwCkHZANSmFFrUpa2FVSM/RJj6RuvZdQ1u8LlRUstXB0Ge17uNu34iEEQgCyvn5svf7D+XZvgszMtPGiQipImRG6PIWUSJVACJ32WtaGjhOmo/cazxBVlWBCK6CGEhgdLwxiVBcauixEQ1YVMtIPhUqZXA0ZUSgxsWEiWNfpNXsvPfvYp5c6AFpYilEwEom8PSERIVJmTqsJdGMUpwgVq+rDAh4zQXWowokjIvZp6DTb80Yw7pATQPMeVl+iZEGzA6WlAVQdsRAzMTWZSJWJ4FNxvXV39vuAYLl1Xw7AjbivVaM3pYXWEpb+aOXzHz/1aPb6WrG+7sygUJ+LK9QX4gvxTr2Ddyq5iEfwvJVCpYB4CZ18EgpNc1Wv6gAv6hRe4EpfpFCDKkX5ZHWqhUr4yVULkaGE332ufih+KC5Xn5M4lo4fVHsrzFf+8lNP/NKf/O6nl5a+3mpdnwOIRCKRtwsKVYx8dEJfWBCNHNmKqYJDq71x1N8ntT76javeYI8YszNbCf/rVQrnvZdSjMkwwhokLJw1nChYiN3hScy1ADzI6jPzwLa0myUsLWO5hdZ38J1v9L7yD9f/3o+HP9jCeqM5ubMsW+p6lv0Ou2tfgnRomPWVyi8qo84/GRvIq0JC5Wc53QvFn6VrxKhZQgqRIJ8tpEJQw0mWHbx8an//0qWnpn/pi384t7JycmEh1sVEIpG3JUePAuCcOA/dZbAmwEQUrMxHCswEhWGaoMFw47C/uICLT1Njg9Mh4EPrxdP7qydPnuTaDNVmRl4J0N6k9qbGG6TaFtU2ocrMAEGcbE1j+PeRnlG/zTY1dhR6tFS0DGX6xlvaasi5jwFHH6TKzMNJjQaWsASghdYX8IWTqyexinT7s/smDk7MTokv1CTOCTMXoh6kTAIIyBKESAlGIIApy0ERnJ4MlDVYTAQbeiVSDt0SI/lshKIZBDm2kItVY6xKnhyY6J/xzXMXPrH8fwEc2H7jxLFjCydP0slYGRiJRN4JUGlup9OVStrsLJ+vjv/UOtz/wbm0t7W5OWgWm+8rH+03Ud/SvSbDNoFJ6ACe9NoXLGLfcRowwbMh8uRGFR6q6sMiFfms2pfpy359/93v6d55mIEwsLQr5n+r/dXF9uKL/ZP9CZcl2ZGD7/F90cITkRdRCSpB8OI9YAEmGIIBGUAIhkIsDE70wYNXaSQ7Wqp+m1B4Iya1DIXAJKqpnVp5IyPf+/7WyVMLj+BHYTxHzp+PidBIJPIOoqyy10Fj6CrbW5VadbPXNwDmqn55y055u3H5EeAFwI0EInT0392Xw6tzpDoEAGxiYgtb55EJIFdfPE/ygQ9Q/wJXJgw5QS55E6RZLe8PHBNCl7+I5EOyk1t+fT9w4j4dgut5+IFwN2HtEBewdGHp8f1PVTroane6Nj31eM10KgQ2zFp4FTCREIUeP69qwAZqFEzwUFZiEgCkagwZS6ECSqFJYglilGGNsVo5tz7VXZvj9mR3/dFLp5bQAhCLQiORyDuSkABloqK7uXr5ud2iuG2EIs3jwAngGLC0EwjJQa6KgyOTOgBgIal2gBN4rIfU4fAEdbtsSMHBAYhAfOg5njjIJCAh1QK5n7qAF3/Rb7rgRQAABNZJREFUL7zIFa9DVZFRdlYmjuZb/a8ML3/zwRwTvNUC4e7Z4enLr5zGK4tYXMTiZ7d+LkuzKTszrA4e3XcknapJb6iFqCtFEoihylIWKwkBnsmoeiG2xKlhgiPJJzLacHol8VNm39Yqqfz1Xz/xuV1LsrEiNBKJvIPZmdb5GrA4ckTazbVqkTd0aoKqlO0OqkRIevjwBQBoNmllQ6gwaoPBATNpfVoVUF+a2XkBGwBoLQkga6mBM6JqQm8Auw44Wb+He31bHk7V6B4Jy4fHcOyrb3zlo69/5Pdf/b0//NEX0qn0pTMnVs6vXlpt93ze02I4hG7YslgmdEdASZEmebPeb9a3eWI4ifa0bjz9+suDKdv+/uTa1xqv/sKjv/ad3/0H+MIJlG2bsSI0Eom8w1EAEBJFG1jcS/qRiBIti2IAlLLKRKU7gagqPAv3a+xqfAXalyQzQZMkbJIImQ02B0oAmFmMLZpmC2bTGpWxmiYAEd9d67ruBPDgGurfHlf+FlorWJnH/O4p4yIWTxw/AWDhhYXwz2te9YXjOzc7JxcWPre4CIDCM1s4tnJibr7dWooCMZFI5B3N888jScym2n5SeE8Ac+JXU7nyReD49VPAXSwCSObOJwcuDgd9ZgJR8fIngUWeeiY59B4V733p2cuGGSxa9g8SGVUPwLCRrrEwU3O02hsEcVFVELGx5BwMwXkX8qIiAoiu9WT1KIBbju1e8tZKjd6MEP9O7hJ1bKH17cPfPnzuMICVYyvzJ+dv8fKtiYmPffvbS61Wa2kJIRAuAYgikZFI5F1AO0NzE72pUmcZYBavYUb4hdu+mogtcU6kAJdN9R+TjSOu8gZN1UIAC4WoCiViETFsqpVab9AVCSJg6J2tiiM75R07kTD9U+9KfWdmVlXvBSoYbMjqD4Eu8OBsKOJ0KBKJRN7RHPwsLk7zoTO2OSFaGpjLqsjq127Xq7cIIN1/Idt/Kc/7Xr0BDX/yZ8BHgb+i5of54CQgREZEUKp7cZYwDEu/JqYDgiHynbR44ygwnx46ne5v572hKLxIcHsS8SBOjXUuF4WuLev6mQdxWHbxcBrqI5FIJPKA2P4wcEI7P1A3o8Np7Sfaz3V4AnkXt/F3aAEwjW2fk/Sb2vF+a5VSp/mrAJBfBD4Nn0JNJVMYTUiLXLULv14rLvwUXIpBX3pD+Nek9wkAvjPth234nKjenMitrRhio1poRbYKdAn91x98FEScEUYikci7icVd/73TV13/wkUApvnnlAHoClfhIGutUT3qwnWvXQKWgMVkaokzVq2rQrknhcrapx6io2ecEUYikci7hBbQBdrA/O3mgte/EMCJ617YAqD569L7mvT+qXY/r/2jwDJwFOgBR69+yRKwDLSAZRnAd7/mu78uvUPS/W/af3T0qjsa1T0jzggjkUgkcpe0gBVg/k7UQVtAMIFqPzBN0UgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQib33+PxajkPLHE+68AAAAAElFTkSuQmCC",
                            width: 600,
                            height: 180
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__b",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 600,
                                height: 180
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__c)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__d)",
                    transform: "matrix(.12952 0 0 .12952 .493 5.57)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 200,
                            height: 200
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__d",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 200,
                                height: 200
                            })
                        })
                    ]
                })
            })
        ]
    }));
var $b0f91621c24890df$export$2e2bcd8739ae039 = $b0f91621c24890df$var$SvgCephLogoPlusSvg;





const $a4996e3fa9df448c$var$SvgCephLogoPlusWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 150,
        height: 50,
        viewBox: "0 0 112.5 37.5"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "ceph_logo_plus_white_svg__a",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M.492.324h111.02V36.59H.492Zm0 0"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_white_svg__a)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_white_svg__b)",
                    transform: "matrix(.1734 0 0 .1727 -4.592 .325)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArwAAADSCAIAAAAnuYQXAAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOy9eZwkyVXn+XvPPM48Kuvuquqqvqv6VHerL7WOlpCQWo1ANxIg2JkRYga0zOwAgs8MO9qd2V2YXQ4NaD6wwMJwDYNAAzpAQhodjdDROvqspm91d1V33Xdecbnbe/uHuXtGRURGehwZGVlt3y6lMiPczc3Nzc1+9t4zM8Dj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4PB6Px+PxeDwej8fj8Xg8Ho/H4/F4LnRorTMwpqjqcl8RdSu05U7sfpbH4/F4PONPsNYZGCO6CIXhJu4FhMfj8XjWI7736lMrpGcR0XK/Z0nHCwiPx+PxrBdeoj3WUIwKqpp2+c2/iwgz95qaVw8ej8fjGXNech3VqvogBsdLB4/H4/GMLS+VLiq7Vmi2GXRMxH3b8bD0wy6JZMSrB4/H4/GMGy+JnqkP64Lr9fvu+wc8PcVLB4/H4/GMDxdyn9RRKyxnIXC/rFInPaB68NLB4/F4POPABdsbtSiG5YIWOx7QJc3m+REdyW5g6FVJeOng8Xg8nrXlAuyHlpMLK+qG9nRiiaAKTdJVJWbwMudaUdW4eycCAUTdZUQXR0b7h143eDwej2cNuaA6oeVsAFniE1utCO4XBZgG6apVBOqKmdLCzmKN6JJnLx08Ho/HsyZcON1PlmjHLgN6VYUIADKm5YDakZPVoyfD07ON2QU7v2jnFsOzcy6ZpbSINLL5HZtNuRRMTeSmJ/PbNxcu2lzYtqn1cpEFkdMizdMxOmZyOW3hdYPH4/F4Rs+F0Pd0CV9AJ/t/2lVrYk5QEQrYmQIkstFCZfG5Q3OPPrP47KHqgSN2vhLNL2qlJvWG1homCIwxIAWBmq9MkEYoIqZU4EKOJ8o8UcptmSls3zJ13RVTN19d2LElmCwTc5wHESRrQLXbHrI4ULx08Hg8Hs8oWfe9TrNi6M0NoQoFmbjbVitnH35y/umDZ7/zxPzj37VnFxhgFQZxYExgmA0zMTMBFDsc0mvE8Q5EUEBFVESsFSsSRU6hCCG3bdPEtVdsuO26yasvn7z28qUsWQGBmFdcB6Idrxs8Ho/HMzLWd5fT7pJYrq9ttjeoiIpyYNzn808dOPrFb80++szCkwfs2fl8MR8UCsYYA2ImBghggEAEJZD7E+5n06Wc1UKhABREUAUUEKhDIhvV62Gtkd+5pXjFng23X7/5dbeVLtnhTpcoImOy7F7R4tTwusHj8Xg8o2Ed9zddwh5xfld6nnUBcA6C6vEzp7756KFP3rvwzAtaqzNQKJeCXMAKVmWQAYjIwE2VIAaIyMmFxNhABCiBYqEQXy3NmZtyoYBCoSqAEikhbDSial0M0UR56qZ9W978qplX3BhMleECJ7HCnIuOEy68dPB4PB7ParMue5qOLokuRxJR6gIAsPji8YOf+PKJex9Y+O6LhXIxyAWBMcxkAFYYIkPEICYwiAGmWB9Q+kvTP12aFYFkxkVLBiFQAKKqgKgKQQnWirU2qtetSPnaKza9/ratP/C6/KYNANRaEBMvKYMsEQ9eN3g8Ho9nVVl/3UwXl0T7vIM41kCEjQEw+9TBZ/70M6fu2x+dmcvlc/lykUUNiAFDMERMZIgZMEQEGErcE0RY8kq4CZRx2bk4hvPdFInhwVkYlrKtAqiqQEUhqgK1BEAbi9UosrldW7e+/fXbvv+1+a0b4aQD83KTLDridYPH4/F4Vo911sd0mVd5XtRC8jOVCwsvHHv2L79w8BP3aq2ez+dz+VyLXcEQmCgg4uRPSjwU7GIanEVBiRLTAqFtCQbVeCZEanRArBti+ZKIBmd+EKioiqoSWWhYb4S1ev7i7Vvf/j3b3/3GYLKsqhAlwy26oYt9xesGj8fj8awS66mDWXElhuYQQhfBQMzhYvWZ//a55z7+pcaJM/mJUmCMARhqQE2KgUwcvkCxvQFw6sGFMhCUmgrLGR7iTzSJkExkwdKUiuT3RDHEB4gLjCQ4xSCaqAfAEsJaPazVC3sv2fX+t295451ITA7Nd9rd/OB1g8fj8XhWg3XTu/S0dpNYYcMAjn5j//7f/Njs0wfy+XyukGdV53owIOePMHASwWkFGJDhOJrB6Yk4doHQLBqcPkjtDe7/mleOpNimQCAlpdRJgdTeABV1P1WxJB2sqgWEUK9Wo8jOvP72PT/13tIlO1IN5Kdiejwej2etWB9dS3fF0DKbQCLLgQkrtYd/82PPfeJeVs0XC6xx7IKzJRgiA2XixMDAJvZQNAVCgpice0LTJRjiGAbngiBKjA1KRJpYIzT2VyjBHbRkfVBVSidnajwbU5IZF6Jim6RDpFqbXzBbNuz8wLt2vPuNADSyFJguNoZmSeF1g2d90fKa+wo8LNZpwbY3++sl5xc26+AZ6NIovXWQ3b7OoxuOn/vuoa/94m+de+pgcaJkmEnVNBkPXPiCAVJPhCFmuIAGNB0JJmIiqBLFbgiKdQOwJASQfhuvEekEhSolagLQtCdP85oGSGoaIJn4KSzUiloVy9SoN8JafeZ777jsQ/8kv2Vjc3Rke9Rny+f+HfOsI5YbG/hqPCDrtGDXabYveMa99FsUwwoTLEWJ6eCXvvPN/+u/hOfmC5MlFiVVjt0QzXMiiAlBog+W4hvSyAYmVmK3R4S6FaNd/6+JFSH1SzRFNgDk/BGk5xkbzt8Nq2UlSV2yOsQOC+t+qloVC0TQ2txC/rJdl/3CP9tw23VuLYfUVdF9r4r19YJlcUKlrK9b8yxHxofuH3d/rFi841mw6zTbLwXGutyzbCqx9KcIMR/++v4v/+x/gpVcMU8iTSGNcCsuJEsvJDYGwBAntofEc5EaGxJ7Q2JsIKJEByQmh1QxNEdEUmJkiA0L7kiNv0DTQtSKJcODpvENcK4KiEoEtSKWqV6pWsO7/+UP73jvm9P7zTIbc5zfrp5UQnfG+TY9XfBKcZVY1wWbcbXfccv2SwFe+ZA1otnG4H7pPoZWUQAHv/JAo1IPykWJrKqKiI2sjaxVjVw3TBDDwpSEDqiFWE1+d8snKASQpf5blahp0+zzlmZwEiDdSdvlzGmH8zWZUw4gothJ4YwEqkTkJnZSvFCEky8cEAXMOeIcm0BQLJfyhl/49T95/tf/WCJLzGptukBFPEGjUzMxxI55iKR5HtsEPeNA+8hhrXJygbG+CrbL8rijz8xLnPEVDc1kqRnEBGDPa2/JT5drswuiEBAZY6bKXC647r9Rb1Rm5xdOna3NLzbC0DJZokg1jH0BalUi1UjVShyT6E5UjU0N6laNTtZhSJeLhpuUqSCNJ0eQIunEnHkhjpTUeB3JJATBJaoa6waQC88MkoDNgDggyjEHipzJlSbKx//ss8/829+MFipkjFrJspj0+LxamjCUpFY1fc+a0PzsOnYV/uEOzvoq2BW80uOa7QuVMbXtdHdMdDmLiI58+/FT+5+Zunh7UMznivmJHVuiWn3x6CkCaqfOVU+dqx0/U3nxxOKLR+vHTxs2+UIuCIJcYAyIFUEy1g/4vIUcKFlP2pkaktkTSVxkMmUijYiEi2WIzQ7neTSSw5OpFtrkz0jvRFUBZw6RRM3E9hKm6ux8+aZ9+379Q7kNk2otGdNsjxlPO97Q7Qor3tGa37InC8uJv469mg/yzU5/b9yYFGxqOu0Y4p0e4+vD6BnHgu5S17t0FVkiJVPChWr1+OnK0VOnvvP4yW88Uj9yQmthPp/PlwpGEACGOCAY4oDT6RWx+4AUBEUc7NgUEdkc2ZBGREIp1haqTX4LNC3zcJ5uANK4h3T5SEkNIdBIxKpERLX5hdKNe6/+yM8H0xOpbnD+j+Xueq3eq4zuyY4HdA9kyYJvTcac5d73FR+9f7Ld6em9S78ak1LtkvnlmvoxyfkFz9iVct/j0TQk0O18jbT/dD15sqIzVAFy+2I7JIrOPvLM4c9949Q3H60fOlEol/L5XKAUEALnKWAyYENwK0FRohua622sADSedblCRGQa/dBkb0CTgABin4YA7qdVcT+d6yS2N8wtlG7c22Jv6NjXpoz+veq7S2g5fcV1Kbp87luTcSbLK9/8QMetextbsrelY/i+dPRSrThmGIecX/CMXRE3W6VWI/F46qMbxUOJOb3Q4ovHj3z+vhc/cW907HShVCzkc0Y0YA6Yg6Wlpolje4O62RRIm7DkKkveCnKBDEpxWMPShAtt+nnen/EMTaXE0bCkG7Dkp4jtDUy1ufnSjfv2feRDuelJteJ2qRif9yqLfzq7fSj7RcfQO+NZjp7GCenYwP3pH2sXuhds9554zQt2xaZjOdY85xc841W+aUVxPn3OvGpyHxdqXjgBqirqzA+1U+cOfOzzh//qy5ivlqYmAtUcs4tGzKQb2o0NyUHO4kHJJpkdnBRN+UNqozhPN4gIIohVjUQilYhQnZ2f+d47rvqlf8WBcStVtDSsLYzmpepvoDD4RcdHMHkyMmCwi3+my7FiwS5ZZ8dPN3jRMLaMUfmuVRDsUpdmBQRiBnDusWef/q2/nP3WY8WJciEwASiXTGRwuoGIOA5PUKIk5LFt2YY4IjKWFctGRKLN/OBylRoe4hkcgFVpmuUhoYowLZ6d3faeu6/4Nz+uIksTO8+/u2ZW+73qI4hhKBfNcgnfpowbXjSsEn27JxxeNHg6Mkblu7YzZ5ptD25DbbXy7B99+sAffCpPVCgUckCOuINugKbRkGn3D7RHNqBjRGSLkwJNj6SjboiXl4iXndBIbAgNVeuLlUt+9n/a+cP3NE+m6PL+rN6rlSWOdfU0hJ9Vse5Y133bOLOuCzajaBjDnF/wjMs6DWurGHB+PWNjxFoyfOWPv/36//OntFys1+oRIVSJkqmPNpkWqYgDLd2kiLTvj9WBpms9peGYS76I9qrtvmtaJKpJccTaggggt7QlgYkZCEC5YuHgf/6zs/c9QsZoZFtiDFet2FppdjC1fz4CV3RLyh3vfc0rm6c/uofKevpm/fay6zfn65exEA2r8dqnAZUr0pyBdBzMxqioilz0httv/ujP06bpaqVqCVHsHUgXfYJqvBuVUjxPcslDASA+IP4v1QnapC1SodAhNJLOX3Y6VgzJDpwgIhhiggZBECg9/6t/2Dh+hgKjIs1BGx39BatU5mgLGWmNIBktvlO5YPCPcvXwZevJyFiIhiHSLAJUJOnVOx4a9/lu/6fmE+PIICYQibXT11x200d+lrfMVCvViBCqjZKFEwTqkomnSSDWDfGqkUvLTROSr5sCHmM10EyzkyI9Upd+nndKYntAjg1EGzl+4Znn7vsPHwWQbkuhyTLVAxftCjQ3OtS0HgsSKdZ3Htq1XXaWu3ffRK5H1lB6XvB0nNm0JjnxjDlrLxq6jIb7S0ci6xZXJubkH3WAmw4ggqhEFk0NU9zdMktkp/buuenXf5Y2b6jV6hEhcvtIQSxE1XkhkrkRLjNY6v8Ta4TzUMSmhHRhaXf8eV6Jpl9i90RyTGzFiOduEoOIKBQ5Ua8crs2/uDi3UDDf/dLXH/+vnwbgjA1dCnZVG4U+hEJLTWhRIf1lo3uARX9petYQb472rIh/tVeVtX8D2wNeskfJnWf3VudWiGWQrTcqp2ar5+bPPvXi4tFT9bNzi8dPk7hJkpjYvrkwVZ6+ZMfknovKF20qbJjMTZbjNK2AksDGJDMSWQ7Mqa8/8ugvfjQvKOTyOVCOORfvE+HWi1SK95+gZSIikd5c07INy0REprMugXShJ12ybWhN7FzYOBPVFqKwYa1VUYIQwjAKyqXv++NfmbnqUrGWm4IiVy9oKEvw44optFgmhhUs2Z5yiu+BxoGemngf+JadwfvONSzYjIGQy+GrxOqxxiU7SLVOOwM32cF9aBvhC9949ORjz59+/PnTTx1cPHHGxGYFt3NE+k9JFQoVW94yM3P5rpmrdm+95drtr7g+VQ9irTNCxANfKxyYF//7F5/51T8pl0s5cJ45RxwwBWAmYlJ2FoCmDSnSuZeaqIpkrkU6/bLTWk9NisGFNUj82qioLkTRuah+JqxVbOikh6iKSuQkBXP13Oxl97zu9R/9MLoup7jiV9kfxIApoK92ofmUXk9Pj/eNy5qzrvu2cWZdF6wXDWPL+hMNzUGLIpI6rU899cLjn/7a4fsfnz14PJxdyOWDXDEfBAaAAVwn3SQakn8Ejaw2QlurF6bKExdv23rTvkvf9rqN111OhgGoFWIGLYU7PPq//86pz3x1YsN0XhHvW91ibEi2o3C6YWmtp1Q3wNkyFC26QTXVDe4OnSBwSVmVxSg82ajOR2FdrctPsp2VSrzOtEZQMOli9Q2/9KHd73yjWGHD7ePsIfaaHaMsV0x2WIaEjDRfrrnawLcva8267tvGmT5MOC1v5XoRDc0H+Mqw2qxl+bZE12c/hYhc9KJbiOnZrzz8xKe/duBr+221bgzlizljDKlChBSJjUEBMOC2nyZSN453V2UiYqgVrTegwvnctluuufRtr935hjvIsDqnBrOKEHNjduE77//3evR0qVjMEeXJOCeFIWICVCmpt4kUWNINiLfHRPPul3BqxmmKdAHppHgIiFTOhvUzjfqCbVgVV2pWRTQRDRAbB2RqoArgcBjKvsv++R/+ytT0ZLPMGnrT0CVgYjRvb0e/Q0/4VmZt8aJhlfCiwbMajIVoQLZq4X4hIueqB3D44e9+/Xc/dfg7T9h6ozhRjPeihEDVbWnN8coIykREsBCxApEcsyFiwBjDBFaoWFWN14eGRpUaEW295eq9P/6OrXdcB8CFNbhLH/38fU/8b//vRLlUIFOIF5lmE68RubSmAnCeyaEtsiFeWNqJhaUe3ZVGIhfOhfWTjdpCFLpgSnGzPRVOK0SqAIyIQutEJ6Pw8SB43EZHRA4sVj7yb37qZ37ih8IwyuWCLp3rsMIMewpf6O+Kq5Smb2jWEC8aVgkvGjyrwbiIhixHJhEMyoYXTs197Xc++einvib1RrFcNIZghQEmMgBBrVpRiVQaEoZRWK/Xo3rdhmGhXAyCwI37AyKtNgpEE8XyRKlUzOdMXOPUMAOwixUy5uK3vPrq//k9xS0zzrzhpvHt/4XfOHfvAxPTUwVQfslDkdgwyNkPknrsfrboBmd6UHVzMZ2rwE0uZJBVey5snGxUKjYSVaRyAUj8EarQnNqq6lFjngntY4X8Y5VaFVpXMapRtXrZpbu+8me/sXvHNivCTQb5dvp70zo+wWH5JtoPWL2g6OE2NP1NDR1iBoZF9htZDWNVdgapKiP2kfV6ysgKNqNoGFnBrrlouGDe4qEzFkKy+cOO5R5PYUhc0U//wyNf/PW/OP3dw+XJkjHMKqTKxAyFom4bdWlEpLV6rVGrGaLSZHnXdVfu2HvJtmsum5iZCoKcqEAhqrX5hdnDJ049c/D0o9+tHzszzUGZg2KpYALDxMykYsOFysQlO67+l+/d8YbbkZgc5p468MhP/nJRqWCCAnOOjAE48VAkxobzIiI1WfEpiWxINrtCsuwjQIAA58L6yXplIQoBKFQQywW3OARUWUWgc6r7g9x+q88bcyyMjIiBqAhUrAozLZw++0sf/ulf/KkfbfbiDyv+fMC2fsBs9K1XlmOIbdwgjD4udbjibPQVqfmiI855FoaodPuIFO7p4C6ioe+7GIoVc5SiYXxe5LFlLERDF8t5+pUL6APwpf/819/4w78j1WK5QFZYwaSGWNTWonolqlsVK7a+sDC1ceaSm/bd9AOvveKVN5ZnpoNCrmuOosqLR5/+7NdOPPi0ff4kV+rMzACgYIqqNVG54v1v2/uT7wbg9nf4x1/4zYWvPjwxOZEH54hMPNfCRSws7WaJ9ohIUjrPHZHcJrAYhcfqldmoIapMLnBhSS6oak5slXCY+SHOPQhzFqiLBmJZxapYtSIiKuIcFo3GJbsu2v/ZP5gsl1b0/Q+lSer+erd8O6AtdLi6YVg+muW+7Sn9UQ7cW55I39ddLs0VGYpoGMO2fjUqRk/HD0U0rFXBjlg0rJIV84KUDsGaXLXlCXUv2VQx1Oarn/6lP33kU1+fmJ4ImCQSdt8qFqNqJapGKgSElWqhWLz9XXff8UN3X3rrtWk61oohBTNAZ89Wjh5bOHN68dx8XdlQYMgExCZ//Ws2X3+rfvEr5774HSYiN+lBNSiVrNjn/+BTlRdP3PDvftyUCgAK2zYtxLtXnn9zzjnRtAADEl+FJpGS6aLSbs4kgxpqT9Yrp+q1SMWpjDCZGWEVUGGVqspjhdL9ap7I5asWJDZQG0AtkQW5BaSIiJSdo6OQzz1/4MXf/W9/83MfeI+1EgSm76aq+xPM/ig7/tl3N9+ejZ6a1PZWsieyNDTOQhbrzx5THvGofYjt5sjCYNPL9X1iSz6HkvP2/LQ/0CwVo2NmRlm2GYd2HU9cjYJdJYZS89f8YY2MtbmfLA+pxcZQm6/+2c//ztNffmh6yzRZMQpiBIQwiubCxbptsCENxTYa17z2ljf/yx/efeNeAGLFGf6dlaJWjx57+vS3Hjp69Ojc/EI4V5dGtZFr1EuV+U2zJyYrcxsWZjfnZOtUHotVA6I0KiHu3FGfX9x05w1X/OS7a0dOPv9rf5pv2EIQuF2zDRHH7gYiat0F2zkGXKhDHPfYVA5zUf1obWEhipigUDczQlQjBamw2Hmix3LFhwoTB2CqonmxqiLNpgWV9l+IdHFu/vZbbvjqX3w0n8uJKg/J0tDfa7YawVYdG+iMafY99zJjBR5QlPSUq9UL+Gi/UPY7ynLksHLeq9LqciOroSOHmD3HikkNbmloobvKSc8dSsGOxtKwYhFlrO2DP6x1xFiLBiJysxyrc5X/+qHfffqr+6c3TsIKw02OQCWqzjcqUA0Cri9Wyxsmvv9f/+gr33ePO92dqwpmCkP7tQeO3nvfi8dOLEBUgqAg0ebZk9vOHdt25th0ZdZFUDLiiZCBMUzESKIQoC7PSrC1BgAmFIIgFwQ55hwRE5tYDCC1KTTZFyg2QCQrPCpcwCNCkeONxVP1qqiAKPZHqEYKVTFi54DHi5PfLkwepZyosLWkEmmzPnC6QUXtedLBTbNQrdbrf/Vb/+Gdd98VRdYYHoqHYogBDaP34mOZl3zE3XN2VTHKrrdL+l1cS10Ybt+2YlLtmcye1QGrZfYb6S4ghlW2QxcN3c/Nfnyv9XmVRMNQGrEueWv/6sKQDmvgnsgyNEyfh+u0/+Lf/8ljf//IzOZpa60BiFhVz4aLlUaVGcy0MLuw57orf/RX/pdd11yqqirqtpYAwEyHTyx+7DPPPPHsmTxpvpRXxebjL+45+OTmudPFsCFBXk1OCQIiIgYFBHbTL4FmYwOgAAqlktMBQaIzCEu5j50PbgOrNJIhUQxIZlRCwYz5qHGourBoQyYSQNRahRW1EGNtA/pYafJbxY0HTIFFCmIFsMwiSu6i6obJTASCENjNy0i/BcgYRrX2t1++751332XMcLYaGWRw7xiiYliO7llaVZdERh+Q+3Yo45gBj1/x9C7NXx9N5+rRkpMuJbzUwiQHtNxIH2W+4gEtBrblLtFStismNUT6q429ZmbNjfZDMTBk1DHNSa35jQ+FNbiBLA8s/YWZP/lrH//y7392euMkW2WCW9h5tj5Xt3UDJtb6YvWm773jR/+ff1XeMGkjy4abm4NvPHL8v3/h2YWFRilgS2SqtUufemj3kWcDVQ5yxJxTGIAZBsTkfhJDGURuR69YN8RrSgJu0UYyRAbuXCIidt4HgJa8Ehov2+DuiOJ1JQkQ1ZONyvF6Jd4zIg5fkEhBEinsgVz5vqmtB4MJUTU2EhXbYl1w0Y6qVqzo+Y6Jpk9UxIotFvOPfe6Pdm3fIhIHPnQs+b6H2lmGAh3TH9YrNBRjwyjHxFny00Kvw8ouuc1yp8Nt3bqk1mupZsnbsEbMvb4RWfRWH1lqFzdZMtmHpaG/b/sje30erqUhu517xcP6S2e964a1CYRcEUpCGR78/AP3/vEXyhsmRUBuywjIbH2hahsBSJkq84uv/eE3v++XPgigXTF87puH/vpLB3JMpYKJlHP1ytUP/P3WM8dQKIHAoEDJEAyxISWQITCIATeBkxEvNe3EACe7V7p/DOJ0Zyt10yZjveAOiwVC/LdzcSgR1Wx0uLYwG9UBxNMpRSOoiAQSHgsKD0zveqo4UxPk1QrEEjvbxpJ1QYnATGpVmdgFXZISx+ESxGAFWNUSGWNmZ+f/7ivf+sB73qJQptjeMPQGrvsDzfjhsMjeB2d3W654oUEKsON4tznN4RqBV8kS09/leiJLOj3ZqNv7m57KvLlitNsPBrzrdmNJe4JDKdsVX5ZBrtLx3DUZdjfLOyx/14NnrEv6693eMOqtsTPahUSEDZ86dOqvf+3jbAzivadJCbONyqKtM0iZF2bnb3vLXU4xiBUTGJeCAkT0V185+PF7DxYLgTFk2QRh/arv/P3GM8dtocQgg3TtZ2YihjFJaEL8Sbp5NpiIDcU/039EzjUQ+1GQbE4JaPwfyHkrlEhVBSCic2Ht2crsuaiubqsIlVC0oapRGGr07altn7romscmthO4GAuWZGNvJxrcL27hSopXsGRiRvIRu5y7jbPjzb+h+KvPfQUuawkDVtyWtrLXhz4mr03G0VjGUfsQ2253xZbHNERTR9opDivBFVNbVTtN3yzXmbX0LsvRfljLExw67uVdLhurxzSaKjUAACAASURBVCB1ewxf9uZH3P7tUC7UfonVuNboGbVoyELaUP7Nb//NyRdPBaWCiIsOoGpUXwxrpKTM1cXqVbde+2P/0SkG67Zlcq4AJvof9x/7wv3Hy8WcEhQQ5p1PPrTx5DEpFI26VZhc98om7lmJiV2vHE+2TIhtDck3aQ9OlG5x7RRDsrKjJg4KwC3aIKoulOFYffFAdb4qkUIjkUgkFERiEdUPFcqfv+jqr2+6vM75kkp8iSWhEIuDNANpJptySsTcJCyWMLncE9994flDR835m1cNWHcznj7KJkNVxe1L0pd1uqfPVwlXjZcb2w29aRtisj0NyvsmY3fed7LZR9XdO6HVoEvGRvMuDzflUb5Z7dWmeSbIcEf/ze/vutYHHRkv0dBsm33sG49/82+/VZoui40Xb45g58KK6/Ea9cbU5pkf/8jPFSfLNrJsTGKiUGZ67ODsJ+87HOQYTAAkn586c2LrwaclX2BtHqQzL+kCZ/CnWCE4I0G8bZRCNbYhxH8ln2gceaiahG1qsus2oKSqJKoEhCovVOcO1xYjFVENRSOVBhS20VD74JbdX9hx/aHy1hKRQVLp0o4fS//P4DTbSz+d7QFMQLOySXQNSoXCwcPH/+FbjwCwIunrMUjPOkopsCLNmelpUYTk+S9Lx3e+14YgNRtkzFJH2+bQO8vme+9YCC1XHNwqM0SGbuNNU2v2TfSXQsc/UwbRatTmrRgW2dNMTR19jBnWxEbSQvp+NVfv7Ho3+0vR/WGtXzExXqLB4Ur5s7//OTdiVCUhUmCxUQvFgshCReS9v/jPtu7ZZqPIJGsWiSozzVbCv/jaYQHYsAJggsjW5540UQRmBsFtEpGM4JHIBjjxoC5yQpEu2hQ/9dSckHxIcTDDUjxpOmVCoUSqEBUCVWz43OK5U2ENUCsSqUSqoSpF9WP50r07r3946141hYLYxJ5xfscfw+fJCHdoeiPpMZQ4TZqODYIA1fqDjz8DgLuK356qcsaGZpSvx3Db0+UUQxadkf5sP37FAmlPfwR+0PZc9Scu+xBhPbFcW9zSGaf0et1UMTTLiPbD+r6RZkXS8RIrpjwyk1jHBDvWijE0OjbTkj063wyQRTHQ+c3mIGOnVTKVjYyRBkJ2b4LdL9aKMfzwvfuffvC7bnqkWywplKgS1QGAuTI794q3vOYVb7tLVZ2NwSXlnt4X9586crY+kTc2EiISNqWwPnX4BQ3yjMTmH4cwJkMt9z9VBSlp4mdwfwKabB2BWDkQxUs9qlMUsVZwJop4XqVrt5jobFg/XJtv2EiBUMWqRlCIqG08s2nnQ1v3VriQt6ElWGJSiSWMslvoiZVAjFiHuHWoCcQEJXDTBMv4dwapu0clBrslq1WVyqWHH392dn5hw9SkuM2+x8lUsOZkL40uR6aeBXTq2/rog5ttb+2fZ0ykV7Ib5/vLw4CZX+70jkWNtu45I71Kn+WeVMb0Oz7fLHc6LHqqY+2fZ68wI67M6GRRGMTAs5xmzZ6Z9d7wrr2loeX1ZiZV/dJf/kOtFrExAteHo2LroVgFhWE4sXH6bf/qPQBUWgOVT803vvHMuULBSOLvV2MmTx8zNnILNiKeLwmk9gGKF3Ry21HHbgc3TZKcbojlgcth/JXqUvCjW5SB4q/T3auVcKJeeaE6Wxfr1nl0BgZEjYqh+3dd9+1dN9ugVIB1UqYpYiKNWEisDiCO54KmR6beCfcvtTa7w9hh2BhjCDRZLu1/4tlTZ+eQ6I+hPL7mwVyWR7zcJ4MzSJodz+1okOx+s65NHOIAYsAWqo9rdbncmDR22UfnqVzo+7n0ap8YShG16M4uDNHa3/0lHYptsstNjWbM3Wwt6KLJ2v0OHbPnYqeWO325r9oFU4aMjxdrLBqai4yIRJSInn30wKP3PVmeKlsbBxNakWpYdx6EWrV+69137t63x83JTMd2ogDw90+cmatFxrAbe4OAXM68+CJFFmTivpIIrldOJmVgqfOP8xJrAnVfOBkB1aS1AjRe1ZHch9r0oUAVaiGHq/OHavORqqiGyT9EtVPFyfsuu/25rVflVRmqzc4IEDc5F2LTSEdAfF7QAxORYQ6MCYIglwuYWESjyNbrjWqtEUVy7ujJR598rr3kByFt4MaB1chJixlzxUukXdQQM4Chdg/DYs2fe8uAoYt7Bb1U1PaBKTKUdkZRkvGpjY+1P6353e3EzQdnSXBkLOeYwPLypf3b9tvvyQyT5at1xFqu09Be4Zwp4P4v769W6sWZvIooQ0E127AqTGRFytOT3/eBtwJJz55UC8O0WLdPHKuwYRASaz3AVKwukkriXYjXb1SkzUHsXIgnShLFOSHVpmWgkXgHUm9FMi5b+kChTgPUJTpSnT8X1gkkUBEbASoiUj8ws+PJPS8PTbFoG5aYAFaVeFVHOCsGg51jQogYZJ0uApOq23zbrfyoIHZ3yCAFA7V6o1qv1+oNK7ZcKkyUi0HAU5MlQEVFdl+UywVYCsHI9Fx6eohrzhAtKM2/d0+23e7aZRyz4nVbzhqlsaEPstzmalikOxbUUGpj80Ps46wVD8tYndp/HyXNVbrZ6dZCl0cwSt/KsMguBYZ4F+PWhK7IWoqG9pIiJrFy3+cfKJSLVoRBpGDSehSKqgnM7Km5N/7Im3ZdebFzTKQpWFFDeOFM7cRClM+xWnFOfyEuseYhFmTcNpCI5Yk63eA8/iCCCoFBAmWkAiIJaEC8LnR8rIuIdNojWdDJKQYmWgwbh+rzlSgkwLodqwG1UQh9Zue1B7ZfS0SBDYWYIAQiZhJJYhuZIApisCTxCkwkcMs6JacQGTYGHEbuvyiyUWTtpRdvu2z3tl07tlx+yfYtmzZctHXjZLl48Y6thjmMoq2bNhhjRLTXTRe7P8T+uo31Qpbmu2O/3t/9LndWR3/wOJRqS9ey3DGrd91VutDqlW0WY1X2g9sZJOctFrU+dFh3kdH90kMv8I5GoyyWgFV9s8bhtR2EcbE0ONseEZ7ef+DUsXPGGI33laZQolAjEFkrhYnSjXfdDEBE3KSJZsPRkdlwMZSpnBEFVEBEhkUiEQtQ7EFIVnRUoni07owNcDGQS1tHIIl2hPNUUGxz0ERAJIsyxLIaqkQ4F9YPV+caKogVg1qAosaCyT11xe2nZvbkbChiLRnAxis8updU4xhGBqmSIt4scynakVKXBDNRpVZbrFbLpcLmjdN7L9955y37brtp78UXbd4wXS4VC8uVudunLm0ahvIcs6Szvl6SjhbULLfQsm3mcif2YaEd1jC6JRvdE2w3D3Q5bPSdxKpWqi6J9/T4etJSWVwAPX3bKx0Gcl0VTEev2RgOIXp9fTJK0v5cLR3TWUct5NpsWNXeyhCRiAXM/vuebDTsRDkQ1zeDG2IjsYa5Xq1t37PtujuvB+B6vjQFJgA4PNcIAl4akytB2dp6PWpMUByvoPGEBwCQdFaE0wTqJj7ETgqoAipEHE/hcBLB/Rdvge1MERJLCD1Vr5yoL1pRxNtbawRwVD9dmnr6ylctTm/PNWoCEDFDABYnyWMbAwHEILfZFkAAW7frFJgUxhAJhZHU6mEYhZddsv3m6y+989Z9d7583+ZN080lLCLWStNowd2vElFLubU/lBVpVmk9nfhSIBVkju69Ra8tztDLuVfDQH/ZHjrdJe+KLXvGXq09qf6qujsl4ybsHUt4NfRir2TM8Io2p46prdLdDViM2S0Tvb4Ra/40B2R0oqF7T6Maj+qfffJQGFoQq4gCFhpaK24XaSu7rto9s2VDGgKZnk5EVnQhFGIGK7Fbv5mINAoK52w0I6IggSqpKFyCqe2BoKJId62gRGHEMyLcB0rptpVQJSJxZgdVIoQix+sLpxtVt/STqFgXERlWD2+77MCld0T5yVxUt8wQxC6GJWkT7yihyS/pNhNMLBBDzEwLi9VI7GQ5/8rb9v3Am265bt/ui7ZtTEtPE3eKa5tyuaCtkLu9A/1V4vVe+1eDLG1NesDgHXDfj2C5rneVsp2xO8lCs3my+zi4+fM0/in9c8XOIDsr3lezmuxbefT61bDIXiX6eMSjHIGsaD3q43VA72/EOKjAQVgDS0NaxOe7J2AMz56ZP/biKc4FomCQ2/4xlMgNymH4mluuAeBCIFsKvWH1dMWagFUFRHDdsSiCQsUEi7aew6SKCpPEaz+rUrwmg9MFQLwhlcYRC0lVSKwRiAVF7KBw+oCJFqLG0VoaxJAoBhUb1Y/sufHopbdB4yAGVgGRTV0SAIHZmTqgDBZK3ScggiFAUa3W643G3isveuXt+976ppfvuXiru2VrRaGGGQAlK113NOR4Rk/fgqCnQLm+GSSFPnTDatTJPhrfLIqhv5wMfkxHU3/GxIdyRx2FXa8GyF6zMbJmqlcDVfNZQ2ddN85rE9PQ3oK4Ef6xQ6dPn5gz+UBUoWBAoKFEyXgf19x+TZdkJdYK8b6PygxiwywX7Zg9+OyUWkPsVmEQJSVyboUmLwMxxetAOz9EvBW2auq8cL87vQCACacb1eO1hVAsALd7dQSCjeoqB698xezum0xkRa0QA3JeYCPcrFABEYFYWSBELo4BxjCsVuuRiFx39cVvfsPLvveu66enyu5OrRVyq15Tq7thXVfHcWDNjY19jIf6oGO2ezLernlBoRe7TsezBrlof4Ep7pfs52bvs3vNzHKJDHEcPFbj6fHJCVZnPtHIGIutsV0UIYDZswvzc5ViIec6UiWKbCTqYhA1KOS37toKIIkAaCNeHhpghoJUYFhVcnv21L6lC2F9U75soQxlty4UoK4nXzIoUCJQYocJJWaAdIQiqoASIKpHawunGxW3o6UkioHC2mKxfPDyVyxs3xtEDQDJrAdGbEJQArNzcsQTLZe8EszEMJVaXVSuu/rid37/ra95xb58PgAQRdYYBpxc6FPaD5GRjYHWiiyZH+XdDfFao38o7VccVt1YkwqWsfJ3+XMolxgWzY1J31JszeNdujDKhmhFZ9z6bRIxJqKBkhiC2XOLc3OV8vZNYoUJCli18RwKK1u3bnTLDHRcZyAwtKFkjs4xQYSJlFTjTanDzTs4XzhbW5gI8iXOCSAEq8qJsUGIOH5tnFHBeSxSGwPIRUQiDh9gQs3ao7W5+ahOIHVLMEAtgEbl7Mz2F/a9JixvdYohnXYRO05icaCaBDzaWAMRg4nRaNhqrXHJ7s3vecdtb3jtdU4luMDGIJkwkpbbKB7P+fTXLqxT6bDiqGuIrvpeyeieHyXjk5N22ru01cvtenxH1urSq3fXayhiVnTGrfl4bxDGQjSoxgslLc5VlVgAAgSkLkQAMETWytTG6SC/bIYDwmTBxNEC8cCeSBmRoDwpV+4NH3noTFi9qBAwIKpCsEoESLxqU7zdRLzFg4LiwAuASABStXGkIc6F9eO1+bpEpGQhoupWcFLbOLntsiNX36WmZGxDnRrQpsWhkM6GcK+Kc0yQEAXEobWVSrh5U/nHfuiV93zv9ZOTRSRx16lpYQzrWZaYstGPmXpixfz39+3qMXhNaE+hD290e4B6rxe9kBiwixqHF3y4Gegj1GOInpE+MjP4RVt87n03LOPM2oiG9tJ0yw0dPXyGAxOvmgAIyFkaLEFEJqYnTdA5w6LKRNsmcxFAzEJItmoiJVC+YK+4Wh55aCGsnSHaVpi2qi5gIt51G8lWFQpN9rF0az0BccgjIExkVU7XK6frFdUkiAFiAURhRDh82c1nLrmFlVlCBSchEHFbwGBxu0ypxH8qCMrMBKpU67mA3/KmG977rlu3bJ4CYK0wnzdJsuMLpkl5rVWjs35rfxd6Ksl1V+arOsi+IOvDigxlUNsc9LC2PpcRq/wLo85kV+HjIBD7Zi0DIZtxKoGIXZABQAwIIMmsSEn3pO6Eiz/YPhmwYTDIKGLfBMGwRpFeckV08W5z+PBZkAFvLUxaqJsHEbjlphN7gHMisEszXulRDRFA81HjVH1xMawToCBVa51pIqovFspHr37lwqbLAiuAKLktKpciD+IbB5OLdgQDQkSGTRhG1Xp45eXb3vdDt914/cVwW6EsY11ontqkoiKWDDOzRFZViVkZzvvRsZz7eDQrMla1f8C2e5AJYMMyOWa57hCj5QdMpIUVXTnDvdwgDCszGatcl9i3wa0+gzPcp9PTuzBWtQKDTWPOrgY6dIJj9oIsx1i4J1IUECUBGCSqhhKtoFCiMIxUO2ws5nwAAC6aMBvLQaUWMbvdG1ynrySRTs+E198cHD7EqmfqiwTdUphkUlLEq0AASjBQVXCsINT5TQxRzdq5sHKmsWg1DoEUiEBVRMPG2a0XH9v7qqi8KYgaTn64/MT3RG5vq8RagDjgEWBjsFCpl0vBO972srd//40mYBHFSrO603pJhmAYgNQaXMzH11OFxLETo6mF2S+xqm744fovR6O3+ktn8NJbDZ/RGoZ3rCG9zoPo+AqMQ7kN5erNY6T1Ww36zvnoXbFrwri4J+LPk17eQgkkGu+LLVA2fPrkuUYtzBfyHVIDAFw8ldtaNs9UbYkRx0IKEbGyQdjAy14ePvYwHzpEheKZ+mJD7Jb8xESQdyGKlsDJAgyqYDjfBCK1p+u1ubBatyEBILWqqmoJiMJQ9dSVN5/ZczM4Z6KGm4RByYIOsdhxwRHxp3CrNhnmKLLVWnTt1Re974duueLyLWhaNq572G367YtfvO/Yo08uHjtZPztX2rqxuGlm5y03XPy620GkIqog7nOtleGOOVZPKGS5bpYjVzszw2U8W6UVW8zxzPYgrFhzmithLPSXsf+veeEMN8J6zW+nhXUdeDhujIt7wqHOJaHx2gkCQCEgUhBzZbGi6PCWutSsqmHat6nw7NkQADGrAuz2tGaSSPOlxve8mT/+JxSGFOQWo3rDhpNBfkOuWDK5HFNA7CZTWhUViVQqYX3R1kJrkSwUraJCAlVt1CvTG49fdUd16+UmjCBWmUkTk0Ls60CyzxWSpR8IBGO4Wmvk8+a9P3jzW+65xhhOwxewUm/nvp194cgXf/o/nH7yuXCxEtZqnA9MPh/k8/9YLm27Yd8tH/zRHa+8GYCK0DLrRg+FLCmviZc0++XWnWIY4tMcukW6u95d88H0cOlSczoGIV1I9z5cRlAxxrDw1+/rMG7uCY2DGBQCZSILABCAjTlz8ty507NTGybj5RSaT1R1+zbetrP45YOL1oKcpYHjyAY1hqIQl1zZeN2b+HOfJjZghspcWFuI6gU2BTZ5Ns7AoCqhRKFat30FxVdwMzFVo9ASzu65+uyVt0t+yiTzKuNlHiiedhFvqB2vABFbGogBpVotuvSSTe/7kZuvuHwzAGvFzatsGYt0wZSKe995d2F6kg03FionH3vm8H0PLRw/AeajDz722Z/8dy9//3tu/tf/hM7fCmG49FTpV/sN6fs24+iQ5Qci4/ZuDzEzw72vLJaGcSvMvsmiGNYXa5jnEVx6DB/KuOUnO+MmGiAgIQAqIAERsSbLMojyd//xwO7Ld7l3tlMgCXZM5q7dnL//WK1kWERdr7mkG8JQbryjXq/TvZ9DkCeTI1WCNmzUkIjJeSVAIIZyGpigyeJTUag2rE7NnLn6jsWtVxgF24a6tlKTzTOQaITEtRdP5ASYKYpERL/ndVe84x3Xlst5Z2AwJtO2k6mkUNXJrZtu+KfvbP524ciJJ/78b/f/8V+ZfI6Yv/XRP+J87sYP/oiKun06huhxH8TWNz5vr8uJcwkNnhRG1QqMTwH2yvrN+XJ0vKM+7jGLcbHnzHnOpyd/pS/wLoyLaFARsNm+Y1MYWjdqFzfZESZevZlgRZ/a/9z3vPVVUBC3egRV1XkCXr174qETdRDcblAusgFEYFImFpHb76oGQfErX0C9qvmCG/+bJG5SkrkHoqpxXIKoWArrjYnp2YtfNn/pDShMB2EDqkoc70IR76gNqJMLLtdu/4q4s6/Xw+np4tvffu2rX3UpACvi5EL2aHlVdTMzNNFNUIUVIprcue22n3v/zKW7vvZLvw3Vwsbp7/z2n26+7qqLX3ubRJYMq8Tqa8Bevz/awxrW1mmSZolXMsZkTyq9eoY89s9qhJt4eqI51q8Pe1uXQIeOjP4ZjaxijOxCPV2Fzp/ytkqs31dvLQMhmz1/7hlNThUjUQW5ORKiABuNbfys0CcefgYAOnV7cf8OvXZr4aZthQeO1cqGRRXKxFBVckskKMiK3vLq6tYd9mtfLBw6qKJMrLkckWEXAQEAYAgaESSC4bBQnL/yZZXd10STm00YwTZAiBebTlZuinfEhCaWBgVIFcykgmo1vPLKzT/ywzfu2TPjzOFuoylkMDDEReTGxIYBQARzi3L0NO/cQlPl2KBi5ap33T1/6Pj9v/2nhQ1TYRjt/4O/3HnnTTAMVXIBEyI67Lcie9j8yBqInhqjQXLVfqH12xYMzktBhbS8OFnutyXE4QIOdOi1VRnl7Y+sTbjgWQPR0D4nRzUeBJenSuWpUhgJEzPcDlKBgkWFSIN87tCBY0/vf27vyy53u2OfnyyIyG1Ucc8VU0+eboTOMh8vmpD+Y1WhsKEXX9Z4x49FB54xT+wvnD3JZ0/nKvPChqECELQRBNiwMSxP13ZcWt91hc1PkagJXQRDnKLTDQASxZD6JtxKkmDiMLRQvftNV731rdcUCkG6wmN2l4QTBGQYQPjgk42vPhw9+pwcPw0RMPOOLYXvvb3wttdQIQ/gxp94z7N/9/dzh44VpiYPffOhI998+OK7blNRW2sQERdyGGrjnl0xLHfuUPLQ8knfWeoop7okta4bl+HWgSEmeMHQbkhIy+qlILAwHp6XdVHU45/DlNGJhubmuH1w5j7ZsHGyPFWK6lHesJBzTxCxgYgocvn8yeNnHvn2E3tfdrmo0vmdrkufiUR1z4bcD1w1+bHH50qGYNg5G8AKZRIoqRpDNgQbueK66PJr7dwZHD5Ec2eLth6otYo6FyVfos3bw8mNakFRxDaCqrp9pmK5gGTTjCSCId4YUxVgJgC1arh5U/nd777u1lvcqk1LcQkZXRJQhSoZtkdOVn73E+FXH4YV5IN4d67I2uePLH7kv9kTZyZ++gfFWlMu7nv3Pd/8ld/LFfMmF+z///7y8H0PzR08EtUbEoY7b7/p5p9+H9pepAF7/b5r/Oq9z1nU2OBJrW17NEixD5gCztdqIsKrOU9nndL+iqWKAb1UntEX7LA8mOPmeVmOdfoirwlrYGno6NV2/79x0+TkdOn0sdkgMAS1ioCYOYgkNG6/STbf/NKDb33fGwulfOqkb0bVddr6+ksnD89H//BCZSJgEVVD8QZVhqCsEKiBCkWhEZHSNK66QaGLNiIrELVCpEKNkMMQKgq4s9MNL902VvHUCiQ5ibfTJmaKQhtG9o7bL37XO67btKksokRwBoaeGgvnWQgfeHLxl//InjzLk2WQ89wkBRcQZiYbn/9m4Z47zRUXA9j92tvv/80/UpFcsXD8occOff07ZAwZE9bqsy8cdqJhuYeS8Qm2tyk9yKChknZdA47hljvlguwIhzv2TfvC7mr4AijGQZx6LQ7Zjgcsd4mXznB8WHloLswsA5txuPf1wloGQrb79nZdvHnL9g2HXzhdLORVIW4qI+cFVQZZK+XJ0v77nzzw9Av7brwyXgDh/ASXAgaBH7p2w+mqffxkvWxYRNUNhJTgfAsuNNIwALKCKCRRiKgoRI0VqEChbtcrifd30GbrAoB03QiNRYSTBdVquHVL+Z43773r1Zci26pNHcrHvcnM0WPPLfwfv68LVZ6egBWV840EVigI5MycnJ4NrrgYQFDIFzdMhQuLxBQU8rlSEVAl4lyw8ZLd/TyqLLntPWBwcDttcwvbU/EOy7vZpfXvlRHEXnW86HCbyxWtMmPSOY2GlpvN+I705CAbFkN8NBnTWe2bainGPi43mhd53b0OvPIhq0ZL4UaRzeXMlq0bIisKWHVbToA5IDLitpIiajSiT/7pF9wpnV6wuOqLas7Q+2+c2bs5v2iVDREzmNw/YlJO9sMkArMao4bBhpiJSQ0rG5Bbv5GIiJg0+Xn+MhEEZwUhGMP1urVW77xj94d+5tV3vfpSF3rYxx6V6qIimHWxuvif/lznFqlY0Miik3NHo4g3b+CZqaWCdQ4TIkDFWrUCKxLZmct3A0tSp2/abyTLq9JiFWj+s48us2MoQ8e89ZHV7Ed2bOIzpp8e359iGFxnDN5gZc9DszViWFdfW1a89y43SG0MO3e90fFeeqpgzQen/pcux4/4lkdzuf7asb5bgDVhLUVDS/PhHuoVV+0IckGk4narsqqGc8x5hSqRKHLF/Ne/9MCRg8eZ2Y3gzx9unhfcMF0wP/XyTbfuLC1YwO0YyYlQcJYGcjIiyUDyL/0z+dClHl8C8b9kF00mZrKiC4uNyy/f+FM/cduP/7NbNm8uWyvx7Il4feneXADOB1H726/b7x6iclGt7dxVM6NaD66+xFyxS0UAKCFcrLr1JQnE7iyCWHvRbS9z561w6R5p1kNdan+zaaFdQvXdQg1Ox+Fgsy0k47mjZ5ByGETutPcQ2VnzDnJYdLQKpCznaOhVIozGNpOlqmdPagwfcfa+uXkw02v6fWZuXbGWogGtDTQAXHvDHpMzVuJoQwUsKDAFASsApSCfO3d67tN/9gUAKp2fU7NumMjzP3/5pruvnGoohQpjGMxw5gQmZ1cApUYIgCmOMUxkAcVeEiKKzQzqdpAAiMgYjqxUatHMhuL73nvDz/z0nS+74SKRPg0MKZrMKIkeegrLBCXFKasgHxTe+hoyRq0AOPr1B8OFRTZMCnLrRhBBtDBRntl7Sa85WY72zhXZXrMuZbLii91+QB/miu5tffNhLb9kZ7jGjP4OXpHlHkH2bGSv2xdke9rrq53RaD9Ajgai7/qQ/bD2U0bW13aXa2k2Wp7ph/8FXwAAIABJREFUquZtnb4Ua7+4k54/K+mGGy8pTRZrCzUmZoCUmNSYApNRjYSIRHPF/Bc+9bV73vM9l1y5S6y0LPTUnLLTDUz0g9duuGpT/pOPnXvxTK3MxIbcZpZKGs/udFEOxPEu3ExxsCNBmeItuile7YnYCQdEkVRq4bbN5dtu3vH6uy7dOFMC4OQCkorYt+gmZq01dL4CbtV2caExQ1XmKqUfuyf/6pvUCucCiexTf/0/gkLB7a/pgiY350sblIqX757cNOPSHuJQoH2YvuJdD8WDkNacliqUhV7FXJeDW4ztzfaJodxmMyMzsXa5UEueMxbjGA49BydjLRpQWo2s6LpI+e55WE5EZmkEaPXdVa4d7j67p8sIIfvtZ89PxwutF0ZqaehYTC0fTk+Xrty3sxGJElmK969S4lxQsgBAosjn8yeOnvn4738mTaH9saXdCROpqqjedFHpZ1+17S3XzBjDVatWwYbZMBL7AYjASKQDEldF7KNQFwLBzIZFtB5KtWE3byq9/fv2/ewH73jXW6/ZOFMScbVzaYpEyxBcVcVaG0bun0RR7FDo6FAUoWKeN2/QyMKYpaBPAhkDJq01NLKl97259BNvU0DFAvjHP/7r0//4VFDIk1M80DzzdKEolfr0y/bmNm1QkXRl61ViNO9D+tz7u1xPhoQuxonmEUz7MGW5s5b7asXnsnoPrsV+036h9g/H0xA9SrrcvvtKRNJPVjShdfx8sAz2QHeluFz2mj9veU0yVuZVqkLNyca+2gzupF6fQpcXvEvG2gXTOmLtLQ3NuNner3nttV//yhOT5YIIhGAVRGBT4Kgqag2RFSlPlj//iX94/Q+88uWvut5G1gSmi0wGwERWdLpo3nn9xjt2T3zhqXNPHFk8PVcn0SLHGkGJAE72zGKoOA1B1q26oGKl3ojCyG6czF+0pfyqW3feeO22yYk8gGSbytbdj7Qp4k+sZWPIGJjz79paSva3TPe4gsb7XRTe+prwwSflzByVCsnKUaK1BgWBuXxn6QNvy995gwIaRpzLPf/Zf3jot/5rUCwy4Na1FqDEuQK4mg8mr70CgIpwsOxz72O83l7gGc2w2Ufk3TMw9Ean/b4yvtt9u2zaU+j7gF5Jq2jHMdZwr9XMS0RtMLesQbdyP5p9sL5KdG9Lu9PxFehyidV4f9uzlLbJK4q8FQ2KWch+Uz0NXcaEMRINRCSiAG66+dLSRCEUDUACGJCo5jgXBKVGOM8ugpE1rNk//I2PX3/rvnwhl3oE2tNEIocNk6gC2LUh/09v33Z8vrH/0MJTRytPHVmo1pVVSQCrJG5bboVCRGFVRdSqRlIummt2b7rm8o17L5u5fI+z88PluXmbyvYMuF/IGKmHh+//xzMHD1dn540xUxtndtx63YbLdgFwaz6qqoqwMXDDlMjmbr1m8pc/WP+br0ZPHkQYQQSlYrB3d+7lV+fuuoknShJGHBjKBc9/7qtf/V9/jUCBMaTipmwaoo2Foq3Xizu2zty0D87rMbw3tr1/7eNtGVA3ZDyy41V6zW2WS6xeO9ilgg2YYN/pZOwbLlSGfoOrWn/6y8OKjxid6s84+CY6pp/F3TBIZrqcvuZPdiiM+gZWMtCBmc6dW/wXH/i9Jx59YcNEiYCAKFANmEilWjsLjQyBVAxj/tz8+3/mB9//c++x1nLXrRzSmp3YoOIVGyMrJ+fDF07XDpyoHD1TPTtbbzRsFFqIsMKQlgLeNJXfvW1iz0Xli7ZMbJwuFPImza27VLf3XKFQIrKNcP/H/u6Rj/3t2YNHarPzEAkK+XyxMLF10zXf/7rbP/gjucmyRBExE3NUqT3511/Yc9ct03t22kZo8jkAcvKsikKVgoC3bIjzEFnOBWLtI7/3F/t/92NMZAJDoiAQyKpszpe2FMq1xcWZV9x4/X/+tyqCrtq2jzq9nEGvV3tD9qsP691bse0Y/BLo8daWS2G5OtafPaOn62IYt9BCixNniKl1YU1MwWvSTzQ/tQFpt5m1346zEC93VkZajm9xc2Tv5ruk03zw0J/LaB5034O0ITJqS0MXLw4RARpFdmZm4uW3XPbwg88rQQUCFZBV5Mjkc+V6Y85NYBSVienyx//gM9ffsu/2192YOimyDCiZyU28CAzvmCnsmCncccUG91Vo5cx8g4B8wDOT+fZ8WutWaoqXd1zRqEVMjUrtv3/gw4e/8+jGPTu23bAXkV08cXr+2Enkguq5uW/97seOPPjYPb/xi5MXbQVw4N5vP/A7f374/kd33nzt3R/98NTOrRBVAm3dSM3JqhIz5YKj33rk4d/58yP3PVSYKBtmiNvTE1Z1wuQ254pWRYk2v+7WlqIYYtfb/kwzXqW7dW45m3l2M8lQ7tFVKm4LR81+esZzu9/viGlpiNv3EL8whk3jxtjWASxfk5s/1N6jkrGaPd9yvezQr/jSeRfWpiJ2+daJ1vvvf+6D//z3NNKcMQE5YwMMwRBq9XPW1gMCVAJGo1bfuXvLr//Zh7ft3GKtNaZDcENzYEH7Ly436QnLjYGStRaQnpt9JB3WG0cffbpQLJQ3zeQmy7ZWr83OH3ng8Qf+6K/OHTxSnJysnDlz2atuec0v/MSjH/vMk5/4H6RamCw3FqtTO7bd+IEf3PfONwb5XEvKUbV+/IFHn/7klw7d+82oWitOTpAoAAacYsgz7ypNGuJQrAbmlo/9amH75u5DxgFHw32f2zG19kLur+nsz3zafG67qbZXC+cq9QRDGa8PpZB7usSKY8FeGZmlocuYZ7kr9jSoHa4JbYimstXuETu+Hdkz0MXSgK7lMMSBRxY/3aqW5MhUy1iIhpaxo/v5nnd95MnHD08W8wwK3GaXhBwTJKrWzpJaJpBaY6gyt3DLndf98n/5N8Vyod1Q1nKJ5hWd0dYKrNgoEFHqlchyp90rSuXk2c/8zH88/O39xalJbTQ4YKk3CqWiYQMRYo7qdRGZ3Lltx8uv3Xz15TNXXRLVG/MHj5579oVj395fPXFaao38RMkYExsYiABYlSLzzuJkwCyE6rm57e94w97/7SdXNDIPWO3WxPzbH6vdzWTvifv7CkPtelfU2T1lbMVLXHiiIUuHkeXILAdkzCdWTTQMojKzmIHTI7NfortoQNdOp2/SNAe8/WFxIYsGrBzZoMz8l39x34d/8WMbN0ywIGAyhAAUkAZENqxVG+cMwKSk1hhenJ2/6023/fyvfnB646S6eQduOyuiNO7PWquiQS4A4PbLXm0FHbe8IgChLU5Tw4hzweLx05/4iQ+f/e7BUrkIK0FgSN06EQRn91O1YWjDhoZWrCWAjOHABPmcMYFbwQlQAghuhqpOBsFFhbIhilQFaDTq1/zqhza/+maNLAWmQ0YThmLJ71YUo7KyrujC6Ok9H2bOhsdwu97hPpouqfU0EMzImouGXuki35crup4e0HBFw7Do6WUcrmhAV90wgnapfdQ69EuMTDSM0eyJFl79mqu379g4P1spBoHEyzTBgghqcsWiTtXDBQYUbK0Uy6Vvf/XhF549fP2t+1SUDacrUKgVt8TC0QNHf+1f/N/3/Nj33f1Pvo+YVlU3LJkxRNx0yui5w9F3noiePKD1kHdsKbzp9mDfJbYRTmzffNOPve3L/+43ADJsSMmA3OqUlPjegnyBCgW3YgScR0VVJRYKRHDLXFtojmhjrrQxVwQ0EgumcKEy+bK9M7deBwAm0/Img7BcqzqyCt1yuQEVA4bXT/THcmJruOU59LdgVevY2tKxPvRagH1Y+0bWq2HVOtHBX8bhsqLOGJB2KaPJGlOrcbmRMY6igYhEZOfOjW+8+2V/8l/uLW6eVqv/f3tnHm1ZVd/57++3zzl3fGPNRVUBxWQxFSIQKm1QoEnjsBxQ2qGlJRLblYC209LYUdMrahbaHWySbo0uUKKtHRI6mO5AixAHQJyilECgqAJKKKoYi5ree3c4Z+9f/7HPvXW507vvvfuGW/w+sGrdd4d99jlnn32+5zdtKyASX6+RIFFUSFzV2jITEahSjc89b/OpZ50kzrHh5LE99pFdlInMSRvM6mUAxLl1x60768Jz/vJDX9y17fH3fPZ9XLuDdrcPozZNiHXiLTNUKyk9nfXYKwa371Dpr2+pfPenmCohDAAgsdXv/bR49ZXBKRsBrD3z5JG1qyp794dRlJax9mYGIgZRzRwkIiTucFgFk/h4DIGDMGg8zIxH2QyZRMSKCMiJOGD5BeeYbCTWkkkDRbGwkUeNH83TRntnFn1YFN0gDQFlTYNtiSuGxqtmKZzxvtM0Hvq1m43T0cIfunlVDHM3+M2dLlfxPJkc2jpijoCLYnFEQ+tVhxfrPl/84NJLz73l//6qNFXJhREEjuAABpyQhQjEAQwCsXPyivNOBwDmZPsThz7232WyBMM8OpR57W9n3/lvEBgA7/rEv3/qN3tu/vJNmXz2sk/9HnpzG6fTd4NhX0ScddyhNgMaFEOyc8/kZ76W7HiCi3kM5SECEHIkk6X4nvvDUzYCyA4VwmymIsJERgAgw8GyKHsgrsZiRYSJyMuEmkqQmrGNgJC5YMLRMJMNjAisz8sEANhqHK1dsfqN5/sjs2DjtS9PY7NjRnEAvdO6R3Px7E5LF9NCv7ZS30TTXmDOU1tjV+dP6ywR5v6A3nQi2srEhWTuzpEe21x4uttBF8ZD1/ZyWKzZcnYs8oJVnvoTVV1lG8PWupe9bO1vnXtCpZI4EoE4qVWVBlx6/yQLCMGJFIYKvjUpV+TgBGVCInJ7D0x95eaJT38V5Yp1DsAlf/jWtcev+8frbr7vzq1E1GnJq7QpEd+lykRp+133PviDX+y4e+vTD+0kIjbsnKt3uPWHxCyJnbr2xmTHE37RarEOgjTegjk4/Tj/s+pkycYxs/dIkAFl2KzOFI8rjK7LDi2PcnkThmQgECfihIkybIpBuDzKrcsOHVcYXZ8rFkzoTQ5ptyFiOC5Vjnr7xUEx74tV1w9y21Mw17PYtcFGLd/4Zn832rrdxvfnuI/dJcJcGpdajsa0rc3rYxBqR2kWE1bdguWp104+UhVD2/3qcn11b6qXS3JxbdqzE0N9b3PuzMcTRRO9mHK7f9pYenx2X5hXFs090fZSaVXc77ni/O9//wHrHMAEOIglIgETC9gBBhAhED/1xDMAxLnwtBOiV51Z+d7PeNkIEdHYUPWHvyytXZ6/6lIXJ8dtPv6Ykzf+/Hs/uef/3HX6eWd0WuyqjjghQ4/e++DXfv8zzJSUKqOrxjZsPunct7/mZRecjU5eZxEQxXdvTbZu5+GixAkAAokIBUYOTQVnbwrP2uQjE5/b9tjEM3vz2Sz55bshERsQAtCKTB6QxDkrYsVBBBDDxCBDFBJDkECcOEHqrPBFsIWoOlXOH79+5cWvbHuQF4DGU9xWy3cSFk1v1pua9TNxv3a5vkddJFHbXWi8nbS1SzW+72/ArUlAC3ni0G6nOp3N1qftebUxLAWTFXq42bcVyk0XRaMTav66Oh+Nt5707ld3EzPq8Iwu8Gnv2Z1OXBNdpqOmdpqugr5MR93PaffFt+abJWFpQIssFREiiMjmzRve9Kaz9x2YYuMDISEQCzgQyAggICtgY3743Z8niSVACLn3vjE4+Vj3/H5xDgIqZKs/ud89u8+HFIwsHwuj6JH7diTVpNP1gMODD+LcSedu/uSPrrv8f/yn337X6xIr9956119f9bm7rv9OQ2/TcSPO1fel+rN/gfH+EyZmMBGzHJri9asKH3gbGeN/9cjt90glNsyUBktwwYQMYmInAlCGTcGEI2FmNMqORdkhE+VNGJFxAgtJXR6or1nhHTeSxPHqN18YjQ37QpOtB7nO/A2+pglx2ouw6f3GO1DTr+otTzsF9HfvumiCabc17e2hPge17tRCThBNzzGNe9e4C52etptuhH3v+cIcil620vt9sfHQNb32X5jLc/nCKwa063mrQupE3zs8C+tO77f21iux9fSh5wEz7df8A0OXr/ViyZhXloRoaGvspVpkw++959WrVo+UqrEwRGAFTsQ6MRwB5PMro1xm547df3v9rcScVGJeu2Lo81fl3v06ymWkUkVsebhYb7wSxyAc2HvAOdumK3WPg8+NYSZmEwajq5effMHZb/3sle/7xuc2nnVKkiS3fOH6f77xe/7L4sQmiTghf75FAASbjpFqLJNlKVVkqizlilSr4ZbThv7rB8yG1bYak+Edt/145+335IeLcMIgAIaoGGTShbqJvAyquSbECpzvps+wAOqKQYD0O4S4VClsOnbNJRcCoFrBq/qtaIFNnZ3G97RTUtPtqlODnXRDL5foLGjd+oy+30SjYZ8anl067ft80/sDUydmOpMONLPTFm2H6+I6INoyixthdxG/MJdkv37Ventu/Unvm+7xm9NefYt+TS1m9gR1NfaKiDGcJHbjxpXveOe/+m/X3JoZCxzSxEMnYkwEDpyLfWhklI2u/+JNK9cs/9dv2OISS+PD+fe9OfuW8+3OPWA2J65HIcdA6dDU7h27hGhofISI61tEbX3J+qMSjJGpsnv+gJQrlMvQ8hHKZW01PurkY9917cevu+JPnv/Nk7f/xf886fyzhlaOAzAcANi365ncaDE7VBCRzOtfiWpS/dGvpJqQYXPcUdEFZwVnnEhErhqbKHzuoZ13X31dwIaJmcgnTRSDKMsBAKrnWPqj5A8aCAQBqLYcJyi97aSiAXCAFXf0FW822YyPx5SaGKqPyLnfG2Z6rtFOs/e3/XlqvNPmepzlmwqONf1Zb6rt6Vj4CaLTFjuVTZtpO/1lwY5P90l8Rvf7tkey7XmfhYxYyAHTaUhQB6fhAvRtppuYVuLMuUd9bmoRvRJ1lmjKJWqn068eefnlr7rj9gce3fF0IReR+BWfhUGhyVfcAf9NDgIkyec/9pUkji9+y3kAICLLR3n5qH/pR/et3/zuE9t3BUF03KnHh5nQb8hZJ+KYuV65Qapx+eYfxT/+td25x+07xOPD5pg12UsvjH7njKRcXXb0mnPectFt135z/3P7fvl3t7/6yreV9h969Mdbd9+//d6/v+O01573uv/8B846Dkz2rRdk33rBYf8FINYSM0fhU/dtv+0jXyg/90I+nzeCVDcAY2HWeJcVRAREAiEhgaBmw0j1jR/sLq1lJU6chTimyv5Dyy7esvz8c9LfL9IF3Ep9o/P3ULWQ+9XLzN7k7m3r/cWCa4UuQ6LTQ3CnO0Er/Z24B2JDvd/jpz2Sczn1fVEerY9wbb/WfUfmPp5nfbJmsSH/Yj42198LudFp28dmZ8riGw+7nCp/dKx1xvAddzzw/qu+VshGAZkAwrUFKSrxfmcrBkSQgMUl1iXx+a899/IPXLJu45omIXzH3/7TDX/2DVeNXWJP33LaJVe+Zf1J6zO5TH1lBxHxgmXic1+v3PJjykSUCWEY1km5isAUP/O+aMtpAJ5++PEvvf1jSbmy7KhVG885ddfWbft27q6WytlCLsxGl339M0edfqKNE/LjhkmsExG/XqWIu/+m239yzTfsxGQulzOCgChkBjAWZDbkR7jmNyISb2wggCB1gzUkDX60XiuIJOKsuESkGsco5jb/1afyx66tL7eNRZX/nejvVbq4F1If92V2OzL3DvRl9pz1WViwp+p53VB/D90c7/f9amRRxsPstjv3SaBfF/JMe9K63R5l0yIYIxd4e61M+6AGQATM9OlP/93/+tbdy0eLsGKYAkIAYrHlil8vm1jEMOBstVQuFLOv2HLqOedvXrZi1DDvfWbvz2//5613bo3CIDKGIGKtjeORsaHjTj/+uM0nrNm49mW/dfLoijEA8dbtE5/4ki/KCOsAgAlh4J7dl//A23JvvwhOShNTn7/gva5SZSJbrgTGRNnIV31OKpXxY9a+/jNXrT9zU9PuTD6/f9cv7r/vW7fs+eW/ZLOZKIy8YgiYGIjIbCyMZk3grSlEgtSnICTpIEpHksDBOXFOxCuGRFzinCWUDh46/hNXHHXpRfVqTug8sBbd0lVnYZ41F4aBmOymtXbMqM2leSIWkSPy0B2RO9WJhZ+RWr23Kho6Mq2xwTlhpomJ8jvf8ZeP7XiqmM8ah7puEFetVg+SJOx1A4khiHPVUrlaKheLOcNUOjhZyGcLhawBIGJ8nCEESZJU42qpZIz50Ff+6OzXbBGgesfPJz93A5goE6VmhjiRqXJw6sahz7+fRosEPPazB77+H/7UAIbZEDNAEPZ3aKZqqRwVsye++uz1Z568bOO66qHJvTuf3PvormcffGTvtsfDwOTyWQMyIJMqBgqJ1ueGR8IMUmsHCF4lCECppYG8ywIi4uBtDP5/iZ2zjKn9B5f/7pZTrv6PjYd06SsGZe7MaI5bajYnRVEGhaUY0+BpDPhnJmtdsZj95KcuufIProurCYUBiTggASKOctmxuHrQ2goR+fLJzCZfLA4PF+EcQYqr8xBHTkAw5G/AwkIUhGEYFkeKkwcOPr1zD3wVxQvOck/trXz3J+7ZffL8BA0XeMVYsPmE/BVvoNGiixMTBvff/tOkVM0UCgRHAIEMEQgsApFcPm+r8QPf+cHDt95twhDOSRK7OImisDgyZEDkxBAMUUAMwBCvyw0PhxknjgFvTwAAQjq9k6QRjwBSxeCTKcSKJM45QmWqnDl6zfEfvswfvvpKXYueoqMoitJHlniI6JHNUjmOrYOg8WHIf+qcGMNf/9oPr/6zm8dGCmzFP6YbQcjEkDietEmJ4QyQLuIAGK8SBAEJAUxikIYIMIQBiGOmSqm0+uhVn/j2n44sH03ixISBe/oFu3O37DtIo0Nmw2pet9IB7Bwxb7t767fef7WxCAPjN+GzJRk+bVLI5z4wwVk4ISImGGYCsThfminwtgQgb8I12eJwGEHEmxP88tsEebGxwSsGOIhIWu7JpqEMLra2apPT/vwj41s2+5pRTcF3TYdXL6EjjN6n0R6D1xRlyTLryINWm39jwnPTC6UtS+joNJ7Lpnmt6Yn5U3984998++6V40OwMIyAKAAFjACAS5KkJK4KcQzHBANhkCFhUEAUsSmEWQaqScW5WOBIHEGIUZ6YPOmcTVde+5Hh5SMAXKot0iQF3xtx7pf/eNctV98QH5zMRJEBDLEBAMlwYAixTdLyCQTyIgAggEFEwgSvGAgESEQ8FmVXRoXIsPdKkP+VVwwC/wLiLQ2HFYNLFYOPf7QxpDwxefyHL1v/ztf2EsrQ/SNlEJljAJeOB2VQ6HuaQ9PtRq+F7iyho1MfCm2fhBqDG2zirnjPl3/xkx3jIwWxEhIMcUAwQEAUELFYcTFcQnB1Y0PInOUgY6KIiCFMsDY5WNlvbUwkEMeM0sTU6mNXX/Tu1532O2es2LCqsQN7tj/x+K933H/bPQ/feW8uG0VBaCCG2BCxYFkmPxLlAsLBaulAdcpBfIAF1ZRHTUkIAwyKmIeDzFiYKQaRtwYwA0JMkooGb2wQqaVZ+qMjPvjRwXslrBVJGFP7D6y55MJNn3xvq2pWM8NLhDnGNOiQUAaF+U7F1GuhO0vr6DTqBqktPd50//MZmM88c+C97/mrx7Y/NTach0NEZAgBkSEKUungZYQwIQACQkDE8IYHMQQWFxCX4smDlQPeSUEQNihPlSSxy9etWLZ2fHTFeBgGlYnJg8/tn3h+34E9zxugOFQwABMFPo5BZFkmvzo7JBACDFC18cG4VHaxSFpS2qdQGqKAKGvMcJgpmihnAgIgjr2w8LGZ4nMlUt1QUwxpHIPA1aMZEucScY4wdeDg2HkvP/3PP8LG1Es5QeMfX2LMsUiAjgplUJi1aOgxukuvhe4suaPTvX5Fo2549NFnPnjV13btfG64kCVBAAopjRUwoIDgX4RMXjcYwJAEREbEkI8/AEMOVPaX45IBMQRwfpWGpFyxSexv5yzCRFEUZDJhQAwrAcMQGRDghoPcmtywIXDNohAABDhxFRdb5ys0IiLOMGc5CJl9sIWvN+WTOFgozeYgIhFGWi6irhjExzFAfG0G65wVZxnlgxPFzSdsvuaj4UixXpWh+6DXS+KIpJcaU50+1SGhDBCNz5ZoZ1XtJA662LAb3+nX5dC29EJfWl5cltw+9FK2gYiSxAaBuf/+J/7wvV+dOjA1VMiSkwAcMBmiEAiIfZRDzSQgAVHg60jWwiGZhAUEu7+yP04qtTBGRyKGAAhTWkfSF4/yyiAA+QRLQzwa5VZkCgExQQwRQbwbgkW8aYGJOA1rqLsq0kAHAwAv8kfUSjKQT+4Qgc+wlNTy4qw4R2KdJOIco3Josnj6Cadf85FopFgPZegS/IgjZdQqrSxWBR5FWWBaIxlnNIDbBsw1fmFhClIN7kW3JBasaqSXQykiQWCSxJ522oYvXHPZ2IrhiYmyMFmIExERC1j/RA6kN12QAA4MgiMISIiECEREZjw7NpQZYgochIgNM4gJXjMwgwkwYAYz2JdnzAaZlbnhFdlhJhbAa4Na3IL3NJBDGq5ofSCCiJcAvgiD86GSvici6b+SagrnbQv18AWR2P/rXCy+iNNE4fQTNn/xoy9SDF0P4+AOU6VfHKlPP8pLlrkohv4y07iieerGfLNE54vuWrL+p/dTPLxtz8c/eMPjjz0zPlIgm0Y2hERB7X9DCImYEAoZgmGEAiL4ctQsYiCGYW1cjktVW7EuIUharykNXQSDGAgI+SAaCjJDYSYkJhKW1GLBICZhEtRfixCB6x4Hb4rwUQsQSiMlvV0BjFrZx/qaEl7vwDmBPZwx4RyjdODgyMtPOuOaj0YjRWct19IlsCTLRSsLwOxSLnVUKANHlzy72bXWyRXuX7ReLHUfetP7Tb/tpWODeAEu3R53clw1ven9FDsfffaPPnzD9od2LxsukPNhjxxQPcohlQ4BwQgFjIAQCJjEEIx4X4MYIiMCsU6skzg9gLQJAAALP0lEQVSxFrBpDCMQMuc5iEwQMQdEBLA4JvgsCfalogBDglRJgOHzJ+HjJZmE0vwIn36Z/glpMFN4m0j6n3MQSYs4OeucI1hxpYmJsXNOefnVHwxHCk2rS3Q5noM4OpXembasauv7OiSUQaS7Pm66tffSWqcLoW0qZnfJ0uQg7h6c19ThQWHpdrd7BiZa7A0v7D30xx/95s/u2jY+UgiISBASB0QBIwQHBENsCGFDmCTDGxvECDGJgdQqNcGQj39EGvoAcBo+CR+FUKsflaZWMkAkplENpDETPlIBLEIkDCIRTiMYhAheaoBAtZWu/b9OBOIE4pyzkFQxWFuenDzqTa8+9ZO/T8yNJRnQ2caAARyXykzpcS6ro0NCGVDmVTRMm2E0bbPTPsINelmIJd3daZ0U/kU9nyKu2v/y2Zu+8zf3FHKZXBSQQ2ppYPK6IbU3gAzDgAKI8dGRJCwICAQYiE/UNIRUHBBM6oBI/0ydGgSSBt1AQiCDtO4kSVoNgkTYx060GBvIF6msqSOI8/sl8JJBRJxLXRIUlyuOcMy7X3/i+94CQG0MSiMzcpHqkFAGlx5Fw7TfrH+n9Sdtw8l7FA1te9ua4tGpz0ufpd7XJntDl5wZ55xfCPvGb9751WtvrUxWRoo5FjHggCkAhQTjwx1AhpGWc/BGBRIDYpGAhIgC727wdSQFBkIkpqYMfHKm90ek5gSkxgPTYGNI17aoBT1QmiiBmieiZmwA4Gs+QgBBWtvB+YgGJ85BHKR8aCKzetkpH7981XlnAqjXY2g6JvpA+RJn2hlNx4My6MylTsO0KZddHsNUNHgGoK9d/BT1uyYAInIuzYd4+MEnP/8nN2779eNDhWw2CFgkZDZoiIs8bGxAGutAMOIFBIz4AlBeNIiPajSHYx7JpJ6Fw0qiHu3IRKlKSPM5ydSSKplq+ZY+qRIgOL8flBoYvFTwSRPOiQgjrlbjcnnleWdu+tC/K25YLc7Bp2a2aIVWDTFYY1HpC50mNR0MypHBHFMuW1ubV9HQC4N1bQ5GX7ufpyanvl/XqlSq3vCl227+1l1JuTpcyDFgQCEo4NRDEfgyUHRYN/jvBFQLZRBff1pIEMDHMyI1NtRiF7yAYIE3RZCIQWpU8FEOPmSBKa3NwABqdRqQZkg6AQAHSeMYHJyICGAhlcnJYHToxCvesPEdFwPwQQzoIc4DgzYQlX6hSZXKkU2raEAPg7yTrbrvomEWImawrtCB6Wvv3qm6bgBw7y8e+fIXbt5x365cJirkQnIIgIDZwIc7pItd+cUpjC/cROJLSfpq07XakWQafRP1Uk447K2g1OrgkyZ8rINfdAq1RSjSfyVdXdNXbHAOLq3f5EszQBwhLpfjarz6lWdsuurfjpy4wX9IvlxlD4NysEahoihKj8ziWb+LD3eB3RNtGazpepD62mPYKl5scqhWk3/49l3/+4YfPLt778hwPmMCI+KLQIdMtTWu6jYG/w5MujCmLxctPuvSp2j6YElOfRlpFYcXRUSmRgWp+SPgPRe+j0TwVZyIfOUpEbjUygARQlKtVidLxeOOOuny1x/9hvMAOGuJue6Iqe8gtIiToigvMWZ9216AmIamlMvW9tu2OVgMWI+7nLBWv36jyeHp3S/8w7fu/H833l2dqhSyUSYKDdJFKAKfiun1gZcLQMBpeQZTWySTBIc9F6mMICJJUyoOq4RauoSkaRRAWriJ4KRmbxCfYJlaF4QYDmKrcXWqlFs9vvHSC49546tyy0dRy5JAV7HcyCCOQkVRlB7pnl087W/nzz3RS6pz65sDN2MPWHfR7py11XSNMZJ16fDow7tvuv6Oe+98cHL/RDaKCvmML7EQgLxoSLVC3WfRIBrqnoi0kAN8gCRqTor0BZMPchRvfvCrSMCLBvGVoyHkajYGAQBCPDllxWbGh4++eMvxb7uouG4lALEOTN2NCk0M3PhTFEWZEf0NRZwn90QnJ4hmTywOvSvNhsQKBwEbBvD4I099/zs/+/k/3bdrx55iPpMJwyjkkMgICAhqoiFgYVDgK0JyKhoMQCR+HUsvKYjAcKmTIi3MkAoIH8HgIx99b3y6BPkPnHXWJpWqjePxk49df+FZG1//yvzqZfD+CKLGRa67++E8gzXyFEVRZsF8i4buRtzeo+sAOOeI6AgLQRukvjbR6eS1SsW61cF/5Ms5PP/0vnt//ND3//6eJ7ftjsuxAQr5TCYIGGJEDIhri2ubxloO3saQOil8UUgcDmLwmRHkV7USgqBubPCxkAwiJJVqXC6zMZwxq8/atPE1W9ZsOS0zUgQgzsH3froSpINu41IURZkF3VMuWx0E07Y2T4GQnZpqndgHa/YepL620sVV0fZ9qZWBEicmSHMXdz705E9v+9Ujv37siQd3Tb5wKJfN5HOBYRMQBUwGtUDItJi0j4hE4G0MJN4+4f0RXjQcjn+EEAgQgoM4l9ikUrXl8tDaFaMnHLXu3FPWv+oVo8eu8T10iSXTHO3YZa81tVJRlJcg3W/bXURD27t+F0vDHCtAzIgBmsYHpqOdaOuq6HKyX2R1qDksADjrtv3qkSe27Xrop9sff+A3pf0TDCLnAkIYmMiYIOCAKWCiegkHgJAWZiAShmN/6p2Fc2KdJIlYSwAzgVxx1fiqU45de86mFScfu+LkY+tdctYRNVsXehyvAzTUFEVR5s6MRMO0P19IZdBlcwM0kw9MR7vQi3Js0o9oyFqEwDnnDQ8AbGKnJkp7Hnnqsa2P7Xroib1PPlc5VKocnEqmyrYSJ+VKGHAUBOkiFLVMCu+DcHFC1mVyUZTPZIu5TCGTHx8aO3r1ypM2rDnjhKGjlmeKuXqtBV8K2m+0x6iFJgZonCmKovSFRRQNvdgheoxbH1z/8sB0dFpmFJ/S+qaIOOcAGGOavrB39969u/dO7D0wdWCydGiyfGBy8oUJwyCAUc+VIGvt6JqxbCGXGy4Ulg0PrRofWjlaWDHa1JpLLIioc1pEL+NygEaYoihKH1lcS8MsREbTPN9qTh6s+XyQ+jotXUIje3db1P4EfBgjTx/72q1LzonAD4z6we4S5NhLnwdrhCmKovSR/ooGTBcJN9Putf1596YGa0ofpL72SCchOdMIl6boB9+siDAzcQflYZ2IgOry0S9n2U0itHZP5YKiKEon+i4aZtGB/gZLDtbEPkh9nRFdbFBdnBTTttlojWhLL1aETlvsbhEZrIGlKIoyHzTYg2czT/ZRNHQPX+gywzcycBP7gHV3RrQdHJ0Ug38xT+evdzV6ZIwqRVGUeWLRLQ2tDc4ulBKDObcPXo9nwSxGSWvOxUL+vM4gDilFUZR5pXVKn+lU2fam0JRh1zttK0D0+KuBYyA7PQt6P53d4w/QMD66+DhULiiKogwovdwvuuRb9sLgzvCD2u9Z03fbVH8Z3JGkKIpyJNHdGjGL3/b+86XMwO/A7OiLdOgUXOmc41rVpt45AgaToiiKcmSjN6pZCojG2MlOr3tpR7WCoiiKMijoHeswPaqHaYsyzbEFRVEURVmaBIvdgSVE09IP89e4oiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoihLkf8POZz1gDtBPDIAAAAASUVORK5CYII=",
                            width: 700,
                            height: 210
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_white_svg__b",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 700,
                                height: 210
                            })
                        })
                    ]
                })
            })
        ]
    }));
var $a4996e3fa9df448c$export$2e2bcd8739ae039 = $a4996e3fa9df448c$var$SvgCephLogoPlusWhite;





parcelRequire("7fPBF");
const $67599b84b2002306$var$SvgPowerBi = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M8 7c-3.31 0-6 2.69-6 6v20a5.99 5.99 0 0 0 5 5.91v-2.04A3.99 3.99 0 0 1 4 33V13c0-2.21 1.79-4 4-4h33c2.21 0 4 1.79 4 4v20a3.99 3.99 0 0 1-3 3.87v2.04c2.84-.47 5-2.94 5-5.91V13c0-3.31-2.69-6-6-6H8zm28.5 8a2.5 2.5 0 0 0-2.5 2.5v24a2.5 2.5 0 1 0 5 0v-24a2.5 2.5 0 0 0-2.5-2.5zm-16 6a2.5 2.5 0 0 0-2.5 2.5v18a2.5 2.5 0 1 0 5 0v-18a2.5 2.5 0 0 0-2.5-2.5zm8 4a2.5 2.5 0 0 0-2.5 2.5v14a2.5 2.5 0 1 0 5 0v-14a2.5 2.5 0 0 0-2.5-2.5zm-16 5a2.5 2.5 0 0 0-2.5 2.5v9a2.5 2.5 0 1 0 5 0v-9a2.5 2.5 0 0 0-2.5-2.5z"
        })
    }));
var $67599b84b2002306$export$2e2bcd8739ae039 = $67599b84b2002306$var$SvgPowerBi;





parcelRequire("7fPBF");
const $cef83b92ad455ae8$var$SvgPreferences = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 7c-1.852 0-3.406 1.285-3.855 3H3a1.006 1.006 0 0 0-.879.496 1.01 1.01 0 0 0 0 1.008c.184.312.52.5.879.496h18.145c.449 1.715 2.003 3 3.855 3 1.852 0 3.406-1.285 3.855-3H47c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H28.855C28.406 8.285 26.852 7 25 7Zm0 2c1.086 0 1.941.836 1.988 1.91a1.44 1.44 0 0 0 0 .184A1.975 1.975 0 0 1 25 13a1.976 1.976 0 0 1-1.988-1.91 1.44 1.44 0 0 0 0-.184A1.975 1.975 0 0 1 25 9Zm14 12c-1.852 0-3.406 1.285-3.855 3H3a1.006 1.006 0 0 0-.879.496 1.01 1.01 0 0 0 0 1.008c.184.312.52.5.879.496h32.145c.449 1.715 2.003 3 3.855 3 1.852 0 3.406-1.285 3.855-3H47c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496h-4.145c-.449-1.715-2.003-3-3.855-3Zm0 2c1.086 0 1.941.836 1.988 1.91a1.44 1.44 0 0 0 0 .184A1.975 1.975 0 0 1 39 27a1.976 1.976 0 0 1-1.988-1.91 1.44 1.44 0 0 0 0-.184A1.975 1.975 0 0 1 39 23ZM14 35c-1.852 0-3.406 1.285-3.855 3H3a1.006 1.006 0 0 0-.879.496 1.01 1.01 0 0 0 0 1.008c.184.312.52.5.879.496h7.145c.449 1.715 2.003 3 3.855 3 1.852 0 3.406-1.285 3.855-3H47c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H17.855c-.449-1.715-2.003-3-3.855-3Zm0 2c1.086 0 1.941.836 1.988 1.91a1.44 1.44 0 0 0 0 .184A1.975 1.975 0 0 1 14 41a1.976 1.976 0 0 1-1.988-1.91 1.44 1.44 0 0 0 0-.184A1.975 1.975 0 0 1 14 37Z"
        })
    }));
var $cef83b92ad455ae8$export$2e2bcd8739ae039 = $cef83b92ad455ae8$var$SvgPreferences;





const $24f5c501f2475f6f$var$SvgProLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "proLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M13.668 119.082h885.613v259.086H13.668Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "proLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#proLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#proLogoTransparent_svg__b)",
                                transform: "matrix(.98767 0 0 .98842 -45.894 86.29)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#proLogoTransparent_svg__c)",
                mask: "url(#proLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.98767 0 0 .98842 -45.894 86.29)"
                })
            })
        ]
    }));
var $24f5c501f2475f6f$export$2e2bcd8739ae039 = $24f5c501f2475f6f$var$SvgProLogo;





const $15669c683dd043b1$var$SvgProLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "proLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "proLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#proLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#proLogoWhite_svg__b)",
                                transform: "matrix(.97794 0 0 .97844 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#proLogoWhite_svg__c)",
                mask: "url(#proLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97794 0 0 .97844 -48.056 88.733)"
                })
            })
        ]
    }));
var $15669c683dd043b1$export$2e2bcd8739ae039 = $15669c683dd043b1$var$SvgProLogoWhite;





parcelRequire("7fPBF");
const $7efcdfa101ef1389$var$SvgPs4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M1 19a1 1 0 1 0 0 2h11.5c.84 0 1.5.66 1.5 1.5s-.66 1.5-1.5 1.5H3c-1.645 0-3 1.355-3 3v3a1 1 0 1 0 2 0v-3c0-.565.435-1 1-1h9.5c1.785 0 3.22-1.381 3.422-3.115A1 1 0 0 0 16 22.5c0-1.921-1.579-3.5-3.5-3.5H1zm25 0c-1.645 0-3 1.355-3 3v6c0 .565-.435 1-1 1h-6a1 1 0 1 0 0 2h6c1.645 0 3-1.355 3-3v-6c0-.565.435-1 1-1h6a1 1 0 1 0 0-2h-6zm20.97 0a1 1 0 0 0-.466.13l-14 8A1 1 0 0 0 33 29h13v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-7a1 1 0 0 0-1.03-1zM46 21.725V27h-9.232L46 21.725z"
        })
    }));
var $7efcdfa101ef1389$export$2e2bcd8739ae039 = $7efcdfa101ef1389$var$SvgPs4;





const $3ddc512c8843c2cb$var$SvgReactNative = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M69.11 7.969c-1.56-.053-3.192.22-4.829.75-3.273 1.06-6.703 3.129-10.222 5.992-1.38 1.122-2.772 2.405-4.168 3.766-1.366-1.327-2.73-2.579-4.078-3.676-3.518-2.861-6.938-4.926-10.204-5.985-3.265-1.058-6.515-1.091-9.183.45s-4.265 4.369-4.98 7.726c-.717 3.358-.642 7.356.077 11.832.25 1.555.61 3.186 1.016 4.848-1.525.462-3.006.948-4.379 1.484-4.144 1.619-7.573 3.555-10.07 5.86-2.497 2.304-4.11 5.1-4.11 8.172 0 3.07 1.613 5.863 4.11 8.167 2.497 2.305 5.926 4.245 10.07 5.864 1.468.573 3.058 1.09 4.7 1.578-.59 2.206-1.07 4.346-1.395 6.375-.72 4.48-.796 8.478-.078 11.844.717 3.365 2.314 6.21 4.996 7.757 2.682 1.549 5.945 1.51 9.219.45s6.699-3.126 10.218-5.989c1.367-1.111 2.75-2.38 4.133-3.726 1.39 1.354 2.78 2.63 4.152 3.746 3.518 2.86 6.942 4.926 10.208 5.984 3.265 1.059 6.51 1.092 9.18-.449 2.668-1.54 4.264-4.369 4.98-7.727.716-3.357.637-7.355-.082-11.831-.327-2.035-.806-4.179-1.399-6.391 1.695-.5 3.335-1.03 4.848-1.621 4.144-1.619 7.573-3.56 10.07-5.864s4.11-5.097 4.11-8.167c0-3.071-1.613-5.868-4.11-8.172s-5.926-4.241-10.07-5.86c-1.393-.544-2.897-1.036-4.446-1.504.41-1.672.773-3.314 1.024-4.879.72-4.48.796-8.482.078-11.847-.717-3.365-2.318-6.206-5-7.754-1.34-.774-2.827-1.15-4.387-1.203m-.184 4.07c.978.027 1.813.26 2.527.672 1.428.824 2.484 2.43 3.047 5.07s.544 6.21-.121 10.348c-.228 1.417-.558 2.918-.934 4.457-4.09-.984-8.571-1.715-13.347-2.145-2.4-3.324-4.866-6.348-7.352-9.035 1.314-1.283 2.62-2.483 3.895-3.52 3.251-2.644 6.33-4.444 8.898-5.277 1.284-.416 2.408-.597 3.387-.57m-37.953.012c.984-.028 2.11.152 3.398.57 2.576.835 5.66 2.634 8.914 5.281 1.249 1.016 2.526 2.19 3.813 3.442-2.504 2.707-4.988 5.763-7.403 9.117-4.759.437-9.224 1.175-13.297 2.164-.373-1.531-.699-3.027-.925-4.437-.666-4.142-.682-7.715-.117-10.364.564-2.649 1.628-4.261 3.07-5.094.72-.416 1.563-.652 2.547-.68m18.98 12.234a90 90 0 0 1 4.875 5.8A116 116 0 0 0 50 29.98c-1.665 0-3.303.041-4.922.11a90 90 0 0 1 4.875-5.805M50 34.02c2.72 0 5.37.111 7.95.3a114 114 0 0 1 5.16 8.114 114 114 0 0 1 3.96 7.504 114 114 0 0 1-4.015 7.605 114 114 0 0 1-4.024 6.43c-2.912.243-5.93.379-9.031.379-3.175 0-6.261-.144-9.238-.399a115 115 0 0 1-3.957-6.336 114 114 0 0 1-4.004-7.586 114 114 0 0 1 4.023-7.633 114 114 0 0 1 5.137-8.07A109 109 0 0 1 50 34.02m13.102.8c3.295.412 6.39.983 9.27 1.668a90 90 0 0 1-3.184 8.75c-.829-1.597-1.687-3.199-2.614-4.804a120 120 0 0 0-3.472-5.614m-26.414.032a120 120 0 0 0-3.399 5.504 121 121 0 0 0-2.652 4.867 90 90 0 0 1-3.16-8.7 86 86 0 0 1 9.21-1.672m39.64 2.699c1.418.429 2.787.876 4.043 1.367 3.82 1.492 6.842 3.259 8.8 5.066 1.96 1.808 2.81 3.531 2.81 5.203s-.85 3.396-2.81 5.204c-1.958 1.807-4.98 3.574-8.8 5.066-1.396.545-2.93 1.04-4.523 1.508-1.138-3.518-2.59-7.187-4.317-10.934 1.987-4.3 3.591-8.494 4.797-12.48m-52.723.02c1.193 3.945 2.777 8.097 4.735 12.355-1.74 3.768-3.198 7.459-4.34 10.996-1.538-.456-3.02-.937-4.371-1.465-3.82-1.492-6.842-3.259-8.8-5.066-1.96-1.808-2.81-3.531-2.81-5.203s.85-3.396 2.81-5.204c1.958-1.807 4.98-3.574 8.8-5.066 1.236-.483 2.583-.924 3.976-1.348M50 40c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10m0 4c3.337 0 6 2.663 6 6s-2.663 6-6 6a5.97 5.97 0 0 1-6-6c0-3.337 2.663-6 6-6m19.238 10.727a93 93 0 0 1 2.727 7.254 86 86 0 0 1-7.66 1.398 122 122 0 0 0 2.289-3.793 121 121 0 0 0 2.644-4.86m-38.554.004a121 121 0 0 0 2.66 4.886 122 122 0 0 0 2.258 3.75 86 86 0 0 1-7.637-1.402 93 93 0 0 1 2.719-7.235m-3.872 11.117c3.62.857 7.543 1.516 11.704 1.945 2.777 4.017 5.67 7.626 8.582 10.781-1.302 1.27-2.593 2.461-3.856 3.489-3.251 2.644-6.333 4.44-8.902 5.273s-4.486.723-5.914-.102c-1.428-.824-2.48-2.429-3.043-5.07s-.548-6.206.117-10.344c.302-1.877.752-3.887 1.313-5.972m46.31.015c.564 2.097 1.016 4.117 1.32 6.004.665 4.142.681 7.71.117 10.36-.565 2.648-1.626 4.265-3.067 5.097s-3.373.945-5.949.11c-2.576-.836-5.66-2.638-8.914-5.286-1.272-1.034-2.572-2.231-3.883-3.511 2.931-3.168 5.845-6.796 8.64-10.836 4.171-.427 8.106-1.081 11.735-1.938m-29.388 2.34c2.054.112 4.134.188 6.266.188 2.061 0 4.074-.071 6.063-.176a92 92 0 0 1-6.169 7.48 92 92 0 0 1-6.16-7.492"
        })
    }));
var $3ddc512c8843c2cb$export$2e2bcd8739ae039 = $3ddc512c8843c2cb$var$SvgReactNative;





parcelRequire("7fPBF");
const $914be67361fb6872$var$SvgRecordWorkflow = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.75,
                d: "m3 15 7 2.7-3 1.1-1.1 3zM18 1.8l1.47 2.73L22.2 6l-2.73 1.47L18 10.2l-1.47-2.73L13.8 6l2.73-1.47z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeDasharray: "0 3.2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.75,
                d: "M4 11.5c0-5 4.5-6 9-5.5"
            })
        ]
    }));
var $914be67361fb6872$export$2e2bcd8739ae039 = $914be67361fb6872$var$SvgRecordWorkflow;





parcelRequire("7fPBF");
const $f16a8074acc9fc02$var$SvgReminders = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.959 0-9 4.041-9 9v24c0 4.959 4.041 9 9 9h24c4.959 0 9-4.041 9-9V13c0-4.959-4.041-9-9-9H13zm0 2h24c3.877 0 7 3.123 7 7v24c0 3.877-3.123 7-7 7H13c-3.877 0-7-3.123-7-7V13c0-3.877 3.123-7 7-7zm0 5c-1.292 0-2.323.502-2.998 1.262C9.327 13.022 9 14.014 9 15s.327 1.979 1.002 2.738C10.677 18.498 11.708 19 13 19c1.292 0 2.323-.502 2.998-1.262C16.673 16.978 17 15.986 17 15s-.327-1.979-1.002-2.738C15.323 11.502 14.292 11 13 11zm0 1c1.042 0 1.76.373 2.252.926.492.553.748 1.31.748 2.074 0 .764-.256 1.521-.748 2.074-.492.553-1.21.926-2.252.926-1.042 0-1.76-.373-2.252-.926C10.256 16.521 10 15.764 10 15c0-.764.256-1.521.748-2.074C11.24 12.373 11.958 12 13 12zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm8 1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H21zm-8 7c-1.292 0-2.323.502-2.998 1.262C9.327 23.022 9 24.014 9 25s.327 1.979 1.002 2.738C10.677 28.498 11.708 29 13 29c1.292 0 2.323-.502 2.998-1.262C16.673 26.978 17 25.986 17 25s-.327-1.979-1.002-2.738C15.323 21.502 14.292 21 13 21zm0 1c1.042 0 1.76.373 2.252.926.492.553.748 1.31.748 2.074 0 .764-.256 1.521-.748 2.074-.492.553-1.21.926-2.252.926-1.042 0-1.76-.373-2.252-.926C10.256 26.521 10 25.764 10 25c0-.764.256-1.521.748-2.074C11.24 22.373 11.958 22 13 22zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm8 1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H21zm-8 7c-1.292 0-2.323.502-2.998 1.262C9.327 33.022 9 34.014 9 35s.327 1.979 1.002 2.738C10.677 38.498 11.708 39 13 39c1.292 0 2.323-.502 2.998-1.262C16.673 36.978 17 35.986 17 35s-.327-1.979-1.002-2.738C15.323 31.502 14.292 31 13 31zm0 1c1.042 0 1.76.373 2.252.926.492.553.748 1.31.748 2.074 0 .764-.256 1.521-.748 2.074-.492.553-1.21.926-2.252.926-1.042 0-1.76-.373-2.252-.926C10.256 36.521 10 35.764 10 35c0-.764.256-1.521.748-2.074C11.24 32.373 11.958 32 13 32zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm8 1a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H21z"
        })
    }));
var $f16a8074acc9fc02$export$2e2bcd8739ae039 = $f16a8074acc9fc02$var$SvgReminders;





parcelRequire("7fPBF");
const $fabb58c67223cc99$var$SvgRockstarGames = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12 3c-4.959 0-9 4.041-9 9v26c0 4.959 4.041 9 9 9h26c4.959 0 9-4.041 9-9V12c0-4.959-4.041-9-9-9H12zm0 2h26c3.877 0 7 3.123 7 7v26c0 3.877-3.123 7-7 7H12c-3.877 0-7-3.123-7-7V12c0-3.877 3.123-7 7-7zm3.723 5a1 1 0 0 0-.977.79l-3.867 18a1 1 0 0 0 .976 1.21h4.27a1 1 0 0 0 .977-.785l1.37-6.217h2.067c.939 0 1.122.156 1.36.73.237.575.304 1.766.101 3.407a1 1 0 0 0 0 .002 5.454 5.454 0 0 0 .021 1.597c.002.011.006.017.008.028a1 1 0 0 0 .291.972l3.37 3.116-2.6 5.738a1 1 0 0 0 1.43 1.266l5.58-3.393 4.287 3.328a1 1 0 0 0 1.595-.98L34.9 33.25l4.694-3.47A1 1 0 0 0 39 27.974h-4.863l-.817-5.133a1 1 0 0 0-.976-.842 1 1 0 0 0-.887.514l-2.771 4.994c-.06-.584-.073-1.467.064-2.828.15-1.48.012-2.642-.176-3.448-.065-.278-.088-.257-.158-.457.31-.168.407-.123.777-.494.802-.801 1.593-2.177 1.746-4.263.167-2.257-.554-3.976-1.92-4.905C27.655 10.184 25.908 10 24 10h-8.277zm.808 2H24c1.75 0 3.126.246 3.893.768.766.521 1.187 1.275 1.052 3.103-.122 1.667-.683 2.514-1.166 2.996-.482.483-.816.56-.816.56a1 1 0 0 0-.604 1.442s.125.21.266.817c.14.605.262 1.537.135 2.79a1 1 0 0 0 0 .003c-.166 1.644-.131 2.713-.012 3.521h-2.76c-.01-.186-.038-.325-.002-.62.22-1.776.257-3.214-.24-4.415s-1.755-1.967-3.207-1.967h-2.87a1 1 0 0 0-.976.785L15.323 28h-2.23l3.438-16zm2.762 1.031a1 1 0 0 0-.98.805l-.981 4.937a1 1 0 0 0 .98 1.196h4.471c.785 0 1.651-.12 2.442-.576.79-.457 1.45-1.303 1.677-2.414.234-1.142-.071-2.219-.722-2.918-.651-.7-1.565-1.03-2.475-1.03h-4.412zm.82 2h3.592c.418 0 .794.16 1.01.39.215.232.355.53.226 1.157-.129.626-.364.879-.716 1.082-.353.204-.88.309-1.442.309H19.53l.584-2.938zM31.801 26.02l.496 3.113a1 1 0 0 0 .986.842h2.686l-2.764 2.043a1 1 0 0 0-.389.994l.694 3.564-2.727-2.117a1 1 0 0 0-1.133-.064l-3.404 2.07 1.563-3.445a1 1 0 0 0-.233-1.149L25.555 30H29a1 1 0 0 0 .875-.514l1.926-3.466z"
        })
    }));
var $fabb58c67223cc99$export$2e2bcd8739ae039 = $fabb58c67223cc99$var$SvgRockstarGames;





parcelRequire("7fPBF");
const $7cb0e7963ddb95ec$var$SvgSafari = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 1.92C12.265 1.92 1.92 12.265 1.92 25c0 12.735 10.345 23.08 23.08 23.08 12.735 0 23.08-10.345 23.08-23.08C48.08 12.265 37.735 1.92 25 1.92zm0 2c11.654 0 21.08 9.426 21.08 21.08 0 11.654-9.426 21.08-21.08 21.08-11.654 0-21.08-9.426-21.08-21.08 0-.364.01-.726.027-1.086C4.511 12.766 13.71 3.92 25 3.92zM25 6C14.518 6 6 14.518 6 25s8.518 19 19 19 19-8.518 19-19S35.482 6 25 6zm0 2a16.92 16.92 0 0 1 11.26 4.28l-14.774 8.863a1 1 0 0 0-.343.343L12.279 36.26A16.92 16.92 0 0 1 8 25c0-9.4 7.6-17 17-17zm-.016.986A1 1 0 0 0 24 10v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014zm5.74 1.143a1 1 0 0 0-.908.63l-.382.925a1 1 0 1 0 1.847.765l.383-.924a1 1 0 0 0-.94-1.396zm-11.49.004a1 1 0 0 0-.908 1.396l.383.924a1 1 0 1 0 1.848-.767l-.385-.924a1 1 0 0 0-.938-.63zm-4.861 3.26a1 1 0 0 0-.695 1.718l.709.705a1 1 0 1 0 1.412-1.416l-.71-.705a1 1 0 0 0-.716-.302zm23.348.347A16.92 16.92 0 0 1 42 25c0 9.4-7.6 17-17 17a16.92 16.92 0 0 1-11.26-4.28l14.774-8.863a1 1 0 0 0 .343-.343l8.864-14.774zm-3.635 2.174L27.27 27.271l-11.357 6.815 6.815-11.357 11.357-6.815zm4.73 2.3a1 1 0 0 0-.359.083l-.924.385a1 1 0 1 0 .772 1.845l.922-.384a1 1 0 0 0-.41-1.928zm-27.681.042a1 1 0 0 0-.377 1.93l.924.382a1 1 0 1 0 .765-1.847l-.924-.383a1 1 0 0 0-.388-.082zM25 23a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2zm-15 1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1zm29 0a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1zm-1.07 5.35a1 1 0 0 0-.377 1.93l.924.382a1 1 0 1 0 .765-1.848l-.924-.382a1 1 0 0 0-.388-.082zm-25.875.04a1 1 0 0 0-.36.083l-.922.384a1 1 0 1 0 .77 1.846l.924-.385a1 1 0 0 0-.412-1.927zm22.841 4.49a1 1 0 0 0-.695 1.72l.71.705a1 1 0 1 0 1.411-1.416l-.709-.705a1 1 0 0 0-.717-.303zm-4.542 3.036a1 1 0 0 0-.91 1.398l.384.924a1 1 0 1 0 1.846-.767l-.383-.924a1 1 0 0 0-.937-.631zm-10.729.006a1 1 0 0 0-.906.629l-.383.924a1 1 0 1 0 1.848.765l.382-.924a1 1 0 0 0-.941-1.394zm5.36 1.064A1 1 0 0 0 24 39v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014z"
        })
    }));
var $7cb0e7963ddb95ec$export$2e2bcd8739ae039 = $7cb0e7963ddb95ec$var$SvgSafari;





parcelRequire("7fPBF");
const $566b6e2d6ce5c43b$var$SvgSanAndreas = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M32 5v1c-.286.039-.426.143-.66.238-.222-.092-.505-.238-.85-.238h-8.537c-.477 0-.893.077-1.252.21A3.567 3.567 0 0 0 19.45 6h-7.44C9.943 6 9 7.442 9 8.781V18h4v4.219c0 .585.176 1.183.535 1.68a2.725 2.725 0 0 0-.539.326c-.653.519-1.012 1.291-1.012 2.177v4.784c0 .26.047.522.118.779a14.058 14.058 0 0 1-.852-.297l-.494.59c-.266-.091-.533-.193-.799-.293a33.424 33.424 0 0 0-.912-.332l-1.549-.531s-2.041 3.728-2.154 4.003l-.045.108-.031.074-.026.078c-.109.335-.187.67-.234 1.002-.183.285-.33.593-.438.914a4.665 4.665 0 0 0-.3 1.592c0 .626.134 1.118.25 1.477l.017.054.022.055c.03.076.063.15.1.225l-.06.105A4.37 4.37 0 0 0 4 42.97c0 .777.247 1.457.752 2.08l.057.07.062.065A2.658 2.658 0 0 0 6.79 46c.383 0 .766-.08 1.139-.238.505-.194 1-.552 1.55-1.116l1.254.428.881-1.066c.154-.187.312-.381.469-.578l.068.082.963 1.15 1.366-1.398 1.119.574.416-.61.78.801 1.058-1.447 1.199.738.578-.761a2.123 2.123 0 0 0 .625-.047 2.123 2.123 0 0 0 .764-.307l1.252.772.501-.618 1.342 1.65.774-1.585.779.933 1.033-1.238 1.059.87 1.037-1.065 1.246 1.494 1.42-1.459 1.713 2.637 1.217-2.082c.068.083.13.154.19.215l1.567 1.609.752-.928.217.113.19.096.076.04 1.38.706.163-.183 1.261 1.295.168-.233.092-.125.707.727.348-.532 1.34 2.065 1.361-2.799h1.492v-5.506l-.347-.51a7.108 7.108 0 0 0-.149-.21l.018-.038c.104-.209.21-.42.314-.636l.037-.075.03-.076c.094-.24.2-.515.27-.799.012-.055.027-.134.042-.2.045-.204.092-.444.092-.74a3.834 3.834 0 0 0-.125-.913c-.018-.071-.03-.148-.05-.215l-.083-.252-.142-.22a2.836 2.836 0 0 0-.452-.542 2.43 2.43 0 0 0-.543-.382l-.43-.221h-.482c-.376 0-.73.092-1.039.264l-1.08-1.291-.666 1.365-.74-.762-.016-.014-.353.54-1.436-1.178-.51 1.05-.152-.078-.111.116-.924-1.707-1.254 1.287-.459-1.037c.02-.143.045-.286.045-.436l.018-4.33c0-.803-.343-1.635-1.045-2.186.422.216.932.352 1.55.352h2.504C40.07 25 41 23.558 41 22.219V15h-3V5h-6zm1.906 1.521H36V14h-3.55c-.674 0-1.009-.223-1.009-.744V8.79h-.002c0-.521.337-.781 1.01-.781h1.457V6.52zM12.01 8h3.476v7.256c0 .52-.336.744-1.01.744H11v-1.488h2.506V14H12.01c-.674 0-1.01-.223-1.01-.744V8.78c0-.52.337-.781 1.01-.781zm4.101 0H19.59c.673 0 1.01.26 1.01.781v1.6c0 .298-.188.52-.524.633.336.112.524.297.524.632v3.35l1.513.004v1.865l1.44-.006c.673 0 1.008.26 1.008.782V23l-1.963.006v-4.578h-.487v4.578L20.076 23v-6.516h-.486c-.224 0-.45-.036-.637-.185-.224-.15-.373-.336-.373-.559v-3.98h-.45v2.232h-2.019V8zm6.182.01h2.482c.677 0 1.018.26 1.018.781V14h-3.498c-.677 0-1.018-.223-1.018-.744v-2.233h-.002c0-.484.341-.744 1.018-.744h1.467v-.744h-.451v.371h-2.032V8.791c0-.521.339-.781 1.016-.781zm4.137 0h1.98v.408c.336-.26.821-.408 1.494-.408.224 0 .45.073.674.222.224.15.336.334.336.557V14h-2.02V9.535h-.484V14h-1.98V8.01zM13.02 9.525v2.987h.486V9.525h-.486zm5.113 0v.745h.447v-.745h-.447zm15.289.01v2.977h.486V9.535h-.486zm-10.115 2.233v.744h.45v-.744h-.45zm2.81 5.23h2.447c.621 0 .952.257.952.766v2.98h-2.412v.766h.474v-.365h1.938v1.091c0 .51-.33.764-.952.764h-2.447c-.658 0-.986-.255-.986-.764v-4.472c0-.51.33-.766.986-.766zM14.984 17h1.973v.4h2.41v1.49h-2.41v2.62h.475v-2.256h1.935v2.982c0 .51-.328.764-.949.764h-2.447c-.658 0-.987-.255-.987-.764v-3.345h-.474V17.4h.474V17zM31 17h2.668v1.527h-1.719v.364h1.719v1.492h-1.719V23h-1.935v-5.236c0-.473.329-.727.986-.764zm3.615 0h1.975v.4H39v1.49h-2.41v2.62h.474v-2.256H39v2.982c0 .51-.291.764-.95.764h-2.448c-.658 0-.987-.255-.987-.764v-3.345h-.474V17.4h.474V17zm-7.511 1.527v.727h.474v-.727h-.474zM14.939 26h2.348c.64 0 .961.255.961.764V32h-3.309c-.64 0-.96-.255-.96-.764V28.98c0-.473.32-.726.96-.726h1.424v-.764H15.9v.365H13.98v-1.091c0-.51.32-.764.96-.764zm3.795 0h1.885v4.346l-.014.008c-.173.069-.345.136-.51.232-.096.057-.186.132-.279.197-.142.101-.284.2-.416.322-.09.085-.172.186-.26.28-.09.099-.19.186-.275.295a.766.766 0 0 1-.13-.444V26zm2.352 0h1.883v4.215a3.523 3.523 0 0 0-.948-.145 3.67 3.67 0 0 0-.343.016h-.002c-.202.014-.395.064-.59.113V26zm2.945 0h1.885v.363h2.348v1.492h-2.348v1.846l-1.795.342-.09.021v-2.209h-.498v-1.492h.498V26zm5.625 0h2.383c.641 0 .961.255.961.764v4.472a.709.709 0 0 1-.174.487l-.299-.307-.498.584h-.851l-1.016-1.137-.596-.668h-.836v-3.431c0-.51.321-.764.926-.764zm.961 1.49v3.02h.461v-3.02h-.46zm-4.238.766h1.885v1.94h-1.67l-.07-.608-.145.025v-1.357zM15.9 29.744v.766h.461v-.766h-.46zm8.625 2.254v.04a1.824 1.824 0 0 0-.38.39 1.2 1.2 0 0 0-.19.625v4.918c0 .234.038.468.076.625.038.195.114.31.19.31.152-.039.304-.076.418-.232.038.078.077.115.115.154-.19.237-.343.434-.457.55-.304.39-.495.702-.61.936-.19-.234-.341-.429-.417-.664-.038-.117-.115-.35-.229-.78a11.31 11.31 0 0 0-.646.741c-.19.234-.382.508-.573.743-.19-.117-.494-.352-.95-.704-.343-.273-.532-.388-.608-.388-.114 0-.19.039-.229.117-.076.078-.113.194-.113.35 0 .078.036.156.074.234.038.078.04.156.04.234 0 .078-.002.196-.04.235-.038.078-.074.117-.15.117-.076.039-.154 0-.192-.117-.076-.078-.076-.196-.076-.352 0-.156.115-.548.381-1.133.076-.195.305-.702.686-1.482-.342-.468-.534-.703-.534-.781-.304-.43-.418-1.014-.418-1.756 0-.664.19-1.29.647-1.875.418-.625.95-.938 1.521-.977a1.63 1.63 0 0 1 1.067.274c.114.039.341.195.646.468.114-.312.304-.547.57-.703a1.52 1.52 0 0 1 .381-.117zm4.07.2h.077l1.254 1.404c.418.508.838.977 1.256 1.484 0-.04-.001-.117.037-.195s.038-.118.076-.157c.038-.078.113-.117.19-.195 0 .04.038.078.076.117a1.81 1.81 0 0 0-.114.35c-.038.156-.039.312-.039.508v3.982c-.114.04-.227.117-.379.195a1.323 1.323 0 0 0-.341.235c-.076.039-.152.115-.266.232-.114.078-.192.196-.268.274a6.14 6.14 0 0 0-.722-.703c-.114-.078-.227-.157-.38-.196a1.385 1.385 0 0 0-.417-.193v-.078l-.04-.04c.077-.077.116-.156.116-.195.076-.234.113-.468.113-.742V35.201c.038 0 .115-.039.229-.078a.284.284 0 0 0 .19-.076l.228-.117c.076-.078.112-.157.15-.235l-1.025-1.172v-1.326zm-6.962.78c-.38.04-.724.274-1.104.665-.342.468-.533.975-.533 1.482 0 .429.038.82.152 1.172.114.312.343.623.61.857.229-.392.42-.82.61-1.25.19-.39.38-.82.609-1.21-.076-.079-.116-.157-.192-.196-.038-.078-.112-.076-.226-.076-.266 0-.496.234-.686.664v-.156c0-.273.077-.548.229-.782.19-.234.38-.39.609-.39h.342c.114.039.188.078.302.078.076-.117.153-.274.229-.43-.076-.117-.228-.232-.418-.31a1.19 1.19 0 0 0-.533-.117zm-11.297.465a.822.822 0 0 1 .19.118c-.115.429-.267.899-.419 1.328-.152.468-.303.897-.455 1.365a.333.333 0 0 1 .19-.04c.038-.038.113-.038.19-.077.57-.117 1.027-.039 1.445.234.494.351.761.975.761 1.873 0 .547-.114 1.056-.304 1.64-.19.469-.456.976-.8 1.483-.303.43-.646.86-1.064 1.367-.114-.039-.229-.078-.38-.156-.153-.078-.228-.117-.266-.117a2.736 2.736 0 0 0-.533-.156c-.304.35-.57.664-.836.937-.342.351-.647.586-.875.664-.342.156-.647.117-.875-.117-.19-.234-.305-.468-.305-.82 0-.39.114-.82.342-1.21.228-.428.496-.702.762-.78.228-.078.418-.157.533-.157.114-.039.228-.039.418-.039.076-.273.113-.507.19-.742-.419.117-.725.195-.915.234-.152 0-.341-.039-.494-.078a.985.985 0 0 1-.418-.468 2.658 2.658 0 0 1-.152-.86c0-.312.075-.623.19-.935.113-.351.304-.626.495-.82 0-.39.076-.783.19-1.134.114-.273.267-.662.533-1.17.228-.467.494-.899.722-1.289.57.195 1.14.43 1.711.625l.229-.703zm12.44.198c-.229.507-.496 1.014-.762 1.56-.228.506-.494 1.055-.723 1.563.571-.04 1.142-.078 1.713-.078v-2.694l-.229-.351zm4.372.505c.228.273.456.548.647.86.152-.195.267-.352.38-.508a.539.539 0 0 0 .114.156c-.19.312-.305.508-.305.547-.076.117-.076.235-.076.39v3.319c0 .117.001.235.04.313 0 .078.037.117.113.117l.152-.078.113-.117c.038.078.115.117.153.195-.303.31-.57.623-.874.935a1.204 1.204 0 0 1-.418-.625c-.038-.117-.076-.193-.076-.31v-.664c0-.508-.037-.978-.037-1.485V35.67c-.114-.195-.266-.39-.418-.586-.19.234-.38.429-.57.664v1.639c0 .547.037 1.093.037 1.64.076.117.152.235.266.352-.266.312-.495.584-.723.857a7.259 7.259 0 0 1-.646-.857c.076-.117.151-.274.265-.39v-1.641c0-.507-.039-1.054-.039-1.6 0-.195.001-.313-.037-.43 0-.117-.076-.156-.152-.156-.038 0-.077.04-.153.078l-.037.04c-.038-.04-.075-.118-.113-.157.266-.351.533-.663.799-.975.152.156.265.312.379.547.038.156.115.35.115.545 0 .078.037.157.037.274.152-.156.266-.312.418-.508a1.49 1.49 0 0 0 .19-.235c.265-.39.418-.586.456-.625zm5.48.239c.077.078.152.156.19.234.038.04.076.118.114.274.076.078.114.193.152.35.038.155.037.273.037.39l.914-1.17c.19.429.419.819.61 1.248-.192.232-.422.465-.612.66a6.344 6.344 0 0 1-.494-.857c-.152.117-.266.232-.418.35v3.359c.152.156.266.35.418.547.114-.117.228-.196.342-.313.038.078.114.156.152.234l-.531.547c-.152.195-.306.351-.42.547-.076-.117-.152-.234-.266-.351-.114-.156-.226-.272-.302-.39-.114-.116-.19-.195-.229-.273-.076-.039-.151-.117-.265-.195a.92.92 0 0 0 .226-.351c.038-.117.04-.312.04-.586v-2.926a.509.509 0 0 0-.04-.234c0-.04-.037-.079-.113-.079-.038 0-.075.04-.113.079 0 .039-.039.039-.077.117a.858.858 0 0 0-.115-.196c.266-.35.535-.703.8-1.015zm-14.57.152c.229.234.456.508.647.781.152-.195.267-.35.38-.547.039.04.076.118.114.157-.19.35-.304.508-.304.547-.076.117-.077.271-.077.427V39.223c0 .156.04.232.04.31.037.078.075.117.113.117 0 0 .076-.039.152-.117l.113-.115.153.154c-.266.352-.57.743-.836 1.094-.19-.117-.341-.312-.455-.547-.038-.117-.039-.234-.077-.351v-.625c0-.508-.039-1.015-.039-1.522v-1.56c-.152-.156-.266-.351-.418-.547-.19.273-.379.507-.57.78v1.679c0 .547.037 1.093.037 1.68.076.077.154.195.268.312-.228.35-.497.662-.725.974-.228-.234-.417-.507-.646-.742.076-.156.19-.31.265-.467v-1.68c0-.546-.037-1.132-.037-1.679 0-.195 0-.31-.039-.428 0-.117-.074-.156-.15-.156-.038 0-.077.04-.153.078 0 .04-.039.04-.039.078-.038-.039-.075-.117-.113-.156.266-.35.532-.743.799-1.094.152.117.305.313.38.508.077.156.114.351.114.547 0 .078.037.156.037.273.152-.156.266-.35.418-.546.038-.04.116-.157.192-.274.266-.429.418-.625.457-.664zm18.145.158c.38.703.76 1.366 1.14 2.069l-.761.779a8.087 8.087 0 0 0-.76.86v1.404c.228.195.418.39.647.586l.57-.467c.038.078.076.154.152.271-.19.117-.264.196-.302.235a1.683 1.683 0 0 0-.268.234c-.228.234-.416.43-.607.664-.076-.078-.153-.195-.305-.351-.114-.117-.229-.235-.305-.274a1.087 1.087 0 0 0-.379-.232.822.822 0 0 0-.19-.118.306.306 0 0 1-.038-.156c.076-.117.151-.234.19-.351.037-.117.038-.312.038-.586V35.67l.38-.195a1.07 1.07 0 0 1 .19-.157c.115-.117.19-.156.227-.195 0 0 .115-.155.381-.428zM8.32 34.85c-.19.039-.342.156-.494.312-.19.234-.265.507-.265.82 0 .234.038.43.152.586.152.195.38.274.683.196.266-.078.419-.118.534-.157.114-.078.265-.156.455-.273.114-.312.19-.585.304-.898a1.897 1.897 0 0 0-.722-.467c-.265-.118-.457-.158-.647-.12zm21.569.078c-.114.118-.191.234-.305.351 0 .585.037 1.17.037 1.756v1.719c.152.117.342.234.533.351l.457.35v-3.67c-.228-.312-.494-.584-.722-.857zm-15.864.08c.38.195.761.35 1.141.547.076-.117.19-.235.266-.352.038 0 .077.04.115.04-.114.35-.23.546-.268.663-.038.195-.076.39-.076.586v3.24a.74.74 0 0 0 .076.274c.038.078.077.115.153.076a.081.081 0 0 0 .076-.076c.038 0 .039-.04.039-.078a.294.294 0 0 0 .15.154c-.265.388-.492.779-.758 1.17a1.018 1.018 0 0 1-.228-.195c-.038-.078-.114-.196-.152-.313-.114-.195-.153-.466-.153-.818v-.04l-1.14 1.757-.037.039a3.004 3.004 0 0 1-.497-.782c-.076-.273-.152-.584-.152-.896 0-.39.077-.821.229-1.25.114-.39.341-.858.646-1.326-.152-.547-.304-1.133-.457-1.719 0-.039.038-.078.076-.117.038 0 .115-.04.153-.04.076 0 .151-.038.265-.077.076-.04.19-.079.229-.118a.302.302 0 0 0 .152-.156c.076-.039.114-.115.152-.193zm29.674.039a.648.648 0 0 1 .229.232c.035.116.072.312.072.508 0 .156-.038.313-.076.469a4.79 4.79 0 0 1-.19.545c-.304.625-.609 1.21-.875 1.797.266.35.57.701.836 1.091V42.578a.69.69 0 0 0-.265.078c-.114 0-.189.04-.303.117-.114.078-.19.157-.305.274-.114.117-.19.193-.228.271a3.371 3.371 0 0 0-.418-.547c-.114-.156-.265-.232-.38-.31-.113-.04-.19-.04-.228-.078-.19-.04-.304-.04-.418 0-.114.039-.228.154-.304.271-.076-.078-.115-.193-.153-.271.19-.351.382-.704.573-1.094.19-.35.379-.743.57-1.094-.304-.39-.572-.74-.838-1.13v-2.303a.41.41 0 0 0 .268-.117c.152-.117.226-.196.302-.274.038-.039.153-.156.229-.312.076-.117.152-.233.228-.39.228.274.456.506.647.702.19.195.381.313.496.352a.43.43 0 0 0 .379-.078c.114-.117.19-.233.19-.428 0 0-.075-.157-.151-.43a1.168 1.168 0 0 1-.076-.351c0-.117-.001-.196.037-.274.038-.078.076-.115.152-.115zm-4.644.076c.38.312.76.626 1.14.977.076-.117.192-.196.268-.313l.113.117c-.114.312-.227.546-.265.664-.038.195-.077.39-.077.586V40.785c0 .117.039.235.077.352a.42.42 0 0 0 .113.195c.038 0 .075 0 .113-.039 0 0 .04-.04.04-.078l.112.234c-.228.31-.492.624-.72.936a.816.816 0 0 1-.229-.39c-.076-.118-.113-.274-.19-.391a4.023 4.023 0 0 1-.114-.975v-.078c-.38.468-.761.897-1.141 1.326l-.076-.04a3.406 3.406 0 0 1-.457-1.015 3.128 3.128 0 0 1-.153-1.013c0-.39.077-.782.229-1.172.114-.39.341-.78.646-1.131l-.455-1.992c.038-.04.038-.079.076-.118.076.04.115.04.153.04h.265c.114 0 .191 0 .229-.04.076-.039.113-.078.19-.117a.539.539 0 0 0 .113-.156zm-3.233.469v2.342c.266-.273.532-.548.8-.86a51.083 51.083 0 0 1-.8-1.482zm2.473.195c.113.546.19 1.093.305 1.639.266.312.532.586.836.898v-1.56a25.37 25.37 0 0 0-1.141-.977zm-25.03.078c.077.508.19.976.303 1.444.266.195.534.351.838.507 0-.468-.039-.938-.039-1.445-.38-.156-.72-.31-1.101-.506zm28.493 1.016v1.834c.152.195.341.429.494.625.304-.586.609-1.17.875-1.795h-.305c-.116-.001-.23-.002-.267-.041-.114 0-.265-.078-.38-.195-.113-.117-.265-.233-.417-.428zm-31.322.455a1.633 1.633 0 0 0-.329.05c-.152 0-.266.04-.418.079-.152.039-.303.117-.455.195-.114.273-.19.547-.265.82.152-.078.304-.117.418-.156.114-.039.227-.078.379-.117.076 0 .115-.039.115-.039.266-.039.532-.039.76.039.304.117.494.39.494.82 0 .312-.076.665-.266.977a6.613 6.613 0 0 1-.799.975c.228.078.494.156.723.234.19-.234.417-.626.57-1.094.19-.507.268-.897.268-1.248 0-.547-.152-.977-.418-1.25-.2-.205-.465-.3-.777-.285zm-3.409.012c-.038.117-.113.232-.113.31-.076.117-.076.274-.076.43 0 .35.076.625.228.781.19.195.533.234.989.078.114-.039.19-.078.304-.117a3.34 3.34 0 0 0 .303-.193c.114-.273.192-.587.268-.86-.114.078-.23.118-.381.196-.152.078-.266.117-.342.156a.652.652 0 0 1-.646-.117c-.152-.117-.306-.351-.534-.664zm15.977.156c-.686.039-1.408.078-2.131.117-.114.234-.19.43-.305.664a26.79 26.79 0 0 1 1.79 1.016c.227-.273.456-.508.685-.742 0-.351-.04-.704-.04-1.055zm-9.473.04a3.422 3.422 0 0 0-.152.663c-.038.273-.037.508-.037.742 0 .351.037.626.113.86.076.234.19.429.342.664.19-.312.418-.587.61-.899v-1.482c-.305-.195-.572-.351-.876-.547zm25.03.116c-.037.196-.115.391-.153.664a4.86 4.86 0 0 0-.039.742c0 .351.04.665.115.938.038.273.152.584.342.857l.61-.625v-1.638c-.304-.312-.571-.626-.875-.938zM10.09 39.393a.83.83 0 0 0-.248.062c-.342.078-.57.156-.723.195-.114.078-.341.157-.57.313-.114.234-.19.507-.229.781.456.04.95.117 1.407.156.114-.078.228-.234.38-.507.153-.273.229-.468.229-.586 0-.195-.037-.35-.113-.389-.02-.02-.067-.03-.133-.025zm32.35.101c-.343.664-.684 1.29-.989 1.914h.305c.114.04.228.04.342.078.304.117.57.352.875.782v-2.032c-.19-.234-.344-.468-.534-.742zM7.712 42.11c-.343.001-.572.08-.762.12-.114.078-.267.154-.38.31-.115.117-.151.274-.151.469 0 .234.074.39.226.547.152.117.306.156.497.078a2.62 2.62 0 0 0 .912-.703c.076-.078.267-.312.533-.664-.266-.117-.57-.157-.875-.157z"
        })
    }));
var $566b6e2d6ce5c43b$export$2e2bcd8739ae039 = $566b6e2d6ce5c43b$var$SvgSanAndreas;





const $6bbbdeadab023461$var$SvgSdkLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "sdkLogo_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.762H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "sdkLogo_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#sdkLogo_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#sdkLogo_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -36.738 88.73)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAEsCAAAAAB1LsazAAAAAmJLR0QA/4ePzL8AACAASURBVHic7Z1/tB1Vled3IAaMQm6MIEHaVJA0ikIu2hpWO/oKG1kmvex+iKx2gCWFSpiW9PLawKB21Mq4RqGNcvFHN1G6uYFxgAnaD4dJXHGEE8TGsMbp+8IS2mWT1Ft0mE4Y4b4XgobVPXv+qPuj6tQ+p86pH/fWfW9//nmvqs7Z58etb53f5wAwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMwDMMUy6JRRyDKmrMG/z+/d3TxYJj5RiWEvu6Nb1v1hjNOl2+/+OTsvgP7d40iRgwzvxi10Ne9b+1b36R38uwv9v2Y1c4weRil0Ne97wPvNHX7+E9Y7Awzflyx4yDacWTH5StGHWuGYcy5YscRS5V32XH5qKPOMIwRa7baluWxcv2ONaNOAMMwaWz4UQ6Vh+zlYp1hKs2mPIX5gIPXcWudYapKQTJHRDyylaXOMFWkQJkjIs5dN+oEMQwjc0WxMkdEPMhtdYapFBfsLVzmiIh71406YQzD9FhxRykyR0S8g5vqDFMNSqi1Dzi4ftTJYxim1OI8hAt1hhk5F5RZnIcc5JY6w4yWTRkntduxedTJZJgFzd8MQ+aIuJur7wwzMr46JJ1z9b1c3FFHwIB6rRy7Tkl25xXlt8/7zPHsmfJARNGcrPYbLxBF0ys+jv4YpH3kDFHoiDwltjS6OTzljToiGkRJcfTHIO0GlLuV1Ff/vFTzEt/70JACcpxBRbHdATGkYEcH9v6ZaTU7o4yIBjHR/We2WWgc/S+UY3fIlLxn3OYPwKMIwX440wF4NxhvEZeN8pVeq7t1Z618d7bdboug7LBHCA7+nWlMjS4eOvpCB5j1CoxjX+gAs41WcXbnN2su31rOrPeQ+0uNfL3Z1oQdtOZvQy6W0KlqJlOUFEd/DNJeUTbcUVrb/anShtnqrU568K3JsoIfLfFUtiv5tot4HJ2i7Ppxu/Wi7C4M1t1R0kSacs53qXmBYfiBX0kV5ERKZKeKaRRSHJ2C7PqSXVa6Jdc9lVXMWkqovdd8g8J88CbMQ6nLaaximS5KiqMkdAwqmPaKs76U5nrRSreTOSJixy84CiMnkcQKdsjJQi8qjrLQURRjd0FxeRmN9TsKjeKkaaU9SuAWGoeRk0xh9TojEkIvKI4JoaNXiN2FxYqvZJBRGgXOnHGSr48ZzeLiUAGS6QtGHaUEyV8qKMRuUuiV7KKoPOtKaKoXthfFpG2tfUBx3b4VgEhf5Yp04pPsFWE3KXRsFGF3wbFiR2YxqThS0AqXVp5IdNxiIlEFiORVrpVOCL1dhF1C6EERdhcg1+XRE0khw+k13fQYE7wCIlENqNRVrf5KNbKcAuwSQscxHGI7btQRAIBvXXCkYItv2pbfRr2dmOpqyZ1e/lhUl3F42ctqX7gl2S2RKggd9r6vaKVfuimvhbpYlTsW81rp7qgjYIA7ZnZLpBJCh71vf6pgi7dMpLvRURfLCojFfFb6OJToTkl2q9ZsMaAaQodfXV1wmb70zlzei9E5wJ3jIIdsjMPLnrfxpSJnKTIKKiL04mvvq2/P4blWkM4BxDjogZn/LB5GICvWnenAuwEA4IkOPPT8zwg3e99H3c3BtfeKrF6L0zksm3KLMsUw2Sld6BdcNHHO6YPLdwJcD/D4Ew//8NeSw72bvllsyH97ZlafTZMq3x4AkzrchO9njQbDjAlX3K+ezL538xrJddEzZ76cMdZeit2g5bl9x25jKmX6nJMxGhWCSpYYdaQkyMnKBdilxtGLsDt/WJO65nxvfBBsRcFLXI6eminejla4nWayf83TzogXmWJRKcYhWSz00bDBaA3qka3ROWzrTLxYsDNTzHWqVS02d3WeKjct3BoqVWLUkZJgoY+CK/5R8+LHiEm92LVss89mGdxqaCw21X3omvUvQYZYVAsqVWLUkZJgoQ8fs9K8x5GtfY/FVd6P/QtippexphasfpmKo54a79lHo1pQiRKjjpQEC33YrLhfp0CKgxt6ftfbeiU5Ntf7z7WOvXrFWtreRLUplc/AOhYVg0qUGHWkJFjoQ2azugvuwPT09PT09OHkk/4Z5z9TejZloHLM8DY6SrsGe5ApG+rj3kqn0iRGHSkJFvpQWfEj+lU/cO+15w1cnXfNtn3x571DEvMW6Yeka9cy/soC3WSvQeXCVmEZi6oxDmlioQ+TdWQj+8CXz0k6PfXaXbGyv7sB1JMqpRnw4lzilrCLv7JAN9tTtK5q4Dt20agaVJLEqCMlwULXUuzMuE3fIG7u2voQ5fbwtm2nXumf1L/+5vkfBwB48M1ZA39h+auSNydcYWPDV9yf9YyO3Wr7t9IPJm33kOud7dYpZJcUGccBAIAgKNhurTvMIYoyVEb63fCPKNxwWojF57cFhQp98xeT93bd8GT0su7W1/x+9/+Xntv1TKSo/9iyywC6U+Ltef41y8n7nrAwUlM1pn3D9605SU+K9YyF7tTr0uluezpt0S7seL+660bMzwRCiELsOq5bj0R7TyAynUZXq7uOU48tNZjuiHY7i62kcdetR36fPe32VLnHJjqu4zrRfQ1m20G7LUoNU0GRhyzef2ni1r5PisiV601qV4vsvvWfNt6YJeSXj52kfLY6MLfTUBTIe1xTC+7DeWIx6U4qtruYbk0ZWPCTt1pRb06DsD87NZW2ARxVVY3mSc3ziOUBZnGOUPdc1SqDGZEWSUF9YiOvd21y8o+TDqZbrRStRw5ZJO2qqE26qrf9AWGZMdUiOap2NDbb3Mu7B5uKY8mmeQTfIgmqGDrmJhQ97166z7TT3dpeaj+BPvmuevyvoTdN+RH9p4464i0nPd09K82UHfQ7LVfnX99G1xzDkRLHbG30yZSNRcf4uPWticTsj/SzQz3rDulp6GVuNYhdV5hoWWTDJG0iddPUSYP8ST3tifDj9545SpkjIna0WxhTPkTvof4kG19tNYp2DvEgTFdtQSt0fRxbumzNInSTo/oCzyxnqsamREp2Hh95TGZXAaTJHG0GsZsKC45NRtC/cUr90Ow9Tz3tifDR89BI26Jed04o5V6Ej+pp9TST80fNSwGhtKYRemocdZ85e6GbnsgZjOP0iuR6lM9EntbKKs7TZW6zA7nifWhZ5YTia+FovOgL2zha3RDufQAw/AHUbzvlWgBA+pJeNDh/tKb6wJL4CitqoetWL/RQH3xuK/TUr0oE4aRkTeVYkZgOd1PkaT3L+WUGzJo5M93NSTWI7lplhUsb0Xy9PbvzYHy1JcJ1E8D4B1BWYSnHAsD0iAt9BtooA1E5pUEpdLM4Kj+glkK3q7p2xq1QT6xiiek8+8FGOl40degZJkJROgWWeUGn1lc5r1mfB6MufQjHAix+ANW0IMqtAOOjbLRluuVnTmlOJXTT7FVF0krompVNCsbrkL7NcvSHoHOTWnuIad1dUYG2/SnoWrIqElnOg1FO0yPcCqsfQGGZcirUfRoJNGeKG9T9E5CaVAjd/DOqULqN0LO86i1l1lSPNXLFvXydG9baQwzr7or6re2idrryJmjH2XLHouQVdp8SemIQnSALjSq/tVl0jthxkpZoods0/2mlWwjdvnKCOFZKlyvu0Z1damW0z3/7WyvnZg0hRRM9sM0NeoCN7nbP+hU0L3mFqqKioGVoF4VV3F06rxQdGqkQ3yNS6IrBTgVkxcNc6Nk+WmOk9A1SxPdHH/by/2jGXKCwKs7RNCcVL4WZ5wiK0XjKqX57Oh2CDJpw2LZ9/ai+dzIGVm2OgIyvZpePFJLtKVLolvapXDUWetaP1nDa6UXMdf9O/PKlaAHa6E1MXFpAQCHH4GRLH66RK0UV3XpVRXuPqcvaVOb94yeahod0r7V9i3xhlmK700pWeS3ibvb0f3JKmDiztD/RyK65evaDpD8pKncINYU8VSY67zV7kaXEtjhHNGxmK6q4bjm5pgnRDKo9ksdeH0Ln5VhV1aGMELKxQqZqEI1/wxI91yHbVJ9D9ZCWoO+LPuu/ysSuMtl4IYsno9JP8aaUk2kAZhM51HSIBmUug32SuVWEVeJjm6v7xpWMFTMnSyQiaSj0XB/tISzuz19133B6/HpL5H+3v17Itrat4OV/y3SWmVGJTtdFZ7KEZ4Tjax5Od9odgHqtrqx8LvMNK+8x9nTaAI7jKBbJAQCAn7agKxNeIrqeOhJ7uutypRW7UXzXNgZhnro13Tk8lvsX9KFWxvXZAwIAXE1rZ4Js2VQLae+oH0afWc8FScF87DxOYJIQ2qsoI88AQFMEBU134KreUNYJk5+vlFyInD1R8zRFkG9nFzGY8n3f96d0RXSQiK3CdfyIjJpy0aNjmJ0hrclBETGpWSeYiKZRia7uVWw3IqlxlSv0qPpZtVgjxTi6Yk2902I2MlXbEdFoJF3RWV5aj6iqNzy5qslVvOoiYVOXBR3ZrnqGfeKt09mNCdNpqiXkSEYVGZ5coafYMl+qIWiFLhvVrFqVs8lI6Krh+uRyO9VYuy87rBrSpLifRp8NGqHP6H4FQ469lN2vQd1dMTril5RvqvKMPCNCMYHald1pcoCax+6q3nbf3K6sIfWm155klBQHOWmF7ugScUcaoVPz2JWTVSWzRkJXlGjkojhFBlW+SJe64i6LPhvkZQFCt+9tD0TTb7iu6xo10YcsdEWB7tm4bsnO1HlBt+dVb3tgbJcQpqq9JteNqC+dYhoqPXgTd6MWumJtgCqeUhRMhE6bUs2ep11n6XEZIlLN/XD0WW1w//8ofwVT7MbphD9pO3PVftVZLugC3VM5p5XuSK6U+aGyqxoUklKttEvO0FMoSMRdkaWgKrfJAYr4L6wUuqBNKuPZirsyEDpdoKuX8pABByrX1UCquW+LPotI51nVr2CKRTfcVMNW4wCgLGLdQrIpAT2ErOkQICu6vuRIlSUtpVnFPFbJg8quYvyX/npIXflUDghlPKloxr8KKqFrFtQYxdNA6HTLylOGSwdc7RWr0jT3aFdcNP3/ovgVDDFungfNzNll2g4uBrKhpnkn6X7dQHKkyhWNXXowX3rZVdnt0jYVlaO4Iyq/1T8eVQj6MRcqoWu++oqmdTwWBkIna2e6yW5kP2RL4yE/x+X0/87Y1XOx2TJOUcHMLXmlibOZ2853GmMxmRBq5LCrbvN4smNnlVndRWe3OU3dXWb0vdwu6PuCtCnNZqA+PuofLzCJD8V2zYTeYAt527asoHfu1bW529sLCNaOnELfEL+Mn9TgDP791zyBzBnNttl+idOwnpc+KsgfdVrovEzNEjc9k8D2aO3SL6RrYHdW+S7TTZC4tIlvlGaRgDCID4mve9ik8tRwacQA8sfcHmgDJu6ZfVyzklPob4tfKjY1B6APVzDjiIHOZ7Ys98ajLA8hf1P9kH2HSp9rEpjeriDn/pkYVp9+IAx8u4sSmARqiV5vnRZ1d5VjF4ZL3fS1XtpUnYe0UxQ5hS59ln+icndi9iB+qz6boceeqx2/jFmb5eFSN1O+VNTjtQajrzMpdsnvgIlh9QckoOvuIyBlvhP92LUKok7V3KcDvafMX+2s5BT678SuXoqdvmQ2wzyFl9O/EXsudFsFhDRMyBnsD6R8q0i9uumBpdV06OfpP960pqFEPirifbBkJqUxR3+R7CLqUjfTMl0Q90w+rpnJKfR4X9w/xR9GM/mFbPaPLElzsf38jMsQRolL3RRpvqiX0uCdTLNLv+xuLrsBdXMEc79Sm3OkgwKELlI8kc/L/BLm7XWP8az6UbbeuNm0avueC72iOuBEQXZMIH/R1IQExD03PbDUl11QN51Uu6Q3g2cZcNyMHVUikwM7wZGuUwOmekZcq3DtyLdMVep01yzpPCWL+bT5v3t8kcWsFfUygnCom66b4ovKDdJSjPTmsvhkJsPDGOJwnHpNv65Uj0hzQCZiWc2mx4dqos/4Fgb6lFmiF3s+epx2dP3ty6mVcJljKWvOZvyWrckMlFLfJBcmU6d2pqJbVx6SrseAupn+0pHeiqJey6fwkNlUwXZmqBy0+bqTGbUq049ZZtsmn9D126/EcvmF11naPvoq7ePZZnO8OtpLIrWHIkg1QZdqab60NYX0QFXUa26trt0XwwKDSkeQN6gC1Wm3DZ8d+YT+B/HLJ+KXIvpZs9V5yiyZBxqBpcE0FC+FW3AwZdlUYvCyz1KqTqu+ah8H6YEmwqsXqPAuBkVBm1JX7hK9ehRadZfel/gr9oLVpBn9LJkZT9gYM0LxUlR9mXDqOzmMlz0vtUnXLVbiIQYfOTJ7bH70Il+QEgeQChX6G+KXneloG8tG5y8v0Xa331bK9BiytQZ5m4llU/UPkQGTnm7DNaYQyuyMAxFTiXmRrq+2T2tH1Fa8Bx75tWlAMRSttbpt77Ljkbf9iAtLi7kIhhlYBjy/jLLcmIXS0VOq0Kdi4zbGOtdX27f46mc3/vH5SwEA9u28+0m1KwVkBTaL0Mke1+iAi2NpMRfBMAOzxm2NVObDGSQ0psTqWaETZs6VrqX1EmYfz6Ogq7bPnO8rn112+C/fFR4Ic96nf7HzVKPQIgT07YI6WxTWczMmfUEKmg+PWOfVosQfs1ChJxQan5RVO2JgY1Y7qnabrnx9/Yv79u17rnux/sClBqFFKarb3dpDLsa5jV5rU1N1mDIotUSXFwed9HKahZd/oxu/nb2koasVNM9cu3btqYs37gIAgKX336RxSyDo22sdOzMK6SmsL2Rqouo9nfOIfEL/39L1edJ1IG0lsCRF6bParWT2OCZLzv/tOxve8vcAAHDzxwycR1BMAbGdZk3XvxZKp4851dD5ONeIbMgndHlN2vtlB750rVX6Uf10rC2uqViefNftAADw9TcZeggR9G3PyohqflO0YaAIKBNBmgO3wMAKpVUFnY95H4c5+YS+SLp2ZQdC3h1oyZzK1svHtK3z2Qt901gBwJ/eBwCw9F4LL0XV3V36dlm9u0FJdkunYTF4Pr2H2mRt/lHiEEC+4bVfSde/l3Dhy7tLnXxsEbW85UXUr0jdM2lSnLvQPZwPPvzO1QCw9tLvGfjqoWoYNHT7/CWga/ozqdGftgqlT5DJVxyy+lpyW6PmGziabXfaQdDuALhXZQoki6ci2N7K5G1shH7KhFyCi+3yL3QCHDlBlvoLr3y1PiDd4HlIbXLSXQYAs1N+AABw4/0AAJ+yETo8QBcyntVEPFrosZ+QNNcRFoFYYDCVlaxDlzzA3NQ202aCdkfkb+IY1MuzbQ0QIaBulvVjZifnhJkXJYFuTGzk2ZhM/KInARx6Vd/jy50TlqXMpZmZTMv5WqPRDWbZVVdd3QKA7z1xLgC865wnz3kzAJjpfYoW+rKGb+QdAAAUc7ZF9IJMTVlLl9JLtVGUezVVF+eMaLeDoKhQMjqx+bAH1M151/KXzm+IH8kUotjNH/E3zz77rNFBS9T5gHGk8zYdAICbEBFxf3hnp1FqanLIXWwOwFOc8+PEHJHJdkh7VlBmRaov8heKfYzs7VI+/Mhz+twIbLkWcfRjLsgDHFLTTp9N4UQcpB3gQJ4CEaQHPGRyjqM/I12fkiyXBL1LPsCJK1euTF31DDB7ie78AQAAaP5d3E4DAOC/AwDA6vBOsvOAovMAfX9Zyl6iERy6LTkTxC7JIt0xDsSK9MLFpW6W3EQnC/TZC4teleimOaBzJ7AIgnS7qnKjdjmFHsg3iEkqfq4e0wfSB89b8vyqOgDAky9F7mh2s4tZUty/yjXzr9xeWEoDKXTjMOxYlqr0bJue5aJGNVRmncIDzZZ2u82qyWMnXCsTQyCn0B+Sb0wQU8w9RUFpwOwl6b3tDUWHbHRP2r1mwU2pdr1TnLybwFWMGbXil6TQM+5/mIqbyUFQcCzikPrS/dQZS8jUPCUd2PVDDvOrnZ2cQk8IaOn1hCsv637+2w3mwjm3Jm6FWX985M7/MgxQVUdfZjInD6DWou/L24sLylFZ23p7Kc+TvaUAZZfoLnFPe3JUxt6tiZQ8rVERKULoZX21M5Oz1/3Xz54u3bmaqLx36q0sw6Bm+8j4yVuht7dE7vzUMMiWr+g1mGh5Jt4Va7Fa0nVAbnIxKTuTqFFvu0iLE6x1Au1zurms95MXSn/ab6mbMSBP371Cf+TshC6om6vSVjc7jqmpavCjRIcjvZSEPN5bC3l8aBKipzwAAICJyJ2jxulRHJ6MRqfaKnrcMbmdLeky7f0iPcVc0KHr33X67OC46igXQmuV8uEPHlNd5K7GHDke4sec0McmB9pY0p7iLYj0Y5PJ085b+oBJT2VOXci7ei3ZE0HV3QEaV5MHV6q5zTHr6iZKOQ8AAC6P3PkH42Dp8zUBAK5KHeVTVlu2JxqfZOm11tWaJ4eeNQeQ9vEc3VOfvGvWVCkUXWdMtlmDALDK0z11yckLwjIM0v1V+rfFpSYp2QY8TNYlv0uK1aEO+eFT0HJMI5D84IYfiOMPR25tNk+Qp45UWxupmrI8p0bIyZF0/RedLFriClDlpsYqXaBLUaZcCG1kKR/+4LFliV4js8uPuaFLdAx0gqNfSS/mJr1Er5NWWtr8IWOryYHRcyQR3cPHK5z6RtNj0EbmhDBb4f3bo/cusEiQ5nuka03U1f5ahHP6q+Br4kW/TvEKjSoGmq4hOtrSJ4dyIjRxzSR0TSRpEfsGbrQNF0U7rZbuKG6HzkNXkz1kcVLtlczJRjrernLrqAu9CDYyT7be/PD2RPSeyc42fZQz+RAR264iFro+CCo9tGyRaIj0QiDfJgNBIiJ2lHYVv4j0RaOcCGVUVT78wWNKlWpFKiLpxxyphC4V0BEmafdSq8VA6HQtUDOfsk4WeS2l+yqwORnho+coXadKPWjYDjLFJBa44c2V0Yo73p/dYIK2l4yg09TVVXwyFPq9VCqS1rn8EivjECjsqvoea+l2hS4P04Q+RaVd9cur3hk/5kopdJXSabUlnBsInW5ZYFuVIEXI1Z4gv4aI8aMa9zpRdJRTnXUMhBl43VtnHIjZ3WRlT6GpAVON6E/i+nr3ikaiouLQoXNA0cEha0MdC/oLopJQC9LtCm0mUj78wWNSPXKoITXqoyDbA53Q5fpJiKd4DwPJnYHQVd9LRaeOS4csFFlZFZ4i4nyN1sdkK6BypelqfV2zcz8i7n/wksQTxxdCiCm//y5PHI6bXmGXItWnPhZbIXzfF4JKSRxVqlQvpk98GBqKGPmSO108knZd5RdK/ipQboQ2D1NiS1d2W4QhlR4TqdcIHYUjm3UMPx9mQlcU6WSnjrKV52ozdPTcQcT5aNpey3WvKQaZI6Z8V19jP3Xb0b7r/W7v7qVfIR1/+mg8Nj+yTZKm590aZctT2RfQkSRZ81Rfk0RlVxuTju9E3U6qlSHkuBo5SvXhDx4ruihkQaqTLtkDvdARW7Fvl9NSfj4SeWoidNVivEglsxeyskdan58VgBhgQzSciea6borCQ66JSzccwDvnUXIo75xH5cjY1dwBskzvUaFsp2mm1yAK3w1fzLrra15gXzaZGht/0q1DzXV99ZuORGORjKM2B9OiqxLw1GDQ3/G0kbQTOmLQargugOt6TfOvBxgKXTNW05lquGGa3MmmppXnavOzChykon1LoUHcdfjRbbdcecu2fV3rNwHA7UcREb8tjeWdevvRRFwsa+4AWhFa0XHUYajqe8Ykh90LiTNRg6ZcCW0GUj58swzuCCGEMJh14cdCTBO6GckeFTOhK6oo5iQzvXIQ/e6IaHt8ghnn3Bdav+GD3R0l8PBnI1I/794XkzGxrrkDFPXa6DtStQN5mYwXEmei95tyJrT5R/nwI89zCwPLEXpyMN9M6Jq500Zo5/UUQQFnr933ReruXf/XZHamLU/+yff/dikA+P0dY0/5zw3x0OEHX176/te6F6ym/LSyBDRZyKbjV2vnuonbch1U8qmSpkZrD8koivZ0JTZ7lnkg89Rfn55Oa0p/c5V6X/FBUK8BdNoA4ZqewjbYygwxZwYR91sffmbGey2/lQczhlNA7d1LC0PZ9WtAi7BHubNtIFCvOuVOaFNG+fCjDiw7PKkCM2aPLNFti1mqXDUs0dNHZXUMeucHyfBBYHe6nBNe56GII5nofSVW/0xS+pJilP/Qt+3c35MxHC/3VuJXt1LDyLpQ32J36LZdzWras45KJlpW0Zr2MwXStNzyxGhPcQUdz3LZVoTt6lmByyahkNXtRQj9m/RGTaulEe/NB7ZlDsJptIRohun93EspjuNkDtS7OqtPAACYvbCV6qbjZlX6tPGxNTBp8wLOpm7QVxQ2C9JmvWxhWIpP39JKo+1mVfp2b/B/a8uW7QCwZcsWEd4oSOiFsJWsjjwhuXKPZq3Ou736jAAAgF02lSK76a9x6unTYZS0zSY0ZqzwKUbtKKfCptNPMQWXtquD8uHHnSjHnpN45Hhc3B5Vdbfr9PPIlJhW3SHz+9KSzLi9AAQiYqe3nsOXg7OikNNUv0ze/S8AAPWWEM3w7REfeGn1AfU0eDXNh3v9HBMeAMA+G8/0nBoz2vXbsnrd7pqVDp16lhbCdvPyHACEcdVk1jDWhdA0TvnVrcx72LXNq2XpLa3UwOpZKmhbPM3DGVhWr0yBDnA/9aE6D/pry7oznm7J1EUX7RXzAQCutPhaGu4KqcTN9JHu2Pw0mkmeCpS1XsqxAOOeL+WSGpVdNZQPX3Zk2N/pAZAFdtweXaKb9/p5ipRYlOiQYaoV8apES/QmYhOmsCPylujFQK1soi0inQAADbVJREFUQYDBtgbdV+gwonWTOZZ1HgDALRb5uCF32oxX0Q9IP3EihmYpO4WmUUA5FwCGHxP1xhpKu1Yx8ROujJTuAUA2oQcAkDjdg0axmAhshW5bMgjiVYkK3e1gUEOcqojQySL9DIDB1MBQ6TchIlmkn3fP9PT0zi8TFftYAzOcy2HRRs9boAMA1CylLuyXG6oWrRB0fI0dMjoAYNR81OzQoLZr44OIefr4V2+BLfFNiNsjhN6NosGHNLnqRR9FTcprFmN6AVnziwm9hegjelUROlWkbwSI6LQNAHAqIn6J8r++62pnQuqxH9gHAABpbZqO/AU6AEDNN/9MT7nZQjCUur6yQPkQ3RBSKpWqLTXS7Fr48Al3aQVgs5deQj5xe2qhp6Zduw+prdBN91dRf7NjQp9E7CDWqiJ0qkjfBQCRJlIdAOCw8hi0+k2PIiIevVG6H30RWgAA8B/NshGxmAI9ZNJobkvQdLIGUGukf0wCaglrFMqT6D10CSn0LXvZ7Rr78Ml06z5xkcpRHqED1DVpl1cLStgLPW0nkpC2p/IdE3oNEXEKKiP0Ncm94zDsK+81Dz0AgAOI6o7Jc/4eMbGWPfL6twBA2vUxhXUFprDmTel/vaCVs3fU1a7W6hiYp/yJSACKr5Xw8tk19OHTTpX1pdg2JPmErk576pZGWYQOAJ62ZAiamvZdTOgwhYhedYROjaXvD5+ENZnAAYDjUSd0OP47iHj0TbF7/XzutWe26TIwzo6iE1lvTNEvZdBq2LfMqQB8QYm9I3zXxDsVNRF14DQS7VXRcIqIeS6SW5F0pogtu/LhNBLfgrZOb7mZbJL1iGAq5V2JC91DxFp+oS/K5TvCin3ymS0Au7pN5Fq9Ozf/mm8DTOtSuev9A19dPH8VADww1QovN5p327/o/NrYrQVurR49OKTdCQJRpH3HcSNLGzptEMbLGaiSZo8bv67V3f4pIaLgqOfAqdcj0WqXNJ7v1p3e69fuiHb5swDrTvRlCYJOOz3QerN7Mk2zDo12bQoCD5p1aLXKiqQdVxAfL7k9/gQi/pV0z221EdvdatrKo4gYdshN3LO/5yTyabg4udxcicVu7vMEKhfEqCPFzDOoRWz7Yr3on0Hstdx7OP3aTXhg6b2IeA/ApfccRsRrE2F82lzmBfbEjQ0sdKZ8qP44PHr7YNw8VOlfR5Ue3WWlCQBwDSIe/km32D4sjbmvTOwSpaPInrgxgYXODAF6q5mj914EAHD8xun+nZ/c0tt/Jjo/UQAAXBrz+9Oo0k/9a2L7GDVbh5z6KsBCZ4bBXpXo9k0/Id867ALER8l9AIAPxl3t/2DP9sT/sJI5PjWaLBgtVEZk3jOFmU8UsJXUgA3Bq+kH5yZvnfJmAQDB4Jzw6SYAwMVxV6u/d2D3/l+dcv5bz38VWPGiZ+d+/jLE9WjMQoHqeVdxL0B0OXY4t9NmNoyW60abESOCyonqrHFk5g/UaQ4KuoeuelNt7Ije1FGbhWk6Cp8qMx5QWeGMOlLMfETZTE9C7P02YdcOV/JUhq3c5wNEVnDNnSmDFdQYm4LPyp4/XpDOjyzAkTUAIIXujzpOzPxknYXSf7Iy6vNCq1FyHZePKvGjhsgLZ9RxYuYpmywUeXTnx5cAAMDxH7x9f7pzQxZmRxwAJfTWqKPEVIPCFrUM2PQNK+fPPQtw+ikFhv+9DxVobLxILGqZdYa1ezOz8CC3ihwaefZ3HncSmeGNOkZMRSihRAe4v5wTFo14fKF2xAEkS/ToyQCMEUvWvfWcNctOPnnuwMwz/zwtnU3w9ti0rd8+99yLlIk3vh4A/t+j8u2zXwcAcOQfCotqBRhdmb5QB9ZCpMxojTo+Y8c77piL5eAjl74i+vjnifft6R94iWbnzYiY3IRmIvQwV/axqcNlVEpf2DqXhN4adXTGjdPvS75Rh/4sUulNCh0R8ccfjU8kJ4V+Qeh27rzykzFURqP0Ba7zuNBtDjdjAODcQ+RLdfeJfRe00BEfPStqhxL627o1hXcMJSXDZBRK37HAdR4Veobd5Rc4r6V1jvitvhOV0BE3Rsp9QujndnX+74aVmASFrl6L8qGt15dlWsX9lw07xMoy7fPqVFtu625+8NDftX85d+y1v/u7b/rESQAA8IkHd8Uc3hr+OeGNbzmjf2/ba27WmD77f4aW3pfooZsPXFdMMW3MQtxpQiLMiE5sn2TGjJVh5j0e2fzslO+G93b3bvwcMbbA/4Q167/be/3e3b+bKNHP7NYV/qjM+I+Q9RazYfOzcOfDDTDfGJqR2YiIiA+fELv5R+G79TvdS1noAABnPBi6OdTfDUkW+hnPhC4+XFbUR866p4Ym8wW7jiWGO+oIjDHhCmm5U/wvERHxou4VJXQ47rPhK3hf74Yk9NN+GT7/qORv+Vsv/ujn/E3vP+sVMPas2DEkne9d6N1wTF7uRkTE46W7b0dExI90r0ihA3w9fAl772Bc6K/9Rfh0U8zLkkt/PHh7v34GjD30hpFFc8eok8mMPXciIuIq6e5JiIj4ye6VQuivCPc9/Vj3Mib05d2e+s/EfLxX6uH/uuVOaRVkCNX3ufWjTiQz/vwnRES8U779e5dddtllZ3cvFELv7l38cPcqKvSTHgvf0S/GjSbe4ftKmYs+XCy2l8rEbq62M/np7nd4n24hpUroi8Putm4NPCL0pQ+HVr8Wc35Wb57tM49P9/5N7MIyhmw4WKLM5xbsLhNMoby690J9+ESlG5XQu630PwwvBkI/cWdoc9txMddfQkTExy5ZAgDHnf/D0M34V96BPGq1IBb8ZDimKP6sX3b8zfuX0E6UQv8TRES8OrzoC/0V3aOT75a6+B5DRNzd+54s/gYiRsfhx5k1FptGWvAUt86Zwvh85M36/p++mWg1K4V+FiIifjq86Al98T1dY9I5w0sREdHtXy+eQ0S8obB0jJb1xdff53iODFMkN8der0PfuFiuxCuFvhwREW+NmoHj7uxZujvuOPwqnD+48V1ERN0U2vHiumKlPreVa+1MoSz6w8ell+ye98YcKIW+GBH7U2ZCoS/61sDMB2KOw6/CPYNlJhPXX3/99aNb71I8BUqdZc6UwcXyVsSP/kHkqVLoMIeI+Ej4fyj0aL/UoeVJx/jLD5e2omz0FCT1gyxzpiScT+yOv2yPDAbc1EJHxP7il2gLoDv9NT6j60s9/X91Yv5qfb2UjRl4itvmTJks/+BfPRN5337e3/1JKfQliIh4V3gREfr3T/hU+E/s8NBlj/UdzLUuW07Ymxes2ZqnWD+yg5evMOVz1rWDSvyjvTFupdBPQcR+f9pA6HcthsVhs/+Zk6LOa7G+gJ2TitG88efyHRlXsO7mwpwZFm/8bG9Geu+kAqXQz0NExE+FF32hf+s4ADg3biJk2ebYJpSHPj9vpQ6X77At14/suI5b5swwWf7fuu/eyeG1UugfR0TEfx9e9IR+czgS3x2ef0/cx6uvi+1L9cOTy0vFyFm32Xwazd6tPDeGGT7Xhq9fd0G6Uuh3ISJidyyuK/S/6D47IVyn+vRS2dMZGx8cvODTp5WTgKqwfvOOtOVtB3ezyJmy+cgPfvCDH3ztuMT9UMJeeKES+slhRbwr5VDog/Xn68L3mNrqbOn623p1+Fvzp6HyrL986469yZr8wb27t17HGmeGwS1RqUa4CBERbwwvVEK/HhEHS1wTe8Z1h9QvIAM++cau1MttpldiHG8X/FcAAFj3msG95/eOKDLMgmQWAADe8I/y/WMAAPBrrd/TvwAAAPepnn/hkjMBALav/S0AAJy2COA3/cMv576y7bFzAABWzlhFmGEYez6CiIj/IXE/LKwvDC/oEv3EcFh8rrf3W3Jf9/eGZXZ39wlERHx95PGFmgKfYZgCeU8oVnn2ytKwb3x1eEUK/bTuFLCbejeIAxy+HTp5GwB0Z8BGm6RviDxkGKZEFodj5j9/fezu0lDEh7otXELoJ17ZHWzf3V90Tgh9eehoegkAwE7E+Lj6ekRMLGZlGKYEPhfqde6GQaG+dOPT4c1rujfiQl9y1kXXfq3XaX5oMDxGnb3W3SB+M0BvYP3D/fXub34aEfGQvAEtwzDF86pf9EZ7fv7dL1zpXnTZ53f2t3brdYiH9finQ6LT4aP7SNCnqXYPan0rAFwc/vvIO5YAwKLXh/3982g9OsNUmbPjR6NH+P2eE+Uhi4+fHTFECv11ofXHFwMsuqvn7dBj071/p5cNJ5UMs9A5c1rWb1iev7PvQiX0v4iNUpNChytDpzcAwCvl/S0Qn+EWOsMMiaUbCSV/K9IRTwr98T9fHTdDC31Rd0fYswFg5d2SjV+eLTtnGKY81n4tVoHffUNsm3dJ6E8/ct+tn3hDwsbNiIhPJ26Hg2jdLd7P/EbEzn0T5R/fMA8OiGCYAnnF6aedtvK0U37zwvMv/PKJfy0vnKWrndWrZ1/5zD8/u//58kJhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhGIZhKsX/B5Jvp2Zvu1vHAAAAAElFTkSuQmCC",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#sdkLogo_svg__c)",
                mask: "url(#sdkLogo_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -36.738 88.73)"
                })
            })
        ]
    }));
var $6bbbdeadab023461$export$2e2bcd8739ae039 = $6bbbdeadab023461$var$SvgSdkLogo;





const $8f033889ae95cbbe$var$SvgSdkLogoWhite = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogoWhite_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogoWhite_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "sdkLogoWhite_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.762H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "sdkLogoWhite_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#sdkLogoWhite_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#sdkLogoWhite_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -36.738 88.73)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#sdkLogoWhite_svg__c)",
                mask: "url(#sdkLogoWhite_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -36.738 88.73)"
                })
            })
        ]
    }));
var $8f033889ae95cbbe$export$2e2bcd8739ae039 = $8f033889ae95cbbe$var$SvgSdkLogoWhite;





parcelRequire("7fPBF");
const $99cdf9595233aa23$var$SvgSelfServiceKiosk = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M7 4C5.355 4 4 5.355 4 7v36c0 1.645 1.355 3 3 3h36.006a3.015 3.015 0 0 0 3-2.992L46.1 7.002a1 1 0 0 0 0-.002c0-1.645-1.355-3-3-3H7zm0 2h36.1c.565 0 1 .435 1 1l-.094 36.002a.985.985 0 0 1-1 .998H7c-.565 0-1-.435-1-1V7c0-.565.435-1 1-1zm3 3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H10zm1 2h28v20H11V11zm-1 24a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2.291c.233.495.561.938 1.012 1.242.736.497 1.67.758 2.697.758 1.026 0 1.961-.261 2.697-.758.45-.304.78-.747 1.012-1.242H22a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H10zm18 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H28zm-17 2h10v1h-2a1 1 0 0 0-1 1c0 .156-.083.355-.422.584-.339.229-.904.416-1.578.416s-1.24-.187-1.578-.416c-.34-.229-.422-.428-.422-.584a1 1 0 0 0-1-1h-2v-1zm18 0h10v1H29v-1z"
        })
    }));
var $99cdf9595233aa23$export$2e2bcd8739ae039 = $99cdf9595233aa23$var$SvgSelfServiceKiosk;





parcelRequire("7fPBF");
const $fbf8be4ed6bd1575$var$SvgSensitivity = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M.906-.031C.863-.023.82-.011.781 0A1.002 1.002 0 0 0 0 1v48c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v17c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v7c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-7h1v11.5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v5c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-5h1v18c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v7c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-7h1v23c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V26h1v4c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-4h1v15c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V9a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 27 9v15h-1v-4a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 24 20v4h-1V1a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 21 1v23h-1v-7a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 18 17v7h-1V6a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 15 6v18h-1v-5a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 12 19v5h-1V12.5a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031a1.002 1.002 0 0 0-.781 1V24H8v-7a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 6 17v7H5V7a1 1 0 0 0-1.094-1.031c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 3 7v17H2V1A1 1 0 0 0 .906-.031ZM39 0v2h9v6h-5v2h5v6h-5v2h5v6h-9v2h9v6h-5v2h5v6h-5v2h5v6h-9v2h11V0Z"
        })
    }));
var $fbf8be4ed6bd1575$export$2e2bcd8739ae039 = $fbf8be4ed6bd1575$var$SvgSensitivity;





parcelRequire("7fPBF");
const $f7d13e33d82d990b$var$SvgShakePhone = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                d: "m23.528 38.31 7.865-2.689.667 1.95-7.865 2.69-.667-1.95Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "m48.63 77 19.197 6.563a4.26 4.26 0 0 0 5.41-2.653L86.572 41.9a4.26 4.26 0 0 0-2.653-5.409L63.353 29.46c.393.556.63 1.232.646 1.964l19.388 6.628a2.611 2.611 0 0 1 1.626 3.316l-13.337 39.01a2.611 2.611 0 0 1-3.315 1.626L53.727 77h-5.098Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillOpacity: 0.3,
                fillRule: "evenodd",
                d: "M35.498 29.716A3.431 3.431 0 0 0 35 31.5v.129L16.213 38.05a2.611 2.611 0 0 0-1.626 3.316l13.337 39.01a2.611 2.611 0 0 0 3.316 1.626L45.873 77h5.098l-19.198 6.563a4.26 4.26 0 0 1-5.41-2.653L13.028 41.9a4.26 4.26 0 0 1 2.653-5.409l19.818-6.776Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34.34 32.483c0-2.467 2-4.467 4.466-4.467h21.988c2.467 0 4.466 2 4.466 4.467V73.71c0 2.466-2 4.466-4.466 4.466H38.806c-2.466 0-4.466-2-4.466-4.466V32.483Zm4.466-2.405a2.405 2.405 0 0 0-2.405 2.405V73.71a2.405 2.405 0 0 0 2.405 2.404h21.988a2.405 2.405 0 0 0 2.405-2.404V32.483a2.405 2.405 0 0 0-2.405-2.405H38.806Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M44.99 32.483h9.62v2.06h-9.62v-2.06Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "m9.918 27.667-.22-3.962a1.35 1.35 0 0 0-2.696.15l.409 7.356 7.686 1.618a1.35 1.35 0 1 0 .556-2.642l-3.658-.77C16.941 24.768 30.075 16.7 49.448 16.7c19.2 0 33.117 8.332 38.402 12.739l-3.553.748a1.35 1.35 0 0 0 .556 2.642l7.686-1.618.409-7.356a1.35 1.35 0 0 0-2.696-.15l-.224 4.042C84.638 23.068 69.89 14 49.448 14c-20.329 0-34.226 8.552-39.53 13.667Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $f7d13e33d82d990b$export$2e2bcd8739ae039 = $f7d13e33d82d990b$var$SvgShakePhone;





parcelRequire("7fPBF");
const $f3b7e121ae3cb925$var$SvgShazam = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm-1.93 5.873a1.955 1.955 0 0 0-1.293.574v.002l-7.547 7.559a8.99 8.99 0 0 0-.617.68v.001c-.191.235-.37.476-.535.725v.002a8.89 8.89 0 0 0-.453.764v.002c-.137.26-.26.526-.37.797v.001c-.109.27-.206.545-.288.823v.002a9 9 0 0 0-.37 2.566 9.079 9.079 0 0 0 .659 3.39v.003a8.943 8.943 0 0 0 1.975 2.977v.001a8.977 8.977 0 0 0 6.367 2.623 9.046 9.046 0 0 0 4.191-1.025 8.915 8.915 0 0 0 2.176-1.598v-.002l3.771-3.773h.002a1.894 1.894 0 0 0 .06-2.672 1.891 1.891 0 0 0-2.671-.06v.001l-.06.059v.002l-3.774 3.771a5.192 5.192 0 0 1-7.39 0 5.347 5.347 0 0 1-.942-1.271 5.206 5.206 0 0 1-.217-.463v-.002a5.178 5.178 0 0 1-.387-1.963v-.002a5.184 5.184 0 0 1 .604-2.428v-.002c.08-.151.17-.3.266-.445v-.002a5.267 5.267 0 0 1 .675-.822v-.002l7.547-7.547a1.909 1.909 0 0 0 .57-1.326 1.898 1.898 0 0 0-.126-.711v-.002a1.905 1.905 0 0 0-1.823-1.207zm6.338 6.756a9.147 9.147 0 0 0-3.398.656 8.878 8.878 0 0 0-1.567.824 8.89 8.89 0 0 0-1.408 1.155l-3.773 3.773c-.378.36-.572.84-.582 1.324-.01.484.162.971.521 1.348a1.91 1.91 0 0 0 1.688.545c.357-.062.701-.227.984-.496.024-.012.037-.037.06-.049l3.774-3.785a5.342 5.342 0 0 1 1.272-.936 5.21 5.21 0 0 1 6.119.936 5.296 5.296 0 0 1 1.45 2.705 5.184 5.184 0 0 1-.001 1.994 5.197 5.197 0 0 1-.774 1.879c-.096.145-.2.288-.312.426-.113.137-.235.27-.363.398l-7.547 7.547a1.893 1.893 0 0 0-.455 2.04 1.875 1.875 0 0 0 .408.632 1.886 1.886 0 0 0 2.031.46 1.86 1.86 0 0 0 .627-.4c.024-.024.049-.036.06-.06l7.548-7.547a9 9 0 0 0 1.603-2.174 8.918 8.918 0 0 0 .658-1.625 9.08 9.08 0 0 0-.287-5.96 8.914 8.914 0 0 0-1.974-2.975 8.94 8.94 0 0 0-6.362-2.635z"
        })
    }));
var $f3b7e121ae3cb925$export$2e2bcd8739ae039 = $f3b7e121ae3cb925$var$SvgShazam;





parcelRequire("7fPBF");
const $303639901bf99dc0$var$SvgShift = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 8C5.862 8 2 11.862 2 16.6v17.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V16.6c0-4.738-3.862-8.6-8.6-8.6H10.6zm0 2h28.8c3.656 0 6.6 2.943 6.6 6.6v10.8c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 27.4V16.6c0-3.657 2.943-6.6 6.6-6.6zM25 17a.57.57 0 0 0-.217.043c-.015.006-.028.01-.043.018a.624.624 0 0 0-.172.115c-.009.009-.014.02-.023.03a.628.628 0 0 0-.065.071l-3.125 3.752a.626.626 0 0 0 .518.971H24v5a1 1 0 0 0 2 .027V22h2.127a.625.625 0 0 0 .52-.973l-3.126-3.752a.628.628 0 0 0-.064-.072c-.009-.009-.014-.02-.023-.03a.633.633 0 0 0-.172-.112c-.014-.007-.03-.012-.045-.018A.57.57 0 0 0 25 17zM4 32.902A8.585 8.585 0 0 0 10.6 36h28.8a8.587 8.587 0 0 0 6.6-3.098V34.4c0 3.656-2.943 6.6-6.6 6.6H10.6A6.584 6.584 0 0 1 4 34.4v-1.498z"
        })
    }));
var $303639901bf99dc0$export$2e2bcd8739ae039 = $303639901bf99dc0$var$SvgShift;





parcelRequire("7fPBF");
const $a105b007c217e587$var$SvgShift2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zM25 13l-5 5h4v13a1 1 0 1 0 2 0V18h4l-5-5zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    }));
var $a105b007c217e587$export$2e2bcd8739ae039 = $a105b007c217e587$var$SvgShift2;





parcelRequire("7fPBF");
const $6c173fbd5231fa4f$var$SvgShiftMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm7.504 14.293a1 1 0 0 0-.725.305l-5.5 5.709A1 1 0 0 0 13 31h2v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5h2a1 1 0 0 0 .72-1.693l-5.5-5.71a1 1 0 0 0-.716-.304zm-.004 2.441L21.646 29H21a1 1 0 0 0-1 1v5h-3v-5a1 1 0 0 0-1-1h-.646l3.146-3.266z"
        })
    }));
var $6c173fbd5231fa4f$export$2e2bcd8739ae039 = $6c173fbd5231fa4f$var$SvgShiftMac;





parcelRequire("7fPBF");
const $7bcdb42b48fb49f4$var$SvgShowtime = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        clipRule: "evenodd",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C18.21 2 12.097 4.95 7.889 9.635l-1.106 1.23 1.604.406c2.368.602 3.414 2.013 4.006 3.586.428 1.14.525 2.234.562 3.143H9.844c-.037-.437.007-.632-.201-1.299-.185-.59-.464-1.223-.967-1.76A3.012 3.012 0 0 0 6.5 14c-.81 0-1.483.33-1.93.695v.002h-.002c-.388.32-.727.776-.931 1.574-.356 1.4-.214 3.833 2.199 5.977 1.555 1.382 3.642 2.572 5.299 4.12C12.79 27.913 14 29.688 14 32.374c0 4.183-2.897 6.216-5.299 6.566l-1.879.274 1.29 1.394C12.311 45.151 18.33 48 25 48c6.745 0 12.825-2.91 17.031-7.543l1.135-1.25-1.64-.395c-2.076-.498-3.663-2.05-4.794-4.484C35.602 31.894 35 28.617 35 25c0-3.617.602-6.894 1.732-9.328 1.13-2.434 2.718-3.986 4.793-4.485l1.641-.394-1.135-1.25A22.952 22.952 0 0 0 25 2zm0 2c5.627 0 10.661 2.28 14.43 5.879-1.96.98-3.482 2.733-4.512 4.951C33.616 17.634 33 21.165 33 25s.616 7.366 1.918 10.17c1.03 2.218 2.552 3.97 4.512 4.951C35.66 43.72 30.627 46 25 46c-5.517 0-10.459-2.199-14.205-5.674C13.51 39.211 16 36.574 16 32.375c0-3.314-1.618-5.711-3.5-7.469-1.882-1.757-4.043-3.005-5.336-4.154-1.92-1.707-1.807-3.128-1.59-3.984v-.002c.084-.323.37-.608.264-.522.192-.157.35-.244.662-.244.358 0 .515.095.715.309.2.213.39.58.517.99C7.988 18.118 8 19 8 19v1h7v-1c0-.875.016-2.85-.734-4.846A7.642 7.642 0 0 0 10.48 9.97C14.258 6.318 19.327 4 25 4zm-9 28.375V41h7V28.5h3V41h7V10h-7v11.5h-3V10h-7v22.375zM18 12h3v11.5h7V12h3v27h-3V26.5h-7V39h-3V12zm25 2c-.89 0-1.68.461-2.283 1.1-.604.638-1.08 1.47-1.475 2.457C38.453 19.529 38 22.13 38 25c0 2.87.453 5.47 1.242 7.443.395.987.871 1.82 1.475 2.457C41.32 35.54 42.11 36 43 36c.89 0 1.68-.461 2.283-1.1.604-.638 1.08-1.47 1.475-2.457C47.547 30.471 48 27.87 48 25c0-2.87-.453-5.47-1.242-7.443-.395-.987-.871-1.82-1.475-2.457C44.68 14.46 43.89 14 43 14zm0 2c.215 0 .476.099.83.473s.741 1.004 1.07 1.828C45.56 19.948 46 22.347 46 25c0 2.653-.44 5.052-1.1 6.7-.329.823-.716 1.453-1.07 1.827-.354.374-.615.473-.83.473-.215 0-.476-.099-.83-.473s-.741-1.004-1.07-1.828C40.44 30.052 40 27.653 40 25c0-2.653.44-5.052 1.1-6.7.329-.823.716-1.453 1.07-1.827.354-.374.615-.473.83-.473zM2.031 22.117 2 24.487s-.096 3.724.666 6.296c.52 1.757 1.08 3.014 1.893 3.906C5.37 35.582 6.487 36 7.625 36c.93 0 1.864-.384 2.477-1.133.612-.749.898-1.773.898-2.992 0-1.534-.808-2.778-1.766-3.73-.957-.953-2.1-1.691-3.04-2.342-1.555-1.077-2.487-2.01-2.487-2.01l-1.676-1.676zm2.045 4.535c.424.347.38.379.98.795.972.672 2.016 1.37 2.768 2.117C8.576 30.312 9 31.031 9 31.875c0 .906-.214 1.444-.445 1.727-.231.282-.485.398-.93.398-.737 0-1.121-.144-1.59-.658-.468-.514-.971-1.507-1.451-3.125-.29-.98-.434-2.392-.508-3.565z"
        })
    }));
var $7bcdb42b48fb49f4$export$2e2bcd8739ae039 = $7bcdb42b48fb49f4$var$SvgShowtime;





const $b5b42c3034b41cbc$var$SvgSidebar = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M39.969 9.973a2 2 0 0 0-.29.027H10c-3.29 0-6 2.71-6 6v68c0 3.29 2.71 6 6 6h29.664a2 2 0 0 0 .652 0H90c3.29 0 6-2.71 6-6V16c0-3.29-2.71-6-6-6H40.309a2 2 0 0 0-.34-.027M10 14h28v72H10c-1.11 0-2-.89-2-2V16c0-1.11.89-2 2-2m32 0h48c1.11 0 2 .89 2 2v68c0 1.11-.89 2-2 2H42zm-28 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 22zm27.98 1.98a2 2 0 0 0-1.394 3.434L57.172 36l-8.586 8.586a2 2 0 1 0 2.828 2.828l10-10a2 2 0 0 0 0-2.828l-10-10a2 2 0 0 0-1.434-.605M14 30a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 30zm-8 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 38zm-8 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4h10a2.002 2.002 0 0 0 1.874-2.772A2 2 0 0 0 32 46z"
        })
    }));
var $b5b42c3034b41cbc$export$2e2bcd8739ae039 = $b5b42c3034b41cbc$var$SvgSidebar;





parcelRequire("7fPBF");
const $e5994517905e023d$var$SvgSignalApp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m25 2-.219.002.016 2L25 4c1.529 0 3.054.165 4.533.492l.434-1.953A23.074 23.074 0 0 0 25 2zm-2.305.113c-1.74.174-3.453.548-5.097 1.11l.644 1.892a20.791 20.791 0 0 1 4.653-1.011l-.2-1.99zm9.29.973-.608 1.904a20.393 20.393 0 0 1 4.328 1.967l1.035-1.71a22.399 22.399 0 0 0-4.756-2.161zm-16.337.906a22.248 22.248 0 0 0-4.476 2.686l1.223 1.582a20.243 20.243 0 0 1 4.076-2.446l-.823-1.822zm22.829 2.42L37.285 8.02a19.763 19.763 0 0 1 3.447 3.263l1.541-1.273a21.774 21.774 0 0 0-3.796-3.598zM25 7C15.626 7 8 14.178 8 23c0 5.129 2.606 9.926 7 12.938V41a.998.998 0 0 0 1.498.865l5.432-3.127A18.13 18.13 0 0 0 25 39c9.374 0 17-7.178 17-16S34.374 7 25 7zM9.578 8.037a21.362 21.362 0 0 0-3.35 4.02l1.684 1.08a19.344 19.344 0 0 1 3.035-3.643L9.578 8.037zM25 9c8.271 0 15 6.28 15 14s-6.729 14-15 14a16.19 16.19 0 0 1-3.062-.293 1.006 1.006 0 0 0-.69.115L17 39.27V35.4a1 1 0 0 0-.463-.841C12.443 31.942 10 27.62 10 23c0-7.72 6.729-14 15-14zm18.53 2.69-1.66 1.115a18.59 18.59 0 0 1 2.118 4.226l1.89-.66a20.68 20.68 0 0 0-2.349-4.682zM5.185 13.878a20.192 20.192 0 0 0-1.748 4.943l1.957.416a18.16 18.16 0 0 1 1.574-4.455l-1.783-.904zm41.28 4.514-1.946.457a18.115 18.115 0 0 1 .47 4.699l2 .06a20.174 20.174 0 0 0-.523-5.217zM3.11 20.9a20.106 20.106 0 0 0 .137 5.242l1.977-.312a18.193 18.193 0 0 1-.125-4.723L3.109 20.9zm41.727 4.538a18.046 18.046 0 0 1-1.24 4.556l1.845.774a20.03 20.03 0 0 0 1.377-5.063l-1.982-.267zm-39.22 2.246-1.932.515a20.376 20.376 0 0 0 1.994 4.85l1.736-.992a18.458 18.458 0 0 1-1.799-4.373zm37.16 4.02a19.076 19.076 0 0 1-2.77 3.845l1.467 1.36a21.156 21.156 0 0 0 3.058-4.249l-1.756-.957zM8.437 33.655 6.81 34.818a21.264 21.264 0 0 0 3.236 3.586l.41 4.024 1.992-.203-.453-4.418a1.005 1.005 0 0 0-.348-.66 19.33 19.33 0 0 1-3.21-3.49zm30.208 3.221a20.165 20.165 0 0 1-3.9 2.71l.941 1.765a22.211 22.211 0 0 0 4.288-2.98l-1.329-1.495zm-5.623 3.525c-1.46.61-3 1.053-4.572 1.315l.328 1.972a22.723 22.723 0 0 0 5.016-1.441l-.772-1.846zm-10.175 1.489a1.04 1.04 0 0 0-.508.08l-1.014.449.813 1.828.771-.344c1.27.115 2.554.124 3.795.033l-.146-1.994a21.624 21.624 0 0 1-3.711-.052zM19.5 43.232l-4.572 2.028.81 1.828 4.573-2.027-.811-1.829zm-6.848.98-1.99.206.344 3.336a1 1 0 0 0 1.398.81l1.506-.668-.81-1.828-.246.11-.202-1.965z"
        })
    }));
var $e5994517905e023d$export$2e2bcd8739ae039 = $e5994517905e023d$var$SvgSignalApp;





parcelRequire("7fPBF");
const $0f464a6a2f00d4b8$var$SvgSiri = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25c0 3.347.723 6.526 2.012 9.396a1 1 0 0 0 .199.44C7.902 42.613 15.828 48 25 48c12.69 0 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21 0 .482-.02.96-.053 1.434C42.36 21.88 37.885 18 32 18c-4.775 0-9.209 3.172-13.652 6.518-.159.119-.318.228-.477.347-.027-.01-.037-.024-.064-.033-3.465-1.166-8.32-1.45-13.752 1.623A21.313 21.313 0 0 1 4 25C4 13.39 13.39 4 25 4zm7 16c4.065 0 7.454 2.246 10.41 5.398a20.727 20.727 0 0 0-7.972-2.365c-4.302-.385-8.552.501-12.424 1.89-.598.215-1.171.458-1.752.692C24.402 22.54 28.359 20 32 20zm.73 4.893c4.26.055 8.564 1.436 12.686 5.027-.138.576-.3 1.143-.484 1.7-2.997-1.561-6.024-2.388-9.053-2.509-5.493-.218-10.995 1.868-16.352 5.996-3.152-1.795-6.15-2.47-8.73-2.59.577-.312 1.166-.633 1.795-.972 2.142-1.157 4.556-2.43 7.133-3.55 1.594.88 2.568 1.712 2.568 1.712a1 1 0 1 0 1.414-1.414s-.695-.529-1.746-1.2c.244-.092.48-.198.727-.286 3.235-1.161 6.623-1.96 10.042-1.914zm-20.779 1.154c1.387-.07 2.662.083 3.819.353-3.447 2.586-6.906 5.062-10.356 6.182a20.85 20.85 0 0 1-1.096-3.95c2.824-1.752 5.379-2.47 7.633-2.585zm22.307 4.994c3.3-.143 6.599.674 9.94 2.459a21.004 21.004 0 0 1-4.378 6.385c-4.884 1.637-11.358 2.004-17.195-2.666-.432-.346-.863-.66-1.293-.961 4.379-3.252 8.654-5.032 12.926-5.217zM9.893 34.465c2.24-.015 4.922.445 7.816 1.928-3.468 2.214-6.375 2.566-8.65 2.263a20.989 20.989 0 0 1-2.6-3.79 15.939 15.939 0 0 1 3.434-.401zm9.709 3.043c.586.384 1.176.796 1.773 1.273 4.832 3.866 10.153 4.621 14.756 4.008A20.888 20.888 0 0 1 25 46c-5.338 0-10.192-2.002-13.895-5.275 2.477-.137 5.371-1.037 8.497-3.217z"
        })
    }));
var $0f464a6a2f00d4b8$export$2e2bcd8739ae039 = $0f464a6a2f00d4b8$var$SvgSiri;





parcelRequire("7fPBF");
const $2005106e9deaac4d$var$SvgSlack = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M27.96 3.016a4.506 4.506 0 0 0-1.796.226c-2.492.805-3.707 3.508-2.922 5.887l1.117 3.398-5.285 1.93-1.07-3.25c-.59-1.887-2.25-3.059-4.043-3.191a4.61 4.61 0 0 0-1.79.226c-2.5.805-3.714 3.508-2.929 5.895l1.149 3.492-3.336 1.219c-2.356.832-3.598 3.496-2.836 5.91C4.848 26.75 6.629 28 8.489 28c.577 0 1.07-.14 1.433-.27h.008l3.383-1.238 1.624 4.934-3.863 1.414c-2.449.816-3.594 3.531-2.844 5.914C8.848 40.71 10.566 42 12.492 42c.535 0 .957-.14 1.36-.246l.043-.008 3.968-1.434 1.153 3.485v.012C19.684 45.69 21.453 47 23.39 47c.582 0 1.086-.137 1.46-.262 2.403-.808 3.715-3.472 2.919-5.89l-1.211-3.676 5.289-1.91 1.168 3.535v.008c.668 1.883 2.437 3.191 4.375 3.191.582 0 1.086-.137 1.46-.262 2.403-.812 3.715-3.476 2.919-5.89l-1.227-3.723 2.488-.898.016-.008c2.3-.945 3.547-3.602 2.672-6.024-.582-1.796-2.164-3.02-3.91-3.175a4.24 4.24 0 0 0-1.778.226l-.004.004-2.445.895-1.617-4.922 2.957-1.078c2.45-.817 3.598-3.524 2.848-5.907a4.473 4.473 0 0 0-3.938-3.21 4.297 4.297 0 0 0-1.766.226l-.004.004-3.019 1.101-1.04-3.152c-.589-1.887-2.25-3.058-4.042-3.187Zm-.132 1.976c1.012.059 1.922.696 2.266 1.805l.004.008 1.066 3.238-4.922 1.797-1.101-3.336c-.461-1.402.195-2.902 1.64-3.363h.012l.004-.004c.344-.117.691-.16 1.031-.145Zm9.875 5.004c.953.05 1.817.684 2.156 1.816v.016c.453 1.43-.203 2.957-1.57 3.414l-.012.004-2.941 1.074-1.668-5.062 3.062-1.117c.325-.118.653-.16.973-.145ZM13.828 10c1.012.055 1.922.695 2.266 1.805l.004.008 1.097 3.332-4.922 1.796-1.132-3.433c-.461-1.403.195-2.899 1.64-3.363h.012l.004-.004A2.7 2.7 0 0 1 13.828 10Zm17.961 1.941 1.668 5.063-4.922 1.8-1.668-5.066Zm-6.8 2.485 1.667 5.062-5.285 1.934-1.668-5.063Zm-7.165 2.62 1.664 5.063-4.922 1.797-1.664-5.062Zm16.258 1.86 1.621 4.922-4.922 1.797-1.62-4.922Zm-23.062.625 1.668 5.063-3.43 1.25a2.5 2.5 0 0 1-.77.156c-.953 0-1.984-.656-2.36-1.844-.44-1.402.329-2.976 1.59-3.422Zm16.261 1.86 1.621 4.922-5.285 1.937-1.62-4.926Zm-7.168 2.617 1.625 4.93-4.922 1.8-1.625-4.93Zm21.543 0c.95.086 1.836.758 2.168 1.808l.004.028.008.02c.512 1.394-.242 2.96-1.543 3.5h-.004l-2.371.855-1.711-5.18 2.492-.91c.313-.11.637-.149.957-.121Zm-5.328 1.719 1.707 5.175-4.93 1.782-1.699-5.157Zm-6.797 2.488 1.692 5.144-5.29 1.91-1.687-5.117Zm-7.168 2.625 1.684 5.113-4.926 1.777-1.68-5.09ZM38.66 32.8l1.211 3.669c.45 1.37-.32 2.918-1.656 3.37-.25.083-.578.157-.824.157-.973 0-2.11-.793-2.485-1.855l-1.176-3.563Zm-23.097.528 1.675 5.082-3.918 1.414c-.39.102-.761.176-.828.176-1.082 0-1.969-.617-2.355-1.844h.004c-.453-1.433.203-2.965 1.566-3.418l.012-.004Zm9.113 4.524 1.195 3.625c.45 1.367-.32 2.914-1.656 3.367-.25.082-.578.156-.824.156-.973 0-2.11-.797-2.485-1.855l-.004-.004-1.156-3.512Z"
        })
    }));
var $2005106e9deaac4d$export$2e2bcd8739ae039 = $2005106e9deaac4d$var$SvgSlack;





parcelRequire("7fPBF");
const $02d2ce069a187b72$var$SvgSmartWatch = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25.063 0C22.5 0 20.59.09 19.156.406c-.718.16-1.332.387-1.843.75-.512.364-.918.926-1 1.563-.051.379-.06.367-.157.656-.097.29-.218.754-.375 1.688-.457 2.761-1.851 2.605-3.125 3.968-.047.051-.11.07-.156.125C10.996 10.25 10 12.008 10 14v22c0 1.992.996 3.75 2.5 4.844l.031.031c.043.031.082.066.125.094 1.25 1.343 2.606 1.234 3.125 4 .156.84.29 1.261.375 1.531.086.27.098.34.157.781.078.617.472 1.168.968 1.532.496.363 1.078.585 1.782.75 1.406.328 3.308.437 5.875.437 2.562 0 4.472-.09 5.906-.406.718-.16 1.332-.387 1.843-.75.512-.364.918-.926 1-1.563.051-.379.06-.367.157-.656.097-.29.218-.754.375-1.687.457-2.762 1.851-2.606 3.125-3.97.043-.027.082-.062.125-.093l.031-.031C39.004 39.75 40 37.992 40 36v-2c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1v-3a2.17 2.17 0 0 0 2-2.156v-3.688A2.17 2.17 0 0 0 40 15v-1c0-1.992-.996-3.75-2.5-4.844l-.031-.031c-.043-.031-.082-.066-.125-.094-1.25-1.344-2.606-1.234-3.125-4-.157-.84-.29-1.261-.375-1.531-.086-.27-.098-.34-.157-.781-.078-.617-.472-1.168-.968-1.531-.496-.364-1.078-.586-1.782-.75C29.532.108 27.63 0 25.063 0Zm0 2c2.503 0 4.343.121 5.437.375.547.129.871.29 1.031.406.16.117.145.14.157.219.07.535.167.836.25 1.094.082.258.167.535.312 1.312A6.769 6.769 0 0 0 33.313 8H16.719a6.544 6.544 0 0 0 1.031-2.625c.145-.867.238-1.156.313-1.375.074-.219.183-.496.25-1 .011-.086-.012-.098.156-.219.168-.12.527-.281 1.093-.406 1.13-.25 2.993-.375 5.5-.375ZM16 10h18c2.219 0 4 1.781 4 4v2.156c-.332.617-.562 1.508-.562 2.844 0 1.332.234 2.223.562 2.844V36c0 2.219-1.781 4-4 4H16c-2.219 0-4-1.781-4-4V14c0-2.219 1.781-4 4-4Zm13 4c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm-7.5 1a2.518 2.518 0 0 0-2.5 2.5c0 1.367 1.133 2.5 2.5 2.5s2.5-1.133 2.5-2.5-1.133-2.5-2.5-2.5Zm7.5 1c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm-12.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 0c.29 0 .5.21.5.5 0 .29-.21.5-.5.5-.29 0-.5-.21-.5-.5 0-.29.21-.5.5-.5Zm18.344 0c.101 0 .156.055.156.156v3.688c0 .101-.055.156-.156.156h-.032c-.011-.016-.015-.008-.03-.031-.134-.215-.344-.762-.344-1.969s.242-1.758.374-1.969c.02-.031.016-.011.032-.031ZM25 21c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Zm-8 1c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm16 0c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm-8 1c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2Zm-8 1c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm16 0c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm.5 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM21 30c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3Zm7.5 0a2.518 2.518 0 0 0-2.5 2.5c0 1.367 1.133 2.5 2.5 2.5s2.5-1.133 2.5-2.5-1.133-2.5-2.5-2.5ZM21 32c.563 0 1 .438 1 1 0 .563-.437 1-1 1-.562 0-1-.437-1-1 0-.562.438-1 1-1Zm7.5 0c.29 0 .5.21.5.5 0 .29-.21.5-.5.5-.29 0-.5-.21-.5-.5 0-.29.21-.5.5-.5ZM16.688 42H33.28a6.544 6.544 0 0 0-1.031 2.625c-.145.867-.238 1.156-.312 1.375-.075.219-.184.496-.25 1-.012.086.011.098-.157.219-.168.12-.527.281-1.093.406-1.13.25-2.993.375-5.5.375-2.504 0-4.344-.121-5.438-.375-.547-.129-.871-.29-1.031-.406-.16-.117-.145-.14-.157-.219-.07-.535-.167-.836-.25-1.094-.082-.258-.167-.535-.312-1.312A6.769 6.769 0 0 0 16.688 42Z"
        })
    }));
var $02d2ce069a187b72$export$2e2bcd8739ae039 = $02d2ce069a187b72$var$SvgSmartWatch;





parcelRequire("7fPBF");
const $086b5e67479dbabb$var$SvgSmile = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "m64.266 77.858-2.41 1.83a20.688 20.688 0 0 1-11.857 4.199 20.689 20.689 0 0 1-11.855-4.2l-2.411-1.83A29.682 29.682 0 0 1 24.38 58.976L21.7 42.483c-.424-2.614-.61-5.302.186-7.828 2.553-8.108 10.866-19.32 27.46-19.32 17.78 0 26.207 11.212 28.768 19.32.797 2.525.61 5.214.184 7.828l-2.68 16.492a29.683 29.683 0 0 1-11.352 18.883Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#000",
                fillRule: "evenodd",
                d: "M49.347 16.671c-15.857 0-23.758 10.67-26.187 18.386-.7 2.22-.557 4.654-.141 7.212l2.68 16.492A28.347 28.347 0 0 0 36.54 76.794l2.411 1.83A19.354 19.354 0 0 0 50 82.551a19.354 19.354 0 0 0 11.049-3.927l2.41-1.83A28.347 28.347 0 0 0 74.3 58.76l2.68-16.492c.416-2.56.56-4.993-.14-7.211-2.423-7.673-10.413-18.387-27.493-18.387Zm1.726 68.494a22.024 22.024 0 0 0 11.59-4.413l2.41-1.83a31.02 31.02 0 0 0 11.864-19.733l2.68-16.492c.433-2.668.665-5.612-.23-8.444C76.69 25.71 67.826 14 49.347 14c-17.332 0-26.058 11.753-28.735 20.254-.892 2.831-.663 5.774-.23 8.443l2.68 16.492a31.02 31.02 0 0 0 11.863 19.733l2.411 1.83a22.024 22.024 0 0 0 11.59 4.413c.132.044.273.068.42.068.219 0 .436-.003.654-.01.217.007.434.01.652.01.147 0 .289-.024.421-.068Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#EE486F",
                fillRule: "evenodd",
                d: "M62.69 65.765c.523.76.33 1.8-.43 2.322-9.637 6.626-18.975 3.62-23.678-.061a1.67 1.67 0 1 1 2.058-2.63c3.83 2.998 11.559 5.557 19.73-.06a1.67 1.67 0 0 1 2.32.43Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $086b5e67479dbabb$export$2e2bcd8739ae039 = $086b5e67479dbabb$var$SvgSmile;





parcelRequire("7fPBF");
const $bd1ce7d657321c94$var$SvgSoundcloud = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M30 11c-3.602 0-7 1.79-9 4.688v3.5l.313.218.375-1c1.398-3.3 4.718-5.406 8.218-5.406 5 0 9 4 9 9v2l1.5-.594c.7-.3 1.395-.406 2.094-.406 3 0 5.5 2.5 5.5 5.5S45.5 34 42.5 34H21v2h21.5c4.102 0 7.5-3.398 7.5-7.5S46.602 21 42.5 21c-.5 0-1 .086-1.5.188C40.5 15.488 35.8 11 30 11Zm-13 5c-.7 0-1.398.086-2 .188V36h2Zm1 0v20h2V16.5c-.602-.2-1.3-.398-2-.5Zm-4 .5c-.7.3-1.398.602-2 1V36h2Zm-3 1.813c-.8.699-1.5 1.593-2 2.593V36h2ZM6.5 22a1.993 1.993 0 0 0-.5.094v13.812c.3.102.7.094 1 .094h1V22.094C7.7 21.992 7.3 22 7 22c-.148 0-.324-.012-.5 0Zm-1.5.313c-.7.199-1.398.5-2 1v11.375c.602.398 1.3.8 2 1Zm-3 1.78C.8 25.396 0 27.103 0 29c0 1.898.8 3.605 2 4.906Z"
        })
    }));
var $bd1ce7d657321c94$export$2e2bcd8739ae039 = $bd1ce7d657321c94$var$SvgSoundcloud;





parcelRequire("7fPBF");
const $c5ccfc72ed9852e5$var$SvgSpotify = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 1.99C12.267 1.99 1.99 12.267 1.99 25c0 12.733 10.277 23.01 23.01 23.01 12.733 0 23.01-10.277 23.01-23.01C48.01 12.267 37.733 1.99 25 1.99zm0 2.02c11.65 0 20.99 9.34 20.99 20.99 0 11.65-9.34 20.99-20.99 20.99-11.65 0-20.99-9.34-20.99-20.99C4.01 13.35 13.35 4.01 25 4.01zM21.934 14C16 14 11.536 15.027 11.318 15.078h-.002v.002c-1.6.374-2.61 2-2.238 3.6.372 1.601 1.998 2.609 3.598 2.242h.008l.005-.002c-.113.028.05-.012.17-.037a41.216 41.216 0 0 1 2.486-.422c1.664-.23 3.98-.461 6.589-.461h.062c4.313.006 10.51.668 15.484 3.588h.002v.002a3.01 3.01 0 0 0 4.105-1.072 3.016 3.016 0 0 0-1.067-4.106C34.276 14.747 27.009 14.007 22.004 14h-.07zm0 2h.07c4.805.007 11.748.758 17.502 4.137a.986.986 0 0 1 .357 1.369.992.992 0 0 1-.865.494.993.993 0 0 1-.504-.137l-.004-.002C33.013 18.647 26.504 18.006 21.998 18h-.064c-2.726 0-5.128.24-6.862.48-.867.12-1.568.24-2.056.332a27.35 27.35 0 0 0-.569.114c-.125.026-.116.022-.217.047a.986.986 0 0 1-1.205-.746.984.984 0 0 1 .745-1.2C11.922 16.992 16.232 16 21.934 16zm.058 6.002c-2.506.02-4.67.255-6.25.496s-2.477.459-2.765.541a2.733 2.733 0 0 0-1.873 3.356 2.73 2.73 0 0 0 3.355 1.87l.006-.001h.004l.119-.028a35.347 35.347 0 0 1 2.152-.393 40.441 40.441 0 0 1 5.582-.452c3.864-.034 8.246.533 12.522 3.197.446.28.949.414 1.437.414.906 0 1.797-.46 2.309-1.28a2.732 2.732 0 0 0-.87-3.743c-5.384-3.355-11.16-4.015-15.728-3.977zM22.01 24c4.361-.036 9.715.598 14.654 3.676a.703.703 0 0 1 .229.988.71.71 0 0 1-.612.338.69.69 0 0 1-.375-.107l-.002-.002c-4.691-2.924-9.523-3.538-13.6-3.502a42.32 42.32 0 0 0-7.65.789c-.214.043-.384.078-.504.105l-.142.033c-.036.009.02-.01-.106.028l.01-.004a.71.71 0 0 1-.885-.494.702.702 0 0 1 .494-.885h.002c-.011.003 1.018-.26 2.52-.488A42.38 42.38 0 0 1 22.01 24zm.49 5.002c-4.359.001-7.586 1.06-7.791 1.129a2.514 2.514 0 0 0-1.58 3.162c.433 1.299 1.864 2.02 3.166 1.578l-.016.006c.1-.032.16-.053.463-.135.304-.081.75-.19 1.307-.3a23.341 23.341 0 0 1 4.451-.44c4.337-.001 7.299 1.038 9.613 2.58v-.002c.424.283.91.422 1.385.422.807 0 1.605-.399 2.082-1.115a2.515 2.515 0 0 0-.693-3.465C31.242 29.992 27.14 29 22.5 29.002zm0 2c4.36-.002 7.995.896 11.277 3.084.239.16.298.455.139.693a.49.49 0 0 1-.418.223.48.48 0 0 1-.275-.084v-.002c-2.634-1.755-6.06-2.915-10.723-2.914-1.939 0-3.624.237-4.838.477-.607.12-1.097.24-1.44.332-.342.092-.64.19-.554.162l-.008.002-.008.002a.483.483 0 0 1-.627-.317.487.487 0 0 1 .317-.633c.058-.02 3.127-1.024 7.158-1.025z"
        })
    }));
var $c5ccfc72ed9852e5$export$2e2bcd8739ae039 = $c5ccfc72ed9852e5$var$SvgSpotify;





parcelRequire("7fPBF");
const $46b7fb5cd67a058d$var$SvgSsd = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M7.688 0c-.958 0-1.72.66-1.875 1.594L.093 35.406C.036 35.594 0 35.796 0 36v12c0 1.094.906 2 2 2h46c1.094 0 2-.906 2-2V36c0-.297-.066-.59-.187-.844L44.187 1.594C44.032.66 43.27 0 42.314 0Zm.093 2H42.22l5.375 32H2.375ZM2 36h45.969c.008.02.02.043.031.063V48H2Zm5 4v5h27v-5h-2v3h-3v-3h-2v3h-3v-3h-2v3h-3v-3h-2v3h-3v-3h-2v3H9v-3Zm34 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Z"
        })
    }));
var $46b7fb5cd67a058d$export$2e2bcd8739ae039 = $46b7fb5cd67a058d$var$SvgSsd;





parcelRequire("7fPBF");
const $28ab7c56405aa7ea$var$SvgSvgCephy = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 500 500"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "svg-cephy_svg__linear-gradient",
                        x1: 4.82,
                        x2: 282.2,
                        y1: 407.51,
                        y2: 247.37,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#062844"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.34,
                                stopColor: "#693b82"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.68,
                                stopColor: "#a3417a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ed486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("filter", {
                        id: "svg-cephy_svg__drop-shadow-5",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feOffset", {
                                dy: 10
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feGaussianBlur", {
                                result: "blur",
                                stdDeviation: 16
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feFlood", {
                                floodColor: "#ed486f",
                                floodOpacity: 0.75
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in2: "blur",
                                operator: "in"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in: "SourceGraphic"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.svg-cephy_svg__cls-4{fill:#fff}.svg-cephy_svg__cls-5{fill:#141526;mix-blend-mode:multiply;opacity:.2}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: 'none',
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "svg-cephy_svg__Layer_1",
                    style: {
                        filter: 'url(#svg-cephy_svg__drop-shadow-5)',
                        fill: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M319.91 419.59c-14.31 0-33.03-10.47-50.06-28.01-10.08-10.37-15.94-19.86-19.85-26.31-3.91 6.45-9.77 15.93-19.85 26.31-17.04 17.54-35.75 28.01-50.07 28.01-10.87 0-19.47-6.08-22.45-15.87-2.5-8.23.52-14.87 5.39-20.64-9.53 2.81-20.54 4.62-33.22 4.62h-.86c-16.93-.11-27.35-3.21-33.78-10.04-4.19-4.45-6.23-10.1-5.89-16.36.73-13.84 12.67-18.78 23.19-21.01-16.35-6.01-30.87-17.39-43.37-34.03-9.09-13.12-8.6-22.74-6.64-28.56 2.21-6.59 7.37-11.68 14.17-14.02 2.08-.76 4.28-1.15 6.53-1.15 1.2 0 2.36.1 3.49.3-1.1-2.94-1.81-5.9-2.08-8.87-.76-8.09 1.79-15.76 6.99-21.02 3.83-3.9 9.45-6.14 15.39-6.14 8.19 0 15.5 4.12 20.04 11.31 9.9 15.68 21.42 18.93 30.67 21.54 3.67 1.04 8.05 2.28 11.76 4.7-.47-11.87-4.6-31.51-12.68-65.74-5.53-23.44-1.94-58.75 18.57-84.79 11.92-15.14 34.44-33.22 73.96-33.41h.72c39.85 0 62.55 18.1 74.57 33.28 20.61 26.04 24.24 61.41 18.69 84.91-8.09 34.23-12.22 53.88-12.68 65.74 3.71-2.42 8.09-3.66 11.76-4.7 9.26-2.61 20.78-5.87 30.67-21.54 4.54-7.19 11.85-11.31 20.04-11.31 5.94 0 11.56 2.24 15.4 6.15 5.18 5.26 7.73 12.92 6.97 21.01-.28 2.97-.98 5.93-2.08 8.87 1.13-.19 2.3-.3 3.5-.3 2.25 0 4.45.39 6.53 1.15 6.8 2.34 11.95 7.43 14.17 14.02 1.96 5.83 2.46 15.44-6.32 28.13-12.71 16.93-27.32 28.41-43.71 34.46 10.52 2.23 22.47 7.17 23.22 21.02.34 6.25-1.7 11.91-5.89 16.36-6.43 6.83-16.85 9.93-33.78 10.04h-.86c-12.68 0-23.69-1.8-33.23-4.62 4.88 5.77 7.9 12.41 5.4 20.64-2.98 9.79-11.58 15.87-22.45 15.87Z",
                            className: "svg-cephy_svg__cls-4"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M418.78 276.51c-6.93-2.73-17.21 10.65-33.08 18.9-14.71 7.66-29.99 8.79-45.62 2.87-31.31-11.86-26.87-31.73-10.09-102.8 8.53-36.13-8.4-101.46-80.01-101.46h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-5.81 1.91-10.15 8.67-1.22 21.58 40.62 54.06 88.48 24.86 91.4 32.18 2.32 5.34-26.67 19.11-47.86 22-12.03 1.64-20.33 3.68-20.66 9.77-.49 9.16 10.82 11.95 26.16 12.05 56.47.36 74.38-38.5 81.13-34.58 4.07 1.98 2.26 7.41-3.32 16.82-14.47 24.39-39.17 33.63-36.18 43.44 3.91 12.84 27.49 5.22 49.73-17.67 19.49-20.06 20.91-35.61 29.61-35.61s10.12 15.55 29.61 35.61c22.24 22.89 45.82 30.51 49.73 17.67 2.98-9.81-21.72-19.06-36.18-43.44-5.59-9.41-7.4-14.83-3.32-16.82 6.76-3.92 24.67 34.94 81.13 34.58 15.34-.1 26.65-2.88 26.16-12.05-.33-6.1-8.62-8.13-20.66-9.77-21.19-2.89-50.18-16.66-47.86-22 2.93-7.32 50.78 21.89 91.4-32.18 8.93-12.91 4.59-19.67-1.22-21.58Zm-135.01-7.34c-6.04 11-18.83 18.63-33.78 18.63s-27.74-7.63-33.78-18.63c-1.27-2.32.61-5.03 3.57-5.03 0 0 14.59 6.53 30.22 6.53s30.22-6.53 30.22-6.53c2.95 0 4.84 2.71 3.57 5.03Zm52.51 8.89c1.89-7.85 28.72-1.81 48.22-32.68 4.15-6.57 11.54-5.61 14.23-2.88 5.97 6.05 5.08 21.17-15.85 35.65-14.63 10.88-32.21 12.18-41.32 7.91-6.93-3.22-5.27-8-5.27-8Zm-172.59 0c-1.89-7.85-28.72-1.81-48.22-32.68-4.15-6.57-11.54-5.61-14.23-2.88-5.97 6.05-5.08 21.17 15.85 35.65 14.63 10.88 32.21 12.18 41.32 7.91 6.93-3.22 5.27-8 5.27-8Z",
                            style: {
                                fill: 'url(#svg-cephy_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M110.52 306.85c15.19 8.49 40.3 10.26 56.26 5.29 32.75-10.19 46.72-36.6 29.87-113.5-10.6-48.37 8.19-100.6 78.54-101.43-7.53-2-15.89-3.13-25.2-3.13h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-1.39.46-2.68 1.2-3.74 2.22 7.07 7.46 17.66 19.46 33.06 28.07Z",
                            className: "svg-cephy_svg__cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M306.48 192.79c3.47-31.52-15.82-60.49-47.29-66.62-4.67-1-7.76-5.72-6.21-10.36 4.14-10.64 15.94-2.43 22.86.5 19.91 9.82 34.44 29.94 36.69 52.02.98 8.55.78 16.95-.97 25.44-.29 1.4-1.66 2.3-3.06 2.02-1.4-.28-2.26-1.63-2.04-2.99Z",
                            className: "svg-cephy_svg__cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M210.76 240.42c-7.64 0-13.83-7.71-13.83-17.22 0-9.51 6.19-17.22 13.83-17.22 4.95 0 9.26 3.26 11.7 8.12-1.52-1.41-3.38-2.27-5.42-2.27-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c2.04 0 3.9-.86 5.42-2.27-2.44 4.86-6.75 8.12-11.7 8.12ZM291.76 240.42c-7.64 0-13.83-7.71-13.83-17.22s6.19-17.22 13.83-17.22c4.68 0 8.79 2.91 11.3 7.33-1.31-.91-2.8-1.48-4.41-1.48-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c1.61 0 3.1-.56 4.41-1.48-2.5 4.42-6.62 7.33-11.3 7.33Z",
                            className: "svg-cephy_svg__cls-4"
                        })
                    ]
                })
            })
        ]
    }));
var $28ab7c56405aa7ea$export$2e2bcd8739ae039 = $28ab7c56405aa7ea$var$SvgSvgCephy;





parcelRequire("7fPBF");
const $3e1a50be14ab9a9e$var$SvgSwitchControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M50 77.353c15.107 0 27.353-12.246 27.353-27.353 0-15.107-12.246-27.353-27.353-27.353-15.107 0-27.353 12.246-27.353 27.353 0 15.107 12.246 27.353 27.353 27.353ZM50 80c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M72 50c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Z"
            })
        ]
    }));
var $3e1a50be14ab9a9e$export$2e2bcd8739ae039 = $3e1a50be14ab9a9e$var$SvgSwitchControl;





parcelRequire("7fPBF");
const $78046ad711fac15d$var$SvgSwitchControl1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 32.5,
                stroke: "#000",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 42.5,
                stroke: "#000",
                strokeWidth: 3,
                opacity: 0.1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 25,
                fill: "#E51546"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M74.813 67.203v6.89A15.313 15.313 0 0 1 59.5 89.407c-8.456 0-10.682-4.594-17.862-17.226a3.828 3.828 0 0 1 6.63-3.828l3.576 5.742V53.422a3.828 3.828 0 1 1 7.656 0V64.14a3.828 3.828 0 1 1 7.656 0v3.062a3.828 3.828 0 1 1 7.656 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M70.984 61.844a5.333 5.333 0 0 0-2.555.649 5.359 5.359 0 0 0-7.398-3.195v-5.876a5.36 5.36 0 0 0-10.719 0v15.312l-.73-1.173a5.363 5.363 0 0 0-9.274 5.384l.894 1.576c6.586 11.61 9.311 16.417 18.298 16.417a16.863 16.863 0 0 0 16.844-16.844v-6.89a5.36 5.36 0 0 0-5.36-5.36Zm2.297 12.25A13.797 13.797 0 0 1 59.5 87.875c-7.203 0-9.157-3.445-15.634-14.868l-.898-1.583v-.01a2.297 2.297 0 0 1 .837-3.137 2.273 2.273 0 0 1 1.148-.306 2.297 2.297 0 0 1 2.02 1.192l3.573 5.742a1.53 1.53 0 0 0 2.829-.811V53.422a2.297 2.297 0 0 1 4.594 0v13.016a1.531 1.531 0 1 0 3.062 0V64.14a2.297 2.297 0 0 1 4.594 0v3.828a1.531 1.531 0 0 0 3.062 0v-.766a2.297 2.297 0 0 1 4.594 0v6.89Z"
            })
        ]
    }));
var $78046ad711fac15d$export$2e2bcd8739ae039 = $78046ad711fac15d$var$SvgSwitchControl1;





parcelRequire("7fPBF");
const $4bb4296f4d314913$var$SvgSwitchControl2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 32.5,
                stroke: "#000",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 42.5,
                stroke: "#000",
                strokeWidth: 3,
                opacity: 0.1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 25,
                fill: "#E51546"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M74.813 67.203v6.89A15.313 15.313 0 0 1 59.5 89.407c-8.456 0-10.682-4.594-17.862-17.226a3.828 3.828 0 0 1 6.63-3.828l3.576 5.742V53.422a3.828 3.828 0 1 1 7.656 0V64.14a3.828 3.828 0 1 1 7.656 0v3.062a3.828 3.828 0 1 1 7.656 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M70.984 61.844a5.333 5.333 0 0 0-2.555.649 5.359 5.359 0 0 0-7.398-3.195v-5.876a5.36 5.36 0 0 0-10.719 0v15.312l-.73-1.173a5.363 5.363 0 0 0-9.274 5.384l.894 1.576c6.586 11.61 9.311 16.417 18.298 16.417a16.863 16.863 0 0 0 16.844-16.844v-6.89a5.36 5.36 0 0 0-5.36-5.36Zm2.297 12.25A13.797 13.797 0 0 1 59.5 87.875c-7.203 0-9.157-3.445-15.634-14.868l-.898-1.583v-.01a2.297 2.297 0 0 1 .837-3.137 2.273 2.273 0 0 1 1.148-.306 2.297 2.297 0 0 1 2.02 1.192l3.573 5.742a1.53 1.53 0 0 0 2.829-.811V53.422a2.297 2.297 0 0 1 4.594 0v13.016a1.531 1.531 0 1 0 3.062 0V64.14a2.297 2.297 0 0 1 4.594 0v3.828a1.531 1.531 0 0 0 3.062 0v-.766a2.297 2.297 0 0 1 4.594 0v6.89Z"
            })
        ]
    }));
var $4bb4296f4d314913$export$2e2bcd8739ae039 = $4bb4296f4d314913$var$SvgSwitchControl2;





parcelRequire("7fPBF");
const $6b7947571a956063$var$SvgSwitchSimple = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0 1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 5,
                fill: "currentColor"
            })
        ]
    }));
var $6b7947571a956063$export$2e2bcd8739ae039 = $6b7947571a956063$var$SvgSwitchSimple;





parcelRequire("7fPBF");
const $d4753e72983465a2$var$SvgSymantec = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M46 2v2h2V2Zm0 2h-4v2h4Zm-8 2v4h2V6Zm2 4v2h2v-2Zm2 0h2V8h-2Zm-2 2h-2v2h-2v2h-2v-2h2v-2h-2v1.598C30.602 10.699 26.3 9 21.5 9 10.7 9 2 17.7 2 28.5S10.7 48 21.5 48 41 39.3 41 28.5c0-3.8-1.102-7.3-3-10.3V16h2Zm-4 0h2v-2h-2Zm-14.5-1c3.898 0 7.602 1.3 10.5 3.5V16h-2v.8C27.602 15 24.7 14 21.5 14 13.5 14 7 20.5 7 28.5S13.5 43 21.5 43 36 36.5 36 28.5c0-2.7-.7-5.2-2-7.3V20h-2v-2h2v2h2.8c1.4 2.5 2.2 5.398 2.2 8.5C39 38.102 31.102 46 21.5 46S4 38.102 4 28.5 11.898 11 21.5 11Zm0 5c2.8 0 5.398.898 7.5 2.5v.5h-2s-4.102 8-5 10c0 0-5-7-8-7 0 0-1-.102-1 1s1 2 1 2 4.102 3.5 6 10c.2.7.8 2 2.5 2 1 0 1.898-.8 2.5-2 1-2 2.102-6.2 5-10v-1h2v-2h.2c1.198 1.898 1.8 4.102 1.8 6.5C34 35.398 28.398 41 21.5 41S9 35.398 9 28.5 14.602 16 21.5 16Z"
        })
    }));
var $d4753e72983465a2$export$2e2bcd8739ae039 = $d4753e72983465a2$var$SvgSymantec;





parcelRequire("7fPBF");
const $e0ea924b4f8fb967$var$SvgTabKey2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10.6 4C5.862 4 2 7.862 2 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h28.8c4.738 0 8.6-3.862 8.6-8.6V12.6C48 7.862 44.138 4 39.4 4H10.6zm0 2h28.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 31.4V12.6C4 8.943 6.943 6 10.6 6zm19.125 10.365v10.37h1.632v-1.182h.118c.423.82 1.29 1.304 2.336 1.304 1.886 0 3.07-1.482 3.07-3.86 0-2.393-1.176-3.862-3.07-3.862-1.025 0-1.886.497-2.276 1.31h-.115v-4.08h-1.695zm-16.633.506v1.524h3.035v8.34h1.764v-8.34h3.043V16.87h-7.842zm11.525 2.234c-1.777 0-3.013.842-3.15 2.16h1.6c.157-.505.69-.779 1.468-.779.916 0 1.408.412 1.408 1.143v.629l-1.927.115c-1.818.109-2.836.888-2.836 2.242 0 1.367 1.03 2.243 2.472 2.242.978 0 1.798-.423 2.215-1.148h.117v1.025h1.633V21.63c0-1.585-1.079-2.524-3-2.524zm8.662 1.471c1.155 0 1.86.916 1.86 2.42s-.698 2.42-1.86 2.42c-1.162 0-1.886-.93-1.886-2.42 0-1.49.731-2.42 1.886-2.42zm-7.336 2.822v.596c0 .868-.765 1.531-1.79 1.531-.753 0-1.294-.376-1.294-1.005 0-.61.447-.95 1.397-1.012l1.687-.11zM4 36.902A8.588 8.588 0 0 0 10.6 40h28.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H10.6A6.585 6.585 0 0 1 4 38.4v-1.498z"
        })
    }));
var $e0ea924b4f8fb967$export$2e2bcd8739ae039 = $e0ea924b4f8fb967$var$SvgTabKey2;





parcelRequire("7fPBF");
const $02e80b1c53448aa7$var$SvgTabMac = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm16.984 11.986A1 1 0 0 0 27 22v14a1 1 0 1 0 2 0V22a1 1 0 0 0-1.016-1.014zM19.99 23.99a1 1 0 0 0-.697 1.717L21.586 28H13a1 1 0 1 0 0 2h8.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l3.912-3.912a1 1 0 0 0-.002-1.592l-3.91-3.91a1 1 0 0 0-.717-.303z"
        })
    }));
var $02e80b1c53448aa7$export$2e2bcd8739ae039 = $02e80b1c53448aa7$var$SvgTabMac;





const $ac547a61f677026b$var$SvgTapPause = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 26.5,
                stroke: "currentColor",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 3,
                height: 18,
                x: 43,
                y: 41,
                fill: "currentColor",
                rx: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 3,
                height: 18,
                x: 54,
                y: 41,
                fill: "currentColor",
                rx: 1.5
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M83.125 67.031v5.906A13.125 13.125 0 0 1 70 86.064c-7.248 0-9.156-3.938-15.31-14.766a3.281 3.281 0 0 1 5.683-3.281l3.065 4.921V55.22a3.281 3.281 0 1 1 6.562 0v9.187a3.281 3.281 0 0 1 6.563 0v2.625a3.281 3.281 0 0 1 6.562 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M79.844 62.438c-.765-.001-1.518.19-2.19.556a4.594 4.594 0 0 0-6.341-2.739V55.22a4.594 4.594 0 1 0-9.188 0v13.125l-.627-1.006a4.596 4.596 0 0 0-7.949 4.615l.767 1.35C59.96 83.255 62.297 87.375 70 87.375a14.454 14.454 0 0 0 14.438-14.437V67.03a4.594 4.594 0 0 0-4.594-4.594Zm1.969 10.5A11.826 11.826 0 0 1 70 84.75c-6.174 0-7.849-2.953-13.4-12.744l-.77-1.357v-.008a1.969 1.969 0 0 1 .717-2.69c.299-.173.639-.263.984-.262a1.969 1.969 0 0 1 1.731 1.022l3.063 4.922a1.313 1.313 0 0 0 2.425-.695v-17.72a1.969 1.969 0 1 1 3.938 0v11.157a1.313 1.313 0 0 0 2.624 0v-1.969a1.969 1.969 0 1 1 3.938 0v3.281a1.313 1.313 0 0 0 2.625 0v-.656a1.969 1.969 0 1 1 3.938 0v5.906Z"
            })
        ]
    }));
var $ac547a61f677026b$export$2e2bcd8739ae039 = $ac547a61f677026b$var$SvgTapPause;





const $27e318183cdf78bd$var$SvgTapPlay = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 26.5,
                stroke: "currentColor",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "m61 50-16.5 9.526V40.474L61 50Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M83.125 67.031v5.906A13.125 13.125 0 0 1 70 86.064c-7.248 0-9.156-3.938-15.31-14.766a3.281 3.281 0 0 1 5.683-3.281l3.065 4.921V55.22a3.281 3.281 0 1 1 6.562 0v9.187a3.281 3.281 0 0 1 6.563 0v2.625a3.281 3.281 0 0 1 6.562 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M79.844 62.438c-.765-.001-1.518.19-2.19.556a4.594 4.594 0 0 0-6.341-2.739V55.22a4.594 4.594 0 1 0-9.188 0v13.125l-.627-1.006a4.596 4.596 0 0 0-7.949 4.615l.767 1.35C59.96 83.255 62.297 87.375 70 87.375a14.454 14.454 0 0 0 14.438-14.437V67.03a4.594 4.594 0 0 0-4.594-4.594Zm1.969 10.5A11.826 11.826 0 0 1 70 84.75c-6.174 0-7.849-2.953-13.4-12.744l-.77-1.357v-.008a1.969 1.969 0 0 1 .717-2.69c.299-.173.639-.263.984-.262a1.969 1.969 0 0 1 1.731 1.022l3.063 4.922a1.313 1.313 0 0 0 2.425-.695v-17.72a1.969 1.969 0 1 1 3.938 0v11.157a1.313 1.313 0 0 0 2.624 0v-1.969a1.969 1.969 0 1 1 3.938 0v3.281a1.313 1.313 0 0 0 2.625 0v-.656a1.969 1.969 0 1 1 3.938 0v5.906Z"
            })
        ]
    }));
var $27e318183cdf78bd$export$2e2bcd8739ae039 = $27e318183cdf78bd$var$SvgTapPlay;





const $0b5a1ec4c31772a9$var$SvgTapStop = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 50,
                cy: 50,
                r: 26.5,
                stroke: "currentColor",
                strokeWidth: 3
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#FBFDFE",
                d: "M83.125 67.031v5.906A13.125 13.125 0 0 1 70 86.064c-7.248 0-9.156-3.938-15.31-14.766a3.281 3.281 0 0 1 5.683-3.281l3.065 4.921V55.22a3.281 3.281 0 1 1 6.562 0v9.187a3.281 3.281 0 0 1 6.563 0v2.625a3.281 3.281 0 0 1 6.562 0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M79.844 62.438c-.765-.001-1.518.19-2.19.556a4.594 4.594 0 0 0-6.341-2.739V55.22a4.594 4.594 0 1 0-9.188 0v13.125l-.627-1.006a4.596 4.596 0 0 0-7.949 4.615l.767 1.35C59.96 83.255 62.297 87.375 70 87.375a14.454 14.454 0 0 0 14.438-14.437V67.03a4.594 4.594 0 0 0-4.594-4.594Zm1.969 10.5A11.826 11.826 0 0 1 70 84.75c-6.174 0-7.849-2.953-13.4-12.744l-.77-1.357v-.008a1.969 1.969 0 0 1 .717-2.69c.299-.173.639-.263.984-.262a1.969 1.969 0 0 1 1.731 1.022l3.063 4.922a1.313 1.313 0 0 0 2.425-.695v-17.72a1.969 1.969 0 1 1 3.938 0v11.157a1.313 1.313 0 0 0 2.624 0v-1.969a1.969 1.969 0 1 1 3.938 0v3.281a1.313 1.313 0 0 0 2.625 0v-.656a1.969 1.969 0 1 1 3.938 0v5.906Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M42 42h16v16H42z"
            })
        ]
    }));
var $0b5a1ec4c31772a9$export$2e2bcd8739ae039 = $0b5a1ec4c31772a9$var$SvgTapStop;





parcelRequire("7fPBF");
const $39440ba5457cc20b$var$SvgTiktok = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.672 0 3 1.328 3 3v32c0 1.672-1.328 3-3 3H9c-1.672 0-3-1.328-3-3V9c0-1.672 1.328-3 3-3zm17.043 4a1 1 0 0 0-1 .998l-.022 9.762-.015 6.73L25 30.594c0 1.815-1.649 3.299-3.527 3.299a3.337 3.337 0 0 1-3.352-3.354 3.335 3.335 0 0 1 3.352-3.352c.063 0 .19.021.408.047A1 1 0 0 0 23 26.24v-4.2a1 1 0 0 0-.937-.999c-.156-.01-.352-.03-.59-.03-5.25 0-9.528 4.279-9.528 9.528 0 5.25 4.278 9.527 9.528 9.527 5.249 0 9.527-4.277 9.527-9.527V21.49c1.455 1.164 3.268 1.9 5.27 1.9.273 0 .532-.016.78-.038a1 1 0 0 0 .909-.997v-4.67a1 1 0 0 0-.928-.997 6.478 6.478 0 0 1-5.978-5.792 1 1 0 0 0-.994-.896h-4.016zm.998 2h2.281a8.35 8.35 0 0 0 6.637 6.445v2.866c-2.139-.11-4.018-1.176-5.123-2.858a1 1 0 0 0-1.836.55V30.54a7.513 7.513 0 0 1-7.527 7.527 7.513 7.513 0 0 1-7.528-7.527c0-4 3.121-7.176 7.055-7.432v2.176c-2.714.253-4.879 2.48-4.879 5.256 0 2.944 2.407 5.354 5.352 5.354 2.929 0 5.527-2.307 5.527-5.3l.006-3.099.015-6.73.02-8.764z"
        })
    }));
var $39440ba5457cc20b$export$2e2bcd8739ae039 = $39440ba5457cc20b$var$SvgTiktok;





parcelRequire("7fPBF");
const $e3d15c36ae3535e8$var$SvgTodoist = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M6 4c-1.09 0-2 .91-2 2v38c0 1.09.91 2 2 2h38c1.09 0 2-.91 2-2V6c0-1.09-.91-2-2-2H6zm0 2h38v38H6v-9.13l5.89 3.12c.3.16.67.16.96-.01L30 28.21c.6-.34.68-1.19.14-1.63l-1.35-1.13c-.32-.27-.78-.3-1.15-.09l-14.79 8.37c-.3.17-.66.18-.96.02L6 30.666v-2.734l5.76 3.058c.31.16.67.16.97-.01l17.14-9.77c.61-.34.68-1.19.15-1.63l-1.35-1.13c-.33-.27-.79-.3-1.15-.09l-14.8 8.37a.976.976 0 0 1-.95.02L6 23.734V21l5.64 2.99c.3.16.67.16.96-.01l17.15-9.77c.6-.34.68-1.19.14-1.63l-1.35-1.13c-.32-.27-.78-.3-1.15-.09L12.6 19.73c-.3.17-.66.18-.96.02L6 16.797V6z"
        })
    }));
var $e3d15c36ae3535e8$export$2e2bcd8739ae039 = $e3d15c36ae3535e8$var$SvgTodoist;





parcelRequire("7fPBF");
const $5c13e7fb415e096f$var$SvgToggleKey = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.906 2.969a1.169 1.169 0 0 0-.219.062.88.88 0 0 0-.093.031 1.204 1.204 0 0 0-.188.126.949.949 0 0 0-.125.093.954.954 0 0 0-.125.156l-7.875 7.844a1.014 1.014 0 0 0 0 1.438c.399.398 1.04.398 1.438 0L12 6.438V38c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V6.438l6.281 6.28c.399.4 1.04.4 1.438 0a1.014 1.014 0 0 0 0-1.437l-7.875-7.844A1.022 1.022 0 0 0 13.188 3a.972.972 0 0 0-.282-.031ZM37 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-.094 3.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0 0 36 12v31.563l-6.281-6.282A1.007 1.007 0 0 0 28.78 37a.994.994 0 0 0-.781.703c-.105.367.004.758.281 1.016l7.875 7.843c.02.032.04.063.063.094l.062.063c.02.023.04.043.063.062h.031c.066.063.14.114.219.157h.031c.02.011.043.023.063.03h.03a.879.879 0 0 0 .094.032c.106.016.208.016.313 0h.063a.967.967 0 0 0 .25-.094c.132-.066.25-.164.343-.281l7.938-7.906a1.014 1.014 0 0 0 0-1.438 1.014 1.014 0 0 0-1.438 0L38 43.563V12a1 1 0 0 0-1.094-1.031ZM13 41c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
    }));
var $5c13e7fb415e096f$export$2e2bcd8739ae039 = $5c13e7fb415e096f$var$SvgToggleKey;





parcelRequire("7fPBF");
const $722cd4719e6bada2$var$SvgTools = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M38.5-.094c-.297.008-.605.028-.906.063-1.2.136-2.438.465-3.625.906C31.594 1.758 29.406 3.094 28 4.5c-1.52 1.52-2.266 3.375-2.25 5.281.012 1.649.629 3.313 1.531 4.906L25 17a1.004 1.004 0 0 0-.348 1.004c.086.371.38.664.75.75.375.086.762-.05 1.004-.348l2.813-2.812a.999.999 0 0 0 .125-1.25c-1.024-1.582-1.582-3.145-1.594-4.563-.012-1.418.477-2.695 1.656-3.875 1.094-1.093 3.157-2.363 5.282-3.156a11.749 11.749 0 0 1 3.78-.719l-3.78 3.75a.466.466 0 0 0-.032.063c-1.027 1.172-1.074 2.957.032 4.062L40 15.22l.031.031c1.172 1.027 2.957 1.074 4.063-.031l3.781-3.781a11.623 11.623 0 0 1-.719 3.812c-.789 2.113-2.058 4.152-3.156 5.25-1.18 1.18-2.434 1.613-3.844 1.594-1.41-.02-3.008-.574-4.656-1.563a1 1 0 0 0-1.219.157l-1.593 1.593a1.006 1.006 0 0 0 1.406 1.438l1.125-1.125c1.625.87 3.258 1.476 4.906 1.5 1.89.027 3.762-.668 5.281-2.188 1.403-1.402 2.742-3.574 3.625-5.937.883-2.364 1.348-4.926.625-7.094a1.001 1.001 0 0 0-.722-.648A1.005 1.005 0 0 0 48 8.5l-5.312 5.281c-.282.281-.86.32-1.282 0-.02-.015-.043-.015-.062-.031l-5.25-5.25c-.297-.297-.313-.918.062-1.344l5.25-5.25c.246-.242.348-.593.274-.933A1.001 1.001 0 0 0 41.03.25c-.8-.273-1.644-.371-2.531-.344ZM3.344 0c-.211.031-.41.129-.563.281l-2.5 2.5A1 1 0 0 0 .125 4l4.219 7.313a1 1 0 0 0 1 .468l2.187-.344L21.094 25l-.5.5a2.827 2.827 0 0 0 0 4l.687.719c.797.797 1.895.793 2.875.468l1.688 1.657c-.114 1.347.281 2.687 1.25 3.656L39.28 48.219a6.318 6.318 0 0 0 8.938 0v-.032c2.37-2.492 2.402-6.503 0-8.906L36 27.094c-1.008-1.008-2.348-1.32-3.656-1.25l-1.657-1.688c.325-.98.329-2.078-.468-2.875l-.719-.687a2.835 2.835 0 0 0-2-.844c-.727 0-1.45.293-2 .844l-.5.5L11.438 7.53l.343-2.187a1 1 0 0 0-.469-1L4 .125A.979.979 0 0 0 3.438 0h-.094Zm.344 2.25 6.03 3.469-.312 2.031c-.043.309.063.621.281.844L23.595 22.5 22.5 23.594 8.594 9.687a1.009 1.009 0 0 0-.844-.28l-2.031.312L2.25 3.688ZM27.5 21.781c.223 0 .445.07.594.219l.687.719a.83.83 0 0 1 .063 1.125 1 1 0 0 0 .062 1.375l2.282 2.281c.23.23.554.336.875.281.925-.152 1.894.082 2.53.719l12.188 12.219c1.594 1.593 1.61 4.351 0 6.062-1.73 1.73-4.332 1.73-6.062 0L28.5 34.594c-.664-.664-.926-1.606-.719-2.438a.996.996 0 0 0-.281-.968l-2.281-2.282a1 1 0 0 0-1.375-.062.83.83 0 0 1-1.125-.063L22 28.094c-.297-.297-.297-.89 0-1.188L26.906 22c.149-.148.371-.219.594-.219Zm-9.812 3a1.005 1.005 0 0 0-.594.313l-4.75 4.75c-.68-.133-1.348-.25-2.031-.25-5.637 0-10.22 4.582-10.22 10.218C.094 45.45 4.677 50 10.314 50 15.949 50 20.5 45.45 20.5 39.813c0-.731-.164-1.454-.344-2.157l3.438-3.437a1.006 1.006 0 0 0-1.407-1.438l-3.78 3.813a1.006 1.006 0 0 0-.25 1.062c.25.664.343 1.332.343 2.157A8.136 8.136 0 0 1 10.313 48c-4.563 0-8.22-3.625-8.22-8.187a8.189 8.189 0 0 1 8.22-8.22c.714 0 1.433.102 2.156.282.34.074.695-.031.937-.281L18.5 26.5a1.002 1.002 0 0 0-.719-1.719h-.093Zm14.03 5.5-1.437 1.438 12 12 1.438-1.438ZM11.376 34a1.006 1.006 0 0 0-.156.031L6.53 35.344a.998.998 0 0 0-.687.687L4.53 40.72a.997.997 0 0 0 .25 1l3.5 3.5c.254.25.625.347.969.25l4.813-1.313a1 1 0 0 0 .718-.718l1.188-4.688a.997.997 0 0 0-.25-.969l-3.5-3.5a1.009 1.009 0 0 0-.844-.281Zm-.187 2.125 2.687 2.688-.906 3.593-3.656.969-2.688-2.687.969-3.594Z"
        })
    }));
var $722cd4719e6bada2$export$2e2bcd8739ae039 = $722cd4719e6bada2$var$SvgTools;





parcelRequire("7fPBF");
const $7fccdf11ae80529b$var$SvgTouchpad = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M5.008 5A4.023 4.023 0 0 0 1 9.008v25.984A4.023 4.023 0 0 0 5.008 39H12a1 1 0 1 0 0-2H5.008A1.994 1.994 0 0 1 3 34.992V9.008C3 7.888 3.887 7 5.008 7h39.984C46.112 7 47 7.889 47 9.008v25.984c0 1.12-.889 2.008-2.008 2.008H42a1 1 0 1 0 0 2h2.992A4.023 4.023 0 0 0 49 34.992V9.008A4.024 4.024 0 0 0 44.992 5H5.008zM24 12c-6.063 0-11 4.937-11 11 0 .48.031.955.092 1.422a1 1 0 1 0 1.982-.256A9.066 9.066 0 0 1 15 23c0-4.983 4.017-9 9-9s9 4.017 9 9c0 .437-.032.865-.092 1.283a1 1 0 0 0 1.98.283c.075-.513.112-1.035.112-1.566 0-6.063-4.937-11-11-11zm0 4c-3.854 0-7 3.146-7 7a1 1 0 1 0 2 0c0-2.774 2.226-5 5-5s5 2.226 5 5a1 1 0 1 0 2 0c0-3.854-3.146-7-7-7zm0 4c-1.645 0-3 1.355-3 3v12.258l-1.06-1.06a3.015 3.015 0 0 0-4.243 0 3.015 3.015 0 0 0 0 4.241l5.596 5.596a1 1 0 0 0 .008.008s.74.723 1.781 1.443C24.124 46.206 25.474 47 27 47h4.777c3.8 0 6.927-2.962 7.196-6.7.007-.042.027-.125.027-.3v-7c0-1.645-1.355-3-3-3-.607 0-1.088.337-1.562.652C33.923 29.73 33.12 29 32 29c-.607 0-1.088.337-1.562.652C29.923 28.73 29.12 28 28 28c-.388 0-.658.279-1 .416V23c0-1.645-1.355-3-3-3zm0 2c.565 0 1 .435 1 1v9a1 1 0 1 0 2 0v-.986A1 1 0 0 0 27 31c0-.565.435-1 1-1s1 .435 1 1v1a1 1 0 0 0 .049.295 1 1 0 0 0 .035.094 1 1 0 0 0 .1.173 1 1 0 0 0 .06.079 1 1 0 0 0 .069.072 1 1 0 0 0 .158.123 1 1 0 0 0 .088.047 1 1 0 0 0 .187.07 1 1 0 0 0 .098.022 1 1 0 0 0 .199.01 1 1 0 0 0 .293-.057 1 1 0 0 0 .094-.04 1 1 0 0 0 .088-.046 1 1 0 0 0 .228-.192 1 1 0 0 0 .065-.078 1 1 0 0 0 .136-.265 1 1 0 0 0 .053-.293A1 1 0 0 0 31 32c0-.565.435-1 1-1s1 .435 1 1v1a1 1 0 0 0 2 0c0-.565.435-1 1-1s1 .435 1 1v7c0-.047-.001-.019-.016.102a1 1 0 0 0-.005.05A5.204 5.204 0 0 1 31.777 45H27c-.74 0-1.89-.542-2.781-1.158a12.889 12.889 0 0 1-1.512-1.22l-.008-.009-5.588-5.588a.985.985 0 0 1 0-1.414.985.985 0 0 1 1.414 0l2.768 2.768A1 1 0 0 0 23 37.672V23c0-.565.435-1 1-1z"
        })
    }));
var $7fccdf11ae80529b$export$2e2bcd8739ae039 = $7fccdf11ae80529b$var$SvgTouchpad;





parcelRequire("7fPBF");
const $f481633bf928acdb$var$SvgTrello = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M9 4C6.25 4 4 6.25 4 9v32c0 2.75 2.25 5 5 5h32c2.75 0 5-2.25 5-5V9c0-2.75-2.25-5-5-5H9zm0 2h32c1.668 0 3 1.332 3 3v32c0 1.668-1.332 3-3 3H9c-1.668 0-3-1.332-3-3V9c0-1.668 1.332-3 3-3zm3 3c-1.645 0-3 1.355-3 3v24c0 1.645 1.355 3 3 3h7c1.645 0 3-1.355 3-3V12c0-1.645-1.355-3-3-3h-7zm19 0c-1.645 0-3 1.355-3 3v12c0 1.645 1.355 3 3 3h7c1.645 0 3-1.355 3-3V12c0-1.645-1.355-3-3-3h-7zm-19 2h7c.565 0 1 .435 1 1v24c0 .565-.435 1-1 1h-7c-.565 0-1-.435-1-1V12c0-.565.435-1 1-1zm19 0h7c.565 0 1 .435 1 1v12c0 .565-.435 1-1 1h-7c-.565 0-1-.435-1-1V12c0-.565.435-1 1-1z"
        })
    }));
var $f481633bf928acdb$export$2e2bcd8739ae039 = $f481633bf928acdb$var$SvgTrello;





parcelRequire("7fPBF");
const $fe23b5827fb90960$var$SvgTripadvisor = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 11c-5.832 0-11.156 1.512-15.21 4H2s1.754 2.152 2.578 4.578A11.952 11.952 0 0 0 2 27c0 6.629 5.371 12 12 12 3.496 0 6.637-1.508 8.828-3.895L25 38l2.172-2.895C29.363 37.492 32.504 39 36 39c6.629 0 12-5.371 12-12 0-2.805-.969-5.379-2.578-7.422C46.246 17.152 48 15 48 15h-7.797c-4.055-2.488-9.375-4-15.203-4Zm0 2c3.883 0 7.586.707 10.8 2.012A11.99 11.99 0 0 0 25 22.215a11.985 11.985 0 0 0-10.828-7.203l.07-.024C17.453 13.7 21.145 13 25 13Zm-11 4c5.523 0 10 4.477 10 10s-4.477 10-10 10S4 32.523 4 27s4.477-10 10-10Zm22 0c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm-22 4c-3.312 0-6 2.688-6 6 0 3.313 2.688 6 6 6 3.313 0 6-2.687 6-6 0-3.312-2.687-6-6-6Zm22 0c-3.312 0-6 2.688-6 6 0 3.313 2.688 6 6 6 3.313 0 6-2.687 6-6 0-3.312-2.687-6-6-6Zm-22 2c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm22 0c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm-22 2a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Zm22 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Z"
        })
    }));
var $fe23b5827fb90960$export$2e2bcd8739ae039 = $fe23b5827fb90960$var$SvgTripadvisor;





parcelRequire("7fPBF");
const $1695f1b8e4452b4e$var$SvgTv = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M0 7v32h50V7Zm2 2h46v28H2Zm8.813 32c-.551.05-.958.543-.907 1.094.051.55.543.957 1.094.906h28c.36.004.695-.184.879-.496a1.01 1.01 0 0 0 0-1.008c-.184-.312-.52-.5-.879-.496H10.812Z"
        })
    }));
var $1695f1b8e4452b4e$export$2e2bcd8739ae039 = $1695f1b8e4452b4e$var$SvgTv;





parcelRequire("7fPBF");
const $0c48daaee27f5aac$var$SvgTwitch = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m5.313 1-.25.656-3 8L2 9.812V43h11v6h7.406l.313-.281L26.437 43h8.97l.312-.281L48 30.437V1Zm1.375 2H46v26.594L34.594 41h-9l-6 6H15v-6H4V10.188ZM10 5v30h8v7.406l1.719-1.687L25.437 35h11.97l.312-.281 6-6 .281-.313V5Zm2 2h30v20.563L36.563 33h-11.97l-.312.281L20 37.563V33h-8Zm8 6v14h6V13Zm10 0v14h6V13Zm-8 2h2v10h-2Zm10 0h2v10h-2Z"
        })
    }));
var $0c48daaee27f5aac$export$2e2bcd8739ae039 = $0c48daaee27f5aac$var$SvgTwitch;





parcelRequire("7fPBF");
const $d417e5b9a3bf4ea5$var$SvgTwitterx = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11 4c-3.854 0-7 3.146-7 7v28c0 3.854 3.146 7 7 7h28c3.854 0 7-3.146 7-7V11c0-3.854-3.146-7-7-7H11zm0 2h28c2.774 0 5 2.226 5 5v28c0 2.774-2.226 5-5 5H11c-2.774 0-5-2.226-5-5V11c0-2.774 2.226-5 5-5zm2.086 7 9.223 13.104L13 37h2.5l7.938-9.293L29.977 37h7.937L27.79 22.613 36 13h-2.5l-6.84 8.01L21.023 13h-7.937zm3.828 2h3.065l14.107 20H31.02L16.914 15z"
        })
    }));
var $d417e5b9a3bf4ea5$export$2e2bcd8739ae039 = $d417e5b9a3bf4ea5$var$SvgTwitterx;





parcelRequire("7fPBF");
const $418d4e99ed245825$var$SvgUber = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14.5 20c-.277 0-.5.223-.5.5v9c0 .277.223.5.5.5H21c1.207 0 3-.8 3-3 0-1.277-.61-2.07-1.348-2.52.211-.402.348-.886.348-1.48 0-2.2-1.793-3-3-3Zm14 0c-.277 0-.5.223-.5.5v9c0 .277.223.5.5.5h7.387c.11 0 .215-.062.265-.168l.836-1.691c.035-.063-.011-.141-.086-.141H30v-1.5c0-.277.223-.5.5-.5h3.375a.292.292 0 0 0 .266-.168l.847-1.687a.099.099 0 0 0-.086-.145H30v-2h5.86c.109 0 .21-.062.265-.16l.863-1.695a.098.098 0 0 0-.086-.145Zm11.996 0a.495.495 0 0 0-.496.5v9.2c0 .163.137.3.3.3H42v-2c0-.55.45-1 1-1h2.984l1.7 2.848a.3.3 0 0 0 .257.152h1.961c.075 0 .121-.082.082-.152l-1.879-3.188C49.285 26.14 50 25.02 50 23.5c0-2.125-1.375-3.5-3.5-3.5Zm-40.195.074c-.164 0-.301.137-.301.301V26c0 1.512 1.047 4.375 5 4.375 3.953 0 5-2.863 5-4.375v-5.926H8.3c-.163 0-.3.137-.3.301v5.613c-.008.399-.187 2.387-3 2.387-2.812 0-2.992-1.984-3-2.375v-5.926ZM16 22h3.988c.461.012 1.012.195 1.012 1 0 .746-.473.957-.898.996-.055 0-.079 0-.114.004H16Zm26 0h4.5c1.344 0 1.5.855 1.5 1.5s-.156 1.5-1.5 1.5H42Zm-25.5 4h4.488c.461.012 1.012.195 1.012 1 0 .805-.55.988-1.012 1H16v-1.5c0-.277.223-.5.5-.5Z"
        })
    }));
var $418d4e99ed245825$export$2e2bcd8739ae039 = $418d4e99ed245825$var$SvgUber;





parcelRequire("7fPBF");
const $6eacdd29be96605e$var$SvgUnity = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M40.45 3a.934.934 0 0 0-.274.031l-16.41 4a.98.98 0 0 0-.692.598L21.324 12H16a.994.994 0 0 0-.734.324l-12 13a.992.992 0 0 0 .046 1.399l12.579 12c.187.18.433.277.691.277h5.742l1.75 4.371a.986.986 0 0 0 .754.613l17.461 3a1.002 1.002 0 0 0 1.148-.77l3.54-16.23c.054-.25.011-.515-.122-.734l-2.328-3.82 2.375-5a.982.982 0 0 0 .04-.758l-5.583-16c-.136-.39-.5-.656-.91-.672Zm-.68 2.188 5.152 14.753-1.477 3.106-3.492-11.344a.997.997 0 0 0-.98-.703 1.006 1.006 0 0 0-.868.55l-7 14c-.16.321-.136.7.06.997l8 12.21c.218.337.62.505 1.015.434a.995.995 0 0 0 .793-.761l2.48-10.914 1.484 2.433-3.25 14.903-15.968-2.743-1.117-2.797 11.582 2.153a1.001 1.001 0 0 0 1.011-1.543l-8.367-12.48A1.002 1.002 0 0 0 28 27H12a.999.999 0 0 0-.672 1.738L20.414 37h-3.43L5.402 25.953 16.437 14h3.301l-8.476 9.328a.995.995 0 0 0-.176 1.078c.16.36.52.594.914.594h16c.379 0 .727-.215.895-.55l7-14A1 1 0 0 0 35.03 9a.919.919 0 0 0-.254.023l-11.136 2.57 1.093-2.741Zm-6.614 6.265L27.383 23H14.262l8.27-9.094Zm5.625 3.227 3.184 10.36-2.418 10.651-6.395-9.757ZM14.586 29h12.883l6.742 10.063-10.746-1.997Z"
        })
    }));
var $6eacdd29be96605e$export$2e2bcd8739ae039 = $6eacdd29be96605e$var$SvgUnity;





parcelRequire("7fPBF");
const $6506a335d289da77$var$SvgUnrealEngine = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.309 2 2 12.309 2 25s10.309 23 23 23 23-10.309 23-23S37.691 2 25 2Zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4Zm-1.36 6.45c-.074 0-.148.01-.218.027-3.953.941-8.027 3.71-11.09 7.132-3.059 3.426-5.168 7.532-4.7 11.371.056.426.376.774.802.86.421.082.851-.113 1.066-.492 1.953-3.453 3.57-5.364 4.723-6.38 1.152-1.019 1.894-1.109 1.836-1.109.074 0 .093.004.113.004-.024-.023.015-.004.015.246v10.485c0 .12 0 .09.004.078-.128.031-.55.016-.953-.047a1.006 1.006 0 0 0-.992.457.994.994 0 0 0 .016 1.09c3.484 5.195 11.105 5.375 11.105 5.375a.98.98 0 0 0 .778-.32l2.582-2.805 2.382 2.039c.34.289.825.32 1.196.078 2.504-1.621 4.539-3.766 5.968-5.621a22.262 22.262 0 0 0 1.676-2.477c.196-.347.352-.656.469-.93.117-.277.223-.452.223-.882a.997.997 0 0 0-1.738-.672c-1.102 1.211-2.094 1.902-2.84 2.29-.747.382-1.36.444-1.239.444-.09 0-.117-.011-.191-.02v-12.1c0 .19.078-.243.34-.692a19.66 19.66 0 0 1 1.07-1.582c.836-1.137 1.797-2.3 2.285-2.926a1.001 1.001 0 0 0-1.035-1.586c-3.215.844-5.469 2.074-6.93 3.117-1.031.735-1.242 1.051-1.539 1.38-.078-.036-.062-.044-.152-.075-.54-.191-1.324-.371-2.356-.371-.418 0-.789.262-.937.652a1 1 0 0 0 .289 1.106c.586.504 1.297 1.402 1.297 2.136v10.844c-.195.13-.29.207-.66.414-.602.336-1.39.61-1.575.61-.453 0-.777-.11-.914-.2-.132-.09-.128-.074-.128-.214v-13.61a.996.996 0 0 0-1.512-.86c-.078-.194-.188-.667-.188-1.464 0-.375.473-1.23 1.07-1.887.598-.652 1.204-1.117 1.204-1.117.343-.266.48-.715.34-1.125a1.006 1.006 0 0 0-.961-.672Zm-3.308 3.585c-.152.387-.344.754-.344 1.215 0 .957.106 1.66.34 2.23.238.57.688 1.032 1.195 1.2.067.023.102-.016.165-.004v12.508c0 .765.433 1.488 1.019 1.878.59.391 1.285.536 2.023.536 1.008 0 1.836-.465 2.551-.864.715-.398 1.266-.797 1.266-.797.262-.19.418-.492.418-.812V19.73c0-.543-.254-.94-.434-1.382.426.218.95.101 1.246-.278 0 0 .473-.633 1.75-1.539.739-.527 1.82-1.11 3.102-1.672-.078.102-.125.153-.2.254-.44.602-.859 1.203-1.179 1.758-.324.555-.617.969-.617 1.7v12.44c0 .352.129.735.347 1.005.22.265.489.414.723.504.465.18.852.171 1.121.171.36 0 .883-.246 1.356-.421-1.16 1.414-2.653 2.898-4.399 4.136l-2.488-2.129a.997.997 0 0 0-1.387.082l-2.86 3.11c-.585-.047-4.874-.59-7.8-3.2.18-.109.375-.144.52-.328.293-.37.422-.859.422-1.347V22.109c0-.582-.141-1.18-.56-1.625-.413-.449-1.023-.625-1.57-.625h-.003c-.797 0-1.774.391-3.153 1.61-.73.64-1.566 1.57-2.476 2.781.734-1.79 1.894-3.625 3.398-5.305 1.867-2.086 4.176-3.68 6.508-4.91Z"
        })
    }));
var $6506a335d289da77$export$2e2bcd8739ae039 = $6506a335d289da77$var$SvgUnrealEngine;





const $18715178eb9fa0d1$var$SvgComponent = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25s10.31 23 23 23 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S4 36.61 4 25 13.39 4 25 4zm-.066 3L25 9c.624 0 1.247.035 1.855.105l.233-1.986C26.403 7.04 25.7 7 25 7h-.066zm-4.15.496c-.682.164-1.357.369-2.005.608l.692 1.876a15.962 15.962 0 0 1 1.779-.539l-.467-1.945zm10.372.584-.683 1.88c.582.213 1.156.46 1.707.737l.9-1.785a17.717 17.717 0 0 0-1.924-.832zM15.055 9.994c-.577.383-1.141.808-1.674 1.258l1.293 1.525a15.5 15.5 0 0 1 1.484-1.115l-1.103-1.668zm21.511 1.215-1.285 1.531c.475.398.93.829 1.352 1.276l1.455-1.371a17.814 17.814 0 0 0-1.522-1.436zm-26.039 3.088c-.415.559-.8 1.149-1.146 1.752l1.734.996a16.02 16.02 0 0 1 1.02-1.557l-1.608-1.191zM25 14.586l-8.041 8.039 1.416 1.416L24 18.414V35h2V18.414l5.625 5.627 1.416-1.416L25 14.585zm15.586 1.404-1.73 1.002c.308.534.59 1.093.835 1.66l1.834-.795a18.207 18.207 0 0 0-.94-1.867zm-32.852 3.9a17.704 17.704 0 0 0-.474 2.042l1.97.338c.105-.61.247-1.218.422-1.811l-1.918-.568zm34.993 1.967-1.97.348c.108.61.18 1.23.216 1.848l1.996-.116a17.786 17.786 0 0 0-.242-2.08zM9.029 25.98l-1.996.12c.042.696.124 1.394.246 2.077l1.969-.35a16.084 16.084 0 0 1-.219-1.847zm31.733 1.785c-.107.61-.248 1.216-.424 1.808l1.916.57c.198-.664.357-1.35.478-2.035l-1.97-.343zm-30.44 3.615-1.834.797c.277.637.596 1.264.946 1.865l1.728-1.006a15.88 15.88 0 0 1-.84-1.656zM38.87 32.98a16.126 16.126 0 0 1-1.02 1.555l1.604 1.194c.414-.554.8-1.144 1.149-1.749l-1.733-1zm-25.48 3.026-1.451 1.377c.48.507.993.988 1.523 1.431l1.283-1.535a16.09 16.09 0 0 1-1.355-1.273zM35.3 37.242c-.474.4-.974.774-1.489 1.112l1.102 1.67a17.586 17.586 0 0 0 1.676-1.253l-1.29-1.529zM17.85 39.316l-.897 1.79c.621.31 1.269.589 1.924.826l.682-1.881a15.953 15.953 0 0 1-1.71-.735zm12.65.715c-.58.212-1.178.39-1.781.535l.465 1.946c.677-.162 1.35-.365 2.002-.602l-.686-1.879zm-7.324.867-.229 1.987A18.21 18.21 0 0 0 25 43h.033L25 41c-.61 0-1.224-.034-1.824-.102z"
        })
    }));
var $18715178eb9fa0d1$export$2e2bcd8739ae039 = $18715178eb9fa0d1$var$SvgComponent;





parcelRequire("7fPBF");
const $7594f1f4d24bde25$var$SvgUsb2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 2v15c-1.645 0-3 1.355-3 3v17c0 2.75 2.25 5 5 5h4v6h2v-6h4v6h2v-6h4c2.75 0 5-2.25 5-5V20c0-1.645-1.355-3-3-3V2H15zm2 2h16v13H17V4zm2 5v3h4V9h-4zm8 0v3h4V9h-4zM15 19h20c.565 0 1 .435 1 1v17c0 1.668-1.332 3-3 3H17c-1.668 0-3-1.332-3-3V20c0-.565.435-1 1-1z"
        })
    }));
var $7594f1f4d24bde25$export$2e2bcd8739ae039 = $7594f1f4d24bde25$var$SvgUsb2;





parcelRequire("7fPBF");
const $afd76c8e7b7affb8$var$SvgUsbC = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M19 0c-2.75 0-5 2.25-5 5 0 .053.006.104.008.156V14h-.992c-2.75 0-5 2.25-5 5v25.96c0 2.75 2.25 5 5 5H39c2.75 0 5-2.25 5-5V19c0-2.75-2.25-5-5-5h-1V5a1 1 0 0 0-.006-.111C37.934 2.19 35.712 0 33 0H19zm0 2h14c1.668 0 3 1.332 3 3s-1.332 3-3 3H19a2.98 2.98 0 0 1-2.992-2.922V5a1 1 0 0 0-.002-.057A2.982 2.982 0 0 1 19 2zm0 2a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H19zm17 4.97v5.862a1 1 0 0 0 0 .326V19c0 1.117-.883 2-2 2H18.008c-1.117 0-2-.883-2-2v-3.898a1 1 0 0 0 0-.217V8.977A4.948 4.948 0 0 0 19 10h14c1.128 0 2.16-.393 3-1.03zM13.016 16h.992v3c0 2.197 1.802 4 4 4H34c2.197 0 4-1.803 4-4v-3h1c1.668 0 3 1.332 3 3v3.96c0 1.67-1.332 3-3 3H13.016c-1.669 0-3-1.33-3-3V19c0-1.668 1.331-3 3-3zm-3 10.932a4.948 4.948 0 0 0 3 1.029H39c1.128 0 2.16-.393 3-1.03v18.03c0 1.668-1.332 3-3 3H13.016c-1.669 0-3-1.332-3-3V26.93z"
        })
    }));
var $afd76c8e7b7affb8$export$2e2bcd8739ae039 = $afd76c8e7b7affb8$var$SvgUsbC;





parcelRequire("7fPBF");
const $f45133cdb78263ed$var$SvgUsbOff = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M15 2v15c-1.645 0-3 1.355-3 3v17c0 2.75 2.25 5 5 5h4v6h2v-6h4v6h2v-6h4c2.75 0 5-2.25 5-5V20c0-1.645-1.355-3-3-3V2H15zm2 2h16v13H17V4zm2 6v3h4v-3h-4zm8 0v3h4v-3h-4zm-12 9h20c.565 0 1 .435 1 1v17c0 1.668-1.332 3-3 3H17c-1.668 0-3-1.332-3-3V20c0-.565.435-1 1-1zm10 3c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1z"
        })
    }));
var $f45133cdb78263ed$export$2e2bcd8739ae039 = $f45133cdb78263ed$var$SvgUsbOff;





const $121fda4f624e73fb$var$SvgVector = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 505,
        height: 581,
        viewBox: "0 0 505 581",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "url(#Vector_svg__a)",
                d: "M457.684 1500.32c-30.12-243.44-94.261-446.21-131.864-628.43-39.122-202.555-86.469-422.65 73.305-576.105 116.836-115.344 315.292-105.303 457.472-38.511 151.373 81.241 235.493 212.117 137.965 476.192 73.888-97.375 111.808-218.289 97.368-323.135C1045.97 77.757 778.061-1.681 594.512.871c-175.52 2.533-394.476 113.857-497.94 328.182-70.68 146.511-99.608 353.409-24.858 728.307 91.609 459.01 54.045 777.53-62.825 1030.07-1.822 3.75-2.923 7.85-5.032 11.45-5.411 9.67-4.948 18.98 12.726 22.58 2.443.48 4.96 1.17 7.476 1.85 136.433 33.89 273.551 45.83 407.721 37.81 3.835-15.95 70.045-305.05 26.044-661.09l-.14.29Z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                    id: "Vector_svg__a",
                    x1: 459.422,
                    x2: 192.952,
                    y1: 41.475,
                    y2: 633.478,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            stopColor: "#6DB9E7"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.07,
                            stopColor: "#6CA2D7"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.16,
                            stopColor: "#6B8AC6"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.26,
                            stopColor: "#6B79BA"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.37,
                            stopColor: "#6B6FB3"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 0.5,
                            stopColor: "#6B6CB1"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#062844"
                        })
                    ]
                })
            })
        ]
    }));
var $121fda4f624e73fb$export$2e2bcd8739ae039 = $121fda4f624e73fb$var$SvgVector;





const $fa3e65f55eb3500f$var$SvgVirtualApps = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 50 50",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M48 36h-2.561A3.939 3.939 0 0 0 46 34V12c0-2.197-1.803-4-4-4h-4.625v2H42c1.117 0 2 .883 2 2v22c0 1.117-.883 2-2 2H8c-1.117 0-2-.883-2-2V12c0-1.117.883-2 2-2h4V8H8c-2.197 0-4 1.803-4 4v22c0 .731.214 1.408.561 2H2a1 1 0 0 0-1 1c0 2.75 2.25 5 5 5h38c2.75 0 5-2.25 5-5a1 1 0 0 0-1-1zm-4 4H6c-1.276 0-2.151-.888-2.588-2h43.176c-.437 1.112-1.312 2-2.588 2z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M24 28h2v6h-2zM35.734 7.419a2.39 2.39 0 0 0-1.213-1.259l-8.196-3.864a3.102 3.102 0 0 0-2.654.001L15.476 6.16A2.578 2.578 0 0 0 14 8.485v10.601c0 .959.529 1.831 1.38 2.276l8.177 4.283c.444.232.943.355 1.443.355.499 0 .998-.123 1.444-.355l8.174-4.281a2.562 2.562 0 0 0 1.381-2.277V9.493L36 9.329c.002-.596.005-1.27-.266-1.91zM24.523 4.106a1.117 1.117 0 0 1 .951-.001l7.818 3.686-8.295 4.094-8.347-4.068 7.873-3.711zm-8.216 15.485a.571.571 0 0 1-.307-.505V9.725l8 3.901v9.995l-7.693-4.03zm17.384 0L26 23.619v-9.997l8-3.95-.001 9.414a.568.568 0 0 1-.308.505z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "m32.627 32.936-2.549-2.509V26h2v3.589l1.951 1.921zM17.452 32.936l-1.404-1.426L18 29.589V26h2v4.427z"
            })
        ]
    }));
var $fa3e65f55eb3500f$export$2e2bcd8739ae039 = $fa3e65f55eb3500f$var$SvgVirtualApps;





parcelRequire("7fPBF");
const $faa4b1f11be8231d$var$SvgVirtualButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M30 22.85A5.85 5.85 0 0 1 35.85 17h28.8a5.85 5.85 0 0 1 5.85 5.85v54a5.85 5.85 0 0 1-5.85 5.85h-28.8A5.85 5.85 0 0 1 30 76.85v-54Zm5.85-3.15a3.15 3.15 0 0 0-3.15 3.15v54A3.15 3.15 0 0 0 35.85 80h28.8a3.15 3.15 0 0 0 3.15-3.15v-54a3.15 3.15 0 0 0-3.15-3.15h-28.8Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                d: "M36.75 33.65a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM36.75 48.05a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM36.75 62.45a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM52.05 33.65a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM52.05 48.05a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1ZM52.05 62.45a1.8 1.8 0 0 1 1.8-1.8h8.1a1.8 1.8 0 0 1 1.8 1.8v8.1a1.8 1.8 0 0 1-1.8 1.8h-8.1a1.8 1.8 0 0 1-1.8-1.8v-8.1Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M43.95 22.85h12.6v2.7h-12.6v-2.7Z"
            })
        ]
    }));
var $faa4b1f11be8231d$export$2e2bcd8739ae039 = $faa4b1f11be8231d$var$SvgVirtualButton;





parcelRequire("7fPBF");
const $24e6d56f54bae8bf$var$SvgVirtualReality = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M10 8c-2.547 0-4.668 1.938-4.969 4.406C3.254 13.176 2 14.95 2 17v20c0 2.75 2.25 5 5 5h11.375a4.993 4.993 0 0 0 4.563-3h4.125a4.993 4.993 0 0 0 4.562 3H43c2.75 0 5-2.25 5-5V17c0-2.05-1.254-3.824-3.031-4.594C44.668 9.937 42.547 8 40 8Zm0 2h30c1.32 0 2.438.828 2.844 2H7.156A2.992 2.992 0 0 1 10 10Zm-3 4h36c1.668 0 3 1.332 3 3v20c0 1.668-1.332 3-3 3H31.625a2.977 2.977 0 0 1-2.75-1.812l-1.562-3.657A2.528 2.528 0 0 0 25 33c-1.004 0-1.918.61-2.312 1.531l-1.563 3.657A2.977 2.977 0 0 1 18.375 40H7c-1.668 0-3-1.332-3-3V17c0-1.668 1.332-3 3-3Zm7.5 7C10.922 21 8 23.922 8 27.5s2.922 6.5 6.5 6.5 6.5-2.922 6.5-6.5-2.922-6.5-6.5-6.5Zm21 0c-3.578 0-6.5 2.922-6.5 6.5s2.922 6.5 6.5 6.5 6.5-2.922 6.5-6.5-2.922-6.5-6.5-6.5Zm-21 2c2.496 0 4.5 2.004 4.5 4.5S16.996 32 14.5 32a4.486 4.486 0 0 1-4.5-4.5c0-2.496 2.004-4.5 4.5-4.5Zm21 0c2.496 0 4.5 2.004 4.5 4.5S37.996 32 35.5 32a4.486 4.486 0 0 1-4.5-4.5c0-2.496 2.004-4.5 4.5-4.5ZM25 35c.21 0 .387.121.469.313L26.187 37h-2.375l.72-1.687A.502.502 0 0 1 25 35Z"
        })
    }));
var $24e6d56f54bae8bf$export$2e2bcd8739ae039 = $24e6d56f54bae8bf$var$SvgVirtualReality;





parcelRequire("7fPBF");
const $00343718cdb9cc97$var$SvgVisualStudio = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M35.5 2a2.5 2.5 0 0 0-1.668.639 4.685 4.685 0 0 0-.125.127l-.137.154-.504.559-1.763 1.97c-1.455 1.625-3.386 3.785-5.315 5.942l-7.068 7.906-5.13-4.166-3.23-2.623-.915-.746-.247-.201-.056-.045-.002-.002h-.002A2.011 2.011 0 0 0 8 11c-.389 0-.493.079-.691.15a9.876 9.876 0 0 0-.649.268c-.472.21-1.022.481-1.555.75-1.065.538-2.056 1.072-2.056 1.072l.006.012A2.007 2.007 0 0 0 2 15v21c0 .784.47 1.466 1.137 1.793l-.004.008s.918.468 1.885.955c.483.243.979.491 1.378.69.4.197.623.314.854.408.23.093.487.146.75.146.352 0 .692-.096.984-.262l.002.002.104-.068.023-.016c.01-.007.014-.013.02-.017l.033-.026.098-.08.345-.287a6851.457 6851.457 0 0 0 4.863-4.066l4.58-3.834A39683.096 39683.096 0 0 0 32.435 45.86l.97 1.05.266.286.078.08c.02.022-.043-.029.088.088l.002.002c.44.393 1.03.633 1.662.633.37 0 .721-.088 1.04-.236l.003.007s2.405-1.244 4.846-2.51c1.22-.632 2.45-1.27 3.392-1.761.472-.245.872-.455 1.164-.607.292-.153.41-.211.543-.288A3.006 3.006 0 0 0 48 40V10a3.003 3.003 0 0 0-1.322-2.486c-.136-.092-.15-.091-.244-.143a194.527 194.527 0 0 0-1.549-.82A1057.4 1057.4 0 0 0 41.46 4.77C39 3.495 36.586 2.249 36.584 2.248h-.002A2.506 2.506 0 0 0 35.5 2zm0 2c.11 0 .198.03.28.084A.49.49 0 0 1 36 4.5v10.033l-11.291 9.465-1.182-.959-3.052-2.478A16164.07 16164.07 0 0 1 32.793 6.78l1.764-1.967c.214-.238.381-.427.498-.556l.12-.135A.482.482 0 0 1 35.5 4zM38 5.232c.922.477 1.26.649 2.541 1.313 1.229.637 2.468 1.282 3.418 1.78a198.057 198.057 0 0 1 1.514.8c.082.045.18.11.084.045h.002v.002c.265.18.441.476.441.828v30c0 .38-.204.697-.506.87.06-.036-.187.1-.476.251l-1.159.604c-.941.49-2.172 1.129-3.392 1.761L38 44.764V5.232zM8.027 13.023l.036.03.068.056.25.204.916.746 3.23 2.625 9.74 7.908L36 35.738V45.5a.482.482 0 0 1-.252.43l-.07.037A.524.524 0 0 1 35.5 46a.48.48 0 0 1-.326-.123l-.043-.047-.262-.281-.967-1.045-3.402-3.688c-2.804-3.04-6.526-7.079-10.244-11.115-3.719-4.036-7.433-8.07-10.225-11.097-1.395-1.515-2.56-2.778-3.379-3.665l-.826-.892c.091-.047.087-.047.18-.094a36.69 36.69 0 0 1 1.469-.709c.21-.093.393-.168.515-.213.016-.005.022-.004.037-.008zM4 15.018l.23.248c.221.238.545.586.954 1.029L7 18.265v14.376l-2.996 3.353C4.002 35.997 4.002 36 4 36V15.018zm32 2.125v16.02l-9.709-7.882L36 17.143zM9 20.436l4.52 4.906L9 30.4v-9.964zm5.88 6.382c.987 1.07 1.794 1.949 2.815 3.057l-4.506 3.771c-1.325 1.11-2.651 2.219-3.65 3.053L8.33 37.71l-.342.283-.002.002c.032.012-.318-.151-.703-.342-.392-.194-.884-.439-1.365-.681l-.072-.037 9.035-10.116zM8.01 37.994l.46.824-.472-.816L8 38l.01-.006z"
        })
    }));
var $00343718cdb9cc97$export$2e2bcd8739ae039 = $00343718cdb9cc97$var$SvgVisualStudio;





parcelRequire("7fPBF");
const $33b5e9a8ed1b53a5$var$SvgVoice = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 90 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M80.088 44.766a1.784 1.784 0 0 1 2.347.927C90.33 63.915 78.85 78.52 72.238 83.512a1.784 1.784 0 0 1-2.15-2.849c5.995-4.524 16.021-17.515 9.073-33.55a1.784 1.784 0 0 1 .927-2.347Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M48.62 17.652a1.284 1.284 0 0 1 2.554.264c-.333 3.221.427 11.087 6.032 16.424 1.587 1.512 2.53 2.973 2.756 4.411.24 1.528-.367 2.774-1.3 3.684-.893.87-2.108 1.468-3.286 1.877-.687.238-1.397.424-2.084.564l-.381.077-.248 4.96a2.544 2.544 0 0 1-2.377 2.412l-9.392.606-.128.255a2.46 2.46 0 0 0-.125 1.972c.397 1.106 1.782 2.729 5.786 4.247l.094.036.088.05c.481.276.733.724.809 1.171a2.5 2.5 0 0 1-.044.933c-.052.24-.13.5-.2.733l-.032.105v.003c-.065.213-.13.428-.195.666-.292 1.073-.544 2.5-.087 4.33.423 1.69.314 3.834-.405 5.683-.726 1.866-2.164 3.625-4.514 4.095-1.065.213-3.077.27-5.504.111a52.624 52.624 0 0 1-8.56-1.28c-6.095-1.445-12.876-4.314-16.19-9.772a1.284 1.284 0 0 1 2.195-1.333c2.752 4.532 8.64 7.195 14.588 8.605a50.067 50.067 0 0 0 8.134 1.217c2.38.155 4.114.077 4.833-.067 1.215-.243 2.099-1.156 2.624-2.507.53-1.362.599-2.965.308-4.13-.602-2.406-.259-4.31.1-5.627.048-.177.097-.345.143-.5l.127-.424-.406-.177c-3.517-1.532-5.411-3.356-6.11-5.3-.79-2.198.092-4.132 1.098-5.215l.348-.375 10.43-.673.354-7.077 1.078-.127c.936-.11 2.013-.33 3.003-.674 1.008-.35 1.824-.792 2.335-1.29.223-.217.391-.443.487-.697.099-.261.106-.511.068-.75-.098-.628-.58-1.605-1.99-2.948-6.385-6.082-7.195-14.869-6.815-18.548Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M57.636 52.088a1.784 1.784 0 0 1 2.489.415c2.51 3.514 2.493 6.846 1.234 9.53-1.19 2.534-3.397 4.314-5.048 5.209a1.784 1.784 0 0 1-1.7-3.138c1.204-.652 2.745-1.942 3.517-3.588.703-1.497.865-3.459-.907-5.94a1.784 1.784 0 0 1 .415-2.488ZM69.444 47.952a1.784 1.784 0 0 1 2.31 1.014c4.98 12.762-2.88 22.648-7.378 25.99a1.784 1.784 0 0 1-2.128-2.865c3.828-2.844 10.337-11.18 6.182-21.828a1.784 1.784 0 0 1 1.014-2.31Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $33b5e9a8ed1b53a5$export$2e2bcd8739ae039 = $33b5e9a8ed1b53a5$var$SvgVoice;





parcelRequire("7fPBF");
const $acd55902513cc2be$var$SvgVoiceControl = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M80.088 44.766a1.784 1.784 0 0 1 2.347.927C90.33 63.915 78.85 78.52 72.238 83.512a1.784 1.784 0 0 1-2.15-2.849c5.995-4.524 16.021-17.515 9.073-33.55a1.784 1.784 0 0 1 .927-2.347Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M48.62 17.652a1.284 1.284 0 0 1 2.554.264c-.333 3.221.427 11.087 6.032 16.424 1.587 1.512 2.53 2.973 2.756 4.411.24 1.528-.367 2.774-1.3 3.684-.893.87-2.108 1.468-3.286 1.877-.687.238-1.397.424-2.084.564l-.381.077-.248 4.96a2.544 2.544 0 0 1-2.377 2.412l-9.392.606-.128.255a2.46 2.46 0 0 0-.125 1.972c.397 1.106 1.782 2.729 5.786 4.247l.094.036.088.05c.481.276.733.724.809 1.171a2.5 2.5 0 0 1-.044.933c-.052.24-.13.5-.2.733l-.032.105v.003c-.065.213-.13.428-.195.666-.292 1.073-.544 2.5-.087 4.33.423 1.69.314 3.834-.405 5.683-.726 1.866-2.164 3.625-4.514 4.095-1.065.213-3.077.27-5.504.111a52.624 52.624 0 0 1-8.56-1.28c-6.095-1.445-12.876-4.314-16.19-9.772a1.284 1.284 0 0 1 2.195-1.333c2.752 4.532 8.64 7.195 14.588 8.605a50.067 50.067 0 0 0 8.134 1.217c2.38.155 4.114.077 4.833-.067 1.215-.243 2.099-1.156 2.624-2.507.53-1.362.599-2.965.308-4.13-.602-2.406-.259-4.31.1-5.627.048-.177.097-.345.143-.5l.127-.424-.406-.177c-3.517-1.532-5.411-3.356-6.11-5.3-.79-2.198.092-4.132 1.098-5.215l.348-.375 10.43-.673.354-7.077 1.078-.127c.936-.11 2.013-.33 3.003-.674 1.008-.35 1.824-.792 2.335-1.29.223-.217.391-.443.487-.697.099-.261.106-.511.068-.75-.098-.628-.58-1.605-1.99-2.948-6.385-6.082-7.195-14.869-6.815-18.548Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "#E51546",
                fillRule: "evenodd",
                d: "M57.636 52.088a1.784 1.784 0 0 1 2.489.415c2.51 3.514 2.493 6.846 1.234 9.53-1.19 2.534-3.397 4.314-5.048 5.209a1.784 1.784 0 0 1-1.7-3.138c1.204-.652 2.745-1.942 3.517-3.588.703-1.497.865-3.459-.907-5.94a1.784 1.784 0 0 1 .415-2.488ZM69.444 47.952a1.784 1.784 0 0 1 2.31 1.014c4.98 12.762-2.88 22.648-7.378 25.99a1.784 1.784 0 0 1-2.128-2.865c3.828-2.844 10.337-11.18 6.182-21.828a1.784 1.784 0 0 1 1.014-2.31Z",
                clipRule: "evenodd"
            })
        ]
    }));
var $acd55902513cc2be$export$2e2bcd8739ae039 = $acd55902513cc2be$var$SvgVoiceControl;





parcelRequire("7fPBF");
const $34aed62813af1122$var$SvgVoiceMemos = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 3C7.489 3 3 7.489 3 13v24c0 5.511 4.489 10 10 10h24c5.511 0 10-4.489 10-10V13c0-5.511-4.489-10-10-10H13zm0 2h24c4.43 0 8 3.57 8 8v24c0 4.43-3.57 8-8 8H13c-4.43 0-8-3.57-8-8V13c0-4.43 3.57-8 8-8zm15 2a2 2 0 0 0-1 3.73v28.54A2 2 0 0 0 28 43a2 2 0 0 0 1-3.73V10.73A2 2 0 0 0 28 7zm-9.016 3.986A1 1 0 0 0 18 12v26a1 1 0 1 0 2 0V12a1 1 0 0 0-1.016-1.014zm3 3A1 1 0 0 0 21 15v20a1 1 0 1 0 2 0V15a1 1 0 0 0-1.016-1.014zm-6 1A1 1 0 0 0 15 16v18a1 1 0 1 0 2 0V16a1 1 0 0 0-1.016-1.014zm9 3A1 1 0 0 0 24 19v12a1 1 0 1 0 2 0V19a1 1 0 0 0-1.016-1.014zm-12 1A1 1 0 0 0 12 20v10a1 1 0 1 0 2 0V20a1 1 0 0 0-1.016-1.014zm18 0A1 1 0 0 0 30 20v10a1 1 0 1 0 2 0V20a1 1 0 0 0-1.016-1.014zm-21 3A1 1 0 0 0 9 23v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1.016-1.014zm24 0A1 1 0 0 0 33 23v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1.016-1.014zm6 1A1 1 0 0 0 39 24v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1.016-1.014zm-33 .5A1 1 0 0 0 6 24.5v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014zm30 0A1 1 0 0 0 36 24.5v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014zm6 0A1 1 0 0 0 42 24.5v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1.016-1.014z"
        })
    }));
var $34aed62813af1122$export$2e2bcd8739ae039 = $34aed62813af1122$var$SvgVoiceMemos;





parcelRequire("7fPBF");
const $c3ac36ea1b4137a8$var$SvgWaze = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 3.99c-5.511 0-10 4.489-10 10v22c0 5.512 4.489 10 10 10h22c5.511 0 10-4.488 10-10v-22c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8v-22c0-4.43 3.57-8 8-8zM25.969 13c-6.093 0-11.033 5.073-11.032 11.277 0 .734-.025 1.746-.255 2.436-.115.345-.267.587-.432.73-.165.143-.348.239-.76.239a1 1 0 0 0-.922 1.386c1.047 2.486 2.73 4.177 4.946 5.166A3 3 0 0 0 20.5 37a3 3 0 0 0 2.617-1.541 1 1 0 0 0 .084.008c.872.061 1.797.086 2.768.086.156 0 .31-.011.465-.018A2.99 2.99 0 0 0 29 37c1.656 0 3-1.344 3-3 0-.097-.014-.19-.023-.285A11.318 11.318 0 0 0 37 24.277C37 18.073 32.061 13 25.969 13zm0 2C30.954 15 35 19.128 35 24.277c0 3.401-1.772 6.355-4.406 7.971a1 1 0 0 0-.002 0c-.463.284-.96.513-1.47.709l-.876.283c-.524.14-1.06.247-1.617.287a1 1 0 0 0-.01 0 7.822 7.822 0 0 1-.65.026c-.9 0-1.737-.025-2.52-.076A3 3 0 0 0 20.5 31a3 3 0 0 0-2.447 1.271c-1.336-.681-2.292-1.704-3.073-3.113.177-.096.432-.076.579-.203.523-.453.83-1.037 1.021-1.61.382-1.145.358-2.334.358-3.068-.001-5.149 4.045-9.277 9.03-9.277zm-2.043 5a1.223 1.223 0 1 0 0 2.445 1.223 1.223 0 1 0 0-2.445zm6.851 0a1.223 1.223 0 1 0 0 2.445 1.223 1.223 0 1 0 0-2.445zm-7.05 5.22a1 1 0 0 0-.875 1.42s1.347 2.796 4.584 2.796c3.236 0 4.584-2.795 4.584-2.795a1 1 0 0 0-1.829-.813s-.61 1.608-2.755 1.608c-2.146 0-2.756-1.608-2.756-1.608a1 1 0 0 0-.953-.607z"
        })
    }));
var $c3ac36ea1b4137a8$export$2e2bcd8739ae039 = $c3ac36ea1b4137a8$var$SvgWaze;





parcelRequire("7fPBF");
const $0a85044c5feaf17c$var$SvgWeather = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm0 2h22c4.43 0 8 3.57 8 8v22c0 4.43-3.57 8-8 8H14c-4.43 0-8-3.57-8-8V14c0-4.43 3.57-8 8-8zm18 7c-3.168 0-5.906 1.858-7.2 4.543A7.696 7.696 0 0 0 22 17c-3.877 0-7.036 2.81-7.76 6.484-2.458.928-4.24 3.242-4.24 6.016 0 3.218 2.384 5.838 5.467 6.346A1 1 0 0 0 16 36h13c3.854 0 7-3.146 7-7 0-.35-.035-.691-.086-1.027A8.003 8.003 0 0 0 40 21c0-4.406-3.594-8-8-8zm0 2c3.326 0 6 2.674 6 6a5.978 5.978 0 0 1-2.697 4.998 7.032 7.032 0 0 0-5.951-3.928 8.19 8.19 0 0 0-2.793-3.586A5.99 5.99 0 0 1 32 15zm-10 4a5.99 5.99 0 0 1 5.75 4.299 1 1 0 0 0 1.012.715c.132-.007.208-.014.238-.014 2.774 0 5 2.226 5 5s-2.226 5-5 5H16.887l.103.855a1 1 0 0 0-.902-.876A4.488 4.488 0 0 1 12 29.5a4.49 4.49 0 0 1 3.313-4.336 1 1 0 0 0 .73-.852A5.987 5.987 0 0 1 22 19z"
        })
    }));
var $0a85044c5feaf17c$export$2e2bcd8739ae039 = $0a85044c5feaf17c$var$SvgWeather;





parcelRequire("7fPBF");
const $b62ebb210c573784$var$SvgWechat = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M19 6C9.746 6 2 12.36 2 20.5c0 4.395 2.293 8.18 5.836 10.824l-2.656 7.98 8.293-5.136c1.714.539 3.609.832 5.527.832.746 0 1.473-.055 2.195-.137C23.38 39.105 28.328 42 34 42c1.723 0 3.316-.324 4.797-.766l6.848 3.832-1.91-6.55C46.312 36.375 48 33.395 48 30c0-6.21-5.402-11.164-12.25-11.895C34.398 11.125 27.324 6 19 6Zm0 2c7.309 0 13.328 4.352 14.703 10.012C26.183 18.148 20 23.355 20 30c0 1.02.16 2.004.438 2.941-.473.04-.954.059-1.438.059-1.898 0-3.8-.29-5.367-.844l-.45-.156-4.363 2.7 1.367-4.106-.624-.422C6.082 27.82 4 24.445 4 20.5 4 13.64 10.656 8 19 8Zm-6 6c-1.102 0-2 .898-2 2 0 1.102.898 2 2 2 1.102 0 2-.898 2-2 0-1.102-.898-2-2-2Zm12 0c-1.102 0-2 .898-2 2 0 1.102.898 2 2 2 1.102 0 2-.898 2-2 0-1.102-.898-2-2-2Zm9 6c6.746 0 12 4.535 12 10 0 2.957-1.508 5.55-3.996 7.395l-.559.417.91 3.122-3.25-1.825-.421.141c-1.399.469-2.996.75-4.684.75-6.746 0-12-4.535-12-10s5.254-10 12-10Zm-4.5 6c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5Zm9 0c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5Z"
        })
    }));
var $b62ebb210c573784$export$2e2bcd8739ae039 = $b62ebb210c573784$var$SvgWechat;





parcelRequire("7fPBF");
const $af66a6393cd41f93$var$SvgWellsfargo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13 4c-4.962 0-9 4.037-9 9v24c0 4.963 4.038 9 9 9h24c4.962 0 9-4.037 9-9V13c0-4.963-4.038-9-9-9H13zm0 2h24c3.86 0 7 3.141 7 7v24c0 3.859-3.14 7-7 7H13c-3.86 0-7-3.141-7-7V13c0-3.859 3.14-7 7-7zm25.002 10.84c-1.509 0-2.48.724-2.48 1.889 0 .9.565 1.56 1.65 1.798l1.121.248c.715.16.978.44.978.909 0 .574-.431.89-1.296.89-.98 0-1.483-.388-1.704-1.129l-.115-.379h-.635v1.73a5.497 5.497 0 0 0 2.604.573c1.482 0 2.453-.74 2.453-1.896 0-.972-.592-1.643-1.703-1.899l-1.121-.256c-.653-.15-.926-.406-.926-.838 0-.52.416-.845 1.227-.845.81 0 1.286.29 1.472.978l.08.3h.635v-1.526a4.93 4.93 0 0 0-2.24-.547zm-28.842.176v.767h.707l1.553 5.41h1.226l1.288-4.482 1.254 4.482h1.224l1.545-5.41h1.217v4.643h-.75v.767h5.303v-2.109h-.635l-.072.31c-.177.786-.432 1.032-1.006 1.032h-1.526v-1.914h1.774a.926.926 0 0 0 .097-.442.877.877 0 0 0-.097-.424h-1.774v-1.863h1.465c.591 0 .794.257.988.998l.063.239h.635v-2.004h-7.483v.767h.865l-1.013 3.733-1.264-4.5h-1.27l-1.234 4.492-1.033-3.725h.83v-.767H9.16zm15.21 0v.767h.75v4.64h-.75v.768h5.003v-2.109h-.635l-.07.31c-.177.786-.426 1.032-1.008 1.032h-1.224v-4.64h.837v-.768H24.37zm5.558 0v.767h.75v4.64h-.75v.768h5.004v-2.109h-.635l-.072.31c-.176.786-.424 1.032-1.006 1.032h-1.227v-4.64h.838v-.768h-2.902zm.638 9.466c-1.94 0-3.246 1.299-3.246 3.284 0 1.994 1.27 3.263 3.246 3.263a5.553 5.553 0 0 0 2.471-.652v-2.754H30.69a.828.828 0 0 0-.095.414c-.006.15.026.3.095.434h1.051v1.56c-.33.136-.684.205-1.04.203-1.27 0-1.932-.908-1.932-2.478 0-1.57.66-2.479 1.86-2.479a1.532 1.532 0 0 1 1.546 1.084l.096.248h.634v-1.58a5.159 5.159 0 0 0-2.338-.547zm6.567.002a3.28 3.28 0 0 0-3.281 3.272 3.28 3.28 0 0 0 6.562 0 3.28 3.28 0 0 0-3.281-3.272zm-27.178.192v.767h.75v4.643h-.75v.768h2.947v-.768h-.882v-1.8h1.818a.926.926 0 0 0 .098-.442.88.88 0 0 0-.098-.424H12.02v-1.977h1.57c.59 0 .794.257.988.998l.063.239h.634v-2.004h-5.32zm7.227.002-2.162 5.408h-.62v.768h2.338v-.768h-.74l.406-1.104h2.293l.407 1.104h-.723v.768h5.549v-.768h-.838v-1.879h.484c.971 0 1.263.343 1.37 1.234l.034.311c.097.82.512 1.172 1.368 1.172.23 0 .46-.013.687-.043a.865.865 0 0 0 0-.725 1.042 1.042 0 0 1-.185.018c-.406 0-.512-.23-.565-.742l-.035-.327c-.08-.697-.406-1.147-1.209-1.209v-.025c.794-.036 1.615-.565 1.615-1.562 0-1.006-.82-1.631-2.082-1.631h-3.547v.767h.75v4.64h-1.216l-2.207-5.407h-1.172zm19.95.607c1.192 0 1.837.909 1.837 2.47 0 1.57-.636 2.472-1.836 2.472-1.2 0-1.834-.901-1.834-2.471 0-1.561.643-2.47 1.834-2.47zm-14.04.158h1.04c.795 0 1.192.345 1.192.989 0 .636-.406.998-1.191.998h-1.041v-1.987zm-5.541.452.865 2.337h-1.73l.865-2.337z"
        })
    }));
var $af66a6393cd41f93$export$2e2bcd8739ae039 = $af66a6393cd41f93$var$SvgWellsfargo;





parcelRequire("7fPBF");
const $b418400b3516f49e$var$SvgWhatsapp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M25 2C12.31 2 2 12.31 2 25c0 4.08 1.119 7.886 2.984 11.209L2.037 46.73a1 1 0 0 0 1.203 1.24l10.97-2.718C17.436 46.972 21.094 48 25 48c12.69 0 23-10.31 23-23S37.69 2 25 2zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21c-3.722 0-7.208-.97-10.238-2.666a1 1 0 0 0-.729-.098l-9.607 2.381 2.576-9.191a1 1 0 0 0-.1-.78A20.88 20.88 0 0 1 4 25C4 13.39 13.39 4 25 4zm-8.357 9c-.641 0-1.557.238-2.309 1.049-.452.487-2.334 2.32-2.334 5.545 0 3.361 2.331 6.262 2.613 6.635h.002v.001a31.669 31.669 0 0 0 3.004 3.684c1.804 1.899 4.34 4.093 7.486 5.436 1.45.617 2.593.99 3.46 1.261 1.605.504 3.067.428 4.165.266.823-.121 1.727-.516 2.622-1.082.894-.566 1.771-1.27 2.158-2.34a8.25 8.25 0 0 0 .469-2.059 4.72 4.72 0 0 0 .01-.787c-.02-.238 0-.42-.221-.785-.466-.764-.993-.784-1.543-1.056a183.29 183.29 0 0 0-2.05-.993c-.871-.415-1.626-.783-2.091-.949-.294-.106-.652-.258-1.17-.199-.517.059-1.029.432-1.326.873-.282.418-1.418 1.758-1.764 2.152-.004-.002.026.011-.111-.056-.428-.212-.952-.392-1.727-.801a14.283 14.283 0 0 1-2.804-1.947v-.002c-1.579-1.39-2.685-3.135-3.034-3.721.024-.028-.002.006.047-.043l.002-.002c.357-.351.673-.77.94-1.078.378-.436.545-.82.726-1.18.361-.716.16-1.503-.049-1.918v-.002c.015.029-.112-.252-.25-.576l-.5-1.195c-.374-.898-.792-1.906-1.04-2.496v-.002c-.293-.695-.69-1.196-1.208-1.438-.518-.241-.975-.173-.994-.174h-.002A26.2 26.2 0 0 0 16.643 13zm0 2c.385 0 .765.005 1.084.02.327.016.307.017.244-.012-.064-.03.023-.04.209.402.243.578.663 1.59 1.039 2.49.188.451.363.874.504 1.205.14.332.216.517.304.694v.002l.002.002c.087.17.08.061.05.12-.212.42-.24.522-.454.768-.325.375-.657.792-.832.965-.154.151-.43.386-.604.846-.173.46-.092 1.093.186 1.564.37.629 1.59 2.613 3.484 4.282a16.35 16.35 0 0 0 3.194 2.216c.888.469 1.611.743 1.773.823.385.19.805.338 1.293.279.489-.059.91-.355 1.178-.658l.002-.002c.357-.405 1.417-1.615 1.926-2.361.021.007.014.001.183.062v.002h.002c.077.027 1.044.46 1.906.871.863.41 1.738.838 2.022.979.41.203.604.335.654.336a2.35 2.35 0 0 1-.006.328 6.365 6.365 0 0 1-.357 1.552c-.105.292-.654.893-1.346 1.33-.692.438-1.534.748-1.846.793-.937.139-2.05.189-3.273-.195a33.421 33.421 0 0 1-3.273-1.193c-2.776-1.184-5.135-3.198-6.82-4.973a29.716 29.716 0 0 1-1.999-2.338c-.48-.623-.688-.948-.863-1.178l-.002-.001c-.31-.41-2.207-3.05-2.207-5.426 0-2.516 1.168-3.503 1.8-4.184.333-.358.696-.41.843-.41z"
        })
    }));
var $b418400b3516f49e$export$2e2bcd8739ae039 = $b418400b3516f49e$var$SvgWhatsapp;





parcelRequire("7fPBF");
const $d752c8bed9966dc3$var$SvgWindows11 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M4 4v20h20V4H4zm22 0v20h20V4H26zM6 6h16v16H6V6zm22 0h16v16H28V6zM4 26v20h20V26H4zm22 0v20h20V26H26zM6 28h16v16H6V28zm22 0h16v16H28V28z"
        })
    }));
var $d752c8bed9966dc3$export$2e2bcd8739ae039 = $d752c8bed9966dc3$var$SvgWindows11;





const $cbdf5641ddee00a3$var$SvgWindowsXp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        viewBox: "0 0 100 100",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M37.172 6.137c-1.732.02-3.342.194-4.805.465-5.85 1.082-9.539 3.726-9.539 3.726a2 2 0 0 0-.773 1.164l-6.477 27.543a2 2 0 0 0 2.426 2.399c6.85-1.698 17.135-2.465 27.773 3.48a2.002 2.002 0 0 0 2.914-1.25l7.594-29.77a2 2 0 0 0-.863-2.18c-6.756-4.307-13.054-5.637-18.25-5.577m.047 3.98a25 25 0 0 1 4.785.39c3.033.54 6.421 1.836 10.016 3.934l-6.633 26c-9.445-4.52-18.412-4.651-25.223-3.433l5.586-23.762c.681-.45 3.016-1.914 7.344-2.715a25 25 0 0 1 4.125-.414m24.062 6.274a2 2 0 0 0-1.89 1.504L51.844 47.48a2 2 0 0 0 .77 2.117c13.308 9.562 26.952 6.189 32.628 4.023a2 2 0 0 0 1.235-1.41l7.468-31.754a2 2 0 0 0-3.12-2.074s-2.933 2.143-8.016 3.074c-5.084.93-12.132.626-20.387-4.742a2 2 0 0 0-1.14-.324m1.364 4.937c8.118 4.51 15.502 5.048 20.882 4.063 2.344-.43 4.017-1.151 5.579-1.817l-6.258 26.594c-5.207 1.833-15.816 3.925-26.739-3.234zM27.434 44.242c-5.486.038-10.037 1.365-12.743 2.399a2 2 0 0 0-1.234 1.41L6.055 79.543A2 2 0 0 0 6 80v.09a2 2 0 0 0 3.172 1.62s2.755-2.005 7.574-2.968 11.514-.849 19.387 3.793a2 2 0 0 0 2.957-1.23l7.535-29.543a2 2 0 0 0-.855-2.18c-6.431-4.126-12.851-5.377-18.336-5.34m-.075 3.985c4.482-.044 9.698 1.11 14.98 4.156L35.81 77.98c-7.759-3.87-14.76-4.177-19.848-3.16-2.14.427-3.637 1.092-5.09 1.71l6.219-26.445c2.432-.855 5.925-1.817 10.27-1.86m24.239 5.937a2 2 0 0 0-1.84 1.504L42.21 85.234a2 2 0 0 0 .793 2.133c9.362 6.54 17.96 7.264 24.117 6.23s10.05-3.84 10.05-3.84A2 2 0 0 0 78 88.232v-.004l6.356-27a2 2 0 0 0-2.43-2.399 40.7 40.7 0 0 1-9.77 1.215c-5.849 0-12.57-1.363-19.414-5.582a2 2 0 0 0-1.144-.297m1.46 4.746c6.692 3.551 13.321 5.133 19.098 5.133 2.895 0 5.251-.507 7.649-.95l-5.59 23.77c-.724.479-3.201 2.025-7.754 2.79-5.04.846-11.964.304-19.996-4.9z"
        })
    }));
var $cbdf5641ddee00a3$export$2e2bcd8739ae039 = $cbdf5641ddee00a3$var$SvgWindowsXp;





parcelRequire("7fPBF");
const $e1fdb89e8a7f1773$var$SvgXfinity = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M13.373 16.637c-1.566 0-2.5 1.025-2.5 2.734l-.002.879h-.965l-1.117 1.6h2.084v7.8h2.045v-7.8h2.086v-1.6h-2.086v-.91c0-.688.286-.967.98-.967.4 0 .813.078 1.106.158v-1.646c-.42-.15-1.001-.248-1.631-.248zm24.15.42-2.039 1.039v2.156h-1.488v1.598h1.488v5.254c0 1.715.933 2.73 2.495 2.73.518 0 1.033-.063 1.423-.184l.248-1.63a4.229 4.229 0 0 1-.923.132c-.851 0-1.202-.34-1.202-1.187V21.85h2.35l-.611-1.598h-1.74v-3.195zm-12.546 3.006c-.962 0-1.88.405-2.356 1.037v-.85h-2.045v9.4h2.045v-5.486c0-1.524.659-2.365 1.858-2.365 1.3 0 1.857.76 1.857 2.543v5.308h2.039v-5.38c.001-2.754-1.17-4.207-3.398-4.207zM.225 20.25l3.193 4.537L0 29.65h2.346l2.2-3.218 4.57 6.533h2.251L5.67 24.787l3.195-4.537H6.521l-1.974 2.893L2.57 20.25H.225zm16.123 0v9.4h2.045v-9.4h-2.045zm14.119 0v9.4h2.053v-9.4h-2.053zm9.683 0 3.15 8.195-2.437 4.52h2.158L50 20.25h-2.207l-3.28 5.99-2.243-5.99h-2.12z"
        })
    }));
var $e1fdb89e8a7f1773$export$2e2bcd8739ae039 = $e1fdb89e8a7f1773$var$SvgXfinity;





parcelRequire("7fPBF");
const $9d8b2252c9d0cc9d$var$SvgYelp = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M21.61 2C18.933 2 12.8 3.813 11.5 5.156c-.48.457-.602 1.145-.48 1.602.238.457 9.968 15.222 9.968 15.222 1.059 1.68 1.746 1.989 2.18 1.989.156 0 .277-.04.375-.067.36-.117 1.562-.547 1.32-3.293-.117-3.093-1.078-16.71-1.199-17.398-.238-.57-.602-1.031-1.32-1.148A3.573 3.573 0 0 0 21.609 2Zm0 2h.124c.227 2.582 1.02 13.84 1.13 16.688l.007.093c.016.172.02.324.024.461a8.547 8.547 0 0 1-.239-.363c-3.293-4.996-8.086-12.293-9.504-14.492C14.445 5.547 19.27 4 21.61 4Zm15.128 11.996c-.316 0-.613.086-.879.274-.75.738-.484.214-4.8 5.933l-2.043 2.629c-.48.574-.368 1.527.113 2.215.398.57.918.918 1.605.918.141 0 .286-.012.442-.043.36-.113 1.082-.23 2.402-.574 8.277-1.828 8.352-1.813 8.715-2.04.477-.343.719-.804.719-1.492v-.113c-.239-1.828-3.793-6.746-5.473-7.547-.27-.101-.539-.16-.8-.16Zm.121 2.078c1.137.809 3.578 4.168 4.086 5.586-.629.156-1.945.445-4.168.934l-3.632.8-.036.012-.035.008c-.699.18-1.219.293-1.605.379-.262.059-.477.105-.668.156a.184.184 0 0 0-.035-.047c-.008-.011-.012-.023-.02-.039l1.906-2.457c3.336-4.41 3.852-4.992 4.207-5.332ZM9.402 23.97c-.48 0-1.082.23-1.441.8-.84 1.149-1.102 4.801-.86 7.32.118.802.239 1.454.477 1.911.36.574.84.918 1.442.918.359 0 .09-.105 7.293-2.164l3.246-1.031c.84-.23 1.425-.801 1.425-1.72 0-.913-.445-1.671-1.285-2.015l-2.281-.914C9.609 23.98 9.762 23.97 9.402 23.97Zm.11 2.11c.36.136.937.37 1.71.679 1.15.46 2.864 1.144 5.45 2.168l2.25.902-3.188 1.012c-3.96 1.133-5.664 1.672-6.476 1.941-.074-.304-.14-.718-.172-.937-.219-2.387.098-5 .426-5.766Zm21.383 5.937c-.543 0-1.051.172-1.442.593-.39.426-.683 1.621-.203 2.309l1.32 1.945c4.325 6.64 4.348 6.98 4.707 7.211.282.266.602.38.942.38.242 0 .492-.06.738-.153 1.926-.688 5.684-5.239 5.922-7.067.121-.574-.117-1.148-.598-1.718-.242-.23-.742-.313-7.468-2.403l-3.079-.976a3.185 3.185 0 0 0-.84-.121Zm-8.13 2c-.527 0-1.015.156-1.316.59l-1.562 1.828c-5.407 6.066-5.645 6.41-5.766 6.754-.121.23-.121.457-.121.687.121.34.242.57.484.914C15.707 46.062 20.813 48 23.082 48c.176 0 .336-.012.477-.035.601-.117 1.082-.461 1.32-1.031.121-.344.121-.57.121-7.782v-3.324c0-1-.441-1.332-1.281-1.676a3.649 3.649 0 0 0-.953-.136Zm8.301.015c.032.008.07.016.11.028l3.043.964c2.113.657 3.613 1.118 4.683 1.446.883.27 1.567.476 1.97.61-.372 1.288-3.134 4.57-4.43 5.265-.118-.184-.274-.434-.454-.719-.593-.95-1.703-2.723-3.761-5.887Zm-8.199 1.989c.035.003.082.007.133.015v3.117c0 4 0 6.016-.02 6.848-1.777-.059-5.527-1.52-6.761-2.36.707-.859 2.543-2.94 5.187-5.91Z"
        })
    }));
var $9d8b2252c9d0cc9d$export$2e2bcd8739ae039 = $9d8b2252c9d0cc9d$var$SvgYelp;





parcelRequire("7fPBF");
const $3c010517a0bd62c4$var$SvgYoutube = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M24.402 9c-6.601 0-12.8.5-16.101 1.2-2.2.5-4.102 2-4.5 4.3C3.402 16.898 3 20.5 3 25s.398 8 .898 10.5c.403 2.2 2.301 3.8 4.5 4.3 3.504.7 9.5 1.2 16.102 1.2s12.598-.5 16.098-1.2c2.203-.5 4.101-2 4.5-4.3.402-2.5.902-6.098 1-10.598 0-4.5-.5-8.101-1-10.601-.399-2.2-2.297-3.801-4.5-4.301-3.5-.5-9.598-1-16.196-1Zm0 2c7.2 0 12.996.598 15.797 1.098 1.5.402 2.7 1.402 2.899 2.703.601 3.199 1 6.601 1 10.101C44 29.2 43.5 32.7 43.098 35.2c-.297 1.899-2.297 2.5-2.899 2.703-3.601.7-9.601 1.196-15.601 1.196S12.5 38.699 9 37.902C7.5 37.5 6.3 36.5 6.102 35.2 5.3 32.4 5 28.7 5 25c0-4.602.402-8 .8-10.098C6.103 13 8.2 12.398 8.7 12.2 12 11.5 18.101 11 24.401 11ZM19 17v16l14-8Zm2 3.402L29 25l-8 4.598Z"
        })
    }));
var $3c010517a0bd62c4$export$2e2bcd8739ae039 = $3c010517a0bd62c4$var$SvgYoutube;





parcelRequire("7fPBF");
const $a567b0078c16856f$var$SvgZoom = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 100,
        height: 100,
        fill: "currentColor",
        viewBox: "0 0 50 50"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M16.38 4C9.556 4 4 9.555 4 16.38v17.24C4 40.444 9.555 46 16.38 46h17.24C40.444 46 46 40.445 46 33.62V16.38C46 9.556 40.445 4 33.62 4H16.38zm0 2h17.24C39.364 6 44 10.635 44 16.38v17.24C44 39.364 39.365 44 33.62 44H16.38A10.365 10.365 0 0 1 6 33.62V16.38C6 10.636 10.635 6 16.38 6zm20.823 10.629a1.648 1.648 0 0 0-.896.252l-5.633 3.52C29.994 18.44 28.178 17 25.994 17H13a1 1 0 0 0-1 1v9.994C12 30.747 14.253 33 17.006 33H30a1 1 0 0 0 1-1v-3.197l5.307 3.316c1.128.705 2.693-.162 2.693-1.492V18.373c0-.998-.88-1.735-1.797-1.744zM37 18.805v11.39l-6-3.75v-3.89l6-3.75zM14 19h11.994A2.991 2.991 0 0 1 29 22.006V31H17.006A2.991 2.991 0 0 1 14 27.994V19z"
        })
    }));
var $a567b0078c16856f$export$2e2bcd8739ae039 = $a567b0078c16856f$var$SvgZoom;









const $86c90ea367ca0c45$var$BouncingTyping = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "currentColor",
        viewBox: "0 0 256 256"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                children: '@keyframes bt-bounce{0%,60%,to{transform:translateY(0)}30%{transform:translateY(-14px)}}.bt-dot{animation:bt-bounce 1.2s ease-in-out infinite;transform-box:fill-box;transform-origin:center}.bt-dot:nth-of-type(2){animation-delay:.15s}.bt-dot:nth-of-type(3){animation-delay:.3s}'
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                className: "bt-dot",
                cx: 48,
                cy: 128,
                r: 28
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                className: "bt-dot",
                cx: 128,
                cy: 128,
                r: 28
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                className: "bt-dot",
                cx: 208,
                cy: 128,
                r: 28
            })
        ]
    }));
var $86c90ea367ca0c45$export$2e2bcd8739ae039 = $86c90ea367ca0c45$var$BouncingTyping;





const $3fce52eea13a1fbd$var$BasicPlanIcon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 112a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 112ZM196 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 112Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 112Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 40a16 16 0 0 1 16 16l-.01.593A16 16 0 1 1 60 40ZM196 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 196 40ZM128 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 128 40ZM60 184a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 184ZM196 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 184ZM128 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 184Z",
                opacity: 0.2
            })
        ]
    }));
var $3fce52eea13a1fbd$export$2e2bcd8739ae039 = $3fce52eea13a1fbd$var$BasicPlanIcon;





const $792a7de6b5a42e16$export$ab33d2e722ad9ed4 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 112a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 112ZM196 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 112Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 112ZM60 40a16 16 0 0 1 16 16l-.01.593A16 16 0 1 1 60 40ZM196 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 196 40Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 128 40Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 184a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 184ZM196 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 184Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 184Z"
            })
        ]
    }));





const $91a415956e584103$export$1e132fe159dac75f = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 112a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 112ZM196 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 112Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 112Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 40a16 16 0 0 1 16 16l-.01.593A16 16 0 1 1 60 40ZM196 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 196 40Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 128 40Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 184a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 184ZM196 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 184ZM128 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 184Z"
            })
        ]
    }));





const $ea26704d40de2a8e$var$PlusPlanIcon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 112a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 112ZM196 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 112ZM128 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 112Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 40a16 16 0 0 1 16 16l-.01.593A16 16 0 1 1 60 40ZM196 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 196 40Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 128 40Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M60 184a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 184ZM196 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 184Z",
                opacity: 0.2
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 8,
                d: "M128 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 184Z"
            })
        ]
    }));
var $ea26704d40de2a8e$export$2e2bcd8739ae039 = $ea26704d40de2a8e$var$PlusPlanIcon;





const $fd901bbd982b58bb$var$ProPlanIcon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            stroke: "currentColor",
            strokeWidth: 8,
            d: "M60 112a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 112ZM196 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 112ZM128 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 112ZM60 40a16 16 0 0 1 16 16l-.01.593A16 16 0 1 1 60 40ZM196 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 196 40ZM128 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 128 40ZM60 184a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 184ZM196 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 184ZM128 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 184Z"
        })
    }));
var $fd901bbd982b58bb$export$2e2bcd8739ae039 = $fd901bbd982b58bb$var$ProPlanIcon;


let $3adbcb77e640770e$var$_ = (t)=>t, $3adbcb77e640770e$var$t, $3adbcb77e640770e$var$t1;
const $3adbcb77e640770e$var$spin = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($3adbcb77e640770e$var$t || ($3adbcb77e640770e$var$t = $3adbcb77e640770e$var$_`
    to {
        transform: rotate(360deg);
    }
`));
/**
 * The busy indicator as an icon, so a control that takes an `IconName` — `TinyIconButton`, `ItemActionList`'s
 * actions — can show it without swapping in a different component while it works.
 *
 * `overflow: hidden` clips the sweep to the glyph's own square. Without it the rotation can paint a hair
 * outside the icon's box and, in a control barely larger than the icon, cross the dashed focus ring that
 * `MixinFocusVisible` draws 2px outside the button — a flickering ring under a spinner that only shows up
 * once the button is focused.
 *
 * The reduced-motion case slows the spin rather than stopping it: unlike the decorative animations elsewhere
 * (which are gated off entirely under `no-preference`), the motion here IS the message, and a frozen spinner
 * reads as a hung control.
 */ const $3adbcb77e640770e$var$CircularProgressIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bd90a784cc828027$export$14e2ba5030ceec95))($3adbcb77e640770e$var$t1 || ($3adbcb77e640770e$var$t1 = $3adbcb77e640770e$var$_`
    overflow: hidden;
    transform-origin: 50% 50%;
    animation: ${0} 1s linear infinite;

    @media (prefers-reduced-motion: reduce) {
        animation-duration: 3s;
    }
`), $3adbcb77e640770e$var$spin);
const $3adbcb77e640770e$export$6d49a893c897b0cc = {
    handTap: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba208388ac239df$export$7caf2e6d06b0e274), {}),
    cursorClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $499cedc40c55e7cb$export$e9e98f64fb597ccd), {}),
    cursorText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $991a051c44f6b41d$export$d665abe9390574dd), {}),
    appWindow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dfac1a9d177543ce$export$73674ec7e4bd2217), {}),
    translate: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0cac562beb02fd2$export$d1fe1d52e2885c4e), {}),
    thumbsUp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $175455dd9719881a$export$9e47e8f2c540d668), {}),
    flag: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6633ea98f1283125$export$4fd8d63cb0915eb0), {}),
    thumbsDown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b88431c71b28a7d6$export$d97232a1783d37ec), {}),
    robot: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6b769c496a9d5ca$export$5db83f67d50796e6), {}),
    openAiLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $58461f01577d65e9$export$526f06eba48e24ab), {}),
    addRow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ae7f63f5859902d$export$64702cae849e08a7), {}),
    ai: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2c91a69e5d67ec9$export$ae8a512ee3f09294), {}),
    airbnb: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00b3ccebbd02c720$export$2e2bcd8739ae039), {}),
    alert: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59680ec94e4e297e$export$d7b686e8afc4bc7e), {}),
    amazon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c8355b7723d13ecc$export$2e2bcd8739ae039), {}),
    amazonMusic: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5433efa7792edf57$export$2e2bcd8739ae039), {}),
    presentationChart: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbd40d632367bb70$export$efe9d8422aa89449), {}),
    androidOs: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3a92e462d72dd79$export$2e2bcd8739ae039), {}),
    androidTablet: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $319817bcb0975b64$export$2e2bcd8739ae039), {}),
    appStore: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d7ddc2c7594bdb77$export$2e2bcd8739ae039), {}),
    appleFitness: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7562bb96cc645793$export$2e2bcd8739ae039), {}),
    appleLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $960c6f50f044d54a$export$2e2bcd8739ae039), {}),
    appleNews: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c05f531d54f5030b$export$2e2bcd8739ae039), {}),
    applePay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $596bbe84e95bafd3$export$2e2bcd8739ae039), {}),
    appleTv: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3079e7169fff8540$export$2e2bcd8739ae039), {}),
    appleWatch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d1f4a65eeeeac6d$export$2e2bcd8739ae039), {}),
    atlassianConfluence: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63c6023a46e87011$export$2e2bcd8739ae039), {}),
    audible: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3c505b5d5c9a2b9$export$2e2bcd8739ae039), {}),
    automation: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd1c6f3efdeb55a$export$70208e77f6c45b17), {}),
    award: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a04767458aa408f3$export$f8328d6431f0c3df), {}),
    back: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fa01b25bab55864$export$810196a5854768f3), {}),
    background: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba5cf70b83cf27ea$export$62a30a6e7319c2c6), {}),
    bing: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18f555e019f9ab0b$export$2e2bcd8739ae039), {}),
    bouncingTyping: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86c90ea367ca0c45$export$2e2bcd8739ae039), {}),
    bluetooth2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0589edc71e767746$export$263c50ea203500d6), {}),
    bug: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c308ce43177e2521$export$3724a79860e51b2a), {}),
    build: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d330376fb0bcf89$export$57e3e6ad9de04bb9), {}),
    calendar: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8abaaeeab67664a2$export$5fda1783bb83f57b), {}),
    calendarDot: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa0c2f4db5eff029$export$6a0cf186e5c8acd9), {}),
    calendarDots: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a85869910c19ec6f$export$282abcbd253822f3), {}),
    callOfDutyBlackOps3: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b6a21eb2740d1a0$export$2e2bcd8739ae039), {}),
    callOfDutyMobile: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65c1d56f8fc276a2$export$2e2bcd8739ae039), {}),
    camera: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1ef82a974bad340$export$bed1a57ff13393e9), {}),
    cameraOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0eee0b1d53174355$export$e227a0e5d7fa29a5), {}),
    cameraPause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0eee0b1d53174355$export$e227a0e5d7fa29a5), {}),
    cameraSwitch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $940356a37dfbb440$export$7b925291abba066b), {}),
    cameraBaselineShow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32f3c95d33b86bb3$export$15406caa0ed774d4), {}),
    cameraBaselineHide: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d0ede6d22577f4c$export$b5014a80f94eec28), {}),
    cancel: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7425fd815e1431db$export$852d83c83fe09d93), {}),
    cancel2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $99a54942b2884ad1$export$a5090bbd7fc88fde), {}),
    chat: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffea4d92108488a3$export$9a3f119425fb8c38), {}),
    check: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a50b2f774bdffff$export$7dd004358974b05d), {}),
    checkCircle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07440da420a178a0$export$f6dd727656c97851), {}),
    chrome: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c435ded412ce4cee$export$2e2bcd8739ae039), {}),
    chromebook: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46a011279831d90c$export$2e2bcd8739ae039), {}),
    circle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8671267bc76a08e9$export$9c1c3f5a4a271817), {}),
    circleFilled: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8671267bc76a08e9$export$9c1c3f5a4a271817), {
        weight: "fill"
    }),
    circleNotch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd90a784cc828027$export$14e2ba5030ceec95), {}),
    circularProgress: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3adbcb77e640770e$var$CircularProgressIcon, {}),
    close: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8682947bc7c82d8$export$5e658a8851ae9322), {}),
    closeX: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8682947bc7c82d8$export$5e658a8851ae9322), {}),
    clipboard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c58fd630e9f542$export$5ea4e40e738fba70), {}),
    clockCountdown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2df690f830f6bfe$export$b4de5782c179f82b), {}),
    cnn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1421cc100a791107$export$2e2bcd8739ae039), {}),
    code: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e673841d74d2fd8a$export$8ee6b256df317f28), {}),
    collapseArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f193c00afed960f7$export$7d1b8b90f61377d1), {}),
    command: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce7a829edce56cbe$export$76bfbab5e3f9a6a3), {}),
    commandGlobal: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8d2c170e0262ea2$export$c4a25ec2a3f59ed3), {}),
    communicate: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137fb85d062916e7$export$932ca73f3598151a), {}),
    connect: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22492976e1d4d968$export$55653f8b5a32ba35), {}),
    connectionOffline: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2584623c5b466be$export$40ca6aea9c29b1cf), {}),
    connectionStatusOn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6e819780b9c1274e$export$303836f55ddf2d4b), {}),
    compress: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $26629d2c54ba0e90$export$2e28bad6de91f83d), {}),
    computerMouse: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91081726855ec7c6$export$53ac786375585ec0), {}),
    contacts: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1cce39a8b578ff0a$export$2e2bcd8739ae039), {}),
    counterStrike: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4698ad62cc1274e$export$2e2bcd8739ae039), {}),
    createOrder: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34d18705d2aaa06f$export$ca191b730434e9b4), {}),
    crown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78e34b15ecf2a54e$export$338dfc3083a3d7f0), {}),
    dataSecure: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8a6231e5abb5624$export$da01a61080044588), {}),
    delete: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9819cc275a023cc4$export$d23329de703dffc4), {}),
    deleteRow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $543fda4ac58ac75f$export$12a3823f287db803), {}),
    details: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1f565be31fe1992$export$70784bf0c528892c), {}),
    deviceManager: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0536198cc436fd7c$export$ba4cac3c471c5034), {}),
    dictationOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1498f3d123581ef7$export$d9c1abf94e64825b), {}),
    dictationOn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32c43b5d35c7f6a5$export$2aab0b35a50deea3), {}),
    dictationPause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4c041254446cc77$export$2e2bcd8739ae039), {}),
    dictationPlay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7bd416e9f38b8977$export$2e2bcd8739ae039), {}),
    discoball: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8140d5c711c8dac2$export$f8943b539a4bce42), {}),
    discord: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3679bbefd6a2cdc$export$2e2bcd8739ae039), {}),
    disneyMovies: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c67d20bd69d9f8ef$export$2e2bcd8739ae039), {}),
    doomLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $92aaa8e9b3c9a4fd$export$2e2bcd8739ae039), {}),
    downLeftArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67b9a227b3b8fac0$export$13cb63b08462037d), {}),
    downRightArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6637b5fdc104c1c9$export$56519a0a31438e20), {}),
    download: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3d7aae5ab6f8c20e$export$5e12dc2d5a33c663), {}),
    duplicate: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db96a5dcfc35585c$export$51b6cd98f8778f0d), {}),
    edit: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bcf07f234bdd453$export$97ae7c994680a9ed), {}),
    eduLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b863f60fd8ea76e$export$2e2bcd8739ae039), {}),
    eduLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $793a6d9e0f3eb994$export$2e2bcd8739ae039), {}),
    epicGames: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $512b1d6277a77d97$export$2e2bcd8739ae039), {}),
    expandArrow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d78174bfef35f91$export$73a4c78a4a00962), {}),
    expression: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f83f391ed40890b1$export$2e2bcd8739ae039), {}),
    export: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $424c21aaeac80038$export$e9c88b7c429dba64), {}),
    externalLink: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2c52d04e0b586f6c$export$8a7958b7fd68e86d), {}),
    eye: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41331bef289ddf9d$export$4b2c798a70974642), {}),
    eyebrowRaise: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $878338a7c05872f6$export$2e2bcd8739ae039), {}),
    faceExpression: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e8f8716714af8e2c$export$2e2bcd8739ae039), {}),
    facebook: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a6e3afa557217638$export$2e2bcd8739ae039), {}),
    facebookMessenger: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0de5ad6202c372c1$export$2e2bcd8739ae039), {}),
    facetime: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27eac4e6b224d0c7$export$2e2bcd8739ae039), {}),
    fileMd: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $494752190a3820c3$export$88937d130805b394), {}),
    files: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $250558ea9b1ae473$export$e08f3be1829716d), {}),
    folder: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9d524fe12241a80$export$b7c13c52029a403), {}),
    folderPlus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b689941a4e3d9043$export$73cbd9fbc6f9a78e), {}),
    findIphone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25abb7d8311d1b5e$export$2e2bcd8739ae039), {}),
    fireTv: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d66404571458338$export$2e2bcd8739ae039), {}),
    fortnite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $195bb2aa60406de1$export$2e2bcd8739ae039), {}),
    forward: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf227e7e52862ade$export$5e4a7579d3e78657), {}),
    futures: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $352ea393a631b359$export$9da4f9d7ed027300), {}),
    game: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07eb5346ad9d064e$export$67c6cd66cb8e49db), {}),
    github: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e61990689ecc79a$export$2e2bcd8739ae039), {}),
    globe: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b80ecb83ad6de581$export$a70e2e549144f66), {}),
    gmail: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $792bc4d5598bcd37$export$2e2bcd8739ae039), {}),
    gmailLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75745da5fba927e0$export$2e2bcd8739ae039), {}),
    google: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6371eb2aedbedde$export$2e2bcd8739ae039), {}),
    googleCalendar: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6a3e630182db681$export$2e2bcd8739ae039), {}),
    googleClassroom: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2a655191d7c12f7$export$2e2bcd8739ae039), {}),
    googleDocs: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $713e9c2c47877792$export$2e2bcd8739ae039), {}),
    googleDrawing: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e950c6997d469e51$export$2e2bcd8739ae039), {}),
    googleDrive: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28402c28da4b8b2b$export$2e2bcd8739ae039), {}),
    googleEarth: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52d4718a69ac94c7$export$2e2bcd8739ae039), {}),
    googleForms: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ee8c38486294b4f$export$2e2bcd8739ae039), {}),
    googleMeet: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11b2a8be749657ee$export$2e2bcd8739ae039), {}),
    googlePixel6: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $611cb8c6b8793355$export$2e2bcd8739ae039), {}),
    googlePlay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $480150230dd592ca$export$2e2bcd8739ae039), {}),
    googlePlayMusic: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f49bc59318865ee6$export$2e2bcd8739ae039), {}),
    googlePlus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a80e63067819b2a7$export$2e2bcd8739ae039), {}),
    googleSheets: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e1061f35716bd07$export$2e2bcd8739ae039), {}),
    googleSlides: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e30adf1bb2f794b5$export$2e2bcd8739ae039), {}),
    grammarly: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3ace68bbd1278b8$export$2e2bcd8739ae039), {}),
    hboMax: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $13c1584923501bf3$export$2e2bcd8739ae039), {}),
    heart: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $daf0af796c7daf33$export$44fb2b0459be5849), {}),
    headMovement: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a40ac44443616e4e$export$2e2bcd8739ae039), {}),
    headMovement1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3215e388a4926a3$export$2e2bcd8739ae039), {}),
    headTurning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cbedcd5de46db09$export$2e2bcd8739ae039), {}),
    headUpAndDown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95fa162f48833150$export$2e2bcd8739ae039), {}),
    health: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6570d7c790cde0b$export$2e2bcd8739ae039), {}),
    help: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2322f0f5c675ac09$export$f314ed182f5da2a0), {}),
    hide: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0987fb0e4a894127$export$a3d42ccaf02d165b), {}),
    hideSidepanel: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fffe8c4dc33c750$export$8e4e0663d737f944), {}),
    history: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85bbabb726c65e23$export$92c4ba459e027921), {}),
    home: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f183d9af8860529$export$f8c453d4287040a2), {}),
    hub: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25483bd4b980c997$export$49b63808e7fc4751), {}),
    hulu: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32705bcb0cd360a7$export$2e2bcd8739ae039), {}),
    icloud: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45cda0bdf909d545$export$2e2bcd8739ae039), {}),
    idea: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $885e936d56aff1b9$export$f678a184393c5940), {}),
    imac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db0aecd837df835e$export$78a6319cfd8cd037), {}),
    imovie: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0fa071542d1ff183$export$2e2bcd8739ae039), {}),
    insertRow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1cd2f9ed3ccb6f1$export$83609ace955a79f), {}),
    insertRowAbove: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1cd2f9ed3ccb6f1$export$83609ace955a79f), {}),
    instagram: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $655e3e5c364148e2$export$2e2bcd8739ae039), {}),
    iosLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9bb0f831af78c332$export$2e2bcd8739ae039), {}),
    iosPhotos: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $142e6c76da9ebc8b$export$2e2bcd8739ae039), {}),
    iphone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32f3456307b486ee$export$86748a064d6b172), {}),
    itunes: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37d29f22d8db03a3$export$2e2bcd8739ae039), {}),
    javaScript: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c25bb468cbb9a994$export$2e2bcd8739ae039), {}),
    jira: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44bfc9fc6a27ffb$export$2e2bcd8739ae039), {}),
    joystick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6234b88ab556c79a$export$da69e29052e4731), {}),
    key0: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a632d8591d1e8129$export$2e2bcd8739ae039), {}),
    key1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8df11c1882a1a51b$export$2e2bcd8739ae039), {}),
    key2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e1ea149a9060c6a$export$2e2bcd8739ae039), {}),
    key3: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0c42c8087af715b$export$2e2bcd8739ae039), {}),
    key4: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4f76112c461b32f$export$2e2bcd8739ae039), {}),
    key5: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02bb6564be985baa$export$2e2bcd8739ae039), {}),
    key6: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11ba4ce477af0c9a$export$2e2bcd8739ae039), {}),
    key7: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d8a61a07fbe0860$export$2e2bcd8739ae039), {}),
    key8: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb6bb042edf63b5c$export$2e2bcd8739ae039), {}),
    key9: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0440a6aa4628c945$export$2e2bcd8739ae039), {}),
    keyA: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d905b0a6418e110d$export$2e2bcd8739ae039), {}),
    keyAlt: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30670d6961572f0f$export$2e2bcd8739ae039), {}),
    keyAltgr: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $93014453a15abd8b$export$2e2bcd8739ae039), {}),
    keyAsterisk: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c3c343fdfab7ac2$export$2e2bcd8739ae039), {}),
    keyB: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8df7a3bd0475c986$export$2e2bcd8739ae039), {}),
    keyBackspace: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $027d46a574c94474$export$2e2bcd8739ae039), {}),
    keyC: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4348b719525840f3$export$2e2bcd8739ae039), {}),
    keyCapsLock: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6921955218308c40$export$2e2bcd8739ae039), {}),
    keyCapslockText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31e3b501c850f2fe$export$2e2bcd8739ae039), {}),
    keyCmd: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e784f7a02803758d$export$2e2bcd8739ae039), {}),
    keyCoinsButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5b77224cfca79fc$export$2e2bcd8739ae039), {}),
    keyCommand: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0606a21a12ea54c0$export$2e2bcd8739ae039), {}),
    keyControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49250ec78a20638c$export$2e2bcd8739ae039), {}),
    keyCtrl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1940e6fd7db13266$export$2e2bcd8739ae039), {}),
    keyD: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b9831ccf8f478fd$export$2e2bcd8739ae039), {}),
    keyDelete: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0e0005e3eb8a47f$export$2e2bcd8739ae039), {}),
    keyDelete2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6575f368334c18a$export$2e2bcd8739ae039), {}),
    keyDot: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $335196af04c84a31$export$2e2bcd8739ae039), {}),
    keyE: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fbebede1d622f77a$export$2e2bcd8739ae039), {}),
    keyEndButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22a251f88571b84a$export$2e2bcd8739ae039), {}),
    keyEnter: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebbe86d494ff9bbc$export$2e2bcd8739ae039), {}),
    keyEnterMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37dbda8c254edf97$export$2e2bcd8739ae039), {}),
    keyEqual: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $487d6e36dcafcb2d$export$2e2bcd8739ae039), {}),
    keyEsc: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6d465961f631267$export$2e2bcd8739ae039), {}),
    keyEscMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0708247861041f7$export$2e2bcd8739ae039), {}),
    keyF: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97c5c43afd0584a8$export$2e2bcd8739ae039), {}),
    keyF1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d770639ab656fa18$export$2e2bcd8739ae039), {}),
    keyF10: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $332524047e7a4ac5$export$2e2bcd8739ae039), {}),
    keyF11: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca5f38dbd83f3721$export$2e2bcd8739ae039), {}),
    keyF12: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e9a184e77d9537a4$export$2e2bcd8739ae039), {}),
    keyF2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $377584932bdac7fe$export$2e2bcd8739ae039), {}),
    keyF3: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd4b812de9ff4851$export$2e2bcd8739ae039), {}),
    keyF4: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b573a3566bd3206$export$2e2bcd8739ae039), {}),
    keyF5: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41d8574f644e60ac$export$2e2bcd8739ae039), {}),
    keyF6: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62856496d756886b$export$2e2bcd8739ae039), {}),
    keyF7: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47c4a943b3e5ccd3$export$2e2bcd8739ae039), {}),
    keyF8: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9e8ae470d5334fbf$export$2e2bcd8739ae039), {}),
    keyF9: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f638f7603c3f0297$export$2e2bcd8739ae039), {}),
    keyFn: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1253f9538fc416fa$export$2e2bcd8739ae039), {}),
    keyFunctionMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7c04b832cc34ee7$export$2e2bcd8739ae039), {}),
    keyG: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $721bb2247b62229e$export$2e2bcd8739ae039), {}),
    keyH: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40c08a9bfd143af3$export$2e2bcd8739ae039), {}),
    keyHashtag: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9df36942c9a98cf6$export$2e2bcd8739ae039), {}),
    keyHomeButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e90a70d42b6dc2e5$export$2e2bcd8739ae039), {}),
    keyI: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31af271f439f7f10$export$2e2bcd8739ae039), {}),
    keyJ: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2e5ff91a41ba25e$export$2e2bcd8739ae039), {}),
    keyK: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eed7a945fc76c2bd$export$2e2bcd8739ae039), {}),
    keyL: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $babff20b0d4654ba$export$2e2bcd8739ae039), {}),
    keyLeftAngleParentheses: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28380b67fbfe727d$export$2e2bcd8739ae039), {}),
    keyM: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eeaf776f967e20c6$export$2e2bcd8739ae039), {}),
    keyMinus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dcb0c3efc1457ecf$export$2e2bcd8739ae039), {}),
    keyN: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e13a1775e3b494bc$export$2e2bcd8739ae039), {}),
    keyO: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4c0f13b7e9c863f6$export$2e2bcd8739ae039), {}),
    keyOption: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f785a1fe04b59464$export$2e2bcd8739ae039), {}),
    keyP: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f857acdec584cd37$export$2e2bcd8739ae039), {}),
    keyPageDownButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e99cc5022343e76f$export$2e2bcd8739ae039), {}),
    keyPageUpButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a844d4ba0847ea6$export$2e2bcd8739ae039), {}),
    keyPlus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5047847f9449d0d7$export$2e2bcd8739ae039), {}),
    keyQ: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6604f2ab651791da$export$2e2bcd8739ae039), {}),
    keyR: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $756d3ddc5105ca4d$export$2e2bcd8739ae039), {}),
    keyRightAngleParentheses: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cdc0aa5cadea8c33$export$2e2bcd8739ae039), {}),
    keyS: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39f8b5dc7ed29ffc$export$2e2bcd8739ae039), {}),
    keySolidus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8378efa8f631e6e6$export$2e2bcd8739ae039), {}),
    keySpace: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $20566c6a075b51f1$export$2e2bcd8739ae039), {}),
    keyT: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $441acdbafb1bd1ee$export$2e2bcd8739ae039), {}),
    keyTab: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eb7fda30618d887d$export$2e2bcd8739ae039), {}),
    keyU: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0674e1fc2efa4c50$export$2e2bcd8739ae039), {}),
    keyV: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $300d4a3a425ff969$export$2e2bcd8739ae039), {}),
    keyW: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $673e0b4aaae7ef63$export$2e2bcd8739ae039), {}),
    keyWindows: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfc8508a0d8a5a06$export$2e2bcd8739ae039), {}),
    keyX: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bded3da25f49952b$export$2e2bcd8739ae039), {}),
    keyY: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d240e40e324119ef$export$2e2bcd8739ae039), {}),
    keyZ: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1401a11666a30a5e$export$2e2bcd8739ae039), {}),
    keyboard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3977927b8e8acd3c$export$97dac707ecee26f6), {}),
    launchpad: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47547f2fd2eb2527$export$ccc8b9cc502aea29), {}),
    layers: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23259387cb66f7b3$export$f95b8a41f9121b54), {}),
    leanFrontToBack: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46e8d4dadea67077$export$2e2bcd8739ae039), {}),
    library: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $862061e2a830a35b$export$3ac311e31945509f), {}),
    link: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c3d003be71bd9c3$export$69387b41dfc808f7), {}),
    linkedin: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $788da9ed54ecd493$export$2e2bcd8739ae039), {}),
    linkBreak: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a7ac72ddd488c3fa$export$3cf6c022d9395be8), {}),
    lightning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $66907d3d09578e84$export$b9beba9ac1b19787), {}),
    logo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0e324a98afaf32e9$export$2e2bcd8739ae039), {}),
    logo2KLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4c0ef6c1c64a1357$export$2e2bcd8739ae039), {}),
    logout: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91f7b26fb1a24ddc$export$5bb2595dc31bfece), {}),
    macbookProM1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a4a10635b84b894$export$b94473071ddf9fbf), {}),
    mail: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $356076885242800f$export$ea4109706c07d076), {}),
    mastercard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc242ec31876a589$export$2e2bcd8739ae039), {}),
    mcp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6f9f0c9fbec8b58a$export$5bdc63ba07f7b8a8), {}),
    messages: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fbee013cad25ded$export$2e2bcd8739ae039), {}),
    microphone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09b782f8de8a3c61$export$d2834cd4e399cf8b), {}),
    microphoneOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2bb6ac751b7724ae$export$8d1357c8e3c4bfd6), {}),
    microsoftEdge: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0ca46ae71da4c2a$export$2e2bcd8739ae039), {}),
    microsoftExcel: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $073cb9bb3a09c7d7$export$2e2bcd8739ae039), {}),
    microsoftOnenote: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9b5ae76a6c0d9c1$export$2e2bcd8739ae039), {}),
    microsoftOnenote2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddc5edcab4e76c4a$export$2e2bcd8739ae039), {}),
    microsoftOutlook: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9b7e1a52af65fadf$export$2e2bcd8739ae039), {}),
    microsoftPowerpoint: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $043753d569a8f872$export$2e2bcd8739ae039), {}),
    microsoftTeams2019: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d612a33d3bd29557$export$2e2bcd8739ae039), {}),
    microsoftToDoApp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4690868c4c694c15$export$2e2bcd8739ae039), {}),
    microsoftWord: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $be2fbecbfbe47448$export$2e2bcd8739ae039), {}),
    motionControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a9622dbe0a0baaaf$export$2e2bcd8739ae039), {}),
    motionControl1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0fccc9e464ae15bb$export$2e2bcd8739ae039), {}),
    motionControl2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ca35a7fde0d51c6$export$2e2bcd8739ae039), {}),
    money: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a91f296d46ab80$export$fb505dcffad77432), {}),
    more: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88db7d04aef0c70c$export$fc32f3c5f46e7c02), {}),
    motherboard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c2550b6d641714$export$a0dda6738dfadcc6), {}),
    mouse: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91081726855ec7c6$export$53ac786375585ec0), {}),
    mouseLeftClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $35ad9356e9e5ec61$export$6b5f666f729352a), {}),
    mouseMiddleClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d85af3025ef534f2$export$5963dbb4ba2dab8b), {}),
    mouseRightClick: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f8122a9e58d3677$export$50d995ce278ebfd9), {}),
    mouseScrolling: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fa60ad372f26f07$export$f0907b1c06628174), {}),
    move: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $262c01eb267814c7$export$a851e5e12081274c), {}),
    moveDown: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $31ad35f89b420139$export$39cd7ca4553bb068), {}),
    moveUp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $618411f7e75dbf5e$export$877fb05cb295590c), {}),
    multipleDevices: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0536198cc436fd7c$export$ba4cac3c471c5034), {}),
    music: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $311040ba1740986f$export$2e2bcd8739ae039), {}),
    naturalUserInterface2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ba208388ac239df$export$7caf2e6d06b0e274), {}),
    netflix: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9cedd24a1acdd63f$export$2e2bcd8739ae039), {}),
    newYorkTimes: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e5ab08ff1b567f0$export$2e2bcd8739ae039), {}),
    nintendoSwitchLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2081ab8da1be49dc$export$2e2bcd8739ae039), {}),
    nod: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b823c4a4b1403fe$export$2e2bcd8739ae039), {}),
    notes: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69972f0aea86b6a2$export$d07ff5a8e7869743), {}),
    notification: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19062bd64dded0d3$export$2235404cc2cfe93c), {}),
    octopus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85b17b826eab10ce$export$2e2bcd8739ae039), {}),
    office365: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4262604d9c082a54$export$2e2bcd8739ae039), {}),
    openCloseMouth: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97f91bf195707c03$export$2e2bcd8739ae039), {}),
    orgAdmin: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $380b00235de4079c$export$2d4a0edcdd78d72c), {}),
    orgAuthClient: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9991baf035cb3560$export$3dc0fe769dc7dcac), {}),
    orgCompany: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $866da9b1db75c8ee$export$5039d390f8f90df), {}),
    orgDeleteUser: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43867aff44220ee6$export$dcdebfa7a96805c0), {}),
    orgInvite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3a96a83bceac7286$export$237d26d4b8472a), {}),
    orgInviteExpired: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e71b30b7f3057cfb$export$1ce52e77d13914c6), {}),
    orgMembers: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc77a89d27a4c55c$export$4e04c809deb7a605), {}),
    orgPermissions: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f437e07b97666ee$export$3006507487a721d3), {}),
    orgTransaction: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a91f296d46ab80$export$fb505dcffad77432), {}),
    pandoraApp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6e649c234c8975d4$export$2e2bcd8739ae039), {}),
    palette: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a77e4a11253c5e2$export$c142a38f581c8178), {}),
    pause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $282419a8b70eaf27$export$9b47433640e5db3a), {}),
    pause2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67a070e95907d9d1$export$75886cde6273c22e), {}),
    paypal: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6efa39f11e16b5aa$export$2e2bcd8739ae039), {}),
    personalLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f65eb00043ec877$export$2e2bcd8739ae039), {}),
    personalLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $710403c951aed9ee$export$2e2bcd8739ae039), {}),
    phone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9242fb59a025a53$export$54336acd81078d46), {}),
    play: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3771d59d9595d59e$export$a6630b90defda83f), {}),
    playstation: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc51cba71cb43570$export$2e2bcd8739ae039), {}),
    playstore: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a9ffda3eb6c05e1$export$2e2bcd8739ae039), {}),
    plus: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5), {}),
    plusLight: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd4d57083c8a9ad0$export$99bb4c5ac5bf5ec5), {}),
    plusSimple: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $788766255439a751$export$f21ab0717a89c77f), {}),
    plusLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0f91621c24890df$export$2e2bcd8739ae039), {}),
    plusLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4996e3fa9df448c$export$2e2bcd8739ae039), {}),
    powerBi: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67599b84b2002306$export$2e2bcd8739ae039), {}),
    preferences: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef83b92ad455ae8$export$2e2bcd8739ae039), {}),
    preview: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41331bef289ddf9d$export$4b2c798a70974642), {}),
    previous: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2fa01b25bab55864$export$810196a5854768f3), {}),
    proLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24f5c501f2475f6f$export$2e2bcd8739ae039), {}),
    proLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $15669c683dd043b1$export$2e2bcd8739ae039), {}),
    process: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $45c37c8e5c384c5e$export$c6d97cdd83a3ef7a), {}),
    ps4: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7efcdfa101ef1389$export$2e2bcd8739ae039), {}),
    purchaseOrder: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $da973a188202d04f$export$efdad510605bf5b6), {}),
    reactNative: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ddc512c8843c2cb$export$2e2bcd8739ae039), {}),
    read: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c629337a707d5c1c$export$e7072e36fe002dd0), {}),
    recordWorkflow: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $914be67361fb6872$export$2e2bcd8739ae039), {}),
    releaseKey: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77361cab3d35eb70$export$d4c1fa49fa5d23e1), {}),
    reminders: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f16a8074acc9fc02$export$2e2bcd8739ae039), {}),
    repeat: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $510c9fc2f66cce3f$export$e5f174c029ba02b2), {}),
    replicateRows: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7cfe8b811c67a0e$export$2f845a994f66da8f), {}),
    rockstarGames: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fabb58c67223cc99$export$2e2bcd8739ae039), {}),
    safari: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7cb0e7963ddb95ec$export$2e2bcd8739ae039), {}),
    sanAndreas: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $566b6e2d6ce5c43b$export$2e2bcd8739ae039), {}),
    save: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d09bbb62b804b286$export$72eeb4bb593c0c95), {}),
    sdk: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341dc8bc46d90b3a$export$2acbef2959ecd829), {}),
    sdkLogo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6bbbdeadab023461$export$2e2bcd8739ae039), {}),
    sdkLogoWhite: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f033889ae95cbbe$export$2e2bcd8739ae039), {}),
    search: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5394ccda98b8b514$export$f7658c347b037c3f), {}),
    selfServiceKiosk: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $99cdf9595233aa23$export$2e2bcd8739ae039), {}),
    send: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e100296a4b3103b5$export$2b1f3042fe58a494), {}),
    sent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5b6c5e30bc6121e$export$6d66b94e76150c22), {}),
    sensitivity: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fbf8be4ed6bd1575$export$2e2bcd8739ae039), {}),
    settings: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27341b9e147c07ff$export$9d72c0eeb3943e75), {}),
    shakePhone: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7d13e33d82d990b$export$2e2bcd8739ae039), {}),
    share: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $281c4dbdb34445c4$export$40148c7db598e4e0), {}),
    shazam: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3b7e121ae3cb925$export$2e2bcd8739ae039), {}),
    shift: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $303639901bf99dc0$export$2e2bcd8739ae039), {}),
    shift2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a105b007c217e587$export$2e2bcd8739ae039), {}),
    shiftMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6c173fbd5231fa4f$export$2e2bcd8739ae039), {}),
    showtime: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7bcdb42b48fb49f4$export$2e2bcd8739ae039), {}),
    sidebar: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $275efacd365e2acb$export$717f5d3c6bfa9f5e), {}),
    signalApp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5994517905e023d$export$2e2bcd8739ae039), {}),
    siri: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f464a6a2f00d4b8$export$2e2bcd8739ae039), {}),
    slack: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2005106e9deaac4d$export$2e2bcd8739ae039), {}),
    smartWatch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02d2ce069a187b72$export$2e2bcd8739ae039), {}),
    smile: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $086b5e67479dbabb$export$2e2bcd8739ae039), {}),
    soundcloud: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd1ce7d657321c94$export$2e2bcd8739ae039), {}),
    sparkles: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8899997e3fc20429$export$1019ff5537a7252e), {}),
    speaker: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0972bbebf39666e5$export$951b168b9ecc05fb), {}),
    speedometer: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d545586961bd20bd$export$5ff880ebd1cf0b62), {}),
    spotify: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5ccfc72ed9852e5$export$2e2bcd8739ae039), {}),
    squaredMenu: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffc30300995f8d60$export$aa8679e33ed2ffa0), {}),
    ssd: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46b7fb5cd67a058d$export$2e2bcd8739ae039), {}),
    star: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9564cc79ecb90f47$export$2ee28caa7f1e962e), {}),
    stop: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9eef48aaff177bbc$export$dc6949a98411e916), {}),
    summarize: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd6772777789f3b6$export$174e4a35fe496af8), {}),
    svgCephy: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28ab7c56405aa7ea$export$2e2bcd8739ae039), {}),
    switchControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e1a50be14ab9a9e$export$2e2bcd8739ae039), {}),
    switchControl1: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78046ad711fac15d$export$2e2bcd8739ae039), {}),
    switchControl2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bb4296f4d314913$export$2e2bcd8739ae039), {}),
    switchSimple: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b7947571a956063$export$2e2bcd8739ae039), {}),
    symantec: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4753e72983465a2$export$2e2bcd8739ae039), {}),
    sync: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0626899a8774a822$export$67f45bdc93ca8e23), {}),
    tabKey2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0ea924b4f8fb967$export$2e2bcd8739ae039), {}),
    tabMac: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02e80b1c53448aa7$export$2e2bcd8739ae039), {}),
    tapPause: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac547a61f677026b$export$2e2bcd8739ae039), {}),
    tapPlay: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27e318183cdf78bd$export$2e2bcd8739ae039), {}),
    tapStop: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5a1ec4c31772a9$export$2e2bcd8739ae039), {}),
    terminal: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af5f4727f2779cea$export$9ff5547afd06adf7), {}),
    tiktok: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39440ba5457cc20b$export$2e2bcd8739ae039), {}),
    timer: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec3dc4d0853d94d0$export$579848c7cccecf3f), {}),
    todoist: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3d15c36ae3535e8$export$2e2bcd8739ae039), {}),
    toggleKey: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c13e7fb415e096f$export$2e2bcd8739ae039), {}),
    tools: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52a0c24a3d3e2214$export$bc176c2a10341979), {}),
    touchpad: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fccdf11ae80529b$export$2e2bcd8739ae039), {}),
    trello: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f481633bf928acdb$export$2e2bcd8739ae039), {}),
    tripadvisor: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe23b5827fb90960$export$2e2bcd8739ae039), {}),
    tv: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1695f1b8e4452b4e$export$2e2bcd8739ae039), {}),
    twitch: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c48daaee27f5aac$export$2e2bcd8739ae039), {}),
    twitterx: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d417e5b9a3bf4ea5$export$2e2bcd8739ae039), {}),
    uber: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $418d4e99ed245825$export$2e2bcd8739ae039), {}),
    unity: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6eacdd29be96605e$export$2e2bcd8739ae039), {}),
    unrealEngine: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6506a335d289da77$export$2e2bcd8739ae039), {}),
    upgrade: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18715178eb9fa0d1$export$2e2bcd8739ae039), {}),
    usb2: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7594f1f4d24bde25$export$2e2bcd8739ae039), {}),
    usbC: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afd76c8e7b7affb8$export$2e2bcd8739ae039), {}),
    usbOff: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f45133cdb78263ed$export$2e2bcd8739ae039), {}),
    user: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c61379047732f24$export$9daf73c3c6a408a2), {}),
    userGroups: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0b8800b731f944b$export$31f7e9379e51640b), {}),
    variant: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bbcdd9ecba689979$export$2bc1d0180119f574), {}),
    vector: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $121fda4f624e73fb$export$2e2bcd8739ae039), {}),
    virtualApps: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa3e65f55eb3500f$export$2e2bcd8739ae039), {}),
    virtualButton: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $faa4b1f11be8231d$export$2e2bcd8739ae039), {}),
    virtualReality: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24e6d56f54bae8bf$export$2e2bcd8739ae039), {}),
    visualStudio: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00343718cdb9cc97$export$2e2bcd8739ae039), {}),
    voice: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $33b5e9a8ed1b53a5$export$2e2bcd8739ae039), {}),
    voiceControl: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $acd55902513cc2be$export$2e2bcd8739ae039), {}),
    voiceMemos: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34aed62813af1122$export$2e2bcd8739ae039), {}),
    wheelchairMotion: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47d7fdd528e7358c$export$70f2a162da142226), {}),
    warning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a44ba7e85f055b31$export$9f0af3ec4c4725c2), {}),
    warningFilled: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd4997cb53138a7f$export$d724908cf9d2c1d6), {}),
    warningTriangle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0770788fd5741d9$export$f7dc499a72baa103), {}),
    waze: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3ac36ea1b4137a8$export$2e2bcd8739ae039), {}),
    weather: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a85044c5feaf17c$export$2e2bcd8739ae039), {}),
    wechat: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b62ebb210c573784$export$2e2bcd8739ae039), {}),
    wellsfargo: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af66a6393cd41f93$export$2e2bcd8739ae039), {}),
    whatsapp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b418400b3516f49e$export$2e2bcd8739ae039), {}),
    wiFi: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1dc4c4bf0ea2b94$export$bb1fb2a6f6348cd5), {}),
    windows11: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d752c8bed9966dc3$export$2e2bcd8739ae039), {}),
    windowsXp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cbdf5641ddee00a3$export$2e2bcd8739ae039), {}),
    xfinity: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1fdb89e8a7f1773$export$2e2bcd8739ae039), {}),
    yelp: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d8b2252c9d0cc9d$export$2e2bcd8739ae039), {}),
    youtube: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c010517a0bd62c4$export$2e2bcd8739ae039), {}),
    zoom: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a567b0078c16856f$export$2e2bcd8739ae039), {}),
    // Workflow Step Icons
    archive: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d648a03dbd4f3269$export$64abfa02d870a554), {}),
    textAa: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f15fbbae0cbab63b$export$65c346b6dab7f802), {}),
    textT: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3551c25430464ec$export$e667e191e6c30e84), {}),
    cursor: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eba72b294d6f09da$export$8ce9a6eef5b50cda), {}),
    fileText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f0996278d9b7033$export$605674723bcc715c), {}),
    listChecks: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca64e21eb0b03905$export$35749e1285046a5a), {}),
    listMagnifyingGlass: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b70a64411fa68f1f$export$c4110d37f1233070), {}),
    info: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ad77d9dd26a095a7$export$2957fc44b3d2481), {}),
    squaresFour: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffc30300995f8d60$export$aa8679e33ed2ffa0), {}),
    folderOpen: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c752b0dc2a4fd996$export$d2044f064f31dbdd), {}),
    fileMagnifyingGlass: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7a2cae967b7bcae2$export$588b3e9b8e13e2d4), {}),
    selection: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $80401d3fb267975d$export$20f327b9bcd226d8), {}),
    // Plan Icons
    basic_plan: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fce52eea13a1fbd$export$2e2bcd8739ae039), {}),
    plus_plan: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea26704d40de2a8e$export$2e2bcd8739ae039), {}),
    pro_plan: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd901bbd982b58bb$export$2e2bcd8739ae039), {}),
    dev_plan: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $792a7de6b5a42e16$export$ab33d2e722ad9ed4), {}),
    edu_plan: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91a415956e584103$export$1e132fe159dac75f), {})
};


let $f7580c2fb20f0ef1$var$_ = (t)=>t, $f7580c2fb20f0ef1$var$t;
/**
 * This is a wrapper component for the icons defined in the IconMap.tsx file.
 * This has the flexibility to change the size and color of the icons.
 * By default the size is 24px and color is inherit -- which means that it will inherit the text color of the parent element when no color prop is passed.
 * Icons can be enhanced to have hover and active states if needed. An example of adding a hover state is below where the parent component is extended and the svg element is targeted to change the size and color.
 *
 *      const IconButtonLinkWithHover = styled(IconButtonLink)`
 *          :hover {
 *              svg {
 *                  height: 26px;
 *                  width: 26px;
 *                  color: ${color.bg_light};
 *              }
 *          }
 *      `;
 *
 *
 *
 *
 * It is important to note that the svg jsx components must have fill and stroke values set to 'currentcolor' for color changes to work.
 *
 *  */ function $f7580c2fb20f0ef1$var$Icons(_param) {
    var { ariaLabel: ariaLabel = '', name: name, size: size = 1, color: color = '', sizeInPx: sizeInPx, weight: weight } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "ariaLabel",
        "name",
        "size",
        "color",
        "sizeInPx",
        "weight"
    ]);
    if (size > 3) size = size / 16;
    const svgToRender = (0, $3adbcb77e640770e$export$6d49a893c897b0cc)[name] || null;
    const svgWithWeight = svgToRender && weight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(svgToRender, {
        weight: weight
    }) : svgToRender;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f7580c2fb20f0ef1$var$IconContainer, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": ariaLabel ? 'false' : 'true',
        $size: size,
        $color: color,
        $sizeInPx: sizeInPx
    }, restProps), {
        children: [
            svgWithWeight,
            ariaLabel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: ariaLabel
            })
        ]
    }));
}
const $f7580c2fb20f0ef1$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)('span')($f7580c2fb20f0ef1$var$t || ($f7580c2fb20f0ef1$var$t = $f7580c2fb20f0ef1$var$_`
    color: ${0};
    display: inline-block;
    line-height: 0;
    pointer-events: auto;
    svg {
        width: ${0};
        height: ${0};
    }
`), (props)=>props.$color || 'inherit', (props)=>(props.$sizeInPx ? props.$sizeInPx + 'px' : props.$size + 'rem') || '1.5rem', (props)=>(props.$sizeInPx ? props.$sizeInPx + 'px' : props.$size + 'rem') || '1.5rem');
var $f7580c2fb20f0ef1$export$2e2bcd8739ae039 = $f7580c2fb20f0ef1$var$Icons;




var $7fPBF = parcelRequire("7fPBF");
/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $99aa633853900a15$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $99aa633853900a15$export$825a82322d91916e = /^[\\/]{2}/;
function $99aa633853900a15$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $830828eb44359214$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $830828eb44359214$var$PopStateEventType = "popstate";
function $830828eb44359214$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $830828eb44359214$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $830828eb44359214$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $830828eb44359214$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $830828eb44359214$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $830828eb44359214$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $830828eb44359214$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $830828eb44359214$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $830828eb44359214$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        var _globalHistory_state;
        let maskedLocation = (_globalHistory_state = globalHistory.state) === null || _globalHistory_state === void 0 ? void 0 : _globalHistory_state.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $830828eb44359214$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $830828eb44359214$export$fe53371bee54353d(to);
    }
    return $830828eb44359214$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $830828eb44359214$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $830828eb44359214$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $830828eb44359214$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $830828eb44359214$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $830828eb44359214$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $830828eb44359214$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $830828eb44359214$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $830828eb44359214$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $830828eb44359214$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $830828eb44359214$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $830828eb44359214$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $830828eb44359214$export$8ccf933b0513f8d0(to) : to), {
        state: state,
        key: to && to.key || key || $830828eb44359214$var$createKey(),
        mask: mask
    });
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $830828eb44359214$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $830828eb44359214$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $830828eb44359214$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $830828eb44359214$var$isLocation(to) ? to : $830828eb44359214$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $830828eb44359214$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $830828eb44359214$var$isLocation(to) ? to : $830828eb44359214$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $830828eb44359214$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $830828eb44359214$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($830828eb44359214$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($830828eb44359214$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $830828eb44359214$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $830828eb44359214$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $830828eb44359214$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $99aa633853900a15$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $3e8576eccd4c7288$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $d86b59e89b8a0208$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $54af65440e83a537$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $d86b59e89b8a0208$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $3e8576eccd4c7288$export$71511d61b312f219)(receiver, descriptor);
}


function $4dddf84ac518a0ab$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $0a7837cd8c38b609$export$71511d61b312f219(obj, privateMap, value) {
    (0, $4dddf84ac518a0ab$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}








var $7fPBF = parcelRequire("7fPBF");
var $869207a87b6bfdfe$var$_map;
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $869207a87b6bfdfe$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $869207a87b6bfdfe$export$b8d3e69d4b3eff04 = ($869207a87b6bfdfe$var$_map = /*#__PURE__*/ new WeakMap(), class {
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if ((0, $54af65440e83a537$export$71511d61b312f219)(this, $869207a87b6bfdfe$var$_map).has(context)) return (0, $54af65440e83a537$export$71511d61b312f219)(this, $869207a87b6bfdfe$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        (0, $54af65440e83a537$export$71511d61b312f219)(this, $869207a87b6bfdfe$var$_map).set(context, value);
    }
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        (0, $0a7837cd8c38b609$export$71511d61b312f219)(this, $869207a87b6bfdfe$var$_map, {
            writable: true,
            value: /* @__PURE__ */ new Map()
        });
        if (init) for (let [context, value] of init)this.set(context, value);
    }
});
const $869207a87b6bfdfe$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $869207a87b6bfdfe$export$3e22299e33adeed1(key) {
    return $869207a87b6bfdfe$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $869207a87b6bfdfe$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $869207a87b6bfdfe$export$a89d811eaa209e85(key) {
    return $869207a87b6bfdfe$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $869207a87b6bfdfe$var$isIndexRoute(route) {
    return route.index === true;
}
function $869207a87b6bfdfe$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $7fPBF.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $869207a87b6bfdfe$export$87cb1a9238dc3fba(routes, mapRouteProperties = $869207a87b6bfdfe$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $830828eb44359214$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $830828eb44359214$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($869207a87b6bfdfe$var$isIndexRoute(route)) {
            let indexRoute = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, route), {
                id: id
            });
            manifest[id] = $869207a87b6bfdfe$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, route), {
                id: id,
                children: void 0
            });
            manifest[id] = $869207a87b6bfdfe$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $869207a87b6bfdfe$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $869207a87b6bfdfe$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, updates, typeof updates.lazy === "object" && updates.lazy != null ? {
        lazy: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, route.lazy, updates.lazy)
    } : {}));
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $869207a87b6bfdfe$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $869207a87b6bfdfe$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $869207a87b6bfdfe$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $869207a87b6bfdfe$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches !== null && precomputedBranches !== void 0 ? precomputedBranches : $869207a87b6bfdfe$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $869207a87b6bfdfe$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $869207a87b6bfdfe$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $869207a87b6bfdfe$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $869207a87b6bfdfe$export$e486c0390e42ccf6(routes) {
    let branches = $869207a87b6bfdfe$var$flattenRoutes(routes);
    $869207a87b6bfdfe$var$rankRouteBranches(branches);
    return branches;
}
function $869207a87b6bfdfe$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $830828eb44359214$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $869207a87b6bfdfe$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $830828eb44359214$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $869207a87b6bfdfe$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $869207a87b6bfdfe$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $869207a87b6bfdfe$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, meta), {
                    matcher: matcher,
                    compiledParams: params
                });
            })
        });
    };
    routes.forEach((route, index)=>{
        var _route_path;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $869207a87b6bfdfe$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $869207a87b6bfdfe$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $869207a87b6bfdfe$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $869207a87b6bfdfe$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $869207a87b6bfdfe$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $869207a87b6bfdfe$var$paramRe = /^:[\w-]+$/;
const $869207a87b6bfdfe$var$partialParamRe = /^:[\w-]+/;
const $869207a87b6bfdfe$var$partialDynamicSegmentValue = 3.5;
const $869207a87b6bfdfe$var$dynamicSegmentValue = 3;
const $869207a87b6bfdfe$var$indexRouteValue = 2;
const $869207a87b6bfdfe$var$emptySegmentValue = 1;
const $869207a87b6bfdfe$var$staticSegmentValue = 10;
const $869207a87b6bfdfe$var$splatPenalty = -2;
const $869207a87b6bfdfe$var$isSplat = (s)=>s === "*";
function $869207a87b6bfdfe$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($869207a87b6bfdfe$var$isSplat)) initialScore += $869207a87b6bfdfe$var$splatPenalty;
    if (index) initialScore += $869207a87b6bfdfe$var$indexRouteValue;
    return segments.filter((s)=>!$869207a87b6bfdfe$var$isSplat(s)).reduce((score, segment)=>score + ($869207a87b6bfdfe$var$paramRe.test(segment) ? $869207a87b6bfdfe$var$dynamicSegmentValue : $869207a87b6bfdfe$var$partialParamRe.test(segment) ? $869207a87b6bfdfe$var$partialDynamicSegmentValue : segment === "" ? $869207a87b6bfdfe$var$emptySegmentValue : $869207a87b6bfdfe$var$staticSegmentValue), initialScore);
}
function $869207a87b6bfdfe$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $869207a87b6bfdfe$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $869207a87b6bfdfe$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $869207a87b6bfdfe$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $869207a87b6bfdfe$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $869207a87b6bfdfe$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $869207a87b6bfdfe$var$normalizePathname($869207a87b6bfdfe$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $869207a87b6bfdfe$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $869207a87b6bfdfe$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $869207a87b6bfdfe$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$869207a87b6bfdfe$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $869207a87b6bfdfe$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $830828eb44359214$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $830828eb44359214$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $869207a87b6bfdfe$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $869207a87b6bfdfe$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $869207a87b6bfdfe$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $869207a87b6bfdfe$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $869207a87b6bfdfe$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $869207a87b6bfdfe$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $830828eb44359214$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $869207a87b6bfdfe$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $830828eb44359214$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $869207a87b6bfdfe$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $869207a87b6bfdfe$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $869207a87b6bfdfe$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $869207a87b6bfdfe$export$a1cbf2de32a9fd1 = (url)=>(0, $99aa633853900a15$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $869207a87b6bfdfe$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $869207a87b6bfdfe$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/")) pathname = $869207a87b6bfdfe$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $869207a87b6bfdfe$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $869207a87b6bfdfe$var$normalizeSearch(search),
        hash: $869207a87b6bfdfe$var$normalizeHash(hash)
    };
}
function $869207a87b6bfdfe$var$resolvePathname(relativePath, fromPathname) {
    let segments = $869207a87b6bfdfe$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $869207a87b6bfdfe$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $869207a87b6bfdfe$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $869207a87b6bfdfe$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $869207a87b6bfdfe$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $869207a87b6bfdfe$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $830828eb44359214$export$8ccf933b0513f8d0)(toArg);
    else {
        to = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, toArg);
        (0, $830828eb44359214$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $869207a87b6bfdfe$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $830828eb44359214$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $869207a87b6bfdfe$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $830828eb44359214$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $869207a87b6bfdfe$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $869207a87b6bfdfe$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $869207a87b6bfdfe$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $869207a87b6bfdfe$export$86d9a7913e44197e = (paths)=>$869207a87b6bfdfe$export$f857a07c5bd323b8(paths.join("/"));
const $869207a87b6bfdfe$export$b6d465111d914331 = (path)=>path.replace(/\/+$/, "");
const $869207a87b6bfdfe$var$normalizePathname = (pathname)=>$869207a87b6bfdfe$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $869207a87b6bfdfe$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $869207a87b6bfdfe$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $869207a87b6bfdfe$var$DataWithResponseInit = class {
    constructor(data, init){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", "DataWithResponseInit");
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "data", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "init", void 0);
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $869207a87b6bfdfe$export$4051a07651545597(data, init) {
    return new $869207a87b6bfdfe$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $869207a87b6bfdfe$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, responseInit), {
        headers: headers
    }));
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $869207a87b6bfdfe$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $869207a87b6bfdfe$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $869207a87b6bfdfe$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $869207a87b6bfdfe$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $869207a87b6bfdfe$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $869207a87b6bfdfe$export$f2680fa305b734ca = class {
    constructor(status, statusText, data, internal = false){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "status", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "statusText", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "data", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "error", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "internal", void 0);
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $869207a87b6bfdfe$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $869207a87b6bfdfe$export$d738435097971c09(matches) {
    return $869207a87b6bfdfe$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $869207a87b6bfdfe$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $869207a87b6bfdfe$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $869207a87b6bfdfe$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $99aa633853900a15$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($869207a87b6bfdfe$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $99aa633853900a15$export$825a82322d91916e).test(to) ? new URL((0, $99aa633853900a15$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $869207a87b6bfdfe$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        (0, $830828eb44359214$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

function $0b3c0e0699c28bdc$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $2906a6c695077413$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $d86b59e89b8a0208$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $0b3c0e0699c28bdc$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}








/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



//#region lib/router/instrumentation.ts
const $2bb0deb7d52e689e$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $2bb0deb7d52e689e$export$b1aab28b8e9d7d25 = (0, $869207a87b6bfdfe$export$fd42f52fd3ae1109)();
let $2bb0deb7d52e689e$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $2bb0deb7d52e689e$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $2bb0deb7d52e689e$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.loader, $2bb0deb7d52e689e$var$getHandlerInfo(args[0]), ()=>original(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $2bb0deb7d52e689e$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $2bb0deb7d52e689e$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.action, $2bb0deb7d52e689e$var$getHandlerInfo(args[0]), ()=>original(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
        };
        $2bb0deb7d52e689e$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $2bb0deb7d52e689e$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.middleware, $2bb0deb7d52e689e$var$getHandlerInfo(args[0]), ()=>original(...args), $2bb0deb7d52e689e$var$getInstrumentationInnerResult));
        };
        $2bb0deb7d52e689e$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $2bb0deb7d52e689e$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $2bb0deb7d52e689e$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $830828eb44359214$export$fe53371bee54353d)(to) : "."
            }, $2bb0deb7d52e689e$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
            return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $2bb0deb7d52e689e$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $2bb0deb7d52e689e$var$getInstrumentationInnerResult(result)), {
                    meta: meta
                })));
        };
        $2bb0deb7d52e689e$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $2bb0deb7d52e689e$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.fetch, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key
            }, $2bb0deb7d52e689e$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {})), async ()=>{
                let cleanup = $2bb0deb7d52e689e$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $2bb0deb7d52e689e$var$getInstrumentationInnerResult(result)), {
                    meta: meta
                })));
        };
        $2bb0deb7d52e689e$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $2bb0deb7d52e689e$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context !== null && context !== void 0 ? context : new (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04)();
        return $2bb0deb7d52e689e$var$throwOrReturnResult(await $2bb0deb7d52e689e$var$recurseRight(aggregated.request, {
            request: $2bb0deb7d52e689e$var$getReadonlyRequest(request),
            context: $2bb0deb7d52e689e$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                var _info_context;
                meta = (_info_context = info.context) === null || _info_context === void 0 ? void 0 : _info_context.get($2bb0deb7d52e689e$export$b1aab28b8e9d7d25);
            } catch (e) {}
            (0, $830828eb44359214$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $2bb0deb7d52e689e$var$getInstrumentationInnerResult(result)), {
                statusCode: result.value.status,
                meta: meta
            });
        }));
    };
    return instrumentedHandler;
}
function $2bb0deb7d52e689e$var$getUninstrumentedHandler(handler) {
    var _handler_UninstrumentedSymbol;
    return (_handler_UninstrumentedSymbol = handler[$2bb0deb7d52e689e$var$UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
}
function $2bb0deb7d52e689e$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$2bb0deb7d52e689e$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $2bb0deb7d52e689e$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $2bb0deb7d52e689e$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($2bb0deb7d52e689e$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $2bb0deb7d52e689e$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $2bb0deb7d52e689e$export$5579798e35f5560e(router) {
    let receiver = $2bb0deb7d52e689e$var$instrumentationClientResultMetaReceivers.get(router);
    $2bb0deb7d52e689e$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $2bb0deb7d52e689e$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $2bb0deb7d52e689e$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $2bb0deb7d52e689e$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $830828eb44359214$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $2bb0deb7d52e689e$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $2bb0deb7d52e689e$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, args), {
        request: $2bb0deb7d52e689e$var$getReadonlyRequest(request),
        params: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, params),
        context: $2bb0deb7d52e689e$var$getReadonlyContext(context)
    });
}
function $2bb0deb7d52e689e$var$getRouterInfo(router, opts) {
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        currentUrl: (0, $830828eb44359214$export$fe53371bee54353d)(router.state.location)
    }, "formMethod" in opts ? {
        formMethod: opts.formMethod
    } : {}, "formEncType" in opts ? {
        formEncType: opts.formEncType
    } : {}, "formData" in opts ? {
        formData: opts.formData
    } : {}, "body" in opts ? {
        body: opts.body
    } : {});
}
function $2bb0deb7d52e689e$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $2bb0deb7d52e689e$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


var $320f70ca3b146d69$var$_routes, $320f70ca3b146d69$var$_branches, $320f70ca3b146d69$var$_hmrRoutes, $320f70ca3b146d69$var$_hmrBranches;
//#region lib/router/router.ts
const $320f70ca3b146d69$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $320f70ca3b146d69$var$validMutationMethods = new Set($320f70ca3b146d69$var$validMutationMethodsArr);
const $320f70ca3b146d69$var$validRequestMethodsArr = [
    "GET",
    ...$320f70ca3b146d69$var$validMutationMethodsArr
];
const $320f70ca3b146d69$var$validRequestMethods = new Set($320f70ca3b146d69$var$validRequestMethodsArr);
const $320f70ca3b146d69$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $320f70ca3b146d69$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $320f70ca3b146d69$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $320f70ca3b146d69$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $320f70ca3b146d69$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $320f70ca3b146d69$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $320f70ca3b146d69$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $320f70ca3b146d69$var$DataRoutes = ($320f70ca3b146d69$var$_routes = /*#__PURE__*/ new WeakMap(), $320f70ca3b146d69$var$_branches = /*#__PURE__*/ new WeakMap(), $320f70ca3b146d69$var$_hmrRoutes = /*#__PURE__*/ new WeakMap(), $320f70ca3b146d69$var$_hmrBranches = /*#__PURE__*/ new WeakMap(), class {
    /** The stable route tree */ get stableRoutes() {
        return (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        var _class_private_field_get1;
        return (_class_private_field_get1 = (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes)) !== null && _class_private_field_get1 !== void 0 ? _class_private_field_get1 : (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        var _class_private_field_get1;
        return (_class_private_field_get1 = (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrBranches)) !== null && _class_private_field_get1 !== void 0 ? _class_private_field_get1 : (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_branches);
    }
    get hasHMRRoutes() {
        return (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_routes, routes);
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_branches, (0, $869207a87b6bfdfe$export$e486c0390e42ccf6)(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes, routes);
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrBranches, (0, $869207a87b6bfdfe$export$e486c0390e42ccf6)(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ((0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes)) {
            (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_routes, (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes));
            (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_branches, (0, $54af65440e83a537$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrBranches));
            (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes, void 0);
            (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrBranches, void 0);
        }
    }
    constructor(routes){
        (0, $0a7837cd8c38b609$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_routes, {
            writable: true,
            value: void 0
        });
        (0, $0a7837cd8c38b609$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_branches, {
            writable: true,
            value: void 0
        });
        (0, $0a7837cd8c38b609$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrRoutes, {
            writable: true,
            value: void 0
        });
        (0, $0a7837cd8c38b609$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_hmrBranches, {
            writable: true,
            value: void 0
        });
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_routes, routes);
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $320f70ca3b146d69$var$_branches, (0, $869207a87b6bfdfe$export$e486c0390e42ccf6)(routes));
    }
});
/**
* Create a router and listen to history POP navigations
*/ function $320f70ca3b146d69$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $830828eb44359214$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _mapRouteProperties === null || _mapRouteProperties === void 0 ? void 0 : _mapRouteProperties(route), (0, $2bb0deb7d52e689e$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route));
        };
    }
    let manifest = {};
    let dataRoutes = new $320f70ca3b146d69$var$DataRoutes((0, $869207a87b6bfdfe$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $320f70ca3b146d69$var$defaultDataStrategyWithMiddleware;
    let future = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, init.future);
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $320f70ca3b146d69$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $320f70ca3b146d69$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$320f70ca3b146d69$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $320f70ca3b146d69$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $320f70ca3b146d69$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $830828eb44359214$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $320f70ca3b146d69$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $320f70ca3b146d69$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$320f70ca3b146d69$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state, newState);
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        var _newState_errors;
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>{
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        var _location_state, _location_state1;
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $320f70ca3b146d69$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $320f70ca3b146d69$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $320f70ca3b146d69$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $320f70ca3b146d69$export$cbae47800eb95bc3(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP") {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, newState), {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $320f70ca3b146d69$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $320f70ca3b146d69$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $2bb0deb7d52e689e$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $320f70ca3b146d69$var$normalizeNavigateOptions(false, $320f70ca3b146d69$var$normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative), opts);
        let maskPath;
        if (opts === null || opts === void 0 ? void 0 : opts.mask) maskPath = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            pathname: "",
            search: "",
            hash: ""
        }, typeof opts.mask === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(opts.mask) : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.location.mask, opts.mask));
        let currentLocation = state.location;
        let nextLocation = (0, $830828eb44359214$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $320f70ca3b146d69$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $320f70ca3b146d69$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $320f70ca3b146d69$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $320f70ca3b146d69$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $320f70ca3b146d69$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts === null || opts === void 0 ? void 0 : opts.instrumentationNavigateMetaReceiver) {
            let meta = $320f70ca3b146d69$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts.overrideNavigation), {
            matches: matches,
            historyAction: historyAction
        }) : void 0;
        pendingNavigationController = new AbortController();
        let request = $320f70ca3b146d69$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $320f70ca3b146d69$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $320f70ca3b146d69$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($320f70ca3b146d69$var$isErrorResult(result) && (0, $869207a87b6bfdfe$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $320f70ca3b146d69$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $320f70ca3b146d69$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            matches: updatedMatches || matches
        }, $320f70ca3b146d69$var$getActionDataForCommit(pendingActionResult)), {
            loaderData: loaderData,
            errors: errors
        }), workingFetchers ? {
            fetchers: workingFetchers
        } : {}));
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $320f70ca3b146d69$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $320f70ca3b146d69$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $320f70ca3b146d69$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $320f70ca3b146d69$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $320f70ca3b146d69$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($320f70ca3b146d69$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $320f70ca3b146d69$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($320f70ca3b146d69$var$isErrorResult(result)) {
            let boundaryMatch = $320f70ca3b146d69$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $320f70ca3b146d69$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $320f70ca3b146d69$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    navigation: loadingNavigation
                }, actionData !== void 0 ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $320f70ca3b146d69$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $320f70ca3b146d69$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $320f70ca3b146d69$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $320f70ca3b146d69$var$getActionDataForCommit(pendingActionResult), didUpdateFetcherRedirects ? {
                fetchers: workingFetchers
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $320f70ca3b146d69$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $320f70ca3b146d69$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $320f70ca3b146d69$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.errors, errors);
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            workingFetchers: workingFetchers
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$320f70ca3b146d69$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $320f70ca3b146d69$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $2bb0deb7d52e689e$export$5579798e35f5560e)(router);
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $320f70ca3b146d69$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let matches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($320f70ca3b146d69$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $320f70ca3b146d69$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $320f70ca3b146d69$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $320f70ca3b146d69$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $320f70ca3b146d69$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $320f70ca3b146d69$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $320f70ca3b146d69$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $320f70ca3b146d69$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $320f70ca3b146d69$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($320f70ca3b146d69$var$isRedirectResult(actionResult) || $320f70ca3b146d69$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $320f70ca3b146d69$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($320f70ca3b146d69$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $320f70ca3b146d69$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $320f70ca3b146d69$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($320f70ca3b146d69$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $320f70ca3b146d69$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        (0, $830828eb44359214$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $320f70ca3b146d69$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $320f70ca3b146d69$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $320f70ca3b146d69$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $320f70ca3b146d69$var$getDoneFetcher(actionResult.data));
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, s), {
                fetchers: workingFetchers
            });
        };
        let redirect = $320f70ca3b146d69$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $320f70ca3b146d69$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $320f70ca3b146d69$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $320f70ca3b146d69$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $830828eb44359214$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $320f70ca3b146d69$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $320f70ca3b146d69$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $320f70ca3b146d69$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $320f70ca3b146d69$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $320f70ca3b146d69$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $320f70ca3b146d69$var$getDoneFetcher(void 0));
            return;
        }
        if ($320f70ca3b146d69$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $320f70ca3b146d69$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($320f70ca3b146d69$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $320f70ca3b146d69$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $830828eb44359214$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        location = $320f70ca3b146d69$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = (0, $830828eb44359214$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $869207a87b6bfdfe$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $830828eb44359214$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $320f70ca3b146d69$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($320f70ca3b146d69$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $320f70ca3b146d69$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, activeSubmission), {
                formAction: location
            }),
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $320f70ca3b146d69$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $320f70ca3b146d69$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$320f70ca3b146d69$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            var _results_match_route_id;
            if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.type) === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($320f70ca3b146d69$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $320f70ca3b146d69$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $320f70ca3b146d69$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $320f70ca3b146d69$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $320f70ca3b146d69$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $320f70ca3b146d69$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, $320f70ca3b146d69$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $830828eb44359214$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $320f70ca3b146d69$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $830828eb44359214$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $830828eb44359214$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $320f70ca3b146d69$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $320f70ca3b146d69$export$386d57f03f0b2883;
        (0, $830828eb44359214$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $830828eb44359214$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $320f70ca3b146d69$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $320f70ca3b146d69$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $320f70ca3b146d69$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $869207a87b6bfdfe$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) return {
                active: true,
                matches: (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $320f70ca3b146d69$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $869207a87b6bfdfe$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $320f70ca3b146d69$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $2bb0deb7d52e689e$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $320f70ca3b146d69$export$3336b097a6fbc59a(routes, opts) {
    (0, $830828eb44359214$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts === null || opts === void 0 ? void 0 : opts.future);
    if (opts === null || opts === void 0 ? void 0 : opts.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _mapRouteProperties === null || _mapRouteProperties === void 0 ? void 0 : _mapRouteProperties(route), (0, $2bb0deb7d52e689e$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route));
        };
    }
    let dataRoutes = (0, $869207a87b6bfdfe$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    let routeBranches = (0, $869207a87b6bfdfe$export$e486c0390e42ccf6)(dataRoutes);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $320f70ca3b146d69$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $830828eb44359214$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04)();
        if (!$320f70ca3b146d69$var$isValidMethod(method) && method !== "HEAD") {
            let error = $320f70ca3b146d69$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $320f70ca3b146d69$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $320f70ca3b146d69$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $320f70ca3b146d69$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $830828eb44359214$export$f5708dca728d7177)(requestContext instanceof (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $320f70ca3b146d69$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $320f70ca3b146d69$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $869207a87b6bfdfe$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $869207a87b6bfdfe$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        var _opts_filterMatchesToLoad;
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? (_opts_filterMatchesToLoad = opts.filterMatchesToLoad) !== null && _opts_filterMatchesToLoad !== void 0 ? _opts_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true);
                        if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            location: location,
                            basename: basename
                        }, result);
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($320f70ca3b146d69$export$6e80290866a84dd4(error)) return error;
                    if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(error.status, error.statusText, await $320f70ca3b146d69$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($320f70ca3b146d69$export$e0163cfdf7bc9cfa(error)) error = $320f70ca3b146d69$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $320f70ca3b146d69$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $320f70ca3b146d69$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        var _matches_find;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $320f70ca3b146d69$var$findNearestBoundary(matches, ((_matches_find = matches.find((m)=>m.route.id === routeId || m.route.loader)) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id]: error
                            },
                            statusCode: (0, $869207a87b6bfdfe$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $830828eb44359214$export$f5708dca728d7177)($320f70ca3b146d69$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(result)) return result;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            location: location,
            basename: basename
        }, result);
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $320f70ca3b146d69$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $830828eb44359214$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04)();
        if (!$320f70ca3b146d69$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $320f70ca3b146d69$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $320f70ca3b146d69$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $320f70ca3b146d69$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $320f70ca3b146d69$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $320f70ca3b146d69$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $830828eb44359214$export$f5708dca728d7177)(requestContext instanceof (0, $869207a87b6bfdfe$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $320f70ca3b146d69$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $320f70ca3b146d69$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $869207a87b6bfdfe$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $869207a87b6bfdfe$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $320f70ca3b146d69$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($320f70ca3b146d69$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($320f70ca3b146d69$var$dataWithResponseInitToResponse(error));
                if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $830828eb44359214$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($320f70ca3b146d69$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $320f70ca3b146d69$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $320f70ca3b146d69$export$3f1eb41d9a6a6a27(result) ? result : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result), {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            if ($320f70ca3b146d69$var$isDataStrategyResult(e) && $320f70ca3b146d69$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($320f70ca3b146d69$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $320f70ca3b146d69$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $320f70ca3b146d69$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($320f70ca3b146d69$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($320f70ca3b146d69$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($320f70ca3b146d69$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $320f70ca3b146d69$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $869207a87b6bfdfe$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}),
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($320f70ca3b146d69$var$isErrorResult(result)) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
            (skipLoaderErrorBubbling ? actionMatch : $320f70ca3b146d69$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
            result
        ])), {
            statusCode: (0, $869207a87b6bfdfe$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad)), {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }), result.statusCode ? {
            statusCode: result.statusCode
        } : {}), {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw $320f70ca3b146d69$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $869207a87b6bfdfe$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $320f70ca3b146d69$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $320f70ca3b146d69$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $320f70ca3b146d69$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $320f70ca3b146d69$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling)), {
            matches: matches
        });
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $320f70ca3b146d69$var$callDataStrategyImpl(dataStrategy || $320f70ca3b146d69$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($320f70ca3b146d69$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $320f70ca3b146d69$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($320f70ca3b146d69$export$e0163cfdf7bc9cfa(result.result)) throw $320f70ca3b146d69$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $320f70ca3b146d69$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $320f70ca3b146d69$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerContext), {
        statusCode: (0, $869207a87b6bfdfe$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    });
}
function $320f70ca3b146d69$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $320f70ca3b146d69$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $320f70ca3b146d69$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $320f70ca3b146d69$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $869207a87b6bfdfe$export$cae722b0cc860f13)(to ? to : ".", (0, $869207a87b6bfdfe$export$fe6dbc5de95f53ab)(contextualMatches), (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $320f70ca3b146d69$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $869207a87b6bfdfe$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $830828eb44359214$export$fe53371bee54353d)(path);
}
function $320f70ca3b146d69$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$320f70ca3b146d69$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$320f70ca3b146d69$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $320f70ca3b146d69$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $320f70ca3b146d69$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $320f70ca3b146d69$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$320f70ca3b146d69$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$320f70ca3b146d69$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    (0, $830828eb44359214$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $320f70ca3b146d69$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $320f70ca3b146d69$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $320f70ca3b146d69$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $320f70ca3b146d69$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($320f70ca3b146d69$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $830828eb44359214$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $320f70ca3b146d69$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $830828eb44359214$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $320f70ca3b146d69$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    var _state_matches_;
    let actionResult = pendingActionResult ? $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    let pattern = (0, $869207a87b6bfdfe$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$320f70ca3b146d69$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $320f70ca3b146d69$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($320f70ca3b146d69$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $320f70ca3b146d69$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($320f70ca3b146d69$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        return $320f70ca3b146d69$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $320f70ca3b146d69$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(routesToUse, f.path, basename !== null && basename !== void 0 ? basename : "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $320f70ca3b146d69$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $320f70ca3b146d69$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            if ($320f70ca3b146d69$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $320f70ca3b146d69$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $320f70ca3b146d69$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$320f70ca3b146d69$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $320f70ca3b146d69$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $320f70ca3b146d69$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $320f70ca3b146d69$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $320f70ca3b146d69$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $830828eb44359214$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$320f70ca3b146d69$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $869207a87b6bfdfe$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $869207a87b6bfdfe$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $320f70ca3b146d69$var$isSameRoute(newRoute, existingRoute) {
    var _newRoute_children;
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    var _newRoute_children_every;
    return (_newRoute_children_every = (_newRoute_children = newRoute.children) === null || _newRoute_children === void 0 ? void 0 : _newRoute_children.every((aChild, i)=>{
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some((bChild)=>$320f70ca3b146d69$var$isSameRoute(aChild, bChild));
    })) !== null && _newRoute_children_every !== void 0 ? _newRoute_children_every : false;
}
const $320f70ca3b146d69$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $320f70ca3b146d69$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $830828eb44359214$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $320f70ca3b146d69$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $320f70ca3b146d69$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $869207a87b6bfdfe$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $830828eb44359214$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $830828eb44359214$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $320f70ca3b146d69$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $320f70ca3b146d69$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $830828eb44359214$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $320f70ca3b146d69$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $830828eb44359214$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $869207a87b6bfdfe$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $830828eb44359214$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $830828eb44359214$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mapRouteProperties(routeToUpdate)), {
                lazy: void 0
            }));
        })();
        $320f70ca3b146d69$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $320f70ca3b146d69$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(()=>{});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $320f70ca3b146d69$var$isNonNullable(value) {
    return value !== void 0;
}
function $320f70ca3b146d69$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $320f70ca3b146d69$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($320f70ca3b146d69$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $320f70ca3b146d69$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $320f70ca3b146d69$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $320f70ca3b146d69$var$defaultDataStrategy(args);
    return $320f70ca3b146d69$var$runClientMiddlewarePipeline(args, ()=>$320f70ca3b146d69$var$defaultDataStrategy(args));
}
function $320f70ca3b146d69$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $320f70ca3b146d69$var$runMiddlewarePipeline(args, handler, processResult, $320f70ca3b146d69$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $320f70ca3b146d69$export$e0163cfdf7bc9cfa(result) ? $320f70ca3b146d69$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $320f70ca3b146d69$var$runClientMiddlewarePipeline(args, handler) {
    return $320f70ca3b146d69$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($320f70ca3b146d69$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $320f70ca3b146d69$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                var _match__lazyPromises;
                await ((_match__lazyPromises = match._lazyPromises) === null || _match__lazyPromises === void 0 ? void 0 : _match__lazyPromises.route);
            } catch (e) {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$320f70ca3b146d69$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $320f70ca3b146d69$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches } = args, dataFnArgs = (0, $8901fc92b5563702$export$71511d61b312f219)(args, [
        "matches"
    ]);
    return await $320f70ca3b146d69$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $320f70ca3b146d69$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    var _request_signal_reason;
    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $320f70ca3b146d69$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result !== null && result !== void 0 ? result : nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $320f70ca3b146d69$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $320f70ca3b146d69$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $320f70ca3b146d69$var$loadLazyRoute(match.route, $320f70ca3b146d69$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $320f70ca3b146d69$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $320f70ca3b146d69$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $320f70ca3b146d69$var$shouldRevalidateLoader(match, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            }));
            if (typeof defaultShouldRevalidate === "boolean") return $320f70ca3b146d69$var$shouldRevalidateLoader(match, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return $320f70ca3b146d69$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$320f70ca3b146d69$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($320f70ca3b146d69$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $320f70ca3b146d69$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    });
}
function $320f70ca3b146d69$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, match), {
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $320f70ca3b146d69$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        });
        return $320f70ca3b146d69$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $869207a87b6bfdfe$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $320f70ca3b146d69$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    })) await Promise.all(matches.map((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    }));
    let dataStrategyArgs = {
        request: request,
        url: (0, $869207a87b6bfdfe$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $869207a87b6bfdfe$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $320f70ca3b146d69$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, typedDataStrategyArgs), {
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            }));
        });
    };
    let results = await dataStrategyImpl((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, dataStrategyArgs), {
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    }));
    try {
        await Promise.all(matches.flatMap((m)=>{
            var _m__lazyPromises, _m__lazyPromises1;
            return [
                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
            ];
        }));
    } catch (e) {}
    return results;
}
async function $320f70ca3b146d69$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $320f70ca3b146d69$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $869207a87b6bfdfe$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $320f70ca3b146d69$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $320f70ca3b146d69$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $320f70ca3b146d69$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $320f70ca3b146d69$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    var _result_init, _result_init1;
    let { result: result, type: type } = dataStrategyResult;
    if ($320f70ca3b146d69$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $320f70ca3b146d69$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($320f70ca3b146d69$export$e0163cfdf7bc9cfa(result)) {
            var _result_init2, _result_init3, _result_init4;
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $320f70ca3b146d69$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $869207a87b6bfdfe$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $869207a87b6bfdfe$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($320f70ca3b146d69$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
        headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $320f70ca3b146d69$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $830828eb44359214$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $869207a87b6bfdfe$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $320f70ca3b146d69$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $320f70ca3b146d69$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $320f70ca3b146d69$export$961a3ef7a4da3a39(location) {
    try {
        return $320f70ca3b146d69$var$invalidProtocols.includes(new URL(location).protocol);
    } catch (e) {
        return false;
    }
}
function $320f70ca3b146d69$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $869207a87b6bfdfe$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $99aa633853900a15$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $99aa633853900a15$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($320f70ca3b146d69$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $869207a87b6bfdfe$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($320f70ca3b146d69$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $320f70ca3b146d69$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($320f70ca3b146d69$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $320f70ca3b146d69$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $320f70ca3b146d69$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $320f70ca3b146d69$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $320f70ca3b146d69$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $320f70ca3b146d69$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $830828eb44359214$export$f5708dca728d7177)(!$320f70ca3b146d69$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($320f70ca3b146d69$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $320f70ca3b146d69$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $320f70ca3b146d69$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $869207a87b6bfdfe$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $320f70ca3b146d69$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $320f70ca3b146d69$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $830828eb44359214$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($320f70ca3b146d69$var$isErrorResult(result)) {
            let boundaryMatch = $320f70ca3b146d69$var$findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, errors), {
                [boundaryMatch.route.id]: result.error
            });
            workingFetchers.delete(key);
        } else if ($320f70ca3b146d69$var$isRedirectResult(result)) (0, $830828eb44359214$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $320f70ca3b146d69$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $320f70ca3b146d69$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $320f70ca3b146d69$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $320f70ca3b146d69$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $320f70ca3b146d69$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $320f70ca3b146d69$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $320f70ca3b146d69$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $320f70ca3b146d69$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $320f70ca3b146d69$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($320f70ca3b146d69$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $320f70ca3b146d69$var$stripHashFromPath(path) {
    return (0, $830828eb44359214$export$fe53371bee54353d)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, typeof path === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(path) : path), {
        hash: ""
    }));
}
function $320f70ca3b146d69$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $320f70ca3b146d69$var$dataWithResponseInitToResponse(data) {
    var _data_init;
    return Response.json(data.data, (_data_init = data.init) !== null && _data_init !== void 0 ? _data_init : void 0);
}
function $320f70ca3b146d69$var$dataWithResponseInitToErrorResponse(data) {
    var _data_init, _data_init1;
    var _data_init_status, _data_init_statusText;
    return new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)((_data_init_status = (_data_init = data.init) === null || _data_init === void 0 ? void 0 : _data_init.status) !== null && _data_init_status !== void 0 ? _data_init_status : 500, (_data_init_statusText = (_data_init1 = data.init) === null || _data_init1 === void 0 ? void 0 : _data_init1.statusText) !== null && _data_init_statusText !== void 0 ? _data_init_statusText : "Internal Server Error", data.data);
}
function $320f70ca3b146d69$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $320f70ca3b146d69$var$isDataStrategyResult(value));
}
function $320f70ca3b146d69$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $320f70ca3b146d69$var$isRedirectDataStrategyResult(result) {
    return $320f70ca3b146d69$export$3f1eb41d9a6a6a27(result.result) && $320f70ca3b146d69$var$redirectStatusCodes.has(result.result.status);
}
function $320f70ca3b146d69$var$isErrorResult(result) {
    return result.type === "error";
}
function $320f70ca3b146d69$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $320f70ca3b146d69$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $320f70ca3b146d69$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $320f70ca3b146d69$export$794b2760043cf8cd(statusCode) {
    return $320f70ca3b146d69$var$redirectStatusCodes.has(statusCode);
}
function $320f70ca3b146d69$export$6e80290866a84dd4(result) {
    return $320f70ca3b146d69$export$3f1eb41d9a6a6a27(result) && $320f70ca3b146d69$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $320f70ca3b146d69$var$isValidMethod(method) {
    return $320f70ca3b146d69$var$validRequestMethods.has(method.toUpperCase());
}
function $320f70ca3b146d69$export$cbae47800eb95bc3(method) {
    return $320f70ca3b146d69$var$validMutationMethods.has(method.toUpperCase());
}
function $320f70ca3b146d69$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $320f70ca3b146d69$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $320f70ca3b146d69$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $869207a87b6bfdfe$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $320f70ca3b146d69$var$getInstrumentationNavigateMeta(history, location, matches) {
    var _matches_;
    return {
        url: (0, $869207a87b6bfdfe$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $869207a87b6bfdfe$export$d738435097971c09)(matches) : "",
        params: (matches === null || matches === void 0 ? void 0 : (_matches_ = matches[0]) === null || _matches_ === void 0 ? void 0 : _matches_.params) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, matches[0].params) : {}
    };
}
function $320f70ca3b146d69$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $320f70ca3b146d69$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $320f70ca3b146d69$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $320f70ca3b146d69$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $320f70ca3b146d69$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $320f70ca3b146d69$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $320f70ca3b146d69$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($320f70ca3b146d69$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $320f70ca3b146d69$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($320f70ca3b146d69$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $830828eb44359214$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $320f70ca3b146d69$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
//#region lib/context.ts
const $70040d9784a39bd0$export$2eeee58951ff3c1c = $7fPBF.createContext(null);
$70040d9784a39bd0$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $70040d9784a39bd0$export$315e3ffb01f217 = $7fPBF.createContext(null);
$70040d9784a39bd0$export$315e3ffb01f217.displayName = "DataRouterState";
const $70040d9784a39bd0$export$717f757c655223f1 = $7fPBF.createContext(false);
function $70040d9784a39bd0$export$6e1eeb090b3ec35b() {
    return $7fPBF.useContext($70040d9784a39bd0$export$717f757c655223f1);
}
const $70040d9784a39bd0$export$3681f408decb40d1 = $7fPBF.createContext({
    isTransitioning: false
});
$70040d9784a39bd0$export$3681f408decb40d1.displayName = "ViewTransition";
const $70040d9784a39bd0$export$cb3f1df1bef00a39 = $7fPBF.createContext(/* @__PURE__ */ new Map());
$70040d9784a39bd0$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $70040d9784a39bd0$export$804c460aade54ac8 = $7fPBF.createContext(null);
$70040d9784a39bd0$export$804c460aade54ac8.displayName = "Await";
const $70040d9784a39bd0$export$2666c20e15407622 = (props)=>$7fPBF.createElement($70040d9784a39bd0$export$804c460aade54ac8.Provider, props);
const $70040d9784a39bd0$export$3044ab7fdabeaee6 = $7fPBF.createContext(null);
$70040d9784a39bd0$export$3044ab7fdabeaee6.displayName = "Navigation";
const $70040d9784a39bd0$export$e6a44b110a0c44d3 = $7fPBF.createContext(null);
$70040d9784a39bd0$export$e6a44b110a0c44d3.displayName = "Location";
const $70040d9784a39bd0$export$aac280ed165a4397 = $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$70040d9784a39bd0$export$aac280ed165a4397.displayName = "Route";
const $70040d9784a39bd0$export$af8bd2647fea9c11 = $7fPBF.createContext(null);
$70040d9784a39bd0$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 







/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $56e78b6ee5fd5399$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $56e78b6ee5fd5399$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $56e78b6ee5fd5399$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $56e78b6ee5fd5399$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$56e78b6ee5fd5399$var$ERROR_DIGEST_BASE}:${$56e78b6ee5fd5399$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch (e) {}
}
function $56e78b6ee5fd5399$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$56e78b6ee5fd5399$var$ERROR_DIGEST_BASE}:${$56e78b6ee5fd5399$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch (e) {}
}



var $7fPBF = parcelRequire("7fPBF");
var $39c9549f68558626$var$_React$1_Component, $39c9549f68558626$var$_class;
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $39c9549f68558626$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $830828eb44359214$export$f5708dca728d7177)($39c9549f68558626$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $39c9549f68558626$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $39c9549f68558626$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext((0, $70040d9784a39bd0$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $39c9549f68558626$export$45d76561a5302f2b() {
    (0, $830828eb44359214$export$f5708dca728d7177)($39c9549f68558626$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $7fPBF.useContext((0, $70040d9784a39bd0$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $39c9549f68558626$export$1b3f31771c5d07c() {
    return $7fPBF.useContext((0, $70040d9784a39bd0$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $39c9549f68558626$export$6c330e8992e8a295(pattern) {
    (0, $830828eb44359214$export$f5708dca728d7177)($39c9549f68558626$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $39c9549f68558626$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $869207a87b6bfdfe$export$81336c211d5ff295)(pattern, (0, $869207a87b6bfdfe$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $39c9549f68558626$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $39c9549f68558626$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    return isDataRoute ? $39c9549f68558626$var$useNavigateStable() : $39c9549f68558626$var$useNavigateUnstable();
}
function $39c9549f68558626$var$useNavigateUnstable() {
    (0, $830828eb44359214$export$f5708dca728d7177)($39c9549f68558626$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let { matches: matches } = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    let { pathname: locationPathname } = $39c9549f68558626$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $869207a87b6bfdfe$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $7fPBF.useRef(false);
    $7fPBF.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $7fPBF.useCallback((to, options = {})=>{
        (0, $830828eb44359214$export$491112666e282270)(activeRef.current, $39c9549f68558626$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $869207a87b6bfdfe$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $39c9549f68558626$var$OutletContext = $7fPBF.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $39c9549f68558626$export$4138103a3ae699cc() {
    return $7fPBF.useContext($39c9549f68558626$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $39c9549f68558626$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397)).outlet;
    return $7fPBF.useMemo(()=>outlet && /* @__PURE__ */ $7fPBF.createElement($39c9549f68558626$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $39c9549f68558626$export$99eaa27ddbbb95ef() {
    var _matches_;
    let { matches: matches } = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    var _matches__params;
    return (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $39c9549f68558626$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    let { pathname: locationPathname } = $39c9549f68558626$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $869207a87b6bfdfe$export$fe6dbc5de95f53ab)(matches));
    return $7fPBF.useMemo(()=>(0, $869207a87b6bfdfe$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $39c9549f68558626$export$5d3fca4a98652595(routes, locationArg) {
    return $39c9549f68558626$export$f7ce0646a48561fb(routes, locationArg);
}
function $39c9549f68558626$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $830828eb44359214$export$f5708dca728d7177)($39c9549f68558626$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $39c9549f68558626$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $830828eb44359214$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $830828eb44359214$export$f5708dca728d7177)(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : (0, $869207a87b6bfdfe$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $39c9549f68558626$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0
            }, location),
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $39c9549f68558626$var$DefaultErrorComponent() {
    let error = $39c9549f68558626$export$ed527bf60f6e05f2();
    let message = (0, $869207a87b6bfdfe$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $39c9549f68558626$var$defaultErrorElement = /* @__PURE__ */ $7fPBF.createElement($39c9549f68558626$var$DefaultErrorComponent, null);
var $39c9549f68558626$var$RenderErrorBoundary = ($39c9549f68558626$var$_class = class extends ($39c9549f68558626$var$_React$1_Component = $7fPBF.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $56e78b6ee5fd5399$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7fPBF.createElement($39c9549f68558626$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}, (0, $919ebf39980bf8f3$export$71511d61b312f219)($39c9549f68558626$var$_class, "contextType", (0, $70040d9784a39bd0$export$717f757c655223f1)), $39c9549f68558626$var$_class);
const $39c9549f68558626$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $39c9549f68558626$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $56e78b6ee5fd5399$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $39c9549f68558626$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $869207a87b6bfdfe$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ((0, $320f70ca3b146d69$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $869207a87b6bfdfe$export$4e09c449d6c407f7) && !$39c9549f68558626$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $39c9549f68558626$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7fPBF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $39c9549f68558626$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, children);
}
function $39c9549f68558626$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0);
        (0, $830828eb44359214$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            pattern: (0, $869207a87b6bfdfe$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $39c9549f68558626$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $39c9549f68558626$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7fPBF.createElement($39c9549f68558626$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7fPBF.createElement($39c9549f68558626$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $39c9549f68558626$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $39c9549f68558626$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $70040d9784a39bd0$export$2eeee58951ff3c1c));
    (0, $830828eb44359214$export$f5708dca728d7177)(ctx, $39c9549f68558626$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $39c9549f68558626$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $70040d9784a39bd0$export$315e3ffb01f217));
    (0, $830828eb44359214$export$f5708dca728d7177)(state, $39c9549f68558626$var$getDataRouterConsoleError(hookName));
    return state;
}
function $39c9549f68558626$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    (0, $830828eb44359214$export$f5708dca728d7177)(route, $39c9549f68558626$var$getDataRouterConsoleError(hookName));
    return route;
}
function $39c9549f68558626$var$useCurrentRouteId(hookName) {
    let route = $39c9549f68558626$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    (0, $830828eb44359214$export$f5708dca728d7177)(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
/**
* Returns the ID for the nearest contextual route
*
* @category Hooks
* @returns The ID of the nearest contextual route
*/ function $39c9549f68558626$export$4200b254756b08af() {
    return $39c9549f68558626$var$useCurrentRouteId("useRouteId");
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $39c9549f68558626$export$d0fd4b7106de2769() {
    let state = $39c9549f68558626$var$useDataRouterState("useNavigation");
    return $7fPBF.useMemo(()=>{
        let _state_navigation = state.navigation, { matches: matches, historyAction: historyAction } = _state_navigation, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_state_navigation, [
            "matches",
            "historyAction"
        ]);
        return rest;
    }, [
        state.navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $39c9549f68558626$export$600dc272ed516c15() {
    let dataRouterContext = $39c9549f68558626$var$useDataRouterContext("useRevalidator");
    let state = $39c9549f68558626$var$useDataRouterState("useRevalidator");
    let revalidate = $7fPBF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7fPBF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $39c9549f68558626$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $39c9549f68558626$var$useDataRouterState("useMatches");
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $869207a87b6bfdfe$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $39c9549f68558626$export$1448a5050d252c4d() {
    let state = $39c9549f68558626$var$useDataRouterState("useLoaderData");
    let routeId = $39c9549f68558626$var$useCurrentRouteId("useLoaderData");
    return state.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $39c9549f68558626$export$fd5d37484eab868d(routeId) {
    return $39c9549f68558626$var$useDataRouterState("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $39c9549f68558626$export$fdc00f3f26066d5e() {
    let state = $39c9549f68558626$var$useDataRouterState("useActionData");
    let routeId = $39c9549f68558626$var$useCurrentRouteId("useLoaderData");
    return state.actionData ? state.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $39c9549f68558626$export$ed527bf60f6e05f2() {
    var _state_errors;
    let error = $7fPBF.useContext((0, $70040d9784a39bd0$export$af8bd2647fea9c11));
    let state = $39c9549f68558626$var$useDataRouterState("useRouteError");
    let routeId = $39c9549f68558626$var$useCurrentRouteId("useRouteError");
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $39c9549f68558626$export$78a72ddb39bdd145() {
    var _React$1_useContext;
    return (_React$1_useContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$804c460aade54ac8))) === null || _React$1_useContext === void 0 ? void 0 : _React$1_useContext._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $39c9549f68558626$export$17f53340677d5831() {
    var _React$1_useContext;
    return (_React$1_useContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$804c460aade54ac8))) === null || _React$1_useContext === void 0 ? void 0 : _React$1_useContext._error;
}
let $39c9549f68558626$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $39c9549f68558626$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $39c9549f68558626$var$useDataRouterContext("useBlocker");
    let state = $39c9549f68558626$var$useDataRouterState("useBlocker");
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentLocation), {
                pathname: (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nextLocation), {
                pathname: (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7fPBF.useEffect(()=>{
        let key = String(++$39c9549f68558626$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $320f70ca3b146d69$export$386d57f03f0b2883);
}
function $39c9549f68558626$var$useNavigateStable() {
    let { router: router } = $39c9549f68558626$var$useDataRouterContext("useNavigate");
    let id = $39c9549f68558626$var$useCurrentRouteId("useNavigate");
    let activeRef = $7fPBF.useRef(false);
    $7fPBF.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $7fPBF.useCallback(async (to, options = {})=>{
        (0, $830828eb44359214$export$491112666e282270)(activeRef.current, $39c9549f68558626$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
}
const $39c9549f68558626$var$alreadyWarned = {};
function $39c9549f68558626$var$warningOnce(key, cond, message) {
    if (!cond && !$39c9549f68558626$var$alreadyWarned[key]) {
        $39c9549f68558626$var$alreadyWarned[key] = true;
        (0, $830828eb44359214$export$491112666e282270)(false, message);
    }
}
function $39c9549f68558626$export$3f79f0b98112cf57(...args) {
    var _state_actionData;
    const currentRouteId = $39c9549f68558626$var$useCurrentRouteId("useRoute");
    var _args_;
    const id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    const state = $39c9549f68558626$var$useDataRouterState("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
function $39c9549f68558626$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $39c9549f68558626$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $39c9549f68558626$var$useDataRouterState("unstable_useRouterState");
    let active = $7fPBF.useMemo(()=>{
        var _matches_;
        var _matches__params;
        return {
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {},
            matches: matches.map((m)=>$39c9549f68558626$var$toRouterStateMatch(m))
        };
    }, [
        location,
        matches,
        type
    ]);
    let pending = $7fPBF.useMemo(()=>{
        var _navigation_matches_;
        if (navigation.state === "idle") return null;
        var _navigation_matches__params;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: (_navigation_matches__params = (_navigation_matches_ = navigation.matches[navigation.matches.length - 1]) === null || _navigation_matches_ === void 0 ? void 0 : _navigation_matches_.params) !== null && _navigation_matches__params !== void 0 ? _navigation_matches__params : {},
            matches: navigation.matches.map((m)=>$39c9549f68558626$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, shared), {
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        }) : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, shared), {
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        });
    }, [
        navigation
    ]);
    return $7fPBF.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 







/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $125b0b57b9574ddd$var$alreadyWarned = {};
function $125b0b57b9574ddd$export$5b28268982f175ba(condition, message) {
    if (!condition && !$125b0b57b9574ddd$var$alreadyWarned[message]) {
        $125b0b57b9574ddd$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $7fPBF = parcelRequire("7fPBF");
//#region lib/components.tsx
const $74e05fac257f9d21$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $74e05fac257f9d21$export$f30f7e456d254e83(routes, opts) {
    return (0, $320f70ca3b146d69$export$baddd0131ee8c05b)({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: (0, $830828eb44359214$export$2b76ad033c6e6d08)({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $869207a87b6bfdfe$export$6bc17138063be773),
        hydrationRouteProperties: $74e05fac257f9d21$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
var $74e05fac257f9d21$var$Deferred = class {
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "status", "pending");
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "promise", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "resolve", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "reject", void 0);
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $74e05fac257f9d21$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $70040d9784a39bd0$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $7fPBF.useState(router.state);
    let [state, setOptimisticState] = (0, $7fPBF.useOptimistic)(_state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(/* @__PURE__ */ new Map());
    let setState = $7fPBF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>{
            var _newState_matches_;
            var _newState_matches__params;
            return onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                pattern: (0, $869207a87b6bfdfe$export$d738435097971c09)(newState.matches)
            });
        });
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $125b0b57b9574ddd$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $125b0b57b9574ddd$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7fPBF.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$74e05fac257f9d21$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $74e05fac257f9d21$var$Deferred());
    }, [
        vtContext
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7fPBF.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$74e05fac257f9d21$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$315e3ffb01f217).Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$cb3f1df1bef00a39).Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7fPBF.createElement($74e05fac257f9d21$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7fPBF.createElement($74e05fac257f9d21$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $74e05fac257f9d21$var$getOptimisticRouterState(currentState, newState) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentState), {
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    });
}
const $74e05fac257f9d21$var$MemoizedDataRoutes = $7fPBF.memo($74e05fac257f9d21$export$699f06c8afb533c9);
function $74e05fac257f9d21$export$699f06c8afb533c9({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return (0, $39c9549f68558626$export$f7ce0646a48561fb)(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $74e05fac257f9d21$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7fPBF.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $830828eb44359214$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($74e05fac257f9d21$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $74e05fac257f9d21$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $830828eb44359214$export$f5708dca728d7177)((0, $39c9549f68558626$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    (0, $830828eb44359214$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    let path = (0, $869207a87b6bfdfe$export$cae722b0cc860f13)(to, (0, $869207a87b6bfdfe$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $74e05fac257f9d21$export$910ae8079b2c2852(props) {
    return (0, $39c9549f68558626$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $74e05fac257f9d21$export$e7b0ac011bb776c6(props) {
    (0, $830828eb44359214$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $74e05fac257f9d21$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $830828eb44359214$export$f5708dca728d7177)(!(0, $39c9549f68558626$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $830828eb44359214$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $830828eb44359214$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $74e05fac257f9d21$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $39c9549f68558626$export$5d3fca4a98652595)($74e05fac257f9d21$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $74e05fac257f9d21$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$315e3ffb01f217));
    let onError = $7fPBF.useCallback((error, errorInfo)=>{
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            pattern: (0, $869207a87b6bfdfe$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($74e05fac257f9d21$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7fPBF.createElement($74e05fac257f9d21$var$ResolveAwait, null, children));
}
var $74e05fac257f9d21$var$AwaitErrorBoundary = class extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                var _this_props_onError, _this_props;
                (_this_props_onError = (_this_props = this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $7fPBF.createElement((0, $70040d9784a39bd0$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
};
function $74e05fac257f9d21$var$ResolveAwait({ children: children }) {
    let data = (0, $39c9549f68558626$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $74e05fac257f9d21$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!$7fPBF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            routes.push.apply(routes, $74e05fac257f9d21$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $830828eb44359214$export$f5708dca728d7177)(element.type === $74e05fac257f9d21$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $830828eb44359214$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $74e05fac257f9d21$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $74e05fac257f9d21$export$9b5b6d122dea0c88 = $74e05fac257f9d21$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $74e05fac257f9d21$export$daf73786167a7f72(matches) {
    return (0, $39c9549f68558626$export$569816e95a012c39)(matches);
}
function $74e05fac257f9d21$var$useRouteComponentProps() {
    return {
        params: (0, $39c9549f68558626$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $39c9549f68558626$export$1448a5050d252c4d)(),
        actionData: (0, $39c9549f68558626$export$fdc00f3f26066d5e)(),
        matches: (0, $39c9549f68558626$export$2378eb7f5ff86053)()
    };
}
function $74e05fac257f9d21$export$6c4f3826290c37af({ children: children }) {
    const props = $74e05fac257f9d21$var$useRouteComponentProps();
    return $7fPBF.cloneElement(children, props);
}
function $74e05fac257f9d21$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $74e05fac257f9d21$var$useRouteComponentProps();
        return $7fPBF.createElement(Component, props);
    };
}
function $74e05fac257f9d21$var$useHydrateFallbackProps() {
    return {
        params: (0, $39c9549f68558626$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $39c9549f68558626$export$1448a5050d252c4d)(),
        actionData: (0, $39c9549f68558626$export$fdc00f3f26066d5e)()
    };
}
function $74e05fac257f9d21$export$f8cff34f39c1932a({ children: children }) {
    const props = $74e05fac257f9d21$var$useHydrateFallbackProps();
    return $7fPBF.cloneElement(children, props);
}
function $74e05fac257f9d21$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $74e05fac257f9d21$var$useHydrateFallbackProps();
        return $7fPBF.createElement(HydrateFallback, props);
    };
}
function $74e05fac257f9d21$var$useErrorBoundaryProps() {
    return {
        params: (0, $39c9549f68558626$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $39c9549f68558626$export$1448a5050d252c4d)(),
        actionData: (0, $39c9549f68558626$export$fdc00f3f26066d5e)(),
        error: (0, $39c9549f68558626$export$ed527bf60f6e05f2)()
    };
}
function $74e05fac257f9d21$export$e5afde5c4b6d747b({ children: children }) {
    const props = $74e05fac257f9d21$var$useErrorBoundaryProps();
    return $7fPBF.cloneElement(children, props);
}
function $74e05fac257f9d21$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $74e05fac257f9d21$var$useErrorBoundaryProps();
        return $7fPBF.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $ab606116c29068d0$var$defaultEncType = "application/x-www-form-urlencoded";
function $ab606116c29068d0$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $ab606116c29068d0$var$isButtonElement(object) {
    return $ab606116c29068d0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ab606116c29068d0$var$isFormElement(object) {
    return $ab606116c29068d0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ab606116c29068d0$var$isInputElement(object) {
    return $ab606116c29068d0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ab606116c29068d0$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ab606116c29068d0$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$ab606116c29068d0$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $ab606116c29068d0$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ab606116c29068d0$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $ab606116c29068d0$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $ab606116c29068d0$var$_formDataSupportsSubmitter = null;
function $ab606116c29068d0$var$isFormDataSubmitterSupported() {
    if ($ab606116c29068d0$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $ab606116c29068d0$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ab606116c29068d0$var$_formDataSupportsSubmitter = true;
    }
    return $ab606116c29068d0$var$_formDataSupportsSubmitter;
}
const $ab606116c29068d0$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ab606116c29068d0$var$getFormEncType(encType) {
    if (encType != null && !$ab606116c29068d0$var$supportedFormEncTypes.has(encType)) {
        (0, $830828eb44359214$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$ab606116c29068d0$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $ab606116c29068d0$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ab606116c29068d0$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $ab606116c29068d0$var$getFormEncType(target.getAttribute("enctype")) || $ab606116c29068d0$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ab606116c29068d0$var$isButtonElement(target) || $ab606116c29068d0$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $ab606116c29068d0$var$getFormEncType(target.getAttribute("formenctype")) || $ab606116c29068d0$var$getFormEncType(form.getAttribute("enctype")) || $ab606116c29068d0$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$ab606116c29068d0$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ab606116c29068d0$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $ab606116c29068d0$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $7d9ff2d4eef2b99f$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $7d9ff2d4eef2b99f$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $7d9ff2d4eef2b99f$export$4cf11838cdc2a8a8(html) {
    return html.replace($7d9ff2d4eef2b99f$var$ESCAPE_REGEX, (match)=>$7d9ff2d4eef2b99f$var$ESCAPE_LOOKUP[match]);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 






/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $57741220c3c7a4b5$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $afcf8070a61a3a06$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $afcf8070a61a3a06$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $afcf8070a61a3a06$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $e4ae8714e5aaa473$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $e4ae8714e5aaa473$var$dedupeLinkDescriptors(matches.map((match)=>{
        var _module_links;
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2), $e4ae8714e5aaa473$export$442b9e023f41af00(matches, manifest));
}
function $e4ae8714e5aaa473$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $e4ae8714e5aaa473$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $e4ae8714e5aaa473$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($e4ae8714e5aaa473$var$prefetchStyleLink));
}
async function $e4ae8714e5aaa473$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$e4ae8714e5aaa473$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$e4ae8714e5aaa473$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$e4ae8714e5aaa473$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, descriptor), {
        rel: "preload",
        as: "style"
    }));
    await Promise.all(styleLinks.map($e4ae8714e5aaa473$var$prefetchStyleLink));
}
async function $e4ae8714e5aaa473$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $e4ae8714e5aaa473$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $e4ae8714e5aaa473$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $e4ae8714e5aaa473$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $e4ae8714e5aaa473$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $afcf8070a61a3a06$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($e4ae8714e5aaa473$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link), {
            rel: "prefetch",
            as: "style"
        }) : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link), {
            rel: "prefetch"
        })));
}
function $e4ae8714e5aaa473$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        var _currentMatches_index_route_path;
        return currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $e4ae8714e5aaa473$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $e4ae8714e5aaa473$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $e4ae8714e5aaa473$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $e4ae8714e5aaa473$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $e4ae8714e5aaa473$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$e4ae8714e5aaa473$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($e4ae8714e5aaa473$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $e4ae8714e5aaa473$var$_isPreloadSupported;
function $e4ae8714e5aaa473$var$isPreloadSupported() {
    if ($e4ae8714e5aaa473$var$_isPreloadSupported !== void 0) return $e4ae8714e5aaa473$var$_isPreloadSupported;
    let el = document.createElement("link");
    $e4ae8714e5aaa473$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $e4ae8714e5aaa473$var$_isPreloadSupported;
}



/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts

var $9839740b67f7df85$export$85f6557964517f1a = class {
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "promise", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "resolve", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "reject", void 0);
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $9839740b67f7df85$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $3c4de97e2727e249$var$TIME_LIMIT_MS = 1;
const $3c4de97e2727e249$var$getNow = ()=>Date.now();
const $3c4de97e2727e249$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $3c4de97e2727e249$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $3c4de97e2727e249$var$stringify.call(this, stack);
    return index;
}
async function $3c4de97e2727e249$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $3c4de97e2727e249$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $3c4de97e2727e249$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $3c4de97e2727e249$var$TIME_LIMIT_MS) {
            await $3c4de97e2727e249$var$yieldToMain();
            lastYieldTime = $3c4de97e2727e249$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($3c4de97e2727e249$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $3c4de97e2727e249$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3c4de97e2727e249$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3c4de97e2727e249$var$objectProtoNames;
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $6a503ebd4c2f482f$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $6a503ebd4c2f482f$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $6a503ebd4c2f482f$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $6a503ebd4c2f482f$var$hydrate.call(this, startIndex);
}
function $6a503ebd4c2f482f$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $9839740b67f7df85$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $6a503ebd4c2f482f$var$globalObj && (0, $869207a87b6bfdfe$export$1a235bd2b33434e5).includes(errorType) && errorType in $6a503ebd4c2f482f$var$globalObj && typeof $6a503ebd4c2f482f$var$globalObj[errorType] === "function" ? new $6a503ebd4c2f482f$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $f8ce3b483299fb6c$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options !== null && options !== void 0 ? options : {};
    const done = new (0, $9839740b67f7df85$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $9839740b67f7df85$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $f8ce3b483299fb6c$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $f8ce3b483299fb6c$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $f8ce3b483299fb6c$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $6a503ebd4c2f482f$export$4315a2af848d75d7).call(this, line)
    };
}
async function $f8ce3b483299fb6c$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = (0, $6a503ebd4c2f482f$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = (0, $6a503ebd4c2f482f$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $f8ce3b483299fb6c$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options !== null && options !== void 0 ? options : {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $3c4de97e2727e249$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $3c4de97e2727e249$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $3c4de97e2727e249$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    });
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $7de704501e262fb3$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/ssr/single-fetch.tsx
const $411d1e58aae92a52$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $411d1e58aae92a52$var$SingleFetchNoResultError = class extends Error {
};
const $411d1e58aae92a52$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $411d1e58aae92a52$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $7d9ff2d4eef2b99f$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement($7fPBF.Suspense, null, /* @__PURE__ */ $7fPBF.createElement($411d1e58aae92a52$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $411d1e58aae92a52$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $411d1e58aae92a52$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $411d1e58aae92a52$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $411d1e58aae92a52$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $411d1e58aae92a52$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $411d1e58aae92a52$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $411d1e58aae92a52$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $411d1e58aae92a52$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $411d1e58aae92a52$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $411d1e58aae92a52$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $320f70ca3b146d69$export$3f1eb41d9a6a6a27)(result.result) || (0, $869207a87b6bfdfe$export$972111febbeef05b)(result.result) || (0, $320f70ca3b146d69$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $869207a87b6bfdfe$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $411d1e58aae92a52$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data } = await fetchAndDecode(args, [
                        routeId
                    ]);
                    return $411d1e58aae92a52$var$unwrapSingleFetchResult(data, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $411d1e58aae92a52$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$411d1e58aae92a52$var$createDeferred());
    let singleFetchDfd = $411d1e58aae92a52$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $411d1e58aae92a52$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $411d1e58aae92a52$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $411d1e58aae92a52$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $411d1e58aae92a52$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    var _results_match_route_id;
                    middlewareError = routeResult.error;
                    if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $411d1e58aae92a52$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $411d1e58aae92a52$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $411d1e58aae92a52$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $411d1e58aae92a52$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $411d1e58aae92a52$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $411d1e58aae92a52$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $411d1e58aae92a52$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $411d1e58aae92a52$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $7de704501e262fb3$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($411d1e58aae92a52$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $411d1e58aae92a52$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($411d1e58aae92a52$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$411d1e58aae92a52$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
            (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $411d1e58aae92a52$export$4023ad4ecd4126a2(body, global) {
    return (0, $f8ce3b483299fb6c$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $869207a87b6bfdfe$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$411d1e58aae92a52$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $411d1e58aae92a52$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $869207a87b6bfdfe$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $411d1e58aae92a52$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $411d1e58aae92a52$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 






/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/ssr/errorBoundaries.tsx
var $589cc703cdc90620$export$32e57f52df4b6e34 = class extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7fPBF.createElement($589cc703cdc90620$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $589cc703cdc90620$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $8914d20ea47a0731$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $869207a87b6bfdfe$export$972111febbeef05b)(error)) return /* @__PURE__ */ $7fPBF.createElement($589cc703cdc90620$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7fPBF.createElement($589cc703cdc90620$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $589cc703cdc90620$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    var _routeModules_root;
    let { routeModules: routeModules } = (0, $8914d20ea47a0731$export$17134ff624fc6bc2)();
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7fPBF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7fPBF.createElement("head", null, /* @__PURE__ */ $7fPBF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7fPBF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7fPBF.createElement("title", null, title)), /* @__PURE__ */ $7fPBF.createElement("body", null, /* @__PURE__ */ $7fPBF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7fPBF.createElement((0, $8914d20ea47a0731$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/ssr/fallback.tsx
function $ae70a2f195d7e379$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $8914d20ea47a0731$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $7fPBF.createElement((0, $589cc703cdc90620$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/ssr/routes.tsx
function $f97b969fc846f78b$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $f97b969fc846f78b$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $f97b969fc846f78b$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $ae70a2f195d7e379$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7fPBF.createElement((0, $589cc703cdc90620$export$20b33acd14692c9), {
            error: (0, $39c9549f68558626$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, Component ? {
        element: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(Component, null))
    } : {
        Component: Component
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $f97b969fc846f78b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $f97b969fc846f78b$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $f97b969fc846f78b$var$getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        });
        let children = $f97b969fc846f78b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $f97b969fc846f78b$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $f97b969fc846f78b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $f97b969fc846f78b$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $f97b969fc846f78b$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $f97b969fc846f78b$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $f97b969fc846f78b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $f97b969fc846f78b$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $f97b969fc846f78b$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $e4ae8714e5aaa473$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, dataRoute, $f97b969fc846f78b$var$getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $f97b969fc846f78b$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $f97b969fc846f78b$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $f97b969fc846f78b$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $f97b969fc846f78b$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $f97b969fc846f78b$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $f97b969fc846f78b$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $f97b969fc846f78b$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, args), {
                            async serverLoader () {
                                $f97b969fc846f78b$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        }));
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, args), {
                            async serverAction () {
                                $f97b969fc846f78b$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        }));
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $f97b969fc846f78b$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $f97b969fc846f78b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $f97b969fc846f78b$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $f97b969fc846f78b$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $869207a87b6bfdfe$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $f97b969fc846f78b$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $f97b969fc846f78b$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $afcf8070a61a3a06$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $e4ae8714e5aaa473$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $e4ae8714e5aaa473$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $f97b969fc846f78b$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $f97b969fc846f78b$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $f97b969fc846f78b$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/ssr/fog-of-war.ts
const $67a9ada8284b6523$var$nextPaths = /* @__PURE__ */ new Set();
const $67a9ada8284b6523$var$discoveredPathsMaxSize = 1e3;
const $67a9ada8284b6523$var$discoveredPaths = /* @__PURE__ */ new Set();
const $67a9ada8284b6523$export$b5915cf27fa06b9f = 7680;
function $67a9ada8284b6523$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $67a9ada8284b6523$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $67a9ada8284b6523$export$ae5150779dbcc11a(_param, router) {
    var { sri: sri } = _param, manifest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "sri"
    ]);
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = (0, $869207a87b6bfdfe$export$5c7b09132f833c25)(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function $67a9ada8284b6523$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$67a9ada8284b6523$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($67a9ada8284b6523$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $67a9ada8284b6523$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $830828eb44359214$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $67a9ada8284b6523$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7fPBF.useEffect(()=>{
        var _window_navigator_connection, _window_navigator;
        if (!$67a9ada8284b6523$export$741d98b28dbfd(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$67a9ada8284b6523$var$discoveredPaths.has(pathname)) $67a9ada8284b6523$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($67a9ada8284b6523$var$nextPaths.keys()).filter((path)=>{
                if ($67a9ada8284b6523$var$discoveredPaths.has(path)) {
                    $67a9ada8284b6523$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $67a9ada8284b6523$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $67a9ada8284b6523$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $67a9ada8284b6523$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $67a9ada8284b6523$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $67a9ada8284b6523$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if (!needsReload) {
        try {
            sessionStorage.removeItem($67a9ada8284b6523$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch (e) {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    try {
        if (sessionStorage.getItem($67a9ada8284b6523$var$MANIFEST_VERSION_STORAGE_KEY) === version) {
            console.error("Unable to discover routes due to manifest version mismatch.");
            return true;
        }
        sessionStorage.setItem($67a9ada8284b6523$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch (e) {}
    window.location.href = errorReloadPath;
    console.warn("Detected manifest version mismatch, reloading...");
    await new Promise(()=>{});
    return true;
}
async function $67a9ada8284b6523$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $67a9ada8284b6523$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($67a9ada8284b6523$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $67a9ada8284b6523$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $67a9ada8284b6523$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$67a9ada8284b6523$var$addToFifoQueue(p, $67a9ada8284b6523$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $f97b969fc846f78b$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $67a9ada8284b6523$var$addToFifoQueue(path, queue) {
    if (queue.size >= $67a9ada8284b6523$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $67a9ada8284b6523$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/ssr/components.tsx
function $8914d20ea47a0731$var$useDataRouterContext() {
    let context = $7fPBF.useContext((0, $70040d9784a39bd0$export$2eeee58951ff3c1c));
    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $8914d20ea47a0731$var$useDataRouterStateContext() {
    let context = $7fPBF.useContext((0, $70040d9784a39bd0$export$315e3ffb01f217));
    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
const $8914d20ea47a0731$export$208d6a3bc3aa62bd = $7fPBF.createContext(void 0);
$8914d20ea47a0731$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $8914d20ea47a0731$export$17134ff624fc6bc2() {
    let context = $7fPBF.useContext($8914d20ea47a0731$export$208d6a3bc3aa62bd);
    (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $8914d20ea47a0731$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $7fPBF.useContext($8914d20ea47a0731$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7fPBF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7fPBF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7fPBF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $8914d20ea47a0731$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $8914d20ea47a0731$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $8914d20ea47a0731$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $8914d20ea47a0731$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $8914d20ea47a0731$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $8914d20ea47a0731$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $8914d20ea47a0731$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$8914d20ea47a0731$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $8914d20ea47a0731$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $8914d20ea47a0731$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $8914d20ea47a0731$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches } = $8914d20ea47a0731$var$useDataRouterStateContext();
    let matches = $8914d20ea47a0731$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7fPBF.useMemo(()=>(0, $e4ae8714e5aaa473$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7fPBF.createElement("style", {
        [$8914d20ea47a0731$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7fPBF.createElement("link", {
        [$8914d20ea47a0731$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>{
        var _link_crossOrigin, _link_crossOrigin1;
        return (0, $e4ae8714e5aaa473$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $7fPBF.createElement($8914d20ea47a0731$export$60dcec93e67386bd, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : crossOrigin
        })) : /* @__PURE__ */ $7fPBF.createElement("link", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin1 = link.crossOrigin) !== null && _link_crossOrigin1 !== void 0 ? _link_crossOrigin1 : crossOrigin
        }));
    }));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $8914d20ea47a0731$export$60dcec93e67386bd(_param) {
    var { page: page } = _param, linkProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "page"
    ]);
    let rsc = (0, $70040d9784a39bd0$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $8914d20ea47a0731$export$17134ff624fc6bc2();
    let { router: router } = $8914d20ea47a0731$var$useDataRouterContext();
    let matches = $7fPBF.useMemo(()=>(0, $869207a87b6bfdfe$export$2708184779ceb39d)(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, linkProps), {
        nonce: contextNonce
    });
    if (rsc) return /* @__PURE__ */ $7fPBF.createElement($8914d20ea47a0731$var$RSCPrefetchPageLinksImpl, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        page: page,
        matches: matches
    }, linkProps));
    return /* @__PURE__ */ $7fPBF.createElement($8914d20ea47a0731$var$PrefetchPageLinksImpl, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        page: page,
        matches: matches
    }, linkProps));
}
function $8914d20ea47a0731$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $8914d20ea47a0731$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7fPBF.useState([]);
    $7fPBF.useEffect(()=>{
        let interrupted = false;
        (0, $e4ae8714e5aaa473$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $8914d20ea47a0731$var$RSCPrefetchPageLinksImpl(_param) {
    var { page: page, matches: nextMatches } = _param, linkProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "page",
        "matches"
    ]);
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $411d1e58aae92a52$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps))));
}
function $8914d20ea47a0731$var$PrefetchPageLinksImpl(_param) {
    var { page: page, matches: nextMatches } = _param, linkProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "page",
        "matches"
    ]);
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $8914d20ea47a0731$export$17134ff624fc6bc2();
    let { loaderData: loaderData, matches: matches } = $8914d20ea47a0731$var$useDataRouterStateContext();
    let newMatchesForData = $7fPBF.useMemo(()=>(0, $e4ae8714e5aaa473$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7fPBF.useMemo(()=>(0, $e4ae8714e5aaa473$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            var _routeModules_m_route_id;
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $411d1e58aae92a52$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7fPBF.useMemo(()=>(0, $e4ae8714e5aaa473$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $8914d20ea47a0731$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps))), moduleHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps))), keyedPrefetchLinks.map(({ key: key, link: link })=>{
        var _link_crossOrigin;
        return /* @__PURE__ */ $7fPBF.createElement("link", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: key,
            nonce: linkProps.nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : linkProps.crossOrigin
        }));
    }));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $8914d20ea47a0731$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $8914d20ea47a0731$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $8914d20ea47a0731$var$useDataRouterStateContext();
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let _matches = $8914d20ea47a0731$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName } = metaProps, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(metaProps, [
                "tagName"
            ]);
            if (!$8914d20ea47a0731$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7fPBF.createElement(Comp, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7fPBF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps;
            var _charSet;
            (_charSet = (_metaProps = metaProps).charSet) !== null && _charSet !== void 0 ? _charSet : _metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7fPBF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $7d9ff2d4eef2b99f$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7fPBF.createElement("meta", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function $8914d20ea47a0731$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $8914d20ea47a0731$var$isHydrated = false;
function $8914d20ea47a0731$export$3be068dde909e563() {
    $8914d20ea47a0731$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $8914d20ea47a0731$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $8914d20ea47a0731$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = $8914d20ea47a0731$var$useDataRouterContext();
    let { matches: routerMatches } = $8914d20ea47a0731$var$useDataRouterStateContext();
    let isRSCRouterContext = (0, $70040d9784a39bd0$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $67a9ada8284b6523$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scriptProps), {
        nonce: contextNonce
    });
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $8914d20ea47a0731$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7fPBF.useEffect(()=>{
        $8914d20ea47a0731$export$3be068dde909e563();
    }, []);
    let initialScripts = $7fPBF.useMemo(()=>{
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $57741220c3c7a4b5$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $67a9ada8284b6523$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("script", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $7fPBF.createElement("script", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    let preloads = $8914d20ea47a0731$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $e4ae8714e5aaa473$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $125b0b57b9574ddd$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $8914d20ea47a0731$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7fPBF.createElement("script", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scriptProps), {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    })) : null, !enableFogOfWar ? /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $8914d20ea47a0731$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $7fPBF = parcelRequire("7fPBF");
//#region lib/dom/lib.tsx
const $f232cebbf1b70e96$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($f232cebbf1b70e96$var$isBrowser) window.__reactRouterVersion = "8.3.0";
} catch (e) {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $f232cebbf1b70e96$export$1f3f55432a00e06d(routes, opts) {
    return (0, $320f70ca3b146d69$export$baddd0131ee8c05b)({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: (0, $830828eb44359214$export$719fc203c4e16dee)({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $f232cebbf1b70e96$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $869207a87b6bfdfe$export$6bc17138063be773),
        hydrationRouteProperties: $74e05fac257f9d21$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $f232cebbf1b70e96$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $320f70ca3b146d69$export$baddd0131ee8c05b)({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: (0, $830828eb44359214$export$b71fdd3798280242)({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $f232cebbf1b70e96$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $869207a87b6bfdfe$export$6bc17138063be773),
        hydrationRouteProperties: $74e05fac257f9d21$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function $f232cebbf1b70e96$var$parseHydrationData() {
    var _window;
    let state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        errors: $f232cebbf1b70e96$var$deserializeErrors(state.errors)
    });
    return state;
}
function $f232cebbf1b70e96$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $869207a87b6bfdfe$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $869207a87b6bfdfe$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch (e) {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $f232cebbf1b70e96$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $7fPBF.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $830828eb44359214$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement((0, $74e05fac257f9d21$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $f232cebbf1b70e96$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $7fPBF.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $830828eb44359214$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement((0, $74e05fac257f9d21$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $f232cebbf1b70e96$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement((0, $74e05fac257f9d21$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$f232cebbf1b70e96$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $f232cebbf1b70e96$export$a6c7ac8248d6e38a = $7fPBF.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var { onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "mask",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $99aa633853900a15$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $869207a87b6bfdfe$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $39c9549f68558626$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $869207a87b6bfdfe$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $8914d20ea47a0731$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $f232cebbf1b70e96$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $7fPBF.createElement("a", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest, prefetchHandlers), {
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $8914d20ea47a0731$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, link, /* @__PURE__ */ $7fPBF.createElement((0, $8914d20ea47a0731$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$f232cebbf1b70e96$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $f232cebbf1b70e96$export$b0d92dbee9b5b60d = $7fPBF.forwardRef(function NavLinkWithRef(_param, ref) {
    var { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    let path = (0, $39c9549f68558626$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $70040d9784a39bd0$export$315e3ffb01f217));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let isTransitioning = routerState != null && $f232cebbf1b70e96$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7fPBF.createElement($f232cebbf1b70e96$export$a6c7ac8248d6e38a, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$f232cebbf1b70e96$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $f232cebbf1b70e96$export$a7fed597f4b8afd8 = $7fPBF.forwardRef((_param, forwardedRef)=>{
    var { discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    let { useTransitions: useTransitions } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let submit = $f232cebbf1b70e96$export$47c85c6e3a081d3();
    let formAction = $f232cebbf1b70e96$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $99aa633853900a15$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7fPBF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7fPBF.createElement("form", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
$f232cebbf1b70e96$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $f232cebbf1b70e96$export$11aac1aab828f1fa(_param) {
    var { getKey: getKey, storageKey: storageKey } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "getKey",
        "storageKey"
    ]);
    let remixContext = $7fPBF.useContext((0, $8914d20ea47a0731$export$208d6a3bc3aa62bd));
    let { basename: basename } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let matches = (0, $39c9549f68558626$export$2378eb7f5ff86053)();
    $f232cebbf1b70e96$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7fPBF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $f232cebbf1b70e96$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && (remixContext === null || remixContext === void 0 ? void 0 : remixContext.nonce)) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $7fPBF.createElement("script", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $7d9ff2d4eef2b99f$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $f232cebbf1b70e96$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $7d9ff2d4eef2b99f$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    }));
}
$f232cebbf1b70e96$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $f232cebbf1b70e96$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f232cebbf1b70e96$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $70040d9784a39bd0$export$2eeee58951ff3c1c));
    (0, $830828eb44359214$export$f5708dca728d7177)(ctx, $f232cebbf1b70e96$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $f232cebbf1b70e96$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $70040d9784a39bd0$export$315e3ffb01f217));
    (0, $830828eb44359214$export$f5708dca728d7177)(state, $f232cebbf1b70e96$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $f232cebbf1b70e96$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let path = (0, $39c9549f68558626$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ((0, $ab606116c29068d0$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $830828eb44359214$export$fe53371bee54353d)(location) === (0, $830828eb44359214$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7fPBF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $f232cebbf1b70e96$export$f1a78c17382fe22a(defaultInit) {
    (0, $830828eb44359214$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $7fPBF.useRef((0, $ab606116c29068d0$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>(0, $ab606116c29068d0$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    return [
        searchParams,
        $7fPBF.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $ab606116c29068d0$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $f232cebbf1b70e96$var$fetcherId = 0;
let $f232cebbf1b70e96$var$getUniqueFetcherId = ()=>`__${String(++$f232cebbf1b70e96$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $f232cebbf1b70e96$export$47c85c6e3a081d3() {
    let { router: router } = $f232cebbf1b70e96$var$useDataRouterContext("useSubmit");
    let { basename: basename } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $39c9549f68558626$export$4200b254756b08af)();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7fPBF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $ab606116c29068d0$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $f232cebbf1b70e96$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $f232cebbf1b70e96$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let routeContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    (0, $830828eb44359214$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $39c9549f68558626$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $869207a87b6bfdfe$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $830828eb44359214$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $f232cebbf1b70e96$export$5b0d2d9a9921565a({ key: key } = {}) {
    var _route_matches_;
    let { router: router } = $f232cebbf1b70e96$var$useDataRouterContext("useFetcher");
    let state = $f232cebbf1b70e96$var$useDataRouterState("useFetcher");
    let fetcherData = $7fPBF.useContext((0, $70040d9784a39bd0$export$cb3f1df1bef00a39));
    let route = $7fPBF.useContext((0, $70040d9784a39bd0$export$aac280ed165a4397));
    let routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    (0, $830828eb44359214$export$f5708dca728d7177)(fetcherData, `useFetcher must be used inside a FetchersContext`);
    (0, $830828eb44359214$export$f5708dca728d7177)(route, `useFetcher must be used inside a RouteContext`);
    (0, $830828eb44359214$export$f5708dca728d7177)(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7fPBF.useId();
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7fPBF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7fPBF.useCallback(async (href, opts)=>{
        (0, $830828eb44359214$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $f232cebbf1b70e96$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback(async (target, opts)=>{
        await submitImpl(target, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts), {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7fPBF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = $7fPBF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7fPBF.createElement($f232cebbf1b70e96$export$a7fed597f4b8afd8, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || (0, $320f70ca3b146d69$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    return $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset
        }, fetcher), {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $f232cebbf1b70e96$export$fa996778a3a31087() {
    let state = $f232cebbf1b70e96$var$useDataRouterState("useFetchers");
    return $7fPBF.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fetcher), {
                key: key
            })), [
        state.fetchers
    ]);
}
const $f232cebbf1b70e96$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $f232cebbf1b70e96$var$savedScrollPositions = {};
function $f232cebbf1b70e96$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, location), {
            pathname: (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $f232cebbf1b70e96$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $f232cebbf1b70e96$var$useDataRouterContext("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f232cebbf1b70e96$var$useDataRouterState("useScrollRestoration");
    let { basename: basename } = $7fPBF.useContext((0, $70040d9784a39bd0$export$3044ab7fdabeaee6));
    let location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    let matches = (0, $39c9549f68558626$export$2378eb7f5ff86053)();
    let navigation = (0, $39c9549f68558626$export$d0fd4b7106de2769)();
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $f232cebbf1b70e96$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $f232cebbf1b70e96$var$getScrollRestorationKey(location, matches, basename, getKey);
            $f232cebbf1b70e96$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f232cebbf1b70e96$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f232cebbf1b70e96$var$savedScrollPositions));
        } catch (error) {
            (0, $830828eb44359214$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f232cebbf1b70e96$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f232cebbf1b70e96$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            let disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration($f232cebbf1b70e96$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$f232cebbf1b70e96$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                (0, $830828eb44359214$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $f232cebbf1b70e96$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $f232cebbf1b70e96$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $f232cebbf1b70e96$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $39c9549f68558626$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $f232cebbf1b70e96$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7fPBF.useContext((0, $70040d9784a39bd0$export$3681f408decb40d1));
    (0, $830828eb44359214$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $f232cebbf1b70e96$var$useDataRouterContext("useViewTransitionState");
    let path = (0, $39c9549f68558626$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $869207a87b6bfdfe$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $869207a87b6bfdfe$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $869207a87b6bfdfe$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}






let $b091aef3a32d2bd8$var$_ = (t)=>t, $b091aef3a32d2bd8$var$t, $b091aef3a32d2bd8$var$t1, $b091aef3a32d2bd8$var$t2, $b091aef3a32d2bd8$var$t3, $b091aef3a32d2bd8$var$t4, $b091aef3a32d2bd8$var$t5, $b091aef3a32d2bd8$var$t6, $b091aef3a32d2bd8$var$t7, $b091aef3a32d2bd8$var$t8, $b091aef3a32d2bd8$var$t9, $b091aef3a32d2bd8$var$t10, $b091aef3a32d2bd8$var$t11, $b091aef3a32d2bd8$var$t12, $b091aef3a32d2bd8$var$t13, $b091aef3a32d2bd8$var$t14, $b091aef3a32d2bd8$var$t15, $b091aef3a32d2bd8$var$t16, $b091aef3a32d2bd8$var$t17, $b091aef3a32d2bd8$var$t18, $b091aef3a32d2bd8$var$t19, $b091aef3a32d2bd8$var$t20, $b091aef3a32d2bd8$var$t21, $b091aef3a32d2bd8$var$t22, $b091aef3a32d2bd8$var$t23, $b091aef3a32d2bd8$var$t24, $b091aef3a32d2bd8$var$t25, $b091aef3a32d2bd8$var$t26, $b091aef3a32d2bd8$var$t27, $b091aef3a32d2bd8$var$t28, $b091aef3a32d2bd8$var$t29, $b091aef3a32d2bd8$var$t30, $b091aef3a32d2bd8$var$t31, $b091aef3a32d2bd8$var$t32, $b091aef3a32d2bd8$var$t33, $b091aef3a32d2bd8$var$t34, $b091aef3a32d2bd8$var$t35, $b091aef3a32d2bd8$var$t36, $b091aef3a32d2bd8$var$t37, $b091aef3a32d2bd8$var$t38, $b091aef3a32d2bd8$var$t39, $b091aef3a32d2bd8$var$t40, $b091aef3a32d2bd8$var$t41, $b091aef3a32d2bd8$var$t42, $b091aef3a32d2bd8$var$t43, $b091aef3a32d2bd8$var$t44, $b091aef3a32d2bd8$var$t45, $b091aef3a32d2bd8$var$t46, $b091aef3a32d2bd8$var$t47, $b091aef3a32d2bd8$var$t48, $b091aef3a32d2bd8$var$t49, $b091aef3a32d2bd8$var$t50, $b091aef3a32d2bd8$var$t51, $b091aef3a32d2bd8$var$t52, $b091aef3a32d2bd8$var$t53, $b091aef3a32d2bd8$var$t54, $b091aef3a32d2bd8$var$t55, $b091aef3a32d2bd8$var$t56, $b091aef3a32d2bd8$var$t57, $b091aef3a32d2bd8$var$t58, $b091aef3a32d2bd8$var$t59, $b091aef3a32d2bd8$var$t60, $b091aef3a32d2bd8$var$t61, $b091aef3a32d2bd8$var$t62;
const $b091aef3a32d2bd8$export$23ab5f1937583a99 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t || ($b091aef3a32d2bd8$var$t = $b091aef3a32d2bd8$var$_`
    font-size: 0.625rem;
    line-height: 1.125rem;
`));
const $b091aef3a32d2bd8$export$c0ddd0327d77e944 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t1 || ($b091aef3a32d2bd8$var$t1 = $b091aef3a32d2bd8$var$_`
    font-size: 0.75rem;
    line-height: 1;
`));
const $b091aef3a32d2bd8$export$41749b24b1e59255 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t2 || ($b091aef3a32d2bd8$var$t2 = $b091aef3a32d2bd8$var$_`
    font-size: 0.825rem;
    line-height: 1.25;
`));
const $b091aef3a32d2bd8$export$3e193b19d995235f = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t3 || ($b091aef3a32d2bd8$var$t3 = $b091aef3a32d2bd8$var$_`
    font-size: 0.875rem;
    line-height: 1.25;
`));
const $b091aef3a32d2bd8$export$9f95ce22eaa08be4 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t4 || ($b091aef3a32d2bd8$var$t4 = $b091aef3a32d2bd8$var$_`
    font-size: 1rem;
    line-height: 1.5;
`));
const $b091aef3a32d2bd8$export$1962b39d20eacf1d = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t5 || ($b091aef3a32d2bd8$var$t5 = $b091aef3a32d2bd8$var$_`
    font-size: 1.2rem;
    line-height: 1.5;
`));
const $b091aef3a32d2bd8$export$734b24ef8489e701 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t6 || ($b091aef3a32d2bd8$var$t6 = $b091aef3a32d2bd8$var$_`
    font-size: 1.44rem;
    line-height: 1.15;
`));
const $b091aef3a32d2bd8$export$5835e378394a0ad0 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t7 || ($b091aef3a32d2bd8$var$t7 = $b091aef3a32d2bd8$var$_`
    font-size: 1.728rem;
    line-height: 1.15;
`));
const $b091aef3a32d2bd8$export$b9c7c09e58fa57b5 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t8 || ($b091aef3a32d2bd8$var$t8 = $b091aef3a32d2bd8$var$_`
    font-size: 2.074rem;
    line-height: 1.15;
`));
const $b091aef3a32d2bd8$export$6fc64914395588c3 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t9 || ($b091aef3a32d2bd8$var$t9 = $b091aef3a32d2bd8$var$_`
    font-size: 2.488rem;
    line-height: 1.15;
`));
const $b091aef3a32d2bd8$export$fcfc2e791d591d65 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t10 || ($b091aef3a32d2bd8$var$t10 = $b091aef3a32d2bd8$var$_`
    font-size: 2.986rem;
    line-height: 1.15;
`));
const $b091aef3a32d2bd8$export$321a87690482e115 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t11 || ($b091aef3a32d2bd8$var$t11 = $b091aef3a32d2bd8$var$_`
    font-size: 3.25rem;
    line-height: 1.15;
`));
const $b091aef3a32d2bd8$export$90f89b8a63d85ede = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t12 || ($b091aef3a32d2bd8$var$t12 = $b091aef3a32d2bd8$var$_`
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`));
const $b091aef3a32d2bd8$export$c29b4f740eefd6d8 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t13 || ($b091aef3a32d2bd8$var$t13 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    letter-spacing: 0.03rem;
    ${0}
`), $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$e6005bbb0c0f31ce = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t14 || ($b091aef3a32d2bd8$var$t14 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    letter-spacing: 0.03rem;
    ${0}
`), $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$6413e6f2a6a43998 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t15 || ($b091aef3a32d2bd8$var$t15 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    letter-spacing: 0.03rem;
    ${0}
`), $b091aef3a32d2bd8$export$3e193b19d995235f);
const $b091aef3a32d2bd8$export$904d37a5903dadbe = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t16 || ($b091aef3a32d2bd8$var$t16 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    ${0}
`), $b091aef3a32d2bd8$export$c0ddd0327d77e944);
const $b091aef3a32d2bd8$export$54800003a6845797 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t17 || ($b091aef3a32d2bd8$var$t17 = $b091aef3a32d2bd8$var$_`
    font-weight: 900;
    ${0}
`), $b091aef3a32d2bd8$export$b9c7c09e58fa57b5);
const $b091aef3a32d2bd8$export$53e784b1f50184bf = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t18 || ($b091aef3a32d2bd8$var$t18 = $b091aef3a32d2bd8$var$_`
    font-weight: 900;
    ${0}
`), $b091aef3a32d2bd8$export$5835e378394a0ad0);
const $b091aef3a32d2bd8$export$2e3b5fdc3b6aeb4e = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t19 || ($b091aef3a32d2bd8$var$t19 = $b091aef3a32d2bd8$var$_`
    font-weight: 800;
    letter-spacing: 0.03rem;
    ${0}
`), $b091aef3a32d2bd8$export$734b24ef8489e701);
const $b091aef3a32d2bd8$export$51371c1775291179 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t20 || ($b091aef3a32d2bd8$var$t20 = $b091aef3a32d2bd8$var$_`
    font-weight: 800;
    letter-spacing: 0.03rem;
    ${0}
`), $b091aef3a32d2bd8$export$1962b39d20eacf1d);
const $b091aef3a32d2bd8$export$aca8b073d32574b4 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b091aef3a32d2bd8$var$t21 || ($b091aef3a32d2bd8$var$t21 = $b091aef3a32d2bd8$var$_`
    font-weight: 900;
    letter-spacing: -0.02rem;
    word-break: break-word;
    ${0}
`), $b091aef3a32d2bd8$export$6fc64914395588c3);
const $b091aef3a32d2bd8$export$e08999835651ba4a = (0, $8de346382d86c747$export$2e2bcd8739ae039).h1($b091aef3a32d2bd8$var$t22 || ($b091aef3a32d2bd8$var$t22 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$aca8b073d32574b4, (props)=>props.theme.color.text);
const $b091aef3a32d2bd8$export$9d43a8e504d2cc74 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$e08999835651ba4a)($b091aef3a32d2bd8$var$t23 || ($b091aef3a32d2bd8$var$t23 = $b091aef3a32d2bd8$var$_`
    text-align: center;
`));
const $b091aef3a32d2bd8$export$d0736df568c9b0a1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h2($b091aef3a32d2bd8$var$t24 || ($b091aef3a32d2bd8$var$t24 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$54800003a6845797, (props)=>props.theme.color.text);
const $b091aef3a32d2bd8$export$eb3d1c5f8a2a1200 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$d0736df568c9b0a1)($b091aef3a32d2bd8$var$t25 || ($b091aef3a32d2bd8$var$t25 = $b091aef3a32d2bd8$var$_`
    text-align: center;
    padding: 0.5rem 0 0 0;
`));
const $b091aef3a32d2bd8$export$f83be28a61c8ee22 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3($b091aef3a32d2bd8$var$t26 || ($b091aef3a32d2bd8$var$t26 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
    text-align: center;
`), $b091aef3a32d2bd8$export$53e784b1f50184bf, (props)=>props.theme.color.text);
const $b091aef3a32d2bd8$export$d9f4918700223049 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3($b091aef3a32d2bd8$var$t27 || ($b091aef3a32d2bd8$var$t27 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$53e784b1f50184bf, (props)=>props.theme.color.text);
const $b091aef3a32d2bd8$export$1120d81cab3b4d4a = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3($b091aef3a32d2bd8$var$t28 || ($b091aef3a32d2bd8$var$t28 = $b091aef3a32d2bd8$var$_`
    font-weight: 900;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$734b24ef8489e701);
const $b091aef3a32d2bd8$export$b8b202156ead000b = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3($b091aef3a32d2bd8$var$t29 || ($b091aef3a32d2bd8$var$t29 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$51371c1775291179, (props)=>props.theme.color.text);
const $b091aef3a32d2bd8$export$fe91652f4f7f8d90 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h1($b091aef3a32d2bd8$var$t30 || ($b091aef3a32d2bd8$var$t30 = $b091aef3a32d2bd8$var$_`
    font-weight: 700;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$5835e378394a0ad0);
const $b091aef3a32d2bd8$export$5c3bdb37a55baa65 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h2($b091aef3a32d2bd8$var$t31 || ($b091aef3a32d2bd8$var$t31 = $b091aef3a32d2bd8$var$_`
    font-weight: 700;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$734b24ef8489e701);
const $b091aef3a32d2bd8$export$2c65789109b698b0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3($b091aef3a32d2bd8$var$t32 || ($b091aef3a32d2bd8$var$t32 = $b091aef3a32d2bd8$var$_`
    font-weight: 700;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$1962b39d20eacf1d);
const $b091aef3a32d2bd8$export$68b378fffb2ccca3 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$2c65789109b698b0)($b091aef3a32d2bd8$var$t33 || ($b091aef3a32d2bd8$var$t33 = $b091aef3a32d2bd8$var$_`
    ${0}
`), $b091aef3a32d2bd8$export$90f89b8a63d85ede);
const $b091aef3a32d2bd8$export$509f2eb89cb5202e = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t34 || ($b091aef3a32d2bd8$var$t34 = $b091aef3a32d2bd8$var$_`
    font-weight: 700;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$7a7caa5e1960fb1c = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t35 || ($b091aef3a32d2bd8$var$t35 = $b091aef3a32d2bd8$var$_`
    font-weight: 700;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$3e193b19d995235f);
const $b091aef3a32d2bd8$export$c1529625596ef638 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t36 || ($b091aef3a32d2bd8$var$t36 = $b091aef3a32d2bd8$var$_`
    font-weight: 500;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$734b24ef8489e701);
const $b091aef3a32d2bd8$export$a35e4d6f9ac473d6 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t37 || ($b091aef3a32d2bd8$var$t37 = $b091aef3a32d2bd8$var$_`
    font-weight: 500;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$1962b39d20eacf1d);
const $b091aef3a32d2bd8$export$a79389cfbe6f64d = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t38 || ($b091aef3a32d2bd8$var$t38 = $b091aef3a32d2bd8$var$_`
    font-weight: 500;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$df83f18906197f6b = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t39 || ($b091aef3a32d2bd8$var$t39 = $b091aef3a32d2bd8$var$_`
    font-weight: 500;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$3e193b19d995235f);
const $b091aef3a32d2bd8$export$b01bdb1fe0103a4c = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t40 || ($b091aef3a32d2bd8$var$t40 = $b091aef3a32d2bd8$var$_`
    font-weight: 500;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$c0ddd0327d77e944);
const $b091aef3a32d2bd8$export$69d65bc555dfaf7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t41 || ($b091aef3a32d2bd8$var$t41 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$b9c7c09e58fa57b5);
const $b091aef3a32d2bd8$export$ea6aee68c7b1694f = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t42 || ($b091aef3a32d2bd8$var$t42 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$734b24ef8489e701);
const $b091aef3a32d2bd8$export$b312780b0d72eabb = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t43 || ($b091aef3a32d2bd8$var$t43 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$1962b39d20eacf1d);
const $b091aef3a32d2bd8$export$476b59e00e6c3fbd = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t44 || ($b091aef3a32d2bd8$var$t44 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    color: ${0};
    line-height: 1.313rem; // 21px
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$f51cc64edb23e9d6 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t45 || ($b091aef3a32d2bd8$var$t45 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$3e193b19d995235f);
const $b091aef3a32d2bd8$export$e4355dfd845d8ca = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t46 || ($b091aef3a32d2bd8$var$t46 = $b091aef3a32d2bd8$var$_`
    font-weight: 400;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$c0ddd0327d77e944);
const $b091aef3a32d2bd8$export$eda1d74e80a4b8e4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t47 || ($b091aef3a32d2bd8$var$t47 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    color: ${0};
    letter-spacing: 0.03rem;
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$b9c7c09e58fa57b5);
const $b091aef3a32d2bd8$export$332e4cc0f2c73ebf = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t48 || ($b091aef3a32d2bd8$var$t48 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    font-size: 1.565rem; // 25px
    color: ${0};
    line-height: 2.5625rem; // 41px
    letter-spacing: 0.03rem;
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$5835e378394a0ad0);
const $b091aef3a32d2bd8$export$c527f4a83cede337 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t49 || ($b091aef3a32d2bd8$var$t49 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    font-size: 1.3125rem; // 21px
    color: ${0};
    line-height: 2rem; // 32px
    letter-spacing: 0.03rem;
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$734b24ef8489e701);
const $b091aef3a32d2bd8$export$32a758e2e508ec9f = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t50 || ($b091aef3a32d2bd8$var$t50 = $b091aef3a32d2bd8$var$_`
    font-weight: 300;
    font-size: 1.125rem; // 18px
    color: ${0};
    line-height: 1.625rem; // 26px
    letter-spacing: 0.03rem;
    ${0}
`), (props)=>props.theme.color.textBody, $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$ddf9e902b54c6c8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t51 || ($b091aef3a32d2bd8$var$t51 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$c29b4f740eefd6d8, (props)=>props.theme.color.textBody);
const $b091aef3a32d2bd8$export$1ef657600983666a = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t52 || ($b091aef3a32d2bd8$var$t52 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$6413e6f2a6a43998, (props)=>props.theme.color.textBody);
const $b091aef3a32d2bd8$export$aa612d3716e98a87 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t53 || ($b091aef3a32d2bd8$var$t53 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
`), $b091aef3a32d2bd8$export$904d37a5903dadbe, (props)=>props.theme.color.textBody);
const $b091aef3a32d2bd8$export$45814810f7000d9e = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t54 || ($b091aef3a32d2bd8$var$t54 = $b091aef3a32d2bd8$var$_`
    font-weight: 200;
    text-align: center;
    ${0}
`), $b091aef3a32d2bd8$export$9f95ce22eaa08be4);
const $b091aef3a32d2bd8$export$b2b508107a916021 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t55 || ($b091aef3a32d2bd8$var$t55 = $b091aef3a32d2bd8$var$_`
    font-family: 'Courier New', Courier, monospace;
    color: ${0};
    letter-spacing: -0.02rem;
    ${0}
    font-weight: 300;
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$c0ddd0327d77e944);
const $b091aef3a32d2bd8$export$7196dc36c372814f = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($b091aef3a32d2bd8$var$t56 || ($b091aef3a32d2bd8$var$t56 = $b091aef3a32d2bd8$var$_`
    font-family: 'Courier New', Courier, monospace;
    color: ${0};
    ${0}
    background-color: ${0};
    border-radius: 0.25rem;
    padding: 0.125rem 0.25rem;
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$c0ddd0327d77e944, (props)=>props.theme.color.cardHover);
const $b091aef3a32d2bd8$export$a6cc38c9c1109f8f = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$b01bdb1fe0103a4c)($b091aef3a32d2bd8$var$t57 || ($b091aef3a32d2bd8$var$t57 = $b091aef3a32d2bd8$var$_`
    color: ${0};
    border: 1px solid ${0};
    background-color: #e1e6e1;
    border-radius: 0.375rem;
    padding: 0.25rem 0.5rem;
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).success, (0, $8951886a6b49e92a$export$35e9368ef982300f).success);
const $b091aef3a32d2bd8$export$415891f6b2865cea = (0, $8de346382d86c747$export$2e2bcd8739ae039)($b091aef3a32d2bd8$export$df83f18906197f6b)($b091aef3a32d2bd8$var$t58 || ($b091aef3a32d2bd8$var$t58 = $b091aef3a32d2bd8$var$_`
    color: ${0};
    border: 1px solid ${0};
    background-color: #e1e6e1;
    border-radius: 0.375rem;
    padding: 0.25rem 0.5rem;
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).success, (0, $8951886a6b49e92a$export$35e9368ef982300f).success);
const $b091aef3a32d2bd8$export$4e1c901a864890d = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($b091aef3a32d2bd8$var$t59 || ($b091aef3a32d2bd8$var$t59 = $b091aef3a32d2bd8$var$_`
    color: ${0};
    font-weight: 500;
    ${0}
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$41749b24b1e59255);
const $b091aef3a32d2bd8$export$ad47c28fb799b177 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($b091aef3a32d2bd8$var$t60 || ($b091aef3a32d2bd8$var$t60 = $b091aef3a32d2bd8$var$_`
    ${0}
    color: ${0};
    letter-spacing: 0.02rem;
    font-weight: 300;
`), $b091aef3a32d2bd8$export$41749b24b1e59255, (props)=>props.theme.color.textBody);
const $b091aef3a32d2bd8$export$97bcfb831ca24418 = (0, $8de346382d86c747$export$2e2bcd8739ae039).h2($b091aef3a32d2bd8$var$t61 || ($b091aef3a32d2bd8$var$t61 = $b091aef3a32d2bd8$var$_`
    text-transform: uppercase;
    color: ${0};
    font-weight: 700;
    ${0}
    letter-spacing: 0.02rem;
`), (props)=>props.theme.color.text, $b091aef3a32d2bd8$export$c0ddd0327d77e944);
const $b091aef3a32d2bd8$export$2fd1dcadb6f52076 = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($b091aef3a32d2bd8$var$t62 || ($b091aef3a32d2bd8$var$t62 = $b091aef3a32d2bd8$var$_`
    text-transform: uppercase;
    color: ${0};
    font-weight: 700;
    ${0}
    letter-spacing: 0.02rem;
`), (props)=>props.theme.color.textBodyLight, $b091aef3a32d2bd8$export$c0ddd0327d77e944);


// styles/buttonStyles.ts




let $2e997290a21e7a60$var$_ = (t)=>t, $2e997290a21e7a60$var$t, $2e997290a21e7a60$var$t1, $2e997290a21e7a60$var$t2, $2e997290a21e7a60$var$t3, $2e997290a21e7a60$var$t4, $2e997290a21e7a60$var$t5, $2e997290a21e7a60$var$t6, $2e997290a21e7a60$var$t7, $2e997290a21e7a60$var$t8, $2e997290a21e7a60$var$t9, $2e997290a21e7a60$var$t10, $2e997290a21e7a60$var$t11, $2e997290a21e7a60$var$t12;
const $2e997290a21e7a60$export$9d2da132b8db8494 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t || ($2e997290a21e7a60$var$t = $2e997290a21e7a60$var$_`
    text-align: center;
    border-radius: ${0};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
    position: relative;
    padding: 0.25rem 0.5rem;
    gap: 0.5rem;
    text-underline-offset: 0.15rem;
    @media (prefers-reduced-motion: no-preference) {
        transition: all 0.1s ease-out;
        & * {
            transition: ease-out 0.1s;
        }
    }
    transform-origin: center;
    ${0}
`), (0, $8951886a6b49e92a$export$7a57f79000377ca2).md, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $2e997290a21e7a60$export$8aee7c0c79d62b1e = {
    xsmall: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t1 || ($2e997290a21e7a60$var$t1 = $2e997290a21e7a60$var$_`
        ${0}
        padding: 0 0.5rem;
        min-height: 24px;
        border-radius: ${0};
        width: 100%;
    `), (0, $b091aef3a32d2bd8$export$3e193b19d995235f), (0, $8951886a6b49e92a$export$7a57f79000377ca2).sm),
    small: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t2 || ($2e997290a21e7a60$var$t2 = $2e997290a21e7a60$var$_`
        ${0}
        min-height: 2rem;
        padding: 0 0.625rem;
    `), (0, $b091aef3a32d2bd8$export$3e193b19d995235f)),
    medium: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t3 || ($2e997290a21e7a60$var$t3 = $2e997290a21e7a60$var$_`
        ${0}
        width: fit-content;
        max-width: 100%;
        padding: 0.625rem;
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4)),
    large: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t4 || ($2e997290a21e7a60$var$t4 = $2e997290a21e7a60$var$_`
        ${0}
        width: 100%;
        padding: 0.875rem;
    `), (0, $b091aef3a32d2bd8$export$1962b39d20eacf1d)),
    quick: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t5 || ($2e997290a21e7a60$var$t5 = $2e997290a21e7a60$var$_`
        ${0}
        padding: 0.625rem 0.875rem;
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4))
};
const $2e997290a21e7a60$export$948573dcec1ef86a = {
    xsmall: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t6 || ($2e997290a21e7a60$var$t6 = $2e997290a21e7a60$var$_`
        ${0}
        min-height: 2.25rem;
        padding: 0 0.5rem;
    `), (0, $b091aef3a32d2bd8$export$3e193b19d995235f)),
    small: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t7 || ($2e997290a21e7a60$var$t7 = $2e997290a21e7a60$var$_`
        ${0}
        min-height: 2.75rem;
        min-width: 44px;
        padding: 0 0.75rem;
    `), (0, $b091aef3a32d2bd8$export$3e193b19d995235f)),
    medium: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t8 || ($2e997290a21e7a60$var$t8 = $2e997290a21e7a60$var$_`
        ${0}
        min-width: 44px;
        min-height: 44px;
        width: fit-content;
        max-width: 100%;
        padding: 0.75rem;
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4)),
    large: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t9 || ($2e997290a21e7a60$var$t9 = $2e997290a21e7a60$var$_`
        ${0}
        width: 100%;
        min-width: 44px;
        min-height: 44px;
        padding: 1rem;
    `), (0, $b091aef3a32d2bd8$export$1962b39d20eacf1d)),
    quick: (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t10 || ($2e997290a21e7a60$var$t10 = $2e997290a21e7a60$var$_`
        ${0}
        min-width: 44px;
        min-height: 44px;
        padding: 0.75rem 1rem;
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4))
};
const $2e997290a21e7a60$export$e163c4626827e48 = ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t11 || ($2e997290a21e7a60$var$t11 = $2e997290a21e7a60$var$_`
    cursor: not-allowed;
    color: ${0};
    background: ${0};
    border-color: ${0};
    svg {
        color: ${0};
    }
    &:hover {
        background: ${0};
        color: ${0};
    }
`), theme.button.disabled.text, theme.button.disabled.background, theme.button.disabled.border, theme.button.disabled.icon, theme.button.disabled.hoverBackground, theme.button.disabled.hoverText);
const $2e997290a21e7a60$export$eed3a444493d1eb5 = ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($2e997290a21e7a60$var$t12 || ($2e997290a21e7a60$var$t12 = $2e997290a21e7a60$var$_`
    cursor: not-allowed;
    opacity: 0.9;
    color: ${0};
    border-color: ${0};
    &:hover {
        color: ${0};
    }
`), theme.button.disabled.text, theme.button.disabled.border, theme.button.disabled.text);


let $bc5329fe346ebf22$var$_ = (t)=>t, $bc5329fe346ebf22$var$t, $bc5329fe346ebf22$var$t1, $bc5329fe346ebf22$var$t2, $bc5329fe346ebf22$var$t3, $bc5329fe346ebf22$var$t4, $bc5329fe346ebf22$var$t5, $bc5329fe346ebf22$var$t6, $bc5329fe346ebf22$var$t7, $bc5329fe346ebf22$var$t8, $bc5329fe346ebf22$var$t9, $bc5329fe346ebf22$var$t10, $bc5329fe346ebf22$var$t11, $bc5329fe346ebf22$var$t12, $bc5329fe346ebf22$var$t13, $bc5329fe346ebf22$var$t14, $bc5329fe346ebf22$var$t15;
// ─────────────────────────────────────────────
// VARIANT STYLES
// Each variant is a self-contained style block.
// They reference theme tokens only — no raw values.
// The base structure (size, spacing, touch target)
// comes from buttonBaseStyles and sizeStyles.
// ─────────────────────────────────────────────
const $bc5329fe346ebf22$var$variantStyles = {
    primary: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t || ($bc5329fe346ebf22$var$t = $bc5329fe346ebf22$var$_`
        font-weight: 700;
        background: ${0};
        ${0};
        border: 1px solid ${0};
        color: ${0};
        text-decoration: none;
        &:hover {
            color: ${0};
            background: ${0};
            svg {
                color: ${0};
            }
        }
    `), theme.button.primary.background, theme.button.primary.backgroundImage && `background-image: ${(0, $8951886a6b49e92a$export$78ee211991971792).primary_button}`, theme.button.primary.border, theme.button.primary.text, theme.button.primary.hoverText, theme.button.primary.hoverBackground, theme.button.primary.icon),
    secondary: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t1 || ($bc5329fe346ebf22$var$t1 = $bc5329fe346ebf22$var$_`
        font-weight: 700;
        background: ${0};
        border: 1px solid ${0};
        color: ${0};
        text-decoration: none;
        &:hover {
            color: ${0};
            background: ${0};
        }
    `), theme.button.secondary.background, theme.button.secondary.border, theme.button.secondary.text, theme.button.secondary.hoverText, theme.button.secondary.hoverBackground),
    accent: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t2 || ($bc5329fe346ebf22$var$t2 = $bc5329fe346ebf22$var$_`
        font-weight: 300;
        background: ${0};
        border: 1px solid transparent;
        border-radius: ${0};
        color: ${0};
        text-decoration: none;
        &:hover {
            border-color: ${0};
            background: ${0};
            color: ${0};
            svg {
                color: ${0};
            }
        }
    `), theme.button.accent.background, (0, $8951886a6b49e92a$export$7a57f79000377ca2).lg, theme.button.accent.text, theme.button.accent.border, theme.button.accent.hoverBackground, theme.button.accent.hoverText, theme.button.accent.icon),
    simple: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t3 || ($bc5329fe346ebf22$var$t3 = $bc5329fe346ebf22$var$_`
        background: transparent;
        font-weight: 400;
        color: ${0};
        border: none;
        text-decoration: underline;
        text-decoration-color: ${0};
        min-width: fit-content;
        &:hover {
            box-shadow: 0 0 0 1px ${0};
            filter: none;
        }
    `), theme.button.simple.text, theme.button.simple.text, theme.button.simple.text),
    quick: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t4 || ($bc5329fe346ebf22$var$t4 = $bc5329fe346ebf22$var$_`
        font-weight: 400;
        font-family: 'Archivo', sans-serif;
        background: ${0};
        border: 1px solid ${0};
        border-radius: ${0};
        color: ${0};
        text-decoration: none;
        svg {
            color: ${0};
        }
        &:hover {
            background: ${0};
            color: ${0};
            text-decoration: underline;
            text-decoration-color: ${0};
            svg {
                color: ${0};
            }
        }
    `), theme.button.quick.background, theme.button.quick.border, (0, $8951886a6b49e92a$export$7a57f79000377ca2).lg, theme.button.quick.text, theme.button.quick.border, theme.button.quick.hoverBackground, theme.button.quick.hoverText, theme.button.quick.border, theme.button.quick.icon),
    solidAccent: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t5 || ($bc5329fe346ebf22$var$t5 = $bc5329fe346ebf22$var$_`
        font-weight: 300;
        background: ${0};
        border: 1px solid ${0};
        border-radius: ${0};
        color: ${0};
        min-width: fit-content;
        text-decoration: none;
        &:hover {
            border-color: ${0};
            background: ${0};
            color: ${0};
            svg {
                color: ${0};
            }
        }
    `), theme.button.accent.background, theme.color.accent, (0, $8951886a6b49e92a$export$7a57f79000377ca2).lg, theme.color.accent, theme.button.accent.border, theme.button.accent.hoverBackground, theme.button.accent.border, theme.button.accent.border),
    // ─────────────────────────────────────────────
    // ROUND SHELL/PANEL CONTROL VARIANTS
    // Shared color recipe behind FooterButton/SendButton
    // (card surface + accent icon, and accent-filled send).
    // ─────────────────────────────────────────────
    footer: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t6 || ($bc5329fe346ebf22$var$t6 = $bc5329fe346ebf22$var$_`
        background: ${0};
        border: 1px solid ${0};
        color: ${0};
        svg {
            color: ${0};
        }
        &:hover {
            background: ${0};
            color: ${0};
        }
    `), theme.button.footer.background, theme.button.footer.border, theme.button.footer.text, theme.button.footer.icon, theme.button.footer.hoverBackground, theme.button.footer.hoverText),
    send: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t7 || ($bc5329fe346ebf22$var$t7 = $bc5329fe346ebf22$var$_`
        background: ${0};
        border: 1px solid ${0};
        color: ${0};
        svg {
            color: ${0};
        }
        &:hover {
            background: ${0};
            color: ${0};
        }
    `), theme.button.send.background, theme.button.send.border, theme.button.send.text, theme.button.send.icon, theme.button.send.hoverBackground, theme.button.send.hoverText),
    danger: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t8 || ($bc5329fe346ebf22$var$t8 = $bc5329fe346ebf22$var$_`
        background: ${0};
        border: 1px solid ${0};
        color: ${0};
        svg {
            color: ${0};
        }
        &:hover {
            background: ${0};
            color: ${0};
            svg {
                color: ${0};
            }
        }
    `), theme.button.danger.background, theme.button.danger.border, theme.button.danger.text, theme.button.danger.icon, theme.button.danger.hoverBackground, theme.button.danger.hoverText, theme.button.danger.hoverText),
    // ─────────────────────────────────────────────
    // TEXT / LINK-STYLE VARIANTS
    // Folded in from the former TextButton component.
    // These reference color/banner tokens directly and
    // skip the filled-button base + size styles (see
    // sharedStyles → TEXT_VARIANTS branch below).
    // ─────────────────────────────────────────────
    text: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t9 || ($bc5329fe346ebf22$var$t9 = $bc5329fe346ebf22$var$_`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        ${0}
        font-weight: 500;
        color: ${0};
        &:hover {
            color: ${0};
            text-decoration: underline;
        }
    `), (0, $b091aef3a32d2bd8$export$3e193b19d995235f), theme.color.textBody, theme.color.link),
    context: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t10 || ($bc5329fe346ebf22$var$t10 = $bc5329fe346ebf22$var$_`
        ${0}
        font-weight: 400;
        color: ${0};
        text-decoration: underline !important;
        &:hover {
            color: ${0};
            text-decoration: none;
        }
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4), theme.color.link, theme.color.text),
    control: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t11 || ($bc5329fe346ebf22$var$t11 = $bc5329fe346ebf22$var$_`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        ${0}
        font-weight: 500;
        color: ${0};
        &:hover {
            cursor: pointer;
            color: ${0};
            text-decoration: underline;
        }
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4), theme.color.textBody, theme.color.link),
    negative: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t12 || ($bc5329fe346ebf22$var$t12 = $bc5329fe346ebf22$var$_`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        ${0}
        font-weight: 500;
        color: ${0};
        &:hover {
            color: ${0};
            text-decoration: underline;
        }
    `), (0, $b091aef3a32d2bd8$export$3e193b19d995235f), theme.banner.error.linkText, theme.color.link),
    subsection: ({ theme: theme })=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t13 || ($bc5329fe346ebf22$var$t13 = $bc5329fe346ebf22$var$_`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        ${0}
        font-weight: 400;
        color: ${0};
        text-decoration: underline !important;
        &:hover {
            cursor: pointer;
            color: ${0};
            text-decoration: underline;
        }
    `), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4), theme.color.link, theme.color.link)
};
// Text/link-style variants use a transparent, borderless base and opt out of
// the filled-button base + touch-target size styles.
const $bc5329fe346ebf22$var$TEXT_VARIANTS = new Set([
    'text',
    'context',
    'control',
    'negative',
    'subsection'
]);
const $bc5329fe346ebf22$var$textVariantBaseStyles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t14 || ($bc5329fe346ebf22$var$t14 = $bc5329fe346ebf22$var$_`
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-family: 'Archivo', sans-serif;
    padding: 0.25rem 1rem 0.25rem 0;
    text-decoration: none;
    ${0}
    @media (prefers-reduced-motion: no-preference) {
        transition: all 0.1s ease-out;
    }
    svg {
        vertical-align: middle;
        scale: 0.8;
    }
`), (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
// Shared style function — single source of truth for all three primitives.
// Filled variants get buttonBaseStyles + size styles; text/link variants get
// the transparent text base and skip sizing entirely.
const $bc5329fe346ebf22$var$sharedStyles = ({ theme: theme, $color: $color, $size: $size, $dashed: $dashed, $pill: $pill, disabled: disabled })=>{
    var _variantStyles_$color;
    const isText = $bc5329fe346ebf22$var$TEXT_VARIANTS.has($color);
    return (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($bc5329fe346ebf22$var$t15 || ($bc5329fe346ebf22$var$t15 = $bc5329fe346ebf22$var$_`
        ${0}
        ${0}
        ${0}
        ${0}
        ${0}
        ${0}
    `), isText ? $bc5329fe346ebf22$var$textVariantBaseStyles : (0, $2e997290a21e7a60$export$9d2da132b8db8494), (_variantStyles_$color = $bc5329fe346ebf22$var$variantStyles[$color]) === null || _variantStyles_$color === void 0 ? void 0 : _variantStyles_$color.call($bc5329fe346ebf22$var$variantStyles, {
        theme: theme
    }), !isText && (theme.scaleSize > 16 ? (0, $2e997290a21e7a60$export$948573dcec1ef86a)[$size] : (0, $2e997290a21e7a60$export$8aee7c0c79d62b1e)[$size]), $dashed && 'border-style: dashed;', $pill && `border-radius: ${(0, $8951886a6b49e92a$export$7a57f79000377ca2).pill};`, disabled && (isText ? (0, $2e997290a21e7a60$export$eed3a444493d1eb5)({
        theme: theme
    }) : (0, $2e997290a21e7a60$export$e163c4626827e48)({
        theme: theme
    })));
};
const $bc5329fe346ebf22$var$shouldForwardProp = (prop)=>![
        '$color',
        '$size',
        '$dashed',
        '$pill'
    ].includes(prop);
// Three typed primitives sharing one style function.
// button → <button>, href → <a>, to → <NavLink>
const $bc5329fe346ebf22$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)('button', {
    shouldForwardProp: $bc5329fe346ebf22$var$shouldForwardProp
})($bc5329fe346ebf22$var$sharedStyles);
const $bc5329fe346ebf22$var$StyledAnchor = (0, $8de346382d86c747$export$2e2bcd8739ae039)('a', {
    shouldForwardProp: $bc5329fe346ebf22$var$shouldForwardProp
})($bc5329fe346ebf22$var$sharedStyles);
const $bc5329fe346ebf22$var$StyledNavLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f232cebbf1b70e96$export$b0d92dbee9b5b60d), {
    shouldForwardProp: $bc5329fe346ebf22$var$shouldForwardProp
})($bc5329fe346ebf22$var$sharedStyles);
// ─────────────────────────────────────────────
// CORE BUTTON
// Renders as button, <a>, or NavLink depending
// on props. All three share the same styled
// primitive via the `as` prop — no duplicate
// styled components needed.
// ─────────────────────────────────────────────
const $bc5329fe346ebf22$var$Button = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_param, ref)=>{
    var { type: type = 'button', $color: $color = 'primary', $size: $size = 'medium', disabled: disabled = false, onClick: onClick, href: href, to: to, target: target, iconSize: iconSize, startIcon: startIcon, endIcon: endIcon, startComponent: startComponent, endComponent: endComponent, children: children } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "type",
        "$color",
        "$size",
        "disabled",
        "onClick",
        "href",
        "to",
        "target",
        "iconSize",
        "startIcon",
        "endIcon",
        "startComponent",
        "endComponent",
        "children"
    ]);
    // Auto-apply external link icon for blank targets
    if (target === '_blank' && (href === null || href === void 0 ? void 0 : href.startsWith('http'))) endIcon = endIcon !== null && endIcon !== void 0 ? endIcon : 'externalLink';
    // Default anchor target
    if (href && !target) target = '_self';
    // Text/link variants render smaller icons (matching the former
    // TextButton); filled variants default to 1.5rem.
    const isTextVariant = $bc5329fe346ebf22$var$TEXT_VARIANTS.has($color);
    const resolvedIconSize = iconSize !== null && iconSize !== void 0 ? iconSize : isTextVariant ? 1 : 1.5;
    const sharedProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        $color: $color,
        $size: $size,
        disabled: disabled,
        target: target,
        className: 'core-button'
    }, restProps);
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            startComponent,
            startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: startIcon,
                size: resolvedIconSize
            }),
            children,
            endComponent,
            endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: endIcon,
                size: resolvedIconSize
            })
        ]
    });
    if (href) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bc5329fe346ebf22$var$StyledAnchor, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: ref,
        className: "core-button",
        href: href,
        target: target,
        $color: $color,
        $size: $size
    }, restProps), {
        children: content
    }));
    if (to) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bc5329fe346ebf22$var$StyledNavLink, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: ref,
        className: "core-button",
        viewTransition: true,
        to: to,
        $color: $color,
        $size: $size
    }, restProps), {
        children: content
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bc5329fe346ebf22$var$StyledButton, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: ref,
        className: "core-button",
        type: type,
        onClick: onClick,
        disabled: disabled,
        $color: $color,
        $size: $size
    }, restProps), {
        children: content
    }));
});
$bc5329fe346ebf22$var$Button.displayName = 'CoreButton';
var $bc5329fe346ebf22$export$2e2bcd8739ae039 = $bc5329fe346ebf22$var$Button;




var $7fPBF = parcelRequire("7fPBF");


let $e0a3a060208427f7$var$_ = (t)=>t, $e0a3a060208427f7$var$t, $e0a3a060208427f7$var$t1, $e0a3a060208427f7$var$t2;
const $e0a3a060208427f7$var$Container = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e0a3a060208427f7$var$t || ($e0a3a060208427f7$var$t = $e0a3a060208427f7$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    min-height: 100vh;
    padding: 2rem;
    text-align: center;
    background: ${0};
`), (props)=>props.theme.color.background);
const $e0a3a060208427f7$var$Message = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$32a758e2e508ec9f))($e0a3a060208427f7$var$t1 || ($e0a3a060208427f7$var$t1 = $e0a3a060208427f7$var$_`
    max-width: 32rem;
`));
const $e0a3a060208427f7$var$Actions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e0a3a060208427f7$var$t2 || ($e0a3a060208427f7$var$t2 = $e0a3a060208427f7$var$_`
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: center;
    padding-top: 0.5rem;
`));
function $e0a3a060208427f7$export$2e2bcd8739ae039({ onError: onError }) {
    const error = (0, $39c9549f68558626$export$ed527bf60f6e05f2)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        // Log in the background instead of surfacing raw errors to the user.
        console.error('Route error boundary caught an error:', error);
        onError === null || onError === void 0 ? void 0 : onError(error);
    // Report only once when the boundary mounts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e0a3a060208427f7$var$Container, {
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1120d81cab3b4d4a), {
                children: t('error:appError.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e0a3a060208427f7$var$Message, {
                children: t('error:appError.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e0a3a060208427f7$var$Actions, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "primary",
                        onClick: ()=>window.location.reload(),
                        children: t('common:reload')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "secondary",
                        onClick: ()=>navigate('/'),
                        children: t('error:appError.home')
                    })
                ]
            })
        ]
    });
}









var $7fPBF = parcelRequire("7fPBF");



/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $f711ef723d44714d$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}










function $97c645b800be1175$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $97c645b800be1175$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $97c645b800be1175$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $97c645b800be1175$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $97c645b800be1175$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $dddaf6f84c717660$exports.ForwardRef:
            return $97c645b800be1175$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $dddaf6f84c717660$exports.Memo:
            return $97c645b800be1175$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}






function $b945bc00e988a2ef$export$2e2bcd8739ae039(input) {
    const { variants: variants } = input, style = (0, $8901fc92b5563702$export$71511d61b312f219)(input, [
        "variants"
    ]);
    const result = {
        variants: variants,
        style: (0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $0109f047b1d45fbf$export$35e57303dbd8a66 = (0, $67f12c31e9ee9daa$export$2e2bcd8739ae039)();
function $0109f047b1d45fbf$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $0109f047b1d45fbf$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $0109f047b1d45fbf$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $0109f047b1d45fbf$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $1f51cf9603142ca0$export$2e2bcd8739ae039)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $0109f047b1d45fbf$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$0109f047b1d45fbf$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle === null || resolvedStyle === void 0 ? void 0 : resolvedStyle.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $0109f047b1d45fbf$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants } = resolvedStyle, otherStyles = (0, $8901fc92b5563702$export$71511d61b312f219)(resolvedStyle, [
                "variants"
            ]);
            rootStyle = layerName ? $0109f047b1d45fbf$var$shallowLayer((0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(otherStyles), layerName) : otherStyles;
        }
        return $0109f047b1d45fbf$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle === null || resolvedStyle === void 0 ? void 0 : resolvedStyle.isProcessed) return layerName ? $0109f047b1d45fbf$var$shallowLayer((0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $0109f047b1d45fbf$var$shallowLayer((0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(resolvedStyle), layerName) : resolvedStyle;
}
function $0109f047b1d45fbf$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState !== null && mergedState !== void 0 ? mergedState : mergedState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props, props.ownerState), {
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            var _props_ownerState;
            if (props[key] !== variant.props[key] && ((_props_ownerState = props.ownerState) === null || _props_ownerState === void 0 ? void 0 : _props_ownerState[key]) !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState !== null && mergedState !== void 0 ? mergedState : mergedState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props, props.ownerState), {
                ownerState: props.ownerState
            });
            results.push(layerName ? $0109f047b1d45fbf$var$shallowLayer((0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $0109f047b1d45fbf$var$shallowLayer((0, $4840e3b66caa6fde$export$13a2d3ef13012b32)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $0109f047b1d45fbf$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0109f047b1d45fbf$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0109f047b1d45fbf$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0109f047b1d45fbf$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $0109f047b1d45fbf$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $4840e3b66caa6fde$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $06ba45f570780ba8$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0109f047b1d45fbf$var$defaultOverridesResolver($0109f047b1d45fbf$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $8901fc92b5563702$export$71511d61b312f219)(inputOptions, [
            "name",
            "slot",
            "skipVariantsResolver",
            "skipSx",
            "overridesResolver"
        ]);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $0109f047b1d45fbf$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0109f047b1d45fbf$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $4840e3b66caa6fde$export$2e2bcd8739ae039)(tag, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            shouldForwardProp: shouldForwardPropOption,
            label: $0109f047b1d45fbf$var$generateStyledLabel(componentName, componentSlot)
        }, options));
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $0109f047b1d45fbf$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $9450f632817fee8b$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $b945bc00e988a2ef$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $0109f047b1d45fbf$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $0109f047b1d45fbf$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                var _theme_components_componentName, _theme_components;
                const theme = props.theme;
                const styleOverrides = (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_componentName = _theme_components[componentName]) === null || _theme_components_componentName === void 0 ? void 0 : _theme_components_componentName.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $0109f047b1d45fbf$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                var _theme_components_componentName, _theme_components;
                const theme = props.theme;
                const themeVariants = theme === null || theme === void 0 ? void 0 : (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_componentName = _theme_components[componentName]) === null || _theme_components_componentName === void 0 ? void 0 : _theme_components_componentName.variants;
                if (!themeVariants) return null;
                return $0109f047b1d45fbf$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $06ba45f570780ba8$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $0109f047b1d45fbf$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $c2e12d7064dac06e$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $97c645b800be1175$export$2e2bcd8739ae039)(tag)})`;
}
function $0109f047b1d45fbf$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0109f047b1d45fbf$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $0109f047b1d45fbf$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}




// copied from @mui/system/createStyled
function $69b67c4b8d281c07$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $69b67c4b8d281c07$export$2e2bcd8739ae039 = $69b67c4b8d281c07$var$slotShouldForwardProp;


const $796b6cf2edfc05d3$var$rootShouldForwardProp = (prop)=>(0, $69b67c4b8d281c07$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $796b6cf2edfc05d3$export$2e2bcd8739ae039 = $796b6cf2edfc05d3$var$rootShouldForwardProp;



'use client';
const $ce10e2b5fa342a3c$var$styled = (0, $0109f047b1d45fbf$export$2e2bcd8739ae039)({
    themeId: (0, $3096faf8e377d232$export$2e2bcd8739ae039),
    defaultTheme: $7a5b46fd67f157c3$export$2e2bcd8739ae039,
    rootShouldForwardProp: $796b6cf2edfc05d3$export$2e2bcd8739ae039
});
var $ce10e2b5fa342a3c$export$2e2bcd8739ae039 = $ce10e2b5fa342a3c$var$styled;



/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $6e7fdeba6dcbe24a$var$arg = {
    theme: undefined
};
function $6e7fdeba6dcbe24a$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $6e7fdeba6dcbe24a$var$arg.theme = props.theme;
            value = (0, $b945bc00e988a2ef$export$2e2bcd8739ae039)(styleFn($6e7fdeba6dcbe24a$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $958b1f7c7bc02768$var$memoTheme = (0, $6e7fdeba6dcbe24a$export$2e2bcd8739ae039);
var $958b1f7c7bc02768$export$2e2bcd8739ae039 = $958b1f7c7bc02768$var$memoTheme;



parcelRequire("7fPBF");



'use client';
function $c6c3e15a46633a8f$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $67ed59d14b557650$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
}
var $c6c3e15a46633a8f$export$2e2bcd8739ae039 = $c6c3e15a46633a8f$var$DefaultPropsProvider;
function $c6c3e15a46633a8f$export$2440da353cedad43(params) {
    return (0, $67ed59d14b557650$export$2440da353cedad43)(params);
}



var $8353d23c1e9a3769$export$2e2bcd8739ae039 = (0, $c2e12d7064dac06e$export$2e2bcd8739ae039);


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $9c4e6c7e7d64f2cc$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $9c4e6c7e7d64f2cc$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$9c4e6c7e7d64f2cc$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $9c4e6c7e7d64f2cc$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}



const $cb5a0f46c2f8cec1$export$214b055320e0bf32 = {
    transition: 'none'
};
function $cb5a0f46c2f8cec1$export$3f1342cbd4bf84cc(reducedMotion, styles) {
    if (reducedMotion === 'always') return styles;
    if (reducedMotion === 'system') return {
        '@media (prefers-reduced-motion: reduce)': styles
    };
    return null;
}


const $0ea347727154ba9d$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
const $0ea347727154ba9d$var$DEFAULT_TRANSLATE_OFFSET = {
    offsetX: 0,
    offsetY: 0
};
const $0ea347727154ba9d$var$EMPTY_STYLE = {};
const $0ea347727154ba9d$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $0ea347727154ba9d$var$EMPTY_OPTIONS = {};
const $0ea347727154ba9d$var$transformOffsetIndexes = {
    matrix: [
        4,
        5
    ],
    matrix3d: [
        12,
        13
    ],
    translate: [
        0,
        1
    ],
    translate3d: [
        0,
        1
    ],
    translateX: [
        0,
        null
    ],
    translateY: [
        null,
        0
    ]
};
function $0ea347727154ba9d$var$parseTranslateValue(value) {
    const parsedValue = parseFloat(value !== null && value !== void 0 ? value : '');
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
}
function $0ea347727154ba9d$var$parseTransform(transform) {
    const match = transform.match(/^(matrix|matrix3d|translate|translate3d|translateX|translateY)\((.+)\)$/);
    if (!match) return null;
    return {
        type: match[1],
        values: match[2].split(',').map($0ea347727154ba9d$var$parseTranslateValue)
    };
}
function $0ea347727154ba9d$var$getTranslateOffsetValue(values, index) {
    return index === null ? 0 : values[index] || 0;
}
function $0ea347727154ba9d$export$23d6f784a708ab33(transform) {
    if (!transform || transform === 'none') return $0ea347727154ba9d$var$DEFAULT_TRANSLATE_OFFSET;
    const parsedTransform = $0ea347727154ba9d$var$parseTransform(transform);
    if (!parsedTransform) return $0ea347727154ba9d$var$DEFAULT_TRANSLATE_OFFSET;
    const { type: type, values: values } = parsedTransform;
    const offsetIndexes = $0ea347727154ba9d$var$transformOffsetIndexes[type];
    if (!offsetIndexes) return $0ea347727154ba9d$var$DEFAULT_TRANSLATE_OFFSET;
    return {
        offsetX: $0ea347727154ba9d$var$getTranslateOffsetValue(values, offsetIndexes[0]),
        offsetY: $0ea347727154ba9d$var$getTranslateOffsetValue(values, offsetIndexes[1])
    };
}
function $0ea347727154ba9d$export$da8da2b45a650a33(nodeRef, callback) {
    return (maybeIsAppearing)=>{
        if (callback) {
            const node = nodeRef.current;
            // Enter callbacks receive isAppearing; exit callbacks do not.
            if (maybeIsAppearing === undefined) callback(node);
            else callback(node, maybeIsAppearing);
        }
    };
}
function $0ea347727154ba9d$export$c1e03ca92f01ef32(state, inProp, baseStyles, hiddenStyles, styleProp, childStyle) {
    const base = state === 'exited' && !inProp ? hiddenStyles : baseStyles[state] || baseStyles.exited;
    return styleProp || childStyle ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, base, styleProp, childStyle) : base;
}
function $0ea347727154ba9d$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = $0ea347727154ba9d$var$EMPTY_STYLE } = props;
    var _style_transitionDuration, _style_transitionTimingFunction;
    return {
        duration: (_style_transitionDuration = style.transitionDuration) !== null && _style_transitionDuration !== void 0 ? _style_transitionDuration : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style_transitionTimingFunction = style.transitionTimingFunction) !== null && _style_transitionTimingFunction !== void 0 ? _style_transitionTimingFunction : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}
function $0ea347727154ba9d$export$4bc2c89b8b366948(theme, styles) {
    var _theme_motion;
    const resolvedStyles = styles !== null && styles !== void 0 ? styles : (0, $cb5a0f46c2f8cec1$export$214b055320e0bf32);
    return (0, $cb5a0f46c2f8cec1$export$3f1342cbd4bf84cc)((_theme_motion = theme.motion) === null || _theme_motion === void 0 ? void 0 : _theme_motion.reducedMotion, resolvedStyles);
}
function $0ea347727154ba9d$export$cfbcd9a4c0ed32ac(theme, props = $0ea347727154ba9d$var$DEFAULT_TRANSITION_PROPS, options = $0ea347727154ba9d$var$EMPTY_OPTIONS) {
    var _theme_transitions_create, _theme_transitions;
    const transition = (_theme_transitions = theme.transitions) === null || _theme_transitions === void 0 ? void 0 : (_theme_transitions_create = _theme_transitions.create) === null || _theme_transitions_create === void 0 ? void 0 : _theme_transitions_create.call(_theme_transitions, props, options);
    const reducedMotionStyles = $0ea347727154ba9d$export$4bc2c89b8b366948(theme);
    if (transition === undefined) return reducedMotionStyles !== null && reducedMotionStyles !== void 0 ? reducedMotionStyles : $0ea347727154ba9d$var$EMPTY_STYLE;
    const transitionStyles = {
        transition: transition
    };
    return reducedMotionStyles ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transitionStyles, reducedMotionStyles) : transitionStyles;
}


const $a014965d951379c4$var$defaultGenerator = (componentName)=>componentName;
const $a014965d951379c4$var$createClassNameGenerator = ()=>{
    let generate = $a014965d951379c4$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $a014965d951379c4$var$defaultGenerator;
        }
    };
};
const $a014965d951379c4$var$ClassNameGenerator = $a014965d951379c4$var$createClassNameGenerator();
var $a014965d951379c4$export$2e2bcd8739ae039 = $a014965d951379c4$var$ClassNameGenerator;


const $e3a5efaa168b7e25$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $e3a5efaa168b7e25$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $e3a5efaa168b7e25$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $a014965d951379c4$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $e3a5efaa168b7e25$export$34c0130b1f3e8ae3(slot) {
    return $e3a5efaa168b7e25$export$9d6b9120de57c54[slot] !== undefined;
}


function $e320bada9cd4dcc5$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $a30b0ef863569af4$export$29cad1383b3f235d(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $a30b0ef863569af4$var$circularProgressClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDisableShrink'
]);
var $a30b0ef863569af4$export$2e2bcd8739ae039 = $a30b0ef863569af4$var$circularProgressClasses;



'use client';
let $5310a643ead17d95$var$_ = (t)=>t, $5310a643ead17d95$var$t, $5310a643ead17d95$var$t1, $5310a643ead17d95$var$t2, $5310a643ead17d95$var$t3;
const $5310a643ead17d95$var$SIZE = 44;
let $5310a643ead17d95$var$warnedMinMaxWithoutVariant = false;
let $5310a643ead17d95$var$warnedInvalidMinMaxValue = false;
function $5310a643ead17d95$export$36f40a3150c2c3a2() {
    $5310a643ead17d95$var$warnedMinMaxWithoutVariant = false;
    $5310a643ead17d95$var$warnedInvalidMinMaxValue = false;
}
const $5310a643ead17d95$var$circularRotateKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($5310a643ead17d95$var$t || ($5310a643ead17d95$var$t = $5310a643ead17d95$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $5310a643ead17d95$var$circularDashKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($5310a643ead17d95$var$t1 || ($5310a643ead17d95$var$t1 = $5310a643ead17d95$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`));
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $5310a643ead17d95$var$rotateAnimation = typeof $5310a643ead17d95$var$circularRotateKeyframe !== 'string' ? (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($5310a643ead17d95$var$t2 || ($5310a643ead17d95$var$t2 = $5310a643ead17d95$var$_`
        animation: ${0} 1.4s linear infinite;
      `), $5310a643ead17d95$var$circularRotateKeyframe) : null;
const $5310a643ead17d95$var$dashAnimation = typeof $5310a643ead17d95$var$circularDashKeyframe !== 'string' ? (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($5310a643ead17d95$var$t3 || ($5310a643ead17d95$var$t3 = $5310a643ead17d95$var$_`
        animation: ${0} 1.4s ease-in-out infinite;
      `), $5310a643ead17d95$var$circularDashKeyframe) : null;
const $5310a643ead17d95$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $a30b0ef863569af4$export$29cad1383b3f235d), classes);
};
const $5310a643ead17d95$var$CircularProgressRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionAnimationStyles = (0, $0ea347727154ba9d$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    return {
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'transform'))
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $5310a643ead17d95$var$rotateAnimation || {
                    animation: `${$5310a643ead17d95$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...reducedMotionAnimationStyles ? [
                {
                    props: {
                        variant: 'indeterminate'
                    },
                    style: reducedMotionAnimationStyles
                }
            ] : [],
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    };
}));
const $5310a643ead17d95$var$CircularProgressSVG = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $5310a643ead17d95$var$CircularProgressCircle = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionAnimationStyles = (0, $0ea347727154ba9d$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    return {
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'stroke-dashoffset'))
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine while waiting for the animation to kick in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $5310a643ead17d95$var$dashAnimation || {
                    // At runtime for Pigment CSS, `dashAnimation` will be null and the generated keyframe will be used.
                    animation: `${$5310a643ead17d95$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            },
            ...reducedMotionAnimationStyles ? [
                {
                    props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                    style: reducedMotionAnimationStyles
                }
            ] : []
        ]
    };
}));
const $5310a643ead17d95$var$CircularProgressTrack = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $5310a643ead17d95$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    var _props_min;
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, min: minProp, max: maxProp, size: size = 40, style: style, thickness: thickness = 3.6, value: value = (_props_min = props.min) !== null && _props_min !== void 0 ? _props_min : 0, variant: variant = 'indeterminate' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "color",
        "disableShrink",
        "enableTrackSlot",
        "min",
        "max",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    const min = minProp !== null && minProp !== void 0 ? minProp : 0;
    const max = maxProp !== null && maxProp !== void 0 ? maxProp : 100;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    });
    const classes = $5310a643ead17d95$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($5310a643ead17d95$var$SIZE - thickness) / 2);
        const range = max - min;
        circleStyle.strokeDasharray = circumference.toFixed(3);
        circleStyle.strokeDashoffset = range > 0 ? `${((max - value) / range * circumference).toFixed(3)}px` : `${circumference.toFixed(3)}px`; // empty-state fallback when range is invalid
        rootStyle.transform = 'rotate(-90deg)';
        rootProps['aria-valuenow'] = value;
        rootProps['aria-valuemin'] = min;
        rootProps['aria-valuemax'] = max;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5310a643ead17d95$var$CircularProgressRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5310a643ead17d95$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$5310a643ead17d95$var$SIZE / 2} ${$5310a643ead17d95$var$SIZE / 2} ${$5310a643ead17d95$var$SIZE} ${$5310a643ead17d95$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5310a643ead17d95$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $5310a643ead17d95$var$SIZE,
                    cy: $5310a643ead17d95$var$SIZE,
                    r: ($5310a643ead17d95$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5310a643ead17d95$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $5310a643ead17d95$var$SIZE,
                    cy: $5310a643ead17d95$var$SIZE,
                    r: ($5310a643ead17d95$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    }));
});
var $5310a643ead17d95$export$2e2bcd8739ae039 = $5310a643ead17d95$var$CircularProgress;





parcelRequire("7fPBF");
const $0e54c6b17377038f$var$SvgIcon = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 500 500"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "icon_svg__linear-gradient",
                        x1: 87.69,
                        x2: 445.37,
                        y1: 515.02,
                        y2: 376.71,
                        gradientTransform: "rotate(-8.86 -1005.607 449.555)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "icon_svg__linear-gradient-2",
                        x1: -1214.8,
                        x2: -1320.26,
                        y1: -1720.35,
                        y2: -1993.07,
                        gradientTransform: "rotate(81.14 -1702.827 77.309)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "icon_svg__luminosity-invert",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.icon_svg__cls-8{stroke-width:0}.icon_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.icon_svg__cls-8{fill:#ee486f}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "icon_svg__mask",
                        width: 386,
                        height: 388,
                        x: 57.27,
                        y: 56.08,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 386,
                            height: 388,
                            style: {
                                filter: 'url(#icon_svg__luminosity-invert)'
                            },
                            transform: "translate(57.27 56.08)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "icon_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 250,
                            cy: 250,
                            r: 218.04,
                            style: {
                                fill: '#fff',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'url(#icon_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#icon_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M423.3 278.06c-6.24-20.76-23.53-25.23-34.56-23.23-3.73.68-7.06 2.19-9.6 3.65-1.18.68-.54 2.48.8 2.29 7.95-1.09 22-.85 28.92 12.28 2.42 4.6 12.06 24.68-18.71 41.5-16.41 8.97-35.03 6.43-43.28-4.98-4.76 2.88-9.59 5.81-14.61 8.81-12.93-18.26-30.68-11.37-39.03-5.58-1.14.79-.3 2.57 1.04 2.21 8.24-2.21 22.21-3.67 29.17 8.79 6.02 10.79-1.44 25.88-15.8 33.23-14.36 7.35-31.45 8.24-36.53-7.56-5.86 2.13-11.77 4.06-17.76 5.63-4.84-18.54-20.06-20.22-28.74-17.95-1.34.35-1.18 2.31.2 2.43 6.28.56 15.15 2.91 18.77 11.41 2.9 6.83 2.42 22.51-22.21 25.61-13.96 1.76-28.18-4.3-27.8-17.71-6.35-.98-12.67-2.4-18.91-4.42 6.76-16.28-4.56-26.7-12.61-30.2-1.29-.56-2.4 1.09-1.35 2.03 4.06 3.65 8.69 9.47 8.47 16.88-1.17 15.18-16.96 19.66-30.98 12.01-11.58-6.32-19.7-18.59-11.68-30.53-12.52-12.32-23-30.24-29.21-48.7-12.14-36.08 0-72.66 26.42-94.1 33.14-26.87 65.23-18.02 80.26-12.18 2.7 1.05 2.23 3.64-.83 3.01-2.06-.43-4.6-.58-6.87-.72-5.33-.34-10.96 0-15.57 1.17-15.55 3.96-28.26 22.1-29.23 46.19.29 22.04 11.21 47.71 32.94 55.39 29.17 10.77 54.06-8.72 77.23-26.1 20.69-15.92 42.37-36.48 71.26-55.21 42.25-27.4 85.07-37.27 85.07-37.27-27.13-48.06-74.23-82.66-128.27-93.87-21.93-4.55-45.02-5.34-68.45-1.69a192.795 192.795 0 0 0-36.2 9.32s-24.5 8.63-44.5 23.19c-2.25 1.63-4.94 3.83-7.73 6.2-4.46 3.8-1.26 11.06 4.55 10.31 11.82-1.52 27.68-1.4 46.13 4.13 34.82 10.44 52.88 35.39 61.54 52 4.7 9.03-4.08 12.95-9.12 7.9-15.94-15.99-64.45-45.57-121.42-15.56-37.65 19.83-51.86 54.75-54.29 83.82-3.7 44.1 12.63 83.05 23.73 102.62 27.1 47.83 73.78 81.92 127.59 93.18 22.02 4.61 45.23 5.43 68.77 1.76 43.21-6.73 80.75-27.43 108.83-56.75a193.006 193.006 0 0 0 30.14-41.27c10.4-19.14 17.61-40.12 21.01-62.13a2.18 2.18 0 0 0-1.97-2.49c-8.48-.7-15.01 1.26-15.01 1.26Z",
                                className: "icon_svg__cls-10",
                                style: {
                                    fill: '#141728',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M282.16 344.9c1.32 2.58 4.5 3.52 6.28 3.84 4.19.77 9.19-.13 13.73-2.45 7.84-4.01 11.81-10.96 11.12-15.38-.09-.6-.27-1.15-.55-1.68-1.32-2.58-4.5-3.52-6.28-3.84-4.19-.77-9.19.13-13.73 2.45-7.84 4.01-11.8 10.97-11.11 15.38.09.6.27 1.15.54 1.67ZM204.94 359.8v.09c.54 3.38 6.68 7.58 15.12 6.49 4.29-.56 8.17-2.41 10.67-5.07.77-.82 2.52-2.97 2.21-5.23-.53-3.37-6.67-7.58-15.11-6.49-4.29.56-8.17 2.41-10.66 5.07-.77.82-2.52 2.97-2.23 5.14ZM135.15 331.26c-.13.2-.5.79-.43 2.08.16 3.06 2.65 7.61 7.83 10.9 3.47 2.2 7.38 3.3 10.71 3 .96-.08 3.29-.44 4.18-1.84.12-.2.5-.78.43-2.07-.16-3.05-2.65-7.61-7.83-10.9-3.47-2.2-7.38-3.3-10.71-3-.96.09-3.29.44-4.17 1.83ZM354.77 298.44c.17 1.11.52 2.16 1.03 3.12 3.96 7.35 17.35 8.47 28.67 2.39 11.08-5.96 15.86-15.63 14.85-22.1a9.572 9.572 0 0 0-1.04-3.12c-3.95-7.35-17.34-8.47-28.66-2.39-11.08 5.96-15.86 15.63-14.85 22.1Z",
                            className: "icon_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M332.91 193.39c-28.88 18.73-50.56 39.3-71.26 55.21-23.17 17.37-48.06 36.86-77.23 26.1-21.74-7.68-32.65-33.34-32.94-55.39.97-24.09 12.32-42.76 51.67-46.63-16.82-3.36-34.43-.73-46.78 7.54-39.16 26.22-32.77 64.92-21.16 87.92 11.09 22 38.58 42.82 72.01 42.74 22.84-.06 50.73-9.11 93.49-41.57 52.34-39.73 94.85-54.55 133.93-55.27.59-.01 1.18-.11 1.75-.07 1.55.08 2.7-.54 2.07-2.99-.09-.35-.15-.7-.22-1.05-4.11-19.3-11.01-37.36-20.24-53.81-2.25.51-42.83 9.87-85.07 37.27Z",
                            style: {
                                fill: 'url(#icon_svg__linear-gradient-2)',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M258.57 228.81c-23.17 17.37-46.14 40.29-75.31 29.52-15.38-5.43-27.15-23.33-31.77-39.13 0 .04 0 .07-.01.11.02 1.38.08 2.77.18 4.17.1 1.4.24 2.81.43 4.22 2.58 19.78 13.32 40.27 32.34 46.99 5.47 2.02 10.79 2.97 15.97 3.08 22.47.45 42.43-15.06 61.26-29.17 6.11-4.7 12.33-9.82 18.76-15.16 15.38-12.76 32.13-26.84 52.49-40.05 41.43-26.87 81.37-36.42 85.02-37.26v-.11a191.01 191.01 0 0 0-11.29-17.62c-16.21 5.31-50.57 18.18-76.81 35.19-28.88 18.73-50.56 39.29-71.25 55.21Z",
                            style: {
                                fill: '#141526',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M99.69 189.16c-13.2 15.05-31.43 60.23-13.11 104.52 4.7 11.37 11.11 24.1 21.23 34.37-.64 3.74-.68 7.44-.12 11.05 3.05 19.55 22.46 29.74 23.45 30.25 19.15 9.13 33.08 3.38 38.85-.06l10.79 3.27c7.88 22.93 39.73 20.67 41.12 20.56 23.42-1.76 33-14.04 36.22-19.78l7.55-2.49c20.74 19.19 51.76 1.14 53.12.33 21.54-12.7 24.48-31.1 24.62-39.32l1.83-1.06c26.46 16.4 56.87-2.77 57.87-3.43 17.86-9.84 24.13-25.13 26.15-32.16 2.45-.6 5.42-.59 7.91-.37 1.24-5.12 2.29-10.3 3.11-15.55.19-1.24-.73-2.39-1.98-2.49-1.35-.11-2.65-.15-3.89-.14-.17 0-.36-.01-.53 0-.48 0-.92.04-1.38.07-.52.02-1.08.03-1.56.07-.19.01-.34.04-.53.06-.71.06-1.41.13-2.04.22-1.2.16-2.16.34-2.96.51-.28.06-.58.12-.81.17-.82.19-1.29.33-1.29.33-.71-2.34-1.59-4.42-2.55-6.36-.29-.58-.6-1.11-.91-1.66-.76-1.35-1.57-2.6-2.43-3.75-.34-.45-.68-.93-1.03-1.35-2.57-3.05-5.48-5.38-8.55-7.02a29.867 29.867 0 0 0-9.9-3.21c-1.63-.23-3.24-.32-4.78-.29-1.54.03-3.02.18-4.39.43-1.53.28-2.93.76-4.29 1.25-.82.31-1.64.63-2.4.98-1.01.46-2.05.92-2.9 1.41-.01 0-.01.02-.02.03-.36.23-.5.57-.53.91v.24c.05.35.19.7.5.91.14.09.34.09.53.11.12.02.2.09.33.07.96-.13 2.04-.23 3.16-.3h.2c.6-.04 1.25-.02 1.88-.03h.09c.57 0 1.11-.04 1.7-.02s.02 0 .02 0c.05 0 .1.01.15.01 1.01.04 2.05.13 3.1.26.53.07 1.05.18 1.58.27.64.12 1.28.25 1.92.41.73.18 1.45.39 2.19.65.53.18 1.05.42 1.58.63s1.04.4 1.55.66c1.19.6 2.36 1.28 3.47 2.13 2.42 1.85 4.59 4.33 6.32 7.61.04.07.09.2.14.28.51.99 1.25 2.55 1.9 4.56.1.32.21.63.3.97.2.7.37 1.43.53 2.21.02.08.04.16.06.25.14.78.26 1.6.33 2.46v.02c.04.51.04 1.06.05 1.59v.04c.03 1.68-.14 3.46-.54 5.32-.05.24-.09.48-.15.72-.1.41-.21.82-.34 1.23-.42 1.36-1.01 2.75-1.73 4.15l-.03.06c-.49.94-1.05 1.88-1.7 2.84-.17.26-.34.51-.52.76-.64.89-1.37 1.78-2.16 2.68-.06.07-.12.13-.17.2a41.236 41.236 0 0 1-4.27 4.13c-.05.04-.09.09-.14.13a58.12 58.12 0 0 1-5.6 4.09h-.01c-1.13.73-2.35 1.45-3.63 2.18-.01 0-.03.01-.04.02-.33.19-.61.38-.95.57-.08.04-.17.08-.25.11-.71.38-1.43.64-2.15.98-1.05.5-2.09 1.02-3.15 1.43-1.2.46-2.4.79-3.61 1.14h-.02c-.65.19-1.3.4-1.95.55h-.02c-.92.22-1.83.4-2.75.56-.85.14-1.69.23-2.53.31-1.08.11-2.15.23-3.2.25h-.01c-.1 0-.2-.01-.3-.01-2.3.02-4.51-.19-6.66-.58-.09-.02-.17-.04-.25-.05-1.81-.34-3.53-.83-5.18-1.46h-.02a26.38 26.38 0 0 1-4.64-2.3c-.13-.08-.26-.18-.39-.27-1.12-.73-2.19-1.49-3.16-2.38-.25-.22-.45-.48-.67-.73-.57-.57-1.13-1.14-1.63-1.77-.24-.25-.5-.48-.7-.76-4.76 2.88-9.59 5.81-14.61 8.81-.07-.1-.14-.17-.21-.27-.07-.08-.13-.16-.2-.25-.78-1.06-1.57-2.04-2.38-2.93-.38-.42-.77-.78-1.15-1.16a30.6 30.6 0 0 0-1.81-1.66c-.43-.35-.85-.69-1.28-1.01-.6-.44-1.21-.83-1.81-1.2-.2-.12-.41-.24-.61-.36-.01 0-.03-.01-.04-.02-.2-.12-.4-.25-.61-.36-.76-.4-1.52-.73-2.29-1.02-2.14-.83-4.29-1.31-6.41-1.48h-.03c-1.61-.12-3.2-.08-4.75.1s-.01 0-.02 0c-.62.07-1.22.18-1.83.29-.06 0-.13.02-.19.03-.3.05-.6.1-.89.16l-.22.06c-.13.03-.25.07-.38.1-1.02.25-2.02.55-2.98.88-.03 0-.05.02-.08.03-.13.04-.26.09-.39.13-1.29.47-2.52 1-3.68 1.57-.07.03-.14.07-.22.11-.05.02-.09.04-.14.07-1.57.8-3 1.64-4.23 2.48-.03.02-.05.03-.08.05-.04.03-.08.05-.12.08-.27.19-.42.44-.49.7-.04.15 0 .29.02.44v.08c0 .05 0 .09.02.14.07.19.19.37.35.52.12.12.27.21.43.28h.09c.12.03.25.05.39.04.07 0 .13.02.2 0 .87-.23 1.83-.45 2.81-.65.18-.04.34-.09.52-.12 1.07-.21 2.22-.36 3.38-.48l.59-.06c.16-.01.32 0 .48-.02 1.28-.1 2.58-.13 3.91-.07h.04c1.31.06 2.63.21 3.94.46.28.06.56.14.84.22 1.02.24 2.03.52 3.01.91.3.12.59.3.88.44h.02c.92.43 1.83.87 2.7 1.46.42.28.79.67 1.19 1.01.74.6 1.48 1.19 2.15 1.94.97 1.08 1.89 2.28 2.69 3.72.62 1.11 1.01 2.29 1.34 3.48.18.61.3 1.23.41 1.86.16.95.29 1.9.29 2.88 0 .6-.07 1.19-.14 1.79-.06.49-.15 1.3-.24 1.79-.16.86-.34 1.71-.6 2.57-.26.84-.56 1.67-.92 2.5-.37.87-.82 1.72-1.29 2.57-.16.28-.33.56-.5.84-1.62 2.68-3.72 5.2-6.27 7.48-.63.55-1.24 1.11-1.92 1.63-1.83 1.42-3.77 2.75-5.94 3.85s-.01.01-.02.01c-1.27.65-2.56 1.22-3.85 1.76-.05.02-.11.04-.16.07h-.01c-2.69 1.11-5.42 1.96-8.12 2.51h-.01c-.09.02-.19.04-.28.05-5.24 1.03-10.29.87-14.5-.94-.15-.06-.28-.14-.43-.21-.83-.38-1.62-.83-2.37-1.35-.16-.11-.34-.22-.5-.34a16.09 16.09 0 0 1-2.37-2.17c-.1-.12-.19-.25-.29-.37-.61-.73-1.17-1.55-1.68-2.43-.14-.24-.28-.47-.41-.72-.55-1.05-1.06-2.17-1.46-3.43-5.86 2.13-11.77 4.07-17.76 5.63s0-.03-.01-.04c0-.02-.01-.04-.02-.06-1.08-4.1-2.72-7.27-4.63-9.85-.2-.27-.37-.61-.57-.89-.18-.24-.37-.43-.56-.63s-.04-.05-.07-.07c-.45-.51-.9-1-1.37-1.44-.31-.29-.63-.54-.94-.8-.39-.32-.78-.64-1.18-.92-.34-.24-.68-.47-1.02-.68-.41-.26-.83-.5-1.24-.72-.16-.09-.32-.17-.48-.25-.18-.09-.35-.19-.53-.27-.5-.23-1.01-.43-1.52-.63-.02 0-.04-.02-.07-.02-.01 0-.02 0-.03-.01-.22-.08-.43-.18-.65-.25-.79-.26-1.58-.48-2.37-.65l-.17-.03h-.06c-.75-.15-1.51-.27-2.25-.35h-.12c-.07 0-.15-.01-.22-.02-.73-.07-1.45-.11-2.16-.11h-.19c-.79 0-1.56.03-2.31.1h-.13c-.25.02-.5.05-.75.08-.98.12-1.91.29-2.78.51-.12.03-.25.05-.37.08-.32.08-.54.27-.69.49-.14.21-.2.46-.19.72v.01c0 .07.02.15.04.22.03.16.1.3.19.44.05.08.1.15.17.22.03.02.07.03.11.05.07.05.16.08.25.12.07.04.13.08.21.1.05.01.09.05.14.05.08 0 .17.04.25.05 1.72.17 3.62.49 5.55 1.01s.08 0 .12.02c.07.02.15.06.22.08.87.25 1.73.55 2.59.89.04.01.07.03.11.05.85.35 1.68.75 2.49 1.21h.02c1.67.95 3.21 2.16 4.55 3.68.25.29.5.57.73.88.77 1.01 1.46 2.1 2.02 3.37s0 0 0 .02c.02.05.06.09.08.14.02.05.04.12.06.17.27.67.51 1.43.7 2.24.16.67.29 1.37.36 2.11v.08c.07.69.08 1.41.06 2.15 0 .18-.02.36-.03.54-.03.58-.1 1.17-.2 1.77-.03.19-.06.37-.1.56-.14.7-.33 1.39-.57 2.09l-.06.21c-.59 1.63-1.49 3.24-2.74 4.77-.06.07-.12.14-.18.2-.6.71-1.29 1.4-2.06 2.07-.06.05-.11.09-.16.14-1.71 1.44-3.85 2.74-6.5 3.82-.18.07-.39.14-.58.21h-.02c-1.14.44-2.38.83-3.71 1.19-.4.11-.79.21-1.2.31-1.64.38-3.36.73-5.28.97-2.13.27-4.25.29-6.35.2-.21-.01-.4-.04-.61-.05-2.03-.13-3.98-.43-5.86-.9h-.01c-.21-.05-.43-.1-.64-.16-1.27-.35-2.47-.79-3.63-1.29-.16-.07-.31-.13-.46-.2a22.76 22.76 0 0 1-2.99-1.67c-.2-.13-.38-.28-.57-.41-.88-.64-1.7-1.33-2.43-2.1-.14-.15-.26-.32-.4-.48-.73-.83-1.4-1.69-1.93-2.66-.16-.29-.27-.62-.4-.93-.49-1.07-.89-2.18-1.13-3.4-.26-1.14-.44-2.33-.4-3.64-3.4-.53-6.8-1.21-10.17-2.01-2.93-.68-5.84-1.48-8.74-2.41s0 0 0-.01c.8-1.94 1.34-3.78 1.67-5.55v-.03c.32-1.77.42-3.46.34-5.07-.05-.96-.15-1.89-.32-2.79-.02-.13-.06-.25-.09-.38-.2-.92-.46-1.79-.77-2.64-.02-.04-.03-.09-.05-.13-.06-.17-.13-.33-.19-.5-.3-.73-.63-1.44-1-2.12-.06-.12-.12-.25-.19-.37l-.03-.06c-.45-.79-.95-1.54-1.48-2.25-.11-.14-.22-.28-.33-.41-.03-.04-.06-.07-.09-.11-.41-.51-.83-1.01-1.27-1.48-.02-.03-.05-.05-.08-.08-.18-.19-.36-.39-.55-.57-.43-.43-.87-.83-1.31-1.22-.08-.07-.17-.15-.25-.23l-.3-.27c-.58-.48-1.16-.91-1.75-1.33-.12-.09-.24-.16-.37-.24l-.54-.36c-.32-.21-.64-.41-.96-.59-.03-.01-.05-.03-.08-.04-.24-.14-.47-.27-.71-.4l-.21-.12c-.29-.16-.58-.29-.87-.43-.28-.13-.56-.28-.83-.4-.3-.13-.59-.12-.85-.05-.05.01-.09.04-.13.06-.11.05-.19.14-.28.22-.07.06-.16.09-.21.17-.03.04-.07.08-.09.12-.13.22-.21.47-.19.72.02.14.14.27.21.4.07.13.08.28.2.39.3.27.61.59.92.89.01.01.03.03.05.04.46.45.91.92 1.37 1.42l.02.02c.04.05.09.1.13.15 1.07 1.18 2.09 2.51 2.98 3.96.06.1.13.19.19.3.4.67.75 1.36 1.08 2.08.06.12.14.24.19.37.02.04.02.09.04.13.41.96.72 1.99.97 3.04.03.12.05.24.08.37.28 1.3.46 2.65.42 4.07v.02c-.01.13-.06.23-.08.36-.16 1.66-.47 3.2-.97 4.59-.39 1.12-.98 2.06-1.56 3.01 0 0 0 .02-.01.03-.18.28-.29.62-.48.89-.45.63-.99 1.15-1.52 1.69-.4.41-.8.83-1.24 1.19-.57.47-1.17.88-1.8 1.26-.54.33-1.11.6-1.69.87-.63.28-1.23.58-1.9.8-.53.17-1.11.23-1.66.36-1.15.25-2.31.45-3.53.5h-.02c-1.05.05-2.11.05-3.21-.05-.56-.05-1.11-.14-1.67-.23-.37-.06-.74-.17-1.11-.25-2.33-.47-4.68-1.25-7.02-2.38-.49-.23-.99-.37-1.47-.64-1.3-.71-2.54-1.52-3.74-2.37-.35-.25-.68-.51-1.01-.77-.86-.66-1.68-1.36-2.46-2.08-2.71-2.53-4.86-5.44-6.18-8.58v-.02c-.41-.99-.88-2.67-1.14-3.71l-.04-.16c-.23-1.28-.36-2.58-.28-3.91s0-.02 0-.03c0-.02.01-.04.01-.07 0-.03.02-.07.02-.1.11-1.41.38-2.84.89-4.27.52-1.48 1.26-2.97 2.25-4.46-3.83-3.77-7.44-8.11-10.82-12.78-.67-.91-1.35-1.83-1.99-2.76-.32-.48-.63-.97-.95-1.45-.92-1.4-1.82-2.8-2.67-4.23-1.98-3.27-3.81-6.67-5.53-10.15-.16-.32-.31-.63-.47-.95-1.7-3.51-3.27-7.07-4.67-10.7-.1-.25-.21-.47-.31-.73-1.03-2.52-2.32-6.21-3.47-10.73-.2-.75-.38-1.5-.56-2.26v-.02c-.12-.54-.24-1.1-.35-1.66-2.87-13.2-2.63-26.27.28-38.46 0-.04.02-.08.03-.12a89.26 89.26 0 0 1 1.63-5.87c.05-.16.1-.31.16-.47.73-2.25 1.56-4.46 2.47-6.64s.03-.08.05-.12c1.5-3.55 3.22-6.99 5.18-10.29.02-.04.05-.07.07-.11 1.94-3.25 4.07-6.38 6.43-9.35.1-.13.18-.26.28-.39.54-.68 1.25-1.43 1.85-2.14.58-.67 1.13-1.35 1.73-1.99.92-1.01 1.95-2.02 2.99-3.05.63-.62 1.27-1.24 1.92-1.85 1.04-.96 2.12-1.91 3.27-2.86.24-.2.47-.42.71-.62.45-.37.9-.66 1.35-1.01 1.38-1.08 2.76-2.15 4.26-3.19 2.27-1.58 4.54-3.03 6.78-4.31 1.65-.92 3.34-1.8 5.1-2.62.84-.4 1.67-.76 2.5-1.12h.02s.02-.02.03-.02c.5-.21 1.01-.41 1.51-.62 1.88-.77 3.74-1.44 5.59-2.03s0 0 .01 0c.31-.1.61-.2.92-.29h.01a71.54 71.54 0 0 1 5.39-1.41h.03c1.75-.38 3.47-.7 5.17-.94.07 0 .13-.02.2-.03 1.66-.23 3.3-.41 4.91-.53.1 0 .19-.01.28-.02 1.62-.11 3.21-.17 4.77-.18h.22c2.12 0 4.18.08 6.18.25.25.02.49.03.74.05 2.71.25 5.28.63 7.73 1.1.15.03.3.06.46.09 2.42.48 4.71 1.02 6.84 1.62l.21.06c1.73.49 3.36 1 4.87 1.52.08.02.15.05.23.07 1.34.46 2.62.92 3.77 1.37l.11.04c-27.53-17.76-77.17-11.4-104.28 19.49Z",
                            className: "icon_svg__cls-10",
                            style: {
                                fill: '#141526',
                                strokeWidth: 0
                            }
                        })
                    ]
                })
            })
        ]
    }));
var $0e54c6b17377038f$export$2e2bcd8739ae039 = $0e54c6b17377038f$var$SvgIcon;





const $af532f2d7e07bf07$var$SvgFullLogo = (props)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 1000 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient",
                        x1: 215.09,
                        x2: 374.06,
                        y1: 61.06,
                        y2: -0.41,
                        gradientTransform: "rotate(-8.86 992.89 1045.428)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient-2",
                        x1: -236.73,
                        x2: -283.6,
                        y1: 787.35,
                        y2: 666.15,
                        gradientTransform: "rotate(81.14 295.919 673.252)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "full_logo_svg__luminosity-invert",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.full_logo_svg__cls-7,.full_logo_svg__cls-8{stroke-width:0}.full_logo_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.full_logo_svg__cls-7{fill:#062844}.full_logo_svg__cls-8{fill:#ee486f}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "full_logo_svg__mask",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 174,
                            height: 176,
                            style: {
                                filter: 'url(#full_logo_svg__luminosity-invert)'
                            },
                            transform: "translate(59 62)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "full_logo_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'url(#full_logo_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#full_logo_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                                className: "full_logo_svg__cls-10",
                                style: {
                                    fill: '#141728',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M160.51 192.18c.59 1.15 2 1.56 2.79 1.71 1.86.34 4.09-.06 6.1-1.09 3.48-1.78 5.25-4.87 4.94-6.83-.04-.27-.12-.51-.24-.75-.59-1.15-2-1.56-2.79-1.71-1.86-.34-4.09.06-6.1 1.09-3.48 1.78-5.24 4.87-4.94 6.84.04.27.12.51.24.74ZM126.19 198.8v.04c.24 1.5 2.97 3.37 6.72 2.88 1.9-.25 3.63-1.07 4.74-2.25.34-.37 1.12-1.32.98-2.33-.23-1.5-2.96-3.37-6.72-2.88-1.9.25-3.63 1.07-4.74 2.25-.34.36-1.12 1.32-.99 2.29ZM95.17 186.12c-.06.09-.22.35-.19.93.07 1.36 1.18 3.38 3.48 4.84 1.54.98 3.28 1.47 4.76 1.33.43-.04 1.46-.19 1.86-.82.05-.09.22-.35.19-.92-.07-1.36-1.18-3.38-3.48-4.84-1.54-.98-3.28-1.47-4.76-1.33-.43.04-1.46.19-1.86.81ZM192.78 171.53c.08.49.23.96.46 1.38 1.76 3.27 7.71 3.76 12.74 1.06 4.93-2.65 7.05-6.95 6.6-9.82-.08-.49-.23-.96-.46-1.39-1.76-3.27-7.71-3.76-12.74-1.06-4.93 2.65-7.05 6.95-6.6 9.82Z",
                            className: "full_logo_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M183.06 124.84c-12.84 8.33-22.47 17.46-31.67 24.54-10.3 7.72-21.36 16.38-34.33 11.6-9.66-3.41-14.51-14.82-14.64-24.62.43-10.71 5.48-19 22.96-20.73-7.48-1.49-15.3-.32-20.79 3.35-17.41 11.65-14.56 28.85-9.41 39.08 4.93 9.78 17.15 19.03 32 18.99 10.15-.03 22.55-4.05 41.55-18.47 23.26-17.66 42.16-24.24 59.52-24.57.26 0 .52-.05.78-.03.69.04 1.2-.24.92-1.33-.04-.15-.07-.31-.1-.47a84.457 84.457 0 0 0-9-23.91c-1 .22-19.03 4.39-37.81 16.57Z",
                            style: {
                                fill: 'url(#full_logo_svg__linear-gradient-2)',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M150.02 140.58c-10.3 7.72-20.51 17.91-33.47 13.12-6.84-2.41-12.07-10.37-14.12-17.39v.05c0 .61.03 1.23.08 1.85.04.62.11 1.25.19 1.88 1.15 8.79 5.92 17.9 14.37 20.89 2.43.9 4.79 1.32 7.1 1.37 9.99.2 18.86-6.69 27.23-12.97 2.71-2.09 5.48-4.37 8.34-6.74 6.84-5.67 14.28-11.93 23.33-17.8 18.41-11.94 36.16-16.19 37.79-16.56v-.05a83.974 83.974 0 0 0-5.02-7.83c-7.2 2.36-22.48 8.08-34.14 15.64-12.84 8.33-22.47 17.46-31.67 24.54Z",
                            style: {
                                fill: '#141526',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M79.41 122.96c-5.87 6.69-13.97 26.77-5.83 46.45 2.09 5.05 4.94 10.71 9.44 15.27-.28 1.66-.3 3.31-.05 4.91 1.35 8.69 9.98 13.22 10.42 13.44 8.51 4.06 14.7 1.5 17.27-.03l4.8 1.45c3.5 10.19 17.66 9.19 18.28 9.14 10.41-.78 14.66-6.24 16.1-8.79l3.36-1.11c9.22 8.53 23.01.51 23.61.15 9.57-5.65 10.88-13.82 10.94-17.47l.81-.47c11.76 7.29 25.28-1.23 25.72-1.52 7.94-4.38 10.73-11.17 11.62-14.29 1.09-.27 2.41-.26 3.52-.17.55-2.28 1.02-4.58 1.38-6.91.09-.55-.33-1.06-.88-1.11-.6-.05-1.18-.06-1.73-.06h-.24c-.22 0-.41.02-.61.03l-.7.03c-.08 0-.15.02-.23.03a21.176 21.176 0 0 0-2.23.32c-.12.03-.26.05-.36.07-.36.08-.57.15-.58.15-.31-1.04-.71-1.96-1.13-2.83-.13-.26-.27-.49-.4-.74-.34-.6-.7-1.16-1.08-1.67-.15-.2-.3-.41-.46-.6-1.14-1.35-2.44-2.39-3.8-3.12a13.41 13.41 0 0 0-6.52-1.56c-.68.01-1.34.08-1.95.19-.68.12-1.3.34-1.91.56-.36.14-.73.28-1.07.44-.45.21-.91.41-1.29.63l-.01.01a.49.49 0 0 0-.23.41v.11c.02.16.09.31.22.4.06.04.15.04.23.05.05 0 .09.04.15.03.43-.06.91-.1 1.4-.13s.05 0 .07 0h.01c.27-.02.56-.01.84-.01h.04c.25 0 .49-.02.76 0h.07c.45.02.91.06 1.38.12.23.03.47.08.7.12.28.05.57.11.85.18.33.08.65.18.97.29.24.08.47.18.7.28s.46.18.69.3c.53.27 1.05.57 1.54.94 1.07.82 2.04 1.92 2.81 3.38.02.03.04.09.06.13.23.44.56 1.14.85 2.03.05.14.09.28.14.43.09.31.17.64.23.98 0 .04.02.07.03.11.06.35.11.71.15 1.09.02.23.02.47.02.71v.02c.01.75-.06 1.54-.24 2.37-.02.11-.04.21-.07.32-.04.18-.09.36-.15.55-.18.6-.45 1.22-.77 1.85 0 0 0 .02-.01.03-.22.42-.47.84-.75 1.26-.08.11-.15.23-.23.34-.28.4-.61.79-.96 1.19-.03.03-.05.06-.08.09-.55.61-1.17 1.23-1.9 1.84l-.06.06c-.73.61-1.56 1.22-2.49 1.82-.5.32-1.05.65-1.61.97 0 0-.01 0-.02.01-.15.08-.27.17-.42.25-.04.02-.07.03-.11.05-.31.17-.64.28-.96.43-.47.22-.93.45-1.4.63-.53.21-1.07.35-1.6.51h-.01c-.29.08-.58.18-.87.25-.41.1-.81.18-1.22.25-.38.06-.75.1-1.12.14-.48.05-.95.1-1.42.11s-.09 0-.13 0c-1.02.01-2.01-.08-2.96-.26s-.07-.02-.11-.02c-.8-.15-1.57-.37-2.3-.65-.73-.28-1.42-.62-2.06-1.02-.06-.04-.12-.08-.17-.12-.5-.32-.98-.66-1.4-1.06-.11-.1-.2-.21-.3-.32-.25-.25-.5-.51-.73-.79-.11-.11-.22-.21-.31-.34-2.12 1.28-4.26 2.58-6.49 3.91s-.06-.08-.09-.12c-.03-.04-.06-.07-.09-.11-.35-.47-.7-.91-1.06-1.3-.17-.19-.34-.35-.51-.52-.27-.26-.53-.51-.8-.74a9.335 9.335 0 0 0-1.38-.98c-.09-.05-.18-.11-.27-.16 0 0-.01 0-.02-.01-.09-.05-.18-.11-.27-.16-.34-.18-.68-.32-1.02-.46-.95-.37-1.91-.58-2.85-.66h-.02c-.72-.05-1.42-.03-2.11.04-.27.03-.54.08-.81.13-.03 0-.06 0-.08.01-.13.02-.27.04-.4.07-.03 0-.07.02-.1.03-.06.01-.11.03-.17.04-.45.11-.9.24-1.32.39-.01 0-.02 0-.03.01a14.268 14.268 0 0 0-1.8.76c-.03.02-.06.03-.1.05l-.06.03c-.7.35-1.33.73-1.88 1.1-.01 0-.02.02-.04.02-.02.01-.04.02-.05.04-.12.08-.19.2-.22.31-.02.07 0 .13.01.19v.1c.03.09.09.17.16.23.06.05.12.09.19.12h.04c.06.01.11.02.17.02.03 0 .06.01.09 0 .39-.1.81-.2 1.25-.29.08-.02.15-.04.23-.05.48-.09.98-.16 1.5-.21.09 0 .17-.02.26-.03h.21c.57-.04 1.15-.06 1.74-.03h.02c.58.03 1.17.09 1.75.21.13.03.25.06.37.1.45.11.9.23 1.34.41.13.05.26.13.39.2.41.19.81.39 1.2.65.19.13.35.3.53.45.33.27.66.53.95.86.43.48.84 1.01 1.19 1.65.28.49.45 1.02.6 1.55.08.27.13.55.18.83.07.42.13.85.13 1.28a7 7 0 0 1-.06.79c-.02.22-.07.58-.11.8-.07.38-.15.76-.27 1.14-.12.37-.25.74-.41 1.11-.17.39-.36.76-.58 1.14-.07.13-.15.25-.22.37-.72 1.19-1.65 2.31-2.79 3.32-.28.24-.55.49-.85.72-.81.63-1.68 1.22-2.64 1.71-.56.29-1.14.54-1.71.78-.02 0-.05.02-.07.03-1.2.49-2.41.87-3.61 1.12-.04 0-.08.02-.13.02-2.33.46-4.57.39-6.45-.42-.06-.03-.13-.06-.19-.09a6.79 6.79 0 0 1-1.05-.6c-.07-.05-.15-.1-.22-.15-.38-.28-.73-.6-1.05-.96-.04-.05-.08-.11-.13-.16a8.602 8.602 0 0 1-.93-1.4c-.24-.47-.47-.96-.65-1.52-2.6.95-5.23 1.81-7.89 2.5s0-.01 0-.02v-.03c-.48-1.82-1.21-3.23-2.06-4.38-.09-.12-.16-.27-.25-.39-.08-.1-.16-.19-.25-.28l-.03-.03c-.2-.23-.4-.44-.61-.64-.14-.13-.28-.24-.42-.36-.17-.14-.34-.28-.52-.41-.15-.11-.3-.21-.45-.3-.18-.11-.37-.22-.55-.32-.07-.04-.14-.07-.21-.11-.08-.04-.16-.08-.23-.12-.22-.1-.45-.19-.68-.28 0 0-.02 0-.03-.01h-.01c-.1-.04-.19-.08-.29-.11-.35-.12-.7-.21-1.05-.29-.03 0-.05 0-.08-.01h-.03c-.34-.07-.67-.12-1-.16H138.91c-.32-.03-.65-.05-.96-.05h-.08c-.35 0-.69.01-1.03.04h-.06c-.11.01-.22.02-.33.04-.43.05-.85.13-1.23.23-.05.01-.11.02-.16.04-.14.04-.24.12-.31.22-.06.09-.09.21-.09.32a.722.722 0 0 0 .11.3c.02.03.04.07.07.1.01.01.03.02.05.02.03.02.07.04.11.05.03.02.06.04.09.04.02 0 .04.02.06.02.03 0 .08.02.11.02.77.07 1.61.22 2.47.45s.03 0 .05 0c.03 0 .06.03.1.04.39.11.77.24 1.15.4.02 0 .03.01.05.02.38.15.75.33 1.11.54.74.42 1.43.96 2.02 1.64.11.13.22.25.33.39.34.45.65.93.9 1.5.01.02.03.04.04.06 0 .02.02.05.03.08.12.3.23.63.31 1 .07.3.13.61.16.94v.03c.03.31.04.63.03.96 0 .08-.01.16-.02.24-.01.26-.04.52-.09.79-.01.08-.03.17-.05.25-.06.31-.15.62-.25.93l-.03.09c-.26.72-.66 1.44-1.22 2.12-.03.03-.05.06-.08.09-.27.32-.57.62-.92.92-.02.02-.05.04-.07.06-.76.64-1.71 1.22-2.89 1.7-.08.03-.17.06-.26.09-.51.2-1.06.37-1.65.53-.18.05-.35.09-.53.14-.73.17-1.49.32-2.35.43-.95.12-1.89.13-2.82.09-.09 0-.18-.02-.27-.02-.9-.06-1.77-.19-2.6-.4-.09-.02-.19-.04-.29-.07-.57-.15-1.1-.35-1.62-.58l-.21-.09c-.47-.22-.91-.47-1.33-.74-.09-.06-.17-.12-.25-.18-.39-.28-.76-.59-1.08-.93l-.18-.21c-.32-.37-.62-.75-.86-1.18-.07-.13-.12-.27-.18-.41-.22-.47-.4-.97-.5-1.51-.12-.51-.19-1.04-.18-1.62-1.51-.23-3.02-.54-4.52-.89-1.3-.3-2.6-.66-3.88-1.07.36-.86.6-1.68.74-2.47v-.02a9.75 9.75 0 0 0 .01-3.49c-.01-.06-.03-.11-.04-.17-.09-.41-.21-.8-.34-1.17 0-.02-.02-.04-.02-.06-.03-.07-.06-.15-.09-.22-.13-.33-.28-.64-.44-.94-.03-.05-.05-.11-.08-.16 0 0 0-.02-.01-.03-.2-.35-.42-.68-.66-1l-.15-.18c-.01-.02-.03-.03-.04-.05-.18-.23-.37-.45-.56-.66a.138.138 0 0 1-.03-.04c-.08-.09-.16-.17-.24-.25-.19-.19-.39-.37-.58-.54-.04-.03-.07-.07-.11-.1-.04-.04-.09-.08-.13-.12-.26-.21-.52-.41-.78-.59-.05-.04-.11-.07-.16-.11-.08-.05-.16-.11-.24-.16-.14-.09-.29-.18-.43-.26-.01 0-.02-.01-.03-.02-.11-.06-.21-.12-.31-.18a.405.405 0 0 0-.09-.05c-.13-.07-.26-.13-.39-.19-.12-.06-.25-.12-.37-.18a.559.559 0 0 0-.38-.02c-.02 0-.04.02-.06.03-.05.02-.08.06-.12.1-.03.03-.07.04-.09.07-.01.02-.03.03-.04.05-.06.1-.09.21-.08.32 0 .06.06.12.09.18s.03.12.09.17c.13.12.27.26.41.4l.02.02c.2.2.41.41.61.63.02.02.04.04.06.07.47.53.93 1.11 1.33 1.76.03.04.06.09.09.13.18.3.34.6.48.92.03.06.06.11.09.16 0 .02.01.04.02.06.18.43.32.88.43 1.35l.03.16c.12.58.2 1.18.19 1.81v.01c0 .06-.03.1-.03.16a8.47 8.47 0 0 1-.43 2.04c-.17.5-.43.92-.69 1.34v.01c-.08.12-.13.28-.22.39-.2.28-.44.51-.68.75-.18.18-.35.37-.55.53-.25.21-.52.39-.8.56-.24.15-.49.27-.75.39-.28.13-.55.26-.84.35-.23.08-.49.1-.74.16-.51.11-1.03.2-1.57.22-.47.02-.94.02-1.43-.02-.25-.02-.49-.06-.74-.1-.16-.03-.33-.08-.49-.11-1.04-.21-2.08-.56-3.12-1.06-.22-.1-.44-.17-.65-.28-.58-.32-1.13-.67-1.66-1.05-.15-.11-.3-.23-.45-.34-.38-.29-.75-.6-1.09-.93-1.2-1.13-2.16-2.42-2.75-3.81-.18-.44-.39-1.19-.5-1.65l-.02-.07c-.1-.57-.16-1.15-.12-1.74s0 0 0-.01v-.08c.05-.63.17-1.26.39-1.9.23-.66.56-1.32 1-1.98-1.7-1.68-3.31-3.6-4.81-5.68-.3-.41-.6-.82-.88-1.23-.14-.21-.28-.43-.42-.65-.41-.62-.81-1.24-1.19-1.88-.88-1.45-1.69-2.97-2.46-4.51l-.21-.42c-.76-1.56-1.45-3.14-2.08-4.76-.05-.11-.09-.21-.14-.32-.46-1.12-1.03-2.76-1.54-4.77-.09-.34-.17-.67-.25-1-.05-.24-.1-.49-.16-.74-1.28-5.87-1.17-11.68.13-17.09 0-.02 0-.04.01-.05.21-.88.45-1.75.72-2.61.02-.07.05-.14.07-.21.33-1 .69-1.98 1.1-2.95s.01-.03.02-.05c.67-1.58 1.43-3.11 2.3-4.57.01-.02.02-.03.03-.05a35.94 35.94 0 0 1 2.86-4.15c.04-.06.08-.11.12-.17.24-.3.55-.63.82-.95.26-.3.5-.6.77-.89.41-.45.87-.9 1.33-1.36a32.886 32.886 0 0 1 2.3-2.09c.11-.09.21-.19.32-.28.2-.16.4-.29.6-.45.61-.48 1.23-.95 1.9-1.42 1.01-.7 2.02-1.35 3.02-1.92.73-.41 1.49-.8 2.27-1.17.37-.18.74-.34 1.11-.5s0 0 .01-.01c.22-.09.45-.18.67-.28.84-.34 1.66-.64 2.49-.9.14-.04.27-.09.41-.13.81-.24 1.61-.45 2.4-.63h.02c.78-.17 1.54-.31 2.3-.42.03 0 .06 0 .09-.01.74-.1 1.46-.18 2.18-.23h.13c.72-.05 1.42-.08 2.12-.08h.09c.94 0 1.86.04 2.75.11.11 0 .22.01.33.02 1.2.11 2.35.28 3.44.49.07.01.14.03.2.04 1.08.21 2.09.45 3.04.72s.06.02.09.03c.77.22 1.49.44 2.16.68l.1.03c.6.21 1.16.41 1.67.61.02 0 .03.01.05.02-12.23-7.89-34.3-5.07-46.34 8.66Z",
                            className: "full_logo_svg__cls-10",
                            style: {
                                fill: '#141526',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M265.72 141.77v-3.21c0-30.43 19.95-51.98 50.08-51.98 26.06 0 43.39 16.45 45.13 40.91h-21.84c-1.6-14.27-10.19-22.86-23.59-22.86-17.47 0-27.37 13.68-27.37 33.92v3.21c0 20.24 10.04 33.77 27.37 33.77 13.98 0 22.71-9.46 23.44-23.88h21.84c-1.6 24.61-18.34 42.08-45.13 42.08-30.58 0-49.94-21.4-49.94-51.98ZM372.73 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.17 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.54 25.77-24.17 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.87-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.47 15.29h33.78ZM630.34 170.89c0-12.81 8.15-20.38 21.83-22.28l27.66-3.93v-4.37c0-6.25-4.07-10.04-12.96-10.04-8.3 0-13.53 3.21-14.27 9.61h-19.21c1.16-16.01 14.41-25.04 33.92-25.04s32.17 10.04 32.17 25.77v51.25H680.7l-.73-11.5c-4.52 8.15-13.25 13.39-24.31 13.39-15.15 0-25.33-9.61-25.33-22.86Zm49.5-6.55v-5.97l-20.38 2.76c-6.26.88-9.46 3.49-9.46 8.73s4.37 8.59 11.79 8.59c9.9 0 18.05-5.83 18.05-14.12ZM833.5 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.18 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.55 25.77-24.16 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.88-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.48 15.29h33.78ZM504.98 114.83c-12.23 0-20.67 6.7-24.17 13.39l-.58-11.51h-19.07v99.34s20.49-.84 20.53-20.48v-14.35c4.08 6.99 12.23 12.52 22.86 12.52 20.24 0 32.61-16.31 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.18-38.43Zm11.5 40.33c0 14.7-6.12 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.26-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM593.2 114.83c-11.94 0-19.56 6.11-23.5 12.81v-24.08c0-18.74-20.46-19.62-20.46-19.62v107.91h20.37v-41.64c0-11.94 6.41-18.93 15.87-18.93s13.54 6.4 13.54 17.33v43.24h20.24v-48.34c0-16.89-7.43-28.68-26.06-28.68ZM757.42 114.83c-11.06 0-18.93 5.24-23.44 11.94v-22.3h.01c0-19.69-20.53-20.53-20.53-20.53v107.91h19.06l.58-11.79c3.35 6.7 11.36 13.68 23.74 13.68 20.09 0 32.61-16.16 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.04-38.43Zm11.36 40.33c0 14.7-6.11 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.25-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM821.91 103.89c0-18.95-20.38-19.95-20.38-19.95v107.91h20.38v-87.96ZM915.9 193.68v-10.36h-3.55v-2.48h10.13v2.48h-3.53v10.36h-3.05ZM924.26 193.68v-12.84h4.34l2.82 8.97 2.84-8.97h4.11v12.84h-2.88v-9.3l-2.95 9.3h-2.37l-2.98-9.33v9.33h-2.93Z",
                            className: "full_logo_svg__cls-7"
                        })
                    ]
                })
            })
        ]
    }));
};
var $af532f2d7e07bf07$export$2e2bcd8739ae039 = $af532f2d7e07bf07$var$SvgFullLogo;





const $5e08dea7b0296858$var$SvgProductEduLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "eduLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "eduLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "eduLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#eduLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#eduLogoTransparent_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -48.056 88.733)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#eduLogoTransparent_svg__c)",
                mask: "url(#eduLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -48.056 88.733)"
                })
            })
        ]
    }));
var $5e08dea7b0296858$export$2e2bcd8739ae039 = $5e08dea7b0296858$var$SvgProductEduLogo;





const $89f8912dfe9250e1$var$SvgProductPersonalLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "personalLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "personalLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 88.734H899.28V380.77H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "personalLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#personalLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#personalLogoTransparent_svg__b)",
                                transform: "matrix(.97644 0 0 .97594 -38.322 87.774)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#personalLogoTransparent_svg__c)",
                mask: "url(#personalLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAEsCAIAAADfJw44AAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nOy9fZBk13ne97zvud3TCxCkaBImRTHmhxh7dsVybckUv0BBK+6uuK6KKyknccV/xLEpfjiCZCmqqCpWbJfiKrsS5UOJI6UsihJp2VKU2FHkoj8gAiAhCJRERhJBmQJWX6QoUZQgAMICuzvT3fee98kf55zbt3t6dmeme7p7Zt8fl4Oe7ju3b997+97nPOc57wEcx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3FOFbLuDXBuwy/d/0EiAoRw/6UIAQTv+ORHVrdljuM4juM4zgpx4b4p/Py7/gZFQEAAEiBJACra0z6lvs3fK60xkIAIABGBQAAIBO/4uR87/k/gOI7jOI7jHCMu3NfGz7/rAxQDSBhJEEHEVNUIYZbtpAgUolmFQ2TqmJGQJPOR/0RFAJH8SCigRRAQUYgIVOQbXMc7juM4juOcNFy4r5RPvOsDEBOSMCEq6ZlGoRlJUou2BqD5L0SzWJfingOdw5YN+qTbAU6eBolW0ENEKFCpRKLFJOMFLuIdx3Ecx3FODC7cV8HD9783iWuhKCrRKBYjoZJ1uQKS7PAk0JNwF0kPkmrX9lhlbZ+0eksS6khGffp/+t2ysgcBA0FCFCKVSGRksuIBBHvbIz++mh3iOI7jOI7jHBYX7sfIz97/XhAgFRRVEKQpRAEVEUAhmt10apbj0xY70qBTiEh6gEl0PUnxlhyVYftb+i9SDKf8mpehEQQNUIWwQq9mI6AK9G2P/eiq9pDjOI7jOI5zUFy4L5+P3/9BMpIETFTEAEYVEUiy2INIMdGleO2ceO1Zo3eV+kSs5/9Mp2XKf7NaJyCt6V7UfM7MFx1v5SVLP0FRCCtjqmAjArz9sY+ubq85juM4juM4t8SF+zL5t/e/D0YAQSuzmmQABaKSNHoW7iUhI5r99azRta0IUzS6SkevA2gfzNPuWay3WZliyecMTQ7RTCR7EvEGGgkgkgZa2R4QaRvdgHccx3Ecx9kEXLgvh39z37eSBhENimggNQXWRQIoIkHSYyTfPRR9rCXaDkDB8mQi1XSctts7pjtyYKala7qTZamJ6T7R8Vni29RPJvedZC5DI4GMUEJEPAHvOI7jOI6zVly4L8rH7vtW0gQIosaYYuvFXBcVBKRSjAgqKQ8TcmwG0nHck1jXEmFPv8pkJGqr5ueY7hPt3k25lxz8RKmXZdJCNvHdp7R7fjwx4IP0GkYBIIEu3x3HcRzHcdaCC/ej87H7vjX52yJCxpSBCUWyiyA9FiAIBBK0HZDaRmVyHqZNtCfTPa2/VerJj+9WcJ813TvKvftbW2UGnfAMy7OdBHweq5oUfKpNWUQ8I5N8V+lFNgKGtz/mFSQdx3Ecx3FWjQv3o/Av73t/MqaDiGW7HQIJkwj7VJy9lJERVQRIsthDmd1Up7Ls7Mp0mZLot0m6F7hXsbN9YUrjl2xMZ6CqgUgPyLRAzr4TBkJCicF79t1xHMdxHGeluHA/HP/Pfe8DWYIxTVvSUSFBMJOTaU13LRmYMkp1MjJVO8XatQjxqTh754G0bnxHu5Ocp91nf+1m3/OzZRjrjIJPMh3JcS/We+y47yoVEEWgKm/55EeWsV8dx3Ecx3Gc2+DC/aD89MUH2DSIEYTQQAYpJR0nYp2tag9ZqXc9eOSAe5loKbSVH8szAgCcK9NnpDymAzOYeT576HNIaRkpIr5TKRLZZW8jNG1gZo98J6SqJJpRPPjuOI7jOI6zCly4H4ifvu/9VJF+j8MRrekmYaSo9lDmUWrdd5lNzlAhql3Jnl9tdbmWSVFnh6IeMjAjmJLtMl0msjApMrMn8s6Z/Ewr32OS72QEKaI9QyOK8A0/58F3x3Ecx3GcY8SF+21IRjujKREZwRRnh3Y0d3fUaQBkYsBj7ijVFJhpVXsuIFOkfHHWs8aetdj3PpDZJ8vj+Y47OiK+FKXJufauAd/Wd08jVmM38k7G8jiClQZDdOvdcRzHcRznWHHhfit+6r73iUqv37fhKFqUNgADiKCCoBN9yYEZICn1Gbs9jUZNaZk2XdMmZNqke6IbmMHRTXd0tXv31enykZNf29qRyWgHYGAbm4ml+Ewx3W0SfE/We5Qg6ql3x3Ecx3Gc48CF+7783/d9wBghQjMBW9VenPI2zp5N9I5S537CXaRY9aUKjZRi7W3hdkyOyoG1+8FM970HuztJU7v0jHyX4r63td4jyU7ePXnwDdir1IwQeeujrt0dx3Ecx3GWjAv3+fzkO98vZFBtYi1tvgV5pqQ0BypKVD1753kBCcIyZ2pR8535mEppyInvjlI1ErO6/BhN95knu6Vm9sr3bvbdSrFI6yRnGpqBDalBSSMglcdmHMdxHMdxlokL9zn8xDvfT1JFaBE5zg6ZFu46GYqaC64HBSDFVu/48ZNZmRBEAIR2VGtJyXejMkc03bGfdr+N6d59cj/5jk6pmSTZ2+RMG5hpioInRbY8NuM4zhSD7UvpwfDqw+vdEue46Z27HEMEYMHwxKPr3py1Mdi+0lQNgKZq7uT94CyXat0bsIkYTUWjxZRjmcxeVH5N6ZGQguDZLGc0CUoDhIAIQCFMJBCU5EJLKiJpEEEeE0qhQIws9WSm3uXWdEaX3mJhmQnM3ILJSkRKIRoRAYFAmOQ3EsDSQqBARRhJgAYDNIJxLL1KY8Sn7/9Wn6fJcRxMrpzob19KF6UYCGGs6JrmlCFkiKHu19U46PZFQiwYBVbdWTqesKqphoNh2g/wc95ZBnr7Re48SDQWOTVqc/KgHbgZsyFd8t/IuZH0JImYXkU7+ehUeZYSPoFhUrxlajOA1ArYuw37bPecV2/9635PTpL3k0rzU/PCBtEACTL5V4kE0UqkEqkgTWOAkvZL9793v+11HOfOgbnBDwACoSCYxIrVOPS2L/W2L69z45zlQqixP6zUUtSUGoNVdqcda4KGpt0Pfs47S8Ed9znMSGQCRihgYArMTGYiBShUQAkD0hWKBAETBOaC6ioipGUjXYRM7jsgKjQKhJonQe3GXtqHs9J6r9feNd33GPBTa5hrz899st3e7L1DNG/1xHoXQAgRiaDABCqgCIXWsIEE0n7xG/+Ld/z8P7nNTnemGWxfASzX2d+3tUaUpBY8geCcHAgIBUB/WEGQZoSrzr2biniHmbKnkpkiZkIBeEce6+k7r5/zzjLwjPscfvwd3yqiZo2UqZEESIl2IBdxB6AClMcBQCo70xmuGjpzpoap8altxXdRIKi05d6x8tKQt34ykRswbVul9Bikn5GWRqx2a0Q2ZKQ1nelbXbvfivMXqkZhUNOyv0VRAQ0Azsyn1UWoFEy8zNQoFEAUOrz64Aq23XEOQr9k3G/BeNBUtarJ+KlHVrBJzjGxtX0Jt8to3gnH+oDnfBgHNa2vPrSCTXJOAS7c5/BP3/l+gKqBsQGgogqmB0SqJ0PSiramgCRDqQzTnVwpVZhpp1OVJNnTNKsiAVRRzaNUbzVWdQWlIfd7siUHevJjkrlMZHd21azazVy7H4Teucu5bI+w6dtgWBlST8dBxjjMQQATghoQDBGgBaNHKp0N4CAiBgCEJnQb8kRzEOEOnP5jfcBznhCqUXla94OzXFy4z+cn3vVBWgqup9qOaKPeAoCUnFJIuXKqSFVVMJo1AjAXnJEg6FZzT3MwBdFUYSaZ7kGymm/lfjuXake7r9l0T+SBs0WLp0B/KjgTb6vdhRBoBS8T2Tt3OU1RCwAqoEnOvCwdgdh4K1bjoCYQnmJzy9lwDircAQjGW41GseANzhPJQYU78rGuxqGy3unrITzsOR9qVYb6SbfenVvhwn05fOz+D+Y5Rs0IExEJKgbSQp68KWv3SkQglbTWO7JqL4/bOpIo5v1aSkPuRwq+d+tFzszNZFNzM1mr3Y0IW7SIdzx6pwr38xe0UTFRE6iI4eAFfxZGIAbC9DT7W84mcwgRAwAcD6Jr9xPKIYQ7AFDRI0xOXbrvsOc8VVPa0bW7cwtcuB8LH7v/fcgJCIgEwIQxyfeqo+C1FGZRkVCc+GLV52GqXe3eKu+9en32yaMGZg5yQrRjXS3Pt7qvdp/x3Q0QISh3XGbm/IXQKIBYWW/Yk9Xp9TmMB027MS6JnJVxSBEDAOOB++4nkkMKdwBQVI3WTT+epmN9hHOeKiYWe6dqPzjLxavKHAt/6bEPpwf/+l0fSHkbiIhqjGZkyrgDWsYhkhBSqBZKyZkmh+aF6fe2xguAg1Rwn/fCoWrD33YZAirCXBsHIE1Ep6vbVKqNWZUT+9aQpIC8g+rMJMneIFbWH1ah0RW67PPpDyukkWFj1e1LY69F42wq/WEYD2JoNK57S5zjxlA3fT/WEGP0c965Je64r4gH738fjSnmTYlKBNFuEXSFVJrzM63jHspw1U7efU5OfcWjVDElznNsZj/fPdIiGcmGZmBtBskDBN7x+Edv9z4nm/7Zi6Zsepa08maS+nO8lKRz3BzBfQQAgYkpT3PtkdPHERx34BQe66Od8wJEpXidGWcffAKmFXHlsQ//xcd/VErBdwvSwGpaQ2vMGrPI9HMiedtqLehMz3SIS+G8RdOkTot/nHbdqVGRRu6maL7k8bWS5m9S0ZQFqkQVUom2JVNO8dxMg+0rW9vfAoqabLJqRypEA/bOXlz3hjjOPAjlesNlzqrwYw0g9WmbmhrOX1j3tjibiAv3lfKeT/3IlU/9KBQiGrbOmGht1tBqsinjOCMZk3tN5vroRbvfdi7VubOr3voyeMC5VG/BfO2eS+ikBL+2lXOSgidMVEH7/77pFGr3/tmLhiip0D83vVPLAAqEsrV9ebB9Zd2b4zh7SNPWeNvyToBCiE8pKmDsxzQYyXFm8NNiDVx57EdD1bcYBUKpxmRNG5MNrbak3S3mqizZd0/a3bjvPDx72W++zaWb7gnJQXxpZ63KxemBXKheREWrot3NmqBK2C9/899YfGM2h/72ZVAgZmhOinOU5jUUBCIOjpZncJxjZdPbv84SkbUPBNoEtkaV+G5w5uHCfT1ceuSHvuXRf0wCimpwpgYbsyYlZ9poOEiy2ZOZ4cFM9+7vnPPcvr/e4sn9lpHOz7aiZdLubXKmUz8nxfq1sagqkfbpi3/tAO+28Zy/EN78zaYGyOYb7XsQQyOgAW53OZuHmNCTA3cCAhOI9/6R0Ki9c341dmZx4b5O3vP4h0KvF5s6qDJobWzMamvluzUgmWcnTQUWy2DQObrwkIGZqTUsMTADIM9XJSKdsLtANMVpUqJGIEBdGwJ58sfP985dDnWIFXWl1dmXjAGEAHTt7mwWRNO3ypMDdwSiCIStezPWD1XkEL3szp2CXwfXzKVHfug9P/chAGIIUkVYY21ghm1mJml3EmxrqJc13P5rvdbATJl0Fio5+54q5AhSTUzaWGjy6W88wYGZ3rnLIJXaH1YnvVNfSrVP1+7ORjEYVq7l7hAozcm1P5aIump35uHCfSP4lsc+HKCEKXpJuzepfiLZdLR7GrSaTPeuQNycUaqTn5NilNK678l0z5NM5diMklTqc83op9/xVw/zbptCUu0QETslF1nX7s4GYoCa37DuCAi44479B6o5dzh+HdwU3v34hwRqMNN+BOuYtHuphg5ais2ARFsu/cCs0HRvkY4Bj1IvXCRXoNHyzE5svjy8PgTHsV58Y1bM6VPtiYl294SlsyGc7K4s5zC40wygW0LOcTq4cN8g3v34h0yDmilKZqaE3SfyPcdm0kDVOYGZfR/MG6U6w+Km+1722vBJr99smqfHu1/YeeHp0c7NZnxzvGtmP/XW/2Sxd1st5y+Y2OlT7QkBoWLitYSdjcBFzJ2Et9IAd9udfdjoqWE2in9y8QFtDEaJESDIVLNKymymKm22u/WZ+R9/6sOHepdveeyHP/GuD6TMTMNaCAUECphAFbDkVxMmh2h1cZ8LIbMdvuj1gZ0KXvknJy91qWnPjnZfbMZji6lUTrLhzWKvV5nxn7/9P/tPf+mnFtyeVXD+gkaJvRiGp/Ye45NvOxvFqf2mOXPwo+0483Hhfit+5L7/UkghQYu7Y5zpV8PGRIRUEWNb808EZKp+mFJpEgTRzP7FO98bIAgBqqzCX37kh277pu9+/EMT7W41NLUNNJVy74GWrGtCRNBR8K063/sgw0kGYvq5fX+9xZN7l0EO34Mlm9f+GskX69Ez4+GuNanToPu3afKm4Xh09+DuOja3e6uNIDQaK+sPw7o35HjZGlZR2d++NL768Lq3xXEcx3HudLxRO4cP3fc3xchkq4cq0GBGmEyiRdS2bHn5KxWi5EBQfqZ5QxUSB30ZjRRQUYj8pcd++Nbb8Il3fYCIVFFaT7QnWqlWIpVoEAkoNdFTscXia3cPp8x9ILNPlsezSnovtz5XcpF5AHmiqBzE37H62dHwhWbUlNo4eVJYkmDE5BmCoiGI9kL4K5/+57d8tzXT275MNTVdZWfmzP5fbS+qKMLw6oMrfU/ndNFfbG6vdP6PvAF5EtjavoSFr1GnwCxY8JxPnIL94CwXd9wn/OP7P8gIGGOMIQSNjKA0tU2SMNl71rZgOTuKmdIppQKCkiQsmwjITg1R1QARi82/vO+9CvlLn/rR/Tbm3Y9/6OH73wfAiAamgFAUMDAFZjRl3AVK7jXd92XeEgsGZlqvPa27Ve3Pj4fP1ru7sbH8ailCnwrjtGma8rYCsRgHWz0jfvqd//lf/oV/erTtOW4G21cMEatQ7UIgII9C7h669o0VoBx78QEvq+w4juM4m4ALdwD4wfs+SGNTs+qJRRFabJoIhOyfazsTpgiK1862agomimoyYaZ2nG5J5a1oTTRGaNBAMdq//sb3qWqv6l2aF6G59NiHH/6mD2Bry8a7DSg0SVsiIqAxrze5/CxvfYvAzIzyu4XEP3hgpkwIlR6TREN7Zjx8brzb0DoFcJJyT5J9EqHJv5Y/B7A7Ht1z5mX1BleYIUwRDMcV6aEQojCm08kABYbzTJfB9qVWsqczQY+nHAPREOifvTh+6pFjWL3jOI7jOAfiThfu/+i+v0mjRWoQNlYPqUg1C9lR3hOvHUVlSudBNxuTzfbOk91wSh7EGa0RCMRoW9VW3dQPftMHqrnyvepJXQuriCaABkahMsXcs+lOAchcc/EgLMl07xrtAAiOYnx6vPNCPd5TtpIkujkZIs8CixRI6qhNI3fHOz9bj3vnLtdPPnTw7VkNW2cvpebJMa1/PGiqcRASKrf9+F0139u+nAdadNpCy4JIbcOlrtRxHMdxnENy5wr3//m+B2DWRKuCsEGsLc3uCSDNE9SSB4J2pXeG3WoqeVnOdb7zUkXNZ6PejDu7O6oy2DozHo/+1bve+x88/mPdjbz0yA994l0foBKQmiYiShpoIjox3XOVxUOY7ouNUt0r2W809XPj3ReaOj2XVHuqND/5WR4k1W65nCUn7jvx2Xr8pMXf2r3xB6HaxKmez1+ItQVb/nx2FNZbMTQaGm36EU88etg11FcfQvHgCUK63T9L2kSgt305vZHjOI7jOKvnThTuP/jWBxrQGmOlaKypo+ZpgSZilcwFYrBH9RrZ6nuAO7Fp8+491UpUp/XSxK3PVSLLeNb09wSNu7s3RAPIf/2u96rqX3xsUkTy3Y9/6OELH0To23g30gIkCkPKnIiUsLjcVqPtW2pmzsbO/kn3GeyR7H882rkZG5sk13OWPcdjui57duKzZE+1ZZ41+1ysn4j2GzSIGgEJaiQw2L40NyKyLkKjTc90uOTZDxRohNpIrOwIkr1L2l39sxdBVQRDvdQB6EuoHOo4juM4zpG544T797/9gaHZADoCra4VUBHMCN8y9FTAbj5gFOsxYxObBlZbTA5yNxLTJt37GtK/M9rrawgiAiFTPD0tnx8Ula80EgwhCOXj3/RBrapJciZUaGpoiBZzVEZokO7oyOTr38J0n+UApvvM4ij2eVrmRhw/Pdy5GZuJTC8lYtrgu7Hru2fVnnT8c2afM3vc7GkIpWKgmhko6Y9K5GNzGGxfidaEYVjqdnE8iNVYK9Phk0trooyfemSwfaXRuunH/qha1vamKI4n3R3HcRxnXdxBwv0fvvUBgNEMqjesUUK7el06/2/NdbC2OLZm2IxH1gDQkh8uMj1pZak0oKN6DdyJzc04voZdAc5o70zovazqJxs/NRTS2Nbs3acRm4A1sdKgVRXr+mff9YH3PP4hAJce+aFHvun9MGuAQFbCSIa2lTD1KSee6FFHqc4x3WeM9pHFL+9e70r29JFnsjFzJftNs18zPkw8o4GholKy5gdFhGzD1Om9Nsd0JyxYtdQxqRwPokZp+tY88YnlrRYAhlcfxPkLodGoVkVdVlNDPOnuOI7jOOtjyZ3+G8s/fPt3prIbFDRWI6tnobQZFrTxbwKRdr3e/crOi08PX3x+vDO0hihhDwKQKvR6/S2ttiCa8jOYCN4scQWq4czd/bsb0Wtx9Lu7154Z3hwXz1ogClERFVFoEA2ilaoxjoc7MBDx4/e/L63x4s/9CAm1EGnpvawo5pk5Sg89vHTOc9L9lSWhTmBs8fd3r1+98fyNmOdRSqI80iI5+WfW5MfWIL/0RBM/Yvh70vvnvTN/0huoVp2JZiX9v/0PptsMa2ewfQWAYYlTiGbVboELxmP25YlH4+c/AcFo0CxrRwoFkLQ3HMdxHMdZMXeE4/733/Ed0ZqgFeMIpIoKyNb8TtXYc1UWGcZ6txntNKM2LgPQiDR30la/36/6w9EOQTOKiIb+f/ur/+fc9/0fv/6v9kTGZgIE1cGZu0bj5iujGy+teq+ozlSq7ShYkRR0MQCpJntkHUKg8Wff9b73PP5hAEIVMYh062mzFJvsuObLKQ05k40h+PRw97l6tymF2JF89H1GoJbxqXiW/AzxmdC/2e8RVNJomAwSKDueufNBymje1uDfBNM9V8xfmt1+/Kq9ECsLtVJVbAnanYCi2qia7r1zl4UUzhmPQQHl9sV5TiuD7SuA7SkylDoL9Q6aTuv8hapRMQSbY1St/dqyEPt/tDv2/B/sP+fRyT7Wa2X/vXrnXU82gKXWndhI/v7bHyApGtiMU6JdIVqqPYZ83lEE41hfr3fHVku2nZM6hQj7VY8iMOtpVYUQNPzXn/7IzBt92/d+PPvVVkZpokRgiLtffLp388Xe8MZdo5uvfv73afLq3iBAUKZzIii5QiItW/smEkCD4D2P/xiAT37jtxIyUNnS0NNQifZEgojm+VPTZqNbT+QWD9DJBs07D1qBjuvN6CvDm2Mz60r22VoxiDkek7om8NvAp6X3+aovWhlz3N2Y7XvLv6ZEe/d5yzEbGkrSfc3TJZ6/0BtXYkvrAKCKSYy9RYeiHpAsbTudM4sgAlBG66gtM9i+QkQC6LQcCIFKmNcsiSqwqdo6pgZFs/Ag4M0kHWigPdKiqDCntVkZYhv5Sz9XoGlWNnPqYPuKwZDb2zC1pm+D4RyXaroBqgB0YyXI+QtVozBoR6ObsunHuR8Nk/O/+9VQAeT4Z0Fe3cyp5y+ERkAJsT2X5wcJyrEmIRaMAjv+68BJnDm1fH1mGvy3iGdMridY7SXljuWUC/e/9w0PiDCoWIwCqCBApEyDquVcJOOL9e5uHAowqSVDCLBV9V+ytbUzHhoIke/bY65/+995iJBczhAUCki1aHnapRLYLg723bs3vurmta995ouvuHktbYNIq5+T4kfJ5NBoFKioaFBAaQAHqn0NPdFKtBJRkTAr3HFA7d6JCE2ceABloiQ0tC/vXn+xqYFJJUe206NyVrKnSjK/Av2lauvp3pki7idanCDNDFMyfZ6sb9ctq7nT3ILw5nfHyvr73B0PSz4vVuuEbZ29VNqhi8OkCFd2RPpnL6bvkEAUlUkNlpJMB7uCSfo+EAoMB0011mABEFmJSlvg5p2CZLfZyDyVb7p2qGgusHr7nSO5C6WjX4XHN/L42IX7+QuhUSE0qqKKSFLODrYf0izFwdDk8UeboeB75y5nk0SYmh8GlMIJB4eS7mxCZW8is47tcB+7cD9/QRsVihBNP/ZHgYBSbvuOApgQ1HpQV2OFgILFy3ntx4kR7ml/mqiJQBQhIkq+ah6U9D0SoZQ+2Y36Kp0mTnNU5u9+wwNGKqSJUSeTnKYcBlJAxoDdZni93iVzfDlbVURVhV7Vk2jjprmrP9hrsX/H932SII1iRgkCa0Mnppr1ukgVx/fcuPbyF5596c61l+28cNdot0paHJIaEihjVRgqkscAACAASURBVEtVRwPEJGlYMdIgEAgCwIpQqOY7evunectlknu51Tduv8AMOiNQATw32n16vNMU5z3XX99Hsqcnf0WqR7buHlYDgorsmrdbmPZ8qbSZokqSnsCkqKWwXTL39645myHE1qhaitkuQPr849X2X4+eenhr+9KSugxEUdnxH5Heuctt01dylwEMTW6TTvzi29MOQDGgP6ySThMGQwzn3k1dhfd2JCgItzj5S9n+qAhRakk1mfKLt985acmydoEYiOrr3n2sUuY4GGxfIczGVvebrVFF0NBMrve3IzVpBTA0uYHIQNjW9resS3NMGmNGaDKDpJ9VOw7fedb6UVKG16fDLf3tS3Ky/NHzF0KjaBAr6w17IkyWygEvbswDddJfUURGW01vXOn6jvV66Z+9CIqN2fRjb9hL19b263Oo0yx39rX1C9LdjsEQe9uXAPE5QJbFqRXu3/u2B6IxiESaStKBaUJ4Yc5WC2nPDW+ksaqApPlHE2d6W5ExWgwhfO8v/9OZlX/bP/ikmBipJlQQoe2bbh8MRjfvfe4rr3n6d1+28wIgQXKePqgqJCTvX2TadCcAEU3tDYAmzAVXjEATRKpUKr6MapXyWbp3p2kFP1+mTzEJxeetj7Qv7bx4M9ZWJlSy0qcQS51Hm5bsv6q9T565Z1QNDJC8+FSKPZXfKbufLHH2otGlbGSS8ZKXJg3NGruGeucuSyT333mHIjVCRk+t4folgLXG22IUL/O46J+9COYZE9JdtgyBWBZCgmgAqoW6X4dG8eZ3b6Ba3e/kT1I15etMSDay6Hxb+SoQTEZbTVVrOHtp9NQJEHP97UuGqAhi7A+rnHM8Ou25IYpgiP3tS6vMKsxtjB3DBbC96GfzPjXsN1y+97cv2diavvWHVWh00pV9RIRMLXkRaNQmbORF4JjobV9Ot3wRqml/uLQsaCYZb2jaHk+X78vidAr3/+at32FmqlJHq/KFSQIk9eOkFEgdm+dG15EtYUruXmbQUFVaW+xJ+O9+9Sf2rvzb/8HPk0Y1jUqhELmDroiir7r27Bu+9OQrrj0jKX0OVc2lJ0NW6qIiAubAPQC041NThseSlA1l5czBHgkiybAv5eelK9OnL/CT7+EtRPweo50v1uMvD683LKGdTvH1FH3pBmOMeCL0Hj3z8nE1IHJbo7jmhBT7vPXdJ4NQ83NZoc9x5dN6si24tvLhZBoVvAwkDXJdyroOy/Dqw/3ti5wMXT46Ijys43dAsmpJbT4CyxhQe0tEsveG8aCpxqqrVWkHY3YnbJ29REZBMGlKqG15b0b0h1W6aPbOXsIGj25MMRISAi61Tmsir5NY0X5IQxRSIYTcabDcyY/nk8sPSOqPOntpM8eztsdaTfvLngIve8wmsW8nqMl6ZJJkRzbOeMhEzOFhNiXThN797YsQ+GQgi3AKhfvffvt3mkURbWITsg5URYnFQgTcaUYvjG9KSZa3srVf9f+HJ37yP3r9O8/9qdftVe3f9QOftCYwElGl612mXnvhy55/5mt/67Mvu/GCiiRtrcllFwASyjhUhahkKZ+ekaJkS05dmd13kK0xIgIESBCopE+VxPuci/s8HT+Houtz9cpI+/Lu9ReacWorT0aglmyMtQNnQSM+V209NnjFuD8gIDDSirleQi+5D6PId0HHaG+1vaB485DktDP3TyCb7usz3IHUd7CMLVAEwtbZGzvVq7QAhEAG21eW+Fm6FnJxPVdKku8rU2lH5PyF0KgZFTA2x7ePcjhOVMitjdQxve3LMEJFePsU+yIISFGQvXOXj+usOH9BG6EZRJVcfS6Q5WZhIjCuuJPhtmydvUSm2cyP9VgzNVmj8LRa73nIBNtb8EqvsnmctACUNebQTgFh3RuwZP72Wx8wo4bQxCbl2iXb21k5KmS3GV4b30xGdtfR6FeDL13/o6/aeslDX/6Vn//Dz8+s+du+/1OkhCpa0ytpLhRxidDUb7r6y2/6rc8N6pGKVqIqKiKVqKTCL0XKB9HQynop7ruI5vH+pUSMSBC0f1t+lr+FBFGVrOZLC2TvT0HnOjfzIIv7UihmNzZf2H1xJzYgDIylPRPLz1SX3UADfld6P33Pq37jJX+avV4uijODtHK3La8z6ddsl55xlGbWwvZ7DpjQvuZ1+KPf3XvQj4/B9pWyjYvfLVJ/YWie/e2FV3VE4rNfrF75Rnb6N46MoiJifPYLS9mw5AApApdStHIBcjPfWL3yjcv6dOGVb1zkzwnas19EcmRNYs96dVjJXhIhko6RV72Br1n027fgfkinbDoo/WwZ5n65RVZ7kHcWAipi7L3yjc2SzoqW3rnLYrAe08ja9ZLKqpqavOr1fM3rj3zEq8WOdaJzrFFuMquwcATS9GOotbr3TfbMQod7wXM+sawLUX/7EtKZzFV05exPLjhhiOHeN8Rnv7jObTmZnLYJmBpCheO6LlZ0HsNJ5HN1pxldG++QrZ2cZjLCoLdljK+75zWf+qN/t3e13/YDn4GqUZvxVrbH8z9AcNeN57/ulz/x6j/8UqutZVptq2jISj3/LNpdU5wmQNokTEepa/u3QbTqKP7OlKtTiRd0Ht/6FpCt9Fw+hn802vntm9fGMRrRwJJqb5JSJ2qzaNbQIvgc9F/cde/HXvmmm2e+Kg2x7cye1AHlZ55fKR0Q6S4LmezENk5TFkR3VSCavmmz6tPVYIpqSXY7AW6CwRCWcdE2qZejMc5fCG9+N9WY8tzrFi6AiFEAU4Y3vxvnL6x3a1jSEskqU2qJca9qAwg1jZVplLXvjURS7ZItwxUhqZcjHYjlkfoNlKE/DCsJxhwINYkVQx2W+2GPQNtCO6Zs3nyI/jAoQ+pmWeEbHxeD7Stbqf2DVK56zWdavtqLkeidvbjejTmJnCrh/p3f8B2RGFp2nHP5uJysEgA3m9Hz4xutrm1nDhr0thqLler3PzE7DhVJtZMIaVjptHEtcubFa2c/84mXXH9BWuM8aXERSY+LR15KyKtmwQppVbgI8mDT9kFeTJMH3xrzSSlnKdyJsZcPtYeJiTPzwVM/WWP2hZ0X/ni0k7IxEWbMM6EaWRsbWqRF2A7weP9lP3Hvn/vjl71aQt7YVrW3rRlMafnys/R+dFs85TNMyXRgSs3nPxXpDXvruLExLmm2VFs8Wr4MFEuK66ciHAty/oJGiZWp6SpF2EFQyiaoVaWg7eAWWVOHBPvDYIFr3xsAemcvlpHiq94VhjQDgy1rJ/TafoMN0FLTSH9YKXW9yrVV7as/1vmgiJwC7d47d9kQU1W6dW/LNDm+LKlTxTk4p0e4/623/S2CUdRITuXGs3IdW3NtdLNNbOSxqOCgd6YxUw3//Wf/2d7VftsPfAYARDRPr1pcfBGI9Hdvbn/mkV5Thyyyk1LXUBIykpPu6YF2nec2757WlR9wotQFOmXAQ7TVu1ngdmIotzLdZfb5NGsSeDOOr978k5tNbUCTK8enSEyy25OCtwh+KfR/8hVv+vV731j1+jKjrfea6Hv1d8c9n/1lxnSf48qn5SjEinUDkSbYXXg9QopsQsWGtA1L0AhTIayj0Dt3OdTBAvvDzbujILtum6BWqTCJ61PtCUl7IzTr1JdEWwNgPbtCjLEXwzK6/iaqfQNPfgDJmhURS4nBVUNwXS20llOg3VOXDnXf+lTrRZju+3TtfihOj3A3I1TNLEmKttZz+upH8vnR9bxkrpTCCA76Z6JF1er756n27/qBz6ooAO0EY9BpFLzxl3+u19TFa5fWdG8laOdJaePsSa8DoiKc8qU7arXAPVp25ss304e4JyY+9TPPhAQQfHa8+zs3X2jICBrNkstujGQ0GnM25ibwsZe+9uOv/jo789JJu6HLHI+82Okd7d2126c0/syn3+vKl2WbflylbhhsXxEs6a4qG/VFW0K384LNmW7wYwNvJwXZCO1OxJ6JrXMqAwBpb4jpum+xst5ISX9Uqcn+M8AfiMH2Jdls1Z4QoyJwSb2Oh3/7tbXQJptghCyzm2WVTHfpbCy5ebbuC8tJYqP0xNF54C3fTUpsUq1BKY57nryFwAvjG7HMJ8gsYdHv9cexCRr+p8/++NzVWmDFoJVOxHpHVb7qN3/t7hefT9Z4qfCYx8KqBJVSar3rkbO1qIuVPOkZKDGcNtkDoB1Z22kydKIve6z0PT/bJa0UjzGgMfv93et/OLxppc5jCsY0tDrb7VbTGtpv9+7+qVe/+bmXf42EamKTz+wITOnvGRN9Vn+XpseMRp9tu8y2CiCQ/milMdBUSnk567K2Tv36ocjixdwX+fvB9hUxrNtCPiCt07zOS2V/tCHNG1FTgFtnlzAf5BGgboDSJYIt9v05f6FRUyzLFTheDDXB1QeRRbAhof8ldrOskpPSOASQhzGs4zQ7oZywc3E/jBGoABonCRkr0nYY6904Rh6RiTTpp6jWZqKyn2p/4Ic/awHNFjGrMAGRajS69wtPde3ikglB9wdQgiPlVcmlGiZyPDGluTlfgu8XZ+86qHu/o5aXSTPFcmjNF3ZfuFaPImA0Q6vaU1QmZ2N2IA/+qdd/6jVfFwYv6X7yiYk+z3SfSPDOKzNyf1rHo7tMWbKTie+Y/ICqre6MJWBSL2NNIsBGlRfkGnsAzl9otE7T5axtGw6HbA0rsfUMoiLSHMSrf+f9YBICawkPbEC3A5DC7tnOPAqh0aa/GZ/kQEiarmTBToZDsxmqPbE1rNRkXe3VI9A7d9nS3I6bdO24JUyztvRdux+A0yDc/+ZbvpNg5NiA0ruWHBEFQOKF8U0AVi64NFAEvT5F/7cn5kyxBOC7PvJZVbDaK9lzGPve3/y1Xl2jmMHtONTs9kt+BtkvzyKU0NSY4LQcZ7bagT0yvX1pHyk/a7pP/22uHpNmKTHwejP+nZvXdmJjIGltir0p2r2BNbQv9F/y019z/tqf+veCVq2C7mr09oNjSl630nuvjp8Oz7TqfDJKddZtn/j45V8qvHP36hTDcgaUrrlrfy+SC6cs+O9ohEabfjQspUW0Ipiyd+u5qWycYcY0j+1Ky3wA6JSG3QDKVfzQ9M9eFMPW8CTNoJJGXm3WWbhamIaJU9YS9z805y+YROqS6hCsCqGIANSTsZPXymkQ7kZDHkIo7czoaUofCnaaoZUZLcp8n+iHLcSIsG8QwkxDhTxLUqtTOsGNl3/pd7pCMyvY1l4vD9qMO8povlsI8Sk1Xx6xo873ya9Ld/mZtVmJxxj5zHj3Szsvdgehlp+IZIRF2i70F7/qtZ9+7Z+vztwzK527Jnn7W/mkWYXvWWZGfE+W78j53DHRCdigvPe0K69BsMIStLIUnbBpd7z6yYeWsgePsJKts5fEZGOCH4cg3VRMeRKjrktHzIQ4QQbk0hEYjtbtQCg37ZJwe9IGr9p03yRICAIXL6V1/IRGN2NUzOGh6AnZyevlJLX75/K+t3y3sTFGRSu0lEApLyc3612SzC8RhKo2ZpWGH/zV+SGZb//Iv6Mxxl6J23S0OwHh3c8+HeqxiEpW46KYaPpW7imknTy09WckXQKkrGzyc2KtsftuZatmnuz+xLxlgCznDSTxB8Pr1+oh29YLuWcmVHu2GvzCq/5c/ZJXVjRjGTBQ9muaug6cTEErJESYqzoh/QLpTJhaZkKdmjCVkv+oXXPumOguJiAmM7Amh59iXGndQFnG/J22ee3j0Trq2wy2r5AxLGVs7FqgNL2ozQnzsY4HEUFUw/kLp292yYMh0EN3O/S2LxMnULYny3ntA0XXDdEAMti+tAn1wfajf/aiGfujkyrtiIaQ3vbl+uoGhUs3jU1TFIfGaJCKBKACKSGZ7DfvNqNIS9F25GGp3OqdgcgPfm6+agcAEapQCO247JOUgLz0S781Sa1nCd4a7TkJDiQRrZgR09Om+55gzCFM99kVcrKGtnqMgbXZ7+xce74elqGoZlOVH62BRdpvnnnFY697a3zpn54ywucH07vhlz1uejfqMuPH70nAz3XlZxZrszZphZxqqhwvy7pRbfKFfmUQJgjHo9opmBZEy+ksmaU3Cmq6sbXhskPQeeL4viokmp6duBF7y4RHaMHNOC1LYPbM776wVKWdjLDNizHMfveLJ3YM7wSsISJ2KM5fMKXyWNytvQnJRTKT+5EFjJ7IMj4r42Rfdv/6276HQLQmicR8HRUQYgSBm/UOy4wzlqSthlEcV6G33zq/6yNPCQQa5kXbs6c+eP65nI7hJLWNUuSx3C5nWxFTD4rIBiYPbpF0xwGeTKtNnnp6PpI7sf6tm8/vxnpSQAZ5fqUmx2O4C/2FV37t1Te8JWzdtSeb3smrTILpwCTNIl1dvVd8l+z6ZOk5Or7V+DOJnKmNgYhAocqvOv6vdO/c5aVc+o7vLnKySF4j0SxxnRQqkHZvMjInHSTt8O5clWk5h0AoAl3tLI63h0Jq+ZBTm0YCphwPGh5DU6afgtqbdn/d+zGPp/kiFOEhapyn9t6yJFXnoE+f+ZMlODn0y3hTYqOyIgLheNCYcmYPTCo7yPKbSQuOSz5utJGmt9y5/iiC9vKyN6ybntH9Wo9HQsDYP3llfFbJSe1PSdAMVQ/1EIBRgqRYQk531DaONACSKquQAHr9yqL94Gd/bL91RkUwbRQTgToVcweEZ679SanMLROdXnL2k83LDaOSC+mmZSAg23BM51VJbfr8TDdAUx7uk58pV+es2knihXr4h8MbsSj5mOIxgBGkNaDRnuvd9Suv+fPxnldIMujRRl9YCkh08yol2ZK2Os+QMQm9QMpkaJM1dP4kfehJAoeAlASOTK1KSjJnEtTJb9rrjWPct921LISkChaufGJyInvGjwEusauExWc0ULHvzFa9c5eFbG8ttgy/U40ENqS7vHzrBSRV5lcuOn9BG7VgIaoimDRLbEjGykKja6ryPQWFEIXN+7oRgChClHq5A8UVlR1cyJJYxiUFwHjQVOMg+aDvfx6mQ69RbZJOXARKswnFXtLHhzA00vRtblirf/YiKKbW9GN/qUOBp+7Jm8Rg+0pjdRgtZ21ShBPL3XC/wmiD7UuW207AknZOf1jF6k5O4t2GEy7caWhM2umWKKoTN2ynHk18bQJg0BAbC9UtW3IqdYDki2zyzZNwz7K8d+PF/O4lsM6iRDs9VNLtquwG3Ns/bFfSLjAjx9v1zwvET9Y2tZIkU4Qknx3v/PFoh3k3gW1IplSBNNoXXnLv1deeD/0BSMnezSR3jqLUu/F0dBdo1foeeZ2VfcenTxsq0gmv55B8q+w5WdVkSQoEJSsPSD2+S8Ox1yQRQnmUvvA961lKTv5kk+YBWcoFncJ6K4ZxUNPx7aRze6cZbF9a1lHgpoR9ZTyo036on7plGPSJR9Np3Nu+QphQ5Eghj7n0h5Xp+i3YVshCZTxPXgy2rxgiBfVW0x9Vyzp+EfFwMpa2YNORKoSl0ky31zTl0IezF03Z9GJ/GBbagLnW/uogVQ/48cdPPQIA5y+ERqkIVhnqpRjwChrQO3d5oyr8AiCssp4to1dTJPdcKGT41G0us62F0du+bGqxH5fyFdscU2ADOcGdEX/9bd9DMjImQV26xzQ9iOSwGVsR7dl1q3oC+fA+Y1IBfNf/+0X0VFVn0hxT/zrzuaWkzMzkOm1CBmzfuvMnnWBMN8WOyav7Bma6L2F6hSSthPgbsz8Y3nh6tJP0epOC7Ln4IyLNwIb2xL1v+q3Xv623dfdUviWnUkpkZTbQsjeYjvQ1zyK9G62RPbtvOg8DtG+BqSR9eqAKEUUIAohqCCHmhoWtwHHfyFWdWJbTZ00IBdpI7MdDDV0aXn14dPWR8jVcdEsMgrWGfUVgaqHRQ+2H4dUHR1c/LiAhimpZrQ81WWPpZaqYMim5+qmH99NSw6sPjq8+1PRjaNSWmKDIkczbM9i+Ilx0RiFqqg2g8fOfOJQTOX7qkaZn1TgoFrpypo+6njEegvEgmsTDffwnHo2f/0Swioi5rPnCEJPaF5tDuhzZMua4pQoBCEZXHz5Uv2J99aG4vK/Y1qjyzur9OMGOu5mFqtfUQ0KzohUY83dqFMdsQzL5JJKmqavqVlcuMwtbvTiskYdBFq9dkbsIhXc9+/RebT05wXJhlSm/vBjSbP3y8kDawS5dN33Woe+Y7nsDM0m1p9eNMNrv7r44sppEqhgDsB2Nmp4ZiX7mdX9h/PLXVhDmWT33eOqlfkz+2BMLvGj0XEumE6ThVJCmLSeznx+fpXsqMwOpVREbWO5LLhkHs7SXzBBCiPH6k//mEGfJUVnavf2ON9z7Zy+SWPxGl+MxpvbkI0dbw/jqw8n7X7izm4JqXWHflLILkNHnj7IfhlcfHmxfabRu+gv7rwnBmuITHA9iqINSm88frPXyxKMR6Jd54BdvuuiB+9OIqKgWckPTW8m+iYXb8MSj1fYVIk5uOUeCh6+lszgCNKml2rP4xCcO++fDqw9iqcddbL09D3MgTKCLDyJKx5cyv+fq9izvK0ZCo/TPXsydJ06Hky3caUZqGaEmrRoGMIrjvFw23RlCReOPPvHRW62UaJomub5sVftkNCYhMrpxDchWcpF3QmarmdOueVeCt6fw1JMLlIbM5n2n5uPQ6t/budaQJEwI0khO0u002vP9uz73hnfIS16uuSBkV2cXnd4Jq6AkXEqOhZgE04sGksOVhkwpFDG0AZ0IKGGh+sqn/9nhzoPjgYAtI6538Fv7KWbxfC2FFIrpgjXC6qsP9bYvUw2L2Z+GZk1dKUI1mI5vHY+5JcOrD+L8hVArVZcwfy3XEx1S9Koxmn6MTxzuvj6++lARFos2z5OTcsAlKfWRvwXlTsHxLRLtt2N49cGts5cWVN1CW2Vdr8Ro0IRG4+cPLdm7lOOOZdgyFGCjNOVShv4T2ftcMAWUdjVzPHKBXb02U2DTOcFRmWhWW2xtdUqWy0YhpLaagBVbjEj+8W1OAgMVChXonoRMKQ25M95FJw/TzcB0f04KOLJ9ftLz03kgLImauRmY7kq6a24TMgQNjOS1evjFm9fq4qyTbGhGayw/09C+dM+rf237UnXPK6eiKdMxlkk2pvNi8cj3/FX30Wwwpl0AuSJMmrKTuctABEr9wi985Iu/+NHf+8WP/v4vfvQPfuGjBz38x0xpoiyB5ZfzOEGcv7CUbtN6K5raUir71lcfMrV6a9E+ZYKrzwyMBzWVS9gPTzyqDELe7op4EAisek5ZBYhYWe9oY9fGVx8SUJcUnDjIacDFpmFOQ24Xl4mjnFdeJOYuK66qRJVQh1gtoYNrfPUhARbMC2WWMdh3WfTPXsTiHYDFtVtKdn989SEIqIspTJ5ggXqsnFTH/a+85btjjAAEYkQQKXJWANRWW5lgM8l6gUTGIPtOlZoQUVNITJlrYUrIaFpFNuDrr37tzV//dy/tnQFAEQNCaRiUWioH89rLg8SMs96maGTOS0AnHpPk+x8Ob1yrh6mYDMiIbLGTMFhDAnzyVWef/5qvq6peOyGVFHUqxWTHxFMv+ZY205LfTopLzpL/2TMItfXs8/pFJFWWT9EYvfpz/8ehD/lq2ZRL8glHG2361h8udP1VoBpr019aNMUqaqOLBmZWnhlY7n6on3xo6+ylEkhb7HxfdYFMiWrBcgTiiKvIZYIXblXqgYSsALnL8WgsLbrXrm4RVnl1FDGo6mH7VfZdHcJyJlFbU0fTfFLlhsU2R1kRNr768SVtE6YlzNHIpsDm9GxsCCe1QUMjQiiutljHhAYwauqp8u1AqIKo/Pjn9590Ka22DMyECLRrImPiI4fqZjNGMd2Ze6lguYr6lOleRHZ75t5qlOqM6T47FJWTj1MG3TISjdkXdl54vh4aU8adTf5JIxtYQxtJeOJ133Dj9V9f9bYmH2liiWPGL8e8UaoCTJaZttpn9lH6nwpUUzuAAlGVX//kP3ryk//7U4/+4NEOunPiEEpvuKC/RQMq02XWBXviUQD1YLHaRLRV3rkFMHC5+2H01MOSZ59YiMlVbyWMB7UpFyzHObz6MPLopYUIcwtQzkMXyMkAsiztIifqrq8IsiQPODG8+qCpjQeLl14hNmo6qkXNaUkp+eVsDIBc1EsW366NaR5tECfVcQdgkQIxgSCXSGjHodbWtAPQUotPROR2djvKeMlJtF1K5d1O3p0vf8XQ6pqmoql4/ESCUwwMIu0Y2Rm/vKyd3Se7pjum/wSdG6KgDCPtVGrfieMv774YaSBKzUcSORsTScJuVoOn3nSfvvy1SjO2s6yWVDrbzz1x0OeUhpx46jlFMmWxSzHmSz3Hra3eaDwWMgT8yr/9X45wfJ1TgMY0+vjoayDUNI6fXCjeuherrBqHRdwgIUy5skrDaazE0ovHF+N5sZWsdFdINQ5Nfyll4iRAFy+fdxA9LjigvJ/Dct32E9WXKIaouP2N+1DEyqpxWKgDBACgCIeo4n9s9M5dpi1abFcRCFukC2s+SbUscAqv2BQ4KZxU4W5k6aLMytKIUGp919Z0tDINCHrGeACDTVp12ma5p0epCnRrYFXvhfHOvYN7kLMoWb5bUb9dNx1pTuZy6s6N0ADSllyZFvqT3vzcsdtW0iWeHd98drSTuh8IMJVpz6n3NE+qvbB192983Xv6Z16aSxIAZUQpyuDa3L6YV4KdJcqXEy/svtAV7mz76gSgikazrX7/0Z/5vsMeWefU0Dt3GQctl7cv9aDW45hC74lHdftSHh99RKTpx9DIaioNt6PYl8vw6sNb25fRzlN1RKTpx6rRZc6Luw9UCBXLCE4o1BAXF8YH2XOjDZiu68SR0ijDp5atJp94VLcvK8KCbbZDV/E/HpYxVyANjR6DGqyffKi/fXGR79eK/ZGTwkkV7gQimeuWCFLQHMk9Sto1h6+zh7w73j3TP3P79apkc6S121keF/neO3Nm+LKXh+eeeZmdCaFvkIA88qhVCDOiXQAAIABJREFU7elibnl61TyMZb/SkEWmz9bpal8tk3bkqSIhMLOvDG9cb0ZJhpc4O0lGTCrJ/OFLX/OV7fv7vQEm6fMyHykmE6PmFkLrxO/11KXdQpT4O6Z1vKA0KFT05z/2fUc9sM7pYQl3FMHy7NW9K1+0UdEfBdNV2EHJbj+2oKcIw4IlKQbDqlnFTEyEEQuOeCsMrz7Y37604IRaXCTB69ya1HN9DBTVvlibTdqRdGtGF2x3QwAu327PqxZZaOTs6kyBE8RJFe6RBNKY1EmU3CAKGuMkIQMYEDQY7COf/eHbrzcr7aLgbdp0L9Xc66/5M3jumefHO4MzfWbVLkKo0AChBuFMWgb79MpPvTpRzcBEtSdBn2omEsAo1l/evZ7iQAA6ldqtTcsY7ak/c3702jf3dHKIJc0VlTufpK3S3ir1bgl2dD11Tn7lXolfRgmr6qM/83cPdRyd082CdxQBgklzPF7L+KlH+tsXF7p5U1Yzs1/utjuuleviIsYAtWPPTieVvOwZKxfSPCcogTvYvpIKrW2E2LwdqbFaL1D+8hYMrz64oBOMzSn1u3B5Gy0D6o6DxVQ7sDpT4CRxIoX7f/iW72FskmfNctZaOf/GMUViBHlm71Qc5mA3FSlREZbxltr+mhYQAPa6N9rnfnnY1Deb0T3VIGnr1IowQEjN5WXI1s9G7gRoU+Ht161ruqfAzPTFoGTaAZAv1qOnxzdKqD3b7cREtUfaWMNTX3sf7n2DyuynnqoeU4JGbU59Is3zFnQ99ZyAF8gkbAMhDaKB9tDP/J0D7eETgizjipPYgEv7mmDpijkqQhjQ3760xI2aZqHSMnKcN7wpjicnkxhefbC3fXGhFDawyGiBQ73HckPaS/yabxRFo7O0LFIPcKOoBBYXjnevAAFiOMYzypSVLTTAg4ApNiLFsdh+SjvhmC6zi3+5VmMKnCxOpHAHIKFCU3Nyr5F2dIaB1un+FEAQDjzyv8S8pwqllNKQyUU3yFe/tun1tan/ZHTjrtBXCTNpGaNAqJzEeNqNwR4DXqZfnV6AreAH+UfDGy+mmo+gEcloBy3mopAWyetbd//2195Xvfyr5+83mWRgJgoexULvZGNKJp4lG1M0PQCBisRIQFTDg//iew60b08Uy7qt3eE96QtWTDx+RbXQ0NlVHVgCMn7qOEPSsugJv5rSmMoelzGpe8umq9cD0Dt3OQ/2agc/TTR6w9y4zC+mVPfmq3YA460YmuPcTsWw3/SHC0mgtac4ysjUU82dfQ+dy4kU7p0MCVJdFJNU1IwEGotlGSl2NQ56iRYREZI5KkO2vrtYUbzC/l0vGX7Nn+l96Xci+czo+lefeVmECCgUFaa3V0GS1ypiuebaZJRqa7pjVsFLGSXaMdqB2uwPdl8YxZpIYXZAUiSGAGKpJPPsPX/69/7sff0zL73ViT4JrU/6EcqUpq2njslLyKNYk+kuwmgCMAT9Vz/1Xx3isN2RnKCe9ONg8z/94ls42L609GIv06ygYrRQFppYZzUH+hiG0J0kUZA1eue+kG8DKiHFrfdo9ImWP2mNlGMc3AIAaHJdqYUYDKu41hTHMkambjqbEUjaLE6mcCcomtLtaXKl4rWXBYq41/KrHfCe1E6Syq7pPqc0ZLN9jr/7OwbuNvWfjG68Yuseg6aMe1Lt0SQo8uDRzjxN06Z7q+Tz9kv5hAYi3bHJ68346eF1Y2QR8waaWWu9G2G0L73q33/hjW/tV/1b34omo1S7afV9SkOiWxpSwF6NRgP0Z37ybx1of55Yolrw7rkFGGxfOn0JhL2s5BQ5/tuWLOHef/zFHwgsNOnSPAQIWLgi5PI5f6FqFAadJNKLRicNwtSjm24Zlu87OJkafS8CqMnxRlCeeFS3Ly7eblt7iiOko396cdW+lxMp3I2ENeXyJKl4CwGBEmxoaZRqUtwEa4t6sIioqFkMIq2Cz2+RFGy3NKS+8c/Vdz8iO7sKvlgP+6H3st6ZVA4yN4CFMKkUBoIIkoeZCqBFqksR62X7ybY+iwBkTT4zuvFiPUpV21NgJteQAS2PSWWt+tuvf5t99XaVQ+1ym1Zq6qpAbjXkjovyOdEpDUlBykP2gtVGscAq/sxHT7/RzmV0pKLNO92R6GlMD+/l+JPdx34G1U8+tHjC9bhjA7e7qB2NVBFyMzh/QRsVEzXhmE0/DoaVAXM0OiAHTX+eSFaWMLTF4v5rT0KWinXr3IbVcPwdmyeJEyvciyyQ4mSnwEwAosXW1U4XuxDEDqgghNVgGMcDKIBJNffp0pCASG9w182/8PbeY59Ilv9zw+sKeWlvIMKY1a+kx0GEoFEEadAq01SpKnn7iYmPrq1lQtuJ9dO715tstJcSl0W1g4ykwa5vveQL29/Uf+m9sxfy/b/P3dKQ6c3a0pBIQfaJEw8olDRKT8NPffTbD3msTipL6UjFHaza7xBWcNdcWfGKBT/KCmIDC0fxZykVIddM/+xFADZm07fesCeAGPrD6k7Q6PNZyQfmwnH/tSchp2JTpxfv+57hRAp3lnuMEWXmIwEYUkYcImDRxFCIUQ9YMUGrxuperhXRHZ+qndKQKUij0Dd/ff0rv5RMd0KeHV0n+fL+mZxVT0NUAYCas+MTVd567TlsjvR8LnNp5B+PXrzRjMrA1En1GMJIWi4pY1955eue+7Pv7FcDzBbwuM1duFMaEiUZI+UvpfX8tyA1NAr+r4++/xBHaB8+ffGvXa9jYwRQqdzTC2975McXX+2xkCboWQJCoHfu8rJr2B2dwfYVlooTC65qvL8F0gbATjeruXMvdyryfd5iCQTTA8xy50zobV9GrtJFpfaHKxjP4GSW3g50nNVwUoU7i9duHYnKUqKWnScNCAf+fv6v3/yG73jwK8kub6u2T6z3lJyJubZKb3DXzb/wjuqxR1qX6fnxzbE19269RFRb3z0ZJhEIkotP6f/P3rtHSXLdZYLf97s3IrOqX2q1ZFm2bOMn1W1ZatmyhAEzbakbWh4MMuDXGLGjNZ41exi2d5fBMJw5Z3bHBzDMQK8tMOMX5mEGDF48A4wF3bJ7zcs2xm7Zcqt5GTBgw2CpJfWjMiPi/n77x70RmfXo7qrKrKrM6vhOnT5Z0VERkZGREd/97vf7fnVSTBoXxPkus+jFf6y88Hgxr7EElckhYzGsHaqpz5KV4v7y2bfaU/Zm0Ra0LC7J3hd0VkpVsogVqCbw0BAQDBnk/e97wwpP4LL49dteE0yDhi+ePff0Hdu/fKEAcH0n/+snzv7Ci+7uSObEebi7P/H+UfayDrBRI/IiZMR21GOHEjJiw53LwuoWBOu6lysD/srwHF1Z6M4dtDTdmuqINvuIrjik6eb2FjUNaOeuhzGVxF2TDB4coMbEsSE6EN2tqUxdoGmvBAaNXpFGccdFoyHdTbf2Tn125pF/iuX8AXq+6vdDcU1n+46si9rpDhoJWFL+4+HVcnt8YWr6WDH/eDlvKTXGGnMMUhFqMsyo6bnu9r/edyDf+aQUBFEn1qxWdIclpo6haEgy7kec0/e9995VfTSL8Au3fYeGcCEUsy5X6vmyfOiRR+N/PTIPALnLTODhelr86u2vzVz2bX/4i6PscbwY0QFZbwVj4f/jg21ANV5dMtFiVCiCYAyurRaTg2zvnVo/DtqvySaiTSyZCmj7OS3EVBL3Zl43RrVgkMfCxHZTt9HaaK6rKD+y2kUCq7VSaSwtQ9GQJAjf6fRe9k3Zh36VVSmIgapKyP/on32suLAz6+zMZnK6WDaroMHqdqomaWc4XxbzVf986KtF3T2WqMagALXkfjet3TJ/++TnnX3OrbnvXvTc2MV/XbLygmhIg5hTQIj3vvOelZ+0i6GnVdf5qiweD+eXXaEIZRHK85jv+s6M6xZV79dvf/V3fOIDo+96LFipxerSoE7UTWcs4t5l/dBXin64EZVh69WNvMUmYP8BV9HUAG7pEL8pwJVyj9oCuEIqcFeMqTT9173gkvNEjVrPJTe+3dibyUgDgllYcWLSfXddz+aeGt3tHP7Bon+7T3vW2dteYoZgGluZBlMzlFqdKS588fyjfzt/5h/nz54p5s9X/QuhOF8V56viXNn/Sv/8l+ef+Muzj3y598RjZa9SU9PKTM0UFgCFBYOaBrPKoGYXsvz03pfO7/26LJup5fr65kMsdyO6zK2pflcAKWA1m6mnwL33na9f4em6LB6r+hRmLstdlrtsUTPX5rT2qv7j8497sgjVr9726nHtfRRwUAMw2nYMBLtzh8ewrXHAsMXjwzYSkzWV0mLCsf+ABAZvopyKLkgtWkwM2u/LAFNJ3AGoJhOt1pEyqG21jh5DtN6MZgHgt9z43SvcOA1iQ4S4Ye0y4PEcovKdW1969nlzMUw9wIIhmIaU+mL9UD5R9v6pf+5L84///YXH/v7C41+68PiX5s8+0r9wtuxXGtRUzSJBV1gFC7DKNKgG06AW1ILpl659+hduu9s95XmkDEw2WMTdF76Iv1z6gidAiokKXaWh49/1rrHx5p6GHKwsJeeo2elzX3nDyd/a3p3t+A6GjGsEzezx/gUnXi38xkteO65jWDMIjEkqp8DbJNmUR4+paPlqg/Z50mJF2H9AAtVZ3nPtVTMJaO0XLaYUU2mVMZCkmjoOmhZFWuSiym4cnlwhKNIRWem3lGAYkGCmaEig7spkqUq1Doukczj4inNFsf2v/xJQUjTlK6YyWoPJsCulPuZUVTpswLdUsKRICZBqVnQ6X3ze17jrnpUvKPZbdvLoIjNKF59oEtBnVlbwQd5x3ytXeIpWiO/79G8uXfgdNzz/D7/yxduvumFPZ9fj5XylxXCgzbniwtUz29Xsdw78y2868b7xHs+q0Dt9PJu7s0nJHAXGaqKKz2Rk5s526rLGBpyGNsN4C8BVEry2rH1yYFHCmKQ7c4sWK8FUKu6GmB5jGHLIqCGq76AMLO9JyqX3tft9BTh61/UxwyVhWHRvzDOxuFPSEt/p2su//exz9wbTyjTA1CxYVN9Tm6SgVpnWy5sV4jrJz1OZVqZlLdj3Rf7+hq/+m699lb/+ORSp3xbTUTVq+lLDzCLR/SIgAJoqM493vGPMrP1i+PW/+/z/8xcfn3WdXigzcmc+awuGI3ysd2F7d+ZCv7cxx3NpjOWuHosTJsEt0507OBZ/Bw3qLjWHwCm9uawStv4k7Eo4jVsenb0Hqcz7vmXtk4WWtU8NWqFogKlU3DWFJ5KpIylQP94UEHqg3ySjKwCwKnV1dGVYZk2xNZaqVIeiIVOVKgDSd7p2+Nseu+EZO3//AVQlGFe25LYHkPIrU/LiUNKkWdLljUBI784evfaGR+e+rrNtVwYb+IFWrnRerkqVUANpfNvbv3UVZ2b1OHP4CAAIIIDH7g8dBRDDH3/ttlf3Q9n1nX5VNOub2SNnH/fOb36h6tiSfinwk9CjUWFSu8hGQa9b+epSlPKKeR5ukcD6lC416kZaLIf9B0KpTmUCkgdjxO0UzJdtiI9lK3xzrwjQdMWOiSsBU0ncrRbaOdRWPSY0ghCKRUbdxEgTQSuKvPKWN/7GZ961kl3cd9f133v/l02RaikXVKYOF6fGDqipDyqddF5w6+M3fFXn9353+9/8pYFKumTvpgODIfZqGybu9T0q3akq585c94wnnnVTvmNPhwJrmhpz0OA4+nBY34dtkKMziIZcgMU5kd5rCIDZfffdvfZP4iI4c/cRVDCNH0nNCRTIYYU9evh/i3MEu+8/+qpPfuD9t367mooTDQM+2QvVTp9Vq4kDWg/U8zpjQGBpBPYfwMkT49ni2o9kDBmXvnBVfqlPZxx81mQKnqwbUb2wMY8sG+1DC0JOADOdQLhKqkylt6FzJ81zwEAH63UrX4goAcjEl6fbNHWL3cwDHcdt9hKNYCYFvU5w1eQ/CzYO00rczdTMHKmpG9IgGhLiANSEmtEro2bdPLdV5W8Z6NRM0vWSchy52ODOFA2ZerYS3auusbte/chX/qHziY9t+/IXUZUEhbHRBmjJ2s5mN/Ema9ab3Xnmq/YV1z+nM7u9Y43KzsGEfDOPMMzUGyyzZBnRvbHHOGdHj47ZHnPm7iNWwSqjJ3txbzHG3ACghzhzIYDBzhw+svv+o6//1Ad/6cXfNiOd82G+OS0G9ELpIB+6/fWKYLBhAWbDZPji4QeyuYNj8XPTWHYqV8kmjkW6cwcV40imJ0R56RGIEUqOknhXj1Mn+X7NGP+6rvvYiCS0/Qe0MNHR3sjQzbLFAPsPoELey9bvU2TdcaKZdgYGWhBhlZivpMoVJ090x9MQen0htlHB3SN+uTY7X7yR8da8BaOqcZL9eEHUV1L5CR9sbiimkrh/7ORPfP1N/wdJrb0MCtYMkSKZArKA5ZKABdPVCA333XX99x3/W+eKUHSBoSpVaxR3g7DugGpDGjzoXPdJT8E/f/Vj58/hb7+Q/d0X8kf+afbMV9IUQeNCNxTbdvZ3XNW/7mnlk57qZ6+iuI429wIb1ADa4H0seJIPi+4NLiq6q3lDWC97zJm7jlhpzKg9omrKhhc9y9PwIh505O6Z+LKqRERVm2Mtqurqzs4LVW/WdysMOqn3qvL9t3776z/1wbEf/7JQZxLG0/s07/ngdRNFdwPG4pNZWkWxzL5IjJZTbQAghLvCU8w3QMWOrC4fTRImrDjVVtAuRqxJdZf0la0SZBKko/vOLMVEJW1IgGkvZd4wOjwi8RbjBlS5XAIER5w/iWOk3ukHxnZMLdYfU0ncgeQsjyp7Y1SRuumS0MFCI1MTVFpR9sW5lbtlAIirQpkNGWaGrDLR7x6WE91Rs3Iyn92O570Az7mxqMKFYl77fXn8kSilW2eWM9udeBFHszw1WBoi62gU9CF7DIZE6YFhZokMzwUDl3gaMm+VQZ399NHx22MeueuImVFpPeXACnRRWBpwAMBrPvGBX3nxqzL688U8hopvz1bnyxB6oRj+q67vrKqj1ogwWtkt8954vinxEb4pont37rAhupFGfSjSLu8PKU8dy0fW9iRWhVzZ2Ag/sqLbG1HRmvTZ9s0CDZ2+H8fZaSiaRQMMobJlh7UEbF3DlLJ9h6CjD4o9N/UGRRBwo3TCNkBlIjycLVaOqSXuoKUbmSE2yqm/QI5wPivLIEj6dDTMqVkny0JYxdfs6Mue+b0f/nLk5AYMUXZcLBoy8VUxDNNXGp1k3VnkM9i+C2owS//GF0gJL2zEhmHzeloSNzUsWDdHuuzDfbCQRlCDihcduz0GwCOHj8DMmmNbGbRh7oCn83TnMF+r9ASgqs3ce32LZRlKt4Eze+rVFzIu9pT3MhPNNiPdz6CEsxFu8Q0Ulazo1mFDn/DaUG2uoDUJiCcw23eoPHVsnXYhKiOyjyWzfi0AAPsPsBjDdF30FtqWUNNXiPF0rb4EDCYjefmwijvh+kFGzzyo8uAqbn5yQosVY5KtTZeGxGmu2DM19fepiwmFndrnR60t6gaWRWVqr7zpTSvfzX13Xc9UQApgWHQfioaM/ZhkwZLaOTP0J1i2/erC9VHvJhFYLljCYVrLwQpc7k/qdTIXSIXJ29/2revB2s/cdSTZ/1epXww/6j3d2fJCbcJgc+YElHSK05q5OG4klzt5QsbpMjanrESx/8CYNrgidOcOAqYcA2s3mhEr0fkM1NEevgpMVOOqzYJtQN3naN+poanAFgP4Sso8jPjJFd2qEiXQP318dNY+LeOr9c9pHP3WYsCK7oTrh97p+2vv7dqR910bizldmFbibiKkU6QBs4Ea2xUBCniXC6OXlwRhVAJkCJWXPNjqxpZv+6brDSBD8qs0BF0WMHhyES9f+jPM44fk+YGvpOnJOrxasyYXrozFTH3xOTIKSAtG5/S++16xqne9Qpw5fMTMol1olO3c/Yn3FxZy8eAyz/806InnQ8SLG2Vfa8H4HnYKVPl4Pa+Xw/4DlSjH9che8XQHQdiIb9NUbIMHOROIdc0RzPfeOTqdsxW4465EKLqjuewE8IVUuY5LaDdgxOH0BsGwjt/9/QeMxlHPw0TQp9H1EQMktF/eacLUWmWEpYP0AJrWsrOkKlUDKJKH0Ec01aRSHiqstHIN1V73fdP133f8i+LKUHTqWPdhOl7Xp6YkmwUhM8mG3ujlAz/6wjCnNFsQX0Z9baFLvXHso7HKXKRKlQQsYwgmRnn70XWh7BHpUNZELJYaKc6HsjOYMRi6ldjgrWbObXCYWfHwA/75dzgdm+jZ6fkgls8dKk6vl/lhGK6SKh9fGp3W9rDLgw6iI5lzWOVBqlGNHBfF/gO+EircCIEqG2BdiI0eunOH10XeW1rdvno4OG3nRpZAdKRa8HjT8yrVyY+M7ZiwEWr26DCgzMM6VQRJJVUeRqxc4mS4w2KLyVG0pciP1s+M1507nGZPRzjIK8QhtkJMxJBxDVAHFhWB2Fcp6e71VWGAdzOaAjSiLT3GpzNUhaq+4gVvXO0exQUNLkn8jaYuC6T3FYjuw7r7EvmcQ4sGW2icNhjYYy4pusemTgHiqPetJ2s/c/cRyNpZdAzpifjAS14nZN68N3LR6YkwwFu2kR73tF+i3xmDzyRtDRAVwPK5Q+Pa5sWQzx2qWzaOBya6wvu7jMN/mfWyMeTgXASuksrrKKx9ox7c69XAqzt3GGOYGIEiyNQ+TdYVIwWSExgvZdl/QKehOUJEp+/XaW5AlFkvG3EjEzNvQYeRp6DHE5y2PAxhKOdvbVuYlHM9IZjWW+0nP/mjVBholp5mWnvcI1/3LifE6kwKTVWfVDPnsqCrJmFHX/bMtx18upmLw9sFVhnURauLzevRir+Isg//1bDxfcgJ0xhm4qKGnS8g+kP+mXrFKNtHff7tR9fF0b4AFZiv2SRDs4HyU2m1rTMLNDW64PA7rEcmXni+uiCj36dWiXEHuiHOVaiou/GO9bOC5HOHABMdW4eNolutnOP1Tt+/cFJpLSDUqaxL+PT+AwDyXqa1xW4NPxuGwBKJZ48TBhW4UQcghMG2aLzJqJAR5O00qzo+uEqqkT33GwYzSJBs3OpGd+6g6Bi6DumIt7YxQdKs5khvhwrjulRepfIqlCPcZtu+bosxrcQdAERAURjqj7YuVE0MPvMdHdDhumEupah6MFuD6A7gvm+6nokasymbXF50X6ZKdSFlX6C7N1L6wipVDrH2etGCX2sqb2SmBU0h/Omjr1hXob2BaeyptBbEt7H7w0fjrw899o/9qi91DeqSUUuCiJt1/u5PvH+Ne10zTp4AUHTHJroDiJQ6ePWFGzshw/4D7sY7VHRgtRoDmBU+rDY2cFTBnLI+iksM2B5pinkDQxBpFLjxlurGq250Id+MnAgOM3EY8bQEGdmGPYw0Up0mf6yBOu5SfoONJP9GEDYZ/o3e6fuNNvIAz6o8rEflVa3crP34psHYtdGYZuJOwgsAM1MwMfg6XFGBzM9iiM1HsmsgzJzL/u7Mn69tt287/BSANHPLlagu5OtMhviLlqgOa+0Lb/LDVapYUq6KIboPhoyEBjpv4ad/8pvX9r7WgrXaWo0LtKRvf+q+H/nTj5VVFcX1hcYgCPjM2Z3P2XbVc7Zd9ezZq7Zl+egHvgYEr65w404ntLznvGaG0Nk7NlE523fIlRK8RkPOuDYrcKKyurjfcWiGcVg+eir8MLJ9h6gclcQs9XKtJ2IL4XzvnePaoCFwtCnsCAc3GeLjVoPT0QnZ0NbSSHWaQFjIg4yv3X0+d9AAHfmaN6O6yRGCufLMgIsh72WiHO/cZjZ3aCRjOwDAtcx9CaaZuAu1CtHgbomsW9PtWUFQMteJJngm0T1SZCmq3mf+7sRzn7R/bXt++13XC6mmqW3aQqZeR0NiCYkf4usYXrisJ755FA6pzxheQsCCgwqoCJl7+099y7p7YxZhTbbWOHYycvf9RwF84CWvm9txzS/f9h0yNCQZxnafecYRGoLYNj+qN3GNOHlCVIajQccEKirQzKwzd+eo9839B+TGlxlUzOW9kS0QC0CDcpUfePHwA+MICmQ0lGb7xjRpvv+AMqz2vSyFXizQab1goBo4lvOQzx0yQId6Eq/5qBRVa3BfDyhtXDaBWOvSmSq5PSLrO9HxGGZSgNI4BtxltxypemG8YGxTPeLxjDmqONt3KEZzjHhYCkxPXcYGYYrvth//kx9VgyGKoBYsTcnHjMh4rXg/AyDO1g+L7mb45zfeu2fb9d96y/+ytr0fvev6t738qTCDqtNgw1r78tGQl9Ddhy0xQ3wdl4qGDNTYwMgE7/jxu372x+4a4VyuERSgu7o/aRq97vnwUQD/+UXfdqEsbt791F7ZFwCkYHDy4gjlqqwTYzVAIOgmDr/L08cIW4+bSN3ulgq4fXfI6o3v3bnD+dwhXzj1xkjwxnqcsa5gLT5mcuTSx3gEhNkYOOv+AxIYMqWOqD4a1GyDuXsMsxr5PORzB4dCq0YCSXXaGtyXxahMCuOJRGxqXSaGaa4CNFIFsBG5e7bvkI3qXWqOCb5wOjHTF+WpYypqoysRQJWrBI5+yWX7DsEMsuYSuAacEEvSRGGKiTsAMsVT68Awg8a1qqCT3EtuKYgo6nbJjhGq6rqrnh6qkVzLb3vF00RVSVF1MFtcn7osa1/qk1lSpTrE7Ot4FdS/I+tkEBA04h1v3RzKnuBh5cq5S3xjBnDP/UcBvPWmu6pQ9s3O9c47cMDah9jEjPOdOrXdU2j8+hPvG/8bWTEIVqLro7XEkaeJOvXqC5fvPZjvPXhpitadO9iZO5jP3amoBI6GvOe5DoObINUaJWqC4xhtUQ0k1UaZlOjOHfaFU2d5b1R3h0F0xQE7Y0Q8D6Nw96EsozFcxv1O1U5lXwKjnBwaR+35sC61LhuN1OAPtmY/YTZ3KCU1j+NiNSOVqzMNrjNMUHZHnz1D3nPqbMSyq+7cweZ2PeLxmAwhlUBbAAAgAElEQVQX+LVImL6Js4Wgp6+sX5uhm0x3mKVXWbat6hcG+pQ5LrBgoMGKfl9EvuUFb/xvn3vXmo/g6CufCeDIb/yVGsRMvGipqSNRIqE2IOIYfh2lZxvQcgyrYKx/rccaFiwOOYJmeXb0379szccM4D0vfm1QVbOgQU0NJqAXyZ33IuLcd/7R5QtAd3/o6CN3HYm+l0uGnJOI3W1J8OraIfN4f/7Rqn8t6erJhQV1uYABV2dJ0jeYwYnbZJGjd/q43Pgy9To687sISFjeS42olIRaPhdtzcvsTlPOFqNjYT0oO4CiW7lKylNrUVXLU8c6cwfHwhqoJkAQczfeEbyu9sHZ2XvQLHjNpIexzJXLRnbRGgLVTGjQ1Z6H7txBg9mgi8QYjsUXrsrbdunLI97gR0Hey1R0bT0fsrlDWmjIQ97308vaI+LjFMbO3DcSsvIZnu7cYUt22jHwyBpjns8cHTq23DPmPSdIZVf9h1cpde8/IBUrVa+iI59tAlCzlbYNuYIw3cRd6CotjbEnjJlRCTHTqFKbkXCSiXRM+7E3kwCJZVJUq8zNmOorb3rTb3z2Z0c5koa+W4gkygyWslEb+i6ANlJ6Y/1lbR5BvQRANE8MudYiOYbd95aRPNC/8LX3lCFUoeqHsuOyECoytU/S2LgKEOfmy+Ldt77KeXfvx39l0RZ+8fbXlRoAVBr+1Z98cM+Hjz5y1xGaRZvHom+YASIwTZQ9mtoB/PKLX1VU5a7OjDc4GkBZKLRHzDg/43ysTTSD6wSdgAZv6s2VYiLjewwsh0iv6uEQ07AP9a9oftUFy8aPpnfjmrfQXOCjny8FqAwxAGGFtHX/AamEGlu1mVo1lnO1uaV+VCNY5CErvKyAyuR774RBYTJ6s6UhmIAmOPnAuDa49WAY0S1gogJgFYS1vuChJiqut/n3zLHADIQRThGyvYdAXHq+q6bsSoixGuMsqYlWp8baEmt0nDyBG+8outU4UoOoqEiYIZs7CLBcwaAxnm0ttMwr1x9Py7x44RYbPqs5+Zhu4v6Jk2954U1vpglqrd2lylSgjnxSoJPNzvcLpC4jBMSgpAFSlL2ZfFsVxjDHhJq+A/jeX/5TADAzM1NzThI3btw6KUmmKZWJHaTifABB81UIkm41JO/7D3eMfnjvfPHr58tyJsvKEIKGs6HCwvFCoVWhFct+Li7v5FVV/dxtr733k4m7f+D21/e1DKHKnJ+vCgF+8bbX3vPJX9nz4aNnDh8xLBiAoOFqBgp3//ejzUZKLdVUyHP9844ShfZGK2j+XMAnd2at3pQTCaW5bAJ0o5MnZN8hpNHIxhzP4ofOhp0Fo1W0EXs39k4fH5foHhEfTkW38oVzcwdj/YORzYM823eIZnEmIhRW5SHrZcDaOvwugzgFselz5fE8EKKo0rQMCaDyKgYqBrZmQ2whXfekGwOSQNFOZF8CUbUZlcUYgUhY87lDAGU5Bt+dOxxTvrQI8YJfh0r6TYYBhirpGGr53MFFele9Tnz0V7FtmaEa42lI3/3JQ/DqS4mEe3QMJCM05zlezYNrr57BG5xtqo4rb3QRnWgxjOkm7kjfYMa26mIwMJAAJNJkM0c6ybzrVmFeQYGxFrmjNt4vL1DcN7/gDb/1ufeM66ju+xdfHV/8rz/3eZIalOn2XX+lhKgIVjB4ZAGlWUD8ttBYmTpxQUf0wyzC2aq/w3fOXDindaknlnw3ouxdaijnL2zrzFYhcff33vbqC6GYdfkT1XyvXxDo5DOffexL33z93t/68sONlH4J/L9fe0+pVaVVJtl8daEK6ikk3MJvaP3K9uQznqIWqxfMwZF6+wM/P8YTsmaUp45lc4cAM9o6uVMmA1Z2glTsnRq1NohAEONY4ynzno+XjgAheYrSfJSpmdCZKeCU0huzVWDEKYjxom6/QtDEEIQSWOWh2/NIbzve78ZcmaFCmrV62KXAuq33aEiElTCjgyhCw1mRJucScwoIopL3ptjRvgLUSRSx1CtlygGx4WHKlIsthcbbeQPY7Km2S+HkCbf3oEV77dgG54NUMJohjR7TbTbmvaQPwGy8ZztewW1Z6rKYeuIOUBEscnBCYWIA2XyNDVCwk20PoW9QBR0sie4wUIKFTDKo3n3TGz/02bWb3ZfFz9z7/KULv/cdn4lT/ggkoaZOsqP/523j3fWy+FL/iV3iM8m8E1N7PBS7XC7CIhRWh2w0X/rz/QvbOrMw/fnbXl2pqsiZ4lx07hO4UMw/e8e1P/FnH3vF9XtJ/rcvnbrYTn/+9tdBw4WyP5t1Su2fK895kKQwZs82Ratp7wB2+s5VWUeTHxcAXD4RPpkG5elj2d47kxa2RZ+RgswXGIuDuXf6uLvxjpCX4+3/0piFFtmWojlSh9YZ4z4NFBWMMAWxDoijXWrtosl7w+RiXWqpDTp6evTWRnnqWDQbjOcjMBCJHi1UW9hw9wm6RW4EzBYav+I1T4y75WyNCZlquxj6Dx/P9h4Ex23jtGbuZjE1VwDrEq3FIOr0CrucV4ypJ+5/8tkfvfmmH4SYWXxOU6LGQaBuoSqAkJ1sW688F+eROKhSBSlV2e/mM8HCK2954298ZszcfSnu+55b1nsXy+Js6HcolcHTVK0ynRVfmnpFRre9O3u27JehrE08JOxCf/7q7kxJ0dDTokoh9QAAA03DO2+52zn/hk/9+r957kufv+u6T5154h/6xe88/sXvuOFJT3KzN83sqVStKujzEIqz82cJeKGgoexoQulrWC7uyZ1ZrWfrDAClKuEnwSczhPLhB/K5QyrqdHISfccGE6oGr1k1Jgdz8OoLkdGNA5sKE4FZsdqarS2Holu6SqqHWrn9ciBTAdBYseSG01Kc9QfNl1Jlk30DS5nu0414eylPLXj0RANkE+exBASoROx/EMfKttBCuTCRLIpuqyh0nhxMPXEHYiKJV+0zVaaCsUoVpmCsEVXQ+5lMyyr0Flepggb2it7MTDdUYyhUnVj8+8/+5sX+65duf30/VATocg1FHZhCAZ4oCkAJOEkDa0mFkoaoeITqXbfcTXHB7Ouv3f3aj3/uDc966ocf/8uffPpLy0od2Q+VK+aFAOmSUQkx+RE1cU+TyoaOuBtmdsSjMiSfjKdXmxSfzDCK08fcjXf087BuITObAwNjOX9vTUkyy+PkCT93UGEWo0ynEGQqE9/sA9lkGOgKF9owmZUguWVav+6Ug1CaTFgK5FKUp47lcwdVbHrlpIvFIdDMSLmohd8ABwsmaR3GWLZ6/e7cYUMYKkszwNl06khbYaKTdKYVKGaxeSoVBoPW2p7WhplutoP09R2UsbWpESAN1u/NO2aq1StvetPK9rzv1uvuuvW6u9600vUnF9/5ife/4VO/WoIwy91sXBibSsFUSCEJCsVThHSko3iKF+coGeksiIUL/f57bnne1+66+j9cd9t8v69aqlYZ6SWuT4EI6ChS91kaOgruyLKnz+wU0uqBQVweLMikTsoHr66iCrbMg7lpkjX2kPLe6eNGXEIzmWww0IjLZFlsfRAmKjq5hoGJQrxaRm+O02JzUXQqExQPT0GAUnH6uIn1u9U0ejija9Yve3sxiFrkdRf5qQAbXic248z33gnAoIRbtP4YI7Y2EltBcT958i033/RmI1WVJMwi84sGzDpFwRxhYDff2es/ptDYiSE1HwVJqllRXsiz2Vgnelk8/5prP/WPf/Omm76htPnvvvmedz/4i+v7PseBM4ePoP42p8gaJNF794eP/utP/9o7Xvg6YWCWhTJ5ZuLgRoQC1J2iBqI7a4dbdMFZfFlvlWloWEvsKfSCwzJ7OhizPfnMNXlXzRSpviZWrIs4mL7kY+/dsLO0Opw8EerehFvA7z5g7avPjV4JyocfcDfeUfhq2uYoLNpb+w9t9JO7KSKfDFjRCa6S6gofvawOsQJrQj7EKUgCKrpV3vcTcr4AmNCVLmRTM8UUvG5EZvH4EVV19MbnRSSbggczLs0Xmq7zk7BVZAASpgZqil1Ek0ai0YEBmEFBL76bba9nLglIHbBCA9SC2kqjIffMbH/13n0XqscoqgHf/YJ7J1l6P3P4yKOHj8TxZepfWj9P4vz/o4ePAPieT/8X791s3rWUQR+FdhIU0JFRbichRPOrkI7iKB7i4TxcBuchPi5kfEFJa8LVcr4QAuSUp8/uvCafQRoPxEEAACjMwTjpDxoUp48BjG0+NvtY1g5JMQLrxdojglcJLLphem6aVnSDBG5WmkS/O/5wjLXBRFw5qakak4ry9DESOhl9ZEym4KHvCyk6E3PNg1ATm6opppMnxBxsuroXJc3oEl2fdPB4XeZ9ybJLYwz4/gMqOjUPnMthKyjuAB588Mdu2f/mYISq1rVAMREyfpAaRXdAAee7XWi/PKcpE4QwU4CgEmWoMucBnHn5ERtybCRDNtFEkj9j1+6O7/aLc/2ycOJybjP0//Ut9779Mz+3KSfhEnjkriMWrcVxgmGIXdbtWAjYmcNHdt9/NHO+V/S8eGhg5O6kq9uakkl0x8J/08uFtrphTzyWGyaS2J1392RdXRiynaJhzYQSYG4a2HBxus6IlDG26NswmImomgC99WTtAHDyhO4/ELn7NOjuibWrs816cmd9NwlFvSaEmcCFyUrUmQLEeqpxZWyv/TBA6FTUl9CVbhJupOvnG1xvlKeOZfsORe6+6adxBUjn+RIdglNvyzTnb0vvhxd5k2aAK12Zh/Fmmm0ipmDwvUJQ2O0wwNQsmBksiu5Wi+6K5J8xQMQ3DniQhjiTCe9nlPJfP/eeM3cfMdoCZbqW9R89fCQaTjq+W4XS+xkzqIZ+eCJ30IDvnzDd/ZHDR2JF3SDTaRlYQ7q/6w9/sQgqIvVQhW5QTkpBFM7F1T9S/7iFP36wQtLaI+JQAMBO33nO7O5r8xnWino6PrPYmF0B8ULyaz72vnU/TeNAefoYhEotutW4U7PXFSy6QRlMuEG5uSdPqLNpqA3gprN2AGJUYHMncyJrB6ePwUwCylPHEunYvA+x4aCbeRArgyjFJDa528TDWG/f4HqjPHUMTM+jiZ/evAxrB1CePlaePl6ePr6Uthanjxenj/cv9vAS0pD1svEc6QRg6xB371kUBoomX0xTmcqGDuog+DndvCz9b3JoBDPSAUAFZjS1uvmc0czUUrAE7MzLj7z75LtJMa06edeAYOFs2Z9Bp49ic07BcnjkriNp0HE5qWd4/Ery8bJATbMBOJKAkLm4Z8zu2p11a9/Lop+mdJVLX8Ts9g7l2nxmbtvVT+1ul4F8DwCRrEefTGzKGIJymib7UJ46FrIgFY02Hd8umoq6SkKmG8rJTp4ID31UVCbWX0QinpnNZe0Rtdq0OSeqZe2jo//wcQxR5w3GMAedxC/bEpSnjmFzr/kpZ+0R8XnkKqrYhGpJNUG7NGtfAwbv1xSWFFpM/Kh1JdgiEwcAPvnJH7355h8S8Rr6kbuTUKPAAgd9S4UpZMaSkcZY92mCoQoFfP2x9pbdjxmMImZ25uVHdv/3o2+4+X8KoYo1rqbhCXc+U//9N73pP64pU/LfvvB1EquYzAwWbeWZOCfixX3/J1Znwjlz+IiZ1amXl4HUZjAAZrYryy1UTdR6dLqLoePddpft8Pm1Nvtof/58VYShLkS1SD8Mq7fPHS7f5v1On8ecxzSJMVTXXQe3R7M4SJrZSz46cdajy+DkCQXyuYMTeZscBotu6UsRZfHQ5pgfFvqLdGJuqhbz2p1x46tRl0XZnKihbmUbAhNkqsGkZe2jojh9bFOq2Bdx0GlJpmyueQzqCzcIAijMppy1J5w8EYBs7500TILjrgGBfrdKD6B16Izh6ga7NJbdKvlkJqZIfBRMhya4QpDONETRXS2J7rXunhxRzfKIOHdZi+qomrLxKprbl71Z0FQbMvyeB3/eMetkXQAGlFU5w07JNRbW9ENQmoNLgS2IjcrNi+tVxY/c+p3/8fZ7V761WIC7EtYOGLqDNoieUFUAJAXR3k6JvxtJEbBLd8PMjq/eseeZs7uu7cxu9/kOn8ca1jgW6ojb7rNrspnrO9ueNbtrbvvVT53ZvivrAAOvfPMVGuLuFhumGmOB+VQ8YpZBr565U4kzlRMEAiaMcnKV6eZmnEV/UT1S28QDGcDA6C67RJnUxqM8XWuQGzUHZTSAhiBwLWsfC4r6Q9ywPZosoxxP5hxXxPCRlaePkWZg/S42Yu8Cb6Ckb9wWQfnwAwJWk/MwooWNeAClq6lxt9tUlHhcDluKuJ88+RYQIpnCAAsxWDDFy7Dm8alOo7bNJKuMEQC7NhNH9rvvP7pEOR4GTQHYmZcfAeDonXWbesp516+w9tyoJ8ryQjlfVlVZVVVV9av+hWL+0QuPVxpyl/XL4q23ftfKt7bC4bVBrLA4AfPe215HUC0Im4pcCgiKI2ecj51oYzsmAbe5/Lp82zNmdn3VzK7n77jm+Tuuef6Oa5+/45rnbrvqq2Z2XtfdtiefmXUZU7VAY2hfQNbrORAzQA1qicR9/ZS42y+G4vTxKldXSfCTccdkml+iGSHhoY9sugkEQHnqWPnwcRJhk58rLLqVihIoHz4+gVR1A4soTGLlOq1/+tg0NhecWDSWgPV++hqt6FZKhSxVjidadRx+8hYPPwBSGYpuWG+zB1O+nBJug6p9NhC9+mFkAoHf1HkXg0GM6/4AWtKyuOyuNDZwkrGliDsA0qkG1qI7hqIhU5UqAEAkayQHMypjHgo1qDN5xS1vRFJFjBe9uI31lLXAX6jOas0+e6EsbK2Ku6o3U8K8zGYz3nvUY8SiKh678IQXV4TyR174+pVsbYVTosk+q9z9oaMAPv6Vv8p8JomvY1BQChCYcdnAOVPb1od/uGh5Pf4ZjqNZsPfkj7H680pyOyZHgB0RJ0+Ehz4SvLpKVDTN/G74OzOawNNogADF5BHT/sPHq2wwyNngD7/oVsEHV0mVazHBz+xFRRTrcZIMjKRdwHIaOs5MHYrTxwVYP/kzTqkZIRVDFibtm75alKeOhUylohEm63VjKLpVEAWtf/p3t+xI9eSJ8NBHnHqDEhT4DTS+mw1S51icfmADZnqLzkIJlcj6br13ugHYasT95Mm3MInuaET3pn9qjPFU0AwiuQKa7gFpXBZCmeeurAKA3fcfZfLWXWSSrhbtf/azP/v357+EuojSDGGtoV/3fe7Xjz70QXGSwxVWOcqObTtRJ+8q7Gz/nKMQfPtL/tXadrEIjf1xz/1HAXzzU/a98wsf75W9RM3rEHdG4Z2yzWd1wWoi5YuiIQfKes3vBxr7Mlo7ECX2aGcyiyMu70lOvdy+ACdPhIc+Up36SDxTSTTFxQeGYwNBMxhNFIFw/dPHJ1dMGhrkBFEMNfBaH8Qspbo81+uETEFcBidP6EMf9SrxezSuYJ6mWD8+YvunH5jc62T60VuvuTgOT6npQx+dgut5JTh5Qh/6KCE0s/Fd8wDIOGhPto2JcsetE3qn7++f/l1CFIEmKZ9j3e6yRjNhwzRiAsx67Wwhsv6CKOmt4ZPBVipObUA6oKKIqiLWTaYqVYCRuxOgd3mhRVKlY7I5DZD5XiHCb3r+vb/z+Z/bff/RM4ePGIwQjesN7ad5tf/J+x/4m4++ft9rtRkJjTaI/YmTvxZf/Mjt937mf/z5r/3V7//w/tdYiK1McaHsXbd9z3zVX8mmLim6k4yKd2LtP3Pra/7siX/42VtfZSH5ZAYNmAihdMTl4uMcem2jSfk8zV4aBm+Db0kzoll8bDHJJ6XI1HI7KKoiMjlVNONEkhn2H5BK1KkEAoBQ4tTDeOQPkqbxuofFEOni4elR3U6eiDpJNxX4mgEQUsfQfjJuoS7SigNzq05NXzB5ZNXxFNFIOGNlturKw/gFpnlF4AQX5E1LSeUqEK/z/QfiXJxo1IhkLdc4YcayW2aFM6VgnL0n14Y1f08v8UHHqYNF1zxsDfsyI0ChJqd18LpFRjgrRjOrkKreDYzVPYCMrsMTBOIzKF6dGF91+yWukKUuCbNBNX/ZLf1CxX2iHWMXx1a7E0a88IU/6D3n54OQnnAUAQVwAgEE8ADNzvcfESgNghjhojQzWO6cqorI73z+5xCzWQCIMWeKmhE00ZC77z/60qe/9NlXP7soegQElklG8j2f+8WVHGraeLrg4os0+GWy2uOlT37+c3c+5akzu1WruDz3eSY+81mTM/OTL74nqKoFVVULP/zgBwE8cvgIBwHtC0YdqfIVJLH7w0cB/PiLvqNjyMRZKDOKIz3Fp8h2xHyb6zs7rs47cXASc97jay75N8JMmQi6RSO7poh90zgZEkP3zSrTkGZINMu3h1B+7Yl3ruIjn2Zk+w7RFnxEAmgdpHDZr6jSaDTQDfekIADYVsnvi51EmjgvgQOqug8DLvGQaZi+AIBXBNRfNNbcd72Rzx0c5c/j0V40ohgA0J07bFDAgoQq124vtja9aP5M1NiaCya1VoNsWYfANCDfe2dzbQqcsqx1p0t9iBBADYA6M5peMQS0ueYjbxfACIXJRVTVeJ8UoNetfCFM3Re3yB1yLMj33hmr0QEANCFNV/IYimo6CVo8vS6NQtfnGZTvPWhMyd8ADGgk/HzuTiPiNaBCg1Z56PR8PEgVBY3KtAIIWDmF84pbk7jfdtsPlaWa0YIKIZGGAlE59kj0varOl9UFxpkcAFDCxAym3nvAnEjms//6mf8M4MzdR1DVOTUE6haq99x0r2oZNEhabLP5jJq++8Gfv/RB1pQ99XmNFzmA+MURwMQgpMfuDx394VteZ+Kk6EVrGmBXze4qQ+VgqqqmMOtmeRmqKhQkM5/9m0/9l+G9AKDQBh3U2AwMAPz0i15TWegTM6oZxZMe9CJCcUAKYoc8b/tuTwEg9aMeC00ywGBJguki4h4l9lBz92AaX1fQSjW2XPK+c/sDP73Gj3/K0Z07aIPZicvcNC0FmSYTkmwUGd1EdOcOp7qVIUKz7ClaOEEWO/9uAjfdAOI+wP4DvhIoRGX4z4cxfFquhAtm6tCdO2wIw0P5i32IhmhhxBXOPqMGb4PTtfiENf+lYhBUV8zwZs2IWgkA1pN4Fxe5EwioU+O6n94kdQ1VijW3x5h6mQ6HqLzSwMH9kEYdznOf2AnGS2NrEncA+/f/YMyUoZmQPrYBAhwpTMRdzC70H2H6LhtggmgtMEAdMdOdDVUloKP/jeVy2V938/8MDZ5SVr3G8D3T6cS05Xd95ucudnhn7j5iRXMJXUwwJLuwClf/1tF/+6LvdCGYmWkZCUju8niouc+qEIKWUd4GrJt3CduWZ9/zhwPVPwbgAGm80eCnXvSdYhVNndBC6SSydhnunSSkA5/c3bYnm0GMlGlukRwQ90X/WjLMKFLnWou/qGl0yATTyOMjdw+mIbrp4V76sfdc4sNt0WKKsKHEvUWLFi1abGlsWeIO4Oabf4h0IfR8aucpDnCIdu2ku4dQFOXjhEXDDGhilnR3GGmZ87l0itA3guRvf+69cePPf9L+XZ1dT9v1DHE+lD0BHNMIrpvlFFZVScCJIymUn/3Me4eP7cw3H4GH9S7TccZICq7+7aMA/q9bXi+UXnVBQACe4ihBq4HUzWRcMeiebduKKuTeDXP3RfiFr72nCKEI1jfntU9TIb3QJdYujvAEKQLMOP/s2d1IrD3uLck9WI61J4dCEo4HxhgbsscEDFF2s0o1yyWoff3/976VfcItWkwBWuLeokWLFi3GhS1YnNqAdKqliFNNarqSgDkjmHIhvcvVZqpqPuXHxELU5D1QgFUIIZwXcaQgVK/Ye48Qj5z/h9//m2OvecG9sBDKHpvYF0BoZVWamRDioqtEyrL3xhv/hVAy5+87+T4ApmAPlx040WB1nJGQlFhoyFhPGyykBkmojStJwOejF+avnp3pleGnXnzP//7Hi7n7z7z4HrNwrqi2574Ipeg8QSfiSAc6ipBCOAIUAQR8SncHUq3qgtIQa1way5WMNPb92tHRRLbbcIZMMKtMSQmVOb+VB5MtWqwBU1pB1aJFixYtxo6tTNxPnnzLzTe/mYQSarHaDyAFpkbUnWhyvx1mIcwbUYvmJA0QWiq6MFVogIECoeyZfdLde19fhVIA0sXEOgLClB0ZK6o1xD/rx6iHTp6HpnpQV/QwNgy6mRpikXY68rpBacx+sUZ0J2AQM3t8vtfx3aoq/tOLXhO5uCWnuRahyF2uWjwyP+8siveIfhipWbuQcecEn9zd3hWPhax9uPX6AiofvW4LyD01edyjVcbUkDzupiH+Rzxw40s+elF/UYsWVyDGkKTTokWLFi22CrZajvsiPPjgW0XQ7ToglXDChrTeOoq9m+/wbiZyaqt7qQJijE1CUyK5EzEwmEVHCeEIJxQZZJ0LKKCIpGZEEq0mFAMKraypOVzRiad0B2v+5RNfDhaZu8SGSJFkUyQeg6MIalMQhYaimDeoGpyIkFrHOwYL/fJC0JCBXsQLheIgjnFmITZGjYGQsjPrXJV1FzVDqqV0YmHK4zDBiB2pFFazdpjVbhmYwgIspBca/T8v/f2WtbdosRDjSwlt0aJFixbTji1O3AF4L2WpdD40rB2MfF0tCeBm6OQ7Mte1RnFP9hOJAZKEY/2i1qSl7hEqkUULk/07sXi6WrlOKwL827NfToclYBeXsMpYrEwNoAeAb7j+xp//iwdKLVOwej1gQKTada8kkTSKSBScFANV+0XRLwqtylAVsOBAL+IoEv+Fi1y/7ngqQolZWVdlnad0dzSs3Zb8O3TAAyhQh5KnfqhxwBNHSpUNTDLRJ0PJmhDMFi1aLEBKmWrRokWLFi2ugOfBJz/5o2Y0VVJCLbdHr3VAzPJMYbDdfGc32wFIk2TKWnof6iKa6DKawBUI6CLlxYBDE0T8k1TPSYaq+u2/On7Lk14AgB5WAWL1CDl6AI4AACAASURBVGEQxGJpQ2YV6LD7Q0f/7xff81Xbr/t3L3wdLHpn6p1F7T352+kABxD0FCfi6Lw4L+JFPMVTMoqn8xJZu/O1yt68Eya3DGkA+OTu9id3dww6wg6dVRu8GIjuceEQa4daarGksPRi8KPBrDKLowKKa+X2Fi2WQixrR7QtWrRo0SLiSnki3HzTm2OIuRh8pN6EI10dk+JTNjkFoV+cDaEUWqz7FJjUgS2+LgNlYsmQxJ5RrwwkQ0uMlTQx1B5vNfLL5/7xKTue/O7P/hKGui81THhp96V/96LvgoXMSa/fj2HqMaixng6IGZTRjD6U7Tv4FdElO5y2LkCsao3dZF0al6SFJDPwhtmdsy5LywfbTBvBgg0OoiGB1DA1GWNgMAsYJuuqsJghE8wCbKazrQrl110x7ZZaXGkYLVUmjtV92xqpRYsWLVrgyiHuAF74wjd7L8V8KcnJzZh16GA+aePmSKEJqFqG6kIVConEHaAwvoj1mpHWx78i4cXtyLdRQxHKMvQbDl13Y4VBaapmEBEYhebwzj/5pUsc8A+86LugQWCZ+LLs+3TMKVidoKuHE02EPGB125W6XDW2dq6Zd7SSk5ZGKawrXBk3YkJe5TtP7myvnfvNjIANU38sfJ3eLxew9lgKq4DFClRYZRYsaOyTaqamAqG4LLty2y212PIYMQ4SYDGFLUJatGjRosV6YCunyiyC9xIKdcyClYQIoQaBWYqGtBgyozElXbI8vwoIpkUIRRX6NII0mCG6SmCgo+SSzfpu7jJHE4fZDDTrh/n5cj5oRTgwEBCIgYJgqk4kOLgKh5/xijP93if+4e+BU81xfv31+/d0dz5v19M0lOIyrYpS+44S3TnRIhM9LQBJ5OJ2Zt3tPlfTf5x/PNpUoimdAKBMbSOBNEUQjx1Jqk/cHSS3u2xPPrvdZ2n9OizG6lz2Jt9iUYZMfGFqMWhGa9ZugJrWHVKtMbXH7HaKV1XR0LL2Fi2WhcAb9PLrtWjRokWLKwNXkOIO4EU3/ZBCScKCgI70iQRDSA8KTCSaxTmoSI1GdQsGjQ6ZaJLJnffRGg6LPVkBdQAMAhSh/0T/MVhUo2M1rKWEFagZvIiX7G0nP/Gtz3z2DTu2O4KGvzv3jx/8wkd+6IX/srTSQiXpSJLK7qOnhXQpwga78u613e1A6gVrZl/pn5uv+lbHugsQyXbdNQnCwYuax2OX71ydz3TFkyZ1BCWH+isNy/ZLrDIx90Lj77GEQGvWbkDTIVVNo+geTCmZmZL8Z22T1BZbGiMo7jQxp61PpkWLFlsXL3qFK0qqSQgAUkUcgNMPbPaRTSiuLOIO4IU3/yBMQcDMJ3YuJD3Q+GckRSIirlCz58TOCROkMMjInn1jcE+2eAPgoI/OnwlaNWZ3gwpgUDOTWpMm1GCZ84z/a4BqNK+nYPX6wFyTHVMXoWbOPW3mKi8DQ4uQNO2F8nzZP1v1FtLu9GFLzcg9OeOyHT7f5Tsxux3R+bNwfXKYoy9jmAEWdEgFk0MmsnYzq6Lonli7hrgWSXH/7GPv3pCPvUWLTcOaiXvRrVwl4aGPjPd4WrRo0WJyIC+4S3Ofn59vlhQwB4SWuF8EV5BVJuLTD/7YC2/+ATMAEmKbIDMfu6Qi9maKnJTJOWMUxp6qKYLGUVJ8iiXuboDSBIheGlpUrN3Ozs4zvUfNUuMiB2dQgZBmNDGAmgRri/EyEEDECYk0PEgZMm5QTspUUUp5cnenExcHDBjwbJn1+TafX4cdPS17oQyqlVWo2fY2lznKrPMz4ptcmvguYiephZWyC14sWlgvSqx9ka89xsuExNqTPaYyS12tzA60rL1Fi4vAQFe4kIfLr9qixaYim/vGOqBgNX9mSlKtAhG0wJ/+wXocW4vJB1Wzc73hiycHV9aj8grFFUfcAXz6wR+/5aY3E2YUNRWaxiJJs8BkCYkOeBAeUBjB6HdxoAI+dVdFrP2Mue+EJSGZKcI8l2xXZ9cT/SfQ6NwmjPzfDDSBA4x1RWl8kTo5MZa9piLUWgJns+T62as64jGUQkPWewFpRmBG8m0uH65bHV4tcvSGiA9z9GEju1kdFwOg7pY6iMus89phTZIMDAtYuw2qUY0wE2ca7viD963vx9yixRSDgIlKONlqTi0mH8ZBHsKKQTGrvMv71TmPjnz1IT2boe+qR7rAr63LYbaYSEi1TBmPXHl+kJVj6+e4L4vPfPatIGlGSjBo6quayijrPk0AzGBqbJqqRh93/SK2WR28jr4SG9BsmfEzuzo7k/smRq+TRN3olOKQOjcJRehIV/9X6r/q6g5OktJfmDn/1G1X5+IBCmulnowHZjV1b9LeF7+uV2v8MEOh7M0bWdxlaVHrpcVtUJvyU5iaBk2WmFiHWkbWDgtA1dkGkZa1t2hxcTAyobINk2kxHTBCxVb/A7EQcs4IBYTfUVWPdP1Tz+b7XrbZ76hFi8nFFUrcAXz6wbcKGUNiggGwYNDa6aFqANQQEklN5aUYvKZFKm+R5tJIEAoYqQQZObTMZjN7ZnaLxJLXujNT3Wk1MnJh85ParMqgFWtKiidIyK7OtqfO7vb0kYjXTH1xzSjqhXVO45AwP3QSDGx6Jw1z9GHujsX9lVinPcZi29SAtg58hNbB7Y2jPea1BzPtzCJU6vOxf5otWmwVpACnNgKyxbRgTNKoKTWfOyO7+lDmX33neLbaosWWw5VL3AH88YNvxYC7R0+H1spx4qN1Rkok6/FFtIcgoMlpY2q/Gu0wkcIn2RtmzF1+zcyeHfk2oQOYEtITRxeh44C7pxpUiXb3VBpKUrbnMzdsu3p3vq2m7LKAghsXyOH1awwtRBpsDBZi8QrLLGyGK4MlMTEmDnVSekxi6jVftzKJ7laaJp9MZxahgvMH2/DHFi2WQxPC2rL2Flcu1MFoRLZvxAYILVpsTVzRxB1D3F3pzDTE7EKYpfhCM1iAGSwoIjvX5HevayyBYAOTiS55AYoCIrI93/6k2Wuu7u7sug6SlL7Ax1JDQEHy1shs1rl2ZsfTtu3Z09npxWNIYh9m2xbt9gsWsuHci9bEEClvRHcsJ7pj4cppcAMoap9MbWQfqOxAU4daxmpU0lrW3qLFxUHAhDHFtWXtLa50kBBqUeGGl2z2obRoMXG4EotTF+GPH3zri29+s5gaBapBREwDBSlkJrUr8kAwgiYxzt0oQCBQj35iQIxLBBdCRj4fS1oBgBBKlzMzfoawSstKSzOttBzkOQIEus5llI74rsuSUSb+PRALQVG3KiUa1l1PsaeV0jKDsS4wtWSYMVu88mA7zfLhKtW4XFNXVFOrhw11jAzqsPY01EkxMhpiKg+FoYTLWtbeosUSWJyXo5mRxamWtbfYCrhsJogMP72WgIrQ67usjVVq0WIxWuIOAH/84Fu/5uYfAAzizEIgYSqAGiACI2FKwCCgRjJMC4AzBpqAwWJAjBmodUqM1kTcQDWTmD/DWHmG3Ocdy2Nu+sIYeMSFLtnS0wBgKcnGQmJtAIzkYiq/7IvFC2tmv5C1N6uk8BhL+zaNBploJTILsTbAmipVVdNgCkpsOHXoRJv82KLFIlBiEbwBtOLhNkCmxVYBL8/czaDGKviuK5TL+OTzbdu1Ktfl8Fq0mGa0xD3h4w/++Ev2vxkwEacaQDDyTlWKaK1vB8SgdkQ2HQhvCDQHhmRhMQdGW3yMY7fE4AevXRLZBi51q2V74yBMXVOCJEASNjQMwEA8TwEUC3j5Qr28DnCsdXrWMny9mfgiin4LtpNe25AxPqnu0SQDNHwdZnXgY1Tcg5lzXlUBfuPvvXc9P7oWLaYGrL/sdWgVBOydPr7Zx9WixZhBonj4chf2c+7yDApmUpW6hI3QkDvsP4CTJ5b96+7c4fgwSoZQpiYh9fNNij/73TUe/XPucgykiZjBhEaYo50/teRIXvQKV1aiKlWoNbOUoKzeGRnyDH/ym6vdu0ggIRK7iKawiORWBRSKP1tyJKvBthvvrNRgVEXdYrGZ97fi86sREW54iWQ5HcV51rQjMRSzWPbX+/NWlRgnWuI+wB+dfOvX3fJmwMRnqEoFAI35jpH9KiKzNjEEEmY+rmHJSxNXEFhI9D2J7hFqyfQyzLZZvwbQkOzh14ssK5GLLyXrg/+tE3WXau1YbuHw/2JoU+moDLHvK+sYGTbZO7HLa3K913K7mZoGWM4saBCRg22XpRZXNuLTsC56GXD3lq+3uNLxFx+ugG37DgQToaotLrqrOsGVXOyWed6BGO+gqISeZkoQNDMKTClQgzeq23vQSKXg87+zdOfZvoOLyrmitd4MQcsyZLmUIGhUIKeGhYfn5+6g0eZ71UzXX+ilJ3tshmgwoVSh2Dbj53v86jthKP/scuT1wAF3TlgS81WlPstKgsaUO0FGHiwBlafDcw6YaihK/N0fLbuxfO5Q8zxvHuvl6eP53m8ErArmHfqVCV0kMIwanVMLcE95gfXP6yNfuPTxdvcdUjOtQjXf8/l2iFFpNFgk8CYiDEEF/rl3mFmoDH994jInocUK4Db7ACYLf/sPf/CMp36DmOa5rzQwNjStY2KAlBMTx9MCROdI7GkaxXFJbnRGXZ71mnGhDEa2lPpVczNolgyHNtYLWf/n4F8s8L4vuPsMXtf/DP8Jl/5JffxpaI9E2VPwZWTtDUGvwx9jqkxIlakaU2WU8N1ZNXUmd/7eu1Z03lu02LrIrnkWAAL908fDV74Qf6qvXOah2KLFtMBd86zFiwgAYWUXeflPf+2vfabagodb2nJJEPpPf9Us6czdSTCYeRGCBq0D1eJTkvGflM9MC+JcULfn2UtpqNvzLAg4JFaJAAonqhAnOqREM5gQFr7yVwBmbvxGd82z4ty1KF35/7d3b7GSnVdewP9rfbv2OX1zbOf4MkNicNtxn7ZnxMw4ghkUDT1xdxtrGAkQA4h5GF5AghcyYiKekFriYUQCIkhIA3niBV6CxANEJnbb7hBbhFGahHEy7radZMYh8cTutO2+n6rvW38evr3rfq7dvhD/f4ns6qpdu/au03W89qr1rZWBqXrWqRR2GmWrXwa4pbseaO75RHnzu0vfhH0PHrNs+SMcvNMYmFLYZF99RGBmhmRd57l8/Uazutrc81C5sGSfae3wXGwQOfvt9wE0TwAjbDaC6FKCBrP2YPnBWb/357j2MN7+48Wdrxw9ke46TMDNaNa0rdlUnFGDDANAusHMHaNhpIGnu++PC9+f21taewCTGGdih39/PoQUuM977fXnH/z4r+ZSHKgLxmpsze4bOJsMiev/nnn/obWpGNnGOXVjPyQJ6P929qF8DbKnP10GjEtobDqCt6mXm3wg5/493sls9D/5NE39Jpr6iE3n+etXj12yH+N+7XUk6iR270pi2A9XymQwaObmIH0weOyr/25X77zIT6V84XtZkbr89LrJwB1AvvD9tHZ4sc2dOxBWflJDvVNp7X4Cqd1I3TzxbRgssSaAmdYOz8Xuae0wwqbjxQhrYHmTbnuExYXv4ZHHjUxuDE7913uro6ivYSkVIu5dxxuvzG2xeuQkDWkYfq2px70TqW0tNWCku+4vS6Lh+6eKYVErBMq1YbOv3Xb5gRnSXQ9krKbGeXF+zyvrJwj2o+N3eLCWGofTgHTXfOyuwH23PuztIJd65g9+76tnP1frWLwZgMxRgsHa+hBRAt2IUKBrHAmydkUkgjXARV2ySVpBN4qVsFou3zd9n4xz6u8cP9p3YByvD8Vcp3Yb3168sbQ1ZF8JONkyJv+sfexRogblk1R6YdTM+rhZe5l0aueILIxRRGE4GhDBOPnVL6qBjIiI7Jj1XZQnInySIFv7k3Lhz/r+d3YaK/a8T6oP1k/OPMD5/ThL2Tqq/div+HA4Mi95/lC3xVJyanwwxLFj0/evPPI4jWapNLsvXWbUMtZm/dPbbWrlbrYH9y+e9SZ75spqY2bNkRMz9z98rCBqYdL2nYNmORyGiIQHn9jdM2WWAvdN/Y9vft49IQrMiERG7pulBEvp1mJG30GFBV3FCBEF7MP32hsR6EeKYioijz6YxlyQzXFF7FSw3m8W0zH65Ll9aD71KDDZ8/iXXXC8E+vjddbSl+h/DeRJyF6D9Shk7kYpRWHkiMLIXbN20qxd3Q+HIz3xvJaiiojI7ixJX3eNIbD68HHf/87g6Nc2S0dvHUOaAeaRNvDoo1tsRvMtwloj02AQ12+0ZXmPSi7cmNPmYdw2aq5Mv8ap8vadSB4LFy07RSPIXLbteb/y+mCnyfy6YwDuZjNnk+jZS+w2Zp/s1Etp0p5PVgAocN/ac2d/77lvfg40RxicYGZ0mfVgjEN2jtPtQTAHglEQtRZ8PMWpX9M5zmrX3pGTMBqTXPtMvnwqAW/Tcfn0Zkvy7pwJ5ceXCjXtPllL2k2YqlOTuv+PC9brHKXSJdpjNDUMNffhO1Jj7iXn1LaPv6CidhER2b2YDyvDuspREs3BS7YsrCZsOFihWVx7a3judGNpaSrYEGX1io9WtzqAJbuvlaRMtbuL+8qB/YvbkKjHwK48xRzNkr2Rqz9OyJMHfO1P8g+PIC+/EnC3Ia8HS7gPD+zjJoU5Di83hqkdbHVqNcKfOmYDGPRufZ4t/R4j+fw7abCWg7lNazQyjBx9Y50Ah/2M+dmno0157mJAdkuB+/ae+z+f66cpGcwzo7DU0LzOGAqWWkNCss/Kox8pCoIlWMYJeHTF4mS3xLO2Vix9YN3l2meT7uM7Z+P7SfXLeEvM1tiMK2FqcxhO1cPU4a+lj+BL9+VAlLpBH7J3KXYyE4UcReS+PIZmq6v7HAjY41/99yqPERGR3Ro89FjXs2xWsibC8dCxqF9cz7PhgX2lSV5Kbtr82tnB2gOjS687rFncFzC4drvFTtf1ERhGDtZkFwg44E3D2aiJgFuhm5ecm3Z07vTo3GlHIgI0LhRuR5jfmOzBVq4Njn5t8XrESQNy5MYGGcO8b8VHI6YUBCMtnlp78AA3Lu3w1AAO7x2VQZ052c1VNHKxiqZ+EY/DxycHzMW5WdY2BMLNM8vw3OnhudMZ8DrwJi284UZXxv3mqB3kjjz9rc8DOPGLnwVJpLAwBgvoNoAVOBENrExWqNcPgw0MmUzoOiR5F/6joFvzWiN7x2T9K4FAXRDfdbOxOscIwNRC0nE/+Pr02vR9fMNA72J6Wp9ot360E9BdC9eVqUFi6n7rhqHWho9E3/+RfR1/vT2wBEPOeTDQSFQREdmTB58IZOfsQlEAwMaGp8RkNorS+ny4Mrx35JctVlbGjdJHF74LYP+REwVInK8/MZqNVvDgE3j1yS0Oh6jZ6S4Sxfkz44faI8fn4laDBa2xcmNq5vGNc/8dwODoCbBPwY9NDYw98PCxHG9yoQkmI8LMyXz+ufGdNak3eOhxQ/HCSDPvFYH44bd8bUnPlvmdm3HAdMXyRwvOTJ/apH3ktJyRmpmOnLPnAzPmYm3Dq99+dnLvuWcCGDzyeJTA4jcZu1ukIPOUcd+Fp7/5eXTt1Y1NUxek5ohSS96j1rvXEhrmAFHL4pFRF7bWUvLIYBA5ujz3eG1oYV9LQ477o4+nS5RuzShiqsCmK33pM/d1UWn06fxJRh+Mbr1pt/NxSUyZ5NrZl7Azkzm6KqAR+3L2iLoU1dwcVhgI/BUl2kVEZE9Wj5xsvJRoJs2Se0Y0KZdiBmsXEre0SG97HBoujje6dv7p2ilyMYWcd1Bg7TBeu2jwOP/s4pyjuXIeA8PSjWbf4n5GLz1tsdB2ZSrsL/TG5w/GDOZO8sb5JX3fRy9/xcliPhdjGzA4+mlbObD1qdW+cTby8o3npqN2AMPzT5vBF64iVval2eup+fc0DCVw9dtLjnbjO1/pc4lyKynjvjs19f7EJ/8popg5zQpHpDe00jV493qJ7ajlNUZYAxYYabVrbJ3Y1BgLzAmDFbBvFmm1j2TNrEfQbJxE71pMGuFWw32kLj0fRrihdHn3+vUeHChR+1Fi/HkzcjzaqW/7SOsWzrL/HwO0vi6//hEADFzdh+EwOX7jeU1WEhGRZVhnAG25BRCIBu5NXnw4HE7i1Sdt/bElvVBovsEyG32O3Tj/1OBn/nZz6M1iM5HoSsplu7YqG+eeTmuH8w/OLjnihSpzArkZpFHGQ4+X8MVcvudAk6a3Hye2CRvGwOZicE/GGJ57Fpu48coz6RMnSzRtM5q+32B+6O7lxfLjbQykjV56eumjcblNHxli9lIiyOm3sMYS0/VCoxtc+C5kGqcCHLk1FLjvxZPf+BcA/uovfRYshpTM+/Cd2WthDAbwErVor5bQEKhD0OiwZCzsmsQTTH0oTTDBHCxd9E+YeR+Ol1pm113Dsh+c3tfSsBbDoHS/5PrqGsL7Snjv7u5qY7ryPRB993ZObo+z+GRtW7uygpyRc7TtX1OWXUREluoqMbdWRxjZ8oYqhvEgUl57G/vvmMt0GzE8t9UsUg73X3/5V9v152efx/lk9fzTrPn4o0ujdtRVqAv1PO1oA2bDaBrPOPJrRBRknH8BgNV56fWfk0qUcYc361bPTb9CCUvbhLmFqfE8V7LC7d5zq6Wzi/3Sx3sY+o0/uqNdf2vmzshzu2WXVzQAEfSEWHLZNX7ROkp1y/ORXVLgvnf/7X9/HsBf/6XPksWQUMP3MJolIIOpn3ZGIsHql2puZogCC7C++25GogEK4KxfZdWku0VX7lYHZXX17QSMtWSHMRngyrr+vm5h6JaQ1Dx937yJgW4fjlrF3vW4JUnUrRikoWuGA9Dc0upq5Gw5o2n+hkJ2ERHZxg46h3CzzWzYtCly/s5XcO+fy6+dbdePzz2RQHvksS32HdfeGdw2H3+Thi1bmtAsHbxjs0A0Lr+RDt29uOQUZNuMQMDSkMMGra+fAGBItd59qelYvr+H7CpMtvTqk3bkuM1G7ob5i4D5gzcYsXFuebodQH5zX3Pf5WWPTHa7/GLpkcf96HGrAczcEzhuriG3jAL3m/Vf+vAdLDCHGzmOeo20ZBFm9beFwxpgBCSYA6Vr78h6u4u6zZxwMIMOq7l2AAGmGtxP1qF24Xg/JLXr6m7EuN7GJtv0N1hXxwaArkKmC90DQDDqctVaaWcMmEfOrpBdRETeA2ZNyTk1ALw5EL9wDDdmHqfRFnsNzvL979R9zezYl/QonNY2Zfj2G5s9yo0rGz96cbB+fHkG2QCgtX0AiEgYBEs6epJmkRq8+OX5vS1kyLlN7D3zUjSbK7NhCxw7hk3Kh5zbRtBf8v3Ht9lk4pR/9DVbueaHLrCUnFJTRkCyvgTXum41rhr3W06B+61Rw/e/+cl/AtIMqWlKzqVOXqIl48gsETBkWm0uWXvCONB0K02tAWFmwbDxnUw1pjY4ADMDSy1trwX1Na3OGspHvdP6/jSTwJ3sm+GOu2QRfQMZ1gv9PuluZpa8TpCC+d/62hffr3dVREQ+TDhcLc0oeaQa6fqhe9qr810cDVgsWdnR3rcL969++5nB3fdv9mj5yfft0K+Nzn1q5ejzW+/JYIEMgwdH7cogj9LREw6/9tJMNn2+3GUHp9BtaV2/xWn5zoKlGXMAtzTv3Rw9yUvnyg/XB0deMKPB2lKTipP2d+NlcbfuZaWjwP1W+s/f+FcA/u5f/GzUJDsJMwKFEfWbLCKZBa1xAAiggY2IZN3QOO9bQ+Y+rY5+ZSrQ9Xb0vn7Q+8Wk40aQQHSXt6wV7XVLGhG1mLD7WLFL4tctDSSTge4WgdoU0u3vPK+QXURE3nUkkEAwZcuDgm91JRlerLi/Z/Ffc9+jo9eWF7hXvPyX/dCFjZc+NTj6/E7mCJnVIng4Ugm2D50cvvzU5NG5jbmDtHi/aXH6XI+bHwGrO21Uv2e+dphXf2K3oT1U1w8oof5eU+B+6/2n//X5euO3Hv0doEbG5slyoYPBaGA54IYEG9GSWZCNGQEnUr+UxfvRql6/5DKkvkLGYV4LWvpWM12RDBhdkRlrt3jj+Jq8hvhR62Ksyz1w4KAbV9rYGBlJ999SvC4iIjfBdtJsmoXAsLR49cnmvkdt/x3mnr99emaTmmPaU3592WFZ33RtOd9/x3a7OBWXT/naa+XNj8aFaI9eBMZzVjZH5G4kUwyOHh+9dHr5ZhY7vkKxJQn62AcMd/j8vUlrh8uF7w3WT9iWb6O8qxS4v4v+49l/XW/8vb/wOwyawWgNBsSotmyHmXW1NF2KPcFIulnUCB5hsFpUYyT61pBhTOji77q6dNwp0uqK0rosFug/XTVq71rCJ4NZatwZJWqlXC6xMvhtVbGLiMhNMowLPDdFEhY0v/rDuPPBvEmem+6pFM52eSew0PZ9Z6IsWVq6a6fiAoDfTGvX41KLg6M8QttieTA9wbp4My79eOquPZbKgEhM8+n5j13HpXcxqGvWP41rb68cPb5lxVG34tjp5pGLmc/X4stNUuD+XvgPf9BF8P/g0d9l12ydXUN2YxgZsIjk1jeAjwSEwWFuEbDU1cyxW5lKTo9KretUHegXqnb1M9a3ejRDckeYJbcotdFkEO7pt1/4/ffvjRERkZ9Gho2Xntp+s+3ElbV856V2tDF7t5Ox6wi8Jsu2zY7v1JfKBQDA4eMpIQJYjXxnGbzRWnCzINyI8sMX/a4H4s3vYrFUJrZpejPZErY4X6q5mPKdm7dmvGkG4/7bl71/RnIAK+jGxNQ+nwxzq6GMAvdbSYH7e+qLZ//l+PY//ORnrF9aWrsuIiUGi0UiComgG5w0WJilrtmLpb44vbvRl7Nn0MjGunp5h5vBvYkyAsjaMzZonv6+gnUREfnAi9FBvHgEs+3YPTLNN85tUnDSa4/0PVImEa7tNVcP/PyvDyKMbEgEjbCCK999Ct873Y09OnbMr6ZoiwXynaX9cVrawHzw8Ml453WMl9hOBcLm4M56nnPJMCjYEJu1lLkFjh3jLFnp1QAACBtJREFURfoozdUFERjlZuC5GBPs2uwPpT1y3KzMj4+Vm6PA/X3z+9/4wvQfP/PLnwFJo7PvpoQuQ5BSYygE2KXeK6vtZQBrADZELnXKs3ef6NqPMjwN/tEL//a9PTkREZGb9safae57cb6kxHwndSXds6ajdtu2r8ymUuSRN/tzBgA3GzKnWFl/bGPc2vzMma5y5dixdMXK6Lby6p9fOfICZ5PoVko6dE9BPanZIJgAufqJx268stVsKTx8rLasm47duaS95K3UXPV8Z7R/OlP+RNjo3pFdxOjaYHFqbN3kVtQmyQwF7h8UX/j6F5be/89++R/3vR+7K/GY6jbDWi1jtIA16XefV5G6iIj81Dhl+xf6phtAm+vQMq+Lbmc60pB77CMJwMg2b+TxzgawzRalnjlTAOCU3/fKxsHV9ur12WPvqnWc3X/ap3kgtjvAFJ69tDETv9X+kDs+m93LWH2jmVuRahZdfc4fLvn2oz16gtsOdJXdU+D+QffPv/5v3u9DEBEReX8w3HyhapzOLcvBE2t0OxcXp9hrqYzXrs7TlwGwaGPzmUen4raT6RoXFq1O/jiA5dnzKsksMHjo8dHLy+en7nvwWCaa0szV1BAWl9b2cF475BupLNTxOM2GzMtOv/3EcQTNN726kT3bQcMmERERkfcDYcM8n2Skk4PwT34ax44tPsXX7sf1yyucf9Zo3wp9j2FP37RtRr4z/E3iY7+y5AmPPO65lDKau+Soi9oApIWoHV1Qn2AxOLpkiGn70Mnw1JRYiNoxOveXONy/25Paubi05j7fJJ6EAQd+7rG5+9NH748bFxFYGrUHiIePvUvH+WGgjLuIiIh8QJXwgY/meicaiGxxsKSLK1j/jeKr+KMv4cEn3DOuX4wfnB2sHV4MGpvrN/K+1b0dRrinhW6S7euD4dUraf8+PHKiJMMfPgUAP//rHgWMSE272Auxn7xy7fzT6Wef8NuGc8tMzUvdpPmFx2KAOFBw5q700etYKbQRmEozX+JvBr//O/H9R/Z2ajvBjf0b3znSzq4SpqFpMCxI64+VC/c1SNZeRfPy6LWz7drhJetnAQDZi9PVB37PFLiLiIjIB9WrT/pDj1lBzCZ8DVh5vQFiI602cdmPHA/mHE1z4COD9eOLmV5GGA1n/+vejoJmN9rV+caUxvbgQRiGyZpR+PpxAJGHuWkHuTSxLDrtGjsDAIdpdO7OlfW35o7WCANimOL2YXMx4b7L+bVD7ZGLNIct2edw/740uAyc2tup7UR58+PNfS/OtcEBMMzmhhGYDl7Mf/yLq+tfJ25fWT++xVLZQQyIaI4cR51L8+4d9E8plcqIiIjIB5cRZXVJexIaaGzjLUc2wJ1tM/JlbcON4PXbb6beOqcm5dGyHRBkO4zxqzrZjjaWN4wnAY7X1MaFfc3PXmUsicQIWET7p40Pzffndv0t2PJJRgFLN4ZlMNjrme3QKbQXF1/fABItLK1ebdefD2Qu9KKfvywBHV3fatW/74ECdxEREfnguvHKM7GCjXvyFoH3Vg3QzTbOf4rXbh+9/OzeD+LFL3sE2703lIwukz7tS34ww3Y/TKpHwkgrsedvEnbxWhHDK1d2NiFqIpy2yXNiswdkSwrcRURE5AOtHAy/7Gy5ZYQ+jwCJ4T0jf+Cl8pP7ph/apAB7K6Pzp6Pl6GfyXhocGg2k2fD8TI/24ctPmYNBy7utGbFxl5d87undH9COX6Y/2zIc+r59G+3Kzp/LCAvYFqGm7eUH8SGnwF1ERERumXclEDtzJs4+60OH1cYwO8jVEqPWyyr9ssfHf7xYAp5svk3KtuJQpCteVmK4mm0HjdMNgHF4I0emGZdG2BsvnbbCAgxv5P45W2HfaSdogI3ObzNB9mbMvEX/93/G6j4fjobDHfyIjcNzd8SVFSNILi3yGSfc9/CD+DBT4C4iIiK3DN+1GffD80+7gySvvTU8d5qObhiqwVgXdZIRw8hBhiNlBlOcfXax1bqbE7Hrq4wzZ8o3ni2INPK8GqN7s6MJGqy2lbduVCgtEKlxGCIzNZZHMXxp03moG68+m3OkxqNEhA3zwI2g9eXi7Oaok6lxM0SYe5RIo/Nb59q7yHjP5T0k3aYCxRe/HKNICflKMzx3RyBA64a9gzS6mxeCjEttWrtefnRweP4ZA0HrOs8bUL81KUDAbK8/iA8xvVMiIiLy/xm/67C1B/zQ3ah1KEYABIMkESBePvPuHsGxY82VBiP4hrGL18eBKc0MhuR+/dubj3dd6sEnGi8A3Scjn7qrEjcDLO1+n7feb/raNWvDDw27gzSY1UsnQ/DGKzNXKfuPnAh0iffufAALDF95F78uEBERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERGRd8H/A6UHmLzmIBUnAAAAAElFTkSuQmCC",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97644 0 0 .97594 -38.322 87.774)"
                })
            })
        ]
    }));
var $89f8912dfe9250e1$export$2e2bcd8739ae039 = $89f8912dfe9250e1$var$SvgProductPersonalLogo;





const $abd4a3f412a40f06$var$SvgProductPlusLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 112.5 37.5"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__a",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M23.945 2h87.567v33.559H23.945Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "ceph_logo_plus_svg_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.492 6H26v25H.492Zm0 0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__a)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__b)",
                    transform: "matrix(.18873 0 0 .18915 -.627 1.514)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 600,
                            height: 180
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__b",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 600,
                                height: 180
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#ceph_logo_plus_svg_svg__c)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    mask: "url(#ceph_logo_plus_svg_svg__d)",
                    transform: "matrix(.12952 0 0 .12952 .493 5.57)",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 200,
                            height: 200
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                            id: "ceph_logo_plus_svg_svg__d",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                xlinkHref: "data:image/png;base64,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",
                                width: 200,
                                height: 200
                            })
                        })
                    ]
                })
            })
        ]
    }));
var $abd4a3f412a40f06$export$2e2bcd8739ae039 = $abd4a3f412a40f06$var$SvgProductPlusLogo;





const $444a29ef95e42a89$var$SvgProductProLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "proLogoTransparent_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "proLogoTransparent_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M13.668 119.082h885.613v259.086H13.668Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "proLogoTransparent_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#proLogoTransparent_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#proLogoTransparent_svg__b)",
                                transform: "matrix(.98767 0 0 .98842 -45.894 86.29)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#proLogoTransparent_svg__c)",
                mask: "url(#proLogoTransparent_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.98767 0 0 .98842 -45.894 86.29)"
                })
            })
        ]
    }));
var $444a29ef95e42a89$export$2e2bcd8739ae039 = $444a29ef95e42a89$var$SvgProductProLogo;





const $581166daca419b3f$var$SvgProductSdkLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 1200,
        height: 627,
        viewBox: "0 0 900 470.25"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__a",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "sdkLogo_svg__b",
                        width: "100%",
                        height: "100%",
                        x: "0%",
                        y: "0%",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            colorInterpolationFilters: "sRGB",
                            values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        id: "sdkLogo_svg__c",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M.715 89H899.28v291.762H.715Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "sdkLogo_svg__d",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            filter: "url(#sdkLogo_svg__a)",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                filter: "url(#sdkLogo_svg__b)",
                                transform: "matrix(.97345 0 0 .97345 -36.738 88.73)",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                                    xlinkHref: "data:image/png;base64,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",
                                    width: 1000,
                                    height: 300
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                clipPath: "url(#sdkLogo_svg__c)",
                mask: "url(#sdkLogo_svg__d)",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                    xlinkHref: "data:image/png;base64,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",
                    width: 1000,
                    height: 300,
                    transform: "matrix(.97345 0 0 .97345 -36.738 88.73)"
                })
            })
        ]
    }));
var $581166daca419b3f$export$2e2bcd8739ae039 = $581166daca419b3f$var$SvgProductSdkLogo;





parcelRequire("7fPBF");
// Todo: Add variants for different styles found in images/icons
const $7de7807cf4d66fcd$var$SvgCephy = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 500 500"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: 4.82,
                        x2: 282.2,
                        y1: 407.51,
                        y2: 247.37,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#062844"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.34,
                                stopColor: "#693b82"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.68,
                                stopColor: "#a3417a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ed486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("filter", {
                        id: "drop-shadow-5",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feOffset", {
                                dy: 10
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feGaussianBlur", {
                                result: "blur",
                                stdDeviation: 16
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feFlood", {
                                floodColor: "#ed486f",
                                floodOpacity: 0.75
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in2: "blur",
                                operator: "in"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feComposite", {
                                in: "SourceGraphic"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.cls-4{fill:#fff}.cls-5{fill:#141526;mix-blend-mode:multiply;opacity:.2}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: 'none',
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "Layer_1",
                    style: {
                        filter: 'url(#drop-shadow-5)',
                        fill: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M319.91 419.59c-14.31 0-33.03-10.47-50.06-28.01-10.08-10.37-15.94-19.86-19.85-26.31-3.91 6.45-9.77 15.93-19.85 26.31-17.04 17.54-35.75 28.01-50.07 28.01-10.87 0-19.47-6.08-22.45-15.87-2.5-8.23.52-14.87 5.39-20.64-9.53 2.81-20.54 4.62-33.22 4.62h-.86c-16.93-.11-27.35-3.21-33.78-10.04-4.19-4.45-6.23-10.1-5.89-16.36.73-13.84 12.67-18.78 23.19-21.01-16.35-6.01-30.87-17.39-43.37-34.03-9.09-13.12-8.6-22.74-6.64-28.56 2.21-6.59 7.37-11.68 14.17-14.02 2.08-.76 4.28-1.15 6.53-1.15 1.2 0 2.36.1 3.49.3-1.1-2.94-1.81-5.9-2.08-8.87-.76-8.09 1.79-15.76 6.99-21.02 3.83-3.9 9.45-6.14 15.39-6.14 8.19 0 15.5 4.12 20.04 11.31 9.9 15.68 21.42 18.93 30.67 21.54 3.67 1.04 8.05 2.28 11.76 4.7-.47-11.87-4.6-31.51-12.68-65.74-5.53-23.44-1.94-58.75 18.57-84.79 11.92-15.14 34.44-33.22 73.96-33.41h.72c39.85 0 62.55 18.1 74.57 33.28 20.61 26.04 24.24 61.41 18.69 84.91-8.09 34.23-12.22 53.88-12.68 65.74 3.71-2.42 8.09-3.66 11.76-4.7 9.26-2.61 20.78-5.87 30.67-21.54 4.54-7.19 11.85-11.31 20.04-11.31 5.94 0 11.56 2.24 15.4 6.15 5.18 5.26 7.73 12.92 6.97 21.01-.28 2.97-.98 5.93-2.08 8.87 1.13-.19 2.3-.3 3.5-.3 2.25 0 4.45.39 6.53 1.15 6.8 2.34 11.95 7.43 14.17 14.02 1.96 5.83 2.46 15.44-6.32 28.13-12.71 16.93-27.32 28.41-43.71 34.46 10.52 2.23 22.47 7.17 23.22 21.02.34 6.25-1.7 11.91-5.89 16.36-6.43 6.83-16.85 9.93-33.78 10.04h-.86c-12.68 0-23.69-1.8-33.23-4.62 4.88 5.77 7.9 12.41 5.4 20.64-2.98 9.79-11.58 15.87-22.45 15.87Z",
                            className: "cls-4"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M418.78 276.51c-6.93-2.73-17.21 10.65-33.08 18.9-14.71 7.66-29.99 8.79-45.62 2.87-31.31-11.86-26.87-31.73-10.09-102.8 8.53-36.13-8.4-101.46-80.01-101.46h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-5.81 1.91-10.15 8.67-1.22 21.58 40.62 54.06 88.48 24.86 91.4 32.18 2.32 5.34-26.67 19.11-47.86 22-12.03 1.64-20.33 3.68-20.66 9.77-.49 9.16 10.82 11.95 26.16 12.05 56.47.36 74.38-38.5 81.13-34.58 4.07 1.98 2.26 7.41-3.32 16.82-14.47 24.39-39.17 33.63-36.18 43.44 3.91 12.84 27.49 5.22 49.73-17.67 19.49-20.06 20.91-35.61 29.61-35.61s10.12 15.55 29.61 35.61c22.24 22.89 45.82 30.51 49.73 17.67 2.98-9.81-21.72-19.06-36.18-43.44-5.59-9.41-7.4-14.83-3.32-16.82 6.76-3.92 24.67 34.94 81.13 34.58 15.34-.1 26.65-2.88 26.16-12.05-.33-6.1-8.62-8.13-20.66-9.77-21.19-2.89-50.18-16.66-47.86-22 2.93-7.32 50.78 21.89 91.4-32.18 8.93-12.91 4.59-19.67-1.22-21.58Zm-135.01-7.34c-6.04 11-18.83 18.63-33.78 18.63s-27.74-7.63-33.78-18.63c-1.27-2.32.61-5.03 3.57-5.03 0 0 14.59 6.53 30.22 6.53s30.22-6.53 30.22-6.53c2.95 0 4.84 2.71 3.57 5.03Zm52.51 8.89c1.89-7.85 28.72-1.81 48.22-32.68 4.15-6.57 11.54-5.61 14.23-2.88 5.97 6.05 5.08 21.17-15.85 35.65-14.63 10.88-32.21 12.18-41.32 7.91-6.93-3.22-5.27-8-5.27-8Zm-172.59 0c-1.89-7.85-28.72-1.81-48.22-32.68-4.15-6.57-11.54-5.61-14.23-2.88-5.97 6.05-5.08 21.17 15.85 35.65 14.63 10.88 32.21 12.18 41.32 7.91 6.93-3.22 5.27-8 5.27-8Z",
                            style: {
                                fill: 'url(#linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M110.52 306.85c15.19 8.49 40.3 10.26 56.26 5.29 32.75-10.19 46.72-36.6 29.87-113.5-10.6-48.37 8.19-100.6 78.54-101.43-7.53-2-15.89-3.13-25.2-3.13h-.65c-71.05.33-87.86 65.44-79.35 101.46 16.78 71.07 21.22 90.94-10.09 102.8-15.63 5.92-30.91 4.79-45.62-2.87-15.87-8.26-26.15-21.63-33.08-18.9-1.39.46-2.68 1.2-3.74 2.22 7.07 7.46 17.66 19.46 33.06 28.07Z",
                            className: "cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M306.48 192.79c3.47-31.52-15.82-60.49-47.29-66.62-4.67-1-7.76-5.72-6.21-10.36 4.14-10.64 15.94-2.43 22.86.5 19.91 9.82 34.44 29.94 36.69 52.02.98 8.55.78 16.95-.97 25.44-.29 1.4-1.66 2.3-3.06 2.02-1.4-.28-2.26-1.63-2.04-2.99Z",
                            className: "cls-5"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M210.76 240.42c-7.64 0-13.83-7.71-13.83-17.22 0-9.51 6.19-17.22 13.83-17.22 4.95 0 9.26 3.26 11.7 8.12-1.52-1.41-3.38-2.27-5.42-2.27-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c2.04 0 3.9-.86 5.42-2.27-2.44 4.86-6.75 8.12-11.7 8.12ZM291.76 240.42c-7.64 0-13.83-7.71-13.83-17.22s6.19-17.22 13.83-17.22c4.68 0 8.79 2.91 11.3 7.33-1.31-.91-2.8-1.48-4.41-1.48-5.04 0-9.13 5.09-9.13 11.36s4.09 11.36 9.13 11.36c1.61 0 3.1-.56 4.41-1.48-2.5 4.42-6.62 7.33-11.3 7.33Z",
                            className: "cls-4"
                        })
                    ]
                })
            })
        ]
    }));
var $7de7807cf4d66fcd$export$2e2bcd8739ae039 = $7de7807cf4d66fcd$var$SvgCephy;





const $41158ab2c4dff680$var$SvgComponent = (props)=>{
    const color = props.color || 'currentColor';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 1000 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                children: `.st0{fill:${color}}`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M265.7 141.8v-3.2c0-30.4 20-52 50.1-52 26.1 0 43.4 16.4 45.1 40.9h-21.8c-1.6-14.3-10.2-22.9-23.6-22.9-17.5 0-27.4 13.7-27.4 33.9v3.2c0 20.2 10 33.8 27.4 33.8 14 0 22.7-9.5 23.4-23.9h21.8c-1.6 24.6-18.3 42.1-45.1 42.1-30.5 0-49.9-21.4-49.9-51.9zM372.7 155.2v-1.9c0-22.9 15-38.4 38.7-38.4 25.6 0 38.3 18 37 44.3h-54.9c1 12.8 7 19.1 17.9 19.1 9.2 0 14.4-4.4 16.3-10.2H448c-3.6 15.9-16.9 25.8-36.5 25.8-24.2-.2-38.8-15.6-38.8-38.7zm54.9-9.5c-.9-9.5-6.1-15.3-16.3-15.3s-15.7 4.9-17.5 15.3h33.8zM630.3 170.9c0-12.8 8.2-20.4 21.8-22.3l27.7-3.9v-4.4c0-6.2-4.1-10-13-10-8.3 0-13.5 3.2-14.3 9.6h-19.2c1.2-16 14.4-25 33.9-25s32.2 10 32.2 25.8v51.2h-18.8l-.7-11.5c-4.5 8.1-13.2 13.4-24.3 13.4-15.1 0-25.3-9.7-25.3-22.9zm49.5-6.6v-6l-20.4 2.8c-6.3.9-9.5 3.5-9.5 8.7s4.4 8.6 11.8 8.6c10 0 18.1-5.8 18.1-14.1zM833.5 155.2v-1.9c0-22.9 15-38.4 38.7-38.4 25.6 0 38.3 18 37 44.3h-54.9c1 12.8 7 19.1 17.9 19.1 9.2 0 14.4-4.4 16.3-10.2h20.2c-3.6 15.9-16.9 25.8-36.5 25.8-24.1-.2-38.7-15.6-38.7-38.7zm54.9-9.5c-.9-9.5-6.1-15.3-16.3-15.3s-15.7 4.9-17.5 15.3h33.8zM505 114.8c-12.2 0-20.7 6.7-24.2 13.4l-.6-11.5h-19.1V216s20.5-.8 20.5-20.5v-14.4c4.1 7 12.2 12.5 22.9 12.5 20.2 0 32.6-16.3 32.6-38.6v-1.9c.1-22-12-38.3-32.1-38.3zm11.5 40.4c0 14.7-6.1 22.9-17.8 22.9s-17.8-8.2-17.8-22.9v-1.9c0-14.7 6.3-22.9 17.8-22.9s17.8 8.1 17.8 22.9v1.9zM593.2 114.8c-11.9 0-19.6 6.1-23.5 12.8v-24.1c0-18.7-20.5-19.6-20.5-19.6v107.9h20.4v-41.6c0-11.9 6.4-18.9 15.9-18.9s13.5 6.4 13.5 17.3v43.2h20.2v-48.3c.1-16.9-7.4-28.7-26-28.7zM757.4 114.8c-11.1 0-18.9 5.2-23.4 11.9v-22.3c0-19.7-20.5-20.5-20.5-20.5v107.9h19.1l.6-11.8c3.3 6.7 11.4 13.7 23.7 13.7 20.1 0 32.6-16.2 32.6-38.6v-1.9c-.1-22.1-12.1-38.4-32.1-38.4zm11.4 40.4c0 14.7-6.1 22.9-17.8 22.9s-17.8-8.2-17.8-22.9v-1.9c0-14.7 6.2-22.9 17.8-22.9s17.8 8.1 17.8 22.9v1.9zM821.9 103.9c0-18.9-20.4-19.9-20.4-19.9v107.9h20.4v-88zM915.9 193.7v-10.4h-3.5v-2.5h10.1v2.5H919v10.4h-3.1zM924.3 193.7v-12.8h4.3l2.8 9 2.8-9h4.1v12.8h-2.9v-9.3l-3 9.3H930l-3-9.3v9.3h-2.7zM199.4 161.7c5-2.7 11-2.2 12.7 1.1.2.4.4.9.5 1.4.4 2.9-1.7 7.2-6.6 9.8-5 2.7-11 2.2-12.7-1.1-.2-.4-.4-.9-.5-1.4-.5-2.8 1.6-7.1 6.6-9.8zm-38.9 30.5c.6 1.1 2 1.6 2.8 1.7 1.9.3 4.1-.1 6.1-1.1 3.5-1.8 5.2-4.9 4.9-6.8 0-.3-.1-.5-.2-.8-.6-1.1-2-1.6-2.8-1.7-1.9-.3-4.1.1-6.1 1.1-3.5 1.8-5.2 4.9-4.9 6.8 0 .3.1.5.2.8zm69.4-30.3c-.7-.1-1.3-.1-1.9-.1-.4 0-.9 0-1.3.1-.4 0-.8.1-1.1.1h-.1c-1.4.2-2.2.4-2.2.4-1.4-4.6-4-7.4-6.8-8.9-1.4-.8-2.9-1.2-4.4-1.4-.7-.1-1.4-.1-2.1-.1s-1.3.1-1.9.2c-1.6.3-3.1 1-4.2 1.6-.5.3-.2 1.1.4 1 .4-.1.8-.1 1.3-.1H207.5c.4 0 .9.1 1.4.1.2 0 .5.1.7.1.3.1.6.1.9.2.3.1.6.2 1 .3.2.1.5.2.7.3.2.1.5.2.7.3.3.1.6.3.8.5 1.4.9 2.6 2.1 3.5 3.9v.1c.2.4.6 1.1.9 2 .1.1.1.3.1.4.1.3.2.6.2 1v.2c.1.3.1.7.1 1.1v.7c0 .8-.1 1.5-.2 2.4 0 .1 0 .2-.1.3 0 .2-.1.4-.1.6-.2.6-.4 1.2-.8 1.9-.2.4-.5.8-.8 1.3-.1.1-.1.2-.2.3-.3.4-.6.8-1 1.2l-.1.1c-.6.6-1.2 1.2-1.9 1.8l-.1.1c-.7.6-1.6 1.2-2.5 1.8-.5.3-1.1.6-1.6 1-.1.1-.3.2-.4.2 0 0-.1 0-.1.1-.3.2-.6.3-1 .4-.5.2-.9.4-1.4.6-.5.2-1.1.4-1.6.5-.3.1-.6.2-.9.2-.4.1-.8.2-1.2.2-.4.1-.8.1-1.1.1-.5.1-.9.1-1.4.1h-.1c-1 0-2-.1-3-.3h-.1c-.8-.1-1.6-.4-2.3-.6-.7-.3-1.4-.6-2.1-1-.1 0-.1-.1-.2-.1-.5-.3-1-.7-1.4-1.1l-.3-.3c-.2-.2-.5-.5-.7-.8l-.3-.3c-.9.6-1.9 1.2-2.9 1.8-1.2.7-2.4 1.4-3.6 2.2-5.7-8.1-13.6-5.1-17.3-2.5-.5.4-.1 1.1.5 1 .5-.1 1.1-.3 1.7-.4.4-.1.8-.1 1.3-.2h.5c.6 0 1.1-.1 1.7 0 .6 0 1.2.1 1.8.2.1 0 .2.1.4.1.4.1.9.2 1.3.4.1.1.3.1.4.2l1.2.6c.2.1.4.3.5.4.3.3.7.5.9.9s.6.7.8 1.1c.1.2.2.4.4.6 0 .1.1.1.1.2.2.4.4.9.5 1.3.1.3.1.6.2.8.1.4.1.9.1 1.3 0 .3 0 .5-.1.8 0 .2-.1.6-.1.8-.1.4-.1.8-.3 1.1-.1.4-.2.7-.4 1.1-.2.4-.4.8-.6 1.1-.1.1-.1.2-.2.4-.7 1.2-1.6 2.3-2.8 3.3-.3.2-.6.5-.9.7-.8.6-1.7 1.2-2.6 1.7-.6.3-1.1.5-1.7.8h-.1c-1.2.5-2.4.9-3.6 1.1h-.1c-.9.2-1.7.3-2.5.3h-.9c-.7-.1-1.5-.2-2.1-.4-.1 0-.1 0-.2-.1-.2-.1-.4-.1-.6-.2-.1 0-.1-.1-.2-.1-.4-.2-.7-.4-1.1-.6-.1-.1-.1-.1-.2-.1-.1-.1-.3-.2-.4-.3l-.3-.3-.3-.3-.1-.1-.1-.1c-.3-.3-.5-.7-.8-1.1 0-.1-.1-.1-.1-.1 0-.1-.1-.1-.1-.2l-.3-.6c-.1-.3-.3-.6-.4-.9-2.6.9-5.2 1.8-7.9 2.5-.6-2.2-1.5-3.9-2.6-5.1-.2-.2-.4-.4-.6-.7-.1-.1-.1-.1-.2-.1-.6-.5-1.2-1-1.9-1.3 0 0-.1 0-.1-.1h-.1c-.3-.1-.5-.2-.8-.4-.4-.2-.9-.3-1.4-.4h-.1c-.3-.1-.7-.1-1-.2-.4 0-.7-.1-1.1-.1-.5 0-1 0-1.5.1s-.9.1-1.4.3c-.1 0-.2.1-.3.2-.2.3-.1.8.4.9h.1c.8.1 1.6.2 2.5.4h.2c.4.1.8.2 1.1.4h.1c.4.1.8.3 1.1.5.7.4 1.4 1 2 1.6.1.1.2.2.3.4.3.4.6.9.9 1.5.1.3.2.6.3 1 .1.3.1.6.2.9v1.2c0 .3 0 .5-.1.8 0 .1 0 .2-.1.2-.1.3-.1.6-.2.9v.1c-.3.7-.7 1.4-1.2 2.1l-.1.1-.9.9s-.1 0-.1.1c-.8.6-1.7 1.2-2.9 1.7-.1 0-.2.1-.3.1-.5.2-1.1.4-1.6.5-.2.1-.4.1-.5.1-.7.2-1.5.3-2.4.4-.9.1-1.9.1-2.8.1h-.3c-.9-.1-1.8-.2-2.6-.4-.1 0-.2 0-.3-.1-.6-.1-1.1-.4-1.6-.6-.1 0-.1-.1-.2-.1-.5-.2-.9-.5-1.3-.7-.1-.1-.2-.1-.2-.2-.4-.3-.8-.6-1.1-.9l-.2-.2-.9-1.2c-.1-.1-.1-.3-.2-.4-.2-.5-.4-1-.5-1.5-.1-.5-.2-1-.2-1.6-1.5-.2-3-.5-4.5-.9-1.2-.3-2.4-.6-3.5-1-.1 0-.2-.1-.3-.1.7-1.7 1-3.3.9-4.7 0-.4-.1-.8-.1-1.2v-.2l-.3-1.2v-.1c0-.1-.1-.1-.1-.2-.1-.3-.3-.6-.4-.9 0-.1-.1-.1-.1-.2-.2-.4-.5-.8-.8-1.1l-.1-.1v-.1l-.6-.6-.2-.2c-.8-.8-1.6-1.4-2.4-1.9l-1.2-.6c-.6-.2-1.1.5-.6.9l.4.4.6.6s0 .1.1.1c.2.3.5.5.7.8l.6.9.1.1c.2.3.3.6.5.9.1.3.3.6.4.9.1.2.1.4.2.6v.2c.1.3.1.6.1.8 0 .3.1.6.1 1v.2c-.1.7-.2 1.4-.4 2-.2.5-.4.9-.7 1.3-.1.1-.1.3-.2.4-.2.3-.4.5-.7.8-.2.2-.3.4-.6.5-.2.2-.5.4-.8.6-.2.1-.5.3-.8.4-.3.1-.6.3-.8.4-.2.1-.5.1-.7.2-.5.1-1 .2-1.6.2H102c-.2 0-.5-.1-.7-.1-.2 0-.3-.1-.5-.1-1-.2-2.1-.6-3.1-1.1-.2-.1-.4-.2-.7-.3-.6-.3-1.1-.7-1.7-1.1-.2-.1-.3-.2-.4-.3-.4-.3-.8-.6-1.1-.9-1.2-1.1-2.2-2.4-2.8-3.8-.2-.4-.4-1.2-.5-1.6v-.1c-.1-.6-.2-1.1-.1-1.7v-.1c.1-.6.2-1.3.4-1.9.1-.2.2-.4.2-.5.2-.5.4-1 .8-1.4-.4-.4-.8-.8-1.2-1.3v-.1c-1.2-1.3-2.4-2.8-3.5-4.4l-.9-1.2c-.1-.2-.3-.4-.4-.6-.4-.6-.8-1.2-1.2-1.9-.9-1.4-1.7-3-2.5-4.5-.1-.1-.1-.3-.2-.4-.8-1.6-1.4-3.1-2.1-4.8 0-.1-.1-.1-.1-.2-.3-.8-.6-1.5-.8-2.3-.1-.4-.3-.9-.4-1.3-.1-.4-.2-.9-.4-1.3-.1-.3-.2-.7-.2-1-.1-.2-.1-.5-.2-.7-1.3-5.9-1.2-11.7.1-17.1v-.1c.2-.9.4-1.8.7-2.6 0-.1.1-.1.1-.2.3-1 .7-2 1.1-2.9v-.1c.7-1.6 1.4-3.1 2.3-4.6v-.1c.9-1.4 1.8-2.8 2.9-4.2 0 0 0-.1.1-.1.1-.1.2-.2.2-.3.2-.2.4-.5.7-.8.3-.3.5-.6.8-.9.4-.4.9-.9 1.3-1.4l.8-.8c.5-.4.9-.8 1.4-1.3l.3-.3c.2-.2.4-.3.6-.4.6-.5 1.2-.9 1.9-1.4 1-.7 2-1.3 3-1.9.7-.4 1.5-.8 2.3-1.2.4-.2.7-.3 1.1-.5.2-.1.4-.2.7-.3.8-.3 1.7-.6 2.5-.9.1 0 .3-.1.4-.1l2.4-.6c.8-.2 1.5-.3 2.3-.4h.1c.7-.1 1.5-.2 2.2-.2h.1c.7-.1 1.4-.1 2.1-.1h.1c.9 0 1.9 0 2.8.1h.3c1.2.1 2.3.3 3.4.5h.2c1.1.2 2.1.4 3 .7h.1c.8.2 1.5.4 2.2.7h.1c.6.2 1.2.4 1.7.6 1.2.5 1 1.6-.4 1.3-7.5-1.5-15.3-.3-20.8 3.3-17.4 11.7-14.6 28.8-9.4 39.1 4.9 9.8 17.2 19 32 19 10.1 0 22.6-4.1 41.6-18.5 23.3-17.7 42.2-24.2 59.5-24.6.3 0 .5-.1.8 0 .7 0 1.2-.2.9-1.3 0-.1-.1-.3-.1-.5-1.8-8.6-4.9-16.6-9-23.9-1.6.4-19.4 4.6-37.8 16.6-9.1 5.9-16.5 12.1-23.3 17.8-2.9 2.4-5.6 4.6-8.3 6.7-8.4 6.3-17.2 13.2-27.2 13-2.3-.1-4.7-.5-7.1-1.4-8.4-3-13.2-12.1-14.4-20.9-.1-.6-.2-1.2-.2-1.9-.1-.6-.1-1.2-.1-1.9v-.1c2.1 7 7.3 15 14.1 17.4 13 4.8 23.2-5.4 33.5-13.1 9.2-7.1 18.8-16.2 31.7-24.5 11.7-7.6 26.9-13.3 34.1-15.6-12.4-17.2-31-29.5-52-33.8-9.7-2-20-2.4-30.4-.8-5.6.9-11 2.3-16.1 4.1 0 0-10.9 3.8-19.8 10.3-1 .7-2.2 1.7-3.4 2.8-2 1.7-.6 4.9 2 4.6 5.2-.7 12.3-.6 20.5 1.8 15.5 4.6 23.5 15.7 27.4 23.1 2.1 4-1.8 5.8-4.1 3.5-7.1-7.1-28.6-20.2-54-6.9-16.7 8.8-23 24.3-24.1 37.3-1.6 19.6 5.6 36.9 10.5 45.6 12.1 21.3 32.8 36.4 56.7 41.4 9.8 2.1 20.1 2.4 30.6.8 19.2-3 35.9-12.2 48.4-25.2 5.3-5.5 9.8-11.7 13.4-18.3 4.6-8.5 7.8-17.8 9.3-27.6-.1.1-.5-.4-1.2-.5zm-103.7 36.9c.2 1.5 3 3.4 6.7 2.9 1.9-.2 3.6-1.1 4.7-2.2.3-.4 1.1-1.3 1-2.3-.2-1.5-3-3.4-6.7-2.9-1.9.2-3.6 1.1-4.7 2.2-.4.4-1.1 1.3-1 2.3zM97 185.3c-.4 0-1.5.2-1.9.8-.1.1-.2.4-.2.9.1 1.4 1.2 3.4 3.5 4.8 1.5 1 3.3 1.5 4.8 1.3.4 0 1.5-.2 1.9-.8.1-.1.2-.4.2-.9-.1-1.4-1.2-3.4-3.5-4.8-1.6-1-3.3-1.4-4.8-1.3z",
                className: "st0"
            })
        ]
    }));
};
var $41158ab2c4dff680$export$2e2bcd8739ae039 = $41158ab2c4dff680$var$SvgComponent;





parcelRequire("7fPBF");
const $10c818dd7f51e943$var$SvgWave1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 900,
        height: 600
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "#EE486F",
            d: "m0 174 21.5-4.7c21.5-4.6 64.5-14 107.3-9 42.9 5 85.5 24.4 128.4 23.4 42.8-1 85.8-22.4 128.6-32.9 42.9-10.5 85.5-10.1 128.4-.6 42.8 9.5 85.8 28.1 128.6 32.5 42.9 4.3 85.5-5.7 128.4-7.7 42.8-2 85.8 4 107.3 7l21.5 3V0H0Z"
        })
    }));
var $10c818dd7f51e943$export$2e2bcd8739ae039 = $10c818dd7f51e943$var$SvgWave1;





parcelRequire("7fPBF");
const $9305c41ed80e679e$var$SvgWave2 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 900,
        height: 600
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "#EE486F",
            d: "m0 112 21.5 4.3c21.5 4.4 64.5 13 107.3 28.7 42.9 15.7 85.5 38.3 128.4 45.7 42.8 7.3 85.8-.7 128.6-13.9 42.9-13.1 85.5-31.5 128.4-27.5 42.8 4 85.8 30.4 128.6 29 42.9-1.3 85.5-30.3 128.4-42.8C814 123 857 127 878.5 129l21.5 2V0H0Z"
        })
    }));
var $9305c41ed80e679e$export$2e2bcd8739ae039 = $9305c41ed80e679e$var$SvgWave2;








let $2b7126a11f803509$var$_ = (t)=>t, $2b7126a11f803509$var$t, $2b7126a11f803509$var$t1, $2b7126a11f803509$var$t2, $2b7126a11f803509$var$t3;
const $2b7126a11f803509$var$SplashLoader = ({ text: text, className: className, children: children, refreshButton: refreshButton = false, onSignOut: onSignOut })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2b7126a11f803509$var$SplashLoaderWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2b7126a11f803509$var$StyledCephableIcon, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2b7126a11f803509$export$b1ae020268e0b4d5, {}),
            text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2b7126a11f803509$var$StyledLabelXLarge, {
                children: text
            }),
            children,
            refreshButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    window.location.reload();
                },
                children: t('reload')
            }),
            onSignOut && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: onSignOut,
                children: t('account.signout.title')
            })
        ]
    });
};
const $2b7126a11f803509$var$StyledCephableIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0e54c6b17377038f$export$2e2bcd8739ae039))($2b7126a11f803509$var$t || ($2b7126a11f803509$var$t = $2b7126a11f803509$var$_`
    height: 128px;
    width: 128px;
`));
const $2b7126a11f803509$var$StyledLabelXLarge = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$c1529625596ef638))($2b7126a11f803509$var$t1 || ($2b7126a11f803509$var$t1 = $2b7126a11f803509$var$_`
    color: ${0};
`), (props)=>props.theme.color.text);
const $2b7126a11f803509$export$b1ae020268e0b4d5 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5310a643ead17d95$export$2e2bcd8739ae039))($2b7126a11f803509$var$t2 || ($2b7126a11f803509$var$t2 = $2b7126a11f803509$var$_`
    margin: 16px;
`));
const $2b7126a11f803509$var$SplashLoaderWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2b7126a11f803509$var$t3 || ($2b7126a11f803509$var$t3 = $2b7126a11f803509$var$_`
    min-height: 90vh;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    ${0}
    img {
        height: 128px;
        width: 128px;
    }
`), (0, $19e0bc52fddd02b4$export$29c8ed22df400735));
var $2b7126a11f803509$export$2e2bcd8739ae039 = $2b7126a11f803509$var$SplashLoader;







const $d8990c2b9fb87b75$export$52a528b1f45cfa42 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const showError = (error, timeout = 5000)=>{
        set((state)=>{
            state.error = error;
        });
        setTimeout(()=>{
            set((state)=>{
                state.error = null;
            });
        }, timeout);
    };
    const showSuccess = (success, timeout = 5000)=>{
        set((state)=>{
            state.success = success;
        });
        setTimeout(()=>{
            set((state)=>{
                state.success = null;
            });
        }, timeout);
    };
    const showWarning = (warning, timeout = 5000)=>{
        set((state)=>{
            state.warning = warning;
        });
        setTimeout(()=>{
            set((state)=>{
                state.warning = null;
            });
        }, timeout);
    };
    const addBanner = (newBanner, duration)=>{
        const existing = get().bannerMap[newBanner.id];
        if (existing === null || existing === void 0 ? void 0 : existing.timeout) clearTimeout(existing.timeout);
        let timeout;
        if (duration !== undefined) timeout = setTimeout(()=>{
            get().removeBanner(newBanner.id);
        }, duration);
        set((state)=>{
            state.bannerMap[newBanner.id] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, newBanner), {
                timeout: timeout
            });
            state.bannersArray = Object.values(state.bannerMap);
        });
    };
    const removeBanner = (id)=>{
        const banner = get().bannerMap[id];
        if (banner === null || banner === void 0 ? void 0 : banner.timeout) clearTimeout(banner.timeout);
        set((state)=>{
            delete state.bannerMap[id];
            state.bannersArray = Object.values(state.bannerMap);
        });
    };
    return {
        // State
        bannerMap: {},
        bannersArray: [],
        error: null,
        success: null,
        warning: null,
        addBanner: // Actions
        addBanner,
        removeBanner: removeBanner,
        showError: showError,
        showSuccess: showSuccess,
        showWarning: showWarning
    };
}));
(0, $e7df95de73caec26$export$ec068583843480e7)('alertSuccess', (alert)=>{
    $d8990c2b9fb87b75$export$52a528b1f45cfa42.getState().showSuccess(alert.message);
});
(0, $e7df95de73caec26$export$ec068583843480e7)('alertError', (alert)=>{
    $d8990c2b9fb87b75$export$52a528b1f45cfa42.getState().showError(alert.message);
});
(0, $e7df95de73caec26$export$ec068583843480e7)('alertWarning', (alert)=>{
    $d8990c2b9fb87b75$export$52a528b1f45cfa42.getState().showWarning(alert.message);
});








const $455682785eac4c5b$var$signoutListeners = [];
const $455682785eac4c5b$var$notifyListeners = (listeners)=>{
    listeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            console.error('Error in signout listener:', error);
        }
    });
};
const $455682785eac4c5b$export$650ce9f0b4df82fd = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((set, get)=>{
    const setIsInitialized = (value)=>set({
            isInitialized: value
        });
    const setIsLoadingDataComplete = (value)=>set({
            isLoadingDataComplete: value
        });
    const handleIsLoading = (loading)=>set({
            isLoading: loading
        });
    const initializeFromStorage = ()=>{
        set({
            isLoading: true
        });
        try {
            const accessToken = sessionStorage.getItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c));
            const refreshToken = localStorage.getItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051));
            const expirationDate = localStorage.getItem((0, $db3063bd3b6d501e$export$ccdad49998c6d6ff));
            if (refreshToken) {
                set((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    accessToken: accessToken,
                    refreshToken: refreshToken,
                    isAuthenticated: true,
                    isInitialized: true
                }, expirationDate && {
                    expirationDate: new Date(expirationDate)
                }));
                console.log('Auth.initializeFromStorage: Authenticated');
            } else console.log('Auth.initializeFromStorage: No refresh token found');
            return true;
        } catch (e) {
            console.log('Auth.initializeFromStorage:', e);
            return false;
        } finally{
            set({
                isLoading: false
            });
        }
    };
    const loginFromCode = async (code)=>{
        set({
            isLoading: true
        });
        try {
            var _result_errors;
            const result = await $1a4c36336f303477$export$257b2d10b709d8ef((0, $db3063bd3b6d501e$export$666167f3cc1c081a)(), code, (0, $07546889aef07ebc$export$b0c2c82d7aa8a735)());
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                sessionStorage.setItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c), result.data.access_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051), result.data.refresh_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$ccdad49998c6d6ff), result.data.access_token_expiration);
                set({
                    accessToken: result.data.access_token,
                    refreshToken: result.data.refresh_token,
                    expirationDate: new Date(result.data.access_token_expiration),
                    isAuthenticated: true,
                    isInitialized: true
                });
            } else if ((_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.length) set({
                errors: [
                    ...result.errors
                ]
            });
            return result;
        } catch (error) {
            set({
                errors: [
                    error
                ]
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set({
                isLoading: false
            });
        }
    };
    const getNewToken = async ()=>{
        set({
            isRefreshing: true
        });
        try {
            var _result_errors;
            const latestRefresh = localStorage.getItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051));
            if (!latestRefresh) {
                set({
                    isRefreshing: false
                });
                return {
                    resultType: 'Invalid',
                    errors: [
                        'No refresh token found'
                    ]
                };
            }
            const result = await $1a4c36336f303477$export$c542b5e295206b2a((0, $db3063bd3b6d501e$export$666167f3cc1c081a)(), (0, $db3063bd3b6d501e$export$abb5e0783f1a4f17)(), latestRefresh);
            // desktop app can use local storage, admin app (web app) should reject
            const isDesktop = (0, $db3063bd3b6d501e$export$94d1d6411b964f7)() == 'desktop';
            if (isDesktop && (result.resultType === 'Offline' || result.resultType === 'NoResponse')) {
                const storage = get().initializeFromStorage();
                if (storage) return {
                    resultType: 'Ok'
                };
            }
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                sessionStorage.setItem((0, $db3063bd3b6d501e$export$d975f71e6c6b349c), result.data.access_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051), result.data.refresh_token);
                localStorage.setItem((0, $db3063bd3b6d501e$export$ccdad49998c6d6ff), result.data.access_token_expiration);
                set({
                    accessToken: result.data.access_token,
                    refreshToken: result.data.refresh_token,
                    expirationDate: new Date(result.data.access_token_expiration),
                    isAuthenticated: true,
                    isInitialized: true
                });
            }
            if (((_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.length) && result.resultType !== 'Ok') {
                set({
                    errors: [
                        ...result.errors
                    ]
                });
                get().logout();
            }
            return result;
        } catch (error) {
            set({
                errors: [
                    error
                ]
            });
            return {
                resultType: 'Invalid',
                errors: [
                    error
                ]
            };
        } finally{
            set({
                isRefreshing: false
            });
        }
    };
    const logout = ()=>{
        set({
            isLoading: true
        });
        $455682785eac4c5b$var$notifyListeners($455682785eac4c5b$var$signoutListeners);
        sessionStorage.clear();
        localStorage.clear();
        $455682785eac4c5b$var$signoutListeners.length = 0;
        set({
            isAuthenticated: false,
            accessToken: null,
            refreshToken: null,
            expirationDate: new Date(),
            isLoading: false
        });
    };
    const addSignoutListener = (listener)=>$455682785eac4c5b$var$signoutListeners.push(listener);
    const removeSignoutListener = (listener)=>{
        const idx = $455682785eac4c5b$var$signoutListeners.indexOf(listener);
        if (idx !== -1) $455682785eac4c5b$var$signoutListeners.splice(idx, 1);
    };
    return {
        // State
        accessToken: null,
        errors: [],
        expirationDate: new Date(),
        isAuthenticated: false,
        isInitialized: false,
        isLoading: false,
        isRefreshing: false,
        isLoadingDataComplete: false,
        refreshToken: null,
        addSignoutListener: // Actions
        addSignoutListener,
        getNewToken: getNewToken,
        handleIsLoading: handleIsLoading,
        initializeFromStorage: initializeFromStorage,
        loginFromCode: loginFromCode,
        logout: logout,
        removeSignoutListener: removeSignoutListener,
        setIsInitialized: setIsInitialized,
        setIsLoadingDataComplete: setIsLoadingDataComplete
    };
});



var $7fPBF = parcelRequire("7fPBF");


const $f6147295756e879a$var$LOGIN_PATH = '../login';
const $f6147295756e879a$var$HOME_PATH = '../';
const $f6147295756e879a$var$AuthCallbackPage = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [searchParams] = (0, $f232cebbf1b70e96$export$f1a78c17382fe22a)();
    const queryCode = searchParams.get('code');
    const tryInitializeFromStorage = async ()=>{
        try {
            const result = await (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().initializeFromStorage();
            if (result) navigate($f6147295756e879a$var$HOME_PATH, {
                replace: true,
                viewTransition: true
            });
            else errorReset();
        } catch (error) {
            errorReset();
        }
    };
    const errorReset = ()=>{
        (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:login.error'));
        if (!(0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().isLoading) navigate($f6147295756e879a$var$LOGIN_PATH, {
            replace: true,
            viewTransition: true
        });
    };
    const fetchData = async ()=>{
        try {
            const result = await (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().loginFromCode(queryCode || '');
            if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') navigate($f6147295756e879a$var$HOME_PATH, {
                replace: true,
                viewTransition: true
            });
            else tryInitializeFromStorage();
        } catch (error) {
            errorReset();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!queryCode) {
            navigate($f6147295756e879a$var$LOGIN_PATH, {
                replace: true,
                viewTransition: true
            });
            return;
        }
        if (!(0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().isAuthenticated) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {
        text: t('common:authenticating'),
        refreshButton: true
    });
};
var $f6147295756e879a$export$2e2bcd8739ae039 = $f6147295756e879a$var$AuthCallbackPage;








let $aa23c6db410f15d5$var$_ = (t)=>t, $aa23c6db410f15d5$var$t, $aa23c6db410f15d5$var$t1, $aa23c6db410f15d5$var$t2, $aa23c6db410f15d5$var$t3, $aa23c6db410f15d5$var$t4, $aa23c6db410f15d5$var$t5, $aa23c6db410f15d5$var$t6, $aa23c6db410f15d5$var$t7, $aa23c6db410f15d5$var$t8, $aa23c6db410f15d5$var$t9, $aa23c6db410f15d5$var$t10, $aa23c6db410f15d5$var$t11, $aa23c6db410f15d5$var$t12, $aa23c6db410f15d5$var$t13;
const $aa23c6db410f15d5$export$b59bdbef9ce70de2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t || ($aa23c6db410f15d5$var$t = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    width: 100%;
`));
const $aa23c6db410f15d5$export$c0437c89e5dcfbb = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t1 || ($aa23c6db410f15d5$var$t1 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
`));
const $aa23c6db410f15d5$export$54fb318478ce42e9 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t2 || ($aa23c6db410f15d5$var$t2 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: column;
    padding: 0 2rem;
`));
const $aa23c6db410f15d5$export$9f629bf691066a45 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t3 || ($aa23c6db410f15d5$var$t3 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    gap: 2rem;
    width: 100%;
    max-width: 775px;
    margin: 2rem auto;
`));
const $aa23c6db410f15d5$export$168e1409b442d455 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($aa23c6db410f15d5$export$9f629bf691066a45)($aa23c6db410f15d5$var$t4 || ($aa23c6db410f15d5$var$t4 = $aa23c6db410f15d5$var$_`
    gap: 0;
`));
const $aa23c6db410f15d5$export$a334180936c1c286 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t5 || ($aa23c6db410f15d5$var$t5 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    width: 100%;
    max-width: 775px;
    margin: 1rem auto;
    gap: 0.5rem;
`));
const $aa23c6db410f15d5$export$562f981f17d360a4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t6 || ($aa23c6db410f15d5$var$t6 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    & > * {
        transition: all 0.2s ease-in-out;
    }
`));
const $aa23c6db410f15d5$export$81ea29a9084db687 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t7 || ($aa23c6db410f15d5$var$t7 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin: 1rem 0;
`));
const $aa23c6db410f15d5$export$20dc64867e1691d0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t8 || ($aa23c6db410f15d5$var$t8 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`));
const $aa23c6db410f15d5$export$bdcd69dc79c387fe = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t9 || ($aa23c6db410f15d5$var$t9 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    min-width: 0;
    padding: 0 0.5rem;
`));
const $aa23c6db410f15d5$export$6e2c8f0811a474ce = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t10 || ($aa23c6db410f15d5$var$t10 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
`));
const $aa23c6db410f15d5$export$816b5d811295e6bc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t11 || ($aa23c6db410f15d5$var$t11 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
`));
const $aa23c6db410f15d5$export$36534891196a2314 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t12 || ($aa23c6db410f15d5$var$t12 = $aa23c6db410f15d5$var$_`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.375rem 0.25rem;
    min-width: 0;
`));
const $aa23c6db410f15d5$export$767df0b5721436de = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($aa23c6db410f15d5$var$t13 || ($aa23c6db410f15d5$var$t13 = $aa23c6db410f15d5$var$_`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    gap: 0.5rem;
`));







let $746bf81c54a0dba3$var$_ = (t)=>t, $746bf81c54a0dba3$var$t, $746bf81c54a0dba3$var$t1, $746bf81c54a0dba3$var$t2, $746bf81c54a0dba3$var$t3;
function $746bf81c54a0dba3$export$2e2bcd8739ae039({ items: items }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbNav, {
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbList, {
            children: items.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbItem, {
                    children: index < items.length - 1 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($746bf81c54a0dba3$var$BreadcrumbLink, {
                        viewTransition: true,
                        to: item.href,
                        children: item.label
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        "aria-current": "page",
                        children: item.label
                    })
                }, index))
        })
    });
}
// Styled components
const $746bf81c54a0dba3$var$BreadcrumbNav = (0, $8de346382d86c747$export$2e2bcd8739ae039).nav($746bf81c54a0dba3$var$t || ($746bf81c54a0dba3$var$t = $746bf81c54a0dba3$var$_`
    ${0}
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${0};
    position: sticky;
    top: 0;
    z-index: 1000;
    padding: 0.5rem 0 0 0;
    width: 100%;
    background-color: ${0};
`), (0, $b091aef3a32d2bd8$export$e6005bbb0c0f31ce), ({ theme: theme })=>theme.color.textBody, ({ theme: theme })=>theme.color.background);
const $746bf81c54a0dba3$var$BreadcrumbList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ol($746bf81c54a0dba3$var$t1 || ($746bf81c54a0dba3$var$t1 = $746bf81c54a0dba3$var$_`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
`));
const $746bf81c54a0dba3$var$BreadcrumbItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).li($746bf81c54a0dba3$var$t2 || ($746bf81c54a0dba3$var$t2 = $746bf81c54a0dba3$var$_`
    display: flex;
    align-items: center;

    &::after {
        content: '/';
        margin: 0 0.5rem;
        color: ${0};
    }

    &:last-child::after {
        content: '';
    }
`), ({ theme: theme })=>theme.color.border);
const $746bf81c54a0dba3$var$BreadcrumbLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f232cebbf1b70e96$export$b0d92dbee9b5b60d))($746bf81c54a0dba3$var$t3 || ($746bf81c54a0dba3$var$t3 = $746bf81c54a0dba3$var$_`
    text-decoration: none;
    color: ${0};

    &:hover,
    &:focus {
        text-decoration: underline;
        outline: none;
    }

    ${0}
`), ({ theme: theme })=>theme.color.link, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));







let $9926e0d0274623af$var$_ = (t)=>t, $9926e0d0274623af$var$t, $9926e0d0274623af$var$t1, $9926e0d0274623af$var$t2, $9926e0d0274623af$var$t3, $9926e0d0274623af$var$t4, $9926e0d0274623af$var$t5, $9926e0d0274623af$var$t6, $9926e0d0274623af$var$t7, $9926e0d0274623af$var$t8, $9926e0d0274623af$var$t9, $9926e0d0274623af$var$t10, $9926e0d0274623af$var$t11, $9926e0d0274623af$var$t12, $9926e0d0274623af$var$t13, $9926e0d0274623af$var$t14, $9926e0d0274623af$var$t15;
// Defaults the folded text/link variant so these styled wrappers keep the
// former TextButton's transparent, borderless base.
const $9926e0d0274623af$var$TextVariantButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        $color: "text"
    }, props));
const $9926e0d0274623af$export$ce6636bfa4e9f0e8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($9926e0d0274623af$var$t || ($9926e0d0274623af$var$t = $9926e0d0274623af$var$_`
    width: 100%;
    max-width: 1000px;
    padding: 3rem 2rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
`));
const $9926e0d0274623af$export$a0a5e8e630ce7261 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9926e0d0274623af$export$ce6636bfa4e9f0e8)($9926e0d0274623af$var$t1 || ($9926e0d0274623af$var$t1 = $9926e0d0274623af$var$_`
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
`));
const $9926e0d0274623af$export$1d02c21cd5285ce0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($9926e0d0274623af$var$t2 || ($9926e0d0274623af$var$t2 = $9926e0d0274623af$var$_`
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    margin: 2rem 0;
`));
const $9926e0d0274623af$export$155581e8dc02007a = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$e08999835651ba4a))($9926e0d0274623af$var$t3 || ($9926e0d0274623af$var$t3 = $9926e0d0274623af$var$_`
    padding: 0.5rem 0;
`));
const $9926e0d0274623af$export$b8851b0fad634649 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d))($9926e0d0274623af$var$t4 || ($9926e0d0274623af$var$t4 = $9926e0d0274623af$var$_`
    padding: 1rem 0 0.5rem 0;
`));
const $9926e0d0274623af$export$aaf6264d06ddc4ce = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65))($9926e0d0274623af$var$t5 || ($9926e0d0274623af$var$t5 = $9926e0d0274623af$var$_`
    padding: 2rem 0 0.5rem 0;
`));
const $9926e0d0274623af$export$1373bbbab1727c6f = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$2c65789109b698b0))($9926e0d0274623af$var$t6 || ($9926e0d0274623af$var$t6 = $9926e0d0274623af$var$_`
    padding: 1rem 0 0.5rem 0;
`));
const $9926e0d0274623af$export$2f7dd73b133adfb7 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($9926e0d0274623af$var$t7 || ($9926e0d0274623af$var$t7 = $9926e0d0274623af$var$_`
    color: ${0};
    display: inline-block;
`), (props)=>props.theme.color.textBody);
const $9926e0d0274623af$export$154f0ea7dcc0c8c6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))($9926e0d0274623af$var$t8 || ($9926e0d0274623af$var$t8 = $9926e0d0274623af$var$_`
    margin: 2rem 0;
`));
const $9926e0d0274623af$export$da51057063e69428 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9926e0d0274623af$var$TextVariantButton)($9926e0d0274623af$var$t9 || ($9926e0d0274623af$var$t9 = $9926e0d0274623af$var$_`
    display: inline-block;
    padding-left: 0.5rem;
`));
const $9926e0d0274623af$export$646b80a994b34028 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($9926e0d0274623af$var$t10 || ($9926e0d0274623af$var$t10 = $9926e0d0274623af$var$_`
    padding: 0rem 0 0.5rem 0;
`));
const $9926e0d0274623af$export$a6c3c9410ede5653 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($9926e0d0274623af$var$t11 || ($9926e0d0274623af$var$t11 = $9926e0d0274623af$var$_`
    padding: 0rem 0 0.5rem 0;
`));
const $9926e0d0274623af$export$a4cc130c20be0091 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$2c65789109b698b0))($9926e0d0274623af$var$t12 || ($9926e0d0274623af$var$t12 = $9926e0d0274623af$var$_`
    padding: 0rem 0 1rem 0;
    font-weight: 300;
`));
const $9926e0d0274623af$export$61d973530a8ddc92 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9926e0d0274623af$var$TextVariantButton)($9926e0d0274623af$var$t13 || ($9926e0d0274623af$var$t13 = $9926e0d0274623af$var$_`
    font-weight: 700;
    ${0}
    color: ${0};
    :hover {
        color: ${0};
    }
`), (0, $b091aef3a32d2bd8$export$734b24ef8489e701), (props)=>props.theme.color.text, (props)=>props.theme.color.link);
const $9926e0d0274623af$export$3288d34c523a1192 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($9926e0d0274623af$var$t14 || ($9926e0d0274623af$var$t14 = $9926e0d0274623af$var$_`
    display: block;
    margin: 0.5rem 0;
    width: min-content;
    color: ${0};
    background-color: ${0};
    padding: 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0.375rem;
`), (props)=>props.theme.tag.text, (props)=>props.theme.tag.background);
const $9926e0d0274623af$export$86956144d6970eff = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9926e0d0274623af$export$3288d34c523a1192)($9926e0d0274623af$var$t15 || ($9926e0d0274623af$var$t15 = $9926e0d0274623af$var$_`
    margin-left: 5px;
    display: inline-block;
    white-space: nowrap;
    ${0}
`), (0, $b091aef3a32d2bd8$export$3e193b19d995235f));






let $b341816979fee99b$var$_ = (t)=>t, $b341816979fee99b$var$t, $b341816979fee99b$var$t1, $b341816979fee99b$var$t2, $b341816979fee99b$var$t3, $b341816979fee99b$var$t4, $b341816979fee99b$var$t5;
const $b341816979fee99b$export$489b03dc3e6c3fea = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8))($b341816979fee99b$var$t || ($b341816979fee99b$var$t = $b341816979fee99b$var$_`
    max-width: 800px;
`));
const $b341816979fee99b$export$ac90896a1379b2ac = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b341816979fee99b$var$t1 || ($b341816979fee99b$var$t1 = $b341816979fee99b$var$_`
    display: flex;
    flex-direction: column;
    align-self: self-end;
    padding: 0 0 0.25rem 0;
    flex: 1;
    min-width: 60%; // ensure the header text doesn't get too small and takes up appropriate portion of header
`));
const $b341816979fee99b$export$128b0389825fe3d5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b341816979fee99b$var$t2 || ($b341816979fee99b$var$t2 = $b341816979fee99b$var$_`
    display: flex;
    flex-direction: column;
    justify-content: center;
`));
const $b341816979fee99b$export$1e86fd0e1db89578 = (0, $8de346382d86c747$export$2e2bcd8739ae039).header($b341816979fee99b$var$t3 || ($b341816979fee99b$var$t3 = $b341816979fee99b$var$_`
    flex-basis: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem;
    border-bottom: ${0};
`), ({ theme: theme })=>`1px solid ${theme.color.sidebarDivider}`);
const $b341816979fee99b$export$8e6b12661156fe2f = (0, $8de346382d86c747$export$2e2bcd8739ae039).a($b341816979fee99b$var$t4 || ($b341816979fee99b$var$t4 = $b341816979fee99b$var$_`
    color: ${0};
    display: flex;
    height: 42px;
    ${0}
`), ({ theme: theme })=>theme.color.text, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $b341816979fee99b$export$eddf54ea3db8d0f0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b341816979fee99b$var$t5 || ($b341816979fee99b$var$t5 = $b341816979fee99b$var$_`
    display: flex;
    gap: 1rem;
`));


function $dbcf46d7f0dc128d$export$2e2bcd8739ae039({ title: title = '', description: description, children: children, prefix: prefix, tag: tag, items: items, licenseTag: licenseTag }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const { managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    if (managedOrgId) tag = t('organization.managed.titleShort');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            items && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $746bf81c54a0dba3$export$2e2bcd8739ae039), {
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$c0437c89e5dcfbb), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$ac90896a1379b2ac), {
                        children: [
                            prefix && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8), {
                                children: prefix
                            }),
                            tag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$3288d34c523a1192), {
                                children: tag
                            }),
                            licenseTag,
                            typeof title == 'string' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$d9f4918700223049), {
                                as: "h1",
                                children: title
                            }) : title,
                            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: description
                            })
                        ]
                    }),
                    children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$128b0389825fe3d5), {
                        children: children
                    })
                ]
            })
        ]
    });
}


function $3bdd92f3efb1b659$export$2e2bcd8739ae039({ pageTitle: pageTitle }) {
    const params = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: pageTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: params && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pre", {
                    children: JSON.stringify(params, null, 2)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "This page has not been created yet."
            })
        ]
    });
}














let $6392222d2b8fb222$var$_ = (t)=>t, $6392222d2b8fb222$var$t, $6392222d2b8fb222$var$t1, $6392222d2b8fb222$var$t2, $6392222d2b8fb222$var$t3, $6392222d2b8fb222$var$t4, $6392222d2b8fb222$var$t5;
const $6392222d2b8fb222$export$474db65c3c394e1c = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$fe91652f4f7f8d90))($6392222d2b8fb222$var$t || ($6392222d2b8fb222$var$t = $6392222d2b8fb222$var$_`
    font-weight: ${0};
    text-transform: capitalize;
`), (props)=>props.fontWeight || 400);
const $6392222d2b8fb222$export$2d914cb1a3b0bf58 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($6392222d2b8fb222$export$474db65c3c394e1c)($6392222d2b8fb222$var$t1 || ($6392222d2b8fb222$var$t1 = $6392222d2b8fb222$var$_`
    text-align: center;
    display: flex;
    align-items: center;
    align-self: center;
    gap: 0.5rem;
`));
const $6392222d2b8fb222$export$f37ee4cff56f2c69 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($6392222d2b8fb222$var$t2 || ($6392222d2b8fb222$var$t2 = $6392222d2b8fb222$var$_`
    font-weight: ${0};
`), (props)=>props.fontWeight || 400);
const $6392222d2b8fb222$export$68ed3e0616d4c778 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($6392222d2b8fb222$export$f37ee4cff56f2c69)($6392222d2b8fb222$var$t3 || ($6392222d2b8fb222$var$t3 = $6392222d2b8fb222$var$_`
    text-align: center;
    display: flex;
    align-self: center;
`));
const $6392222d2b8fb222$export$cd24fb4f2042953 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b))($6392222d2b8fb222$var$t4 || ($6392222d2b8fb222$var$t4 = $6392222d2b8fb222$var$_`
    color: ${0};
`), (props)=>props.theme.color.text);
const $6392222d2b8fb222$export$d14d08fa0d83d69d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b))($6392222d2b8fb222$var$t5 || ($6392222d2b8fb222$var$t5 = $6392222d2b8fb222$var$_`
    color: ${0};
    margin-bottom: 0.875rem;
`), (props)=>props.theme.color.textBody);










parcelRequire("7fPBF");



let $5292444ccdcf3a91$var$_ = (t)=>t, $5292444ccdcf3a91$var$t, $5292444ccdcf3a91$var$t1;
function $5292444ccdcf3a91$export$2e2bcd8739ae039(_param) {
    var { as: as, title: title, description: description, icon: icon, iconSize: iconSize = 100, fullHeight: fullHeight = false, children: children } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "as",
        "title",
        "description",
        "icon",
        "iconSize",
        "fullHeight",
        "children"
    ]);
    // try to appropriately set the heading level based on the fullHeight prop
    if (fullHeight) as = as || 'h1';
    else as = as || 'h3';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5292444ccdcf3a91$var$BannerCard, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        $fullHeight: fullHeight
    }, restProps), {
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: icon,
                size: iconSize
            }),
            title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65), {
                as: as,
                children: title
            }),
            description && typeof description === 'string' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: description
            }) : description,
            children
        ]
    }));
}
const $5292444ccdcf3a91$var$BannerCard = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($5292444ccdcf3a91$var$t || ($5292444ccdcf3a91$var$t = $5292444ccdcf3a91$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 600px;
    text-align: center;
    gap: 10px;
    flex-grow: 1;
    padding: 20px;
    ${0};
    ${0};
`), ({ $fullHeight: $fullHeight })=>$fullHeight && $5292444ccdcf3a91$var$FullHeight, (0, $19e0bc52fddd02b4$export$db407487374f02c9));
const $5292444ccdcf3a91$var$FullHeight = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($5292444ccdcf3a91$var$t1 || ($5292444ccdcf3a91$var$t1 = $5292444ccdcf3a91$var$_`
    height: 100%;
`));


let $347ffda0d89c401a$var$_ = (t)=>t, $347ffda0d89c401a$var$t, $347ffda0d89c401a$var$t1, $347ffda0d89c401a$var$t2, $347ffda0d89c401a$var$t3, $347ffda0d89c401a$var$t4, $347ffda0d89c401a$var$t5, $347ffda0d89c401a$var$t6, $347ffda0d89c401a$var$t7, $347ffda0d89c401a$var$t8, $347ffda0d89c401a$var$t9, $347ffda0d89c401a$var$t10, $347ffda0d89c401a$var$t11, $347ffda0d89c401a$var$t12, $347ffda0d89c401a$var$t13, $347ffda0d89c401a$var$t14, $347ffda0d89c401a$var$t15, $347ffda0d89c401a$var$t16, $347ffda0d89c401a$var$t17, $347ffda0d89c401a$var$t18, $347ffda0d89c401a$var$t19;
const $347ffda0d89c401a$export$a30053b04ba33ef5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t || ($347ffda0d89c401a$var$t = $347ffda0d89c401a$var$_`
    border-radius: 0.375rem;
    border: 1px solid ${0};
`), (props)=>props.theme.color.border);
const $347ffda0d89c401a$export$8ffb7ce587ade322 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t1 || ($347ffda0d89c401a$var$t1 = $347ffda0d89c401a$var$_`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    padding: 0.75rem 0;
    > svg {
        padding-top: 1rem;
    }
    &:not(:last-of-type) {
        border-bottom: 1px solid ${0};
    }
`), (props)=>props.theme.color.border);
const $347ffda0d89c401a$export$a27f3c48b2f1c458 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t2 || ($347ffda0d89c401a$var$t2 = $347ffda0d89c401a$var$_`
    display: flex;
    gap: 0.5rem;
    &:not(:last-of-type) {
        border-bottom: 1px solid ${0};
    }
`), (props)=>props.theme.color.border);
const $347ffda0d89c401a$export$401042fa3f49d26 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t3 || ($347ffda0d89c401a$var$t3 = $347ffda0d89c401a$var$_`
    position: relative;
    width: 16rem;
    min-height: 12rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    border-radius: 0.375rem;
    border: 1px solid ${0};
`), (props)=>props.theme.color.border);
const $347ffda0d89c401a$export$1056953590c5547a = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t4 || ($347ffda0d89c401a$var$t4 = $347ffda0d89c401a$var$_`
    display: flex;
    flex-direction: column;
    padding: 2.25rem;
    gap: 0.5rem;
    border-radius: 0.375rem;
    width: 24.625rem;
    max-width: 100vw;
    border: 1px solid ${0};
    background: ${0};
`), (props)=>props.theme.input.background, (props)=>props.theme.color.background);
const $347ffda0d89c401a$export$70dfb9c5a6f2c300 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t5 || ($347ffda0d89c401a$var$t5 = $347ffda0d89c401a$var$_`
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    padding: 2.25rem;
    gap: 0.5rem;
    border-radius: 0.375rem;
    background: ${0};
`), (props)=>props.theme.color.background);
const $347ffda0d89c401a$export$f2e4196c0d2b5bb8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t6 || ($347ffda0d89c401a$var$t6 = $347ffda0d89c401a$var$_`
    padding: 1.25rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 10rem;
`));
const $347ffda0d89c401a$export$256a01711efe0002 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t7 || ($347ffda0d89c401a$var$t7 = $347ffda0d89c401a$var$_`
    position: relative;
    flex: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: ${0};
    border-bottom: 1px solid ${0};
`), (props)=>props.theme.color.accentCard, (props)=>props.theme.color.border);
const $347ffda0d89c401a$export$9ee67e6e3f51a5ed = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t8 || ($347ffda0d89c401a$var$t8 = $347ffda0d89c401a$var$_`
    margin: 0;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`));
const $347ffda0d89c401a$export$546e21c7323442a2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t9 || ($347ffda0d89c401a$var$t9 = $347ffda0d89c401a$var$_`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
`));
const $347ffda0d89c401a$export$9de46b28c4f6c978 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t10 || ($347ffda0d89c401a$var$t10 = $347ffda0d89c401a$var$_`
    flex-basis: 100%;
    padding: 1.25rem 1.25rem 1.75rem 1.25rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
`));
const $347ffda0d89c401a$export$e258f2838ef6407 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t11 || ($347ffda0d89c401a$var$t11 = $347ffda0d89c401a$var$_`
    justify-self: space-between;
    align-self: stretch;
    flex-grow: 1;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: flex-end;
    align-items: stretch;
`));
const $347ffda0d89c401a$export$564cbe3426fc093a = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t12 || ($347ffda0d89c401a$var$t12 = $347ffda0d89c401a$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`));
const $347ffda0d89c401a$export$56d6cb3330e62b54 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($347ffda0d89c401a$export$564cbe3426fc093a)($347ffda0d89c401a$var$t13 || ($347ffda0d89c401a$var$t13 = $347ffda0d89c401a$var$_`
    justify-content: center;
    margin: 1rem 0 2rem 0;
`));
const $347ffda0d89c401a$export$1d05104315b67c54 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($347ffda0d89c401a$export$564cbe3426fc093a)($347ffda0d89c401a$var$t14 || ($347ffda0d89c401a$var$t14 = $347ffda0d89c401a$var$_`
    justify-content: space-between;
    align-items: center;
    width: 100%;

    & > :last-child {
        margin-left: auto;
    }
`));
const $347ffda0d89c401a$export$7a6f0da2e354fd03 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($347ffda0d89c401a$var$t15 || ($347ffda0d89c401a$var$t15 = $347ffda0d89c401a$var$_`
    margin-bottom: 0.5rem;
`));
const $347ffda0d89c401a$export$fd5345d4562e9833 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a6cc38c9c1109f8f))($347ffda0d89c401a$var$t16 || ($347ffda0d89c401a$var$t16 = $347ffda0d89c401a$var$_`
    position: absolute;
    top: -0.8rem;
    left: 50%;
    transform: translateX(-50%);
`));
const $347ffda0d89c401a$export$989506d4e6ea852a = (0, $6392222d2b8fb222$export$d14d08fa0d83d69d).withComponent('li');
const $347ffda0d89c401a$export$cd7bba038e96e3a1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($347ffda0d89c401a$var$t17 || ($347ffda0d89c401a$var$t17 = $347ffda0d89c401a$var$_`
    padding: 10px;
    columns: 2;
`));
const $347ffda0d89c401a$export$cdfe17842e70350d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039))($347ffda0d89c401a$var$t18 || ($347ffda0d89c401a$var$t18 = $347ffda0d89c401a$var$_`
    border-radius: 0.375rem;
    background: ${0};
    margin-top: 2rem;
    margin-bottom: 2rem;
`), (props)=>props.theme.color.accentCard);
const $347ffda0d89c401a$export$9bb2c5592f957d1c = (0, $8de346382d86c747$export$2e2bcd8739ae039)($347ffda0d89c401a$export$a30053b04ba33ef5)($347ffda0d89c401a$var$t19 || ($347ffda0d89c401a$var$t19 = $347ffda0d89c401a$var$_`
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 100%;
    max-width: 1200px;
    margin: 1rem auto 0 auto;
    padding: 1.5rem;
    gap: 1rem;
    border-left: 3px solid ${0};
    background-color: ${0};
    border-radius: ${0} ${0} ${0} ${0};
`), ({ $accent: $accent })=>$accent, (props)=>props.theme.color.card, (0, $8951886a6b49e92a$export$7a57f79000377ca2).micro, (0, $8951886a6b49e92a$export$7a57f79000377ca2).md, (0, $8951886a6b49e92a$export$7a57f79000377ca2).md, (0, $8951886a6b49e92a$export$7a57f79000377ca2).micro);


let $8d7313a1e2f7db62$var$_ = (t)=>t, $8d7313a1e2f7db62$var$t, $8d7313a1e2f7db62$var$t1, $8d7313a1e2f7db62$var$t2;
const $8d7313a1e2f7db62$var$CardStack = (_param)=>{
    var { id: id, title: title, description: description, name: name, size: size = 50, statusText: tag, tagNode: tagNode, children: children } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "id",
        "title",
        "description",
        "name",
        "size",
        "statusText",
        "tagNode",
        "children"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$8ffb7ce587ade322), {
        id: id,
        children: [
            name && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                name: name,
                size: size
            }, restProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8d7313a1e2f7db62$var$StackWrapCardText, {
                children: [
                    tag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8d7313a1e2f7db62$var$CustomTag, {
                        children: tag
                    }),
                    tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8d7313a1e2f7db62$var$CustomTagNode, {
                        children: [
                            tagNode,
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                children: title
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
};
// TODO: Did not want to change this because this at the time (Release)
// Should replace this with import of shared tag component: InlineTagNodeWrap
const $8d7313a1e2f7db62$var$CustomTagNode = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($8d7313a1e2f7db62$var$t || ($8d7313a1e2f7db62$var$t = $8d7313a1e2f7db62$var$_`
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`));
const $8d7313a1e2f7db62$var$CustomTag = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$3288d34c523a1192))($8d7313a1e2f7db62$var$t1 || ($8d7313a1e2f7db62$var$t1 = $8d7313a1e2f7db62$var$_`
    margin: 0;
`));
const $8d7313a1e2f7db62$var$StackWrapCardText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$9de46b28c4f6c978))($8d7313a1e2f7db62$var$t2 || ($8d7313a1e2f7db62$var$t2 = $8d7313a1e2f7db62$var$_`
    padding: 0 1.25rem 1.25rem 1.25rem;
`));
var $8d7313a1e2f7db62$export$2e2bcd8739ae039 = $8d7313a1e2f7db62$var$CardStack;



let $348d9e775387b4da$var$_ = (t)=>t, $348d9e775387b4da$var$t, $348d9e775387b4da$var$t1, $348d9e775387b4da$var$t2, $348d9e775387b4da$var$t3, $348d9e775387b4da$var$t4, $348d9e775387b4da$var$t5;
const $348d9e775387b4da$export$8a73847ccc40addf = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($348d9e775387b4da$var$t || ($348d9e775387b4da$var$t = $348d9e775387b4da$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 0 auto;
    padding: 0 0 0 2rem;
`));
const $348d9e775387b4da$export$5c96f0521c6e1626 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($348d9e775387b4da$var$t1 || ($348d9e775387b4da$var$t1 = $348d9e775387b4da$var$_`
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 2rem;
    margin: 0 auto;
    & > * {
        flex: 1 1 auto;
    }
`));
const $348d9e775387b4da$export$85a4c3b5f32264b8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($348d9e775387b4da$var$t2 || ($348d9e775387b4da$var$t2 = $348d9e775387b4da$var$_`
    max-width: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
    grid-column-gap: 1rem;
    margin: 1rem 0;
    & > * {
        display: block;
        min-width: 100%;
    }
`));
const $348d9e775387b4da$export$b684108872a6efff = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($348d9e775387b4da$var$t3 || ($348d9e775387b4da$var$t3 = $348d9e775387b4da$var$_`
    max-width: 100vw;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-column-gap: 1rem;
    margin: 1rem 2rem;
    justify-items: center;
    & > * {
        display: block;
        min-width: 100%;
    }
`));
const $348d9e775387b4da$export$e529837a22b31a11 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($348d9e775387b4da$var$t4 || ($348d9e775387b4da$var$t4 = $348d9e775387b4da$var$_`
    margin: 1rem;
    display: flex;
    justify-content: center;
`));
const $348d9e775387b4da$export$ef2184bd89960b14 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($348d9e775387b4da$var$t5 || ($348d9e775387b4da$var$t5 = $348d9e775387b4da$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 16rem), 16rem));
    justify-content: start;
    gap: 1rem;
    margin: 0.5rem 0;
`));











var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
'use client';
function $86c63002f4c86923$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $7fPBF.useRef(undefined);
    const refEffect = $7fPBF.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup === null || refCleanup === void 0 ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
    return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
}


function $f6d27cbe60518e62$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $7fPBF = parcelRequire("7fPBF");
function $1c288d38aeb7dcee$export$2e2bcd8739ae039(element) {
    var _element_props;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($7fPBF.version, 10) >= 19) return (element === null || element === void 0 ? void 0 : (_element_props = element.props) === null || _element_props === void 0 ? void 0 : _element_props.ref) || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element === null || element === void 0 ? void 0 : element.ref) || null;
}




/**
 * Copied from @base-ui/utils
 *
 * Shadow DOM-aware containment check.
 *
 * Native `parent.contains(child)` returns `false` when the child is inside a
 * shadow root that is a descendant of the parent. This function handles that
 * case by traversing up through shadow root hosts.
 *
 * @param parent - The potential ancestor element.
 * @param child - The potential descendant element.
 * @returns Whether `parent` contains `child`, even across shadow root boundaries.
 */ function $9028c966bc380775$export$2e2bcd8739ae039(parent, child) {
    var _child_getRootNode;
    if (!parent || !child) return false;
    // First, attempt with the faster native method.
    if (parent.contains(child)) return true;
    // Then fall back to traversing out of shadow roots when needed.
    const rootNode = (_child_getRootNode = child.getRootNode) === null || _child_getRootNode === void 0 ? void 0 : _child_getRootNode.call(child);
    if (rootNode && rootNode instanceof ShadowRoot) {
        let next = child;
        while(next){
            if (parent === next) return true;
            var _next_parentNode, _ref;
            next = (_ref = (_next_parentNode = next.parentNode) !== null && _next_parentNode !== void 0 ? _next_parentNode : next.host) !== null && _ref !== void 0 ? _ref : null;
        }
    }
    return false;
}


var $ce3a34ab77d30b1b$export$2e2bcd8739ae039 = (0, $9028c966bc380775$export$2e2bcd8739ae039);


/**
 * Gets the actual active element, traversing through shadow roots if necessary.
 *
 * When an element inside a shadow root has focus, `document.activeElement` returns
 * the shadow host element. This function recursively traverses shadow roots to find
 * the actual focused element.
 *
 * @param root - The document or shadow root to start the search from.
 * @returns The actual focused element, or null if no element has focus.
 *
 * @example
 * // In a shadow DOM context
 * const activeElement = getActiveElement(document);
 * // Returns the actual focused element inside the shadow root
 *
 * @example
 * // Starting from a specific document
 * const activeElement = getActiveElement(ownerDocument(element));
 */ function $cffea48de8ee8b2e$export$2e2bcd8739ae039(doc) {
    var _element_shadowRoot;
    let element = doc.activeElement;
    while((element === null || element === void 0 ? void 0 : (_element_shadowRoot = element.shadowRoot) === null || _element_shadowRoot === void 0 ? void 0 : _element_shadowRoot.activeElement) != null)element = element.shadowRoot.activeElement;
    return element;
}


var $bf9d1879104a7d85$export$2e2bcd8739ae039 = (0, $cffea48de8ee8b2e$export$2e2bcd8739ae039);


const $61cbbbb9ef851fb1$export$1022acd1ec27c201 = 'data-mui-focusable';
function $61cbbbb9ef851fb1$export$37c39ceada63b0c7(rootElement) {
    if (!rootElement) return null;
    return rootElement.hasAttribute($61cbbbb9ef851fb1$export$1022acd1ec27c201) ? rootElement : rootElement.querySelector(`[${$61cbbbb9ef851fb1$export$1022acd1ec27c201}]`);
}



'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $ad54025a02984b15$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $ad54025a02984b15$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $ad54025a02984b15$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $ad54025a02984b15$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $ad54025a02984b15$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $ad54025a02984b15$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($ad54025a02984b15$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $ad54025a02984b15$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$ad54025a02984b15$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $ad54025a02984b15$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $ad54025a02984b15$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $ad54025a02984b15$var$defaultGetTabbable, isEnabled: isEnabled = $ad54025a02984b15$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)((0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // Reset on every mount — React 18 Strict Mode double-mounts leave this
        // stuck at `true` after the cleanup of the previous mount set it.
        ignoreNextEnforceFocus.current = false;
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(rootRef.current);
        const activeElement = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
        var _getFocusTarget;
        // Prefer the explicitly marked focusable element. Fall back to the root
        // element for generic FocusTrap usage.
        const focusTarget = (_getFocusTarget = (0, $61cbbbb9ef851fb1$export$37c39ceada63b0c7)(rootRef.current)) !== null && _getFocusTarget !== void 0 ? _getFocusTarget : rootRef.current;
        if (!(0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(rootRef.current, activeElement)) {
            if (!focusTarget.hasAttribute('tabIndex')) focusTarget.setAttribute('tabIndex', '-1');
            if (activated.current) focusTarget.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus && nodeToRestore.current) {
                ignoreNextEnforceFocus.current = true;
                nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            const rootElement = rootRef.current;
            const activeElement = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
            if (rootElement === null) return;
            const focusTarget = (0, $61cbbbb9ef851fb1$export$37c39ceada63b0c7)(rootElement);
            const isFocusStart = activeElement === rootElement || activeElement === focusTarget;
            // Marked focus targets can be non-tabbable, but should start tabbing
            // from the first/last tabbable child.
            if (isFocusStart) {
                const tabbable = getTabbable(rootElement);
                if (tabbable.length === 0) return;
                nativeEvent.preventDefault();
                if (nativeEvent.shiftKey) tabbable[tabbable.length - 1].focus();
                else tabbable[0].focus();
                return;
            }
            if ((0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(rootElement, activeElement)) {
                const tabbable = getTabbable(rootElement);
                const currentIndex = tabbable.indexOf(activeElement);
                if (currentIndex === -1) // Leave shadow-root descendants to native tab handling.
                return;
                const hasPositiveTabIndex = tabbable.some((node)=>$ad54025a02984b15$var$getTabIndex(node) > 0);
                // Positive tabIndex needs the computed order; regular tabIndex=0 can
                // use native tab handling.
                if (!hasPositiveTabIndex) return;
                nativeEvent.preventDefault();
                let nextIndex = 0;
                if (nativeEvent.shiftKey) nextIndex = currentIndex <= 0 ? tabbable.length - 1 : currentIndex - 1;
                else nextIndex = currentIndex === tabbable.length - 1 ? 0 : currentIndex + 1;
                tabbable[nextIndex].focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            const activeEl = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if ((0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(rootElement, activeEl)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (activeEl !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown_current, _lastKeydown_current1;
                const isShiftTab = Boolean(((_lastKeydown_current = lastKeydown.current) === null || _lastKeydown_current === void 0 ? void 0 : _lastKeydown_current.shiftKey) && ((_lastKeydown_current1 = lastKeydown.current) === null || _lastKeydown_current1 === void 0 ? void 0 : _lastKeydown_current1.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            const activeEl = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
            if (activeEl && activeEl.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $ad54025a02984b15$export$2e2bcd8739ae039 = $ad54025a02984b15$var$FocusTrap;



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $2f83cafe8ca49a0a$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}





'use client';
function $c6730ab5de482f0d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $c6730ab5de482f0d$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? (0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($c6730ab5de482f0d$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $2f83cafe8ca49a0a$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $2f83cafe8ca49a0a$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode;
});
var $c6730ab5de482f0d$export$2e2bcd8739ae039 = $c6730ab5de482f0d$var$Portal;









var $7fPBF = parcelRequire("7fPBF");











/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $6b6af0ee4304783c$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $6b6af0ee4304783c$export$2e2bcd8739ae039 = $6b6af0ee4304783c$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $d665962efb9ba42e$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, otherProps), {
        ownerState: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, otherProps.ownerState, ownerState)
    });
}
var $d665962efb9ba42e$export$2e2bcd8739ae039 = $d665962efb9ba42e$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $7e6c8eda416e9255$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $7e6c8eda416e9255$export$2e2bcd8739ae039 = $7e6c8eda416e9255$var$resolveComponentProps;




// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $7847d856aad7e6a5$export$2e2bcd8739ae039(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 */ function $d6f21882b2ade459$var$extractEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    for (const prop of Object.keys(object))if ((0, $7847d856aad7e6a5$export$2e2bcd8739ae039)(prop, object[prop])) result[prop] = object[prop];
    return result;
}
var $d6f21882b2ade459$export$2e2bcd8739ae039 = $d6f21882b2ade459$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $ea67696afb87138e$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $ea67696afb87138e$export$2e2bcd8739ae039 = $ea67696afb87138e$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $6e74c8f8fbb8fba6$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className, className, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.style, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style);
        const props = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $d6f21882b2ade459$export$2e2bcd8739ae039)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $ea67696afb87138e$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $ea67696afb87138e$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(internalSlotProps === null || internalSlotProps === void 0 ? void 0 : internalSlotProps.className, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className, className, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, internalSlotProps === null || internalSlotProps === void 0 ? void 0 : internalSlotProps.style, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.style, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style);
    const props = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $6e74c8f8fbb8fba6$export$2e2bcd8739ae039 = $6e74c8f8fbb8fba6$var$mergeSlotProps;


'use client';
function $5f8e5bdc972f8f36$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false } = parameters, useSlotPropsParams = (0, $8901fc92b5563702$export$71511d61b312f219)(parameters, [
        "className",
        "elementType",
        "ownerState",
        "externalForwardedProps",
        "internalForwardedProps",
        "shouldForwardComponentProp"
    ]);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $8901fc92b5563702$export$71511d61b312f219)(externalForwardedProps, [
        "component",
        "slots",
        "slotProps"
    ]);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $6e74c8f8fbb8fba6$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: className
    }, useSlotPropsParams), {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_mergeSlotProps.props, [
        "component"
    ]);
    const ref = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps === null || resolvedComponentsProps === void 0 ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $d665962efb9ba42e$export$2e2bcd8739ae039)(elementType, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && !shouldForwardComponentProp && {
        as: LeafComponent
    }, LeafComponent && shouldForwardComponentProp && {
        component: LeafComponent
    }), {
        ref: ref
    }), ownerState);
    return [
        elementType,
        props
    ];
}






var $7fPBF = parcelRequire("7fPBF");



/// <reference path="./react-transition-group.d.ts" />


var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
'use client';
const $4a8eb4c5718f0b0a$var$UNINITIALIZED = {};
function $4a8eb4c5718f0b0a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($4a8eb4c5718f0b0a$var$UNINITIALIZED);
    if (ref.current === $4a8eb4c5718f0b0a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
function $6ddf17963088dc3f$export$2e2bcd8739ae039(value) {
    const latest = (0, $4a8eb4c5718f0b0a$export$2e2bcd8739ae039)(()=>$6ddf17963088dc3f$var$createValueRef(value)).current;
    latest.next = value;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- effect never changes; it reads latest.next.
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(latest.effect);
    return latest;
}
function $6ddf17963088dc3f$var$createValueRef(value) {
    const latest = {
        current: value,
        next: value,
        effect: ()=>{
            latest.current = latest.next;
        }
    };
    return latest;
}



var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);




'use client';
function $21f9c8c3b3e8932a$var$resolveTimeouts(timeout) {
    if (timeout == null) return {
        appear: undefined,
        enter: undefined,
        exit: undefined
    };
    if (typeof timeout === 'number') return {
        appear: timeout,
        enter: timeout,
        exit: timeout
    };
    const enter = timeout.enter;
    const exit = timeout.exit;
    const appear = timeout.appear !== undefined ? timeout.appear : enter;
    return {
        appear: appear,
        enter: enter,
        exit: exit
    };
}
/**
 * Resolves the authored completion timeout for the current transition phase.
 * Auto durations are read by the caller at scheduling time so Grow/Collapse
 * can pass the latest measured value without storing it in React state.
 */ function $21f9c8c3b3e8932a$var$getCompletionTimeout(params) {
    if (params.autoTimeout != null) return params.autoTimeout;
    const resolved = $21f9c8c3b3e8932a$var$resolveTimeouts(params.timeout);
    var _resolved_appear, _ref, _resolved_enter;
    if (params.currentStatus === 'entering') return params.isAppearing ? (_ref = (_resolved_appear = resolved.appear) !== null && _resolved_appear !== void 0 ? _resolved_appear : resolved.enter) !== null && _ref !== void 0 ? _ref : null : (_resolved_enter = resolved.enter) !== null && _resolved_enter !== void 0 ? _resolved_enter : null;
    var _resolved_exit;
    return (_resolved_exit = resolved.exit) !== null && _resolved_exit !== void 0 ? _resolved_exit : null;
}
function $21f9c8c3b3e8932a$var$Transition(props) {
    const { in: inProp = false, appear: appear = false, enter: enter = true, exit: exit = true, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, timeout: timeout, addEndListener: addEndListener, reduceMotion: reduceMotion = false, getAutoTimeout: getAutoTimeout, nodeRef: nodeRef, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, children: children } = props, childProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "in",
        "appear",
        "enter",
        "exit",
        "mountOnEnter",
        "unmountOnExit",
        "timeout",
        "addEndListener",
        "reduceMotion",
        "getAutoTimeout",
        "nodeRef",
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "children"
    ]);
    const parentGroup = $7fPBF.useContext((0, $61c94efb1735eff6$export$2e2bcd8739ae039));
    // react-transition-group's TransitionGroup tells children whether the group
    // is still mounting. Material UI needs two values from that:
    // - shouldEnterOnMount: whether this child should run an enter animation now.
    // - isAppearing: the value passed to enter callbacks.
    // A child added after the group mounted still enters, but callbacks receive
    // isAppearing=false because the parent group is no longer mounting.
    const shouldEnterOnMount = parentGroup && !parentGroup.isMounting ? enter : appear;
    const [status, setStatus] = $7fPBF.useState(()=>{
        if (inProp) return shouldEnterOnMount ? 'exited' : 'entered';
        if (mountOnEnter || unmountOnExit) return 'unmounted';
        return 'exited';
    });
    const statusRef = $7fPBF.useRef(status);
    statusRef.current = status;
    // Opening from `unmounted`: mount the child in the same commit that `in` turns
    // true so its ref is attached before effects run. react-transition-group did
    // this by deriving the status from props during render; handling it in a
    // layout effect instead would add a commit where the child is still null,
    // breaking consumers that read the ref right after `in` flips.
    if (inProp && status === 'unmounted') {
        statusRef.current = 'exited';
        setStatus('exited');
    }
    const shouldAppearOnMountRef = $7fPBF.useRef(inProp && shouldEnterOnMount);
    const mountedRef = $7fPBF.useRef(false);
    const nextCallbackRef = $7fPBF.useRef(null);
    // Remember which status already fired lifecycle callbacks. React StrictMode
    // can run effects twice in development; this prevents duplicate callbacks.
    const lastFiredStatusRef = $7fPBF.useRef(status);
    // Store the isAppearing value for the current enter transition. performEnter
    // sets it before the status effect later calls onEntering/onEntered.
    const isAppearingRef = $7fPBF.useRef(false);
    // Capture reduced motion at the start of each phase so prop updates do not
    // change the completion timing for an active transition.
    const transitionReduceMotionRef = $7fPBF.useRef(reduceMotion);
    // Transition end callbacks can run after props changed. Read props through
    // this ref so delayed work uses the latest callbacks and timeout settings.
    const propsRef = (0, $6ddf17963088dc3f$export$2e2bcd8739ae039)({
        timeout: timeout,
        addEndListener: addEndListener,
        reduceMotion: reduceMotion,
        getAutoTimeout: getAutoTimeout,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        enter: enter,
        exit: exit,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        nodeRef: nodeRef,
        parentGroup: parentGroup
    });
    // Effects below depend on these helpers. Keep their identity stable; they read
    // changing props through propsRef.
    const cancelPendingCallback = $7fPBF.useCallback(()=>{
        if (nextCallbackRef.current !== null) {
            nextCallbackRef.current.cancel();
            nextCallbackRef.current = null;
        }
    }, []);
    const makeCallback = $7fPBF.useCallback((handler)=>{
        let active = true;
        const wrapped = ()=>{
            if (active) {
                active = false;
                nextCallbackRef.current = null;
                handler();
            }
        };
        wrapped.cancel = ()=>{
            active = false;
        };
        nextCallbackRef.current = wrapped;
        return wrapped;
    }, []);
    const scheduleTransitionEnd = $7fPBF.useCallback((nextStatus, currentStatus)=>{
        var _propsRef_current_getAutoTimeout, _propsRef_current;
        let timeoutId;
        const clearTimer = ()=>{
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
                timeoutId = undefined;
            }
        };
        const done = makeCallback(()=>{
            clearTimer();
            statusRef.current = nextStatus;
            setStatus(nextStatus);
        });
        const cancelDone = done.cancel;
        done.cancel = ()=>{
            clearTimer();
            cancelDone();
        };
        const node = propsRef.current.nodeRef.current;
        const listener = propsRef.current.addEndListener;
        const hasAutoTimeout = propsRef.current.getAutoTimeout !== undefined;
        const autoTimeout = (_propsRef_current_getAutoTimeout = (_propsRef_current = propsRef.current).getAutoTimeout) === null || _propsRef_current_getAutoTimeout === void 0 ? void 0 : _propsRef_current_getAutoTimeout.call(_propsRef_current);
        const authoredTimeout = $21f9c8c3b3e8932a$var$getCompletionTimeout({
            currentStatus: currentStatus,
            isAppearing: isAppearingRef.current,
            timeout: propsRef.current.timeout,
            autoTimeout: autoTimeout
        });
        const transitionReduceMotion = transitionReduceMotionRef.current;
        // Auto-duration consumers may skip measurement under reduced motion, but
        // still need a 0ms timeout when they provide addEndListener.
        const fallbackTimeout = authoredTimeout !== null && authoredTimeout !== void 0 ? authoredTimeout : transitionReduceMotion && hasAutoTimeout ? 0 : null;
        const scheduleTimer = (value)=>{
            timeoutId = setTimeout(done, value);
        };
        if (!node) {
            // Match react-transition-group: if there is no DOM node, there is no
            // transition to observe, so finish on the next tick.
            scheduleTimer(0);
            return;
        }
        if (listener) {
            if (fallbackTimeout != null) scheduleTimer(transitionReduceMotion ? 0 : fallbackTimeout);
            // With nodeRef, react-transition-group calls addEndListener(done).
            // Material UI has long supported addEndListener(node, done). Keep both call
            // shapes so existing transition wrappers do not have to change.
            if (listener.length >= 2) listener(node, done);
            else listener(done);
            return;
        }
        scheduleTimer(transitionReduceMotion ? 0 : authoredTimeout !== null && authoredTimeout !== void 0 ? authoredTimeout : 0);
    }, [
        makeCallback,
        propsRef
    ]);
    const performEnter = $7fPBF.useCallback((mounting)=>{
        var _current_onEnter;
        const current = propsRef.current;
        const isAppearing = current.parentGroup ? current.parentGroup.isMounting : mounting;
        isAppearingRef.current = isAppearing;
        // On updates, enter=false skips the enter animation. Move straight to
        // entered; the status effect will call onEntered, but onEnter/onEntering
        // must not fire.
        if (!mounting && !current.enter) {
            statusRef.current = 'entered';
            setStatus('entered');
            return;
        }
        transitionReduceMotionRef.current = current.reduceMotion;
        (_current_onEnter = current.onEnter) === null || _current_onEnter === void 0 ? void 0 : _current_onEnter.call(current, isAppearing);
        statusRef.current = 'entering';
        setStatus('entering');
    }, [
        propsRef
    ]);
    const performExit = $7fPBF.useCallback(()=>{
        var _current_onExit;
        const current = propsRef.current;
        if (!current.exit) {
            statusRef.current = 'exited';
            setStatus('exited');
            return;
        }
        transitionReduceMotionRef.current = current.reduceMotion;
        (_current_onExit = current.onExit) === null || _current_onExit === void 0 ? void 0 : _current_onExit.call(current);
        statusRef.current = 'exiting';
        setStatus('exiting');
    }, [
        propsRef
    ]);
    const updateStatus = $7fPBF.useCallback((mounting, nextStatus)=>{
        cancelPendingCallback();
        if (nextStatus === 'entering') {
            const current = propsRef.current;
            // If the node was just mounted, read layout before entering so the
            // browser applies the starting styles before the animation begins.
            if (current.mountOnEnter || current.unmountOnExit) {
                const node = current.nodeRef.current;
                if (node) (0, $0ea347727154ba9d$export$b7a864e1eaef9de5)(node);
            }
            performEnter(mounting);
        } else performExit();
    }, [
        cancelPendingCallback,
        performEnter,
        performExit,
        propsRef
    ]);
    // Runs on mount. useEnhancedEffect is needed because the initial appear
    // transition may read layout before paint. In StrictMode development builds,
    // React mounts, cleans up, and mounts again; cleanup cancels pending work and
    // the second mount restarts the same transition.
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        mountedRef.current = true;
        if (shouldAppearOnMountRef.current) {
            shouldAppearOnMountRef.current = false;
            updateStatus(true, 'entering');
        }
        return ()=>{
            mountedRef.current = false;
            cancelPendingCallback();
        };
    }, [
        cancelPendingCallback,
        updateStatus
    ]);
    // Reconcile the rendered status after `in` or status changes:
    // - opening from unmounted is handled during render (see above) so the child
    //   is committed as exited with its ref attached before this effect runs.
    // - unmountOnExit removes the child after the exited state commits.
    // This matches react-transition-group's observable status steps without
    // running work after unrelated commits.
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!mountedRef.current) return;
        const current = statusRef.current;
        if (inProp) {
            if (current !== 'entering' && current !== 'entered') updateStatus(false, 'entering');
        } else if (current === 'entering' || current === 'entered') updateStatus(false, 'exiting');
        else if (current === 'exited' && unmountOnExit) {
            statusRef.current = 'unmounted';
            setStatus('unmounted');
        }
    }, [
        inProp,
        status,
        unmountOnExit,
        updateStatus
    ]);
    // Fire lifecycle callbacks for committed status changes. The guard prevents
    // duplicate callbacks in StrictMode; propsRef keeps delayed callbacks fresh.
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        var _current_onEntered, _current_onExited;
        // `unmounted` is bookkeeping, not a real transition state. Do not fire
        // callbacks when moving into or out of it; otherwise the first open with
        // mountOnEnter/unmountOnExit would look like a completed exit.
        if (status === 'unmounted' || lastFiredStatusRef.current === 'unmounted') {
            lastFiredStatusRef.current = status;
            return;
        }
        const prev = lastFiredStatusRef.current;
        if (prev === status) return;
        lastFiredStatusRef.current = status;
        const current = propsRef.current;
        if (status === 'entering') {
            var _current_onEntering;
            (_current_onEntering = current.onEntering) === null || _current_onEntering === void 0 ? void 0 : _current_onEntering.call(current, isAppearingRef.current);
            scheduleTransitionEnd('entered', 'entering');
        } else if (status === 'exiting') {
            var _current_onExiting;
            (_current_onExiting = current.onExiting) === null || _current_onExiting === void 0 ? void 0 : _current_onExiting.call(current);
            scheduleTransitionEnd('exited', 'exiting');
        } else if (status === 'entered') (_current_onEntered = current.onEntered) === null || _current_onEntered === void 0 ? void 0 : _current_onEntered.call(current, isAppearingRef.current);
        else if (status === 'exited') (_current_onExited = current.onExited) === null || _current_onExited === void 0 ? void 0 : _current_onExited.call(current);
    }, [
        propsRef,
        scheduleTransitionEnd,
        status
    ]);
    if (status === 'unmounted') return null;
    // Nested Material UI transitions should not inherit this transition's parent group.
    // A null context keeps an outer TransitionGroup from controlling them.
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: children(status, childProps)
    });
}
var $21f9c8c3b3e8932a$export$2e2bcd8739ae039 = $21f9c8c3b3e8932a$var$Transition;




var $7fPBF = parcelRequire("7fPBF");

'use client';
const $1fb9020c3655f750$var$MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
const $1fb9020c3655f750$var$REDUCED_MOTION_DURATION = 0;
const $1fb9020c3655f750$var$REDUCED_MOTION_DELAY = '0ms';
const $1fb9020c3655f750$var$NOOP = ()=>{};
const $1fb9020c3655f750$var$getDefaultSnapshot = ()=>false;
const $1fb9020c3655f750$var$getReducedMotionSnapshot = ()=>true;
const $1fb9020c3655f750$var$subscribeNoop = ()=>$1fb9020c3655f750$var$NOOP;
/**
 * Subscribes to the OS reduced-motion media query only when the theme mode needs it.
 * React 17 reads the media query after mount, matching useMediaQuery's fallback path.
 */ function $1fb9020c3655f750$var$useReducedMotionMediaQueryOld(enabled) {
    const [queryState, setQueryState] = $7fPBF.useState(()=>({
            enabled: enabled,
            matches: enabled ? null : false
        }));
    let matches = queryState.matches;
    if (queryState.enabled !== enabled) {
        matches = null;
        if (!enabled) matches = false;
    }
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        const setResolvedMatches = (nextMatches)=>{
            setQueryState((previousState)=>{
                if (previousState.enabled === enabled && previousState.matches === nextMatches) return previousState;
                return {
                    enabled: enabled,
                    matches: nextMatches
                };
            });
        };
        if (!enabled) {
            if (queryState.enabled) setResolvedMatches(false);
            return undefined;
        }
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            setResolvedMatches(false);
            return undefined;
        }
        const mediaQueryList = window.matchMedia($1fb9020c3655f750$var$MEDIA_QUERY);
        const update = ()=>{
            setResolvedMatches(mediaQueryList.matches);
        };
        update();
        mediaQueryList.addEventListener('change', update);
        return ()=>{
            mediaQueryList.removeEventListener('change', update);
        };
    }, [
        enabled,
        queryState.enabled
    ]);
    return matches;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $1fb9020c3655f750$var$safeReact = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fPBF);
const $1fb9020c3655f750$var$maybeReactUseSyncExternalStore = $1fb9020c3655f750$var$safeReact.useSyncExternalStore;
/**
 * React 18+ can read the media query during client renders, so newly mounted
 * transitions do not start from the SSR-safe reduced-motion default.
 */ function $1fb9020c3655f750$var$useReducedMotionMediaQueryNew(enabled) {
    const getServerSnapshot = enabled ? $1fb9020c3655f750$var$getReducedMotionSnapshot : $1fb9020c3655f750$var$getDefaultSnapshot;
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (!enabled || typeof window === 'undefined' || typeof window.matchMedia !== 'function') return [
            $1fb9020c3655f750$var$getDefaultSnapshot,
            $1fb9020c3655f750$var$subscribeNoop
        ];
        const mediaQueryList = window.matchMedia($1fb9020c3655f750$var$MEDIA_QUERY);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        enabled
    ]);
    return $1fb9020c3655f750$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
const $1fb9020c3655f750$var$useReducedMotionMediaQuery = $1fb9020c3655f750$var$maybeReactUseSyncExternalStore !== undefined ? $1fb9020c3655f750$var$useReducedMotionMediaQueryNew : $1fb9020c3655f750$var$useReducedMotionMediaQueryOld;
function $1fb9020c3655f750$export$2e2bcd8739ae039(mode, disablePrefersReducedMotion) {
    const prefersReducedMotion = $1fb9020c3655f750$var$useReducedMotionMediaQuery(!disablePrefersReducedMotion && mode === 'system');
    const shouldReduceMotion = !disablePrefersReducedMotion && (mode === 'always' || mode === 'system' && prefersReducedMotion !== false);
    return $7fPBF.useMemo(()=>({
            shouldReduceMotion: shouldReduceMotion,
            getTransitionTiming (timing) {
                if (!shouldReduceMotion) return timing;
                return {
                    duration: $1fb9020c3655f750$var$REDUCED_MOTION_DURATION,
                    delay: $1fb9020c3655f750$var$REDUCED_MOTION_DELAY
                };
            }
        }), [
        shouldReduceMotion
    ]);
}


parcelRequire("7fPBF");



'use client';
function $17852965b9ddab5b$export$2e2bcd8739ae039() {
    const theme = (0, $9da1e3d1169cfe7e$export$2e2bcd8739ae039)((0, $7a5b46fd67f157c3$export$2e2bcd8739ae039));
    return theme[0, $3096faf8e377d232$export$2e2bcd8739ae039] || theme;
}




'use client';
var $e25ff38916f49b9a$export$2e2bcd8739ae039 = (0, $86c63002f4c86923$export$2e2bcd8739ae039);



'use client';
const $0f34aa3278e20e02$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    },
    exiting: {
        opacity: 0
    },
    exited: {
        opacity: 0
    }
};
const $0f34aa3278e20e02$var$hiddenStyles = {
    opacity: 0,
    visibility: 'hidden'
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 */ const $0f34aa3278e20e02$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, disablePrefersReducedMotion: disablePrefersReducedMotion = false, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "addEndListener",
        "appear",
        "children",
        "disablePrefersReducedMotion",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout"
    ]);
    const reducedMotion = (0, $1fb9020c3655f750$export$2e2bcd8739ae039)(theme.motion.reducedMotion, disablePrefersReducedMotion);
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(nodeRef, (0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(children), ref);
    const handleEntering = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, onEntering);
    const handleEnter = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, (node, isAppearing)=>{
        if (!reducedMotion.shouldReduceMotion) (0, $0ea347727154ba9d$export$b7a864e1eaef9de5)(node); // Force layout so the animation starts from the initial styles.
        const transitionProps = (0, $0ea347727154ba9d$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        const transitionTiming = reducedMotion.getTransitionTiming({
            duration: transitionProps.duration,
            delay: transitionProps.delay
        });
        node.style.transition = theme.transitions.create('opacity', {
            duration: transitionTiming.duration,
            easing: transitionProps.easing,
            delay: transitionTiming.delay
        });
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, onEntered);
    const handleExiting = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, onExiting);
    const handleExit = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, (node)=>{
        const transitionProps = (0, $0ea347727154ba9d$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        const transitionTiming = reducedMotion.getTransitionTiming({
            duration: transitionProps.duration,
            delay: transitionProps.delay
        });
        node.style.transition = theme.transitions.create('opacity', {
            duration: transitionTiming.duration,
            easing: transitionProps.easing,
            delay: transitionTiming.delay
        });
        if (onExit) onExit(node);
    });
    const handleExited = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, (node)=>{
        // Clear transition CSS after exit so fixed elements like Backdrop do not
        // keep a compositor layer alive and cause idle CPU usage. handleEnter sets
        // it again on next open.
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = addEndListener ? (next)=>{
        addEndListener(nodeRef.current, next);
    } : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f9c8c3b3e8932a$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        reduceMotion: reducedMotion.shouldReduceMotion,
        timeout: timeout
    }, other), {
        children: (state, _param)=>{
            var { ownerState: ownerState } = _param, restChildProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "ownerState"
            ]);
            // Do not pass ownerState to a DOM child. ownerState is only for
            // Material UI styling, and React would treat it as an invalid DOM attribute.
            const childStyle = (0, $0ea347727154ba9d$export$c1e03ca92f01ef32)(state, inProp, $0f34aa3278e20e02$var$styles, $0f34aa3278e20e02$var$hiddenStyles, style, children.props.style);
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                style: childStyle,
                ref: handleRef
            }, restChildProps));
        }
    }));
});
var $0f34aa3278e20e02$export$2e2bcd8739ae039 = $0f34aa3278e20e02$var$Fade;




function $53ccdc39905cbd48$export$9927a91fd93152bd(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $53ccdc39905cbd48$var$backdropClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $53ccdc39905cbd48$export$2e2bcd8739ae039 = $53ccdc39905cbd48$var$backdropClasses;



'use client';
const $981c78e9e523e91e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $53ccdc39905cbd48$export$9927a91fd93152bd), classes);
};
const $981c78e9e523e91e$var$BackdropRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $981c78e9e523e91e$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, transitionDuration: transitionDuration } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "component",
        "invisible",
        "open",
        "slotProps",
        "slots",
        "transitionDuration"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        invisible: invisible
    });
    const classes = $981c78e9e523e91e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        component: component,
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        elementType: $981c78e9e523e91e$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $0f34aa3278e20e02$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        in: open,
        timeout: transitionDuration
    }, other, transitionProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
            ref: ref,
            children: children
        }))
    }));
});
var $981c78e9e523e91e$export$2e2bcd8739ae039 = $981c78e9e523e91e$var$Backdrop;





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

'use client';
/**
 * Inspired by https://github.com/react/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $3dbbba1106564c4f$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $3dbbba1106564c4f$export$2e2bcd8739ae039 = $3dbbba1106564c4f$var$useEventCallback;


/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c67646090daa5c9c$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




function $e6403c3a02044c6f$export$2e2bcd8739ae039(node) {
    const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $07f2847d4540e4ff$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


// Is a vertical scrollbar displayed?
function $bd22517014220799$var$isOverflowing(container) {
    const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $e6403c3a02044c6f$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $bd22517014220799$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $bd22517014220799$var$getPaddingRight(element) {
    return parseFloat((0, $e6403c3a02044c6f$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight) || 0;
}
function $bd22517014220799$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $bd22517014220799$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$bd22517014220799$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $bd22517014220799$export$e1bd0c6150f13d96(element, hide);
    });
}
function $bd22517014220799$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $bd22517014220799$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($bd22517014220799$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $07f2847d4540e4ff$export$2e2bcd8739ae039)((0, $e6403c3a02044c6f$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$bd22517014220799$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$bd22517014220799$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $e6403c3a02044c6f$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent === null || parent === void 0 ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $bd22517014220799$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $bd22517014220799$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $bd22517014220799$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $bd22517014220799$var$getHiddenSiblings(container);
        $bd22517014220799$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $bd22517014220799$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $bd22517014220799$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $bd22517014220799$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $bd22517014220799$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $bd22517014220799$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $bd22517014220799$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $bd22517014220799$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.modals = [];
        this.containers = [];
    }
}


'use client';
function $851c1a711c6784df$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $851c1a711c6784df$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $851c1a711c6784df$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $851c1a711c6784df$var$manager = new (0, $bd22517014220799$export$ce11c4ecd08cea67)();
function $851c1a711c6784df$var$useModal(parameters) {
    const { container: container, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $851c1a711c6784df$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $851c1a711c6784df$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $851c1a711c6784df$var$getContainer(container) || getDoc().body;
        $851c1a711c6784df$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$851c1a711c6784df$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $bd22517014220799$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        $851c1a711c6784df$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers_onKeyDown;
            (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers_onClick;
            (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $d6f21882b2ade459$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, propsEventHandlers, otherHandlers);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation'
        }, externalEventHandlers), {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            'aria-hidden': true
        }, externalEventHandlers), {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        var _children_props_onEnter, _children_props_onExited;
        return {
            onEnter: (0, $c67646090daa5c9c$export$2e2bcd8739ae039)(handleEnter, (_children_props_onEnter = children === null || children === void 0 ? void 0 : children.props.onEnter) !== null && _children_props_onEnter !== void 0 ? _children_props_onEnter : $851c1a711c6784df$var$noop),
            onExited: (0, $c67646090daa5c9c$export$2e2bcd8739ae039)(handleExited, (_children_props_onExited = children === null || children === void 0 ? void 0 : children.props.onExited) !== null && _children_props_onExited !== void 0 ? _children_props_onExited : $851c1a711c6784df$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $851c1a711c6784df$export$2e2bcd8739ae039 = $851c1a711c6784df$var$useModal;




function $7c1b72fb3ad790b0$export$67960e22b12a638d(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $7c1b72fb3ad790b0$var$modalClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $7c1b72fb3ad790b0$export$2e2bcd8739ae039 = $7c1b72fb3ad790b0$var$modalClasses;




'use client';
const $d2d6d7b93acac061$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7c1b72fb3ad790b0$export$67960e22b12a638d), classes);
};
const $d2d6d7b93acac061$var$ModalRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $d2d6d7b93acac061$var$ModalBackdrop = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $981c78e9e523e91e$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $d2d6d7b93acac061$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "classes",
        "className",
        "closeAfterTransition",
        "children",
        "container",
        "component",
        "disableAutoFocus",
        "disableEnforceFocus",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "onClose",
        "onTransitionEnter",
        "onTransitionExited",
        "open",
        "slotProps",
        "slots",
        "theme"
    ]);
    const propsWithDefaults = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $851c1a711c6784df$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, propsWithDefaults), {
        rootRef: ref
    }));
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, propsWithDefaults), {
        exited: exited
    });
    const classes = $d2d6d7b93acac061$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $d2d6d7b93acac061$var$ModalRoot,
        externalForwardedProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other), {
            component: component
        }),
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes === null || classes === void 0 ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes === null || classes === void 0 ? void 0 : classes.hidden))
    });
    const [BackdropSlot, backdropProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('backdrop', {
        elementType: $d2d6d7b93acac061$var$ModalBackdrop,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, otherHandlers), {
                onClick: (event)=>{
                    if (otherHandlers === null || otherHandlers === void 0 ? void 0 : otherHandlers.onClick) otherHandlers.onClick(event);
                }
            }));
        },
        className: classes === null || classes === void 0 ? void 0 : classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6730ab5de482f0d$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
            children: [
                !hideBackdrop ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BackdropSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ad54025a02984b15$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $d2d6d7b93acac061$export$2e2bcd8739ae039 = $d2d6d7b93acac061$var$Modal;







var $7fPBF = parcelRequire("7fPBF");












function $e0d0afcd19cde264$export$29cdb466b9b6f20b(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $e0d0afcd19cde264$var$paperClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $e0d0afcd19cde264$export$2e2bcd8739ae039 = $e0d0afcd19cde264$var$paperClasses;




'use client';
const $c12b3e51dd27af1e$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $e0d0afcd19cde264$export$29cdb466b9b6f20b), classes);
};
const $c12b3e51dd27af1e$var$PaperRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'box-shadow')), {
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $c12b3e51dd27af1e$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    var _theme_vars_overlays;
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "component",
        "elevation",
        "square",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $c12b3e51dd27af1e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c12b3e51dd27af1e$var$PaperRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other), {
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, variant === 'elevation' && (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            '--Paper-shadow': (theme.vars || theme).shadows[elevation]
        }, theme.vars && {
            '--Paper-overlay': (_theme_vars_overlays = theme.vars.overlays) === null || _theme_vars_overlays === void 0 ? void 0 : _theme_vars_overlays[elevation]
        }, !theme.vars && theme.palette.mode === 'dark' && {
            '--Paper-overlay': `linear-gradient(${(0, $989ea3f9d8f44081$export$58f0f39f63f3cf42)('#fff', (0, $7076a1421ccbd150$export$2e2bcd8739ae039)(elevation))}, ${(0, $989ea3f9d8f44081$export$58f0f39f63f3cf42)('#fff', (0, $7076a1421ccbd150$export$2e2bcd8739ae039)(elevation))})`
        }), other.style)
    }));
});
var $c12b3e51dd27af1e$export$2e2bcd8739ae039 = $c12b3e51dd27af1e$var$Paper;




function $b479a9c1dd555a27$export$2177af0aa15c34c2(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDialog', slot);
}
const $b479a9c1dd555a27$var$dialogClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDialog', [
    'root',
    'backdrop',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $b479a9c1dd555a27$export$2e2bcd8739ae039 = $b479a9c1dd555a27$var$dialogClasses;



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $982abec7c31ab888$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $982abec7c31ab888$export$2e2bcd8739ae039 = $982abec7c31ab888$var$DialogContext;









'use client';
const $29f821306e66414b$var$DialogBackdrop = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $981c78e9e523e91e$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop'
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $29f821306e66414b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        backdrop: [
            'backdrop'
        ],
        container: [
            'container',
            `scroll${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperWidth${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $b479a9c1dd555a27$export$2177af0aa15c34c2), classes);
};
const $29f821306e66414b$var$DialogRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $d2d6d7b93acac061$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $29f821306e66414b$var$DialogContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $29f821306e66414b$var$DialogPaper = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperWidth${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`
                }
            },
            {
                props: {
                    maxWidth: 'xs',
                    scroll: 'body'
                },
                style: {
                    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                        maxWidth: 'calc(100% - 64px)'
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`
                    }
                })),
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth,
                        scroll: 'body'
                    },
                    style: {
                        [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen && ownerState.scroll === 'body',
                style: {
                    margin: 0,
                    maxWidth: '100%'
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $29f821306e66414b$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, children: children, className: className, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), role: role = 'dialog', scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, transitionDuration: transitionDuration = defaultTransitionDuration } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        'aria-describedby',
        'aria-labelledby',
        'aria-modal',
        "children",
        "className",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onClick",
        "onClose",
        "open",
        "PaperComponent",
        "role",
        "scroll",
        "slots",
        "slotProps",
        "transitionDuration"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $29f821306e66414b$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        elementType: $29f821306e66414b$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('backdrop', {
        elementType: $29f821306e66414b$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.backdrop
    });
    const [PaperSlot, paperSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('paper', {
        elementType: $29f821306e66414b$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper,
        additionalProps: {
            elevation: 24,
            role: role,
            'aria-describedby': ariaDescribedby,
            'aria-labelledby': ariaLabelledby,
            'aria-modal': ariaModal,
            tabIndex: -1,
            [(0, $61cbbbb9ef851fb1$export$1022acd1ec27c201)]: ''
        }
    });
    const [ContainerSlot, containerSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('container', {
        elementType: $29f821306e66414b$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $0f34aa3278e20e02$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                transitionDuration: transitionDuration
            }, backdropSlotProps)
        },
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick
    }, rootSlotProps, other), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transitionSlotProps), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ContainerSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                onMouseDown: handleMouseDown
            }, containerSlotProps), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    as: PaperComponent
                }, paperSlotProps), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $982abec7c31ab888$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            }))
        }))
    }));
});
var $29f821306e66414b$export$2e2bcd8739ae039 = $29f821306e66414b$var$Dialog;















var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
'use client';
const $f41e23dcede3198a$var$EMPTY = [];
function $f41e23dcede3198a$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $f41e23dcede3198a$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $80a372d1a4c84812$export$786b4da70f00938b {
    static create() {
        return new $80a372d1a4c84812$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "currentId", null);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "clear", ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        });
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "disposeEffect", ()=>{
            return this.clear;
        });
    }
}
function $80a372d1a4c84812$export$2e2bcd8739ae039() {
    const timeout = (0, $4a8eb4c5718f0b0a$export$2e2bcd8739ae039)($80a372d1a4c84812$export$786b4da70f00938b.create).current;
    (0, $f41e23dcede3198a$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}




/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $3ee2ed17fbd1526c$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}











var $7fPBF = parcelRequire("7fPBF");









'use client';
function $3ab1beedea58600b$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $3ab1beedea58600b$var$styles = {
    entering: {
        opacity: 1,
        transform: $3ab1beedea58600b$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    },
    exiting: {
        opacity: 0,
        transform: $3ab1beedea58600b$var$getScale(0.75)
    },
    exited: {
        opacity: 0,
        transform: $3ab1beedea58600b$var$getScale(0.75)
    }
};
const $3ab1beedea58600b$var$hiddenStyles = {
    opacity: 0,
    transform: $3ab1beedea58600b$var$getScale(0.75),
    visibility: 'hidden'
};
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 */ const $3ab1beedea58600b$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, disablePrefersReducedMotion: disablePrefersReducedMotion = false, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "addEndListener",
        "appear",
        "children",
        "disablePrefersReducedMotion",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout"
    ]);
    const autoTimeout = $7fPBF.useRef(null);
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const reducedMotion = (0, $1fb9020c3655f750$export$2e2bcd8739ae039)(theme.motion.reducedMotion, disablePrefersReducedMotion);
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(nodeRef, (0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(children), ref);
    const handleEntering = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, onEntering);
    const handleEnter = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, (node, isAppearing)=>{
        if (!reducedMotion.shouldReduceMotion) (0, $0ea347727154ba9d$export$b7a864e1eaef9de5)(node); // Force layout so the animation starts from the initial styles.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0ea347727154ba9d$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto' && !reducedMotion.shouldReduceMotion) {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else {
            duration = transitionDuration;
            autoTimeout.current = null;
        }
        const transitionTiming = reducedMotion.getTransitionTiming({
            duration: duration,
            delay: delay
        });
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: transitionTiming.duration,
                delay: transitionTiming.delay
            }),
            theme.transitions.create('transform', {
                duration: typeof transitionTiming.duration === 'string' ? transitionTiming.duration : transitionTiming.duration * 0.666,
                delay: transitionTiming.delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, onEntered);
    const handleExiting = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, onExiting);
    const handleExit = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, (node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0ea347727154ba9d$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto' && !reducedMotion.shouldReduceMotion) {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else {
            duration = transitionDuration;
            autoTimeout.current = null;
        }
        const transitionTiming = reducedMotion.getTransitionTiming({
            duration: duration,
            delay: delay
        });
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: transitionTiming.duration,
                delay: transitionTiming.delay
            }),
            theme.transitions.create('transform', {
                duration: typeof transitionTiming.duration === 'string' ? transitionTiming.duration : transitionTiming.duration * 0.666,
                delay: transitionTiming.delay || (typeof transitionTiming.duration === 'string' ? transitionTiming.duration : transitionTiming.duration * 0.333),
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $3ab1beedea58600b$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = (0, $0ea347727154ba9d$export$da8da2b45a650a33)(nodeRef, (node)=>{
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = addEndListener ? (next)=>{
        addEndListener(nodeRef.current, next);
    } : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f9c8c3b3e8932a$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        getAutoTimeout: timeout === 'auto' ? ()=>autoTimeout.current : undefined,
        reduceMotion: reducedMotion.shouldReduceMotion,
        timeout: timeout === 'auto' ? null : timeout
    }, other), {
        children: (state, _param)=>{
            var { ownerState: ownerState } = _param, restChildProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "ownerState"
            ]);
            // Do not pass ownerState to a DOM child. ownerState is only for
            // Material UI styling, and React would treat it as an invalid DOM attribute.
            const childStyle = (0, $0ea347727154ba9d$export$c1e03ca92f01ef32)(state, inProp, $3ab1beedea58600b$var$styles, $3ab1beedea58600b$var$hiddenStyles, style, children.props.style);
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                style: childStyle,
                ref: handleRef
            }, restChildProps));
        }
    }));
});
if ($3ab1beedea58600b$var$Grow) $3ab1beedea58600b$var$Grow.muiSupportAuto = true;
var $3ab1beedea58600b$export$2e2bcd8739ae039 = $3ab1beedea58600b$var$Grow;










var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");






function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;



function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
}


function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b48f13af3862f004$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(node) || !(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node)) return (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(node);
    else return (0, $6923eaccf7a43aef$export$2e2bcd8739ae039)(node);
}


function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e7afd89efa353b85$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)).left + (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $998896b7349c78b7$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fa62512f527d34a4$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(node) && (0, $998896b7349c78b7$export$2e2bcd8739ae039)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(node));
}





function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1d462f2c86b4c65a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $998896b7349c78b7$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $9906540837c752ea$export$2e2bcd8739ae039)(target)));
}







function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) >= 0;
}




function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c76403bd29ed319a$export$2e2bcd8739ae039)());
    if (isIE && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9906540837c752ea$export$2e2bcd8739ae039)(element);
    if ((0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $08ccc1de57d53c59$export$2e2bcd8739ae039)(offsetParent) && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}


var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];


function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $7c96f63dd602b579$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(reference) ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $13c27cceb4b24b2f$export$2e2bcd8739ae039)((0, $320e6f4d2835a922$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $585037a155f95873$export$2e2bcd8739ae039)(reference, (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4c8edc0cb4d5666b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};



function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7c96f63dd602b579$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7c96f63dd602b579$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7c96f63dd602b579$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7c96f63dd602b579$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $7c96f63dd602b579$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7c96f63dd602b579$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};










var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cb70389d1b75072d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var sideY = (0, $7c96f63dd602b579$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(popper);
            if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || placement === (0, $7c96f63dd602b579$export$79ffe56a765070d2)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideY = (0, $7c96f63dd602b579$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) || (placement === (0, $7c96f63dd602b579$export$1e95b668f3b82d) || placement === (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)) && variation === (0, $7c96f63dd602b579$export$bd5df0f255a350f8)) {
            sideX = (0, $7c96f63dd602b579$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) || !(0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7c96f63dd602b579$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};


var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}



var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}







function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5a7577945ba4d648$export$2e2bcd8739ae039)(element);
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b48f13af3862f004$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e95acb4acf5ee909$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e0a76d77d33c9d6e$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cb70389d1b75072d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f3e95cf60f991b3e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) ? (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $05957f974ad3b041$export$2e2bcd8739ae039)(element, strategy)) : (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $18107b7e48021ffa$export$2e2bcd8739ae039)((0, $f2541b971d258cf0$export$2e2bcd8739ae039)((0, $7d9656f011992b2b$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $3d1bbe7c8c599173$export$2e2bcd8739ae039)((0, $9906540837c752ea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e40145ffd569d9c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f3e95cf60f991b3e$export$1b3bfaa9684536aa)(element) ? (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b8ce8e5214ef2302$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cb70389d1b75072d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)(), paddingObject);
}


function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7c96f63dd602b579$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7c96f63dd602b579$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7c96f63dd602b579$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? (0, $7c96f63dd602b579$export$ca50aac9f3ba507f) : (0, $7c96f63dd602b579$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $86796f3d3717fc99$export$2e2bcd8739ae039)((0, $f3e95cf60f991b3e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7d9656f011992b2b$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e7afd89efa353b85$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c2c9d9550c09d816$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $18107b7e48021ffa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7c96f63dd602b579$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7c96f63dd602b579$export$79ffe56a765070d2),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7c96f63dd602b579$export$1e95b668f3b82d),
                (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7c96f63dd602b579$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7c96f63dd602b579$export$368f9a87e87fa4e1) : (0, $7c96f63dd602b579$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7c96f63dd602b579$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $690483208b9a3207$export$2e2bcd8739ae039)(placement);
    return [
        (0, $13515282412eb271$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $13515282412eb271$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $690483208b9a3207$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$dfb5619354ba860) ? (0, $a935996b3496591b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(placement) === (0, $7c96f63dd602b579$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7c96f63dd602b579$export$79ffe56a765070d2) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $690483208b9a3207$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $cb70389d1b75072d$export$8960430cfd85939f)(min, (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $cd593f453867f36a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $8d60439f259d6a8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7c96f63dd602b579$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1e806166c2cdf48d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? (0, $cb70389d1b75072d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cb70389d1b75072d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7c96f63dd602b579$export$1e95b668f3b82d),
            (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $14b5cb667dce379f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $14b5cb667dce379f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $ff6dcd1b0906e9b8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c8d699eb93b3090c$export$2e2bcd8739ae039)(padding, (0, $7c96f63dd602b579$export$aec2ce47c367b8c3)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2e8856bdb677ff8e$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $334987ecb6fc56c7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $790f3bf845b39e8e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $7c96f63dd602b579$export$1e95b668f3b82d) : (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $7c96f63dd602b579$export$40e543e69a8b3fbb) : (0, $7c96f63dd602b579$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6ebea87f6f98e49c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $14b5cb667dce379f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fa38ef77d76834a0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7c96f63dd602b579$export$1e95b668f3b82d),
        (0, $7c96f63dd602b579$export$79ffe56a765070d2),
        (0, $7c96f63dd602b579$export$40e543e69a8b3fbb),
        (0, $7c96f63dd602b579$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $52693e6050d55014$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};




var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1564186ea0096528$export$2e2bcd8739ae039),
    (0, $e0848fa64ca744df$export$2e2bcd8739ae039),
    (0, $adff49e8d09ee1e5$export$2e2bcd8739ae039),
    (0, $5bfb95a331f35baa$export$2e2bcd8739ae039),
    (0, $a984b8b647b41eeb$export$2e2bcd8739ae039),
    (0, $a97241372b70cd07$export$2e2bcd8739ae039),
    (0, $cf968237b9d7dd4a$export$2e2bcd8739ae039),
    (0, $e7f3cf13e0769248$export$2e2bcd8739ae039),
    (0, $74f12d998f890694$export$2e2bcd8739ae039)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $879850b738b0fd85$export$ed5e13716264f202)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules











'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $506d49d02f67e45f$var$useSlotProps(parameters) {
    var _parameters_additionalProps;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, other = (0, $8901fc92b5563702$export$71511d61b312f219)(parameters, [
        "elementType",
        "externalSlotProps",
        "ownerState",
        "skipResolvingSlotProps"
    ]);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $6e74c8f8fbb8fba6$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, other), {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps === null || resolvedComponentsProps === void 0 ? void 0 : resolvedComponentsProps.ref, (_parameters_additionalProps = parameters.additionalProps) === null || _parameters_additionalProps === void 0 ? void 0 : _parameters_additionalProps.ref);
    const props = (0, $d665962efb9ba42e$export$2e2bcd8739ae039)(elementType, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedProps), {
        ref: ref
    }), ownerState);
    return props;
}
var $506d49d02f67e45f$export$2e2bcd8739ae039 = $506d49d02f67e45f$var$useSlotProps;






function $7d047ab74b2b782d$export$1b69b6cd0fa638a1(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $7d047ab74b2b782d$var$popperClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);
var $7d047ab74b2b782d$export$2e2bcd8739ae039 = $7d047ab74b2b782d$var$popperClasses;



'use client';
function $36659880d36ac503$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $36659880d36ac503$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $36659880d36ac503$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $36659880d36ac503$var$isVirtualElement(element) {
    return !$36659880d36ac503$var$isHTMLElement(element);
}
const $36659880d36ac503$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7d047ab74b2b782d$export$1b69b6cd0fa638a1), classes);
};
const $36659880d36ac503$var$defaultPopperOptions = {};
const $36659880d36ac503$var$PopperTooltip = /*#__PURE__*/ $7fPBF.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "anchorEl",
        "children",
        "direction",
        "disablePortal",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "slotProps",
        "slots",
        "TransitionProps",
        "ownerState"
    ]);
    const tooltipRef = $7fPBF.useRef(null);
    const ownRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $7fPBF.useRef(null);
    const handlePopperRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $36659880d36ac503$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $7fPBF.useState(rtlPlacement);
    const resolvedAnchorElement = $7fPBF.useMemo(()=>$36659880d36ac503$var$resolveAnchorEl(anchorEl), [
        anchorEl
    ]);
    $7fPBF.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $a5ed26444bdb4d3e$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            placement: rtlPlacement
        }, popperOptions), {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        const popperElement = tooltipRef.current;
        return ()=>{
            // popper.destroy() clears all inline positioning via the applyStyles
            // modifier cleanup, which causes the element to jump to its static
            // position. Snapshot and restore only the positioning properties so the
            // element stays in place during the destroy/recreate gap (prevents scroll
            // jumps when a child focuses between the two).
            // https://github.com/mui/mui-x/issues/21839
            if (popperElement) {
                const { style: style } = popperElement;
                const position = style.position;
                const top = style.top;
                const left = style.left;
                const transform = style.transform;
                popper.destroy();
                style.position = position;
                style.top = top;
                style.left = left;
                style.transform = transform;
            } else popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $36659880d36ac503$var$useUtilityClasses(props);
    var _slots_root;
    const Root = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : 'div';
    const rootProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $36659880d36ac503$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $36659880d36ac503$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "anchorEl",
        "children",
        "container",
        "direction",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition",
        "slotProps",
        "slots"
    ]);
    const [exited, setExited] = $7fPBF.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $36659880d36ac503$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $36659880d36ac503$var$isHTMLElement(resolvedAnchorEl) ? (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6730ab5de482f0d$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($36659880d36ac503$var$PopperTooltip, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other), {
            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $36659880d36ac503$export$2e2bcd8739ae039 = $36659880d36ac503$var$Popper;





'use client';
const $a5b41facef9806db$var$PopperRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $36659880d36ac503$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a5b41facef9806db$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "anchorEl",
        "component",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "transition",
        "slots",
        "slotProps"
    ]);
    const otherProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a5b41facef9806db$var$PopperRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: slots,
        slotProps: slotProps
    }, otherProps), {
        ref: ref
    }));
});
var $a5b41facef9806db$export$2e2bcd8739ae039 = $a5b41facef9806db$var$Popper;



'use client';
var $4b34ab98a42d4f2d$export$2e2bcd8739ae039 = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039);




'use client';
var $ad114c389ed7c9ee$export$2e2bcd8739ae039 = (0, $f017d1fe847d8509$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");
'use client';
function $dbfd4b86e42733ca$export$2e2bcd8739ae039(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $d2efeb5524b9e738$export$2e2bcd8739ae039 = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039);





function $918312187d2c820e$export$837848f5f6cee923(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $918312187d2c820e$var$tooltipClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $918312187d2c820e$export$2e2bcd8739ae039 = $918312187d2c820e$var$tooltipClasses;



'use client';
function $ee2f76e72685f4ff$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ee2f76e72685f4ff$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $918312187d2c820e$export$837848f5f6cee923), classes);
};
const $ee2f76e72685f4ff$var$TooltipPopper = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a5b41facef9806db$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState, open: open })=>open && !ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $918312187d2c820e$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $918312187d2c820e$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $918312187d2c820e$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        insetInlineStart: 0,
                        marginInlineStart: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $918312187d2c820e$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        insetInlineEnd: 0,
                        marginInlineEnd: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            }
        ]
    })));
const $ee2f76e72685f4ff$var$TooltipTooltip = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center',
            marginInlineEnd: '14px'
        },
        [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center',
            marginInlineStart: '14px'
        },
        [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    marginBlock: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$ee2f76e72685f4ff$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginInlineEnd: '24px'
                    },
                    [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginInlineStart: '24px'
                    },
                    [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    },
                    [`.${(0, $918312187d2c820e$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $ee2f76e72685f4ff$var$TooltipArrow = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $ee2f76e72685f4ff$var$hystersisOpen = false;
const $ee2f76e72685f4ff$var$hystersisTimer = new (0, $80a372d1a4c84812$export$786b4da70f00938b)();
let $ee2f76e72685f4ff$var$cursorPosition = {
    x: 0,
    y: 0
};
function $ee2f76e72685f4ff$export$b9ee5a7ace0541f8() {
    $ee2f76e72685f4ff$var$hystersisOpen = false;
    $ee2f76e72685f4ff$var$hystersisTimer.clear();
}
function $ee2f76e72685f4ff$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
const $ee2f76e72685f4ff$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', slotProps: slotProps = {}, slots: slots = {}, title: title } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "arrow",
        "children",
        "classes",
        "describeChild",
        "disableFocusListener",
        "disableHoverListener",
        "disableInteractive",
        "disableTouchListener",
        "enterDelay",
        "enterNextDelay",
        "enterTouchDelay",
        "followCursor",
        "id",
        "leaveDelay",
        "leaveTouchDelay",
        "onClose",
        "onOpen",
        "open",
        "placement",
        "slotProps",
        "slots",
        "title"
    ]);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $7fPBF.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const [childNode, setChildNode] = $7fPBF.useState();
    const [arrowRef, setArrowRef] = $7fPBF.useState(null);
    const ignoreNonTouchEvents = $7fPBF.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const enterTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const touchTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $d2efeb5524b9e738$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $7fPBF.useRef();
    const stopTouchInteraction = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $7fPBF.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $ee2f76e72685f4ff$var$hystersisTimer.clear();
        $ee2f76e72685f4ff$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $ee2f76e72685f4ff$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $ee2f76e72685f4ff$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (childNode === null || childNode === void 0 ? void 0 : childNode.disabled) return;
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $ee2f76e72685f4ff$var$hystersisOpen && enterNextDelay) enterTimer.start($ee2f76e72685f4ff$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        var _event_target;
        // Needed for https://github.com/mui/material-ui/issues/45373
        const target = (_event_target = event === null || event === void 0 ? void 0 : event.target) !== null && _event_target !== void 0 ? _event_target : childNode;
        if (!target || target.disabled || !(0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(target)) {
            setChildIsFocusVisible(false);
            // InputBase can call onBlur() without an event when the input becomes disabled.
            // Tooltip must not assume an event object exists.
            const closeEvent = event !== null && event !== void 0 ? event : new Event('blur');
            // `new Event('blur')` has `target/currentTarget === null`, but Tooltip's close logic
            // (and user callbacks like onClose) may expect them to reference the anchor element.
            if (!event && target) {
                Object.defineProperty(closeEvent, 'target', {
                    value: target
                });
                Object.defineProperty(closeEvent, 'currentTarget', {
                    value: target
                });
            }
            handleMouseLeave(closeEvent);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/react/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) {
            // Workaround for https://github.com/react/react/issues/9142.
            // React does not fire blur when a focused element becomes disabled.
            const handleNativeBlur = (blurEvent)=>{
                if (blurEvent.target.disabled) handleBlur(blurEvent);
                blurEvent.target.removeEventListener('blur', handleNativeBlur);
            };
            event.target.addEventListener('blur', handleNativeBlur);
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)((0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $7fPBF.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $ee2f76e72685f4ff$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nameOrDescProps, other, children.props), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }), followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $ee2f76e72685f4ff$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $ee2f76e72685f4ff$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $ee2f76e72685f4ff$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $ee2f76e72685f4ff$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        touch: ignoreNonTouchEvents.current
    });
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $7fPBF.useMemo(()=>{
        var _resolvedPopperProps_popperOptions;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (resolvedPopperProps === null || resolvedPopperProps === void 0 ? void 0 : (_resolvedPopperProps_popperOptions = resolvedPopperProps.popperOptions) === null || _resolvedPopperProps_popperOptions === void 0 ? void 0 : _resolvedPopperProps_popperOptions.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, resolvedPopperProps === null || resolvedPopperProps === void 0 ? void 0 : resolvedPopperProps.popperOptions), {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        resolvedPopperProps === null || resolvedPopperProps === void 0 ? void 0 : resolvedPopperProps.popperOptions
    ]);
    const classes = $ee2f76e72685f4ff$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            arrow: slotProps.arrow,
            popper: resolvedPopperProps,
            tooltip: slotProps.tooltip,
            transition: slotProps.transition
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('popper', {
        elementType: $ee2f76e72685f4ff$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper
    });
    const [TransitionSlot, transitionSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $3ab1beedea58600b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('tooltip', {
        elementType: $ee2f76e72685f4ff$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('arrow', {
        elementType: $ee2f76e72685f4ff$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PopperSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                as: (0, $a5b41facef9806db$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $ee2f76e72685f4ff$var$cursorPosition.y,
                            left: $ee2f76e72685f4ff$var$cursorPosition.x,
                            right: $ee2f76e72685f4ff$var$cursorPosition.x,
                            bottom: $ee2f76e72685f4ff$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperSlotProps), {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionSlotProps), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(TooltipSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tooltipSlotProps), {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ArrowSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arrowSlotProps)) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $ee2f76e72685f4ff$export$2e2bcd8739ae039 = $ee2f76e72685f4ff$var$Tooltip;



const $c5e3795911646adc$export$4b882a3bf08f9554 = (variant, theme)=>{
    if (variant === 'primary') return (0, $8951886a6b49e92a$export$35e9368ef982300f).primary;
    if (variant === 'secondary') return (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary;
    if (variant === 'accent') return (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_light;
    if (variant === 'accent_2') return (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_dark_text;
    if (variant === 'success') return (0, $8951886a6b49e92a$export$35e9368ef982300f).success_dark;
    if (variant === 'error') return (0, $8951886a6b49e92a$export$35e9368ef982300f).error_dark;
    if (variant === 'diminished') return theme.color.textBody;
    if (variant === 'diminished_accent') return theme.color.textBodyLight;
    if (variant === 'diminished_error') return theme.color.error;
    if (variant === 'diminished_success') return theme.color.success;
    if (variant === 'text' || variant === 'underline_text') return theme.color.text;
    if (variant === 'underline_diminished') return theme.color.textBody;
};
const $c5e3795911646adc$export$c90419c99840f046 = (variant, theme)=>{
    if (variant === 'primary') return (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_card_border;
    if (variant === 'secondary') return (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_card_border;
    if (variant === 'accent') return (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_light;
    if (variant === 'accent_2') return (0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_light;
    if (variant === 'success') return (0, $8951886a6b49e92a$export$35e9368ef982300f).success_card_border;
    if (variant === 'error') return (0, $8951886a6b49e92a$export$35e9368ef982300f).error_card_border;
    if (variant === 'diminished') return 'transparent';
    if (variant === 'diminished_accent') return 'transparent';
    if (variant === 'diminished_error') return 'transparent';
    if (variant === 'diminished_success') return 'transparent';
    if (variant === 'text' || variant === 'underline_text') return 'transparent';
    if (variant === 'underline_diminished') return 'transparent';
};
const $c5e3795911646adc$export$98bac143fbc272fc = (variant, theme)=>{
    if (variant === 'diminished' || variant === 'underline_diminished') return theme.color.background;
    if (variant === 'text' || variant === 'underline_text') return theme.color.text;
    return $c5e3795911646adc$export$4b882a3bf08f9554(variant, theme) || theme.color.text;
};
const $c5e3795911646adc$export$476ad49a155045fd = (variant, theme)=>{
    const background = $c5e3795911646adc$export$c90419c99840f046(variant, theme);
    if (background && background !== 'transparent') return background;
    if (variant === 'diminished_accent') return theme.color.background;
    if (variant === 'text' || variant === 'underline_text') return theme.color.background;
    return variant === 'diminished_error' || variant === 'diminished_success' ? (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light : theme.color.text;
};



var $7fPBF = parcelRequire("7fPBF");


let $c7922ab368d0f289$var$_ = (t)=>t, $c7922ab368d0f289$var$t;
const $c7922ab368d0f289$export$b27464191770945a = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TinyIconButton(_param, ref) {
    var { icon: icon, label: label, tooltip: tooltip, tooltipPlacement: tooltipPlacement, iconSize: iconSize = 1, iconWeight: iconWeight = 'bold', variant: variant = 'diminished_accent' } = _param, buttonProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "icon",
        "label",
        "tooltip",
        "tooltipPlacement",
        "iconSize",
        "iconWeight",
        "variant"
    ]);
    const tag = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c7922ab368d0f289$var$TinyIconButtonBase, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: ref,
        type: "button",
        "aria-label": label,
        $variant: variant
    }, buttonProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
            name: icon,
            size: iconSize,
            weight: iconWeight
        })
    }));
    if (!tooltip) return tag;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
        title: tooltip,
        placement: tooltipPlacement,
        arrow: true,
        children: tag
    });
});
const $c7922ab368d0f289$var$TinyIconButtonBase = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($c7922ab368d0f289$var$t || ($c7922ab368d0f289$var$t = $c7922ab368d0f289$var$_`
    width: 1.625rem;
    height: 1.625rem;
    flex: 0 0 auto;
    padding: 0;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${0};
    background: ${0};
    transition:
        background 0.15s ease,
        border-color 0.15s ease,
        color 0.15s ease;

    /* Hover and the pressed toggle share one look: the variant's color and background trade places. */
    &[aria-pressed='true'],
    &:hover:not(:disabled) {
        background: ${0};
        color: ${0};
        border-color: currentColor;
    }

    ${0}

    &:disabled {
        cursor: default;
        opacity: 0.45;
    }

    /* A recorded vote disables its button but must still read as the chosen one. */
    &[aria-pressed='true']:disabled {
        opacity: 1;
    }
`), (props)=>(0, $c5e3795911646adc$export$4b882a3bf08f9554)(props.$variant, props.theme) || props.theme.color.text, (props)=>(0, $c5e3795911646adc$export$c90419c99840f046)(props.$variant, props.theme) || 'transparent', (props)=>(0, $c5e3795911646adc$export$98bac143fbc272fc)(props.$variant, props.theme), (props)=>(0, $c5e3795911646adc$export$476ad49a155045fd)(props.$variant, props.theme), (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));







var $7fPBF = parcelRequire("7fPBF");







function $6596fb92fbd3ed52$export$5e57a444791c63be(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDialogActions', slot);
}
const $6596fb92fbd3ed52$var$dialogActionsClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $6596fb92fbd3ed52$export$2e2bcd8739ae039 = $6596fb92fbd3ed52$var$dialogActionsClasses;



'use client';
const $49c50691da23b940$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $6596fb92fbd3ed52$export$5e57a444791c63be), classes);
};
const $49c50691da23b940$var$DialogActionsRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $49c50691da23b940$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "disableSpacing"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disableSpacing: disableSpacing
    });
    const classes = $49c50691da23b940$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($49c50691da23b940$var$DialogActionsRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $49c50691da23b940$export$2e2bcd8739ae039 = $49c50691da23b940$var$DialogActions;





var $7fPBF = parcelRequire("7fPBF");








function $837c39920bb2c1aa$export$61b0ee1f05fb344e(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDialogContent', slot);
}
const $837c39920bb2c1aa$var$dialogContentClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $837c39920bb2c1aa$export$2e2bcd8739ae039 = $837c39920bb2c1aa$var$dialogContentClasses;




function $9912c69f7016a743$export$f5d2ec7e4c47e088(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDialogTitle', slot);
}
const $9912c69f7016a743$var$dialogTitleClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDialogTitle', [
    'root'
]);
var $9912c69f7016a743$export$2e2bcd8739ae039 = $9912c69f7016a743$var$dialogTitleClasses;



'use client';
const $6ff02a49d1cf2980$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $837c39920bb2c1aa$export$61b0ee1f05fb344e), classes);
};
const $6ff02a49d1cf2980$var$DialogContentRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $9912c69f7016a743$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $6ff02a49d1cf2980$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "dividers"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        dividers: dividers
    });
    const classes = $6ff02a49d1cf2980$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6ff02a49d1cf2980$var$DialogContentRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6ff02a49d1cf2980$export$2e2bcd8739ae039 = $6ff02a49d1cf2980$var$DialogContent;





var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");










function $ea02e131f61770cc$export$24c1f8f60cbac79e(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $ea02e131f61770cc$var$typographyClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom'
]);
var $ea02e131f61770cc$export$2e2bcd8739ae039 = $ea02e131f61770cc$var$typographyClasses;



'use client';
const $f577398c4e8dc99c$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $ea02e131f61770cc$export$24c1f8f60cbac79e), classes);
};
const $f577398c4e8dc99c$export$140e2f5526d3cad8 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    var _theme_palette;
    return {
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(((_theme_palette = theme.palette) === null || _theme_palette === void 0 ? void 0 : _theme_palette.text) || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            }
        ]
    };
}));
const $f577398c4e8dc99c$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $f577398c4e8dc99c$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const { color: color, align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, variant: variant = 'body1', variantMapping: variantMapping = $f577398c4e8dc99c$var$defaultVariantMapping } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "color",
        "align",
        "className",
        "component",
        "gutterBottom",
        "noWrap",
        "variant",
        "variantMapping"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || variantMapping[variant] || $f577398c4e8dc99c$var$defaultVariantMapping[variant] || 'span';
    const classes = $f577398c4e8dc99c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f577398c4e8dc99c$export$140e2f5526d3cad8, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: Component,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other), {
        ownerState: ownerState,
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, align !== 'inherit' && {
            '--Typography-textAlign': align
        }, other.style)
    }));
});
var $f577398c4e8dc99c$export$2e2bcd8739ae039 = $f577398c4e8dc99c$var$Typography;




function $7579251f8404b282$export$d9c6dc45f75b0e4f(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDialogContentText', slot);
}
const $7579251f8404b282$var$dialogContentTextClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDialogContentText', [
    'root'
]);
var $7579251f8404b282$export$2e2bcd8739ae039 = $7579251f8404b282$var$dialogContentTextClasses;



'use client';
const $737904127084e237$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7579251f8404b282$export$d9c6dc45f75b0e4f), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $737904127084e237$var$DialogContentTextRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $737904127084e237$var$DialogContentText = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className } = props, ownerState = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className"
    ]);
    const classes = $737904127084e237$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($737904127084e237$var$DialogContentTextRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, props), {
        classes: classes
    }));
});
var $737904127084e237$export$2e2bcd8739ae039 = $737904127084e237$var$DialogContentText;




var $7fPBF = parcelRequire("7fPBF");









'use client';
const $6e7ef7bd2d21dbc0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $9912c69f7016a743$export$f5d2ec7e4c47e088), classes);
};
const $6e7ef7bd2d21dbc0$var$DialogTitleRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $6e7ef7bd2d21dbc0$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "id"
    ]);
    const ownerState = props;
    const classes = $6e7ef7bd2d21dbc0$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $982abec7c31ab888$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6e7ef7bd2d21dbc0$var$DialogTitleRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        component: "h2",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp !== null && idProp !== void 0 ? idProp : titleId
    }, other));
});
var $6e7ef7bd2d21dbc0$export$2e2bcd8739ae039 = $6e7ef7bd2d21dbc0$var$DialogTitle;




let $082accbd174d656b$var$_ = (t)=>t, $082accbd174d656b$var$t, $082accbd174d656b$var$t1, $082accbd174d656b$var$t2, $082accbd174d656b$var$t3, $082accbd174d656b$var$t4, $082accbd174d656b$var$t5, $082accbd174d656b$var$t6, $082accbd174d656b$var$t7;
const $082accbd174d656b$export$1a4605a7458e0ef = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $29f821306e66414b$export$2e2bcd8739ae039))($082accbd174d656b$var$t || ($082accbd174d656b$var$t = $082accbd174d656b$var$_`
    & .MuiPaper-root {
        border: 1px solid ${0};
        background: ${0};
    }
`), (props)=>props.theme.color.border, (props)=>props.theme.color.background);
const $082accbd174d656b$export$a821680a90fed6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $6e7ef7bd2d21dbc0$export$2e2bcd8739ae039))($082accbd174d656b$var$t1 || ($082accbd174d656b$var$t1 = $082accbd174d656b$var$_`
    flex: 0 1 auto;
    padding: 0;
    margin: 0;
    align-self: center;
    font-weight: 900;
    color: ${0};
    word-break: break-word;
    ${0}
`), (props)=>props.theme.color.text, (0, $b091aef3a32d2bd8$export$5835e378394a0ad0));
const $082accbd174d656b$export$6f975883ded828a4 = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')($082accbd174d656b$var$t2 || ($082accbd174d656b$var$t2 = $082accbd174d656b$var$_`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.5rem 1.5rem 0 1.5rem;
    gap: 0.5rem;
`));
const $082accbd174d656b$export$5a0bc68f6657e9db = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $6ff02a49d1cf2980$export$2e2bcd8739ae039))($082accbd174d656b$var$t3 || ($082accbd174d656b$var$t3 = $082accbd174d656b$var$_`
    padding: 0.25rem 1.5rem 1rem 1.5rem;
`));
const $082accbd174d656b$export$174d4944f63edcc7 = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')($082accbd174d656b$var$t4 || ($082accbd174d656b$var$t4 = $082accbd174d656b$var$_`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1rem;
`));
const $082accbd174d656b$export$d6e3240af6047b76 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $737904127084e237$export$2e2bcd8739ae039))($082accbd174d656b$var$t5 || ($082accbd174d656b$var$t5 = $082accbd174d656b$var$_`
    padding: 0.25rem 1.5rem 1.5rem 1.5rem;
`));
const $082accbd174d656b$export$e1b02e289332d3a3 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$3288d34c523a1192))($082accbd174d656b$var$t6 || ($082accbd174d656b$var$t6 = $082accbd174d656b$var$_`
    word-break: keep-all;
    ${0}
`), (0, $b091aef3a32d2bd8$export$3e193b19d995235f));
const $082accbd174d656b$export$b54ac9d7963ef6f6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $49c50691da23b940$export$2e2bcd8739ae039))($082accbd174d656b$var$t7 || ($082accbd174d656b$var$t7 = $082accbd174d656b$var$_`
    padding: 0 1.5rem 1.5rem 1.5rem;
    align-items: center;
`));


function $54aed6520e5f6aee$export$2e2bcd8739ae039(_param) {
    var { title: title, description: description, onCancel: onCancel, cancelButtonText: cancelButtonText, onConfirm: onConfirm, onClose: onClose, confirmButtonText: confirmButtonText, confirmIcon: confirmIcon, cancelIcon: cancelIcon, children: children, scroll: scroll = 'paper', dialogTag: dialogTag } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "description",
        "onCancel",
        "cancelButtonText",
        "onConfirm",
        "onClose",
        "confirmButtonText",
        "confirmIcon",
        "cancelIcon",
        "children",
        "scroll",
        "dialogTag"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const randomId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const cancelText = cancelButtonText !== null && cancelButtonText !== void 0 ? cancelButtonText : t('common:cancel');
    const confirmText = confirmButtonText !== null && confirmButtonText !== void 0 ? confirmButtonText : t('common:save');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $29f821306e66414b$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        sx: {
            '& .MuiPaper-root': {
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: theme.color.border,
                background: theme.color.background
            }
        },
        scroll: scroll,
        onClose: onClose,
        "aria-labelledby": `dialog-title-${randomId}`,
        "aria-describedby": description ? `dialog-description-${randomId}` : undefined
    }, restProps), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$a821680a90fed6), {
                        id: `dialog-title-${randomId}`,
                        children: [
                            dialogTag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$e1b02e289332d3a3), {
                                as: "span",
                                children: dialogTag
                            }),
                            title
                        ]
                    }),
                    onClose && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7922ab368d0f289$export$b27464191770945a), {
                        label: t('common:close'),
                        icon: "closeX",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: [
                    description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        id: `dialog-description-${randomId}`,
                        children: description
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$b54ac9d7963ef6f6), {
                children: [
                    cancelText && onCancel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "simple",
                        startIcon: cancelIcon,
                        onClick: onCancel,
                        children: cancelText
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "secondary",
                        startIcon: confirmIcon,
                        onClick: onConfirm,
                        children: confirmText
                    })
                ]
            })
        ]
    }));
}


const $0609c53c7172c5fc$export$da6d2f7032b7150b = (route)=>{
    // we use a hash router for web and desktop so local routes need "#" in front of them
    return '#' + route;
};





var $7fPBF = parcelRequire("7fPBF");


function $e30fe951f2edb943$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.id);
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const commandKeyMappings = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.commandKeyMappings);
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = (0, $7fPBF.useState)(false);
    const handleDelete = async ()=>{
        const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().id;
        if (!id) return;
        (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileDeleted', {
            profileId: id
        });
        if (organizationId) navigate(`/org/${organizationId}/profiles`, {
            replace: true
        });
        else navigate('/profiles', {
            replace: true
        });
    };
    if (!commandKeyMappings) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$8a73847ccc40addf), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "touchpad",
                        title: t('common:keys.title'),
                        description: t('common:keys.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/keybindings`),
                            children: t('common:keys.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "virtualButton",
                        title: t('common:hotkey.titlePlural'),
                        description: t('common:hotkey.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/hotkeys`),
                            children: t('common:hotkey.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "dictationPlay",
                        title: t('common:dictation.title'),
                        description: t('common:dictation.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/dictation`),
                            children: t('common:dictation.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "ai",
                        title: t('common:suggestedPrompts.title'),
                        description: t('common:suggestedPrompts.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/suggested-prompts`),
                            children: t('common:suggestedPrompts.edit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "details",
                        title: t('common:profile.summary.title'),
                        description: t('common:profile.summary.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/summary`),
                            disabled: isPreview,
                            children: t('common:profile.summary.view')
                        })
                    }),
                    id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "share",
                        title: t('common:share'),
                        description: t('common:profile.share.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/share`),
                            children: t('common:profile.share.title')
                        })
                    }),
                    id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                        name: "delete",
                        title: t('common:dangerZone'),
                        description: t('common:profile.delete.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "context",
                            onClick: ()=>setIsDeleteConfirmationOpen(true),
                            children: t('common:profile.delete.title')
                        })
                    })
                ]
            }),
            isDeleteConfirmationOpen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: isDeleteConfirmationOpen,
                onCancel: ()=>setIsDeleteConfirmationOpen(false),
                title: t('common:profile.delete.confirm'),
                description: t('common:profile.delete.confirmLong'),
                onConfirm: handleDelete,
                confirmButtonText: t('common:profile.delete.confirmButton'),
                cancelButtonText: t('common:cancel'),
                confirmIcon: "delete"
            })
        ]
    });
}








function $6f812bcbdad827c6$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $6f812bcbdad827c6$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $48e4b1fcfcd646c1$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $6f812bcbdad827c6$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $0bb108cf9f15301b$export$2e2bcd8739ae039)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $48e4b1fcfcd646c1$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $6f812bcbdad827c6$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $49fc6b0b9a1bf345$export$6321afa313b251b5)(args, cache.registered);
        $6f812bcbdad827c6$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $6f812bcbdad827c6$var$merge(cache.registered, css, $6f812bcbdad827c6$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $48e4b1fcfcd646c1$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $6f812bcbdad827c6$var$merge.bind(null, cache.registered, css)
    };
};
var $6f812bcbdad827c6$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};





var $d77565acc82ac668$var$_createEmotion = (0, $6f812bcbdad827c6$export$2e2bcd8739ae039)({
    key: 'css'
}), $d77565acc82ac668$export$4909b86c8034bf73 = $d77565acc82ac668$var$_createEmotion.flush, $d77565acc82ac668$export$fa8d919ba61d84db = $d77565acc82ac668$var$_createEmotion.hydrate, $d77565acc82ac668$export$a274e22fb40f762e = $d77565acc82ac668$var$_createEmotion.cx, $d77565acc82ac668$export$4950aa0f605343fb = $d77565acc82ac668$var$_createEmotion.merge, $d77565acc82ac668$export$95d99596f328fd52 = $d77565acc82ac668$var$_createEmotion.getRegisteredStyles, $d77565acc82ac668$export$efb9f5caaa2ca0c7 = $d77565acc82ac668$var$_createEmotion.injectGlobal, $d77565acc82ac668$export$d25ddfdf17c3ad3e = $d77565acc82ac668$var$_createEmotion.keyframes, $d77565acc82ac668$export$dbf350e5966cf602 = $d77565acc82ac668$var$_createEmotion.css, $d77565acc82ac668$export$995990c5c04c46f0 = $d77565acc82ac668$var$_createEmotion.sheet, $d77565acc82ac668$export$69a3209f1a06c04d = $d77565acc82ac668$var$_createEmotion.cache;









let $184b8f5fc607fb11$var$_ = (t)=>t, $184b8f5fc607fb11$var$t, $184b8f5fc607fb11$var$t1, $184b8f5fc607fb11$var$t2;
// TODO DEPRECATE we now use Card from cards/Card.tsx
const $184b8f5fc607fb11$var$LegacyCard = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($184b8f5fc607fb11$var$t || ($184b8f5fc607fb11$var$t = $184b8f5fc607fb11$var$_`
    transition: ${0};
    overflow: hidden;
    border-radius: 10px;
`), (0, $8951886a6b49e92a$export$66bb15e2994e6a26).default);
const $184b8f5fc607fb11$export$eeffb7d514a37123 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($184b8f5fc607fb11$var$t1 || ($184b8f5fc607fb11$var$t1 = $184b8f5fc607fb11$var$_`
    transition: ${0};
    background-color: ${0};
    border-radius: 10px;
`), (0, $8951886a6b49e92a$export$66bb15e2994e6a26).default, (props)=>props.theme.color.background);
const $184b8f5fc607fb11$export$e0b30d1797fa97ad = (0, $8de346382d86c747$export$2e2bcd8739ae039)($184b8f5fc607fb11$var$LegacyCard)($184b8f5fc607fb11$var$t2 || ($184b8f5fc607fb11$var$t2 = $184b8f5fc607fb11$var$_`
    cursor: pointer;
    &:hover {
        box-shadow: ${0};
    }
    &:focus-within {
        outline: ${0} auto 2px;
    }
`), (0, $8951886a6b49e92a$export$16e1fc8de5cd9687).hover, (0, $8951886a6b49e92a$export$35e9368ef982300f).accent);
var $184b8f5fc607fb11$export$2e2bcd8739ae039 = $184b8f5fc607fb11$var$LegacyCard;


let $30f62651b17206ee$var$_ = (t)=>t, $30f62651b17206ee$var$t;
const $30f62651b17206ee$var$ActionCardWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$2e2bcd8739ae039))($30f62651b17206ee$var$t || ($30f62651b17206ee$var$t = $30f62651b17206ee$var$_`
    border: 1px solid ${0};
    box-shadow: none;
    display: flex;
    overflow: visible;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 380px;
    max-width: 800px;
    width: 100%;
    padding: 16px;
    background-color: ${0};
    color: ${0};
    > * {
        margin: 8px 16px;
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary_light, (props)=>props.theme.color.background, (props)=>props.theme.color.text);
var $30f62651b17206ee$export$2e2bcd8739ae039 = $30f62651b17206ee$var$ActionCardWrapper;



let $e5f1d53bbf8fecdc$var$_ = (t)=>t, $e5f1d53bbf8fecdc$var$t;
const $e5f1d53bbf8fecdc$var$ChipButtonContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5f1d53bbf8fecdc$var$t || ($e5f1d53bbf8fecdc$var$t = $e5f1d53bbf8fecdc$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
`));
var $e5f1d53bbf8fecdc$export$2e2bcd8739ae039 = $e5f1d53bbf8fecdc$var$ChipButtonContainer;



let $4f907cce853cc2ff$var$_ = (t)=>t, $4f907cce853cc2ff$var$t;
// TODO MOVE TO COMPONENTS
const $4f907cce853cc2ff$var$MenuCardContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4f907cce853cc2ff$var$t || ($4f907cce853cc2ff$var$t = $4f907cce853cc2ff$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 32px;
    flex: 1;
    width: 100%;
    gap: 0.5rem;
`));
var $4f907cce853cc2ff$export$2e2bcd8739ae039 = $4f907cce853cc2ff$var$MenuCardContainer;









let $73229ceea4361fb2$var$_ = (t)=>t, $73229ceea4361fb2$var$t;
const $73229ceea4361fb2$var$FieldContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($73229ceea4361fb2$var$t || ($73229ceea4361fb2$var$t = $73229ceea4361fb2$var$_`
    padding: 0 16px;
    margin: 16px 0;

    input {
        margin-top: 4px;
        width: calc(100% - 32px);
    }
`));
var $73229ceea4361fb2$export$2e2bcd8739ae039 = $73229ceea4361fb2$var$FieldContainer;







var $7fPBF = parcelRequire("7fPBF");











var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $decbc28a2d75c38b$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}







'use client';
function $0f283a2aa4430763$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $0f283a2aa4430763$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $0f283a2aa4430763$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $0f283a2aa4430763$var$isEmpty(obj) {
    return $0f283a2aa4430763$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $0f283a2aa4430763$var$TextareaAutosize = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "onChange",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const textareaRef = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $7fPBF.useRef(null);
    const hiddenTextareaRef = $7fPBF.useRef(null);
    const calculateTextareaStyles = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $e6403c3a02044c6f$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $0f283a2aa4430763$var$getStyleValue(computedStyle.paddingBottom) + $0f283a2aa4430763$var$getStyleValue(computedStyle.paddingTop);
        const border = $0f283a2aa4430763$var$getStyleValue(computedStyle.borderBottomWidth) + $0f283a2aa4430763$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $0f283a2aa4430763$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $0f283a2aa4430763$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $7fPBF.useRef(-1);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $decbc28a2d75c38b$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $e6403c3a02044c6f$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $0f283a2aa4430763$var$styles.shadow, style), {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $0f283a2aa4430763$export$2e2bcd8739ae039 = $0f283a2aa4430763$var$TextareaAutosize;



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $19e55fec28026df4$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $19e55fec28026df4$export$2e2bcd8739ae039 = $19e55fec28026df4$var$FormControlContext;



var $7fPBF = parcelRequire("7fPBF");

'use client';
function $7c05b6d5a150dbd8$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $19e55fec28026df4$export$2e2bcd8739ae039));
}
function $7c05b6d5a150dbd8$export$a733b6eeb54fd614({ props: props, states: states }) {
    const muiFormControl = $7fPBF.useContext((0, $19e55fec28026df4$export$2e2bcd8739ae039));
    const result = {};
    states.forEach((state)=>{
        const value = props[state];
        result[state] = value === undefined && muiFormControl ? muiFormControl[state] : value;
    });
    return [
        result,
        muiFormControl
    ];
}








const $f4d953277e740006$var$splitProps = (props)=>{
    var _props_theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    var _props_theme_unstable_sxConfig;
    const config = (_props_theme_unstable_sxConfig = props === null || props === void 0 ? void 0 : (_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.unstable_sxConfig) !== null && _props_theme_unstable_sxConfig !== void 0 ? _props_theme_unstable_sxConfig : (0, $1d606436c1f166ff$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $f4d953277e740006$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "sx"
    ]);
    const { systemProps: systemProps, otherProps: otherProps } = $f4d953277e740006$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $9450f632817fee8b$export$53b83ca8eaab0383)(result)) return systemProps;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, systemProps, result);
    };
    else finalSx = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, systemProps, inSx);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, otherProps), {
        sx: finalSx
    });
}










'use client';
function $d0683fcdabbf22d2$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d77204311b13899f$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        defaultTheme: (0, $7a5b46fd67f157c3$export$2e2bcd8739ae039),
        themeId: (0, $3096faf8e377d232$export$2e2bcd8739ae039)
    }));
}
var $d0683fcdabbf22d2$export$2e2bcd8739ae039 = $d0683fcdabbf22d2$var$GlobalStyles;





function $bd864450f0fe6591$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $824c049f32d4395d$exports.jsx)((0, $d0683fcdabbf22d2$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    theme: theme
                }, props)) : styles
        }));
    };
}
function $bd864450f0fe6591$export$7e7f5719ff4debb1() {
    return 0, $f4d953277e740006$export$2e2bcd8739ae039;
}







'use client';
var $e367f16ec1a5cce1$export$2e2bcd8739ae039 = (0, $9a1cc0725facde24$export$2e2bcd8739ae039);



var $3f5ab0f2fc599ae7$export$2e2bcd8739ae039 = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039);



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $58bd733c82ee5006$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $58bd733c82ee5006$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($58bd733c82ee5006$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $58bd733c82ee5006$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $58bd733c82ee5006$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $8f851f1fb9b359ad$export$ef57d5c8ca2278f6(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $8f851f1fb9b359ad$var$inputBaseClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputTypeSearch'
]);
var $8f851f1fb9b359ad$export$2e2bcd8739ae039 = $8f851f1fb9b359ad$var$inputBaseClasses;




'use client';
var $59aac830385ae48a$var$_InputGlobalStyles;
const $59aac830385ae48a$var$MUI_AUTO_FILL = 'mui-auto-fill';
const $59aac830385ae48a$var$MUI_AUTO_FILL_CANCEL = 'mui-auto-fill-cancel';
const $59aac830385ae48a$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $59aac830385ae48a$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.type === 'search' && styles.inputTypeSearch
    ];
};
const $59aac830385ae48a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            readOnly && 'readOnly'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8f851f1fb9b359ad$export$ef57d5c8ca2278f6), classes);
};
const $59aac830385ae48a$export$298a043133d72a38 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $59aac830385ae48a$export$965edad20a84fa75
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.body1), {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $59aac830385ae48a$export$ee10465db6ff6017 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $59aac830385ae48a$export$cf507b112810e72d
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'opacity', {
        duration: theme.transitions.duration.shorter
    }));
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: $59aac830385ae48a$var$MUI_AUTO_FILL_CANCEL,
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: $59aac830385ae48a$var$MUI_AUTO_FILL
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $59aac830385ae48a$var$InputGlobalStyles = (0, $bd864450f0fe6591$export$db53682eef82cc11)({
    // Keep keyframes non-empty for Emotion production builds. Animation properties are ignored
    // inside keyframes, avoiding the visible display animation triggered by Chrome 117+.
    [`@keyframes ${$59aac830385ae48a$var$MUI_AUTO_FILL}`]: {
        from: {
            animationName: $59aac830385ae48a$var$MUI_AUTO_FILL
        }
    },
    [`@keyframes ${$59aac830385ae48a$var$MUI_AUTO_FILL_CANCEL}`]: {
        from: {
            animationName: $59aac830385ae48a$var$MUI_AUTO_FILL_CANCEL
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $59aac830385ae48a$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        'aria-describedby',
        'aria-label',
        "autoComplete",
        "autoFocus",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "disableInjectingGlobalStyles",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "maxRows",
        "minRows",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "size",
        "slotProps",
        "slots",
        "startAdornment",
        "type",
        "value"
    ]);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const [fcs, muiFormControl] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $58bd733c82ee5006$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    // Sync focused state when autoFocus is used in SSR.
    // If the browser focused the element before hydration, the onFocus handler never
    // fires. If it did not, React hydration does not call focus() for autoFocus.
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        if (!autoFocus) return;
        const input = inputRef.current;
        if (!input) return;
        const doc = (0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(input);
        const activeElement = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
        const noElementFocused = activeElement == null || activeElement === doc.body || activeElement === doc.documentElement;
        if (input === activeElement) {
            if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus();
            else setFocused(true);
        } else if (noElementFocused) input.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoFocus
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $0f283a2aa4430763$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === $59aac830385ae48a$var$MUI_AUTO_FILL_CANCEL ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $59aac830385ae48a$var$useUtilityClasses(ownerState);
    const Root = slots.root || $59aac830385ae48a$export$298a043133d72a38;
    const rootProps = slotProps.root || {};
    const Input = slots.input || $59aac830385ae48a$export$ee10465db6ff6017;
    inputProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, inputProps, slotProps.input);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $59aac830385ae48a$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($59aac830385ae48a$var$_InputGlobalStyles || ($59aac830385ae48a$var$_InputGlobalStyles = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($59aac830385ae48a$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Root, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
                ref: ref,
                onClick: handleClick
            }), other, !(0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ownerState, rootProps.ownerState)
            }), {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19e55fec28026df4$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Input, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            "aria-label": ariaLabel,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ownerState, inputProps.ownerState)
                        }), {
                            ref: handleInputRef,
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fcs), {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $59aac830385ae48a$export$2e2bcd8739ae039 = $59aac830385ae48a$var$InputBase;









function $d09e71aa67920ff5$export$c1c4b4545ad2ea5f(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $d09e71aa67920ff5$var$inputLabelClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $d09e71aa67920ff5$export$2e2bcd8739ae039 = $d09e71aa67920ff5$var$inputLabelClasses;






function $4f2d1e17fd74d4a3$export$cdb270390122322b(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $4f2d1e17fd74d4a3$var$inputClasses = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $8f851f1fb9b359ad$export$2e2bcd8739ae039), (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $4f2d1e17fd74d4a3$export$2e2bcd8739ae039 = $4f2d1e17fd74d4a3$var$inputClasses;





'use client';
const $6ebe290b69afc685$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $4f2d1e17fd74d4a3$export$cdb270390122322b), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $6ebe290b69afc685$var$InputRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $59aac830385ae48a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $59aac830385ae48a$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    [`label + &, .${(0, $d09e71aa67920ff5$export$2e2bcd8739ae039).root} + &`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)'
                    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })), {
                        pointerEvents: 'none' // Transparent to the hover style.
                    }),
                    [`&.${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0
                    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'border-bottom-color', {
                        duration: theme.transitions.duration.shorter
                    })), {
                        pointerEvents: 'none' // Transparent to the hover style.
                    }),
                    [`&:hover:not(.${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).disabled}, .${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $6ebe290b69afc685$var$InputInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $59aac830385ae48a$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $59aac830385ae48a$export$cf507b112810e72d)
})({});
const $6ebe290b69afc685$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, notched: notched, slotProps: // declare here to prevent spreading to DOM
    slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "disableUnderline",
        "fullWidth",
        "inputComponent",
        "multiline",
        "notched",
        "slotProps",
        "slots",
        "type"
    ]);
    const classes = $6ebe290b69afc685$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ? (0, $9450f632817fee8b$export$2e2bcd8739ae039)(slotProps, inputComponentsProps) : inputComponentsProps;
    var _slots_root;
    const RootSlot = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : $6ebe290b69afc685$var$InputRoot;
    var _slots_input;
    const InputSlot = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : $6ebe290b69afc685$var$InputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59aac830385ae48a$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other), {
        classes: classes
    }));
});
$6ebe290b69afc685$var$Input.muiName = 'Input';
var $6ebe290b69afc685$export$2e2bcd8739ae039 = $6ebe290b69afc685$var$Input;






var $7fPBF = parcelRequire("7fPBF");














function $572939f6e0094c91$export$3331e419f1a48437(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $572939f6e0094c91$var$filledInputClasses = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $8f851f1fb9b359ad$export$2e2bcd8739ae039), (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiFilledInput', [
    'root',
    'underline',
    'input',
    'adornedStart',
    'adornedEnd',
    'sizeSmall',
    'multiline',
    'hiddenLabel'
]));
var $572939f6e0094c91$export$2e2bcd8739ae039 = $572939f6e0094c91$var$filledInputClasses;






'use client';
const $ded456c71337d0a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $572939f6e0094c91$export$3331e419f1a48437), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $ded456c71337d0a5$var$FilledInputRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $59aac830385ae48a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $59aac830385ae48a$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
    })), {
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $572939f6e0094c91$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $572939f6e0094c91$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)'
                    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })), {
                        pointerEvents: 'none' // Transparent to the hover style.
                    }),
                    [`&.${(0, $572939f6e0094c91$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $572939f6e0094c91$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0
                    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'border-bottom-color', {
                        duration: theme.transitions.duration.shorter
                    })), {
                        pointerEvents: 'none' // Transparent to the hover style.
                    }),
                    [`&:hover:not(.${(0, $572939f6e0094c91$export$2e2bcd8739ae039).disabled}, .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $572939f6e0094c91$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>{
                var _palette_color;
                return {
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(_palette_color = (theme.vars || theme).palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main}`
                        }
                    }
                };
            }),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    });
}));
const $ded456c71337d0a5$var$FilledInputInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $59aac830385ae48a$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $59aac830385ae48a$export$cf507b112810e72d)
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        '&:-webkit-autofill': (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, !theme.vars && {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff'
        }), {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }), theme.vars && theme.applyStyles('dark', {
            WebkitBoxShadow: '0 0 0 100px #266798 inset',
            WebkitTextFillColor: '#fff',
            caretColor: '#fff'
        })),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $ded456c71337d0a5$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, notched: notched, slotProps: // declare here to prevent spreading to DOM
    slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "disableUnderline",
        "fullWidth",
        "hiddenLabel",
        "inputComponent",
        "multiline",
        "notched",
        "slotProps",
        "slots",
        "type"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $ded456c71337d0a5$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ? (0, $9450f632817fee8b$export$2e2bcd8739ae039)(filledInputComponentsProps, slotProps) : filledInputComponentsProps;
    var _slots_root;
    const RootSlot = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : $ded456c71337d0a5$var$FilledInputRoot;
    var _slots_input;
    const InputSlot = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : $ded456c71337d0a5$var$FilledInputInput;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59aac830385ae48a$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other), {
        classes: classes
    }));
});
$ded456c71337d0a5$var$FilledInput.muiName = 'Input';
var $ded456c71337d0a5$export$2e2bcd8739ae039 = $ded456c71337d0a5$var$FilledInput;






var $7fPBF = parcelRequire("7fPBF");












'use client';
var $09b096a03a4e545d$var$_span;
const $09b096a03a4e545d$var$NotchedOutlineRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $09b096a03a4e545d$var$NotchedOutlineLegend = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    padding: 0,
                    lineHeight: '11px'
                }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'width', {
                    duration: 150,
                    easing: theme.transitions.easing.easeOut
                }))
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01
                }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'max-width', {
                    duration: 50,
                    easing: theme.transitions.easing.easeOut
                })), {
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                })
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    maxWidth: '100%'
                }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'max-width', {
                    duration: 100,
                    easing: theme.transitions.easing.easeOut,
                    delay: 50
                }))
            }
        ]
    })));
function $09b096a03a4e545d$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "classes",
        "className",
        "label",
        "notched"
    ]);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($09b096a03a4e545d$var$NotchedOutlineRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($09b096a03a4e545d$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: label
            }) : $09b096a03a4e545d$var$_span || ($09b096a03a4e545d$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    }));
}












function $515e3e51337f7613$export$89922944c7227687(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $515e3e51337f7613$var$outlinedInputClasses = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $8f851f1fb9b359ad$export$2e2bcd8739ae039), (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $515e3e51337f7613$export$2e2bcd8739ae039 = $515e3e51337f7613$var$outlinedInputClasses;





'use client';
const $1c1528b45b139d82$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $515e3e51337f7613$export$89922944c7227687), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $1c1528b45b139d82$var$OutlinedInputRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $59aac830385ae48a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $59aac830385ae48a$export$965edad20a84fa75)
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $515e3e51337f7613$export$2e2bcd8739ae039).focused} .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $515e3e51337f7613$export$2e2bcd8739ae039).focused} .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${(0, $515e3e51337f7613$export$2e2bcd8739ae039).error} .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $515e3e51337f7613$export$2e2bcd8739ae039).disabled} .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $1c1528b45b139d82$var$NotchedOutlineRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $09b096a03a4e545d$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $1c1528b45b139d82$var$OutlinedInputInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $59aac830385ae48a$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $59aac830385ae48a$export$cf507b112810e72d)
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        '&:-webkit-autofill': (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, !theme.vars && {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff'
        }), {
            borderRadius: 'inherit'
        }), theme.vars && theme.applyStyles('dark', {
            WebkitBoxShadow: '0 0 0 100px #266798 inset',
            WebkitTextFillColor: '#fff',
            caretColor: '#fff'
        })),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $1c1528b45b139d82$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "fullWidth",
        "inputComponent",
        "label",
        "multiline",
        "notched",
        "slots",
        "slotProps",
        "type"
    ]);
    const classes = $1c1528b45b139d82$var$useUtilityClasses(props);
    const [fcs, muiFormControl] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    var _slots_root;
    const RootSlot = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : $1c1528b45b139d82$var$OutlinedInputRoot;
    var _slots_input;
    const InputSlot = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : $1c1528b45b139d82$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $1c1528b45b139d82$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59aac830385ae48a$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NotchedSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, notchedProps), {
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            })),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other), {
        classes: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes), {
            notchedOutline: null
        })
    }));
});
$1c1528b45b139d82$var$OutlinedInput.muiName = 'Input';
var $1c1528b45b139d82$export$2e2bcd8739ae039 = $1c1528b45b139d82$var$OutlinedInput;






var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");











function $01f4919a2cb43013$export$f7d501e40371cd17(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $01f4919a2cb43013$var$formLabelClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $01f4919a2cb43013$export$2e2bcd8739ae039 = $01f4919a2cb43013$var$formLabelClasses;



'use client';
const $1c6d2c28accf5634$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $01f4919a2cb43013$export$f7d501e40371cd17), classes);
};
const $1c6d2c28accf5634$export$aa5bc7f8a4705b27 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1), {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $01f4919a2cb43013$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $01f4919a2cb43013$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $01f4919a2cb43013$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $1c6d2c28accf5634$var$AsteriskComponent = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $01f4919a2cb43013$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $1c6d2c28accf5634$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    const [fcs] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $1c6d2c28accf5634$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($1c6d2c28accf5634$export$aa5bc7f8a4705b27, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other), {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($1c6d2c28accf5634$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $1c6d2c28accf5634$export$2e2bcd8739ae039 = $1c6d2c28accf5634$var$FormLabel;










'use client';
const $dbc61dc9c3129b5f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $d09e71aa67920ff5$export$c1c4b4545ad2ea5f), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $dbc61dc9c3129b5f$var$InputLabelRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $1c6d2c28accf5634$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $01f4919a2cb43013$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input` small size style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
                    'color',
                    'transform',
                    'max-width'
                ], {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }))
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $dbc61dc9c3129b5f$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "disableAnimation",
        "margin",
        "shrink",
        "variant",
        "className"
    ]);
    const [fcs, muiFormControl] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $dbc61dc9c3129b5f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dbc61dc9c3129b5f$var$InputLabelRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "data-shrink": shrink,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other), {
        ownerState: ownerState,
        classes: classes
    }));
});
var $dbc61dc9c3129b5f$export$2e2bcd8739ae039 = $dbc61dc9c3129b5f$var$InputLabel;






var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
function $99467bcdb0826632$export$2e2bcd8739ae039(element, muiNames) {
    var _element_type__payload_value, _element_type__payload, _element_type;
    var // For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/react/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    _element_type_muiName;
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf((_element_type_muiName = element.type.muiName) !== null && _element_type_muiName !== void 0 ? _element_type_muiName : (_element_type = element.type) === null || _element_type === void 0 ? void 0 : (_element_type__payload = _element_type._payload) === null || _element_type__payload === void 0 ? void 0 : (_element_type__payload_value = _element_type__payload.value) === null || _element_type__payload_value === void 0 ? void 0 : _element_type__payload_value.muiName) !== -1;
}


var $a2d1b41792d62690$export$2e2bcd8739ae039 = (0, $99467bcdb0826632$export$2e2bcd8739ae039);





function $b3bf553254cc5ffd$export$149c8b8bab2289d1(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $b3bf553254cc5ffd$var$formControlClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $b3bf553254cc5ffd$export$2e2bcd8739ae039 = $b3bf553254cc5ffd$var$formControlClasses;



'use client';
const $2987d9546a369844$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $b3bf553254cc5ffd$export$149c8b8bab2289d1), classes);
};
const $2987d9546a369844$var$FormControlRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $2987d9546a369844$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "focused",
        "fullWidth",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $2987d9546a369844$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $a2d1b41792d62690$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $a2d1b41792d62690$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $58bd733c82ee5006$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $a2d1b41792d62690$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $58bd733c82ee5006$export$d652b828d7fdeff8)(child.props, true) || (0, $58bd733c82ee5006$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $7fPBF.useRef(false);
    const onFilled = $7fPBF.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $7fPBF.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19e55fec28026df4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2987d9546a369844$var$FormControlRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other), {
            children: children
        }))
    });
});
var $2987d9546a369844$export$2e2bcd8739ae039 = $2987d9546a369844$var$FormControl;






var $7fPBF = parcelRequire("7fPBF");










function $034ade6cef2e1e77$export$a394fa61b1d583a9(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $034ade6cef2e1e77$var$formHelperTextClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $034ade6cef2e1e77$export$2e2bcd8739ae039 = $034ade6cef2e1e77$var$formHelperTextClasses;



'use client';
var $0230b9d36bca11dc$var$_span;
const $0230b9d36bca11dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $034ade6cef2e1e77$export$a394fa61b1d583a9), classes);
};
const $0230b9d36bca11dc$var$FormHelperTextRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption), {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $034ade6cef2e1e77$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $034ade6cef2e1e77$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $0230b9d36bca11dc$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    const [fcs] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $0230b9d36bca11dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0230b9d36bca11dc$var$FormHelperTextRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other), {
        ownerState: ownerState,
        children: children === ' ' ? $0230b9d36bca11dc$var$_span || ($0230b9d36bca11dc$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    }));
});
var $0230b9d36bca11dc$export$2e2bcd8739ae039 = $0230b9d36bca11dc$var$FormHelperText;






var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");












var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
// From mui-x: https://github.com/mui/mui-x/blob/bb92fb0adac6764461adea9a9d7d43f1095f49e5/packages/x-internals/src/fastObjectShallowCompare/fastObjectShallowCompare.ts
/* eslint-disable guard-for-in */ const $b8ddcca89edada37$var$is = Object.is;
function $b8ddcca89edada37$export$2e2bcd8739ae039(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    for(const key in a){
        aLength += 1;
        if (!$b8ddcca89edada37$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
    for(const _ in b)bLength += 1;
    return aLength === bLength;
}









var $7fPBF = parcelRequire("7fPBF");
'use client';
const $42a6f889b44da94f$export$9248f542b77b4e3f = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $42a6f889b44da94f$export$7d0448bcff5cc25() {
    const context = $7fPBF.useContext($42a6f889b44da94f$export$9248f542b77b4e3f);
    if (context === undefined) throw new Error('MUI: RovingTabIndexContext is missing. Roving tab index items must be placed within a roving tab index provider.');
    return context;
}


'use client';
const $bc3efb6b12d4ce5b$var$SUPPORTED_KEYS = [
    'ArrowRight',
    'ArrowLeft',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End'
];
function $bc3efb6b12d4ce5b$export$a80dd08291d838d9(params) {
    const { activeItemId: activeItemIdProp, getDefaultActiveItemId: getDefaultActiveItemId, orientation: orientation, isRtl: isRtl = false, isItemFocusable: itemFilter = $bc3efb6b12d4ce5b$export$1fa34763d581e7d, wrap: wrap = true } = params;
    const [activeItemIdState, setActiveItemIdState] = $7fPBF.useState(activeItemIdProp);
    const [previousActiveItemIdProp, setPreviousActiveItemIdProp] = $7fPBF.useState(activeItemIdProp);
    let activeItemIdCandidate = activeItemIdState;
    if (activeItemIdProp !== previousActiveItemIdProp) {
        setPreviousActiveItemIdProp(activeItemIdProp);
        if (activeItemIdProp !== undefined && activeItemIdProp !== activeItemIdState) {
            activeItemIdCandidate = activeItemIdProp;
            setActiveItemIdState(activeItemIdProp);
        }
    }
    const containerRef = $7fPBF.useRef(null);
    // based on https://github.com/mui/base-ui/blob/7392a928fca91fcc68b9fad3439ac61e10f3f7ba/packages/react/src/composite/list/CompositeList.tsx#L25-L35
    const itemMapRef = $7fPBF.useRef(new Map());
    const [mapTick, setMapTick] = $7fPBF.useState(0);
    const orderedItems = $7fPBF.useMemo(()=>{
        return $bc3efb6b12d4ce5b$var$getOrderedItems(itemMapRef.current);
    }, [
        mapTick
    ]);
    const resolvedActiveItemId = $bc3efb6b12d4ce5b$var$resolveActiveItemId(activeItemIdCandidate, orderedItems, itemFilter, getDefaultActiveItemId);
    const activeItemIdRef = $7fPBF.useRef(resolvedActiveItemId);
    activeItemIdRef.current = resolvedActiveItemId;
    const getActiveItem = $7fPBF.useCallback(()=>{
        const snapshot = $bc3efb6b12d4ce5b$var$getOrderedItems(itemMapRef.current);
        const resolvedItemId = $bc3efb6b12d4ce5b$var$resolveActiveItemId(activeItemIdRef.current, snapshot, itemFilter, getDefaultActiveItemId);
        return $bc3efb6b12d4ce5b$var$getItemById(snapshot, resolvedItemId);
    }, [
        getDefaultActiveItemId,
        itemFilter
    ]);
    const getItemMap = $7fPBF.useCallback(()=>{
        return itemMapRef.current;
    }, []);
    const registerItem = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((item)=>{
        const previousItem = itemMapRef.current.get(item.id);
        if ((0, $b8ddcca89edada37$export$2e2bcd8739ae039)(previousItem !== null && previousItem !== void 0 ? previousItem : null, item)) return;
        itemMapRef.current.set(item.id, item);
        setMapTick((value)=>value + 1);
    });
    const unregisterItem = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((itemId)=>{
        if (itemMapRef.current.delete(itemId)) setMapTick((value)=>value + 1);
    });
    const setActiveItemId = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((itemId)=>{
        setActiveItemIdState(itemId);
    });
    const isItemActive = $7fPBF.useCallback((itemId)=>{
        return activeItemIdRef.current === itemId;
    }, []);
    // Moves focus relative to a starting index. This is the directional helper used by
    // keyboard navigation and `focusNext()`.
    const focusItem = $7fPBF.useCallback((currentIndex, direction, wrap, isItemFocusableOverride)=>{
        var _nextItem_element;
        const snapshot = $bc3efb6b12d4ce5b$var$getNavigableItemsSnapshot(itemMapRef.current);
        const nextItem = $bc3efb6b12d4ce5b$var$getNextActiveItem(snapshot, currentIndex, direction, wrap, isItemFocusableOverride !== null && isItemFocusableOverride !== void 0 ? isItemFocusableOverride : itemFilter);
        if (!nextItem) return null;
        (_nextItem_element = nextItem.element) === null || _nextItem_element === void 0 ? void 0 : _nextItem_element.focus();
        setActiveItemIdState(nextItem.id);
        return nextItem;
    }, [
        itemFilter
    ]);
    const getContainerProps = $7fPBF.useCallback((ref)=>{
        const onFocus = (event)=>{
            const snapshot = $bc3efb6b12d4ce5b$var$getNavigableItemsSnapshot(itemMapRef.current);
            const focusedIndex = $bc3efb6b12d4ce5b$var$findItemIndexByElement(snapshot, event.target);
            if (focusedIndex !== -1) setActiveItemIdState(snapshot[focusedIndex].id);
        };
        const onKeyDown = (event)=>{
            if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
            if (!$bc3efb6b12d4ce5b$var$SUPPORTED_KEYS.includes(event.key)) return;
            let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
            let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
            if (orientation === 'horizontal' && isRtl) {
                previousItemKey = 'ArrowRight';
                nextItemKey = 'ArrowLeft';
            }
            const snapshot = $bc3efb6b12d4ce5b$var$getNavigableItemsSnapshot(itemMapRef.current);
            const currentFocus = (0, $cffea48de8ee8b2e$export$2e2bcd8739ae039)((0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(containerRef.current));
            const isFocusOnContainer = currentFocus === containerRef.current;
            let currentIndex = $bc3efb6b12d4ce5b$var$getCurrentActiveItemIndex(snapshot, currentFocus, activeItemIdRef.current);
            let direction = 'next';
            switch(event.key){
                case previousItemKey:
                    direction = 'previous';
                    event.preventDefault();
                    if (isFocusOnContainer) // Set to length, so that the previous focused element will be the last one.
                    currentIndex = snapshot.length;
                    break;
                case nextItemKey:
                    event.preventDefault();
                    if (isFocusOnContainer) currentIndex = -1;
                    break;
                case 'Home':
                    event.preventDefault();
                    currentIndex = -1;
                    break;
                case 'End':
                    event.preventDefault();
                    direction = 'previous';
                    currentIndex = snapshot.length;
                    break;
                default:
                    return;
            }
            focusItem(currentIndex, direction, wrap);
        };
        return {
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            ref: $bc3efb6b12d4ce5b$var$handleRefs(ref, (elementNode)=>{
                containerRef.current = elementNode;
            })
        };
    }, [
        focusItem,
        isRtl,
        orientation,
        wrap
    ]);
    const focusNext = $7fPBF.useCallback((isItemFocusableOverride)=>{
        var _focusItem;
        const snapshot = $bc3efb6b12d4ce5b$var$getNavigableItemsSnapshot(itemMapRef.current);
        const currentFocus = (0, $cffea48de8ee8b2e$export$2e2bcd8739ae039)((0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(containerRef.current));
        const isFocusOnContainer = currentFocus === containerRef.current;
        const currentIndex = isFocusOnContainer ? -1 : $bc3efb6b12d4ce5b$var$getCurrentActiveItemIndex(snapshot, currentFocus, activeItemIdRef.current);
        var _focusItem_id;
        return (_focusItem_id = (_focusItem = focusItem(currentIndex, 'next', true, isItemFocusableOverride)) === null || _focusItem === void 0 ? void 0 : _focusItem.id) !== null && _focusItem_id !== void 0 ? _focusItem_id : null;
    }, [
        focusItem
    ]);
    return $7fPBF.useMemo(()=>({
            activeItemId: resolvedActiveItemId,
            focusNext: focusNext,
            getActiveItem: getActiveItem,
            getContainerProps: getContainerProps,
            getItemMap: getItemMap,
            isItemActive: isItemActive,
            registerItem: registerItem,
            setActiveItemId: setActiveItemId,
            unregisterItem: unregisterItem
        }), [
        resolvedActiveItemId,
        focusNext,
        getActiveItem,
        getContainerProps,
        getItemMap,
        isItemActive,
        registerItem,
        setActiveItemId,
        unregisterItem
    ]);
}
function $bc3efb6b12d4ce5b$export$736d50a885584c2d(params) {
    const rootContext = (0, $42a6f889b44da94f$export$7d0448bcff5cc25)();
    const { activeItemId: activeItemId, registerItem: registerItem, unregisterItem: unregisterItem } = rootContext;
    const elementRef = $7fPBF.useRef(null);
    const item = $7fPBF.useMemo(()=>{
        var _params_disabled, _params_focusableWhenDisabled, _params_selected;
        return {
            disabled: (_params_disabled = params.disabled) !== null && _params_disabled !== void 0 ? _params_disabled : false,
            element: null,
            focusableWhenDisabled: (_params_focusableWhenDisabled = params.focusableWhenDisabled) !== null && _params_focusableWhenDisabled !== void 0 ? _params_focusableWhenDisabled : false,
            id: params.id,
            selected: (_params_selected = params.selected) !== null && _params_selected !== void 0 ? _params_selected : false,
            textValue: params.textValue
        };
    }, [
        params.disabled,
        params.focusableWhenDisabled,
        params.id,
        params.selected,
        params.textValue
    ]);
    const latestItemRef = $7fPBF.useRef(item);
    // Keep the ref callback stable across item prop changes. The callback reads the latest
    // item metadata from this ref so React does not have to detach and re-attach the ref
    // every time `disabled`, `selected`, or similar item state changes.
    latestItemRef.current = item;
    const handleElementRef = $7fPBF.useCallback((element)=>{
        elementRef.current = element;
        if (element == null) {
            // Ref detachment runs during React's commit phase. Calling `unregisterItem()`
            // synchronously here can trigger a nested state update while React is still
            // finishing that commit. Unregister in a microtask so it runs after the
            // commit completes.
            queueMicrotask(()=>{
                // null check prevents stale unregisters for a remove-then-re-add edge case
                if (elementRef.current == null) unregisterItem(params.id);
            });
            return;
        }
        registerItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, latestItemRef.current), {
            element: element
        }));
    }, [
        params.id,
        registerItem,
        unregisterItem
    ]);
    // `UseRovingTabIndexItemReturnValue.ref` must always be a callback ref. `useForkRef()`
    // is typed to return `null` when every input ref is nullish, but this call always includes
    // `handleElementRef`, so the merged ref cannot be `null` here.
    const mergedRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(params.ref, handleElementRef);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!elementRef.current) return;
        registerItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, item), {
            element: elementRef.current
        }));
    }, [
        item,
        registerItem
    ]);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        const itemId = params.id;
        // Keep unmount cleanup separate from the effect above. The effect above re-runs when
        // item metadata changes, but we only want to unregister on unmount or when the item id changes.
        return ()=>{
            unregisterItem(itemId);
        };
    }, [
        params.id,
        unregisterItem
    ]);
    return {
        ref: mergedRef,
        tabIndex: activeItemId === params.id ? 0 : -1
    };
}
/**
 * Resolves which item id should own the roving tab stop for the current render.
 *
 * This is the top-level decision point for "who gets `tabIndex=0` right now?".
 * For example:
 * - `Tabs` sometimes passes `selectedValue` as `activeItemId` so the selected tab becomes
 *   the tab stop when focus enters the list from outside.
 * - `MenuList` leaves `activeItemId` undefined and relies on the default-item logic below
 *   so that menu-specific rules decide which menu item should initially own the tab stop.
 *
 * @param activeItemId The item id supplied through the root hook's `activeItemId` option.
 *   `undefined` means "the caller did not ask for a specific item, use the default-item
 *   logic instead". `null` means "there is intentionally no preferred item, so also fall
 *   back to the default-item logic".
 * @param items The ordered registered items currently in the roving set.
 * @param isFocusable A predicate that decides whether an item may receive roving focus.
 * @param getDefaultActiveItemId Optional caller-provided function that picks the preferred
 *   default item when `activeItemId` is not driving the tab stop directly.
 * @returns The id of the item that should own `tabIndex=0`, or `null` if no item is focusable.
 */ function $bc3efb6b12d4ce5b$var$resolveActiveItemId(activeItemId, items, isFocusable, getDefaultActiveItemId) {
    if (activeItemId != null) return $bc3efb6b12d4ce5b$var$resolveRequestedItemId(activeItemId, items, isFocusable);
    return $bc3efb6b12d4ce5b$var$resolveDefaultItemId(items, isFocusable, getDefaultActiveItemId);
}
/**
 * Resolves the item id supplied through the root hook's `activeItemId` option.
 *
 * This path is used when a component such as `Tabs` or `MenuList` wants roving focus to
 * follow a specific logical item. For example, `Tabs` can pass the selected tab's value as
 * `activeItemId` so that the selected tab owns `tabIndex=0` when focus enters the list.
 *
 * @param requestedItemId The item id passed to the root hook's `activeItemId` option.
 * @param items The ordered registered items currently in the roving set.
 * @param isFocusable A predicate that decides whether an item may receive roving focus.
 * @returns The same id when it still points to a focusable item. If that id no longer exists,
 *   returns the first focusable item. If the id still exists but the item is not focusable,
 *   returns the next focusable item after it without wrapping.
 */ function $bc3efb6b12d4ce5b$var$resolveRequestedItemId(requestedItemId, items, isFocusable) {
    var _getNextActiveItem;
    const requestedItemIndex = $bc3efb6b12d4ce5b$var$findItemIndexById(items, requestedItemId);
    if (requestedItemIndex === -1) return $bc3efb6b12d4ce5b$var$getFirstFocusableItemId(items, isFocusable);
    if (isFocusable(items[requestedItemIndex])) return items[requestedItemIndex].id;
    var _getNextActiveItem_id;
    return (_getNextActiveItem_id = (_getNextActiveItem = $bc3efb6b12d4ce5b$var$getNextActiveItem(items, requestedItemIndex, 'next', false, isFocusable)) === null || _getNextActiveItem === void 0 ? void 0 : _getNextActiveItem.id) !== null && _getNextActiveItem_id !== void 0 ? _getNextActiveItem_id : null;
}
/**
 * Resolves the default active item when the caller is not driving roving focus with
 * `activeItemId`.
 *
 * This path is used on the initial render and whenever the caller leaves the choice of tab
 * stop to the hook. `getDefaultActiveItemId` lets a component prefer a specific logical item
 * before falling back to the first focusable item.
 *
 * For example:
 * - `MenuList` uses this path all the time. When `variant="selectedMenu"`, it prefers the
 *   selected menu item; otherwise it prefers the first focusable menu item.
 * - `Tabs` uses this path while focus is already inside the tab list, because at that point
 *   the current roving position should be driven by actual focus movement rather than by the
 *   selected tab value.
 *
 * @param items The ordered registered items currently in the roving set.
 * @param isFocusable A predicate that decides whether an item may receive roving focus.
 * @param getDefaultActiveItemId Optional caller-provided function that chooses which item
 *   should own the tab stop before the generic "first focusable item" fallback runs.
 * @returns The default item id when it points to a focusable item, otherwise the first
 *   focusable item in the snapshot, or `null` when none are focusable.
 */ function $bc3efb6b12d4ce5b$var$resolveDefaultItemId(items, isFocusable, getDefaultActiveItemId) {
    const defaultItemId = getDefaultActiveItemId === null || getDefaultActiveItemId === void 0 ? void 0 : getDefaultActiveItemId(items);
    if (defaultItemId != null) {
        const defaultItem = $bc3efb6b12d4ce5b$var$getItemById(items, defaultItemId);
        if (defaultItem && isFocusable(defaultItem)) return defaultItem.id;
    }
    return $bc3efb6b12d4ce5b$var$getFirstFocusableItemId(items, isFocusable);
}
/**
 * Finds the best starting index for keyboard navigation.
 *
 * This is used immediately before keyboard navigation and `focusNext()` navigation. It prefers
 * the item that currently holds DOM focus, but if focus is on the container or outside the item
 * set it falls back to the last known active item id.
 *
 * @param items The navigable item snapshot used for the current keyboard interaction.
 * @param currentFocus The element that currently has DOM focus, if any.
 * @param fallbackActiveItemId The last known active item id when focus is not on an item.
 * @returns The focused item's index when focus is currently on an item. Otherwise, the index
 *   of the fallback active item id, or `-1` when no matching item exists.
 */ function $bc3efb6b12d4ce5b$var$getCurrentActiveItemIndex(items, currentFocus, fallbackActiveItemId) {
    if (currentFocus) {
        const focusedIndex = $bc3efb6b12d4ce5b$var$findItemIndexByElement(items, currentFocus);
        if (focusedIndex !== -1) return focusedIndex;
    }
    return $bc3efb6b12d4ce5b$var$findItemIndexById(items, fallbackActiveItemId);
}
/**
 * Walks the item snapshot to find the next focusable item in the requested direction.
 *
 * This is the shared navigation primitive used by keyboard handling and imperative helpers
 * such as `focusNext()`. It starts from the supplied index, advances through the snapshot in
 * the requested direction, and skips over items that fail the `isFocusable` predicate.
 *
 * @param items The ordered navigable item snapshot.
 * @param currentIndex The index to start from. Use `-1` to start before the first item or
 *   `items.length` to start after the last item.
 * @param direction The direction to move through the snapshot.
 * @param wrap Whether navigation should wrap around at the ends of the list.
 * @param isFocusable A predicate that decides whether an item may receive roving focus.
 * @returns The next focusable item record, or `null` when no focusable item can be reached.
 */ function $bc3efb6b12d4ce5b$var$getNextActiveItem(items, currentIndex, direction, wrap, isFocusable) {
    const lastIndex = items.length - 1;
    if (lastIndex === -1) return null;
    let wrappedOnce = false;
    let nextIndex = $bc3efb6b12d4ce5b$var$getNextIndex(currentIndex, lastIndex, direction, wrap);
    const startIndex = nextIndex;
    while(nextIndex !== -1){
        if (nextIndex === startIndex) {
            if (wrappedOnce) return null;
            wrappedOnce = true;
        }
        const nextItem = items[nextIndex];
        if (!nextItem || !isFocusable(nextItem)) nextIndex = $bc3efb6b12d4ce5b$var$getNextIndex(nextIndex, lastIndex, direction, wrap);
        else return nextItem;
    }
    return null;
}
function $bc3efb6b12d4ce5b$var$getFirstFocusableItemId(items, isFocusable) {
    var _items_find;
    var _items_find_id;
    return (_items_find_id = (_items_find = items.find((item)=>isFocusable(item))) === null || _items_find === void 0 ? void 0 : _items_find.id) !== null && _items_find_id !== void 0 ? _items_find_id : null;
}
function $bc3efb6b12d4ce5b$var$getItemById(items, itemId) {
    var _items_find;
    return itemId == null ? null : (_items_find = items.find((item)=>item.id === itemId)) !== null && _items_find !== void 0 ? _items_find : null;
}
function $bc3efb6b12d4ce5b$var$findItemIndexById(items, itemId) {
    return itemId == null ? -1 : items.findIndex((item)=>item.id === itemId);
}
function $bc3efb6b12d4ce5b$var$findItemIndexByElement(items, element) {
    if (!element) return -1;
    return items.findIndex((item)=>{
        var _item_element;
        return item.element === element || ((_item_element = item.element) === null || _item_element === void 0 ? void 0 : _item_element.contains(element));
    });
}
function $bc3efb6b12d4ce5b$var$getOrderedItems(itemMap) {
    const items = Array.from(itemMap.values());
    if (items.every((item)=>item.element == null)) return items;
    const connectedItems = items.filter($bc3efb6b12d4ce5b$var$isConnectedItem).sort((itemA, itemB)=>$bc3efb6b12d4ce5b$var$sortByDocumentPosition(itemA.element, itemB.element));
    const disconnectedItems = items.filter((item)=>!$bc3efb6b12d4ce5b$var$isConnectedItem(item));
    return [
        ...connectedItems,
        ...disconnectedItems
    ];
}
function $bc3efb6b12d4ce5b$var$getNavigableItemsSnapshot(itemMap) {
    return $bc3efb6b12d4ce5b$var$getOrderedItems(itemMap).filter($bc3efb6b12d4ce5b$var$isConnectedItem);
}
function $bc3efb6b12d4ce5b$var$getNextIndex(currentIndex, lastIndex, direction, wrap = true) {
    if (direction === 'next') {
        if (currentIndex === lastIndex) return wrap ? 0 : -1;
        return currentIndex + 1;
    }
    if (currentIndex === 0) return wrap ? lastIndex : -1;
    return currentIndex - 1;
}
function $bc3efb6b12d4ce5b$export$1fa34763d581e7d(item) {
    if (!item.element) return false;
    if (item.focusableWhenDisabled) return true;
    return !item.disabled && !item.element.hasAttribute('disabled') && item.element.getAttribute('aria-disabled') !== 'true' && item.element.hasAttribute('tabindex');
}
function $bc3efb6b12d4ce5b$var$isConnectedItem(item) {
    return item.element != null && item.element.isConnected;
}
/* eslint-disable no-bitwise */ function $bc3efb6b12d4ce5b$var$sortByDocumentPosition(a, b) {
    if (a === b) return 0;
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
/* eslint-enable no-bitwise */ function $bc3efb6b12d4ce5b$var$handleRefs(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            (0, $2f83cafe8ca49a0a$export$2e2bcd8739ae039)(ref !== null && ref !== void 0 ? ref : null, node);
        });
    };
}






var $3fd0af911c2661ac$export$2e2bcd8739ae039 = (0, $07f2847d4540e4ff$export$2e2bcd8739ae039);


'use client';
function $e500432f0027efe7$export$2e2bcd8739ae039(element, focusSource) {
    if (focusSource == null) {
        element.focus();
        return;
    }
    try {
        element.focus({
            focusVisible: focusSource === 'keyboard'
        });
    } catch (error) {
        element.focus();
    }
}







var $0f23d889c670216c$export$2e2bcd8739ae039 = (0, $e6403c3a02044c6f$export$2e2bcd8739ae039);






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $060e19b7623095b4$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $060e19b7623095b4$export$2e2bcd8739ae039 = $060e19b7623095b4$var$ListContext;




function $603ab10a4e946f77$export$c6bd6795ed6e3203(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiList', slot);
}
const $603ab10a4e946f77$var$listClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $603ab10a4e946f77$export$2e2bcd8739ae039 = $603ab10a4e946f77$var$listClasses;



'use client';
const $13e3cdc57dc522c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $603ab10a4e946f77$export$c6bd6795ed6e3203), classes);
};
const $13e3cdc57dc522c3$var$ListRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0,
                isolation: 'isolate' // Prevent overlap with iOS overlay scrollbars.
            }
        }
    ]
});
const $13e3cdc57dc522c3$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $13e3cdc57dc522c3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $060e19b7623095b4$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($13e3cdc57dc522c3$var$ListRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            as: component,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other), {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $13e3cdc57dc522c3$export$2e2bcd8739ae039 = $13e3cdc57dc522c3$var$List;



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $079d434782d2fb16$var$SelectFocusSourceContext = /*#__PURE__*/ $7fPBF.createContext(null);
function $079d434782d2fb16$export$990808021214d5e() {
    const context = $7fPBF.useContext($079d434782d2fb16$var$SelectFocusSourceContext);
    return context;
}
const $079d434782d2fb16$export$4aa9473fca4c4988 = $079d434782d2fb16$var$SelectFocusSourceContext.Provider;



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $fa21ae2d9022b983$export$1c2bdfb4407fdacf = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $fa21ae2d9022b983$export$f3a2a1dcca60a23() {
    const context = $7fPBF.useContext($fa21ae2d9022b983$export$1c2bdfb4407fdacf);
    if (context === undefined) throw new Error('MUI: MenuListContext is missing. MenuItems must be placed within Menu or MenuList.');
    return context;
}



'use client';
function $6b48b896db5396e8$var$getItemText(itemOrElement) {
    var _itemOrElement_element;
    const element = (_itemOrElement_element = itemOrElement === null || itemOrElement === void 0 ? void 0 : itemOrElement.element) !== null && _itemOrElement_element !== void 0 ? _itemOrElement_element : itemOrElement;
    if (!element) return '';
    if ((itemOrElement === null || itemOrElement === void 0 ? void 0 : itemOrElement.textValue) !== undefined) return itemOrElement.textValue;
    let text = element.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = element.textContent;
    return text !== null && text !== void 0 ? text : '';
}
function $6b48b896db5396e8$var$textCriteriaMatches(itemOrElement, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = $6b48b896db5396e8$var$getItemText(itemOrElement);
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $6b48b896db5396e8$var$isItemFocusableWithTextCriteria(item, criteria) {
    if (!$6b48b896db5396e8$var$textCriteriaMatches(item, criteria)) return false;
    return (0, $bc3efb6b12d4ce5b$export$1fa34763d581e7d)(item);
}
// Menu auto-focus is not always keyboard-driven. On open we often move focus to the
// active item programmatically so arrow-key navigation starts from the right place.
function $6b48b896db5396e8$var$focusInitialItem(element, focusSource) {
    (0, $e500432f0027efe7$export$2e2bcd8739ae039)(element, focusSource);
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $6b48b896db5396e8$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocusList = false, autoFocusItem: autoFocusActiveItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    const listRef = $7fPBF.useRef(null);
    const hasFocusedInitialTargetRef = $7fPBF.useRef(false);
    // Escape hatch for <Menu variant="menu"> (items have no selection state). When opened with
    // mouse/pointer, the initial focused item should still receive DOM focus, but ButtonBase
    // should suppress its focus-visible state for that one initial handoff.
    const [suppressInitialFocusVisible, setSuppressInitialFocusVisible] = $7fPBF.useState(false);
    // Current anchored <Menu>s cannot receive a `openInteractionType` signal from a trigger
    // the API only receives `open` and `anchorEl`. When <MenuList> is used in <Select>, the
    // internal <SelectInput> is able to achieve this via `useSelectFocusSource`.
    const focusSource = (0, $079d434782d2fb16$export$990808021214d5e)();
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    const getDefaultActiveItemId = $7fPBF.useCallback((items)=>{
        var _items_find, _items_find1, _items_find2;
        var _items_find_id, _ref;
        if (variant === 'selectedMenu') return (_ref = (_items_find_id = (_items_find = items.find((item)=>item.selected && (0, $bc3efb6b12d4ce5b$export$1fa34763d581e7d)(item))) === null || _items_find === void 0 ? void 0 : _items_find.id) !== null && _items_find_id !== void 0 ? _items_find_id : (_items_find1 = items.find((item)=>(0, $bc3efb6b12d4ce5b$export$1fa34763d581e7d)(item))) === null || _items_find1 === void 0 ? void 0 : _items_find1.id) !== null && _ref !== void 0 ? _ref : null;
        var _items_find_id1;
        return (_items_find_id1 = (_items_find2 = items.find((item)=>(0, $bc3efb6b12d4ce5b$export$1fa34763d581e7d)(item))) === null || _items_find2 === void 0 ? void 0 : _items_find2.id) !== null && _items_find_id1 !== void 0 ? _items_find_id1 : null;
    }, [
        variant
    ]);
    const rovingContainer = (0, $bc3efb6b12d4ce5b$export$a80dd08291d838d9)({
        activeItemId: undefined,
        getDefaultActiveItemId: getDefaultActiveItemId,
        orientation: 'vertical',
        wrap: !disableListWrap
    });
    const { activeItemId: activeItemId, focusNext: focusNext, getActiveItem: getActiveItem, getContainerProps: getContainerProps, getItemMap: getItemMap } = rovingContainer;
    const focusInitialTarget = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((force = false)=>{
        // `force` is used by the imperative action when `Menu` asks `MenuList` to restore its
        // initial focus target after the popover finishes entering, even if this list already
        // completed its normal one-time initial-focus path on an earlier render.
        if (!listRef.current || !force && hasFocusedInitialTargetRef.current) return null;
        if (autoFocusActiveItem) {
            const activeItem = getActiveItem();
            if (activeItem === null || activeItem === void 0 ? void 0 : activeItem.element) {
                const hasSelectedItem = Array.from(getItemMap().values()).some((item)=>item.selected);
                const shouldSuppressInitialFocusVisible = variant === 'menu' && hasSelectedItem && !activeItem.selected && focusSource == null;
                setSuppressInitialFocusVisible(shouldSuppressInitialFocusVisible);
                $6b48b896db5396e8$var$focusInitialItem(activeItem.element, focusSource);
                hasFocusedInitialTargetRef.current = true;
                return activeItem.element;
            }
            if (!autoFocusList) return null;
            // Keep the list container focusable while waiting for items to register,
            // or when there is no focusable item to move to.
            setSuppressInitialFocusVisible(false);
            listRef.current.focus();
            return listRef.current;
        }
        if (!autoFocusList) {
            setSuppressInitialFocusVisible(false);
            return null;
        }
        setSuppressInitialFocusVisible(false);
        listRef.current.focus();
        hasFocusedInitialTargetRef.current = true;
        return listRef.current;
    });
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        if (!autoFocusList && !autoFocusActiveItem) {
            hasFocusedInitialTargetRef.current = false;
            setSuppressInitialFocusVisible(false);
            return undefined;
        }
        focusInitialTarget();
        return undefined;
    }, [
        activeItemId,
        autoFocusActiveItem,
        autoFocusList,
        focusInitialTarget
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $3fd0af911c2661ac$export$2e2bcd8739ae039)((0, $0f23d889c670216c$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            },
            focusInitialTarget: ()=>{
                if (!listRef.current) return null;
                const currentFocus = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)((0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(listRef.current));
                if (currentFocus && (0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(listRef.current, currentFocus)) return currentFocus;
                return focusInitialTarget(true);
            }
        }), [
        focusInitialTarget
    ]);
    const rovingContainerProps = getContainerProps();
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(listRef, rovingContainerProps.ref, ref);
    const menuListContextValue = $7fPBF.useMemo(()=>({
            itemsFocusableWhenDisabled: disabledItemsFocusable,
            suppressInitialFocusVisible: suppressInitialFocusVisible,
            variant: variant
        }), [
        disabledItemsFocusable,
        suppressInitialFocusVisible,
        variant
    ]);
    const handleKeyDown = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event)=>{
        if (suppressInitialFocusVisible) setSuppressInitialFocusVisible(false);
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed && onKeyDown) {
            onKeyDown(event);
            return;
        }
        rovingContainerProps.onKeyDown(event);
        if (event.key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = event.key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const currentFocus = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)((0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(listRef.current));
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $6b48b896db5396e8$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || focusNext((item)=>$6b48b896db5396e8$var$isItemFocusableWithTextCriteria(item, criteria)) != null)) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $13e3cdc57dc522c3$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        onFocus: rovingContainerProps.onFocus,
        tabIndex: -1
    }, other), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa21ae2d9022b983$export$1c2bdfb4407fdacf).Provider, {
            value: menuListContextValue,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42a6f889b44da94f$export$9248f542b77b4e3f).Provider, {
                value: rovingContainer,
                children: children
            })
        })
    }));
});
var $6b48b896db5396e8$export$2e2bcd8739ae039 = $6b48b896db5396e8$var$MenuList;






var $7fPBF = parcelRequire("7fPBF");












var $a20ff4b1b2349f15$export$2e2bcd8739ae039 = (0, $decbc28a2d75c38b$export$2e2bcd8739ae039);









function $143df6a9f6803be4$export$88f455dd56c95edb(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $143df6a9f6803be4$var$popoverClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $143df6a9f6803be4$export$2e2bcd8739ae039 = $143df6a9f6803be4$var$popoverClasses;






function $a7f2a504e52c35ca$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ((0, $7847d856aad7e6a5$export$2e2bcd8739ae039)(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ownerState, defaultSlotPropsValue)) : externalSlotProps;
        const className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(ownerState === null || ownerState === void 0 ? void 0 : ownerState.className, defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.className, externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultSlotPropsValue, externalSlotPropsValue, handlers, !!className && {
            className: className
        }, (defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.style) && (externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.style) && {
            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultSlotPropsValue.style, externalSlotPropsValue.style)
        }, (defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.sx) && (externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.sx) && {
            sx: [
                ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                    defaultSlotPropsValue.sx
                ],
                ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                    externalSlotPropsValue.sx
                ]
            ]
        });
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultSlotProps, externalSlotProps, handlers, !!className && {
        className: className
    }, (typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.style) && (externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style) && {
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, typedDefaultSlotProps.style, externalSlotProps.style)
    }, (typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.sx) && (externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.sx) && {
        sx: [
            ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                typedDefaultSlotProps.sx
            ],
            ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                externalSlotProps.sx
            ]
        ]
    });
}



'use client';
function $0be5f260e07bc5b9$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $0be5f260e07bc5b9$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $0be5f260e07bc5b9$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $0be5f260e07bc5b9$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $0be5f260e07bc5b9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $143df6a9f6803be4$export$88f455dd56c95edb), classes);
};
const $0be5f260e07bc5b9$export$bcce13685275fc99 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $d2d6d7b93acac061$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $0be5f260e07bc5b9$export$821346c38a2d9390 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0be5f260e07bc5b9$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, disableAutoFocus: disableAutoFocus = false, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, slots: slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, transitionDuration: transitionDurationProp = 'auto', disableScrollLock: disableScrollLock = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "className",
        "container",
        "disableAutoFocus",
        "elevation",
        "marginThreshold",
        "open",
        "slots",
        "slotProps",
        "transformOrigin",
        "transitionDuration",
        "disableScrollLock"
    ]);
    const paperRef = $7fPBF.useRef();
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        transitionDuration: transitionDurationProp
    });
    const classes = $0be5f260e07bc5b9$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $0be5f260e07bc5b9$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $0be5f260e07bc5b9$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $0be5f260e07bc5b9$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $0be5f260e07bc5b9$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $0be5f260e07bc5b9$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $0be5f260e07bc5b9$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $0f23d889c670216c$export$2e2bcd8739ae039)($0be5f260e07bc5b9$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold != null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold != null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold != null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $0be5f260e07bc5b9$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top != null) element.style.setProperty('top', positioning.top);
        if (positioning.left != null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $a20ff4b1b2349f15$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $0f23d889c670216c$export$2e2bcd8739ae039)($0be5f260e07bc5b9$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [TransitionSlot, transitionSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $3ab1beedea58600b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onEntering: (element, isAppearing)=>{
                    var _handlers_onEntering;
                    (_handlers_onEntering = handlers.onEntering) === null || _handlers_onEntering === void 0 ? void 0 : _handlers_onEntering.call(handlers, element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    var _handlers_onExited;
                    (_handlers_onExited = handlers.onExited) === null || _handlers_onExited === void 0 ? void 0 : _handlers_onExited.call(handlers, element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)($0be5f260e07bc5b9$var$resolveAnchorEl(anchorEl)).body : undefined);
    const _useSlot = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $0be5f260e07bc5b9$export$bcce13685275fc99,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $a7f2a504e52c35ca$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }), [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp }] = _useSlot, rootProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_useSlot[1], [
        "slots",
        "slotProps"
    ]);
    const [PaperSlot, paperProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $0be5f260e07bc5b9$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps, !(0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(RootSlot) && {
        slots: rootSlotsProp,
        slotProps: rootSlotPropsProp,
        disableAutoFocus: disableAutoFocus,
        disableScrollLock: disableScrollLock
    }), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transitionSlotProps), {
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, paperProps), {
                children: children
            }))
        }))
    }));
});
var $0be5f260e07bc5b9$export$2e2bcd8739ae039 = $0be5f260e07bc5b9$var$Popover;







function $8c885a8feb63fd95$export$2cf86a63a84fe23d(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $8c885a8feb63fd95$var$menuClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $8c885a8feb63fd95$export$2e2bcd8739ae039 = $8c885a8feb63fd95$var$menuClasses;




'use client';
const $32855a33cbd5a576$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $32855a33cbd5a576$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $32855a33cbd5a576$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8c885a8feb63fd95$export$2cf86a63a84fe23d), classes);
};
const $32855a33cbd5a576$var$MenuRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $0be5f260e07bc5b9$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $32855a33cbd5a576$export$4f7c51a5920c9f33 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $0be5f260e07bc5b9$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $32855a33cbd5a576$var$MenuMenuList = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6b48b896db5396e8$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $32855a33cbd5a576$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, onClose: onClose, open: open, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "autoFocus",
        "children",
        "className",
        "disableAutoFocusItem",
        "onClose",
        "open",
        "PopoverClasses",
        "transitionDuration",
        "variant",
        "slots",
        "slotProps"
    ]);
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        transitionDuration: transitionDuration,
        variant: variant
    });
    const classes = $32855a33cbd5a576$var$useUtilityClasses(ownerState);
    const shouldManageInitialFocus = autoFocus && open; // `&& open` prevents a Menu with `keepMounted={true}` from accidentally stealing focus
    const shouldAutoFocusActiveItem = shouldManageInitialFocus && !disableAutoFocusItem;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, _isAppearing)=>{
        if (menuListActionsRef.current) {
            var _menuListActionsRef_current_focusInitialTarget, _menuListActionsRef_current;
            menuListActionsRef.current.adjustStyleForScrollbar(element, {
                direction: isRtl ? 'rtl' : 'ltr'
            });
            if (shouldManageInitialFocus) (_menuListActionsRef_current_focusInitialTarget = (_menuListActionsRef_current = menuListActionsRef.current).focusInitialTarget) === null || _menuListActionsRef_current_focusInitialTarget === void 0 ? void 0 : _menuListActionsRef_current_focusInitialTarget.call(_menuListActionsRef_current);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const rootSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $32855a33cbd5a576$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('list', {
        className: classes.list,
        elementType: $32855a33cbd5a576$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onKeyDown: (event)=>{
                    var _handlers_onKeyDown;
                    handleListKeyDown(event);
                    (_handlers_onKeyDown = handlers.onKeyDown) === null || _handlers_onKeyDown === void 0 ? void 0 : _handlers_onKeyDown.call(handlers, event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($32855a33cbd5a576$var$MenuRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        disableAutoFocus: autoFocus,
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $32855a33cbd5a576$var$RTL_ORIGIN : $32855a33cbd5a576$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            transition: slots.transition
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, resolvedTransitionProps), {
                onEntering: (...args)=>{
                    var _resolvedTransitionProps_onEntering;
                    handleEntering(...args);
                    resolvedTransitionProps === null || resolvedTransitionProps === void 0 ? void 0 : (_resolvedTransitionProps_onEntering = resolvedTransitionProps.onEntering) === null || _resolvedTransitionProps_onEntering === void 0 ? void 0 : _resolvedTransitionProps_onEntering.call(resolvedTransitionProps, ...args);
                }
            })
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState
    }, other), {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ListSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            actions: menuListActionsRef,
            autoFocus: shouldManageInitialFocus,
            autoFocusItem: shouldAutoFocusActiveItem,
            variant: variant
        }, listSlotProps), {
            children: children
        }))
    }));
});
var $32855a33cbd5a576$export$2e2bcd8739ae039 = $32855a33cbd5a576$var$Menu;






var $7fPBF = parcelRequire("7fPBF");







function $1f552146dc6b9d53$export$1ee13051fd9e2ab5(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $1f552146dc6b9d53$var$nativeSelectClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $1f552146dc6b9d53$export$2e2bcd8739ae039 = $1f552146dc6b9d53$var$nativeSelectClasses;





'use client';
const $4ad1daf29cda1856$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $1f552146dc6b9d53$export$1ee13051fd9e2ab5), classes);
};
const $4ad1daf29cda1856$export$50b3545a8ccd87af = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $1f552146dc6b9d53$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $4ad1daf29cda1856$var$NativeSelectSelect = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)($4ad1daf29cda1856$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $796b6cf2edfc05d3$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $1f552146dc6b9d53$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $4ad1daf29cda1856$export$7dd4d92f143902e3 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $1f552146dc6b9d53$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $4ad1daf29cda1856$var$NativeSelectIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)($4ad1daf29cda1856$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $4ad1daf29cda1856$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "disabled",
        "error",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $4ad1daf29cda1856$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4ad1daf29cda1856$var$NativeSelectSelect, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4ad1daf29cda1856$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $4ad1daf29cda1856$export$2e2bcd8739ae039 = $4ad1daf29cda1856$var$NativeSelectInput;











function $c2e0c2c0186a46b5$export$2c0c1ee5a3392e(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $c2e0c2c0186a46b5$var$selectClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'nativeInput',
    'error'
]);
var $c2e0c2c0186a46b5$export$2e2bcd8739ae039 = $c2e0c2c0186a46b5$var$selectClasses;


function $0d74bb70f3e6ea0d$export$2e2bcd8739ae039(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}

function $19ffb06d73e5072d$export$2e2bcd8739ae039(event) {
    if (!event) return null;
    if (event.type === 'mousedown' || event.type === 'pointerdown' || event.type === 'touchstart') return 'pointer';
    if (event.type === 'keydown' || event.type === 'click' && event.detail === 0) return 'keyboard';
    return null;
}

function $4d65cfa209396780$export$2e2bcd8739ae039(display) {
    return display == null || typeof display === 'string' && !display.trim();
}



var $7fPBF = parcelRequire("7fPBF");

function $3d8a150d3a35f0e0$var$hasOwnValueProp(child) {
    return Object.prototype.hasOwnProperty.call(child.props, 'value');
}
function $3d8a150d3a35f0e0$var$getTextFromReactNode(node) {
    if (typeof node === 'string' || typeof node === 'number') return String(node);
    let text = '';
    $7fPBF.Children.forEach(node, (child)=>{
        if (typeof child === 'string' || typeof child === 'number') text += String(child);
        else if (/*#__PURE__*/ $7fPBF.isValidElement(child)) text += $3d8a150d3a35f0e0$var$getTextFromReactNode(child.props.children);
    });
    return text;
}
function $3d8a150d3a35f0e0$export$c691ed146d18f505(options, search, startIndex = 0) {
    if (options.length === 0) return -1;
    const normalizedStartIndex = (startIndex % options.length + options.length) % options.length;
    for(let offset = 0; offset < options.length; offset += 1){
        const index = (normalizedStartIndex + offset) % options.length;
        if (options[index].label.startsWith(search)) return index;
    }
    return -1;
}
function $3d8a150d3a35f0e0$export$d4ed25fe51855a08(options, key) {
    return !options.some((option)=>option.label[0] === key && option.label[1] === key);
}
function $3d8a150d3a35f0e0$export$f6451f6fcdb20e00(childrenArray, value) {
    const options = [];
    let selectedIndex = -1;
    for(let index = 0; index < childrenArray.length; index += 1){
        const child = childrenArray[index];
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child) || !$3d8a150d3a35f0e0$var$hasOwnValueProp(child) || child.props.disabled) continue;
        // Closed typeahead cannot exclude CSS-hidden text because no option DOM is mounted.
        const label = $3d8a150d3a35f0e0$var$getTextFromReactNode(child.props.children).trim().toLowerCase();
        if (label === '') continue;
        if (selectedIndex === -1 && (0, $0d74bb70f3e6ea0d$export$2e2bcd8739ae039)(value, child.props.value)) selectedIndex = options.length;
        options.push({
            child: child,
            label: label,
            value: child.props.value
        });
    }
    return {
        options: options,
        selectedIndex: selectedIndex
    };
}




'use client';
var $223fe9025ce3be4c$var$_span;
const $223fe9025ce3be4c$var$OPENING_MOUSE_UP_BOUNDARY_OFFSET = 2;
// The initial mouseup may land on an item when the menu opens over the trigger.
const $223fe9025ce3be4c$var$SELECTED_MOUSE_UP_DELAY = 400;
const $223fe9025ce3be4c$var$UNSELECTED_MOUSE_UP_DELAY = 200;
const $223fe9025ce3be4c$var$TYPEAHEAD_RESET_MS = 750;
const $223fe9025ce3be4c$var$SPACE = ' ';
const $223fe9025ce3be4c$var$ARROW_UP = 'ArrowUp';
const $223fe9025ce3be4c$var$ARROW_DOWN = 'ArrowDown';
const $223fe9025ce3be4c$var$ENTER = 'Enter';
/**
 * Returns true when a native mouse event should be treated as happening inside
 * the element, even if a portal or backdrop retargeted the event away from it.
 *
 * Select uses this for the opening mouseup: when the menu opens over the
 * trigger, the release can target the backdrop or portaled menu even though the
 * pointer is still inside the trigger or menu bounds.
 */ function $223fe9025ce3be4c$var$isMouseEventInsideElement(event, element) {
    var _event_target;
    if (!element) return false;
    const eventPath = event.composedPath();
    if (eventPath.includes(element)) return true;
    if (((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.nodeType) && element.contains(event.target)) return true;
    const rect = element.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) // Hidden or transition-mounted elements do not have useful bounds to hit-test.
    return false;
    return event.clientX >= rect.left - $223fe9025ce3be4c$var$OPENING_MOUSE_UP_BOUNDARY_OFFSET && event.clientX <= rect.right + $223fe9025ce3be4c$var$OPENING_MOUSE_UP_BOUNDARY_OFFSET && event.clientY >= rect.top - $223fe9025ce3be4c$var$OPENING_MOUSE_UP_BOUNDARY_OFFSET && event.clientY <= rect.bottom + $223fe9025ce3be4c$var$OPENING_MOUSE_UP_BOUNDARY_OFFSET;
}
const $223fe9025ce3be4c$var$SelectSelect = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $4ad1daf29cda1856$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $c2e0c2c0186a46b5$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $c2e0c2c0186a46b5$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $c2e0c2c0186a46b5$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $c2e0c2c0186a46b5$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $c2e0c2c0186a46b5$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $223fe9025ce3be4c$var$SelectIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $4ad1daf29cda1856$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $223fe9025ce3be4c$var$SelectNativeInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $69b67c4b8d281c07$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
const $223fe9025ce3be4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $c2e0c2c0186a46b5$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $223fe9025ce3be4c$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var _MenuProps_slotProps, _MenuProps_slotProps1, _MenuProps_slotProps2, _MenuProps_slotProps3;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onKeyDown: // eslint-disable-next-line react/prop-types
    onKeyDown, onMouseDown: // eslint-disable-next-line react/prop-types
    onMouseDown, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        'aria-describedby',
        'aria-label',
        "autoFocus",
        "autoWidth",
        "children",
        "className",
        "defaultOpen",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "error",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onKeyDown",
        "onMouseDown",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "required",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    const [value, setValueState] = (0, $d2efeb5524b9e738$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $d2efeb5524b9e738$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const paperRef = $7fPBF.useRef(null);
    const openRef = $7fPBF.useRef(false);
    const hasSelectedItemInListRef = $7fPBF.useRef(false);
    const openingMouseUpListenerCleanupRef = $7fPBF.useRef(null);
    const didPointerDownOnItemRef = $7fPBF.useRef(false);
    const selectionRef = $7fPBF.useRef({
        allowSelectedMouseUp: false,
        allowUnselectedMouseUp: false
    });
    const closedTypeaheadRef = $7fPBF.useRef({
        buffer: '',
        previousSearchIndex: null,
        matchedIndex: null
    });
    const selectedMouseUpTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const unselectedMouseUpTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const typeaheadResetTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const [openInteractionType, setOpenInteractionType] = $7fPBF.useState(null);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode === null || displayNode === void 0 ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    const open = displayNode !== null && openState;
    const resetClosedTypeahead = $7fPBF.useCallback(()=>{
        typeaheadResetTimer.clear();
        closedTypeaheadRef.current.buffer = '';
        closedTypeaheadRef.current.previousSearchIndex = null;
        closedTypeaheadRef.current.matchedIndex = null;
    }, [
        typeaheadResetTimer
    ]);
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        openRef.current = open;
        if (open) resetClosedTypeahead();
    }, [
        open,
        resetClosedTypeahead
    ]);
    const clearSelectionTimers = $7fPBF.useCallback(()=>{
        selectedMouseUpTimer.clear();
        unselectedMouseUpTimer.clear();
    }, [
        selectedMouseUpTimer,
        unselectedMouseUpTimer
    ]);
    const resetMouseUpSelection = $7fPBF.useCallback(()=>{
        clearSelectionTimers();
        didPointerDownOnItemRef.current = false;
        selectionRef.current = {
            allowSelectedMouseUp: false,
            allowUnselectedMouseUp: false
        };
    }, [
        clearSelectionTimers
    ]);
    const clearOpeningMouseUpListener = $7fPBF.useCallback(()=>{
        if (openingMouseUpListenerCleanupRef.current) {
            openingMouseUpListenerCleanupRef.current();
            openingMouseUpListenerCleanupRef.current = null;
        }
    }, []);
    $7fPBF.useEffect(()=>{
        if (!open) {
            resetMouseUpSelection();
            clearOpeningMouseUpListener();
        }
    }, [
        open,
        resetMouseUpSelection,
        clearOpeningMouseUpListener
    ]);
    // Keep unmount cleanup separate from the `open` effect. Effect cleanups also run
    // before the next effect, which would clear the opening mouseup listener while opening.
    $7fPBF.useEffect(()=>{
        return ()=>{
            resetMouseUpSelection();
            clearOpeningMouseUpListener();
            resetClosedTypeahead();
        };
    }, [
        resetMouseUpSelection,
        clearOpeningMouseUpListener,
        resetClosedTypeahead
    ]);
    $7fPBF.useEffect(()=>{
        if (!open || !anchorElement || autoWidth) return undefined;
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            setMenuMinWidthState(anchorElement.clientWidth);
        });
        observer.observe(anchorElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        open,
        anchorElement,
        autoWidth
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((openParam, event)=>{
        if (!openParam) {
            resetMouseUpSelection();
            clearOpeningMouseUpListener();
        }
        if (openParam) {
            resetClosedTypeahead();
            setOpenInteractionType((0, $19ffb06d73e5072d$export$2e2bcd8739ae039)(event));
            if (onOpen) onOpen(event);
        } else {
            setOpenInteractionType(null);
            if (onClose) onClose(event);
        }
        if (!isOpenControlled) {
            openRef.current = openParam;
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(openParam);
        }
    });
    const scheduleMouseUpSelection = ()=>{
        resetMouseUpSelection();
        // When there is no selected item in the list, a mousedown
        // on the trigger followed by a quick mouseup over the first option can accidentally select
        // within 200ms. Delay unselected mouseup to match the safer 400ms window.
        if (!hasSelectedItemInListRef.current) selectedMouseUpTimer.start($223fe9025ce3be4c$var$SELECTED_MOUSE_UP_DELAY, ()=>{
            selectionRef.current.allowSelectedMouseUp = true;
            selectionRef.current.allowUnselectedMouseUp = true;
        });
        else // mousedown -> move to unselected item -> mouseup should not select within 200ms.
        unselectedMouseUpTimer.start($223fe9025ce3be4c$var$UNSELECTED_MOUSE_UP_DELAY, ()=>{
            selectionRef.current.allowUnselectedMouseUp = true;
            // mousedown -> mouseup on selected item should not select within 400ms.
            selectedMouseUpTimer.start($223fe9025ce3be4c$var$UNSELECTED_MOUSE_UP_DELAY, ()=>{
                selectionRef.current.allowSelectedMouseUp = true;
            });
        });
    };
    const handleMouseDown = (event)=>{
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        if (!displayRef.current) return;
        displayRef.current.focus();
        const doc = (0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(event.currentTarget);
        scheduleMouseUpSelection();
        clearOpeningMouseUpListener();
        const handleMouseUp = (mouseEvent)=>{
            openingMouseUpListenerCleanupRef.current = null;
            if (!displayRef.current) return;
            if ($223fe9025ce3be4c$var$isMouseEventInsideElement(mouseEvent, displayRef.current) || $223fe9025ce3be4c$var$isMouseEventInsideElement(mouseEvent, paperRef.current)) return;
            if (!openRef.current && isOpenControlled) return;
            update(false, mouseEvent);
        };
        doc.addEventListener('mouseup', handleMouseUp, {
            capture: true,
            once: true
        });
        openingMouseUpListenerCleanupRef.current = ()=>{
            doc.removeEventListener('mouseup', handleMouseUp, true);
        };
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleValueChange = (event, child, newValue)=>{
        setValueState(newValue);
        if (onChange) {
            // Redefine target to allow name and value to be read.
            // This allows seamless integration with the most popular form libraries.
            // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
            // Clone the event to not override `target` of the original event.
            const nativeEvent = event.nativeEvent || event;
            const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
            Object.defineProperty(clonedEvent, 'target', {
                writable: true,
                value: {
                    value: newValue,
                    name: name
                }
            });
            onChange(clonedEvent, child);
        }
    };
    const handleItemClick = (child)=>(event)=>{
            didPointerDownOnItemRef.current = false;
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) handleValueChange(event, child, newValue);
            if (!multiple) update(false, event);
        };
    const handleItemMouseUp = (child, selected)=>(event)=>{
            var _child_props_onMouseUp, _child_props;
            (_child_props_onMouseUp = (_child_props = child.props).onMouseUp) === null || _child_props_onMouseUp === void 0 ? void 0 : _child_props_onMouseUp.call(_child_props, event);
            if (didPointerDownOnItemRef.current) {
                didPointerDownOnItemRef.current = false;
                return;
            }
            const disallowSelectedMouseUp = !selectionRef.current.allowSelectedMouseUp && selected;
            const disallowUnselectedMouseUp = !selectionRef.current.allowUnselectedMouseUp && !selected;
            if (disallowSelectedMouseUp || disallowUnselectedMouseUp) return;
            event.currentTarget.click();
        };
    const handleClosedTypeahead = (event)=>{
        var _event_nativeEvent;
        const state = closedTypeaheadRef.current;
        const hasActiveBuffer = state.buffer !== '';
        if (open || multiple || disabled || event.defaultPrevented || ((_event_nativeEvent = event.nativeEvent) === null || _event_nativeEvent === void 0 ? void 0 : _event_nativeEvent.isComposing) || event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey || event.key === $223fe9025ce3be4c$var$SPACE && !hasActiveBuffer) return false;
        if (event.key === $223fe9025ce3be4c$var$SPACE) event.preventDefault();
        const isNewSession = state.buffer === '';
        const { options: searchableOptions, selectedIndex: selectedIndex } = (0, $3d8a150d3a35f0e0$export$f6451f6fcdb20e00)(childrenArray, value);
        if (searchableOptions.length === 0) {
            if (event.key !== $223fe9025ce3be4c$var$SPACE) resetClosedTypeahead();
            return true;
        }
        if (isNewSession) state.previousSearchIndex = selectedIndex;
        const key = event.key.toLowerCase();
        if (state.buffer === key && (0, $3d8a150d3a35f0e0$export$d4ed25fe51855a08)(searchableOptions, key)) {
            state.buffer = '';
            state.previousSearchIndex = state.matchedIndex;
        }
        state.buffer += key;
        typeaheadResetTimer.start($223fe9025ce3be4c$var$TYPEAHEAD_RESET_MS, resetClosedTypeahead);
        var _state_previousSearchIndex;
        const matchingIndex = (0, $3d8a150d3a35f0e0$export$c691ed146d18f505)(searchableOptions, state.buffer, ((_state_previousSearchIndex = state.previousSearchIndex) !== null && _state_previousSearchIndex !== void 0 ? _state_previousSearchIndex : -1) + 1);
        if (matchingIndex !== -1) {
            const matchedOption = searchableOptions[matchingIndex];
            state.matchedIndex = matchingIndex;
            if (!(0, $0d74bb70f3e6ea0d$export$2e2bcd8739ae039)(value, matchedOption.value)) handleValueChange(event, matchedOption.child, matchedOption.value);
            return true;
        }
        if (event.key !== $223fe9025ce3be4c$var$SPACE) resetClosedTypeahead();
        return true;
    };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const isClosedTypeaheadHandled = handleClosedTypeahead(event);
            // The native select doesn't respond to Enter on macOS, but it's recommended by
            // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
            const isOpenKey = event.key === $223fe9025ce3be4c$var$SPACE || event.key === $223fe9025ce3be4c$var$ARROW_UP || event.key === $223fe9025ce3be4c$var$ARROW_DOWN || event.key === $223fe9025ce3be4c$var$ENTER;
            if (!isClosedTypeaheadHandled && isOpenKey) {
                event.preventDefault();
                update(true, event);
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        }
    };
    const handleBlur = (event)=>{
        resetClosedTypeahead();
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    const handleItemKeyDown = (child)=>(event)=>{
            var _child_props_onKeyDown, _child_props;
            child === null || child === void 0 ? void 0 : (_child_props = child.props) === null || _child_props === void 0 ? void 0 : (_child_props_onKeyDown = _child_props.onKeyDown) === null || _child_props_onKeyDown === void 0 ? void 0 : _child_props_onKeyDown.call(_child_props, event);
            if (event.key === $223fe9025ce3be4c$var$SPACE && event.target === event.currentTarget && !event.defaultPrevented) {
                // Prevent the browser from scrolling the page
                event.preventDefault();
                // Ignore auto-repeated keydowns to avoid toggling multiple times
                if (!event.repeat) // Trigger via click so that onClick receives a click event,
                // consistent with Enter and pointer interactions.
                event.currentTarget.click();
            }
        };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $58bd733c82ee5006$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $a3749e0ba38a91a1$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>(0, $0d74bb70f3e6ea0d$export$2e2bcd8739ae039)(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = (0, $0d74bb70f3e6ea0d$export$2e2bcd8739ae039)(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onMouseDown: (event)=>{
                var _child_props_onMouseDown, _child_props;
                didPointerDownOnItemRef.current = true;
                (_child_props_onMouseDown = (_child_props = child.props).onMouseDown) === null || _child_props_onMouseDown === void 0 ? void 0 : _child_props_onMouseDown.call(_child_props, event);
            },
            onPointerDown: (event)=>{
                var _child_props_onPointerDown, _child_props;
                didPointerDownOnItemRef.current = true;
                (_child_props_onPointerDown = (_child_props = child.props).onPointerDown) === null || _child_props_onPointerDown === void 0 ? void 0 : _child_props_onPointerDown.call(_child_props, event);
            },
            onClick: handleItemClick(child),
            onMouseUp: handleItemMouseUp(child, selected),
            onKeyUp: (event)=>{
                if (event.key === $223fe9025ce3be4c$var$SPACE) // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            onKeyDown: handleItemKeyDown(child),
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    // Keep the opening mouseup guard current without mutating refs during render.
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        hasSelectedItemInListRef.current = foundMatch;
        if (!open && !multiple && !foundMatch) resetClosedTypeahead();
    }, [
        foundMatch,
        multiple,
        open,
        resetClosedTypeahead
    ]);
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $223fe9025ce3be4c$var$useUtilityClasses(ownerState);
    const menuPaperSlotProps = typeof ((_MenuProps_slotProps = MenuProps.slotProps) === null || _MenuProps_slotProps === void 0 ? void 0 : _MenuProps_slotProps.paper) === 'function' ? MenuProps.slotProps.paper(ownerState) : (_MenuProps_slotProps1 = MenuProps.slotProps) === null || _MenuProps_slotProps1 === void 0 ? void 0 : _MenuProps_slotProps1.paper;
    const handlePaperRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(menuPaperSlotProps === null || menuPaperSlotProps === void 0 ? void 0 : menuPaperSlotProps.ref, paperRef);
    const menuListSlotProps = typeof ((_MenuProps_slotProps2 = MenuProps.slotProps) === null || _MenuProps_slotProps2 === void 0 ? void 0 : _MenuProps_slotProps2.list) === 'function' ? MenuProps.slotProps.list(ownerState) : (_MenuProps_slotProps3 = MenuProps.slotProps) === null || _MenuProps_slotProps3 === void 0 ? void 0 : _MenuProps_slotProps3.list;
    const listboxId = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)();
    const nativeInputId = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)();
    var _other_id;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($223fe9025ce3be4c$var$SelectSelect, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-readonly": readOnly ? 'true' : undefined,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps), {
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: (0, $4d65cfa209396780$export$2e2bcd8739ae039)(display) ? $223fe9025ce3be4c$var$_span || ($223fe9025ce3be4c$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($223fe9025ce3be4c$var$SelectNativeInput, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                readOnly: readOnly,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required
            }, other), {
                id: (_other_id = other.id) !== null && _other_id !== void 0 ? _other_id : nativeInputId,
                ownerState: ownerState
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($223fe9025ce3be4c$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $079d434782d2fb16$export$4aa9473fca4c4988), {
                value: openInteractionType,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32855a33cbd5a576$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    id: `menu-${name || ''}`,
                    anchorEl: anchorElement,
                    open: open,
                    onClose: handleClose,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    }
                }, MenuProps), {
                    slotProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, MenuProps.slotProps), {
                        list: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            'aria-labelledby': labelId,
                            role: 'listbox',
                            'aria-multiselectable': multiple ? 'true' : undefined,
                            disableListWrap: true,
                            id: listboxId
                        }, menuListSlotProps),
                        paper: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, menuPaperSlotProps), {
                            ref: handlePaperRef,
                            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                                minWidth: menuMinWidth
                            }, menuPaperSlotProps === null || menuPaperSlotProps === void 0 ? void 0 : menuPaperSlotProps.style)
                        })
                    }),
                    children: items
                }))
            })
        ]
    });
});
var $223fe9025ce3be4c$export$2e2bcd8739ae039 = $223fe9025ce3be4c$var$SelectInput;






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");









function $349ec8af334f355f$export$c7c50641356bdfa5(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $349ec8af334f355f$var$svgIconClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $349ec8af334f355f$export$2e2bcd8739ae039 = $349ec8af334f355f$var$svgIconClasses;




'use client';
const $306340580a5f4f8d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $349ec8af334f355f$export$c7c50641356bdfa5), classes);
};
const $306340580a5f4f8d$var$SvgIconRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    var _transitions_duration, _transitions, _theme_typography_pxToRem, _theme_typography, _theme_typography_pxToRem1, _theme_typography1, _theme_typography_pxToRem2, _theme_typography2, _palette_action, _palette, _palette_action1, _palette1;
    var _theme_vars, _theme_vars1, _theme_vars2, _theme_vars3;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'fill', {
        duration: (_transitions = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).transitions) === null || _transitions === void 0 ? void 0 : (_transitions_duration = _transitions.duration) === null || _transitions_duration === void 0 ? void 0 : _transitions_duration.shorter
    })), {
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_pxToRem = _theme_typography.pxToRem) === null || _theme_typography_pxToRem === void 0 ? void 0 : _theme_typography_pxToRem.call(_theme_typography, 20)) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_pxToRem1 = _theme_typography1.pxToRem) === null || _theme_typography_pxToRem1 === void 0 ? void 0 : _theme_typography_pxToRem1.call(_theme_typography1, 24)) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_pxToRem2 = _theme_typography2.pxToRem) === null || _theme_typography_pxToRem2 === void 0 ? void 0 : _theme_typography_pxToRem2.call(_theme_typography2, 35)) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries(((_theme_vars1 = theme.vars) !== null && _theme_vars1 !== void 0 ? _theme_vars1 : theme).palette).filter(([, value])=>value && value.main).map(([color])=>{
                var _palette_color, _palette;
                var _theme_vars;
                return {
                    props: {
                        color: color
                    },
                    style: {
                        color: (_palette = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_color = _palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main
                    }
                };
            }),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (_palette = ((_theme_vars2 = theme.vars) !== null && _theme_vars2 !== void 0 ? _theme_vars2 : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_action = _palette.action) === null || _palette_action === void 0 ? void 0 : _palette_action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (_palette1 = ((_theme_vars3 = theme.vars) !== null && _theme_vars3 !== void 0 ? _theme_vars3 : theme).palette) === null || _palette1 === void 0 ? void 0 : (_palette_action1 = _palette1.action) === null || _palette_action1 === void 0 ? void 0 : _palette_action1.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    });
}));
const $306340580a5f4f8d$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "inheritViewBox",
        "titleAccess",
        "viewBox"
    ]);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $306340580a5f4f8d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($306340580a5f4f8d$var$SvgIconRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props), {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$306340580a5f4f8d$var$SvgIcon.muiName = 'SvgIcon';
var $306340580a5f4f8d$export$2e2bcd8739ae039 = $306340580a5f4f8d$var$SvgIcon;



'use client';
function $a8d4aa799c2c536a$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $306340580a5f4f8d$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            "data-testid": undefined,
            ref: ref
        }, props), {
            children: path
        }));
    }
    Component.muiName = (0, $306340580a5f4f8d$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}



'use client';
var $aa033ff66c15bb08$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');












'use client';
const $69621a0a62cf21c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $c2e0c2c0186a46b5$export$2c0c1ee5a3392e), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $69621a0a62cf21c5$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) && prop !== 'variant'
};
const $69621a0a62cf21c5$var$StyledInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6ebe290b69afc685$export$2e2bcd8739ae039), $69621a0a62cf21c5$var$styledRootConfig)('');
const $69621a0a62cf21c5$var$StyledOutlinedInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $1c1528b45b139d82$export$2e2bcd8739ae039), $69621a0a62cf21c5$var$styledRootConfig)('');
const $69621a0a62cf21c5$var$StyledFilledInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $ded456c71337d0a5$export$2e2bcd8739ae039), $69621a0a62cf21c5$var$styledRootConfig)('');
const $69621a0a62cf21c5$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $aa033ff66c15bb08$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultOpen",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    const inputComponent = native ? (0, $4ad1daf29cda1856$export$2e2bcd8739ae039) : (0, $223fe9025ce3be4c$export$2e2bcd8739ae039);
    const [fcs] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        variant: variant,
        classes: classesProp
    });
    const classes = $69621a0a62cf21c5$var$useUtilityClasses(ownerState);
    const { root: root } = classes, restOfClasses = (0, $8901fc92b5563702$export$71511d61b312f219)(classes, [
        "root"
    ]);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($69621a0a62cf21c5$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($69621a0a62cf21c5$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($69621a0a62cf21c5$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(ref, (0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps), {
                classes: inputProps ? (0, $9450f632817fee8b$export$2e2bcd8739ae039)(restOfClasses, inputProps.classes) : restOfClasses
            }), input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}), {
            ref: inputComponentRef,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root)
        }), !input && {
            variant: variant
        }, other))
    });
});
$69621a0a62cf21c5$var$Select.muiName = 'Select';
var $69621a0a62cf21c5$export$2e2bcd8739ae039 = $69621a0a62cf21c5$var$Select;




function $95eb75de86672e7a$export$c1bdcbaf0596aeda(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $95eb75de86672e7a$var$textFieldClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $95eb75de86672e7a$export$2e2bcd8739ae039 = $95eb75de86672e7a$var$textFieldClasses;




'use client';
const $3e90c645ab00aca9$var$variantComponent = {
    standard: (0, $6ebe290b69afc685$export$2e2bcd8739ae039),
    filled: (0, $ded456c71337d0a5$export$2e2bcd8739ae039),
    outlined: (0, $1c1528b45b139d82$export$2e2bcd8739ae039)
};
const $3e90c645ab00aca9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $95eb75de86672e7a$export$c1bdcbaf0596aeda), classes);
};
const $3e90c645ab00aca9$var$TextFieldRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const slotProps = {
 *   htmlInput: {
 *      step: 300
 *   }
 * };
 *
 * return <TextField id="time" type="time" slotProps={slotProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the `slotProps` prop for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $3e90c645ab00aca9$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "fullWidth",
        "helperText",
        "id",
        "inputRef",
        "label",
        "maxRows",
        "minRows",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "select",
        "slots",
        "slotProps",
        "type",
        "value",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $3e90c645ab00aca9$var$useUtilityClasses(ownerState);
    const id = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $3e90c645ab00aca9$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [SelectSlot, selectProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('select', {
        elementType: (0, $69621a0a62cf21c5$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const nativeSelect = select && selectProps.native;
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!nativeSelect) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        elementType: $3e90c645ab00aca9$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $0230b9d36bca11dc$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        }
    }, inputProps));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputLabelSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                htmlFor: select && !nativeSelect ? undefined : id,
                id: inputLabelId
            }, select && !nativeSelect && {
                component: 'div'
            }, inputLabelProps), {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SelectSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, selectProps), {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(FormHelperTextSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                id: helperTextId
            }, formHelperTextProps), {
                children: helperText
            }))
        ]
    }));
});
var $3e90c645ab00aca9$export$2e2bcd8739ae039 = $3e90c645ab00aca9$var$TextField;


let $62386b9deba6bf98$var$_ = (t)=>t, $62386b9deba6bf98$var$t;
const $62386b9deba6bf98$var$StyledTextField = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039))($62386b9deba6bf98$var$t || ($62386b9deba6bf98$var$t = $62386b9deba6bf98$var$_`
    input {
        &:focus {
            outline: none;
        }
    }
`));
var $62386b9deba6bf98$export$2e2bcd8739ae039 = $62386b9deba6bf98$var$StyledTextField;



function $40551a8a102d1426$var$TalkBackField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
            fullWidth: true,
            disabled: disabled,
            type: "text",
            value: value,
            label: t('common:talkback.title'),
            placeholder: t('common:talkback.question'),
            onChange: (e)=>onChange(e.target.value)
        })
    });
}
var $40551a8a102d1426$export$2e2bcd8739ae039 = $40551a8a102d1426$var$TalkBackField;







var $7fPBF = parcelRequire("7fPBF");












var $7fPBF = parcelRequire("7fPBF");














var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
function $768452f5eaf12684$export$2e2bcd8739ae039(parameters) {
    const { focusableWhenDisabled: focusableWhenDisabled, disabled: disabled, composite: composite = false, tabIndex: tabIndexProp = 0, isNativeButton: isNativeButton } = parameters;
    const isFocusableComposite = composite && focusableWhenDisabled !== false;
    const isNonFocusableComposite = composite && focusableWhenDisabled === false;
    // we can't explicitly assign `undefined` to any of these props because it
    // would otherwise prevent subsequently merged props from setting them
    const props = $7fPBF.useMemo(()=>{
        const additionalProps = {
            // allow Tabbing away from focusableWhenDisabled elements
            onKeyDown (event) {
                if (disabled && focusableWhenDisabled && event.key !== 'Tab') event.preventDefault();
            }
        };
        if (!composite) {
            additionalProps.tabIndex = tabIndexProp;
            if (!isNativeButton && disabled) additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
        }
        if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled) additionalProps['aria-disabled'] = disabled;
        if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) additionalProps.disabled = disabled;
        return additionalProps;
    }, [
        composite,
        disabled,
        focusableWhenDisabled,
        isFocusableComposite,
        isNonFocusableComposite,
        isNativeButton,
        tabIndexProp
    ]);
    return props;
}


'use client';
const $6591837fe39e2e8d$var$EMPTY = {};
function $6591837fe39e2e8d$export$2e2bcd8739ae039(parameters) {
    const { nativeButton: nativeButton, nativeButtonProp: nativeButtonProp, internalNativeButton: internalNativeButton = nativeButton, allowInferredHostMismatch: allowInferredHostMismatch = false, disabled: disabled, type: type, hasFormAction: hasFormAction = false, tabIndex: tabIndex = 0, focusableWhenDisabled: focusableWhenDisabledParam, stopEventPropagation: stopEventPropagation = false, onBeforeKeyDown: onBeforeKeyDown, onBeforeKeyUp: onBeforeKeyUp } = parameters;
    const rootRef = $7fPBF.useRef(null);
    const focusableWhenDisabled = focusableWhenDisabledParam === true;
    const focusableWhenDisabledProps = (0, $768452f5eaf12684$export$2e2bcd8739ae039)({
        focusableWhenDisabled: focusableWhenDisabled,
        disabled: disabled,
        isNativeButton: nativeButton,
        tabIndex: tabIndex
    });
    // A helper for event handlers to determine whether to use browser-defined keyboard activation
    // for native elements like <button> and <a href>, or synthesize Enter/Space clicks for non-native
    // elements like `<div role="button">`.
    // This is UNSAFE TO USE outside of event handers, e.g. in render.
    const hasNativeKeyboardActivation = $7fPBF.useCallback(()=>{
        const root = rootRef.current;
        if (root == null) return nativeButton;
        if (root.tagName === 'BUTTON') return true;
        // Although this hook is not intended for links, this check is for
        // backward compatibility with `<ButtonBase href="#" />` since ButtonBase
        // uses the returned event handlers.
        return Boolean(root.tagName === 'A' && root.href);
    }, [
        nativeButton
    ]);
    const buttonProps = $7fPBF.useMemo(()=>{
        const resolvedButtonProps = focusableWhenDisabled ? {} : {
            tabIndex: disabled ? -1 : tabIndex
        };
        if (nativeButton) {
            resolvedButtonProps.type = type === undefined && !hasFormAction ? 'button' : type;
            if (!focusableWhenDisabled) resolvedButtonProps.disabled = disabled;
        } else {
            resolvedButtonProps.role = 'button';
            if (!focusableWhenDisabled && disabled) resolvedButtonProps['aria-disabled'] = disabled;
        }
        if (focusableWhenDisabled) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, resolvedButtonProps, focusableWhenDisabledProps);
        return resolvedButtonProps;
    }, [
        disabled,
        focusableWhenDisabled,
        focusableWhenDisabledProps,
        hasFormAction,
        nativeButton,
        tabIndex,
        type
    ]);
    const getButtonProps = $7fPBF.useCallback((externalProps = $6591837fe39e2e8d$var$EMPTY)=>{
        const { onClick: externalOnClick, onKeyDown: externalOnKeyDown, onKeyUp: externalOnKeyUp } = externalProps, otherExternalProps = (0, $8901fc92b5563702$export$71511d61b312f219)(externalProps, [
            "onClick",
            "onKeyDown",
            "onKeyUp"
        ]);
        const handleClick = (event)=>{
            if (stopEventPropagation) event.stopPropagation();
            if (disabled) {
                event.preventDefault();
                return;
            }
            externalOnClick === null || externalOnClick === void 0 ? void 0 : externalOnClick(event);
        };
        const handleKeyDown = (event)=>{
            if (focusableWhenDisabled) focusableWhenDisabledProps.onKeyDown(event);
            if (disabled) return;
            onBeforeKeyDown === null || onBeforeKeyDown === void 0 ? void 0 : onBeforeKeyDown(event);
            externalOnKeyDown === null || externalOnKeyDown === void 0 ? void 0 : externalOnKeyDown(event);
            if (event.target !== event.currentTarget || hasNativeKeyboardActivation()) return;
            if (event.key === ' ') {
                event.preventDefault();
                return;
            }
            if (event.key === 'Enter') {
                event.preventDefault();
                event.currentTarget.click();
            }
        };
        const handleKeyUp = (event)=>{
            if (disabled) return;
            onBeforeKeyUp === null || onBeforeKeyUp === void 0 ? void 0 : onBeforeKeyUp(event);
            externalOnKeyUp === null || externalOnKeyUp === void 0 ? void 0 : externalOnKeyUp(event);
            if (event.target === event.currentTarget && !hasNativeKeyboardActivation() && event.key === ' ' && !event.defaultPrevented) event.currentTarget.click();
        };
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, buttonProps, otherExternalProps), {
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp
        });
    }, [
        buttonProps,
        disabled,
        focusableWhenDisabled,
        focusableWhenDisabledProps,
        hasNativeKeyboardActivation,
        onBeforeKeyDown,
        onBeforeKeyUp,
        stopEventPropagation
    ]);
    return {
        getButtonProps: getButtonProps,
        rootRef: rootRef
    };
}




var $7fPBF = parcelRequire("7fPBF");

'use client';
class $449b021b69a64c5b$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $449b021b69a64c5b$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $4a8eb4c5718f0b0a$export$2e2bcd8739ae039)($449b021b69a64c5b$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $7fPBF.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $7fPBF.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $449b021b69a64c5b$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    /* Ripple API */ start(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.start(...args);
        });
    }
    stop(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.stop(...args);
        });
    }
    pulsate(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.pulsate(...args);
        });
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "mountEffect", ()=>{
            if (this.shouldMount && !this.didMount) {
                if (this.ref.current !== null) {
                    this.didMount = true;
                    this.mounted.resolve();
                }
            }
        });
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
}
function $449b021b69a64c5b$export$2e2bcd8739ae039() {
    return $449b021b69a64c5b$export$f5de0641c7db4154.use();
}
function $449b021b69a64c5b$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}






var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");




'use client';
function $5c26981681b7631a$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const exitTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const exitTimerStartedRef = $7fPBF.useRef(false);
    const onExitedRef = $7fPBF.useRef(onExited);
    onExitedRef.current = onExited;
    const hasExitedCallback = onExited != null;
    const rippleClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && hasExitedCallback) {
            if (!exitTimerStartedRef.current) {
                exitTimerStartedRef.current = true;
                exitTimer.start(timeout, ()=>{
                    var _onExitedRef_current;
                    exitTimerStartedRef.current = false;
                    (_onExitedRef_current = onExitedRef.current) === null || _onExitedRef_current === void 0 ? void 0 : _onExitedRef_current.call(onExitedRef);
                });
            }
        } else {
            exitTimerStartedRef.current = false;
            exitTimer.clear();
        }
    }, [
        exitTimer,
        hasExitedCallback,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $5c26981681b7631a$export$2e2bcd8739ae039 = $5c26981681b7631a$var$Ripple;




function $85c9dc87a031c20c$export$b464606f735ab902(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $85c9dc87a031c20c$var$touchRippleClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $85c9dc87a031c20c$export$2e2bcd8739ae039 = $85c9dc87a031c20c$var$touchRippleClasses;





'use client';
let $5a367d525ebc1b55$var$_ = (t)=>t, $5a367d525ebc1b55$var$t, $5a367d525ebc1b55$var$t1, $5a367d525ebc1b55$var$t2, $5a367d525ebc1b55$var$t3, $5a367d525ebc1b55$var$t4, $5a367d525ebc1b55$var$t5;
const $5a367d525ebc1b55$var$DURATION = 550;
const $5a367d525ebc1b55$export$95d0c9356b2231a3 = 80;
const $5a367d525ebc1b55$var$EMPTY_OBJ = {};
const $5a367d525ebc1b55$var$EMPTY_ARRAY = [];
const $5a367d525ebc1b55$var$NOOP = ()=>{};
/**
 * Keep the same DOM order TouchRipple had when it used react-transition-group:
 * exiting ripples stay in place, and new ripples are inserted before the final
 * group of ripples that are waiting for their exit animation to finish.
 *
 * @param {number[]} prevOrder The previous DOM order, including ripples that may be exiting.
 * @param {number[]} nextActiveKeys The ripples that should still be treated as active.
 * @returns {number[]} The next DOM order, preserving the position of exiting ripples where possible.
 */ function $5a367d525ebc1b55$var$mergeRippleOrder(prevOrder, nextActiveKeys) {
    const nextKeySet = new Set(nextActiveKeys);
    const nextKeysPending = new Map();
    let pendingKeys = [];
    for (const prevKey of prevOrder){
        if (nextKeySet.has(prevKey)) {
            if (pendingKeys.length > 0) {
                nextKeysPending.set(prevKey, pendingKeys);
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const nextOrder = [];
    for (const nextKey of nextActiveKeys){
        const pendingBefore = nextKeysPending.get(nextKey);
        if (pendingBefore) nextOrder.push(...pendingBefore);
        nextOrder.push(nextKey);
    }
    nextOrder.push(...pendingKeys);
    return nextOrder;
}
/**
 * Calculate where the ripple should start and how large it must be to cover the host element.
 *
 * @param {object} params
 * @param {object} params.event The mouse or touch event that started the ripple.
 * @param {HTMLElement | null} params.element The host element used for measurements. Tests pass `null`.
 * @param {boolean} params.center If `true`, start the ripple from the center of the host element.
 * @returns {{ rippleX: number, rippleY: number, rippleSize: number }} The ripple position and size.
 */ function $5a367d525ebc1b55$var$computeRippleState({ event: event, element: element, center: center }) {
    const rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
    };
    let rippleX;
    let rippleY;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
    } else {
        const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
    }
    let rippleSize;
    if (center) {
        rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
        // Mobile Chrome can skip this animation for even pixel sizes.
        if (rippleSize % 2 === 0) rippleSize += 1;
    } else {
        const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    return {
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
    };
}
const $5a367d525ebc1b55$var$enterKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($5a367d525ebc1b55$var$t || ($5a367d525ebc1b55$var$t = $5a367d525ebc1b55$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $5a367d525ebc1b55$var$exitKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($5a367d525ebc1b55$var$t1 || ($5a367d525ebc1b55$var$t1 = $5a367d525ebc1b55$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $5a367d525ebc1b55$var$pulsateKeyframe = (0, $84f3fdd51733d70b$export$d25ddfdf17c3ad3e)($5a367d525ebc1b55$var$t2 || ($5a367d525ebc1b55$var$t2 = $5a367d525ebc1b55$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
function $5a367d525ebc1b55$var$getAnimationStyles(theme) {
    if (theme.motion.reducedMotion === 'always') return null;
    const styles = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($5a367d525ebc1b55$var$t3 || ($5a367d525ebc1b55$var$t3 = $5a367d525ebc1b55$var$_`
    &.${0} {
      animation-name: ${0};
      animation-duration: ${0}ms;
      animation-timing-function: ${0};
    }

    &.${0} {
      animation-duration: ${0}ms;
    }

    & .${0} {
      animation-name: ${0};
      animation-duration: ${0}ms;
      animation-timing-function: ${0};
    }

    & .${0} {
      animation-name: ${0};
      animation-duration: 2500ms;
      animation-timing-function: ${0};
      animation-iteration-count: infinite;
      animation-delay: 200ms;
    }
  `), (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).rippleVisible, $5a367d525ebc1b55$var$enterKeyframe, $5a367d525ebc1b55$var$DURATION, theme.transitions.easing.easeInOut, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).ripplePulsate, theme.transitions.duration.shorter, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).childLeaving, $5a367d525ebc1b55$var$exitKeyframe, $5a367d525ebc1b55$var$DURATION, theme.transitions.easing.easeInOut, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).childPulsate, $5a367d525ebc1b55$var$pulsateKeyframe, theme.transitions.easing.easeInOut);
    if (theme.motion.reducedMotion === 'system') return (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($5a367d525ebc1b55$var$t4 || ($5a367d525ebc1b55$var$t4 = $5a367d525ebc1b55$var$_`
      @media (prefers-reduced-motion: no-preference) {
        ${0}
      }
    `), styles);
    return styles;
}
const $5a367d525ebc1b55$export$f6b7418508c72c25 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $5a367d525ebc1b55$export$676cfe7b12693c4b = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $5c26981681b7631a$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($5a367d525ebc1b55$var$t5 || ($5a367d525ebc1b55$var$t5 = $5a367d525ebc1b55$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
  }

  /*
   * Order matters: 'child', 'childLeaving' and 'childPulsate' apply to the same
   * element with equal specificity, so the later rule wins. 'child' must come
   * before 'childLeaving' so the leaving 'opacity: 0' takes precedence. A focus
   * (pulsate) ripple keeps 'pulsateKeyframe' (no opacity animation) on exit, so
   * it relies on this static 'opacity: 0' to disappear on blur instead of
   * lingering until removal.
   */
  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
  }

  ${0}
`), (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).rippleVisible, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).child, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).childLeaving, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).childPulsate, ({ theme: theme })=>$5a367d525ebc1b55$var$getAnimationStyles(theme));
/**
 * @ignore - internal component.
 */ const $5a367d525ebc1b55$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const reducedMotion = (0, $1fb9020c3655f750$export$2e2bcd8739ae039)(theme.motion.reducedMotion, false);
    const { center: centerProp = false, classes: classes = $5a367d525ebc1b55$var$EMPTY_OBJ, className: className } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "center",
        "classes",
        "className"
    ]);
    // Store ripples as data so we can keep exiting ripples mounted until their
    // exit animation ends. Ripple calls onExited when it is safe to remove one.
    const [rippleState, setRippleState] = $7fPBF.useState({
        items: $5a367d525ebc1b55$var$EMPTY_ARRAY,
        order: $5a367d525ebc1b55$var$EMPTY_ARRAY
    });
    const ripples = rippleState.items;
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    const mountedRef = $7fPBF.useRef(false);
    (0, $f41e23dcede3198a$export$2e2bcd8739ae039)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    });
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    // Holds delayed touch-start work until the delay expires or touchend forces it to run.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const handleExited = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((key)=>{
        if (!mountedRef.current) return;
        setRippleState((prevState)=>{
            const nextItems = prevState.items.filter((ripple)=>ripple.key !== key);
            const nextOrder = $5a367d525ebc1b55$var$mergeRippleOrder(prevState.order.filter((rippleKey)=>rippleKey !== key), nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key));
            return {
                items: nextItems,
                order: nextOrder
            };
        });
    });
    const startCommit = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        const key = nextKey.current;
        nextKey.current += 1;
        setRippleState((prevState)=>{
            const nextItems = [
                ...prevState.items,
                {
                    key: key,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize,
                    exiting: false
                }
            ];
            return {
                items: nextItems,
                order: $5a367d525ebc1b55$var$mergeRippleOrder(prevState.order, nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key))
            };
        });
        rippleCallback.current = cb;
    });
    const start = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event = $5a367d525ebc1b55$var$EMPTY_OBJ, options = $5a367d525ebc1b55$var$EMPTY_OBJ, cb = $5a367d525ebc1b55$var$NOOP)=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // Used only by tests.
         } = options;
        if ((event === null || event === void 0 ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event === null || event === void 0 ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const { rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize } = $5a367d525ebc1b55$var$computeRippleState({
            event: event,
            element: element,
            center: center
        });
        // Delay touch ripples so scroll gestures do not flash a ripple.
        if (event === null || event === void 0 ? void 0 : event.touches) // Ignore extra touchstart events from multi-touch. There is only one
        // delayed start callback to clear on unmount.
        {
            if (startTimerCommit.current === null) {
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                startTimer.start($5a367d525ebc1b55$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    });
    const pulsate = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)(()=>{
        start($5a367d525ebc1b55$var$EMPTY_OBJ, {
            pulsate: true
        });
    });
    const stop = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event, cb)=>{
        startTimer.clear();
        // If touch ends before the delay finishes, show the ripple now and stop it
        // on the next tick so the user still gets feedback.
        if ((event === null || event === void 0 ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRippleState((prevState)=>{
            const firstActiveIndex = prevState.items.findIndex((ripple)=>!ripple.exiting);
            if (firstActiveIndex === -1) return prevState;
            const nextItems = prevState.items.slice();
            nextItems[firstActiveIndex] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nextItems[firstActiveIndex]), {
                exiting: true
            });
            return {
                items: nextItems,
                order: $5a367d525ebc1b55$var$mergeRippleOrder(prevState.order, nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key))
            };
        });
        rippleCallback.current = cb;
    });
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    const rippleByKey = new Map(ripples.map((ripple)=>[
            ripple.key,
            ripple
        ]));
    const orderedRipples = rippleState.order.map((rippleKey)=>rippleByKey.get(rippleKey)).filter(Boolean);
    // Keep the old react-transition-group DOM order:
    // exiting ripples stay in place, and new ripples are inserted before the
    // final group waiting for its exit animation to finish.
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a367d525ebc1b55$export$f6b7418508c72c25, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)((0, $85c9dc87a031c20c$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other), {
        children: orderedRipples.map((ripple)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a367d525ebc1b55$export$676cfe7b12693c4b, {
                classes: {
                    ripple: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripple, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).ripple),
                    rippleVisible: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).rippleVisible),
                    ripplePulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).ripplePulsate),
                    child: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).child),
                    childLeaving: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childLeaving, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).childLeaving),
                    childPulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childPulsate, (0, $85c9dc87a031c20c$export$2e2bcd8739ae039).childPulsate)
                },
                timeout: reducedMotion.shouldReduceMotion ? 0 : $5a367d525ebc1b55$var$DURATION,
                pulsate: ripple.pulsate,
                rippleX: ripple.rippleX,
                rippleY: ripple.rippleY,
                rippleSize: ripple.rippleSize,
                in: !ripple.exiting,
                onExited: ()=>handleExited(ripple.key)
            }, ripple.key))
    }));
});
var $5a367d525ebc1b55$export$2e2bcd8739ae039 = $5a367d525ebc1b55$var$TouchRipple;




function $836ef505e0e79e8b$export$fccb0498dcd99783(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $836ef505e0e79e8b$var$buttonBaseClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $836ef505e0e79e8b$export$2e2bcd8739ae039 = $836ef505e0e79e8b$var$buttonBaseClasses;



'use client';
const $a3a679d546941285$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, suppressFocusVisible: suppressFocusVisible, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && !suppressFocusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $836ef505e0e79e8b$export$fccb0498dcd99783), classes);
    if (focusVisible && !suppressFocusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $a3a679d546941285$export$7ec0dcc5e3cdcd36 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $836ef505e0e79e8b$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $a3a679d546941285$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, focusableWhenDisabled: /* eslint-disable react/prop-types */ // replaces internal handling in Chip, other components can opt-in individually to use this in the future
    focusableWhenDisabled, suppressFocusVisible: // escape hatch to suppress the focusVisible state and callback
    // used by anchored <Menu>s to to suppress focus visible styling when opened with a pointer
    suppressFocusVisible = false, // private prop to allow native vs non-native button props to be resolved before mount
    internalNativeButton: internalNativeButtonProp, LinkComponent: /* eslint-enable react/prop-types */ LinkComponent = 'a', nativeButton: nativeButtonProp, onBlur: onBlur, onClick: onClickProp, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDownProp, onKeyUp: onKeyUpProp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "action",
        "centerRipple",
        "children",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "focusableWhenDisabled",
        "suppressFocusVisible",
        "internalNativeButton",
        "LinkComponent",
        "nativeButton",
        "onBlur",
        "onClick",
        "onContextMenu",
        "onDragLeave",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "tabIndex",
        "TouchRippleProps",
        "touchRippleRef",
        "type"
    ]);
    const isLink = Boolean(other.href || other.to);
    const hasFormAction = Boolean(other.formAction);
    let ComponentProp = component;
    if (ComponentProp === 'button' && isLink) ComponentProp = LinkComponent;
    const internalNativeButton = typeof ComponentProp === 'string' ? ComponentProp === 'button' : internalNativeButtonProp !== null && internalNativeButtonProp !== void 0 ? internalNativeButtonProp : false;
    const nativeButton = nativeButtonProp !== null && nativeButtonProp !== void 0 ? nativeButtonProp : internalNativeButton;
    const ripple = (0, $449b021b69a64c5b$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if ((disabled || suppressFocusVisible) && focusVisible) setFocusVisible(false);
    const handleBeforeKeyDown = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
    });
    const handleBeforeKeyUp = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
    });
    const { getButtonProps: getButtonProps, rootRef: buttonRef } = (0, $6591837fe39e2e8d$export$2e2bcd8739ae039)({
        nativeButton: nativeButton,
        nativeButtonProp: nativeButtonProp,
        internalNativeButton: internalNativeButton,
        allowInferredHostMismatch: isLink || typeof ComponentProp === 'string',
        disabled: disabled,
        type: type,
        hasFormAction: hasFormAction,
        tabIndex: tabIndex,
        onBeforeKeyDown: handleBeforeKeyDown,
        onBeforeKeyUp: handleBeforeKeyUp
    });
    const _getButtonProps = getButtonProps({
        onClick: onClickProp,
        onKeyDown: onKeyDownProp,
        onKeyUp: onKeyUpProp
    }), { onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp } = _getButtonProps, buttonProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_getButtonProps, [
        "onClick",
        "onKeyDown",
        "onKeyUp"
    ]);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), [
        buttonRef
    ]);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $a3a679d546941285$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $a3a679d546941285$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $a3a679d546941285$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/react/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (!suppressFocusVisible && (0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const linkProps = {};
    if (isLink) {
        linkProps.tabIndex = disabled ? -1 : tabIndex;
        if (disabled) linkProps['aria-disabled'] = disabled;
        linkProps.type = type;
    }
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        suppressFocusVisible: suppressFocusVisible,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $a3a679d546941285$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a3a679d546941285$export$7ec0dcc5e3cdcd36, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: ComponentProp,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef
    }, isLink ? linkProps : buttonProps, other), {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a367d525ebc1b55$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
function $a3a679d546941285$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $a3a679d546941285$export$2e2bcd8739ae039 = $a3a679d546941285$var$ButtonBase;









function $2ce3a65194a0babc$export$46f01d01378ec5a2(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $2ce3a65194a0babc$var$dividerClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'vertical',
    'withChildren',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $2ce3a65194a0babc$export$2e2bcd8739ae039 = $2ce3a65194a0babc$var$dividerClasses;




function $34b66a05af668b52$export$81478e24460c57f2(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $34b66a05af668b52$var$listItemIconClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $34b66a05af668b52$export$2e2bcd8739ae039 = $34b66a05af668b52$var$listItemIconClasses;




function $8c4009b72c82a55b$export$1061006a0db3aeb5(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $8c4009b72c82a55b$var$listItemTextClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $8c4009b72c82a55b$export$2e2bcd8739ae039 = $8c4009b72c82a55b$var$listItemTextClasses;






function $c8af481c7ead0c1f$export$515f8c67b5305377(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $c8af481c7ead0c1f$var$menuItemClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $c8af481c7ead0c1f$export$2e2bcd8739ae039 = $c8af481c7ead0c1f$var$menuItemClasses;



'use client';
const $ce4664bb90d2045a$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $ce4664bb90d2045a$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $c8af481c7ead0c1f$export$515f8c67b5305377), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $ce4664bb90d2045a$var$MenuItemRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $ce4664bb90d2045a$export$4334bb34c76fef24
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.body1), {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $c8af481c7ead0c1f$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $c8af481c7ead0c1f$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $c8af481c7ead0c1f$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $c8af481c7ead0c1f$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $c8af481c7ead0c1f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $2ce3a65194a0babc$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $2ce3a65194a0babc$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $8c4009b72c82a55b$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $8c4009b72c82a55b$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $34b66a05af668b52$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4
                }, theme.typography.body2), {
                    [`& .${(0, $34b66a05af668b52$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                })
            }
        ]
    })));
const $ce4664bb90d2045a$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: shouldAutoFocusOnMount = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "autoFocus",
        "component",
        "dense",
        "divider",
        "disableGutters",
        "focusVisibleClassName",
        "role",
        "tabIndex",
        "className"
    ]);
    const focusSource = (0, $079d434782d2fb16$export$990808021214d5e)();
    const context = $7fPBF.useContext((0, $060e19b7623095b4$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuListContext = (0, $fa21ae2d9022b983$export$f3a2a1dcca60a23)();
    const rovingItemId = (0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)();
    // Escape hatch via ButtonBase for when an anchored <Menu> is opened with a pointer
    // interaction on a trigger, the item should receive DOM focus but without focus visible
    // styling. Current API does not allow a reliable `openInteractionType` for anchored menus.
    const suppressFocusVisible = menuListContext.suppressInitialFocusVisible;
    const itemsFocusableWhenDisabled = menuListContext.itemsFocusableWhenDisabled;
    const menuItemRef = $7fPBF.useRef(null);
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        if (shouldAutoFocusOnMount) {
            if (menuItemRef.current) (0, $e500432f0027efe7$export$2e2bcd8739ae039)(menuItemRef.current, focusSource);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldAutoFocusOnMount
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $ce4664bb90d2045a$var$useUtilityClasses(props);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root } = classes, forwardedClasses = (0, $8901fc92b5563702$export$71511d61b312f219)(classes, [
        "root"
    ]);
    const rovingItemProps = (0, $bc3efb6b12d4ce5b$export$736d50a885584c2d)({
        id: rovingItemId,
        ref: ref,
        disabled: props.disabled,
        focusableWhenDisabled: itemsFocusableWhenDisabled,
        selected: props.selected
    });
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(menuItemRef, rovingItemProps.ref);
    let tabIndex;
    if (tabIndexProp !== undefined) tabIndex = tabIndexProp;
    else if (menuListContext.variant === 'selectedMenu') tabIndex = rovingItemProps.tabIndex;
    else if (!props.disabled || itemsFocusableWhenDisabled) // In `menu` variant, registration still drives arrow-key navigation even
    // though each item keeps `tabIndex={-1}`.
    tabIndex = -1;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $060e19b7623095b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ce4664bb90d2045a$var$MenuItemRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            internalNativeButton: false,
            focusableWhenDisabled: itemsFocusableWhenDisabled,
            suppressFocusVisible: suppressFocusVisible,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other), {
            ownerState: ownerState,
            classes: forwardedClasses
        }))
    });
});
var $ce4664bb90d2045a$export$2e2bcd8739ae039 = $ce4664bb90d2045a$var$MenuItem;





function $b1109042f38aaa6d$var$ExpressionControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                id: fieldId,
                children: t('common:expression.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                disabled: disabled,
                labelId: fieldId,
                value: value,
                label: t('common:expression.label'),
                onChange: (e)=>onChange(e.target.value),
                children: (0, $f44f3a5bc46b1c4c$export$c64c937c3a3522ea).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: t(c.title)
                    }, c.value))
            })
        ]
    });
}
var $b1109042f38aaa6d$export$2e2bcd8739ae039 = $b1109042f38aaa6d$var$ExpressionControlField;







function $c32407a418a9484e$var$ExternalKeyControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                id: fieldId,
                children: t('common:keys.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                disabled: disabled,
                labelId: fieldId,
                value: value,
                label: t('common:keys.label'),
                onChange: (e)=>onChange(e.target.value),
                children: (0, $f44f3a5bc46b1c4c$export$71d467a5c4a5cf9f).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: c.translationKey ? t(c.translationKey) : c.title
                    }, c.value))
            })
        ]
    });
}
var $c32407a418a9484e$export$2e2bcd8739ae039 = $c32407a418a9484e$var$ExternalKeyControlField;







function $c0e1046edce6d946$var$HeadControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                id: fieldId,
                children: t('common:head.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                labelId: 'head',
                value: value,
                label: t('common:head.label'),
                onChange: (e)=>onChange(e.target.value),
                disabled: disabled,
                children: (0, $f44f3a5bc46b1c4c$export$b47f0ea920cae9ed).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: t(c.title)
                    }, c.value))
            })
        ]
    });
}
var $c0e1046edce6d946$export$2e2bcd8739ae039 = $c0e1046edce6d946$var$HeadControlField;








function $5f22d2958842cad1$var$HotkeyControlField(_param) {
    var { value: value, onChange: onChange, disabled: disabled } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "value",
        "onChange",
        "disabled"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    value = value.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '');
    const handleChange = (value)=>{
        value = value.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '');
        onChange('hotkey_' + value);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        fullWidth: true,
        disabled: disabled,
        type: "text",
        value: value,
        label: t('common:hotkey.label'),
        placeholder: t('common:hotkey.placeholder'),
        onChange: (e)=>handleChange(e.target.value)
    }, restProps));
}
var $5f22d2958842cad1$export$2e2bcd8739ae039 = $5f22d2958842cad1$var$HotkeyControlField;





function $3f5241a464a7fe52$var$OtherControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        fullWidth: true,
        disabled: disabled,
        type: "text",
        value: value,
        label: t('common:other.label'),
        placeholder: t('common:other.placeholder'),
        onChange: (e)=>onChange(e.target.value)
    });
}
var $3f5241a464a7fe52$export$2e2bcd8739ae039 = $3f5241a464a7fe52$var$OtherControlField;







function $573d96641b0a52c8$var$TiltControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    disabled = true;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                id: fieldId,
                children: [
                    t('common:motion.title'),
                    " - ",
                    t('common:deprecated')
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                disabled: disabled,
                labelId: fieldId,
                value: value,
                label: t('common:motion.title'),
                onChange: (e)=>onChange(e.target.value),
                children: (0, $f44f3a5bc46b1c4c$export$6ed006bdf26d1b97).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                        value: c.value,
                        children: t(c.title)
                    }, c.value))
            })
        ]
    });
}
var $573d96641b0a52c8$export$2e2bcd8739ae039 = $573d96641b0a52c8$var$TiltControlField;





function $2ed5e210cedb5cf5$var$VoiceControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        disabled: disabled,
        fullWidth: true,
        value: value,
        label: t('common:voice.title'),
        placeholder: t('common:voice.placeholder'),
        onChange: (e)=>onChange(e.target.value)
    });
}
var $2ed5e210cedb5cf5$export$2e2bcd8739ae039 = $2ed5e210cedb5cf5$var$VoiceControlField;


const $00051b104a6506d5$var$controlTypeRenderMap = {
    expression: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1109042f38aaa6d$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    externalKeyboard: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c32407a418a9484e$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    head: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0e1046edce6d946$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    motion: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $573d96641b0a52c8$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    spoken: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40551a8a102d1426$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    tilt: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $573d96641b0a52c8$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    hotkey: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5f22d2958842cad1$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    voice: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2ed5e210cedb5cf5$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)),
    other: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f5241a464a7fe52$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props))
};
function $00051b104a6506d5$export$43ee9de14381bd97(_param) {
    var { control: control, value: value, onChange: onChange, disabled: disabled } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "control",
        "value",
        "onChange",
        "disabled"
    ]);
    const controlTypeComponent = $00051b104a6506d5$var$controlTypeRenderMap[control];
    if (controlTypeComponent) {
        const controlProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            value: value,
            onChange: onChange,
            disabled: disabled
        }, restProps);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
            children: controlTypeComponent(controlProps)
        });
    }
    return null;
}










var $7fPBF = parcelRequire("7fPBF");












function $b8e72ce5997f9ccc$export$69aecd24bc2cf7e3(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiAlert', slot);
}
const $b8e72ce5997f9ccc$var$alertClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'outlined',
    'standard'
]);
var $b8e72ce5997f9ccc$export$2e2bcd8739ae039 = $b8e72ce5997f9ccc$var$alertClasses;






var $7fPBF = parcelRequire("7fPBF");














function $8b7df60dc94a8d55$export$5e8702d71474f093(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $8b7df60dc94a8d55$var$iconButtonClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $8b7df60dc94a8d55$export$2e2bcd8739ae039 = $8b7df60dc94a8d55$var$iconButtonClasses;




'use client';
const $6767d63d9006cc81$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8b7df60dc94a8d55$export$5e8702d71474f093), classes);
};
const $6767d63d9006cc81$var$IconButtonRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'background-color', {
        duration: theme.transitions.duration.shortest
    })), {
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $8b7df60dc94a8d55$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $8b7df60dc94a8d55$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $6767d63d9006cc81$var$IconButtonLoadingIndicator = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $6767d63d9006cc81$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "edge",
        "children",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size",
        "id",
        "loading",
        "loadingIndicator"
    ]);
    const loadingId = (0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp !== null && loadingIndicatorProp !== void 0 ? loadingIndicatorProp : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5310a643ead17d95$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    });
    const classes = $6767d63d9006cc81$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6767d63d9006cc81$var$IconButtonRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: loading ? loadingId : idProp,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        internalNativeButton: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref
    }, other), {
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $824c049f32d4395d$exports.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6767d63d9006cc81$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    }));
});
var $6767d63d9006cc81$export$2e2bcd8739ae039 = $6767d63d9006cc81$var$IconButton;




'use client';
var $2bcfe137620bb1dc$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');




'use client';
var $22b6c99416c07b62$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');




'use client';
var $02b641ccff6c7e66$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');




'use client';
var $03f84b7e0106ca1c$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');




'use client';
var $6d7a2ea81d8b74c9$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



'use client';
const $0e94917eb8d34aa5$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $b8e72ce5997f9ccc$export$69aecd24bc2cf7e3), classes);
};
const $0e94917eb8d34aa5$var$AlertRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.body2), {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $b8e72ce5997f9ccc$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $b8e72ce5997f9ccc$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
}));
const $0e94917eb8d34aa5$var$AlertIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $0e94917eb8d34aa5$var$AlertMessage = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $0e94917eb8d34aa5$var$AlertAction = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $0e94917eb8d34aa5$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2bcfe137620bb1dc$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22b6c99416c07b62$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $02b641ccff6c7e66$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $03f84b7e0106ca1c$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $0e94917eb8d34aa5$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef(function Alert(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, icon: icon, iconMapping: iconMapping = $0e94917eb8d34aa5$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "action",
        "children",
        "className",
        "closeText",
        "color",
        "icon",
        "iconMapping",
        "onClose",
        "role",
        "severity",
        "slotProps",
        "slots",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $0e94917eb8d34aa5$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $0e94917eb8d34aa5$var$AlertRoot,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('icon', {
        className: classes.icon,
        elementType: $0e94917eb8d34aa5$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('message', {
        className: classes.message,
        elementType: $0e94917eb8d34aa5$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $0e94917eb8d34aa5$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $6767d63d9006cc81$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $6d7a2ea81d8b74c9$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(IconSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, iconSlotProps), {
                children: icon || iconMapping[severity] || $0e94917eb8d34aa5$var$defaultIconMapping[severity]
            })) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MessageSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, messageSlotProps), {
                children: children
            })),
            action != null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, actionSlotProps), {
                children: action
            })) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, actionSlotProps), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CloseButtonSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CloseIconSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            })) : null
        ]
    }));
});
var $0e94917eb8d34aa5$export$2e2bcd8739ae039 = $0e94917eb8d34aa5$var$Alert;





var $7fPBF = parcelRequire("7fPBF");









function $9872eea79e46a9e6$export$f3b76d2cce458caa(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiCard', slot);
}
const $9872eea79e46a9e6$var$cardClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiCard', [
    'root'
]);
var $9872eea79e46a9e6$export$2e2bcd8739ae039 = $9872eea79e46a9e6$var$cardClasses;



'use client';
const $c25995eea3cd5a6e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $9872eea79e46a9e6$export$f3b76d2cce458caa), classes);
};
const $c25995eea3cd5a6e$var$CardRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root'
})({
    overflow: 'hidden'
});
const $c25995eea3cd5a6e$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "raised"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        raised: raised
    });
    const classes = $c25995eea3cd5a6e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c25995eea3cd5a6e$var$CardRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $c25995eea3cd5a6e$export$2e2bcd8739ae039 = $c25995eea3cd5a6e$var$Card;





var $7fPBF = parcelRequire("7fPBF");












function $f24784cbe4c76c85$export$717666c39ec07e12(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $f24784cbe4c76c85$var$formControlLabelClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $f24784cbe4c76c85$export$2e2bcd8739ae039 = $f24784cbe4c76c85$var$formControlLabelClasses;




'use client';
const $302bb1ec2a19f6b0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $f24784cbe4c76c85$export$717666c39ec07e12), classes);
};
const $302bb1ec2a19f6b0$export$1b479270917a5676 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f24784cbe4c76c85$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $f24784cbe4c76c85$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $f24784cbe4c76c85$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $f24784cbe4c76c85$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $302bb1ec2a19f6b0$var$AsteriskComponent = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $f24784cbe4c76c85$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $302bb1ec2a19f6b0$var$FormControlLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "checked",
        "className",
        "control",
        "disabled",
        "disableTypography",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "required",
        "slots",
        "slotProps",
        "value"
    ]);
    const [fcs, muiFormControl] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'error'
        ]
    });
    var _ref;
    const disabled = (_ref = disabledProp !== null && disabledProp !== void 0 ? disabledProp : control.props.disabled) !== null && _ref !== void 0 ? _ref : muiFormControl === null || muiFormControl === void 0 ? void 0 : muiFormControl.disabled;
    const required = requiredProp !== null && requiredProp !== void 0 ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $302bb1ec2a19f6b0$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [TypographySlot, typographySlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $f577398c4e8dc99c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $f577398c4e8dc99c$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TypographySlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        component: "span"
    }, typographySlotProps), {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.label, typographySlotProps === null || typographySlotProps === void 0 ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($302bb1ec2a19f6b0$export$1b479270917a5676, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other), {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($302bb1ec2a19f6b0$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $302bb1ec2a19f6b0$export$2e2bcd8739ae039 = $302bb1ec2a19f6b0$var$FormControlLabel;





var $7fPBF = parcelRequire("7fPBF");







function $615febe253653921$export$d72d4cbdc30b331f(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiFormGroup', slot);
}
const $615febe253653921$var$formGroupClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $615febe253653921$export$2e2bcd8739ae039 = $615febe253653921$var$formGroupClasses;




'use client';
const $ea5892afc276c974$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $615febe253653921$export$d72d4cbdc30b331f), classes);
};
const $ea5892afc276c974$var$FormGroupRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $ea5892afc276c974$var$FormGroup = /*#__PURE__*/ $7fPBF.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "row"
    ]);
    const [fcs] = (0, $7c05b6d5a150dbd8$export$a733b6eeb54fd614)({
        props: props,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        row: row,
        error: fcs.error
    });
    const classes = $ea5892afc276c974$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ea5892afc276c974$var$FormGroupRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $ea5892afc276c974$export$2e2bcd8739ae039 = $ea5892afc276c974$var$FormGroup;





var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");










function $67234a0116662ecd$export$baa0faa0c7ad8085(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $67234a0116662ecd$var$switchBaseClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $67234a0116662ecd$export$2e2bcd8739ae039 = $67234a0116662ecd$var$switchBaseClasses;




'use client';
const $ee7fbb23030d5fe3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $67234a0116662ecd$export$baa0faa0c7ad8085), classes);
};
const $ee7fbb23030d5fe3$var$SwitchBaseRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $ee7fbb23030d5fe3$var$SwitchBaseInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $ee7fbb23030d5fe3$var$SwitchBase = /*#__PURE__*/ $7fPBF.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "defaultChecked",
        "disabled",
        "disableFocusRipple",
        "edge",
        "icon",
        "id",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value",
        "slots",
        "slotProps"
    ]);
    const { nativeButton: nativeButton } = other, buttonBaseProps = (0, $8901fc92b5563702$export$71511d61b312f219)(other, [
        "nativeButton"
    ]);
    const [checked, setCheckedState] = (0, $d2efeb5524b9e738$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $7c05b6d5a150dbd8$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/react/react/issues/9023
        if (event.nativeEvent.defaultPrevented || readOnly) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $ee7fbb23030d5fe3$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $ee7fbb23030d5fe3$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps), {
            component: 'span'
        }), buttonBaseProps),
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onFocus: (event)=>{
                    var _handlers_onFocus;
                    (_handlers_onFocus = handlers.onFocus) === null || _handlers_onFocus === void 0 ? void 0 : _handlers_onFocus.call(handlers, event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    var _handlers_onBlur;
                    (_handlers_onBlur = handlers.onBlur) === null || _handlers_onBlur === void 0 ? void 0 : _handlers_onBlur.call(handlers, event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('input', {
        elementType: $ee7fbb23030d5fe3$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onChange: (event)=>{
                    var _handlers_onChange;
                    (_handlers_onChange = handlers.onChange) === null || _handlers_onChange === void 0 ? void 0 : _handlers_onChange.call(handlers, event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type
        }, type === 'checkbox' && value === undefined ? {} : {
            value: value
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, inputSlotProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $ee7fbb23030d5fe3$export$2e2bcd8739ae039 = $ee7fbb23030d5fe3$var$SwitchBase;







'use client';
var $4413534621116c3f$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');




'use client';
var $dde438d0891cdd7d$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');







'use client';
const $00aad52bfb17a4b1$var$RadioButtonIconRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)
})({
    position: 'relative',
    display: 'flex'
});
const $00aad52bfb17a4b1$var$RadioButtonIconBackground = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $4413534621116c3f$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $00aad52bfb17a4b1$var$RadioButtonIconDot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $dde438d0891cdd7d$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)'
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
    })), {
        variants: [
            {
                props: {
                    checked: true
                },
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    transform: 'scale(1)'
                }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.shortest
                }))
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $00aad52bfb17a4b1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        checked: checked
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($00aad52bfb17a4b1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($00aad52bfb17a4b1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($00aad52bfb17a4b1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $00aad52bfb17a4b1$export$2e2bcd8739ae039 = $00aad52bfb17a4b1$var$RadioButtonIcon;




var $be539280bce7ae8a$export$2e2bcd8739ae039 = (0, $c67646090daa5c9c$export$2e2bcd8739ae039);




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $0c9c49001271722a$var$RadioGroupContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $0c9c49001271722a$export$2e2bcd8739ae039 = $0c9c49001271722a$var$RadioGroupContext;


'use client';
function $54a951467d098e7f$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $0c9c49001271722a$export$2e2bcd8739ae039));
}




function $f574f79e1a95e5a2$export$192f7b2363c77155(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiRadio', slot);
}
const $f574f79e1a95e5a2$var$radioClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $f574f79e1a95e5a2$export$2e2bcd8739ae039 = $f574f79e1a95e5a2$var$radioClasses;









'use client';
const $e76fcaea1c3599b6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            size !== 'medium' && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $f574f79e1a95e5a2$export$192f7b2363c77155), classes));
};
const $e76fcaea1c3599b6$var$RadioRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $ee7fbb23030d5fe3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $f574f79e1a95e5a2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $f574f79e1a95e5a2$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $e76fcaea1c3599b6$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $e76fcaea1c3599b6$var$defaultCheckedIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00aad52bfb17a4b1$export$2e2bcd8739ae039), {
    checked: true
});
const $e76fcaea1c3599b6$var$defaultIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00aad52bfb17a4b1$export$2e2bcd8739ae039), {});
const $e76fcaea1c3599b6$var$Radio = /*#__PURE__*/ $7fPBF.forwardRef(function Radio(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $e76fcaea1c3599b6$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $e76fcaea1c3599b6$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "checked",
        "checkedIcon",
        "color",
        "icon",
        "name",
        "onChange",
        "size",
        "className",
        "disabled",
        "disableRipple",
        "slots",
        "slotProps"
    ]);
    const muiFormControl = (0, $7c05b6d5a150dbd8$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled !== null && disabled !== void 0 ? disabled : disabled = false;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    });
    const classes = $e76fcaea1c3599b6$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $54a951467d098e7f$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $be539280bce7ae8a$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $e76fcaea1c3599b6$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input;
    var _icon_props_fontSize, _checkedIcon_props_fontSize;
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $e76fcaea1c3599b6$var$RadioRoot,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            slots: slots,
            slotProps: slotProps
        }, other),
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onChange: (event, ...args)=>{
                    var _handlers_onChange;
                    (_handlers_onChange = handlers.onChange) === null || _handlers_onChange === void 0 ? void 0 : _handlers_onChange.call(handlers, event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
                fontSize: (_icon_props_fontSize = icon.props.fontSize) !== null && _icon_props_fontSize !== void 0 ? _icon_props_fontSize : size
            }),
            checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(checkedIcon, {
                fontSize: (_checkedIcon_props_fontSize = checkedIcon.props.fontSize) !== null && _checkedIcon_props_fontSize !== void 0 ? _checkedIcon_props_fontSize : size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        classes: classes
    }));
});
var $e76fcaea1c3599b6$export$2e2bcd8739ae039 = $e76fcaea1c3599b6$var$Radio;





var $7fPBF = parcelRequire("7fPBF");






function $3bfebc960e5c9996$export$c4cff3a43f7cabb6(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiRadioGroup', slot);
}
const $3bfebc960e5c9996$var$radioGroupClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $3bfebc960e5c9996$export$2e2bcd8739ae039 = $3bfebc960e5c9996$var$radioGroupClasses;







'use client';
const $194e327f1282a3e9$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $3bfebc960e5c9996$export$c4cff3a43f7cabb6), classes);
};
const $194e327f1282a3e9$var$RadioGroup = /*#__PURE__*/ $7fPBF.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "actions",
        "children",
        "className",
        "defaultValue",
        "name",
        "onChange",
        "value"
    ]);
    const rootRef = $7fPBF.useRef(null);
    const classes = $194e327f1282a3e9$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $d2efeb5524b9e738$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $7fPBF.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $7fPBF.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c9c49001271722a$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea5892afc276c974$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other), {
            children: children
        }))
    });
});
var $194e327f1282a3e9$export$2e2bcd8739ae039 = $194e327f1282a3e9$var$RadioGroup;




parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");

let $1bb13d1f471bb27c$var$_ = (t)=>t, $1bb13d1f471bb27c$var$t;
const $1bb13d1f471bb27c$var$IconsButton = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_param, ref)=>{
    var { label: label, circle: circle = false, $color: $color = 'secondary', hideBorder: hideBorder = false } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "label",
        "circle",
        "$color",
        "hideBorder"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1bb13d1f471bb27c$var$StyledButton, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: ref,
        $color: $color,
        $size: "quick",
        $borderRadius: circle,
        $hideBorder: hideBorder
    }, restProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
            children: label
        })
    }));
});
const $1bb13d1f471bb27c$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== '$borderRadius' && prop !== '$hideBorder'
})($1bb13d1f471bb27c$var$t || ($1bb13d1f471bb27c$var$t = $1bb13d1f471bb27c$var$_`
    height: min-content;
    gap: 0;
    padding: 0 !important;
    max-width: min-content;
    ${0}
    ${0}
    svg {
        padding: 0.5rem;
    }
`), (props)=>props.$hideBorder ? 'border: none;' : '', (props)=>props.$borderRadius ? 'border-radius: 50%;' : '');
var $1bb13d1f471bb27c$export$2e2bcd8739ae039 = $1bb13d1f471bb27c$var$IconsButton;


/** Round, borderless destructive icon button (error-red, red-fill on hover). */ function $5c09a12afb55a78a$var$DeleteIconButton({ children: children, disabled: disabled, onClick: onClick }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
        label: typeof children === 'string' ? children : '',
        startIcon: "delete",
        $color: "danger",
        circle: true,
        hideBorder: true,
        disabled: disabled,
        onClick: onClick
    });
}
var $5c09a12afb55a78a$export$2e2bcd8739ae039 = $5c09a12afb55a78a$var$DeleteIconButton;



let $6e48650aa2ed148e$var$_ = (t)=>t, $6e48650aa2ed148e$var$t;
const $6e48650aa2ed148e$var$HorizontalFieldContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6e48650aa2ed148e$var$t || ($6e48650aa2ed148e$var$t = $6e48650aa2ed148e$var$_`
    margin: 1rem 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    input {
        flex: 1;
        margin-top: 4px;
        flex-grow: 1;
    }
`));
var $6e48650aa2ed148e$export$2e2bcd8739ae039 = $6e48650aa2ed148e$var$HorizontalFieldContainer;







let $98e7e100f470a300$var$_ = (t)=>t, $98e7e100f470a300$var$t, $98e7e100f470a300$var$t1, $98e7e100f470a300$var$t2;
const $98e7e100f470a300$export$7f714e6c560938e5 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($98e7e100f470a300$var$t || ($98e7e100f470a300$var$t = $98e7e100f470a300$var$_`
    color: ${0};
    text-align: center;
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).error);
const $98e7e100f470a300$export$d953939534de1974 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d))($98e7e100f470a300$var$t1 || ($98e7e100f470a300$var$t1 = $98e7e100f470a300$var$_`
    color: ${0};
    text-align: left;
    margin-bottom: 4px;
    margin-top: 1rem;
`), (props)=>props.theme.color.text).withComponent('legend');
const $98e7e100f470a300$export$1acdcf5a973a8414 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))($98e7e100f470a300$var$t2 || ($98e7e100f470a300$var$t2 = $98e7e100f470a300$var$_`
    text-align: left;
    margin-bottom: 4px;
    margin-top: 16px;
`)).withComponent('label');









var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");





'use client';
function $ee774f7b5890adec$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $4840e3b66caa6fde$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $06ba45f570780ba8$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $9da1e3d1169cfe7e$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div' } = inProps, other = (0, $8901fc92b5563702$export$71511d61b312f219)(inProps, [
            "className",
            "component"
        ]);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BoxRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            as: component,
            ref: ref,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}







const $382a37df26b36de0$var$boxClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $382a37df26b36de0$export$2e2bcd8739ae039 = $382a37df26b36de0$var$boxClasses;


'use client';
const $0295843db55c2695$var$defaultTheme = (0, $1626f90a7ddd654a$export$2e2bcd8739ae039)();
const $0295843db55c2695$var$Box = (0, $ee774f7b5890adec$export$2e2bcd8739ae039)({
    themeId: (0, $3096faf8e377d232$export$2e2bcd8739ae039),
    defaultTheme: $0295843db55c2695$var$defaultTheme,
    defaultClassName: (0, $382a37df26b36de0$export$2e2bcd8739ae039).root,
    generateClassName: (0, $a014965d951379c4$export$2e2bcd8739ae039).generate
});
var $0295843db55c2695$export$2e2bcd8739ae039 = $0295843db55c2695$var$Box;





var $7fPBF = parcelRequire("7fPBF");







function $b4928b37678e045b$export$964336739a8c7119(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiCardContent', slot);
}
const $b4928b37678e045b$var$cardContentClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiCardContent', [
    'root'
]);
var $b4928b37678e045b$export$2e2bcd8739ae039 = $b4928b37678e045b$var$cardContentClasses;



'use client';
const $5bfcdd07d543f75b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $b4928b37678e045b$export$964336739a8c7119), classes);
};
const $5bfcdd07d543f75b$var$CardContentRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardContent',
    slot: 'Root'
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $5bfcdd07d543f75b$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "component"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component
    });
    const classes = $5bfcdd07d543f75b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5bfcdd07d543f75b$var$CardContentRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5bfcdd07d543f75b$export$2e2bcd8739ae039 = $5bfcdd07d543f75b$var$CardContent;





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");






const $a1838e012595e8ac$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $a1838e012595e8ac$export$2e2bcd8739ae039 = $a1838e012595e8ac$var$visuallyHidden;




function $0349f65dbbfbf1b0$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $0349f65dbbfbf1b0$export$2e2bcd8739ae039 = $0349f65dbbfbf1b0$var$areArraysEqual;




'use client';
const $5bd6441cba88677d$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
const $5bd6441cba88677d$var$EMPTY_MARKS = [];
const $5bd6441cba88677d$var$EMPTY_OBJ = {};
function $5bd6441cba88677d$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $5bd6441cba88677d$var$asc(a, b) {
    return a - b;
}
function $5bd6441cba88677d$var$findClosest(values, currentValue, preferredIndex = -1) {
    var _values_reduce;
    const closestValue = (_values_reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc == null || distance <= acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) !== null && _values_reduce !== void 0 ? _values_reduce : $5bd6441cba88677d$var$EMPTY_OBJ;
    const { index: closestIndex } = closestValue;
    if (closestIndex == null) return closestIndex;
    if (preferredIndex >= 0 && values[preferredIndex] === values[closestIndex]) return preferredIndex;
    return closestIndex;
}
function $5bd6441cba88677d$var$trackFinger(event, touchIdRef) {
    // The event is TouchEvent
    if (touchIdRef.current != null && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchIdRef.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is PointerEvent or MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $5bd6441cba88677d$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $5bd6441cba88677d$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $5bd6441cba88677d$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $5bd6441cba88677d$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($5bd6441cba88677d$var$getDecimalPrecision(step)));
}
function $5bd6441cba88677d$var$setValueIndex(values, newValue, index) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($5bd6441cba88677d$var$asc);
}
function $5bd6441cba88677d$var$focusThumb(sliderRef, activeIndex, setActive, focusVisible) {
    const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(sliderRef.current);
    const activeElement = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
    if (!(0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(sliderRef.current, activeElement) || Number(activeElement === null || activeElement === void 0 ? void 0 : activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef_current;
        const input = (_sliderRef_current = sliderRef.current) === null || _sliderRef_current === void 0 ? void 0 : _sliderRef_current.querySelector(`[type="range"][data-index="${activeIndex}"]`);
        if (input != null) {
            if (focusVisible == null) input.focus({
                preventScroll: true
            });
            else input.focus({
                preventScroll: true,
                focusVisible: // Prevent pointer-driven focus rings in browsers that support this option.
                // Chrome 144+ supports `focusVisible` in `HTMLElement.focus()` options.
                focusVisible
            });
        }
    }
    if (setActive) setActive(activeIndex);
}
function $5bd6441cba88677d$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $0349f65dbbfbf1b0$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $5bd6441cba88677d$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $5bd6441cba88677d$export$544bf02140fa9a77 = (x)=>x;
function $5bd6441cba88677d$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $5bd6441cba88677d$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchIdRef = $7fPBF.useRef(undefined);
    const focusFrameRef = $7fPBF.useRef(null);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $7fPBF.useState(-1);
    const [open, setOpen] = $7fPBF.useState(-1);
    const [dragging, setDragging] = $7fPBF.useState(false);
    const moveCountRef = $7fPBF.useRef(0);
    // Ref (not state) because setActive() always accompanies updates, providing the re-render.
    const lastUsedThumbIndexRef = $7fPBF.useRef(-1);
    // Prevents duplicate listener registration when both pointer and touch events fire
    // for the same physical touch interaction.
    const pointerDownHandledRef = $7fPBF.useRef(false);
    // Tracks which pointer owns the current drag session, so stray pointerup/pointermove
    // events from a second pointer don't interfere.
    const activePointerIdRef = $7fPBF.useRef(-1);
    const cancelFocusFrame = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        if (focusFrameRef.current != null) {
            cancelAnimationFrame(focusFrameRef.current);
            focusFrameRef.current = null;
        }
    });
    // lastChangedValueRef is updated whenever onChange is triggered.
    const lastChangedValueRef = $7fPBF.useRef(null);
    const [valueDerived, setValueState] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue !== null && defaultValue !== void 0 ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValueRef.current = value;
        onChange === null || onChange === void 0 ? void 0 : onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    const values = $7fPBF.useMemo(()=>{
        if (typeof valueDerived === 'number') return [
            (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(valueDerived, min, max)
        ];
        if (valueDerived == null) return [
            min
        ];
        const sortedValues = valueDerived.slice().sort($5bd6441cba88677d$var$asc);
        for(let i = 0; i < sortedValues.length; i += 1){
            const value = sortedValues[i];
            sortedValues[i] = value == null ? min : (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(value, min, max);
        }
        return sortedValues;
    }, [
        valueDerived,
        min,
        max
    ]);
    const marks = $7fPBF.useMemo(()=>{
        if (marksProp === true && step != null) {
            const generatedMarks = new Array(Math.floor((max - min) / step) + 1);
            for(let i = 0; i < generatedMarks.length; i += 1)generatedMarks[i] = {
                value: min + step * i
            };
            return generatedMarks;
        }
        return Array.isArray(marksProp) ? marksProp : $5bd6441cba88677d$var$EMPTY_MARKS;
    }, [
        marksProp,
        step,
        min,
        max
    ]);
    const marksValues = $7fPBF.useMemo(()=>{
        const markValues = new Array(marks.length);
        for(let i = 0; i < marks.length; i += 1)markValues[i] = marks[i].value;
        return markValues;
    }, [
        marks
    ]);
    const [focusedThumbIndex, setFocusedThumbIndex] = $7fPBF.useState(-1);
    const sliderRef = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers_onFocus;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers === null || otherHandlers === void 0 ? void 0 : (_otherHandlers_onFocus = otherHandlers.onFocus) === null || _otherHandlers_onFocus === void 0 ? void 0 : _otherHandlers_onFocus.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers_onBlur;
            if (!(0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers === null || otherHandlers === void 0 ? void 0 : (_otherHandlers_onBlur = otherHandlers.onBlur) === null || _otherHandlers_onBlur === void 0 ? void 0 : _otherHandlers_onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $5bd6441cba88677d$var$setValueIndex(values, newValue, index);
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $5bd6441cba88677d$var$focusThumb(sliderRef, activeIndex);
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (onChange && !$5bd6441cba88677d$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        var _lastChangedValueRef_current;
        if (onChangeCommitted) onChangeCommitted(event, (_lastChangedValueRef_current = lastChangedValueRef.current) !== null && _lastChangedValueRef_current !== void 0 ? _lastChangedValueRef_current : newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers_onKeyDown;
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $5bd6441cba88677d$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $5bd6441cba88677d$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $5bd6441cba88677d$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $5bd6441cba88677d$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $5bd6441cba88677d$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $5bd6441cba88677d$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers === null || otherHandlers === void 0 ? void 0 : (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
        };
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        const activeElement = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)((0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(sliderRef.current));
        if (disabled && (0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(sliderRef.current, activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        {
            if (activeElement != null && 'blur' in activeElement) activeElement.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers_onChange;
            (_otherHandlers_onChange = otherHandlers.onChange) === null || _otherHandlers_onChange === void 0 ? void 0 : _otherHandlers_onChange.call(otherHandlers, event);
            // Handles value changes reported through the hidden range input.
            changeValue(event, event.currentTarget.valueAsNumber);
        };
    const previousIndexRef = $7fPBF.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    // Converts finger coordinates to a slider value and determines the active thumb.
    // For range sliders, reads `previousIndexRef.current` to decide which thumb is active:
    //   -1 = initial press → find closest thumb
    //   ≥0 = drag in progress → keep same thumb
    // Callers must reset `previousIndexRef.current = -1` before calling on a new interaction.
    const getValueAtFinger = (finger)=>{
        const { current: slider } = sliderRef;
        if (!slider) return null;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $5bd6441cba88677d$var$percentToValue(percent, min, max);
        if (step) newValue = $5bd6441cba88677d$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $5bd6441cba88677d$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            const isDragging = previousIndexRef.current !== -1;
            activeIndex = isDragging ? previousIndexRef.current : $5bd6441cba88677d$var$findClosest(values, newValue, lastUsedThumbIndexRef.current);
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $5bd6441cba88677d$var$setValueIndex(values, newValue, activeIndex);
            // Potentially swap the index if needed.
            if (!(disableSwap && isDragging)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndexRef.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((nativeEvent)=>{
        // Ignore pointer events from a different pointer than the one that started the drag.
        if ('pointerId' in nativeEvent && nativeEvent.pointerId !== activePointerIdRef.current) return;
        const finger = $5bd6441cba88677d$var$trackFinger(nativeEvent, touchIdRef);
        if (!finger) return;
        moveCountRef.current += 1;
        // Cancel move in case some other element consumed a pointerup event and it was not fired.
        if (nativeEvent.type === 'pointermove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const newFingerValue = getValueAtFinger(finger);
        if (!newFingerValue) return;
        $5bd6441cba88677d$var$focusThumb(sliderRef, newFingerValue.activeIndex, setActive, false);
        lastUsedThumbIndexRef.current = newFingerValue.activeIndex;
        setValueState(newFingerValue.newValue);
        if (!dragging && moveCountRef.current > $5bd6441cba88677d$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (onChange && !$5bd6441cba88677d$var$areValuesEqual(newFingerValue.newValue, valueDerived)) handleChange(nativeEvent, newFingerValue.newValue, newFingerValue.activeIndex);
    });
    const handleTouchEnd = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((nativeEvent)=>{
        var _sliderRef_current;
        // Ignore pointer events from a different pointer than the one that started the drag.
        if ('pointerId' in nativeEvent && nativeEvent.pointerId !== activePointerIdRef.current) return;
        const finger = $5bd6441cba88677d$var$trackFinger(nativeEvent, touchIdRef);
        setDragging(false);
        if (!finger) return;
        const newFingerValue = getValueAtFinger(finger);
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        var _lastChangedValueRef_current;
        if (newFingerValue && onChangeCommitted) onChangeCommitted(nativeEvent, (_lastChangedValueRef_current = lastChangedValueRef.current) !== null && _lastChangedValueRef_current !== void 0 ? _lastChangedValueRef_current : newFingerValue.newValue);
        // Release pointer capture if applicable
        if ('pointerType' in nativeEvent && ((_sliderRef_current = sliderRef.current) === null || _sliderRef_current === void 0 ? void 0 : _sliderRef_current.hasPointerCapture(nativeEvent.pointerId))) sliderRef.current.releasePointerCapture(nativeEvent.pointerId);
        touchIdRef.current = undefined;
        activePointerIdRef.current = -1;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If the pointer path already handled this interaction,
        // only record the touch identifier and skip duplicate listener registration.
        if (pointerDownHandledRef.current) {
            pointerDownHandledRef.current = false;
            const touch = nativeEvent.changedTouches[0];
            if (touch != null) touchIdRef.current = touch.identifier;
            return;
        }
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchIdRef.current = touch.identifier;
        const finger = $5bd6441cba88677d$var$trackFinger(nativeEvent, touchIdRef);
        if (finger !== false) {
            previousIndexRef.current = -1;
            const newFingerValue = getValueAtFinger(finger);
            if (newFingerValue) {
                $5bd6441cba88677d$var$focusThumb(sliderRef, newFingerValue.activeIndex, setActive, false);
                lastUsedThumbIndexRef.current = newFingerValue.activeIndex;
                setValueState(newFingerValue.newValue);
                if (onChange && !$5bd6441cba88677d$var$areValuesEqual(newFingerValue.newValue, valueDerived)) handleChange(nativeEvent, newFingerValue.newValue, newFingerValue.activeIndex);
            }
        }
        moveCountRef.current = 0;
        const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $7fPBF.useCallback(()=>{
        const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('pointermove', handleTouchMove);
        doc.removeEventListener('pointerup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $7fPBF.useEffect(()=>{
        const slider = sliderRef.current;
        if (!slider) return undefined;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: true
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            cancelFocusFrame();
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart,
        cancelFocusFrame
    ]);
    $7fPBF.useEffect(()=>{
        if (disabled) {
            stopListening();
            cancelFocusFrame();
        }
    }, [
        disabled,
        stopListening,
        cancelFocusFrame
    ]);
    const createHandlePointerDown = (otherHandlers)=>(event)=>{
            var _otherHandlers_onPointerDown;
            (_otherHandlers_onPointerDown = otherHandlers.onPointerDown) === null || _otherHandlers_onPointerDown === void 0 ? void 0 : _otherHandlers_onPointerDown.call(otherHandlers, event);
            // On touch devices, the browser fires both pointerdown and touchstart for the
            // same physical touch. Mark this BEFORE early returns so handleTouchStart always
            // knows the pointer path saw this interaction — even if it was prevented or disabled.
            if (event.pointerType === 'touch') pointerDownHandledRef.current = true;
            if (disabled || event.defaultPrevented || event.button !== 0) return;
            const finger = $5bd6441cba88677d$var$trackFinger(event, touchIdRef);
            if (finger !== false) {
                previousIndexRef.current = -1;
                const newFingerValue = getValueAtFinger(finger);
                if (newFingerValue) {
                    var _sliderRef_current;
                    const thumbInput = (_sliderRef_current = sliderRef.current) === null || _sliderRef_current === void 0 ? void 0 : _sliderRef_current.querySelector(`input[type="range"][data-index="${newFingerValue.activeIndex}"]`);
                    const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(sliderRef.current);
                    const pressedOnFocusedThumb = thumbInput != null && thumbInput === (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)(doc);
                    setActive(newFingerValue.activeIndex);
                    lastUsedThumbIndexRef.current = newFingerValue.activeIndex;
                    if (pressedOnFocusedThumb) event.preventDefault();
                    else {
                        cancelFocusFrame();
                        focusFrameRef.current = requestAnimationFrame(()=>{
                            focusFrameRef.current = null;
                            $5bd6441cba88677d$var$focusThumb(sliderRef, newFingerValue.activeIndex, undefined, false);
                        });
                    }
                    setValueState(newFingerValue.newValue);
                    if (onChange && !$5bd6441cba88677d$var$areValuesEqual(newFingerValue.newValue, valueDerived)) handleChange(event, newFingerValue.newValue, newFingerValue.activeIndex);
                }
            }
            moveCountRef.current = 0;
            activePointerIdRef.current = event.pointerId;
            const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(sliderRef.current);
            // Use pointer capture for reliable drag tracking
            try {
                event.currentTarget.setPointerCapture(event.pointerId);
            } catch (e) {
            // setPointerCapture can throw if the pointerId is invalid (e.g. synthetic
            // events in tests, or the pointer was already released). The slider still
            // works via document-level listeners; pointer capture is a progressive
            // enhancement for reliable drag tracking.
            }
            doc.addEventListener('pointermove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('pointerup', handleTouchEnd);
        };
    const trackOffset = $5bd6441cba88677d$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $5bd6441cba88677d$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = $5bd6441cba88677d$var$EMPTY_OBJ)=>{
        const externalHandlers = (0, $d6f21882b2ade459$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onPointerDown: createHandlePointerDown(externalHandlers)
        };
        const mergedEventHandlers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalHandlers, ownEventHandlers);
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalProps), {
            ref: handleRef
        }), mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers_onMouseOver;
            (_otherHandlers_onMouseOver = otherHandlers.onMouseOver) === null || _otherHandlers_onMouseOver === void 0 ? void 0 : _otherHandlers_onMouseOver.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers_onMouseLeave;
            (_otherHandlers_onMouseLeave = otherHandlers.onMouseLeave) === null || _otherHandlers_onMouseLeave === void 0 ? void 0 : _otherHandlers_onMouseLeave.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = $5bd6441cba88677d$var$EMPTY_OBJ)=>{
        const externalHandlers = (0, $d6f21882b2ade459$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers),
            onMouseLeave: createHandleMouseLeave(externalHandlers)
        };
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        let zIndex;
        if (range) {
            if (active === index) zIndex = 2;
            else if (lastUsedThumbIndexRef.current === index) zIndex = 1;
        } else if (active === index) zIndex = 1;
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined,
            zIndex: zIndex
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = $5bd6441cba88677d$var$EMPTY_OBJ)=>{
        const externalHandlers = (0, $d6f21882b2ade459$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers),
            onFocus: createHandleHiddenInputFocus(externalHandlers),
            onBlur: createHandleHiddenInputBlur(externalHandlers),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers)
        };
        const mergedEventHandlers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalHandlers, ownEventHandlers);
        var _parameters_step;
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters_step = parameters.step) !== null && _parameters_step !== void 0 ? _parameters_step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers), {
            style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $a1838e012595e8ac$export$2e2bcd8739ae039)), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $5bd6441cba88677d$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}










var $7fPBF = parcelRequire("7fPBF");




function $72bc311c97f425ee$export$9f59f2622d5cbc2a(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiSlider', slot);
}
const $72bc311c97f425ee$var$sliderClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'track',
    'trackInverted',
    'trackFalse',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $72bc311c97f425ee$export$2e2bcd8739ae039 = $72bc311c97f425ee$var$sliderClasses;



'use client';
const $23a1a8dd4a6d66d5$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(open && (0, $72bc311c97f425ee$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $72bc311c97f425ee$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $72bc311c97f425ee$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $23a1a8dd4a6d66d5$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $23a1a8dd4a6d66d5$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $7fPBF.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}





'use client';
function $b2f3bbecbfe39692$var$Identity(x) {
    return x;
}
const $b2f3bbecbfe39692$export$c1a21b3b4da66aa1 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).thumb}, & .${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $b2f3bbecbfe39692$export$b02fde61a3559c2 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    '@media (forced-colors: active)': {
        border: '1px solid transparent',
        boxSizing: 'border-box'
    },
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $b2f3bbecbfe39692$export$105594979f116971 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor'
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'left',
        'width',
        'bottom',
        'height'
    ], {
        duration: theme.transitions.duration.shortest
    })), {
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    '@media (forced-colors: none)': {
                        border: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        backgroundColor: theme.lighten(theme.palette[color].main, 0.62),
                        borderColor: theme.lighten(theme.palette[color].main, 0.62)
                    }, theme.applyStyles('dark', {
                        backgroundColor: theme.darken(theme.palette[color].main, 0.5)
                    }), theme.applyStyles('dark', {
                        borderColor: theme.darken(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    });
}));
const $b2f3bbecbfe39692$export$2c1b491743890dec = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Thumb'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'box-shadow',
        'left',
        'bottom'
    ], {
        duration: theme.transitions.duration.shortest
    })), {
        '@media (forced-colors: active)': {
            border: '1px solid ButtonBorder'
        },
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).focusVisible}`]: {
                            boxShadow: `0px 0px 0px 8px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`,
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).active}`]: {
                            boxShadow: `0px 0px 0px 14px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`
                        }
                    }
                }))
        ]
    })));
const $b2f3bbecbfe39692$export$6453176f504d54f0 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $23a1a8dd4a6d66d5$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2), {
        fontWeight: 500
    }), (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'transform'
    ], {
        duration: theme.transitions.duration.shortest
    })), {
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $72bc311c97f425ee$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $b2f3bbecbfe39692$export$6f85f6a3c5da6f62 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $69b67c4b8d281c07$export$2e2bcd8739ae039)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $b2f3bbecbfe39692$export$e6cd369965e5aa95 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $69b67c4b8d281c07$export$2e2bcd8739ae039)(prop) && prop !== 'markLabelActive'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.body2), {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $b2f3bbecbfe39692$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            size && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled'
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $72bc311c97f425ee$export$9f59f2622d5cbc2a), classes);
};
const $b2f3bbecbfe39692$var$Forward = ({ children: children })=>children;
const $b2f3bbecbfe39692$var$Slider = /*#__PURE__*/ $7fPBF.forwardRef(function Slider(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $b2f3bbecbfe39692$var$Identity, slotProps: slotProps = {}, slots: slots = {}, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $b2f3bbecbfe39692$var$Identity } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        'aria-label',
        'aria-valuetext',
        'aria-labelledby',
        "color",
        "classes",
        "className",
        "disableSwap",
        "disabled",
        "getAriaLabel",
        "getAriaValueText",
        "marks",
        "max",
        "min",
        "name",
        "onChange",
        "onChangeCommitted",
        "orientation",
        "shiftStep",
        "size",
        "step",
        "scale",
        "slotProps",
        "slots",
        "tabIndex",
        "track",
        "value",
        "valueLabelDisplay",
        "valueLabelFormat"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $5bd6441cba88677d$export$56b2c08e277f365)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ownerState), {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $b2f3bbecbfe39692$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        elementType: $b2f3bbecbfe39692$export$c1a21b3b4da66aa1,
        getSlotProps: getRootProps,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [RailSlot, railProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('rail', {
        elementType: $b2f3bbecbfe39692$export$b02fde61a3559c2,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const [TrackSlot, trackProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('track', {
        elementType: $b2f3bbecbfe39692$export$105594979f116971,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: ownerState,
        className: classes.track
    });
    const [ThumbSlot, thumbProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('thumb', {
        elementType: $b2f3bbecbfe39692$export$2c1b491743890dec,
        getSlotProps: getThumbProps,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.thumb
    });
    const [ValueLabelSlot, valueLabelProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('valueLabel', {
        elementType: $b2f3bbecbfe39692$export$6453176f504d54f0,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.valueLabel
    });
    const [MarkSlot, markProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('mark', {
        elementType: $b2f3bbecbfe39692$export$6f85f6a3c5da6f62,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const [MarkLabelSlot, markLabelProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('markLabel', {
        elementType: $b2f3bbecbfe39692$export$e6cd369965e5aa95,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const [InputSliderSlot, inputSliderProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('input', {
        elementType: 'input',
        getSlotProps: getHiddenInputProps,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RailSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, railProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TrackSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $5bd6441cba88677d$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            "data-index": index
                        }, markProps, !(0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(MarkSlot) && {
                            markActive: markActive
                        }), {
                            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, style, markProps.style),
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkLabelSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }), {
                            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, style, markLabelProps.style),
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $5bd6441cba88677d$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $b2f3bbecbfe39692$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $824c049f32d4395d$exports.jsx)(ValueLabelComponent, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, !(0, $6b6af0ee4304783c$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ThumbSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        "data-index": index
                    }, thumbProps), {
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputSliderSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $b2f3bbecbfe39692$export$2e2bcd8739ae039 = $b2f3bbecbfe39692$var$Slider;





let $bf69660d3ccba544$var$_ = (t)=>t, $bf69660d3ccba544$var$t, $bf69660d3ccba544$var$t1;
const $bf69660d3ccba544$export$3c56cb56459c147a = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($bf69660d3ccba544$var$t || ($bf69660d3ccba544$var$t = $bf69660d3ccba544$var$_`
    padding: 0.5rem 1rem;
    border: none;
    background: ${0};
    color: ${0};
    cursor: pointer;
    border-radius: ${0};
    transition: all 0.2s ease;
    &:hover {
        background: ${0};
        color: ${0};
    }
    ${0}
`), (props)=>props.isActive ? props.theme.color.accent : props.theme.color.cardHover, (props)=>props.isActive ? props.theme.color.background : props.theme.button.secondary.text, (0, $8951886a6b49e92a$export$7a57f79000377ca2).pill, (props)=>props.theme.button.secondary.text, (props)=>props.theme.color.background, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $bf69660d3ccba544$export$63c9a9d77925d61e = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($bf69660d3ccba544$var$t1 || ($bf69660d3ccba544$var$t1 = $bf69660d3ccba544$var$_`
    display: flex;
    gap: 10px;
    margin: 10px 0;
`));






let $cbb6bb91774a9b44$var$_ = (t)=>t, $cbb6bb91774a9b44$var$t, $cbb6bb91774a9b44$var$t1, $cbb6bb91774a9b44$var$t2, $cbb6bb91774a9b44$var$t3, $cbb6bb91774a9b44$var$t4, $cbb6bb91774a9b44$var$t5;
const $cbb6bb91774a9b44$export$b1a401d0eced3e7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cbb6bb91774a9b44$var$t || ($cbb6bb91774a9b44$var$t = $cbb6bb91774a9b44$var$_`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
    align-items: center;
`));
const $cbb6bb91774a9b44$export$c14c794fcd73bed8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cbb6bb91774a9b44$var$t1 || ($cbb6bb91774a9b44$var$t1 = $cbb6bb91774a9b44$var$_`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 2rem 2rem 0;
    max-width: 800px;
    width: calc(100% - 3rem);
`));
const $cbb6bb91774a9b44$export$cd7bba038e96e3a1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cbb6bb91774a9b44$var$t2 || ($cbb6bb91774a9b44$var$t2 = $cbb6bb91774a9b44$var$_`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2rem;
    align-items: center;
`));
const $cbb6bb91774a9b44$export$eff72ff865909d33 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cbb6bb91774a9b44$var$t3 || ($cbb6bb91774a9b44$var$t3 = $cbb6bb91774a9b44$var$_`
    display: inline-block;
`));
const $cbb6bb91774a9b44$export$cc2315a10717ef53 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8))($cbb6bb91774a9b44$var$t4 || ($cbb6bb91774a9b44$var$t4 = $cbb6bb91774a9b44$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding-bottom: 0;
    max-width: 100%;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
`));
const $cbb6bb91774a9b44$export$4e88b920c7e5fd9 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))($cbb6bb91774a9b44$var$t5 || ($cbb6bb91774a9b44$var$t5 = $cbb6bb91774a9b44$var$_`
    float: right;
    height: min-content;
`));






var $7fPBF = parcelRequire("7fPBF");

let $fd343a4c977deb5d$var$_ = (t)=>t, $fd343a4c977deb5d$var$t, $fd343a4c977deb5d$var$t1, $fd343a4c977deb5d$var$t2, $fd343a4c977deb5d$var$t3, $fd343a4c977deb5d$var$t4, $fd343a4c977deb5d$var$t5, $fd343a4c977deb5d$var$t6;
const $fd343a4c977deb5d$var$JOYSTICK_RADIUS = 100;
const $fd343a4c977deb5d$var$STICK_RADIUS = 30;
const $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE = $fd343a4c977deb5d$var$JOYSTICK_RADIUS - $fd343a4c977deb5d$var$STICK_RADIUS;
function $fd343a4c977deb5d$export$2e2bcd8739ae039({ macro: macro, event: event, eventIndex: eventIndex, onChange: onChange }) {
    const [config, setConfig] = (0, $7fPBF.useState)({
        joystickLeftMoveX: event.joystickLeftMoveX ? event.joystickLeftMoveX / 100 : 0,
        joystickLeftMoveY: event.joystickLeftMoveY ? event.joystickLeftMoveY / 100 : 0,
        joystickRightMoveX: event.joystickRightMoveX ? event.joystickRightMoveX / 100 : 0,
        joystickRightMoveY: event.joystickRightMoveY ? event.joystickRightMoveY / 100 : 0,
        holdTimeMilliseconds: event.holdTimeMilliseconds || 100,
        isKeyLatch: event.isKeyLatch ? event.isKeyLatch : event.holdTimeMilliseconds != undefined
    });
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const muiTheme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const scaleJoystickValue = (value)=>{
        if (!value) return 0;
        value = value * 100; // Scale to percentage
        const clampedValue = Math.max(-100, Math.min(100, value));
        return Math.round(clampedValue);
    };
    const clampToUnitCircle = (x, y)=>{
        const mag = Math.sqrt(x * x + y * y);
        if (mag > 1) return {
            x: x / mag,
            y: y / mag
        };
        return {
            x: x,
            y: y
        };
    };
    const clampAndFloatValue = (value)=>{
        if (value === undefined) return 0;
        let clampedValue = Math.max(-1, Math.min(1, value));
        return clampedValue.toFixed(2) ? parseFloat(clampedValue.toFixed(2)) : 0;
    };
    const handleTimeChange = (isLatched, value)=>{
        const holdTime = value !== null && value !== void 0 ? value : 0;
        setConfig((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                holdTimeMilliseconds: isLatched ? 0 : holdTime
            }));
        const newEvents = macro.events.map((evt, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, evt), {
                holdTimeMilliseconds: isLatched ? undefined : holdTime,
                isKeyLatch: isLatched
            }) : evt);
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleJoystickMove = (0, $7fPBF.useCallback)((stick, x, y)=>{
        const scaledX = scaleJoystickValue(x);
        const scaledY = scaleJoystickValue(y);
        if (stick === 'leftStick') setConfig((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                joystickLeftMoveX: x,
                joystickLeftMoveY: y
            }));
        else setConfig((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                joystickRightMoveX: x,
                joystickRightMoveY: y
            }));
        const newEvents = macro.events.map((evt, idx)=>{
            if (idx !== eventIndex) return evt;
            const eventToUpdate = stick === 'leftStick' ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, evt), {
                joystickLeftMoveX: scaledX,
                joystickLeftMoveY: scaledY
            }) : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, evt), {
                joystickRightMoveX: scaledX,
                joystickRightMoveY: scaledY
            });
            if (!eventToUpdate.isKeyLatch && !eventToUpdate.holdTimeMilliseconds) eventToUpdate.isKeyLatch = true;
            return eventToUpdate;
        });
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    }, [
        macro,
        eventIndex,
        onChange
    ]);
    const handleMouseDown = (stick, event)=>{
        const rect = event.currentTarget.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const handleMouseMove = (e)=>{
            let x = (e.clientX - centerX) / $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE;
            let y = -(e.clientY - centerY) / $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE;
            x = clampAndFloatValue(x);
            y = clampAndFloatValue(y);
            handleJoystickMove(stick, x, y);
        };
        const handleMouseUp = ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const resetJoystick = (stick)=>{
        handleJoystickMove(stick, 0, 0);
    };
    const clampedLeft = clampToUnitCircle(config.joystickLeftMoveX, config.joystickLeftMoveY);
    const clampedRight = clampToUnitCircle(config.joystickRightMoveX, config.joystickRightMoveY);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5bfcdd07d543f75b$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$JoystickContainer, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$JoystickWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b8b202156ead000b), {
                                    children: t('common:event.joystickMove.left')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickBase, {
                                    onMouseDown: (e)=>handleMouseDown('leftStick', e),
                                    color: muiTheme.palette.primary.main,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickStick, {
                                        x: clampedLeft.x,
                                        y: clampedLeft.y,
                                        active: !!(config.joystickLeftMoveX || config.joystickLeftMoveY),
                                        color: muiTheme.palette.primary.main
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $0295843db55c2695$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$StatusIndicator, {
                                            active: !!(config.joystickLeftMoveX || config.joystickLeftMoveY)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                            children: [
                                                "X: ",
                                                config.joystickLeftMoveX.toFixed(2),
                                                ", Y: ",
                                                config.joystickLeftMoveY.toFixed(2)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
                                            title: t('common:reset'),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
                                                size: "small",
                                                onClick: ()=>resetJoystick('leftStick'),
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "sync",
                                                    size: 18,
                                                    color: theme.color.textBody
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$JoystickWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b8b202156ead000b), {
                                    children: t('common:event.joystickMove.right')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickBase, {
                                    onMouseDown: (e)=>handleMouseDown('rightStick', e),
                                    color: muiTheme.palette.secondary.main,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$JoystickStick, {
                                        x: clampedRight.x,
                                        y: clampedRight.y,
                                        active: !!(config.joystickRightMoveX || config.joystickRightMoveY),
                                        color: muiTheme.palette.secondary.main
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $0295843db55c2695$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fd343a4c977deb5d$var$StatusIndicator, {
                                            active: !!(config.joystickRightMoveX || config.joystickRightMoveY)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                            children: [
                                                "X: ",
                                                config.joystickRightMoveX.toFixed(2),
                                                ", Y: ",
                                                config.joystickRightMoveY.toFixed(2)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
                                            title: "Reset Position",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
                                                size: "small",
                                                onClick: ()=>resetJoystick('rightStick'),
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "sync",
                                                    size: 18,
                                                    color: theme.color.textBody
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    id: `leftX${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.leftX'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f3bbecbfe39692$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `leftX${macro.id}`,
                                    value: config.joystickLeftMoveX,
                                    onChange: (_, value)=>handleJoystickMove('leftStick', value, config.joystickLeftMoveY || 0),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickLeftMoveX || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    id: `leftY${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.leftY'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f3bbecbfe39692$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `leftY${macro.id}`,
                                    value: config.joystickLeftMoveY,
                                    onChange: (_, value)=>handleJoystickMove('leftStick', config.joystickLeftMoveX || 0, value),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickLeftMoveY
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    id: `rightX${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.rightX'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f3bbecbfe39692$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `rightX${macro.id}`,
                                    value: config.joystickRightMoveX,
                                    onChange: (_, value)=>handleJoystickMove('rightStick', value, config.joystickRightMoveY || 0),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "secondary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickRightMoveX
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$AxisControl, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    id: `rightY${macro.id}`,
                                    variant: "body2",
                                    sx: {
                                        minWidth: 70
                                    },
                                    children: [
                                        t('common:event.joystickMove.rightY'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f3bbecbfe39692$export$2e2bcd8739ae039), {
                                    "aria-labelledby": `rightY${macro.id}`,
                                    value: config.joystickRightMoveY,
                                    onChange: (_, value)=>handleJoystickMove('rightStick', config.joystickRightMoveX || 0, value),
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                    sx: {
                                        flex: 1
                                    },
                                    color: "secondary"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        minWidth: 50,
                                        textAlign: 'right'
                                    },
                                    children: config.joystickRightMoveY
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cbb6bb91774a9b44$export$b1a401d0eced3e7), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($fd343a4c977deb5d$var$StyledRow, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf69660d3ccba544$export$3c56cb56459c147a), {
                                            isActive: !!event.isKeyLatch || event.isKeyLatch == undefined,
                                            onClick: ()=>handleTimeChange(true),
                                            children: t('common:event.keyPress.latch')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf69660d3ccba544$export$3c56cb56459c147a), {
                                            isActive: !(event.isKeyLatch || event.isKeyLatch == undefined) && event.holdTimeMilliseconds != undefined,
                                            onClick: ()=>handleTimeChange(false, 0),
                                            children: t('common:event.keyPress.hold')
                                        })
                                    ]
                                }),
                                !event.isKeyLatch && event.isKeyLatch != undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: t('common:event.hold'),
                                    type: "number",
                                    value: config.holdTimeMilliseconds,
                                    placeholder: t('common:event.hold'),
                                    onChange: (e)=>handleTimeChange(false, Number(e.target.value))
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: [
                                        t('common:event.joystickMove.latch'),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $fd343a4c977deb5d$var$JoystickContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t || ($fd343a4c977deb5d$var$t = $fd343a4c977deb5d$var$_`
    display: flex;
    gap: 40px;
    justify-content: space-between;
    margin: 1rem auto;
    flex-wrap: wrap;
    max-width: 600px;
    justify-self: center;
`));
const $fd343a4c977deb5d$var$JoystickWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t1 || ($fd343a4c977deb5d$var$t1 = $fd343a4c977deb5d$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    gap: 16px;
`));
const $fd343a4c977deb5d$var$JoystickBase = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t2 || ($fd343a4c977deb5d$var$t2 = $fd343a4c977deb5d$var$_`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: ${0}20;
    border: 2px solid ${0};
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border: 2px solid ${0};
    }
`), (props)=>props.color, (props)=>props.color, (props)=>props.color);
const $fd343a4c977deb5d$var$JoystickStick = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t3 || ($fd343a4c977deb5d$var$t3 = $fd343a4c977deb5d$var$_`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: ${0};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(
        calc(-50% + ${0}px),
        calc(-50% + ${0}px)
    );
    transition: all 0.2s ease;
    cursor: grab;

    &:active {
        cursor: grabbing;
        transform: translate(
                calc(-50% + ${0}px),
                calc(-50% + ${0}px)
            )
            scale(0.95);
    }
`), (props)=>props.active ? props.color || props.theme.color.secondary : props.theme.color.textBody, (props)=>props.x * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE, (props)=>-props.y * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE, (props)=>props.x * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE, (props)=>-props.y * $fd343a4c977deb5d$var$JOYSTICK_MOVEMENT_SCALE);
const $fd343a4c977deb5d$var$AxisControl = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t4 || ($fd343a4c977deb5d$var$t4 = $fd343a4c977deb5d$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
`));
const $fd343a4c977deb5d$var$StatusIndicator = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t5 || ($fd343a4c977deb5d$var$t5 = $fd343a4c977deb5d$var$_`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${0};
    transition: all 0.3s ease;
`), (props)=>props.active ? (0, $8951886a6b49e92a$export$35e9368ef982300f).success : props.theme.color.textBody);
const $fd343a4c977deb5d$var$StyledRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fd343a4c977deb5d$var$t6 || ($fd343a4c977deb5d$var$t6 = $fd343a4c977deb5d$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 0.5rem;
`));











var $7fPBF = parcelRequire("7fPBF");

let $f9d7c8960dba7b88$var$_ = (t)=>t, $f9d7c8960dba7b88$var$t, $f9d7c8960dba7b88$var$t1;
function $f9d7c8960dba7b88$export$2e2bcd8739ae039({ macro: macro, event: event, eventIndex: eventIndex, isPreview: isPreview = false, onChange: onChange }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    var _event_mouseMoveX;
    const initMouseMoveX = (_event_mouseMoveX = event.mouseMoveX) !== null && _event_mouseMoveX !== void 0 ? _event_mouseMoveX : 0;
    const initDirectionX = initMouseMoveX <= 0 ? 'left' : 'right';
    const initPixelsX = Math.abs(initMouseMoveX);
    var _event_mouseMoveY;
    const initMouseMoveY = (_event_mouseMoveY = event.mouseMoveY) !== null && _event_mouseMoveY !== void 0 ? _event_mouseMoveY : 0;
    const initDirectionY = initMouseMoveY >= 0 ? 'down' : 'up';
    const initPixelsY = Math.abs(initMouseMoveY);
    const [moveX, setMoveX] = (0, $7fPBF.useState)(initMouseMoveX ? initMouseMoveX : 0);
    const [directionX, setDirectionX] = (0, $7fPBF.useState)(initDirectionX ? initDirectionX : 'right');
    const [pixelsX, setPixelsX] = (0, $7fPBF.useState)(initPixelsX ? initPixelsX : 0);
    const [moveY, setMoveY] = (0, $7fPBF.useState)(initMouseMoveY ? initMouseMoveY : 0);
    const [directionY, setDirectionY] = (0, $7fPBF.useState)(initDirectionY ? initDirectionY : 'up');
    const [pixelsY, setPixelsY] = (0, $7fPBF.useState)(initPixelsY ? initPixelsY : 0);
    const withEventUpdate = (changes)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: macro.events.map((evt, idx)=>idx === eventIndex ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, evt, changes) : evt)
        });
    const handleEventMouseXLeftRight = (value)=>{
        const newMoveX = pixelsX * (value === 'left' ? -1 : 1);
        onChange(withEventUpdate({
            mouseMoveX: newMoveX
        }));
        setMoveX(newMoveX);
        setDirectionX(value);
    };
    const handleEventMouseXChange = (value)=>{
        setPixelsX(Number(value));
        const newMoveX = Number(value) * (directionX === 'left' ? -1 : 1);
        onChange(withEventUpdate({
            mouseMoveX: newMoveX
        }));
        setMoveX(newMoveX);
    };
    const handleEventMouseYUpDown = (value)=>{
        const newMoveY = moveY * -1;
        onChange(withEventUpdate({
            mouseMoveY: newMoveY
        }));
        setMoveY(newMoveY);
        setDirectionY(value);
    };
    const handleEventMouseYChange = (value)=>{
        setPixelsY(Number(value));
        const newMoveY = Number(value) * (directionY === 'down' ? 1 : -1);
        onChange(withEventUpdate({
            mouseMoveY: newMoveY
        }));
        setMoveY(newMoveY);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$6e2c8f0811a474ce), {
        "data-id": "mouse-move-step",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                        children: t('common:event.mouseMove.moveX')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$Set, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$StyledRadioGroup, {
                                name: `${eventIndex}-horizontal-mouse`,
                                defaultValue: directionX,
                                onChange: (e)=>handleEventMouseXLeftRight(e.target.value),
                                value: directionX,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                        value: "right",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.right')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                        value: "left",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.left')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                disabled: isPreview,
                                type: "number",
                                fullWidth: true,
                                slotProps: {
                                    htmlInput: {
                                        min: 0
                                    }
                                },
                                value: pixelsX,
                                label: t('common:event.mouseMove.numberMoveX'),
                                placeholder: t('common:event.mouseMove.numberMoveX'),
                                onChange: (e)=>handleEventMouseXChange(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                        children: t('common:event.mouseMove.moveY')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$Set, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f9d7c8960dba7b88$var$StyledRadioGroup, {
                                name: `${eventIndex}-vertical-mouse`,
                                defaultValue: directionY,
                                onChange: (e)=>handleEventMouseYUpDown(e.target.value),
                                value: directionY,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                        value: "up",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.up')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                        value: "down",
                                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                            disabled: isPreview
                                        }),
                                        label: t('common:event.directions.down')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                disabled: isPreview,
                                type: "number",
                                label: t('common:event.mouseMove.numberMoveY'),
                                fullWidth: true,
                                slotProps: {
                                    htmlInput: {
                                        min: 0
                                    }
                                },
                                value: pixelsY,
                                placeholder: t('common:event.mouseMove.numberMoveY'),
                                onChange: (e)=>handleEventMouseYChange(e.target.value)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $f9d7c8960dba7b88$var$StyledRadioGroup = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $194e327f1282a3e9$export$2e2bcd8739ae039))($f9d7c8960dba7b88$var$t || ($f9d7c8960dba7b88$var$t = $f9d7c8960dba7b88$var$_`
    margin-bottom: 1rem;
`));
const $f9d7c8960dba7b88$var$Set = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($f9d7c8960dba7b88$var$t1 || ($f9d7c8960dba7b88$var$t1 = $f9d7c8960dba7b88$var$_`
    padding: 0 0.5rem;
`));


let $3546a67590dd0db1$var$_ = (t)=>t, $3546a67590dd0db1$var$t, $3546a67590dd0db1$var$t1, $3546a67590dd0db1$var$t2;
const $3546a67590dd0db1$var$MacroStepEditor = ({ macro: macro, step: step, stepIndex: stepIndex, isPreview: isPreview, onChange: onChange })=>{
    var _step_keys, _step_keys1, _step_keys2;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const profileCustomControls = (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496)((state)=>state.profileCustomControls);
    const defaultLocale = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.defaultLocale);
    const originalProfile = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.originalProfile);
    const availableCustomControls = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.availableCustomControls);
    const locale = defaultLocale;
    const defaultKeyMapping = (0, $9a9874d925dad9cc$export$2f002ae08ac7e997)(locale, originalProfile === null || originalProfile === void 0 ? void 0 : originalProfile.platform);
    const [showStepOptions, setShowStepOptions] = (0, $7fPBF.useState)(false);
    const handleMoveStepUp = (eventIndex)=>{
        if (eventIndex == 0) return;
        const newEvents = [
            ...macro.events
        ];
        const temp = newEvents[eventIndex - 1];
        newEvents[eventIndex - 1] = newEvents[eventIndex];
        newEvents[eventIndex] = temp;
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const computedProfileCustomControls = (availableCustomControls === null || availableCustomControls === void 0 ? void 0 : availableCustomControls.length) ? availableCustomControls : profileCustomControls !== null && profileCustomControls !== void 0 ? profileCustomControls : [];
    const getCustomControlAllowsHold = (controlId)=>{
        const availableCustomControls = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().availableCustomControls;
        const profileCustomControls = (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496).getState().profileCustomControls;
        const controls = (availableCustomControls === null || availableCustomControls === void 0 ? void 0 : availableCustomControls.length) > 0 ? availableCustomControls : profileCustomControls !== null && profileCustomControls !== void 0 ? profileCustomControls : [];
        for (const deviceControls of controls){
            const control = deviceControls.controls.find((c)=>c.id === controlId);
            if (control) return control.allowsHold;
        }
        return false;
    };
    const isDeviceAvailable = (deviceTypeId)=>{
        const availableCustomControls = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().availableCustomControls;
        const profileCustomControls = (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496).getState().profileCustomControls;
        const controls = (availableCustomControls === null || availableCustomControls === void 0 ? void 0 : availableCustomControls.length) > 0 ? availableCustomControls : profileCustomControls !== null && profileCustomControls !== void 0 ? profileCustomControls : [];
        if (!deviceTypeId || controls.length === 0) return true;
        return controls.some((device)=>device.deviceTypeId === deviceTypeId);
    };
    const handleMoveStepDown = (eventIndex)=>{
        if (eventIndex == macro.events.length - 1) return;
        const newEvents = [
            ...macro.events
        ];
        const temp = newEvents[eventIndex + 1];
        newEvents[eventIndex + 1] = newEvents[eventIndex];
        newEvents[eventIndex] = temp;
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleCopyStep = (eventIndex)=>{
        const newEvents = [
            ...macro.events,
            (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro.events[eventIndex])
        ];
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleInsertStep = (eventIndex)=>{
        const newEvents = [
            ...macro.events
        ];
        newEvents.splice(eventIndex + 1, 0, {
            eventType: 'KeyPress',
            keys: [
                ''
            ],
            holdTimeMilliseconds: 0
        });
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleRemoveStep = (eventIndex)=>{
        const newEvents = [
            ...macro.events
        ];
        newEvents.splice(eventIndex, 1);
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleEventFieldTypeChange = (eventIndex, value)=>{
        const newEvents = macro.events.map((event, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                eventType: value
            }) : event);
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleEventHoldChange = (eventIndex, value)=>{
        const newEvents = macro.events.map((event, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                holdTimeMilliseconds: value ? Number(value) : undefined
            }) : event);
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleEventTypeChange = (eventIndex, value)=>{
        const newEvents = macro.events.map((event, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                typedPhrase: value
            }) : event);
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleEventAudioChange = (eventIndex, value)=>{
        const newEvents = macro.events.map((event, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                outputSpeech: value
            }) : event);
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const handleEventDeviceTypeCustomActionIdChange = (eventIndex, event)=>{
        const availableCustomControls = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().availableCustomControls;
        const profileCustomControls = (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496).getState().profileCustomControls;
        if (availableCustomControls || profileCustomControls) {
            var _controls_find;
            const controls = availableCustomControls && availableCustomControls.length > 0 ? availableCustomControls : profileCustomControls ? profileCustomControls : [];
            const deviceTypeId = (_controls_find = controls.find((control)=>control.controls.some((c)=>c.id === event.target.value))) === null || _controls_find === void 0 ? void 0 : _controls_find.deviceTypeId;
            const newEvents = macro.events.map((evt, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, evt), {
                    deviceTypeCustomActionId: event.target.value,
                    deviceTypeId: deviceTypeId
                }) : evt);
            onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
                events: newEvents
            }));
        }
    };
    const handleAddKey = (eventIndex)=>{
        var _macro_events_eventIndex, _macro_events;
        if (macro === null || macro === void 0 ? void 0 : (_macro_events = macro.events) === null || _macro_events === void 0 ? void 0 : (_macro_events_eventIndex = _macro_events[eventIndex]) === null || _macro_events_eventIndex === void 0 ? void 0 : _macro_events_eventIndex.keys) {
            const newEvents = macro.events.map((event, idx)=>idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                    keys: [
                        ...event.keys || [],
                        ''
                    ]
                }) : event);
            onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
                events: newEvents
            }));
        }
    };
    const handleKeyValueChange = (eventIndex, keyIndex, value)=>{
        var _macro_events_eventIndex_keys, _macro_events_eventIndex, _macro_events;
        if (macro.events && macro.events[eventIndex] && macro.events[eventIndex].keys) {
            if (((_macro_events = macro.events) === null || _macro_events === void 0 ? void 0 : (_macro_events_eventIndex = _macro_events[eventIndex]) === null || _macro_events_eventIndex === void 0 ? void 0 : (_macro_events_eventIndex_keys = _macro_events_eventIndex.keys) === null || _macro_events_eventIndex_keys === void 0 ? void 0 : _macro_events_eventIndex_keys[keyIndex]) !== undefined) {
                const newEvents = macro.events.map((event, idx)=>{
                    var _event_keys;
                    return idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                        keys: (_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : _event_keys.map((k, ki)=>ki === keyIndex ? value : k)
                    }) : event;
                });
                onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
                    events: newEvents
                }));
            }
        }
    };
    const handleRemoveKey = (eventIndex, keyIndex)=>{
        var _macro_events_eventIndex, _macro_events;
        if (macro === null || macro === void 0 ? void 0 : (_macro_events = macro.events) === null || _macro_events === void 0 ? void 0 : (_macro_events_eventIndex = _macro_events[eventIndex]) === null || _macro_events_eventIndex === void 0 ? void 0 : _macro_events_eventIndex.keys) {
            const newEvents = macro.events.map((event, idx)=>{
                var _event_keys;
                return idx === eventIndex ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                    keys: (_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : _event_keys.filter((_, ki)=>ki !== keyIndex)
                }) : event;
            });
            onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
                events: newEvents
            }));
        }
    };
    const uuId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const handleKeyPressTypeChange = (eventIndex, value)=>{
        const newEvents = macro.events.map((event, idx)=>{
            if (idx !== eventIndex) return event;
            if (value == 'tap') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                holdTimeMilliseconds: undefined,
                isKeyLatch: false,
                isCustomToggle: false,
                isCustomRelease: false
            });
            else if (value == 'latch') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                holdTimeMilliseconds: undefined,
                isKeyLatch: true,
                isCustomToggle: false,
                isCustomRelease: false
            });
            else if (value == 'hold') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                holdTimeMilliseconds: 1000,
                isKeyLatch: false,
                isCustomToggle: false,
                isCustomRelease: false
            });
            else if (value == 'toggle') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                isKeyLatch: false,
                holdTimeMilliseconds: 0,
                isCustomToggle: true,
                isCustomRelease: false
            });
            else if (value == 'release') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
                isKeyLatch: false,
                holdTimeMilliseconds: 0,
                isCustomToggle: false,
                isCustomRelease: true
            });
            return event;
        });
        onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: newEvents
        }));
    };
    const getKeyPressType = (eventIndex)=>{
        if (macro.events[eventIndex].isCustomToggle) return 'toggle';
        if (macro.events[eventIndex].isCustomRelease) return 'release';
        if (macro.events[eventIndex].isKeyLatch) return 'latch';
        if (macro.events[eventIndex].holdTimeMilliseconds != null) return 'hold';
        return 'tap';
    };
    var _step_holdTimeMilliseconds, _step_holdTimeMilliseconds1;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3546a67590dd0db1$var$StepCard, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                            id: `step-${stepIndex}`,
                            children: t('common:event.stepType')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                            disabled: isPreview,
                            labelId: `step-${stepIndex}`,
                            value: step.eventType,
                            label: t('common:event.stepType'),
                            onChange: (e)=>handleEventFieldTypeChange(stepIndex, e.target.value),
                            children: (0, $03a56fb167cf9474$export$caaa93ee9052213c).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: c.eventType,
                                    children: t(c.displayName)
                                }, c.eventType))
                        })
                    ]
                }),
                step.eventType == 'DeviceTypeCustomAction' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.deviceTypeCustomAction.title')
                        }),
                        !isDeviceAvailable(step.deviceTypeId) && step.deviceTypeId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: t('common:event.deviceTypeCustomAction.title'),
                                    disabled: true,
                                    value: step.deviceTypeCustomActionId || '',
                                    id: 'custom_' + uuId,
                                    slotProps: {
                                        htmlInput: {
                                            readOnly: true
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $0e94917eb8d34aa5$export$2e2bcd8739ae039), {
                                    severity: "info",
                                    children: [
                                        t('common:customControls.noDevice'),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "text",
                                            to: `/devices/new/${step.deviceTypeId}`,
                                            startIcon: "deviceManager",
                                            children: t('common:device.add.action')
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                                    id: 'custom_' + uuId,
                                    children: t('common:event.deviceTypeCustomAction.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                                    labelId: 'custom_' + uuId,
                                    fullWidth: true,
                                    value: step.deviceTypeCustomActionId || '',
                                    label: t('common:event.deviceTypeCustomAction.title'),
                                    onChange: (event)=>{
                                        handleEventDeviceTypeCustomActionIdChange(stepIndex, event);
                                    },
                                    children: computedProfileCustomControls === null || computedProfileCustomControls === void 0 ? void 0 : computedProfileCustomControls.flatMap((d)=>[
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$DeviceSubheader, {
                                                children: d.name
                                            }, d.deviceTypeId),
                                            d.controls.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                                    value: c.id,
                                                    "data-device": d.deviceTypeId,
                                                    children: c.name
                                                }, c.id))
                                        ])
                                })
                            ]
                        }),
                        getCustomControlAllowsHold(step.deviceTypeCustomActionId) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                                    children: t('common:event.keyPress.timing')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
                                    row: true,
                                    name: `${stepIndex}-key-press-type`,
                                    defaultValue: "right",
                                    onChange: (e)=>handleKeyPressTypeChange(stepIndex, e.target.value),
                                    value: getKeyPressType(stepIndex),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "tap",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.tapLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "hold",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.holdLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "latch",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.latchLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "toggle",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.toggleLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "release",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.releaseLong')
                                        })
                                    ]
                                }),
                                getCustomControlAllowsHold(step.deviceTypeCustomActionId) && getKeyPressType(stepIndex) === 'hold' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: t('common:event.hold'),
                                    disabled: isPreview,
                                    type: "number",
                                    value: (_step_holdTimeMilliseconds = step.holdTimeMilliseconds) !== null && _step_holdTimeMilliseconds !== void 0 ? _step_holdTimeMilliseconds : 0,
                                    id: `${stepIndex}hold`,
                                    placeholder: t('common:event.hold'),
                                    onChange: (e)=>handleEventHoldChange(stepIndex, e.target.value)
                                })
                            ]
                        })
                    ]
                }),
                step.eventType == 'KeyPress' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.keyPress.fieldSet')
                        }),
                        (_step_keys = step.keys) === null || _step_keys === void 0 ? void 0 : _step_keys.map((k, ki)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                                                id: 'key_' + uuId + ki,
                                                children: t('common:event.keyPress.label')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                                                labelId: 'key_' + uuId + ki,
                                                value: (0, $9a9874d925dad9cc$export$38eb86f225c9e34c)(k, locale),
                                                label: t('common:event.keyPress.label'),
                                                onChange: (e)=>handleKeyValueChange(stepIndex, ki, e.target.value),
                                                children: defaultKeyMapping.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                                        value: c.key,
                                                        children: c.displayName
                                                    }, c.key))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                        disabled: isPreview,
                                        onClick: ()=>handleRemoveKey(stepIndex, ki),
                                        children: t('common:event.keyPress.remove')
                                    })
                                ]
                            }, uuId + ki)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "text",
                                startIcon: "touchpad",
                                disabled: isPreview,
                                onClick: ()=>handleAddKey(stepIndex),
                                children: t('common:event.keyPress.add')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$d953939534de1974), {
                                    children: t('common:event.keyPress.timing')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
                                    row: true,
                                    name: `${stepIndex}-key-press-type`,
                                    defaultValue: "right",
                                    onChange: (e)=>handleKeyPressTypeChange(stepIndex, e.target.value),
                                    value: getKeyPressType(stepIndex),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "tap",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.tapLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "hold",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.holdLong')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3546a67590dd0db1$var$StyledFormControlLabel, {
                                            value: "latch",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                                                disabled: isPreview
                                            }),
                                            label: t('common:event.keyPress.latchLong')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                step.eventType == 'KeyRelease' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.keyRelease.title')
                        }),
                        (_step_keys1 = step.keys) === null || _step_keys1 === void 0 ? void 0 : _step_keys1.map((k, ki)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                                                id: 'release' + uuId + ki,
                                                children: t('common:event.keyRelease.title')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                                                labelId: 'release' + uuId + ki,
                                                value: (0, $9a9874d925dad9cc$export$38eb86f225c9e34c)(k, locale),
                                                label: t('common:event.keyRelease.title'),
                                                onChange: (e)=>handleKeyValueChange(stepIndex, ki, e.target.value),
                                                children: defaultKeyMapping.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                                        value: c.key,
                                                        children: c.displayName
                                                    }, c.key))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                        disabled: isPreview,
                                        onClick: ()=>handleRemoveKey(stepIndex, ki),
                                        children: t('common:event.keyRelease.remove')
                                    })
                                ]
                            }, uuId + ki)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "text",
                                startIcon: "touchpad",
                                disabled: isPreview,
                                onClick: ()=>handleAddKey(stepIndex),
                                children: t('common:event.keyRelease.add')
                            })
                        })
                    ]
                }),
                step.eventType == 'KeyToggle' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:event.keyToggle.title')
                        }),
                        (_step_keys2 = step.keys) === null || _step_keys2 === void 0 ? void 0 : _step_keys2.map((k, ki)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                                                id: `key-${ki}`,
                                                children: t('common:event.keyToggle.title')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                                                labelId: `key-${ki}`,
                                                value: (0, $9a9874d925dad9cc$export$38eb86f225c9e34c)(k, locale),
                                                label: t('common:event.keyToggle.selected'),
                                                onChange: (e)=>handleKeyValueChange(stepIndex, ki, e.target.value),
                                                children: defaultKeyMapping.map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                                        value: c.key,
                                                        children: c.displayName
                                                    }, c.key))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                        disabled: isPreview,
                                        onClick: ()=>handleRemoveKey(stepIndex, ki),
                                        children: t('common:event.keyToggle.remove')
                                    })
                                ]
                            }, ki)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "text",
                                startIcon: "touchpad",
                                disabled: isPreview,
                                onClick: ()=>handleAddKey(stepIndex),
                                children: t('common:event.keyToggle.add')
                            })
                        })
                    ]
                }),
                step.eventType == 'Type' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        multiline: true,
                        minRows: 3,
                        label: t('common:event.type.field'),
                        disabled: isPreview,
                        type: "text",
                        value: step.typedPhrase,
                        id: uuId,
                        placeholder: t('common:event.type.placeholder'),
                        onChange: (e)=>handleEventTypeChange(stepIndex, e.target.value)
                    })
                }),
                step.eventType == 'PlayAudio' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: t('common:event.playAudio.title'),
                        disabled: isPreview,
                        value: step.outputSpeech,
                        id: uuId,
                        placeholder: t('common:event.playAudio.placeholder'),
                        onChange: (e)=>handleEventAudioChange(stepIndex, e.target.value)
                    })
                }),
                step.eventType == 'StopOutputs' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                        htmlFor: `${stepIndex}speak`,
                        children: t('common:event.stopOutputs.titleLong')
                    })
                }),
                step.eventType == 'JoysticksMove' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd343a4c977deb5d$export$2e2bcd8739ae039), {
                    event: step,
                    eventIndex: stepIndex,
                    macro: macro,
                    isPreview: isPreview,
                    onChange: onChange
                }),
                step.eventType == 'MouseMove' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9d7c8960dba7b88$export$2e2bcd8739ae039), {
                    event: step,
                    eventIndex: stepIndex,
                    macro: macro,
                    isPreview: isPreview,
                    onChange: onChange
                }),
                (0, $03a56fb167cf9474$export$7e8bcaa1250bba4e)(step) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea5892afc276c974$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: t('common:event.hold'),
                            disabled: isPreview,
                            type: "number",
                            value: (_step_holdTimeMilliseconds1 = step.holdTimeMilliseconds) !== null && _step_holdTimeMilliseconds1 !== void 0 ? _step_holdTimeMilliseconds1 : 0,
                            id: `${stepIndex}hold`,
                            placeholder: t('common:event.hold'),
                            onChange: (e)=>handleEventHoldChange(stepIndex, e.target.value)
                        })
                    })
                }),
                showStepOptions ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 32
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            onClick: ()=>setShowStepOptions(false),
                            children: t('common:event.hideOptions')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            startIcon: "moveUp",
                            onClick: ()=>handleMoveStepUp(stepIndex),
                            disabled: stepIndex == 0,
                            children: t('common:event.stepUp')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            startIcon: "moveDown",
                            disabled: isPreview,
                            onClick: ()=>handleMoveStepDown(stepIndex),
                            children: t('common:event.stepDown')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            startIcon: "duplicate",
                            disabled: isPreview,
                            onClick: ()=>handleCopyStep(stepIndex),
                            children: t('common:event.stepCopy')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            startIcon: "insertRow",
                            disabled: isPreview,
                            onClick: ()=>handleInsertStep(stepIndex),
                            children: t('common:event.insertStep')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            startIcon: "delete",
                            disabled: isPreview,
                            onClick: ()=>handleRemoveStep(stepIndex),
                            children: t('common:event.stepRemove')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 8
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "simple",
                        onClick: ()=>setShowStepOptions(true),
                        children: t('common:event.showOptions')
                    })
                })
            ]
        })
    });
};
const $3546a67590dd0db1$var$StyledFormControlLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039))($3546a67590dd0db1$var$t || ($3546a67590dd0db1$var$t = $3546a67590dd0db1$var$_`
    align-self: flex-start;
`));
const $3546a67590dd0db1$var$StepCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $c25995eea3cd5a6e$export$2e2bcd8739ae039))($3546a67590dd0db1$var$t1 || ($3546a67590dd0db1$var$t1 = $3546a67590dd0db1$var$_`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1rem auto;
    gap: 16px;
    padding: 32px 16px;
    width: calc(100% - 32px);
`));
const $3546a67590dd0db1$var$DeviceSubheader = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a35e4d6f9ac473d6))($3546a67590dd0db1$var$t2 || ($3546a67590dd0db1$var$t2 = $3546a67590dd0db1$var$_`
    margin: 1rem 0.5rem;
`)).withComponent('h3');
var $3546a67590dd0db1$export$2e2bcd8739ae039 = $3546a67590dd0db1$var$MacroStepEditor;








var $7fPBF = parcelRequire("7fPBF");


let $8f0c21677a1de5b0$var$_ = (t)=>t, $8f0c21677a1de5b0$var$t, $8f0c21677a1de5b0$var$t1, $8f0c21677a1de5b0$var$t2;
function $8f0c21677a1de5b0$export$2e2bcd8739ae039() {
    var _macro_commands_, _macro_commands, _macro_commands_1, _macro_commands1, _macro_commands_2, _macro_commands2, _macro_commands_3, _macro_commands3, _macro_commands_4, _macro_commands4, _allControls_find, _macro_events;
    const { index: index } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { t: t2 } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.macros);
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const isNew = (index === null || index === void 0 ? void 0 : index.toLowerCase()) == 'new';
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const [macro, setMacro] = (0, $7fPBF.useState)(isNew ? {
        commands: [],
        events: [],
        id: (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)()
    } : macros[Number(index)]);
    const [stage, setStage] = (0, $7fPBF.useState)(0);
    const handleFinish = async ()=>{
        var _macro_commands_filter, _macro_commands_, _macro_commands;
        if (((_macro_commands_filter = macro.commands.filter((c)=>{
            var _c_command;
            return ((_c_command = c.command) === null || _c_command === void 0 ? void 0 : _c_command.length) > 0;
        })) === null || _macro_commands_filter === void 0 ? void 0 : _macro_commands_filter.length) < 1) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t2('common:event.error'));
            return;
        }
        if (macro.events.length < 1) (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t2('common:event.error'));
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        if (macro.commands.some((c)=>c.commandType == 'hotkey')) {
            var _macro_commands_1, _macro_commands1, _macro_commands_2, _macro_commands2, _updatedMacro_commands_, _updatedMacro_commands;
            const originalValue = (_macro_commands1 = macro.commands) === null || _macro_commands1 === void 0 ? void 0 : (_macro_commands_1 = _macro_commands1[0]) === null || _macro_commands_1 === void 0 ? void 0 : _macro_commands_1.command;
            const hotkeyCommand = (_macro_commands2 = macro.commands) === null || _macro_commands2 === void 0 ? void 0 : (_macro_commands_2 = _macro_commands2[0]) === null || _macro_commands_2 === void 0 ? void 0 : _macro_commands_2.command;
            const hotkeyId = editProfileStore.updateHotkeyFromMacro(hotkeyCommand, macro, 0, originalValue);
            const updatedMacro = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
                commands: macro.commands.map((c, i)=>i === 0 ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c), {
                        hotkeyLocalId: hotkeyId !== null && hotkeyId !== void 0 ? hotkeyId : undefined
                    }) : c)
            });
            const macros = [
                ...editProfileStore.macros
            ];
            if (isNew) macros.unshift((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, updatedMacro), {
                name: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)((_updatedMacro_commands = updatedMacro.commands) === null || _updatedMacro_commands === void 0 ? void 0 : (_updatedMacro_commands_ = _updatedMacro_commands[0]) === null || _updatedMacro_commands_ === void 0 ? void 0 : _updatedMacro_commands_.command, t2)
            }));
            else macros[Number(index)] = updatedMacro;
            editProfileStore.updateMacros(macros);
            editProfileStore.setHasChanges(true);
            navigate(-1);
            return;
        }
        const currentMacros = [
            ...editProfileStore.macros
        ];
        if (isNew) currentMacros.unshift((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            name: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command, t2)
        }));
        else currentMacros[Number(index)] = macro;
        // update macros in profile
        editProfileStore.updateMacros(currentMacros);
        editProfileStore.setHasChanges(true);
        navigate(-1);
    };
    const handleAddStep = (eventType)=>{
        setStage(3);
        setMacro((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            events: [
                ...macro.events,
                {
                    eventType: eventType !== null && eventType !== void 0 ? eventType : 'KeyPress',
                    keys: [
                        ''
                    ],
                    holdTimeMilliseconds: undefined
                }
            ]
        }));
    };
    const handleCommandChange = (value, index)=>{
        setMacro((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro), {
            commands: macro.commands.map((c, i)=>i === index ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c), {
                    command: value
                }) : c)
        }));
    };
    const selectCommandType = (commandType)=>{
        if (macro.commands.length < 2) macro.commands = [
            {
                commandType: commandType,
                command: ''
            }
        ];
        else macro.commands.push({
            commandType: commandType,
            command: ''
        });
        setStage(1);
    };
    const goBack = ()=>{
        setStage(stage - 1);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $4f907cce853cc2ff$export$2e2bcd8739ae039), {
            children: [
                stage == 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                            children: [
                                t2('common:input.select'),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t2('common:input.question')
                        }),
                        (0, $f44f3a5bc46b1c4c$export$6c5a93cb3986a928).map((c, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                id: c,
                                $color: "secondary",
                                startIcon: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].icon,
                                onClick: ()=>selectCommandType(c),
                                children: t2((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].title)
                            }, `commandType-${i}`))
                    ]
                }),
                stage == 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[(_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.commandType].icon
                                            }),
                                            t2((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[(_macro_commands1 = macro.commands) === null || _macro_commands1 === void 0 ? void 0 : (_macro_commands_1 = _macro_commands1[0]) === null || _macro_commands_1 === void 0 ? void 0 : _macro_commands_1.commandType].title)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: t2((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[(_macro_commands2 = macro.commands) === null || _macro_commands2 === void 0 ? void 0 : (_macro_commands_2 = _macro_commands2[0]) === null || _macro_commands_2 === void 0 ? void 0 : _macro_commands_2.commandType].question)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00051b104a6506d5$export$43ee9de14381bd97), {
                                        id: "input-command-field",
                                        control: (_macro_commands3 = macro.commands) === null || _macro_commands3 === void 0 ? void 0 : (_macro_commands_3 = _macro_commands3[0]) === null || _macro_commands_3 === void 0 ? void 0 : _macro_commands_3.commandType,
                                        value: (_macro_commands4 = macro.commands) === null || _macro_commands4 === void 0 ? void 0 : (_macro_commands_4 = _macro_commands4[0]) === null || _macro_commands_4 === void 0 ? void 0 : _macro_commands_4.command,
                                        onChange: (e)=>handleCommandChange(e, 0)
                                    }),
                                    (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((e)=>{
                                        var _macro_commands_, _macro_commands;
                                        return e.value == ((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command);
                                    }) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: t2((_allControls_find = (0, $f44f3a5bc46b1c4c$export$48c02457e332140e).find((e)=>{
                                            var _macro_commands_, _macro_commands;
                                            return e.value == ((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command);
                                        })) === null || _allControls_find === void 0 ? void 0 : _allControls_find.description)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                id: "macro-edit-next",
                                onClick: ()=>{
                                    var _macro_commands__command, _macro_commands_, _macro_commands;
                                    if (((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : (_macro_commands__command = _macro_commands_.command) === null || _macro_commands__command === void 0 ? void 0 : _macro_commands__command.length) > 0) setStage(2);
                                },
                                children: t2('common:next')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "simple",
                                onClick: goBack,
                                children: t2('common:back')
                            })
                        ]
                    })
                }),
                stage == 2 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                            children: t2('common:event.select')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t2('common:event.question')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('KeyPress'),
                            children: t2('common:event.keyPress.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('KeyRelease'),
                            children: t2('common:event.keyRelease.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('KeyToggle'),
                            children: t2('common:event.keyToggle.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            id: "event-type",
                            $color: "secondary",
                            onClick: ()=>handleAddStep('Type'),
                            children: t2('common:event.type.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('MouseMove'),
                            children: t2('common:event.mouseMove.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('JoysticksMove'),
                            children: t2('common:event.joystickMove.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('PlayAudio'),
                            children: t2('common:event.playAudio.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('StopOutputs'),
                            children: t2('common:event.stopOutputs.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>handleAddStep('DeviceTypeCustomAction'),
                            children: t2('common:event.deviceTypeCustomAction.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            onClick: ()=>{
                                handleAddStep();
                                handleAddStep();
                            },
                            children: t2('common:event.multiple')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "simple",
                            onClick: goBack,
                            children: t2('common:back')
                        })
                    ]
                }),
                stage == 3 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8f0c21677a1de5b0$var$StyledActionCardWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                                    children: t2('common:event.setup')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: t2('common:event.question')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleFinish(),
                                    children: t2('common:finish')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    $color: "simple",
                                    onClick: goBack,
                                    children: t2('common:back')
                                })
                            ]
                        }),
                        (_macro_events = macro.events) === null || _macro_events === void 0 ? void 0 : _macro_events.map((e, ei)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3546a67590dd0db1$export$2e2bcd8739ae039), {
                                macro: macro,
                                step: e,
                                stepIndex: ei,
                                onChange: (macro)=>setMacro(macro)
                            }, ei)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            className: (0, $d77565acc82ac668$export$dbf350e5966cf602)($8f0c21677a1de5b0$var$t || ($8f0c21677a1de5b0$var$t = $8f0c21677a1de5b0$var$_`
                                margin: 16px;
                                width: calc(100% - 32px);
                            `)),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "text",
                                startIcon: "plus",
                                disabled: isPreview,
                                onClick: ()=>handleAddStep(),
                                children: t2('common:event.add')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            className: (0, $d77565acc82ac668$export$dbf350e5966cf602)($8f0c21677a1de5b0$var$t1 || ($8f0c21677a1de5b0$var$t1 = $8f0c21677a1de5b0$var$_`
                                margin: 16px;
                                width: calc(100% - 32px);
                            `)),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                id: "finish-macro-edit",
                                onClick: ()=>handleFinish(),
                                children: t2('common:finish')
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $8f0c21677a1de5b0$var$StyledActionCardWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $30f62651b17206ee$export$2e2bcd8739ae039))($8f0c21677a1de5b0$var$t2 || ($8f0c21677a1de5b0$var$t2 = $8f0c21677a1de5b0$var$_`
    margin: 16px;
    width: calc(100% - 32px);
`));









let $fcaddb9c30332041$var$_ = (t)=>t, $fcaddb9c30332041$var$t, $fcaddb9c30332041$var$t1, $fcaddb9c30332041$var$t2, $fcaddb9c30332041$var$t3, $fcaddb9c30332041$var$t4, $fcaddb9c30332041$var$t5, $fcaddb9c30332041$var$t6, $fcaddb9c30332041$var$t7;
const $fcaddb9c30332041$export$a14e0b54e46f6871 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fcaddb9c30332041$var$t || ($fcaddb9c30332041$var$t = $fcaddb9c30332041$var$_`
    height: calc(100dvh - ${0}px);
    display: flex;
    flex: 1;
    flex-direction: column;
`), (props)=>props.$offset ? props.$offset : 0);
const $fcaddb9c30332041$export$d6b9c1bba5ee845 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fcaddb9c30332041$var$t1 || ($fcaddb9c30332041$var$t1 = $fcaddb9c30332041$var$_`
    flex-shrink: 0; /* Prevent shrinking */
    width: 100%;
`));
const $fcaddb9c30332041$export$2264cf7efee465f9 = (0, $8de346382d86c747$export$2e2bcd8739ae039).main($fcaddb9c30332041$var$t2 || ($fcaddb9c30332041$var$t2 = $fcaddb9c30332041$var$_`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    flex: 1;
    &[data-managed='true'] {
        border-left: 10px solid ${0};
    }
`), (props)=>props.theme.color.indicator);
const $fcaddb9c30332041$export$5b061f6699ff1c06 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fcaddb9c30332041$var$t3 || ($fcaddb9c30332041$var$t3 = $fcaddb9c30332041$var$_`
    flex: 1;
    display: flex;
    overflow: hidden;
    overflow-y: auto;
    scrollbar-color: ${0} ${0};
    scrollbar-width: thin;
`), (props)=>props.theme.color.accent, (props)=>props.theme.color.cardHover);
const $fcaddb9c30332041$export$de401b45f203ff7f = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')($fcaddb9c30332041$var$t4 || ($fcaddb9c30332041$var$t4 = $fcaddb9c30332041$var$_`
    background-color: ${0};
    position: sticky;
    bottom: 0;
    padding: 1rem 0;
    display: flex;
    justify-content: ${0};

    ${0}
`), ({ theme: theme })=>theme.color.background, ({ contentPosition: contentPosition })=>contentPosition || 'flex-end', ({ $visuallyHide: $visuallyHide })=>$visuallyHide && (0, $19e0bc52fddd02b4$export$15b02e474f045d64));
const $fcaddb9c30332041$export$7df9baccf69a86b2 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($fcaddb9c30332041$export$de401b45f203ff7f)($fcaddb9c30332041$var$t5 || ($fcaddb9c30332041$var$t5 = $fcaddb9c30332041$var$_`
    flex: 1;
    width: 100%;
`));
const $fcaddb9c30332041$export$6ce170286acaa8d3 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fcaddb9c30332041$var$t6 || ($fcaddb9c30332041$var$t6 = $fcaddb9c30332041$var$_`
    padding: 1rem 1rem 2rem 1rem;
`));
const $fcaddb9c30332041$export$ef8a3f74a07f9d23 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($fcaddb9c30332041$var$t7 || ($fcaddb9c30332041$var$t7 = $fcaddb9c30332041$var$_`
    flex: 1;
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
    position: relative;

    .interaction-blocker {
        position: absolute;
        inset: 0;
        z-index: 1;
        background: transparent;
        cursor: not-allowed;
    }
`));





/** NOTE: not included in ControlTypeField */ function $368a38ffb0c2a5b2$var$DictationControlField({ value: value, onChange: onChange, disabled: disabled }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        disabled: disabled,
        fullWidth: true,
        value: value,
        label: t('common:dictation.title'),
        placeholder: t('common:dictation.question'),
        onChange: (e)=>onChange(e.target.value)
    });
}
var $368a38ffb0c2a5b2$export$2e2bcd8739ae039 = $368a38ffb0c2a5b2$var$DictationControlField;






var $7fPBF = parcelRequire("7fPBF");

function $c3060ab743a09b93$export$3bd2a898ef2fa88e({ shouldBlock: shouldBlock, onConfirm: onConfirm }) {
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const blocker = (0, $39c9549f68558626$export$b273b3273281a049)(shouldBlock);
    const blockerRef = (0, $7fPBF.useRef)(blocker);
    blockerRef.current = blocker;
    const pendingLocationRef = (0, $7fPBF.useRef)(null);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (blocker.state === 'blocked') {
            const destination = blocker.location.pathname;
            if (destination.includes(location.pathname)) {
                var // If the destination is a deeper route of the current path, allow navigation without blocking
                _blocker_proceed;
                (_blocker_proceed = blocker.proceed) === null || _blocker_proceed === void 0 ? void 0 : _blocker_proceed.call(blocker);
                return;
            }
            console.log('Navigation attempt to:', destination);
            pendingLocationRef.current = destination;
            setOpen(true);
        }
    }, [
        blocker,
        location
    ]);
    return {
        openDialog: open,
        handleConfirm: async ()=>{
            const pendingLocation = pendingLocationRef.current;
            pendingLocationRef.current = null;
            await onConfirm();
            setOpen(false);
            // Never call proceed() after an async operation — the router's internal
            // state may have already transitioned. Navigate manually instead.
            if (pendingLocation) navigate(pendingLocation);
        },
        handleCancel: ()=>{
            var _blockerRef_current_reset, _blockerRef_current;
            (_blockerRef_current_reset = (_blockerRef_current = blockerRef.current).reset) === null || _blockerRef_current_reset === void 0 ? void 0 : _blockerRef_current_reset.call(_blockerRef_current);
            pendingLocationRef.current = null;
            setOpen(false);
        },
        handleContinue: ()=>{
            var _blockerRef_current_proceed, _blockerRef_current;
            if (blockerRef.current.state === 'blocked') (_blockerRef_current_proceed = (_blockerRef_current = blockerRef.current).proceed) === null || _blockerRef_current_proceed === void 0 ? void 0 : _blockerRef_current_proceed.call(_blockerRef_current);
            else if (pendingLocationRef.current) navigate(pendingLocationRef.current);
            pendingLocationRef.current = null;
            setOpen(false);
        }
    };
}




function $258cb68b976e3a51$export$2e2bcd8739ae039(_param) {
    var { hasChanges: hasChanges, setHasChanges: setHasChanges, onSave: onSave, title: title, description: description, confirmButtonText: confirmButtonText, cancelButtonText: cancelButtonText } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "hasChanges",
        "setHasChanges",
        "onSave",
        "title",
        "description",
        "confirmButtonText",
        "cancelButtonText"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { openDialog: openDialog, handleConfirm: handleConfirm, handleCancel: handleCancel, handleContinue: handleContinue } = (0, $c3060ab743a09b93$export$3bd2a898ef2fa88e)({
        shouldBlock: hasChanges,
        onConfirm: onSave
    });
    const handleContinueWithState = async ()=>{
        await handleContinue();
        setHasChanges(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        open: openDialog,
        title: title !== null && title !== void 0 ? title : t('common:unsaved.title'),
        description: description !== null && description !== void 0 ? description : t('common:unsaved.description'),
        confirmButtonText: confirmButtonText !== null && confirmButtonText !== void 0 ? confirmButtonText : t('common:unsaved.confirm'),
        cancelButtonText: cancelButtonText !== null && cancelButtonText !== void 0 ? cancelButtonText : t('common:unsaved.cancel'),
        onConfirm: handleConfirm,
        onCancel: handleContinueWithState,
        onClose: handleCancel
    }, restProps));
}




var $7fPBF = parcelRequire("7fPBF");


let $013893ecb4f625ea$var$_ = (t)=>t, $013893ecb4f625ea$var$t;
function $013893ecb4f625ea$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const initialDictationCommands = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.dictationCommands);
    const hasChanges = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hasChanges);
    const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.id);
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const [dictationCommands, setDictationCommands] = (0, $7fPBF.useState)(initialDictationCommands || []);
    (0, $7fPBF.useEffect)(()=>{
        if (initialDictationCommands) setDictationCommands([
            ...initialDictationCommands
        ]);
    }, [
        initialDictationCommands
    ]);
    const handleCommandChange = (value, index)=>{
        dictationCommands[index] = value;
        setDictationCommands([
            ...dictationCommands
        ]);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
    };
    const handleRemoveDictationCommand = (index)=>{
        dictationCommands.splice(index, 1);
        setDictationCommands([
            ...dictationCommands
        ]);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
    };
    const handleAddDictationCommand = ()=>{
        dictationCommands.unshift('');
        setDictationCommands([
            ...dictationCommands
        ]);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
    };
    const handleSave = async ()=>{
        const filteredCommands = dictationCommands.filter((command)=>command.length > 0);
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        editProfileStore.updateDictationCommands(filteredCommands);
        if (organizationId) editProfileStore.setOrganizationId(organizationId);
        await editProfileStore.saveChanges();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($013893ecb4f625ea$var$AddHeaderContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "solidAccent",
                    $dashed: true,
                    startIcon: "plus",
                    onClick: ()=>handleAddDictationCommand(),
                    children: t('common:dictation.add')
                })
            }),
            dictationCommands === null || dictationCommands === void 0 ? void 0 : dictationCommands.map((h, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $368a38ffb0c2a5b2$export$2e2bcd8739ae039), {
                            value: h,
                            onChange: (e)=>handleCommandChange(e, i),
                            disabled: isPreview
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                            disabled: isPreview,
                            onClick: ()=>handleRemoveDictationCommand(i),
                            children: t('common:dictation.remove')
                        })
                    ]
                }, i)),
            hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: hasChanges,
                setHasChanges: (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges,
                onSave: handleSave
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !hasChanges && id !== undefined,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: handleSave,
                    children: t('common:saveAndFinish')
                })
            })
        ]
    });
}
const $013893ecb4f625ea$var$AddHeaderContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($013893ecb4f625ea$var$t || ($013893ecb4f625ea$var$t = $013893ecb4f625ea$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    > * {
        margin: 0.25rem;
    }
`));














let $2a7f35c066805bff$var$_ = (t)=>t, $2a7f35c066805bff$var$t, $2a7f35c066805bff$var$t1, $2a7f35c066805bff$var$t2, $2a7f35c066805bff$var$t3, $2a7f35c066805bff$var$t4, $2a7f35c066805bff$var$t5, $2a7f35c066805bff$var$t6, $2a7f35c066805bff$var$t7;
function $2a7f35c066805bff$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const hotkeys = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hotkeys);
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const hasChanges = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hasChanges);
    const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.id);
    const originatedByProfileId = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.originatedByProfileId);
    const moveHotkeyUp = (hotkey)=>{
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        const currentHotkeys = editProfileStore.hotkeys;
        const index = currentHotkeys.indexOf(hotkey);
        if (index == 0) return;
        const temp = currentHotkeys[index - 1];
        currentHotkeys[index - 1] = currentHotkeys[index];
        currentHotkeys[index] = temp;
        editProfileStore.updateHotkeys([
            ...currentHotkeys
        ]);
        editProfileStore.setHasChanges(true);
    };
    const moveHotkeyDown = (hotkey)=>{
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        const currentHotkeys = editProfileStore.hotkeys;
        const index = currentHotkeys.indexOf(hotkey);
        if (index == currentHotkeys.length - 1) return;
        const temp = currentHotkeys[index + 1];
        currentHotkeys[index + 1] = currentHotkeys[index];
        currentHotkeys[index] = temp;
        editProfileStore.updateHotkeys([
            ...currentHotkeys
        ]);
        editProfileStore.setHasChanges(true);
    };
    const handleSave = async ()=>{
        const result = await (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().saveChanges();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (hotkeys === null || hotkeys === void 0 ? void 0 : hotkeys.length) > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$HotkeyWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$StyledSubtitleText, {
                        children: t('common:hotkey.reorder')
                    }),
                    hotkeys === null || hotkeys === void 0 ? void 0 : hotkeys.map((h, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$Card, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$Content, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                            name: "virtualButton",
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                            children: h.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2a7f35c066805bff$var$ButtonsContainer, {
                                    children: [
                                        i > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$StyledButton, {
                                            $color: "simple",
                                            $size: "small",
                                            disabled: isPreview,
                                            onClick: ()=>moveHotkeyUp(h),
                                            startIcon: "moveUp",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                                                children: t('common:event.options.moveUp')
                                            })
                                        }),
                                        i < hotkeys.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$StyledButton, {
                                            $color: "simple",
                                            $size: "small",
                                            disabled: isPreview,
                                            onClick: ()=>moveHotkeyDown(h),
                                            startIcon: "moveDown",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                                                children: t('common:event.options.moveDown')
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i))
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$HotkeyWrapper, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2a7f35c066805bff$var$Message, {
                    children: t('common:hotkey.empty')
                })
            }),
            hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: hasChanges,
                setHasChanges: (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges,
                onSave: handleSave
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !hasChanges || id !== undefined && originatedByProfileId !== undefined,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: handleSave,
                    children: t('common:saveAndFinish')
                })
            })
        ]
    });
}
const $2a7f35c066805bff$var$Message = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2a7f35c066805bff$var$t || ($2a7f35c066805bff$var$t = $2a7f35c066805bff$var$_`
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`));
const $2a7f35c066805bff$var$HotkeyWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2a7f35c066805bff$var$t1 || ($2a7f35c066805bff$var$t1 = $2a7f35c066805bff$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin: 1rem;
`));
const $2a7f35c066805bff$var$StyledButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))($2a7f35c066805bff$var$t2 || ($2a7f35c066805bff$var$t2 = $2a7f35c066805bff$var$_`
    gap: 0;
`));
const $2a7f35c066805bff$var$Card = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$eeffb7d514a37123))($2a7f35c066805bff$var$t3 || ($2a7f35c066805bff$var$t3 = $2a7f35c066805bff$var$_`
    padding: 0.5rem;
    width: 45%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-grow: 1;
    justify-content: space-between;

    border: 1px solid ${0};
    background: ${0};
    &:last-child:nth-of-type(odd) {
        width: 90%;
        height: 100px;
    }
`), (props)=>props.theme.color.neutral, (props)=>props.theme.color.accentCard);
const $2a7f35c066805bff$var$ButtonsContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2a7f35c066805bff$var$t4 || ($2a7f35c066805bff$var$t4 = $2a7f35c066805bff$var$_`
    align-self: center;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.25rem;
`));
const $2a7f35c066805bff$var$Content = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2a7f35c066805bff$var$t5 || ($2a7f35c066805bff$var$t5 = $2a7f35c066805bff$var$_`
    flex: 1;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
`));
const $2a7f35c066805bff$var$StyledSubtitleText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$45814810f7000d9e))($2a7f35c066805bff$var$t6 || ($2a7f35c066805bff$var$t6 = $2a7f35c066805bff$var$_`
    padding: 1rem 0;
    width: 100%;
`));
const $2a7f35c066805bff$export$7e45b7e9a9d29a91 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2a7f35c066805bff$var$t7 || ($2a7f35c066805bff$var$t7 = $2a7f35c066805bff$var$_`
    border: solid 1px ${0}40;
    border-radius: 10px;
    margin: -2rem 0 1rem 0;
    padding: 1rem;
    width: 100%;
    > * {
        max-width: calc(100% - 2rem);
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark);












var $7fPBF = parcelRequire("7fPBF");

let $67d08281aa8666ad$var$_ = (t)=>t, $67d08281aa8666ad$var$t, $67d08281aa8666ad$var$t1, $67d08281aa8666ad$var$t2, $67d08281aa8666ad$var$t3, $67d08281aa8666ad$var$t4, $67d08281aa8666ad$var$t5, $67d08281aa8666ad$var$t6;
const $67d08281aa8666ad$var$ExpanderCard = ({ title: title, startExpanded: startExpanded, children: children, leftIcons: leftIcons, id: id, rightComponent: rightComponent })=>{
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(startExpanded);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($67d08281aa8666ad$var$MarginWrapper, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$WrapperButton, {
                id: id,
                onClick: ()=>setIsExpanded(!isExpanded),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($67d08281aa8666ad$export$2061af696e09df60, {
                    "data-expanded": isExpanded,
                    children: [
                        leftIcons && leftIcons.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$IconContainer, {
                            children: leftIcons === null || leftIcons === void 0 ? void 0 : leftIcons.map((icon, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
                                    title: icon.tooltip,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$CardIcon, {
                                        src: icon.src,
                                        alt: icon.alt
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$export$f4ebac71945699fe, {
                            children: title
                        }),
                        rightComponent && rightComponent()
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($67d08281aa8666ad$var$ExpandedSection, {
                children: children
            })
        ]
    });
};
const $67d08281aa8666ad$var$MarginWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($67d08281aa8666ad$var$t || ($67d08281aa8666ad$var$t = $67d08281aa8666ad$var$_`
    margin-bottom: 16px;
`));
const $67d08281aa8666ad$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($67d08281aa8666ad$var$t1 || ($67d08281aa8666ad$var$t1 = $67d08281aa8666ad$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-right: auto;
    margin-left: 16px;
    position: absolute;
    left: 16px;
`));
const $67d08281aa8666ad$var$CardIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039).img($67d08281aa8666ad$var$t2 || ($67d08281aa8666ad$var$t2 = $67d08281aa8666ad$var$_`
    width: 32px;
    height: 32px;
    margin-right: 8px;
`));
const $67d08281aa8666ad$var$WrapperButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($67d08281aa8666ad$var$t3 || ($67d08281aa8666ad$var$t3 = $67d08281aa8666ad$var$_`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    width: 100%;
    position: relative;
`));
const $67d08281aa8666ad$var$ExpandedSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($67d08281aa8666ad$var$t4 || ($67d08281aa8666ad$var$t4 = $67d08281aa8666ad$var$_`
    background-color: ${0};
    animation: float 0.25s ease-in-out;
    margin: 0 16px 32px 16px;
    padding: 1rem 1rem 2rem 1rem;
    border-radius: 0 0 10px 10px;
    @keyframes float {
        0% {
            opacity: 0;
            transform: translatey(0px);
        }
        100% {
            transform: translatey(0px);
            opacity: 1;
        }
    }
    @keyframes fade {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`), (props)=>props.theme.color.accentCard);
const $67d08281aa8666ad$export$f4ebac71945699fe = (0, $8de346382d86c747$export$2e2bcd8739ae039).h3($67d08281aa8666ad$var$t5 || ($67d08281aa8666ad$var$t5 = $67d08281aa8666ad$var$_`
    font-size: ${0};
    font-weight: lighter;
    color: ${0};
    margin: 0 88px;
    flex: 1;
`), (0, $8951886a6b49e92a$export$7536ca5ba8ef94f0).card_title, (props)=>props.theme.color.text);
const $67d08281aa8666ad$export$2061af696e09df60 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$e0b30d1797fa97ad))($67d08281aa8666ad$var$t6 || ($67d08281aa8666ad$var$t6 = $67d08281aa8666ad$var$_`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    cursor: pointer;
    width: calc(100% - 32px);
    min-width: 380px;
    padding: 16px;
    margin: 0 16px;
    background-color: ${0};
    color: ${0};
    &[data-expanded='true'] {
        box-shadow: none;
        border: 1px solid ${0}40;
        border-radius: 10px 10px 0 0;
        border-bottom: none;
    }
`), (props)=>props.theme.color.accentCard, (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary, (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark);
var $67d08281aa8666ad$export$2e2bcd8739ae039 = $67d08281aa8666ad$var$ExpanderCard;











parcelRequire("7fPBF");


const $0cb68ea454bd64de$var$CommandField = ({ value: value, onChange: onChange, onRemove: onRemove, commandType: commandType, startIcon: startIcon, disabled: disabled })=>{
    var _commandTypesDisplay_commandType;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fallbackIcon = startIcon || ((_commandTypesDisplay_commandType = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[commandType]) === null || _commandTypesDisplay_commandType === void 0 ? void 0 : _commandTypesDisplay_commandType.icon);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
        children: [
            fallbackIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                size: 42,
                name: fallbackIcon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00051b104a6506d5$export$43ee9de14381bd97), {
                control: commandType,
                value: value,
                onChange: onChange,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                onClick: onRemove,
                children: t('common:input.remove')
            })
        ]
    });
};
var $0cb68ea454bd64de$export$2e2bcd8739ae039 = $0cb68ea454bd64de$var$CommandField;







var $7fPBF = parcelRequire("7fPBF");










function $db4609e9b7aaab06$export$5682c366c0c669d9(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiListItem', slot);
}
const $db4609e9b7aaab06$var$listItemClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiListItem', [
    'root',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $db4609e9b7aaab06$export$2e2bcd8739ae039 = $db4609e9b7aaab06$var$listItemClasses;




function $0e30f0544d748ea6$export$c09531d8563c67a5(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiListItemButton', slot);
}
const $0e30f0544d748ea6$var$listItemButtonClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $0e30f0544d748ea6$export$2e2bcd8739ae039 = $0e30f0544d748ea6$var$listItemButtonClasses;






var $7fPBF = parcelRequire("7fPBF");








function $b1787665b55e7eda$export$ccdb26aeba48a86e(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', slot);
}
const $b1787665b55e7eda$var$listItemSecondaryActionClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $b1787665b55e7eda$export$2e2bcd8739ae039 = $b1787665b55e7eda$var$listItemSecondaryActionClasses;



'use client';
const $c22aa9835de7337e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $b1787665b55e7eda$export$ccdb26aeba48a86e), classes);
};
const $c22aa9835de7337e$var$ListItemSecondaryActionRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $c22aa9835de7337e$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, component: component } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "component"
    ]);
    const context = $7fPBF.useContext((0, $060e19b7623095b4$export$2e2bcd8739ae039));
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disableGutters: context.disableGutters
    });
    const classes = $c22aa9835de7337e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c22aa9835de7337e$var$ListItemSecondaryActionRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$c22aa9835de7337e$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $c22aa9835de7337e$export$2e2bcd8739ae039 = $c22aa9835de7337e$var$ListItemSecondaryAction;




'use client';
const $b8e2be557d769e87$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding
    ];
};
const $b8e2be557d769e87$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ],
        secondaryAction: [
            'secondaryAction'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $db4609e9b7aaab06$export$5682c366c0c669d9), classes);
};
const $b8e2be557d769e87$export$aed538f7519abe89 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $b8e2be557d769e87$export$4334bb34c76fef24
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $0e30f0544d748ea6$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'background-color', {
                    duration: theme.transitions.duration.shortest
                })), {
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                })
            }
        ]
    })));
const $b8e2be557d769e87$var$StyledListItemSecondaryAction = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c22aa9835de7337e$export$2e2bcd8739ae039), {
    name: 'MuiListItem',
    slot: 'secondaryAction'
})({});
const $b8e2be557d769e87$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp = 'li', dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "alignItems",
        "children",
        "className",
        "component",
        "dense",
        "disableGutters",
        "disablePadding",
        "divider",
        "secondaryAction",
        "slotProps",
        "slots"
    ]);
    const context = $7fPBF.useContext((0, $060e19b7623095b4$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        secondaryAction: secondaryAction
    });
    const classes = $b8e2be557d769e87$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $b8e2be557d769e87$export$aed538f7519abe89,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            component: componentProp
        }, externalForwardedProps, other),
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [SecondaryActionSlot, secondaryActionSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('secondaryAction', {
        elementType: $b8e2be557d769e87$var$StyledListItemSecondaryAction,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.secondaryAction
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $060e19b7623095b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
            children: [
                childrenProp,
                secondaryAction && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SecondaryActionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, secondaryActionSlotProps), {
                    children: secondaryAction
                }))
            ]
        }))
    });
});
var $b8e2be557d769e87$export$2e2bcd8739ae039 = $b8e2be557d769e87$var$ListItem;





var $7fPBF = parcelRequire("7fPBF");














'use client';
const $cac4ee654e1261f3$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $cac4ee654e1261f3$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $0e30f0544d748ea6$export$c09531d8563c67a5), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $cac4ee654e1261f3$var$ListItemButtonRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $cac4ee654e1261f3$export$4334bb34c76fef24
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'background-color', {
        duration: theme.transitions.duration.shortest
    })), {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $0e30f0544d748ea6$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $0e30f0544d748ea6$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $0e30f0544d748ea6$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $0e30f0544d748ea6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0e30f0544d748ea6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $cac4ee654e1261f3$var$ListItemButton = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "alignItems",
        "autoFocus",
        "component",
        "children",
        "dense",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected",
        "className"
    ]);
    const context = $7fPBF.useContext((0, $060e19b7623095b4$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $cac4ee654e1261f3$var$useUtilityClasses(ownerState);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root } = classes, forwardedClasses = (0, $8901fc92b5563702$export$71511d61b312f219)(classes, [
        "root"
    ]);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $060e19b7623095b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cac4ee654e1261f3$var$ListItemButtonRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            internalNativeButton: false,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other), {
            classes: forwardedClasses,
            children: children
        }))
    });
});
var $cac4ee654e1261f3$export$2e2bcd8739ae039 = $cac4ee654e1261f3$var$ListItemButton;





var $7fPBF = parcelRequire("7fPBF");










'use client';
const $f3de860d0682ac5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8c4009b72c82a55b$export$1061006a0db3aeb5), classes);
};
const $f3de860d0682ac5a$var$ListItemTextRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8c4009b72c82a55b$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $8c4009b72c82a55b$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    // Combine this and the below selector once https://github.com/emotion-js/emotion/issues/3366 is solved
    [`.${(0, $ea02e131f61770cc$export$2e2bcd8739ae039).root}:where(& .${(0, $8c4009b72c82a55b$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $ea02e131f61770cc$export$2e2bcd8739ae039).root}:where(& .${(0, $8c4009b72c82a55b$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $f3de860d0682ac5a$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, secondary: secondaryProp, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "secondary",
        "slots",
        "slotProps"
    ]);
    const { dense: dense } = $7fPBF.useContext((0, $060e19b7623095b4$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $f3de860d0682ac5a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $f3de860d0682ac5a$var$ListItemTextRoot,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $f577398c4e8dc99c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $f577398c4e8dc99c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $f577398c4e8dc99c$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PrimarySlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        variant: dense ? 'body2' : 'body1',
        component: (primarySlotProps === null || primarySlotProps === void 0 ? void 0 : primarySlotProps.variant) ? undefined : 'span'
    }, primarySlotProps), {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $f577398c4e8dc99c$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SecondarySlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        variant: "body2",
        color: "textSecondary"
    }, secondarySlotProps), {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        children: [
            primary,
            secondary
        ]
    }));
});
var $f3de860d0682ac5a$export$2e2bcd8739ae039 = $f3de860d0682ac5a$var$ListItemText;



parcelRequire("7fPBF");



let $4321e97835f672ea$var$_ = (t)=>t, $4321e97835f672ea$var$t;
const $4321e97835f672ea$var$CommandPickerDialog = ({ open: open, onClose: onClose, onCommandTypeSelected: onCommandTypeSelected })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // write a function to check if the commandType is 'tilt' or 'hotkey' and return true or false
    const isMobileOnly = (commandType)=>{
        return commandType === 'tilt';
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $29f821306e66414b$export$2e2bcd8739ae039), {
            open: open,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6e7ef7bd2d21dbc0$export$2e2bcd8739ae039), {
                    children: t('common:input.typeLabel')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $13e3cdc57dc522c3$export$2e2bcd8739ae039), {
                    children: (0, $f44f3a5bc46b1c4c$export$6c5a93cb3986a928).map((c, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8e2be557d769e87$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cac4ee654e1261f3$export$2e2bcd8739ae039), {
                                onClick: ()=>onCommandTypeSelected(c),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4321e97835f672ea$var$StyledIcons, {
                                        size: 35,
                                        name: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].icon
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3de860d0682ac5a$export$2e2bcd8739ae039), {
                                        children: t((0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c].title)
                                    }),
                                    isMobileOnly(c) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$86956144d6970eff), {
                                        children: t('common:mobileApp.title')
                                    })
                                ]
                            })
                        }, `commandtype-${i}`))
                })
            ]
        })
    });
};
const $4321e97835f672ea$var$StyledIcons = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))($4321e97835f672ea$var$t || ($4321e97835f672ea$var$t = $4321e97835f672ea$var$_`
    padding-right: 5px;
`));
var $4321e97835f672ea$export$2e2bcd8739ae039 = $4321e97835f672ea$var$CommandPickerDialog;





function $1bf2d9e347e3226e$export$8e8496b12e2bee1f(id, options) {
    const { settleMs: settleMs = 0, block: block = 'start', focusId: focusId, maxAttempts: maxAttempts = 60, onReveal: onReveal } = options !== null && options !== void 0 ? options : {};
    const reveal = (element)=>{
        element.scrollIntoView({
            behavior: 'smooth',
            block: block
        });
        const focusTarget = focusId ? document.getElementById(focusId) : element;
        focusTarget === null || focusTarget === void 0 ? void 0 : focusTarget.focus({
            preventScroll: true
        });
        onReveal === null || onReveal === void 0 ? void 0 : onReveal(element);
    };
    let attempts = 0;
    const tick = ()=>{
        const element = document.getElementById(id);
        if (element) {
            if (settleMs > 0) setTimeout(()=>reveal(element), settleMs);
            else reveal(element);
        } else if (attempts < maxAttempts) {
            attempts++;
            requestAnimationFrame(tick);
        }
    };
    requestAnimationFrame(tick);
}



var $7fPBF = parcelRequire("7fPBF");

function $c449c760a7ee086f$export$29bdea29542a2205() {
    const [searchParams, setSearchParams] = (0, $f232cebbf1b70e96$export$f1a78c17382fe22a)();
    (0, $7fPBF.useEffect)(()=>{
        const id = searchParams.get('scrollToId');
        if (!id) return;
        (0, $1bf2d9e347e3226e$export$8e8496b12e2bee1f)(id, {
            // Allow a few seconds for the target to mount on slower routes.
            maxAttempts: 180,
            onReveal: ()=>{
                // Remove `scrollToId` from the URL without adding a history entry.
                setSearchParams((prevParams)=>{
                    const newParams = new URLSearchParams(prevParams);
                    newParams.delete('scrollToId');
                    return newParams;
                }, {
                    replace: true
                });
            }
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    return null;
}



var $7fPBF = parcelRequire("7fPBF");

function $48f7f3d9d01bd5f7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    (0, $c449c760a7ee086f$export$29bdea29542a2205)();
    const [keyToAddCommand, setKeyToAddCommand] = (0, $7fPBF.useState)();
    const [isResetConfirmationOpen, setIsResetConfirmationOpen] = (0, $7fPBF.useState)(false);
    const [resetOption, setResetOption] = (0, $7fPBF.useState)('default');
    const commandKeyMappings = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.commandKeyMappings);
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const hasChanges = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hasChanges);
    const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.id);
    const { saveChanges: saveChanges, setHasChanges: setHasChanges, updateCommandKeyMappings: updateCommandKeyMappings } = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
    const handleCommandChange = (value, keybind, index)=>{
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        const updatedMappings = editProfileStore.commandKeyMappings.map((k)=>{
            if (k.key !== keybind.key) return k;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
                commands: k.commands.map((c, i)=>i === index ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c), {
                        command: value
                    }) : c)
            });
        });
        setHasChanges(true);
        updateCommandKeyMappings(updatedMappings);
    };
    const handleRemoveCommand = (command, keybind, index)=>{
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        const updatedMappings = editProfileStore.commandKeyMappings.map((k)=>{
            if (k.key !== keybind.key) return k;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
                commands: k.commands.filter((_, i)=>i !== index)
            });
        });
        editProfileStore.setHasChanges(true);
        editProfileStore.updateCommandKeyMappings(updatedMappings);
    };
    const handleAddCommand = (keybind)=>{
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        setKeyToAddCommand(keybind);
    };
    const handleAddCommandWithType = (keybind, commandType)=>{
        setKeyToAddCommand(undefined);
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        editProfileStore.setHasChanges(true);
        const updatedMappings = editProfileStore.commandKeyMappings.map((k)=>{
            if (k.key !== keybind.key) return k;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, k), {
                commands: [
                    ...k.commands,
                    {
                        command: '',
                        commandType: commandType
                    }
                ]
            });
        });
        editProfileStore.updateCommandKeyMappings(updatedMappings);
    };
    const handleSave = async ()=>{
        const result = await (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().saveChanges();
    };
    const handleReset = ()=>{
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        if (resetOption === 'default') editProfileStore.resetKeybindingsToDefault();
        else editProfileStore.resetKeybindingsToEmpty();
        setIsResetConfirmationOpen(false);
        setResetOption('default');
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "text",
                    startIcon: "repeat",
                    disabled: isPreview,
                    onClick: ()=>{
                        setResetOption('default');
                        setIsResetConfirmationOpen(true);
                    },
                    children: t('common:keys.reset.title')
                })
            }),
            commandKeyMappings === null || commandKeyMappings === void 0 ? void 0 : commandKeyMappings.map((k, i)=>{
                var _k_commands;
                var _k_displayName;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $67d08281aa8666ad$export$2e2bcd8739ae039), {
                    title: (_k_displayName = k.displayName) !== null && _k_displayName !== void 0 ? _k_displayName : k.key,
                    id: k.key,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            children: t('common:macros.title')
                        }),
                        (_k_commands = k.commands) === null || _k_commands === void 0 ? void 0 : _k_commands.map((c, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0cb68ea454bd64de$export$2e2bcd8739ae039), {
                                disabled: isPreview,
                                value: c.command,
                                commandType: c.commandType,
                                startIcon: (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c.commandType].icon,
                                onChange: (value)=>handleCommandChange(value, k, i),
                                onRemove: ()=>handleRemoveCommand(c.command, k, i)
                            }, i)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "text",
                                startIcon: "plus",
                                disabled: isPreview,
                                onClick: ()=>handleAddCommand(k),
                                children: t('common:input.add')
                            })
                        })
                    ]
                }, i);
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4321e97835f672ea$export$2e2bcd8739ae039), {
                open: !!keyToAddCommand,
                onClose: ()=>setKeyToAddCommand(undefined),
                onCommandTypeSelected: (commandType)=>{
                    if (keyToAddCommand) handleAddCommandWithType(keyToAddCommand, commandType);
                }
            }),
            hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: hasChanges,
                setHasChanges: setHasChanges,
                onSave: async ()=>{
                    await saveChanges();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !hasChanges && id !== undefined,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: handleSave,
                    children: t('common:saveAndFinish')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: isResetConfirmationOpen,
                onCancel: ()=>{
                    setIsResetConfirmationOpen(false);
                    setResetOption('default');
                },
                onClose: ()=>{
                    setIsResetConfirmationOpen(false);
                    setResetOption('default');
                },
                title: t('common:keys.reset.confirm'),
                description: t('common:keys.reset.confirmDescription'),
                onConfirm: handleReset,
                confirmButtonText: t('common:keys.reset.confirmButton'),
                cancelButtonText: t('common:cancel'),
                confirmIcon: "repeat",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
                    name: "resetOption",
                    value: resetOption,
                    onChange: (e)=>setResetOption(e.target.value),
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                            value: "default",
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {}),
                            label: t('common:keys.reset.defaultOption')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                            value: "empty",
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {}),
                            label: t('common:keys.reset.emptyOption')
                        })
                    ]
                })
            })
        ]
    });
}












var $7fPBF = parcelRequire("7fPBF");












function $b70750b2c4fdb3ec$export$4b135a4b3a6c4550(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $b70750b2c4fdb3ec$var$inputAdornmentClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $b70750b2c4fdb3ec$export$2e2bcd8739ae039 = $b70750b2c4fdb3ec$var$inputAdornmentClasses;



'use client';
var $decc99a0f014db0d$var$_span;
const $decc99a0f014db0d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $decc99a0f014db0d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $b70750b2c4fdb3ec$export$4b135a4b3a6c4550), classes);
};
const $decc99a0f014db0d$var$InputAdornmentRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $decc99a0f014db0d$var$overridesResolver
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $b70750b2c4fdb3ec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $b70750b2c4fdb3ec$export$2e2bcd8739ae039).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $decc99a0f014db0d$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    const muiFormControl = (0, $7c05b6d5a150dbd8$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $decc99a0f014db0d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19e55fec28026df4$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($decc99a0f014db0d$var$InputAdornmentRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other), {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $decc99a0f014db0d$var$_span || ($decc99a0f014db0d$var$_span = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $decc99a0f014db0d$export$2e2bcd8739ae039 = $decc99a0f014db0d$var$InputAdornment;





let $51af5a17187af6b5$var$_ = (t)=>t, $51af5a17187af6b5$var$t, $51af5a17187af6b5$var$t1;
function $51af5a17187af6b5$var$SearchField({ label: label, placeholder: placeholder = '', value: value = '', onChange: onChange, onClear: onClear, showClearButton: showClearButton = true, id: id, inputRef: inputRef, icon: icon = 'search', onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onClick: onClick, htmlInputProps: htmlInputProps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // An explicit empty label hides the floating label (used where the placeholder is
    // enough, e.g. the AI History search); we still expose an aria-label for a11y.
    const hideLabel = label === '';
    const resolvedLabel = label || t('common:search');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($51af5a17187af6b5$var$StyledTextField, {
            onChange: onChange,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: onClick,
            id: id,
            inputRef: inputRef,
            size: "small",
            fullWidth: true,
            variant: "outlined",
            placeholder: placeholder,
            label: hideLabel ? undefined : resolvedLabel,
            value: value,
            slotProps: {
                input: {
                    startAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $decc99a0f014db0d$export$2e2bcd8739ae039), {
                        position: "start",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: icon,
                            color: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
                        })
                    }),
                    endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $decc99a0f014db0d$export$2e2bcd8739ae039), {
                        position: "end",
                        children: showClearButton && value && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($51af5a17187af6b5$var$CloseButton, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: "cancel2",
                                ariaLabel: t('common:close')
                            })
                        })
                    })
                },
                htmlInput: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, hideLabel ? {
                    'aria-label': placeholder || resolvedLabel
                } : {}, htmlInputProps)
            }
        })
    });
}
const $51af5a17187af6b5$var$StyledTextField = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039))($51af5a17187af6b5$var$t || ($51af5a17187af6b5$var$t = $51af5a17187af6b5$var$_`
    margin: 0.5rem 0;
    background: ${0};
    border-radius: 40px;
    & .MuiOutlinedInput-root {
        border-radius: 40px;
    }
    input {
        &:focus {
            outline: none;
        }
    }
`), (props)=>props.theme.color.background);
const $51af5a17187af6b5$var$CloseButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($51af5a17187af6b5$var$t1 || ($51af5a17187af6b5$var$t1 = $51af5a17187af6b5$var$_`
    background: none;
    border: none;
    color: ${0};
`), (props)=>props.theme.color.text);
var $51af5a17187af6b5$export$2e2bcd8739ae039 = $51af5a17187af6b5$var$SearchField;
























let $4d0153946beed1fa$var$_ = (t)=>t, $4d0153946beed1fa$var$t;
const $4d0153946beed1fa$var$getJoystickMoveLabel = (event, isLeft)=>{
    let label = '';
    var _ref;
    const xValueToCheck = (_ref = isLeft ? event.joystickLeftMoveX : event.joystickRightMoveX) !== null && _ref !== void 0 ? _ref : 0;
    var _ref1;
    const yValueToCheck = (_ref1 = isLeft ? event.joystickLeftMoveY : event.joystickRightMoveY) !== null && _ref1 !== void 0 ? _ref1 : 0;
    // if we have X and Y as non zero add both details to the label
    if (xValueToCheck != 0 && yValueToCheck != 0) label += `${Math.abs(xValueToCheck)}% ${xValueToCheck < 0 ? 'left' : 'right'} and ${Math.abs(yValueToCheck)}% ${yValueToCheck > 0 ? 'up' : 'down'}`;
    else if (xValueToCheck != 0) label += `${Math.abs(xValueToCheck)}% ${xValueToCheck < 0 ? 'left' : 'right'}`;
    else if (yValueToCheck != 0) label += `${Math.abs(yValueToCheck)}% ${yValueToCheck > 0 ? 'up' : 'down'}`;
    return label;
};
const $4d0153946beed1fa$var$getMouseMoveLabel = (event)=>{
    let label = '';
    let mouseEvents = [];
    if (event.mouseMoveX != 0 && event.mouseMoveX !== undefined) {
        const directionX = event.mouseMoveX >= 0 ? 'right' : 'left';
        var _Math_abs;
        mouseEvents.push(`${(_Math_abs = Math.abs(event.mouseMoveX)) !== null && _Math_abs !== void 0 ? _Math_abs : 0}px ${directionX}`);
    }
    if (event.mouseMoveY != 0 && event.mouseMoveY !== undefined) {
        const directionY = event.mouseMoveY <= 0 ? 'up' : 'down';
        var _Math_abs1;
        mouseEvents.push(`${(_Math_abs1 = Math.abs(event.mouseMoveY)) !== null && _Math_abs1 !== void 0 ? _Math_abs1 : 0}px ${directionY}`);
    }
    label = mouseEvents.join(' and ');
    return label;
};
const $4d0153946beed1fa$var$checkJoystick = (target)=>target !== 0 && target !== undefined && target !== null;
function $4d0153946beed1fa$var$MacroEventDescription({ event: event }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const defaultLocale = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.defaultLocale);
    const locale = defaultLocale;
    const getDeviceControlDisplayName = (controlId)=>{
        const control = (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496).getState().getDeviceControlName(controlId);
        return control;
    };
    const getKeyPressLabel = (event)=>{
        var _event_keys_map, _event_keys;
        const keys = (_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : (_event_keys_map = _event_keys.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))) === null || _event_keys_map === void 0 ? void 0 : _event_keys_map.join(" \xb7 ");
        if (event.holdTimeMilliseconds && event.holdTimeMilliseconds > 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
            children: t('common:event.keyPress.pressLabel', 'Press keys', {
                value: keys,
                time: event.holdTimeMilliseconds
            })
        });
        else if (event.isKeyLatch) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
            children: t('common:event.keyPress.latchLabel', 'Latch keys', {
                value: keys
            })
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
            children: t('common:event.keyPress.tapLabel', 'Tap keys', {
                value: keys
            })
        });
    };
    const eventLabels = {
        KeyPress: (event)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: getKeyPressLabel(event)
            });
        },
        KeyRelease: (event)=>{
            var _event_keys_map, _event_keys;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.keyRelease.label', 'Release', {
                    value: (_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : (_event_keys_map = _event_keys.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))) === null || _event_keys_map === void 0 ? void 0 : _event_keys_map.join(" \xb7 ")
                })
            });
        },
        KeyToggle: (event)=>{
            var _event_keys_map, _event_keys;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.keyToggle.label', 'Toggle', {
                    value: (_event_keys = event.keys) === null || _event_keys === void 0 ? void 0 : (_event_keys_map = _event_keys.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, locale))) === null || _event_keys_map === void 0 ? void 0 : _event_keys_map.join(" \xb7 ")
                })
            });
        },
        Type: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.type.label', 'Type', {
                    value: event.typedPhrase
                })
            }),
        PlayAudio: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.playAudio.label', 'Speak', {
                    value: event.outputSpeech
                })
            }),
        JoysticksMove: (event)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            ($4d0153946beed1fa$var$checkJoystick(event.joystickLeftMoveX) || $4d0153946beed1fa$var$checkJoystick(event.joystickLeftMoveY)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t('common:event.joystickMove.labelLeft')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: $4d0153946beed1fa$var$getJoystickMoveLabel(event, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            ($4d0153946beed1fa$var$checkJoystick(event.joystickRightMoveX) || $4d0153946beed1fa$var$checkJoystick(event.joystickRightMoveY)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t('common:event.joystickMove.labelRight')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: $4d0153946beed1fa$var$getJoystickMoveLabel(event, false)
                            }),
                            event.holdTimeMilliseconds && event.holdTimeMilliseconds > 0 ? ` for ${event.holdTimeMilliseconds} milliseconds` : null
                        ]
                    })
                ]
            });
        },
        MouseMove: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.mouseMove.label', 'Move mouse', {
                    value: $4d0153946beed1fa$var$getMouseMoveLabel(event)
                })
            }),
        Pause: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                children: t('common:event.pause.label', 'Pause', {
                    value: event.holdTimeMilliseconds
                })
            }),
        StopOutputs: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: t('common:event.stopOutputs.label')
            }),
        DeviceTypeCustomAction: (event)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: event.deviceTypeCustomActionId && getDeviceControlDisplayName(event.deviceTypeCustomActionId)
            })
    };
    const labelGenerator = eventLabels[event.eventType];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d0153946beed1fa$var$TextWrap, {
        children: labelGenerator ? labelGenerator(event) : ''
    });
}
const $4d0153946beed1fa$var$TextWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4d0153946beed1fa$var$t || ($4d0153946beed1fa$var$t = $4d0153946beed1fa$var$_`
    word-break: break-all; // forces breaks within words if needed
`));
var $4d0153946beed1fa$export$2e2bcd8739ae039 = $4d0153946beed1fa$var$MacroEventDescription;









let $d10a5e3fe02cf217$var$_ = (t)=>t, $d10a5e3fe02cf217$var$t;
const $d10a5e3fe02cf217$var$otherEventTypeToIconMap = {
    MouseMove: {
        title: 'Move the mouse',
        icon: 'computerMouse'
    },
    JoysticksMove: {
        title: 'Move the joystick',
        icon: 'joystick'
    },
    PlayAudio: {
        title: 'Speak',
        icon: 'speaker'
    },
    Type: {
        title: 'Type',
        icon: 'keyboard'
    },
    Pause: {
        title: 'Pause',
        icon: 'timer'
    },
    StopOutputs: {
        title: 'Stop All',
        icon: 'stop'
    },
    DeviceTypeCustomAction: {
        title: 'Custom',
        icon: 'hub'
    }
};
function $d10a5e3fe02cf217$export$2e2bcd8739ae039({ event: event, iconSize: iconSize = 28 }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const defaultLocale = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.defaultLocale);
    const getOtherView = (step)=>{
        const eventType = step.eventType;
        const eventInfo = $d10a5e3fe02cf217$var$otherEventTypeToIconMap[eventType];
        const { title: title, icon: icon } = eventInfo;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
            title: title,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d10a5e3fe02cf217$var$SingleStepContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: icon,
                    size: iconSize
                })
            })
        });
    };
    const getOverflowView = ()=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
            title: t('common:event.expand'),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d10a5e3fe02cf217$var$SingleStepContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: "layers",
                    size: iconSize
                })
            })
        });
    };
    const getKeysView = (step)=>{
        var _step_keys_map, _step_keys, _step_keys1;
        let eventTypeDescription;
        if (step.eventType === 'KeyToggle') eventTypeDescription = t('common:event.keyToggle.short');
        else if (step.eventType === 'KeyRelease') eventTypeDescription = t('common:event.keyRelease.short');
        else eventTypeDescription = t('common:event.keyPress.short');
        var _step_keys_map_join;
        const keysDescription = (_step_keys_map_join = (_step_keys = step.keys) === null || _step_keys === void 0 ? void 0 : (_step_keys_map = _step_keys.map((k)=>(0, $9a9874d925dad9cc$export$a23a68036192c276)(k, defaultLocale))) === null || _step_keys_map === void 0 ? void 0 : _step_keys_map.join(" \xb7 ")) !== null && _step_keys_map_join !== void 0 ? _step_keys_map_join : '';
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
            title: `${eventTypeDescription} ${keysDescription}`,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d10a5e3fe02cf217$var$SingleStepContainer, {
                children: [
                    (_step_keys1 = step.keys) === null || _step_keys1 === void 0 ? void 0 : _step_keys1.slice(0, 2).map((key, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: (0, $9a9874d925dad9cc$export$fbe8b56204f00600)(key, defaultLocale),
                            size: iconSize
                        }, index)),
                    step.keys && step.keys.length > 2 && getOverflowView()
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: (event === null || event === void 0 ? void 0 : event.eventType) === 'KeyPress' || (event === null || event === void 0 ? void 0 : event.eventType) == 'KeyRelease' || (event === null || event === void 0 ? void 0 : event.eventType) == 'KeyToggle' ? getKeysView(event) : getOtherView(event)
    });
}
const $d10a5e3fe02cf217$var$SingleStepContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d10a5e3fe02cf217$var$t || ($d10a5e3fe02cf217$var$t = $d10a5e3fe02cf217$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
`));


let $81c5d0a00b454a03$var$_ = (t)=>t, $81c5d0a00b454a03$var$t, $81c5d0a00b454a03$var$t1, $81c5d0a00b454a03$var$t2, $81c5d0a00b454a03$var$t3, $81c5d0a00b454a03$var$t4, $81c5d0a00b454a03$var$t5, $81c5d0a00b454a03$var$t6, $81c5d0a00b454a03$var$t7, $81c5d0a00b454a03$var$t8, $81c5d0a00b454a03$var$t9, $81c5d0a00b454a03$var$t10;
function $81c5d0a00b454a03$export$2e2bcd8739ae039(_param) {
    var { id: id, macro: macro, showTitle: showTitle = true, children: children } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "id",
        "macro",
        "showTitle",
        "children"
    ]);
    var _macro_commands_, _macro_commands, _macro_commands1, _macro_events;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getIconsForCommand = (commandType)=>{
        return (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[commandType] || null;
    };
    const macroName = macro.name ? macro.name : (0, $9d76aba0a210d2c6$export$61a248617ae833c4)((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command, t);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$Card, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restProps), {
        id: id,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$Content, {
            children: [
                showTitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$474db65c3c394e1c), {
                    children: macroName
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$SummaryLeft, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$SummarySectionText, {
                            children: t('common:when')
                        }),
                        (_macro_commands1 = macro.commands) === null || _macro_commands1 === void 0 ? void 0 : _macro_commands1.map((c, i)=>{
                            const icon = getIconsForCommand(c.commandType);
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$StepWrapperLeft, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                        size: 32,
                                        name: icon.icon,
                                        ariaLabel: icon.alt
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$SummaryDetailText, {
                                        "data-testid": c.command,
                                        children: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(c.command, t)
                                    })
                                ]
                            }, `mcCommands_${i}`);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$SummaryRight, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$SummarySectionText, {
                            children: t('common:thenMacro')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$MacroName, {
                            children: [
                                macroName,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "logo",
                                    size: 32
                                })
                            ]
                        }),
                        (_macro_events = macro.events) === null || _macro_events === void 0 ? void 0 : _macro_events.map((e, i)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($81c5d0a00b454a03$var$StepWrapperRight, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d10a5e3fe02cf217$export$2e2bcd8739ae039), {
                                        event: e,
                                        iconSize: 24
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d0153946beed1fa$export$2e2bcd8739ae039), {
                                        event: e
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($81c5d0a00b454a03$var$IconStep, {
                                        name: "downLeftArrow",
                                        size: 18
                                    })
                                ]
                            }, `mcEvents_${i}`);
                        })
                    ]
                }),
                children
            ]
        })
    }));
}
const $81c5d0a00b454a03$var$Content = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($81c5d0a00b454a03$var$t || ($81c5d0a00b454a03$var$t = $81c5d0a00b454a03$var$_`
    margin: auto;
    max-width: 800px;
    align-self: center;
`));
const $81c5d0a00b454a03$var$IconStep = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))($81c5d0a00b454a03$var$t1 || ($81c5d0a00b454a03$var$t1 = $81c5d0a00b454a03$var$_`
    position: relative;
    top: -0.2em;
`));
const $81c5d0a00b454a03$var$MacroName = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $6392222d2b8fb222$export$68ed3e0616d4c778))($81c5d0a00b454a03$var$t2 || ($81c5d0a00b454a03$var$t2 = $81c5d0a00b454a03$var$_`
    padding: 0 0 0.5rem 0;
    vertical-align: middle;
    gap: 0.2rem;
    justify-content: right;
    font-weight: 500;
`));
const $81c5d0a00b454a03$var$Card = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$eeffb7d514a37123))($81c5d0a00b454a03$var$t3 || ($81c5d0a00b454a03$var$t3 = $81c5d0a00b454a03$var$_`
    padding: 0.5rem 2rem 2rem 2rem;
    width: 100%;
`));
const $81c5d0a00b454a03$var$StepWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($81c5d0a00b454a03$var$t4 || ($81c5d0a00b454a03$var$t4 = $81c5d0a00b454a03$var$_`
    display: flex;
    vertical-align: middle;
    align-items: center;
    gap: 0.2rem;
    width: 100%;
    padding: 0.2rem 0;
    color: ${0};
`), (props)=>props.theme.color.text);
const $81c5d0a00b454a03$var$StepWrapperLeft = (0, $8de346382d86c747$export$2e2bcd8739ae039)($81c5d0a00b454a03$var$StepWrapper)($81c5d0a00b454a03$var$t5 || ($81c5d0a00b454a03$var$t5 = $81c5d0a00b454a03$var$_`
    justify-content: left;
`));
const $81c5d0a00b454a03$var$StepWrapperRight = (0, $8de346382d86c747$export$2e2bcd8739ae039)($81c5d0a00b454a03$var$StepWrapper)($81c5d0a00b454a03$var$t6 || ($81c5d0a00b454a03$var$t6 = $81c5d0a00b454a03$var$_`
    justify-content: right;
`));
const $81c5d0a00b454a03$var$SummaryLeft = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($81c5d0a00b454a03$var$t7 || ($81c5d0a00b454a03$var$t7 = $81c5d0a00b454a03$var$_``));
const $81c5d0a00b454a03$var$SummaryRight = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($81c5d0a00b454a03$var$t8 || ($81c5d0a00b454a03$var$t8 = $81c5d0a00b454a03$var$_`
    text-align: right;
`));
const $81c5d0a00b454a03$var$SummarySectionText = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($81c5d0a00b454a03$var$t9 || ($81c5d0a00b454a03$var$t9 = $81c5d0a00b454a03$var$_`
    margin: 1em 0 0.5em;
    font-size: ${0};
    font-weight: lighter;
`), (0, $8951886a6b49e92a$export$7536ca5ba8ef94f0).default);
const $81c5d0a00b454a03$var$SummaryDetailText = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($81c5d0a00b454a03$var$t10 || ($81c5d0a00b454a03$var$t10 = $81c5d0a00b454a03$var$_`
    white-space: pre-wrap;
`));



let $2169ab088e8080bb$var$_ = (t)=>t, $2169ab088e8080bb$var$t, $2169ab088e8080bb$var$t1, $2169ab088e8080bb$var$t2, $2169ab088e8080bb$var$t3, $2169ab088e8080bb$var$t4, $2169ab088e8080bb$var$t5, $2169ab088e8080bb$var$t6, $2169ab088e8080bb$var$t7, $2169ab088e8080bb$var$t8, $2169ab088e8080bb$var$t9;
const $2169ab088e8080bb$export$54c2e3dc7acea9f5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($2169ab088e8080bb$var$t || ($2169ab088e8080bb$var$t = $2169ab088e8080bb$var$_`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
`));
const $2169ab088e8080bb$export$f64d7e81e0578d1d = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($2169ab088e8080bb$var$t1 || ($2169ab088e8080bb$var$t1 = $2169ab088e8080bb$var$_`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
`));
const $2169ab088e8080bb$export$a4164a4373c4965b = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2169ab088e8080bb$var$t2 || ($2169ab088e8080bb$var$t2 = $2169ab088e8080bb$var$_`
    font-style: italic;
    font-weight: 300;
    grid-column: 1 / span 2;
    padding: 1rem;
    text-align: center;
`));
const $2169ab088e8080bb$export$7c6e2c02157bb7d2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).td($2169ab088e8080bb$var$t3 || ($2169ab088e8080bb$var$t3 = $2169ab088e8080bb$var$_`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    :nth-of-type(even) {
        grid-column: 2;
        justify-content: flex-end;
        text-align: right;
    }
    :nth-of-type(odd) {
        grid-column: 1;
        justify-content: flex-start;
        text-align: left;
    }
`));
const $2169ab088e8080bb$export$54ec01a60f47d33d = (0, $8de346382d86c747$export$2e2bcd8739ae039).table($2169ab088e8080bb$var$t4 || ($2169ab088e8080bb$var$t4 = $2169ab088e8080bb$var$_`
    width: 100%;
`));
const $2169ab088e8080bb$export$204d9105ce9ffb5d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$45814810f7000d9e))($2169ab088e8080bb$var$t5 || ($2169ab088e8080bb$var$t5 = $2169ab088e8080bb$var$_`
    text-align: inherit;
`));
const $2169ab088e8080bb$export$67152d26d4f56ee8 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$eeffb7d514a37123))($2169ab088e8080bb$var$t6 || ($2169ab088e8080bb$var$t6 = $2169ab088e8080bb$var$_`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    max-width: 800px;
    width: calc(100% - 2rem);
    padding: 40px;
`));
const $2169ab088e8080bb$export$3122aab815c89f9a = (0, $8de346382d86c747$export$2e2bcd8739ae039).tr($2169ab088e8080bb$var$t7 || ($2169ab088e8080bb$var$t7 = $2169ab088e8080bb$var$_`
    display: grid;
    gap: 1rem;
    grid-template-columns: auto auto;
    padding: 1rem 0;
    width: 100%;
    :not(:only-child):not(:last-child) {
        border-bottom: solid 1px ${0}20;
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark);
const $2169ab088e8080bb$export$12253aa05c1176e2 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2169ab088e8080bb$var$t8 || ($2169ab088e8080bb$var$t8 = $2169ab088e8080bb$var$_`
    margin: 1rem;
    display: flex;
    width: calc(100% - 2rem);
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1rem;
`));
const $2169ab088e8080bb$export$f2170af9598ce20e = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $81c5d0a00b454a03$export$2e2bcd8739ae039))($2169ab088e8080bb$var$t9 || ($2169ab088e8080bb$var$t9 = $2169ab088e8080bb$var$_`
    background-color: ${0};
    box-shadow: none;
    border-top: none !important;
`), (props)=>props.theme.color.accentCard);









var $7fPBF = parcelRequire("7fPBF");










let $0b0745218a11d1f7$var$_ = (t)=>t, $0b0745218a11d1f7$var$t, $0b0745218a11d1f7$var$t1;
const $0b0745218a11d1f7$var$getIconsForCommand = (commandType)=>{
    return (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[commandType] || null;
};
function $0b0745218a11d1f7$export$2e2bcd8739ae039(_param) {
    var { commands: commands } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "commands"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    //Dedupe command types for icons
    const uniqueCommandTypesArray = [
        ...new Set(commands.map(({ commandType: commandType })=>commandType))
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0b0745218a11d1f7$var$IconContainer, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restProps), {
        children: uniqueCommandTypesArray.map((c, i)=>{
            const command = $0b0745218a11d1f7$var$getIconsForCommand(c);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
                title: t('common:input.toolTip', 'This uses inputs', {
                    alt: command.alt
                }),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0b0745218a11d1f7$var$IconHover, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: command.icon,
                        ariaLabel: command.alt,
                        size: 34
                    })
                })
            }, `mcPreview_${i}`);
        })
    }));
}
const $0b0745218a11d1f7$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($0b0745218a11d1f7$var$t || ($0b0745218a11d1f7$var$t = $0b0745218a11d1f7$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-right: auto;
    padding: 0.5rem 0;
    left: 1rem;
`));
const $0b0745218a11d1f7$var$IconHover = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($0b0745218a11d1f7$var$t1 || ($0b0745218a11d1f7$var$t1 = $0b0745218a11d1f7$var$_``));







var $7fPBF = parcelRequire("7fPBF");


let $e12bbab59ef21f05$var$_ = (t)=>t, $e12bbab59ef21f05$var$t, $e12bbab59ef21f05$var$t1;
// TODO: mave OverflowView a component shared with MacroStepIcons possibly unify with getOtherView
const $e12bbab59ef21f05$var$MacroPreviewIcons = ({ macro: macro })=>{
    var _macro_events, _macro_events1;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getOverflowView = ()=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
            title: t('common:event.expand'),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e12bbab59ef21f05$var$SingleStepContainer, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: "layers"
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e12bbab59ef21f05$var$IconContainerView, {
        children: [
            macro === null || macro === void 0 ? void 0 : (_macro_events = macro.events) === null || _macro_events === void 0 ? void 0 : _macro_events.slice(0, 2).map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d10a5e3fe02cf217$export$2e2bcd8739ae039), {
                        event: event
                    })
                }, index)),
            (macro === null || macro === void 0 ? void 0 : (_macro_events1 = macro.events) === null || _macro_events1 === void 0 ? void 0 : _macro_events1.length) > 2 && getOverflowView()
        ]
    });
};
const $e12bbab59ef21f05$var$SingleStepContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e12bbab59ef21f05$var$t || ($e12bbab59ef21f05$var$t = $e12bbab59ef21f05$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
`));
const $e12bbab59ef21f05$var$IconContainerView = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e12bbab59ef21f05$var$t1 || ($e12bbab59ef21f05$var$t1 = $e12bbab59ef21f05$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    right: 24px;
    left: auto;

    img {
        width: 32px;
        margin: 0 2px;
    }
`));
var $e12bbab59ef21f05$export$2e2bcd8739ae039 = $e12bbab59ef21f05$var$MacroPreviewIcons;


let $cfa8aa82a863cabd$var$_ = (t)=>t, $cfa8aa82a863cabd$var$t, $cfa8aa82a863cabd$var$t1, $cfa8aa82a863cabd$var$t2, $cfa8aa82a863cabd$var$t3, $cfa8aa82a863cabd$var$t4;
//TODO: update to properly announce expanded state to SR https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion/
function $cfa8aa82a863cabd$var$MacroExpanderCard({ id: id, macro: macro, startExpanded: startExpanded, alwaysShowIcons: alwaysShowIcons = true, children: children }) {
    var _macro_commands_, _macro_commands;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(startExpanded);
    const iconShow = alwaysShowIcons === true ? false : isExpanded;
    const macroName = macro.name ? macro.name : (0, $9d76aba0a210d2c6$export$61a248617ae833c4)((_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : (_macro_commands_ = _macro_commands[0]) === null || _macro_commands_ === void 0 ? void 0 : _macro_commands_.command, t);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($cfa8aa82a863cabd$var$WrapperMacro, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cfa8aa82a863cabd$var$WrapperButton, {
                id: id,
                onClick: ()=>setIsExpanded(!isExpanded),
                "aria-pressed": isExpanded,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($cfa8aa82a863cabd$export$2061af696e09df60, {
                    "data-expanded": isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cfa8aa82a863cabd$var$StyledMacroCommandPreview, {
                            "data-expanded": iconShow,
                            commands: macro.commands,
                            iconSize: 32
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                            children: macroName
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e12bbab59ef21f05$export$2e2bcd8739ae039), {
                            macro: macro
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cfa8aa82a863cabd$var$ExpandedSection, {
                children: children
            })
        ]
    });
}
const $cfa8aa82a863cabd$var$WrapperMacro = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cfa8aa82a863cabd$var$t || ($cfa8aa82a863cabd$var$t = $cfa8aa82a863cabd$var$_`
    width: 100%;
`));
const $cfa8aa82a863cabd$var$WrapperButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($cfa8aa82a863cabd$var$t1 || ($cfa8aa82a863cabd$var$t1 = $cfa8aa82a863cabd$var$_`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    width: 100%;
`));
const $cfa8aa82a863cabd$var$StyledMacroCommandPreview = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0b0745218a11d1f7$export$2e2bcd8739ae039))($cfa8aa82a863cabd$var$t2 || ($cfa8aa82a863cabd$var$t2 = $cfa8aa82a863cabd$var$_`
    position: absolute;
    left: 24px;
    &[data-expanded='true'] {
        border: none;
        display: none;
    }
`));
const $cfa8aa82a863cabd$var$ExpandedSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cfa8aa82a863cabd$var$t3 || ($cfa8aa82a863cabd$var$t3 = $cfa8aa82a863cabd$var$_`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${0};
    animation: all 0.5s ease-in-out;
    border: 1px solid ${0}40;
    border-top: none;
    border-radius: 0 0 10px 10px;
    margin-top: -0.5rem;
    width: 100%;
`), (props)=>props.theme.color.accentCard, (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark);
const $cfa8aa82a863cabd$export$2061af696e09df60 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($cfa8aa82a863cabd$var$t4 || ($cfa8aa82a863cabd$var$t4 = $cfa8aa82a863cabd$var$_`
    box-shadow: none;
    border: 1px solid ${0}40;
    border-radius: 10px;
    width: 100%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    min-width: 380px;
    padding: 16px;
    background-color: ${0};
    color: ${0};
    &[data-expanded='true'] {
        box-shadow: none;
        border: 1px solid ${0}40;
        border-bottom: none !important;
        border-radius: 10px 10px 0 0;
    }
    :hover {
        background-color: ${0}40;
        text-decoration: underline;
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark, (props)=>props.theme.color.accentCard, (props)=>props.theme.color.text, (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark, (props)=>props.theme.color.accent);
var $cfa8aa82a863cabd$export$2e2bcd8739ae039 = $cfa8aa82a863cabd$var$MacroExpanderCard;


function $031c6e7d94ce0aa0$var$MacroListing({ macros: macros, startExpanded: startExpanded = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return macros && macros.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$12253aa05c1176e2), {
        children: macros.map((macro, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfa8aa82a863cabd$export$2e2bcd8739ae039), {
                macro: macro,
                startExpanded: startExpanded,
                id: macro.id,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$f2170af9598ce20e), {
                    macro: macro,
                    showTitle: false
                })
            }, `macro_${i}`))
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
        children: t('common:macroEmpty')
    });
}
var $031c6e7d94ce0aa0$export$2e2bcd8739ae039 = $031c6e7d94ce0aa0$var$MacroListing;








function $c0e241dbffe40cae$var$AssociatedProgramsListing({ programNames: programNames, profileName: profileName, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: programNames.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:profile.autoProfileSwitching.associatedPrograms.title', '', {
                        profileName: profileName
                    })
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:profile.autoProfileSwitching.associatedPrograms.description.short')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$45814810f7000d9e), {
                    children: t('common:profile.autoProfileSwitching.associatedPrograms.when', `Cephable will automatically switch my profile to ${profileName} when I use...`, {
                        profileName: profileName
                    })
                }),
                programNames.map((name, i)=>{
                    if (name === '') return null;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                        as: "span",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                            as: "span",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "virtualApps",
                                    size: 24,
                                    ariaLabel: t('common:profile.autoProfileSwitching.associatedPrograms.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: name
                                })
                            ]
                        })
                    }, `associated_program_${i}`);
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:profile.autoProfileSwitching.associatedPrograms.emptySearch')
        })
    });
}
var $c0e241dbffe40cae$export$2e2bcd8739ae039 = $c0e241dbffe40cae$var$AssociatedProgramsListing;










let $d1f6ba63b9e90a78$var$_ = (t)=>t, $d1f6ba63b9e90a78$var$t;
function $d1f6ba63b9e90a78$var$DictationListing({ dictationCommands: dictationCommands, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const icon = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)['dictation'];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: dictationCommands.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:dictation.title')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:dictation.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:voice.when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:dictation.thenMacro')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: dictationCommands.map((command, i)=>{
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: icon.icon,
                                                    size: 24,
                                                    ariaLabel: t(icon.title)
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: command
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d1f6ba63b9e90a78$var$Transcribe, {
                                                    children: t('common:dictation.type')
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "keyboard",
                                                    size: 24,
                                                    ariaLabel: t('common:steps')
                                                })
                                            ]
                                        })
                                    ]
                                }, `commandKeyMappings_${i}_${command}`);
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:dictation.empty')
        })
    });
}
const $d1f6ba63b9e90a78$var$Transcribe = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($d1f6ba63b9e90a78$var$t || ($d1f6ba63b9e90a78$var$t = $d1f6ba63b9e90a78$var$_`
    font-weight: 100;
    font-style: italic;
`));
var $d1f6ba63b9e90a78$export$2e2bcd8739ae039 = $d1f6ba63b9e90a78$var$DictationListing;









let $4bb13f250ef3167a$var$_ = (t)=>t, $4bb13f250ef3167a$var$t;
function $4bb13f250ef3167a$var$HotkeysListing({ hotkeys: hotkeys, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: hotkeys.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:hotkey.titlePlural')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:hotkey.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:hotkey.when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:thenMacro')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: hotkeys.map((hotkey, i)=>{
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "virtualButton",
                                                    size: 24,
                                                    ariaLabel: t('common:hotkey.title')
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: hotkey.displayName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4bb13f250ef3167a$var$MacroTitle, {
                                                    children: hotkey.macroName ? hotkey.macroName : hotkey.command
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "logo",
                                                    size: 24,
                                                    ariaLabel: t('common:steps')
                                                })
                                            ]
                                        })
                                    ]
                                }, `hotkey_${i}`);
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:hotkey.emptySearch')
        })
    });
}
const $4bb13f250ef3167a$var$MacroTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039).p($4bb13f250ef3167a$var$t || ($4bb13f250ef3167a$var$t = $4bb13f250ef3167a$var$_`
    text-transform: capitalize;
`));
var $4bb13f250ef3167a$export$2e2bcd8739ae039 = $4bb13f250ef3167a$var$HotkeysListing;










function $51f16c3433a05d99$var$KeyCommandListing({ commandKeyMappings: commandKeyMappings, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: commandKeyMappings.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:keys.title')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:keys.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:keys.then')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: commandKeyMappings.map((e, i)=>{
                                const commands = e.commands;
                                return commands.map((c, commandId)=>{
                                    const icon = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c.commandType];
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: icon.icon,
                                                        size: 24,
                                                        ariaLabel: t(icon.title)
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(c.command, t)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: e.displayName
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: e.icon,
                                                        size: 24,
                                                        ariaLabel: t('common:steps')
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `commandKeyMappings_${i}_${commandId}`);
                                });
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:keys.empty')
        })
    });
}
var $51f16c3433a05d99$export$2e2bcd8739ae039 = $51f16c3433a05d99$var$KeyCommandListing;










function $c8ea9f037cb7aa38$var$TalkbackListing({ audioEvents: audioEvents, showDescription: showDescription = true }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$67152d26d4f56ee8), {
        children: audioEvents.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$2d914cb1a3b0bf58), {
                    children: t('common:talkback.title')
                }),
                showDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:talkback.description')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$54ec01a60f47d33d), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:when')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                        as: "th",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$204d9105ce9ffb5d), {
                                            children: t('common:talkback.thenMacro')
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                            children: audioEvents.map((e, i)=>{
                                const commands = e.commands;
                                return commands.map((c, commandId)=>{
                                    const icon = (0, $f44f3a5bc46b1c4c$export$31469898f99e9a2)[c.commandType];
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$3122aab815c89f9a), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: icon.icon,
                                                        size: 24,
                                                        ariaLabel: t(icon.title)
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: (0, $9d76aba0a210d2c6$export$a9e54ec0b37334dc)(c.command, t)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2169ab088e8080bb$export$7c6e2c02157bb7d2), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        children: e.outputSpeech
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                        name: "speaker",
                                                        size: 24,
                                                        ariaLabel: t('common:steps')
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `audioEvents_${i}_${commandId}`);
                                });
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$a4164a4373c4965b), {
            children: t('common:talkback.empty')
        })
    });
}
var $c8ea9f037cb7aa38$export$2e2bcd8739ae039 = $c8ea9f037cb7aa38$var$TalkbackListing;





var $7fPBF = parcelRequire("7fPBF");


let $7ac5e11d07b654ce$var$lastShareCode = null;
let $7ac5e11d07b654ce$var$lastProfileId = null;
function $7ac5e11d07b654ce$export$2e2bcd8739ae039({ isDeepLink: isDeepLink = false }) {
    const { shareCode: shareCode, profileId: profileId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.macros);
    const hotkeys = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hotkeys);
    const audioEvents = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.audioEvents);
    const dictationCommands = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.dictationCommands);
    const commandKeyMappings = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.commandKeyMappings);
    const associatedPrograms = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.associatedPrograms);
    const name = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.name);
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const [loadingError, setLoadingError] = (0, $7fPBF.useState)(false);
    const filteredMacros = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return macros.filter((m)=>{
            var _m_name, _m_commands;
            const macroName = ((_m_name = m.name) === null || _m_name === void 0 ? void 0 : _m_name.toLowerCase()) || t('common:noName');
            const commandMatches = (_m_commands = m.commands) === null || _m_commands === void 0 ? void 0 : _m_commands.some((c)=>c.command.toLowerCase().includes(filter));
            return commandMatches || macroName.includes(filter) || !filter;
        });
    }, [
        filter,
        macros,
        loadingError,
        t
    ]);
    const filteredHotkeys = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return hotkeys.filter((h)=>{
            var _h_displayName, _h_command;
            const hotkeyName = (_h_displayName = h.displayName) === null || _h_displayName === void 0 ? void 0 : _h_displayName.toLowerCase().includes(filter);
            const hotkeyCommandMatches = (_h_command = h.command) === null || _h_command === void 0 ? void 0 : _h_command.toLowerCase().includes(filter);
            return hotkeyCommandMatches || hotkeyName || !filter;
        });
    }, [
        filter,
        hotkeys,
        loadingError
    ]);
    const filteredTalkback = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return audioEvents.filter((a)=>{
            var _a_outputSpeech, _a_commands;
            const talkbackName = (_a_outputSpeech = a.outputSpeech) === null || _a_outputSpeech === void 0 ? void 0 : _a_outputSpeech.toLowerCase().includes(filter);
            const talkbackCommandMatches = (_a_commands = a.commands) === null || _a_commands === void 0 ? void 0 : _a_commands.some((c)=>c.command.toLowerCase().includes(filter));
            return talkbackCommandMatches || talkbackName || !filter;
        });
    }, [
        filter,
        audioEvents,
        loadingError
    ]);
    const filteredDictation = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return dictationCommands.filter((d)=>{
            const dictationName = d === null || d === void 0 ? void 0 : d.toLowerCase().includes(filter);
            return dictationName || !filter;
        });
    }, [
        filter,
        dictationCommands,
        loadingError
    ]);
    const filteredKeyCommands = (0, $7fPBF.useMemo)(()=>{
        if (loadingError) return [];
        return commandKeyMappings.filter((k)=>{
            var _k_displayName, _k_commands;
            const keyCommandName = (_k_displayName = k.displayName) === null || _k_displayName === void 0 ? void 0 : _k_displayName.toLowerCase().includes(filter);
            const keyCommandCommandMatches = (_k_commands = k.commands) === null || _k_commands === void 0 ? void 0 : _k_commands.some((c)=>c.command.toLowerCase().includes(filter));
            return keyCommandCommandMatches || keyCommandName || !filter;
        });
    }, [
        filter,
        commandKeyMappings,
        loadingError
    ]);
    const handleSearchChange = (e)=>{
        const query = e.target.value;
        setFilter(query);
    };
    const handleClearSearch = ()=>{
        setFilter('');
    };
    (0, $7fPBF.useEffect)(()=>{
        if ($7ac5e11d07b654ce$var$lastShareCode === shareCode && shareCode != null) return;
        if ($7ac5e11d07b654ce$var$lastProfileId === profileId && profileId != null && !shareCode) return;
        $7ac5e11d07b654ce$var$lastShareCode = shareCode !== null && shareCode !== void 0 ? shareCode : null;
        $7ac5e11d07b654ce$var$lastProfileId = profileId !== null && profileId !== void 0 ? profileId : null;
        const loadProfile = async ()=>{
            const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
            editProfileStore.setIsPreview(true);
            if (shareCode) {
                const result = await editProfileStore.loadPreview(shareCode);
                if (result.resultType !== 'Ok') {
                    editProfileStore.setDefaultProfile('en-US');
                    setLoadingError(true);
                }
            } else if (profileId) {
                const profile = (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().allProfiles.find((p)=>p.id === profileId);
                if (profile) editProfileStore.updateProfileState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, profile), {
                    userId: undefined
                }));
                else editProfileStore.loadPublicPreview(profileId);
            }
        };
        loadProfile();
    }, [
        profileId,
        shareCode
    ]);
    function hasKeyCommands(commandKeyMappings) {
        return commandKeyMappings.some((item)=>item.commands.length > 0);
    }
    if (loadingError) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            children: t('common:profile.previewLoadError')
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: filter,
                onChange: handleSearchChange,
                onClear: handleClearSearch
            }),
            macros.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $031c6e7d94ce0aa0$export$2e2bcd8739ae039), {
                macros: filteredMacros
            }),
            hotkeys.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bb13f250ef3167a$export$2e2bcd8739ae039), {
                hotkeys: filteredHotkeys
            }),
            audioEvents.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c8ea9f037cb7aa38$export$2e2bcd8739ae039), {
                audioEvents: filteredTalkback
            }),
            dictationCommands.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1f6ba63b9e90a78$export$2e2bcd8739ae039), {
                dictationCommands: filteredDictation
            }),
            hasKeyCommands(commandKeyMappings) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51f16c3433a05d99$export$2e2bcd8739ae039), {
                commandKeyMappings: filteredKeyCommands
            }),
            associatedPrograms.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0e241dbffe40cae$export$2e2bcd8739ae039), {
                profileName: name,
                programNames: associatedPrograms
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






const $82997fc35e38e364$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $82997fc35e38e364$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views !== null && views !== void 0 ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(153));
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $4e19e5fab2f9b93c$export$a98b123b8f29e004 = (adapter, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
    mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
    mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
    mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
    return mergedDate;
};
const $4e19e5fab2f9b93c$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, adapter: adapter, timezone: timezone })=>{
    const today = $4e19e5fab2f9b93c$export$a98b123b8f29e004(adapter, adapter.date(undefined, timezone), date);
    if (disablePast && adapter.isBefore(minDate, today)) minDate = today;
    if (disableFuture && adapter.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (adapter.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (adapter.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && adapter.isAfter(forward, maxDate)) forward = null;
        if (backward && adapter.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = adapter.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = adapter.addDays(backward, -1);
        }
    }
    return null;
};
const $4e19e5fab2f9b93c$export$36ca889e039badd5 = (adapter, value)=>!adapter.isValid(value) ? null : value;
const $4e19e5fab2f9b93c$export$eb73579ccade48fd = (adapter, value, defaultValue)=>{
    if (value == null || !adapter.isValid(value)) return defaultValue;
    return value;
};
const $4e19e5fab2f9b93c$export$8fabf9a4cbada414 = (adapter, a, b)=>{
    if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) return true;
    return adapter.isEqual(a, b);
};
const $4e19e5fab2f9b93c$export$62591b96a734eacd = (adapter, year)=>{
    const firstMonth = adapter.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(adapter.addMonths(prevMonth, 1));
    }
    return months;
};
const $4e19e5fab2f9b93c$export$1118e4272ea1e258 = (adapter, timezone, valueType)=>valueType === 'date' ? adapter.startOfDay(adapter.date(undefined, timezone)) : adapter.date(undefined, timezone);
const $4e19e5fab2f9b93c$export$fae94c0a662107ef = (adapter, meridiem)=>{
    const date = adapter.setHours(adapter.date(), meridiem === 'am' ? 2 : 14);
    return adapter.format(date, 'meridiem');
};
const $4e19e5fab2f9b93c$export$76f4ff1fc64d3035 = [
    'year',
    'month',
    'day'
];
const $4e19e5fab2f9b93c$export$b32dfef9f07dea64 = (view)=>$4e19e5fab2f9b93c$export$76f4ff1fc64d3035.includes(view);
const $4e19e5fab2f9b93c$export$bb1c921f313ec928 = (adapter, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $4e19e5fab2f9b93c$export$24c38139da66592d = (adapter, date)=>{
    const start = adapter.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>adapter.addDays(start, diff));
};



const $b092b35a693ec4af$export$cf292de8b6883a7f = [
    'hours',
    'minutes',
    'seconds'
];
const $b092b35a693ec4af$export$570ec1747e4b1938 = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const $b092b35a693ec4af$export$8f04d380cefd5a0d = (view)=>$b092b35a693ec4af$export$cf292de8b6883a7f.includes(view);
const $b092b35a693ec4af$export$a3328136ac50623d = (view)=>$b092b35a693ec4af$export$570ec1747e4b1938.includes(view);
const $b092b35a693ec4af$export$c3352ead7b032236 = (date, adapter)=>{
    if (!date) return null;
    return adapter.getHours(date) >= 12 ? 'pm' : 'am';
};
const $b092b35a693ec4af$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $b092b35a693ec4af$export$c368d4ff66779998 = (time, meridiem, ampm, adapter)=>{
    const newHoursAmount = $b092b35a693ec4af$export$4159dc823695870e(adapter.getHours(time), meridiem, ampm);
    return adapter.setHours(time, newHoursAmount);
};
const $b092b35a693ec4af$export$888a1ce13aa61986 = (date, adapter)=>{
    return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
const $b092b35a693ec4af$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, adapter)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return adapter.isAfter(dateLeft, dateRight);
        return $b092b35a693ec4af$export$888a1ce13aa61986(dateLeft, adapter) > $b092b35a693ec4af$export$888a1ce13aa61986(dateRight, adapter);
    };
const $b092b35a693ec4af$export$3a6776b3863772fe = (adapter, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $82997fc35e38e364$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $ca987ffc32eec519$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $ca987ffc32eec519$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULARITY_section_type;
        return (_SECTION_TYPE_GRANULARITY_section_type = $ca987ffc32eec519$export$8f74e8f4ed8ae0ac[section.type]) !== null && _SECTION_TYPE_GRANULARITY_section_type !== void 0 ? _SECTION_TYPE_GRANULARITY_section_type : 1;
    }));
const $ca987ffc32eec519$var$roundDate = (adapter, granularity, date)=>{
    if (granularity === $ca987ffc32eec519$export$8f74e8f4ed8ae0ac.year) return adapter.startOfYear(date);
    if (granularity === $ca987ffc32eec519$export$8f74e8f4ed8ae0ac.month) return adapter.startOfMonth(date);
    if (granularity === $ca987ffc32eec519$export$8f74e8f4ed8ae0ac.day) return adapter.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $ca987ffc32eec519$export$8f74e8f4ed8ae0ac.minutes) roundedDate = adapter.setMinutes(roundedDate, 0);
    if (granularity < $ca987ffc32eec519$export$8f74e8f4ed8ae0ac.seconds) roundedDate = adapter.setSeconds(roundedDate, 0);
    if (granularity < $ca987ffc32eec519$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = adapter.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $ca987ffc32eec519$export$6a31d56794238e4e = ({ props: props, adapter: adapter, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $ca987ffc32eec519$var$roundDate(adapter, granularity, (0, $4e19e5fab2f9b93c$export$1118e4272ea1e258)(adapter, timezone));
    if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) referenceDate = $ca987ffc32eec519$var$roundDate(adapter, granularity, props.minDate);
    if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $ca987ffc32eec519$var$roundDate(adapter, granularity, props.maxDate);
    var _props_disableIgnoringDatePartForTimeValidation;
    const isAfter = (0, $b092b35a693ec4af$export$fb87c80b35a46b89)((_props_disableIgnoringDatePartForTimeValidation = props.disableIgnoringDatePartForTimeValidation) !== null && _props_disableIgnoringDatePartForTimeValidation !== void 0 ? _props_disableIgnoringDatePartForTimeValidation : false, adapter);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $ca987ffc32eec519$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $4e19e5fab2f9b93c$export$a98b123b8f29e004)(adapter, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $ca987ffc32eec519$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $4e19e5fab2f9b93c$export$a98b123b8f29e004)(adapter, referenceDate, props.maxTime));
    return referenceDate;
};





const $22f2351be8dc685a$export$2f3c5fac7a2a65f6 = (adapter, formatToken)=>{
    const config = adapter.formatTokenMap[formatToken];
    if (config == null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(157, formatToken));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $22f2351be8dc685a$export$c65c7173f879039f = (adapter, format)=>{
    const elements = [];
    const now = adapter.date(undefined, 'default');
    const startDate = adapter.startOfWeek(now);
    const endDate = adapter.endOfWeek(now);
    let current = startDate;
    while(adapter.isBefore(current, endDate)){
        elements.push(current);
        current = adapter.addDays(current, 1);
    }
    return elements.map((weekDay)=>adapter.formatByString(weekDay, format));
};
const $22f2351be8dc685a$export$3ee1e7e19c2b047a = (adapter, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $4e19e5fab2f9b93c$export$62591b96a734eacd)(adapter, adapter.date(undefined, timezone)).map((month)=>adapter.formatByString(month, format));
        case 'weekDay':
            return $22f2351be8dc685a$export$c65c7173f879039f(adapter, format);
        case 'meridiem':
            {
                const now = adapter.date(undefined, timezone);
                return [
                    adapter.startOfDay(now),
                    adapter.endOfDay(now)
                ].map((date)=>adapter.formatByString(date, format));
            }
        default:
            return [];
    }
};
// This format should be the same on all the adapters
// If some adapter does not respect this convention, then we will need to hardcode the format on each adapter.
const $22f2351be8dc685a$var$FORMAT_SECONDS_NO_LEADING_ZEROS = 's';
const $22f2351be8dc685a$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $22f2351be8dc685a$export$b42be9ae7016ef5d = (adapter)=>{
    const today = adapter.date(undefined);
    const formattedZero = adapter.formatByString(adapter.setSeconds(today, 0), $22f2351be8dc685a$var$FORMAT_SECONDS_NO_LEADING_ZEROS);
    if (formattedZero === '0') return $22f2351be8dc685a$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>adapter.formatByString(adapter.setSeconds(today, index), $22f2351be8dc685a$var$FORMAT_SECONDS_NO_LEADING_ZEROS));
};
const $22f2351be8dc685a$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const $22f2351be8dc685a$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const $22f2351be8dc685a$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $22f2351be8dc685a$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $22f2351be8dc685a$export$713c6d756c12fc27 = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
const $22f2351be8dc685a$export$ef88db4bceade9fd = (adapter, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = adapter.setDate(sectionBoundaries.longestMonth, value);
        return adapter.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $22f2351be8dc685a$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $22f2351be8dc685a$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $22f2351be8dc685a$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($22f2351be8dc685a$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $22f2351be8dc685a$export$2816862a602354ce = (adapter, valueStr, currentFormat, newFormat)=>{
    return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
const $22f2351be8dc685a$var$isFourDigitYearFormat = (adapter, format)=>adapter.formatByString(adapter.date(undefined, 'system'), format).length === 4;
const $22f2351be8dc685a$export$78b5830e2dd2de49 = (adapter, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = adapter.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (adapter.lib === 'dayjs' && format === 'YY') return true;
            return adapter.formatByString(adapter.setYear(now, 1), format).startsWith('0');
        case 'month':
            return adapter.formatByString(adapter.startOfYear(now), format).length > 1;
        case 'day':
            return adapter.formatByString(adapter.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return adapter.formatByString(adapter.startOfWeek(now), format).length > 1;
        case 'hours':
            return adapter.formatByString(adapter.setHours(now, 1), format).length > 1;
        case 'minutes':
            return adapter.formatByString(adapter.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return adapter.formatByString(adapter.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(158));
    }
};
const $22f2351be8dc685a$export$b0c1bfd065bfe742 = (adapter, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($22f2351be8dc685a$export$85daa91f6c6e875f(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $22f2351be8dc685a$export$c6efb65bdba8cad3 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
const $22f2351be8dc685a$export$360600f456ea7d5f = (adapter, localizedDigits, timezone)=>{
    const today = adapter.date(undefined, timezone);
    const endOfYear = adapter.endOfYear(today);
    const endOfDay = adapter.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $4e19e5fab2f9b93c$export$62591b96a734eacd)(adapter, today).reduce((acc, month)=>{
        const daysInMonth = adapter.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $22f2351be8dc685a$var$isFourDigitYearFormat(adapter, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: adapter.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $22f2351be8dc685a$export$c65c7173f879039f(adapter, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = adapter.getHours(endOfDay);
            const formattedMidnight = Number($22f2351be8dc685a$export$7dd321105a319e8(adapter.formatByString(adapter.startOfDay(today), format), localizedDigits));
            const formattedEndOfDay = Number($22f2351be8dc685a$export$7dd321105a319e8(adapter.formatByString(adapter.endOfDay(today), format), localizedDigits));
            const hasMeridiem = formattedEndOfDay !== lastHourInDay;
            if (hasMeridiem) {
                // K/KK format (hour 0-11): midnight formats as 0
                if (formattedMidnight === 0) return {
                    minimum: 0,
                    maximum: formattedEndOfDay
                };
                // h/hh format (hour 1-12): midnight formats as 12
                return {
                    minimum: 1,
                    maximum: formattedMidnight
                };
            }
            // k/kk format (hour 1-24): midnight formats as 24 (> lastHourInDay)
            if (formattedMidnight > lastHourInDay) return {
                minimum: 1,
                maximum: formattedMidnight
            };
            // H/HH format (hour 0-23)
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: adapter.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: adapter.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $22f2351be8dc685a$var$warnedOnceInvalidSection = false;
const $22f2351be8dc685a$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $22f2351be8dc685a$var$transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
        case 'month':
            return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = $22f2351be8dc685a$export$713c6d756c12fc27(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = $22f2351be8dc685a$export$c65c7173f879039f(adapter, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return adapter.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const meridiem = adapter.getHours(dateToTransferFrom) < 12 ? 'am' : 'pm';
                return (0, $b092b35a693ec4af$export$c368d4ff66779998)(dateToTransferTo, meridiem, true, adapter);
            }
        case 'hours':
            return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
        case 'minutes':
            return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
        case 'seconds':
            return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $22f2351be8dc685a$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $22f2351be8dc685a$export$6c6df982c77f60a9 = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$22f2351be8dc685a$var$reliableSectionModificationOrder[a.type] - $22f2351be8dc685a$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $22f2351be8dc685a$var$transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $22f2351be8dc685a$export$7725fd6fe0a2aadf = (sections)=>{
    const neighbors = {};
    sections.forEach((_, index)=>{
        const leftIndex = index === 0 ? null : index - 1;
        const rightIndex = index === sections.length - 1 ? null : index + 1;
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: 0,
        endIndex: sections.length - 1
    };
};
const $22f2351be8dc685a$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};


const $47fcf740fb158e5e$var$_excluded = [
    "value",
    "referenceDate"
];
const $47fcf740fb158e5e$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $4e19e5fab2f9b93c$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $47fcf740fb158e5e$var$_excluded);
        if (params.adapter.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $ca987ffc32eec519$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $4e19e5fab2f9b93c$export$36ca889e039badd5),
    areValuesEqual: (0, $4e19e5fab2f9b93c$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (adapter, value)=>adapter.isValid(value) ? adapter.getTimezone(value) : null,
    setTimezone: (adapter, timezone, value)=>value == null ? null : adapter.setTimezone(value, timezone)
};
const $47fcf740fb158e5e$export$b602c94f557316b4 = {
    updateReferenceValue: (adapter, value, prevReferenceValue)=>adapter.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getHiddenInputValueFromSections: (0, $22f2351be8dc685a$export$c6efb65bdba8cad3),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, section, {
                value: ''
            }))
};




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");







function $22aa6b47d640612b$export$b109c489973c3d80(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersToolbar', slot);
}
const $22aa6b47d640612b$export$59f09e5e2b3d9913 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
'use client';
const $35a6f30d863ede10$export$5e8d511415c09dec = /*#__PURE__*/ $7fPBF.createContext(()=>true);
function $35a6f30d863ede10$export$52df06af7329e367() {
    return $7fPBF.useContext($35a6f30d863ede10$export$5e8d511415c09dec);
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $6e1a1c224f194aa0$export$263a5df151942441 = /*#__PURE__*/ $7fPBF.createContext(null);
function $6e1a1c224f194aa0$export$700ab01cf24fdb1() {
    return $7fPBF.useContext($6e1a1c224f194aa0$export$263a5df151942441);
}




var $7fPBF = parcelRequire("7fPBF");
'use client';
const $603bd506ac49bd15$export$b72b8dade9393cd5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $603bd506ac49bd15$export$4495bebe53492ac8 = ()=>{
    const value = $7fPBF.useContext($603bd506ac49bd15$export$b72b8dade9393cd5);
    if (value == null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(151));
    return value;
};



'use client';
const $266c452779606bb3$export$d1dfa4910c58a4e = /*#__PURE__*/ $7fPBF.createContext(null);
const $266c452779606bb3$export$3a79edaa4b9c6a3e = /*#__PURE__*/ $7fPBF.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function $266c452779606bb3$export$aae9fbe9dd4050fa(props) {
    const { contextValue: contextValue, actionsContextValue: actionsContextValue, privateContextValue: privateContextValue, fieldPrivateContextValue: fieldPrivateContextValue, isValidContextValue: isValidContextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $603bd506ac49bd15$export$b72b8dade9393cd5).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($266c452779606bb3$export$d1dfa4910c58a4e.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($266c452779606bb3$export$3a79edaa4b9c6a3e.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6e1a1c224f194aa0$export$263a5df151942441).Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $35a6f30d863ede10$export$5e8d511415c09dec).Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9a7f2bc06270517e$export$dc45bdc734ce6f1e), {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}


'use client';
const $a1b6bd1887cb0e9a$export$ceff2e8b47408642 = ()=>$7fPBF.useContext((0, $266c452779606bb3$export$3a79edaa4b9c6a3e));


function $eebb2a7887d207b4$export$52d82af37dec73b2() {
    const { ownerState: pickerOwnerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    return $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}



'use client';
const $d22aed4febc94e21$var$_excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const $d22aed4febc94e21$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $22aa6b47d640612b$export$b109c489973c3d80), classes);
};
const $d22aed4febc94e21$var$PickersToolbarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $d22aed4febc94e21$var$PickersToolbarContent = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $d22aed4febc94e21$export$eb3c4d84783d6feb = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, classes: classesProp, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId, landscapeDirection: landscapeDirection } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $d22aed4febc94e21$var$_excluded);
    const ownerState = (0, $eebb2a7887d207b4$export$52d82af37dec73b2)();
    const classes = $d22aed4febc94e21$var$useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d22aed4febc94e21$var$PickersToolbarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                variant: "overline",
                id: titleId,
                className: classes.title,
                sx: {
                    color: 'text.secondary'
                },
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d22aed4febc94e21$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});





var $7fPBF = parcelRequire("7fPBF");

const $7063a395665e04d0$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $a7ddd27bcd29399a$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $a7ddd27bcd29399a$export$1af4c7e47ad72f44 = $a7ddd27bcd29399a$var$enUSPickers;
const $a7ddd27bcd29399a$export$137380d9ce54f7f = (0, $7063a395665e04d0$export$67c96d35a1b010b3)($a7ddd27bcd29399a$var$enUSPickers);



'use client';
const $67f1bc9f3ce33f9d$export$4b5a24245de9f7f9 = ()=>{
    const localization = $7fPBF.useContext((0, $9a7f2bc06270517e$export$41298298dbe382b));
    if (localization === null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(149));
    if (localization.adapter === null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(150));
    const localeText = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $a7ddd27bcd29399a$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b = ()=>$67f1bc9f3ce33f9d$export$4b5a24245de9f7f9().adapter;


'use client';
const $4ba3a3ea18159e56$export$a795e6ca852975b9 = ()=>(0, $67f1bc9f3ce33f9d$export$4b5a24245de9f7f9)().localeText;




function $8c2e9628fedca85b$export$a1c3879af2c3b694(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDatePickerToolbar', slot);
}
const $8c2e9628fedca85b$export$2e35fa7d24ef4179 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDatePickerToolbar', [
    'root',
    'title'
]);





'use client';
const $3ef77ecf3cbe1760$var$_excluded = [
    "toolbarFormat",
    "toolbarPlaceholder",
    "className",
    "classes"
];
const $3ef77ecf3cbe1760$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8c2e9628fedca85b$export$a1c3879af2c3b694), classes);
};
const $3ef77ecf3cbe1760$var$DatePickerToolbarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $d22aed4febc94e21$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root'
})({});
const $3ef77ecf3cbe1760$var$DatePickerToolbarTitle = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title'
})({
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const $3ef77ecf3cbe1760$export$21b7f8ea763109eb = /*#__PURE__*/ $7fPBF.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", className: className, classes: classesProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $3ef77ecf3cbe1760$var$_excluded);
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { value: value, views: views, orientation: orientation } = (0, $603bd506ac49bd15$export$4495bebe53492ac8)();
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const ownerState = (0, $eebb2a7887d207b4$export$52d82af37dec73b2)();
    const classes = $3ef77ecf3cbe1760$var$useUtilityClasses(classesProp);
    const dateText = $7fPBF.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        const formatFromViews = (0, $4e19e5fab2f9b93c$export$bb1c921f313ec928)(adapter, {
            format: toolbarFormat,
            views: views
        }, true);
        return adapter.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter,
        views
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ef77ecf3cbe1760$var$DatePickerToolbarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ef77ecf3cbe1760$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: orientation === 'landscape' ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});




var $7fPBF = parcelRequire("7fPBF");



const $32a91d31b03a0978$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate } = props;
    const now = adapter.date(undefined, timezone);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
$32a91d31b03a0978$export$ffb3d0046ef3a2.valueManager = (0, $47fcf740fb158e5e$export$2764b246aa3b75ba);



var $7fPBF = parcelRequire("7fPBF");

'use client';
const $561935f171930cf5$export$7c38da3a2e90fa83 = ()=>(0, $67f1bc9f3ce33f9d$export$4b5a24245de9f7f9)().defaultDates;
const $561935f171930cf5$export$3a404aece3dff2fa = (timezone)=>{
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const now = $7fPBF.useRef(undefined);
    if (now.current === undefined) now.current = adapter.date(undefined, timezone);
    return now.current;
};



'use client';
function $b7fa3b3c8a55dd1e$export$6b73f8c5013b806e() {
    return $7fPBF.useMemo(()=>({
            valueType: 'date',
            validator: (0, $32a91d31b03a0978$export$ffb3d0046ef3a2),
            internal_valueManager: (0, $47fcf740fb158e5e$export$2764b246aa3b75ba),
            internal_fieldValueManager: (0, $47fcf740fb158e5e$export$b602c94f557316b4),
            internal_useApplyDefaultValuesToFieldInternalProps: $b7fa3b3c8a55dd1e$var$useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $b7fa3b3c8a55dd1e$var$useOpenPickerButtonAriaLabel
        }), []);
}
function $b7fa3b3c8a55dd1e$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    return $7fPBF.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $b7fa3b3c8a55dd1e$var$useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const validationProps = $b7fa3b3c8a55dd1e$export$82ecc8c5f467152f(internalProps);
    return $7fPBF.useMemo(()=>{
        var _internalProps_format;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, internalProps, validationProps, {
            format: (_internalProps_format = internalProps.format) !== null && _internalProps_format !== void 0 ? _internalProps_format : adapter.formats.keyboardDate
        });
    }, [
        internalProps,
        validationProps,
        adapter
    ]);
}
function $b7fa3b3c8a55dd1e$export$82ecc8c5f467152f(props) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const defaultDates = (0, $561935f171930cf5$export$7c38da3a2e90fa83)();
    return $7fPBF.useMemo(()=>{
        var _props_disablePast, _props_disableFuture;
        return {
            disablePast: (_props_disablePast = props.disablePast) !== null && _props_disablePast !== void 0 ? _props_disablePast : false,
            disableFuture: (_props_disableFuture = props.disableFuture) !== null && _props_disableFuture !== void 0 ? _props_disableFuture : false,
            minDate: (0, $4e19e5fab2f9b93c$export$eb73579ccade48fd)(adapter, props.minDate, defaultDates.minDate),
            maxDate: (0, $4e19e5fab2f9b93c$export$eb73579ccade48fd)(adapter, props.maxDate, defaultDates.maxDate)
        };
    }, [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}


function $6256e61ca6e2a023$export$a552c17ed3587731(props, name) {
    const themeProps = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $b7fa3b3c8a55dd1e$export$82ecc8c5f467152f)(themeProps);
    const localeText = $7fPBF.useMemo(()=>{
        var _themeProps_localeText;
        if (((_themeProps_localeText = themeProps.localeText) === null || _themeProps_localeText === void 0 ? void 0 : _themeProps_localeText.toolbarTitle) == null) return themeProps.localeText;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        localeText: localeText
    }, (0, $82997fc35e38e364$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            toolbar: (0, $3ef77ecf3cbe1760$export$21b7f8ea763109eb)
        }, themeProps.slots)
    });
}



const $95d6db0fe23c2dc0$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $95d6db0fe23c2dc0$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $95d6db0fe23c2dc0$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $95d6db0fe23c2dc0$var$VALIDATION_PROP_NAMES = [
    ...$95d6db0fe23c2dc0$export$430d9fc64cf058d6,
    ...$95d6db0fe23c2dc0$export$fd5e0f8b4115a8c7,
    ...$95d6db0fe23c2dc0$export$1df62d3ba2121371
];
const $95d6db0fe23c2dc0$export$5890f750904acddb = (props)=>$95d6db0fe23c2dc0$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});








var $7fPBF = parcelRequire("7fPBF");











/**
 * Taken from https://github.com/matijs/is-interactive-element/
 */ const $160364d5fab9725e$var$isInputHidden = (input)=>input.type === 'hidden';
function $160364d5fab9725e$export$7951a64a727d5e0e(element) {
    const { nodeName: nodeName } = element;
    if ([
        'BUTTON',
        'DETAILS',
        'EMBED',
        'IFRAME',
        'KEYGEN',
        'LABEL',
        'SELECT',
        'TEXTAREA'
    ].includes(nodeName)) return true;
    if (nodeName === 'A' && element.hasAttribute('href')) return true;
    if (element instanceof HTMLInputElement && !$160364d5fab9725e$var$isInputHidden(element)) return true;
    if ([
        'AUDIO',
        'VIDEO'
    ].includes(nodeName) && element.hasAttribute('controls')) return true;
    if ([
        'IMG',
        'OBJECT'
    ].includes(nodeName) && element.hasAttribute('usemap')) return true;
    if (element.hasAttribute('tabindex') && element.tabIndex > -1) return true;
    return false;
}




function $8487424663788397$export$13707a1542cd4ff5(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickerPopper', slot);
}
const $8487424663788397$export$e7d83f8e0f3c53d3 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickerPopper', [
    'root',
    'paper'
]);



function $3e1b4adab776c920$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $3e1b4adab776c920$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $3e1b4adab776c920$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $3e1b4adab776c920$var$getActiveElementInternal = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $3e1b4adab776c920$var$getActiveElementInternal(activeEl.shadowRoot);
    return activeEl;
};
const $3e1b4adab776c920$export$cd4e5573fbe2b576 = (node)=>{
    return $3e1b4adab776c920$var$getActiveElementInternal((0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(node));
};
const $3e1b4adab776c920$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($3e1b4adab776c920$export$cd4e5573fbe2b576(listElement));
};
const $3e1b4adab776c920$export$9ae5b19305db48ce = '@media (pointer: fine)';
function $3e1b4adab776c920$export$1427765d2f0e99a5(props) {
    const forwardedProps = {};
    for (const key of Object.keys(props))if (key.startsWith('data-') || key.startsWith('aria-')) forwardedProps[key] = props[key];
    return forwardedProps;
}
function $3e1b4adab776c920$export$3da104473fe9d2e8(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}





'use client';
const $8546de91339ee0c8$var$_excluded = [
    "PaperComponent",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $8546de91339ee0c8$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8487424663788397$export$13707a1542cd4ff5), classes);
};
const $8546de91339ee0c8$var$PickerPopperRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a5b41facef9806db$export$2e2bcd8739ae039), {
    name: 'MuiPickerPopper',
    slot: 'Root'
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $8546de91339ee0c8$var$PickerPopperPaper = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiPickerPopper',
    slot: 'Paper'
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ popperPlacement: popperPlacement })=>new Set([
                    'top',
                    'top-start',
                    'top-end'
                ]).has(popperPlacement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function $8546de91339ee0c8$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $8546de91339ee0c8$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/react/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) {
            // Reset syntheticEventRef to avoid stale state when a programmatic click
            // (e.g., ButtonBase Enter key handler) sets it without a preceding mousedown.
            syntheticEventRef.current = false;
            return;
        }
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $8546de91339ee0c8$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = (event)=>{
        // Ignore events handled by our internal components
        if (!event.defaultMuiPrevented) syntheticEventRef.current = true;
    };
    $7fPBF.useEffect(()=>{
        if (active) {
            const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $7fPBF.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $8546de91339ee0c8$var$PickerPopperPaperWrapper = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, ownerState: ownerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8546de91339ee0c8$var$_excluded);
    const paperProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PaperComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, paperProps, {
        onClick: (event)=>{
            var _paperProps_onClick;
            onPaperClick(event);
            (_paperProps_onClick = paperProps.onClick) === null || _paperProps_onClick === void 0 ? void 0 : _paperProps_onClick.call(paperProps, event);
        },
        onTouchStart: (event)=>{
            var _paperProps_onTouchStart;
            onPaperTouchStart(event);
            (_paperProps_onTouchStart = paperProps.onTouchStart) === null || _paperProps_onTouchStart === void 0 ? void 0 : _paperProps_onTouchStart.call(paperProps, event);
        },
        ownerState: ownerState,
        children: children
    }));
});
const $8546de91339ee0c8$var$isEventTargetInteractive = (eventTarget)=>{
    const element = eventTarget instanceof HTMLElement ? eventTarget : null;
    if (!element) return false;
    return (0, $160364d5fab9725e$export$7951a64a727d5e0e)(element);
};
function $8546de91339ee0c8$export$ac84dff7cf037abd(inProps) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickerPopper'
    });
    const { children: children, placement: placement = 'bottom-start', slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const { open: open, popupRef: popupRef, reduceAnimations: reduceAnimations, keepOpenDuringFieldFocus: keepOpenDuringFieldFocus } = (0, $603bd506ac49bd15$export$4495bebe53492ac8)();
    const { ownerState: pickerOwnerState, rootRefObject: rootRefObject } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const { dismissViews: dismissViews, getCurrentViewMode: getCurrentViewMode, onPopperExited: onPopperExited, triggerElement: triggerElement, viewContainerRole: viewContainerRole } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    $7fPBF.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') dismissViews();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        dismissViews,
        open
    ]);
    const lastFocusedElementRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (viewContainerRole === 'tooltip' || getCurrentViewMode() === 'field') return;
        if (open) lastFocusedElementRef.current = (0, $3e1b4adab776c920$export$cd4e5573fbe2b576)(rootRefObject.current);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        viewContainerRole,
        getCurrentViewMode,
        rootRefObject
    ]);
    const classes = $8546de91339ee0c8$var$useUtilityClasses(classesProp);
    const handleClickAway = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // Do not close when clicking inside the field if keepOpenDuringFieldFocus is enabled
        if (keepOpenDuringFieldFocus && triggerElement && event && 'target' in event && triggerElement.contains(event.target)) return;
        if (viewContainerRole === 'tooltip') (0, $3e1b4adab776c920$export$2e03bc8dde24716b)(()=>{
            var _rootRefObject_current, _popupRef_current;
            if (((_rootRefObject_current = rootRefObject.current) === null || _rootRefObject_current === void 0 ? void 0 : _rootRefObject_current.contains((0, $3e1b4adab776c920$export$cd4e5573fbe2b576)(rootRefObject.current))) || ((_popupRef_current = popupRef.current) === null || _popupRef_current === void 0 ? void 0 : _popupRef_current.contains((0, $3e1b4adab776c920$export$cd4e5573fbe2b576)(popupRef.current)))) return;
            dismissViews();
        });
        else {
            // Get all the targets of this event.
            const eventTargets = event.composedPath();
            // https://github.com/mui/mui-x/pull/13434
            // Check if the click is on an interactive element.
            // If it is, we don't want to refocus the last focused element.
            if (eventTargets.some($8546de91339ee0c8$var$isEventTargetInteractive)) lastFocusedElementRef.current = null;
            dismissViews();
        }
    });
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $8546de91339ee0c8$var$useClickAwayListener(open, handleClickAway);
    const paperRef = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(paperRef, popupRef);
    const handlePaperRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            dismissViews();
        }
    };
    var _slots_desktopTransition;
    const Transition = ((_slots_desktopTransition = slots === null || slots === void 0 ? void 0 : slots.desktopTransition) !== null && _slots_desktopTransition !== void 0 ? _slots_desktopTransition : reduceAnimations) ? (0, $0f34aa3278e20e02$export$2e2bcd8739ae039) : (0, $3ab1beedea58600b$export$2e2bcd8739ae039);
    var _slots_desktopTrapFocus;
    const FocusTrap = (_slots_desktopTrapFocus = slots === null || slots === void 0 ? void 0 : slots.desktopTrapFocus) !== null && _slots_desktopTrapFocus !== void 0 ? _slots_desktopTrapFocus : (0, $ad54025a02984b15$export$2e2bcd8739ae039);
    var _slots_desktopPaper;
    const Paper = (_slots_desktopPaper = slots === null || slots === void 0 ? void 0 : slots.desktopPaper) !== null && _slots_desktopPaper !== void 0 ? _slots_desktopPaper : $8546de91339ee0c8$var$PickerPopperPaper;
    var _slots_popper;
    const Popper = (_slots_popper = slots === null || slots === void 0 ? void 0 : slots.popper) !== null && _slots_popper !== void 0 ? _slots_popper : $8546de91339ee0c8$var$PickerPopperRoot;
    const popperProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.popper,
        additionalProps: {
            transition: true,
            role: viewContainerRole == null ? undefined : viewContainerRole,
            open: open,
            placement: placement,
            anchorEl: triggerElement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: pickerOwnerState
    });
    const ownerState = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            popperPlacement: popperProps.placement
        }), [
        pickerOwnerState,
        popperProps.placement
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Popper, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(FocusTrap, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: viewContainerRole === 'tooltip'
            }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Transition, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, TransitionProps, slotProps === null || slotProps === void 0 ? void 0 : slotProps.desktopTransition, {
                    onExited: (event)=>{
                        var _slotProps_desktopTransition_onExited, _slotProps_desktopTransition, _TransitionProps_onExited;
                        onPopperExited === null || onPopperExited === void 0 ? void 0 : onPopperExited();
                        slotProps === null || slotProps === void 0 ? void 0 : (_slotProps_desktopTransition = slotProps.desktopTransition) === null || _slotProps_desktopTransition === void 0 ? void 0 : (_slotProps_desktopTransition_onExited = _slotProps_desktopTransition.onExited) === null || _slotProps_desktopTransition_onExited === void 0 ? void 0 : _slotProps_desktopTransition_onExited.call(_slotProps_desktopTransition, event);
                        TransitionProps === null || TransitionProps === void 0 ? void 0 : (_TransitionProps_onExited = TransitionProps.onExited) === null || _TransitionProps_onExited === void 0 ? void 0 : _TransitionProps_onExited.call(TransitionProps);
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8546de91339ee0c8$var$PickerPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}





var $7fPBF = parcelRequire("7fPBF");






const $a00ff025c4e5aa15$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// TODO v10: Remove user-agent sniffing. The Android branch is dead and the iOS branch is becoming
// irrelevant.
// https://github.com/mui/mui-x/pull/22710#discussion_r3377072061
const $a00ff025c4e5aa15$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $a00ff025c4e5aa15$var$androidVersion = $a00ff025c4e5aa15$var$mobileVersionMatches && $a00ff025c4e5aa15$var$mobileVersionMatches[1] ? parseInt($a00ff025c4e5aa15$var$mobileVersionMatches[1], 10) : null;
const $a00ff025c4e5aa15$var$iOSVersion = $a00ff025c4e5aa15$var$mobileVersionMatches && $a00ff025c4e5aa15$var$mobileVersionMatches[2] ? parseInt($a00ff025c4e5aa15$var$mobileVersionMatches[2], 10) : null;
const $a00ff025c4e5aa15$export$7e3b2a595fb375e5 = $a00ff025c4e5aa15$var$androidVersion && $a00ff025c4e5aa15$var$androidVersion < 10 || $a00ff025c4e5aa15$var$iOSVersion && $a00ff025c4e5aa15$var$iOSVersion < 13 || false;
function $a00ff025c4e5aa15$export$7e40eba507bb97c4(customReduceAnimations) {
    const prefersReduced = (0, $ec3395cd7fe43d7a$export$2e2bcd8739ae039)($a00ff025c4e5aa15$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || $a00ff025c4e5aa15$export$7e3b2a595fb375e5;
}





var $7fPBF = parcelRequire("7fPBF");



const $9967f2134ddca3ac$export$c9a0b669a5b51c7d = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
function $9967f2134ddca3ac$export$768f745bfa10c92a(parameters) {
    const { steps: steps, isViewMatchingStep: isViewMatchingStep, onStepChange: onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return $9967f2134ddca3ac$export$c9a0b669a5b51c7d;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}


'use client';
let $54e70f6a722a2ad6$var$warnedOnceNotValidView = false;
function $54e70f6a722a2ad6$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, getStepNavigation: getStepNavigation }) {
    const previousOpenTo = $7fPBF.useRef(openTo);
    const previousViews = $7fPBF.useRef(views);
    const defaultView = $7fPBF.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $7fPBF.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView: setView,
        view: view,
        defaultView: defaultView.current,
        views: views
    }) : (0, $9967f2134ddca3ac$export$c9a0b669a5b51c7d);
    $7fPBF.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    var _views_;
    const previousView = (_views_ = views[viewIndex - 1]) !== null && _views_ !== void 0 ? _views_ : null;
    var _views_1;
    const nextView = (_views_1 = views[viewIndex + 1]) !== null && _views_1 !== void 0 ? _views_1 : null;
    const handleFocusedViewChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange === null || onFocusedViewChange === void 0 ? void 0 : onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, stepNavigation, {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    });
}



var $7fPBF = parcelRequire("7fPBF");


'use client';
function $a977538a2027276d$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function $a977538a2027276d$export$550084c67147f6c4(views, customOrientation) {
    const [orientation, setOrientation] = $7fPBF.useState($a977538a2027276d$var$getOrientation);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($a977538a2027276d$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $3e1b4adab776c920$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation !== null && customOrientation !== void 0 ? customOrientation : orientation;
}





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



const $30766ef8faf316f9$export$ac06ac6808815c7c = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const [valueWithInputTimezone, setValue] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue !== null && defaultValue !== void 0 ? defaultValue : valueManager.emptyValue
    });
    const inputTimezone = $7fPBF.useMemo(()=>valueManager.getTimezone(adapter, valueWithInputTimezone), [
        adapter,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(adapter, inputTimezone, newValue);
    });
    const timezoneToRender = $7fPBF.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        adapter
    ]);
    const valueWithTimezoneToRender = $7fPBF.useMemo(()=>valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        adapter,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};




var $7fPBF = parcelRequire("7fPBF");


'use client';
function $578af4c71e4ea9ec$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const previousValidationErrorRef = $7fPBF.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $7fPBF.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}


'use client';
function $263440494a3fe50c$export$475fd52a3cfe883b(parameters) {
    const { props: props, valueManager: valueManager, validator: validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange: onChange, referenceDate: referenceDate, timezone: timezoneProp, onAccept: onAccept, closeOnSelect: closeOnSelect, open: openProp, onOpen: onOpen, onClose: onClose } = props;
    const { current: defaultValue } = $7fPBF.useRef(defaultValueProp);
    const { current: isValueControlled } = $7fPBF.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp !== undefined);
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone: timezone, value: value, handleValueChange: handleValueChange } = (0, $30766ef8faf316f9$export$ac06ac6808815c7c)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [state, setState] = $7fPBF.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $578af4c71e4ea9ec$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: props.onError
    });
    const setOpen = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    const setValue = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newValue, options)=>{
        const { changeImportance: changeImportance = 'accept', skipPublicationIfPristine: skipPublicationIfPristine = false, validationError: validationError, shortcut: shortcut, source: source, shouldClose: shouldClose = changeImportance === 'accept' } = options !== null && options !== void 0 ? options : {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                let inferredSource;
                if (source) inferredSource = source;
                else if (shortcut) inferredSource = 'view';
                else // Default to unknown when not explicitly tagged by a picker call site
                inferredSource = 'unknown';
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError,
                    source: inferredSource
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set',
            source: 'view'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $7fPBF.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(160));
            setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = $7fPBF.useMemo(()=>valueManager.cleanValue(adapter, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        adapter,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone: timezone,
        state: state,
        setValue: setValue,
        setValueFromView: setValueFromView,
        setOpen: setOpen,
        value: value,
        viewValue: viewValue
    };
}



'use client';
const $eb835d50c563d0a9$var$_excluded = [
    "className",
    "sx"
];
const $eb835d50c563d0a9$export$fc3313977ac596c4 = ({ ref: ref, props: props, valueManager: valueManager, valueType: valueType, variant: variant, validator: validator, onPopperExited: onPopperExited, autoFocusView: autoFocusView, rendererInterceptor: RendererInterceptor, localeText: localeText, viewContainerRole: viewContainerRole, getStepNavigation: getStepNavigation })=>{
    const { views: // View props
    views, view: viewProp, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker: disableOpenPicker, closeOnSelect: closeOnSelect, disabled: // Form props
    disabled, readOnly: readOnly, formatDensity: // Field props
    formatDensity, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, format: format, label: label, autoFocus: // Other props
    autoFocus, name: name, keepOpenDuringFieldFocus: keepOpenDuringFieldFocus } = props;
    const { className: className, sx: sx } = props, propsToForwardToView = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $eb835d50c563d0a9$var$_excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)();
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const reduceAnimations = (0, $a00ff025c4e5aa15$export$7e40eba507bb97c4)(reduceAnimationsProp);
    const orientation = (0, $a977538a2027276d$export$550084c67147f6c4)(views, orientationProp);
    const { current: initialView } = $7fPBF.useRef(openTo !== null && openTo !== void 0 ? openTo : null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = $7fPBF.useState(null);
    const popupRef = $7fPBF.useRef(null);
    const internalFieldRef = $7fPBF.useRef(null);
    const rootRefObject = $7fPBF.useRef(null);
    const rootRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, rootRefObject);
    const { timezone: timezone, state: state, setOpen: setOpen, setValue: setValue, setValueFromView: setValueFromView, value: value, viewValue: viewValue } = (0, $263440494a3fe50c$export$475fd52a3cfe883b)({
        props: props,
        valueManager: valueManager,
        validator: validator
    });
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView, goToNextStep: goToNextStep, hasNextStep: hasNextStep, hasSeveralSteps: hasSeveralSteps } = (0, $54e70f6a722a2ad6$export$9b46cba8f8ccd954)({
        view: viewProp,
        views: views,
        openTo: openTo,
        onChange: setValueFromView,
        onViewChange: onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation: getStepNavigation
    });
    const clearValue = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        var _internalFieldRef_current;
        if (value === null && ((_internalFieldRef_current = internalFieldRef.current) === null || _internalFieldRef_current === void 0 ? void 0 : _internalFieldRef_current.clearValue)) internalFieldRef.current.clearValue();
        setValue(valueManager.emptyValue, {
            source: 'view'
        });
    });
    const setValueToToday = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>setValue(valueManager.getTodayValue(adapter, timezone, valueType), {
            source: 'view'
        }));
    const acceptValueChanges = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>setValue(value, {
            source: 'view'
        }));
    const cancelValueChanges = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true,
            source: 'view'
        }));
    const dismissViews = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true,
            source: 'view'
        });
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup, timeViewsCount: timeViewsCount } = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, $b092b35a693ec4af$export$8f04d380cefd5a0d)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>currentViewMode);
    const [popperView, setPopperView] = $7fPBF.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                var _internalFieldRef_current, // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                _internalFieldRef_current1;
                internalFieldRef === null || internalFieldRef === void 0 ? void 0 : (_internalFieldRef_current = internalFieldRef.current) === null || _internalFieldRef_current === void 0 ? void 0 : _internalFieldRef_current.setSelectedSections(view);
                internalFieldRef === null || internalFieldRef === void 0 ? void 0 : (_internalFieldRef_current1 = internalFieldRef.current) === null || _internalFieldRef_current1 === void 0 ? void 0 : _internalFieldRef_current1.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = $7fPBF.useMemo(()=>{
        var _props_disabled, _props_readOnly;
        return {
            isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: (_props_disabled = props.disabled) !== null && _props_disabled !== void 0 ? _props_disabled : false,
            isPickerReadOnly: (_props_readOnly = props.readOnly) !== null && _props_readOnly !== void 0 ? _props_readOnly : false,
            pickerOrientation: orientation,
            pickerVariant: variant
        };
    }, [
        adapter,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = $7fPBF.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(goToNextStep);
    const defaultActionBarActions = $7fPBF.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = $7fPBF.useMemo(()=>({
            setValue: setValue,
            setOpen: setOpen,
            clearValue: clearValue,
            setValueToToday: setValueToToday,
            acceptValueChanges: acceptValueChanges,
            cancelValueChanges: cancelValueChanges,
            setView: setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actionsContextValue, {
            value: value,
            timezone: timezone,
            open: state.open,
            views: views,
            view: popperView,
            initialView: initialView,
            disabled: disabled !== null && disabled !== void 0 ? disabled : false,
            readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : false,
            autoFocus: autoFocus !== null && autoFocus !== void 0 ? autoFocus : false,
            variant: variant,
            orientation: orientation,
            popupRef: popupRef,
            reduceAnimations: reduceAnimations,
            triggerRef: triggerRef,
            triggerStatus: triggerStatus,
            keepOpenDuringFieldFocus: Boolean(keepOpenDuringFieldFocus),
            hasNextStep: hasNextStep,
            fieldFormat: format !== null && format !== void 0 ? format : '',
            name: name,
            label: label,
            rootSx: sx,
            rootRef: rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        keepOpenDuringFieldFocus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = $7fPBF.useMemo(()=>({
            dismissViews: dismissViews,
            ownerState: ownerState,
            hasUIView: hasUIView,
            getCurrentViewMode: getCurrentViewMode,
            rootRefObject: rootRefObject,
            labelId: labelId,
            triggerElement: triggerElement,
            viewContainerRole: viewContainerRole,
            defaultActionBarActions: defaultActionBarActions,
            onPopperExited: onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = $7fPBF.useMemo(()=>({
            formatDensity: formatDensity,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            internalFieldRef: internalFieldRef
        }), [
        formatDensity,
        selectedSections,
        onSelectedSectionsChange,
        internalFieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, propsToForwardToView, {
            views: views,
            timezone: timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount: timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView: focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText: localeText,
            contextValue: contextValue,
            privateContextValue: privateContextValue,
            actionsContextValue: actionsContextValue,
            fieldPrivateContextValue: fieldPrivateContextValue,
            isValidContextValue: isValidContextValue
        },
        renderCurrentView: renderCurrentView,
        ownerState: ownerState
    };
};





var $7fPBF = parcelRequire("7fPBF");






function $212f1905209e3dca$export$1671c31de798d429(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersLayout', slot);
}
const $212f1905209e3dca$export$7a6dac186703fe4c = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);





var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");















function $51d4adb71e3a4ff1$export$5a6f9035944c8119(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $51d4adb71e3a4ff1$var$buttonClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'outlined',
    'contained',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $51d4adb71e3a4ff1$export$2e2bcd8739ae039 = $51d4adb71e3a4ff1$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $6c601e9bdfa4b364$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $6c601e9bdfa4b364$export$2e2bcd8739ae039 = $6c601e9bdfa4b364$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $5ae2da91f81c1497$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $5ae2da91f81c1497$export$2e2bcd8739ae039 = $5ae2da91f81c1497$var$ButtonGroupButtonContext;




'use client';
const $7c35bba429ede747$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon'
        ],
        endIcon: [
            'icon',
            'endIcon'
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $51d4adb71e3a4ff1$export$5a6f9035944c8119), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $7c35bba429ede747$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $7c35bba429ede747$var$ButtonRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.button), {
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'background-color',
        'box-shadow',
        'border-color',
        'color'
    ], {
        duration: theme.transitions.duration.short
    })), {
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
                    'background-color',
                    'box-shadow',
                    'border-color'
                ], {
                    duration: theme.transitions.duration.short
                })), {
                    [`&.${(0, $51d4adb71e3a4ff1$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                })
            }
        ]
    });
}));
const $7c35bba429ede747$var$ButtonStartIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        alignItems: 'center',
        marginRight: 8,
        marginLeft: -4,
        '&::before': {
            content: '"\\200b"',
            width: 0,
            overflow: 'hidden'
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
                    'opacity'
                ], {
                    duration: theme.transitions.duration.short
                })), {
                    opacity: 0
                })
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$7c35bba429ede747$var$commonIconStyles
        ]
    }));
const $7c35bba429ede747$var$ButtonEndIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
                    'opacity'
                ], {
                    duration: theme.transitions.duration.short
                })), {
                    opacity: 0
                })
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$7c35bba429ede747$var$commonIconStyles
        ]
    }));
const $7c35bba429ede747$var$ButtonLoadingIndicator = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $7c35bba429ede747$var$ButtonLoadingIconPlaceholder = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $7c35bba429ede747$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $6c601e9bdfa4b364$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $5ae2da91f81c1497$export$2e2bcd8739ae039));
    const resolvedProps = (0, $0376810ac8b36fe3$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "color",
        "component",
        "className",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "id",
        "loading",
        "loadingIndicator",
        "loadingPosition",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    const loadingId = (0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp !== null && loadingIndicatorProp !== void 0 ? loadingIndicatorProp : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5310a643ead17d95$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $7c35bba429ede747$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7c35bba429ede747$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7c35bba429ede747$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7c35bba429ede747$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7c35bba429ede747$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $824c049f32d4395d$exports.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7c35bba429ede747$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    // Don't forward the 'root' classes to the ButtonBase, as they will get duplicated with the one passed to the className prop.
    const { root: root } = classes, forwardedClasses = (0, $8901fc92b5563702$export$71511d61b312f219)(classes, [
        "root"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7c35bba429ede747$var$ButtonRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        internalNativeButton: true,
        type: type,
        id: loading ? loadingId : idProp
    }, other), {
        classes: forwardedClasses,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    }));
});
var $7c35bba429ede747$export$2e2bcd8739ae039 = $7c35bba429ede747$var$Button;






'use client';
const $5c6c2d0b069137f6$var$_excluded = [
    "actions"
];
const $5c6c2d0b069137f6$var$PickersActionBarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $49c50691da23b940$export$2e2bcd8739ae039), {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $5c6c2d0b069137f6$var$PickersActionBarComponent(props) {
    const { actions: actions } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5c6c2d0b069137f6$var$_excluded);
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const { clearValue: clearValue, setValueToToday: setValueToToday, acceptValueChanges: acceptValueChanges, cancelValueChanges: cancelValueChanges, goToNextStep: goToNextStep, hasNextStep: hasNextStep } = (0, $603bd506ac49bd15$export$4495bebe53492ac8)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions === null || actions === void 0 ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c35bba429ede747$export$2e2bcd8739ae039), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5c6c2d0b069137f6$var$PickersActionBarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}
const $5c6c2d0b069137f6$export$72ffda3bb7ecf665 = /*#__PURE__*/ $7fPBF.memo($5c6c2d0b069137f6$var$PickersActionBarComponent);













var $7fPBF = parcelRequire("7fPBF");





'use client';
var $3ec0c74815b47347$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');













function $2f9a1ad555a0f55f$export$31444911e4ee6fdd(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiChip', slot);
}
const $2f9a1ad555a0f55f$var$chipClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'deletable',
    'outlined',
    'filled',
    'avatar',
    'icon',
    'label',
    'deleteIcon',
    'focusVisible'
]);
var $2f9a1ad555a0f55f$export$2e2bcd8739ae039 = $2f9a1ad555a0f55f$var$chipClasses;





'use client';
const $c44792dc96536365$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            onDelete && 'deletable'
        ],
        label: [
            'label'
        ],
        avatar: [
            'avatar'
        ],
        icon: [
            'icon'
        ],
        deleteIcon: [
            'deleteIcon'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $2f9a1ad555a0f55f$export$31444911e4ee6fdd), classes);
};
const $c44792dc96536365$var$ChipRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) && prop !== 'focusableWhenDisabled' && prop !== 'skipFocusWhenDisabled',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            styles.root,
            styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            onDelete && styles.deletable,
            styles[variant]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap'
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'background-color',
        'box-shadow'
    ])), {
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: {
                        color: (theme.vars || theme).palette.primary.contrastText,
                        backgroundColor: (theme.vars || theme).palette.primary.dark
                    }
                }
            },
            {
                props: {
                    color: 'secondary'
                },
                style: {
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: {
                        color: (theme.vars || theme).palette.secondary.contrastText,
                        backgroundColor: (theme.vars || theme).palette.secondary.dark
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4,
                        marginRight: -4,
                        width: 18,
                        height: 18,
                        fontSize: theme.typography.pxToRem(10)
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${(0, $2f9a1ad555a0f55f$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    });
}));
const $c44792dc96536365$var$ChipLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label'
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $c44792dc96536365$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $c44792dc96536365$var$Chip = /*#__PURE__*/ $7fPBF.forwardRef(function Chip(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "avatar",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant",
        "tabIndex",
        "skipFocusWhenDisabled",
        "slots",
        "slotProps"
    ]);
    const { nativeButton: nativeButton } = other, buttonBaseProps = (0, $8901fc92b5563702$export$71511d61b312f219)(other, [
        "nativeButton"
    ]);
    const chipRef = $7fPBF.useRef(null);
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $c44792dc96536365$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $c44792dc96536365$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $a3a679d546941285$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $c44792dc96536365$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $a3a679d546941285$export$2e2bcd8739ae039) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        component: ComponentProp || 'div',
        internalNativeButton: false,
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }, nativeButton !== undefined && {
        nativeButton: nativeButton
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $7fPBF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(deleteIconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ec0c74815b47347$export$2e2bcd8739ae039), {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $7fPBF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $7fPBF.cloneElement(avatarProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $7fPBF.isValidElement(iconProp)) icon = /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        elementType: $c44792dc96536365$var$ChipRoot,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, buttonBaseProps),
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        additionalProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex
        }, moreProps),
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onClick: (event)=>{
                    var _handlers_onClick;
                    (_handlers_onClick = handlers.onClick) === null || _handlers_onClick === void 0 ? void 0 : _handlers_onClick.call(handlers, event);
                    onClick === null || onClick === void 0 ? void 0 : onClick(event);
                },
                onKeyDown: (event)=>{
                    var _handlers_onKeyDown;
                    (_handlers_onKeyDown = handlers.onKeyDown) === null || _handlers_onKeyDown === void 0 ? void 0 : _handlers_onKeyDown.call(handlers, event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    var _handlers_onKeyUp;
                    (_handlers_onKeyUp = handlers.onKeyUp) === null || _handlers_onKeyUp === void 0 ? void 0 : _handlers_onKeyUp.call(handlers, event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('label', {
        elementType: $c44792dc96536365$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component
    }, rootProps), {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LabelSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, labelProps), {
                children: label
            })),
            deleteIcon
        ]
    }));
});
var $c44792dc96536365$export$2e2bcd8739ae039 = $c44792dc96536365$var$Chip;


const $bf2de1012f0783e6$export$3f0060ce4cc8f4d0 = 36;
const $bf2de1012f0783e6$export$dde58b009b497666 = 2;
const $bf2de1012f0783e6$export$ee46b8a74d6c94d3 = 320;
const $bf2de1012f0783e6$export$73724491020e90c7 = 280;
const $bf2de1012f0783e6$export$f2fef360e2df0cb7 = 336;
const $bf2de1012f0783e6$export$1c2eabda4acea0e4 = 232;
const $bf2de1012f0783e6$export$a462ceb9cfdb5d71 = 48;




var $7fPBF = parcelRequire("7fPBF");

'use client';
const $f2b6adb4280d964b$export$64b5b0e74c5c8445 = ()=>{
    const value = $7fPBF.useContext((0, $266c452779606bb3$export$d1dfa4910c58a4e));
    if (value == null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(148));
    return value;
};



'use client';
const $7b4ed701af90f494$var$_excluded = [
    "items",
    "changeImportance"
], $7b4ed701af90f494$var$_excluded2 = [
    "getValue"
];
const $7b4ed701af90f494$var$PickersShortcutsRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $13e3cdc57dc522c3$export$2e2bcd8739ae039), {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $7b4ed701af90f494$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = 'accept' } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7b4ed701af90f494$var$_excluded);
    const { setValue: setValue } = (0, $f2b6adb4280d964b$export$64b5b0e74c5c8445)();
    const isValidValue = (0, $35a6f30d863ede10$export$52df06af7329e367)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $7b4ed701af90f494$var$_excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance: changeImportance,
                    shortcut: item,
                    source: 'view'
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7b4ed701af90f494$var$PickersShortcutsRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $bf2de1012f0783e6$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            var _item_id;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b8e2be557d769e87$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44792dc96536365$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item))
            }, (_item_id = item.id) !== null && _item_id !== void 0 ? _item_id : item.label);
        })
    }));
}





'use client';
const $8da69bab0ff4e8cc$var$_excluded = [
    "ownerState"
];
function $8da69bab0ff4e8cc$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $8da69bab0ff4e8cc$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $212f1905209e3dca$export$1671c31de798d429), classes);
};
const $8da69bab0ff4e8cc$var$usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions: defaultActionBarActions } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const { view: view } = (0, $603bd506ac49bd15$export$4495bebe53492ac8)();
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const { children: children, slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const ownerState = $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr',
            hasShortcuts: false
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = $8da69bab0ff4e8cc$var$useUtilityClasses(classesProp, ownerState);
    var _slots_actionBar;
    // Action bar
    const ActionBar = (_slots_actionBar = slots === null || slots === void 0 ? void 0 : slots.actionBar) !== null && _slots_actionBar !== void 0 ? _slots_actionBar : (0, $5c6c2d0b069137f6$export$72ffda3bb7ecf665);
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState: ownerState
    }), actionBarProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $8da69bab0ff4e8cc$var$_excluded);
    const actionBar = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ActionBar, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots === null || slots === void 0 ? void 0 : slots.toolbar;
    const toolbarProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.toolbar,
        className: classes.toolbar,
        ownerState: ownerState
    });
    const toolbar = $8da69bab0ff4e8cc$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Toolbar, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots === null || slots === void 0 ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Tabs, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        className: classes.tabs
    }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.tabs)) : null;
    var _slots_shortcuts;
    // Shortcuts
    const Shortcuts = (_slots_shortcuts = slots === null || slots === void 0 ? void 0 : slots.shortcuts) !== null && _slots_shortcuts !== void 0 ? _slots_shortcuts : (0, $7b4ed701af90f494$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.shortcuts,
        className: classes.shortcuts,
        ownerState: ownerState
    });
    const hasShortcuts = Array.isArray(shortcutsProps === null || shortcutsProps === void 0 ? void 0 : shortcutsProps.items) && shortcutsProps.items.length > 0;
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Shortcuts, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            hasShortcuts: hasShortcuts
        })
    };
};
var $8da69bab0ff4e8cc$export$2e2bcd8739ae039 = $8da69bab0ff4e8cc$var$usePickerLayout;




'use client';
const $d51971d9b4444569$var$_excluded = [
    "sx",
    "className",
    "classes",
    "children",
    "slots",
    "slotProps"
];
const $d51971d9b4444569$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $212f1905209e3dca$export$1671c31de798d429), classes);
};
const $d51971d9b4444569$export$9a9363506c13836 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: false
            },
            style: {
                [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '1 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: true
            },
            style: {
                [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1,
                    maxWidth: 'max-content'
                },
                [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: 2
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                hasShortcuts: true,
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${(0, $212f1905209e3dca$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 4
                }
            }
        }
    ]
});
const $d51971d9b4444569$export$bc1494d918129235 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $d51971d9b4444569$export$647f604ea2397c05 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $8da69bab0ff4e8cc$export$2e2bcd8739ae039)(props);
    const { orientation: orientation, variant: variant } = (0, $603bd506ac49bd15$export$4495bebe53492ac8)();
    const { sx: sx, className: className, classes: classesProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $d51971d9b4444569$var$_excluded);
    const classes = $d51971d9b4444569$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d51971d9b4444569$export$9a9363506c13836, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        sx: sx,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d51971d9b4444569$export$bc1494d918129235, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    }));
});




function $52f6be834eae5f31$export$57511d4166284144(parameters) {
    const { steps: steps } = parameters;
    return (0, $9967f2134ddca3ac$export$768f745bfa10c92a)({
        steps: steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step: step, defaultView: defaultView, setView: setView, view: view, views: views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}




const $88ceaa8c066f05e1$var$_excluded = [
    "props",
    "steps"
], $88ceaa8c066f05e1$var$_excluded2 = [
    "ownerState"
];
const $88ceaa8c066f05e1$export$b1b70bc56ac5be0e = (_ref)=>{
    var _innerSlotProps_toolbar;
    let { props: props, steps: steps } = _ref, pickerParams = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $88ceaa8c066f05e1$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $52f6be834eae5f31$export$57511d4166284144)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $eb835d50c563d0a9$export$fc3313977ac596c4)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'desktop',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    var _innerSlotProps_toolbar_hidden;
    const isToolbarHidden = (_innerSlotProps_toolbar_hidden = innerSlotProps === null || innerSlotProps === void 0 ? void 0 : (_innerSlotProps_toolbar = innerSlotProps.toolbar) === null || _innerSlotProps_toolbar === void 0 ? void 0 : _innerSlotProps_toolbar.hidden) !== null && _innerSlotProps_toolbar_hidden !== void 0 ? _innerSlotProps_toolbar_hidden : false;
    const Field = slots.field;
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps === null || innerSlotProps === void 0 ? void 0 : innerSlotProps.field,
        externalForwardedProps: (0, $3e1b4adab776c920$export$1427765d2f0e99a5)(props),
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $88ceaa8c066f05e1$var$_excluded2);
    var _slots_layout;
    const Layout = (_slots_layout = slots.layout) !== null && _slots_layout !== void 0 ? _slots_layout : (0, $d51971d9b4444569$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps === null || innerSlotProps === void 0 ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        popper: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps === null || innerSlotProps === void 0 ? void 0 : innerSlotProps.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $266c452779606bb3$export$aae9fbe9dd4050fa), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Field, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slots, fieldProps.slots),
                    slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slotProps, fieldProps.slotProps),
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8546de91339ee0c8$export$ac84dff7cf037abd), {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Layout, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");

'use client';
const $e0420c5af5e82979$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'fieldRef',
    'startFieldRef',
    'endFieldRef',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
const $e0420c5af5e82979$export$be857fabf132acea = (props, valueType)=>{
    return $7fPBF.useMemo(()=>{
        const forwardedProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $e0420c5af5e82979$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') (0, $95d6db0fe23c2dc0$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === 'time') (0, $95d6db0fe23c2dc0$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === 'date-time') {
            (0, $95d6db0fe23c2dc0$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $95d6db0fe23c2dc0$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $95d6db0fe23c2dc0$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
}; /**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ 






const $ff37b552d0052bdb$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $ff37b552d0052bdb$export$66d00048b8bb82f6 = ({ stateResponse: { localizedDigits: // States and derived states
localizedDigits, sectionsValueBoundaries: sectionsValueBoundaries, state: state, timezone: timezone, setCharacterQuery: // Methods to update the states
setCharacterQuery, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue } })=>{
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$ff37b552d0052bdb$var$isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($ff37b552d0052bdb$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($ff37b552d0052bdb$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $22f2351be8dc685a$export$3ee1e7e19c2b047a)(adapter, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $22f2351be8dc685a$export$2f3c5fac7a2a65f6)(adapter, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($ff37b552d0052bdb$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $22f2351be8dc685a$export$2816862a602354ce)(adapter, fallbackValue, adapter.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue: queryValue, skipIfBelowMinimum: skipIfBelowMinimum, section: section })=>{
            const cleanQueryValue = (0, $22f2351be8dc685a$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $22f2351be8dc685a$export$ef88db4bceade9fd)(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue: queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $22f2351be8dc685a$export$78b5830e2dd2de49)(adapter, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if ($ff37b552d0052bdb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $22f2351be8dc685a$export$2816862a602354ce)(adapter, response.sectionValue, 'MM', activeSection.format);
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if ($ff37b552d0052bdb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $22f2351be8dc685a$export$c65c7173f879039f)(adapter, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $22f2351be8dc685a$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    return (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, $22f2351be8dc685a$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, params, {
            keyPressed: (0, $22f2351be8dc685a$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section: section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
}; /**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */  /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ 




var $7fPBF = parcelRequire("7fPBF");









const $13d7bc1895e201a3$var$expandFormat = ({ adapter: adapter, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = adapter.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = adapter.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(154));
    }
    return nextFormat;
};
const $13d7bc1895e201a3$var$getEscapedPartsFromFormat = ({ adapter: adapter, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = adapter.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $13d7bc1895e201a3$var$getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: adapter.formatByString(adapter.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $13d7bc1895e201a3$var$createSection = ({ adapter: adapter, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(155));
    const sectionConfig = (0, $22f2351be8dc685a$export$2f3c5fac7a2a65f6)(adapter, token);
    const hasLeadingZerosInFormat = (0, $22f2351be8dc685a$export$78b5830e2dd2de49)(adapter, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = adapter.isValid(date);
    let sectionValue = isValidDate ? adapter.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? adapter.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(156, token));
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $22f2351be8dc685a$export$80dbbc19eba82070)((0, $22f2351be8dc685a$export$713c6d756c12fc27)((0, $22f2351be8dc685a$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $13d7bc1895e201a3$var$getSectionPlaceholder(adapter, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $13d7bc1895e201a3$var$buildSections = (parameters)=>{
    const { adapter: adapter, expandedFormat: expandedFormat, escapedParts: escapedParts } = parameters;
    const now = adapter.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        var _regExpFirstWordInFormat_exec;
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = (_regExpFirstWordInFormat_exec = regExpFirstWordInFormat.exec(expandedFormat.slice(i))) === null || _regExpFirstWordInFormat_exec === void 0 ? void 0 : _regExpFirstWordInFormat_exec[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($13d7bc1895e201a3$var$createSection((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parameters, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar === null || escapedPartOfCurrentChar === void 0 ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar === null || escapedPartOfCurrentChar === void 0 ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $13d7bc1895e201a3$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $13d7bc1895e201a3$export$34084be60bfe3b3b = (parameters)=>{
    let expandedFormat = $13d7bc1895e201a3$var$expandFormat(parameters);
    if (parameters.isRtl) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $13d7bc1895e201a3$var$getEscapedPartsFromFormat((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parameters, {
        expandedFormat: expandedFormat
    }));
    const sections = $13d7bc1895e201a3$var$buildSections((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parameters, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $13d7bc1895e201a3$var$postProcessSections((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, parameters, {
        sections: sections
    }));
};





'use client';
const $5be328edd92a725d$var$QUERY_LIFE_DURATION_MS = 5000;
const $5be328edd92a725d$export$4e8d6353e50062e7 = (parameters)=>{
    var _state_sections_state_characterQuery_sectionIndex;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const { manager: { validator: validator, valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp }, forwardedProps: { error: errorProp } } = parameters;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $30766ef8faf316f9$export$ac06ac6808815c7c)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const valueRef = $7fPBF.useRef(value);
    $7fPBF.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError: hasValidationError } = (0, $578af4c71e4ea9ec$export$87fe492f99f25a20)({
        props: internalPropsWithDefaults,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: internalPropsWithDefaults.onError
    });
    const localizedDigits = $7fPBF.useMemo(()=>(0, $22f2351be8dc685a$export$b42be9ae7016ef5d)(adapter), [
        adapter
    ]);
    const sectionsValueBoundaries = $7fPBF.useMemo(()=>(0, $22f2351be8dc685a$export$360600f456ea7d5f)(adapter, localizedDigits, timezone), [
        adapter,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $7fPBF.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, $13d7bc1895e201a3$export$34084be60bfe3b3b)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        adapter,
        formatDensity
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, $22f2351be8dc685a$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format: format,
                isRtl: isRtl,
                locale: adapter.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, $ca987ffc32eec519$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: value,
            adapter: adapter,
            props: internalPropsWithDefaults,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange === null || onSelectedSectionsChange === void 0 ? void 0 : onSelectedSectionsChange(newSelectedSections);
    };
    const parsedSelectedSections = $7fPBF.useMemo(()=>(0, $22f2351be8dc685a$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = $7fPBF.useMemo(()=>(0, $22f2351be8dc685a$export$7725fd6fe0a2aadf)(state.sections), [
        state.sections
    ]);
    const areAllSectionsEmpty = $7fPBF.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    // When the field loses focus (no active section), consider partially filled sections as invalid.
    // This enforces that the field must be entirely filled or entirely empty on blur.
    const hasPartiallyFilledSectionsOnBlur = $7fPBF.useMemo(()=>{
        if (activeSectionIndex != null) return false;
        const filledSections = state.sections.filter((s)=>s.value !== '');
        return filledSections.length > 0 && state.sections.length - filledSections.length > 0;
    }, [
        state.sections,
        activeSectionIndex
    ]);
    const error = $7fPBF.useMemo(()=>{
        if (errorProp !== undefined) return errorProp;
        return hasValidationError || hasPartiallyFilledSectionsOnBlur;
    }, [
        hasValidationError,
        hasPartiallyFilledSectionsOnBlur,
        errorProp
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter: adapter,
                value: newValue,
                timezone: timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = $7fPBF.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = adapter.parse(dateStr, format);
            if (!adapter.isValid(date)) return null;
            const sections = (0, $13d7bc1895e201a3$export$34084be60bfe3b3b)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                isRtl: isRtl
            });
            return (0, $22f2351be8dc685a$export$6c6df982c77f60a9)(adapter, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const updateSectionValue = ({ section: section, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, $22f2351be8dc685a$export$b0c1bfd065bfe742)(adapter, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (adapter.isValid(newActiveDate)) {
            const mergedDate = (0, $22f2351be8dc685a$export$6c6df982c77f60a9)(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || adapter.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `newActiveDate to prevent error state oscillation`.
     * @link: https://github.com/mui/mui-x/issues/17967
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    const setCharacterQuery = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newCharacterQuery)=>{
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        const isActiveDateInvalid = sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]));
        let sections;
        if (isActiveDateInvalid) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                lastExternalValue: value,
                sections: sections,
                sectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                referenceValue: isActiveDateInvalid ? prevState.referenceValue : fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, $22f2351be8dc685a$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, prevState, {
                lastSectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                sections: sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && ((_state_sections_state_characterQuery_sectionIndex = state.sections[state.characterQuery.sectionIndex]) === null || _state_sections_state_characterQuery_sectionIndex === void 0 ? void 0 : _state_sections_state_characterQuery_sectionIndex.type) !== state.characterQuery.sectionType) setCharacterQuery(null);
    $7fPBF.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    $7fPBF.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start($5be328edd92a725d$var$QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $7fPBF.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        activeSectionIndex: // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty: areAllSectionsEmpty,
        error: error,
        localizedDigits: localizedDigits,
        parsedSelectedSections: parsedSelectedSections,
        sectionOrder: sectionOrder,
        sectionsValueBoundaries: sectionsValueBoundaries,
        state: state,
        timezone: timezone,
        value: value,
        clearValue: // Methods to update the states
        clearValue,
        clearActiveSection: clearActiveSection,
        setCharacterQuery: setCharacterQuery,
        setSelectedSections: setSelectedSections,
        setTempAndroidValueStr: setTempAndroidValueStr,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        getSectionsFromValue: // Utilities methods
        getSectionsFromValue
    };
};




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

'use client';
const $9b16b02e0e0a9752$export$20c6f014e602a134 = ()=>$7fPBF.useContext((0, $603bd506ac49bd15$export$b72b8dade9393cd5));



function $4f2fdf36be839d44$export$e2fe2bbcb0489bc7(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps: internalProps, skipContextFieldRefAssignment: skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, $9b16b02e0e0a9752$export$20c6f014e602a134)();
    const fieldPrivateContext = (0, $6e1a1c224f194aa0$export$700ab01cf24fdb1)();
    const handleFieldRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(internalProps.fieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext === null || fieldPrivateContext === void 0 ? void 0 : fieldPrivateContext.internalFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext === null || fieldPrivateContext === void 0 ? void 0 : fieldPrivateContext.fieldRef);
    const setValue = pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.setValue;
    const handleChangeFromPicker = $7fPBF.useCallback((newValue, ctx)=>{
        return setValue === null || setValue === void 0 ? void 0 : setValue(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = $7fPBF.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            fieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}




function $c9d84b4e9de55f7d$export$ce8bf2f461033ebb(parameters) {
    const { focused: focused, domGetters: domGetters, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, state: state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(domGetters.getRoot()).getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
        selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, $3e1b4adab776c920$export$cd4e5573fbe2b576)(domGetters.getRoot()))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}








function $67e84bafbbff2e1d$export$45510bb94d9a4b66(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, focused: focused, setFocused: setFocused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, internalPropsWithDefaults: internalPropsWithDefaults, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, sectionOrder: sectionOrder, state: state, value: value, activeSectionIndex: activeSectionIndex, localizedDigits: localizedDigits, timezone: timezone, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateValueFromValueStr: updateValueFromValueStr, updateSectionValue: updateSectionValue }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false, minutesStep: minutesStep } } = parameters;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const handleKeyDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        var _event_key;
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && (((_event_key = event.key) === null || _event_key === void 0 ? void 0 : _event_key.toUpperCase()) === 'A' || String.fromCharCode(event.keyCode) === 'A') && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = $67e84bafbbff2e1d$var$adjustSectionValue(adapter, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    const containerClickTimeout = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    const handleClick = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        if (disabled || !domGetters.isReady()) return;
        if (parsedSelectedSections === 'all') {
            setFocused(true);
            containerClickTimeout.start(0, ()=>{
                // `getSelection`/`getRangeAt` can be unset transiently (e.g. focus
                // moved before this 0-tick callback ran). Fall back to the first
                // section in that case.
                const selection = document.getSelection();
                if (!selection || selection.rangeCount === 0) {
                    setSelectedSections(sectionOrder.startIndex);
                    return;
                }
                const cursorPosition = selection.getRangeAt(0).startOffset;
                if (cursorPosition === 0) {
                    setSelectedSections(sectionOrder.startIndex);
                    return;
                }
                let sectionIndex = 0;
                let cursorOnStartOfSection = 0;
                while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                    const section = state.sections[sectionIndex];
                    sectionIndex += 1;
                    cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
                }
                setSelectedSections(sectionIndex - 1);
            });
            return;
        }
        // For trusted pointer input, `handleMouseDown` already ran and set the
        // section. This branch only matters for `click` events that arrive
        // without a preceding `mousedown` (programmatic `element.click()`, some
        // assistive-technology activations, synthetic event sequences in tests).
        // Fall back to the first section so the field doesn't enter a "focused
        // but no active section" state.
        if (!focused) {
            setFocused(true);
            if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
        }
    });
    // Replaces Chromium's focus delegation with an explicit section focus on
    // every primary mousedown inside the sections container. The CSS gate
    // (`WebkitUserModify: read-only` while not `:focus-within`) can make the
    // section's contenteditable span temporarily non-focusable, in which case
    // Chromium falls back to the sections-container `tabindex=0` and our
    // `handleFocus` then runs the "no active section" fallback, briefly
    // selecting the first section before the click bubble corrects it.
    // Setting the target section here (and letting `syncSelectionToDOM` move
    // focus via `.focus()`, which works even with the user-modify rule
    // active) skips that race entirely.
    const handleMouseDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        if (disabled || !domGetters.isReady() || parsedSelectedSections === 'all') return;
        if (event.button !== 0) return;
        const target = event.target;
        // `sectionListRoot` is the sections container (a descendant of the
        // InputBase root that owns this handler). The guard rejects clicks on
        // sibling adornments (open / clear buttons, etc.) which have their own
        // behavior and must not get intercepted here.
        const sectionListRoot = domGetters.getRoot();
        if (!sectionListRoot.contains(target)) return;
        // Prefer the visually-containing section (matches Chromium's
        // delegation + section container `onClick`), fall back to the
        // closest-by-distance section for padding / past-last-section clicks.
        const sectionElement = target.closest('[data-sectionindex]');
        const parsedIndex = sectionElement ? Number(sectionElement.dataset.sectionindex) : $67e84bafbbff2e1d$var$findClosestSectionIndexToPoint(sectionListRoot, event.clientX);
        // `Number(undefined) === NaN` and `NaN == null === false`, so guard
        // explicitly here even though `data-sectionindex` is set by
        // `useFieldSectionContainerProps` for every section in practice.
        if (parsedIndex == null || !Number.isInteger(parsedIndex)) return;
        event.preventDefault();
        setFocused(true);
        // `mousedown` is now authoritative for pointer section selection. The
        // section container's own `onClick` deduplicates against the resulting
        // `parsedSelectedSections` on the click bubble (see
        // `useFieldSectionContainerProps`), so we always select here and let that
        // guard absorb the redundant call -- matching the pre-PR
        // `onSelectedSectionsChange` invocation count.
        setSelectedSections(parsedIndex);
    });
    const handleInput = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        var _target_textContent;
        const keyPressed = (_target_textContent = target.textContent) !== null && _target_textContent !== void 0 ? _target_textContent : '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, $c9d84b4e9de55f7d$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, $3e1b4adab776c920$export$cd4e5573fbe2b576)(domGetters.getRoot());
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, $3e1b4adab776c920$export$cd4e5573fbe2b576)(domGetters.getRoot());
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: internalPropsWithDefaults.disabled || parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}
/**
 * Returns the index of the section whose horizontal center is closest to `clientX`.
 * Returns `null` if the field renders no `[role="spinbutton"]` descendants
 * (defensive — every section content span sets `role="spinbutton"` in practice).
 */ function $67e84bafbbff2e1d$var$findClosestSectionIndexToPoint(root, clientX) {
    const sections = root.querySelectorAll('[role="spinbutton"]');
    if (sections.length === 0) return null;
    let closestIndex = 0;
    let closestDistance = Infinity;
    for(let i = 0; i < sections.length; i += 1){
        const rect = sections[i].getBoundingClientRect();
        const center = (rect.left + rect.right) / 2;
        const distance = Math.abs(clientX - center);
        if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
        }
    }
    return closestIndex;
}
function $67e84bafbbff2e1d$var$getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function $67e84bafbbff2e1d$var$adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = $67e84bafbbff2e1d$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, $22f2351be8dc685a$export$ef88db4bceade9fd)(adapter, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && (stepsAttributes === null || stepsAttributes === void 0 ? void 0 : stepsAttributes.minutesStep) ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return adapter.formatByString(adapter.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, $22f2351be8dc685a$export$7dd321105a319e8)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, $22f2351be8dc685a$export$3ee1e7e19c2b047a)(adapter, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}



var $7fPBF = parcelRequire("7fPBF");

function $bfbba9d7935a5809$export$9c7e79f1afdc4487(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, state: state, updateValueFromValueStr: // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $7fPBF.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getHiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}



var $7fPBF = parcelRequire("7fPBF");

function $130e2104956a9a9e$export$b8da0597bcdfa361(parameters) {
    const { stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, setSelectedSections: // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled: disabled = false } } = parameters;
    // A single stable handler shared by every section, rather than a per-index
    // factory. The section index is read from the container's `data-sectionindex`
    // at click time, and `useEventCallback` reads the latest `disabled` /
    // `parsedSelectedSections` / `setSelectedSections` internally -- so none of
    // them sit in a dependency array and the `onClick` identity stays stable
    // across renders (`setSelectedSections` is recreated on every render, which
    // would otherwise churn the handler).
    const handleClick = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call to this function is actually intended, or a side effect.
        if (disabled || event.isDefaultPrevented()) return;
        // `currentTarget` is the section container, which always carries
        // `data-sectionindex` (set below). Guard the parse defensively all the
        // same -- `Number(undefined)` is `NaN`, and `NaN === parsedSelectedSections`
        // is always false, so it would otherwise reach `setSelectedSections(NaN)`.
        const sectionIndex = Number(event.currentTarget.dataset.sectionindex);
        if (!Number.isInteger(sectionIndex)) return;
        // For pointer input the `mousedown` handler already selected the section
        // before this click bubbles, so bail to avoid a redundant
        // `onSelectedSectionsChange` invocation. On the non-pointer paths
        // (programmatic `element.click()`, some AT activations) `mousedown`
        // didn't run, so `parsedSelectedSections` won't match yet and selection
        // proceeds normally.
        if (parsedSelectedSections === sectionIndex) return;
        setSelectedSections(sectionIndex);
    });
    return $7fPBF.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: handleClick
        }), [
        handleClick
    ]);
}



var $7fPBF = parcelRequire("7fPBF");




function $70a164505701ddfd$export$ef10e76e860835f1(parameters) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const { focused: focused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, state: state, value: value, localizedDigits: localizedDigits, clearActiveSection: // Methods to update the states
    clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, $c9d84b4e9de55f7d$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    const handleInput = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        var _target_textContent;
        const keyPressed = (_target_textContent = target.textContent) !== null && _target_textContent !== void 0 ? _target_textContent : '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = $7fPBF.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $7fPBF.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-readonly': readOnly,
            'aria-valuenow': $70a164505701ddfd$var$getSectionValueNow(section, adapter, localizedDigits),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? $70a164505701ddfd$var$getSectionValueText(section, adapter, localizedDigits) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: !isEditable || isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            // Firefox hydrates this as `'none`' instead of `'off'`. No problems in chromium with both values.
            // For reference https://github.com/mui/mui-x/issues/19012
            autoCapitalize: isEditable ? 'none' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        adapter,
        localizedDigits,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function $70a164505701ddfd$var$getSectionValueText(section, adapter, localizedDigits) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') {
                    const dateWithMonth = adapter.setMonth(adapter.date(), Number((0, $22f2351be8dc685a$export$7dd321105a319e8)(section.value, localizedDigits)) - 1);
                    return adapter.isValid(dateWithMonth) ? adapter.format(dateWithMonth, 'month') : '';
                }
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate && adapter.isValid(parsedDate) ? adapter.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            if (section.contentType === 'digit') {
                const dateWithDay = adapter.setDate(adapter.startOfYear(adapter.date()), Number((0, $22f2351be8dc685a$export$7dd321105a319e8)(section.value, localizedDigits)));
                // Announce a cardinal day (e.g. "2"), not a locale ordinal (e.g. French "2ème").
                // See https://github.com/mui/mui-x/issues/22915.
                return adapter.isValid(dateWithDay) ? adapter.format(dateWithDay, 'dayOfMonth') : '';
            }
            return section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function $70a164505701ddfd$var$getSectionValueNow(section, adapter, localizedDigits) {
    if (!section.value) return undefined;
    const nonLocalizedValue = (0, $22f2351be8dc685a$export$7dd321105a319e8)(section.value, localizedDigits);
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(nonLocalizedValue);
        case 'meridiem':
            {
                const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
                if (parsedDate) return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(nonLocalizedValue, 10) : Number(nonLocalizedValue);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(nonLocalizedValue);
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(nonLocalizedValue) : undefined;
    }
}


'use client';
const $fdcd71b1eaa93763$export$294aa081a6c6f55d = (parameters)=>{
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $e0420c5af5e82979$export$be857fabf132acea)(props, valueType);
    const internalPropsWithDefaults = (0, $4f2fdf36be839d44$export$e2fe2bbcb0489bc7)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur: onBlur, onClick: onClick, onMouseDown: onMouseDown, onFocus: onFocus, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable } = forwardedProps;
    const { disabled: disabled = false, readOnly: readOnly = false, autoFocus: autoFocus = false, focused: focusedProp, fieldRef: fieldRef } = internalPropsWithDefaults;
    const sectionListRef = $7fPBF.useRef(null);
    const handleSectionListRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(sectionListRefProp, sectionListRef);
    const domGetters = $7fPBF.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, $5be328edd92a725d$export$4e8d6353e50062e7)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, error: error, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, setSelectedSections: setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, $ff37b552d0052bdb$export$66d00048b8bb82f6)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = $7fPBF.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        $fdcd71b1eaa93763$var$getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, $22f2351be8dc685a$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, $67e84bafbbff2e1d$export$45510bb94d9a4b66)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        focused: focused,
        setFocused: setFocused,
        domGetters: domGetters
    });
    const hiddenInputProps = (0, $bfbba9d7935a5809$export$9c7e79f1afdc4487)({
        manager: manager,
        stateResponse: stateResponse
    });
    const createSectionContainerProps = (0, $130e2104956a9a9e$export$b8da0597bcdfa361)({
        stateResponse: stateResponse,
        internalPropsWithDefaults: internalPropsWithDefaults
    });
    const createSectionContentProps = (0, $70a164505701ddfd$export$ef10e76e860835f1)({
        manager: manager,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        internalPropsWithDefaults: internalPropsWithDefaults,
        domGetters: domGetters,
        focused: focused
    });
    const handleRootKeyDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        rootProps.onBlur(event);
        // Skip the user callback when focus is only moving to another element inside the field
        // (e.g. the section that gains focus after the focusable root gives it up).
        const next = event.relatedTarget;
        if (domGetters.isReady() && next instanceof Node && domGetters.getRoot().contains(next)) return;
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    });
    const handleRootFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        rootProps.onFocus(event);
        // Skip the user callback when focus is only arriving from another element inside the field
        // (e.g. the focusable root receiving it before it is forwarded to a section, and the section
        // focus event bubbling back up to the root).
        const previous = event.relatedTarget;
        if (domGetters.isReady() && previous instanceof Node && domGetters.getRoot().contains(previous)) return;
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    });
    const handleRootClick = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        rootProps.onClick(event);
    });
    const handleRootMouseDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // The `isDefaultPrevented` check skips mousedowns that have already been
        // suppressed before this handler runs -- in particular, propagated events
        // from the clear / open buttons whose own handlers `preventDefault`, and
        // capture-phase parents that intentionally block field interactions.
        // Userland `onMouseDown` calling `event.preventDefault()` does *not*
        // suppress `rootProps.onMouseDown` here: the prevent fires *after* this
        // check, and `rootProps.onMouseDown` is the section-selection mechanism
        // for the field -- letting consumers disable it inline would leave the
        // field unable to focus a section on click.
        if (event.isDefaultPrevented()) return;
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        rootProps.onMouseDown(event);
    });
    const handleRootPaste = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        onPaste === null || onPaste === void 0 ? void 0 : onPaste(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        onInput === null || onInput === void 0 ? void 0 : onInput(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear === null || onClear === void 0 ? void 0 : onClear(event, ...args);
        clearValue();
        if (!$fdcd71b1eaa93763$var$isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = $7fPBF.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: content,
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    $7fPBF.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(249));
        if (autoFocus && !disabled) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        (0, $c9d84b4e9de55f7d$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    $7fPBF.useImperativeHandle(fieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>$fdcd71b1eaa93763$var$getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, $22f2351be8dc685a$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField: focusField,
            isFieldFocused: ()=>$fdcd71b1eaa93763$var$isFieldFocused(sectionListRef),
            clearValue: clearValue
        }));
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onMouseDown: handleRootMouseDown,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp !== null && focusedProp !== void 0 ? focusedProp : focused,
        sectionListRef: handleSectionListRef,
        elements: // Additional
        elements,
        areAllSectionsEmpty: areAllSectionsEmpty,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
function $fdcd71b1eaa93763$var$getActiveSectionIndex(sectionListRef) {
    var _sectionListRef_current;
    const activeElement = (0, $3e1b4adab776c920$export$cd4e5573fbe2b576)((_sectionListRef_current = sectionListRef.current) === null || _sectionListRef_current === void 0 ? void 0 : _sectionListRef_current.getRoot());
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function $fdcd71b1eaa93763$var$isFieldFocused(sectionListRef) {
    var _sectionListRef_current;
    const activeElement = (0, $3e1b4adab776c920$export$cd4e5573fbe2b576)((_sectionListRef_current = sectionListRef.current) === null || _sectionListRef_current === void 0 ? void 0 : _sectionListRef_current.getRoot());
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}



'use client';
const $2d171a2ba59f3830$export$5591b0b878c1a989 = (props)=>{
    const manager = (0, $b7fa3b3c8a55dd1e$export$6b73f8c5013b806e)();
    return (0, $fdcd71b1eaa93763$export$294aa081a6c6f55d)({
        manager: manager,
        props: props
    });
};





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");


function $1299ed8e89b4e17a$export$fe06f3f35a7c97cd(parameters) {
    const { ownerState: pickerOwnerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    return $7fPBF.useMemo(()=>{
        var _parameters_disabled, _parameters_readOnly, _parameters_required;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            isFieldDisabled: (_parameters_disabled = parameters.disabled) !== null && _parameters_disabled !== void 0 ? _parameters_disabled : false,
            isFieldReadOnly: (_parameters_readOnly = parameters.readOnly) !== null && _parameters_readOnly !== void 0 ? _parameters_readOnly : false,
            isFieldRequired: (_parameters_required = parameters.required) !== null && _parameters_required !== void 0 ? _parameters_required : false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        });
    }, [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}





var $7fPBF = parcelRequire("7fPBF");

const $3ad354549f02ea44$export$ed0fe318cc298673 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $3ad354549f02ea44$export$8afed21ef5c2afa5 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $3ad354549f02ea44$export$9ca09caa9c849d9c = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $3ad354549f02ea44$export$5fda1783bb83f57b = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $3ad354549f02ea44$export$8099ab97743c966c = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $3ad354549f02ea44$export$90a8eab2a2411720 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $3ad354549f02ea44$export$7e95adcf912503e3 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $3ad354549f02ea44$export$cefbac224a47f32 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');






var $7fPBF = parcelRequire("7fPBF");













function $236f3f2e41c76175$export$d99678ed7aad1677(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersTextField', slot);
}
const $236f3f2e41c76175$export$284739773a7ae972 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);





var $7fPBF = parcelRequire("7fPBF");










function $4e578c70c1fcad98$export$3821cb625ac26962(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersInputBase', slot);
}
const $4e578c70c1fcad98$export$f20b5ba262568322 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'readOnly',
    'error',
    'notchedOutline',
    'sectionsContainer',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'inputSizeSmall',
    'activeBar'
]);


function $2b243c5f4e81bcf6$export$c0dd951a3959ac7f(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersOutlinedInput', slot);
}
const $2b243c5f4e81bcf6$export$a7da60486bcc91df = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $4e578c70c1fcad98$export$f20b5ba262568322), (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));




parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
'use client';
const $f4d7be8bdf00aee1$export$b7e46bfe0a5d9502 = /*#__PURE__*/ $7fPBF.createContext(null);
const $f4d7be8bdf00aee1$export$589d98a5b6c57f51 = ()=>{
    const value = $7fPBF.useContext($f4d7be8bdf00aee1$export$b7e46bfe0a5d9502);
    if (value == null) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(146));
    return value;
};



const $8f3ead42d7aaa5a9$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $8f3ead42d7aaa5a9$var$OutlineRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
});
const $8f3ead42d7aaa5a9$var$OutlineLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    slot: 'internal',
    shouldForwardProp: undefined
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $8f3ead42d7aaa5a9$var$OutlineLegend = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('legend', {
    slot: 'internal',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'notched'
})(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $8f3ead42d7aaa5a9$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8f3ead42d7aaa5a9$var$_excluded);
    const ownerState = (0, $f4d7be8bdf00aee1$export$589d98a5b6c57f51)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8f3ead42d7aaa5a9$var$OutlineRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8f3ead42d7aaa5a9$var$OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8f3ead42d7aaa5a9$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $824c049f32d4395d$exports.jsx)($8f3ead42d7aaa5a9$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}






var $7fPBF = parcelRequire("7fPBF");
















var $7fPBF = parcelRequire("7fPBF");







function $f24adf390339bc6f$export$f891a98d04ce6513(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersSectionList', slot);
}
const $f24adf390339bc6f$export$8455939b33d2ee90 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);




'use client';
const $8e67a48a32f0357a$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const $8e67a48a32f0357a$export$4ee86b293725486c = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $8e67a48a32f0357a$export$30e7187e386feb4f = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const $8e67a48a32f0357a$export$c403b59604f63120 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const $8e67a48a32f0357a$export$1f2c61561fe3d6 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const $8e67a48a32f0357a$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $f24adf390339bc6f$export$f891a98d04ce6513), classes);
};
function $8e67a48a32f0357a$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    var _slots_section;
    const Section = (_slots_section = slots === null || slots === void 0 ? void 0 : slots.section) !== null && _slots_section !== void 0 ? _slots_section : $8e67a48a32f0357a$export$30e7187e386feb4f;
    const sectionProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Section,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: ownerState
    });
    var _slots_sectionContent;
    const SectionContent = (_slots_sectionContent = slots === null || slots === void 0 ? void 0 : slots.sectionContent) !== null && _slots_sectionContent !== void 0 ? _slots_sectionContent : $8e67a48a32f0357a$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: SectionContent,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: ownerState
    });
    var _slots_sectionSeparator;
    const SectionSeparator = (_slots_sectionSeparator = slots === null || slots === void 0 ? void 0 : slots.sectionSeparator) !== null && _slots_sectionSeparator !== void 0 ? _slots_sectionSeparator : $8e67a48a32f0357a$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    // Only propagate blur when focus leaves the SectionContent entirely.
    const sectionContentRef = $7fPBF.useRef(null);
    const handleSectionContentRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(sectionContentProps.ref, sectionContentRef);
    const handleContentBlur = (event)=>{
        const next = event.relatedTarget;
        // If the next focused element stays within the whole field (root),
        // do not propagate blur. We only want blur when leaving the field entirely.
        const root = event.currentTarget.closest(`.${(0, $f24adf390339bc6f$export$8455939b33d2ee90).root}`);
        if (root && next instanceof Node && root.contains(next)) {
            event.stopPropagation();
            return;
        }
    // Otherwise, focus left the whole field; allow propagation.
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(Section, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SectionSeparator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SectionContent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionContentProps, {
                ref: handleSectionContentRef,
                onBlur: handleContentBlur
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SectionSeparator, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $8e67a48a32f0357a$export$847fd4b97819700 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef, classes: classesProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8e67a48a32f0357a$var$_excluded);
    const classes = $8e67a48a32f0357a$var$useUtilityClasses(classesProp);
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const rootRef = $7fPBF.useRef(null);
    const handleRootRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(145, methodName));
        return rootRef.current;
    };
    $7fPBF.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${(0, $f24adf390339bc6f$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${(0, $f24adf390339bc6f$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $f24adf390339bc6f$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $f24adf390339bc6f$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $f24adf390339bc6f$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    var _slots_root;
    const Root = (_slots_root = slots === null || slots === void 0 ? void 0 : slots.root) !== null && _slots_root !== void 0 ? _slots_root : $8e67a48a32f0357a$export$4ee86b293725486c;
    const rootProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8e67a48a32f0357a$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});




'use client';
const $5be307406ca1ce7d$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
], $5be307406ca1ce7d$var$_excluded2 = [
    "ref"
];
function $5be307406ca1ce7d$var$mergePickersInputBaseSectionContentSlotProps(consumerSlotProps, baseClassName) {
    return (ownerState)=>{
        var _resolveComponentProps;
        const resolved = (_resolveComponentProps = (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)(consumerSlotProps, ownerState)) !== null && _resolveComponentProps !== void 0 ? _resolveComponentProps : {};
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, resolved, {
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(baseClassName, resolved.className)
        });
    };
}
const $5be307406ca1ce7d$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $5be307406ca1ce7d$export$ddc18880178d980e = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$5be307406ca1ce7d$var$round(0.15 / 16)}em`,
        [`&.${(0, $4e578c70c1fcad98$export$f20b5ba262568322).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $5be307406ca1ce7d$export$52f3fbbfe9321824 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $8e67a48a32f0357a$export$4ee86b293725486c), {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    justifyContent: 'end'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                // While the field is empty and blurred, the format is shown as a placeholder.
                props: {
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            },
            {
                // ...except when a non-shrunk label sits in the notch, where the format would overlap it.
                // A start adornment always shrinks the label, so it never triggers this case.
                props: {
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    hasStartAdornment: false,
                    inputHasLabel: true,
                    isLabelShrunk: false
                },
                style: {
                    opacity: 0
                }
            }
        ]
    }));
const $5be307406ca1ce7d$var$PickersInputBaseSection = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $8e67a48a32f0357a$export$30e7187e386feb4f), {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $5be307406ca1ce7d$var$PickersInputBaseSectionContent = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $8e67a48a32f0357a$export$1f2c61561fe3d6), {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none',
        // Disables Chromium's focus-delegation onto contenteditable descendants
        // while the field is not focused. The bug is Chromium-only, and applying
        // `WebkitUserModify` on WebKit breaks Playwright's `fill()` editability
        // check, so we gate on a Chromium-only CSS property (`-webkit-app-region`,
        // a Blink/Electron extension WebKit never adopted) via `@supports`.
        // The WebKit exclusion is empirical, not guaranteed across versions: the
        // regression guard is the WebKit `fill()` cases in the browser e2e suite,
        // which would fail if a future WebKit started matching this `@supports`.
        '@supports (-webkit-app-region: drag)': {
            [`.${(0, $4e578c70c1fcad98$export$f20b5ba262568322).root}:not(:focus-within) &`]: {
                WebkitUserModify: 'read-only',
                userSelect: 'none'
            }
        }
    }));
const $5be307406ca1ce7d$var$PickersInputBaseSectionSeparator = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $8e67a48a32f0357a$export$c403b59604f63120), {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $5be307406ca1ce7d$var$PickersInputBaseInput = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $a1838e012595e8ac$export$2e2bcd8739ae039)));
const $5be307406ca1ce7d$var$PickersInputBaseActiveBar = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const $5be307406ca1ce7d$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldReadOnly: isFieldReadOnly, hasFieldError: hasFieldError, inputSize: inputSize, isInputInFullWidth: isInputInFullWidth, inputColor: inputColor, hasStartAdornment: hasStartAdornment, hasEndAdornment: hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, $c2e12d7064dac06e$export$2e2bcd8739ae039)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $4e578c70c1fcad98$export$3821cb625ac26962), classes);
};
function $5be307406ca1ce7d$var$resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    // Only measure sections that belong to a range date.
    if (sectionElement.content['data-range-position'] !== undefined) {
        var _rootRef_current;
        const activeSectionElements = (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function $5be307406ca1ce7d$var$resolveSectionWidthAndOffsets(elements, rootRef) {
    var _rootRef_current, _rootRef_current_querySelector, _rootRef_current1, _rootRef_current_querySelector1, _rootRef_current2;
    let activeBarWidth = 0;
    const activeRangePosition = (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += $5be307406ca1ce7d$var$resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += $5be307406ca1ce7d$var$resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth: activeBarWidth,
        sectionOffsets: [
            ((_rootRef_current1 = rootRef.current) === null || _rootRef_current1 === void 0 ? void 0 : (_rootRef_current_querySelector = _rootRef_current1.querySelector(`[data-sectionindex="0"]`)) === null || _rootRef_current_querySelector === void 0 ? void 0 : _rootRef_current_querySelector.offsetLeft) || 0,
            ((_rootRef_current2 = rootRef.current) === null || _rootRef_current2 === void 0 ? void 0 : (_rootRef_current_querySelector1 = _rootRef_current2.querySelector(`[data-sectionindex="${elements.length / 2}"]`)) === null || _rootRef_current_querySelector1 === void 0 ? void 0 : _rootRef_current_querySelector1.offsetLeft) || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const $5be307406ca1ce7d$export$ff827734ba831074 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputRef: inputRef, sectionListRef: sectionListRef, onFocus: onFocus, onBlur: onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5be307406ca1ce7d$var$_excluded);
    const ownerStateContext = (0, $f4d7be8bdf00aee1$export$589d98a5b6c57f51)();
    const rootRef = $7fPBF.useRef(null);
    const activeBarRef = $7fPBF.useRef(null);
    const sectionOffsetsRef = $7fPBF.useRef([]);
    const handleRootRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, rootRef);
    const muiFormControl = (0, $7c05b6d5a150dbd8$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error((0, $047add07c951d037$export$5201d50a34753d71)(152));
    const ownerState = ownerStateProp !== null && ownerStateProp !== void 0 ? ownerStateProp : ownerStateContext;
    const handleInputFocus = (event)=>{
        var _muiFormControl_onFocus;
        (_muiFormControl_onFocus = muiFormControl.onFocus) === null || _muiFormControl_onFocus === void 0 ? void 0 : _muiFormControl_onFocus.call(muiFormControl, event);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            var _rootRef_current, _rootRef_current1;
            // Do nothing if it's a multi input field
            if ((_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.dataset.multiInput) return;
            const closestForm = (_rootRef_current1 = rootRef.current) === null || _rootRef_current1 === void 0 ? void 0 : _rootRef_current1.closest('form');
            const submitTrigger = closestForm === null || closestForm === void 0 ? void 0 : closestForm.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        var _muiFormControl_onBlur;
        (_muiFormControl_onBlur = muiFormControl.onBlur) === null || _muiFormControl_onBlur === void 0 ? void 0 : _muiFormControl_onBlur.call(muiFormControl, event);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $7fPBF.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = $5be307406ca1ce7d$var$useUtilityClasses(classesProp, ownerState);
    const InputRoot = (slots === null || slots === void 0 ? void 0 : slots.root) || $5be307406ca1ce7d$export$ddc18880178d980e;
    const inputRootProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: InputRoot,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = (slots === null || slots === void 0 ? void 0 : slots.input) || $5be307406ca1ce7d$export$52f3fbbfe9321824;
    const HtmlInputComponent = (slots === null || slots === void 0 ? void 0 : slots.htmlInput) || $5be307406ca1ce7d$var$PickersInputBaseInput;
    const _ref = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: HtmlInputComponent,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.htmlInput,
        ownerState: ownerState
    }), { ref: resolvedHtmlInputRef } = _ref, htmlInputProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $5be307406ca1ce7d$var$_excluded2);
    const handleInputRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(resolvedHtmlInputRef, inputRef);
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    $7fPBF.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth: activeBarWidth, sectionOffsets: sectionOffsets } = $5be307406ca1ce7d$var$resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(InputRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e67a48a32f0357a$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $5be307406ca1ce7d$var$PickersInputBaseSection,
                    sectionContent: $5be307406ca1ce7d$var$PickersInputBaseSectionContent,
                    sectionSeparator: $5be307406ca1ce7d$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.input, {
                        ownerState: ownerState
                    }),
                    sectionContent: $5be307406ca1ce7d$var$mergePickersInputBaseSectionContentSlotProps(slotProps === null || slotProps === void 0 ? void 0 : slotProps.sectionContent, (0, $4e578c70c1fcad98$export$f20b5ba262568322).sectionContent),
                    sectionSeparator: ({ separatorPosition: separatorPosition })=>({
                            className: separatorPosition === 'before' ? (0, $4e578c70c1fcad98$export$f20b5ba262568322).sectionBefore : (0, $4e578c70c1fcad98$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(HtmlInputComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, htmlInputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5be307406ca1ce7d$var$PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});




'use client';
const $82703d0829709534$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched",
    "slots",
    "slotProps"
];
const $82703d0829709534$var$PickersOutlinedInputRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $5be307406ca1ce7d$export$ddc18880178d980e), {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    var _theme_vars;
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).focused} .${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).error} .${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            }
        },
        variants: Object.keys(((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette)// @ts-ignore
        .filter((key)=>{
            var _palette_key;
            var _theme_vars, _palette_key_main;
            return (_palette_key_main = (_palette_key = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette[key]) === null || _palette_key === void 0 ? void 0 : _palette_key.main) !== null && _palette_key_main !== void 0 ? _palette_key_main : false;
        }).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).focused}:not(.${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).error}) .${(0, $2b243c5f4e81bcf6$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $82703d0829709534$var$PickersOutlinedInputSectionsContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $5be307406ca1ce7d$export$52f3fbbfe9321824), {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $82703d0829709534$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $2b243c5f4e81bcf6$export$c0dd951a3959ac7f), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $82703d0829709534$export$44d4d00edb0c710f = /*#__PURE__*/ $7fPBF.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, classes: classesProp, notched: notched, slots: inSlots, slotProps: inSlotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $82703d0829709534$var$_excluded);
    const muiFormControl = (0, $7c05b6d5a150dbd8$export$2e2bcd8739ae039)();
    const classes = $82703d0829709534$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5be307406ca1ce7d$export$ff827734ba831074), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            root: $82703d0829709534$var$PickersOutlinedInputRoot,
            input: $82703d0829709534$var$PickersOutlinedInputSectionsContainer
        }, inSlots),
        slotProps: inSlotProps,
        renderSuffix: (state)=>{
            const isNotched = typeof notched !== 'undefined' ? notched : Boolean(state.adornedStart || state.focused || state.filled);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f3ead42d7aaa5a9$export$2e2bcd8739ae039), {
                shrink: isNotched,
                notched: isNotched,
                className: classes.notchedOutline,
                label: label != null && label !== '' && (muiFormControl === null || muiFormControl === void 0 ? void 0 : muiFormControl.required) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            });
        },
        label: label,
        classes: classes,
        ref: ref
    }));
});
$82703d0829709534$export$44d4d00edb0c710f.muiName = 'Input';





var $7fPBF = parcelRequire("7fPBF");









function $7f1620d59a71fc67$export$6cb188bdacb35d0e(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersFilledInput', slot);
}
const $7f1620d59a71fc67$export$3964d3188824d772 = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $4e578c70c1fcad98$export$f20b5ba262568322), (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));






'use client';
const $b4733a16b82967db$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes",
    "slots",
    "slotProps"
];
const $b4733a16b82967db$var$PickersFilledInputRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $5be307406ca1ce7d$export$ddc18880178d980e), {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    var _theme_vars;
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $7f1620d59a71fc67$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $7f1620d59a71fc67$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys(((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette)// @ts-ignore
            .filter((key)=>{
                var _theme_vars;
                return ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette[key].main;
            }).map((color)=>{
                var _palette_color;
                return {
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(_palette_color = (theme.vars || theme).palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main}`
                        }
                    }
                };
            }),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $7f1620d59a71fc67$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $7f1620d59a71fc67$export$3964d3188824d772).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $7f1620d59a71fc67$export$3964d3188824d772).disabled}, .${(0, $7f1620d59a71fc67$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $7f1620d59a71fc67$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $b4733a16b82967db$var$PickersFilledSectionsContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $5be307406ca1ce7d$export$52f3fbbfe9321824), {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $b4733a16b82967db$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7f1620d59a71fc67$export$6cb188bdacb35d0e), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $b4733a16b82967db$export$8cc8c624890b5045 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, hiddenLabel: hiddenLabel = false, classes: classesProp, slots: inSlots, slotProps: inSlotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $b4733a16b82967db$var$_excluded);
    const pickerTextFieldOwnerState = (0, $f4d7be8bdf00aee1$export$589d98a5b6c57f51)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $b4733a16b82967db$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5be307406ca1ce7d$export$ff827734ba831074), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            root: $b4733a16b82967db$var$PickersFilledInputRoot,
            input: $b4733a16b82967db$var$PickersFilledSectionsContainer
        }, inSlots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inSlotProps, {
            root: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                disableUnderline: disableUnderline
            }, inSlotProps === null || inSlotProps === void 0 ? void 0 : inSlotProps.root),
            input: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                hiddenLabel: hiddenLabel
            }, inSlotProps === null || inSlotProps === void 0 ? void 0 : inSlotProps.input)
        }),
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
$b4733a16b82967db$export$8cc8c624890b5045.muiName = 'Input';





var $7fPBF = parcelRequire("7fPBF");









function $ac71796868496f02$export$defbb17803ff7cff(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersFilledInput', slot);
}
const $ac71796868496f02$export$f5c5ba079c8bb9dd = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $4e578c70c1fcad98$export$f20b5ba262568322), (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));






'use client';
const $e870b0a280761a26$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes",
    "slots",
    "slotProps"
];
const $e870b0a280761a26$var$PickersInputRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $5be307406ca1ce7d$export$ddc18880178d980e), {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    var _theme_vars;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys(((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette)// @ts-ignore
            .filter((key)=>{
                var _theme_vars;
                return ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        inputColor: color,
                        inputHasUnderline: true
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    inputHasUnderline: true
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $ac71796868496f02$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $ac71796868496f02$export$f5c5ba079c8bb9dd).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $ac71796868496f02$export$f5c5ba079c8bb9dd).disabled}, .${(0, $ac71796868496f02$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $ac71796868496f02$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $e870b0a280761a26$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $ac71796868496f02$export$defbb17803ff7cff), classes);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $e870b0a280761a26$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, classes: classesProp, slots: inSlots, slotProps: inSlotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e870b0a280761a26$var$_excluded);
    const pickerTextFieldOwnerState = (0, $f4d7be8bdf00aee1$export$589d98a5b6c57f51)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $e870b0a280761a26$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5be307406ca1ce7d$export$ff827734ba831074), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            root: $e870b0a280761a26$var$PickersInputRoot
        }, inSlots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inSlotProps, {
            root: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                disableUnderline: disableUnderline
            }, inSlotProps === null || inSlotProps === void 0 ? void 0 : inSlotProps.root)
        }),
        ownerState: ownerState,
        label: label,
        classes: classes,
        ref: ref
    }));
});
$e870b0a280761a26$export$7c4ebb2cfaf4f474.muiName = 'Input';





'use client';
const $917c109bede1b47e$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "hiddenLabel",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onMouseDown",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "label",
    "slots",
    "slotProps",
    "data-active-range-position"
];
const $917c109bede1b47e$var$VARIANT_COMPONENT = {
    standard: (0, $e870b0a280761a26$export$7c4ebb2cfaf4f474),
    filled: (0, $b4733a16b82967db$export$8cc8c624890b5045),
    outlined: (0, $82703d0829709534$export$44d4d00edb0c710f)
};
const $917c109bede1b47e$var$PickersTextFieldRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const $917c109bede1b47e$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldRequired: isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $236f3f2e41c76175$export$d99678ed7aad1677), classes);
};
const $917c109bede1b47e$export$b3e9b101d92e4d4d = /*#__PURE__*/ $7fPBF.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, classes: classesProp, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, hiddenLabel: hiddenLabel = false, inputRef: // Props used by PickersInput
    inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onMouseDown: onMouseDown, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, label: // Props used by InputLabel
    label, slots: // Slot system
    slots, slotProps: slotProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $917c109bede1b47e$var$_excluded);
    const rootRef = $7fPBF.useRef(null);
    const handleRootRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const inputSlotProps = slotProps === null || slotProps === void 0 ? void 0 : slotProps.input;
    const inputLabelSlotProps = slotProps === null || slotProps === void 0 ? void 0 : slotProps.inputLabel;
    const fieldOwnerState = (0, $1299ed8e89b4e17a$export$fe06f3f35a7c97cd)({
        disabled: props.disabled,
        required: props.required,
        readOnly: inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.readOnly
    });
    const ownerState = $7fPBF.useMemo(()=>{
        var _props_size;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused !== null && focused !== void 0 ? focused : false,
            hasFieldError: error !== null && error !== void 0 ? error : false,
            inputSize: (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : 'medium',
            inputColor: color !== null && color !== void 0 ? color : 'primary',
            isInputInFullWidth: fullWidth !== null && fullWidth !== void 0 ? fullWidth : false,
            hasStartAdornment: Boolean(startAdornment !== null && startAdornment !== void 0 ? startAdornment : inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.startAdornment),
            hasEndAdornment: Boolean(endAdornment !== null && endAdornment !== void 0 ? endAdornment : inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.endAdornment),
            inputHasLabel: !!label,
            isLabelShrunk: Boolean(inputLabelSlotProps === null || inputLabelSlotProps === void 0 ? void 0 : inputLabelSlotProps.shrink)
        });
    }, [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.startAdornment,
        inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.endAdornment,
        label,
        inputLabelSlotProps === null || inputLabelSlotProps === void 0 ? void 0 : inputLabelSlotProps.shrink
    ]);
    const classes = $917c109bede1b47e$var$useUtilityClasses(classesProp, ownerState);
    var _slots_input;
    const PickersInputComponent = (_slots_input = slots === null || slots === void 0 ? void 0 : slots.input) !== null && _slots_input !== void 0 ? _slots_input : $917c109bede1b47e$var$VARIANT_COMPONENT[variant];
    var _slots_root;
    const RootComponent = (_slots_root = slots === null || slots === void 0 ? void 0 : slots.root) !== null && _slots_root !== void 0 ? _slots_root : $917c109bede1b47e$var$PickersTextFieldRoot;
    var _slots_inputLabel;
    const InputLabelComponent = (_slots_inputLabel = slots === null || slots === void 0 ? void 0 : slots.inputLabel) !== null && _slots_inputLabel !== void 0 ? _slots_inputLabel : (0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039);
    var _slots_formHelperText;
    const FormHelperTextComponent = (_slots_formHelperText = slots === null || slots === void 0 ? void 0 : slots.formHelperText) !== null && _slots_formHelperText !== void 0 ? _slots_formHelperText : (0, $0230b9d36bca11dc$export$2e2bcd8739ae039);
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    } else if (variant === 'filled') inputAdditionalProps.hiddenLabel = hiddenLabel;
    const rootSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: RootComponent,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.root,
        externalForwardedProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
            className: className
        }),
        additionalProps: {
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required
        },
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f4d7be8bdf00aee1$export$b7e46bfe0a5d9502).Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rootSlotProps, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputLabelComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    htmlFor: id,
                    id: inputLabelId
                }, inputLabelSlotProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PickersInputComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onMouseDown: onMouseDown,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, inputSlotProps, {
                    slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.slots, (slots === null || slots === void 0 ? void 0 : slots.htmlInput) !== undefined && {
                        htmlInput: slots.htmlInput
                    }),
                    slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, inputSlotProps === null || inputSlotProps === void 0 ? void 0 : inputSlotProps.slotProps, (slotProps === null || slotProps === void 0 ? void 0 : slotProps.htmlInput) !== undefined && {
                        htmlInput: slotProps.htmlInput
                    })
                })),
                helperText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(FormHelperTextComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    id: helperTextId
                }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.formHelperText, {
                    children: helperText
                }))
            ]
        }))
    });
});



'use client';
const $07836ed0da29a707$var$_excluded = [
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel",
    "InputProps",
    "inputProps",
    "InputLabelProps",
    "FormHelperTextProps"
], $07836ed0da29a707$var$_excluded2 = [
    "ownerState"
], $07836ed0da29a707$var$_excluded3 = [
    "ownerState"
], $07836ed0da29a707$var$_excluded4 = [
    "ownerState"
], $07836ed0da29a707$var$_excluded5 = [
    "ownerState"
], $07836ed0da29a707$var$_excluded6 = [
    "InputProps",
    "inputProps",
    "InputLabelProps",
    "FormHelperTextProps"
];
const $07836ed0da29a707$export$d31e0c72c716cd73 = (fieldResponse)=>{
    var _other_slotProps;
    const _ref = fieldResponse, { readOnly: readOnly, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel, // TODO v10: remove
    // Explicitly discard legacy props that are no longer supported on `PickersTextField`.
    // Without this, any leftover values would silently leak into `...other` and end up spread
    // as unknown attributes on the underlying form control.
    InputProps: legacyInputProps, inputProps: legacyHtmlInputProps, InputLabelProps: legacyInputLabelProps, FormHelperTextProps: legacyFormHelperTextProps } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $07836ed0da29a707$var$_excluded);
    return {
        clearable: clearable,
        onClear: onClear,
        clearButtonPosition: clearButtonPosition,
        openPickerButtonPosition: openPickerButtonPosition,
        openPickerAriaLabel: openPickerAriaLabel,
        textFieldProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
            slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other === null || other === void 0 ? void 0 : other.slotProps, {
                input: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other === null || other === void 0 ? void 0 : (_other_slotProps = other.slotProps) === null || _other_slotProps === void 0 ? void 0 : _other_slotProps.input, {
                    readOnly: readOnly
                })
            })
        })
    };
};
const $07836ed0da29a707$export$f5bc58012fe60483 = /*#__PURE__*/ $7fPBF.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function $07836ed0da29a707$export$f83254b974f9d6d3(props) {
    var _textFieldProps_slotProps;
    const { fieldResponse: fieldResponse, defaultOpenPickerIcon: defaultOpenPickerIcon } = props;
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const pickerContext = (0, $9b16b02e0e0a9752$export$20c6f014e602a134)();
    const pickerFieldUIContext = $7fPBF.useContext($07836ed0da29a707$export$f5bc58012fe60483);
    const { textFieldProps: textFieldProps, onClear: onClear, clearable: clearable, openPickerAriaLabel: openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = $07836ed0da29a707$export$d31e0c72c716cd73(fieldResponse);
    const ownerState = (0, $1299ed8e89b4e17a$export$fe06f3f35a7c97cd)(textFieldProps);
    const handleClickOpeningButton = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        // Force open instead of toggling to avoid conflicts with field-level open-on-focus logic
        pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.setOpen(true);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    var _pickerFieldUIContext_slots_textField;
    const TextField = (_pickerFieldUIContext_slots_textField = pickerFieldUIContext.slots.textField) !== null && _pickerFieldUIContext_slots_textField !== void 0 ? _pickerFieldUIContext_slots_textField : (0, $917c109bede1b47e$export$b3e9b101d92e4d4d);
    var _pickerFieldUIContext_slots_inputAdornment;
    const InputAdornment = (_pickerFieldUIContext_slots_inputAdornment = pickerFieldUIContext.slots.inputAdornment) !== null && _pickerFieldUIContext_slots_inputAdornment !== void 0 ? _pickerFieldUIContext_slots_inputAdornment : (0, $decc99a0f014db0d$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $07836ed0da29a707$var$_excluded2);
    const _useSlotProps2 = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps2, $07836ed0da29a707$var$_excluded3);
    var _pickerFieldUIContext_slots_openPickerButton;
    const OpenPickerButton = (_pickerFieldUIContext_slots_openPickerButton = pickerFieldUIContext.slots.openPickerButton) !== null && _pickerFieldUIContext_slots_openPickerButton !== void 0 ? _pickerFieldUIContext_slots_openPickerButton : (0, $6767d63d9006cc81$export$2e2bcd8739ae039);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            // Mark this element so field handlers can ignore its events
            'data-mui-picker-open-button': 'true',
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState: ownerState
    }), openPickerButtonProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps3, $07836ed0da29a707$var$_excluded4);
    var _pickerFieldUIContext_slots_openPickerIcon;
    const OpenPickerIcon = (_pickerFieldUIContext_slots_openPickerIcon = pickerFieldUIContext.slots.openPickerIcon) !== null && _pickerFieldUIContext_slots_openPickerIcon !== void 0 ? _pickerFieldUIContext_slots_openPickerIcon : defaultOpenPickerIcon;
    const openPickerIconProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState: ownerState
    });
    var _pickerFieldUIContext_slots_clearButton;
    const ClearButton = (_pickerFieldUIContext_slots_clearButton = pickerFieldUIContext.slots.clearButton) !== null && _pickerFieldUIContext_slots_clearButton !== void 0 ? _pickerFieldUIContext_slots_clearButton : (0, $6767d63d9006cc81$export$2e2bcd8739ae039);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: ClearButton,
        externalSlotProps: pickerFieldUIContext.slotProps.clearButton,
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState: ownerState
    }), clearButtonProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps4, $07836ed0da29a707$var$_excluded5);
    var _pickerFieldUIContext_slots_clearIcon;
    const ClearIcon = (_pickerFieldUIContext_slots_clearIcon = pickerFieldUIContext.slots.clearIcon) !== null && _pickerFieldUIContext_slots_clearIcon !== void 0 ? _pickerFieldUIContext_slots_clearIcon : (0, $3ad354549f02ea44$export$cefbac224a47f32);
    const clearIconProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: ClearIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.clearIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    textFieldProps.ref = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(textFieldProps.ref, pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.rootRef);
    const externalInputSlotProps = (_textFieldProps_slotProps = textFieldProps.slotProps) === null || _textFieldProps_slotProps === void 0 ? void 0 : _textFieldProps_slotProps.input;
    const additionalInputSlotProps = {};
    const forkedInputRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(externalInputSlotProps === null || externalInputSlotProps === void 0 ? void 0 : externalInputSlotProps.ref, pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.triggerRef);
    if (pickerContext) additionalInputSlotProps.ref = forkedInputRef;
    if (!(externalInputSlotProps === null || externalInputSlotProps === void 0 ? void 0 : externalInputSlotProps.startAdornment) && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) additionalInputSlotProps.startAdornment = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(InputAdornment, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(OpenPickerButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(OpenPickerIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClearButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClearIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, clearIconProps))
            }))
        ]
    }));
    if (!(externalInputSlotProps === null || externalInputSlotProps === void 0 ? void 0 : externalInputSlotProps.endAdornment) && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) additionalInputSlotProps.endAdornment = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(InputAdornment, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClearButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClearIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(OpenPickerButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(OpenPickerIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, openPickerIconProps))
            }))
        ]
    }));
    // handle the case of showing custom `inputAdornment` for Field components
    if (!additionalInputSlotProps.endAdornment && !additionalInputSlotProps.startAdornment && pickerFieldUIContext.slots.inputAdornment) additionalInputSlotProps.endAdornment = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(InputAdornment, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, endInputAdornmentProps));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    textFieldProps.slotProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, textFieldProps.slotProps, {
        input: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, externalInputSlotProps, additionalInputSlotProps)
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TextField, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, textFieldProps));
}
function $07836ed0da29a707$export$b01d1e419b049226(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)(slotPropsB, ownerState), (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)(slotPropsA, ownerState));
    };
}
function $07836ed0da29a707$export$fa1adc26aa0d007a(parameters) {
    const { ref: ref, externalForwardedProps: externalForwardedProps, slotProps: slotProps } = parameters;
    const pickerFieldUIContext = $7fPBF.useContext($07836ed0da29a707$export$f5bc58012fe60483);
    const pickerContext = (0, $9b16b02e0e0a9752$export$20c6f014e602a134)();
    const ownerState = (0, $1299ed8e89b4e17a$export$fe06f3f35a7c97cd)(externalForwardedProps);
    // TODO v10: remove
    // Strip the legacy `InputProps` / `inputProps` / `InputLabelProps` / `FormHelperTextProps`
    // before they reach `PickersTextField`, which would silently ignore them. JS users without
    // TypeScript checks would otherwise see their configuration vanish.
    const _ref2 = externalForwardedProps !== null && externalForwardedProps !== void 0 ? externalForwardedProps : {}, { InputProps: legacyInputProps, inputProps: legacyHtmlInputProps, InputLabelProps: legacyInputLabelProps, FormHelperTextProps: legacyFormHelperTextProps } = _ref2, sanitizedExternalForwardedProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref2, $07836ed0da29a707$var$_excluded6);
    const textFieldProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: (0, $917c109bede1b47e$export$b3e9b101d92e4d4d),
        externalSlotProps: $07836ed0da29a707$export$b01d1e419b049226(pickerFieldUIContext.slotProps.textField, slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField),
        externalForwardedProps: sanitizedExternalForwardedProps,
        additionalProps: {
            ref: ref,
            sx: pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.rootSx,
            label: pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.label,
            name: pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.name,
            className: pickerContext === null || pickerContext === void 0 ? void 0 : pickerContext.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState: ownerState
    });
    // When requested, open the picker when the user focuses/clicks the field to edit
    if (pickerContext && pickerContext.keepOpenDuringFieldFocus && pickerContext.triggerStatus === 'enabled' && !pickerContext.open && !pickerContext.readOnly && !pickerContext.disabled) {
        const prevOnFocus = textFieldProps.onFocus;
        const prevOnMouseDown = textFieldProps.onMouseDown;
        const isFromOpenButton = (event)=>{
            var _nativeEvent_composedPath;
            var _event_nativeEvent;
            const nativeEvent = (_event_nativeEvent = event.nativeEvent) !== null && _event_nativeEvent !== void 0 ? _event_nativeEvent : event;
            const path = nativeEvent === null || nativeEvent === void 0 ? void 0 : (_nativeEvent_composedPath = nativeEvent.composedPath) === null || _nativeEvent_composedPath === void 0 ? void 0 : _nativeEvent_composedPath.call(nativeEvent);
            if (Array.isArray(path)) for (const el of path){
                if (el && el.getAttribute && el.getAttribute('data-mui-picker-open-button') === 'true') return true;
            }
            const target = event.target;
            if (target && target.closest) return Boolean(target.closest('[data-mui-picker-open-button="true"]'));
            return false;
        };
        textFieldProps.onFocus = (event)=>{
            prevOnFocus === null || prevOnFocus === void 0 ? void 0 : prevOnFocus(event);
            // Avoid opening if event was prevented by user code
            if (!event.isDefaultPrevented() && !isFromOpenButton(event)) pickerContext.setOpen(true);
        };
        textFieldProps.onMouseDown = (event)=>{
            prevOnMouseDown === null || prevOnMouseDown === void 0 ? void 0 : prevOnMouseDown(event);
            if (!event.isDefaultPrevented() && !isFromOpenButton(event)) pickerContext.setOpen(true);
        };
    }
    return textFieldProps;
}
function $07836ed0da29a707$export$5a824d9f5f1d0778(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, inputRef: inputRef, children: children } = props;
    const contextValue = $7fPBF.useMemo(()=>({
            inputRef: inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($07836ed0da29a707$export$f5bc58012fe60483.Provider, {
        value: contextValue,
        children: children
    });
}




'use client';
const $61864b2c364c1d9d$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $61864b2c364c1d9d$export$d9781c7894a82487 = /*#__PURE__*/ $7fPBF.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots: slots, slotProps: slotProps } = themeProps, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(themeProps, $61864b2c364c1d9d$var$_excluded);
    const textFieldProps = (0, $07836ed0da29a707$export$fa1adc26aa0d007a)({
        slotProps: slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, $2d171a2ba59f3830$export$5591b0b878c1a989)(textFieldProps);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07836ed0da29a707$export$5a824d9f5f1d0778), {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07836ed0da29a707$export$f83254b974f9d6d3), {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: (0, $3ad354549f02ea44$export$5fda1783bb83f57b)
        })
    });
});





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


'use client';
const $dad5368f73994feb$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    return $7fPBF.useCallback((day)=>(0, $32a91d31b03a0978$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};






'use client';
const $e06d4c59d97eaad1$var$createCalendarStateReducer = (reduceAnimations, adapter)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (adapter.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
                    if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
                    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw /* minify-error-disabled */ new Error('missing support');
        }
    };
const $e06d4c59d97eaad1$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onYearChange: onYearChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone, getCurrentMonthFromVisibleDate: getCurrentMonthFromVisibleDate } = params;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const reducerFn = $7fPBF.useRef($e06d4c59d97eaad1$var$createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
    const referenceDate = $7fPBF.useMemo(()=>{
        return (0, $47fcf740fb158e5e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $ca987ffc32eec519$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $7fPBF.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        // Keep the time from the reference date when computing the current month anchor.
        // Using startOfMonth would reset the time to 00:00 which breaks expectations
        // that month selections preserve the referenceDate time when no value is provided.
        // See tests: "should use `referenceDate` when no value defined".
        currentMonth: adapter.setDate(referenceDate, 1),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, $dad5368f73994feb$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $7fPBF.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: adapter.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        adapter
    ]);
    const setVisibleDate = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(({ target: target, reason: reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = adapter.startOfMonth(target);
                const endOfMonth = adapter.endOfMonth(target);
                focusedDay = (0, $4e19e5fab2f9b93c$export$ca1f317ae8db2ee8)({
                    adapter: adapter,
                    date: focusedDay,
                    minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast: disablePast,
                    disableFuture: disableFuture,
                    isDateDisabled: isDateDisabled,
                    timezone: timezone
                });
            }
        }
        const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange === null || onMonthChange === void 0 ? void 0 : onMonthChange(month);
        if (hasChangedYear) onYearChange === null || onYearChange === void 0 ? void 0 : onYearChange(adapter.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month: month,
            direction: adapter.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation: skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = $7fPBF.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        setVisibleDate: setVisibleDate,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd
    };
};



parcelRequire("7fPBF");



function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}


function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $da27c96857818bcc$export$2e2bcd8739ae039)(t, o);
}




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;







const $cc32d1374808cf2f$export$5b0bb0174eb448ca = (slot)=>(0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', slot);
const $cc32d1374808cf2f$export$1461f245817ac559 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', [
    'root'
]);



const $7bacf030790f8ce1$var$_excluded = [
    "children"
];
const $7bacf030790f8ce1$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $cc32d1374808cf2f$export$5b0bb0174eb448ca), classes);
};
const $7bacf030790f8ce1$var$PickersFadeTransitionGroupRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
function $7bacf030790f8ce1$export$5262185daf493fee(inProps) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className: className, reduceAnimations: reduceAnimations, transKey: transKey, classes: classesProp } = props;
    const { children: children } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $7bacf030790f8ce1$var$_excluded);
    const classes = $7bacf030790f8ce1$var$useUtilityClasses(classesProp);
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7bacf030790f8ce1$var$PickersFadeTransitionGroupRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f34aa3278e20e02$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");










function $3ebde84672fe7175$export$d0598dca23ab7a85(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickerDay', slot);
}
const $3ebde84672fe7175$export$6c2f3523b3f252b9 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickerDay', [
    'root',
    'dayOutsideMonth',
    'today',
    'selected',
    'disabled',
    'fillerCell'
]);





var $7fPBF = parcelRequire("7fPBF");


function $be6a734326d04be6$export$250873c81c19b1fa(parameters) {
    const { disabled: disabled, selected: selected, today: today, outsideCurrentMonth: outsideCurrentMonth, day: day, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = parameters;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { ownerState: pickerOwnerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    return $7fPBF.useMemo(()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            day: day,
            isDaySelected: selected !== null && selected !== void 0 ? selected : false,
            isDayDisabled: disabled !== null && disabled !== void 0 ? disabled : false,
            isDayCurrent: today !== null && today !== void 0 ? today : false,
            isDayOutsideMonth: outsideCurrentMonth !== null && outsideCurrentMonth !== void 0 ? outsideCurrentMonth : false,
            isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
            isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
            disableHighlightToday: disableHighlightToday !== null && disableHighlightToday !== void 0 ? disableHighlightToday : false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth !== null && showDaysOutsideCurrentMonth !== void 0 ? showDaysOutsideCurrentMonth : false
        }), [
        adapter,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}



'use client';
const $91a8f5eded5b6fdc$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth",
    "isVisuallySelected",
    "isDayFillerCell"
];
const $91a8f5eded5b6fdc$var$useUtilityClasses = (ownerState, classes)=>{
    const { isDaySelected: isDaySelected, disableHighlightToday: disableHighlightToday, isDayCurrent: isDayCurrent, isDayDisabled: isDayDisabled, isDayOutsideMonth: isDayOutsideMonth, isDayFillerCell: isDayFillerCell } = ownerState;
    const slots = {
        root: [
            'root',
            isDaySelected && !isDayFillerCell && 'selected',
            isDayDisabled && 'disabled',
            !disableHighlightToday && isDayCurrent && !isDaySelected && !isDayFillerCell && 'today',
            isDayOutsideMonth && 'dayOutsideMonth',
            isDayFillerCell && 'fillerCell'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $3ebde84672fe7175$export$d0598dca23ab7a85), classes);
};
const $91a8f5eded5b6fdc$var$PickerDayRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    name: 'MuiPickerDay',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
            ownerState.isDayOutsideMonth && styles.dayOutsideMonth,
            ownerState.isDayFillerCell && styles.fillerCell
        ];
    }
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        '--PickerDay-horizontalMargin': `${(0, $bf2de1012f0783e6$export$dde58b009b497666)}px`,
        '--PickerDay-size': `${(0, $bf2de1012f0783e6$export$3f0060ce4cc8f4d0)}px`
    }, theme.typography.caption, {
        lineHeight: 1,
        display: 'flex',
        width: 'var(--PickerDay-size)',
        height: 'var(--PickerDay-size)',
        borderRadius: 'calc(var(--PickerDay-size) / 2)',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.focusOpacity)
        },
        marginLeft: 'var(--PickerDay-horizontalMargin)',
        marginRight: 'var(--PickerDay-horizontalMargin)',
        variants: [
            {
                props: {
                    isDaySelected: true
                },
                style: {
                    color: (theme.vars || theme).palette.primary.contrastText,
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    fontWeight: theme.typography.fontWeightMedium,
                    '&:focus, &:hover': {
                        willChange: 'background-color',
                        backgroundColor: (theme.vars || theme).palette.primary.dark
                    },
                    [`&.${(0, $3ebde84672fe7175$export$6c2f3523b3f252b9).disabled}`]: {
                        opacity: 0.6
                    }
                }
            },
            {
                props: {
                    isDayDisabled: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    isDayFillerCell: true
                },
                style: {
                    // visibility: 'hidden' does not work here as it hides the element from screen readers
                    // and results in unexpected relationships between week day and day columns.
                    opacity: 0,
                    pointerEvents: 'none'
                }
            },
            {
                props: {
                    isDayOutsideMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    isDayCurrent: true,
                    isDaySelected: false
                },
                style: {
                    outline: `1px solid ${(theme.vars || theme).palette.text.secondary}`,
                    outlineOffset: -1
                }
            }
        ]
    }));
const $91a8f5eded5b6fdc$var$noop = ()=>{};
const $91a8f5eded5b6fdc$var$PickerDayRaw = /*#__PURE__*/ $7fPBF.forwardRef(function PickerDay(inProps, forwardedRef) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickerDay'
    });
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { autoFocus: autoFocus = false, className: className, classes: classesProp, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $91a8f5eded5b6fdc$var$noop, onBlur: onBlur = $91a8f5eded5b6fdc$var$noop, onKeyDown: onKeyDown = $91a8f5eded5b6fdc$var$noop, onMouseDown: onMouseDown = $91a8f5eded5b6fdc$var$noop, onMouseEnter: onMouseEnter = $91a8f5eded5b6fdc$var$noop, children: children, day: day, selected: selected, disabled: disabled, today: today, outsideCurrentMonth: outsideCurrentMonth, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, isDayFillerCell: isDayFillerCellProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $91a8f5eded5b6fdc$var$_excluded);
    const pickerDayOwnerState = (0, $be6a734326d04be6$export$250873c81c19b1fa)({
        day: day,
        selected: selected,
        disabled: disabled,
        today: today,
        outsideCurrentMonth: outsideCurrentMonth,
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerDayOwnerState, {
        // Properties specific to the MUI implementation (some might be removed in the next major)
        isDayFillerCell: isDayFillerCellProp !== null && isDayFillerCellProp !== void 0 ? isDayFillerCellProp : outsideCurrentMonth && !showDaysOutsideCurrentMonth
    });
    const classes = $91a8f5eded5b6fdc$var$useUtilityClasses(ownerState, classesProp);
    const ref = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        event.defaultMuiPrevented = true;
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (ownerState.isDayFillerCell) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($91a8f5eded5b6fdc$var$PickerDayRoot, {
        ref: handleRef,
        role: other.role,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        as: "div"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($91a8f5eded5b6fdc$var$PickerDayRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        children: children !== null && children !== void 0 ? children : adapter.format(day, 'dayOfMonth')
    }));
});
const $91a8f5eded5b6fdc$export$e3052bca0bf5a502 = /*#__PURE__*/ $7fPBF.memo($91a8f5eded5b6fdc$var$PickerDayRaw);








var $7fPBF = parcelRequire("7fPBF");







/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;




var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $1e3f901d29816e8c$export$2e2bcd8739ae039)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $89edc8a1840ff9c1$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $623678cbb6daf054$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ''
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;




const $dfd9f5556dafac39$export$e98c1b6c3bbc3c59 = (slot)=>(0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersSlideTransition', slot);
const $dfd9f5556dafac39$export$d251a58673156a67 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);




const $e9d44655d35bed2d$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $e9d44655d35bed2d$var$useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $dfd9f5556dafac39$export$e98c1b6c3bbc3c59), classes);
};
const $e9d44655d35bed2d$var$elementOverrides = [
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
];
const $e9d44655d35bed2d$var$PickersSlideTransitionRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>$e9d44655d35bed2d$var$elementOverrides.reduce((acc, key)=>{
            acc.push({
                [`.${(0, $dfd9f5556dafac39$export$d251a58673156a67)[key]}`]: styles[key]
            });
            return acc;
        }, [
            styles.root
        ])
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $dfd9f5556dafac39$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $dfd9f5556dafac39$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $dfd9f5556dafac39$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $dfd9f5556dafac39$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $dfd9f5556dafac39$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $dfd9f5556dafac39$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $e9d44655d35bed2d$export$e868fcc7557d3a06(inProps) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey, classes: classesProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e9d44655d35bed2d$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        slideDirection: slideDirection
    });
    const classes = $e9d44655d35bed2d$var$useUtilityClasses(classesProp, ownerState);
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e9d44655d35bed2d$var$PickersSlideTransitionRoot, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $7fPBF.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "none",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9e47e451b39ae9f$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}






const $49825d47e66e3e89$export$fbe827982a69894a = (slot)=>(0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDayCalendar', slot);
const $49825d47e66e3e89$export$b3f91ee59da1294a = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);




'use client';
const $3ca766bc5a8f077f$var$_excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $3ca766bc5a8f077f$var$_excluded2 = [
    "ownerState"
];
const $3ca766bc5a8f077f$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $49825d47e66e3e89$export$fbe827982a69894a), classes);
};
const $3ca766bc5a8f077f$var$weeksContainerHeight = ((0, $bf2de1012f0783e6$export$3f0060ce4cc8f4d0) + (0, $bf2de1012f0783e6$export$dde58b009b497666) * 2) * 6;
const $3ca766bc5a8f077f$var$PickerCalendarDayRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const $3ca766bc5a8f077f$var$PickerCalendarDayHeader = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $3ca766bc5a8f077f$var$PickerCalendarWeekDayLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $3ca766bc5a8f077f$var$PickerCalendarWeekNumberLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const $3ca766bc5a8f077f$var$PickerCalendarWeekNumber = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $bf2de1012f0783e6$export$3f0060ce4cc8f4d0),
        height: (0, $bf2de1012f0783e6$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $bf2de1012f0783e6$export$dde58b009b497666)}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $3ca766bc5a8f077f$var$PickerCalendarLoadingContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $3ca766bc5a8f077f$var$weeksContainerHeight
});
const $3ca766bc5a8f077f$var$PickerCalendarSlideTransition = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $e9d44655d35bed2d$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: $3ca766bc5a8f077f$var$weeksContainerHeight
});
const $3ca766bc5a8f077f$var$PickerCalendarWeekContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const $3ca766bc5a8f077f$var$PickerCalendarWeek = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${(0, $bf2de1012f0783e6$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $3ca766bc5a8f077f$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusedDay: focusedDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $3ca766bc5a8f077f$var$_excluded);
    const { currentMonth: currentMonth, disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const now = (0, $561935f171930cf5$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>adapter.isSameDay(selectedDay, day));
    const isToday = adapter.isSameDay(day, now);
    const isDisabled = $7fPBF.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = $7fPBF.useMemo(()=>adapter.getMonth(day) !== currentMonthNumber, [
        adapter,
        day,
        currentMonthNumber
    ]);
    const ownerStateBase = (0, $be6a734326d04be6$export$250873c81c19b1fa)({
        day: day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    var _slots_day;
    const Day = (_slots_day = slots === null || slots === void 0 ? void 0 : slots.day) !== null && _slots_day !== void 0 ? _slots_day : (0, $91a8f5eded5b6fdc$export$e3052bca0bf5a502);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.day,
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': adapter.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerStateBase, {
            day: day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $3ca766bc5a8f077f$var$_excluded2);
    const isFirstVisibleCell = $7fPBF.useMemo(()=>{
        const startOfMonth = adapter.startOfMonth(currentMonth);
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, startOfMonth);
        return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
    }, [
        currentMonth,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    const isLastVisibleCell = $7fPBF.useMemo(()=>{
        const endOfMonth = adapter.endOfMonth(currentMonth);
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, endOfMonth);
        return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
    }, [
        currentMonth,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Day, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $3ca766bc5a8f077f$export$8fb56b32a5df6314(inProps) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, classes: classesProp, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            children: "\u2026"
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>adapter.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, timezone: timezone } = props;
    const now = (0, $561935f171930cf5$export$3a404aece3dff2fa)(timezone);
    const classes = $3ca766bc5a8f077f$var$useUtilityClasses(classesProp);
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const isDateDisabled = (0, $dad5368f73994feb$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const handleDaySelect = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange === null || onFocusedViewChange === void 0 ? void 0 : onFocusedViewChange(true);
        }
    };
    const handleKeyDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(adapter.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(adapter.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $4e19e5fab2f9b93c$export$ca1f317ae8db2ee8)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $4e19e5fab2f9b93c$export$ca1f317ae8db2ee8)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(adapter.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(adapter.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(adapter.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(adapter.addMonths(day, -1));
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleDaySelect(day);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, day)=>{
        if (focusedDay != null && adapter.isSameDay(focusedDay, day)) onFocusedViewChange === null || onFocusedViewChange === void 0 ? void 0 : onFocusedViewChange(false);
    });
    const currentMonthNumber = adapter.getMonth(currentMonth);
    const currentYearNumber = adapter.getYear(currentMonth);
    const validSelectedDays = $7fPBF.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>adapter.startOfDay(day)), [
        adapter,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $7fPBF.useMemo(()=>/*#__PURE__*/ $7fPBF.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = $7fPBF.useMemo(()=>{
        const toDisplay = adapter.getWeekArray(currentMonth);
        let nextMonth = adapter.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = adapter.getWeekArray(nextMonth);
            const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = adapter.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        adapter
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3ca766bc5a8f077f$var$PickerCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3ca766bc5a8f077f$var$PickerCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$PickerCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $4e19e5fab2f9b93c$export$24c38139da66592d)(adapter, now).map((weekday, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$PickerCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": adapter.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$PickerCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$PickerCalendarSlideTransition, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$PickerCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3ca766bc5a8f077f$var$PickerCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$PickerCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ca766bc5a8f077f$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");











var $7fPBF = parcelRequire("7fPBF");







function $6013be6bdc840305$export$da0c97315339ebd9(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiMonthCalendar', slot);
}
const $6013be6bdc840305$export$edf77d5566c7007c = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);



'use client';
const $8f30bf483da5bc45$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $8f30bf483da5bc45$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $6013be6bdc840305$export$da0c97315339ebd9), classes);
};
const $8f30bf483da5bc45$var$DefaultMonthButton = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $6013be6bdc840305$export$edf77d5566c7007c).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $6013be6bdc840305$export$edf77d5566c7007c).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $6013be6bdc840305$export$edf77d5566c7007c).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $6013be6bdc840305$export$edf77d5566c7007c).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $8f30bf483da5bc45$export$ca92875d3d780f06 = /*#__PURE__*/ $7fPBF.memo(function MonthCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $8f30bf483da5bc45$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = $8f30bf483da5bc45$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        var // `ref.current` being `null` would be a bug in MUI.
        _ref_current;
        if (autoFocus) (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }, [
        autoFocus
    ]);
    var _slots_monthButton;
    const MonthButton = (_slots_monthButton = slots === null || slots === void 0 ? void 0 : slots.monthButton) !== null && _slots_monthButton !== void 0 ? _slots_monthButton : $8f30bf483da5bc45$var$DefaultMonthButton;
    const monthButtonProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: MonthButton,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MonthButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, monthButtonProps));
});













'use client';
const $fe302e384460fef5$var$_excluded = [
    "autoFocus",
    "className",
    "currentMonth",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $fe302e384460fef5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $6013be6bdc840305$export$da0c97315339ebd9), classes);
};
function $fe302e384460fef5$export$5b6e066572408095(props, name) {
    const themeProps = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $b7fa3b3c8a55dd1e$export$82ecc8c5f467152f)(themeProps);
    var _themeProps_monthsPerRow;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        monthsPerRow: (_themeProps_monthsPerRow = themeProps.monthsPerRow) !== null && _themeProps_monthsPerRow !== void 0 ? _themeProps_monthsPerRow : 3
    });
}
const $fe302e384460fef5$var$isSameMonth = (monthA, monthB, yearA, yearB, adapter)=>Boolean(monthA === monthB && yearB && adapter.isSameYear(yearA, yearB));
const $fe302e384460fef5$var$MonthCalendarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: (0, $bf2de1012f0783e6$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
const $fe302e384460fef5$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $7fPBF.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $fe302e384460fef5$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { autoFocus: autoFocus, className: className, currentMonth: currentMonth, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $fe302e384460fef5$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $30766ef8faf316f9$export$ac06ac6808815c7c)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $47fcf740fb158e5e$export$2764b246aa3b75ba)
    });
    const now = (0, $561935f171930cf5$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $47fcf740fb158e5e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $ca987ffc32eec519$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $fe302e384460fef5$var$useUtilityClasses(classesProp);
    const todayMonth = $7fPBF.useMemo(()=>adapter.getMonth(now), [
        adapter,
        now
    ]);
    const selectedMonth = $7fPBF.useMemo(()=>{
        if (value != null) return adapter.getMonth(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedMonth, setFocusedMonth] = $7fPBF.useState(()=>selectedMonth || adapter.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus !== null && autoFocus !== void 0 ? autoFocus : false
    });
    const changeHasFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $7fPBF.useCallback((dateToValidate)=>{
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = adapter.startOfMonth(dateToValidate);
        if (adapter.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (adapter.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        adapter
    ]);
    const handleMonthSelection = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((_event, month)=>{
        if (readOnly) return;
        const currentValue = value && currentMonth && !adapter.isSameYear(value, currentMonth) ? adapter.setYear(value, adapter.getYear(currentMonth)) : value;
        var _ref;
        // When no value is selected yet but a year was chosen (via YearCalendar),
        // prefer using currentMonth (which carries the selected year) over the initial referenceDate.
        // Fix for: https://github.com/mui/mui-x/issues/20624
        const baseDateForMonth = (_ref = currentValue !== null && currentValue !== void 0 ? currentValue : currentMonth) !== null && _ref !== void 0 ? _ref : referenceDate;
        const newDate = adapter.setMonth(baseDateForMonth, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((month)=>{
        var _ref;
        if (!isMonthDisabled(adapter.setMonth((_ref = value !== null && value !== void 0 ? value : currentMonth) !== null && _ref !== void 0 ? _ref : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleMonthSelection(event, month);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    var _ref;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fe302e384460fef5$var$MonthCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, $4e19e5fab2f9b93c$export$62591b96a734eacd)(adapter, (_ref = currentMonth !== null && currentMonth !== void 0 ? currentMonth : value) !== null && _ref !== void 0 ? _ref : referenceDate).map((month)=>{
            const monthNumber = adapter.getMonth(month);
            const monthText = adapter.format(month, 'monthShort');
            const monthLabel = adapter.format(month, 'month');
            const isSelected = $fe302e384460fef5$var$isSameMonth(monthNumber, selectedMonth, month, value, adapter);
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f30bf483da5bc45$export$ca92875d3d780f06), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": $fe302e384460fef5$var$isSameMonth(monthNumber, todayMonth, month, now, adapter) ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});





var $7fPBF = parcelRequire("7fPBF");












var $7fPBF = parcelRequire("7fPBF");







function $7f90f7c459f6df61$export$4477acc520094dec(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiYearCalendar', slot);
}
const $7f90f7c459f6df61$export$e42d427cd9fe5fd7 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);



'use client';
const $e03d5ea1bff5c9f9$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $e03d5ea1bff5c9f9$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7f90f7c459f6df61$export$4477acc520094dec), classes);
};
const $e03d5ea1bff5c9f9$var$DefaultYearButton = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $7f90f7c459f6df61$export$e42d427cd9fe5fd7).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $7f90f7c459f6df61$export$e42d427cd9fe5fd7).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $7f90f7c459f6df61$export$e42d427cd9fe5fd7).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $7f90f7c459f6df61$export$e42d427cd9fe5fd7).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $e03d5ea1bff5c9f9$export$cc9e2b0aa124cbe6 = /*#__PURE__*/ $7fPBF.memo(function YearCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $e03d5ea1bff5c9f9$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const ownerState = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = $e03d5ea1bff5c9f9$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        var // `ref.current` being `null` would be a bug in MUI.
        _ref_current;
        if (autoFocus) (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }, [
        autoFocus
    ]);
    var _slots_yearButton;
    const YearButton = (_slots_yearButton = slots === null || slots === void 0 ? void 0 : slots.yearButton) !== null && _slots_yearButton !== void 0 ? _slots_yearButton : $e03d5ea1bff5c9f9$var$DefaultYearButton;
    const yearButtonProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: YearButton,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(YearButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, yearButtonProps));
});












'use client';
const $5d35ec493abcaca5$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $5d35ec493abcaca5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7f90f7c459f6df61$export$4477acc520094dec), classes);
};
function $5d35ec493abcaca5$var$useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $b7fa3b3c8a55dd1e$export$82ecc8c5f467152f)(themeProps);
    var _themeProps_yearsPerRow, _themeProps_yearsOrder;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        yearsPerRow: (_themeProps_yearsPerRow = themeProps.yearsPerRow) !== null && _themeProps_yearsPerRow !== void 0 ? _themeProps_yearsPerRow : 3,
        yearsOrder: (_themeProps_yearsOrder = themeProps.yearsOrder) !== null && _themeProps_yearsOrder !== void 0 ? _themeProps_yearsOrder : 'asc'
    });
}
const $5d35ec493abcaca5$var$YearCalendarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $0109f047b1d45fbf$export$3ba67b570e26eea0)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: (0, $bf2de1012f0783e6$export$ee46b8a74d6c94d3),
    maxHeight: (0, $bf2de1012f0783e6$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const $5d35ec493abcaca5$var$YearCalendarButtonFiller = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
const $5d35ec493abcaca5$export$657f9200591b2b71 = /*#__PURE__*/ $7fPBF.forwardRef(function YearCalendar(inProps, ref) {
    const props = $5d35ec493abcaca5$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5d35ec493abcaca5$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $30766ef8faf316f9$export$ac06ac6808815c7c)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $47fcf740fb158e5e$export$2764b246aa3b75ba)
    });
    const now = (0, $561935f171930cf5$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $47fcf740fb158e5e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $ca987ffc32eec519$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $5d35ec493abcaca5$var$useUtilityClasses(classesProp);
    const todayYear = $7fPBF.useMemo(()=>adapter.getYear(now), [
        adapter,
        now
    ]);
    const selectedYear = $7fPBF.useMemo(()=>{
        if (value != null) return adapter.getYear(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedYear, setFocusedYear] = $7fPBF.useState(()=>selectedYear || adapter.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus !== null && autoFocus !== void 0 ? autoFocus : false
    });
    const changeHasFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $7fPBF.useCallback((dateToValidate)=>{
        if (disablePast && adapter.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && adapter.isAfterYear(dateToValidate, now)) return true;
        if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = adapter.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        adapter
    ]);
    const handleYearSelection = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((_event, year)=>{
        if (readOnly) return;
        const newDate = adapter.setYear(value !== null && value !== void 0 ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(adapter.setYear(value !== null && value !== void 0 ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus === null || onYearFocus === void 0 ? void 0 : onYearFocus(year);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleYearSelection(event, year);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $7fPBF.useRef(null);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)(ref, scrollerRef);
    $7fPBF.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = adapter.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5d35ec493abcaca5$var$YearCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = adapter.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e03d5ea1bff5c9f9$export$cc9e2b0aa124cbe6), {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: adapter.format(year, 'year')
                }, adapter.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5d35ec493abcaca5$var$YearCalendarButtonFiller, {}, index))
        ]
    }));
});






var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");










function $bd94f5daa631f258$export$cef978c25740de90(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', slot);
}
const $bd94f5daa631f258$export$f8819209558cd362 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);




'use client';
const $9431c4186aa08c5d$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], $9431c4186aa08c5d$var$_excluded2 = [
    "ownerState"
], $9431c4186aa08c5d$var$_excluded3 = [
    "ownerState"
];
const $9431c4186aa08c5d$var$PickersArrowSwitcherRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const $9431c4186aa08c5d$var$PickersArrowSwitcherSpacer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $9431c4186aa08c5d$var$PickersArrowSwitcherButton = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $9431c4186aa08c5d$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $bd94f5daa631f258$export$cef978c25740de90), classes);
};
const $9431c4186aa08c5d$export$597b7cbdb7b2a24c = /*#__PURE__*/ $7fPBF.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId, classes: classesProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $9431c4186aa08c5d$var$_excluded);
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const classes = $9431c4186aa08c5d$var$useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    var _slots_previousIconButton;
    const PreviousIconButton = (_slots_previousIconButton = slots === null || slots === void 0 ? void 0 : slots.previousIconButton) !== null && _slots_previousIconButton !== void 0 ? _slots_previousIconButton : $9431c4186aa08c5d$var$PickersArrowSwitcherButton;
    var _previousProps_isHidden;
    const previousIconButtonProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            isButtonHidden: (_previousProps_isHidden = previousProps.isHidden) !== null && _previousProps_isHidden !== void 0 ? _previousProps_isHidden : false
        }),
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.button, classes.previousIconButton)
    });
    var _slots_nextIconButton;
    const NextIconButton = (_slots_nextIconButton = slots === null || slots === void 0 ? void 0 : slots.nextIconButton) !== null && _slots_nextIconButton !== void 0 ? _slots_nextIconButton : $9431c4186aa08c5d$var$PickersArrowSwitcherButton;
    var _nextProps_isHidden;
    const nextIconButtonProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            isButtonHidden: (_nextProps_isHidden = nextProps.isHidden) !== null && _nextProps_isHidden !== void 0 ? _nextProps_isHidden : false
        }),
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.button, classes.nextIconButton)
    });
    var _slots_leftArrowIcon;
    const LeftArrowIcon = (_slots_leftArrowIcon = slots === null || slots === void 0 ? void 0 : slots.leftArrowIcon) !== null && _slots_leftArrowIcon !== void 0 ? _slots_leftArrowIcon : (0, $3ad354549f02ea44$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $9431c4186aa08c5d$var$_excluded2);
    var _slots_rightArrowIcon;
    const RightArrowIcon = (_slots_rightArrowIcon = slots === null || slots === void 0 ? void 0 : slots.rightArrowIcon) !== null && _slots_rightArrowIcon !== void 0 ? _slots_rightArrowIcon : (0, $3ad354549f02ea44$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps2, $9431c4186aa08c5d$var$_excluded3);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($9431c4186aa08c5d$var$PickersArrowSwitcherRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PreviousIconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RightArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LeftArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9431c4186aa08c5d$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NextIconButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(LeftArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RightArrowIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $7fPBF = parcelRequire("7fPBF");


function $f918eff299212d84$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    return $7fPBF.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        return !adapter.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        adapter,
        timezone
    ]);
}
function $f918eff299212d84$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    return $7fPBF.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        return !adapter.isBefore(firstEnabledMonth, adapter.startOfMonth(month));
    }, [
        disablePast,
        minDate,
        month,
        adapter,
        timezone
    ]);
}
function $f918eff299212d84$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const cleanDate = $7fPBF.useMemo(()=>!adapter.isValid(date) ? null : date, [
        adapter,
        date
    ]);
    const meridiemMode = (0, $b092b35a693ec4af$export$c3352ead7b032236)(cleanDate, adapter);
    const handleMeridiemChange = $7fPBF.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, $b092b35a693ec4af$export$c368d4ff66779998)(cleanDate, mode, Boolean(ampm), adapter);
        onChange(timeWithMeridiem, selectionState !== null && selectionState !== void 0 ? selectionState : 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        adapter
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}




const $bded8cd2a1b8a920$export$457ac4d3a1ad92b4 = (slot)=>(0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', slot);
const $bded8cd2a1b8a920$export$63db7afb9247cb91 = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);




'use client';
const $f435138ec595225a$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], $f435138ec595225a$var$_excluded2 = [
    "ownerState"
];
const $f435138ec595225a$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $bded8cd2a1b8a920$export$457ac4d3a1ad92b4), classes);
};
const $f435138ec595225a$var$PickersCalendarHeaderRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $f435138ec595225a$var$PickersCalendarHeaderLabelContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme: theme })=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $f435138ec595225a$var$PickersCalendarHeaderLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const $f435138ec595225a$var$PickersCalendarHeaderSwitchViewButton = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${(0, $bded8cd2a1b8a920$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $f435138ec595225a$var$PickersCalendarHeaderSwitchViewIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $3ad354549f02ea44$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $f435138ec595225a$export$6801ffebb353f473 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $4ba3a3ea18159e56$export$a795e6ca852975b9)();
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, classes: classesProp, timezone: timezone, format: format = `${adapter.formats.month} ${adapter.formats.year}` } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $f435138ec595225a$var$_excluded);
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const classes = $f435138ec595225a$var$useUtilityClasses(classesProp);
    var _slots_switchViewButton;
    const SwitchViewButton = (_slots_switchViewButton = slots === null || slots === void 0 ? void 0 : slots.switchViewButton) !== null && _slots_switchViewButton !== void 0 ? _slots_switchViewButton : $f435138ec595225a$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownerState, {
            view: view
        }),
        className: classes.switchViewButton
    });
    var _slots_switchViewIcon;
    const SwitchViewIcon = (_slots_switchViewIcon = slots === null || slots === void 0 ? void 0 : slots.switchViewIcon) !== null && _slots_switchViewIcon !== void 0 ? _slots_switchViewIcon : $f435138ec595225a$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $f435138ec595225a$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(adapter.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(adapter.addMonths(month, -1));
    const isNextMonthDisabled = (0, $f918eff299212d84$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $f918eff299212d84$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = adapter.formatByString(month, format);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f435138ec595225a$var$PickersCalendarHeaderRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f435138ec595225a$var$PickersCalendarHeaderLabelContainer, {
                role: "none",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7bacf030790f8ce1$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f435138ec595225a$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SwitchViewButton, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(SwitchViewIcon, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f34aa3278e20e02$export$2e2bcd8739ae039), {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9431c4186aa08c5d$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});





const $a1877450c14265f0$export$512b066b8abdfde4 = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    overflow: 'hidden',
    width: (0, $bf2de1012f0783e6$export$ee46b8a74d6c94d3),
    maxHeight: (0, $bf2de1012f0783e6$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});





const $25000df968eca51b$export$da8c2318897a6672 = (slot)=>(0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiDateCalendar', slot);
const $25000df968eca51b$export$d0237e2bb9598e8d = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);









'use client';
const $5d7f399928888f80$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $5d7f399928888f80$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $25000df968eca51b$export$da8c2318897a6672), classes);
};
function $5d7f399928888f80$var$useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const reduceAnimations = (0, $a00ff025c4e5aa15$export$7e40eba507bb97c4)(themeProps.reduceAnimations);
    const validationProps = (0, $b7fa3b3c8a55dd1e$export$82ecc8c5f467152f)(themeProps);
    var _themeProps_loading, _themeProps_openTo, _themeProps_views, _themeProps_renderLoading;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        loading: (_themeProps_loading = themeProps.loading) !== null && _themeProps_loading !== void 0 ? _themeProps_loading : false,
        openTo: (_themeProps_openTo = themeProps.openTo) !== null && _themeProps_openTo !== void 0 ? _themeProps_openTo : 'day',
        views: (_themeProps_views = themeProps.views) !== null && _themeProps_views !== void 0 ? _themeProps_views : [
            'year',
            'day'
        ],
        reduceAnimations: reduceAnimations,
        renderLoading: (_themeProps_renderLoading = themeProps.renderLoading) !== null && _themeProps_renderLoading !== void 0 ? _themeProps_renderLoading : ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: "\u2026"
            })
    });
}
const $5d7f399928888f80$var$DateCalendarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a1877450c14265f0$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $bf2de1012f0783e6$export$f2fef360e2df0cb7)
});
const $5d7f399928888f80$var$DateCalendarViewTransitionContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $7bacf030790f8ce1$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
const $5d7f399928888f80$export$68078fe5d2bf8909 = /*#__PURE__*/ $7fPBF.forwardRef(function DateCalendar(inProps, ref) {
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    const id = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)();
    const props = $5d7f399928888f80$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $5d7f399928888f80$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $30766ef8faf316f9$export$ac06ac6808815c7c)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $47fcf740fb158e5e$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $54e70f6a722a2ad6$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, setVisibleDate: setVisibleDate, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $e06d4c59d97eaad1$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (adapter.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return adapter.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    var _slots_calendarHeader;
    const CalendarHeader = (_slots_calendarHeader = slots === null || slots === void 0 ? void 0 : slots.calendarHeader) !== null && _slots_calendarHeader !== void 0 ? _slots_calendarHeader : (0, $f435138ec595225a$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: ownerState
    });
    const handleDateMonthChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = adapter.startOfMonth(newDate);
        const endOfMonth = adapter.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4e19e5fab2f9b93c$export$ca1f317ae8db2ee8)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = adapter.startOfYear(newDate);
        const endOfYear = adapter.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4e19e5fab2f9b93c$export$ca1f317ae8db2ee8)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $4e19e5fab2f9b93c$export$a98b123b8f29e004)(adapter, day, value !== null && value !== void 0 ? value : referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $7fPBF.useEffect(()=>{
        if (adapter.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = $5d7f399928888f80$var$useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $7fPBF.useRef(view);
    $7fPBF.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $7fPBF.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5d7f399928888f80$var$DateCalendarRoot, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CalendarHeader, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5d7f399928888f80$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d35ec493abcaca5$export$657f9200591b2b71), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe302e384460fef5$export$d7a7c85c0f5afc4a), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            currentMonth: calendarState.currentMonth,
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ca766bc5a8f077f$export$8fb56b32a5df6314), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




const $cb3c0e56c933353d$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d7f399928888f80$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $4e19e5fab2f9b93c$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $4e19e5fab2f9b93c$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $c5df64ab91bba12c$export$5a73641f0156e1e4 = /*#__PURE__*/ $7fPBF.forwardRef(function DesktopDatePicker(inProps, ref) {
    var _defaultizedProps_slotProps;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $6256e61ca6e2a023$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        day: (0, $cb3c0e56c933353d$export$69888ffe06193e5e),
        month: (0, $cb3c0e56c933353d$export$69888ffe06193e5e),
        year: (0, $cb3c0e56c933353d$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    var _defaultizedProps_closeOnSelect, _defaultizedProps_yearsPerRow;
    // Props with the default values specific to the desktop variant
    const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps, {
        closeOnSelect: (_defaultizedProps_closeOnSelect = defaultizedProps.closeOnSelect) !== null && _defaultizedProps_closeOnSelect !== void 0 ? _defaultizedProps_closeOnSelect : true,
        viewRenderers: viewRenderers,
        format: (0, $4e19e5fab2f9b93c$export$bb1c921f313ec928)(adapter, defaultizedProps, false),
        yearsPerRow: (_defaultizedProps_yearsPerRow = defaultizedProps.yearsPerRow) !== null && _defaultizedProps_yearsPerRow !== void 0 ? _defaultizedProps_yearsPerRow : 4,
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            field: (0, $61864b2c364c1d9d$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps_slotProps;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)((_defaultizedProps_slotProps = defaultizedProps.slotProps) === null || _defaultizedProps_slotProps === void 0 ? void 0 : _defaultizedProps_slotProps.field, ownerState), (0, $95d6db0fe23c2dc0$export$5890f750904acddb)(defaultizedProps));
            },
            toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                hidden: true
            }, (_defaultizedProps_slotProps = defaultizedProps.slotProps) === null || _defaultizedProps_slotProps === void 0 ? void 0 : _defaultizedProps_slotProps.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $88ceaa8c066f05e1$export$b1b70bc56ac5be0e)({
        ref: ref,
        props: props,
        valueManager: (0, $47fcf740fb158e5e$export$2764b246aa3b75ba),
        valueType: 'date',
        validator: (0, $32a91d31b03a0978$export$ffb3d0046ef3a2),
        steps: null
    });
    return renderPicker();
});




var $7fPBF = parcelRequire("7fPBF");







parcelRequire("7fPBF");








const $47cb507ce621cdca$var$PickersModalDialogRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $29f821306e66414b$export$2e2bcd8739ae039), {
    slot: 'internal'
})({
    [`& .${(0, $b479a9c1dd555a27$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $b479a9c1dd555a27$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $bf2de1012f0783e6$export$ee46b8a74d6c94d3)
    }
});
const $47cb507ce621cdca$var$PickersModalDialogContent = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6ff02a49d1cf2980$export$2e2bcd8739ae039), {
    slot: 'internal'
})({
    '&:first-of-type': {
        padding: 0
    }
});
function $47cb507ce621cdca$export$99f83c99e1491f77(props) {
    var _slotProps_dialog, _slotProps_dialog1;
    const { children: children, slots: slots, slotProps: slotProps } = props;
    const { open: open } = (0, $603bd506ac49bd15$export$4495bebe53492ac8)();
    const { dismissViews: dismissViews, onPopperExited: onPopperExited } = (0, $a1b6bd1887cb0e9a$export$ceff2e8b47408642)();
    var _slots_dialog;
    const Dialog = (_slots_dialog = slots === null || slots === void 0 ? void 0 : slots.dialog) !== null && _slots_dialog !== void 0 ? _slots_dialog : $47cb507ce621cdca$var$PickersModalDialogRoot;
    var _slots_mobileTransition;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Dialog, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited === null || onPopperExited === void 0 ? void 0 : onPopperExited();
        }
    }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.dialog, {
        PaperComponent: slots === null || slots === void 0 ? void 0 : slots.mobilePaper,
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            transition: (_slots_mobileTransition = slots === null || slots === void 0 ? void 0 : slots.mobileTransition) !== null && _slots_mobileTransition !== void 0 ? _slots_mobileTransition : (0, $0f34aa3278e20e02$export$2e2bcd8739ae039)
        }, slotProps === null || slotProps === void 0 ? void 0 : (_slotProps_dialog = slotProps.dialog) === null || _slotProps_dialog === void 0 ? void 0 : _slotProps_dialog.slots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            transition: slotProps === null || slotProps === void 0 ? void 0 : slotProps.mobileTransition,
            paper: slotProps === null || slotProps === void 0 ? void 0 : slotProps.mobilePaper
        }, slotProps === null || slotProps === void 0 ? void 0 : (_slotProps_dialog1 = slotProps.dialog) === null || _slotProps_dialog1 === void 0 ? void 0 : _slotProps_dialog1.slotProps),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($47cb507ce621cdca$var$PickersModalDialogContent, {
            children: children
        })
    }));
}








const $8f4b160cd85e8377$var$_excluded = [
    "props",
    "steps"
], $8f4b160cd85e8377$var$_excluded2 = [
    "ownerState"
];
const $8f4b160cd85e8377$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps_toolbar;
    let { props: props, steps: steps } = _ref, pickerParams = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $8f4b160cd85e8377$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $52f6be834eae5f31$export$57511d4166284144)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $eb835d50c563d0a9$export$fc3313977ac596c4)((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    var _innerSlotProps_toolbar_hidden;
    const isToolbarHidden = (_innerSlotProps_toolbar_hidden = innerSlotProps === null || innerSlotProps === void 0 ? void 0 : (_innerSlotProps_toolbar = innerSlotProps.toolbar) === null || _innerSlotProps_toolbar === void 0 ? void 0 : _innerSlotProps_toolbar.hidden) !== null && _innerSlotProps_toolbar_hidden !== void 0 ? _innerSlotProps_toolbar_hidden : false;
    const Field = slots.field;
    const _useSlotProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps === null || innerSlotProps === void 0 ? void 0 : innerSlotProps.field,
        externalForwardedProps: (0, $3e1b4adab776c920$export$1427765d2f0e99a5)(props),
        additionalProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useSlotProps, $8f4b160cd85e8377$var$_excluded2);
    var _slots_layout;
    const Layout = (_slots_layout = slots.layout) !== null && _slots_layout !== void 0 ? _slots_layout : (0, $d51971d9b4444569$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, innerSlotProps === null || innerSlotProps === void 0 ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps === null || innerSlotProps === void 0 ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $266c452779606bb3$export$aae9fbe9dd4050fa), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Field, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slots, fieldProps.slots),
                    slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slotProps, fieldProps.slotProps),
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47cb507ce621cdca$export$99f83c99e1491f77), {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Layout, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};









'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $1c8a127b5a96fde3$export$97b476d7a92fee62 = /*#__PURE__*/ $7fPBF.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps_slotProps;
    const adapter = (0, $67f1bc9f3ce33f9d$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $6256e61ca6e2a023$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        day: (0, $cb3c0e56c933353d$export$69888ffe06193e5e),
        month: (0, $cb3c0e56c933353d$export$69888ffe06193e5e),
        year: (0, $cb3c0e56c933353d$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $4e19e5fab2f9b93c$export$bb1c921f313ec928)(adapter, defaultizedProps, false),
        slots: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            field: (0, $61864b2c364c1d9d$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps_slotProps;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $7e6c8eda416e9255$export$2e2bcd8739ae039)((_defaultizedProps_slotProps = defaultizedProps.slotProps) === null || _defaultizedProps_slotProps === void 0 ? void 0 : _defaultizedProps_slotProps.field, ownerState), (0, $95d6db0fe23c2dc0$export$5890f750904acddb)(defaultizedProps));
            },
            toolbar: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                hidden: false
            }, (_defaultizedProps_slotProps = defaultizedProps.slotProps) === null || _defaultizedProps_slotProps === void 0 ? void 0 : _defaultizedProps_slotProps.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $8f4b160cd85e8377$export$5ca0153a626a7dd7)({
        ref: ref,
        props: props,
        valueManager: (0, $47fcf740fb158e5e$export$2764b246aa3b75ba),
        valueType: 'date',
        validator: (0, $32a91d31b03a0978$export$ffb3d0046ef3a2),
        steps: null
    });
    return renderPicker();
});




'use client';
const $82b5ac02126ff85d$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $82b5ac02126ff85d$export$5109c6dd95d8fb00 = /*#__PURE__*/ $7fPBF.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $3e8cc72401f6b742$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $3e1b4adab776c920$export$9ae5b19305db48ce) } = props, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $82b5ac02126ff85d$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $ec3395cd7fe43d7a$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5df64ab91bba12c$export$5a73641f0156e1e4), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c8a127b5a96fde3$export$97b476d7a92fee62), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});












let $61f23b7617a6c4bc$var$_ = (t)=>t, $61f23b7617a6c4bc$var$t, $61f23b7617a6c4bc$var$t1;
function $61f23b7617a6c4bc$export$2e2bcd8739ae039({ icon: icon = 'duplicate', iconSize: iconSize = 32, onClick: onClick, inputLabel: inputLabel, actionLabel: actionLabel, value: value, readOnly: readOnly, onChange: onChange, disabled: disabled }) {
    const id = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
            sx: {
                marginTop: '16px',
                marginBottom: '8px'
            },
            fullWidth: true,
            variant: "outlined",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                    htmlFor: id,
                    children: inputLabel
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c1528b45b139d82$export$2e2bcd8739ae039), {
                    id: id,
                    type: "text",
                    value: value,
                    onChange: onChange,
                    disabled: disabled,
                    onClick: onClick,
                    readOnly: readOnly,
                    endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($61f23b7617a6c4bc$var$StyledInputAdornment, {
                        position: "end",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($61f23b7617a6c4bc$var$Button, {
                            "aria-label": actionLabel,
                            onClick: onClick,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: icon,
                                size: iconSize
                            })
                        })
                    }),
                    label: inputLabel
                })
            ]
        })
    });
}
const $61f23b7617a6c4bc$var$Button = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($61f23b7617a6c4bc$var$t || ($61f23b7617a6c4bc$var$t = $61f23b7617a6c4bc$var$_`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
`));
const $61f23b7617a6c4bc$var$StyledInputAdornment = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $decc99a0f014db0d$export$2e2bcd8739ae039))($61f23b7617a6c4bc$var$t1 || ($61f23b7617a6c4bc$var$t1 = $61f23b7617a6c4bc$var$_`
    background-color: ${0};
    color: ${0};
    padding: 28px 14px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 1px solid ${0};
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).border, (0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark, (0, $8951886a6b49e92a$export$35e9368ef982300f).border);









var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $5a6c6a7624f41526$var$_extends() {
    return $5a6c6a7624f41526$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a6c6a7624f41526$var$_extends.apply(null, arguments);
}
var $5a6c6a7624f41526$var$reservedModifierKeywords = [
    'shift',
    'alt',
    'meta',
    'mod',
    'ctrl'
];
var $5a6c6a7624f41526$var$mappedKeys = {
    esc: 'escape',
    "return": 'enter',
    '.': 'period',
    ',': 'comma',
    '-': 'slash',
    ' ': 'space',
    '`': 'backquote',
    '#': 'backslash',
    '+': 'bracketright',
    ShiftLeft: 'shift',
    ShiftRight: 'shift',
    AltLeft: 'alt',
    AltRight: 'alt',
    MetaLeft: 'meta',
    MetaRight: 'meta',
    OSLeft: 'meta',
    OSRight: 'meta',
    ControlLeft: 'ctrl',
    ControlRight: 'ctrl'
};
function $5a6c6a7624f41526$var$mapKey(key) {
    return (key && $5a6c6a7624f41526$var$mappedKeys[key] || key || '').trim().toLowerCase().replace(/key|digit|numpad|arrow/, '');
}
function $5a6c6a7624f41526$var$isHotkeyModifier(key) {
    return $5a6c6a7624f41526$var$reservedModifierKeywords.includes(key);
}
function $5a6c6a7624f41526$var$parseKeysHookInput(keys, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    return keys.split(splitKey);
}
function $5a6c6a7624f41526$var$parseHotkey(hotkey, combinationKey, description) {
    if (combinationKey === void 0) combinationKey = '+';
    var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k) {
        return $5a6c6a7624f41526$var$mapKey(k);
    });
    var modifiers = {
        alt: keys.includes('alt'),
        ctrl: keys.includes('ctrl') || keys.includes('control'),
        shift: keys.includes('shift'),
        meta: keys.includes('meta'),
        mod: keys.includes('mod')
    };
    var singleCharKeys = keys.filter(function(k) {
        return !$5a6c6a7624f41526$var$reservedModifierKeywords.includes(k);
    });
    return $5a6c6a7624f41526$var$_extends({}, modifiers, {
        keys: singleCharKeys,
        description: description,
        hotkey: hotkey
    });
}
(function() {
    if (typeof document !== 'undefined') {
        document.addEventListener('keydown', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$pushToCurrentlyPressedKeys([
                $5a6c6a7624f41526$var$mapKey(e.key),
                $5a6c6a7624f41526$var$mapKey(e.code)
            ]);
        });
        document.addEventListener('keyup', function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$removeFromCurrentlyPressedKeys([
                $5a6c6a7624f41526$var$mapKey(e.key),
                $5a6c6a7624f41526$var$mapKey(e.code)
            ]);
        });
    }
    if (typeof window !== 'undefined') window.addEventListener('blur', function() {
        $5a6c6a7624f41526$var$currentlyPressedKeys.clear();
    });
})();
var $5a6c6a7624f41526$var$currentlyPressedKeys = /*#__PURE__*/ new Set();
// https://github.com/microsoft/TypeScript/issues/17002
function $5a6c6a7624f41526$var$isReadonlyArray(value) {
    return Array.isArray(value);
}
function $5a6c6a7624f41526$export$eae3d25ef8fab782(key, splitKey) {
    if (splitKey === void 0) splitKey = ',';
    var hotkeyArray = $5a6c6a7624f41526$var$isReadonlyArray(key) ? key : key.split(splitKey);
    return hotkeyArray.every(function(hotkey) {
        return $5a6c6a7624f41526$var$currentlyPressedKeys.has(hotkey.trim().toLowerCase());
    });
}
function $5a6c6a7624f41526$var$pushToCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if ($5a6c6a7624f41526$var$currentlyPressedKeys.has('meta')) $5a6c6a7624f41526$var$currentlyPressedKeys.forEach(function(key) {
        return !$5a6c6a7624f41526$var$isHotkeyModifier(key) && $5a6c6a7624f41526$var$currentlyPressedKeys["delete"](key.toLowerCase());
    });
    hotkeyArray.forEach(function(hotkey) {
        return $5a6c6a7624f41526$var$currentlyPressedKeys.add(hotkey.toLowerCase());
    });
}
function $5a6c6a7624f41526$var$removeFromCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (key === 'meta') $5a6c6a7624f41526$var$currentlyPressedKeys.clear();
    else hotkeyArray.forEach(function(hotkey) {
        return $5a6c6a7624f41526$var$currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
}
function $5a6c6a7624f41526$var$maybePreventDefault(e, hotkey, preventDefault) {
    if (typeof preventDefault === 'function' && preventDefault(e, hotkey) || preventDefault === true) e.preventDefault();
}
function $5a6c6a7624f41526$var$isHotkeyEnabled(e, hotkey, enabled) {
    if (typeof enabled === 'function') return enabled(e, hotkey);
    return enabled === true || enabled === undefined;
}
function $5a6c6a7624f41526$var$isKeyboardEventTriggeredByInput(ev) {
    return $5a6c6a7624f41526$var$isHotkeyEnabledOnTag(ev, [
        'input',
        'textarea',
        'select'
    ]);
}
function $5a6c6a7624f41526$var$isHotkeyEnabledOnTag(event, enabledOnTags) {
    if (enabledOnTags === void 0) enabledOnTags = false;
    var target = event.target, composed = event.composed;
    var targetTagName = null;
    if ($5a6c6a7624f41526$var$isCustomElement(target) && composed) targetTagName = event.composedPath()[0] && event.composedPath()[0].tagName;
    else targetTagName = target && target.tagName;
    if ($5a6c6a7624f41526$var$isReadonlyArray(enabledOnTags)) return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
        var _targetTagName;
        return tag.toLowerCase() === ((_targetTagName = targetTagName) == null ? void 0 : _targetTagName.toLowerCase());
    }));
    return Boolean(targetTagName && enabledOnTags && enabledOnTags);
}
function $5a6c6a7624f41526$var$isCustomElement(element) {
    // We just do a basic check w/o any complex RegEx or validation against the list of legacy names containing a hyphen,
    // as none of them is likely to be an event target, and it won't hurt anyway if we miss.
    // see: https://html.spec.whatwg.org/multipage/custom-elements.html#prod-potentialcustomelementname
    return !!element.tagName && !element.tagName.startsWith("-") && element.tagName.includes("-");
}
function $5a6c6a7624f41526$var$isScopeActive(activeScopes, scopes) {
    if (activeScopes.length === 0 && scopes) {
        console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
        return true;
    }
    if (!scopes) return true;
    return activeScopes.some(function(scope) {
        return scopes.includes(scope);
    }) || activeScopes.includes('*');
}
var $5a6c6a7624f41526$var$isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent(e, hotkey, ignoreModifiers) {
    if (ignoreModifiers === void 0) ignoreModifiers = false;
    var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
    var pressedKeyUppercase = e.key, code = e.code, ctrlKey = e.ctrlKey, metaKey = e.metaKey, shiftKey = e.shiftKey, altKey = e.altKey;
    var keyCode = $5a6c6a7624f41526$var$mapKey(code);
    var pressedKey = pressedKeyUppercase.toLowerCase();
    if (!(keys != null && keys.includes(keyCode)) && !(keys != null && keys.includes(pressedKey)) && ![
        'ctrl',
        'control',
        'unknown',
        'meta',
        'alt',
        'shift',
        'os'
    ].includes(keyCode)) return false;
    if (!ignoreModifiers) {
        // We check the pressed keys for compatibility with the keyup event. In keyup events the modifier flags are not set.
        if (alt === !altKey && pressedKey !== 'alt') return false;
        if (shift === !shiftKey && pressedKey !== 'shift') return false;
        // Mod is a special key name that is checking for meta on macOS and ctrl on other platforms
        if (mod) {
            if (!metaKey && !ctrlKey) return false;
        } else {
            if (meta === !metaKey && pressedKey !== 'meta' && pressedKey !== 'os') return false;
            if (ctrl === !ctrlKey && pressedKey !== 'ctrl' && pressedKey !== 'control') return false;
        }
    }
    // All modifiers are correct, now check the key
    // If the key is set, we check for the key
    if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) return true;
    else if (keys) // Check if all keys are present in pressedDownKeys set
    return $5a6c6a7624f41526$export$eae3d25ef8fab782(keys);
    else if (!keys) // If the key is not set, we only listen for modifiers, that check went alright, so we return true
    return true;
    // There is nothing that matches.
    return false;
};
var $5a6c6a7624f41526$var$BoundHotkeysProxyProvider = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
var $5a6c6a7624f41526$var$useBoundHotkeysProxy = function useBoundHotkeysProxy() {
    return (0, $7fPBF.useContext)($5a6c6a7624f41526$var$BoundHotkeysProxyProvider);
};
function $5a6c6a7624f41526$var$BoundHotkeysProxyProviderProvider(_ref) {
    var addHotkey = _ref.addHotkey, removeHotkey = _ref.removeHotkey, children = _ref.children;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a6c6a7624f41526$var$BoundHotkeysProxyProvider.Provider, {
        value: {
            addHotkey: addHotkey,
            removeHotkey: removeHotkey
        },
        children: children
    });
}
function $5a6c6a7624f41526$var$deepEqual(x, y) {
    //@ts-ignore
    return x && y && typeof x === 'object' && typeof y === 'object' ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
    Object.keys(x).reduce(function(isEqual, key) {
        return isEqual && $5a6c6a7624f41526$var$deepEqual(x[key], y[key]);
    }, true) : x === y;
}
var $5a6c6a7624f41526$var$HotkeysContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    hotkeys: [],
    enabledScopes: [],
    toggleScope: function toggleScope() {},
    enableScope: function enableScope() {},
    disableScope: function disableScope() {}
});
var $5a6c6a7624f41526$export$183c7bf336967877 = function useHotkeysContext() {
    return (0, $7fPBF.useContext)($5a6c6a7624f41526$var$HotkeysContext);
};
var $5a6c6a7624f41526$export$9d58aaad435254c0 = function HotkeysProvider(_ref) {
    var _ref$initiallyActiveS = _ref.initiallyActiveScopes, initiallyActiveScopes = _ref$initiallyActiveS === void 0 ? [
        '*'
    ] : _ref$initiallyActiveS, children = _ref.children;
    var _useState = (0, $7fPBF.useState)((initiallyActiveScopes == null ? void 0 : initiallyActiveScopes.length) > 0 ? initiallyActiveScopes : [
        '*'
    ]), internalActiveScopes = _useState[0], setInternalActiveScopes = _useState[1];
    var _useState2 = (0, $7fPBF.useState)([]), boundHotkeys = _useState2[0], setBoundHotkeys = _useState2[1];
    var enableScope = (0, $7fPBF.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes('*')) return [
                scope
            ];
            return Array.from(new Set([].concat(prev, [
                scope
            ])));
        });
    }, []);
    var disableScope = (0, $7fPBF.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.filter(function(s) {
                return s !== scope;
            }).length === 0) return [
                '*'
            ];
            else return prev.filter(function(s) {
                return s !== scope;
            });
        });
    }, []);
    var toggleScope = (0, $7fPBF.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes(scope)) {
                if (prev.filter(function(s) {
                    return s !== scope;
                }).length === 0) return [
                    '*'
                ];
                else return prev.filter(function(s) {
                    return s !== scope;
                });
            } else {
                if (prev.includes('*')) return [
                    scope
                ];
                return Array.from(new Set([].concat(prev, [
                    scope
                ])));
            }
        });
    }, []);
    var addBoundHotkey = (0, $7fPBF.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return [].concat(prev, [
                hotkey
            ]);
        });
    }, []);
    var removeBoundHotkey = (0, $7fPBF.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return prev.filter(function(h) {
                return !$5a6c6a7624f41526$var$deepEqual(h, hotkey);
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a6c6a7624f41526$var$HotkeysContext.Provider, {
        value: {
            enabledScopes: internalActiveScopes,
            hotkeys: boundHotkeys,
            enableScope: enableScope,
            disableScope: disableScope,
            toggleScope: toggleScope
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5a6c6a7624f41526$var$BoundHotkeysProxyProviderProvider, {
            addHotkey: addBoundHotkey,
            removeHotkey: removeBoundHotkey,
            children: children
        })
    });
};
function $5a6c6a7624f41526$var$useDeepEqualMemo(value) {
    var ref = (0, $7fPBF.useRef)(undefined);
    if (!$5a6c6a7624f41526$var$deepEqual(ref.current, value)) ref.current = value;
    return ref.current;
}
var $5a6c6a7624f41526$var$stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
};
var $5a6c6a7624f41526$var$useSafeLayoutEffect = typeof window !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $5a6c6a7624f41526$export$1b0c17123b4f3646(keys, callback, options, dependencies) {
    var _useState = (0, $7fPBF.useState)(null), ref = _useState[0], setRef = _useState[1];
    var hasTriggeredRef = (0, $7fPBF.useRef)(false);
    var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : undefined;
    var _keys = $5a6c6a7624f41526$var$isReadonlyArray(keys) ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
    var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : undefined;
    var memoisedCB = (0, $7fPBF.useCallback)(callback, _deps != null ? _deps : []);
    var cbRef = (0, $7fPBF.useRef)(memoisedCB);
    if (_deps) cbRef.current = memoisedCB;
    else cbRef.current = callback;
    var memoisedOptions = $5a6c6a7624f41526$var$useDeepEqualMemo(_options);
    var _useHotkeysContext = $5a6c6a7624f41526$export$183c7bf336967877(), enabledScopes = _useHotkeysContext.enabledScopes;
    var proxy = $5a6c6a7624f41526$var$useBoundHotkeysProxy();
    $5a6c6a7624f41526$var$useSafeLayoutEffect(function() {
        if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !$5a6c6a7624f41526$var$isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) return;
        var listener = function listener(e, isKeyUp) {
            var _e$target;
            if (isKeyUp === void 0) isKeyUp = false;
            if ($5a6c6a7624f41526$var$isKeyboardEventTriggeredByInput(e) && !$5a6c6a7624f41526$var$isHotkeyEnabledOnTag(e, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) return;
            // TODO: SINCE THE EVENT IS NOW ATTACHED TO THE REF, THE ACTIVE ELEMENT CAN NEVER BE INSIDE THE REF. THE HOTKEY ONLY TRIGGERS IF THE
            // REF IS THE ACTIVE ELEMENT. THIS IS A PROBLEM SINCE FOCUSED SUB COMPONENTS WON'T TRIGGER THE HOTKEY.
            if (ref !== null) {
                var rootNode = ref.getRootNode();
                if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement !== ref && !ref.contains(rootNode.activeElement)) {
                    $5a6c6a7624f41526$var$stopPropagation(e);
                    return;
                }
            }
            if ((_e$target = e.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) return;
            $5a6c6a7624f41526$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                var _hotkey$keys;
                var hotkey = $5a6c6a7624f41526$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
                if ($5a6c6a7624f41526$var$isHotkeyMatchingKeyboardEvent(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes('*')) {
                    if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e)) return;
                    if (isKeyUp && hasTriggeredRef.current) return;
                    $5a6c6a7624f41526$var$maybePreventDefault(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
                    if (!$5a6c6a7624f41526$var$isHotkeyEnabled(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
                        $5a6c6a7624f41526$var$stopPropagation(e);
                        return;
                    }
                    // Execute the user callback for that hotkey
                    cbRef.current(e, hotkey);
                    if (!isKeyUp) hasTriggeredRef.current = true;
                }
            });
        };
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$pushToCurrentlyPressedKeys($5a6c6a7624f41526$var$mapKey(event.code));
            if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === undefined && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) listener(event);
        };
        var handleKeyUp = function handleKeyUp(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $5a6c6a7624f41526$var$removeFromCurrentlyPressedKeys($5a6c6a7624f41526$var$mapKey(event.code));
            hasTriggeredRef.current = false;
            if (memoisedOptions != null && memoisedOptions.keyup) listener(event, true);
        };
        var domNode = ref || (_options == null ? void 0 : _options.document) || document;
        // @ts-ignore
        domNode.addEventListener('keyup', handleKeyUp, _options == null ? void 0 : _options.eventListenerOptions);
        // @ts-ignore
        domNode.addEventListener('keydown', handleKeyDown, _options == null ? void 0 : _options.eventListenerOptions);
        if (proxy) $5a6c6a7624f41526$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
            return proxy.addHotkey($5a6c6a7624f41526$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
        return function() {
            // @ts-ignore
            domNode.removeEventListener('keyup', handleKeyUp, _options == null ? void 0 : _options.eventListenerOptions);
            // @ts-ignore
            domNode.removeEventListener('keydown', handleKeyDown, _options == null ? void 0 : _options.eventListenerOptions);
            if (proxy) $5a6c6a7624f41526$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                return proxy.removeHotkey($5a6c6a7624f41526$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
            });
        };
    }, [
        ref,
        _keys,
        memoisedOptions,
        enabledScopes
    ]);
    return setRef;
}
function $5a6c6a7624f41526$export$175b3984f625ab17() {
    var _useState = (0, $7fPBF.useState)(new Set()), keys = _useState[0], setKeys = _useState[1];
    var _useState2 = (0, $7fPBF.useState)(false), isRecording = _useState2[0], setIsRecording = _useState2[1];
    var handler = (0, $7fPBF.useCallback)(function(event) {
        if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
        return;
        event.preventDefault();
        event.stopPropagation();
        setKeys(function(prev) {
            var newKeys = new Set(prev);
            newKeys.add($5a6c6a7624f41526$var$mapKey(event.code));
            return newKeys;
        });
    }, []);
    var stop = (0, $7fPBF.useCallback)(function() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('keydown', handler);
            setIsRecording(false);
        }
    }, [
        handler
    ]);
    var start = (0, $7fPBF.useCallback)(function() {
        setKeys(new Set());
        if (typeof document !== 'undefined') {
            stop();
            document.addEventListener('keydown', handler);
            setIsRecording(true);
        }
    }, [
        handler,
        stop
    ]);
    var resetKeys = (0, $7fPBF.useCallback)(function() {
        setKeys(new Set());
    }, []);
    return [
        keys,
        {
            start: start,
            stop: stop,
            resetKeys: resetKeys,
            isRecording: isRecording
        }
    ];
}




let $7a1bf8f9f1406bc7$var$_ = (t)=>t, $7a1bf8f9f1406bc7$var$t;
function $7a1bf8f9f1406bc7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { profileId: profileId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const [shareLink, setShareLink] = (0, $7fPBF.useState)('');
    const [hasExpiration, setHasExpiration] = (0, $7fPBF.useState)(false);
    const [isSingleUse, setIsSingleUse] = (0, $7fPBF.useState)(false);
    const [expirationDate, setExpirationDate] = (0, $7fPBF.useState)((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().add(1, 'day'));
    const [existingShares, setExistingShares] = (0, $7fPBF.useState)([]);
    const createLink = async ()=>{
        var _result_data;
        const result = await (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().createShareLink(profileId, isSingleUse, hasExpiration ? expirationDate : null);
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok' && ((_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.accessCode)) {
            const shareLink = `https://share.cephable.com/profileshare/copy/${result.data.accessCode}`;
            setShareLink(shareLink);
            navigator.clipboard.writeText(shareLink);
        }
    };
    const loadShares = async ()=>{
        var _result_data;
        const result = await (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().getShares(profileId);
        var _result_data_filter;
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') setExistingShares((_result_data_filter = (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.filter((s)=>s.isDisabled != true)) !== null && _result_data_filter !== void 0 ? _result_data_filter : []);
    };
    const deleteShare = async (id)=>{
        const result = await (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().deleteShare(id);
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') loadShares();
    };
    (0, $7fPBF.useEffect)(()=>{
        loadShares();
    }, []);
    // listens to ctrl+c or cmd+c
    (0, $5a6c6a7624f41526$export$1b0c17123b4f3646)([
        'mod+c'
    ], ()=>{
        navigator.clipboard.writeText(JSON.stringify((0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().getUserDeviceProfileFromState()));
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$a30053b04ba33ef5), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                    children: shareLink ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61f23b7617a6c4bc$export$2e2bcd8739ae039), {
                        value: shareLink,
                        readOnly: true,
                        onClick: ()=>navigator.clipboard.writeText(shareLink),
                        inputLabel: t('common:profile.share.link'),
                        actionLabel: t('common:profile.share.copy')
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:profile.share.usage')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
                                    name: "isSingleUse",
                                    defaultValue: "right",
                                    onChange: (e)=>setIsSingleUse(e.target.value == 'true'),
                                    value: isSingleUse ? 'true' : 'false',
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                            value: "true",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.once')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                            value: "false",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.unlimited')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:profile.share.expiration.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
                                    name: "hasExpiration",
                                    defaultValue: "right",
                                    onChange: (e)=>setHasExpiration(e.target.value == 'true'),
                                    value: hasExpiration ? 'true' : 'false',
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                            value: "false",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.no')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                            value: "true",
                                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {}),
                                            label: t('common:profile.share.expiration.dateDescription')
                                        })
                                    ]
                                }),
                                hasExpiration && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82b5ac02126ff85d$export$5109c6dd95d8fb00), {
                                    label: t('common:profile.share.expiration.date'),
                                    value: expirationDate,
                                    onChange: (e)=>setExpirationDate(e)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    onClick: createLink,
                                    children: t('common:profile.share.add')
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$aaf6264d06ddc4ce), {
                        children: t('common:profile.share.manage')
                    }),
                    (existingShares === null || existingShares === void 0 ? void 0 : existingShares.length) > 0 ? existingShares.map((share, index)=>{
                        var _dayjs;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7a1bf8f9f1406bc7$var$ShareCard, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                                    children: t('common:profile.share.created', 'created', {
                                        value: (_dayjs = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(share.createdDate)) === null || _dayjs === void 0 ? void 0 : _dayjs.format('dddd MMMM DD, YYYY')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                                    onClick: ()=>deleteShare(share.id),
                                    children: "Remove"
                                })
                            ]
                        }, index);
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: t('common:profile.share.empty')
                    })
                ]
            })
        ]
    });
}
const $7a1bf8f9f1406bc7$var$ShareCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $184b8f5fc607fb11$export$2e2bcd8739ae039))($7a1bf8f9f1406bc7$var$t || ($7a1bf8f9f1406bc7$var$t = $7a1bf8f9f1406bc7$var$_`
    margin: 8px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: ${0};
    > button {
        margin-left: auto;
        margin-right: 0;
    }
`), (props)=>props.theme.color.accentCard);











/** NOTE: not included in ControlTypeField */ function $17c3db2e0b73f463$var$SuggestedPromptField({ value: value, onChange: onChange, disabled: disabled, placeholder: placeholder, autoFocus: autoFocus }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        disabled: disabled,
        fullWidth: true,
        value: value,
        label: t('common:suggestedPrompts.title'),
        placeholder: placeholder,
        autoFocus: autoFocus,
        onChange: (e)=>onChange(e.target.value)
    });
}
var $17c3db2e0b73f463$export$2e2bcd8739ae039 = $17c3db2e0b73f463$var$SuggestedPromptField;





var $7fPBF = parcelRequire("7fPBF");

function $7d3c7fab6a83fa5f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const suggestedGeneratePrompts = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.suggestedGeneratePrompts);
    const { setHasChanges: setHasChanges, updateSuggestedGeneratePrompts: updateSuggestedGeneratePrompts, updateSuggestedRewritePrompts: updateSuggestedRewritePrompts, saveChanges: saveChanges } = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
    const hasChanges = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hasChanges);
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)('generate');
    const [createButtonLabel, setCreateButtonLabel] = (0, $7fPBF.useState)(t('common:suggestedPrompts.addGenerate'));
    const [placeholderText, setPlaceholderText] = (0, $7fPBF.useState)(t('common:suggestedPrompts.generatePlaceholder'));
    const [prompts, setPrompts] = (0, $7fPBF.useState)(suggestedGeneratePrompts || []);
    const newItemIndexRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        const suggestedGeneratePrompts = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().suggestedGeneratePrompts;
        const suggestedRewritePrompts = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().suggestedRewritePrompts;
        if (activeTab === 'generate') {
            setCreateButtonLabel(t('common:suggestedPrompts.addGenerate'));
            setPlaceholderText(t('common:suggestedPrompts.generatePlaceholder'));
            setPrompts(suggestedGeneratePrompts || []);
        } else {
            setCreateButtonLabel(t('common:suggestedPrompts.addRewrite'));
            setPlaceholderText(t('common:suggestedPrompts.rewritePlaceholder'));
            setPrompts(suggestedRewritePrompts || []);
        }
    }, [
        activeTab
    ]);
    const activeTabIsGenerate = activeTab === 'generate';
    const setUpdates = (updated)=>{
        setPrompts(updated);
        if (activeTabIsGenerate) updateSuggestedGeneratePrompts(updated);
        else updateSuggestedRewritePrompts(updated);
        setHasChanges(true);
    };
    const updatePrompts = (value, index)=>{
        const updated = prompts.map((p, i)=>i === index ? value : p);
        setUpdates(updated);
    };
    const removePrompts = (index)=>{
        const updated = prompts.filter((_, i)=>i !== index);
        setUpdates(updated);
    };
    const addPrompts = ()=>{
        const updated = [
            ...prompts,
            ''
        ];
        newItemIndexRef.current = updated.length - 1;
        setUpdates(updated);
    };
    const handleSave = async ()=>{
        const result = await saveChanges();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bf69660d3ccba544$export$63c9a9d77925d61e), {
                role: "tablist",
                "aria-label": "Profile Tabs",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf69660d3ccba544$export$3c56cb56459c147a), {
                        role: "tab",
                        style: {
                            padding: '16px 32px'
                        },
                        "aria-selected": activeTab === 'generate',
                        onClick: ()=>setActiveTab('generate'),
                        isActive: activeTab === 'generate',
                        children: t('common:suggestedPrompts.generate')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf69660d3ccba544$export$3c56cb56459c147a), {
                        role: "tab",
                        style: {
                            padding: '16px 32px'
                        },
                        "aria-selected": activeTab === 'rewrite',
                        onClick: ()=>setActiveTab('rewrite'),
                        isActive: activeTab === 'rewrite',
                        children: t('common:suggestedPrompts.rewrite')
                    })
                ]
            }),
            prompts.map((prompt, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e48650aa2ed148e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $17c3db2e0b73f463$export$2e2bcd8739ae039), {
                            value: prompt,
                            onChange: (value)=>updatePrompts(value, i),
                            disabled: isPreview,
                            placeholder: placeholderText,
                            autoFocus: newItemIndexRef.current === i
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5c09a12afb55a78a$export$2e2bcd8739ae039), {
                            disabled: isPreview,
                            onClick: ()=>removePrompts(i),
                            children: t('common:suggestedPrompts.remove')
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "text",
                    $size: "large",
                    startIcon: "plus",
                    onClick: addPrompts,
                    children: createButtonLabel
                })
            }),
            hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: hasChanges,
                setHasChanges: setHasChanges,
                onSave: handleSave
            })
        ]
    });
}














var $7fPBF = parcelRequire("7fPBF");
/**
 * Filtered views of the profile's macros, keybindings and hotkeys.
 *
 * These must stay *derived*. Mirroring them into `useState` via an effect renders one pass
 * behind the store, and that stale pass re-writes the value of whichever field is being
 * edited — which moves the caret to the end of the input on every keystroke.
 */ const $138dae19c52184af$var$useFilterProfileConfigurations = ({ profile: profile, filter: filter, selectedCommandType: selectedCommandType = '' })=>{
    const filterNormalized = filter === null || filter === void 0 ? void 0 : filter.toLowerCase().trim();
    const macros = profile === null || profile === void 0 ? void 0 : profile.macros;
    const commandKeyMappings = profile === null || profile === void 0 ? void 0 : profile.commandKeyMappings;
    const hotkeys = profile === null || profile === void 0 ? void 0 : profile.hotkeys;
    const filteredMacros = (0, $7fPBF.useMemo)(()=>{
        var _macros_filter;
        return (_macros_filter = macros === null || macros === void 0 ? void 0 : macros.filter((m)=>{
            var _m_name;
            return m.commands.some((c)=>{
                var _c_command;
                return (c.commandType === selectedCommandType || !selectedCommandType) && (((_c_command = c.command) === null || _c_command === void 0 ? void 0 : _c_command.toLowerCase().includes(filterNormalized)) || !filterNormalized);
            }) || ((_m_name = m.name) === null || _m_name === void 0 ? void 0 : _m_name.toLowerCase().includes(filterNormalized)) || !filterNormalized;
        })) !== null && _macros_filter !== void 0 ? _macros_filter : [];
    }, [
        macros,
        filterNormalized,
        selectedCommandType
    ]);
    const filteredKeybinds = (0, $7fPBF.useMemo)(()=>{
        var _commandKeyMappings_filter;
        return (_commandKeyMappings_filter = commandKeyMappings === null || commandKeyMappings === void 0 ? void 0 : commandKeyMappings.filter((m)=>m.commands.some((c)=>{
                var _c_command;
                return (c.commandType == selectedCommandType || !selectedCommandType) && (((_c_command = c.command) === null || _c_command === void 0 ? void 0 : _c_command.toLowerCase().includes(filterNormalized)) || !filterNormalized);
            }))) !== null && _commandKeyMappings_filter !== void 0 ? _commandKeyMappings_filter : [];
    }, [
        commandKeyMappings,
        filterNormalized,
        selectedCommandType
    ]);
    const filteredHotkeys = (0, $7fPBF.useMemo)(()=>{
        var _hotkeys_filter;
        return (_hotkeys_filter = hotkeys === null || hotkeys === void 0 ? void 0 : hotkeys.filter((m)=>{
            var _m_command, _m_displayName;
            return ((_m_command = m.command) === null || _m_command === void 0 ? void 0 : _m_command.toLowerCase().includes(filterNormalized)) || ((_m_displayName = m.displayName) === null || _m_displayName === void 0 ? void 0 : _m_displayName.toLowerCase().includes(filterNormalized)) || !filterNormalized;
        })) !== null && _hotkeys_filter !== void 0 ? _hotkeys_filter : [];
    }, [
        hotkeys,
        filterNormalized
    ]);
    if (!profile) return {
        filteredMacros: null,
        filteredKeybinds: [],
        filteredHotkeys: []
    };
    return {
        filteredMacros: filteredMacros,
        filteredKeybinds: filteredKeybinds,
        filteredHotkeys: filteredHotkeys
    };
};
var $138dae19c52184af$export$2e2bcd8739ae039 = $138dae19c52184af$var$useFilterProfileConfigurations;



var $7fPBF = parcelRequire("7fPBF");

let $4025efcf1cd15ab4$var$_ = (t)=>t, $4025efcf1cd15ab4$var$t;
function $4025efcf1cd15ab4$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const associatedPrograms = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.associatedPrograms);
    const name = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.name);
    const [selectedCommandType, setSelectedCommandType] = (0, $7fPBF.useState)('');
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const { filteredMacros: filteredMacros, filteredHotkeys: filteredHotkeys, filteredKeybinds: filteredKeybinds } = (0, $138dae19c52184af$export$2e2bcd8739ae039)({
        profile: (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState(),
        filter: filter,
        selectedCommandType: selectedCommandType || undefined
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    style: {
                        marginTop: 32
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                            id: "command-type",
                            children: t('common:input.filter')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                            labelId: `command-type`,
                            value: selectedCommandType,
                            label: t('common:input.filter'),
                            onChange: (e)=>setSelectedCommandType(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: '',
                                    children: t('common:all')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: "other",
                                    children: t('common:voice.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: "expression",
                                    children: t('common:expression.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: "tilt",
                                    children: t('common:motion.title')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: "external_keyboard",
                                    children: t('common:hotkey.title')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                            htmlFor: `filter`,
                            children: t('common:profile.summary.filter')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            value: filter !== null && filter !== void 0 ? filter : '',
                            name: `filter`,
                            placeholder: t('common:profile.summary.placeholder'),
                            onChange: (e)=>setFilter(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4025efcf1cd15ab4$var$ListingContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $031c6e7d94ce0aa0$export$2e2bcd8739ae039), {
                        macros: filteredMacros,
                        startExpanded: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51f16c3433a05d99$export$2e2bcd8739ae039), {
                        commandKeyMappings: filteredKeybinds,
                        showDescription: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bb13f250ef3167a$export$2e2bcd8739ae039), {
                        hotkeys: filteredHotkeys,
                        showDescription: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0e241dbffe40cae$export$2e2bcd8739ae039), {
                        programNames: associatedPrograms,
                        profileName: name,
                        showDescription: false
                    })
                ]
            })
        ]
    });
}
const $4025efcf1cd15ab4$var$ListingContentWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4025efcf1cd15ab4$var$t || ($4025efcf1cd15ab4$var$t = $4025efcf1cd15ab4$var$_`
    margin: 0 2rem;
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`));








let $22d301bc679683f5$var$_ = (t)=>t, $22d301bc679683f5$var$t;
const $22d301bc679683f5$export$439a8b0fa6ae7667 = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($22d301bc679683f5$var$t || ($22d301bc679683f5$var$t = $22d301bc679683f5$var$_`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;

    &:hover {
        opacity: 0.8;
    }
`));









const $3521ff40d609c2ed$export$aa94277a9804d2bd = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const setNotifications = (notifications)=>set((state)=>{
            state.notifications = notifications;
        });
    const setUnreadNotifications = (unreadNotifications)=>set((state)=>{
            state.unreadNotifications = unreadNotifications;
        });
    const setErrors = (errors)=>set((state)=>{
            state.errors = errors;
        });
    const setLoading = (loading)=>set((state)=>{
            state.loading = loading;
        });
    const initializeFromRemote = async ()=>{
        await get().getUserNotificationsAll();
    };
    const getUserNotificationsUnread = async ()=>{
        set((state)=>{
            state.loading = true;
        });
        try {
            const allNotes = await $1a4c36336f303477$export$1cfb7ff6a4b15ea();
            if ((allNotes === null || allNotes === void 0 ? void 0 : allNotes.resultType) === 'Ok' && allNotes.data) set((state)=>{
                state.unreadNotifications = allNotes.data.filter((n)=>!n.isRead);
            });
            else {
                set((state)=>{
                    state.errors = [
                        'Failed to load notifications'
                    ];
                });
                console.warn('Error initializing notifications:', allNotes);
            }
        } catch (e) {
            set((state)=>{
                state.errors = [
                    e.message
                ];
            });
            console.error('Error initializing notifications:', e);
        }
        set((state)=>{
            state.loading = false;
        });
    };
    const getUserNotificationsAll = async ()=>{
        set((state)=>{
            state.loading = true;
        });
        try {
            const allNotes = await $1a4c36336f303477$export$e212b208cbec5050();
            if ((allNotes === null || allNotes === void 0 ? void 0 : allNotes.resultType) === 'Ok' && allNotes.data) set((state)=>{
                state.notifications = allNotes.data;
                state.unreadNotifications = allNotes.data.filter((n)=>!n.isRead);
            });
            else {
                set((state)=>{
                    state.errors = [
                        'Failed to load notifications'
                    ];
                });
                console.warn('Error initializing notifications:', allNotes);
            }
        } catch (e) {
            set((state)=>{
                state.errors = [
                    e.message
                ];
            });
            console.error('Error initializing notifications:', e);
        }
        set((state)=>{
            state.loading = false;
        });
    };
    const markNotificationRead = async (notificationId)=>{
        set((state)=>{
            state.loading = true;
        });
        try {
            const markResult = await $1a4c36336f303477$export$49199adf1afcc108(notificationId);
            if ((markResult === null || markResult === void 0 ? void 0 : markResult.resultType) === 'Ok' && markResult.data) set((state)=>{
                const noteIndex = state.notifications.findIndex((n)=>n.id === notificationId);
                if (noteIndex > -1) {
                    state.notifications[noteIndex] = markResult.data;
                    state.unreadNotifications = state.notifications.filter((n)=>!n.isRead);
                }
            });
            else set((state)=>{
                state.errors = [
                    'Failed to mark notification as read'
                ];
            });
        } catch (e) {
            set((state)=>{
                state.errors = [
                    e.message
                ];
            });
        }
        set((state)=>{
            state.loading = false;
        });
    };
    const generateNotification = async (notification)=>{
        set((state)=>{
            state.loading = true;
        });
        try {
            const generateResult = await $1a4c36336f303477$export$f4d031e4baefbd82(notification);
            if ((generateResult === null || generateResult === void 0 ? void 0 : generateResult.resultType) === 'Ok' && generateResult.data) set((state)=>{
                state.notifications.push(generateResult.data);
                state.unreadNotifications = state.notifications.filter((n)=>!n.isRead);
            });
            else set((state)=>{
                state.errors = [
                    'Failed to generate notification'
                ];
            });
        } catch (e) {
            set((state)=>{
                state.errors = [
                    e.message
                ];
            });
        }
        get().initializeFromRemote();
        set((state)=>{
            state.loading = false;
        });
    };
    return {
        // State
        errors: [],
        loading: false,
        notifications: [],
        unreadNotifications: [],
        generateNotification: // Actions
        generateNotification,
        getUserNotificationsAll: getUserNotificationsAll,
        getUserNotificationsUnread: getUserNotificationsUnread,
        initializeFromRemote: initializeFromRemote,
        markNotificationRead: markNotificationRead,
        setErrors: setErrors,
        setLoading: setLoading,
        setNotifications: setNotifications,
        setUnreadNotifications: setUnreadNotifications
    };
}));




var $7fPBF = parcelRequire("7fPBF");






















const $54aa53414bc5a0d5$var$hasTiltControls = (macros)=>{
    return macros.some((macro)=>{
        const hasMotion = (0, $404e806b46f153e3$export$27ae0cf28d39b9f3).some((expression)=>macro.commands.some((command)=>command.includes(expression)));
        return hasMotion;
    });
};
const $54aa53414bc5a0d5$var$hasHeadControls = (macros)=>{
    return macros.some((macro)=>{
        const hasHead = (0, $36ef3dc0587051fc$export$b83c6ea936a344b9).some((expression)=>macro.commands.some((command)=>command.includes(expression)));
        return hasHead;
    });
};
const $54aa53414bc5a0d5$var$hasExpressionControls = (macros)=>{
    return macros.some((macro)=>{
        const hasExpression = (0, $4c9078e3f4d4e7ac$export$821d2a2d20ce1ccf).some((expression)=>macro.commands.some((command)=>command.includes(expression)));
        return hasExpression;
    });
};
const $54aa53414bc5a0d5$var$getProfileFeatures = (profileConfig)=>{
    var _profileConfig_hotkeys, _profileConfig_macros, _profileConfig_audioEvents;
    const features = [];
    if (((_profileConfig_hotkeys = profileConfig.hotkeys) === null || _profileConfig_hotkeys === void 0 ? void 0 : _profileConfig_hotkeys.length) > 0) features.push('hotkey');
    if ($54aa53414bc5a0d5$var$hasTiltControls(profileConfig.macros)) features.push('tilt');
    if ($54aa53414bc5a0d5$var$hasHeadControls(profileConfig.macros)) features.push('head');
    if ($54aa53414bc5a0d5$var$hasExpressionControls(profileConfig.macros)) features.push('expression');
    if (((_profileConfig_macros = profileConfig.macros) === null || _profileConfig_macros === void 0 ? void 0 : _profileConfig_macros.length) > 0) features.push('voice');
    if (((_profileConfig_audioEvents = profileConfig.audioEvents) === null || _profileConfig_audioEvents === void 0 ? void 0 : _profileConfig_audioEvents.length) > 0) features.push('spoken');
    return features;
};
var $54aa53414bc5a0d5$export$2e2bcd8739ae039 = $54aa53414bc5a0d5$var$getProfileFeatures;





var $7fPBF = parcelRequire("7fPBF");

const $c921e0617b97e4e7$export$7f5c23377d97a19f = ()=>typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true;
function $c921e0617b97e4e7$export$2e2bcd8739ae039() {
    const { addBanner: addBanner, removeBanner: removeBanner } = (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [status, setStatus] = (0, $7fPBF.useState)($c921e0617b97e4e7$export$7f5c23377d97a19f());
    const setOnline = ()=>setStatus(true);
    const setOffline = ()=>setStatus(false);
    const handleOffline = (0, $7fPBF.useCallback)(()=>{
        const offlineBanner = {
            id: 'offline',
            icon: 'connectionOffline',
            title: t('common:wifi.disconnected'),
            subtitle: t('common:wifi.description'),
            color: 'error'
        };
        addBanner(offlineBanner);
    }, [
        addBanner,
        t
    ]);
    const handleOnline = (0, $7fPBF.useCallback)(()=>{
        removeBanner('offline');
    }, [
        removeBanner
    ]);
    (0, $7fPBF.useEffect)(()=>{
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);
        return ()=>{
            window.removeEventListener('online', setOnline);
            window.removeEventListener('offline', setOffline);
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (status) handleOnline();
        else handleOffline();
    }, [
        status
    ]);
}


const $ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE = 'PROFILES_LAST_UPDATED_DATE';
const $ba024c453c69bc05$var$DEFAULT_PROFILES = 'DEFAULT_PROFILES';
const $ba024c453c69bc05$export$42d6892da55f3748 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const isProfileLocaleMatch = (profile, locale)=>{
        if (!profile.defaultLocale) return true;
        const normalizedLocale = locale.toLowerCase();
        const profileLocale = profile.defaultLocale.toLowerCase();
        return (0, $eeb1a4bb5a11a603$export$e88b669f03544b69)(profileLocale, 'voice') === normalizedLocale || (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(profileLocale) === (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(normalizedLocale);
    };
    const getFilteredProfiles = (profiles, locale, licenseAccess)=>{
        return profiles.filter((profile)=>isProfileLocaleMatch(profile, locale) && (0, $28343ab509e453ee$export$6ff753f9d38ae18d)(profile, licenseAccess));
    };
    const updateLocalDefaultProfiles = (profiles)=>{
        const sorted = profiles.sort((a, b)=>a.name.localeCompare(b.name));
        set((state)=>{
            state.defaultProfiles = sorted;
        });
        (0, $e7df95de73caec26$export$89b472e03be495df)('default-profiles-updated', sorted);
    };
    const loadDefaultProfilesFromStorage = (locale, licenseAccess)=>{
        let localDefaultProfiles = [];
        try {
            const localProfiles = localStorage.getItem($ba024c453c69bc05$var$DEFAULT_PROFILES);
            if (localProfiles) {
                const parsedProfiles = JSON.parse(localProfiles);
                localDefaultProfiles = getFilteredProfiles(parsedProfiles, locale, licenseAccess);
            }
        } catch (e) {
            console.log(e);
        }
        return localDefaultProfiles;
    };
    const isProfilesOutdated = (profiles, locale, licenseAccess)=>{
        if (profiles.length === 0) return true;
        const newLocaleProfiles = profiles.filter((p)=>isProfileLocaleMatch(p, locale));
        if (newLocaleProfiles.length === 0) return true;
        const freeProfiles = profiles.filter((p)=>(0, $28343ab509e453ee$export$513d3938ac2af8f0)(p));
        if (freeProfiles.length === profiles.length && licenseAccess.type !== 'personal') return true;
        return false;
    };
    const loadDefaultProfilesFromRemote = async (locale, os, lastUpdatedDate)=>{
        const localDefaultProfiles = [];
        try {
            let skip = 0;
            const take = 25;
            let result = new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            let request = {
                locale: locale,
                skip: skip,
                take: take,
                isHidden: false,
                modifiedDate: lastUpdatedDate ? lastUpdatedDate : undefined,
                platform: os
            };
            let hasMore = true;
            while(hasMore){
                result = await $1a4c36336f303477$export$dda1c3bd332d195f(request);
                if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
                    if (result.data.length === 0 || result.data.length < take) hasMore = false;
                    localDefaultProfiles.push(...result.data);
                    skip += result.data.length;
                    request = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, request), {
                        skip: skip
                    });
                } else {
                    set((state)=>{
                        var _result_errors;
                        state.errors = (_result_errors = result.errors) !== null && _result_errors !== void 0 ? _result_errors : [
                            'Error loading default profiles'
                        ];
                    });
                    break;
                }
            }
            return localDefaultProfiles;
        } catch (error) {
            console.error(error);
            set((state)=>{
                state.errors = [
                    'Error loading default profiles'
                ];
            });
            return localDefaultProfiles;
        } finally{
            set((state)=>{
                state.isLoading = false;
            });
        }
    };
    const saveDefaultProfilesToStorage = (profiles)=>{
        try {
            localStorage.setItem($ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE, new Date().toISOString());
            localStorage.setItem($ba024c453c69bc05$var$DEFAULT_PROFILES, JSON.stringify(profiles));
            updateLocalDefaultProfiles(profiles);
        } catch (error) {
            console.error(error);
        }
    };
    const loadDefaultProfiles = async (locale, os, licenseAccess)=>{
        try {
            set((state)=>{
                state.isLoading = true;
            });
            let existingProfiles = loadDefaultProfilesFromStorage(locale, licenseAccess);
            const lastUpdatedDate = existingProfiles.length > 0 && !isProfilesOutdated(existingProfiles, locale, licenseAccess) ? localStorage.getItem($ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE) : undefined;
            const newProfiles = await loadDefaultProfilesFromRemote(locale, os, lastUpdatedDate);
            const combinedProfiles = [
                ...newProfiles
            ];
            if (newProfiles.length > 0 && existingProfiles) {
                for (const profile of existingProfiles)if (isProfileLocaleMatch(profile, locale)) {
                    const existingProfile = combinedProfiles.find((p)=>p.id === profile.id);
                    if (!existingProfile) combinedProfiles.push(profile);
                }
            }
            if (combinedProfiles.length > 0) saveDefaultProfilesToStorage(combinedProfiles);
            else updateLocalDefaultProfiles(existingProfiles);
            return combinedProfiles.length > 0 ? new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(combinedProfiles) : new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(existingProfiles);
        } catch (error) {
            console.error(error);
            set((state)=>{
                state.errors = [
                    'Error loading default profiles'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            set((state)=>{
                state.isLoading = false;
            });
        }
    };
    const getProfileById = async (profileId, loadFromStorageOnly = false)=>{
        try {
            const existingProfile = get().defaultProfiles.find((p)=>p.id === profileId);
            if (existingProfile) return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(existingProfile);
            else if (loadFromStorageOnly) return new (0, $206736819695f5cd$export$2e2bcd8739ae039)();
            else {
                const result = await $1a4c36336f303477$export$fb988fbe57f9c402(profileId);
                return result;
            }
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadPublicProfiles = async (locale, os, licenseAccess, loadFromStorage = false)=>{
        const isOnline = (0, $c921e0617b97e4e7$export$7f5c23377d97a19f)();
        if (!isOnline || loadFromStorage) {
            get().initializeFromStorage(locale, licenseAccess);
            return;
        }
        const defaultProfilesResult = await loadDefaultProfiles(locale, os, licenseAccess);
        if ((defaultProfilesResult === null || defaultProfilesResult === void 0 ? void 0 : defaultProfilesResult.resultType) !== 'Ok') get().initializeFromStorage(locale, licenseAccess);
    };
    const initializeFromStorage = (locale, licenseAccess)=>{
        try {
            const localDefaultProfiles = loadDefaultProfilesFromStorage(locale, licenseAccess);
            updateLocalDefaultProfiles(localDefaultProfiles);
        } catch (e) {
            console.log(e);
        }
    };
    const getPaginatedPublicProfiles = async (filters, os)=>{
        try {
            set((state)=>{
                state.isLoading = true;
            });
            const request = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filters), {
                platform: os
            });
            const result = await $1a4c36336f303477$export$dda1c3bd332d195f(request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                var _result_data;
                const sortedProfiles = ((_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(b.modifiedDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(a.modifiedDate)))) || [];
                sortedProfiles.forEach((p, i)=>{
                    sortedProfiles[i].features = (0, $54aa53414bc5a0d5$export$2e2bcd8739ae039)(p.configuration);
                });
                set((state)=>{
                    state.publicProfiles = sortedProfiles;
                });
            }
            set((state)=>{
                state.isLoading = false;
            });
            return result;
        } catch (error) {
            console.error(error);
            set((state)=>{
                state.isLoading = false;
                state.errors = [
                    'Error getting profiles'
                ];
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getPublicProfileFeatures = (profileId)=>{
        const profile = get().publicProfiles.find((p)=>p.id === profileId);
        if (!profile) return [];
        return (0, $54aa53414bc5a0d5$export$2e2bcd8739ae039)(profile.configuration);
    };
    const clearProfiles = ()=>{
        set((state)=>{
            state.defaultProfiles = [];
            state.publicProfiles = [];
        });
        localStorage.removeItem($ba024c453c69bc05$var$DEFAULT_PROFILES);
        localStorage.removeItem($ba024c453c69bc05$var$PROFILES_LAST_UPDATED_DATE);
    };
    const getProfile = async (profileId, loadFromStorageOnly = false)=>{
        const profileResult = await getProfileById(profileId, loadFromStorageOnly);
        if ((profileResult === null || profileResult === void 0 ? void 0 : profileResult.resultType) === 'Ok' && profileResult.data) return profileResult.data;
        return null;
    };
    return {
        // State
        defaultProfiles: [],
        publicProfiles: [],
        isLoading: false,
        errors: [],
        clearProfiles: // Actions
        clearProfiles,
        getPaginatedPublicProfiles: getPaginatedPublicProfiles,
        getProfile: getProfile,
        getPublicProfileFeatures: getPublicProfileFeatures,
        initializeFromStorage: initializeFromStorage,
        isProfileLocaleMatch: isProfileLocaleMatch,
        loadDefaultProfilesFromRemote: loadDefaultProfilesFromRemote,
        loadPublicProfiles: loadPublicProfiles,
        saveDefaultProfilesToStorage: saveDefaultProfilesToStorage
    };
}));









var $gSkQi = parcelRequire("gSkQi");
function $109a0b472437364a$export$186d0c8cd99a5e65(profile, favorites) {
    var _profile_configuration;
    const macros = profile === null || profile === void 0 ? void 0 : (_profile_configuration = profile.configuration) === null || _profile_configuration === void 0 ? void 0 : _profile_configuration.macros;
    if (!macros) return false;
    return macros.some((m)=>m.id != null && m.id in favorites && !!m.isFavorite !== favorites[m.id]);
}
function $109a0b472437364a$export$3c1b064ed728421(profile, favorites) {
    const clone = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(profile);
    var _clone_configuration_macros;
    clone.configuration.macros = ((_clone_configuration_macros = clone.configuration.macros) !== null && _clone_configuration_macros !== void 0 ? _clone_configuration_macros : []).map((m)=>m.id != null && m.id in favorites ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
            isFavorite: favorites[m.id]
        }) : m);
    return clone;
}
function $109a0b472437364a$export$bfa2b33b23c7c846(profile, favorites) {
    const withFavorites = $109a0b472437364a$export$3c1b064ed728421(profile, favorites);
    var _withFavorites_description, _withFavorites_defaultLocale, _withFavorites_requiresEmployeeAccess, _withFavorites_requiresStudentAccess, _withFavorites_requiresGenericLicense, _withFavorites_requiresPlusAccess, _withFavorites_platform, _withFavorites_interests, _withFavorites_organizationId;
    return {
        name: withFavorites.name,
        description: (_withFavorites_description = withFavorites.description) !== null && _withFavorites_description !== void 0 ? _withFavorites_description : '',
        profileType: withFavorites.configuration.profileType,
        configuration: withFavorites.configuration,
        defaultLocale: (_withFavorites_defaultLocale = withFavorites.defaultLocale) !== null && _withFavorites_defaultLocale !== void 0 ? _withFavorites_defaultLocale : '',
        originatedByProfileId: withFavorites.originatedByProfileId,
        requiresEmployeeAccess: (_withFavorites_requiresEmployeeAccess = withFavorites.requiresEmployeeAccess) !== null && _withFavorites_requiresEmployeeAccess !== void 0 ? _withFavorites_requiresEmployeeAccess : false,
        requiresStudentAccess: (_withFavorites_requiresStudentAccess = withFavorites.requiresStudentAccess) !== null && _withFavorites_requiresStudentAccess !== void 0 ? _withFavorites_requiresStudentAccess : false,
        requiresGenericLicense: (_withFavorites_requiresGenericLicense = withFavorites.requiresGenericLicense) !== null && _withFavorites_requiresGenericLicense !== void 0 ? _withFavorites_requiresGenericLicense : false,
        requiresPlusAccess: (_withFavorites_requiresPlusAccess = withFavorites.requiresPlusAccess) !== null && _withFavorites_requiresPlusAccess !== void 0 ? _withFavorites_requiresPlusAccess : false,
        platform: (_withFavorites_platform = withFavorites.platform) !== null && _withFavorites_platform !== void 0 ? _withFavorites_platform : 'generic',
        interests: (_withFavorites_interests = withFavorites.interests) !== null && _withFavorites_interests !== void 0 ? _withFavorites_interests : [],
        organizationId: (_withFavorites_organizationId = withFavorites.organizationId) !== null && _withFavorites_organizationId !== void 0 ? _withFavorites_organizationId : undefined
    };
}


async function $3067d71ce8045ada$export$75371600075d5413(profileId, favorites) {
    const canonical = (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().allProfiles.find((p)=>p.id === profileId);
    if (!canonical) return false;
    // Favorites on a public profile can't be persisted (the user doesn't own it) — leave them session-only.
    if (canonical.isPublic) return false;
    // Skip a no-op write when the stored profile already matches the panel's favorite state.
    if (!(0, $109a0b472437364a$export$186d0c8cd99a5e65)(canonical, favorites)) return true;
    const result = await $1a4c36336f303477$export$5880729c5d131040(profileId, (0, $109a0b472437364a$export$bfa2b33b23c7c846)(canonical, favorites));
    if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) {
        // Keep local stores in sync (mirrors EditProfileContainer.saveChanges).
        (0, $e7df95de73caec26$export$89b472e03be495df)('userProfileUpdated', {
            profile: result.data
        });
        return true;
    }
    return false;
}



let $a3e40fac5e1cec18$var$requestCounter = 0;
function $a3e40fac5e1cec18$export$f98b8c48ff970d22(timeoutMs = 2000) {
    const requestId = `panel-favorites-${++$a3e40fac5e1cec18$var$requestCounter}`;
    return new Promise((resolve)=>{
        let settled = false;
        const finish = (state)=>{
            if (settled) return;
            settled = true;
            unsubscribe();
            clearTimeout(timer);
            resolve(state);
        };
        const unsubscribe = (0, $e7df95de73caec26$export$ec068583843480e7)('panelFavoritesResponse', (data)=>{
            if (data.requestId !== requestId) return;
            finish({
                profileId: data.profileId,
                favorites: data.favorites,
                dirty: data.dirty
            });
        });
        const timer = setTimeout(()=>finish({
                profileId: null,
                favorites: {},
                dirty: false
            }), timeoutMs);
        (0, $e7df95de73caec26$export$89b472e03be495df)('requestPanelFavorites', {
            requestId: requestId
        });
    });
}


function $6e4c204c2f850d70$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [isShowingSignoutConfirmation, setIsShowingSignoutConfirmation] = (0, $7fPBF.useState)(false);
    const hideSignoutConfirmation = (0, $7fPBF.useCallback)(()=>{
        setIsShowingSignoutConfirmation(false);
    }, []);
    const showSignoutConfirmation = (0, $7fPBF.useCallback)(()=>{
        setIsShowingSignoutConfirmation(true);
    }, []);
    const clearAndReload = (0, $7fPBF.useCallback)(()=>{
        // Perform all necessary cleanup operations
        (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().logout();
        (0, $57ef534a0961ba07$export$2b13470419707314).getState().clearDevices();
        (0, $43d630686eddb628$export$21b1c44aa0aad518).getState().clearAll();
        (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().clearProfiles();
        (0, $ba024c453c69bc05$export$42d6892da55f3748).getState().clearProfiles();
        (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().clearCurrentUser();
        (0, $b8d2d4cc121e033d$export$5c51a4b25a3f0496).getState().clear();
        // Clear upgrade modal dismissal so it shows again on next login
        localStorage.removeItem((0, $4a3c7ab711a29dd4$export$ee420f2304181127));
        navigate('../login');
        window.location.reload(); // Reload the page to ensure all changes take effect
    }, []);
    const signout = async ()=>{
        var _useCurrentDeviceStore_getState_currentProfile;
        console.log('signout');
        // remove everything from local storage, navigate to home page, refresh page
        // delete virtual device then clear
        (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().handleIsLoading(true);
        hideSignoutConfirmation();
        // Persist any unsaved favorite changes for the current device profile before tearing down.
        // The panel window holds the live favorites; ask it (bridged over IPC) and save via the API.
        // Awaited before clearAndReload so the profiles store is still populated for the save.
        if ((_useCurrentDeviceStore_getState_currentProfile = (0, $43d630686eddb628$export$21b1c44aa0aad518).getState().currentProfile) === null || _useCurrentDeviceStore_getState_currentProfile === void 0 ? void 0 : _useCurrentDeviceStore_getState_currentProfile.id) try {
            const panelFavorites = await (0, $a3e40fac5e1cec18$export$f98b8c48ff970d22)();
            if (panelFavorites.dirty && panelFavorites.profileId) await (0, $3067d71ce8045ada$export$75371600075d5413)(panelFavorites.profileId, panelFavorites.favorites);
        } catch (error) {
            console.error('Failed to persist favorites on sign-out', error);
        }
        const virtualDeviceId = (0, $57ef534a0961ba07$export$2b13470419707314).getState().virtualDeviceId;
        if (virtualDeviceId) try {
            const result = await (0, $57ef534a0961ba07$export$2b13470419707314).getState().disableDevice(virtualDeviceId);
            if ((result === null || result === void 0 ? void 0 : result.resultType) != 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:device.error.deleteLong'));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:device.error.deleteLong'));
        }
        clearAndReload();
        (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().handleIsLoading(false);
    };
    return {
        signout: signout,
        isSignOutConfirmationVisible: isShowingSignoutConfirmation,
        showSignoutConfirmation: showSignoutConfirmation,
        hideSignoutConfirmation: hideSignoutConfirmation,
        clearAndReload: clearAndReload
    };
}



var $7fPBF = parcelRequire("7fPBF");












var $7fPBF = parcelRequire("7fPBF");












const $6c98c9e4544fab35$export$59a533f935b3ed74 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function getLocaleDisplayName(locale) {
        return t(`common:localization.locales.${locale}`, locale);
    }
    return getLocaleDisplayName;
};



function $bdbd121ff5ebdd35$var$LocalizationLanguageField({ value: value, onChange: onChange, disabled: disabled, variant: variant }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const fieldId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const inputLabel = t(`common:localization.${variant}.title`);
    const getLocaleDisplayName = (0, $6c98c9e4544fab35$export$59a533f935b3ed74)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                id: fieldId,
                children: inputLabel
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                labelId: `${variant}_language_field`,
                value: value,
                label: inputLabel,
                onChange: (e)=>onChange(e.target.value),
                disabled: disabled,
                children: (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed)[variant].map((locale)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                        value: locale,
                        children: getLocaleDisplayName(locale)
                    }, `${locale}_${variant}`))
            })
        ]
    });
}
var $bdbd121ff5ebdd35$export$2e2bcd8739ae039 = $bdbd121ff5ebdd35$var$LocalizationLanguageField;


let $1078910feab41cef$var$_ = (t)=>t, $1078910feab41cef$var$t;
function $1078910feab41cef$var$LocalizationFieldCard({ variant: variant, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        title: (0, $1e580fbd50c9e2d3$export$625550452a3fa3ec)(`common:localization.${variant}.title`),
        description: (0, $1e580fbd50c9e2d3$export$625550452a3fa3ec)(`common:localization.${variant}.description`),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1078910feab41cef$var$TextWrap, {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bdbd121ff5ebdd35$export$2e2bcd8739ae039), {
                variant: variant,
                value: value,
                onChange: onChange
            })
        })
    });
}
const $1078910feab41cef$var$TextWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($1078910feab41cef$var$t || ($1078910feab41cef$var$t = $1078910feab41cef$var$_`
    padding-top: 2rem;
    width: 100%;
`));
var $1078910feab41cef$export$2e2bcd8739ae039 = $1078910feab41cef$var$LocalizationFieldCard;


function $ccbc7a02b152347e$var$LocalizationEditDialog(_param) {
    var { open: open, onClose: onClose, description: description, customSave: customSave = null } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "open",
        "onClose",
        "description",
        "customSave"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const initialUserLocalePreferences = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.userLocalePreferences);
    const getCurrentUserLocales = ()=>{
        return {
            defaultLocale: initialUserLocalePreferences.defaultLocale,
            defaultVoiceLocale: initialUserLocalePreferences.defaultVoiceLocale
        };
    };
    const [userLocalePreferences, setUserLocalePreferences] = (0, $7fPBF.useState)(getCurrentUserLocales());
    const handleCancel = ()=>{
        onClose();
        setUserLocalePreferences(getCurrentUserLocales());
    };
    const handleSave = async ()=>{
        if ((0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().isAuthenticated) {
            const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().saveUserLocales(userLocalePreferences);
            if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') {
                onClose();
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:localization.save.success'), 5000);
            } else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:localization.save.error'), 5000);
        } else {
            // handle case when locale is changed pre-auth.
            (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().updateUserLocales(userLocalePreferences, false);
            onClose();
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:localization.save.success'), 5000);
        }
    };
    const handleLanguageSelection = (variant, value)=>{
        const newLocalePreferences = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, userLocalePreferences);
        if (variant == 'display') newLocalePreferences.defaultLocale = value;
        else if (variant == 'voice') newLocalePreferences.defaultVoiceLocale = value;
        setUserLocalePreferences(newLocalePreferences);
    };
    // Sync local state when dialog opens or store values change
    (0, $7fPBF.useEffect)(()=>{
        if (open) setUserLocalePreferences(getCurrentUserLocales());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        initialUserLocalePreferences.defaultLocale,
        initialUserLocalePreferences.defaultVoiceLocale
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "data-testid": "localization-edit-dialog",
        title: t('common:localization.title'),
        description: description !== null && description !== void 0 ? description : '',
        open: open,
        onConfirm: ()=>customSave ? customSave(userLocalePreferences.defaultLocale) : handleSave(),
        onCancel: handleCancel,
        onClose: handleCancel
    }, restProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$8a73847ccc40addf), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1078910feab41cef$export$2e2bcd8739ae039), {
                    variant: "display",
                    value: userLocalePreferences.defaultLocale,
                    onChange: (value)=>handleLanguageSelection('display', value)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1078910feab41cef$export$2e2bcd8739ae039), {
                    variant: "voice",
                    value: userLocalePreferences.defaultVoiceLocale,
                    onChange: (value)=>handleLanguageSelection('voice', value)
                })
            ]
        })
    }));
}
var $ccbc7a02b152347e$export$2e2bcd8739ae039 = $ccbc7a02b152347e$var$LocalizationEditDialog;


let $4d34bf1fa9080e8b$var$_ = (t)=>t, $4d34bf1fa9080e8b$var$t, $4d34bf1fa9080e8b$var$t1, $4d34bf1fa9080e8b$var$t2, $4d34bf1fa9080e8b$var$t3;
function $4d34bf1fa9080e8b$export$2e2bcd8739ae039({ settingsHref: settingsHref, notificationHref: notificationHref, skipConfirmation: skipConfirmation = true, otherContent: otherContent }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const isAuthenticated = (0, $455682785eac4c5b$export$650ce9f0b4df82fd)((state)=>state.isAuthenticated);
    const isEmailVerified = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.isEmailVerified);
    const { signout: signout, isSignOutConfirmationVisible: isSignOutConfirmationVisible, showSignoutConfirmation: showSignoutConfirmation, hideSignoutConfirmation: hideSignoutConfirmation } = (0, $6e4c204c2f850d70$export$2e2bcd8739ae039)();
    const unreadNotifications = (0, $3521ff40d609c2ed$export$aa94277a9804d2bd)((state)=>state.unreadNotifications);
    const [showLocalizationDialog, setShowLocalizationDialog] = (0, $7fPBF.useState)(false);
    function handleClick(event) {
        if (anchorEl !== event.currentTarget) setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    function handleSettingsClick() {
        handleClose();
        navigate(settingsHref);
    }
    function handleLogoutClick() {
        handleClose();
        showSignoutConfirmation();
    }
    function handleNotificationClick() {
        handleClose();
        navigate(notificationHref);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$IconButton, {
                id: "user-menu",
                "aria-haspopup": "true",
                "aria-expanded": anchorEl ? 'true' : 'false',
                onClick: handleClick,
                onMouseOver: handleClick,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                        children: t('common:account.menu')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        size: 24,
                        name: "user"
                    }),
                    unreadNotifications.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d34bf1fa9080e8b$var$NotificationIndicator, {
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $32855a33cbd5a576$export$2e2bcd8739ae039), {
                closeAfterTransition: false,
                "aria-labelledby": "user-menu",
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: handleClose,
                slotProps: {
                    list: {
                        onMouseLeave: handleClose
                    }
                },
                children: [
                    otherContent,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledMenuItem, {
                        onClick: ()=>setShowLocalizationDialog(true),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: "globe",
                                size: 20
                            }),
                            t('common:localization.titleShort')
                        ]
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            isEmailVerified && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledMenuItem, {
                                        onClick: handleNotificationClick,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "alert",
                                                size: 20
                                            }),
                                            t('common:notifications.title')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$StyledMenuItem, {
                                        onClick: handleSettingsClick,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "settings",
                                                size: 20
                                            }),
                                            t('common:account.settings')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4d34bf1fa9080e8b$var$SignOutMenuItem, {
                                onClick: skipConfirmation ? signout : handleLogoutClick,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                        name: "logout"
                                    }),
                                    t('common:account.signout.title')
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ccbc7a02b152347e$export$2e2bcd8739ae039), {
                open: showLocalizationDialog,
                onClose: ()=>setShowLocalizationDialog(false)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: isSignOutConfirmationVisible,
                onCancel: hideSignoutConfirmation,
                title: t('common:account.signout.question'),
                description: t('common:account.signout.description'),
                onConfirm: signout,
                confirmButtonText: t('common:account.signout.confirm'),
                cancelButtonText: t('common:cancel')
            })
        ]
    });
}
const $4d34bf1fa9080e8b$var$StyledMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039))($4d34bf1fa9080e8b$var$t || ($4d34bf1fa9080e8b$var$t = $4d34bf1fa9080e8b$var$_`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 300;
    ${0}
    letter-spacing: 0.03rem;
    &:hover {
        color: ${0};
        text-decoration: underline;
    }
`), (0, $b091aef3a32d2bd8$export$3e193b19d995235f), (props)=>props.theme.color.accent);
const $4d34bf1fa9080e8b$var$SignOutMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)($4d34bf1fa9080e8b$var$StyledMenuItem)($4d34bf1fa9080e8b$var$t1 || ($4d34bf1fa9080e8b$var$t1 = $4d34bf1fa9080e8b$var$_`
    margin-top: 1rem;
    padding-top: 0.5rem;
    border-top: 1px solid ${0};
`), (props)=>props.theme.input.border);
const $4d34bf1fa9080e8b$var$NotificationIndicator = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($4d34bf1fa9080e8b$var$t2 || ($4d34bf1fa9080e8b$var$t2 = $4d34bf1fa9080e8b$var$_`
    position: absolute;
    top: 5px;
    right: 5px;
    width: 10px;
    height: 10px;
    background-color: ${0};
    border-radius: 50%;
    pointer-events: none; /* Ensure it doesn't interfere with clicks */
`), (props)=>props.theme.color.link);
const $4d34bf1fa9080e8b$var$IconButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $22d301bc679683f5$export$439a8b0fa6ae7667))($4d34bf1fa9080e8b$var$t3 || ($4d34bf1fa9080e8b$var$t3 = $4d34bf1fa9080e8b$var$_`
    color: ${0};
`), (props)=>props.theme.color.text);






function $e4b0152a6024286a$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$1e86fd0e1db89578), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$8e6b12661156fe2f), {
                href: "#/",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $41158ab2c4dff680$export$2e2bcd8739ae039), {
                        width: 125
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                        children: t('common:home.title')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$eddf54ea3db8d0f0), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d34bf1fa9080e8b$export$2e2bcd8739ae039), {
                    settingsHref: '../my-account',
                    notificationHref: '../notifications'
                })
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");
const $b1f35a815c258980$var$useReduceMotion = ()=>{
    const [isReducedMotion, setIsReducedMotion] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const handleReduceMotionChange = ()=>{
            setIsReducedMotion(mediaQuery.matches);
        };
        handleReduceMotionChange();
        mediaQuery.addEventListener('change', handleReduceMotionChange);
        return ()=>{
            mediaQuery.removeEventListener('change', handleReduceMotionChange);
        };
    }, []);
    return isReducedMotion;
};
var $b1f35a815c258980$export$2e2bcd8739ae039 = $b1f35a815c258980$var$useReduceMotion;



let $546e295734ca2def$var$_ = (t)=>t, $546e295734ca2def$var$t;
function $546e295734ca2def$export$2e2bcd8739ae039({ scrollToId: scrollToId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const isReducedMotion = (0, $b1f35a815c258980$export$2e2bcd8739ae039)();
    const handleClick = ()=>{
        const element = document.getElementById(scrollToId);
        if (element) {
            element.focus();
            element.scrollIntoView({
                behavior: isReducedMotion ? 'instant' : 'smooth'
            });
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($546e295734ca2def$var$SkipToMainLink, {
        onClick: handleClick,
        children: t('common:skipToMain')
    });
}
const $546e295734ca2def$var$SkipToMainLink = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($546e295734ca2def$var$t || ($546e295734ca2def$var$t = $546e295734ca2def$var$_`
    position: absolute;
    top: -40px;
    left: 0;
    background: ${0};
    color: ${0};
    padding: 0.5rem 1rem;
    z-index: 100;
    text-decoration: none;
    font-weight: 700;
    transition: top 0.3s;
    &:focus {
        top: 0;
    }
`), ({ theme: theme })=>theme.color.text, ({ theme: theme })=>theme.color.background);


function $2bae683e05e61603$export$2e2bcd8739ae039({ children: children, headerContent: headerContent, offset: offset = 0 }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$a14e0b54e46f6871), {
        $offset: offset,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $546e295734ca2def$export$2e2bcd8739ae039), {
                scrollToId: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$d6b9c1bba5ee845), {
                children: headerContent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$5b061f6699ff1c06), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$2264cf7efee465f9), {
                    id: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8),
                    tabIndex: -1,
                    children: children
                })
            })
        ]
    });
}


parcelRequire("7fPBF");
function $d308289446e38196$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2bae683e05e61603$export$2e2bcd8739ae039), {
        headerContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4b0152a6024286a$export$2e2bcd8739ae039), {}),
        children: children
    });
}








var $7fPBF = parcelRequire("7fPBF");

const $fdf6d68b1a7a3435$var$TokenRefresher = ()=>{
    const { signout: signout } = (0, $6e4c204c2f850d70$export$2e2bcd8739ae039)();
    const REFRESH_MS = 1500000; // 25 min
    (0, $7fPBF.useEffect)(()=>{
        const interval = setInterval(async ()=>{
            if (!(0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().isLoading) {
                const result = await (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState().getNewToken();
                const isAdmin = (0, $db3063bd3b6d501e$export$94d1d6411b964f7)() == 'admin';
                if (isAdmin && result.resultType !== 'Ok') signout();
                // loadUserLicenseAccess has a fallback to storage
                await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().loadUserLicenseAccess();
            // removing this to not force reconnect of signalr on refresh
            // publish('force-reconnect');
            }
        }, REFRESH_MS);
        return ()=>clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {});
};
var $fdf6d68b1a7a3435$export$2e2bcd8739ae039 = $fdf6d68b1a7a3435$var$TokenRefresher;








var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");



'use client';
function $e3f467debf57d841$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $80a372d1a4c84812$export$2e2bcd8739ae039)();
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose === null || onClose === void 0 ? void 0 : onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event, reason)=>{
        onClose === null || onClose === void 0 ? void 0 : onClose(event, reason);
    });
    const setAutoHideTimer = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $7fPBF.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose === null || onClose === void 0 ? void 0 : onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $7fPBF.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback === null || onBlurCallback === void 0 ? void 0 : onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback === null || onFocusCallback === void 0 ? void 0 : onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback === null || onMouseEnterCallback === void 0 ? void 0 : onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback === null || onMouseLeaveCallback === void 0 ? void 0 : onMouseLeaveCallback(event);
            handleResume();
        };
    $7fPBF.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d6f21882b2ade459$export$2e2bcd8739ae039)(parameters), (0, $d6f21882b2ade459$export$2e2bcd8739ae039)(externalProps));
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers), {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $e3f467debf57d841$export$2e2bcd8739ae039 = $e3f467debf57d841$var$useSnackbar;



var $7fPBF = parcelRequire("7fPBF");








'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $114507656b938c3f$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $114507656b938c3f$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $114507656b938c3f$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/react/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $86c63002f4c86923$export$2e2bcd8739ae039)((0, $1c288d38aeb7dcee$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $114507656b938c3f$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !(0, $9028c966bc380775$export$2e2bcd8739ae039)(doc.documentElement, event.target) || (0, $9028c966bc380775$export$2e2bcd8739ae039)(nodeRef.current, event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $7fPBF.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $114507656b938c3f$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $7fPBF.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $114507656b938c3f$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $f6d27cbe60518e62$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps);
}











var $7fPBF = parcelRequire("7fPBF");










function $e6290a006c6489a3$export$def81488db1a3216(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiSnackbarContent', slot);
}
const $e6290a006c6489a3$var$snackbarContentClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $e6290a006c6489a3$export$2e2bcd8739ae039 = $e6290a006c6489a3$var$snackbarContentClasses;



'use client';
const $562321b4282e75fd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $e6290a006c6489a3$export$def81488db1a3216), classes);
};
const $562321b4282e75fd$var$SnackbarContentRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.body2), {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText((0, $989ea3f9d8f44081$export$e665714f76e581fd)(theme.palette.background.default, emphasis)),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : (0, $989ea3f9d8f44081$export$e665714f76e581fd)(theme.palette.background.default, emphasis),
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
}));
const $562321b4282e75fd$var$SnackbarContentMessage = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message'
})({
    padding: '8px 0'
});
const $562321b4282e75fd$var$SnackbarContentAction = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $562321b4282e75fd$var$SnackbarContent = /*#__PURE__*/ $7fPBF.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "action",
        "className",
        "message",
        "role"
    ]);
    const ownerState = props;
    const classes = $562321b4282e75fd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($562321b4282e75fd$var$SnackbarContentRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        role: role,
        elevation: 6,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($562321b4282e75fd$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($562321b4282e75fd$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $562321b4282e75fd$export$2e2bcd8739ae039 = $562321b4282e75fd$var$SnackbarContent;




function $f4fdef2309236e39$export$6cb096457f5926f4(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiSnackbar', slot);
}
const $f4fdef2309236e39$var$snackbarClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f4fdef2309236e39$export$2e2bcd8739ae039 = $f4fdef2309236e39$var$snackbarClasses;




'use client';
const $d3c024375219024e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $f4fdef2309236e39$export$6cb096457f5926f4), classes);
};
const $d3c024375219024e$var$SnackbarRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $d3c024375219024e$var$Snackbar = /*#__PURE__*/ $7fPBF.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, transitionDuration: transitionDuration = defaultTransitionDuration } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "className",
        "disableWindowBlurListener",
        "message",
        "onBlur",
        "onClose",
        "onFocus",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "slots",
        "slotProps",
        "transitionDuration"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        transitionDuration: transitionDuration
    });
    const classes = $d3c024375219024e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $e3f467debf57d841$export$2e2bcd8739ae039)(ownerState);
    const [exited, setExited] = $7fPBF.useState(true);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [Root, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $d3c024375219024e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        ownerState: ownerState
    });
    const _useSlot = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('clickAwayListener', {
        elementType: (0, $114507656b938c3f$export$58385c17fee43f89),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    var _handlers_onClickAway;
                    const event = params[0];
                    (_handlers_onClickAway = handlers.onClickAway) === null || _handlers_onClickAway === void 0 ? void 0 : _handlers_onClickAway.call(handlers, ...params);
                    if (event === null || event === void 0 ? void 0 : event.defaultMuiPrevented) return;
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    }), [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp }] = _useSlot, clickAwayListenerProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_useSlot[1], [
        "ownerState"
    ]);
    const [ContentSlot, contentSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('content', {
        elementType: (0, $562321b4282e75fd$export$2e2bcd8739ae039),
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $3ab1beedea58600b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    var _handlers_onEnter;
                    (_handlers_onEnter = handlers.onEnter) === null || _handlers_onEnter === void 0 ? void 0 : _handlers_onEnter.call(handlers, ...params);
                    setExited(false);
                },
                onExited: (...params)=>{
                    var _handlers_onExited;
                    (_handlers_onExited = handlers.onExited) === null || _handlers_onExited === void 0 ? void 0 : _handlers_onExited.call(handlers, ...params);
                    setExited(true);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClickAwaySlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, clickAwayListenerProps, slots.clickAwayListener && {
        ownerState: clickAwayOwnerStateProp
    }), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Root, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TransitionSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transitionProps), {
                children: children || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ContentSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentSlotProps))
            }))
        }))
    }));
});
var $d3c024375219024e$export$2e2bcd8739ae039 = $d3c024375219024e$var$Snackbar;


let $137bd7d08cdd39ae$var$_ = (t)=>t, $137bd7d08cdd39ae$var$t;
function $137bd7d08cdd39ae$export$2e2bcd8739ae039({ severity: severity, message: message }) {
    if (message === '') return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($137bd7d08cdd39ae$var$ToolbarSnackbar, {
        open: true,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0e94917eb8d34aa5$export$2e2bcd8739ae039), {
            severity: severity,
            sx: {
                width: '100%'
            },
            children: message
        })
    });
}
const $137bd7d08cdd39ae$var$ToolbarSnackbar = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $d3c024375219024e$export$2e2bcd8739ae039))($137bd7d08cdd39ae$var$t || ($137bd7d08cdd39ae$var$t = $137bd7d08cdd39ae$var$_`
    margin-top: 52px;
`));


function $9ee98a180c3fcf7a$export$2e2bcd8739ae039(props) {
    const success = (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42)((state)=>state.success);
    const warning = (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42)((state)=>state.warning);
    const error = (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42)((state)=>state.error);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137bd7d08cdd39ae$export$2e2bcd8739ae039), {
                severity: "error",
                message: error
            }),
            success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137bd7d08cdd39ae$export$2e2bcd8739ae039), {
                severity: "success",
                message: success
            }),
            warning && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $137bd7d08cdd39ae$export$2e2bcd8739ae039), {
                severity: "warning",
                message: warning
            })
        ]
    });
}











const $0c1ab25d828a9947$export$118f45a8309a4356 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set)=>({
        // State
        isCollapsed: false,
        // Actions
        toggleCollapsed: ()=>set((state)=>{
                state.isCollapsed = !state.isCollapsed;
            }),
        setCollapsed: (collapsed)=>set((state)=>{
                state.isCollapsed = collapsed;
            })
    })));



function $020e06f09a693c51$export$133e74ed0ce62600(href) {
    if (!href) return '/';
    return href.startsWith('/') ? href : '/' + href;
}
function $020e06f09a693c51$export$2e2bcd8739ae039(href) {
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    const correctedHref = $020e06f09a693c51$export$133e74ed0ce62600(href);
    return {
        startMatch: location.pathname.startsWith(correctedHref),
        exactMatch: location.pathname === correctedHref,
        getCorrectedHref: $020e06f09a693c51$export$133e74ed0ce62600
    };
}



var $7fPBF = parcelRequire("7fPBF");









let $52f85d4476d77156$var$_ = (t)=>t, $52f85d4476d77156$var$t, $52f85d4476d77156$var$t1, $52f85d4476d77156$var$t2, $52f85d4476d77156$var$t3, $52f85d4476d77156$var$t4, $52f85d4476d77156$var$t5, $52f85d4476d77156$var$t6, $52f85d4476d77156$var$t7, $52f85d4476d77156$var$t8, $52f85d4476d77156$var$t9, $52f85d4476d77156$var$t10, $52f85d4476d77156$var$t11, $52f85d4476d77156$var$t12;
const $52f85d4476d77156$export$c41ee88144f544d8 = 16;
const $52f85d4476d77156$export$f3cf094cba057fe0 = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t || ($52f85d4476d77156$var$t = $52f85d4476d77156$var$_`
    background-color: ${0};
    color: ${0};
    border: 1px solid ${0};
    overflow: hidden;
`), theme.color.accentCard, theme.color.text, theme.color.border);
const $52f85d4476d77156$export$70c67a3f7d0c5d9 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t1 || ($52f85d4476d77156$var$t1 = $52f85d4476d77156$var$_`
    text-decoration: none;

    ${0}
    &:hover,
    &:focus {
        text-decoration: underline;
    }
`), (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $52f85d4476d77156$export$a56d8f56d2a61cdc = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t2 || ($52f85d4476d77156$var$t2 = $52f85d4476d77156$var$_`
    display: flex;
    align-items: center;
`));
const $52f85d4476d77156$export$d76ebe66a35bd9e4 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t3 || ($52f85d4476d77156$var$t3 = $52f85d4476d77156$var$_`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 0px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 0px;
    padding: 0;
    margin: 0;
`));
const $52f85d4476d77156$export$b3f4db470d6087f0 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t4 || ($52f85d4476d77156$var$t4 = $52f85d4476d77156$var$_`
    @media (max-width: 500px) {
        ${0}
    }
`), $52f85d4476d77156$export$d76ebe66a35bd9e4);
const $52f85d4476d77156$export$fa0509db3f2d3c5 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t5 || ($52f85d4476d77156$var$t5 = $52f85d4476d77156$var$_`
    [data-collapsed='true'] & {
        ${0}
    }
`), $52f85d4476d77156$export$d76ebe66a35bd9e4);
const $52f85d4476d77156$export$5a9b97e708ad0766 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($52f85d4476d77156$var$t6 || ($52f85d4476d77156$var$t6 = $52f85d4476d77156$var$_`
    flex-shrink: 0;
    width: 6px;
    min-width: 6px;
    max-width: 6px;
    height: 1.75rem;
    margin: 0.25rem 0;
    background-color: ${0};
`), (props)=>props.isActive ? props.theme.color.accent : 'transparent');
const $52f85d4476d77156$export$41f7f2138d562eaf = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($52f85d4476d77156$var$t7 || ($52f85d4476d77156$var$t7 = $52f85d4476d77156$var$_`
    ${0}
    ${0}
    padding: 0 0.25rem 0 0;
`), (0, $b091aef3a32d2bd8$export$41749b24b1e59255), (0, $b091aef3a32d2bd8$export$90f89b8a63d85ede));
const $52f85d4476d77156$export$6f1fd8501043f18d = (0, $8de346382d86c747$export$2e2bcd8739ae039)($52f85d4476d77156$export$41f7f2138d562eaf)($52f85d4476d77156$var$t8 || ($52f85d4476d77156$var$t8 = $52f85d4476d77156$var$_`
    ${0}
    ${0}
`), $52f85d4476d77156$export$b3f4db470d6087f0, $52f85d4476d77156$export$fa0509db3f2d3c5);
const $52f85d4476d77156$export$703c1c953fa4e09f = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t9 || ($52f85d4476d77156$var$t9 = $52f85d4476d77156$var$_`
    display: flex;
    align-items: center;
    width: 100%;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    ${0}
    color: ${0};
    &:hover,
    &:focus {
        background-color: ${0};
        outline: none;
    }

    ${0}
`), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4), theme.color.text, theme.color.border, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $52f85d4476d77156$export$5dbea4eb1d692ec8 = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t10 || ($52f85d4476d77156$var$t10 = $52f85d4476d77156$var$_`
    color: ${0};
    &.active,
    &:hover,
    &:focus {
        color: ${0};
    }
`), theme.color.textBody, theme.color.text);
const $52f85d4476d77156$export$44ed08724635349f = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t11 || ($52f85d4476d77156$var$t11 = $52f85d4476d77156$var$_`
    ${0}
    width: 100%;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    &:hover,
    &:focus {
        background-color: ${0};
        outline: none;
    }

    ${0}
`), $52f85d4476d77156$export$a56d8f56d2a61cdc, theme.color.border, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $52f85d4476d77156$export$ffdb31dd435fbd72 = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($52f85d4476d77156$var$t12 || ($52f85d4476d77156$var$t12 = $52f85d4476d77156$var$_`
    ${0}
    ${0}
`), (0, $b091aef3a32d2bd8$export$41749b24b1e59255), $52f85d4476d77156$export$5dbea4eb1d692ec8(theme));








let $3825d73ff67b3ed3$var$_ = (t)=>t, $3825d73ff67b3ed3$var$t, $3825d73ff67b3ed3$var$t1;
function $3825d73ff67b3ed3$export$2e2bcd8739ae039({ item: item }) {
    const { exactMatch: exactMatch } = (0, $020e06f09a693c51$export$2e2bcd8739ae039)(item.href);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$5a9b97e708ad0766), {
                isActive: exactMatch,
                isSubActive: !!item.activeSub
            }),
            item.href ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3825d73ff67b3ed3$var$MenuItemLink, {
                id: item.id,
                role: "menuitem",
                to: item.href,
                target: item.target,
                viewTransition: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3825d73ff67b3ed3$var$MenuLabel, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: item.icon,
                            size: (0, $52f85d4476d77156$export$c41ee88144f544d8)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$6f1fd8501043f18d), {
                            $isActive: exactMatch !== null && exactMatch !== void 0 ? exactMatch : !!item.activeSub,
                            children: item.label
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3825d73ff67b3ed3$var$MenuLabel, {
                id: item.id,
                role: "menuitem",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: item.icon,
                        size: (0, $52f85d4476d77156$export$c41ee88144f544d8)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$6f1fd8501043f18d), {
                        $isActive: exactMatch !== null && exactMatch !== void 0 ? exactMatch : !!item.activeSub,
                        children: item.label
                    })
                ]
            })
        ]
    });
}
const $3825d73ff67b3ed3$var$MenuLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($3825d73ff67b3ed3$var$t || ($3825d73ff67b3ed3$var$t = $3825d73ff67b3ed3$var$_`
    ${0}
    gap: 0.25rem;
    justify-items: center;
`), (0, $52f85d4476d77156$export$a56d8f56d2a61cdc));
const $3825d73ff67b3ed3$var$MenuItemLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f232cebbf1b70e96$export$b0d92dbee9b5b60d))($3825d73ff67b3ed3$var$t1 || ($3825d73ff67b3ed3$var$t1 = $3825d73ff67b3ed3$var$_`
    ${0}
    padding: 0 0.25rem;
    flex: 1;
    justify-self: center;
    ${0}
`), (0, $52f85d4476d77156$export$70c67a3f7d0c5d9), (props)=>(0, $52f85d4476d77156$export$5dbea4eb1d692ec8)(props.theme));







let $d3cd096afaede658$var$_ = (t)=>t, $d3cd096afaede658$var$t, $d3cd096afaede658$var$t1, $d3cd096afaede658$var$t2;
function $d3cd096afaede658$export$2e2bcd8739ae039({ subItem: subItem }) {
    const { startMatch: startMatch, exactMatch: exactMatch } = (0, $020e06f09a693c51$export$2e2bcd8739ae039)(subItem.href);
    const isActive = !subItem.activeStateMatchCriteria || subItem.activeStateMatchCriteria == 'start' ? startMatch : exactMatch;
    const matchUrlExactly = subItem.activeStateMatchCriteria == 'exact' || subItem.activeStateMatchCriteria == 'end';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d3cd096afaede658$var$SubmenuItem, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d3cd096afaede658$var$SubMenuActiveBar, {
                isActive: isActive,
                isSubActive: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d3cd096afaede658$var$SubmenuLink, {
                id: subItem.id,
                to: subItem.href,
                role: "menuitem",
                end: matchUrlExactly,
                viewTransition: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52f85d4476d77156$export$6f1fd8501043f18d), {
                    children: subItem.label
                })
            })
        ]
    });
}
const $d3cd096afaede658$var$SubmenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($d3cd096afaede658$var$t || ($d3cd096afaede658$var$t = $d3cd096afaede658$var$_`
    ${0}
`), (props)=>(0, $52f85d4476d77156$export$44ed08724635349f)(props.theme));
const $d3cd096afaede658$var$SubmenuLink = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f232cebbf1b70e96$export$b0d92dbee9b5b60d))($d3cd096afaede658$var$t1 || ($d3cd096afaede658$var$t1 = $d3cd096afaede658$var$_`
    ${0}
    padding: 0.5rem 0.5rem 0.5rem 40px;
    ${0}
`), (0, $52f85d4476d77156$export$70c67a3f7d0c5d9), (props)=>(0, $52f85d4476d77156$export$ffdb31dd435fbd72)(props.theme));
const $d3cd096afaede658$var$SubMenuActiveBar = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $52f85d4476d77156$export$5a9b97e708ad0766))($d3cd096afaede658$var$t2 || ($d3cd096afaede658$var$t2 = $d3cd096afaede658$var$_``));


let $2eb3a8db99bc4b3a$var$_ = (t)=>t, $2eb3a8db99bc4b3a$var$t, $2eb3a8db99bc4b3a$var$t1, $2eb3a8db99bc4b3a$var$t2, $2eb3a8db99bc4b3a$var$t3, $2eb3a8db99bc4b3a$var$t4, $2eb3a8db99bc4b3a$var$t5, $2eb3a8db99bc4b3a$var$t6, $2eb3a8db99bc4b3a$var$t7;
function $2eb3a8db99bc4b3a$export$2e2bcd8739ae039({ prefixComponent: prefixComponent, topMenuItems: topMenuItems, bottomMenuItems: bottomMenuItems }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    const isCollapsed = (0, $0c1ab25d828a9947$export$118f45a8309a4356)((state)=>state.isCollapsed);
    const [openMenus, setOpenMenus] = (0, $7fPBF.useState)({});
    const [manualToggles, setManualToggles] = (0, $7fPBF.useState)({});
    // Automatically open menus based on location.pathname, respecting manual toggles
    (0, $7fPBF.useEffect)(()=>{
        const updatedOpenMenus = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, openMenus);
        [
            ...topMenuItems,
            ...bottomMenuItems
        ].forEach((item)=>{
            if (item.submenu) {
                const correctedHref = (0, $020e06f09a693c51$export$133e74ed0ce62600)(item.href);
                if (location.pathname.startsWith(correctedHref)) {
                    updatedOpenMenus[item.label] = true;
                    manualToggles[item.label] = true;
                }
            }
        });
        setOpenMenus(updatedOpenMenus);
    }, [
        location.pathname,
        topMenuItems,
        bottomMenuItems
    ]);
    const toggleMenu = (label)=>{
        setManualToggles((prevState)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevState), {
                [label]: !prevState[label]
            }));
        setOpenMenus((prevState)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevState), {
                [label]: !prevState[label]
            }));
    };
    const checkActiveSub = (item)=>{
        return openMenus[item.label] || false;
    };
    const renderMenuItems = (menuItems)=>{
        return menuItems.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$MenuItemWrapper, {
                role: "none",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$MenuItemContainer, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3825d73ff67b3ed3$export$2e2bcd8739ae039), {
                                item: item
                            }),
                            item.submenu && !item.activeSub && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$ExpandButton, {
                                role: "menuitem",
                                "aria-expanded": checkActiveSub(item),
                                "aria-haspopup": "true",
                                "aria-label": t('menu.expand'),
                                onClick: ()=>toggleMenu(item.label),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "expandArrow",
                                    size: 8
                                })
                            })
                        ]
                    }),
                    item.submenu && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$Submenu, {
                        role: "menu",
                        isOpen: checkActiveSub(item),
                        children: item.submenu.map((subItem, subIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3cd096afaede658$export$2e2bcd8739ae039), {
                                subItem: subItem
                            }, subIndex))
                    })
                ]
            }, index));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$SidebarNav, {
        "aria-label": "Sidebar Navigation",
        "data-collapsed": isCollapsed,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($2eb3a8db99bc4b3a$var$TopSection, {
                children: [
                    prefixComponent,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$MenuList, {
                        role: "menubar",
                        children: renderMenuItems(topMenuItems)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$BottomSection, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2eb3a8db99bc4b3a$var$MenuList, {
                    role: "menubar",
                    children: renderMenuItems(bottomMenuItems)
                })
            })
        ]
    });
}
// Styled Components
const $2eb3a8db99bc4b3a$var$TopSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2eb3a8db99bc4b3a$var$t || ($2eb3a8db99bc4b3a$var$t = $2eb3a8db99bc4b3a$var$_`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    scrollbar-width: none;
    margin-bottom: auto;
`));
const $2eb3a8db99bc4b3a$var$BottomSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2eb3a8db99bc4b3a$var$t1 || ($2eb3a8db99bc4b3a$var$t1 = $2eb3a8db99bc4b3a$var$_`
    width: 100%;
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${0};
`), (props)=>props.theme.color.sidebarDivider);
const $2eb3a8db99bc4b3a$var$SidebarNav = (0, $8de346382d86c747$export$2e2bcd8739ae039).nav($2eb3a8db99bc4b3a$var$t2 || ($2eb3a8db99bc4b3a$var$t2 = $2eb3a8db99bc4b3a$var$_`
    max-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid ${0};
`), (props)=>props.theme.color.sidebarDivider);
const $2eb3a8db99bc4b3a$var$MenuList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($2eb3a8db99bc4b3a$var$t3 || ($2eb3a8db99bc4b3a$var$t3 = $2eb3a8db99bc4b3a$var$_`
    list-style: none;
    margin: 0;
    padding: 0;
`));
const $2eb3a8db99bc4b3a$var$MenuItemWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).li($2eb3a8db99bc4b3a$var$t4 || ($2eb3a8db99bc4b3a$var$t4 = $2eb3a8db99bc4b3a$var$_``));
const $2eb3a8db99bc4b3a$var$MenuItemContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2eb3a8db99bc4b3a$var$t5 || ($2eb3a8db99bc4b3a$var$t5 = $2eb3a8db99bc4b3a$var$_`
    ${0}
`), (props)=>(0, $52f85d4476d77156$export$703c1c953fa4e09f)(props.theme));
const $2eb3a8db99bc4b3a$var$ExpandButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($2eb3a8db99bc4b3a$var$t6 || ($2eb3a8db99bc4b3a$var$t6 = $2eb3a8db99bc4b3a$var$_`
    margin-left: auto;
    height: 30px;
    min-width: 30px;
    background: none;
    border: none;
    cursor: pointer;
    ${0}
    color: inherit;
    &:hover,
    &:focus {
        outline: none;
    }

    transform: rotate(0deg);
    transition: transform 0.3s ease-in-out;

    &[aria-expanded='true'] {
        transform: rotate(180deg);
        ${0}
    }
    ${0}
    ${0}
`), (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4), (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd), (0, $52f85d4476d77156$export$b3f4db470d6087f0), (0, $52f85d4476d77156$export$fa0509db3f2d3c5));
const $2eb3a8db99bc4b3a$var$Submenu = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($2eb3a8db99bc4b3a$var$t7 || ($2eb3a8db99bc4b3a$var$t7 = $2eb3a8db99bc4b3a$var$_`
    list-style: none;
    margin: 0;
    padding: 0;
    display: ${0};
    padding-bottom: 20px;
    ${0}
    ${0}
`), (props)=>props.isOpen ? 'block' : 'none', (0, $52f85d4476d77156$export$b3f4db470d6087f0), (0, $52f85d4476d77156$export$fa0509db3f2d3c5));





var $7fPBF = parcelRequire("7fPBF");

const $ff0a0decfce0b174$var$ScrollToTop = ()=>{
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    (0, $7fPBF.useEffect)(()=>{
        setTimeout(()=>{
            const contentElement = document.getElementById((0, $14e4f1609944ac39$export$18d6475ce2e9bfe8));
            if (contentElement) contentElement.scrollTop = 0;
            else window.scrollTo(0, 0);
        }, 100); // timeout due to view transitions
    }, [
        location
    ]);
    return null;
};
var $ff0a0decfce0b174$export$2e2bcd8739ae039 = $ff0a0decfce0b174$var$ScrollToTop;



function $064a5b98a9970d8a$export$2e2bcd8739ae039({ isLoading: isLoading, headerContent: headerContent, topItems: topItems = [], bottomItems: bottomItems = [], managed: managed = false, children: children, offset: offset = 0, prefixComponent: prefixComponent }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$a14e0b54e46f6871), {
        $offset: offset,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $546e295734ca2def$export$2e2bcd8739ae039), {
                scrollToId: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$d6b9c1bba5ee845), {
                children: headerContent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$5b061f6699ff1c06), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ee98a180c3fcf7a$export$2e2bcd8739ae039), {}),
                    isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {
                        text: t('common:authenticating'),
                        refreshButton: true
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2eb3a8db99bc4b3a$export$2e2bcd8739ae039), {
                                topMenuItems: topItems,
                                bottomMenuItems: bottomItems,
                                prefixComponent: prefixComponent
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$2264cf7efee465f9), {
                                id: (0, $14e4f1609944ac39$export$18d6475ce2e9bfe8),
                                tabIndex: -1,
                                "data-managed": !!managed,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ff0a0decfce0b174$export$2e2bcd8739ae039), {}),
                                    children
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}









var $7fPBF = parcelRequire("7fPBF");






'use client';
var $cde68eb75095d357$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');




'use client';
var $47d083a378b7cd8a$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');




'use client';
var $a538594cdb65885a$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');






function $02acf1c5a6bceb26$export$6c57c6e16b4063b(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiCheckbox', slot);
}
const $02acf1c5a6bceb26$var$checkboxClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $02acf1c5a6bceb26$export$2e2bcd8739ae039 = $02acf1c5a6bceb26$var$checkboxClasses;









'use client';
const $782ff1a97e868b05$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $02acf1c5a6bceb26$export$6c57c6e16b4063b), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $782ff1a97e868b05$var$CheckboxRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $ee7fbb23030d5fe3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $796b6cf2edfc05d3$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $02acf1c5a6bceb26$export$2e2bcd8739ae039).checked}, &.${(0, $02acf1c5a6bceb26$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $02acf1c5a6bceb26$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $782ff1a97e868b05$var$defaultCheckedIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47d083a378b7cd8a$export$2e2bcd8739ae039), {});
const $782ff1a97e868b05$var$defaultIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cde68eb75095d357$export$2e2bcd8739ae039), {});
const $782ff1a97e868b05$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a538594cdb65885a$export$2e2bcd8739ae039), {});
const $782ff1a97e868b05$var$Checkbox = /*#__PURE__*/ $7fPBF.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $782ff1a97e868b05$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $782ff1a97e868b05$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $782ff1a97e868b05$var$defaultIndeterminateIcon, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "checkedIcon",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "size",
        "disableRipple",
        "className",
        "slots",
        "slotProps"
    ]);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $782ff1a97e868b05$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input;
    var _icon_props_fontSize, _indeterminateIcon_props_fontSize;
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $782ff1a97e868b05$var$CheckboxRoot,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            slots: slots,
            slotProps: slotProps
        }, other),
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
                fontSize: (_icon_props_fontSize = icon.props.fontSize) !== null && _icon_props_fontSize !== void 0 ? _icon_props_fontSize : size
            }),
            checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(indeterminateIcon, {
                fontSize: (_indeterminateIcon_props_fontSize = indeterminateIcon.props.fontSize) !== null && _indeterminateIcon_props_fontSize !== void 0 ? _indeterminateIcon_props_fontSize : size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $a7f2a504e52c35ca$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate,
                    'aria-checked': indeterminate ? 'mixed' : undefined
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        classes: classes
    }));
});
var $782ff1a97e868b05$export$2e2bcd8739ae039 = $782ff1a97e868b05$var$Checkbox;






var $7fPBF = parcelRequire("7fPBF");



let $c6b91e65655da099$var$_ = (t)=>t, $c6b91e65655da099$var$t;
function $c6b91e65655da099$export$2e2bcd8739ae039({ open: open, tosConfig: tosConfig, onAccepted: onAccepted }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const [isSubmitting, setIsSubmitting] = (0, $7fPBF.useState)(false);
    const [hasError, setHasError] = (0, $7fPBF.useState)(false);
    const [hasAcceptedTerms, setHasAcceptedTerms] = (0, $7fPBF.useState)(false);
    const handleAccept = async ()=>{
        setIsSubmitting(true);
        setHasError(false);
        try {
            const result = await $1a4c36336f303477$export$c2c1fd00af0fe210({
                version: tosConfig.requiredVersion,
                // IP address is intentionally left empty; the server infers it from the request
                ipAddress: ''
            });
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') onAccepted();
            else setHasError(true);
        } catch (e) {
            console.error('Failed to accept TOS', e);
            setHasError(true);
        } finally{
            setIsSubmitting(false);
        }
    };
    const formattedDate = tosConfig.effectiveDate ? new Date(tosConfig.effectiveDate).toLocaleDateString() : '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $29f821306e66414b$export$2e2bcd8739ae039), {
        open: open,
        onClose: (_, reason)=>{
            if (reason !== 'escapeKeyDown') handleAccept();
        },
        slotProps: {
            paper: {
                sx: {
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    borderColor: theme.color.border,
                    background: theme.color.background
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c6b91e65655da099$var$TitleRow, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$a821680a90fed6), {
                            children: t('common:tos.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d34bf1fa9080e8b$export$2e2bcd8739ae039), {
                            settingsHref: "#",
                            notificationHref: "#",
                            skipConfirmation: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:tos.description')
                        }),
                        formattedDate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:tos.effectiveDate', {
                                date: formattedDate
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "text",
                            $size: "small",
                            href: "https://cephable.com/terms-of-use/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: t('common:tos.viewInBrowser')
                        }),
                        hasError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:tos.loadError')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$b54ac9d7963ef6f6), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                            checked: hasAcceptedTerms,
                            onChange: (e)=>setHasAcceptedTerms(e.target.checked)
                        }),
                        label: t('common:tos.acceptCheckbox')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "secondary",
                        onClick: handleAccept,
                        disabled: isSubmitting || !hasAcceptedTerms,
                        children: t('common:tos.accept')
                    })
                ]
            })
        ]
    });
}
const $c6b91e65655da099$var$TitleRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c6b91e65655da099$var$t || ($c6b91e65655da099$var$t = $c6b91e65655da099$var$_`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 1rem;
`));












const $55ce97f088539572$export$87aeeca3aeff7121 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const setLoading = (v)=>{
        set({
            loading: v
        });
    };
    const setLoadingData = (key, value)=>{
        set((s)=>{
            s.loadingData[key] = value;
        });
    };
    const addError = (message)=>{
        set((s)=>{
            s.errors.push(message);
        });
    };
    const updateMemberships = (newMemberships, updateLicenseAccess = true)=>{
        set({
            memberships: newMemberships
        });
        if (updateLicenseAccess) (0, $e7df95de73caec26$export$89b472e03be495df)('updateUserLicenseAccess');
    };
    const loadOrganizations = async (updateLicenseAccess = true)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$f7fea89e235b5345();
            if (response.resultType === 'Ok' && response.data) {
                updateMemberships(response.data, updateLicenseAccess);
                localStorage.setItem('ORGANIZATIONS', JSON.stringify(response.data));
            }
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const setErrors = (errors)=>set({
            errors: errors
        });
    const setCurrentUserEmail = (email)=>set({
            currentUserEmail: email
        });
    const setScopes = (v)=>set({
            scopes: v
        });
    const setOrgAuthClients = (v)=>set({
            orgAuthClients: v
        });
    const setOrgDeviceTypes = (v)=>set({
            orgDeviceTypes: v
        });
    const handleLoadingDataChange = (key, value)=>setLoadingData(key, value);
    const initializeFromRemote = ()=>loadOrganizations(false);
    const initializeFromStorage = ()=>{
        try {
            const localMemberships = localStorage.getItem('ORGANIZATIONS');
            if (localMemberships) updateMemberships(JSON.parse(localMemberships), false);
        } catch (e) {
            console.log(e);
        }
    };
    const loadOrganizationMembers = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9fa0549694b5b397(organizationId, searchParams);
            if (response.data) set((s)=>{
                const idx = s.organizationMembers.findIndex((m)=>m.organizationId === organizationId);
                if (idx === -1) s.organizationMembers.push({
                    organizationId: organizationId,
                    members: response.data
                });
                else s.organizationMembers[idx].members = response.data;
            });
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const loadInvites = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$fc5cc62c84093276(organizationId, searchParams);
            if (response.data) set((s)=>{
                const idx = s.invites.findIndex((i)=>i.organizationId === organizationId);
                if (idx === -1) s.invites.push({
                    organizationId: organizationId,
                    invites: response.data
                });
                else s.invites[idx].invites = response.data;
            });
            setLoading(false);
            return response;
        } catch (error) {
            set({
                invites: []
            });
            addError(error.message);
            setLoading(false);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const createOrganizationInvite = async (organizationId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$ca73d6dfa029e755(organizationId, request);
            if (response.resultType === 'Ok') await get().loadInvites(organizationId);
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
        }
    };
    const deleteOrganizationInvite = async (organizationId, inviteId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$723853a93f25bfc8(inviteId);
            if (response.resultType === 'Ok') await get().loadInvites(organizationId);
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
        }
    };
    const acceptOrganizationInvite = async (inviteId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$760587335e9aead6(inviteId);
            if (response.resultType === 'Ok') await loadOrganizations();
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
            return new (0, $6340c001daecf2cb$export$2e2bcd8739ae039)(error.message);
        }
    };
    const removeMember = async (organizationId, memberId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$f49c5f59ccb70c7(memberId);
            if (response.resultType === 'Ok') {
                var _response_data;
                await get().loadOrganizationMembers(organizationId);
                if (((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.user.email) === get().currentUserEmail) (0, $e7df95de73caec26$export$89b472e03be495df)('updateUserLicenseAccess');
            }
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
        }
    };
    const updateMemberRole = async (organizationId, memberId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9e3347137373e17d(memberId, request);
            if (response.resultType === 'Ok') await get().loadOrganizationMembers(organizationId);
            setLoading(false);
            return response;
        } catch (error) {
            addError(error.message);
            setLoading(false);
        }
    };
    const updateOrganization = async (organizationId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$3f4430ea1068bd7f(organizationId, request);
            if (response.resultType === 'Ok') {
                await loadOrganizations();
                return response;
            } else throw new Error('Error updating organization');
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationDetails = async (organizationId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$7e61d855c21d0cf9(organizationId);
            if (response.resultType !== 'Ok') throw new Error('Organization not found');
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const loadCurrentOrganizationDetails = async (organizationId)=>{
        try {
            setLoadingData('currentOrg', true);
            const response = await $1a4c36336f303477$export$7e61d855c21d0cf9(organizationId);
            if (response.resultType === 'Ok' && response.data) set({
                currentOrg: response.data
            });
            return response;
        } catch (error) {
            set({
                currentOrg: null
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoadingData('currentOrg', false);
        }
    };
    const getOrgAuthClients = async (organizationId)=>{
        if (!organizationId) {
            set({
                orgAuthClients: []
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$3c51bcb045a4dcf7(organizationId);
            if (response.resultType === 'Ok' && response.data) set({
                orgAuthClients: response.data
            });
            else set({
                orgAuthClients: []
            });
            return response;
        } catch (error) {
            addError(error.message);
            set({
                orgAuthClients: []
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const createOrgAuthClient = async (organizationId, request)=>{
        if (!organizationId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$6273d0fdd20ec2b(organizationId, request);
            if (response.resultType === 'Ok') await get().getOrgAuthClients(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const updateOrgAuthClient = async (organizationId, orgAuthClientId, request)=>{
        if (!organizationId || !orgAuthClientId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$882babc7ce0168b1(organizationId, orgAuthClientId, request);
            if (response.resultType === 'Ok') await get().getOrgAuthClients(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const rotateClientSecret = async (organizationId, orgAuthClientId)=>{
        if (!organizationId || !orgAuthClientId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$fb8fa300ccf972f1(organizationId, orgAuthClientId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const deleteOrgAuthClient = async (organizationId, orgAuthClientId)=>{
        if (!organizationId || !orgAuthClientId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9d046100115f8eb6(organizationId, orgAuthClientId);
            if (response.resultType === 'Ok') await get().getOrgAuthClients(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgDeviceTypes = async (organizationId)=>{
        if (!organizationId) {
            set({
                orgDeviceTypes: []
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$1349a2482875cb46(organizationId);
            if (response.resultType === 'Ok' && response.data) set({
                orgDeviceTypes: response.data
            });
            else set({
                orgDeviceTypes: []
            });
            return response;
        } catch (error) {
            addError(error.message);
            set({
                orgDeviceTypes: []
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const createOrgDeviceType = async (organizationId, request)=>{
        if (!organizationId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$56b000d2f0c12703(organizationId, request);
            if (response.resultType === 'Ok') await get().getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const updateOrgDeviceType = async (organizationId, orgDeviceTypeId, request)=>{
        if (!organizationId || !orgDeviceTypeId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$283d103ee023ff02(organizationId, orgDeviceTypeId, request);
            if (response.resultType === 'Ok') await get().getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const updateOrgDeviceTypeThrottleRules = async (organizationId, orgDeviceTypeId, request)=>{
        if (!organizationId || !orgDeviceTypeId || !request) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$b7d20456d96f632(organizationId, orgDeviceTypeId, request);
            if (response.resultType === 'Ok') // Throttle rules live on the cached device type, so refresh it or the
            // page reads pre-save values until a full reload.
            await get().getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const deleteOrgDeviceType = async (organizationId, orgDeviceTypeId)=>{
        if (!organizationId || !orgDeviceTypeId) return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$564a73641b2b83a(organizationId, orgDeviceTypeId);
            if (response.resultType === 'Ok') await get().getOrgDeviceTypes(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getScopes = async ()=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$a751a00626fa5d99();
            if (response.resultType === 'Ok' && response.data) return response.data;
            return [];
        } catch (error) {
            addError(error.message);
            return [];
        } finally{
            setLoading(false);
        }
    };
    const updateMembershipsByOrganization = async (organization)=>{
        const localMemberships = [
            ...get().memberships
        ];
        const index = localMemberships.findIndex((m)=>m.organizationId === organization.id);
        if (index > 0) {
            localMemberships[index].organization = organization;
            updateMemberships(localMemberships);
        } else await loadOrganizations();
    };
    const activateNewOrgLicenseKey = async (request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$4f1930389137b6da(request);
            if (response.resultType === 'Ok' && response.data) await get().updateMembershipsByOrganization(response.data);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const activateExistingOrgLicenseKey = async (organizationId, request)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$68ccee5da54c27c3(organizationId, request);
            if (response.resultType === 'Ok' && response.data) await get().updateMembershipsByOrganization(response.data);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const validateLicenseKey = async (licenseKey)=>{
        try {
            return await $1a4c36336f303477$export$18169adbba1e88bc(licenseKey);
        } catch (error) {
            addError(error.message);
            return null;
        }
    };
    const validateLicenseKeyForOrganization = async (organizationId, licenseKey)=>{
        try {
            const response = await $1a4c36336f303477$export$4e97a7883c500e67(organizationId, licenseKey);
            return response;
        } catch (error) {
            addError(error.message);
            return null;
        }
    };
    const getTrialUpgradeLink = async (organizationId, trialId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$8c7a465b3f0d49dd(organizationId, trialId);
            return response.resultType == 'Ok' && response.data ? response.data.url : null;
        } catch (error) {
            addError(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    const getTrialUpgradeLinkForProduct = async (organizationId, trialId, productId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$912fe73bbf623b0f(organizationId, trialId, productId);
            return response.resultType == 'Ok' && response.data ? response.data.url : null;
        } catch (error) {
            addError(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    const getBillingLink = async (organizationId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$dabcd4edef40b727(organizationId);
            return response.resultType == 'Ok' && response.data ? response.data.url : null;
        } catch (error) {
            addError(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    const getBillingLinkForOrgByProduct = async (organizationId, productId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$7c5bc9294ee86597(organizationId, productId);
            return response.resultType == 'Ok' && response.data ? response.data.url : null;
        } catch (error) {
            addError(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    const getBillingLinkForManagedOrg = async (organizationId, managedOrgId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$e8e91c27f56f2528(organizationId, managedOrgId);
            return response.resultType == 'Ok' && response.data ? response.data.url : null;
        } catch (error) {
            addError(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    const loadAvailableProducts = async ()=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$2e4ad76cf0d49052();
            return response.resultType === 'Ok' && response.data ? response.data : [];
        } catch (error) {
            addError(error.message);
            return [];
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationMembership = (organizationId)=>{
        if (!organizationId) return undefined;
        return get().memberships.find((member)=>member.organizationId === organizationId);
    };
    const searchOrgManageLicenseKeys = async (organizationId, searchParams, filter)=>{
        try {
            if (filter === 'available') return get().getOrgManagedLicenseKeysAvailable(organizationId, searchParams);
            else if (filter === 'used') return get().getOrgManagedLicenseKeysUsed(organizationId, searchParams);
            else return get().getOrgManagedLicenseKeys(organizationId, searchParams);
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const getOrgManagedLicenseKeys = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$3459b02a7394388f(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) set({
                orgManagedLicenseKeys: response.data
            });
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgManagedLicenseKeysAvailable = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$c9479eea2fe9bdb4(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) set({
                orgManagedLicenseKeys: response.data
            });
            else set({
                orgManagedLicenseKeys: []
            });
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgManagedLicenseKeysUsed = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$9b109560db3e5fa8(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) set({
                orgManagedLicenseKeys: response.data
            });
            else set({
                orgManagedLicenseKeys: []
            });
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgManagedOrgsAll = async (organizationId, searchParams)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$c2666d621521d258(organizationId, searchParams);
            if (response.resultType === 'Ok' && response.data) set({
                orgManagedOrgs: response.data
            });
            else set({
                orgManagedOrgs: []
            });
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const createManagedOrg = async (organizationId, newOrganization)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$cbe92e1dd502f37(organizationId, newOrganization);
            if (response.resultType === 'Ok' && response.data) await get().getOrgManagedOrgsAll(organizationId);
            return response;
        } catch (error) {
            addError(error.message);
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationProducts = async (organizationId, locale, searchParams)=>{
        if (!organizationId) {
            set({
                orgProducts: []
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$e57608268c048777(organizationId, locale, searchParams);
            if (response.resultType === 'Ok' && response.data) set({
                orgProducts: response.data
            });
            else set({
                orgProducts: []
            });
            return response;
        } catch (error) {
            addError(error.message);
            set({
                orgProducts: []
            });
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            setLoading(false);
        }
    };
    const getOrgAvailableCustomControls = async (organizationId, locale)=>{
        if (!organizationId) {
            set({
                orgAvailableCustomControls: []
            });
            return false;
        }
        let newAvailableCustomControls = [];
        try {
            setLoading(true);
            const response = await get().getOrgDeviceTypes(organizationId);
            if (response.resultType === 'Ok' && response.data) {
                for (const deviceType of response.data){
                    const controlsResponse = await $1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceType.id, locale);
                    if (controlsResponse.resultType === 'Ok' && controlsResponse.data) {
                        if (controlsResponse.data.controls && controlsResponse.data.controls.length > 0) newAvailableCustomControls.push({
                            deviceId: deviceType.id,
                            deviceTypeId: deviceType.id,
                            name: deviceType.name,
                            controls: controlsResponse.data.controls.filter((control)=>control.isProfileControl)
                        });
                    }
                }
                set({
                    orgAvailableCustomControls: newAvailableCustomControls
                });
            } else set({
                orgAvailableCustomControls: []
            });
            return true;
        } catch (error) {
            addError(error.message);
            set({
                orgAvailableCustomControls: []
            });
            return false;
        } finally{
            setLoading(false);
        }
    };
    const getOrganizationProductLink = async (organizationId, productId)=>{
        try {
            setLoading(true);
            const response = await $1a4c36336f303477$export$8c8a9832b60f1887(organizationId, productId);
            return response.resultType == 'Ok' && response.data ? response.data.url : null;
        } catch (error) {
            addError(error.message);
            return null;
        } finally{
            setLoading(false);
        }
    };
    return {
        // State
        currentOrg: null,
        currentOrgId: null,
        currentUserEmail: null,
        errors: [],
        invites: [],
        loading: true,
        loadingData: {
            organizationMembers: false,
            organizations: false,
            projects: false,
            licenseKeys: false,
            invites: false,
            scopes: false,
            memberships: false,
            currentOrg: false,
            managedOrgs: false,
            managedKeys: false,
            products: false
        },
        memberships: [],
        organizationMembers: [],
        orgAuthClients: [],
        orgAvailableCustomControls: [],
        orgDeviceTypes: [],
        orgManagedLicenseKeys: [],
        orgManagedOrgs: [],
        orgProducts: [],
        scopes: [],
        initializeFromStorage: // Actions
        initializeFromStorage,
        acceptOrganizationInvite: acceptOrganizationInvite,
        activateExistingOrgLicenseKey: activateExistingOrgLicenseKey,
        activateNewOrgLicenseKey: activateNewOrgLicenseKey,
        createManagedOrg: createManagedOrg,
        createOrganizationInvite: createOrganizationInvite,
        createOrgAuthClient: createOrgAuthClient,
        createOrgDeviceType: createOrgDeviceType,
        deleteOrganizationInvite: deleteOrganizationInvite,
        deleteOrgAuthClient: deleteOrgAuthClient,
        deleteOrgDeviceType: deleteOrgDeviceType,
        getBillingLink: getBillingLink,
        getBillingLinkForManagedOrg: getBillingLinkForManagedOrg,
        getBillingLinkForOrgByProduct: getBillingLinkForOrgByProduct,
        getOrganizationDetails: getOrganizationDetails,
        getOrganizationMembership: getOrganizationMembership,
        getOrganizationProductLink: getOrganizationProductLink,
        getOrganizationProducts: getOrganizationProducts,
        getOrgAuthClients: getOrgAuthClients,
        getOrgAvailableCustomControls: getOrgAvailableCustomControls,
        getOrgDeviceTypes: getOrgDeviceTypes,
        getOrgManagedLicenseKeys: getOrgManagedLicenseKeys,
        getOrgManagedLicenseKeysAvailable: getOrgManagedLicenseKeysAvailable,
        getOrgManagedLicenseKeysUsed: getOrgManagedLicenseKeysUsed,
        getOrgManagedOrgsAll: getOrgManagedOrgsAll,
        getScopes: getScopes,
        getTrialUpgradeLink: getTrialUpgradeLink,
        getTrialUpgradeLinkForProduct: getTrialUpgradeLinkForProduct,
        handleLoadingDataChange: handleLoadingDataChange,
        initializeFromRemote: initializeFromRemote,
        loadAvailableProducts: loadAvailableProducts,
        loadCurrentOrganizationDetails: loadCurrentOrganizationDetails,
        loadInvites: loadInvites,
        loadOrganizationMembers: loadOrganizationMembers,
        loadOrganizations: loadOrganizations,
        removeMember: removeMember,
        rotateClientSecret: rotateClientSecret,
        searchOrgManageLicenseKeys: searchOrgManageLicenseKeys,
        setCurrentUserEmail: setCurrentUserEmail,
        setErrors: setErrors,
        setLoading: setLoading,
        setOrgAuthClients: setOrgAuthClients,
        setOrgDeviceTypes: setOrgDeviceTypes,
        setScopes: setScopes,
        updateMemberRole: updateMemberRole,
        updateMembershipsByOrganization: updateMembershipsByOrganization,
        updateOrganization: updateOrganization,
        updateOrgAuthClient: updateOrgAuthClient,
        updateOrgDeviceType: updateOrgDeviceType,
        updateOrgDeviceTypeThrottleRules: updateOrgDeviceTypeThrottleRules,
        validateLicenseKey: validateLicenseKey,
        validateLicenseKeyForOrganization: validateLicenseKeyForOrganization
    };
}));
// ---- Module-level subscription replacing useEffect ----
(0, $e7df95de73caec26$export$ec068583843480e7)('userUpdated', (data)=>{
    $55ce97f088539572$export$87aeeca3aeff7121.getState().setCurrentUserEmail(data.user.email);
});



var $7fPBF = parcelRequire("7fPBF");
function $f17ba869eb5b6a67$export$bdf7755e6d5d402a() {
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const isAuthenticated = (0, $455682785eac4c5b$export$650ce9f0b4df82fd)((state)=>state.isAuthenticated);
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const organizationLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loading);
    (0, $7fPBF.useEffect)(()=>{
        const initialize = async ()=>{
            try {
                const userResult = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().loadCurrentUser();
                if ((userResult === null || userResult === void 0 ? void 0 : userResult.resultType) === 'Ok') await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().checkAndUpdatePendingTos();
                await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().loadUserLicenseAccess();
                await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().initializeFromRemote();
            } catch (error) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError('Error initializing data');
            } finally{
                setIsLoading(false);
            }
        };
        if (currentUser === null && isAuthenticated === true) initialize();
    }, [
        currentUser,
        isAuthenticated
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isAuthenticated && currentUser && !organizationLoading) setIsLoading(false);
    }, [
        isAuthenticated,
        currentUser,
        organizationLoading
    ]);
    return {
        isLoading: isLoading
    };
}


const $b969eaec2195befc$export$aca1c9091a4fb992 = '/upgrade';
const $b969eaec2195befc$export$662bfc32d000edb3 = '/org';
const $b969eaec2195befc$export$e84fa2c5f7fcc9c7 = (membership)=>Boolean(membership.isAdmin || membership.canManageBilling);
const $b969eaec2195befc$var$isManagedOrg = (membership)=>Boolean(membership.organization.originatedByOrganizationId);
const $b969eaec2195befc$export$c169ff81af47339c = (intent)=>{
    const params = new URLSearchParams();
    if (intent === null || intent === void 0 ? void 0 : intent.organizationId) params.set('organizationId', intent.organizationId);
    if (intent === null || intent === void 0 ? void 0 : intent.managedOrgId) params.set('managedOrgId', intent.managedOrgId);
    if (intent === null || intent === void 0 ? void 0 : intent.productId) params.set('productId', intent.productId);
    const query = params.toString();
    return query.length > 0 ? `${$b969eaec2195befc$export$aca1c9091a4fb992}?${query}` : $b969eaec2195befc$export$aca1c9091a4fb992;
};
const $b969eaec2195befc$export$296e765752e56d8 = (searchParams)=>{
    var _searchParams_get, _searchParams_get1, _searchParams_get2;
    return {
        organizationId: (_searchParams_get = searchParams.get('organizationId')) !== null && _searchParams_get !== void 0 ? _searchParams_get : undefined,
        managedOrgId: (_searchParams_get1 = searchParams.get('managedOrgId')) !== null && _searchParams_get1 !== void 0 ? _searchParams_get1 : undefined,
        productId: (_searchParams_get2 = searchParams.get('productId')) !== null && _searchParams_get2 !== void 0 ? _searchParams_get2 : undefined
    };
};
const $b969eaec2195befc$export$c81f6db1580be55a = ({ organizationId: organizationId, managedOrgId: managedOrgId, productId: productId })=>{
    if (managedOrgId) return `/org/${organizationId}/managed/${managedOrgId}/billing/redirect/upgrade`;
    const route = `/org/${organizationId}/billing/redirect/upgrade`;
    return productId ? `${route}/product/${productId}` : route;
};
const $b969eaec2195befc$export$7f01a2876ca50dcf = ({ memberships: memberships, intent: intent = {} })=>{
    const { organizationId: organizationId, managedOrgId: managedOrgId, productId: productId } = intent;
    const requestedMembership = organizationId ? memberships.find((membership)=>membership.organizationId === organizationId) : undefined;
    // With a single membership there is nothing to disambiguate, so use it even without an intent.
    const membership = requestedMembership !== null && requestedMembership !== void 0 ? requestedMembership : memberships.length === 1 ? memberships[0] : undefined;
    if (!membership) // More than one org and no usable hint: make the user pick one first.
    return memberships.length > 1 ? $b969eaec2195befc$export$662bfc32d000edb3 : null;
    // `managedOrgId` means this org is acting as the billing parent, so it keeps its own route.
    if (!managedOrgId && $b969eaec2195befc$var$isManagedOrg(membership)) return $b969eaec2195befc$export$662bfc32d000edb3;
    return $b969eaec2195befc$export$c81f6db1580be55a({
        organizationId: membership.organizationId,
        managedOrgId: managedOrgId,
        productId: productId
    });
};


function $d0493a8b121d95e9$export$3aa18b5a5694efe6(organization) {
    if (organization.isDeveloperAccess) return 'sdk';
    if (organization.isEmployeeAccess) return 'orgCompany';
    if (organization.isStudentAccess) return 'library';
    if (organization.isReseller) return 'globe';
    if (organization.isPlusAccess) return 'plusLight';
    return 'orgCompany';
}





var $7fPBF = parcelRequire("7fPBF");

function $d248d2e07e495df9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const isLicenseExpired = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.isLicenseExpired);
    const [topItems, setTopItems] = (0, $7fPBF.useState)([]);
    const [bottomItems, setBottomItems] = (0, $7fPBF.useState)([]);
    const getSubmenuItems = (0, $7fPBF.useCallback)((membership)=>{
        let subMenu = [];
        var _membership_organization_maxMembers;
        const isOrgMultipleMembers = ((_membership_organization_maxMembers = membership.organization.maxMembers) !== null && _membership_organization_maxMembers !== void 0 ? _membership_organization_maxMembers : 0) > 1;
        const originatedByOrganizationId = membership.organization.originatedByOrganizationId;
        const isManagedOrganization = originatedByOrganizationId != undefined && originatedByOrganizationId != null && originatedByOrganizationId.length > 0;
        // User is one of many members of an organization
        if (isOrgMultipleMembers || isManagedOrganization) subMenu = [
            ...membership.canViewMembers || membership.isAdmin ? [
                {
                    label: t('common:organization.member.titlePlural'),
                    href: `org/${membership.organization.id}/members`,
                    activeStateMatchCriteria: 'end'
                }
            ] : [],
            ...membership.canInviteMembers || membership.isAdmin ? [
                {
                    label: t('common:organization.invite.titlePlural'),
                    href: `org/${membership.organization.id}/members/invites`,
                    activeStateMatchCriteria: 'end'
                }
            ] : [],
            // {
            //     label: t('common:organization.metrics.title'),
            //     href: `org/${membership.organization.id}/metrics`,
            // },
            ...membership.canAccessOrganizationProfiles || membership.canEditOrganizationProfiles || membership.isAdmin ? [
                {
                    label: t('common:organization.profiles.titleShort'),
                    href: `org/${membership.organization.id}/profiles`
                }
            ] : [],
            ...membership.organization.isReseller && (membership.canManageChildOrganizations || membership.isAdmin) ? [
                {
                    label: t('common:organization.managed.title'),
                    href: `org/${membership.organization.id}/managed`
                },
                {
                    label: t('common:license.key.title'),
                    href: `org/${membership.organization.id}/licensekey`
                },
                {
                    label: t('common:license.key.product.title'),
                    href: `org/${membership.organization.id}/purchase`
                }
            ] : [],
            ...membership.canCreateAuthClients || membership.canViewAuthClients || membership.isAdmin ? [
                {
                    label: t('common:organization.projects.title'),
                    href: `org/${membership.organization.id}/projects`
                }
            ] : [],
            ...membership.organization.isEmployeeAccess && (membership.canManageGlobalAutomationRules || membership.isAdmin) ? [
                {
                    label: t('common:organization.governance.title'),
                    href: `org/${membership.organization.id}/governance`
                }
            ] : [],
            {
                label: t('common:settings.title'),
                href: `org/${membership.organization.id}/settings`
            }
        ];
        else // User is the only member of a single organization -> show direct billing
        subMenu = [
            {
                label: isLicenseExpired ? t('common:upgrade') : t('common:license.key.product.Subscription.title'),
                href: (0, $b969eaec2195befc$export$c169ff81af47339c)({
                    organizationId: membership.organizationId
                })
            }
        ];
        return subMenu;
    }, [
        isLicenseExpired,
        t
    ]);
    // Helper to generate organization menu items
    const generateOrgItems = (0, $7fPBF.useCallback)(()=>{
        if (memberships.length === 0 || !(0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().isEmailVerified) return [];
        return memberships.map((membership)=>({
                icon: (0, $d0493a8b121d95e9$export$3aa18b5a5694efe6)(membership.organization),
                label: membership.organization.name,
                href: `org/${membership.organization.id}`,
                submenu: getSubmenuItems(membership)
            }));
    }, [
        memberships,
        getSubmenuItems
    ]);
    // Generate default top menu items
    const generateDefaultItems = (0, $7fPBF.useCallback)(()=>[
            {
                icon: 'squaredMenu',
                label: t('common:dashboard.title'),
                href: '/'
            }
        ], [
        t
    ]);
    // Generate bottom menu items
    const generateBottomItems = (0, $7fPBF.useCallback)(()=>[
            {
                icon: 'code',
                label: t('common:developer.title'),
                href: '/developer'
            },
            {
                icon: 'help',
                label: t('common:support.title'),
                href: 'https://cephable.com/free-trial/support/'
            }
        ], [
        t
    ]);
    // Consolidated effect to set menu items
    (0, $7fPBF.useEffect)(()=>{
        setTopItems([
            ...generateDefaultItems(),
            ...generateOrgItems()
        ]);
        setBottomItems(generateBottomItems());
    }, [
        generateDefaultItems,
        generateOrgItems,
        generateBottomItems
    ]);
    return {
        topItems: topItems,
        bottomItems: bottomItems
    };
}



function $97c83f16300f0c22$export$2e2bcd8739ae039() {
    const { isLoading: isLoading } = (0, $f17ba869eb5b6a67$export$bdf7755e6d5d402a)();
    const { topItems: topItems, bottomItems: bottomItems } = (0, $d248d2e07e495df9$export$2e2bcd8739ae039)();
    const { managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { setPendingTosConfig: setPendingTosConfig } = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState();
    const pendingTosConfig = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.pendingTosConfig);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $064a5b98a9970d8a$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        headerContent: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4b0152a6024286a$export$2e2bcd8739ae039), {}),
        topItems: topItems,
        bottomItems: bottomItems,
        managed: !!managedOrgId,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fcaddb9c30332041$export$6ce170286acaa8d3), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74e05fac257f9d21$export$910ae8079b2c2852), {}),
                pendingTosConfig && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6b91e65655da099$export$2e2bcd8739ae039), {
                    open: true,
                    tosConfig: pendingTosConfig,
                    onAccepted: ()=>setPendingTosConfig(null)
                })
            ]
        })
    });
}


function $18eb3fb4329f0ffa$export$2e2bcd8739ae039({ authRedirect: authRedirect = '../login', children: children }) {
    const isAuthenticated = (0, $455682785eac4c5b$export$650ce9f0b4df82fd)((state)=>state.isAuthenticated);
    const isInitialized = (0, $455682785eac4c5b$export$650ce9f0b4df82fd)((state)=>state.isInitialized);
    const { getNewToken: getNewToken } = (0, $455682785eac4c5b$export$650ce9f0b4df82fd).getState();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [searchParams] = (0, $f232cebbf1b70e96$export$f1a78c17382fe22a)();
    const tokenRefresh = localStorage.getItem((0, $db3063bd3b6d501e$export$f849a8e4906d2051));
    const { initializeFromRemote: initializeNotifications } = (0, $3521ff40d609c2ed$export$aa94277a9804d2bd).getState();
    (0, $7fPBF.useEffect)(()=>{
        const handleNewToken = async ()=>{
            const result = await getNewToken();
            if (result.resultType !== 'Ok') navigate(authRedirect, {
                replace: true
            });
        };
        if (!isAuthenticated && tokenRefresh && !isInitialized) handleNewToken();
        else if (searchParams.get('code')) navigate(`../authcallback?code=${searchParams.get('code')}`, {
            replace: true,
            viewTransition: true
        });
        else if (!isAuthenticated) navigate(authRedirect, {
            replace: true,
            viewTransition: true
        });
        const unsubNavigateTo = (0, $e7df95de73caec26$export$ec068583843480e7)('navigateTo', (data)=>{
            if (data.path) {
                const url = data.params ? (0, $13d0c8a27a7be22f$export$990cf17cc7759dd4)(data.path, data.params) : data.path;
                navigate(url, {
                    replace: false,
                    viewTransition: true
                });
            }
        });
        return ()=>{
            unsubNavigateTo();
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (!isInitialized) return;
        initializeNotifications();
        const intervalId = setInterval(()=>{
            initializeNotifications();
        }, 1800000); // 30 minutes in milliseconds
        return ()=>clearInterval(intervalId);
    }, [
        isInitialized
    ]);
    if (!isInitialized || !isAuthenticated) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fdf6d68b1a7a3435$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97c83f16300f0c22$export$2e2bcd8739ae039), {})
        ]
    });
}



var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");
const $a22a182679eb182e$var$SvgFullLogo = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 1000 300"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient",
                        x1: 215.09,
                        x2: 374.06,
                        y1: 61.06,
                        y2: -0.41,
                        gradientTransform: "rotate(-8.86 992.89 1045.428)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#36368b"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#563986"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.17,
                                stopColor: "#7e3d7f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.27,
                                stopColor: "#a1407a"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.38,
                                stopColor: "#bd4376"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#d24573"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.63,
                                stopColor: "#e24670"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.78,
                                stopColor: "#eb476f"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ee486f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("linearGradient", {
                        id: "full_logo_svg__linear-gradient-2",
                        x1: -236.73,
                        x2: -283.6,
                        y1: 787.35,
                        y2: 666.15,
                        gradientTransform: "rotate(81.14 295.919 673.252)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6db9e7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.07,
                                stopColor: "#6ca2d7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.16,
                                stopColor: "#6b8ac6"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.26,
                                stopColor: "#6b79ba"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.37,
                                stopColor: "#6b6fb3"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#6b6cb1"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#062844"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("filter", {
                        id: "full_logo_svg__luminosity-invert",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("feColorMatrix", {
                            result: "cm",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("style", {
                        children: '.full_logo_svg__cls-7,.full_logo_svg__cls-8{stroke-width:0}.full_logo_svg__cls-10{mix-blend-mode:multiply;opacity:.2}.full_logo_svg__cls-7{fill:#fff}.full_logo_svg__cls-8{fill:#ee486f}'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("mask", {
                        id: "full_logo_svg__mask",
                        width: 174,
                        height: 176,
                        x: 59,
                        y: 62,
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("image", {
                            xlinkHref: "data:image/png;base64,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",
                            width: 174,
                            height: 176,
                            style: {
                                filter: 'url(#full_logo_svg__luminosity-invert)'
                            },
                            transform: "translate(59 62)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    id: "full_logo_svg__Layer_1",
                    "data-name": "Layer 1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                            cx: 148,
                            cy: 150,
                            r: 90,
                            style: {
                                fill: '#fff',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                            style: {
                                strokeWidth: 0,
                                fill: 'url(#full_logo_svg__linear-gradient)'
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                            style: {
                                mask: 'url(#full_logo_svg__mask)'
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                d: "M223.24 162.47c-2.78-9.23-10.46-11.21-15.36-10.33-1.66.3-3.14.97-4.27 1.62-.52.3-.24 1.1.36 1.02 3.54-.48 9.78-.38 12.85 5.46 1.08 2.04 5.36 10.97-8.32 18.44-7.29 3.99-15.57 2.86-19.24-2.21-2.12 1.28-4.26 2.58-6.49 3.91-5.74-8.12-13.64-5.05-17.35-2.48-.51.35-.13 1.14.46.98 3.66-.98 9.87-1.63 12.96 3.91 2.68 4.8-.64 11.5-7.02 14.77-6.38 3.27-13.98 3.66-16.23-3.36-2.6.95-5.23 1.81-7.89 2.5-2.15-8.24-8.92-8.99-12.78-7.98-.59.16-.52 1.03.09 1.08 2.79.25 6.73 1.29 8.34 5.07 1.29 3.04 1.07 10-9.87 11.38-6.2.78-12.52-1.91-12.36-7.87-2.82-.43-5.63-1.07-8.41-1.96 3-7.24-2.03-11.87-5.61-13.42-.57-.25-1.07.49-.6.9 1.8 1.62 3.86 4.21 3.77 7.5-.52 6.75-7.54 8.74-13.77 5.34-5.15-2.81-8.76-8.26-5.19-13.57-5.57-5.47-10.22-13.44-12.98-21.64-5.4-16.04 0-32.3 11.74-41.82 14.73-11.94 28.99-8.01 35.67-5.41 1.2.47.99 1.62-.37 1.34-.92-.19-2.05-.26-3.05-.32-2.37-.15-4.87 0-6.92.52-6.91 1.76-12.56 9.82-12.99 20.53.13 9.8 4.98 21.2 14.64 24.62 12.97 4.79 24.03-3.88 34.33-11.6 9.2-7.07 18.83-16.21 31.67-24.54 18.78-12.18 37.81-16.57 37.81-16.57-12.06-21.36-32.99-36.74-57.01-41.72a85.104 85.104 0 0 0-30.42-.75c-5.59.87-10.96 2.28-16.09 4.14 0 0-10.89 3.84-19.78 10.31-1 .73-2.2 1.7-3.43 2.76-1.98 1.69-.56 4.91 2.02 4.58 5.25-.68 12.3-.62 20.5 1.83 15.48 4.64 23.5 15.73 27.35 23.11 2.09 4.01-1.81 5.76-4.05 3.51-7.09-7.11-28.64-20.25-53.96-6.91-16.73 8.81-23.05 24.33-24.13 37.26-1.64 19.6 5.61 36.91 10.54 45.61 12.05 21.26 32.79 36.41 56.71 41.41a85.01 85.01 0 0 0 30.57.78c19.2-2.99 35.89-12.19 48.37-25.22a85.59 85.59 0 0 0 13.4-18.34c4.62-8.51 7.83-17.83 9.34-27.62a.976.976 0 0 0-.88-1.11c-3.77-.31-6.67.56-6.67.56Z",
                                className: "full_logo_svg__cls-10",
                                style: {
                                    fill: '#141728',
                                    strokeWidth: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M160.51 192.18c.59 1.15 2 1.56 2.79 1.71 1.86.34 4.09-.06 6.1-1.09 3.48-1.78 5.25-4.87 4.94-6.83-.04-.27-.12-.51-.24-.75-.59-1.15-2-1.56-2.79-1.71-1.86-.34-4.09.06-6.1 1.09-3.48 1.78-5.24 4.87-4.94 6.84.04.27.12.51.24.74ZM126.19 198.8v.04c.24 1.5 2.97 3.37 6.72 2.88 1.9-.25 3.63-1.07 4.74-2.25.34-.37 1.12-1.32.98-2.33-.23-1.5-2.96-3.37-6.72-2.88-1.9.25-3.63 1.07-4.74 2.25-.34.36-1.12 1.32-.99 2.29ZM95.17 186.12c-.06.09-.22.35-.19.93.07 1.36 1.18 3.38 3.48 4.84 1.54.98 3.28 1.47 4.76 1.33.43-.04 1.46-.19 1.86-.82.05-.09.22-.35.19-.92-.07-1.36-1.18-3.38-3.48-4.84-1.54-.98-3.28-1.47-4.76-1.33-.43.04-1.46.19-1.86.81ZM192.78 171.53c.08.49.23.96.46 1.38 1.76 3.27 7.71 3.76 12.74 1.06 4.93-2.65 7.05-6.95 6.6-9.82-.08-.49-.23-.96-.46-1.39-1.76-3.27-7.71-3.76-12.74-1.06-4.93 2.65-7.05 6.95-6.6 9.82Z",
                            className: "full_logo_svg__cls-8"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M183.06 124.84c-12.84 8.33-22.47 17.46-31.67 24.54-10.3 7.72-21.36 16.38-34.33 11.6-9.66-3.41-14.51-14.82-14.64-24.62.43-10.71 5.48-19 22.96-20.73-7.48-1.49-15.3-.32-20.79 3.35-17.41 11.65-14.56 28.85-9.41 39.08 4.93 9.78 17.15 19.03 32 18.99 10.15-.03 22.55-4.05 41.55-18.47 23.26-17.66 42.16-24.24 59.52-24.57.26 0 .52-.05.78-.03.69.04 1.2-.24.92-1.33-.04-.15-.07-.31-.1-.47a84.457 84.457 0 0 0-9-23.91c-1 .22-19.03 4.39-37.81 16.57Z",
                            style: {
                                fill: 'url(#full_logo_svg__linear-gradient-2)',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M150.02 140.58c-10.3 7.72-20.51 17.91-33.47 13.12-6.84-2.41-12.07-10.37-14.12-17.39v.05c0 .61.03 1.23.08 1.85.04.62.11 1.25.19 1.88 1.15 8.79 5.92 17.9 14.37 20.89 2.43.9 4.79 1.32 7.1 1.37 9.99.2 18.86-6.69 27.23-12.97 2.71-2.09 5.48-4.37 8.34-6.74 6.84-5.67 14.28-11.93 23.33-17.8 18.41-11.94 36.16-16.19 37.79-16.56v-.05a83.974 83.974 0 0 0-5.02-7.83c-7.2 2.36-22.48 8.08-34.14 15.64-12.84 8.33-22.47 17.46-31.67 24.54Z",
                            style: {
                                fill: '#141526',
                                mixBlendMode: 'multiply',
                                opacity: 0.2,
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M79.41 122.96c-5.87 6.69-13.97 26.77-5.83 46.45 2.09 5.05 4.94 10.71 9.44 15.27-.28 1.66-.3 3.31-.05 4.91 1.35 8.69 9.98 13.22 10.42 13.44 8.51 4.06 14.7 1.5 17.27-.03l4.8 1.45c3.5 10.19 17.66 9.19 18.28 9.14 10.41-.78 14.66-6.24 16.1-8.79l3.36-1.11c9.22 8.53 23.01.51 23.61.15 9.57-5.65 10.88-13.82 10.94-17.47l.81-.47c11.76 7.29 25.28-1.23 25.72-1.52 7.94-4.38 10.73-11.17 11.62-14.29 1.09-.27 2.41-.26 3.52-.17.55-2.28 1.02-4.58 1.38-6.91.09-.55-.33-1.06-.88-1.11-.6-.05-1.18-.06-1.73-.06h-.24c-.22 0-.41.02-.61.03l-.7.03c-.08 0-.15.02-.23.03a21.176 21.176 0 0 0-2.23.32c-.12.03-.26.05-.36.07-.36.08-.57.15-.58.15-.31-1.04-.71-1.96-1.13-2.83-.13-.26-.27-.49-.4-.74-.34-.6-.7-1.16-1.08-1.67-.15-.2-.3-.41-.46-.6-1.14-1.35-2.44-2.39-3.8-3.12a13.41 13.41 0 0 0-6.52-1.56c-.68.01-1.34.08-1.95.19-.68.12-1.3.34-1.91.56-.36.14-.73.28-1.07.44-.45.21-.91.41-1.29.63l-.01.01a.49.49 0 0 0-.23.41v.11c.02.16.09.31.22.4.06.04.15.04.23.05.05 0 .09.04.15.03.43-.06.91-.1 1.4-.13s.05 0 .07 0h.01c.27-.02.56-.01.84-.01h.04c.25 0 .49-.02.76 0h.07c.45.02.91.06 1.38.12.23.03.47.08.7.12.28.05.57.11.85.18.33.08.65.18.97.29.24.08.47.18.7.28s.46.18.69.3c.53.27 1.05.57 1.54.94 1.07.82 2.04 1.92 2.81 3.38.02.03.04.09.06.13.23.44.56 1.14.85 2.03.05.14.09.28.14.43.09.31.17.64.23.98 0 .04.02.07.03.11.06.35.11.71.15 1.09.02.23.02.47.02.71v.02c.01.75-.06 1.54-.24 2.37-.02.11-.04.21-.07.32-.04.18-.09.36-.15.55-.18.6-.45 1.22-.77 1.85 0 0 0 .02-.01.03-.22.42-.47.84-.75 1.26-.08.11-.15.23-.23.34-.28.4-.61.79-.96 1.19-.03.03-.05.06-.08.09-.55.61-1.17 1.23-1.9 1.84l-.06.06c-.73.61-1.56 1.22-2.49 1.82-.5.32-1.05.65-1.61.97 0 0-.01 0-.02.01-.15.08-.27.17-.42.25-.04.02-.07.03-.11.05-.31.17-.64.28-.96.43-.47.22-.93.45-1.4.63-.53.21-1.07.35-1.6.51h-.01c-.29.08-.58.18-.87.25-.41.1-.81.18-1.22.25-.38.06-.75.1-1.12.14-.48.05-.95.1-1.42.11s-.09 0-.13 0c-1.02.01-2.01-.08-2.96-.26s-.07-.02-.11-.02c-.8-.15-1.57-.37-2.3-.65-.73-.28-1.42-.62-2.06-1.02-.06-.04-.12-.08-.17-.12-.5-.32-.98-.66-1.4-1.06-.11-.1-.2-.21-.3-.32-.25-.25-.5-.51-.73-.79-.11-.11-.22-.21-.31-.34-2.12 1.28-4.26 2.58-6.49 3.91s-.06-.08-.09-.12c-.03-.04-.06-.07-.09-.11-.35-.47-.7-.91-1.06-1.3-.17-.19-.34-.35-.51-.52-.27-.26-.53-.51-.8-.74a9.335 9.335 0 0 0-1.38-.98c-.09-.05-.18-.11-.27-.16 0 0-.01 0-.02-.01-.09-.05-.18-.11-.27-.16-.34-.18-.68-.32-1.02-.46-.95-.37-1.91-.58-2.85-.66h-.02c-.72-.05-1.42-.03-2.11.04-.27.03-.54.08-.81.13-.03 0-.06 0-.08.01-.13.02-.27.04-.4.07-.03 0-.07.02-.1.03-.06.01-.11.03-.17.04-.45.11-.9.24-1.32.39-.01 0-.02 0-.03.01a14.268 14.268 0 0 0-1.8.76c-.03.02-.06.03-.1.05l-.06.03c-.7.35-1.33.73-1.88 1.1-.01 0-.02.02-.04.02-.02.01-.04.02-.05.04-.12.08-.19.2-.22.31-.02.07 0 .13.01.19v.1c.03.09.09.17.16.23.06.05.12.09.19.12h.04c.06.01.11.02.17.02.03 0 .06.01.09 0 .39-.1.81-.2 1.25-.29.08-.02.15-.04.23-.05.48-.09.98-.16 1.5-.21.09 0 .17-.02.26-.03h.21c.57-.04 1.15-.06 1.74-.03h.02c.58.03 1.17.09 1.75.21.13.03.25.06.37.1.45.11.9.23 1.34.41.13.05.26.13.39.2.41.19.81.39 1.2.65.19.13.35.3.53.45.33.27.66.53.95.86.43.48.84 1.01 1.19 1.65.28.49.45 1.02.6 1.55.08.27.13.55.18.83.07.42.13.85.13 1.28a7 7 0 0 1-.06.79c-.02.22-.07.58-.11.8-.07.38-.15.76-.27 1.14-.12.37-.25.74-.41 1.11-.17.39-.36.76-.58 1.14-.07.13-.15.25-.22.37-.72 1.19-1.65 2.31-2.79 3.32-.28.24-.55.49-.85.72-.81.63-1.68 1.22-2.64 1.71-.56.29-1.14.54-1.71.78-.02 0-.05.02-.07.03-1.2.49-2.41.87-3.61 1.12-.04 0-.08.02-.13.02-2.33.46-4.57.39-6.45-.42-.06-.03-.13-.06-.19-.09a6.79 6.79 0 0 1-1.05-.6c-.07-.05-.15-.1-.22-.15-.38-.28-.73-.6-1.05-.96-.04-.05-.08-.11-.13-.16a8.602 8.602 0 0 1-.93-1.4c-.24-.47-.47-.96-.65-1.52-2.6.95-5.23 1.81-7.89 2.5s0-.01 0-.02v-.03c-.48-1.82-1.21-3.23-2.06-4.38-.09-.12-.16-.27-.25-.39-.08-.1-.16-.19-.25-.28l-.03-.03c-.2-.23-.4-.44-.61-.64-.14-.13-.28-.24-.42-.36-.17-.14-.34-.28-.52-.41-.15-.11-.3-.21-.45-.3-.18-.11-.37-.22-.55-.32-.07-.04-.14-.07-.21-.11-.08-.04-.16-.08-.23-.12-.22-.1-.45-.19-.68-.28 0 0-.02 0-.03-.01h-.01c-.1-.04-.19-.08-.29-.11-.35-.12-.7-.21-1.05-.29-.03 0-.05 0-.08-.01h-.03c-.34-.07-.67-.12-1-.16H138.91c-.32-.03-.65-.05-.96-.05h-.08c-.35 0-.69.01-1.03.04h-.06c-.11.01-.22.02-.33.04-.43.05-.85.13-1.23.23-.05.01-.11.02-.16.04-.14.04-.24.12-.31.22-.06.09-.09.21-.09.32a.722.722 0 0 0 .11.3c.02.03.04.07.07.1.01.01.03.02.05.02.03.02.07.04.11.05.03.02.06.04.09.04.02 0 .04.02.06.02.03 0 .08.02.11.02.77.07 1.61.22 2.47.45s.03 0 .05 0c.03 0 .06.03.1.04.39.11.77.24 1.15.4.02 0 .03.01.05.02.38.15.75.33 1.11.54.74.42 1.43.96 2.02 1.64.11.13.22.25.33.39.34.45.65.93.9 1.5.01.02.03.04.04.06 0 .02.02.05.03.08.12.3.23.63.31 1 .07.3.13.61.16.94v.03c.03.31.04.63.03.96 0 .08-.01.16-.02.24-.01.26-.04.52-.09.79-.01.08-.03.17-.05.25-.06.31-.15.62-.25.93l-.03.09c-.26.72-.66 1.44-1.22 2.12-.03.03-.05.06-.08.09-.27.32-.57.62-.92.92-.02.02-.05.04-.07.06-.76.64-1.71 1.22-2.89 1.7-.08.03-.17.06-.26.09-.51.2-1.06.37-1.65.53-.18.05-.35.09-.53.14-.73.17-1.49.32-2.35.43-.95.12-1.89.13-2.82.09-.09 0-.18-.02-.27-.02-.9-.06-1.77-.19-2.6-.4-.09-.02-.19-.04-.29-.07-.57-.15-1.1-.35-1.62-.58l-.21-.09c-.47-.22-.91-.47-1.33-.74-.09-.06-.17-.12-.25-.18-.39-.28-.76-.59-1.08-.93l-.18-.21c-.32-.37-.62-.75-.86-1.18-.07-.13-.12-.27-.18-.41-.22-.47-.4-.97-.5-1.51-.12-.51-.19-1.04-.18-1.62-1.51-.23-3.02-.54-4.52-.89-1.3-.3-2.6-.66-3.88-1.07.36-.86.6-1.68.74-2.47v-.02a9.75 9.75 0 0 0 .01-3.49c-.01-.06-.03-.11-.04-.17-.09-.41-.21-.8-.34-1.17 0-.02-.02-.04-.02-.06-.03-.07-.06-.15-.09-.22-.13-.33-.28-.64-.44-.94-.03-.05-.05-.11-.08-.16 0 0 0-.02-.01-.03-.2-.35-.42-.68-.66-1l-.15-.18c-.01-.02-.03-.03-.04-.05-.18-.23-.37-.45-.56-.66a.138.138 0 0 1-.03-.04c-.08-.09-.16-.17-.24-.25-.19-.19-.39-.37-.58-.54-.04-.03-.07-.07-.11-.1-.04-.04-.09-.08-.13-.12-.26-.21-.52-.41-.78-.59-.05-.04-.11-.07-.16-.11-.08-.05-.16-.11-.24-.16-.14-.09-.29-.18-.43-.26-.01 0-.02-.01-.03-.02-.11-.06-.21-.12-.31-.18a.405.405 0 0 0-.09-.05c-.13-.07-.26-.13-.39-.19-.12-.06-.25-.12-.37-.18a.559.559 0 0 0-.38-.02c-.02 0-.04.02-.06.03-.05.02-.08.06-.12.1-.03.03-.07.04-.09.07-.01.02-.03.03-.04.05-.06.1-.09.21-.08.32 0 .06.06.12.09.18s.03.12.09.17c.13.12.27.26.41.4l.02.02c.2.2.41.41.61.63.02.02.04.04.06.07.47.53.93 1.11 1.33 1.76.03.04.06.09.09.13.18.3.34.6.48.92.03.06.06.11.09.16 0 .02.01.04.02.06.18.43.32.88.43 1.35l.03.16c.12.58.2 1.18.19 1.81v.01c0 .06-.03.1-.03.16a8.47 8.47 0 0 1-.43 2.04c-.17.5-.43.92-.69 1.34v.01c-.08.12-.13.28-.22.39-.2.28-.44.51-.68.75-.18.18-.35.37-.55.53-.25.21-.52.39-.8.56-.24.15-.49.27-.75.39-.28.13-.55.26-.84.35-.23.08-.49.1-.74.16-.51.11-1.03.2-1.57.22-.47.02-.94.02-1.43-.02-.25-.02-.49-.06-.74-.1-.16-.03-.33-.08-.49-.11-1.04-.21-2.08-.56-3.12-1.06-.22-.1-.44-.17-.65-.28-.58-.32-1.13-.67-1.66-1.05-.15-.11-.3-.23-.45-.34-.38-.29-.75-.6-1.09-.93-1.2-1.13-2.16-2.42-2.75-3.81-.18-.44-.39-1.19-.5-1.65l-.02-.07c-.1-.57-.16-1.15-.12-1.74s0 0 0-.01v-.08c.05-.63.17-1.26.39-1.9.23-.66.56-1.32 1-1.98-1.7-1.68-3.31-3.6-4.81-5.68-.3-.41-.6-.82-.88-1.23-.14-.21-.28-.43-.42-.65-.41-.62-.81-1.24-1.19-1.88-.88-1.45-1.69-2.97-2.46-4.51l-.21-.42c-.76-1.56-1.45-3.14-2.08-4.76-.05-.11-.09-.21-.14-.32-.46-1.12-1.03-2.76-1.54-4.77-.09-.34-.17-.67-.25-1-.05-.24-.1-.49-.16-.74-1.28-5.87-1.17-11.68.13-17.09 0-.02 0-.04.01-.05.21-.88.45-1.75.72-2.61.02-.07.05-.14.07-.21.33-1 .69-1.98 1.1-2.95s.01-.03.02-.05c.67-1.58 1.43-3.11 2.3-4.57.01-.02.02-.03.03-.05a35.94 35.94 0 0 1 2.86-4.15c.04-.06.08-.11.12-.17.24-.3.55-.63.82-.95.26-.3.5-.6.77-.89.41-.45.87-.9 1.33-1.36a32.886 32.886 0 0 1 2.3-2.09c.11-.09.21-.19.32-.28.2-.16.4-.29.6-.45.61-.48 1.23-.95 1.9-1.42 1.01-.7 2.02-1.35 3.02-1.92.73-.41 1.49-.8 2.27-1.17.37-.18.74-.34 1.11-.5s0 0 .01-.01c.22-.09.45-.18.67-.28.84-.34 1.66-.64 2.49-.9.14-.04.27-.09.41-.13.81-.24 1.61-.45 2.4-.63h.02c.78-.17 1.54-.31 2.3-.42.03 0 .06 0 .09-.01.74-.1 1.46-.18 2.18-.23h.13c.72-.05 1.42-.08 2.12-.08h.09c.94 0 1.86.04 2.75.11.11 0 .22.01.33.02 1.2.11 2.35.28 3.44.49.07.01.14.03.2.04 1.08.21 2.09.45 3.04.72s.06.02.09.03c.77.22 1.49.44 2.16.68l.1.03c.6.21 1.16.41 1.67.61.02 0 .03.01.05.02-12.23-7.89-34.3-5.07-46.34 8.66Z",
                            className: "full_logo_svg__cls-10",
                            style: {
                                fill: '#141526',
                                strokeWidth: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M265.72 141.77v-3.21c0-30.43 19.95-51.98 50.08-51.98 26.06 0 43.39 16.45 45.13 40.91h-21.84c-1.6-14.27-10.19-22.86-23.59-22.86-17.47 0-27.37 13.68-27.37 33.92v3.21c0 20.24 10.04 33.77 27.37 33.77 13.98 0 22.71-9.46 23.44-23.88h21.84c-1.6 24.61-18.34 42.08-45.13 42.08-30.58 0-49.94-21.4-49.94-51.98ZM372.73 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.17 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.54 25.77-24.17 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.87-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.47 15.29h33.78ZM630.34 170.89c0-12.81 8.15-20.38 21.83-22.28l27.66-3.93v-4.37c0-6.25-4.07-10.04-12.96-10.04-8.3 0-13.53 3.21-14.27 9.61h-19.21c1.16-16.01 14.41-25.04 33.92-25.04s32.17 10.04 32.17 25.77v51.25H680.7l-.73-11.5c-4.52 8.15-13.25 13.39-24.31 13.39-15.15 0-25.33-9.61-25.33-22.86Zm49.5-6.55v-5.97l-20.38 2.76c-6.26.88-9.46 3.49-9.46 8.73s4.37 8.59 11.79 8.59c9.9 0 18.05-5.83 18.05-14.12ZM833.5 155.16v-1.9c0-22.85 15-38.43 38.73-38.43 25.62 0 38.29 18.05 36.98 44.26h-54.89c1.02 12.81 6.99 19.07 17.91 19.07 9.18 0 14.41-4.37 16.31-10.19h20.24c-3.64 15.87-16.89 25.77-36.55 25.77-24.16 0-38.73-15.43-38.73-38.58Zm54.89-9.46c-.88-9.47-6.12-15.29-16.31-15.29s-15.73 4.94-17.48 15.29h33.78ZM504.98 114.83c-12.23 0-20.67 6.7-24.17 13.39l-.58-11.51h-19.07v99.34s20.49-.84 20.53-20.48v-14.35c4.08 6.99 12.23 12.52 22.86 12.52 20.24 0 32.61-16.31 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.18-38.43Zm11.5 40.33c0 14.7-6.12 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.26-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM593.2 114.83c-11.94 0-19.56 6.11-23.5 12.81v-24.08c0-18.74-20.46-19.62-20.46-19.62v107.91h20.37v-41.64c0-11.94 6.41-18.93 15.87-18.93s13.54 6.4 13.54 17.33v43.24h20.24v-48.34c0-16.89-7.43-28.68-26.06-28.68ZM757.42 114.83c-11.06 0-18.93 5.24-23.44 11.94v-22.3h.01c0-19.69-20.53-20.53-20.53-20.53v107.91h19.06l.58-11.79c3.35 6.7 11.36 13.68 23.74 13.68 20.09 0 32.61-16.16 32.61-38.58v-1.9c0-22.13-12.09-38.43-32.04-38.43Zm11.36 40.33c0 14.7-6.11 22.86-17.76 22.86s-17.76-8.16-17.76-22.86v-1.9c0-14.7 6.25-22.85 17.76-22.85s17.76 8.15 17.76 22.85v1.9ZM821.91 103.89c0-18.95-20.38-19.95-20.38-19.95v107.91h20.38v-87.96ZM915.9 193.68v-10.36h-3.55v-2.48h10.13v2.48h-3.53v10.36h-3.05ZM924.26 193.68v-12.84h4.34l2.82 8.97 2.84-8.97h4.11v12.84h-2.88v-9.3l-2.95 9.3h-2.37l-2.98-9.33v9.33h-2.93Z",
                            className: "full_logo_svg__cls-7"
                        })
                    ]
                })
            })
        ]
    }));
var $a22a182679eb182e$export$2e2bcd8739ae039 = $a22a182679eb182e$var$SvgFullLogo;











let $9ad04432e4bd50f2$var$_ = (t)=>t, $9ad04432e4bd50f2$var$t, $9ad04432e4bd50f2$var$t1, $9ad04432e4bd50f2$var$t2, $9ad04432e4bd50f2$var$t3, $9ad04432e4bd50f2$var$t4, $9ad04432e4bd50f2$var$t5, $9ad04432e4bd50f2$var$t6;
// Defaults the folded text/link variant (formerly TextButton's default).
const $9ad04432e4bd50f2$var$TextVariantButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        $color: "text"
    }, props));
const $9ad04432e4bd50f2$export$2eca4db030987fb4 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f))($9ad04432e4bd50f2$var$t || ($9ad04432e4bd50f2$var$t = $9ad04432e4bd50f2$var$_`
    text-align: center;
    position: relative;
    top: -15px;
`));
const $9ad04432e4bd50f2$export$aa34b0733809f7c9 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$154f0ea7dcc0c8c6))($9ad04432e4bd50f2$var$t1 || ($9ad04432e4bd50f2$var$t1 = $9ad04432e4bd50f2$var$_`
    z-index: 2;
    position: relative;
    margin: 1rem 0 0.5rem 0;
`));
const $9ad04432e4bd50f2$export$2391059582428a3f = (0, $8de346382d86c747$export$2e2bcd8739ae039)($9ad04432e4bd50f2$var$TextVariantButton)($9ad04432e4bd50f2$var$t2 || ($9ad04432e4bd50f2$var$t2 = $9ad04432e4bd50f2$var$_`
    z-index: 2;
    ${0}
    font-weight: 400;
    text-decoration: underline !important;
    :hover {
        text-decoration: none !important;
    }
`), (0, $b091aef3a32d2bd8$export$1962b39d20eacf1d));
const $9ad04432e4bd50f2$export$276e2d5aebf03c9a = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($9ad04432e4bd50f2$var$t3 || ($9ad04432e4bd50f2$var$t3 = $9ad04432e4bd50f2$var$_`
    position: relative;
    flex: 1;
    max-width: 800px;
    align-self: stretch;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    margin: auto;
    background-color: transparent;
    @media (prefers-reduced-motion: no-preference) {
        animation-name: ${0};
        animation-duration: 3.5s;
    }
`), (0, $8951886a6b49e92a$export$f6e93140e4a16f4b));
const $9ad04432e4bd50f2$export$94008d681fbde3e7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($9ad04432e4bd50f2$var$t4 || ($9ad04432e4bd50f2$var$t4 = $9ad04432e4bd50f2$var$_`
    // height minutes the height of the footer and toolbar
    min-height: calc(100vh - 230px);
    flex: 1;
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${0};
    animation-name: ${0};

    animation-duration: 300ms;
    :before {
        background-image: ${0};
        background-size: 100%;
        position: fixed;
        top: 60vh;
        right: -60vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
        pointer-events: none;
    }
    :after {
        transform: rotate(180deg);
        background-image: ${0};
        background-size: 100%;
        position: fixed;
        top: -1000px;
        left: -70vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
        pointer-events: none;
    }
`), (props)=>props.theme.color.background, (0, $8951886a6b49e92a$export$a63bc229d382c303), (0, $8951886a6b49e92a$export$29bb14a8b9f2803e), (0, $8951886a6b49e92a$export$29bb14a8b9f2803e));
const $9ad04432e4bd50f2$export$6c854e2ebdd9e349 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$2f7dd73b133adfb7))($9ad04432e4bd50f2$var$t5 || ($9ad04432e4bd50f2$var$t5 = $9ad04432e4bd50f2$var$_`
    display: inline-block;
    text-align: center;
    font-weight: 400;
    z-index: 2;
    position: relative;
`));
const $9ad04432e4bd50f2$export$866b79548f9e5b64 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($9ad04432e4bd50f2$var$t6 || ($9ad04432e4bd50f2$var$t6 = $9ad04432e4bd50f2$var$_`
    background-color: ${0}90;
    padding: 2rem;
    border-radius: 8px;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`), (props)=>props.theme.color.background);



let $d906f0ec45e15ad7$var$_ = (t)=>t, $d906f0ec45e15ad7$var$t;
function $d906f0ec45e15ad7$export$2e2bcd8739ae039({ isExperimentalDevice: isExperimentalDevice, isLoading: isLoading, showLoading: showLoading, onExternalNavigation: onExternalNavigation, signInUrl: signInUrl, signUpUrl: signUpUrl }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { theme: theme } = (0, $7fPBF.useContext)((0, $c6dc2c2d62651942$export$2c657da244d00bd6));
    const handleExternalNavigation = (event)=>{
        const nativeEvent = event.nativeEvent;
        if (nativeEvent instanceof MouseEvent && (nativeEvent.button !== 0 || nativeEvent.metaKey || nativeEvent.ctrlKey || nativeEvent.shiftKey || nativeEvent.altKey)) return;
        onExternalNavigation === null || onExternalNavigation === void 0 ? void 0 : onExternalNavigation();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$94008d681fbde3e7), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9ad04432e4bd50f2$export$276e2d5aebf03c9a), {
            children: [
                isExperimentalDevice && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d906f0ec45e15ad7$var$StyledTag, {
                    children: t('common:beta')
                }),
                theme == 'light' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af532f2d7e07bf07$export$2e2bcd8739ae039), {
                    width: 350
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a22a182679eb182e$export$2e2bcd8739ae039), {
                    width: 350
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$2eca4db030987fb4), {
                    children: t('common:login.description')
                }),
                isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                    children: t('common:login.loading')
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$aa34b0733809f7c9), {
                            href: signUpUrl,
                            onClick: handleExternalNavigation,
                            children: t('common:login.create')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$562f981f17d360a4), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$6c854e2ebdd9e349), {
                                    children: t('common:login.existingAccount')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$2391059582428a3f), {
                                    $color: "context",
                                    onClick: (event)=>{
                                        handleExternalNavigation(event);
                                        showLoading === null || showLoading === void 0 ? void 0 : showLoading();
                                    },
                                    href: signInUrl,
                                    children: t('common:login.signIn')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $d906f0ec45e15ad7$var$StyledTag = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$3288d34c523a1192))($d906f0ec45e15ad7$var$t || ($d906f0ec45e15ad7$var$t = $d906f0ec45e15ad7$var$_`
    position: relative;
    top: 30px;
`));







var $7fPBF = parcelRequire("7fPBF");

function $3fc44e910064c4f6$export$2e2bcd8739ae039() {
    const isAuthenticated = (0, $455682785eac4c5b$export$650ce9f0b4df82fd)((state)=>state.isAuthenticated);
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [queryParams] = (0, $f232cebbf1b70e96$export$f1a78c17382fe22a)();
    (0, $7fPBF.useEffect)(()=>{
        const queryCode = queryParams.get('code');
        if (queryCode) navigate(`../authcallback?code=${queryCode}`);
        if (isAuthenticated) navigate('../');
    }, []);
    const signInUrl = `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/signin?client_id=${(0, $db3063bd3b6d501e$export$666167f3cc1c081a)()}&redirect_uri=${(0, $07546889aef07ebc$export$b0c2c82d7aa8a735)()}`;
    const signUpUrl = `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/signup/v2?client_id=${(0, $db3063bd3b6d501e$export$666167f3cc1c081a)()}&redirect_uri=${(0, $07546889aef07ebc$export$b0c2c82d7aa8a735)()}&culture=${(0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().userLocalePreferences.defaultLocale}`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: !isAuthenticated && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d906f0ec45e15ad7$export$2e2bcd8739ae039), {
            signInUrl: signInUrl,
            signUpUrl: signUpUrl
        })
    });
}




const $427978696205d868$export$5122f57547dc8eca = (organization)=>{
    if (!organization) return 'personal';
    // professional licenses
    if (organization.isEmployeeAccess) return 'isEmployeeAccess';
    if (organization.isDeveloperAccess) return 'isDeveloperAccess';
    if (organization.isStudentAccess) return 'isStudentAccess';
    if (organization.isPlusAccess) return 'isPlusAccess';
    // default placeholder, in case it is unrecognized license type
    return 'isEmployeeAccess';
};
const $427978696205d868$export$40de46cbbcdfc304 = {
    personal: 'basic_plan',
    isPlusAccess: 'plus_plan',
    isEmployeeAccess: 'pro_plan',
    isDeveloperAccess: 'dev_plan',
    isStudentAccess: 'edu_plan'
};
const $427978696205d868$export$315f569a87774f90 = {
    personal: 'common:billing.personal.title',
    isPlusAccess: 'common:billing.isPlusAccess.title',
    isEmployeeAccess: 'common:billing.isEmployeeAccess.title',
    isStudentAccess: 'common:billing.isStudentAccess.title',
    isDeveloperAccess: 'common:billing.isDeveloperAccess.title'
};



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

function $748d28edcc8cedba$export$2e2bcd8739ae039() {
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const currentOrgId = (0, $7fPBF.useMemo)(()=>{
        return managedOrgId || organizationId;
    }, [
        managedOrgId,
        organizationId
    ]);
    return {
        organizationId: currentOrgId,
        parentOrgId: organizationId,
        managedOrgId: managedOrgId
    };
}


function $b194594edd326788$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const currentOrg = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.currentOrg);
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.currentOrg);
    const fetchOrgDetailData = (0, $7fPBF.useCallback)(async ()=>{
        const { currentOrg: currentOrg, loadingData: loadingData } = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
        if (!organizationId || (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id) == organizationId || loadingData.currentOrg) return;
        try {
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('currentOrg', true);
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadCurrentOrganizationDetails(organizationId);
            if (result.resultType != 'Ok') throw new Error('Error fetching organization data');
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.error'));
        } finally{
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('currentOrg', false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchOrgDetailData();
    }, [
        fetchOrgDetailData
    ]);
    const remainingSeats = (0, $7fPBF.useMemo)(()=>{
        if (!currentOrg || currentOrg.currentMemberCount == null || !currentOrg.maxMembers) return 0;
        if (currentOrg.maxMembers < currentOrg.currentMemberCount) return 0;
        return currentOrg.maxMembers - currentOrg.currentMemberCount;
    }, [
        currentOrg
    ]);
    const isExpiredOrg = (0, $7fPBF.useMemo)(()=>{
        if (!currentOrg || !currentOrg.licenseExpirationDate) return false;
        return currentOrg.licenseExpirationDate && new Date(currentOrg.licenseExpirationDate) < new Date();
    }, [
        currentOrg
    ]);
    const licenseType = (0, $7fPBF.useMemo)(()=>{
        return (0, $427978696205d868$export$5122f57547dc8eca)(currentOrg);
    }, [
        currentOrg
    ]);
    const currentMembership = (0, $7fPBF.useMemo)(()=>{
        if (!memberships || !organizationId) return null;
        return (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrganizationMembership(organizationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId,
        memberships
    ]);
    const originatingOrgMembership = (0, $7fPBF.useMemo)(()=>{
        if (!memberships || !currentOrg || !currentOrg.originatedByOrganizationId) return null;
        return (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrganizationMembership(currentOrg.originatedByOrganizationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentOrg,
        memberships
    ]);
    const membership = (0, $7fPBF.useMemo)(()=>{
        if (!organizationId) return null;
        if (currentMembership) return currentMembership;
        if (originatingOrgMembership) {
            const newMembership = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, originatingOrgMembership);
            newMembership.organizationId = organizationId;
            newMembership.isAdmin = true;
            return newMembership;
        }
        return null;
    }, [
        currentMembership,
        originatingOrgMembership,
        organizationId
    ]);
    const hasSomeMemberEditPermissions = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canRemoveMembers) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canChangeMemberPermissions) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageBilling = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageBilling) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    //     canAccessOrganizationProfiles: boolean;
    // canEditOrganizationProfiles: boolean;
    const canAccessOrganizationProfiles = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canAccessOrganizationProfiles) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canEditOrganizationProfiles = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canEditOrganizationProfiles) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canShareSkillsWithOrganization = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canShareSkillsWithOrganization) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageOrganizationSkills) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canShareMcpServersWithOrganization = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canShareMcpServersWithOrganization) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageOrganizationMcpServers) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageOrganizationSkills = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageOrganizationSkills) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageOrganizationMcpServers = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageOrganizationMcpServers) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canUseExternalSkills = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canUseExternalSkills) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canUseExternalMcpServers = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canUseExternalMcpServers) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canInviteMembers = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canInviteMembers) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canViewMembers = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canViewMembers) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canCreateAuthClients = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canCreateAuthClients) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canViewAuthClients = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canViewAuthClients) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageChildOrganizations = (0, $7fPBF.useMemo)(()=>{
        return !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageChildOrganizations) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageChildOrganizations) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin));
    }, [
        currentMembership,
        originatingOrgMembership
    ]);
    const canManageGovernance = (0, $7fPBF.useMemo)(()=>{
        return !!(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.isEmployeeAccess) && !!((currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.isAdmin) || (currentMembership === null || currentMembership === void 0 ? void 0 : currentMembership.canManageGlobalAutomationRules) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.isAdmin) || (originatingOrgMembership === null || originatingOrgMembership === void 0 ? void 0 : originatingOrgMembership.canManageGlobalAutomationRules));
    }, [
        currentOrg,
        currentMembership,
        originatingOrgMembership
    ]);
    const canViewOrgDetails = (0, $7fPBF.useMemo)(()=>{
        var _currentOrg_maxMembers;
        return !!(managedOrgId || ((_currentOrg_maxMembers = currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.maxMembers) !== null && _currentOrg_maxMembers !== void 0 ? _currentOrg_maxMembers : 0) > 1);
    }, [
        currentOrg,
        managedOrgId
    ]);
    const isManagedOrg = (0, $7fPBF.useMemo)(()=>{
        return !!(managedOrgId || (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.originatedByOrganizationId));
    }, [
        managedOrgId,
        currentOrg
    ]);
    /** Membership is owned by the customer's identity provider, so the portal cannot invite members. */ const isScimManaged = (0, $7fPBF.useMemo)(()=>{
        return !!(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.isScimEnabled);
    }, [
        currentOrg
    ]);
    /** Cephable sends this organization no email at all. Set by Cephable staff; read-only here. */ const areCephableEmailsBlocked = (0, $7fPBF.useMemo)(()=>{
        return !!(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.disableCephableEmails);
    }, [
        currentOrg
    ]);
    return {
        isLoading: isLoading,
        currentOrg: currentOrg,
        membership: membership,
        remainingSeats: remainingSeats,
        isExpiredOrg: isExpiredOrg,
        licenseType: licenseType,
        hasSomeMemberEditPermissions: hasSomeMemberEditPermissions,
        canManageBilling: canManageBilling,
        canCreateAuthClients: canCreateAuthClients,
        canViewAuthClients: canViewAuthClients,
        canInviteMembers: canInviteMembers,
        canViewMembers: canViewMembers,
        canManageChildOrganizations: canManageChildOrganizations,
        canManageGovernance: canManageGovernance,
        canViewOrgDetails: canViewOrgDetails,
        canAccessOrganizationProfiles: canAccessOrganizationProfiles,
        canEditOrganizationProfiles: canEditOrganizationProfiles,
        canShareSkillsWithOrganization: canShareSkillsWithOrganization,
        canShareMcpServersWithOrganization: canShareMcpServersWithOrganization,
        canManageOrganizationSkills: canManageOrganizationSkills,
        canManageOrganizationMcpServers: canManageOrganizationMcpServers,
        canUseExternalSkills: canUseExternalSkills,
        canUseExternalMcpServers: canUseExternalMcpServers,
        isManagedOrg: isManagedOrg,
        isScimManaged: isScimManaged,
        areCephableEmailsBlocked: areCephableEmailsBlocked
    };
}




function $f5559fd1343df4e9$export$2e2bcd8739ae039() {
    const matches = (0, $39c9549f68558626$export$2378eb7f5ff86053)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)(); // Get the dynamic params
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)(); // Get current organization details
    const items = matches.filter((match)=>{
        var _match_handle;
        return (_match_handle = match.handle) === null || _match_handle === void 0 ? void 0 : _match_handle.crumbKey;
    }).map((match)=>{
        var _match_handle;
        let crumbKey = ((_match_handle = match.handle) === null || _match_handle === void 0 ? void 0 : _match_handle.crumbKey) || '';
        // Replace :organizationId or :managedOrgId with the actual organization name if available
        let dynamicLabel = '';
        if (organizationId && !managedOrgId && (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name)) dynamicLabel = crumbKey.replace('common:organization.title', currentOrg.name);
        if (managedOrgId && (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name)) dynamicLabel = crumbKey.replace('common:organization.managed.title', currentOrg.name);
        const breadcrumbLabel = t(dynamicLabel || crumbKey);
        return {
            label: String(breadcrumbLabel) || '',
            href: match.pathname ? `${match.pathname}` : ''
        };
    });
    return {
        items: items,
        matches: matches
    };
}







let $2dfada774612a323$var$_ = (t)=>t, $2dfada774612a323$var$t;
const $2dfada774612a323$export$bab42a9f58782ce1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2dfada774612a323$var$t || ($2dfada774612a323$var$t = $2dfada774612a323$var$_`
    // height minus the height of the footer and toolbar
    min-height: calc(100vh - 186px);
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-between;
    animation-name: ${0};
    animation-duration: 300ms;
    :before {
        z-index: -1;
        background-image: ${0};
        background-size: 100% 100%;
        position: fixed;
        top: 60vh;
        right: -60vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
    }
    :after {
        z-index: -1;
        transform: rotate(180deg);
        background-image: ${0};
        background-size: 100% 100%;
        position: fixed;
        top: -1000px;
        left: -70vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
    }
`), (0, $8951886a6b49e92a$export$a63bc229d382c303), (0, $8951886a6b49e92a$export$29bb14a8b9f2803e), (0, $8951886a6b49e92a$export$29bb14a8b9f2803e));





function $0a32b82ac174a6a1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2dfada774612a323$export$bab42a9f58782ce1), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$a0a5e8e630ce7261), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9ad04432e4bd50f2$export$276e2d5aebf03c9a), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$fe91652f4f7f8d90), {
                        children: "404."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                        children: t('common:notFoundDescription')
                    })
                ]
            })
        })
    });
}



function $b4fdfd1bcb4375a9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:notFound'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a32b82ac174a6a1$export$2e2bcd8739ae039), {})
        ]
    });
}











parcelRequire("7fPBF");



let $d955c60ca6420e2e$var$_ = (t)=>t, $d955c60ca6420e2e$var$t, $d955c60ca6420e2e$var$t1, $d955c60ca6420e2e$var$t2, $d955c60ca6420e2e$var$t3;
function $d955c60ca6420e2e$export$2e2bcd8739ae039(_param) {
    var { title: title = '', prefixElement: prefixElement, children: children, description: description, complete: complete, number: number, tabIndex: tabIndex, scrollId: scrollId, as: as = 'h2', variant: variant = 'default' } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "prefixElement",
        "children",
        "description",
        "complete",
        "number",
        "tabIndex",
        "scrollId",
        "as",
        "variant"
    ]);
    if (complete) variant = 'small';
    const BodyComponent = variant == 'small' || !!complete ? (0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8) : (0, $b091aef3a32d2bd8$export$2c65789109b698b0);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d955c60ca6420e2e$var$RowWrapper, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restProps), {
        $variant: variant,
        children: [
            (number || complete) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d955c60ca6420e2e$var$Step, {
                children: complete ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                    name: "check"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d955c60ca6420e2e$var$StyledTitleSmall, {
                    as: "span",
                    children: number
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b341816979fee99b$export$ac90896a1379b2ac), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d955c60ca6420e2e$var$TextHeadingWrapper, {
                        children: [
                            prefixElement,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BodyComponent, {
                                as: as,
                                tabIndex: tabIndex,
                                id: scrollId,
                                children: title
                            })
                        ]
                    }),
                    description && variant != 'small' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$489b03dc3e6c3fea), {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b341816979fee99b$export$128b0389825fe3d5), {
                children: children
            })
        ]
    }));
}
const $d955c60ca6420e2e$var$RowWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d955c60ca6420e2e$var$t || ($d955c60ca6420e2e$var$t = $d955c60ca6420e2e$var$_`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    position: ${0};
    top: 1rem;
    padding-top: ${0};
    margin: ${0};
    border-bottom-width: 1px;
    border-style: solid;
    border-color: ${0};
    background-color: ${0};
    z-index: ${0};
`), (props)=>props.$sticky ? 'sticky' : 'static', (props)=>props.$variant == 'small' ? '0.25rem' : '0.5rem', (props)=>props.$variant == 'small' ? '1rem 0 0 0' : '2rem 0 0 0', (props)=>props.$variant == 'small' ? props.theme.color.border : props.theme.color.textBody, (props)=>props.$sticky ? props.theme.color.background : 'transparent', (props)=>props.$sticky ? 10 : 'auto');
const $d955c60ca6420e2e$var$Step = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d955c60ca6420e2e$var$t1 || ($d955c60ca6420e2e$var$t1 = $d955c60ca6420e2e$var$_`
    background-color: ${0};
    color: ${0};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    width: 2rem;
    flex-shrink: 0;
    margin-top: 0.25rem;
`), (props)=>props.theme.color.text, (props)=>props.theme.color.background);
const $d955c60ca6420e2e$var$StyledTitleSmall = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$2c65789109b698b0))($d955c60ca6420e2e$var$t2 || ($d955c60ca6420e2e$var$t2 = $d955c60ca6420e2e$var$_`
    padding: 0;
    color: ${0};
`), (props)=>props.theme.color.background);
const $d955c60ca6420e2e$var$TextHeadingWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d955c60ca6420e2e$var$t3 || ($d955c60ca6420e2e$var$t3 = $d955c60ca6420e2e$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
`));















var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");





var $e26231f066199887$var$LicenseActivationSteps = /*#__PURE__*/ function(LicenseActivationSteps) {
    LicenseActivationSteps[LicenseActivationSteps["LicenseKey"] = 0] = "LicenseKey";
    LicenseActivationSteps[LicenseActivationSteps["OrganizationDetails"] = 1] = "OrganizationDetails";
    return LicenseActivationSteps;
}($e26231f066199887$var$LicenseActivationSteps || {});
const $e26231f066199887$var$DefaultOrgName = 'My Team';
function $e26231f066199887$export$2e2bcd8739ae039({ open: open, onCancel: onCancel, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [errorMessage, setErrorMessage] = (0, $7fPBF.useState)(null);
    const [licenseKey, setLicenseKey] = (0, $7fPBF.useState)('');
    const [orgName, setOrgName] = (0, $7fPBF.useState)('');
    const [orgDescription, setOrgDescription] = (0, $7fPBF.useState)('');
    const [currentStep, setCurrentStep] = (0, $7fPBF.useState)(0);
    const description = organizationId ? t('common:license.activate.description') : t('common:license.activate.descriptionLong');
    /** Activation Logic */ const processResult = (result)=>{
        if (result.resultType == 'Ok' && result.data) {
            // navigate to activate license page
            navigate(`/org/${result.data.id}/license`, {
                replace: true
            });
            // show success message
            const licenseType = (0, $427978696205d868$export$5122f57547dc8eca)(result.data);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:license.activate.success', {
                license: t(`common:billing.${licenseType}.titleLong`)
            }));
            (0, $e7df95de73caec26$export$89b472e03be495df)('license-trial-started');
            // remove dialog
            onDismiss();
        } else setErrorMessage(t('common:license.activate.invalid.key'));
    };
    // free user is upgrading to a licensed organization
    const activateNewOrg = async (name, description)=>{
        // validation
        if (name == '') {
            setErrorMessage(t('common:license.activate.invalid.empty.name'));
            return;
        }
        // submit
        const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().activateNewOrgLicenseKey({
            name: name,
            description: description,
            key: licenseKey
        });
        processResult(result);
    };
    // existing org is activating a license key
    const activateExistingOrg = async ()=>{
        // permission check
        if (!organizationId) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.error'));
            onDismiss();
            return;
        }
        // submit
        const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().activateExistingOrgLicenseKey(organizationId, {
            key: licenseKey
        });
        processResult(result);
    };
    // custom activation logic based on user type
    const onActivate = async ()=>{
        if (currentStep === 0) {
            var _validateResult_data;
            // validate license key
            if (licenseKey === '') {
                setErrorMessage(t('common:license.activate.invalid.empty.key'));
                return;
            }
            let validateResult = null;
            if (organizationId) validateResult = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().validateLicenseKeyForOrganization(organizationId, licenseKey);
            else validateResult = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().validateLicenseKey(licenseKey);
            if ((validateResult === null || validateResult === void 0 ? void 0 : validateResult.resultType) === 'Ok' && validateResult.data && ((_validateResult_data = validateResult.data) === null || _validateResult_data === void 0 ? void 0 : _validateResult_data.isValid)) {
                // upgrade
                if (organizationId) await activateExistingOrg();
                else if (validateResult.data.maxMembers <= 1) {
                    const licenseType = (0, $427978696205d868$export$5122f57547dc8eca)(validateResult.data);
                    const description = t(`common:billing.${licenseType}.description`);
                    await activateNewOrg($e26231f066199887$var$DefaultOrgName, description);
                } else // proceed to next step
                setCurrentStep(1);
            } else {
                setErrorMessage(t('common:license.activate.invalid.key'));
                return;
            }
        }
        if (currentStep === 1) await activateNewOrg(orgName, orgDescription);
    };
    /** UI State Management */ const clearError = ()=>{
        if (errorMessage) setErrorMessage(null);
    };
    const onLicenseKeyChange = (e)=>{
        clearError();
        setLicenseKey(e.target.value);
    };
    const onOrgNameChange = (e)=>{
        clearError();
        setOrgName(e.target.value);
    };
    const onOrgDescriptionChange = (e)=>{
        clearError();
        setOrgDescription(e.target.value);
    };
    const onDismiss = ()=>{
        setErrorMessage(null);
        setLicenseKey('');
        setOrgName('');
        setOrgDescription('');
        setCurrentStep(0);
        onCancel();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        title: t('common:license.activate.title'),
        description: description,
        open: open,
        onClose: onDismiss,
        onCancel: onDismiss,
        onConfirm: onActivate,
        confirmButtonText: t('common:license.activate.button'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
            children: [
                currentStep === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                    label: t('common:license.activate.fieldLabel'),
                    placeholder: t('common:license.activate.placeholder'),
                    required: true,
                    value: licenseKey,
                    onChange: onLicenseKeyChange,
                    fullWidth: true
                }),
                currentStep === 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                            label: t('common:organization.new.name.label'),
                            placeholder: t('common:organization.new.name.placeholder'),
                            required: true,
                            value: orgName,
                            onChange: onOrgNameChange,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                            label: t('common:organization.new.description.label'),
                            placeholder: t('common:organization.new.description.placeholder'),
                            value: orgDescription,
                            onChange: onOrgDescriptionChange,
                            fullWidth: true
                        })
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$7f714e6c560938e5), {
                    children: errorMessage
                })
            ]
        })
    });
}


let $0b175acfd81bea10$var$_ = (t)=>t, $0b175acfd81bea10$var$t;
function $0b175acfd81bea10$export$2e2bcd8739ae039({ center: center = true, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const onClick = ()=>{
        setShowDialog(true);
    };
    const onCancel = ()=>{
        setShowDialog(false);
    };
    const RowWrapper = center ? (0, $aa23c6db410f15d5$export$562f981f17d360a4) : $0b175acfd81bea10$var$StyledRow;
    if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailVerified)) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RowWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$6c854e2ebdd9e349), {
                        children: t('common:license.activate.question')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9ad04432e4bd50f2$export$2391059582428a3f), {
                        $color: "context",
                        onClick: onClick,
                        children: t('common:license.activate.button')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e26231f066199887$export$2e2bcd8739ae039), {
                open: showDialog,
                onCancel: onCancel,
                organizationId: organizationId
            })
        ]
    });
}
const $0b175acfd81bea10$var$StyledRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $aa23c6db410f15d5$export$b59bdbef9ce70de2))($0b175acfd81bea10$var$t || ($0b175acfd81bea10$var$t = $0b175acfd81bea10$var$_`
    align-items: center;
    justify-content: flex-start;
`));


function $e1e9eb2af1eb4d35$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const isEmailVerified = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.isEmailVerified);
    const hasNoOrgMemberships = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.hasNoOrgMemberships);
    // option to activate license and create new organization only available to free users who have verified emails
    if (!hasNoOrgMemberships || !isEmailVerified) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:license.upgrade.generic.title'),
                description: t('common:license.upgrade.generic.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {
                        center: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        to: "/upgrade",
                        $color: "secondary",
                        children: t('common:billing.viewProducts')
                    })
                ]
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");



function $cd171fdb3e7df3d1$export$2e2bcd8739ae039({ open: open, onCancel: onCancel }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const availableMemberships = (0, $7fPBF.useMemo)(()=>{
        return memberships.filter((0, $b969eaec2195befc$export$e84fa2c5f7fcc9c7));
    }, [
        memberships
    ]);
    const [memberIndex, setMemberIndex] = (0, $7fPBF.useState)(0);
    const handleRadioSelectionClick = async (value)=>{
        setMemberIndex(value);
    };
    const onConfirm = async ()=>{
        const member = availableMemberships[memberIndex];
        (0, $55ce97f088539572$export$87aeeca3aeff7121).setState({
            currentOrgId: member.organizationId
        });
        navigate((0, $b969eaec2195befc$export$c169ff81af47339c)({
            organizationId: member.organizationId
        }));
        onDismiss();
    };
    const onDismiss = ()=>{
        setMemberIndex(0);
        onCancel();
    };
    if (availableMemberships.length === 0) {
        onDismiss();
        (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.error'));
        return null;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        title: t('common:organization.expired.dialog.title'),
        description: t('common:organization.expired.dialog.description'),
        open: open,
        onCancel: onDismiss,
        onClose: onDismiss,
        onConfirm: onConfirm,
        confirmButtonText: t('common:upgrade'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
            name: t('common:organization.titlePlural'),
            onChange: (e)=>handleRadioSelectionClick(parseInt(e.target.value)),
            value: memberIndex,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$1d02c21cd5285ce0), {
                children: availableMemberships.map((membership, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        value: i,
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                            sx: {
                                padding: '0 9'
                            }
                        }),
                        label: membership.organization.name
                    }, i))
            })
        })
    });
}



function $bf6564604dc78833$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const isLicenseExpired = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.isLicenseExpired);
    const isEmailVerified = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.isEmailVerified);
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const isSingleMembership = memberships.length == 1;
    const getTitle = ()=>{
        return isSingleMembership ? t('common:organization.expired.title') : t('common:organization.expired.titlePlural');
    };
    const getDescription = (0, $7fPBF.useCallback)(()=>{
        if (isSingleMembership) {
            const { isAdmin: isAdmin, canManageBilling: canManageBilling } = memberships[0];
            return canManageBilling || isAdmin ? t('common:organization.expired.admin') : t('common:organization.expired.user');
        }
        return t('common:organization.expired.multiple');
    }, [
        memberships,
        t,
        isSingleMembership
    ]);
    const handleClick = (0, $7fPBF.useCallback)(()=>{
        if (!isSingleMembership) {
            setShowDialog(true);
            return;
        }
        navigate((0, $b969eaec2195befc$export$c169ff81af47339c)({
            organizationId: memberships[0].organizationId
        }));
    }, [
        isSingleMembership,
        memberships,
        navigate
    ]);
    if (!isEmailVerified || !isLicenseExpired) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: getTitle(),
                description: getDescription()
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: isSingleMembership ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {
                            organizationId: memberships[0].organizationId,
                            center: false
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            onClick: handleClick,
                            $color: "secondary",
                            children: t('common:upgrade')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            onClick: handleClick,
                            $color: "secondary",
                            children: t('common:organization.viewOrganization')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cd171fdb3e7df3d1$export$2e2bcd8739ae039), {
                            open: showDialog,
                            onCancel: ()=>setShowDialog(false)
                        })
                    ]
                })
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");



let $1b7625fd457850e2$var$_ = (t)=>t, $1b7625fd457850e2$var$t, $1b7625fd457850e2$var$t1;
const $1b7625fd457850e2$export$5b9c17e7405b566e = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($1b7625fd457850e2$var$t || ($1b7625fd457850e2$var$t = $1b7625fd457850e2$var$_`
    margin-left: 0.5rem;
    padding: 0.25rem 0.5rem;
    border-left: 2px solid ${0};
    gap: 0.5rem;
`), (props)=>props.theme.color.cardHover);
const $1b7625fd457850e2$export$7dc96ad3c0a94692 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($1b7625fd457850e2$var$t1 || ($1b7625fd457850e2$var$t1 = $1b7625fd457850e2$var$_`
    min-width: 150px;
`));







var $7fPBF = parcelRequire("7fPBF");

function $f2d327d1efeb1ca4$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const { clearAndReload: clearAndReload } = (0, $6e4c204c2f850d70$export$2e2bcd8739ae039)();
    const handleDeleteAccount = async ()=>{
        const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().deleteCurrentUser();
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') clearAndReload();
    };
    const showDeleteConfirmation = ()=>{
        setShowDialog(true);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1b7625fd457850e2$export$7dc96ad3c0a94692), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    startIcon: "delete",
                    $size: "xsmall",
                    $color: "secondary",
                    onClick: showDeleteConfirmation,
                    children: t('delete')
                })
            }),
            showDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showDialog,
                onClose: ()=>setShowDialog(false),
                onCancel: ()=>setShowDialog(false),
                onConfirm: handleDeleteAccount,
                confirmButtonText: t('account.delete.confirm'),
                title: t('account.delete.title'),
                description: t('account.delete.description')
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");











function $6899017c561c4fe6$export$39f6debbec19b3ba(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiSwitch', slot);
}
const $6899017c561c4fe6$var$switchClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $6899017c561c4fe6$export$2e2bcd8739ae039 = $6899017c561c4fe6$var$switchClasses;






'use client';
const $3b6e9b66c5b93a14$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $6899017c561c4fe6$export$39f6debbec19b3ba), classes);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes, composedClasses);
};
const $3b6e9b66c5b93a14$var$SwitchRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $3b6e9b66c5b93a14$var$SwitchSwitchBase = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $ee7fbb23030d5fe3$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'left',
        'transform'
    ], {
        duration: theme.transitions.duration.shortest
    })), {
        [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).checked} + .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).disabled} + .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).checked} + .${(0, $6899017c561c4fe6$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $3b6e9b66c5b93a14$var$SwitchTrack = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, [
        'opacity',
        'background-color'
    ], {
        duration: theme.transitions.duration.shortest
    })), {
        '@media (forced-colors: active)': {
            boxSizing: 'border-box',
            border: '1px solid ButtonBorder'
        },
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $3b6e9b66c5b93a14$var$SwitchThumb = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        boxSizing: 'border-box',
        border: '1px solid transparent',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $3b6e9b66c5b93a14$var$Switch = /*#__PURE__*/ $7fPBF.forwardRef(function Switch(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "color",
        "edge",
        "size",
        "sx",
        "slots",
        "slotProps"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $3b6e9b66c5b93a14$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $3b6e9b66c5b93a14$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('thumb', {
        className: classes.thumb,
        elementType: $3b6e9b66c5b93a14$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ThumbSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, thumbSlotProps));
    const [TrackSlot, trackSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('track', {
        className: classes.track,
        elementType: $3b6e9b66c5b93a14$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3b6e9b66c5b93a14$var$SwitchSwitchBase, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other), {
                classes: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, classes), {
                    root: classes.switchBase
                }),
                slots: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, slots.switchBase && {
                    root: slots.switchBase
                }, slots.input && {
                    input: slots.input
                }),
                slotProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, slotProps.switchBase && {
                    root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                }), {
                    input: (0, $a7f2a504e52c35ca$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                        role: 'switch'
                    })
                })
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TrackSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, trackSlotProps))
        ]
    }));
});
var $3b6e9b66c5b93a14$export$2e2bcd8739ae039 = $3b6e9b66c5b93a14$var$Switch;




let $21f5b9af76a0c38b$var$_ = (t)=>t, $21f5b9af76a0c38b$var$t, $21f5b9af76a0c38b$var$t1, $21f5b9af76a0c38b$var$t2, $21f5b9af76a0c38b$var$t3, $21f5b9af76a0c38b$var$t4, $21f5b9af76a0c38b$var$t5;
const $21f5b9af76a0c38b$export$3e3aaa3680e7023b = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b2f3bbecbfe39692$export$2e2bcd8739ae039))($21f5b9af76a0c38b$var$t || ($21f5b9af76a0c38b$var$t = $21f5b9af76a0c38b$var$_`
    padding: 0 0 2rem 0;
`));
const $21f5b9af76a0c38b$export$b5d5cf8927ab7262 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3b6e9b66c5b93a14$export$2e2bcd8739ae039))($21f5b9af76a0c38b$var$t1 || ($21f5b9af76a0c38b$var$t1 = $21f5b9af76a0c38b$var$_`
    :focus-within {
        outline: 3px solid ${0};
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).accent);
const $21f5b9af76a0c38b$export$59e5bd234d7e3579 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$d9f4918700223049))($21f5b9af76a0c38b$var$t2 || ($21f5b9af76a0c38b$var$t2 = $21f5b9af76a0c38b$var$_`
    text-align: center;
    margin: 0 0 16px 0;
`)).withComponent('p');
const $21f5b9af76a0c38b$export$f60fd70865eea589 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($21f5b9af76a0c38b$var$t3 || ($21f5b9af76a0c38b$var$t3 = $21f5b9af76a0c38b$var$_`
    width: 100%;
    padding: 1rem 0;
`));
const $21f5b9af76a0c38b$export$1f54913ccc4368b1 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($21f5b9af76a0c38b$var$t4 || ($21f5b9af76a0c38b$var$t4 = $21f5b9af76a0c38b$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    gap: 0.5rem;
    & label {
        align-self: flex-start;
    }
`));
const $21f5b9af76a0c38b$export$2d00230e1e6f7fbc = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $ea5892afc276c974$export$2e2bcd8739ae039))($21f5b9af76a0c38b$var$t5 || ($21f5b9af76a0c38b$var$t5 = $21f5b9af76a0c38b$var$_`
    gap: 0.5rem;
`));












let $28d9662e98370ec0$var$_ = (t)=>t, $28d9662e98370ec0$var$t, $28d9662e98370ec0$var$t1, $28d9662e98370ec0$var$t2, $28d9662e98370ec0$var$t3, $28d9662e98370ec0$var$t4, $28d9662e98370ec0$var$t5, $28d9662e98370ec0$var$t6, $28d9662e98370ec0$var$t7, $28d9662e98370ec0$var$t8, $28d9662e98370ec0$var$t9, $28d9662e98370ec0$var$t10, $28d9662e98370ec0$var$t11;
const $28d9662e98370ec0$export$bc7adc8ef74607f = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($28d9662e98370ec0$var$t || ($28d9662e98370ec0$var$t = $28d9662e98370ec0$var$_`
    display: flex;
    border-bottom-width: 1px;
    border-style: solid;
    flex-basis: 100%;
    border-color: ${0};
    border-bottom-width: ${0};
`), (props)=>props.theme.color.border, (props)=>props.borderless ? '0' : '1px');
const $28d9662e98370ec0$export$25f993d99f705cbc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($28d9662e98370ec0$var$t1 || ($28d9662e98370ec0$var$t1 = $28d9662e98370ec0$var$_``));
const $28d9662e98370ec0$export$e9f274a1a8d32886 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($28d9662e98370ec0$var$t2 || ($28d9662e98370ec0$var$t2 = $28d9662e98370ec0$var$_`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`));
const $28d9662e98370ec0$export$23f145dc49963d58 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($28d9662e98370ec0$var$t3 || ($28d9662e98370ec0$var$t3 = $28d9662e98370ec0$var$_`
    margin-top: 0.25rem;
    flex-grow: ${0};
`), (props)=>props.$wrap ? '1' : '0');
const $28d9662e98370ec0$export$ec763714b6894364 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))($28d9662e98370ec0$var$t4 || ($28d9662e98370ec0$var$t4 = $28d9662e98370ec0$var$_`
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    height: 100%;
`));
const $28d9662e98370ec0$export$d210d4f1518e7142 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039))($28d9662e98370ec0$var$t5 || ($28d9662e98370ec0$var$t5 = $28d9662e98370ec0$var$_`
    margin-right: 0.4rem;
    align-self: center;
`));
const $28d9662e98370ec0$export$27894facc6548d4b = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($28d9662e98370ec0$var$t6 || ($28d9662e98370ec0$var$t6 = $28d9662e98370ec0$var$_`
    padding: 0 1rem;
    display: flex;
    flex-direction: column;
`));
const $28d9662e98370ec0$export$ab02e7e1b80b05a4 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($28d9662e98370ec0$var$t7 || ($28d9662e98370ec0$var$t7 = $28d9662e98370ec0$var$_`
    flex-grow: 1;
    gap: 0.25rem;
    display: flex;
    flex-direction: row;
    padding: 0.5rem;
    text-align: left;
    text-decoration: none;
    border: none;
    font-weight: inherit;
    background-color: ${0};
    transition:
        background-color 0.2s ease-in-out,
        border-color 0.2s ease-in-out;
    opacity: ${0};
    &:hover {
        background-color: ${0};
    }
    color: ${0};
    ${0};
`), (props)=>props.theme.color.background, ({ disabled: disabled })=>disabled ? 0.6 : 1, (props)=>props.disabled ? 'transparent' : props.theme.color.cardHover, (props)=>props.theme.color.text, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $28d9662e98370ec0$export$c40b407fe7288f21 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($28d9662e98370ec0$export$ab02e7e1b80b05a4.withComponent('a'))($28d9662e98370ec0$var$t8 || ($28d9662e98370ec0$var$t8 = $28d9662e98370ec0$var$_`
    &:hover {
        color: ${0};
        cursor: pointer;
    }
`), (props)=>props.disabled ? props.theme.color.textBody : props.theme.color.link);
const $28d9662e98370ec0$export$564cbe3426fc093a = (0, $8de346382d86c747$export$2e2bcd8739ae039)($28d9662e98370ec0$export$ab02e7e1b80b05a4.withComponent('button'))($28d9662e98370ec0$var$t9 || ($28d9662e98370ec0$var$t9 = $28d9662e98370ec0$var$_`
    &:hover {
        color: ${0};
        cursor: pointer;
    }
`), (props)=>props.disabled ? props.theme.color.textBody : props.theme.color.link);
const $28d9662e98370ec0$export$6ca0cf093d0e7859 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($28d9662e98370ec0$export$ab02e7e1b80b05a4.withComponent((0, $f232cebbf1b70e96$export$a6c7ac8248d6e38a)))($28d9662e98370ec0$var$t10 || ($28d9662e98370ec0$var$t10 = $28d9662e98370ec0$var$_`
    background-color: ${0};
    margin-top: 0.5rem;
    border-radius: 10px;
    border: 1px solid ${0};
    &:hover {
        background-color: ${0};
        cursor: pointer;
    }
`), (props)=>props.theme.color.cardHover, (props)=>props.theme.color.border, (props)=>props.theme.color.card);
const $28d9662e98370ec0$export$f2a3559b50aabeed = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($28d9662e98370ec0$var$t11 || ($28d9662e98370ec0$var$t11 = $28d9662e98370ec0$var$_`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    & > * {
        flex: 1;
    }
`));


let $57a5002928f949a3$var$_ = (t)=>t, $57a5002928f949a3$var$t, $57a5002928f949a3$var$t1, $57a5002928f949a3$var$t2, $57a5002928f949a3$var$t3;
function $57a5002928f949a3$export$2e2bcd8739ae039(_param) {
    var { title: title, titleId: titleId, description: description, prefixComponent: prefixComponent, suffixComponent: suffixComponent, children: children, secondaryComponent: secondaryComponent, titleSubtext: titleSubtext, wrap: wrap = false, thin: thin = false } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "titleId",
        "description",
        "prefixComponent",
        "suffixComponent",
        "children",
        "secondaryComponent",
        "titleSubtext",
        "wrap",
        "thin"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($57a5002928f949a3$var$StyledRowWrapper, {
                $wrap: wrap,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($57a5002928f949a3$var$Row, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    $wrap: wrap,
                    $thin: thin
                }, restProps), {
                    children: [
                        prefixComponent,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($57a5002928f949a3$var$StyledRowContent, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($57a5002928f949a3$var$StyledLabelMedium, {
                                    id: titleId,
                                    children: [
                                        title,
                                        titleSubtext && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8), {
                                            as: "span",
                                            children: titleSubtext
                                        })
                                    ]
                                }),
                                description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                    children: description
                                }),
                                suffixComponent
                            ]
                        }),
                        children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$23f145dc49963d58), {
                            $wrap: wrap,
                            children: children
                        })
                    ]
                }))
            }),
            secondaryComponent
        ]
    });
}
const $57a5002928f949a3$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($57a5002928f949a3$var$t || ($57a5002928f949a3$var$t = $57a5002928f949a3$var$_`
    display: flex;
    flex-wrap: ${0};
    align-items: ${0};

    padding: ${0};
    gap: 1rem;
    flex-basis: 100%;
`), (props)=>props.$wrap ? 'wrap' : 'nowrap', (props)=>props.$thin ? 'center' : 'flex-start', (props)=>props.$thin ? '0 0.75rem' : '0.75rem');
const $57a5002928f949a3$var$StyledRowContent = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $28d9662e98370ec0$export$e9f274a1a8d32886))($57a5002928f949a3$var$t1 || ($57a5002928f949a3$var$t1 = $57a5002928f949a3$var$_`
    justify-content: space-between;
`));
const $57a5002928f949a3$var$StyledLabelMedium = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b))($57a5002928f949a3$var$t2 || ($57a5002928f949a3$var$t2 = $57a5002928f949a3$var$_`
    color: ${0};
`), ({ theme: theme })=>theme.color.text);
const $57a5002928f949a3$var$StyledRowWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $28d9662e98370ec0$export$bc7adc8ef74607f))($57a5002928f949a3$var$t3 || ($57a5002928f949a3$var$t3 = $57a5002928f949a3$var$_`
    flex-wrap: ${0};
    border-bottom: none;
`), (props)=>props.$wrap ? 'wrap' : 'nowrap');





var $7fPBF = parcelRequire("7fPBF");

function $590356dd036c873d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    var _currentUser_isEmailOptIn;
    const [isEmailOptIn, setIsEmailOptIn] = (0, $7fPBF.useState)((_currentUser_isEmailOptIn = currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailOptIn) !== null && _currentUser_isEmailOptIn !== void 0 ? _currentUser_isEmailOptIn : false);
    const handleSaveEmailPreferences = async (v)=>{
        setIsEmailOptIn(v);
        try {
            var _result_errors;
            const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().updateEmailPreferences({
                isEmailOptIn: isEmailOptIn
            });
            var _result_errors_join;
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:account.success.marketing'));
            else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError((_result_errors_join = result === null || result === void 0 ? void 0 : (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.join(', ')) !== null && _result_errors_join !== void 0 ? _result_errors_join : t('common:account.error.marketing'));
        } catch (error) {
            console.error('Failed to update email preferences:', error);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.generic'));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $57a5002928f949a3$export$2e2bcd8739ae039), {
            thin: true,
            title: t('common:account.marketing.optIn'),
            titleId: `emailPreferences-label`,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                "aria-labelledby": `emailPreferences-label`,
                checked: isEmailOptIn,
                onChange: ()=>{
                    handleSaveEmailPreferences(!isEmailOptIn);
                }
            })
        })
    });
}









var $7fPBF = parcelRequire("7fPBF");



const $db4834f7df953e0a$export$aff464d60fdfb505 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [oldPassword, setOldPassword] = (0, $7fPBF.useState)('');
    const [newPassword, setNewPassword] = (0, $7fPBF.useState)('');
    const [confirmNewPassword, setConfirmNewPassword] = (0, $7fPBF.useState)('');
    const handleSavePassword = async ()=>{
        try {
            if (!validatePasswordInputs()) return;
            const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().updatePassword(oldPassword, newPassword, confirmNewPassword);
            handlePasswordSaveResult(result);
        } catch (error) {
            console.error('Failed to update password:', error);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.generic'));
        }
    };
    const validatePasswordInputs = ()=>{
        if (!oldPassword) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.old'));
            return false;
        }
        if (!newPassword) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.new'));
            return false;
        }
        if (newPassword !== confirmNewPassword) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.match'));
            return false;
        }
        return true;
    };
    const handlePasswordSaveResult = (result)=>{
        var _result_errors;
        var _result_errors_join;
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:account.success.password'));
            resetPasswordFields();
        } else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError((_result_errors_join = result === null || result === void 0 ? void 0 : (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.join(', ')) !== null && _result_errors_join !== void 0 ? _result_errors_join : t('common:account.error.password'));
    };
    const resetPasswordFields = ()=>{
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    };
    return {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmNewPassword,
        setOldPassword: setOldPassword,
        setNewPassword: setNewPassword,
        setConfirmNewPassword: setConfirmNewPassword,
        handleSavePassword: handleSavePassword
    };
};



function $d70f7f2448ed99ba$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { oldPassword: oldPassword, setOldPassword: setOldPassword, newPassword: newPassword, setNewPassword: setNewPassword, confirmNewPassword: confirmNewPassword, setConfirmNewPassword: setConfirmNewPassword, handleSavePassword: handleSavePassword } = (0, $db4834f7df953e0a$export$aff464d60fdfb505)();
    const handleConfirm = async ()=>{
        await handleSavePassword();
        // Only close if successful - the handleSavePassword will show error if not
        onClose();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        onCancel: onClose,
        onConfirm: handleConfirm,
        title: t('common:account.password.change'),
        confirmButtonText: t('common:account.password.update'),
        cancelButtonText: t('common:cancel'),
        maxWidth: "sm",
        fullWidth: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    label: t('common:account.password.old'),
                    type: "password",
                    placeholder: t('common:account.password.current'),
                    value: oldPassword,
                    onChange: (e)=>setOldPassword(e.target.value)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    label: t('common:account.password.new'),
                    type: "password",
                    placeholder: t('common:account.password.desired'),
                    value: newPassword,
                    onChange: (e)=>setNewPassword(e.target.value)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    label: t('common:account.password.confirm'),
                    type: "password",
                    placeholder: t('common:account.password.desired'),
                    value: confirmNewPassword,
                    onChange: (e)=>setConfirmNewPassword(e.target.value)
                })
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");

function $97d862a8a3c72e2c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $57a5002928f949a3$export$2e2bcd8739ae039), {
                title: t('common:account.password.change'),
                description: t('common:account.password.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1b7625fd457850e2$export$7dc96ad3c0a94692), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "xsmall",
                        $color: "secondary",
                        startIcon: "sync",
                        onClick: handleOpenDialog,
                        children: t('common:update')
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d70f7f2448ed99ba$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog
            })
        ]
    });
}















var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
/**
 * Note: This is a custom hook that is used to store a reference to the state.
 * When updating the state from the ref, you will need to use cloneDeep to create a new reference.
 * Without doing so, the state will not update and any useEffects that depend on the state will not run.
 * For examples of this, please see the ProfilesContainer.ts file.
 */ const $03ffc57089f4cd6c$var$isFunction = (setStateAction)=>typeof setStateAction === 'function';
const $03ffc57089f4cd6c$var$useStateRef = (initialState)=>{
    const [state, setState] = (0, $7fPBF.useState)(initialState);
    const ref = (0, $7fPBF.useRef)(state);
    const dispatch = (0, $7fPBF.useCallback)((setStateAction)=>{
        ref.current = $03ffc57089f4cd6c$var$isFunction(setStateAction) ? setStateAction(ref.current) : setStateAction;
        setState(ref.current);
    }, []);
    return [
        state,
        dispatch,
        ref
    ];
};
var $03ffc57089f4cd6c$export$2e2bcd8739ae039 = $03ffc57089f4cd6c$var$useStateRef;


function $2c3144704a635922$export$2e2bcd8739ae039(initialFlags) {
    const [featureFlags, setFeatureFlags, featureFlagRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(initialFlags);
    const initialFlagsRef = (0, $7fPBF.useRef)(initialFlags);
    const updateFeatureFlags = (flagName, isEnabled)=>{
        setFeatureFlags((prevFlags)=>{
            const hasFlag = prevFlags.includes(flagName);
            if (isEnabled && !hasFlag) return [
                ...prevFlags,
                flagName
            ];
            else if (!isEnabled && hasFlag) return prevFlags.filter((flag)=>flag !== flagName);
            return prevFlags;
        });
    };
    const handleEnabledFeatureFlagChange = async ()=>{
        // TODO HEAD MOUSE: Add head mouse settings when the feature flag is enabled
        if (initialFlagsRef.current.includes((0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78)) && !featureFlagRef.current.includes((0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78))) for (const device of (0, $57ef534a0961ba07$export$2b13470419707314).getState().devices){
            if (device.expressionSettings.mouseMoveMode == undefined || device.expressionSettings.mouseMoveMode === 'Off') continue;
            try {
                await (0, $57ef534a0961ba07$export$2b13470419707314).getState().updateDevice(device.id, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, device), {
                    expressionSettings: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, device.expressionSettings), {
                        mouseMoveLeftExpression: undefined,
                        mouseMoveRightExpression: undefined,
                        mouseMoveUpExpression: undefined,
                        mouseMoveDownExpression: undefined,
                        mouseMoveMode: 'Off'
                    })
                }));
            } catch (error) {
                return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
            }
        }
        return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)((0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78));
    };
    /**
     * Handles the extended feature flag change on user preference save
     * Use this when you need other functionality to be triggered when a feature flag is changed using if conditions
     * @returns A result indicating the success or failure of the operation
     */ const handleExtendedFeatureFlagChange = async ()=>{
        const flagHandlers = {
            [(0, $eec5c3b697f8e81e$export$19e7a64c17ac6a78)]: handleEnabledFeatureFlagChange
        };
        try {
            const results = await Promise.all(Object.entries(flagHandlers).map(([flag, handler])=>{
                if (featureFlagRef.current.includes(flag) || initialFlagsRef.current.includes(flag)) return handler(); // Call the handler if the feature flag is has existed in initial or current flags
                return Promise.resolve(new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)('')); // Resolve with a SuccessResult if not enabled
            }));
            // Check for any UnexpectedResults and return the first one found
            const unexpectedResult = results.find((result)=>result instanceof (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039));
            if (unexpectedResult) return unexpectedResult; // Return the UnexpectedResult if found
            // Reset the initial flags to the current flags after handling since those have been saved.
            // This ensures the next 'save' click behaves as expected.
            initialFlagsRef.current = featureFlagRef.current;
            return new (0, $84d8c1f6f6e5603d$export$2e2bcd8739ae039)(''); // Return a generic success result
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    return {
        featureFlags: featureFlags,
        updateFeatureFlags: updateFeatureFlags,
        handleExtendedFeatureFlagChange: handleExtendedFeatureFlagChange
    };
}



var $7fPBF = parcelRequire("7fPBF");



function $6bb82cbdc861c255$export$2e2bcd8739ae039({ flagName: flagName, isEnabled: isEnabled, onToggle: onToggle, label: label }) {
    const handleToggle = ()=>{
        onToggle(flagName, !isEnabled);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
        value: "start",
        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b6e9b66c5b93a14$export$2e2bcd8739ae039), {
            checked: isEnabled,
            onChange: handleToggle
        }),
        label: label,
        labelPlacement: "end"
    });
}


function $4d95bdbd61412061$export$2e2bcd8739ae039() {
    var _currentUser_userPreferences, _currentUser_userPreferences1;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const userBetaFeatureFlags = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.userBetaFeatureFlags);
    var _currentUser_userPreferences_isWarningConflictIndicatorsOptOut;
    const [isWarningOptOut, setIsWarningOptOut] = (0, $7fPBF.useState)((_currentUser_userPreferences_isWarningConflictIndicatorsOptOut = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_userPreferences = currentUser.userPreferences) === null || _currentUser_userPreferences === void 0 ? void 0 : _currentUser_userPreferences.isWarningConflictIndicatorsOptOut) !== null && _currentUser_userPreferences_isWarningConflictIndicatorsOptOut !== void 0 ? _currentUser_userPreferences_isWarningConflictIndicatorsOptOut : false);
    var _currentUser_userPreferences_featureFlags;
    const initialFeatureFlags = (_currentUser_userPreferences_featureFlags = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_userPreferences1 = currentUser.userPreferences) === null || _currentUser_userPreferences1 === void 0 ? void 0 : _currentUser_userPreferences1.featureFlags) !== null && _currentUser_userPreferences_featureFlags !== void 0 ? _currentUser_userPreferences_featureFlags : [];
    const { featureFlags: featureFlags, updateFeatureFlags: updateFeatureFlags, handleExtendedFeatureFlagChange: handleExtendedFeatureFlagChange } = (0, $2c3144704a635922$export$2e2bcd8739ae039)(initialFeatureFlags);
    const handleSaveUserPreferences = async ()=>{
        try {
            var _result_errors;
            const preferences = {
                isWarningConflictIndicatorsOptOut: isWarningOptOut,
                featureFlags: featureFlags
            };
            const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().updateUserPreferences(preferences);
            var _result_errors_join;
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') {
                const featureFlagResult = await handleExtendedFeatureFlagChange();
                if (featureFlagResult.resultType === 'Unexpected') {
                    (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.userPreferences'));
                    return;
                }
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:account.success.userPreferences'));
            } else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError((_result_errors_join = result === null || result === void 0 ? void 0 : (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.join(', ')) !== null && _result_errors_join !== void 0 ? _result_errors_join : t('common:account.error.userPreferences'));
        } catch (error) {
            console.error('Error saving user preferences:', error);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.error.unexpected')); // Provide a generic fallback error message
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:account.userPreferences.title'),
                description: t('common:account.userPreferences.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        value: "start",
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b6e9b66c5b93a14$export$2e2bcd8739ae039), {
                            checked: isWarningOptOut,
                            onChange: ()=>{
                                setIsWarningOptOut(!isWarningOptOut);
                            }
                        }),
                        label: t('common:account.userPreferences.warningOptOut'),
                        labelPlacement: "end"
                    }),
                    userBetaFeatureFlags.map((flag)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6bb82cbdc861c255$export$2e2bcd8739ae039), {
                            flagName: flag,
                            isEnabled: featureFlags.includes(flag),
                            onToggle: updateFeatureFlags,
                            label: t(`common:account.userPreferences.${flag}`)
                        }, flag)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        onClick: handleSaveUserPreferences,
                        children: t('common:save')
                    })
                ]
            })
        ]
    });
}


function $1655878af8403289$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const hasNoOrgMemberships = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.hasNoOrgMemberships);
    (0, $7fPBF.useEffect)(()=>{
        const fetchUserData = async ()=>{
            await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().loadCurrentUser();
            setIsLoading(false);
        };
        fetchUserData();
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$168e1409b442d455), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$a4cc130c20be0091), {
                        as: "p",
                        children: [
                            t('common:account.usernameLabel'),
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                as: "span",
                                children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.username
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$a4cc130c20be0091), {
                        as: "p",
                        children: [
                            t('common:account.emailLabel'),
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                as: "span",
                                children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.email
                            })
                        ]
                    })
                ]
            }),
            hasNoOrgMemberships ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e1e9eb2af1eb4d35$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf6564604dc78833$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97d862a8a3c72e2c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $590356dd036c873d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d95bdbd61412061$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('dangerZone')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2d327d1efeb1ca4$export$2e2bcd8739ae039), {})
        ]
    });
}



function $6895f6b5d8df95cd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:account.settings'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1655878af8403289$export$2e2bcd8739ae039), {})
        ]
    });
}













function $ae034d1fd76a0328$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    if (memberships.length > 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.noOrg.description'),
        fullHeight: true,
        icon: "orgCompany",
        title: t('common:organization.noOrg.title'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                href: `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/trial/`,
                startIcon: "plusLight",
                children: t('common:license.trial.start')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {})
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");

function $b8d9a8d0ea07c335$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleResendVerification = (0, $7fPBF.useCallback)(async ()=>{
        try {
            const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().requestEmailVerificationResend();
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:account.isEmailVerified.success'));
            else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.isEmailVerified.error'));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:account.isEmailVerified.error'));
        }
    }, [
        t
    ]);
    return {
        handleResendVerification: handleResendVerification
    };
}





function $16382b6bee5ea13e$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { handleResendVerification: handleResendVerification } = (0, $b8d9a8d0ea07c335$export$2e2bcd8739ae039)();
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const isLoading = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.isLoading);
    if (!currentUser || isLoading || currentUser.isEmailVerified) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:account.isEmailVerified.org'),
        fullHeight: true,
        icon: "orgInvite",
        title: t('common:account.isEmailVerified.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            onClick: handleResendVerification,
            startIcon: "sync",
            children: t('common:account.isEmailVerified.resend')
        })
    });
}














let $4f034ea975db3d0b$var$_ = (t)=>t, $4f034ea975db3d0b$var$t;
function $4f034ea975db3d0b$export$2e2bcd8739ae039(_param) {
    var { title: title, description: description, disabled: disabled = false, startComponent: startComponent, startIcon: startIcon, endIcon: endIcon = 'forward', href: href, iconSize: iconSize = 42, onClick: onClick, children: children, tagNode: tagNode, borderless: borderless = false, variant: variant = 'default' } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "description",
        "disabled",
        "startComponent",
        "startIcon",
        "endIcon",
        "href",
        "iconSize",
        "onClick",
        "children",
        "tagNode",
        "borderless",
        "variant"
    ]);
    const commonProps = {
        disabled: disabled
    };
    if (!href && !onClick) throw new Error('ActionRow requires either an href or onClick prop');
    if (href) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$bc7adc8ef74607f), {
        borderless: borderless,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$c40b407fe7288f21), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            href: href
        }, commonProps, restProps), {
            children: [
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$d210d4f1518e7142), {
                    name: startIcon,
                    size: iconSize
                }),
                startComponent,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$e9f274a1a8d32886), {
                    children: [
                        tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9ee67e6e3f51a5ed), {
                            children: [
                                tagNode,
                                " ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                                    as: "span",
                                    children: title
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                            as: "span",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            as: "span",
                            children: description
                        }),
                        children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$23f145dc49963d58), {
                            children: children
                        })
                    ]
                }),
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$ec763714b6894364), {
                    name: endIcon,
                    size: iconSize
                })
            ]
        }))
    });
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$bc7adc8ef74607f), {
        borderless: borderless,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$564cbe3426fc093a), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            onClick: onClick
        }, commonProps, restProps), {
            children: [
                startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$d210d4f1518e7142), {
                    name: startIcon,
                    size: iconSize
                }),
                startComponent,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$e9f274a1a8d32886), {
                    children: [
                        tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9ee67e6e3f51a5ed), {
                            children: [
                                tagNode,
                                ' ',
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                                    $variant: variant,
                                    as: "span",
                                    children: title
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4f034ea975db3d0b$var$ActionRowTitle, {
                            $variant: variant,
                            as: "span",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            as: "span",
                            children: description
                        }),
                        children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$23f145dc49963d58), {
                            children: children
                        })
                    ]
                }),
                endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$ec763714b6894364), {
                    name: endIcon,
                    size: iconSize
                })
            ]
        }))
    });
}
const $4f034ea975db3d0b$var$ActionRowTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d))($4f034ea975db3d0b$var$t || ($4f034ea975db3d0b$var$t = $4f034ea975db3d0b$var$_`
    color: inherit;
    ${0};
`), ({ $variant: $variant })=>$variant === 'small' ? (0, $b091aef3a32d2bd8$export$3e193b19d995235f) : (0, $b091aef3a32d2bd8$export$9f95ce22eaa08be4));


function $d352f17b0797ff29$export$2e2bcd8739ae039({ membership: membership }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const handleNavigate = ()=>{
        navigate(`../org/${membership.organizationId}`);
    };
    if (!membership || !membership.organization || !membership.organizationId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
        iconSize: 24,
        startIcon: (0, $d0493a8b121d95e9$export$3aa18b5a5694efe6)(membership.organization),
        title: membership.organization.name,
        description: membership.organization.description,
        onClick: handleNavigate
    });
}





function $1571b35751ed6eec$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    var _memberships__organization_maxMembers;
    // part of multiple orgs or single org with multiple members
    const canViewOrganizationDetails = memberships.length > 1 || memberships.length === 1 && ((_memberships__organization_maxMembers = memberships[0].organization.maxMembers) !== null && _memberships__organization_maxMembers !== void 0 ? _memberships__organization_maxMembers : 0) > 1;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:welcome'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16382b6bee5ea13e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae034d1fd76a0328$export$2e2bcd8739ae039), {}),
            (memberships === null || memberships === void 0 ? void 0 : memberships.length) > 0 && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailVerified) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: canViewOrganizationDetails ? t('common:organization.titlePlural') : t('common:license.titlePlural'),
                description: canViewOrganizationDetails ? t('common:organization.description') : t('common:billing.description')
            }),
            memberships && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailVerified) && memberships.map((membership)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d352f17b0797ff29$export$2e2bcd8739ae039), {
                    membership: membership
                }, membership.organizationId))
        ]
    });
}











let $0bebe83a624352a6$var$_ = (t)=>t, $0bebe83a624352a6$var$t, $0bebe83a624352a6$var$t1;
function $0bebe83a624352a6$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($0bebe83a624352a6$var$SplashLoaderWrapper, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0bebe83a624352a6$export$b1ae020268e0b4d5, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "quick",
                $size: "small",
                onClick: ()=>{
                    window.location.reload();
                },
                children: t('common:reload')
            })
        ]
    });
}
const $0bebe83a624352a6$export$b1ae020268e0b4d5 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $5310a643ead17d95$export$2e2bcd8739ae039))($0bebe83a624352a6$var$t || ($0bebe83a624352a6$var$t = $0bebe83a624352a6$var$_`
    margin: 16px;
`));
const $0bebe83a624352a6$var$SplashLoaderWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($0bebe83a624352a6$var$t1 || ($0bebe83a624352a6$var$t1 = $0bebe83a624352a6$var$_`
    min-height: 90vh;
    flex: 1;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    ${0}
    img {
        height: 128px;
        width: 128px;
    }
`), (0, $19e0bc52fddd02b4$export$29c8ed22df400735));






function $8dc4863d22c2164a$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {
        text: "Coming soon."
    });
// if (!currentOrg || isInviteLoading) return <SplashLoader />;
// if (!(currentOrg.isAdmin || currentOrg.canCreateAuthClients)) return <OrgNoAccessBanner />;
// return (
//     <>
//         <CardSmallGrid>
//             {invites && (
//                 <NumberStatCard
//                     title={invites.length.toString() ?? '0'}
//                     description={t('common:organization.invite.stat', {
//                         value: currentOrg.organization.maxMembers,
//                     })}
//                 />
//             )}
//         </CardSmallGrid>
//     </>
// );
}




function $71606fe9d87fd62f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.metrics.orgTitle', {
                    value: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name
                }),
                description: t('common:organization.metrics.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dc4863d22c2164a$export$2e2bcd8739ae039), {})
        ]
    });
}















let $12a7318cc7b914d5$var$_ = (t)=>t, $12a7318cc7b914d5$var$t, $12a7318cc7b914d5$var$t1, $12a7318cc7b914d5$var$t2, $12a7318cc7b914d5$var$t3, $12a7318cc7b914d5$var$t4, $12a7318cc7b914d5$var$t5, $12a7318cc7b914d5$var$t6, $12a7318cc7b914d5$var$t7, $12a7318cc7b914d5$var$t8, $12a7318cc7b914d5$var$t9, $12a7318cc7b914d5$var$t10, $12a7318cc7b914d5$var$t11;
// Defaults the folded text/link variant (formerly TextButton's default).
const $12a7318cc7b914d5$var$TextVariantButton = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        $color: "text"
    }, props));
const $12a7318cc7b914d5$export$7c05dc9bbd6db060 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($12a7318cc7b914d5$var$t || ($12a7318cc7b914d5$var$t = $12a7318cc7b914d5$var$_`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    gap: 0.5rem;
`));
const $12a7318cc7b914d5$export$bdfe625add29c644 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$export$7c05dc9bbd6db060)($12a7318cc7b914d5$var$t2 || ($12a7318cc7b914d5$var$t2 = $12a7318cc7b914d5$var$_`
    border: 2px solid ${0};
    border-radius: 6px;
    background-color: ${0};
    color: ${0};
    ${0}
`), (props)=>props.theme.banner[props.$color || 'default'].border, (props)=>props.theme.banner[props.$color || 'default'].background, (props)=>props.theme.banner[props.$color || 'default'].text, (props)=>props.$borderless && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($12a7318cc7b914d5$var$t1 || ($12a7318cc7b914d5$var$t1 = $12a7318cc7b914d5$var$_`
            border: none;
            padding: 0;
            background-color: transparent;
        `)));
const $12a7318cc7b914d5$export$e30e93a3651e4e64 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($12a7318cc7b914d5$var$t3 || ($12a7318cc7b914d5$var$t3 = $12a7318cc7b914d5$var$_`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
`));
const $12a7318cc7b914d5$export$4a703ded2a7a3e59 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($12a7318cc7b914d5$var$t4 || ($12a7318cc7b914d5$var$t4 = $12a7318cc7b914d5$var$_`
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;
    padding: 1rem;
    border-radius: 6px;
    border: 2px solid ${0};
    background-color: ${0}25;
    &[data-isread='true'] {
        background-color: ${0};
        border: none;
        & * {
            color: ${0};
        }
    }
    justify-self: center;
`), (props)=>props.theme.color.secondary, (props)=>props.theme.color.secondary, (props)=>props.theme.color.accentCard, (props)=>props.theme.color.textBody);
const $12a7318cc7b914d5$export$7cee909993ddd8b7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($12a7318cc7b914d5$var$t5 || ($12a7318cc7b914d5$var$t5 = $12a7318cc7b914d5$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
`));
const $12a7318cc7b914d5$export$e47d9fd7cf4256ee = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$export$7cee909993ddd8b7)($12a7318cc7b914d5$var$t6 || ($12a7318cc7b914d5$var$t6 = $12a7318cc7b914d5$var$_`
    padding: 0;
    margin: 1rem 0;
    justify-content: center;
`));
const $12a7318cc7b914d5$export$8e508ed4a13b5a61 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$export$4a703ded2a7a3e59)($12a7318cc7b914d5$var$t7 || ($12a7318cc7b914d5$var$t7 = $12a7318cc7b914d5$var$_`
    border: 1px solid ${0};
    background-color: ${0};
`), (props)=>{
    var _props_$color;
    return props.theme.banner[(_props_$color = props.$color) !== null && _props_$color !== void 0 ? _props_$color : 'default'].border;
}, (props)=>{
    var _props_$color;
    return props.theme.banner[(_props_$color = props.$color) !== null && _props_$color !== void 0 ? _props_$color : 'default'].background;
});
const $12a7318cc7b914d5$var$sharedStyles = (props)=>{
    var _props_theme_banner_props_$color_buttonText, _props_theme_banner_props_$color_buttonText1;
    return (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($12a7318cc7b914d5$var$t8 || ($12a7318cc7b914d5$var$t8 = $12a7318cc7b914d5$var$_`
    .core-button {
        color: ${0};
        border-color: transparent;
        background: ${0};

        :hover {
            color: ${0};
            border-color: transparent;
            background: ${0};
            text-decoration: underline;
        }
    }
    .text-button {
        color: ${0};
    }
`), (_props_theme_banner_props_$color_buttonText = props.theme.banner[props.$color].buttonText) !== null && _props_theme_banner_props_$color_buttonText !== void 0 ? _props_theme_banner_props_$color_buttonText : props.theme.banner[props.$color].text, props.theme.banner[props.$color || 'default'].border, (_props_theme_banner_props_$color_buttonText1 = props.theme.banner[props.$color].buttonText) !== null && _props_theme_banner_props_$color_buttonText1 !== void 0 ? _props_theme_banner_props_$color_buttonText1 : props.theme.banner[props.$color || 'default'].text, props.theme.banner[props.$color || 'default'].border, props.theme.banner[props.$color || 'default'].linkText);
};
const $12a7318cc7b914d5$export$503892287317b6c8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($12a7318cc7b914d5$var$t9 || ($12a7318cc7b914d5$var$t9 = $12a7318cc7b914d5$var$_`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-content: center;
    ${0};
`), (props)=>props.$color !== 'default' && $12a7318cc7b914d5$var$sharedStyles(props));
const $12a7318cc7b914d5$export$dc254ddf4c41e5d7 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($12a7318cc7b914d5$var$t10 || ($12a7318cc7b914d5$var$t10 = $12a7318cc7b914d5$var$_`
    ${0};
`), (props)=>props.$color !== 'default' && $12a7318cc7b914d5$var$sharedStyles(props));
const $12a7318cc7b914d5$export$1a9858f2fb62c3f2 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($12a7318cc7b914d5$var$TextVariantButton)($12a7318cc7b914d5$var$t11 || ($12a7318cc7b914d5$var$t11 = $12a7318cc7b914d5$var$_`
    color: ${0};
    ${0}
    padding: 0 0.5rem;
    :hover {
        text-decoration: none !important;
    }
`), (props)=>props.theme.banner.default.text, (0, $b091aef3a32d2bd8$export$3e193b19d995235f));







function $1e6a0781013949e7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function getRelativeTime(inputDate) {
        const currentDate = new Date();
        const inputDateObj = new Date(inputDate);
        const timeDifference = currentDate.getTime() - inputDateObj.getTime();
        const absDifference = Math.abs(timeDifference);
        const isFuture = timeDifference < 0;
        const minutes = Math.floor(absDifference / 60000);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);
        let relativeTime = '';
        if (absDifference < 86400000) {
            if (minutes < 60) relativeTime = isFuture ? t('common:time.minutesAhead', 'in {count} minutes', {
                count: minutes
            }) : t('common:time.minutesAgo', '{count} minutes ago', {
                count: minutes
            });
            else relativeTime = isFuture ? t('common:time.todayAhead', 'later today') : t('common:time.today', 'today');
        } else if (absDifference < 172800000) relativeTime = isFuture ? t('common:time.tomorrow', 'tomorrow') : t('common:time.yesterday', 'yesterday');
        else if (absDifference < 2592000000) relativeTime = isFuture ? t('common:time.daysAhead', 'in {count} days', {
            count: days
        }) : t('common:time.daysAgo', '{count} days ago', {
            count: days
        });
        else if (absDifference < 31536000000) relativeTime = isFuture ? t('common:time.monthsAhead', 'in {count} months', {
            count: months
        }) : t('common:time.monthsAgo', '{count} months ago', {
            count: months
        });
        else relativeTime = isFuture ? t('common:time.yearsAhead', 'in {count} years', {
            count: years
        }) : t('common:time.yearsAgo', '{count} years ago', {
            count: years
        });
        return relativeTime;
    }
    return getRelativeTime;
}



/**
 * @import {Element, ElementContent, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentProps, ElementType, ReactElement} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in Extract<ElementType, string>]?: ElementType<ComponentProps<Key> & ExtraProps>
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ 
function $5f7e7f29fdd0c06b$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $5f7e7f29fdd0c06b$export$411ce8e5a71e3069() {}
function $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49() {}
function $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $9323934601145f2e$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $9323934601145f2e$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $8ae047d5df63cb7f$var$startRe = RegExp("[$_\\p{ID_Start}]", "u");
const $8ae047d5df63cb7f$var$contRe = RegExp("[$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
const $8ae047d5df63cb7f$var$contReJsx = RegExp("[-$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
const $8ae047d5df63cb7f$var$nameRe = RegExp("^[$_\\p{ID_Start}][$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
const $8ae047d5df63cb7f$var$nameReJsx = RegExp("^[$_\\p{ID_Start}][-$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
/** @type {Options} */ const $8ae047d5df63cb7f$var$emptyOptions = {};
function $8ae047d5df63cb7f$export$b3571188c770cc5a(code) {
    return code ? $8ae047d5df63cb7f$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $8ae047d5df63cb7f$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $8ae047d5df63cb7f$var$emptyOptions;
    const re = settings.jsx ? $8ae047d5df63cb7f$var$contReJsx : $8ae047d5df63cb7f$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $8ae047d5df63cb7f$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $8ae047d5df63cb7f$var$emptyOptions;
    const re = settings.jsx ? $8ae047d5df63cb7f$var$nameReJsx : $8ae047d5df63cb7f$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $99728b3b7e804493$var$re = /[ \t\n\f\r]/g;
function $99728b3b7e804493$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $99728b3b7e804493$var$empty(thing.value) : false : $99728b3b7e804493$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $99728b3b7e804493$var$empty(value) {
    return value.replace($99728b3b7e804493$var$re, '') === '';
}


/**
 * @import {Schema} from 'property-information'
 */ /**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $f5a64e1dc26e2922$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.attribute = '';
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.booleanish = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.boolean = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.defined = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.number = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.property = '';
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.space = undefined;


var $6327116045afe73c$exports = {};

$parcel$export($6327116045afe73c$exports, "boolean", function () { return $6327116045afe73c$export$4a21f16c33752377; });
$parcel$export($6327116045afe73c$exports, "booleanish", function () { return $6327116045afe73c$export$55e9e1fbc638dc8f; });
$parcel$export($6327116045afe73c$exports, "overloadedBoolean", function () { return $6327116045afe73c$export$242ac3d3042558aa; });
$parcel$export($6327116045afe73c$exports, "number", function () { return $6327116045afe73c$export$98e628dec113755e; });
$parcel$export($6327116045afe73c$exports, "spaceSeparated", function () { return $6327116045afe73c$export$ab8645c862eb5a3e; });
$parcel$export($6327116045afe73c$exports, "commaSeparated", function () { return $6327116045afe73c$export$9c8d678629b3d3; });
$parcel$export($6327116045afe73c$exports, "commaOrSpaceSeparated", function () { return $6327116045afe73c$export$2ad25cfebf36cacd; });
let $6327116045afe73c$var$powers = 0;
const $6327116045afe73c$export$4a21f16c33752377 = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$55e9e1fbc638dc8f = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$242ac3d3042558aa = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$98e628dec113755e = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$ab8645c862eb5a3e = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$9c8d678629b3d3 = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$2ad25cfebf36cacd = $6327116045afe73c$var$increment();
function $6327116045afe73c$var$increment() {
    return 2 ** ++$6327116045afe73c$var$powers;
}


const $e9abde33d3611e8d$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($6327116045afe73c$exports);
class $e9abde33d3611e8d$export$ea6b9f0064e88c9b extends (0, $f5a64e1dc26e2922$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $e9abde33d3611e8d$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $e9abde33d3611e8d$var$checks.length){
            const check = $e9abde33d3611e8d$var$checks[index];
            $e9abde33d3611e8d$var$mark(this, $e9abde33d3611e8d$var$checks[index], (mask & $6327116045afe73c$exports[check]) === $6327116045afe73c$exports[check]);
        }
    }
}
$e9abde33d3611e8d$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $e9abde33d3611e8d$var$mark(values, key, value) {
    if (value) values[key] = value;
}



/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $e193cc6bfb75f539$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


const $84669bfd2b988556$var$cap = /[A-Z]/g;
const $84669bfd2b988556$var$dash = /-[a-z]/g;
const $84669bfd2b988556$var$valid = /^data[-\w.:]+$/i;
function $84669bfd2b988556$export$71aa6c912b956294(schema, value) {
    const normal = (0, $e193cc6bfb75f539$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $f5a64e1dc26e2922$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $84669bfd2b988556$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($84669bfd2b988556$var$dash, $84669bfd2b988556$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$84669bfd2b988556$var$dash.test(rest)) {
                let dashes = rest.replace($84669bfd2b988556$var$cap, $84669bfd2b988556$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $e9abde33d3611e8d$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $84669bfd2b988556$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $84669bfd2b988556$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $a1ae9812302ca8ea$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $3f644418d59ec988$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$3f644418d59ec988$export$19342e026b58ebb7.prototype.normal = {};
$3f644418d59ec988$export$19342e026b58ebb7.prototype.property = {};
$3f644418d59ec988$export$19342e026b58ebb7.prototype.space = undefined;


function $f22be46171b10c63$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $3f644418d59ec988$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 


function $9241b59662c8e4b9$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $e9abde33d3611e8d$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $e193cc6bfb75f539$export$a3295358bff77e)(property)] = property;
        normals[(0, $e193cc6bfb75f539$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $3f644418d59ec988$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $f6c2d7ac952f45ea$export$4d2d26490572750a = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaColIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaColSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaControls: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaPressed: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaRowIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaRowSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaSelected: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueMin: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueNow: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $57102789fbb4388b$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f66392ca00ae8b5e$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $57102789fbb4388b$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $aed0b684443ef64e$export$c0bb0b647f701bb5 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $6327116045afe73c$export$9c8d678629b3d3),
        acceptCharset: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        accessKey: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $6327116045afe73c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $6327116045afe73c$export$4a21f16c33752377),
        allowUserMedia: (0, $6327116045afe73c$export$4a21f16c33752377),
        alpha: (0, $6327116045afe73c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $6327116045afe73c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        autoFocus: (0, $6327116045afe73c$export$4a21f16c33752377),
        autoPlay: (0, $6327116045afe73c$export$4a21f16c33752377),
        blocking: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $6327116045afe73c$export$4a21f16c33752377),
        cite: null,
        className: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $6327116045afe73c$export$98e628dec113755e),
        colSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        controls: (0, $6327116045afe73c$export$4a21f16c33752377),
        controlsList: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        coords: (0, $6327116045afe73c$export$98e628dec113755e) | (0, $6327116045afe73c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $6327116045afe73c$export$4a21f16c33752377),
        defer: (0, $6327116045afe73c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $6327116045afe73c$export$4a21f16c33752377),
        download: (0, $6327116045afe73c$export$242ac3d3042558aa),
        draggable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $6327116045afe73c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        height: (0, $6327116045afe73c$export$98e628dec113755e),
        hidden: (0, $6327116045afe73c$export$242ac3d3042558aa),
        high: (0, $6327116045afe73c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $6327116045afe73c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $6327116045afe73c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        itemRef: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        itemScope: (0, $6327116045afe73c$export$4a21f16c33752377),
        itemType: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $6327116045afe73c$export$4a21f16c33752377),
        low: (0, $6327116045afe73c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $6327116045afe73c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $6327116045afe73c$export$98e628dec113755e),
        multiple: (0, $6327116045afe73c$export$4a21f16c33752377),
        muted: (0, $6327116045afe73c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $6327116045afe73c$export$4a21f16c33752377),
        noValidate: (0, $6327116045afe73c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $6327116045afe73c$export$4a21f16c33752377),
        optimum: (0, $6327116045afe73c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $6327116045afe73c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $6327116045afe73c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        required: (0, $6327116045afe73c$export$4a21f16c33752377),
        reversed: (0, $6327116045afe73c$export$4a21f16c33752377),
        rows: (0, $6327116045afe73c$export$98e628dec113755e),
        rowSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        sandbox: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $6327116045afe73c$export$4a21f16c33752377),
        seamless: (0, $6327116045afe73c$export$4a21f16c33752377),
        selected: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootClonable: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $6327116045afe73c$export$4a21f16c33752377),
        shape: null,
        size: (0, $6327116045afe73c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $6327116045afe73c$export$98e628dec113755e),
        spellCheck: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $6327116045afe73c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $6327116045afe73c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        width: (0, $6327116045afe73c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $6327116045afe73c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $6327116045afe73c$export$4a21f16c33752377),
        declare: (0, $6327116045afe73c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $6327116045afe73c$export$98e628dec113755e),
        leftMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        marginWidth: (0, $6327116045afe73c$export$98e628dec113755e),
        noResize: (0, $6327116045afe73c$export$4a21f16c33752377),
        noHref: (0, $6327116045afe73c$export$4a21f16c33752377),
        noShade: (0, $6327116045afe73c$export$4a21f16c33752377),
        noWrap: (0, $6327116045afe73c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $6327116045afe73c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $6327116045afe73c$export$4a21f16c33752377),
        disablePictureInPicture: (0, $6327116045afe73c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $6327116045afe73c$export$4a21f16c33752377),
        exportParts: (0, $6327116045afe73c$export$9c8d678629b3d3),
        part: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $6327116045afe73c$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $f66392ca00ae8b5e$export$32b9e4cec9c208e1)
});





const $098f3c17bccabf6d$export$7ed1367e7fa1ad68 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        accentHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $6327116045afe73c$export$98e628dec113755e),
        amplitude: (0, $6327116045afe73c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $6327116045afe73c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $6327116045afe73c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $6327116045afe73c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        className: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $6327116045afe73c$export$98e628dec113755e),
        diffuseConstant: (0, $6327116045afe73c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $6327116045afe73c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $6327116045afe73c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $6327116045afe73c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $6327116045afe73c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $6327116045afe73c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $6327116045afe73c$export$9c8d678629b3d3),
        g2: (0, $6327116045afe73c$export$9c8d678629b3d3),
        glyphName: (0, $6327116045afe73c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $6327116045afe73c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $6327116045afe73c$export$98e628dec113755e),
        horizOriginX: (0, $6327116045afe73c$export$98e628dec113755e),
        horizOriginY: (0, $6327116045afe73c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $6327116045afe73c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $6327116045afe73c$export$98e628dec113755e),
        k: (0, $6327116045afe73c$export$98e628dec113755e),
        k1: (0, $6327116045afe73c$export$98e628dec113755e),
        k2: (0, $6327116045afe73c$export$98e628dec113755e),
        k3: (0, $6327116045afe73c$export$98e628dec113755e),
        k4: (0, $6327116045afe73c$export$98e628dec113755e),
        kernelMatrix: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $6327116045afe73c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $6327116045afe73c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $6327116045afe73c$export$98e628dec113755e),
        overlineThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $6327116045afe73c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $6327116045afe73c$export$98e628dec113755e),
        pointsAtY: (0, $6327116045afe73c$export$98e628dec113755e),
        pointsAtZ: (0, $6327116045afe73c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        rev: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $6327116045afe73c$export$98e628dec113755e),
        specularExponent: (0, $6327116045afe73c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $6327116045afe73c$export$98e628dec113755e),
        strikethroughThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $6327116045afe73c$export$98e628dec113755e),
        strokeOpacity: (0, $6327116045afe73c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $6327116045afe73c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        tabIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $6327116045afe73c$export$98e628dec113755e),
        targetY: (0, $6327116045afe73c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $6327116045afe73c$export$98e628dec113755e),
        underlineThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $6327116045afe73c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $6327116045afe73c$export$98e628dec113755e),
        vMathematical: (0, $6327116045afe73c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $6327116045afe73c$export$98e628dec113755e),
        vIdeographic: (0, $6327116045afe73c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $6327116045afe73c$export$98e628dec113755e),
        vertOriginX: (0, $6327116045afe73c$export$98e628dec113755e),
        vertOriginY: (0, $6327116045afe73c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $57102789fbb4388b$export$5b10b3bc32d7efbc)
});



const $f7b1fe9153b66aca$export$2bd1230ec7600845 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $d677600be62c9ee2$export$e20c24a128671213 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $f66392ca00ae8b5e$export$32b9e4cec9c208e1)
});



const $2258d34ea2045e6e$export$f2913fe8983302e = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});





const $cad208d20be39d74$export$c0bb0b647f701bb5 = (0, $f22be46171b10c63$export$4950aa0f605343fb)([
    (0, $f6c2d7ac952f45ea$export$4d2d26490572750a),
    (0, $aed0b684443ef64e$export$c0bb0b647f701bb5),
    (0, $f7b1fe9153b66aca$export$2bd1230ec7600845),
    (0, $d677600be62c9ee2$export$e20c24a128671213),
    (0, $2258d34ea2045e6e$export$f2913fe8983302e)
], 'html');
const $cad208d20be39d74$export$7ed1367e7fa1ad68 = (0, $f22be46171b10c63$export$4950aa0f605343fb)([
    (0, $f6c2d7ac952f45ea$export$4d2d26490572750a),
    (0, $098f3c17bccabf6d$export$7ed1367e7fa1ad68),
    (0, $f7b1fe9153b66aca$export$2bd1230ec7600845),
    (0, $d677600be62c9ee2$export$e20c24a128671213),
    (0, $2258d34ea2045e6e$export$f2913fe8983302e)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $0d98344a9bfa0653$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $0d98344a9bfa0653$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $f27ef1e87b7b8987$exports = {};
"use strict";
var $f27ef1e87b7b8987$var$__importDefault = $f27ef1e87b7b8987$exports && $f27ef1e87b7b8987$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $f27ef1e87b7b8987$var$style_to_object_1 = $f27ef1e87b7b8987$var$__importDefault((parcelRequire("iBNfx")));
var $e3fbc6aceeefe6b0$exports = {};
"use strict";
Object.defineProperty($e3fbc6aceeefe6b0$exports, "__esModule", {
    value: true
});
$e3fbc6aceeefe6b0$exports.camelCase = void 0;
var $e3fbc6aceeefe6b0$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $e3fbc6aceeefe6b0$var$HYPHEN_REGEX = /-([a-z])/g;
var $e3fbc6aceeefe6b0$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $e3fbc6aceeefe6b0$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $e3fbc6aceeefe6b0$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $e3fbc6aceeefe6b0$var$skipCamelCase = function(property) {
    return !property || $e3fbc6aceeefe6b0$var$NO_HYPHEN_REGEX.test(property) || $e3fbc6aceeefe6b0$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $e3fbc6aceeefe6b0$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $e3fbc6aceeefe6b0$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $e3fbc6aceeefe6b0$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($e3fbc6aceeefe6b0$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($e3fbc6aceeefe6b0$var$MS_VENDOR_PREFIX_REGEX, $e3fbc6aceeefe6b0$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($e3fbc6aceeefe6b0$var$VENDOR_PREFIX_REGEX, $e3fbc6aceeefe6b0$var$trimHyphen);
    return property.replace($e3fbc6aceeefe6b0$var$HYPHEN_REGEX, $e3fbc6aceeefe6b0$var$capitalize);
};
$e3fbc6aceeefe6b0$exports.camelCase = $e3fbc6aceeefe6b0$var$camelCase;


/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $f27ef1e87b7b8987$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $f27ef1e87b7b8987$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $e3fbc6aceeefe6b0$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$f27ef1e87b7b8987$var$StyleToJS.default = $f27ef1e87b7b8987$var$StyleToJS;
$f27ef1e87b7b8987$exports = $f27ef1e87b7b8987$var$StyleToJS;


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $9861e7b4f8df2806$export$da309cdce9dc2a25 = $9861e7b4f8df2806$var$point('end');
const $9861e7b4f8df2806$export$771bf3e4949bfbee = $9861e7b4f8df2806$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $9861e7b4f8df2806$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $9861e7b4f8df2806$export$5880b8b5730aff45(node) {
    const start = $9861e7b4f8df2806$export$771bf3e4949bfbee(node);
    const end = $9861e7b4f8df2806$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ 
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $451965882c5a8799$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $451965882c5a8799$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $451965882c5a8799$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $451965882c5a8799$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $451965882c5a8799$var$point(point) {
    return $451965882c5a8799$var$index(point && point.line) + ':' + $451965882c5a8799$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $451965882c5a8799$var$position(pos) {
    return $451965882c5a8799$var$point(pos && pos.start) + '-' + $451965882c5a8799$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $451965882c5a8799$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $0aa9ed7423c10921$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, optionsOrParentOrPlace);
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $451965882c5a8799$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url = undefined;
    }
}
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.file = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.name = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.reason = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.message = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.stack = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.column = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.line = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ancestors = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.cause = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.fatal = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.place = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ruleId = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.source = undefined;


// To do: next major: `Object.hasOwn`.
const $bcaef7e086af7de5$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $bcaef7e086af7de5$var$emptyMap = new Map();
const $bcaef7e086af7de5$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $bcaef7e086af7de5$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $bcaef7e086af7de5$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $bcaef7e086af7de5$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $bcaef7e086af7de5$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $bcaef7e086af7de5$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $bcaef7e086af7de5$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $bcaef7e086af7de5$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$one(state, node, key) {
    if (node.type === 'element') return $bcaef7e086af7de5$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $bcaef7e086af7de5$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $bcaef7e086af7de5$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $bcaef7e086af7de5$var$mdxEsm(state, node);
    if (node.type === 'root') return $bcaef7e086af7de5$var$root(state, node, key);
    if (node.type === 'text') return $bcaef7e086af7de5$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $bcaef7e086af7de5$var$findComponentFromName(state, node.tagName, false);
    const props = $bcaef7e086af7de5$var$createElementProps(state, node);
    let children = $bcaef7e086af7de5$var$createChildren(state, node);
    if ($bcaef7e086af7de5$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $99728b3b7e804493$export$7af1228ff777d175)(child) : true;
    });
    $bcaef7e086af7de5$var$addNode(state, props, type, node);
    $bcaef7e086af7de5$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $bcaef7e086af7de5$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $bcaef7e086af7de5$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $bcaef7e086af7de5$var$findComponentFromName(state, node.name, true);
    const props = $bcaef7e086af7de5$var$createJsxElementProps(state, node);
    const children = $bcaef7e086af7de5$var$createChildren(state, node);
    $bcaef7e086af7de5$var$addNode(state, props, type, node);
    $bcaef7e086af7de5$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $bcaef7e086af7de5$var$addChildren(props, $bcaef7e086af7de5$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $bcaef7e086af7de5$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $bcaef7e086af7de5$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $bcaef7e086af7de5$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $bcaef7e086af7de5$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $bcaef7e086af7de5$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $bcaef7e086af7de5$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $bcaef7e086af7de5$var$own.call(node.properties, prop)) {
        const result = $bcaef7e086af7de5$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $bcaef7e086af7de5$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $bcaef7e086af7de5$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $bcaef7e086af7de5$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $bcaef7e086af7de5$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $bcaef7e086af7de5$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $bcaef7e086af7de5$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $bcaef7e086af7de5$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $bcaef7e086af7de5$var$createProperty(state, prop, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737)(value) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $bcaef7e086af7de5$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $bcaef7e086af7de5$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $a1ae9812302ca8ea$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $bcaef7e086af7de5$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f27ef1e87b7b8987$exports)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        const cause = /** @type {Error} */ error;
        const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $bcaef7e086af7de5$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $bcaef7e086af7de5$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $8ae047d5df63cb7f$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $8ae047d5df63cb7f$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {string | number} */ result.value;
        return $bcaef7e086af7de5$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $bcaef7e086af7de5$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $bcaef7e086af7de5$var$crashEstree(state, place) {
    const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $bcaef7e086af7de5$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $bcaef7e086af7de5$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($bcaef7e086af7de5$var$own.call(domCasing, from)) cssCasing[$bcaef7e086af7de5$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $bcaef7e086af7de5$var$transformStyleToCssCasing(from) {
    let to = from.replace($bcaef7e086af7de5$var$cap, $bcaef7e086af7de5$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $bcaef7e086af7de5$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $1389ec48924c67a6$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};




var $7fPBF = parcelRequire("7fPBF");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ 

/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $da74a7bb5b052f79$var$emptyOptions = {};
function $da74a7bb5b052f79$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $da74a7bb5b052f79$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml) {
    if ($da74a7bb5b052f79$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $da74a7bb5b052f79$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $da74a7bb5b052f79$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $da74a7bb5b052f79$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $da74a7bb5b052f79$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $da74a7bb5b052f79$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ 
/// <reference lib="dom" />
/* global document */ const $b2bf0a6c22a4700b$var$element = document.createElement('i');
function $b2bf0a6c22a4700b$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $b2bf0a6c22a4700b$var$element.innerHTML = characterReference;
    const character = $b2bf0a6c22a4700b$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $6d957c9e6a169a49$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $6d957c9e6a169a49$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $6d957c9e6a169a49$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $1c4ab323543eb9b7$var$hasOwnProperty = {}.hasOwnProperty;
function $1c4ab323543eb9b7$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$1c4ab323543eb9b7$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$1c4ab323543eb9b7$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $1c4ab323543eb9b7$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(existing, 0, 0, before);
}
function $1c4ab323543eb9b7$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$1c4ab323543eb9b7$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $a72b41c19fbe228c$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $1730a6ab3d7ab9f0$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $1730a6ab3d7ab9f0$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $1730a6ab3d7ab9f0$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $c580fc709a668807$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $9a96cd0c036af4eb$export$d65d6b62c24d5436 = $9a96cd0c036af4eb$var$regexCheck(/[A-Za-z]/);
const $9a96cd0c036af4eb$export$75c76db11865a9f4 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Za-z]/);
const $9a96cd0c036af4eb$export$4397998b34fe597d = $9a96cd0c036af4eb$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $9a96cd0c036af4eb$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e = $9a96cd0c036af4eb$var$regexCheck(/\d/);
const $9a96cd0c036af4eb$export$eca2752363989806 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Fa-f]/);
const $9a96cd0c036af4eb$export$35794a7d1db99380 = $9a96cd0c036af4eb$var$regexCheck(/[!-/:-@[-`{-~]/);
function $9a96cd0c036af4eb$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $9a96cd0c036af4eb$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $9a96cd0c036af4eb$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $9a96cd0c036af4eb$export$aa04114dd888a7a0 = $9a96cd0c036af4eb$var$regexCheck(RegExp("\\p{P}|\\p{S}", "u"));
const $9a96cd0c036af4eb$export$a0ff789c034ffdf4 = $9a96cd0c036af4eb$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $9a96cd0c036af4eb$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $b82d09afb4bbc7a9$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)($b82d09afb4bbc7a9$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $b82d09afb4bbc7a9$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $76c598c95b20c009$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $76c598c95b20c009$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $76c598c95b20c009$var$protocolSource = /^https?$/i;
function $76c598c95b20c009$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $1c4ab323543eb9b7$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, body);
        head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($76c598c95b20c009$var$hasOwnProperty.call(handles, kind) && handle) handle.call((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $c580fc709a668807$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$76c598c95b20c009$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $a72b41c19fbe228c$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $a27bcbb6afb3eadb$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $145b6cb5bda265c1$export$a7db06668cad9adb = {
    tokenize: $145b6cb5bda265c1$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $145b6cb5bda265c1$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 



const $3d8796971204dffa$export$5a7bfc01df82fcd1 = {
    tokenize: $3d8796971204dffa$var$initializeDocument
};
/** @type {Construct} */ const $3d8796971204dffa$var$containerConstruct = {
    tokenize: $3d8796971204dffa$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $3d8796971204dffa$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($3d8796971204dffa$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($3d8796971204dffa$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $3d8796971204dffa$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $30b85425f5f538a1$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $30b85425f5f538a1$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $30b85425f5f538a1$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 

/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $151e2065d6a4ba72$export$bd596157370df26e {
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $151e2065d6a4ba72$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $151e2065d6a4ba72$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $151e2065d6a4ba72$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $151e2065d6a4ba72$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $151e2065d6a4ba72$var$chunkedPush(this.left, removed.reverse());
        }
    }
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $151e2065d6a4ba72$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $7901602e44e77495$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $151e2065d6a4ba72$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $7901602e44e77495$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events.get(lineIndex)[1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $6d957c9e6a169a49$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $7901602e44e77495$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $728ee34a4e233cee$export$a7db06668cad9adb = {
    resolve: $728ee34a4e233cee$var$resolveContent,
    tokenize: $728ee34a4e233cee$var$tokenizeContent
};
/** @type {Construct} */ const $728ee34a4e233cee$var$continuationConstruct = {
    partial: true,
    tokenize: $728ee34a4e233cee$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $728ee34a4e233cee$var$resolveContent(events) {
    (0, $7901602e44e77495$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($728ee34a4e233cee$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $4320be06d95fd4d0$export$ccc7b0636abaffc3 = {
    tokenize: $4320be06d95fd4d0$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $4320be06d95fd4d0$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $30b85425f5f538a1$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $728ee34a4e233cee$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ 
const $009f2a13a0d178f2$export$50397835cbfdbc24 = {
    resolveAll: $009f2a13a0d178f2$var$createResolver()
};
const $009f2a13a0d178f2$export$22b082955e083ec3 = $009f2a13a0d178f2$var$initializeFactory('string');
const $009f2a13a0d178f2$export$6f093cfa640b7166 = $009f2a13a0d178f2$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $009f2a13a0d178f2$var$initializeFactory(field) {
    return {
        resolveAll: $009f2a13a0d178f2$var$createResolver(field === 'text' ? $009f2a13a0d178f2$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $009f2a13a0d178f2$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $009f2a13a0d178f2$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data.end)
            };
            data.end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $f81d41200564ef26$exports = {};

$parcel$export($f81d41200564ef26$exports, "document", function () { return $f81d41200564ef26$export$5a7bfc01df82fcd1; });
$parcel$export($f81d41200564ef26$exports, "contentInitial", function () { return $f81d41200564ef26$export$5a2181fb44b58173; });
$parcel$export($f81d41200564ef26$exports, "flowInitial", function () { return $f81d41200564ef26$export$cf8bead395eff824; });
$parcel$export($f81d41200564ef26$exports, "flow", function () { return $f81d41200564ef26$export$ccc7b0636abaffc3; });
$parcel$export($f81d41200564ef26$exports, "string", function () { return $f81d41200564ef26$export$22b082955e083ec3; });
$parcel$export($f81d41200564ef26$exports, "text", function () { return $f81d41200564ef26$export$6f093cfa640b7166; });
$parcel$export($f81d41200564ef26$exports, "insideSpan", function () { return $f81d41200564ef26$export$d44f260a3f9b69f5; });
$parcel$export($f81d41200564ef26$exports, "attentionMarkers", function () { return $f81d41200564ef26$export$b9c0b60d74426aea; });
$parcel$export($f81d41200564ef26$exports, "disable", function () { return $f81d41200564ef26$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $a0bda62677f8e9a6$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $ea09a4790e991212$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $ea09a4790e991212$var$resolveAllAttention,
    tokenize: $ea09a4790e991212$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $ea09a4790e991212$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].end);
            const end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[index][1].start);
            $ea09a4790e991212$var$movePoint(start, -use);
            $ea09a4790e991212$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].end),
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, openingSequence.start),
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, closingSequence.end)
            };
            events[open][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, openingSequence.start);
            events[index][1].start = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ea09a4790e991212$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $ea09a4790e991212$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $5d74961dcf69642f$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $5d74961dcf69642f$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5d74961dcf69642f$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $9a96cd0c036af4eb$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $5b7191973b2dcb30$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation
    },
    exit: $5b7191973b2dcb30$var$exit,
    name: 'blockQuote',
    tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($5b7191973b2dcb30$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $5b7191973b2dcb30$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $be85b25963329d93$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $be85b25963329d93$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $be85b25963329d93$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $9a96cd0c036af4eb$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $3f5b13d75c9b46b1$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $3f5b13d75c9b46b1$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3f5b13d75c9b46b1$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $9a96cd0c036af4eb$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $9a96cd0c036af4eb$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $9a96cd0c036af4eb$export$75c76db11865a9f4) && !(0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $834069fabf19784a$var$nonLazyContinuation = {
    partial: true,
    tokenize: $834069fabf19784a$var$tokenizeNonLazyContinuation
};
const $834069fabf19784a$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $834069fabf19784a$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $7dbe9fe18b3b23b2$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $7dbe9fe18b3b23b2$var$furtherStart = {
    partial: true,
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.attempt($7dbe9fe18b3b23b2$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $23d5e8c756b561fa$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $23d5e8c756b561fa$var$previous,
    resolve: $23d5e8c756b561fa$var$resolveCodeText,
    tokenize: $23d5e8c756b561fa$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $23d5e8c756b561fa$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $23d5e8c756b561fa$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $23d5e8c756b561fa$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $a5b0165eceaa5b2a$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $5b1b1349c9302e3d$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $3b751ecfea53c49c$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $65f43375f77b595c$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $03db4060f53ac021$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $03db4060f53ac021$var$tokenizeDefinition
};
/** @type {Construct} */ const $03db4060f53ac021$var$titleBefore = {
    partial: true,
    tokenize: $03db4060f53ac021$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($03db4060f53ac021$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2db70170e88ebee0$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $2db70170e88ebee0$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2db70170e88ebee0$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $83113747934b3ae6$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $83113747934b3ae6$var$resolveHeadingAtx,
    tokenize: $83113747934b3ae6$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $83113747934b3ae6$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $6d957c9e6a169a49$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $83113747934b3ae6$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $b9e56abd53b703db$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $b9e56abd53b703db$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $bc2cbab316b16c92$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $bc2cbab316b16c92$var$resolveToHtmlFlow,
    tokenize: $bc2cbab316b16c92$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $bc2cbab316b16c92$var$blankLineBefore = {
    partial: true,
    tokenize: $bc2cbab316b16c92$var$tokenizeBlankLineBefore
};
const $bc2cbab316b16c92$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $bc2cbab316b16c92$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $b9e56abd53b703db$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($bc2cbab316b16c92$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($bc2cbab316b16c92$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d4159befe711bc18$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $d4159befe711bc18$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d4159befe711bc18$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 








const $2761660aaca3721f$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $2761660aaca3721f$var$resolveAllLabelEnd,
    resolveTo: $2761660aaca3721f$var$resolveToLabelEnd,
    tokenize: $2761660aaca3721f$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $2761660aaca3721f$var$resourceConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeResource
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceFullConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceCollapsedConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $6d957c9e6a169a49$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].start),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].start),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open + offset + 2][1].end),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($2761660aaca3721f$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($2761660aaca3721f$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($2761660aaca3721f$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $39595bc63cd49799$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll,
    tokenize: $39595bc63cd49799$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $39595bc63cd49799$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $036fa9de6a4e2994$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll,
    tokenize: $036fa9de6a4e2994$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $036fa9de6a4e2994$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $309179153cfedf16$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $309179153cfedf16$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $309179153cfedf16$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $e46429feccf3186d$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $e46429feccf3186d$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e46429feccf3186d$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $3c31a37b3e3d082a$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $3c31a37b3e3d082a$var$tokenizeListContinuation
    },
    exit: $3c31a37b3e3d082a$var$tokenizeListEnd,
    name: 'list',
    tokenize: $3c31a37b3e3d082a$var$tokenizeListStart
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$indentConstruct = {
    partial: true,
    tokenize: $3c31a37b3e3d082a$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $e46429feccf3186d$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($3c31a37b3e3d082a$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt($3c31a37b3e3d082a$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $3c31a37b3e3d082a$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $151c8a7318d441a4$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $151c8a7318d441a4$var$resolveToSetextUnderline,
    tokenize: $151c8a7318d441a4$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $151c8a7318d441a4$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[content][1].start),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $151c8a7318d441a4$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $f81d41200564ef26$export$5a7bfc01df82fcd1 = {
    [42]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [43]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [45]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [48]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [49]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [50]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [51]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [52]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [53]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [54]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [55]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [56]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [57]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [62]: (0, $5b7191973b2dcb30$export$200dcd0a5903c968)
};
const $f81d41200564ef26$export$5a2181fb44b58173 = {
    [91]: (0, $03db4060f53ac021$export$69f215ed977cdb73)
};
const $f81d41200564ef26$export$cf8bead395eff824 = {
    [-2]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [-1]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [32]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853)
};
const $f81d41200564ef26$export$ccc7b0636abaffc3 = {
    [35]: (0, $83113747934b3ae6$export$3871e9deb360695c),
    [42]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [45]: [
        (0, $151c8a7318d441a4$export$e104e2de391dfde9),
        (0, $e46429feccf3186d$export$ba7b13e047416c03)
    ],
    [60]: (0, $bc2cbab316b16c92$export$476ac411cb7d0d8f),
    [61]: (0, $151c8a7318d441a4$export$e104e2de391dfde9),
    [95]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [96]: (0, $834069fabf19784a$export$c23e4921f8d87e7c),
    [126]: (0, $834069fabf19784a$export$c23e4921f8d87e7c)
};
const $f81d41200564ef26$export$22b082955e083ec3 = {
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [92]: (0, $be85b25963329d93$export$2005478564e78d96)
};
const $f81d41200564ef26$export$6f093cfa640b7166 = {
    [-5]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-4]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-3]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [33]: (0, $39595bc63cd49799$export$3d754936e25aa5f5),
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [42]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [60]: [
        (0, $5d74961dcf69642f$export$17ddf85e4c916ad6),
        (0, $d4159befe711bc18$export$398af27f284914fe)
    ],
    [91]: (0, $036fa9de6a4e2994$export$5c0cee0701a3b584),
    [92]: [
        (0, $2db70170e88ebee0$export$86c573ab9e06f418),
        (0, $be85b25963329d93$export$2005478564e78d96)
    ],
    [93]: (0, $2761660aaca3721f$export$470a5dafbbf62654),
    [95]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [96]: (0, $23d5e8c756b561fa$export$d24f93e715f9df88)
};
const $f81d41200564ef26$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ea09a4790e991212$export$45b92471da762af7),
        (0, $009f2a13a0d178f2$export$50397835cbfdbc24)
    ]
};
const $f81d41200564ef26$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $f81d41200564ef26$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $e090088a8e1afd2b$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $e090088a8e1afd2b$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $e090088a8e1afd2b$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $6d957c9e6a169a49$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $e090088a8e1afd2b$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $e090088a8e1afd2b$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $9dfba146f4c3c794$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $1c4ab323543eb9b7$export$86a865d89ef3c690)([
        $f81d41200564ef26$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $145b6cb5bda265c1$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $3d8796971204dffa$export$5a7bfc01df82fcd1)),
        flow: create((0, $4320be06d95fd4d0$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $009f2a13a0d178f2$export$22b082955e083ec3)),
        text: create((0, $009f2a13a0d178f2$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $e090088a8e1afd2b$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $faf817751c9db3c6$export$bd0e6e1378a871d7(events) {
    while(!(0, $7901602e44e77495$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $2dbc8c8d3cee1d06$var$search = /[\0\t\n\r]/g;
function $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $2dbc8c8d3cee1d06$var$search.lastIndex = startPosition;
            match = $2dbc8c8d3cee1d06$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $b990c273e4f741f3$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $76c598c95b20c009$export$ef7acd7185315e22)(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $516ec3b0ba9da2c8$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $516ec3b0ba9da2c8$export$a0fb664af7d0cc44(value) {
    return value.replace($516ec3b0ba9da2c8$var$characterEscapeOrReference, $516ec3b0ba9da2c8$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $516ec3b0ba9da2c8$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $a72b41c19fbe228c$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)($2) || $0;
}





const $dc140a31dd8ab4b3$var$own = {}.hasOwnProperty;
function $dc140a31dd8ab4b3$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $dc140a31dd8ab4b3$var$compiler(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $dc140a31dd8ab4b3$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $dc140a31dd8ab4b3$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($dc140a31dd8ab4b3$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $dc140a31dd8ab4b3$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $dc140a31dd8ab4b3$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $dc140a31dd8ab4b3$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $dc140a31dd8ab4b3$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $516ec3b0ba9da2c8$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $a72b41c19fbe228c$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $dc140a31dd8ab4b3$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $dc140a31dd8ab4b3$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $dc140a31dd8ab4b3$var$configure(combined, value);
        else $dc140a31dd8ab4b3$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $dc140a31dd8ab4b3$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($dc140a31dd8ab4b3$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $dc140a31dd8ab4b3$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $4f339a22525673d0$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $dc140a31dd8ab4b3$export$d744d789c09bfde6)(doc, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, self.data('settings'), options), {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}


/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ 
/**
 * @import {Nodes as HastNodes} from 'hast'
 * @import {Nodes as MdastNodes} from 'mdast'
 * @import {Options} from './state.js'
 */ 
/**
 * @import {ElementContent, Element} from 'hast'
 * @import {State} from './state.js'
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ 

const $2b1365c4997070ae$export$1cd1943b3a73bbe8 = -1;
const $2b1365c4997070ae$export$a44b4f3d5b73db95 = 0;
const $2b1365c4997070ae$export$b119f07080a207ba = 1;
const $2b1365c4997070ae$export$8b8a958a7f6f130c = 2;
const $2b1365c4997070ae$export$501a7fac1df67a49 = 3;
const $2b1365c4997070ae$export$cd2b220b1ea851b2 = 4;
const $2b1365c4997070ae$export$ce970371e0e850bc = 5;
const $2b1365c4997070ae$export$5e8f180ef0142226 = 6;
const $2b1365c4997070ae$export$103bedf43ba882db = 7;
const $2b1365c4997070ae$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $293fd6bfda9276e2$var$env = typeof self === 'object' ? self : globalThis;
const $293fd6bfda9276e2$var$guard = (name, init)=>{
    switch(name){
        case 'Function':
        case 'SharedWorker':
        case 'Worker':
        case 'eval':
        case 'setInterval':
        case 'setTimeout':
            throw new TypeError('unable to deserialize ' + name);
    }
    return new $293fd6bfda9276e2$var$env[name](init);
};
const $293fd6bfda9276e2$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $2b1365c4997070ae$export$a44b4f3d5b73db95:
            case 0, $2b1365c4997070ae$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $2b1365c4997070ae$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $2b1365c4997070ae$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $2b1365c4997070ae$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $2b1365c4997070ae$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $2b1365c4997070ae$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $2b1365c4997070ae$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $2b1365c4997070ae$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(typeof $293fd6bfda9276e2$var$env[name] === 'function' ? $293fd6bfda9276e2$var$guard(name, message) : new Error(message), index);
                }
            case 0, $2b1365c4997070ae$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as($293fd6bfda9276e2$var$guard(type, value), index);
    };
    return unpair;
};
const $293fd6bfda9276e2$export$efcd34ab6248d3cd = (serialized)=>$293fd6bfda9276e2$var$deserializer(new Map, serialized)(0);



const $623b953cac82f88a$var$EMPTY = '';
const { toString: $623b953cac82f88a$var$toString } = {};
const { keys: $623b953cac82f88a$var$keys } = Object;
const $623b953cac82f88a$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $2b1365c4997070ae$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $623b953cac82f88a$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $2b1365c4997070ae$export$b119f07080a207ba),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $2b1365c4997070ae$export$8b8a958a7f6f130c),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $2b1365c4997070ae$export$501a7fac1df67a49),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $2b1365c4997070ae$export$cd2b220b1ea851b2),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $2b1365c4997070ae$export$ce970371e0e850bc),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $2b1365c4997070ae$export$5e8f180ef0142226),
                $623b953cac82f88a$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $2b1365c4997070ae$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $2b1365c4997070ae$export$b119f07080a207ba),
        asString
    ];
    if (value instanceof Error) return [
        (0, $2b1365c4997070ae$export$103bedf43ba882db),
        value.name || 'Error'
    ];
    return [
        (0, $2b1365c4997070ae$export$8b8a958a7f6f130c),
        asString
    ];
};
const $623b953cac82f88a$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $2b1365c4997070ae$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $623b953cac82f88a$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $623b953cac82f88a$var$typeOf(value);
        switch(TYPE){
            case 0, $2b1365c4997070ae$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $2b1365c4997070ae$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $2b1365c4997070ae$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $2b1365c4997070ae$export$b119f07080a207ba:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $2b1365c4997070ae$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $623b953cac82f88a$var$keys(value))if (strict || !$623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $2b1365c4997070ae$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    isNaN(value.getTime()) ? $623b953cac82f88a$var$EMPTY : value.toISOString()
                ], value);
            case 0, $2b1365c4997070ae$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $2b1365c4997070ae$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(key)) || $623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $2b1365c4997070ae$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$623b953cac82f88a$var$shouldSkip($623b953cac82f88a$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $623b953cac82f88a$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $623b953cac82f88a$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $e46c0242ff031819$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $293fd6bfda9276e2$export$efcd34ab6248d3cd)((0, $623b953cac82f88a$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $293fd6bfda9276e2$export$efcd34ab6248d3cd)((0, $623b953cac82f88a$export$dfdc1655ccc5b9cb)(any, options));



function $5f8ac0136b7180f6$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $5f8ac0136b7180f6$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $5f8ac0136b7180f6$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $5f8ac0136b7180f6$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $5f8ac0136b7180f6$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        const content = state.all(definition);
        const id = String(definition.identifier).toUpperCase();
        const safeId = (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $e46c0242ff031819$export$2e2bcd8739ae039)(footnoteLabelProperties)), {
                    id: 'footnote-label'
                }),
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @import {
 *   ElementContent as HastElementContent,
 *   Element as HastElement,
 *   Nodes as HastNodes,
 *   Properties as HastProperties,
 *   RootContent as HastRootContent,
 *   Text as HastText
 * } from 'hast'
 * @import {
 *   Definition as MdastDefinition,
 *   FootnoteDefinition as MdastFootnoteDefinition,
 *   Nodes as MdastNodes,
 *   Parents as MdastParents
 * } from 'mdast'
 * @import {VFile} from 'vfile'
 * @import {
 *   FootnoteBackContentTemplate,
 *   FootnoteBackLabelTemplate
 * } from './footer.js'
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 


/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $312c10cea7b70433$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $312c10cea7b70433$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$312c10cea7b70433$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $312c10cea7b70433$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $312c10cea7b70433$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $312c10cea7b70433$var$ok;
    if (typeof test === 'function') return $312c10cea7b70433$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $312c10cea7b70433$var$anyFactory(test) : // narrows to `Array`.
    $312c10cea7b70433$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $312c10cea7b70433$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $312c10cea7b70433$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $312c10cea7b70433$export$9c68d69a4c5bbcf9(tests[index]);
    return $312c10cea7b70433$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $312c10cea7b70433$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $312c10cea7b70433$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $312c10cea7b70433$var$typeFactory(check) {
    return $312c10cea7b70433$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $312c10cea7b70433$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($312c10cea7b70433$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $312c10cea7b70433$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $312c10cea7b70433$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $1e49ba1db9d29029$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $9ef2eaca0b34953c$var$empty = [];
const $9ef2eaca0b34953c$export$f4d8133c446fe484 = true;
const $9ef2eaca0b34953c$export$7f100f842f565dc9 = false;
const $9ef2eaca0b34953c$export$8773f85c2fb2c116 = 'skip';
function $9ef2eaca0b34953c$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $1e49ba1db9d29029$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $9ef2eaca0b34953c$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $9ef2eaca0b34953c$var$toResult(visitor(node, parents));
                if (result[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $9ef2eaca0b34953c$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $9ef2eaca0b34953c$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $9ef2eaca0b34953c$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $9ef2eaca0b34953c$var$empty : [
        value
    ];
}


function $2ca43c18c27b56fa$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @import {Handlers} from '../state.js'
 */ /**
 * @import {Element} from 'hast'
 * @import {Blockquote} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2009e735e4920922$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {Break} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $caf09a68931aae43$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Code} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b5c217a518855008$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    // Someone can write `js&#x20;python&#x9;ruby`.
    const language = node.lang ? node.lang.split(/\s+/) : [];
    // GH/CM still drop the non-first languages.
    if (language.length > 0) properties.className = [
        'language-' + language[0]
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @import {Element} from 'hast'
 * @import {Delete} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9739c1e1cf800b5e$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Emphasis} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c0bba787c55d4212$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {FootnoteReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $5af8976c830555c1$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @import {Element} from 'hast'
 * @import {Heading} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9b6df163a26bd000$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Html} from 'mdast'
 * @import {State} from '../state.js'
 * @import {Raw} from '../../index.js'
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */ function $f59721a0d8aa9c1f$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ImageReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
/**
 * @import {ElementContent} from 'hast'
 * @import {Reference, Nodes} from 'mdast'
 * @import {State} from './state.js'
 */ /**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */ function $adeec68f555ea12e$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $b377321b20712ea8$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $adeec68f555ea12e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Image} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $2bb84a02d2957974$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {InlineCode} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $772ddadd8e054087$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {LinkReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 

function $63d9a7473ae80c48$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $adeec68f555ea12e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Link} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $a668870950e44a11$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ListItem, Parents} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $eb748566f942a1fa$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $eb748566f942a1fa$var$listLoose(parent) : $eb748566f942a1fa$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $eb748566f942a1fa$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $eb748566f942a1fa$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $eb748566f942a1fa$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {List} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7581156d9e04fe28$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Paragraph} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $20fbb56018958335$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Parents as HastParents, Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */ function $2af4be4c3af73f2b$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Strong} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8df89fc7fe3cfe9c$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Table} from 'mdast'
 * @import {Element} from 'hast'
 * @import {State} from '../state.js'
 */ 
function $9257848335846de3$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, ElementContent, Properties} from 'hast'
 * @import {Parents, TableRow} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $06793005ec3da281$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {TableCell} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6181448ff3679c4d$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element as HastElement, Text as HastText} from 'hast'
 * @import {Text as MdastText} from 'mdast'
 * @import {State} from '../state.js'
 */ const $012eac5e07020bbc$var$tab = 9 /* `\t` */ ;
const $012eac5e07020bbc$var$space = 32 /* ` ` */ ;
function $012eac5e07020bbc$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($012eac5e07020bbc$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($012eac5e07020bbc$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $012eac5e07020bbc$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $012eac5e07020bbc$var$tab || code === $012eac5e07020bbc$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $012eac5e07020bbc$var$tab || code === $012eac5e07020bbc$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $32a26ed6da9265ed$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $012eac5e07020bbc$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {ThematicBreak} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $eb5ff7d2182720ae$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $e276fa0624fad11d$export$455ce229eb3d2472 = {
    blockquote: $2009e735e4920922$export$67dc04e652a298ca,
    break: (0, $caf09a68931aae43$export$371da9dd35aba193),
    code: $b5c217a518855008$export$6565f9f03506010b,
    delete: (0, $9739c1e1cf800b5e$export$19426ff118fe8be),
    emphasis: $c0bba787c55d4212$export$bef81ba411953b51,
    footnoteReference: $5af8976c830555c1$export$7f87ee744075c1ba,
    heading: $9b6df163a26bd000$export$46e4a324ac90507f,
    html: $f59721a0d8aa9c1f$export$c0bb0b647f701bb5,
    imageReference: $b377321b20712ea8$export$f281796f6bc3b8db,
    image: $2bb84a02d2957974$export$5c452ff88e35e47d,
    inlineCode: $772ddadd8e054087$export$91b9bee19a0d8569,
    linkReference: $63d9a7473ae80c48$export$e6c469b1b7b2bc6a,
    link: $a668870950e44a11$export$9c30223ca0a664fb,
    listItem: $eb748566f942a1fa$export$76c7e83ecc9cdf05,
    list: $7581156d9e04fe28$export$8837f4fc672e936d,
    paragraph: $20fbb56018958335$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $2af4be4c3af73f2b$export$e8e78c978b129247,
    strong: $8df89fc7fe3cfe9c$export$59ae2c325a998f89,
    table: $9257848335846de3$export$9852986a3ec5f6a0,
    tableCell: $6181448ff3679c4d$export$e1e720e5f4603e6a,
    tableRow: $06793005ec3da281$export$ce666bf02318c957,
    text: $32a26ed6da9265ed$export$6f093cfa640b7166,
    thematicBreak: $eb5ff7d2182720ae$export$ba7b13e047416c03,
    toml: $e276fa0624fad11d$var$ignore,
    yaml: $e276fa0624fad11d$var$ignore,
    definition: $e276fa0624fad11d$var$ignore,
    footnoteDefinition: $e276fa0624fad11d$var$ignore
};
// Return nothing for nodes that are ignored.
function $e276fa0624fad11d$var$ignore() {
    return undefined;
}


const $e7336a21b70de7b0$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $e7336a21b70de7b0$var$emptyOptions = {};
function $e7336a21b70de7b0$export$e6a0daad8304de(tree, options) {
    const settings = options || $e7336a21b70de7b0$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $e276fa0624fad11d$export$455ce229eb3d2472), settings.handlers);
    /** @type {State} */ const state = {
        all: all,
        applyData: $e7336a21b70de7b0$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $e7336a21b70de7b0$var$patch,
        wrap: $e7336a21b70de7b0$export$4997ffc0176396a6
    };
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($e7336a21b70de7b0$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children } = node, shallow = (0, $8901fc92b5563702$export$71511d61b312f219)(node, [
                    "children"
                ]);
                const result = (0, $e46c0242ff031819$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $e46c0242ff031819$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $e7336a21b70de7b0$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $e7336a21b70de7b0$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $e7336a21b70de7b0$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $e7336a21b70de7b0$var$patch(from, to) {
    if (from.position) to.position = (0, $9861e7b4f8df2806$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $e7336a21b70de7b0$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $e46c0242ff031819$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $e7336a21b70de7b0$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($e7336a21b70de7b0$var$own.call(data, 'hProperties') || $e7336a21b70de7b0$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $e7336a21b70de7b0$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $e7336a21b70de7b0$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $43774b39a057500d$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $e7336a21b70de7b0$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $5f8ac0136b7180f6$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $74ce0141155f6a3a$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $43774b39a057500d$export$c0e4c5cf07538633)(tree, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            file: file
        }, options));
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $43774b39a057500d$export$c0e4c5cf07538633)(tree, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            file: file
        }, destination || options));
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $2fd75206f7b34a41$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $ce3b58bef1324512$exports = {};
'use strict';
var $ce3b58bef1324512$var$hasOwn = Object.prototype.hasOwnProperty;
var $ce3b58bef1324512$var$toStr = Object.prototype.toString;
var $ce3b58bef1324512$var$defineProperty = Object.defineProperty;
var $ce3b58bef1324512$var$gOPD = Object.getOwnPropertyDescriptor;
var $ce3b58bef1324512$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $ce3b58bef1324512$var$toStr.call(arr) === '[object Array]';
};
var $ce3b58bef1324512$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $ce3b58bef1324512$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $ce3b58bef1324512$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $ce3b58bef1324512$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $ce3b58bef1324512$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $ce3b58bef1324512$var$setProperty = function setProperty(target, options) {
    if ($ce3b58bef1324512$var$defineProperty && options.name === '__proto__') $ce3b58bef1324512$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $ce3b58bef1324512$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$ce3b58bef1324512$var$hasOwn.call(obj, name)) return void 0;
        else if ($ce3b58bef1324512$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $ce3b58bef1324512$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$ce3b58bef1324512$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $ce3b58bef1324512$var$getProperty(target, name);
            copy = $ce3b58bef1324512$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($ce3b58bef1324512$var$isPlainObject(copy) || (copyIsArray = $ce3b58bef1324512$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $ce3b58bef1324512$var$isArray(src) ? src : [];
                    } else clone = src && $ce3b58bef1324512$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $ce3b58bef1324512$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $ce3b58bef1324512$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $89bf888846328aa6$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $f4c69d6c22bcde86$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $f4c69d6c22bcde86$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $f4c69d6c22bcde86$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $3f77da5648f21d15$export$500c965389abde9c = {
    basename: $3f77da5648f21d15$var$basename,
    dirname: $3f77da5648f21d15$var$dirname,
    extname: $3f77da5648f21d15$var$extname,
    join: $3f77da5648f21d15$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $3f77da5648f21d15$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $3f77da5648f21d15$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    let firstNonSlashEnd = -1;
    let extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$dirname(path) {
    $3f77da5648f21d15$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $3f77da5648f21d15$var$extname(path) {
    $3f77da5648f21d15$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $3f77da5648f21d15$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $3f77da5648f21d15$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $3f77da5648f21d15$var$normalize(path) {
    $3f77da5648f21d15$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $3f77da5648f21d15$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $3f77da5648f21d15$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $1faf6772e03c3c94$export$77f0ef6e088922ec = {
    cwd: $1faf6772e03c3c94$var$cwd
};
function $1faf6772e03c3c94$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $95cef6ea1b5451c9$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $fefa7e5b02919ba3$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $95cef6ea1b5451c9$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $fefa7e5b02919ba3$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $fefa7e5b02919ba3$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $365ad175729fa366$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $365ad175729fa366$export$93dff69eb10dc7ce {
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $365ad175729fa366$var$assertNonEmpty(basename, 'basename');
        $365ad175729fa366$var$assertPart(basename, 'basename');
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $365ad175729fa366$var$assertPath(this.basename, 'dirname');
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $365ad175729fa366$var$assertPart(extname, 'extname');
        $365ad175729fa366$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $95cef6ea1b5451c9$export$8304a22d431f958)(path)) path = (0, $fefa7e5b02919ba3$export$9b2b676c902de799)(path);
        $365ad175729fa366$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $3f77da5648f21d15$export$500c965389abde9c).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $365ad175729fa366$var$assertNonEmpty(stem, 'stem');
        $365ad175729fa366$var$assertPart(stem, 'stem');
        this.path = (0, $3f77da5648f21d15$export$500c965389abde9c).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $95cef6ea1b5451c9$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $365ad175729fa366$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $1faf6772e03c3c94$export$77f0ef6e088922ec).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $365ad175729fa366$var$order.length){
            const field = $365ad175729fa366$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? [
                ...options[field]
            ] : options[field];
        }
        /** @type {string} */ let field;
        // Set non-path related properties.
        for(field in options)// @ts-expect-error: fine to set other things.
        if (!$365ad175729fa366$var$order.includes(field)) // @ts-expect-error: fine to set other things.
        this[field] = options[field];
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $365ad175729fa366$var$assertPart(part, name) {
    if (part && part.includes((0, $3f77da5648f21d15$export$500c965389abde9c).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $3f77da5648f21d15$export$500c965389abde9c).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $365ad175729fa366$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $365ad175729fa366$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $365ad175729fa366$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


const $e4c6cc9ff888c1a4$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $82354957eb1a51f9$var$own = {}.hasOwnProperty;
class $82354957eb1a51f9$export$c30cd198d731db19 extends (0, $e4c6cc9ff888c1a4$export$b7de1db558410812) {
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $82354957eb1a51f9$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $82354957eb1a51f9$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $82354957eb1a51f9$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $82354957eb1a51f9$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $82354957eb1a51f9$var$vfile(file);
        const parser = this.parser || this.Parser;
        $82354957eb1a51f9$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $82354957eb1a51f9$var$assertParser('process', this.parser || this.Parser);
        $82354957eb1a51f9$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $82354957eb1a51f9$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($82354957eb1a51f9$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $82354957eb1a51f9$var$assertParser('processSync', this.parser || this.Parser);
        $82354957eb1a51f9$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $82354957eb1a51f9$var$assertDone('processSync', 'process', complete);
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $2fd75206f7b34a41$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $82354957eb1a51f9$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $82354957eb1a51f9$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $82354957eb1a51f9$var$assertDone('runSync', 'run', complete);
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $2fd75206f7b34a41$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $82354957eb1a51f9$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $82354957eb1a51f9$var$assertCompiler('stringify', compiler);
        $82354957eb1a51f9$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $82354957eb1a51f9$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $89bf888846328aa6$export$2e2bcd8739ae039)(currentPrimary) && (0, $89bf888846328aa6$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $f4c69d6c22bcde86$export$91b56f5ca106aa43)();
    }
}
const $82354957eb1a51f9$export$7cc1b2fe10c52bb = new $82354957eb1a51f9$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $82354957eb1a51f9$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $82354957eb1a51f9$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $82354957eb1a51f9$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $82354957eb1a51f9$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $89bf888846328aa6$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $82354957eb1a51f9$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $82354957eb1a51f9$var$vfile(value) {
    return $82354957eb1a51f9$var$looksLikeAVFile(value) ? value : new (0, $365ad175729fa366$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $82354957eb1a51f9$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $82354957eb1a51f9$var$looksLikeAValue(value) {
    return typeof value === 'string' || $82354957eb1a51f9$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $82354957eb1a51f9$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




const $09cf8ac2a6e57519$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $09cf8ac2a6e57519$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $09cf8ac2a6e57519$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $09cf8ac2a6e57519$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $09cf8ac2a6e57519$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $09cf8ac2a6e57519$export$7460c8b7e4ce9582(options) {
    const processor = $09cf8ac2a6e57519$var$createProcessor(options);
    const file = $09cf8ac2a6e57519$var$createFile(options);
    return $09cf8ac2a6e57519$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $09cf8ac2a6e57519$export$445edbd7f2c65a8c(options) {
    const processor = $09cf8ac2a6e57519$var$createProcessor(options);
    const file = $09cf8ac2a6e57519$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $09cf8ac2a6e57519$var$post(tree, options);
}
function $09cf8ac2a6e57519$export$915021c692d253a2(options) {
    const processor = $09cf8ac2a6e57519$var$createProcessor(options);
    const [error, setError] = (0, $7fPBF.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $7fPBF.useState)(/** @type {Root | undefined} */ undefined);
    (0, $7fPBF.useEffect)(/* c8 ignore next 7 -- hooks are client-only. */ function() {
        const file = $09cf8ac2a6e57519$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            setError(error);
            setTree(tree);
        });
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    /* c8 ignore next -- hooks are client-only. */ if (error) throw error;
    /* c8 ignore next -- hooks are client-only. */ return tree ? $09cf8ac2a6e57519$var$post(tree, options) : (0, $7fPBF.createElement)((0, $824c049f32d4395d$exports.Fragment));
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $09cf8ac2a6e57519$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $09cf8ac2a6e57519$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $09cf8ac2a6e57519$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options.remarkRehypeOptions, $09cf8ac2a6e57519$var$emptyRemarkRehypeOptions) : $09cf8ac2a6e57519$var$emptyRemarkRehypeOptions;
    const processor = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $4f339a22525673d0$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $74ce0141155f6a3a$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $09cf8ac2a6e57519$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $365ad175729fa366$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $09cf8ac2a6e57519$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $09cf8ac2a6e57519$export$ca5e94754123e2f3;
    for (const deprecation of $09cf8ac2a6e57519$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $09cf8ac2a6e57519$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    // Wrap in `div` if there’s a class name.
    if (options.className) tree = {
        type: 'element',
        tagName: 'div',
        properties: {
            className: options.className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ tree.type === 'root' ? tree.children : [
            tree
        ]
    };
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $bcaef7e086af7de5$export$59c10052b2dee561)(tree, {
        Fragment: $824c049f32d4395d$exports.Fragment,
        components: // @ts-expect-error
        // React components are allowed to return numbers,
        // but not according to the types in hast-util-to-jsx-runtime
        components,
        ignoreInvalidStyle: true,
        jsx: $824c049f32d4395d$exports.jsx,
        jsxs: $824c049f32d4395d$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $1389ec48924c67a6$export$de3e062aedff083a)if (Object.hasOwn((0, $1389ec48924c67a6$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $1389ec48924c67a6$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $09cf8ac2a6e57519$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $09cf8ac2a6e57519$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}


/**
 * @import {Root} from 'mdast'
 * @import {Options} from 'remark-gfm'
 * @import {} from 'remark-parse'
 * @import {} from 'remark-stringify'
 * @import {Processor} from 'unified'
 */ /**
 * @import {Extension as FromMarkdownExtension} from 'mdast-util-from-markdown'
 * @import {Options} from 'mdast-util-gfm'
 * @import {Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $b227513681bd728a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}




/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $439fd7e08f00e217$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}




function $10de114def6cf069$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $10de114def6cf069$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, 'text', visitor);
    /** @type {BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: 'text',
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $10de114def6cf069$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $10de114def6cf069$var$toExpression(tuple[0]),
            $10de114def6cf069$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $10de114def6cf069$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $439fd7e08f00e217$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $10de114def6cf069$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $a508b14f9fabfff1$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ const $a508b14f9fabfff1$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $a508b14f9fabfff1$export$b6afdfff2163546f() {
    return {
        transforms: [
            $a508b14f9fabfff1$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $a508b14f9fabfff1$var$enterLiteralAutolink,
            literalAutolinkEmail: $a508b14f9fabfff1$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $a508b14f9fabfff1$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $a508b14f9fabfff1$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $a508b14f9fabfff1$var$exitLiteralAutolink,
            literalAutolinkEmail: $a508b14f9fabfff1$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $a508b14f9fabfff1$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $a508b14f9fabfff1$var$exitLiteralAutolinkWww
        }
    };
}
function $a508b14f9fabfff1$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $a508b14f9fabfff1$var$inConstruct,
                notInConstruct: $a508b14f9fabfff1$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $a508b14f9fabfff1$var$inConstruct,
                notInConstruct: $a508b14f9fabfff1$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $a508b14f9fabfff1$var$inConstruct,
                notInConstruct: $a508b14f9fabfff1$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a508b14f9fabfff1$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $a508b14f9fabfff1$var$transformGfmAutolinkLiterals(tree) {
    (0, $10de114def6cf069$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $a508b14f9fabfff1$var$findUrl
        ],
        [
            RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"),
            $a508b14f9fabfff1$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $a508b14f9fabfff1$var$findUrl(_, protocol, domain, path, match) {
    let prefix = '';
    // Not an expected previous character.
    if (!$a508b14f9fabfff1$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$a508b14f9fabfff1$var$isCorrectDomain(domain)) return false;
    const parts = $a508b14f9fabfff1$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $a508b14f9fabfff1$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$a508b14f9fabfff1$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $a508b14f9fabfff1$var$isCorrectDomain(domain) {
    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $a508b14f9fabfff1$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(')');
    const openingParens = (0, $b227513681bd728a$export$fa42eaa97a352e23)(url, '(');
    let closingParens = (0, $b227513681bd728a$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $a508b14f9fabfff1$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || (0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {ToMarkdownOptions} from 'mdast-util-gfm-footnote'
 * @import {
 *   Handle as ToMarkdownHandle,
 *   Map,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 * @import {FootnoteDefinition, FootnoteReference} from 'mdast'
 */ 

$c376fab83e3ca8f4$var$footnoteReference.peek = $c376fab83e3ca8f4$var$footnoteReferencePeek;
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c376fab83e3ca8f4$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/** @type {ToMarkdownHandle} */ function $c376fab83e3ca8f4$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $c376fab83e3ca8f4$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteReference');
    const subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        after: ']',
        before: value
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
function $c376fab83e3ca8f4$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteCallString: $c376fab83e3ca8f4$var$enterFootnoteCallString,
            gfmFootnoteCall: $c376fab83e3ca8f4$var$enterFootnoteCall,
            gfmFootnoteDefinitionLabelString: $c376fab83e3ca8f4$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $c376fab83e3ca8f4$var$enterFootnoteDefinition
        },
        exit: {
            gfmFootnoteCallString: $c376fab83e3ca8f4$var$exitFootnoteCallString,
            gfmFootnoteCall: $c376fab83e3ca8f4$var$exitFootnoteCall,
            gfmFootnoteDefinitionLabelString: $c376fab83e3ca8f4$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $c376fab83e3ca8f4$var$exitFootnoteDefinition
        }
    };
}
function $c376fab83e3ca8f4$export$3727766a73a6c09f(options) {
    // To do: next major: change default.
    let firstLineBlank = false;
    if (options && options.firstLineBlank) firstLineBlank = true;
    return {
        handlers: {
            footnoteDefinition: footnoteDefinition,
            footnoteReference: $c376fab83e3ca8f4$var$footnoteReference
        },
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'label',
                    'phrasing',
                    'reference'
                ]
            }
        ]
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */ function footnoteDefinition(node, _, state, info) {
        const tracker = state.createTracker(info);
        let value = tracker.move('[^');
        const exit = state.enter('footnoteDefinition');
        const subexit = state.enter('label');
        value += tracker.move(state.safe(state.associationId(node), {
            before: value,
            after: ']'
        }));
        subexit();
        value += tracker.move(']:');
        if (node.children && node.children.length > 0) {
            tracker.shift(4);
            value += tracker.move((firstLineBlank ? '\n' : ' ') + state.indentLines(state.containerFlow(node, tracker.current()), firstLineBlank ? $c376fab83e3ca8f4$var$mapAll : $c376fab83e3ca8f4$var$mapExceptFirst));
        }
        exit();
        return value;
    }
}
/** @type {Map} */ function $c376fab83e3ca8f4$var$mapExceptFirst(line, index, blank) {
    return index === 0 ? line : $c376fab83e3ca8f4$var$mapAll(line, index, blank);
}
/** @type {Map} */ function $c376fab83e3ca8f4$var$mapAll(line, index, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ 

const $09e40cfc169f6d05$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$09e40cfc169f6d05$var$handleDelete.peek = $09e40cfc169f6d05$var$peekDelete;
function $09e40cfc169f6d05$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $09e40cfc169f6d05$var$enterStrikethrough
        },
        exit: {
            strikethrough: $09e40cfc169f6d05$var$exitStrikethrough
        }
    };
}
function $09e40cfc169f6d05$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $09e40cfc169f6d05$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $09e40cfc169f6d05$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $09e40cfc169f6d05$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $09e40cfc169f6d05$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $09e40cfc169f6d05$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tracker.current()), {
        before: value,
        after: '~'
    }));
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $09e40cfc169f6d05$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 


// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $04345556f6d0def5$var$defaultStringLength(value) {
    return value.length;
}
function $04345556f6d0def5$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $04345556f6d0def5$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $04345556f6d0def5$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $04345556f6d0def5$var$toAlignment(align[columnIndex]);
    else {
        const code = $04345556f6d0def5$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $04345556f6d0def5$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $04345556f6d0def5$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $c22d6b26d8763f1a$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $c22d6b26d8763f1a$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $c22d6b26d8763f1a$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $faa99a565617de42$export$78221a09424368d(stack, pattern) {
    return $faa99a565617de42$var$listInScope(stack, pattern.inConstruct, true) && !$faa99a565617de42$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $faa99a565617de42$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $b44c63001bb6e43e$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $faa99a565617de42$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ 
/**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $b732c3de0f6b9a59$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $976a1661809365d1$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $16d1e1d0e9bb535c$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $c9de17fde5da4e09$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $16d1e1d0e9bb535c$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $976a1661809365d1$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $c9de17fde5da4e09$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $b732c3de0f6b9a59$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: ' ',
            encode: [
                '`'
            ]
        }, tracker.current())));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '\n',
            encode: [
                '`'
            ]
        }, tracker.current())));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $c9de17fde5da4e09$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $ce55bd1707ed4560$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $de907278b9522dcf$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current())));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: node.title ? ' ' : '\n'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $75785ad8dfd7e058$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $ef164935741e67b3$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $e3ad60aa0bb5edc4$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(outside);
    const insideKind = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$5363ce757c0f934c$export$bef81ba411953b51.peek = $5363ce757c0f934c$var$emphasisPeek;
function $5363ce757c0f934c$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $75785ad8dfd7e058$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        after: marker,
        before: before
    }, tracker.current())));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $5363ce757c0f934c$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ 

function $57ca23d123f29cd8$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $9ef2eaca0b34953c$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $b9838158d361d84b$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $57ca23d123f29cd8$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tracker.current()), {
            before: '\n',
            after: '\n'
        }));
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: '# ',
        after: '\n'
    }, tracker.current()));
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $9a83b6191accc866$export$c0bb0b647f701bb5.peek = $9a83b6191accc866$var$htmlPeek;
function $9a83b6191accc866$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $9a83b6191accc866$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 

$d5640795fae1711f$export$5c452ff88e35e47d.peek = $d5640795fae1711f$var$imagePeek;
function $d5640795fae1711f$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current())));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: node.title ? ' ' : ')'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $d5640795fae1711f$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ 
$9ab1f1e75e4d33d3$export$f281796f6bc3b8db.peek = $9ab1f1e75e4d33d3$var$imageReferencePeek;
function $9ab1f1e75e4d33d3$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $9ab1f1e75e4d33d3$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $d83732a415638d5c$export$91b9bee19a0d8569.peek = $d83732a415638d5c$var$inlineCodePeek;
function $d83732a415638d5c$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $d83732a415638d5c$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 

/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $fa39aaa691787db5$export$74cae3045e3179ed(node, state) {
    const raw = (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$44386f6ce5814f19$export$9c30223ca0a664fb.peek = $44386f6ce5814f19$var$linkPeek;
function $44386f6ce5814f19$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $fa39aaa691787db5$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']('
    }, tracker.current())));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: node.title ? ' ' : ')'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $44386f6ce5814f19$var$linkPeek(node, _, state) {
    return (0, $fa39aaa691787db5$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ 
$6fcde372b87d3fed$export$e6c469b1b7b2bc6a.peek = $6fcde372b87d3fed$var$linkReferencePeek;
function $6fcde372b87d3fed$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $6fcde372b87d3fed$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $f52261392897ff44$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $ae37c79b31867a05$export$e6803bf0889262a1(state) {
    const bullet = (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $82eeac05fc7d31a0$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $01ecb0fec064563b$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $83184e8a3561368a$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $82eeac05fc7d31a0$export$98d522b78eddc19b)(state) : (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $ae37c79b31867a05$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $01ecb0fec064563b$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $902901864b46e6e0$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $6e73d61bc3f6f849$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $902901864b46e6e0$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $5dcdf38c0853bd5d$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $76e22c02785b163c$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $ec9cfa703f4340b2$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $76e22c02785b163c$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $6d8e2a72f1cdda8f$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$50fff993476f6ef3$export$59ae2c325a998f89.peek = $50fff993476f6ef3$var$strongPeek;
function $50fff993476f6ef3$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $6d8e2a72f1cdda8f$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        after: marker,
        before: before
    }, tracker.current())));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $50fff993476f6ef3$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $7d79792942bf3874$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $9c901976bd352085$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $8f3edd6f95dc34f7$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $01ecb0fec064563b$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $9c901976bd352085$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $da19da82921559d2$export$8f34ce051745d39e = {
    blockquote: $c22d6b26d8763f1a$export$67dc04e652a298ca,
    break: (0, $b44c63001bb6e43e$export$371da9dd35aba193),
    code: $c9de17fde5da4e09$export$6565f9f03506010b,
    definition: $de907278b9522dcf$export$69f215ed977cdb73,
    emphasis: $5363ce757c0f934c$export$bef81ba411953b51,
    hardBreak: $b44c63001bb6e43e$export$371da9dd35aba193,
    heading: $b9838158d361d84b$export$46e4a324ac90507f,
    html: $9a83b6191accc866$export$c0bb0b647f701bb5,
    image: $d5640795fae1711f$export$5c452ff88e35e47d,
    imageReference: $9ab1f1e75e4d33d3$export$f281796f6bc3b8db,
    inlineCode: $d83732a415638d5c$export$91b9bee19a0d8569,
    link: $44386f6ce5814f19$export$9c30223ca0a664fb,
    linkReference: $6fcde372b87d3fed$export$e6c469b1b7b2bc6a,
    list: $83184e8a3561368a$export$8837f4fc672e936d,
    listItem: $6e73d61bc3f6f849$export$76c7e83ecc9cdf05,
    paragraph: $5dcdf38c0853bd5d$export$9c206ddddb32a9b,
    root: $ec9cfa703f4340b2$export$e8e78c978b129247,
    strong: $50fff993476f6ef3$export$59ae2c325a998f89,
    text: $7d79792942bf3874$export$6f093cfa640b7166,
    thematicBreak: $8f3edd6f95dc34f7$export$ba7b13e047416c03
};


function $27370860b3e1d456$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $27370860b3e1d456$var$enterTable,
            tableData: $27370860b3e1d456$var$enterCell,
            tableHeader: $27370860b3e1d456$var$enterCell,
            tableRow: $27370860b3e1d456$var$enterRow
        },
        exit: {
            codeText: $27370860b3e1d456$var$exitCodeText,
            table: $27370860b3e1d456$var$exitTable,
            tableData: $27370860b3e1d456$var$exit,
            tableHeader: $27370860b3e1d456$var$exit,
            tableRow: $27370860b3e1d456$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterTable(token) {
    const align = token._align;
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $27370860b3e1d456$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $27370860b3e1d456$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $27370860b3e1d456$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, info), {
            before: around,
            after: around
        }));
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $04345556f6d0def5$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $da19da82921559d2$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 


function $d3a60ff58d98f77f$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $d3a60ff58d98f77f$var$exitCheck,
            taskListCheckValueUnchecked: $d3a60ff58d98f77f$var$exitCheck,
            paragraph: $d3a60ff58d98f77f$var$exitParagraphWithTaskListItem
        }
    };
}
function $d3a60ff58d98f77f$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $d3a60ff58d98f77f$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d3a60ff58d98f77f$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d3a60ff58d98f77f$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $d3a60ff58d98f77f$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $da19da82921559d2$export$8f34ce051745d39e).listItem(node, parent, state, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, info, tracker.current()));
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $fa527d008df0ac0a$export$95adae814eb7433e() {
    return [
        (0, $a508b14f9fabfff1$export$b6afdfff2163546f)(),
        (0, $c376fab83e3ca8f4$export$c9d5ad4bdf6ff801)(),
        (0, $09e40cfc169f6d05$export$34d64e709dd0b9bb)(),
        (0, $27370860b3e1d456$export$8bd0ec8ecf6adb7d)(),
        (0, $d3a60ff58d98f77f$export$a427a608608b215f)()
    ];
}
function $fa527d008df0ac0a$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $a508b14f9fabfff1$export$d3ace9096b01c39d)(),
            (0, $c376fab83e3ca8f4$export$3727766a73a6c09f)(options),
            (0, $09e40cfc169f6d05$export$1632835bd2c84956)(),
            (0, $27370860b3e1d456$export$dafcad76ea6e0045)(options),
            (0, $d3a60ff58d98f77f$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
const $2c344f86004a8679$var$wwwPrefix = {
    tokenize: $2c344f86004a8679$var$tokenizeWwwPrefix,
    partial: true
};
const $2c344f86004a8679$var$domain = {
    tokenize: $2c344f86004a8679$var$tokenizeDomain,
    partial: true
};
const $2c344f86004a8679$var$path = {
    tokenize: $2c344f86004a8679$var$tokenizePath,
    partial: true
};
const $2c344f86004a8679$var$trail = {
    tokenize: $2c344f86004a8679$var$tokenizeTrail,
    partial: true
};
const $2c344f86004a8679$var$emailDomainDotTrail = {
    tokenize: $2c344f86004a8679$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $2c344f86004a8679$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $2c344f86004a8679$var$tokenizeWwwAutolink,
    previous: $2c344f86004a8679$var$previousWww
};
const $2c344f86004a8679$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $2c344f86004a8679$var$tokenizeProtocolAutolink,
    previous: $2c344f86004a8679$var$previousProtocol
};
const $2c344f86004a8679$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $2c344f86004a8679$var$tokenizeEmailAutolink,
    previous: $2c344f86004a8679$var$previousEmail
};
/** @type {ConstructRecord} */ const $2c344f86004a8679$var$text = {};
function $2c344f86004a8679$export$608123d9b549151() {
    return {
        text: $2c344f86004a8679$var$text
    };
}
/** @type {Code} */ let $2c344f86004a8679$var$code = 48;
// Add alphanumerics.
while($2c344f86004a8679$var$code < 123){
    $2c344f86004a8679$var$text[$2c344f86004a8679$var$code] = $2c344f86004a8679$var$emailAutolink;
    $2c344f86004a8679$var$code++;
    if ($2c344f86004a8679$var$code === 58) $2c344f86004a8679$var$code = 65;
    else if ($2c344f86004a8679$var$code === 91) $2c344f86004a8679$var$code = 97;
}
$2c344f86004a8679$var$text[43] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[45] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[46] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[95] = $2c344f86004a8679$var$emailAutolink;
$2c344f86004a8679$var$text[72] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$protocolAutolink
];
$2c344f86004a8679$var$text[104] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$protocolAutolink
];
$2c344f86004a8679$var$text[87] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$wwwAutolink
];
$2c344f86004a8679$var$text[119] = [
    $2c344f86004a8679$var$emailAutolink,
    $2c344f86004a8679$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$2c344f86004a8679$var$gfmAtext(code) || !$2c344f86004a8679$var$previousEmail.call(self, self.previous) || $2c344f86004a8679$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($2c344f86004a8679$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($2c344f86004a8679$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$2c344f86004a8679$var$previousWww.call(self, self.previous) || $2c344f86004a8679$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($2c344f86004a8679$var$wwwPrefix, effects.attempt($2c344f86004a8679$var$domain, effects.attempt($2c344f86004a8679$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = '';
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $2c344f86004a8679$var$previousProtocol.call(self, self.previous) && !$2c344f86004a8679$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code) || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || (0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($2c344f86004a8679$var$domain, effects.attempt($2c344f86004a8679$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($2c344f86004a8679$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($2c344f86004a8679$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2c344f86004a8679$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $2c344f86004a8679$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $2c344f86004a8679$var$previousProtocol(code) {
    return !(0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $2c344f86004a8679$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $2c344f86004a8679$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $2c344f86004a8679$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $2c344f86004a8679$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $0682bb87e6ae324b$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $0682bb87e6ae324b$var$literalAutolinkEmail,
            literalAutolinkHttp: $0682bb87e6ae324b$var$literalAutolinkHttp,
            literalAutolinkWww: $0682bb87e6ae324b$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $0682bb87e6ae324b$var$literalAutolinkWww(token) {
    $0682bb87e6ae324b$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $0682bb87e6ae324b$var$literalAutolinkEmail(token) {
    $0682bb87e6ae324b$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $0682bb87e6ae324b$var$literalAutolinkHttp(token) {
    $0682bb87e6ae324b$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $0682bb87e6ae324b$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 



const $f74b812b1b41bff1$var$indent = {
    tokenize: $f74b812b1b41bff1$var$tokenizeIndent,
    partial: true
};
function $f74b812b1b41bff1$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                name: 'gfmFootnoteDefinition',
                tokenize: $f74b812b1b41bff1$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $f74b812b1b41bff1$var$tokenizeDefinitionContinuation
                },
                exit: $f74b812b1b41bff1$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                name: 'gfmFootnoteCall',
                tokenize: $f74b812b1b41bff1$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                name: 'gfmPotentialFootnoteCall',
                add: 'after',
                tokenize: $f74b812b1b41bff1$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $f74b812b1b41bff1$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $f74b812b1b41bff1$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), ok, effects.attempt($f74b812b1b41bff1$var$indent, ok, nok));
}
/** @type {Exiter} */ function $f74b812b1b41bff1$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f74b812b1b41bff1$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

const $e3a6d41f5be8d102$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $e3a6d41f5be8d102$var$emptyOptions = {};
function $e3a6d41f5be8d102$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $e3a6d41f5be8d102$export$a731a1f6cf81900c(options) {
    const config = options || $e3a6d41f5be8d102$var$emptyOptions;
    const label = config.label || 'Footnotes';
    const labelTagName = config.labelTagName || 'h2';
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $e3a6d41f5be8d102$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData('gfmFootnoteDefinitions');
                const footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                const tightStack = this.getData('tightStack');
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$e3a6d41f5be8d102$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData('gfmFootnoteCallOrder');
                let counts = this.getData('gfmFootnoteCallCounts');
                const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null () {
                const calls = this.getData('gfmFootnoteCallOrder') || [];
                const counts = this.getData('gfmFootnoteCallCounts') || {};
                const definitions = this.getData('gfmFootnoteDefinitions') || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    const reference = references.join(' ');
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag('</li>');
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $0f83fff5c7ab5a13$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $5d0cc46fa6aace08$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough () {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $fb088f9b3e1902f4$export$9348908dd4518b4a {
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $fb088f9b3e1902f4$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $fb088f9b3e1902f4$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $b6d029dbee6a13e7$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $fe86da6860750184$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $fe86da6860750184$var$tokenizeTable,
                resolveAll: $fe86da6860750184$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fe86da6860750184$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $fe86da6860750184$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $fb088f9b3e1902f4$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $fe86da6860750184$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $fe86da6860750184$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $fe86da6860750184$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $b6d029dbee6a13e7$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $fe86da6860750184$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $fe86da6860750184$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $fe86da6860750184$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $fe86da6860750184$var$getPoint(context.events, range[2]);
        const relatedEnd = $fe86da6860750184$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $fe86da6860750184$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $fe86da6860750184$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $fe86da6860750184$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $fe86da6860750184$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ const $d05dddf934c23ce5$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $d05dddf934c23ce5$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody () {
                this.tag('<tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $d05dddf934c23ce5$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $d05dddf934c23ce5$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow () {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $d05dddf934c23ce5$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader () {
                const tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData('tableAlign');
                let tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $d05dddf934c23ce5$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $d05dddf934c23ce5$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $a41dbafcf7a614bf$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $a41dbafcf7a614bf$var$reText = new RegExp('^' + $a41dbafcf7a614bf$var$reFlow.source, 'i');
function $a41dbafcf7a614bf$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $a41dbafcf7a614bf$var$exitHtmlData.call(this, token, $a41dbafcf7a614bf$var$reFlow);
            },
            htmlTextData (token) {
                $a41dbafcf7a614bf$var$exitHtmlData.call(this, token, $a41dbafcf7a614bf$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $a41dbafcf7a614bf$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $783b238101f8100d$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $783b238101f8100d$var$tokenizeTasklistCheck
};
function $783b238101f8100d$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $783b238101f8100d$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $783b238101f8100d$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $783b238101f8100d$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $783b238101f8100d$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $300c8f9ec1306002$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag('/>');
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $0e954356959e94f6$export$59ffe8c4d7a4aab2(options) {
    return (0, $1c4ab323543eb9b7$export$86a865d89ef3c690)([
        (0, $2c344f86004a8679$export$608123d9b549151)(),
        (0, $f74b812b1b41bff1$export$c82499b6656305df)(),
        (0, $0f83fff5c7ab5a13$export$8bbec8ea1400a00e)(options),
        (0, $fe86da6860750184$export$e36cebda627bf2dd)(),
        (0, $783b238101f8100d$export$2912e8b2802475ff)()
    ]);
}
function $0e954356959e94f6$export$6983b82e6105d62a(options) {
    return (0, $1c4ab323543eb9b7$export$eaf8c406dfb0a620)([
        (0, $0682bb87e6ae324b$export$999603f1f1c3d2f9)(),
        (0, $e3a6d41f5be8d102$export$a731a1f6cf81900c)(options),
        (0, $5d0cc46fa6aace08$export$58acedca46108820)(),
        (0, $d05dddf934c23ce5$export$c64626c032567c7f)(),
        (0, $a41dbafcf7a614bf$export$c9bf87ea36d00682)(),
        (0, $300c8f9ec1306002$export$4b6a13e2af1b08ed)()
    ]);
}


/** @type {Options} */ const $78aec921ddca40c1$var$emptyOptions = {};
function $78aec921ddca40c1$export$2e2bcd8739ae039(options) {
    // @ts-expect-error: TS is wrong about `this`.
    // eslint-disable-next-line unicorn/no-this-assignment
    const self = /** @type {Processor<Root>} */ this;
    const settings = options || $78aec921ddca40c1$var$emptyOptions;
    const data = self.data();
    const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push((0, $0e954356959e94f6$export$59ffe8c4d7a4aab2)(settings));
    fromMarkdownExtensions.push((0, $fa527d008df0ac0a$export$95adae814eb7433e)());
    toMarkdownExtensions.push((0, $fa527d008df0ac0a$export$ea77de6901e7c72b)(settings));
}





let $10952db78fee7c4f$var$_ = (t)=>t, $10952db78fee7c4f$var$t, $10952db78fee7c4f$var$t1, $10952db78fee7c4f$var$t2;
const $10952db78fee7c4f$export$5c24b9f68c75af1d = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $09cf8ac2a6e57519$export$7460c8b7e4ce9582))($10952db78fee7c4f$var$t || ($10952db78fee7c4f$var$t = $10952db78fee7c4f$var$_`
    font-weight: 400;
    font-size: 1.313rem; // 21px
    color: ${0};
    line-height: 2rem; // 32px
    a {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
        display: block;
        color: ${0};
        text-decoration: underline;
        :hover {
            color: ${0};
            text-decoration: none;
        }
    }
`), (props)=>props.theme.color.textBody, (props)=>props.theme.color.secondary, (props)=>props.theme.color.secondary);
const $10952db78fee7c4f$export$2def7183994512e9 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($10952db78fee7c4f$var$t1 || ($10952db78fee7c4f$var$t1 = $10952db78fee7c4f$var$_`
    ${0};
    color: ${0};
    padding: 2rem 0;
    line-height: 2rem; // 32px
    & a,
    * a {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
        display: block;
        color: ${0};
        text-decoration: underline;
        :hover {
            color: ${0};
            text-decoration: none;
        }
    }
    & code,
    * code {
        background-color: ${0};
        font-family: 'Courier New', Courier, monospace;
    }
    & pre,
    * pre {
        overflow-x: auto;
        background-color: ${0};
        border-radius: 0.5rem;
        padding: 1rem 1rem 1rem 1rem !important;
    }
    & h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: ${0};
        font-weight: 900;
    }
    & h1 {
        ${0};
    }
    & h2 {
        font-size: 1.75rem; // 28px
        line-height: 2.25rem; // 36px
    }
    & h3 {
        font-size: 1.5rem; // 24px
        line-height: 2rem; // 32px
    }
    & h4 {
        font-size: 1.25rem; // 20px
        line-height: 1.75rem; // 28px
    }
    & h5 {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
    }
    & h6 {
        font-size: 1rem; // 16px
        line-height: 1.313rem; // 21px
    }
    & ul,
    ol,
    * ul,
    * ol {
        padding-left: 2rem;
    }
`), (0, $b091aef3a32d2bd8$export$c29b4f740eefd6d8), (props)=>props.theme.color.textBody, (props)=>props.theme.color.link, (props)=>props.theme.color.link, (props)=>props.theme.color.background + 90, (props)=>props.theme.color.card, (props)=>props.theme.color.text, (0, $b091aef3a32d2bd8$export$53e784b1f50184bf));
const $10952db78fee7c4f$export$c59b91b8761c2f2d = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($10952db78fee7c4f$var$t2 || ($10952db78fee7c4f$var$t2 = $10952db78fee7c4f$var$_`
    p {
        margin: 0 0 0.5em;
    }
    p:last-child {
        margin-bottom: 0;
    }
    h1,
    h2,
    h3,
    h4 {
        margin: 0.75em 0 0.375em;
        font-weight: 600;
    }
    h1 {
        font-size: 1.1em;
    }
    h2 {
        font-size: 1em;
    }
    h3 {
        font-size: 0.95em;
    }
    ul,
    ol {
        margin: 0.25em 0 0.5em;
        padding-left: 1.25em;
    }
    li {
        margin-bottom: 0.15em;
    }
    code {
        background: ${0};
        border-radius: 4px;
        padding: 0.1em 0.35em;
        font-size: 0.875em;
        font-family: 'Fira Code', 'Consolas', monospace;
    }
    pre {
        background: ${0};
        border-radius: 6px;
        padding: 0.75em 1em;
        overflow-x: auto;
        margin: 0.5em 0;
        code {
            background: none;
            padding: 0;
        }
    }
    blockquote {
        border-left: 3px solid ${0};
        margin: 0.5em 0;
        padding: 0.25em 0.75em;
        opacity: 0.85;
    }
    table {
        border-collapse: collapse;
        width: 100%;
        font-size: 0.875em;
        margin: 0.5em 0;
    }
    th,
    td {
        border: 1px solid ${0};
        padding: 0.375em 0.625em;
    }
    th {
        font-weight: 600;
        background: ${0};
    }
    a {
        color: ${0};
        text-decoration: none;
    }
    a:hover {
        text-decoration: underline;
    }
    hr {
        border: none;
        border-top: 1px solid ${0};
        margin: 0.75em 0;
    }
    strong {
        font-weight: 600;
    }
    em {
        font-style: italic;
    }
`), (p)=>p.theme.color.cardHover, (p)=>p.theme.color.cardHover, (p)=>p.theme.color.accent, (p)=>p.theme.color.border, (p)=>p.theme.color.cardHover, (p)=>p.theme.color.accent, (p)=>p.theme.color.border);


let $c88a36d69c05f5c8$var$_ = (t)=>t, $c88a36d69c05f5c8$var$t;
const $c88a36d69c05f5c8$var$MarkdownLinkRenderer = (props)=>{
    if (props.href.startsWith('http')) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        href: props.href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: props.children
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        href: props.href,
        children: props.children
    });
};
const $c88a36d69c05f5c8$var$NotificationCard = (props)=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getRelativeTime = (0, $1e6a0781013949e7$export$2e2bcd8739ae039)();
    let { isRead: isRead, id: id, title: title, subtitle: subtitle, markdown: markdown, notificationType: notificationType, isDisabled: isDisabled, startDate: startDate } = props;
    const handleMarkAsRead = ()=>{
        isRead = true;
        (0, $3521ff40d609c2ed$export$aa94277a9804d2bd).getState().markNotificationRead(id);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$4a703ded2a7a3e59), {
        "data-isread": isRead,
        id: id,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c88a36d69c05f5c8$var$ContentWrap, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$d9f4918700223049), {
                    as: "h2",
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ea6aee68c7b1694f), {
                    children: subtitle
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10952db78fee7c4f$export$2def7183994512e9), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09cf8ac2a6e57519$export$7460c8b7e4ce9582), {
                        remarkPlugins: [
                            (0, $78aec921ddca40c1$export$2e2bcd8739ae039)
                        ],
                        components: {
                            a: $c88a36d69c05f5c8$var$MarkdownLinkRenderer
                        },
                        children: markdown
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$e30e93a3651e4e64), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                            children: [
                                "Posted: ",
                                getRelativeTime(new Date(startDate))
                            ]
                        }),
                        isRead ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: "read",
                                size: 16,
                                ariaLabel: t('common:notifications.seen')
                            })
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "control",
                            disabled: isRead,
                            onClick: handleMarkAsRead,
                            children: isRead ? t('common:notifications.seen') : t('common:notifications.markAsRead')
                        })
                    ]
                })
            ]
        })
    });
};
const $c88a36d69c05f5c8$var$ContentWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c88a36d69c05f5c8$var$t || ($c88a36d69c05f5c8$var$t = $c88a36d69c05f5c8$var$_``));
var $c88a36d69c05f5c8$export$2e2bcd8739ae039 = $c88a36d69c05f5c8$var$NotificationCard;




const $5fd89f49783ce974$var$NotificationListing = ({ notifications: notifications })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!notifications) return null;
    if (notifications.length < 1) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        title: t('common:notifications.empty')
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: notifications.map((notification)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c88a36d69c05f5c8$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, notification), notification.id))
    });
};
var $5fd89f49783ce974$export$2e2bcd8739ae039 = $5fd89f49783ce974$var$NotificationListing;




function $9a22a8e524cd97e1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const notifications = (0, $3521ff40d609c2ed$export$aa94277a9804d2bd)((state)=>state.notifications);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:notifications.center'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fd89f49783ce974$export$2e2bcd8739ae039), {
                notifications: notifications
            })
        ]
    });
}










const $3d257c68ce43608e$export$d79fc0b00008bd8d = 'https://cephable.com/pricing/#matrix';
const $3d257c68ce43608e$export$ed2c078912602c20 = {
    personal: {
        icon: {
            light: 'personalLogo',
            dark: 'personalLogoWhite'
        },
        title: 'common:billing.personal.titleLong',
        description: 'common:billing.personal.description',
        licenseType: 'personal'
    },
    isPlusAccess: {
        icon: {
            light: 'plusLogo',
            dark: 'plusLogoWhite'
        },
        title: 'common:billing.isPlusAccess.titleLong',
        description: 'common:billing.isPlusAccess.description',
        // trial: `${getBaseApiUrl()}/trial/plus`,
        licenseType: 'isPlusAccess'
    },
    isEmployeeAccess: {
        icon: {
            light: 'proLogo',
            dark: 'proLogoWhite'
        },
        title: 'common:billing.isEmployeeAccess.titleLong',
        description: 'common:billing.isEmployeeAccess.description',
        trial: `${(0, $07546889aef07ebc$export$df8e085683bf7fe4)()}/trial`,
        licenseType: 'isEmployeeAccess'
    },
    isStudentAccess: {
        icon: {
            light: 'eduLogo',
            dark: 'eduLogoWhite'
        },
        title: 'common:billing.isStudentAccess.titleLong',
        description: 'common:billing.isStudentAccess.description',
        // trial: `${getBaseApiUrl()}/trial/education`,
        licenseType: 'isStudentAccess'
    },
    isDeveloperAccess: {
        icon: {
            light: 'sdkLogo',
            dark: 'sdkLogoWhite'
        },
        title: 'common:billing.isDeveloperAccess.titleLong',
        description: 'common:billing.isDeveloperAccess.description',
        // trial: `${getBaseApiUrl()}/trial/developers`,
        licenseType: 'isDeveloperAccess'
    }
};
const $3d257c68ce43608e$export$3dc32300594beeaf = [
    'common:billing.isEmployeeAccess.supportedFeatures.features.0',
    'common:billing.isPlusAccess.supportedFeatures.features.0',
    'common:billing.isPlusAccess.supportedFeatures.features.1',
    'common:billing.isPlusAccess.supportedFeatures.features.2',
    'common:billing.isPlusAccess.supportedFeatures.features.3'
];






var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");










let $a5e039f9955fc75e$var$_ = (t)=>t, $a5e039f9955fc75e$var$t;
const $a5e039f9955fc75e$var$CardCenteredContent = (_param)=>{
    var { title: title, description: description, name: name, size: size = 50, children: children } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "description",
        "name",
        "size",
        "children"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$401042fa3f49d26), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a5e039f9955fc75e$var$CenteredCardText, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    name: name,
                    size: size
                }, restProps)),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: description
                }),
                children
            ]
        })
    }));
};
const $a5e039f9955fc75e$var$CenteredCardText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$9de46b28c4f6c978))($a5e039f9955fc75e$var$t || ($a5e039f9955fc75e$var$t = $a5e039f9955fc75e$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-grow: 1;
`));
var $a5e039f9955fc75e$export$2e2bcd8739ae039 = $a5e039f9955fc75e$var$CardCenteredContent;



function $fd9b8885d8abdd3b$export$2e2bcd8739ae039({ organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const onDialogCancel = ()=>{
        setShowDialog(false);
    };
    if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailVerified)) return null;
    const description = organizationId ? t('common:license.activate.description') : t('common:license.activate.descriptionLong');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
                title: t('common:license.activate.title'),
                description: description,
                name: "orgAuthClient",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    startIcon: "plusLight",
                    onClick: ()=>setShowDialog(true),
                    children: t('common:license.activate.button')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e26231f066199887$export$2e2bcd8739ae039), {
                open: showDialog,
                onCancel: onDialogCancel,
                organizationId: organizationId
            })
        ]
    });
}





















var $7fPBF = parcelRequire("7fPBF");


let $d0f22230e48d02ba$var$_ = (t)=>t, $d0f22230e48d02ba$var$t;
function $d0f22230e48d02ba$export$2e2bcd8739ae039(_param) {
    var { licenseType: licenseType, size: size = 250 } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "licenseType",
        "size"
    ]);
    const { theme: theme } = (0, $7fPBF.useContext)((0, $c6dc2c2d62651942$export$2c657da244d00bd6));
    const isLightMode = theme === 'light';
    const iconName = isLightMode ? (0, $3d257c68ce43608e$export$ed2c078912602c20)[licenseType].icon.light : (0, $3d257c68ce43608e$export$ed2c078912602c20)[licenseType].icon.dark;
    var _iconMap_iconName;
    const svgToRender = (_iconMap_iconName = (0, $3adbcb77e640770e$export$6d49a893c897b0cc)[iconName]) !== null && _iconMap_iconName !== void 0 ? _iconMap_iconName : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d0f22230e48d02ba$var$IconContainer, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        $size: size
    }, restProps), {
        children: [
            svgToRender,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: (0, $3d257c68ce43608e$export$ed2c078912602c20)[licenseType].title
            })
        ]
    }));
}
const $d0f22230e48d02ba$var$IconContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)('span')($d0f22230e48d02ba$var$t || ($d0f22230e48d02ba$var$t = $d0f22230e48d02ba$var$_`
    color: ${0};
    display: inline-block;
    line-height: 0;
    svg {
        width: ${0};
        height: 100%;
    }
`), (props)=>props.$color || 'inherit', (props)=>props.$size + 'px');



let $d4c1fc4a3d4947e8$var$_ = (t)=>t, $d4c1fc4a3d4947e8$var$t, $d4c1fc4a3d4947e8$var$t1, $d4c1fc4a3d4947e8$var$t2, $d4c1fc4a3d4947e8$var$t3, $d4c1fc4a3d4947e8$var$t4, $d4c1fc4a3d4947e8$var$t5, $d4c1fc4a3d4947e8$var$t6;
function $d4c1fc4a3d4947e8$export$2e2bcd8739ae039({ product: product, purchaseOption: purchaseOption, supportedFeatures: supportedFeatures, statusText: statusText, $variant: $variant = 'default', organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const hasNoOrgMemberships = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.hasNoOrgMemberships);
    const userLicenseType = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.userLicenseType);
    // Determine if we should show trial upgrade option (ie Plus Trial -> Pro Trial)
    const currPriorityIdx = (0, $eec5c3b697f8e81e$export$9e1a6fca7c3450cd).indexOf(userLicenseType);
    const nextPriorityIdx = (0, $eec5c3b697f8e81e$export$9e1a6fca7c3450cd).indexOf(product.licenseType);
    const isTrialUpgrade = currPriorityIdx !== -1 && nextPriorityIdx !== -1 && nextPriorityIdx > currPriorityIdx;
    const showTrial = hasNoOrgMemberships || isTrialUpgrade;
    let label = t('common:billing.subscription.billedMonthly');
    if ((purchaseOption === null || purchaseOption === void 0 ? void 0 : purchaseOption.type) === 'yearly') label = t('common:billing.subscription.billedYearly');
    const onPurchaseClickForOrg = ()=>{
        if (!organizationId || !(purchaseOption === null || purchaseOption === void 0 ? void 0 : purchaseOption.productId)) return;
        navigate((0, $b969eaec2195befc$export$c169ff81af47339c)({
            organizationId: organizationId,
            productId: purchaseOption.productId
        }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        title: t(product.title),
        children: [
            statusText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$fd5345d4562e9833), {
                children: statusText
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d4c1fc4a3d4947e8$var$StyledIconWrap, {
                $variant: $variant,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039), {
                    licenseType: product.licenseType,
                    size: 150
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$StyledWrapCardText, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: t(product.title)
                    }),
                    purchaseOption && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65), {
                        as: "p",
                        children: [
                            "$",
                            purchaseOption.price,
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$ddf9e902b54c6c8), {
                                as: "span",
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d4c1fc4a3d4947e8$var$FeatureWrap, {
                        children: supportedFeatures.map((sf, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$FeatureGroup, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                                        children: sf.tag
                                    }),
                                    sf.features.map((feature, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$FeatureItem, {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "check",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                                    children: t(feature)
                                                })
                                            ]
                                        }, `feature_${feature}_${idx}`))
                                ]
                            }, `supportedFeature_${sf.tag}_${index}`))
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d4c1fc4a3d4947e8$var$Footer, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d4c1fc4a3d4947e8$var$FooterLinks, {
                            children: [
                                purchaseOption && (hasNoOrgMemberships ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    href: purchaseOption.defaultPaymentLink,
                                    target: "_blank",
                                    $color: "secondary",
                                    children: t('common:purchase')
                                }, 'purchaseLink') : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    onClick: ()=>onPurchaseClickForOrg(),
                                    $color: "secondary",
                                    children: t('common:purchase')
                                }, 'purchaseLink')),
                                product.trial && showTrial && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    href: product.trial,
                                    target: "_blank",
                                    $color: "simple",
                                    children: t('common:license.trial.start')
                                }, 'trialLink')
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const $d4c1fc4a3d4947e8$var$Footer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d4c1fc4a3d4947e8$var$t || ($d4c1fc4a3d4947e8$var$t = $d4c1fc4a3d4947e8$var$_`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-grow: 1;
    width: 100%;
`));
const $d4c1fc4a3d4947e8$var$FooterLinks = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d4c1fc4a3d4947e8$var$t1 || ($d4c1fc4a3d4947e8$var$t1 = $d4c1fc4a3d4947e8$var$_`
    display: flex;
    flex-direction: column;
    align-items: center; /* Center-align the links horizontally */
`));
const $d4c1fc4a3d4947e8$var$FeatureWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d4c1fc4a3d4947e8$var$t2 || ($d4c1fc4a3d4947e8$var$t2 = $d4c1fc4a3d4947e8$var$_`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
    flex-grow: 1;
    margin: 1rem 0;
`));
const $d4c1fc4a3d4947e8$var$FeatureGroup = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d4c1fc4a3d4947e8$var$t3 || ($d4c1fc4a3d4947e8$var$t3 = $d4c1fc4a3d4947e8$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`));
const $d4c1fc4a3d4947e8$var$FeatureItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d4c1fc4a3d4947e8$var$t4 || ($d4c1fc4a3d4947e8$var$t4 = $d4c1fc4a3d4947e8$var$_`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    color: ${0};
`), ({ theme: theme })=>theme.color.link);
const $d4c1fc4a3d4947e8$var$StyledIconWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$f2e4196c0d2b5bb8))($d4c1fc4a3d4947e8$var$t5 || ($d4c1fc4a3d4947e8$var$t5 = $d4c1fc4a3d4947e8$var$_`
    padding: 0 0;
    min-height: auto;
    svg {
        padding: ${0};
    }
`), (props)=>props.$variant === 'small' ? '0.75rem' : '0');
const $d4c1fc4a3d4947e8$var$StyledWrapCardText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$9de46b28c4f6c978))($d4c1fc4a3d4947e8$var$t6 || ($d4c1fc4a3d4947e8$var$t6 = $d4c1fc4a3d4947e8$var$_`
    padding: 0.5rem 1.25rem 1.75rem 1.25rem;
`));


let $05f7c300601947a5$var$_ = (t)=>t, $05f7c300601947a5$var$t, $05f7c300601947a5$var$t1;
function $05f7c300601947a5$export$2e2bcd8739ae039({ variant: variant = 'default' }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $f232cebbf1b70e96$export$f1a78c17382fe22a)();
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const BodyComponent = variant == 'default' ? (0, $348d9e775387b4da$export$5c96f0521c6e1626) : (0, $348d9e775387b4da$export$85a4c3b5f32264b8);
    const [publicProducts, setPublicProducts] = (0, $7fPBF.useState)([]);
    const [purchaseOption, setPurchaseOption] = (0, $7fPBF.useState)('monthly');
    (0, $7fPBF.useEffect)(()=>{
        if (organizationId || (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().hasNoOrgMemberships) return;
        const intent = (0, $b969eaec2195befc$export$296e765752e56d8)(searchParams);
        var _intent_organizationId, _ref;
        const destination = (0, $b969eaec2195befc$export$7f01a2876ca50dcf)({
            memberships: memberships,
            intent: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, intent), {
                // no org in the link (bookmark, deep link, nav item) -> upgrade the one they are working in
                organizationId: (_ref = (_intent_organizationId = intent.organizationId) !== null && _intent_organizationId !== void 0 ? _intent_organizationId : (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().currentOrgId) !== null && _ref !== void 0 ? _ref : undefined
            })
        });
        //  null means already at /upgrade
        if (destination) navigate(destination, {
            replace: true
        });
    }, [
        memberships,
        organizationId,
        searchParams
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const fetchProducts = async ()=>{
            const products = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadAvailableProducts();
            setPublicProducts(products);
        };
        fetchProducts();
    }, []);
    const getPurchaseOption = (licenseType, subscription)=>{
        const locale = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().userLocalePreferences.defaultLocale;
        const products = publicProducts.filter((p)=>{
            // when checking for locale, display locale english is "en" and payment default is "en-us", hence only checking for language right now
            return p[licenseType] && p.isPublic && (p.locale === locale || (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(p.locale) === (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(locale) || (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)(p.locale) === (0, $eeb1a4bb5a11a603$export$d44f5da3b0eb939f)((0, $3ecd3f7dea3d56de$export$c89f3ba9a8ee8018)));
        });
        if (products.length === 0) return undefined;
        // sorted by billing cycle, so that the default payment link is always the first one
        const sortedProducts = products.sort((a, b)=>{
            var _a_billingCycle, _b_billingCycle;
            return ((_a_billingCycle = a.billingCycle) !== null && _a_billingCycle !== void 0 ? _a_billingCycle : '').localeCompare((_b_billingCycle = b.billingCycle) !== null && _b_billingCycle !== void 0 ? _b_billingCycle : '');
        });
        const purchaseOption = {
            price: sortedProducts[0].price,
            defaultPaymentLink: sortedProducts[0].defaultPaymentLink,
            type: subscription,
            productId: sortedProducts[0].id
        };
        if (subscription === 'yearly' && sortedProducts.length > 1) {
            purchaseOption.price = sortedProducts[1].price;
            purchaseOption.defaultPaymentLink = sortedProducts[1].defaultPaymentLink;
            purchaseOption.productId = sortedProducts[1].id;
        }
        return purchaseOption;
    };
    const getTranslatedFeatures = (featureKey)=>{
        const locale = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().userLocalePreferences.defaultLocale;
        const translatedFeatures = t(featureKey, {
            returnObjects: true,
            lng: locale
        });
        const jsonTranslatedCommands = JSON.parse(JSON.stringify(translatedFeatures));
        const features = [];
        for(const key in jsonTranslatedCommands)features.push(jsonTranslatedCommands[key]);
        return features;
    };
    const products = [
        {
            product: (0, $3d257c68ce43608e$export$ed2c078912602c20).isPlusAccess,
            supportedFeatures: [
                {
                    tag: t('common:billing.isPlusAccess.supportedFeatures.tag'),
                    features: getTranslatedFeatures('common:billing.isPlusAccess.supportedFeatures.features')
                }
            ],
            statusText: t('common:billing.mostPopular'),
            $variant: 'small'
        },
        {
            product: (0, $3d257c68ce43608e$export$ed2c078912602c20).isEmployeeAccess,
            supportedFeatures: [
                {
                    tag: t('common:billing.isEmployeeAccess.supportedFeatures.tag'),
                    features: getTranslatedFeatures('common:billing.isEmployeeAccess.supportedFeatures.features')
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($05f7c300601947a5$var$TabContainer, {
                role: "tablist",
                "aria-label": t('common:billing.subscription.title'),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf69660d3ccba544$export$3c56cb56459c147a), {
                        role: "tab",
                        "aria-selected": purchaseOption === 'monthly',
                        onClick: ()=>setPurchaseOption('monthly'),
                        isActive: purchaseOption === 'monthly',
                        children: t('common:billing.subscription.monthly')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bf69660d3ccba544$export$3c56cb56459c147a), {
                        role: "tab",
                        "aria-selected": purchaseOption === 'yearly',
                        onClick: ()=>setPurchaseOption('yearly'),
                        isActive: purchaseOption === 'yearly',
                        children: t('common:billing.subscription.yearly')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(BodyComponent, {
                children: [
                    products.map((product, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4c1fc4a3d4947e8$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, product), {
                            purchaseOption: getPurchaseOption(product.product.licenseType, purchaseOption),
                            organizationId: organizationId
                        }), 'product_' + i)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd9b8885d8abdd3b$export$2e2bcd8739ae039), {
                        organizationId: organizationId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($05f7c300601947a5$export$6aedc35c4b1b61dc, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    href: (0, $3d257c68ce43608e$export$d79fc0b00008bd8d),
                    endIcon: "externalLink",
                    target: "_blank",
                    children: t('common:learnMore')
                })
            })
        ]
    });
}
const $05f7c300601947a5$export$6aedc35c4b1b61dc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($05f7c300601947a5$var$t || ($05f7c300601947a5$var$t = $05f7c300601947a5$var$_`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
`));
const $05f7c300601947a5$var$TabContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)($05f7c300601947a5$export$6aedc35c4b1b61dc)($05f7c300601947a5$var$t1 || ($05f7c300601947a5$var$t1 = $05f7c300601947a5$var$_`
    display: flex;
    gap: 10px;
    margin: 1rem 0;
`));



function $8fb8c11d74adb839$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:billing.upgrade.compare'),
                description: t('common:billing.upgrade.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $05f7c300601947a5$export$2e2bcd8739ae039), {})
        ]
    });
}











function $030ccdeb6cb3fc1a$export$2e2bcd8739ae039() {
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!currentOrg) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
        href: 'https://cephable.com/individual-pricing/',
        target: "_blank",
        rel: "noopener noreferrer",
        children: t('common:upgrade')
    });
}




function $572ce21afb4be0ad$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, canViewOrgDetails: canViewOrgDetails, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:billing.title'),
                items: canViewOrgDetails ? items : []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
                title: t('common:license.upgrade.fallback.title'),
                description: isManagedOrg ? t('common:billing.error') : t('common:license.upgrade.fallback.description'),
                fullHeight: true,
                icon: "money",
                children: !isManagedOrg && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $030ccdeb6cb3fc1a$export$2e2bcd8739ae039), {})
            })
        ]
    });
}










const $85e272e760900bb9$var$objectToString = Object.prototype.toString;
function $85e272e760900bb9$export$e6127cc7fe7395c3(wat) {
    switch($85e272e760900bb9$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $85e272e760900bb9$export$49034edbe6b62415(wat, Error);
    }
}
function $85e272e760900bb9$var$isBuiltin(wat, className) {
    return $85e272e760900bb9$var$objectToString.call(wat) === `[object ${className}]`;
}
function $85e272e760900bb9$export$9f9636d330b71954(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "ErrorEvent");
}
function $85e272e760900bb9$export$ef9e2056653f0c8e(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "DOMError");
}
function $85e272e760900bb9$export$12e869b2a583f783(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "DOMException");
}
function $85e272e760900bb9$export$844ec244b1367d54(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "String");
}
function $85e272e760900bb9$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $85e272e760900bb9$export$c3825b437cbdea5c(wat) {
    return wat === null || $85e272e760900bb9$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $85e272e760900bb9$export$53b83ca8eaab0383(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "Object");
}
function $85e272e760900bb9$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $85e272e760900bb9$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $85e272e760900bb9$export$49034edbe6b62415(wat, Event);
}
function $85e272e760900bb9$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $85e272e760900bb9$export$49034edbe6b62415(wat, Element);
}
function $85e272e760900bb9$export$49841c62b9eff15(wat) {
    return $85e272e760900bb9$var$isBuiltin(wat, "RegExp");
}
function $85e272e760900bb9$export$f5b060c2914b97c8(wat) {
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === "function");
}
function $85e272e760900bb9$export$bc2894c7158efbac(wat) {
    return $85e272e760900bb9$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $85e272e760900bb9$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (e) {
        return false;
    }
}
function $85e272e760900bb9$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $85e272e760900bb9$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $85e272e760900bb9$export$49034edbe6b62415(request, Request);
}


function $b466939a0d6f1536$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $b466939a0d6f1536$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $b466939a0d6f1536$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $b466939a0d6f1536$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributeValue, checkedUnit);
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        var _JSON_stringify;
        stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : "";
    } catch (e) {}
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        value: stringValue,
        type: "string"
    }, checkedUnit);
}
function $b466939a0d6f1536$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes !== null && attributes !== void 0 ? attributes : {})){
        const typedValue = $b466939a0d6f1536$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $b466939a0d6f1536$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        var _attr_unit;
        weight += key.length * 2;
        weight += attr.type.length * 2;
        var _attr_unit_length;
        weight += ((_attr_unit_length = (_attr_unit = attr.unit) === null || _attr_unit === void 0 ? void 0 : _attr_unit.length) !== null && _attr_unit_length !== void 0 ? _attr_unit_length : 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $b466939a0d6f1536$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(val)) weight += $b466939a0d6f1536$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $b466939a0d6f1536$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $b466939a0d6f1536$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}


const $961dedfff8dbd514$export$31499a9cd224b78c = "10.67.0";


const $df8678217e707dd5$export$f1a6cdb1459e81d1 = globalThis;


function $3d29ea41beb10247$export$19eade501500c6c1() {
    $3d29ea41beb10247$export$c8bfa33e4e8ae492((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return 0, $df8678217e707dd5$export$f1a6cdb1459e81d1;
}
function $3d29ea41beb10247$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $961dedfff8dbd514$export$31499a9cd224b78c);
    return __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] || {};
}
function $3d29ea41beb10247$export$7e223ec222791509(name, creator, obj = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] = __SENTRY__[0, $961dedfff8dbd514$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}






const $37b03cd1fa6d4fb8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;








const $d8898b8567c29ee9$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $d8898b8567c29ee9$var$PREFIX = "Sentry Logger ";
const $d8898b8567c29ee9$export$77c4ce905194557b = {};
function $d8898b8567c29ee9$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d8898b8567c29ee9$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d8898b8567c29ee9$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d8898b8567c29ee9$var$enable() {
    $d8898b8567c29ee9$var$_getLoggerSettings().enabled = true;
}
function $d8898b8567c29ee9$var$disable() {
    $d8898b8567c29ee9$var$_getLoggerSettings().enabled = false;
}
function $d8898b8567c29ee9$var$isEnabled() {
    return $d8898b8567c29ee9$var$_getLoggerSettings().enabled;
}
function $d8898b8567c29ee9$var$log(...args) {
    $d8898b8567c29ee9$var$_maybeLog("log", ...args);
}
function $d8898b8567c29ee9$var$warn(...args) {
    $d8898b8567c29ee9$var$_maybeLog("warn", ...args);
}
function $d8898b8567c29ee9$var$error(...args) {
    $d8898b8567c29ee9$var$_maybeLog("error", ...args);
}
function $d8898b8567c29ee9$var$_maybeLog(level, ...args) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    if ($d8898b8567c29ee9$var$isEnabled()) $d8898b8567c29ee9$export$cda52e2a8927a2ca(()=>{
        (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console[level](`${$d8898b8567c29ee9$var$PREFIX}[${level}]:`, ...args);
    });
}
function $d8898b8567c29ee9$var$_getLoggerSettings() {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $d8898b8567c29ee9$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $d8898b8567c29ee9$var$enable,
    disable: /** Disable logging. */ $d8898b8567c29ee9$var$disable,
    isEnabled: /** Check if logging is enabled. */ $d8898b8567c29ee9$var$isEnabled,
    log: /** Log a message. */ $d8898b8567c29ee9$var$log,
    warn: /** Log a warning. */ $d8898b8567c29ee9$var$warn,
    error: /** Log an error. */ $d8898b8567c29ee9$var$error
};



function $85a434b6cfc19e37$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $85a434b6cfc19e37$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $85a434b6cfc19e37$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (e) {}
}
function $85a434b6cfc19e37$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($85a434b6cfc19e37$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $85a434b6cfc19e37$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $85a434b6cfc19e37$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $85a434b6cfc19e37$export$62ff257738bf57f5(value) {
    if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(value)) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $85a434b6cfc19e37$var$getOwnProperties(value));
    if ((0, $85e272e760900bb9$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: type,
            target: target,
            currentTarget: currentTarget
        }, detail ? {
            detail: detail
        } : {}, $85a434b6cfc19e37$var$getOwnProperties(value));
    }
    return value;
}
function $85a434b6cfc19e37$var$getOwnProperties(obj) {
    if ((0, $85e272e760900bb9$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $85a434b6cfc19e37$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($85a434b6cfc19e37$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $85a434b6cfc19e37$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $85a434b6cfc19e37$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $85a434b6cfc19e37$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($85a434b6cfc19e37$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($85a434b6cfc19e37$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $85a434b6cfc19e37$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $85a434b6cfc19e37$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $85a434b6cfc19e37$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $85e272e760900bb9$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $8aca1af6321ba44f$var$RESOLVED_RUNNER;
function $8aca1af6321ba44f$export$ff239213cb80e2da(cb) {
    if ($8aca1af6321ba44f$var$RESOLVED_RUNNER !== void 0) return $8aca1af6321ba44f$var$RESOLVED_RUNNER ? $8aca1af6321ba44f$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $8aca1af6321ba44f$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $8aca1af6321ba44f$var$RESOLVED_RUNNER(cb);
    }
    $8aca1af6321ba44f$var$RESOLVED_RUNNER = null;
    return cb();
}
function $8aca1af6321ba44f$export$9869d72de32a3917() {
    return $8aca1af6321ba44f$export$ff239213cb80e2da(()=>Math.random());
}
function $8aca1af6321ba44f$export$65b1bada40c91b34() {
    return $8aca1af6321ba44f$export$ff239213cb80e2da(()=>Date.now());
}




const $e335bea78aa151c5$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $e335bea78aa151c5$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $e335bea78aa151c5$export$280812de8e91ea53(obj) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(obj, $e335bea78aa151c5$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $e335bea78aa151c5$export$610d1422c4bdc4c1(obj, depth) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(obj, $e335bea78aa151c5$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $e335bea78aa151c5$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$e335bea78aa151c5$var$SENTRY_SKIP_NORMALIZATION]);
}
function $e335bea78aa151c5$export$fe95a19841c4b155(value) {
    const v = value[$e335bea78aa151c5$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}





const $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT = 50;
const $a6df8b9dd4ca405a$export$27c7e15d453fc0ac = "?";
const $a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $a6df8b9dd4ca405a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($a6df8b9dd4ca405a$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $a6df8b9dd4ca405a$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $a6df8b9dd4ca405a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $a6df8b9dd4ca405a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $a6df8b9dd4ca405a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($a6df8b9dd4ca405a$var$STRIP_FRAME_REGEXP.test($a6df8b9dd4ca405a$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $a6df8b9dd4ca405a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, frame), {
            filename: frame.filename || $a6df8b9dd4ca405a$var$getLastStackFrame(localStack).filename,
            function: frame.function || $a6df8b9dd4ca405a$export$27c7e15d453fc0ac
        }));
}
function $a6df8b9dd4ca405a$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $a6df8b9dd4ca405a$var$defaultFunctionName = "<anonymous>";
function $a6df8b9dd4ca405a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $a6df8b9dd4ca405a$var$defaultFunctionName;
        return fn.name || $a6df8b9dd4ca405a$var$defaultFunctionName;
    } catch (e) {
        return $a6df8b9dd4ca405a$var$defaultFunctionName;
    }
}
function $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (e) {
            return void 0;
        }
    }
    return void 0;
}
function $a6df8b9dd4ca405a$export$60c0d6c8e038267a(path) {
    let filename = (path === null || path === void 0 ? void 0 : path.startsWith("file://")) ? path.slice(7) : path;
    if (filename === null || filename === void 0 ? void 0 : filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


let $7879d292a118e15d$var$stringifier;
function $7879d292a118e15d$export$575c40989754ba4d(newStringifier) {
    $7879d292a118e15d$var$stringifier = newStringifier;
}
function $7879d292a118e15d$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $7879d292a118e15d$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $7879d292a118e15d$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $7879d292a118e15d$export$a3295358bff77e(object, depth);
    if ($7879d292a118e15d$var$jsonSize(normalized) > maxSize) return $7879d292a118e15d$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $7879d292a118e15d$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7879d292a118e15d$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $7879d292a118e15d$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $e335bea78aa151c5$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $e335bea78aa151c5$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $7879d292a118e15d$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (e) {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $85a434b6cfc19e37$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7879d292a118e15d$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $7879d292a118e15d$export$a110e5bc79f44a84(key, value) {
    try {
        if ($7879d292a118e15d$var$stringifier) {
            const stringified = $7879d292a118e15d$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $7879d292a118e15d$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $7879d292a118e15d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}
function $7879d292a118e15d$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $7879d292a118e15d$var$jsonSize(value) {
    return $7879d292a118e15d$var$utf8Length(JSON.stringify(value));
}
function $7879d292a118e15d$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (e) {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $7879d292a118e15d$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $6c937b4b236937d4$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch (e) {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $6c937b4b236937d4$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $6c937b4b236937d4$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $6c937b4b236937d4$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $7879d292a118e15d$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $6c937b4b236937d4$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $85e272e760900bb9$export$844ec244b1367d54)(value)) return false;
    if ((0, $85e272e760900bb9$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $85e272e760900bb9$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $6c937b4b236937d4$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($6c937b4b236937d4$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $df365b8ef5885c2b$var$getCrypto() {
    const gbl = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $df365b8ef5885c2b$var$emptyUuid;
function $df365b8ef5885c2b$var$getRandomByte() {
    return (0, $8aca1af6321ba44f$export$9869d72de32a3917)() * 16;
}
function $df365b8ef5885c2b$export$19f53698e68b2496(crypto = $df365b8ef5885c2b$var$getCrypto()) {
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return (0, $8aca1af6321ba44f$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch (e) {}
    if (!$df365b8ef5885c2b$var$emptyUuid) $df365b8ef5885c2b$var$emptyUuid = "10000000100040008000100000000000";
    return $df365b8ef5885c2b$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($df365b8ef5885c2b$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $df365b8ef5885c2b$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
function $df365b8ef5885c2b$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $df365b8ef5885c2b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $df365b8ef5885c2b$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $df365b8ef5885c2b$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $df365b8ef5885c2b$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        const mergedData = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
const $df365b8ef5885c2b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $df365b8ef5885c2b$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $df365b8ef5885c2b$export$d364f2020ab30578(input) {
    const match = input.match($df365b8ef5885c2b$var$SEMVER_REGEXP) || [];
    const major = $df365b8ef5885c2b$var$_parseInt(match[1]);
    const minor = $df365b8ef5885c2b$var$_parseInt(match[2]);
    const patch = $df365b8ef5885c2b$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $df365b8ef5885c2b$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6c937b4b236937d4$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $6c937b4b236937d4$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6c937b4b236937d4$export$4215662d762d6f9d)(line, 0));
}
function $df365b8ef5885c2b$export$6de4ffac6a2f1098(exception) {
    if ($df365b8ef5885c2b$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (e) {}
    return false;
}
function $df365b8ef5885c2b$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {}
}




const $b007b72e24b33b62$var$ONE_SECOND_IN_MS = 1e3;
function $b007b72e24b33b62$export$7740643b9eeaf0c4() {
    return (0, $8aca1af6321ba44f$export$65b1bada40c91b34)() / $b007b72e24b33b62$var$ONE_SECOND_IN_MS;
}
function $b007b72e24b33b62$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $b007b72e24b33b62$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $8aca1af6321ba44f$export$ff239213cb80e2da)(()=>performance.now())) / $b007b72e24b33b62$var$ONE_SECOND_IN_MS;
    };
}
let $b007b72e24b33b62$var$_cachedTimestampInSeconds;
function $b007b72e24b33b62$export$ee52dced521e3e18() {
    const func = $b007b72e24b33b62$var$_cachedTimestampInSeconds !== null && $b007b72e24b33b62$var$_cachedTimestampInSeconds !== void 0 ? $b007b72e24b33b62$var$_cachedTimestampInSeconds : $b007b72e24b33b62$var$_cachedTimestampInSeconds = $b007b72e24b33b62$var$createUnixTimestampInSecondsFunc();
    return func();
}
let $b007b72e24b33b62$var$cachedTimeOrigin = null;
function $b007b72e24b33b62$var$getBrowserTimeOrigin() {
    var _performance_timing;
    const { performance: performance } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $8aca1af6321ba44f$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $8aca1af6321ba44f$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $b007b72e24b33b62$export$baf075a948ffc0bf() {
    if ($b007b72e24b33b62$var$cachedTimeOrigin === null) $b007b72e24b33b62$var$cachedTimeOrigin = $b007b72e24b33b62$var$getBrowserTimeOrigin();
    return $b007b72e24b33b62$var$cachedTimeOrigin;
}


function $4ea28bfd5ee93486$export$14a186326edbb264(context) {
    const startingTime = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $df365b8ef5885c2b$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$4ea28bfd5ee93486$var$sessionToJSON(session)
    };
    if (context) $4ea28bfd5ee93486$export$531818e825e774db(session, context);
    return session;
}
function $4ea28bfd5ee93486$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $4ea28bfd5ee93486$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $4ea28bfd5ee93486$export$531818e825e774db(session, context);
}
function $4ea28bfd5ee93486$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}





function $6758701f8e924183$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialObj);
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $6758701f8e924183$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $f56fc4041ba3a369$export$dc6d7ea554bcce10() {
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
}
function $f56fc4041ba3a369$export$295213bc4d0c54ad() {
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)().substring(16);
}





function $dff99a7a1f7c3087$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch (e) {}
    return value;
}
function $dff99a7a1f7c3087$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch (e) {
        return void 0;
    }
    return ref;
}


const $9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $9f9cfe5727c3ad26$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(scope, $9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD, (0, $dff99a7a1f7c3087$export$f0b98edec95fcb33)(span));
    else delete scope[$9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD];
}
function $9f9cfe5727c3ad26$export$91f063ebb8eff307(scope) {
    return (0, $dff99a7a1f7c3087$export$a0592ad8c3586cf)(scope[$9f9cfe5727c3ad26$var$SCOPE_SPAN_FIELD]);
}




const $88388f6b019104ff$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $88388f6b019104ff$export$775b6bb06e53a214 {
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $88388f6b019104ff$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags);
        newScope._attributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._attributes);
        newScope._extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra);
        newScope._contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._contexts);
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(newScope, (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $4ea28bfd5ee93486$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._attributes, newAttributes);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $88388f6b019104ff$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $85e272e760900bb9$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._tags, tags);
        this._attributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._attributes, attributes);
        this._extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._extra, extra);
        this._contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $88388f6b019104ff$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            timestamp: (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)()
        }, breadcrumb), {
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $6c937b4b236937d4$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        });
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            var _this__client;
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $6758701f8e924183$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        var _hint_syntheticException;
        const syntheticException = (_hint_syntheticException = hint === null || hint === void 0 ? void 0 : hint.syntheticException) !== null && _hint_syntheticException !== void 0 ? _hint_syntheticException : new Error(message);
        this._client.captureMessage(message, level, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
        };
    }
}


function $303b3b8942f870bd$export$6f1b9191db9c4d5() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}
function $303b3b8942f870bd$export$de9862929b76bf57() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}



const $7a8fa26b5d72274f$var$isActualPromise = (p)=>p instanceof Promise && !p[$7a8fa26b5d72274f$var$kChainedCopy];
const $7a8fa26b5d72274f$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $7a8fa26b5d72274f$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $7a8fa26b5d72274f$var$isActualPromise(chained) && $7a8fa26b5d72274f$var$isActualPromise(original) ? chained : $7a8fa26b5d72274f$var$copyProps(original, chained);
};
const $7a8fa26b5d72274f$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$7a8fa26b5d72274f$var$kChainedCopy]: true
    });
    return chained;
};




class $349a8e27b595687d$export$d36ec451f120cfba {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $7a8fa26b5d72274f$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
function $349a8e27b595687d$var$getAsyncContextStack() {
    const registry = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $349a8e27b595687d$export$d36ec451f120cfba((0, $303b3b8942f870bd$export$6f1b9191db9c4d5)(), (0, $303b3b8942f870bd$export$de9862929b76bf57)());
}
function $349a8e27b595687d$var$withScope(callback) {
    return $349a8e27b595687d$var$getAsyncContextStack().withScope(callback);
}
function $349a8e27b595687d$var$withSetScope(scope, callback) {
    const stack = $349a8e27b595687d$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $349a8e27b595687d$var$withIsolationScope(callback) {
    return $349a8e27b595687d$var$getAsyncContextStack().withScope(()=>{
        return callback($349a8e27b595687d$var$getAsyncContextStack().getIsolationScope());
    });
}
function $349a8e27b595687d$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $349a8e27b595687d$var$withIsolationScope,
        withScope: $349a8e27b595687d$var$withScope,
        withSetScope: $349a8e27b595687d$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $349a8e27b595687d$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$349a8e27b595687d$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$349a8e27b595687d$var$getAsyncContextStack().getIsolationScope()
    };
}


function $e26a4b07a4ad38af$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $e26a4b07a4ad38af$export$f639b0c2752203be(carrier) {
    const sentry = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $349a8e27b595687d$export$329d4d4d54e42710)();
}





let $6486f3d311605b78$var$_externalPropagationContextProvider;
function $6486f3d311605b78$export$b5defb3466e9689b(fn) {
    $6486f3d311605b78$var$_externalPropagationContextProvider = fn;
}
function $6486f3d311605b78$export$92547f779c920a71() {
    return $6486f3d311605b78$var$_externalPropagationContextProvider === null || $6486f3d311605b78$var$_externalPropagationContextProvider === void 0 ? void 0 : $6486f3d311605b78$var$_externalPropagationContextProvider();
}
function $6486f3d311605b78$export$53f0ae651a1c4298() {
    return $6486f3d311605b78$var$_externalPropagationContextProvider !== void 0;
}
function $6486f3d311605b78$export$c7be4b0125a10cba() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $6486f3d311605b78$export$68f3af03034c9e90() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $6486f3d311605b78$export$aa55d5ab8e05984f() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("globalScope", ()=>new (0, $88388f6b019104ff$export$775b6bb06e53a214)());
}
function $6486f3d311605b78$export$ec58d9285c204497(...rest) {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $6486f3d311605b78$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $6486f3d311605b78$export$6bb76d6eba7e258c() {
    return $6486f3d311605b78$export$c7be4b0125a10cba().getClient();
}
function $6486f3d311605b78$export$1e83db7ee4876dc4(scope) {
    const externalContext = $6486f3d311605b78$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}








const $370456451b52ff1d$export$849dbeeeda01ae98 = "production";
const $370456451b52ff1d$export$6829f580e78306fa = "development";



const $fdf17a1e56d9d4ca$export$d7a7d984b0791405 = "sentry.source";
const $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $fdf17a1e56d9d4ca$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09 = "sentry.op";
const $fdf17a1e56d9d4ca$export$cca8dd30f57f805e = "sentry.origin";
const $fdf17a1e56d9d4ca$export$d9e02c0285078f88 = "sentry.status.message";
const $fdf17a1e56d9d4ca$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $fdf17a1e56d9d4ca$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $fdf17a1e56d9d4ca$export$f5cefb258679b29e = "sentry.release";
const $fdf17a1e56d9d4ca$export$d1b1dbb47f5ba57c = "sentry.environment";
const $fdf17a1e56d9d4ca$export$4626f2be16112c1c = "sentry.segment.name";
const $fdf17a1e56d9d4ca$export$25fa4a1832d3736a = "sentry.segment.id";
const $fdf17a1e56d9d4ca$export$87a4807042e1f1bb = "sentry.sdk.name";
const $fdf17a1e56d9d4ca$export$301ebe936458e291 = "sentry.sdk.version";
const $fdf17a1e56d9d4ca$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $fdf17a1e56d9d4ca$export$1f9cc1d34ea098a0 = "user.id";
const $fdf17a1e56d9d4ca$export$b7466609ef46c07e = "user.email";
const $fdf17a1e56d9d4ca$export$8d592bdaea63b930 = "user.ip_address";
const $fdf17a1e56d9d4ca$export$c05ee933d3f74b2b = "user.name";
const $fdf17a1e56d9d4ca$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $fdf17a1e56d9d4ca$export$1efec95406bbe327 = "sentry.profile_id";
const $fdf17a1e56d9d4ca$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $fdf17a1e56d9d4ca$export$b016f89ac1066ec = "cache.hit";
const $fdf17a1e56d9d4ca$export$3110e4c3f4386399 = "cache.key";
const $fdf17a1e56d9d4ca$export$86be76deee227ff2 = "cache.item_size";
const $fdf17a1e56d9d4ca$export$be7a251980e7e946 = "http.request.method";
const $fdf17a1e56d9d4ca$export$25dfd73e0e32c6e1 = "url.full";
const $fdf17a1e56d9d4ca$export$ff77b5fd5b2d627b = "sentry.link.type";
const $fdf17a1e56d9d4ca$export$71a4a707257f2774 = "gen_ai.conversation.id";





const $4d0fefb7946dcfa7$export$6e69537d67fa20f = "sentry-";
const $4d0fefb7946dcfa7$export$eb0401070c617ea5 = /^sentry-/;
const $4d0fefb7946dcfa7$export$bdd844ddb2def819 = 8192;
function $4d0fefb7946dcfa7$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $4d0fefb7946dcfa7$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($4d0fefb7946dcfa7$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($4d0fefb7946dcfa7$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $4d0fefb7946dcfa7$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$4d0fefb7946dcfa7$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $4d0fefb7946dcfa7$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $85e272e760900bb9$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $4d0fefb7946dcfa7$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $4d0fefb7946dcfa7$var$baggageHeaderToObject(baggageHeader);
}
function $4d0fefb7946dcfa7$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $4d0fefb7946dcfa7$export$bdd844ddb2def819) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $4d0fefb7946dcfa7$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $4d0fefb7946dcfa7$export$397de414d189db00(existing);
    const incomingEntries = $4d0fefb7946dcfa7$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($4d0fefb7946dcfa7$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($4d0fefb7946dcfa7$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    var _merged_key;
    for (const [key, value] of Object.entries(newNonSentryEntries))(_merged_key = merged[key]) !== null && _merged_key !== void 0 ? _merged_key : merged[key] = value;
    return $4d0fefb7946dcfa7$export$12a7349a29a6e3c2(merged);
}




const $94fe38c0afc4d11c$var$ORG_ID_REGEX = /^o(\d+)\./;
const $94fe38c0afc4d11c$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $94fe38c0afc4d11c$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $94fe38c0afc4d11c$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $94fe38c0afc4d11c$export$b892860177f70a30(str) {
    const match = $94fe38c0afc4d11c$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $94fe38c0afc4d11c$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $94fe38c0afc4d11c$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $94fe38c0afc4d11c$var$validateDsn(dsn) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$94fe38c0afc4d11c$var$isValidProtocol(protocol)) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $94fe38c0afc4d11c$export$5914f4e7748c29c9(host) {
    const match = host.match($94fe38c0afc4d11c$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
function $94fe38c0afc4d11c$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $94fe38c0afc4d11c$export$5914f4e7748c29c9(host);
    return org_id;
}
function $94fe38c0afc4d11c$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $94fe38c0afc4d11c$export$b892860177f70a30(from) : $94fe38c0afc4d11c$var$dsnFromComponents(from);
    if (!components || !$94fe38c0afc4d11c$var$validateDsn(components)) return void 0;
    return components;
}



function $8540c501196729c9$export$1f70765132c3c225(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || ((_getClient = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}











const $f217ebe7a0a6fc3c$export$136e25984ba4a383 = 0;
const $f217ebe7a0a6fc3c$export$58f7963109c806fc = 1;
const $f217ebe7a0a6fc3c$export$f966a0446ece71e = 2;
function $f217ebe7a0a6fc3c$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $f217ebe7a0a6fc3c$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $f217ebe7a0a6fc3c$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $f217ebe7a0a6fc3c$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $f217ebe7a0a6fc3c$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $f7bbc910493e6179$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $f7bbc910493e6179$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $f7bbc910493e6179$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $f7bbc910493e6179$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $dff99a7a1f7c3087$export$f0b98edec95fcb33)(isolationScope));
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $f7bbc910493e6179$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$f7bbc910493e6179$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $dff99a7a1f7c3087$export$a0592ad8c3586cf)(spanWithScopes[$f7bbc910493e6179$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $f7bbc910493e6179$export$d135494e80cbbcae(span) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $f7bbc910493e6179$export$2e69b79005fc86eb(span) {
    return span[$f7bbc910493e6179$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $f7bbc910493e6179$export$c45f16c039fb5033(span) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $f7bbc910493e6179$export$aceb4106f395d20e(span) {
    return span[$f7bbc910493e6179$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $f7bbc910493e6179$export$6ba79447c0a2d852(span) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $f7bbc910493e6179$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $f7bbc910493e6179$export$a9ba2a501dbf6a56(span) {
    return span[$f7bbc910493e6179$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}








function $ab7c7053b878f035$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $ae017cc8b57317cd$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $ae017cc8b57317cd$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($ae017cc8b57317cd$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $ae017cc8b57317cd$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $ae017cc8b57317cd$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
    };
    const sampleRand = $ae017cc8b57317cd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $ae017cc8b57317cd$export$f35d907436da45cf(traceId = (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(), spanId = (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $ae017cc8b57317cd$export$1aff3752542747dd(traceId = (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(), spanId = (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $ae017cc8b57317cd$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $8aca1af6321ba44f$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $8aca1af6321ba44f$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $8aca1af6321ba44f$export$9869d72de32a3917)();
}
function $ae017cc8b57317cd$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $94fe38c0afc4d11c$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $cac16f6eada858e7$export$208d5b368507fb8b = 0;
const $cac16f6eada858e7$export$eb571cd9b5d98de8 = 1;
let $cac16f6eada858e7$var$hasShownSpanDropWarning = false;
function $cac16f6eada858e7$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $cac16f6eada858e7$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $cac16f6eada858e7$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $cac16f6eada858e7$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $cac16f6eada858e7$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cac16f6eada858e7$export$5caecac1caaf3a71(span);
    return (0, $ae017cc8b57317cd$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $cac16f6eada858e7$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cac16f6eada858e7$export$5caecac1caaf3a71(span);
    return (0, $ae017cc8b57317cd$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $cac16f6eada858e7$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map((_param)=>{
        var { context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes } = _param, restContext = (0, $8901fc92b5563702$export$71511d61b312f219)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8,
            attributes: attributes
        }, restContext);
    });
    else return void 0;
}
function $cac16f6eada858e7$export$9015adcf158ef3a5(links) {
    if (links === null || links === void 0 ? void 0 : links.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $cac16f6eada858e7$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $cac16f6eada858e7$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $cac16f6eada858e7$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
}
function $cac16f6eada858e7$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $cac16f6eada858e7$export$92d8c23565496537(span) {
    if ($cac16f6eada858e7$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $cac16f6eada858e7$var$getOtelParentSpanId(span),
            start_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(endTime) || void 0,
            status: $cac16f6eada858e7$export$e238a77ea3a8cd66(status),
            op: attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09],
            origin: attributes[0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e],
            links: $cac16f6eada858e7$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $cac16f6eada858e7$export$db0cad9e44f67af8(span) {
    if ($cac16f6eada858e7$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $cac16f6eada858e7$var$getOtelParentSpanId(span),
            start_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(startTime),
            end_timestamp: $cac16f6eada858e7$export$3f7581298f56c6d7(endTime),
            is_segment: span === $cac16f6eada858e7$export$7a3106f345d83bb6(span),
            status: $cac16f6eada858e7$export$d3856a3187d34821(status),
            attributes: $cac16f6eada858e7$export$1464a9cb828ba99f(attributes, status),
            links: $cac16f6eada858e7$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $cac16f6eada858e7$export$7a3106f345d83bb6(span)
    };
}
function $cac16f6eada858e7$var$getOtelParentSpanId(span) {
    var _span_parentSpanContext;
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : void 0;
}
function $cac16f6eada858e7$export$5402aa553bcf35f3(spanJson) {
    var _spanJson_links;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanJson), {
        attributes: (0, $b466939a0d6f1536$export$4954cae66e755861)(spanJson.attributes),
        links: (_spanJson_links = spanJson.links) === null || _spanJson_links === void 0 ? void 0 : _spanJson_links.map((link)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link), {
                attributes: (0, $b466939a0d6f1536$export$4954cae66e755861)(link.attributes)
            }))
    });
}
function $cac16f6eada858e7$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $cac16f6eada858e7$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $cac16f6eada858e7$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $cac16f6eada858e7$export$eb571cd9b5d98de8;
}
function $cac16f6eada858e7$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $f217ebe7a0a6fc3c$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $f217ebe7a0a6fc3c$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $cac16f6eada858e7$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $f217ebe7a0a6fc3c$export$58f7963109c806fc) || status.code === (0, $f217ebe7a0a6fc3c$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $cac16f6eada858e7$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $cac16f6eada858e7$export$d3856a3187d34821(status) === "error" ? status === null || status === void 0 ? void 0 : status.message : void 0;
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, statusMessage && {
        [(0, $fdf17a1e56d9d4ca$export$d9e02c0285078f88)]: statusMessage
    }, attributes);
}
const $cac16f6eada858e7$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $cac16f6eada858e7$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $cac16f6eada858e7$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$cac16f6eada858e7$var$ROOT_SPAN_FIELD] || span;
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(childSpan, $cac16f6eada858e7$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(span, $cac16f6eada858e7$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $cac16f6eada858e7$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) span[$cac16f6eada858e7$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $cac16f6eada858e7$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($cac16f6eada858e7$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$cac16f6eada858e7$var$CHILD_SPANS_FIELD] ? Array.from(span2[$cac16f6eada858e7$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $cac16f6eada858e7$export$c4c6a79b1260ca1b = $cac16f6eada858e7$export$7a3106f345d83bb6;
function $cac16f6eada858e7$export$7a3106f345d83bb6(span) {
    return span[$cac16f6eada858e7$var$ROOT_SPAN_FIELD] || span;
}
function $cac16f6eada858e7$export$1be426a8e585c83e() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)((0, $6486f3d311605b78$export$c7be4b0125a10cba)());
}
function $cac16f6eada858e7$export$d11691ff45a3e535() {
    if (!$cac16f6eada858e7$var$hasShownSpanDropWarning) {
        (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $cac16f6eada858e7$var$hasShownSpanDropWarning = true;
    }
}
function $cac16f6eada858e7$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: "custom",
        [(0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050)]: name
    });
}





const $ca20a23f2fb66f57$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $ca20a23f2fb66f57$export$d6636b700b76c516 {
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $cac16f6eada858e7$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(this, $ca20a23f2fb66f57$var$NON_RECORDING_SPAN_FIELD, true);
    }
}
function $ca20a23f2fb66f57$export$61cc547d99783aa7(span) {
    return !!span && span[$ca20a23f2fb66f57$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $5c79f8c2b5cb59fa$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(spanWithMaybeDsc, $5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD, dsc);
}
function $5c79f8c2b5cb59fa$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $370456451b52ff1d$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $94fe38c0afc4d11c$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $5c79f8c2b5cb59fa$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $5c79f8c2b5cb59fa$export$a117f995597e25df(span) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    const rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rate")) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$5c79f8c2b5cb59fa$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $8540c501196729c9$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b(client, capturedScope));
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $5c79f8c2b5cb59fa$export$366bad00d6815eed(span.spanContext().traceId, client);
    var _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
    const source = (_rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = rootSpanAttributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405]) !== null && _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE !== void 0 ? _rootSpanAttributes_SEMANTIC_ATTRIBUTE_SENTRY_SOURCE : rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $8540c501196729c9$export$1f70765132c3c225)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, $cac16f6eada858e7$export$5caecac1caaf3a71)(rootSpan));
        var // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get("sentry.sample_rand")) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $5c79f8c2b5cb59fa$export$95cf936fdacaff7b(span) {
    const dsc = $5c79f8c2b5cb59fa$export$a117f995597e25df(span);
    return (0, $4d0fefb7946dcfa7$export$56766feef403f365)(dsc);
}




function $d1de0be2af275d5b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $d1de0be2af275d5b$var$applyDataToEvent(event, data);
    if (span) $d1de0be2af275d5b$var$applySpanToEvent(event, span);
    $d1de0be2af275d5b$var$applyFingerprintToEvent(event, fingerprint);
    $d1de0be2af275d5b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $d1de0be2af275d5b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $d1de0be2af275d5b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $d1de0be2af275d5b$export$b1a120a2871faa46(data, "extra", extra);
    $d1de0be2af275d5b$export$b1a120a2871faa46(data, "tags", tags);
    $d1de0be2af275d5b$export$b1a120a2871faa46(data, "attributes", attributes);
    $d1de0be2af275d5b$export$b1a120a2871faa46(data, "user", user);
    $d1de0be2af275d5b$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $6758701f8e924183$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data.propagationContext, propagationContext);
}
function $d1de0be2af275d5b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $6758701f8e924183$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $d1de0be2af275d5b$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $6486f3d311605b78$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $d1de0be2af275d5b$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $d1de0be2af275d5b$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $d1de0be2af275d5b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contexts, event.contexts);
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $d1de0be2af275d5b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $d1de0be2af275d5b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $d1de0be2af275d5b$var$applySpanToEvent(event, span) {
    event.contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        trace: (0, $cac16f6eada858e7$export$46c6fbd1d265ebf0)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        dynamicSamplingContext: (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span)
    }, event.sdkProcessingMetadata);
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $d1de0be2af275d5b$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}




const $a26af9225b375ea5$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $a26af9225b375ea5$var$_sequenceNumber = 0;
let $a26af9225b375ea5$var$_previousTimestampMs;
function $a26af9225b375ea5$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($a26af9225b375ea5$var$_previousTimestampMs !== void 0 && nowMs !== $a26af9225b375ea5$var$_previousTimestampMs) $a26af9225b375ea5$var$_sequenceNumber = 0;
    const value = $a26af9225b375ea5$var$_sequenceNumber;
    $a26af9225b375ea5$var$_sequenceNumber++;
    $a26af9225b375ea5$var$_previousTimestampMs = nowMs;
    return {
        key: $a26af9225b375ea5$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}





function $72542fc242eb8419$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $cac16f6eada858e7$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $cac16f6eada858e7$export$46c6fbd1d265ebf0)(span) : (0, $6486f3d311605b78$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(span) : (0, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


const $779462112850bb95$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};











function $5e31f551d021d379$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $5e31f551d021d379$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $5e31f551d021d379$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $5e31f551d021d379$export$604a45d95a155e2b(envelope, types) {
    return $5e31f551d021d379$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $5e31f551d021d379$var$encodeUTF8(input) {
    const carrier = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $5e31f551d021d379$var$decodeUTF8(input) {
    const carrier = (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $5e31f551d021d379$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $5e31f551d021d379$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $5e31f551d021d379$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                stringifiedPayload = JSON.stringify((0, $7879d292a118e15d$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $5e31f551d021d379$var$concatBuffers(parts);
}
function $5e31f551d021d379$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $5e31f551d021d379$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $5e31f551d021d379$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($5e31f551d021d379$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $5e31f551d021d379$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $5e31f551d021d379$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $5e31f551d021d379$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $5e31f551d021d379$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $5e31f551d021d379$var$_isOverriddenType(type) {
    return type in $5e31f551d021d379$var$DATA_CATEGORY_OVERRIDES;
}
function $5e31f551d021d379$export$b11169581eeaf237(type) {
    return $5e31f551d021d379$var$_isOverriddenType(type) ? $5e31f551d021d379$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $5e31f551d021d379$export$d369f3b2758f6743(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $5e31f551d021d379$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    const dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        event_id: event.event_id,
        sent_at: new Date((0, $8aca1af6321ba44f$export$65b1bada40c91b34)()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}



var $3MsYN = parcelRequire("3MsYN");

function $3a8ae0c240b87a96$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $3MsYN.isNodeEnv)() || $3a8ae0c240b87a96$var$isElectronNodeRenderer());
}
function $3a8ae0c240b87a96$var$isElectronNodeRenderer() {
    const process = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).process;
    return (process === null || process === void 0 ? void 0 : process.type) === "renderer";
}


function $c172ea6c14583c3d$export$efdf3b13edb1118e(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            version: 2
        }, (0, $3a8ae0c240b87a96$export$4e09c449d6c407f7)() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: items
        })
    ];
}
function $c172ea6c14583c3d$export$cdcd668e6516443f(logs, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn);
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(headers, [
        $c172ea6c14583c3d$export$efdf3b13edb1118e(logs, inferUserData)
    ]);
}


const $95dada53d77b757b$var$MAX_LOG_BUFFER_SIZE = 100;
function $95dada53d77b757b$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $95dada53d77b757b$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $95dada53d77b757b$var$_getBufferMap();
    const logBuffer = $95dada53d77b757b$export$5365c9902fb9e770(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $95dada53d77b757b$var$MAX_LOG_BUFFER_SIZE) {
        $95dada53d77b757b$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $95dada53d77b757b$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)(), captureSerializedLog = $95dada53d77b757b$export$743ba6f7ec19225f) {
    var _client_getSdkMetadata;
    var _currentScope_getClient;
    const client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, $72542fc242eb8419$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, beforeLog.attributes);
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $d1de0be2af275d5b$export$cc422922fcbb91c6)((0, $6486f3d311605b78$export$68f3af03034c9e90)(), currentScope);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === "buffer") $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $85e272e760900bb9$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__ === null || __sentry_template_values__ === void 0 ? void 0 : __sentry_template_values__.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(currentScope);
    $95dada53d77b757b$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    const processedLog = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $a26af9225b375ea5$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $95dada53d77b757b$export$b879a166f5ac57c8(String(message)),
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : (0, $779462112850bb95$export$4fb50c0840d636d1)[level],
        attributes: $95dada53d77b757b$var$sanitizeLogAttributes((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $b466939a0d6f1536$export$4954cae66e755861)(scopeAttributes), (0, $b466939a0d6f1536$export$4954cae66e755861)(logAttributes, true)), {
            [sequenceAttr.key]: sequenceAttr.value
        }))
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $95dada53d77b757b$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    var _ref;
    const logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : $95dada53d77b757b$export$5365c9902fb9e770(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $c172ea6c14583c3d$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $95dada53d77b757b$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope);
}
function $95dada53d77b757b$export$5365c9902fb9e770(client) {
    return $95dada53d77b757b$var$_getBufferMap().get(client);
}
function $95dada53d77b757b$var$_getBufferMap() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $95dada53d77b757b$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $95dada53d77b757b$export$b879a166f5ac57c8(key);
        if (attr.type === "string") sanitized[sanitizedKey] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attr), {
            value: $95dada53d77b757b$export$b879a166f5ac57c8(attr.value)
        });
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $95dada53d77b757b$export$b879a166f5ac57c8(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}



/** Ways to communicate between the renderer and main process  */ var $c19dedf7769fe3b4$export$2c45cff090811b40;
(function(IPCMode) {
    /** Configures Electron IPC to receive messages from renderers */ IPCMode[IPCMode["Classic"] = 1] = "Classic";
    /** Configures Electron protocol module to receive messages from renderers */ IPCMode[IPCMode["Protocol"] = 2] = "Protocol";
    /**
     * Configures both methods for best compatibility.
     *
     * Renderers favour IPC but fall back to protocol if IPC has not
     * been configured in a preload script
     */ IPCMode[IPCMode["Both"] = 3] = "Both";
})($c19dedf7769fe3b4$export$2c45cff090811b40 || ($c19dedf7769fe3b4$export$2c45cff090811b40 = {}));
/**
 * Utility for creating namespaced IPC channels and protocol routes
 */ function $c19dedf7769fe3b4$export$7a377f14f0dbb927(namespace) {
    return {
        createUrl: (channel)=>{
            // sentry_key in the url stops these messages from being picked up by our HTTP instrumentations
            return `${namespace}://${channel}/sentry_key`;
        },
        urlMatches: function(url, channel) {
            return url.startsWith(this.createUrl(channel));
        },
        createKey: (channel)=>{
            return `${namespace}.${channel}`;
        },
        namespace: namespace
    };
}
const $c19dedf7769fe3b4$export$cad78848e344a758 = 'sentry-electron-renderer-id';
const $c19dedf7769fe3b4$var$UTILITY_PROCESS_MAGIC_MESSAGE_KEY = '__sentry_message_port_message__';
/** Does the message look like the magic message */ function $c19dedf7769fe3b4$export$8090a647fb5ab048(msg) {
    return !!(msg && typeof msg === 'object' && $c19dedf7769fe3b4$var$UTILITY_PROCESS_MAGIC_MESSAGE_KEY in msg);
}
/** Get the magic message to send to the utility process */ function $c19dedf7769fe3b4$export$77cf3c9181af5186() {
    return {
        [$c19dedf7769fe3b4$var$UTILITY_PROCESS_MAGIC_MESSAGE_KEY]: true
    };
}


/** Gets the available IPC implementation */ function $2ee8f950f6923ed9$var$getImplementation(ipcKey) {
    var _window___SENTRY_IPC__;
    const ipcUtil = (0, $c19dedf7769fe3b4$export$7a377f14f0dbb927)(ipcKey);
    // Favour IPC if it's been exposed by a preload script
    if ((_window___SENTRY_IPC__ = window.__SENTRY_IPC__) === null || _window___SENTRY_IPC__ === void 0 ? void 0 : _window___SENTRY_IPC__[ipcUtil.namespace]) return window.__SENTRY_IPC__[ipcUtil.namespace];
    else {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).log('IPC was not configured in preload script, falling back to custom protocol and fetch');
        // A unique ID used to identify this renderer and is send in the headers of every request
        // Because it added as a global, this can be fetched from the main process via executeJavaScript
        const id = window.__SENTRY_RENDERER_ID__ = (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        const headers = {
            [(0, $c19dedf7769fe3b4$export$cad78848e344a758)]: id
        };
        return {
            sendRendererStart: ()=>{
                fetch(ipcUtil.createUrl('start'), {
                    method: 'POST',
                    body: '',
                    headers: headers
                }).catch(()=>{
                    console.error(`Sentry SDK failed to establish connection with the Electron main process.
  - Ensure you have initialized the SDK in the main process
  - If your renderers use custom sessions, be sure to set 'getSessions' in the main process options
  - If you are bundling your main process code and using Electron < v5, you'll need to manually configure a preload script`);
                });
            },
            sendScope: (body)=>{
                fetch(ipcUtil.createUrl('scope'), {
                    method: 'POST',
                    body: body,
                    headers: headers
                }).catch(()=>{
                // ignore
                });
            },
            sendEnvelope: (body)=>{
                const requestBody = typeof body === 'string' ? body : body.buffer instanceof ArrayBuffer ? body.buffer.slice(body.byteOffset, body.byteOffset + body.byteLength) : Uint8Array.from(body).buffer;
                fetch(ipcUtil.createUrl('envelope'), {
                    method: 'POST',
                    body: requestBody,
                    headers: headers
                }).catch(()=>{
                // ignore
                });
            },
            sendStatus: (status)=>{
                fetch(ipcUtil.createUrl('status'), {
                    method: 'POST',
                    body: JSON.stringify({
                        status: status
                    }),
                    headers: headers
                }).catch(()=>{
                // ignore
                });
            },
            sendStructuredLog: (log)=>{
                fetch(ipcUtil.createUrl('structured-log'), {
                    method: 'POST',
                    body: JSON.stringify(log),
                    headers: headers
                }).catch(()=>{
                // ignore
                });
            },
            sendMetric: (metric)=>{
                fetch(ipcUtil.createUrl('metric'), {
                    method: 'POST',
                    body: JSON.stringify(metric),
                    headers: headers
                }).catch(()=>{
                // ignore
                });
            }
        };
    }
}
let $2ee8f950f6923ed9$var$cachedInterfaces;
/**
 * Renderer IPC interface
 *
 * Favours IPC if its been exposed via a preload script but will
 * fallback to custom protocol and fetch if IPC is not available
 */ function $2ee8f950f6923ed9$export$4d0c35c3c1a4776f(client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) {
    if (!client) throw new Error('Could not find client, make sure to call Sentry.init before getIPC');
    if (!$2ee8f950f6923ed9$var$cachedInterfaces) $2ee8f950f6923ed9$var$cachedInterfaces = new WeakMap();
    const found = $2ee8f950f6923ed9$var$cachedInterfaces.get(client);
    if (found) return found;
    const namespace = client.getOptions().ipcNamespace;
    const implementation = $2ee8f950f6923ed9$var$getImplementation(namespace);
    $2ee8f950f6923ed9$var$cachedInterfaces.set(client, implementation);
    implementation.sendRendererStart();
    return implementation;
}


function $7d071653eb41256a$var$captureLog(level, message, attributes, severityNumber) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    (0, $95dada53d77b757b$export$3ab3d16b9eebd986)({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, (0, $6486f3d311605b78$export$c7be4b0125a10cba)(), (_, log)=>(0, $2ee8f950f6923ed9$export$4d0c35c3c1a4776f)(client).sendStructuredLog(log));
}
/**
 * @summary Capture a log with the `trace` level. Requires `enableLogs` to be enabled in the Electron main process.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function $7d071653eb41256a$export$357889f174732d38(message, attributes) {
    $7d071653eb41256a$var$captureLog('trace', message, attributes);
}
/**
 * @summary Capture a log with the `debug` level. Requires `enableLogs` to be enabled in the Electron main process.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function $7d071653eb41256a$export$1c9f709888824e05(message, attributes) {
    $7d071653eb41256a$var$captureLog('debug', message, attributes);
}
/**
 * @summary Capture a log with the `info` level. Requires `enableLogs` to be enabled in the Electron main process.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function $7d071653eb41256a$export$a80b3bd66acc52ff(message, attributes) {
    $7d071653eb41256a$var$captureLog('info', message, attributes);
}
/**
 * @summary Capture a log with the `warn` level. Requires `enableLogs` to be enabled in the Electron main process.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function $7d071653eb41256a$export$c106dd0671a0fc2d(message, attributes) {
    $7d071653eb41256a$var$captureLog('warn', message, attributes);
}
/**
 * @summary Capture a log with the `error` level. Requires `enableLogs` to be enabled in the Electron main process.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function $7d071653eb41256a$export$a3bc9b8ed74fc(message, attributes) {
    $7d071653eb41256a$var$captureLog('error', message, attributes);
}
/**
 * @summary Capture a log with the `fatal` level. Requires `enableLogs` to be enabled in the Electron main process.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function $7d071653eb41256a$export$570101a5202fba29(message, attributes) {
    $7d071653eb41256a$var$captureLog('fatal', message, attributes);
}



















function $8ef533047427f0ca$export$58e45eb52ad1077d(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            version: 2
        }, (0, $3a8ae0c240b87a96$export$4e09c449d6c407f7)() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: items
        })
    ];
}
function $8ef533047427f0ca$export$f23eb96e33154901(metrics, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn);
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(headers, [
        $8ef533047427f0ca$export$58e45eb52ad1077d(metrics, inferUserData)
    ]);
}


const $be338f8d93fa0a44$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $be338f8d93fa0a44$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $be338f8d93fa0a44$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $be338f8d93fa0a44$var$_getBufferMap();
    const metricBuffer = $be338f8d93fa0a44$export$49385134251b08ff(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $be338f8d93fa0a44$var$MAX_METRIC_BUFFER_SIZE) {
        $be338f8d93fa0a44$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $be338f8d93fa0a44$var$_enrichMetricAttributes(beforeMetric, client, user) {
    var _client_getSdkMetadata;
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, beforeMetric.attributes);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay === null || replay === void 0 ? void 0 : replay.getReplayId(true);
    $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && (replay === null || replay === void 0 ? void 0 : replay.getRecordingMode()) === "buffer") $be338f8d93fa0a44$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, beforeMetric), {
        attributes: processedMetricAttributes
    });
}
function $be338f8d93fa0a44$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = (0, $72542fc242eb8419$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $a26af9225b375ea5$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId !== null && traceId !== void 0 ? traceId : "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $b466939a0d6f1536$export$4954cae66e755861)(scopeAttributes), (0, $b466939a0d6f1536$export$4954cae66e755861)(metric.attributes, "skip-undefined")), {
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
}
function $be338f8d93fa0a44$export$288d896e6652e0c4(beforeMetric, options) {
    var _options_scope;
    const currentScope = (_options_scope = options === null || options === void 0 ? void 0 : options.scope) !== null && _options_scope !== void 0 ? _options_scope : (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    var _options_captureSerializedMetric;
    const captureSerializedMetric = (_options_captureSerializedMetric = options === null || options === void 0 ? void 0 : options.captureSerializedMetric) !== null && _options_captureSerializedMetric !== void 0 ? _options_captureSerializedMetric : $be338f8d93fa0a44$export$84661fd26e6cac96;
    var _currentScope_getClient;
    const client = (_currentScope_getClient = currentScope === null || currentScope === void 0 ? void 0 : currentScope.getClient()) !== null && _currentScope_getClient !== void 0 ? _currentScope_getClient : (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    var _ref;
    const metricsEnabled = (_ref = enableMetrics !== null && enableMetrics !== void 0 ? enableMetrics : _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
    if (!metricsEnabled) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = (0, $d1de0be2af275d5b$export$cc422922fcbb91c6)((0, $6486f3d311605b78$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $be338f8d93fa0a44$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || (_experiments === null || _experiments === void 0 ? void 0 : _experiments.beforeSendMetric);
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $be338f8d93fa0a44$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $be338f8d93fa0a44$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    var _ref;
    const metricBuffer = (_ref = maybeMetricBuffer !== null && maybeMetricBuffer !== void 0 ? maybeMetricBuffer : $be338f8d93fa0a44$export$49385134251b08ff(client)) !== null && _ref !== void 0 ? _ref : [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $8ef533047427f0ca$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $be338f8d93fa0a44$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope);
}
function $be338f8d93fa0a44$export$49385134251b08ff(client) {
    return $be338f8d93fa0a44$var$_getBufferMap().get(client);
}
function $be338f8d93fa0a44$var$_getBufferMap() {
    return (0, $3d29ea41beb10247$export$7e223ec222791509)("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}



function $93f53dbdc672feff$var$captureMetric(type, name, value, options) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    var _options_scope;
    (0, $be338f8d93fa0a44$export$288d896e6652e0c4)({
        type: type,
        name: name,
        value: value,
        unit: options === null || options === void 0 ? void 0 : options.unit,
        attributes: options === null || options === void 0 ? void 0 : options.attributes
    }, {
        scope: (_options_scope = options === null || options === void 0 ? void 0 : options.scope) !== null && _options_scope !== void 0 ? _options_scope : (0, $6486f3d311605b78$export$c7be4b0125a10cba)(),
        captureSerializedMetric: (_, metric)=>(0, $2ee8f950f6923ed9$export$4d0c35c3c1a4776f)(client).sendMetric(metric)
    });
}
/**
 * @summary Increment a counter metric. Requires the `_experiments.enableMetrics` option to be enabled.
 *
 * @param name - The name of the counter metric.
 * @param value - The value to increment by (defaults to 1).
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.count('api.requests', 1, {
 *   attributes: {
 *     endpoint: '/api/users',
 *     method: 'GET',
 *     status: 200
 *   }
 * });
 * ```
 *
 * @example With custom value
 *
 * ```
 * Sentry.metrics.count('items.processed', 5, {
 *   attributes: {
 *     processor: 'batch-processor',
 *     queue: 'high-priority'
 *   }
 * });
 * ```
 */ function $93f53dbdc672feff$export$85b9a36db797e02b(name, value = 1, options) {
    $93f53dbdc672feff$var$captureMetric('counter', name, value, options);
}
/**
 * @summary Set a gauge metric to a specific value. Requires the `_experiments.enableMetrics` option to be enabled.
 *
 * @param name - The name of the gauge metric.
 * @param value - The current value of the gauge.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.gauge('memory.usage', 1024, {
 *   unit: 'megabyte',
 *   attributes: {
 *     process: 'web-server',
 *     region: 'us-east-1'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.gauge('active.connections', 42, {
 *   attributes: {
 *     server: 'api-1',
 *     protocol: 'websocket'
 *   }
 * });
 * ```
 */ function $93f53dbdc672feff$export$b0660673397c6c28(name, value, options) {
    $93f53dbdc672feff$var$captureMetric('gauge', name, value, options);
}
/**
 * @summary Record a value in a distribution metric. Requires the `_experiments.enableMetrics` option to be enabled.
 *
 * @param name - The name of the distribution metric.
 * @param value - The value to record in the distribution.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.distribution('task.duration', 500, {
 *   unit: 'millisecond',
 *   attributes: {
 *     task: 'data-processing',
 *     priority: 'high'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.distribution('batch.size', 100, {
 *   attributes: {
 *     processor: 'batch-1',
 *     type: 'async'
 *   }
 * });
 * ```
 */ function $93f53dbdc672feff$export$fd8e353f0040520a(name, value, options) {
    $93f53dbdc672feff$var$captureMetric('distribution', name, value, options);
}

















function $e47550d94a838770$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $e47550d94a838770$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $e47550d94a838770$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(value)) return (0, $7a8fa26b5d72274f$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}






function $3ba72cc613510e20$var$logIgnoredSpan(droppedSpan) {
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $3ba72cc613510e20$export$5d569ac97c389400(span, ignoreSpans) {
    if (!(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    for (const pattern of ignoreSpans){
        if ($3ba72cc613510e20$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && $3ba72cc613510e20$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>{
            var _span_attributes;
            return $3ba72cc613510e20$var$_matchesAttributeValue((_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[key], valuePattern);
        }) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && $3ba72cc613510e20$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $3ba72cc613510e20$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $6c937b4b236937d4$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $3ba72cc613510e20$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $3ba72cc613510e20$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $5da71dc6e7ad8d8b$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}












function $ac09a37575b310ba$export$2f3d84e767c9592b(span) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $cac16f6eada858e7$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $ac09a37575b310ba$export$b77c830667a4d630(span) {
    if (!(0, $37b03cd1fa6d4fb8$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(msg);
}








function $c763fd1ae3ee0fd4$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $8540c501196729c9$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, samplingContext), {
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        }));
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}










function $c26cfd9b49302c59$export$d3f49b33a1f44720(callback) {
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $c26cfd9b49302c59$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}







function $0ca80a3f5337ad93$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    var _event_sdk, _event_sdk1, _event_sdk2, _event_sdk3;
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, eventSdkInfo), {
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...((_event_sdk = event.sdk) === null || _event_sdk === void 0 ? void 0 : _event_sdk.integrations) || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...((_event_sdk1 = event.sdk) === null || _event_sdk1 === void 0 ? void 0 : _event_sdk1.packages) || [],
            ...newSdkInfo.packages || []
        ],
        settings: ((_event_sdk2 = event.sdk) === null || _event_sdk2 === void 0 ? void 0 : _event_sdk2.settings) || newSdkInfo.settings ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (_event_sdk3 = event.sdk) === null || _event_sdk3 === void 0 ? void 0 : _event_sdk3.settings, newSdkInfo.settings) : void 0
    });
    return event;
}
function $0ca80a3f5337ad93$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5e31f551d021d379$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        sent_at: new Date((0, $8aca1af6321ba44f$export$65b1bada40c91b34)()).toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    });
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $0ca80a3f5337ad93$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5e31f551d021d379$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $0ca80a3f5337ad93$export$8a6cdb6116a9fd2b(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    const envelopeHeaders = (0, $5e31f551d021d379$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $0ca80a3f5337ad93$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(spans[0]);
    const dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    const headers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        sent_at: new Date((0, $8aca1af6321ba44f$export$65b1bada40c91b34)()).toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)
    });
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const filteredSpans = (ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) ? spans.filter((span)=>{
        const json = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
        return !(0, $3ba72cc613510e20$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
        const processedSpan = !(0, $c26cfd9b49302c59$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $cac16f6eada858e7$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $5e31f551d021d379$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(headers, items);
}













function $293a838d63649350$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $cac16f6eada858e7$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a)]: value,
            [(0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5)]: unit
        });
    }
}
function $293a838d63649350$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $fdf17a1e56d9d4ca$export$f5f95cff026507b5];
        const value = attributes[0, $fdf17a1e56d9d4ca$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



function $04d4fb9bc11b3e87$export$39f842ff1b89e918(strategy) {
    (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $3d29ea41beb10247$export$19eade501500c6c1)()).segmentSpanCaptureStrategy = strategy;
}
function $04d4fb9bc11b3e87$export$ccd123f3ffd8eb3() {
    return (0, $3d29ea41beb10247$export$c8bfa33e4e8ae492)((0, $3d29ea41beb10247$export$19eade501500c6c1)()).segmentSpanCaptureStrategy;
}




const $4c5fac8529c371f2$var$MAX_SPAN_COUNT = 1e3;
class $4c5fac8529c371f2$export$a92149b045260d9f {
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $cac16f6eada858e7$export$eb571cd9b5d98de8) : (0, $cac16f6eada858e7$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === (0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405) && value !== void 0 && (0, $f7bbc910493e6179$export$2e69b79005fc86eb)(this)) (0, $f7bbc910493e6179$export$c45f16c039fb5033)(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!(0, $f7bbc910493e6179$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = (0, $f7bbc910493e6179$export$a9ba2a501dbf6a56)(this);
            return;
        }
        this._endTime = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(endTimestamp);
        (0, $ac09a37575b310ba$export$b77c830667a4d630)(this);
        this._onSpanEnded();
        this._frozen = (0, $f7bbc910493e6179$export$a9ba2a501dbf6a56)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $cac16f6eada858e7$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $fdf17a1e56d9d4ca$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879],
            measurements: (0, $293a838d63649350$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $cac16f6eada858e7$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        var _this__name, _this__endTime;
        return {
            name: (_this__name = this._name) !== null && _this__name !== void 0 ? _this__name : "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: (_this__endTime = this._endTime) !== null && _this__endTime !== void 0 ? _this__endTime : this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this),
            status: (0, $cac16f6eada858e7$export$d3856a3187d34821)(this._status),
            attributes: (0, $cac16f6eada858e7$export$1464a9cb828ba99f)(this._attributes, this._status),
            links: (0, $cac16f6eada858e7$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $4c5fac8529c371f2$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        const attributes = $4c5fac8529c371f2$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $4c5fac8529c371f2$var$sendSpanEnvelope((0, $0ca80a3f5337ad93$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = (0, $04d4fb9bc11b3e87$export$ccd123f3ffd8eb3)();
            if (strategy2) {
                const scope2 = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this).scope || (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && (0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this).scope || (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
        const strategy = (0, $04d4fb9bc11b3e87$export$ccd123f3ffd8eb3)();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        var _capturedSpanScope_getScopeData_sdkProcessingMetadata, _options_onSpanCaptured;
        if (!$4c5fac8529c371f2$var$isFullFinishedSpan((0, $cac16f6eada858e7$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 ? void 0 : (_capturedSpanScope_getScopeData_sdkProcessingMetadata = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope_getScopeData_sdkProcessingMetadata === void 0 ? void 0 : _capturedSpanScope_getScopeData_sdkProcessingMetadata.normalizedRequest;
        if (this._sampled !== true) return void 0;
        (_options_onSpanCaptured = options.onSpanCaptured) === null || _options_onSpanCaptured === void 0 ? void 0 : _options_onSpanCaptured.call(options, this);
        const spans = [];
        for (const descendant of (0, $cac16f6eada858e7$export$340c5c8a13ffc680)(this)){
            var _options_isSpanAlreadyCaptured, _options_onSpanCaptured1;
            if (descendant === this || $4c5fac8529c371f2$var$isStandaloneSpan(descendant) || ((_options_isSpanAlreadyCaptured = options.isSpanAlreadyCaptured) === null || _options_isSpanAlreadyCaptured === void 0 ? void 0 : _options_isSpanAlreadyCaptured.call(options, descendant))) continue;
            const spanJSON = (0, $cac16f6eada858e7$export$92d8c23565496537)(descendant);
            if (!$4c5fac8529c371f2$var$isFullFinishedSpan(spanJSON)) continue;
            (_options_onSpanCaptured1 = options.onSpanCaptured) === null || _options_onSpanCaptured1 === void 0 ? void 0 : _options_onSpanCaptured1.call(options, descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405];
        delete this._attributes[0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            var _span_op;
            delete span.data[0, $fdf17a1e56d9d4ca$export$165ce9a229f6f050];
            if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            contexts: {
                trace: (0, $cac16f6eada858e7$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $4c5fac8529c371f2$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $4c5fac8529c371f2$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest
        }, source && {
            transaction_info: {
                source: source
            }
        });
        const measurements = (0, $293a838d63649350$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f56fc4041ba3a369$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: "manual",
            [(0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09)]: spanContext.op
        }, spanContext.attributes));
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
}
function $4c5fac8529c371f2$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $4c5fac8529c371f2$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $4c5fac8529c371f2$var$isStandaloneSpan(span) {
    return span instanceof $4c5fac8529c371f2$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $4c5fac8529c371f2$var$sendSpanEnvelope(envelope) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $93c45d57befd4356$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $93c45d57befd4356$export$a1bd95187356f372(options, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $93c45d57befd4356$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
            const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, client) : $93c45d57befd4356$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$93c45d57befd4356$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e47550d94a838770$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $93c45d57befd4356$export$c10292ad04b92aea(options, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope === null || customScope === void 0 ? void 0 : customScope.clone();
    return (0, $6486f3d311605b78$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $93c45d57befd4356$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
            const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, (0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) : $93c45d57befd4356$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$93c45d57befd4356$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e47550d94a838770$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $cac16f6eada858e7$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $f217ebe7a0a6fc3c$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $93c45d57befd4356$export$63dbba021a6b4047(options) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $93c45d57befd4356$var$_startInactiveSpanImpl(options);
}
function $93c45d57befd4356$export$8672cc6c19af377a(options) {
    return $93c45d57befd4356$var$_startInactiveSpanImpl(options);
}
function $93c45d57befd4356$var$_startInactiveSpanImpl(options) {
    const spanArguments = $93c45d57befd4356$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $6486f3d311605b78$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$93c45d57befd4356$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
        const parentSpan = $93c45d57befd4356$var$getParentSpan(scope, customParentSpan);
        const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, client);
        return $93c45d57befd4356$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $93c45d57befd4356$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    const acs = (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $4d0fefb7946dcfa7$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $ae017cc8b57317cd$export$18811bc99eefceaa)(client, incomingDsc === null || incomingDsc === void 0 ? void 0 : incomingDsc.org_id)) return $93c45d57befd4356$export$f90b03291402f553(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $ae017cc8b57317cd$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $93c45d57befd4356$export$e57ac09b143d92a2(span, callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        (0, $9f9cfe5727c3ad26$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $93c45d57befd4356$export$869298f9835abc68(callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$93c45d57befd4356$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$93c45d57befd4356$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $93c45d57befd4356$export$7d5f2376f7cf513(scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)()) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$93c45d57befd4356$export$61ab4e30f2201736] === true;
}
function $93c45d57befd4356$export$f90b03291402f553(callback) {
    const acs = $93c45d57befd4356$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $f56fc4041ba3a369$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $8aca1af6321ba44f$export$9869d72de32a3917)()
        });
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $93c45d57befd4356$export$e57ac09b143d92a2(null, callback);
    });
}
function $93c45d57befd4356$var$startMissingRequiredParentSpan(scope, client) {
    client === null || client === void 0 ? void 0 : client.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(span, scope, (0, $6486f3d311605b78$export$68f3af03034c9e90)());
    return span;
}
function $93c45d57befd4356$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    if (!(0, $8540c501196729c9$export$1f70765132c3c225)()) {
        const scopePropagationContext = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, span2);
        (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if ($93c45d57befd4356$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$93c45d57befd4356$export$7d5f2376f7cf513(scope)) client === null || client === void 0 ? void 0 : client.recordDroppedEvent("ignored", "span");
        var _parentSpan_spanContext_traceId;
        const ignoredSpan = new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: (_parentSpan_spanContext_traceId = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext().traceId) !== null && _parentSpan_spanContext_traceId !== void 0 ? _parentSpan_spanContext_traceId : scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, ignoredSpan);
        (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $93c45d57befd4356$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $5c79f8c2b5cb59fa$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(parentSpan);
        span = $93c45d57befd4356$var$_startRootSpan((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, isolationScope.getPropagationContext(), scope.getPropagationContext());
        span = $93c45d57befd4356$var$_startRootSpan((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            traceId: traceId,
            parentSpanId: parentSpanId
        }, spanArguments), scope, isolationScope, parentSampled);
        if (dsc) (0, $5c79f8c2b5cb59fa$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $ac09a37575b310ba$export$2f3d84e767c9592b)(span);
    return span;
}
function $93c45d57befd4356$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        isStandalone: exp.standalone
    }, options);
    if (options.startTime) {
        const ctx = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialCtx);
        ctx.startTimestamp = (0, $cac16f6eada858e7$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $93c45d57befd4356$var$getAcs() {
    const carrier = (0, $3d29ea41beb10247$export$19eade501500c6c1)();
    return (0, $e26a4b07a4ad38af$export$f639b0c2752203be)(carrier);
}
function $93c45d57befd4356$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    var _currentPropagationContext_dsc;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanArguments.attributes),
        spanName: name,
        parentSampled: parentSampled
    };
    client === null || client === void 0 ? void 0 : client.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    var _mutableSpanSamplingData_parentSampled;
    const finalParentSampled = (_mutableSpanSamplingData_parentSampled = mutableSpanSamplingData.parentSampled) !== null && _mutableSpanSamplingData_parentSampled !== void 0 ? _mutableSpanSamplingData_parentSampled : parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $93c45d57befd4356$export$7d5f2376f7cf513(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : (0, $c763fd1ae3ee0fd4$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $ab7c7053b878f035$export$a5bd2d81656d9546)((_currentPropagationContext_dsc = currentPropagationContext.dsc) === null || _currentPropagationContext_dsc === void 0 ? void 0 : _currentPropagationContext_dsc.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $4c5fac8529c371f2$export$a92149b045260d9f)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanArguments), {
        attributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: "custom",
            [(0, $fdf17a1e56d9d4ca$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0
        }, finalAttributes),
        sampled: sampled
    }));
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $93c45d57befd4356$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $93c45d57befd4356$export$7d5f2376f7cf513(scope);
    const sampled = _isTracingSuppressed ? false : (0, $cac16f6eada858e7$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $4c5fac8529c371f2$export$a92149b045260d9f)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, spanArguments), {
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    })) : new (0, $ca20a23f2fb66f57$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $cac16f6eada858e7$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $f7bbc910493e6179$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client) && (0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $93c45d57befd4356$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $9f9cfe5727c3ad26$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $cac16f6eada858e7$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $93c45d57befd4356$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $93c45d57befd4356$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $93c45d57befd4356$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    var _spanArguments_attributes;
    const ignoreSpans = client === null || client === void 0 ? void 0 : client.getOptions().ignoreSpans;
    if (!client || !(0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client) || !(ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length)) return false;
    return (0, $3ba72cc613510e20$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: ((_spanArguments_attributes = spanArguments.attributes) === null || _spanArguments_attributes === void 0 ? void 0 : _spanArguments_attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09]) || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $93c45d57befd4356$export$b0b1bd7d4bdbd54e(span) {
    return (0, $ca20a23f2fb66f57$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}













const $29c1921438eb1933$var$STATE_PENDING = 0;
const $29c1921438eb1933$var$STATE_RESOLVED = 1;
const $29c1921438eb1933$var$STATE_REJECTED = 2;
function $29c1921438eb1933$export$1fda8aa4d135f8aa(value) {
    return new $29c1921438eb1933$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
function $29c1921438eb1933$export$78e43115b553f358(reason) {
    return new $29c1921438eb1933$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
class $29c1921438eb1933$export$6f292d4960313241 {
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $29c1921438eb1933$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $29c1921438eb1933$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $29c1921438eb1933$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $29c1921438eb1933$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $29c1921438eb1933$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $29c1921438eb1933$var$STATE_PENDING) return;
            if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($29c1921438eb1933$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($29c1921438eb1933$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
    constructor(executor){
        this._state = $29c1921438eb1933$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
}


function $769941f266d7f5f1$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $769941f266d7f5f1$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $85e272e760900bb9$export$f5b060c2914b97c8)(result) ? result : (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $29c1921438eb1933$export$78e43115b553f358)(error);
    }
}
function $769941f266d7f5f1$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), hint);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && result === null && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(result)) return result.then((final)=>$769941f266d7f5f1$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $769941f266d7f5f1$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $1e2af912048c6c6b$var$parsedStackResults;
let $1e2af912048c6c6b$var$lastSentryKeysCount;
let $1e2af912048c6c6b$var$lastNativeKeysCount;
let $1e2af912048c6c6b$var$cachedFilenameDebugIds;
function $1e2af912048c6c6b$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($1e2af912048c6c6b$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $1e2af912048c6c6b$var$lastSentryKeysCount && nativeDebugIdKeys.length === $1e2af912048c6c6b$var$lastNativeKeysCount) return $1e2af912048c6c6b$var$cachedFilenameDebugIds;
    $1e2af912048c6c6b$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $1e2af912048c6c6b$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $1e2af912048c6c6b$var$cachedFilenameDebugIds = {};
    if (!$1e2af912048c6c6b$var$parsedStackResults) $1e2af912048c6c6b$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $1e2af912048c6c6b$var$parsedStackResults === null || $1e2af912048c6c6b$var$parsedStackResults === void 0 ? void 0 : $1e2af912048c6c6b$var$parsedStackResults[key];
            if (result && $1e2af912048c6c6b$var$cachedFilenameDebugIds && debugId) {
                $1e2af912048c6c6b$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($1e2af912048c6c6b$var$parsedStackResults) $1e2af912048c6c6b$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                    if (filename && $1e2af912048c6c6b$var$cachedFilenameDebugIds && $1e2af912048c6c6b$var$parsedStackResults) {
                        $1e2af912048c6c6b$var$cachedFilenameDebugIds[filename] = debugId;
                        $1e2af912048c6c6b$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $1e2af912048c6c6b$var$cachedFilenameDebugIds;
}
function $1e2af912048c6c6b$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $1e2af912048c6c6b$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $a6df8b9dd4ca405a$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}








function $670d18f27a56af80$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $df365b8ef5885c2b$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)()
    });
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $670d18f27a56af80$export$d7e04067a6fbc882(prepared, options);
    $670d18f27a56af80$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $670d18f27a56af80$export$63042efc86f043e7(prepared, options.stackParser);
    const finalScope = $670d18f27a56af80$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = (0, $d1de0be2af275d5b$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $d1de0be2af275d5b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(prepared) : (0, $769941f266d7f5f1$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) $670d18f27a56af80$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $670d18f27a56af80$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $670d18f27a56af80$export$d7e04067a6fbc882(event, options) {
    var _event_exception_values, _event_exception;
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || (0, $370456451b52ff1d$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if ((request === null || request === void 0 ? void 0 : request.url) && maxValueLength) request.url = (0, $6c937b4b236937d4$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        if (exception.value) exception.value = (0, $6c937b4b236937d4$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
function $670d18f27a56af80$export$63042efc86f043e7(event, stackParser) {
    var _event_exception_values, _event_exception;
    const filenameDebugIdMap = (0, $1e2af912048c6c6b$export$e069fee9c632ed00)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $670d18f27a56af80$export$1be657ba8ef44ff0(event) {
    var _event_exception_values, _event_exception;
    const filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $670d18f27a56af80$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $670d18f27a56af80$var$normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    const normalized = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map((b)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, b, b.data && {
                data: (0, $7879d292a118e15d$export$a3295358bff77e)(b.data, depth, maxBreadth)
            }))
    }, event.user && {
        user: (0, $7879d292a118e15d$export$a3295358bff77e)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $7879d292a118e15d$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $7879d292a118e15d$export$a3295358bff77e)(event.extra, depth, maxBreadth)
    });
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $7879d292a118e15d$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, span, span.data && {
            data: (0, $7879d292a118e15d$export$a3295358bff77e)(span.data, depth, maxBreadth)
        });
    });
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, $7879d292a118e15d$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $670d18f27a56af80$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $88388f6b019104ff$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
function $670d18f27a56af80$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($670d18f27a56af80$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($670d18f27a56af80$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $670d18f27a56af80$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $88388f6b019104ff$export$775b6bb06e53a214) || typeof hint === "function";
}
const $670d18f27a56af80$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $670d18f27a56af80$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$670d18f27a56af80$var$captureContextKeys.includes(key));
}





function $bb3616fd55b6cdc0$export$f5282963edea4a68(exception, hint) {
    return (0, $6486f3d311605b78$export$c7be4b0125a10cba)().captureException(exception, (0, $670d18f27a56af80$export$76b5f966996d1653)(hint));
}
function $bb3616fd55b6cdc0$export$45654777c133ae80(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $6486f3d311605b78$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
function $bb3616fd55b6cdc0$export$1462b974fdcf6ba2(event, hint) {
    return (0, $6486f3d311605b78$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
function $bb3616fd55b6cdc0$export$2f04de43fe27971a(name, context) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setContext(name, context);
}
function $bb3616fd55b6cdc0$export$bb4922da0dd51b92(extras) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setExtras(extras);
}
function $bb3616fd55b6cdc0$export$8e8e7789d42ed61d(key, extra) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setExtra(key, extra);
}
function $bb3616fd55b6cdc0$export$74a8fb34822092e6(tags) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setTags(tags);
}
function $bb3616fd55b6cdc0$export$a37d07ee78eb4569(key, value) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setTag(key, value);
}
function $bb3616fd55b6cdc0$export$74da2cba014bdc09(attributes) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setAttributes(attributes);
}
function $bb3616fd55b6cdc0$export$9fec4d97f1922e0b(key, value) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setAttribute(key, value);
}
function $bb3616fd55b6cdc0$export$8b6bb3dd62a01be2(user) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setUser(user);
}
function $bb3616fd55b6cdc0$export$58213391a19e392(conversationId) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().setConversationId(conversationId);
}
function $bb3616fd55b6cdc0$export$5d4e9fd7fac8e617() {
    return (0, $6486f3d311605b78$export$68f3af03034c9e90)().lastEventId();
}
function $bb3616fd55b6cdc0$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
}
function $bb3616fd55b6cdc0$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $bb3616fd55b6cdc0$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = (0, $b007b72e24b33b62$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $bb3616fd55b6cdc0$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return (0, $6486f3d311605b78$export$9a4fed82c350c2bd)(()=>(upsertMonitorConfig === null || upsertMonitorConfig === void 0 ? void 0 : upsertMonitorConfig.isolateTrace) ? (0, $93c45d57befd4356$export$f90b03291402f553)(runCallback) : runCallback());
}
async function $bb3616fd55b6cdc0$export$4909b86c8034bf73(timeout) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $bb3616fd55b6cdc0$export$8360e631d277ea4d(timeout) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $bb3616fd55b6cdc0$export$3f95c6f800b78024() {
    return !!(0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
}
function $bb3616fd55b6cdc0$export$3b029eb57ac4d562() {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
function $bb3616fd55b6cdc0$export$9aac0b9f77928fbf(callback) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().addEventProcessor(callback);
}
function $bb3616fd55b6cdc0$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    const { user: user } = (0, $d1de0be2af275d5b$export$cc422922fcbb91c6)(isolationScope, (0, $6486f3d311605b78$export$c7be4b0125a10cba)());
    const { userAgent: userAgent } = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $4ea28bfd5ee93486$export$14a186326edbb264)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        user: user
    }, userAgent && {
        userAgent: userAgent
    }, context));
    const currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === "ok") (0, $4ea28bfd5ee93486$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $bb3616fd55b6cdc0$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $bb3616fd55b6cdc0$export$17a5be43989a0bc1() {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    const currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $4ea28bfd5ee93486$export$56521d9ba90f62ee)(session);
    $bb3616fd55b6cdc0$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $bb3616fd55b6cdc0$var$_sendSessionUpdate() {
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $bb3616fd55b6cdc0$export$667e7b4d445d566b(end = false) {
    if (end) {
        $bb3616fd55b6cdc0$export$17a5be43989a0bc1();
        return;
    }
    $bb3616fd55b6cdc0$var$_sendSessionUpdate();
}



const $5169eff32bb2cc1c$var$OPERA10_PRIORITY = 10;
const $5169eff32bb2cc1c$var$OPERA11_PRIORITY = 20;
const $5169eff32bb2cc1c$var$CHROME_PRIORITY = 30;
const $5169eff32bb2cc1c$var$WINJS_PRIORITY = 40;
const $5169eff32bb2cc1c$var$GECKO_PRIORITY = 50;
function $5169eff32bb2cc1c$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $5169eff32bb2cc1c$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $5169eff32bb2cc1c$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $5169eff32bb2cc1c$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $5169eff32bb2cc1c$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $5169eff32bb2cc1c$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($5169eff32bb2cc1c$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $5169eff32bb2cc1c$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $5169eff32bb2cc1c$var$createFrame(filename, (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +line2, +col);
    }
    const parts = $5169eff32bb2cc1c$var$chromeRegex.exec(line);
    if (parts) {
        var _parts_;
        const isEval = ((_parts_ = parts[2]) === null || _parts_ === void 0 ? void 0 : _parts_.indexOf("eval")) === 0;
        if (isEval) {
            const subMatch = $5169eff32bb2cc1c$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $5169eff32bb2cc1c$var$extractSafariExtensionDetails(parts[1] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), parts[2]);
        return $5169eff32bb2cc1c$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $5169eff32bb2cc1c$export$263a749fff749872 = [
    $5169eff32bb2cc1c$var$CHROME_PRIORITY,
    $5169eff32bb2cc1c$var$chromeStackParserFn
];
const $5169eff32bb2cc1c$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $5169eff32bb2cc1c$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $5169eff32bb2cc1c$var$gecko = (line)=>{
    const parts = $5169eff32bb2cc1c$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $5169eff32bb2cc1c$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac);
        [func, filename] = $5169eff32bb2cc1c$var$extractSafariExtensionDetails(func, filename);
        return $5169eff32bb2cc1c$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $5169eff32bb2cc1c$export$cdba47a5dd2804d = [
    $5169eff32bb2cc1c$var$GECKO_PRIORITY,
    $5169eff32bb2cc1c$var$gecko
];
const $5169eff32bb2cc1c$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $5169eff32bb2cc1c$var$winjs = (line)=>{
    const parts = $5169eff32bb2cc1c$var$winjsRegex.exec(line);
    return parts ? $5169eff32bb2cc1c$var$createFrame(parts[2], parts[1] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $5169eff32bb2cc1c$export$179460296da408e8 = [
    $5169eff32bb2cc1c$var$WINJS_PRIORITY,
    $5169eff32bb2cc1c$var$winjs
];
const $5169eff32bb2cc1c$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $5169eff32bb2cc1c$var$opera10 = (line)=>{
    const parts = $5169eff32bb2cc1c$var$opera10Regex.exec(line);
    return parts ? $5169eff32bb2cc1c$var$createFrame(parts[2], parts[3] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +parts[1]) : void 0;
};
const $5169eff32bb2cc1c$export$f892b52c880ffc7a = [
    $5169eff32bb2cc1c$var$OPERA10_PRIORITY,
    $5169eff32bb2cc1c$var$opera10
];
const $5169eff32bb2cc1c$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $5169eff32bb2cc1c$var$opera11 = (line)=>{
    const parts = $5169eff32bb2cc1c$var$opera11Regex.exec(line);
    return parts ? $5169eff32bb2cc1c$var$createFrame(parts[5], parts[3] || parts[4] || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : void 0;
};
const $5169eff32bb2cc1c$export$af11af13f09fb0dc = [
    $5169eff32bb2cc1c$var$OPERA11_PRIORITY,
    $5169eff32bb2cc1c$var$opera11
];
const $5169eff32bb2cc1c$export$7197c0fe6554c079 = [
    $5169eff32bb2cc1c$export$263a749fff749872,
    $5169eff32bb2cc1c$export$cdba47a5dd2804d
];
const $5169eff32bb2cc1c$export$2b2b997d81bf3907 = (0, $a6df8b9dd4ca405a$export$a5739666fb2d03d4)(...$5169eff32bb2cc1c$export$7197c0fe6554c079);
const $5169eff32bb2cc1c$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



function $18106c32f7a600ff$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//);
    return !isInternal && filename !== void 0 && !filename.includes("node_modules/");
}
function $18106c32f7a600ff$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    const DATA_URI_MATCH = /at (?:async )?(.+?) \(data:(.*?),/;
    return (line)=>{
        const dataUriMatch = line.match(DATA_URI_MATCH);
        if (dataUriMatch) return {
            filename: `<data:${dataUriMatch[2]}>`,
            function: dataUriMatch[1]
        };
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = void 0;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = void 0;
                functionName = void 0;
            }
            if (functionName === void 0) {
                methodName = methodName || (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac);
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = (0, $a6df8b9dd4ca405a$export$60c0d6c8e038267a)(lineMatch[2]);
            const isNative = lineMatch[5] === "native";
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const maybeDecodedFilename = filename ? $18106c32f7a600ff$var$_safeDecodeURI(filename) : void 0;
            return {
                filename: maybeDecodedFilename !== null && maybeDecodedFilename !== void 0 ? maybeDecodedFilename : filename,
                module: maybeDecodedFilename && (getModule === null || getModule === void 0 ? void 0 : getModule(maybeDecodedFilename)),
                function: functionName,
                lineno: $18106c32f7a600ff$var$_parseIntOrUndefined(lineMatch[3]),
                colno: $18106c32f7a600ff$var$_parseIntOrUndefined(lineMatch[4]),
                in_app: $18106c32f7a600ff$export$1de92f38f4de99a8(filename || "", isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return void 0;
    };
}
function $18106c32f7a600ff$export$673345a0da635a78(getModule) {
    return [
        90,
        $18106c32f7a600ff$export$35059013cd4a06db(getModule)
    ];
}
function $18106c32f7a600ff$var$_parseIntOrUndefined(input) {
    return parseInt(input || "", 10) || void 0;
}
function $18106c32f7a600ff$var$_safeDecodeURI(filename) {
    try {
        return decodeURI(filename);
    } catch (e) {
        return void 0;
    }
}


const $973693a0215d9dfd$var$STACKTRACE_FRAME_LIMIT = 50;
const [, $973693a0215d9dfd$var$chrome] = (0, $5169eff32bb2cc1c$export$263a749fff749872);
const [, $973693a0215d9dfd$var$node] = (0, $18106c32f7a600ff$export$673345a0da635a78)();
/**
 * A stack parser than combines Chrome and node.js parsers to give the best results even when nodeIntegration = true
 */ const $973693a0215d9dfd$export$d6d804653700038a = (stack, skipFirst = 0)=>{
    const frames = [];
    for (const line of stack.split('\n').slice(skipFirst)){
        const chromeFrame = $973693a0215d9dfd$var$chrome(line);
        const nodeFrame = $973693a0215d9dfd$var$node(line);
        // We favour the chrome parser unless in_app == false
        if (chromeFrame && (nodeFrame === null || nodeFrame === void 0 ? void 0 : nodeFrame.in_app) !== false) frames.push(chromeFrame);
        else if (nodeFrame) {
            if (nodeFrame.module === undefined) delete nodeFrame.module;
            frames.push(nodeFrame);
        }
        if (frames.length >= $973693a0215d9dfd$var$STACKTRACE_FRAME_LIMIT) break;
    }
    return (0, $a6df8b9dd4ca405a$export$c55c24c0eeba0205)(frames);
};







const $425e0f9c169ee798$export$b14a8888f80a0b3e = [];
function $425e0f9c169ee798$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $425e0f9c169ee798$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $425e0f9c169ee798$var$filterDuplicates(integrations);
}
function $425e0f9c169ee798$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration === null || integration === void 0 ? void 0 : integration.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $425e0f9c169ee798$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $425e0f9c169ee798$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
}
function $425e0f9c169ee798$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$425e0f9c169ee798$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $425e0f9c169ee798$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $425e0f9c169ee798$export$2d8f5188773bcddd(integration) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $425e0f9c169ee798$export$2323046b9414659f(fn) {
    return fn;
}
function $425e0f9c169ee798$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, integration, extendedIntegration);
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}



const $16f890b5e511ac25$export$3a3de876bc5e2aa7 = (0, $425e0f9c169ee798$export$2323046b9414659f)((options)=>{
    var _options_threshold;
    const anrThreshold = (_options_threshold = options === null || options === void 0 ? void 0 : options.threshold) !== null && _options_threshold !== void 0 ? _options_threshold : 1000;
    const pollInterval = (options === null || options === void 0 ? void 0 : options.pollInterval) || anrThreshold / 2;
    return {
        name: 'EventLoopBlockRenderer',
        setup (client) {
            const config = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                pollInterval: pollInterval,
                anrThreshold: anrThreshold,
                captureStackTrace: true
            }, options);
            const ipc = (0, $2ee8f950f6923ed9$export$4d0c35c3c1a4776f)(client);
            // eslint-disable-next-line no-restricted-globals
            ipc.sendStatus({
                status: document.visibilityState,
                config: config
            });
            setInterval(()=>{
                ipc.sendStatus({
                    status: 'alive',
                    config: config
                });
            }, config.pollInterval);
        }
    };
});








const $d33fc4dd6add5ea5$var$INTEGRATION_NAME = "ConversationId";
const $d33fc4dd6add5ea5$var$_conversationIdIntegration = ()=>{
    return {
        name: $d33fc4dd6add5ea5$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $6486f3d311605b78$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = (0, $cac16f6eada858e7$export$92d8c23565496537)(span);
                    if (!(op === null || op === void 0 ? void 0 : op.startsWith("gen_ai.")) && !attributes["ai.operationId"] && !(name === null || name === void 0 ? void 0 : name.startsWith("ai."))) return;
                    span.setAttribute((0, $fdf17a1e56d9d4ca$export$71a4a707257f2774), conversationId);
                }
            });
        }
    };
};
const $d33fc4dd6add5ea5$export$97457a453081a5b3 = (0, $425e0f9c169ee798$export$2323046b9414659f)($d33fc4dd6add5ea5$var$_conversationIdIntegration);





const $ba9fe14e35164f86$var$INTEGRATION_NAME = "Dedupe";
const $ba9fe14e35164f86$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $ba9fe14e35164f86$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($ba9fe14e35164f86$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (e) {}
            return previousEvent = currentEvent;
        }
    };
};
const $ba9fe14e35164f86$export$6d39aa44cd0c7567 = (0, $425e0f9c169ee798$export$2323046b9414659f)($ba9fe14e35164f86$var$_dedupeIntegration);
function $ba9fe14e35164f86$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($ba9fe14e35164f86$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($ba9fe14e35164f86$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $ba9fe14e35164f86$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$ba9fe14e35164f86$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ba9fe14e35164f86$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ba9fe14e35164f86$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $ba9fe14e35164f86$var$_getExceptionFromEvent(previousEvent);
    const currentException = $ba9fe14e35164f86$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$ba9fe14e35164f86$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$ba9fe14e35164f86$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $ba9fe14e35164f86$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $a6df8b9dd4ca405a$export$91d8ca51bd9f6a47)(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $ba9fe14e35164f86$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (e) {
        return false;
    }
}
function $ba9fe14e35164f86$var$_getExceptionFromEvent(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}




const $af5076b22b0f565c$var$INTEGRATION_NAME = "FunctionToString";
const $af5076b22b0f565c$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $af5076b22b0f565c$var$_functionToStringIntegration = ()=>{
    return {
        name: $af5076b22b0f565c$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = new Proxy(originalFunctionToString, {
                    apply (target, thisArg, args) {
                        const originalFunction = (0, $85a434b6cfc19e37$export$e6cc1e135e2092e5)(thisArg);
                        let context = thisArg;
                        try {
                            if ($af5076b22b0f565c$var$SETUP_CLIENTS.has((0, $6486f3d311605b78$export$6bb76d6eba7e258c)()) && originalFunction) context = originalFunction;
                        } catch (e) {}
                        return Reflect.apply(target, context, args);
                    }
                });
            } catch (e) {}
        },
        setup (client) {
            $af5076b22b0f565c$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $af5076b22b0f565c$export$7918117e9202e4fb = (0, $425e0f9c169ee798$export$2323046b9414659f)($af5076b22b0f565c$var$_functionToStringIntegration);






function $6fb56feda9bd3e8a$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {}
    return possibleMessages;
}




const $cc458e21b964fdb2$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $cc458e21b964fdb2$var$INTEGRATION_NAME = "EventFilters";
const $cc458e21b964fdb2$export$9a84f518c163c552 = (0, $425e0f9c169ee798$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $cc458e21b964fdb2$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $cc458e21b964fdb2$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $cc458e21b964fdb2$var$_mergeOptions(options, clientOptions);
            }
            return $cc458e21b964fdb2$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $cc458e21b964fdb2$export$cb3c5c2ceb9818ba = (0, $425e0f9c169ee798$export$2323046b9414659f)((options = {})=>{
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $cc458e21b964fdb2$export$9a84f518c163c552(options)), {
        name: "InboundFilters"
    });
});
function $cc458e21b964fdb2$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $cc458e21b964fdb2$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $cc458e21b964fdb2$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($cc458e21b964fdb2$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($cc458e21b964fdb2$var$_isUselessError(event)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($cc458e21b964fdb2$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}.
Url: ${$cc458e21b964fdb2$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$cc458e21b964fdb2$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}.
Url: ${$cc458e21b964fdb2$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($cc458e21b964fdb2$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $cc458e21b964fdb2$var$_isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return (0, $6fb56feda9bd3e8a$export$d55a97c329cacfcc)(event).some((message)=>(0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $cc458e21b964fdb2$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    const name = event.transaction;
    return name ? (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $cc458e21b964fdb2$var$_isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    const url = $cc458e21b964fdb2$var$_getEventFilterUrl(event);
    return !url ? false : (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $cc458e21b964fdb2$var$_isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    const url = $cc458e21b964fdb2$var$_getEventFilterUrl(event);
    return !url ? true : (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $cc458e21b964fdb2$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $cc458e21b964fdb2$var$_getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        const rootException = [
            ...(_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []
        ].reverse().find((value)=>{
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === void 0 && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        const frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? $cc458e21b964fdb2$var$_getLastValidUrl(frames) : null;
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $df365b8ef5885c2b$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $cc458e21b964fdb2$var$_isUselessError(event) {
    var _event_exception_values, _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




function $5adaab7f928cd880$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) (0, $d8898b8567c29ee9$export$1c9f709888824e05).enable();
        else (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $5adaab7f928cd880$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
function $5adaab7f928cd880$export$ecb76f41d43c0e43(client) {
    (0, $6486f3d311605b78$export$c7be4b0125a10cba)().setClient(client);
}





function $5e2903ba91c783d2$export$3e12ad68afa434ac(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === void 0) objWithMaybeUser.user = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objWithMaybeUser.user), {
        ip_address: "{{auto}}"
    });
}
function $5e2903ba91c783d2$export$e8e2d07ba63e2b6c(session) {
    var _session_attrs;
    if ("aggregates" in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs["ip_address"]) === void 0) session.attrs = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, session.attrs), {
            ip_address: "{{auto}}"
        });
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}


function $1ca02136df3c52aa$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: (0, $961dedfff8dbd514$export$31499a9cd224b78c)
            }));
        sdk.version = (0, $961dedfff8dbd514$export$31499a9cd224b78c);
    }
}




const $8c0899c4b9f5d22e$export$9207631ea4ce5c48 = "7";
function $8c0899c4b9f5d22e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $8c0899c4b9f5d22e$var$_getIngestEndpoint(dsn) {
    return `${$8c0899c4b9f5d22e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $8c0899c4b9f5d22e$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $8c0899c4b9f5d22e$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $8c0899c4b9f5d22e$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$8c0899c4b9f5d22e$var$_getIngestEndpoint(dsn)}?${$8c0899c4b9f5d22e$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $8c0899c4b9f5d22e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $94fe38c0afc4d11c$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$8c0899c4b9f5d22e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $94fe38c0afc4d11c$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


















function $f95e436d28aaeac1$export$f6f6d4b2a7942521(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, span.data),
        links: span.links
    };
    return (0, $cac16f6eada858e7$export$5402aa553bcf35f3)(streamedSpan);
}


function $2c90e60f3ada509e$export$9aeb9a2b899f8587(event, client) {
    var _event_spans, _event_sdkProcessingMetadata, _span_op;
    if (event.type !== "transaction" || !((_event_spans = event.spans) === null || _event_spans === void 0 ? void 0 : _event_spans.length) || !((_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.hasGenAiSpans) || client.getOptions().streamGenAiSpans === false || (0, $5da71dc6e7ad8d8b$export$6ea47215d699c04a)(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if ((_span_op = span.op) === null || _span_op === void 0 ? void 0 : _span_op.startsWith("gen_ai.")) genAiSpans.push((0, $f95e436d28aaeac1$export$f6f6d4b2a7942521)(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            version: 2
        }, (0, $3a8ae0c240b87a96$export$4e09c449d6c407f7)() && {
            ingest_settings: {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            }
        }), {
            items: genAiSpans
        })
    ];
}






function $fe59e0d26f85c06d$export$630056cb83d87863(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}


const $37fe8c4357879c39$export$c8667f1887a128dc = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $37fe8c4357879c39$export$85a4f67f852183e6(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return (0, $29c1921438eb1933$export$78e43115b553f358)($37fe8c4357879c39$export$c8667f1887a128dc);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $fe59e0d26f85c06d$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}




const $b20b411e20ea6eb5$export$b09ce39faaeb1e7c = 60000;
function $b20b411e20ea6eb5$export$615352e17ed7741(header, now = (0, $8aca1af6321ba44f$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $b20b411e20ea6eb5$export$b09ce39faaeb1e7c;
}
function $b20b411e20ea6eb5$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $b20b411e20ea6eb5$export$6c91fec22056810a(limits, dataCategory, now = (0, $8aca1af6321ba44f$export$65b1bada40c91b34)()) {
    return $b20b411e20ea6eb5$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $b20b411e20ea6eb5$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $8aca1af6321ba44f$export$65b1bada40c91b34)()) {
    const updatedRateLimits = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, limits);
    const rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $b20b411e20ea6eb5$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $fd4b80e45f21271b$export$e515cf6dfd2f98b8 = 64;
function $fd4b80e45f21271b$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $37fe8c4357879c39$export$85a4f67f852183e6)(options.bufferSize || $fd4b80e45f21271b$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        (0, $5e31f551d021d379$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $5e31f551d021d379$export$b11169581eeaf237)(type);
            if ((0, $b20b411e20ea6eb5$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $5e31f551d021d379$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ((0, $5e31f551d021d379$export$604a45d95a155e2b)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $5e31f551d021d379$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $5e31f551d021d379$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $5e31f551d021d379$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ((0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $b20b411e20ea6eb5$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $37fe8c4357879c39$export$c8667f1887a128dc)) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




function $cf3e39e4079becde$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $5e31f551d021d379$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}



















function $86741795a2158fb1$export$d9c6b2464b0a687e(event) {
    var _event_contexts;
    var _event_contexts_trace;
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {};
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : "",
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : "",
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[0, $fdf17a1e56d9d4ca$export$1efec95406bbe327],
        exclusive_time: data === null || data === void 0 ? void 0 : data[0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
function $86741795a2158fb1$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, span.data, span.profile_id && {
                    [(0, $fdf17a1e56d9d4ca$export$1efec95406bbe327)]: span.profile_id
                }, span.exclusive_time && {
                    [(0, $fdf17a1e56d9d4ca$export$fea48ba9f4550879)]: span.exclusive_time
                })
            }
        },
        measurements: span.measurements
    };
}


const $e25ff1e4d1950bc6$export$59adc876c1ebd512 = "[Filtered]";
const $e25ff1e4d1950bc6$export$8d9b1945e94c47d = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $e25ff1e4d1950bc6$export$cdee6254fbd57505 = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $e25ff1e4d1950bc6$export$6f34743829a9a6fb = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];


function $912bb47802ceb85b$export$8d055982fdc6ee04(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: (0, $e25ff1e4d1950bc6$export$8d9b1945e94c47d)
        },
        httpHeaders: {
            request: {
                deny: (0, $e25ff1e4d1950bc6$export$8d9b1945e94c47d)
            },
            response: {
                deny: (0, $e25ff1e4d1950bc6$export$8d9b1945e94c47d)
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: (0, $e25ff1e4d1950bc6$export$8d9b1945e94c47d)
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}


const $c636246ba52b9790$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $c636246ba52b9790$export$e0e409941f20a4c(options) {
    var _dc_httpHeaders, _dc_httpHeaders1, _dc_graphQL, _dc_graphQL1, _dc_genAI, _dc_genAI1;
    const base = options.dataCollection != null ? $c636246ba52b9790$var$DEFAULTS : (0, $912bb47802ceb85b$export$8d055982fdc6ee04)(options.sendDefaultPii);
    var _options_dataCollection;
    const dc = (_options_dataCollection = options.dataCollection) !== null && _options_dataCollection !== void 0 ? _options_dataCollection : {};
    var _dc_userInfo, _dc_cookies, _dc_httpHeaders_request, _dc_httpHeaders_response, _dc_httpBodies, _dc_urlQueryParams, _ref, _dc_graphQL_document, _dc_graphQL_variables, _dc_genAI_inputs, _dc_genAI_outputs, _dc_databaseQueryData, _dc_stackFrameVariables, _dc_frameContextLines;
    return {
        userInfo: (_dc_userInfo = dc.userInfo) !== null && _dc_userInfo !== void 0 ? _dc_userInfo : base.userInfo,
        cookies: (_dc_cookies = dc.cookies) !== null && _dc_cookies !== void 0 ? _dc_cookies : base.cookies,
        httpHeaders: {
            request: (_dc_httpHeaders_request = (_dc_httpHeaders = dc.httpHeaders) === null || _dc_httpHeaders === void 0 ? void 0 : _dc_httpHeaders.request) !== null && _dc_httpHeaders_request !== void 0 ? _dc_httpHeaders_request : base.httpHeaders.request,
            response: (_dc_httpHeaders_response = (_dc_httpHeaders1 = dc.httpHeaders) === null || _dc_httpHeaders1 === void 0 ? void 0 : _dc_httpHeaders1.response) !== null && _dc_httpHeaders_response !== void 0 ? _dc_httpHeaders_response : base.httpHeaders.response
        },
        httpBodies: (_dc_httpBodies = dc.httpBodies) !== null && _dc_httpBodies !== void 0 ? _dc_httpBodies : base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: (_ref = (_dc_urlQueryParams = dc.urlQueryParams) !== null && _dc_urlQueryParams !== void 0 ? _dc_urlQueryParams : dc.queryParams) !== null && _ref !== void 0 ? _ref : base.urlQueryParams,
        graphQL: {
            document: (_dc_graphQL_document = (_dc_graphQL = dc.graphQL) === null || _dc_graphQL === void 0 ? void 0 : _dc_graphQL.document) !== null && _dc_graphQL_document !== void 0 ? _dc_graphQL_document : base.graphQL.document,
            variables: (_dc_graphQL_variables = (_dc_graphQL1 = dc.graphQL) === null || _dc_graphQL1 === void 0 ? void 0 : _dc_graphQL1.variables) !== null && _dc_graphQL_variables !== void 0 ? _dc_graphQL_variables : base.graphQL.variables
        },
        genAI: {
            inputs: (_dc_genAI_inputs = (_dc_genAI = dc.genAI) === null || _dc_genAI === void 0 ? void 0 : _dc_genAI.inputs) !== null && _dc_genAI_inputs !== void 0 ? _dc_genAI_inputs : base.genAI.inputs,
            outputs: (_dc_genAI_outputs = (_dc_genAI1 = dc.genAI) === null || _dc_genAI1 === void 0 ? void 0 : _dc_genAI1.outputs) !== null && _dc_genAI_outputs !== void 0 ? _dc_genAI_outputs : base.genAI.outputs
        },
        databaseQueryData: (_dc_databaseQueryData = dc.databaseQueryData) !== null && _dc_databaseQueryData !== void 0 ? _dc_databaseQueryData : base.databaseQueryData,
        stackFrameVariables: (_dc_stackFrameVariables = dc.stackFrameVariables) !== null && _dc_stackFrameVariables !== void 0 ? _dc_stackFrameVariables : base.stackFrameVariables,
        frameContextLines: (_dc_frameContextLines = dc.frameContextLines) !== null && _dc_frameContextLines !== void 0 ? _dc_frameContextLines : base.frameContextLines
    };
}


const $4b79de9c25a3b1c8$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $4b79de9c25a3b1c8$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $4b79de9c25a3b1c8$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $4b79de9c25a3b1c8$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $4b79de9c25a3b1c8$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $4b79de9c25a3b1c8$var$_makeInternalError(message) {
    return {
        message: message,
        [$4b79de9c25a3b1c8$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $4b79de9c25a3b1c8$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$4b79de9c25a3b1c8$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $4b79de9c25a3b1c8$var$_isInternalError(error) {
    return (0, $85e272e760900bb9$export$c10d0b04eaa80a43)(error) && $4b79de9c25a3b1c8$var$INTERNAL_ERROR_SYMBOL in error;
}
function $4b79de9c25a3b1c8$var$_isDoNotSendEventError(error) {
    return (0, $85e272e760900bb9$export$c10d0b04eaa80a43)(error) && $4b79de9c25a3b1c8$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $4b79de9c25a3b1c8$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            var _client_getOptions__flushInterval;
            const flushInterval = (_client_getOptions__flushInterval = client.getOptions()._flushInterval) !== null && _client_getOptions__flushInterval !== void 0 ? _client_getOptions__flushInterval : $4b79de9c25a3b1c8$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = (0, $fe59e0d26f85c06d$export$630056cb83d87863)(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $4b79de9c25a3b1c8$export$1f2bb630327ac4b6 {
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if ((0, $df365b8ef5885c2b$export$6de4ffac6a2f1098)(exception)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log($4b79de9c25a3b1c8$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            event_id: eventId
        }, hint);
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            event_id: (0, $df365b8ef5885c2b$export$19f53698e68b2496)()
        }, hint);
        const eventMessage = (0, $85e272e760900bb9$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $85e272e760900bb9$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $df365b8ef5885c2b$export$19f53698e68b2496)();
        if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && (0, $df365b8ef5885c2b$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log($4b79de9c25a3b1c8$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            event_id: eventId
        }, hint);
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $4b79de9c25a3b1c8$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        (0, $4ea28bfd5ee93486$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        (0, $425e0f9c169ee798$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        if (!isAlreadyInstalled) (0, $425e0f9c169ee798$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = (0, $2c90e60f3ada509e$export$9aeb9a2b899f8587)(event, this);
        let env = (0, $0ca80a3f5337ad93$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $5e31f551d021d379$export$d650323442802f6f)(env, (0, $5e31f551d021d379$export$d8fc80952cc31fa4)(attachment));
        if (genAiSpanItem) env = (0, $5e31f551d021d379$export$d650323442802f6f)(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $370456451b52ff1d$export$849dbeeeda01ae98) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn($4b79de9c25a3b1c8$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn($4b79de9c25a3b1c8$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $0ca80a3f5337ad93$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error("Error while sending envelope:", reason);
            return {};
        }
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $425e0f9c169ee798$export$51abed9797baa598)(this, integrations);
        (0, $425e0f9c169ee798$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        var _event_exception;
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
        if (exceptions) {
            var _ex_mechanism;
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (((_ex_mechanism = ex.mechanism) === null || _ex_mechanism === void 0 ? void 0 : _ex_mechanism.handled) === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $4ea28bfd5ee93486$export$531818e825e774db)(session, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, crashed && {
                status: "crashed"
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $670d18f27a56af80$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            var _evt_contexts;
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                trace: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (_evt_contexts = evt.contexts) === null || _evt_contexts === void 0 ? void 0 : _evt_contexts.trace, (0, $6486f3d311605b78$export$1e83db7ee4876dc4)(currentScope))
            }, evt.contexts);
            const dynamicSamplingContext = (0, $5c79f8c2b5cb59fa$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                dynamicSamplingContext: dynamicSamplingContext
            }, evt.sdkProcessingMetadata);
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)(), isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)()) {
        if ((0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && $4b79de9c25a3b1c8$var$isErrorEvent(event)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Captured error event \`${(0, $6fb56feda9bd3e8a$export$d55a97c329cacfcc)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) {
                if ($4b79de9c25a3b1c8$var$_isDoNotSendEventError(reason)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(reason.message);
                else if ($4b79de9c25a3b1c8$var$_isInternalError(reason)) (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(reason.message);
                else (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4b79de9c25a3b1c8$var$isTransactionEvent(event);
        const isError = $4b79de9c25a3b1c8$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : (0, $ab7c7053b878f035$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && (0, $8aca1af6321ba44f$export$9869d72de32a3917)() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, $29c1921438eb1933$export$78e43115b553f358)($4b79de9c25a3b1c8$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $4b79de9c25a3b1c8$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            var _hint_data;
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $4b79de9c25a3b1c8$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = ((_hint_data = hint.data) === null || _hint_data === void 0 ? void 0 : _hint_data.__sentry__) === true;
            if (isInternalException) return prepared;
            const result = $4b79de9c25a3b1c8$var$processBeforeSend(this, options, prepared, hint);
            return $4b79de9c25a3b1c8$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $4b79de9c25a3b1c8$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                var _processedEvent_sdkProcessingMetadata;
                const spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transactionInfo), {
                    source: source
                });
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($4b79de9c25a3b1c8$var$_isDoNotSendEventError(reason) || $4b79de9c25a3b1c8$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $4b79de9c25a3b1c8$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $37fe8c4357879c39$export$c8667f1887a128dc)) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log("Sending outcomes:", outcomes);
        const envelope = (0, $cf3e39e4079becde$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $94fe38c0afc4d11c$export$44d472fbb931a776)(this._dsn));
        this.sendEnvelope(envelope);
    }
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        var _options_transportOptions, _this__options__experiments, _this__options__experiments1;
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        var _options_transportOptions_bufferSize;
        this._promiseBuffer = (0, $37fe8c4357879c39$export$85a4f67f852183e6)((_options_transportOptions_bufferSize = (_options_transportOptions = options.transportOptions) === null || _options_transportOptions === void 0 ? void 0 : _options_transportOptions.bufferSize) !== null && _options_transportOptions_bufferSize !== void 0 ? _options_transportOptions_bufferSize : (0, $fd4b80e45f21271b$export$e515cf6dfd2f98b8));
        this._dataCollection = (0, $c636246ba52b9790$export$e0e409941f20a4c)(options);
        if (options.dsn) this._dsn = (0, $94fe38c0afc4d11c$export$128827c3562ec0cb)(options.dsn);
        else (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $8c0899c4b9f5d22e$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
        var _this__options_enableLogs;
        this._options.enableLogs = (_this__options_enableLogs = this._options.enableLogs) !== null && _this__options_enableLogs !== void 0 ? _this__options_enableLogs : (_this__options__experiments = this._options._experiments) === null || _this__options__experiments === void 0 ? void 0 : _this__options__experiments.enableLogs;
        if (this._options.enableLogs) $4b79de9c25a3b1c8$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $4b79de9c25a3b1c8$var$estimateLogSizeInBytes, (0, $95dada53d77b757b$export$f8ed83d3b6a0b504));
        var _this__options_enableMetrics, _ref;
        const enableMetrics = (_ref = (_this__options_enableMetrics = this._options.enableMetrics) !== null && _this__options_enableMetrics !== void 0 ? _this__options_enableMetrics : (_this__options__experiments1 = this._options._experiments) === null || _this__options__experiments1 === void 0 ? void 0 : _this__options__experiments1.enableMetrics) !== null && _ref !== void 0 ? _ref : true;
        if (enableMetrics) $4b79de9c25a3b1c8$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $4b79de9c25a3b1c8$var$estimateMetricSizeInBytes, (0, $be338f8d93fa0a44$export$91c9ef254b7d0f67));
    }
}
function $4b79de9c25a3b1c8$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $4b79de9c25a3b1c8$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $85e272e760900bb9$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $85e272e760900bb9$export$53b83ca8eaab0383)(event) && event !== null) throw $4b79de9c25a3b1c8$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $4b79de9c25a3b1c8$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $85e272e760900bb9$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $4b79de9c25a3b1c8$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $4b79de9c25a3b1c8$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan = !(0, $c26cfd9b49302c59$export$ca3e1ec3cdcc76ac)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($4b79de9c25a3b1c8$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($4b79de9c25a3b1c8$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan || ignoreSpans) {
            const rootSpanJson = (0, $86741795a2158fb1$export$d9c6b2464b0a687e)(processedEvent);
            if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, $3ba72cc613510e20$export$5d569ac97c389400)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
                else processedEvent = (0, $6758701f8e924183$export$4950aa0f605343fb)(event, (0, $86741795a2158fb1$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if ((ignoreSpans === null || ignoreSpans === void 0 ? void 0 : ignoreSpans.length) && (0, $3ba72cc613510e20$export$5d569ac97c389400)({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        (0, $3ba72cc613510e20$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $4b79de9c25a3b1c8$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $4b79de9c25a3b1c8$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $4b79de9c25a3b1c8$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $4b79de9c25a3b1c8$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $4b79de9c25a3b1c8$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $4b79de9c25a3b1c8$var$estimateAttributesSizeInBytes(log.attributes);
}
function $4b79de9c25a3b1c8$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $4b79de9c25a3b1c8$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(value)) weight += $4b79de9c25a3b1c8$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $4b79de9c25a3b1c8$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}


var $iPRIv = parcelRequire("iPRIv");








function $5c2f0dcb09838907$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $5c2f0dcb09838907$var$hasSentryFetchUrlHost(error) {
    return (0, $85e272e760900bb9$export$e6127cc7fe7395c3)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $5c2f0dcb09838907$export$35a730c8874c1024(error) {
    if ($5c2f0dcb09838907$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $5c2f0dcb09838907$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $5c2f0dcb09838907$export$35a730c8874c1024(error)
    };
    const frames = $5c2f0dcb09838907$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $5c2f0dcb09838907$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $5c2f0dcb09838907$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = (0, $85a434b6cfc19e37$export$b0244d5063c0b61b)(exception);
    if ((0, $85e272e760900bb9$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $5c2f0dcb09838907$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $5c2f0dcb09838907$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
function $5c2f0dcb09838907$var$getException(client, mechanism, exception, hint) {
    if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ((0, $85e272e760900bb9$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: (0, $7879d292a118e15d$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $5c2f0dcb09838907$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $5c2f0dcb09838907$var$getMessageForObject(exception);
        const ex2 = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $5c2f0dcb09838907$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = (hint === null || hint === void 0 ? void 0 : hint.data) && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $5c2f0dcb09838907$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $5c2f0dcb09838907$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, void 0, void 0);
    (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, mechanism);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event), {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id
    });
}
function $5c2f0dcb09838907$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint === null || hint === void 0 ? void 0 : hint.event_id,
        level: level
    };
    if (attachStacktrace && (hint === null || hint === void 0 ? void 0 : hint.syntheticException)) {
        const frames = $5c2f0dcb09838907$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $85e272e760900bb9$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


function $30b34c487def1b34$export$a6c2d27607295951(stackParser, ex) {
    const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $30b34c487def1b34$export$2e9ae379995d99e3(ex),
        value: $30b34c487def1b34$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $30b34c487def1b34$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    const errorFromProp = $30b34c487def1b34$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $7879d292a118e15d$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $30b34c487def1b34$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $85e272e760900bb9$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $30b34c487def1b34$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $30b34c487def1b34$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $30b34c487def1b34$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $30b34c487def1b34$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $30b34c487def1b34$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $30b34c487def1b34$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {}
    return [];
}
const $30b34c487def1b34$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $30b34c487def1b34$var$getSkipFirstStackStringLines(ex) {
    if (ex && $30b34c487def1b34$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $30b34c487def1b34$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $30b34c487def1b34$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $30b34c487def1b34$export$2e9ae379995d99e3(ex) {
    const name = ex === null || ex === void 0 ? void 0 : ex.name;
    if (!name && $30b34c487def1b34$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $30b34c487def1b34$export$86005d1b62804363(ex) {
    const message = ex === null || ex === void 0 ? void 0 : ex.message;
    if ($30b34c487def1b34$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $5c2f0dcb09838907$export$35a730c8874c1024)(message.error);
    return (0, $5c2f0dcb09838907$export$35a730c8874c1024)(ex);
}
function $30b34c487def1b34$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || void 0;
    const event = $30b34c487def1b34$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event);
    event.level = "error";
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(event);
}
function $30b34c487def1b34$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || void 0;
    const event = $30b34c487def1b34$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $29c1921438eb1933$export$1fda8aa4d135f8aa)(event);
}
function $30b34c487def1b34$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $85e272e760900bb9$export$9f9636d330b71954)(exception) && exception.error) {
        const errorEvent = exception;
        return $30b34c487def1b34$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $85e272e760900bb9$export$ef9e2056653f0c8e)(exception) || (0, $85e272e760900bb9$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            var _event_exception_values, _event_exception;
            event = $30b34c487def1b34$var$eventFromError(stackParser, exception);
            const firstException = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $85e272e760900bb9$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $30b34c487def1b34$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) event.tags = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.tags), {
            "DOMException.code": `${domException.code}`
        });
        return event;
    }
    if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(exception)) return $30b34c487def1b34$var$eventFromError(stackParser, exception);
    if ((0, $85e272e760900bb9$export$53b83ca8eaab0383)(exception) || (0, $85e272e760900bb9$export$9671ea99bd126ace)(exception)) {
        const objectException = exception;
        event = $30b34c487def1b34$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    event = $30b34c487def1b34$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, `${exception}`, void 0);
    (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $30b34c487def1b34$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $30b34c487def1b34$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $85e272e760900bb9$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $30b34c487def1b34$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $85a434b6cfc19e37$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $85e272e760900bb9$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $85e272e760900bb9$export$9671ea99bd126ace)(exception)) {
        const className = $30b34c487def1b34$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $30b34c487def1b34$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
function $30b34c487def1b34$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}






const $0ff4a1c827ec052f$var$WINDOW = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
const $0ff4a1c827ec052f$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $0ff4a1c827ec052f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $0ff4a1c827ec052f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $0ff4a1c827ec052f$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $0ff4a1c827ec052f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return "";
    if ($0ff4a1c827ec052f$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $85e272e760900bb9$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $0ff4a1c827ec052f$export$1cfafeee2987818b() {
    try {
        return $0ff4a1c827ec052f$var$WINDOW.document.location.href;
    } catch (e) {
        return "";
    }
}
function $0ff4a1c827ec052f$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$0ff4a1c827ec052f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


const $437be5401ebe48b5$export$56d8a8a25bd48b81 = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
let $437be5401ebe48b5$var$ignoreOnError = 0;
function $437be5401ebe48b5$export$b79738ab10c590b2() {
    return $437be5401ebe48b5$var$ignoreOnError > 0;
}
function $437be5401ebe48b5$export$1265a142ff5ba165() {
    $437be5401ebe48b5$var$ignoreOnError++;
    setTimeout(()=>{
        $437be5401ebe48b5$var$ignoreOnError--;
    });
}
function $437be5401ebe48b5$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $85a434b6cfc19e37$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$437be5401ebe48b5$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $437be5401ebe48b5$export$1265a142ff5ba165();
            (0, $6486f3d311605b78$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $df365b8ef5885c2b$export$f26508487bf83ee7)(event, void 0, void 0);
                        (0, $df365b8ef5885c2b$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $bb3616fd55b6cdc0$export$f5282963edea4a68)(ex);
            });
            throw ex;
        } finally{
            (0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $df8678217e707dd5$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {}
    (0, $85a434b6cfc19e37$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch (e) {}
    return sentryWrapped;
}
function $437be5401ebe48b5$export$a3c4a8453e8936f0() {
    const url = (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
    const { referrer: referrer } = $437be5401ebe48b5$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $437be5401ebe48b5$export$56d8a8a25bd48b81.navigator || {};
    const headers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        "User-Agent": userAgent
    });
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $31a3c3a87f4e980b$export$1df9218a526d318d extends (0, $4b79de9c25a3b1c8$export$1f2bb630327ac4b6) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $30b34c487def1b34$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $30b34c487def1b34$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        var _opts__metadata;
        const opts = $31a3c3a87f4e980b$export$4e107b20a7f977(options);
        const sdkSource = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $iPRIv.getSDKSource)();
        (0, $1ca02136df3c52aa$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if ((_opts__metadata = opts._metadata) === null || _opts__metadata === void 0 ? void 0 : _opts__metadata.sdk) opts._metadata.sdk.settings = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never"
        }, opts._metadata.sdk.settings);
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document) (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $5e2903ba91c783d2$export$e8e2d07ba63e2b6c));
    }
}
function $31a3c3a87f4e980b$export$4e107b20a7f977(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}








const $26248f9dbcbb9359$var$DEFAULT_BREADCRUMBS = 100;
function $26248f9dbcbb9359$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $26248f9dbcbb9359$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $b007b72e24b33b62$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        timestamp: timestamp
    }, breadcrumb);
    const finalBreadcrumb = beforeBreadcrumb ? (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}









const $53b768e21077af87$var$handlers = {};
const $53b768e21077af87$var$instrumented = {};
function $53b768e21077af87$export$a4e09611e30da72e(type, handler) {
    $53b768e21077af87$var$handlers[type] = $53b768e21077af87$var$handlers[type] || [];
    $53b768e21077af87$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $53b768e21077af87$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $53b768e21077af87$export$b17eab759a1cb5fe() {
    Object.keys($53b768e21077af87$var$handlers).forEach((key)=>{
        $53b768e21077af87$var$handlers[key] = void 0;
    });
}
function $53b768e21077af87$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$53b768e21077af87$var$instrumented[type]) {
        $53b768e21077af87$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $53b768e21077af87$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $53b768e21077af87$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}


const $f058fa0fdfb21014$var$_filter = /* @__PURE__ */ new Set([]);
function $f058fa0fdfb21014$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    const removeHandler = (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $f058fa0fdfb21014$export$b80c01837473f7bc);
    return removeHandler;
}
function $f058fa0fdfb21014$export$7444162f8bcc9c91(filter) {
    for (const f of filter)$f058fa0fdfb21014$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$f058fa0fdfb21014$var$_filter.delete(f);
    };
}
const $f058fa0fdfb21014$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $f058fa0fdfb21014$export$b80c01837473f7bc() {
    if (!("console" in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1))) return;
    (0, $d8898b8567c29ee9$export$2a2b1d2252a69ecb).forEach(function(level) {
        if ($f058fa0fdfb21014$var$instrumentedLevels.has(level) || !(level in (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console)) return;
        $f058fa0fdfb21014$var$instrumentedLevels.add(level);
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $d8898b8567c29ee9$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = (0, $d8898b8567c29ee9$export$77c4ce905194557b)[level];
                const isFiltered = $f058fa0fdfb21014$var$_filter.size && typeof firstArg === "string" && (0, $6c937b4b236937d4$export$a7a5ec66062ea5d)(firstArg, $f058fa0fdfb21014$var$_filter);
                if (!isFiltered) (0, $53b768e21077af87$export$b18c893e424d3127)("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).isEnabled()) log === null || log === void 0 ? void 0 : log.apply((0, $df8678217e707dd5$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}









const $ed8e12a1b26c7e3d$var$WINDOW = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);
function $ed8e12a1b26c7e3d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$67fc34576016d6ec() {
    return "history" in $ed8e12a1b26c7e3d$var$WINDOW && !!$ed8e12a1b26c7e3d$var$WINDOW.history;
}
const $ed8e12a1b26c7e3d$export$edf3cb81fd7d2a3e = $ed8e12a1b26c7e3d$var$_isFetchSupported;
function $ed8e12a1b26c7e3d$var$_isFetchSupported() {
    if (!("fetch" in $ed8e12a1b26c7e3d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $ed8e12a1b26c7e3d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $ed8e12a1b26c7e3d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$ed8e12a1b26c7e3d$var$_isFetchSupported()) return false;
    if ($ed8e12a1b26c7e3d$export$d5f608b368e73f38($ed8e12a1b26c7e3d$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $ed8e12a1b26c7e3d$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        var _sandbox_contentWindow;
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) result = $ed8e12a1b26c7e3d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $37b03cd1fa6d4fb8$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $ed8e12a1b26c7e3d$export$531055a6c684a70a() {
    return "ReportingObserver" in $ed8e12a1b26c7e3d$var$WINDOW;
}
function $ed8e12a1b26c7e3d$export$2d308b428295192f() {
    if (!$ed8e12a1b26c7e3d$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}





function $2676de91bc47760e$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, ()=>$2676de91bc47760e$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $2676de91bc47760e$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, ()=>$2676de91bc47760e$var$instrumentFetch($2676de91bc47760e$var$streamHandler));
    return removeHandler;
}
function $2676de91bc47760e$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $ed8e12a1b26c7e3d$export$c82d238e23c40b21)()) return;
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $df8678217e707dd5$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $2676de91bc47760e$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $2676de91bc47760e$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $53b768e21077af87$export$b18c893e424d3127)("fetch", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData));
            return originalFetch.apply((0, $df8678217e707dd5$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $53b768e21077af87$export$b18c893e424d3127)("fetch", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData), {
                    endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                    response: response
                }));
                return response;
            }, (error)=>{
                (0, $53b768e21077af87$export$b18c893e424d3127)("fetch", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData), {
                    endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                    error: error
                }));
                if ((0, $85e272e760900bb9$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
                var _client_getOptions_enhanceFetchErrorMessages;
                const enhanceOption = (_client_getOptions_enhanceFetchErrorMessages = client === null || client === void 0 ? void 0 : client.getOptions().enhanceFetchErrorMessages) !== null && _client_getOptions_enhanceFetchErrorMessages !== void 0 ? _client_getOptions_enhanceFetchErrorMessages : "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch (e) {}
                throw error;
            });
        };
    });
}
async function $2676de91bc47760e$var$resolveResponse(res, onFinishedResolving) {
    if (res === null || res === void 0 ? void 0 : res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (e) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $2676de91bc47760e$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    $2676de91bc47760e$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $53b768e21077af87$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $2676de91bc47760e$var$hasProp(obj, prop) {
    return (0, $85e272e760900bb9$export$c10d0b04eaa80a43)(obj) && !!obj[prop];
}
function $2676de91bc47760e$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($2676de91bc47760e$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $2676de91bc47760e$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $2676de91bc47760e$var$getUrlFromResource(resource),
            method: $2676de91bc47760e$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $85e272e760900bb9$export$6d3d1f317d7cda57)(resource) && $2676de91bc47760e$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $2676de91bc47760e$var$getUrlFromResource(arg),
        method: $2676de91bc47760e$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $2676de91bc47760e$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $85e272e760900bb9$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {}
    return;
}

function $7648c008ec662140$export$b8cfcc4175694bcc(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}


const $e3f8d2d1d7c51bd6$var$DEFAULT_BASE_URL = "thismessage:/";
function $e3f8d2d1d7c51bd6$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $e3f8d2d1d7c51bd6$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $e3f8d2d1d7c51bd6$var$DEFAULT_BASE_URL : void 0;
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {}
    return void 0;
}
function $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c(url) {
    if ($e3f8d2d1d7c51bd6$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $e3f8d2d1d7c51bd6$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    const method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $e3f8d2d1d7c51bd6$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $e3f8d2d1d7c51bd6$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $fdf17a1e56d9d4ca$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = "route";
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, $fdf17a1e56d9d4ca$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405] = "route";
        }
        if (!$e3f8d2d1d7c51bd6$export$e258e13805402ba7(urlObject)) {
            attributes[0, $fdf17a1e56d9d4ca$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $e3f8d2d1d7c51bd6$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $e3f8d2d1d7c51bd6$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $e3f8d2d1d7c51bd6$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "")) || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $e3f8d2d1d7c51bd6$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}

function $bff673aa5089d0b2$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




const $b7c04b6a834a93ab$export$56d8a8a25bd48b81 = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1);


const $e2f6a75a34783fde$var$DEBOUNCE_DURATION = 1e3;
let $e2f6a75a34783fde$var$debounceTimerID;
let $e2f6a75a34783fde$var$lastCapturedEventType;
let $e2f6a75a34783fde$var$lastCapturedEventTargetId;
function $e2f6a75a34783fde$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $e2f6a75a34783fde$export$3014bbf0af0e1d4a);
}
function $e2f6a75a34783fde$export$3014bbf0af0e1d4a() {
    if (!(0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $53b768e21077af87$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $e2f6a75a34783fde$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        var _globalObject_target, _proto_hasOwnProperty;
        const globalObject = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81);
        const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, "addEventListener"))) return;
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $e2f6a75a34783fde$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $e2f6a75a34783fde$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $e2f6a75a34783fde$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $e2f6a75a34783fde$var$lastCapturedEventTargetId) return false;
    } catch (e) {}
    return true;
}
function $e2f6a75a34783fde$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $e2f6a75a34783fde$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $e2f6a75a34783fde$var$getEventTarget(event);
        if ($e2f6a75a34783fde$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $85a434b6cfc19e37$export$e73679ffaf56810e)(target, "_sentryId", (0, $df365b8ef5885c2b$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$e2f6a75a34783fde$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $e2f6a75a34783fde$var$lastCapturedEventType = event.type;
            $e2f6a75a34783fde$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($e2f6a75a34783fde$var$debounceTimerID);
        $e2f6a75a34783fde$var$debounceTimerID = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).setTimeout(()=>{
            $e2f6a75a34783fde$var$lastCapturedEventTargetId = void 0;
            $e2f6a75a34783fde$var$lastCapturedEventType = void 0;
        }, $e2f6a75a34783fde$var$DEBOUNCE_DURATION);
    };
}
function $e2f6a75a34783fde$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        return null;
    }
}



let $a2d725b30741e272$var$lastHref;
function $a2d725b30741e272$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $a2d725b30741e272$export$d9b613a6254a184e);
}
function $a2d725b30741e272$export$d9b613a6254a184e() {
    (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).location.href;
        const from = $a2d725b30741e272$var$lastHref;
        $a2d725b30741e272$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $53b768e21077af87$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $ed8e12a1b26c7e3d$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $a2d725b30741e272$var$lastHref;
                const to = $a2d725b30741e272$var$getAbsoluteUrl(String(url));
                $a2d725b30741e272$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $53b768e21077af87$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $a2d725b30741e272$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch (e) {
        return urlOrPath;
    }
}



const $8700a702c00468d1$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $8700a702c00468d1$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $8700a702c00468d1$export$c67d533bf77cbf54);
}
function $8700a702c00468d1$export$c67d533bf77cbf54() {
    if (!(0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $85e272e760900bb9$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $8700a702c00468d1$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {}
                    const handlerData = {
                        endTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $53b768e21077af87$export$b18c893e424d3127)("xhr", handlerData);
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $85e272e760900bb9$export$844ec244b1367d54)(header) && (0, $85e272e760900bb9$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$8700a702c00468d1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $b007b72e24b33b62$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $53b768e21077af87$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $8700a702c00468d1$var$parseXhrUrlArg(url) {
    if ((0, $85e272e760900bb9$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch (e) {}
    return void 0;
}


const $d6cf245db051044b$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $d6cf245db051044b$var$accessors = {};
try {
    if (typeof Node !== "undefined") $d6cf245db051044b$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $d6cf245db051044b$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $d6cf245db051044b$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $d6cf245db051044b$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $d6cf245db051044b$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $d6cf245db051044b$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch (e) {}
function $d6cf245db051044b$var$_safeRead(el, prop, arg) {
    const fn = $d6cf245db051044b$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch (e) {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $d6cf245db051044b$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d6cf245db051044b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d6cf245db051044b$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $d6cf245db051044b$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch (e) {
        return "<unknown>";
    }
}
function $d6cf245db051044b$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $d6cf245db051044b$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $d6cf245db051044b$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>$d6cf245db051044b$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $d6cf245db051044b$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $d6cf245db051044b$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $d6cf245db051044b$var$_safeRead(el, "className");
        if (className && (0, $85e272e760900bb9$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $d6cf245db051044b$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}


const $03d071cefd392f71$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $6345fc92bb1e1d94$var$INTEGRATION_NAME = "Breadcrumbs";
const $6345fc92bb1e1d94$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $6345fc92bb1e1d94$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $f058fa0fdfb21014$export$1d6e0d073f9e6723)($6345fc92bb1e1d94$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $e2f6a75a34783fde$export$5aeffd3db2cf9df7)($6345fc92bb1e1d94$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $8700a702c00468d1$export$26ace48dd54c9aea)($6345fc92bb1e1d94$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $2676de91bc47760e$export$f75d3c772c923df0)($6345fc92bb1e1d94$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $a2d725b30741e272$export$3f18c56c58114e75)($6345fc92bb1e1d94$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $6345fc92bb1e1d94$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $6345fc92bb1e1d94$export$c079d904b326663a = (0, $425e0f9c169ee798$export$2323046b9414659f)($6345fc92bb1e1d94$var$_breadcrumbsIntegration);
function $6345fc92bb1e1d94$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $df365b8ef5885c2b$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
function $6345fc92bb1e1d94$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $6345fc92bb1e1d94$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $6345fc92bb1e1d94$var$_isEvent(event) ? event.target : event;
            target = (0, $d6cf245db051044b$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $0ff4a1c827ec052f$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $6345fc92bb1e1d94$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $bff673aa5089d0b2$export$d771ef054122c30a)(handlerData.level),
            message: (0, $6c937b4b236937d4$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6c937b4b236937d4$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $6345fc92bb1e1d94$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $8700a702c00468d1$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $7648c008ec662140$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
function $6345fc92bb1e1d94$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $7648c008ec662140$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $26248f9dbcbb9359$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
function $6345fc92bb1e1d94$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(from) : void 0;
        const parsedTo = (0, $e3f8d2d1d7c51bd6$export$7a5253c0f62e0150)(to);
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $26248f9dbcbb9359$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $6345fc92bb1e1d94$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $e83828a914926395$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $e83828a914926395$var$INTEGRATION_NAME = "BrowserApiErrors";
const $e83828a914926395$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: $e83828a914926395$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81), "setTimeout", $e83828a914926395$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81), "setInterval", $e83828a914926395$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)((0, $437be5401ebe48b5$export$56d8a8a25bd48b81), "requestAnimationFrame", $e83828a914926395$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $437be5401ebe48b5$export$56d8a8a25bd48b81)) (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $e83828a914926395$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e83828a914926395$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$e83828a914926395$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $e83828a914926395$export$59bfe9f1c76150e = (0, $425e0f9c169ee798$export$2323046b9414659f)($e83828a914926395$var$_browserApiErrorsIntegration);
function $e83828a914926395$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $437be5401ebe48b5$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $e83828a914926395$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $437be5401ebe48b5$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $e83828a914926395$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $85a434b6cfc19e37$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(originalFunction);
                return (0, $437be5401ebe48b5$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e83828a914926395$var$_wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    const globalObject = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81);
    const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, "addEventListener"))) return;
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($e83828a914926395$var$isEventListenerObject(fn)) fn.handleEvent = (0, $437be5401ebe48b5$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch (e) {}
            if (integrationOptions.unregisterOriginalCallbacks) $e83828a914926395$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $437be5401ebe48b5$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $a6df8b9dd4ca405a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $85a434b6cfc19e37$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch (e) {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $e83828a914926395$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $e83828a914926395$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}





function $714f4a09de6c5df8$export$26d3d892edc56833(type, listener, options) {
    if ((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $714f4a09de6c5df8$export$324d7b4b46528191(type, listener, options) {
    if ((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


const $1ab0135bc0534957$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};


const $b71c182abb79b9ce$export$d3314d5863fc1fef = (cb)=>{
    var _WINDOW_document;
    const rIC = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).requestIdleCallback || (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).setTimeout;
    if (((_WINDOW_document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document) === null || _WINDOW_document === void 0 ? void 0 : _WINDOW_document.visibilityState) === "hidden") cb();
    else {
        cb = (0, $1ab0135bc0534957$export$b841d51e31c12bab)(cb);
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $714f4a09de6c5df8$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $714f4a09de6c5df8$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $714f4a09de6c5df8$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};




const $243e9b09baa28783$export$1baa7880e357371c = (0, $425e0f9c169ee798$export$2323046b9414659f)((options = {})=>{
    var _options_lifecycle;
    const lifecycle = (_options_lifecycle = options.lifecycle) !== null && _options_lifecycle !== void 0 ? _options_lifecycle : "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $bb3616fd55b6cdc0$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $b71c182abb79b9ce$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $bb3616fd55b6cdc0$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if ((previousUser === null || previousUser === void 0 ? void 0 : previousUser.id) !== (maybeNewUser === null || maybeNewUser === void 0 ? void 0 : maybeNewUser.id) || (previousUser === null || previousUser === void 0 ? void 0 : previousUser.ip_address) !== (maybeNewUser === null || maybeNewUser === void 0 ? void 0 : maybeNewUser.ip_address)) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $bb3616fd55b6cdc0$export$667e7b4d445d566b)();
                }
            });
            if (lifecycle === "route") (0, $a2d725b30741e272$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $bb3616fd55b6cdc0$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $bb3616fd55b6cdc0$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
        }
    };
});











function $f1ef6c7ef9a15d58$export$3f58558cf4af9c09(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if ((state === null || state === void 0 ? void 0 : state.state) && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}



const $0de125d8b6156cce$export$b60c5e9f9b7b58bd = "ai.citations", $0de125d8b6156cce$export$cc06afd6de7f2c10 = "ai.completion_tokens.used", $0de125d8b6156cce$export$ced6746028fe2cc = "ai.documents", $0de125d8b6156cce$export$e6f4aa4f4fcb6da8 = "ai.finish_reason", $0de125d8b6156cce$export$f02d892201cd8d36 = "ai.frequency_penalty", $0de125d8b6156cce$export$f277a7ef9e273960 = "ai.function_call", $0de125d8b6156cce$export$1a8c212c3becaa80 = "ai.generation_id", $0de125d8b6156cce$export$721b137086c68a47 = "ai.input_messages", $0de125d8b6156cce$export$6afde2bb69d9aa86 = "ai.is_search_required", $0de125d8b6156cce$export$eadb4b562c974031 = "ai.metadata", $0de125d8b6156cce$export$22a90f0ac1eee843 = "ai.model_id", $0de125d8b6156cce$export$a727f215a0be1dad = "ai.model.provider", $0de125d8b6156cce$export$536bc61b34d995e5 = "ai.pipeline.name", $0de125d8b6156cce$export$c43ea6115b380e62 = "ai.preamble", $0de125d8b6156cce$export$d2a16e26bada7cf1 = "ai.presence_penalty", $0de125d8b6156cce$export$604eb1bd2278163b = "ai.prompt_tokens.used", $0de125d8b6156cce$export$2f8568696c5aa352 = "ai.raw_prompting", $0de125d8b6156cce$export$ccc8efd7dd31d3a9 = "ai.responses", $0de125d8b6156cce$export$e176bf5dc45e40df = "ai.response_format", $0de125d8b6156cce$export$c4ea01fd53f64e16 = "ai.search_queries", $0de125d8b6156cce$export$bb5e6f2f31a15da9 = "ai.search_results", $0de125d8b6156cce$export$1762c11b666b026a = "ai.seed", $0de125d8b6156cce$export$14ddd4b729910100 = "ai.streaming", $0de125d8b6156cce$export$5311d7c8e1f8eabb = "ai.tags", $0de125d8b6156cce$export$2b748b9eca00828b = "ai.temperature", $0de125d8b6156cce$export$5af25308c11addea = "ai.texts", $0de125d8b6156cce$export$28f78b3b1663cb92 = "ai.tools", $0de125d8b6156cce$export$a1d3f09f0f1f066f = "ai.tool_calls", $0de125d8b6156cce$export$322bd4ea9f163663 = "ai.top_k", $0de125d8b6156cce$export$95711b9e669edad8 = "ai.top_p", $0de125d8b6156cce$export$5924d7d72384626a = "ai.total_cost", $0de125d8b6156cce$export$db3b1b877a4ce4db = "ai.total_tokens.used", $0de125d8b6156cce$export$a434a3e8afec2879 = "ai.warnings", $0de125d8b6156cce$export$fe00bb20636d42af = "angular.version", $0de125d8b6156cce$export$712aa698b7ee271e = "app.app_build", $0de125d8b6156cce$export$1fac638b11ec16d9 = "app.app_identifier", $0de125d8b6156cce$export$d132016ea64058e3 = "app.app_name", $0de125d8b6156cce$export$53f2f47ec3b2f9ed = "app.app_start_time", $0de125d8b6156cce$export$9f80c4b11053cef1 = "app.app_version", $0de125d8b6156cce$export$5f7a08466d84e877 = "app.build", $0de125d8b6156cce$export$2cea7f14750b8c19 = "app.identifier", $0de125d8b6156cce$export$34c59270f032a6c6 = "app.in_foreground", $0de125d8b6156cce$export$5b6c28c7dca07ad7 = "app.name", $0de125d8b6156cce$export$1dc8ae58b58d6c50 = "app_start_cold", $0de125d8b6156cce$export$ba267414e3c0d822 = "app.start_time", $0de125d8b6156cce$export$71b176005902b99e = "app_start_type", $0de125d8b6156cce$export$5c5b5a3c245a0079 = "app_start_warm", $0de125d8b6156cce$export$8ee1df3c6367a60 = "app.version", $0de125d8b6156cce$export$e8c7802ae95beccf = "app.vitals.frames.delay.value", $0de125d8b6156cce$export$bb237734da4d464 = "app.vitals.frames.frozen.count", $0de125d8b6156cce$export$cdaaf6d1fdcba0b6 = "app.vitals.frames.slow.count", $0de125d8b6156cce$export$36223ebd4a30e9f5 = "app.vitals.frames.total.count", $0de125d8b6156cce$export$8feaa177bb7941e2 = "app.vitals.start.cold.value", $0de125d8b6156cce$export$e1ca25240db91d68 = "app.vitals.start.prewarmed", $0de125d8b6156cce$export$404a223fd1ada08b = "app.vitals.start.reason", $0de125d8b6156cce$export$53362079310c68 = "app.vitals.start.screen", $0de125d8b6156cce$export$3efb5af0ac379f77 = "app.vitals.start.type", $0de125d8b6156cce$export$2c10c1ca0612c46d = "app.vitals.start.warm.value", $0de125d8b6156cce$export$bbb86ad4d6654da6 = "app.vitals.ttfd.value", $0de125d8b6156cce$export$ad6896f00a2b1076 = "app.vitals.ttid.value", $0de125d8b6156cce$export$300f39d8506a273d = "art.gc.blocking_count", $0de125d8b6156cce$export$ecaa0e7f4773ddc7 = "art.gc.blocking_time", $0de125d8b6156cce$export$74b78acb4c54c06b = "art.gc.pre_oome_count", $0de125d8b6156cce$export$b15b2c133bc50e33 = "art.gc.total_count", $0de125d8b6156cce$export$5f1381d9ae1b1c95 = "art.gc.total_time", $0de125d8b6156cce$export$c170b7ff277132ea = "art.gc.waiting_time", $0de125d8b6156cce$export$9459a5df93695e45 = "art.memory.free", $0de125d8b6156cce$export$a7902bd57492ebe8 = "art.memory.free_until_gc", $0de125d8b6156cce$export$d2ace0da59da09b7 = "art.memory.free_until_oome", $0de125d8b6156cce$export$c15dd8d2461e0aeb = "art.memory.max", $0de125d8b6156cce$export$5405b0a98e00e538 = "art.memory.total", $0de125d8b6156cce$export$5d9f28f388f552d2 = "aws.cloudwatch.logs.log_group", $0de125d8b6156cce$export$b3d2f68e0e769504 = "aws.cloudwatch.logs.log_stream", $0de125d8b6156cce$export$2c98412ed43013e8 = "aws.cloudwatch.logs.url", $0de125d8b6156cce$export$a7bd794d11c19f1b = "aws.dynamodb.attribute_definitions", $0de125d8b6156cce$export$df4227832b83fdd0 = "aws.dynamodb.consistent_read", $0de125d8b6156cce$export$f131a6d8fbc0534f = "aws.dynamodb.consumed_capacity", $0de125d8b6156cce$export$9bdc66d4a70e7e3a = "aws.dynamodb.count", $0de125d8b6156cce$export$bfbbc3cbcaa90e98 = "aws.dynamodb.exclusive_start_table", $0de125d8b6156cce$export$3565fa72459aa4d6 = "aws.dynamodb.global_secondary_indexes", $0de125d8b6156cce$export$bb67a834ae4bffdc = "aws.dynamodb.global_secondary_index_updates", $0de125d8b6156cce$export$4a06c859a283f06 = "aws.dynamodb.index_name", $0de125d8b6156cce$export$68324fac2038d0f2 = "aws.dynamodb.item_collection_metrics", $0de125d8b6156cce$export$5e1bd62ffd2786fb = "aws.dynamodb.limit", $0de125d8b6156cce$export$bfdf2261058f56b = "aws.dynamodb.local_secondary_indexes", $0de125d8b6156cce$export$23bf57842d9d53df = "aws.dynamodb.projection", $0de125d8b6156cce$export$bfbd7e060eeb4d35 = "aws.dynamodb.provisioned_read_capacity", $0de125d8b6156cce$export$82eb6cccda27c3ff = "aws.dynamodb.provisioned_write_capacity", $0de125d8b6156cce$export$8ea68734d455808f = "aws.dynamodb.scanned_count", $0de125d8b6156cce$export$40050e29324d44ee = "aws.dynamodb.scan_forward", $0de125d8b6156cce$export$5cd7541006d9f467 = "aws.dynamodb.segment", $0de125d8b6156cce$export$81c017edd95d692e = "aws.dynamodb.select", $0de125d8b6156cce$export$120b3897a58cf903 = "aws.dynamodb.table_count", $0de125d8b6156cce$export$d4a9de43b4b1076c = "aws.dynamodb.table_names", $0de125d8b6156cce$export$f37f4f9022f1ab17 = "aws.dynamodb.total_segments", $0de125d8b6156cce$export$66ac18da14747cfb = "aws.extended_request_id", $0de125d8b6156cce$export$9e49b833525ca49d = "aws.kinesis.stream_name", $0de125d8b6156cce$export$247839c65766758 = "aws.kinesis.stream.name", $0de125d8b6156cce$export$b084fea5b3097227 = "aws.lambda.aws_request_id", $0de125d8b6156cce$export$e09cd8615652e8d0 = "aws.lambda.execution_duration_in_millis", $0de125d8b6156cce$export$a43a60ec723a90ee = "aws.lambda.function_name", $0de125d8b6156cce$export$34cc955357266287 = "aws.lambda.function_version", $0de125d8b6156cce$export$d9dd218693ea9bba = "aws.lambda.invoked_arn", $0de125d8b6156cce$export$c9649b7156282a2f = "aws.lambda.invoked_function_arn", $0de125d8b6156cce$export$daa8ce1f8adc553e = "aws.lambda.remaining_time_in_millis", $0de125d8b6156cce$export$cb93c7b05db202cf = "aws.log.group.names", $0de125d8b6156cce$export$930f9bd3cc2e5b3d = "aws.log.stream.names", $0de125d8b6156cce$export$48c6d4c44afdc0b = "aws.request.extended_id", $0de125d8b6156cce$export$c78d41789fe4b1e4 = "aws.request_id", $0de125d8b6156cce$export$f4d52b02df927d54 = "aws.request.id", $0de125d8b6156cce$export$f462d9921f1f7332 = "aws.s3.bucket", $0de125d8b6156cce$export$bc71f8df9a45e243 = "aws.secretsmanager.secret.arn", $0de125d8b6156cce$export$ed840ec4a5f5d053 = "aws.sns.topic.arn", $0de125d8b6156cce$export$c1a559a4f74a5e8e = "aws.step_functions.activity.arn", $0de125d8b6156cce$export$d1c007424092e3f5 = "aws.step_functions.state_machine.arn", $0de125d8b6156cce$export$9ebb466ce954c49c = "blocked_main_thread", $0de125d8b6156cce$export$e9aafc7348984403 = "browser.name", $0de125d8b6156cce$export$faaa46964f075237 = "browser.performance.navigation.activation_start", $0de125d8b6156cce$export$d28c4b3cc4431a87 = "browser.performance.time_origin", $0de125d8b6156cce$export$734b017b330c8fe6 = "browser.report.type", $0de125d8b6156cce$export$683ebdc48ba3758d = "browser.script.invoker", $0de125d8b6156cce$export$be0263971250ef44 = "browser.script.invoker_type", $0de125d8b6156cce$export$36a0cbc35c405232 = "browser.script.source_char_position", $0de125d8b6156cce$export$469f7765ba335497 = "browser.version", $0de125d8b6156cce$export$fe6fe2b7af051610 = "browser.web_vital.cls.report_event", $0de125d8b6156cce$export$8345821877c4dfad = "browser.web_vital.cls.source.<key>", $0de125d8b6156cce$export$f6c188a7e02335cf = "browser.web_vital.cls.source", $0de125d8b6156cce$export$aaf709a8971e825f = "browser.web_vital.cls.value", $0de125d8b6156cce$export$def01b82f8c092f7 = "browser.web_vital.fcp.value", $0de125d8b6156cce$export$23d4264c606a73a6 = "browser.web_vital.fp.value", $0de125d8b6156cce$export$af9ece53bb92f66b = "browser.web_vital.inp.value", $0de125d8b6156cce$export$25421625a565b69 = "browser.web_vital.lcp.element", $0de125d8b6156cce$export$ab0c90d873e69ccb = "browser.web_vital.lcp.id", $0de125d8b6156cce$export$538c05cc8cb2a2bb = "browser.web_vital.lcp.load_time", $0de125d8b6156cce$export$f86df4de196e1a7c = "browser.web_vital.lcp.render_time", $0de125d8b6156cce$export$51e8aa8c0d65e7b8 = "browser.web_vital.lcp.report_event", $0de125d8b6156cce$export$99023486ecc470bd = "browser.web_vital.lcp.size", $0de125d8b6156cce$export$2f6c85eaf382e81 = "browser.web_vital.lcp.url", $0de125d8b6156cce$export$1158d57c0aed42be = "browser.web_vital.lcp.value", $0de125d8b6156cce$export$d85c4f947ab776e3 = "browser.web_vital.ttfb.request_time", $0de125d8b6156cce$export$813ef8386d874918 = "browser.web_vital.ttfb.value", $0de125d8b6156cce$export$7c2f74ff9251f64 = "cache.hit", $0de125d8b6156cce$export$993f84dab107b880 = "cache.item_size", $0de125d8b6156cce$export$7b9c2315e94d8d2f = "cache.key", $0de125d8b6156cce$export$f01e5cd42b9ec146 = "cache.operation", $0de125d8b6156cce$export$987f6b4367434b55 = "cache.ttl", $0de125d8b6156cce$export$d9d145585d5022bb = "cache.write", $0de125d8b6156cce$export$44ffba16bd48dac6 = "channel", $0de125d8b6156cce$export$3134892c5d2e251a = "client.address", $0de125d8b6156cce$export$8495028d10296058 = "client.port", $0de125d8b6156cce$export$d6d0e4fcf46d490c = "cloudflare.d1.duration", $0de125d8b6156cce$export$658dced473c19301 = "cloudflare.d1.query_type", $0de125d8b6156cce$export$97b0f9c3fbe64076 = "cloudflare.d1.rows_read", $0de125d8b6156cce$export$cf2c95ed5efbe9eb = "cloudflare.d1.rows_written", $0de125d8b6156cce$export$880007904f61a388 = "cloudflare.durable_object.query.bindings", $0de125d8b6156cce$export$3e903b72d4d9e07d = "cloudflare.durable_object.response.rows_read", $0de125d8b6156cce$export$34da07180e0e56af = "cloudflare.durable_object.response.rows_written", $0de125d8b6156cce$export$c49aafdaeb061953 = "cloudflare.r2.bucket", $0de125d8b6156cce$export$ceb762c61de2f17f = "cloudflare.r2.operation", $0de125d8b6156cce$export$a5f54ccfb28c0caf = "cloudflare.r2.request.delimiter", $0de125d8b6156cce$export$1c86a56857b024db = "cloudflare.r2.request.key", $0de125d8b6156cce$export$7598f3464be47440 = "cloudflare.r2.request.part_number", $0de125d8b6156cce$export$b673289c971fc0ae = "cloudflare.r2.request.prefix", $0de125d8b6156cce$export$98b23f3e6f0c2a6f = "cloudflare.workflow.attempt", $0de125d8b6156cce$export$6ddeaf0498614ebb = "cloudflare.workflow.retries.backoff", $0de125d8b6156cce$export$97b78f78d64a7232 = "cloudflare.workflow.retries.delay", $0de125d8b6156cce$export$5147715be870fff7 = "cloudflare.workflow.retries.limit", $0de125d8b6156cce$export$5276bb46e6096fba = "cloudflare.workflow.timeout", $0de125d8b6156cce$export$cbcbc1f67a937cf3 = "cloud.account.id", $0de125d8b6156cce$export$226a2381b8f0cf78 = "cloud.availability_zone", $0de125d8b6156cce$export$fd35512cae286064 = "cloud.platform", $0de125d8b6156cce$export$de9bbf95ab1d81e = "cloud.provider", $0de125d8b6156cce$export$47fb20e8d18d7d15 = "cloud.region", $0de125d8b6156cce$export$9db7964e4b8cb849 = "cloud.resource_id", $0de125d8b6156cce$export$7139adf9d3bace41 = "cls", $0de125d8b6156cce$export$8ac3d09060e7f25d = "cls.source.<key>", $0de125d8b6156cce$export$dad0e4778ea23971 = "cls.source", $0de125d8b6156cce$export$c14d903ccf9385a8 = "code.filepath", $0de125d8b6156cce$export$934cded0041affd7 = "code.file.path", $0de125d8b6156cce$export$6386da1dcba88c9d = "code.function", $0de125d8b6156cce$export$a3371797e606e2 = "code.function.name", $0de125d8b6156cce$export$a5bbef0af83b23e5 = "code.lineno", $0de125d8b6156cce$export$91ed1f55874222a6 = "code.line.number", $0de125d8b6156cce$export$23de81068d2aed1b = "code.namespace", $0de125d8b6156cce$export$d738320e1fba9e9d = "connectionType", $0de125d8b6156cce$export$2eacdea75497e8a5 = "connection.rtt", $0de125d8b6156cce$export$2bc3ea101f86c1d2 = "culture.calendar", $0de125d8b6156cce$export$c54e27e8d90ee081 = "culture.display_name", $0de125d8b6156cce$export$4943adcec371c2a6 = "culture.is_24_hour_format", $0de125d8b6156cce$export$f000a5900d0480c2 = "culture.locale", $0de125d8b6156cce$export$8f5234893868273b = "culture.timezone", $0de125d8b6156cce$export$1a35518f6e81e8c7 = "db.collection.name", $0de125d8b6156cce$export$a2d90911eaae60fc = "db.driver.name", $0de125d8b6156cce$export$3c22ff8b64b8f565 = "db.name", $0de125d8b6156cce$export$b8019c0e2a5b5f0f = "db.namespace", $0de125d8b6156cce$export$8c11477e471467c8 = "db.operation", $0de125d8b6156cce$export$92a96f6363488aee = "db.operation.batch.size", $0de125d8b6156cce$export$f91beb6088f9ded9 = "db.operation.name", $0de125d8b6156cce$export$78bc7224576bf289 = "db.query.parameter.<key>", $0de125d8b6156cce$export$a8027e0ea0d93ca = "db.query.parameter", $0de125d8b6156cce$export$5e59d3aea52e5037 = "db.query.summary", $0de125d8b6156cce$export$47e408be0da7933f = "db.query.text", $0de125d8b6156cce$export$d5772b934ca13e57 = "db.redis.connection", $0de125d8b6156cce$export$36e47f6a5777561d = "db.redis.key", $0de125d8b6156cce$export$e768cbc99cd68acf = "db.redis.parameters", $0de125d8b6156cce$export$dfcc6c69df1343f2 = "db.response.status_code", $0de125d8b6156cce$export$69b0a5d9226b5211 = "db.sql.bindings", $0de125d8b6156cce$export$da010a4f4fc971ae = "db.statement", $0de125d8b6156cce$export$5d515b35be0601a0 = "db.stored_procedure.name", $0de125d8b6156cce$export$3e1b1037a315c5ca = "db.system", $0de125d8b6156cce$export$847fdd494825f0fb = "db.system.name", $0de125d8b6156cce$export$a9d76f26c6c730a9 = "db.user", $0de125d8b6156cce$export$de03f86d1c9866ca = "deviceMemory", $0de125d8b6156cce$export$65798ecab7eef8c = "device.archs", $0de125d8b6156cce$export$22aa61f48b9c79a0 = "device.battery_level", $0de125d8b6156cce$export$69f5fb98f5aed812 = "device.battery_temperature", $0de125d8b6156cce$export$bdea5d1006fd280a = "device.boot_time", $0de125d8b6156cce$export$f63a7230c5b1d609 = "device.brand", $0de125d8b6156cce$export$6f25e59b05bb8e17 = "device.charging", $0de125d8b6156cce$export$a56ad13c4afc7421 = "device.chipset", $0de125d8b6156cce$export$d9ce89ce8912bf12 = "device.class", $0de125d8b6156cce$export$17094e5f380e4162 = "device.connection_type", $0de125d8b6156cce$export$28a0ffdf747973a0 = "device.cpu_description", $0de125d8b6156cce$export$5480ae1ba5d50bb9 = "device.external_free_storage", $0de125d8b6156cce$export$edc72ee4a17f5152 = "device.external_storage_size", $0de125d8b6156cce$export$19e4df138d354f8b = "device.family", $0de125d8b6156cce$export$92b0d20fa482b4b2 = "device.free_memory", $0de125d8b6156cce$export$3f638a793d61933f = "device.free_storage", $0de125d8b6156cce$export$3f511731cc3687d4 = "device.id", $0de125d8b6156cce$export$692b08741d6b6265 = "device.locale", $0de125d8b6156cce$export$cf67f8cb2324428e = "device.low_memory", $0de125d8b6156cce$export$9d4197c1ffc5f359 = "device.low_power_mode", $0de125d8b6156cce$export$509634fbff540e75 = "device.manufacturer", $0de125d8b6156cce$export$ccbc4fdff4b5eff5 = "device.memory.estimated_capacity", $0de125d8b6156cce$export$e0cb371ca548b1d6 = "device.memory_size", $0de125d8b6156cce$export$3c39026d09026bc2 = "device.model", $0de125d8b6156cce$export$bf9e8248cb72cf00 = "device.model_id", $0de125d8b6156cce$export$1054f22a72121d0f = "device.name", $0de125d8b6156cce$export$723b8a59dad2e467 = "device.online", $0de125d8b6156cce$export$160081ff141bac8e = "device.orientation", $0de125d8b6156cce$export$194f62c84d27310 = "device.processor_count", $0de125d8b6156cce$export$7ed866d57b018d09 = "device.processor_frequency", $0de125d8b6156cce$export$d50bae4562e03e5 = "device.screen_density", $0de125d8b6156cce$export$649ea67a18fe8e8b = "device.screen_dpi", $0de125d8b6156cce$export$136a5c1b43caaccd = "device.screen_height_pixels", $0de125d8b6156cce$export$e33a28ea554b6ddc = "device.screen_width_pixels", $0de125d8b6156cce$export$acbe2d25ac76ea64 = "device.simulator", $0de125d8b6156cce$export$793c13e17d7e5e2b = "device.storage_size", $0de125d8b6156cce$export$a5617e33b89fd956 = "device.thermal_state", $0de125d8b6156cce$export$b51f82164fa31e07 = "device.timezone", $0de125d8b6156cce$export$f2ef55183c04d202 = "device.usable_memory", $0de125d8b6156cce$export$7c98fc0c48a16b1c = "dist", $0de125d8b6156cce$export$f0511e328234ae83 = "effectiveConnectionType", $0de125d8b6156cce$export$be46596bc6608f3b = "environment", $0de125d8b6156cce$export$f215947b3d76a6b7 = "error.type", $0de125d8b6156cce$export$89bbc91416db6670 = "event.id", $0de125d8b6156cce$export$b4b5eff8a8712c89 = "event.name", $0de125d8b6156cce$export$f455969a57ab8a03 = "exception.escaped", $0de125d8b6156cce$export$13f2f8f42af49cec = "exception.message", $0de125d8b6156cce$export$cd357afe2ffdd2c3 = "exception.stacktrace", $0de125d8b6156cce$export$d9ca2a279a11be5e = "exception.type", $0de125d8b6156cce$export$bbd59a8c7efad4c9 = "faas.coldstart", $0de125d8b6156cce$export$8413282a17f1cda5 = "faas.cron", $0de125d8b6156cce$export$30d19ddc7705e7e8 = "faas.duration_in_ms", $0de125d8b6156cce$export$64a4f09e2444b3d = "faas.entry_point", $0de125d8b6156cce$export$645b039fe163809e = "faas.execution", $0de125d8b6156cce$export$b23ef8b8ffa607e1 = "faas.id", $0de125d8b6156cce$export$8bf64516740c1369 = "faas.identity", $0de125d8b6156cce$export$9a0dc8e612f3e10b = "faas.invocation_id", $0de125d8b6156cce$export$abe90fedb3dddda2 = "faas.invoked_name", $0de125d8b6156cce$export$4a19da9c85ed2ade = "faas.invoked_provider", $0de125d8b6156cce$export$5e091479f094bdbc = "faas.invoked_region", $0de125d8b6156cce$export$d70909b5aa96a79a = "faas.name", $0de125d8b6156cce$export$651d142a8017d83d = "faas.time", $0de125d8b6156cce$export$44382a010a9f7fcf = "faas.trigger", $0de125d8b6156cce$export$807abfdc6b7b9338 = "faas.version", $0de125d8b6156cce$export$31881d07f2569218 = "fcp", $0de125d8b6156cce$export$e5bbf306deb709a6 = "flag.evaluation.<key>", $0de125d8b6156cce$export$aa8721167c5c8d2d = "flag.evaluation", $0de125d8b6156cce$export$757b93e5b3adc7cb = "fp", $0de125d8b6156cce$export$f869eaa92db1dc9b = "frames.delay", $0de125d8b6156cce$export$5d1d761e41c32d9e = "frames.frozen", $0de125d8b6156cce$export$8aec72d9491f9399 = "frames_frozen_rate", $0de125d8b6156cce$export$5562635d2be2ab25 = "frames.slow", $0de125d8b6156cce$export$2dc31837ce6f7a3d = "frames_slow_rate", $0de125d8b6156cce$export$b561df15f64d32e3 = "frames.total", $0de125d8b6156cce$export$181f78b28f2ffa57 = "fs_error", $0de125d8b6156cce$export$6c97c77b89571c75 = "gcp.function.context.event_id", $0de125d8b6156cce$export$51e431eaf1f9bf58 = "gcp.function.context.event_type", $0de125d8b6156cce$export$71429c7ef7cb7063 = "gcp.function.context.id", $0de125d8b6156cce$export$99905d7583a6e8ac = "gcp.function.context.resource", $0de125d8b6156cce$export$b6c4be74fd0c06bd = "gcp.function.context.source", $0de125d8b6156cce$export$fd23e5b8d261a89 = "gcp.function.context.specversion", $0de125d8b6156cce$export$25fabc9b3d1dd567 = "gcp.function.context.time", $0de125d8b6156cce$export$41507f7b07dad151 = "gcp.function.context.timestamp", $0de125d8b6156cce$export$1352f3699c35dd73 = "gcp.function.context.type", $0de125d8b6156cce$export$fd6c9d5c74d943ac = "gcp.project.id", $0de125d8b6156cce$export$c29634e3cf41e479 = "gen_ai.agent.name", $0de125d8b6156cce$export$e6a60882cce7a085 = "gen_ai.context.utilization", $0de125d8b6156cce$export$6773c9098ba5e194 = "gen_ai.context.window_size", $0de125d8b6156cce$export$6ee6b62f50047686 = "gen_ai.conversation.id", $0de125d8b6156cce$export$efac052bb3661242 = "gen_ai.cost.cache_creation.input_tokens", $0de125d8b6156cce$export$7ccd63b9ca955862 = "gen_ai.cost.cache_read.input_tokens", $0de125d8b6156cce$export$50921df5a58cb3ef = "gen_ai.cost.input_tokens", $0de125d8b6156cce$export$8e48efc7acb57a97 = "gen_ai.cost.output_tokens", $0de125d8b6156cce$export$cea9121727113f77 = "gen_ai.cost.reasoning.output_tokens", $0de125d8b6156cce$export$bed35ff7f9af3aaa = "gen_ai.cost.total_tokens", $0de125d8b6156cce$export$6b729e898b9067ce = "gen_ai.embeddings.input", $0de125d8b6156cce$export$984fbab9b52f7e24 = "gen_ai.function_id", $0de125d8b6156cce$export$9ea17906a87ada6f = "gen_ai.input.messages", $0de125d8b6156cce$export$394b443aaff3ef92 = "gen_ai.operation.name", $0de125d8b6156cce$export$6ddc374adbc06720 = "gen_ai.operation.type", $0de125d8b6156cce$export$ab8c7ebc9add56b2 = "gen_ai.output.messages", $0de125d8b6156cce$export$40ecc5bcd633d1ee = "gen_ai.pipeline.name", $0de125d8b6156cce$export$86a8df7fff52fc69 = "gen_ai.prompt", $0de125d8b6156cce$export$cf2115d46768f4c5 = "gen_ai.prompt.name", $0de125d8b6156cce$export$3d7e036e195764db = "gen_ai.provider.name", $0de125d8b6156cce$export$60c1d11221608cee = "gen_ai.request.available_tools", $0de125d8b6156cce$export$bc3cef164abbc42c = "gen_ai.request.frequency_penalty", $0de125d8b6156cce$export$43f9afb62cd79dec = "gen_ai.request.max_tokens", $0de125d8b6156cce$export$a5ab4ffc4765f75f = "gen_ai.request.messages", $0de125d8b6156cce$export$ccf46db9ab1743ec = "gen_ai.request.model", $0de125d8b6156cce$export$76c1c247342d776 = "gen_ai.request.presence_penalty", $0de125d8b6156cce$export$92f5944f0b02c9fb = "gen_ai.request.reasoning_effort", $0de125d8b6156cce$export$867eeefcb1c95b27 = "gen_ai.request.seed", $0de125d8b6156cce$export$5ada4697ae6aa17e = "gen_ai.request.stop_sequences", $0de125d8b6156cce$export$427122300e8d54d0 = "gen_ai.request.temperature", $0de125d8b6156cce$export$bcea8881375c352f = "gen_ai.request.top_k", $0de125d8b6156cce$export$b867715f9a0c04e9 = "gen_ai.request.top_p", $0de125d8b6156cce$export$69878a39cbdbe097 = "gen_ai.response.finish_reasons", $0de125d8b6156cce$export$584c61a1b769552d = "gen_ai.response.id", $0de125d8b6156cce$export$8169ebcb0b0331dd = "gen_ai.response.model", $0de125d8b6156cce$export$2c9713b624877853 = "gen_ai.response.streaming", $0de125d8b6156cce$export$45942692aeb454e0 = "gen_ai.response.text", $0de125d8b6156cce$export$8e5efeaa031210cd = "gen_ai.response.time_to_first_chunk", $0de125d8b6156cce$export$35a62769ee05a05a = "gen_ai.response.time_to_first_token", $0de125d8b6156cce$export$8ea4f7e986ca4b06 = "gen_ai.response.tokens_per_second", $0de125d8b6156cce$export$d2fd9ecaff0285a4 = "gen_ai.response.tool_calls", $0de125d8b6156cce$export$a6c8e656a4f9bb67 = "gen_ai.system", $0de125d8b6156cce$export$352a8075b163d53 = "gen_ai.system_instructions", $0de125d8b6156cce$export$426d7b90ba5d79db = "gen_ai.system.message", $0de125d8b6156cce$export$f5a1ee40934d19ce = "gen_ai.tool.call.arguments", $0de125d8b6156cce$export$1ba812a9756622ce = "gen_ai.tool.call.result", $0de125d8b6156cce$export$351120039c36e03 = "gen_ai.tool.definitions", $0de125d8b6156cce$export$d42aa25ca09e17c4 = "gen_ai.tool.description", $0de125d8b6156cce$export$d268db29b88a4286 = "gen_ai.tool.input", $0de125d8b6156cce$export$c5deb6018f2d6251 = "gen_ai.tool.message", $0de125d8b6156cce$export$e06baa3034409453 = "gen_ai.tool.name", $0de125d8b6156cce$export$646fdb5910ce3931 = "gen_ai.tool.output", $0de125d8b6156cce$export$662e3d2d4361e29b = "gen_ai.tool.type", $0de125d8b6156cce$export$1de3962f221ba441 = "gen_ai.usage.cache_creation.input_tokens", $0de125d8b6156cce$export$a4b3f0f5499c8738 = "gen_ai.usage.cache_read.input_tokens", $0de125d8b6156cce$export$1aecdac6cecbdc5b = "gen_ai.usage.completion_tokens", $0de125d8b6156cce$export$2eb2ab35b317a103 = "gen_ai.usage.input_tokens", $0de125d8b6156cce$export$c7e14ea195ede241 = "gen_ai.usage.input_tokens.cached", $0de125d8b6156cce$export$41ac034e7b9725a2 = "gen_ai.usage.input_tokens.cache_write", $0de125d8b6156cce$export$9e521119d7751e37 = "gen_ai.usage.output_tokens", $0de125d8b6156cce$export$cbac8f541a64a150 = "gen_ai.usage.output_tokens.reasoning", $0de125d8b6156cce$export$93dd08efa94c9dd4 = "gen_ai.usage.prompt_tokens", $0de125d8b6156cce$export$183e3523dac20bca = "gen_ai.usage.reasoning.output_tokens", $0de125d8b6156cce$export$3867ca1d8381d4e3 = "gen_ai.usage.total_tokens", $0de125d8b6156cce$export$11febcf9917c0057 = "graphql.document", $0de125d8b6156cce$export$88ae1ee0c0a63398 = "graphql.operation.name", $0de125d8b6156cce$export$d5bd986d1f283f29 = "graphql.operation.type", $0de125d8b6156cce$export$fc4a2d238535d998 = "hardwareConcurrency", $0de125d8b6156cce$export$57e53a60bf563f41 = "http.client_ip", $0de125d8b6156cce$export$ffdb1464deb0eedb = "http.decoded_response_content_length", $0de125d8b6156cce$export$b52670c950fd640 = "http.flavor", $0de125d8b6156cce$export$c499fd8f1db3d18e = "http.fragment", $0de125d8b6156cce$export$b2ee2242301eff05 = "http.host", $0de125d8b6156cce$export$2ebf9f7586f16841 = "http.method", $0de125d8b6156cce$export$6e9ffd608b3e828b = "http.query", $0de125d8b6156cce$export$b960c5a73a722e6c = "http.request.body.data", $0de125d8b6156cce$export$a7a850351369c77e = "http.request.connection_end", $0de125d8b6156cce$export$b18bca78f4736a94 = "http.request.connect_start", $0de125d8b6156cce$export$61a0059f562fb6c2 = "http.request.domain_lookup_end", $0de125d8b6156cce$export$7dc0d5aefb816d91 = "http.request.domain_lookup_start", $0de125d8b6156cce$export$58f6db56c841bef6 = "http.request.fetch_start", $0de125d8b6156cce$export$97a3da679f509d5 = "http.request.header.<key>", $0de125d8b6156cce$export$c387ec65fd1c2638 = "http.request.header", $0de125d8b6156cce$export$4d9db82211f308a4 = "http.request.method", $0de125d8b6156cce$export$df30ee8c5b5f1989 = "http.request_method", $0de125d8b6156cce$export$ee4948a3be025123 = "http.request.redirect_end", $0de125d8b6156cce$export$e0021eb2979cddaa = "http.request.redirect_start", $0de125d8b6156cce$export$7c0ac0c19a45beac = "http.request.request_start", $0de125d8b6156cce$export$6c32e9d84f534ee = "http.request.resend_count", $0de125d8b6156cce$export$d1f9fbdb211dd29b = "http.request.response_end", $0de125d8b6156cce$export$45e7eea99a17d6e4 = "http.request.response_start", $0de125d8b6156cce$export$20ea34e16c0aa64f = "http.request.same_origin", $0de125d8b6156cce$export$8365b0f03557fae9 = "http.request.secure_connection_start", $0de125d8b6156cce$export$49ebbb9621675650 = "http.request.time_to_first_byte", $0de125d8b6156cce$export$842be66a901f093 = "http.request.worker_start", $0de125d8b6156cce$export$a9f5a6cb28adccb1 = "http.response.body.size", $0de125d8b6156cce$export$57b055d4bc586d67 = "http.response_content_length", $0de125d8b6156cce$export$3ddfd660caa7bf7a = "http.response.header.content-length", $0de125d8b6156cce$export$fa7e1f5305153b3d = "http.response.header.<key>", $0de125d8b6156cce$export$5674ce9d013eb7bd = "http.response.header", $0de125d8b6156cce$export$6e8dc14cff6ccf72 = "http.response.size", $0de125d8b6156cce$export$afd59480458e1b57 = "http.response.status_code", $0de125d8b6156cce$export$48e61fb9bccccba9 = "http.response_transfer_size", $0de125d8b6156cce$export$d3e674514dd3a3e1 = "http.route", $0de125d8b6156cce$export$97ad02b50c60ef68 = "http.scheme", $0de125d8b6156cce$export$61d053b1b63e82c4 = "http.server_name", $0de125d8b6156cce$export$54256cce0d674dea = "http.server.request.time_in_queue", $0de125d8b6156cce$export$8c01f0f407bcc5ca = "http.status_code", $0de125d8b6156cce$export$be3f46982f6c7160 = "http.target", $0de125d8b6156cce$export$778e4213e2788579 = "http.url", $0de125d8b6156cce$export$8b48ca3594d2b172 = "http.user_agent", $0de125d8b6156cce$export$8be180ec26319f9f = "id", $0de125d8b6156cce$export$60eccaddefa8fc1c = "inp", $0de125d8b6156cce$export$c99ce4fe37484d84 = "jsonrpc.protocol.version", $0de125d8b6156cce$export$fdf432fcac7d8f37 = "jsonrpc.request.id", $0de125d8b6156cce$export$4c21cc9cdf2f5dbd = "jvm.gc.action", $0de125d8b6156cce$export$dcc1eab7f3f31816 = "jvm.gc.name", $0de125d8b6156cce$export$dcb7f1379b2b8f86 = "jvm.memory.pool.name", $0de125d8b6156cce$export$53416edeea4c2d74 = "jvm.memory.type", $0de125d8b6156cce$export$69f7e5d2b74c5c9e = "jvm.thread.daemon", $0de125d8b6156cce$export$8e104aed582a26bc = "jvm.thread.state", $0de125d8b6156cce$export$577047501949be9 = "koa.name", $0de125d8b6156cce$export$c4c45b599a2c15e = "koa.type", $0de125d8b6156cce$export$361cb541700d648e = "lcp", $0de125d8b6156cce$export$974f160e11f25731 = "lcp.element", $0de125d8b6156cce$export$7162f5c702b95903 = "lcp.id", $0de125d8b6156cce$export$a034d066a9090500 = "lcp.loadTime", $0de125d8b6156cce$export$70938021e43e047c = "lcp.renderTime", $0de125d8b6156cce$export$5f6ac460012a73bb = "lcp.size", $0de125d8b6156cce$export$d8e498c1c670bcbf = "lcp.url", $0de125d8b6156cce$export$cc1a78a24d947903 = "logger.name", $0de125d8b6156cce$export$d29b927e0bb0ffea = "mcp.cancelled.reason", $0de125d8b6156cce$export$b3999cacef245779 = "mcp.cancelled.request_id", $0de125d8b6156cce$export$ff168b5f9cf9dcf6 = "mcp.client.name", $0de125d8b6156cce$export$2ab876a45bd6e64 = "mcp.client.title", $0de125d8b6156cce$export$cb8027e4395c6c0e = "mcp.client.version", $0de125d8b6156cce$export$f5303d1bac3c2660 = "mcp.lifecycle.phase", $0de125d8b6156cce$export$6c463c5f3b00f64 = "mcp.logging.data_type", $0de125d8b6156cce$export$e25d553065457cab = "mcp.logging.level", $0de125d8b6156cce$export$15d24c154ea8a56f = "mcp.logging.logger", $0de125d8b6156cce$export$e5065789a6c415d0 = "mcp.logging.message", $0de125d8b6156cce$export$62662c561d7c7835 = "mcp.method.name", $0de125d8b6156cce$export$218f394557fb0a5a = "mcp.progress.current", $0de125d8b6156cce$export$2a5ff6de5448ecdf = "mcp.progress.message", $0de125d8b6156cce$export$9d23f3030ed2597e = "mcp.progress.percentage", $0de125d8b6156cce$export$a26ff217a6124160 = "mcp.progress.token", $0de125d8b6156cce$export$c8072f5fcfdb5b77 = "mcp.progress.total", $0de125d8b6156cce$export$c4e4b74f1ccf3d96 = "mcp.prompt.name", $0de125d8b6156cce$export$328519d02a26ac41 = "mcp.prompt.result.description", $0de125d8b6156cce$export$d2061b291c43d045 = "mcp.prompt.result.message_content", $0de125d8b6156cce$export$d1f04dfd3d695286 = "mcp.prompt.result.message_count", $0de125d8b6156cce$export$234fbd86ea0f0bd8 = "mcp.prompt.result.message_role", $0de125d8b6156cce$export$e795000978a75b12 = "mcp.protocol.ready", $0de125d8b6156cce$export$9f4683b4d1018ace = "mcp.protocol.version", $0de125d8b6156cce$export$e431b042fcdb1d63 = "mcp.request.argument.<key>", $0de125d8b6156cce$export$a453239171ac9a23 = "mcp.request.argument", $0de125d8b6156cce$export$3a7726a976c18d5f = "mcp.request.argument.name", $0de125d8b6156cce$export$7eca7a6c06843b93 = "mcp.request.argument.uri", $0de125d8b6156cce$export$f25c55f83e5b0672 = "mcp.request.id", $0de125d8b6156cce$export$9562bfac4eb079cb = "mcp.resource.protocol", $0de125d8b6156cce$export$c276d164ff91d2f7 = "mcp.resource.uri", $0de125d8b6156cce$export$2f3e0574f1a99754 = "mcp.server.name", $0de125d8b6156cce$export$15eecaab68167880 = "mcp.server.title", $0de125d8b6156cce$export$513c47f6e194086a = "mcp.server.version", $0de125d8b6156cce$export$a3f464c4d5cd9096 = "mcp.session.id", $0de125d8b6156cce$export$ed366a03a2330b03 = "mcp.tool.name", $0de125d8b6156cce$export$9b802c784f235e1d = "mcp.tool.result.content", $0de125d8b6156cce$export$add0fc8b8c5726a4 = "mcp.tool.result.content_count", $0de125d8b6156cce$export$e7f32463f5bfd554 = "mcp.tool.result.is_error", $0de125d8b6156cce$export$f9346f394edf26a = "mcp.transport", $0de125d8b6156cce$export$16b917774e73ef92 = "mdc.<key>", $0de125d8b6156cce$export$15d2b60bf3b65454 = "mdc", $0de125d8b6156cce$export$db55eca5af256142 = "messaging.batch.message_count", $0de125d8b6156cce$export$967c74f8b1f3d35 = "messaging.destination", $0de125d8b6156cce$export$7c33ae67962515d1 = "messaging.destination.connection", $0de125d8b6156cce$export$9c69839b2d93489b = "messaging.destination.name", $0de125d8b6156cce$export$be22d22d4b6cf5d8 = "messaging.message.body.size", $0de125d8b6156cce$export$c529961b911626ac = "messaging.message.conversation_id", $0de125d8b6156cce$export$e39c4b15d2881f5 = "messaging.message.envelope.size", $0de125d8b6156cce$export$a8ca145161313e7 = "messaging.message.id", $0de125d8b6156cce$export$3c1204d03918d076 = "messaging.message.receive.latency", $0de125d8b6156cce$export$eaac3f141165e288 = "messaging.message.retry.count", $0de125d8b6156cce$export$4c7e6934714150e6 = "messaging.operation.name", $0de125d8b6156cce$export$6f71f9711d666eb4 = "messaging.operation.type", $0de125d8b6156cce$export$2a3cd2bb71fb63a4 = "messaging.rabbitmq.destination.routing_key", $0de125d8b6156cce$export$55478a0b7d2ae98f = "messaging.system", $0de125d8b6156cce$export$bed10c4da9b8eb0a = "method", $0de125d8b6156cce$export$a82607b6424c06c8 = "middleware.name", $0de125d8b6156cce$export$6b081f3484c7f4e5 = "navigation.origin", $0de125d8b6156cce$export$b7754d85fd39406c = "navigation.route.id", $0de125d8b6156cce$export$492856c046eb4728 = "navigation.type", $0de125d8b6156cce$export$c1678a2059fbe906 = "nel.elapsed_time", $0de125d8b6156cce$export$6d384a0bc1011c34 = "nel.phase", $0de125d8b6156cce$export$1499a7dbfc01e7d4 = "nel.referrer", $0de125d8b6156cce$export$cfcbff40019f0ff1 = "nel.sampling_function", $0de125d8b6156cce$export$27157b5f68e583af = "nel.type", $0de125d8b6156cce$export$54bf5ed61532925d = "network.connection.effective_type", $0de125d8b6156cce$export$60ed0786292ace08 = "network.connection.rtt", $0de125d8b6156cce$export$d770bfb8345e146 = "network.connection.type", $0de125d8b6156cce$export$bb73817f1290ad28 = "network.local.address", $0de125d8b6156cce$export$f201c980f2b75802 = "network.local.port", $0de125d8b6156cce$export$b40e970572afd0ee = "network.peer.address", $0de125d8b6156cce$export$8850630a3d343488 = "network.peer.port", $0de125d8b6156cce$export$fd0a39a918d6516f = "network.protocol.name", $0de125d8b6156cce$export$e68ef41f8e0335bf = "network.protocol.version", $0de125d8b6156cce$export$5bff09650e762829 = "network.transport", $0de125d8b6156cce$export$21c1adce0e067f37 = "network.type", $0de125d8b6156cce$export$fed6ce86f48c84bc = "net.host.ip", $0de125d8b6156cce$export$500c2675137ac16e = "net.host.name", $0de125d8b6156cce$export$402c7728623fd8df = "net.host.port", $0de125d8b6156cce$export$15417259f4c0fe6b = "net.peer.ip", $0de125d8b6156cce$export$2b3b7f579a727f45 = "net.peer.name", $0de125d8b6156cce$export$514832a0b029734b = "net.peer.port", $0de125d8b6156cce$export$b0522e6a14dec1a4 = "net.protocol.name", $0de125d8b6156cce$export$659ea19f71a7ee0b = "net.protocol.version", $0de125d8b6156cce$export$1b61d972db315e73 = "net.sock.family", $0de125d8b6156cce$export$fb2970ee11a479ee = "net.sock.host.addr", $0de125d8b6156cce$export$920aceb2a8fad77e = "net.sock.host.port", $0de125d8b6156cce$export$48f8f6fbc999d187 = "net.sock.peer.addr", $0de125d8b6156cce$export$eed590fa00a8223b = "net.sock.peer.name", $0de125d8b6156cce$export$f2e5bb5cd4a130da = "net.sock.peer.port", $0de125d8b6156cce$export$779ef03d633a9086 = "net.transport", $0de125d8b6156cce$export$d98b87c8d53d0dbc = "os.build", $0de125d8b6156cce$export$ca719aa57653a0a7 = "os.build_id", $0de125d8b6156cce$export$74b19c5f48270c05 = "os.description", $0de125d8b6156cce$export$c351affe7e8098cb = "os.kernel_version", $0de125d8b6156cce$export$be7cd6b3ae3ae765 = "os.name", $0de125d8b6156cce$export$ec182524c4c57275 = "os.raw_description", $0de125d8b6156cce$export$9e45758246a85b07 = "os.rooted", $0de125d8b6156cce$export$9fa5d5f0144954cb = "os.theme", $0de125d8b6156cce$export$e66ba5bc4b978023 = "os.type", $0de125d8b6156cce$export$2306e23cc611a36d = "os.version", $0de125d8b6156cce$export$144f8c1fe01428db = "otel.kind", $0de125d8b6156cce$export$f303b2744d52121c = "otel.scope.name", $0de125d8b6156cce$export$866b2dbc7bf18ce6 = "otel.scope.version", $0de125d8b6156cce$export$b4c85774878b4841 = "otel.status_code", $0de125d8b6156cce$export$1c967a71bc9a3077 = "otel.status_description", $0de125d8b6156cce$export$5e3884a35a19eb90 = "params.<key>", $0de125d8b6156cce$export$6e7ff99bb3259573 = "params", $0de125d8b6156cce$export$7c932cba2d9e7a7 = "performance.activationStart", $0de125d8b6156cce$export$94091942edce0667 = "performance.timeOrigin", $0de125d8b6156cce$export$3671a8a524706a9d = "previous_route", $0de125d8b6156cce$export$c288888dc82d233f = "process.command_args", $0de125d8b6156cce$export$8ff188536cebc35 = "process.executable.name", $0de125d8b6156cce$export$6407d78968c0eabe = "process.pid", $0de125d8b6156cce$export$43e9fb9ec28d9743 = "process.runtime.description", $0de125d8b6156cce$export$26f31d5c5c201739 = "process.runtime.engine.name", $0de125d8b6156cce$export$bff85124d2d35b93 = "process.runtime.engine.version", $0de125d8b6156cce$export$495c671ed5a6408c = "process.runtime.name", $0de125d8b6156cce$export$54b3d4d5548c35c3 = "process.runtime.version", $0de125d8b6156cce$export$2954db6444fe1fa8 = "query.<key>", $0de125d8b6156cce$export$15c1c974d16dd678 = "query", $0de125d8b6156cce$export$9be2ae89a1eac217 = "react.version", $0de125d8b6156cce$export$5c698591c0e586a2 = "release", $0de125d8b6156cce$export$b711f2bb9c9a848a = "remix.action_form_data.<key>", $0de125d8b6156cce$export$1d3a8501efd30213 = "remix.action_form_data", $0de125d8b6156cce$export$cebaf684ced5a2c9 = "replay_id", $0de125d8b6156cce$export$d4c658ecdcb7c78c = "resource.deployment.environment", $0de125d8b6156cce$export$b1b162b01baeb044 = "resource.deployment.environment.name", $0de125d8b6156cce$export$8be2d593d7f88ed8 = "resource.render_blocking_status", $0de125d8b6156cce$export$dbd0a3528a97ccc0 = "route", $0de125d8b6156cce$export$66581dc6d3d083d1 = "rpc.grpc.status_code", $0de125d8b6156cce$export$e545f99e7abcc499 = "rpc.method", $0de125d8b6156cce$export$7e1af5787f8c4aaa = "rpc.response.status_code", $0de125d8b6156cce$export$186c94c351c54768 = "rpc.service", $0de125d8b6156cce$export$2e3fd8dfcb16fe0c = "rpc.system", $0de125d8b6156cce$export$7eeeceaa1dbd7cd5 = "rpc.system.name", $0de125d8b6156cce$export$9d5bffdff936d554 = "runtime.build", $0de125d8b6156cce$export$dc3a801c9a2c5b79 = "runtime.name", $0de125d8b6156cce$export$27933a9557f87e98 = "runtime.raw_description", $0de125d8b6156cce$export$eefa737b40a0d535 = "runtime.version", $0de125d8b6156cce$export$92740ffbcb02553b = "score.<key>", $0de125d8b6156cce$export$500e89753f9f1008 = "score", $0de125d8b6156cce$export$d91a18e47fdddefd = "score.ratio.<key>", $0de125d8b6156cce$export$eccbe6f20884ea7f = "score.ratio", $0de125d8b6156cce$export$9e24f11d79141afb = "score.total", $0de125d8b6156cce$export$f0b96ad9586f8887 = "score.weight.<key>", $0de125d8b6156cce$export$8a92ed5d436a85c6 = "score.weight", $0de125d8b6156cce$export$edd59acdf7e86a71 = "sentry.action", $0de125d8b6156cce$export$ae81a1ae71952d50 = "sentry.browser.name", $0de125d8b6156cce$export$6101470cd57eac1b = "sentry.browser.version", $0de125d8b6156cce$export$452c0aee9673fe67 = "sentry.cancellation_reason", $0de125d8b6156cce$export$773dddd1e8667756 = "sentry.category", $0de125d8b6156cce$export$98815f8579a64a90 = "sentry.client_sample_rate", $0de125d8b6156cce$export$7bc4e27428665019 = "sentry.description", $0de125d8b6156cce$export$e7d7477fa9057ee2 = "sentry.dist", $0de125d8b6156cce$export$1f4267a3fc018448 = "sentry.domain", $0de125d8b6156cce$export$c171cae150389952 = "sentry.dsc.environment", $0de125d8b6156cce$export$d9bb35e957b22c72 = "sentry.dsc.project_id", $0de125d8b6156cce$export$b3508a2c95f74e3d = "sentry.dsc.public_key", $0de125d8b6156cce$export$20bb272f4d21532d = "sentry.dsc.release", $0de125d8b6156cce$export$d7e64fbd0102ce90 = "sentry.dsc.sampled", $0de125d8b6156cce$export$c17eae7e86dbba3c = "sentry.dsc.sample_rate", $0de125d8b6156cce$export$349603c0a9165744 = "sentry.dsc.trace_id", $0de125d8b6156cce$export$4dadf693741f0283 = "sentry.dsc.transaction", $0de125d8b6156cce$export$6377864d12f7eeb3 = "sentry.environment", $0de125d8b6156cce$export$ba081af9585ed4 = "sentry.exclusive_time", $0de125d8b6156cce$export$7841dacb241485d0 = "sentry.graphql.operation", $0de125d8b6156cce$export$52c7044cf6301362 = "sentry.group", $0de125d8b6156cce$export$56ea1c9e44590e20 = "sentry.http.prefetch", $0de125d8b6156cce$export$7626e389d05f4c36 = "sentry.idle_span_finish_reason", $0de125d8b6156cce$export$5e0a48187329b2e7 = "sentry.is_remote", $0de125d8b6156cce$export$c322b150d7667841 = "sentry.kind", $0de125d8b6156cce$export$4a4797d3c962f753 = "sentry.main_thread", $0de125d8b6156cce$export$767524d5e72e2645 = "sentry.message.parameter.<key>", $0de125d8b6156cce$export$497354ca7b0ee666 = "sentry.message.template", $0de125d8b6156cce$export$cbdc4ad11118116a = "sentry.metric.source", $0de125d8b6156cce$export$5b890de778c4c2fe = "sentry.mobile", $0de125d8b6156cce$export$a78d9803b5e0a83e = "sentry.module.<key>", $0de125d8b6156cce$export$df1b536467b3992a = "sentry.module", $0de125d8b6156cce$export$73104a329e205998 = "sentry.nextjs.ssr.function.route", $0de125d8b6156cce$export$5740e3da55330b0a = "sentry.nextjs.ssr.function.type", $0de125d8b6156cce$export$8dcc2d92ff6d65da = "sentry.normalized_db_query", $0de125d8b6156cce$export$e5f1321e53e24810 = "sentry.normalized_db_query.hash", $0de125d8b6156cce$export$56dd3098cbca7c8a = "sentry.normalized_description", $0de125d8b6156cce$export$aa7aff70e4380665 = "sentry.observed_timestamp_nanos", $0de125d8b6156cce$export$dacb7d452aa6bcaf = "sentry.op", $0de125d8b6156cce$export$15dfc6c5e8f9baf6 = "sentry.origin", $0de125d8b6156cce$export$91ad03bba7909fb5 = "sentry.platform", $0de125d8b6156cce$export$86128e6c0ab71d64 = "sentry.profiler_id", $0de125d8b6156cce$export$745b60c4819aec1d = "sentry.profile_id", $0de125d8b6156cce$export$d2c893bfac1da9a1 = "sentry.release", $0de125d8b6156cce$export$1c14ad02f9534b19 = "sentry.replay_id", $0de125d8b6156cce$export$db3cb63e0594d014 = "sentry.replay_is_buffering", $0de125d8b6156cce$export$a65c9a0eba2c222d = "sentry.report_event", $0de125d8b6156cce$export$68dbcca9c0e339ec = "sentry.sdk.integrations", $0de125d8b6156cce$export$d59b669d4bb3f006 = "sentry.sdk.name", $0de125d8b6156cce$export$4d88d347aa9667fc = "sentry.sdk.version", $0de125d8b6156cce$export$9943ffdcaa4bc506 = "sentry.segment.id", $0de125d8b6156cce$export$268a117c860fca6d = "sentry.segment_id", $0de125d8b6156cce$export$d4f25b923533dbba = "sentry.segment.name", $0de125d8b6156cce$export$35f3396a1cdeea45 = "sentry.server_sample_rate", $0de125d8b6156cce$export$80e399da474bc98d = "sentry.source", $0de125d8b6156cce$export$e01809e2dbceac35 = "sentry.span.source", $0de125d8b6156cce$export$41900d5c4e8a9c68 = "sentry.status", $0de125d8b6156cce$export$362bb1cb0bb5ca03 = "sentry.status_code", $0de125d8b6156cce$export$6803ac54f919d9cc = "sentry.status.message", $0de125d8b6156cce$export$72f5b47540331169 = "sentry.sveltekit.navigation.from", $0de125d8b6156cce$export$6c61a8c9aa5305cb = "sentry.sveltekit.navigation.to", $0de125d8b6156cce$export$6b5244c457b68e65 = "sentry.sveltekit.navigation.type", $0de125d8b6156cce$export$b7bd0c9a886f3414 = "sentry.thread.id", $0de125d8b6156cce$export$6b77f2bacac7c93d = "sentry.timestamp.sequence", $0de125d8b6156cce$export$ddbc15c0e8e8a7ea = "sentry.trace_lifecycle", $0de125d8b6156cce$export$feb4fe753df28a82 = "sentry.trace.parent_span_id", $0de125d8b6156cce$export$d6267756132e2175 = "sentry.trace.status", $0de125d8b6156cce$export$570ac5a3fd7e6cc6 = "sentry.transaction", $0de125d8b6156cce$export$5b9a0015e1c530ed = "sentry.user.email", $0de125d8b6156cce$export$8bbff71c84508218 = "sentry.user.geo.city", $0de125d8b6156cce$export$b55aa07a514a2430 = "sentry.user.geo.country_code", $0de125d8b6156cce$export$9927ad09f7c084dc = "sentry.user.geo.region", $0de125d8b6156cce$export$52a07a35ff8ec6b6 = "sentry.user.geo.subdivision", $0de125d8b6156cce$export$a10d277c42e6cae3 = "sentry.user.id", $0de125d8b6156cce$export$cdc0ce5c66182801 = "sentry.user.ip", $0de125d8b6156cce$export$2504d4bd698dd962 = "sentry.user.username", $0de125d8b6156cce$export$9dc86f3b876e96ef = "server.address", $0de125d8b6156cce$export$70ff7865f52549ae = "server_name", $0de125d8b6156cce$export$f77b53a42be6e6fd = "server.port", $0de125d8b6156cce$export$818eb7ab11414506 = "service.name", $0de125d8b6156cce$export$829ef6b2e59d984d = "service.version", $0de125d8b6156cce$export$b30f4cb52c088a26 = "session.id", $0de125d8b6156cce$export$335eace0ff1771cd = "stall_percentage", $0de125d8b6156cce$export$374d88a2025416ac = "stall_total_time", $0de125d8b6156cce$export$bb7a91303551eb37 = "state.type", $0de125d8b6156cce$export$f132ea291a7db56b = "thread.id", $0de125d8b6156cce$export$f0abd4170bbd2468 = "thread.name", $0de125d8b6156cce$export$50d00a157dc08581 = "timber.tag", $0de125d8b6156cce$export$484576567a98833f = "time_to_full_display", $0de125d8b6156cce$export$ec9e491e475d0c97 = "time_to_initial_display", $0de125d8b6156cce$export$a86c59c10992220f = "transaction", $0de125d8b6156cce$export$e12f06597e992fde = "trpc.procedure_path", $0de125d8b6156cce$export$7ec54678ba28ea59 = "trpc.procedure_type", $0de125d8b6156cce$export$433ba14c16717110 = "ttfb", $0de125d8b6156cce$export$309ee349b8a537f = "ttfb.requestTime", $0de125d8b6156cce$export$b87f371cbc396fcf = "type", $0de125d8b6156cce$export$60050fc49fe0e7e2 = "ui.component_name", $0de125d8b6156cce$export$348c8e2b37f276cd = "ui.contributes_to_ttfd", $0de125d8b6156cce$export$7f47e8a8b2d97cb2 = "ui.contributes_to_ttid", $0de125d8b6156cce$export$50d5adc4b543ce95 = "ui.element.height", $0de125d8b6156cce$export$9221f1d2c934d9f = "ui.element.id", $0de125d8b6156cce$export$3a56578b3ae09a02 = "ui.element.identifier", $0de125d8b6156cce$export$e47b8dab9466c895 = "ui.element.load_time", $0de125d8b6156cce$export$4ca52f75cf4889c5 = "ui.element.paint_type", $0de125d8b6156cce$export$7343d7d72195067f = "ui.element.render_time", $0de125d8b6156cce$export$f334f32f8d4d8063 = "ui.element.type", $0de125d8b6156cce$export$c7bf2089e89a217c = "ui.element.url", $0de125d8b6156cce$export$f514f97553a434b2 = "ui.element.width", $0de125d8b6156cce$export$61abde59b50deb8e = "url", $0de125d8b6156cce$export$5a5ce44f9fb51f93 = "url.domain", $0de125d8b6156cce$export$7044ea8d89b6f59d = "url.fragment", $0de125d8b6156cce$export$40eacf1a072c9dbd = "url.full", $0de125d8b6156cce$export$4c1fa0ac0eff2ac = "url.path", $0de125d8b6156cce$export$5bee9450fe31dde1 = "url.path.parameter.<key>", $0de125d8b6156cce$export$d0b571fb4406d953 = "url.path.parameter", $0de125d8b6156cce$export$258b370e6c2b85d5 = "url.port", $0de125d8b6156cce$export$dc5e5523da291a4b = "url.query", $0de125d8b6156cce$export$fd5a8904ab5abfe0 = "url.same_origin", $0de125d8b6156cce$export$1350d8937b0f26fb = "url.scheme", $0de125d8b6156cce$export$2a045f777fb349a8 = "url.template", $0de125d8b6156cce$export$8bb874585539a88f = "user_agent.original", $0de125d8b6156cce$export$17d3a50785727199 = "user.email", $0de125d8b6156cce$export$2931c570009689e = "user.full_name", $0de125d8b6156cce$export$199cbcedee735a43 = "user.geo.city", $0de125d8b6156cce$export$4ba5bf9d4e3ed862 = "user.geo.country_code", $0de125d8b6156cce$export$674c01ec2f0b89c3 = "user.geo.region", $0de125d8b6156cce$export$bda1686739fd61c7 = "user.geo.subdivision", $0de125d8b6156cce$export$8d804148f485d54c = "user.hash", $0de125d8b6156cce$export$212a8f1ea37518bd = "user.id", $0de125d8b6156cce$export$c9ac0fee28245883 = "user.ip_address", $0de125d8b6156cce$export$77078610759fe5f6 = "user.name", $0de125d8b6156cce$export$7c6317deeec7a6c1 = "user.roles", $0de125d8b6156cce$export$877ebf2e4ad81f03 = "vercel.branch", $0de125d8b6156cce$export$70b2343945496e1f = "vercel.build_id", $0de125d8b6156cce$export$8415b56d2c6d2b1d = "vercel.deployment_id", $0de125d8b6156cce$export$cc81114a03caab18 = "vercel.destination", $0de125d8b6156cce$export$bc14eb892daceb23 = "vercel.edge_type", $0de125d8b6156cce$export$3c973217450c3e9d = "vercel.entrypoint", $0de125d8b6156cce$export$582c0b730ff1ddb9 = "vercel.execution_region", $0de125d8b6156cce$export$b3edfb545b65f1c5 = "vercel.id", $0de125d8b6156cce$export$2593317d8731841c = "vercel.ja3_digest", $0de125d8b6156cce$export$8bb5bc1732aa41f = "vercel.ja4_digest", $0de125d8b6156cce$export$74a79c98b110b5b9 = "vercel.log_type", $0de125d8b6156cce$export$26461b03281b4db4 = "vercel.path", $0de125d8b6156cce$export$eaea590d6d3dd93c = "vercel.project_id", $0de125d8b6156cce$export$af45365f70099379 = "vercel.project_name", $0de125d8b6156cce$export$a49e732d34d5ba9b = "vercel.proxy.cache_id", $0de125d8b6156cce$export$7c147fe246bc8bd3 = "vercel.proxy.client_ip", $0de125d8b6156cce$export$e5111b6070e1ee9e = "vercel.proxy.host", $0de125d8b6156cce$export$591cbfd403f8c8d = "vercel.proxy.lambda_region", $0de125d8b6156cce$export$b1388db955bbb885 = "vercel.proxy.method", $0de125d8b6156cce$export$e898d0e9e211abd9 = "vercel.proxy.path", $0de125d8b6156cce$export$ab6fee0e8a6ee069 = "vercel.proxy.path_type", $0de125d8b6156cce$export$9786ad94c199ffbb = "vercel.proxy.path_type_variant", $0de125d8b6156cce$export$269890524eed693b = "vercel.proxy.referer", $0de125d8b6156cce$export$2ec623a8212d6b64 = "vercel.proxy.region", $0de125d8b6156cce$export$30e7673b01ff994e = "vercel.proxy.response_byte_size", $0de125d8b6156cce$export$9ea93477840812bf = "vercel.proxy.scheme", $0de125d8b6156cce$export$a6da0c365670c430 = "vercel.proxy.status_code", $0de125d8b6156cce$export$7986b22da43f2885 = "vercel.proxy.timestamp", $0de125d8b6156cce$export$a9f943c7ceb3b42f = "vercel.proxy.user_agent", $0de125d8b6156cce$export$dfe49501efcdffce = "vercel.proxy.vercel_cache", $0de125d8b6156cce$export$be465f50c92eb01d = "vercel.proxy.vercel_id", $0de125d8b6156cce$export$c138d1796bb34999 = "vercel.proxy.waf_action", $0de125d8b6156cce$export$85a0016690a0ccf2 = "vercel.proxy.waf_rule_id", $0de125d8b6156cce$export$883acab36ede4bfa = "vercel.request_id", $0de125d8b6156cce$export$9cfc88d203f9cdf1 = "vercel.source", $0de125d8b6156cce$export$b3c6c599110d7bab = "vercel.status_code", $0de125d8b6156cce$export$96f586f8837b86ae = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $0de125d8b6156cce$export$bd393bbb84b309d3 = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};


function $5e4d56cfb7ac3b31$export$b1e72a433efdc918(span, client) {
    var _processedSpan_attributes;
    const spanJSON = (0, $cac16f6eada858e7$export$db0cad9e44f67af8)(span);
    const segmentSpan = (0, $cac16f6eada858e7$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $cac16f6eada858e7$export$db0cad9e44f67af8)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $f7bbc910493e6179$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $d1de0be2af275d5b$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $5e4d56cfb7ac3b31$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $5e4d56cfb7ac3b31$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $5e4d56cfb7ac3b31$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, $c26cfd9b49302c59$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $5e4d56cfb7ac3b31$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    const spanNameSource = (_processedSpan_attributes = processedSpan.attributes) === null || _processedSpan_attributes === void 0 ? void 0 : _processedSpan_attributes[0, $fdf17a1e56d9d4ca$export$d7a7d984b0791405];
    if (spanJSON.is_segment && spanNameSource) $5e4d56cfb7ac3b31$export$146fcadff0eefcf3(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $cac16f6eada858e7$export$5402aa553bcf35f3)(processedSpan)), {
        _segmentSpan: segmentSpan
    });
}
function $5e4d56cfb7ac3b31$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = (0, $f1ef6c7ef9a15d58$export$3f58558cf4af9c09)(scopeData.contexts);
    $5e4d56cfb7ac3b31$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $5e4d56cfb7ac3b31$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    var _spanJSON_attributes;
    const originalAttributes = (_spanJSON_attributes = spanJSON.attributes) !== null && _spanJSON_attributes !== void 0 ? _spanJSON_attributes : spanJSON.attributes = {};
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $5e4d56cfb7ac3b31$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $5e4d56cfb7ac3b31$export$146fcadff0eefcf3(segmentSpanJSON, {
        [(0, $fdf17a1e56d9d4ca$export$bd847b1cc92ae587)]: integrationNames
    });
}
function $5e4d56cfb7ac3b31$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    var _sdk_sdk, _sdk_sdk1, _scopeData_user, _scopeData_user1, _scopeData_user2, _scopeData_user3;
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $5e4d56cfb7ac3b31$export$146fcadff0eefcf3(spanJSON, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        [(0, $0de125d8b6156cce$export$ddbc15c0e8e8a7ea)]: "stream",
        [(0, $0de125d8b6156cce$export$d4f25b923533dbba)]: serializedSegmentSpan.name,
        [(0, $0de125d8b6156cce$export$9943ffdcaa4bc506)]: serializedSegmentSpan.span_id,
        [(0, $0de125d8b6156cce$export$d59b669d4bb3f006)]: sdk === null || sdk === void 0 ? void 0 : (_sdk_sdk = sdk.sdk) === null || _sdk_sdk === void 0 ? void 0 : _sdk_sdk.name,
        [(0, $0de125d8b6156cce$export$4d88d347aa9667fc)]: sdk === null || sdk === void 0 ? void 0 : (_sdk_sdk1 = sdk.sdk) === null || _sdk_sdk1 === void 0 ? void 0 : _sdk_sdk1.version,
        [(0, $fdf17a1e56d9d4ca$export$f5cefb258679b29e)]: release,
        [(0, $fdf17a1e56d9d4ca$export$d1b1dbb47f5ba57c)]: environment || (0, $370456451b52ff1d$export$849dbeeeda01ae98),
        [(0, $fdf17a1e56d9d4ca$export$1f9cc1d34ea098a0)]: (_scopeData_user = scopeData.user) === null || _scopeData_user === void 0 ? void 0 : _scopeData_user.id,
        [(0, $fdf17a1e56d9d4ca$export$b7466609ef46c07e)]: (_scopeData_user1 = scopeData.user) === null || _scopeData_user1 === void 0 ? void 0 : _scopeData_user1.email,
        [(0, $fdf17a1e56d9d4ca$export$8d592bdaea63b930)]: (_scopeData_user2 = scopeData.user) === null || _scopeData_user2 === void 0 ? void 0 : _scopeData_user2.ip_address,
        [(0, $fdf17a1e56d9d4ca$export$c05ee933d3f74b2b)]: (_scopeData_user3 = scopeData.user) === null || _scopeData_user3 === void 0 ? void 0 : _scopeData_user3.username
    }, scopeData.attributes));
}
function $5e4d56cfb7ac3b31$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $cac16f6eada858e7$export$d11691ff45a3e535)();
        return span;
    }
    return modifedSpan;
}



const $b24879b1551d47c8$var$INTEGRATION_NAME = "CultureContext";
const $b24879b1551d47c8$var$_cultureContextIntegration = ()=>{
    return {
        name: $b24879b1551d47c8$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            var _event_contexts;
            const culture = $b24879b1551d47c8$var$getCultureContext();
            if (culture) event.contexts = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, event.contexts), {
                culture: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, culture, (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.culture)
            });
        },
        processSegmentSpan (span) {
            const culture = $b24879b1551d47c8$var$getCultureContext();
            if (culture) (0, $5e4d56cfb7ac3b31$export$146fcadff0eefcf3)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $b24879b1551d47c8$export$ec5976aacdc85985 = (0, $425e0f9c169ee798$export$2323046b9414659f)($b24879b1551d47c8$var$_cultureContextIntegration);
function $b24879b1551d47c8$var$getCultureContext() {
    try {
        const intl = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch (e) {
        return void 0;
    }
}





let $9d033d1e0336d65c$var$_oldOnErrorHandler = null;
function $9d033d1e0336d65c$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $9d033d1e0336d65c$var$instrumentError);
}
function $9d033d1e0336d65c$var$instrumentError() {
    $9d033d1e0336d65c$var$_oldOnErrorHandler = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onerror;
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $53b768e21077af87$export$b18c893e424d3127)("error", handlerData);
        if ($9d033d1e0336d65c$var$_oldOnErrorHandler) return $9d033d1e0336d65c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler = null;
function $2c547f3d9d7242c6$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $53b768e21077af87$export$a4e09611e30da72e)(type, handler);
    (0, $53b768e21077af87$export$e18d6c5462c01368)(type, $2c547f3d9d7242c6$var$instrumentUnhandledRejection);
}
function $2c547f3d9d7242c6$var$instrumentUnhandledRejection() {
    $2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler = (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $53b768e21077af87$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler) return $2c547f3d9d7242c6$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $df8678217e707dd5$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $008435ba3a09b2ce$var$INTEGRATION_NAME = "GlobalHandlers";
const $008435ba3a09b2ce$var$_globalHandlersIntegration = (options = {})=>{
    const _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $008435ba3a09b2ce$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $008435ba3a09b2ce$var$_installGlobalOnErrorHandler(client);
                $008435ba3a09b2ce$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $008435ba3a09b2ce$var$_installGlobalOnUnhandledRejectionHandler(client);
                $008435ba3a09b2ce$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $008435ba3a09b2ce$export$66acc70e8cf2b71a = (0, $425e0f9c169ee798$export$2323046b9414659f)($008435ba3a09b2ce$var$_globalHandlersIntegration);
function $008435ba3a09b2ce$var$_installGlobalOnErrorHandler(client) {
    (0, $9d033d1e0336d65c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $008435ba3a09b2ce$var$getOptions();
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client || (0, $437be5401ebe48b5$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $008435ba3a09b2ce$var$_enhanceEventWithInitialFrame((0, $30b34c487def1b34$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $bb3616fd55b6cdc0$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $008435ba3a09b2ce$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $2c547f3d9d7242c6$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $008435ba3a09b2ce$var$getOptions();
        if ((0, $6486f3d311605b78$export$6bb76d6eba7e258c)() !== client || (0, $437be5401ebe48b5$export$b79738ab10c590b2)()) return;
        const error = $008435ba3a09b2ce$export$b2cc40fa8241780(e);
        const event = (0, $85e272e760900bb9$export$c3825b437cbdea5c)(error) ? $008435ba3a09b2ce$export$1353b5b36844a9ed(error) : (0, $30b34c487def1b34$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $bb3616fd55b6cdc0$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $008435ba3a09b2ce$export$b2cc40fa8241780(error) {
    if ((0, $85e272e760900bb9$export$c3825b437cbdea5c)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e) {}
    return error;
}
function $008435ba3a09b2ce$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $008435ba3a09b2ce$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    var _getFilenameFromUrl;
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: (_getFilenameFromUrl = $008435ba3a09b2ce$var$getFilenameFromUrl(url)) !== null && _getFilenameFromUrl !== void 0 ? _getFilenameFromUrl : (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)(),
        function: (0, $a6df8b9dd4ca405a$export$27c7e15d453fc0ac),
        in_app: true
    });
    return event;
}
function $008435ba3a09b2ce$var$globalHandlerLog(type) {
    (0, $03d071cefd392f71$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $008435ba3a09b2ce$var$getOptions() {
    const client = (0, $6486f3d311605b78$export$6bb76d6eba7e258c)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $008435ba3a09b2ce$var$getFilenameFromUrl(url) {
    if (!(0, $85e272e760900bb9$export$844ec244b1367d54)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $e3f8d2d1d7c51bd6$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}






const $ae48a345b36d4dea$export$1378794447170364 = (0, $425e0f9c169ee798$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            var _event_request;
            if (!(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).navigator && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $437be5401ebe48b5$export$a3c4a8453e8936f0)();
            const headers = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, reqData, event.request), {
                headers: headers
            });
        },
        processSegmentSpan (span) {
            var _span_attributes;
            const spanOp = (_span_attributes = span.attributes) === null || _span_attributes === void 0 ? void 0 : _span_attributes[0, $fdf17a1e56d9d4ca$export$1a413bd9a88fdb09];
            if (!(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).navigator && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).location && !(0, $437be5401ebe48b5$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $437be5401ebe48b5$export$a3c4a8453e8936f0)();
            (0, $5e4d56cfb7ac3b31$export$146fcadff0eefcf3)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": spanOp !== "http.client" ? reqData.url : void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});





function $3b6f7235b5d38fbd$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !(0, $85e272e760900bb9$export$49034edbe6b62415)(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $85e272e760900bb9$export$49034edbe6b62415)(error[key], Error)) {
        $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($3b6f7235b5d38fbd$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $85e272e760900bb9$export$49034edbe6b62415)(childError, Error)) {
            $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $3b6f7235b5d38fbd$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $3b6f7235b5d38fbd$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        handled: true,
        type: "auto.core.linked_errors"
    }, $3b6f7235b5d38fbd$var$isExceptionGroup(error) && {
        is_exception_group: true
    }, exception.mechanism), {
        exception_id: exceptionId
    });
}
function $3b6f7235b5d38fbd$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        handled: true
    }, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}



const $e21518743e269de2$var$DEFAULT_KEY = "cause";
const $e21518743e269de2$var$DEFAULT_LIMIT = 5;
const $e21518743e269de2$var$INTEGRATION_NAME = "LinkedErrors";
const $e21518743e269de2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e21518743e269de2$var$DEFAULT_LIMIT;
    const key = options.key || $e21518743e269de2$var$DEFAULT_KEY;
    return {
        name: $e21518743e269de2$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $3b6f7235b5d38fbd$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $30b34c487def1b34$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $e21518743e269de2$export$ebabb00eb7f3a395 = (0, $425e0f9c169ee798$export$2323046b9414659f)($e21518743e269de2$var$_linkedErrorsIntegration);






const $3e6faad079da1d06$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $3bac9bbc1b963200$var$cachedImplementations = {};
function $3bac9bbc1b963200$export$e464f4a514ac28a8(name) {
    const cached = $3bac9bbc1b963200$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81)[name];
    if ((0, $ed8e12a1b26c7e3d$export$d5f608b368e73f38)(impl)) return $3bac9bbc1b963200$var$cachedImplementations[name] = impl.bind((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81));
    const document = (0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $3e6faad079da1d06$export$16a28057038b10ef) && (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $3bac9bbc1b963200$var$cachedImplementations[name] = impl.bind((0, $b7c04b6a834a93ab$export$56d8a8a25bd48b81));
}
function $3bac9bbc1b963200$export$8aa36702e8c8978(name) {
    $3bac9bbc1b963200$var$cachedImplementations[name] = void 0;
}
function $3bac9bbc1b963200$export$e7aa7bc5c1b3cfb3(...rest) {
    return $3bac9bbc1b963200$export$e464f4a514ac28a8("fetch")(...rest);
}
function $3bac9bbc1b963200$export$831dc9f2ab0a617b(...rest) {
    return $3bac9bbc1b963200$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $141b8c0af9761dc1$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $141b8c0af9761dc1$export$b2311068c46d7cc8(options, nativeFetch = (0, $3bac9bbc1b963200$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15
        }, options.fetchOptions);
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $3bac9bbc1b963200$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $fd4b80e45f21271b$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $37fe8c4357879c39$export$85a4f67f852183e6)(options.bufferSize || $141b8c0af9761dc1$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $3c847d25aac5a3f2$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch (e) {
        return false;
    }
}


const $7297cbf2d0486041$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $7297cbf2d0486041$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $3c847d25aac5a3f2$export$45a5e7f76e0caa8d)(value)) {
        const objName = $7297cbf2d0486041$var$getConstructorName(value);
        if ($7297cbf2d0486041$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $d6cf245db051044b$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $7297cbf2d0486041$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : "null prototype";
}





function $fec3fc268afb8040$export$dc236a86065879fc() {
    if ($fec3fc268afb8040$var$_isEmbeddedBrowserExtension()) {
        if (0, $03d071cefd392f71$export$16a28057038b10ef) (0, $d8898b8567c29ee9$export$cda52e2a8927a2ca)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $fec3fc268afb8040$var$_isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    const href = (0, $0ff4a1c827ec052f$export$1cfafeee2987818b)();
    const isDedicatedExtensionPage = (0, $437be5401ebe48b5$export$56d8a8a25bd48b81) === (0, $437be5401ebe48b5$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $ab62593fb3228f58$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $cc458e21b964fdb2$export$cb3c5c2ceb9818ba)(),
        (0, $af5076b22b0f565c$export$7918117e9202e4fb)(),
        (0, $d33fc4dd6add5ea5$export$97457a453081a5b3)(),
        (0, $e83828a914926395$export$59bfe9f1c76150e)(),
        (0, $6345fc92bb1e1d94$export$c079d904b326663a)(),
        (0, $008435ba3a09b2ce$export$66acc70e8cf2b71a)(),
        (0, $e21518743e269de2$export$ebabb00eb7f3a395)(),
        (0, $ba9fe14e35164f86$export$6d39aa44cd0c7567)(),
        (0, $ae48a345b36d4dea$export$1378794447170364)(),
        (0, $b24879b1551d47c8$export$ec5976aacdc85985)(),
        (0, $243e9b09baa28783$export$1baa7880e357371c)()
    ];
}
function $ab62593fb3228f58$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $fec3fc268afb8040$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $ab62593fb3228f58$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $a6df8b9dd4ca405a$export$1d5cf88b347146d4)(options.stackParser || (0, $5169eff32bb2cc1c$export$2b2b997d81bf3907)),
        integrations: (0, $425e0f9c169ee798$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $141b8c0af9761dc1$export$b2311068c46d7cc8)
    });
    (0, $7879d292a118e15d$export$575c40989754ba4d)((0, $7297cbf2d0486041$export$4c88c355e6072df5));
    return (0, $5adaab7f928cd880$export$5333c3f1c58d9bc1)((0, $31a3c3a87f4e980b$export$1df9218a526d318d), clientOptions);
}
function $ab62593fb3228f58$export$a3f323d81eede727() {}
function $ab62593fb3228f58$export$4e4d8b287d028b6b(callback) {
    callback();
}





/** Gets the merged scope data */ function $adaf1b684779c558$export$eb4e2ea7ad4e9d9a() {
    const globalScope = (0, $6486f3d311605b78$export$aa55d5ab8e05984f)().getScopeData();
    const isolationScope = (0, $6486f3d311605b78$export$68f3af03034c9e90)().getScopeData();
    const currentScope = (0, $6486f3d311605b78$export$c7be4b0125a10cba)().getScopeData();
    (0, $d1de0be2af275d5b$export$25ac7e259a513db4)(globalScope, isolationScope);
    (0, $d1de0be2af275d5b$export$25ac7e259a513db4)(globalScope, currentScope);
    globalScope.eventProcessors = [];
    return globalScope;
}
/** Hooks both current and isolation scope changes and passes merged scope on changes  */ function $adaf1b684779c558$export$63aca979985820db(callback) {
    (0, $6486f3d311605b78$export$68f3af03034c9e90)().addScopeListener((isolation)=>{
        const merged = $adaf1b684779c558$export$eb4e2ea7ad4e9d9a();
        callback(merged, isolation);
    });
    (0, $6486f3d311605b78$export$c7be4b0125a10cba)().addScopeListener((current)=>{
        const merged = $adaf1b684779c558$export$eb4e2ea7ad4e9d9a();
        callback(merged, current);
    });
    (0, $6486f3d311605b78$export$aa55d5ab8e05984f)().addScopeListener((global)=>{
        const merged = $adaf1b684779c558$export$eb4e2ea7ad4e9d9a();
        callback(merged, global);
    });
}



/**
 * Passes scope changes to the main process.
 */ const $446c1169140a0682$export$c652adbdb172b96f = (0, $425e0f9c169ee798$export$2323046b9414659f)(()=>{
    return {
        name: 'ScopeToMain',
        setup (client) {
            const ipc = (0, $2ee8f950f6923ed9$export$4d0c35c3c1a4776f)(client);
            (0, $adaf1b684779c558$export$63aca979985820db)((merged, changed)=>{
                ipc.sendScope(JSON.stringify((0, $7879d292a118e15d$export$a3295358bff77e)(merged, 20, 2000)));
                changed.clearBreadcrumbs();
                changed.clearAttachments();
            });
        }
    };
});





/**
 * Creates a Transport that passes envelopes to the Electron main process.
 */ function $68bdfd6c7379496a$export$6b8011f06c1b4302(options) {
    let ipc;
    return (0, $fd4b80e45f21271b$export$d09f50d9ab7f7b69)(options, async (request)=>{
        // We delay getting the IPC interface until until there is a client where we can pull the IPC namespace from.
        if (!ipc) ipc = (0, $2ee8f950f6923ed9$export$4d0c35c3c1a4776f)();
        ipc.sendEnvelope(request.body);
        // Since the main process handles sending of envelopes and rate limiting, we always return 200 OK to the renderers.
        return {
            statusCode: 200
        };
    });
}


/** Get the default integrations for the renderer SDK. */ function $ddb9ed14f9d24ad0$export$5783b2920b1d62b9(options) {
    return [
        ...(0, $ab62593fb3228f58$export$5783b2920b1d62b9)(options).filter((i)=>i.name !== 'BrowserSession' && i.name !== 'CultureContext'),
        (0, $446c1169140a0682$export$c652adbdb172b96f)()
    ];
}
/**
 * Initialize Sentry in the Electron renderer process
 * @param options SDK options
 * @param originalInit Optional init function for a specific framework SDK
 * @returns
 */ function $ddb9ed14f9d24ad0$export$2cd8252107eb640b(options = {}, // This parameter name ensures that TypeScript error messages contain a hint for fixing SDK version mismatches
originalInit = (0, $ab62593fb3228f58$export$2cd8252107eb640b)) {
    var _window;
    // Ensure the browser SDK is only init'ed once.
    if ((_window = window) === null || _window === void 0 ? void 0 : _window.__SENTRY__RENDERER_INIT__) {
        (0, $d8898b8567c29ee9$export$1c9f709888824e05).warn(`The browser SDK has already been initialized.
If init has been called in the preload and contextIsolation is disabled, is not required to call init in the renderer`);
        return;
    }
    window.__SENTRY__RENDERER_INIT__ = true;
    // Disable client reports for renderer as the sdk should only send
    // events using the main process.
    options.sendClientReports = false;
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $ddb9ed14f9d24ad0$export$5783b2920b1d62b9(options);
    if (options.stackParser === undefined) options.stackParser = (0, $973693a0215d9dfd$export$d6d804653700038a);
    if (options.ipcNamespace === undefined) options.ipcNamespace = 'sentry-ipc';
    // eslint-disable-next-line deprecation/deprecation
    if (options.dsn === undefined) // Events are sent via the main process but browser SDK wont start without dsn
    // eslint-disable-next-line deprecation/deprecation
    options.dsn = 'https://12345@dummy.dsn/12345';
    if (options.transport === undefined) options.transport = (0, $68bdfd6c7379496a$export$6b8011f06c1b4302);
    // We only handle initialScope in the main process otherwise it can cause race conditions over IPC
    delete options.initialScope;
    originalInit(options);
}











var $7fPBF = parcelRequire("7fPBF");


const $5fba312ddab247b6$var$assertUnreachable = (request)=>{
    throw new Error(`Unsupported billing link request: ${JSON.stringify(request)}`);
};
/** Most recently expiring trial first. */ const $5fba312ddab247b6$var$sortTrialsByExpiration = (trials)=>[
        ...trials !== null && trials !== void 0 ? trials : []
    ].sort((a, b)=>new Date(b.expirationDate).getTime() - new Date(a.expirationDate).getTime());
/** A Stripe-backed trial is a live subscription, so it is managed through the billing portal. */ const $5fba312ddab247b6$var$isStripeTrial = (trial)=>Boolean((trial === null || trial === void 0 ? void 0 : trial.isAutoUpdate) && (trial === null || trial === void 0 ? void 0 : trial.isCreatedFromStripe));
const $5fba312ddab247b6$var$hasBillingPermissions = ({ organizationMembership: organizationMembership, managedOrgId: managedOrgId, productId: productId })=>Boolean(// Picking a specific product is a self-serve purchase any member may start.
    productId || managedOrgId && organizationMembership.canManageChildOrganizations || organizationMembership.isAdmin || organizationMembership.canManageBilling);
const $5fba312ddab247b6$var$hasActiveLicense = (organizationMembership, now)=>{
    const { hasLicense: hasLicense, licenseExpirationDate: licenseExpirationDate } = organizationMembership.organization;
    return Boolean(hasLicense && (!licenseExpirationDate || new Date(licenseExpirationDate) >= now));
};
const $5fba312ddab247b6$export$5f86b113e6f03cf0 = ({ organizationId: organizationId, organizationMembership: organizationMembership, managedOrgId: managedOrgId, productId: productId, now: now = new Date() })=>{
    if (!$5fba312ddab247b6$var$hasBillingPermissions({
        organizationMembership: organizationMembership,
        managedOrgId: managedOrgId,
        productId: productId
    })) return {
        type: 'permissionDenied'
    };
    // A managed org is always billed through its parent's managed portal
    if (managedOrgId) return {
        type: 'openExternalBilling',
        request: {
            type: 'managedOrgBillingLink',
            organizationId: organizationId,
            managedOrgId: managedOrgId
        },
        errorRedirectPath: `/org/${organizationId}/managed/${managedOrgId}/billing/redirect/error`
    };
    const { hasLicense: hasLicense, isReseller: isReseller, customBillingUrl: customBillingUrl, trials: trials } = organizationMembership.organization;
    const sortedTrials = $5fba312ddab247b6$var$sortTrialsByExpiration(trials);
    const activeTrial = sortedTrials.find((trial)=>new Date(trial.expirationDate) >= now);
    const errorRedirectPath = hasLicense ? `/org/${organizationId}/billing/redirect/error` : `/org/${organizationId}/trial/redirect/error`;
    const openExternalBilling = (request)=>({
            type: 'openExternalBilling',
            request: request,
            errorRedirectPath: errorRedirectPath
        });
    if (productId) {
        // product selection
        if (!isReseller && $5fba312ddab247b6$var$hasActiveLicense(organizationMembership, now)) return openExternalBilling({
            type: 'licensedOrgProductLink',
            organizationId: organizationId,
            productId: productId
        });
        if (!isReseller && activeTrial) return openExternalBilling({
            type: 'trialOrgProductLink',
            organizationId: organizationId,
            trialId: activeTrial.id,
            productId: productId
        });
        return openExternalBilling({
            type: 'orgProductLink',
            organizationId: organizationId,
            productId: productId
        });
    }
    // Existing Subscription
    const hasBillingPortal = $5fba312ddab247b6$var$hasActiveLicense(organizationMembership, now) || Boolean(customBillingUrl) || $5fba312ddab247b6$var$isStripeTrial(activeTrial !== null && activeTrial !== void 0 ? activeTrial : sortedTrials[0]);
    if (hasBillingPortal) return openExternalBilling({
        type: 'orgBillingLink',
        organizationId: organizationId
    });
    // Explore Products
    return {
        type: 'navigateToCompare',
        comparePath: `/org/${organizationId}/billing/compare`
    };
};
const $5fba312ddab247b6$export$53f5ff045c974caa = (resolvers, request)=>{
    switch(request.type){
        case 'orgProductLink':
            return resolvers.getOrganizationProductLink(request.organizationId, request.productId);
        case 'licensedOrgProductLink':
            return resolvers.getBillingLinkForOrgByProduct(request.organizationId, request.productId);
        case 'trialOrgProductLink':
            return resolvers.getTrialUpgradeLinkForProduct(request.organizationId, request.trialId, request.productId);
        case 'managedOrgBillingLink':
            return resolvers.getBillingLinkForManagedOrg(request.organizationId, request.managedOrgId);
        case 'orgBillingLink':
            return resolvers.getBillingLink(request.organizationId);
        default:
            return $5fba312ddab247b6$var$assertUnreachable(request);
    }
};


function $52d9b4cf6ab1d6c0$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, productId: productId, managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const openBillingLink = (billingLink, errorRedirect)=>{
        if (billingLink) {
            window.open(billingLink, '_blank', 'noopener,noreferrer');
            navigate(-1); // redirect to previous page to maintain context
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:license.redirect.external'));
        } else {
            $bb3616fd55b6cdc0$export$45654777c133ae80('Failed to resolve billing link, showing fallback', {
                extra: {
                    organizationId: organizationId,
                    productId: productId,
                    managedOrgId: managedOrgId,
                    billingLink: billingLink,
                    errorRedirect: errorRedirect,
                    userLicenseAccess: JSON.stringify((0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().userLicenseAccess)
                }
            });
            navigate(errorRedirect, {
                replace: true
            });
        }
    };
    const loadBillingLink = async ()=>{
        if (!organizationId) return false;
        const organizationStore = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
        let organizationMembership = organizationStore.getOrganizationMembership(organizationId);
        if (!organizationMembership) {
            await organizationStore.loadOrganizations(false);
            organizationMembership = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrganizationMembership(organizationId);
        }
        if (!organizationMembership) return false;
        const decision = (0, $5fba312ddab247b6$export$5f86b113e6f03cf0)({
            organizationId: organizationId,
            organizationMembership: organizationMembership,
            managedOrgId: managedOrgId,
            productId: productId
        });
        if (decision.type === 'permissionDenied') return false;
        if (decision.type === 'navigateToCompare') {
            navigate(decision.comparePath, {
                replace: true
            });
            return true;
        }
        const billingLink = await (0, $5fba312ddab247b6$export$53f5ff045c974caa)((0, $55ce97f088539572$export$87aeeca3aeff7121).getState(), decision.request);
        openBillingLink(billingLink, decision.errorRedirectPath);
        return true;
    };
    (0, $7fPBF.useEffect)(()=>{
        const manageBillingLink = async ()=>{
            const hasBillingPermissions = await loadBillingLink();
            if (!hasBillingPermissions) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.canManageBilling.error'));
                navigate(-1);
            }
        };
        manageBillingLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
        startIcon: "repeat",
        onClick: ()=>loadBillingLink(),
        children: t('common:reload')
    });
}




var $7fPBF = parcelRequire("7fPBF");


function $70228be3ff15ddce$export$f08c2f745253d47b() {
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    (0, $7fPBF.useEffect)(()=>{
        const handlePermissionChangeRedirect = ()=>{
            var _organizationStore_memberships;
            const organizationStore = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
            if (!(organizationStore === null || organizationStore === void 0 ? void 0 : organizationStore.memberships) || ((_organizationStore_memberships = organizationStore.memberships) === null || _organizationStore_memberships === void 0 ? void 0 : _organizationStore_memberships.length) < 1) {
                navigate('/', {
                    replace: true
                });
                return;
            }
            const currentMember = organizationStore.getOrganizationMembership(organizationId);
            if (!currentMember) navigate('/', {
                replace: true
            });
        };
        const handleOrgNullRedirect = ()=>{
            if (!organizationId) navigate('/', {
                replace: true
            });
        };
        handlePermissionChangeRedirect();
        handleOrgNullRedirect();
    }, [
        organizationId
    ]);
}



function $fa7643c656d80855$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { canViewOrgDetails: canViewOrgDetails } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:billing.title'),
                items: canViewOrgDetails ? items : []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
                title: t('common:license.redirect.title'),
                description: t('common:license.redirect.description'),
                icon: "money",
                fullHeight: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52d9b4cf6ab1d6c0$export$2e2bcd8739ae039), {})
            })
        ]
    });
}


















function $d1ebcf00b940bfdd$export$2e2bcd8739ae039({ canManageBilling: canManageBilling, organizationId: organizationId, isManagedOrg: isManagedOrg, customBillingUrl: customBillingUrl }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    // show billing link if: not a managed org, or is a managed org with custom billing but not viewed by a reseller admin
    const showBillingLink = !isManagedOrg || !managedOrgId && !!customBillingUrl;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        icon: "cancel",
        fullHeight: true,
        title: t('common:organization.expired.title'),
        description: canManageBilling ? t('common:organization.expired.admin') : t('common:organization.expired.user'),
        children: canManageBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                showBillingLink && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    href: `#${(0, $b969eaec2195befc$export$c169ff81af47339c)({
                        organizationId: organizationId
                    })}`,
                    endIcon: "externalLink",
                    children: t('common:billing.view')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b175acfd81bea10$export$2e2bcd8739ae039), {
                    organizationId: organizationId
                })
            ]
        })
    });
}













const $6601f3edf09b4a92$var$CardIcon = (_param)=>{
    var { title: title, description: description, name: name, size: size = 100, children: children } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "description",
        "name",
        "size",
        "children"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$f2e4196c0d2b5bb8), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    name: name,
                    size: size
                }, restProps))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
};
var $6601f3edf09b4a92$export$2e2bcd8739ae039 = $6601f3edf09b4a92$var$CardIcon;




var $7fPBF = parcelRequire("7fPBF");






function $9588f4c9a4c5209d$export$2e2bcd8739ae039({ variant: variant, organizationId: organizationId, textOverride: textOverride }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: parentOrgId, managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    let url = '';
    let textKey = 'common:other.title';
    let endIcon;
    let appendManagedOrg = false;
    let destinationPath = null;
    if (!variant || !organizationId) return null;
    // handle for reseller managed org navigation
    if (organizationId !== parentOrgId && parentOrgId && organizationId === managedOrgId) {
        organizationId = parentOrgId;
        appendManagedOrg = true;
    }
    switch(variant){
        case 'orgMembers':
            url = `/members`;
            textKey = 'common:organization.canViewMembers.title';
            break;
        case 'orgBilling':
            url = `/billing`;
            textKey = 'common:organization.canManageBilling.title';
            break;
        case 'orgDetails':
            url = `/`;
            textKey = 'common:organization.titleLong';
            break;
        case 'orgInvites':
            url = `/members/invites`;
            textKey = 'common:organization.invite.view';
            break;
        case 'orgMe':
            url = `/`;
            textKey = 'common:organization.member.me';
            break;
        case 'orgAuthClient':
            url = `/projects`;
            textKey = 'common:organization.canCreateAuthClients.title';
            break;
        case 'orgMetrics':
            url = `/metrics`;
            textKey = 'common:organization.metrics.view';
            break;
        case 'orgProjects':
            url = `/projects`;
            textKey = 'common:organization.projects.view';
            break;
        case 'orgUpgradeRedirect':
            destinationPath = (0, $b969eaec2195befc$export$c169ff81af47339c)({
                organizationId: organizationId,
                managedOrgId: appendManagedOrg ? managedOrgId : undefined
            });
            textKey = 'common:billing.view';
            endIcon = 'externalLink';
            break;
        case 'orgSettings':
            url = `/settings`;
            textKey = 'common:settings.title';
            break;
        case 'orgLicenseKeys':
            url = `/licensekey`;
            textKey = 'common:license.key.titlePlural';
            break;
        case 'orgManagedOrgs':
            url = `/managed`;
            textKey = 'common:organization.managed.title';
            break;
        case 'orgProduct':
            url = `/purchase`;
            textKey = 'common:license.key.product.title';
            break;
        case 'orgProfiles':
            url = `/profiles`;
            textKey = 'common:organization.profiles.title';
            break;
        case 'orgGovernance':
            url = `/governance`;
            textKey = 'common:organization.governance.title';
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
        $color: "subsection",
        to: destinationPath !== null && destinationPath !== void 0 ? destinationPath : appendManagedOrg ? `/org/${organizationId}/managed/${managedOrgId}` + url : `/org/${organizationId}` + url,
        viewTransition: true,
        endIcon: endIcon,
        children: textOverride !== null && textOverride !== void 0 ? textOverride : t(textKey)
    });
}


function $e8b8e2208f47c8d7$export$2e2bcd8739ae039({ orgId: orgId, isLicensed: isLicensed }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showDialog, setShowDialog] = (0, $7fPBF.useState)(false);
    const onClick = ()=>{
        setShowDialog(true);
    };
    const onCancel = ()=>{
        setShowDialog(false);
    };
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
        name: "money",
        title: t('common:billing.title'),
        description: t('common:billing.description'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
                organizationId: orgId,
                variant: "orgUpgradeRedirect"
            }),
            !isLicensed && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "subsection",
                        onClick: onClick,
                        children: t('common:license.activate.title')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e26231f066199887$export$2e2bcd8739ae039), {
                        open: showDialog,
                        onCancel: onCancel,
                        organizationId: orgId
                    })
                ]
            })
        ]
    });
}





function $ba0132d00fab9151$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
        name: "orgTransaction",
        title: t('common:billing.title'),
        description: t('common:billing.error')
    });
}


let $d6e1b40cb257f60f$var$_ = (t)=>t, $d6e1b40cb257f60f$var$t;
function $d6e1b40cb257f60f$export$2e2bcd8739ae039({ currentOrg: currentOrg, canManageBilling: canManageBilling }) {
    const showBilling = canManageBilling && !(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.originatedByOrganizationId) || (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.originatedByOrganizationId) && (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.customBillingUrl);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d6e1b40cb257f60f$var$Row, {
        children: [
            showBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e8b8e2208f47c8d7$export$2e2bcd8739ae039), {
                orgId: currentOrg.id,
                isLicensed: !!currentOrg.hasLicense
            }),
            canManageBilling && !showBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba0132d00fab9151$export$2e2bcd8739ae039), {})
        ]
    });
}
const $d6e1b40cb257f60f$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d6e1b40cb257f60f$var$t || ($d6e1b40cb257f60f$var$t = $d6e1b40cb257f60f$var$_`
    margin: 1rem;
`));






function $2088beebbdbb1bdb$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgAdmin",
        title: t('common:organization.governance.title'),
        description: t('common:organization.governance.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgGovernance'
        })
    });
}






function $3b15295b8744e383$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgInvite",
        title: t('common:organization.canInviteMembers.title'),
        description: t('common:organization.canInviteMembers.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            variant: "orgInvites",
            organizationId: orgId
        })
    });
}






function $e94b26966f7e8b34$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgAuthClient",
        title: t('common:license.key.titlePlural'),
        description: t('common:license.key.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgLicenseKeys'
        })
    });
}






function $b48e4cf00b3bcbc6$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgCompany",
        title: t('common:organization.managed.titlePlural'),
        description: t('common:organization.managed.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgManagedOrgs'
        })
    });
}






function $0f540dd632df425d$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgMembers",
        title: t('common:organization.member.viewAll.title'),
        description: t('common:organization.member.viewAll.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgMembers'
        })
    });
}






function $ede53a4d18dfd239$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "purchaseOrder",
        title: t('common:organization.profiles.title'),
        description: t('common:organization.profiles.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            variant: "orgProfiles",
            organizationId: orgId
        })
    });
}






function $f9629eea5f62c57b$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "orgTransaction",
        title: t('common:license.key.product.titleLong'),
        description: t('common:license.key.product.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgProduct'
        })
    });
}








function $af0cebb6e8b6c0e3$export$2e2bcd8739ae039({ orgId: orgId, projects: projects }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: projects ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
            name: "virtualApps",
            title: t('common:organization.projects.title'),
            description: t('common:organization.projects.description'),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
                organizationId: orgId,
                variant: 'orgProjects'
            })
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$8ffb7ce587ade322), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
                name: "virtualApps",
                title: t('common:organization.projects.title'),
                description: t('common:organization.projects.upgrade.shortDescription'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    href: `https://cephable.com/sdk-trial/`,
                    startIcon: "plusLight",
                    $color: "secondary",
                    children: t('common:upgrade')
                })
            })
        })
    });
}






function $27edc0649b04e14f$export$2e2bcd8739ae039({ orgId: orgId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    if (!orgId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d7313a1e2f7db62$export$2e2bcd8739ae039), {
        name: "settings",
        title: t('common:settings.title'),
        description: t('common:organization.settings.description'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9588f4c9a4c5209d$export$2e2bcd8739ae039), {
            organizationId: orgId,
            variant: 'orgSettings'
        })
    });
}


function $8692271737acf203$export$2e2bcd8739ae039({ isAdminPortal: isAdminPortal = false }) {
    const { canAccessOrganizationProfiles: canAccessOrganizationProfiles, canCreateAuthClients: canCreateAuthClients, canEditOrganizationProfiles: canEditOrganizationProfiles, canInviteMembers: canInviteMembers, canManageBilling: canManageBilling, canManageChildOrganizations: canManageChildOrganizations, canManageGovernance: canManageGovernance, canViewMembers: canViewMembers, canViewOrgDetails: canViewOrgDetails, currentOrg: currentOrg, hasSomeMemberEditPermissions: hasSomeMemberEditPermissions, isExpiredOrg: isExpiredOrg, isLoading: isLoading, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    if (!currentOrg) return null;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    if (!canViewOrgDetails) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6e1b40cb257f60f$export$2e2bcd8739ae039), {
            currentOrg: currentOrg,
            canManageBilling: canManageBilling
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (canViewMembers || hasSomeMemberEditPermissions) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f540dd632df425d$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            canInviteMembers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b15295b8744e383$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            (canAccessOrganizationProfiles || canEditOrganizationProfiles) && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ede53a4d18dfd239$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            canManageGovernance && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2088beebbdbb1bdb$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            }),
            !managedOrgId && currentOrg.isReseller && canManageChildOrganizations && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b48e4cf00b3bcbc6$export$2e2bcd8739ae039), {
                        orgId: currentOrg.id
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e94b26966f7e8b34$export$2e2bcd8739ae039), {
                        orgId: currentOrg.id
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f9629eea5f62c57b$export$2e2bcd8739ae039), {
                        orgId: currentOrg.id
                    })
                ]
            }),
            canCreateAuthClients && isAdminPortal && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af0cebb6e8b6c0e3$export$2e2bcd8739ae039), {
                orgId: currentOrg.id,
                projects: currentOrg.canCreateAuthClients
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27edc0649b04e14f$export$2e2bcd8739ae039), {
                orgId: currentOrg.id
            })
        ]
    });
}














let $e82a2233d2b7ec37$var$_ = (t)=>t, $e82a2233d2b7ec37$var$t, $e82a2233d2b7ec37$var$t1, $e82a2233d2b7ec37$var$t2, $e82a2233d2b7ec37$var$t3, $e82a2233d2b7ec37$var$t4, $e82a2233d2b7ec37$var$t5;
function $e82a2233d2b7ec37$export$2e2bcd8739ae039({ color: color = 'default', title: title, subtitle: subtitle, subtitleAction: subtitleAction, icon: icon, children: children, borderless: borderless = false }) {
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    if (!title) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$bdfe625add29c644), {
        $color: color,
        $borderless: borderless,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e82a2233d2b7ec37$var$FlexRow, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e82a2233d2b7ec37$var$FlexWrap, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e82a2233d2b7ec37$var$IconRow, {
                            children: [
                                icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    size: 18,
                                    name: icon,
                                    color: theme.banner[color].icon
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e82a2233d2b7ec37$var$StyledTitleXSmall, {
                                    as: "h2",
                                    $color: color,
                                    children: title
                                })
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$dc254ddf4c41e5d7), {
                            $color: color,
                            children: [
                                subtitle && typeof subtitle === 'string' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e82a2233d2b7ec37$var$StyledLightXSmall, {
                                    $color: color,
                                    children: subtitle
                                }) : subtitle,
                                subtitleAction
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$503892287317b6c8), {
                    $color: color,
                    children: children
                })
            ]
        })
    });
}
const $e82a2233d2b7ec37$var$FlexWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e82a2233d2b7ec37$var$t || ($e82a2233d2b7ec37$var$t = $e82a2233d2b7ec37$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    flex-wrap: wrap;
`));
const $e82a2233d2b7ec37$var$FlexRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e82a2233d2b7ec37$var$t1 || ($e82a2233d2b7ec37$var$t1 = $e82a2233d2b7ec37$var$_`
    width: 100%;
    flex: 1;
    display: flex;
    gap: 0.5rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`));
const $e82a2233d2b7ec37$var$IconRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)($e82a2233d2b7ec37$var$FlexRow)($e82a2233d2b7ec37$var$t2 || ($e82a2233d2b7ec37$var$t2 = $e82a2233d2b7ec37$var$_`
    justify-content: flex-start;
`));
const $e82a2233d2b7ec37$var$StyledLightXSmall = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$1ef657600983666a))($e82a2233d2b7ec37$var$t3 || ($e82a2233d2b7ec37$var$t3 = $e82a2233d2b7ec37$var$_`
    color: ${0};
    display: inline;
`), (props)=>props.theme.banner[props.$color].text);
const $e82a2233d2b7ec37$var$StyledNotificationContent = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e82a2233d2b7ec37$var$t4 || ($e82a2233d2b7ec37$var$t4 = $e82a2233d2b7ec37$var$_`
    color: ${0};
`), (props)=>props.theme.banner[props.$color].text);
const $e82a2233d2b7ec37$var$StyledTitleXSmall = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))($e82a2233d2b7ec37$var$t5 || ($e82a2233d2b7ec37$var$t5 = $e82a2233d2b7ec37$var$_`
    color: ${0};
`), (props)=>props.theme.banner[props.$color].text);










let $04208d5c79c2b652$var$_ = (t)=>t, $04208d5c79c2b652$var$t, $04208d5c79c2b652$var$t1, $04208d5c79c2b652$var$t2;
const $04208d5c79c2b652$export$b6125dcde81daafc = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($04208d5c79c2b652$var$t || ($04208d5c79c2b652$var$t = $04208d5c79c2b652$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-bottom: 0.5rem;
`));
const $04208d5c79c2b652$export$422de0a0421e1558 = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($04208d5c79c2b652$var$t1 || ($04208d5c79c2b652$var$t1 = $04208d5c79c2b652$var$_`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`));
const $04208d5c79c2b652$export$989506d4e6ea852a = (0, $8de346382d86c747$export$2e2bcd8739ae039).li($04208d5c79c2b652$var$t2 || ($04208d5c79c2b652$var$t2 = $04208d5c79c2b652$var$_`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    color: ${0};
`), ({ theme: theme })=>theme.color.link);




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");

function $0f5d8549378ffa13$export$17a459df3f7c4dec() {
    const [freeTrialOrg, setFreeTrialOrg] = (0, $7fPBF.useState)(null);
    const [mostRecentTrial, setMostRecentTrial] = (0, $7fPBF.useState)(null);
    const canManageBilling = (0, $7fPBF.useMemo)(()=>{
        if (!freeTrialOrg) return false;
        return freeTrialOrg.isAdmin || freeTrialOrg.canManageBilling;
    }, [
        freeTrialOrg
    ]);
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().memberships;
    (0, $7fPBF.useEffect)(()=>{
        const isMemberPartOfOrganization = (memberships === null || memberships === void 0 ? void 0 : memberships.length) > 0;
        if (isMemberPartOfOrganization) {
            let mostRecentTrialOrg = null;
            let mostRecentTrial = null;
            let found = false;
            for (const org of memberships){
                if (found) break;
                if (!org.organization.hasLicense && org.organization.trials) {
                    const activeTrial = org.organization.trials.find((trial)=>new Date(trial.expirationDate) > new Date());
                    if (activeTrial) {
                        mostRecentTrialOrg = org;
                        mostRecentTrial = activeTrial;
                    }
                    // if no active trial, set most recent trial
                    const recentTrial = org.organization.trials.reduce((latest, trial)=>{
                        return new Date(trial.expirationDate) > new Date(latest.expirationDate) ? trial : latest;
                    }, org.organization.trials[0]);
                    if (!mostRecentTrial || new Date(recentTrial.expirationDate) > new Date(mostRecentTrial.expirationDate)) {
                        mostRecentTrialOrg = org;
                        mostRecentTrial = recentTrial;
                    }
                    if (mostRecentTrial && mostRecentTrialOrg) {
                        found = true;
                        break;
                    }
                }
            }
            setFreeTrialOrg(mostRecentTrialOrg);
            setMostRecentTrial(mostRecentTrial);
        }
    }, [
        memberships
    ]);
    return {
        mostRecentTrial: mostRecentTrial,
        freeTrialOrg: freeTrialOrg,
        canManageBilling: canManageBilling
    };
}



function $0ffdb47bc7ff01de$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, managedOrgId: managedOrgId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { removeUpgradeBanner: removeUpgradeBanner, addUpgradeBanner: addUpgradeBanner } = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState();
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const userLicenseAccess = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.userLicenseAccess);
    const memberships = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.memberships);
    const currentOrg = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.currentOrg);
    const { mostRecentTrial: mostRecentTrial, freeTrialOrg: freeTrialOrg, canManageBilling: canManageBilling } = (0, $0f5d8549378ffa13$export$17a459df3f7c4dec)();
    const today = new Date();
    const daysLeft = mostRecentTrial ? Math.ceil((new Date(mostRecentTrial.expirationDate).getTime() - today.getTime()) / 86400000) : 0;
    const isOnHomePage = location.pathname === '/';
    const getTrialProductName = ()=>{
        if (!mostRecentTrial) return '';
        // this logic is based on current product naming conventions and may need to be updated if new products are added or names change
        if (mostRecentTrial.isEmployeeAccess || mostRecentTrial.isStudentAccess) return t('common:billing.isEmployeeAccess.titleLong');
        else if (mostRecentTrial.isPlusAccess) return t('common:billing.isPlusAccess.titleLong');
        else return 'Cephable';
    };
    const handleFreeTrial = (0, $7fPBF.useCallback)(async ()=>{
        // validation
        if (!freeTrialOrg) {
            handleFreeTrialExpiration();
            return;
        }
        var _freeTrialOrg_organization_maxMembers;
        // remaining users calculation
        const maxMembers = (_freeTrialOrg_organization_maxMembers = freeTrialOrg === null || freeTrialOrg === void 0 ? void 0 : freeTrialOrg.organization.maxMembers) !== null && _freeTrialOrg_organization_maxMembers !== void 0 ? _freeTrialOrg_organization_maxMembers : 0;
        let currMembers = 0;
        var _currentOrg_currentMemberCount;
        if ((currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id) === freeTrialOrg.organizationId) currMembers = (_currentOrg_currentMemberCount = currentOrg.currentMemberCount) !== null && _currentOrg_currentMemberCount !== void 0 ? _currentOrg_currentMemberCount : 0;
        else {
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrganizationDetails(freeTrialOrg.organizationId);
            var _result_data_currentMemberCount;
            currMembers = (result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data ? (_result_data_currentMemberCount = result.data.currentMemberCount) !== null && _result_data_currentMemberCount !== void 0 ? _result_data_currentMemberCount : 0 : 0;
        }
        const remainingUsers = Math.max(0, maxMembers - currMembers);
        const isMultiUserOrg = maxMembers > 1;
        const handleUpgrade = ()=>{
            // upgrade button
            if (isOnHomePage && isMultiUserOrg) navigate(`/org/${freeTrialOrg.organizationId}`);
            else navigate((0, $b969eaec2195befc$export$c169ff81af47339c)({
                organizationId: freeTrialOrg.organizationId
            }));
        };
        const ActionComponent = canManageBilling && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            $size: "small",
            startIcon: "upgrade",
            onClick: handleUpgrade,
            children: t('common:upgrade')
        });
        // current org member
        const canInviteMembers = (freeTrialOrg === null || freeTrialOrg === void 0 ? void 0 : freeTrialOrg.canInviteMembers) || (freeTrialOrg === null || freeTrialOrg === void 0 ? void 0 : freeTrialOrg.isAdmin);
        let subtitle = remainingUsers == 0 ? t('common:license.trial.noUsersSubtitle') : t('common:license.trial.subtitle', {
            count: remainingUsers
        });
        if (maxMembers === 1) subtitle = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $04208d5c79c2b652$export$b6125dcde81daafc), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                    children: t('billing.upgrade.longDescription')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04208d5c79c2b652$export$422de0a0421e1558), {
                    children: (0, $3d257c68ce43608e$export$3dc32300594beeaf).map((feature, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $04208d5c79c2b652$export$989506d4e6ea852a), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "check",
                                    size: 16
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                    children: t(feature)
                                })
                            ]
                        }, index))
                })
            ]
        });
        // prevent inviting members if email is not verified
        const SubtitleAction = remainingUsers > 0 && canInviteMembers ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$1a9858f2fb62c3f2), {
            disabled: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isEmailVerified) == false,
            $color: "context",
            to: `/org/${freeTrialOrg.organizationId}/members/invites`,
            children: t('common:organization.canInviteMembers.title')
        }) : null;
        const title = memberships.length > 1 && isOnHomePage ? t('common:license.trial.title.multiple', {
            days: daysLeft,
            organization: freeTrialOrg.organization.name,
            productName: getTrialProductName()
        }) : t('common:license.trial.title.single', {
            days: daysLeft,
            productName: getTrialProductName()
        });
        const freeTrialBanner = {
            id: 'freeTrial',
            title: title,
            subtitle: subtitle,
            children: ActionComponent,
            subtitleAction: SubtitleAction
        };
        addUpgradeBanner(freeTrialBanner);
    }, [
        addUpgradeBanner,
        t,
        freeTrialOrg,
        mostRecentTrial
    ]);
    const handleFreeTrialExpiration = (0, $7fPBF.useCallback)(()=>{
        removeUpgradeBanner('freeTrial');
    }, [
        removeUpgradeBanner
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (userLicenseAccess === null || userLicenseAccess === undefined) return;
        const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().currentUser;
        const isTrial = currentUser && freeTrialOrg && mostRecentTrial && daysLeft > 0 && !userLicenseAccess.hasLicense;
        const isValidPage = isOnHomePage || organizationId && ((freeTrialOrg === null || freeTrialOrg === void 0 ? void 0 : freeTrialOrg.organizationId) === organizationId && !managedOrgId || (freeTrialOrg === null || freeTrialOrg === void 0 ? void 0 : freeTrialOrg.organizationId) === managedOrgId);
        if (isTrial && isValidPage && !(0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().isFreeUser()) handleFreeTrial();
        else handleFreeTrialExpiration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        freeTrialOrg,
        mostRecentTrial,
        organizationId,
        userLicenseAccess
    ]);
}


let $a31cb358b2102a46$var$_ = (t)=>t, $a31cb358b2102a46$var$t;
function $a31cb358b2102a46$export$2e2bcd8739ae039() {
    const upgradeBannersArray = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.upgradeBannersArray);
    (0, $0ffdb47bc7ff01de$export$2e2bcd8739ae039)();
    if (upgradeBannersArray.length === 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a31cb358b2102a46$var$StyledNotificationListingWrap, {
        as: "section",
        children: upgradeBannersArray.map((banner)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e82a2233d2b7ec37$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, banner), banner.id))
    });
}
const $a31cb358b2102a46$var$StyledNotificationListingWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $12a7318cc7b914d5$export$7cee909993ddd8b7))($a31cb358b2102a46$var$t || ($a31cb358b2102a46$var$t = $a31cb358b2102a46$var$_`
    margin: 2rem 0;
`));


function $e8ddd06b3da44631$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a31cb358b2102a46$export$2e2bcd8739ae039), {}),
            children
        ]
    });
}



function $6da00e256676a096$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    var _currentOrg_name, _currentOrg_description;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: (_currentOrg_name = currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name) !== null && _currentOrg_name !== void 0 ? _currentOrg_name : t('common:organization.title'),
                description: (_currentOrg_description = currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.description) !== null && _currentOrg_description !== void 0 ? _currentOrg_description : t('common:organization.description'),
                items: items,
                children: ((currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.customResourcesMarkdown) || (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.managedResourcesMarkdown)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    href: `#/org/${currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id}/documentation`,
                    children: t('common:resources.title')
                })
            }),
            currentOrg && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8692271737acf203$export$2e2bcd8739ae039), {
                isAdminPortal: true
            })
        ]
    });
}












var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
'use client';
function $1bda6af89f760c61$export$2e2bcd8739ae039() {
    const [, setState] = $7fPBF.useState({});
    return $7fPBF.useCallback(()=>{
        setState({});
    }, []);
}






var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
'use client';
function $db7101c987a7f613$var$usePreviousProps(value) {
    const ref = $7fPBF.useRef({});
    $7fPBF.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $db7101c987a7f613$export$2e2bcd8739ae039 = $db7101c987a7f613$var$usePreviousProps;


'use client';
function $f8e26c72dc86ef0a$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $f8e26c72dc86ef0a$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $f8e26c72dc86ef0a$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $f8e26c72dc86ef0a$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $f8e26c72dc86ef0a$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $f8e26c72dc86ef0a$var$defaultFilterOptions = $f8e26c72dc86ef0a$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $f8e26c72dc86ef0a$var$pageSize = 5;
const $f8e26c72dc86ef0a$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && (0, $9028c966bc380775$export$2e2bcd8739ae039)(listboxRef.current.parentElement, document.activeElement);
const $f8e26c72dc86ef0a$var$defaultIsOptionEqualToValue = (option, value)=>option === value;
const $f8e26c72dc86ef0a$var$MULTIPLE_DEFAULT_VALUE = [];
function $f8e26c72dc86ef0a$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $f8e26c72dc86ef0a$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $f8e26c72dc86ef0a$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $f8e26c72dc86ef0a$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $f8e26c72dc86ef0a$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option_label;
        return (_option_label = option.label) !== null && _option_label !== void 0 ? _option_label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = $f8e26c72dc86ef0a$var$defaultIsOptionEqualToValue, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, resetHighlightOnMouseLeave: resetHighlightOnMouseLeave = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $f017d1fe847d8509$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $7fPBF.useRef(false);
    const firstFocus = $7fPBF.useRef(true);
    const inputRef = $7fPBF.useRef(null);
    const listboxRef = $7fPBF.useRef(null);
    // VoiceOver synthesises a spurious Backspace on the input after a chip
    // deletion moves DOM focus back to it. This flag suppresses that one event.
    const ignoreNextBackspaceRef = $7fPBF.useRef(false);
    const windowLostFocus = $7fPBF.useRef(false);
    const [anchorEl, setAnchorEl] = $7fPBF.useState(null);
    const [focusedItem, setFocusedItem] = $7fPBF.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $7fPBF.useRef(defaultHighlighted);
    // Tracks how the current highlight was set:
    // - 'keyboard' — arrow keys, Home/End, PageUp/PageDown
    // - 'mouse'    — handleOptionMouseMove
    // - 'touch'    — handleOptionTouchStart
    // - null       — programmatic (autoHighlight, value sync)
    //
    // This lets handleBlur and the Enter handler distinguish intentional
    // interactions from incidental ones — e.g. autoSelect should not commit
    // a highlight that came from a casual mouse hover.
    /** @type {React.RefObject<AutocompleteHighlightChangeReason | null>} */ const highlightReasonRef = $7fPBF.useRef(null);
    const touchScrolledRef = $7fPBF.useRef(false);
    const isTouchRef = $7fPBF.useRef(false);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $7fPBF.useRef($f8e26c72dc86ef0a$var$getInputValue(defaultValue !== null && defaultValue !== void 0 ? defaultValue : valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $7fPBF.useState(false);
    const resetInputValue = $7fPBF.useCallback((event, newValue, reason)=>{
        // Retain the current `inputValue` when no new option is selected and `clearOnBlur` is false.
        // In `multiple` mode, `newValue` is the next value array, so only length growth counts as a selection.
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        // A controlled single-value `freeSolo` reset to `null` should still clear the input.
        const shouldClearOnReset = reason === 'reset' && freeSolo && !multiple && newValue === null;
        if (!isOptionSelected && !clearOnBlur && !shouldClearOnReset) return;
        const newInputValue = $f8e26c72dc86ef0a$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        freeSolo,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $dbfd4b86e42733ca$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $7fPBF.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const selectedValues = $7fPBF.useMemo(()=>{
        if (multiple) return value;
        if (value != null) return [
            value
        ];
        return [];
    }, [
        multiple,
        value
    ]);
    const selectedValuesSet = $7fPBF.useMemo(()=>{
        // Fast path for the default strict equality comparator to avoid O(n^2) option checks.
        if (isOptionEqualToValue !== $f8e26c72dc86ef0a$var$defaultIsOptionEqualToValue || selectedValues.length === 0) return null;
        return new Set(selectedValues);
    }, [
        isOptionEqualToValue,
        selectedValues
    ]);
    const isOptionSelected = $7fPBF.useCallback((option)=>{
        if (selectedValuesSet) return selectedValuesSet.has(option);
        return selectedValues.some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
    }, [
        isOptionEqualToValue,
        selectedValues,
        selectedValuesSet
    ]);
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && isOptionSelected(option)) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $db7101c987a7f613$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $7fPBF.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // In freeSolo mode, only reset the input after a real value change.
        // Also prevent the initial default value of `null` from clearing controlled values.
        const shouldSkipFreeSoloReset = freeSolo && (!valueChange || value == null && previousProps.value === undefined);
        if (shouldSkipFreeSoloReset) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-item-index="${itemToFocus}"]`).focus();
    });
    // Ensure the focusedItem is never inconsistent
    $7fPBF.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const syncHighlightedIndexToDOM = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(({ index: index, reason: reason, preserveScroll: preserveScroll = false })=>{
        // React can clear refs before pending passive effects run during unmount.
        // If both refs are gone, there is no DOM left to sync.
        if (inputRef.current == null && listboxRef.current == null) return;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            if (!preserveScroll) listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const setHighlightedIndex = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason, preserveScroll: preserveScroll = false })=>{
        highlightedIndexRef.current = index;
        highlightReasonRef.current = reason !== null && reason !== void 0 ? reason : null;
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        syncHighlightedIndexToDOM({
            index: index,
            reason: reason,
            preserveScroll: preserveScroll
        });
    });
    const setHighlightedIndexFromSync = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(({ index: index })=>{
        highlightedIndexRef.current = index;
        syncHighlightedIndexToDOM({
            index: index,
            reason: highlightReasonRef.current
        });
    });
    const changeHighlightedIndex = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason, preserveScroll: preserveScroll })=>{
        if (!popupOpen) return;
        if (reason === 'keyboard') {
            touchScrolledRef.current = false;
            isTouchRef.current = false;
        }
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event,
            preserveScroll: preserveScroll
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$f8e26c72dc86ef0a$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$f8e26c72dc86ef0a$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $7fPBF.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            // Keep the original highlight reason while re-syncing the DOM state.
            // The highlighted option still exists after the filteredOptions array changed
            // (e.g. async fetch returns new options while the user is mid-navigation),
            // so the original interaction reason (keyboard, mouse, etc.) still applies.
            setHighlightedIndexFromSync({
                index: previousHighlightedOptionIndex
            });
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            var _previousProps_filteredOptions;
            // Preserve scroll when new options are appended without changing the current filter.
            const isAppendOnly = filteredOptionsChanged && previousProps.inputValue === inputValue && ((_previousProps_filteredOptions = previousProps.filteredOptions) === null || _previousProps_filteredOptions === void 0 ? void 0 : _previousProps_filteredOptions.length) > 0 && filteredOptions.length > previousProps.filteredOptions.length && previousProps.filteredOptions.every((option, index)=>getOptionLabel(option) === getOptionLabel(filteredOptions[index]));
            changeHighlightedIndex({
                diff: 'reset',
                preserveScroll: isAppendOnly
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            var _previousProps_filteredOptions1;
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current selected highlight while the popup stays open;
            // on reopen, resync from the selected value.
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1 && ((_previousProps_filteredOptions1 = previousProps.filteredOptions) === null || _previousProps_filteredOptions1 === void 0 ? void 0 : _previousProps_filteredOptions1.length) > 0) {
                setHighlightedIndexFromSync({
                    index: highlightedIndexRef.current
                });
                return;
            }
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        changeHighlightedIndex,
        setHighlightedIndex,
        setHighlightedIndexFromSync,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $3dbbba1106564c4f$export$2e2bcd8739ae039)((node)=>{
        (0, $2f83cafe8ca49a0a$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $7fPBF.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen && !disableCloseOnSelect) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen,
        disableCloseOnSelect
    ]);
    // Listen for browser window blur to detect when the user switches tabs or windows.
    // This helps prevent the popup from reopening automatically when the window regains focus.
    $7fPBF.useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const handleWindowBlur = ()=>{
            windowLostFocus.current = true;
        };
        window.addEventListener('blur', handleWindowBlur);
        return ()=>{
            window.removeEventListener('blur', handleWindowBlur);
        };
    }, []);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        isTouchRef.current = false;
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        touchScrolledRef.current = false;
        highlightReasonRef.current = null;
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouchRef.current || blurOnSelect === 'mouse' && !isTouchRef.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-item-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        // When moving focus from the input to tags with ArrowLeft,
        // always jump to the last tag (if any) from the input.
        if (focusedItem === -1 && direction === 'previous') {
            nextItem = value.length - 1;
            // In freeSolo, clear any draft text so it doesn't "come back" later.
            if (freeSolo && inputValue !== '') {
                setInputValueState('');
                if (onInputChange) onInputChange(event, '', 'reset');
            }
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$f8e26c72dc86ef0a$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $f8e26c72dc86ef0a$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    {
                        const input = inputRef.current;
                        // Only handle ArrowLeft when the caret is at the start of the input.
                        // Otherwise let the browser move the caret normally.
                        const caretAtStart = input && input.selectionStart === 0 && input.selectionEnd === 0;
                        if (!caretAtStart) // Let the browser handle normal cursor movement
                        return;
                        // Single-value rendering: move focus from input to the single tag.
                        if (!multiple && renderValue && value != null) {
                            // Moving from input to single tag; clear freeSolo draft text,
                            // so it doesn't reappear when we move back.
                            if (freeSolo && inputValue !== '') {
                                setInputValueState('');
                                if (onInputChange) onInputChange(event, '', 'reset');
                            }
                            setFocusedItem(0);
                            focusItem(0);
                        } else // Multi-value: delegate to tag navigation helper.
                        handleFocusItem(event, 'previous');
                        break;
                    }
                case 'ArrowRight':
                    if (!multiple && renderValue) {
                        setFocusedItem(-1);
                        focusItem(-1);
                    } else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    {
                        // In freeSolo, once the user has typed new text, Enter should commit that text instead
                        // of treating a programmatic highlight as an intentional selection. Programmatic
                        // highlights include autoHighlight and syncHighlightedIndex matching a previous value.
                        const hasProgrammaticHighlight = popupOpen && highlightedIndexRef.current !== -1 && highlightReasonRef.current === null;
                        const shouldCommitFreeSoloOverProgrammaticHighlight = freeSolo && !inputPristine && hasProgrammaticHighlight;
                        const shouldSelectHighlighted = !freeSolo || inputPristine || !hasProgrammaticHighlight;
                        const shouldPreventSubmitAfterFreeSoloCommit = shouldCommitFreeSoloOverProgrammaticHighlight && !touchScrolledRef.current;
                        if (highlightedIndexRef.current !== -1 && popupOpen && shouldSelectHighlighted && // After a touch-scroll the highlight is stale (the user scrolled
                        // past it), so skip selection until the next deliberate interaction.
                        !touchScrolledRef.current) {
                            const option = filteredOptions[highlightedIndexRef.current];
                            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                            // Avoid early form validation, let the end-users continue filling the form.
                            event.preventDefault();
                            if (disabled) return;
                            selectNewValue(event, option, 'selectOption');
                            // Move the selection to the end.
                            if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                        } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                            if (multiple || shouldPreventSubmitAfterFreeSoloCommit) // Allow people to commit the freeSolo value before they submit the form.
                            event.preventDefault();
                            selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                        } else if (popupOpen && touchScrolledRef.current) {
                            // The highlight is stale from a touch-scroll - close without selecting.
                            event.preventDefault();
                            // This happens on Enter, but re-using "escape" as the closest `AutocompleteCloseReason`
                            // to avoid creating a new reason
                            handleClose(event, 'escape');
                        }
                        break;
                    }
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (ignoreNextBackspaceRef.current) {
                        ignoreNextBackspaceRef.current = false;
                        break;
                    }
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                        if (focusedItem !== -1) {
                            // Suppress the spurious Backspace VoiceOver synthesises on the
                            // input after focus returns to it. Clear it shortly after
                            // deletion so a later real Backspace is not ignored if the
                            // synthetic follow-up event never arrives.
                            ignoreNextBackspaceRef.current = true;
                            setTimeout(()=>{
                                if (ignoreNextBackspaceRef.current) ignoreNextBackspaceRef.current = false;
                            }, 0);
                        }
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') // Single-value rendering: Delete on empty input removes
                    // the single rendered option, same "removeOption" reason as multiple.
                    handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        // When focusing the input, ensure any previously focused item (chip)
        // is cleared so the input receives the visible caret and the
        // input-focused styling is applied.
        if (focusedItem !== -1) {
            setFocusedItem(-1);
            // Ensure DOM focus lands on the input
            focusItem(-1);
        }
        // If the window previously lost focus while the popup was open,
        // ignore this focus event to prevent unintended reopening.
        // Reset the flag so normal focus behavior resumes.
        if (windowLostFocus.current) {
            windowLostFocus.current = false;
            return;
        }
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE 11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        // Auto-select the highlighted option on blur, but only if the highlight
        // came from keyboard navigation or was set programmatically (autoHighlight).
        // Mouse hover and touch should not trigger selection — the user may have
        // moved the pointer over an option without intending to commit to it.
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen && highlightReasonRef.current !== 'mouse' && highlightReasonRef.current !== 'touch') selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        const valueChanged = inputValue !== newValue;
        if (valueChanged) {
            setInputValueState(newValue);
            touchScrolledRef.current = false;
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') // For normal single-select, clearing the input clears the value.
        // For renderValue (chip-style single), only Backspace/Delete clear the value.
        {
            if (!disableClearable && !multiple && !renderValue) handleValue(event, null, 'clear');
        } else handleOpen(event);
        // Called after handleOpen so it overrides handleOpen's setInputPristine(true)
        // when the first keystroke also opens the popup.
        if (valueChanged) setInputPristine(false);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
        else // The option is already highlighted (e.g. programmatically via autoHighlight),
        // but the user moved the mouse over it — mark as mouse-initiated so
        // autoSelect on blur correctly treats this as incidental hover.
        highlightReasonRef.current = 'mouse';
        // Don't clear the touch-scroll guard while touch state is still latched.
        // After a touch gesture, browsers may fire compatibility mousemove
        // events; if those cleared the guard immediately, later compat events in
        // the same sequence could be misclassified as a real mouse interaction.
        // Touch state is cleared by the next deliberate interaction
        // (keyboard nav, handleOptionClick, or handleOpen).
        if (!isTouchRef.current) touchScrolledRef.current = false;
    };
    const handleListboxMouseLeave = (event)=>{
        if (!resetHighlightOnMouseLeave || highlightedIndexRef.current === -1 || highlightReasonRef.current !== 'mouse' || isTouchRef.current) return;
        setHighlightedIndex({
            event: event,
            index: -1,
            reason: 'mouse',
            preserveScroll: true
        });
    };
    const handleOptionTouchStart = (event)=>{
        touchScrolledRef.current = false;
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouchRef.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouchRef.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!(0, $9028c966bc380775$export$2e2bcd8739ae039)(event.currentTarget, event.target)) return;
        // Don't interfere with interactions outside the input area (e.g. helper text)
        if (anchorEl && !(0, $9028c966bc380775$export$2e2bcd8739ae039)(anchorEl, event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!(0, $9028c966bc380775$export$2e2bcd8739ae039)(event.currentTarget, event.target)) return;
        // Don't interfere with interactions outside the input area (e.g. helper text)
        if (anchorEl && !(0, $9028c966bc380775$export$2e2bcd8739ae039)(anchorEl, event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open) && // Only handle event when the main button is pressed (left click).
        event.button === 0) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, other), {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: (event)=>{
                    ignoreFocus.current = true;
                    handleClear(event);
                }
            }),
        getItemProps: ({ index: index = 0 } = {})=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, multiple && {
                key: index
            }), {
                'data-item-index': index,
                tabIndex: -1,
                onFocus: ()=>{
                    // If focus on the item doesn't come from keyboard events, we update the state via onFocus.
                    if (focusedItem !== index) setFocusedItem(index);
                }
            }), !readOnly && {
                onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getListboxProps: (other = {})=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, other), {
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                'aria-multiselectable': multiple || undefined,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    var _other_onMouseDown;
                    (_other_onMouseDown = other.onMouseDown) === null || _other_onMouseDown === void 0 ? void 0 : _other_onMouseDown.call(other, event);
                    if (event.defaultMuiPrevented) return;
                    // Prevent blur
                    event.preventDefault();
                },
                onScroll: (event)=>{
                    var _other_onScroll;
                    (_other_onScroll = other.onScroll) === null || _other_onScroll === void 0 ? void 0 : _other_onScroll.call(other, event);
                    if (event.defaultMuiPrevented) return;
                    if (isTouchRef.current) touchScrolledRef.current = true;
                },
                onMouseLeave: (event)=>{
                    var _other_onMouseLeave;
                    (_other_onMouseLeave = other.onMouseLeave) === null || _other_onMouseLeave === void 0 ? void 0 : _other_onMouseLeave.call(other, event);
                    if (event.defaultMuiPrevented) return;
                    handleListboxMouseLeave(event);
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = isOptionSelected(option);
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            var _getOptionKey;
            return {
                key: (_getOptionKey = getOptionKey === null || getOptionKey === void 0 ? void 0 : getOptionKey(option)) !== null && _getOptionKey !== void 0 ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $f8e26c72dc86ef0a$export$2e2bcd8739ae039 = $f8e26c72dc86ef0a$var$useAutocomplete;







var $7fPBF = parcelRequire("7fPBF");









function $7882cc17a80db119$export$6816d4fc0981ec7(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiListSubheader', slot);
}
const $7882cc17a80db119$var$listSubheaderClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $7882cc17a80db119$export$2e2bcd8739ae039 = $7882cc17a80db119$var$listSubheaderClasses;



'use client';
const $1cce50701276f311$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $7882cc17a80db119$export$6816d4fc0981ec7), classes);
};
const $1cce50701276f311$var$ListSubheaderRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $1cce50701276f311$var$ListSubheader = /*#__PURE__*/ $7fPBF.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "color",
        "component",
        "disableGutters",
        "disableSticky",
        "inset"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $1cce50701276f311$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1cce50701276f311$var$ListSubheaderRoot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $1cce50701276f311$export$2e2bcd8739ae039 = $1cce50701276f311$var$ListSubheader;
















function $917245b32cfc71bc$export$8ee01529667e66d9(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiAutocomplete', slot);
}
const $917245b32cfc71bc$var$autocompleteClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $917245b32cfc71bc$export$2e2bcd8739ae039 = $917245b32cfc71bc$var$autocompleteClasses;





'use client';
var $dbb161f60fb52eda$var$_ClearIcon, $dbb161f60fb52eda$var$_ArrowDropDownIcon;
const $dbb161f60fb52eda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $917245b32cfc71bc$export$8ee01529667e66d9), classes);
};
const $dbb161f60fb52eda$var$AutocompleteRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).focused} .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).root}.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $4f2d1e17fd74d4a3$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $515e3e51337f7613$export$2e2bcd8739ae039).root}.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).root}.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).root}.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $572939f6e0094c91$export$2e2bcd8739ae039).root}.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).hiddenLabel}.${(0, $8f851f1fb9b359ad$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $dbb161f60fb52eda$var$AutocompleteEndAdornment = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $dbb161f60fb52eda$var$AutocompleteClearIndicator = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $dbb161f60fb52eda$var$AutocompletePopupIndicator = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $dbb161f60fb52eda$var$AutocompletePopper = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a5b41facef9806db$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $dbb161f60fb52eda$var$AutocompletePaper = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.body1), {
        overflow: 'auto'
    })));
const $dbb161f60fb52eda$var$AutocompleteLoading = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $dbb161f60fb52eda$var$AutocompleteNoOptions = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $dbb161f60fb52eda$var$AutocompleteListbox = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        isolation: 'isolate',
        // Prevent overlap with iOS overlay scrollbars.
        position: 'relative',
        [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $dbb161f60fb52eda$var$AutocompleteGroupLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $1cce50701276f311$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $dbb161f60fb52eda$var$AutocompleteGroupUl = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${(0, $917245b32cfc71bc$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $dbb161f60fb52eda$var$Autocomplete = /*#__PURE__*/ $7fPBF.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, className: className, clearIcon: clearIcon = $dbb161f60fb52eda$var$_ClearIcon || ($dbb161f60fb52eda$var$_ClearIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6d7a2ea81d8b74c9$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, popupIcon: popupIcon = $dbb161f60fb52eda$var$_ArrowDropDownIcon || ($dbb161f60fb52eda$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa033ff66c15bb08$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderValue: renderValue, resetHighlightOnMouseLeave: resetHighlightOnMouseLeave = false, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "autoComplete",
        "autoHighlight",
        "autoSelect",
        "blurOnSelect",
        "className",
        "clearIcon",
        "clearOnBlur",
        "clearOnEscape",
        "clearText",
        "closeText",
        "defaultValue",
        "disableClearable",
        "disableCloseOnSelect",
        "disabled",
        "disabledItemsFocusable",
        "disableListWrap",
        "disablePortal",
        "filterOptions",
        "filterSelectedOptions",
        "forcePopupIcon",
        "freeSolo",
        "fullWidth",
        "getLimitTagsText",
        "getOptionDisabled",
        "getOptionKey",
        "getOptionLabel",
        "isOptionEqualToValue",
        "groupBy",
        "handleHomeEndKeys",
        "id",
        "includeInputInList",
        "inputValue",
        "limitTags",
        "loading",
        "loadingText",
        "multiple",
        "noOptionsText",
        "onChange",
        "onClose",
        "onHighlightChange",
        "onInputChange",
        "onOpen",
        "open",
        "openOnFocus",
        "openText",
        "options",
        "popupIcon",
        "readOnly",
        "renderGroup",
        "renderInput",
        "renderOption",
        "renderValue",
        "resetHighlightOnMouseLeave",
        "selectOnFocus",
        "size",
        "slots",
        "slotProps",
        "value"
    ]);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $f8e26c72dc86ef0a$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        componentName: 'Autocomplete'
    }));
    // Re-render when anchorEl resizes so the Popper width stays in sync.
    // Width is always read synchronously from anchorEl.clientWidth during render
    // (no stale cached value). The hook just triggers a re-render on resize.
    const forceRenderOnResize = (0, $1bda6af89f760c61$export$2e2bcd8739ae039)();
    $7fPBF.useEffect(()=>{
        if (!popupOpen || !anchorEl || typeof ResizeObserver === 'undefined') return undefined;
        let lastWidth = anchorEl.clientWidth;
        const observer = new ResizeObserver(()=>{
            const newWidth = anchorEl.clientWidth;
            if (lastWidth !== newWidth) {
                lastWidth = newWidth;
                forceRenderOnResize();
            }
        });
        observer.observe(anchorEl);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupOpen,
        anchorEl,
        forceRenderOnResize
    ]);
    // When popupOpen becomes false, useAutocomplete returns [] for groupedOptions.
    // Transitioned Poppers can remain mounted for their exit animation, so keep rendering
    // the last open-state options instead of flashing "No options" or an empty Paper.
    // These options are stale because they no longer reflect the hook's current
    // groupedOptions, but they are non-interactive while closing and reset on next open.
    const previousGroupedOptionsRef = $7fPBF.useRef([]);
    const prevPopupOpenRef = $7fPBF.useRef(false);
    const renderedOptions = popupOpen ? groupedOptions : previousGroupedOptionsRef.current;
    (0, $9a1cc0725facde24$export$2e2bcd8739ae039)(()=>{
        if (popupOpen && !prevPopupOpenRef.current) previousGroupedOptionsRef.current = [];
        prevPopupOpenRef.current = popupOpen;
        if (popupOpen && groupedOptions.length > 0) previousGroupedOptionsRef.current = groupedOptions;
    }, [
        popupOpen,
        groupedOptions
    ]);
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const defaultGetOptionLabel = (option)=>{
        var _option_label;
        return (_option_label = option.label) !== null && _option_label !== void 0 ? _option_label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $dbb161f60fb52eda$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $dbb161f60fb52eda$var$AutocompleteRoot,
        externalForwardedProps: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other),
        getSlotProps: getRootProps,
        ownerState: ownerState
    });
    const [ListboxSlot, listboxProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('listbox', {
        elementType: $dbb161f60fb52eda$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        getSlotProps: getListboxProps
    });
    const [PaperSlot, paperProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('paper', {
        elementType: (0, $c12b3e51dd27af1e$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('popper', {
        elementType: (0, $a5b41facef9806db$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null,
                // Prevent interaction with stale cached options during exit transitions.
                // The hook's filteredOptions is [] when popupOpen=false, so clicks on stale
                // rendered options would pass undefined to selectNewValue.
                pointerEvents: popupOpen ? undefined : 'none'
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    // Don't render the Popper when there's no content to show.
    // In freeSolo mode, "No options" text is suppressed, so if there are also no
    // matching options and loading is false, the Paper would be empty.
    // Uses renderedOptions (not groupedOptions) so Popper stays during exit transitions.
    // Respect keepMounted from resolved popperProps (handles both object and callback slotProps forms).
    const hasPopupContent = renderedOptions.length > 0 || loading || !freeSolo || popperProps.keepMounted === true;
    const [ClearIndicatorSlot, clearIndicatorProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('clearIndicator', {
        elementType: $dbb161f60fb52eda$var$AutocompleteClearIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.clearIndicator,
        shouldForwardComponentProp: true,
        additionalProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, getClearProps()), {
            'aria-label': clearText,
            title: clearText
        })
    });
    const [PopupIndicatorSlot, popupIndicatorProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('popupIndicator', {
        elementType: $dbb161f60fb52eda$var$AutocompletePopupIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popupIndicator,
        shouldForwardComponentProp: true,
        additionalProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, getPopupIndicatorProps()), {
            disabled: disabled,
            'aria-label': popupOpen ? closeText : openText,
            title: popupOpen ? closeText : openText
        })
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            className: classes.tag,
            disabled: disabled
        }, getItemProps(params));
    if (multiple) {
        if (value.length > 0) {
            if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const _getCustomizedItemProps = getCustomizedItemProps({
                    index: index
                }), { key: key } = _getCustomizedItemProps, customItemProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_getCustomizedItemProps, [
                    "key"
                ]);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44792dc96536365$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    label: getOptionLabel(option),
                    size: size
                }, customItemProps, externalForwardedProps.slotProps.chip), key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dbb161f60fb52eda$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dbb161f60fb52eda$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props2, [
            "key"
        ]);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, otherProps), {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, optionProps), {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    var _props_fullWidth;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootProps), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: (_props_fullWidth = props.fullWidth) !== null && _props_fullWidth !== void 0 ? _props_fullWidth : true,
                    size: size === 'small' ? 'small' : undefined,
                    slotProps: {
                        inputLabel: getInputLabelProps(),
                        input: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            ref: setAnchorEl,
                            className: classes.inputRoot,
                            startAdornment: startAdornment,
                            onMouseDown: (event)=>{
                                if (event.target === event.currentTarget) handleInputMouseDown(event);
                            }
                        }, (hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($dbb161f60fb52eda$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ClearIndicatorSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, clearIndicatorProps), {
                                        children: clearIcon
                                    })) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PopupIndicatorSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popupIndicatorProps), {
                                        children: popupIcon
                                    })) : null
                                ]
                            })
                        }),
                        htmlInput: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            className: classes.input,
                            disabled: disabled,
                            readOnly: readOnly
                        }, getInputProps())
                    }
                })
            })),
            anchorEl && hasPopupContent ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dbb161f60fb52eda$var$AutocompletePopper, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                as: PopperSlot
            }, popperProps), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($dbb161f60fb52eda$var$AutocompletePaper, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    as: PaperSlot
                }, paperProps), {
                    children: [
                        loading && renderedOptions.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dbb161f60fb52eda$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        renderedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dbb161f60fb52eda$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        renderedOptions.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ListboxSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, listboxProps), {
                            children: renderedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $dbb161f60fb52eda$export$2e2bcd8739ae039 = $dbb161f60fb52eda$var$Autocomplete;















var $7fPBF = parcelRequire("7fPBF");

let $e5a40d332c2f8520$var$_ = (t)=>t, $e5a40d332c2f8520$var$t, $e5a40d332c2f8520$var$t1, $e5a40d332c2f8520$var$t2, $e5a40d332c2f8520$var$t3, $e5a40d332c2f8520$var$t4, $e5a40d332c2f8520$var$t5, $e5a40d332c2f8520$var$t6, $e5a40d332c2f8520$var$t7, $e5a40d332c2f8520$var$t8, $e5a40d332c2f8520$var$t9, $e5a40d332c2f8520$var$t10, $e5a40d332c2f8520$var$t11, $e5a40d332c2f8520$var$t12, $e5a40d332c2f8520$var$t13, $e5a40d332c2f8520$var$t14;
const $e5a40d332c2f8520$var$emptyRule = {
    applyToAllMembers: true,
    ruleType: 'Block',
    appOrDomainName: '',
    rulePrompt: ''
};
function $e5a40d332c2f8520$var$getRuleValues(rule) {
    if (!rule) return $e5a40d332c2f8520$var$emptyRule;
    var _rule_appOrDomainName, _rule_rulePrompt;
    return {
        applyToAllMembers: rule.applyToAllMembers,
        ruleType: rule.ruleType,
        appOrDomainName: (_rule_appOrDomainName = rule.appOrDomainName) !== null && _rule_appOrDomainName !== void 0 ? _rule_appOrDomainName : '',
        rulePrompt: (_rule_rulePrompt = rule.rulePrompt) !== null && _rule_rulePrompt !== void 0 ? _rule_rulePrompt : ''
    };
}
function $e5a40d332c2f8520$export$2e2bcd8739ae039({ organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [rules, setRules] = (0, $7fPBF.useState)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [search, setSearch] = (0, $7fPBF.useState)('');
    const [editingRule, setEditingRule] = (0, $7fPBF.useState)(undefined);
    const [deletingRule, setDeletingRule] = (0, $7fPBF.useState)(null);
    const [assigningRule, setAssigningRule] = (0, $7fPBF.useState)(null);
    const loadRules = async ()=>{
        setIsLoading(true);
        try {
            const result = await $1a4c36336f303477$export$a465a1c9c4acd44f(organizationId);
            if (result.resultType !== 'Ok' || !result.data) throw new Error('Unable to load automation rules');
            setRules(result.data);
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.automation.loadError'));
        } finally{
            setIsLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        loadRules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    const filteredRules = (0, $7fPBF.useMemo)(()=>{
        const normalizedSearch = search.trim().toLowerCase();
        if (!normalizedSearch) return rules;
        return rules.filter((rule)=>[
                rule.appOrDomainName,
                rule.rulePrompt,
                rule.ruleType,
                rule.applyToAllMembers ? 'organization' : 'member'
            ].some((value)=>value === null || value === void 0 ? void 0 : value.toLowerCase().includes(normalizedSearch)));
    }, [
        rules,
        search
    ]);
    const saveRule = async (values)=>{
        try {
            const result = editingRule ? await $1a4c36336f303477$export$79317fff3103dbad(organizationId, editingRule.id, values) : await $1a4c36336f303477$export$fb336c06cd332913(organizationId, values);
            if (result.resultType !== 'Ok' || !result.data) throw new Error('Unable to save automation rule');
            setEditingRule(undefined);
            await loadRules();
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t(editingRule ? 'common:organization.governance.automation.updated' : 'common:organization.governance.automation.created'));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.automation.saveError'));
        }
    };
    const deleteRule = async ()=>{
        if (!deletingRule) return;
        try {
            const result = await $1a4c36336f303477$export$2a08cd7e8e594692(organizationId, deletingRule.id);
            if (result.resultType !== 'Ok') throw new Error('Unable to delete automation rule');
            setDeletingRule(null);
            await loadRules();
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.governance.automation.deleted'));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.automation.deleteError'));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$ManagerWrap, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$GovernanceIntro, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$IntroIcon, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: "automation",
                            size: 30
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                children: t('common:organization.governance.automation.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                                children: t('common:organization.governance.automation.description')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$GuidanceGrid, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$GuidanceCard, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: t('common:organization.governance.automation.guidance.block.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t('common:organization.governance.automation.guidance.block.description')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$GuidanceCard, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: t('common:organization.governance.automation.guidance.prompt.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t('common:organization.governance.automation.guidance.prompt.description')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$GuidanceCard, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: t('common:organization.governance.automation.guidance.scope.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t('common:organization.governance.automation.guidance.scope.description')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.governance.automation.rulesTitle'),
                variant: "small",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    $size: "small",
                    startIcon: "plus",
                    onClick: ()=>setEditingRule(null),
                    children: t('common:organization.governance.automation.create')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                label: "",
                placeholder: t('common:organization.governance.automation.searchPlaceholder'),
                value: search,
                onChange: (event)=>setSearch(event.target.value),
                onClear: ()=>setSearch('')
            }),
            isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {}) : filteredRules.length ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$RuleList, {
                children: filteredRules.map((rule)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$RuleCard, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$RuleHeading, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$RuleIdentity, {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44792dc96536365$export$2e2bcd8739ae039), {
                                                    label: t(`common:organization.governance.automation.type.${rule.ruleType.toLowerCase()}`),
                                                    color: rule.ruleType === 'Block' ? 'error' : 'primary',
                                                    size: "small"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                                                    children: rule.appOrDomainName || t('common:organization.governance.automation.promptOnly')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c44792dc96536365$export$2e2bcd8739ae039), {
                                            label: t(rule.applyToAllMembers ? 'common:organization.governance.automation.scope.organization' : 'common:organization.governance.automation.scope.members'),
                                            variant: "outlined",
                                            size: "small"
                                        })
                                    ]
                                }),
                                rule.rulePrompt && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$RulePrompt, {
                                    children: rule.rulePrompt
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$564cbe3426fc093a), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "text",
                                            $size: "small",
                                            startIcon: "edit",
                                            onClick: ()=>setEditingRule(rule),
                                            children: t('common:edit')
                                        }),
                                        !rule.applyToAllMembers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "text",
                                            $size: "small",
                                            startIcon: "user",
                                            onClick: ()=>setAssigningRule(rule),
                                            children: t('common:organization.governance.automation.assign')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "negative",
                                            $size: "small",
                                            startIcon: "cancel2",
                                            onClick: ()=>setDeletingRule(rule),
                                            children: t('common:delete')
                                        })
                                    ]
                                })
                            ]
                        })
                    }, rule.id))
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$EmptyState, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: "automation",
                        size: 32
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: t('common:organization.governance.automation.empty.title')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:organization.governance.automation.empty.description')
                    })
                ]
            }),
            editingRule !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$AutomationRuleDialog, {
                rule: editingRule,
                onClose: ()=>setEditingRule(undefined),
                onSave: saveRule
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: !!deletingRule,
                title: t('common:organization.governance.automation.delete.title'),
                description: t('common:organization.governance.automation.delete.description'),
                confirmButtonText: t('common:delete'),
                confirmIcon: "cancel2",
                onConfirm: deleteRule,
                onClose: ()=>setDeletingRule(null),
                onCancel: ()=>setDeletingRule(null)
            }),
            assigningRule && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$MemberAssignmentDialog, {
                organizationId: organizationId,
                rule: assigningRule,
                onClose: ()=>setAssigningRule(null)
            })
        ]
    });
}
function $e5a40d332c2f8520$var$AutomationRuleDialog({ rule: rule, onClose: onClose, onSave: onSave }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [values, setValues] = (0, $7fPBF.useState)(()=>$e5a40d332c2f8520$var$getRuleValues(rule));
    const [showValidation, setShowValidation] = (0, $7fPBF.useState)(false);
    const isValid = Boolean(values.appOrDomainName.trim() || values.rulePrompt.trim());
    const save = async ()=>{
        if (!isValid) {
            setShowValidation(true);
            return;
        }
        await onSave((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, values), {
            appOrDomainName: values.appOrDomainName.trim(),
            rulePrompt: values.rulePrompt.trim()
        }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        maxWidth: "sm",
        open: true,
        title: t(rule ? 'common:organization.governance.automation.edit' : 'common:organization.governance.automation.create'),
        description: t('common:organization.governance.automation.editorDescription'),
        confirmButtonText: t('common:save'),
        onConfirm: save,
        onClose: onClose,
        onCancel: onClose,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$DialogForm, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                            id: "automation-rule-type-label",
                            children: t('common:organization.governance.automation.type.label')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                            labelId: "automation-rule-type-label",
                            label: t('common:organization.governance.automation.type.label'),
                            value: values.ruleType,
                            onChange: (event)=>setValues((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                                        ruleType: event.target.value
                                    })),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: "Block",
                                    children: t('common:organization.governance.automation.type.block')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: "Allow",
                                    children: t('common:organization.governance.automation.type.allow')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    label: t('common:organization.governance.automation.appOrDomain.label'),
                    helperText: t('common:organization.governance.automation.appOrDomain.helper'),
                    value: values.appOrDomainName,
                    onChange: (event)=>setValues((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                                appOrDomainName: event.target.value
                            })),
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    label: t('common:organization.governance.automation.prompt.label'),
                    helperText: showValidation && !isValid ? t('common:organization.governance.automation.validation') : t('common:organization.governance.automation.prompt.helper'),
                    error: showValidation && !isValid,
                    value: values.rulePrompt,
                    onChange: (event)=>setValues((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                                rulePrompt: event.target.value
                            })),
                    multiline: true,
                    minRows: 4,
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$ScopeSwitch, {
                    control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                        checked: values.applyToAllMembers,
                        onChange: (event)=>setValues((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                                    applyToAllMembers: event.target.checked
                                }))
                    }),
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: t('common:organization.governance.automation.scope.organization')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t('common:organization.governance.automation.scope.organizationDescription')
                            })
                        ]
                    })
                }),
                !values.applyToAllMembers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$ScopeNotice, {
                    children: t('common:organization.governance.automation.scope.membersDescription')
                })
            ]
        })
    });
}
function $e5a40d332c2f8520$var$MemberAssignmentDialog({ organizationId: organizationId, rule: rule, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [members, setMembers] = (0, $7fPBF.useState)([]);
    const [selectedMember, setSelectedMember] = (0, $7fPBF.useState)(null);
    const [isApplied, setIsApplied] = (0, $7fPBF.useState)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const loadMembers = async ()=>{
            try {
                const result = await $1a4c36336f303477$export$9fa0549694b5b397(organizationId, {
                    take: 100,
                    skip: 0
                });
                if (result.resultType !== 'Ok' || !result.data) throw new Error('Unable to load organization members');
                setMembers(result.data);
            } catch (error) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.automation.assignment.loadError'));
            } finally{
                setIsLoading(false);
            }
        };
        loadMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    const selectMember = async (_, member)=>{
        setSelectedMember(member);
        setIsApplied(null);
        if (!member) return;
        try {
            const result = await $1a4c36336f303477$export$a6f9b5388d528cec(organizationId, member.id);
            if (result.resultType !== 'Ok' || !result.data) throw new Error('Unable to load member rules');
            setIsApplied(result.data.some((memberRule)=>memberRule.id === rule.id));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.automation.assignment.statusError'));
        }
    };
    const updateAssignment = async ()=>{
        if (!selectedMember || isApplied === null) return;
        setIsSaving(true);
        try {
            const result = isApplied ? await $1a4c36336f303477$export$ba7b32392a99780c(organizationId, selectedMember.id, rule.id) : await $1a4c36336f303477$export$b9df2887c5fea5c(organizationId, selectedMember.id, rule.id);
            if (result.resultType !== 'Ok') throw new Error('Unable to update rule assignment');
            setIsApplied(!isApplied);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t(isApplied ? 'common:organization.governance.automation.assignment.removed' : 'common:organization.governance.automation.assignment.applied'));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.automation.assignment.saveError'));
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        maxWidth: "sm",
        open: true,
        title: t('common:organization.governance.automation.assignment.title'),
        description: t('common:organization.governance.automation.assignment.description', {
            value: rule.appOrDomainName || t('common:organization.governance.automation.promptOnly')
        }),
        confirmButtonText: isApplied ? t('common:organization.governance.automation.assignment.remove') : t('common:organization.governance.automation.assignment.apply'),
        onConfirm: updateAssignment,
        onClose: onClose,
        onCancel: onClose,
        children: isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e5a40d332c2f8520$var$DialogForm, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbb161f60fb52eda$export$2e2bcd8739ae039), {
                    options: members,
                    value: selectedMember,
                    onChange: selectMember,
                    getOptionLabel: (member)=>{
                        var _member_user;
                        var _member_user_email;
                        return (_member_user_email = (_member_user = member.user) === null || _member_user === void 0 ? void 0 : _member_user.email) !== null && _member_user_email !== void 0 ? _member_user_email : '';
                    },
                    renderInput: (params)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, params), {
                            label: t('common:organization.governance.automation.assignment.memberLabel')
                        }))
                }),
                selectedMember && isApplied !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e5a40d332c2f8520$var$AssignmentStatus, {
                    $applied: isApplied,
                    children: t(isApplied ? 'common:organization.governance.automation.assignment.assigned' : 'common:organization.governance.automation.assignment.notAssigned')
                }),
                isSaving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t('common:loading')
                })
            ]
        })
    });
}
const $e5a40d332c2f8520$var$ManagerWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t || ($e5a40d332c2f8520$var$t = $e5a40d332c2f8520$var$_`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin-top: 1.5rem;
`));
const $e5a40d332c2f8520$var$GovernanceIntro = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t1 || ($e5a40d332c2f8520$var$t1 = $e5a40d332c2f8520$var$_`
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.25rem;
    border: 1px solid ${0};
    border-radius: 0.5rem;
    background: ${0};
`), (props)=>props.theme.color.border, (props)=>props.theme.color.accentCard);
const $e5a40d332c2f8520$var$IntroIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t2 || ($e5a40d332c2f8520$var$t2 = $e5a40d332c2f8520$var$_`
    color: ${0};
`), (props)=>props.theme.color.accent);
const $e5a40d332c2f8520$var$GuidanceGrid = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t3 || ($e5a40d332c2f8520$var$t3 = $e5a40d332c2f8520$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 0.75rem;
`));
const $e5a40d332c2f8520$var$GuidanceCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$a30053b04ba33ef5))($e5a40d332c2f8520$var$t4 || ($e5a40d332c2f8520$var$t4 = $e5a40d332c2f8520$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 1rem;
`));
const $e5a40d332c2f8520$var$RuleList = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t5 || ($e5a40d332c2f8520$var$t5 = $e5a40d332c2f8520$var$_`
    display: flex;
    flex-direction: column;
`));
const $e5a40d332c2f8520$var$RuleCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$a30053b04ba33ef5))($e5a40d332c2f8520$var$t6 || ($e5a40d332c2f8520$var$t6 = $e5a40d332c2f8520$var$_`
    &:not(:last-child) {
        margin-bottom: 0.75rem;
    }
`));
const $e5a40d332c2f8520$var$RuleHeading = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t7 || ($e5a40d332c2f8520$var$t7 = $e5a40d332c2f8520$var$_`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
`));
const $e5a40d332c2f8520$var$RuleIdentity = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t8 || ($e5a40d332c2f8520$var$t8 = $e5a40d332c2f8520$var$_`
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`));
const $e5a40d332c2f8520$var$RulePrompt = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($e5a40d332c2f8520$var$t9 || ($e5a40d332c2f8520$var$t9 = $e5a40d332c2f8520$var$_`
    white-space: pre-wrap;
`));
const $e5a40d332c2f8520$var$EmptyState = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t10 || ($e5a40d332c2f8520$var$t10 = $e5a40d332c2f8520$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 2.5rem 1rem;
    text-align: center;
    color: ${0};
    border: 1px dashed ${0};
    border-radius: 0.5rem;
`), (props)=>props.theme.color.text, (props)=>props.theme.color.border);
const $e5a40d332c2f8520$var$DialogForm = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e5a40d332c2f8520$var$t11 || ($e5a40d332c2f8520$var$t11 = $e5a40d332c2f8520$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
`));
const $e5a40d332c2f8520$var$ScopeSwitch = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039))($e5a40d332c2f8520$var$t12 || ($e5a40d332c2f8520$var$t12 = $e5a40d332c2f8520$var$_`
    align-items: flex-start;
    margin: 0;
`));
const $e5a40d332c2f8520$var$ScopeNotice = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($e5a40d332c2f8520$var$t13 || ($e5a40d332c2f8520$var$t13 = $e5a40d332c2f8520$var$_`
    padding: 0.75rem;
    border-left: 3px solid ${0};
    background: ${0};
`), (props)=>props.theme.color.accent, (props)=>props.theme.color.accentCard);
const $e5a40d332c2f8520$var$AssignmentStatus = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($e5a40d332c2f8520$var$t14 || ($e5a40d332c2f8520$var$t14 = $e5a40d332c2f8520$var$_`
    color: ${0};
`), ({ $applied: $applied, theme: theme })=>$applied ? theme.color.success : theme.color.text);














const $d227fca458ea4785$export$68befc518ea2400f = (member)=>{
    const { isAdmin: isAdmin, canViewMembers: canViewMembers, canInviteMembers: canInviteMembers, canChangeMemberPermissions: canChangeMemberPermissions, canRemoveMembers: canRemoveMembers, canCreateAuthClients: canCreateAuthClients, canViewAuthClients: canViewAuthClients, canManageBilling: canManageBilling, canManageChildOrganizations: canManageChildOrganizations, canViewAnalytics: canViewAnalytics, canAccessOrganizationProfiles: canAccessOrganizationProfiles, canEditOrganizationProfiles: canEditOrganizationProfiles, canManageGlobalAutomationRules: canManageGlobalAutomationRules } = member;
    return {
        isAdmin: isAdmin,
        canViewMembers: canViewMembers,
        canInviteMembers: canInviteMembers,
        canChangeMemberPermissions: canChangeMemberPermissions,
        canRemoveMembers: canRemoveMembers,
        canCreateAuthClients: canCreateAuthClients,
        canViewAuthClients: canViewAuthClients,
        canManageBilling: canManageBilling,
        canManageChildOrganizations: canManageChildOrganizations,
        canViewAnalytics: canViewAnalytics,
        canAccessOrganizationProfiles: canAccessOrganizationProfiles,
        canEditOrganizationProfiles: canEditOrganizationProfiles,
        canManageGlobalAutomationRules: canManageGlobalAutomationRules !== null && canManageGlobalAutomationRules !== void 0 ? canManageGlobalAutomationRules : false
    };
};





var $7fPBF = parcelRequire("7fPBF");

let $570b4391b76c7f06$var$_ = (t)=>t, $570b4391b76c7f06$var$t, $570b4391b76c7f06$var$t1, $570b4391b76c7f06$var$t2;
/** The four org-wide allow toggles, keyed by their OrganizationModel field. */ const $570b4391b76c7f06$var$ORG_ALLOW_FLAGS = [
    'allowPublicSkills',
    'allowMemberManagedSkills',
    'allowPublicMcpServers',
    'allowMemberManagedMcpServers'
];
/** The six per-member extension permissions, keyed by their model field. */ const $570b4391b76c7f06$var$MEMBER_EXTENSION_FLAGS = [
    'canShareSkillsWithOrganization',
    'canManageOrganizationSkills',
    'canUseExternalSkills',
    'canShareMcpServersWithOrganization',
    'canManageOrganizationMcpServers',
    'canUseExternalMcpServers'
];
function $570b4391b76c7f06$export$2e2bcd8739ae039({ organization: organization }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [savingFlag, setSavingFlag] = (0, $7fPBF.useState)(null);
    const setOrgFlag = async (flag, value)=>{
        setSavingFlag(flag);
        try {
            var _organization_customResourcesMarkdown, _organization_customBillingUrl;
            // Send the required fields plus the toggled flag; nullable governance flags on the API mean
            // omitted flags are left unchanged, so we only need to include the one we're changing.
            const result = await $1a4c36336f303477$export$3f4430ea1068bd7f(organization.id, {
                name: organization.name,
                description: organization.description,
                customResourcesMarkdown: (_organization_customResourcesMarkdown = organization.customResourcesMarkdown) !== null && _organization_customResourcesMarkdown !== void 0 ? _organization_customResourcesMarkdown : '',
                customBillingUrl: (_organization_customBillingUrl = organization.customBillingUrl) !== null && _organization_customBillingUrl !== void 0 ? _organization_customBillingUrl : '',
                [flag]: value
            });
            if (result.resultType !== 'Ok') throw new Error('Unable to update organization');
            await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadCurrentOrganizationDetails(organization.id);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.governance.extensions.permissions.saved'));
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.extensions.permissions.saveError'));
        } finally{
            setSavingFlag(null);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($570b4391b76c7f06$var$Wrap, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.governance.extensions.permissions.orgTitle'),
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: t('common:organization.governance.extensions.permissions.orgDescription')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($570b4391b76c7f06$var$ToggleCard, {
                children: $570b4391b76c7f06$var$ORG_ALLOW_FLAGS.map((flag)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($570b4391b76c7f06$var$ToggleRow, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                        children: t(`common:organization.governance.extensions.orgFlags.${flag}.title`)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: t(`common:organization.governance.extensions.orgFlags.${flag}.description`)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                                checked: organization[flag] !== false,
                                disabled: savingFlag === flag,
                                onChange: (event)=>setOrgFlag(flag, event.target.checked)
                            })
                        ]
                    }, flag))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($570b4391b76c7f06$var$MemberPermissions, {
                organizationId: organization.id
            })
        ]
    });
}
/** Pick a member and toggle their individual skill/connector share/manage/use-external permissions. */ function $570b4391b76c7f06$var$MemberPermissions({ organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [members, setMembers] = (0, $7fPBF.useState)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [selected, setSelected] = (0, $7fPBF.useState)(null);
    const [savingFlag, setSavingFlag] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        const loadMembers = async ()=>{
            setIsLoading(true);
            try {
                const result = await $1a4c36336f303477$export$9fa0549694b5b397(organizationId, {
                    take: 200,
                    skip: 0
                });
                if (result.resultType !== 'Ok' || !result.data) throw new Error('Unable to load members');
                setMembers(result.data);
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.extensions.members.loadError'));
            } finally{
                setIsLoading(false);
            }
        };
        loadMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    const setMemberFlag = async (flag, value)=>{
        if (!selected) return;
        setSavingFlag(flag);
        var _selected_canUseExternalSkills, _selected_canUseExternalMcpServers, _selected_canShareSkillsWithOrganization, _selected_canShareMcpServersWithOrganization, _selected_canManageOrganizationSkills, _selected_canManageOrganizationMcpServers;
        // Build a full request from the member's current role + extension perms so nothing is clobbered.
        const request = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d227fca458ea4785$export$68befc518ea2400f)(selected)), {
            canUseExternalSkills: (_selected_canUseExternalSkills = selected.canUseExternalSkills) !== null && _selected_canUseExternalSkills !== void 0 ? _selected_canUseExternalSkills : false,
            canUseExternalMcpServers: (_selected_canUseExternalMcpServers = selected.canUseExternalMcpServers) !== null && _selected_canUseExternalMcpServers !== void 0 ? _selected_canUseExternalMcpServers : false,
            canShareSkillsWithOrganization: (_selected_canShareSkillsWithOrganization = selected.canShareSkillsWithOrganization) !== null && _selected_canShareSkillsWithOrganization !== void 0 ? _selected_canShareSkillsWithOrganization : false,
            canShareMcpServersWithOrganization: (_selected_canShareMcpServersWithOrganization = selected.canShareMcpServersWithOrganization) !== null && _selected_canShareMcpServersWithOrganization !== void 0 ? _selected_canShareMcpServersWithOrganization : false,
            canManageOrganizationSkills: (_selected_canManageOrganizationSkills = selected.canManageOrganizationSkills) !== null && _selected_canManageOrganizationSkills !== void 0 ? _selected_canManageOrganizationSkills : false,
            canManageOrganizationMcpServers: (_selected_canManageOrganizationMcpServers = selected.canManageOrganizationMcpServers) !== null && _selected_canManageOrganizationMcpServers !== void 0 ? _selected_canManageOrganizationMcpServers : false,
            [flag]: value
        });
        try {
            const result = await $1a4c36336f303477$export$9e3347137373e17d(selected.id, request);
            if (result.resultType !== 'Ok' || !result.data) throw new Error('Unable to update member');
            setSelected(result.data);
            setMembers((prev)=>prev.map((m)=>m.id === result.data.id ? result.data : m));
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.governance.extensions.members.saved'));
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.extensions.members.saveError'));
        } finally{
            setSavingFlag(null);
        }
    };
    const sortedMembers = (0, $7fPBF.useMemo)(()=>[
            ...members
        ].sort((a, b)=>{
            var _a_user, _b_user;
            var _a_user_email, _b_user_email;
            return ((_a_user_email = (_a_user = a.user) === null || _a_user === void 0 ? void 0 : _a_user.email) !== null && _a_user_email !== void 0 ? _a_user_email : '').localeCompare((_b_user_email = (_b_user = b.user) === null || _b_user === void 0 ? void 0 : _b_user.email) !== null && _b_user_email !== void 0 ? _b_user_email : '');
        }), [
        members
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.governance.extensions.members.title'),
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: t('common:organization.governance.extensions.members.description')
            }),
            isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbb161f60fb52eda$export$2e2bcd8739ae039), {
                        options: sortedMembers,
                        value: selected,
                        onChange: (_, member)=>setSelected(member),
                        getOptionLabel: (member)=>{
                            var _member_user;
                            var _member_user_email;
                            return (_member_user_email = (_member_user = member.user) === null || _member_user === void 0 ? void 0 : _member_user.email) !== null && _member_user_email !== void 0 ? _member_user_email : member.userId;
                        },
                        isOptionEqualToValue: (a, b)=>a.id === b.id,
                        renderInput: (params)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, params), {
                                label: t('common:organization.governance.extensions.members.memberLabel')
                            }))
                    }),
                    selected && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($570b4391b76c7f06$var$ToggleCard, {
                        children: [
                            selected.isAdmin && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t('common:organization.governance.extensions.members.adminNote')
                            }),
                            $570b4391b76c7f06$var$MEMBER_EXTENSION_FLAGS.map((flag)=>{
                                var _selected_flag;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($570b4391b76c7f06$var$ToggleRow, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                                    children: t(`common:organization.governance.extensions.memberFlags.${flag}.title`)
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                                    children: t(`common:organization.governance.extensions.memberFlags.${flag}.description`)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                                            checked: selected.isAdmin || ((_selected_flag = selected[flag]) !== null && _selected_flag !== void 0 ? _selected_flag : false),
                                            disabled: selected.isAdmin || savingFlag === flag,
                                            onChange: (event)=>setMemberFlag(flag, event.target.checked)
                                        })
                                    ]
                                }, flag);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $570b4391b76c7f06$var$Wrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($570b4391b76c7f06$var$t || ($570b4391b76c7f06$var$t = $570b4391b76c7f06$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1.5rem;
`));
const $570b4391b76c7f06$var$ToggleCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$a30053b04ba33ef5))($570b4391b76c7f06$var$t1 || ($570b4391b76c7f06$var$t1 = $570b4391b76c7f06$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
`));
const $570b4391b76c7f06$var$ToggleRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($570b4391b76c7f06$var$t2 || ($570b4391b76c7f06$var$t2 = $570b4391b76c7f06$var$_`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;

    & > div:first-of-type {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
    }
`));



























var $7fPBF = parcelRequire("7fPBF");










let $dd1906991ea04169$var$_ = (t)=>t, $dd1906991ea04169$var$t, $dd1906991ea04169$var$t1, $dd1906991ea04169$var$t2, $dd1906991ea04169$var$t3, $dd1906991ea04169$var$t4;
const $dd1906991ea04169$export$d23a46b15e7317a5 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($dd1906991ea04169$var$t || ($dd1906991ea04169$var$t = $dd1906991ea04169$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    border-radius: 0.25rem;
    /* The diminished variants are unfilled, so padding would only push them out of line with their row. */
    padding: ${0};
    color: ${0};
    background-color: ${0};
    /* The one variant that reads as a link rather than a chip — the underline is what marks it clickable. */
    text-decoration: ${0};
`), (p)=>p.$variant.startsWith('diminished') ? '0' : '0.1rem 0.4rem', (p)=>(0, $c5e3795911646adc$export$4b882a3bf08f9554)(p.$variant, p.theme) || p.theme.color.text, (p)=>(0, $c5e3795911646adc$export$c90419c99840f046)(p.$variant, p.theme) || 'transparent', (p)=>p.$variant.startsWith('underline') ? 'underline' : 'none');
const $dd1906991ea04169$export$34028d8930504f65 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$e4355dfd845d8ca))($dd1906991ea04169$var$t1 || ($dd1906991ea04169$var$t1 = $dd1906991ea04169$var$_`
    color: inherit;
`));
const $dd1906991ea04169$export$243af89aa098f622 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$e4355dfd845d8ca))($dd1906991ea04169$var$t2 || ($dd1906991ea04169$var$t2 = $dd1906991ea04169$var$_`
    font-weight: 700;
    color: inherit;
`));
const $dd1906991ea04169$export$e51ff66f34543d30 = (0, $8de346382d86c747$export$2e2bcd8739ae039)($dd1906991ea04169$export$d23a46b15e7317a5)($dd1906991ea04169$var$t3 || ($dd1906991ea04169$var$t3 = $dd1906991ea04169$var$_`
    padding: 0.1rem 0.4rem;
    cursor: pointer;
    user-select: none;
    border: none;
    font: inherit;
    text-align: left;
    border-radius: ${0};
    min-height: ${0};
    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
        background-color: ${0};
        color: ${0};
    }

    &:disabled {
        cursor: default;
        opacity: 0.45;
    }
`), (p)=>p.$borderRadius ? (0, $8951886a6b49e92a$export$7a57f79000377ca2)[p.$borderRadius] : '0.25rem', (p)=>p.theme.scaleSize >= 20 ? '44px' : '24px', (p)=>(0, $c5e3795911646adc$export$98bac143fbc272fc)(p.$variant, p.theme), (p)=>(0, $c5e3795911646adc$export$476ad49a155045fd)(p.$variant, p.theme));
const $dd1906991ea04169$export$ef1712973086b4ba = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($dd1906991ea04169$var$t4 || ($dd1906991ea04169$var$t4 = $dd1906991ea04169$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
`));


function $8ecd8fc09c60c02c$export$2e2bcd8739ae039({ title: title, value: value, hideLabel: hideLabel, tooltip: tooltip, icon: icon, iconSize: iconSize, variant: variant = 'diminished' }) {
    const tag = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $dd1906991ea04169$export$d23a46b15e7317a5), {
        $variant: variant,
        title: hideLabel && !tooltip ? title : undefined,
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: icon,
                weight: "bold",
                size: iconSize || 14
            }),
            hideLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: title
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$34028d8930504f65), {
                children: title
            }),
            value !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$243af89aa098f622), {
                children: value
            })
        ]
    });
    if (!tooltip) return tag;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
        title: tooltip,
        arrow: true,
        children: tag
    });
}



let $8684a19e32913368$var$_ = (t)=>t, $8684a19e32913368$var$t, $8684a19e32913368$var$t1, $8684a19e32913368$var$t2, $8684a19e32913368$var$t3, $8684a19e32913368$var$t4, $8684a19e32913368$var$t5, $8684a19e32913368$var$t6;
function $8684a19e32913368$export$2e2bcd8739ae039(_param) {
    var { title: title, titleAdornment: titleAdornment, subtitle: subtitle, description: description, image: image, headerActions: headerActions, headerActionsLabel: headerActionsLabel, onCancel: onCancel, cancelButtonText: cancelButtonText, onConfirm: onConfirm, confirmDisabled: confirmDisabled, confirmStartComponent: confirmStartComponent, onClose: onClose, error: error, confirmButtonText: confirmButtonText, confirmIcon: confirmIcon, cancelIcon: cancelIcon, children: children, scroll: scroll = 'paper', dialogTag: dialogTag } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "titleAdornment",
        "subtitle",
        "description",
        "image",
        "headerActions",
        "headerActionsLabel",
        "onCancel",
        "cancelButtonText",
        "onConfirm",
        "confirmDisabled",
        "confirmStartComponent",
        "onClose",
        "error",
        "confirmButtonText",
        "confirmIcon",
        "cancelIcon",
        "children",
        "scroll",
        "dialogTag"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const id = (0, $7fPBF.useId)();
    const subtitleId = `dialog-subtitle-${id}`;
    const descriptionId = `dialog-description-${id}`;
    const cancelText = cancelButtonText !== null && cancelButtonText !== void 0 ? cancelButtonText : t('cancel');
    const confirmText = confirmButtonText !== null && confirmButtonText !== void 0 ? confirmButtonText : t('save');
    // Both lines describe the dialog, so both are named — the subtitle first, the way they read on screen.
    const describedBy = [
        subtitle && subtitleId,
        description && descriptionId
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$1a4605a7458e0ef), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        scroll: scroll,
        onClose: onClose,
        "aria-labelledby": `dialog-title-${id}`,
        "aria-describedby": describedBy || undefined
    }, restProps), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: [
                    image && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8684a19e32913368$var$HeaderMedia, {
                        children: image
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8684a19e32913368$var$HeaderText, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8684a19e32913368$var$TitleRow, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8684a19e32913368$var$HeaderTitle, {
                                        id: `dialog-title-${id}`,
                                        children: [
                                            dialogTag && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$e1b02e289332d3a3), {
                                                as: "span",
                                                children: dialogTag
                                            }),
                                            title
                                        ]
                                    }),
                                    titleAdornment
                                ]
                            }),
                            subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8684a19e32913368$var$HeaderSubtitle, {
                                id: subtitleId,
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8684a19e32913368$var$HeaderActions, {
                        role: headerActionsLabel ? 'group' : undefined,
                        "aria-label": headerActionsLabel,
                        children: [
                            headerActions,
                            onClose && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7922ab368d0f289$export$b27464191770945a), {
                                label: t('close'),
                                tooltip: t('close'),
                                tooltipPlacement: "bottom",
                                icon: "closeX",
                                variant: "text",
                                onClick: onClose
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: [
                    description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8684a19e32913368$var$Description, {
                        id: descriptionId,
                        children: description
                    }),
                    children
                ]
            }),
            (onConfirm || onCancel) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$b54ac9d7963ef6f6), {
                children: [
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ecd8fc09c60c02c$export$2e2bcd8739ae039), {
                        variant: "error",
                        title: error
                    }),
                    cancelText && onCancel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "simple",
                        startIcon: cancelIcon,
                        onClick: onCancel,
                        children: cancelText
                    }),
                    onConfirm && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        $color: "secondary",
                        startIcon: confirmStartComponent ? undefined : confirmIcon,
                        startComponent: confirmStartComponent,
                        disabled: confirmDisabled,
                        onClick: onConfirm,
                        children: confirmText
                    })
                ]
            })
        ]
    }));
}
/** A fixed square so a tall or wide image can't push the title out of line. */ const $8684a19e32913368$var$HeaderMedia = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($8684a19e32913368$var$t || ($8684a19e32913368$var$t = $8684a19e32913368$var$_`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 0.5rem;
    overflow: hidden;
    color: ${0};
    background: ${0};

    img,
    svg {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`), (props)=>props.theme.color.accent, (props)=>props.theme.color.card);
const $8684a19e32913368$var$HeaderText = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($8684a19e32913368$var$t1 || ($8684a19e32913368$var$t1 = $8684a19e32913368$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
    flex: 1 1 auto;
`));
/** Keeps the type tag on the title's line, wrapping beneath it only when the name runs long. */ const $8684a19e32913368$var$TitleRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($8684a19e32913368$var$t2 || ($8684a19e32913368$var$t2 = $8684a19e32913368$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
`));
/** DisplayDialogTitle centers itself for the single-line header; here it heads a column instead. */ const $8684a19e32913368$var$HeaderTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $082accbd174d656b$export$a821680a90fed6))($8684a19e32913368$var$t3 || ($8684a19e32913368$var$t3 = $8684a19e32913368$var$_`
    align-self: flex-start;
`));
const $8684a19e32913368$var$HeaderSubtitle = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($8684a19e32913368$var$t4 || ($8684a19e32913368$var$t4 = $8684a19e32913368$var$_`
    color: ${0};
    ${0}
`), (props)=>props.theme.color.textBody, (0, $b091aef3a32d2bd8$export$3e193b19d995235f));
/** Kept on one line beside the close button, so the actions read as a set rather than as stray glyphs. */ const $8684a19e32913368$var$HeaderActions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($8684a19e32913368$var$t5 || ($8684a19e32913368$var$t5 = $8684a19e32913368$var$_`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
`));
const $8684a19e32913368$var$Description = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($8684a19e32913368$var$t6 || ($8684a19e32913368$var$t6 = $8684a19e32913368$var$_`
    white-space: pre-wrap;
    color: ${0};
    font-weight: 300;
`), (props)=>props.theme.color.textBody);

















function $63e32f8e29f3f937$export$2e2bcd8739ae039(props) {
    if (props.href !== undefined) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyLinkButton, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
    if (props.to !== undefined) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyNavButton, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyPressButton, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
}
function $63e32f8e29f3f937$var$TinyPressButton(_param) {
    var { title: title, value: value, hideLabel: hideLabel, tooltip: tooltip, tooltipPlacement: tooltipPlacement, icon: icon, endIcon: endIcon, iconSize: iconSize, variant: variant = 'diminished', borderRadius: borderRadius = 'sm' } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "value",
        "hideLabel",
        "tooltip",
        "tooltipPlacement",
        "icon",
        "endIcon",
        "iconSize",
        "variant",
        "borderRadius"
    ]);
    const hoverTitle = hideLabel && !tooltip ? title : undefined;
    const tag = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyPressRow, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: "button",
        $variant: variant,
        $borderRadius: borderRadius,
        title: hoverTitle
    }, restProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyButtonContent, {
            title: title,
            value: value,
            hideLabel: hideLabel,
            icon: icon,
            endIcon: endIcon,
            iconSize: iconSize
        })
    }));
    return $63e32f8e29f3f937$var$withTooltip(tag, tooltip, tooltipPlacement);
}
function $63e32f8e29f3f937$var$TinyLinkButton(_param) {
    var { title: title, value: value, hideLabel: hideLabel, tooltip: tooltip, tooltipPlacement: tooltipPlacement, icon: icon, iconSize: iconSize, variant: variant = 'diminished', borderRadius: borderRadius = 'sm', href: href, endIcon: endIcon } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "value",
        "hideLabel",
        "tooltip",
        "tooltipPlacement",
        "icon",
        "iconSize",
        "variant",
        "borderRadius",
        "href",
        "endIcon"
    ]);
    const hoverTitle = hideLabel && !tooltip ? title : undefined;
    const tag = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyLinkRow, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        href: href,
        $variant: variant,
        $borderRadius: borderRadius,
        title: hoverTitle
    }, restProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyButtonContent, {
            title: title,
            value: value,
            hideLabel: hideLabel,
            icon: icon,
            endIcon: endIcon,
            iconSize: iconSize
        })
    }));
    return $63e32f8e29f3f937$var$withTooltip(tag, tooltip, tooltipPlacement);
}
function $63e32f8e29f3f937$var$TinyNavButton(_param) {
    var { title: title, value: value, hideLabel: hideLabel, tooltip: tooltip, tooltipPlacement: tooltipPlacement, icon: icon, iconSize: iconSize, endIcon: endIcon, variant: variant = 'diminished', borderRadius: borderRadius = 'sm', to: to } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "title",
        "value",
        "hideLabel",
        "tooltip",
        "tooltipPlacement",
        "icon",
        "iconSize",
        "endIcon",
        "variant",
        "borderRadius",
        "to"
    ]);
    const hoverTitle = hideLabel && !tooltip ? title : undefined;
    const tag = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyNavRow, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        to: to,
        $variant: variant,
        $borderRadius: borderRadius,
        title: hoverTitle
    }, restProps), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($63e32f8e29f3f937$var$TinyButtonContent, {
            title: title,
            value: value,
            hideLabel: hideLabel,
            icon: icon,
            endIcon: endIcon,
            iconSize: iconSize
        })
    }));
    return $63e32f8e29f3f937$var$withTooltip(tag, tooltip, tooltipPlacement);
}
function $63e32f8e29f3f937$var$TinyButtonContent({ title: title, value: value, hideLabel: hideLabel, icon: icon, iconSize: iconSize, endIcon: endIcon }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                weight: "bold",
                name: icon,
                size: iconSize || 14
            }),
            hideLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: title
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$34028d8930504f65), {
                children: title
            }),
            value !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$243af89aa098f622), {
                children: value
            }),
            endIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                weight: "bold",
                name: endIcon,
                size: iconSize || 14
            })
        ]
    });
}
function $63e32f8e29f3f937$var$withTooltip(tag, tooltip, tooltipPlacement) {
    if (!tooltip) return tag;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
        title: tooltip,
        placement: tooltipPlacement,
        arrow: true,
        children: tag
    });
}
const $63e32f8e29f3f937$var$TinyPressRow = (0, $dd1906991ea04169$export$e51ff66f34543d30).withComponent('button');
const $63e32f8e29f3f937$var$TinyLinkRow = (0, $dd1906991ea04169$export$e51ff66f34543d30).withComponent('a');
const $63e32f8e29f3f937$var$TinyNavRow = (0, $dd1906991ea04169$export$e51ff66f34543d30).withComponent((0, $f232cebbf1b70e96$export$b0d92dbee9b5b60d));








function $a8f303ae5b091ff2$export$2e2bcd8739ae039({ title: title, value: value, hideLabel: hideLabel, tooltip: tooltip, icon: icon, iconSize: iconSize, variant: variant = 'diminished' }) {
    const tag = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $dd1906991ea04169$export$d23a46b15e7317a5), {
        $variant: variant,
        title: hideLabel && !tooltip ? title : undefined,
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                weight: "bold",
                name: icon,
                size: iconSize || 14
            }),
            value !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$243af89aa098f622), {
                children: value
            }),
            hideLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: title
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$34028d8930504f65), {
                children: title
            })
        ]
    });
    if (!tooltip) return tag;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
        title: tooltip,
        arrow: true,
        children: tag
    });
}





let $3b6a3cbab36cb485$var$_ = (t)=>t, $3b6a3cbab36cb485$var$t, $3b6a3cbab36cb485$var$t1, $3b6a3cbab36cb485$var$t2, $3b6a3cbab36cb485$var$t3, $3b6a3cbab36cb485$var$t4, $3b6a3cbab36cb485$var$t5, $3b6a3cbab36cb485$var$t6, $3b6a3cbab36cb485$var$t7, $3b6a3cbab36cb485$var$t8, $3b6a3cbab36cb485$var$t9, $3b6a3cbab36cb485$var$t10, $3b6a3cbab36cb485$var$t11, $3b6a3cbab36cb485$var$t12, $3b6a3cbab36cb485$var$t13;
const $3b6a3cbab36cb485$export$92e06d6b76f1142e = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t || ($3b6a3cbab36cb485$var$t = $3b6a3cbab36cb485$var$_`
    display: flex;
    flex-direction: column;
    border: 1px solid ${0};
    border-radius: 0.75rem;
    overflow: hidden;
    background: ${0};
`), (props)=>props.theme.color.border, (props)=>props.theme.color.background);
/**
 * The rule between two rows: the container's own border colour at reduced alpha, so a divider inside the
 * card reads lighter than the card's edge. One value because a hand-written alpha suffix is easy to mistype
 * and impossible to spot once it has drifted between surfaces.
 */ const $3b6a3cbab36cb485$var$rowDividerBorder = (theme)=>`1px solid ${theme.color.border + '60'}`;
const $3b6a3cbab36cb485$export$527520a6d6040263 = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($3b6a3cbab36cb485$var$t1 || ($3b6a3cbab36cb485$var$t1 = $3b6a3cbab36cb485$var$_`
    & + & {
        border-top: ${0};
    }
`), $3b6a3cbab36cb485$var$rowDividerBorder(theme));
const $3b6a3cbab36cb485$export$3d4d30e5fa0588b1 = (theme)=>(0, $84f3fdd51733d70b$export$dbf350e5966cf602)($3b6a3cbab36cb485$var$t2 || ($3b6a3cbab36cb485$var$t2 = $3b6a3cbab36cb485$var$_`
    &:not(:first-of-type) {
        border-top: ${0};
    }
`), $3b6a3cbab36cb485$var$rowDividerBorder(theme));
const $3b6a3cbab36cb485$export$6a00d6693df2f023 = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($3b6a3cbab36cb485$var$t3 || ($3b6a3cbab36cb485$var$t3 = $3b6a3cbab36cb485$var$_`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`));
const $3b6a3cbab36cb485$export$f27dc7d6a74620e = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t4 || ($3b6a3cbab36cb485$var$t4 = $3b6a3cbab36cb485$var$_`
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.5rem 0.875rem;
`));
const $3b6a3cbab36cb485$export$e0dcc087511e163f = (0, $8de346382d86c747$export$2e2bcd8739ae039)($3b6a3cbab36cb485$export$f27dc7d6a74620e)($3b6a3cbab36cb485$var$t5 || ($3b6a3cbab36cb485$var$t5 = $3b6a3cbab36cb485$var$_`
    align-items: flex-start;
    padding: 0.625rem 0.875rem;
    transition: background 0.15s ease;

    &:hover {
        background: ${0};
    }
`), (props)=>props.theme.color.cardHover);
const $3b6a3cbab36cb485$export$d013cfb3f99a2fac = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $782ff1a97e868b05$export$2e2bcd8739ae039))($3b6a3cbab36cb485$var$t6 || ($3b6a3cbab36cb485$var$t6 = $3b6a3cbab36cb485$var$_`
    flex: 0 0 auto;
    padding: 0;
`));
const $3b6a3cbab36cb485$export$2c71fd7f79e02880 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t7 || ($3b6a3cbab36cb485$var$t7 = $3b6a3cbab36cb485$var$_`
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    flex: 1;
    min-width: 0;
    cursor: pointer;
`));
const $3b6a3cbab36cb485$export$7b5f2021d5a86d4a = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($3b6a3cbab36cb485$var$t8 || ($3b6a3cbab36cb485$var$t8 = $3b6a3cbab36cb485$var$_`
    display: inline-flex;
    flex: 0 0 auto;
    padding-top: 0.0625rem;
`));
const $3b6a3cbab36cb485$export$b273293a3851506d = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t9 || ($3b6a3cbab36cb485$var$t9 = $3b6a3cbab36cb485$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    min-width: 0;
    flex: 1;
`));
const $3b6a3cbab36cb485$export$4946964d45ae6053 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t10 || ($3b6a3cbab36cb485$var$t10 = $3b6a3cbab36cb485$var$_`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 0;
`));
const $3b6a3cbab36cb485$export$67aa7368b6d201e0 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($3b6a3cbab36cb485$var$t11 || ($3b6a3cbab36cb485$var$t11 = $3b6a3cbab36cb485$var$_`
    min-width: 0;
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${0};
    ${0}
`), (props)=>props.theme.color.text, $3b6a3cbab36cb485$export$6a00d6693df2f023);
const $3b6a3cbab36cb485$export$cdf6b77c5382cf04 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t12 || ($3b6a3cbab36cb485$var$t12 = $3b6a3cbab36cb485$var$_`
    display: flex;
    align-items: center;
    gap: 0.25rem 0.75rem;
    flex-wrap: wrap;
    min-width: 0;
`));
const $3b6a3cbab36cb485$export$523acc1bb0ce2e43 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($3b6a3cbab36cb485$var$t13 || ($3b6a3cbab36cb485$var$t13 = $3b6a3cbab36cb485$var$_`
    display: flex;
    align-items: center;
    gap: 0.125rem;
    flex-shrink: 0;
`));


let $4371ce2bad68da1d$var$_ = (t)=>t, $4371ce2bad68da1d$var$t, $4371ce2bad68da1d$var$t1, $4371ce2bad68da1d$var$t2, $4371ce2bad68da1d$var$t3, $4371ce2bad68da1d$var$t4, $4371ce2bad68da1d$var$t5;
function $4371ce2bad68da1d$export$2e2bcd8739ae039({ items: items, emptyText: emptyText, selectedIds: selectedIds, onSelectionChange: onSelectionChange, addLabel: addLabel, onAdd: onAdd, addDisabled: addDisabled, monospaceLabels: monospaceLabels }) {
    const selectable = !!selectedIds && !!onSelectionChange;
    const showAddRow = !!addLabel && !!onAdd;
    const toggle = (id)=>{
        if (!selectedIds || !onSelectionChange) return;
        onSelectionChange(selectedIds.includes(id) ? selectedIds.filter((s)=>s !== id) : [
            ...selectedIds,
            id
        ]);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3b6a3cbab36cb485$export$92e06d6b76f1142e), {
        children: [
            items.length === 0 && emptyText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4371ce2bad68da1d$var$EmptyRow, {
                children: emptyText
            }),
            items.map((item)=>{
                var _item_actions;
                var _item_identifierVariant;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4371ce2bad68da1d$var$ItemRow, {
                    title: item.title,
                    children: [
                        selectable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b6a3cbab36cb485$export$d013cfb3f99a2fac), {
                            size: "small",
                            checked: selectedIds.includes(item.id),
                            disabled: item.disabled,
                            slotProps: {
                                input: {
                                    'aria-label': item.label
                                }
                            },
                            onChange: ()=>toggle(item.id)
                        }),
                        item.icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4371ce2bad68da1d$var$RowIcon, {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: item.icon,
                                size: 16
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4371ce2bad68da1d$var$LabelRow, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4371ce2bad68da1d$var$RowLabel, {
                                    $mono: monospaceLabels,
                                    children: item.label
                                }),
                                item.prefixTag
                            ]
                        }),
                        item.identifier && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8f303ae5b091ff2$export$2e2bcd8739ae039), {
                            title: item.identifier,
                            variant: (_item_identifierVariant = item.identifierVariant) !== null && _item_identifierVariant !== void 0 ? _item_identifierVariant : 'diminished'
                        }),
                        (_item_actions = item.actions) === null || _item_actions === void 0 ? void 0 : _item_actions.map((action)=>action.showLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63e32f8e29f3f937$export$2e2bcd8739ae039), {
                                icon: action.icon,
                                title: action.label,
                                tooltip: action.showTooltip ? action.label : undefined,
                                variant: action.variant,
                                disabled: action.disabled || item.disabled,
                                onClick: action.onClick
                            }, action.label) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7922ab368d0f289$export$b27464191770945a), {
                                icon: action.icon,
                                label: action.label,
                                tooltip: action.showTooltip ? action.label : undefined,
                                variant: action.variant,
                                disabled: action.disabled || item.disabled,
                                onClick: action.onClick
                            }, action.label))
                    ]
                }, item.id);
            }),
            showAddRow && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4371ce2bad68da1d$var$AddRow, {
                type: "button",
                disabled: addDisabled,
                onClick: onAdd,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: "plus",
                        size: 16,
                        weight: "bold"
                    }),
                    addLabel
                ]
            })
        ]
    });
}
const $4371ce2bad68da1d$var$ItemRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3b6a3cbab36cb485$export$f27dc7d6a74620e))($4371ce2bad68da1d$var$t || ($4371ce2bad68da1d$var$t = $4371ce2bad68da1d$var$_`
    ${0}
`), (props)=>(0, $3b6a3cbab36cb485$export$527520a6d6040263)(props.theme));
// Not the shared `RowIcon`, which nudges itself down for a top-aligned multi-line row: these rows are
// single-line and vertically centred, and want the icon muted like the rest of the row's metadata.
const $4371ce2bad68da1d$var$RowIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($4371ce2bad68da1d$var$t1 || ($4371ce2bad68da1d$var$t1 = $4371ce2bad68da1d$var$_`
    display: inline-flex;
    flex: 0 0 auto;
    color: ${0};
`), (props)=>props.theme.color.textBody);
const $4371ce2bad68da1d$var$RowLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($4371ce2bad68da1d$var$t2 || ($4371ce2bad68da1d$var$t2 = $4371ce2bad68da1d$var$_`
    flex: 1;
    min-width: 0;
    font-size: 0.8125rem;
    color: ${0};
    font-family: ${0};
    ${0}
`), (props)=>props.theme.color.text, (props)=>props.$mono ? `'Courier New', Courier, monospace` : 'inherit', (0, $3b6a3cbab36cb485$export$6a00d6693df2f023));
const $4371ce2bad68da1d$var$EmptyRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6))($4371ce2bad68da1d$var$t3 || ($4371ce2bad68da1d$var$t3 = $4371ce2bad68da1d$var$_`
    padding: 0.75rem 0.875rem;
    color: ${0};
    font-style: italic;
`), (props)=>props.theme.color.textBody);
const $4371ce2bad68da1d$var$AddRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($4371ce2bad68da1d$var$t4 || ($4371ce2bad68da1d$var$t4 = $4371ce2bad68da1d$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.625rem 0.875rem;
    border: none;
    border-top: 1px dashed ${0};
    background: transparent;
    font-family: inherit;
    font-size: 0.8125rem;
    font-weight: 500;
    text-align: left;
    color: ${0};
    cursor: pointer;

    &:hover:not(:disabled) {
        background: ${0};
    }

    ${0}

    &:disabled {
        cursor: default;
        opacity: 0.45;
    }
`), (props)=>props.theme.color.border, (props)=>props.theme.color.link, (props)=>props.theme.color.cardHover, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));
const $4371ce2bad68da1d$var$LabelRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4371ce2bad68da1d$var$t5 || ($4371ce2bad68da1d$var$t5 = $4371ce2bad68da1d$var$_`
    display: flex;
    flex-grow: 1;
    gap: 0.25rem;
    flex-direction: column;
`));






parcelRequire("7fPBF");


let $b64f84dcf6c6afeb$var$_ = (t)=>t, $b64f84dcf6c6afeb$var$t, $b64f84dcf6c6afeb$var$t1, $b64f84dcf6c6afeb$var$t2, $b64f84dcf6c6afeb$var$t3, $b64f84dcf6c6afeb$var$t4, $b64f84dcf6c6afeb$var$t5;
function $b64f84dcf6c6afeb$export$2e2bcd8739ae039({ title: title, description: description, children: children, prefixElement: prefixElement, icon: icon, rail: rail, as: as, size: size = 'medium' }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b64f84dcf6c6afeb$var$RowWrapper, {
        $rail: rail,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b64f84dcf6c6afeb$var$TextHeadingWrapper, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b64f84dcf6c6afeb$var$Column, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b64f84dcf6c6afeb$var$Row, {
                            children: [
                                prefixElement,
                                icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: icon,
                                    size: 16
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b64f84dcf6c6afeb$var$Title, {
                                    as: as !== null && as !== void 0 ? as : 'h3',
                                    $small: size === 'small',
                                    children: title
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            children: description
                        })
                    ]
                })
            }),
            children
        ]
    });
}
/** The small size reads as an eyebrow: smaller, uppercase, and tracked out so it still holds its own. */ const $b64f84dcf6c6afeb$var$Title = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))($b64f84dcf6c6afeb$var$t1 || ($b64f84dcf6c6afeb$var$t1 = $b64f84dcf6c6afeb$var$_`
    ${0}
`), (props)=>props.$small && (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($b64f84dcf6c6afeb$var$t || ($b64f84dcf6c6afeb$var$t = $b64f84dcf6c6afeb$var$_`
            ${0}
            text-transform: uppercase;
            letter-spacing: 0.04em;
            font-weight: 700;
        `), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944)));
const $b64f84dcf6c6afeb$var$RowWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b64f84dcf6c6afeb$var$t2 || ($b64f84dcf6c6afeb$var$t2 = $b64f84dcf6c6afeb$var$_`
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 1rem 0 0.25rem 0;
    ${0}
`), (props)=>props.$rail && `
        border-bottom: 1px solid ${props.theme.color.cardHover};
    `);
const $b64f84dcf6c6afeb$var$Column = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b64f84dcf6c6afeb$var$t3 || ($b64f84dcf6c6afeb$var$t3 = $b64f84dcf6c6afeb$var$_`
    display: flex;
    flex-direction: column;
`));
const $b64f84dcf6c6afeb$var$TextHeadingWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b64f84dcf6c6afeb$var$t4 || ($b64f84dcf6c6afeb$var$t4 = $b64f84dcf6c6afeb$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
`));
const $b64f84dcf6c6afeb$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b64f84dcf6c6afeb$var$t5 || ($b64f84dcf6c6afeb$var$t5 = $b64f84dcf6c6afeb$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
`));


function $ac99b0e2fadd2449$export$95e534ed1053b920(skill) {
    return !skill.enabled ? 'off' : skill.activation;
}
function $ac99b0e2fadd2449$export$76a4575c6f42158b(skillId, mode) {
    return mode === 'off' ? {
        id: skillId,
        enabled: false
    } : {
        id: skillId,
        enabled: true,
        activation: mode
    };
}
function $ac99b0e2fadd2449$export$1d45664231d692f4(t) {
    return [
        {
            value: 'off',
            label: t('skills.mode.off'),
            description: t('skills.mode.offTooltip')
        },
        {
            value: 'auto',
            label: t('skills.activation.autoShort'),
            description: t('skills.activation.autoDescription')
        },
        {
            value: 'manual',
            label: t('skills.activation.manualShort'),
            description: t('skills.activation.manualDescription')
        }
    ];
}
function $ac99b0e2fadd2449$export$5a0cd9ede3eaec0f(mode) {
    if (mode === 'auto') return 'success';
    if (mode === 'manual') return 'accent';
    return 'diminished';
}


/**
 * AI Skills — user-authored, reusable capability packs that teach the on-device AI Workflows agent
 * how to do a domain task well. A skill is a directory containing a `SKILL.md` (YAML frontmatter +
 * markdown instructions) and optional `scripts/`, `references/`, and `assets/` subfolders, per the
 * Agent Skills specification (https://agentskills.io/specification) that LangChain deepagents parses.
 *
 * These models live in `shared/` so both the desktop renderer (Extensions manager, composer picker)
 * and the desktop worker/agent can use them. Intentionally free of any runtime dependency on
 * `deepagents` — the limit constants below mirror the spec so shared/web/admin bundles stay light.
 */ /** Where a skill came from. Only `user`/`imported` are producible in v1; the rest are future-proofing. */ const $83bad78370366bbe$export$fc097f65acdbbf35 = 'manual';
const $83bad78370366bbe$export$c56c7504d561f6c6 = 64;
const $83bad78370366bbe$export$51627feacfc0fcb0 = 1024;
const $83bad78370366bbe$export$1b435da42db50750 = 10485760;



function $4b33d1984f0c4c25$export$90544e016b732245(name) {
    const value = (name !== null && name !== void 0 ? name : '').trim();
    if (!value) return {
        valid: false,
        error: 'A name is required.'
    };
    if (value.length > (0, $83bad78370366bbe$export$c56c7504d561f6c6)) return {
        valid: false,
        error: `Name must be ${0, $83bad78370366bbe$export$c56c7504d561f6c6} characters or fewer.`
    };
    // Unicode-lowercase alphanumeric + hyphen. Use the case-insensitive-free check: reject any uppercase
    // A–Z and any character that isn't a letter, digit, or hyphen.
    if (/[A-Z]/.test(value)) return {
        valid: false,
        error: 'Use lowercase letters only.'
    };
    if (!RegExp("^[\\p{Ll}\\p{Nd}-]+$", "u").test(value)) return {
        valid: false,
        error: 'Use lowercase letters, numbers, and hyphens only.'
    };
    if (value.startsWith('-') || value.endsWith('-')) return {
        valid: false,
        error: 'Name cannot start or end with a hyphen.'
    };
    if (value.includes('--')) return {
        valid: false,
        error: 'Name cannot contain consecutive hyphens.'
    };
    return {
        valid: true
    };
}
function $4b33d1984f0c4c25$export$c46ec21c6dcc4443(description) {
    const value = (description !== null && description !== void 0 ? description : '').trim();
    if (!value) return {
        valid: false,
        error: 'A description is required so the assistant knows when to use this skill.'
    };
    if (value.length > (0, $83bad78370366bbe$export$51627feacfc0fcb0)) return {
        valid: false,
        error: `Description must be ${0, $83bad78370366bbe$export$51627feacfc0fcb0} characters or fewer.`
    };
    return {
        valid: true
    };
}
function $4b33d1984f0c4c25$export$b02cb0d06cabe0e8(input) {
    const slug = (input !== null && input !== void 0 ? input : '').toLowerCase().replace(/[_\s]+/g, '-').replace(RegExp("[^\\p{Ll}\\p{Nd}-]", "gu"), '').replace(/-+/g, '-').replace(/^-+|-+$/g, '').slice(0, (0, $83bad78370366bbe$export$c56c7504d561f6c6)).replace(/-+$/g, '');
    return slug;
}



var $7fPBF = parcelRequire("7fPBF");






let $575b7786b3f3cd02$var$_ = (t)=>t, $575b7786b3f3cd02$var$t, $575b7786b3f3cd02$var$t1, $575b7786b3f3cd02$var$t2, $575b7786b3f3cd02$var$t3, $575b7786b3f3cd02$var$t4;
function $575b7786b3f3cd02$export$2e2bcd8739ae039({ label: label, options: options, value: value, onChange: onChange, compact: compact }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            !compact && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                size: "small",
                title: label
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($575b7786b3f3cd02$var$ModeRadioGroup, {
                "aria-label": label,
                $compact: compact,
                value: value,
                onChange: (_event, next)=>onChange(next),
                name: label,
                children: options.map((option)=>{
                    const choice = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($575b7786b3f3cd02$var$ModeChoice, {
                        value: option.value,
                        $selected: value === option.value,
                        $compact: compact,
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76fcaea1c3599b6$export$2e2bcd8739ae039), {
                            size: "small"
                        }),
                        // The label is two lines of our own typography, not MUI's — a label may only hold
                        // phrasing content, so both render as spans.
                        disableTypography: true,
                        label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($575b7786b3f3cd02$var$ModeText, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($575b7786b3f3cd02$var$ModeLabel, {
                                    as: "span",
                                    $selected: value === option.value,
                                    $compact: compact,
                                    children: option.label
                                }),
                                !compact && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($575b7786b3f3cd02$var$ModeDescription, {
                                    as: "span",
                                    children: option.description
                                })
                            ]
                        })
                    }, option.value);
                    // Compact drops the sentence from the box, so the tooltip is the only place left that
                    // explains what the option does.
                    return compact ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
                        title: option.description,
                        placement: "top",
                        children: choice
                    }, option.value) : choice;
                })
            })
        ]
    });
}
/** Three equal columns; they wrap rather than squeeze when the dialog is narrow. */ const $575b7786b3f3cd02$var$ModeRadioGroup = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $194e327f1282a3e9$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== '$compact'
})($575b7786b3f3cd02$var$t || ($575b7786b3f3cd02$var$t = $575b7786b3f3cd02$var$_`
    display: flex;
    flex-direction: row;
    flex-wrap: ${0};
    /* Compact butts the boxes together into one segmented control; the full group keeps them as three
       separate cards, each holding a label and its own sentence. */
    gap: ${0};
`), (props)=>props.$compact ? 'nowrap' : 'wrap', (props)=>props.$compact ? '0' : '0.5rem');
/**
 * Each choice is its own bordered box so the label and its sentence read as one unit, and the picked
 * one is outlined in the accent — the selection is legible from the box, not just the radio dot.
 */ const $575b7786b3f3cd02$var$ModeChoice = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== '$selected' && prop !== '$compact'
})($575b7786b3f3cd02$var$t1 || ($575b7786b3f3cd02$var$t1 = $575b7786b3f3cd02$var$_`
    flex: ${0};
    align-items: ${0};
    margin: 0;
    padding: ${0};
    border: 1px solid ${0};
    border-radius: 0.5rem;
    background: ${0};

    & .MuiRadio-root {
        padding: 0 0.4rem 0 0;
    }
    ${0}
    &:hover {
        border-color: ${0};
        z-index: 1;
    }
    &:has(.Mui-focusVisible) {
        outline: 2px solid ${0};
        outline-offset: -2px;
        z-index: 1;
    }
`), (props)=>props.$compact ? '0 0 auto' : '1 1 10rem', (props)=>props.$compact ? 'center' : 'flex-start', (props)=>props.$compact ? '0.15rem 0.4rem' : '0.5rem 0.6rem', (props)=>props.$selected ? props.theme.color.accent : props.theme.color.border, (props)=>props.$selected ? props.theme.color.cardHover : 'transparent', (props)=>props.$compact && `
        /* Only the outer edges of the group are rounded, and each box overlaps the one before it so their
           borders collapse into a single shared rule \u{2014} three options reading as one control rather than as
           three unrelated pills. The picked box lifts above its neighbours so its accent border stays whole
           on both sides. */
        border-radius: 0;
        position: relative;
        z-index: ${props.$selected ? 1 : 0};

        &:first-of-type {
            border-radius: 0.4rem 0 0 0.4rem;
        }
        &:last-of-type {
            border-radius: 0 0.4rem 0.4rem 0;
        }
        &:not(:first-of-type) {
            margin-left: -1px;
        }

        /* Visually hidden rather than removed: the input stays in the tab order and keeps the group operable
           by keyboard, while the box itself carries the selection. */
        & .MuiRadio-root {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            overflow: hidden;
            clip-path: inset(50%);
        }
    `, (props)=>props.theme.color.accent, (props)=>props.theme.color.accent);
const $575b7786b3f3cd02$var$ModeText = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($575b7786b3f3cd02$var$t2 || ($575b7786b3f3cd02$var$t2 = $575b7786b3f3cd02$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
`));
/**
 * `BodyXSmall` is 0.875rem — fine in the dialog, where the group is the section's content, but larger than
 * the title of the row it sits beside in compact. There it drops below the metadata line's 0.75rem and only
 * the picked option takes the full text colour, so the control reads as a setting on the row rather than
 * competing with the name for the first glance.
 */ const $575b7786b3f3cd02$var$ModeLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6))($575b7786b3f3cd02$var$t3 || ($575b7786b3f3cd02$var$t3 = $575b7786b3f3cd02$var$_`
    font-weight: ${0};
    color: ${0};
    ${0}
`), (props)=>props.$selected ? 600 : 400, (props)=>props.$compact && !props.$selected ? props.theme.color.textBody : props.theme.color.text, (props)=>props.$compact && `
        font-size: 0.6875rem;
        line-height: 1.2;
        letter-spacing: 0.01em;
    `);
const $575b7786b3f3cd02$var$ModeDescription = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$e4355dfd845d8ca))($575b7786b3f3cd02$var$t4 || ($575b7786b3f3cd02$var$t4 = $575b7786b3f3cd02$var$_``));







var $7fPBF = parcelRequire("7fPBF");

let $24134fde542ee06d$var$_ = (t)=>t, $24134fde542ee06d$var$t, $24134fde542ee06d$var$t1, $24134fde542ee06d$var$t2, $24134fde542ee06d$var$t3, $24134fde542ee06d$var$t4, $24134fde542ee06d$var$t5;
function $24134fde542ee06d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const tips = [
        {
            key: 'common:skills.bestPractices.description',
            fallback: 'Write a clear description that says WHAT the skill does and WHEN to use it. The assistant matches your request against this to decide when to use the skill, so specific words help.'
        },
        {
            key: 'common:skills.bestPractices.focused',
            fallback: 'Keep instructions short and focused on one job. Use numbered steps in the order they should happen.'
        },
        {
            key: 'common:skills.bestPractices.examples',
            fallback: 'Add a short example of a request the skill handles and the ideal result.'
        },
        {
            key: 'common:skills.bestPractices.keywords',
            fallback: 'Add a few keywords (brand names, aliases, file types) to help the assistant find the skill from everyday wording.'
        },
        {
            key: 'common:skills.bestPractices.activation',
            fallback: "Choose \u201CAutomatically\u201D for skills the assistant should reach for on its own, or \u201COnly when I choose it\u201D for ones you want to trigger deliberately with / or @."
        },
        {
            key: 'common:skills.bestPractices.trust',
            fallback: "Only import skills from people you trust \u2014 a skill can tell the assistant to run tasks on your computer."
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($24134fde542ee06d$var$Panel, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($24134fde542ee06d$var$Header, {
                type: "button",
                "aria-expanded": open,
                onClick: ()=>setOpen((prev)=>!prev),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: "idea",
                        size: 15
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$a79389cfbe6f64d), {
                        children: t('common:skills.bestPractices.title', 'Tips for great skills')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($24134fde542ee06d$var$Chevron, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: open ? 'collapseArrow' : 'expandArrow',
                            size: 12
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($24134fde542ee06d$var$TipList, {
                children: tips.map((tip)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($24134fde542ee06d$var$Tip, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($24134fde542ee06d$var$Dot, {
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t(tip.key, tip.fallback)
                            })
                        ]
                    }, tip.key))
            })
        ]
    });
}
const $24134fde542ee06d$var$Panel = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($24134fde542ee06d$var$t || ($24134fde542ee06d$var$t = $24134fde542ee06d$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    border: 1px solid ${0};
    background: ${0};
`), (props)=>props.theme.color.border, (props)=>props.theme.color.accentCard);
const $24134fde542ee06d$var$Header = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($24134fde542ee06d$var$t1 || ($24134fde542ee06d$var$t1 = $24134fde542ee06d$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    color: ${0};
    text-align: left;

    &:focus-visible {
        outline: 2px solid ${0};
        outline-offset: 2px;
        border-radius: 0.25rem;
    }
`), (props)=>props.theme.color.accent, (props)=>props.theme.color.accent);
const $24134fde542ee06d$var$Chevron = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($24134fde542ee06d$var$t2 || ($24134fde542ee06d$var$t2 = $24134fde542ee06d$var$_`
    margin-left: auto;
    display: inline-flex;
    color: ${0};
`), (props)=>props.theme.color.accent);
const $24134fde542ee06d$var$TipList = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($24134fde542ee06d$var$t3 || ($24134fde542ee06d$var$t3 = $24134fde542ee06d$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`));
const $24134fde542ee06d$var$Tip = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($24134fde542ee06d$var$t4 || ($24134fde542ee06d$var$t4 = $24134fde542ee06d$var$_`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
`));
const $24134fde542ee06d$var$Dot = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($24134fde542ee06d$var$t5 || ($24134fde542ee06d$var$t5 = $24134fde542ee06d$var$_`
    flex: none;
    width: 0.4rem;
    height: 0.4rem;
    margin-top: 0.45rem;
    border-radius: 50%;
    background: ${0};
`), (props)=>props.theme.color.accent);






var $7fPBF = parcelRequire("7fPBF");

/**
 * @import {Nodes, Parents} from 'hast'
 */ /**
 * Get the plain-text value of a hast node.
 *
 * @param {Nodes} node
 *   Node to serialize.
 * @returns {string}
 *   Serialized node.
 */ function $58714581718e6349$export$f84e8e69fd4488a5(node) {
    // “The concatenation of data of all the Text node descendants of the context
    // object, in tree order.”
    if ('children' in node) return $58714581718e6349$var$all(node);
    // “Context object’s data.”
    return 'value' in node ? node.value : '';
}
/**
 * @param {Nodes} node
 *   Node.
 * @returns {string}
 *   Serialized node.
 */ function $58714581718e6349$var$one(node) {
    if (node.type === 'text') return node.value;
    return 'children' in node ? $58714581718e6349$var$all(node) : '';
}
/**
 * @param {Parents} node
 *   Node.
 * @returns {string}
 *   Serialized node.
 */ function $58714581718e6349$var$all(node) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    while(++index < node.children.length)result[index] = $58714581718e6349$var$one(node.children[index]);
    return result.join('');
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [cascade=true]
 *   Whether to drop parent nodes if they had children, but all their children
 *   were filtered out (default: `true`).
 */ 
const $31e44c919774b7ea$var$own = {}.hasOwnProperty;
function $31e44c919774b7ea$export$3dea766d36a8935f(tree, options, test) {
    const is = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(test || options);
    const cascadeRaw = options && typeof options === 'object' && 'cascade' in options ? /** @type {boolean | null | undefined} */ options.cascade : undefined;
    const cascade = cascadeRaw === undefined || cascadeRaw === null ? true : cascadeRaw;
    return preorder(tree);
    /**
   * @param {Node} node
   *   Current node.
   * @param {number | undefined} [index]
   *   Index of `node` in `parent`.
   * @param {Parent | undefined} [parentNode]
   *   Parent node.
   * @returns {Node | undefined}
   *   Shallow copy of `node`.
   */ function preorder(node, index, parentNode) {
        /** @type {Array<Node>} */ const children = [];
        if (!is(node, index, parentNode)) return undefined;
        if ($31e44c919774b7ea$var$parent(node)) {
            let childIndex = -1;
            while(++childIndex < node.children.length){
                const result = preorder(node.children[childIndex], childIndex, node);
                if (result) children.push(result);
            }
            if (cascade && node.children.length > 0 && children.length === 0) return undefined;
        }
        // Create a shallow clone, using the new children.
        /** @type {typeof node} */ // @ts-expect-error all the fields will be copied over.
        const next = {};
        /** @type {string} */ let key;
        for(key in node)if ($31e44c919774b7ea$var$own.call(node, key)) // @ts-expect-error: Looks like a record.
        next[key] = key === 'children' ? children : node[key];
        return next;
    }
}
/**
 * @param {Node} node
 * @returns {node is Parent}
 */ function $31e44c919774b7ea$var$parent(node) {
    return 'children' in node && node.children !== undefined;
}


var $97f2cf7466aff99c$exports = {};
/**
 * @param {string} string    The string to parse
 * @returns {Array<number>}  Returns an energetic array.
 */ function $97f2cf7466aff99c$var$parsePart(string) {
    let res = [];
    let m;
    for (let str of string.split(",").map((str)=>str.trim())){
        // just a number
        if (/^-?\d+$/.test(str)) res.push(parseInt(str, 10));
        else if (m = str.match(/^(-?\d+)(-|\.\.\.?|\u2025|\u2026|\u22EF)(-?\d+)$/)) {
            // 1-5 or 1..5 (equivalent) or 1...5 (doesn't include 5)
            let [_, lhs, sep, rhs] = m;
            if (lhs && rhs) {
                lhs = parseInt(lhs);
                rhs = parseInt(rhs);
                const incr = lhs < rhs ? 1 : -1;
                // Make it inclusive by moving the right 'stop-point' away by one.
                if (sep === "-" || sep === ".." || sep === "\u2025") rhs += incr;
                for(let i = lhs; i !== rhs; i += incr)res.push(i);
            }
        }
    }
    return res;
}
$97f2cf7466aff99c$exports.default = $97f2cf7466aff99c$var$parsePart;
$97f2cf7466aff99c$exports = $97f2cf7466aff99c$var$parsePart;


/**
 * @typedef {import('./core.js').Syntax} Syntax
 */ // @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $eba707d89e6509b5$export$2e2bcd8739ae039.displayName = 'clike';
$eba707d89e6509b5$export$2e2bcd8739ae039.aliases = [];
function $eba707d89e6509b5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f4e156ae6ed8d0a0$export$2e2bcd8739ae039.displayName = 'c';
$f4e156ae6ed8d0a0$export$2e2bcd8739ae039.aliases = [];
function $f4e156ae6ed8d0a0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.c = Prism.languages.extend('clike', {
        comment: {
            pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        string: {
            // https://en.cppreference.com/w/c/language/string_literal
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
            lookbehind: true
        },
        keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    });
    Prism.languages.insertBefore('c', 'string', {
        char: {
            // https://en.cppreference.com/w/c/language/character_constant
            pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('c', 'string', {
        macro: {
            // allow for multiline macro definitions
            // spaces after the # character compile fine with gcc
            pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                string: [
                    {
                        // highlight the path of the include statement as a string
                        pattern: /^(#\s*include\s*)<[^>]+>/,
                        lookbehind: true
                    },
                    Prism.languages.c['string']
                ],
                char: Prism.languages.c['char'],
                comment: Prism.languages.c['comment'],
                'macro-name': [
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                        lookbehind: true
                    },
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                        lookbehind: true,
                        alias: 'function'
                    }
                ],
                // highlight macro directives as keywords
                directive: {
                    pattern: /^(#\s*)[a-z]+/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                'directive-hash': /^#/,
                punctuation: /##|\\(?=[\r\n])/,
                expression: {
                    pattern: /\S[\s\S]*/,
                    inside: Prism.languages.c
                }
            }
        }
    });
    Prism.languages.insertBefore('c', 'function', {
        // highlight predefined macros as constants
        constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    });
    delete Prism.languages.c['boolean'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b373cdd06f88d58c$export$2e2bcd8739ae039.displayName = 'cpp';
$b373cdd06f88d58c$export$2e2bcd8739ae039.aliases = [];
function $b373cdd06f88d58c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    (function(Prism) {
        var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
        var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
            return keyword.source;
        });
        Prism.languages.cpp = Prism.languages.extend('c', {
            'class-name': [
                {
                    pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                        return keyword.source;
                    })),
                    lookbehind: true
                },
                // This is intended to capture the class name of method implementations like:
                //   void foo::bar() const {}
                // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
                // it starts with an uppercase letter. This approximation should give decent results.
                /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
                // This will capture the class name before destructors like:
                //   Foo::~Foo() {}
                /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
                // This also intends to capture the class name of method implementations but here the class has template
                // parameters, so it can't be a namespace (until C++ adds generic namespaces).
                /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
            ],
            keyword: keyword,
            number: {
                pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
                greedy: true
            },
            operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
            boolean: /\b(?:false|true)\b/
        });
        Prism.languages.insertBefore('cpp', 'string', {
            module: {
                // https://en.cppreference.com/w/cpp/language/modules
                pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
                /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
                /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                    return modName;
                }) + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    string: /^[<"][\s\S]+/,
                    operator: /:/,
                    punctuation: /\./
                }
            },
            'raw-string': {
                pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
                alias: 'string',
                greedy: true
            }
        });
        Prism.languages.insertBefore('cpp', 'keyword', {
            'generic-function': {
                pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        alias: 'class-name',
                        inside: Prism.languages.cpp
                    }
                }
            }
        });
        Prism.languages.insertBefore('cpp', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('cpp', 'class-name', {
            // the base clause is an optional list of parent classes
            // https://en.cppreference.com/w/cpp/language/class
            'base-clause': {
                pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: Prism.languages.extend('cpp', {})
            }
        });
        Prism.languages.insertBefore('inside', 'double-colon', {
            // All untokenized words that are not namespaces should be class names
            'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
        }, Prism.languages.cpp['base-clause']);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$4fe2e947cede365f$export$2e2bcd8739ae039.displayName = 'arduino';
$4fe2e947cede365f$export$2e2bcd8739ae039.aliases = [
    'ino'
];
function $4fe2e947cede365f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
    Prism.languages.arduino = Prism.languages.extend('cpp', {
        keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
        constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
        builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    });
    Prism.languages.ino = Prism.languages.arduino;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8bc35bfd2be6822a$export$2e2bcd8739ae039.displayName = 'bash';
$8bc35bfd2be6822a$export$2e2bcd8739ae039.aliases = [
    'sh',
    'shell'
];
function $8bc35bfd2be6822a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
        // + LC_ALL, RANDOM, REPLY, SECONDS.
        // + make sure PS1..4 are here as they are not always set,
        // - some useless things.
        var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
        var commandAfterHeredoc = {
            pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
            lookbehind: true,
            alias: 'punctuation',
            // this looks reasonably well in all themes
            inside: null // see below
        };
        var insideString = {
            bash: commandAfterHeredoc,
            environment: {
                pattern: RegExp('\\$' + envVars),
                alias: 'constant'
            },
            variable: [
                // [0]: Arithmetic Environment
                {
                    pattern: /\$?\(\([\s\S]+?\)\)/,
                    greedy: true,
                    inside: {
                        // If there is a $ sign at the beginning highlight $(( and )) as variable
                        variable: [
                            {
                                pattern: /(^\$\(\([\s\S]+)\)\)/,
                                lookbehind: true
                            },
                            /^\$\(\(/
                        ],
                        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                        operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                        // If there is no $ sign at the beginning highlight (( and )) as punctuation
                        punctuation: /\(\(?|\)\)?|,|;/
                    }
                },
                // [1]: Command Substitution
                {
                    pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                    greedy: true,
                    inside: {
                        variable: /^\$\(|^`|\)$|`$/
                    }
                },
                // [2]: Brace expansion
                {
                    pattern: /\$\{[^}]+\}/,
                    greedy: true,
                    inside: {
                        operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                        punctuation: /[\[\]]/,
                        environment: {
                            pattern: RegExp('(\\{)' + envVars),
                            lookbehind: true,
                            alias: 'constant'
                        }
                    }
                },
                /\$(?:\w+|[#?*!@$])/
            ],
            // Escape sequences from echo and printf's manuals, and escaped quotes.
            entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
        };
        Prism.languages.bash = {
            shebang: {
                pattern: /^#!\s*\/.*/,
                alias: 'important'
            },
            comment: {
                pattern: /(^|[^"{\\$])#.*/,
                lookbehind: true
            },
            'function-name': [
                // a) function foo {
                // b) foo() {
                // c) function foo() {
                // but not “foo {”
                {
                    // a) and c)
                    pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                    lookbehind: true,
                    alias: 'function'
                },
                {
                    // b)
                    pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                    alias: 'function'
                }
            ],
            // Highlight variable names as variables in for and select beginnings.
            'for-or-select': {
                pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                alias: 'variable',
                lookbehind: true
            },
            // Highlight variable names as variables in the left-hand part
            // of assignments (“=” and “+=”).
            'assign-left': {
                pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/,
                inside: {
                    environment: {
                        pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                },
                alias: 'variable',
                lookbehind: true
            },
            // Highlight parameter names as variables
            parameter: {
                pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/,
                alias: 'variable',
                lookbehind: true
            },
            string: [
                // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
                {
                    pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                // Here-document with quotes around the tag
                // → No expansion (so no “inside”).
                {
                    pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        bash: commandAfterHeredoc
                    }
                },
                // “Normal” string
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                    pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                    pattern: /(^|[^$\\])'[^']*'/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                    pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                    greedy: true,
                    inside: {
                        entity: insideString.entity
                    }
                }
            ],
            environment: {
                pattern: RegExp('\\$?' + envVars),
                alias: 'constant'
            },
            variable: insideString.variable,
            function: {
                pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            keyword: {
                pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            builtin: {
                pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                lookbehind: true,
                // Alias added to make those easier to distinguish from strings.
                alias: 'class-name'
            },
            boolean: {
                pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            'file-descriptor': {
                pattern: /\B&\d\b/,
                alias: 'important'
            },
            operator: {
                // Lots of redirections here, but not just that.
                pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                inside: {
                    'file-descriptor': {
                        pattern: /^\d/,
                        alias: 'important'
                    }
                }
            },
            punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
            number: {
                pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                lookbehind: true
            }
        };
        commandAfterHeredoc.inside = Prism.languages.bash;
        /* Patterns in command substitution. */ var toBeCopied = [
            'comment',
            'function-name',
            'for-or-select',
            'assign-left',
            'parameter',
            'string',
            'environment',
            'function',
            'keyword',
            'builtin',
            'boolean',
            'file-descriptor',
            'operator',
            'punctuation',
            'number'
        ];
        var inside = insideString.variable[1].inside;
        for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
        Prism.languages.sh = Prism.languages.bash;
        Prism.languages.shell = Prism.languages.bash;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$803928922a6961a4$export$2e2bcd8739ae039.displayName = 'csharp';
$803928922a6961a4$export$2e2bcd8739ae039.aliases = [
    'cs',
    'dotnet'
];
function $803928922a6961a4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        }
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/keywords/
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
            // keywords which are used to declare a type
            typeDeclaration: 'class enum interface record struct',
            // contextual keywords
            // ("var" and "dynamic" are missing because they are used like types)
            contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
            // all other keywords
            other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
        };
        // keywords
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
        var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
        var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other);
        // types
        var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2) // the idea behind the other forbidden characters is to prevent false positives. Same for tupleElement.
        ;
        var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
        var name = /@?\b[A-Za-z_]\w*\b/.source;
        var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
            name,
            generic
        ]);
        var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
            nonTypeKeywords,
            genericName
        ]);
        var array = /\[\s*(?:,\s*)*\]/.source;
        var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
            identifier,
            array
        ]);
        var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
            generic,
            nestedRound,
            array
        ]);
        var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [
            tupleElement
        ]);
        var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
            tuple,
            identifier,
            array
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        };
        // strings & characters
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#character-literals
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#string-literals
        var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source // simplified pattern
        ;
        var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
        var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
        Prism.languages.csharp = Prism.languages.extend('clike', {
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        verbatimString
                    ]),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: re(/(^|[^@$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // Using static
                    // using static System.Math;
                    pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (type)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                        name,
                        typeExpression
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (alias)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Type declarations
                    // class Foo<A, B>
                    // interface Foo<out A, B>
                    pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                        typeDeclarationKeywords,
                        genericName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Single catch exception declaration
                    // catch(Foo)
                    // (things like catch(Foo e) is covered by variable declaration)
                    pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Name of the type parameter of generic constraints
                    // where Foo : class
                    pattern: re(/(\bwhere\s+)<<0>>/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Casts and checks via as and is.
                    // as Foo<A>, is Bar<B>
                    // (things like if(a is Foo b) is covered by variable declaration)
                    pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
                        typeExpressionWithoutTuple
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Variable, field and parameter declaration
                    // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
                    pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                        typeExpression,
                        nonContextualKeywords,
                        name
                    ]),
                    inside: typeInside
                }
            ],
            keyword: keywords,
            // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
            number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
            operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
            punctuation: /\?\.?|::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('csharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('csharp', 'punctuation', {
            'named-parameter': {
                pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [
                    name
                ]),
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('csharp', 'class-name', {
            namespace: {
                // namespace Foo.Bar {}
                // using Foo.Bar;
                pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [
                    name
                ]),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            'type-expression': {
                // default(Foo), typeof(Foo<Bar>), sizeof(int)
                pattern: re(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [
                    nestedRound
                ]),
                lookbehind: true,
                alias: 'class-name',
                inside: typeInside
            },
            'return-type': {
                // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
                // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
                // int Foo => 0; int Foo { get; set } = 0;
                pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                    typeExpression,
                    identifier
                ]),
                inside: typeInside,
                alias: 'class-name'
            },
            'constructor-invocation': {
                // new List<Foo<Bar[]>> { }
                pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [
                    typeExpression
                ]),
                lookbehind: true,
                inside: typeInside,
                alias: 'class-name'
            },
            /*'explicit-implementation': {
// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
inside: classNameInside,
alias: 'class-name'
},*/ 'generic-method': {
                // foo<Bar>()
                pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                    name,
                    generic
                ]),
                inside: {
                    function: re(/^<<0>>/.source, [
                        name
                    ]),
                    generic: {
                        pattern: RegExp(generic),
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            },
            'type-list': {
                // The list of types inherited or of generic constraints
                // class Foo<F> : Bar, IList<FooBar>
                // where F : Bar, IList<int>
                pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                    typeDeclarationKeywords,
                    genericName,
                    name,
                    typeExpression,
                    keywords.source,
                    nestedRound,
                    /\bnew\s*\(\s*\)/.source
                ]),
                lookbehind: true,
                inside: {
                    'record-arguments': {
                        pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                            genericName,
                            nestedRound
                        ]),
                        lookbehind: true,
                        greedy: true,
                        inside: Prism.languages.csharp
                    },
                    keyword: keywords,
                    'class-name': {
                        pattern: RegExp(typeExpression),
                        greedy: true,
                        inside: typeInside
                    },
                    punctuation: /[,()]/
                }
            },
            preprocessor: {
                pattern: /(^[\t ]*)#.*/m,
                lookbehind: true,
                alias: 'property',
                inside: {
                    // highlight preprocessor directives as keywords
                    directive: {
                        pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                        lookbehind: true,
                        alias: 'keyword'
                    }
                }
            }
        });
        // attributes
        var regularStringOrCharacter = regularString + '|' + character;
        var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [
            regularStringOrCharacter
        ]);
        var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        // https://docs.microsoft.com/en-us/dotnet/csharp/programming-guide/concepts/attributes/#attribute-targets
        var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
        var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
            identifier,
            roundExpression
        ]);
        Prism.languages.insertBefore('csharp', 'class-name', {
            attribute: {
                // Attributes
                // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
                pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                    attrTarget,
                    attr
                ]),
                lookbehind: true,
                greedy: true,
                inside: {
                    target: {
                        pattern: re(/^<<0>>(?=\s*:)/.source, [
                            attrTarget
                        ]),
                        alias: 'keyword'
                    },
                    'attribute-arguments': {
                        pattern: re(/\(<<0>>*\)/.source, [
                            roundExpression
                        ]),
                        inside: Prism.languages.csharp
                    },
                    'class-name': {
                        pattern: RegExp(identifier),
                        inside: {
                            punctuation: /\./
                        }
                    },
                    punctuation: /[:,]/
                }
            }
        });
        // string interpolation
        var formatString = /:[^}\r\n]+/.source;
        // multi line
        var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            mInterpolationRound,
            formatString
        ]);
        // single line
        var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [
            regularStringOrCharacter
        ]), 2);
        var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            sInterpolationRound,
            formatString
        ]);
        function createInterpolationInside(interpolation, interpolationRound) {
            return {
                interpolation: {
                    pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [
                        interpolation
                    ]),
                    lookbehind: true,
                    inside: {
                        'format-string': {
                            pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                                interpolationRound,
                                formatString
                            ]),
                            lookbehind: true,
                            inside: {
                                punctuation: /^:/
                            }
                        },
                        punctuation: /^\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            alias: 'language-csharp',
                            inside: Prism.languages.csharp
                        }
                    }
                },
                string: /[\s\S]+/
            };
        }
        Prism.languages.insertBefore('csharp', 'string', {
            'interpolation-string': [
                {
                    pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [
                        mInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(mInterpolation, mInterpolationRound)
                },
                {
                    pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
                        sInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(sInterpolation, sInterpolationRound)
                }
            ],
            char: {
                pattern: RegExp(character),
                greedy: true
            }
        });
        Prism.languages.dotnet = Prism.languages.cs = Prism.languages.csharp;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f47682e33a093951$export$2e2bcd8739ae039.displayName = 'markup';
$f47682e33a093951$export$2e2bcd8739ae039.aliases = [
    'atom',
    'html',
    'mathml',
    'rss',
    'ssml',
    'svg',
    'xml'
];
function $f47682e33a093951$export$2e2bcd8739ae039(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
    // Plugin to make entity title show the real entity, idea by Roman Komarov
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8467c3aacdff56ee$export$2e2bcd8739ae039.displayName = 'css';
$8467c3aacdff56ee$export$2e2bcd8739ae039.aliases = [];
function $8467c3aacdff56ee$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
                inside: {
                    rule: /^@[\w-]+/,
                    'selector-function-argument': {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: 'selector'
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    }
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp('^' + string.source + '$'),
                        alias: 'url'
                    }
                }
            },
            selector: {
                pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $dab2950de0f638d9$export$2e2bcd8739ae039.displayName = 'diff';
$dab2950de0f638d9$export$2e2bcd8739ae039.aliases = [];
function $dab2950de0f638d9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.diff = {
            coord: [
                // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
                /^(?:\*{3}|-{3}|\+{3}).*$/m,
                // Match "@@ ... @@" coord lines in unified diff.
                /^@@.*@@$/m,
                // Match coord lines in normal diff (starts with a number).
                /^\d.*$/m
            ]
        };
        /**
     * A map from the name of a block to its line prefix.
     *
     * @type {Object<string, string>}
     */ var PREFIXES = {
            'deleted-sign': '-',
            'deleted-arrow': '<',
            'inserted-sign': '+',
            'inserted-arrow': '>',
            unchanged: ' ',
            diff: '!'
        };
        // add a token for each prefix
        Object.keys(PREFIXES).forEach(function(name) {
            var prefix = PREFIXES[name];
            var alias = [];
            if (!/^\w+$/.test(name)) // "deleted-sign" -> "deleted"
            alias.push(/\w+/.exec(name)[0]);
            if (name === 'diff') alias.push('bold');
            Prism.languages.diff[name] = {
                pattern: RegExp('^(?:[' + prefix + '].*(?:\r\n?|\n|(?![\\s\\S])))+', 'm'),
                alias: alias,
                inside: {
                    line: {
                        pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
                        lookbehind: true
                    },
                    prefix: {
                        pattern: /[\s\S]/,
                        alias: /\w+/.exec(name)[0]
                    }
                }
            };
        });
        // make prefixes available to Diff plugin
        Object.defineProperty(Prism.languages.diff, 'PREFIXES', {
            value: PREFIXES
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$1c0f2e453947e61a$export$2e2bcd8739ae039.displayName = 'go';
$1c0f2e453947e61a$export$2e2bcd8739ae039.aliases = [];
function $1c0f2e453947e61a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.go = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
        boolean: /\b(?:_|false|iota|nil|true)\b/,
        number: [
            // binary and octal integers
            /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
            // hexadecimal integers and floats
            /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            // decimal integers and floats
            /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
        ],
        operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
        builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    });
    Prism.languages.insertBefore('go', 'string', {
        char: {
            pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
            greedy: true
        }
    });
    delete Prism.languages.go['class-name'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $197381b2d5f39c0b$export$2e2bcd8739ae039.displayName = 'ini';
$197381b2d5f39c0b$export$2e2bcd8739ae039.aliases = [];
function $197381b2d5f39c0b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ini = {
        /**
     * The component mimics the behavior of the Win32 API parser.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
     */ comment: {
            pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
            lookbehind: true
        },
        section: {
            pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
            lookbehind: true,
            inside: {
                'section-name': {
                    pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
                    lookbehind: true,
                    alias: 'selector'
                },
                punctuation: /\[|\]/
            }
        },
        key: {
            pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
            lookbehind: true,
            alias: 'attr-value',
            inside: {
                'inner-value': {
                    pattern: /^("|').+(?=\1$)/,
                    lookbehind: true
                }
            }
        },
        punctuation: /=/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$49817f5fa65142f2$export$2e2bcd8739ae039.displayName = 'java';
$49817f5fa65142f2$export$2e2bcd8739ae039.aliases = [];
function $49817f5fa65142f2$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;
        // full package (optional) + parent classes (optional)
        var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
        // based on the java naming conventions
        var className = {
            pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /\./
            }
        };
        Prism.languages.java = Prism.languages.extend('clike', {
            string: {
                pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
                lookbehind: true,
                greedy: true
            },
            'class-name': [
                className,
                {
                    // variables, parameters, and constructor references
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
                    lookbehind: true,
                    inside: className.inside
                },
                {
                    // class names based on keyword
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            function: [
                Prism.languages.clike.function,
                {
                    pattern: /(::\s*)[a-z_]\w*/,
                    lookbehind: true
                }
            ],
            number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
            operator: {
                pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
                lookbehind: true
            },
            constant: /\b[A-Z][A-Z_\d]+\b/
        });
        Prism.languages.insertBefore('java', 'string', {
            'triple-quoted-string': {
                // http://openjdk.java.net/jeps/355#Description
                pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
                greedy: true,
                alias: 'string'
            },
            char: {
                pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
                greedy: true
            }
        });
        Prism.languages.insertBefore('java', 'class-name', {
            annotation: {
                pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
                lookbehind: true,
                alias: 'punctuation'
            },
            generics: {
                pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            },
            import: [
                {
                    pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
                    lookbehind: true,
                    inside: {
                        namespace: className.inside.namespace,
                        punctuation: /\./,
                        operator: /\*/,
                        'class-name': /\w+/
                    }
                },
                {
                    pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
                    lookbehind: true,
                    alias: 'static',
                    inside: {
                        namespace: className.inside.namespace,
                        static: /\b\w+$/,
                        punctuation: /\./,
                        operator: /\*/,
                        'class-name': /\w+/
                    }
                }
            ],
            namespace: {
                pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                    return keywords.source;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c029552e57eb42d4$export$2e2bcd8739ae039.displayName = 'regex';
$c029552e57eb42d4$export$2e2bcd8739ae039.aliases = [];
function $c029552e57eb42d4$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var specialEscape = {
            pattern: /\\[\\(){}[\]^$+*?|.]/,
            alias: 'escape'
        };
        var escape = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/;
        var charSet = {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var charSetWithoutDot = {
            pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var rangeChar = '(?:[^\\\\-]|' + escape.source + ')';
        var range = RegExp(rangeChar + '-' + rangeChar);
        // the name of a capturing group
        var groupName = {
            pattern: /(<|')[^<>']+(?=[>']$)/,
            lookbehind: true,
            alias: 'variable'
        };
        Prism.languages.regex = {
            'char-class': {
                pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
                lookbehind: true,
                inside: {
                    'char-class-negation': {
                        pattern: /(^\[)\^/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    'char-class-punctuation': {
                        pattern: /^\[|\]$/,
                        alias: 'punctuation'
                    },
                    range: {
                        pattern: range,
                        inside: {
                            escape: escape,
                            'range-punctuation': {
                                pattern: /-/,
                                alias: 'operator'
                            }
                        }
                    },
                    'special-escape': specialEscape,
                    'char-set': charSetWithoutDot,
                    escape: escape
                }
            },
            'special-escape': specialEscape,
            'char-set': charSet,
            backreference: [
                {
                    // a backreference which is not an octal escape
                    pattern: /\\(?![123][0-7]{2})[1-9]/,
                    alias: 'keyword'
                },
                {
                    pattern: /\\k<[^<>']+>/,
                    alias: 'keyword',
                    inside: {
                        'group-name': groupName
                    }
                }
            ],
            anchor: {
                pattern: /[$^]|\\[ABbGZz]/,
                alias: 'function'
            },
            escape: escape,
            group: [
                {
                    // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
                    // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
                    // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
                    pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                    alias: 'punctuation',
                    inside: {
                        'group-name': groupName
                    }
                },
                {
                    pattern: /\)/,
                    alias: 'punctuation'
                }
            ],
            quantifier: {
                pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
                alias: 'number'
            },
            alternation: {
                pattern: /\|/,
                alias: 'keyword'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$7a8c3997a83eed46$export$2e2bcd8739ae039.displayName = 'javascript';
$7a8c3997a83eed46$export$2e2bcd8739ae039.aliases = [
    'js'
];
function $7a8c3997a83eed46$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.javascript = Prism.languages.extend('clike', {
        'class-name': [
            Prism.languages.clike['class-name'],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
            (/NaN|Infinity/.source + '|' + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
            /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore('javascript', 'keyword', {
        regex: {
            pattern: RegExp(// lookbehind
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
            // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
            // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
            // with the only syntax, so we have to define 2 different regex patterns.
            /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
            /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
            /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\/|\/$/,
                'regex-flags': /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore('javascript', 'string', {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        'string-property': {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        }
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'literal-property': {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: 'property'
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined('script', 'javascript');
        // add attribute support for all DOM events.
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
    }
    Prism.languages.js = Prism.languages.javascript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7ca1ade36c00114f$export$2e2bcd8739ae039.displayName = 'json';
$7ca1ade36c00114f$export$2e2bcd8739ae039.aliases = [
    'webmanifest'
];
function $7ca1ade36c00114f$export$2e2bcd8739ae039(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$edb8a8bbc6c61935$export$2e2bcd8739ae039.displayName = 'kotlin';
$edb8a8bbc6c61935$export$2e2bcd8739ae039.aliases = [
    'kt',
    'kts'
];
function $edb8a8bbc6c61935$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.kotlin = Prism.languages.extend('clike', {
            keyword: {
                // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
                pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
                lookbehind: true
            },
            function: [
                {
                    pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                    greedy: true
                },
                {
                    pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
            operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
        });
        delete Prism.languages.kotlin['class-name'];
        var interpolationInside = {
            'interpolation-punctuation': {
                pattern: /^\$\{?|\}$/,
                alias: 'punctuation'
            },
            expression: {
                pattern: /[\s\S]+/,
                inside: Prism.languages.kotlin
            }
        };
        Prism.languages.insertBefore('kotlin', 'string', {
            // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
            'string-literal': [
                {
                    pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                    alias: 'multiline',
                    inside: {
                        interpolation: {
                            pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                    alias: 'singleline',
                    inside: {
                        interpolation: {
                            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            lookbehind: true,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            char: {
                // https://kotlinlang.org/spec/expressions.html#character-literals
                pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
                greedy: true
            }
        });
        delete Prism.languages.kotlin['string'];
        Prism.languages.insertBefore('kotlin', 'keyword', {
            annotation: {
                pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
                alias: 'builtin'
            }
        });
        Prism.languages.insertBefore('kotlin', 'function', {
            label: {
                pattern: /\b\w+@|@\w+\b/,
                alias: 'symbol'
            }
        });
        Prism.languages.kt = Prism.languages.kotlin;
        Prism.languages.kts = Prism.languages.kotlin;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f3a5ce20fdab9e50$export$2e2bcd8739ae039.displayName = 'less';
$f3a5ce20fdab9e50$export$2e2bcd8739ae039.aliases = [];
function $f3a5ce20fdab9e50$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    /* FIXME :
:extend() is not handled specifically : its highlighting is buggy.
Mixin usage must be inside a ruleset to be highlighted.
At-rules (e.g. import) containing interpolations are buggy.
Detached rulesets are highlighted as at-rules.
A comment before a mixin usage prevents the latter to be properly highlighted.
*/ Prism.languages.less = Prism.languages.extend('css', {
        comment: [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^|[^\\])\/\/.*/,
                lookbehind: true
            }
        ],
        atrule: {
            pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                punctuation: /[:()]/
            }
        },
        // selectors and mixins are considered the same
        selector: {
            pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                // mixin parameters
                variable: /@+[\w-]+/
            }
        },
        property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
        operator: /[+\-*\/]/
    });
    Prism.languages.insertBefore('less', 'property', {
        variable: [
            // Variable declaration (the colon must be consumed!)
            {
                pattern: /@[\w-]+\s*:/,
                inside: {
                    punctuation: /:/
                }
            },
            // Variable usage
            /@@?[\w-]+/
        ],
        'mixin-usage': {
            pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
            lookbehind: true,
            alias: 'function'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $20b8caf8b024dc15$export$2e2bcd8739ae039.displayName = 'lua';
$20b8caf8b024dc15$export$2e2bcd8739ae039.aliases = [];
function $20b8caf8b024dc15$export$2e2bcd8739ae039(Prism) {
    Prism.languages.lua = {
        comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
        // \z may be used to skip the following space
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
            greedy: true
        },
        number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
        keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
        function: /(?!\d)\w+(?=\s*(?:[({]))/,
        operator: [
            /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
            {
                // Match ".." but don't break "..."
                pattern: /(^|[^.])\.\.(?!\.)/,
                lookbehind: true
            }
        ],
        punctuation: /[\[\](){},;]|\.+|:+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $23da19d9f15297a4$export$2e2bcd8739ae039.displayName = 'makefile';
$23da19d9f15297a4$export$2e2bcd8739ae039.aliases = [];
function $23da19d9f15297a4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.makefile = {
        comment: {
            pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'builtin-target': {
            pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
            alias: 'builtin'
        },
        target: {
            pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
            alias: 'symbol',
            inside: {
                variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
            }
        },
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
        // Directives
        keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
        function: {
            pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
            lookbehind: true
        },
        operator: /(?:::|[?:+!])?=|[|@]/,
        punctuation: /[:;(){}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1da2260b608e55ec$export$2e2bcd8739ae039.displayName = 'yaml';
$1da2260b608e55ec$export$2e2bcd8739ae039.aliases = [
    'yml'
];
function $1da2260b608e55ec$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
        // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
        var anchorOrAlias = /[*&][^\s[\]{},]+/;
        // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
        var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/;
        // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
        var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)';
        // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
        // This is a simplified version that doesn't support "#" and multiline keys
        // All these long scarry character classes are simplified versions of YAML's characters
        var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
            return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        });
        var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
        /**
     *
     * @param {string} value
     * @param {string} [flags]
     * @returns {RegExp}
     */ function createValuePattern(value, flags) {
            flags = (flags || '').replace(/m/g, '') + 'm' // add m flag
            ;
            var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<value>>/g, function() {
                return value;
            });
            return RegExp(pattern, flags);
        }
        Prism.languages.yaml = {
            scalar: {
                pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                })),
                lookbehind: true,
                alias: 'string'
            },
            comment: /#.*/,
            key: {
                pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                }).replace(/<<key>>/g, function() {
                    return '(?:' + plainKey + '|' + string + ')';
                })),
                lookbehind: true,
                greedy: true,
                alias: 'atrule'
            },
            directive: {
                pattern: /(^[ \t]*)%.+/m,
                lookbehind: true,
                alias: 'important'
            },
            datetime: {
                pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
                lookbehind: true,
                alias: 'number'
            },
            boolean: {
                pattern: createValuePattern(/false|true/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            null: {
                pattern: createValuePattern(/null|~/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            string: {
                pattern: createValuePattern(string),
                lookbehind: true,
                greedy: true
            },
            number: {
                pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
                lookbehind: true
            },
            tag: tag,
            important: anchorOrAlias,
            punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
        };
        Prism.languages.yml = Prism.languages.yaml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ee5893254ac9a415$export$2e2bcd8739ae039.displayName = 'markdown';
$ee5893254ac9a415$export$2e2bcd8739ae039.aliases = [
    'md'
];
function $ee5893254ac9a415$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        // Allow only one line break
        var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
        /**
     * This function is intended for the creation of the bold or italic pattern.
     *
     * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
     *
     * _Note:_ Keep in mind that this adds a capturing group.
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function createInline(pattern) {
            pattern = pattern.replace(/<inner>/g, function() {
                return inner;
            });
            return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
        }
        var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
        var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
            return tableCell;
        });
        var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
        Prism.languages.markdown = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('markdown', 'prolog', {
            'front-matter-block': {
                pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^---|---$/,
                    'front-matter': {
                        pattern: /\S+(?:\s+\S+)*/,
                        alias: [
                            'yaml',
                            'language-yaml'
                        ],
                        inside: Prism.languages.yaml
                    }
                }
            },
            blockquote: {
                // > ...
                pattern: /^>(?:[\t ]*>)*/m,
                alias: 'punctuation'
            },
            table: {
                pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
                inside: {
                    'table-data-rows': {
                        pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                        lookbehind: true,
                        inside: {
                            'table-data': {
                                pattern: RegExp(tableCell),
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    },
                    'table-line': {
                        pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                        lookbehind: true,
                        inside: {
                            punctuation: /\||:?-{3,}:?/
                        }
                    },
                    'table-header-row': {
                        pattern: RegExp('^' + tableRow + '$'),
                        inside: {
                            'table-header': {
                                pattern: RegExp(tableCell),
                                alias: 'important',
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    }
                }
            },
            code: [
                {
                    // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                    pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                {
                    // ```optional language
                    // code block
                    // ```
                    pattern: /^```[\s\S]*?^```$/m,
                    greedy: true,
                    inside: {
                        'code-block': {
                            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                            lookbehind: true
                        },
                        'code-language': {
                            pattern: /^(```).+/,
                            lookbehind: true
                        },
                        punctuation: /```/
                    }
                }
            ],
            title: [
                {
                    // title 1
                    // =======
                    // title 2
                    // -------
                    pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                    alias: 'important',
                    inside: {
                        punctuation: /==+$|--+$/
                    }
                },
                {
                    // # title 1
                    // ###### title 6
                    pattern: /(^\s*)#.+/m,
                    lookbehind: true,
                    alias: 'important',
                    inside: {
                        punctuation: /^#+|#+$/
                    }
                }
            ],
            hr: {
                // ***
                // ---
                // * * *
                // -----------
                pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            list: {
                // * item
                // + item
                // - item
                // 1. item
                pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            'url-reference': {
                // [id]: http://example.com "Optional title"
                // [id]: http://example.com 'Optional title'
                // [id]: http://example.com (Optional title)
                // [id]: <http://example.com> "Optional title"
                pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                inside: {
                    variable: {
                        pattern: /^(!?\[)[^\]]+/,
                        lookbehind: true
                    },
                    string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                    punctuation: /^[\[\]!:]|[<>]/
                },
                alias: 'url'
            },
            bold: {
                // **strong**
                // __strong__
                // allow one nested instance of italic text using the same delimiter
                pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^..)[\s\S]+(?=..$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /\*\*|__/
                }
            },
            italic: {
                // *em*
                // _em_
                // allow one nested instance of bold text using the same delimiter
                pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^.)[\s\S]+(?=.$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /[*_]/
                }
            },
            strike: {
                // ~~strike through~~
                // ~strike~
                // eslint-disable-next-line regexp/strict
                pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^~~?)[\s\S]+(?=\1$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /~~?/
                }
            },
            'code-snippet': {
                // `code`
                // ``code``
                pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                lookbehind: true,
                greedy: true,
                alias: [
                    'code',
                    'keyword'
                ]
            },
            url: {
                // [example](http://example.com "Optional title")
                // [example][id]
                // [example] [id]
                pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    operator: /^!/,
                    content: {
                        pattern: /(^\[)[^\]]+(?=\])/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    variable: {
                        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                        lookbehind: true
                    },
                    url: {
                        pattern: /(^\]\()[^\s)]+/,
                        lookbehind: true
                    },
                    string: {
                        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                        lookbehind: true
                    }
                }
            }
        });
        [
            'url',
            'bold',
            'italic',
            'strike'
        ].forEach(function(token) {
            [
                'url',
                'bold',
                'italic',
                'strike',
                'code-snippet'
            ].forEach(function(inside) {
                if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
            });
        });
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'markdown' && env.language !== 'md') return;
            function walkTokens(tokens) {
                if (!tokens || typeof tokens === 'string') return;
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (token.type !== 'code') {
                        walkTokens(token.content);
                        continue;
                    }
                    /*
           * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
           * is optional. But the grammar is defined so that there is only one case we have to handle:
           *
           * token.content = [
           *     <span class="punctuation">```</span>,
           *     <span class="code-language">xxxx</span>,
           *     '\n', // exactly one new lines (\r or \n or \r\n)
           *     <span class="code-block">...</span>,
           *     '\n', // exactly one new lines again
           *     <span class="punctuation">```</span>
           * ];
           */ var codeLang = token.content[1];
                    var codeBlock = token.content[3];
                    if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                        // this might be a language that Prism does not support
                        // do some replacements to support C++, C#, and F#
                        var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
                        // only use the first word
                        lang = (/[a-z][\w-]*/i.exec(lang) || [
                            ''
                        ])[0].toLowerCase();
                        var alias = 'language-' + lang;
                        // add alias
                        if (!codeBlock.alias) codeBlock.alias = [
                            alias
                        ];
                        else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                            codeBlock.alias,
                            alias
                        ];
                        else codeBlock.alias.push(alias);
                    }
                }
            }
            walkTokens(env.tokens);
        });
        Prism.hooks.add('wrap', function(env) {
            if (env.type !== 'code-block') return;
            var codeLang = '';
            for(var i = 0, l = env.classes.length; i < l; i++){
                var cls = env.classes[i];
                var match = /language-(.+)/.exec(cls);
                if (match) {
                    codeLang = match[1];
                    break;
                }
            }
            var grammar = Prism.languages[codeLang];
            if (!grammar) {
                if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                    var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                    env.attributes['id'] = id;
                    Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                        var ele = document.getElementById(id);
                        if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                    });
                }
            } else env.content = Prism.highlight(env.content.value, grammar, codeLang);
        });
        var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
        /**
     * A list of known entity names.
     *
     * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
     *
     * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
     */ var KNOWN_ENTITY_NAMES = {
            amp: '&',
            lt: '<',
            gt: '>',
            quot: '"'
        };
        // IE 11 doesn't support `String.fromCodePoint`
        var fromCodePoint = String.fromCodePoint || String.fromCharCode;
        /**
     * Returns the text content of a given HTML source code string.
     *
     * @param {string} html
     * @returns {string}
     */ function textContent(html) {
            // remove all tags
            var text = html.replace(tagPattern, '');
            // decode known entities
            text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                code = code.toLowerCase();
                if (code[0] === '#') {
                    var value;
                    if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                    else value = Number(code.slice(1));
                    return fromCodePoint(value);
                } else {
                    var known = KNOWN_ENTITY_NAMES[code];
                    if (known) return known;
                    // unable to decode
                    return m;
                }
            });
            return text;
        }
        Prism.languages.md = Prism.languages.markdown;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$846ab470db2ff869$export$2e2bcd8739ae039.displayName = 'objectivec';
$846ab470db2ff869$export$2e2bcd8739ae039.aliases = [
    'objc'
];
function $846ab470db2ff869$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.objectivec = Prism.languages.extend('c', {
        string: {
            pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
        operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    });
    delete Prism.languages.objectivec['class-name'];
    Prism.languages.objc = Prism.languages.objectivec;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $380e029e8a782237$export$2e2bcd8739ae039.displayName = 'perl';
$380e029e8a782237$export$2e2bcd8739ae039.aliases = [];
function $380e029e8a782237$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var brackets = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
        Prism.languages.perl = {
            comment: [
                {
                    // POD
                    pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // TODO Could be nice to handle Heredoc too.
            string: [
                {
                    pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // q/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // q a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // q(...)
                        // q{...}
                        // q[...]
                        // q<...>
                        brackets
                    ].join('|') + ')'),
                    greedy: true
                },
                // "...", `...`
                {
                    pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
                    greedy: true
                },
                // '...'
                // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
                {
                    pattern: /'(?:[^'\\\r\n]|\\.)*'/,
                    greedy: true
                }
            ],
            regex: [
                {
                    pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // m/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // m a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // m(...)
                        // m{...}
                        // m[...]
                        // m<...>
                        brackets
                    ].join('|') + ')' + /[msixpodualngc]*/.source),
                    greedy: true
                },
                // The lookbehinds prevent -s from breaking
                {
                    pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // s/.../.../
                        // eslint-disable-next-line regexp/strict
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // s a...a...a
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                        // s(...)(...)
                        // s{...}{...}
                        // s[...][...]
                        // s<...><...>
                        // s(...)[...]
                        brackets + /\s*/.source + brackets
                    ].join('|') + ')' + /[msixpodualngcer]*/.source),
                    lookbehind: true,
                    greedy: true
                },
                // /.../
                // The look-ahead tries to prevent two divisions on
                // the same line from being highlighted as regex.
                // This does not support multi-line regex.
                {
                    pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
                    greedy: true
                }
            ],
            // FIXME Not sure about the handling of ::, ', and #
            variable: [
                // ${^POSTMATCH}
                /[&*$@%]\{\^[A-Z]+\}/,
                // $^V
                /[&*$@%]\^[A-Z_]/,
                // ${...}
                /[&*$@%]#?(?=\{)/,
                // $foo
                /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
                // $1
                /[&*$@%]\d+/,
                // $_, @_, %!
                // The negative lookahead prevents from breaking the %= operator
                /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
            ],
            filehandle: {
                // <>, <FOO>, _
                pattern: /<(?![<=])\S*?>|\b_\b/,
                alias: 'symbol'
            },
            'v-string': {
                // v1.2, 1.2.3
                pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
                alias: 'string'
            },
            function: {
                pattern: /(\bsub[ \t]+)\w+/,
                lookbehind: true
            },
            keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
            operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
            punctuation: /[{}[\];(),:]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$11b4f9d2b497fd4f$export$2e2bcd8739ae039.displayName = 'markup-templating';
$11b4f9d2b497fd4f$export$2e2bcd8739ae039.aliases = [];
function $11b4f9d2b497fd4f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Returns the placeholder for the given language id and index.
     *
     * @param {string} language
     * @param {string|number} index
     * @returns {string}
     */ function getPlaceholder(language, index) {
            return '___' + language.toUpperCase() + index + '___';
        }
        Object.defineProperties(Prism.languages['markup-templating'] = {}, {
            buildPlaceholders: {
                /**
         * Tokenize all inline templating expressions matching `placeholderPattern`.
         *
         * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
         * `true` will be replaced.
         *
         * @param {object} env The environment of the `before-tokenize` hook.
         * @param {string} language The language id.
         * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
         * @param {(match: string) => boolean} [replaceFilter]
         */ value: function(env, language, placeholderPattern, replaceFilter) {
                    if (env.language !== language) return;
                    var tokenStack = env.tokenStack = [];
                    env.code = env.code.replace(placeholderPattern, function(match) {
                        if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                        var i = tokenStack.length;
                        var placeholder;
                        // Check for existing strings
                        while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                        // Create a sparse array
                        tokenStack[i] = match;
                        return placeholder;
                    });
                    // Switch the grammar to markup
                    env.grammar = Prism.languages.markup;
                }
            },
            tokenizePlaceholders: {
                /**
         * Replace placeholders with proper tokens after tokenizing.
         *
         * @param {object} env The environment of the `after-tokenize` hook.
         * @param {string} language The language id.
         */ value: function(env, language) {
                    if (env.language !== language || !env.tokenStack) return;
                    // Switch the grammar back
                    env.grammar = Prism.languages[language];
                    var j = 0;
                    var keys = Object.keys(env.tokenStack);
                    function walkTokens(tokens) {
                        for(var i = 0; i < tokens.length; i++){
                            // all placeholders are replaced already
                            if (j >= keys.length) break;
                            var token = tokens[i];
                            if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                                var k = keys[j];
                                var t = env.tokenStack[k];
                                var s = typeof token === 'string' ? token : token.content;
                                var placeholder = getPlaceholder(language, k);
                                var index = s.indexOf(placeholder);
                                if (index > -1) {
                                    ++j;
                                    var before = s.substring(0, index);
                                    var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                                    var after = s.substring(index + placeholder.length);
                                    var replacement = [];
                                    if (before) replacement.push.apply(replacement, walkTokens([
                                        before
                                    ]));
                                    replacement.push(middle);
                                    if (after) replacement.push.apply(replacement, walkTokens([
                                        after
                                    ]));
                                    if (typeof token === 'string') tokens.splice.apply(tokens, [
                                        i,
                                        1
                                    ].concat(replacement));
                                    else token.content = replacement;
                                }
                            } else if (token.content /* && typeof token.content !== 'string' */ ) walkTokens(token.content);
                        }
                        return tokens;
                    }
                    walkTokens(env.tokens);
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$8a2c8b738cd1f636$export$2e2bcd8739ae039.displayName = 'php';
$8a2c8b738cd1f636$export$2e2bcd8739ae039.aliases = [];
function $8a2c8b738cd1f636$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
        var constant = [
            {
                pattern: /\b(?:false|true)\b/i,
                alias: 'boolean'
            },
            {
                pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
                greedy: true,
                lookbehind: true
            },
            /\b(?:null)\b/i,
            /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
        ];
        var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
        var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
        var punctuation = /[{}\[\](),:;]/;
        Prism.languages.php = {
            delimiter: {
                pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
                alias: 'important'
            },
            comment: comment,
            variable: /\$+(?:\w+\b|(?=\{))/,
            package: {
                pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            'class-name-definition': {
                pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            'function-definition': {
                pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
                lookbehind: true,
                alias: 'function'
            },
            keyword: [
                {
                    pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
                    alias: 'type-casting',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
                    alias: 'type-declaration',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    // yield from
                    pattern: /(\byield\s+)from\b/i,
                    lookbehind: true
                },
                // `class` is always a keyword unlike other keywords
                /\bclass\b/i,
                {
                    // https://www.php.net/manual/en/reserved.keywords.php
                    //
                    // keywords cannot be preceded by "->"
                    // the complex lookbehind means `(?<!(?:->|::)\s*)`
                    pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
                    lookbehind: true
                }
            ],
            'argument-name': {
                pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i,
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-declaration'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'static-context'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-hint'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'return-type'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                }
            ],
            constant: constant,
            function: {
                pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            property: {
                pattern: /(->\s*)\w+/,
                lookbehind: true
            },
            number: number,
            operator: operator,
            punctuation: punctuation
        };
        var string_interpolation = {
            pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
            lookbehind: true,
            inside: Prism.languages.php
        };
        var string = [
            {
                pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
                alias: 'nowdoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<'?|[';]$/
                        }
                    }
                }
            },
            {
                pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<"?|[";]$/
                        }
                    },
                    interpolation: string_interpolation
                }
            },
            {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                alias: 'backtick-quoted-string',
                greedy: true
            },
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                alias: 'single-quoted-string',
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                alias: 'double-quoted-string',
                greedy: true,
                inside: {
                    interpolation: string_interpolation
                }
            }
        ];
        Prism.languages.insertBefore('php', 'variable', {
            string: string,
            attribute: {
                pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
                greedy: true,
                inside: {
                    'attribute-content': {
                        pattern: /^(#\[)[\s\S]+(?=\]$)/,
                        lookbehind: true,
                        // inside can appear subset of php
                        inside: {
                            comment: comment,
                            string: string,
                            'attribute-class-name': [
                                {
                                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                                    alias: 'class-name',
                                    greedy: true,
                                    lookbehind: true
                                },
                                {
                                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                                    alias: [
                                        'class-name',
                                        'class-name-fully-qualified'
                                    ],
                                    greedy: true,
                                    lookbehind: true,
                                    inside: {
                                        punctuation: /\\/
                                    }
                                }
                            ],
                            constant: constant,
                            number: number,
                            operator: operator,
                            punctuation: punctuation
                        }
                    },
                    delimiter: {
                        pattern: /^#\[|\]$/,
                        alias: 'punctuation'
                    }
                }
            }
        });
        Prism.hooks.add('before-tokenize', function(env) {
            if (!/<\?/.test(env.code)) return;
            var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4c79b618a588b28d$export$2e2bcd8739ae039.displayName = 'python';
$4c79b618a588b28d$export$2e2bcd8739ae039.aliases = [
    'py'
];
function $4c79b618a588b28d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.python = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true,
            greedy: true
        },
        'string-interpolation': {
            pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
                interpolation: {
                    // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                    pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                    lookbehind: true,
                    inside: {
                        'format-spec': {
                            pattern: /(:)[^:(){}]+(?=\}$)/,
                            lookbehind: true
                        },
                        'conversion-option': {
                            pattern: /![sra](?=[:}]$)/,
                            alias: 'punctuation'
                        },
                        rest: null
                    }
                },
                string: /[\s\S]+/
            }
        },
        'triple-quoted-string': {
            pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
        },
        'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
        },
        decorator: {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
            lookbehind: true,
            alias: [
                'annotation',
                'punctuation'
            ],
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
    Prism.languages.py = Prism.languages.python;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $781e96ef45d1066d$export$2e2bcd8739ae039.displayName = 'r';
$781e96ef45d1066d$export$2e2bcd8739ae039.aliases = [];
function $781e96ef45d1066d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.r = {
        comment: /#.*/,
        string: {
            pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'percent-operator': {
            // Includes user-defined operators
            // and %%, %*%, %/%, %in%, %o%, %x%
            pattern: /%[^%\s]*%/,
            alias: 'operator'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        ellipsis: /\.\.(?:\.|\d+)/,
        number: [
            /\b(?:Inf|NaN)\b/,
            /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
        ],
        keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
        operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
        punctuation: /[(){}\[\],;]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0814f5761e025965$export$2e2bcd8739ae039.displayName = 'ruby';
$0814f5761e025965$export$2e2bcd8739ae039.aliases = [
    'rb'
];
function $0814f5761e025965$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.ruby = Prism.languages.extend('clike', {
            comment: {
                pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
                lookbehind: true,
                inside: {
                    punctuation: /[.\\]/
                }
            },
            keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
            operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
            punctuation: /[(){}[\].,;]/
        });
        Prism.languages.insertBefore('ruby', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        var interpolation = {
            pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
            lookbehind: true,
            inside: {
                content: {
                    pattern: /^(#\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                delimiter: {
                    pattern: /^#\{|\}$/,
                    alias: 'punctuation'
                }
            }
        };
        delete Prism.languages.ruby.function;
        var percentExpression = '(?:' + [
            /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
            /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
            /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
            /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
            /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
        ].join('|') + ')';
        var symbolName = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
        Prism.languages.insertBefore('ruby', 'keyword', {
            'regex-literal': [
                {
                    pattern: RegExp(/%r/.source + percentExpression + /[egimnosux]{0,6}/.source),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                },
                {
                    pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                }
            ],
            variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
            symbol: [
                {
                    pattern: RegExp(/(^|[^:]):/.source + symbolName),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: RegExp(/([\r\n{(,][ \t]*)/.source + symbolName + /(?=:(?!:))/.source),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'method-definition': {
                pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
                lookbehind: true,
                inside: {
                    function: /\b\w+$/,
                    keyword: /^self\b/,
                    'class-name': /^\w+/,
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('ruby', 'string', {
            'string-literal': [
                {
                    pattern: RegExp(/%[qQiIwWs]?/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?/
                            }
                        },
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?'|'$/
                            }
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            'command-literal': [
                {
                    pattern: RegExp(/%x/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                },
                {
                    pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                }
            ]
        });
        delete Prism.languages.ruby.string;
        Prism.languages.insertBefore('ruby', 'number', {
            builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
            constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
        });
        Prism.languages.rb = Prism.languages.ruby;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $27d87a17c8c1aaf3$export$2e2bcd8739ae039.displayName = 'rust';
$27d87a17c8c1aaf3$export$2e2bcd8739ae039.aliases = [];
function $27d87a17c8c1aaf3$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
        for(var i = 0; i < 2; i++)// support 4 levels of nested comments
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return multilineComment;
        });
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return /[^\s\S]/.source;
        });
        Prism.languages.rust = {
            comment: [
                {
                    pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            string: {
                pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
                greedy: true
            },
            char: {
                pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
                greedy: true
            },
            attribute: {
                pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
                greedy: true,
                alias: 'attr-name',
                inside: {
                    string: null // see below
                }
            },
            // Closure params should not be confused with bitwise OR |
            'closure-params': {
                pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'closure-punctuation': {
                        pattern: /^\||\|$/,
                        alias: 'punctuation'
                    },
                    rest: null // see below
                }
            },
            'lifetime-annotation': {
                pattern: /'\w+/,
                alias: 'symbol'
            },
            'fragment-specifier': {
                pattern: /(\$\w+:)[a-z]+/,
                lookbehind: true,
                alias: 'punctuation'
            },
            variable: /\$\w+/,
            'function-definition': {
                pattern: /(\bfn\s+)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            'type-definition': {
                pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
                lookbehind: true,
                alias: 'class-name'
            },
            'module-declaration': [
                {
                    pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                    lookbehind: true,
                    alias: 'namespace'
                },
                {
                    pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /::/
                    }
                }
            ],
            keyword: [
                // https://github.com/rust-lang/reference/blob/master/src/keywords.md
                /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
                // primitives and str
                // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
                /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
            ],
            // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
            // and Rust's naming conventions recommend snake_case anyway.
            // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
            macro: {
                pattern: /\b\w+!/,
                alias: 'property'
            },
            constant: /\b[A-Z_][A-Z_\d]+\b/,
            'class-name': /\b[A-Z]\w*\b/,
            namespace: {
                pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
                inside: {
                    punctuation: /::/
                }
            },
            // Hex, oct, bin, dec numbers with visual separators and type suffix
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
            operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
        };
        Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
        Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d4804f7e613d614f$export$2e2bcd8739ae039.displayName = 'sass';
$d4804f7e613d614f$export$2e2bcd8739ae039.aliases = [];
function $d4804f7e613d614f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.sass = Prism.languages.extend('css', {
            // Sass comments don't need to be closed, only indented
            comment: {
                pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
                lookbehind: true,
                greedy: true
            }
        });
        Prism.languages.insertBefore('sass', 'atrule', {
            // We want to consume the whole line
            'atrule-line': {
                // Includes support for = and + shortcuts
                pattern: /^(?:[ \t]*)[@+=].+/m,
                greedy: true,
                inside: {
                    atrule: /(?:@[\w-]+|[+=])/
                }
            }
        });
        delete Prism.languages.sass.atrule;
        var variable = /\$[-\w]+|#\{\$[-\w]+\}/;
        var operator = [
            /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
            {
                pattern: /(\s)-(?=\s)/,
                lookbehind: true
            }
        ];
        Prism.languages.insertBefore('sass', 'property', {
            // We want to consume the whole line
            'variable-line': {
                pattern: /^[ \t]*\$.+/m,
                greedy: true,
                inside: {
                    punctuation: /:/,
                    variable: variable,
                    operator: operator
                }
            },
            // We want to consume the whole line
            'property-line': {
                pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
                greedy: true,
                inside: {
                    property: [
                        /[^:\s]+(?=\s*:)/,
                        {
                            pattern: /(:)[^:\s]+/,
                            lookbehind: true
                        }
                    ],
                    punctuation: /:/,
                    variable: variable,
                    operator: operator,
                    important: Prism.languages.sass.important
                }
            }
        });
        delete Prism.languages.sass.property;
        delete Prism.languages.sass.important;
        // Now that whole lines for other patterns are consumed,
        // what's left should be selectors
        Prism.languages.insertBefore('sass', 'punctuation', {
            selector: {
                pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
                lookbehind: true,
                greedy: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$621160e6c15c3eff$export$2e2bcd8739ae039.displayName = 'scss';
$621160e6c15c3eff$export$2e2bcd8739ae039.aliases = [];
function $621160e6c15c3eff$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    Prism.languages.scss = Prism.languages.extend('css', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true
        },
        atrule: {
            pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
            inside: {
                rule: /@[\w-]+/
            }
        },
        // url, compassified
        url: /(?:[-a-z]+-)?url(?=\()/i,
        // CSS selector regex is not appropriate for Sass
        // since there can be lot more things (var, @ directive, nesting..)
        // a selector must start at the end of a property or after a brace (end of other rules or nesting)
        // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
        // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
        // can "pass" as a selector- e.g: proper#{$erty})
        // this one was hard to do, so please be careful if you edit this one :)
        selector: {
            // Initial look-ahead is used to prevent matching of blank selectors
            pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
            inside: {
                parent: {
                    pattern: /&/,
                    alias: 'important'
                },
                placeholder: /%[-\w]+/,
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        },
        property: {
            pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
            inside: {
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        }
    });
    Prism.languages.insertBefore('scss', 'atrule', {
        keyword: [
            /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
            {
                pattern: /( )(?:from|through)(?= )/,
                lookbehind: true
            }
        ]
    });
    Prism.languages.insertBefore('scss', 'important', {
        // var and interpolated vars
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
    });
    Prism.languages.insertBefore('scss', 'function', {
        'module-modifier': {
            pattern: /\b(?:as|hide|show|with)\b/i,
            alias: 'keyword'
        },
        placeholder: {
            pattern: /%[-\w]+/,
            alias: 'selector'
        },
        statement: {
            pattern: /\B!(?:default|optional)\b/i,
            alias: 'keyword'
        },
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        operator: {
            pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
            lookbehind: true
        }
    });
    Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $eb5bcdfed284c0e2$export$2e2bcd8739ae039.displayName = 'sql';
$eb5bcdfed284c0e2$export$2e2bcd8739ae039.aliases = [];
function $eb5bcdfed284c0e2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.sql = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
            lookbehind: true
        },
        variable: [
            {
                pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
                greedy: true
            },
            /@[\w.$]+/
        ],
        string: {
            pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
            greedy: true,
            lookbehind: true
        },
        identifier: {
            pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
            greedy: true,
            lookbehind: true,
            inside: {
                punctuation: /^`|`$/
            }
        },
        function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
        // Should we highlight user defined functions too?
        keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
        punctuation: /[;[\]()`,.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $10278687c497f16d$export$2e2bcd8739ae039.displayName = 'swift';
$10278687c497f16d$export$2e2bcd8739ae039.aliases = [];
function $10278687c497f16d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.swift = {
        comment: {
            // Nested comments are supported up to 2 levels
            pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
            lookbehind: true,
            greedy: true
        },
        'string-literal': [
            // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
            {
                pattern: RegExp(/(^|[^"#])/.source + '(?:' + // single-line string
                /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + // multi-line string
                /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\\($/,
                        alias: 'punctuation'
                    },
                    punctuation: /\\(?=[\r\n])/,
                    string: /[\s\S]+/
                }
            },
            {
                pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + // single-line string
                /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + // multi-line string
                /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\#+\($/,
                        alias: 'punctuation'
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        directive: {
            // directives with conditions
            pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + // This regex is a little complex. It's equivalent to this:
            //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
            // where <round> is a general parentheses expression.
            /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
            alias: 'property',
            inside: {
                'directive-name': /^#\w+/,
                boolean: /\b(?:false|true)\b/,
                number: /\b\d+(?:\.\d+)*\b/,
                operator: /!|&&|\|\||[<>]=?/,
                punctuation: /[(),]/
            }
        },
        literal: {
            pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
            alias: 'constant'
        },
        'other-directive': {
            pattern: /#\w+\b/,
            alias: 'property'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'atrule'
        },
        'function-definition': {
            pattern: /(\bfunc\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        label: {
            // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
            pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
            lookbehind: true,
            alias: 'important'
        },
        keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
        boolean: /\b(?:false|true)\b/,
        nil: {
            pattern: /\bnil\b/,
            alias: 'constant'
        },
        'short-argument': /\$\d+\b/,
        omit: {
            pattern: /\b_\b/,
            alias: 'keyword'
        },
        number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
        // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
        'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
        // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
        // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
        // This regex only supports ASCII operators.
        operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
        punctuation: /[{}[\]();,.:\\]/
    };
    Prism.languages.swift['string-literal'].forEach(function(rule) {
        rule.inside['interpolation'].inside = Prism.languages.swift;
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$010d7940936c67fb$export$2e2bcd8739ae039.displayName = 'typescript';
$010d7940936c67fb$export$2e2bcd8739ae039.aliases = [
    'ts'
];
function $010d7940936c67fb$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.typescript = Prism.languages.extend('javascript', {
            'class-name': {
                pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
        });
        // The keywords TypeScript adds to JavaScript
        Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/);
        // doesn't work with TS because TS is too complex
        delete Prism.languages.typescript['parameter'];
        delete Prism.languages.typescript['literal-property'];
        // a version of typescript specifically for highlighting types
        var typeInside = Prism.languages.extend('typescript', {});
        delete typeInside['class-name'];
        Prism.languages.typescript['class-name'].inside = typeInside;
        Prism.languages.insertBefore('typescript', 'function', {
            decorator: {
                pattern: /@[$\w\xA0-\uFFFF]+/,
                inside: {
                    at: {
                        pattern: /^@/,
                        alias: 'operator'
                    },
                    function: /^[\s\S]+/
                }
            },
            'generic-function': {
                // e.g. foo<T extends "bar" | "baz">( ...
                pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                greedy: true,
                inside: {
                    function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        // everything after the first <
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            }
        });
        Prism.languages.ts = Prism.languages.typescript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b245c95193e08d8c$export$2e2bcd8739ae039.displayName = 'basic';
$b245c95193e08d8c$export$2e2bcd8739ae039.aliases = [];
function $b245c95193e08d8c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.basic = {
        comment: {
            pattern: /(?:!|REM\b).+/i,
            inside: {
                keyword: /^REM/i
            }
        },
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
        function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
        operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
        punctuation: /[,;:()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$74f53190c8211cce$export$2e2bcd8739ae039.displayName = 'vbnet';
$74f53190c8211cce$export$2e2bcd8739ae039.aliases = [];
function $74f53190c8211cce$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $b245c95193e08d8c$export$2e2bcd8739ae039));
    Prism.languages.vbnet = Prism.languages.extend('basic', {
        comment: [
            {
                pattern: /(?:!|REM\b).+/i,
                inside: {
                    keyword: /^REM/i
                }
            },
            {
                pattern: /(^|[^\\:])'.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
        punctuation: /[,;:(){}]/
    });
}


/**
 * @import {Element, Root, Text} from 'hast'
 * @import {Grammar, Languages} from 'prismjs'
 */ /**
 * @typedef _Token
 *   Hidden Prism token.
 * @property {string} alias
 *   Alias.
 * @property {string} content
 *   Content.
 * @property {number} length
 *   Length.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef _Env
 *   Hidden Prism environment.
 * @property {Record<string, string>} attributes
 *   Attributes.
 * @property {Array<string>} classes
 *   Classes.
 * @property {Array<Element | Text> | Element | Text} content
 *   Content.
 * @property {string} language
 *   Language.
 * @property {string} tag
 *   Tag.
 * @property {string} type
 *   Type.
 */ /**
 * @typedef {((prism: Refractor) => undefined | void) & {aliases?: Array<string> | undefined, displayName: string}} Syntax
 *   Refractor syntax function.
 */ /**
 * @typedef Refractor
 *   Virtual syntax highlighting
 * @property {typeof alias} alias
 * @property {Languages} languages
 * @property {typeof listLanguages} listLanguages
 * @property {typeof highlight} highlight
 * @property {typeof registered} registered
 * @property {typeof register} register
 */ // Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
// Register the JSX namespace on `h`.
/**
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 */ // Register the JSX namespace on `s`.
/**
 * @typedef {import('./jsx-classic.js').Element} s.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} s.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} s.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} s.JSX.IntrinsicElements
 */ 
/**
 * @import {Element, Nodes, RootContent, Root} from 'hast'
 * @import {Info, Schema} from 'property-information'
 */ /**
 * @typedef {Array<Nodes | PrimitiveChild>} ArrayChildNested
 *   List of children (deep).
 */ /**
 * @typedef {Array<ArrayChildNested | Nodes | PrimitiveChild>} ArrayChild
 *   List of children.
 */ /**
 * @typedef {Array<number | string>} ArrayValue
 *   List of property values for space- or comma separated values (such as `className`).
 */ /**
 * @typedef {ArrayChild | Nodes | PrimitiveChild} Child
 *   Acceptable child value.
 */ /**
 * @typedef {number | string | null | undefined} PrimitiveChild
 *   Primitive children, either ignored (nullish), or turned into text nodes.
 */ /**
 * @typedef {boolean | number | string | null | undefined} PrimitiveValue
 *   Primitive property value.
 */ /**
 * @typedef {Record<string, PropertyValue | Style>} Properties
 *   Acceptable value for element properties.
 */ /**
 * @typedef {ArrayValue | PrimitiveValue} PropertyValue
 *   Primitive value or list value.
 */ /**
 * @typedef {Element | Root} Result
 *   Result from a `h` (or `s`) call.
 */ /**
 * @typedef {number | string} StyleValue
 *   Value for a CSS style field.
 */ /**
 * @typedef {Record<string, StyleValue>} Style
 *   Supported value of a `style` prop.
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 */ /**
 * @template {string} SimpleSelector
 *   Selector type.
 * @template {string} DefaultTagName
 *   Default tag name.
 * @typedef {(
 *   SimpleSelector extends ''
 *     ? DefaultTagName
 *     : SimpleSelector extends `${infer TagName}.${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends `${infer TagName}#${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends string
 *     ? SimpleSelector
 *     : DefaultTagName
 * )} ExtractTagName
 *   Extract tag name from a simple selector.
 */ const $3fdccad7db8388a7$var$search = /[#.]/g;
function $3fdccad7db8388a7$export$529769e360e2fa1b(selector, defaultTagName) {
    const value = selector || '';
    /** @type {Properties} */ const props = {};
    let start = 0;
    /** @type {string | undefined} */ let previous;
    /** @type {string | undefined} */ let tagName;
    while(start < value.length){
        $3fdccad7db8388a7$var$search.lastIndex = start;
        const match = $3fdccad7db8388a7$var$search.exec(value);
        const subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) tagName = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (Array.isArray(props.className)) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        // @ts-expect-error: tag name is parsed.
        tagName: tagName || defaultTagName || 'div',
        properties: props,
        children: []
    };
}




function $d415320c58bb27af$export$92ec6bcf7c3ee08c(schema, defaultTagName, caseSensitive) {
    const adjust = caseSensitive ? $d415320c58bb27af$var$createAdjustMap(caseSensitive) : undefined;
    /**
   * Hyperscript compatible DSL for creating virtual hast trees.
   *
   * @overload
   * @param {null | undefined} [selector]
   * @param {...Child} children
   * @returns {Root}
   *
   * @overload
   * @param {string} selector
   * @param {Properties} properties
   * @param {...Child} children
   * @returns {Element}
   *
   * @overload
   * @param {string} selector
   * @param {...Child} children
   * @returns {Element}
   *
   * @param {string | null | undefined} [selector]
   *   Selector.
   * @param {Child | Properties | null | undefined} [properties]
   *   Properties (or first child) (default: `undefined`).
   * @param {...Child} children
   *   Children.
   * @returns {Result}
   *   Result.
   */ function h(selector, properties, ...children) {
        /** @type {Result} */ let node;
        if (selector === null || selector === undefined) {
            node = {
                type: 'root',
                children: []
            };
            // Properties are not supported for roots.
            const child = /** @type {Child} */ properties;
            children.unshift(child);
        } else {
            node = (0, $3fdccad7db8388a7$export$529769e360e2fa1b)(selector, defaultTagName);
            // Normalize the name.
            const lower = node.tagName.toLowerCase();
            const adjusted = adjust ? adjust.get(lower) : undefined;
            node.tagName = adjusted || lower;
            // Handle properties.
            if ($d415320c58bb27af$var$isChild(properties)) children.unshift(properties);
            else for (const [key, value] of Object.entries(properties))$d415320c58bb27af$var$addProperty(schema, node.properties, key, value);
        }
        // Handle children.
        for (const child of children)$d415320c58bb27af$var$addChild(node.children, child);
        if (node.type === 'element' && node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    return h;
}
/**
 * Check if something is properties or a child.
 *
 * @param {Child | Properties} value
 *   Value to check.
 * @returns {value is Child}
 *   Whether `value` is definitely a child.
 */ function $d415320c58bb27af$var$isChild(value) {
    // Never properties if not an object.
    if (value === null || typeof value !== 'object' || Array.isArray(value)) return true;
    // Never node without `type`; that’s the main discriminator.
    if (typeof value.type !== 'string') return false;
    // Slower check: never property value if object or array with
    // non-number/strings.
    const record = /** @type {Record<string, unknown>} */ value;
    const keys = Object.keys(value);
    for (const key of keys){
        const value = record[key];
        if (value && typeof value === 'object') {
            if (!Array.isArray(value)) return true;
            const list = /** @type {ReadonlyArray<unknown>} */ value;
            for (const item of list){
                if (typeof item !== 'number' && typeof item !== 'string') return true;
            }
        }
    }
    // Also see empty `children` as a node.
    if ('children' in value && Array.isArray(value.children)) return true;
    // Default to properties, someone can always pass an empty object,
    // put `data: {}` in a node,
    // or wrap it in an array.
    return false;
}
/**
 * @param {Schema} schema
 *   Schema.
 * @param {Properties} properties
 *   Properties object.
 * @param {string} key
 *   Property name.
 * @param {PropertyValue | Style} value
 *   Property value.
 * @returns {undefined}
 *   Nothing.
 */ function $d415320c58bb27af$var$addProperty(schema, properties, key, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(schema, key);
    /** @type {PropertyValue} */ let result;
    // Ignore nullish and NaN values.
    if (value === null || value === undefined) return;
    if (typeof value === 'number') {
        // Ignore NaN.
        if (Number.isNaN(value)) return;
        result = value;
    } else if (typeof value === 'boolean') result = value;
    else if (typeof value === 'string') {
        if (info.spaceSeparated) result = (0, $0d98344a9bfa0653$export$98e6a39c04603d36)(value);
        else if (info.commaSeparated) result = (0, $9323934601145f2e$export$98e6a39c04603d36)(value);
        else if (info.commaOrSpaceSeparated) result = (0, $0d98344a9bfa0653$export$98e6a39c04603d36)((0, $9323934601145f2e$export$98e6a39c04603d36)(value).join(' '));
        else result = $d415320c58bb27af$var$parsePrimitive(info, info.property, value);
    } else if (Array.isArray(value)) result = [
        ...value
    ];
    else result = info.property === 'style' ? $d415320c58bb27af$var$style(value) : String(value);
    if (Array.isArray(result)) {
        /** @type {Array<number | string>} */ const finalResult = [];
        for (const item of result)// Assume no booleans in array.
        finalResult.push(/** @type {number | string} */ $d415320c58bb27af$var$parsePrimitive(info, info.property, item));
        result = finalResult;
    }
    // Class names (which can be added both on the `selector` and here).
    if (info.property === 'className' && Array.isArray(properties.className)) // Assume no booleans in `className`.
    result = properties.className.concat(/** @type {Array<number | string> | number | string} */ result);
    properties[info.property] = result;
}
/**
 * @param {Array<RootContent>} nodes
 *   Children.
 * @param {Child} value
 *   Child.
 * @returns {undefined}
 *   Nothing.
 */ function $d415320c58bb27af$var$addChild(nodes, value) {
    if (value === null || value === undefined) ;
    else if (typeof value === 'number' || typeof value === 'string') nodes.push({
        type: 'text',
        value: String(value)
    });
    else if (Array.isArray(value)) for (const child of value)$d415320c58bb27af$var$addChild(nodes, child);
    else if (typeof value === 'object' && 'type' in value) {
        if (value.type === 'root') $d415320c58bb27af$var$addChild(nodes, value.children);
        else nodes.push(value);
    } else throw new Error('Expected node, nodes, or string, got `' + value + '`');
}
/**
 * Parse a single primitives.
 *
 * @param {Info} info
 *   Property information.
 * @param {string} name
 *   Property name.
 * @param {PrimitiveValue} value
 *   Property value.
 * @returns {PrimitiveValue}
 *   Property value.
 */ function $d415320c58bb27af$var$parsePrimitive(info, name, value) {
    if (typeof value === 'string') {
        if (info.number && value && !Number.isNaN(Number(value))) return Number(value);
        if ((info.boolean || info.overloadedBoolean) && (value === '' || (0, $e193cc6bfb75f539$export$a3295358bff77e)(value) === (0, $e193cc6bfb75f539$export$a3295358bff77e)(name))) return true;
    }
    return value;
}
/**
 * Serialize a `style` object as a string.
 *
 * @param {Style} styles
 *   Style object.
 * @returns {string}
 *   CSS string.
 */ function $d415320c58bb27af$var$style(styles) {
    /** @type {Array<string>} */ const result = [];
    for (const [key, value] of Object.entries(styles))result.push([
        key,
        value
    ].join(': '));
    return result.join('; ');
}
/**
 * Create a map to adjust casing.
 *
 * @param {ReadonlyArray<string>} values
 *   List of properly cased keys.
 * @returns {Map<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */ function $d415320c58bb27af$var$createAdjustMap(values) {
    /** @type {Map<string, string>} */ const result = new Map();
    for (const value of values)result.set(value.toLowerCase(), value);
    return result;
}


/**
 * List of case-sensitive SVG tag names.
 *
 * @type {ReadonlyArray<string>}
 */ const $7f0a7850c17f5683$export$5ec6e4ea2f9364a1 = [
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'solidColor',
    'textArea',
    'textPath'
];


const $ef6b1b82ffb3458e$export$dda1d9f60106f0e9 = (0, $d415320c58bb27af$export$92ec6bcf7c3ee08c)((0, $cad208d20be39d74$export$c0bb0b647f701bb5), 'div');
const $ef6b1b82ffb3458e$export$2408f22a0fab9ae5 = (0, $d415320c58bb27af$export$92ec6bcf7c3ee08c)((0, $cad208d20be39d74$export$7ed1367e7fa1ad68), 'g', (0, $7f0a7850c17f5683$export$5ec6e4ea2f9364a1));


/**
 * @import {Point} from 'unist'
 * @import {Options} from '../index.js'
 */ /**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $9d441a8e4486a83e$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of invalid numeric character references to their replacements, according to HTML.
 *
 * @type {Record<number, string>}
 */ const $922953b77e46a921$export$18e663c9b25e3b2 = {
    0: "\uFFFD",
    128: "\u20AC",
    130: "\u201A",
    131: "\u0192",
    132: "\u201E",
    133: "\u2026",
    134: "\u2020",
    135: "\u2021",
    136: "\u02C6",
    137: "\u2030",
    138: "\u0160",
    139: "\u2039",
    140: "\u0152",
    142: "\u017D",
    145: "\u2018",
    146: "\u2019",
    147: "\u201C",
    148: "\u201D",
    149: "\u2022",
    150: "\u2013",
    151: "\u2014",
    152: "\u02DC",
    153: "\u2122",
    154: "\u0161",
    155: "\u203A",
    156: "\u0153",
    158: "\u017E",
    159: "\u0178"
};


/**
 * Check if the given character code, or the character code at the first
 * character, is decimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is a decimal
 */ function $be23405d8147b49a$export$2ad0182371401ea4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is hexadecimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is hexadecimal
 */ function $4ccc8a5f535bff43$export$8ec2d91f756e9f4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is alphabetical.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is alphabetical.
 */ function $cae77ff8c527c2d9$export$1e381e1de5ace8e(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}



function $7b67d5966946bfd3$export$176ed353558777b8(character) {
    return (0, $cae77ff8c527c2d9$export$1e381e1de5ace8e)(character) || (0, $be23405d8147b49a$export$2ad0182371401ea4)(character);
}



// Warning messages.
const $fe979033c71e7672$var$messages = [
    '',
    /* 1: Non terminated (named) */ 'Named character references must be terminated by a semicolon',
    /* 2: Non terminated (numeric) */ 'Numeric character references must be terminated by a semicolon',
    /* 3: Empty (named) */ 'Named character references cannot be empty',
    /* 4: Empty (numeric) */ 'Numeric character references cannot be empty',
    /* 5: Unknown (named) */ 'Named character references must be known',
    /* 6: Disallowed (numeric) */ 'Numeric character references cannot be disallowed',
    /* 7: Prohibited (numeric) */ 'Numeric character references cannot be outside the permissible Unicode range'
];
function $fe979033c71e7672$export$6c6c782be925911c(value, options) {
    const settings = options || {};
    const additional = typeof settings.additional === 'string' ? settings.additional.charCodeAt(0) : settings.additional;
    /** @type {Array<string>} */ const result = [];
    let index = 0;
    let lines = -1;
    let queue = '';
    /** @type {Point | undefined} */ let point;
    /** @type {Array<number>|undefined} */ let indent;
    if (settings.position) {
        if ('start' in settings.position || 'indent' in settings.position) {
            // @ts-expect-error: points don’t have indent.
            indent = settings.position.indent;
            // @ts-expect-error: points don’t have indent.
            point = settings.position.start;
        } else point = settings.position;
    }
    let line = (point ? point.line : 0) || 1;
    let column = (point ? point.column : 0) || 1;
    // Cache the current point.
    let previous = now();
    /** @type {number|undefined} */ let character;
    // Ensure the algorithm walks over the first character (inclusive).
    index--;
    while(++index <= value.length){
        // If the previous character was a newline.
        if (character === 10 /* `\n` */ ) column = (indent ? indent[lines] : 0) || 1;
        character = value.charCodeAt(index);
        if (character === 38 /* `&` */ ) {
            const following = value.charCodeAt(index + 1);
            // The behavior depends on the identity of the next character.
            if (following === 9 /* `\t` */  || following === 10 /* `\n` */  || following === 12 /* `\f` */  || following === 32 /* ` ` */  || following === 38 /* `&` */  || following === 60 /* `<` */  || Number.isNaN(following) || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += String.fromCharCode(character);
                column++;
                continue;
            }
            const start = index + 1;
            let begin = start;
            let end = start;
            /** @type {string} */ let type;
            if (following === 35 /* `#` */ ) {
                // Numerical reference.
                end = ++begin;
                // The behavior further depends on the next character.
                const following = value.charCodeAt(end);
                if (following === 88 /* `X` */  || following === 120 /* `x` */ ) {
                    // ASCII hexadecimal digits.
                    type = 'hexadecimal';
                    end = ++begin;
                } else // ASCII decimal digits.
                type = 'decimal';
            } else // Named reference.
            type = 'named';
            let characterReferenceCharacters = '';
            let characterReference = '';
            let characters = '';
            // Each type of character reference accepts different characters.
            // This test is used to detect whether a reference has ended (as the semicolon
            // is not strictly needed).
            const test = type === 'named' ? (0, $7b67d5966946bfd3$export$176ed353558777b8) : type === 'decimal' ? (0, $be23405d8147b49a$export$2ad0182371401ea4) : (0, $4ccc8a5f535bff43$export$8ec2d91f756e9f4);
            end--;
            while(++end <= value.length){
                const following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += String.fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === 'named' && (0, $9d441a8e4486a83e$export$9545335bdecb4b8c).includes(characters)) {
                    characterReferenceCharacters = characters;
                    // @ts-expect-error: always able to decode.
                    characterReference = (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(characters);
                }
            }
            let terminated = value.charCodeAt(end) === 59 /* `;` */ ;
            if (terminated) {
                end++;
                const namedReference = type === 'named' ? (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(characters) : false;
                if (namedReference) {
                    characterReferenceCharacters = characters;
                    characterReference = namedReference;
                }
            }
            let diff = 1 + end - start;
            let reference = '';
            if (!terminated && settings.nonTerminated === false) ;
            else if (!characters) // An empty (possible) reference is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== 'named') warning(4 /* Empty (numeric) */ , diff);
            } else if (type === 'named') {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !characterReference) warning(5 /* Unknown (named) */ , 1);
                else {
                    // If there’s something after an named reference which is not known,
                    // cap the reference.
                    if (characterReferenceCharacters !== characters) {
                        end = begin + characterReferenceCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        const reason = characterReferenceCharacters ? 1 /* Non terminated (named) */  : 3 /* Empty (named) */ ;
                        if (settings.attribute) {
                            const following = value.charCodeAt(end);
                            if (following === 61 /* `=` */ ) {
                                warning(reason, diff);
                                characterReference = '';
                            } else if ((0, $7b67d5966946bfd3$export$176ed353558777b8)(following)) characterReference = '';
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = characterReference;
            } else {
                if (!terminated) // All nonterminated numeric references are not rendered, and emit a
                // warning.
                warning(2 /* Non terminated (numeric) */ , diff);
                // When terminated and numerical, parse as either hexadecimal or
                // decimal.
                let referenceCode = Number.parseInt(characters, type === 'hexadecimal' ? 16 : 10);
                // Emit a warning when the parsed number is prohibited, and replace with
                // replacement character.
                if ($fe979033c71e7672$var$prohibited(referenceCode)) {
                    warning(7 /* Prohibited (numeric) */ , diff);
                    reference = String.fromCharCode(65533 /* `�` */ );
                } else if (referenceCode in (0, $922953b77e46a921$export$18e663c9b25e3b2)) {
                    // Emit a warning when the parsed number is disallowed, and replace by
                    // an alternative.
                    warning(6 /* Disallowed (numeric) */ , diff);
                    reference = (0, $922953b77e46a921$export$18e663c9b25e3b2)[referenceCode];
                } else {
                    // Parse the number.
                    let output = '';
                    // Emit a warning when the parsed number should not be used.
                    if ($fe979033c71e7672$var$disallowed(referenceCode)) warning(6 /* Disallowed (numeric) */ , diff);
                    // Serialize the number.
                    if (referenceCode > 0xffff) {
                        referenceCode -= 0x10000;
                        output += String.fromCharCode(referenceCode >>> 10 | 0xd800);
                        referenceCode = 0xdc00 | referenceCode & 0x3ff;
                    }
                    reference = output + String.fromCharCode(referenceCode);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat a reference.
            if (reference) {
                flush();
                previous = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                const next = now();
                next.offset++;
                if (settings.reference) settings.reference.call(settings.referenceContext || undefined, reference, {
                    start: previous,
                    end: next
                }, value.slice(start - 1, end));
                previous = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 /* `\n` */ ) {
                line++;
                lines++;
                column = 0;
            }
            if (Number.isNaN(character)) flush();
            else {
                queue += String.fromCharCode(character);
                column++;
            }
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + ((point ? point.offset : 0) || 0)
        };
    }
    /**
   * Handle the warning.
   *
   * @param {1|2|3|4|5|6|7} code
   * @param {number} offset
   */ function warning(code, offset) {
        /** @type {ReturnType<now>} */ let position;
        if (settings.warning) {
            position = now();
            position.column += offset;
            position.offset += offset;
            settings.warning.call(settings.warningContext || undefined, $fe979033c71e7672$var$messages[code], position, code);
        }
    }
    /**
   * Flush `queue` (normal text).
   * Macro invoked before each reference and at the end of `value`.
   * Does nothing when `queue` is empty.
   */ function flush() {
        if (queue) {
            result.push(queue);
            if (settings.text) settings.text.call(settings.textContext || undefined, queue, {
                start: previous,
                end: now()
            });
            queue = '';
        }
    }
}
/**
 * Check if `character` is outside the permissible unicode range.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $fe979033c71e7672$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
/**
 * Check if `character` is disallowed.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $fe979033c71e7672$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}


// @ts-nocheck
// This is a slimmed down version of `prism-core.js`, to remove globals,
// document, workers, `util.encode`, `Token.stringify`
// Private helper vars
var $7272cd95bfd5bc93$var$lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
var $7272cd95bfd5bc93$var$uniqueId = 0;
// The grammar object for plaintext
var $7272cd95bfd5bc93$var$plainTextGrammar = {};
var $7272cd95bfd5bc93$var$_ = {
    /**
   * A namespace for utility methods.
   *
   * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
   * change or disappear at any time.
   *
   * @namespace
   * @memberof Prism
   */ util: {
        /**
     * Returns the name of the type of the given value.
     *
     * @param {any} o
     * @returns {string}
     * @example
     * type(null)      === 'Null'
     * type(undefined) === 'Undefined'
     * type(123)       === 'Number'
     * type('foo')     === 'String'
     * type(true)      === 'Boolean'
     * type([1, 2])    === 'Array'
     * type({})        === 'Object'
     * type(String)    === 'Function'
     * type(/abc+/)    === 'RegExp'
     */ type: function(o) {
            return Object.prototype.toString.call(o).slice(8, -1);
        },
        /**
     * Returns a unique number for the given object. Later calls will still return the same number.
     *
     * @param {Object} obj
     * @returns {number}
     */ objId: function(obj) {
            if (!obj['__id']) Object.defineProperty(obj, '__id', {
                value: ++$7272cd95bfd5bc93$var$uniqueId
            });
            return obj['__id'];
        },
        /**
     * Creates a deep clone of the given object.
     *
     * The main intended use of this function is to clone language definitions.
     *
     * @param {T} o
     * @param {Record<number, any>} [visited]
     * @returns {T}
     * @template T
     */ clone: function deepClone(o, visited) {
            visited = visited || {};
            var clone;
            var id;
            switch($7272cd95bfd5bc93$var$_.util.type(o)){
                case 'Object':
                    id = $7272cd95bfd5bc93$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = /** @type {Record<string, any>} */ {};
                    visited[id] = clone;
                    for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                    return /** @type {any} */ clone;
                case 'Array':
                    id = $7272cd95bfd5bc93$var$_.util.objId(o);
                    if (visited[id]) return visited[id];
                    clone = [];
                    visited[id] = clone; /** @type {Array} */ 
                    /** @type {any} */ o.forEach(function(v, i) {
                        clone[i] = deepClone(v, visited);
                    });
                    return /** @type {any} */ clone;
                default:
                    return o;
            }
        }
    },
    /**
   * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
   *
   * @namespace
   * @memberof Prism
   * @public
   */ languages: {
        /**
     * The grammar for plain, unformatted text.
     */ plain: $7272cd95bfd5bc93$var$plainTextGrammar,
        plaintext: $7272cd95bfd5bc93$var$plainTextGrammar,
        text: $7272cd95bfd5bc93$var$plainTextGrammar,
        txt: $7272cd95bfd5bc93$var$plainTextGrammar,
        /**
     * Creates a deep copy of the language with the given id and appends the given tokens.
     *
     * If a token in `redef` also appears in the copied language, then the existing token in the copied language
     * will be overwritten at its original position.
     *
     * ## Best practices
     *
     * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
     * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
     * understand the language definition because, normally, the order of tokens matters in Prism grammars.
     *
     * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
     * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
     *
     * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
     * @param {Grammar} redef The new tokens to append.
     * @returns {Grammar} The new language created.
     * @public
     * @example
     * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
     *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
     *     // at its original position
     *     'comment': { ... },
     *     // CSS doesn't have a 'color' token, so this token will be appended
     *     'color': /\b(?:red|green|blue)\b/
     * });
     */ extend: function(id, redef) {
            var lang = $7272cd95bfd5bc93$var$_.util.clone($7272cd95bfd5bc93$var$_.languages[id]);
            for(var key in redef)lang[key] = redef[key];
            return lang;
        },
        /**
     * Inserts tokens _before_ another token in a language definition or any other grammar.
     *
     * ## Usage
     *
     * This helper method makes it easy to modify existing languages. For example, the CSS language definition
     * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
     * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
     * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
     * this:
     *
     * ```js
     * Prism.languages.markup.style = {
     *     // token
     * };
     * ```
     *
     * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
     * before existing tokens. For the CSS example above, you would use it like this:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'cdata', {
     *     'style': {
     *         // token
     *     }
     * });
     * ```
     *
     * ## Special cases
     *
     * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
     * will be ignored.
     *
     * This behavior can be used to insert tokens after `before`:
     *
     * ```js
     * Prism.languages.insertBefore('markup', 'comment', {
     *     'comment': Prism.languages.markup.comment,
     *     // tokens after 'comment'
     * });
     * ```
     *
     * ## Limitations
     *
     * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
     * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
     * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
     * deleting properties which is necessary to insert at arbitrary positions.
     *
     * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
     * Instead, it will create a new object and replace all references to the target object with the new one. This
     * can be done without temporarily deleting properties, so the iteration order is well-defined.
     *
     * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
     * you hold the target object in a variable, then the value of the variable will not change.
     *
     * ```js
     * var oldMarkup = Prism.languages.markup;
     * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
     *
     * assert(oldMarkup !== Prism.languages.markup);
     * assert(newMarkup === Prism.languages.markup);
     * ```
     *
     * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
     * object to be modified.
     * @param {string} before The key to insert before.
     * @param {Grammar} insert An object containing the key-value pairs to be inserted.
     * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
     * object to be modified.
     *
     * Defaults to `Prism.languages`.
     * @returns {Grammar} The new grammar object.
     * @public
     */ insertBefore: function(inside, before, insert, root) {
            root = root || /** @type {any} */ $7272cd95bfd5bc93$var$_.languages;
            var grammar = root[inside];
            /** @type {Grammar} */ var ret = {};
            for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                if (token == before) {
                    for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                }
                // Do not insert token which also occur in insert. See #1525
                if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
            }
            var old = root[inside];
            root[inside] = ret;
            // Update references in other language definitions
            $7272cd95bfd5bc93$var$_.languages.DFS($7272cd95bfd5bc93$var$_.languages, function(key, value) {
                if (value === old && key != inside) this[key] = ret;
            });
            return ret;
        },
        // Traverse a language definition with Depth First Search
        DFS: function DFS(o, callback, type, visited) {
            visited = visited || {};
            var objId = $7272cd95bfd5bc93$var$_.util.objId;
            for(var i in o)if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type || i);
                var property = o[i];
                var propertyType = $7272cd95bfd5bc93$var$_.util.type(property);
                if (propertyType === 'Object' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, null, visited);
                } else if (propertyType === 'Array' && !visited[objId(property)]) {
                    visited[objId(property)] = true;
                    DFS(property, callback, i, visited);
                }
            }
        }
    },
    plugins: {},
    /**
   * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
   * and the language definitions to use, and returns a string with the HTML produced.
   *
   * The following hooks will be run:
   * 1. `before-tokenize`
   * 2. `after-tokenize`
   * 3. `wrap`: On each {@link Token}.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @param {string} language The name of the language definition passed to `grammar`.
   * @returns {string} The highlighted HTML.
   * @memberof Prism
   * @public
   * @example
   * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
   */ highlight: function(text, grammar, language) {
        var env = {
            code: text,
            grammar: grammar,
            language: language
        };
        $7272cd95bfd5bc93$var$_.hooks.run('before-tokenize', env);
        if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
        env.tokens = $7272cd95bfd5bc93$var$_.tokenize(env.code, env.grammar);
        $7272cd95bfd5bc93$var$_.hooks.run('after-tokenize', env);
        return $7272cd95bfd5bc93$var$Token.stringify($7272cd95bfd5bc93$var$_.util.encode(env.tokens), env.language);
    },
    /**
   * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
   * and the language definitions to use, and returns an array with the tokenized code.
   *
   * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
   *
   * This method could be useful in other contexts as well, as a very crude parser.
   *
   * @param {string} text A string with the code to be highlighted.
   * @param {Grammar} grammar An object containing the tokens to use.
   *
   * Usually a language definition like `Prism.languages.markup`.
   * @returns {TokenStream} An array of strings and tokens, a token stream.
   * @memberof Prism
   * @public
   * @example
   * let code = `var foo = 0;`;
   * let tokens = Prism.tokenize(code, Prism.languages.javascript);
   * tokens.forEach(token => {
   *     if (token instanceof Prism.Token && token.type === 'number') {
   *         console.log(`Found numeric literal: ${token.content}`);
   *     }
   * });
   */ tokenize: function(text, grammar) {
        var rest = grammar.rest;
        if (rest) {
            for(var token in rest)grammar[token] = rest[token];
            delete grammar.rest;
        }
        var tokenList = new $7272cd95bfd5bc93$var$LinkedList();
        $7272cd95bfd5bc93$var$addAfter(tokenList, tokenList.head, text);
        $7272cd95bfd5bc93$var$matchGrammar(text, tokenList, grammar, tokenList.head, 0);
        return $7272cd95bfd5bc93$var$toArray(tokenList);
    },
    /**
   * @namespace
   * @memberof Prism
   * @public
   */ hooks: {
        all: {},
        /**
     * Adds the given callback to the list of callbacks for the given hook.
     *
     * The callback will be invoked when the hook it is registered for is run.
     * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
     *
     * One callback function can be registered to multiple hooks and the same hook multiple times.
     *
     * @param {string} name The name of the hook.
     * @param {HookCallback} callback The callback function which is given environment variables.
     * @public
     */ add: function(name, callback) {
            var hooks = $7272cd95bfd5bc93$var$_.hooks.all;
            hooks[name] = hooks[name] || [];
            hooks[name].push(callback);
        },
        /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */ run: function(name, env) {
            var callbacks = $7272cd95bfd5bc93$var$_.hooks.all[name];
            if (!callbacks || !callbacks.length) return;
            for(var i = 0, callback; callback = callbacks[i++];)callback(env);
        }
    },
    Token: $7272cd95bfd5bc93$var$Token
};
// Typescript note:
// The following can be used to import the Token type in JSDoc:
//
//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
/**
 * Creates a new token.
 *
 * @param {string} type See {@link Token#type type}
 * @param {string | TokenStream} content See {@link Token#content content}
 * @param {string|string[]} [alias] The alias(es) of the token.
 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
 * @class
 * @global
 * @public
 */ function $7272cd95bfd5bc93$var$Token(type, content, alias, matchedStr) {
    /**
   * The type of the token.
   *
   * This is usually the key of a pattern in a {@link Grammar}.
   *
   * @type {string}
   * @see GrammarToken
   * @public
   */ this.type = type;
    /**
   * The strings or tokens contained by this token.
   *
   * This will be a token stream if the pattern matched also defined an `inside` grammar.
   *
   * @type {string | TokenStream}
   * @public
   */ this.content = content;
    /**
   * The alias(es) of the token.
   *
   * @type {string|string[]}
   * @see GrammarToken
   * @public
   */ this.alias = alias;
    // Copy of the full string this token was created from
    this.length = (matchedStr || '').length | 0;
}
/**
 * A token stream is an array of strings and {@link Token Token} objects.
 *
 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
 * them.
 *
 * 1. No adjacent strings.
 * 2. No empty strings.
 *
 *    The only exception here is the token stream that only contains the empty string and nothing else.
 *
 * @typedef {Array<string | Token>} TokenStream
 * @global
 * @public
 */ /**
 * @param {RegExp} pattern
 * @param {number} pos
 * @param {string} text
 * @param {boolean} lookbehind
 * @returns {RegExpExecArray | null}
 */ function $7272cd95bfd5bc93$var$matchPattern(pattern, pos, text, lookbehind) {
    pattern.lastIndex = pos;
    var match = pattern.exec(text);
    if (match && lookbehind && match[1]) {
        // change the match to remove the text matched by the Prism lookbehind group
        var lookbehindLength = match[1].length;
        match.index += lookbehindLength;
        match[0] = match[0].slice(lookbehindLength);
    }
    return match;
}
/**
 * @param {string} text
 * @param {LinkedList<string | Token>} tokenList
 * @param {any} grammar
 * @param {LinkedListNode<string | Token>} startNode
 * @param {number} startPos
 * @param {RematchOptions} [rematch]
 * @returns {void}
 * @private
 *
 * @typedef RematchOptions
 * @property {string} cause
 * @property {number} reach
 */ function $7272cd95bfd5bc93$var$matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
    for(var token in grammar){
        if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
        var patterns = grammar[token];
        patterns = Array.isArray(patterns) ? patterns : [
            patterns
        ];
        for(var j = 0; j < patterns.length; ++j){
            if (rematch && rematch.cause == token + ',' + j) return;
            var patternObj = patterns[j];
            var inside = patternObj.inside;
            var lookbehind = !!patternObj.lookbehind;
            var greedy = !!patternObj.greedy;
            var alias = patternObj.alias;
            if (greedy && !patternObj.pattern.global) {
                // Without the global flag, lastIndex won't work
                var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
            }
            /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
            for(// iterate the token list and keep track of the current token/string position
            var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                if (rematch && pos >= rematch.reach) break;
                var str = currentNode.value;
                if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                return;
                if (str instanceof $7272cd95bfd5bc93$var$Token) continue;
                var removeCount = 1 // this is the to parameter of removeBetween
                ;
                var match;
                if (greedy) {
                    match = $7272cd95bfd5bc93$var$matchPattern(pattern, pos, text, lookbehind);
                    if (!match || match.index >= text.length) break;
                    var from = match.index;
                    var to = match.index + match[0].length;
                    var p = pos;
                    // find the node that contains the match
                    p += currentNode.value.length;
                    while(from >= p){
                        currentNode = currentNode.next;
                        p += currentNode.value.length;
                    }
                    // adjust pos (and p)
                    p -= currentNode.value.length;
                    pos = p;
                    // the current node is a Token, then the match starts inside another Token, which is invalid
                    if (currentNode.value instanceof $7272cd95bfd5bc93$var$Token) continue;
                    // find the last node which is affected by this match
                    for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                        removeCount++;
                        p += k.value.length;
                    }
                    removeCount--;
                    // replace with the new match
                    str = text.slice(pos, p);
                    match.index -= pos;
                } else {
                    match = $7272cd95bfd5bc93$var$matchPattern(pattern, 0, str, lookbehind);
                    if (!match) continue;
                }
                // eslint-disable-next-line no-redeclare
                var from = match.index;
                var matchStr = match[0];
                var before = str.slice(0, from);
                var after = str.slice(from + matchStr.length);
                var reach = pos + str.length;
                if (rematch && reach > rematch.reach) rematch.reach = reach;
                var removeFrom = currentNode.prev;
                if (before) {
                    removeFrom = $7272cd95bfd5bc93$var$addAfter(tokenList, removeFrom, before);
                    pos += before.length;
                }
                $7272cd95bfd5bc93$var$removeRange(tokenList, removeFrom, removeCount);
                var wrapped = new $7272cd95bfd5bc93$var$Token(token, inside ? $7272cd95bfd5bc93$var$_.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                currentNode = $7272cd95bfd5bc93$var$addAfter(tokenList, removeFrom, wrapped);
                if (after) $7272cd95bfd5bc93$var$addAfter(tokenList, currentNode, after);
                if (removeCount > 1) {
                    // at least one Token object was removed, so we have to do some rematching
                    // this can only happen if the current pattern is greedy
                    /** @type {RematchOptions} */ var nestedRematch = {
                        cause: token + ',' + j,
                        reach: reach
                    };
                    $7272cd95bfd5bc93$var$matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                    // the reach might have been extended because of the rematching
                    if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                }
            }
        }
    }
}
/**
 * @typedef LinkedListNode
 * @property {T} value
 * @property {LinkedListNode<T> | null} prev The previous node.
 * @property {LinkedListNode<T> | null} next The next node.
 * @template T
 * @private
 */ /**
 * @template T
 * @private
 */ function $7272cd95bfd5bc93$var$LinkedList() {
    /** @type {LinkedListNode<T>} */ var head = {
        value: null,
        prev: null,
        next: null
    };
    /** @type {LinkedListNode<T>} */ var tail = {
        value: null,
        prev: head,
        next: null
    };
    head.next = tail;
    /** @type {LinkedListNode<T>} */ this.head = head;
    /** @type {LinkedListNode<T>} */ this.tail = tail;
    this.length = 0;
}
/**
 * Adds a new node with the given value to the list.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {T} value
 * @returns {LinkedListNode<T>} The added node.
 * @template T
 */ function $7272cd95bfd5bc93$var$addAfter(list, node, value) {
    // assumes that node != list.tail && values.length >= 0
    var next = node.next;
    var newNode = {
        value: value,
        prev: node,
        next: next
    };
    node.next = newNode;
    next.prev = newNode;
    list.length++;
    return newNode;
}
/**
 * Removes `count` nodes after the given node. The given node will not be removed.
 *
 * @param {LinkedList<T>} list
 * @param {LinkedListNode<T>} node
 * @param {number} count
 * @template T
 */ function $7272cd95bfd5bc93$var$removeRange(list, node, count) {
    var next = node.next;
    for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
    node.next = next;
    next.prev = node;
    list.length -= i;
}
/**
 * @param {LinkedList<T>} list
 * @returns {T[]}
 * @template T
 */ function $7272cd95bfd5bc93$var$toArray(list) {
    var array = [];
    var node = list.head.next;
    while(node !== list.tail){
        array.push(node.value);
        node = node.next;
    }
    return array;
}
const $7272cd95bfd5bc93$export$dc7257ffb0972f87 = $7272cd95bfd5bc93$var$_;


// Inherit.
function $2c82f7cbfe622eb8$var$Refractor() {}
$2c82f7cbfe622eb8$var$Refractor.prototype = (0, $7272cd95bfd5bc93$export$dc7257ffb0972f87);
const $2c82f7cbfe622eb8$export$1c6435d0b8e9f390 = new $2c82f7cbfe622eb8$var$Refractor();
// Create.
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.highlight = $2c82f7cbfe622eb8$var$highlight;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.register = $2c82f7cbfe622eb8$var$register;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.alias = $2c82f7cbfe622eb8$var$alias;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.registered = $2c82f7cbfe622eb8$var$registered;
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.listLanguages = $2c82f7cbfe622eb8$var$listLanguages;
// @ts-expect-error Overwrite Prism.
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.util.encode = $2c82f7cbfe622eb8$var$encode;
// @ts-expect-error Overwrite Prism.
$2c82f7cbfe622eb8$export$1c6435d0b8e9f390.Token.stringify = $2c82f7cbfe622eb8$var$stringify;
/**
 * Highlight `value` (code) as `language` (programming language).
 *
 * @param {string} value
 *   Code to highlight.
 * @param {Grammar | string} language
 *   Programming language name, alias, or grammar.
 * @returns {Root}
 *   Node representing highlighted code.
 */ function $2c82f7cbfe622eb8$var$highlight(value, language) {
    if (typeof value !== 'string') throw new TypeError('Expected `string` for `value`, got `' + value + '`');
    /** @type {Grammar} */ let grammar;
    /** @type {string | undefined} */ let name;
    // `name` is a grammar object.
    // This was called internally by Prism.js before 1.28.0.
    /* c8 ignore next 2 */ if (language && typeof language === 'object') grammar = language;
    else {
        name = language;
        if (typeof name !== 'string') throw new TypeError('Expected `string` for `name`, got `' + name + '`');
        if (Object.hasOwn($2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages, name)) grammar = $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return {
        type: 'root',
        // @ts-expect-error: we hacked Prism to accept and return the things we want.
        children: (0, $7272cd95bfd5bc93$export$dc7257ffb0972f87).highlight.call($2c82f7cbfe622eb8$export$1c6435d0b8e9f390, value, grammar, name)
    };
}
/**
 * Register a syntax.
 *
 * @param {Syntax} syntax
 *   Language function made for refractor, as in, the files in
 *   `refractor/lang/*.js`.
 * @returns {undefined}
 *   Nothing.
 */ function $2c82f7cbfe622eb8$var$register(syntax) {
    if (typeof syntax !== 'function' || !syntax.displayName) throw new Error('Expected `function` for `syntax`, got `' + syntax + '`');
    // Do not duplicate registrations.
    if (!Object.hasOwn($2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages, syntax.displayName)) syntax($2c82f7cbfe622eb8$export$1c6435d0b8e9f390);
}
/**
 * Register aliases for already registered languages.
 *
 * @param {Record<string, ReadonlyArray<string> | string> | string} language
 *   Language to alias.
 * @param {ReadonlyArray<string> | string | null | undefined} [alias]
 *   Aliases.
 * @returns {undefined}
 *   Nothing.
 */ function $2c82f7cbfe622eb8$var$alias(language, alias) {
    const languages = $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages;
    /** @type {Record<string, ReadonlyArray<string> | string>} */ let map = {};
    if (typeof language === 'string') {
        if (alias) map[language] = alias;
    } else map = language;
    /** @type {string} */ let key;
    for(key in map)if (Object.hasOwn(map, key)) {
        const value = map[key];
        const list = typeof value === 'string' ? [
            value
        ] : value;
        let index = -1;
        while(++index < list.length)languages[list[index]] = languages[key];
    }
}
/**
 * Check whether an `alias` or `language` is registered.
 *
 * @param {string} aliasOrLanguage
 *   Language or alias to check.
 * @returns {boolean}
 *   Whether the language is registered.
 */ function $2c82f7cbfe622eb8$var$registered(aliasOrLanguage) {
    if (typeof aliasOrLanguage !== 'string') throw new TypeError('Expected `string` for `aliasOrLanguage`, got `' + aliasOrLanguage + '`');
    return Object.hasOwn($2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages, aliasOrLanguage);
}
/**
 * List all registered languages (names and aliases).
 *
 * @returns {Array<string>}
 *   List of language names.
 */ function $2c82f7cbfe622eb8$var$listLanguages() {
    const languages = $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.languages;
    /** @type {Array<string>} */ const list = [];
    /** @type {string} */ let language;
    for(language in languages)if (Object.hasOwn(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
/**
 * @param {Array<_Token | string> | _Token | string} value
 *   Token to stringify.
 * @param {string} language
 *   Language of the token.
 * @returns {Array<Element | Text> | Element | Text}
 *   Node representing the token.
 */ function $2c82f7cbfe622eb8$var$stringify(value, language) {
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if (Array.isArray(value)) {
        /** @type {Array<Element | Text>} */ const result = [];
        let index = -1;
        while(++index < value.length)if (value[index] !== null && value[index] !== undefined && value[index] !== '') // Cast because we assume no sub-arrays.
        result.push(/** @type {Element | Text} */ $2c82f7cbfe622eb8$var$stringify(value[index], language));
        return result;
    }
    /** @type {_Env} */ const env = {
        attributes: {},
        classes: [
            'token',
            value.type
        ],
        content: $2c82f7cbfe622eb8$var$stringify(value.content, language),
        language: language,
        tag: 'span',
        type: value.type
    };
    if (value.alias) env.classes.push(...typeof value.alias === 'string' ? [
        value.alias
    ] : value.alias);
    // @ts-expect-error Prism.
    $2c82f7cbfe622eb8$export$1c6435d0b8e9f390.hooks.run('wrap', env);
    return (0, $ef6b1b82ffb3458e$export$dda1d9f60106f0e9)(env.tag + '.' + env.classes.join('.'), $2c82f7cbfe622eb8$var$attributes(env.attributes), env.content);
}
/**
 * @template {unknown} T
 *   Tokens.
 * @param {T} tokens
 *   Input.
 * @returns {T}
 *   Output, same as input.
 */ function $2c82f7cbfe622eb8$var$encode(tokens) {
    return tokens;
}
/**
 * @param {Record<string, string>} record
 *   Attributes.
 * @returns {Record<string, string>}
 *   Attributes.
 */ function $2c82f7cbfe622eb8$var$attributes(record) {
    /** @type {string} */ let key;
    for(key in record)if (Object.hasOwn(record, key)) record[key] = (0, $fe979033c71e7672$export$6c6c782be925911c)(record[key]);
    return record;
}


(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4fe2e947cede365f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8bc35bfd2be6822a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $803928922a6961a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f47682e33a093951$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dab2950de0f638d9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1c0f2e453947e61a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $197381b2d5f39c0b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c029552e57eb42d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $edb8a8bbc6c61935$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f3a5ce20fdab9e50$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $20b8caf8b024dc15$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23da19d9f15297a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1da2260b608e55ec$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ee5893254ac9a415$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $846ab470db2ff869$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $380e029e8a782237$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4c79b618a588b28d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $781e96ef45d1066d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0814f5761e025965$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $27d87a17c8c1aaf3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d4804f7e613d614f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $621160e6c15c3eff$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $10278687c497f16d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b245c95193e08d8c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $74f53190c8211cce$export$2e2bcd8739ae039));


/**
 * @typedef {import('./core.js').Syntax} Syntax
 */ 




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $95ea2c9bcdd7f611$export$2e2bcd8739ae039.displayName = 'abap';
$95ea2c9bcdd7f611$export$2e2bcd8739ae039.aliases = [];
function $95ea2c9bcdd7f611$export$2e2bcd8739ae039(Prism) {
    Prism.languages.abap = {
        comment: /^\*.*/m,
        string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'string-template': {
            pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
            lookbehind: true,
            alias: 'string'
        },
        /* End Of Line comments should not interfere with strings when the
quote character occurs within them. We assume a string being highlighted
inside an EOL comment is more acceptable than the opposite.
*/ 'eol-comment': {
            pattern: /(^|\s)".*/m,
            lookbehind: true,
            alias: 'comment'
        },
        keyword: {
            pattern: /(\s|\.|^)(?:\*-INPUT|\?TO|ABAP-SOURCE|ABBREVIATED|ABS|ABSTRACT|ACCEPT|ACCEPTING|ACCESSPOLICY|ACCORDING|ACOS|ACTIVATION|ACTUAL|ADD|ADD-CORRESPONDING|ADJACENT|AFTER|ALIAS|ALIASES|ALIGN|ALL|ALLOCATE|ALPHA|ANALYSIS|ANALYZER|AND|ANY|APPEND|APPENDAGE|APPENDING|APPLICATION|ARCHIVE|AREA|ARITHMETIC|AS|ASCENDING|ASIN|ASPECT|ASSERT|ASSIGN|ASSIGNED|ASSIGNING|ASSOCIATION|ASYNCHRONOUS|AT|ATAN|ATTRIBUTES|AUTHORITY|AUTHORITY-CHECK|AVG|BACK|BACKGROUND|BACKUP|BACKWARD|BADI|BASE|BEFORE|BEGIN|BETWEEN|BIG|BINARY|BINDING|BIT|BIT-AND|BIT-NOT|BIT-OR|BIT-XOR|BLACK|BLANK|BLANKS|BLOB|BLOCK|BLOCKS|BLUE|BOUND|BOUNDARIES|BOUNDS|BOXED|BREAK-POINT|BT|BUFFER|BY|BYPASSING|BYTE|BYTE-CA|BYTE-CN|BYTE-CO|BYTE-CS|BYTE-NA|BYTE-NS|BYTE-ORDER|C|CA|CALL|CALLING|CASE|CAST|CASTING|CATCH|CEIL|CENTER|CENTERED|CHAIN|CHAIN-INPUT|CHAIN-REQUEST|CHANGE|CHANGING|CHANNELS|CHAR-TO-HEX|CHARACTER|CHARLEN|CHECK|CHECKBOX|CIRCULAR|CI_|CLASS|CLASS-CODING|CLASS-DATA|CLASS-EVENTS|CLASS-METHODS|CLASS-POOL|CLEANUP|CLEAR|CLIENT|CLOB|CLOCK|CLOSE|CN|CNT|CO|COALESCE|CODE|CODING|COLLECT|COLOR|COLUMN|COLUMNS|COL_BACKGROUND|COL_GROUP|COL_HEADING|COL_KEY|COL_NEGATIVE|COL_NORMAL|COL_POSITIVE|COL_TOTAL|COMMENT|COMMENTS|COMMIT|COMMON|COMMUNICATION|COMPARING|COMPONENT|COMPONENTS|COMPRESSION|COMPUTE|CONCAT|CONCATENATE|COND|CONDENSE|CONDITION|CONNECT|CONNECTION|CONSTANTS|CONTEXT|CONTEXTS|CONTINUE|CONTROL|CONTROLS|CONV|CONVERSION|CONVERT|COPIES|COPY|CORRESPONDING|COS|COSH|COUNT|COUNTRY|COVER|CP|CPI|CREATE|CREATING|CRITICAL|CS|CURRENCY|CURRENCY_CONVERSION|CURRENT|CURSOR|CURSOR-SELECTION|CUSTOMER|CUSTOMER-FUNCTION|DANGEROUS|DATA|DATABASE|DATAINFO|DATASET|DATE|DAYLIGHT|DBMAXLEN|DD\/MM\/YY|DD\/MM\/YYYY|DDMMYY|DEALLOCATE|DECIMALS|DECIMAL_SHIFT|DECLARATIONS|DEEP|DEFAULT|DEFERRED|DEFINE|DEFINING|DEFINITION|DELETE|DELETING|DEMAND|DEPARTMENT|DESCENDING|DESCRIBE|DESTINATION|DETAIL|DIALOG|DIRECTORY|DISCONNECT|DISPLAY|DISPLAY-MODE|DISTANCE|DISTINCT|DIV|DIVIDE|DIVIDE-CORRESPONDING|DIVISION|DO|DUMMY|DUPLICATE|DUPLICATES|DURATION|DURING|DYNAMIC|DYNPRO|E|EACH|EDIT|EDITOR-CALL|ELSE|ELSEIF|EMPTY|ENABLED|ENABLING|ENCODING|END|END-ENHANCEMENT-SECTION|END-LINES|END-OF-DEFINITION|END-OF-FILE|END-OF-PAGE|END-OF-SELECTION|ENDAT|ENDCASE|ENDCATCH|ENDCHAIN|ENDCLASS|ENDDO|ENDENHANCEMENT|ENDEXEC|ENDFOR|ENDFORM|ENDFUNCTION|ENDIAN|ENDIF|ENDING|ENDINTERFACE|ENDLOOP|ENDMETHOD|ENDMODULE|ENDON|ENDPROVIDE|ENDSELECT|ENDTRY|ENDWHILE|ENGINEERING|ENHANCEMENT|ENHANCEMENT-POINT|ENHANCEMENT-SECTION|ENHANCEMENTS|ENTRIES|ENTRY|ENVIRONMENT|EQ|EQUAL|EQUIV|ERRORMESSAGE|ERRORS|ESCAPE|ESCAPING|EVENT|EVENTS|EXACT|EXCEPT|EXCEPTION|EXCEPTION-TABLE|EXCEPTIONS|EXCLUDE|EXCLUDING|EXEC|EXECUTE|EXISTS|EXIT|EXIT-COMMAND|EXP|EXPAND|EXPANDING|EXPIRATION|EXPLICIT|EXPONENT|EXPORT|EXPORTING|EXTEND|EXTENDED|EXTENSION|EXTRACT|FAIL|FETCH|FIELD|FIELD-GROUPS|FIELD-SYMBOL|FIELD-SYMBOLS|FIELDS|FILE|FILTER|FILTER-TABLE|FILTERS|FINAL|FIND|FIRST|FIRST-LINE|FIXED-POINT|FKEQ|FKGE|FLOOR|FLUSH|FONT|FOR|FORM|FORMAT|FORWARD|FOUND|FRAC|FRAME|FRAMES|FREE|FRIENDS|FROM|FUNCTION|FUNCTION-POOL|FUNCTIONALITY|FURTHER|GAPS|GE|GENERATE|GET|GIVING|GKEQ|GKGE|GLOBAL|GRANT|GREATER|GREEN|GROUP|GROUPS|GT|HANDLE|HANDLER|HARMLESS|HASHED|HAVING|HDB|HEAD-LINES|HEADER|HEADERS|HEADING|HELP-ID|HELP-REQUEST|HIDE|HIGH|HINT|HOLD|HOTSPOT|I|ICON|ID|IDENTIFICATION|IDENTIFIER|IDS|IF|IGNORE|IGNORING|IMMEDIATELY|IMPLEMENTATION|IMPLEMENTATIONS|IMPLEMENTED|IMPLICIT|IMPORT|IMPORTING|IN|INACTIVE|INCL|INCLUDE|INCLUDES|INCLUDING|INCREMENT|INDEX|INDEX-LINE|INFOTYPES|INHERITING|INIT|INITIAL|INITIALIZATION|INNER|INOUT|INPUT|INSERT|INSTANCES|INTENSIFIED|INTERFACE|INTERFACE-POOL|INTERFACES|INTERNAL|INTERVALS|INTO|INVERSE|INVERTED-DATE|IS|ISO|ITERATOR|ITNO|JOB|JOIN|KEEP|KEEPING|KERNEL|KEY|KEYS|KEYWORDS|KIND|LANGUAGE|LAST|LATE|LAYOUT|LE|LEADING|LEAVE|LEFT|LEFT-JUSTIFIED|LEFTPLUS|LEFTSPACE|LEGACY|LENGTH|LESS|LET|LEVEL|LEVELS|LIKE|LINE|LINE-COUNT|LINE-SELECTION|LINE-SIZE|LINEFEED|LINES|LIST|LIST-PROCESSING|LISTBOX|LITTLE|LLANG|LOAD|LOAD-OF-PROGRAM|LOB|LOCAL|LOCALE|LOCATOR|LOG|LOG-POINT|LOG10|LOGFILE|LOGICAL|LONG|LOOP|LOW|LOWER|LPAD|LPI|LT|M|MAIL|MAIN|MAJOR-ID|MAPPING|MARGIN|MARK|MASK|MATCH|MATCHCODE|MAX|MAXIMUM|MEDIUM|MEMBERS|MEMORY|MESH|MESSAGE|MESSAGE-ID|MESSAGES|MESSAGING|METHOD|METHODS|MIN|MINIMUM|MINOR-ID|MM\/DD\/YY|MM\/DD\/YYYY|MMDDYY|MOD|MODE|MODIF|MODIFIER|MODIFY|MODULE|MOVE|MOVE-CORRESPONDING|MULTIPLY|MULTIPLY-CORRESPONDING|NA|NAME|NAMETAB|NATIVE|NB|NE|NESTED|NESTING|NEW|NEW-LINE|NEW-PAGE|NEW-SECTION|NEXT|NO|NO-DISPLAY|NO-EXTENSION|NO-GAP|NO-GAPS|NO-GROUPING|NO-HEADING|NO-SCROLLING|NO-SIGN|NO-TITLE|NO-TOPOFPAGE|NO-ZERO|NODE|NODES|NON-UNICODE|NON-UNIQUE|NOT|NP|NS|NULL|NUMBER|NUMOFCHAR|O|OBJECT|OBJECTS|OBLIGATORY|OCCURRENCE|OCCURRENCES|OCCURS|OF|OFF|OFFSET|OLE|ON|ONLY|OPEN|OPTION|OPTIONAL|OPTIONS|OR|ORDER|OTHER|OTHERS|OUT|OUTER|OUTPUT|OUTPUT-LENGTH|OVERFLOW|OVERLAY|PACK|PACKAGE|PAD|PADDING|PAGE|PAGES|PARAMETER|PARAMETER-TABLE|PARAMETERS|PART|PARTIALLY|PATTERN|PERCENTAGE|PERFORM|PERFORMING|PERSON|PF|PF-STATUS|PINK|PLACES|POOL|POSITION|POS_HIGH|POS_LOW|PRAGMAS|PRECOMPILED|PREFERRED|PRESERVING|PRIMARY|PRINT|PRINT-CONTROL|PRIORITY|PRIVATE|PROCEDURE|PROCESS|PROGRAM|PROPERTY|PROTECTED|PROVIDE|PUBLIC|PUSHBUTTON|PUT|QUEUE-ONLY|QUICKINFO|RADIOBUTTON|RAISE|RAISING|RANGE|RANGES|RAW|READ|READ-ONLY|READER|RECEIVE|RECEIVED|RECEIVER|RECEIVING|RED|REDEFINITION|REDUCE|REDUCED|REF|REFERENCE|REFRESH|REGEX|REJECT|REMOTE|RENAMING|REPLACE|REPLACEMENT|REPLACING|REPORT|REQUEST|REQUESTED|RESERVE|RESET|RESOLUTION|RESPECTING|RESPONSIBLE|RESULT|RESULTS|RESUMABLE|RESUME|RETRY|RETURN|RETURNCODE|RETURNING|RIGHT|RIGHT-JUSTIFIED|RIGHTPLUS|RIGHTSPACE|RISK|RMC_COMMUNICATION_FAILURE|RMC_INVALID_STATUS|RMC_SYSTEM_FAILURE|ROLE|ROLLBACK|ROUND|ROWS|RTTI|RUN|SAP|SAP-SPOOL|SAVING|SCALE_PRESERVING|SCALE_PRESERVING_SCIENTIFIC|SCAN|SCIENTIFIC|SCIENTIFIC_WITH_LEADING_ZERO|SCREEN|SCROLL|SCROLL-BOUNDARY|SCROLLING|SEARCH|SECONDARY|SECONDS|SECTION|SELECT|SELECT-OPTIONS|SELECTION|SELECTION-SCREEN|SELECTION-SET|SELECTION-SETS|SELECTION-TABLE|SELECTIONS|SELECTOR|SEND|SEPARATE|SEPARATED|SET|SHARED|SHIFT|SHORT|SHORTDUMP-ID|SIGN|SIGN_AS_POSTFIX|SIMPLE|SIN|SINGLE|SINH|SIZE|SKIP|SKIPPING|SMART|SOME|SORT|SORTABLE|SORTED|SOURCE|SPACE|SPECIFIED|SPLIT|SPOOL|SPOTS|SQL|SQLSCRIPT|SQRT|STABLE|STAMP|STANDARD|START-OF-SELECTION|STARTING|STATE|STATEMENT|STATEMENTS|STATIC|STATICS|STATUSINFO|STEP-LOOP|STOP|STRLEN|STRUCTURE|STRUCTURES|STYLE|SUBKEY|SUBMATCHES|SUBMIT|SUBROUTINE|SUBSCREEN|SUBSTRING|SUBTRACT|SUBTRACT-CORRESPONDING|SUFFIX|SUM|SUMMARY|SUMMING|SUPPLIED|SUPPLY|SUPPRESS|SWITCH|SWITCHSTATES|SYMBOL|SYNCPOINTS|SYNTAX|SYNTAX-CHECK|SYNTAX-TRACE|SYSTEM-CALL|SYSTEM-EXCEPTIONS|SYSTEM-EXIT|TAB|TABBED|TABLE|TABLES|TABLEVIEW|TABSTRIP|TAN|TANH|TARGET|TASK|TASKS|TEST|TESTING|TEXT|TEXTPOOL|THEN|THROW|TIME|TIMES|TIMESTAMP|TIMEZONE|TITLE|TITLE-LINES|TITLEBAR|TO|TOKENIZATION|TOKENS|TOP-LINES|TOP-OF-PAGE|TRACE-FILE|TRACE-TABLE|TRAILING|TRANSACTION|TRANSFER|TRANSFORMATION|TRANSLATE|TRANSPORTING|TRMAC|TRUNC|TRUNCATE|TRUNCATION|TRY|TYPE|TYPE-POOL|TYPE-POOLS|TYPES|ULINE|UNASSIGN|UNDER|UNICODE|UNION|UNIQUE|UNIT|UNIT_CONVERSION|UNIX|UNPACK|UNTIL|UNWIND|UP|UPDATE|UPPER|USER|USER-COMMAND|USING|UTF-8|VALID|VALUE|VALUE-REQUEST|VALUES|VARY|VARYING|VERIFICATION-MESSAGE|VERSION|VIA|VIEW|VISIBLE|WAIT|WARNING|WHEN|WHENEVER|WHERE|WHILE|WIDTH|WINDOW|WINDOWS|WITH|WITH-HEADING|WITH-TITLE|WITHOUT|WORD|WORK|WRITE|WRITER|X|XML|XOR|XSD|XSTRLEN|YELLOW|YES|YYMMDD|Z|ZERO|ZONE)(?![\w-])/i,
            lookbehind: true
        },
        /* Numbers can be only integers. Decimal or Hex appear only as strings */ number: /\b\d+\b/,
        /* Operators must always be surrounded by whitespace, they cannot be put
adjacent to operands.
*/ operator: {
            pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
            lookbehind: true
        },
        'string-operator': {
            pattern: /(\s)&&?(?=\s)/,
            lookbehind: true,
            /* The official editor highlights */ alias: 'keyword'
        },
        'token-operator': [
            {
                /* Special operators used to access structure components, class methods/attributes, etc. */ pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            {
                /* Special tokens used do delimit string templates */ pattern: /[|{}]/,
                alias: 'punctuation'
            }
        ],
        punctuation: /[,.:()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c4d1e2daa7d84c8b$export$2e2bcd8739ae039.displayName = 'abnf';
$c4d1e2daa7d84c8b$export$2e2bcd8739ae039.aliases = [];
function $c4d1e2daa7d84c8b$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var coreRules = '(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)';
        Prism.languages.abnf = {
            comment: /;.*/,
            string: {
                pattern: /(?:%[is])?"[^"\n\r]*"/,
                greedy: true,
                inside: {
                    punctuation: /^%[is]/
                }
            },
            range: {
                pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
                alias: 'number'
            },
            terminal: {
                pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
                alias: 'number'
            },
            repetition: {
                pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
                lookbehind: true,
                alias: 'operator'
            },
            definition: {
                pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
                lookbehind: true,
                alias: 'keyword',
                inside: {
                    punctuation: /<|>/
                }
            },
            'core-rule': {
                pattern: RegExp('(?:(^|[^<\\w-])' + coreRules + '|<' + coreRules + '>)(?![\\w-])', 'i'),
                lookbehind: true,
                alias: [
                    'rule',
                    'constant'
                ],
                inside: {
                    punctuation: /<|>/
                }
            },
            rule: {
                pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
                lookbehind: true,
                inside: {
                    punctuation: /<|>/
                }
            },
            operator: /=\/?|\//,
            punctuation: /[()\[\]]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0a13ac6a7fcf6722$export$2e2bcd8739ae039.displayName = 'actionscript';
$0a13ac6a7fcf6722$export$2e2bcd8739ae039.aliases = [];
function $0a13ac6a7fcf6722$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.languages.actionscript = Prism.languages.extend('javascript', {
        keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
        operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    });
    Prism.languages.actionscript['class-name'].alias = 'function';
    // doesn't work with AS because AS is too complex
    delete Prism.languages.actionscript['parameter'];
    delete Prism.languages.actionscript['literal-property'];
    if (Prism.languages.markup) Prism.languages.insertBefore('actionscript', 'string', {
        xml: {
            pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
            lookbehind: true,
            inside: Prism.languages.markup
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f7f5127772c5c04e$export$2e2bcd8739ae039.displayName = 'ada';
$f7f5127772c5c04e$export$2e2bcd8739ae039.aliases = [];
function $f7f5127772c5c04e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ada = {
        comment: /--.*/,
        string: /"(?:""|[^"\r\f\n])*"/,
        number: [
            {
                pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
            },
            {
                pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
            }
        ],
        attribute: {
            pattern: /\b'\w+/,
            alias: 'attr-name'
        },
        keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|or|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
        boolean: /\b(?:false|true)\b/i,
        operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
        punctuation: /\.\.?|[,;():]/,
        char: /'.'/,
        variable: /\b[a-z](?:\w)*\b/i
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $64a4add7c0be4a61$export$2e2bcd8739ae039.displayName = 'agda';
$64a4add7c0be4a61$export$2e2bcd8739ae039.aliases = [];
function $64a4add7c0be4a61$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.agda = {
            comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
            string: {
                pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
                greedy: true
            },
            punctuation: /[(){}⦃⦄.;@]/,
            'class-name': {
                pattern: /((?:data|record) +)\S+/,
                lookbehind: true
            },
            function: {
                pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
                lookbehind: true
            },
            operator: {
                pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
                lookbehind: true
            },
            keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $99775d8f376cb002$export$2e2bcd8739ae039.displayName = 'al';
$99775d8f376cb002$export$2e2bcd8739ae039.aliases = [];
function $99775d8f376cb002$export$2e2bcd8739ae039(Prism) {
    // based on https://github.com/microsoft/AL/blob/master/grammar/alsyntax.tmlanguage
    Prism.languages.al = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        function: {
            pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
            lookbehind: true
        },
        keyword: [
            // keywords
            /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
            // objects and metadata that are used like keywords
            /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
        ],
        number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
        boolean: /\b(?:false|true)\b/i,
        variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
        'class-name': /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
        operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
        punctuation: /[()\[\]{}:.;,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f2801efe566f5e02$export$2e2bcd8739ae039.displayName = 'antlr4';
$f2801efe566f5e02$export$2e2bcd8739ae039.aliases = [
    'g4'
];
function $f2801efe566f5e02$export$2e2bcd8739ae039(Prism) {
    Prism.languages.antlr4 = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        string: {
            pattern: /'(?:\\.|[^\\'\r\n])*'/,
            greedy: true
        },
        'character-class': {
            pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
            greedy: true,
            alias: 'regex',
            inside: {
                range: {
                    pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
                    lookbehind: true,
                    alias: 'punctuation'
                },
                escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
                punctuation: /[\[\]]/
            }
        },
        action: {
            pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
            greedy: true,
            inside: {
                content: {
                    // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
                    pattern: /(\{)[\s\S]+(?=\})/,
                    lookbehind: true
                },
                punctuation: /[{}]/
            }
        },
        command: {
            pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
            lookbehind: true,
            inside: {
                function: /\b\w+(?=\s*(?:[,(]|$))/,
                punctuation: /[,()]/
            }
        },
        annotation: {
            pattern: /@\w+(?:::\w+)*/,
            alias: 'keyword'
        },
        label: {
            pattern: /#[ \t]*\w+/,
            alias: 'punctuation'
        },
        keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
        definition: [
            {
                pattern: /\b[a-z]\w*(?=\s*:)/,
                alias: [
                    'rule',
                    'class-name'
                ]
            },
            {
                pattern: /\b[A-Z]\w*(?=\s*:)/,
                alias: [
                    'token',
                    'constant'
                ]
            }
        ],
        constant: /\b[A-Z][A-Z_]*\b/,
        operator: /\.\.|->|[|~]|[*+?]\??/,
        punctuation: /[;:()=]/
    };
    Prism.languages.g4 = Prism.languages.antlr4;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5f9b78712ea78e48$export$2e2bcd8739ae039.displayName = 'apacheconf';
$5f9b78712ea78e48$export$2e2bcd8739ae039.aliases = [];
function $5f9b78712ea78e48$export$2e2bcd8739ae039(Prism) {
    Prism.languages.apacheconf = {
        comment: /#.*/,
        'directive-inline': {
            pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
            lookbehind: true,
            alias: 'property'
        },
        'directive-block': {
            pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
            inside: {
                'directive-block': {
                    pattern: /^<\/?\w+/,
                    inside: {
                        punctuation: /^<\/?/
                    },
                    alias: 'tag'
                },
                'directive-block-parameter': {
                    pattern: /.*[^>]/,
                    inside: {
                        punctuation: /:/,
                        string: {
                            pattern: /("|').*\1/,
                            inside: {
                                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                            }
                        }
                    },
                    alias: 'attr-value'
                },
                punctuation: />/
            },
            alias: 'tag'
        },
        'directive-flags': {
            pattern: /\[(?:[\w=],?)+\]/,
            alias: 'keyword'
        },
        string: {
            pattern: /("|').*\1/,
            inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
            }
        },
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
        regex: /\^?.*\$|\^.*\$?/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$c25959ac29c21b23$export$2e2bcd8739ae039.displayName = 'apex';
$c25959ac29c21b23$export$2e2bcd8739ae039.aliases = [];
function $c25959ac29c21b23$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i;
        var className = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(/<keyword>/g, function() {
            return keywords.source;
        });
        /** @param {string} pattern */ function insertClassName(pattern) {
            return RegExp(pattern.replace(/<CLASS-NAME>/g, function() {
                return className;
            }), 'i');
        }
        var classNameInside = {
            keyword: keywords,
            punctuation: /[()\[\]{};,:.<>]/
        };
        Prism.languages.apex = {
            comment: Prism.languages.clike.comment,
            string: Prism.languages.clike.string,
            sql: {
                pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
                lookbehind: true,
                greedy: true,
                alias: 'language-sql',
                inside: Prism.languages.sql
            },
            annotation: {
                pattern: /@\w+\b/,
                alias: 'punctuation'
            },
            'class-name': [
                {
                    pattern: insertClassName(/(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // cast
                    pattern: insertClassName(/(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // variable/parameter declaration and return types
                    pattern: insertClassName(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
                    inside: classNameInside
                }
            ],
            trigger: {
                pattern: /(\btrigger\s+)\w+\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            keyword: keywords,
            function: /\b[a-z_]\w*(?=\s*\()/i,
            boolean: /\b(?:false|true)\b/i,
            number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
            operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
            punctuation: /[()\[\]{};,.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $34c2ee9c440ac9ed$export$2e2bcd8739ae039.displayName = 'apl';
$34c2ee9c440ac9ed$export$2e2bcd8739ae039.aliases = [];
function $34c2ee9c440ac9ed$export$2e2bcd8739ae039(Prism) {
    Prism.languages.apl = {
        comment: /(?:⍝|#[! ]).*$/m,
        string: {
            pattern: /'(?:[^'\r\n]|'')*'/,
            greedy: true
        },
        number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
        statement: /:[A-Z][a-z][A-Za-z]*\b/,
        'system-function': {
            pattern: /⎕[A-Z]+/i,
            alias: 'function'
        },
        constant: /[⍬⌾#⎕⍞]/,
        function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
        'monadic-operator': {
            pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
            alias: 'operator'
        },
        'dyadic-operator': {
            pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
            alias: 'operator'
        },
        assignment: {
            pattern: /←/,
            alias: 'keyword'
        },
        punctuation: /[\[;\]()◇⋄]/,
        dfn: {
            pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
            alias: 'builtin'
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $16c57dd521f1a867$export$2e2bcd8739ae039.displayName = 'applescript';
$16c57dd521f1a867$export$2e2bcd8739ae039.aliases = [];
function $16c57dd521f1a867$export$2e2bcd8739ae039(Prism) {
    Prism.languages.applescript = {
        comment: [
            // Allow one level of nesting
            /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
            /--.+/,
            /#.+/
        ],
        string: /"(?:\\.|[^"\\\r\n])*"/,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
        operator: [
            /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
            /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
        ],
        keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
        'class-name': /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
        punctuation: /[{}():,¬«»《》]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d761452eb924cd1c$export$2e2bcd8739ae039.displayName = 'aql';
$d761452eb924cd1c$export$2e2bcd8739ae039.aliases = [];
function $d761452eb924cd1c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.aql = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        property: {
            pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        variable: /@@?\w+/,
        keyword: [
            {
                pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
                lookbehind: true
            },
            /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
            // pseudo keywords get a lookbehind to avoid false positives
            {
                pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
                lookbehind: true
            },
            {
                pattern: /\bOPTIONS(?=\s*\{)/i
            }
        ],
        function: /\b(?!\d)\w+(?=\s*\()/,
        boolean: /\b(?:false|true)\b/i,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        number: [
            /\b0b[01]+/i,
            /\b0x[0-9a-f]+/i,
            /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
        ],
        operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
        punctuation: /::|[?.:,;()[\]{}]/
    };
}





// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $46893c7fe39cde19$export$2e2bcd8739ae039.displayName = 'arff';
$46893c7fe39cde19$export$2e2bcd8739ae039.aliases = [];
function $46893c7fe39cde19$export$2e2bcd8739ae039(Prism) {
    Prism.languages.arff = {
        comment: /%.*/,
        string: {
            pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /@(?:attribute|data|end|relation)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        punctuation: /[{},]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $13f495791853dbf3$export$2e2bcd8739ae039.displayName = 'armasm';
$13f495791853dbf3$export$2e2bcd8739ae039.aliases = [
    'arm-asm'
];
function $13f495791853dbf3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.armasm = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"/,
            greedy: true,
            inside: {
                variable: {
                    pattern: /((?:^|[^$])(?:\${2})*)\$\w+/,
                    lookbehind: true
                }
            }
        },
        char: {
            pattern: /'(?:[^'\r\n]{0,4}|'')'/,
            greedy: true
        },
        'version-symbol': {
            pattern: /\|[\w@]+\|/,
            greedy: true,
            alias: 'property'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        directive: {
            pattern: /\b(?:ALIAS|ALIGN|AREA|ARM|ASSERT|ATTR|CN|CODE|CODE16|CODE32|COMMON|CP|DATA|DCB|DCD|DCDO|DCDU|DCFD|DCFDU|DCI|DCQ|DCQU|DCW|DCWU|DN|ELIF|ELSE|END|ENDFUNC|ENDIF|ENDP|ENTRY|EQU|EXPORT|EXPORTAS|EXTERN|FIELD|FILL|FN|FUNCTION|GBLA|GBLL|GBLS|GET|GLOBAL|IF|IMPORT|INCBIN|INCLUDE|INFO|KEEP|LCLA|LCLL|LCLS|LTORG|MACRO|MAP|MEND|MEXIT|NOFP|OPT|PRESERVE8|PROC|QN|READONLY|RELOC|REQUIRE|REQUIRE8|RLIST|ROUT|SETA|SETL|SETS|SN|SPACE|SUBT|THUMB|THUMBX|TTL|WEND|WHILE)\b/,
            alias: 'property'
        },
        instruction: {
            pattern: /((?:^|(?:^|[^\\])(?:\r\n?|\n))[ \t]*(?:(?:[A-Z][A-Z0-9_]*[a-z]\w*|[a-z]\w*|\d+)[ \t]+)?)\b[A-Z.]+\b/,
            lookbehind: true,
            alias: 'keyword'
        },
        variable: /\$\w+/,
        number: /(?:\b[2-9]_\d+|(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e-?\d+)?|\b0(?:[fd]_|x)[0-9a-f]+|&[0-9a-f]+)\b/i,
        register: {
            pattern: /\b(?:r\d|lr)\b/,
            alias: 'symbol'
        },
        operator: /<>|<<|>>|&&|\|\||[=!<>/]=?|[+\-*%#?&|^]|:[A-Z]+:/,
        punctuation: /[()[\],]/
    };
    Prism.languages['arm-asm'] = Prism.languages.armasm;
}





// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $93cf65ee58a98ba9$export$2e2bcd8739ae039.displayName = 'arturo';
$93cf65ee58a98ba9$export$2e2bcd8739ae039.aliases = [
    'art'
];
function $93cf65ee58a98ba9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} lang
     * @param {string} pattern
     */ var createLanguageString = function(lang, pattern) {
            return {
                pattern: RegExp(/\{!/.source + '(?:' + (pattern || lang) + ')' + /$[\s\S]*\}/.source, 'm'),
                greedy: true,
                inside: {
                    embedded: {
                        pattern: /(^\{!\w+\b)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        alias: 'language-' + lang,
                        inside: Prism.languages[lang]
                    },
                    string: /[\s\S]+/
                }
            };
        };
        Prism.languages.arturo = {
            comment: {
                pattern: /;.*/,
                greedy: true
            },
            character: {
                pattern: /`.`/,
                alias: 'char',
                greedy: true
            },
            number: {
                pattern: /\b\d+(?:\.\d+(?:\.\d+(?:-[\w+-]+)?)?)?\b/
            },
            string: {
                pattern: /"(?:[^"\\\r\n]|\\.)*"/,
                greedy: true
            },
            regex: {
                pattern: /\{\/.*?\/\}/,
                greedy: true
            },
            'html-string': createLanguageString('html'),
            'css-string': createLanguageString('css'),
            'js-string': createLanguageString('js'),
            'md-string': createLanguageString('md'),
            'sql-string': createLanguageString('sql'),
            'sh-string': createLanguageString('shell', 'sh'),
            multistring: {
                pattern: /».*|\{:[\s\S]*?:\}|\{[\s\S]*?\}|^-{6}$[\s\S]*/m,
                alias: 'string',
                greedy: true
            },
            label: {
                pattern: /\w+\b\??:/,
                alias: 'property'
            },
            literal: {
                pattern: /'(?:\w+\b\??:?)/,
                alias: 'constant'
            },
            type: {
                pattern: /:(?:\w+\b\??:?)/,
                alias: 'class-name'
            },
            color: /#\w+/,
            predicate: {
                pattern: /\b(?:all|and|any|ascii|attr|attribute|attributeLabel|binary|block|char|contains|database|date|dictionary|empty|equal|even|every|exists|false|floating|function|greater|greaterOrEqual|if|in|inline|integer|is|key|label|leap|less|lessOrEqual|literal|logical|lower|nand|negative|nor|not|notEqual|null|numeric|odd|or|path|pathLabel|positive|prefix|prime|regex|same|set|some|sorted|standalone|string|subset|suffix|superset|symbol|symbolLiteral|true|try|type|unless|upper|when|whitespace|word|xnor|xor|zero)\?/,
                alias: 'keyword'
            },
            'builtin-function': {
                pattern: /\b(?:abs|acos|acosh|acsec|acsech|actan|actanh|add|after|alert|alias|and|angle|append|arg|args|arity|array|as|asec|asech|asin|asinh|atan|atan2|atanh|attr|attrs|average|before|benchmark|blend|break|call|capitalize|case|ceil|chop|clear|clip|close|color|combine|conj|continue|copy|cos|cosh|crc|csec|csech|ctan|ctanh|cursor|darken|dec|decode|define|delete|desaturate|deviation|dialog|dictionary|difference|digest|digits|div|do|download|drop|dup|e|else|empty|encode|ensure|env|escape|execute|exit|exp|extend|extract|factors|fdiv|filter|first|flatten|floor|fold|from|function|gamma|gcd|get|goto|hash|hypot|if|inc|indent|index|infinity|info|input|insert|inspect|intersection|invert|jaro|join|keys|kurtosis|last|let|levenshtein|lighten|list|ln|log|loop|lower|mail|map|match|max|median|min|mod|module|mul|nand|neg|new|nor|normalize|not|now|null|open|or|outdent|pad|palette|panic|path|pause|permissions|permutate|pi|pop|popup|pow|powerset|powmod|prefix|print|prints|process|product|query|random|range|read|relative|remove|rename|render|repeat|replace|request|return|reverse|round|sample|saturate|script|sec|sech|select|serve|set|shl|shr|shuffle|sin|sinh|size|skewness|slice|sort|spin|split|sqrt|squeeze|stack|strip|sub|suffix|sum|switch|symbols|symlink|sys|take|tan|tanh|terminal|terminate|to|truncate|try|type|unclip|union|unique|unless|until|unzip|upper|values|var|variance|volume|webview|while|with|wordwrap|write|xnor|xor|zip)\b/,
                alias: 'keyword'
            },
            sugar: {
                pattern: /->|=>|\||::/,
                alias: 'operator'
            },
            punctuation: /[()[\],]/,
            symbol: {
                pattern: /<:|-:|ø|@|#|\+|\||\*|\$|---|-|%|\/|\.\.|\^|~|=|<|>|\\/
            },
            boolean: {
                pattern: /\b(?:false|maybe|true)\b/
            }
        };
        Prism.languages.art = Prism.languages['arturo'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $825a50f0352eefcc$export$2e2bcd8739ae039.displayName = 'asciidoc';
$825a50f0352eefcc$export$2e2bcd8739ae039.aliases = [
    'adoc'
];
function $825a50f0352eefcc$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var attributes = {
            pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
            lookbehind: true,
            inside: {
                quoted: {
                    pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
                    inside: {
                        punctuation: /^[$`]|[$`]$/
                    }
                },
                interpreted: {
                    pattern: /'(?:[^'\\]|\\.)*'/,
                    inside: {
                        punctuation: /^'|'$/
                    }
                },
                string: /"(?:[^"\\]|\\.)*"/,
                variable: /\w+(?==)/,
                punctuation: /^\[|\]$|,/,
                operator: /=/,
                // The negative look-ahead prevents blank matches
                'attr-value': /(?!^\s+$).+/
            }
        };
        var asciidoc = Prism.languages.asciidoc = {
            'comment-block': {
                pattern: /^(\/{4,})$[\s\S]*?^\1/m,
                alias: 'comment'
            },
            table: {
                pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
                inside: {
                    specifiers: {
                        pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
                        alias: 'attr-value'
                    },
                    punctuation: {
                        pattern: /(^|[^\\])[|!]=*/,
                        lookbehind: true
                    }
                }
            },
            'passthrough-block': {
                pattern: /^(\+{4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^\++|\++$/
                }
            },
            // Literal blocks and listing blocks
            'literal-block': {
                pattern: /^(-{4,}|\.{4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
                }
            },
            // Sidebar blocks, quote blocks, example blocks and open blocks
            'other-block': {
                pattern: /^(--|\*{4,}|_{4,}|={4,})$[\s\S]*?^\1$/m,
                inside: {
                    punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
                }
            },
            // list-punctuation and list-label must appear before indented-block
            'list-punctuation': {
                pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
                lookbehind: true,
                alias: 'punctuation'
            },
            'list-label': {
                pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
                lookbehind: true,
                alias: 'symbol'
            },
            'indented-block': {
                pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
                lookbehind: true
            },
            comment: /^\/\/.*/m,
            title: {
                pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
                alias: 'important',
                inside: {
                    punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
                }
            },
            'attribute-entry': {
                pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
                alias: 'tag'
            },
            attributes: attributes,
            hr: {
                pattern: /^'{3,}$/m,
                alias: 'punctuation'
            },
            'page-break': {
                pattern: /^<{3,}$/m,
                alias: 'punctuation'
            },
            admonition: {
                pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
                alias: 'keyword'
            },
            callout: [
                {
                    pattern: /(^[ \t]*)<?\d*>/m,
                    lookbehind: true,
                    alias: 'symbol'
                },
                {
                    pattern: /<\d+>/,
                    alias: 'symbol'
                }
            ],
            macro: {
                pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                inside: {
                    function: /^[a-z\d-]+(?=:)/,
                    punctuation: /^::?/,
                    attributes: {
                        pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                        inside: attributes.inside
                    }
                }
            },
            inline: {
                /*
The initial look-behind prevents the highlighting of escaped quoted text.
Quoted text can be multi-line but cannot span an empty line.
All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
First, we handle the constrained quotes.
Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
Then we handle the unconstrained quotes.
Those do not have the restrictions of the constrained quotes.
They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
*/ pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
                lookbehind: true,
                inside: {
                    attributes: attributes,
                    url: {
                        pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
                        inside: {
                            punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
                        }
                    },
                    'attribute-ref': {
                        pattern: /^\{.+\}$/,
                        inside: {
                            variable: {
                                pattern: /(^\{)[a-z\d,+_-]+/,
                                lookbehind: true
                            },
                            operator: /^[=?!#%@$]|!(?=[:}])/,
                            punctuation: /^\{|\}$|::?/
                        }
                    },
                    italic: {
                        pattern: /^(['_])[\s\S]+\1$/,
                        inside: {
                            punctuation: /^(?:''?|__?)|(?:''?|__?)$/
                        }
                    },
                    bold: {
                        pattern: /^\*[\s\S]+\*$/,
                        inside: {
                            punctuation: /^\*\*?|\*\*?$/
                        }
                    },
                    punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
                }
            },
            replacement: {
                pattern: /\((?:C|R|TM)\)/,
                alias: 'builtin'
            },
            entity: /&#?[\da-z]{1,8};/i,
            'line-continuation': {
                pattern: /(^| )\+$/m,
                lookbehind: true,
                alias: 'punctuation'
            }
        };
        // Allow some nesting. There is no recursion though, so cloning should not be needed.
        function copyFromAsciiDoc(keys) {
            keys = keys.split(' ');
            var o = {};
            for(var i = 0, l = keys.length; i < l; i++)o[keys[i]] = asciidoc[keys[i]];
            return o;
        }
        attributes.inside['interpreted'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        asciidoc['passthrough-block'].inside.rest = copyFromAsciiDoc('macro');
        asciidoc['literal-block'].inside.rest = copyFromAsciiDoc('callout');
        asciidoc['table'].inside.rest = copyFromAsciiDoc('comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation');
        asciidoc['other-block'].inside.rest = copyFromAsciiDoc('table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation');
        asciidoc['title'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        // Plugin to make entity title show the real entity, idea by Roman Komarov
        Prism.hooks.add('wrap', function(env) {
            if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
        });
        Prism.languages.adoc = Prism.languages.asciidoc;
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$ae7a5bea34c537e5$export$2e2bcd8739ae039.displayName = 'aspnet';
$ae7a5bea34c537e5$export$2e2bcd8739ae039.aliases = [];
function $ae7a5bea34c537e5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $803928922a6961a4$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    Prism.languages.aspnet = Prism.languages.extend('markup', {
        'page-directive': {
            pattern: /<%\s*@.*%>/,
            alias: 'tag',
            inside: {
                'page-directive': {
                    pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
                    alias: 'tag'
                },
                rest: Prism.languages.markup.tag.inside
            }
        },
        directive: {
            pattern: /<%.*%>/,
            alias: 'tag',
            inside: {
                directive: {
                    pattern: /<%\s*?[$=%#:]{0,2}|%>/,
                    alias: 'tag'
                },
                rest: Prism.languages.csharp
            }
        }
    });
    // Regexp copied from prism-markup, with a negative look-ahead added
    Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
    // match directives of attribute value foo="<% Bar %>"
    Prism.languages.insertBefore('inside', 'punctuation', {
        directive: Prism.languages.aspnet['directive']
    }, Prism.languages.aspnet.tag.inside['attr-value']);
    Prism.languages.insertBefore('aspnet', 'comment', {
        'asp-comment': {
            pattern: /<%--[\s\S]*?--%>/,
            alias: [
                'asp',
                'comment'
            ]
        }
    });
    // script runat="server" contains csharp, not javascript
    Prism.languages.insertBefore('aspnet', Prism.languages.javascript ? 'script' : 'tag', {
        'asp-script': {
            pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
            lookbehind: true,
            alias: [
                'asp',
                'script'
            ],
            inside: Prism.languages.csharp || {}
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $bd73346734ce1e3f$export$2e2bcd8739ae039.displayName = 'asm6502';
$bd73346734ce1e3f$export$2e2bcd8739ae039.aliases = [];
function $bd73346734ce1e3f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.asm6502 = {
        comment: /;.*/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'op-code': {
            pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{1,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[xya]\b/i,
            alias: 'variable'
        },
        punctuation: /[(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $75d197dead828344$export$2e2bcd8739ae039.displayName = 'asmatmel';
$75d197dead828344$export$2e2bcd8739ae039.aliases = [];
function $75d197dead828344$export$2e2bcd8739ae039(Prism) {
    Prism.languages.asmatmel = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        'r-register': {
            pattern: /\br(?:\d|[12]\d|3[01])\b/,
            alias: 'variable'
        },
        'op-code': {
            pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{2,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[acznvshtixy]\b/i,
            alias: 'variable'
        },
        operator: />>=?|<<=?|&[&=]?|\|[\|=]?|[-+*/%^!=<>?]=?/,
        punctuation: /[(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6fdeaba363e1867b$export$2e2bcd8739ae039.displayName = 'autohotkey';
$6fdeaba363e1867b$export$2e2bcd8739ae039.aliases = [];
function $6fdeaba363e1867b$export$2e2bcd8739ae039(Prism) {
    // NOTES - follows first-first highlight method, block is locked after highlight, different from SyntaxHl
    Prism.languages.autohotkey = {
        comment: [
            {
                pattern: /(^|\s);.*/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
                lookbehind: true,
                greedy: true
            }
        ],
        tag: {
            // labels
            pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
            lookbehind: true
        },
        string: /"(?:[^"\n\r]|"")*"/,
        variable: /%\w+%/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
        boolean: /\b(?:false|true)\b/,
        command: {
            pattern: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
            alias: 'selector'
        },
        constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
        builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
        symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
        directive: {
            pattern: /#[a-z]+\b/i,
            alias: 'important'
        },
        keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
        function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
        punctuation: /[{}[\]():,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b9409e2dd4b1f152$export$2e2bcd8739ae039.displayName = 'autoit';
$b9409e2dd4b1f152$export$2e2bcd8739ae039.aliases = [];
function $b9409e2dd4b1f152$export$2e2bcd8739ae039(Prism) {
    Prism.languages.autoit = {
        comment: [
            /;.*/,
            {
                // The multi-line comments delimiters can actually be commented out with ";"
                pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
                lookbehind: true
            }
        ],
        url: {
            pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
            greedy: true,
            inside: {
                variable: /([%$@])\w+\1/
            }
        },
        directive: {
            pattern: /(^[\t ]*)#[\w-]+/m,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b\w+(?=\()/,
        // Variables and macros
        variable: /[$@]\w+/,
        keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        boolean: /\b(?:False|True)\b/i,
        operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
        punctuation: /[\[\]().,:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5a70a1b33a6cef7a$export$2e2bcd8739ae039.displayName = 'avisynth';
$5a70a1b33a6cef7a$export$2e2bcd8739ae039.aliases = [
    'avs'
];
function $5a70a1b33a6cef7a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return replacements[+index];
            });
        }
        function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        var types = /bool|clip|float|int|string|val/.source;
        var internals = [
            // bools
            /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
            // control
            /apply|assert|default|eval|import|nop|select|undefined/.source,
            // global
            /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
            // conv
            /hex(?:value)?|value/.source,
            // numeric
            /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
            // trig
            /a?sinh?|a?cosh?|a?tan[2h]?/.source,
            // bit
            /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
            // runtime
            /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
            // script
            /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
            // string
            /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
            // version
            /isversionorgreater|version(?:number|string)/.source,
            // helper
            /buildpixeltype|colorspacenametopixeltype/.source,
            // avsplus
            /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
        ].join('|');
        var properties = [
            // content
            /has(?:audio|video)/.source,
            // resolution
            /height|width/.source,
            // framerate
            /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
            // interlacing
            /getparity|is(?:field|frame)based/.source,
            // color format
            /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
            // audio
            /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
        ].join('|');
        var filters = [
            // source
            /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
            // color
            /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
            // overlay
            /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
            // geometry
            /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
            // pixel
            /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
            // timeline
            /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
            // interlace
            /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
            // audio
            /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
            // conditional
            /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
            // export
            /imagewriter/.source,
            // debug
            /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
        ].join('|');
        var allinternals = [
            internals,
            properties,
            filters
        ].join('|');
        Prism.languages.avisynth = {
            comment: [
                {
                    // Matches [* *] nestable block comments, but only supports 1 level of nested comments
                    // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
                    pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches /* */ block comments
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches # comments
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // Handle before strings because optional arguments are surrounded by double quotes
            argument: {
                pattern: re(/\b(?:<<0>>)\s+("?)\w+\1/.source, [
                    types
                ], 'i'),
                inside: {
                    keyword: /^\w+/
                }
            },
            // Optional argument assignment
            'argument-label': {
                pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
                lookbehind: true,
                inside: {
                    'argument-name': {
                        pattern: /^\w+/,
                        alias: 'punctuation'
                    },
                    punctuation: /=$/
                }
            },
            string: [
                {
                    // triple double-quoted
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true
                },
                {
                    // single double-quoted
                    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        constant: {
                            // These *are* case-sensitive!
                            pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
                        }
                    }
                }
            ],
            // The special "last" variable that takes the value of the last implicitly returned clip
            variable: /\b(?:last)\b/i,
            boolean: /\b(?:false|no|true|yes)\b/i,
            keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
            constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
            // AviSynth's internal functions, filters, and properties
            'builtin-function': {
                pattern: re(/\b(?:<<0>>)\b/.source, [
                    allinternals
                ], 'i'),
                alias: 'function'
            },
            'type-cast': {
                pattern: re(/\b(?:<<0>>)(?=\s*\()/.source, [
                    types
                ], 'i'),
                alias: 'keyword'
            },
            // External/user-defined filters
            function: {
                pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
                lookbehind: true
            },
            // Matches a \ as the first or last character on a line
            'line-continuation': {
                pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
            operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
            punctuation: /[{}\[\]();,.]/
        };
        Prism.languages.avs = Prism.languages.avisynth;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fde5bd5d73cb6997$export$2e2bcd8739ae039.displayName = 'avro-idl';
$fde5bd5d73cb6997$export$2e2bcd8739ae039.aliases = [
    'avdl'
];
function $fde5bd5d73cb6997$export$2e2bcd8739ae039(Prism) {
    // GitHub: https://github.com/apache/avro
    // Docs: https://avro.apache.org/docs/current/idl.html
    Prism.languages['avro-idl'] = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        annotation: {
            pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
            greedy: true,
            alias: 'function'
        },
        'function-identifier': {
            pattern: /`[^\r\n`]+`(?=\s*\()/,
            greedy: true,
            alias: 'function'
        },
        identifier: {
            pattern: /`[^\r\n`]+`/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: [
            {
                pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
                lookbehind: true
            },
            /-?\b(?:Infinity|NaN)\b/
        ],
        operator: /=/,
        punctuation: /[()\[\]{}<>.:,;-]/
    };
    Prism.languages.avdl = Prism.languages['avro-idl'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c23e2e2dfd81122c$export$2e2bcd8739ae039.displayName = 'awk';
$c23e2e2dfd81122c$export$2e2bcd8739ae039.aliases = [
    'gawk'
];
function $c23e2e2dfd81122c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.awk = {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\\"\r\n]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        regex: {
            pattern: /((?:^|[^\w\s)])\s*)\/(?:[^\/\\\r\n]|\\.)*\//,
            lookbehind: true,
            greedy: true
        },
        variable: /\$\w+/,
        keyword: /\b(?:BEGIN|BEGINFILE|END|ENDFILE|break|case|continue|default|delete|do|else|exit|for|function|getline|if|in|next|nextfile|printf?|return|switch|while)\b|@(?:include|load)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[a-fA-F0-9]+)\b/,
        operator: /--|\+\+|!?~|>&|>>|<<|(?:\*\*|[<>!=+\-*/%^])=?|&&|\|[|&]|[?:]/,
        punctuation: /[()[\]{},;]/
    };
    Prism.languages.gawk = Prism.languages.awk;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f1ff25d1ebcd6cac$export$2e2bcd8739ae039.displayName = 'batch';
$f1ff25d1ebcd6cac$export$2e2bcd8739ae039.aliases = [];
function $f1ff25d1ebcd6cac$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /%%?[~:\w]+%?|!\S+!/;
        var parameter = {
            pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
            alias: 'attr-name',
            inside: {
                punctuation: /:/
            }
        };
        var string = /"(?:[\\"]"|[^"])*"(?!")/;
        var number = /(?:\b|-)\d+\b/;
        Prism.languages.batch = {
            comment: [
                /^::.*/m,
                {
                    pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true
                }
            ],
            label: {
                pattern: /^:.*/m,
                alias: 'property'
            },
            command: [
                {
                    // FOR command
                    pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:do|in)\b|^for\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        punctuation: /[()',]/
                    }
                },
                {
                    // IF command
                    pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
                    }
                },
                {
                    // ELSE command
                    pattern: /((?:^|[&()])[ \t]*)else\b/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^else\b/i
                    }
                },
                {
                    // SET command
                    pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^set\b/i,
                        string: string,
                        parameter: parameter,
                        variable: [
                            variable,
                            /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/
                        ],
                        number: number,
                        operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
                        punctuation: /[()',]/
                    }
                },
                {
                    // Other commands
                    pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^\w+\b/,
                        string: string,
                        parameter: parameter,
                        label: {
                            pattern: /(^\s*):\S+/m,
                            lookbehind: true,
                            alias: 'property'
                        },
                        variable: variable,
                        number: number,
                        operator: /\^/
                    }
                }
            ],
            operator: /[&@]/,
            punctuation: /[()']/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $92013590b857bd88$export$2e2bcd8739ae039.displayName = 'bbcode';
$92013590b857bd88$export$2e2bcd8739ae039.aliases = [
    'shortcode'
];
function $92013590b857bd88$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bbcode = {
        tag: {
            pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
            inside: {
                tag: {
                    pattern: /^\[\/?[^\s=\]]+/,
                    inside: {
                        punctuation: /^\[\/?/
                    }
                },
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
                    inside: {
                        punctuation: [
                            /^=/,
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\]/,
                'attr-name': /[^\s=\]]+/
            }
        }
    };
    Prism.languages.shortcode = Prism.languages.bbcode;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d4e3d605b49454d4$export$2e2bcd8739ae039.displayName = 'bbj';
$d4e3d605b49454d4$export$2e2bcd8739ae039.aliases = [];
function $d4e3d605b49454d4$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.bbj = {
            comment: {
                pattern: /(^|[^\\:])rem\s+.*/i,
                lookbehind: true,
                greedy: true
            },
            string: {
                pattern: /(['"])(?:(?!\1|\\).|\\.)*\1/,
                greedy: true
            },
            number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            keyword: /\b(?:abstract|all|argc|begin|bye|callback|case|chn|class|classend|ctl|day|declare|delete|dim|dom|dread|dsz|else|end|endif|err|exitto|extends|fi|field|for|from|gosub|goto|if|implements|interface|interfaceend|iol|iolist|let|list|load|method|methodend|methodret|on|opts|pfx|print|private|process_events|protected|psz|public|read|read_resource|release|remove_callback|repeat|restore|return|rev|seterr|setesc|sqlchn|sqlunt|ssn|start|static|swend|switch|sys|then|tim|unt|until|use|void|wend|where|while)\b/i,
            function: /\b\w+(?=\()/,
            boolean: /\b(?:BBjAPI\.TRUE|BBjAPI\.FALSE)\b/i,
            operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:and|not|or|xor)\b/i,
            punctuation: /[.,;:()]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $26acd6c806290335$export$2e2bcd8739ae039.displayName = 'bicep';
$26acd6c806290335$export$2e2bcd8739ae039.aliases = [];
function $26acd6c806290335$export$2e2bcd8739ae039(Prism) {
    // based loosely upon: https://github.com/Azure/bicep/blob/main/src/textmate/bicep.tmlanguage
    Prism.languages.bicep = {
        comment: [
            {
                // multiline comments eg /* ASDF */
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                // singleline comments eg // ASDF
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        property: [
            {
                pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
                lookbehind: true
            },
            {
                pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: /'''[^'][\s\S]*?'''/,
                greedy: true
            },
            {
                pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
                lookbehind: true,
                greedy: true
            }
        ],
        'interpolated-string': {
            pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}\r\n]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true
                        },
                        punctuation: /^\$\{|\}$/
                    }
                },
                string: /[\s\S]+/
            }
        },
        datatype: {
            pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
            lookbehind: true,
            alias: 'class-name'
        },
        boolean: /\b(?:false|true)\b/,
        // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
        keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
        decorator: /@\w+\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.bicep['interpolated-string'].inside['interpolation'].inside['expression'].inside = Prism.languages.bicep;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$e9431566d3fac7dd$export$2e2bcd8739ae039.displayName = 'birb';
$e9431566d3fac7dd$export$2e2bcd8739ae039.aliases = [];
function $e9431566d3fac7dd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.birb = Prism.languages.extend('clike', {
        string: {
            pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
            greedy: true
        },
        'class-name': [
            /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
            // matches variable and function return types (parameters as well).
            /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
        ],
        keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
        variable: /\b[a-z_]\w*\b/
    });
    Prism.languages.insertBefore('birb', 'function', {
        metadata: {
            pattern: /<\w+>/,
            greedy: true,
            alias: 'symbol'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$c084f125db8708f6$export$2e2bcd8739ae039.displayName = 'bison';
$c084f125db8708f6$export$2e2bcd8739ae039.aliases = [];
function $c084f125db8708f6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.bison = Prism.languages.extend('c', {});
    Prism.languages.insertBefore('bison', 'comment', {
        bison: {
            // This should match all the beginning of the file
            // including the prologue(s), the bison declarations and
            // the grammar rules.
            pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
            inside: {
                c: {
                    // Allow for one level of nested braces
                    pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
                    inside: {
                        delimiter: {
                            pattern: /^%?\{|%?\}$/,
                            alias: 'punctuation'
                        },
                        'bison-variable': {
                            pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                            alias: 'variable',
                            inside: {
                                punctuation: /<|>/
                            }
                        },
                        rest: Prism.languages.c
                    }
                },
                comment: Prism.languages.c.comment,
                string: Prism.languages.c.string,
                property: /\S+(?=:)/,
                keyword: /%\w+/,
                number: {
                    pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
                    lookbehind: true
                },
                punctuation: /%[%?]|[|:;\[\]<>]/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8798e67056712316$export$2e2bcd8739ae039.displayName = 'bnf';
$8798e67056712316$export$2e2bcd8739ae039.aliases = [
    'rbnf'
];
function $8798e67056712316$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bnf = {
        string: {
            pattern: /"[^\r\n"]*"|'[^\r\n']*'/
        },
        definition: {
            pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
            alias: [
                'rule',
                'keyword'
            ],
            inside: {
                punctuation: /^<|>$/
            }
        },
        rule: {
            pattern: /<[^<>\r\n\t]+>/,
            inside: {
                punctuation: /^<|>$/
            }
        },
        operator: /::=|[|()[\]{}*+?]|\.{3}/
    };
    Prism.languages.rbnf = Prism.languages.bnf;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $604e26785f89d2b2$export$2e2bcd8739ae039.displayName = 'bqn';
$604e26785f89d2b2$export$2e2bcd8739ae039.aliases = [];
function $604e26785f89d2b2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bqn = {
        shebang: {
            pattern: /^#![ \t]*\/.*/,
            alias: 'important',
            greedy: true
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /"(?:[^"]|"")*"/,
            greedy: true,
            alias: 'string'
        },
        'character-literal': {
            pattern: /'(?:[\s\S]|[\uD800-\uDBFF][\uDC00-\uDFFF])'/,
            greedy: true,
            alias: 'char'
        },
        function: /•[\w¯.∞π]+[\w¯.∞π]*/,
        'dot-notation-on-brackets': {
            pattern: /\{(?=.*\}\.)|\}\./,
            alias: 'namespace'
        },
        'special-name': {
            pattern: /(?:𝕨|𝕩|𝕗|𝕘|𝕤|𝕣|𝕎|𝕏|𝔽|𝔾|𝕊|_𝕣_|_𝕣)/,
            alias: 'keyword'
        },
        'dot-notation-on-name': {
            pattern: /[A-Za-z_][\w¯∞π]*\./,
            alias: 'namespace'
        },
        'word-number-scientific': {
            pattern: /\d+(?:\.\d+)?[eE]¯?\d+/,
            alias: 'number'
        },
        'word-name': {
            pattern: /[A-Za-z_][\w¯∞π]*/,
            alias: 'symbol'
        },
        'word-number': {
            pattern: /[¯∞π]?(?:\d*\.?\b\d+(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+|E[+¯]?\d+)?|¯|∞|π))?/,
            alias: 'number'
        },
        'null-literal': {
            pattern: /@/,
            alias: 'char'
        },
        'primitive-functions': {
            pattern: /[-+×÷⋆√⌊⌈|¬∧∨<>≠=≤≥≡≢⊣⊢⥊∾≍⋈↑↓↕«»⌽⍉/⍋⍒⊏⊑⊐⊒∊⍷⊔!]/,
            alias: 'operator'
        },
        'primitive-1-operators': {
            pattern: /[`˜˘¨⁼⌜´˝˙]/,
            alias: 'operator'
        },
        'primitive-2-operators': {
            pattern: /[∘⊸⟜○⌾⎉⚇⍟⊘◶⎊]/,
            alias: 'operator'
        },
        punctuation: /[←⇐↩(){}⟨⟩[\]‿·⋄,.;:?]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $69bb850a8bbe91f4$export$2e2bcd8739ae039.displayName = 'brainfuck';
$69bb850a8bbe91f4$export$2e2bcd8739ae039.aliases = [];
function $69bb850a8bbe91f4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.brainfuck = {
        pointer: {
            pattern: /<|>/,
            alias: 'keyword'
        },
        increment: {
            pattern: /\+/,
            alias: 'inserted'
        },
        decrement: {
            pattern: /-/,
            alias: 'deleted'
        },
        branching: {
            pattern: /\[|\]/,
            alias: 'important'
        },
        operator: /[.,]/,
        comment: /\S+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0d5ca126f659299e$export$2e2bcd8739ae039.displayName = 'brightscript';
$0d5ca126f659299e$export$2e2bcd8739ae039.aliases = [];
function $0d5ca126f659299e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.brightscript = {
        comment: /(?:\brem|').*/i,
        'directive-statement': {
            pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
            lookbehind: true,
            alias: 'property',
            inside: {
                'error-message': {
                    pattern: /(^#error).+/,
                    lookbehind: true
                },
                directive: {
                    pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
                    alias: 'keyword'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        property: {
            pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        'class-name': {
            pattern: /(\bAs[\t ]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?!\d)\w+(?=[\t ]*\()/,
        number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
        operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
        punctuation: /[.,;()[\]{}]/,
        constant: /\b(?:LINE_NUM)\b/i
    };
    Prism.languages.brightscript['directive-statement'].inside.expression.inside = Prism.languages.brightscript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $beb46e0ab65e7d5b$export$2e2bcd8739ae039.displayName = 'bro';
$beb46e0ab65e7d5b$export$2e2bcd8739ae039.aliases = [];
function $beb46e0ab65e7d5b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.bro = {
        comment: {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: true,
            inside: {
                italic: /\b(?:FIXME|TODO|XXX)\b/
            }
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        boolean: /\b[TF]\b/,
        function: {
            pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
            lookbehind: true
        },
        builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
        constant: {
            pattern: /(\bconst[ \t]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
        operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $daeaab3980ca96e4$export$2e2bcd8739ae039.displayName = 'bsl';
$daeaab3980ca96e4$export$2e2bcd8739ae039.aliases = [
    'oscript'
];
function $daeaab3980ca96e4$export$2e2bcd8739ae039(Prism) {
    /* eslint-disable no-misleading-character-class */ // 1C:Enterprise
    // https://github.com/Diversus23/
    //
    Prism.languages.bsl = {
        comment: /\/\/.*/,
        string: [
            // Строки
            // Strings
            {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            // Дата и время
            // Date & time
            {
                pattern: /'(?:[^'\r\n\\]|\\.)*'/
            }
        ],
        keyword: [
            {
                // RU
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                // EN
                pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
            }
        ],
        number: {
            pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
            lookbehind: true
        },
        operator: [
            /[<>+\-*/]=?|[%=]/,
            // RU
            {
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            // EN
            {
                pattern: /\b(?:and|not|or)\b/i
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
        directive: [
            // Теги препроцессора вида &Клиент, &Сервер, ...
            // Preprocessor tags of the type &Client, &Server, ...
            {
                pattern: /^([ \t]*)&.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            },
            // Инструкции препроцессора вида:
            // #Если Сервер Тогда
            // ...
            // #КонецЕсли
            // Preprocessor instructions of the form:
            // #If Server Then
            // ...
            // #EndIf
            {
                pattern: /^([ \t]*)#.*/gm,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            }
        ]
    };
    Prism.languages.oscript = Prism.languages['bsl'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$84399bc3f59b1c8b$export$2e2bcd8739ae039.displayName = 'cfscript';
$84399bc3f59b1c8b$export$2e2bcd8739ae039.aliases = [
    'cfc'
];
function $84399bc3f59b1c8b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    // https://cfdocs.org/script
    Prism.languages.cfscript = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                inside: {
                    annotation: {
                        pattern: /(?:^|[^.])@[\w\.]+/,
                        alias: 'punctuation'
                    }
                }
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
        operator: [
            /\+\+|--|&&|\|\||::|=>|[!=]==|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|:/,
            /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
        ],
        scope: {
            pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
            alias: 'global'
        },
        type: {
            pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
            alias: 'builtin'
        }
    });
    Prism.languages.insertBefore('cfscript', 'keyword', {
        // This must be declared before keyword because we use "function" inside the lookahead
        'function-variable': {
            pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        }
    });
    delete Prism.languages.cfscript['class-name'];
    Prism.languages.cfc = Prism.languages['cfscript'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$56a51c0494ec22f0$export$2e2bcd8739ae039.displayName = 'chaiscript';
$56a51c0494ec22f0$export$2e2bcd8739ae039.aliases = [];
function $56a51c0494ec22f0$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
    Prism.languages.chaiscript = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
            lookbehind: true,
            greedy: true
        },
        'class-name': [
            {
                // e.g. class Rectangle { ... }
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            {
                // e.g. attr Rectangle::height, def Rectangle::area() { ... }
                pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
                lookbehind: true
            }
        ],
        keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
        number: [
            Prism.languages.cpp.number,
            /\b(?:Infinity|NaN)\b/
        ],
        operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    });
    Prism.languages.insertBefore('chaiscript', 'operator', {
        'parameter-type': {
            // e.g. def foo(int x, Vector y) {...}
            pattern: /([,(]\s*)\w+(?=\s+\w)/,
            lookbehind: true,
            alias: 'class-name'
        }
    });
    Prism.languages.insertBefore('chaiscript', 'string', {
        'string-interpolation': {
            pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-expression': {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            inside: Prism.languages.chaiscript
                        },
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8ec1bae033ed476d$export$2e2bcd8739ae039.displayName = 'cil';
$8ec1bae033ed476d$export$2e2bcd8739ae039.aliases = [];
function $8ec1bae033ed476d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cil = {
        comment: /\/\/.*/,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        directive: {
            pattern: /(^|\W)\.[a-z]+(?=\s)/,
            lookbehind: true,
            alias: 'class-name'
        },
        // Actually an assembly reference
        variable: /\[[\w\.]+\]/,
        keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
        function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
        punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$fa97cf30362824f8$export$2e2bcd8739ae039.displayName = 'cilkc';
$fa97cf30362824f8$export$2e2bcd8739ae039.aliases = [
    'cilk-c'
];
function $fa97cf30362824f8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.cilkc = Prism.languages.insertBefore('c', 'function', {
        'parallel-keyword': {
            pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
            alias: 'keyword'
        }
    });
    Prism.languages['cilk-c'] = Prism.languages['cilkc'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$aad082cba5464279$export$2e2bcd8739ae039.displayName = 'cilkcpp';
$aad082cba5464279$export$2e2bcd8739ae039.aliases = [
    'cilk',
    'cilk-cpp'
];
function $aad082cba5464279$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
    Prism.languages.cilkcpp = Prism.languages.insertBefore('cpp', 'function', {
        'parallel-keyword': {
            pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
            alias: 'keyword'
        }
    });
    Prism.languages['cilk-cpp'] = Prism.languages['cilkcpp'];
    Prism.languages['cilk'] = Prism.languages['cilkcpp'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $77fe7b80ef861b40$export$2e2bcd8739ae039.displayName = 'clojure';
$77fe7b80ef861b40$export$2e2bcd8739ae039.aliases = [];
function $77fe7b80ef861b40$export$2e2bcd8739ae039(Prism) {
    // Copied from https://github.com/jeluard/prism-clojure
    Prism.languages.clojure = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"/,
            greedy: true
        },
        char: /\\\w+/,
        symbol: {
            pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
            lookbehind: true
        },
        keyword: {
            pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
            lookbehind: true
        },
        boolean: /\b(?:false|nil|true)\b/,
        number: {
            pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
            lookbehind: true
        },
        function: {
            pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
            lookbehind: true
        },
        operator: /[#@^`~]/,
        punctuation: /[{}\[\](),]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $53052fb9d74303db$export$2e2bcd8739ae039.displayName = 'cmake';
$53052fb9d74303db$export$2e2bcd8739ae039.aliases = [];
function $53052fb9d74303db$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cmake = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
                    inside: {
                        punctuation: /\$\{|\}/,
                        variable: /\w+/
                    }
                }
            }
        },
        variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_NAME|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE))\b/,
        property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
        keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
        boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
        namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
        operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
        inserted: {
            pattern: /\b\w+::\w+\b/,
            alias: 'class-name'
        },
        number: /\b\d+(?:\.\d+)*\b/,
        function: /\b[a-z_]\w*(?=\s*\()\b/i,
        punctuation: /[()>}]|\$[<{]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f86df18bcfea9f70$export$2e2bcd8739ae039.displayName = 'cobol';
$f86df18bcfea9f70$export$2e2bcd8739ae039.aliases = [];
function $f86df18bcfea9f70$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cobol = {
        comment: {
            pattern: /\*>.*|(^[ \t]*)\*.*/m,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
            greedy: true
        },
        level: {
            pattern: /(^[ \t]*)\d+\b/m,
            lookbehind: true,
            greedy: true,
            alias: 'number'
        },
        'class-name': {
            // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
            pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
            lookbehind: true,
            inside: {
                number: {
                    pattern: /(\()\d+/,
                    lookbehind: true
                },
                punctuation: /[()]/
            }
        },
        keyword: {
            pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
            lookbehind: true
        },
        operator: [
            /<>|[<>]=?|[=+*/&]/,
            {
                pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
                lookbehind: true
            }
        ],
        punctuation: /[.:,()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f4e95d0947d511df$export$2e2bcd8739ae039.displayName = 'coffeescript';
$f4e95d0947d511df$export$2e2bcd8739ae039.aliases = [
    'coffee'
];
function $f4e95d0947d511df$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        // Ignore comments starting with { to privilege string interpolation highlighting
        var comment = /#(?!\{).+/;
        var interpolation = {
            pattern: /#\{[^}]+\}/,
            alias: 'variable'
        };
        Prism.languages.coffeescript = Prism.languages.extend('javascript', {
            comment: comment,
            string: [
                // Strings are multiline
                {
                    pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                    greedy: true
                },
                {
                    // Strings are multiline
                    pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation
                    }
                }
            ],
            keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
            'class-member': {
                pattern: /@(?!\d)\w+/,
                alias: 'variable'
            }
        });
        Prism.languages.insertBefore('coffeescript', 'comment', {
            'multiline-comment': {
                pattern: /###[\s\S]+?###/,
                alias: 'comment'
            },
            // Block regexp can contain comments and interpolation
            'block-regex': {
                pattern: /\/{3}[\s\S]*?\/{3}/,
                alias: 'regex',
                inside: {
                    comment: comment,
                    interpolation: interpolation
                }
            }
        });
        Prism.languages.insertBefore('coffeescript', 'string', {
            'inline-javascript': {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                inside: {
                    delimiter: {
                        pattern: /^`|`$/,
                        alias: 'punctuation'
                    },
                    script: {
                        pattern: /[\s\S]+/,
                        alias: 'language-javascript',
                        inside: Prism.languages.javascript
                    }
                }
            },
            // Block strings
            'multiline-string': [
                {
                    pattern: /'''[\s\S]*?'''/,
                    greedy: true,
                    alias: 'string'
                },
                {
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        interpolation: interpolation
                    }
                }
            ]
        });
        Prism.languages.insertBefore('coffeescript', 'keyword', {
            // Object property
            property: /(?!\d)\w+(?=\s*:(?!:))/
        });
        delete Prism.languages.coffeescript['template-string'];
        Prism.languages.coffee = Prism.languages.coffeescript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1f6beaffa93c6e28$export$2e2bcd8739ae039.displayName = 'concurnas';
$1f6beaffa93c6e28$export$2e2bcd8739ae039.aliases = [
    'conc'
];
function $1f6beaffa93c6e28$export$2e2bcd8739ae039(Prism) {
    Prism.languages.concurnas = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        langext: {
            pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
            greedy: true,
            inside: {
                'class-name': /^\w+/,
                string: {
                    pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
                    lookbehind: true
                },
                punctuation: /\|\|/
            }
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
        punctuation: /[{}[\];(),.:]/,
        operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
        annotation: {
            pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
            alias: 'builtin'
        }
    };
    Prism.languages.insertBefore('concurnas', 'langext', {
        'regex-literal': {
            pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                regex: /[\s\S]+/
            }
        },
        'string-literal': {
            pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.conc = Prism.languages.concurnas;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1fe20ac82cecf3eb$export$2e2bcd8739ae039.displayName = 'csp';
$1fe20ac82cecf3eb$export$2e2bcd8739ae039.aliases = [];
function $1fe20ac82cecf3eb$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @returns {RegExp}
     */ function value(source) {
            return RegExp(/([ \t])/.source + '(?:' + source + ')' + /(?=[\s;]|$)/.source, 'i');
        }
        Prism.languages.csp = {
            directive: {
                pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
                lookbehind: true,
                alias: 'property'
            },
            scheme: {
                pattern: value(/[a-z][a-z0-9.+-]*:/.source),
                lookbehind: true
            },
            none: {
                pattern: value(/'none'/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            nonce: {
                pattern: value(/'nonce-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            hash: {
                pattern: value(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            host: {
                pattern: value(/[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + '|' + /\*[^\s;,']*/.source + '|' + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source),
                lookbehind: true,
                alias: 'url',
                inside: {
                    important: /\*/
                }
            },
            keyword: [
                {
                    pattern: value(/'unsafe-[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'unsafe'
                },
                {
                    pattern: value(/'[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'safe'
                }
            ],
            punctuation: /;/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $debd1f6308a90423$export$2e2bcd8739ae039.displayName = 'cooklang';
$debd1f6308a90423$export$2e2bcd8739ae039.aliases = [];
function $debd1f6308a90423$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // see https://github.com/cooklang/spec/blob/main/EBNF.md
        var single_token_suffix = /(?:(?!\s)[\d$+<=a-zA-Z\x80-\uFFFF])+/.source;
        var multi_token_infix = /[^{}@#]+/.source;
        var multi_token_suffix = /\{[^}#@]*\}/.source;
        var multi_token = multi_token_infix + multi_token_suffix;
        var timer_units = /(?:h|hours|hrs|m|min|minutes)/.source;
        var amount_group_impl = {
            pattern: /\{[^{}]*\}/,
            inside: {
                amount: {
                    pattern: /([\{|])[^{}|*%]+/,
                    lookbehind: true,
                    alias: 'number'
                },
                unit: {
                    pattern: /(%)[^}]+/,
                    lookbehind: true,
                    alias: 'symbol'
                },
                'servings-scaler': {
                    pattern: /\*/,
                    alias: 'operator'
                },
                'servings-alternative-separator': {
                    pattern: /\|/,
                    alias: 'operator'
                },
                'unit-separator': {
                    pattern: /(?:%|(\*)%)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                punctuation: /[{}]/
            }
        };
        Prism.languages.cooklang = {
            comment: {
                // [- comment -]
                // -- comment
                pattern: /\[-[\s\S]*?-\]|--.*/,
                greedy: true
            },
            meta: {
                // >> key: value
                pattern: />>.*:.*/,
                inside: {
                    property: {
                        // key:
                        pattern: /(>>\s*)[^\s:](?:[^:]*[^\s:])?/,
                        lookbehind: true
                    }
                }
            },
            'cookware-group': {
                // #...{...}, #...
                pattern: new RegExp('#(?:' + multi_token + '|' + single_token_suffix + ')'),
                inside: {
                    cookware: {
                        pattern: new RegExp('(^#)(?:' + multi_token_infix + ')'),
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'cookware-keyword': {
                        pattern: /^#/,
                        alias: 'keyword'
                    },
                    'quantity-group': {
                        pattern: new RegExp(/\{[^{}@#]*\}/),
                        inside: {
                            quantity: {
                                pattern: new RegExp(/(^\{)/.source + multi_token_infix),
                                lookbehind: true,
                                alias: 'number'
                            },
                            punctuation: /[{}]/
                        }
                    }
                }
            },
            'ingredient-group': {
                // @...{...}, @...
                pattern: new RegExp('@(?:' + multi_token + '|' + single_token_suffix + ')'),
                inside: {
                    ingredient: {
                        pattern: new RegExp('(^@)(?:' + multi_token_infix + ')'),
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'ingredient-keyword': {
                        pattern: /^@/,
                        alias: 'keyword'
                    },
                    'amount-group': amount_group_impl
                }
            },
            'timer-group': {
                // ~timer{...}
                // eslint-disable-next-line regexp/sort-alternatives
                pattern: /~(?!\s)[^@#~{}]*\{[^{}]*\}/,
                inside: {
                    timer: {
                        pattern: /(^~)[^{]+/,
                        lookbehind: true,
                        alias: 'variable'
                    },
                    'duration-group': {
                        // {...}
                        pattern: /\{[^{}]*\}/,
                        inside: {
                            punctuation: /[{}]/,
                            unit: {
                                pattern: new RegExp(/(%\s*)/.source + timer_units + /\b/.source),
                                lookbehind: true,
                                alias: 'symbol'
                            },
                            operator: /%/,
                            duration: {
                                pattern: /\d+/,
                                alias: 'number'
                            }
                        }
                    },
                    'timer-keyword': {
                        pattern: /^~/,
                        alias: 'keyword'
                    }
                }
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e8643cf3d5f78f91$export$2e2bcd8739ae039.displayName = 'coq';
$e8643cf3d5f78f91$export$2e2bcd8739ae039.aliases = [];
function $e8643cf3d5f78f91$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://github.com/coq/coq
        var commentSource = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source;
        for(var i = 0; i < 2; i++)commentSource = commentSource.replace(/<self>/g, function() {
            return commentSource;
        });
        commentSource = commentSource.replace(/<self>/g, '[]');
        Prism.languages.coq = {
            comment: RegExp(commentSource),
            string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            attribute: [
                {
                    pattern: RegExp(/#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(/<comment>/g, function() {
                        return commentSource;
                    })),
                    greedy: true,
                    alias: 'attr-name',
                    inside: {
                        comment: RegExp(commentSource),
                        string: {
                            pattern: /"(?:[^"]|"")*"(?!")/,
                            greedy: true
                        },
                        operator: /=/,
                        punctuation: /^#\[|\]$|[,()]/
                    }
                },
                {
                    pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
                    alias: 'attr-name'
                }
            ],
            keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
            number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
            punct: {
                pattern: /@\{|\{\||\[=|:>/,
                alias: 'punctuation'
            },
            operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
            punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
        };
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$4f8b5c37b37db49e$export$2e2bcd8739ae039.displayName = 'crystal';
$4f8b5c37b37db49e$export$2e2bcd8739ae039.aliases = [];
function $4f8b5c37b37db49e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0814f5761e025965$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.crystal = Prism.languages.extend('ruby', {
            keyword: [
                /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
                {
                    pattern: /(\.\s*)(?:is_a|responds_to)\?/,
                    lookbehind: true
                }
            ],
            number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
            operator: [
                /->/,
                Prism.languages.ruby.operator
            ],
            punctuation: /[(){}[\].,;\\]/
        });
        Prism.languages.insertBefore('crystal', 'string-literal', {
            attribute: {
                pattern: /@\[.*?\]/,
                inside: {
                    delimiter: {
                        pattern: /^@\[|\]$/,
                        alias: 'punctuation'
                    },
                    attribute: {
                        pattern: /^(\s*)\w+/,
                        lookbehind: true,
                        alias: 'class-name'
                    },
                    args: {
                        pattern: /\S(?:[\s\S]*\S)?/,
                        inside: Prism.languages.crystal
                    }
                }
            },
            expansion: {
                pattern: /\{(?:\{.*?\}|%.*?%)\}/,
                inside: {
                    content: {
                        pattern: /^(\{.)[\s\S]+(?=.\}$)/,
                        lookbehind: true,
                        inside: Prism.languages.crystal
                    },
                    delimiter: {
                        pattern: /^\{[\{%]|[\}%]\}$/,
                        alias: 'operator'
                    }
                }
            },
            char: {
                pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
                greedy: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a0274c81b19638e1$export$2e2bcd8739ae039.displayName = 'css-extras';
$a0274c81b19638e1$export$2e2bcd8739ae039.aliases = [];
function $a0274c81b19638e1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var selectorInside;
        Prism.languages.css.selector = {
            pattern: Prism.languages.css.selector.pattern,
            lookbehind: true,
            inside: selectorInside = {
                'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
                'pseudo-class': /:[-\w]+/,
                class: /\.[-\w]+/,
                id: /#[-\w]+/,
                attribute: {
                    pattern: RegExp('\\[(?:[^[\\]"\']|' + string.source + ')*\\]'),
                    greedy: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        'case-sensitivity': {
                            pattern: /(\s)[si]$/i,
                            lookbehind: true,
                            alias: 'keyword'
                        },
                        namespace: {
                            pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                            lookbehind: true,
                            inside: {
                                punctuation: /\|$/
                            }
                        },
                        'attr-name': {
                            pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                            lookbehind: true
                        },
                        'attr-value': [
                            string,
                            {
                                pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                                lookbehind: true
                            }
                        ],
                        operator: /[|~*^$]?=/
                    }
                },
                'n-th': [
                    {
                        pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                        lookbehind: true,
                        inside: {
                            number: /[\dn]+/,
                            operator: /[+-]/
                        }
                    },
                    {
                        pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                        lookbehind: true
                    }
                ],
                combinator: />|\+|~|\|\|/,
                // the `tag` token has been existed and removed.
                // because we can't find a perfect tokenize to match it.
                // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
                punctuation: /[(),]/
            }
        };
        Prism.languages.css['atrule'].inside['selector-function-argument'].inside = selectorInside;
        Prism.languages.insertBefore('css', 'property', {
            variable: {
                pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
                lookbehind: true
            }
        });
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
            lookbehind: true
        };
        // 123 -123 .123 -.123 12.3 -12.3
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        Prism.languages.insertBefore('css', 'function', {
            operator: {
                pattern: /(\s)[+\-*\/](?=\s)/,
                lookbehind: true
            },
            // CAREFUL!
            // Previewers and Inline color use hexcode and color.
            hexcode: {
                pattern: /\B#[\da-f]{3,8}\b/i,
                alias: 'color'
            },
            color: [
                {
                    pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            // it's important that there is no boundary assertion after the hex digits
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            number: number
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $732efa98354ef152$export$2e2bcd8739ae039.displayName = 'csv';
$732efa98354ef152$export$2e2bcd8739ae039.aliases = [];
function $732efa98354ef152$export$2e2bcd8739ae039(Prism) {
    // https://tools.ietf.org/html/rfc4180
    Prism.languages.csv = {
        value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
        punctuation: /,/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4c72dd9423c79b65$export$2e2bcd8739ae039.displayName = 'cue';
$4c72dd9423c79b65$export$2e2bcd8739ae039.aliases = [];
function $4c72dd9423c79b65$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://cuelang.org/docs/references/spec/
        // eslint-disable-next-line regexp/strict
        var stringEscape = /\\(?:(?!\2)|\2(?:[^()\r\n]|\([^()]*\)))/.source;
        // eslint-disable-next-line regexp/strict
        var stringTypes = /"""(?:[^\\"]|"(?!""\2)|<esc>)*"""/.source + // eslint-disable-next-line regexp/strict
        '|' + /'''(?:[^\\']|'(?!''\2)|<esc>)*'''/.source + // eslint-disable-next-line regexp/strict
        '|' + /"(?:[^\\\r\n"]|"(?!\2)|<esc>)*"/.source + // eslint-disable-next-line regexp/strict
        '|' + /'(?:[^\\\r\n']|'(?!\2)|<esc>)*'/.source;
        var stringLiteral = '(?:' + stringTypes.replace(/<esc>/g, stringEscape) + ')';
        Prism.languages.cue = {
            comment: {
                pattern: /\/\/.*/,
                greedy: true
            },
            'string-literal': {
                // eslint-disable-next-line regexp/strict
                pattern: RegExp(/(^|[^#"'\\])(#*)/.source + stringLiteral + /(?!["'])\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    // I'm using dirty hack here. We have to know the number hashes at the start of the string somehow,
                    // but we can't look back. So instead, we will use a lookahead, go to the end of the string, and
                    // capture the hashes at the end of the string.
                    escape: {
                        pattern: /(?=[\s\S]*["'](#*)$)\\\1(?:U[a-fA-F0-9]{1,8}|u[a-fA-F0-9]{1,4}|x[a-fA-F0-9]{1,2}|\d{2,3}|[^(])/,
                        greedy: true,
                        alias: 'string'
                    },
                    interpolation: {
                        pattern: /(?=[\s\S]*["'](#*)$)\\\1\([^()]*\)/,
                        greedy: true,
                        inside: {
                            punctuation: /^\\#*\(|\)$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: null
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            keyword: {
                pattern: /(^|[^\w$])(?:for|if|import|in|let|null|package)(?![\w$])/,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^\w$])(?:false|true)(?![\w$])/,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^\w$])(?:bool|bytes|float|float(?:32|64)|u?int(?:8|16|32|64|128)?|number|rune|string)(?![\w$])/,
                lookbehind: true
            },
            attribute: {
                pattern: /@[\w$]+(?=\s*\()/,
                alias: 'function'
            },
            function: {
                pattern: /(^|[^\w$])[a-z_$][\w$]*(?=\s*\()/i,
                lookbehind: true
            },
            number: {
                pattern: /(^|[^\w$.])(?:0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|0[xX][0-9A-Fa-f]+(?:_[0-9A-Fa-f]+)*|(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[eE][+-]?\d+(?:_\d+)*)?(?:[KMGTP]i?)?)(?![\w$])/,
                lookbehind: true
            },
            operator: /\.{3}|_\|_|&&?|\|\|?|[=!]~|[<>=!]=?|[+\-*/?]/,
            punctuation: /[()[\]{},.:]/
        };
        Prism.languages.cue['string-literal'].inside.interpolation.inside.expression.inside = Prism.languages.cue;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4849b6a31c9f2c50$export$2e2bcd8739ae039.displayName = 'cypher';
$4849b6a31c9f2c50$export$2e2bcd8739ae039.aliases = [];
function $4849b6a31c9f2c50$export$2e2bcd8739ae039(Prism) {
    Prism.languages.cypher = {
        // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
        comment: /\/\/.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        'class-name': {
            pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
            lookbehind: true,
            greedy: true
        },
        relationship: {
            pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        identifier: {
            pattern: /`(?:[^`\\\r\n])*`/,
            greedy: true
        },
        variable: /\$\w+/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
        keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
        function: /\b\w+\b(?=\s*\()/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
        operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
        punctuation: /[()[\]{},;.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d96e6553b79e688e$export$2e2bcd8739ae039.displayName = 'd';
$d96e6553b79e688e$export$2e2bcd8739ae039.aliases = [];
function $d96e6553b79e688e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.d = Prism.languages.extend('clike', {
        comment: [
            {
                // Shebang
                pattern: /^\s*#!.+/,
                greedy: true
            },
            {
                pattern: RegExp(/(^|[^\\])/.source + '(?:' + [
                    // /+ comment +/
                    // Allow one level of nesting
                    /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
                    // // comment
                    /\/\/.*/.source,
                    // /* comment */
                    /\/\*[\s\S]*?\*\//.source
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: RegExp([
                    // r"", x""
                    /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
                    // q"[]", q"()", q"<>", q"{}"
                    /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
                    // q"IDENT
                    // ...
                    // IDENT"
                    /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
                    // q"//", q"||", etc.
                    // eslint-disable-next-line regexp/strict
                    /\bq"(.)[\s\S]*?\2"/.source,
                    // eslint-disable-next-line regexp/strict
                    /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
                ].join('|'), 'm'),
                greedy: true
            },
            {
                pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
                greedy: true,
                alias: 'token-string'
            }
        ],
        // In order: $, keywords and special tokens, globally defined symbols
        keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
        number: [
            // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
            // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
            /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
            {
                pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
                lookbehind: true
            }
        ],
        operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    });
    Prism.languages.insertBefore('d', 'string', {
        // Characters
        // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
        char: /'(?:\\(?:\W|\w+)|[^\\])'/
    });
    Prism.languages.insertBefore('d', 'keyword', {
        property: /\B@\w*/
    });
    Prism.languages.insertBefore('d', 'function', {
        register: {
            // Iasm registers
            pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
            alias: 'variable'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$74043824b764ef3e$export$2e2bcd8739ae039.displayName = 'dart';
$74043824b764ef3e$export$2e2bcd8739ae039.aliases = [];
function $74043824b764ef3e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var keywords = [
            /\b(?:async|sync|yield)\*/,
            /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
        ];
        // Handles named imports, such as http.Client
        var packagePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
        // based on the dart naming conventions
        var className = {
            pattern: RegExp(packagePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                }
            }
        };
        Prism.languages.dart = Prism.languages.extend('clike', {
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(packagePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
        });
        Prism.languages.insertBefore('dart', 'string', {
            'string-literal': {
                pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                        lookbehind: true,
                        inside: {
                            punctuation: /^\$\{?|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: Prism.languages.dart
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            string: undefined
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            metadata: {
                pattern: /@\w+/,
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            generics: {
                pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $a2a3ecd8671a9cb9$export$2e2bcd8739ae039.displayName = 'dataweave';
$a2a3ecd8671a9cb9$export$2e2bcd8739ae039.aliases = [];
function $a2a3ecd8671a9cb9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.dataweave = {
            url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
            property: {
                pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
                greedy: true
            },
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            'mime-type': /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
            date: {
                pattern: /\|[\w:+-]+\|/,
                greedy: true
            },
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            regex: {
                pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
                greedy: true
            },
            keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
            function: /\b[A-Z_]\w*(?=\s*\()/i,
            number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
            punctuation: /[{}[\];(),.:@]/,
            operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
            boolean: /\b(?:false|true)\b/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $456d34d6a0e808d3$export$2e2bcd8739ae039.displayName = 'dax';
$456d34d6a0e808d3$export$2e2bcd8739ae039.aliases = [];
function $456d34d6a0e808d3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.dax = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
            lookbehind: true
        },
        'data-field': {
            pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'symbol'
        },
        measure: {
            pattern: /\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'constant'
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
        keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
        boolean: {
            pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
            alias: 'constant'
        },
        number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
        operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
        punctuation: /[;\[\](){}`,.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $09fb00aefac0036e$export$2e2bcd8739ae039.displayName = 'dhall';
$09fb00aefac0036e$export$2e2bcd8739ae039.aliases = [];
function $09fb00aefac0036e$export$2e2bcd8739ae039(Prism) {
    // ABNF grammar:
    // https://github.com/dhall-lang/dhall-lang/blob/master/standard/dhall.abnf
    Prism.languages.dhall = {
        // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
        // The multi-line pattern is essentially this:
        //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
        comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            alias: 'language-dhall',
                            inside: null // see blow
                        },
                        punctuation: /\$\{|\}/
                    }
                }
            }
        },
        label: {
            pattern: /`[^`]*`/,
            greedy: true
        },
        url: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
            pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
            greedy: true
        },
        env: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
            pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
            greedy: true,
            inside: {
                function: /^env/,
                operator: /^:/,
                variable: /[\s\S]+/
            }
        },
        hash: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
            pattern: /\bsha256:[\da-fA-F]{64}\b/,
            inside: {
                function: /sha256/,
                operator: /:/,
                number: /[\da-fA-F]{64}/
            }
        },
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
        keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
        builtin: /\b(?:None|Some)\b/,
        boolean: /\b(?:False|True)\b/,
        number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
        operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
        punctuation: /\.\.|[{}\[\](),./]/,
        // we'll just assume that every capital word left is a type name
        'class-name': /\b[A-Z]\w*\b/
    };
    Prism.languages.dhall.string.inside.interpolation.inside.expression.inside = Prism.languages.dhall;
}




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$713fb0d437182828$export$2e2bcd8739ae039.displayName = 'django';
$713fb0d437182828$export$2e2bcd8739ae039.aliases = [
    'jinja2'
];
function $713fb0d437182828$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.django = {
            comment: /^\{#[\s\S]*?#\}$/,
            tag: {
                pattern: /(^\{%[+-]?\s*)\w+/,
                lookbehind: true,
                alias: 'keyword'
            },
            delimiter: {
                pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
                alias: 'punctuation'
            },
            string: {
                pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            },
            filter: {
                pattern: /(\|)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            test: {
                pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b[a-z_]\w+(?=\s*\()/i,
            keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
            operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
            number: /\b\d+(?:\.\d+)?\b/,
            boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
            variable: /\b\w+\b/,
            punctuation: /[{}[\](),.:;]/
        };
        var pattern = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g;
        var markupTemplating = Prism.languages['markup-templating'];
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'django', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'django');
        });
        // Add an Jinja2 alias
        Prism.languages.jinja2 = Prism.languages.django;
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'jinja2', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'jinja2');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9df90d7c45567ff9$export$2e2bcd8739ae039.displayName = 'dns-zone-file';
$9df90d7c45567ff9$export$2e2bcd8739ae039.aliases = [
    'dns-zone'
];
function $9df90d7c45567ff9$export$2e2bcd8739ae039(Prism) {
    Prism.languages['dns-zone-file'] = {
        comment: /;.*/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(^\$ORIGIN[ \t]+)\S+/m,
                lookbehind: true
            },
            {
                pattern: /(^|\s)@(?=\s|$)/,
                lookbehind: true
            }
        ],
        keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
        class: {
            // https://tools.ietf.org/html/rfc1035#page-13
            pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            // https://en.wikipedia.org/wiki/List_of_DNS_record_types
            pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        punctuation: /[()]/
    };
    Prism.languages['dns-zone'] = Prism.languages['dns-zone-file'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6bf0eb89a36e65a0$export$2e2bcd8739ae039.displayName = 'docker';
$6bf0eb89a36e65a0$export$2e2bcd8739ae039.aliases = [
    'dockerfile'
];
function $6bf0eb89a36e65a0$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // Many of the following regexes will contain negated lookaheads like `[ \t]+(?![ \t])`. This is a trick to ensure
        // that quantifiers behave *atomically*. Atomic quantifiers are necessary to prevent exponential backtracking.
        var spaceAfterBackSlash = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source;
        // At least one space, comment, or line break
        var space = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(/<SP_BS>/g, function() {
            return spaceAfterBackSlash;
        });
        var string = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source;
        var option = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(/<STR>/g, function() {
            return string;
        });
        var stringRule = {
            pattern: RegExp(string),
            greedy: true
        };
        var commentRule = {
            pattern: /(^[ \t]*)#.*/m,
            lookbehind: true,
            greedy: true
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function re(source, flags) {
            source = source.replace(/<OPT>/g, function() {
                return option;
            }).replace(/<SP>/g, function() {
                return space;
            });
            return RegExp(source, flags);
        }
        Prism.languages.docker = {
            instruction: {
                pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
                lookbehind: true,
                greedy: true,
                inside: {
                    options: {
                        pattern: re(/(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source, 'i'),
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            property: {
                                pattern: /(^|\s)--[\w-]+/,
                                lookbehind: true
                            },
                            string: [
                                stringRule,
                                {
                                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                                    lookbehind: true
                                }
                            ],
                            operator: /\\$/m,
                            punctuation: /=/
                        }
                    },
                    keyword: [
                        {
                            // https://docs.docker.com/engine/reference/builder/#healthcheck
                            pattern: re(/(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#from
                            pattern: re(/(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#onbuild
                            pattern: re(/(^ONBUILD<SP>)\w+/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            pattern: /^\w+/,
                            greedy: true
                        }
                    ],
                    comment: commentRule,
                    string: stringRule,
                    variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
                    operator: /\\$/m
                }
            },
            comment: commentRule
        };
        Prism.languages.dockerfile = Prism.languages.docker;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9be5e6824314caae$export$2e2bcd8739ae039.displayName = 'dot';
$9be5e6824314caae$export$2e2bcd8739ae039.aliases = [
    'gv'
];
function $9be5e6824314caae$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var ID = '(?:' + [
            // an identifier
            /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
            // a number
            /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
            // a double-quoted string
            /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
            // HTML-like string
            /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
        ].join('|') + ')';
        var IDInside = {
            markup: {
                pattern: /(^<)[\s\S]+(?=>$)/,
                lookbehind: true,
                alias: [
                    'language-markup',
                    'language-html',
                    'language-xml'
                ],
                inside: Prism.languages.markup
            }
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function withID(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return ID;
            }), flags);
        }
        Prism.languages.dot = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
                greedy: true
            },
            'graph-name': {
                pattern: withID(/(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source, 'i'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name',
                inside: IDInside
            },
            'attr-value': {
                pattern: withID(/(=[ \t\r\n]*)<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            'attr-name': {
                pattern: withID(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
            'compass-point': {
                pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
                lookbehind: true,
                alias: 'builtin'
            },
            node: {
                pattern: withID(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            operator: /[=:]|-[->]/,
            punctuation: /[\[\]{};,]/
        };
        Prism.languages.gv = Prism.languages.dot;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $582d3cacea24a910$export$2e2bcd8739ae039.displayName = 'ebnf';
$582d3cacea24a910$export$2e2bcd8739ae039.aliases = [];
function $582d3cacea24a910$export$2e2bcd8739ae039(Prism) {
    Prism.languages.ebnf = {
        comment: /\(\*[\s\S]*?\*\)/,
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        special: {
            pattern: /\?[^?\r\n]*\?/,
            greedy: true,
            alias: 'class-name'
        },
        definition: {
            pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
            lookbehind: true,
            alias: [
                'rule',
                'keyword'
            ]
        },
        rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
        punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
        operator: /[-=|*/!]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5b71468010bc72da$export$2e2bcd8739ae039.displayName = 'editorconfig';
$5b71468010bc72da$export$2e2bcd8739ae039.aliases = [];
function $5b71468010bc72da$export$2e2bcd8739ae039(Prism) {
    Prism.languages.editorconfig = {
        // https://editorconfig-specification.readthedocs.io
        comment: /[;#].*/,
        section: {
            pattern: /(^[ \t]*)\[.+\]/m,
            lookbehind: true,
            alias: 'selector',
            inside: {
                regex: /\\\\[\[\]{},!?.*]/,
                // Escape special characters with '\\'
                operator: /[!?]|\.\.|\*{1,2}/,
                punctuation: /[\[\]{},]/
            }
        },
        key: {
            pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /=.*/,
            alias: 'attr-value',
            inside: {
                punctuation: /^=/
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $05008d3ff07b1f36$export$2e2bcd8739ae039.displayName = 'eiffel';
$05008d3ff07b1f36$export$2e2bcd8739ae039.aliases = [];
function $05008d3ff07b1f36$export$2e2bcd8739ae039(Prism) {
    Prism.languages.eiffel = {
        comment: /--.*/,
        string: [
            // Aligned-verbatim-strings
            {
                pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
                greedy: true
            },
            // Non-aligned-verbatim-strings
            {
                pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
                greedy: true
            },
            // Single-line string
            {
                pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
                greedy: true
            }
        ],
        // normal char | special char | char code
        char: /'(?:%.|[^%'\r\n])+'/,
        keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
        boolean: /\b(?:False|True)\b/i,
        // Convention: class-names are always all upper-case characters
        'class-name': /\b[A-Z][\dA-Z_]*\b/,
        number: [
            // hexa | octal | bin
            /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
            // Decimal
            /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
        ],
        punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
        operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$1f738c70877931fd$export$2e2bcd8739ae039.displayName = 'ejs';
$1f738c70877931fd$export$2e2bcd8739ae039.aliases = [
    'eta'
];
function $1f738c70877931fd$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.ejs = {
            delimiter: {
                pattern: /^<%[-_=]?|[-_]?%>$/,
                alias: 'punctuation'
            },
            comment: /^#[\s\S]*/,
            'language-javascript': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.javascript
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var ejsPattern = /<%(?!%)[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ejs', ejsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ejs');
        });
        Prism.languages.eta = Prism.languages.ejs;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7290ce53648b43d9$export$2e2bcd8739ae039.displayName = 'elixir';
$7290ce53648b43d9$export$2e2bcd8739ae039.aliases = [];
function $7290ce53648b43d9$export$2e2bcd8739ae039(Prism) {
    Prism.languages.elixir = {
        doc: {
            pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
            inside: {
                attribute: /^@\w+/,
                string: /['"][\s\S]+/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
        regex: {
            pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
            greedy: true
        },
        string: [
            {
                // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
                pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
                greedy: true,
                inside: {
                }
            },
            {
                pattern: /("""|''')[\s\S]*?\1/,
                greedy: true,
                inside: {
                }
            },
            {
                // Multi-line strings are allowed
                pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                greedy: true,
                inside: {
                }
            }
        ],
        atom: {
            // Look-behind prevents bad highlighting of the :: operator
            pattern: /(^|[^:]):\w+/,
            lookbehind: true,
            alias: 'symbol'
        },
        module: {
            pattern: /\b[A-Z]\w*\b/,
            alias: 'class-name'
        },
        // Look-ahead prevents bad highlighting of the :: operator
        'attr-name': /\b\w+\??:(?!:)/,
        argument: {
            // Look-behind prevents bad highlighting of the && operator
            pattern: /(^|[^&])&\d+/,
            lookbehind: true,
            alias: 'variable'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'variable'
        },
        function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
        number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
        keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        operator: [
            /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
            {
                // We don't want to match <<
                pattern: /([^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /([^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,%\[\]{}()]/
    };
    Prism.languages.elixir.string.forEach(function(o) {
        o.inside = {
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.elixir
                }
            }
        };
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4e7615bc2bd38bf5$export$2e2bcd8739ae039.displayName = 'elm';
$4e7615bc2bd38bf5$export$2e2bcd8739ae039.aliases = [];
function $4e7615bc2bd38bf5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.elm = {
        comment: /--.*|\{-[\s\S]*?-\}/,
        char: {
            pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
            greedy: true
        },
        string: [
            {
                // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
                pattern: /"""[\s\S]*?"""/,
                greedy: true
            },
            {
                pattern: /"(?:[^\\"\r\n]|\\.)*"/,
                greedy: true
            }
        ],
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|exposing|import)\b/
            }
        },
        keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
        // decimal integers and floating point numbers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
        // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
        operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
        // In Elm, nearly everything is a variable, do not highlight these.
        hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
        constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
        punctuation: /[{}[\]|(),.:]/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$24261424b318a546$export$2e2bcd8739ae039.displayName = 'etlua';
$24261424b318a546$export$2e2bcd8739ae039.aliases = [];
function $24261424b318a546$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $20b8caf8b024dc15$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.etlua = {
            delimiter: {
                pattern: /^<%[-=]?|-?%>$/,
                alias: 'punctuation'
            },
            'language-lua': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.lua
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var pattern = /<%[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'etlua', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'etlua');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$81a7c5742f763317$export$2e2bcd8739ae039.displayName = 'erb';
$81a7c5742f763317$export$2e2bcd8739ae039.aliases = [];
function $81a7c5742f763317$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.register((0, $0814f5761e025965$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.erb = {
            delimiter: {
                pattern: /^(\s*)<%=?|%>(?=\s*$)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            ruby: {
                pattern: /\s*\S[\s\S]*/,
                alias: 'language-ruby',
                inside: Prism.languages.ruby
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var erbPattern = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'erb', erbPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'erb');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $645d653be7f1e246$export$2e2bcd8739ae039.displayName = 'erlang';
$645d653be7f1e246$export$2e2bcd8739ae039.aliases = [];
function $645d653be7f1e246$export$2e2bcd8739ae039(Prism) {
    Prism.languages.erlang = {
        comment: /%.+/,
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        'quoted-function': {
            pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
            alias: 'function'
        },
        'quoted-atom': {
            pattern: /'(?:\\.|[^\\'\r\n])+'/,
            alias: 'atom'
        },
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:after|begin|case|catch|end|fun|if|of|receive|try|when)\b/,
        number: [
            /\$\\?./,
            /\b\d+#[a-z0-9]+/i,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
        ],
        function: /\b[a-z][\w@]*(?=\()/,
        variable: {
            // Look-behind is used to prevent wrong highlighting of atoms containing "@"
            pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
            lookbehind: true
        },
        operator: [
            /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        atom: /\b[a-z][\w@]*/,
        punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $23b4532be12400bd$export$2e2bcd8739ae039.displayName = 'excel-formula';
$23b4532be12400bd$export$2e2bcd8739ae039.aliases = [
    'xls',
    'xlsx'
];
function $23b4532be12400bd$export$2e2bcd8739ae039(Prism) {
    Prism.languages['excel-formula'] = {
        comment: {
            pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        reference: {
            // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
            // Sales!B2
            // 'Winter sales'!B2
            // [Sales.xlsx]Jan!B2:B5
            // D:\Reports\[Sales.xlsx]Jan!B2:B5
            // '[Sales.xlsx]Jan sales'!B2:B5
            // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
            pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
            greedy: true,
            alias: 'string',
            inside: {
                operator: /!$/,
                punctuation: /'/,
                sheet: {
                    pattern: /[^[\]]+$/,
                    alias: 'function'
                },
                file: {
                    pattern: /\[[^[\]]+\]$/,
                    inside: {
                        punctuation: /[[\]]/
                    }
                },
                path: /[\s\S]+/
            }
        },
        'function-name': {
            pattern: /\b[A-Z]\w*(?=\()/i,
            alias: 'builtin'
        },
        range: {
            pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
            alias: 'selector',
            inside: {
                operator: /:/,
                cell: /\$?[A-Z]+\$?\d+/i,
                column: /\$?[A-Z]+/i,
                row: /\$?\d+/
            }
        },
        cell: {
            // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
            // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
            pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
            alias: 'selector'
        },
        number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        operator: /[-+*/^%=&,]|<[=>]?|>=?/,
        punctuation: /[[\]();{}|]/
    };
    Prism.languages['xlsx'] = Prism.languages['xls'] = Prism.languages['excel-formula'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$03636fbb6bcf9de6$export$2e2bcd8739ae039.displayName = 'fsharp';
$03636fbb6bcf9de6$export$2e2bcd8739ae039.aliases = [];
function $03636fbb6bcf9de6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.fsharp = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
            lookbehind: true,
            inside: {
                operator: /->|\*/,
                punctuation: /\./
            }
        },
        keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
        number: [
            /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
            /\b0b[01]+(?:uy|y)?\b/,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
            /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
        ],
        operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    });
    Prism.languages.insertBefore('fsharp', 'keyword', {
        preprocessor: {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
                    lookbehind: true,
                    alias: 'keyword'
                }
            }
        }
    });
    Prism.languages.insertBefore('fsharp', 'punctuation', {
        'computation-expression': {
            pattern: /\b[_a-z]\w*(?=\s*\{)/i,
            alias: 'keyword'
        }
    });
    Prism.languages.insertBefore('fsharp', 'string', {
        annotation: {
            pattern: /\[<.+?>\]/,
            greedy: true,
            inside: {
                punctuation: /^\[<|>\]$/,
                'class-name': {
                    pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
                    lookbehind: true
                },
                'annotation-content': {
                    pattern: /[\s\S]+/,
                    inside: Prism.languages.fsharp
                }
            }
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
            greedy: true
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d1ff02eb2618944d$export$2e2bcd8739ae039.displayName = 'factor';
$d1ff02eb2618944d$export$2e2bcd8739ae039.aliases = [];
function $d1ff02eb2618944d$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment_inside = {
            function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
        };
        var string_inside = {
            number: /\\[^\s']|%\w/
        };
        var factor = {
            comment: [
                {
                    // ! single-line exclamation point comments with whitespace after/around the !
                    pattern: /(^|\s)(?:! .*|!$)/,
                    lookbehind: true,
                    inside: comment_inside
                } /* from basis/multiline: */ ,
                {
                    // /* comment */, /* comment*/
                    pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                },
                {
                    // ![[ comment ]] , ![===[ comment]===]
                    pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                }
            ],
            number: [
                {
                    // basic base 10 integers 9, -9
                    pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
                    pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
                    pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // positive mixed numbers 23+1/5 +23+1/5
                    pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // negative mixed numbers -23-1/5
                    pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
                    // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
                    pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // NAN literal syntax NAN: 80000deadbeef, NAN: a
                    pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    /*
base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
"The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
<https://docs.factorcode.org/content/article-syntax-floats.html>
*/ pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
                    lookbehind: true
                }
            ],
            // R/ regexp?\/\\/
            regexp: {
                pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
                lookbehind: true,
                alias: 'number',
                inside: {
                    variable: /\\\S/,
                    keyword: /[+?*\[\]^$(){}.|]/,
                    operator: {
                        pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
                        lookbehind: true
                    }
                }
            },
            boolean: {
                pattern: /(^|\s)[tf](?=\s|$)/,
                lookbehind: true
            },
            // SBUF" asd", URL" ://...", P" /etc/"
            'custom-string': {
                pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
                lookbehind: true,
                greedy: true,
                alias: 'string',
                inside: {
                    number: /\\\S|%\w|\//
                }
            },
            'multiline-string': [
                {
                    // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
                    pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        number: string_inside.number,
                        // trailing semicolon on its own line
                        'semicolon-or-setlocal': {
                            pattern: /([\r\n][ \t]*);(?=\s|$)/,
                            lookbehind: true,
                            alias: 'function'
                        }
                    }
                },
                {
                    // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
                    pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                },
                {
                    // [[ string ]], [==[ string]==]
                    pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                }
            ],
            'special-using': {
                pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
                lookbehind: true,
                alias: 'function',
                inside: {
                    // this is essentially a regex for vocab names, which i don't want to specify
                    // but the USING: gets picked up as a vocab name
                    string: {
                        pattern: /(\s)[^:\s]+/,
                        lookbehind: true
                    }
                }
            },
            /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
trying to do better is more work and regex-computation-time than it's worth though.
- we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
- we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
- we'd like if the following variable name conventions were recognised specifically:
special row variables = ..a b..
type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
word throws unconditional error = *
any other word-like variable name = a ? q' etc
https://docs.factorcode.org/content/article-effects.html
these are pretty complicated to highlight properly without a real parser, and therefore out of scope
the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
*/ // current solution is not great
            'stack-effect-delimiter': [
                {
                    // opening parenthesis
                    pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // middle --
                    pattern: /(\s)--(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing parenthesis
                    pattern: /(\s)\)(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            combinators: {
                pattern: null,
                lookbehind: true,
                alias: 'keyword'
            },
            'kernel-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'sequences-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'math-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'constructor-word': {
                // <array> but not <=>
                pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'other-builtin-syntax': {
                pattern: null,
                lookbehind: true,
                alias: 'operator'
            },
            /*
full list of supported word naming conventions: (the convention appears outside of the [brackets])
set-[x]
change-[x]
with-[x]
new-[x]
>[string]
[base]>
[string]>[number]
+[symbol]+
[boolean-word]?
?[of]
[slot-reader]>>
>>[slot-setter]
[slot-writer]<<
([implementation-detail])
[mutater]!
[variant]*
[prettyprint].
$[help-markup]
<constructors>, SYNTAX:, etc are supported by their own patterns.
`with` and `new` from `kernel` are their own builtins.
see <https://docs.factorcode.org/content/article-conventions.html>
*/ 'conventionally-named-word': {
                pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'colon-syntax': {
                pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'semicolon-or-setlocal': {
                pattern: /(\s)(?:;|:>)(?=\s|$)/,
                lookbehind: true,
                alias: 'function'
            },
            // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
            'curly-brace-literal-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)[a-z]*\{(?=\s)/i,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\}(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
            'quotation-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)\[(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\](?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            'normal-word': {
                pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
                lookbehind: true
            },
            /*
basic first-class string "a"
with escaped double-quote "a\""
escaped backslash "\\"
and general escapes since Factor has so many "\N"
syntax that works in the reference implementation that isn't fully
supported because it's an implementation detail:
"string 1""string 2" -> 2 strings (works anyway)
"string"5 -> string, 5
"string"[ ] -> string, quotation
{ "a"} -> array<string>
the rest of those examples all properly recognise the string, but not
the other object (number, quotation, etc)
this is fine for a regex-only implementation.
*/ string: {
                pattern: /"(?:\\\S|[^"\\])*"/,
                greedy: true,
                inside: string_inside
            }
        };
        var escape = function(str) {
            return (str + '').replace(/([.?*+\^$\[\]\\(){}|\-])/g, '\\$1');
        };
        var arrToWordsRegExp = function(arr) {
            return new RegExp('(^|\\s)(?:' + arr.map(escape).join('|') + ')(?=\\s|$)');
        };
        var builtins = {
            'kernel-builtin': [
                'or',
                '2nipd',
                '4drop',
                'tuck',
                'wrapper',
                'nip',
                'wrapper?',
                'callstack>array',
                'die',
                'dupd',
                'callstack',
                'callstack?',
                '3dup',
                'hashcode',
                'pick',
                '4nip',
                'build',
                '>boolean',
                'nipd',
                'clone',
                '5nip',
                'eq?',
                '?',
                '=',
                'swapd',
                '2over',
                'clear',
                '2dup',
                'get-retainstack',
                'not',
                'tuple?',
                'dup',
                '3nipd',
                'call',
                '-rotd',
                'object',
                'drop',
                'assert=',
                'assert?',
                '-rot',
                'execute',
                'boa',
                'get-callstack',
                'curried?',
                '3drop',
                'pickd',
                'overd',
                'over',
                'roll',
                '3nip',
                'swap',
                'and',
                '2nip',
                'rotd',
                'throw',
                '(clone)',
                'hashcode*',
                'spin',
                'reach',
                '4dup',
                'equal?',
                'get-datastack',
                'assert',
                '2drop',
                '<wrapper>',
                'boolean?',
                'identity-hashcode',
                'identity-tuple?',
                'null',
                'composed?',
                'new',
                '5drop',
                'rot',
                '-roll',
                'xor',
                'identity-tuple',
                'boolean'
            ],
            'other-builtin-syntax': [
                // syntax
                '=======',
                'recursive',
                'flushable',
                '>>',
                '<<<<<<',
                'M\\',
                'B',
                'PRIVATE>',
                '\\',
                '======',
                'final',
                'inline',
                'delimiter',
                'deprecated',
                '<PRIVATE',
                '>>>>>>',
                '<<<<<<<',
                'parse-complex',
                'malformed-complex',
                'read-only',
                '>>>>>>>',
                'call-next-method',
                '<<',
                'foldable',
                // literals
                '$',
                '$[',
                '${'
            ],
            'sequences-builtin': [
                'member-eq?',
                'mismatch',
                'append',
                'assert-sequence=',
                'longer',
                'repetition',
                'clone-like',
                '3sequence',
                'assert-sequence?',
                'last-index-from',
                'reversed',
                'index-from',
                'cut*',
                'pad-tail',
                'join-as',
                'remove-eq!',
                'concat-as',
                'but-last',
                'snip',
                'nths',
                'nth',
                'sequence',
                'longest',
                'slice?',
                '<slice>',
                'remove-nth',
                'tail-slice',
                'empty?',
                'tail*',
                'member?',
                'virtual-sequence?',
                'set-length',
                'drop-prefix',
                'iota',
                'unclip',
                'bounds-error?',
                'unclip-last-slice',
                'non-negative-integer-expected',
                'non-negative-integer-expected?',
                'midpoint@',
                'longer?',
                '?set-nth',
                '?first',
                'rest-slice',
                'prepend-as',
                'prepend',
                'fourth',
                'sift',
                'subseq-start',
                'new-sequence',
                '?last',
                'like',
                'first4',
                '1sequence',
                'reverse',
                'slice',
                'virtual@',
                'repetition?',
                'set-last',
                'index',
                '4sequence',
                'max-length',
                'set-second',
                'immutable-sequence',
                'first2',
                'first3',
                'supremum',
                'unclip-slice',
                'suffix!',
                'insert-nth',
                'tail',
                '3append',
                'short',
                'suffix',
                'concat',
                'flip',
                'immutable?',
                'reverse!',
                '2sequence',
                'sum',
                'delete-all',
                'indices',
                'snip-slice',
                '<iota>',
                'check-slice',
                'sequence?',
                'head',
                'append-as',
                'halves',
                'sequence=',
                'collapse-slice',
                '?second',
                'slice-error?',
                'product',
                'bounds-check?',
                'bounds-check',
                'immutable',
                'virtual-exemplar',
                'harvest',
                'remove',
                'pad-head',
                'last',
                'set-fourth',
                'cartesian-product',
                'remove-eq',
                'shorten',
                'shorter',
                'reversed?',
                'shorter?',
                'shortest',
                'head-slice',
                'pop*',
                'tail-slice*',
                'but-last-slice',
                'iota?',
                'append!',
                'cut-slice',
                'new-resizable',
                'head-slice*',
                'sequence-hashcode',
                'pop',
                'set-nth',
                '?nth',
                'second',
                'join',
                'immutable-sequence?',
                '<reversed>',
                '3append-as',
                'virtual-sequence',
                'subseq?',
                'remove-nth!',
                'length',
                'last-index',
                'lengthen',
                'assert-sequence',
                'copy',
                'move',
                'third',
                'first',
                'tail?',
                'set-first',
                'prefix',
                'bounds-error',
                '<repetition>',
                'exchange',
                'surround',
                'cut',
                'min-length',
                'set-third',
                'push-all',
                'head?',
                'subseq-start-from',
                'delete-slice',
                'rest',
                'sum-lengths',
                'head*',
                'infimum',
                'remove!',
                'glue',
                'slice-error',
                'subseq',
                'push',
                'replace-slice',
                'subseq-as',
                'unclip-last'
            ],
            'math-builtin': [
                'number=',
                'next-power-of-2',
                '?1+',
                'fp-special?',
                'imaginary-part',
                'float>bits',
                'number?',
                'fp-infinity?',
                'bignum?',
                'fp-snan?',
                'denominator',
                'gcd',
                '*',
                '+',
                'fp-bitwise=',
                '-',
                'u>=',
                '/',
                '>=',
                'bitand',
                'power-of-2?',
                'log2-expects-positive',
                'neg?',
                '<',
                'log2',
                '>',
                'integer?',
                'number',
                'bits>double',
                '2/',
                'zero?',
                'bits>float',
                'float?',
                'shift',
                'ratio?',
                'rect>',
                'even?',
                'ratio',
                'fp-sign',
                'bitnot',
                '>fixnum',
                'complex?',
                '/i',
                'integer>fixnum',
                '/f',
                'sgn',
                '>bignum',
                'next-float',
                'u<',
                'u>',
                'mod',
                'recip',
                'rational',
                '>float',
                '2^',
                'integer',
                'fixnum?',
                'neg',
                'fixnum',
                'sq',
                'bignum',
                '>rect',
                'bit?',
                'fp-qnan?',
                'simple-gcd',
                'complex',
                '<fp-nan>',
                'real',
                '>fraction',
                'double>bits',
                'bitor',
                'rem',
                'fp-nan-payload',
                'real-part',
                'log2-expects-positive?',
                'prev-float',
                'align',
                'unordered?',
                'float',
                'fp-nan?',
                'abs',
                'bitxor',
                'integer>fixnum-strict',
                'u<=',
                'odd?',
                '<=',
                '/mod',
                '>integer',
                'real?',
                'rational?',
                'numerator'
            ]
        };
        Object.keys(builtins).forEach(function(k) {
            factor[k].pattern = arrToWordsRegExp(builtins[k]);
        });
        var combinators = [
            // kernel
            '2bi',
            'while',
            '2tri',
            'bi*',
            '4dip',
            'both?',
            'same?',
            'tri@',
            'curry',
            'prepose',
            '3bi',
            '?if',
            'tri*',
            '2keep',
            '3keep',
            'curried',
            '2keepd',
            'when',
            '2bi*',
            '2tri*',
            '4keep',
            'bi@',
            'keepdd',
            'do',
            'unless*',
            'tri-curry',
            'if*',
            'loop',
            'bi-curry*',
            'when*',
            '2bi@',
            '2tri@',
            'with',
            '2with',
            'either?',
            'bi',
            'until',
            '3dip',
            '3curry',
            'tri-curry*',
            'tri-curry@',
            'bi-curry',
            'keepd',
            'compose',
            '2dip',
            'if',
            '3tri',
            'unless',
            'tuple',
            'keep',
            '2curry',
            'tri',
            'most',
            'while*',
            'dip',
            'composed',
            'bi-curry@',
            // sequences
            'find-last-from',
            'trim-head-slice',
            'map-as',
            'each-from',
            'none?',
            'trim-tail',
            'partition',
            'if-empty',
            'accumulate*',
            'reject!',
            'find-from',
            'accumulate-as',
            'collector-for-as',
            'reject',
            'map',
            'map-sum',
            'accumulate!',
            '2each-from',
            'follow',
            'supremum-by',
            'map!',
            'unless-empty',
            'collector',
            'padding',
            'reduce-index',
            'replicate-as',
            'infimum-by',
            'trim-tail-slice',
            'count',
            'find-index',
            'filter',
            'accumulate*!',
            'reject-as',
            'map-integers',
            'map-find',
            'reduce',
            'selector',
            'interleave',
            '2map',
            'filter-as',
            'binary-reduce',
            'map-index-as',
            'find',
            'produce',
            'filter!',
            'replicate',
            'cartesian-map',
            'cartesian-each',
            'find-index-from',
            'map-find-last',
            '3map-as',
            '3map',
            'find-last',
            'selector-as',
            '2map-as',
            '2map-reduce',
            'accumulate',
            'each',
            'each-index',
            'accumulate*-as',
            'when-empty',
            'all?',
            'collector-as',
            'push-either',
            'new-like',
            'collector-for',
            '2selector',
            'push-if',
            '2all?',
            'map-reduce',
            '3each',
            'any?',
            'trim-slice',
            '2reduce',
            'change-nth',
            'produce-as',
            '2each',
            'trim',
            'trim-head',
            'cartesian-find',
            'map-index',
            // math
            'if-zero',
            'each-integer',
            'unless-zero',
            '(find-integer)',
            'when-zero',
            'find-last-integer',
            '(all-integers?)',
            'times',
            '(each-integer)',
            'find-integer',
            'all-integers?',
            // math.combinators
            'unless-negative',
            'if-positive',
            'when-positive',
            'when-negative',
            'unless-positive',
            'if-negative',
            // combinators
            'case',
            '2cleave',
            'cond>quot',
            'case>quot',
            '3cleave',
            'wrong-values',
            'to-fixed-point',
            'alist>quot',
            'cond',
            'cleave',
            'call-effect',
            'recursive-hashcode',
            'spread',
            'deep-spread>quot',
            // combinators.short-circuit
            '2||',
            '0||',
            'n||',
            '0&&',
            '2&&',
            '3||',
            '1||',
            '1&&',
            'n&&',
            '3&&',
            // combinators.smart
            'smart-unless*',
            'keep-inputs',
            'reduce-outputs',
            'smart-when*',
            'cleave>array',
            'smart-with',
            'smart-apply',
            'smart-if',
            'inputs/outputs',
            'output>sequence-n',
            'map-outputs',
            'map-reduce-outputs',
            'dropping',
            'output>array',
            'smart-map-reduce',
            'smart-2map-reduce',
            'output>array-n',
            'nullary',
            'input<sequence',
            'append-outputs',
            'drop-inputs',
            'inputs',
            'smart-2reduce',
            'drop-outputs',
            'smart-reduce',
            'preserving',
            'smart-when',
            'outputs',
            'append-outputs-as',
            'smart-unless',
            'smart-if*',
            'sum-outputs',
            'input<sequence-unsafe',
            'output>sequence'
        ];
        factor.combinators.pattern = arrToWordsRegExp(combinators);
        Prism.languages.factor = factor;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0690cd6d0a840968$export$2e2bcd8739ae039.displayName = 'false';
$0690cd6d0a840968$export$2e2bcd8739ae039.aliases = [];
function $0690cd6d0a840968$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Based on the manual by Wouter van Oortmerssen.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2801#issue-829717504}
     */ Prism.languages['false'] = {
            comment: {
                pattern: /\{[^}]*\}/
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            'character-code': {
                pattern: /'(?:[^\r]|\r\n?)/,
                alias: 'number'
            },
            'assembler-code': {
                pattern: /\d+`/,
                alias: 'important'
            },
            number: /\d+/,
            operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
            punctuation: /\[|\]/,
            variable: /[a-z]/,
            'non-standard': {
                pattern: /[()<BDO®]/,
                alias: 'bold'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b30f7170c1780bbb$export$2e2bcd8739ae039.displayName = 'firestore-security-rules';
$b30f7170c1780bbb$export$2e2bcd8739ae039.aliases = [];
function $b30f7170c1780bbb$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages['firestore-security-rules'] = Prism.languages.extend('clike', {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
    });
    delete Prism.languages['firestore-security-rules']['class-name'];
    Prism.languages.insertBefore('firestore-security-rules', 'keyword', {
        path: {
            pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
                    inside: {
                        operator: /=/,
                        keyword: /\*\*/,
                        punctuation: /[.$(){}]/
                    }
                },
                punctuation: /\//
            }
        },
        method: {
            // to make the pattern shorter, the actual method names are omitted
            pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
            lookbehind: true,
            alias: 'builtin',
            inside: {
                punctuation: /,/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$589c0bdcaa161eef$export$2e2bcd8739ae039.displayName = 'flow';
$589c0bdcaa161eef$export$2e2bcd8739ae039.aliases = [];
function $589c0bdcaa161eef$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.flow = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('flow', 'keyword', {
            type: [
                {
                    pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                    alias: 'class-name'
                }
            ]
        });
        Prism.languages.flow['function-variable'].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i;
        delete Prism.languages.flow['parameter'];
        Prism.languages.insertBefore('flow', 'operator', {
            'flow-punctuation': {
                pattern: /\{\||\|\}/,
                alias: 'punctuation'
            }
        });
        if (!Array.isArray(Prism.languages.flow.keyword)) Prism.languages.flow.keyword = [
            Prism.languages.flow.keyword
        ];
        Prism.languages.flow.keyword.unshift({
            pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
            lookbehind: true
        }, {
            pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
            lookbehind: true
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1f14745690836bca$export$2e2bcd8739ae039.displayName = 'fortran';
$1f14745690836bca$export$2e2bcd8739ae039.aliases = [];
function $1f14745690836bca$export$2e2bcd8739ae039(Prism) {
    Prism.languages.fortran = {
        'quoted-number': {
            pattern: /[BOZ](['"])[A-F0-9]+\1/i,
            alias: 'number'
        },
        string: {
            pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
            inside: {
                comment: {
                    pattern: /(&(?:\r\n?|\n)\s*)!.*/,
                    lookbehind: true
                }
            }
        },
        comment: {
            pattern: /!.*/,
            greedy: true
        },
        boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
        keyword: [
            // Types
            /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
            // END statements
            /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
            // Statements
            /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
            // Others
            /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
        ],
        operator: [
            /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
            {
                // Use lookbehind to prevent confusion with (/ /)
                pattern: /(^|(?!\().)\/(?!\))/,
                lookbehind: true
            }
        ],
        punctuation: /\(\/|\/\)|[(),;:&]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$c4bd90163a636571$export$2e2bcd8739ae039.displayName = 'ftl';
$c4bd90163a636571$export$2e2bcd8739ae039.aliases = [];
function $c4bd90163a636571$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        // https://freemarker.apache.org/docs/dgui_template_exp.html
        // FTL expression with 4 levels of nesting supported
        var FTL_EXPR = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source;
        for(var i = 0; i < 2; i++)FTL_EXPR = FTL_EXPR.replace(/<expr>/g, function() {
            return FTL_EXPR;
        });
        FTL_EXPR = FTL_EXPR.replace(/<expr>/g, /[^\s\S]/.source);
        var ftl = {
            comment: /<#--[\s\S]*?-->/,
            string: [
                {
                    // raw string
                    pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
                    greedy: true
                },
                {
                    pattern: RegExp(/("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(/<expr>/g, function() {
                        return FTL_EXPR;
                    })),
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: RegExp(/((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(/<expr>/g, function() {
                                return FTL_EXPR;
                            })),
                            lookbehind: true,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^\$\{|\}$/,
                                    alias: 'punctuation'
                                },
                                rest: null
                            }
                        }
                    }
                }
            ],
            keyword: /\b(?:as)\b/,
            boolean: /\b(?:false|true)\b/,
            'builtin-function': {
                pattern: /((?:^|[^?])\?\s*)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b\w+(?=\s*\()/,
            number: /\b\d+(?:\.\d+)?\b/,
            operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
            punctuation: /[,;.:()[\]{}]/
        };
        ftl.string[1].inside.interpolation.inside.rest = ftl;
        Prism.languages.ftl = {
            'ftl-comment': {
                // the pattern is shortened to be more efficient
                pattern: /^<#--[\s\S]*/,
                alias: 'comment'
            },
            'ftl-directive': {
                pattern: /^<[\s\S]+>$/,
                inside: {
                    directive: {
                        pattern: /(^<\/?)[#@][a-z]\w*/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    punctuation: /^<\/?|\/?>$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            },
            'ftl-interpolation': {
                pattern: /^\$\{[\s\S]*\}$/,
                inside: {
                    punctuation: /^\$\{|\}$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            // eslint-disable-next-line regexp/no-useless-lazy
            var pattern = RegExp(/<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(/<expr>/g, function() {
                return FTL_EXPR;
            }), 'gi');
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ftl', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ftl');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d04717890a46cf2e$export$2e2bcd8739ae039.displayName = 'gml';
$d04717890a46cf2e$export$2e2bcd8739ae039.aliases = [
    'gamemakerlanguage'
];
function $d04717890a46cf2e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.gamemakerlanguage = Prism.languages.gml = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
        number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
        operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
        constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
        variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $79b0be010e76d7ca$export$2e2bcd8739ae039.displayName = 'gap';
$79b0be010e76d7ca$export$2e2bcd8739ae039.aliases = [];
function $79b0be010e76d7ca$export$2e2bcd8739ae039(Prism) {
    // https://www.gap-system.org/Manuals/doc/ref/chap4.html
    // https://www.gap-system.org/Manuals/doc/ref/chap27.html
    Prism.languages.gap = {
        shell: {
            pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
            greedy: true,
            inside: {
                gap: {
                    pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
                    lookbehind: true,
                    inside: null // see below
                },
                punctuation: /^gap>/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
            lookbehind: true,
            greedy: true,
            inside: {
                continuation: {
                    pattern: /([\r\n])>/,
                    lookbehind: true,
                    alias: 'punctuation'
                }
            }
        },
        keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        continuation: {
            pattern: /([\r\n])>/,
            lookbehind: true,
            alias: 'punctuation'
        },
        operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
        punctuation: /[()[\]{},;.:]/
    };
    Prism.languages.gap.shell.inside.gap.inside = Prism.languages.gap;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $3ad1242016c38065$export$2e2bcd8739ae039.displayName = 'gcode';
$3ad1242016c38065$export$2e2bcd8739ae039.aliases = [];
function $3ad1242016c38065$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gcode = {
        comment: /;.*|\B\(.*?\)\B/,
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        keyword: /\b[GM]\d+(?:\.\d+)?\b/,
        property: /\b[A-Z]/,
        checksum: {
            pattern: /(\*)\d+/,
            lookbehind: true,
            alias: 'number'
        },
        // T0:0:0
        punctuation: /[:*]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $675c24a063f84cbd$export$2e2bcd8739ae039.displayName = 'gdscript';
$675c24a063f84cbd$export$2e2bcd8739ae039.aliases = [];
function $675c24a063f84cbd$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gdscript = {
        comment: /#.*/,
        string: {
            pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
            greedy: true
        },
        'class-name': {
            // class_name Foo, extends Bar, class InnerClass
            // export(int) var baz, export(int, 0) var i
            // as Node
            // const FOO: int = 9, var bar: bool = true
            // func add(reference: Item, amount: int) -> Item:
            pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
            lookbehind: true
        },
        keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        variable: /\$\w+/,
        number: [
            /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
            /\b(?:INF|NAN|PI|TAU)\b/
        ],
        constant: /\b[A-Z][A-Z_\d]*\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
        punctuation: /[.:,;()[\]{}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b7509ddd058c90d0$export$2e2bcd8739ae039.displayName = 'gedcom';
$b7509ddd058c90d0$export$2e2bcd8739ae039.aliases = [];
function $b7509ddd058c90d0$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gedcom = {
        'line-value': {
            // Preceded by level, optional pointer, and tag
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
            lookbehind: true,
            inside: {
                pointer: {
                    pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
                    alias: 'variable'
                }
            }
        },
        record: {
            // Preceded by level and optional pointer
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
            lookbehind: true,
            alias: 'tag'
        },
        level: {
            pattern: /(^[\t ]*)\d+/m,
            lookbehind: true,
            alias: 'number'
        },
        pointer: {
            pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
            alias: 'variable'
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $ec3042630860b388$export$2e2bcd8739ae039.displayName = 'gettext';
$ec3042630860b388$export$2e2bcd8739ae039.aliases = [
    'po'
];
function $ec3042630860b388$export$2e2bcd8739ae039(Prism) {
    Prism.languages.gettext = {
        comment: [
            {
                pattern: /# .*/,
                greedy: true,
                alias: 'translator-comment'
            },
            {
                pattern: /#\..*/,
                greedy: true,
                alias: 'extracted-comment'
            },
            {
                pattern: /#:.*/,
                greedy: true,
                alias: 'reference-comment'
            },
            {
                pattern: /#,.*/,
                greedy: true,
                alias: 'flag-comment'
            },
            {
                pattern: /#\|.*/,
                greedy: true,
                alias: 'previously-untranslated-comment'
            },
            {
                pattern: /#.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\])"(?:[^"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        keyword: /^msg(?:ctxt|id|id_plural|str)\b/m,
        number: /\b\d+\b/,
        punctuation: /[\[\]]/
    };
    Prism.languages.po = Prism.languages.gettext;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e41ae20b134c7e19$export$2e2bcd8739ae039.displayName = 'gherkin';
$e41ae20b134c7e19$export$2e2bcd8739ae039.aliases = [];
function $e41ae20b134c7e19$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var tableRow = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
        Prism.languages.gherkin = {
            pystring: {
                pattern: /("""|''')[\s\S]+?\1/,
                alias: 'string'
            },
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[ \t]*)@\S*/m,
                lookbehind: true
            },
            feature: {
                pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]+/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            scenario: {
                pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]*/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            'table-body': {
                // Look-behind is used to skip the table head, which has the same format as any table row
                pattern: RegExp('(' + tableRow + ')(?:' + tableRow + ')+'),
                lookbehind: true,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    },
                    td: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'string'
                    },
                    punctuation: /\|/
                }
            },
            'table-head': {
                pattern: RegExp(tableRow),
                inside: {
                    th: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'variable'
                    },
                    punctuation: /\|/
                }
            },
            atrule: {
                pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
                lookbehind: true
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    }
                }
            },
            outline: {
                pattern: /<[^>]+>/,
                alias: 'variable'
            }
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b8a98b0ff64a5cd4$export$2e2bcd8739ae039.displayName = 'git';
$b8a98b0ff64a5cd4$export$2e2bcd8739ae039.aliases = [];
function $b8a98b0ff64a5cd4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.git = {
        /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */ comment: /^#.*/m,
        /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */ deleted: /^[-–].*/m,
        inserted: /^\+.*/m,
        /*
     * a string (double and simple quote)
     */ string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */ command: {
            pattern: /^.*\$ git .*$/m,
            inside: {
                /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */ parameter: /\s--?\w+/
            }
        },
        /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */ coord: /^@@.*@@$/m,
        /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */ 'commit-sha1': /^commit \w{40}$/m
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a9f5bac9ba5085d8$export$2e2bcd8739ae039.displayName = 'glsl';
$a9f5bac9ba5085d8$export$2e2bcd8739ae039.aliases = [];
function $a9f5bac9ba5085d8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.glsl = Prism.languages.extend('c', {
        keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5bfce00dfe9edf4d$export$2e2bcd8739ae039.displayName = 'gn';
$5bfce00dfe9edf4d$export$2e2bcd8739ae039.aliases = [
    'gni'
];
function $5bfce00dfe9edf4d$export$2e2bcd8739ae039(Prism) {
    // https://gn.googlesource.com/gn/+/refs/heads/main/docs/reference.md#grammar
    Prism.languages.gn = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
                    lookbehind: true,
                    inside: {
                        number: /^\$0x[\s\S]{2}$/,
                        variable: /^\$\w+$/,
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        keyword: /\b(?:else|if)\b/,
        boolean: /\b(?:false|true)\b/,
        'builtin-function': {
            // a few functions get special highlighting to improve readability
            pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
            alias: 'keyword'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
        number: /-?\b\d+\b/,
        operator: /[-+!=<>]=?|&&|\|\|/,
        punctuation: /[(){}[\],.]/
    };
    Prism.languages.gn['string-literal'].inside['interpolation'].inside['expression'].inside = Prism.languages.gn;
    Prism.languages.gni = Prism.languages.gn;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $47dfe45f952c98c2$export$2e2bcd8739ae039.displayName = 'linker-script';
$47dfe45f952c98c2$export$2e2bcd8739ae039.aliases = [
    'ld'
];
function $47dfe45f952c98c2$export$2e2bcd8739ae039(Prism) {
    Prism.languages['linker-script'] = {
        comment: {
            pattern: /(^|\s)\/\*[\s\S]*?(?:$|\*\/)/,
            lookbehind: true,
            greedy: true
        },
        identifier: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        'location-counter': {
            pattern: /\B\.\B/,
            alias: 'important'
        },
        section: {
            pattern: /(^|[^\w*])\.\w+\b/,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b[A-Z][A-Z_]*(?=\s*\()/,
        number: /\b(?:0[xX][a-fA-F0-9]+|\d+)[KM]?\b/,
        operator: />>=?|<<=?|->|\+\+|--|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?/,
        punctuation: /[(){},;]/
    };
    Prism.languages['ld'] = Prism.languages['linker-script'];
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9f945d890adcf850$export$2e2bcd8739ae039.displayName = 'go-module';
$9f945d890adcf850$export$2e2bcd8739ae039.aliases = [
    'go-mod'
];
function $9f945d890adcf850$export$2e2bcd8739ae039(Prism) {
    // https://go.dev/ref/mod#go-mod-file-module
    Prism.languages['go-mod'] = Prism.languages['go-module'] = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        version: {
            pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
            lookbehind: true,
            alias: 'number'
        },
        'go-version': {
            pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
            lookbehind: true,
            alias: 'number'
        },
        keyword: {
            pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
            lookbehind: true
        },
        operator: /=>/,
        punctuation: /[()[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$cd8c18afbde31359$export$2e2bcd8739ae039.displayName = 'gradle';
$cd8c18afbde31359$export$2e2bcd8739ae039.aliases = [];
function $cd8c18afbde31359$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolation = {
            pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
            lookbehind: true,
            inside: {
                'interpolation-punctuation': {
                    pattern: /^\$\{?|\}$/,
                    alias: 'punctuation'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null
                }
            }
        };
        Prism.languages.gradle = Prism.languages.extend('clike', {
            string: {
                pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
                greedy: true
            },
            keyword: /\b(?:apply|def|dependencies|else|if|implementation|import|plugin|plugins|project|repositories|repository|sourceSets|tasks|val)\b/,
            number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
            operator: {
                pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
                lookbehind: true
            },
            punctuation: /\.+|[{}[\];(),:$]/
        });
        Prism.languages.insertBefore('gradle', 'string', {
            shebang: {
                pattern: /#!.+/,
                alias: 'comment',
                greedy: true
            },
            'interpolation-string': {
                pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true,
                inside: {
                    interpolation: interpolation,
                    string: /[\s\S]+/
                }
            }
        });
        Prism.languages.insertBefore('gradle', 'punctuation', {
            'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
        });
        Prism.languages.insertBefore('gradle', 'function', {
            annotation: {
                pattern: /(^|[^.])@\w+/,
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        interpolation.inside.expression.inside = Prism.languages.gradle;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c77c0e4272178579$export$2e2bcd8739ae039.displayName = 'graphql';
$c77c0e4272178579$export$2e2bcd8739ae039.aliases = [];
function $c77c0e4272178579$export$2e2bcd8739ae039(Prism) {
    Prism.languages.graphql = {
        comment: /#.*/,
        description: {
            pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
            greedy: true,
            alias: 'string',
            inside: {
                'language-markdown': {
                    pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: Prism.languages.markdown
                }
            }
        },
        string: {
            pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:false|true)\b/,
        variable: /\$[a-z_]\w*/i,
        directive: {
            pattern: /@[a-z_]\w*/i,
            alias: 'function'
        },
        'attr-name': {
            pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
            greedy: true
        },
        'atom-input': {
            pattern: /\b[A-Z]\w*Input\b/,
            alias: 'class-name'
        },
        scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
        constant: /\b[A-Z][A-Z_\d]*\b/,
        'class-name': {
            pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
            lookbehind: true
        },
        fragment: {
            pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-mutation': {
            pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-query': {
            pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
        operator: /[!=|&]|\.{3}/,
        'property-query': /\w+(?=\s*\()/,
        object: /\w+(?=\s*\{)/,
        punctuation: /[!(){}\[\]:=,]/,
        property: /\w+/
    };
    Prism.hooks.add('after-tokenize', function afterTokenizeGraphql(env) {
        if (env.language !== 'graphql') return;
        /**
     * get the graphql token stream that we want to customize
     *
     * @typedef {InstanceType<import("./prism-core")["Token"]>} Token
     * @type {Token[]}
     */ var validTokens = env.tokens.filter(function(token) {
            return typeof token !== 'string' && token.type !== 'comment' && token.type !== 'scalar';
        });
        var currentIndex = 0;
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {number} offset
     * @returns {Token | undefined}
     */ function getToken(offset) {
            return validTokens[currentIndex + offset];
        }
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {readonly string[]} types
     * @param {number} [offset=0]
     * @returns {boolean}
     */ function isTokenType(types, offset) {
            offset = offset || 0;
            for(var i = 0; i < types.length; i++){
                var token = getToken(i + offset);
                if (!token || token.type !== types[i]) return false;
            }
            return true;
        }
        /**
     * Returns the index of the closing bracket to an opening bracket.
     *
     * It is assumed that `token[currentIndex - 1]` is an opening bracket.
     *
     * If no closing bracket could be found, `-1` will be returned.
     *
     * @param {RegExp} open
     * @param {RegExp} close
     * @returns {number}
     */ function findClosingBracket(open, close) {
            var stackHeight = 1;
            for(var i = currentIndex; i < validTokens.length; i++){
                var token = validTokens[i];
                var content = token.content;
                if (token.type === 'punctuation' && typeof content === 'string') {
                    if (open.test(content)) stackHeight++;
                    else if (close.test(content)) {
                        stackHeight--;
                        if (stackHeight === 0) return i;
                    }
                }
            }
            return -1;
        }
        /**
     * Adds an alias to the given token.
     *
     * @param {Token} token
     * @param {string} alias
     * @returns {void}
     */ function addAlias(token, alias) {
            var aliases = token.alias;
            if (!aliases) token.alias = aliases = [];
            else if (!Array.isArray(aliases)) token.alias = aliases = [
                aliases
            ];
            aliases.push(alias);
        }
        for(; currentIndex < validTokens.length;){
            var startToken = validTokens[currentIndex++];
            // add special aliases for mutation tokens
            if (startToken.type === 'keyword' && startToken.content === 'mutation') {
                // any array of the names of all input variables (if any)
                var inputVariables = [];
                if (isTokenType([
                    'definition-mutation',
                    'punctuation'
                ]) && getToken(1).content === '(') {
                    // definition
                    currentIndex += 2 // skip 'definition-mutation' and 'punctuation'
                    ;
                    var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                    if (definitionEnd === -1) continue;
                    // find all input variables
                    for(; currentIndex < definitionEnd; currentIndex++){
                        var t = getToken(0);
                        if (t.type === 'variable') {
                            addAlias(t, 'variable-input');
                            inputVariables.push(t.content);
                        }
                    }
                    currentIndex = definitionEnd + 1;
                }
                if (isTokenType([
                    'punctuation',
                    'property-query'
                ]) && getToken(0).content === '{') {
                    currentIndex++ // skip opening bracket
                    ;
                    addAlias(getToken(0), 'property-mutation');
                    if (inputVariables.length > 0) {
                        var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                        if (mutationEnd === -1) continue;
                        // give references to input variables a special alias
                        for(var i = currentIndex; i < mutationEnd; i++){
                            var varToken = validTokens[i];
                            if (varToken.type === 'variable' && inputVariables.indexOf(varToken.content) >= 0) addAlias(varToken, 'variable-input');
                        }
                    }
                }
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$bb09ab25dfcbb114$export$2e2bcd8739ae039.displayName = 'groovy';
$bb09ab25dfcbb114$export$2e2bcd8739ae039.aliases = [];
function $bb09ab25dfcbb114$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolation = {
            pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/,
            lookbehind: true,
            inside: {
                'interpolation-punctuation': {
                    pattern: /^\$\{?|\}$/,
                    alias: 'punctuation'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        };
        Prism.languages.groovy = Prism.languages.extend('clike', {
            string: {
                // https://groovy-lang.org/syntax.html#_dollar_slashy_string
                pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/,
                greedy: true
            },
            keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
            number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
            operator: {
                pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
                lookbehind: true
            },
            punctuation: /\.+|[{}[\];(),:$]/
        });
        Prism.languages.insertBefore('groovy', 'string', {
            shebang: {
                pattern: /#!.+/,
                alias: 'comment',
                greedy: true
            },
            'interpolation-string': {
                // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
                // simple division (see JS regex), so find a fix maybe?
                pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true,
                inside: {
                    interpolation: interpolation,
                    string: /[\s\S]+/
                }
            }
        });
        Prism.languages.insertBefore('groovy', 'punctuation', {
            'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
        });
        Prism.languages.insertBefore('groovy', 'function', {
            annotation: {
                pattern: /(^|[^.])@\w+/,
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        interpolation.inside.expression.inside = Prism.languages.groovy;
    })(Prism);
}




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$9c25dab359558e3e$export$2e2bcd8739ae039.displayName = 'textile';
$9c25dab359558e3e$export$2e2bcd8739ae039.aliases = [];
function $9c25dab359558e3e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        // We don't allow for pipes inside parentheses
        // to not break table pattern |(. foo |). bar |
        var modifierRegex = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source;
        // Opening and closing parentheses which are not a modifier
        // This pattern is necessary to prevent exponential backtracking
        var parenthesesRegex = /\)|\((?![^|()\n]+\))/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function withModifier(source, flags) {
            return RegExp(source.replace(/<MOD>/g, function() {
                return '(?:' + modifierRegex + ')';
            }).replace(/<PAR>/g, function() {
                return '(?:' + parenthesesRegex + ')';
            }), flags || '');
        }
        var modifierTokens = {
            css: {
                pattern: /\{[^{}]+\}/,
                inside: {
                    rest: Prism.languages.css
                }
            },
            'class-id': {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: true,
                alias: 'attr-value'
            },
            lang: {
                pattern: /(\[)[^\[\]]+(?=\])/,
                lookbehind: true,
                alias: 'attr-value'
            },
            // Anything else is punctuation (the first pattern is for row/col spans inside tables)
            punctuation: /[\\\/]\d+|\S/
        };
        var textile = Prism.languages.textile = Prism.languages.extend('markup', {
            phrase: {
                pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
                lookbehind: true,
                inside: {
                    // h1. Header 1
                    'block-tag': {
                        pattern: withModifier(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            tag: /^[a-z]\w*/,
                            punctuation: /\.$/
                        }
                    },
                    // # List item
                    // * List item
                    list: {
                        pattern: withModifier(/^[*#]+<MOD>*\s+\S.*/.source, 'm'),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[*#]+)<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /^[*#]+/
                        }
                    },
                    // | cell | cell | cell |
                    table: {
                        // Modifiers can be applied to the row: {color:red}.|1|2|3|
                        // or the cell: |{color:red}.1|2|3|
                        pattern: withModifier(/^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source, 'm'),
                        inside: {
                            modifier: {
                                // Modifiers for rows after the first one are
                                // preceded by a pipe and a line feed
                                pattern: withModifier(/(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /\||^\./
                        }
                    },
                    inline: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source),
                        lookbehind: true,
                        inside: {
                            // Note: superscripts and subscripts are not handled specifically
                            // *bold*, **bold**
                            bold: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // _italic_, __italic__
                            italic: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(__?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // ??cite??
                            cite: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                                lookbehind: true,
                                alias: 'string'
                            },
                            // @code@
                            code: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^@<MOD>*).+?(?=@)/.source),
                                lookbehind: true,
                                alias: 'keyword'
                            },
                            // +inserted+
                            inserted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\+<MOD>*).+?(?=\+)/.source),
                                lookbehind: true
                            },
                            // -deleted-
                            deleted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^-<MOD>*).+?(?=-)/.source),
                                lookbehind: true
                            },
                            // %span%
                            span: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^%<MOD>*).+?(?=%)/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /[*_%?@+\-^~]+/
                        }
                    },
                    // [alias]http://example.com
                    'link-ref': {
                        pattern: /^\[[^\]]+\]\S+$/m,
                        inside: {
                            string: {
                                pattern: /(^\[)[^\]]+(?=\])/,
                                lookbehind: true
                            },
                            url: {
                                pattern: /(^\])\S+$/,
                                lookbehind: true
                            },
                            punctuation: /[\[\]]/
                        }
                    },
                    // "text":http://example.com
                    // "text":link-ref
                    link: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source),
                        inside: {
                            text: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^"<MOD>*)[^"]+(?=")/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^")<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[":]/
                        }
                    },
                    // !image.jpg!
                    // !image.jpg(Title)!:http://example.com
                    image: {
                        pattern: withModifier(/!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source),
                        inside: {
                            source: {
                                pattern: withModifier(/(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source),
                                lookbehind: true,
                                alias: 'url'
                            },
                            modifier: {
                                pattern: withModifier(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[!:]/
                        }
                    },
                    // Footnote[1]
                    footnote: {
                        pattern: /\b\[\d+\]/,
                        alias: 'comment',
                        inside: {
                            punctuation: /\[|\]/
                        }
                    },
                    // CSS(Cascading Style Sheet)
                    acronym: {
                        pattern: /\b[A-Z\d]+\([^)]+\)/,
                        inside: {
                            comment: {
                                pattern: /(\()[^()]+(?=\))/,
                                lookbehind: true
                            },
                            punctuation: /[()]/
                        }
                    },
                    // Prism(C)
                    mark: {
                        pattern: /\b\((?:C|R|TM)\)/,
                        alias: 'comment',
                        inside: {
                            punctuation: /[()]/
                        }
                    }
                }
            }
        });
        var phraseInside = textile['phrase'].inside;
        var nestedPatterns = {
            inline: phraseInside['inline'],
            link: phraseInside['link'],
            image: phraseInside['image'],
            footnote: phraseInside['footnote'],
            acronym: phraseInside['acronym'],
            mark: phraseInside['mark']
        };
        // Only allow alpha-numeric HTML tags, not XML tags
        textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
        // Allow some nesting
        var phraseInlineInside = phraseInside['inline'].inside;
        phraseInlineInside['bold'].inside = nestedPatterns;
        phraseInlineInside['italic'].inside = nestedPatterns;
        phraseInlineInside['inserted'].inside = nestedPatterns;
        phraseInlineInside['deleted'].inside = nestedPatterns;
        phraseInlineInside['span'].inside = nestedPatterns;
        // Allow some styles inside table cells
        var phraseTableInside = phraseInside['table'].inside;
        phraseTableInside['inline'] = nestedPatterns['inline'];
        phraseTableInside['link'] = nestedPatterns['link'];
        phraseTableInside['image'] = nestedPatterns['image'];
        phraseTableInside['footnote'] = nestedPatterns['footnote'];
        phraseTableInside['acronym'] = nestedPatterns['acronym'];
        phraseTableInside['mark'] = nestedPatterns['mark'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2590b32a10d9ecc8$export$2e2bcd8739ae039.displayName = 'haml';
$2590b32a10d9ecc8$export$2e2bcd8739ae039.aliases = [];
function $2590b32a10d9ecc8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0814f5761e025965$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.haml = {
            // Multiline stuff should appear before the rest
            'multiline-comment': {
                pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
                lookbehind: true,
                alias: 'comment'
            },
            'multiline-code': [
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                }
            ],
            // See at the end of the file for known filters
            filter: {
                pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    }
                }
            },
            markup: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
                lookbehind: true
            },
            tag: {
                // Allows for one nested group of braces
                pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            // Lookbehind tries to prevent interpolations from breaking it all
                            // Allows for one nested group of braces
                            pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                            lookbehind: true,
                            inside: Prism.languages.ruby
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                                    lookbehind: true
                                },
                                'attr-name': /[\w:-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[=(),]/
                            }
                        },
                        {
                            pattern: /\[[^\]]+\]/,
                            inside: Prism.languages.ruby
                        }
                    ],
                    punctuation: /[<>]/
                }
            },
            code: {
                pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
                lookbehind: true,
                inside: Prism.languages.ruby
            },
            // Interpolations in plain text
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    ruby: {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages.ruby
                    }
                }
            },
            punctuation: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
                lookbehind: true
            }
        };
        var filter_pattern = '((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+';
        // Non exhaustive list of available filters and associated languages
        var filters = [
            'css',
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'erb',
            'javascript',
            'less',
            'markdown',
            'ruby',
            'scss',
            'textile'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('{{filter_name}}', function() {
                    return filter.filter;
                })),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    },
                    text: {
                        pattern: /[\s\S]+/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('haml', 'filter', all_filters);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$abb136260c600497$export$2e2bcd8739ae039.displayName = 'handlebars';
$abb136260c600497$export$2e2bcd8739ae039.aliases = [
    'hbs',
    'mustache'
];
function $abb136260c600497$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.handlebars = {
            comment: /\{\{![\s\S]*?\}\}/,
            delimiter: {
                pattern: /^\{\{\{?|\}\}\}?$/,
                alias: 'punctuation'
            },
            string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
            boolean: /\b(?:false|true)\b/,
            block: {
                pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
                lookbehind: true,
                alias: 'keyword'
            },
            brackets: {
                pattern: /\[[^\]]+\]/,
                inside: {
                    punctuation: /\[|\]/,
                    variable: /[\s\S]+/
                }
            },
            punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
            variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'handlebars', handlebarsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'handlebars');
        });
        Prism.languages.hbs = Prism.languages.handlebars;
        Prism.languages.mustache = Prism.languages.handlebars;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2ae70ee16ca48837$export$2e2bcd8739ae039.displayName = 'haskell';
$2ae70ee16ca48837$export$2e2bcd8739ae039.aliases = [
    'hs'
];
function $2ae70ee16ca48837$export$2e2bcd8739ae039(Prism) {
    Prism.languages.haskell = {
        comment: {
            pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
            lookbehind: true
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
            alias: 'string'
        },
        string: {
            pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
            greedy: true
        },
        keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import|qualified)\b/,
                punctuation: /\./
            }
        },
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
        // decimal integers and floating point numbers | octal integers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
        operator: [
            {
                // infix operator
                pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
                greedy: true
            },
            {
                // function composition
                pattern: /(\s)\.(?=\s)/,
                lookbehind: true
            },
            // Most of this is needed because of the meaning of a single '.'.
            // If it stands alone freely, it is the function composition.
            // It may also be a separator between a module name and an identifier => no
            // operator. If it comes together with other special characters it is an
            // operator too.
            //
            // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
            /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
        ],
        // In Haskell, nearly everything is a variable, do not highlight these.
        hvariable: {
            pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        constant: {
            pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.hs = Prism.languages.haskell;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$1ba73c5509e75af1$export$2e2bcd8739ae039.displayName = 'haxe';
$1ba73c5509e75af1$export$2e2bcd8739ae039.aliases = [];
function $1ba73c5509e75af1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.haxe = Prism.languages.extend('clike', {
        string: {
            // Strings can be multi-line
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        'class-name': [
            {
                pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
                lookbehind: true
            },
            // based on naming convention
            /\b[A-Z]\w*/
        ],
        // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
        keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
        function: {
            pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
            greedy: true
        },
        operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    });
    Prism.languages.insertBefore('haxe', 'string', {
        'string-interpolation': {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{?|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.haxe
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'class-name', {
        regex: {
            pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
            greedy: true,
            inside: {
                'regex-flags': /\b[a-z]+$/,
                'regex-source': {
                    pattern: /^(~\/)[\s\S]+(?=\/$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^~\/|\/$/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'keyword', {
        preprocessor: {
            pattern: /#(?:else|elseif|end|if)\b.*/,
            alias: 'property'
        },
        metadata: {
            pattern: /@:?[\w.]+/,
            alias: 'symbol'
        },
        reification: {
            pattern: /\$(?:\w+|(?=\{))/,
            alias: 'important'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $50cc4f59c8b2da7b$export$2e2bcd8739ae039.displayName = 'hcl';
$50cc4f59c8b2da7b$export$2e2bcd8739ae039.aliases = [];
function $50cc4f59c8b2da7b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.hcl = {
        comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
        heredoc: {
            pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
            greedy: true,
            alias: 'string'
        },
        keyword: [
            {
                pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
                inside: {
                    type: {
                        pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            {
                pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
                inside: {
                    type: {
                        pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            /[\w-]+(?=\s+\{)/
        ],
        property: [
            /[-\w\.]+(?=\s*=(?!=))/,
            /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/
        ],
        string: {
            pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
                    lookbehind: true,
                    inside: {
                        type: {
                            pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                            lookbehind: true,
                            alias: 'variable'
                        },
                        keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
                        function: /\w+(?=\()/,
                        string: {
                            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                            greedy: true
                        },
                        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
                        punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
                    }
                }
            }
        },
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        boolean: /\b(?:false|true)\b/i,
        punctuation: /[=\[\]{}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$e2e7d35f13665654$export$2e2bcd8739ae039.displayName = 'hlsl';
$e2e7d35f13665654$export$2e2bcd8739ae039.aliases = [];
function $e2e7d35f13665654$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    Prism.languages.hlsl = Prism.languages.extend('c', {
        // Regarding keywords and class names:
        // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
        'class-name': [
            Prism.languages.c['class-name'],
            /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
        ],
        keyword: [
            // HLSL keyword
            /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
            // scalar, vector, and matrix types
            /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
        ],
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
        number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
        boolean: /\b(?:false|true)\b/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e34b34b543223ef4$export$2e2bcd8739ae039.displayName = 'hoon';
$e34b34b543223ef4$export$2e2bcd8739ae039.aliases = [];
function $e34b34b543223ef4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.hoon = {
        comment: {
            pattern: /::.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'/,
            greedy: true
        },
        constant: /%(?:\.[ny]|[\w-]+)/,
        'class-name': /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
        function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
        keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $669817df648224fc$export$2e2bcd8739ae039.displayName = 'hpkp';
$669817df648224fc$export$2e2bcd8739ae039.aliases = [];
function $669817df648224fc$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hpkp-cheat-sheet/
   */ Prism.languages.hpkp = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6c6957e69ba93803$export$2e2bcd8739ae039.displayName = 'hsts';
$6c6957e69ba93803$export$2e2bcd8739ae039.aliases = [];
function $6c6957e69ba93803$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hsts-cheat-sheet/
   */ Prism.languages.hsts = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6583f09ac504dc32$export$2e2bcd8739ae039.displayName = 'uri';
$6583f09ac504dc32$export$2e2bcd8739ae039.aliases = [
    'url'
];
function $6583f09ac504dc32$export$2e2bcd8739ae039(Prism) {
    // https://tools.ietf.org/html/rfc3986#appendix-A
    Prism.languages.uri = {
        scheme: {
            pattern: /^[a-z][a-z0-9+.-]*:/im,
            greedy: true,
            inside: {
                'scheme-delimiter': /:$/
            }
        },
        fragment: {
            pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'fragment-delimiter': /^#/
            }
        },
        query: {
            pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'query-delimiter': {
                    pattern: /^\?/,
                    greedy: true
                },
                'pair-delimiter': /[&;]/,
                pair: {
                    pattern: /^[^=][\s\S]*/,
                    inside: {
                        key: /^[^=]+/,
                        value: {
                            pattern: /(^=)[\s\S]+/,
                            lookbehind: true
                        }
                    }
                }
            }
        },
        authority: {
            pattern: RegExp(/^\/\//.source + // [ userinfo "@" ]
            /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
            ('(?:' + // IP-literal
            /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + '|' + // IPv4address or registered name
            /[\w\-.~!$&'()*+,;=%]*/.source + ')') + // [ ":" port ]
            /(?::\d*)?/.source, 'm'),
            inside: {
                'authority-delimiter': /^\/\//,
                'user-info-segment': {
                    pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
                    inside: {
                        'user-info-delimiter': /@$/,
                        'user-info': /^[\w\-.~!$&'()*+,;=%:]+/
                    }
                },
                'port-segment': {
                    pattern: /:\d*$/,
                    inside: {
                        'port-delimiter': /^:/,
                        port: /^\d+/
                    }
                },
                host: {
                    pattern: /[\s\S]+/,
                    inside: {
                        'ip-literal': {
                            pattern: /^\[[\s\S]+\]$/,
                            inside: {
                                'ip-literal-delimiter': /^\[|\]$/,
                                'ipv-future': /^v[\s\S]+/,
                                'ipv6-address': /^[\s\S]+/
                            }
                        },
                        'ipv4-address': /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
                    }
                }
            }
        },
        path: {
            pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
            inside: {
                'path-separator': /\//
            }
        }
    };
    Prism.languages.url = Prism.languages.uri;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $df4a8f4049b5c047$export$2e2bcd8739ae039.displayName = 'http';
$df4a8f4049b5c047$export$2e2bcd8739ae039.aliases = [];
function $df4a8f4049b5c047$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} name
     * @returns {RegExp}
     */ function headerValueOf(name) {
            return RegExp('(^(?:' + name + '):[ \t]*(?![ \t]))[^]+', 'i');
        }
        Prism.languages.http = {
            'request-line': {
                pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
                inside: {
                    // HTTP Method
                    method: {
                        pattern: /^[A-Z]+\b/,
                        alias: 'property'
                    },
                    // Request Target e.g. http://example.com, /path/to/file
                    'request-target': {
                        pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
                        lookbehind: true,
                        alias: 'url',
                        inside: Prism.languages.uri
                    },
                    // HTTP Version
                    'http-version': {
                        pattern: /^(\s)HTTP\/[\d.]+/,
                        lookbehind: true,
                        alias: 'property'
                    }
                }
            },
            'response-status': {
                pattern: /^HTTP\/[\d.]+ \d+ .+/m,
                inside: {
                    // HTTP Version
                    'http-version': {
                        pattern: /^HTTP\/[\d.]+/,
                        alias: 'property'
                    },
                    // Status Code
                    'status-code': {
                        pattern: /^(\s)\d+(?=\s)/,
                        lookbehind: true,
                        alias: 'number'
                    },
                    // Reason Phrase
                    'reason-phrase': {
                        pattern: /^(\s).+/,
                        lookbehind: true,
                        alias: 'string'
                    }
                }
            },
            header: {
                pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
                inside: {
                    'header-value': [
                        {
                            pattern: headerValueOf(/Content-Security-Policy/.source),
                            lookbehind: true,
                            alias: [
                                'csp',
                                'languages-csp'
                            ],
                            inside: Prism.languages.csp
                        },
                        {
                            pattern: headerValueOf(/Public-Key-Pins(?:-Report-Only)?/.source),
                            lookbehind: true,
                            alias: [
                                'hpkp',
                                'languages-hpkp'
                            ],
                            inside: Prism.languages.hpkp
                        },
                        {
                            pattern: headerValueOf(/Strict-Transport-Security/.source),
                            lookbehind: true,
                            alias: [
                                'hsts',
                                'languages-hsts'
                            ],
                            inside: Prism.languages.hsts
                        },
                        {
                            pattern: headerValueOf(/[^:]+/.source),
                            lookbehind: true
                        }
                    ],
                    'header-name': {
                        pattern: /^[^:]+/,
                        alias: 'keyword'
                    },
                    punctuation: /^:/
                }
            }
        };
        // Create a mapping of Content-Type headers to language definitions
        var langs = Prism.languages;
        var httpLanguages = {
            'application/javascript': langs.javascript,
            'application/json': langs.json || langs.javascript,
            'application/xml': langs.xml,
            'text/xml': langs.xml,
            'text/html': langs.html,
            'text/css': langs.css,
            'text/plain': langs.plain
        };
        // Declare which types can also be suffixes
        var suffixTypes = {
            'application/json': true,
            'application/xml': true
        };
        /**
     * Returns a pattern for the given content type which matches it and any type which has it as a suffix.
     *
     * @param {string} contentType
     * @returns {string}
     */ function getSuffixPattern(contentType) {
            var suffix = contentType.replace(/^[a-z]+\//, '');
            var suffixPattern = '\\w+/(?:[\\w.-]+\\+)+' + suffix + '(?![+\\w.-])';
            return '(?:' + contentType + '|' + suffixPattern + ')';
        }
        // Insert each content type parser that has its associated language
        // currently loaded.
        var options;
        for(var contentType in httpLanguages)if (httpLanguages[contentType]) {
            options = options || {};
            var pattern = suffixTypes[contentType] ? getSuffixPattern(contentType) : contentType;
            options[contentType.replace(/\//g, '-')] = {
                pattern: RegExp('(' + /content-type:\s*/.source + pattern + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ')' + // This is a little interesting:
                // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
                // However, when writing code by hand (e.g. to display on a website) people can forget about this,
                // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
                // the body does not start with a [\w-] character (as headers do).
                /[^ \t\w-][\s\S]*/.source, 'i'),
                lookbehind: true,
                inside: httpLanguages[contentType]
            };
        }
        if (options) Prism.languages.insertBefore('http', 'header', options);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $dae26b846c274399$export$2e2bcd8739ae039.displayName = 'ichigojam';
$dae26b846c274399$export$2e2bcd8739ae039.aliases = [];
function $dae26b846c274399$export$2e2bcd8739ae039(Prism) {
    // according to the offical reference (EN)
    // https://ichigojam.net/IchigoJam-en.html
    Prism.languages.ichigojam = {
        comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
        function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
        label: /(?:\B@\S+)/,
        operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
        punctuation: /[\[,;:()\]]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7f7ed36c71460d27$export$2e2bcd8739ae039.displayName = 'icon';
$7f7ed36c71460d27$export$2e2bcd8739ae039.aliases = [];
function $7f7ed36c71460d27$export$2e2bcd8739ae039(Prism) {
    Prism.languages.icon = {
        comment: /#.*/,
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
            greedy: true
        },
        number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
        'builtin-keyword': {
            pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
            alias: 'variable'
        },
        directive: {
            pattern: /\$\w+/,
            alias: 'builtin'
        },
        keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
        function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
        operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
        punctuation: /[\[\](){},;]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $01d5a9ee0f18d738$export$2e2bcd8739ae039.displayName = 'icu-message-format';
$01d5a9ee0f18d738$export$2e2bcd8739ae039.aliases = [];
function $01d5a9ee0f18d738$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @param {number} level
     * @returns {string}
     */ function nested(source, level) {
            if (level <= 0) return /[]/.source;
            else return source.replace(/<SELF>/g, function() {
                return nested(source, level - 1);
            });
        }
        var stringPattern = /'[{}:=,](?:[^']|'')*'(?!')/;
        var escape = {
            pattern: /''/,
            greedy: true,
            alias: 'operator'
        };
        var string = {
            pattern: stringPattern,
            greedy: true,
            inside: {
                escape: escape
            }
        };
        var argumentSource = nested(/\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(/<STR>/g, function() {
            return stringPattern.source;
        }), 8);
        var nestedMessage = {
            pattern: RegExp(argumentSource),
            inside: {
                message: {
                    pattern: /^(\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: null // see below
                },
                'message-delimiter': {
                    pattern: /./,
                    alias: 'punctuation'
                }
            }
        };
        Prism.languages['icu-message-format'] = {
            argument: {
                pattern: RegExp(argumentSource),
                greedy: true,
                inside: {
                    content: {
                        pattern: /^(\{)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        inside: {
                            'argument-name': {
                                pattern: /^(\s*)[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'choice-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    punctuation: /\|/,
                                    range: {
                                        pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                                        lookbehind: true,
                                        inside: {
                                            operator: /[<#\u2264]/,
                                            number: /\S+/
                                        }
                                    },
                                    rest: null // see below
                                }
                            },
                            'plural-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    offset: /^offset:\s*\d+/,
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /=\d+|[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^(?:few|many|one|other|two|zero)$/
                                        }
                                    }
                                }
                            },
                            'select-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^other$/
                                        }
                                    }
                                }
                            },
                            keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                            'arg-type': {
                                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                                alias: 'keyword'
                            },
                            'arg-skeleton': {
                                pattern: /(,\s*)::[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'arg-style': {
                                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                                lookbehind: true
                            },
                            'arg-style-text': {
                                pattern: RegExp(/(^\s*,\s*(?=\S))/.source + nested(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + '$'),
                                lookbehind: true,
                                alias: 'string'
                            },
                            punctuation: /,/
                        }
                    },
                    'argument-delimiter': {
                        pattern: /./,
                        alias: 'operator'
                    }
                }
            },
            escape: escape,
            string: string
        };
        nestedMessage.inside.message.inside = Prism.languages['icu-message-format'];
        Prism.languages['icu-message-format'].argument.inside.content.inside['choice-style'].inside.rest = Prism.languages['icu-message-format'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3c79c65302ac0671$export$2e2bcd8739ae039.displayName = 'idris';
$3c79c65302ac0671$export$2e2bcd8739ae039.aliases = [
    'idr'
];
function $3c79c65302ac0671$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $2ae70ee16ca48837$export$2e2bcd8739ae039));
    Prism.languages.idris = Prism.languages.extend('haskell', {
        comment: {
            pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
        },
        keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
        builtin: undefined
    });
    Prism.languages.insertBefore('idris', 'keyword', {
        'import-statement': {
            pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    });
    Prism.languages.idr = Prism.languages.idris;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $de2f160c2fe3453a$export$2e2bcd8739ae039.displayName = 'ignore';
$de2f160c2fe3453a$export$2e2bcd8739ae039.aliases = [
    'gitignore',
    'hgignore',
    'npmignore'
];
function $de2f160c2fe3453a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.ignore = {
            // https://git-scm.com/docs/gitignore
            comment: /^#.*/m,
            entry: {
                pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
                alias: 'string',
                inside: {
                    operator: /^!|\*\*?|\?/,
                    regex: {
                        pattern: /(^|[^\\])\[[^\[\]]*\]/,
                        lookbehind: true
                    },
                    punctuation: /\//
                }
            }
        };
        Prism.languages.gitignore = Prism.languages.ignore;
        Prism.languages.hgignore = Prism.languages.ignore;
        Prism.languages.npmignore = Prism.languages.ignore;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2575e451a3a1df7f$export$2e2bcd8739ae039.displayName = 'inform7';
$2575e451a3a1df7f$export$2e2bcd8739ae039.aliases = [];
function $2575e451a3a1df7f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.inform7 = {
        string: {
            pattern: /"[^"]*"/,
            inside: {
                substitution: {
                    pattern: /\[[^\[\]]+\]/,
                    inside: {
                        delimiter: {
                            pattern: /\[|\]/,
                            alias: 'punctuation'
                        }
                    }
                }
            }
        },
        comment: {
            pattern: /\[[^\[\]]+\]/,
            greedy: true
        },
        title: {
            pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
            alias: 'important'
        },
        number: {
            pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
            lookbehind: true
        },
        verb: {
            pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
            lookbehind: true,
            alias: 'operator'
        },
        keyword: {
            pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
            lookbehind: true
        },
        property: {
            pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
            lookbehind: true,
            alias: 'symbol'
        },
        position: {
            pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
            lookbehind: true,
            alias: 'variable'
        },
        punctuation: /[.,:;(){}]/
    };
    Prism.languages.inform7['string'].inside['substitution'].inside.rest = Prism.languages.inform7;
    // We don't want the remaining text in the substitution to be highlighted as the string.
    Prism.languages.inform7['string'].inside['substitution'].inside.rest.text = {
        pattern: /\S(?:\s*\S)*/,
        alias: 'comment'
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0b6b8e959651c37f$export$2e2bcd8739ae039.displayName = 'io';
$0b6b8e959651c37f$export$2e2bcd8739ae039.aliases = [];
function $0b6b8e959651c37f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.io = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
            lookbehind: true,
            greedy: true
        },
        'triple-quoted-string': {
            pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /"(?:\\.|[^\\\r\n"])*"/,
            greedy: true
        },
        keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
        builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
        operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cd93a27b452b7c48$export$2e2bcd8739ae039.displayName = 'j';
$cd93a27b452b7c48$export$2e2bcd8739ae039.aliases = [];
function $cd93a27b452b7c48$export$2e2bcd8739ae039(Prism) {
    Prism.languages.j = {
        comment: {
            pattern: /\bNB\..*/,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
        verb: {
            // Negative look-ahead prevents bad highlighting
            // of ^: ;. =. =: !. !:
            pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
            alias: 'keyword'
        },
        number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
        adverb: {
            pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
            alias: 'builtin'
        },
        operator: /[=a][.:]|_\./,
        conjunction: {
            pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
            alias: 'variable'
        },
        punctuation: /[()]/
    };
}




// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $27318f6b523d68d5$export$2e2bcd8739ae039.displayName = 'javadoclike';
$27318f6b523d68d5$export$2e2bcd8739ae039.aliases = [];
function $27318f6b523d68d5$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var javaDocLike = Prism.languages.javadoclike = {
            parameter: {
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
                lookbehind: true
            },
            keyword: {
                // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
                // @word, {@word}
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
                lookbehind: true
            },
            punctuation: /[{}]/
        };
        /**
     * Adds doc comment support to the given language and calls a given callback on each doc comment pattern.
     *
     * @param {string} lang the language add doc comment support to.
     * @param {(pattern: {inside: {rest: undefined}}) => void} callback the function called with each doc comment pattern as argument.
     */ function docCommentSupport(lang, callback) {
            var tokenName = 'doc-comment';
            var grammar = Prism.languages[lang];
            if (!grammar) return;
            var token = grammar[tokenName];
            if (!token) {
                // add doc comment: /** */
                var definition = {};
                definition[tokenName] = {
                    pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    alias: 'comment'
                };
                grammar = Prism.languages.insertBefore(lang, 'comment', definition);
                token = grammar[tokenName];
            }
            if (token instanceof RegExp) // convert regex to object
            token = grammar[tokenName] = {
                pattern: token
            };
            if (Array.isArray(token)) for(var i = 0, l = token.length; i < l; i++){
                if (token[i] instanceof RegExp) token[i] = {
                    pattern: token[i]
                };
                callback(token[i]);
            }
            else callback(token);
        }
        /**
     * Adds doc-comment support to the given languages for the given documentation language.
     *
     * @param {string[]|string} languages
     * @param {Object} docLanguage
     */ function addSupport(languages, docLanguage) {
            if (typeof languages === 'string') languages = [
                languages
            ];
            languages.forEach(function(lang) {
                docCommentSupport(lang, function(pattern) {
                    if (!pattern.inside) pattern.inside = {};
                    pattern.inside.rest = docLanguage;
                });
            });
        }
        Object.defineProperty(javaDocLike, 'addSupport', {
            value: addSupport
        });
        javaDocLike.addSupport([
            'java',
            'javascript',
            'php'
        ], javaDocLike);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$46a0b7b965a829bf$export$2e2bcd8739ae039.displayName = 'scala';
$46a0b7b965a829bf$export$2e2bcd8739ae039.aliases = [];
function $46a0b7b965a829bf$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
    Prism.languages.scala = Prism.languages.extend('java', {
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /<-|=>|\b(?:abstract|case|catch|class|def|derives|do|else|enum|extends|extension|final|finally|for|forSome|given|if|implicit|import|infix|inline|lazy|match|new|null|object|opaque|open|override|package|private|protected|return|sealed|self|super|this|throw|trait|transparent|try|type|using|val|var|while|with|yield)\b/,
        number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
        builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
        symbol: /'[^\d\s\\]\w*/
    });
    Prism.languages.insertBefore('scala', 'triple-quoted-string', {
        'string-interpolation': {
            pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
            greedy: true,
            inside: {
                id: {
                    pattern: /^\w+/,
                    greedy: true,
                    alias: 'function'
                },
                escape: {
                    pattern: /\\\$"|\$[$"]/,
                    greedy: true,
                    alias: 'symbol'
                },
                interpolation: {
                    pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                    greedy: true,
                    inside: {
                        punctuation: /^\$\{?|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.scala
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    delete Prism.languages.scala['class-name'];
    delete Prism.languages.scala['function'];
    delete Prism.languages.scala['constant'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$988c0ef2629271f3$export$2e2bcd8739ae039.displayName = 'javadoc';
$988c0ef2629271f3$export$2e2bcd8739ae039.aliases = [];
function $988c0ef2629271f3$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
    Prism.register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var codeLinePattern = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m;
        var memberReference = /#\s*\w+(?:\s*\([^()]*\))?/.source;
        var reference = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(/<mem>/g, function() {
            return memberReference;
        });
        Prism.languages.javadoc = Prism.languages.extend('javadoclike', {});
        Prism.languages.insertBefore('javadoc', 'keyword', {
            reference: {
                pattern: RegExp(/(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + '(?:' + reference + ')'),
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /(#\s*)\w+(?=\s*\()/,
                        lookbehind: true
                    },
                    field: {
                        pattern: /(#\s*)\w+/,
                        lookbehind: true
                    },
                    namespace: {
                        pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    'class-name': /\b[A-Z]\w*/,
                    keyword: Prism.languages.java.keyword,
                    punctuation: /[#()[\],.]/
                }
            },
            'class-name': {
                // @param <T> the first generic type parameter
                pattern: /(@param\s+)<[A-Z]\w*>/,
                lookbehind: true,
                inside: {
                    punctuation: /[.<>]/
                }
            },
            'code-section': [
                {
                    pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
                    lookbehind: true,
                    inside: {
                        code: {
                            // there can't be any HTML inside of {@code} tags
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: Prism.languages.java,
                            alias: 'language-java'
                        }
                    }
                },
                {
                    pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
                    lookbehind: true,
                    inside: {
                        line: {
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: {
                                // highlight HTML tags and entities
                                tag: Prism.languages.markup.tag,
                                entity: Prism.languages.markup.entity,
                                code: {
                                    // everything else is Java code
                                    pattern: /.+/,
                                    inside: Prism.languages.java,
                                    alias: 'language-java'
                                }
                            }
                        }
                    }
                }
            ],
            tag: Prism.languages.markup.tag,
            entity: Prism.languages.markup.entity
        });
        Prism.languages.javadoclike.addSupport('java', Prism.languages.javadoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cb363a9e19005aae$export$2e2bcd8739ae039.displayName = 'javastacktrace';
$cb363a9e19005aae$export$2e2bcd8739ae039.aliases = [];
function $cb363a9e19005aae$export$2e2bcd8739ae039(Prism) {
    // Specification:
    // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/Throwable.html#printStackTrace()
    Prism.languages.javastacktrace = {
        // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: com.example.myproject.MyProjectServletException
        // Caused by: MidLevelException: LowLevelException
        // Suppressed: Resource$CloseFailException: Resource ID = 0
        summary: {
            pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
                    lookbehind: true
                },
                // the current thread if the summary starts with 'Exception in thread'
                string: {
                    pattern: /^(\s*)"[^"]*"/,
                    lookbehind: true
                },
                exceptions: {
                    pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
                    lookbehind: true,
                    inside: {
                        'class-name': /[\w$]+$/,
                        namespace: /\b[a-z]\w*\b/,
                        punctuation: /\./
                    }
                },
                message: {
                    pattern: /(:\s*)\S.*/,
                    lookbehind: true,
                    alias: 'string'
                },
                punctuation: /:/
            }
        },
        // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
        // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
        // at java.base/java.lang.Class.forName0(Native Method)
        // at Util.<init>(Unknown Source)
        // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
        // at com.foo.loader//com.foo.bar.App.run(App.java:12)
        // at acme@2.1/org.acme.Lib.test(Lib.java:80)
        // at MyClass.mash(MyClass.java:9)
        //
        // More information:
        // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
        //
        // A valid Java module name is defined as:
        //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
        // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
        //
        // A Java module version is defined by this class:
        // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
        // This is the implementation of the `parse` method in JDK13:
        // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
        // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
        'stack-frame': {
            pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^(\s*)at(?= )/,
                    lookbehind: true
                },
                source: [
                    // (Main.java:15)
                    // (Main.scala:15)
                    {
                        pattern: /(\()\w+\.\w+:\d+(?=\))/,
                        lookbehind: true,
                        inside: {
                            file: /^\w+\.\w+/,
                            punctuation: /:/,
                            'line-number': {
                                pattern: /\b\d+\b/,
                                alias: 'number'
                            }
                        }
                    },
                    // (Unknown Source)
                    // (Native Method)
                    // (...something...)
                    {
                        pattern: /(\()[^()]*(?=\))/,
                        lookbehind: true,
                        inside: {
                            keyword: /^(?:Native Method|Unknown Source)$/
                        }
                    }
                ],
                'class-name': /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
                function: /(?:<init>|[\w$]+)(?=\()/,
                'class-loader': {
                    pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /\./
                    }
                },
                module: {
                    pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
                    lookbehind: true,
                    inside: {
                        version: {
                            pattern: /(@)[\s\S]+/,
                            lookbehind: true,
                            alias: 'number'
                        },
                        punctuation: /[@.]/
                    }
                },
                namespace: {
                    pattern: /(?:\b[a-z]\w*\.)+/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()/.]/
            }
        },
        // ... 32 more
        // ... 32 common frames omitted
        more: {
            pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\.{3}/,
                number: /\d+/,
                keyword: /\b[a-z]+(?: [a-z]+)*\b/
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $49ed9aeb5a3777c3$export$2e2bcd8739ae039.displayName = 'jexl';
$49ed9aeb5a3777c3$export$2e2bcd8739ae039.aliases = [];
function $49ed9aeb5a3777c3$export$2e2bcd8739ae039(Prism) {
    Prism.languages.jexl = {
        string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        transform: {
            pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
            alias: 'function',
            lookbehind: true
        },
        function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
        operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
        boolean: /\b(?:false|true)\b/,
        keyword: /\bin\b/,
        punctuation: /[{}[\](),.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$23ae979d55503543$export$2e2bcd8739ae039.displayName = 'jolie';
$23ae979d55503543$export$2e2bcd8739ae039.aliases = [];
function $23ae979d55503543$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.jolie = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
        operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
        punctuation: /[()[\]{},;.:]/,
        builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    });
    Prism.languages.insertBefore('jolie', 'keyword', {
        aggregates: {
            pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
            lookbehind: true,
            inside: {
                keyword: /\bwith\b/,
                'class-name': /\w+/,
                punctuation: /,/
            }
        },
        redirects: {
            pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
            lookbehind: true,
            inside: {
                punctuation: /,/,
                'class-name': /\w+/,
                operator: /=>/
            }
        },
        property: {
            pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8f95bc848ace76c7$export$2e2bcd8739ae039.displayName = 'jq';
$8f95bc848ace76c7$export$2e2bcd8739ae039.aliases = [];
function $8f95bc848ace76c7$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var interpolation = /\\\((?:[^()]|\([^()]*\))*\)/.source;
        var string = RegExp(/(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(/__/g, function() {
            return interpolation;
        }));
        var stringInterpolation = {
            interpolation: {
                pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + interpolation),
                lookbehind: true,
                inside: {
                    content: {
                        pattern: /^(\\\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /^\\\(|\)$/
                }
            }
        };
        var jq = Prism.languages.jq = {
            comment: /#.*/,
            property: {
                pattern: RegExp(string.source + /(?=\s*:(?!:))/.source),
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            string: {
                pattern: string,
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            function: {
                pattern: /(\bdef\s+)[a-z_]\w+/i,
                lookbehind: true
            },
            variable: /\B\$\w+/,
            'property-literal': {
                pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
                alias: 'property'
            },
            keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
            boolean: /\b(?:false|true)\b/,
            number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
            operator: [
                {
                    pattern: /\|=?/,
                    alias: 'pipe'
                },
                /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
            ],
            'c-style-function': {
                pattern: /\b[a-z_]\w*(?=\s*\()/i,
                alias: 'function'
            },
            punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
            dot: {
                pattern: /\./,
                alias: 'important'
            }
        };
        stringInterpolation.interpolation.inside.content.inside = jq;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b338b4b197bcd1b4$export$2e2bcd8739ae039.displayName = 'js-templates';
$b338b4b197bcd1b4$export$2e2bcd8739ae039.aliases = [];
function $b338b4b197bcd1b4$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        var templateString = Prism.languages.javascript['template-string'];
        // see the pattern in prism-javascript.js
        var templateLiteralPattern = templateString.pattern.source;
        var interpolationObject = templateString.inside['interpolation'];
        var interpolationPunctuationObject = interpolationObject.inside['interpolation-punctuation'];
        var interpolationPattern = interpolationObject.pattern.source;
        /**
     * Creates a new pattern to match a template string with a special tag.
     *
     * This will return `undefined` if there is no grammar with the given language id.
     *
     * @param {string} language The language id of the embedded language. E.g. `markdown`.
     * @param {string} tag The regex pattern to match the tag.
     * @returns {object | undefined}
     * @example
     * createTemplate('css', /\bcss/.source);
     */ function createTemplate(language, tag) {
            if (!Prism.languages[language]) return undefined;
            return {
                pattern: RegExp('((?:' + tag + ')\\s*)' + templateLiteralPattern),
                lookbehind: true,
                greedy: true,
                inside: {
                    'template-punctuation': {
                        pattern: /^`|`$/,
                        alias: 'string'
                    },
                    'embedded-code': {
                        pattern: /[\s\S]+/,
                        alias: language
                    }
                }
            };
        }
        Prism.languages.javascript['template-string'] = [
            // styled-jsx:
            //   css`a { color: #25F; }`
            // styled-components:
            //   styled.h1`color: red;`
            createTemplate('css', /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
            // html`<p></p>`
            // div.innerHTML = `<p></p>`
            createTemplate('html', /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
            // svg`<path fill="#fff" d="M55.37 ..."/>`
            createTemplate('svg', /\bsvg/.source),
            // md`# h1`, markdown`## h2`
            createTemplate('markdown', /\b(?:markdown|md)/.source),
            // gql`...`, graphql`...`, graphql.experimental`...`
            createTemplate('graphql', /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
            // sql`...`
            createTemplate('sql', /\bsql/.source),
            // vanilla template string
            templateString
        ].filter(Boolean);
        /**
     * Returns a specific placeholder literal for the given language.
     *
     * @param {number} counter
     * @param {string} language
     * @returns {string}
     */ function getPlaceholder(counter, language) {
            return '___' + language.toUpperCase() + '_' + counter + '___';
        }
        /**
     * Returns the tokens of `Prism.tokenize` but also runs the `before-tokenize` and `after-tokenize` hooks.
     *
     * @param {string} code
     * @param {any} grammar
     * @param {string} language
     * @returns {(string|Token)[]}
     */ function tokenizeWithHooks(code, grammar, language) {
            var env = {
                code: code,
                grammar: grammar,
                language: language
            };
            Prism.hooks.run('before-tokenize', env);
            env.tokens = Prism.tokenize(env.code, env.grammar);
            Prism.hooks.run('after-tokenize', env);
            return env.tokens;
        }
        /**
     * Returns the token of the given JavaScript interpolation expression.
     *
     * @param {string} expression The code of the expression. E.g. `"${42}"`
     * @returns {Token}
     */ function tokenizeInterpolationExpression(expression) {
            var tempGrammar = {};
            tempGrammar['interpolation-punctuation'] = interpolationPunctuationObject;
            /** @type {Array} */ var tokens = Prism.tokenize(expression, tempGrammar);
            if (tokens.length === 3) {
                /**
         * The token array will look like this
         * [
         *     ["interpolation-punctuation", "${"]
         *     "..." // JavaScript expression of the interpolation
         *     ["interpolation-punctuation", "}"]
         * ]
         */ var args = [
                    1,
                    1
                ];
                args.push.apply(args, tokenizeWithHooks(tokens[1], Prism.languages.javascript, 'javascript'));
                tokens.splice.apply(tokens, args);
            }
            return new Prism.Token('interpolation', tokens, interpolationObject.alias, expression);
        }
        /**
     * Tokenizes the given code with support for JavaScript interpolation expressions mixed in.
     *
     * This function has 3 phases:
     *
     * 1. Replace all JavaScript interpolation expression with a placeholder.
     *    The placeholder will have the syntax of a identify of the target language.
     * 2. Tokenize the code with placeholders.
     * 3. Tokenize the interpolation expressions and re-insert them into the tokenize code.
     *    The insertion only works if a placeholder hasn't been "ripped apart" meaning that the placeholder has been
     *    tokenized as two tokens by the grammar of the embedded language.
     *
     * @param {string} code
     * @param {object} grammar
     * @param {string} language
     * @returns {Token}
     */ function tokenizeEmbedded(code, grammar, language) {
            // 1. First filter out all interpolations
            // because they might be escaped, we need a lookbehind, so we use Prism
            /** @type {(Token|string)[]} */ var _tokens = Prism.tokenize(code, {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    lookbehind: true
                }
            });
            // replace all interpolations with a placeholder which is not in the code already
            var placeholderCounter = 0;
            /** @type {Object<string, string>} */ var placeholderMap = {};
            var embeddedCode = _tokens.map(function(token) {
                if (typeof token === 'string') return token;
                else {
                    var interpolationExpression = token.content;
                    var placeholder;
                    while(code.indexOf(placeholder = getPlaceholder(placeholderCounter++, language)) !== -1);
                    placeholderMap[placeholder] = interpolationExpression;
                    return placeholder;
                }
            }).join('');
            // 2. Tokenize the embedded code
            var embeddedTokens = tokenizeWithHooks(embeddedCode, grammar, language);
            // 3. Re-insert the interpolation
            var placeholders = Object.keys(placeholderMap);
            placeholderCounter = 0;
            /**
       *
       * @param {(Token|string)[]} tokens
       * @returns {void}
       */ function walkTokens(tokens) {
                for(var i = 0; i < tokens.length; i++){
                    if (placeholderCounter >= placeholders.length) return;
                    var token = tokens[i];
                    if (typeof token === 'string' || typeof token.content === 'string') {
                        var placeholder = placeholders[placeholderCounter];
                        var s = typeof token === 'string' ? token : /** @type {string} */ token.content;
                        var index = s.indexOf(placeholder);
                        if (index !== -1) {
                            ++placeholderCounter;
                            var before = s.substring(0, index);
                            var middle = tokenizeInterpolationExpression(placeholderMap[placeholder]);
                            var after = s.substring(index + placeholder.length);
                            var replacement = [];
                            if (before) replacement.push(before);
                            replacement.push(middle);
                            if (after) {
                                var afterTokens = [
                                    after
                                ];
                                walkTokens(afterTokens);
                                replacement.push.apply(replacement, afterTokens);
                            }
                            if (typeof token === 'string') {
                                tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                i += replacement.length - 1;
                            } else token.content = replacement;
                        }
                    } else {
                        var content = token.content;
                        if (Array.isArray(content)) walkTokens(content);
                        else walkTokens([
                            content
                        ]);
                    }
                }
            }
            walkTokens(embeddedTokens);
            return new Prism.Token(language, embeddedTokens, 'language-' + language, code);
        }
        /**
     * The languages for which JS templating will handle tagged template literals.
     *
     * JS templating isn't active for only JavaScript but also related languages like TypeScript, JSX, and TSX.
     */ var supportedLanguages = {
            javascript: true,
            js: true,
            typescript: true,
            ts: true,
            jsx: true,
            tsx: true
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (!(env.language in supportedLanguages)) return;
            /**
       * Finds and tokenizes all template strings with an embedded languages.
       *
       * @param {(Token | string)[]} tokens
       * @returns {void}
       */ function findTemplateStrings(tokens) {
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (typeof token === 'string') continue;
                    var content = token.content;
                    if (!Array.isArray(content)) {
                        if (typeof content !== 'string') findTemplateStrings([
                            content
                        ]);
                        continue;
                    }
                    if (token.type === 'template-string') {
                        /**
             * A JavaScript template-string token will look like this:
             *
             * ["template-string", [
             *     ["template-punctuation", "`"],
             *     (
             *         An array of "string" and "interpolation" tokens. This is the simple string case.
             *         or
             *         ["embedded-code", "..."] This is the token containing the embedded code.
             *                                  It also has an alias which is the language of the embedded code.
             *     ),
             *     ["template-punctuation", "`"]
             * ]]
             */ var embedded = content[1];
                        if (content.length === 3 && typeof embedded !== 'string' && embedded.type === 'embedded-code') {
                            // get string content
                            var code = stringContent(embedded);
                            var alias = embedded.alias;
                            var language = Array.isArray(alias) ? alias[0] : alias;
                            var grammar = Prism.languages[language];
                            if (!grammar) continue;
                            content[1] = tokenizeEmbedded(code, grammar, language);
                        }
                    } else findTemplateStrings(content);
                }
            }
            findTemplateStrings(env.tokens);
        });
        /**
     * Returns the string content of a token or token stream.
     *
     * @param {string | Token | (string | Token)[]} value
     * @returns {string}
     */ function stringContent(value) {
            if (typeof value === 'string') return value;
            else if (Array.isArray(value)) return value.map(stringContent).join('');
            else return stringContent(value.content);
        }
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$bf3c2cf9e7b7e15b$export$2e2bcd8739ae039.displayName = 'jsdoc';
$bf3c2cf9e7b7e15b$export$2e2bcd8739ae039.aliases = [];
function $bf3c2cf9e7b7e15b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
    (function(Prism) {
        var javascript = Prism.languages.javascript;
        var type = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source;
        var parameterPrefix = '(@(?:arg|argument|param|property)\\s+(?:' + type + '\\s+)?)';
        Prism.languages.jsdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                // @param {string} foo - foo bar
                pattern: RegExp(parameterPrefix + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('jsdoc', 'keyword', {
            'optional-parameter': {
                // @param {string} [baz.foo="bar"] foo bar
                pattern: RegExp(parameterPrefix + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    parameter: {
                        pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    code: {
                        pattern: /(=)[\s\S]*(?=\]$)/,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    },
                    punctuation: /[=[\]]/
                }
            },
            'class-name': [
                {
                    pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                {
                    pattern: RegExp('(@[a-z]+\\s+)' + type),
                    lookbehind: true,
                    inside: {
                        string: javascript.string,
                        number: javascript.number,
                        boolean: javascript.boolean,
                        keyword: Prism.languages.typescript.keyword,
                        operator: /=>|\.\.\.|[&|?:*]/,
                        punctuation: /[.,;=<>{}()[\]]/
                    }
                }
            ],
            example: {
                pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
                lookbehind: true,
                inside: {
                    code: {
                        pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    }
                }
            }
        });
        Prism.languages.javadoclike.addSupport('javascript', Prism.languages.jsdoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a236d89746bc105c$export$2e2bcd8739ae039.displayName = 'n4js';
$a236d89746bc105c$export$2e2bcd8739ae039.aliases = [
    'n4jsd'
];
function $a236d89746bc105c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.languages.n4js = Prism.languages.extend('javascript', {
        // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
        keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    });
    Prism.languages.insertBefore('n4js', 'constant', {
        // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
        annotation: {
            pattern: /@+\w+/,
            alias: 'operator'
        }
    });
    Prism.languages.n4jsd = Prism.languages.n4js;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$964a8a24221af55b$export$2e2bcd8739ae039.displayName = 'js-extras';
$964a8a24221af55b$export$2e2bcd8739ae039.aliases = [];
function $964a8a24221af55b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.insertBefore('javascript', 'function-variable', {
            'method-variable': {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function-variable'].pattern.source),
                lookbehind: true,
                alias: [
                    'function-variable',
                    'method',
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'function', {
            method: {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function'].source),
                lookbehind: true,
                alias: [
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'constant', {
            'known-class-name': [
                {
                    // standard built-ins
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
                    pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                    alias: 'class-name'
                },
                {
                    // errors
                    pattern: /\b(?:[A-Z]\w*)Error\b/,
                    alias: 'class-name'
                }
            ]
        });
        /**
     * Replaces the `<ID>` placeholder in the given pattern with a pattern for general JS identifiers.
     *
     * @param {string} source
     * @param {string} [flags]
     * @returns {RegExp}
     */ function withId(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
            }), flags);
        }
        Prism.languages.insertBefore('javascript', 'keyword', {
            imports: {
                // https://tc39.es/ecma262/#sec-imports
                pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            exports: {
                // https://tc39.es/ecma262/#sec-exports
                pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        });
        Prism.languages.javascript['keyword'].unshift({
            pattern: /\b(?:as|default|export|from|import)\b/,
            alias: 'module'
        }, {
            pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
            alias: 'control-flow'
        }, {
            pattern: /\bnull\b/,
            alias: [
                'null',
                'nil'
            ]
        }, {
            pattern: /\bundefined\b/,
            alias: 'nil'
        });
        Prism.languages.insertBefore('javascript', 'operator', {
            spread: {
                pattern: /\.{3}/,
                alias: 'operator'
            },
            arrow: {
                pattern: /=>/,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('javascript', 'punctuation', {
            'property-access': {
                pattern: withId(/(\.\s*)#?<ID>/.source),
                lookbehind: true
            },
            'maybe-class-name': {
                pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
                lookbehind: true
            },
            dom: {
                // this contains only a few commonly used DOM variables
                pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
                alias: 'variable'
            },
            console: {
                pattern: /\bconsole(?=\s*\.)/,
                alias: 'class-name'
            }
        });
        // add 'maybe-class-name' to tokens which might be a class name
        var maybeClassNameTokens = [
            'function',
            'function-variable',
            'method',
            'method-variable',
            'property-access'
        ];
        for(var i = 0; i < maybeClassNameTokens.length; i++){
            var token = maybeClassNameTokens[i];
            var value = Prism.languages.javascript[token];
            // convert regex to object
            if (Prism.util.type(value) === 'RegExp') value = Prism.languages.javascript[token] = {
                pattern: value
            };
            // keep in mind that we don't support arrays
            var inside = value.inside || {};
            value.inside = inside;
            inside['maybe-class-name'] = /^[A-Z][\s\S]*/;
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$1ea37e5c47d5707d$export$2e2bcd8739ae039.displayName = 'json5';
$1ea37e5c47d5707d$export$2e2bcd8739ae039.aliases = [];
function $1ea37e5c47d5707d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
        Prism.languages.json5 = Prism.languages.extend('json', {
            property: [
                {
                    pattern: RegExp(string.source + '(?=\\s*:)'),
                    greedy: true
                },
                {
                    pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
                    alias: 'unquoted'
                }
            ],
            string: {
                pattern: string,
                greedy: true
            },
            number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$94086998b35689c5$export$2e2bcd8739ae039.displayName = 'jsonp';
$94086998b35689c5$export$2e2bcd8739ae039.aliases = [];
function $94086998b35689c5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
    Prism.languages.jsonp = Prism.languages.extend('json', {
        punctuation: /[{}[\]();,.]/
    });
    Prism.languages.insertBefore('jsonp', 'punctuation', {
        function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5b076416d0eabdf4$export$2e2bcd8739ae039.displayName = 'jsstacktrace';
$5b076416d0eabdf4$export$2e2bcd8739ae039.aliases = [];
function $5b076416d0eabdf4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.jsstacktrace = {
        'error-message': {
            pattern: /^\S.*/m,
            alias: 'string'
        },
        'stack-frame': {
            pattern: /(^[ \t]+)at[ \t].*/m,
            lookbehind: true,
            inside: {
                'not-my-code': {
                    pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
                    alias: 'comment'
                },
                filename: {
                    pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
                    lookbehind: true,
                    alias: 'url'
                },
                function: {
                    pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()]/,
                keyword: /\b(?:at|new)\b/,
                alias: {
                    pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
                    alias: 'variable'
                },
                'line-number': {
                    pattern: /:\d+(?::\d+)?\b/,
                    alias: 'number',
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cfc1afd3507a91b5$export$2e2bcd8739ae039.displayName = 'julia';
$cfc1afd3507a91b5$export$2e2bcd8739ae039.aliases = [];
function $cfc1afd3507a91b5$export$2e2bcd8739ae039(Prism) {
    Prism.languages.julia = {
        comment: {
            // support one level of nested comments
            // https://github.com/JuliaLang/julia/pull/6128
            pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
            lookbehind: true
        },
        regex: {
            // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
            pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
            greedy: true
        },
        string: {
            // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
            // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
            // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
            pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
            greedy: true
        },
        char: {
            // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
            pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
        operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
        punctuation: /::?|[{}[\]();,.?]/,
        // https://docs.julialang.org/en/v1/base/numbers/#Base.im
        constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $350499ec8fbf9130$export$2e2bcd8739ae039.displayName = 'keepalived';
$350499ec8fbf9130$export$2e2bcd8739ae039.aliases = [];
function $350499ec8fbf9130$export$2e2bcd8739ae039(Prism) {
    Prism.languages.keepalived = {
        comment: {
            pattern: /[#!].*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
            lookbehind: true,
            greedy: true
        },
        // support IPv4, IPv6, subnet mask
        ip: {
            pattern: RegExp(/\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(/<ipv4>/g, function() {
                return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }), 'i'),
            alias: 'number'
        },
        // support *nix / Windows, directory / file
        path: {
            pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
            lookbehind: true,
            alias: 'string'
        },
        variable: /\$\{?\w+\}?/,
        email: {
            pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
            alias: 'string'
        },
        'conditional-configuration': {
            pattern: /@\^?[\w-]+/,
            alias: 'variable'
        },
        operator: /=/,
        property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
        constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
        number: {
            pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
            lookbehind: true
        },
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\{\}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d1947654b0468835$export$2e2bcd8739ae039.displayName = 'keyman';
$d1947654b0468835$export$2e2bcd8739ae039.aliases = [];
function $d1947654b0468835$export$2e2bcd8739ae039(Prism) {
    Prism.languages.keyman = {
        comment: {
            pattern: /\bc .*/i,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        'virtual-key': {
            pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
            greedy: true,
            alias: 'function' // alias for styles
        },
        // https://help.keyman.com/developer/language/guide/headers
        'header-keyword': {
            pattern: /&\w+/,
            alias: 'bold' // alias for styles
        },
        'header-statement': {
            pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
            alias: 'bold' // alias for styles
        },
        'rule-keyword': {
            pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
            alias: 'keyword'
        },
        'structural-keyword': {
            pattern: /\b(?:ansi|begin|group|match|newcontext|nomatch|postkeystroke|readonly|unicode|using keys)\b/i,
            alias: 'keyword'
        },
        'compile-target': {
            pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
            alias: 'property'
        },
        // U+####, x###, d### characters and numbers
        number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
        operator: /[+>\\$]|\.\./,
        punctuation: /[()=,]/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5796ea4f5c719733$export$2e2bcd8739ae039.displayName = 'kumir';
$5796ea4f5c719733$export$2e2bcd8739ae039.aliases = [
    'kum'
];
function $5796ea4f5c719733$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Regular expression for characters that are not allowed in identifiers.
     *
     * @type {string}
     */ var nonId = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
        /**
     * Surround a regular expression for IDs with patterns for non-ID sequences.
     *
     * @param {string} pattern A regular expression for identifiers.
     * @param {string} [flags] The regular expression flags.
     * @returns {RegExp} A wrapped regular expression for identifiers.
     */ function wrapId(pattern, flags) {
            return RegExp(pattern.replace(/<nonId>/g, nonId), flags);
        }
        Prism.languages.kumir = {
            comment: {
                pattern: /\|.*/
            },
            prolog: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
                greedy: true
            },
            boolean: {
                pattern: wrapId(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            'operator-word': {
                pattern: wrapId(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            'system-variable': {
                pattern: wrapId(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            type: [
                {
                    pattern: wrapId(/(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'builtin'
                },
                {
                    pattern: wrapId(/(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'important'
                }
            ],
            /**
       * Should be performed after searching for type names because of "таб".
       * "таб" is a reserved word, but never used without a preceding type name.
       * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
       */ keyword: {
                pattern: wrapId(/(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for reserved words. */ name: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: wrapId(/(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for names. */ number: {
                pattern: wrapId(/(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source, 'i'),
                lookbehind: true
            },
            /** Should be performed after searching for words. */ punctuation: /:=|[(),:;\[\]]/,
            /**
       * Should be performed after searching for
       * - numeric constants (because of "+" and "-");
       * - punctuation marks (because of ":=" and "=").
       */ 'operator-char': {
                pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
                alias: 'operator'
            }
        };
        Prism.languages.kum = Prism.languages.kumir;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c3d8d532e557e2f4$export$2e2bcd8739ae039.displayName = 'kusto';
$c3d8d532e557e2f4$export$2e2bcd8739ae039.aliases = [];
function $c3d8d532e557e2f4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.kusto = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
            greedy: true
        },
        verb: {
            pattern: /(\|\s*)[a-z][\w-]*/i,
            lookbehind: true,
            alias: 'keyword'
        },
        command: {
            pattern: /\.[a-z][a-z\d-]*\b/,
            alias: 'keyword'
        },
        'class-name': /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
        keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
        boolean: /\b(?:false|null|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/,
        datetime: [
            {
                // RFC 822 + RFC 850
                pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
                alias: 'number'
            },
            {
                // ISO 8601
                pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
                alias: 'number'
            }
        ],
        number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
        operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
        punctuation: /[()\[\]{},;.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f13c2598f5dc8663$export$2e2bcd8739ae039.displayName = 'latex';
$f13c2598f5dc8663$export$2e2bcd8739ae039.aliases = [
    'context',
    'tex'
];
function $f13c2598f5dc8663$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i;
        var insideEqu = {
            'equation-command': {
                pattern: funcPattern,
                alias: 'regex'
            }
        };
        Prism.languages.latex = {
            comment: /%.*/,
            // the verbatim environment prints whitespace to the document
            cdata: {
                pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                lookbehind: true
            },
            /*
       * equations can be between $$ $$ or $ $ or \( \) or \[ \]
       * (all are multiline)
       */ equation: [
                {
                    pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
                    inside: insideEqu,
                    alias: 'string'
                },
                {
                    pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                    lookbehind: true,
                    inside: insideEqu,
                    alias: 'string'
                }
            ],
            /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */ keyword: {
                pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true
            },
            url: {
                pattern: /(\\url\{)[^}]+(?=\})/,
                lookbehind: true
            },
            /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */ headline: {
                pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true,
                alias: 'class-name'
            },
            function: {
                pattern: funcPattern,
                alias: 'selector'
            },
            punctuation: /[[\]{}&]/
        };
        Prism.languages.tex = Prism.languages.latex;
        Prism.languages.context = Prism.languages.latex;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$c8196ec3df0cee5b$export$2e2bcd8739ae039.displayName = 'latte';
$c8196ec3df0cee5b$export$2e2bcd8739ae039.aliases = [];
function $c8196ec3df0cee5b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.latte = {
            comment: /^\{\*[\s\S]*/,
            'latte-tag': {
                // https://latte.nette.org/en/tags
                pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
                lookbehind: true,
                alias: 'important'
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                alias: 'punctuation'
            },
            php: {
                pattern: /\S(?:[\s\S]*\S)?/,
                alias: 'language-php',
                inside: Prism.languages.php
            }
        };
        var markupLatte = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('inside', 'attr-value', {
            'n-attr': {
                pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
                inside: {
                    'attr-name': {
                        pattern: /^[^\s=]+/,
                        alias: 'important'
                    },
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            punctuation: [
                                /^=/,
                                {
                                    pattern: /^(\s*)["']|["']$/,
                                    lookbehind: true
                                }
                            ],
                            php: {
                                pattern: /\S(?:[\s\S]*\S)?/,
                                inside: Prism.languages.php
                            }
                        }
                    }
                }
            }
        }, markupLatte.tag);
        Prism.hooks.add('before-tokenize', function(env) {
            if (env.language !== 'latte') return;
            var lattePattern = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'latte', lattePattern);
            env.grammar = markupLatte;
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'latte');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f15bc5f7f9ab760a$export$2e2bcd8739ae039.displayName = 'scheme';
$f15bc5f7f9ab760a$export$2e2bcd8739ae039.aliases = [];
function $f15bc5f7f9ab760a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.scheme = {
            // this supports "normal" single-line comments:
            //   ; comment
            // and (potentially nested) multiline comments:
            //   #| comment #| nested |# still comment |#
            // (only 1 level of nesting is supported)
            comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            symbol: {
                pattern: /'[^()\[\]#'\s]+/,
                greedy: true
            },
            char: {
                pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
                greedy: true
            },
            'lambda-parameter': [
                // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
                    lookbehind: true
                }
            ],
            keyword: {
                pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            builtin: {
                // all functions of the base library of R7RS plus some of built-ins of R5Rs
                pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            operator: {
                pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            number: {
                // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
                //
                // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
                // <num R>       := <prefix R><complex R>
                // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
                // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
                // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
                // <ureal R>     := <uint R>(?:\/<uint R>)?
                //                | <decimal R>
                //
                // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
                // <uint R>      := <digit R>+
                // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
                // <radix 2>     := #b
                // <radix 8>     := #o
                // <radix 10>    := (?:#d)?
                // <radix 16>    := #x
                // <digit 2>     := [01]
                // <digit 8>     := [0-7]
                // <digit 10>    := \d
                // <digit 16>    := [0-9a-f]
                //
                // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
                // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
                // pattern:
                pattern: RegExp(SortedBNF({
                    '<ureal dec>': /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
                    '<real dec>': /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary dec>': /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
                    '<complex dec>': /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
                    '<num dec>': /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
                    '<ureal box>': /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
                    '<real box>': /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary box>': /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
                    '<complex box>': /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
                    '<num box>': /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
                    '<number>': /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
                }), 'i'),
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            function: {
                pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            identifier: {
                pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
                lookbehind: true,
                greedy: true
            },
            punctuation: /[()\[\]']/
        };
        /**
     * Given a topologically sorted BNF grammar, this will return the RegExp source of last rule of the grammar.
     *
     * @param {Record<string, string>} grammar
     * @returns {string}
     */ function SortedBNF(grammar) {
            for(var key in grammar)grammar[key] = grammar[key].replace(/<[\w\s]+>/g, function(key) {
                return '(?:' + grammar[key].trim() + ')';
            });
            // return the last item
            return grammar[key];
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$dff85ed6bfabe21a$export$2e2bcd8739ae039.displayName = 'lilypond';
$dff85ed6bfabe21a$export$2e2bcd8739ae039.aliases = [
    'ly'
];
function $dff85ed6bfabe21a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f15bc5f7f9ab760a$export$2e2bcd8739ae039));
    (function(Prism) {
        var schemeExpression = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source;
        // allow for up to pow(2, recursivenessLog2) many levels of recursive brace expressions
        // For some reason, this can't be 4
        var recursivenessLog2 = 5;
        for(var i = 0; i < recursivenessLog2; i++)schemeExpression = schemeExpression.replace(/<expr>/g, function() {
            return schemeExpression;
        });
        schemeExpression = schemeExpression.replace(/<expr>/g, /[^\s\S]/.source);
        var lilypond = Prism.languages.lilypond = {
            comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
            'embedded-scheme': {
                pattern: RegExp(/(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(/<expr>/g, function() {
                    return schemeExpression;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                inside: {
                    scheme: {
                        pattern: /^(#)[\s\S]+$/,
                        lookbehind: true,
                        alias: 'language-scheme',
                        inside: {
                            'embedded-lilypond': {
                                pattern: /#\{[\s\S]*?#\}/,
                                greedy: true,
                                inside: {
                                    punctuation: /^#\{|#\}$/,
                                    lilypond: {
                                        pattern: /[\s\S]+/,
                                        alias: 'language-lilypond',
                                        inside: null // see below
                                    }
                                }
                            },
                            rest: Prism.languages.scheme
                        }
                    },
                    punctuation: /#/
                }
            },
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': {
                pattern: /(\\new\s+)[\w-]+/,
                lookbehind: true
            },
            keyword: {
                pattern: /\\[a-z][-\w]*/i,
                inside: {
                    punctuation: /^\\/
                }
            },
            operator: /[=|]|<<|>>/,
            punctuation: {
                pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
                lookbehind: true
            },
            number: /\b\d+(?:\/\d+)?\b/
        };
        lilypond['embedded-scheme'].inside['scheme'].inside['embedded-lilypond'].inside['lilypond'].inside = lilypond;
        Prism.languages.ly = lilypond;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0ebb485d13184e81$export$2e2bcd8739ae039.displayName = 'liquid';
$0ebb485d13184e81$export$2e2bcd8739ae039.aliases = [];
function $0ebb485d13184e81$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.languages.liquid = {
        comment: {
            pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
            lookbehind: true
        },
        delimiter: {
            pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
        object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
        function: [
            {
                pattern: /(\|\s*)\w+/,
                lookbehind: true,
                alias: 'filter'
            },
            {
                // array functions
                pattern: /(\.\s*)(?:first|last|size)/,
                lookbehind: true
            }
        ],
        boolean: /\b(?:false|nil|true)\b/,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
        punctuation: /[.,\[\]()]/,
        empty: {
            pattern: /\bempty\b/,
            alias: 'keyword'
        }
    };
    Prism.hooks.add('before-tokenize', function(env) {
        var liquidPattern = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g;
        var insideRaw = false;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'liquid', liquidPattern, function(match) {
            var tagMatch = /^\{%-?\s*(\w+)/.exec(match);
            if (tagMatch) {
                var tag = tagMatch[1];
                if (tag === 'raw' && !insideRaw) {
                    insideRaw = true;
                    return true;
                } else if (tag === 'endraw') {
                    insideRaw = false;
                    return true;
                }
            }
            return !insideRaw;
        });
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'liquid');
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $59e22f64646db583$export$2e2bcd8739ae039.displayName = 'lisp';
$59e22f64646db583$export$2e2bcd8739ae039.aliases = [
    'elisp',
    'emacs',
    'emacs-lisp'
];
function $59e22f64646db583$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        /**
     * Functions to construct regular expressions
     * e.g. (interactive ... or (interactive)
     *
     * @param {string} name
     * @returns {RegExp}
     */ function simple_form(name) {
            return RegExp(/(\()/.source + '(?:' + name + ')' + /(?=[\s\)])/.source);
        }
        /**
     * booleans and numbers
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function primitive(pattern) {
            return RegExp(/([\s([])/.source + '(?:' + pattern + ')' + /(?=[\s)])/.source);
        }
        // Patterns in regular expressions
        // Symbol name. See https://www.gnu.org/software/emacs/manual/html_node/elisp/Symbol-Type.html
        // & and : are excluded as they are usually used for special purposes
        var symbol = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source;
        // symbol starting with & used in function arguments
        var marker = '&' + symbol;
        // Open parenthesis for look-behind
        var par = '(\\()';
        var endpar = '(?=\\))';
        // End the pattern with look-ahead space
        var space = '(?=\\s)';
        var nestedPar = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source;
        var language = {
            // Three or four semicolons are considered a heading.
            // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
            heading: {
                pattern: /;;;.*/,
                alias: [
                    'comment',
                    'title'
                ]
            },
            comment: /;.*/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true,
                inside: {
                    argument: /[-A-Z]+(?=[.,\s])/,
                    symbol: RegExp('`' + symbol + "'")
                }
            },
            'quoted-symbol': {
                pattern: RegExp("#?'" + symbol),
                alias: [
                    'variable',
                    'symbol'
                ]
            },
            'lisp-property': {
                pattern: RegExp(':' + symbol),
                alias: 'property'
            },
            splice: {
                pattern: RegExp(',@?' + symbol),
                alias: [
                    'symbol',
                    'variable'
                ]
            },
            keyword: [
                {
                    pattern: RegExp(par + '(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)' + space),
                    lookbehind: true
                },
                {
                    pattern: RegExp(par + '(?:append|by|collect|concat|do|finally|for|in|return)' + space),
                    lookbehind: true
                }
            ],
            declare: {
                pattern: simple_form(/declare/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            interactive: {
                pattern: simple_form(/interactive/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            boolean: {
                pattern: primitive(/nil|t/.source),
                lookbehind: true
            },
            number: {
                pattern: primitive(/[-+]?\d+(?:\.\d*)?/.source),
                lookbehind: true
            },
            defvar: {
                pattern: RegExp(par + 'def(?:const|custom|group|var)\\s+' + symbol),
                lookbehind: true,
                inside: {
                    keyword: /^def[a-z]+/,
                    variable: RegExp(symbol)
                }
            },
            defun: {
                pattern: RegExp(par + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + symbol + /\s+\(/.source + nestedPar + /\)/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^(?:cl-)?def\S+/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    function: {
                        pattern: RegExp('(^\\s)' + symbol),
                        lookbehind: true
                    },
                    punctuation: /[()]/
                }
            },
            lambda: {
                pattern: RegExp(par + 'lambda\\s+\\(\\s*(?:&?' + symbol + '(?:\\s+&?' + symbol + ')*\\s*)?\\)'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^lambda/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    punctuation: /[()]/
                }
            },
            car: {
                pattern: RegExp(par + symbol),
                lookbehind: true
            },
            punctuation: [
                // open paren, brackets, and close paren
                /(?:['`,]?\(|[)\[\]])/,
                // cons
                {
                    pattern: /(\s)\.(?=\s)/,
                    lookbehind: true
                }
            ]
        };
        var arg = {
            'lisp-marker': RegExp(marker),
            varform: {
                pattern: RegExp(/\(/.source + symbol + /\s+(?=\S)/.source + nestedPar + /\)/.source),
                inside: language
            },
            argument: {
                pattern: RegExp(/(^|[\s(])/.source + symbol),
                lookbehind: true,
                alias: 'variable'
            },
            rest: language
        };
        var forms = '\\S+(?:\\s+\\S+)*';
        var arglist = {
            pattern: RegExp(par + nestedPar + endpar),
            lookbehind: true,
            inside: {
                'rest-vars': {
                    pattern: RegExp('&(?:body|rest)\\s+' + forms),
                    inside: arg
                },
                'other-marker-vars': {
                    pattern: RegExp('&(?:aux|optional)\\s+' + forms),
                    inside: arg
                },
                keys: {
                    pattern: RegExp('&key\\s+' + forms + '(?:\\s+&allow-other-keys)?'),
                    inside: arg
                },
                argument: {
                    pattern: RegExp(symbol),
                    alias: 'variable'
                },
                punctuation: /[()]/
            }
        };
        language['lambda'].inside.arguments = arglist;
        language['defun'].inside.arguments = Prism.util.clone(arglist);
        language['defun'].inside.arguments.inside.sublist = arglist;
        Prism.languages.lisp = language;
        Prism.languages.elisp = language;
        Prism.languages.emacs = language;
        Prism.languages['emacs-lisp'] = language;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fb1869ae2e02698d$export$2e2bcd8739ae039.displayName = 'livescript';
$fb1869ae2e02698d$export$2e2bcd8739ae039.aliases = [];
function $fb1869ae2e02698d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.livescript = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true
            },
            {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true
            }
        ],
        'interpolated-string': {
            /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */ pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
                    lookbehind: true
                },
                interpolation: {
                    pattern: /(^|[^\\])#\{[^}]+\}/m,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^#\{|\}$/,
                            alias: 'variable'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        string: [
            {
                pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            {
                pattern: /<\[[\s\S]*?\]>/,
                greedy: true
            },
            /\\[^\s,;\])}]+/
        ],
        regex: [
            {
                pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
                greedy: true,
                inside: {
                    comment: {
                        pattern: /(^|[^\\])#.*/,
                        lookbehind: true
                    }
                }
            },
            {
                pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
                greedy: true
            }
        ],
        keyword: {
            pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
            lookbehind: true
        },
        'keyword-operator': {
            pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
            lookbehind: true,
            alias: 'operator'
        },
        boolean: {
            pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
            lookbehind: true
        },
        argument: {
            // Don't match .&. nor &&
            pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
            lookbehind: true,
            alias: 'variable'
        },
        number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
        identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
        operator: [
            // Spaced .
            {
                pattern: /( )\.(?= )/,
                lookbehind: true
            },
            // Full list, in order:
            // .= .~ .. ...
            // .&. .^. .<<. .>>. .>>>.
            // := :: ::=
            // &&
            // || |>
            // < << <<< <<<<
            // <- <-- <-! <--!
            // <~ <~~ <~! <~~!
            // <| <= <?
            // > >> >= >?
            // - -- -> -->
            // + ++
            // @ @@
            // % %%
            // * **
            // ! != !~=
            // !~> !~~>
            // !-> !-->
            // ~ ~> ~~> ~=
            // = ==
            // ^ ^^
            // / ?
            /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
        ],
        punctuation: /[(){}\[\]|.,:;`]/
    };
    Prism.languages.livescript['interpolated-string'].inside['interpolation'].inside.rest = Prism.languages.livescript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b6a0f971cc211856$export$2e2bcd8739ae039.displayName = 'llvm';
$b6a0f971cc211856$export$2e2bcd8739ae039.aliases = [];
function $b6a0f971cc211856$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.llvm = {
            comment: /;.*/,
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            boolean: /\b(?:false|true)\b/,
            variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
            label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
            type: {
                pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
                alias: 'class-name'
            },
            keyword: /\b[a-z_][a-z_0-9]*\b/,
            number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
            punctuation: /[{}[\];(),.!*=<>]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0ce2bbca25db411c$export$2e2bcd8739ae039.displayName = 'log';
$0ce2bbca25db411c$export$2e2bcd8739ae039.aliases = [];
function $0ce2bbca25db411c$export$2e2bcd8739ae039(Prism) {
    // This is a language definition for generic log files.
    // Since there is no one log format, this language definition has to support all formats to some degree.
    //
    // Based on https://github.com/MTDL9/vim-log-highlighting
    Prism.languages.log = {
        string: {
            // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        exception: {
            pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
            lookbehind: true,
            greedy: true,
            alias: [
                'javastacktrace',
                'language-javastacktrace'
            ],
            inside: Prism.languages['javastacktrace'] || {
                keyword: /\bat\b/,
                function: /[a-z_][\w$]*(?=\()/,
                punctuation: /[.:()]/
            }
        },
        level: [
            {
                pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
                alias: [
                    'error',
                    'important'
                ]
            },
            {
                pattern: /\b(?:WARN|WARNING|WRN)\b/,
                alias: [
                    'warning',
                    'important'
                ]
            },
            {
                pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
                alias: [
                    'info',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:DBG|DEBUG|FINE)\b/,
                alias: [
                    'debug',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
                alias: [
                    'trace',
                    'comment'
                ]
            }
        ],
        property: {
            pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
            lookbehind: true
        },
        separator: {
            pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
            lookbehind: true,
            alias: 'comment'
        },
        url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
        email: {
            pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
            lookbehind: true,
            alias: 'url'
        },
        'ip-address': {
            pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
            alias: 'constant'
        },
        'mac-address': {
            pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
            alias: 'constant'
        },
        domain: {
            pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
            lookbehind: true,
            alias: 'constant'
        },
        uuid: {
            pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
            alias: 'constant'
        },
        hash: {
            pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
            alias: 'constant'
        },
        'file-path': {
            pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
            lookbehind: true,
            greedy: true,
            alias: 'string'
        },
        date: {
            pattern: RegExp(/\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + '|' + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + '|' + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source, 'i'),
            alias: 'number'
        },
        time: {
            pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
            alias: 'number'
        },
        boolean: /\b(?:false|null|true)\b/i,
        number: {
            pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
            lookbehind: true
        },
        operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
        punctuation: /[\[\].,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $55c84b5f47c86788$export$2e2bcd8739ae039.displayName = 'lolcode';
$55c84b5f47c86788$export$2e2bcd8739ae039.aliases = [];
function $55c84b5f47c86788$export$2e2bcd8739ae039(Prism) {
    Prism.languages.lolcode = {
        comment: [
            /\bOBTW\s[\s\S]*?\sTLDR\b/,
            /\bBTW.+/
        ],
        string: {
            pattern: /"(?::.|[^":])*"/,
            inside: {
                variable: /:\{[^}]+\}/,
                symbol: [
                    /:\([a-f\d]+\)/i,
                    /:\[[^\]]+\]/,
                    /:[)>o":]/
                ]
            },
            greedy: true
        },
        number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
        symbol: {
            pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
            lookbehind: true,
            inside: {
                keyword: /A(?=\s)/
            }
        },
        label: {
            pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
            lookbehind: true,
            alias: 'string'
        },
        function: {
            pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
            lookbehind: true
        },
        keyword: [
            {
                pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
                lookbehind: true
            },
            /'Z(?=\s|,|$)/
        ],
        boolean: {
            pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
            lookbehind: true
        },
        variable: {
            pattern: /(^|\s)IT(?=\s|,|$)/,
            lookbehind: true
        },
        operator: {
            pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
            lookbehind: true
        },
        punctuation: /\.{3}|…|,|!/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9513a6857dddaa7a$export$2e2bcd8739ae039.displayName = 'magma';
$9513a6857dddaa7a$export$2e2bcd8739ae039.aliases = [];
function $9513a6857dddaa7a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.magma = {
        output: {
            pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        // http://magma.maths.usyd.edu.au/magma/handbook/text/82
        keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
        boolean: /\b(?:false|true)\b/,
        generator: {
            pattern: /\b[a-z_]\w*(?=\s*<)/i,
            alias: 'class-name'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        operator: /->|[-+*/^~!|#=]|:=|\.\./,
        punctuation: /[()[\]{}<>,;.:]/
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7306ed74be230ce9$export$2e2bcd8739ae039.displayName = 'mata';
$7306ed74be230ce9$export$2e2bcd8739ae039.aliases = [];
function $7306ed74be230ce9$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var orgType = /\b(?:(?:col|row)?vector|matrix|scalar)\b/.source;
        var type = /\bvoid\b|<org>|\b(?:complex|numeric|pointer(?:\s*\([^()]*\))?|real|string|(?:class|struct)\s+\w+|transmorphic)(?:\s*<org>)?/.source.replace(/<org>/g, orgType);
        Prism.languages.mata = {
            comment: {
                pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|extends|struct)\s+)\w+(?=\s*(?:\{|\bextends\b))/,
                lookbehind: true
            },
            type: {
                pattern: RegExp(type),
                alias: 'class-name',
                inside: {
                    punctuation: /[()]/,
                    keyword: /\b(?:class|function|struct|void)\b/
                }
            },
            keyword: /\b(?:break|class|continue|do|else|end|extends|external|final|for|function|goto|if|pragma|private|protected|public|return|static|struct|unset|unused|version|virtual|while)\b/,
            constant: /\bNULL\b/,
            number: {
                pattern: /(^|[^\w.])(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|\d[a-f0-9]*(?:\.[a-f0-9]+)?x[+-]?\d+)i?(?![\w.])/i,
                lookbehind: true
            },
            missing: {
                pattern: /(^|[^\w.])(?:\.[a-z]?)(?![\w.])/,
                lookbehind: true,
                alias: 'symbol'
            },
            function: /\b[a-z_]\w*(?=\s*\()/i,
            operator: /\.\.|\+\+|--|&&|\|\||:?(?:[!=<>]=|[+\-*/^<>&|:])|[!?=\\#’`']/,
            punctuation: /[()[\]{},;.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0032d605afbc43b2$export$2e2bcd8739ae039.displayName = 'matlab';
$0032d605afbc43b2$export$2e2bcd8739ae039.aliases = [];
function $0032d605afbc43b2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.matlab = {
        comment: [
            /%\{[\s\S]*?\}%/,
            /%.+/
        ],
        string: {
            pattern: /\B'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        // FIXME We could handle imaginary numbers as a whole
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
        keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
        function: /\b(?!\d)\w+(?=\s*\()/,
        operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
        punctuation: /\.{3}|[.,;\[\](){}!]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $ff984944cd41b96b$export$2e2bcd8739ae039.displayName = 'maxscript';
$ff984944cd41b96b$export$2e2bcd8739ae039.aliases = [];
function $ff984944cd41b96b$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
        Prism.languages.maxscript = {
            comment: {
                pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
                greedy: true
            },
            string: {
                pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
                lookbehind: true,
                greedy: true
            },
            path: {
                pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
                greedy: true,
                alias: 'string'
            },
            'function-call': {
                pattern: RegExp('((?:' + // start of line
                (/^/.source + '|' + // operators and other language constructs
                /[;=<>+\-*/^({\[]/.source + '|' + // keywords as part of statements
                /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ')[ \t]*)' + '(?!' + keywords.source + ')' + /[a-z_]\w*\b/.source + '(?=[ \t]*(?:' + // variable
                ('(?!' + keywords.source + ')' + /[a-z_]/.source + '|' + // number
                /\d|-\.?\d/.source + '|' + // other expressions or literals
                /[({'"$@#?]/.source) + '))', 'im'),
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'function-definition': {
                pattern: /(\b(?:fn|function)\s+)\w+\b/i,
                lookbehind: true,
                alias: 'function'
            },
            argument: {
                pattern: /\b[a-z_]\w*(?=:)/i,
                alias: 'attr-name'
            },
            keyword: keywords,
            boolean: /\b(?:false|true)\b/,
            time: {
                pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
                lookbehind: true,
                alias: 'number'
            },
            number: [
                {
                    pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
                    lookbehind: true
                },
                /\b(?:e|pi)\b/
            ],
            constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
            color: {
                pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
                alias: 'constant'
            },
            operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
            punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $aee6b2f66d7ac757$export$2e2bcd8739ae039.displayName = 'mel';
$aee6b2f66d7ac757$export$2e2bcd8739ae039.aliases = [];
function $aee6b2f66d7ac757$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mel = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        code: {
            pattern: /`(?:\\.|[^\\`])*`/,
            greedy: true,
            alias: 'italic',
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                },
                statement: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        variable: /\$\w+/,
        number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
        flag: {
            pattern: /-[^\d\W]\w*/,
            alias: 'operator'
        },
        keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
        function: {
            pattern: /((?:^|[{;])[ \t]*)[a-z_]\w*\b(?!\s*(?:\.(?!\.)|[[{=]))|\b[a-z_]\w*(?=[ \t]*\()/im,
            lookbehind: true,
            greedy: true
        },
        'tensor-punctuation': {
            pattern: /<<|>>/,
            alias: 'punctuation'
        },
        operator: /\+[+=]?|-[-=]?|&&|\|\||[<>]=?|[*\/!=]=?|[%^]/,
        punctuation: /[.,:;?\[\](){}]/
    };
    Prism.languages.mel['code'].inside['statement'].inside = Prism.languages.mel;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $a4448d0866560d14$export$2e2bcd8739ae039.displayName = 'mermaid';
$a4448d0866560d14$export$2e2bcd8739ae039.aliases = [];
function $a4448d0866560d14$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mermaid = {
        comment: {
            pattern: /%%.*/,
            greedy: true
        },
        style: {
            pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
            lookbehind: true,
            inside: {
                property: /\b\w[\w-]*(?=[ \t]*:)/,
                operator: /:/,
                punctuation: /,/
            }
        },
        'inter-arrow-label': {
            pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
            lookbehind: true,
            greedy: true,
            inside: {
                arrow: {
                    pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
                    alias: 'operator'
                },
                label: {
                    pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
                    lookbehind: true,
                    alias: 'property'
                },
                'arrow-head': {
                    pattern: /^\S+/,
                    alias: [
                        'arrow',
                        'operator'
                    ]
                }
            }
        },
        arrow: [
            // This might look complex but it really isn't.
            // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
            // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
            // characters in the one lookbehind because that would create too many false negatives. So we have to split the
            // arrows into different patterns.
            {
                // ER diagram
                pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // flow chart
                // (?:==+|--+|-\.*-)
                pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // sequence diagram
                pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // class diagram
                pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
                lookbehind: true,
                alias: 'operator'
            }
        ],
        label: {
            pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        text: {
            pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
            alias: 'string'
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        annotation: {
            pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
            alias: 'important'
        },
        keyword: [
            // This language has both case-sensitive and case-insensitive keywords
            {
                pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
                lookbehind: true,
                greedy: true
            }
        ],
        entity: /#[a-z0-9]+;/,
        operator: {
            pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
            lookbehind: true
        },
        punctuation: /[(){};]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8d3fa3f18bccf1b2$export$2e2bcd8739ae039.displayName = 'metafont';
$8d3fa3f18bccf1b2$export$2e2bcd8739ae039.aliases = [];
function $8d3fa3f18bccf1b2$export$2e2bcd8739ae039(Prism) {
    Prism.languages.metafont = {
        // Syntax of METAFONT with the added (public) elements of PlainMETAFONT. Except for internal quantities they are expected to be rarely redefined. Freely inspired by the syntax of Christophe Grandsire for the Crimson Editor.
        comment: {
            pattern: /%.*/,
            greedy: true
        },
        string: {
            pattern: /"[^\r\n"]*"/,
            greedy: true
        },
        number: /\d*\.?\d+/,
        boolean: /\b(?:false|true)\b/,
        punctuation: [
            /[,;()]/,
            {
                pattern: /(^|[^{}])(?:\{|\})(?![{}])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^[])\[(?!\[)/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\]])\](?!\])/,
                lookbehind: true
            }
        ],
        constant: [
            {
                pattern: /(^|[^!?])\?\?\?(?![!?])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^/*\\])(?:\\|\\\\)(?![/*\\])/,
                lookbehind: true
            },
            /\b(?:_|blankpicture|bp|cc|cm|dd|ditto|down|eps|epsilon|fullcircle|halfcircle|identity|in|infinity|left|mm|nullpen|nullpicture|origin|pc|penrazor|penspeck|pensquare|penstroke|proof|pt|quartercircle|relax|right|smoke|unitpixel|unitsquare|up)\b/
        ],
        quantity: {
            pattern: /\b(?:autorounding|blacker|boundarychar|charcode|chardp|chardx|chardy|charext|charht|charic|charwd|currentwindow|day|designsize|displaying|fillin|fontmaking|granularity|hppp|join_radius|month|o_correction|pausing|pen_(?:bot|lft|rt|top)|pixels_per_inch|proofing|showstopping|smoothing|time|tolerance|tracingcapsules|tracingchoices|tracingcommands|tracingedges|tracingequations|tracingmacros|tracingonline|tracingoutput|tracingpens|tracingrestores|tracingspecs|tracingstats|tracingtitles|turningcheck|vppp|warningcheck|xoffset|year|yoffset)\b/,
            alias: 'keyword'
        },
        command: {
            pattern: /\b(?:addto|batchmode|charlist|cull|display|errhelp|errmessage|errorstopmode|everyjob|extensible|fontdimen|headerbyte|inner|interim|let|ligtable|message|newinternal|nonstopmode|numspecial|openwindow|outer|randomseed|save|scrollmode|shipout|show|showdependencies|showstats|showtoken|showvariable|special)\b/,
            alias: 'builtin'
        },
        operator: [
            {
                pattern: /(^|[^>=<:|])(?:<|<=|=|=:|\|=:|\|=:>|=:\|>|=:\||\|=:\||\|=:\|>|\|=:\|>>|>|>=|:|:=|<>|::|\|\|:)(?![>=<:|])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^+-])(?:\+|\+\+|-{1,3}|\+-\+)(?![+-])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^/*\\])(?:\*|\*\*|\/)(?![/*\\])/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.])(?:\.{2,3})(?!\.)/,
                lookbehind: true
            },
            {
                pattern: /(^|[^@#&$])&(?![@#&$])/,
                lookbehind: true
            },
            /\b(?:and|not|or)\b/
        ],
        macro: {
            pattern: /\b(?:abs|beginchar|bot|byte|capsule_def|ceiling|change_width|clear_pen_memory|clearit|clearpen|clearxy|counterclockwise|cullit|cutdraw|cutoff|decr|define_blacker_pixels|define_corrected_pixels|define_good_x_pixels|define_good_y_pixels|define_horizontal_corrected_pixels|define_pixels|define_whole_blacker_pixels|define_whole_pixels|define_whole_vertical_blacker_pixels|define_whole_vertical_pixels|dir|direction|directionpoint|div|dotprod|downto|draw|drawdot|endchar|erase|fill|filldraw|fix_units|flex|font_coding_scheme|font_extra_space|font_identifier|font_normal_shrink|font_normal_space|font_normal_stretch|font_quad|font_size|font_slant|font_x_height|gfcorners|gobble|gobbled|good\.(?:bot|lft|rt|top|x|y)|grayfont|hide|hround|imagerules|incr|interact|interpath|intersectionpoint|inverse|italcorr|killtext|labelfont|labels|lft|loggingall|lowres_fix|makegrid|makelabel(?:\.(?:bot|lft|rt|top)(?:\.nodot)?)?|max|min|mod|mode_def|mode_setup|nodisplays|notransforms|numtok|openit|penlabels|penpos|pickup|proofoffset|proofrule|proofrulethickness|range|reflectedabout|rotatedabout|rotatedaround|round|rt|savepen|screenchars|screenrule|screenstrokes|shipit|showit|slantfont|softjoin|solve|stop|superellipse|tensepath|thru|titlefont|top|tracingall|tracingnone|undraw|undrawdot|unfill|unfilldraw|upto|vround)\b/,
            alias: 'function'
        },
        builtin: /\b(?:ASCII|angle|char|cosd|decimal|directiontime|floor|hex|intersectiontimes|jobname|known|length|makepath|makepen|mexp|mlog|normaldeviate|oct|odd|pencircle|penoffset|point|postcontrol|precontrol|reverse|rotated|sind|sqrt|str|subpath|substring|totalweight|turningnumber|uniformdeviate|unknown|xpart|xxpart|xypart|ypart|yxpart|yypart)\b/,
        keyword: /\b(?:also|at|atleast|begingroup|charexists|contour|controls|curl|cycle|def|delimiters|doublepath|dropping|dump|else|elseif|end|enddef|endfor|endgroup|endinput|exitif|exitunless|expandafter|fi|for|forever|forsuffixes|from|if|input|inwindow|keeping|kern|of|primarydef|quote|readstring|scaled|scantokens|secondarydef|shifted|skipto|slanted|step|tension|tertiarydef|to|transformed|until|vardef|withpen|withweight|xscaled|yscaled|zscaled)\b/,
        type: {
            pattern: /\b(?:boolean|expr|numeric|pair|path|pen|picture|primary|secondary|string|suffix|tertiary|text|transform)\b/,
            alias: 'property'
        },
        variable: {
            pattern: /(^|[^@#&$])(?:@#|#@|#|@)(?![@#&$])|\b(?:aspect_ratio|currentpen|currentpicture|currenttransform|d|extra_beginchar|extra_endchar|extra_setup|h|localfont|mag|mode|screen_cols|screen_rows|w|whatever|x|y|z)\b/,
            lookbehind: true
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fce09911b128bdb6$export$2e2bcd8739ae039.displayName = 'mizar';
$fce09911b128bdb6$export$2e2bcd8739ae039.aliases = [];
function $fce09911b128bdb6$export$2e2bcd8739ae039(Prism) {
    Prism.languages.mizar = {
        comment: /::.+/,
        keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
        parameter: {
            pattern: /\$(?:10|\d)/,
            alias: 'variable'
        },
        variable: /\b\w+(?=:)/,
        number: /(?:\b|-)\d+\b/,
        operator: /\.\.\.|->|&|\.?=/,
        punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3350c1fbd5ca8b13$export$2e2bcd8739ae039.displayName = 'mongodb';
$3350c1fbd5ca8b13$export$2e2bcd8739ae039.aliases = [];
function $3350c1fbd5ca8b13$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        var operators = [
            // query and projection
            '$eq',
            '$gt',
            '$gte',
            '$in',
            '$lt',
            '$lte',
            '$ne',
            '$nin',
            '$and',
            '$not',
            '$nor',
            '$or',
            '$exists',
            '$type',
            '$expr',
            '$jsonSchema',
            '$mod',
            '$regex',
            '$text',
            '$where',
            '$geoIntersects',
            '$geoWithin',
            '$near',
            '$nearSphere',
            '$all',
            '$elemMatch',
            '$size',
            '$bitsAllClear',
            '$bitsAllSet',
            '$bitsAnyClear',
            '$bitsAnySet',
            '$comment',
            '$elemMatch',
            '$meta',
            '$slice',
            // update
            '$currentDate',
            '$inc',
            '$min',
            '$max',
            '$mul',
            '$rename',
            '$set',
            '$setOnInsert',
            '$unset',
            '$addToSet',
            '$pop',
            '$pull',
            '$push',
            '$pullAll',
            '$each',
            '$position',
            '$slice',
            '$sort',
            '$bit',
            // aggregation pipeline stages
            '$addFields',
            '$bucket',
            '$bucketAuto',
            '$collStats',
            '$count',
            '$currentOp',
            '$facet',
            '$geoNear',
            '$graphLookup',
            '$group',
            '$indexStats',
            '$limit',
            '$listLocalSessions',
            '$listSessions',
            '$lookup',
            '$match',
            '$merge',
            '$out',
            '$planCacheStats',
            '$project',
            '$redact',
            '$replaceRoot',
            '$replaceWith',
            '$sample',
            '$set',
            '$skip',
            '$sort',
            '$sortByCount',
            '$unionWith',
            '$unset',
            '$unwind',
            '$setWindowFields',
            // aggregation pipeline operators
            '$abs',
            '$accumulator',
            '$acos',
            '$acosh',
            '$add',
            '$addToSet',
            '$allElementsTrue',
            '$and',
            '$anyElementTrue',
            '$arrayElemAt',
            '$arrayToObject',
            '$asin',
            '$asinh',
            '$atan',
            '$atan2',
            '$atanh',
            '$avg',
            '$binarySize',
            '$bsonSize',
            '$ceil',
            '$cmp',
            '$concat',
            '$concatArrays',
            '$cond',
            '$convert',
            '$cos',
            '$dateFromParts',
            '$dateToParts',
            '$dateFromString',
            '$dateToString',
            '$dayOfMonth',
            '$dayOfWeek',
            '$dayOfYear',
            '$degreesToRadians',
            '$divide',
            '$eq',
            '$exp',
            '$filter',
            '$first',
            '$floor',
            '$function',
            '$gt',
            '$gte',
            '$hour',
            '$ifNull',
            '$in',
            '$indexOfArray',
            '$indexOfBytes',
            '$indexOfCP',
            '$isArray',
            '$isNumber',
            '$isoDayOfWeek',
            '$isoWeek',
            '$isoWeekYear',
            '$last',
            '$last',
            '$let',
            '$literal',
            '$ln',
            '$log',
            '$log10',
            '$lt',
            '$lte',
            '$ltrim',
            '$map',
            '$max',
            '$mergeObjects',
            '$meta',
            '$min',
            '$millisecond',
            '$minute',
            '$mod',
            '$month',
            '$multiply',
            '$ne',
            '$not',
            '$objectToArray',
            '$or',
            '$pow',
            '$push',
            '$radiansToDegrees',
            '$range',
            '$reduce',
            '$regexFind',
            '$regexFindAll',
            '$regexMatch',
            '$replaceOne',
            '$replaceAll',
            '$reverseArray',
            '$round',
            '$rtrim',
            '$second',
            '$setDifference',
            '$setEquals',
            '$setIntersection',
            '$setIsSubset',
            '$setUnion',
            '$size',
            '$sin',
            '$slice',
            '$split',
            '$sqrt',
            '$stdDevPop',
            '$stdDevSamp',
            '$strcasecmp',
            '$strLenBytes',
            '$strLenCP',
            '$substr',
            '$substrBytes',
            '$substrCP',
            '$subtract',
            '$sum',
            '$switch',
            '$tan',
            '$toBool',
            '$toDate',
            '$toDecimal',
            '$toDouble',
            '$toInt',
            '$toLong',
            '$toObjectId',
            '$toString',
            '$toLower',
            '$toUpper',
            '$trim',
            '$trunc',
            '$type',
            '$week',
            '$year',
            '$zip',
            '$count',
            '$dateAdd',
            '$dateDiff',
            '$dateSubtract',
            '$dateTrunc',
            '$getField',
            '$rand',
            '$sampleRate',
            '$setField',
            '$unsetField',
            // aggregation pipeline query modifiers
            '$comment',
            '$explain',
            '$hint',
            '$max',
            '$maxTimeMS',
            '$min',
            '$orderby',
            '$query',
            '$returnKey',
            '$showDiskLoc',
            '$natural'
        ];
        var builtinFunctions = [
            'ObjectId',
            'Code',
            'BinData',
            'DBRef',
            'Timestamp',
            'NumberLong',
            'NumberDecimal',
            'MaxKey',
            'MinKey',
            'RegExp',
            'ISODate',
            'UUID'
        ];
        operators = operators.map(function(operator) {
            return operator.replace('$', '\\$');
        });
        var operatorsSource = '(?:' + operators.join('|') + ')\\b';
        Prism.languages.mongodb = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('mongodb', 'string', {
            property: {
                pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
                greedy: true,
                inside: {
                    keyword: RegExp('^([\'"])?' + operatorsSource + '(?:\\1)?$')
                }
            }
        });
        Prism.languages.mongodb.string.inside = {
            url: {
                // url pattern
                pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
                greedy: true
            },
            entity: {
                // ipv4
                pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
                greedy: true
            }
        };
        Prism.languages.insertBefore('mongodb', 'constant', {
            builtin: {
                pattern: RegExp('\\b(?:' + builtinFunctions.join('|') + ')\\b'),
                alias: 'keyword'
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5c87aab191bc72fd$export$2e2bcd8739ae039.displayName = 'monkey';
$5c87aab191bc72fd$export$2e2bcd8739ae039.aliases = [];
function $5c87aab191bc72fd$export$2e2bcd8739ae039(Prism) {
    Prism.languages.monkey = {
        comment: {
            pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        preprocessor: {
            pattern: /(^[ \t]*)#.+/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        function: /\b\w+(?=\()/,
        'type-char': {
            pattern: /\b[?%#$]/,
            alias: 'class-name'
        },
        number: {
            pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
            lookbehind: true
        },
        keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
        operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
        punctuation: /[.,:;()\[\]]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0efdb6c99f3f7c98$export$2e2bcd8739ae039.displayName = 'moonscript';
$0efdb6c99f3f7c98$export$2e2bcd8739ae039.aliases = [
    'moon'
];
function $0efdb6c99f3f7c98$export$2e2bcd8739ae039(Prism) {
    Prism.languages.moonscript = {
        comment: /--.*/,
        string: [
            {
                pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
                greedy: true
            },
            {
                pattern: /"[^"]*"/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /#\{[^{}]*\}/,
                        inside: {
                            moonscript: {
                                pattern: /(^#\{)[\s\S]+(?=\})/,
                                lookbehind: true,
                                inside: null // see beow
                            },
                            'interpolation-punctuation': {
                                pattern: /#\{|\}/,
                                alias: 'punctuation'
                            }
                        }
                    }
                }
            }
        ],
        'class-name': [
            {
                pattern: /(\b(?:class|extends)[ \t]+)\w+/,
                lookbehind: true
            },
            // class-like names start with a capital letter
            /\b[A-Z]\w*/
        ],
        keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
        variable: /@@?\w*/,
        property: {
            pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
            lookbehind: true
        },
        function: {
            pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
            inside: {
                punctuation: /\./
            }
        },
        boolean: /\b(?:false|true)\b/,
        number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
        operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
        punctuation: /[.,()[\]{}\\]/
    };
    Prism.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = Prism.languages.moonscript;
    Prism.languages.moon = Prism.languages.moonscript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0c54d82c2339cc9c$export$2e2bcd8739ae039.displayName = 'n1ql';
$0c54d82c2339cc9c$export$2e2bcd8739ae039.aliases = [];
function $0c54d82c2339cc9c$export$2e2bcd8739ae039(Prism) {
    // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/index.html
    Prism.languages.n1ql = {
        comment: {
            pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
            greedy: true
        },
        parameter: /\$[\w.]+/,
        // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
        keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
        punctuation: /[;[\](),.{}:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $dd0a8f9cf86863f1$export$2e2bcd8739ae039.displayName = 'nand2tetris-hdl';
$dd0a8f9cf86863f1$export$2e2bcd8739ae039.aliases = [];
function $dd0a8f9cf86863f1$export$2e2bcd8739ae039(Prism) {
    Prism.languages['nand2tetris-hdl'] = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
        number: /\b\d+\b/,
        operator: /=|\.\./,
        punctuation: /[{}[\];(),:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6be9a541d67ded55$export$2e2bcd8739ae039.displayName = 'naniscript';
$6be9a541d67ded55$export$2e2bcd8739ae039.aliases = [
    'nani'
];
function $6be9a541d67ded55$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var expressionDef = /\{[^\r\n\[\]{}]*\}/;
        var params = {
            'quoted-string': {
                pattern: /"(?:[^"\\]|\\.)*"/,
                alias: 'operator'
            },
            'command-param-id': {
                pattern: /(\s)\w+:/,
                lookbehind: true,
                alias: 'property'
            },
            'command-param-value': [
                {
                    pattern: expressionDef,
                    alias: 'selector'
                },
                {
                    pattern: /([\t ])\S+/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'operator'
                },
                {
                    pattern: /\S(?:.*\S)?/,
                    alias: 'operator'
                }
            ]
        };
        Prism.languages.naniscript = {
            // ; ...
            comment: {
                pattern: /^([\t ]*);.*/m,
                lookbehind: true
            },
            // > ...
            // Define is a control line starting with '>' followed by a word, a space and a text.
            define: {
                pattern: /^>.+/m,
                alias: 'tag',
                inside: {
                    value: {
                        pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    key: {
                        pattern: /(^>)\w+/,
                        lookbehind: true
                    }
                }
            },
            // # ...
            label: {
                pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
                lookbehind: true,
                alias: 'regex'
            },
            command: {
                pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
                lookbehind: true,
                alias: 'function',
                inside: {
                    'command-name': /^@\w+/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'command-params': {
                        pattern: /\s*\S[\s\S]*/,
                        inside: params
                    }
                }
            },
            // Generic is any line that doesn't start with operators: ;>#@
            'generic-text': {
                pattern: /(^[ \t]*)[^#@>;\s].*/m,
                lookbehind: true,
                alias: 'punctuation',
                inside: {
                    // \{ ... \} ... \[ ... \] ... \"
                    'escaped-char': /\\[{}\[\]"]/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'inline-command': {
                        pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
                        greedy: true,
                        alias: 'function',
                        inside: {
                            'command-params': {
                                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                                lookbehind: true,
                                inside: params
                            },
                            'command-param-name': {
                                pattern: /^(\[[\t ]*)\w+/,
                                lookbehind: true,
                                alias: 'name'
                            },
                            'start-stop-char': /[\[\]]/
                        }
                    }
                }
            }
        };
        Prism.languages.nani = Prism.languages['naniscript'];
        /** @typedef {InstanceType<import("./prism-core")["Token"]>} Token */ /**
     * This hook is used to validate generic-text tokens for balanced brackets.
     * Mark token as bad-line when contains not balanced brackets: {},[]
     */ Prism.hooks.add('after-tokenize', function(env) {
            /** @type {(Token | string)[]} */ var tokens = env.tokens;
            tokens.forEach(function(token) {
                if (typeof token !== 'string' && token.type === 'generic-text') {
                    var content = getTextContent(token);
                    if (!isBracketsBalanced(content)) {
                        token.type = 'bad-line';
                        token.content = content;
                    }
                }
            });
        });
        /**
     * @param {string} input
     * @returns {boolean}
     */ function isBracketsBalanced(input) {
            var brackets = '[]{}';
            var stack = [];
            for(var i = 0; i < input.length; i++){
                var bracket = input[i];
                var bracketsIndex = brackets.indexOf(bracket);
                if (bracketsIndex !== -1) {
                    if (bracketsIndex % 2 === 0) stack.push(bracketsIndex + 1);
                    else if (stack.pop() !== bracketsIndex) return false;
                }
            }
            return stack.length === 0;
        }
        /**
     * @param {string | Token | (string | Token)[]} token
     * @returns {string}
     */ function getTextContent(token) {
            if (typeof token === 'string') return token;
            else if (Array.isArray(token)) return token.map(getTextContent).join('');
            else return getTextContent(token.content);
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $436bbebbe3139e7e$export$2e2bcd8739ae039.displayName = 'nasm';
$436bbebbe3139e7e$export$2e2bcd8739ae039.aliases = [];
function $436bbebbe3139e7e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nasm = {
        comment: /;.*$/m,
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        label: {
            pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
            lookbehind: true,
            alias: 'function'
        },
        keyword: [
            /\[?BITS (?:16|32|64)\]?/,
            {
                pattern: /(^\s*)section\s*[a-z.]+:?/im,
                lookbehind: true
            },
            /(?:extern|global)[^;\r\n]*/i,
            /(?:CPU|DEFAULT|FLOAT).*$/m
        ],
        register: {
            pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
            alias: 'variable'
        },
        number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-\/%<>=&|$!]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b0c7b814ccf677f$export$2e2bcd8739ae039.displayName = 'neon';
$4b0c7b814ccf677f$export$2e2bcd8739ae039.aliases = [];
function $4b0c7b814ccf677f$export$2e2bcd8739ae039(Prism) {
    Prism.languages.neon = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        datetime: {
            pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
            lookbehind: true,
            alias: 'number'
        },
        key: {
            pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
            lookbehind: true,
            alias: 'property'
        },
        number: {
            pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
            lookbehind: true
        },
        null: {
            pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
            lookbehind: true,
            alias: 'keyword'
        },
        string: {
            pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
            lookbehind: true,
            greedy: true
        },
        literal: {
            pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
            lookbehind: true,
            alias: 'string'
        },
        punctuation: /[,:=[\]{}()-]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $937b72076b7797c7$export$2e2bcd8739ae039.displayName = 'nevod';
$937b72076b7797c7$export$2e2bcd8739ae039.aliases = [];
function $937b72076b7797c7$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nevod = {
        comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
        string: {
            pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
            greedy: true,
            inside: {
                'string-attrs': /!$|!\*$|\*$/
            }
        },
        namespace: {
            pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
            lookbehind: true
        },
        pattern: {
            pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
            lookbehind: true,
            inside: {
                'pattern-name': {
                    pattern: /^#?[a-zA-Z0-9\-.]+/,
                    alias: 'class-name'
                },
                fields: {
                    pattern: /\(.*\)/,
                    inside: {
                        'field-name': {
                            pattern: /[a-zA-Z0-9\-.]+/,
                            alias: 'variable'
                        },
                        punctuation: /[,()]/,
                        operator: {
                            pattern: /~/,
                            alias: 'field-hidden-mark'
                        }
                    }
                }
            }
        },
        search: {
            pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
            alias: 'function',
            lookbehind: true
        },
        keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
        'standard-pattern': {
            pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
            inside: {
                'standard-pattern-name': {
                    pattern: /^[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                quantifier: {
                    pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
                    alias: 'number'
                },
                'standard-pattern-attr': {
                    pattern: /[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                punctuation: /[,()]/
            }
        },
        quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /=/,
                alias: 'pattern-def'
            },
            {
                pattern: /&/,
                alias: 'conjunction'
            },
            {
                pattern: /~/,
                alias: 'exception'
            },
            {
                pattern: /\?/,
                alias: 'optionality'
            },
            {
                pattern: /[[\]]/,
                alias: 'repetition'
            },
            {
                pattern: /[{}]/,
                alias: 'variation'
            },
            {
                pattern: /[+_]/,
                alias: 'sequence'
            },
            {
                pattern: /\.{2,3}/,
                alias: 'span'
            }
        ],
        'field-capture': [
            {
                pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
                lookbehind: true,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            },
            {
                pattern: /[a-zA-Z0-9\-.]+\s*:/,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            }
        ],
        punctuation: /[:;,()]/,
        name: /[a-zA-Z0-9\-.]+/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $93be80b0f58505d4$export$2e2bcd8739ae039.displayName = 'nginx';
$93be80b0f58505d4$export$2e2bcd8739ae039.aliases = [];
function $93be80b0f58505d4$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
        Prism.languages.nginx = {
            comment: {
                pattern: /(^|[\s{};])#.*/,
                lookbehind: true,
                greedy: true
            },
            directive: {
                pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: {
                    string: {
                        pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            escape: {
                                pattern: /\\["'\\nrt]/,
                                alias: 'entity'
                            },
                            variable: variable
                        }
                    },
                    comment: {
                        pattern: /(\s)#.*/,
                        lookbehind: true,
                        greedy: true
                    },
                    keyword: {
                        pattern: /^\S+/,
                        greedy: true
                    },
                    // other patterns
                    boolean: {
                        pattern: /(\s)(?:off|on)(?!\S)/,
                        lookbehind: true
                    },
                    number: {
                        pattern: /(\s)\d+[a-z]*(?!\S)/i,
                        lookbehind: true
                    },
                    variable: variable
                }
            },
            punctuation: /[{};]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $833f205419d7e6ea$export$2e2bcd8739ae039.displayName = 'nim';
$833f205419d7e6ea$export$2e2bcd8739ae039.aliases = [];
function $833f205419d7e6ea$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nim = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
            pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
            greedy: true
        },
        char: {
            // Character literals are handled specifically to prevent issues with numeric type suffixes
            pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
            greedy: true
        },
        function: {
            pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
            greedy: true,
            inside: {
                operator: /\*$/
            }
        },
        // We don't want to highlight operators (and anything really) inside backticks
        identifier: {
            pattern: /`[^`\r\n]+`/,
            greedy: true,
            inside: {
                punctuation: /`/
            }
        },
        // The negative look ahead prevents wrong highlighting of the .. operator
        number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
        keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
        operator: {
            // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
            // but allow the slice operator .. to take precedence over them
            // One can define his own operators in Nim so all combination of operators might be an operator.
            pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
            lookbehind: true
        },
        punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f6e28ce82e52815a$export$2e2bcd8739ae039.displayName = 'nix';
$f6e28ce82e52815a$export$2e2bcd8739ae039.aliases = [];
function $f6e28ce82e52815a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.nix = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
            greedy: true,
            inside: {
                interpolation: {
                    // The lookbehind ensures the ${} is not preceded by \ or ''
                    pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
                    lookbehind: true,
                    inside: null // see below
                }
            }
        },
        url: [
            /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
            {
                pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
                lookbehind: true
            }
        ],
        antiquotation: {
            pattern: /\$(?=\{)/,
            alias: 'important'
        },
        number: /\b\d+\b/,
        keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
        function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
        punctuation: /[{}()[\].,:;]/
    };
    Prism.languages.nix.string.inside.interpolation.inside = Prism.languages.nix;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $a71447da60e1f6e1$export$2e2bcd8739ae039.displayName = 'nsis';
$a71447da60e1f6e1$export$2e2bcd8739ae039.aliases = [];
function $a71447da60e1f6e1$export$2e2bcd8739ae039(Prism) {
    /**
   * Original by Jan T. Sott (http://github.com/idleberg)
   *
   * Includes all commands and plug-ins shipped with NSIS 3.08
   */ Prism.languages.nsis = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: {
            pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|KnownFolderPath|LabelAddress|TempFileName|WinVer)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|RtlLanguage|ShellVarContextAll|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|Target|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
            lookbehind: true
        },
        property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
        constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
        variable: /\$\w[\w\.]*/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
        punctuation: /[{}[\];(),.:]/,
        important: {
            pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
            lookbehind: true
        }
    };
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $db79ad093bda0678$export$2e2bcd8739ae039.displayName = 'ocaml';
$db79ad093bda0678$export$2e2bcd8739ae039.aliases = [];
function $db79ad093bda0678$export$2e2bcd8739ae039(Prism) {
    // https://ocaml.org/manual/lex.html
    Prism.languages.ocaml = {
        comment: {
            pattern: /\(\*[\s\S]*?\*\)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
            greedy: true
        },
        string: [
            {
                pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
                greedy: true
            },
            {
                pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
                greedy: true
            }
        ],
        number: [
            // binary and octal
            /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
            // hexadecimal
            /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
            // decimal
            /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
        ],
        directive: {
            pattern: /\B#\w+/,
            alias: 'property'
        },
        label: {
            pattern: /\B~\w+/,
            alias: 'property'
        },
        'type-variable': {
            pattern: /\B'\w+/,
            alias: 'function'
        },
        variant: {
            pattern: /`\w+/,
            alias: 'symbol'
        },
        // For the list of keywords and operators,
        // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
        keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        'operator-like-punctuation': {
            pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
            alias: 'punctuation'
        },
        // Custom operators are allowed
        operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
        punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4ed009a5750aab51$export$2e2bcd8739ae039.displayName = 'odin';
$4ed009a5750aab51$export$2e2bcd8739ae039.aliases = [];
function $4ed009a5750aab51$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var escapes = /\\(?:["'\\abefnrtv]|0[0-7]{2}|U[\dA-Fa-f]{6}|u[\dA-Fa-f]{4}|x[\dA-Fa-f]{2})/;
        Prism.languages.odin = {
            /**
       * The current implementation supports only 1 level of nesting.
       *
       * @author Michael Schmidt
       * @author edukisto
       */ comment: [
                {
                    pattern: /\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:\*(?!\/)|[^*])*(?:\*\/|$))*(?:\*\/|$)/,
                    greedy: true
                },
                {
                    pattern: /#![^\n\r]*/,
                    greedy: true
                },
                {
                    pattern: /\/\/[^\n\r]*/,
                    greedy: true
                }
            ],
            /**
       * Should be found before strings because of '"'"- and '`'`-like sequences.
       */ char: {
                pattern: /'(?:\\(?:.|[0Uux][0-9A-Fa-f]{1,6})|[^\n\r'\\])'/,
                greedy: true,
                inside: {
                    symbol: escapes
                }
            },
            string: [
                {
                    pattern: /`[^`]*`/,
                    greedy: true
                },
                {
                    pattern: /"(?:\\.|[^\n\r"\\])*"/,
                    greedy: true,
                    inside: {
                        symbol: escapes
                    }
                }
            ],
            directive: {
                pattern: /#\w+/,
                alias: 'property'
            },
            number: /\b0(?:b[01_]+|d[\d_]+|h_*(?:(?:(?:[\dA-Fa-f]_*){8}){1,2}|(?:[\dA-Fa-f]_*){4})|o[0-7_]+|x[\dA-F_a-f]+|z[\dAB_ab]+)\b|(?:\b\d+(?:\.(?!\.)\d*)?|\B\.\d+)(?:[Ee][+-]?\d*)?[ijk]?(?!\w)/,
            discard: {
                pattern: /\b_\b/,
                alias: 'keyword'
            },
            'procedure-definition': {
                pattern: /\b\w+(?=[ \t]*(?::\s*){2}proc\b)/,
                alias: 'function'
            },
            keyword: /\b(?:asm|auto_cast|bit_set|break|case|cast|context|continue|defer|distinct|do|dynamic|else|enum|fallthrough|for|foreign|if|import|in|map|matrix|not_in|or_else|or_return|package|proc|return|struct|switch|transmute|typeid|union|using|when|where)\b/,
            /**
       * false, nil, true can be used as procedure names. "_" and keywords can't.
       */ 'procedure-name': {
                pattern: /\b\w+(?=[ \t]*\()/,
                alias: 'function'
            },
            boolean: /\b(?:false|nil|true)\b/,
            'constant-parameter-sign': {
                pattern: /\$/,
                alias: 'important'
            },
            undefined: {
                pattern: /---/,
                alias: 'operator'
            },
            arrow: {
                pattern: /->/,
                alias: 'punctuation'
            },
            operator: /\+\+|--|\.\.[<=]?|(?:&~|[-!*+/=~]|[%&<>|]{1,2})=?|[?^]/,
            punctuation: /[(),.:;@\[\]{}]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2aa93c3806b01798$export$2e2bcd8739ae039.displayName = 'opencl';
$2aa93c3806b01798$export$2e2bcd8739ae039.aliases = [];
function $2aa93c3806b01798$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
    (function(Prism) {
        /* OpenCL kernel language */ Prism.languages.opencl = Prism.languages.extend('c', {
            // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
            keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
            // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
            // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
            // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
            number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
            boolean: /\b(?:false|true)\b/,
            'constant-opencl-kernel': {
                pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
                alias: 'constant'
            }
        });
        Prism.languages.insertBefore('opencl', 'class-name', {
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
            'builtin-type': {
                pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
                alias: 'keyword'
            }
        });
        var attributes = {
            // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
            'type-opencl-host': {
                pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
                alias: 'keyword'
            },
            'boolean-opencl-host': {
                pattern: /\bCL_(?:FALSE|TRUE)\b/,
                alias: 'boolean'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
            'constant-opencl-host': {
                pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
                alias: 'constant'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
            'function-opencl-host': {
                pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
                alias: 'function'
            }
        };
        /* OpenCL host API */ Prism.languages.insertBefore('c', 'keyword', attributes);
        // C++ includes everything from the OpenCL C host API plus the classes defined in cl2.h
        if (Prism.languages.cpp) {
            // Extracted from doxygen class list http://github.khronos.org/OpenCL-CLHPP/annotated.html
            attributes['type-opencl-host-cpp'] = {
                pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
                alias: 'keyword'
            };
            Prism.languages.insertBefore('cpp', 'keyword', attributes);
        }
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $6a65d32501c7d08f$export$2e2bcd8739ae039.displayName = 'openqasm';
$6a65d32501c7d08f$export$2e2bcd8739ae039.aliases = [
    'qasm'
];
function $6a65d32501c7d08f$export$2e2bcd8739ae039(Prism) {
    // https://qiskit.github.io/openqasm/grammar/index.html
    Prism.languages.openqasm = {
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
            greedy: true
        },
        keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
        'class-name': /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
        function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
        constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
        number: {
            pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
            lookbehind: true
        },
        operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
        punctuation: /[(){}\[\];,:.]/
    };
    Prism.languages.qasm = Prism.languages.openqasm;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8ed4b18f31ffd000$export$2e2bcd8739ae039.displayName = 'oz';
$8ed4b18f31ffd000$export$2e2bcd8739ae039.aliases = [];
function $8ed4b18f31ffd000$export$2e2bcd8739ae039(Prism) {
    Prism.languages.oz = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        atom: {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            alias: 'builtin'
        },
        keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
        function: [
            /\b[a-z][A-Za-z\d]*(?=\()/,
            {
                pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
                lookbehind: true
            }
        ],
        number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
        variable: /`(?:[^`\\]|\\.)+`/,
        'attr-name': /\b\w+(?=[ \t]*:(?![:=]))/,
        operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
        punctuation: /[\[\](){}.:;?]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5e75362810025a55$export$2e2bcd8739ae039.displayName = 'parigp';
$5e75362810025a55$export$2e2bcd8739ae039.aliases = [];
function $5e75362810025a55$export$2e2bcd8739ae039(Prism) {
    Prism.languages.parigp = {
        comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"/,
            greedy: true
        },
        // PARI/GP does not care about white spaces at all
        // so let's process the keywords to build an appropriate regexp
        // (e.g. "b *r *e *a *k", etc.)
        keyword: function() {
            var keywords = [
                'breakpoint',
                'break',
                'dbg_down',
                'dbg_err',
                'dbg_up',
                'dbg_x',
                'forcomposite',
                'fordiv',
                'forell',
                'forpart',
                'forprime',
                'forstep',
                'forsubgroup',
                'forvec',
                'for',
                'iferr',
                'if',
                'local',
                'my',
                'next',
                'return',
                'until',
                'while'
            ];
            keywords = keywords.map(function(keyword) {
                return keyword.split('').join(' *');
            }).join('|');
            return RegExp('\\b(?:' + keywords + ')\\b');
        }(),
        function: /\b\w(?:[\w ]*\w)?(?= *\()/,
        number: {
            // The lookbehind and the negative lookahead prevent from breaking the .. operator
            pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
            lookbehind: true
        },
        operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
        punctuation: /[\[\]{}().,:;|]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$5233df02eb9ce262$export$2e2bcd8739ae039.displayName = 'parser';
$5233df02eb9ce262$export$2e2bcd8739ae039.aliases = [];
function $5233df02eb9ce262$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var parser = Prism.languages.parser = Prism.languages.extend('markup', {
            keyword: {
                pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
                lookbehind: true
            },
            variable: {
                pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    punctuation: /\.|:+/
                }
            },
            function: {
                pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /(^@)(?:GET_|SET_)/,
                        lookbehind: true
                    },
                    punctuation: /\.|:+/
                }
            },
            escape: {
                pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
                alias: 'builtin'
            },
            punctuation: /[\[\](){};]/
        });
        parser = Prism.languages.insertBefore('parser', 'keyword', {
            'parser-comment': {
                pattern: /(\s)#.*/,
                lookbehind: true,
                alias: 'comment'
            },
            expression: {
                // Allow for 3 levels of depth
                pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
                greedy: true,
                lookbehind: true,
                inside: {
                    string: {
                        pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
                        lookbehind: true
                    },
                    keyword: parser.keyword,
                    variable: parser.variable,
                    function: parser.function,
                    boolean: /\b(?:false|true)\b/,
                    number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
                    escape: parser.escape,
                    operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
                    punctuation: parser.punctuation
                }
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            expression: parser.expression,
            keyword: parser.keyword,
            variable: parser.variable,
            function: parser.function,
            escape: parser.escape,
            'parser-punctuation': {
                pattern: parser.punctuation,
                alias: 'punctuation'
            }
        }, parser['tag'].inside['attr-value']);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b2343da39e8ef130$export$2e2bcd8739ae039.displayName = 'pascal';
$b2343da39e8ef130$export$2e2bcd8739ae039.aliases = [
    'objectpascal'
];
function $b2343da39e8ef130$export$2e2bcd8739ae039(Prism) {
    // Based on Free Pascal
    /* TODO
Support inline asm ?
*/ Prism.languages.pascal = {
        directive: {
            pattern: /\{\$[\s\S]*?\}/,
            greedy: true,
            alias: [
                'marco',
                'property'
            ]
        },
        comment: {
            pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
            greedy: true
        },
        asm: {
            pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        keyword: [
            {
                // Turbo Pascal
                pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
                lookbehind: true
            },
            {
                // Free Pascal
                pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
                lookbehind: true
            },
            {
                // Object Pascal
                pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
                lookbehind: true
            },
            {
                // Modifiers
                pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
                lookbehind: true
            }
        ],
        number: [
            // Hexadecimal, octal and binary
            /(?:[&%]\d+|\$[a-f\d]+)/i,
            // Decimal
            /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
        ],
        operator: [
            /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
            {
                pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
                lookbehind: true
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    };
    Prism.languages.pascal.asm.inside = Prism.languages.extend('pascal', {
        asm: undefined,
        keyword: undefined,
        operator: undefined
    });
    Prism.languages.objectpascal = Prism.languages.pascal;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $677549b6ac647aae$export$2e2bcd8739ae039.displayName = 'pascaligo';
$677549b6ac647aae$export$2e2bcd8739ae039.aliases = [];
function $677549b6ac647aae$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // Pascaligo is a layer 2 smart contract language for the tezos blockchain
        var braces = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source;
        var type = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(/<braces>/g, function() {
            return braces;
        });
        var pascaligo = Prism.languages.pascaligo = {
            comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
                greedy: true
            },
            'class-name': [
                {
                    pattern: RegExp(/(\btype\s+\w+\s+is\s+)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    pattern: RegExp(/<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    inside: null // see below
                },
                {
                    pattern: RegExp(/(:\s*)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            keyword: {
                pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^&])\b(?:False|True)\b/i,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
                lookbehind: true
            },
            function: /\b\w+(?=\s*\()/,
            number: [
                // Hexadecimal, octal and binary
                /%[01]+|&[0-7]+|\$[a-f\d]+/i,
                // Decimal
                /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
            ],
            operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
            punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
        };
        var classNameInside = [
            'comment',
            'keyword',
            'builtin',
            'operator',
            'punctuation'
        ].reduce(function(accum, key) {
            accum[key] = pascaligo[key];
            return accum;
        }, {});
        pascaligo['class-name'].forEach(function(p) {
            p.inside = classNameInside;
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $deb4ca581bc1f27a$export$2e2bcd8739ae039.displayName = 'psl';
$deb4ca581bc1f27a$export$2e2bcd8739ae039.aliases = [];
function $deb4ca581bc1f27a$export$2e2bcd8739ae039(Prism) {
    Prism.languages.psl = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true,
            inside: {
                symbol: /\\[ntrbA-Z"\\]/
            }
        },
        'heredoc-string': {
            pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
            alias: 'string',
            greedy: true
        },
        keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
        constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
        boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
        variable: /\b(?:PslDebug|errno|exit_status)\b/,
        builtin: {
            pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
            alias: 'builtin-function'
        },
        'foreach-variable': {
            pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
            lookbehind: true,
            greedy: true
        },
        function: /\b[_a-z]\w*\b(?=\s*\()/i,
        number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
        punctuation: /[(){}\[\];,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5d2497dd4e3ab655$export$2e2bcd8739ae039.displayName = 'pcaxis';
$5d2497dd4e3ab655$export$2e2bcd8739ae039.aliases = [
    'px'
];
function $5d2497dd4e3ab655$export$2e2bcd8739ae039(Prism) {
    Prism.languages.pcaxis = {
        string: /"[^"]*"/,
        keyword: {
            pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
            lookbehind: true,
            greedy: true,
            inside: {
                keyword: /^[-A-Z\d]+/,
                language: {
                    pattern: /^(\s*)\[[-\w]+\]/,
                    lookbehind: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        property: /[-\w]+/
                    }
                },
                'sub-key': {
                    pattern: /^(\s*)\S[\s\S]*/,
                    lookbehind: true,
                    inside: {
                        parameter: {
                            pattern: /"[^"]*"/,
                            alias: 'property'
                        },
                        punctuation: /^\(|\)$|,/
                    }
                }
            }
        },
        operator: /=/,
        tlist: {
            pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
            greedy: true,
            inside: {
                function: /^TLIST/,
                property: {
                    pattern: /^(\s*\(\s*)\w+/,
                    lookbehind: true
                },
                string: /"[^"]*"/,
                punctuation: /[(),]/,
                operator: /-/
            }
        },
        punctuation: /[;,]/,
        number: {
            pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
            lookbehind: true
        },
        boolean: /NO|YES/
    };
    Prism.languages.px = Prism.languages.pcaxis;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b3fd195950a9be7$export$2e2bcd8739ae039.displayName = 'peoplecode';
$4b3fd195950a9be7$export$2e2bcd8739ae039.aliases = [
    'pcode'
];
function $4b3fd195950a9be7$export$2e2bcd8739ae039(Prism) {
    Prism.languages.peoplecode = {
        comment: RegExp([
            // C-style multiline comments
            /\/\*[\s\S]*?\*\//.source,
            // REM comments
            /\bREM[^;]*;/.source,
            // Nested <* *> comments
            /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
            // /+ +/ comments
            /\/\+[\s\S]*?\+\//.source
        ].join('|')),
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        variable: /%\w+/,
        'function-definition': {
            pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
            lookbehind: true,
            alias: 'function'
        },
        'class-name': {
            pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
            lookbehind: true,
            inside: {
                punctuation: /:/
            }
        },
        keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
        'operator-keyword': {
            pattern: /\b(?:and|not|or)\b/i,
            alias: 'operator'
        },
        function: /[_a-z]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
        punctuation: /[:.;,()[\]]/
    };
    Prism.languages.pcode = Prism.languages.peoplecode;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$1e6f9251c3a754c6$export$2e2bcd8739ae039.displayName = 'phpdoc';
$1e6f9251c3a754c6$export$2e2bcd8739ae039.aliases = [];
function $1e6f9251c3a754c6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
    Prism.register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
    (function(Prism) {
        var typeExpression = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
        Prism.languages.phpdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                pattern: RegExp('(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:' + typeExpression + '\\s+)?)\\$\\w+'),
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('phpdoc', 'keyword', {
            'class-name': [
                {
                    pattern: RegExp('(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)' + typeExpression),
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
                        punctuation: /[|\\[\]()]/
                    }
                }
            ]
        });
        Prism.languages.javadoclike.addSupport('php', Prism.languages.phpdoc);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$83967affbf32d3d2$export$2e2bcd8739ae039.displayName = 'php-extras';
$83967affbf32d3d2$export$2e2bcd8739ae039.aliases = [];
function $83967affbf32d3d2$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
    Prism.languages.insertBefore('php', 'variable', {
        this: {
            pattern: /\$this\b/,
            alias: 'keyword'
        },
        global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
        scope: {
            pattern: /\b[\w\\]+::/,
            inside: {
                keyword: /\b(?:parent|self|static)\b/,
                punctuation: /::|\\/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $b8eebe66b02f0b09$export$2e2bcd8739ae039.displayName = 'plant-uml';
$b8eebe66b02f0b09$export$2e2bcd8739ae039.aliases = [
    'plantuml'
];
function $b8eebe66b02f0b09$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var variable = /\$\w+|%[a-z]+%/;
        var arrowAttr = /\[[^[\]]*\]/.source;
        var arrowDirection = /(?:[drlu]|do|down|le|left|ri|right|up)/.source;
        var arrowBody = '(?:-+' + arrowDirection + '-+|\\.+' + arrowDirection + '\\.+|-+(?:' + arrowAttr + '-*)?|' + arrowAttr + '-+|\\.+(?:' + arrowAttr + '\\.*)?|' + arrowAttr + '\\.+)';
        var arrowLeft = /(?:<{1,2}|\/{1,2}|\\{1,2}|<\||[#*^+}xo])/.source;
        var arrowRight = /(?:>{1,2}|\/{1,2}|\\{1,2}|\|>|[#*^+{xo])/.source;
        var arrowPrefix = /[[?]?[ox]?/.source;
        var arrowSuffix = /[ox]?[\]?]?/.source;
        var arrow = arrowPrefix + '(?:' + arrowBody + arrowRight + '|' + arrowLeft + arrowBody + '(?:' + arrowRight + ')?' + ')' + arrowSuffix;
        Prism.languages['plant-uml'] = {
            comment: {
                pattern: /(^[ \t]*)(?:'.*|\/'[\s\S]*?'\/)/m,
                lookbehind: true,
                greedy: true
            },
            preprocessor: {
                pattern: /(^[ \t]*)!.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'property',
                inside: {
                    variable: variable
                }
            },
            delimiter: {
                pattern: /(^[ \t]*)@(?:end|start)uml\b/m,
                lookbehind: true,
                greedy: true,
                alias: 'punctuation'
            },
            arrow: {
                pattern: RegExp(/(^|[^-.<>?|\\[\]ox])/.source + arrow + /(?![-.<>?|\\\]ox])/.source),
                lookbehind: true,
                greedy: true,
                alias: 'operator',
                inside: {
                    expression: {
                        pattern: /(\[)[^[\]]+(?=\])/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /\[(?=$|\])|^\]/
                }
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            text: {
                pattern: /(\[[ \t]*[\r\n]+(?![\r\n]))[^\]]*(?=\])/,
                lookbehind: true,
                greedy: true,
                alias: 'string'
            },
            keyword: [
                {
                    pattern: /^([ \t]*)(?:abstract\s+class|end\s+(?:box|fork|group|merge|note|ref|split|title)|(?:fork|split)(?:\s+again)?|activate|actor|agent|alt|annotation|artifact|autoactivate|autonumber|backward|binary|boundary|box|break|caption|card|case|circle|class|clock|cloud|collections|component|concise|control|create|critical|database|deactivate|destroy|detach|diamond|else|elseif|end|end[hr]note|endif|endswitch|endwhile|entity|enum|file|folder|footer|frame|group|[hr]?note|header|hexagon|hide|if|interface|label|legend|loop|map|namespace|network|newpage|node|nwdiag|object|opt|package|page|par|participant|person|queue|rectangle|ref|remove|repeat|restore|return|robust|scale|set|show|skinparam|stack|start|state|stop|storage|switch|title|together|usecase|usecase\/|while)(?=\s|$)/m,
                    lookbehind: true,
                    greedy: true
                },
                /\b(?:elseif|equals|not|while)(?=\s*\()/,
                /\b(?:as|is|then)\b/
            ],
            divider: {
                pattern: /^==.+==$/m,
                greedy: true,
                alias: 'important'
            },
            time: {
                pattern: /@(?:\d+(?:[:/]\d+){2}|[+-]?\d+|:[a-z]\w*(?:[+-]\d+)?)\b/i,
                greedy: true,
                alias: 'number'
            },
            color: {
                pattern: /#(?:[a-z_]+|[a-fA-F0-9]+)\b/,
                alias: 'symbol'
            },
            variable: variable,
            punctuation: /[:,;()[\]{}]|\.{3}/
        };
        Prism.languages['plant-uml'].arrow.inside.expression.inside = Prism.languages['plant-uml'];
        Prism.languages['plantuml'] = Prism.languages['plant-uml'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ee0a699affb8796e$export$2e2bcd8739ae039.displayName = 'plsql';
$ee0a699affb8796e$export$2e2bcd8739ae039.aliases = [];
function $ee0a699affb8796e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
    Prism.languages.plsql = Prism.languages.extend('sql', {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|--.*/,
            greedy: true
        },
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
        keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
        operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    });
    Prism.languages.insertBefore('plsql', 'operator', {
        label: {
            pattern: /<<\s*\w+\s*>>/,
            alias: 'symbol'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $bb80e878636bd8f6$export$2e2bcd8739ae039.displayName = 'powerquery';
$bb80e878636bd8f6$export$2e2bcd8739ae039.aliases = [
    'mscript',
    'pq'
];
function $bb80e878636bd8f6$export$2e2bcd8739ae039(Prism) {
    // https://docs.microsoft.com/en-us/powerquery-m/power-query-m-language-specification
    Prism.languages.powerquery = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        'quoted-identifier': {
            pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        string: {
            pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        constant: [
            /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
            /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
            /\bOccurrence\.(?:All|First|Last)\b/,
            /\bOrder\.(?:Ascending|Descending)\b/,
            /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
            /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
            /\bQuoteStyle\.(?:Csv|None)\b/,
            /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
            /\bGroupKind\.(?:Global|Local)\b/,
            /\bExtraValues\.(?:Error|Ignore|List)\b/,
            /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
            /\bJoinSide\.(?:Left|Right)\b/,
            /\bPrecision\.(?:Decimal|Double)\b/,
            /\bRelativePosition\.From(?:End|Start)\b/,
            /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
            /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
            /\bnull\b/
        ],
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
        function: {
            pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
            lookbehind: true
        },
        'data-type': {
            pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
            alias: 'class-name'
        },
        number: {
            pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
            lookbehind: true
        },
        operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
        punctuation: /[,;\[\](){}]/
    };
    Prism.languages.pq = Prism.languages['powerquery'];
    Prism.languages.mscript = Prism.languages['powerquery'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $07c52e9b9a88ab06$export$2e2bcd8739ae039.displayName = 'powershell';
$07c52e9b9a88ab06$export$2e2bcd8739ae039.aliases = [];
function $07c52e9b9a88ab06$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var powershell = Prism.languages.powershell = {
            comment: [
                {
                    pattern: /(^|[^`])<#[\s\S]*?#>/,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^`])#.*/,
                    lookbehind: true
                }
            ],
            string: [
                {
                    pattern: /"(?:`[\s\S]|[^`"])*"/,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /'(?:[^']|'')*'/,
                    greedy: true
                }
            ],
            // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
            // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
            namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
            boolean: /\$(?:false|true)\b/i,
            variable: /\$\w+\b/,
            // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
            // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
            // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
            function: [
                /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
                /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
            ],
            // per http://technet.microsoft.com/en-us/library/hh847744.aspx
            keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
            operator: {
                pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
                lookbehind: true
            },
            punctuation: /[|{}[\];(),.]/
        };
        // Variable interpolation inside strings, and nested expressions
        powershell.string[0].inside = {
            function: {
                // Allow for one level of nesting
                pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
                lookbehind: true,
                inside: powershell
            },
            boolean: powershell.boolean,
            variable: powershell.variable
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$b43974aae9bb9664$export$2e2bcd8739ae039.displayName = 'processing';
$b43974aae9bb9664$export$2e2bcd8739ae039.aliases = [];
function $b43974aae9bb9664$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.processing = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
        // Spaces are allowed between function name and parenthesis
        function: /\b\w+(?=\s*\()/,
        operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    });
    Prism.languages.insertBefore('processing', 'number', {
        // Special case: XML is a type
        constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
        type: {
            pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
            alias: 'class-name'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $37e5b1709464e513$export$2e2bcd8739ae039.displayName = 'prolog';
$37e5b1709464e513$export$2e2bcd8739ae039.aliases = [];
function $37e5b1709464e513$export$2e2bcd8739ae039(Prism) {
    Prism.languages.prolog = {
        // Syntax depends on the implementation
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        // Depending on the implementation, strings may allow escaped newlines and quote-escape
        string: {
            pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
            greedy: true
        },
        builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
        // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
        function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
        number: /\b\d+(?:\.\d*)?/,
        // Custom operators are allowed
        operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
        punctuation: /[(){}\[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b50fa11ce89925a$export$2e2bcd8739ae039.displayName = 'promql';
$4b50fa11ce89925a$export$2e2bcd8739ae039.aliases = [];
function $4b50fa11ce89925a$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // PromQL Aggregation Operators
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#aggregation-operators)
        var aggregations = [
            'sum',
            'min',
            'max',
            'avg',
            'group',
            'stddev',
            'stdvar',
            'count',
            'count_values',
            'bottomk',
            'topk',
            'quantile'
        ];
        // PromQL vector matching + the by and without clauses
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#vector-matching)
        var vectorMatching = [
            'on',
            'ignoring',
            'group_right',
            'group_left',
            'by',
            'without'
        ];
        // PromQL offset modifier
        // (https://prometheus.io/docs/prometheus/latest/querying/basics/#offset-modifier)
        var offsetModifier = [
            'offset'
        ];
        var keywords = aggregations.concat(vectorMatching, offsetModifier);
        Prism.languages.promql = {
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            'vector-match': {
                // Match the comma-separated label lists inside vector matching:
                pattern: new RegExp('((?:' + vectorMatching.join('|') + ')\\s*)\\([^)]*\\)'),
                lookbehind: true,
                inside: {
                    'label-key': {
                        pattern: /\b[^,]+\b/,
                        alias: 'attr-name'
                    },
                    punctuation: /[(),]/
                }
            },
            'context-labels': {
                pattern: /\{[^{}]*\}/,
                inside: {
                    'label-key': {
                        pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
                        alias: 'attr-name'
                    },
                    'label-value': {
                        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                        greedy: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\{|\}|=~?|![=~]|,/
                }
            },
            'context-range': [
                {
                    pattern: /\[[\w\s:]+\]/,
                    // [1m]
                    inside: {
                        punctuation: /\[|\]|:/,
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                },
                {
                    pattern: /(\boffset\s+)\w+/,
                    // offset 1m
                    lookbehind: true,
                    inside: {
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                }
            ],
            keyword: new RegExp('\\b(?:' + keywords.join('|') + ')\\b', 'i'),
            function: /\b[a-z_]\w*(?=\s*\()/i,
            number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
            operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
            punctuation: /[{};()`,.[\]]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5ac9473b450a64ab$export$2e2bcd8739ae039.displayName = 'properties';
$5ac9473b450a64ab$export$2e2bcd8739ae039.aliases = [];
function $5ac9473b450a64ab$export$2e2bcd8739ae039(Prism) {
    Prism.languages.properties = {
        comment: /^[ \t]*[#!].*$/m,
        value: {
            pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
            lookbehind: true,
            alias: 'attr-value'
        },
        key: {
            pattern: /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
            alias: 'attr-name'
        },
        punctuation: /[=:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$e427246b711a2509$export$2e2bcd8739ae039.displayName = 'protobuf';
$e427246b711a2509$export$2e2bcd8739ae039.aliases = [];
function $e427246b711a2509$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var builtinTypes = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
        Prism.languages.protobuf = Prism.languages.extend('clike', {
            'class-name': [
                {
                    pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
                    lookbehind: true
                },
                {
                    pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
                    lookbehind: true
                }
            ],
            keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
            function: /\b[a-z_]\w*(?=\s*\()/i
        });
        Prism.languages.insertBefore('protobuf', 'operator', {
            map: {
                pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /[<>.,]/,
                    builtin: builtinTypes
                }
            },
            builtin: builtinTypes,
            'positional-class-name': {
                pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /\./
                }
            },
            annotation: {
                pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
                lookbehind: true
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $295e7fe9e01d0862$export$2e2bcd8739ae039.displayName = 'stylus';
$295e7fe9e01d0862$export$2e2bcd8739ae039.aliases = [];
function $295e7fe9e01d0862$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+)/,
            lookbehind: true
        };
        // 123 -123 .123 -.123 12.3 -12.3
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        var inside = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true
            },
            url: {
                pattern: /\burl\((["']?).*?\1\)/i,
                greedy: true
            },
            string: {
                pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
                greedy: true
            },
            interpolation: null,
            // See below
            func: null,
            // See below
            important: /\B!(?:important|optional)\b/i,
            keyword: {
                pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
                lookbehind: true
            },
            hexcode: /#[\da-f]{3,6}/i,
            color: [
                /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            boolean: /\b(?:false|true)\b/,
            operator: [
                // We want non-word chars around "-" because it is
                // accepted in property names.
                /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
            ],
            number: number,
            punctuation: /[{}()\[\];:,]/
        };
        inside['interpolation'] = {
            pattern: /\{[^\r\n}:]+\}/,
            alias: 'variable',
            inside: {
                delimiter: {
                    pattern: /^\{|\}$/,
                    alias: 'punctuation'
                },
                rest: inside
            }
        };
        inside['func'] = {
            pattern: /[\w-]+\([^)]*\).*/,
            inside: {
                function: /^[^(]+/,
                rest: inside
            }
        };
        Prism.languages.stylus = {
            'atrule-declaration': {
                pattern: /(^[ \t]*)@.+/m,
                lookbehind: true,
                inside: {
                    atrule: /^@[\w-]+/,
                    rest: inside
                }
            },
            'variable-declaration': {
                pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
                lookbehind: true,
                inside: {
                    variable: /^\S+/,
                    rest: inside
                }
            },
            statement: {
                pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
                lookbehind: true,
                inside: {
                    keyword: /^\S+/,
                    rest: inside
                }
            },
            // A property/value pair cannot end with a comma or a brace
            // It cannot have indented content unless it ended with a semicolon
            'property-declaration': {
                pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
                lookbehind: true,
                inside: {
                    property: {
                        pattern: /^[^\s:]+/,
                        inside: {
                            interpolation: inside.interpolation
                        }
                    },
                    rest: inside
                }
            },
            // A selector can contain parentheses only as part of a pseudo-element
            // It can span multiple lines.
            // It must end with a comma or an accolade or have indented content.
            selector: {
                pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
                lookbehind: true,
                inside: {
                    interpolation: inside.interpolation,
                    comment: inside.comment,
                    punctuation: /[{},]/
                }
            },
            func: inside.func,
            string: inside.string,
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true,
                greedy: true
            },
            interpolation: inside.interpolation,
            punctuation: /[{}()\[\];:.]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$48a2ee38b0d45f1e$export$2e2bcd8739ae039.displayName = 'twig';
$48a2ee38b0d45f1e$export$2e2bcd8739ae039.aliases = [];
function $48a2ee38b0d45f1e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    Prism.languages.twig = {
        comment: /^\{#[\s\S]*?#\}$/,
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            }
        },
        keyword: /\b(?:even|if|odd)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
    Prism.hooks.add('before-tokenize', function(env) {
        if (env.language !== 'twig') return;
        var pattern = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'twig', pattern);
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'twig');
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$9d032faa85d6103d$export$2e2bcd8739ae039.displayName = 'pug';
$9d032faa85d6103d$export$2e2bcd8739ae039.aliases = [];
function $9d032faa85d6103d$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        // TODO:
        // - Add CSS highlighting inside <style> tags
        // - Add support for multi-line code blocks
        // - Add support for interpolation #{} and !{}
        // - Add support for tag interpolation #[]
        // - Add explicit support for plain text using |
        // - Add support for markup embedded in plain text
        Prism.languages.pug = {
            // Multiline stuff should appear before the rest
            // This handles both single-line and multi-line comments
            comment: {
                pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
                lookbehind: true
            },
            // All the tag-related part is in lookbehind
            // so that it can be highlighted by the "tag" pattern
            'multiline-script': {
                pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            // See at the end of the file for known filters
            filter: {
                pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: /\S[\s\S]*/
                }
            },
            'multiline-plain-text': {
                pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true
            },
            markup: {
                pattern: /(^[\t ]*)<.+/m,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
                lookbehind: true
            },
            // This handle all conditional and loop keywords
            'flow-control': {
                pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
                lookbehind: true,
                inside: {
                    each: {
                        pattern: /^each .+? in\b/,
                        inside: {
                            keyword: /\b(?:each|in)\b/,
                            punctuation: /,/
                        }
                    },
                    branch: {
                        pattern: /^(?:case|default|else|if|unless|when|while)\b/,
                        alias: 'keyword'
                    },
                    rest: Prism.languages.javascript
                }
            },
            keyword: {
                pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
                lookbehind: true
            },
            mixin: [
                // Declaration
                {
                    pattern: /(^[\t ]*)mixin .+/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^mixin/,
                        function: /\w+(?=\s*\(|\s*$)/,
                        punctuation: /[(),.]/
                    }
                },
                // Usage
                {
                    pattern: /(^[\t ]*)\+.+/m,
                    lookbehind: true,
                    inside: {
                        name: {
                            pattern: /^\+\w+/,
                            alias: 'function'
                        },
                        rest: Prism.languages.javascript
                    }
                }
            ],
            script: {
                pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            'plain-text': {
                pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            pattern: /&[^(]+\([^)]+\)/,
                            inside: Prism.languages.javascript
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                                    lookbehind: true,
                                    inside: Prism.languages.javascript
                                },
                                'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[!=(),]+/
                            }
                        }
                    ],
                    punctuation: /:/,
                    'attr-id': /#[\w\-]+/,
                    'attr-class': /\.[\w\-]+/
                }
            },
            code: [
                {
                    pattern: /(^[\t ]*(?:-|!?=)).+/m,
                    lookbehind: true,
                    inside: Prism.languages.javascript
                }
            ],
            punctuation: /[.\-!=|]+/
        };
        var filter_pattern = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source;
        // Non exhaustive list of available filters and associated languages
        var filters = [
            {
                filter: 'atpl',
                language: 'twig'
            },
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'ejs',
            'handlebars',
            'less',
            'livescript',
            'markdown',
            {
                filter: 'sass',
                language: 'scss'
            },
            'stylus'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('<filter_name>', function() {
                    return filter.filter;
                }), 'm'),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: {
                        pattern: /\S[\s\S]*/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('pug', 'filter', all_filters);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f0ce0a61b7257e87$export$2e2bcd8739ae039.displayName = 'puppet';
$f0ce0a61b7257e87$export$2e2bcd8739ae039.aliases = [];
function $f0ce0a61b7257e87$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.puppet = {
            heredoc: [
                // Matches the content of a quoted heredoc string (subject to interpolation)
                {
                    pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                // Matches the content of an unquoted heredoc string (no interpolation)
                {
                    pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                // Matches the start tag of heredoc strings
                {
                    pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
                    alias: 'string',
                    inside: {
                        punctuation: {
                            pattern: /(\().+?(?=\))/,
                            lookbehind: true
                        }
                    }
                }
            ],
            'multiline-comment': {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true,
                alias: 'comment'
            },
            regex: {
                // Must be prefixed with the keyword "node" or a non-word char
                pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    // Extended regexes must have the x flag. They can contain single-line comments.
                    'extended-regex': {
                        pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
                        inside: {
                            comment: /#.*/
                        }
                    }
                }
            },
            comment: {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true,
                greedy: true
            },
            string: {
                // Allow for one nested level of double quotes inside interpolation
                pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
                greedy: true,
                inside: {
                    'double-quoted': {
                        pattern: /^"[\s\S]*"$/,
                        inside: {
                        }
                    }
                }
            },
            variable: {
                pattern: /\$(?:::)?\w+(?:::\w+)*/,
                inside: {
                    punctuation: /::/
                }
            },
            'attr-name': /(?:\b\w+|\*)(?=\s*=>)/,
            function: [
                {
                    pattern: /(\.)(?!\d)\w+/,
                    lookbehind: true
                },
                /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
            ],
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
            boolean: /\b(?:false|true)\b/,
            // Includes words reserved for future use
            keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
            datatype: {
                pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
                alias: 'symbol'
            },
            operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
            punctuation: /[\[\]{}().,;]|:+/
        };
        var interpolation = [
            {
                // Allow for one nested level of braces inside interpolation
                pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
                lookbehind: true,
                inside: {
                    'short-variable': {
                        // Negative look-ahead prevent wrong highlighting of functions
                        pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
                        lookbehind: true,
                        alias: 'variable',
                        inside: {
                            punctuation: /::/
                        }
                    },
                    delimiter: {
                        pattern: /^\$/,
                        alias: 'variable'
                    },
                    rest: Prism.languages.puppet
                }
            },
            {
                pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
                lookbehind: true,
                alias: 'variable',
                inside: {
                    punctuation: /::/
                }
            }
        ];
        Prism.languages.puppet['heredoc'][0].inside.interpolation = interpolation;
        Prism.languages.puppet['string'].inside['double-quoted'].inside.interpolation = interpolation;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d402b3c4cd63a644$export$2e2bcd8739ae039.displayName = 'pure';
$d402b3c4cd63a644$export$2e2bcd8739ae039.aliases = [];
function $d402b3c4cd63a644$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://agraef.github.io/pure-docs/pure.html#lexical-matters
        Prism.languages.pure = {
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true
                },
                /#!.+/
            ],
            'inline-lang': {
                pattern: /%<[\s\S]+?%>/,
                greedy: true,
                inside: {
                    lang: {
                        pattern: /(^%< *)-\*-.+?-\*-/,
                        lookbehind: true,
                        alias: 'comment'
                    },
                    delimiter: {
                        pattern: /^%<.*|%>$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"/,
                greedy: true
            },
            number: {
                // The look-behind prevents wrong highlighting of the .. operator
                pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
                lookbehind: true
            },
            keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
            function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
            special: {
                pattern: /\b__[a-z]+__\b/i,
                alias: 'builtin'
            },
            // Any combination of operator chars can be an operator
            // eslint-disable-next-line no-misleading-character-class
            operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
            // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
            punctuation: /[(){}\[\];,|]/
        };
        var inlineLanguages = [
            'c',
            {
                lang: 'c++',
                alias: 'cpp'
            },
            'fortran'
        ];
        var inlineLanguageRe = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
        inlineLanguages.forEach(function(lang) {
            var alias = lang;
            if (typeof lang !== 'string') {
                alias = lang.alias;
                lang = lang.lang;
            }
            if (Prism.languages[alias]) {
                var o = {};
                o['inline-lang-' + alias] = {
                    pattern: RegExp(inlineLanguageRe.replace('<lang>', lang.replace(/([.+*?\/\\(){}\[\]])/g, '\\$1')), 'i'),
                    inside: Prism.util.clone(Prism.languages.pure['inline-lang'].inside)
                };
                o['inline-lang-' + alias].inside.rest = Prism.util.clone(Prism.languages[alias]);
                Prism.languages.insertBefore('pure', 'inline-lang', o);
            }
        });
        // C is the default inline language
        if (Prism.languages.c) Prism.languages.pure['inline-lang'].inside.rest = Prism.util.clone(Prism.languages.c);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a42852126578ac8f$export$2e2bcd8739ae039.displayName = 'purebasic';
$a42852126578ac8f$export$2e2bcd8739ae039.aliases = [
    'pbfasm'
];
function $a42852126578ac8f$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    /*
Original Code by Bas Groothedde
!!MANY THANKS!! I never would have made this, regex and me will never be best friends ;)
==> https://codepen.io/ImagineProgramming/details/JYydBy/
slightly changed to pass all tests
*/ // PureBasic support, steal stuff from ansi-c
    Prism.languages.purebasic = Prism.languages.extend('clike', {
        comment: /;.*/,
        keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
        function: /\b\w+(?:\.\w+)?\s*(?=\()/,
        number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
        operator: /(?:@\*?|\?|\*)\w+\$?|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    });
    Prism.languages.insertBefore('purebasic', 'keyword', {
        tag: /#\w+\$?/,
        asm: {
            pattern: /(^[\t ]*)!.*/m,
            lookbehind: true,
            alias: 'tag',
            inside: {
                comment: /;.*/,
                string: {
                    pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                    greedy: true
                },
                // Anonymous label references, i.e.: jmp @b
                'label-reference-anonymous': {
                    pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                // Named label reference, i.e.: jne label1
                'label-reference-addressed': {
                    pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                keyword: [
                    /\b(?:extern|global)\b[^;\r\n]*/i,
                    /\b(?:CPU|DEFAULT|FLOAT)\b.*/
                ],
                function: {
                    pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
                    lookbehind: true
                },
                'function-inline': {
                    pattern: /(:\s*)[\da-z]+(?=\s)/i,
                    lookbehind: true,
                    alias: 'function'
                },
                label: {
                    pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
                number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
                operator: /[\[\]*+\-/%<>=&|$!,.:]/
            }
        }
    });
    delete Prism.languages.purebasic['class-name'];
    delete Prism.languages.purebasic['boolean'];
    Prism.languages.pbfasm = Prism.languages['purebasic'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$75c09846dd2bbd2b$export$2e2bcd8739ae039.displayName = 'purescript';
$75c09846dd2bbd2b$export$2e2bcd8739ae039.aliases = [
    'purs'
];
function $75c09846dd2bbd2b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $2ae70ee16ca48837$export$2e2bcd8739ae039));
    Prism.languages.purescript = Prism.languages.extend('haskell', {
        keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import)\b/,
                punctuation: /\./
            }
        },
        // These are builtin functions only. Constructors are highlighted later as a constant.
        builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
        operator: [
            // Infix operators
            Prism.languages.haskell.operator[0],
            // ASCII operators
            Prism.languages.haskell.operator[2],
            // All UTF16 Unicode operator symbols
            // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
            // See https://github.com/PrismJS/prism/issues/3006 for more details.
            /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
        ]
    });
    Prism.languages.purs = Prism.languages.purescript;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3b64cc26a0bd267e$export$2e2bcd8739ae039.displayName = 'qsharp';
$3b64cc26a0bd267e$export$2e2bcd8739ae039.aliases = [
    'qs'
];
function $3b64cc26a0bd267e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        }
        // https://docs.microsoft.com/en-us/azure/quantum/user-guide/language/typesystem/
        // https://github.com/microsoft/qsharp-language/tree/main/Specifications/Language/5_Grammar
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero',
            // all other keywords
            other: 'Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within'
        };
        // keywords
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.other));
        // types
        var identifier = /\b[A-Za-z_]\w*\b/.source;
        var qualifiedName = replace(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [
            identifier
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        };
        // strings
        var regularString = /"(?:\\.|[^\\"])*"/.source;
        Prism.languages.qsharp = Prism.languages.extend('clike', {
            comment: /\/\/.*/,
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // open Microsoft.Quantum.Canon;
                    // open Microsoft.Quantum.Canon as CN;
                    pattern: re(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // namespace Quantum.App1;
                    pattern: re(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                }
            ],
            keyword: keywords,
            number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
            operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
            punctuation: /::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('qsharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        // single line
        var interpolationExpr = nested(replace(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [
            regularString
        ]), 2);
        Prism.languages.insertBefore('qsharp', 'string', {
            'interpolation-string': {
                pattern: re(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [
                    interpolationExpr
                ]),
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: re(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                            interpolationExpr
                        ]),
                        lookbehind: true,
                        inside: {
                            punctuation: /^\{|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                alias: 'language-qsharp',
                                inside: Prism.languages.qsharp
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            }
        });
    })(Prism);
    Prism.languages.qs = Prism.languages.qsharp;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2651f31c4a94c2f1$export$2e2bcd8739ae039.displayName = 'q';
$2651f31c4a94c2f1$export$2e2bcd8739ae039.aliases = [];
function $2651f31c4a94c2f1$export$2e2bcd8739ae039(Prism) {
    Prism.languages.q = {
        string: /"(?:\\.|[^"\\\r\n])*"/,
        comment: [
            // From http://code.kx.com/wiki/Reference/Slash:
            // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
            {
                pattern: /([\t )\]}])\/.*/,
                lookbehind: true,
                greedy: true
            },
            // From http://code.kx.com/wiki/Reference/Slash:
            // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
            // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
            // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
            // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
            {
                pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
                lookbehind: true,
                greedy: true
            },
            // From http://code.kx.com/wiki/Reference/Slash:
            // A \ on a line by itself with no preceding matching / will comment to end of file.
            {
                pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
                greedy: true
            },
            {
                pattern: /^#!.+/m,
                greedy: true
            }
        ],
        symbol: /`(?::\S+|[\w.]*)/,
        datetime: {
            pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
            alias: 'number'
        },
        // The negative look-ahead prevents bad highlighting
        // of verbs 0: and 1:
        number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
        keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
        adverb: {
            pattern: /['\/\\]:?|\beach\b/,
            alias: 'function'
        },
        verb: {
            pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
            alias: 'operator'
        },
        punctuation: /[(){}\[\];.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2ba51d01e535556e$export$2e2bcd8739ae039.displayName = 'qml';
$2ba51d01e535556e$export$2e2bcd8739ae039.aliases = [];
function $2ba51d01e535556e$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    (function(Prism) {
        var jsString = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source;
        var jsComment = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source;
        var jsExpr = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
            return jsString;
        }).replace(/<comment>/g, function() {
            return jsComment;
        });
        // the pattern will blow up, so only a few iterations
        for(var i = 0; i < 2; i++)jsExpr = jsExpr.replace(/<expr>/g, function() {
            return jsExpr;
        });
        jsExpr = jsExpr.replace(/<expr>/g, '[^\\s\\S]');
        Prism.languages.qml = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            'javascript-function': {
                pattern: RegExp(/((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            'class-name': {
                pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
                lookbehind: true
            },
            property: [
                {
                    pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^property/,
                        property: /\w+(?:\.\w+)*/
                    }
                }
            ],
            'javascript-expression': {
                pattern: RegExp(/(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            string: {
                pattern: /"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            keyword: /\b(?:as|import|on)\b/,
            punctuation: /[{}[\]:;,]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$f20909d17a339405$export$2e2bcd8739ae039.displayName = 'qore';
$f20909d17a339405$export$2e2bcd8739ae039.aliases = [];
function $f20909d17a339405$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.qore = Prism.languages.extend('clike', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
            lookbehind: true
        },
        // Overridden to allow unescaped multi-line strings
        string: {
            pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: true
        },
        keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
        boolean: /\b(?:false|true)\b/i,
        function: /\$?\b(?!\d)\w+(?=\()/,
        number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
        operator: {
            pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
            lookbehind: true
        },
        variable: /\$(?!\d)\w+\b/
    });
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$2def36300150cc17$export$2e2bcd8739ae039.displayName = 'racket';
$2def36300150cc17$export$2e2bcd8739ae039.aliases = [
    'rkt'
];
function $2def36300150cc17$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f15bc5f7f9ab760a$export$2e2bcd8739ae039));
    Prism.languages.racket = Prism.languages.extend('scheme', {
        'lambda-parameter': {
            // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
            // this will just prevent false positives of the `function` pattern
            pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
            lookbehind: true
        }
    });
    Prism.languages.insertBefore('racket', 'string', {
        lang: {
            pattern: /^#lang.+/m,
            greedy: true,
            alias: 'keyword'
        }
    });
    Prism.languages.rkt = Prism.languages.racket;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$be3f5e01c2434719$export$2e2bcd8739ae039.displayName = 'cshtml';
$be3f5e01c2434719$export$2e2bcd8739ae039.aliases = [
    'razor'
];
function $be3f5e01c2434719$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $803928922a6961a4$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var commentLike = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source;
        var stringLike = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + '|' + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<self>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<self>/g, '[^\\s\\S]').replace(/<str>/g, '(?:' + stringLike + ')').replace(/<comment>/g, '(?:' + commentLike + ')');
        }
        var round = nested(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2);
        var square = nested(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 1);
        var curly = nested(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2);
        var angle = nested(/<(?:[^<>'"@/]|<comment>|<self>)*>/.source, 1);
        var inlineCs = /@/.source + /(?:await\b\s*)?/.source + '(?:' + /(?!await\b)\w+\b/.source + '|' + round + ')' + '(?:' + /[?!]?\.\w+\b/.source + '|' + '(?:' + angle + ')?' + round + '|' + square + ')*' + /(?![?!\.(\[]|<(?!\/))/.source;
        // Note about the above bracket patterns:
        // They all ignore HTML expressions that might be in the C# code. This is a problem because HTML (like strings and
        // comments) is parsed differently. This is a huge problem because HTML might contain brackets and quotes which
        // messes up the bracket and string counting implemented by the above patterns.
        //
        // This problem is not fixable because 1) HTML expression are highly context sensitive and very difficult to detect
        // and 2) they require one capturing group at every nested level. See the `tagRegion` pattern to admire the
        // complexity of an HTML expression.
        //
        // To somewhat alleviate the problem a bit, the patterns for characters (e.g. 'a') is very permissive, it also
        // allows invalid characters to support HTML expressions like this: <p>That's it!</p>.
        var tagAttrInlineCs = /@(?![\w()])/.source + '|' + inlineCs;
        var tagAttrValue = '(?:' + /"[^"@]*"|'[^'@]*'|[^\s'"@>=]+(?=[\s>])/.source + '|' + '["\'][^"\'@]*(?:(?:' + tagAttrInlineCs + ')[^"\'@]*)+["\']' + ')';
        var tagAttrs = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*<tagAttrValue>|(?=[\s/>])))+)?/.source.replace(/<tagAttrValue>/, tagAttrValue);
        var tagContent = /(?!\d)[^\s>\/=$<%]+/.source + tagAttrs + /\s*\/?>/.source;
        var tagRegion = /\B@?/.source + '(?:' + /<([a-zA-Z][\w:]*)/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + // nested start tag
        nested(// eslint-disable-next-line regexp/strict
        /<\1/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + '<self>') + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source, 2)) + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source + '|' + /</.source + tagContent + ')';
        // Now for the actual language definition(s):
        //
        // Razor as a language has 2 parts:
        //  1) CSHTML: A markup-like language that has been extended with inline C# code expressions and blocks.
        //  2) C#+HTML: A variant of C# that can contain CSHTML tags as expressions.
        //
        // In the below code, both CSHTML and C#+HTML will be create as separate language definitions that reference each
        // other. However, only CSHTML will be exported via `Prism.languages`.
        Prism.languages.cshtml = Prism.languages.extend('markup', {});
        var csharpWithHtml = Prism.languages.insertBefore('csharp', 'string', {
            html: {
                pattern: RegExp(tagRegion),
                greedy: true,
                inside: Prism.languages.cshtml
            }
        }, {
            csharp: Prism.languages.extend('csharp', {})
        });
        var cs = {
            pattern: /\S[\s\S]*/,
            alias: 'language-csharp',
            inside: csharpWithHtml
        };
        var inlineValue = {
            pattern: RegExp(/(^|[^@])/.source + inlineCs),
            lookbehind: true,
            greedy: true,
            alias: 'variable',
            inside: {
                keyword: /^@/,
                csharp: cs
            }
        };
        Prism.languages.cshtml.tag.pattern = RegExp(/<\/?/.source + tagContent);
        Prism.languages.cshtml.tag.inside['attr-value'].pattern = RegExp(/=\s*/.source + tagAttrValue);
        Prism.languages.insertBefore('inside', 'punctuation', {
            value: inlineValue
        }, Prism.languages.cshtml.tag.inside['attr-value']);
        Prism.languages.insertBefore('cshtml', 'prolog', {
            'razor-comment': {
                pattern: /@\*[\s\S]*?\*@/,
                greedy: true,
                alias: 'comment'
            },
            block: {
                pattern: RegExp(/(^|[^@])@/.source + '(?:' + [
                    // @{ ... }
                    curly,
                    // @code{ ... }
                    /(?:code|functions)\s*/.source + curly,
                    // @for (...) { ... }
                    /(?:for|foreach|lock|switch|using|while)\s*/.source + round + /\s*/.source + curly,
                    // @do { ... } while (...);
                    /do\s*/.source + curly + /\s*while\s*/.source + round + /(?:\s*;)?/.source,
                    // @try { ... } catch (...) { ... } finally { ... }
                    /try\s*/.source + curly + /\s*catch\s*/.source + round + /\s*/.source + curly + /\s*finally\s*/.source + curly,
                    // @if (...) {...} else if (...) {...} else {...}
                    /if\s*/.source + round + /\s*/.source + curly + '(?:' + /\s*else/.source + '(?:' + /\s+if\s*/.source + round + ')?' + /\s*/.source + curly + ')*',
                    // @helper Ident(params) { ... }
                    /helper\s+\w+\s*/.source + round + /\s*/.source + curly
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w*/,
                    csharp: cs
                }
            },
            directive: {
                pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w+/,
                    csharp: cs
                }
            },
            value: inlineValue,
            'delegate-operator': {
                pattern: /(^|[^@])@(?=<)/,
                lookbehind: true,
                alias: 'operator'
            }
        });
        Prism.languages.razor = Prism.languages.cshtml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$0636642bf7a5dca9$export$2e2bcd8739ae039.displayName = 'jsx';
$0636642bf7a5dca9$export$2e2bcd8739ae039.aliases = [];
function $0636642bf7a5dca9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend('markup', javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
        Prism.languages.insertBefore('inside', 'attr-name', {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore('inside', 'special-attr', {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: 'language-javascript',
                inside: {
                    'script-punctuation': {
                        pattern: /^=(?=\{)/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag);
        // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (!token) return '';
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token);
                        // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'jsx' && env.language !== 'tsx') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$1100e9295cc7554a$export$2e2bcd8739ae039.displayName = 'tsx';
$1100e9295cc7554a$export$2e2bcd8739ae039.aliases = [];
function $1100e9295cc7554a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $0636642bf7a5dca9$export$2e2bcd8739ae039));
    Prism.register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
    (function(Prism) {
        var typescript = Prism.util.clone(Prism.languages.typescript);
        Prism.languages.tsx = Prism.languages.extend('jsx', typescript);
        // doesn't work with TS because TS is too complex
        delete Prism.languages.tsx['parameter'];
        delete Prism.languages.tsx['literal-property'];
        // This will prevent collisions between TSX tags and TS generic types.
        // Idea by https://github.com/karlhorky
        // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
        var tag = Prism.languages.tsx.tag;
        tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
        tag.lookbehind = true;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ad8d5c52e7714ea6$export$2e2bcd8739ae039.displayName = 'reason';
$ad8d5c52e7714ea6$export$2e2bcd8739ae039.aliases = [];
function $ad8d5c52e7714ea6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.reason = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        // 'class-name' must be matched *after* 'constructor' defined below
        'class-name': /\b[A-Z]\w*/,
        keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
        operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    });
    Prism.languages.insertBefore('reason', 'class-name', {
        char: {
            pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
            greedy: true
        },
        // Negative look-ahead prevents from matching things like String.capitalize
        constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
        label: {
            pattern: /\b[a-z]\w*(?=::)/,
            alias: 'symbol'
        }
    });
    // We can't match functions property, so let's not even try.
    delete Prism.languages.reason.function;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c4f30d48e56845b8$export$2e2bcd8739ae039.displayName = 'rego';
$c4f30d48e56845b8$export$2e2bcd8739ae039.aliases = [];
function $c4f30d48e56845b8$export$2e2bcd8739ae039(Prism) {
    // https://www.openpolicyagent.org/docs/latest/policy-reference/
    Prism.languages.rego = {
        comment: /#.*/,
        property: {
            pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
        boolean: /\b(?:false|true)\b/,
        function: {
            pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
            inside: {
                namespace: /\b\w+\b(?=\s*\.)/,
                punctuation: /\./
            }
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
        punctuation: /[,;.\[\]{}()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $32c58ead3c55b79c$export$2e2bcd8739ae039.displayName = 'renpy';
$32c58ead3c55b79c$export$2e2bcd8739ae039.aliases = [
    'rpy'
];
function $32c58ead3c55b79c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.renpy = {
        comment: {
            pattern: /(^|[^\\])#.+/,
            lookbehind: true
        },
        string: {
            pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
            greedy: true
        },
        function: /\b[a-z_]\w*(?=\()/i,
        property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
        tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
        keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
        boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
        number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.rpy = Prism.languages.renpy;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $50e3d013937d7b07$export$2e2bcd8739ae039.displayName = 'rescript';
$50e3d013937d7b07$export$2e2bcd8739ae039.aliases = [
    'res'
];
function $50e3d013937d7b07$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rescript = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\r\n\\]|\\(?:.|\w+))'/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        'class-name': /\b[A-Z]\w*|@[a-z.]*|#[A-Za-z]\w*|#\d/,
        function: {
            pattern: /[a-zA-Z]\w*(?=\()|(\.)[a-z]\w*/,
            lookbehind: true
        },
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        boolean: /\b(?:false|true)\b/,
        'attr-value': /[A-Za-z]\w*(?==)/,
        constant: {
            pattern: /(\btype\s+)[a-z]\w*/,
            lookbehind: true
        },
        tag: {
            pattern: /(<)[a-z]\w*|(?:<\/)[a-z]\w*/,
            lookbehind: true,
            inside: {
                operator: /<|>|\//
            }
        },
        keyword: /\b(?:and|as|assert|begin|bool|class|constraint|do|done|downto|else|end|exception|external|float|for|fun|function|if|in|include|inherit|initializer|int|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|string|switch|then|to|try|type|when|while|with)\b/,
        operator: /\.{3}|:[:=]?|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/,
        punctuation: /[(){}[\],;.]/
    };
    Prism.languages.insertBefore('rescript', 'string', {
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'tag'
                        },
                        rest: Prism.languages.rescript
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.res = Prism.languages.rescript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $c37f7ecb6b24967e$export$2e2bcd8739ae039.displayName = 'rest';
$c37f7ecb6b24967e$export$2e2bcd8739ae039.aliases = [];
function $c37f7ecb6b24967e$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rest = {
        table: [
            {
                pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
                lookbehind: true,
                inside: {
                    punctuation: /\||(?:\+[=-]+)+\+/
                }
            },
            {
                pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
                lookbehind: true,
                inside: {
                    punctuation: /[=-]+/
                }
            }
        ],
        // Directive-like patterns
        'substitution-def': {
            pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
            lookbehind: true,
            inside: {
                substitution: {
                    pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
                    alias: 'attr-value',
                    inside: {
                        punctuation: /^\||\|$/
                    }
                },
                directive: {
                    pattern: /( )(?! )[^:]+::/,
                    lookbehind: true,
                    alias: 'function',
                    inside: {
                        punctuation: /::$/
                    }
                }
            }
        },
        'link-target': [
            {
                pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]$/
                }
            },
            {
                pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^_|:$/
                }
            }
        ],
        directive: {
            pattern: /(^[\t ]*\.\. )[^:]+::/m,
            lookbehind: true,
            alias: 'function',
            inside: {
                punctuation: /::$/
            }
        },
        comment: {
            // The two alternatives try to prevent highlighting of blank comments
            pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
            lookbehind: true
        },
        title: [
            // Overlined and underlined
            {
                pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
                inside: {
                    punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            },
            // Underlined only
            {
                pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
                lookbehind: true,
                inside: {
                    punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            }
        ],
        hr: {
            pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
            lookbehind: true,
            alias: 'punctuation'
        },
        field: {
            pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        'command-line-option': {
            pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
            lookbehind: true,
            alias: 'symbol'
        },
        'literal-block': {
            pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^::/,
                    alias: 'punctuation'
                }
            }
        },
        'quoted-literal-block': {
            pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
                    alias: 'punctuation'
                }
            }
        },
        'list-bullet': {
            pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
            lookbehind: true,
            alias: 'punctuation'
        },
        'doctest-block': {
            pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /^>>>/
            }
        },
        inline: [
            {
                pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
                lookbehind: true,
                inside: {
                    bold: {
                        pattern: /(^\*\*).+(?=\*\*$)/,
                        lookbehind: true
                    },
                    italic: {
                        pattern: /(^\*).+(?=\*$)/,
                        lookbehind: true
                    },
                    'inline-literal': {
                        pattern: /(^``).+(?=``$)/,
                        lookbehind: true,
                        alias: 'symbol'
                    },
                    role: {
                        pattern: /^:[^:]+:|:[^:]+:$/,
                        alias: 'function',
                        inside: {
                            punctuation: /^:|:$/
                        }
                    },
                    'interpreted-text': {
                        pattern: /(^`).+(?=`$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    substitution: {
                        pattern: /(^\|).+(?=\|$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\*\*?|``?|\|/
                }
            }
        ],
        link: [
            {
                pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]_$/
                }
            },
            {
                pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
                alias: 'string',
                inside: {
                    punctuation: /^_?`|`$|`?_?_$/
                }
            }
        ],
        // Line block start,
        // quote attribution,
        // explicit markup start,
        // and anonymous hyperlink target shortcut (__)
        punctuation: {
            pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
            lookbehind: true
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9e1e815b43dfcf12$export$2e2bcd8739ae039.displayName = 'rip';
$9e1e815b43dfcf12$export$2e2bcd8739ae039.aliases = [];
function $9e1e815b43dfcf12$export$2e2bcd8739ae039(Prism) {
    Prism.languages.rip = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        char: {
            pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        regex: {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
        builtin: /@|\bSystem\b/,
        boolean: /\b(?:false|true)\b/,
        date: /\b\d{4}-\d{2}-\d{2}\b/,
        time: /\b\d{2}:\d{2}:\d{2}\b/,
        datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
        symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
        number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
        punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
        reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e01299bf75eda32d$export$2e2bcd8739ae039.displayName = 'roboconf';
$e01299bf75eda32d$export$2e2bcd8739ae039.aliases = [];
function $e01299bf75eda32d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.roboconf = {
        comment: /#.*/,
        keyword: {
            pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
            lookbehind: true
        },
        component: {
            pattern: /[\w-]+(?=[ \t]*\{)/,
            alias: 'variable'
        },
        property: /[\w.-]+(?=[ \t]*:)/,
        value: {
            pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
            lookbehind: true,
            alias: 'attr-value'
        },
        optional: {
            pattern: /\(optional\)/,
            alias: 'builtin'
        },
        wildcard: {
            pattern: /(\.)\*/,
            lookbehind: true,
            alias: 'operator'
        },
        punctuation: /[{},.;:=]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $37dde9971f145ea3$export$2e2bcd8739ae039.displayName = 'robotframework';
$37dde9971f145ea3$export$2e2bcd8739ae039.aliases = [
    'robot'
];
function $37dde9971f145ea3$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /(^[ \t]*| {2}|\t)#.*/m,
            lookbehind: true,
            greedy: true
        };
        var variable = {
            pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
            lookbehind: true,
            inside: {
                punctuation: /^[$@&%]\{|\}$/
            }
        };
        function createSection(name, inside) {
            var extendecInside = {};
            extendecInside['section-header'] = {
                pattern: /^ ?\*{3}.+?\*{3}/,
                alias: 'keyword'
            };
            // copy inside tokens
            for(var token in inside)extendecInside[token] = inside[token];
            extendecInside['tag'] = {
                pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
                lookbehind: true,
                inside: {
                    punctuation: /\[|\]/
                }
            };
            extendecInside['variable'] = variable;
            extendecInside['comment'] = comment;
            return {
                pattern: RegExp(/^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(/<name>/g, function() {
                    return name;
                }), 'im'),
                alias: 'section',
                inside: extendecInside
            };
        }
        var docTag = {
            pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: true,
            alias: 'string'
        };
        var testNameLike = {
            pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            alias: 'function',
            inside: {
                variable: variable
            }
        };
        var testPropertyLike = {
            pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            inside: {
                variable: variable
            }
        };
        Prism.languages['robotframework'] = {
            settings: createSection('Settings', {
                documentation: {
                    pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
                    lookbehind: true,
                    alias: 'string'
                },
                property: {
                    pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
                    lookbehind: true
                }
            }),
            variables: createSection('Variables'),
            'test-cases': createSection('Test Cases', {
                'test-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            keywords: createSection('Keywords', {
                'keyword-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            tasks: createSection('Tasks', {
                'task-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            comment: comment
        };
        Prism.languages.robot = Prism.languages['robotframework'];
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $390e344e43dfbcde$export$2e2bcd8739ae039.displayName = 'sas';
$390e344e43dfbcde$export$2e2bcd8739ae039.aliases = [];
function $390e344e43dfbcde$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var stringPattern = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source;
        var number = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i;
        var numericConstant = {
            pattern: RegExp(stringPattern + '[bx]'),
            alias: 'number'
        };
        var macroVariable = {
            pattern: /&[a-z_]\w*/i
        };
        var macroKeyword = {
            pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var step = {
            pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
            alias: 'keyword',
            lookbehind: true
        };
        var comment = [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
                lookbehind: true
            }
        ];
        var string = {
            pattern: RegExp(stringPattern),
            greedy: true
        };
        var punctuation = /[$%@.(){}\[\];,\\]/;
        var func = {
            pattern: /%?\b\w+(?=\()/,
            alias: 'keyword'
        };
        var args = {
            function: func,
            'arg-value': {
                pattern: /(=\s*)[A-Z\.]+/i,
                lookbehind: true
            },
            operator: /=/,
            'macro-variable': macroVariable,
            arg: {
                pattern: /[A-Z]+/i,
                alias: 'keyword'
            },
            number: number,
            'numeric-constant': numericConstant,
            punctuation: punctuation,
            string: string
        };
        var format = {
            pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
            inside: {
                keyword: /^(?:format|put)(?==)/i,
                equals: /=/,
                format: {
                    pattern: /(?:\w|\$\d)+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var altformat = {
            pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
            inside: {
                keyword: /^(?:format|put)/i,
                format: {
                    pattern: /[\w$]+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var globalStatements = {
            pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var submitStatement = {
            pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var actionSets = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source;
        var casActions = {
            pattern: RegExp(/(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(/<act>/g, function() {
                return actionSets;
            }), 'i'),
            lookbehind: true,
            inside: {
                keyword: RegExp(/(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
                    return actionSets;
                }), 'i'),
                action: {
                    pattern: /(?:action)/i,
                    alias: 'keyword'
                },
                comment: comment,
                function: func,
                'arg-value': args['arg-value'],
                operator: args.operator,
                argument: args.arg,
                number: number,
                'numeric-constant': numericConstant,
                punctuation: punctuation,
                string: string
            }
        };
        var keywords = {
            pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
            lookbehind: true
        };
        Prism.languages.sas = {
            datalines: {
                pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
                lookbehind: true,
                alias: 'string',
                inside: {
                    keyword: {
                        pattern: /^(?:cards|(?:data)?lines)/i
                    },
                    punctuation: /;/
                }
            },
            'proc-sql': {
                pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    sql: {
                        pattern: RegExp(/^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        alias: 'language-sql',
                        inside: Prism.languages.sql
                    },
                    'global-statements': globalStatements,
                    'sql-statements': {
                        pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-groovy': {
                pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    groovy: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-groovy',
                        inside: Prism.languages.groovy
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-lua': {
                pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    lua: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-lua',
                        inside: Prism.languages.lua
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-cas': {
                pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    'statement-var': {
                        pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
                        lookbehind: true,
                        inside: {
                            statement: {
                                pattern: /^saveresult\s+\S+/i,
                                inside: {
                                    keyword: /^(?:saveresult)/i
                                }
                            },
                            rest: args
                        }
                    },
                    'cas-actions': casActions,
                    statement: {
                        pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
                        lookbehind: true,
                        inside: args
                    },
                    step: step,
                    keyword: keywords,
                    function: func,
                    format: format,
                    altformat: altformat,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-args': {
                pattern: RegExp(/(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(/<str>/g, function() {
                    return stringPattern;
                }), 'im'),
                lookbehind: true,
                inside: args
            },
            /*Special keywords within macros*/ 'macro-keyword': macroKeyword,
            'macro-variable': macroVariable,
            'macro-string-functions': {
                pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
                        alias: 'keyword'
                    },
                    'macro-keyword': macroKeyword,
                    'macro-variable': macroVariable,
                    'escaped-char': {
                        pattern: /%['"()<>=¬^~;,#]/
                    },
                    punctuation: punctuation
                }
            },
            'macro-declaration': {
                pattern: /^%macro[^;]+(?=;)/im,
                inside: {
                    keyword: /%macro/i
                }
            },
            'macro-end': {
                pattern: /^%mend[^;]+(?=;)/im,
                inside: {
                    keyword: /%mend/i
                }
            },
            /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */ macro: {
                pattern: /%_\w+(?=\()/,
                alias: 'keyword'
            },
            input: {
                pattern: /\binput\s[-\w\s/*.$&]+;/i,
                inside: {
                    input: {
                        alias: 'keyword',
                        pattern: /^input/i
                    },
                    comment: comment,
                    number: number,
                    'numeric-constant': numericConstant
                }
            },
            'options-args': {
                pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
                lookbehind: true,
                inside: args
            },
            'cas-actions': casActions,
            comment: comment,
            function: func,
            format: format,
            altformat: altformat,
            'numeric-constant': numericConstant,
            datetime: {
                // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
                pattern: RegExp(stringPattern + '(?:dt?|t)'),
                alias: 'number'
            },
            string: string,
            step: step,
            keyword: keywords,
            // In SAS Studio syntax highlighting, these operators are styled like keywords
            'operator-keyword': {
                pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
                alias: 'operator'
            },
            // Decimal (1.2e23), hexadecimal (0c1x)
            number: number,
            operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
            punctuation: punctuation
        };
    })(Prism);
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$730f9a4b12501d43$export$2e2bcd8739ae039.displayName = 'shell-session';
$730f9a4b12501d43$export$2e2bcd8739ae039.aliases = [
    'sh-session',
    'shellsession'
];
function $730f9a4b12501d43$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $8bc35bfd2be6822a$export$2e2bcd8739ae039));
    (function(Prism) {
        // CAREFUL!
        // The following patterns are concatenated, so the group referenced by a back reference is non-obvious!
        var strings = [
            // normal string
            /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
            /'[^']*'/.source,
            /\$'(?:[^'\\]|\\[\s\S])*'/.source,
            // here doc
            // 2 capturing groups
            /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
        ].join('|');
        Prism.languages['shell-session'] = {
            command: {
                pattern: RegExp(// user info
                /^/.source + '(?:' + // <user> ":" ( <path> )?
                (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + '|' + // <path>
                // Since the path pattern is quite general, we will require it to start with a special character to
                // prevent false positives.
                /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ')?' + // shell symbol
                /[$#%](?=\s)/.source + // bash command
                /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function() {
                    return strings;
                }), 'm'),
                greedy: true,
                inside: {
                    info: {
                        // foo@bar:~/files$ exit
                        // foo@bar$ exit
                        // ~/files$ exit
                        pattern: /^[^#$%]+/,
                        alias: 'punctuation',
                        inside: {
                            user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                            punctuation: /:/,
                            path: /[\s\S]+/
                        }
                    },
                    bash: {
                        pattern: /(^[$#%]\s*)\S[\s\S]*/,
                        lookbehind: true,
                        alias: 'language-bash',
                        inside: Prism.languages.bash
                    },
                    'shell-symbol': {
                        pattern: /^[$#%]/,
                        alias: 'important'
                    }
                }
            },
            output: /.(?:.*(?:[\r\n]|.$))*/
        };
        Prism.languages['sh-session'] = Prism.languages['shellsession'] = Prism.languages['shell-session'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $0ef3d1ceb8394e5c$export$2e2bcd8739ae039.displayName = 'smali';
$0ef3d1ceb8394e5c$export$2e2bcd8739ae039.aliases = [];
function $0ef3d1ceb8394e5c$export$2e2bcd8739ae039(Prism) {
    // Test files for the parser itself:
    // https://github.com/JesusFreke/smali/tree/master/smali/src/test/resources/LexerTest
    Prism.languages.smali = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
            greedy: true
        },
        'class-name': {
            pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
            lookbehind: true,
            inside: {
                'class-name': {
                    pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
                    lookbehind: true
                },
                namespace: {
                    pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\//
                    }
                },
                builtin: /^L/
            }
        },
        builtin: [
            {
                // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
                pattern: /([();\[])[BCDFIJSVZ]+/,
                lookbehind: true
            },
            {
                // e.g. .field mWifiOnUid:I
                pattern: /([\w$>]:)[BCDFIJSVZ]/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /(\.end\s+)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
            lookbehind: true
        },
        field: {
            pattern: /[\w$]+(?=:)/,
            alias: 'variable'
        },
        register: {
            pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
            lookbehind: true,
            alias: 'variable'
        },
        boolean: {
            pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
            lookbehind: true
        },
        label: {
            pattern: /(:)\w+/,
            lookbehind: true,
            alias: 'property'
        },
        operator: /->|\.\.|[\[=]/,
        punctuation: /[{}(),;:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $feeef9c3da6c04de$export$2e2bcd8739ae039.displayName = 'smalltalk';
$feeef9c3da6c04de$export$2e2bcd8739ae039.aliases = [];
function $feeef9c3da6c04de$export$2e2bcd8739ae039(Prism) {
    Prism.languages.smalltalk = {
        comment: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        char: {
            pattern: /\$./,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'])*'/,
            greedy: true
        },
        symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
        'block-arguments': {
            pattern: /(\[\s*):[^\[|]*\|/,
            lookbehind: true,
            inside: {
                variable: /:[\da-z]+/i,
                punctuation: /\|/
            }
        },
        'temporary-variables': {
            pattern: /\|[^|]+\|/,
            inside: {
                variable: /[\da-z]+/i,
                punctuation: /\|/
            }
        },
        keyword: /\b(?:new|nil|self|super)\b/,
        boolean: /\b(?:false|true)\b/,
        number: [
            /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
            /\b\d+(?:\.\d+)?(?:e-?\d+)?/
        ],
        operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
        punctuation: /[.;:?\[\](){}]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$a0deafd0233b5617$export$2e2bcd8739ae039.displayName = 'smarty';
$a0deafd0233b5617$export$2e2bcd8739ae039.aliases = [];
function $a0deafd0233b5617$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.smarty = {
            comment: {
                pattern: /^\{\*[\s\S]*?\*\}/,
                greedy: true
            },
            'embedded-php': {
                pattern: /^\{php\}[\s\S]*?\{\/php\}/,
                greedy: true,
                inside: {
                    smarty: {
                        pattern: /^\{php\}|\{\/php\}$/,
                        inside: null // see below
                    },
                    php: {
                        pattern: /[\s\S]+/,
                        alias: 'language-php',
                        inside: Prism.languages.php
                    }
                }
            },
            string: [
                {
                    pattern: /"(?:\\.|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: /\{[^{}]*\}|`[^`]*`/,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^[{`]|[`}]$/,
                                    alias: 'punctuation'
                                },
                                expression: {
                                    pattern: /[\s\S]+/,
                                    inside: null // see below
                                }
                            }
                        },
                        variable: /\$\w+/
                    }
                },
                {
                    pattern: /'(?:\\.|[^'\\\r\n])*'/,
                    greedy: true
                }
            ],
            keyword: {
                pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
                lookbehind: true,
                greedy: true
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                greedy: true,
                alias: 'punctuation'
            },
            number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
            variable: [
                /\$(?!\d)\w+/,
                /#(?!\d)\w+#/,
                {
                    pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
                    lookbehind: true
                },
                {
                    pattern: /(\[)(?!\d)\w+(?=\])/,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
                lookbehind: true
            },
            'attr-name': /\b[a-z_]\w*(?=\s*=)/i,
            boolean: /\b(?:false|no|off|on|true|yes)\b/,
            punctuation: /[\[\](){}.,:`]|->/,
            operator: [
                /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
                /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
                /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
            ]
        };
        Prism.languages.smarty['embedded-php'].inside.smarty.inside = Prism.languages.smarty;
        Prism.languages.smarty.string[0].inside.interpolation.inside.expression.inside = Prism.languages.smarty;
        var string = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/;
        var smartyPattern = RegExp(// comments
        /\{\*[\s\S]*?\*\}/.source + '|' + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + '|' + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(/<str>/g, function() {
            return string.source;
        }), 'g');
        // Tokenize all inline Smarty expressions
        Prism.hooks.add('before-tokenize', function(env) {
            var smartyLiteralStart = '{literal}';
            var smartyLiteralEnd = '{/literal}';
            var smartyLiteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'smarty', smartyPattern, function(match) {
                // Smarty tags inside {literal} block are ignored
                if (match === smartyLiteralEnd) smartyLiteralMode = false;
                if (!smartyLiteralMode) {
                    if (match === smartyLiteralStart) smartyLiteralMode = true;
                    return true;
                }
                return false;
            });
        });
        // Re-insert the tokens after tokenizing
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'smarty');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1aa991af509c7894$export$2e2bcd8739ae039.displayName = 'sml';
$1aa991af509c7894$export$2e2bcd8739ae039.aliases = [
    'smlnj'
];
function $1aa991af509c7894$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
        Prism.languages.sml = {
            // allow one level of nesting
            comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
            string: {
                pattern: /#?"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': [
                {
                    // This is only an approximation since the real grammar is context-free
                    //
                    // Why the main loop so complex?
                    // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
                    // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
                    // followed by a long identifier.
                    pattern: RegExp(/((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                        return /\s*(?:[*,]|->)/.source;
                    }).replace(/<TERMINAL>/g, function() {
                        return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
                    }).replace(/<LONG-ID>/g, function() {
                        return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
                    }).replace(/<KEYWORD>/g, function() {
                        return keywords.source;
                    }), 'i'),
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
                lookbehind: true
            },
            keyword: keywords,
            variable: {
                pattern: /(^|[^\w'])'[\w']*/,
                lookbehind: true
            },
            number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
            word: {
                pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
                alias: 'constant'
            },
            boolean: /\b(?:false|true)\b/i,
            operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
            punctuation: /[(){}\[\].:,;]/
        };
        Prism.languages.sml['class-name'][0].inside = Prism.languages.sml;
        Prism.languages.smlnj = Prism.languages.sml;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3a1367f4db4eb9c1$export$2e2bcd8739ae039.displayName = 'solidity';
$3a1367f4db4eb9c1$export$2e2bcd8739ae039.aliases = [
    'sol'
];
function $3a1367f4db4eb9c1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.solidity = Prism.languages.extend('clike', {
        'class-name': {
            pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
            lookbehind: true
        },
        keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
        operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    });
    Prism.languages.insertBefore('solidity', 'keyword', {
        builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    });
    Prism.languages.insertBefore('solidity', 'number', {
        version: {
            pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
            lookbehind: true,
            alias: 'number'
        }
    });
    Prism.languages.sol = Prism.languages.solidity;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $3f3dc76a1a6f0313$export$2e2bcd8739ae039.displayName = 'solution-file';
$3f3dc76a1a6f0313$export$2e2bcd8739ae039.aliases = [
    'sln'
];
function $3f3dc76a1a6f0313$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var guid = {
            // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
            pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
            alias: 'constant',
            inside: {
                punctuation: /[{}]/
            }
        };
        Prism.languages['solution-file'] = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                greedy: true,
                inside: {
                    guid: guid
                }
            },
            object: {
                // Foo
                //   Bar("abs") = 9
                //   EndBar
                //   Prop = TRUE
                // EndFoo
                pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
                lookbehind: true,
                greedy: true,
                alias: 'keyword'
            },
            property: {
                pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
                lookbehind: true,
                inside: {
                    guid: guid
                }
            },
            guid: guid,
            number: /\b\d+(?:\.\d+)*\b/,
            boolean: /\b(?:FALSE|TRUE)\b/,
            operator: /=/,
            punctuation: /[(),]/
        };
        Prism.languages['sln'] = Prism.languages['solution-file'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$4b8f98fbb364b5fe$export$2e2bcd8739ae039.displayName = 'soy';
$4b8f98fbb364b5fe$export$2e2bcd8739ae039.aliases = [];
function $4b8f98fbb364b5fe$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        var stringPattern = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var numberPattern = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
        Prism.languages.soy = {
            comment: [
                /\/\*[\s\S]*?\*\//,
                {
                    pattern: /(\s)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            'command-arg': {
                pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /\./
                }
            },
            parameter: {
                pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'variable'
            },
            keyword: [
                {
                    pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
                    lookbehind: true
                },
                /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
            ],
            delimiter: {
                pattern: /^\{+\/?|\/?\}+$/,
                alias: 'punctuation'
            },
            property: /\w+(?==)/,
            variable: {
                pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
                inside: {
                    string: {
                        pattern: stringPattern,
                        greedy: true
                    },
                    number: numberPattern,
                    punctuation: /[\[\].?]/
                }
            },
            string: {
                pattern: stringPattern,
                greedy: true
            },
            function: [
                /\w+(?=\()/,
                {
                    pattern: /(\|[^\S\r\n]*)\w+/,
                    lookbehind: true
                }
            ],
            boolean: /\b(?:false|true)\b/,
            number: numberPattern,
            operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
            punctuation: /[{}()\[\]|.,:]/
        };
        // Tokenize all inline Soy expressions
        Prism.hooks.add('before-tokenize', function(env) {
            var soyPattern = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g;
            var soyLitteralStart = '{literal}';
            var soyLitteralEnd = '{/literal}';
            var soyLitteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'soy', soyPattern, function(match) {
                // Soy tags inside {literal} block are ignored
                if (match === soyLitteralEnd) soyLitteralMode = false;
                if (!soyLitteralMode) {
                    if (match === soyLitteralStart) soyLitteralMode = true;
                    return true;
                }
                return false;
            });
        });
        // Re-insert the tokens after tokenizing
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'soy');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $013d5fc882b5f308$export$2e2bcd8739ae039.displayName = 'turtle';
$013d5fc882b5f308$export$2e2bcd8739ae039.aliases = [
    'trig'
];
function $013d5fc882b5f308$export$2e2bcd8739ae039(Prism) {
    Prism.languages.turtle = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'multiline-string': {
            pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
            greedy: true,
            alias: 'string',
            inside: {
                comment: /#.*/
            }
        },
        string: {
            pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
            greedy: true
        },
        url: {
            pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
            greedy: true,
            inside: {
                punctuation: /[<>]/
            }
        },
        function: {
            pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
            inside: {
                'local-name': {
                    pattern: /([^:]*:)[\s\S]+/,
                    lookbehind: true
                },
                prefix: {
                    pattern: /[\s\S]+/,
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        },
        number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        punctuation: /[{}.,;()[\]]|\^\^/,
        boolean: /\b(?:false|true)\b/,
        keyword: [
            /(?:\ba|@prefix|@base)\b|=/,
            /\b(?:base|graph|prefix)\b/i
        ],
        tag: {
            pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
            inside: {
                punctuation: /@/
            }
        }
    };
    Prism.languages.trig = Prism.languages['turtle'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$803656f9da2f54a6$export$2e2bcd8739ae039.displayName = 'sparql';
$803656f9da2f54a6$export$2e2bcd8739ae039.aliases = [
    'rq'
];
function $803656f9da2f54a6$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $013d5fc882b5f308$export$2e2bcd8739ae039));
    Prism.languages.sparql = Prism.languages.extend('turtle', {
        boolean: /\b(?:false|true)\b/i,
        variable: {
            pattern: /[?$]\w+/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('sparql', 'punctuation', {
        keyword: [
            /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
            /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
            /\b(?:BASE|GRAPH|PREFIX)\b/i
        ]
    });
    Prism.languages.rq = Prism.languages.sparql;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $fbdec31c6df2c19f$export$2e2bcd8739ae039.displayName = 'splunk-spl';
$fbdec31c6df2c19f$export$2e2bcd8739ae039.aliases = [];
function $fbdec31c6df2c19f$export$2e2bcd8739ae039(Prism) {
    Prism.languages['splunk-spl'] = {
        comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true
        },
        // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
        keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
        'operator-word': {
            pattern: /\b(?:and|as|by|not|or|xor)\b/i,
            alias: 'operator'
        },
        function: /\b\w+(?=\s*\()/,
        property: /\b\w+(?=\s*=(?!=))/,
        date: {
            // MM/DD/YYYY(:HH:MM:SS)?
            pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
            alias: 'number'
        },
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /\b(?:f|false|t|true)\b/i,
        operator: /[<>=]=?|[-+*/%|]/,
        punctuation: /[()[\],]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$12d6f3ddfd59c8f8$export$2e2bcd8739ae039.displayName = 'sqf';
$12d6f3ddfd59c8f8$export$2e2bcd8739ae039.aliases = [];
function $12d6f3ddfd59c8f8$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.sqf = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
            greedy: true
        },
        keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
        number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
        operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
        'magic-variable': {
            pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
            alias: 'keyword'
        },
        constant: /\bDIK(?:_[a-z\d]+)+\b/i
    });
    Prism.languages.insertBefore('sqf', 'string', {
        macro: {
            pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /#[a-z]+\b/i,
                    alias: 'keyword'
                },
                comment: Prism.languages.sqf.comment
            }
        }
    });
    delete Prism.languages.sqf['class-name'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$d0722eb1de37ae4c$export$2e2bcd8739ae039.displayName = 'squirrel';
$d0722eb1de37ae4c$export$2e2bcd8739ae039.aliases = [];
function $d0722eb1de37ae4c$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.squirrel = Prism.languages.extend('clike', {
        comment: [
            Prism.languages.clike['comment'][0],
            {
                pattern: /(^|[^\\:])(?:\/\/|#).*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
        number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
        operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
        punctuation: /[(){}\[\],;.]/
    });
    Prism.languages.insertBefore('squirrel', 'string', {
        char: {
            pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
            lookbehind: true,
            greedy: true
        }
    });
    Prism.languages.insertBefore('squirrel', 'operator', {
        'attribute-punctuation': {
            pattern: /<\/|\/>/,
            alias: 'important'
        },
        lambda: {
            pattern: /@(?=\()/,
            alias: 'operator'
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d11fe3812b565e9e$export$2e2bcd8739ae039.displayName = 'stan';
$d11fe3812b565e9e$export$2e2bcd8739ae039.aliases = [];
function $d11fe3812b565e9e$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        // https://mc-stan.org/docs/2_28/reference-manual/bnf-grammars.html
        var higherOrderFunctions = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
        Prism.languages.stan = {
            comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
            string: {
                // String literals can contain spaces and any printable ASCII characters except for " and \
                // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
                pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
                greedy: true
            },
            directive: {
                pattern: /^([ \t]*)#include\b.*/m,
                lookbehind: true,
                alias: 'property'
            },
            'function-arg': {
                pattern: RegExp('(' + higherOrderFunctions.source + /\s*\(\s*/.source + ')' + /[a-zA-Z]\w*/.source),
                lookbehind: true,
                alias: 'function'
            },
            constraint: {
                pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    property: /\b[a-z]\w*(?=\s*=)/i,
                    operator: /=/,
                    punctuation: /^<|>$|,/
                }
            },
            keyword: [
                {
                    pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
                    alias: 'program-block'
                },
                /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
                // these are functions that are known to take another function as their first argument.
                higherOrderFunctions
            ],
            function: /\b[a-z]\w*(?=\s*\()/i,
            number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            boolean: /\b(?:false|true)\b/,
            operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
            punctuation: /[()\[\]{},;]/
        };
        Prism.languages.stan.constraint.inside.expression.inside = Prism.languages.stan;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 


$b9bd6ce061e8b23b$export$2e2bcd8739ae039.displayName = 'stata';
$b9bd6ce061e8b23b$export$2e2bcd8739ae039.aliases = [];
function $b9bd6ce061e8b23b$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
    Prism.register((0, $7306ed74be230ce9$export$2e2bcd8739ae039));
    Prism.register((0, $4c79b618a588b28d$export$2e2bcd8739ae039));
    // https://www.stata.com/manuals/u.pdf
    // https://www.stata.com/manuals/p.pdf
    Prism.languages.stata = {
        comment: [
            {
                pattern: /(^[ \t]*)\*.*/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|\s)\/\/.*|\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true
            }
        ],
        'string-literal': {
            pattern: /"[^"\r\n]*"|[‘`']".*?"[’`']/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}|[‘`']\w[^’`'\r\n]*[’`']/,
                    inside: {
                        punctuation: /^\$\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        mata: {
            pattern: /(^[ \t]*mata[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-mata',
            inside: Prism.languages.mata
        },
        java: {
            pattern: /(^[ \t]*java[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-java',
            inside: Prism.languages.java
        },
        python: {
            pattern: /(^[ \t]*python[ \t]*:)[\s\S]+?(?=^end\b)/m,
            lookbehind: true,
            greedy: true,
            alias: 'language-python',
            inside: Prism.languages.python
        },
        command: {
            pattern: /(^[ \t]*(?:\.[ \t]+)?(?:(?:bayes|bootstrap|by|bysort|capture|collect|fmm|fp|frame|jackknife|mfp|mi|nestreg|noisily|permute|quietly|rolling|simulate|statsby|stepwise|svy|version|xi)\b[^:\r\n]*:[ \t]*|(?:capture|noisily|quietly|version)[ \t]+)?)[a-zA-Z]\w*/m,
            lookbehind: true,
            greedy: true,
            alias: 'keyword'
        },
        variable: /\$\w+|[‘`']\w[^’`'\r\n]*[’`']/,
        keyword: /\b(?:bayes|bootstrap|by|bysort|capture|clear|collect|fmm|fp|frame|if|in|jackknife|mi[ \t]+estimate|mfp|nestreg|noisily|of|permute|quietly|rolling|simulate|sort|statsby|stepwise|svy|varlist|version|xi)\b/,
        boolean: /\b(?:off|on)\b/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+/,
        function: /\b[a-z_]\w*(?=\()/i,
        operator: /\+\+|--|##?|[<>!=~]=?|[+\-*^&|/]/,
        punctuation: /[(){}[\],:]/
    };
    Prism.languages.stata['string-literal'].inside.interpolation.inside.expression.inside = Prism.languages.stata;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9f8d1abaebbe1e7b$export$2e2bcd8739ae039.displayName = 'iecst';
$9f8d1abaebbe1e7b$export$2e2bcd8739ae039.aliases = [];
function $9f8d1abaebbe1e7b$export$2e2bcd8739ae039(Prism) {
    Prism.languages.iecst = {
        comment: [
            {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: [
            /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
            /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
        ],
        'class-name': /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
        address: {
            pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
            alias: 'symbol'
        },
        number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/,
        operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        punctuation: /[()[\].,;]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $352108f0900288bc$export$2e2bcd8739ae039.displayName = 'supercollider';
$352108f0900288bc$export$2e2bcd8739ae039.aliases = [
    'sclang'
];
function $352108f0900288bc$export$2e2bcd8739ae039(Prism) {
    Prism.languages.supercollider = {
        comment: {
            pattern: /\/\/.*|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^"\\]|\\[\s\S])*"/,
            lookbehind: true,
            greedy: true
        },
        char: {
            pattern: /\$(?:[^\\\r\n]|\\.)/,
            greedy: true
        },
        symbol: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'|\\\w+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:_|arg|classvar|const|nil|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        label: {
            pattern: /\b[a-z_]\w*(?=\s*:)/,
            alias: 'property'
        },
        number: /\b(?:inf|pi|0x[0-9a-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(?:pi)?|\d+r[0-9a-zA-Z]+(?:\.[0-9a-zA-Z]+)?|\d+[sb]{1,4}\d*)\b/,
        'class-name': /\b[A-Z]\w*\b/,
        operator: /\.{2,3}|#(?![[{])|&&|[!=]==?|\+>>|\+{1,3}|-[->]|=>|>>|\?\?|@\|?@|\|(?:@|[!=]=)?\||!\?|<[!=>]|\*{1,2}|<{2,3}\*?|[-!%&/<>?@|=`]/,
        punctuation: /[{}()[\].:,;]|#[[{]/
    };
    Prism.languages.sclang = Prism.languages.supercollider;
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $f6357e1d35f66b04$export$2e2bcd8739ae039.displayName = 'systemd';
$f6357e1d35f66b04$export$2e2bcd8739ae039.aliases = [];
function $f6357e1d35f66b04$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /^[;#].*/m,
            greedy: true
        };
        var quotesSource = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
        Prism.languages.systemd = {
            comment: comment,
            section: {
                pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    'section-name': {
                        pattern: /[\s\S]+/,
                        alias: 'selector'
                    }
                }
            },
            key: {
                pattern: /^[^\s=]+(?=[ \t]*=)/m,
                greedy: true,
                alias: 'attr-name'
            },
            value: {
                // This pattern is quite complex because of two properties:
                //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
                //     the lookbehind. You will see this in the main loop where spaces are handled separately.
                //  2) Line continuations.
                //     After line continuations, empty lines and comments are ignored so we have to consume them.
                pattern: RegExp(/(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
                '(?:' + quotesSource + '|(?=[^"\r\n]))' + // main loop
                '(?:' + (/[^\s\\]/.source + // handle spaces separately because of quotes
                '|' + '[ \t]+(?:(?![ \t"])|' + quotesSource + ')' + // line continuation
                '|' + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'attr-value',
                inside: {
                    comment: comment,
                    quoted: {
                        pattern: RegExp(/(^|\s)/.source + quotesSource),
                        lookbehind: true,
                        greedy: true
                    },
                    punctuation: /\\$/m,
                    boolean: {
                        pattern: /^(?:false|no|off|on|true|yes)$/,
                        greedy: true
                    }
                }
            },
            punctuation: /=/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $cf1be131e0fce4fa$export$2e2bcd8739ae039.displayName = 't4-templating';
$cf1be131e0fce4fa$export$2e2bcd8739ae039.aliases = [];
function $cf1be131e0fce4fa$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function createBlock(prefix, inside, contentAlias) {
            return {
                pattern: RegExp('<#' + prefix + '[\\s\\S]*?#>'),
                alias: 'block',
                inside: {
                    delimiter: {
                        pattern: RegExp('^<#' + prefix + '|#>$'),
                        alias: 'important'
                    },
                    content: {
                        pattern: /[\s\S]+/,
                        inside: inside,
                        alias: contentAlias
                    }
                }
            };
        }
        function createT4(insideLang) {
            var grammar = Prism.languages[insideLang];
            var className = 'language-' + insideLang;
            return {
                block: {
                    pattern: /<#[\s\S]+?#>/,
                    inside: {
                        directive: createBlock('@', {
                            'attr-value': {
                                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                                inside: {
                                    punctuation: /^=|^["']|["']$/
                                }
                            },
                            keyword: /\b\w+(?=\s)/,
                            'attr-name': /\b\w+/
                        }),
                        expression: createBlock('=', grammar, className),
                        'class-feature': createBlock('\\+', grammar, className),
                        standard: createBlock('', grammar, className)
                    }
                }
            };
        }
        Prism.languages['t4-templating'] = Object.defineProperty({}, 'createT4', {
            value: createT4
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$059ad53228ded3c9$export$2e2bcd8739ae039.displayName = 't4-cs';
$059ad53228ded3c9$export$2e2bcd8739ae039.aliases = [
    't4'
];
function $059ad53228ded3c9$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $803928922a6961a4$export$2e2bcd8739ae039));
    Prism.register((0, $cf1be131e0fce4fa$export$2e2bcd8739ae039));
    Prism.languages.t4 = Prism.languages['t4-cs'] = Prism.languages['t4-templating'].createT4('csharp');
}



// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$0acbc38df3a79135$export$2e2bcd8739ae039.displayName = 't4-vb';
$0acbc38df3a79135$export$2e2bcd8739ae039.aliases = [];
function $0acbc38df3a79135$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $cf1be131e0fce4fa$export$2e2bcd8739ae039));
    Prism.register((0, $74f53190c8211cce$export$2e2bcd8739ae039));
    Prism.languages['t4-vb'] = Prism.languages['t4-templating'].createT4('vbnet');
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$3b31713a87a8de6a$export$2e2bcd8739ae039.displayName = 'tap';
$3b31713a87a8de6a$export$2e2bcd8739ae039.aliases = [];
function $3b31713a87a8de6a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $1da2260b608e55ec$export$2e2bcd8739ae039));
    // https://en.wikipedia.org/wiki/Test_Anything_Protocol
    Prism.languages.tap = {
        fail: /not ok[^#{\n\r]*/,
        pass: /ok[^#{\n\r]*/,
        pragma: /pragma [+-][a-z]+/,
        bailout: /bail out!.*/i,
        version: /TAP version \d+/i,
        plan: /\b\d+\.\.\d+(?: +#.*)?/,
        subtest: {
            pattern: /# Subtest(?:: .*)?/,
            greedy: true
        },
        punctuation: /[{}]/,
        directive: /#.*/,
        yamlish: {
            pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
            lookbehind: true,
            inside: Prism.languages.yaml,
            alias: 'language-yaml'
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $735a787ca1f7aae4$export$2e2bcd8739ae039.displayName = 'tcl';
$735a787ca1f7aae4$export$2e2bcd8739ae039.aliases = [];
function $735a787ca1f7aae4$export$2e2bcd8739ae039(Prism) {
    Prism.languages.tcl = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
        },
        string: {
            pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
                lookbehind: true
            },
            {
                pattern: /(\$)\{[^}]+\}/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^[\t ]*proc[ \t]+)\S+/m,
            lookbehind: true
        },
        builtin: [
            {
                pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
                lookbehind: true
            },
            /\b(?:else|elseif)\b/
        ],
        scope: {
            pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
            lookbehind: true,
            alias: 'constant'
        },
        keyword: {
            pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
            lookbehind: true
        },
        operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
        punctuation: /[{}()\[\]]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 

$38e9da697ee0f6f7$export$2e2bcd8739ae039.displayName = 'tt2';
$38e9da697ee0f6f7$export$2e2bcd8739ae039.aliases = [];
function $38e9da697ee0f6f7$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.tt2 = Prism.languages.extend('clike', {
            comment: /#.*|\[%#[\s\S]*?%\]/,
            keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
            punctuation: /[[\]{},()]/
        });
        Prism.languages.insertBefore('tt2', 'number', {
            operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
            variable: {
                pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
            }
        });
        Prism.languages.insertBefore('tt2', 'keyword', {
            delimiter: {
                pattern: /^(?:\[%|%%)-?|-?%\]$/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('tt2', 'string', {
            'single-quoted-string': {
                pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
                greedy: true,
                alias: 'string'
            },
            'double-quoted-string': {
                pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
                greedy: true,
                alias: 'string',
                inside: {
                    variable: {
                        pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
                    }
                }
            }
        });
        // The different types of TT2 strings "replace" the C-like standard string
        delete Prism.languages.tt2.string;
        Prism.hooks.add('before-tokenize', function(env) {
            var tt2Pattern = /\[%[\s\S]+?%\]/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'tt2', tt2Pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'tt2');
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $00d1fd220eb25cf1$export$2e2bcd8739ae039.displayName = 'toml';
$00d1fd220eb25cf1$export$2e2bcd8739ae039.aliases = [];
function $00d1fd220eb25cf1$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var key = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
        /**
     * @param {string} pattern
     */ function insertKey(pattern) {
            return pattern.replace(/__/g, function() {
                return key;
            });
        }
        Prism.languages.toml = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            table: {
                pattern: RegExp(insertKey(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name'
            },
            key: {
                pattern: RegExp(insertKey(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'property'
            },
            string: {
                pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            date: [
                {
                    // Offset Date-Time, Local Date-Time, Local Date
                    pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
                    alias: 'number'
                },
                {
                    // Local Time
                    pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
                    alias: 'number'
                }
            ],
            number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /[.,=[\]{}]/
        };
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $9f2f0d409f6bf608$export$2e2bcd8739ae039.displayName = 'tremor';
$9f2f0d409f6bf608$export$2e2bcd8739ae039.aliases = [
    'trickle',
    'troy'
];
function $9f2f0d409f6bf608$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        Prism.languages.tremor = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
                lookbehind: true
            },
            'interpolated-string': null,
            // see below
            extractor: {
                pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
                greedy: true,
                inside: {
                    regex: {
                        pattern: /(^re)\|[\s\S]+/,
                        lookbehind: true
                    },
                    function: /^\w+/,
                    value: /\|[\s\S]+/
                }
            },
            identifier: {
                pattern: /`[^`]*`/,
                greedy: true
            },
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
            keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
            boolean: /\b(?:false|null|true)\b/i,
            number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
            'pattern-punctuation': {
                pattern: /%(?=[({[])/,
                alias: 'punctuation'
            },
            operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
            punctuation: /::|[;\[\]()\{\},.:]/
        };
        var interpolationPattern = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
        Prism.languages.tremor['interpolated-string'] = {
            pattern: RegExp(/(^|[^\\])/.source + '(?:' + '"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + '|' + interpolationPattern + ')*"""' + '|' + '"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + '|' + interpolationPattern + ')*"' + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    inside: {
                        punctuation: /^#\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.tremor
                        }
                    }
                },
                string: /[\s\S]+/
            }
        };
        Prism.languages.troy = Prism.languages['tremor'];
        Prism.languages.trickle = Prism.languages['tremor'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $91f9e56f191bfd66$export$2e2bcd8739ae039.displayName = 'typoscript';
$91f9e56f191bfd66$export$2e2bcd8739ae039.aliases = [
    'tsconfig'
];
function $91f9e56f191bfd66$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var keywords = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
        Prism.languages.typoscript = {
            comment: [
                {
                    // multiline comments /* */
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true
                },
                {
                    // double-slash comments - ignored when backslashes or colon is found in front
                    // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
                    pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // hash comments - ignored when leading quote is found for hex colors in strings
                    pattern: /(^|[^"'])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            function: [
                {
                    // old include style
                    pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
                    inside: {
                        string: {
                            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                            inside: {
                                keyword: keywords
                            }
                        },
                        keyword: {
                            pattern: /INCLUDE_TYPOSCRIPT/
                        }
                    }
                },
                {
                    // new include style
                    pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
                    inside: {
                        string: /"[^"\r\n]*"|'[^'\r\n]*'/
                    }
                }
            ],
            string: {
                pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
                lookbehind: true,
                inside: {
                    function: /\{\$.*\}/,
                    // constants include
                    keyword: keywords,
                    number: /^\d+$/,
                    punctuation: /[,|:]/
                }
            },
            keyword: keywords,
            number: {
                // special highlighting for indexes of arrays in tags
                pattern: /\b\d+\s*[.{=]/,
                inside: {
                    operator: /[.{=]/
                }
            },
            tag: {
                pattern: /\.?[-\w\\]+\.?/,
                inside: {
                    punctuation: /\./
                }
            },
            punctuation: /[{}[\];(),.:|]/,
            operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
        };
        Prism.languages.tsconfig = Prism.languages.typoscript;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d826ce7b7a227512$export$2e2bcd8739ae039.displayName = 'unrealscript';
$d826ce7b7a227512$export$2e2bcd8739ae039.aliases = [
    'uc',
    'uscript'
];
function $d826ce7b7a227512$export$2e2bcd8739ae039(Prism) {
    Prism.languages.unrealscript = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        category: {
            pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        metadata: {
            pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
            lookbehind: true,
            greedy: true,
            inside: {
                property: /\b\w+(?=\s*=)/,
                operator: /=/,
                punctuation: /[<>|]/
            }
        },
        macro: {
            pattern: /`\w+/,
            alias: 'property'
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
        operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
        punctuation: /[()[\]{};,.]/
    };
    Prism.languages.uc = Prism.languages.uscript = Prism.languages.unrealscript;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $e2afbfabfe840b99$export$2e2bcd8739ae039.displayName = 'uorazor';
$e2afbfabfe840b99$export$2e2bcd8739ae039.aliases = [];
function $e2afbfabfe840b99$export$2e2bcd8739ae039(Prism) {
    Prism.languages.uorazor = {
        'comment-hash': {
            pattern: /#.*/,
            alias: 'comment',
            greedy: true
        },
        'comment-slash': {
            pattern: /\/\/.*/,
            alias: 'comment',
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            },
            greedy: true
        },
        'source-layers': {
            pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
            alias: 'function'
        },
        'source-commands': {
            pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
            alias: 'function'
        },
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
        keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$8548b6b81abd0793$export$2e2bcd8739ae039.displayName = 'v';
$8548b6b81abd0793$export$2e2bcd8739ae039.aliases = [];
function $8548b6b81abd0793$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    (function(Prism) {
        var interpolationExpr = {
            pattern: /[\s\S]+/,
            inside: null
        };
        Prism.languages.v = Prism.languages.extend('clike', {
            string: {
                pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                alias: 'quoted-string',
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
                        lookbehind: true,
                        inside: {
                            'interpolation-variable': {
                                pattern: /^\$\w[\s\S]*$/,
                                alias: 'variable'
                            },
                            'interpolation-punctuation': {
                                pattern: /^\$\{|\}$/,
                                alias: 'punctuation'
                            },
                            'interpolation-expression': interpolationExpr
                        }
                    }
                }
            },
            'class-name': {
                pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
                lookbehind: true
            },
            keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
            number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
            operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
            builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
        });
        interpolationExpr.inside = Prism.languages.v;
        Prism.languages.insertBefore('v', 'string', {
            char: {
                pattern: /`(?:\\`|\\?[^`]{1,2})`/,
                // using {1,2} instead of `u` flag for compatibility
                alias: 'rune'
            }
        });
        Prism.languages.insertBefore('v', 'operator', {
            attribute: {
                pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
                lookbehind: true,
                alias: 'annotation',
                inside: {
                    punctuation: /[\[\]]/,
                    keyword: /\w+/
                }
            },
            generic: {
                pattern: /<\w+>(?=\s*[\)\{])/,
                inside: {
                    punctuation: /[<>]/,
                    'class-name': /\w+/
                }
            }
        });
        Prism.languages.insertBefore('v', 'function', {
            'generic-function': {
                // e.g. foo<T>( ...
                pattern: /\b\w+\s*<\w+>(?=\()/,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<\w+>/,
                        inside: Prism.languages.v.generic.inside
                    }
                }
            }
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$9abdb5de274a074a$export$2e2bcd8739ae039.displayName = 'vala';
$9abdb5de274a074a$export$2e2bcd8739ae039.aliases = [];
function $9abdb5de274a074a$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
    Prism.languages.vala = Prism.languages.extend('clike', {
        // Classes copied from prism-csharp
        'class-name': [
            {
                // (Foo bar, Bar baz)
                pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // [Foo]
                pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo : Bar
                pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo
                pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        ],
        keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
        function: /\b\w+(?=\s*\()/,
        number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
        punctuation: /[{}[\];(),.:]/,
        constant: /\b[A-Z0-9_]+\b/
    });
    Prism.languages.insertBefore('vala', 'string', {
        'raw-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        'template-string': {
            pattern: /@"[\s\S]*?"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
                    inside: {
                        delimiter: {
                            pattern: /^\$\(?|\)$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.vala
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('vala', 'keyword', {
        regex: {
            pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\//,
                'regex-flags': /^[a-z]+$/
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$394ba7ef97b97b86$export$2e2bcd8739ae039.displayName = 'velocity';
$394ba7ef97b97b86$export$2e2bcd8739ae039.aliases = [];
function $394ba7ef97b97b86$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.velocity = Prism.languages.extend('markup', {});
        var velocity = {
            variable: {
                pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
                lookbehind: true,
                inside: {} // See below
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            number: /\b\d+\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
            punctuation: /[(){}[\]:,.]/
        };
        velocity.variable.inside = {
            string: velocity['string'],
            function: {
                pattern: /([^\w-])[a-z][\w-]*(?=\()/,
                lookbehind: true
            },
            number: velocity['number'],
            boolean: velocity['boolean'],
            punctuation: velocity['punctuation']
        };
        Prism.languages.insertBefore('velocity', 'comment', {
            unparsed: {
                pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^#\[\[|\]\]#$/
                }
            },
            'velocity-comment': [
                {
                    pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                },
                {
                    pattern: /(^|[^\\])##.*/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                }
            ],
            directive: {
                pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
                        inside: {
                            punctuation: /[{}]/
                        }
                    },
                    rest: velocity
                }
            },
            variable: velocity['variable']
        });
        Prism.languages.velocity['tag'].inside['attr-value'].inside.rest = Prism.languages.velocity;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $8dca4130d69058ac$export$2e2bcd8739ae039.displayName = 'verilog';
$8dca4130d69058ac$export$2e2bcd8739ae039.aliases = [];
function $8dca4130d69058ac$export$2e2bcd8739ae039(Prism) {
    Prism.languages.verilog = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'kernel-function': {
            // support for any kernel function (ex: $display())
            pattern: /\B\$\w+\b/,
            alias: 'property'
        },
        // support for user defined constants (ex: `define)
        constant: /\B`\w+\b/,
        function: /\b\w+(?=\()/,
        // support for verilog and system verilog keywords
        keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
        // bold highlighting for all verilog and system verilog logic blocks
        important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
        // support for time ticks, vectors, and real numbers
        number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
        operator: /[-+{}^~%*\/?=!<>&|]+/,
        punctuation: /[[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $78709f9d0e4b9c6d$export$2e2bcd8739ae039.displayName = 'vhdl';
$78709f9d0e4b9c6d$export$2e2bcd8739ae039.aliases = [];
function $78709f9d0e4b9c6d$export$2e2bcd8739ae039(Prism) {
    Prism.languages.vhdl = {
        comment: /--.+/,
        // support for all logic vectors
        'vhdl-vectors': {
            pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
            alias: 'number'
        },
        // support for operator overloading included
        'quoted-function': {
            pattern: /"\S+?"(?=\()/,
            alias: 'function'
        },
        string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
        attribute: {
            pattern: /\b'\w+/,
            alias: 'attr-name'
        },
        // support for predefined attributes included
        keyword: /\b(?:access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|private|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|view|wait|when|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\w+(?=\()/,
        // decimal, based, physical, and exponential numbers supported
        number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
        operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
        punctuation: /[{}[\];(),.:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5c60e6cfdf15df7c$export$2e2bcd8739ae039.displayName = 'vim';
$5c60e6cfdf15df7c$export$2e2bcd8739ae039.aliases = [];
function $5c60e6cfdf15df7c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.vim = {
        string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
        comment: /".*/,
        function: /\b\w+(?=\()/,
        keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
        builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
        punctuation: /[{}[\](),;:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $d075f5ceed0fcf6d$export$2e2bcd8739ae039.displayName = 'visual-basic';
$d075f5ceed0fcf6d$export$2e2bcd8739ae039.aliases = [
    'vb',
    'vba'
];
function $d075f5ceed0fcf6d$export$2e2bcd8739ae039(Prism) {
    Prism.languages['visual-basic'] = {
        comment: {
            pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
            inside: {
                keyword: /^REM/i
            }
        },
        directive: {
            pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
            alias: 'property',
            greedy: true
        },
        string: {
            pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
            greedy: true
        },
        date: {
            pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
            alias: 'number'
        },
        number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
        boolean: /\b(?:False|Nothing|True)\b/i,
        keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
        operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
        punctuation: /[{}().,:?]/
    };
    Prism.languages.vb = Prism.languages['visual-basic'];
    Prism.languages.vba = Prism.languages['visual-basic'];
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $444f169e3cccac30$export$2e2bcd8739ae039.displayName = 'warpscript';
$444f169e3cccac30$export$2e2bcd8739ae039.aliases = [];
function $444f169e3cccac30$export$2e2bcd8739ae039(Prism) {
    Prism.languages.warpscript = {
        comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
            greedy: true
        },
        variable: /\$\S+/,
        macro: {
            pattern: /@\S+/,
            alias: 'property'
        },
        // WarpScript doesn't have any keywords, these are all functions under the control category
        // https://www.warp10.io/tags/control
        keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
        number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
        boolean: /\b(?:F|T|false|true)\b/,
        punctuation: /<%|%>|[{}[\]()]/,
        // Some operators from the "operators" category
        // https://www.warp10.io/tags/operators
        operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $984388475bc1f82c$export$2e2bcd8739ae039.displayName = 'wasm';
$984388475bc1f82c$export$2e2bcd8739ae039.aliases = [];
function $984388475bc1f82c$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wasm = {
        comment: [
            /\(;[\s\S]*?;\)/,
            {
                pattern: /;;.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /"(?:\\[\s\S]|[^"\\])*"/,
            greedy: true
        },
        keyword: [
            {
                pattern: /\b(?:align|offset)=/,
                inside: {
                    operator: /=/
                }
            },
            {
                pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
                inside: {
                    punctuation: /\./
                }
            },
            /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
        ],
        variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
        number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
        punctuation: /[()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $4b9a37daa1a6bfeb$export$2e2bcd8739ae039.displayName = 'web-idl';
$4b9a37daa1a6bfeb$export$2e2bcd8739ae039.aliases = [
    'webidl'
];
function $4b9a37daa1a6bfeb$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        var id = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source;
        var type = '(?:' + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + '|' + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + '|' + /(?!(?:unrestricted|unsigned)\b)/.source + id + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ')' + /(?:\s*\?)?/.source;
        var typeInside = {};
        Prism.languages['web-idl'] = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            namespace: {
                pattern: RegExp(/(\bnamespace\s+)/.source + id),
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // callback return type
                    pattern: RegExp('(' + /\bcallback\s+/.source + id + /\s*=\s*/.source + ')' + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // typedef
                    pattern: RegExp(/(\btypedef\b\s*)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + id),
                    lookbehind: true
                },
                {
                    // inheritance
                    pattern: RegExp(/(:\s*)/.source + id),
                    lookbehind: true
                },
                // includes and implements
                RegExp(id + /(?=\s+(?:implements|includes)\b)/.source),
                {
                    pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + id),
                    lookbehind: true
                },
                {
                    // function return type, parameter types, and dictionary members
                    pattern: RegExp(type + '(?=' + /\s*(?:\.{3}\s*)?/.source + id + /\s*[(),;=]/.source + ')'),
                    inside: typeInside
                }
            ],
            builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
            keyword: [
                /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
                // type keywords
                /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
            ],
            boolean: /\b(?:false|true)\b/,
            number: {
                pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
                lookbehind: true
            },
            operator: /\.{3}|[=:?<>-]/,
            punctuation: /[(){}[\].,;]/
        };
        for(var key in Prism.languages['web-idl'])if (key !== 'class-name') typeInside[key] = Prism.languages['web-idl'][key];
        Prism.languages['webidl'] = Prism.languages['web-idl'];
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $1250691c3af59f56$export$2e2bcd8739ae039.displayName = 'wgsl';
$1250691c3af59f56$export$2e2bcd8739ae039.aliases = [];
function $1250691c3af59f56$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wgsl = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        'builtin-attribute': {
            pattern: /(@)builtin\(.*?\)/,
            lookbehind: true,
            inside: {
                attribute: {
                    pattern: /^builtin/,
                    alias: 'attr-name'
                },
                punctuation: /[(),]/,
                'built-in-values': {
                    pattern: /\b(?:frag_depth|front_facing|global_invocation_id|instance_index|local_invocation_id|local_invocation_index|num_workgroups|position|sample_index|sample_mask|vertex_index|workgroup_id)\b/,
                    alias: 'attr-value'
                }
            }
        },
        attributes: {
            pattern: /(@)(?:align|binding|compute|const|fragment|group|id|interpolate|invariant|location|size|vertex|workgroup_size)/i,
            lookbehind: true,
            alias: 'attr-name'
        },
        functions: {
            pattern: /\b(fn\s+)[_a-zA-Z]\w*(?=[(<])/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:bitcast|break|case|const|continue|continuing|default|discard|else|enable|fallthrough|fn|for|function|if|let|loop|private|return|storage|struct|switch|type|uniform|var|while|workgroup)\b/,
        builtin: /\b(?:abs|acos|acosh|all|any|array|asin|asinh|atan|atan2|atanh|atomic|atomicAdd|atomicAnd|atomicCompareExchangeWeak|atomicExchange|atomicLoad|atomicMax|atomicMin|atomicOr|atomicStore|atomicSub|atomicXor|bool|ceil|clamp|cos|cosh|countLeadingZeros|countOneBits|countTrailingZeros|cross|degrees|determinant|distance|dot|dpdx|dpdxCoarse|dpdxFine|dpdy|dpdyCoarse|dpdyFine|exp|exp2|extractBits|f32|f64|faceForward|firstLeadingBit|floor|fma|fract|frexp|fwidth|fwidthCoarse|fwidthFine|i32|i64|insertBits|inverseSqrt|ldexp|length|log|log2|mat[2-4]x[2-4]|max|min|mix|modf|normalize|override|pack2x16float|pack2x16snorm|pack2x16unorm|pack4x8snorm|pack4x8unorm|pow|ptr|quantizeToF16|radians|reflect|refract|reverseBits|round|sampler|sampler_comparison|select|shiftLeft|shiftRight|sign|sin|sinh|smoothstep|sqrt|staticAssert|step|storageBarrier|tan|tanh|textureDimensions|textureGather|textureGatherCompare|textureLoad|textureNumLayers|textureNumLevels|textureNumSamples|textureSample|textureSampleBias|textureSampleCompare|textureSampleCompareLevel|textureSampleGrad|textureSampleLevel|textureStore|texture_1d|texture_2d|texture_2d_array|texture_3d|texture_cube|texture_cube_array|texture_depth_2d|texture_depth_2d_array|texture_depth_cube|texture_depth_cube_array|texture_depth_multisampled_2d|texture_multisampled_2d|texture_storage_1d|texture_storage_2d|texture_storage_2d_array|texture_storage_3d|transpose|trunc|u32|u64|unpack2x16float|unpack2x16snorm|unpack2x16unorm|unpack4x8snorm|unpack4x8unorm|vec[2-4]|workgroupBarrier)\b/,
        'function-calls': {
            pattern: /\b[_a-z]\w*(?=\()/i,
            alias: 'function'
        },
        'class-name': /\b(?:[A-Z][A-Za-z0-9]*)\b/,
        'bool-literal': {
            pattern: /\b(?:false|true)\b/,
            alias: 'boolean'
        },
        'hex-int-literal': {
            pattern: /\b0[xX][0-9a-fA-F]+[iu]?\b(?![.pP])/,
            alias: 'number'
        },
        'hex-float-literal': {
            pattern: /\b0[xX][0-9a-fA-F]*(?:\.[0-9a-fA-F]*)?(?:[pP][+-]?\d+[fh]?)?/,
            alias: 'number'
        },
        'decimal-float-literal': [
            {
                pattern: /\d*\.\d+(?:[eE](?:\+|-)?\d+)?[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\d+\.\d*(?:[eE](?:\+|-)?\d+)?[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\d+[eE](?:\+|-)?\d+[fh]?/,
                alias: 'number'
            },
            {
                pattern: /\b\d+[fh]\b/,
                alias: 'number'
            }
        ],
        'int-literal': {
            pattern: /\b\d+[iu]?\b/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /(?:\^|~|\|(?!\|)|\|\||&&|<<|>>|!)(?!=)/
            },
            {
                pattern: /&(?![&=])/
            },
            {
                pattern: /(?:\+=|-=|\*=|\/=|%=|\^=|&=|\|=|<<=|>>=)/
            },
            {
                pattern: /(^|[^<>=!])=(?![=>])/,
                lookbehind: true
            },
            {
                pattern: /(?:==|!=|<=|\+\+|--|(^|[^=])>=)/,
                lookbehind: true
            },
            {
                pattern: /(?:(?:[+%]|(?:\*(?!\w)))(?!=))|(?:-(?!>))|(?:\/(?!\/))/
            },
            {
                pattern: /->/
            }
        ],
        punctuation: /[@(){}[\],;<>:.]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$0490df0a3775e5e5$export$2e2bcd8739ae039.displayName = 'wiki';
$0490df0a3775e5e5$export$2e2bcd8739ae039.aliases = [];
function $0490df0a3775e5e5$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    Prism.languages.wiki = Prism.languages.extend('markup', {
        'block-comment': {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: true,
            alias: 'comment'
        },
        heading: {
            pattern: /^(=+)[^=\r\n].*?\1/m,
            inside: {
                punctuation: /^=+|=+$/,
                important: /.+/
            }
        },
        emphasis: {
            // TODO Multi-line
            pattern: /('{2,5}).+?\1/,
            inside: {
                'bold-italic': {
                    pattern: /(''''').+?(?=\1)/,
                    lookbehind: true,
                    alias: [
                        'bold',
                        'italic'
                    ]
                },
                bold: {
                    pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                italic: {
                    pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                punctuation: /^''+|''+$/
            }
        },
        hr: {
            pattern: /^-{4,}/m,
            alias: 'punctuation'
        },
        url: [
            /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
            /\[\[.+?\]\]|\[.+?\]/
        ],
        variable: [
            /__[A-Z]+__/,
            // FIXME Nested structures should be handled
            // {{formatnum:{{#expr:{{{3}}}}}}}
            /\{{3}.+?\}{3}/,
            /\{\{.+?\}\}/
        ],
        symbol: [
            /^#redirect/im,
            /~{3,5}/
        ],
        // Handle table attrs:
        // {|
        // ! style="text-align:left;"| Item
        // |}
        'table-tag': {
            pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
            lookbehind: true,
            inside: {
                'table-bar': {
                    pattern: /\|$/,
                    alias: 'punctuation'
                },
                rest: Prism.languages.markup['tag'].inside
            }
        },
        punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    });
    Prism.languages.insertBefore('wiki', 'tag', {
        // Prevent highlighting inside <nowiki>, <source> and <pre> tags
        nowiki: {
            pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
            inside: {
                tag: {
                    pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
                    inside: Prism.languages.markup['tag'].inside
                }
            }
        }
    });
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2e21c917ded61f76$export$2e2bcd8739ae039.displayName = 'wolfram';
$2e21c917ded61f76$export$2e2bcd8739ae039.aliases = [
    'mathematica',
    'nb',
    'wl'
];
function $2e21c917ded61f76$export$2e2bcd8739ae039(Prism) {
    Prism.languages.wolfram = {
        comment: // Allow one level of nesting - note: regex taken from applescipt
        /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
        context: {
            pattern: /\b\w+`+\w*/,
            alias: 'class-name'
        },
        blank: {
            pattern: /\b\w+_\b/,
            alias: 'regex'
        },
        'global-variable': {
            pattern: /\$\w+/,
            alias: 'variable'
        },
        boolean: /\b(?:False|True)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
        operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.mathematica = Prism.languages.wolfram;
    Prism.languages.wl = Prism.languages.wolfram;
    Prism.languages.nb = Prism.languages.wolfram;
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $7b93185b733a6630$export$2e2bcd8739ae039.displayName = 'wren';
$7b93185b733a6630$export$2e2bcd8739ae039.aliases = [];
function $7b93185b733a6630$export$2e2bcd8739ae039(Prism) {
    // https://wren.io/
    Prism.languages.wren = {
        // Multiline comments in Wren can have nested multiline comments
        // Comments: // and /* */
        comment: [
            {
                // support 3 levels of nesting
                // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
                pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        // Triple quoted strings are multiline but cannot have interpolation (raw strings)
        // Based on prism-python.js
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        // see below
        'string-literal': null,
        // #!/usr/bin/env wren on the first line
        hashbang: {
            pattern: /^#!\/.+/,
            greedy: true,
            alias: 'comment'
        },
        // Attributes are special keywords to add meta data to classes
        attribute: {
            // #! attributes are stored in class properties
            // #!myvar = true
            // #attributes are not stored and dismissed at compilation
            pattern: /#!?[ \t\u3000]*\w+/,
            alias: 'keyword'
        },
        'class-name': [
            {
                // class definition
                // class Meta {}
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            // A class must always start with an uppercase.
            // File.read
            /\b[A-Z][a-z\d_]*\b/
        ],
        // A constant can be a variable, class, property or method. Just named in all uppercase letters
        constant: /\b[A-Z][A-Z\d_]*\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        // Functions can be Class.method()
        function: /\b[a-z_]\w*(?=\s*[({])/i,
        operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
        punctuation: /[\[\](){}.,;]/
    };
    Prism.languages.wren['string-literal'] = {
        // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
        pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
        lookbehind: true,
        greedy: true,
        inside: {
            interpolation: {
                // "%(interpolation)"
                pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /^(%\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: Prism.languages.wren
                    },
                    'interpolation-punctuation': {
                        pattern: /^%\(|\)$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: /[\s\S]+/
        }
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$ac40ec14cecb0ed3$export$2e2bcd8739ae039.displayName = 'xeora';
$ac40ec14cecb0ed3$export$2e2bcd8739ae039.aliases = [
    'xeoracube'
];
function $ac40ec14cecb0ed3$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.xeora = Prism.languages.extend('markup', {
            constant: {
                pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
                inside: {
                    punctuation: {
                        pattern: /\$/
                    }
                }
            },
            variable: {
                pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[$.]/
                    },
                    operator: {
                        pattern: /#+|[-+*~=^@]/
                    }
                }
            },
            'function-inline': {
                pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
                inside: {
                    variable: {
                        pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
                        inside: {
                            punctuation: {
                                pattern: /[,.|]/
                            },
                            operator: {
                                pattern: /#+|[-+*~=^@]/
                            }
                        }
                    },
                    punctuation: {
                        pattern: /\$\w:|[$:?.,|]/
                    }
                },
                alias: 'function'
            },
            'function-block': {
                pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
                inside: {
                    punctuation: {
                        pattern: /[$:{}?.,|]/
                    }
                },
                alias: 'function'
            },
            'directive-inline': {
                pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    }
                },
                alias: 'function'
            },
            'directive-block-open': {
                pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    },
                    attribute: {
                        pattern: /![A-Z]+$/,
                        inside: {
                            punctuation: {
                                pattern: /!/
                            }
                        },
                        alias: 'keyword'
                    }
                },
                alias: 'function'
            },
            'directive-block-separator': {
                pattern: /\}:[-\w.]+:\{/,
                inside: {
                    punctuation: {
                        pattern: /[:{}]/
                    }
                },
                alias: 'function'
            },
            'directive-block-close': {
                pattern: /\}:[-\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[:{}$]/
                    }
                },
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            variable: Prism.languages.xeora['function-inline'].inside['variable']
        }, Prism.languages.xeora['function-block']);
        Prism.languages.xeoracube = Prism.languages.xeora;
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$6eb420716c757ee1$export$2e2bcd8739ae039.displayName = 'xml-doc';
$6eb420716c757ee1$export$2e2bcd8739ae039.aliases = [];
function $6eb420716c757ee1$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        /**
     * If the given language is present, it will insert the given doc comment grammar token into it.
     *
     * @param {string} lang
     * @param {any} docComment
     */ function insertDocComment(lang, docComment) {
            if (Prism.languages[lang]) Prism.languages.insertBefore(lang, 'comment', {
                'doc-comment': docComment
            });
        }
        var tag = Prism.languages.markup.tag;
        var slashDocComment = {
            pattern: /\/\/\/.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        var tickDocComment = {
            pattern: /'''.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        insertDocComment('csharp', slashDocComment);
        insertDocComment('fsharp', slashDocComment);
        insertDocComment('vbnet', tickDocComment);
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $5c705af3a8380551$export$2e2bcd8739ae039.displayName = 'xojo';
$5c705af3a8380551$export$2e2bcd8739ae039.aliases = [];
function $5c705af3a8380551$export$2e2bcd8739ae039(Prism) {
    Prism.languages.xojo = {
        comment: {
            pattern: /(?:'|\/\/|Rem\b).+/i,
            greedy: true
        },
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        number: [
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            /&[bchou][a-z\d]+/i
        ],
        directive: {
            pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
            alias: 'property'
        },
        keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
        operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
        punctuation: /[.,;:()]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ 
$794a60f48b235257$export$2e2bcd8739ae039.displayName = 'xquery';
$794a60f48b235257$export$2e2bcd8739ae039.aliases = [];
function $794a60f48b235257$export$2e2bcd8739ae039(Prism) {
    Prism.register((0, $f47682e33a093951$export$2e2bcd8739ae039));
    (function(Prism) {
        Prism.languages.xquery = Prism.languages.extend('markup', {
            'xquery-comment': {
                pattern: /\(:[\s\S]*?:\)/,
                greedy: true,
                alias: 'comment'
            },
            string: {
                pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
                greedy: true
            },
            extension: {
                pattern: /\(#.+?#\)/,
                alias: 'symbol'
            },
            variable: /\$[-\w:]+/,
            axis: {
                pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
                lookbehind: true,
                alias: 'operator'
            },
            'keyword-operator': {
                pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
                lookbehind: true,
                alias: 'operator'
            },
            keyword: {
                pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
                lookbehind: true
            },
            function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
            'xquery-element': {
                pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'tag'
            },
            'xquery-attribute': {
                pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'attr-name'
            },
            builtin: {
                pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
                lookbehind: true
            },
            number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
            operator: [
                /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
                {
                    pattern: /(\s)-(?=\s)/,
                    lookbehind: true
                }
            ],
            punctuation: /[[\](){},;:/]/
        });
        Prism.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
        Prism.languages.xquery['tag'].inside['attr-value'].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['punctuation'] = /^="|"$/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['expression'] = {
            // Allow for two levels of nesting
            pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
            inside: Prism.languages.xquery,
            alias: 'language-xquery'
        };
        // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{' && // Ignore `{{`
                    (!tokens[i + 1] || tokens[i + 1].type !== 'punctuation' || tokens[i + 1].content !== '{') && (!tokens[i - 1] || tokens[i - 1].type !== 'plain-text' || tokens[i - 1].content !== '{')) // Here we might have entered an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else if (token.type !== 'comment') notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside an XQuery expression.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token);
                        // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        if (/^\s+$/.test(plainText)) tokens[i] = plainText;
                        else tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'xquery') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $3fd6a28a1bc887ad$export$2e2bcd8739ae039.displayName = 'yang';
$3fd6a28a1bc887ad$export$2e2bcd8739ae039.aliases = [];
function $3fd6a28a1bc887ad$export$2e2bcd8739ae039(Prism) {
    Prism.languages.yang = {
        // https://tools.ietf.org/html/rfc6020#page-34
        // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
            greedy: true
        },
        keyword: {
            pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
            lookbehind: true
        },
        namespace: {
            pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
            lookbehind: true
        },
        boolean: /\b(?:false|true)\b/,
        operator: /\+/,
        punctuation: /[{};:]/
    };
}


// @ts-nocheck
/**
 * @import {Refractor} from '../lib/core.js'
 */ $2237a96aa7b23da5$export$2e2bcd8739ae039.displayName = 'zig';
$2237a96aa7b23da5$export$2e2bcd8739ae039.aliases = [];
function $2237a96aa7b23da5$export$2e2bcd8739ae039(Prism) {
    (function(Prism) {
        function literal(str) {
            return function() {
                return str;
            };
        }
        var keyword = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/;
        var IDENTIFIER = '\\b(?!' + keyword.source + ')(?!\\d)\\w+\\b';
        var ALIGN = /align\s*\((?:[^()]|\([^()]*\))*\)/.source;
        var PREFIX_TYPE_OP = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(/<ALIGN>/g, literal(ALIGN));
        var SUFFIX_EXPR = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(/<ID>/g, literal(IDENTIFIER));
        var TYPE = '(?!\\s)(?:!?\\s*(?:' + PREFIX_TYPE_OP + '\\s*)*' + SUFFIX_EXPR + ')+';
        /*
     * A simplified grammar for Zig compile time type literals:
     *
     * TypeExpr = ( "!"? PREFIX_TYPE_OP* SUFFIX_EXPR )+
     *
     * SUFFIX_EXPR = ( \b "promise" \b | ( \b "error" "." )? IDENTIFIER ( "." IDENTIFIER )* (?! \s+ IDENTIFIER ) )
     *
     * PREFIX_TYPE_OP = "?"
     *                | \b "promise" "->"
     *                | ( "[" [^\[\]]* "]" | "*" | "**" ) ( ALIGN | "const" \b | "volatile" \b | "allowzero" \b )*
     *
     * ALIGN = "align" "(" ( [^()] | "(" [^()]* ")" )* ")"
     *
     * IDENTIFIER = \b (?! KEYWORD ) [a-zA-Z_] \w* \b
     *
     */ Prism.languages.zig = {
            comment: [
                {
                    pattern: /\/\/[/!].*/,
                    alias: 'doc-comment'
                },
                /\/{2}.*/
            ],
            string: [
                {
                    // "string" and c"string"
                    pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // multiline strings and c-strings
                    pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            char: {
                // characters 'a', '\n', '\xFF', '\u{10FFFF}'
                pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
                lookbehind: true,
                greedy: true
            },
            builtin: /\B@(?!\d)\w+(?=\s*\()/,
            label: {
                pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
                lookbehind: true
            },
            'class-name': [
                // const Foo = struct {};
                /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
                {
                    // const x: i32 = 9;
                    // var x: Bar;
                    // fn foo(x: bool, y: f32) void {}
                    pattern: RegExp(/(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    // extern fn foo(x: f64) f64; (optional alignment)
                    pattern: RegExp(/(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            'builtin-type': {
                pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
                alias: 'keyword'
            },
            keyword: keyword,
            function: /\b(?!\d)\w+(?=\s*\()/,
            number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
            punctuation: /[.:,;(){}[\]]/
        };
        Prism.languages.zig['class-name'].forEach(function(obj) {
            if (obj.inside === null) obj.inside = Prism.languages.zig;
        });
    })(Prism);
}



(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f47682e33a093951$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8467c3aacdff56ee$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eba707d89e6509b5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c029552e57eb42d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7a8c3997a83eed46$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $95ea2c9bcdd7f611$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c4d1e2daa7d84c8b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0a13ac6a7fcf6722$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f7f5127772c5c04e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $64a4add7c0be4a61$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $99775d8f376cb002$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f2801efe566f5e02$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5f9b78712ea78e48$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $eb5bcdfed284c0e2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c25959ac29c21b23$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $34c2ee9c440ac9ed$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $16c57dd521f1a867$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d761452eb924cd1c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f4e156ae6ed8d0a0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b373cdd06f88d58c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4fe2e947cede365f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $46893c7fe39cde19$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $13f495791853dbf3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8bc35bfd2be6822a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1da2260b608e55ec$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ee5893254ac9a415$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $93cf65ee58a98ba9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $825a50f0352eefcc$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $803928922a6961a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ae7a5bea34c537e5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bd73346734ce1e3f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $75d197dead828344$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6fdeaba363e1867b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b9409e2dd4b1f152$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5a70a1b33a6cef7a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fde5bd5d73cb6997$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c23e2e2dfd81122c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b245c95193e08d8c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f1ff25d1ebcd6cac$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $92013590b857bd88$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d4e3d605b49454d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $26acd6c806290335$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e9431566d3fac7dd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c084f125db8708f6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8798e67056712316$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $604e26785f89d2b2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $69bb850a8bbe91f4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0d5ca126f659299e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $beb46e0ab65e7d5b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $daeaab3980ca96e4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $84399bc3f59b1c8b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $56a51c0494ec22f0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8ec1bae033ed476d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fa97cf30362824f8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $aad082cba5464279$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $77fe7b80ef861b40$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $53052fb9d74303db$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f86df18bcfea9f70$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f4e95d0947d511df$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1f6beaffa93c6e28$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1fe20ac82cecf3eb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $debd1f6308a90423$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e8643cf3d5f78f91$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0814f5761e025965$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4f8b5c37b37db49e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a0274c81b19638e1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $732efa98354ef152$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4c72dd9423c79b65$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4849b6a31c9f2c50$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d96e6553b79e688e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $74043824b764ef3e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a2a3ecd8671a9cb9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $456d34d6a0e808d3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $09fb00aefac0036e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dab2950de0f638d9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $11b4f9d2b497fd4f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $713fb0d437182828$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9df90d7c45567ff9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6bf0eb89a36e65a0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9be5e6824314caae$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $582d3cacea24a910$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5b71468010bc72da$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $05008d3ff07b1f36$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1f738c70877931fd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7290ce53648b43d9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4e7615bc2bd38bf5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $20b8caf8b024dc15$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $24261424b318a546$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $81a7c5742f763317$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $645d653be7f1e246$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23b4532be12400bd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $03636fbb6bcf9de6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d1ff02eb2618944d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0690cd6d0a840968$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b30f7170c1780bbb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $589c0bdcaa161eef$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1f14745690836bca$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c4bd90163a636571$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d04717890a46cf2e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $79b0be010e76d7ca$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3ad1242016c38065$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $675c24a063f84cbd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b7509ddd058c90d0$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ec3042630860b388$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e41ae20b134c7e19$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b8a98b0ff64a5cd4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a9f5bac9ba5085d8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5bfce00dfe9edf4d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $47dfe45f952c98c2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1c0f2e453947e61a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9f945d890adcf850$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cd8c18afbde31359$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c77c0e4272178579$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bb09ab25dfcbb114$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f3a5ce20fdab9e50$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $621160e6c15c3eff$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9c25dab359558e3e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2590b32a10d9ecc8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $abb136260c600497$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2ae70ee16ca48837$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1ba73c5509e75af1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $50cc4f59c8b2da7b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e2e7d35f13665654$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e34b34b543223ef4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $669817df648224fc$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6c6957e69ba93803$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7ca1ade36c00114f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6583f09ac504dc32$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $df4a8f4049b5c047$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dae26b846c274399$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7f7ed36c71460d27$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $01d5a9ee0f18d738$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3c79c65302ac0671$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $de2f160c2fe3453a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2575e451a3a1df7f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $197381b2d5f39c0b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0b6b8e959651c37f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cd93a27b452b7c48$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $49817f5fa65142f2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8a2c8b738cd1f636$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $27318f6b523d68d5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $46a0b7b965a829bf$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $988c0ef2629271f3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cb363a9e19005aae$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $49ed9aeb5a3777c3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23ae979d55503543$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8f95bc848ace76c7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b338b4b197bcd1b4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $010d7940936c67fb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bf3c2cf9e7b7e15b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a236d89746bc105c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $964a8a24221af55b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1ea37e5c47d5707d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $94086998b35689c5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5b076416d0eabdf4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cfc1afd3507a91b5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $350499ec8fbf9130$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d1947654b0468835$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $edb8a8bbc6c61935$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5796ea4f5c719733$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c3d8d532e557e2f4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f13c2598f5dc8663$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c8196ec3df0cee5b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f15bc5f7f9ab760a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dff85ed6bfabe21a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0ebb485d13184e81$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $59e22f64646db583$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fb1869ae2e02698d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b6a0f971cc211856$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0ce2bbca25db411c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $55c84b5f47c86788$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9513a6857dddaa7a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $23da19d9f15297a4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7306ed74be230ce9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0032d605afbc43b2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ff984944cd41b96b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $aee6b2f66d7ac757$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a4448d0866560d14$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8d3fa3f18bccf1b2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fce09911b128bdb6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3350c1fbd5ca8b13$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5c87aab191bc72fd$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0efdb6c99f3f7c98$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0c54d82c2339cc9c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $dd0a8f9cf86863f1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6be9a541d67ded55$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $436bbebbe3139e7e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b0c7b814ccf677f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $937b72076b7797c7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $93be80b0f58505d4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $833f205419d7e6ea$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f6e28ce82e52815a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a71447da60e1f6e1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $846ab470db2ff869$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $db79ad093bda0678$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4ed009a5750aab51$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2aa93c3806b01798$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6a65d32501c7d08f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8ed4b18f31ffd000$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5e75362810025a55$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5233df02eb9ce262$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b2343da39e8ef130$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $677549b6ac647aae$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $deb4ca581bc1f27a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5d2497dd4e3ab655$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b3fd195950a9be7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $380e029e8a782237$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1e6f9251c3a754c6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $83967affbf32d3d2$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b8eebe66b02f0b09$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ee0a699affb8796e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $bb80e878636bd8f6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $07c52e9b9a88ab06$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b43974aae9bb9664$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $37e5b1709464e513$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b50fa11ce89925a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5ac9473b450a64ab$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e427246b711a2509$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $295e7fe9e01d0862$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $48a2ee38b0d45f1e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9d032faa85d6103d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f0ce0a61b7257e87$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d402b3c4cd63a644$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a42852126578ac8f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $75c09846dd2bbd2b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4c79b618a588b28d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3b64cc26a0bd267e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2651f31c4a94c2f1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2ba51d01e535556e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f20909d17a339405$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $781e96ef45d1066d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2def36300150cc17$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $be3f5e01c2434719$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0636642bf7a5dca9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1100e9295cc7554a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ad8d5c52e7714ea6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c4f30d48e56845b8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $32c58ead3c55b79c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $50e3d013937d7b07$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $c37f7ecb6b24967e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9e1e815b43dfcf12$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e01299bf75eda32d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $37dde9971f145ea3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $27d87a17c8c1aaf3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $390e344e43dfbcde$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d4804f7e613d614f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $730f9a4b12501d43$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0ef3d1ceb8394e5c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $feeef9c3da6c04de$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $a0deafd0233b5617$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1aa991af509c7894$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3a1367f4db4eb9c1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3f3dc76a1a6f0313$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b8f98fbb364b5fe$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $013d5fc882b5f308$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $803656f9da2f54a6$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $fbdec31c6df2c19f$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $12d6f3ddfd59c8f8$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d0722eb1de37ae4c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d11fe3812b565e9e$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $b9bd6ce061e8b23b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9f8d1abaebbe1e7b$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $352108f0900288bc$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $10278687c497f16d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $f6357e1d35f66b04$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $cf1be131e0fce4fa$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $059ad53228ded3c9$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $74f53190c8211cce$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0acbc38df3a79135$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3b31713a87a8de6a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $735a787ca1f7aae4$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $38e9da697ee0f6f7$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $00d1fd220eb25cf1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9f2f0d409f6bf608$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $91f9e56f191bfd66$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d826ce7b7a227512$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $e2afbfabfe840b99$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8548b6b81abd0793$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $9abdb5de274a074a$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $394ba7ef97b97b86$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $8dca4130d69058ac$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $78709f9d0e4b9c6d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5c60e6cfdf15df7c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $d075f5ceed0fcf6d$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $444f169e3cccac30$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $984388475bc1f82c$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $4b9a37daa1a6bfeb$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $1250691c3af59f56$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $0490df0a3775e5e5$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2e21c917ded61f76$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $7b93185b733a6630$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $ac40ec14cecb0ed3$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $6eb420716c757ee1$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $5c705af3a8380551$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $794a60f48b235257$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $3fd6a28a1bc887ad$export$2e2bcd8739ae039));
(0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390).register((0, $2237a96aa7b23da5$export$2e2bcd8739ae039));


function $f6a8c10565706ab2$var$a() {
    $f6a8c10565706ab2$var$a = function(e, r) {
        return new t(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap;
    function t(e, n, i) {
        var o = new RegExp(e, n);
        return r.set(o, i || r.get(e)), $f6a8c10565706ab2$var$s(o, t.prototype);
    }
    function n(e, t) {
        var n = r.get(t);
        return Object.keys(n).reduce(function(r, t) {
            var i = n[t];
            if ("number" == typeof i) r[t] = e[i];
            else {
                for(var o = 0; void 0 === e[i[o]] && o + 1 < i.length;)o++;
                r[t] = e[i[o]];
            }
            return r;
        }, Object.create(null));
    }
    return function(e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(r && r.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), r && $f6a8c10565706ab2$var$s(e, r);
    }(t, RegExp), t.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = n(t, this);
            var i = t.indices;
            i && (i.groups = n(i, this));
        }
        return t;
    }, t.prototype[Symbol.replace] = function(t, i) {
        if ("string" == typeof i) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, i.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof i) {
            var a = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(n(e, a)), i.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, i);
    }, $f6a8c10565706ab2$var$a.apply(this, arguments);
}
function $f6a8c10565706ab2$var$s(e, r) {
    return $f6a8c10565706ab2$var$s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, $f6a8c10565706ab2$var$s(e, r);
}
function $f6a8c10565706ab2$var$l(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
    return n;
}
function $f6a8c10565706ab2$var$u(e, r) {
    var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (t) return (t = t.call(e)).next.bind(t);
    if (Array.isArray(e) || (t = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $f6a8c10565706ab2$var$l(e, r);
            var t = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f6a8c10565706ab2$var$l(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var n = 0;
        return function() {
            return n >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[n++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $f6a8c10565706ab2$export$f80b9a7578ac06a = function(i) {
    return function(o) {
        return void 0 === o && (o = {}), function(e, r) {
            if (r && !e.registered(r)) throw new Error('The default language "' + r + '" is not registered with refractor.');
        }(i, o.defaultLanguage), function(r) {
            (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(r, "element", s);
        };
        function s(e, s, l) {
            var c, p;
            if (l && "pre" === l.tagName && "code" === e.tagName) {
                var f = (null == e || null == (c = e.data) ? void 0 : c.meta) || (null == e || null == (p = e.properties) ? void 0 : p.metastring) || "";
                e.properties.className ? "boolean" == typeof e.properties.className ? e.properties.className = [] : Array.isArray(e.properties.className) || (e.properties.className = [
                    e.properties.className
                ]) : e.properties.className = [];
                var m, h, d = function(e) {
                    for(var r, t = $f6a8c10565706ab2$var$u(e.properties.className); !(r = t()).done;){
                        var n = r.value;
                        if ("language-" === n.slice(0, 9)) return n.slice(9).toLowerCase();
                    }
                    return null;
                }(e);
                if (!d && o.defaultLanguage && e.properties.className.push("language-" + (d = o.defaultLanguage)), e.properties.className.push("code-highlight"), d) try {
                    var g, y;
                    y = null != (g = d) && g.includes("diff-") ? d.split("-")[1] : d, m = i.highlight((0, $58714581718e6349$export$f84e8e69fd4488a5)(e), y), l.properties.className = (l.properties.className || []).concat("language-" + y);
                } catch (r) {
                    if (!o.ignoreMissing || !/Unknown language/.test(r.message)) throw r;
                    m = e;
                }
                else m = e;
                m.children = (h = 1, function e(r) {
                    return r.reduce(function(r, t) {
                        if ("text" === t.type) {
                            var n = t.value, i = (n.match(/\n/g) || "").length;
                            if (0 === i) t.position = {
                                start: {
                                    line: h,
                                    column: 1
                                },
                                end: {
                                    line: h,
                                    column: 1
                                }
                            }, r.push(t);
                            else for(var o, a = n.split("\n"), s = $f6a8c10565706ab2$var$u(a.entries()); !(o = s()).done;){
                                var l = o.value, c = l[0], p = l[1];
                                r.push({
                                    type: "text",
                                    value: c === a.length - 1 ? p : p + "\n",
                                    position: {
                                        start: {
                                            line: h + c,
                                            column: 1
                                        },
                                        end: {
                                            line: h + c,
                                            column: 1
                                        }
                                    }
                                });
                            }
                            return h += i, r;
                        }
                        if (Object.prototype.hasOwnProperty.call(t, "children")) {
                            var f = h;
                            return t.children = e(t.children), r.push(t), t.position = {
                                start: {
                                    line: f,
                                    column: 1
                                },
                                end: {
                                    line: h,
                                    column: 1
                                }
                            }, r;
                        }
                        return r.push(t), r;
                    }, []);
                })(m.children), m.position = m.children.length > 0 ? {
                    start: {
                        line: m.children[0].position.start.line,
                        column: 0
                    },
                    end: {
                        line: m.children[m.children.length - 1].position.end.line,
                        column: 0
                    }
                } : {
                    start: {
                        line: 0,
                        column: 0
                    },
                    end: {
                        line: 0,
                        column: 0
                    }
                };
                for(var v, b = function(e) {
                    var r = /{([\d,-]+)}/, t = e.split(",").map(function(e) {
                        return e.trim();
                    }).join();
                    if (r.test(t)) {
                        var i = r.exec(t)[1], o = (0, (/*@__PURE__*/$parcel$interopDefault($97f2cf7466aff99c$exports)))(i);
                        return function(e) {
                            return o.includes(e + 1);
                        };
                    }
                    return function() {
                        return !1;
                    };
                }(f), w = function(e) {
                    var r = /*#__PURE__*/ $f6a8c10565706ab2$var$a(/showLineNumbers=(\d+)/i, {
                        lines: 1
                    });
                    if (r.test(e)) {
                        var t = r.exec(e);
                        return Number(t.groups.lines);
                    }
                    return 1;
                }(f), N = function(e) {
                    for(var r = new Array(e), t = 0; t < e; t++)r[t] = {
                        type: "element",
                        tagName: "span",
                        properties: {
                            className: []
                        },
                        children: []
                    };
                    return r;
                }(m.position.end.line), j = [
                    "showlinenumbers=false",
                    'showlinenumbers="false"',
                    "showlinenumbers={false}"
                ], x = function() {
                    var e, n, i = v.value, a = i[0], s = i[1];
                    s.properties.className = [
                        "code-line"
                    ];
                    var l = (0, $31e44c919774b7ea$export$3dea766d36a8935f)(m, function(e) {
                        return e.position.start.line <= a + 1 && e.position.end.line >= a + 1;
                    });
                    s.children = l.children, (f.toLowerCase().includes("showLineNumbers".toLowerCase()) || !0 === o.showLineNumbers || "object" == typeof o.showLineNumbers && o.showLineNumbers.includes(d)) && !j.some(function(e) {
                        return f.toLowerCase().includes(e);
                    }) && (s.properties.line = [
                        (a + w).toString()
                    ], s.properties.className.push("line-number")), b(a) && s.properties.className.push("highlight-line"), ("diff" === d || null != (e = d) && e.includes("diff-")) && "-" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(s).substring(0, 1) ? s.properties.className.push("deleted") : ("diff" === d || null != (n = d) && n.includes("diff-")) && "+" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(s).substring(0, 1) && s.properties.className.push("inserted");
                }, L = $f6a8c10565706ab2$var$u(N.entries()); !(v = L()).done;)x();
                N.length > 0 && "" === (0, $58714581718e6349$export$f84e8e69fd4488a5)(N[N.length - 1]).trim() && N.pop(), e.children = N;
            }
        }
    };
}, $f6a8c10565706ab2$export$d63bd6a97105214e = $f6a8c10565706ab2$export$f80b9a7578ac06a((0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390)), $f6a8c10565706ab2$export$2e2bcd8739ae039 = $f6a8c10565706ab2$export$f80b9a7578ac06a((0, $2c82f7cbfe622eb8$export$1c6435d0b8e9f390));



/**
 * @import {AstSelector} from 'css-selector-parser'
 * @import {Element, Nodes, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 */ /**
 * @typedef {'html' | 'svg'} Space
 *   Name of namespace.
 *
 * @typedef {'auto' | 'ltr' | 'rtl'} Direction
 *   Direction.
 *
 * @typedef State
 *   Current state.
 * @property {Direction} direction
 *   Current direction.
 * @property {boolean} editableOrEditingHost
 *   Whether we’re in `contentEditable`.
 * @property {number | undefined} elementCount
 *   Track siblings: there are `n` siblings.
 * @property {number | undefined} elementIndex
 *   Track siblings: this current element has `n` elements before it.
 * @property {boolean} found
 *   Whether we found at least one match.
 * @property {string | undefined} language
 *   Current language.
 * @property {boolean} one
 *   Whether we can stop looking after we found one element.
 * @property {Array<Element>} results
 *   Matches.
 * @property {AstSelector} rootQuery
 *   Original root selectors.
 * @property {Schema} schema
 *   Current schema.
 * @property {Array<RootContent>} scopeElements
 *   Elements in scope.
 * @property {boolean} shallow
 *   Whether we only allow selectors without nesting.
 * @property {number | undefined} typeCount
 *   Track siblings: there are `n` siblings with this element’s tag name.
 * @property {number | undefined} typeIndex
 *   Track siblings: this current element has `n` elements with its tag name
 *   before it.
 */ 
/**
 * @import {AstSelector} from 'css-selector-parser'
 */ var $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e = {};
var $dde9b3bc5b1e1c4d$export$e5ec415068eb8990 = {};
function $dde9b3bc5b1e1c4d$var$extendIndex(item, index) {
    var currentIndex = index;
    for(var pos = 0; pos < item.length; pos++){
        var isLast = pos === item.length - 1;
        var char = item.charAt(pos);
        var charIndex = currentIndex[char] || (currentIndex[char] = {
            chars: {}
        });
        if (isLast) charIndex.self = item;
        currentIndex = charIndex.chars;
    }
}
function $dde9b3bc5b1e1c4d$export$fd845abd87c3ff7(items) {
    if (items.length === 0) return $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e;
    var index = {};
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        $dde9b3bc5b1e1c4d$var$extendIndex(item, index);
    }
    return index;
}
function $dde9b3bc5b1e1c4d$export$90ad197f4c3d269d(items) {
    if (items.length === 0) return $dde9b3bc5b1e1c4d$export$e5ec415068eb8990;
    var result = {};
    for(var _i = 0, items_2 = items; _i < items_2.length; _i++){
        var item = items_2[_i];
        result[item] = true;
    }
    return result;
}


var $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2 = {};
var $e589bf2e4bc2ee64$export$2860e7ac7b9acf6d = {
    type: 'String',
    optional: true
};
function $e589bf2e4bc2ee64$var$calculatePseudoSignature(types) {
    var result = {
        type: 'NoArgument',
        optional: false
    };
    function setResultType(type) {
        if (result.type && result.type !== type && result.type !== 'NoArgument') throw new Error("Conflicting pseudo-class argument type: \"".concat(result.type, "\" vs \"").concat(type, "\"."));
        result.type = type;
    }
    for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
        var type = types_1[_i];
        if (type === 'NoArgument') result.optional = true;
        if (type === 'Formula') setResultType('Formula');
        if (type === 'FormulaOfSelector') {
            setResultType('Formula');
            result.ofSelector = true;
        }
        if (type === 'String') setResultType('String');
        if (type === 'Selector') setResultType('Selector');
    }
    return result;
}
function $e589bf2e4bc2ee64$export$c8d0a76456c41dc2(obj) {
    var result = {};
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var category = _a[_i];
        var items = obj[category];
        if (items) for(var _b = 0, _c = items; _b < _c.length; _b++){
            var item = _c[_b];
            (result[item] || (result[item] = [])).push(category);
        }
    }
    return result;
}
function $e589bf2e4bc2ee64$export$3e512c88fa08ef5(definitions) {
    var pseudoClassesToArgumentTypes = $e589bf2e4bc2ee64$export$c8d0a76456c41dc2(definitions);
    var result = {};
    for(var _i = 0, _a = Object.keys(pseudoClassesToArgumentTypes); _i < _a.length; _i++){
        var pseudoClass = _a[_i];
        var argumentTypes = pseudoClassesToArgumentTypes[pseudoClass];
        if (argumentTypes) result[pseudoClass] = $e589bf2e4bc2ee64$var$calculatePseudoSignature(argumentTypes);
    }
    return result;
}


var $f67c0075e21dfa5b$var$__assign = undefined && undefined.__assign || function() {
    $f67c0075e21dfa5b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f67c0075e21dfa5b$var$__assign.apply(this, arguments);
};
var $f67c0075e21dfa5b$var$emptyXmlOptions = {};
var $f67c0075e21dfa5b$var$defaultXmlOptions = {
    wildcard: true
};
function $f67c0075e21dfa5b$export$21f18aac0f802d79(param) {
    if (param) {
        if (typeof param === 'boolean') return $f67c0075e21dfa5b$var$defaultXmlOptions;
        else return param;
    } else return $f67c0075e21dfa5b$var$emptyXmlOptions;
}
function $f67c0075e21dfa5b$var$withMigration(migration, merge) {
    return function(base, extension) {
        return merge(migration(base), migration(extension));
    };
}
function $f67c0075e21dfa5b$var$withNoNegative(merge) {
    return function(base, extension) {
        var result = merge(base, extension);
        if (!result) throw new Error("Syntax definition cannot be null or undefined.");
        return result;
    };
}
function $f67c0075e21dfa5b$var$withPositive(positive, merge) {
    return function(base, extension) {
        if (extension === true) return positive;
        return merge(base === true ? positive : base, extension);
    };
}
function $f67c0075e21dfa5b$var$mergeSection(values) {
    return function(base, extension) {
        if (!extension || !base) return extension;
        if (typeof extension !== 'object' || extension === null) throw new Error("Unexpected syntax definition extension type: ".concat(extension, "."));
        var result = $f67c0075e21dfa5b$var$__assign({}, base);
        for(var _i = 0, _a = Object.entries(extension); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === 'latest') continue;
            var mergeSchema = values[key];
            result[key] = mergeSchema(base[key], value);
        }
        return result;
    };
}
function $f67c0075e21dfa5b$var$replaceValueIfSpecified(base, extension) {
    if (extension !== undefined) return extension;
    return base;
}
function $f67c0075e21dfa5b$var$concatArray(base, extension) {
    if (!extension) return base;
    if (!base) return extension;
    return base.concat(extension);
}
function $f67c0075e21dfa5b$var$mergeDefinitions(base, extension) {
    if (!extension) return base;
    if (!base) return extension;
    var result = $f67c0075e21dfa5b$var$__assign({}, base);
    for(var _i = 0, _a = Object.entries(extension); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (!value) {
            delete result[key];
            continue;
        }
        var baseValue = base[key];
        if (!baseValue) {
            result[key] = value;
            continue;
        }
        result[key] = baseValue.concat(value);
    }
    return result;
}
var $f67c0075e21dfa5b$export$e482e55c173ab6 = $f67c0075e21dfa5b$var$withNoNegative($f67c0075e21dfa5b$var$mergeSection({
    baseSyntax: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    modules: $f67c0075e21dfa5b$var$concatArray,
    tag: $f67c0075e21dfa5b$var$withPositive($f67c0075e21dfa5b$var$defaultXmlOptions, $f67c0075e21dfa5b$var$mergeSection({
        wildcard: $f67c0075e21dfa5b$var$replaceValueIfSpecified
    })),
    ids: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    classNames: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    nestingSelector: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
    namespace: $f67c0075e21dfa5b$var$withPositive($f67c0075e21dfa5b$var$defaultXmlOptions, $f67c0075e21dfa5b$var$mergeSection({
        wildcard: $f67c0075e21dfa5b$var$replaceValueIfSpecified
    })),
    combinators: $f67c0075e21dfa5b$var$concatArray,
    attributes: $f67c0075e21dfa5b$var$mergeSection({
        operators: $f67c0075e21dfa5b$var$concatArray,
        caseSensitivityModifiers: $f67c0075e21dfa5b$var$concatArray,
        unknownCaseSensitivityModifiers: $f67c0075e21dfa5b$var$replaceValueIfSpecified
    }),
    pseudoClasses: $f67c0075e21dfa5b$var$mergeSection({
        unknown: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
        definitions: $f67c0075e21dfa5b$var$mergeDefinitions
    }),
    pseudoElements: $f67c0075e21dfa5b$var$mergeSection({
        unknown: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
        notation: $f67c0075e21dfa5b$var$replaceValueIfSpecified,
        definitions: $f67c0075e21dfa5b$var$withMigration(function(definitions) {
            return Array.isArray(definitions) ? {
                NoArgument: definitions
            } : definitions;
        }, $f67c0075e21dfa5b$var$mergeDefinitions)
    })
}));
var $f67c0075e21dfa5b$var$css1SyntaxDefinition = {
    tag: {},
    ids: true,
    classNames: true,
    combinators: [],
    pseudoElements: {
        unknown: 'reject',
        notation: 'singleColon',
        definitions: [
            'first-letter',
            'first-line'
        ]
    },
    pseudoClasses: {
        unknown: 'reject',
        definitions: {
            NoArgument: [
                'link',
                'visited',
                'active'
            ]
        }
    }
};
var $f67c0075e21dfa5b$var$css2SyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$css1SyntaxDefinition, {
    tag: {
        wildcard: true
    },
    combinators: [
        '>',
        '+'
    ],
    attributes: {
        unknownCaseSensitivityModifiers: 'reject',
        operators: [
            '=',
            '~=',
            '|='
        ]
    },
    pseudoElements: {
        definitions: [
            'before',
            'after'
        ]
    },
    pseudoClasses: {
        unknown: 'reject',
        definitions: {
            NoArgument: [
                'hover',
                'focus',
                'first-child'
            ],
            String: [
                'lang'
            ]
        }
    }
});
var $f67c0075e21dfa5b$var$selectors3SyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$css2SyntaxDefinition, {
    namespace: {
        wildcard: true
    },
    combinators: [
        '~'
    ],
    attributes: {
        operators: [
            '^=',
            '$=',
            '*='
        ]
    },
    pseudoElements: {
        notation: 'both'
    },
    pseudoClasses: {
        definitions: {
            NoArgument: [
                'root',
                'last-child',
                'first-of-type',
                'last-of-type',
                'only-child',
                'only-of-type',
                'empty',
                'target',
                'enabled',
                'disabled',
                'checked',
                'indeterminate'
            ],
            Formula: [
                'nth-child',
                'nth-last-child',
                'nth-of-type',
                'nth-last-of-type'
            ],
            Selector: [
                'not'
            ]
        }
    }
});
var $f67c0075e21dfa5b$var$selectors4SyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$selectors3SyntaxDefinition, {
    combinators: [
        '||'
    ],
    attributes: {
        caseSensitivityModifiers: [
            'i',
            'I',
            's',
            'S'
        ]
    },
    pseudoClasses: {
        definitions: {
            NoArgument: [
                'any-link',
                'local-link',
                'target-within',
                'scope',
                'current',
                'past',
                'future',
                'focus-within',
                'focus-visible',
                'read-write',
                'read-only',
                'placeholder-shown',
                'default',
                'valid',
                'invalid',
                'in-range',
                'out-of-range',
                'required',
                'optional',
                'blank',
                'user-invalid',
                'playing',
                'paused',
                'autofill',
                'modal',
                'fullscreen',
                'picture-in-picture',
                'defined',
                'loading',
                'popover-open'
            ],
            Formula: [
                'nth-col',
                'nth-last-col'
            ],
            String: [
                'dir'
            ],
            FormulaOfSelector: [
                'nth-child',
                'nth-last-child'
            ],
            Selector: [
                'current',
                'is',
                'where',
                'has',
                'state'
            ]
        }
    },
    pseudoElements: {
        definitions: {
            NoArgument: [
                'marker'
            ]
        }
    }
});
var $f67c0075e21dfa5b$export$f2154c9edd9fd6d5 = {
    'css-position-1': {
        latest: false,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'static',
                    'relative',
                    'absolute'
                ]
            }
        }
    },
    'css-position-2': {
        latest: false,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'static',
                    'relative',
                    'absolute',
                    'fixed'
                ]
            }
        }
    },
    'css-position-3': {
        latest: false,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'sticky',
                    'fixed',
                    'absolute',
                    'relative',
                    'static'
                ]
            }
        }
    },
    'css-position-4': {
        latest: true,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'sticky',
                    'fixed',
                    'absolute',
                    'relative',
                    'static',
                    'initial'
                ]
            }
        }
    },
    'css-scoping-1': {
        latest: true,
        pseudoClasses: {
            definitions: {
                NoArgument: [
                    'host',
                    'host-context'
                ],
                Selector: [
                    'host',
                    'host-context'
                ]
            }
        },
        pseudoElements: {
            definitions: {
                Selector: [
                    'slotted'
                ]
            }
        }
    },
    'css-pseudo-4': {
        latest: true,
        pseudoElements: {
            definitions: {
                NoArgument: [
                    'marker',
                    'selection',
                    'target-text',
                    'search-text',
                    'spelling-error',
                    'grammar-error',
                    'backdrop',
                    'file-selector-button',
                    'prefix',
                    'postfix',
                    'placeholder',
                    'details-content'
                ],
                String: [
                    'highlight'
                ]
            }
        }
    },
    'css-shadow-parts-1': {
        latest: true,
        pseudoElements: {
            definitions: {
                String: [
                    'part'
                ]
            }
        }
    },
    'css-nesting-1': {
        latest: true,
        nestingSelector: true
    }
};
var $f67c0075e21dfa5b$var$latestSyntaxDefinition = $f67c0075e21dfa5b$var$__assign($f67c0075e21dfa5b$var$__assign({}, $f67c0075e21dfa5b$var$selectors4SyntaxDefinition), {
    modules: Object.entries($f67c0075e21dfa5b$export$f2154c9edd9fd6d5).filter(function(_a) {
        var latest = _a[1].latest;
        return latest;
    }).map(function(_a) {
        var name = _a[0];
        return name;
    })
});
var $f67c0075e21dfa5b$var$progressiveSyntaxDefinition = $f67c0075e21dfa5b$export$e482e55c173ab6($f67c0075e21dfa5b$var$latestSyntaxDefinition, {
    pseudoElements: {
        unknown: 'accept'
    },
    pseudoClasses: {
        unknown: 'accept'
    },
    attributes: {
        unknownCaseSensitivityModifiers: 'accept'
    }
});
var $f67c0075e21dfa5b$export$a62db26b89cc3840 = {
    css1: $f67c0075e21dfa5b$var$css1SyntaxDefinition,
    css2: $f67c0075e21dfa5b$var$css2SyntaxDefinition,
    css3: $f67c0075e21dfa5b$var$selectors3SyntaxDefinition,
    'selectors-3': $f67c0075e21dfa5b$var$selectors3SyntaxDefinition,
    'selectors-4': $f67c0075e21dfa5b$var$selectors4SyntaxDefinition,
    latest: $f67c0075e21dfa5b$var$latestSyntaxDefinition,
    progressive: $f67c0075e21dfa5b$var$progressiveSyntaxDefinition
};
function $f67c0075e21dfa5b$export$936d38df95fb257() {
    var index = {
        pseudoClasses: {},
        pseudoElements: {}
    };
    // Add CSS Levels (excluding 'latest' and 'progressive')
    var cssLevels = [
        'css1',
        'css2',
        'css3',
        'selectors-3',
        'selectors-4'
    ];
    for(var _i = 0, cssLevels_1 = cssLevels; _i < cssLevels_1.length; _i++){
        var level = cssLevels_1[_i];
        var syntax = $f67c0075e21dfa5b$export$a62db26b89cc3840[level];
        // Process pseudo-classes
        if (syntax.pseudoClasses && typeof syntax.pseudoClasses === 'object') {
            var definitions = syntax.pseudoClasses.definitions;
            if (definitions) for(var _a = 0, _b = Object.entries(definitions); _a < _b.length; _a++){
                var _c = _b[_a], names = _c[1];
                for(var _d = 0, names_1 = names; _d < names_1.length; _d++){
                    var name_1 = names_1[_d];
                    if (!index.pseudoClasses[name_1]) index.pseudoClasses[name_1] = [];
                    if (!index.pseudoClasses[name_1].includes(level)) index.pseudoClasses[name_1].push(level);
                }
            }
        }
        // Process pseudo-elements
        if (syntax.pseudoElements && typeof syntax.pseudoElements === 'object') {
            var definitions = syntax.pseudoElements.definitions;
            if (definitions) {
                if (Array.isArray(definitions)) for(var _e = 0, definitions_1 = definitions; _e < definitions_1.length; _e++){
                    var name_2 = definitions_1[_e];
                    if (!index.pseudoElements[name_2]) index.pseudoElements[name_2] = [];
                    if (!index.pseudoElements[name_2].includes(level)) index.pseudoElements[name_2].push(level);
                }
                else for(var _f = 0, _g = Object.values(definitions); _f < _g.length; _f++){
                    var names = _g[_f];
                    for(var _h = 0, names_2 = names; _h < names_2.length; _h++){
                        var name_3 = names_2[_h];
                        if (!index.pseudoElements[name_3]) index.pseudoElements[name_3] = [];
                        if (!index.pseudoElements[name_3].includes(level)) index.pseudoElements[name_3].push(level);
                    }
                }
            }
        }
    }
    // Add CSS Modules
    for(var _j = 0, _k = Object.entries($f67c0075e21dfa5b$export$f2154c9edd9fd6d5); _j < _k.length; _j++){
        var _l = _k[_j], moduleName = _l[0], moduleSyntax = _l[1];
        // Process pseudo-classes
        if (moduleSyntax.pseudoClasses && typeof moduleSyntax.pseudoClasses === 'object') {
            var definitions = moduleSyntax.pseudoClasses.definitions;
            if (definitions) for(var _m = 0, _o = Object.values(definitions); _m < _o.length; _m++){
                var names = _o[_m];
                for(var _p = 0, names_3 = names; _p < names_3.length; _p++){
                    var name_4 = names_3[_p];
                    if (!index.pseudoClasses[name_4]) index.pseudoClasses[name_4] = [];
                    if (!index.pseudoClasses[name_4].includes(moduleName)) index.pseudoClasses[name_4].push(moduleName);
                }
            }
        }
        // Process pseudo-elements
        if (moduleSyntax.pseudoElements && typeof moduleSyntax.pseudoElements === 'object') {
            var definitions = moduleSyntax.pseudoElements.definitions;
            if (definitions) {
                if (Array.isArray(definitions)) for(var _q = 0, definitions_2 = definitions; _q < definitions_2.length; _q++){
                    var name_5 = definitions_2[_q];
                    if (!index.pseudoElements[name_5]) index.pseudoElements[name_5] = [];
                    if (!index.pseudoElements[name_5].includes(moduleName)) index.pseudoElements[name_5].push(moduleName);
                }
                else for(var _r = 0, _s = Object.values(definitions); _r < _s.length; _r++){
                    var names = _s[_r];
                    for(var _t = 0, names_4 = names; _t < names_4.length; _t++){
                        var name_6 = names_4[_t];
                        if (!index.pseudoElements[name_6]) index.pseudoElements[name_6] = [];
                        if (!index.pseudoElements[name_6].includes(moduleName)) index.pseudoElements[name_6].push(moduleName);
                    }
                }
            }
        }
    }
    return index;
}
var $f67c0075e21dfa5b$export$dd1b971945cbb3c7 = $f67c0075e21dfa5b$export$936d38df95fb257();


function $ddae313f2cb96861$export$25af8346f6239c5b(c) {
    return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c === '-' || c === '_' || c === '\\' || c >= '\u00a0';
}
function $ddae313f2cb96861$export$63c9ecd03a955e6b(c) {
    return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c >= '0' && c <= '9' || c === '-' || c === '_' || c >= '\u00a0';
}
function $ddae313f2cb96861$export$8a9b6341a7c96bc(c) {
    return c >= 'a' && c <= 'f' || c >= 'A' && c <= 'F' || c >= '0' && c <= '9';
}
var $ddae313f2cb96861$export$3c7f85fa1719c0df = {
    '!': true,
    '"': true,
    '#': true,
    $: true,
    '%': true,
    '&': true,
    "'": true,
    '(': true,
    ')': true,
    '*': true,
    '+': true,
    ',': true,
    '.': true,
    '/': true,
    ';': true,
    '<': true,
    '=': true,
    '>': true,
    '?': true,
    '@': true,
    '[': true,
    '\\': true,
    ']': true,
    '^': true,
    '`': true,
    '{': true,
    '|': true,
    '}': true,
    '~': true
};
var $ddae313f2cb96861$export$85b7ce609d55feb0 = {
    '\n': true,
    '\r': true,
    '\t': true,
    '\f': true,
    '\v': true
};
var $ddae313f2cb96861$export$f451d7af9c363592 = {
    ' ': true,
    '\t': true,
    '\n': true,
    '\r': true,
    '\f': true
};
var $ddae313f2cb96861$export$4a6f40ec9a9f93d = {
    '"': true,
    "'": true
};
var $ddae313f2cb96861$export$4772887ab32e45a3 = {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    8: true,
    9: true
};
var $ddae313f2cb96861$export$1fccc43cb8f7bfd2 = 6;
function $ddae313f2cb96861$export$56fe274825607f4a(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    while(i < len){
        var chr = s.charAt(i);
        if ($ddae313f2cb96861$export$3c7f85fa1719c0df[chr] || chr === '-' && i === 1 && s.charAt(0) === '-') result += '\\' + chr;
        else if (chr === '-' || chr === '_' || chr >= 'A' && chr <= 'Z' || chr >= 'a' && chr <= 'z' || chr >= '0' && chr <= '9' && i !== 0 && !(i === 1 && s.charAt(0) === '-')) result += chr;
        else {
            var charCode = chr.charCodeAt(0);
            if ((charCode & 0xf800) === 0xd800) {
                var extraCharCode = s.charCodeAt(i++);
                if ((charCode & 0xfc00) !== 0xd800 || (extraCharCode & 0xfc00) !== 0xdc00) throw Error('UCS-2(decode): illegal sequence');
                charCode = ((charCode & 0x3ff) << 10) + (extraCharCode & 0x3ff) + 0x10000;
            }
            result += '\\' + charCode.toString(16) + ' ';
        }
        i++;
    }
    return result.trim();
}
function $ddae313f2cb96861$export$4148cf4a40af9f34(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    while(i < len){
        var chr = s.charAt(i);
        if (chr === '"') chr = '\\"';
        else if (chr === '\\') chr = '\\\\';
        else if ($ddae313f2cb96861$export$85b7ce609d55feb0[chr]) chr = '\\' + chr.charCodeAt(0).toString(16) + (i === len - 1 ? '' : ' ');
        result += chr;
        i++;
    }
    return "\"".concat(result, "\"");
}


var $7b881788824fe7ce$var$errorPrefix = "css-selector-parser parse error: ";
function $7b881788824fe7ce$export$88a1156fad04455f(options) {
    if (options === void 0) options = {};
    var _a = options.syntax, syntax = _a === void 0 ? 'latest' : _a, substitutes = options.substitutes, _b = options.strict, strict = _b === void 0 ? true : _b, modules = options.modules;
    var syntaxDefinition = typeof syntax === 'object' ? syntax : (0, $f67c0075e21dfa5b$export$a62db26b89cc3840)[syntax];
    if (syntaxDefinition.baseSyntax) syntaxDefinition = (0, $f67c0075e21dfa5b$export$e482e55c173ab6)((0, $f67c0075e21dfa5b$export$a62db26b89cc3840)[syntaxDefinition.baseSyntax], syntaxDefinition);
    // Apply modules from syntax definition
    if (syntaxDefinition.modules && syntaxDefinition.modules.length > 0) for(var _i = 0, _c = syntaxDefinition.modules; _i < _c.length; _i++){
        var module_1 = _c[_i];
        var moduleSyntax = (0, $f67c0075e21dfa5b$export$f2154c9edd9fd6d5)[module_1];
        if (moduleSyntax) syntaxDefinition = (0, $f67c0075e21dfa5b$export$e482e55c173ab6)(moduleSyntax, syntaxDefinition);
    }
    // Apply additional modules if specified from options
    if (modules && modules.length > 0) for(var _d = 0, modules_1 = modules; _d < modules_1.length; _d++){
        var module_2 = modules_1[_d];
        var moduleSyntax = (0, $f67c0075e21dfa5b$export$f2154c9edd9fd6d5)[module_2];
        if (moduleSyntax) syntaxDefinition = (0, $f67c0075e21dfa5b$export$e482e55c173ab6)(moduleSyntax, syntaxDefinition);
    }
    var _e = syntaxDefinition.tag ? [
        true,
        Boolean((0, $f67c0075e21dfa5b$export$21f18aac0f802d79)(syntaxDefinition.tag).wildcard)
    ] : [
        false,
        false
    ], tagNameEnabled = _e[0], tagNameWildcardEnabled = _e[1];
    var idEnabled = Boolean(syntaxDefinition.ids);
    var classNamesEnabled = Boolean(syntaxDefinition.classNames);
    var nestingSelectorEnabled = Boolean(syntaxDefinition.nestingSelector);
    var namespaceEnabled = Boolean(syntaxDefinition.namespace);
    var namespaceWildcardEnabled = syntaxDefinition.namespace && (syntaxDefinition.namespace === true || syntaxDefinition.namespace.wildcard === true);
    if (namespaceEnabled && !tagNameEnabled) throw new Error("".concat($7b881788824fe7ce$var$errorPrefix, "Namespaces cannot be enabled while tags are disabled."));
    var substitutesEnabled = Boolean(substitutes);
    var combinatorsIndex = syntaxDefinition.combinators ? (0, $dde9b3bc5b1e1c4d$export$fd845abd87c3ff7)(syntaxDefinition.combinators) : (0, $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e);
    var _f = syntaxDefinition.attributes ? [
        true,
        syntaxDefinition.attributes.operators ? (0, $dde9b3bc5b1e1c4d$export$fd845abd87c3ff7)(syntaxDefinition.attributes.operators) : (0, $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e),
        syntaxDefinition.attributes.caseSensitivityModifiers ? (0, $dde9b3bc5b1e1c4d$export$90ad197f4c3d269d)(syntaxDefinition.attributes.caseSensitivityModifiers) : (0, $dde9b3bc5b1e1c4d$export$e5ec415068eb8990),
        syntaxDefinition.attributes.unknownCaseSensitivityModifiers === 'accept'
    ] : [
        false,
        (0, $dde9b3bc5b1e1c4d$export$fd2ef7d56085a14e),
        (0, $dde9b3bc5b1e1c4d$export$e5ec415068eb8990),
        false
    ], attributesEnabled = _f[0], attributesOperatorsIndex = _f[1], attributesCaseSensitivityModifiers = _f[2], attributesAcceptUnknownCaseSensitivityModifiers = _f[3];
    var attributesCaseSensitivityModifiersEnabled = attributesAcceptUnknownCaseSensitivityModifiers || Object.keys(attributesCaseSensitivityModifiers).length > 0;
    var _g = syntaxDefinition.pseudoClasses ? [
        true,
        syntaxDefinition.pseudoClasses.definitions ? (0, $e589bf2e4bc2ee64$export$3e512c88fa08ef5)(syntaxDefinition.pseudoClasses.definitions) : (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        syntaxDefinition.pseudoClasses.unknown === 'accept'
    ] : [
        false,
        (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        false
    ], pseudoClassesEnabled = _g[0], pseudoClassesDefinitions = _g[1], pseudoClassesAcceptUnknown = _g[2];
    var _h = syntaxDefinition.pseudoElements ? [
        true,
        syntaxDefinition.pseudoElements.notation === 'singleColon' || syntaxDefinition.pseudoElements.notation === 'both',
        !syntaxDefinition.pseudoElements.notation || syntaxDefinition.pseudoElements.notation === 'doubleColon' || syntaxDefinition.pseudoElements.notation === 'both',
        syntaxDefinition.pseudoElements.definitions ? (0, $e589bf2e4bc2ee64$export$3e512c88fa08ef5)(Array.isArray(syntaxDefinition.pseudoElements.definitions) ? {
            NoArgument: syntaxDefinition.pseudoElements.definitions
        } : syntaxDefinition.pseudoElements.definitions) : (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        syntaxDefinition.pseudoElements.unknown === 'accept'
    ] : [
        false,
        false,
        false,
        (0, $e589bf2e4bc2ee64$export$f2d6fbb4761a05b2),
        false
    ], pseudoElementsEnabled = _h[0], pseudoElementsSingleColonNotationEnabled = _h[1], pseudoElementsDoubleColonNotationEnabled = _h[2], pseudoElementsDefinitions = _h[3], pseudoElementsAcceptUnknown = _h[4];
    var str = '';
    var l = str.length;
    var pos = 0;
    var chr = '';
    var is = function(comparison) {
        return chr === comparison;
    };
    var isTagStart = function() {
        return is('*') || (0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr);
    };
    var rewind = function(newPos) {
        pos = newPos;
        chr = str.charAt(pos);
    };
    var next = function() {
        pos++;
        chr = str.charAt(pos);
    };
    var readAndNext = function() {
        var current = chr;
        pos++;
        chr = str.charAt(pos);
        return current;
    };
    /** @throws ParserError */ function fail(errorMessage) {
        var position = Math.min(l - 1, pos);
        var error = new Error("".concat($7b881788824fe7ce$var$errorPrefix).concat(errorMessage, " Pos: ").concat(position, "."));
        error.position = position;
        error.name = 'ParserError';
        throw error;
    }
    function assert(condition, errorMessage) {
        if (!condition) return fail(errorMessage);
    }
    var assertNonEof = function() {
        assert(pos < l, 'Unexpected end of input.');
    };
    var isEof = function() {
        return pos >= l;
    };
    var pass = function(character) {
        assert(pos < l, "Expected \"".concat(character, "\" but end of input reached."));
        assert(chr === character, "Expected \"".concat(character, "\" but \"").concat(chr, "\" found."));
        pos++;
        chr = str.charAt(pos);
    };
    function matchMulticharIndex(index) {
        var match = matchMulticharIndexPos(index, pos);
        if (match) {
            pos += match.length;
            chr = str.charAt(pos);
            return match;
        }
    }
    function matchMulticharIndexPos(index, subPos) {
        var char = str.charAt(subPos);
        var charIndex = index[char];
        if (charIndex) {
            var subMatch = matchMulticharIndexPos(charIndex.chars, subPos + 1);
            if (subMatch) return subMatch;
            if (charIndex.self) return charIndex.self;
        }
    }
    /**
     * @see https://www.w3.org/TR/css-syntax/#hex-digit-diagram
     */ function parseHex() {
        var hex = readAndNext();
        var count = 1;
        while((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr) && count < (0, $ddae313f2cb96861$export$1fccc43cb8f7bfd2)){
            hex += readAndNext();
            count++;
        }
        skipSingleWhitespace();
        return String.fromCharCode(parseInt(hex, 16));
    }
    /**
     * @see https://www.w3.org/TR/css-syntax/#string-token-diagram
     */ function parseString(quote) {
        var result = '';
        pass(quote);
        while(pos < l){
            if (is(quote)) {
                next();
                return result;
            } else if (is('\\')) {
                next();
                if (is(quote)) {
                    result += quote;
                    next();
                } else if (chr === '\n' || chr === '\f') next();
                else if (chr === '\r') {
                    next();
                    if (is('\n')) next();
                } else if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) result += parseHex();
                else {
                    result += chr;
                    next();
                }
            } else {
                result += chr;
                next();
            }
        }
        return result;
    }
    /**
     * @see https://www.w3.org/TR/css-syntax/#ident-token-diagram
     */ function parseIdentifier() {
        if (!(0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) return null;
        var result = '';
        while(is('-')){
            result += chr;
            next();
        }
        if (result === '-' && !(0, $ddae313f2cb96861$export$63c9ecd03a955e6b)(chr) && !is('\\')) fail('Identifiers cannot consist of a single hyphen.');
        if (strict && result.length >= 2) // Checking this only for strict mode since browsers work fine with these identifiers.
        fail('Identifiers cannot start with two hyphens with strict mode on.');
        if ((0, $ddae313f2cb96861$export$4772887ab32e45a3)[chr]) fail('Identifiers cannot start with hyphens followed by digits.');
        while(pos < l){
            if ((0, $ddae313f2cb96861$export$63c9ecd03a955e6b)(chr)) result += readAndNext();
            else if (is('\\')) {
                next();
                assertNonEof();
                if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) result += parseHex();
                else result += readAndNext();
            } else break;
        }
        return result;
    }
    function parsePseudoClassString() {
        var result = '';
        while(pos < l){
            if (is(')')) break;
            else if (is('\\')) {
                next();
                if (isEof() && !strict) return (result + '\\').trim();
                assertNonEof();
                if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) result += parseHex();
                else result += readAndNext();
            } else result += readAndNext();
        }
        return result.trim();
    }
    function skipSingleWhitespace() {
        if (chr === ' ' || chr === '\t' || chr === '\f' || chr === '\n') {
            next();
            return;
        }
        if (chr === '\r') next();
        if (chr === '\n') next();
    }
    function skipWhitespace() {
        while((0, $ddae313f2cb96861$export$f451d7af9c363592)[chr])next();
    }
    function parseSelector(relative) {
        if (relative === void 0) relative = false;
        skipWhitespace();
        var rules = [
            parseRule(relative)
        ];
        while(is(',')){
            next();
            skipWhitespace();
            rules.push(parseRule(relative));
        }
        return {
            type: 'Selector',
            rules: rules
        };
    }
    function parseAttribute() {
        pass('[');
        skipWhitespace();
        var attr;
        if (is('|')) {
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            next();
            var name_1 = parseIdentifier();
            assert(name_1, 'Expected attribute name.');
            attr = {
                type: 'Attribute',
                name: name_1,
                namespace: {
                    type: 'NoNamespace'
                }
            };
        } else if (is('*')) {
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            assert(namespaceWildcardEnabled, 'Wildcard namespace is not enabled.');
            next();
            pass('|');
            var name_2 = parseIdentifier();
            assert(name_2, 'Expected attribute name.');
            attr = {
                type: 'Attribute',
                name: name_2,
                namespace: {
                    type: 'WildcardNamespace'
                }
            };
        } else {
            var identifier = parseIdentifier();
            assert(identifier, 'Expected attribute name.');
            attr = {
                type: 'Attribute',
                name: identifier
            };
            if (is('|')) {
                var savedPos = pos;
                next();
                if ((0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) {
                    assert(namespaceEnabled, 'Namespaces are not enabled.');
                    var name_3 = parseIdentifier();
                    assert(name_3, 'Expected attribute name.');
                    attr = {
                        type: 'Attribute',
                        name: name_3,
                        namespace: {
                            type: 'NamespaceName',
                            name: identifier
                        }
                    };
                } else rewind(savedPos);
            }
        }
        assert(attr.name, 'Expected attribute name.');
        skipWhitespace();
        if (isEof() && !strict) return attr;
        if (is(']')) next();
        else {
            attr.operator = matchMulticharIndex(attributesOperatorsIndex);
            assert(attr.operator, 'Expected a valid attribute selector operator.');
            skipWhitespace();
            assertNonEof();
            if ((0, $ddae313f2cb96861$export$4a6f40ec9a9f93d)[chr]) attr.value = {
                type: 'String',
                value: parseString(chr)
            };
            else if (substitutesEnabled && is('$')) {
                next();
                var name_4 = parseIdentifier();
                assert(name_4, 'Expected substitute name.');
                attr.value = {
                    type: 'Substitution',
                    name: name_4
                };
            } else {
                var value = parseIdentifier();
                assert(value, 'Expected attribute value.');
                attr.value = {
                    type: 'String',
                    value: value
                };
            }
            skipWhitespace();
            if (isEof() && !strict) return attr;
            if (!is(']')) {
                var caseSensitivityModifier = parseIdentifier();
                assert(caseSensitivityModifier, 'Expected end of attribute selector.');
                attr.caseSensitivityModifier = caseSensitivityModifier;
                assert(attributesCaseSensitivityModifiersEnabled, 'Attribute case sensitivity modifiers are not enabled.');
                assert(attributesAcceptUnknownCaseSensitivityModifiers || attributesCaseSensitivityModifiers[attr.caseSensitivityModifier], 'Unknown attribute case sensitivity modifier.');
                skipWhitespace();
                if (isEof() && !strict) return attr;
            }
            pass(']');
        }
        return attr;
    }
    function parseNumber() {
        var result = '';
        while((0, $ddae313f2cb96861$export$4772887ab32e45a3)[chr])result += readAndNext();
        assert(result !== '', 'Formula parse error.');
        return parseInt(result);
    }
    var isNumberStart = function() {
        return is('-') || is('+') || (0, $ddae313f2cb96861$export$4772887ab32e45a3)[chr];
    };
    function parseFormula() {
        if (is('e') || is('o')) {
            var ident = parseIdentifier();
            if (ident === 'even') {
                skipWhitespace();
                return [
                    2,
                    0
                ];
            }
            if (ident === 'odd') {
                skipWhitespace();
                return [
                    2,
                    1
                ];
            }
        }
        var firstNumber = null;
        var firstNumberMultiplier = 1;
        if (is('-')) {
            next();
            firstNumberMultiplier = -1;
        }
        if (isNumberStart()) {
            if (is('+')) next();
            firstNumber = parseNumber();
            if (!is('\\') && !is('n')) return [
                0,
                firstNumber * firstNumberMultiplier
            ];
        }
        if (firstNumber === null) firstNumber = 1;
        firstNumber *= firstNumberMultiplier;
        var identifier;
        if (is('\\')) {
            next();
            if ((0, $ddae313f2cb96861$export$8a9b6341a7c96bc)(chr)) identifier = parseHex();
            else identifier = readAndNext();
        } else identifier = readAndNext();
        assert(identifier === 'n', 'Formula parse error: expected "n".');
        skipWhitespace();
        if (is('+') || is('-')) {
            var sign = is('+') ? 1 : -1;
            next();
            skipWhitespace();
            return [
                firstNumber,
                sign * parseNumber()
            ];
        } else return [
            firstNumber,
            0
        ];
    }
    function parsePseudoArgument(pseudoName, type, signature) {
        var argument;
        if (is('(')) {
            next();
            skipWhitespace();
            if (substitutesEnabled && is('$')) {
                next();
                var name_5 = parseIdentifier();
                assert(name_5, 'Expected substitute name.');
                argument = {
                    type: 'Substitution',
                    name: name_5
                };
            } else if (signature.type === 'String') {
                argument = {
                    type: 'String',
                    value: parsePseudoClassString()
                };
                assert(argument.value, "Expected ".concat(type, " argument value."));
            } else if (signature.type === 'Selector') argument = parseSelector(true);
            else if (signature.type === 'Formula') {
                var _a = parseFormula(), a = _a[0], b = _a[1];
                argument = {
                    type: 'Formula',
                    a: a,
                    b: b
                };
                if (signature.ofSelector) {
                    skipWhitespace();
                    if (is('o') || is('\\')) {
                        var ident = parseIdentifier();
                        assert(ident === 'of', 'Formula of selector parse error.');
                        skipWhitespace();
                        argument = {
                            type: 'FormulaOfSelector',
                            a: a,
                            b: b,
                            selector: parseRule()
                        };
                    }
                }
            } else return fail("Invalid ".concat(type, " signature."));
            skipWhitespace();
            if (isEof() && !strict) return argument;
            pass(')');
        } else assert(signature.optional, "Argument is required for ".concat(type, " \"").concat(pseudoName, "\"."));
        return argument;
    }
    function parseTagName() {
        if (is('*')) {
            assert(tagNameWildcardEnabled, 'Wildcard tag name is not enabled.');
            next();
            return {
                type: 'WildcardTag'
            };
        } else if ((0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) {
            assert(tagNameEnabled, 'Tag names are not enabled.');
            var name_6 = parseIdentifier();
            assert(name_6, 'Expected tag name.');
            return {
                type: 'TagName',
                name: name_6
            };
        } else return fail('Expected tag name.');
    }
    function parseTagNameWithNamespace() {
        if (is('*')) {
            var savedPos = pos;
            next();
            if (!is('|')) {
                rewind(savedPos);
                return parseTagName();
            }
            next();
            if (!isTagStart()) {
                rewind(savedPos);
                return parseTagName();
            }
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            assert(namespaceWildcardEnabled, 'Wildcard namespace is not enabled.');
            var tagName = parseTagName();
            tagName.namespace = {
                type: 'WildcardNamespace'
            };
            return tagName;
        } else if (is('|')) {
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            next();
            var tagName = parseTagName();
            tagName.namespace = {
                type: 'NoNamespace'
            };
            return tagName;
        } else if ((0, $ddae313f2cb96861$export$25af8346f6239c5b)(chr)) {
            var identifier = parseIdentifier();
            assert(identifier, 'Expected tag name.');
            if (!is('|')) {
                assert(tagNameEnabled, 'Tag names are not enabled.');
                return {
                    type: 'TagName',
                    name: identifier
                };
            }
            var savedPos = pos;
            next();
            if (!isTagStart()) {
                rewind(savedPos);
                return {
                    type: 'TagName',
                    name: identifier
                };
            }
            assert(namespaceEnabled, 'Namespaces are not enabled.');
            var tagName = parseTagName();
            tagName.namespace = {
                type: 'NamespaceName',
                name: identifier
            };
            return tagName;
        } else return fail('Expected tag name.');
    }
    function parseRule(relative) {
        var _a, _b;
        if (relative === void 0) relative = false;
        var rule = {
            type: 'Rule',
            items: []
        };
        if (relative) {
            var combinator = matchMulticharIndex(combinatorsIndex);
            if (combinator) {
                rule.combinator = combinator;
                skipWhitespace();
            }
        }
        while(pos < l){
            if (isTagStart()) {
                assert(rule.items.length === 0, 'Unexpected tag/namespace start.');
                rule.items.push(parseTagNameWithNamespace());
            } else if (is('|')) {
                var savedPos = pos;
                next();
                if (isTagStart()) {
                    assert(rule.items.length === 0, 'Unexpected tag/namespace start.');
                    rewind(savedPos);
                    rule.items.push(parseTagNameWithNamespace());
                } else {
                    rewind(savedPos);
                    break;
                }
            } else if (is('.')) {
                assert(classNamesEnabled, 'Class names are not enabled.');
                next();
                var className = parseIdentifier();
                assert(className, 'Expected class name.');
                rule.items.push({
                    type: 'ClassName',
                    name: className
                });
            } else if (is('#')) {
                assert(idEnabled, 'IDs are not enabled.');
                next();
                var idName = parseIdentifier();
                assert(idName, 'Expected ID name.');
                rule.items.push({
                    type: 'Id',
                    name: idName
                });
            } else if (is('&')) {
                assert(nestingSelectorEnabled, 'Nesting selector is not enabled.');
                next();
                rule.items.push({
                    type: 'NestingSelector'
                });
            } else if (is('[')) {
                assert(attributesEnabled, 'Attributes are not enabled.');
                rule.items.push(parseAttribute());
            } else if (is(':')) {
                var isDoubleColon = false;
                var isPseudoElement = false;
                next();
                if (is(':')) {
                    assert(pseudoElementsEnabled, 'Pseudo elements are not enabled.');
                    assert(pseudoElementsDoubleColonNotationEnabled, 'Pseudo elements double colon notation is not enabled.');
                    isDoubleColon = true;
                    next();
                }
                var pseudoName = parseIdentifier();
                assert(isDoubleColon || pseudoName, 'Expected pseudo-class name.');
                assert(!isDoubleColon || pseudoName, 'Expected pseudo-element name.');
                assert(pseudoName, 'Expected pseudo-class name.');
                if (!isDoubleColon || pseudoElementsAcceptUnknown || Object.prototype.hasOwnProperty.call(pseudoElementsDefinitions, pseudoName)) ;
                else {
                    // Generate a helpful error message with location information
                    var locations = (0, $f67c0075e21dfa5b$export$dd1b971945cbb3c7).pseudoElements[pseudoName];
                    var errorMessage = "Unknown pseudo-element \"".concat(pseudoName, "\"");
                    if (locations && locations.length > 0) errorMessage += ". It is defined in: ".concat(locations.join(', '));
                    fail(errorMessage + '.');
                }
                isPseudoElement = pseudoElementsEnabled && (isDoubleColon || !isDoubleColon && pseudoElementsSingleColonNotationEnabled && Object.prototype.hasOwnProperty.call(pseudoElementsDefinitions, pseudoName));
                if (isPseudoElement) {
                    var signature = (_a = pseudoElementsDefinitions[pseudoName]) !== null && _a !== void 0 ? _a : pseudoElementsAcceptUnknown && (0, $e589bf2e4bc2ee64$export$2860e7ac7b9acf6d);
                    var pseudoElement = {
                        type: 'PseudoElement',
                        name: pseudoName
                    };
                    var argument = parsePseudoArgument(pseudoName, 'pseudo-element', signature);
                    if (argument) {
                        assert(argument.type !== 'Formula' && argument.type !== 'FormulaOfSelector', 'Pseudo-elements cannot have formula argument.');
                        pseudoElement.argument = argument;
                    }
                    rule.items.push(pseudoElement);
                } else {
                    assert(pseudoClassesEnabled, 'Pseudo-classes are not enabled.');
                    var signature = (_b = pseudoClassesDefinitions[pseudoName]) !== null && _b !== void 0 ? _b : pseudoClassesAcceptUnknown && (0, $e589bf2e4bc2ee64$export$2860e7ac7b9acf6d);
                    if (signature) ;
                    else {
                        // Generate a helpful error message with location information
                        var locations = (0, $f67c0075e21dfa5b$export$dd1b971945cbb3c7).pseudoClasses[pseudoName];
                        var errorMessage = "Unknown pseudo-class: \"".concat(pseudoName, "\"");
                        if (locations && locations.length > 0) errorMessage += ". It is defined in: ".concat(locations.join(', '));
                        fail(errorMessage + '.');
                    }
                    var argument = parsePseudoArgument(pseudoName, 'pseudo-class', signature);
                    var pseudoClass = {
                        type: 'PseudoClass',
                        name: pseudoName
                    };
                    if (argument) pseudoClass.argument = argument;
                    rule.items.push(pseudoClass);
                }
            } else break;
        }
        if (rule.items.length === 0) {
            if (isEof()) return fail('Expected rule but end of input reached.');
            else return fail("Expected rule but \"".concat(chr, "\" found."));
        }
        skipWhitespace();
        if (!isEof() && !is(',') && !is(')')) {
            var combinator = matchMulticharIndex(combinatorsIndex);
            skipWhitespace();
            rule.nestedRule = parseRule();
            rule.nestedRule.combinator = combinator;
        }
        return rule;
    }
    return function(input) {
        // noinspection SuspiciousTypeOfGuard
        if (typeof input !== 'string') throw new Error("".concat($7b881788824fe7ce$var$errorPrefix, "Expected string input."));
        str = input;
        l = str.length;
        pos = 0;
        chr = str.charAt(0);
        return parseSelector();
    };
}



var $b244e34656e25320$var$errorPrefix = "css-selector-parser render error: ";
function $b244e34656e25320$var$renderNamespace(namespace) {
    if (namespace.type === 'WildcardNamespace') return '*|';
    else if (namespace.type === 'NamespaceName') return "".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(namespace.name), "|");
    else if (namespace.type === 'NoNamespace') return '|';
    throw new Error("".concat($b244e34656e25320$var$errorPrefix, "Unknown namespace type: ").concat(namespace.type, "."));
}
function $b244e34656e25320$var$renderSubstitution(sub) {
    return "$".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(sub.name));
}
function $b244e34656e25320$var$renderFormula(a, b) {
    if (a) {
        var result = "".concat(a === 1 ? '' : a === -1 ? '-' : a, "n");
        if (b) result += "".concat(b > 0 ? '+' : '').concat(b);
        return result;
    } else return String(b);
}
function $b244e34656e25320$export$b3890eb0ae9dca99(entity) {
    if (entity.type === 'Selector') return entity.rules.map($b244e34656e25320$export$b3890eb0ae9dca99).join(', ');
    if (entity.type === 'Rule') {
        var result = '';
        var items = entity.items, combinator = entity.combinator, nestedRule = entity.nestedRule;
        if (combinator) result += "".concat(combinator, " ");
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            result += $b244e34656e25320$export$b3890eb0ae9dca99(item);
        }
        if (nestedRule) result += " ".concat($b244e34656e25320$export$b3890eb0ae9dca99(nestedRule));
        return result;
    } else if (entity.type === 'TagName' || entity.type === 'WildcardTag') {
        var result = '';
        var namespace = entity.namespace;
        if (namespace) result += $b244e34656e25320$var$renderNamespace(namespace);
        if (entity.type === 'TagName') result += (0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name);
        else if (entity.type === 'WildcardTag') result += '*';
        return result;
    } else if (entity.type === 'Id') return "#".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name));
    else if (entity.type === 'ClassName') return ".".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name));
    else if (entity.type === 'NestingSelector') return '&';
    else if (entity.type === 'Attribute') {
        var name_1 = entity.name, namespace = entity.namespace, operator = entity.operator, value = entity.value, caseSensitivityModifier = entity.caseSensitivityModifier;
        var result = '[';
        if (namespace) result += $b244e34656e25320$var$renderNamespace(namespace);
        result += (0, $ddae313f2cb96861$export$56fe274825607f4a)(name_1);
        if (operator && value) {
            result += operator;
            if (value.type === 'String') result += (0, $ddae313f2cb96861$export$4148cf4a40af9f34)(value.value);
            else if (value.type === 'Substitution') result += $b244e34656e25320$var$renderSubstitution(value);
            else throw new Error("Unknown attribute value type: ".concat(value.type, "."));
            if (caseSensitivityModifier) result += " ".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(caseSensitivityModifier));
        }
        result += ']';
        return result;
    } else if (entity.type === 'PseudoClass') {
        var name_2 = entity.name, argument = entity.argument;
        var result = ":".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(name_2));
        if (argument) result += "(".concat(argument.type === 'String' ? (0, $ddae313f2cb96861$export$56fe274825607f4a)(argument.value) : $b244e34656e25320$export$b3890eb0ae9dca99(argument), ")");
        return result;
    } else if (entity.type === 'PseudoElement') {
        var name_3 = entity.name, argument = entity.argument;
        var result = "::".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(name_3));
        if (argument) result += "(".concat(argument.type === 'String' ? (0, $ddae313f2cb96861$export$56fe274825607f4a)(argument.value) : $b244e34656e25320$export$b3890eb0ae9dca99(argument), ")");
        return result;
    } else if (entity.type === 'String') throw new Error("".concat($b244e34656e25320$var$errorPrefix, "String cannot be rendered outside of context."));
    else if (entity.type === 'Formula') return $b244e34656e25320$var$renderFormula(entity.a, entity.b);
    else if (entity.type === 'FormulaOfSelector') return $b244e34656e25320$var$renderFormula(entity.a, entity.b) + ' of ' + $b244e34656e25320$export$b3890eb0ae9dca99(entity.selector);
    else if (entity.type === 'Substitution') return "$".concat((0, $ddae313f2cb96861$export$56fe274825607f4a)(entity.name));
    throw new Error("Unknown type specified to render method: ".concat(entity.type, "."));
}


var $42408b66c0c1394b$var$__assign = undefined && undefined.__assign || function() {
    $42408b66c0c1394b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $42408b66c0c1394b$var$__assign.apply(this, arguments);
};
function $42408b66c0c1394b$var$astMethods(type) {
    return function(generatorName, checkerName) {
        var _a;
        return _a = {}, _a[generatorName] = function(props) {
            return $42408b66c0c1394b$var$__assign({
                type: type
            }, props);
        }, _a[checkerName] = function(entity) {
            return typeof entity === 'object' && entity !== null && entity.type === type;
        }, _a;
    };
}
var $42408b66c0c1394b$export$240a2ee49d1b21d = $42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign($42408b66c0c1394b$var$__assign({}, $42408b66c0c1394b$var$astMethods('Selector')('selector', 'isSelector')), $42408b66c0c1394b$var$astMethods('Rule')('rule', 'isRule')), $42408b66c0c1394b$var$astMethods('TagName')('tagName', 'isTagName')), $42408b66c0c1394b$var$astMethods('Id')('id', 'isId')), $42408b66c0c1394b$var$astMethods('ClassName')('className', 'isClassName')), $42408b66c0c1394b$var$astMethods('WildcardTag')('wildcardTag', 'isWildcardTag')), $42408b66c0c1394b$var$astMethods('NamespaceName')('namespaceName', 'isNamespaceName')), $42408b66c0c1394b$var$astMethods('WildcardNamespace')('wildcardNamespace', 'isWildcardNamespace')), $42408b66c0c1394b$var$astMethods('NoNamespace')('noNamespace', 'isNoNamespace')), $42408b66c0c1394b$var$astMethods('NestingSelector')('nestingSelector', 'isNestingSelector')), $42408b66c0c1394b$var$astMethods('Attribute')('attribute', 'isAttribute')), $42408b66c0c1394b$var$astMethods('PseudoClass')('pseudoClass', 'isPseudoClass')), $42408b66c0c1394b$var$astMethods('PseudoElement')('pseudoElement', 'isPseudoElement')), $42408b66c0c1394b$var$astMethods('String')('string', 'isString')), $42408b66c0c1394b$var$astMethods('Formula')('formula', 'isFormula')), $42408b66c0c1394b$var$astMethods('FormulaOfSelector')('formulaOfSelector', 'isFormulaOfSelector')), $42408b66c0c1394b$var$astMethods('Substitution')('substitution', 'isSubstitution'));


var $a150759246302970$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $a150759246302970$export$df3f009e3d155b20(node, visitor) {
    var visitorObj = typeof visitor === 'function' ? {
        enter: visitor
    } : visitor;
    var state = {
        visitor: visitorObj,
        parents: []
    };
    $a150759246302970$var$visitNode(node, state, undefined, undefined, undefined);
}
/**
 * Visits a single node and its children.
 */ function $a150759246302970$var$visitNode(node, state, parent, key, index) {
    var context = {
        node: node,
        parent: parent,
        parents: $a150759246302970$var$__spreadArray([], state.parents, true),
        key: key,
        index: index
    };
    // Call enter hook
    var skipChildren = false;
    if (state.visitor.enter) {
        var result = state.visitor.enter(node, context);
        if (result === false) skipChildren = true;
    }
    // Visit children unless skipped
    if (!skipChildren) {
        state.parents.push(node);
        $a150759246302970$var$visitChildren(node, state);
        state.parents.pop();
    }
    // Call exit hook
    if (state.visitor.exit) state.visitor.exit(node, context);
}
/**
 * Visits all children of a node based on its type.
 */ function $a150759246302970$var$visitChildren(node, state) {
    switch(node.type){
        case 'Selector':
            $a150759246302970$var$visitSelector(node, state);
            break;
        case 'Rule':
            $a150759246302970$var$visitRule(node, state);
            break;
        case 'TagName':
            $a150759246302970$var$visitTagName(node, state);
            break;
        case 'WildcardTag':
            $a150759246302970$var$visitWildcardTag(node, state);
            break;
        case 'Attribute':
            $a150759246302970$var$visitAttribute(node, state);
            break;
        case 'PseudoClass':
            $a150759246302970$var$visitPseudoClass(node, state);
            break;
        case 'PseudoElement':
            $a150759246302970$var$visitPseudoElement(node, state);
            break;
        case 'FormulaOfSelector':
            $a150759246302970$var$visitFormulaOfSelector(node, state);
            break;
        // Leaf nodes with no children
        case 'Id':
        case 'ClassName':
        case 'NamespaceName':
        case 'WildcardNamespace':
        case 'NoNamespace':
        case 'NestingSelector':
        case 'String':
        case 'Formula':
        case 'Substitution':
            break;
    }
}
function $a150759246302970$var$visitSelector(node, state) {
    node.rules.forEach(function(rule, index) {
        $a150759246302970$var$visitNode(rule, state, node, 'rules', index);
    });
}
function $a150759246302970$var$visitRule(node, state) {
    node.items.forEach(function(item, index) {
        $a150759246302970$var$visitNode(item, state, node, 'items', index);
    });
    if (node.nestedRule) $a150759246302970$var$visitNode(node.nestedRule, state, node, 'nestedRule', undefined);
}
function $a150759246302970$var$visitTagName(node, state) {
    if (node.namespace) $a150759246302970$var$visitNode(node.namespace, state, node, 'namespace', undefined);
}
function $a150759246302970$var$visitWildcardTag(node, state) {
    if (node.namespace) $a150759246302970$var$visitNode(node.namespace, state, node, 'namespace', undefined);
}
function $a150759246302970$var$visitAttribute(node, state) {
    if (node.namespace) $a150759246302970$var$visitNode(node.namespace, state, node, 'namespace', undefined);
    if (node.value) $a150759246302970$var$visitNode(node.value, state, node, 'value', undefined);
}
function $a150759246302970$var$visitPseudoClass(node, state) {
    if (node.argument) $a150759246302970$var$visitNode(node.argument, state, node, 'argument', undefined);
}
function $a150759246302970$var$visitPseudoElement(node, state) {
    if (node.argument) $a150759246302970$var$visitNode(node.argument, state, node, 'argument', undefined);
}
function $a150759246302970$var$visitFormulaOfSelector(node, state) {
    $a150759246302970$var$visitNode(node.selector, state, node, 'selector', undefined);
}




const $4124eb6fe7464b38$var$cssSelectorParse = (0, $7b881788824fe7ce$export$88a1156fad04455f)({
    syntax: 'selectors-4'
});
function $4124eb6fe7464b38$export$98e6a39c04603d36(selector) {
    if (typeof selector !== 'string') throw new TypeError('Expected `string` as selector, not `' + selector + '`');
    return $4124eb6fe7464b38$var$cssSelectorParse(selector);
}


/**
 * @import {AstRule} from 'css-selector-parser'
 * @import {Element, Nodes, Parents} from 'hast'
 * @import {State} from './index.js'
 */ /**
 * @typedef Counts
 *   Info on elements in a parent.
 * @property {number} count
 *   Number of elements.
 * @property {Map<string, number>} types
 *   Number of elements by tag name.
 *
 * @typedef Nest
 *   Rule sets by nesting.
 * @property {Array<AstRule> | undefined} adjacentSibling
 *   `a + b`
 * @property {Array<AstRule> | undefined} descendant
 *   `a b`
 * @property {Array<AstRule> | undefined} directChild
 *   `a > b`
 * @property {Array<AstRule> | undefined} generalSibling
 *   `a ~ b`
 */ /**
 * @import {Visitor} from 'unist-util-visit'
 * @import {ElementContent, Nodes} from 'hast'
 * @import {Direction, State} from './index.js'
 */ const $0db0f7d85151f24d$var$rtlRange = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
const $0db0f7d85151f24d$var$ltrRange = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
/* eslint-disable no-misleading-character-class */ const $0db0f7d85151f24d$var$rtl = new RegExp('^[^' + $0db0f7d85151f24d$var$ltrRange + ']*[' + $0db0f7d85151f24d$var$rtlRange + ']');
const $0db0f7d85151f24d$var$ltr = new RegExp('^[^' + $0db0f7d85151f24d$var$rtlRange + ']*[' + $0db0f7d85151f24d$var$ltrRange + ']');
function $0db0f7d85151f24d$export$9fddb9d0dd7d8a54(value) {
    const source = String(value || '');
    return $0db0f7d85151f24d$var$rtl.test(source) ? 'rtl' : $0db0f7d85151f24d$var$ltr.test(source) ? 'ltr' : 'neutral';
}





function $b8abdcb0edb929ec$export$b6a91203b6b36f(state, node) {
    const schema = state.schema;
    const language = state.language;
    const currentDirection = state.direction;
    const editableOrEditingHost = state.editableOrEditingHost;
    /** @type {Direction | undefined} */ let directionInferred;
    if (node.type === 'element') {
        const lang = node.properties.xmlLang || node.properties.lang;
        const type = node.properties.type || 'text';
        const direction = $b8abdcb0edb929ec$var$directionProperty(node);
        if (lang !== null && lang !== undefined) state.language = String(lang);
        if (schema && schema.space === 'html') {
            if (node.properties.contentEditable === 'true') state.editableOrEditingHost = true;
            if (node.tagName === 'svg') state.schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
            // See: <https://html.spec.whatwg.org/#the-directionality>.
            // Explicit `[dir=rtl]`.
            if (direction === 'rtl') directionInferred = direction;
            else if (// Explicit `[dir=ltr]`.
            direction === 'ltr' || // HTML with an invalid or no `[dir]`.
            direction !== 'auto' && node.tagName === 'html' || // `input[type=tel]` with an invalid or no `[dir]`.
            direction !== 'auto' && node.tagName === 'input' && type === 'tel') directionInferred = 'ltr';
            else if (direction === 'auto' || node.tagName === 'bdi') {
                if (node.tagName === 'textarea') // Check contents of `<textarea>`.
                directionInferred = $b8abdcb0edb929ec$var$directionBidi((0, $58714581718e6349$export$f84e8e69fd4488a5)(node));
                else if (node.tagName === 'input' && (type === 'email' || type === 'search' || type === 'tel' || type === 'text')) // Check value of `<input>`.
                directionInferred = node.properties.value ? $b8abdcb0edb929ec$var$directionBidi(String(node.properties.value)) : 'ltr';
                else // Check text nodes in `node`.
                (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(node, inferDirectionality);
            }
            if (directionInferred) state.direction = directionInferred;
        } else if (state.editableOrEditingHost) state.editableOrEditingHost = false;
    }
    return reset;
    /**
   * @returns {undefined}
   *   Nothing.
   */ function reset() {
        state.schema = schema;
        state.language = language;
        state.direction = currentDirection;
        state.editableOrEditingHost = editableOrEditingHost;
    }
    /** @type {Visitor<ElementContent>} */ function inferDirectionality(child) {
        if (child.type === 'text') {
            directionInferred = $b8abdcb0edb929ec$var$directionBidi(child.value);
            return directionInferred ? (0, $9ef2eaca0b34953c$export$7f100f842f565dc9) : undefined;
        }
        if (child !== node && child.type === 'element' && (child.tagName === 'bdi' || child.tagName === 'script' || child.tagName === 'style' || child.tagName === 'textare' || $b8abdcb0edb929ec$var$directionProperty(child))) return 0, $9ef2eaca0b34953c$export$8773f85c2fb2c116;
    }
}
/**
 * See `wooorm/direction`.
 *
 * @param {string} value
 *   Value to check.
 * @returns {Exclude<Direction, 'auto'> | undefined}
 *   Directionality.
 */ function $b8abdcb0edb929ec$var$directionBidi(value) {
    const result = (0, $0db0f7d85151f24d$export$9fddb9d0dd7d8a54)(value);
    return result === 'neutral' ? undefined : result;
}
/**
 * @param {ElementContent} node
 *   Node to check.
 * @returns {Direction | undefined}
 *   Directionality.
 */ function $b8abdcb0edb929ec$var$directionProperty(node) {
    const value = node.type === 'element' && typeof node.properties.dir === 'string' ? node.properties.dir.toLowerCase() : undefined;
    return value === 'auto' || value === 'ltr' || value === 'rtl' ? value : undefined;
}


/**
 * @import {AstRule} from 'css-selector-parser'
 * @import {Element, Parents} from 'hast'
 * @import {State} from './index.js'
 */ /**
 * @import {AstAttribute} from 'css-selector-parser'
 * @import {Element, Properties} from 'hast'
 * @import {Info, Schema} from 'property-information'
 */ 



function $1e9a7b5843ff9cc5$export$af4b9a83f4b00434(query, element, schema) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(schema, query.name);
    const propertyValue = element.properties[info.property];
    let value = $1e9a7b5843ff9cc5$var$normalizeValue(propertyValue, info);
    // Exists.
    if (!query.value) return value !== undefined;
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.value.type === 'String', 'expected plain string');
    let key = query.value.value;
    // Case-sensitivity.
    if (query.caseSensitivityModifier === 'i') {
        key = key.toLowerCase();
        if (value) value = value.toLowerCase();
    }
    if (value !== undefined) switch(query.operator){
        // Exact.
        case '=':
            return key === value;
        // Ends.
        case '$=':
            return key === value.slice(-key.length);
        // Contains.
        case '*=':
            return value.includes(key);
        // Begins.
        case '^=':
            return key === value.slice(0, key.length);
        // Exact or prefix.
        case '|=':
            return key === value || key === value.slice(0, key.length) && value.charAt(key.length) === '-';
        // Space-separated list.
        case '~=':
            return(// For all other values (including comma-separated lists), return whether this
            // is an exact match.
            key === value || // If this is a space-separated list, and the query is contained in it, return
            // true.
            $0d98344a9bfa0653$export$98e6a39c04603d36(value).includes(key));
    }
    return false;
}
/**
 *
 * @param {Properties[keyof Properties]} value
 * @param {Info} info
 * @returns {string | undefined}
 */ function $1e9a7b5843ff9cc5$var$normalizeValue(value, info) {
    if (value === null || value === undefined) ;
    else if (typeof value === 'boolean') {
        if (value) return info.attribute;
    } else if (Array.isArray(value)) {
        if (value.length > 0) return (info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737) : $0d98344a9bfa0653$export$fac44ee5b035f737)(value);
    } else return String(value);
}


/**
 * @import {AstClassName} from 'css-selector-parser'
 * @import {Element} from 'hast'
 */ /** @type {Array<never>} */ const $693ce8a7cf643383$var$emptyClassNames = [];
function $693ce8a7cf643383$export$2913c0c0b5623090(query, element) {
    // Assume array.
    const value = /** @type {Readonly<Array<string>>} */ element.properties.className || $693ce8a7cf643383$var$emptyClassNames;
    return value.includes(query.name);
}


/**
 * @import {AstId} from 'css-selector-parser'
 * @import {Element} from 'hast'
 */ /**
 * Check whether an element has an ID.
 *
 * @param {AstId} query
 *   AST rule (with `ids`).
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $0d66214d99d2cbfa$export$d560c7e4a29451c2(query, element) {
    return element.properties.id === query.name;
}


/**
 * @import {AstTagName} from 'css-selector-parser'
 * @import {Element} from 'hast'
 */ /**
 * Check whether an element has a tag name.
 *
 * @param {AstTagName} query
 *   AST rule (with `tag`).
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $22aadedf983dfddd$export$a8ff84c12d48cfa6(query, element) {
    return query.name === element.tagName;
}


/**
 * @import {AstPseudoClass} from 'css-selector-parser'
 * @import {default as NthCheck} from 'nth-check'
 * @import {ElementContent, Element, Parents} from 'hast'
 * @import {State} from './index.js'
 */ 

/**
 * See <https://tools.ietf.org/html/rfc4647#section-3.1>
 * for more info on the algorithms.
 */ /**
 * @typedef {string} Tag
 *   BCP-47 tag.
 * @typedef {Array<Tag>} Tags
 *   List of BCP-47 tags.
 * @typedef {string} Range
 *   RFC 4647 range.
 * @typedef {Array<Range>} Ranges
 *   List of RFC 4647 range.
 *
 * @callback Check
 *   An internal check.
 * @param {Tag} tag
 *   BCP-47 tag.
 * @param {Range} range
 *   RFC 4647 range.
 * @returns {boolean}
 *   Whether the range matches the tag.
 *
 * @typedef {FilterOrLookup<true>} Filter
 *   Filter: yields all tags that match a range.
 * @typedef {FilterOrLookup<false>} Lookup
 *   Lookup: yields the best tag that matches a range.
 */ /**
 * @template {boolean} IsFilter
 *   Whether to filter or perform a lookup.
 * @callback FilterOrLookup
 *   A check.
 * @param {Tag|Tags} tags
 *   One or more BCP-47 tags.
 * @param {Range|Ranges|undefined} [ranges='*']
 *   One or more RFC 4647 ranges.
 * @returns {IsFilter extends true ? Tags : Tag|undefined}
 *   Result.
 */ /**
 * Factory to perform a filter or a lookup.
 *
 * This factory creates a function that accepts a list of tags and a list of
 * ranges, and contains logic to exit early for lookups.
 * `check` just has to deal with one tag and one range.
 * This match function iterates over ranges, and for each range,
 * iterates over tags.
 * That way, earlier ranges matching any tag have precedence over later ranges.
 *
 * @template {boolean} IsFilter
 * @param {Check} check
 *   A check.
 * @param {IsFilter} filter
 *   Whether to filter or perform a lookup.
 * @returns {FilterOrLookup<IsFilter>}
 *   Filter or lookup.
 */ function $b87ec220e0070103$var$factory(check, filter) {
    /**
   * @param {Tag|Tags} tags
   *   One or more BCP-47 tags.
   * @param {Range|Ranges|undefined} [ranges='*']
   *   One or more RFC 4647 ranges.
   * @returns {IsFilter extends true ? Tags : Tag|undefined}
   *   Result.
   */ return function(tags, ranges) {
        let left = $b87ec220e0070103$var$cast(tags, 'tag');
        const right = $b87ec220e0070103$var$cast(ranges === null || ranges === undefined ? '*' : ranges, 'range');
        /** @type {Tags} */ const matches = [];
        let rightIndex = -1;
        while(++rightIndex < right.length){
            const range = right[rightIndex].toLowerCase();
            // Ignore wildcards in lookup mode.
            if (!filter && range === '*') continue;
            let leftIndex = -1;
            /** @type {Tags} */ const next = [];
            while(++leftIndex < left.length)if (check(left[leftIndex].toLowerCase(), range)) {
                // Exit if this is a lookup and we have a match.
                if (!filter) return /** @type {IsFilter extends true ? Tags : Tag|undefined} */ left[leftIndex];
                matches.push(left[leftIndex]);
            } else next.push(left[leftIndex]);
            left = next;
        }
        // If this is a filter, return the list.  If it’s a lookup, we didn’t find
        // a match, so return `undefined`.
        return /** @type {IsFilter extends true ? Tags : Tag|undefined} */ filter ? matches : undefined;
    };
}
const $b87ec220e0070103$export$454d02d943c45292 = $b87ec220e0070103$var$factory(function(tag, range) {
    return range === '*' || tag === range || tag.includes(range + '-');
}, true);
const $b87ec220e0070103$export$d216e65da1a9aa7e = $b87ec220e0070103$var$factory(function(tag, range) {
    // 3.3.2.1
    const left = tag.split('-');
    const right = range.split('-');
    let leftIndex = 0;
    let rightIndex = 0;
    // 3.3.2.2
    if (right[rightIndex] !== '*' && left[leftIndex] !== right[rightIndex]) return false;
    leftIndex++;
    rightIndex++;
    // 3.3.2.3
    while(rightIndex < right.length){
        // 3.3.2.3.A
        if (right[rightIndex] === '*') {
            rightIndex++;
            continue;
        }
        // 3.3.2.3.B
        if (!left[leftIndex]) return false;
        // 3.3.2.3.C
        if (left[leftIndex] === right[rightIndex]) {
            leftIndex++;
            rightIndex++;
            continue;
        }
        // 3.3.2.3.D
        if (left[leftIndex].length === 1) return false;
        // 3.3.2.3.E
        leftIndex++;
    }
    // 3.3.2.4
    return true;
}, true);
const $b87ec220e0070103$export$dfc7155ac0343b8 = $b87ec220e0070103$var$factory(function(tag, range) {
    let right = range;
    /* eslint-disable-next-line no-constant-condition */ while(true){
        if (right === '*' || tag === right) return true;
        let index = right.lastIndexOf('-');
        if (index < 0) return false;
        if (right.charAt(index - 2) === '-') index -= 2;
        right = right.slice(0, index);
    }
}, false);
/**
 * Validate tags or ranges, and cast them to arrays.
 *
 * @param {string|Array<string>} values
 * @param {string} name
 * @returns {Array<string>}
 */ function $b87ec220e0070103$var$cast(values, name) {
    const value = values && typeof values === 'string' ? [
        values
    ] : values;
    if (!value || typeof value !== 'object' || !('length' in value)) throw new Error('Invalid ' + name + ' `' + value + '`, expected non-empty string');
    return value;
}




/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 */ const $faf93996c771049f$var$own = {}.hasOwnProperty;
function $faf93996c771049f$export$bf9617eaf5d2451(node, name) {
    const value = node.type === 'element' && $faf93996c771049f$var$own.call(node.properties, name) && node.properties[name];
    return value !== null && value !== undefined && value !== false;
}



// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
const $0cd817c59cf7d5e8$var$whitespace = new Set([
    9,
    10,
    12,
    13,
    32
]);
const $0cd817c59cf7d5e8$var$ZERO = "0".charCodeAt(0);
const $0cd817c59cf7d5e8$var$NINE = "9".charCodeAt(0);
function $0cd817c59cf7d5e8$export$98e6a39c04603d36(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") return [
        2,
        0
    ];
    else if (formula === "odd") return [
        2,
        1
    ];
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    let idx = 0;
    let a = 0;
    let sign = readSign();
    let number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        } else sign = number = 0;
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) throw new Error(`n-th rule couldn't be parsed ('${formula}')`);
    return [
        a,
        sign * number
    ];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") idx++;
        return 1;
    }
    function readNumber() {
        const start = idx;
        let value = 0;
        while(idx < formula.length && formula.charCodeAt(idx) >= $0cd817c59cf7d5e8$var$ZERO && formula.charCodeAt(idx) <= $0cd817c59cf7d5e8$var$NINE){
            value = value * 10 + (formula.charCodeAt(idx) - $0cd817c59cf7d5e8$var$ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while(idx < formula.length && $0cd817c59cf7d5e8$var$whitespace.has(formula.charCodeAt(idx)))idx++;
    }
}


var $b9a70fb689ad7ba3$exports = {};
$b9a70fb689ad7ba3$exports = {
    trueFunc: function trueFunc() {
        return true;
    },
    falseFunc: function falseFunc() {
        return false;
    }
};


function $0a99a8565361a0f1$export$ef7acd7185315e22(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    const b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */ if (b < 0 && a <= 0) return (0, (/*@__PURE__*/$parcel$interopDefault($b9a70fb689ad7ba3$exports))).falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1) return (index)=>index <= b;
    if (a === 0) return (index)=>index === b;
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1) return b < 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($b9a70fb689ad7ba3$exports))).trueFunc : (index)=>index >= b;
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */ const absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    const bMod = (b % absA + absA) % absA;
    return a > 1 ? (index)=>index >= b && index % absA === bMod : (index)=>index <= b && index % absA === bMod;
}
function $0a99a8565361a0f1$export$80d376111cc09ad7(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    let b = parsed[1] - 1;
    let n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        const aPos = -a;
        // Get `b mod a`
        const minValue = (b % aPos + aPos) % aPos;
        return ()=>{
            const val = minValue + aPos * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0) return b < 0 ? ()=>null : ()=>n++ === 0 ? b : null;
    if (b < 0) b += a * Math.ceil(-b / a);
    return ()=>a * n++ + b;
}


function $afef59663c7fe1ad$export$2e2bcd8739ae039(formula) {
    return (0, $0a99a8565361a0f1$export$ef7acd7185315e22)((0, $0cd817c59cf7d5e8$export$98e6a39c04603d36)(formula));
}
function $afef59663c7fe1ad$export$49bb65c2ea163039(formula) {
    return (0, $0a99a8565361a0f1$export$80d376111cc09ad7)((0, $0cd817c59cf7d5e8$export$98e6a39c04603d36)(formula));
}


/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $17810db8694da3f3$var$own = {}.hasOwnProperty;
function $17810db8694da3f3$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $17810db8694da3f3$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $17810db8694da3f3$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}



/** @type {NthCheck} */ // @ts-expect-error: types are broken.
const $a5b05a26e79bd4e7$var$nthCheck = (0, $afef59663c7fe1ad$export$2e2bcd8739ae039).default || (0, $afef59663c7fe1ad$export$2e2bcd8739ae039);
const $a5b05a26e79bd4e7$export$4a40d01fa098dd92 = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('name', {
    handlers: {
        'any-link': $a5b05a26e79bd4e7$var$anyLink,
        blank: $a5b05a26e79bd4e7$var$blank,
        checked: $a5b05a26e79bd4e7$var$checked,
        dir: $a5b05a26e79bd4e7$var$dir,
        disabled: $a5b05a26e79bd4e7$var$disabled,
        empty: $a5b05a26e79bd4e7$var$empty,
        enabled: $a5b05a26e79bd4e7$var$enabled,
        'first-child': $a5b05a26e79bd4e7$var$firstChild,
        'first-of-type': $a5b05a26e79bd4e7$var$firstOfType,
        has: $a5b05a26e79bd4e7$var$has,
        is: $a5b05a26e79bd4e7$var$is,
        lang: $a5b05a26e79bd4e7$var$lang,
        'last-child': $a5b05a26e79bd4e7$var$lastChild,
        'last-of-type': $a5b05a26e79bd4e7$var$lastOfType,
        not: $a5b05a26e79bd4e7$var$not,
        'nth-child': $a5b05a26e79bd4e7$var$nthChild,
        'nth-last-child': $a5b05a26e79bd4e7$var$nthLastChild,
        'nth-last-of-type': $a5b05a26e79bd4e7$var$nthLastOfType,
        'nth-of-type': $a5b05a26e79bd4e7$var$nthOfType,
        'only-child': $a5b05a26e79bd4e7$var$onlyChild,
        'only-of-type': $a5b05a26e79bd4e7$var$onlyOfType,
        optional: $a5b05a26e79bd4e7$var$optional,
        'read-only': $a5b05a26e79bd4e7$var$readOnly,
        'read-write': $a5b05a26e79bd4e7$var$readWrite,
        required: $a5b05a26e79bd4e7$var$required,
        root: $a5b05a26e79bd4e7$var$root,
        scope: $a5b05a26e79bd4e7$var$scope
    },
    invalid: $a5b05a26e79bd4e7$var$invalidPseudo,
    unknown: $a5b05a26e79bd4e7$var$unknownPseudo
});
/**
 * Check whether an element matches an `:any-link` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$anyLink(_, element) {
    return (element.tagName === 'a' || element.tagName === 'area' || element.tagName === 'link') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'href');
}
/**
 * @param {State} state
 *   State.
 * @param {AstPseudoClass} query
 *   Query.
 */ function $a5b05a26e79bd4e7$var$assertDeep(state, query) {
    if (state.shallow) throw new Error('Cannot use `:' + query.name + '` without parent');
}
/**
 * Check whether an element matches a `:blank` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$blank(_, element) {
    return !$a5b05a26e79bd4e7$var$someChildren(element, check);
    /**
   * @param {ElementContent} child
   * @returns {boolean}
   */ function check(child) {
        return child.type === 'element' || child.type === 'text' && !(0, $99728b3b7e804493$export$7af1228ff777d175)(child);
    }
}
/**
 * Check whether an element matches a `:checked` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$checked(_, element) {
    if (element.tagName === 'input' || element.tagName === 'menuitem') return Boolean((element.properties.type === 'checkbox' || element.properties.type === 'radio') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'checked'));
    if (element.tagName === 'option') return (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'selected');
    return false;
}
/**
 * Check whether an element matches a `:dir()` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ // eslint-disable-next-line unicorn/prevent-abbreviations
function $a5b05a26e79bd4e7$var$dir(query, _1, _2, _3, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'String', 'expected plain text');
    return state.direction === query.argument.value;
}
/**
 * Check whether an element matches a `:disabled` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$disabled(_, element) {
    return (element.tagName === 'button' || element.tagName === 'input' || element.tagName === 'select' || element.tagName === 'textarea' || element.tagName === 'optgroup' || element.tagName === 'option' || element.tagName === 'menuitem' || element.tagName === 'fieldset') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'disabled');
}
/**
 * Check whether an element matches an `:empty` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$empty(_, element) {
    return !$a5b05a26e79bd4e7$var$someChildren(element, check);
    /**
   * @param {ElementContent} child
   * @returns {boolean}
   */ function check(child) {
        return child.type === 'element' || child.type === 'text';
    }
}
/**
 * Check whether an element matches an `:enabled` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$enabled(query, element) {
    return !$a5b05a26e79bd4e7$var$disabled(query, element);
}
/**
 * Check whether an element matches a `:first-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$firstChild(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.elementIndex === 0;
}
/**
 * Check whether an element matches a `:first-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$firstOfType(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.typeIndex === 0;
}
/**
 * @param {AstPseudoClass} query
 *   Query.
 * @returns {(value: number) => boolean}
 *   N.
 */ function $a5b05a26e79bd4e7$var$getCachedNthCheck(query) {
    /** @type {(value: number) => boolean} */ // @ts-expect-error: cache.
    let cachedFunction = query._cachedFn;
    if (!cachedFunction) {
        const value = query.argument;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(value, 'expected `argument`');
        if (value.type !== 'Formula') throw new Error('Expected `nth` formula, such as `even` or `2n+1` (`of` is not yet supported)');
        cachedFunction = $a5b05a26e79bd4e7$var$nthCheck(value.a + 'n+' + value.b);
        // @ts-expect-error: cache.
        query._cachedFn = cachedFunction;
    }
    return cachedFunction;
}
/**
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _1
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _2
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$has(query, element, _1, _2, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'Selector', 'expected selector');
    /** @type {State} */ const childState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        // Not found yet.
        found: false,
        // One result is enough.
        one: true,
        results: [],
        rootQuery: query.argument,
        scopeElements: [
            element
        ],
        // Do walk deep.
        shallow: false
    });
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(childState, {
        type: 'root',
        children: element.children
    });
    return childState.results.length > 0;
}
// Shouldn’t be called, parser gives correct data.
/* c8 ignore next 3 */ function $a5b05a26e79bd4e7$var$invalidPseudo() {
    (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Invalid pseudo-selector');
}
/**
 * Check whether an element `:is` further selectors.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _1
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _2
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$is(query, element, _1, _2, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'Selector', 'expected selector');
    /** @type {State} */ const childState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        // Not found yet.
        found: false,
        // One result is enough.
        one: true,
        results: [],
        rootQuery: query.argument,
        scopeElements: [
            element
        ],
        // Do walk deep.
        shallow: false
    });
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(childState, element);
    return childState.results[0] === element;
}
/**
 * Check whether an element matches a `:lang()` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$lang(query, _1, _2, _3, state) {
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument, 'expected `argument`');
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(query.argument.type === 'String', 'expected string');
    return state.language !== '' && state.language !== undefined && (0, $b87ec220e0070103$export$d216e65da1a9aa7e)(state.language, (0, $9323934601145f2e$export$98e6a39c04603d36)(query.argument.value)).length > 0;
}
/**
 * Check whether an element matches a `:last-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$lastChild(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return Boolean(state.elementCount && state.elementIndex === state.elementCount - 1);
}
/**
 * Check whether an element matches a `:last-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$lastOfType(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.typeIndex === 'number' && typeof state.typeCount === 'number' && state.typeIndex === state.typeCount - 1;
}
/**
 * Check whether an element does `:not` match further selectors.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} index
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$not(query, element, index, parent, state) {
    return !$a5b05a26e79bd4e7$var$is(query, element, index, parent, state);
}
/**
 * Check whether an element matches an `:nth-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthChild(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.elementIndex === 'number' && cachedFunction(state.elementIndex);
}
/**
 * Check whether an element matches an `:nth-last-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthLastChild(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return Boolean(typeof state.elementCount === 'number' && typeof state.elementIndex === 'number' && cachedFunction(state.elementCount - state.elementIndex - 1));
}
/**
 * Check whether an element matches a `:nth-last-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthLastOfType(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.typeCount === 'number' && typeof state.typeIndex === 'number' && cachedFunction(state.typeCount - 1 - state.typeIndex);
}
/**
 * Check whether an element matches an `:nth-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$nthOfType(query, _1, _2, _3, state) {
    const cachedFunction = $a5b05a26e79bd4e7$var$getCachedNthCheck(query);
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return typeof state.typeIndex === 'number' && cachedFunction(state.typeIndex);
}
/**
 * Check whether an element matches an `:only-child` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$onlyChild(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.elementCount === 1;
}
/**
 * Check whether an element matches an `:only-of-type` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} _1
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$onlyOfType(query, _1, _2, _3, state) {
    $a5b05a26e79bd4e7$var$assertDeep(state, query);
    return state.typeCount === 1;
}
/**
 * Check whether an element matches an `:optional` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$optional(query, element) {
    return !$a5b05a26e79bd4e7$var$required(query, element);
}
/**
 * Check whether an element matches a `:read-only` pseudo.
 *
 * @param {AstPseudoClass} query
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} index
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$readOnly(query, element, index, parent, state) {
    return !$a5b05a26e79bd4e7$var$readWrite(query, element, index, parent, state);
}
/**
 * Check whether an element matches a `:read-write` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _1
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _2
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$readWrite(_, element, _1, _2, state) {
    return element.tagName === 'input' || element.tagName === 'textarea' ? !(0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'readOnly') && !(0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'disabled') : Boolean(state.editableOrEditingHost);
}
/**
 * Check whether an element matches a `:required` pseudo.
 *
 * @param {AstPseudoClass} _
 *   Query.
 * @param {Element} element
 *   Element.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$required(_, element) {
    return (element.tagName === 'input' || element.tagName === 'textarea' || element.tagName === 'select') && (0, $faf93996c771049f$export$bf9617eaf5d2451)(element, 'required');
}
/**
 * Check whether an element matches a `:root` pseudo.
 *
 * @param {AstPseudoClass} _1
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$root(_1, element, _2, parent, state) {
    return Boolean((!parent || parent.type === 'root') && state.schema && (state.schema.space === 'html' || state.schema.space === 'svg') && (element.tagName === 'html' || element.tagName === 'svg'));
}
/**
 * Check whether an element matches a `:scope` pseudo.
 *
 * @param {AstPseudoClass} _1
 *   Query.
 * @param {Element} element
 *   Element.
 * @param {number | undefined} _2
 *   Index of `element` in `parent`.
 * @param {Parents | undefined} _3
 *   Parent of `element`.
 * @param {State} state
 *   State.
 * @returns {boolean}
 *   Whether `element` matches `query`.
 */ function $a5b05a26e79bd4e7$var$scope(_1, element, _2, _3, state) {
    return state.scopeElements.includes(element);
}
/**
 * Check children.
 *
 * @param {Element} element
 *   Element.
 * @param {(child: ElementContent) => boolean} check
 *   Check.
 * @returns {boolean}
 *   Whether a child of `element` matches `check`.
 */ function $a5b05a26e79bd4e7$var$someChildren(element, check) {
    const children = element.children;
    let index = -1;
    while(++index < children.length){
        if (check(children[index])) return true;
    }
    return false;
}
/**
 * @param {unknown} query_
 *   Query-like value.
 * @returns {never}
 *   Nothing.
 * @throws
 *   Exception.
 */ function $a5b05a26e79bd4e7$var$unknownPseudo(query_) {
    // Runtime JS guarantees it has a `name`.
    const query = /** @type {AstPseudoClass} */ query_;
    throw new Error('Unknown pseudo-selector `' + query.name + '`');
}


function $54886b55b3c045c7$export$e0969da9b8fb378d(query, element, index, parent, state) {
    for (const item of query.items){
        // eslint-disable-next-line unicorn/prefer-switch
        if (item.type === 'Attribute') {
            if (!(0, $1e9a7b5843ff9cc5$export$af4b9a83f4b00434)(item, element, state.schema)) return false;
        } else if (item.type === 'Id') {
            if (!(0, $0d66214d99d2cbfa$export$d560c7e4a29451c2)(item, element)) return false;
        } else if (item.type === 'ClassName') {
            if (!(0, $693ce8a7cf643383$export$2913c0c0b5623090)(item, element)) return false;
        } else if (item.type === 'PseudoClass') {
            if (!(0, $a5b05a26e79bd4e7$export$4a40d01fa098dd92)(item, element, index, parent, state)) return false;
        } else if (item.type === 'PseudoElement') throw new Error('Invalid selector: `::' + item.name + '`');
        else if (item.type === 'TagName') {
            if (!(0, $22aadedf983dfddd$export$a8ff84c12d48cfa6)(item, element)) return false;
        }
    }
    return true;
}


/** @type {Array<never>} */ const $fe3036b5ffa0fe7d$var$empty = [];
function $fe3036b5ffa0fe7d$export$588732934346abbf(state, tree) {
    if (tree) $fe3036b5ffa0fe7d$var$one(state, [], tree, undefined, undefined, tree);
}
/**
 * Add a rule to a nesting map.
 *
 * @param {Nest} nest
 *   Nesting.
 * @param {keyof Nest} field
 *   Field.
 * @param {AstRule} rule
 *   Rule.
 */ function $fe3036b5ffa0fe7d$var$add(nest, field, rule) {
    const list = nest[field];
    if (list) list.push(rule);
    else nest[field] = [
        rule
    ];
}
/**
 * Check in a parent.
 *
 * @param {State} state
 *   State.
 * @param {Nest} nest
 *   Nesting.
 * @param {Parents} node
 *   Parent.
 * @param {Nodes} tree
 *   Tree.
 * @returns {undefined}
 *   Nothing.
 */ function $fe3036b5ffa0fe7d$var$all(state, nest, node, tree) {
    const fromParent = $fe3036b5ffa0fe7d$var$combine(nest.descendant, nest.directChild);
    /** @type {Array<AstRule> | undefined} */ let fromSibling;
    let index = -1;
    /**
   * Total counts.
   * @type {Counts}
   */ const total = {
        count: 0,
        types: new Map()
    };
    /**
   * Counts of previous siblings.
   * @type {Counts}
   */ const before = {
        count: 0,
        types: new Map()
    };
    while(++index < node.children.length)$fe3036b5ffa0fe7d$var$count(total, node.children[index]);
    index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        // Uppercase to prevent prototype polution, injecting `constructor` or so.
        // Normalize because HTML is insensitive.
        const name = child.type === 'element' ? child.tagName.toUpperCase() : undefined;
        // Before counting further elements:
        state.elementIndex = before.count;
        state.typeIndex = name ? before.types.get(name) || 0 : 0;
        // After counting all elements.
        state.elementCount = total.count;
        state.typeCount = name ? total.types.get(name) : 0;
        // Only apply if this is a parent, this should be an element, but we check
        // for parents so that we delve into custom nodes too.
        if ('children' in child) {
            const forSibling = $fe3036b5ffa0fe7d$var$combine(fromParent, fromSibling);
            const nest = $fe3036b5ffa0fe7d$var$one(state, forSibling, node.children[index], index, node, tree);
            fromSibling = $fe3036b5ffa0fe7d$var$combine(nest.generalSibling, nest.adjacentSibling);
        }
        // We found one thing, and one is enough.
        if (state.one && state.found) break;
        $fe3036b5ffa0fe7d$var$count(before, node.children[index]);
    }
}
/**
 * Apply selectors to an element.
 *
 * @param {State} state
 *   Current state.
 * @param {Array<AstRule>} rules
 *   Rules to apply.
 * @param {Element} node
 *   Element to apply rules to.
 * @param {number | undefined} index
 *   Index of `node` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Nest}
 *   Further rules.
 */ function $fe3036b5ffa0fe7d$var$applySelectors(state, rules, node, index, parent) {
    /** @type {Nest} */ const nestResult = {
        adjacentSibling: undefined,
        descendant: undefined,
        directChild: undefined,
        generalSibling: undefined
    };
    let selectorIndex = -1;
    while(++selectorIndex < rules.length){
        const rule = rules[selectorIndex];
        // We found one thing, and one is enough.
        if (state.one && state.found) break;
        // When shallow, we don’t allow nested rules.
        // Idea: we could allow a stack of parents?
        // Might get quite complex though.
        if (state.shallow && rule.nestedRule) throw new Error('Expected selector without nesting');
        // If this rule matches:
        if ((0, $54886b55b3c045c7$export$e0969da9b8fb378d)(rule, node, index, parent, state)) {
            const nest = rule.nestedRule;
            // Are there more?
            if (nest) {
                /** @type {keyof Nest} */ const label = nest.combinator === '+' ? 'adjacentSibling' : nest.combinator === '~' ? 'generalSibling' : nest.combinator === '>' ? 'directChild' : 'descendant';
                $fe3036b5ffa0fe7d$var$add(nestResult, label, nest);
            } else {
                // We have a match!
                state.found = true;
                if (!state.results.includes(node)) state.results.push(node);
            }
        }
        // Descendant.
        if (rule.combinator === undefined) $fe3036b5ffa0fe7d$var$add(nestResult, 'descendant', rule);
        else if (rule.combinator === '~') $fe3036b5ffa0fe7d$var$add(nestResult, 'generalSibling', rule);
    // Drop direct child (`>`), adjacent sibling (`+`).
    }
    return nestResult;
}
/**
 * Combine two lists, if needed.
 *
 * This is optimized to create as few lists as possible.
 *
 * @param {Array<AstRule> | undefined} left
 *   Rules.
 * @param {Array<AstRule> | undefined} right
 *   Rules.
 * @returns {Array<AstRule>}
 *   Rules.
 */ function $fe3036b5ffa0fe7d$var$combine(left, right) {
    return left && right && left.length > 0 && right.length > 0 ? [
        ...left,
        ...right
    ] : left && left.length > 0 ? left : right && right.length > 0 ? right : $fe3036b5ffa0fe7d$var$empty;
}
/**
 * Count a node.
 *
 * @param {Counts} counts
 *   Counts.
 * @param {Nodes} node
 *   Node (we’re looking for elements).
 * @returns {undefined}
 *   Nothing.
 */ function $fe3036b5ffa0fe7d$var$count(counts, node) {
    if (node.type === 'element') {
        // Uppercase to prevent prototype polution, injecting `constructor` or so.
        // Normalize because HTML is insensitive.
        const name = node.tagName.toUpperCase();
        const count = (counts.types.get(name) || 0) + 1;
        counts.count++;
        counts.types.set(name, count);
    }
}
/**
 * Check a node.
 *
 * @param {State} state
 *   State.
 * @param {Array<AstRule>} currentRules
 *   Rules.
 * @param {Nodes} node
 *   Node.
 * @param {number | undefined} index
 *   Index of `node` in `parent`.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @param {Nodes} tree
 *   Tree.
 * @returns {Nest}
 *   Nesting.
 */ function $fe3036b5ffa0fe7d$var$one(state, currentRules, node, index, parent, tree) {
    /** @type {Nest} */ let nestResult = {
        adjacentSibling: undefined,
        descendant: undefined,
        directChild: undefined,
        generalSibling: undefined
    };
    const exit = (0, $b8abdcb0edb929ec$export$b6a91203b6b36f)(state, node);
    if (node.type === 'element') {
        let rootRules = state.rootQuery.rules;
        // Remove direct child rules if this is the root.
        // This only happens for a `:has()` rule, which can be like
        // `a:has(> b)`.
        if (parent && parent !== tree) rootRules = state.rootQuery.rules.filter((d)=>d.combinator === undefined || d.combinator === '>' && parent === tree);
        nestResult = $fe3036b5ffa0fe7d$var$applySelectors(state, // Try the root rules for this element too.
        $fe3036b5ffa0fe7d$var$combine(currentRules, rootRules), node, index, parent);
    }
    // If this is a parent, and we want to delve into them, and we haven’t found
    // our single result yet.
    if ('children' in node && !state.shallow && !(state.one && state.found)) $fe3036b5ffa0fe7d$var$all(state, nestResult, node, tree);
    exit();
    return nestResult;
}


function $ec180a0534485ddf$export$de994efd351b291c(selector, node, space) {
    const state = $ec180a0534485ddf$var$createState(selector, node, space);
    state.one = true;
    state.shallow = true;
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(state, node || undefined);
    return state.results.length > 0;
}
function $ec180a0534485ddf$export$2e6c959c16ff56b8(selector, tree, space) {
    const state = $ec180a0534485ddf$var$createState(selector, tree, space);
    state.one = true;
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(state, tree || undefined);
    return state.results[0];
}
function $ec180a0534485ddf$export$90aca4adda6ff0f5(selector, tree, space) {
    const state = $ec180a0534485ddf$var$createState(selector, tree, space);
    (0, $fe3036b5ffa0fe7d$export$588732934346abbf)(state, tree || undefined);
    return state.results;
}
/**
 * @param {string} selector
 *   CSS selector, such as (`h1`, `a, b`).
 * @param {Nodes | null | undefined} [tree]
 *   Tree to search (optional).
 * @param {Space | null | undefined} [space='html']
 *   Name of namespace (default: `'html'`).
 * @returns {State} State
 *   State.
 */ function $ec180a0534485ddf$var$createState(selector, tree, space) {
    return {
        direction: 'ltr',
        editableOrEditingHost: false,
        elementCount: undefined,
        elementIndex: undefined,
        found: false,
        language: undefined,
        one: false,
        // State of the query.
        results: [],
        rootQuery: (0, $4124eb6fe7464b38$export$98e6a39c04603d36)(selector),
        schema: space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        scopeElements: tree ? tree.type === 'root' ? tree.children : [
            tree
        ] : [],
        shallow: false,
        typeIndex: undefined,
        typeCount: undefined
    };
}


const $bcddeefdf0cb0501$export$fdc2b83d227adb1a = (data = [], code = '')=>{
    data.forEach((node)=>{
        if (node.type === 'text') code += node.value;
        else if (node.type === 'element' && node.children && Array.isArray(node.children)) code += $bcddeefdf0cb0501$export$fdc2b83d227adb1a(node.children);
    });
    return code;
};
const $bcddeefdf0cb0501$var$remarkRewrite = (options)=>{
    const { selector: selector, rewrite: rewrite } = options || {};
    return (tree)=>{
        if (!rewrite || typeof rewrite !== 'function') return;
        if (selector && typeof selector === 'string') {
            const selected = (0, $ec180a0534485ddf$export$90aca4adda6ff0f5)(selector, tree);
            if (selected && selected.length > 0) (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, selected, (node, index, parent)=>{
                rewrite(node, index, parent);
            });
            return;
        }
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node, index, parent)=>{
            rewrite(node, index, parent);
        });
    };
};
var $bcddeefdf0cb0501$export$2e2bcd8739ae039 = $bcddeefdf0cb0501$var$remarkRewrite;




/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
function $6975da2fd2d5971c$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}




const $b0cad0253fcc653e$export$23a35a76cb919b24 = (url = '')=>(url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce((a, v)=>(a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1), a), {});
const $b0cad0253fcc653e$export$7a7e2ad9b538cb5a = (data = [], index)=>{
    let i = index;
    while(i > -1){
        i--;
        if (!data[i]) return;
        if (data[i] && data[i].value && data[i].value.replace(/(\n|\s)/g, '') !== '' || data[i].type !== 'text') {
            if (!/^rehype:/.test(data[i].value) || data[i].type !== 'comment') return;
            return data[i];
        }
    }
    return;
};
const $b0cad0253fcc653e$export$dc55241c2417fab = (data = [], index, tagName, commentStart = "<!--", commentEnd = "-->")=>{
    let i = index;
    while(i < data.length){
        i++;
        if (tagName) {
            const element = data[i];
            if (element && element.value && element.value.replace(/(\n|\s)/g, '') !== '' || data[i] && data[i].type === 'element') return element.tagName === tagName ? element : undefined;
        } else {
            const element = data[i];
            if (!element || element.type === 'element') return;
            if (element.type === 'text') {
                const nextNode = $b0cad0253fcc653e$export$dc55241c2417fab(data, i, undefined);
                if (nextNode) return nextNode;
            }
            if (element.type && /^(comment|raw|text)$/ig.test(element.type)) {
                const regx = new RegExp(`^(\s+)?${commentStart}(.*?)${commentEnd}`);
                if (element.value && !/^rehype:/.test(element.value.replace(/^(\n|\s)+/, '').replace(regx, '$2') || '')) return;
                let comment = element.value.replace(/^(\n|\s)+/, '');
                element.value = comment;
                return element;
            }
        }
    }
    return;
};
const $b0cad0253fcc653e$export$4c884b6086c3192e = ({ value: value = '' }, start = "<!--", end = "-->")=>{
    let regx;
    try {
        // Construct a regular expression to match the comment content
        regx = new RegExp(`^${start}(.*?)${end}`);
    } catch (error) {
        return {};
    }
    const match = value.match(regx);
    const content = match ? match[1] : value;
    // Extract the comment content if it matches the regular expression
    const commentContent = content.replace(/^rehype:/, '');
    // Extract the comment content and parse it into a parameter object
    const param = $b0cad0253fcc653e$export$23a35a76cb919b24(commentContent);
    // Iterate over the key-value pairs of the parameter object and perform type conversion
    Object.keys(param).forEach((keyName)=>{
        if (param[keyName] === 'true') param[keyName] = true;
        else if (param[keyName] === 'false') param[keyName] = false;
        else if (typeof param[keyName] === 'string' && !/^0/.test(param[keyName]) && !isNaN(+param[keyName])) param[keyName] = +param[keyName];
    });
    // Return the processed parameter object
    return param;
};
const $b0cad0253fcc653e$export$2238984c2c06f712 = (defaultAttrs, attrs, type)=>{
    if (type === 'string') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultAttrs), {
        'data-config': JSON.stringify((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attrs), {
            rehyp: true
        }))
    });
    else if (type === 'attr') return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultAttrs, attrs);
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultAttrs), {
        'data-config': (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attrs), {
            rehyp: true
        })
    });
};


const $d80b7298c6dd9c3b$var$rehypeAttrs = (options = {})=>{
    const { properties: properties = 'data', codeBlockParames: codeBlockParames = true, commentStart: commentStart = "<!--", commentEnd: commentEnd = "-->" } = options;
    return (tree)=>{
        (0, $6975da2fd2d5971c$export$bf638b60ea8b89b7)(tree, 'element', (node, index, parent)=>{
            if (codeBlockParames && node.tagName === 'pre' && node && Array.isArray(node.children) && parent && Array.isArray(parent.children) && parent.children.length > 1) {
                const firstChild = node.children[0];
                if (firstChild && firstChild.tagName === 'code' && typeof index === 'number') {
                    const child = (0, $b0cad0253fcc653e$export$7a7e2ad9b538cb5a)(parent.children, index);
                    if (child) {
                        const attr = (0, $b0cad0253fcc653e$export$4c884b6086c3192e)(child, commentStart, commentEnd);
                        if (Object.keys(attr).length > 0) {
                            node.properties = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, node.properties), {
                                'data-type': 'rehyp'
                            });
                            firstChild.properties = (0, $b0cad0253fcc653e$export$2238984c2c06f712)(firstChild.properties, attr, properties);
                        }
                    }
                }
            }
            let rootnode = parent;
            if ((/^(em|strong|b|a|i|p|pre|kbd|blockquote|h(1|2|3|4|5|6)|code|table|img|del|ul|ol)$/.test(node.tagName) || rootnode.type == "root") && parent && Array.isArray(parent.children) && typeof index === 'number') {
                const child = (0, $b0cad0253fcc653e$export$dc55241c2417fab)(parent.children, index, '', commentStart, commentEnd);
                if (child) {
                    const attr = (0, $b0cad0253fcc653e$export$4c884b6086c3192e)(child, commentStart, commentEnd);
                    if (Object.keys(attr).length > 0) node.properties = (0, $b0cad0253fcc653e$export$2238984c2c06f712)(node.properties, attr, properties);
                }
            }
        });
    };
};
var $d80b7298c6dd9c3b$export$2e2bcd8739ae039 = $d80b7298c6dd9c3b$var$rehypeAttrs;


/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} RawOptions
 * @typedef {import('vfile').VFile} VFile
 */ /**
 * @typedef {Omit<RawOptions, 'file'>} Options
 *   Configuration.
 */ 

/**
 * @import {Options} from 'hast-util-raw'
 * @import {Comment, Doctype, Element, Nodes, RootContent, Root, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {DefaultTreeAdapterMap, ParserOptions} from 'parse5'
 * @import {Point} from 'unist'
 */ /**
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Nodes) => undefined} handle
 *   Add a hast node to the parser.
 * @property {Options} options
 *   User configuration.
 * @property {Parser<DefaultTreeAdapterMap>} parser
 *   Current parser.
 * @property {boolean} stitches
 *   Whether there are stitches.
 */ /**
 * @typedef Stitch
 *   Custom comment-like value we pass through parse5, which contains a
 *   replacement node that we’ll swap back in afterwards.
 * @property {'comment'} type
 *   Node type.
 * @property {{stitch: Nodes}} value
 *   Replacement value.
 */ 


/**
 * @import {ElementData, Element, Nodes, RootContent, Root} from 'hast'
 * @import {DefaultTreeAdapterMap, Token} from 'parse5'
 * @import {Schema} from 'property-information'
 * @import {Point, Position} from 'unist'
 * @import {VFile} from 'vfile'
 * @import {Options} from 'hast-util-from-parse5'
 */ /**
 * @typedef State
 *   Info passed around about the current state.
 * @property {VFile | undefined} file
 *   Corresponding file.
 * @property {boolean} location
 *   Whether location info was found.
 * @property {Schema} schema
 *   Current schema.
 * @property {boolean | undefined} verbose
 *   Add extra positional info.
 */ 


/**
 * @import {VFile, Value} from 'vfile'
 * @import {Location} from 'vfile-location'
 */ /**
 * Create an index of the given document to translate between line/column and
 * offset based positional info.
 *
 * Also implemented in Rust in [`wooorm/markdown-rs`][markdown-rs].
 *
 * [markdown-rs]: https://github.com/wooorm/markdown-rs/blob/main/src/util/location.rs
 *
 * @param {VFile | Value} file
 *   File to index.
 * @returns {Location}
 *   Accessors for index.
 */ function $cca897a9465fcc26$export$17b07c660794dc13(file) {
    const value = String(file);
    /**
   * List, where each index is a line number (0-based), and each value is the
   * byte index *after* where the line ends.
   *
   * @type {Array<number>}
   */ const indices = [];
    return {
        toOffset: toOffset,
        toPoint: toPoint
    };
    /** @type {Location['toPoint']} */ function toPoint(offset) {
        if (typeof offset === 'number' && offset > -1 && offset <= value.length) {
            let index = 0;
            while(true){
                let end = indices[index];
                if (end === undefined) {
                    const eol = $cca897a9465fcc26$var$next(value, indices[index - 1]);
                    end = eol === -1 ? value.length + 1 : eol + 1;
                    indices[index] = end;
                }
                if (end > offset) return {
                    line: index + 1,
                    column: offset - (index > 0 ? indices[index - 1] : 0) + 1,
                    offset: offset
                };
                index++;
            }
        }
    }
    /** @type {Location['toOffset']} */ function toOffset(point) {
        if (point && typeof point.line === 'number' && typeof point.column === 'number' && !Number.isNaN(point.line) && !Number.isNaN(point.column)) {
            while(indices.length < point.line){
                const from = indices[indices.length - 1];
                const eol = $cca897a9465fcc26$var$next(value, from);
                const end = eol === -1 ? value.length + 1 : eol + 1;
                if (from === end) break;
                indices.push(end);
            }
            const offset = (point.line > 1 ? indices[point.line - 2] : 0) + point.column - 1;
            // The given `column` could not exist on this line.
            if (offset < indices[point.line - 1]) return offset;
        }
    }
}
/**
 * @param {string} value
 * @param {number} from
 */ function $cca897a9465fcc26$var$next(value, from) {
    const cr = value.indexOf('\r', from);
    const lf = value.indexOf('\n', from);
    if (lf === -1) return cr;
    if (cr === -1 || cr + 1 === lf) return lf;
    return cr < lf ? cr : lf;
}


/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */ const $1ef3bf91500f5903$export$f9bfcc6efbcb9478 = {
    html: 'http://www.w3.org/1999/xhtml',
    mathml: 'http://www.w3.org/1998/Math/MathML',
    svg: 'http://www.w3.org/2000/svg',
    xlink: 'http://www.w3.org/1999/xlink',
    xml: 'http://www.w3.org/XML/1998/namespace',
    xmlns: 'http://www.w3.org/2000/xmlns/'
};


const $73bde87d01cc5621$var$own = {}.hasOwnProperty;
/** @type {unknown} */ // type-coverage:ignore-next-line
const $73bde87d01cc5621$var$proto = Object.prototype;
function $73bde87d01cc5621$export$371ddbe92c872127(tree, options) {
    const settings = options || {};
    return $73bde87d01cc5621$var$one({
        file: settings.file || undefined,
        location: false,
        schema: settings.space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        verbose: settings.verbose || false
    }, tree);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} node
 *   p5 node.
 * @returns {Nodes}
 *   hast node.
 */ function $73bde87d01cc5621$var$one(state, node) {
    /** @type {Nodes} */ let result;
    switch(node.nodeName){
        case '#comment':
            {
                const reference = /** @type {DefaultTreeAdapterMap['commentNode']} */ node;
                result = {
                    type: 'comment',
                    value: reference.data
                };
                $73bde87d01cc5621$var$patch(state, reference, result);
                return result;
            }
        case '#document':
        case '#document-fragment':
            {
                const reference = /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */ node;
                const quirksMode = 'mode' in reference ? reference.mode === 'quirks' || reference.mode === 'limited-quirks' : false;
                result = {
                    type: 'root',
                    children: $73bde87d01cc5621$var$all(state, node.childNodes),
                    data: {
                        quirksMode: quirksMode
                    }
                };
                if (state.file && state.location) {
                    const document = String(state.file);
                    const loc = (0, $cca897a9465fcc26$export$17b07c660794dc13)(document);
                    const start = loc.toPoint(0);
                    const end = loc.toPoint(document.length);
                    // Always defined as we give valid input.
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(start, 'expected `start`');
                    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(end, 'expected `end`');
                    result.position = {
                        start: start,
                        end: end
                    };
                }
                return result;
            }
        case '#documentType':
            {
                const reference = /** @type {DefaultTreeAdapterMap['documentType']} */ node;
                result = {
                    type: 'doctype'
                };
                $73bde87d01cc5621$var$patch(state, reference, result);
                return result;
            }
        case '#text':
            {
                const reference = /** @type {DefaultTreeAdapterMap['textNode']} */ node;
                result = {
                    type: 'text',
                    value: reference.value
                };
                $73bde87d01cc5621$var$patch(state, reference, result);
                return result;
            }
        // Element.
        default:
            {
                const reference = /** @type {DefaultTreeAdapterMap['element']} */ node;
                result = $73bde87d01cc5621$var$element(state, reference);
                return result;
            }
    }
}
/**
 * Transform children.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Array<DefaultTreeAdapterMap['node']>} nodes
 *   Nodes.
 * @returns {Array<RootContent>}
 *   hast nodes.
 */ function $73bde87d01cc5621$var$all(state, nodes) {
    let index = -1;
    /** @type {Array<RootContent>} */ const results = [];
    while(++index < nodes.length){
        // Assume no roots in `nodes`.
        const result = /** @type {RootContent} */ $73bde87d01cc5621$var$one(state, nodes[index]);
        results.push(result);
    }
    return results;
}
/**
 * Transform an element.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['element']} node
 *   `parse5` node to transform.
 * @returns {Element}
 *   hast node.
 */ function $73bde87d01cc5621$var$element(state, node) {
    const schema = state.schema;
    state.schema = node.namespaceURI === (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).svg ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5);
    // Props.
    let index = -1;
    /** @type {Record<string, string>} */ const properties = {};
    while(++index < node.attrs.length){
        const attribute = node.attrs[index];
        const name = (attribute.prefix ? attribute.prefix + ':' : '') + attribute.name;
        if (!$73bde87d01cc5621$var$own.call($73bde87d01cc5621$var$proto, name)) properties[name] = attribute.value;
    }
    // Build.
    const x = state.schema.space === 'svg' ? (0, $ef6b1b82ffb3458e$export$2408f22a0fab9ae5) : (0, $ef6b1b82ffb3458e$export$dda1d9f60106f0e9);
    const result = x(node.tagName, properties, $73bde87d01cc5621$var$all(state, node.childNodes));
    $73bde87d01cc5621$var$patch(state, node, result);
    // Switch content.
    if (result.tagName === 'template') {
        const reference = /** @type {DefaultTreeAdapterMap['template']} */ node;
        const pos = reference.sourceCodeLocation;
        const startTag = pos && pos.startTag && $73bde87d01cc5621$var$position(pos.startTag);
        const endTag = pos && pos.endTag && $73bde87d01cc5621$var$position(pos.endTag);
        // Root in, root out.
        const content = /** @type {Root} */ $73bde87d01cc5621$var$one(state, reference.content);
        if (startTag && endTag && state.file) content.position = {
            start: startTag.end,
            end: endTag.start
        };
        result.content = content;
    }
    state.schema = schema;
    return result;
}
/**
 * Patch positional info from `from` onto `to`.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} from
 *   p5 node.
 * @param {Nodes} to
 *   hast node.
 * @returns {undefined}
 *   Nothing.
 */ function $73bde87d01cc5621$var$patch(state, from, to) {
    if ('sourceCodeLocation' in from && from.sourceCodeLocation && state.file) {
        const position = $73bde87d01cc5621$var$createLocation(state, to, from.sourceCodeLocation);
        if (position) {
            state.location = true;
            to.position = position;
        }
    }
}
/**
 * Create clean positional information.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   hast node.
 * @param {Token.ElementLocation} location
 *   p5 location info.
 * @returns {Position | undefined}
 *   Position, or nothing.
 */ function $73bde87d01cc5621$var$createLocation(state, node, location) {
    const result = $73bde87d01cc5621$var$position(location);
    if (node.type === 'element') {
        const tail = node.children[node.children.length - 1];
        // Bug for unclosed with children.
        // See: <https://github.com/inikulin/parse5/issues/109>.
        if (result && !location.endTag && tail && tail.position && tail.position.end) result.end = Object.assign({}, tail.position.end);
        if (state.verbose) {
            /** @type {Record<string, Position | undefined>} */ const properties = {};
            /** @type {string} */ let key;
            if (location.attrs) {
                for(key in location.attrs)if ($73bde87d01cc5621$var$own.call(location.attrs, key)) properties[(0, $84669bfd2b988556$export$71aa6c912b956294)(state.schema, key).property] = $73bde87d01cc5621$var$position(location.attrs[key]);
            }
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(location.startTag, 'a start tag should exist');
            const opening = $73bde87d01cc5621$var$position(location.startTag);
            const closing = location.endTag ? $73bde87d01cc5621$var$position(location.endTag) : undefined;
            /** @type {ElementData['position']} */ const data = {
                opening: opening
            };
            if (closing) data.closing = closing;
            data.properties = properties;
            node.data = {
                position: data
            };
        }
    }
    return result;
}
/**
 * Turn a p5 location into a position.
 *
 * @param {Token.Location} loc
 *   Location.
 * @returns {Position | undefined}
 *   Position or nothing.
 */ function $73bde87d01cc5621$var$position(loc) {
    const start = $73bde87d01cc5621$var$point({
        line: loc.startLine,
        column: loc.startCol,
        offset: loc.startOffset
    });
    const end = $73bde87d01cc5621$var$point({
        line: loc.endLine,
        column: loc.endCol,
        offset: loc.endOffset
    });
    // @ts-expect-error: we do use `undefined` for points if one or the other
    // exists.
    return start || end ? {
        start: start,
        end: end
    } : undefined;
}
/**
 * Filter out invalid points.
 *
 * @param {Point} point
 *   Point with potentially `undefined` values.
 * @returns {Point | undefined}
 *   Point or nothing.
 */ function $73bde87d01cc5621$var$point(point) {
    return point.line && point.column ? point : undefined;
}


/**
 * @import {Comment, Doctype, Element, Nodes, RootContent, Root, Text} from 'hast'
 * @import {DefaultTreeAdapterMap, Token} from 'parse5'
 * @import {Schema} from 'property-information'
 */ /**
 * @typedef {DefaultTreeAdapterMap['document']} Parse5Document
 * @typedef {DefaultTreeAdapterMap['documentFragment']} Parse5Fragment
 * @typedef {DefaultTreeAdapterMap['element']} Parse5Element
 * @typedef {DefaultTreeAdapterMap['node']} Parse5Nodes
 * @typedef {DefaultTreeAdapterMap['documentType']} Parse5Doctype
 * @typedef {DefaultTreeAdapterMap['commentNode']} Parse5Comment
 * @typedef {DefaultTreeAdapterMap['textNode']} Parse5Text
 * @typedef {DefaultTreeAdapterMap['parentNode']} Parse5Parent
 * @typedef {Token.Attribute} Parse5Attribute
 *
 * @typedef Options
 *   Configuration.
 * @property {Space | null | undefined} [space='html']
 *   Which space the document is in (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 *
 * @typedef {Exclude<Parse5Nodes, Parse5Document | Parse5Fragment>} Parse5Content
 *
 * @typedef {'html' | 'svg'} Space
 */ 





/** @type {Options} */ const $2e94052ec8d06cd1$var$emptyOptions = {};
const $2e94052ec8d06cd1$var$own = {}.hasOwnProperty;
const $2e94052ec8d06cd1$var$one = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
    handlers: {
        root: $2e94052ec8d06cd1$var$root,
        element: $2e94052ec8d06cd1$var$element,
        text: $2e94052ec8d06cd1$var$text,
        comment: $2e94052ec8d06cd1$var$comment,
        doctype: $2e94052ec8d06cd1$var$doctype
    }
});
function $2e94052ec8d06cd1$export$b4cf803c867502fc(tree, options) {
    const settings = options || $2e94052ec8d06cd1$var$emptyOptions;
    const space = settings.space;
    return $2e94052ec8d06cd1$var$one(tree, space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5));
}
/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Document}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$root(node, schema) {
    /** @type {Parse5Document} */ const result = {
        nodeName: '#document',
        // @ts-expect-error: `parse5` uses enums, which are actually strings.
        mode: (node.data || {}).quirksMode ? 'quirks' : 'no-quirks',
        childNodes: []
    };
    result.childNodes = $2e94052ec8d06cd1$var$all(node.children, result, schema);
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Fragment}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$fragment(node, schema) {
    /** @type {Parse5Fragment} */ const result = {
        nodeName: '#document-fragment',
        childNodes: []
    };
    result.childNodes = $2e94052ec8d06cd1$var$all(node.children, result, schema);
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Doctype} node
 *   Node (hast) to transform.
 * @returns {Parse5Doctype}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$doctype(node) {
    /** @type {Parse5Doctype} */ const result = {
        nodeName: '#documentType',
        name: 'html',
        publicId: '',
        systemId: '',
        parentNode: null
    };
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Text} node
 *   Node (hast) to transform.
 * @returns {Parse5Text}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$text(node) {
    /** @type {Parse5Text} */ const result = {
        nodeName: '#text',
        value: node.value,
        parentNode: null
    };
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Comment} node
 *   Node (hast) to transform.
 * @returns {Parse5Comment}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$comment(node) {
    /** @type {Parse5Comment} */ const result = {
        nodeName: '#comment',
        data: node.value,
        parentNode: null
    };
    $2e94052ec8d06cd1$var$patch(node, result);
    return result;
}
/**
 * @param {Element} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Element}
 *   Parse5 node.
 */ function $2e94052ec8d06cd1$var$element(node, schema) {
    const parentSchema = schema;
    let currentSchema = parentSchema;
    if (node.type === 'element' && node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') currentSchema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
    /** @type {Array<Parse5Attribute>} */ const attrs = [];
    /** @type {string} */ let prop;
    if (node.properties) {
        for(prop in node.properties)if (prop !== 'children' && $2e94052ec8d06cd1$var$own.call(node.properties, prop)) {
            const result = $2e94052ec8d06cd1$var$createProperty(currentSchema, prop, node.properties[prop]);
            if (result) attrs.push(result);
        }
    }
    const space = currentSchema.space;
    // `html` and `svg` both have a space.
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(space);
    /** @type {Parse5Element} */ const result = {
        nodeName: node.tagName,
        tagName: node.tagName,
        attrs: attrs,
        // @ts-expect-error: `parse5` types are wrong.
        namespaceURI: (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478)[space],
        childNodes: [],
        parentNode: null
    };
    result.childNodes = $2e94052ec8d06cd1$var$all(node.children, result, currentSchema);
    $2e94052ec8d06cd1$var$patch(node, result);
    if (node.tagName === 'template' && node.content) // @ts-expect-error: `parse5` types are wrong.
    result.content = $2e94052ec8d06cd1$var$fragment(node.content, currentSchema);
    return result;
}
/**
 * Handle a property.
 *
 * @param {Schema} schema
 *   Current schema.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Parse5Attribute | undefined}
 *   Field for runtime, optional.
 */ function $2e94052ec8d06cd1$var$createProperty(schema, prop, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === false || value === null || value === undefined || typeof value === 'number' && Number.isNaN(value) || !value && info.boolean) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737)(value) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737)(value);
    /** @type {Parse5Attribute} */ const attribute = {
        name: info.attribute,
        value: value === true ? '' : String(value)
    };
    if (info.space && info.space !== 'html' && info.space !== 'svg') {
        const index = attribute.name.indexOf(':');
        if (index < 0) attribute.prefix = '';
        else {
            attribute.name = attribute.name.slice(index + 1);
            attribute.prefix = info.attribute.slice(0, index);
        }
        attribute.namespace = (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478)[info.space];
    }
    return attribute;
}
/**
 * Transform all hast nodes.
 *
 * @param {Array<RootContent>} children
 *   List of children.
 * @param {Parse5Parent} parentNode
 *   `parse5` parent node.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Array<Parse5Content>}
 *   Transformed children.
 */ function $2e94052ec8d06cd1$var$all(children, parentNode, schema) {
    let index = -1;
    /** @type {Array<Parse5Content>} */ const results = [];
    if (children) while(++index < children.length){
        /** @type {Parse5Content} */ const child = $2e94052ec8d06cd1$var$one(children[index], schema);
        child.parentNode = parentNode;
        results.push(child);
    }
    return results;
}
/**
 * Add position info from `from` to `to`.
 *
 * @param {Nodes} from
 *   hast node.
 * @param {Parse5Nodes} to
 *   `parse5` node.
 * @returns {undefined}
 *   Nothing.
 */ function $2e94052ec8d06cd1$var$patch(from, to) {
    const position = from.position;
    if (position && position.start && position.end) {
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(typeof position.start.offset === 'number');
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(typeof position.end.offset === 'number');
        to.sourceCodeLocation = {
            startLine: position.start.line,
            startCol: position.start.column,
            startOffset: position.start.offset,
            endLine: position.end.line,
            endCol: position.end.column,
            endOffset: position.end.offset
        };
    }
}


/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $fe4fce3fd1fee116$export$762508062d068de = [
    'area',
    'base',
    'basefont',
    'bgsound',
    'br',
    'col',
    'command',
    'embed',
    'frame',
    'hr',
    'image',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];




const $bb1347fda1174ed8$var$UNDEFINED_CODE_POINTS = new Set([
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
]);
const $bb1347fda1174ed8$export$e8d20e7a50e6c279 = '\uFFFD';
var $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0;
(function(CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
})($bb1347fda1174ed8$export$e3f6c2feb5c0ecc0 || ($bb1347fda1174ed8$export$e3f6c2feb5c0ecc0 = {}));
const $bb1347fda1174ed8$export$5abac700f947e2 = {
    DASH_DASH: '--',
    CDATA_START: '[CDATA[',
    DOCTYPE: 'doctype',
    SCRIPT: 'script',
    PUBLIC: 'public',
    SYSTEM: 'system'
};
function $bb1347fda1174ed8$export$7e678b42035e707f(cp) {
    return cp >= 55296 && cp <= 57343;
}
function $bb1347fda1174ed8$export$e7f1d94bb17e4055(cp) {
    return cp >= 56320 && cp <= 57343;
}
function $bb1347fda1174ed8$export$91e83256751ec906(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
}
function $bb1347fda1174ed8$export$d6953a6077926e(cp) {
    return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
}
function $bb1347fda1174ed8$export$b3484aaf321bda02(cp) {
    return cp >= 64976 && cp <= 65007 || $bb1347fda1174ed8$var$UNDEFINED_CODE_POINTS.has(cp);
}


var $36aeaab04c5a6aea$export$9e0efcb140234d2;
(function(ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
})($36aeaab04c5a6aea$export$9e0efcb140234d2 || ($36aeaab04c5a6aea$export$9e0efcb140234d2 = {}));


//Const
const $5940cf2ccae8becf$var$DEFAULT_BUFFER_WATERLINE = 65536;
class $5940cf2ccae8becf$export$35db5c8036a15ad1 {
    /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */ get col() {
        return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
    get offset() {
        return this.droppedBufferSize + this.pos;
    }
    getError(code, cpOffset) {
        const { line: line, col: col, offset: offset } = this;
        const startCol = col + cpOffset;
        const startOffset = offset + cpOffset;
        return {
            code: code,
            startLine: line,
            endLine: line,
            startCol: startCol,
            endCol: startCol,
            startOffset: startOffset,
            endOffset: startOffset
        };
    }
    _err(code) {
        if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
            this.lastErrOffset = this.offset;
            this.handler.onParseError(this.getError(code, 0));
        }
    }
    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }
    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.html.length - 1) {
            const nextCp = this.html.charCodeAt(this.pos + 1);
            if ((0, $bb1347fda1174ed8$export$e7f1d94bb17e4055)(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;
                //NOTE: add a gap that should be avoided during retreat
                this._addGap();
                return (0, $bb1347fda1174ed8$export$91e83256751ec906)(cp, nextCp);
            }
        } else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF;
        }
        //NOTE: isolated surrogate
        this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).surrogateInInputStream);
        return cp;
    }
    willDropParsedChunk() {
        return this.pos > this.bufferWaterline;
    }
    dropParsedChunk() {
        if (this.willDropParsedChunk()) {
            this.html = this.html.substring(this.pos);
            this.lineStartPos -= this.pos;
            this.droppedBufferSize += this.pos;
            this.pos = 0;
            this.lastGapPos = -2;
            this.gapStack.length = 0;
        }
    }
    write(chunk, isLastChunk) {
        if (this.html.length > 0) this.html += chunk;
        else this.html = chunk;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }
    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
        this.endOfChunkHit = false;
    }
    startsWith(pattern, caseSensitive) {
        // Check if our buffer has enough characters
        if (this.pos + pattern.length > this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return false;
        }
        if (caseSensitive) return this.html.startsWith(pattern, this.pos);
        for(let i = 0; i < pattern.length; i++){
            const cp = this.html.charCodeAt(this.pos + i) | 0x20;
            if (cp !== pattern.charCodeAt(i)) return false;
        }
        return true;
    }
    peek(offset) {
        const pos = this.pos + offset;
        if (pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF;
        }
        const code = this.html.charCodeAt(pos);
        return code === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN ? (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED : code;
    }
    advance() {
        this.pos++;
        //NOTE: LF should be in the last column of the line
        if (this.isEol) {
            this.isEol = false;
            this.line++;
            this.lineStartPos = this.pos;
        }
        if (this.pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) {
            this.isEol = true;
            this.skipNextNewLine = true;
            return (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED;
        }
        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED) {
            this.isEol = true;
            if (this.skipNextNewLine) {
                // `line` will be bumped again in the recursive call.
                this.line--;
                this.skipNextNewLine = false;
                this._addGap();
                return this.advance();
            }
        }
        this.skipNextNewLine = false;
        if ((0, $bb1347fda1174ed8$export$7e678b42035e707f)(cp)) cp = this._processSurrogate(cp);
        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange = this.handler.onParseError === null || cp > 0x1f && cp < 0x7f || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN || cp > 0x9f && cp < 64976;
        if (!isCommonValidRange) this._checkForProblematicCharacters(cp);
        return cp;
    }
    _checkForProblematicCharacters(cp) {
        if ((0, $bb1347fda1174ed8$export$d6953a6077926e)(cp)) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).controlCharacterInInputStream);
        else if ((0, $bb1347fda1174ed8$export$b3484aaf321bda02)(cp)) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).noncharacterInInputStream);
    }
    retreat(count) {
        this.pos -= count;
        while(this.pos < this.lastGapPos){
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }
        this.isEol = false;
    }
    constructor(handler){
        this.handler = handler;
        this.html = '';
        this.pos = -1;
        // NOTE: Initial `lastGapPos` is -2, to ensure `col` on initialisation is 0
        this.lastGapPos = -2;
        this.gapStack = [];
        this.skipNextNewLine = false;
        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = $5940cf2ccae8becf$var$DEFAULT_BUFFER_WATERLINE;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;
        this.line = 1;
        //NOTE: avoid reporting errors twice on advance/retreat
        this.lastErrOffset = -1;
    }
}



var $be390ad8d330a451$exports = {};

$parcel$export($be390ad8d330a451$exports, "TokenType", function () { return $be390ad8d330a451$export$f435f793048e7a0f; });
$parcel$export($be390ad8d330a451$exports, "getTokenAttr", function () { return $be390ad8d330a451$export$df33bba014b5841e; });
var $be390ad8d330a451$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
})($be390ad8d330a451$export$f435f793048e7a0f || ($be390ad8d330a451$export$f435f793048e7a0f = {}));
function $be390ad8d330a451$export$df33bba014b5841e(token, attrName) {
    for(let i = token.attrs.length - 1; i >= 0; i--){
        if (token.attrs[i].name === attrName) return token.attrs[i].value;
    }
    return null;
}


// Generated using scripts/write-decode-map.ts
const $8bb06a4e9c5f6236$export$b6a4accd5ee85f69 = /* #__PURE__ */ new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
const $0de03497dce2af08$export$298b118b5a906d9f = /* #__PURE__ */ new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $ac732ca4fea94b4a$var$_a;
const $ac732ca4fea94b4a$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $ac732ca4fea94b4a$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
($ac732ca4fea94b4a$var$_a = String.fromCodePoint) !== null && $ac732ca4fea94b4a$var$_a !== void 0 ? $ac732ca4fea94b4a$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $ac732ca4fea94b4a$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
    return (_a = $ac732ca4fea94b4a$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $ac732ca4fea94b4a$export$1f5a05ca6191a69a(codePoint) {
    return $ac732ca4fea94b4a$export$73bfc63873071f74($ac732ca4fea94b4a$export$b978ab756102108a(codePoint));
}


var $b715bb39f665675e$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($b715bb39f665675e$var$CharCodes || ($b715bb39f665675e$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $b715bb39f665675e$var$TO_LOWER_BIT = 32;
var $b715bb39f665675e$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($b715bb39f665675e$export$6a4325c613e0faec || ($b715bb39f665675e$export$6a4325c613e0faec = {}));
function $b715bb39f665675e$var$isNumber(code) {
    return code >= $b715bb39f665675e$var$CharCodes.ZERO && code <= $b715bb39f665675e$var$CharCodes.NINE;
}
function $b715bb39f665675e$var$isHexadecimalCharacter(code) {
    return code >= $b715bb39f665675e$var$CharCodes.UPPER_A && code <= $b715bb39f665675e$var$CharCodes.UPPER_F || code >= $b715bb39f665675e$var$CharCodes.LOWER_A && code <= $b715bb39f665675e$var$CharCodes.LOWER_F;
}
function $b715bb39f665675e$var$isAsciiAlphaNumeric(code) {
    return code >= $b715bb39f665675e$var$CharCodes.UPPER_A && code <= $b715bb39f665675e$var$CharCodes.UPPER_Z || code >= $b715bb39f665675e$var$CharCodes.LOWER_A && code <= $b715bb39f665675e$var$CharCodes.LOWER_Z || $b715bb39f665675e$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $b715bb39f665675e$var$isEntityInAttributeInvalidEnd(code) {
    return code === $b715bb39f665675e$var$CharCodes.EQUALS || $b715bb39f665675e$var$isAsciiAlphaNumeric(code);
}
var $b715bb39f665675e$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($b715bb39f665675e$var$EntityDecoderState || ($b715bb39f665675e$var$EntityDecoderState = {}));
var $b715bb39f665675e$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($b715bb39f665675e$export$8c8f129ce60f53c || ($b715bb39f665675e$export$8c8f129ce60f53c = {}));
class $b715bb39f665675e$export$15263a93ff7ec8ba {
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $b715bb39f665675e$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(input, offset) {
        switch(this.state){
            case $b715bb39f665675e$var$EntityDecoderState.EntityStart:
                if (input.charCodeAt(offset) === $b715bb39f665675e$var$CharCodes.NUM) {
                    this.state = $b715bb39f665675e$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(input, offset + 1);
                }
                this.state = $b715bb39f665675e$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(input, offset);
            case $b715bb39f665675e$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(input, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(input, offset) {
        if (offset >= input.length) return -1;
        if ((input.charCodeAt(offset) | $b715bb39f665675e$var$TO_LOWER_BIT) === $b715bb39f665675e$var$CharCodes.LOWER_X) {
            this.state = $b715bb39f665675e$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(input, offset + 1);
        }
        this.state = $b715bb39f665675e$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(input, offset);
    }
    addToNumericResult(input, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($b715bb39f665675e$var$isNumber(char) || $b715bb39f665675e$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($b715bb39f665675e$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $b715bb39f665675e$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $b715bb39f665675e$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $ac732ca4fea94b4a$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $b715bb39f665675e$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(input, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < input.length; offset++, this.excess++){
            const char = input.charCodeAt(offset);
            this.treeIndex = $b715bb39f665675e$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $b715bb39f665675e$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $b715bb39f665675e$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $b715bb39f665675e$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $b715bb39f665675e$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$b715bb39f665675e$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $b715bb39f665675e$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $b715bb39f665675e$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $b715bb39f665675e$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $b715bb39f665675e$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $b715bb39f665675e$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $b715bb39f665675e$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $b715bb39f665675e$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $b715bb39f665675e$export$8c8f129ce60f53c.Strict;
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $b715bb39f665675e$var$getDecoder(decodeTree) {
    let returnValue = "";
    const decoder = new $b715bb39f665675e$export$15263a93ff7ec8ba(decodeTree, (data)=>returnValue += (0, $ac732ca4fea94b4a$export$73bfc63873071f74)(data));
    return function decodeWithTrie(input, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = input.indexOf("&", offset)) >= 0){
            returnValue += input.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const length = decoder.write(input, // Skip the "&"
            offset + 1);
            if (length < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + length;
            // If `length` is 0, skip the current `&` and continue.
            offset = length === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = returnValue + input.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        returnValue = "";
        return result;
    };
}
function $b715bb39f665675e$export$44c08d99945e6276(decodeTree, current, nodeIndex, char) {
    const branchCount = (current & $b715bb39f665675e$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $b715bb39f665675e$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIndex : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIndex;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midValue = decodeTree[mid];
        if (midValue < char) lo = mid + 1;
        else if (midValue > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $b715bb39f665675e$var$htmlDecoder = /* #__PURE__ */ $b715bb39f665675e$var$getDecoder((0, $8bb06a4e9c5f6236$export$b6a4accd5ee85f69));
const $b715bb39f665675e$var$xmlDecoder = /* #__PURE__ */ $b715bb39f665675e$var$getDecoder((0, $0de03497dce2af08$export$298b118b5a906d9f));
function $b715bb39f665675e$export$f045cb747ce77a19(htmlString, mode = $b715bb39f665675e$export$8c8f129ce60f53c.Legacy) {
    return $b715bb39f665675e$var$htmlDecoder(htmlString, mode);
}
function $b715bb39f665675e$export$49f5e8089adb006a(htmlAttribute) {
    return $b715bb39f665675e$var$htmlDecoder(htmlAttribute, $b715bb39f665675e$export$8c8f129ce60f53c.Attribute);
}
function $b715bb39f665675e$export$da52f4371b3f37de(htmlString) {
    return $b715bb39f665675e$var$htmlDecoder(htmlString, $b715bb39f665675e$export$8c8f129ce60f53c.Strict);
}
function $b715bb39f665675e$export$88e3b9643a8bd06e(xmlString) {
    return $b715bb39f665675e$var$xmlDecoder(xmlString, $b715bb39f665675e$export$8c8f129ce60f53c.Strict);
}



var $c2855a9ccb69df69$exports = {};

$parcel$export($c2855a9ccb69df69$exports, "NS", function () { return $c2855a9ccb69df69$export$fb4028874a74450; });
$parcel$export($c2855a9ccb69df69$exports, "ATTRS", function () { return $c2855a9ccb69df69$export$380b7bc9e6cb1918; });
$parcel$export($c2855a9ccb69df69$exports, "DOCUMENT_MODE", function () { return $c2855a9ccb69df69$export$a74d46c85337d29a; });
$parcel$export($c2855a9ccb69df69$exports, "TAG_NAMES", function () { return $c2855a9ccb69df69$export$7e674a85a2656dce; });
$parcel$export($c2855a9ccb69df69$exports, "TAG_ID", function () { return $c2855a9ccb69df69$export$cb0999a53e0acaed; });
$parcel$export($c2855a9ccb69df69$exports, "getTagID", function () { return $c2855a9ccb69df69$export$39db8a1315f68282; });
$parcel$export($c2855a9ccb69df69$exports, "SPECIAL_ELEMENTS", function () { return $c2855a9ccb69df69$export$7e5172336f7d2bbb; });
$parcel$export($c2855a9ccb69df69$exports, "NUMBERED_HEADERS", function () { return $c2855a9ccb69df69$export$1ecc20fa0754c045; });
$parcel$export($c2855a9ccb69df69$exports, "hasUnescapedText", function () { return $c2855a9ccb69df69$export$4ce4f8c09f921aed; });
/** All valid namespaces in HTML. */ var $c2855a9ccb69df69$export$fb4028874a74450;
(function(NS) {
    NS["HTML"] = "http://www.w3.org/1999/xhtml";
    NS["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS["SVG"] = "http://www.w3.org/2000/svg";
    NS["XLINK"] = "http://www.w3.org/1999/xlink";
    NS["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})($c2855a9ccb69df69$export$fb4028874a74450 || ($c2855a9ccb69df69$export$fb4028874a74450 = {}));
var $c2855a9ccb69df69$export$380b7bc9e6cb1918;
(function(ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
})($c2855a9ccb69df69$export$380b7bc9e6cb1918 || ($c2855a9ccb69df69$export$380b7bc9e6cb1918 = {}));
var $c2855a9ccb69df69$export$a74d46c85337d29a;
(function(DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
})($c2855a9ccb69df69$export$a74d46c85337d29a || ($c2855a9ccb69df69$export$a74d46c85337d29a = {}));
var $c2855a9ccb69df69$export$7e674a85a2656dce;
(function(TAG_NAMES) {
    TAG_NAMES["A"] = "a";
    TAG_NAMES["ADDRESS"] = "address";
    TAG_NAMES["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES["APPLET"] = "applet";
    TAG_NAMES["AREA"] = "area";
    TAG_NAMES["ARTICLE"] = "article";
    TAG_NAMES["ASIDE"] = "aside";
    TAG_NAMES["B"] = "b";
    TAG_NAMES["BASE"] = "base";
    TAG_NAMES["BASEFONT"] = "basefont";
    TAG_NAMES["BGSOUND"] = "bgsound";
    TAG_NAMES["BIG"] = "big";
    TAG_NAMES["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES["BODY"] = "body";
    TAG_NAMES["BR"] = "br";
    TAG_NAMES["BUTTON"] = "button";
    TAG_NAMES["CAPTION"] = "caption";
    TAG_NAMES["CENTER"] = "center";
    TAG_NAMES["CODE"] = "code";
    TAG_NAMES["COL"] = "col";
    TAG_NAMES["COLGROUP"] = "colgroup";
    TAG_NAMES["DD"] = "dd";
    TAG_NAMES["DESC"] = "desc";
    TAG_NAMES["DETAILS"] = "details";
    TAG_NAMES["DIALOG"] = "dialog";
    TAG_NAMES["DIR"] = "dir";
    TAG_NAMES["DIV"] = "div";
    TAG_NAMES["DL"] = "dl";
    TAG_NAMES["DT"] = "dt";
    TAG_NAMES["EM"] = "em";
    TAG_NAMES["EMBED"] = "embed";
    TAG_NAMES["FIELDSET"] = "fieldset";
    TAG_NAMES["FIGCAPTION"] = "figcaption";
    TAG_NAMES["FIGURE"] = "figure";
    TAG_NAMES["FONT"] = "font";
    TAG_NAMES["FOOTER"] = "footer";
    TAG_NAMES["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES["FORM"] = "form";
    TAG_NAMES["FRAME"] = "frame";
    TAG_NAMES["FRAMESET"] = "frameset";
    TAG_NAMES["H1"] = "h1";
    TAG_NAMES["H2"] = "h2";
    TAG_NAMES["H3"] = "h3";
    TAG_NAMES["H4"] = "h4";
    TAG_NAMES["H5"] = "h5";
    TAG_NAMES["H6"] = "h6";
    TAG_NAMES["HEAD"] = "head";
    TAG_NAMES["HEADER"] = "header";
    TAG_NAMES["HGROUP"] = "hgroup";
    TAG_NAMES["HR"] = "hr";
    TAG_NAMES["HTML"] = "html";
    TAG_NAMES["I"] = "i";
    TAG_NAMES["IMG"] = "img";
    TAG_NAMES["IMAGE"] = "image";
    TAG_NAMES["INPUT"] = "input";
    TAG_NAMES["IFRAME"] = "iframe";
    TAG_NAMES["KEYGEN"] = "keygen";
    TAG_NAMES["LABEL"] = "label";
    TAG_NAMES["LI"] = "li";
    TAG_NAMES["LINK"] = "link";
    TAG_NAMES["LISTING"] = "listing";
    TAG_NAMES["MAIN"] = "main";
    TAG_NAMES["MALIGNMARK"] = "malignmark";
    TAG_NAMES["MARQUEE"] = "marquee";
    TAG_NAMES["MATH"] = "math";
    TAG_NAMES["MENU"] = "menu";
    TAG_NAMES["META"] = "meta";
    TAG_NAMES["MGLYPH"] = "mglyph";
    TAG_NAMES["MI"] = "mi";
    TAG_NAMES["MO"] = "mo";
    TAG_NAMES["MN"] = "mn";
    TAG_NAMES["MS"] = "ms";
    TAG_NAMES["MTEXT"] = "mtext";
    TAG_NAMES["NAV"] = "nav";
    TAG_NAMES["NOBR"] = "nobr";
    TAG_NAMES["NOFRAMES"] = "noframes";
    TAG_NAMES["NOEMBED"] = "noembed";
    TAG_NAMES["NOSCRIPT"] = "noscript";
    TAG_NAMES["OBJECT"] = "object";
    TAG_NAMES["OL"] = "ol";
    TAG_NAMES["OPTGROUP"] = "optgroup";
    TAG_NAMES["OPTION"] = "option";
    TAG_NAMES["P"] = "p";
    TAG_NAMES["PARAM"] = "param";
    TAG_NAMES["PLAINTEXT"] = "plaintext";
    TAG_NAMES["PRE"] = "pre";
    TAG_NAMES["RB"] = "rb";
    TAG_NAMES["RP"] = "rp";
    TAG_NAMES["RT"] = "rt";
    TAG_NAMES["RTC"] = "rtc";
    TAG_NAMES["RUBY"] = "ruby";
    TAG_NAMES["S"] = "s";
    TAG_NAMES["SCRIPT"] = "script";
    TAG_NAMES["SEARCH"] = "search";
    TAG_NAMES["SECTION"] = "section";
    TAG_NAMES["SELECT"] = "select";
    TAG_NAMES["SOURCE"] = "source";
    TAG_NAMES["SMALL"] = "small";
    TAG_NAMES["SPAN"] = "span";
    TAG_NAMES["STRIKE"] = "strike";
    TAG_NAMES["STRONG"] = "strong";
    TAG_NAMES["STYLE"] = "style";
    TAG_NAMES["SUB"] = "sub";
    TAG_NAMES["SUMMARY"] = "summary";
    TAG_NAMES["SUP"] = "sup";
    TAG_NAMES["TABLE"] = "table";
    TAG_NAMES["TBODY"] = "tbody";
    TAG_NAMES["TEMPLATE"] = "template";
    TAG_NAMES["TEXTAREA"] = "textarea";
    TAG_NAMES["TFOOT"] = "tfoot";
    TAG_NAMES["TD"] = "td";
    TAG_NAMES["TH"] = "th";
    TAG_NAMES["THEAD"] = "thead";
    TAG_NAMES["TITLE"] = "title";
    TAG_NAMES["TR"] = "tr";
    TAG_NAMES["TRACK"] = "track";
    TAG_NAMES["TT"] = "tt";
    TAG_NAMES["U"] = "u";
    TAG_NAMES["UL"] = "ul";
    TAG_NAMES["SVG"] = "svg";
    TAG_NAMES["VAR"] = "var";
    TAG_NAMES["WBR"] = "wbr";
    TAG_NAMES["XMP"] = "xmp";
})($c2855a9ccb69df69$export$7e674a85a2656dce || ($c2855a9ccb69df69$export$7e674a85a2656dce = {}));
var $c2855a9ccb69df69$export$cb0999a53e0acaed;
(function(TAG_ID) {
    TAG_ID[TAG_ID["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID[TAG_ID["A"] = 1] = "A";
    TAG_ID[TAG_ID["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID[TAG_ID["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID[TAG_ID["APPLET"] = 4] = "APPLET";
    TAG_ID[TAG_ID["AREA"] = 5] = "AREA";
    TAG_ID[TAG_ID["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID[TAG_ID["ASIDE"] = 7] = "ASIDE";
    TAG_ID[TAG_ID["B"] = 8] = "B";
    TAG_ID[TAG_ID["BASE"] = 9] = "BASE";
    TAG_ID[TAG_ID["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID[TAG_ID["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID[TAG_ID["BIG"] = 12] = "BIG";
    TAG_ID[TAG_ID["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID[TAG_ID["BODY"] = 14] = "BODY";
    TAG_ID[TAG_ID["BR"] = 15] = "BR";
    TAG_ID[TAG_ID["BUTTON"] = 16] = "BUTTON";
    TAG_ID[TAG_ID["CAPTION"] = 17] = "CAPTION";
    TAG_ID[TAG_ID["CENTER"] = 18] = "CENTER";
    TAG_ID[TAG_ID["CODE"] = 19] = "CODE";
    TAG_ID[TAG_ID["COL"] = 20] = "COL";
    TAG_ID[TAG_ID["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID[TAG_ID["DD"] = 22] = "DD";
    TAG_ID[TAG_ID["DESC"] = 23] = "DESC";
    TAG_ID[TAG_ID["DETAILS"] = 24] = "DETAILS";
    TAG_ID[TAG_ID["DIALOG"] = 25] = "DIALOG";
    TAG_ID[TAG_ID["DIR"] = 26] = "DIR";
    TAG_ID[TAG_ID["DIV"] = 27] = "DIV";
    TAG_ID[TAG_ID["DL"] = 28] = "DL";
    TAG_ID[TAG_ID["DT"] = 29] = "DT";
    TAG_ID[TAG_ID["EM"] = 30] = "EM";
    TAG_ID[TAG_ID["EMBED"] = 31] = "EMBED";
    TAG_ID[TAG_ID["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID[TAG_ID["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID[TAG_ID["FIGURE"] = 34] = "FIGURE";
    TAG_ID[TAG_ID["FONT"] = 35] = "FONT";
    TAG_ID[TAG_ID["FOOTER"] = 36] = "FOOTER";
    TAG_ID[TAG_ID["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID[TAG_ID["FORM"] = 38] = "FORM";
    TAG_ID[TAG_ID["FRAME"] = 39] = "FRAME";
    TAG_ID[TAG_ID["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID[TAG_ID["H1"] = 41] = "H1";
    TAG_ID[TAG_ID["H2"] = 42] = "H2";
    TAG_ID[TAG_ID["H3"] = 43] = "H3";
    TAG_ID[TAG_ID["H4"] = 44] = "H4";
    TAG_ID[TAG_ID["H5"] = 45] = "H5";
    TAG_ID[TAG_ID["H6"] = 46] = "H6";
    TAG_ID[TAG_ID["HEAD"] = 47] = "HEAD";
    TAG_ID[TAG_ID["HEADER"] = 48] = "HEADER";
    TAG_ID[TAG_ID["HGROUP"] = 49] = "HGROUP";
    TAG_ID[TAG_ID["HR"] = 50] = "HR";
    TAG_ID[TAG_ID["HTML"] = 51] = "HTML";
    TAG_ID[TAG_ID["I"] = 52] = "I";
    TAG_ID[TAG_ID["IMG"] = 53] = "IMG";
    TAG_ID[TAG_ID["IMAGE"] = 54] = "IMAGE";
    TAG_ID[TAG_ID["INPUT"] = 55] = "INPUT";
    TAG_ID[TAG_ID["IFRAME"] = 56] = "IFRAME";
    TAG_ID[TAG_ID["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID[TAG_ID["LABEL"] = 58] = "LABEL";
    TAG_ID[TAG_ID["LI"] = 59] = "LI";
    TAG_ID[TAG_ID["LINK"] = 60] = "LINK";
    TAG_ID[TAG_ID["LISTING"] = 61] = "LISTING";
    TAG_ID[TAG_ID["MAIN"] = 62] = "MAIN";
    TAG_ID[TAG_ID["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID[TAG_ID["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID[TAG_ID["MATH"] = 65] = "MATH";
    TAG_ID[TAG_ID["MENU"] = 66] = "MENU";
    TAG_ID[TAG_ID["META"] = 67] = "META";
    TAG_ID[TAG_ID["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID[TAG_ID["MI"] = 69] = "MI";
    TAG_ID[TAG_ID["MO"] = 70] = "MO";
    TAG_ID[TAG_ID["MN"] = 71] = "MN";
    TAG_ID[TAG_ID["MS"] = 72] = "MS";
    TAG_ID[TAG_ID["MTEXT"] = 73] = "MTEXT";
    TAG_ID[TAG_ID["NAV"] = 74] = "NAV";
    TAG_ID[TAG_ID["NOBR"] = 75] = "NOBR";
    TAG_ID[TAG_ID["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID[TAG_ID["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID[TAG_ID["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID[TAG_ID["OBJECT"] = 79] = "OBJECT";
    TAG_ID[TAG_ID["OL"] = 80] = "OL";
    TAG_ID[TAG_ID["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID[TAG_ID["OPTION"] = 82] = "OPTION";
    TAG_ID[TAG_ID["P"] = 83] = "P";
    TAG_ID[TAG_ID["PARAM"] = 84] = "PARAM";
    TAG_ID[TAG_ID["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID[TAG_ID["PRE"] = 86] = "PRE";
    TAG_ID[TAG_ID["RB"] = 87] = "RB";
    TAG_ID[TAG_ID["RP"] = 88] = "RP";
    TAG_ID[TAG_ID["RT"] = 89] = "RT";
    TAG_ID[TAG_ID["RTC"] = 90] = "RTC";
    TAG_ID[TAG_ID["RUBY"] = 91] = "RUBY";
    TAG_ID[TAG_ID["S"] = 92] = "S";
    TAG_ID[TAG_ID["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID[TAG_ID["SEARCH"] = 94] = "SEARCH";
    TAG_ID[TAG_ID["SECTION"] = 95] = "SECTION";
    TAG_ID[TAG_ID["SELECT"] = 96] = "SELECT";
    TAG_ID[TAG_ID["SOURCE"] = 97] = "SOURCE";
    TAG_ID[TAG_ID["SMALL"] = 98] = "SMALL";
    TAG_ID[TAG_ID["SPAN"] = 99] = "SPAN";
    TAG_ID[TAG_ID["STRIKE"] = 100] = "STRIKE";
    TAG_ID[TAG_ID["STRONG"] = 101] = "STRONG";
    TAG_ID[TAG_ID["STYLE"] = 102] = "STYLE";
    TAG_ID[TAG_ID["SUB"] = 103] = "SUB";
    TAG_ID[TAG_ID["SUMMARY"] = 104] = "SUMMARY";
    TAG_ID[TAG_ID["SUP"] = 105] = "SUP";
    TAG_ID[TAG_ID["TABLE"] = 106] = "TABLE";
    TAG_ID[TAG_ID["TBODY"] = 107] = "TBODY";
    TAG_ID[TAG_ID["TEMPLATE"] = 108] = "TEMPLATE";
    TAG_ID[TAG_ID["TEXTAREA"] = 109] = "TEXTAREA";
    TAG_ID[TAG_ID["TFOOT"] = 110] = "TFOOT";
    TAG_ID[TAG_ID["TD"] = 111] = "TD";
    TAG_ID[TAG_ID["TH"] = 112] = "TH";
    TAG_ID[TAG_ID["THEAD"] = 113] = "THEAD";
    TAG_ID[TAG_ID["TITLE"] = 114] = "TITLE";
    TAG_ID[TAG_ID["TR"] = 115] = "TR";
    TAG_ID[TAG_ID["TRACK"] = 116] = "TRACK";
    TAG_ID[TAG_ID["TT"] = 117] = "TT";
    TAG_ID[TAG_ID["U"] = 118] = "U";
    TAG_ID[TAG_ID["UL"] = 119] = "UL";
    TAG_ID[TAG_ID["SVG"] = 120] = "SVG";
    TAG_ID[TAG_ID["VAR"] = 121] = "VAR";
    TAG_ID[TAG_ID["WBR"] = 122] = "WBR";
    TAG_ID[TAG_ID["XMP"] = 123] = "XMP";
})($c2855a9ccb69df69$export$cb0999a53e0acaed || ($c2855a9ccb69df69$export$cb0999a53e0acaed = {}));
const $c2855a9ccb69df69$var$TAG_NAME_TO_ID = new Map([
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.A,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.A
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ADDRESS,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ADDRESS
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ANNOTATION_XML,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ANNOTATION_XML
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.APPLET,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.APPLET
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.AREA,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.AREA
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ARTICLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ARTICLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.ASIDE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.ASIDE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.B,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.B
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BASE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BASE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BASEFONT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BASEFONT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BGSOUND,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BGSOUND
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BIG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BIG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BLOCKQUOTE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BLOCKQUOTE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BODY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BODY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.BUTTON,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.BUTTON
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.CAPTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.CAPTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.CENTER,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.CENTER
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.CODE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.CODE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.COL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.COL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.COLGROUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.COLGROUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DESC,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DESC
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DETAILS,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DETAILS
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DIALOG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DIALOG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DIR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DIR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DIV,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DIV
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.DT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.DT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.EM,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.EM
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.EMBED,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.EMBED
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FIELDSET,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FIELDSET
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FIGCAPTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FIGCAPTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FIGURE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FIGURE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FONT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FONT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FOOTER,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FOOTER
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FOREIGN_OBJECT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FOREIGN_OBJECT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FORM,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FORM
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FRAME,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FRAME
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.FRAMESET,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.FRAMESET
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H1,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H1
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H2,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H2
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H3,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H3
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H4,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H4
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H5,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H5
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.H6,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.H6
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HEAD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HEAD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HEADER,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HEADER
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HGROUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HGROUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.HTML,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.HTML
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.I,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.I
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.IMG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.IMG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.IMAGE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.IMAGE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.INPUT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.INPUT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.IFRAME,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.IFRAME
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.KEYGEN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.KEYGEN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LABEL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LABEL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LI,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LI
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LINK,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LINK
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.LISTING,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.LISTING
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MAIN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MAIN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MALIGNMARK,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MALIGNMARK
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MARQUEE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MARQUEE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MATH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MATH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MENU,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MENU
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.META,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.META
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MGLYPH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MGLYPH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MI,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MI
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MO,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MO
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MS,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MS
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.MTEXT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.MTEXT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NAV,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NAV
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOBR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOBR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOFRAMES,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOFRAMES
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOEMBED,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOEMBED
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.NOSCRIPT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.NOSCRIPT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OBJECT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OBJECT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OPTGROUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OPTGROUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.OPTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.OPTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.P,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.P
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.PARAM,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.PARAM
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.PLAINTEXT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.PLAINTEXT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.PRE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.PRE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RB,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RB
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RTC,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RTC
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.RUBY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.RUBY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.S,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.S
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SCRIPT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SCRIPT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SEARCH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SEARCH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SECTION,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SECTION
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SELECT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SELECT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SOURCE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SOURCE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SMALL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SMALL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SPAN,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SPAN
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.STRIKE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.STRIKE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.STRONG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.STRONG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.STYLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.STYLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SUB,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SUB
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SUMMARY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SUMMARY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SUP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SUP
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TABLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TABLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TBODY,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TBODY
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TEMPLATE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TEMPLATE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TEXTAREA,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TEXTAREA
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TFOOT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TFOOT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TH,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TH
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.THEAD,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.THEAD
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TITLE,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TITLE
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TRACK,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TRACK
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.TT,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.TT
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.U,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.U
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.UL,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.UL
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.SVG,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.SVG
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.VAR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.VAR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.WBR,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.WBR
    ],
    [
        $c2855a9ccb69df69$export$7e674a85a2656dce.XMP,
        $c2855a9ccb69df69$export$cb0999a53e0acaed.XMP
    ]
]);
function $c2855a9ccb69df69$export$39db8a1315f68282(tagName) {
    var _a;
    return (_a = $c2855a9ccb69df69$var$TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : $c2855a9ccb69df69$export$cb0999a53e0acaed.UNKNOWN;
}
const $c2855a9ccb69df69$var$$ = $c2855a9ccb69df69$export$cb0999a53e0acaed;
const $c2855a9ccb69df69$export$7e5172336f7d2bbb = {
    [$c2855a9ccb69df69$export$fb4028874a74450.HTML]: new Set([
        $c2855a9ccb69df69$var$$.ADDRESS,
        $c2855a9ccb69df69$var$$.APPLET,
        $c2855a9ccb69df69$var$$.AREA,
        $c2855a9ccb69df69$var$$.ARTICLE,
        $c2855a9ccb69df69$var$$.ASIDE,
        $c2855a9ccb69df69$var$$.BASE,
        $c2855a9ccb69df69$var$$.BASEFONT,
        $c2855a9ccb69df69$var$$.BGSOUND,
        $c2855a9ccb69df69$var$$.BLOCKQUOTE,
        $c2855a9ccb69df69$var$$.BODY,
        $c2855a9ccb69df69$var$$.BR,
        $c2855a9ccb69df69$var$$.BUTTON,
        $c2855a9ccb69df69$var$$.CAPTION,
        $c2855a9ccb69df69$var$$.CENTER,
        $c2855a9ccb69df69$var$$.COL,
        $c2855a9ccb69df69$var$$.COLGROUP,
        $c2855a9ccb69df69$var$$.DD,
        $c2855a9ccb69df69$var$$.DETAILS,
        $c2855a9ccb69df69$var$$.DIR,
        $c2855a9ccb69df69$var$$.DIV,
        $c2855a9ccb69df69$var$$.DL,
        $c2855a9ccb69df69$var$$.DT,
        $c2855a9ccb69df69$var$$.EMBED,
        $c2855a9ccb69df69$var$$.FIELDSET,
        $c2855a9ccb69df69$var$$.FIGCAPTION,
        $c2855a9ccb69df69$var$$.FIGURE,
        $c2855a9ccb69df69$var$$.FOOTER,
        $c2855a9ccb69df69$var$$.FORM,
        $c2855a9ccb69df69$var$$.FRAME,
        $c2855a9ccb69df69$var$$.FRAMESET,
        $c2855a9ccb69df69$var$$.H1,
        $c2855a9ccb69df69$var$$.H2,
        $c2855a9ccb69df69$var$$.H3,
        $c2855a9ccb69df69$var$$.H4,
        $c2855a9ccb69df69$var$$.H5,
        $c2855a9ccb69df69$var$$.H6,
        $c2855a9ccb69df69$var$$.HEAD,
        $c2855a9ccb69df69$var$$.HEADER,
        $c2855a9ccb69df69$var$$.HGROUP,
        $c2855a9ccb69df69$var$$.HR,
        $c2855a9ccb69df69$var$$.HTML,
        $c2855a9ccb69df69$var$$.IFRAME,
        $c2855a9ccb69df69$var$$.IMG,
        $c2855a9ccb69df69$var$$.INPUT,
        $c2855a9ccb69df69$var$$.LI,
        $c2855a9ccb69df69$var$$.LINK,
        $c2855a9ccb69df69$var$$.LISTING,
        $c2855a9ccb69df69$var$$.MAIN,
        $c2855a9ccb69df69$var$$.MARQUEE,
        $c2855a9ccb69df69$var$$.MENU,
        $c2855a9ccb69df69$var$$.META,
        $c2855a9ccb69df69$var$$.NAV,
        $c2855a9ccb69df69$var$$.NOEMBED,
        $c2855a9ccb69df69$var$$.NOFRAMES,
        $c2855a9ccb69df69$var$$.NOSCRIPT,
        $c2855a9ccb69df69$var$$.OBJECT,
        $c2855a9ccb69df69$var$$.OL,
        $c2855a9ccb69df69$var$$.P,
        $c2855a9ccb69df69$var$$.PARAM,
        $c2855a9ccb69df69$var$$.PLAINTEXT,
        $c2855a9ccb69df69$var$$.PRE,
        $c2855a9ccb69df69$var$$.SCRIPT,
        $c2855a9ccb69df69$var$$.SECTION,
        $c2855a9ccb69df69$var$$.SELECT,
        $c2855a9ccb69df69$var$$.SOURCE,
        $c2855a9ccb69df69$var$$.STYLE,
        $c2855a9ccb69df69$var$$.SUMMARY,
        $c2855a9ccb69df69$var$$.TABLE,
        $c2855a9ccb69df69$var$$.TBODY,
        $c2855a9ccb69df69$var$$.TD,
        $c2855a9ccb69df69$var$$.TEMPLATE,
        $c2855a9ccb69df69$var$$.TEXTAREA,
        $c2855a9ccb69df69$var$$.TFOOT,
        $c2855a9ccb69df69$var$$.TH,
        $c2855a9ccb69df69$var$$.THEAD,
        $c2855a9ccb69df69$var$$.TITLE,
        $c2855a9ccb69df69$var$$.TR,
        $c2855a9ccb69df69$var$$.TRACK,
        $c2855a9ccb69df69$var$$.UL,
        $c2855a9ccb69df69$var$$.WBR,
        $c2855a9ccb69df69$var$$.XMP
    ]),
    [$c2855a9ccb69df69$export$fb4028874a74450.MATHML]: new Set([
        $c2855a9ccb69df69$var$$.MI,
        $c2855a9ccb69df69$var$$.MO,
        $c2855a9ccb69df69$var$$.MN,
        $c2855a9ccb69df69$var$$.MS,
        $c2855a9ccb69df69$var$$.MTEXT,
        $c2855a9ccb69df69$var$$.ANNOTATION_XML
    ]),
    [$c2855a9ccb69df69$export$fb4028874a74450.SVG]: new Set([
        $c2855a9ccb69df69$var$$.TITLE,
        $c2855a9ccb69df69$var$$.FOREIGN_OBJECT,
        $c2855a9ccb69df69$var$$.DESC
    ]),
    [$c2855a9ccb69df69$export$fb4028874a74450.XLINK]: new Set(),
    [$c2855a9ccb69df69$export$fb4028874a74450.XML]: new Set(),
    [$c2855a9ccb69df69$export$fb4028874a74450.XMLNS]: new Set()
};
const $c2855a9ccb69df69$export$1ecc20fa0754c045 = new Set([
    $c2855a9ccb69df69$var$$.H1,
    $c2855a9ccb69df69$var$$.H2,
    $c2855a9ccb69df69$var$$.H3,
    $c2855a9ccb69df69$var$$.H4,
    $c2855a9ccb69df69$var$$.H5,
    $c2855a9ccb69df69$var$$.H6
]);
const $c2855a9ccb69df69$var$UNESCAPED_TEXT = new Set([
    $c2855a9ccb69df69$export$7e674a85a2656dce.STYLE,
    $c2855a9ccb69df69$export$7e674a85a2656dce.SCRIPT,
    $c2855a9ccb69df69$export$7e674a85a2656dce.XMP,
    $c2855a9ccb69df69$export$7e674a85a2656dce.IFRAME,
    $c2855a9ccb69df69$export$7e674a85a2656dce.NOEMBED,
    $c2855a9ccb69df69$export$7e674a85a2656dce.NOFRAMES,
    $c2855a9ccb69df69$export$7e674a85a2656dce.PLAINTEXT
]);
function $c2855a9ccb69df69$export$4ce4f8c09f921aed(tn, scriptingEnabled) {
    return $c2855a9ccb69df69$var$UNESCAPED_TEXT.has(tn) || scriptingEnabled && tn === $c2855a9ccb69df69$export$7e674a85a2656dce.NOSCRIPT;
}


//States
var $c44790542489a2a8$var$State;
(function(State) {
    State[State["DATA"] = 0] = "DATA";
    State[State["RCDATA"] = 1] = "RCDATA";
    State[State["RAWTEXT"] = 2] = "RAWTEXT";
    State[State["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
    State[State["PLAINTEXT"] = 4] = "PLAINTEXT";
    State[State["TAG_OPEN"] = 5] = "TAG_OPEN";
    State[State["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
    State[State["TAG_NAME"] = 7] = "TAG_NAME";
    State[State["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
    State[State["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
    State[State["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
    State[State["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
    State[State["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
    State[State["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
    State[State["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
    State[State["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
    State[State["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
    State[State["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
    State[State["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
    State[State["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
    State[State["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
    State[State["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
    State[State["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
    State[State["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
    State[State["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
    State[State["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
    State[State["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
    State[State["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
    State[State["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
    State[State["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
    State[State["COMMENT_START"] = 42] = "COMMENT_START";
    State[State["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
    State[State["COMMENT"] = 44] = "COMMENT";
    State[State["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
    State[State["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
    State[State["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
    State[State["COMMENT_END"] = 50] = "COMMENT_END";
    State[State["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
    State[State["DOCTYPE"] = 52] = "DOCTYPE";
    State[State["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
    State[State["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
    State[State["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
    State[State["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
    State[State["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
    State[State["CDATA_SECTION"] = 68] = "CDATA_SECTION";
    State[State["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
    State[State["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
    State[State["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
    State[State["AMBIGUOUS_AMPERSAND"] = 72] = "AMBIGUOUS_AMPERSAND";
})($c44790542489a2a8$var$State || ($c44790542489a2a8$var$State = {}));
const $c44790542489a2a8$export$d0c9fb8d2ebe5159 = {
    DATA: $c44790542489a2a8$var$State.DATA,
    RCDATA: $c44790542489a2a8$var$State.RCDATA,
    RAWTEXT: $c44790542489a2a8$var$State.RAWTEXT,
    SCRIPT_DATA: $c44790542489a2a8$var$State.SCRIPT_DATA,
    PLAINTEXT: $c44790542489a2a8$var$State.PLAINTEXT,
    CDATA_SECTION: $c44790542489a2a8$var$State.CDATA_SECTION
};
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function $c44790542489a2a8$var$isAsciiDigit(cp) {
    return cp >= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).DIGIT_0 && cp <= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).DIGIT_9;
}
function $c44790542489a2a8$var$isAsciiUpper(cp) {
    return cp >= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_A && cp <= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_Z;
}
function $c44790542489a2a8$var$isAsciiLower(cp) {
    return cp >= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_SMALL_A && cp <= (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LATIN_SMALL_Z;
}
function $c44790542489a2a8$var$isAsciiLetter(cp) {
    return $c44790542489a2a8$var$isAsciiLower(cp) || $c44790542489a2a8$var$isAsciiUpper(cp);
}
function $c44790542489a2a8$var$isAsciiAlphaNumeric(cp) {
    return $c44790542489a2a8$var$isAsciiLetter(cp) || $c44790542489a2a8$var$isAsciiDigit(cp);
}
function $c44790542489a2a8$var$toAsciiLower(cp) {
    return cp + 32;
}
function $c44790542489a2a8$var$isWhitespace(cp) {
    return cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED;
}
function $c44790542489a2a8$var$isScriptDataDoubleEscapeSequenceEnd(cp) {
    return $c44790542489a2a8$var$isWhitespace(cp) || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS || cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN;
}
function $c44790542489a2a8$var$getErrorForNumericCharacterReference(code) {
    if (code === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nullCharacterReference;
    else if (code > 1114111) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).characterReferenceOutsideUnicodeRange;
    else if ((0, $bb1347fda1174ed8$export$7e678b42035e707f)(code)) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).surrogateCharacterReference;
    else if ((0, $bb1347fda1174ed8$export$b3484aaf321bda02)(code)) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).noncharacterCharacterReference;
    else if ((0, $bb1347fda1174ed8$export$d6953a6077926e)(code) || code === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) return (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).controlCharacterReference;
    return null;
}
class $c44790542489a2a8$export$55e8b082af4aa63e {
    //Errors
    _err(code, cpOffset = 0) {
        var _a, _b;
        (_b = (_a = this.handler).onParseError) === null || _b === void 0 || _b.call(_a, this.preprocessor.getError(code, cpOffset));
    }
    // NOTE: `offset` may never run across line boundaries.
    getCurrentLocation(offset) {
        if (!this.options.sourceCodeLocationInfo) return null;
        return {
            startLine: this.preprocessor.line,
            startCol: this.preprocessor.col - offset,
            startOffset: this.preprocessor.offset - offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }
    _runParsingLoop() {
        if (this.inLoop) return;
        this.inLoop = true;
        while(this.active && !this.paused){
            this.consumedAfterSnapshot = 0;
            const cp = this._consume();
            if (!this._ensureHibernation()) this._callState(cp);
        }
        this.inLoop = false;
    }
    //API
    pause() {
        this.paused = true;
    }
    resume(writeCallback) {
        if (!this.paused) throw new Error('Parser was already resumed');
        this.paused = false;
        // Necessary for synchronous resume.
        if (this.inLoop) return;
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    write(chunk, isLastChunk, writeCallback) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
        this._runParsingLoop();
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            this.preprocessor.retreat(this.consumedAfterSnapshot);
            this.consumedAfterSnapshot = 0;
            this.active = false;
            return true;
        }
        return false;
    }
    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }
    _advanceBy(count) {
        this.consumedAfterSnapshot += count;
        for(let i = 0; i < count; i++)this.preprocessor.advance();
    }
    _consumeSequenceIfMatch(pattern, caseSensitive) {
        if (this.preprocessor.startsWith(pattern, caseSensitive)) {
            // We will already have consumed one character before calling this method.
            this._advanceBy(pattern.length - 1);
            return true;
        }
        return false;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG,
            tagName: '',
            tagID: (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(1)
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG,
            tagName: '',
            tagID: (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(2)
        };
    }
    _createCommentToken(offset) {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).COMMENT,
            data: '',
            location: this.getCurrentLocation(offset)
        };
    }
    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).DOCTYPE,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null,
            location: this.currentLocation
        };
    }
    _createCharacterToken(type, chars) {
        this.currentCharacterToken = {
            type: type,
            chars: chars,
            location: this.currentLocation
        };
    }
    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ''
        };
        this.currentLocation = this.getCurrentLocation(0);
    }
    _leaveAttrName() {
        var _a;
        var _b;
        const token = this.currentToken;
        if ((0, $be390ad8d330a451$export$df33bba014b5841e)(token, this.currentAttr.name) === null) {
            token.attrs.push(this.currentAttr);
            if (token.location && this.currentLocation) {
                const attrLocations = (_a = (_b = token.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = Object.create(null);
                attrLocations[this.currentAttr.name] = this.currentLocation;
                // Set end location
                this._leaveAttrValue();
            }
        } else this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).duplicateAttribute);
    }
    _leaveAttrValue() {
        if (this.currentLocation) {
            this.currentLocation.endLine = this.preprocessor.line;
            this.currentLocation.endCol = this.preprocessor.col;
            this.currentLocation.endOffset = this.preprocessor.offset;
        }
    }
    //Token emission
    prepareToken(ct) {
        this._emitCurrentCharacterToken(ct.location);
        this.currentToken = null;
        if (ct.location) {
            ct.location.endLine = this.preprocessor.line;
            ct.location.endCol = this.preprocessor.col + 1;
            ct.location.endOffset = this.preprocessor.offset + 1;
        }
        this.currentLocation = this.getCurrentLocation(-1);
    }
    emitCurrentTagToken() {
        const ct = this.currentToken;
        this.prepareToken(ct);
        ct.tagID = (0, $c2855a9ccb69df69$export$39db8a1315f68282)(ct.tagName);
        if (ct.type === (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG) {
            this.lastStartTagName = ct.tagName;
            this.handler.onStartTag(ct);
        } else {
            if (ct.attrs.length > 0) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithAttributes);
            if (ct.selfClosing) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithTrailingSolidus);
            this.handler.onEndTag(ct);
        }
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentComment(ct) {
        this.prepareToken(ct);
        this.handler.onComment(ct);
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentDoctype(ct) {
        this.prepareToken(ct);
        this.handler.onDoctype(ct);
        this.preprocessor.dropParsedChunk();
    }
    _emitCurrentCharacterToken(nextLocation) {
        if (this.currentCharacterToken) {
            //NOTE: if we have a pending character token, make it's end location equal to the
            //current token's start location.
            if (nextLocation && this.currentCharacterToken.location) {
                this.currentCharacterToken.location.endLine = nextLocation.startLine;
                this.currentCharacterToken.location.endCol = nextLocation.startCol;
                this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
            }
            switch(this.currentCharacterToken.type){
                case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
                    this.handler.onCharacter(this.currentCharacterToken);
                    break;
                case (0, $be390ad8d330a451$export$f435f793048e7a0f).NULL_CHARACTER:
                    this.handler.onNullCharacter(this.currentCharacterToken);
                    break;
                case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                    this.handler.onWhitespaceCharacter(this.currentCharacterToken);
                    break;
            }
            this.currentCharacterToken = null;
        }
    }
    _emitEOFToken() {
        const location = this.getCurrentLocation(0);
        if (location) {
            location.endLine = location.startLine;
            location.endCol = location.startCol;
            location.endOffset = location.startOffset;
        }
        this._emitCurrentCharacterToken(location);
        this.handler.onEof({
            type: (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF,
            location: location
        });
        this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: The specification uses only one type of character token (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken) {
            if (this.currentCharacterToken.type === type) {
                this.currentCharacterToken.chars += ch;
                return;
            } else {
                this.currentLocation = this.getCurrentLocation(0);
                this._emitCurrentCharacterToken(this.currentLocation);
                this.preprocessor.dropParsedChunk();
            }
        }
        this._createCharacterToken(type, ch);
    }
    _emitCodePoint(cp) {
        const type = $c44790542489a2a8$var$isWhitespace(cp) ? (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER : cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL ? (0, $be390ad8d330a451$export$f435f793048e7a0f).NULL_CHARACTER : (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER;
        this._appendCharToCurrentCharacterToken(type, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken((0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER, ch);
    }
    // Character reference helpers
    _startCharacterReference() {
        this.returnState = this.state;
        this.state = $c44790542489a2a8$var$State.CHARACTER_REFERENCE;
        this.entityStartPos = this.preprocessor.pos;
        this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? (0, $b715bb39f665675e$export$8c8f129ce60f53c).Attribute : (0, $b715bb39f665675e$export$8c8f129ce60f53c).Legacy);
    }
    _isCharacterReferenceInAttribute() {
        return this.returnState === $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_UNQUOTED;
    }
    _flushCodePointConsumedAsCharacterReference(cp) {
        if (this._isCharacterReferenceInAttribute()) this.currentAttr.value += String.fromCodePoint(cp);
        else this._emitCodePoint(cp);
    }
    // Calling states this way turns out to be much faster than any other approach.
    _callState(cp) {
        switch(this.state){
            case $c44790542489a2a8$var$State.DATA:
                this._stateData(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA:
                this._stateRcdata(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT:
                this._stateRawtext(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA:
                this._stateScriptData(cp);
                break;
            case $c44790542489a2a8$var$State.PLAINTEXT:
                this._statePlaintext(cp);
                break;
            case $c44790542489a2a8$var$State.TAG_OPEN:
                this._stateTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.END_TAG_OPEN:
                this._stateEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.TAG_NAME:
                this._stateTagName(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA_LESS_THAN_SIGN:
                this._stateRcdataLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA_END_TAG_OPEN:
                this._stateRcdataEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.RCDATA_END_TAG_NAME:
                this._stateRcdataEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT_LESS_THAN_SIGN:
                this._stateRawtextLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT_END_TAG_OPEN:
                this._stateRawtextEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.RAWTEXT_END_TAG_NAME:
                this._stateRawtextEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_LESS_THAN_SIGN:
                this._stateScriptDataLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_OPEN:
                this._stateScriptDataEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_NAME:
                this._stateScriptDataEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START:
                this._stateScriptDataEscapeStart(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START_DASH:
                this._stateScriptDataEscapeStartDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED:
                this._stateScriptDataEscaped(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH:
                this._stateScriptDataEscapedDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH:
                this._stateScriptDataEscapedDashDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataEscapedLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
                this._stateScriptDataEscapedEndTagOpen(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
                this._stateScriptDataEscapedEndTagName(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START:
                this._stateScriptDataDoubleEscapeStart(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED:
                this._stateScriptDataDoubleEscaped(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
                this._stateScriptDataDoubleEscapedDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
                this._stateScriptDataDoubleEscapedDashDash(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataDoubleEscapedLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END:
                this._stateScriptDataDoubleEscapeEnd(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME:
                this._stateBeforeAttributeName(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_NAME:
                this._stateAttributeName(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_NAME:
                this._stateAfterAttributeName(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_VALUE:
                this._stateBeforeAttributeValue(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
                this._stateAttributeValueDoubleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED:
                this._stateAttributeValueSingleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_UNQUOTED:
                this._stateAttributeValueUnquoted(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED:
                this._stateAfterAttributeValueQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG:
                this._stateSelfClosingStartTag(cp);
                break;
            case $c44790542489a2a8$var$State.BOGUS_COMMENT:
                this._stateBogusComment(cp);
                break;
            case $c44790542489a2a8$var$State.MARKUP_DECLARATION_OPEN:
                this._stateMarkupDeclarationOpen(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_START:
                this._stateCommentStart(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_START_DASH:
                this._stateCommentStartDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT:
                this._stateComment(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN:
                this._stateCommentLessThanSign(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG:
                this._stateCommentLessThanSignBang(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH:
                this._stateCommentLessThanSignBangDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
                this._stateCommentLessThanSignBangDashDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_END_DASH:
                this._stateCommentEndDash(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_END:
                this._stateCommentEnd(cp);
                break;
            case $c44790542489a2a8$var$State.COMMENT_END_BANG:
                this._stateCommentEndBang(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE:
                this._stateDoctype(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME:
                this._stateBeforeDoctypeName(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_NAME:
                this._stateDoctypeName(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_NAME:
                this._stateAfterDoctypeName(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD:
                this._stateAfterDoctypePublicKeyword(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateBeforeDoctypePublicIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypePublicIdentifierDoubleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypePublicIdentifierSingleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateAfterDoctypePublicIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
                this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD:
                this._stateAfterDoctypeSystemKeyword(cp);
                break;
            case $c44790542489a2a8$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateBeforeDoctypeSystemIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypeSystemIdentifierSingleQuoted(cp);
                break;
            case $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateAfterDoctypeSystemIdentifier(cp);
                break;
            case $c44790542489a2a8$var$State.BOGUS_DOCTYPE:
                this._stateBogusDoctype(cp);
                break;
            case $c44790542489a2a8$var$State.CDATA_SECTION:
                this._stateCdataSection(cp);
                break;
            case $c44790542489a2a8$var$State.CDATA_SECTION_BRACKET:
                this._stateCdataSectionBracket(cp);
                break;
            case $c44790542489a2a8$var$State.CDATA_SECTION_END:
                this._stateCdataSectionEnd(cp);
                break;
            case $c44790542489a2a8$var$State.CHARACTER_REFERENCE:
                this._stateCharacterReference();
                break;
            case $c44790542489a2a8$var$State.AMBIGUOUS_AMPERSAND:
                this._stateAmbiguousAmpersand(cp);
                break;
            default:
                throw new Error('Unknown state');
        }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    _stateData(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.TAG_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitCodePoint(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    //  RCDATA state
    //------------------------------------------------------------------
    _stateRcdata(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.RCDATA_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    _stateRawtext(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.RAWTEXT_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data state
    //------------------------------------------------------------------
    _stateScriptData(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    _statePlaintext(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Tag open state
    //------------------------------------------------------------------
    _stateTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this._createStartTagToken();
            this.state = $c44790542489a2a8$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $c44790542489a2a8$var$State.MARKUP_DECLARATION_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.END_TAG_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUESTION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedQuestionMarkInsteadOfTagName);
                this._createCommentToken(1);
                this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('<');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._emitChars('<');
                this.state = $c44790542489a2a8$var$State.DATA;
                this._stateData(cp);
        }
    }
    // End tag open state
    //------------------------------------------------------------------
    _stateEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this.state = $c44790542489a2a8$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingEndTagName);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('</');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._createCommentToken(2);
                this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
        }
    }
    // Tag name state
    //------------------------------------------------------------------
    _stateTagName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.tagName += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                token.tagName += String.fromCodePoint($c44790542489a2a8$var$isAsciiUpper(cp) ? $c44790542489a2a8$var$toAsciiLower(cp) : cp);
        }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    _stateRcdataLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $c44790542489a2a8$var$State.RCDATA_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    _stateRcdataEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.RCDATA_END_TAG_NAME;
            this._stateRcdataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    handleSpecialEndTag(_cp) {
        if (!this.preprocessor.startsWith(this.lastStartTagName, false)) return !this._ensureHibernation();
        this._createEndTagToken();
        const token = this.currentToken;
        token.tagName = this.lastStartTagName;
        const cp = this.preprocessor.peek(this.lastStartTagName.length);
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                return false;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                return false;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._advanceBy(this.lastStartTagName.length);
                this.emitCurrentTagToken();
                this.state = $c44790542489a2a8$var$State.DATA;
                return false;
            default:
                return !this._ensureHibernation();
        }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    _stateRcdataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    _stateRawtextLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $c44790542489a2a8$var$State.RAWTEXT_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    _stateRawtextEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.RAWTEXT_END_TAG_NAME;
            this._stateRawtextEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    _stateRawtextEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataLessThanSign(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_OPEN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START;
                this._emitChars('<!');
                break;
            default:
                this._emitChars('<');
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
                this._stateScriptData(cp);
        }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_END_TAG_NAME;
            this._stateScriptDataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStart(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPE_START_DASH;
            this._emitChars('-');
        } else {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStartDash(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
            this._emitChars('-');
        } else {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escaped state
    //------------------------------------------------------------------
    _stateScriptDataEscaped(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDashDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataEscapedLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
        else if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START;
            this._stateScriptDataDoubleEscapeStart(cp);
        } else {
            this._emitChars('<');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagOpen(cp) {
        if ($c44790542489a2a8$var$isAsciiLetter(cp)) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
            this._stateScriptDataEscapedEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeStart(cp) {
        if (this.preprocessor.startsWith((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT, false) && $c44790542489a2a8$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscaped(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDashDash(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedLessThanSign(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END;
            this._emitChars('/');
        } else {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeEnd(cp) {
        if (this.preprocessor.startsWith((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT, false) && $c44790542489a2a8$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $bb1347fda1174ed8$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $c44790542489a2a8$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Before attribute name state
    //------------------------------------------------------------------
    _stateBeforeAttributeName(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedEqualsSignBeforeAttributeName);
                this._createAttr('=');
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_NAME;
                break;
            default:
                this._createAttr('');
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Attribute name state
    //------------------------------------------------------------------
    _stateAttributeName(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._leaveAttrName();
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._leaveAttrName();
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedCharacterInAttributeName);
                this.currentAttr.name += String.fromCodePoint(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.name += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            default:
                this.currentAttr.name += String.fromCodePoint($c44790542489a2a8$var$isAsciiUpper(cp) ? $c44790542489a2a8$var$toAsciiLower(cp) : cp);
        }
    }
    // After attribute name state
    //------------------------------------------------------------------
    _stateAfterAttributeName(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._createAttr('');
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Before attribute value state
    //------------------------------------------------------------------
    _stateBeforeAttributeValue(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingAttributeValue);
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            default:
                this.state = $c44790542489a2a8$var$State.ATTRIBUTE_VALUE_UNQUOTED;
                this._stateAttributeValueUnquoted(cp);
        }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueDoubleQuoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueSingleQuoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    _stateAttributeValueUnquoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this._startCharacterReference();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GRAVE_ACCENT:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedCharacterInUnquotedAttributeValue);
                this.currentAttr.value += String.fromCodePoint(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    _stateAfterAttributeValueQuoted(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBetweenAttributes);
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    _stateSelfClosingStartTag(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    const token = this.currentToken;
                    token.selfClosing = true;
                    this.state = $c44790542489a2a8$var$State.DATA;
                    this.emitCurrentTagToken();
                    break;
                }
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedSolidusInTag);
                this.state = $c44790542489a2a8$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Bogus comment state
    //------------------------------------------------------------------
    _stateBogusComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    _stateMarkupDeclarationOpen(cp) {
        if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).DASH_DASH, true)) {
            this._createCommentToken((0, $bb1347fda1174ed8$export$5abac700f947e2).DASH_DASH.length + 1);
            this.state = $c44790542489a2a8$var$State.COMMENT_START;
        } else if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).DOCTYPE, false)) {
            // NOTE: Doctypes tokens are created without fixed offsets. We keep track of the moment a doctype *might* start here.
            this.currentLocation = this.getCurrentLocation((0, $bb1347fda1174ed8$export$5abac700f947e2).DOCTYPE.length + 1);
            this.state = $c44790542489a2a8$var$State.DOCTYPE;
        } else if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).CDATA_START, true)) {
            if (this.inForeignNode) this.state = $c44790542489a2a8$var$State.CDATA_SECTION;
            else {
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).cdataInHtmlContent);
                this._createCommentToken((0, $bb1347fda1174ed8$export$5abac700f947e2).CDATA_START.length + 1);
                this.currentToken.data = '[CDATA[';
                this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
            }
        } else if (!this._ensureHibernation()) {
            this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).incorrectlyOpenedComment);
            this._createCommentToken(2);
            this.state = $c44790542489a2a8$var$State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
        }
    }
    // Comment start state
    //------------------------------------------------------------------
    _stateCommentStart(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_START_DASH;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                    this.state = $c44790542489a2a8$var$State.DATA;
                    const token = this.currentToken;
                    this.emitCurrentComment(token);
                    break;
                }
            default:
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment start dash state
    //------------------------------------------------------------------
    _stateCommentStartDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_END;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment state
    //------------------------------------------------------------------
    _stateComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_END_DASH;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    _stateCommentLessThanSign(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                token.data += '!';
                this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                break;
            default:
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBang(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH;
        else {
            this.state = $c44790542489a2a8$var$State.COMMENT;
            this._stateComment(cp);
        }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDash(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $c44790542489a2a8$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
        else {
            this.state = $c44790542489a2a8$var$State.COMMENT_END_DASH;
            this._stateCommentEndDash(cp);
        }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDashDash(cp) {
        if (cp !== (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN && cp !== (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nestedComment);
        this.state = $c44790542489a2a8$var$State.COMMENT_END;
        this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    _stateCommentEndDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $c44790542489a2a8$var$State.COMMENT_END;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end state
    //------------------------------------------------------------------
    _stateCommentEnd(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $c44790542489a2a8$var$State.COMMENT_END_BANG;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '-';
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end bang state
    //------------------------------------------------------------------
    _stateCommentEndBang(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '--!';
                this.state = $c44790542489a2a8$var$State.COMMENT_END_DASH;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).incorrectlyClosedComment);
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--!';
                this.state = $c44790542489a2a8$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    _stateDoctype(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBeforeDoctypeName);
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
        }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    _stateBeforeDoctypeName(cp) {
        if ($c44790542489a2a8$var$isAsciiUpper(cp)) {
            this._createDoctypeToken(String.fromCharCode($c44790542489a2a8$var$toAsciiLower(cp)));
            this.state = $c44790542489a2a8$var$State.DOCTYPE_NAME;
        } else switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._createDoctypeToken((0, $bb1347fda1174ed8$export$e8d20e7a50e6c279));
                this.state = $c44790542489a2a8$var$State.DOCTYPE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypeName);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this.state = $c44790542489a2a8$var$State.DATA;
                    break;
                }
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._createDoctypeToken(String.fromCodePoint(cp));
                this.state = $c44790542489a2a8$var$State.DOCTYPE_NAME;
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    _stateDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_NAME;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.name += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.name += String.fromCodePoint($c44790542489a2a8$var$isAsciiUpper(cp) ? $c44790542489a2a8$var$toAsciiLower(cp) : cp);
        }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    _stateAfterDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).PUBLIC, false)) this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD;
                else if (this._consumeSequenceIfMatch((0, $bb1347fda1174ed8$export$5abac700f947e2).SYSTEM, false)) this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD;
                else if (!this._ensureHibernation()) {
                    this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).invalidCharacterSequenceAfterDoctypeName);
                    token.forceQuirks = true;
                    this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                    this._stateBogusDoctype(cp);
                }
        }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.publicId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $c44790542489a2a8$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $c44790542489a2a8$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $c44790542489a2a8$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $bb1347fda1174ed8$export$e8d20e7a50e6c279);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedCharacterAfterDoctypeSystemIdentifier);
                this.state = $c44790542489a2a8$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    _stateBogusDoctype(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unexpectedNullCharacter);
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
        }
    }
    // CDATA section state
    //------------------------------------------------------------------
    _stateCdataSection(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this.state = $c44790542489a2a8$var$State.CDATA_SECTION_BRACKET;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInCdata);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    _stateCdataSectionBracket(cp) {
        if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET) this.state = $c44790542489a2a8$var$State.CDATA_SECTION_END;
        else {
            this._emitChars(']');
            this.state = $c44790542489a2a8$var$State.CDATA_SECTION;
            this._stateCdataSection(cp);
        }
    }
    // CDATA section end state
    //------------------------------------------------------------------
    _stateCdataSectionEnd(cp) {
        switch(cp){
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $c44790542489a2a8$var$State.DATA;
                break;
            case (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this._emitChars(']');
                break;
            default:
                this._emitChars(']]');
                this.state = $c44790542489a2a8$var$State.CDATA_SECTION;
                this._stateCdataSection(cp);
        }
    }
    // Character reference state
    //------------------------------------------------------------------
    _stateCharacterReference() {
        let length = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
        if (length < 0) {
            if (this.preprocessor.lastChunkWritten) length = this.entityDecoder.end();
            else {
                // Wait for the rest of the entity.
                this.active = false;
                // Mark the entire buffer as read.
                this.preprocessor.pos = this.preprocessor.html.length - 1;
                this.consumedAfterSnapshot = 0;
                this.preprocessor.endOfChunkHit = true;
                return;
            }
        }
        if (length === 0) {
            // This was not a valid entity. Go back to the beginning, and
            // figure out what to do.
            this.preprocessor.pos = this.entityStartPos;
            this._flushCodePointConsumedAsCharacterReference((0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this.state = !this._isCharacterReferenceInAttribute() && $c44790542489a2a8$var$isAsciiAlphaNumeric(this.preprocessor.peek(1)) ? $c44790542489a2a8$var$State.AMBIGUOUS_AMPERSAND : this.returnState;
        } else // We successfully parsed an entity. Switch to the return state.
        this.state = this.returnState;
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    _stateAmbiguousAmpersand(cp) {
        if ($c44790542489a2a8$var$isAsciiAlphaNumeric(cp)) this._flushCodePointConsumedAsCharacterReference(cp);
        else {
            if (cp === (0, $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0).SEMICOLON) this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).unknownNamedCharacterReference);
            this.state = this.returnState;
            this._callState(cp);
        }
    }
    constructor(options, handler){
        this.options = options;
        this.handler = handler;
        this.paused = false;
        /** Ensures that the parsing loop isn't run multiple times at once. */ this.inLoop = false;
        /**
         * Indicates that the current adjusted node exists, is not an element in the HTML namespace,
         * and that it is not an integration point for either MathML or HTML.
         *
         * @see {@link https://html.spec.whatwg.org/multipage/parsing.html#tree-construction}
         */ this.inForeignNode = false;
        this.lastStartTagName = '';
        this.active = false;
        this.state = $c44790542489a2a8$var$State.DATA;
        this.returnState = $c44790542489a2a8$var$State.DATA;
        this.entityStartPos = 0;
        this.consumedAfterSnapshot = -1;
        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = {
            name: '',
            value: ''
        };
        this.preprocessor = new (0, $5940cf2ccae8becf$export$35db5c8036a15ad1)(handler);
        this.currentLocation = this.getCurrentLocation(-1);
        this.entityDecoder = new (0, $b715bb39f665675e$export$15263a93ff7ec8ba)((0, $8bb06a4e9c5f6236$export$b6a4accd5ee85f69), (cp, consumed)=>{
            // Note: Set `pos` _before_ flushing, as flushing might drop
            // the current chunk and invalidate `entityStartPos`.
            this.preprocessor.pos = this.entityStartPos + consumed - 1;
            this._flushCodePointConsumedAsCharacterReference(cp);
        }, handler.onParseError ? {
            missingSemicolonAfterCharacterReference: ()=>{
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingSemicolonAfterCharacterReference, 1);
            },
            absenceOfDigitsInNumericCharacterReference: (consumed)=>{
                this._err((0, $36aeaab04c5a6aea$export$9e0efcb140234d2).absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + consumed);
            },
            validateNumericCharacterReference: (code)=>{
                const error = $c44790542489a2a8$var$getErrorForNumericCharacterReference(code);
                if (error) this._err(error, 1);
            }
        } : undefined);
    }
}



//Element utils
const $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RB,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RTC
]);
const $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = new Set([
    ...$ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).APPLET,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MARQUEE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OBJECT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_LIST = new Set([
    ...$ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_BUTTON = new Set([
    ...$ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_MATHML = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ANNOTATION_XML,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MI,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MN,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MO,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MS,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MTEXT
]);
const $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_SVG = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DESC,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOREIGN_OBJECT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE
]);
const $ebf2c18607f34e1d$var$TABLE_ROW_CONTEXT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML
]);
const $ebf2c18607f34e1d$var$TABLE_BODY_CONTEXT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML
]);
const $ebf2c18607f34e1d$var$TABLE_CONTEXT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML
]);
const $ebf2c18607f34e1d$var$TABLE_CELLS = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH
]);
class $ebf2c18607f34e1d$export$56decf886ed987d6 {
    get currentTmplContentOrNode() {
        return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
    //Index of element
    _indexOf(element) {
        return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
    push(element, tagID) {
        this.stackTop++;
        this.items[this.stackTop] = element;
        this.current = element;
        this.tagIDs[this.stackTop] = tagID;
        this.currentTagId = tagID;
        if (this._isInTemplate()) this.tmplCount++;
        this.handler.onItemPush(element, tagID, true);
    }
    pop() {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount--;
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, true);
    }
    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) this.current = newElement;
    }
    insertAfter(referenceElement, newElement, newElementID) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        this.tagIDs.splice(insertionIdx, 0, newElementID);
        this.stackTop++;
        if (insertionIdx === this.stackTop) this._updateCurrentElement();
        if (this.current && this.currentTagId !== undefined) this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
    popUntilTagNamePopped(tagName) {
        let targetIdx = this.stackTop + 1;
        do targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
        while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        this.shortenToLength(Math.max(targetIdx, 0));
    }
    shortenToLength(idx) {
        while(this.stackTop >= idx){
            const popped = this.current;
            if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount -= 1;
            this.stackTop--;
            this._updateCurrentElement();
            this.handler.onItemPop(popped, this.stackTop < idx);
        }
    }
    popUntilElementPopped(element) {
        const idx = this._indexOf(element);
        this.shortenToLength(Math.max(idx, 0));
    }
    popUntilPopped(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(Math.max(idx, 0));
    }
    popUntilNumberedHeaderPopped() {
        this.popUntilPopped((0, $c2855a9ccb69df69$export$1ecc20fa0754c045), (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    popUntilTableCellPopped() {
        this.popUntilPopped($ebf2c18607f34e1d$var$TABLE_CELLS, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    popAllUpToHtmlElement() {
        //NOTE: here we assume that the root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.tmplCount = 0;
        this.shortenToLength(1);
    }
    _indexOfTagNames(tagNames, namespace) {
        for(let i = this.stackTop; i >= 0; i--){
            if (tagNames.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace) return i;
        }
        return -1;
    }
    clearBackTo(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx + 1);
    }
    clearBackToTableContext() {
        this.clearBackTo($ebf2c18607f34e1d$var$TABLE_CONTEXT, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    clearBackToTableBodyContext() {
        this.clearBackTo($ebf2c18607f34e1d$var$TABLE_BODY_CONTEXT, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    clearBackToTableRowContext() {
        this.clearBackTo($ebf2c18607f34e1d$var$TABLE_ROW_CONTEXT, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    }
    remove(element) {
        const idx = this._indexOf(element);
        if (idx >= 0) {
            if (idx === this.stackTop) this.pop();
            else {
                this.items.splice(idx, 1);
                this.tagIDs.splice(idx, 1);
                this.stackTop--;
                this._updateCurrentElement();
                this.handler.onItemPop(element, false);
            }
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        return this.stackTop >= 1 && this.tagIDs[1] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY ? this.items[1] : null;
    }
    contains(element) {
        return this._indexOf(element) > -1;
    }
    getCommonAncestor(element) {
        const elementIdx = this._indexOf(element) - 1;
        return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.tagIDs[0] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML;
    }
    //Element in scope
    hasInDynamicScope(tagName, htmlScope) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            switch(this.treeAdapter.getNamespaceURI(this.items[i])){
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML:
                    if (tn === tagName) return true;
                    if (htmlScope.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_SVG.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_MATHML.has(tn)) return false;
                    break;
            }
        }
        return true;
    }
    hasInScope(tagName) {
        return this.hasInDynamicScope(tagName, $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML);
    }
    hasInListItemScope(tagName) {
        return this.hasInDynamicScope(tagName, $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_LIST);
    }
    hasInButtonScope(tagName) {
        return this.hasInDynamicScope(tagName, $ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML_BUTTON);
    }
    hasNumberedHeaderInScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            switch(this.treeAdapter.getNamespaceURI(this.items[i])){
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML:
                    if ((0, $c2855a9ccb69df69$export$1ecc20fa0754c045).has(tn)) return true;
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_HTML.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_SVG.has(tn)) return false;
                    break;
                case (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML:
                    if ($ebf2c18607f34e1d$var$SCOPING_ELEMENTS_MATHML.has(tn)) return false;
                    break;
            }
        }
        return true;
    }
    hasInTableScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case tagName:
                    return true;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
                    return false;
            }
        }
        return true;
    }
    hasTableBodyContextInTableScope() {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
                    return true;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
                    return false;
            }
        }
        return true;
    }
    hasInSelectScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) continue;
            switch(this.tagIDs[i]){
                case tagName:
                    return true;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
                    break;
                default:
                    return false;
            }
        }
        return true;
    }
    //Implied end tags
    generateImpliedEndTags() {
        while(this.currentTagId !== undefined && $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsThoroughly() {
        while(this.currentTagId !== undefined && $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsWithExclusion(exclusionId) {
        while(this.currentTagId !== undefined && this.currentTagId !== exclusionId && $ebf2c18607f34e1d$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
    constructor(document, treeAdapter, handler){
        this.treeAdapter = treeAdapter;
        this.handler = handler;
        this.items = [];
        this.tagIDs = [];
        this.stackTop = -1;
        this.tmplCount = 0;
        this.currentTagId = (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN;
        this.current = document;
    }
}


//Const
const $e595487314683422$var$NOAH_ARK_CAPACITY = 3;
var $e595487314683422$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Marker"] = 0] = "Marker";
    EntryType[EntryType["Element"] = 1] = "Element";
})($e595487314683422$export$e41c32906b33062a || ($e595487314683422$export$e41c32906b33062a = {}));
const $e595487314683422$var$MARKER = {
    type: $e595487314683422$export$e41c32906b33062a.Marker
};
class $e595487314683422$export$20023318d9d5bbce {
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for(let i = 0; i < this.entries.length; i++){
            const entry = this.entries[i];
            if (entry.type === $e595487314683422$export$e41c32906b33062a.Marker) break;
            const { element: element } = entry;
            if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
                const elementAttrs = this.treeAdapter.getAttrList(element);
                if (elementAttrs.length === neAttrsLength) candidates.push({
                    idx: i,
                    attrs: elementAttrs
                });
            }
        }
        return candidates;
    }
    _ensureNoahArkCondition(newElement) {
        if (this.entries.length < $e595487314683422$var$NOAH_ARK_CAPACITY) return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < $e595487314683422$var$NOAH_ARK_CAPACITY) return;
        //NOTE: build attrs map for the new element, so we can perform fast lookups
        const neAttrsMap = new Map(neAttrs.map((neAttr)=>[
                neAttr.name,
                neAttr.value
            ]));
        let validCandidates = 0;
        //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met
        for(let i = 0; i < candidates.length; i++){
            const candidate = candidates[i];
            // We know that `candidate.attrs.length === neAttrs.length`
            if (candidate.attrs.every((cAttr)=>neAttrsMap.get(cAttr.name) === cAttr.value)) {
                validCandidates += 1;
                if (validCandidates >= $e595487314683422$var$NOAH_ARK_CAPACITY) this.entries.splice(candidate.idx, 1);
            }
        }
    }
    //Mutations
    insertMarker() {
        this.entries.unshift($e595487314683422$var$MARKER);
    }
    pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
            type: $e595487314683422$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    insertElementAfterBookmark(element, token) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
            type: $e595487314683422$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex !== -1) this.entries.splice(entryIndex, 1);
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */ clearToLastMarker() {
        const markerIdx = this.entries.indexOf($e595487314683422$var$MARKER);
        if (markerIdx === -1) this.entries.length = 0;
        else this.entries.splice(0, markerIdx + 1);
    }
    //Search
    getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry)=>entry.type === $e595487314683422$export$e41c32906b33062a.Marker || this.treeAdapter.getTagName(entry.element) === tagName);
        return entry && entry.type === $e595487314683422$export$e41c32906b33062a.Element ? entry : null;
    }
    getElementEntry(element) {
        return this.entries.find((entry)=>entry.type === $e595487314683422$export$e41c32906b33062a.Element && entry.element === element);
    }
    constructor(treeAdapter){
        this.treeAdapter = treeAdapter;
        this.entries = [];
        this.bookmark = null;
    }
}




const $01acbc1e35b87488$export$7ddbba828dfa4796 = {
    //Node construction
    createDocument () {
        return {
            nodeName: '#document',
            mode: (0, $c2855a9ccb69df69$export$a74d46c85337d29a).NO_QUIRKS,
            childNodes: []
        };
    },
    createDocumentFragment () {
        return {
            nodeName: '#document-fragment',
            childNodes: []
        };
    },
    createElement (tagName, namespaceURI, attrs) {
        return {
            nodeName: tagName,
            tagName: tagName,
            attrs: attrs,
            namespaceURI: namespaceURI,
            childNodes: [],
            parentNode: null
        };
    },
    createCommentNode (data) {
        return {
            nodeName: '#comment',
            data: data,
            parentNode: null
        };
    },
    createTextNode (value) {
        return {
            nodeName: '#text',
            value: value,
            parentNode: null
        };
    },
    //Tree mutation
    appendChild (parentNode, newNode) {
        parentNode.childNodes.push(newNode);
        newNode.parentNode = parentNode;
    },
    insertBefore (parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
        parentNode.childNodes.splice(insertionIdx, 0, newNode);
        newNode.parentNode = parentNode;
    },
    setTemplateContent (templateElement, contentElement) {
        templateElement.content = contentElement;
    },
    getTemplateContent (templateElement) {
        return templateElement.content;
    },
    setDocumentType (document, name, publicId, systemId) {
        const doctypeNode = document.childNodes.find((node)=>node.nodeName === '#documentType');
        if (doctypeNode) {
            doctypeNode.name = name;
            doctypeNode.publicId = publicId;
            doctypeNode.systemId = systemId;
        } else {
            const node = {
                nodeName: '#documentType',
                name: name,
                publicId: publicId,
                systemId: systemId,
                parentNode: null
            };
            $01acbc1e35b87488$export$7ddbba828dfa4796.appendChild(document, node);
        }
    },
    setDocumentMode (document, mode) {
        document.mode = mode;
    },
    getDocumentMode (document) {
        return document.mode;
    },
    detachNode (node) {
        if (node.parentNode) {
            const idx = node.parentNode.childNodes.indexOf(node);
            node.parentNode.childNodes.splice(idx, 1);
            node.parentNode = null;
        }
    },
    insertText (parentNode, text) {
        if (parentNode.childNodes.length > 0) {
            const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
            if ($01acbc1e35b87488$export$7ddbba828dfa4796.isTextNode(prevNode)) {
                prevNode.value += text;
                return;
            }
        }
        $01acbc1e35b87488$export$7ddbba828dfa4796.appendChild(parentNode, $01acbc1e35b87488$export$7ddbba828dfa4796.createTextNode(text));
    },
    insertTextBefore (parentNode, text, referenceNode) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
        if (prevNode && $01acbc1e35b87488$export$7ddbba828dfa4796.isTextNode(prevNode)) prevNode.value += text;
        else $01acbc1e35b87488$export$7ddbba828dfa4796.insertBefore(parentNode, $01acbc1e35b87488$export$7ddbba828dfa4796.createTextNode(text), referenceNode);
    },
    adoptAttributes (recipient, attrs) {
        const recipientAttrsMap = new Set(recipient.attrs.map((attr)=>attr.name));
        for(let j = 0; j < attrs.length; j++)if (!recipientAttrsMap.has(attrs[j].name)) recipient.attrs.push(attrs[j]);
    },
    //Tree traversing
    getFirstChild (node) {
        return node.childNodes[0];
    },
    getChildNodes (node) {
        return node.childNodes;
    },
    getParentNode (node) {
        return node.parentNode;
    },
    getAttrList (element) {
        return element.attrs;
    },
    //Node data
    getTagName (element) {
        return element.tagName;
    },
    getNamespaceURI (element) {
        return element.namespaceURI;
    },
    getTextNodeContent (textNode) {
        return textNode.value;
    },
    getCommentNodeContent (commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName (doctypeNode) {
        return doctypeNode.name;
    },
    getDocumentTypeNodePublicId (doctypeNode) {
        return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId (doctypeNode) {
        return doctypeNode.systemId;
    },
    //Node types
    isTextNode (node) {
        return node.nodeName === '#text';
    },
    isCommentNode (node) {
        return node.nodeName === '#comment';
    },
    isDocumentTypeNode (node) {
        return node.nodeName === '#documentType';
    },
    isElementNode (node) {
        return Object.prototype.hasOwnProperty.call(node, 'tagName');
    },
    // Source code location
    setNodeSourceCodeLocation (node, location) {
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation (node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation (node, endLocation) {
        node.sourceCodeLocation = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, node.sourceCodeLocation, endLocation);
    }
};



//Const
const $32b34f4d04b90291$var$VALID_DOCTYPE_NAME = 'html';
const $32b34f4d04b90291$var$VALID_SYSTEM_ID = 'about:legacy-compat';
const $32b34f4d04b90291$var$QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
const $32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//'
];
const $32b34f4d04b90291$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
const $32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_IDS = new Set([
    '-//w3o//dtd w3 html strict 3.0//en//',
    '-/w3c/dtd html 4.0 transitional/en',
    'html'
]);
const $32b34f4d04b90291$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
    '-//w3c//dtd xhtml 1.0 frameset//',
    '-//w3c//dtd xhtml 1.0 transitional//'
];
const $32b34f4d04b90291$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$32b34f4d04b90291$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
//Utils
function $32b34f4d04b90291$var$hasPrefix(publicId, prefixes) {
    return prefixes.some((prefix)=>publicId.startsWith(prefix));
}
function $32b34f4d04b90291$export$ee48152ecc0e3f40(token) {
    return token.name === $32b34f4d04b90291$var$VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === $32b34f4d04b90291$var$VALID_SYSTEM_ID);
}
function $32b34f4d04b90291$export$64782beacef87b30(token) {
    if (token.name !== $32b34f4d04b90291$var$VALID_DOCTYPE_NAME) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
    const { systemId: systemId } = token;
    if (systemId && systemId.toLowerCase() === $32b34f4d04b90291$var$QUIRKS_MODE_SYSTEM_ID) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
    let { publicId: publicId } = token;
    if (publicId !== null) {
        publicId = publicId.toLowerCase();
        if ($32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_IDS.has(publicId)) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
        let prefixes = systemId === null ? $32b34f4d04b90291$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : $32b34f4d04b90291$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES;
        if ($32b34f4d04b90291$var$hasPrefix(publicId, prefixes)) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS;
        prefixes = systemId === null ? $32b34f4d04b90291$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : $32b34f4d04b90291$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
        if ($32b34f4d04b90291$var$hasPrefix(publicId, prefixes)) return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).LIMITED_QUIRKS;
    }
    return (0, $c2855a9ccb69df69$export$a74d46c85337d29a).NO_QUIRKS;
}



//MIME types
const $488c212c7b5d6f42$var$MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};
//Attributes
const $488c212c7b5d6f42$var$DEFINITION_URL_ATTR = 'definitionurl';
const $488c212c7b5d6f42$var$ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const $488c212c7b5d6f42$var$SVG_ATTRS_ADJUSTMENT_MAP = new Map([
    'attributeName',
    'attributeType',
    'baseFrequency',
    'baseProfile',
    'calcMode',
    'clipPathUnits',
    'diffuseConstant',
    'edgeMode',
    'filterUnits',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'kernelMatrix',
    'kernelUnitLength',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'limitingConeAngle',
    'markerHeight',
    'markerUnits',
    'markerWidth',
    'maskContentUnits',
    'maskUnits',
    'numOctaves',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'refX',
    'refY',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'specularConstant',
    'specularExponent',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stitchTiles',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textLength',
    'viewBox',
    'viewTarget',
    'xChannelSelector',
    'yChannelSelector',
    'zoomAndPan'
].map((attr)=>[
        attr.toLowerCase(),
        attr
    ]));
const $488c212c7b5d6f42$var$XML_ATTRS_ADJUSTMENT_MAP = new Map([
    [
        'xlink:actuate',
        {
            prefix: 'xlink',
            name: 'actuate',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:arcrole',
        {
            prefix: 'xlink',
            name: 'arcrole',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:href',
        {
            prefix: 'xlink',
            name: 'href',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:role',
        {
            prefix: 'xlink',
            name: 'role',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:show',
        {
            prefix: 'xlink',
            name: 'show',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:title',
        {
            prefix: 'xlink',
            name: 'title',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:type',
        {
            prefix: 'xlink',
            name: 'type',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xml:lang',
        {
            prefix: 'xml',
            name: 'lang',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XML
        }
    ],
    [
        'xml:space',
        {
            prefix: 'xml',
            name: 'space',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XML
        }
    ],
    [
        'xmlns',
        {
            prefix: '',
            name: 'xmlns',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XMLNS
        }
    ],
    [
        'xmlns:xlink',
        {
            prefix: 'xmlns',
            name: 'xlink',
            namespace: (0, $c2855a9ccb69df69$export$fb4028874a74450).XMLNS
        }
    ]
]);
const $488c212c7b5d6f42$export$86512877756eb1b1 = new Map([
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'textPath'
].map((tn)=>[
        tn.toLowerCase(),
        tn
    ]));
//Tags that causes exit from foreign content
const $488c212c7b5d6f42$var$EXITS_FOREIGN_CONTENT = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).B,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BIG,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BLOCKQUOTE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CENTER,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CODE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EM,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EMBED,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H1,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H2,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H3,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H4,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H5,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H6,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).I,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMG,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LISTING,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MENU,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PRE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RUBY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).S,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SMALL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SPAN,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRONG,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRIKE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUB,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).U,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).VAR
]);
function $488c212c7b5d6f42$export$3435eb4ab4d2ed2d(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FONT && startTagToken.attrs.some(({ name: name })=>name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).COLOR || name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).SIZE || name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).FACE);
    return isFontWithAttrs || $488c212c7b5d6f42$var$EXITS_FOREIGN_CONTENT.has(tn);
}
function $488c212c7b5d6f42$export$c583cc5a9d633feb(token) {
    for(let i = 0; i < token.attrs.length; i++)if (token.attrs[i].name === $488c212c7b5d6f42$var$DEFINITION_URL_ATTR) {
        token.attrs[i].name = $488c212c7b5d6f42$var$ADJUSTED_DEFINITION_URL_ATTR;
        break;
    }
}
function $488c212c7b5d6f42$export$74ce06f755fb8f68(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrName = $488c212c7b5d6f42$var$SVG_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrName != null) token.attrs[i].name = adjustedAttrName;
    }
}
function $488c212c7b5d6f42$export$a5192af02995cbdc(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrEntry = $488c212c7b5d6f42$var$XML_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
}
function $488c212c7b5d6f42$export$95df78fe2e7f33e3(token) {
    const adjustedTagName = $488c212c7b5d6f42$export$86512877756eb1b1.get(token.tagName);
    if (adjustedTagName != null) {
        token.tagName = adjustedTagName;
        token.tagID = (0, $c2855a9ccb69df69$export$39db8a1315f68282)(token.tagName);
    }
}
//Integration points
function $488c212c7b5d6f42$var$isMathMLTextIntegrationPoint(tn, ns) {
    return ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML && (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MI || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MO || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MN || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MS || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MTEXT);
}
function $488c212c7b5d6f42$var$isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML && tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ANNOTATION_XML) {
        for(let i = 0; i < attrs.length; i++)if (attrs[i].name === (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).ENCODING) {
            const value = attrs[i].value.toLowerCase();
            return value === $488c212c7b5d6f42$var$MIME_TYPES.TEXT_HTML || value === $488c212c7b5d6f42$var$MIME_TYPES.APPLICATION_XML;
        }
    }
    return ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG && (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOREIGN_OBJECT || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DESC || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE);
}
function $488c212c7b5d6f42$export$6baf3ebfdd620e1(tn, ns, attrs, foreignNS) {
    return (!foreignNS || foreignNS === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) && $488c212c7b5d6f42$var$isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML) && $488c212c7b5d6f42$var$isMathMLTextIntegrationPoint(tn, ns);
}






//Misc constants
const $2f5582982d8cf3f4$var$HIDDEN_INPUT_TYPE = 'hidden';
//Adoption agency loops iteration count
const $2f5582982d8cf3f4$var$AA_OUTER_LOOP_ITER = 8;
const $2f5582982d8cf3f4$var$AA_INNER_LOOP_ITER = 3;
//Insertion modes
var $2f5582982d8cf3f4$var$InsertionMode;
(function(InsertionMode) {
    InsertionMode[InsertionMode["INITIAL"] = 0] = "INITIAL";
    InsertionMode[InsertionMode["BEFORE_HTML"] = 1] = "BEFORE_HTML";
    InsertionMode[InsertionMode["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
    InsertionMode[InsertionMode["IN_HEAD"] = 3] = "IN_HEAD";
    InsertionMode[InsertionMode["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
    InsertionMode[InsertionMode["AFTER_HEAD"] = 5] = "AFTER_HEAD";
    InsertionMode[InsertionMode["IN_BODY"] = 6] = "IN_BODY";
    InsertionMode[InsertionMode["TEXT"] = 7] = "TEXT";
    InsertionMode[InsertionMode["IN_TABLE"] = 8] = "IN_TABLE";
    InsertionMode[InsertionMode["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
    InsertionMode[InsertionMode["IN_CAPTION"] = 10] = "IN_CAPTION";
    InsertionMode[InsertionMode["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
    InsertionMode[InsertionMode["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
    InsertionMode[InsertionMode["IN_ROW"] = 13] = "IN_ROW";
    InsertionMode[InsertionMode["IN_CELL"] = 14] = "IN_CELL";
    InsertionMode[InsertionMode["IN_SELECT"] = 15] = "IN_SELECT";
    InsertionMode[InsertionMode["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
    InsertionMode[InsertionMode["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
    InsertionMode[InsertionMode["AFTER_BODY"] = 18] = "AFTER_BODY";
    InsertionMode[InsertionMode["IN_FRAMESET"] = 19] = "IN_FRAMESET";
    InsertionMode[InsertionMode["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
    InsertionMode[InsertionMode["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
    InsertionMode[InsertionMode["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})($2f5582982d8cf3f4$var$InsertionMode || ($2f5582982d8cf3f4$var$InsertionMode = {}));
const $2f5582982d8cf3f4$var$BASE_LOC = {
    startLine: -1,
    startCol: -1,
    startOffset: -1,
    endLine: -1,
    endCol: -1,
    endOffset: -1
};
const $2f5582982d8cf3f4$var$TABLE_STRUCTURE_TAGS = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR
]);
const $2f5582982d8cf3f4$var$defaultParserOptions = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    treeAdapter: (0, $01acbc1e35b87488$export$7ddbba828dfa4796),
    onParseError: null
};
class $2f5582982d8cf3f4$export$7acfa6ed01010e37 {
    // API
    static parse(html, options) {
        const parser = new this(options);
        parser.tokenizer.write(html, true);
        return parser.document;
    }
    static getFragmentParser(fragmentContext, options) {
        const opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $2f5582982d8cf3f4$var$defaultParserOptions, options);
        //NOTE: use a <template> element as the fragment context if no context element was provided,
        //so we will parse in a "forgiving" manner
        fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).TEMPLATE, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        //NOTE: create a fake element which will be used as the `document` for fragment parsing.
        //This is important for jsdom, where a new `document` cannot be created. This led to
        //fragment parsing messing with the main `document`.
        const documentMock = opts.treeAdapter.createElement('documentmock', (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        const parser = new this(opts, documentMock, fragmentContext);
        if (parser.fragmentContextID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) parser.tmplInsertionModeStack.unshift($2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE);
        parser._initTokenizerForFragmentParsing();
        parser._insertFakeRootElement();
        parser._resetInsertionMode();
        parser._findFormInFragmentContext();
        return parser;
    }
    getFragment() {
        const rootElement = this.treeAdapter.getFirstChild(this.document);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
    }
    //Errors
    /** @internal */ _err(token, code, beforeToken) {
        var _a;
        if (!this.onParseError) return;
        const loc = (_a = token.location) !== null && _a !== void 0 ? _a : $2f5582982d8cf3f4$var$BASE_LOC;
        const err = {
            code: code,
            startLine: loc.startLine,
            startCol: loc.startCol,
            startOffset: loc.startOffset,
            endLine: beforeToken ? loc.startLine : loc.endLine,
            endCol: beforeToken ? loc.startCol : loc.endCol,
            endOffset: beforeToken ? loc.startOffset : loc.endOffset
        };
        this.onParseError(err);
    }
    //Stack events
    /** @internal */ onItemPush(node, tid, isTop) {
        var _a, _b;
        (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 || _b.call(_a, node);
        if (isTop && this.openElements.stackTop > 0) this._setContextModes(node, tid);
    }
    /** @internal */ onItemPop(node, isTop) {
        var _a, _b;
        if (this.options.sourceCodeLocationInfo) this._setEndLocation(node, this.currentToken);
        (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 || _b.call(_a, node, this.openElements.current);
        if (isTop) {
            let current;
            let currentTagId;
            if (this.openElements.stackTop === 0 && this.fragmentContext) {
                current = this.fragmentContext;
                currentTagId = this.fragmentContextID;
            } else ({ current: current, currentTagId: currentTagId } = this.openElements);
            this._setContextModes(current, currentTagId);
        }
    }
    _setContextModes(current, tid) {
        const isHTML = current === this.document || current && this.treeAdapter.getNamespaceURI(current) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML;
        this.currentNotInHTML = !isHTML;
        this.tokenizer.inForeignNode = !isHTML && current !== undefined && tid !== undefined && !this._isIntegrationPoint(tid, current);
    }
    /** @protected */ _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.TEXT;
    }
    switchToPlaintextParsing() {
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.TEXT;
        this.originalInsertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
        this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT;
    }
    //Fragment parsing
    /** @protected */ _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    /** @protected */ _findFormInFragmentContext() {
        let node = this.fragmentContext;
        while(node){
            if (this.treeAdapter.getTagName(node) === (0, $c2855a9ccb69df69$export$7e674a85a2656dce).FORM) {
                this.formElement = node;
                break;
            }
            node = this.treeAdapter.getParentNode(node);
        }
    }
    _initTokenizerForFragmentParsing() {
        if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) return;
        switch(this.fragmentContextID){
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEXTAREA:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA;
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).XMP:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IFRAME:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOEMBED:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT;
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).SCRIPT_DATA;
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PLAINTEXT:
                this.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT;
                break;
            default:
        }
    }
    //Tree mutation
    /** @protected */ _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
        if (token.location) {
            const documentChildren = this.treeAdapter.getChildNodes(this.document);
            const docTypeNode = documentChildren.find((node)=>this.treeAdapter.isDocumentTypeNode(node));
            if (docTypeNode) this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token.location);
        }
    }
    /** @protected */ _attachElementToTree(element, location) {
        if (this.options.sourceCodeLocationInfo) {
            const loc = location && (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, location), {
                startTag: location
            });
            this.treeAdapter.setNodeSourceCodeLocation(element, loc);
        }
        if (this._shouldFosterParentOnInsertion()) this._fosterParentElement(element);
        else {
            const parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.appendChild(parent !== null && parent !== void 0 ? parent : this.document, element);
        }
    }
    /**
     * For self-closing tags. Add an element to the tree, but skip adding it
     * to the stack.
     */ /** @protected */ _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
    }
    /** @protected */ _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
        this.openElements.push(element, token.tagID);
    }
    /** @protected */ _insertFakeElement(tagName, tagID) {
        const element = this.treeAdapter.createElement(tagName, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        this._attachElementToTree(element, null);
        this.openElements.push(element, tagID);
    }
    /** @protected */ _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl, token.location);
        this.openElements.push(tmpl, token.tagID);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
    /** @protected */ _insertFakeRootElement() {
        const element = this.treeAdapter.createElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).HTML, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML, []);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(element, null);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML);
    }
    /** @protected */ _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
    }
    /** @protected */ _insertCharacters(token) {
        let parent;
        let beforeElement;
        if (this._shouldFosterParentOnInsertion()) {
            ({ parent: parent, beforeElement: beforeElement } = this._findFosterParentingLocation());
            if (beforeElement) this.treeAdapter.insertTextBefore(parent, token.chars, beforeElement);
            else this.treeAdapter.insertText(parent, token.chars);
        } else {
            parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.insertText(parent, token.chars);
        }
        if (!token.location) return;
        const siblings = this.treeAdapter.getChildNodes(parent);
        const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
        const textNode = siblings[textNodeIdx - 1];
        //NOTE: if we have a location assigned by another token, then just update the end position
        const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
        if (tnLoc) {
            const { endLine: endLine, endCol: endCol, endOffset: endOffset } = token.location;
            this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
                endLine: endLine,
                endCol: endCol,
                endOffset: endOffset
            });
        } else if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
    }
    /** @protected */ _adoptNodes(donor, recipient) {
        for(let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)){
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }
    /** @protected */ _setEndLocation(element, closingToken) {
        if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
            const ctLoc = closingToken.location;
            const tn = this.treeAdapter.getTagName(element);
            const endLoc = // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            closingToken.type === (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG && tn === closingToken.tagName ? {
                endTag: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctLoc),
                endLine: ctLoc.endLine,
                endCol: ctLoc.endCol,
                endOffset: ctLoc.endOffset
            } : {
                endLine: ctLoc.startLine,
                endCol: ctLoc.startCol,
                endOffset: ctLoc.startOffset
            };
            this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
        }
    }
    //Token processing
    shouldProcessStartTagTokenInForeignContent(token) {
        // Check that neither current === document, or ns === NS.HTML
        if (!this.currentNotInHTML) return false;
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
            current = this.fragmentContext;
            currentTagId = this.fragmentContextID;
        } else ({ current: current, currentTagId: currentTagId } = this.openElements);
        if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SVG && this.treeAdapter.getTagName(current) === (0, $c2855a9ccb69df69$export$7e674a85a2656dce).ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML) return false;
        return(// Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MGLYPH || token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MALIGNMARK) && currentTagId !== undefined && !this._isIntegrationPoint(currentTagId, current, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML));
    }
    /** @protected */ _processToken(token) {
        switch(token.type){
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
                this.onCharacter(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).NULL_CHARACTER:
                this.onNullCharacter(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).COMMENT:
                this.onComment(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).DOCTYPE:
                this.onDoctype(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG:
                this._processStartTag(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG:
                this.onEndTag(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF:
                this.onEof(token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                this.onWhitespaceCharacter(token);
                break;
        }
    }
    //Integration points
    /** @protected */ _isIntegrationPoint(tid, element, foreignNS) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return $488c212c7b5d6f42$export$6baf3ebfdd620e1(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    /** @protected */ _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.entries.length;
        if (listLength) {
            const endIndex = this.activeFormattingElements.entries.findIndex((entry)=>entry.type === (0, $e595487314683422$export$e41c32906b33062a).Marker || this.openElements.contains(entry.element));
            const unopenIdx = endIndex === -1 ? listLength - 1 : endIndex - 1;
            for(let i = unopenIdx; i >= 0; i--){
                const entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }
    //Close elements
    /** @protected */ _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
    }
    /** @protected */ _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P);
        this.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P);
    }
    //Insertion modes
    /** @protected */ _resetInsertionMode() {
        for(let i = this.openElements.stackTop; i >= 0; i--)//Insertion mode reset map
        switch(i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]){
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
                this._resetInsertionModeForSelect(i);
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
                this.insertionMode = this.tmplInsertionModeStack[0];
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
                this.insertionMode = this.headElement ? $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD : $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD;
                return;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
                if (i > 0) {
                    this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CELL;
                    return;
                }
                break;
            case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
                if (i > 0) {
                    this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
                    return;
                }
                break;
        }
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    }
    /** @protected */ _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) for(let i = selectIdx - 1; i > 0; i--){
            const tn = this.openElements.tagIDs[i];
            if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) break;
            else if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE) {
                this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE;
                return;
            }
        }
        this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT;
    }
    //Foster parenting
    /** @protected */ _isElementCausesFosterParenting(tn) {
        return $2f5582982d8cf3f4$var$TABLE_STRUCTURE_TAGS.has(tn);
    }
    /** @protected */ _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this.openElements.currentTagId !== undefined && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
    /** @protected */ _findFosterParentingLocation() {
        for(let i = this.openElements.stackTop; i >= 0; i--){
            const openElement = this.openElements.items[i];
            switch(this.openElements.tagIDs[i]){
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
                    if (this.treeAdapter.getNamespaceURI(openElement) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) return {
                        parent: this.treeAdapter.getTemplateContent(openElement),
                        beforeElement: null
                    };
                    break;
                case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
                    {
                        const parent = this.treeAdapter.getParentNode(openElement);
                        if (parent) return {
                            parent: parent,
                            beforeElement: openElement
                        };
                        return {
                            parent: this.openElements.items[i - 1],
                            beforeElement: null
                        };
                    }
                default:
            }
        }
        return {
            parent: this.openElements.items[0],
            beforeElement: null
        };
    }
    /** @protected */ _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        else this.treeAdapter.appendChild(location.parent, element);
    }
    //Special elements
    /** @protected */ _isSpecialElement(element, id) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        return (0, $c2855a9ccb69df69$export$7e5172336f7d2bbb)[ns].has(id);
    }
    /** @internal */ onCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $2f5582982d8cf3f4$var$characterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$tokenBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$tokenBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$tokenInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$tokenInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$tokenAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$characterInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                this._insertCharacters(token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$characterInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$characterInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$tokenInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onNullCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $2f5582982d8cf3f4$var$nullCharacterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$tokenBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$tokenBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$tokenInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$tokenInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$tokenAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
                this._insertCharacters(token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$characterInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$tokenInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onComment(token) {
        this.skipNextNewLine = false;
        if (this.currentNotInHTML) {
            $2f5582982d8cf3f4$var$appendComment(this, token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$appendComment(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$appendCommentToRootHtmlElement(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$appendCommentToDocument(this, token);
                break;
            default:
        }
    }
    /** @internal */ onDoctype(token) {
        this.skipNextNewLine = false;
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$doctypeInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                this._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).misplacedDoctype);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            default:
        }
    }
    /** @internal */ onStartTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        this._processStartTag(token);
        if (token.selfClosing && !token.ackSelfClosing) this._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     * @protected
     */ _processStartTag(token) {
        if (this.shouldProcessStartTagTokenInForeignContent(token)) $2f5582982d8cf3f4$var$startTagInForeignContent(this, token);
        else this._startTagOutsideForeignContent(token);
    }
    /** @protected */ _startTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$startTagBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$startTagBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$startTagInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$startTagInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$startTagAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
                $2f5582982d8cf3f4$var$startTagInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
                $2f5582982d8cf3f4$var$startTagInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
                $2f5582982d8cf3f4$var$startTagInCaption(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$startTagInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
                $2f5582982d8cf3f4$var$startTagInTableBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$startTagInRow(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
                $2f5582982d8cf3f4$var$startTagInCell(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
                $2f5582982d8cf3f4$var$startTagInSelect(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $2f5582982d8cf3f4$var$startTagInSelectInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$startTagInTemplate(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$startTagAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
                $2f5582982d8cf3f4$var$startTagInFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$startTagAfterFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$startTagAfterAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$startTagAfterAfterFrameset(this, token);
                break;
            default:
        }
    }
    /** @internal */ onEndTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        if (this.currentNotInHTML) $2f5582982d8cf3f4$var$endTagInForeignContent(this, token);
        else this._endTagOutsideForeignContent(token);
    }
    /** @protected */ _endTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$endTagBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$endTagBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$endTagInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$endTagInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$endTagAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
                $2f5582982d8cf3f4$var$endTagInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
                $2f5582982d8cf3f4$var$endTagInText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
                $2f5582982d8cf3f4$var$endTagInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
                $2f5582982d8cf3f4$var$endTagInCaption(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
                $2f5582982d8cf3f4$var$endTagInColumnGroup(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
                $2f5582982d8cf3f4$var$endTagInTableBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$endTagInRow(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
                $2f5582982d8cf3f4$var$endTagInCell(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
                $2f5582982d8cf3f4$var$endTagInSelect(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $2f5582982d8cf3f4$var$endTagInSelectInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$endTagInTemplate(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
                $2f5582982d8cf3f4$var$endTagAfterBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
                $2f5582982d8cf3f4$var$endTagInFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$endTagAfterFrameset(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
                $2f5582982d8cf3f4$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    /** @internal */ onEof(token) {
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.INITIAL:
                $2f5582982d8cf3f4$var$tokenInInitialMode(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML:
                $2f5582982d8cf3f4$var$tokenBeforeHtml(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD:
                $2f5582982d8cf3f4$var$tokenBeforeHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
                $2f5582982d8cf3f4$var$tokenInHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $2f5582982d8cf3f4$var$tokenInHeadNoScript(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
                $2f5582982d8cf3f4$var$tokenAfterHead(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
                $2f5582982d8cf3f4$var$eofInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
                $2f5582982d8cf3f4$var$eofInText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$tokenInTableText(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
                $2f5582982d8cf3f4$var$eofInTemplate(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$stopParsing(this, token);
                break;
            default:
        }
    }
    /** @internal */ onWhitespaceCharacter(token) {
        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;
            if (token.chars.charCodeAt(0) === $bb1347fda1174ed8$export$e3f6c2feb5c0ecc0.LINE_FEED) {
                if (token.chars.length === 1) return;
                token.chars = token.chars.substr(1);
            }
        }
        if (this.tokenizer.inForeignNode) {
            this._insertCharacters(token);
            return;
        }
        switch(this.insertionMode){
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD:
            case $2f5582982d8cf3f4$var$InsertionMode.TEXT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET:
                this._insertCharacters(token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_CELL:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $2f5582982d8cf3f4$var$whitespaceCharacterInBody(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY:
            case $2f5582982d8cf3f4$var$InsertionMode.IN_ROW:
                $2f5582982d8cf3f4$var$characterInTable(this, token);
                break;
            case $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT:
                $2f5582982d8cf3f4$var$whitespaceCharacterInTableText(this, token);
                break;
            default:
        }
    }
    constructor(options, document, /** @internal */ fragmentContext = null, /** @internal */ scriptHandler = null){
        this.fragmentContext = fragmentContext;
        this.scriptHandler = scriptHandler;
        this.currentToken = null;
        this.stopped = false;
        /** @internal */ this.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.INITIAL;
        /** @internal */ this.originalInsertionMode = $2f5582982d8cf3f4$var$InsertionMode.INITIAL;
        /** @internal */ this.headElement = null;
        /** @internal */ this.formElement = null;
        /** Indicates that the current node is not an element in the HTML namespace */ this.currentNotInHTML = false;
        /**
         * The template insertion mode stack is maintained from the left.
         * Ie. the topmost element will always have index 0.
         *
         * @internal
         */ this.tmplInsertionModeStack = [];
        /** @internal */ this.pendingCharacterTokens = [];
        /** @internal */ this.hasNonWhitespacePendingCharacterToken = false;
        /** @internal */ this.framesetOk = true;
        /** @internal */ this.skipNextNewLine = false;
        /** @internal */ this.fosterParentingEnabled = false;
        this.options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $2f5582982d8cf3f4$var$defaultParserOptions, options);
        this.treeAdapter = this.options.treeAdapter;
        this.onParseError = this.options.onParseError;
        // Always enable location info if we report parse errors.
        if (this.onParseError) this.options.sourceCodeLocationInfo = true;
        this.document = document !== null && document !== void 0 ? document : this.treeAdapter.createDocument();
        this.tokenizer = new (0, $c44790542489a2a8$export$55e8b082af4aa63e)(this.options, this);
        this.activeFormattingElements = new (0, $e595487314683422$export$20023318d9d5bbce)(this.treeAdapter);
        this.fragmentContextID = fragmentContext ? (0, $c2855a9ccb69df69$export$39db8a1315f68282)(this.treeAdapter.getTagName(fragmentContext)) : (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN;
        this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
        this.openElements = new (0, $ebf2c18607f34e1d$export$56decf886ed987d6)(this.document, this.treeAdapter, this);
    }
}
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function $2f5582982d8cf3f4$var$aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagID)) formattingElementEntry = null;
    } else $2f5582982d8cf3f4$var$genericEndTagInBody(p, token);
    return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function $2f5582982d8cf3f4$var$aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    let idx = p.openElements.stackTop;
    for(; idx >= 0; idx--){
        const element = p.openElements.items[idx];
        if (element === formattingElementEntry.element) break;
        if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) furthestBlock = element;
    }
    if (!furthestBlock) {
        p.openElements.shortenToLength(Math.max(idx, 0));
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
}
//Step 13 of the algorithm
function $2f5582982d8cf3f4$var$aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for(let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement){
        //NOTE: store the next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);
        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= $2f5582982d8cf3f4$var$AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) p.activeFormattingElements.removeEntry(elementEntry);
            p.openElements.remove(element);
        } else {
            element = $2f5582982d8cf3f4$var$aaRecreateElementFromEntry(p, elementEntry);
            if (lastElement === furthestBlock) p.activeFormattingElements.bookmark = elementEntry;
            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }
    return lastElement;
}
//Step 13.7 of the algorithm
function $2f5582982d8cf3f4$var$aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
}
//Step 14 of the algorithm
function $2f5582982d8cf3f4$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    const tn = p.treeAdapter.getTagName(commonAncestor);
    const tid = (0, $c2855a9ccb69df69$export$39db8a1315f68282)(tn);
    if (p._isElementCausesFosterParenting(tid)) p._fosterParentElement(lastElement);
    else {
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
        if (tid === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE && ns === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}
//Steps 15-19 of the algorithm
function $2f5582982d8cf3f4$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const { token: token } = formattingElementEntry;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement, token.tagID);
}
//Algorithm entry point
function $2f5582982d8cf3f4$var$callAdoptionAgency(p, token) {
    for(let i = 0; i < $2f5582982d8cf3f4$var$AA_OUTER_LOOP_ITER; i++){
        const formattingElementEntry = $2f5582982d8cf3f4$var$aaObtainFormattingElementEntry(p, token);
        if (!formattingElementEntry) break;
        const furthestBlock = $2f5582982d8cf3f4$var$aaObtainFurthestBlock(p, formattingElementEntry);
        if (!furthestBlock) break;
        p.activeFormattingElements.bookmark = formattingElementEntry;
        const lastElement = $2f5582982d8cf3f4$var$aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
        p.treeAdapter.detachNode(lastElement);
        if (commonAncestor) $2f5582982d8cf3f4$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        $2f5582982d8cf3f4$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}
//Generic token handlers
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContentOrNode);
}
function $2f5582982d8cf3f4$var$appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}
function $2f5582982d8cf3f4$var$appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}
function $2f5582982d8cf3f4$var$stopParsing(p, token) {
    p.stopped = true;
    // NOTE: Set end locations for elements that remain on the open element stack.
    if (token.location) {
        // NOTE: If we are not in a fragment, `html` and `body` will stay on the stack.
        // This is a problem, as we might overwrite their end position here.
        const target = p.fragmentContext ? 0 : 2;
        for(let i = p.openElements.stackTop; i >= target; i--)p._setEndLocation(p.openElements.items[i], token);
        // Handle `html` and `body`
        if (!p.fragmentContext && p.openElements.stackTop >= 0) {
            const htmlElement = p.openElements.items[0];
            const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
            if (htmlLocation && !htmlLocation.endTag) {
                p._setEndLocation(htmlElement, token);
                if (p.openElements.stackTop >= 1) {
                    const bodyElement = p.openElements.items[1];
                    const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
                    if (bodyLocation && !bodyLocation.endTag) p._setEndLocation(bodyElement, token);
                }
            }
        }
    }
}
// The "initial" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS : $32b34f4d04b90291$export$64782beacef87b30(token);
    if (!$32b34f4d04b90291$export$ee48152ecc0e3f40(token)) p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nonConformingDoctype);
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML;
}
function $2f5582982d8cf3f4$var$tokenInInitialMode(p, token) {
    p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).missingDoctype, true);
    p.treeAdapter.setDocumentMode(p.document, (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HTML;
    p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagBeforeHtml(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) {
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD;
    } else $2f5582982d8cf3f4$var$tokenBeforeHtml(p, token);
}
function $2f5582982d8cf3f4$var$endTagBeforeHtml(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR) $2f5582982d8cf3f4$var$tokenBeforeHtml(p, token);
}
function $2f5582982d8cf3f4$var$tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.BEFORE_HEAD;
    p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagBeforeHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.headElement = p.openElements.current;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
            break;
        default:
            $2f5582982d8cf3f4$var$tokenBeforeHead(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagBeforeHead(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR) $2f5582982d8cf3f4$var$tokenBeforeHead(p, token);
    else p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $2f5582982d8cf3f4$var$tokenBeforeHead(p, token) {
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).HEAD, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
            else {
                p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD_NO_SCRIPT;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
            p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
            p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).SCRIPT_DATA);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            p._insertTemplate(token);
            p.activeFormattingElements.insertMarker();
            p.framesetOk = false;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE;
            p.tmplInsertionModeStack.unshift($2f5582982d8cf3f4$var$InsertionMode.IN_TEMPLATE);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInHead(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p.openElements.pop();
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$tokenInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $2f5582982d8cf3f4$var$templateEndTagInHead(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTagsThoroughly();
        if (p.openElements.currentTagId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).closingOfElementWithOpenChildElements);
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
    } else p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $2f5582982d8cf3f4$var$tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_HEAD;
    p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).nestedNoscriptInHead);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInHeadNoScript(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            p.openElements.pop();
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
            $2f5582982d8cf3f4$var$tokenInHeadNoScript(p, token);
            break;
        default:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $2f5582982d8cf3f4$var$tokenInHeadNoScript(p, token) {
    const errCode = token.type === (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF ? (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).openElementsLeftAfterEof : (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).disallowedContentInNoscriptInHead;
    p._err(token, errCode);
    p.openElements.pop();
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.framesetOk = false;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).abandonedHeadElementChild);
            p.openElements.push(p.headElement, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD);
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            p.openElements.remove(p.headElement);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenAfterHead(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
            $2f5582982d8cf3f4$var$tokenAfterHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $2f5582982d8cf3f4$var$tokenAfterHead(p, token) {
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).BODY, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    $2f5582982d8cf3f4$var$modeInBody(p, token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$modeInBody(p, token) {
    switch(token.type){
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
            $2f5582982d8cf3f4$var$characterInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
            $2f5582982d8cf3f4$var$whitespaceCharacterInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).COMMENT:
            $2f5582982d8cf3f4$var$appendComment(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).START_TAG:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).END_TAG:
            $2f5582982d8cf3f4$var$endTagInBody(p, token);
            break;
        case (0, $be390ad8d330a451$export$f435f793048e7a0f).EOF:
            $2f5582982d8cf3f4$var$eofInBody(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}
function $2f5582982d8cf3f4$var$characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}
function $2f5582982d8cf3f4$var$bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}
function $2f5582982d8cf3f4$var$framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_FRAMESET;
    }
}
function $2f5582982d8cf3f4$var$addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    if (p.openElements.currentTagId !== undefined && (0, $c2855a9ccb69df69$export$1ecc20fa0754c045).has(p.openElements.currentTagId)) p.openElements.pop();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        if (!inTemplate) p.formElement = p.openElements.current;
    }
}
function $2f5582982d8cf3f4$var$listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagID;
    for(let i = p.openElements.stackTop; i >= 0; i--){
        const elementId = p.openElements.tagIDs[i];
        if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI && elementId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI || (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT) && (elementId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD || elementId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT)) {
            p.openElements.generateImpliedEndTagsWithExclusion(elementId);
            p.openElements.popUntilTagNamePopped(elementId);
            break;
        }
        if (elementId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ADDRESS && elementId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV && elementId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P && p._isSpecialElement(p.openElements.items[i], elementId)) break;
    }
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT;
}
function $2f5582982d8cf3f4$var$buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName((0, $c2855a9ccb69df69$export$7e674a85a2656dce).A);
    if (activeElementEntry) {
        $2f5582982d8cf3f4$var$callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $2f5582982d8cf3f4$var$bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $2f5582982d8cf3f4$var$nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR)) {
        $2f5582982d8cf3f4$var$callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $2f5582982d8cf3f4$var$appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== (0, $c2855a9ccb69df69$export$a74d46c85337d29a).QUIRKS && p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
}
function $2f5582982d8cf3f4$var$areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$isHiddenInput(token) {
    const inputType = (0, $be390ad8d330a451$export$df33bba014b5841e)(token, (0, $c2855a9ccb69df69$export$380b7bc9e6cb1918).TYPE);
    return inputType != null && inputType.toLowerCase() === $2f5582982d8cf3f4$var$HIDDEN_INPUT_TYPE;
}
function $2f5582982d8cf3f4$var$inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    if (!$2f5582982d8cf3f4$var$isHiddenInput(token)) p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$paramStartTagInBody(p, token) {
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$imageStartTagInBody(p, token) {
    token.tagName = (0, $c2855a9ccb69df69$export$7e674a85a2656dce).IMG;
    token.tagID = (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMG;
    $2f5582982d8cf3f4$var$areaStartTagInBody(p, token);
}
function $2f5582982d8cf3f4$var$textareaStartTagInBody(p, token) {
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.TEXT;
}
function $2f5582982d8cf3f4$var$xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._closePElement();
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $2f5582982d8cf3f4$var$iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
}
//NOTE: here we assume that we always act as a user agent with enabled plugins/frames, so we parse
//<noembed>/<noframes> as rawtext.
function $2f5582982d8cf3f4$var$rawTextStartTagInBody(p, token) {
    p._switchToTextParsing(token, (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $2f5582982d8cf3f4$var$selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_ROW || p.insertionMode === $2f5582982d8cf3f4$var$InsertionMode.IN_CELL ? $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT_IN_TABLE : $2f5582982d8cf3f4$var$InsertionMode.IN_SELECT;
}
function $2f5582982d8cf3f4$var$optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTags();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTagsWithExclusion((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RTC);
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $488c212c7b5d6f42$export$c583cc5a9d633feb(token);
    $488c212c7b5d6f42$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML);
    else p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $488c212c7b5d6f42$export$74ce06f755fb8f68(token);
    $488c212c7b5d6f42$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG);
    else p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
}
function $2f5582982d8cf3f4$var$startTagInBody(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).I:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).S:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).B:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).U:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EM:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BIG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CODE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SMALL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRIKE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRONG:
            $2f5582982d8cf3f4$var$bStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).A:
            $2f5582982d8cf3f4$var$aStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H1:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H2:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H3:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H4:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H5:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H6:
            $2f5582982d8cf3f4$var$numberedHeaderStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NAV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MAIN:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MENU:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ASIDE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CENTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGURE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOOTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEADER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIALOG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DETAILS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ADDRESS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ARTICLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SEARCH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SECTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUMMARY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIELDSET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGCAPTION:
            $2f5582982d8cf3f4$var$addressStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT:
            $2f5582982d8cf3f4$var$listItemStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).WBR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).AREA:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EMBED:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).KEYGEN:
            $2f5582982d8cf3f4$var$areaStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HR:
            $2f5582982d8cf3f4$var$hrStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RB:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RTC:
            $2f5582982d8cf3f4$var$rbStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).RP:
            $2f5582982d8cf3f4$var$rtStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PRE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LISTING:
            $2f5582982d8cf3f4$var$preStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).XMP:
            $2f5582982d8cf3f4$var$xmpStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SVG:
            $2f5582982d8cf3f4$var$svgStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$htmlStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
            $2f5582982d8cf3f4$var$bodyStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM:
            $2f5582982d8cf3f4$var$formStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR:
            $2f5582982d8cf3f4$var$nobrStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MATH:
            $2f5582982d8cf3f4$var$mathStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            $2f5582982d8cf3f4$var$tableStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).INPUT:
            $2f5582982d8cf3f4$var$inputStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PARAM:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TRACK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SOURCE:
            $2f5582982d8cf3f4$var$paramStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IMAGE:
            $2f5582982d8cf3f4$var$imageStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON:
            $2f5582982d8cf3f4$var$buttonStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).APPLET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OBJECT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MARQUEE:
            $2f5582982d8cf3f4$var$appletStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).IFRAME:
            $2f5582982d8cf3f4$var$iframeStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
            $2f5582982d8cf3f4$var$selectStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
            $2f5582982d8cf3f4$var$optgroupStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOEMBED:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$rawTextStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
            $2f5582982d8cf3f4$var$framesetStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEXTAREA:
            $2f5582982d8cf3f4$var$textareaStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) $2f5582982d8cf3f4$var$rawTextStartTagInBody(p, token);
            else $2f5582982d8cf3f4$var$genericStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PLAINTEXT:
            $2f5582982d8cf3f4$var$plaintextStartTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAME:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
            break;
        default:
            $2f5582982d8cf3f4$var$genericStartTagInBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$bodyEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY;
        //NOTE: <body> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo) {
            const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
            if (bodyElement) p._setEndLocation(bodyElement, token);
        }
    }
}
function $2f5582982d8cf3f4$var$htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_BODY;
        $2f5582982d8cf3f4$var$endTagAfterBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$addressEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $2f5582982d8cf3f4$var$formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const { formElement: formElement } = p;
    if (!inTemplate) p.formElement = null;
    if ((formElement || inTemplate) && p.openElements.hasInScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM)) {
        p.openElements.generateImpliedEndTags();
        if (inTemplate) p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM);
        else if (formElement) p.openElements.remove(formElement);
    }
}
function $2f5582982d8cf3f4$var$pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P)) p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).P, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P);
    p._closePElement();
}
function $2f5582982d8cf3f4$var$liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI);
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI);
    }
}
function $2f5582982d8cf3f4$var$ddEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $2f5582982d8cf3f4$var$numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}
function $2f5582982d8cf3f4$var$appletEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}
function $2f5582982d8cf3f4$var$brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).BR, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR);
    p.openElements.pop();
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$genericEndTagInBody(p, token) {
    const tn = token.tagName;
    const tid = token.tagID;
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        const elementId = p.openElements.tagIDs[i];
        // Compare the tag name here, as the tag might not be a known tag with an ID.
        if (tid === elementId && (tid !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
            p.openElements.generateImpliedEndTagsWithExclusion(tid);
            if (p.openElements.stackTop >= i) p.openElements.shortenToLength(i);
            break;
        }
        if (p._isSpecialElement(element, elementId)) break;
    }
}
function $2f5582982d8cf3f4$var$endTagInBody(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).A:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).B:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).I:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).S:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).U:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).EM:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BIG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CODE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOBR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SMALL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRIKE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STRONG:
            $2f5582982d8cf3f4$var$callAdoptionAgency(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P:
            $2f5582982d8cf3f4$var$pEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).UL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIR:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NAV:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).PRE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MAIN:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MENU:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ASIDE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BUTTON:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CENTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGURE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FOOTER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HEADER:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DIALOG:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ADDRESS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).ARTICLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DETAILS:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SEARCH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SECTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SUMMARY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LISTING:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIELDSET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FIGCAPTION:
            $2f5582982d8cf3f4$var$addressEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LI:
            $2f5582982d8cf3f4$var$liEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).DT:
            $2f5582982d8cf3f4$var$ddEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H1:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H2:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H3:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H4:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H5:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).H6:
            $2f5582982d8cf3f4$var$numberedHeaderEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR:
            $2f5582982d8cf3f4$var$brEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
            $2f5582982d8cf3f4$var$bodyEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$htmlEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM:
            $2f5582982d8cf3f4$var$formEndTagInBody(p);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).APPLET:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OBJECT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).MARQUEE:
            $2f5582982d8cf3f4$var$appletEndTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
            $2f5582982d8cf3f4$var$genericEndTagInBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$eofInBody(p, token) {
    if (p.tmplInsertionModeStack.length > 0) $2f5582982d8cf3f4$var$eofInTemplate(p, token);
    else $2f5582982d8cf3f4$var$stopParsing(p, token);
}
// The "text" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$endTagInText(p, token) {
    var _a;
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT) (_a = p.scriptHandler) === null || _a === void 0 || _a.call(p, p.openElements.current);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}
function $2f5582982d8cf3f4$var$eofInText(p, token) {
    p._err(token, (0, $36aeaab04c5a6aea$export$9e0efcb140234d2).eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p.onEof(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$characterInTable(p, token) {
    if (p.openElements.currentTagId !== undefined && $2f5582982d8cf3f4$var$TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
        p.pendingCharacterTokens.length = 0;
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_TEXT;
        switch(token.type){
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).CHARACTER:
                $2f5582982d8cf3f4$var$characterInTableText(p, token);
                break;
            case (0, $be390ad8d330a451$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                $2f5582982d8cf3f4$var$whitespaceCharacterInTableText(p, token);
                break;
        }
    } else $2f5582982d8cf3f4$var$tokenInTable(p, token);
}
function $2f5582982d8cf3f4$var$captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CAPTION;
}
function $2f5582982d8cf3f4$var$colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
}
function $2f5582982d8cf3f4$var$colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).COLGROUP, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
    $2f5582982d8cf3f4$var$startTagInColumnGroup(p, token);
}
function $2f5582982d8cf3f4$var$tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
}
function $2f5582982d8cf3f4$var$tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).TBODY, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY);
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
    $2f5582982d8cf3f4$var$startTagInTableBody(p, token);
}
function $2f5582982d8cf3f4$var$tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE)) {
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE);
        p._resetInsertionMode();
        p._processStartTag(token);
    }
}
function $2f5582982d8cf3f4$var$inputStartTagInTable(p, token) {
    if ($2f5582982d8cf3f4$var$isHiddenInput(token)) p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
    else $2f5582982d8cf3f4$var$tokenInTable(p, token);
    token.ackSelfClosing = true;
}
function $2f5582982d8cf3f4$var$formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}
function $2f5582982d8cf3f4$var$startTagInTable(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            $2f5582982d8cf3f4$var$tdStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            $2f5582982d8cf3f4$var$colStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FORM:
            $2f5582982d8cf3f4$var$formStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            $2f5582982d8cf3f4$var$tableStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            $2f5582982d8cf3f4$var$tbodyStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).INPUT:
            $2f5582982d8cf3f4$var$inputStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
            $2f5582982d8cf3f4$var$captionStartTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
            $2f5582982d8cf3f4$var$colgroupStartTagInTable(p, token);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInTable(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE)) {
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE);
                p._resetInsertionMode();
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    // Process token in `In Body` mode
    $2f5582982d8cf3f4$var$modeInBody(p, token);
    p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}
function $2f5582982d8cf3f4$var$characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}
function $2f5582982d8cf3f4$var$tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) for(; i < p.pendingCharacterTokens.length; i++)$2f5582982d8cf3f4$var$tokenInTable(p, p.pendingCharacterTokens[i]);
    else for(; i < p.pendingCharacterTokens.length; i++)p._insertCharacters(p.pendingCharacterTokens[i]);
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
const $2f5582982d8cf3f4$var$TABLE_VOID_ELEMENTS = new Set([
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD,
    (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR
]);
function $2f5582982d8cf3f4$var$startTagInCaption(p, token) {
    const tn = token.tagID;
    if ($2f5582982d8cf3f4$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
        }
    } else $2f5582982d8cf3f4$var$startTagInBody(p, token);
}
function $2f5582982d8cf3f4$var$endTagInCaption(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE) $2f5582982d8cf3f4$var$endTagInTable(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInBody(p, token);
    }
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInColumnGroup(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP) {
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            break;
        default:
            $2f5582982d8cf3f4$var$tokenInColumnGroup(p, token);
    }
}
function $2f5582982d8cf3f4$var$tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP) {
        p.openElements.pop();
        p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
        p._processToken(token);
    }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInTableBody(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            p.openElements.clearBackToTableBodyContext();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableBodyContext();
            p._insertFakeElement((0, $c2855a9ccb69df69$export$7e674a85a2656dce).TR, (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            $2f5582982d8cf3f4$var$startTagInRow(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                $2f5582982d8cf3f4$var$startTagInTable(p, token);
            }
            break;
        default:
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInTableBody(p, token) {
    const tn = token.tagID;
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
                $2f5582982d8cf3f4$var$endTagInTable(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInTable(p, token);
    }
}
// The "in row" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInRow(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableRowContext();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_CELL;
            p.activeFormattingElements.insertMarker();
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                $2f5582982d8cf3f4$var$startTagInTableBody(p, token);
            }
            break;
        default:
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInRow(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                $2f5582982d8cf3f4$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(token.tagID) || p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
                $2f5582982d8cf3f4$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInTable(p, token);
    }
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInCell(p, token) {
    const tn = token.tagID;
    if ($2f5582982d8cf3f4$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD) || p.openElements.hasInTableScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH)) {
            p._closeTableCell();
            $2f5582982d8cf3f4$var$startTagInRow(p, token);
        }
    } else $2f5582982d8cf3f4$var$startTagInBody(p, token);
}
function $2f5582982d8cf3f4$var$endTagInCell(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped(tn);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope(tn)) {
                p._closeTableCell();
                $2f5582982d8cf3f4$var$endTagInRow(p, token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            break;
        default:
            $2f5582982d8cf3f4$var$endTagInBody(p, token);
    }
}
// The "in select" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HR:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).INPUT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).KEYGEN:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEXTAREA:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
                if (token.tagID !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT) p._processStartTag(token);
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$endTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.stackTop > 0 && p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
            }
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
            $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
            break;
        default:
    }
}
// The "in select in table" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH) {
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
        p._resetInsertionMode();
        p._processStartTag(token);
    } else $2f5582982d8cf3f4$var$startTagInSelect(p, token);
}
function $2f5582982d8cf3f4$var$endTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TABLE || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD || tn === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SELECT);
            p._resetInsertionMode();
            p.onEndTag(token);
        }
    } else $2f5582982d8cf3f4$var$endTagInSelect(p, token);
}
// The "in template" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInTemplate(p, token) {
    switch(token.tagID){
        // First, handle tags that can start without a mode change
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BASEFONT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BGSOUND:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).LINK:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).META:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).SCRIPT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).STYLE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TITLE:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        // Re-process the token in the appropriate mode
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).CAPTION:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COLGROUP:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TBODY:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TFOOT:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).THEAD:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE;
            $2f5582982d8cf3f4$var$startTagInTable(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).COL:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_COLUMN_GROUP;
            $2f5582982d8cf3f4$var$startTagInColumnGroup(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TR:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_TABLE_BODY;
            $2f5582982d8cf3f4$var$startTagInTableBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TD:
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TH:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_ROW;
            $2f5582982d8cf3f4$var$startTagInRow(p, token);
            break;
        default:
            p.tmplInsertionModeStack[0] = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
            p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
    }
}
function $2f5582982d8cf3f4$var$endTagInTemplate(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE) $2f5582982d8cf3f4$var$templateEndTagInHead(p, token);
}
function $2f5582982d8cf3f4$var$eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped((0, $c2855a9ccb69df69$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
        p.onEof(token);
    } else $2f5582982d8cf3f4$var$stopParsing(p, token);
}
// The "after body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterBody(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) $2f5582982d8cf3f4$var$startTagInBody(p, token);
    else $2f5582982d8cf3f4$var$tokenAfterBody(p, token);
}
function $2f5582982d8cf3f4$var$endTagAfterBody(p, token) {
    var _a;
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) {
        if (!p.fragmentContext) p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_BODY;
        //NOTE: <html> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) {
            p._setEndLocation(p.openElements.items[0], token);
            // Update the body element, if it doesn't have an end tag
            const bodyElement = p.openElements.items[1];
            if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) p._setEndLocation(bodyElement, token);
        }
    } else $2f5582982d8cf3f4$var$tokenAfterBody(p, token);
}
function $2f5582982d8cf3f4$var$tokenAfterBody(p, token) {
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    $2f5582982d8cf3f4$var$modeInBody(p, token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagInFrameset(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAME:
            p._appendElement(token, (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$endTagInFrameset(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();
        if (!p.fragmentContext && p.openElements.currentTagId !== (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).FRAMESET) p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_FRAMESET;
    }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $2f5582982d8cf3f4$var$endTagAfterFrameset(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.AFTER_AFTER_FRAMESET;
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterAfterBody(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML) $2f5582982d8cf3f4$var$startTagInBody(p, token);
    else $2f5582982d8cf3f4$var$tokenAfterAfterBody(p, token);
}
function $2f5582982d8cf3f4$var$tokenAfterAfterBody(p, token) {
    p.insertionMode = $2f5582982d8cf3f4$var$InsertionMode.IN_BODY;
    $2f5582982d8cf3f4$var$modeInBody(p, token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$startTagAfterAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).HTML:
            $2f5582982d8cf3f4$var$startTagInBody(p, token);
            break;
        case (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).NOFRAMES:
            $2f5582982d8cf3f4$var$startTagInHead(p, token);
            break;
        default:
    }
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function $2f5582982d8cf3f4$var$nullCharacterInForeignContent(p, token) {
    token.chars = $bb1347fda1174ed8$export$e8d20e7a50e6c279;
    p._insertCharacters(token);
}
function $2f5582982d8cf3f4$var$characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $2f5582982d8cf3f4$var$popUntilHtmlOrIntegrationPoint(p) {
    while(p.treeAdapter.getNamespaceURI(p.openElements.current) !== (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML && p.openElements.currentTagId !== undefined && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current))p.openElements.pop();
}
function $2f5582982d8cf3f4$var$startTagInForeignContent(p, token) {
    if ($488c212c7b5d6f42$export$3435eb4ab4d2ed2d(token)) {
        $2f5582982d8cf3f4$var$popUntilHtmlOrIntegrationPoint(p);
        p._startTagOutsideForeignContent(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);
        if (currentNs === (0, $c2855a9ccb69df69$export$fb4028874a74450).MATHML) $488c212c7b5d6f42$export$c583cc5a9d633feb(token);
        else if (currentNs === (0, $c2855a9ccb69df69$export$fb4028874a74450).SVG) {
            $488c212c7b5d6f42$export$95df78fe2e7f33e3(token);
            $488c212c7b5d6f42$export$74ce06f755fb8f68(token);
        }
        $488c212c7b5d6f42$export$a5192af02995cbdc(token);
        if (token.selfClosing) p._appendElement(token, currentNs);
        else p._insertElement(token, currentNs);
        token.ackSelfClosing = true;
    }
}
function $2f5582982d8cf3f4$var$endTagInForeignContent(p, token) {
    if (token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).P || token.tagID === (0, $c2855a9ccb69df69$export$cb0999a53e0acaed).BR) {
        $2f5582982d8cf3f4$var$popUntilHtmlOrIntegrationPoint(p);
        p._endTagOutsideForeignContent(token);
        return;
    }
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        if (p.treeAdapter.getNamespaceURI(element) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML) {
            p._endTagOutsideForeignContent(token);
            break;
        }
        const tagName = p.treeAdapter.getTagName(element);
        if (tagName.toLowerCase() === token.tagName) {
            //NOTE: update the token tag name for `_setEndLocation`.
            token.tagName = tagName;
            p.openElements.shortenToLength(i);
            break;
        }
    }
}





const $76b9307c73063a75$export$5699810ce3244ab8 = /["$&'<>\u0080-\uFFFF]/g;
const $76b9307c73063a75$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $76b9307c73063a75$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt == null ? (c, index)=>(c.charCodeAt(index) & 64512) === 55296 ? (c.charCodeAt(index) - 55296) * 1024 + c.charCodeAt(index + 1) - 56320 + 65536 : c.charCodeAt(index) : (input, index)=>input.codePointAt(index);
function $76b9307c73063a75$export$18855ec5be97da16(input) {
    let returnValue = "";
    let lastIndex = 0;
    let match;
    while((match = $76b9307c73063a75$export$5699810ce3244ab8.exec(input)) !== null){
        const { index: index } = match;
        const char = input.charCodeAt(index);
        const next = $76b9307c73063a75$var$xmlCodeMap.get(char);
        if (next === undefined) {
            returnValue += `${input.substring(lastIndex, index)}&#x${$76b9307c73063a75$export$e02688b8085d016b(input, index).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIndex = $76b9307c73063a75$export$5699810ce3244ab8.lastIndex += Number((char & 64512) === 55296);
        } else {
            returnValue += input.substring(lastIndex, index) + next;
            lastIndex = index + 1;
        }
    }
    return returnValue + input.substr(lastIndex);
}
const $76b9307c73063a75$export$4e7f196112fea3c5 = $76b9307c73063a75$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $76b9307c73063a75$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIndex = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIndex !== match.index) result += data.substring(lastIndex, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIndex = match.index + 1;
        }
        return result + data.substring(lastIndex);
    };
}
const $76b9307c73063a75$export$9e081872deefdcb0 = /* #__PURE__ */ $76b9307c73063a75$var$getEscaper(/["&'<>]/g, $76b9307c73063a75$var$xmlCodeMap);
const $76b9307c73063a75$export$30330f3d5eb70e11 = /* #__PURE__ */ $76b9307c73063a75$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $76b9307c73063a75$export$96e6fc3a139b2555 = /* #__PURE__ */ $76b9307c73063a75$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));



// Sets
const $762ab6a391ef02ce$var$VOID_ELEMENTS = new Set([
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).AREA,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BASE,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BASEFONT,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BGSOUND,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).BR,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).COL,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).EMBED,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).FRAME,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).HR,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).IMG,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).INPUT,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).KEYGEN,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).LINK,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).META,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).PARAM,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).SOURCE,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).TRACK,
    (0, $c2855a9ccb69df69$export$7e674a85a2656dce).WBR
]);
function $762ab6a391ef02ce$var$isVoidElement(node, options) {
    return options.treeAdapter.isElementNode(node) && options.treeAdapter.getNamespaceURI(node) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML && $762ab6a391ef02ce$var$VOID_ELEMENTS.has(options.treeAdapter.getTagName(node));
}
const $762ab6a391ef02ce$var$defaultOpts = {
    treeAdapter: (0, $01acbc1e35b87488$export$7ddbba828dfa4796),
    scriptingEnabled: true
};
function $762ab6a391ef02ce$export$dfdc1655ccc5b9cb(node, options) {
    const opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $762ab6a391ef02ce$var$defaultOpts, options);
    if ($762ab6a391ef02ce$var$isVoidElement(node, opts)) return '';
    return $762ab6a391ef02ce$var$serializeChildNodes(node, opts);
}
function $762ab6a391ef02ce$export$71e9c1f1ceb5a856(node, options) {
    const opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $762ab6a391ef02ce$var$defaultOpts, options);
    return $762ab6a391ef02ce$var$serializeNode(node, opts);
}
function $762ab6a391ef02ce$var$serializeChildNodes(parentNode, options) {
    let html = '';
    // Get container of the child nodes
    const container = options.treeAdapter.isElementNode(parentNode) && options.treeAdapter.getTagName(parentNode) === (0, $c2855a9ccb69df69$export$7e674a85a2656dce).TEMPLATE && options.treeAdapter.getNamespaceURI(parentNode) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML ? options.treeAdapter.getTemplateContent(parentNode) : parentNode;
    const childNodes = options.treeAdapter.getChildNodes(container);
    if (childNodes) for (const currentNode of childNodes)html += $762ab6a391ef02ce$var$serializeNode(currentNode, options);
    return html;
}
function $762ab6a391ef02ce$var$serializeNode(node, options) {
    if (options.treeAdapter.isElementNode(node)) return $762ab6a391ef02ce$var$serializeElement(node, options);
    if (options.treeAdapter.isTextNode(node)) return $762ab6a391ef02ce$var$serializeTextNode(node, options);
    if (options.treeAdapter.isCommentNode(node)) return $762ab6a391ef02ce$var$serializeCommentNode(node, options);
    if (options.treeAdapter.isDocumentTypeNode(node)) return $762ab6a391ef02ce$var$serializeDocumentTypeNode(node, options);
    // Return an empty string for unknown nodes
    return '';
}
function $762ab6a391ef02ce$var$serializeElement(node, options) {
    const tn = options.treeAdapter.getTagName(node);
    return `<${tn}${$762ab6a391ef02ce$var$serializeAttributes(node, options)}>${$762ab6a391ef02ce$var$isVoidElement(node, options) ? '' : `${$762ab6a391ef02ce$var$serializeChildNodes(node, options)}</${tn}>`}`;
}
function $762ab6a391ef02ce$var$serializeAttributes(node, { treeAdapter: treeAdapter }) {
    let html = '';
    for (const attr of treeAdapter.getAttrList(node)){
        html += ' ';
        if (attr.namespace) switch(attr.namespace){
            case (0, $c2855a9ccb69df69$export$fb4028874a74450).XML:
                html += `xml:${attr.name}`;
                break;
            case (0, $c2855a9ccb69df69$export$fb4028874a74450).XMLNS:
                if (attr.name !== 'xmlns') html += 'xmlns:';
                html += attr.name;
                break;
            case (0, $c2855a9ccb69df69$export$fb4028874a74450).XLINK:
                html += `xlink:${attr.name}`;
                break;
            default:
                html += `${attr.prefix}:${attr.name}`;
        }
        else html += attr.name;
        html += `="${(0, $76b9307c73063a75$export$30330f3d5eb70e11)(attr.value)}"`;
    }
    return html;
}
function $762ab6a391ef02ce$var$serializeTextNode(node, options) {
    const { treeAdapter: treeAdapter } = options;
    const content = treeAdapter.getTextNodeContent(node);
    const parent = treeAdapter.getParentNode(node);
    const parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
    return parentTn && treeAdapter.getNamespaceURI(parent) === (0, $c2855a9ccb69df69$export$fb4028874a74450).HTML && (0, $c2855a9ccb69df69$export$4ce4f8c09f921aed)(parentTn, options.scriptingEnabled) ? content : (0, $76b9307c73063a75$export$96e6fc3a139b2555)(content);
}
function $762ab6a391ef02ce$var$serializeCommentNode(node, { treeAdapter: treeAdapter }) {
    return `<!--${treeAdapter.getCommentNodeContent(node)}-->`;
}
function $762ab6a391ef02ce$var$serializeDocumentTypeNode(node, { treeAdapter: treeAdapter }) {
    return `<!DOCTYPE ${treeAdapter.getDocumentTypeNodeName(node)}>`;
}







function $7822c393005c8687$export$98e6a39c04603d36(html, options) {
    return (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37).parse(html, options);
}
function $7822c393005c8687$export$e1152f5efcc82ad(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }
    const parser = (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37).getFragmentParser(fragmentContext, options);
    parser.tokenizer.write(html, true);
    return parser.getFragment();
}






const $c58a141a6871fca8$var$gfmTagfilterExpression = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi;
// Node types associated with MDX.
// <https://github.com/mdx-js/mdx/blob/8a56312/packages/mdx/lib/node-types.js>
const $c58a141a6871fca8$var$knownMdxNames = new Set([
    'mdxFlowExpression',
    'mdxJsxFlowElement',
    'mdxJsxTextElement',
    'mdxTextExpression',
    'mdxjsEsm'
]);
/** @type {ParserOptions<DefaultTreeAdapterMap>} */ const $c58a141a6871fca8$var$parseOptions = {
    sourceCodeLocationInfo: true,
    scriptingEnabled: false
};
function $c58a141a6871fca8$export$1776c186c69df29e(tree, options) {
    const document = $c58a141a6871fca8$var$documentMode(tree);
    /** @type {(node: Nodes, state: State) => undefined} */ const one = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
        handlers: {
            root: $c58a141a6871fca8$var$root,
            element: $c58a141a6871fca8$var$element,
            text: $c58a141a6871fca8$var$text,
            comment: $c58a141a6871fca8$var$comment,
            doctype: $c58a141a6871fca8$var$doctype,
            raw: $c58a141a6871fca8$var$handleRaw
        },
        unknown: $c58a141a6871fca8$var$unknown
    });
    /** @type {State} */ const state = {
        parser: document ? new (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37)($c58a141a6871fca8$var$parseOptions) : (0, $2f5582982d8cf3f4$export$7acfa6ed01010e37).getFragmentParser(undefined, $c58a141a6871fca8$var$parseOptions),
        handle (node) {
            one(node, state);
        },
        stitches: false,
        options: options || {}
    };
    one(tree, state);
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)());
    const p5 = document ? state.parser.document : state.parser.getFragment();
    const result = (0, $73bde87d01cc5621$export$371ddbe92c872127)(p5, {
        // To do: support `space`?
        file: state.options.file
    });
    if (state.stitches) (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(result, 'comment', function(node, index, parent) {
        const stitch = /** @type {unknown} */ node;
        if (stitch.value.stitch && parent && index !== undefined) {
            /** @type {Array<RootContent>} */ const siblings = parent.children;
            // @ts-expect-error: assume the stitch is allowed.
            siblings[index] = stitch.value.stitch;
            return index;
        }
    });
    // Unpack if possible and when not given a `root`.
    if (result.type === 'root' && result.children.length === 1 && result.children[0].type === tree.type) return result.children[0];
    return result;
}
/**
 * Transform all nodes
 *
 * @param {Array<RootContent>} nodes
 *   hast content.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$all(nodes, state) {
    let index = -1;
    /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */ if (nodes) while(++index < nodes.length)state.handle(nodes[index]);
}
/**
 * Transform a root.
 *
 * @param {Root} node
 *   hast root node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$root(node, state) {
    $c58a141a6871fca8$var$all(node.children, state);
}
/**
 * Transform an element.
 *
 * @param {Element} node
 *   hast element node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$element(node, state) {
    $c58a141a6871fca8$var$startTag(node, state);
    $c58a141a6871fca8$var$all(node.children, state);
    $c58a141a6871fca8$var$endTag(node, state);
}
/**
 * Transform a text.
 *
 * @param {Text} node
 *   hast text node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$text(node, state) {
    // Allow `DATA` through `PLAINTEXT`,
    // but when hanging in a tag for example,
    // switch back to `DATA`.
    // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
    // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
    if (state.parser.tokenizer.state > 4) state.parser.tokenizer.state = 0;
    /** @type {Token.CharacterToken} */ const token = {
        type: (0, $be390ad8d330a451$exports).TokenType.CHARACTER,
        chars: node.value,
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
}
/**
 * Transform a doctype.
 *
 * @param {Doctype} node
 *   hast doctype node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$doctype(node, state) {
    /** @type {Token.DoctypeToken} */ const token = {
        type: (0, $be390ad8d330a451$exports).TokenType.DOCTYPE,
        name: 'html',
        forceQuirks: false,
        publicId: '',
        systemId: '',
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
}
/**
 * Transform a stitch.
 *
 * @param {Nodes} node
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$stitch(node, state) {
    // Mark that there are stitches, so we need to walk the tree and revert them.
    state.stitches = true;
    /** @type {Nodes} */ const clone = $c58a141a6871fca8$var$cloneWithoutChildren(node);
    // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
    // passed through node).
    if ('children' in node && 'children' in clone) {
        // Root in root out.
        const fakeRoot = /** @type {Root} */ $c58a141a6871fca8$export$1776c186c69df29e({
            type: 'root',
            children: node.children
        }, state.options);
        clone.children = fakeRoot.children;
    }
    // Hack: `value` is supposed to be a string, but as none of the tools
    // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
    // through.
    $c58a141a6871fca8$var$comment({
        type: 'comment',
        value: {
            stitch: clone
        }
    }, state);
}
/**
 * Transform a comment (or stitch).
 *
 * @param {Comment | Stitch} node
 *   hast comment node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$comment(node, state) {
    /** @type {string} */ // @ts-expect-error: we pass stitches through.
    const data = node.value;
    /** @type {Token.CommentToken} */ const token = {
        type: (0, $be390ad8d330a451$exports).TokenType.COMMENT,
        data: data,
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
}
/**
 * Transform a raw node.
 *
 * @param {Raw} node
 *   hast raw node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$handleRaw(node, state) {
    // Reset preprocessor:
    // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/preprocessor.ts#L18-L31>.
    state.parser.tokenizer.preprocessor.html = '';
    state.parser.tokenizer.preprocessor.pos = -1;
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.lastGapPos = -2;
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.gapStack = [];
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.skipNextNewLine = false;
    state.parser.tokenizer.preprocessor.lastChunkWritten = false;
    state.parser.tokenizer.preprocessor.endOfChunkHit = false;
    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.isEol = false;
    // Now pass `node.value`.
    $c58a141a6871fca8$var$setPoint(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    state.parser.tokenizer.write(state.options.tagfilter ? node.value.replace($c58a141a6871fca8$var$gfmTagfilterExpression, '&lt;$1$2') : node.value, false);
    // @ts-expect-error: private.
    state.parser.tokenizer._runParsingLoop();
    // Character references hang, so if we ended there, we need to flush
    // those too.
    // We reset the preprocessor as if the document ends here.
    // Then one single call to the relevant state does the trick, parse5
    // consumes the whole token.
    // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
    // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
    // Note: a change to `parse5`, which breaks this, was merged but not released.
    // Investigate when it is.
    // To do: remove next major.
    /* c8 ignore next 12 -- removed in <https://github.com/inikulin/parse5/pull/897> */ if (state.parser.tokenizer.state === 72 /* NAMED_CHARACTER_REFERENCE */  || // @ts-expect-error: removed.
    state.parser.tokenizer.state === 78 /* NUMERIC_CHARACTER_REFERENCE_END */ ) {
        state.parser.tokenizer.preprocessor.lastChunkWritten = true;
        /** @type {number} */ // @ts-expect-error: private.
        const cp = state.parser.tokenizer._consume();
        // @ts-expect-error: private.
        state.parser.tokenizer._callState(cp);
    }
}
/**
 * Crash on an unknown node.
 *
 * @param {unknown} node_
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Never.
 */ function $c58a141a6871fca8$var$unknown(node_, state) {
    const node = /** @type {Nodes} */ node_;
    if (state.options.passThrough && state.options.passThrough.includes(node.type)) $c58a141a6871fca8$var$stitch(node, state);
    else {
        let extra = '';
        if ($c58a141a6871fca8$var$knownMdxNames.has(node.type)) extra = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax";
        throw new Error('Cannot compile `' + node.type + '` node' + extra);
    }
}
/**
 * Reset the tokenizer of a parser.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$resetTokenizer(state, point) {
    $c58a141a6871fca8$var$setPoint(state, point);
    // Process final characters if they’re still there after hibernating.
    /** @type {Token.CharacterToken} */ // @ts-expect-error: private.
    const token = state.parser.tokenizer.currentCharacterToken;
    if (token && token.location) {
        token.location.endLine = state.parser.tokenizer.preprocessor.line;
        token.location.endCol = state.parser.tokenizer.preprocessor.col + 1;
        token.location.endOffset = state.parser.tokenizer.preprocessor.offset + 1;
        // @ts-expect-error: private.
        state.parser.currentToken = token;
        // @ts-expect-error: private.
        state.parser._processToken(state.parser.currentToken);
    }
    // Reset tokenizer:
    // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/index.ts#L187-L223>.
    // Especially putting it back in the `data` state is useful: some elements,
    // like textareas and iframes, change the state.
    // See GH-7.
    // But also if broken HTML is in `raw`, and then a correct element is given.
    // See GH-11.
    // @ts-expect-error: private.
    state.parser.tokenizer.paused = false;
    // @ts-expect-error: private.
    state.parser.tokenizer.inLoop = false;
    // Note: don’t reset `state`, `inForeignNode`, or `lastStartTagName`, we
    // manually update those when needed.
    state.parser.tokenizer.active = false;
    // @ts-expect-error: private.
    state.parser.tokenizer.returnState = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).DATA;
    // @ts-expect-error: private.
    state.parser.tokenizer.charRefCode = -1;
    // @ts-expect-error: private.
    state.parser.tokenizer.consumedAfterSnapshot = -1;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentLocation = null;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentCharacterToken = null;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentToken = null;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentAttr = {
        name: '',
        value: ''
    };
}
/**
 * Set current location.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$setPoint(state, point) {
    if (point && point.offset !== undefined) {
        /** @type {Token.Location} */ const location = {
            startLine: point.line,
            startCol: point.column,
            startOffset: point.offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
        // @ts-expect-error: private.
        // type-coverage:ignore-next-line
        state.parser.tokenizer.preprocessor.lineStartPos = -point.column + 1 // Looks weird, but ensures we get correct positional info.
        ;
        state.parser.tokenizer.preprocessor.droppedBufferSize = point.offset;
        state.parser.tokenizer.preprocessor.line = point.line;
        // @ts-expect-error: private.
        state.parser.tokenizer.currentLocation = location;
    }
}
/**
 * Emit a start tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$startTag(node, state) {
    const tagName = node.tagName.toLowerCase();
    // Ignore tags if we’re in plain text.
    if (state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT) return;
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node));
    const current = state.parser.openElements.current;
    let ns = 'namespaceURI' in current ? current.namespaceURI : (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).html;
    if (ns === (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).html && tagName === 'svg') ns = (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).svg;
    const result = (0, $2e94052ec8d06cd1$export$b4cf803c867502fc)(// Shallow clone to not delve into `children`: we only need the attributes.
    (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, node), {
        children: []
    }), {
        space: ns === (0, $1ef3bf91500f5903$export$f9bfcc6efbcb9478).svg ? 'svg' : 'html'
    });
    /** @type {Token.TagToken} */ const tag = {
        type: (0, $be390ad8d330a451$exports).TokenType.START_TAG,
        tagName: tagName,
        tagID: (0, $c2855a9ccb69df69$exports).getTagID(tagName),
        // We always send start and end tags.
        selfClosing: false,
        ackSelfClosing: false,
        // Always element.
        /* c8 ignore next */ attrs: 'attrs' in result ? result.attrs : [],
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    // The HTML parsing algorithm works by doing half of the state management in
    // the tokenizer and half in the parser.
    // We can’t use the tokenizer here, as we don’t have strings.
    // So we act *as if* the tokenizer emits tokens:
    // @ts-expect-error: private.
    state.parser.currentToken = tag;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
    // …but then we still need a bunch of work that the tokenizer would normally
    // do, such as:
    // Set a tag name, similar to how the tokenizer would do it.
    state.parser.tokenizer.lastStartTagName = tagName;
// `inForeignNode` is correctly set by the parser.
}
/**
 * Emit an end tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */ function $c58a141a6871fca8$var$endTag(node, state) {
    const tagName = node.tagName.toLowerCase();
    // Do not emit closing tags for HTML void elements.
    if (!state.parser.tokenizer.inForeignNode && (0, $fe4fce3fd1fee116$export$762508062d068de).includes(tagName)) return;
    // Ignore tags if we’re in plain text.
    if (state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).PLAINTEXT) return;
    $c58a141a6871fca8$var$resetTokenizer(state, (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node));
    /** @type {Token.TagToken} */ const tag = {
        type: (0, $be390ad8d330a451$exports).TokenType.END_TAG,
        tagName: tagName,
        tagID: (0, $c2855a9ccb69df69$exports).getTagID(tagName),
        selfClosing: false,
        ackSelfClosing: false,
        attrs: [],
        location: $c58a141a6871fca8$var$createParse5Location(node)
    };
    // The HTML parsing algorithm works by doing half of the state management in
    // the tokenizer and half in the parser.
    // We can’t use the tokenizer here, as we don’t have strings.
    // So we act *as if* the tokenizer emits tokens:
    // @ts-expect-error: private.
    state.parser.currentToken = tag;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
    // …but then we still need a bunch of work that the tokenizer would normally
    // do, such as:
    // Switch back to the data state after alternative states that don’t accept
    // tags:
    if (// Current element is closed.
    tagName === state.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
    (state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
    state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).RAWTEXT || // `<script>`
    state.parser.tokenizer.state === (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).SCRIPT_DATA)) state.parser.tokenizer.state = (0, $c44790542489a2a8$export$d0c9fb8d2ebe5159).DATA;
}
/**
 * Check if `node` represents a whole document or a fragment.
 *
 * @param {Nodes} node
 *   hast node.
 * @returns {boolean}
 *   Whether this represents a whole document or a fragment.
 */ function $c58a141a6871fca8$var$documentMode(node) {
    const head = node.type === 'root' ? node.children[0] : node;
    return Boolean(head && (head.type === 'doctype' || head.type === 'element' && head.tagName.toLowerCase() === 'html'));
}
/**
 * Get a `parse5` location from a node.
 *
 * @param {Nodes | Stitch} node
 *   hast node.
 * @returns {Token.Location}
 *   `parse5` location.
 */ function $c58a141a6871fca8$var$createParse5Location(node) {
    const start = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node) || {
        line: undefined,
        column: undefined,
        offset: undefined
    };
    const end = (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node) || {
        line: undefined,
        column: undefined,
        offset: undefined
    };
    /** @type {Record<keyof Token.Location, number | undefined>} */ const location = {
        startLine: start.line,
        startCol: start.column,
        startOffset: start.offset,
        endLine: end.line,
        endCol: end.column,
        endOffset: end.offset
    };
    // @ts-expect-error: unist point values can be `undefined` in hast, which
    // `parse5` types don’t want.
    return location;
}
/**
 * @template {Nodes} NodeType
 *   Node type.
 * @param {NodeType} node
 *   Node to clone.
 * @returns {NodeType}
 *   Cloned node, without children.
 */ function $c58a141a6871fca8$var$cloneWithoutChildren(node) {
    return 'children' in node ? (0, $e46c0242ff031819$export$2e2bcd8739ae039)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, node), {
        children: []
    })) : (0, $e46c0242ff031819$export$2e2bcd8739ae039)(node);
}


function $f9f41141c2cb11d3$export$2e2bcd8739ae039(options) {
    /**
   * @param {Root} tree
   *   Tree.
   * @param {VFile} file
   *   File.
   * @returns {Root}
   *   New tree.
   */ return function(tree, file) {
        // Assume root in -> root out.
        const result = /** @type {Root} */ (0, $c58a141a6871fca8$export$1776c186c69df29e)(tree, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            file: file
        }));
        return result;
    };
}





var $7fPBF = parcelRequire("7fPBF");
/**
 * @import {Element, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentType, JSX, ReactElement, ReactNode} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in keyof JSX.IntrinsicElements]?: ComponentType<JSX.IntrinsicElements[Key] & ExtraProps> | keyof JSX.IntrinsicElements
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @typedef HooksOptionsOnly
 *   Configuration specifically for {@linkcode MarkdownHooks}.
 * @property {ReactNode | null | undefined} [fallback]
 *   Content to render while the processor processing the markdown (optional).
 */ /**
 * @typedef {Options & HooksOptionsOnly} HooksOptions
 *   Configuration for {@linkcode MarkdownHooks};
 *   extends the regular {@linkcode Options} with a `fallback` prop.
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ 





var $7fPBF = parcelRequire("7fPBF");





const $82a842773b01cef7$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $82a842773b01cef7$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $82a842773b01cef7$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $82a842773b01cef7$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $82a842773b01cef7$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'className',
        id: 'remove-classname'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $82a842773b01cef7$export$7460c8b7e4ce9582(options) {
    const processor = $82a842773b01cef7$var$createProcessor(options);
    const file = $82a842773b01cef7$var$createFile(options);
    return $82a842773b01cef7$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $82a842773b01cef7$export$445edbd7f2c65a8c(options) {
    const processor = $82a842773b01cef7$var$createProcessor(options);
    const file = $82a842773b01cef7$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $82a842773b01cef7$var$post(tree, options);
}
function $82a842773b01cef7$export$915021c692d253a2(options) {
    const processor = $82a842773b01cef7$var$createProcessor(options);
    const [error, setError] = (0, $7fPBF.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $7fPBF.useState)(/** @type {Root | undefined} */ undefined);
    (0, $7fPBF.useEffect)(function() {
        let cancelled = false;
        const file = $82a842773b01cef7$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            if (!cancelled) {
                setError(error);
                setTree(tree);
            }
        });
        /**
       * @returns {undefined}
       *   Nothing.
       */ return function() {
            cancelled = true;
        };
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    if (error) throw error;
    return tree ? $82a842773b01cef7$var$post(tree, options) : options.fallback;
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $82a842773b01cef7$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $82a842773b01cef7$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $82a842773b01cef7$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options.remarkRehypeOptions, $82a842773b01cef7$var$emptyRemarkRehypeOptions) : $82a842773b01cef7$var$emptyRemarkRehypeOptions;
    const processor = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $4f339a22525673d0$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $74ce0141155f6a3a$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $82a842773b01cef7$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $365ad175729fa366$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $82a842773b01cef7$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $82a842773b01cef7$export$ca5e94754123e2f3;
    for (const deprecation of $82a842773b01cef7$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $82a842773b01cef7$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $bcaef7e086af7de5$export$59c10052b2dee561)(tree, {
        Fragment: $824c049f32d4395d$exports.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $824c049f32d4395d$exports.jsx,
        jsxs: $824c049f32d4395d$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $1389ec48924c67a6$export$de3e062aedff083a)if (Object.hasOwn((0, $1389ec48924c67a6$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $1389ec48924c67a6$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $82a842773b01cef7$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $82a842773b01cef7$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}





const $e23aa99c2e71581e$var$alertRegex = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]/i;
const $e23aa99c2e71581e$var$alertLegacyRegex = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)(\/.*)?\]/i;
const $e23aa99c2e71581e$export$a7abfbfd1870441d = ({ legacyTitle: legacyTitle = false, tagName: tagName = "div" } = {})=>{
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, "blockquote", (node, index, parent)=>{
            let alertType = '';
            let title = '';
            let isNext = true;
            let child = node.children.map((item)=>{
                if (isNext && item.type === "paragraph") {
                    const firstNode = item.children[0];
                    const text = firstNode.type === 'text' ? firstNode.value : '';
                    const reg = legacyTitle ? $e23aa99c2e71581e$var$alertLegacyRegex : $e23aa99c2e71581e$var$alertRegex;
                    const match = text.match(reg);
                    if (match) {
                        isNext = false;
                        alertType = match[1].toLocaleLowerCase();
                        title = legacyTitle ? match[2] || alertType.toLocaleUpperCase() : alertType.toLocaleUpperCase();
                        if (text.includes('\n')) item.children[0] = {
                            type: 'text',
                            value: text.replace(reg, '').replace(/^\n+/, '')
                        };
                        if (!text.includes('\n')) {
                            const itemChild = [];
                            item.children.forEach((item, idx)=>{
                                if (idx == 0) return;
                                if (idx == 1 && item.type === 'break') return;
                                itemChild.push(item);
                            });
                            item.children = [
                                ...itemChild
                            ];
                        }
                    }
                }
                return item;
            });
            if (!!alertType) {
                node.data = {
                    hName: tagName,
                    hProperties: {
                        class: `markdown-alert markdown-alert-${alertType}`,
                        dir: 'auto'
                    }
                };
                child.unshift({
                    type: "paragraph",
                    children: [
                        $e23aa99c2e71581e$export$48ba2a4751b6e66d(alertType),
                        {
                            type: "text",
                            value: title.replace(/^\//, '')
                        }
                    ],
                    data: {
                        hProperties: {
                            class: "markdown-alert-title",
                            dir: "auto"
                        }
                    }
                });
            }
            node.children = [
                ...child
            ];
        });
    };
};
var $e23aa99c2e71581e$export$2e2bcd8739ae039 = $e23aa99c2e71581e$export$a7abfbfd1870441d;
function $e23aa99c2e71581e$export$48ba2a4751b6e66d(type) {
    var _pathData_type;
    let pathD = (_pathData_type = $e23aa99c2e71581e$var$pathData[type]) !== null && _pathData_type !== void 0 ? _pathData_type : '';
    return {
        type: "emphasis",
        data: {
            hName: "svg",
            hProperties: {
                class: "octicon",
                viewBox: '0 0 16 16',
                width: '16',
                height: '16',
                ariaHidden: 'true'
            }
        },
        children: [
            {
                type: "emphasis",
                data: {
                    hName: "path",
                    hProperties: {
                        d: pathD
                    }
                },
                children: []
            }
        ]
    };
}
const $e23aa99c2e71581e$var$pathData = {
    note: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
    tip: 'M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z',
    important: 'M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
    warning: 'M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
    caution: 'M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z'
};


var $598ebbeaa9d76cf6$exports = {};
/**! 
 * @uiw/copy-to-clipboard v1.0.21 
 * Copy to clipboard. 
 * 
 * Copyright (c) 2026 Kenny Wang 
 * https://github.com/uiwjs/copy-to-clipboard.git 
 * 
 * @website: https://uiwjs.github.io/copy-to-clipboard
 
 * Licensed under the MIT license 
 */ (function(global, factory) {
    $598ebbeaa9d76cf6$exports = factory();
})($598ebbeaa9d76cf6$exports, function() {
    'use strict';
    /**
   * *** This styling is an extra step which is likely not required. ***
   * https://github.com/w3c/clipboard-apis/blob/master/explainer.adoc#writing-to-the-clipboard
   * 
   * Why is it here? To ensure:
   * 
   * 1. the element is able to have focus and selection.
   * 2. if element was to flash render it has minimal visual impact.
   * 3. less flakyness with selection and copying which **might** occur if
   *     the textarea element is not visible.
   *
   *   The likelihood is the element won't even render, not even a flash,
   *   so some of these are just precautions. However in IE the element
   *   is visible whilst the popup box asking the user for permission for
   *   the web page to copy to the clipboard.
   *  
   *   Place in top-left corner of screen regardless of scroll position.
   *
   * @typedef CopyTextToClipboard
   * @property {(text: string, method?: (isCopy: boolean) => void) => void} void
   * @returns {void}
   * 
   * @param {string} text 
   * @param {CopyTextToClipboard} cb 
   */ function copyTextToClipboard(text, cb) {
        if (typeof document === "undefined") return;
        const el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style = {
            position: 'absolute',
            left: '-9999px'
        };
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        let isCopy = false;
        try {
            const successful = document.execCommand('copy');
            isCopy = !!successful;
        } catch (err) {
            isCopy = false;
        }
        document.body.removeChild(el);
        if (selected && document.getSelection) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        cb && cb(isCopy);
    }
    return copyTextToClipboard;
});



var $7fPBF = parcelRequire("7fPBF");
function $dc74e42b6f513323$var$getParentElement(target) {
    if (!target) return null;
    var dom = target;
    if (dom.dataset.code && dom.classList.contains('copied')) return dom;
    if (dom.parentElement) return $dc74e42b6f513323$var$getParentElement(dom.parentElement);
    return null;
}
function $dc74e42b6f513323$export$89911e2cdbb3cf4e(container) {
    var handle = (event)=>{
        var target = $dc74e42b6f513323$var$getParentElement(event.target);
        if (!target) return;
        target.classList.add('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($598ebbeaa9d76cf6$exports)))(target.dataset.code, function() {
            setTimeout(()=>{
                target.classList.remove('active');
            }, 2000);
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        var _container$current, _container$current2;
        (_container$current = container.current) == null || _container$current.removeEventListener('click', handle, false);
        (_container$current2 = container.current) == null || _container$current2.addEventListener('click', handle, false);
        return ()=>{
            var _container$current3;
            (_container$current3 = container.current) == null || _container$current3.removeEventListener('click', handle, false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        container
    ]);
}




var $efac3f5f92b18b5b$var$_excluded = [
    "prefixCls",
    "className",
    "source",
    "style",
    "disableCopy",
    "skipHtml",
    "onScroll",
    "onMouseOver",
    "pluginsFilter",
    "rehypeRewrite",
    "wrapperElement",
    "warpperElement",
    "urlTransform"
];
var $efac3f5f92b18b5b$var$defaultUrlTransform = (url)=>url;
var $efac3f5f92b18b5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'wmde-markdown wmde-markdown-color' : _props$prefixCls, className = props.className, source = props.source, style = props.style, _props$disableCopy = props.disableCopy, disableCopy = _props$disableCopy === void 0 ? false : _props$disableCopy, _props$skipHtml = props.skipHtml, skipHtml = _props$skipHtml === void 0 ? true : _props$skipHtml, onScroll = props.onScroll, onMouseOver = props.onMouseOver, pluginsFilter = props.pluginsFilter, rewrite = props.rehypeRewrite, _props$wrapperElement = props.wrapperElement, wrapperElement = _props$wrapperElement === void 0 ? {} : _props$wrapperElement, _props$warpperElement = props.warpperElement, warpperElement = _props$warpperElement === void 0 ? {} : _props$warpperElement, urlTransform = props.urlTransform, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $efac3f5f92b18b5b$var$_excluded);
    var mdp = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
            mdp: mdp
        }), [
        mdp,
        props
    ]);
    var cls = (prefixCls || '') + " " + (className || '');
    (0, $dc74e42b6f513323$export$89911e2cdbb3cf4e)(mdp);
    var rehypePlugins = [
        ...other.rehypePlugins || []
    ];
    var customProps = {
        allowElement: (element, index, parent)=>{
            if (other.allowElement) return other.allowElement(element, index, parent);
            return /^[A-Za-z0-9]+$/.test(element.tagName);
        }
    };
    if (!skipHtml) rehypePlugins.push((0, $f9f41141c2cb11d3$export$2e2bcd8739ae039));
    var remarkPlugins = [
        (0, $e23aa99c2e71581e$export$a7abfbfd1870441d),
        ...other.remarkPlugins || [],
        (0, $78aec921ddca40c1$export$2e2bcd8739ae039)
    ];
    var wrapperProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, warpperElement, wrapperElement);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: mdp,
        onScroll: onScroll,
        onMouseOver: onMouseOver
    }, wrapperProps, {
        className: cls,
        style: style,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82a842773b01cef7$export$7460c8b7e4ce9582), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, customProps, other, {
            skipHtml: !skipHtml,
            urlTransform: urlTransform || $efac3f5f92b18b5b$var$defaultUrlTransform,
            rehypePlugins: pluginsFilter ? pluginsFilter('rehype', rehypePlugins) : rehypePlugins,
            remarkPlugins: pluginsFilter ? pluginsFilter('remark', remarkPlugins) : remarkPlugins,
            children: source || ''
        }))
    }));
});




var $616f52481ce12753$export$bcd9bd23ec5009d2 = function reservedMeta(options) {
    if (options === void 0) options = {};
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node)=>{
            if (node.type === 'element' && node.tagName === 'code' && node.data && node.data.meta) node.properties = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, node.properties, {
                'data-meta': String(node.data.meta)
            });
        });
    };
};



var $a9c851889f79086b$export$ff6de02db552a63 = function retrieveMeta(options) {
    if (options === void 0) options = {};
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node)=>{
            if (node.type === 'element' && node.tagName === 'code' && node.properties && node.properties['dataMeta']) {
                if (!node.data) node.data = {};
                var metaString = node.properties['dataMeta'];
                if (typeof metaString === 'string') node.data.meta = metaString;
                delete node.properties['dataMeta'];
            }
        });
    };
};



/**
 * @typedef {import('hast').Root} Root
 */ /**
 * @typedef Options
 *   Configuration (optional).
 * @property {string} [prefix='']
 *   Prefix to add in front of `id`s (default: `''`).
 */ // This module is generated by `script/`.
/* eslint-disable no-control-regex, no-misleading-character-class, no-useless-escape */ const $ae487c3cb68e5dd7$export$17b0f4d84dbfeedf = /[\0-\x1F!-,\.\/:-@\[-\^`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482\u0530\u0557\u0558\u055A-\u055F\u0589-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05EB-\u05EE\u05F3-\u060F\u061B-\u061F\u066A-\u066D\u06D4\u06DD\u06DE\u06E9\u06FD\u06FE\u0700-\u070F\u074B\u074C\u07B2-\u07BF\u07F6-\u07F9\u07FB\u07FC\u07FE\u07FF\u082E-\u083F\u085C-\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u08E2\u0964\u0965\u0970\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09F2-\u09FB\u09FD\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF0-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B70\u0B72-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BF0-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C7F\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D4F-\u0D53\u0D58-\u0D5E\u0D64\u0D65\u0D70-\u0D79\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF4-\u0E00\u0E3B-\u0E3F\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F17\u0F1A-\u0F1F\u0F2A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F48\u0F6D-\u0F70\u0F85\u0F98\u0FBD-\u0FC5\u0FC7-\u0FFF\u104A-\u104F\u109E\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u1360-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u170D\u1715-\u171F\u1735-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17D4-\u17D6\u17D8-\u17DB\u17DE\u17DF\u17EA-\u180A\u180E\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DA-\u19FF\u1A1C-\u1A1F\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B5A-\u1B6A\u1B74-\u1B7F\u1BF4-\u1BFF\u1C38-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CCF\u1CD3\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u203E\u2041-\u2053\u2055-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u20CF\u20F1-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u215F\u2189-\u24B5\u24EA-\u2BFF\u2C2F\u2C5F\u2CE5-\u2CEA\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E00-\u2E2E\u2E30-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u3040\u3097\u3098\u309B\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\u9FFD-\u9FFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA673\uA67E\uA6F2-\uA716\uA720\uA721\uA789\uA78A\uA7C0\uA7C1\uA7CB-\uA7F4\uA828-\uA82B\uA82D-\uA83F\uA874-\uA87F\uA8C6-\uA8CF\uA8DA-\uA8DF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA954-\uA95F\uA97D-\uA97F\uA9C1-\uA9CE\uA9DA-\uA9DF\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAAC3-\uAADA\uAADE\uAADF\uAAF0\uAAF1\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABEB\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFDFF\uFE10-\uFE1F\uFE30-\uFE32\uFE35-\uFE4C\uFE50-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF3E\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD3F\uDD75-\uDDFC\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEE1-\uDEFF\uDF20-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE40-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE7-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD28-\uDD2F\uDD3A-\uDE7F\uDEAA\uDEAD-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF51-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC47-\uDC65\uDC70-\uDC7E\uDCBB-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD40-\uDD43\uDD48-\uDD4F\uDD74\uDD75\uDD77-\uDD7F\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDFF\uDE12\uDE38-\uDE3D\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC4B-\uDC4F\uDC5A-\uDC5D\uDC62-\uDC7F\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDC1-\uDDD7\uDDDE-\uDDFF\uDE41-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF3A-\uDFFF]|\uD806[\uDC3B-\uDC9F\uDCEA-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD44-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE2\uDDE5-\uDDFF\uDE3F-\uDE46\uDE48-\uDE4F\uDE9A-\uDE9C\uDE9E-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC41-\uDC4F\uDC5A-\uDC71\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF7-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83D\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDECF\uDEEE\uDEEF\uDEF5-\uDEFF\uDF37-\uDF3F\uDF44-\uDF4F\uDF5A-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE2\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDC9C\uDC9F-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDEBF\uDEFA-\uDFFF]|\uD83A[\uDCC5-\uDCCF\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDD2F\uDD4A-\uDD4F\uDD6A-\uDD6F\uDD8A-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]/g;


const $4d58ce33fc36f101$var$own = Object.hasOwnProperty;
class $4d58ce33fc36f101$export$2e2bcd8739ae039 {
    /**
   * Generate a unique slug.
  *
  * Tracks previously generated slugs: repeated calls with the same value
  * will result in different slugs.
  * Use the `slug` function to get same slugs.
   *
   * @param  {string} value
   *   String of text to slugify
   * @param  {boolean} [maintainCase=false]
   *   Keep the current case, otherwise make all lowercase
   * @return {string}
   *   A unique slug string
   */ slug(value, maintainCase) {
        const self = this;
        let result = $4d58ce33fc36f101$export$74643d1fe038be1a(value, maintainCase === true);
        const originalSlug = result;
        while($4d58ce33fc36f101$var$own.call(self.occurrences, result)){
            self.occurrences[originalSlug]++;
            result = originalSlug + '-' + self.occurrences[originalSlug];
        }
        self.occurrences[result] = 0;
        return result;
    }
    /**
   * Reset - Forget all previous slugs
   *
   * @return void
   */ reset() {
        this.occurrences = Object.create(null);
    }
    /**
   * Create a new slug class.
   */ constructor(){
        /** @type {Record<string, number>} */ // eslint-disable-next-line no-unused-expressions
        this.occurrences;
        this.reset();
    }
}
function $4d58ce33fc36f101$export$74643d1fe038be1a(value, maintainCase) {
    if (typeof value !== 'string') return '';
    if (!maintainCase) value = value.toLowerCase();
    return value.replace((0, $ae487c3cb68e5dd7$export$17b0f4d84dbfeedf), '').replace(/ /g, '-');
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ /**
 * Get the rank (`1` to `6`) of headings (`h1` to `h6`).
 *
 * @param {Nodes} node
 *   Node to check.
 * @returns {number | undefined}
 *   Rank of the heading or `undefined` if not a heading.
 */ function $bcc3ef519e284ce4$export$82ce812bc3d95a0b(node) {
    const name = node.type === 'element' ? node.tagName.toLowerCase() : '';
    const code = name.length === 2 && name.charCodeAt(0) === 104 /* `h` */  ? name.charCodeAt(1) : 0;
    return code > 48 /* `0` */  && code < 55 /* `7` */  ? code - 48 /* `0` */  : undefined;
}




/** @type {Options} */ const $14d18d8874a9c57e$var$emptyOptions = {};
const $14d18d8874a9c57e$var$slugs = new (0, $4d58ce33fc36f101$export$2e2bcd8739ae039)();
function $14d18d8874a9c57e$export$2e2bcd8739ae039(options) {
    const settings = options || $14d18d8874a9c57e$var$emptyOptions;
    const prefix = settings.prefix || '';
    /**
   * @param {Root} tree
   *   Tree.
   * @returns {undefined}
   *   Nothing.
   */ return function(tree) {
        $14d18d8874a9c57e$var$slugs.reset();
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, 'element', function(node) {
            if ((0, $bcc3ef519e284ce4$export$82ce812bc3d95a0b)(node) && !node.properties.id) node.properties.id = prefix + $14d18d8874a9c57e$var$slugs.slug((0, $58714581718e6349$export$f84e8e69fd4488a5)(node));
        });
    };
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Root} Root
 *
 * @typedef {import('hast-util-is-element').Test} Test
 */ /**
 * @typedef {'after' | 'append' | 'before' | 'prepend' | 'wrap'} Behavior
 *   Behavior.
 *
 * @callback Build
 *   Generate content.
 * @param {Readonly<Element>} element
 *   Current heading.
 * @returns {Array<ElementContent> | ElementContent}
 *   Content.
 *
 * @callback BuildProperties
 *   Generate properties.
 * @param {Readonly<Element>} element
 *   Current heading.
 * @returns {Properties}
 *   Properties.
 *
 * @typedef Options
 *   Configuration.
 * @property {Behavior | null | undefined} [behavior='prepend']
 *   How to create links (default: `'prepend'`).
 * @property {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build | null | undefined} [content]
 *   Content to insert in the link (default: if `'wrap'` then `undefined`,
 *   otherwise `<span class="icon icon-link"></span>`);
 *   if `behavior` is `'wrap'` and `Build` is passed, its result replaces the
 *   existing content, otherwise the content is added after existing content.
 * @property {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build | null | undefined} [group]
 *   Content to wrap the heading and link with, if `behavior` is `'after'` or
 *   `'before'` (optional).
 * @property {Readonly<Properties> | BuildProperties | null | undefined} [headingProperties]
 *   Extra properties to set on the heading (optional).
 * @property {Readonly<Properties> | BuildProperties | null | undefined} [properties]
 *   Extra properties to set on the link when injecting (default:
 *   `{ariaHidden: true, tabIndex: -1}` if `'append'` or `'prepend'`, otherwise
 *   `undefined`).
 * @property {Test | null | undefined} [test]
 *   Extra test for which headings are linked (optional).
 */ /**
 * @template T
 *   Kind.
 * @typedef {(
 *   T extends Record<any, any>
 *     ? {-readonly [k in keyof T]: Cloneable<T[k]>}
 *     : T
 * )} Cloneable
 *   Deep clone.
 *
 *   See: <https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1237#issuecomment-1345515448>
 */ 



/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Parents} Parents
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is an element.
 * @param {unknown} this
 *   Context object (`this`) to call `test` with
 * @param {unknown} [element]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   Position of `element` in its parent.
 * @param {Parents | null | undefined} [parent]
 *   Parent of `element`.
 * @returns {boolean}
 *   Whether this is an element and passes a test.
 *
 * @typedef {Array<TestFunction | string> | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary element.
 *
 *   * when `string`, checks that the element has that tag name
 *   * when `function`, see `TestFunction`
 *   * when `Array`, checks if one of the subtests pass
 *
 * @callback TestFunction
 *   Check if an element passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Element} element
 *   An element.
 * @param {number | undefined} [index]
 *   Position of `element` in its parent.
 * @param {Parents | undefined} [parent]
 *   Parent of `element`.
 * @returns {boolean | undefined | void}
 *   Whether this element passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `element` is an `Element` and whether it passes the given test.
 *
 * @param element
 *   Thing to check, typically `element`.
 * @param test
 *   Check for a specific element.
 * @param index
 *   Position of `element` in its parent.
 * @param parent
 *   Parent of `element`.
 * @param context
 *   Context object (`this`) to call `test` with.
 * @returns
 *   Whether `element` is an `Element` and passes a test.
 * @throws
 *   When an incorrect `test`, `index`, or `parent` is given; there is no error
 *   thrown when `element` is not a node or not an element.
 */ const $209fa5866cc095a5$export$45a5e7f76e0caa8d = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends TestFunction>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(element: unknown, test: Condition, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((element?: null | undefined) => false) &
   *   ((element: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((element: unknown, test?: Test, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [element]
     * @param {Test | undefined} [test]
     * @param {number | null | undefined} [index]
     * @param {Parents | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(element, test, index, parent, context) {
    const check = $209fa5866cc095a5$export$26aad476166fd89e(test);
    if (index !== null && index !== undefined && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite `index`');
    if (parent !== null && parent !== undefined && (!parent.type || !parent.children)) throw new Error('Expected valid `parent`');
    if ((index === null || index === undefined) !== (parent === null || parent === undefined)) throw new Error('Expected both `index` and `parent`');
    return $209fa5866cc095a5$var$looksLikeAnElement(element) ? check.call(context, element, index, parent) : false;
};
const $209fa5866cc095a5$export$26aad476166fd89e = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test | null | undefined} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $209fa5866cc095a5$var$element;
    if (typeof test === 'string') return $209fa5866cc095a5$var$tagNameFactory(test);
    // Assume array.
    if (typeof test === 'object') return $209fa5866cc095a5$var$anyFactory(test);
    if (typeof test === 'function') return $209fa5866cc095a5$var$castFactory(test);
    throw new Error('Expected function, string, or array as `test`');
};
/**
 * Handle multiple tests.
 *
 * @param {Array<TestFunction | string>} tests
 * @returns {Check}
 */ function $209fa5866cc095a5$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $209fa5866cc095a5$export$26aad476166fd89e(tests[index]);
    return $209fa5866cc095a5$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn a string into a test for an element with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $209fa5866cc095a5$var$tagNameFactory(check) {
    return $209fa5866cc095a5$var$castFactory(tagName);
    /**
   * @param {Element} element
   * @returns {boolean}
   */ function tagName(element) {
        return element.tagName === check;
    }
}
/**
 * Turn a custom test into a test for an element that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $209fa5866cc095a5$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($209fa5866cc095a5$var$looksLikeAnElement(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
/**
 * Make sure something is an element.
 *
 * @param {unknown} element
 * @returns {element is Element}
 */ function $209fa5866cc095a5$var$element(element) {
    return Boolean(element && typeof element === 'object' && 'type' in element && element.type === 'element' && 'tagName' in element && typeof element.tagName === 'string');
}
/**
 * @param {unknown} value
 * @returns {value is Element}
 */ function $209fa5866cc095a5$var$looksLikeAnElement(value) {
    return value !== null && typeof value === 'object' && 'type' in value && 'tagName' in value;
}



/** @type {Element} */ const $8241da65474efe8a$var$contentDefaults = {
    type: 'element',
    tagName: 'span',
    properties: {
        className: [
            'icon',
            'icon-link'
        ]
    },
    children: []
};
/** @type {Options} */ const $8241da65474efe8a$var$emptyOptions = {};
function $8241da65474efe8a$export$2e2bcd8739ae039(options) {
    const settings = options || $8241da65474efe8a$var$emptyOptions;
    let properties = settings.properties;
    const headingOroperties = settings.headingProperties;
    const behavior = settings.behavior || 'prepend';
    const content = settings.content;
    const group = settings.group;
    const is = (0, $209fa5866cc095a5$export$26aad476166fd89e)(settings.test);
    /** @type {import('unist-util-visit').Visitor<Element>} */ let method;
    if (behavior === 'after' || behavior === 'before') method = around;
    else if (behavior === 'wrap') method = wrap;
    else {
        method = inject;
        if (!properties) properties = {
            ariaHidden: 'true',
            tabIndex: -1
        };
    }
    /**
   * Transform.
   *
   * @param {Root} tree
   *   Tree.
   * @returns {undefined}
   *   Nothing.
   */ return function(tree) {
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, 'element', function(node, index, parent) {
            if ((0, $bcc3ef519e284ce4$export$82ce812bc3d95a0b)(node) && node.properties.id && is(node, index, parent)) {
                Object.assign(node.properties, $8241da65474efe8a$var$toProperties(headingOroperties, node));
                return method(node, index, parent);
            }
        });
    };
    /** @type {import('unist-util-visit').Visitor<Element>} */ function inject(node) {
        const children = $8241da65474efe8a$var$toChildren(content || $8241da65474efe8a$var$contentDefaults, node);
        node.children[behavior === 'prepend' ? 'unshift' : 'push']($8241da65474efe8a$var$create(node, $8241da65474efe8a$var$toProperties(properties, node), children));
        return [
            (0, $9ef2eaca0b34953c$export$8773f85c2fb2c116)
        ];
    }
    /** @type {import('unist-util-visit').Visitor<Element>} */ function around(node, index, parent) {
        /* c8 ignore next -- uncommon */ if (typeof index !== 'number' || !parent) return;
        const children = $8241da65474efe8a$var$toChildren(content || $8241da65474efe8a$var$contentDefaults, node);
        const link = $8241da65474efe8a$var$create(node, $8241da65474efe8a$var$toProperties(properties, node), children);
        let nodes = behavior === 'before' ? [
            link,
            node
        ] : [
            node,
            link
        ];
        if (group) {
            const grouping = $8241da65474efe8a$var$toNode(group, node);
            if (grouping && !Array.isArray(grouping) && grouping.type === 'element') {
                grouping.children = nodes;
                nodes = [
                    grouping
                ];
            }
        }
        parent.children.splice(index, 1, ...nodes);
        return [
            (0, $9ef2eaca0b34953c$export$8773f85c2fb2c116),
            index + nodes.length
        ];
    }
    /** @type {import('unist-util-visit').Visitor<Element>} */ function wrap(node) {
        /** @type {Array<ElementContent>} */ let before = node.children;
        /** @type {Array<ElementContent> | ElementContent} */ let after = [];
        if (typeof content === 'function') {
            before = [];
            after = content(node);
        } else if (content) after = $8241da65474efe8a$var$clone(content);
        node.children = [
            $8241da65474efe8a$var$create(node, $8241da65474efe8a$var$toProperties(properties, node), Array.isArray(after) ? [
                ...before,
                ...after
            ] : [
                ...before,
                after
            ])
        ];
        return [
            (0, $9ef2eaca0b34953c$export$8773f85c2fb2c116)
        ];
    }
}
/**
 * Deep clone.
 *
 * @template T
 *   Kind.
 * @param {T} thing
 *   Thing to clone.
 * @returns {Cloneable<T>}
 *   Cloned thing.
 */ function $8241da65474efe8a$var$clone(thing) {
    // Cast because it’s mutable now.
    return /** @type {Cloneable<T>} */ (0, $e46c0242ff031819$export$2e2bcd8739ae039)(thing);
}
/**
 * Create an `a`.
 *
 * @param {Readonly<Element>} node
 *   Related heading.
 * @param {Properties | undefined} properties
 *   Properties to set on the link.
 * @param {Array<ElementContent>} children
 *   Content.
 * @returns {Element}
 *   Link.
 */ function $8241da65474efe8a$var$create(node, properties, children) {
    return {
        type: 'element',
        tagName: 'a',
        properties: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, properties), {
            href: '#' + node.properties.id
        }),
        children: children
    };
}
/**
 * Turn into children.
 *
 * @param {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build} value
 *   Content.
 * @param {Readonly<Element>} node
 *   Related heading.
 * @returns {Array<ElementContent>}
 *   Children.
 */ function $8241da65474efe8a$var$toChildren(value, node) {
    const result = $8241da65474efe8a$var$toNode(value, node);
    return Array.isArray(result) ? result : [
        result
    ];
}
/**
 * Turn into a node.
 *
 * @param {Readonly<ElementContent> | ReadonlyArray<ElementContent> | Build} value
 *   Content.
 * @param {Readonly<Element>} node
 *   Related heading.
 * @returns {Array<ElementContent> | ElementContent}
 *   Node.
 */ function $8241da65474efe8a$var$toNode(value, node) {
    if (typeof value === 'function') return value(node);
    return $8241da65474efe8a$var$clone(value);
}
/**
 * Turn into properties.
 *
 * @param {Readonly<Properties> | BuildProperties | null | undefined} value
 *   Properties.
 * @param {Readonly<Element>} node
 *   Related heading.
 * @returns {Properties}
 *   Properties.
 */ function $8241da65474efe8a$var$toProperties(value, node) {
    if (typeof value === 'function') return value(node);
    return value ? $8241da65474efe8a$var$clone(value) : {};
}



const $d3f2ca39d437ddf0$var$rehypeIgnore = (options = {})=>{
    const { openDelimiter: openDelimiter = 'rehype:ignore:start', closeDelimiter: closeDelimiter = 'rehype:ignore:end' } = options;
    return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, (node, index, parent)=>{
            if (node.type === 'element' || node.type === 'root') {
                // const start = node.children.findIndex((item) => item.type === 'comment' && item.value === openDelimiter);
                // const end = node.children.findIndex((item) => item.type === 'comment' && item.value === closeDelimiter);
                // if (start > -1 && end > -1) {
                //   node.children = node.children.filter((_, idx) => idx < start || idx > end);
                // }
                let start = false;
                node.children = node.children.filter((item)=>{
                    if (item.type === 'raw' || item.type === 'comment') {
                        let str = (item.value || '').trim();
                        str = str.replace(/^<!--(.*?)-->/, '$1');
                        if (str === openDelimiter) {
                            start = true;
                            return false;
                        }
                        if (str === closeDelimiter) {
                            start = false;
                            return false;
                        }
                    }
                    return !start;
                });
            }
        });
    };
};
var $d3f2ca39d437ddf0$export$2e2bcd8739ae039 = $d3f2ca39d437ddf0$var$rehypeIgnore;



var $38e354e0e68a1b87$export$923a4a02e333a06 = {
    type: 'element',
    tagName: 'svg',
    properties: {
        className: 'octicon octicon-link',
        viewBox: '0 0 16 16',
        version: '1.1',
        width: '16',
        height: '16',
        ariaHidden: 'true'
    },
    children: [
        {
            type: 'element',
            tagName: 'path',
            children: [],
            properties: {
                fillRule: 'evenodd',
                d: 'M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z'
            }
        }
    ]
};


function $8249f70436a6365a$export$9ffdecd63ef0d23f(str) {
    if (str === void 0) str = '';
    return {
        type: 'element',
        tagName: 'div',
        properties: {
            class: 'copied',
            'data-code': str
        },
        children: [
            {
                type: 'element',
                tagName: 'svg',
                properties: {
                    className: 'octicon-copy',
                    ariaHidden: 'true',
                    viewBox: '0 0 16 16',
                    fill: 'currentColor',
                    height: 12,
                    width: 12
                },
                children: [
                    {
                        type: 'element',
                        tagName: 'path',
                        properties: {
                            fillRule: 'evenodd',
                            d: 'M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z'
                        },
                        children: []
                    },
                    {
                        type: 'element',
                        tagName: 'path',
                        properties: {
                            fillRule: 'evenodd',
                            d: 'M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z'
                        },
                        children: []
                    }
                ]
            },
            {
                type: 'element',
                tagName: 'svg',
                properties: {
                    className: 'octicon-check',
                    ariaHidden: 'true',
                    viewBox: '0 0 16 16',
                    fill: 'currentColor',
                    height: 12,
                    width: 12
                },
                children: [
                    {
                        type: 'element',
                        tagName: 'path',
                        properties: {
                            fillRule: 'evenodd',
                            d: 'M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z'
                        },
                        children: []
                    }
                ]
            }
        ]
    };
}


var $1d3fc30d025817e1$export$44ff98c3c5f3f29e = (disableCopy, rewrite)=>(node, index, parent)=>{
        if (node.type === 'element' && parent && parent.type === 'root' && /h(1|2|3|4|5|6)/.test(node.tagName)) {
            var child = node.children && node.children[0];
            if (child && child.properties && child.properties.ariaHidden === 'true') {
                child.properties = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    class: 'anchor'
                }, child.properties);
                child.children = [
                    (0, $38e354e0e68a1b87$export$923a4a02e333a06)
                ];
            }
        }
        if (node.type === 'element' && node.tagName === 'pre' && !disableCopy) {
            var code = (0, $bcddeefdf0cb0501$export$fdc2b83d227adb1a)(node.children);
            node.children.push((0, $8249f70436a6365a$export$9ffdecd63ef0d23f)(code));
        }
        rewrite && rewrite(node, index === null ? undefined : index, parent === null ? undefined : parent);
    };
var $1d3fc30d025817e1$export$bf2258f12d8e13f4 = [
    (0, $14d18d8874a9c57e$export$2e2bcd8739ae039),
    (0, $8241da65474efe8a$export$2e2bcd8739ae039),
    (0, $d3f2ca39d437ddf0$export$2e2bcd8739ae039)
];





var $7b0fa6cba31fe01a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
    var _props$disableCopy;
    var rehypePlugins = [
        (0, $616f52481ce12753$export$bcd9bd23ec5009d2),
        (0, $f9f41141c2cb11d3$export$2e2bcd8739ae039),
        (0, $a9c851889f79086b$export$ff6de02db552a63),
        ...(0, $1d3fc30d025817e1$export$bf2258f12d8e13f4),
        [
            (0, $bcddeefdf0cb0501$export$2e2bcd8739ae039),
            {
                rewrite: (0, $1d3fc30d025817e1$export$44ff98c3c5f3f29e)((_props$disableCopy = props.disableCopy) != null ? _props$disableCopy : false, props.rehypeRewrite)
            }
        ],
        [
            (0, $d80b7298c6dd9c3b$export$2e2bcd8739ae039),
            {
                properties: 'attr'
            }
        ],
        ...props.rehypePlugins || [],
        [
            (0, $f6a8c10565706ab2$export$2e2bcd8739ae039),
            {
                ignoreMissing: true
            }
        ]
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efac3f5f92b18b5b$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
        rehypePlugins: rehypePlugins,
        ref: ref
    }));
});


function $53471605b9d4580f$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}



var $7fPBF = parcelRequire("7fPBF");
// Note: types exposed from `index.d.ts`
/**
 * @import {Root} from 'hast'
 * @import {Options as FromHtmlOptions} from 'hast-util-from-html'
 * @import {Parser, Processor} from 'unified'
 */ /**
 * @typedef {Omit<FromHtmlOptions, 'onerror'> & RehypeParseFields} Options
 *   Configuration.
 *
 * @typedef RehypeParseFields
 *   Extra fields.
 * @property {boolean | null | undefined} [emitParseErrors=false]
 *   Whether to emit parse errors while parsing (default: `false`).
 *
 *   > 👉 **Note**: parse errors are currently being added to HTML.
 *   > Not all errors emitted by parse5 (or us) are specced yet.
 *   > Some documentation may still be missing.
 */ 


/**
 * @import {Root} from 'hast'
 * @import {ParserError} from 'parse5'
 * @import {Value} from 'vfile'
 * @import {ErrorCode, Options} from './types.js'
 */ 




/**
 * @typedef ErrorInfo
 *   Info on a `parse5` error.
 * @property {string} reason
 *   Reason of error.
 * @property {string} description
 *   More info on error.
 * @property {false} [url]
 *   Turn off if this is not documented in the html5 spec (optional).
 */ const $ccbec9718b6e8588$export$30f3b02011db23c0 = {
    /** @type {ErrorInfo} */ abandonedHeadElementChild: {
        reason: 'Unexpected metadata element after head',
        description: 'Unexpected element after head. Expected the element before `</head>`',
        url: false
    },
    /** @type {ErrorInfo} */ abruptClosingOfEmptyComment: {
        reason: 'Unexpected abruptly closed empty comment',
        description: 'Unexpected `>` or `->`. Expected `-->` to close comments'
    },
    /** @type {ErrorInfo} */ abruptDoctypePublicIdentifier: {
        reason: 'Unexpected abruptly closed public identifier',
        description: 'Unexpected `>`. Expected a closing `"` or `\'` after the public identifier'
    },
    /** @type {ErrorInfo} */ abruptDoctypeSystemIdentifier: {
        reason: 'Unexpected abruptly closed system identifier',
        description: 'Unexpected `>`. Expected a closing `"` or `\'` after the identifier identifier'
    },
    /** @type {ErrorInfo} */ absenceOfDigitsInNumericCharacterReference: {
        reason: 'Unexpected non-digit at start of numeric character reference',
        description: 'Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references'
    },
    /** @type {ErrorInfo} */ cdataInHtmlContent: {
        reason: 'Unexpected CDATA section in HTML',
        description: 'Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead'
    },
    /** @type {ErrorInfo} */ characterReferenceOutsideUnicodeRange: {
        reason: 'Unexpected too big numeric character reference',
        description: 'Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)'
    },
    /** @type {ErrorInfo} */ closingOfElementWithOpenChildElements: {
        reason: 'Unexpected closing tag with open child elements',
        description: 'Unexpectedly closing tag. Expected other tags to be closed first',
        url: false
    },
    /** @type {ErrorInfo} */ controlCharacterInInputStream: {
        reason: 'Unexpected control character',
        description: 'Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace'
    },
    /** @type {ErrorInfo} */ controlCharacterReference: {
        reason: 'Unexpected control character reference',
        description: 'Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace'
    },
    /** @type {ErrorInfo} */ disallowedContentInNoscriptInHead: {
        reason: 'Disallowed content inside `<noscript>` in `<head>`',
        description: 'Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`',
        url: false
    },
    /** @type {ErrorInfo} */ duplicateAttribute: {
        reason: 'Unexpected duplicate attribute',
        description: 'Unexpectedly double attribute. Expected attributes to occur only once'
    },
    /** @type {ErrorInfo} */ endTagWithAttributes: {
        reason: 'Unexpected attribute on closing tag',
        description: 'Unexpected attribute. Expected `>` instead'
    },
    /** @type {ErrorInfo} */ endTagWithTrailingSolidus: {
        reason: 'Unexpected slash at end of closing tag',
        description: 'Unexpected `%c-1`. Expected `>` instead'
    },
    /** @type {ErrorInfo} */ endTagWithoutMatchingOpenElement: {
        reason: 'Unexpected unopened end tag',
        description: 'Unexpected end tag. Expected no end tag or another end tag',
        url: false
    },
    /** @type {ErrorInfo} */ eofBeforeTagName: {
        reason: 'Unexpected end of file',
        description: 'Unexpected end of file. Expected tag name instead'
    },
    /** @type {ErrorInfo} */ eofInCdata: {
        reason: 'Unexpected end of file in CDATA',
        description: 'Unexpected end of file. Expected `]]>` to close the CDATA'
    },
    /** @type {ErrorInfo} */ eofInComment: {
        reason: 'Unexpected end of file in comment',
        description: 'Unexpected end of file. Expected `-->` to close the comment'
    },
    /** @type {ErrorInfo} */ eofInDoctype: {
        reason: 'Unexpected end of file in doctype',
        description: 'Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)'
    },
    /** @type {ErrorInfo} */ eofInElementThatCanContainOnlyText: {
        reason: 'Unexpected end of file in element that can only contain text',
        description: 'Unexpected end of file. Expected text or a closing tag',
        url: false
    },
    /** @type {ErrorInfo} */ eofInScriptHtmlCommentLikeText: {
        reason: 'Unexpected end of file in comment inside script',
        description: 'Unexpected end of file. Expected `-->` to close the comment'
    },
    /** @type {ErrorInfo} */ eofInTag: {
        reason: 'Unexpected end of file in tag',
        description: 'Unexpected end of file. Expected `>` to close the tag'
    },
    /** @type {ErrorInfo} */ incorrectlyClosedComment: {
        reason: 'Incorrectly closed comment',
        description: 'Unexpected `%c-1`. Expected `-->` to close the comment'
    },
    /** @type {ErrorInfo} */ incorrectlyOpenedComment: {
        reason: 'Incorrectly opened comment',
        description: 'Unexpected `%c`. Expected `<!--` to open the comment'
    },
    /** @type {ErrorInfo} */ invalidCharacterSequenceAfterDoctypeName: {
        reason: 'Invalid sequence after doctype name',
        description: 'Unexpected sequence at `%c`. Expected `public` or `system`'
    },
    /** @type {ErrorInfo} */ invalidFirstCharacterOfTagName: {
        reason: 'Invalid first character in tag name',
        description: 'Unexpected `%c`. Expected an ASCII letter instead'
    },
    /** @type {ErrorInfo} */ misplacedDoctype: {
        reason: 'Misplaced doctype',
        description: 'Unexpected doctype. Expected doctype before head',
        url: false
    },
    /** @type {ErrorInfo} */ misplacedStartTagForHeadElement: {
        reason: 'Misplaced `<head>` start tag',
        description: 'Unexpected start tag `<head>`. Expected `<head>` directly after doctype',
        url: false
    },
    /** @type {ErrorInfo} */ missingAttributeValue: {
        reason: 'Missing attribute value',
        description: 'Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead'
    },
    /** @type {ErrorInfo} */ missingDoctype: {
        reason: 'Missing doctype before other content',
        description: 'Expected a `<!doctype html>` before anything else',
        url: false
    },
    /** @type {ErrorInfo} */ missingDoctypeName: {
        reason: 'Missing doctype name',
        description: 'Unexpected doctype end at `%c`. Expected `html` instead'
    },
    /** @type {ErrorInfo} */ missingDoctypePublicIdentifier: {
        reason: 'Missing public identifier in doctype',
        description: 'Unexpected `%c`. Expected identifier for `public` instead'
    },
    /** @type {ErrorInfo} */ missingDoctypeSystemIdentifier: {
        reason: 'Missing system identifier in doctype',
        description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
    },
    /** @type {ErrorInfo} */ missingEndTagName: {
        reason: 'Missing name in end tag',
        description: 'Unexpected `%c`. Expected an ASCII letter instead'
    },
    /** @type {ErrorInfo} */ missingQuoteBeforeDoctypePublicIdentifier: {
        reason: 'Missing quote before public identifier in doctype',
        description: 'Unexpected `%c`. Expected `"` or `\'` instead'
    },
    /** @type {ErrorInfo} */ missingQuoteBeforeDoctypeSystemIdentifier: {
        reason: 'Missing quote before system identifier in doctype',
        description: 'Unexpected `%c`. Expected `"` or `\'` instead'
    },
    /** @type {ErrorInfo} */ missingSemicolonAfterCharacterReference: {
        reason: 'Missing semicolon after character reference',
        description: 'Unexpected `%c`. Expected `;` instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceAfterDoctypePublicKeyword: {
        reason: 'Missing whitespace after public identifier in doctype',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceAfterDoctypeSystemKeyword: {
        reason: 'Missing whitespace after system identifier in doctype',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceBeforeDoctypeName: {
        reason: 'Missing whitespace before doctype name',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceBetweenAttributes: {
        reason: 'Missing whitespace between attributes',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
        reason: 'Missing whitespace between public and system identifiers in doctype',
        description: 'Unexpected `%c`. Expected ASCII whitespace instead'
    },
    /** @type {ErrorInfo} */ nestedComment: {
        reason: 'Unexpected nested comment',
        description: 'Unexpected `<!--`. Expected `-->`'
    },
    /** @type {ErrorInfo} */ nestedNoscriptInHead: {
        reason: 'Unexpected nested `<noscript>` in `<head>`',
        description: 'Unexpected `<noscript>`. Expected a closing tag or a meta element',
        url: false
    },
    /** @type {ErrorInfo} */ nonConformingDoctype: {
        reason: 'Unexpected non-conforming doctype declaration',
        description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
        url: false
    },
    /** @type {ErrorInfo} */ nonVoidHtmlElementStartTagWithTrailingSolidus: {
        reason: 'Unexpected trailing slash on start tag of non-void element',
        description: 'Unexpected `/`. Expected `>` instead'
    },
    /** @type {ErrorInfo} */ noncharacterCharacterReference: {
        reason: 'Unexpected noncharacter code point referenced by character reference',
        description: 'Unexpected code point. Do not use noncharacters in HTML'
    },
    /** @type {ErrorInfo} */ noncharacterInInputStream: {
        reason: 'Unexpected noncharacter character',
        description: 'Unexpected code point `%x`. Do not use noncharacters in HTML'
    },
    /** @type {ErrorInfo} */ nullCharacterReference: {
        reason: 'Unexpected NULL character referenced by character reference',
        description: 'Unexpected code point. Do not use NULL characters in HTML'
    },
    /** @type {ErrorInfo} */ openElementsLeftAfterEof: {
        reason: 'Unexpected end of file',
        description: 'Unexpected end of file. Expected closing tag instead',
        url: false
    },
    /** @type {ErrorInfo} */ surrogateCharacterReference: {
        reason: 'Unexpected surrogate character referenced by character reference',
        description: 'Unexpected code point. Do not use lone surrogate characters in HTML'
    },
    /** @type {ErrorInfo} */ surrogateInInputStream: {
        reason: 'Unexpected surrogate character',
        description: 'Unexpected code point `%x`. Do not use lone surrogate characters in HTML'
    },
    /** @type {ErrorInfo} */ unexpectedCharacterAfterDoctypeSystemIdentifier: {
        reason: 'Invalid character after system identifier in doctype',
        description: 'Unexpected character at `%c`. Expected `>`'
    },
    /** @type {ErrorInfo} */ unexpectedCharacterInAttributeName: {
        reason: 'Unexpected character in attribute name',
        description: 'Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter'
    },
    /** @type {ErrorInfo} */ unexpectedCharacterInUnquotedAttributeValue: {
        reason: 'Unexpected character in unquoted attribute value',
        description: 'Unexpected `%c`. Quote the attribute value to include it'
    },
    /** @type {ErrorInfo} */ unexpectedEqualsSignBeforeAttributeName: {
        reason: 'Unexpected equals sign before attribute name',
        description: 'Unexpected `%c`. Add an attribute name before it'
    },
    /** @type {ErrorInfo} */ unexpectedNullCharacter: {
        reason: 'Unexpected NULL character',
        description: 'Unexpected code point `%x`. Do not use NULL characters in HTML'
    },
    /** @type {ErrorInfo} */ unexpectedQuestionMarkInsteadOfTagName: {
        reason: 'Unexpected question mark instead of tag name',
        description: 'Unexpected `%c`. Expected an ASCII letter instead'
    },
    /** @type {ErrorInfo} */ unexpectedSolidusInTag: {
        reason: 'Unexpected slash in tag',
        description: 'Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value'
    },
    /** @type {ErrorInfo} */ unknownNamedCharacterReference: {
        reason: 'Unexpected unknown named character reference',
        description: 'Unexpected character reference. Expected known named character references'
    }
};


const $171d02596f0a6171$var$base = 'https://html.spec.whatwg.org/multipage/parsing.html#parse-error-';
const $171d02596f0a6171$var$dashToCamelRe = /-[a-z]/g;
const $171d02596f0a6171$var$formatCRe = /%c(?:([-+])(\d+))?/g;
const $171d02596f0a6171$var$formatXRe = /%x/g;
const $171d02596f0a6171$var$fatalities = {
    2: true,
    1: false,
    0: null
};
/** @type {Readonly<Options>} */ const $171d02596f0a6171$var$emptyOptions = {};
function $171d02596f0a6171$export$657711bc6c3b0a5b(value, options) {
    const settings = options || $171d02596f0a6171$var$emptyOptions;
    const onerror = settings.onerror;
    const file = value instanceof (0, $365ad175729fa366$export$93dff69eb10dc7ce) ? value : new (0, $365ad175729fa366$export$93dff69eb10dc7ce)(value);
    const parseFunction = settings.fragment ? (0, $7822c393005c8687$export$e1152f5efcc82ad) : (0, $7822c393005c8687$export$98e6a39c04603d36);
    const document = String(file);
    const p5Document = parseFunction(document, {
        sourceCodeLocationInfo: true,
        // Note `parse5` types currently do not allow `undefined`.
        onParseError: settings.onerror ? internalOnerror : null,
        scriptingEnabled: false
    });
    // `parse5` returns document which are always mapped to roots.
    return /** @type {Root} */ (0, $73bde87d01cc5621$export$371ddbe92c872127)(p5Document, {
        file: file,
        space: settings.space,
        verbose: settings.verbose
    });
    /**
   * Handle a parse error.
   *
   * @param {ParserError} error
   *   Parse5 error.
   * @returns {undefined}
   *   Nothing.
   */ function internalOnerror(error) {
        const code = error.code;
        const name = $171d02596f0a6171$var$camelcase(code);
        const setting = settings[name];
        const config = setting === null || setting === undefined ? true : setting;
        const level = typeof config === 'number' ? config : config ? 1 : 0;
        if (level) {
            const info = (0, $ccbec9718b6e8588$export$30f3b02011db23c0)[name];
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(info, 'expected known error from `parse5`');
            const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)(format(info.reason), {
                place: {
                    start: {
                        line: error.startLine,
                        column: error.startCol,
                        offset: error.startOffset
                    },
                    end: {
                        line: error.endLine,
                        column: error.endCol,
                        offset: error.endOffset
                    }
                },
                ruleId: code,
                source: 'hast-util-from-html'
            });
            if (file.path) {
                message.file = file.path;
                message.name = file.path + ':' + message.name;
            }
            message.fatal = $171d02596f0a6171$var$fatalities[level];
            message.note = format(info.description);
            message.url = info.url === false ? undefined : $171d02596f0a6171$var$base + code;
            (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(onerror, '`internalOnerror` is not passed if `onerror` is not set');
            onerror(message);
        }
        /**
     * Format a human readable string about an error.
     *
     * @param {string} value
     *   Value to format.
     * @returns {string}
     *   Formatted.
     */ function format(value) {
            return value.replace($171d02596f0a6171$var$formatCRe, formatC).replace($171d02596f0a6171$var$formatXRe, formatX);
            /**
       * Format the character.
       *
       * @param {string} _
       *   Match.
       * @param {string} $1
       *   Sign (`-` or `+`, optional).
       * @param {string} $2
       *   Offset.
       * @returns {string}
       *   Formatted.
       */ function formatC(_, $1, $2) {
                const offset = ($2 ? Number.parseInt($2, 10) : 0) * ($1 === '-' ? -1 : 1);
                const char = document.charAt(error.startOffset + offset);
                return $171d02596f0a6171$var$visualizeCharacter(char);
            }
            /**
       * Format the character code.
       *
       * @returns {string}
       *   Formatted.
       */ function formatX() {
                return $171d02596f0a6171$var$visualizeCharacterCode(document.charCodeAt(error.startOffset));
            }
        }
    }
}
/**
 * @param {string} value
 *   Error code in dash case.
 * @returns {ErrorCode}
 *   Error code in camelcase.
 */ function $171d02596f0a6171$var$camelcase(value) {
    // This should match an error code.
    return /** @type {ErrorCode} */ value.replace($171d02596f0a6171$var$dashToCamelRe, $171d02596f0a6171$var$dashToCamel);
}
/**
 * @param {string} $0
 *   Match.
 * @returns {string}
 *   Camelcased.
 */ function $171d02596f0a6171$var$dashToCamel($0) {
    return $0.charAt(1).toUpperCase();
}
/**
 * @param {string} char
 *   Character.
 * @returns {string}
 *   Formatted.
 */ function $171d02596f0a6171$var$visualizeCharacter(char) {
    return char === '`' ? '` ` `' : char;
}
/**
 * @param {number} charCode
 *   Character code.
 * @returns {string}
 *   Formatted.
 */ function $171d02596f0a6171$var$visualizeCharacterCode(charCode) {
    return '0x' + charCode.toString(16).toUpperCase();
}


function $8d8ab2772df59c2a$export$2e2bcd8739ae039(options) {
    /** @type {Processor<Root>} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    const _ref = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, self.data('settings'), options), { emitParseErrors: emitParseErrors } = _ref, settings = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
        "emitParseErrors"
    ]);
    self.parser = parser;
    /**
   * @type {Parser<Root>}
   */ function parser(document, file) {
        return (0, $171d02596f0a6171$export$657711bc6c3b0a5b)(document, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, settings), {
            onerror: emitParseErrors ? function(message) {
                if (file.path) {
                    message.name = file.path + ':' + message.name;
                    message.file = file.path;
                }
                file.messages.push(message);
            } : undefined
        }));
    }
}


/**
 * @import {Root} from 'hast'
 * @import {Options} from 'hast-util-to-html'
 * @import {Compiler, Processor} from 'unified'
 */ 
/**
 * @import {Nodes, Parents, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 * @import {Options as StringifyEntitiesOptions} from 'stringify-entities'
 */ /**
 * @typedef {Omit<StringifyEntitiesOptions, 'attribute' | 'escapeOnly' | 'subset'>} CharacterReferences
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [allowDangerousCharacters=false]
 *   Do not encode some characters which cause XSS vulnerabilities in older
 *   browsers (default: `false`).
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Allow `raw` nodes and insert them as raw HTML (default: `false`).
 *
 *   When `false`, `Raw` nodes are encoded.
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowParseErrors=false]
 *   Do not encode characters which cause parse errors (even though they work),
 *   to save bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [bogusComments=false]
 *   Use “bogus comments” instead of comments to save byes: `<?charlie>`
 *   instead of `<!--charlie-->` (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {CharacterReferences | null | undefined} [characterReferences]
 *   Configure how to serialize character references (optional).
 * @property {boolean | null | undefined} [closeEmptyElements=false]
 *   Close SVG elements without any content with slash (`/`) on the opening tag
 *   instead of an end tag: `<circle />` instead of `<circle></circle>`
 *   (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the HTML space.
 * @property {boolean | null | undefined} [closeSelfClosing=false]
 *   Close self-closing nodes with an extra slash (`/`): `<img />` instead of
 *   `<img>` (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [collapseEmptyAttributes=false]
 *   Collapse empty attributes: get `class` instead of `class=""` (default:
 *   `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: boolean attributes (such as `hidden`) are always collapsed.
 * @property {boolean | null | undefined} [omitOptionalTags=false]
 *   Omit optional opening and closing tags (default: `false`).
 *
 *   For example, in `<ol><li>one</li><li>two</li></ol>`, both `</li>` closing
 *   tags can be omitted.
 *   The first because it’s followed by another `li`, the last because it’s
 *   followed by nothing.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [preferUnquoted=false]
 *   Leave attributes unquoted if that results in less bytes (default: `false`).
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [quoteSmart=false]
 *   Use the other quote if that results in less bytes (default: `false`).
 * @property {Quote | null | undefined} [quote='"']
 *   Preferred quote to use (default: `'"'`).
 * @property {Space | null | undefined} [space='html']
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it (default: `'html'`).
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use [`xast`][xast] if you need to support SVG as XML.
 * @property {boolean | null | undefined} [tightAttributes=false]
 *   Join attributes together, without whitespace, if possible: get
 *   `class="a b"title="c d"` instead of `class="a b" title="c d"` to save
 *   bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightCommaSeparatedLists=false]
 *   Join known comma-separated attribute values with just a comma (`,`),
 *   instead of padding them on the right as well (`,␠`, where `␠` represents a
 *   space) (default: `false`).
 * @property {boolean | null | undefined} [tightDoctype=false]
 *   Drop unneeded spaces in doctypes: `<!doctypehtml>` instead of
 *   `<!doctype html>` to save bytes (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightSelfClosing=false]
 *   Do not use an extra space when closing self-closing elements: `<img/>`
 *   instead of `<img />` (default: `false`).
 *
 *   > 👉 **Note**: only used if `closeSelfClosing: true` or
 *   > `closeEmptyElements: true`.
 * @property {boolean | null | undefined} [upperDoctype=false]
 *   Use a `<!DOCTYPE…` instead of `<!doctype…` (default: `false`).
 *
 *   Useless except for XHTML.
 * @property {ReadonlyArray<string> | null | undefined} [voids]
 *   Tag names of elements to serialize without closing tag (default: `html-void-elements`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: It’s highly unlikely that you want to pass this, because
 *   > hast is not for XML, and HTML will not add more void elements.
 *
 * @typedef {'"' | "'"} Quote
 *   HTML quotes for attribute values.
 *
 * @typedef {Omit<Required<{[key in keyof Options]: Exclude<Options[key], null | undefined>}>, 'space' | 'quote'>} Settings
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Parents | undefined) => string} all
 *   Serialize the children of a parent node.
 * @property {Quote} alternative
 *   Alternative quote.
 * @property {(node: Nodes, index: number | undefined, parent: Parents | undefined) => string} one
 *   Serialize one node.
 * @property {Quote} quote
 *   Preferred quote.
 * @property {Schema} schema
 *   Current schema.
 * @property {Settings} settings
 *   User configuration.
 */ 

/**
 * @import {Nodes, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ 
/**
 * @import {Comment, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ /**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $410b843dad1a1135$var$defaultSubsetRegex = /["&'<>`]/g;
const $410b843dad1a1135$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $410b843dad1a1135$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $410b843dad1a1135$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $410b843dad1a1135$var$subsetToRegexCache = new WeakMap();
function $410b843dad1a1135$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $410b843dad1a1135$var$charactersToExpressionCached(options.subset) : $410b843dad1a1135$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($410b843dad1a1135$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($410b843dad1a1135$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $410b843dad1a1135$var$charactersToExpressionCached(subset) {
    let cached = $410b843dad1a1135$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $410b843dad1a1135$var$charactersToExpression(subset);
        $410b843dad1a1135$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $410b843dad1a1135$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($410b843dad1a1135$var$regexEscapeRegex, '\\$&'));
    return new RegExp('(?:' + groups.join('|') + ')', 'g');
}


/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ const $cf86d5c85b816fed$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $cf86d5c85b816fed$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = '&#x' + code.toString(16).toUpperCase();
    return omit && next && !$cf86d5c85b816fed$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


const $65294a4e137377e3$var$decimalRegex = /\d/;
function $65294a4e137377e3$export$63ad841d70774900(code, next, omit) {
    const value = '&#' + String(code);
    return omit && next && !$65294a4e137377e3$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}



/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $eddcd7cb7275dd15$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: '&',
    lt: '<',
    gt: '>',
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};


/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $4ed18c9e25dcc553$export$39b76096d2f1d598 = [
    'cent',
    'copy',
    'divide',
    'gt',
    'lt',
    'not',
    'para',
    'times'
];


const $6e20758df27af6be$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $6e20758df27af6be$var$characters = {};
/** @type {string} */ let $6e20758df27af6be$var$key;
for($6e20758df27af6be$var$key in 0, $eddcd7cb7275dd15$export$40952e41c47e8e55)if ($6e20758df27af6be$var$own.call((0, $eddcd7cb7275dd15$export$40952e41c47e8e55), $6e20758df27af6be$var$key)) $6e20758df27af6be$var$characters[(0, $eddcd7cb7275dd15$export$40952e41c47e8e55)[$6e20758df27af6be$var$key]] = $6e20758df27af6be$var$key;
const $6e20758df27af6be$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $6e20758df27af6be$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($6e20758df27af6be$var$own.call($6e20758df27af6be$var$characters, character)) {
        const name = $6e20758df27af6be$var$characters[character];
        const value = '&' + name;
        if (omit && (0, $9d441a8e4486a83e$export$9545335bdecb4b8c).includes(name) && !(0, $4ed18c9e25dcc553$export$39b76096d2f1d598).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $6e20758df27af6be$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ';';
    }
    return '';
}


function $270a3d583edee730$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $cf86d5c85b816fed$export$ef12b12fd64fa3cc)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $6e20758df27af6be$export$b1e14dcd42472e57)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $65294a4e137377e3$export$63ad841d70774900)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}


/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $3bd3ec3028ea85fe$export$83cfa611e0071208(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


function $4306eeea4ecd9ecc$export$aca9de459d63ca2e(value, options) {
    return (0, $410b843dad1a1135$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $270a3d583edee730$export$f53904683bee23d7)
    }, options));
}
function $4306eeea4ecd9ecc$export$a2577b9dadf100a3(value, options) {
    return (0, $410b843dad1a1135$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $3bd3ec3028ea85fe$export$83cfa611e0071208)
    }, options));
}


const $b4ee3be9337e6748$var$htmlCommentRegex = /^>|^->|<!--|-->|--!>|<!-$/g;
// Declare arrays as variables so it can be cached by `stringifyEntities`
const $b4ee3be9337e6748$var$bogusCommentEntitySubset = [
    '>'
];
const $b4ee3be9337e6748$var$commentEntitySubset = [
    '<',
    '>'
];
function $b4ee3be9337e6748$export$4a34f930e789283c(node, _1, _2, state) {
    // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>
    return state.settings.bogusComments ? '<?' + (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $b4ee3be9337e6748$var$bogusCommentEntitySubset
    })) + '>' : '<!--' + node.value.replace($b4ee3be9337e6748$var$htmlCommentRegex, encode) + '-->';
    /**
   * @param {string} $0
   */ function encode($0) {
        return (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)($0, Object.assign({}, state.settings.characterReferences, {
            subset: $b4ee3be9337e6748$var$commentEntitySubset
        }));
    }
}


/**
 * @import {Doctype, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a doctype.
 *
 * @param {Doctype} _1
 *   Node to handle.
 * @param {number | undefined} _2
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _3
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $3cb60d8884f767f1$export$3c172dfa1c27da99(_1, _2, _3, state) {
    return '<!' + (state.settings.upperDoctype ? 'DOCTYPE' : 'doctype') + (state.settings.tightDoctype ? '' : ' ') + 'html>';
}


/**
 * @import {Element, Parents, Properties} from 'hast'
 * @import {State} from '../index.js'
 */ 




/**
 * @import {Element, Parents} from 'hast'
 */ 
/**
 * @import {Parents, RootContent} from 'hast'
 */ 
const $3eeeab5c3692c755$export$a0f7cf204d8f22ba = $3eeeab5c3692c755$var$siblings(1);
const $3eeeab5c3692c755$export$b103c35f55382246 = $3eeeab5c3692c755$var$siblings(-1);
/** @type {Array<RootContent>} */ const $3eeeab5c3692c755$var$emptyChildren = [];
/**
 * Factory to check siblings in a direction.
 *
 * @param {number} increment
 */ function $3eeeab5c3692c755$var$siblings(increment) {
    return sibling;
    /**
   * Find applicable siblings in a direction.
   *
   * @template {Parents} Parent
   *   Parent type.
   * @param {Parent | undefined} parent
   *   Parent.
   * @param {number | undefined} index
   *   Index of child in `parent`.
   * @param {boolean | undefined} [includeWhitespace=false]
   *   Whether to include whitespace (default: `false`).
   * @returns {Parent extends {children: Array<infer Child>} ? Child | undefined : never}
   *   Child of parent.
   */ function sibling(parent, index, includeWhitespace) {
        const siblings = parent ? parent.children : $3eeeab5c3692c755$var$emptyChildren;
        let offset = (index || 0) + increment;
        let next = siblings[offset];
        if (!includeWhitespace) while(next && (0, $99728b3b7e804493$export$7af1228ff777d175)(next)){
            offset += increment;
            next = siblings[offset];
        }
        // @ts-expect-error: it’s a correct child.
        return next;
    }
}


/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @callback OmitHandle
 *   Check if a tag can be omitted.
 * @param {Element} element
 *   Element to check.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether to omit a tag.
 *
 */ const $f3ca3f1fb2337dc6$var$own = {}.hasOwnProperty;
function $f3ca3f1fb2337dc6$export$67d072dabf9c1c63(handlers) {
    return omit;
    /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */ function omit(node, index, parent) {
        return $f3ca3f1fb2337dc6$var$own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
    }
}


const $cf67feaaa0a6d0be$export$4e69df80cd44263b = (0, $f3ca3f1fb2337dc6$export$67d072dabf9c1c63)({
    body: $cf67feaaa0a6d0be$var$body,
    caption: $cf67feaaa0a6d0be$var$headOrColgroupOrCaption,
    colgroup: $cf67feaaa0a6d0be$var$headOrColgroupOrCaption,
    dd: $cf67feaaa0a6d0be$var$dd,
    dt: $cf67feaaa0a6d0be$var$dt,
    head: $cf67feaaa0a6d0be$var$headOrColgroupOrCaption,
    html: $cf67feaaa0a6d0be$var$html,
    li: $cf67feaaa0a6d0be$var$li,
    optgroup: $cf67feaaa0a6d0be$var$optgroup,
    option: $cf67feaaa0a6d0be$var$option,
    p: $cf67feaaa0a6d0be$var$p,
    rp: $cf67feaaa0a6d0be$var$rubyElement,
    rt: $cf67feaaa0a6d0be$var$rubyElement,
    tbody: $cf67feaaa0a6d0be$var$tbody,
    td: $cf67feaaa0a6d0be$var$cells,
    tfoot: $cf67feaaa0a6d0be$var$tfoot,
    th: $cf67feaaa0a6d0be$var$cells,
    thead: $cf67feaaa0a6d0be$var$thead,
    tr: $cf67feaaa0a6d0be$var$tr
});
/**
 * Macro for `</head>`, `</colgroup>`, and `</caption>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$headOrColgroupOrCaption(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index, true);
    return !next || next.type !== 'comment' && !(next.type === 'text' && (0, $99728b3b7e804493$export$7af1228ff777d175)(next.value.charAt(0)));
}
/**
 * Whether to omit `</html>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$html(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</body>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$body(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</p>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$p(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return next ? next.type === 'element' && (next.tagName === 'address' || next.tagName === 'article' || next.tagName === 'aside' || next.tagName === 'blockquote' || next.tagName === 'details' || next.tagName === 'div' || next.tagName === 'dl' || next.tagName === 'fieldset' || next.tagName === 'figcaption' || next.tagName === 'figure' || next.tagName === 'footer' || next.tagName === 'form' || next.tagName === 'h1' || next.tagName === 'h2' || next.tagName === 'h3' || next.tagName === 'h4' || next.tagName === 'h5' || next.tagName === 'h6' || next.tagName === 'header' || next.tagName === 'hgroup' || next.tagName === 'hr' || next.tagName === 'main' || next.tagName === 'menu' || next.tagName === 'nav' || next.tagName === 'ol' || next.tagName === 'p' || next.tagName === 'pre' || next.tagName === 'section' || next.tagName === 'table' || next.tagName === 'ul') : !parent || // Confusing parent.
    !(parent.type === 'element' && (parent.tagName === 'a' || parent.tagName === 'audio' || parent.tagName === 'del' || parent.tagName === 'ins' || parent.tagName === 'map' || parent.tagName === 'noscript' || parent.tagName === 'video'));
}
/**
 * Whether to omit `</li>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$li(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'li';
}
/**
 * Whether to omit `</dt>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$dt(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd'));
}
/**
 * Whether to omit `</dd>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$dd(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd');
}
/**
 * Whether to omit `</rt>` or `</rp>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$rubyElement(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'rp' || next.tagName === 'rt');
}
/**
 * Whether to omit `</optgroup>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$optgroup(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'optgroup';
}
/**
 * Whether to omit `</option>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$option(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'option' || next.tagName === 'optgroup');
}
/**
 * Whether to omit `</thead>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$thead(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot'));
}
/**
 * Whether to omit `</tbody>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$tbody(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot');
}
/**
 * Whether to omit `</tfoot>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$tfoot(_, index, parent) {
    return !(0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
}
/**
 * Whether to omit `</tr>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$tr(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'tr';
}
/**
 * Whether to omit `</td>` or `</th>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $cf67feaaa0a6d0be$var$cells(_, index, parent) {
    const next = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'td' || next.tagName === 'th');
}


/**
 * @import {Element, Parents} from 'hast'
 */ 



const $be39f1a58e7b8fed$export$47fa9d71658d4a69 = (0, $f3ca3f1fb2337dc6$export$67d072dabf9c1c63)({
    body: $be39f1a58e7b8fed$var$body,
    colgroup: $be39f1a58e7b8fed$var$colgroup,
    head: $be39f1a58e7b8fed$var$head,
    html: $be39f1a58e7b8fed$var$html,
    tbody: $be39f1a58e7b8fed$var$tbody
});
/**
 * Whether to omit `<html>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$html(node) {
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1);
    return !head || head.type !== 'comment';
}
/**
 * Whether to omit `<head>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$head(node) {
    /** @type {Set<string>} */ const seen = new Set();
    // Whether `srcdoc` or not,
    // make sure the content model at least doesn’t have too many `base`s/`title`s.
    for (const child of node.children)if (child.type === 'element' && (child.tagName === 'base' || child.tagName === 'title')) {
        if (seen.has(child.tagName)) return false;
        seen.add(child.tagName);
    }
    // “May be omitted if the element is empty,
    // or if the first thing inside the head element is an element.”
    const child = node.children[0];
    return !child || child.type === 'element';
}
/**
 * Whether to omit `<body>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$body(node) {
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1, true);
    return !head || head.type !== 'comment' && !(head.type === 'text' && (0, $99728b3b7e804493$export$7af1228ff777d175)(head.value.charAt(0))) && !(head.type === 'element' && (head.tagName === 'meta' || head.tagName === 'link' || head.tagName === 'script' || head.tagName === 'style' || head.tagName === 'template'));
}
/**
 * Whether to omit `<colgroup>`.
 * The spec describes some logic for the opening tag, but it’s easier to
 * implement in the closing tag, to the same effect, so we handle it there
 * instead.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$colgroup(node, index, parent) {
    const previous = (0, $3eeeab5c3692c755$export$b103c35f55382246)(parent, index);
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1, true);
    // Previous colgroup was already omitted.
    if (parent && previous && previous.type === 'element' && previous.tagName === 'colgroup' && (0, $cf67feaaa0a6d0be$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'col');
}
/**
 * Whether to omit `<tbody>`.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $be39f1a58e7b8fed$var$tbody(node, index, parent) {
    const previous = (0, $3eeeab5c3692c755$export$b103c35f55382246)(parent, index);
    const head = (0, $3eeeab5c3692c755$export$a0f7cf204d8f22ba)(node, -1);
    // Previous table section was already omitted.
    if (parent && previous && previous.type === 'element' && (previous.tagName === 'thead' || previous.tagName === 'tbody') && (0, $cf67feaaa0a6d0be$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'tr');
}


/**
 * Maps of subsets.
 *
 * Each value is a matrix of tuples.
 * The value at `0` causes parse errors, the value at `1` is valid.
 * Of both, the value at `0` is unsafe, and the value at `1` is safe.
 *
 * @type {Record<'double' | 'name' | 'single' | 'unquoted', Array<[Array<string>, Array<string>]>>}
 */ const $241c439d722cfb1b$var$constants = {
    // See: <https://html.spec.whatwg.org/#attribute-name-state>.
    name: [
        [
            '\t\n\f\r &/=>'.split(''),
            '\t\n\f\r "&\'/=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'/<=>'.split(''),
            '\0\t\n\f\r "&\'/<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
    unquoted: [
        [
            '\t\n\f\r &>'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'<=>`'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
    single: [
        [
            "&'".split(''),
            '"&\'`'.split('')
        ],
        [
            "\0&'".split(''),
            '\0"&\'`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
    double: [
        [
            '"&'.split(''),
            '"&\'`'.split('')
        ],
        [
            '\0"&'.split(''),
            '\0"&\'`'.split('')
        ]
    ]
};
function $241c439d722cfb1b$export$8454457683f90105(node, index, parent, state) {
    const schema = state.schema;
    const omit = schema.space === 'svg' ? false : state.settings.omitOptionalTags;
    let selfClosing = schema.space === 'svg' ? state.settings.closeEmptyElements : state.settings.voids.includes(node.tagName.toLowerCase());
    /** @type {Array<string>} */ const parts = [];
    /** @type {string} */ let last;
    if (schema.space === 'html' && node.tagName === 'svg') state.schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
    const attributes = $241c439d722cfb1b$var$serializeAttributes(state, node.properties);
    const content = state.all(schema.space === 'html' && node.tagName === 'template' ? node.content : node);
    state.schema = schema;
    // If the node is categorised as void, but it has children, remove the
    // categorisation.
    // This enables for example `menuitem`s, which are void in W3C HTML but not
    // void in WHATWG HTML, to be stringified properly.
    // Note: `menuitem` has since been removed from the HTML spec, and so is no
    // longer void.
    if (content) selfClosing = false;
    if (attributes || !omit || !(0, $be39f1a58e7b8fed$export$47fa9d71658d4a69)(node, index, parent)) {
        parts.push('<', node.tagName, attributes ? ' ' + attributes : '');
        if (selfClosing && (schema.space === 'svg' || state.settings.closeSelfClosing)) {
            last = attributes.charAt(attributes.length - 1);
            if (!state.settings.tightSelfClosing || last === '/' || last && last !== '"' && last !== "'") parts.push(' ');
            parts.push('/');
        }
        parts.push('>');
    }
    parts.push(content);
    if (!selfClosing && (!omit || !(0, $cf67feaaa0a6d0be$export$4e69df80cd44263b)(node, index, parent))) parts.push('</' + node.tagName + '>');
    return parts.join('');
}
/**
 * @param {State} state
 * @param {Properties | null | undefined} properties
 * @returns {string}
 */ function $241c439d722cfb1b$var$serializeAttributes(state, properties) {
    /** @type {Array<string>} */ const values = [];
    let index = -1;
    /** @type {string} */ let key;
    if (properties) {
        for(key in properties)if (properties[key] !== null && properties[key] !== undefined) {
            const value = $241c439d722cfb1b$var$serializeAttribute(state, key, properties[key]);
            if (value) values.push(value);
        }
    }
    while(++index < values.length){
        const last = state.settings.tightAttributes ? values[index].charAt(values[index].length - 1) : undefined;
        // In tight mode, don’t add a space after quoted attributes.
        if (index !== values.length - 1 && last !== '"' && last !== "'") values[index] += ' ';
    }
    return values.join('');
}
/**
 * @param {State} state
 * @param {string} key
 * @param {Properties[keyof Properties]} value
 * @returns {string}
 */ function $241c439d722cfb1b$var$serializeAttribute(state, key, value) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(state.schema, key);
    const x = state.settings.allowParseErrors && state.schema.space === 'html' ? 0 : 1;
    const y = state.settings.allowDangerousCharacters ? 0 : 1;
    let quote = state.quote;
    /** @type {string | undefined} */ let result;
    if (info.overloadedBoolean && (value === info.attribute || value === '')) value = true;
    else if ((info.boolean || info.overloadedBoolean) && (typeof value !== 'string' || value === info.attribute || value === '')) value = Boolean(value);
    if (value === null || value === undefined || value === false || typeof value === 'number' && Number.isNaN(value)) return '';
    const name = (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(info.attribute, Object.assign({}, state.settings.characterReferences, {
        // Always encode without parse errors in non-HTML.
        subset: $241c439d722cfb1b$var$constants.name[x][y]
    }));
    // No value.
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (Firefox, Safari, Chrome),
    // so I can’t test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/main/lib/svg.js>
    if (value === true) return name;
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = Array.isArray(value) ? (info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737))(value, {
        padLeft: !state.settings.tightCommaSeparatedLists
    }) : String(value);
    if (state.settings.collapseEmptyAttributes && !value) return name;
    // Check unquoted value.
    if (state.settings.preferUnquoted) result = (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
        attribute: true,
        subset: $241c439d722cfb1b$var$constants.unquoted[x][y]
    }));
    // If we don’t want unquoted, or if `value` contains character references when
    // unquoted…
    if (result !== value) {
        // If the alternative is less common than `quote`, switch.
        if (state.settings.quoteSmart && (0, $b227513681bd728a$export$fa42eaa97a352e23)(value, quote) > (0, $b227513681bd728a$export$fa42eaa97a352e23)(value, state.alternative)) quote = state.alternative;
        result = quote + (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
            // Always encode without parse errors in non-HTML.
            subset: (quote === "'" ? $241c439d722cfb1b$var$constants.single : $241c439d722cfb1b$var$constants.double)[x][y],
            attribute: true
        })) + quote;
    }
    // Don’t add a `=` for unquoted empties.
    return name + (result ? '=' + result : result);
}


/**
 * @import {Parents} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ /**
 * @import {Parents, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ 
// Declare array as variable so it can be cached by `stringifyEntities`
const $3d3056a7327d61ed$var$textEntitySubset = [
    '<',
    '&'
];
function $3d3056a7327d61ed$export$6f093cfa640b7166(node, _, parent, state) {
    // Check if content of `node` should be escaped.
    return parent && parent.type === 'element' && (parent.tagName === 'script' || parent.tagName === 'style') ? node.value : (0, $4306eeea4ecd9ecc$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $3d3056a7327d61ed$var$textEntitySubset
    }));
}


function $6d731af9aee87b6d$export$1776c186c69df29e(node, index, parent, state) {
    return state.settings.allowDangerousHtml ? node.value : (0, $3d3056a7327d61ed$export$6f093cfa640b7166)(node, index, parent, state);
}


/**
 * @import {Parents, Root} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a root.
 *
 * @param {Root} node
 *   Node to handle.
 * @param {number | undefined} _1
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _2
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $32787891ae5202c8$export$e8e78c978b129247(node, _1, _2, state) {
    return state.all(node);
}



const $63d36365cefda5e3$export$8f34ce051745d39e = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
    invalid: $63d36365cefda5e3$var$invalid,
    unknown: $63d36365cefda5e3$var$unknown,
    handlers: {
        comment: $b4ee3be9337e6748$export$4a34f930e789283c,
        doctype: $3cb60d8884f767f1$export$3c172dfa1c27da99,
        element: $241c439d722cfb1b$export$8454457683f90105,
        raw: $6d731af9aee87b6d$export$1776c186c69df29e,
        root: $32787891ae5202c8$export$e8e78c978b129247,
        text: $3d3056a7327d61ed$export$6f093cfa640b7166
    }
});
/**
 * Fail when a non-node is found in the tree.
 *
 * @param {unknown} node
 *   Unknown value.
 * @returns {never}
 *   Never.
 */ function $63d36365cefda5e3$var$invalid(node) {
    throw new Error('Expected node, not `' + node + '`');
}
/**
 * Fail when a node with an unknown type is found in the tree.
 *
 * @param {unknown} node_
 *  Unknown node.
 * @returns {never}
 *   Never.
 */ function $63d36365cefda5e3$var$unknown(node_) {
    // `type` is guaranteed by runtime JS.
    const node = /** @type {Nodes} */ node_;
    throw new Error('Cannot compile unknown node `' + node.type + '`');
}


/** @type {Options} */ const $b6819b5b1a8bddcd$var$emptyOptions = {};
/** @type {CharacterReferences} */ const $b6819b5b1a8bddcd$var$emptyCharacterReferences = {};
/** @type {Array<never>} */ const $b6819b5b1a8bddcd$var$emptyChildren = [];
function $b6819b5b1a8bddcd$export$a10125c086a4df16(tree, options) {
    const options_ = options || $b6819b5b1a8bddcd$var$emptyOptions;
    const quote = options_.quote || '"';
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error('Invalid quote `' + quote + '`, expected `\'` or `"`');
    /** @type {State} */ const state = {
        one: $b6819b5b1a8bddcd$var$one,
        all: $b6819b5b1a8bddcd$export$84bf76cd7afc7469,
        settings: {
            omitOptionalTags: options_.omitOptionalTags || false,
            allowParseErrors: options_.allowParseErrors || false,
            allowDangerousCharacters: options_.allowDangerousCharacters || false,
            quoteSmart: options_.quoteSmart || false,
            preferUnquoted: options_.preferUnquoted || false,
            tightAttributes: options_.tightAttributes || false,
            upperDoctype: options_.upperDoctype || false,
            tightDoctype: options_.tightDoctype || false,
            bogusComments: options_.bogusComments || false,
            tightCommaSeparatedLists: options_.tightCommaSeparatedLists || false,
            tightSelfClosing: options_.tightSelfClosing || false,
            collapseEmptyAttributes: options_.collapseEmptyAttributes || false,
            allowDangerousHtml: options_.allowDangerousHtml || false,
            voids: options_.voids || (0, $fe4fce3fd1fee116$export$762508062d068de),
            characterReferences: options_.characterReferences || $b6819b5b1a8bddcd$var$emptyCharacterReferences,
            closeSelfClosing: options_.closeSelfClosing || false,
            closeEmptyElements: options_.closeEmptyElements || false
        },
        schema: options_.space === 'svg' ? (0, $cad208d20be39d74$export$7ed1367e7fa1ad68) : (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        quote: quote,
        alternative: alternative
    };
    return state.one(Array.isArray(tree) ? {
        type: 'root',
        children: tree
    } : tree, undefined, undefined);
}
/**
 * Serialize a node.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   Node to handle.
 * @param {number | undefined} index
 *   Index of `node` in `parent.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {string}
 *   Serialized node.
 */ function $b6819b5b1a8bddcd$var$one(node, index, parent) {
    return (0, $63d36365cefda5e3$export$8f34ce051745d39e)(node, index, parent, this);
}
function $b6819b5b1a8bddcd$export$84bf76cd7afc7469(parent) {
    /** @type {Array<string>} */ const results = [];
    const children = parent && parent.children || $b6819b5b1a8bddcd$var$emptyChildren;
    let index = -1;
    while(++index < children.length)results[index] = this.one(children[index], index, parent);
    return results.join('');
}


function $bbf894dfad4e2855$export$2e2bcd8739ae039(options) {
    /** @type {Processor<undefined, undefined, undefined, Root, string>} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    const settings = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, self.data('settings'), options);
    self.compiler = compiler;
    /**
   * @type {Compiler<Root, string>}
   */ function compiler(tree) {
        return (0, $b6819b5b1a8bddcd$export$a10125c086a4df16)(tree, settings);
    }
}



const $896ab3348b7fb05e$export$3c91a9a75d9d4e1f = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $8d8ab2772df59c2a$export$2e2bcd8739ae039)).use((0, $bbf894dfad4e2855$export$2e2bcd8739ae039)).freeze();





var $7fPBF = parcelRequire("7fPBF");
function $7c2cb0ce17642c75$export$1650419e431d3ba3(state, action) {
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, action);
}
var $7c2cb0ce17642c75$export$27b8dd149e32f6c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    markdown: ''
});



var $3b1c409df4bde24b$var$_templateObject;
function $3b1c409df4bde24b$var$html2Escape(sHtml) {
    return sHtml// .replace(/```(\w+)?([\s\S]*?)(\s.+)?```/g, (str: string) => {
    //   return str.replace(
    //     /[<&"]/g,
    //     (c: string) => (({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' } as Record<string, string>)[c]),
    //   );
    // })
    .replace(/[<&"]/g, (c)=>({
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            '"': '&quot;'
        })[c]);
}
function $3b1c409df4bde24b$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls;
    var _useContext = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), _useContext$markdown = _useContext.markdown, markdown = _useContext$markdown === void 0 ? '' : _useContext$markdown, highlightEnable = _useContext.highlightEnable, dispatch = _useContext.dispatch;
    var preRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createRef();
    (0, $7fPBF.useEffect)(()=>{
        if (preRef.current && dispatch) dispatch({
            textareaPre: preRef.current
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!markdown) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pre", {
        ref: preRef,
        className: prefixCls + "-text-pre wmde-markdown-color"
    });
    var mdStr = "<pre class=\"language-markdown " + prefixCls + "-text-pre wmde-markdown-color\"><code class=\"language-markdown\">" + $3b1c409df4bde24b$var$html2Escape(String.raw($3b1c409df4bde24b$var$_templateObject || ($3b1c409df4bde24b$var$_templateObject = (0, $53471605b9d4580f$export$2e2bcd8739ae039)([
        "",
        ""
    ])), markdown)) + "\n</code></pre>";
    if (highlightEnable) try {
        mdStr = (0, $896ab3348b7fb05e$export$3c91a9a75d9d4e1f)().data('settings', {
            fragment: true
        })// https://github.com/uiwjs/react-md-editor/issues/593
        // @ts-ignore
        .use((0, $f6a8c10565706ab2$export$2e2bcd8739ae039), {
            ignoreMissing: true
        }).processSync(mdStr).toString();
    } catch (error) {}
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('div', {
        className: 'wmde-markdown-color',
        dangerouslySetInnerHTML: {
            __html: mdStr || ''
        }
    });
}





var $7fPBF = parcelRequire("7fPBF");


function $291b77f2b248d49a$var$getCommands(data, resulte) {
    if (data === void 0) data = [];
    if (resulte === void 0) resulte = {};
    data.forEach((item)=>{
        if (item.children && Array.isArray(item.children)) resulte = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, resulte, $291b77f2b248d49a$var$getCommands(item.children || []));
        else if (item.keyCommand && item.shortcuts && item.execute) resulte[item.shortcuts.toLocaleLowerCase()] = item;
    });
    return resulte;
}
function $291b77f2b248d49a$export$2e2bcd8739ae039(e, commands, commandOrchestrator, dispatch, state) {
    if (commands === void 0) commands = [];
    var data = $291b77f2b248d49a$var$getCommands(commands || []);
    var shortcuts = [];
    if (e.altKey) shortcuts.push('alt');
    if (e.shiftKey) shortcuts.push('shift');
    if (e.metaKey) shortcuts.push('cmd');
    if (e.ctrlKey) shortcuts.push('ctrl');
    if (shortcuts.length > 0 && !/(control|alt|meta|shift)/.test(e.key.toLocaleLowerCase())) shortcuts.push(e.key.toLocaleLowerCase());
    if (/escape/.test(e.key.toLocaleLowerCase())) shortcuts.push('escape');
    if (shortcuts.length < 1) return;
    var equal = !!data[shortcuts.join('+')];
    var command = equal ? data[shortcuts.join('+')] : undefined;
    Object.keys(data).forEach((item)=>{
        var isequal = item.split('+').every((v)=>{
            if (/ctrlcmd/.test(v)) return shortcuts.includes('ctrl') || shortcuts.includes('cmd');
            return shortcuts.includes(v);
        });
        if (isequal) command = data[item];
    });
    if (command && commandOrchestrator) {
        e.stopPropagation();
        e.preventDefault();
        commandOrchestrator.executeCommand(command, dispatch, state, shortcuts);
        return;
    }
}





var $7fPBF = parcelRequire("7fPBF");


/**
 * The MIT License
 * Copyright (c) 2018 Dmitriy Kubyshkin
 * Copied from https://github.com/grassator/insert-text-at-cursor
 */ var $cd79195d1a384c19$var$browserSupportsTextareaTextNodes;
/**
 * @param {HTMLElement} input
 * @return {boolean}
 */ function $cd79195d1a384c19$var$canManipulateViaTextNodes(input) {
    if (input.nodeName !== 'TEXTAREA') return false;
    if (typeof $cd79195d1a384c19$var$browserSupportsTextareaTextNodes === 'undefined') {
        var textarea = document.createElement('textarea');
        textarea.value = '1';
        $cd79195d1a384c19$var$browserSupportsTextareaTextNodes = !!textarea.firstChild;
    }
    return $cd79195d1a384c19$var$browserSupportsTextareaTextNodes;
}
function $cd79195d1a384c19$export$7d6189efbd20bf69(input, text) {
    // Most of the used APIs only work with the field selected
    input.focus();
    // IE 8-10
    if (document.selection) {
        var ieRange = document.selection.createRange();
        ieRange.text = text;
        // Move cursor after the inserted text
        ieRange.collapse(false);
        ieRange.select();
        return;
    }
    // Webkit + Edge
    var isSuccess = false;
    if (text !== '') isSuccess = document.execCommand && document.execCommand('insertText', false, text);
    else isSuccess = document.execCommand && document.execCommand('delete', false);
    if (!isSuccess) {
        var start = input.selectionStart;
        var end = input.selectionEnd;
        // Firefox (non-standard method)
        if (typeof input.setRangeText === 'function') input.setRangeText(text);
        else {
            // To make a change we just need a Range, not a Selection
            var range = document.createRange();
            var textNode = document.createTextNode(text);
            if ($cd79195d1a384c19$var$canManipulateViaTextNodes(input)) {
                var node = input.firstChild;
                // If textarea is empty, just insert the text
                if (!node) input.appendChild(textNode);
                else {
                    // Otherwise we need to find a nodes for start and end
                    var offset = 0;
                    var startNode = null;
                    var endNode = null;
                    while(node && (startNode === null || endNode === null)){
                        var nodeLength = node.nodeValue.length;
                        // if start of the selection falls into current node
                        if (start >= offset && start <= offset + nodeLength) range.setStart(startNode = node, start - offset);
                        // if end of the selection falls into current node
                        if (end >= offset && end <= offset + nodeLength) range.setEnd(endNode = node, end - offset);
                        offset += nodeLength;
                        node = node.nextSibling;
                    }
                    // If there is some text selected, remove it as we should replace it
                    if (start !== end) range.deleteContents();
                }
            }
            // If the node is a textarea and the range doesn't span outside the element
            //
            // Get the commonAncestorContainer of the selected range and test its type
            // If the node is of type `#text` it means that we're still working with text nodes within our textarea element
            // otherwise, if it's of type `#document` for example it means our selection spans outside the textarea.
            if ($cd79195d1a384c19$var$canManipulateViaTextNodes(input) && range.commonAncestorContainer.nodeName === '#text') // Finally insert a new node. The browser will automatically split start and end nodes into two if necessary
            range.insertNode(textNode);
            else {
                // If the node is not a textarea or the range spans outside a textarea the only way is to replace the whole value
                var value = input.value;
                input.value = value.slice(0, start) + text + value.slice(end);
            }
        }
        // Correct the cursor position to be at the end of the insertion
        input.setSelectionRange(start + text.length, start + text.length);
        // Notify any possible listeners of the change
        var e = document.createEvent('UIEvent');
        e.initEvent('input', true, false);
        input.dispatchEvent(e);
    }
}


parcelRequire("7fPBF");
function $57170ec975fca5ef$export$bc597f78f9f82ed0(_ref) {
    var text = _ref.text, selection = _ref.selection, prefix = _ref.prefix, _ref$suffix = _ref.suffix, suffix = _ref$suffix === void 0 ? prefix : _ref$suffix;
    var result = selection;
    if (text && text.length && selection.start === selection.end) result = $57170ec975fca5ef$export$669c0d5c0b374917(text, selection.start);
    if (result.start >= prefix.length && result.end <= text.length - suffix.length) {
        var selectedTextContext = text.slice(result.start - prefix.length, result.end + suffix.length);
        if (selectedTextContext.startsWith(prefix) && selectedTextContext.endsWith(suffix)) return {
            start: result.start - prefix.length,
            end: result.end + suffix.length
        };
    }
    return result;
}
function $57170ec975fca5ef$export$e41c12847640c21(_ref2) {
    var text = _ref2.text, selection = _ref2.selection;
    var start = text.slice(0, selection.start).lastIndexOf('\n') + 1;
    var end = text.slice(selection.end).indexOf('\n') + selection.end;
    if (end === selection.end - 1) end = text.length;
    return {
        start: start,
        end: end
    };
}
function $57170ec975fca5ef$export$7a6ac73908e24730(text, startPosition) {
    if (text === void 0) text = '';
    if (startPosition === 0) return 0;
    // rules:
    // - If we're in the first line, no breaks are needed
    // - Otherwise there must be 2 breaks before the previous character. Depending on how many breaks exist already, we
    //      may need to insert 0, 1 or 2 breaks
    var neededBreaks = 2;
    var isInFirstLine = true;
    for(var i = startPosition - 1; i >= 0 && neededBreaks >= 0; i--)switch(text.charCodeAt(i)){
        case 32:
            continue;
        case 10:
            // line break
            neededBreaks--;
            isInFirstLine = false;
            break;
        default:
            return neededBreaks;
    }
    return isInFirstLine ? 0 : neededBreaks;
}
function $57170ec975fca5ef$export$ac47e5b3b6484ab3(text, startPosition) {
    if (text === void 0) text = '';
    if (startPosition === text.length - 1) return 0;
    // rules:
    // - If we're in the first line, no breaks are needed
    // - Otherwise there must be 2 breaks before the previous character. Depending on how many breaks exist already, we
    //      may need to insert 0, 1 or 2 breaks
    var neededBreaks = 2;
    var isInLastLine = true;
    for(var i = startPosition; i < text.length && neededBreaks >= 0; i++)switch(text.charCodeAt(i)){
        case 32:
            continue;
        case 10:
            neededBreaks--;
            isInLastLine = false;
            break;
        default:
            return neededBreaks;
    }
    return isInLastLine ? 0 : neededBreaks;
}
function $57170ec975fca5ef$export$669c0d5c0b374917(text, position) {
    if (!text) throw Error("Argument 'text' should be truthy");
    var isWordDelimiter = (c)=>c === ' ' || c.charCodeAt(0) === 10;
    // leftIndex is initialized to 0 because if selection is 0, it won't even enter the iteration
    var start = 0;
    // rightIndex is initialized to text.length because if selection is equal to text.length it won't even enter the interation
    var end = text.length;
    // iterate to the left
    for(var i = position; i - 1 > -1; i--)if (isWordDelimiter(text[i - 1])) {
        start = i;
        break;
    }
    // iterate to the right
    for(var _i = position; _i < text.length; _i++)if (isWordDelimiter(text[_i])) {
        end = _i;
        break;
    }
    return {
        start: start,
        end: end
    };
}
function $57170ec975fca5ef$export$3d4c04ed49431392(_ref3) {
    var api = _ref3.api, selectedText = _ref3.selectedText, selection = _ref3.selection, prefix = _ref3.prefix, _ref3$suffix = _ref3.suffix, suffix = _ref3$suffix === void 0 ? prefix : _ref3$suffix;
    if (selectedText.length >= prefix.length + suffix.length && selectedText.startsWith(prefix) && selectedText.endsWith(suffix)) {
        api.replaceSelection(selectedText.slice(prefix.length, suffix.length ? -suffix.length : undefined));
        api.setSelectionRange({
            start: selection.start - prefix.length,
            end: selection.end - prefix.length
        });
    } else {
        api.replaceSelection("" + prefix + selectedText + suffix);
        api.setSelectionRange({
            start: selection.start + prefix.length,
            end: selection.end + prefix.length
        });
    }
}
function $57170ec975fca5ef$export$296d1daf426952fd(selectedText, insertBefore) {
    var lines = selectedText.split(/\n/);
    var insertionLength = 0;
    var modifiedText = lines.map((item, index)=>{
        if (typeof insertBefore === 'string') {
            if (item.startsWith(insertBefore)) {
                insertionLength -= insertBefore.length;
                return item.slice(insertBefore.length);
            }
            insertionLength += insertBefore.length;
            return insertBefore + item;
        }
        if (typeof insertBefore === 'function') {
            if (item.startsWith(insertBefore(item, index))) {
                insertionLength -= insertBefore(item, index).length;
                return item.slice(insertBefore(item, index).length);
            }
            var insertionResult = insertBefore(item, index);
            insertionLength += insertionResult.length;
            return insertBefore(item, index) + item;
        }
        throw Error('insertion is expected to be either a string or a function');
    }).join('\n');
    return {
        modifiedText: modifiedText,
        insertionLength: insertionLength
    };
}



var $1b1be813ac69f87a$export$73ba5813cda80a49 = {
    name: 'bold',
    keyCommand: 'bold',
    shortcuts: 'ctrlcmd+b',
    prefix: '**',
    buttonProps: {
        'aria-label': 'Add bold text (ctrl + b)',
        title: 'Add bold text (ctrl + b)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        role: "img",
        width: "12",
        height: "12",
        viewBox: "0 0 384 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix
        });
    }
};


parcelRequire("7fPBF");


var $53482fb090606392$export$7bb0d5c671655cc4 = {
    name: 'codeBlock',
    keyCommand: 'codeBlock',
    shortcuts: 'ctrlcmd+shift+j',
    prefix: '```',
    buttonProps: {
        'aria-label': 'Insert Code Block (ctrl + shift + j)',
        title: 'Insert Code Block (ctrl + shift +j)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "13",
        height: "13",
        role: "img",
        viewBox: "0 0 156 156",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M110.85 120.575 43.7 120.483333 43.7083334 110.091667 110.85 110.191667 110.841667 120.583333 110.85 120.575ZM85.1333334 87.1916666 43.625 86.7083332 43.7083334 76.3166666 85.2083334 76.7916666 85.1333334 87.1916666 85.1333334 87.1916666ZM110.841667 53.4166666 43.7 53.3166666 43.7083334 42.925 110.85 43.025 110.841667 53.4166666ZM36 138C27.2916666 138 20.75 136.216667 16.4 132.666667 12.1333334 129.2 10 124.308333 10 118L10 95.3333332C10 91.0666666 9.25 88.1333332 7.7333334 86.5333332 6.3166668 84.8416666 3.7333334 84 0 84L0 72C3.7333334 72 6.3083334 71.2 7.7333334 69.6 9.2416668 67.9083334 10 64.9333334 10 60.6666666L10 38C10 31.775 12.1333334 26.8833334 16.4 23.3333332 20.7583334 19.7749998 27.2916666 18 36 18L40.6666668 18 40.6666668 30 36 30C34.0212222 29.9719277 32.1263151 30.7979128 30.8 32.2666666 29.3605875 33.8216362 28.5938182 35.8823287 28.6666668 38L28.6666668 60.6666666C28.6666668 67.5083332 26.6666668 72.4 22.6666668 75.3333332 20.9317416 76.7274684 18.8640675 77.6464347 16.6666668 78 18.8916668 78.35 20.8916668 79.2416666 22.6666668 80.6666666 26.6666668 83.95 28.6666668 88.8416666 28.6666668 95.3333332L28.6666668 118C28.6666668 120.308333 29.3750002 122.216667 30.8 123.733333 32.2166666 125.241667 33.9583334 126 36 126L40.6666668 126 40.6666668 138 36 138 36 138ZM114.116667 126 118.783333 126C120.833333 126 122.566667 125.241667 123.983333 123.733333 125.422746 122.178364 126.189515 120.117671 126.116667 118L126.116667 95.3333332C126.116667 88.8333332 128.116667 83.9499998 132.116667 80.6666666 133.9 79.2416666 135.9 78.35 138.116667 78 135.919156 77.6468047 133.851391 76.7277979 132.116667 75.3333332 128.116667 72.3999998 126.116667 67.5 126.116667 60.6666666L126.116667 38C126.189515 35.8823287 125.422746 33.8216361 123.983333 32.2666666 122.657018 30.7979128 120.762111 29.9719277 118.783333 30L114.116667 30 114.116667 18 118.783333 18C127.5 18 133.983333 19.775 138.25 23.3333332 142.608333 26.8833332 144.783333 31.7749998 144.783333 38L144.783333 60.6666666C144.783333 64.9333332 145.5 67.9083332 146.916667 69.6 148.433333 71.2 151.05 72 154.783333 72L154.783333 84C151.05 84 148.433333 84.8333334 146.916667 86.5333332 145.5 88.1333332 144.783333 91.0666666 144.783333 95.3333332L144.783333 118C144.783333 124.308333 142.616667 129.2 138.25 132.666667 133.983333 136.216667 127.5 138 118.783333 138L114.116667 138 114.116667 126 114.116667 126Z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: '```\n',
            suffix: '\n```'
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        // Based on context determine if new line is needed or not
        var prefix = '\n```\n';
        var suffix = '\n```\n';
        if (state1.selectedText.length >= prefix.length + suffix.length - 2 && state1.selectedText.startsWith(prefix) && state1.selectedText.endsWith(suffix)) {
            // Remove code block
            prefix = '```\n';
            suffix = '\n```';
        } else {
            // Add code block
            if (state1.selection.start >= 1 && state.text.slice(state1.selection.start - 1, state1.selection.start) === '\n' || state1.selection.start === 0) prefix = '```\n';
            if (state1.selection.end <= state.text.length - 1 && state.text.slice(state1.selection.end, state1.selection.end + 1) === '\n' || state1.selection.end === state.text.length) suffix = '\n```';
        }
        var newSelectionRange2 = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: prefix,
            suffix: suffix
        });
        var state2 = api.setSelectionRange(newSelectionRange2);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state2.selectedText,
            selection: state.selection,
            prefix: prefix,
            suffix: suffix
        });
    }
};
var $53482fb090606392$export$6565f9f03506010b = {
    name: 'code',
    keyCommand: 'code',
    shortcuts: 'ctrlcmd+j',
    prefix: '`',
    buttonProps: {
        'aria-label': 'Insert code (ctrl + j)',
        title: 'Insert code (ctrl + j)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "14",
        height: "14",
        role: "img",
        viewBox: "0 0 640 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
        })
    }),
    execute: (state, api)=>{
        if (state.selectedText.indexOf('\n') === -1) {
            var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
                text: state.text,
                selection: state.selection,
                prefix: state.command.prefix
            });
            var state1 = api.setSelectionRange(newSelectionRange);
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: state.command.prefix
            });
        } else $53482fb090606392$export$7bb0d5c671655cc4.execute(state, api);
    }
};


parcelRequire("7fPBF");


var $9708e0178a5760f3$export$4a34f930e789283c = {
    name: 'comment',
    keyCommand: 'comment',
    shortcuts: 'ctrlcmd+/',
    prefix: '<!-- ',
    suffix: ' -->',
    buttonProps: {
        'aria-label': 'Insert comment (ctrl + /)',
        title: 'Insert comment (ctrl + /)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        height: "1em",
        width: "1em",
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                    points: ".769 .727 24.981 .727 24.981 24.727 .769 24.727"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "3",
                    d: "M12.625,23.8787879 L8.125,19.6969697 L5.125,19.6969697 C2.63971863,19.6969697 0.625,17.8247059 0.625,15.5151515 L0.625,7.15151515 C0.625,4.84196074 2.63971863,2.96969697 5.125,2.96969697 L20.125,2.96969697 C22.6102814,2.96969697 24.625,4.84196074 24.625,7.15151515 L24.625,15.5151515 C24.625,17.8247059 22.6102814,19.6969697 20.125,19.6969697 L17.125,19.6969697 L12.625,23.8787879"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "3",
                    d: "M10.625,8.54545455 L7.25,11.3333333 L10.625,14.1212121 M15.6875,8.54545455 L19.0625,11.3333333 L15.6875,14.1212121"
                })
            ]
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};


var $915c6594da096284$export$e8c9778bf415dd08 = {
    keyCommand: 'divider'
};


parcelRequire("7fPBF");

var $d82069e0665e2255$export$af93ab412ae68734 = {
    name: 'fullscreen',
    keyCommand: 'fullscreen',
    shortcuts: 'ctrlcmd+0',
    value: 'fullscreen',
    buttonProps: {
        'aria-label': 'Toggle fullscreen (ctrl + 0)',
        title: 'Toggle fullscreen (ctrl+ 0)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M118 171.133334L118 342.200271C118 353.766938 126.675 365.333605 141.133333 365.333605L382.634614 365.333605C394.201281 365.333605 405.767948 356.658605 405.767948 342.200271L405.767948 171.133334C405.767948 159.566667 397.092948 148 382.634614 148L141.133333 148C126.674999 148 117.999999 156.675 118 171.133334zM465.353591 413.444444L370 413.444444 370 471.222222 474.0221 471.222222C500.027624 471.222222 520.254143 451 520.254143 425L520.254143 321 462.464089 321 462.464089 413.444444 465.353591 413.444444zM471.0221 43L367 43 367 100.777778 462.353591 100.777778 462.353591 196.111111 520.143647 196.111111 520.143647 89.2222219C517.254144 63.2222219 497.027624 43 471.0221 43zM57.7900547 100.777778L153.143646 100.777778 153.143646 43 46.2320439 43C20.2265191 43 0 63.2222219 0 89.2222219L0 193.222222 57.7900547 193.222222 57.7900547 100.777778zM57.7900547 321L0 321 0 425C0 451 20.2265191 471.222222 46.2320439 471.222223L150.254143 471.222223 150.254143 413.444445 57.7900547 413.444445 57.7900547 321z"
        })
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            fullscreen: !executeCommandState.fullscreen
        });
    }
};


function $75774ac5799c70fb$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}



parcelRequire("7fPBF");

var $1455182fb6186464$export$e5e25fbcc1f7affe = (arr, options)=>{
    var data = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        children: arr,
        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 520 520",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M15.7083333,468 C7.03242448,468 0,462.030833 0,454.666667 L0,421.333333 C0,413.969167 7.03242448,408 15.7083333,408 L361.291667,408 C369.967576,408 377,413.969167 377,421.333333 L377,454.666667 C377,462.030833 369.967576,468 361.291667,468 L15.7083333,468 Z M21.6666667,366 C9.69989583,366 0,359.831861 0,352.222222 L0,317.777778 C0,310.168139 9.69989583,304 21.6666667,304 L498.333333,304 C510.300104,304 520,310.168139 520,317.777778 L520,352.222222 C520,359.831861 510.300104,366 498.333333,366 L21.6666667,366 Z M136.835938,64 L136.835937,126 L107.25,126 L107.25,251 L40.75,251 L40.75,126 L-5.68434189e-14,126 L-5.68434189e-14,64 L136.835938,64 Z M212,64 L212,251 L161.648438,251 L161.648438,64 L212,64 Z M378,64 L378,126 L343.25,126 L343.25,251 L281.75,251 L281.75,126 L238,126 L238,64 L378,64 Z M449.047619,189.550781 L520,189.550781 L520,251 L405,251 L405,64 L449.047619,64 L449.047619,189.550781 Z"
            })
        }),
        execute: ()=>{}
    }, options, {
        keyCommand: 'group'
    });
    if (Array.isArray(data.children)) data.children = data.children.map((_ref)=>{
        var item = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ((0, $75774ac5799c70fb$export$2e2bcd8739ae039)(_ref), _ref));
        item.parent = data;
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item);
    });
    return data;
};


parcelRequire("7fPBF");


var $f1090649299d43a9$export$b4adb3f464574dcf = {
    name: 'hr',
    keyCommand: 'hr',
    shortcuts: 'ctrlcmd+h',
    prefix: '\n\n---\n',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert HR (ctrl + h)',
        title: 'Insert HR (ctrl + h)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 175 175",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M0,129 L175,129 L175,154 L0,154 L0,129 Z M3,9 L28.2158203,9 L28.2158203,47.9824219 L55.7695313,47.9824219 L55.7695313,9 L81.0966797,9 L81.0966797,107.185547 L55.7695313,107.185547 L55.7695313,68.0214844 L28.2158203,68.0214844 L28.2158203,107.185547 L3,107.185547 L3,9 Z M93.1855469,100.603516 L93.1855469,19 L135.211914,19 C143.004922,19 148.960917,19.6679621 153.080078,21.0039063 C157.199239,22.3398504 160.520495,24.8168764 163.043945,28.4350586 C165.567395,32.0532407 166.829102,36.459935 166.829102,41.6552734 C166.829102,46.1826398 165.864267,50.0883625 163.93457,53.3725586 C162.004873,56.6567547 159.351579,59.3193257 155.974609,61.3603516 C153.822255,62.6591862 150.872089,63.7353473 147.124023,64.5888672 C150.129898,65.5908253 152.319329,66.5927684 153.692383,67.5947266 C154.620122,68.2626987 155.965323,69.6913953 157.728027,71.8808594 C159.490731,74.0703234 160.668942,75.7587831 161.262695,76.9462891 L173,100.603516 L144.953125,100.603516 L131.482422,75.6660156 C129.775382,72.4374839 128.253913,70.3408251 126.917969,69.3759766 C125.0996,68.1142515 123.040051,67.4833984 120.739258,67.4833984 L118.512695,67.4833984 L118.512695,100.603516 L93.1855469,100.603516 Z M118.512695,52.0644531 L129.144531,52.0644531 C130.294928,52.0644531 132.521468,51.6933631 135.824219,50.9511719 C137.494149,50.6171858 138.857905,49.7636787 139.915527,48.390625 C140.97315,47.0175713 141.501953,45.4404386 141.501953,43.6591797 C141.501953,41.0244009 140.667001,39.0019602 138.99707,37.5917969 C137.32714,36.1816336 134.191429,35.4765625 129.589844,35.4765625 L117.512695,35.4765625 L118.512695,52.0644531 Z",
            transform: "translate(0 9)"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.length >= state.command.prefix.length && state1.selectedText.startsWith(state.command.prefix)) // Remove
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        else {
            // Add
            state1 = api.setSelectionRange({
                start: state.selection.start,
                end: state.selection.start
            });
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: state.command.prefix,
                suffix: state.command.suffix
            });
        }
    }
};


parcelRequire("7fPBF");


var $23179bbad19e1934$export$5c452ff88e35e47d = {
    name: 'image',
    keyCommand: 'image',
    shortcuts: 'ctrlcmd+k',
    prefix: '![image](',
    suffix: ')',
    buttonProps: {
        'aria-label': 'Add image (ctrl + k)',
        title: 'Add image (ctrl + k)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M15 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4-7H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 13l-6-5-2 2-4-5-4 8V4h16v11z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.includes('http') || state1.selectedText.includes('www')) (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        else {
            newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
                text: state.text,
                selection: state.selection,
                prefix: '![',
                suffix: ']()'
            });
            state1 = api.setSelectionRange(newSelectionRange);
            if (state1.selectedText.length === 0) (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: '![image',
                suffix: '](url)'
            });
            else (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: '![',
                suffix: ']()'
            });
        }
    }
};


parcelRequire("7fPBF");


var $272797a41233c2a2$export$5540da1282cbf565 = {
    name: 'italic',
    keyCommand: 'italic',
    shortcuts: 'ctrlcmd+i',
    prefix: '*',
    buttonProps: {
        'aria-label': 'Add italic text (ctrl + i)',
        title: 'Add italic text (ctrl + i)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "italic",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 320 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix
        });
    }
};


parcelRequire("7fPBF");


var $aacc1dc31941f636$export$9c30223ca0a664fb = {
    name: 'link',
    keyCommand: 'link',
    shortcuts: 'ctrlcmd+l',
    prefix: '[',
    suffix: '](url)',
    buttonProps: {
        'aria-label': 'Add a link (ctrl + l)',
        title: 'Add a link (ctrl + l)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "italic",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M331.751196,182.121107 C392.438214,241.974735 391.605313,337.935283 332.11686,396.871226 C332.005129,396.991316 331.873084,397.121413 331.751196,397.241503 L263.493918,464.491645 C203.291404,523.80587 105.345257,523.797864 45.151885,464.491645 C-15.0506283,405.187427 -15.0506283,308.675467 45.151885,249.371249 L82.8416853,212.237562 C92.836501,202.39022 110.049118,208.9351 110.56511,222.851476 C111.223305,240.5867 114.451306,258.404985 120.407566,275.611815 C122.424812,281.438159 120.983487,287.882964 116.565047,292.23621 L103.272145,305.332975 C74.8052033,333.379887 73.9123737,379.047937 102.098973,407.369054 C130.563883,435.969378 177.350591,436.139505 206.033884,407.879434 L274.291163,340.6393 C302.9257,312.427264 302.805844,266.827265 274.291163,238.733318 C270.531934,235.036561 266.74528,232.16442 263.787465,230.157924 C259.544542,227.2873 256.928256,222.609848 256.731165,217.542518 C256.328935,206.967633 260.13184,196.070508 268.613213,187.714278 L289.998463,166.643567 C295.606326,161.118448 304.403592,160.439942 310.906317,164.911276 C318.353355,170.034591 325.328531,175.793397 331.751196,182.121107 Z M240.704978,55.4828366 L172.447607,122.733236 C172.325719,122.853326 172.193674,122.983423 172.081943,123.103513 C117.703294,179.334654 129.953294,261.569283 185.365841,328.828764 C191.044403,335.721376 198.762988,340.914712 206.209732,346.037661 C212.712465,350.509012 221.510759,349.829503 227.117615,344.305363 L248.502893,323.234572 C256.984277,314.87831 260.787188,303.981143 260.384957,293.406218 C260.187865,288.338869 257.571576,283.661398 253.328648,280.790763 C250.370829,278.78426 246.58417,275.912107 242.824936,272.215337 C214.310216,244.121282 206.209732,204.825874 229.906702,179.334654 L298.164073,112.094263 C326.847404,83.8340838 373.633159,84.0042113 402.099123,112.604645 C430.285761,140.92587 429.393946,186.594095 400.92595,214.641114 L387.63303,227.737929 C383.214584,232.091191 381.773257,238.536021 383.790506,244.362388 C389.746774,261.569283 392.974779,279.387637 393.632975,297.122928 C394.149984,311.039357 411.361608,317.584262 421.356437,307.736882 L459.046288,270.603053 C519.249898,211.29961 519.249898,114.787281 459.047304,55.4828366 C398.853851,-3.82360914 300.907572,-3.83161514 240.704978,55.4828366 Z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.includes('http') || state1.selectedText.includes('www')) {
            newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
                text: state.text,
                selection: state.selection,
                prefix: '[](',
                suffix: ')'
            });
            state1 = api.setSelectionRange(newSelectionRange);
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: '[](',
                suffix: ')'
            });
        } else if (state1.selectedText.length === 0) (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: '[title',
            suffix: '](url)'
        });
        else (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};


parcelRequire("7fPBF");


var $8a2e0a4d28b56dc0$export$8690041b1e066766 = (state, api, insertBefore)=>{
    var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
        text: state.text,
        selection: state.selection,
        prefix: state.command.prefix
    });
    var state1 = api.setSelectionRange(newSelectionRange);
    var breaksBeforeCount = (0, $57170ec975fca5ef$export$7a6ac73908e24730)(state1.text, state1.selection.start);
    var breaksBefore = Array(breaksBeforeCount + 1).join('\n');
    var breaksAfterCount = (0, $57170ec975fca5ef$export$ac47e5b3b6484ab3)(state1.text, state1.selection.end);
    var breaksAfter = Array(breaksAfterCount + 1).join('\n');
    var _insertBeforeEachLine = (0, $57170ec975fca5ef$export$296d1daf426952fd)(state1.selectedText, insertBefore), modifiedText = _insertBeforeEachLine.modifiedText, insertionLength = _insertBeforeEachLine.insertionLength;
    if (insertionLength < 0) {
        // Remove
        var selectionStart = state1.selection.start;
        var selectionEnd = state1.selection.end;
        if (state1.selection.start > 0 && state.text.slice(state1.selection.start - 1, state1.selection.start) === '\n') selectionStart -= 1;
        if (state1.selection.end < state.text.length - 1 && state.text.slice(state1.selection.end, state1.selection.end + 1) === '\n') selectionEnd += 1;
        api.setSelectionRange({
            start: selectionStart,
            end: selectionEnd
        });
        api.replaceSelection("" + modifiedText);
        api.setSelectionRange({
            start: selectionStart,
            end: selectionStart + modifiedText.length
        });
    } else {
        // Add
        api.replaceSelection("" + breaksBefore + modifiedText + breaksAfter);
        var _selectionStart = state1.selection.start + breaksBeforeCount;
        var _selectionEnd = _selectionStart + modifiedText.length;
        api.setSelectionRange({
            start: _selectionStart,
            end: _selectionEnd
        });
    }
};
var $8a2e0a4d28b56dc0$export$6213d25cd68831c1 = {
    name: 'unordered-list',
    keyCommand: 'list',
    shortcuts: 'ctrl+shift+u',
    prefix: '- ',
    buttonProps: {
        'aria-label': 'Add unordered list (ctrl + shift + u)',
        title: 'Add unordered list (ctrl + shift + u)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "unordered-list",
        width: "12",
        height: "12",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
        })
    }),
    execute: (state, api)=>{
        $8a2e0a4d28b56dc0$export$8690041b1e066766(state, api, '- ');
    }
};
var $8a2e0a4d28b56dc0$export$4d4094269a49853c = {
    name: 'ordered-list',
    keyCommand: 'list',
    shortcuts: 'ctrl+shift+o',
    prefix: '1. ',
    buttonProps: {
        'aria-label': 'Add ordered list (ctrl + shift + o)',
        title: 'Add ordered list (ctrl + shift + o)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "ordered-list",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
        })
    }),
    execute: (state, api)=>{
        $8a2e0a4d28b56dc0$export$8690041b1e066766(state, api, (item, index)=>index + 1 + ". ");
    }
};
var $8a2e0a4d28b56dc0$export$2edba76228b93c06 = {
    name: 'checked-list',
    keyCommand: 'list',
    shortcuts: 'ctrl+shift+c',
    prefix: '- [ ] ',
    buttonProps: {
        'aria-label': 'Add checked list (ctrl + shift + c)',
        title: 'Add checked list (ctrl + shift + c)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "checked-list",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M208 132h288c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zM64 368c-26.5 0-48.6 21.5-48.6 48s22.1 48 48.6 48 48-21.5 48-48-21.5-48-48-48zm92.5-299l-72.2 72.2-15.6 15.6c-4.7 4.7-12.9 4.7-17.6 0L3.5 109.4c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.3c4.7-4.7 12.3-4.7 17 0l17 16.5c4.6 4.7 4.6 12.3-.1 17zm0 159.6l-72.2 72.2-15.7 15.7c-4.7 4.7-12.9 4.7-17.6 0L3.5 269c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.7c4.7-4.7 12.3-4.7 17 0l17 17c4.6 4.6 4.6 12.2-.1 16.9z"
        })
    }),
    execute: (state, api)=>{
        $8a2e0a4d28b56dc0$export$8690041b1e066766(state, api, (item, index)=>"- [ ] ");
    }
};


parcelRequire("7fPBF");

var $47528ad1eaeb011b$export$bb03fe4fe5a686f2 = {
    name: 'preview',
    keyCommand: 'preview',
    value: 'preview',
    shortcuts: 'ctrlcmd+9',
    buttonProps: {
        'aria-label': 'Preview code (ctrl + 9)',
        title: 'Preview code (ctrl + 9)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "0 71.293 0 122 38.023 123 38.023 398 0 397 0 449.707 91.023 450.413 91.023 72.293"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "148.023 72.293 520 71.293 520 122 200.023 124 200.023 397 520 396 520 449.707 148.023 450.413"
            })
        ]
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            preview: 'preview'
        });
    }
};
var $47528ad1eaeb011b$export$5f58ca08fd242e88 = {
    name: 'edit',
    keyCommand: 'preview',
    value: 'edit',
    shortcuts: 'ctrlcmd+7',
    buttonProps: {
        'aria-label': 'Edit code (ctrl + 7)',
        title: 'Edit code (ctrl + 7)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "0 71.293 0 122 319 122 319 397 0 397 0 449.707 372 449.413 372 71.293"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "429 71.293 520 71.293 520 122 481 123 481 396 520 396 520 449.707 429 449.413"
            })
        ]
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            preview: 'edit'
        });
    }
};
var $47528ad1eaeb011b$export$3449b126b33d0f8f = {
    name: 'live',
    keyCommand: 'preview',
    value: 'live',
    shortcuts: 'ctrlcmd+8',
    buttonProps: {
        'aria-label': 'Live code (ctrl + 8)',
        title: 'Live code (ctrl + 8)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "0 71.293 0 122 179 122 179 397 0 397 0 449.707 232 449.413 232 71.293"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                fill: "currentColor",
                points: "289 71.293 520 71.293 520 122 341 123 341 396 520 396 520 449.707 289 449.413"
            })
        ]
    }),
    execute: (state, api, dispatch, executeCommandState, shortcuts)=>{
        api.textArea.focus();
        if (shortcuts && dispatch && executeCommandState) dispatch({
            preview: 'live'
        });
    }
};


parcelRequire("7fPBF");


var $56cbd7f6d3e478f3$export$ee7a15c61bfdeb11 = {
    name: 'quote',
    keyCommand: 'quote',
    shortcuts: 'ctrlcmd+q',
    prefix: '> ',
    buttonProps: {
        'aria-label': 'Insert a quote (ctrl + q)',
        title: 'Insert a quote (ctrl + q)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M520,95.75 L520,225.75 C520,364.908906 457.127578,437.050625 325.040469,472.443125 C309.577578,476.586875 294.396016,464.889922 294.396016,448.881641 L294.396016,414.457031 C294.396016,404.242891 300.721328,395.025078 310.328125,391.554687 C377.356328,367.342187 414.375,349.711094 414.375,274.5 L341.25,274.5 C314.325781,274.5 292.5,252.674219 292.5,225.75 L292.5,95.75 C292.5,68.8257812 314.325781,47 341.25,47 L471.25,47 C498.174219,47 520,68.8257812 520,95.75 Z M178.75,47 L48.75,47 C21.8257813,47 0,68.8257812 0,95.75 L0,225.75 C0,252.674219 21.8257813,274.5 48.75,274.5 L121.875,274.5 C121.875,349.711094 84.8563281,367.342187 17.828125,391.554687 C8.22132813,395.025078 1.89601563,404.242891 1.89601563,414.457031 L1.89601563,448.881641 C1.89601563,464.889922 17.0775781,476.586875 32.5404687,472.443125 C164.627578,437.050625 227.5,364.908906 227.5,225.75 L227.5,95.75 C227.5,68.8257812 205.674219,47 178.75,47 Z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        var breaksBeforeCount = (0, $57170ec975fca5ef$export$7a6ac73908e24730)(state1.text, state1.selection.start);
        var breaksBefore = Array(breaksBeforeCount + 1).join('\n');
        var breaksAfterCount = (0, $57170ec975fca5ef$export$ac47e5b3b6484ab3)(state1.text, state1.selection.end);
        var breaksAfter = Array(breaksAfterCount + 1).join('\n');
        var modifiedText = (0, $57170ec975fca5ef$export$296d1daf426952fd)(state1.selectedText, state.command.prefix);
        api.replaceSelection("" + breaksBefore + modifiedText.modifiedText + breaksAfter);
        var selectionStart = state1.selection.start + breaksBeforeCount;
        var selectionEnd = selectionStart + modifiedText.modifiedText.length;
        api.setSelectionRange({
            start: selectionStart,
            end: selectionEnd
        });
    }
};


parcelRequire("7fPBF");


var $1c24713855f6d6fa$export$19426ff118fe8be = {
    name: 'strikethrough',
    keyCommand: 'strikethrough',
    shortcuts: 'ctrl+shift+x',
    buttonProps: {
        'aria-label': 'Add strikethrough text (ctrl + shift + x)',
        title: 'Add strikethrough text (ctrl + shift + x)'
    },
    prefix: '~~',
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        "data-name": "strikethrough",
        width: "12",
        height: "12",
        role: "img",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M496 288H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h480c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16zm-214.666 16c27.258 12.937 46.524 28.683 46.524 56.243 0 33.108-28.977 53.676-75.621 53.676-32.325 0-76.874-12.08-76.874-44.271V368c0-8.837-7.164-16-16-16H113.75c-8.836 0-16 7.163-16 16v19.204c0 66.845 77.717 101.82 154.487 101.82 88.578 0 162.013-45.438 162.013-134.424 0-19.815-3.618-36.417-10.143-50.6H281.334zm-30.952-96c-32.422-13.505-56.836-28.946-56.836-59.683 0-33.92 30.901-47.406 64.962-47.406 42.647 0 64.962 16.593 64.962 32.985V136c0 8.837 7.164 16 16 16h45.613c8.836 0 16-7.163 16-16v-30.318c0-52.438-71.725-79.875-142.575-79.875-85.203 0-150.726 40.972-150.726 125.646 0 22.71 4.665 41.176 12.777 56.547h129.823z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix
        });
    }
};



parcelRequire("7fPBF");
parcelRequire("7fPBF");


var $88569c0108189c0e$export$32fde58c912ee8a = {
    name: 'heading1',
    keyCommand: 'heading1',
    shortcuts: 'ctrlcmd+1',
    prefix: '# ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 1 (ctrl + 1)',
        title: 'Insert Heading 1 (ctrl + 1)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 18,
            textAlign: 'left'
        },
        children: "Heading 1"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $88569c0108189c0e$export$bafb53d6d28bbb73 = $88569c0108189c0e$export$32fde58c912ee8a;




function $8d3503b55bbc42ae$export$cd14d34733017854(_ref) {
    var state = _ref.state, api = _ref.api, prefix = _ref.prefix, _ref$suffix = _ref.suffix, suffix = _ref$suffix === void 0 ? prefix : _ref$suffix;
    var newSelectionRange = (0, $57170ec975fca5ef$export$e41c12847640c21)({
        text: state.text,
        selection: state.selection
    });
    var state1 = api.setSelectionRange(newSelectionRange);
    (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
        api: api,
        selectedText: state1.selectedText,
        selection: state.selection,
        prefix: prefix,
        suffix: suffix
    });
}
var $8d3503b55bbc42ae$export$46e4a324ac90507f = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, (0, $88569c0108189c0e$export$32fde58c912ee8a), {
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 520 520",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M15.7083333,468 C7.03242448,468 0,462.030833 0,454.666667 L0,421.333333 C0,413.969167 7.03242448,408 15.7083333,408 L361.291667,408 C369.967576,408 377,413.969167 377,421.333333 L377,454.666667 C377,462.030833 369.967576,468 361.291667,468 L15.7083333,468 Z M21.6666667,366 C9.69989583,366 0,359.831861 0,352.222222 L0,317.777778 C0,310.168139 9.69989583,304 21.6666667,304 L498.333333,304 C510.300104,304 520,310.168139 520,317.777778 L520,352.222222 C520,359.831861 510.300104,366 498.333333,366 L21.6666667,366 Z M136.835938,64 L136.835937,126 L107.25,126 L107.25,251 L40.75,251 L40.75,126 L-5.68434189e-14,126 L-5.68434189e-14,64 L136.835938,64 Z M212,64 L212,251 L161.648438,251 L161.648438,64 L212,64 Z M378,64 L378,126 L343.25,126 L343.25,251 L281.75,251 L281.75,126 L238,126 L238,64 L378,64 Z M449.047619,189.550781 L520,189.550781 L520,251 L405,251 L405,64 L449.047619,64 L449.047619,189.550781 Z"
        })
    })
});
var $8d3503b55bbc42ae$export$fb184b623420d9be = $8d3503b55bbc42ae$export$46e4a324ac90507f;



parcelRequire("7fPBF");


var $36fb40a0f726427f$export$fdf227ae9d529b82 = {
    name: 'heading2',
    keyCommand: 'heading2',
    shortcuts: 'ctrlcmd+2',
    prefix: '## ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 2 (ctrl + 2)',
        title: 'Insert Heading 2 (ctrl + 2)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 16,
            textAlign: 'left'
        },
        children: "Heading 2"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $36fb40a0f726427f$export$a32e8f003254de0d = $36fb40a0f726427f$export$fdf227ae9d529b82;


parcelRequire("7fPBF");


var $94732458fecf1917$export$866ae29a041994c3 = {
    name: 'heading3',
    keyCommand: 'heading3',
    shortcuts: 'ctrlcmd+3',
    prefix: '### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 3 (ctrl + 3)',
        title: 'Insert Heading 3 (ctrl + 3)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 15,
            textAlign: 'left'
        },
        children: "Heading 3"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $94732458fecf1917$export$a764c41186b9ad10 = $94732458fecf1917$export$866ae29a041994c3;


parcelRequire("7fPBF");


var $985391ef6c21b650$export$1bb412471a29ad7f = {
    name: 'heading4',
    keyCommand: 'heading4',
    shortcuts: 'ctrlcmd+4',
    prefix: '#### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 4 (ctrl + 4)',
        title: 'Insert Heading 4 (ctrl + 4)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 14,
            textAlign: 'left'
        },
        children: "Heading 4"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $985391ef6c21b650$export$148c1c1fe698f02e = $985391ef6c21b650$export$1bb412471a29ad7f;


parcelRequire("7fPBF");


var $7bc18c784a97e596$export$e6417b03ea193326 = {
    name: 'heading5',
    keyCommand: 'heading5',
    shortcuts: 'ctrlcmd+5',
    prefix: '##### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 5 (ctrl + 5)',
        title: 'Insert Heading 5 (ctrl + 5)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 12,
            textAlign: 'left'
        },
        children: "Heading 5"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $7bc18c784a97e596$export$ce3b15c74fe7af88 = $7bc18c784a97e596$export$e6417b03ea193326;


parcelRequire("7fPBF");


var $19666cf4a41f6938$export$25fc23799c4c7dcc = {
    name: 'heading6',
    keyCommand: 'heading6',
    shortcuts: 'ctrlcmd+6',
    prefix: '###### ',
    suffix: '',
    buttonProps: {
        'aria-label': 'Insert Heading 6 (ctrl + 6)',
        title: 'Insert Heading 6 (ctrl + 6)'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            fontSize: 12,
            textAlign: 'left'
        },
        children: "Heading 6"
    }),
    execute: (state, api)=>{
        (0, $8d3503b55bbc42ae$export$cd14d34733017854)({
            state: state,
            api: api,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};
var $19666cf4a41f6938$export$f805de199ca30344 = $19666cf4a41f6938$export$25fc23799c4c7dcc;


parcelRequire("7fPBF");


var $8b5b65f9bb910ca3$export$9852986a3ec5f6a0 = {
    name: 'table',
    keyCommand: 'table',
    prefix: '\n| Header | Header |\n|--------|--------|\n| Cell | Cell |\n| Cell | Cell |\n| Cell | Cell |\n\n',
    suffix: '',
    buttonProps: {
        'aria-label': 'Add table',
        title: 'Add table'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        role: "img",
        width: "12",
        height: "12",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        if (state1.selectedText.length >= state.command.prefix.length + state.command.suffix.length && state1.selectedText.startsWith(state.command.prefix)) // Remove
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        else {
            // Add
            state1 = api.setSelectionRange({
                start: state.selection.start,
                end: state.selection.start
            });
            (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
                api: api,
                selectedText: state1.selectedText,
                selection: state.selection,
                prefix: state.command.prefix,
                suffix: state.command.suffix
            });
        }
    }
};


parcelRequire("7fPBF");


var $e06ccd15504ef7a8$export$69ad3503f98be476 = {
    name: 'issue',
    keyCommand: 'issue',
    prefix: '#',
    suffix: '',
    buttonProps: {
        'aria-label': 'Add issue',
        title: 'Add issue'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        role: "img",
        width: "12",
        height: "12",
        viewBox: "0 0 448 512",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0L325.8 320l58.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-68.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0z"
        })
    }),
    execute: (state, api)=>{
        var newSelectionRange = (0, $57170ec975fca5ef$export$bc597f78f9f82ed0)({
            text: state.text,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
        var state1 = api.setSelectionRange(newSelectionRange);
        (0, $57170ec975fca5ef$export$3d4c04ed49431392)({
            api: api,
            selectedText: state1.selectedText,
            selection: state.selection,
            prefix: state.command.prefix,
            suffix: state.command.suffix
        });
    }
};


parcelRequire("7fPBF");

var $68eb3de1a22c361d$export$34512e3b2db52a4e = {
    name: 'help',
    keyCommand: 'help',
    buttonProps: {
        'aria-label': 'Open help',
        title: 'Open help'
    },
    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        width: "12px",
        height: "12px",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm.9 13H7v-1.8h1.9V13Zm-.1-3.6v.5H7.1v-.6c.2-2.1 2-1.9 1.9-3.2.1-.7-.3-1.1-1-1.1-.8 0-1.2.7-1.2 1.6H5c0-1.7 1.2-3 2.9-3 2.3 0 3 1.4 3 2.3.1 2.3-1.9 2-2.1 3.5Z",
            fill: "currentColor"
        })
    }),
    execute: ()=>{
        window.open('https://www.markdownguide.org/basic-syntax/', '_blank', 'noreferrer');
    }
};


var $85b654349d31b699$export$7a6092e2ae7e1845 = ()=>[
        (0, $1b1be813ac69f87a$export$73ba5813cda80a49),
        (0, $272797a41233c2a2$export$5540da1282cbf565),
        (0, $1c24713855f6d6fa$export$19426ff118fe8be),
        (0, $f1090649299d43a9$export$b4adb3f464574dcf),
        (0, $1455182fb6186464$export$e5e25fbcc1f7affe)([
            (0, $88569c0108189c0e$export$bafb53d6d28bbb73),
            (0, $36fb40a0f726427f$export$a32e8f003254de0d),
            (0, $94732458fecf1917$export$a764c41186b9ad10),
            (0, $985391ef6c21b650$export$148c1c1fe698f02e),
            (0, $7bc18c784a97e596$export$ce3b15c74fe7af88),
            (0, $19666cf4a41f6938$export$f805de199ca30344)
        ], {
            name: 'title',
            groupName: 'title',
            buttonProps: {
                'aria-label': 'Insert title',
                title: 'Insert title'
            }
        }),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $aacc1dc31941f636$export$9c30223ca0a664fb),
        (0, $56cbd7f6d3e478f3$export$ee7a15c61bfdeb11),
        (0, $53482fb090606392$export$6565f9f03506010b),
        (0, $53482fb090606392$export$7bb0d5c671655cc4),
        (0, $9708e0178a5760f3$export$4a34f930e789283c),
        (0, $23179bbad19e1934$export$5c452ff88e35e47d),
        (0, $8b5b65f9bb910ca3$export$9852986a3ec5f6a0),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $8a2e0a4d28b56dc0$export$6213d25cd68831c1),
        (0, $8a2e0a4d28b56dc0$export$4d4094269a49853c),
        (0, $8a2e0a4d28b56dc0$export$2edba76228b93c06),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $68eb3de1a22c361d$export$34512e3b2db52a4e)
    ];
var $85b654349d31b699$export$6e591f5fe2c6ad02 = ()=>[
        (0, $47528ad1eaeb011b$export$5f58ca08fd242e88),
        (0, $47528ad1eaeb011b$export$3449b126b33d0f8f),
        (0, $47528ad1eaeb011b$export$bb03fe4fe5a686f2),
        (0, $915c6594da096284$export$e8c9778bf415dd08),
        (0, $d82069e0665e2255$export$af93ab412ae68734)
    ];
function $85b654349d31b699$export$56c9a4b3c99767b8(textArea) {
    var _textArea$value;
    return {
        selection: {
            start: textArea.selectionStart,
            end: textArea.selectionEnd
        },
        text: textArea.value,
        selectedText: (_textArea$value = textArea.value) == null ? void 0 : _textArea$value.slice(textArea.selectionStart, textArea.selectionEnd)
    };
}
class $85b654349d31b699$export$d45483eeb65d6c0c {
    /**
   * Replaces the current selection with the new text. This will make the new selectedText to be empty, the
   * selection start and selection end will be the same and will both point to the end
   * @param text Text that should replace the current selection
   */ replaceSelection(text) {
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(this.textArea, text);
        return $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea);
    }
    /**
   * Selects the specified text range
   * @param selection
   */ setSelectionRange(selection) {
        this.textArea.focus();
        this.textArea.selectionStart = selection.start;
        this.textArea.selectionEnd = selection.end;
        return $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea);
    }
    constructor(textArea){
        this.textArea = void 0;
        this.textArea = textArea;
    }
}
class $85b654349d31b699$export$7987eb6974342a3c {
    getState() {
        if (!this.textArea) return false;
        return $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea);
    }
    executeCommand(command, dispatch, state, shortcuts) {
        command.execute && command.execute((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            command: command
        }, $85b654349d31b699$export$56c9a4b3c99767b8(this.textArea)), this.textApi, dispatch, state, shortcuts);
    }
    constructor(textArea){
        this.textArea = void 0;
        this.textApi = void 0;
        this.textArea = textArea;
        this.textApi = new $85b654349d31b699$export$d45483eeb65d6c0c(textArea);
    }
}





/**
 * - `13` - `Enter`
 * - `9` - `Tab`
 */ function $7f5193ec23d3d3fe$var$stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $7f5193ec23d3d3fe$var$handleLineMove(e, direction) {
    $7f5193ec23d3d3fe$var$stopPropagation(e);
    var target = e.target;
    var textArea = new (0, $85b654349d31b699$export$d45483eeb65d6c0c)(target);
    var selection = {
        start: target.selectionStart,
        end: target.selectionEnd
    };
    selection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
        text: target.value,
        selection: selection
    });
    if (direction < 0 && selection.start <= 0 || direction > 0 && selection.end >= target.value.length) return;
    var blockText = target.value.slice(selection.start, selection.end);
    if (direction < 0) {
        var prevLineSelection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
            text: target.value,
            selection: {
                start: selection.start - 1,
                end: selection.start - 1
            }
        });
        var prevLineText = target.value.slice(prevLineSelection.start, prevLineSelection.end);
        textArea.setSelectionRange({
            start: prevLineSelection.start,
            end: selection.end
        });
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, blockText + "\n" + prevLineText);
        textArea.setSelectionRange({
            start: prevLineSelection.start,
            end: prevLineSelection.start + blockText.length
        });
    } else {
        var nextLineSelection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
            text: target.value,
            selection: {
                start: selection.end + 1,
                end: selection.end + 1
            }
        });
        var nextLineText = target.value.slice(nextLineSelection.start, nextLineSelection.end);
        textArea.setSelectionRange({
            start: selection.start,
            end: nextLineSelection.end
        });
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, nextLineText + "\n" + blockText);
        textArea.setSelectionRange({
            start: nextLineSelection.end - blockText.length,
            end: nextLineSelection.end
        });
    }
}
function $7f5193ec23d3d3fe$export$2e2bcd8739ae039(e, tabSize, defaultTabEnable) {
    if (tabSize === void 0) tabSize = 2;
    if (defaultTabEnable === void 0) defaultTabEnable = false;
    var target = e.target;
    var starVal = target.value.substr(0, target.selectionStart);
    var valArr = starVal.split('\n');
    var currentLineStr = valArr[valArr.length - 1];
    var textArea = new (0, $85b654349d31b699$export$d45483eeb65d6c0c)(target);
    /**
   * `9` - `Tab`
   */ if (!defaultTabEnable && e.code && e.code.toLowerCase() === 'tab') {
        $7f5193ec23d3d3fe$var$stopPropagation(e);
        var space = new Array(tabSize + 1).join('  ');
        if (target.selectionStart !== target.selectionEnd) {
            var _star = target.value.substring(0, target.selectionStart).split('\n');
            var _end = target.value.substring(0, target.selectionEnd).split('\n');
            var modifiedTextLine = [];
            _end.forEach((item, idx)=>{
                if (item !== _star[idx]) modifiedTextLine.push(item);
            });
            var modifiedText = modifiedTextLine.join('\n');
            var oldSelectText = target.value.substring(target.selectionStart, target.selectionEnd);
            var newStarNum = target.value.substring(0, target.selectionStart).length;
            textArea.setSelectionRange({
                start: target.value.indexOf(modifiedText),
                end: target.selectionEnd
            });
            var modifiedTextObj = (0, $57170ec975fca5ef$export$296d1daf426952fd)(modifiedText, e.shiftKey ? '' : space);
            var text = modifiedTextObj.modifiedText;
            if (e.shiftKey) text = text.split('\n').map((item)=>item.replace(new RegExp("^" + space), '')).join('\n');
            textArea.replaceSelection(text);
            var startTabSize = e.shiftKey ? -tabSize : tabSize;
            var endTabSize = e.shiftKey ? -modifiedTextLine.length * tabSize : modifiedTextLine.length * tabSize;
            textArea.setSelectionRange({
                start: newStarNum + startTabSize,
                end: newStarNum + oldSelectText.length + endTabSize
            });
        } else return (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, space);
    } else if (e.keyCode === 13 && e.code.toLowerCase() === 'enter' && (/^(-|\*)\s/.test(currentLineStr) || /^\d+.\s/.test(currentLineStr)) && !e.shiftKey) {
        /**
     * `13` - `Enter`
     */ $7f5193ec23d3d3fe$var$stopPropagation(e);
        var startStr = '\n- ';
        if (currentLineStr.startsWith('*')) startStr = '\n* ';
        if (currentLineStr.startsWith('- [ ]') || currentLineStr.startsWith('- [X]') || currentLineStr.startsWith('- [x]')) startStr = '\n- [ ] ';
        if (/^\d+.\s/.test(currentLineStr)) startStr = "\n" + (parseInt(currentLineStr) + 1) + ". ";
        return (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, startStr);
    } else if (e.code && e.code.toLowerCase() === 'keyd' && e.ctrlKey) {
        // Duplicate lines
        $7f5193ec23d3d3fe$var$stopPropagation(e);
        var selection = {
            start: target.selectionStart,
            end: target.selectionEnd
        };
        var savedSelection = selection;
        selection = (0, $57170ec975fca5ef$export$e41c12847640c21)({
            text: target.value,
            selection: selection
        });
        var textToDuplicate = target.value.slice(selection.start, selection.end);
        textArea.setSelectionRange({
            start: selection.end,
            end: selection.end
        });
        (0, $cd79195d1a384c19$export$7d6189efbd20bf69)(target, "\n" + textToDuplicate);
        textArea.setSelectionRange({
            start: savedSelection.start,
            end: savedSelection.end
        });
    } else if (e.code && e.code.toLowerCase() === 'arrowup' && e.altKey) $7f5193ec23d3d3fe$var$handleLineMove(e, -1);
    else if (e.code && e.code.toLowerCase() === 'arrowdown' && e.altKey) $7f5193ec23d3d3fe$var$handleLineMove(e, 1);
}





var $053231a4eb786f98$var$_excluded = [
    "prefixCls",
    "onChange"
], $053231a4eb786f98$var$_excluded2 = [
    "markdown",
    "commands",
    "fullscreen",
    "preview",
    "highlightEnable",
    "extraCommands",
    "tabSize",
    "defaultTabEnable",
    "autoFocusEnd",
    "textareaWarp",
    "dispatch"
];
function $053231a4eb786f98$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, _onChange = props.onChange, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $053231a4eb786f98$var$_excluded);
    var _useContext = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), markdown = _useContext.markdown, commands = _useContext.commands, fullscreen = _useContext.fullscreen, preview = _useContext.preview, highlightEnable = _useContext.highlightEnable, extraCommands = _useContext.extraCommands, tabSize = _useContext.tabSize, defaultTabEnable = _useContext.defaultTabEnable, autoFocusEnd = _useContext.autoFocusEnd, textareaWarp = _useContext.textareaWarp, dispatch = _useContext.dispatch, otherStore = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_useContext, $053231a4eb786f98$var$_excluded2);
    var textRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    var executeRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    var statesRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        fullscreen: fullscreen,
        preview: preview
    });
    (0, $7fPBF.useEffect)(()=>{
        statesRef.current = {
            fullscreen: fullscreen,
            preview: preview,
            highlightEnable: highlightEnable
        };
    }, [
        fullscreen,
        preview,
        highlightEnable
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (textRef.current && dispatch) {
            var commandOrchestrator = new (0, $85b654349d31b699$export$7987eb6974342a3c)(textRef.current);
            executeRef.current = commandOrchestrator;
            dispatch({
                textarea: textRef.current,
                commandOrchestrator: commandOrchestrator
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (autoFocusEnd && textRef.current && textareaWarp) {
            textRef.current.focus();
            var length = textRef.current.value.length;
            textRef.current.setSelectionRange(length, length);
            setTimeout(()=>{
                if (textareaWarp) textareaWarp.scrollTop = textareaWarp.scrollHeight;
                if (textRef.current) textRef.current.scrollTop = textRef.current.scrollHeight;
            }, 0);
        }
    }, [
        textareaWarp
    ]);
    var onKeyDown = (e)=>{
        (0, $7f5193ec23d3d3fe$export$2e2bcd8739ae039)(e, tabSize, defaultTabEnable);
        (0, $291b77f2b248d49a$export$2e2bcd8739ae039)(e, [
            ...commands || [],
            ...extraCommands || []
        ], executeRef.current, dispatch, statesRef.current);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (textRef.current) textRef.current.addEventListener('keydown', onKeyDown);
        return ()=>{
            if (textRef.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            textRef.current.removeEventListener('keydown', onKeyDown);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: false
    }, other, {
        ref: textRef,
        className: prefixCls + "-text-input " + (other.className ? other.className : ''),
        value: markdown,
        onChange: (e)=>{
            dispatch && dispatch({
                markdown: e.target.value
            });
            _onChange && _onChange(e);
        }
    }));
}





var $0bb6a7dc1543c1c6$var$_excluded = [
    "prefixCls",
    "className",
    "onScroll",
    "renderTextarea"
];
function $0bb6a7dc1543c1c6$export$5b32cb28d9a29894(options) {
    var _options$useMinHeight;
    var MarkdownComponent = options == null ? void 0 : options.Markdown;
    var useMinHeight = (_options$useMinHeight = options == null ? void 0 : options.useMinHeight) != null ? _options$useMinHeight : false;
    return function TextArea(props) {
        var _ref = props || {}, prefixCls = _ref.prefixCls, className = _ref.className, onScroll = _ref.onScroll, renderTextarea = _ref.renderTextarea, otherProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $0bb6a7dc1543c1c6$var$_excluded);
        var _useContext = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), markdown = _useContext.markdown, scrollTop = _useContext.scrollTop, commands = _useContext.commands, minHeight = _useContext.minHeight, highlightEnable = _useContext.highlightEnable, extraCommands = _useContext.extraCommands, dispatch = _useContext.dispatch;
        var textRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
        var executeRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
        var warp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createRef();
        (0, $7fPBF.useEffect)(()=>{
            var state = {};
            if (warp.current) {
                state.textareaWarp = warp.current || undefined;
                warp.current.scrollTop = scrollTop || 0;
            }
            if (dispatch) dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state));
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        (0, $7fPBF.useEffect)(()=>{
            if (textRef.current && dispatch) {
                var commandOrchestrator = new (0, $85b654349d31b699$export$7987eb6974342a3c)(textRef.current);
                executeRef.current = commandOrchestrator;
                dispatch({
                    textarea: textRef.current,
                    commandOrchestrator: commandOrchestrator
                });
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        var textStyle = MarkdownComponent && highlightEnable ? {} : {
            WebkitTextFillColor: 'initial',
            overflow: 'auto'
        };
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            ref: warp,
            className: prefixCls + "-area " + (className || ''),
            onScroll: onScroll,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: prefixCls + "-text",
                style: useMinHeight ? {
                    minHeight: minHeight
                } : undefined,
                children: renderTextarea ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(renderTextarea((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, otherProps, {
                    value: markdown,
                    autoComplete: 'off',
                    autoCorrect: 'off',
                    spellCheck: 'false',
                    autoCapitalize: 'off',
                    className: prefixCls + "-text-input",
                    style: {
                        WebkitTextFillColor: 'inherit',
                        overflow: 'auto'
                    }
                }), {
                    dispatch: dispatch,
                    onChange: otherProps.onChange,
                    shortcuts: $291b77f2b248d49a$export$2e2bcd8739ae039,
                    useContext: {
                        commands: commands,
                        extraCommands: extraCommands,
                        commandOrchestrator: executeRef.current
                    }
                }), {
                    ref: textRef
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7fPBF.Fragment), {
                    children: [
                        MarkdownComponent && highlightEnable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(MarkdownComponent, {
                            prefixCls: prefixCls
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $053231a4eb786f98$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                            prefixCls: prefixCls
                        }, otherProps, {
                            style: textStyle
                        }))
                    ]
                })
            })
        });
    };
}


var $33ce618c4c7bcc53$export$2e2bcd8739ae039 = (0, $0bb6a7dc1543c1c6$export$5b32cb28d9a29894)({
    Markdown: $3b1c409df4bde24b$export$2e2bcd8739ae039,
    useMinHeight: true
});





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");




function $da6420f2709698c0$export$2e2bcd8739ae039(props) {
    var _ref = props || {}, prefixCls = _ref.prefixCls, groupName = _ref.groupName, commands = _ref.commands, children = _ref.children;
    var _useContext = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), _useContext$barPopup = _useContext.barPopup, barPopup = _useContext$barPopup === void 0 ? {} : _useContext$barPopup;
    return (0, $7fPBF.useMemo)(()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: prefixCls + "-toolbar-child " + (groupName && barPopup[groupName] ? 'active' : ''),
            onClick: (e)=>e.stopPropagation(),
            children: Array.isArray(commands) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f179cc69962c631d$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                commands: commands
            }, props, {
                isChild: true
            })) : children
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        commands,
        barPopup,
        groupName,
        prefixCls
    ]);
}




function $f179cc69962c631d$export$935e16d2d88a04e6(props) {
    var prefixCls = props.prefixCls, overflow = props.overflow;
    var _useContext = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), fullscreen = _useContext.fullscreen, preview = _useContext.preview, _useContext$barPopup = _useContext.barPopup, barPopup = _useContext$barPopup === void 0 ? {} : _useContext$barPopup, components = _useContext.components, commandOrchestrator = _useContext.commandOrchestrator, dispatch = _useContext.dispatch;
    var originalOverflow = (0, $7fPBF.useRef)('');
    function handleClick(command, name) {
        if (!dispatch) return;
        var state = {
            barPopup: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, barPopup)
        };
        if (command.keyCommand === 'preview') state.preview = command.value;
        if (command.keyCommand === 'fullscreen') state.fullscreen = !fullscreen;
        if (props.commands && command.keyCommand === 'group') props.commands.forEach((item)=>{
            if (name === item.groupName) state.barPopup[name] = true;
            else if (item.keyCommand) state.barPopup[item.groupName] = false;
        });
        else if (name || command.parent) Object.keys(state.barPopup || {}).forEach((keyName)=>{
            state.barPopup[keyName] = false;
        });
        if (Object.keys(state).length) dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state));
        commandOrchestrator && commandOrchestrator.executeCommand(command);
    }
    (0, $7fPBF.useEffect)(()=>{
        if (document && overflow) {
            if (fullscreen) // prevent scroll on fullscreen
            document.body.style.overflow = 'hidden';
            else {
                // get the original overflow only the first time
                if (!originalOverflow.current) originalOverflow.current = window.getComputedStyle(document.body, null).overflow;
                // reset to the original overflow
                document.body.style.overflow = originalOverflow.current;
            }
        }
    }, [
        fullscreen,
        originalOverflow,
        overflow
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
        children: (props.commands || []).map((item, idx)=>{
            if (item.keyCommand === 'divider') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item.liProps, {
                className: prefixCls + "-toolbar-divider"
            }), idx);
            if (!item.keyCommand) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {}, idx);
            var activeBtn = fullscreen && item.keyCommand === 'fullscreen' || item.keyCommand === 'preview' && preview === item.value;
            var childNode = item.children && typeof item.children === 'function' ? item.children({
                getState: ()=>commandOrchestrator.getState(),
                textApi: commandOrchestrator ? commandOrchestrator.textApi : undefined,
                close: ()=>handleClick({}, item.groupName),
                execute: ()=>handleClick({
                        execute: item.execute
                    }),
                dispatch: dispatch
            }) : undefined;
            var disabled = barPopup && preview && preview === 'preview' && !/(preview|fullscreen)/.test(item.keyCommand);
            var render = (components == null ? void 0 : components.toolbar) || item.render;
            var com = render && typeof render === 'function' ? render(item, !!disabled, handleClick, idx) : null;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, item.liProps, {
                className: activeBtn ? "active" : '',
                children: [
                    com && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(com) && com,
                    !com && !item.buttonProps && item.icon,
                    !com && item.buttonProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('button', (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        type: 'button',
                        key: idx,
                        disabled: disabled,
                        'data-name': item.name
                    }, item.buttonProps, {
                        onClick: (evn)=>{
                            evn.stopPropagation();
                            handleClick(item, item.groupName);
                        }
                    }), item.icon),
                    item.children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $da6420f2709698c0$export$2e2bcd8739ae039), {
                        overflow: overflow,
                        groupName: item.groupName,
                        prefixCls: prefixCls,
                        children: childNode,
                        commands: Array.isArray(item.children) ? item.children : undefined
                    })
                ]
            }), idx);
        })
    });
}
function $f179cc69962c631d$export$2e2bcd8739ae039(props) {
    if (props === void 0) props = {};
    var _props = props, prefixCls = _props.prefixCls, isChild = _props.isChild, className = _props.className;
    var _useContext2 = (0, $7fPBF.useContext)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7)), commands = _useContext2.commands, extraCommands = _useContext2.extraCommands;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: prefixCls + "-toolbar " + className,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f179cc69962c631d$export$935e16d2d88a04e6, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                commands: props.commands || commands || []
            })),
            !isChild && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f179cc69962c631d$export$935e16d2d88a04e6, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                commands: extraCommands || []
            }))
        ]
    });
}
function $f179cc69962c631d$export$f8f240f0d25ce088(props) {
    var hideToolbar = props.hideToolbar, toolbarBottom = props.toolbarBottom, placement = props.placement, overflow = props.overflow, prefixCls = props.prefixCls;
    if (hideToolbar || placement === 'bottom' && !toolbarBottom || placement === 'top' && toolbarBottom) return null;
    var cls = toolbarBottom ? 'bottom' : '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f179cc69962c631d$export$2e2bcd8739ae039, {
        prefixCls: prefixCls,
        overflow: overflow,
        className: cls
    });
}



var $7fPBF = parcelRequire("7fPBF");


var $d1a159730de79d31$var$DragBar = (props)=>{
    var _ref = props || {}, prefixCls = _ref.prefixCls, onChange = _ref.onChange;
    var $dom = (0, $7fPBF.useRef)(null);
    var dragRef = (0, $7fPBF.useRef)();
    var heightRef = (0, $7fPBF.useRef)(props.height);
    (0, $7fPBF.useEffect)(()=>{
        if (heightRef.current !== props.height) heightRef.current = props.height;
    }, [
        props.height
    ]);
    function handleMouseMove(event) {
        if (dragRef.current) {
            var _changedTouches$;
            var clientY = event.clientY || ((_changedTouches$ = event.changedTouches[0]) == null ? void 0 : _changedTouches$.clientY);
            var newHeight = dragRef.current.height + clientY - dragRef.current.dragY;
            if (newHeight >= props.minHeight && newHeight <= props.maxHeight) onChange && onChange(dragRef.current.height + (clientY - dragRef.current.dragY));
        }
    }
    function handleMouseUp() {
        var _$dom$current, _$dom$current2;
        dragRef.current = undefined;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        (_$dom$current = $dom.current) == null || _$dom$current.removeEventListener('touchmove', handleMouseMove);
        (_$dom$current2 = $dom.current) == null || _$dom$current2.removeEventListener('touchend', handleMouseUp);
    }
    function handleMouseDown(event) {
        var _changedTouches$2, _$dom$current3, _$dom$current4;
        event.preventDefault();
        var clientY = event.clientY || ((_changedTouches$2 = event.changedTouches[0]) == null ? void 0 : _changedTouches$2.clientY);
        dragRef.current = {
            height: heightRef.current,
            dragY: clientY
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        (_$dom$current3 = $dom.current) == null || _$dom$current3.addEventListener('touchmove', handleMouseMove, {
            passive: false
        });
        (_$dom$current4 = $dom.current) == null || _$dom$current4.addEventListener('touchend', handleMouseUp, {
            passive: false
        });
    }
    (0, $7fPBF.useEffect)(()=>{
        if (document) {
            var _$dom$current5, _$dom$current6;
            (_$dom$current5 = $dom.current) == null || _$dom$current5.addEventListener('touchstart', handleMouseDown, {
                passive: false
            });
            (_$dom$current6 = $dom.current) == null || _$dom$current6.addEventListener('mousedown', handleMouseDown);
        }
        return ()=>{
            if (document) {
                var _$dom$current7;
                (_$dom$current7 = $dom.current) == null || _$dom$current7.removeEventListener('touchstart', handleMouseDown);
                document.removeEventListener('mousemove', handleMouseMove);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var svg = (0, $7fPBF.useMemo)(()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
            viewBox: "0 0 512 512",
            height: "100%",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "currentColor",
                d: "M304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm120-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-336 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
            })
        }), []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: prefixCls + "-bar",
        ref: $dom,
        children: svg
    });
};
var $d1a159730de79d31$export$2e2bcd8739ae039 = $d1a159730de79d31$var$DragBar;





var $00681bcf7f1f5fc5$var$_excluded = [
    "prefixCls",
    "className",
    "value",
    "commands",
    "commandsFilter",
    "direction",
    "extraCommands",
    "height",
    "enableScroll",
    "visibleDragbar",
    "highlightEnable",
    "preview",
    "fullscreen",
    "overflow",
    "previewOptions",
    "textareaProps",
    "maxHeight",
    "minHeight",
    "autoFocus",
    "autoFocusEnd",
    "tabSize",
    "defaultTabEnable",
    "onChange",
    "onStatistics",
    "onHeightChange",
    "hideToolbar",
    "toolbarBottom",
    "components",
    "renderTextarea"
];
function $00681bcf7f1f5fc5$var$setGroupPopFalse(data) {
    if (data === void 0) data = {};
    Object.keys(data).forEach((keyname)=>{
        data[keyname] = false;
    });
    return data;
}
function $00681bcf7f1f5fc5$export$182e06dc4f3a32f9(options) {
    var MarkdownPreview = options.MarkdownPreview, TextArea = options.TextArea;
    var PreviewComponent = MarkdownPreview;
    var TextAreaComponent = TextArea;
    var InternalMDEditor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
        var _ref = props || {}, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'w-md-editor' : _ref$prefixCls, className = _ref.className, propsValue = _ref.value, _ref$commands = _ref.commands, commands = _ref$commands === void 0 ? (0, $85b654349d31b699$export$7a6092e2ae7e1845)() : _ref$commands, commandsFilter = _ref.commandsFilter, direction = _ref.direction, _ref$extraCommands = _ref.extraCommands, extraCommands = _ref$extraCommands === void 0 ? (0, $85b654349d31b699$export$6e591f5fe2c6ad02)() : _ref$extraCommands, _ref$height = _ref.height, height = _ref$height === void 0 ? 200 : _ref$height, _ref$enableScroll = _ref.enableScroll, enableScroll = _ref$enableScroll === void 0 ? true : _ref$enableScroll, _ref$visibleDragbar = _ref.visibleDragbar, visibleDragbar = _ref$visibleDragbar === void 0 ? typeof props.visiableDragbar === 'boolean' ? props.visiableDragbar : true : _ref$visibleDragbar, _ref$highlightEnable = _ref.highlightEnable, highlightEnable = _ref$highlightEnable === void 0 ? true : _ref$highlightEnable, _ref$preview = _ref.preview, previewType = _ref$preview === void 0 ? 'live' : _ref$preview, _ref$fullscreen = _ref.fullscreen, fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? true : _ref$overflow, _ref$previewOptions = _ref.previewOptions, previewOptions = _ref$previewOptions === void 0 ? {} : _ref$previewOptions, textareaProps = _ref.textareaProps, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? 1200 : _ref$maxHeight, _ref$minHeight = _ref.minHeight, minHeight = _ref$minHeight === void 0 ? 100 : _ref$minHeight, autoFocus = _ref.autoFocus, _ref$autoFocusEnd = _ref.autoFocusEnd, autoFocusEnd = _ref$autoFocusEnd === void 0 ? false : _ref$autoFocusEnd, _ref$tabSize = _ref.tabSize, tabSize = _ref$tabSize === void 0 ? 2 : _ref$tabSize, _ref$defaultTabEnable = _ref.defaultTabEnable, defaultTabEnable = _ref$defaultTabEnable === void 0 ? false : _ref$defaultTabEnable, onChange = _ref.onChange, onStatistics = _ref.onStatistics, onHeightChange = _ref.onHeightChange, hideToolbar = _ref.hideToolbar, _ref$toolbarBottom = _ref.toolbarBottom, toolbarBottom = _ref$toolbarBottom === void 0 ? false : _ref$toolbarBottom, components = _ref.components, renderTextarea = _ref.renderTextarea, other = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $00681bcf7f1f5fc5$var$_excluded);
        var cmds = commands.map((item)=>commandsFilter ? commandsFilter(item, false) : item).filter(Boolean);
        var extraCmds = extraCommands.map((item)=>commandsFilter ? commandsFilter(item, true) : item).filter(Boolean);
        var _useReducer = (0, $7fPBF.useReducer)((0, $7c2cb0ce17642c75$export$1650419e431d3ba3), {
            markdown: propsValue,
            preview: previewType,
            components: components,
            height: height,
            minHeight: minHeight,
            highlightEnable: highlightEnable,
            tabSize: tabSize,
            defaultTabEnable: defaultTabEnable,
            scrollTop: 0,
            scrollTopPreview: 0,
            commands: cmds,
            extraCommands: extraCmds,
            fullscreen: fullscreen,
            barPopup: {}
        }), state = _useReducer[0], dispatch = _useReducer[1];
        var container = (0, $7fPBF.useRef)(null);
        var previewRef = (0, $7fPBF.useRef)(null);
        var enableScrollRef = (0, $7fPBF.useRef)(enableScroll);
        (0, $7fPBF.useImperativeHandle)(ref, ()=>(0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                container: container.current,
                dispatch: dispatch
            }));
        (0, $7fPBF.useMemo)(()=>enableScrollRef.current = enableScroll, [
            enableScroll
        ]);
        (0, $7fPBF.useEffect)(()=>{
            var stateInit = {};
            if (container.current) stateInit.container = container.current || undefined;
            stateInit.markdown = propsValue || '';
            stateInit.barPopup = {};
            if (dispatch) dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, stateInit));
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        var cls = [
            className,
            'wmde-markdown-var',
            direction ? prefixCls + "-" + direction : null,
            prefixCls,
            state.preview ? prefixCls + "-show-" + state.preview : null,
            state.fullscreen ? prefixCls + "-fullscreen" : null
        ].filter(Boolean).join(' ').trim();
        (0, $7fPBF.useMemo)(()=>propsValue !== state.markdown && dispatch({
                markdown: propsValue || ''
            }), [
            propsValue,
            state.markdown
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (0, $7fPBF.useMemo)(()=>previewType !== state.preview && dispatch({
                preview: previewType
            }), [
            previewType
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (0, $7fPBF.useMemo)(()=>tabSize !== state.tabSize && dispatch({
                tabSize: tabSize
            }), [
            tabSize
        ]);
        (0, $7fPBF.useMemo)(()=>highlightEnable !== state.highlightEnable && dispatch({
                highlightEnable: highlightEnable
            }), // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            highlightEnable
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (0, $7fPBF.useMemo)(()=>autoFocus !== state.autoFocus && dispatch({
                autoFocus: autoFocus
            }), [
            autoFocus
        ]);
        (0, $7fPBF.useMemo)(()=>autoFocusEnd !== state.autoFocusEnd && dispatch({
                autoFocusEnd: autoFocusEnd
            }), [
            autoFocusEnd
        ]);
        (0, $7fPBF.useMemo)(()=>fullscreen !== state.fullscreen && dispatch({
                fullscreen: fullscreen
            }), // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            fullscreen
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (0, $7fPBF.useMemo)(()=>height !== state.height && dispatch({
                height: height
            }), [
            height
        ]);
        (0, $7fPBF.useMemo)(()=>height !== state.height && onHeightChange && onHeightChange(state.height, height, state), [
            height,
            onHeightChange,
            state
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (0, $7fPBF.useMemo)(()=>commands !== state.commands && dispatch({
                commands: cmds
            }), [
            props.commands
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (0, $7fPBF.useMemo)(()=>extraCommands !== state.extraCommands && dispatch({
                extraCommands: extraCmds
            }), [
            props.extraCommands
        ]);
        var textareaDomRef = (0, $7fPBF.useRef)();
        var active = (0, $7fPBF.useRef)('preview');
        var initScroll = (0, $7fPBF.useRef)(false);
        (0, $7fPBF.useMemo)(()=>{
            textareaDomRef.current = state.textareaWarp;
            if (state.textareaWarp) {
                state.textareaWarp.addEventListener('mouseover', ()=>{
                    active.current = 'text';
                });
                state.textareaWarp.addEventListener('mouseleave', ()=>{
                    active.current = 'preview';
                });
            }
        }, [
            state.textareaWarp
        ]);
        var handleScroll = (e, type)=>{
            if (!enableScrollRef.current) return;
            var textareaDom = textareaDomRef.current;
            var previewDom = previewRef.current ? previewRef.current : undefined;
            if (!initScroll.current) {
                active.current = type;
                initScroll.current = true;
            }
            if (textareaDom && previewDom) {
                var scale = (textareaDom.scrollHeight - textareaDom.offsetHeight) / (previewDom.scrollHeight - previewDom.offsetHeight);
                if (e.target === textareaDom && active.current === 'text') previewDom.scrollTop = textareaDom.scrollTop / scale;
                if (e.target === previewDom && active.current === 'preview') textareaDom.scrollTop = previewDom.scrollTop * scale;
                var scrollTop = 0;
                if (active.current === 'text') scrollTop = textareaDom.scrollTop || 0;
                else if (active.current === 'preview') scrollTop = previewDom.scrollTop || 0;
                dispatch({
                    scrollTop: scrollTop
                });
            }
        };
        var previewClassName = prefixCls + "-preview " + (previewOptions.className || '');
        var handlePreviewScroll = (e)=>handleScroll(e, 'preview');
        var mdPreview = (0, $7fPBF.useMemo)(()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                ref: previewRef,
                className: previewClassName,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PreviewComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, previewOptions, {
                    onScroll: handlePreviewScroll,
                    source: state.markdown || ''
                }))
            }), [
            previewClassName,
            previewOptions,
            state.markdown
        ]);
        var preview = (components == null ? void 0 : components.preview) && (components == null ? void 0 : components.preview(state.markdown || '', state, dispatch));
        if (preview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(preview)) mdPreview = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: previewClassName,
            ref: previewRef,
            onScroll: handlePreviewScroll,
            children: preview
        });
        var containerStyle = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, other.style, {
            height: state.height || '100%'
        });
        var containerClick = ()=>dispatch({
                barPopup: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $00681bcf7f1f5fc5$var$setGroupPopFalse(state.barPopup))
            });
        var dragBarChange = (newHeight)=>dispatch({
                height: newHeight
            });
        var changeHandle = (evn)=>{
            onChange && onChange(evn.target.value, evn, state);
            if (textareaProps && textareaProps.onChange) textareaProps.onChange(evn);
            if (state.textarea && state.textarea instanceof HTMLTextAreaElement && onStatistics) {
                var obj = new (0, $85b654349d31b699$export$7987eb6974342a3c)(state.textarea);
                var objState = obj.getState() || {};
                onStatistics((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, objState, {
                    lineCount: evn.target.value.split('\n').length,
                    length: evn.target.value.length
                }));
            }
        };
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c2cb0ce17642c75$export$27b8dd149e32f6c7).Provider, {
            value: (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, {
                dispatch: dispatch
            }),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                ref: container,
                className: cls
            }, other, {
                onClick: containerClick,
                style: containerStyle,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f179cc69962c631d$export$f8f240f0d25ce088), {
                        hideToolbar: hideToolbar,
                        toolbarBottom: toolbarBottom,
                        prefixCls: prefixCls,
                        overflow: overflow,
                        placement: "top"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: prefixCls + "-content",
                        children: [
                            /(edit|live)/.test(state.preview || '') && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(TextAreaComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                                className: prefixCls + "-input",
                                prefixCls: prefixCls,
                                autoFocus: autoFocus
                            }, textareaProps, {
                                onChange: changeHandle,
                                renderTextarea: (components == null ? void 0 : components.textarea) || renderTextarea,
                                onScroll: (e)=>handleScroll(e, 'text')
                            })),
                            /(live|preview)/.test(state.preview || '') && mdPreview
                        ]
                    }),
                    visibleDragbar && !state.fullscreen && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a159730de79d31$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        height: state.height,
                        maxHeight: maxHeight,
                        minHeight: minHeight,
                        onChange: dragBarChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f179cc69962c631d$export$f8f240f0d25ce088), {
                        hideToolbar: hideToolbar,
                        toolbarBottom: toolbarBottom,
                        prefixCls: prefixCls,
                        overflow: overflow,
                        placement: "bottom"
                    })
                ]
            }))
        });
    });
    var Editor = InternalMDEditor;
    Editor.Markdown = MarkdownPreview;
    Editor.displayName = 'MDEditor';
    return Editor;
}


var $e910b812779972f8$export$2e2bcd8739ae039 = (0, $00681bcf7f1f5fc5$export$182e06dc4f3a32f9)({
    MarkdownPreview: $7b0fa6cba31fe01a$export$2e2bcd8739ae039,
    TextArea: $33ce618c4c7bcc53$export$2e2bcd8739ae039
});













var $a046c90ce2b9f87e$export$2e2bcd8739ae039 = (0, $e910b812779972f8$export$2e2bcd8739ae039);





/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-sanitize').Schema} Schema
 */ /**
 * @import {
 *   Comment,
 *   Doctype,
 *   ElementContent,
 *   Element,
 *   Nodes,
 *   Properties,
 *   RootContent,
 *   Root,
 *   Text
 * } from 'hast'
 */ /**
 * @typedef {[string, ...Array<Exclude<Properties[keyof Properties], Array<any>> | RegExp>] | string} PropertyDefinition
 *   Definition for a property.
 *
 * @typedef Schema
 *   Schema that defines what nodes and properties are allowed.
 *
 *   The default schema is `defaultSchema`, which follows how GitHub cleans.
 *   If any top-level key is missing in the given schema, the corresponding
 *   value of the default schema is used.
 *
 *   To extend the standard schema with a few changes, clone `defaultSchema`
 *   like so:
 *
 *   ```js
 *   import deepmerge from 'deepmerge'
 *   import {h} from 'hastscript'
 *   import {defaultSchema, sanitize} from 'hast-util-sanitize'
 *
 *   // This allows `className` on all elements.
 *   const schema = deepmerge(defaultSchema, {attributes: {'*': ['className']}})
 *
 *   const tree = sanitize(h('div', {className: ['foo']}), schema)
 *
 *   // `tree` still has `className`.
 *   console.log(tree)
 *   // {
 *   //   type: 'element',
 *   //   tagName: 'div',
 *   //   properties: {className: ['foo']},
 *   //   children: []
 *   // }
 *   ```
 * @property {boolean | null | undefined} [allowComments=false]
 *   Whether to allow comment nodes (default: `false`).
 *
 *   For example:
 *
 *   ```js
 *   allowComments: true
 *   ```
 * @property {boolean | null | undefined} [allowDoctypes=false]
 *   Whether to allow doctype nodes (default: `false`).
 *
 *   For example:
 *
 *   ```js
 *   allowDoctypes: true
 *   ```
 * @property {Record<string, Array<string>> | null | undefined} [ancestors]
 *   Map of tag names to a list of tag names which are required ancestors
 *   (default: `defaultSchema.ancestors`).
 *
 *   Elements with these tag names will be ignored if they occur outside of one
 *   of their allowed parents.
 *
 *   For example:
 *
 *   ```js
 *   ancestors: {
 *     tbody: ['table'],
 *     // …
 *     tr: ['table']
 *   }
 *   ```
 * @property {Record<string, Array<PropertyDefinition>> | null | undefined} [attributes]
 *   Map of tag names to allowed property names (default:
 *   `defaultSchema.attributes`).
 *
 *   The special key `'*'` as a tag name defines property names allowed on all
 *   elements.
 *
 *   The special value `'data*'` as a property name can be used to allow all
 *   `data` properties.
 *
 *   For example:
 *
 *   ```js
 *   attributes: {
 *     'ariaDescribedBy', 'ariaLabel', 'ariaLabelledBy', …, 'href'
 *     // …
 *     '*': [
 *       'abbr',
 *       'accept',
 *       'acceptCharset',
 *       // …
 *       'vAlign',
 *       'value',
 *       'width'
 *     ]
 *   }
 *   ```
 *
 *   Instead of a single string in the array, which allows any property value
 *   for the field, you can use an array to allow several values.
 *   For example, `input: ['type']` allows `type` set to any value on `input`s.
 *   But `input: [['type', 'checkbox', 'radio']]` allows `type` when set to
 *   `'checkbox'` or `'radio'`.
 *
 *   You can use regexes, so for example `span: [['className', /^hljs-/]]`
 *   allows any class that starts with `hljs-` on `span`s.
 *
 *   When comma- or space-separated values are used (such as `className`), each
 *   value in is checked individually.
 *   For example, to allow certain classes on `span`s for syntax highlighting,
 *   use `span: [['className', 'number', 'operator', 'token']]`.
 *   This will allow `'number'`, `'operator'`, and `'token'` classes, but drop
 *   others.
 * @property {Array<string> | null | undefined} [clobber]
 *   List of property names that clobber (default: `defaultSchema.clobber`).
 *
 *   For example:
 *
 *   ```js
 *   clobber: ['ariaDescribedBy', 'ariaLabelledBy', 'id', 'name']
 *   ```
 * @property {string | null | undefined} [clobberPrefix]
 *   Prefix to use before clobbering properties (default:
 *   `defaultSchema.clobberPrefix`).
 *
 *   For example:
 *
 *   ```js
 *   clobberPrefix: 'user-content-'
 *   ```
 * @property {Record<string, Array<string> | null | undefined> | null | undefined} [protocols]
 *   Map of *property names* to allowed protocols (default:
 *   `defaultSchema.protocols`).
 *
 *   This defines URLs that are always allowed to have local URLs (relative to
 *   the current website, such as `this`, `#this`, `/this`, or `?this`), and
 *   only allowed to have remote URLs (such as `https://example.com`) if they
 *   use a known protocol.
 *
 *   For example:
 *
 *   ```js
 *   protocols: {
 *     cite: ['http', 'https'],
 *     // …
 *     src: ['http', 'https']
 *   }
 *   ```
 * @property {Record<string, Record<string, Properties[keyof Properties]>> | null | undefined} [required]
 *   Map of tag names to required property names with a default value
 *   (default: `defaultSchema.required`).
 *
 *   This defines properties that must be set.
 *   If a field does not exist (after the element was made safe), these will be
 *   added with the given value.
 *
 *   For example:
 *
 *   ```js
 *   required: {
 *     input: {disabled: true, type: 'checkbox'}
 *   }
 *   ```
 *
 *   > 👉 **Note**: properties are first checked based on `schema.attributes`,
 *   > then on `schema.required`.
 *   > That means properties could be removed by `attributes` and then added
 *   > again with `required`.
 * @property {Array<string> | null | undefined} [strip]
 *   List of tag names to strip from the tree (default: `defaultSchema.strip`).
 *
 *   By default, unsafe elements (those not in `schema.tagNames`) are replaced
 *   by what they contain.
 *   This option can drop their contents.
 *
 *   For example:
 *
 *   ```js
 *   strip: ['script']
 *   ```
 * @property {Array<string> | null | undefined} [tagNames]
 *   List of allowed tag names (default: `defaultSchema.tagNames`).
 *
 *   For example:
 *
 *   ```js
 *   tagNames: [
 *     'a',
 *     'b',
 *     // …
 *     'ul',
 *     'var'
 *   ]
 *   ```
 *
 * @typedef State
 *   Info passed around.
 * @property {Readonly<Schema>} schema
 *   Schema.
 * @property {Array<string>} stack
 *   Tag names of ancestors.
 */ 


/**
 * @import {Schema} from 'hast-util-sanitize'
 */ // Couple of ARIA attributes allowed in several, but not all, places.
const $b4cfe5f2a3f70524$var$aria = [
    'ariaDescribedBy',
    'ariaLabel',
    'ariaLabelledBy'
];
const $b4cfe5f2a3f70524$export$1db618b7b2275ea1 = {
    ancestors: {
        tbody: [
            'table'
        ],
        td: [
            'table'
        ],
        th: [
            'table'
        ],
        thead: [
            'table'
        ],
        tfoot: [
            'table'
        ],
        tr: [
            'table'
        ]
    },
    attributes: {
        a: [
            ...$b4cfe5f2a3f70524$var$aria,
            // Note: these 3 are used by GFM footnotes, they do work on all links.
            'dataFootnoteBackref',
            'dataFootnoteRef',
            [
                'className',
                'data-footnote-backref'
            ],
            'href'
        ],
        blockquote: [
            'cite'
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `code` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        code: [
            [
                'className',
                /^language-./
            ]
        ],
        del: [
            'cite'
        ],
        div: [
            'itemScope',
            'itemType'
        ],
        dl: [
            ...$b4cfe5f2a3f70524$var$aria
        ],
        // Note: this is used by GFM footnotes.
        h2: [
            [
                'className',
                'sr-only'
            ]
        ],
        img: [
            ...$b4cfe5f2a3f70524$var$aria,
            'longDesc',
            'src'
        ],
        // Note: `input` is not normally allowed by GH, when manually writing
        // it in markdown, they add it from tasklists some other way.
        // We can’t do that, so we have to allow it.
        input: [
            [
                'disabled',
                true
            ],
            [
                'type',
                'checkbox'
            ]
        ],
        ins: [
            'cite'
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `li` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        li: [
            [
                'className',
                'task-list-item'
            ]
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `ol` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        ol: [
            ...$b4cfe5f2a3f70524$var$aria,
            [
                'className',
                'contains-task-list'
            ]
        ],
        q: [
            'cite'
        ],
        section: [
            'dataFootnotes',
            [
                'className',
                'footnotes'
            ]
        ],
        source: [
            'srcSet'
        ],
        summary: [
            ...$b4cfe5f2a3f70524$var$aria
        ],
        table: [
            ...$b4cfe5f2a3f70524$var$aria
        ],
        // Note: this class is not normally allowed by GH, when manually writing
        // `ol` as HTML in markdown, they adds it some other way.
        // We can’t do that, so we have to allow it.
        ul: [
            ...$b4cfe5f2a3f70524$var$aria,
            [
                'className',
                'contains-task-list'
            ]
        ],
        '*': [
            'abbr',
            'accept',
            'acceptCharset',
            'accessKey',
            'action',
            'align',
            'alt',
            'axis',
            'border',
            'cellPadding',
            'cellSpacing',
            'char',
            'charOff',
            'charSet',
            'checked',
            'clear',
            'colSpan',
            'color',
            'cols',
            'compact',
            'coords',
            'dateTime',
            'dir',
            // Note: `disabled` is technically allowed on all elements by GH.
            // But it is useless on everything except `input`.
            // Because `input`s are normally not allowed, but we allow them for
            // checkboxes due to tasklists, we allow `disabled` only there.
            'encType',
            'frame',
            'hSpace',
            'headers',
            'height',
            'hrefLang',
            'htmlFor',
            'id',
            'isMap',
            'itemProp',
            'label',
            'lang',
            'maxLength',
            'media',
            'method',
            'multiple',
            'name',
            'noHref',
            'noShade',
            'noWrap',
            'open',
            'prompt',
            'readOnly',
            'rev',
            'rowSpan',
            'rows',
            'rules',
            'scope',
            'selected',
            'shape',
            'size',
            'span',
            'start',
            'summary',
            'tabIndex',
            'title',
            'useMap',
            'vAlign',
            'value',
            'width'
        ]
    },
    clobber: [
        'ariaDescribedBy',
        'ariaLabelledBy',
        'id',
        'name'
    ],
    clobberPrefix: 'user-content-',
    protocols: {
        cite: [
            'http',
            'https'
        ],
        href: [
            'http',
            'https',
            'irc',
            'ircs',
            'mailto',
            'xmpp'
        ],
        longDesc: [
            'http',
            'https'
        ],
        src: [
            'http',
            'https'
        ]
    },
    required: {
        input: {
            disabled: true,
            type: 'checkbox'
        }
    },
    strip: [
        'script'
    ],
    tagNames: [
        'a',
        'b',
        'blockquote',
        'br',
        'code',
        'dd',
        'del',
        'details',
        'div',
        'dl',
        'dt',
        'em',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hr',
        'i',
        'img',
        // Note: `input` is not normally allowed by GH, when manually writing
        // it in markdown, they add it from tasklists some other way.
        // We can’t do that, so we have to allow it.
        'input',
        'ins',
        'kbd',
        'li',
        'ol',
        'p',
        'picture',
        'pre',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'source',
        'span',
        'strike',
        'strong',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr',
        'tt',
        'ul',
        'var'
    ]
};


const $d53ef575c839fd46$var$own = {}.hasOwnProperty;
function $d53ef575c839fd46$export$83d2e9e3e4ee39ed(node, options) {
    /** @type {Nodes} */ let result = {
        type: 'root',
        children: []
    };
    /** @type {State} */ const state = {
        schema: options ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $b4cfe5f2a3f70524$export$1db618b7b2275ea1), options) : (0, $b4cfe5f2a3f70524$export$1db618b7b2275ea1),
        stack: []
    };
    const replace = $d53ef575c839fd46$var$transform(state, node);
    if (replace) {
        if (Array.isArray(replace)) {
            if (replace.length === 1) result = replace[0];
            else result.children = replace;
        } else result = replace;
    }
    return result;
}
/**
 * Sanitize `node`.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} node
 *   Unsafe node.
 * @returns {Array<ElementContent> | Nodes | undefined}
 *   Safe result.
 */ function $d53ef575c839fd46$var$transform(state, node) {
    if (node && typeof node === 'object') {
        const unsafe = /** @type {Record<string, Readonly<unknown>>} */ node;
        const type = typeof unsafe.type === 'string' ? unsafe.type : '';
        switch(type){
            case 'comment':
                return $d53ef575c839fd46$var$comment(state, unsafe);
            case 'doctype':
                return $d53ef575c839fd46$var$doctype(state, unsafe);
            case 'element':
                return $d53ef575c839fd46$var$element(state, unsafe);
            case 'root':
                return $d53ef575c839fd46$var$root(state, unsafe);
            case 'text':
                return $d53ef575c839fd46$var$text(state, unsafe);
            default:
        }
    }
}
/**
 * Make a safe comment.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe comment-like value.
 * @returns {Comment | undefined}
 *   Safe comment (if with `allowComments`).
 */ function $d53ef575c839fd46$var$comment(state, unsafe) {
    if (state.schema.allowComments) {
        // See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
        const result = typeof unsafe.value === 'string' ? unsafe.value : '';
        const index = result.indexOf('-->');
        const value = index < 0 ? result : result.slice(0, index);
        /** @type {Comment} */ const node = {
            type: 'comment',
            value: value
        };
        $d53ef575c839fd46$var$patch(node, unsafe);
        return node;
    }
}
/**
 * Make a safe doctype.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe doctype-like value.
 * @returns {Doctype | undefined}
 *   Safe doctype (if with `allowDoctypes`).
 */ function $d53ef575c839fd46$var$doctype(state, unsafe) {
    if (state.schema.allowDoctypes) {
        /** @type {Doctype} */ const node = {
            type: 'doctype'
        };
        $d53ef575c839fd46$var$patch(node, unsafe);
        return node;
    }
}
/**
 * Make a safe element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe element-like value.
 * @returns {Array<ElementContent> | Element | undefined}
 *   Safe element.
 */ function $d53ef575c839fd46$var$element(state, unsafe) {
    const name = typeof unsafe.tagName === 'string' ? unsafe.tagName : '';
    state.stack.push(name);
    const content = /** @type {Array<ElementContent>} */ $d53ef575c839fd46$var$children(state, unsafe.children);
    const properties_ = $d53ef575c839fd46$var$properties(state, unsafe.properties);
    state.stack.pop();
    let safeElement = false;
    if (name && name !== '*' && (!state.schema.tagNames || state.schema.tagNames.includes(name))) {
        safeElement = true;
        // Some nodes can break out of their context if they don’t have a certain
        // ancestor.
        if (state.schema.ancestors && $d53ef575c839fd46$var$own.call(state.schema.ancestors, name)) {
            const ancestors = state.schema.ancestors[name];
            let index = -1;
            safeElement = false;
            while(++index < ancestors.length)if (state.stack.includes(ancestors[index])) safeElement = true;
        }
    }
    if (!safeElement) return state.schema.strip && !state.schema.strip.includes(name) ? content : undefined;
    /** @type {Element} */ const node = {
        type: 'element',
        tagName: name,
        properties: properties_,
        children: content
    };
    $d53ef575c839fd46$var$patch(node, unsafe);
    return node;
}
/**
 * Make a safe root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe root-like value.
 * @returns {Root}
 *   Safe root.
 */ function $d53ef575c839fd46$var$root(state, unsafe) {
    const content = /** @type {Array<RootContent>} */ $d53ef575c839fd46$var$children(state, unsafe.children);
    /** @type {Root} */ const node = {
        type: 'root',
        children: content
    };
    $d53ef575c839fd46$var$patch(node, unsafe);
    return node;
}
/**
 * Make a safe text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe text-like value.
 * @returns {Text}
 *   Safe text.
 */ function $d53ef575c839fd46$var$text(_, unsafe) {
    const value = typeof unsafe.value === 'string' ? unsafe.value : '';
    /** @type {Text} */ const node = {
        type: 'text',
        value: value
    };
    $d53ef575c839fd46$var$patch(node, unsafe);
    return node;
}
/**
 * Make children safe.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} children
 *   Unsafe value.
 * @returns {Array<Nodes>}
 *   Safe children.
 */ function $d53ef575c839fd46$var$children(state, children) {
    /** @type {Array<Nodes>} */ const results = [];
    if (Array.isArray(children)) {
        const childrenUnknown = /** @type {Array<Readonly<unknown>>} */ children;
        let index = -1;
        while(++index < childrenUnknown.length){
            const value = $d53ef575c839fd46$var$transform(state, childrenUnknown[index]);
            if (value) {
                if (Array.isArray(value)) results.push(...value);
                else results.push(value);
            }
        }
    }
    return results;
}
/**
 * Make element properties safe.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<unknown>} properties
 *   Unsafe value.
 * @returns {Properties}
 *   Safe value.
 */ function $d53ef575c839fd46$var$properties(state, properties) {
    const tagName = state.stack[state.stack.length - 1];
    const attributes = state.schema.attributes;
    const required = state.schema.required;
    const specific = attributes && $d53ef575c839fd46$var$own.call(attributes, tagName) ? attributes[tagName] : undefined;
    const defaults = attributes && $d53ef575c839fd46$var$own.call(attributes, '*') ? attributes['*'] : undefined;
    const properties_ = /** @type {Readonly<Record<string, Readonly<unknown>>>} */ properties && typeof properties === 'object' ? properties : {};
    /** @type {Properties} */ const result = {};
    /** @type {string} */ let key;
    for(key in properties_)if ($d53ef575c839fd46$var$own.call(properties_, key)) {
        const unsafe = properties_[key];
        let safe = $d53ef575c839fd46$var$propertyValue(state, $d53ef575c839fd46$var$findDefinition(specific, key), key, unsafe);
        if (safe === null || safe === undefined) safe = $d53ef575c839fd46$var$propertyValue(state, $d53ef575c839fd46$var$findDefinition(defaults, key), key, unsafe);
        if (safe !== null && safe !== undefined) result[key] = safe;
    }
    if (required && $d53ef575c839fd46$var$own.call(required, tagName)) {
        const properties = required[tagName];
        for(key in properties)if ($d53ef575c839fd46$var$own.call(properties, key) && !$d53ef575c839fd46$var$own.call(result, key)) result[key] = properties[key];
    }
    return result;
}
/**
 * Sanitize a property value.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition> | undefined} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value (but an array).
 * @returns {Array<number | string> | boolean | number | string | undefined}
 *   Safe value.
 */ function $d53ef575c839fd46$var$propertyValue(state, definition, key, value) {
    return definition ? Array.isArray(value) ? $d53ef575c839fd46$var$propertyValueMany(state, definition, key, value) : $d53ef575c839fd46$var$propertyValuePrimitive(state, definition, key, value) : undefined;
}
/**
 * Sanitize a property value which is a list.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition>} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<Array<Readonly<unknown>>>} values
 *   Unsafe value (but an array).
 * @returns {Array<number | string>}
 *   Safe value.
 */ function $d53ef575c839fd46$var$propertyValueMany(state, definition, key, values) {
    let index = -1;
    /** @type {Array<number | string>} */ const result = [];
    while(++index < values.length){
        const value = $d53ef575c839fd46$var$propertyValuePrimitive(state, definition, key, values[index]);
        if (typeof value === 'number' || typeof value === 'string') result.push(value);
    }
    return result;
}
/**
 * Sanitize a property value which is a primitive.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Readonly<PropertyDefinition>} definition
 *   Definition.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value (but not an array).
 * @returns {boolean | number | string | undefined}
 *   Safe value.
 */ function $d53ef575c839fd46$var$propertyValuePrimitive(state, definition, key, value) {
    if (typeof value !== 'boolean' && typeof value !== 'number' && typeof value !== 'string') return;
    if (!$d53ef575c839fd46$var$safeProtocol(state, key, value)) return;
    // Just a string, or only one item in an array, means all values are OK.
    // More than one item means an allow list.
    if (typeof definition === 'object' && definition.length > 1) {
        let ok = false;
        let index = 0 // Ignore `key`, which is the first item.
        ;
        while(++index < definition.length){
            const allowed = definition[index];
            // Expression.
            if (allowed && typeof allowed === 'object' && 'flags' in allowed) {
                if (allowed.test(String(value))) {
                    ok = true;
                    break;
                }
            } else if (allowed === value) {
                ok = true;
                break;
            }
        }
        if (!ok) return;
    }
    return state.schema.clobber && state.schema.clobberPrefix && state.schema.clobber.includes(key) ? state.schema.clobberPrefix + value : value;
}
/**
 * Check whether `value` is a safe URL.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} key
 *   Field name.
 * @param {Readonly<unknown>} value
 *   Unsafe value.
 * @returns {boolean}
 *   Whether it’s a safe value.
 */ function $d53ef575c839fd46$var$safeProtocol(state, key, value) {
    const protocols = state.schema.protocols && $d53ef575c839fd46$var$own.call(state.schema.protocols, key) ? state.schema.protocols[key] : undefined;
    // No protocols defined? Then everything is fine.
    if (!protocols || protocols.length === 0) return true;
    const url = String(value);
    const colon = url.indexOf(':');
    const questionMark = url.indexOf('?');
    const numberSign = url.indexOf('#');
    const slash = url.indexOf('/');
    if (colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign) return true;
    let index = -1;
    while(++index < protocols.length){
        const protocol = protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length) === protocol) return true;
    }
    return false;
}
/**
 * Add data and position.
 *
 * @param {Nodes} node
 *   Node to patch safe data and position on.
 * @param {Readonly<Record<string, Readonly<unknown>>>} unsafe
 *   Unsafe node-like value.
 * @returns {undefined}
 *   Nothing.
 */ function $d53ef575c839fd46$var$patch(node, unsafe) {
    const cleanPosition = (0, $9861e7b4f8df2806$export$5880b8b5730aff45)(// @ts-expect-error: looks like a node.
    unsafe);
    if (unsafe.data) node.data = (0, $e46c0242ff031819$export$2e2bcd8739ae039)(unsafe.data);
    if (cleanPosition) node.position = cleanPosition;
}
/**
 *
 * @param {Readonly<Array<PropertyDefinition>> | undefined} definitions
 * @param {string} key
 * @returns {Readonly<PropertyDefinition> | undefined}
 */ function $d53ef575c839fd46$var$findDefinition(definitions, key) {
    /** @type {PropertyDefinition | undefined} */ let dataDefault;
    let index = -1;
    if (definitions) while(++index < definitions.length){
        const entry = definitions[index];
        const name = typeof entry === 'string' ? entry : entry[0];
        if (name === key) return entry;
        if (name === 'data*') dataDefault = entry;
    }
    if (key.length > 4 && key.slice(0, 4).toLowerCase() === 'data') return dataDefault;
}


function $952077a98b509239$export$2e2bcd8739ae039(options) {
    /**
   * @param {Root} tree
   *   Tree.
   * @returns {Root}
   *   New tree.
   */ return function(tree) {
        // Assume root in -> root out.
        const result = /** @type {Root} */ (0, $d53ef575c839fd46$export$83d2e9e3e4ee39ed)(tree, options);
        return result;
    };
}


let $230645309166c0ed$var$_ = (t)=>t, $230645309166c0ed$var$t;
function $230645309166c0ed$export$2e2bcd8739ae039({ value: value, onChange: onChange, placeholder: placeholder, disabled: disabled }) {
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($230645309166c0ed$var$Wrapper, {
        "data-color-mode": theme.mode,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a046c90ce2b9f87e$export$2e2bcd8739ae039), {
            value: value,
            onChange: (next)=>onChange(next !== null && next !== void 0 ? next : ''),
            height: 360,
            preview: "edit",
            visibleDragbar: false,
            textareaProps: {
                placeholder: placeholder,
                disabled: disabled
            },
            previewOptions: {
                disallowedElements: [
                    'style',
                    'script'
                ],
                rehypePlugins: [
                    [
                        (0, $952077a98b509239$export$2e2bcd8739ae039)
                    ]
                ]
            }
        })
    });
}
// Match the editor chrome to the app: rounded border + themed surfaces so it doesn't read as a foreign
// widget. The .w-md-editor classes come from @uiw/react-md-editor's stylesheet.
const $230645309166c0ed$var$Wrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($230645309166c0ed$var$t || ($230645309166c0ed$var$t = $230645309166c0ed$var$_`
    .w-md-editor {
        border: 1px solid ${0};
        border-radius: 0.5rem;
        background-color: ${0};
        box-shadow: none;
    }
    .w-md-editor-toolbar {
        background-color: ${0};
        border-bottom: 1px solid ${0};
        border-radius: 0.5rem 0.5rem 0 0;
    }
    .w-md-editor-text,
    .w-md-editor-content {
        background-color: ${0};
    }
`), (props)=>props.theme.color.border, (props)=>props.theme.color.card, (props)=>props.theme.color.accentCard, (props)=>props.theme.color.border, (props)=>props.theme.color.card);


/**
 * Starter templates for the guided skill builder. Each gives the user a well-structured `SKILL.md` for a
 * common use case, so a non-technical author can produce a skill the on-device agent uses reliably. The
 * picker in {@link SkillEditor} (create mode only) drops the chosen template's name/description/keywords/
 * body into the form for editing. Template copy is intentionally plain English (it's authored content,
 * not app chrome); the picker's labels are localized.
 */ const $e49db62d9ee33434$export$9091a65b06f2e4c5 = [
    {
        id: 'blank',
        titleKey: 'common:skills.templates.blank.title',
        titleFallback: 'Blank',
        summaryKey: 'common:skills.templates.blank.summary',
        summaryFallback: 'Start from an empty template.',
        suggestedName: '',
        description: '',
        keywords: [],
        body: ''
    },
    {
        id: 'navigate-app',
        titleKey: 'common:skills.templates.navigateApp.title',
        titleFallback: 'Navigate an app (click in steps)',
        summaryKey: 'common:skills.templates.navigateApp.summary',
        summaryFallback: 'Tell Cephable where to click, step by step, to get through an app.',
        suggestedName: 'navigate-my-app',
        description: "Walk through <App Name> by clicking the right buttons in order. Use when I ask to open, navigate, or do a multi-step task in <App Name>.",
        keywords: [
            'navigate',
            'click',
            'open',
            'app'
        ],
        activation: 'manual',
        body: `# Navigate <App Name>

Step-by-step clicks to get through <App Name>. Replace <App Name> and the button names below with the
real ones from your app.

## When to use this skill
When I ask to open <App Name> or to do a task in it that takes several clicks.

## Steps
1. Make sure <App Name> is the active window. If it isn't, ask me to open it first.
2. Click the "<First button>" button (top-left toolbar).
3. Wait for the "<Panel/dialog name>" to appear, then click "<Next button>".
4. If a confirmation dialog appears, click "Confirm".
5. Tell me when the task is done, or what you see if a step's button isn't there.

## Tips & best practices
- Refer to buttons by their visible label ("Save", "New", "Settings"), not their position, when you can.
- If a button can't be found, describe what's on screen and ask me how to proceed instead of guessing.
- Do one step at a time and check the result before the next click.

## Example
"Open a new invoice in <App Name>" \u{2192} click New \u{2192} click Invoice \u{2192} confirm the blank invoice opened.
`
    },
    {
        id: 'write-text',
        titleKey: 'common:skills.templates.writeText.title',
        titleFallback: 'Write or insert text',
        summaryKey: 'common:skills.templates.writeText.summary',
        summaryFallback: 'Draft text a certain way and type it where I am working.',
        suggestedName: 'write-in-my-style',
        description: "Write text in my preferred style and type it into the active app. Use when I ask to draft, write, or insert a message, note, or reply.",
        keywords: [
            'write',
            'draft',
            'type',
            'insert',
            'message'
        ],
        body: `# Write In My Style

Draft text the way I like it, then type it where my cursor is.

## When to use this skill
When I ask you to write, draft, reply to, or insert text somewhere.

## Style rules
- Tone: <friendly / professional / concise \u{2014} pick one>.
- Length: keep it short unless I ask for more.
- Never include placeholders like "[name]" \u{2014} ask me if you're missing a detail.

## Steps
1. Understand what I want written and who it's for.
2. Draft the text following the style rules above.
3. Show me the draft first if it's important or long; otherwise type it into the active field.
4. Type the text where my cursor is (do not clear existing text unless I ask).

## Example
"Reply thanks and that I'll review it tomorrow" \u{2192} a short, friendly reply typed into the message box.
`
    },
    {
        id: 'fill-form',
        titleKey: 'common:skills.templates.fillForm.title',
        titleFallback: 'Fill out a form',
        summaryKey: 'common:skills.templates.fillForm.summary',
        summaryFallback: 'Fill a form field by field from details I give you.',
        suggestedName: 'fill-my-form',
        description: "Fill out the <Form Name> form field by field from the details I provide. Use when I ask to complete or fill in <Form Name>.",
        keywords: [
            'form',
            'fill',
            'fields',
            'enter',
            'submit'
        ],
        activation: 'manual',
        body: `# Fill Out <Form Name>

Complete <Form Name> one field at a time. Replace the field names below with the real ones.

## When to use this skill
When I ask you to fill in or complete <Form Name>.

## Fields (in order)
1. "<Field 1 label>" \u{2014} <what goes here>.
2. "<Field 2 label>" \u{2014} <what goes here>.
3. "<Field 3 label>" \u{2014} <what goes here>.

## Steps
1. Click the first field, then type its value.
2. Move to the next field (click it, or press Tab) and type its value.
3. Repeat for every field. If I didn't give a value for a field, ask me \u{2014} don't invent one.
4. Do NOT click Submit/Save unless I tell you to. Show me the filled form first.

## Tips & best practices
- Double-check each value after typing it.
- If a field is a dropdown, tell me the options and let me choose.

## Example
"Fill the contact form with my name and email" \u{2192} Name and Email filled, waiting for me to submit.
`
    },
    {
        id: 'summarize-doc',
        titleKey: 'common:skills.templates.summarizeDoc.title',
        titleFallback: 'Summarize a document',
        summaryKey: 'common:skills.templates.summarizeDoc.summary',
        summaryFallback: 'Read a file and give a short, structured summary.',
        suggestedName: 'summarize-document',
        description: "Read a document and produce a short, structured summary. Use when I ask to summarize, recap, or pull the key points from a file.",
        keywords: [
            'summarize',
            'summary',
            'document',
            'recap',
            'key points'
        ],
        body: `# Summarize A Document

Read a file I point you at and summarize it clearly.

## When to use this skill
When I ask you to summarize, recap, or list the key points of a document or file.

## Steps
1. Read the file with your file tools (I'll attach it or tell you where it is).
2. Identify the main topic and the 3\u{2013}5 most important points.
3. Write the summary in this shape:
   - **Topic:** one line.
   - **Key points:** a short bulleted list.
   - **Action items:** anything I need to do (omit if none).
4. Keep it brief \u{2014} aim for well under one screen.

## Tips & best practices
- Use plain language; avoid copying long passages verbatim.
- If the document is very long, summarize section by section, then give an overall summary.

## Example
"Summarize this contract" \u{2192} Topic, key terms as bullets, and any deadlines as action items.
`
    }
];


let $433a5eef705569ef$var$_ = (t)=>t, $433a5eef705569ef$var$t, $433a5eef705569ef$var$t1, $433a5eef705569ef$var$t2, $433a5eef705569ef$var$t3, $433a5eef705569ef$var$t4, $433a5eef705569ef$var$t5, $433a5eef705569ef$var$t6;
/** Localized label for a file kind, shown as a small tag next to each file. */ function $433a5eef705569ef$var$kindLabel(t, kind) {
    switch(kind){
        case 'script':
            return t('skills.files.kind.scriptShort');
        case 'asset':
            return t('skills.files.kind.assetShort');
        default:
            return t('skills.files.kind.referenceShort');
    }
}
function $433a5eef705569ef$export$2e2bcd8739ae039({ skill: skill, initial: initial, data: data, hideFileManager: hideFileManager, hideTemplates: hideTemplates, onDone: onDone, onCancel: onCancel, editorMode: editorMode }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const isEdit = !!skill;
    const canManageFiles = data.capabilities.manageFiles;
    var _skill_name, _ref;
    const [name, setName] = (0, $7fPBF.useState)((_ref = (_skill_name = skill === null || skill === void 0 ? void 0 : skill.name) !== null && _skill_name !== void 0 ? _skill_name : initial === null || initial === void 0 ? void 0 : initial.name) !== null && _ref !== void 0 ? _ref : '');
    var _skill_description, _ref1;
    const [description, setDescription] = (0, $7fPBF.useState)((_ref1 = (_skill_description = skill === null || skill === void 0 ? void 0 : skill.description) !== null && _skill_description !== void 0 ? _skill_description : initial === null || initial === void 0 ? void 0 : initial.description) !== null && _ref1 !== void 0 ? _ref1 : '');
    var _skill_keywords, _ref2;
    const [keywords, setKeywords] = (0, $7fPBF.useState)(((_ref2 = (_skill_keywords = skill === null || skill === void 0 ? void 0 : skill.keywords) !== null && _skill_keywords !== void 0 ? _skill_keywords : initial === null || initial === void 0 ? void 0 : initial.keywords) !== null && _ref2 !== void 0 ? _ref2 : []).join(', '));
    var _initial_body;
    const [body, setBody] = (0, $7fPBF.useState)((_initial_body = initial === null || initial === void 0 ? void 0 : initial.body) !== null && _initial_body !== void 0 ? _initial_body : '');
    // In create mode the body is ready immediately (empty or from a seed); in edit mode we load it below.
    const [bodyLoaded, setBodyLoaded] = (0, $7fPBF.useState)(!isEdit);
    var _skill_activation, _ref3;
    const [activation, setActivation] = (0, $7fPBF.useState)((_ref3 = (_skill_activation = skill === null || skill === void 0 ? void 0 : skill.activation) !== null && _skill_activation !== void 0 ? _skill_activation : initial === null || initial === void 0 ? void 0 : initial.activation) !== null && _ref3 !== void 0 ? _ref3 : (0, $83bad78370366bbe$export$fc097f65acdbbf35));
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [saveError, setSaveError] = (0, $7fPBF.useState)(null);
    const [templateId, setTemplateId] = (0, $7fPBF.useState)(null);
    const [templatesAnchor, setTemplatesAnchor] = (0, $7fPBF.useState)(null);
    // Supporting files. In edit mode these live on disk (loaded below); in create mode they're staged in
    // memory and copied into the new skill after it's created (see handleSave).
    const [files, setFiles] = (0, $7fPBF.useState)([]);
    var _initial_files;
    const [stagedFiles, setStagedFiles] = (0, $7fPBF.useState)(skill ? [] : (_initial_files = initial === null || initial === void 0 ? void 0 : initial.files) !== null && _initial_files !== void 0 ? _initial_files : []);
    const [addFilesAnchor, setAddFilesAnchor] = (0, $7fPBF.useState)(null);
    const applyTemplate = (template)=>{
        setTemplatesAnchor(null);
        setTemplateId(template.id);
        if (template.suggestedName) setName(template.suggestedName);
        setDescription(template.description);
        setKeywords(template.keywords.join(', '));
        setBody(template.body);
        if (template.activation) setActivation(template.activation);
    };
    // Load the existing skill's SKILL.md body for editing (the list payload omits it).
    (0, $7fPBF.useEffect)(()=>{
        if (!skill) return;
        let active = true;
        data.getBody(skill.id).then((loaded)=>{
            if (active) {
                setBody(loaded !== null && loaded !== void 0 ? loaded : '');
                setBodyLoaded(true);
            }
        });
        return ()=>{
            active = false;
        };
    }, [
        skill
    ]);
    // Load the existing skill's supporting files (edit mode only; native file management only).
    (0, $7fPBF.useEffect)(()=>{
        if (!skill || !canManageFiles || !data.listFiles) return;
        let active = true;
        data.listFiles(skill.id).then((f)=>{
            if (active) setFiles(f);
        });
        return ()=>{
            active = false;
        };
    }, [
        skill
    ]);
    const basename = (p)=>{
        var _p_split_pop;
        return (_p_split_pop = p.split(/[\\/]/).pop()) !== null && _p_split_pop !== void 0 ? _p_split_pop : p;
    };
    const handleAddFiles = async (kind)=>{
        setAddFilesAnchor(null);
        if (!data.pickFiles) return;
        const paths = await data.pickFiles(kind);
        if (!paths || paths.length === 0) return;
        if (skill) try {
            var _data_addFile;
            for (const p of paths)await ((_data_addFile = data.addFile) === null || _data_addFile === void 0 ? void 0 : _data_addFile.call(data, skill.id, p, kind));
            if (data.listFiles) setFiles(await data.listFiles(skill.id));
        } catch (error) {
            setSaveError(error instanceof Error ? error.message : t('skills.files.addError'));
        }
        else setStagedFiles((prev)=>[
                ...prev,
                ...paths.map((p)=>({
                        sourcePath: p,
                        name: basename(p),
                        kind: kind
                    }))
            ]);
    };
    const handleDeleteFile = async (relPath)=>{
        if (!skill || !data.deleteFile) return;
        await data.deleteFile(skill.id, relPath);
        if (data.listFiles) setFiles(await data.listFiles(skill.id));
    };
    const handleOpenFile = (relPath)=>{
        var _data_openFile;
        if (skill) (_data_openFile = data.openFile) === null || _data_openFile === void 0 ? void 0 : _data_openFile.call(data, skill.id, relPath);
    };
    const nameCheck = (0, $4b33d1984f0c4c25$export$90544e016b732245)(name);
    const descriptionCheck = (0, $4b33d1984f0c4c25$export$c46ec21c6dcc4443)(description);
    const nameError = name.length > 0 && !nameCheck.valid ? nameCheck.error : undefined;
    const descriptionError = description.length > 0 && !descriptionCheck.valid ? descriptionCheck.error : undefined;
    const canSave = nameCheck.valid && descriptionCheck.valid && !saving && bodyLoaded;
    const parsedKeywords = keywords.split(',').map((k)=>k.trim()).filter(Boolean);
    /**
     * Saved files can be opened on disk; staged ones don't exist there yet, so they only offer Remove.
     * Staged rows key on source path + index because the same file can legitimately be staged twice.
     */ const fileItems = isEdit ? files.map((f)=>({
            id: f.relPath,
            label: f.name,
            title: f.relPath,
            icon: f.kind === 'script' ? 'code' : 'files',
            identifier: $433a5eef705569ef$var$kindLabel(t, f.kind),
            identifierVariant: f.kind === 'asset' ? 'accent' : 'diminished',
            disabled: saving,
            actions: [
                {
                    icon: 'externalLink',
                    label: t('skills.files.open'),
                    onClick: ()=>handleOpenFile(f.relPath)
                },
                {
                    icon: 'close',
                    label: t('skills.files.remove'),
                    onClick: ()=>handleDeleteFile(f.relPath)
                }
            ]
        })) : stagedFiles.map((s, i)=>({
            id: `${s.sourcePath}-${i}`,
            label: s.name,
            title: s.sourcePath,
            icon: s.kind === 'script' ? 'code' : 'files',
            identifier: $433a5eef705569ef$var$kindLabel(t, s.kind),
            identifierVariant: s.kind === 'asset' ? 'accent' : 'diminished',
            disabled: saving,
            actions: [
                {
                    icon: 'close',
                    label: t('skills.files.remove'),
                    onClick: ()=>setStagedFiles((prev)=>prev.filter((_, idx)=>idx !== i))
                }
            ]
        }));
    const activationOptions = (0, $ac99b0e2fadd2449$export$1d45664231d692f4)(t).filter((option)=>option.value !== 'off').map((option)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, option), {
            value: option.value
        }));
    const handleSave = async ()=>{
        setSaving(true);
        setSaveError(null);
        try {
            let saved;
            if (skill) saved = await data.updateSkill({
                id: skill.id,
                name: name,
                description: description,
                keywords: parsedKeywords,
                body: body,
                activation: activation
            });
            else {
                const created = await data.createSkill({
                    name: name,
                    description: description,
                    keywords: parsedKeywords,
                    // Empty body → the service scaffolds a best-practice template.
                    body: body.trim() ? body : undefined,
                    activation: activation
                });
                saved = created;
                // Copy any files staged during creation into the new skill (native file mgmt only).
                if (data.addFile) for (const staged of stagedFiles)await data.addFile(created.id, staged.sourcePath, staged.kind);
            }
            onDone(saved);
        } catch (error) {
            setSaveError(error instanceof Error ? error.message : t('skills.editor.saveError'));
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8684a19e32913368$export$2e2bcd8739ae039), {
        open: true,
        fullWidth: true,
        maxWidth: "md",
        scroll: "paper",
        onClose: onCancel,
        onCancel: onCancel,
        onConfirm: handleSave,
        confirmDisabled: !canSave,
        cancelButtonText: t('cancel'),
        confirmButtonText: isEdit ? t('skills.editor.save') : t('skills.editor.create'),
        confirmIcon: "check",
        error: saveError !== null && saveError !== void 0 ? saveError : undefined,
        title: editorMode === 'edit' ? t('skills.editTitle') : t('skills.newTitle'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($433a5eef705569ef$var$Body, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24134fde542ee06d$export$2e2bcd8739ae039), {}),
                !isEdit && !hideTemplates && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($433a5eef705569ef$var$TemplateRow, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $size: "small",
                            $color: "secondary",
                            startIcon: "fileText",
                            iconSize: 14,
                            disabled: saving,
                            onClick: (e)=>setTemplatesAnchor(e.currentTarget),
                            children: t('skills.templates.start')
                        }),
                        templateId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$TemplateApplied, {
                            children: t('skills.templates.applied')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32855a33cbd5a576$export$2e2bcd8739ae039), {
                            anchorEl: templatesAnchor,
                            open: !!templatesAnchor,
                            onClose: ()=>setTemplatesAnchor(null),
                            children: (0, $e49db62d9ee33434$export$9091a65b06f2e4c5).map((template)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    onClick: ()=>applyTemplate(template),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($433a5eef705569ef$var$TemplateMenuItem, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$TemplateTitle, {
                                                children: t(template.titleKey, template.titleFallback)
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$TemplateSummary, {
                                                children: t(template.summaryKey, template.summaryFallback)
                                            })
                                        ]
                                    })
                                }, template.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        size: "small",
                        label: t('skills.editor.nameLabel'),
                        value: name,
                        placeholder: t('skills.editor.namePlaceholder'),
                        onChange: (e)=>setName(e.target.value),
                        onBlur: ()=>setName((current)=>(0, $4b33d1984f0c4c25$export$b02cb0d06cabe0e8)(current) || current),
                        error: !!nameError,
                        helperText: nameError !== null && nameError !== void 0 ? nameError : t('skills.editor.nameHelp'),
                        disabled: saving,
                        slotProps: {
                            inputLabel: {
                                shrink: true
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        label: t('skills.editor.descriptionLabel'),
                        fullWidth: true,
                        multiline: true,
                        minRows: 2,
                        value: description,
                        placeholder: t('skills.editor.descriptionPlaceholder'),
                        onChange: (e)=>setDescription(e.target.value.slice(0, (0, $83bad78370366bbe$export$51627feacfc0fcb0))),
                        error: !!descriptionError,
                        helperText: descriptionError !== null && descriptionError !== void 0 ? descriptionError : t('skills.editor.descriptionHelp'),
                        disabled: saving,
                        slotProps: {
                            inputLabel: {
                                shrink: true
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        size: "small",
                        label: t('skills.editor.keywordsLabel'),
                        value: keywords,
                        placeholder: t('skills.editor.keywordsPlaceholder'),
                        onChange: (e)=>setKeywords(e.target.value),
                        helperText: t('skills.editor.keywordsHelp'),
                        disabled: saving,
                        slotProps: {
                            inputLabel: {
                                shrink: true
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($433a5eef705569ef$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $575b7786b3f3cd02$export$2e2bcd8739ae039), {
                        label: t('skills.editor.activationLabel'),
                        options: activationOptions,
                        value: activation,
                        onChange: setActivation
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($433a5eef705569ef$var$Field, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                            size: "small",
                            title: t('skills.editor.instructionsLabel')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $230645309166c0ed$export$2e2bcd8739ae039), {
                            value: body,
                            onChange: setBody,
                            disabled: saving || !bodyLoaded,
                            placeholder: t('skills.editor.instructionsPlaceholder')
                        })
                    ]
                }),
                canManageFiles && !hideFileManager && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($433a5eef705569ef$var$Field, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                            size: "small",
                            title: t('skills.files.label'),
                            description: t('skills.files.help')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4371ce2bad68da1d$export$2e2bcd8739ae039), {
                            monospaceLabels: true,
                            items: fileItems,
                            emptyText: t('skills.files.empty'),
                            addLabel: t('skills.files.add'),
                            addDisabled: saving,
                            onAdd: (e)=>setAddFilesAnchor(e.currentTarget)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $32855a33cbd5a576$export$2e2bcd8739ae039), {
                            anchorEl: addFilesAnchor,
                            open: !!addFilesAnchor,
                            onClose: ()=>setAddFilesAnchor(null),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleAddFiles('reference'),
                                    children: t('skills.files.kind.reference')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleAddFiles('script'),
                                    children: t('skills.files.kind.script')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleAddFiles('asset'),
                                    children: t('skills.files.kind.asset')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/**
 * The gap between fields is deliberately wider than the gap inside one (label → input → helper): a
 * helper has to sit closer to the field it describes than to the next field's label, or it reads as
 * loose body copy between the two.
 */ const $433a5eef705569ef$var$Body = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($433a5eef705569ef$var$t || ($433a5eef705569ef$var$t = $433a5eef705569ef$var$_`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-top: 0.5rem;
`));
const $433a5eef705569ef$var$Field = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($433a5eef705569ef$var$t1 || ($433a5eef705569ef$var$t1 = $433a5eef705569ef$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
`));
const $433a5eef705569ef$var$TemplateRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($433a5eef705569ef$var$t2 || ($433a5eef705569ef$var$t2 = $433a5eef705569ef$var$_`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`));
const $433a5eef705569ef$var$TemplateApplied = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($433a5eef705569ef$var$t3 || ($433a5eef705569ef$var$t3 = $433a5eef705569ef$var$_`
    color: ${0};
`), (props)=>props.theme.color.textBody);
const $433a5eef705569ef$var$TemplateMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($433a5eef705569ef$var$t4 || ($433a5eef705569ef$var$t4 = $433a5eef705569ef$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    max-width: 20rem;
    white-space: normal;
`));
const $433a5eef705569ef$var$TemplateTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($433a5eef705569ef$var$t5 || ($433a5eef705569ef$var$t5 = $433a5eef705569ef$var$_`
    font-size: 0.8125rem;
    font-weight: 600;
`));
const $433a5eef705569ef$var$TemplateSummary = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($433a5eef705569ef$var$t6 || ($433a5eef705569ef$var$t6 = $433a5eef705569ef$var$_`
    font-size: 0.6875rem;
    color: ${0};
`), (props)=>props.theme.color.textBody);





















function $74c799a07a472449$export$2e2bcd8739ae039({ value: value, title: title, hideLabel: hideLabel, tooltip: tooltip, icon: icon, iconSize: iconSize, variant: variant = 'diminished' }) {
    const row = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $dd1906991ea04169$export$d23a46b15e7317a5), {
        $variant: variant,
        title: hideLabel && !tooltip ? title : undefined,
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                weight: "bold",
                name: icon,
                size: iconSize || 14
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$243af89aa098f622), {
                children: value
            }),
            hideLabel ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: title
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd1906991ea04169$export$34028d8930504f65), {
                children: title
            })
        ]
    });
    if (!tooltip) return row;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee2f76e72685f4ff$export$2e2bcd8739ae039), {
        title: tooltip,
        arrow: true,
        children: row
    });
}


function $4d2b958a25fb9295$export$45f7fee5c406a8d0(provenance, t) {
    switch(provenance){
        case 'cephable':
            return t('extensions.provenance.cephable');
        case 'organization':
            return t('extensions.provenance.organization');
        case 'thirdParty':
            return t('extensions.provenance.thirdParty');
        default:
            return t('extensions.provenance.mine');
    }
}
const $4d2b958a25fb9295$export$db4eb5b7eb2f0820 = {
    cephable: 'logo',
    organization: 'orgCompany',
    thirdParty: 'globe',
    mine: 'user'
};
function $4d2b958a25fb9295$export$c345321b6781c7f0(item) {
    if (item.isOfficial) return 'cephable';
    if (item.source === 'user') return 'mine';
    if (item.source === 'organization' || item.organizationId) return 'organization';
    if (item.source === 'marketplace' || item.source === 'imported') return 'thirdParty';
    return 'mine';
}
function $4d2b958a25fb9295$export$cd55afaa53a2e69f(server) {
    if (server.isOfficial) return 'cephable';
    if (server.organizationId) return 'organization';
    return 'thirdParty';
}


function $2b7e1534aed674fc$export$1742ef03ad066fe4(server) {
    return !server.enabled ? 'off' : server.activation;
}
function $2b7e1534aed674fc$export$8960bc3350e363f4(serverId, mode) {
    return mode === 'off' ? {
        id: serverId,
        enabled: false
    } : {
        id: serverId,
        enabled: true,
        activation: mode
    };
}
function $2b7e1534aed674fc$export$1b14be8dae83da24(t) {
    return [
        {
            value: 'off',
            label: t('mcp.mode.off'),
            description: t('mcp.mode.offTooltip')
        },
        {
            value: 'auto',
            label: t('mcp.activation.autoShort'),
            description: t('mcp.activation.autoDescription')
        },
        {
            value: 'manual',
            label: t('mcp.activation.manualShort'),
            description: t('mcp.activation.manualDescription')
        }
    ];
}
function $2b7e1534aed674fc$export$f333af82c76de344(mode) {
    if (mode === 'auto') return 'success';
    if (mode === 'manual') return 'accent';
    return 'diminished';
}



/**
 * MCP (Model Context Protocol) servers — user-configured external tool providers that the on-device AI
 * Workflows agent can load tools from. Surfaced to users as "Tools". A server declares a transport
 * (stdio/CLI, streamable HTTP, or SSE) and, optionally, authentication (API key, custom headers, or
 * OAuth 2.0). When a server is selected for a run (auto by relevance, or manually via `/`·`@`), the
 * worker connects with `@langchain/mcp-adapters` and injects that server's tools into the agent.
 *
 * These models live in `shared/` so both the desktop renderer (Extensions "Tools" manager, composer
 * picker) and the desktop worker/agent can use them. This is the redacted, renderer-safe shape:
 * secret values (API keys, OAuth tokens/secrets, secret headers/env vars) NEVER appear here — only
 * boolean "is set" flags. Secrets are held encrypted main-process-side by McpService and injected into
 * a {@link ResolvedMcpConnection} for the worker at run time.
 *
 * Mirrors the AI Skills model shape (see shared/models/skills/SkillModel.ts) so the two Extensions
 * features stay parallel.
 */ /** How a server talks to Cephable. Matches the transports `@langchain/mcp-adapters` supports. */ const $033e083163b21c3e$export$9eaf6d18288e6f0f = 'manual';
const $033e083163b21c3e$export$1f5030de324ffe37 = 64;
const $033e083163b21c3e$export$46ed11839ca84ea = 1024;
const $033e083163b21c3e$export$9096eef3c61dcb5a = 'mcp';
function $033e083163b21c3e$export$acca87273f13781c(name) {
    return name.startsWith(`${$033e083163b21c3e$export$9096eef3c61dcb5a}__`);
}


function $4bb2c0aa345dbcf8$export$3ff118014240f3c(name) {
    const value = (name !== null && name !== void 0 ? name : '').trim();
    if (!value) return {
        valid: false,
        error: 'A name is required.'
    };
    if (value.length > (0, $033e083163b21c3e$export$1f5030de324ffe37)) return {
        valid: false,
        error: `Name must be ${0, $033e083163b21c3e$export$1f5030de324ffe37} characters or fewer.`
    };
    if (/[A-Z]/.test(value)) return {
        valid: false,
        error: 'Use lowercase letters only.'
    };
    if (!RegExp("^[\\p{Ll}\\p{Nd}-]+$", "u").test(value)) return {
        valid: false,
        error: 'Use lowercase letters, numbers, and hyphens only.'
    };
    if (value.startsWith('-') || value.endsWith('-')) return {
        valid: false,
        error: 'Name cannot start or end with a hyphen.'
    };
    if (value.includes('--')) return {
        valid: false,
        error: 'Name cannot contain consecutive hyphens.'
    };
    return {
        valid: true
    };
}
function $4bb2c0aa345dbcf8$export$3ec2d2df055cf711(description) {
    const value = (description !== null && description !== void 0 ? description : '').trim();
    if (!value) return {
        valid: false,
        error: 'A description is required so the assistant knows when to use this server.'
    };
    if (value.length > (0, $033e083163b21c3e$export$46ed11839ca84ea)) return {
        valid: false,
        error: `Description must be ${0, $033e083163b21c3e$export$46ed11839ca84ea} characters or fewer.`
    };
    return {
        valid: true
    };
}
function $4bb2c0aa345dbcf8$export$cfbcfd76795510ee(input) {
    if (input.transport === 'stdio') {
        var _input_command;
        if (!((_input_command = input.command) !== null && _input_command !== void 0 ? _input_command : '').trim()) return {
            valid: false,
            error: 'A command is required for a stdio (CLI) server.'
        };
        return {
            valid: true
        };
    }
    var _input_url;
    // http / sse
    const url = ((_input_url = input.url) !== null && _input_url !== void 0 ? _input_url : '').trim();
    if (!url) return {
        valid: false,
        error: 'A URL is required for an HTTP or SSE server.'
    };
    let parsed;
    try {
        parsed = new URL(url);
    } catch (e) {
        return {
            valid: false,
            error: 'Enter a valid URL (including http:// or https://).'
        };
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return {
        valid: false,
        error: 'URL must use http:// or https://.'
    };
    return {
        valid: true
    };
}
function $4bb2c0aa345dbcf8$export$b9557588c20ea9c0(port) {
    if (port === undefined || !Number.isInteger(port)) return {
        valid: false,
        error: 'Enter a port number.'
    };
    if (port < 1024 || port > 65535) return {
        valid: false,
        error: 'Use a port between 1024 and 65535.'
    };
    return {
        valid: true
    };
}
function $4bb2c0aa345dbcf8$export$e02faa9d6aebbe9f(input) {
    return (input !== null && input !== void 0 ? input : '').toLowerCase().replace(/[_\s]+/g, '-').replace(RegExp("[^\\p{Ll}\\p{Nd}-]", "gu"), '').replace(/-+/g, '-').replace(/^-+|-+$/g, '').slice(0, (0, $033e083163b21c3e$export$1f5030de324ffe37)).replace(/-+$/g, '');
}


const $66d12c911069c0ae$export$8f06ff8b33d03d12 = 47821;
const $66d12c911069c0ae$export$d7fc7a8478cced45 = 'mcp/callback';
const $66d12c911069c0ae$export$9c05bb6bb8458da7 = 'appCallback';
function $66d12c911069c0ae$export$c534cefa3b3a4124(port) {
    return (0, $4bb2c0aa345dbcf8$export$b9557588c20ea9c0)(port).valid ? port : $66d12c911069c0ae$export$8f06ff8b33d03d12;
}
function $66d12c911069c0ae$export$d02027733503a8b2(type, localhostPort) {
    switch(type){
        case 'localhost':
            return `http://localhost:${$66d12c911069c0ae$export$c534cefa3b3a4124(localhostPort)}/${$66d12c911069c0ae$export$d7fc7a8478cced45}`;
        default:
            return (0, $07546889aef07ebc$export$63c7d63fd659c02)();
    }
}
function $66d12c911069c0ae$export$d9fd7e2a3e3716f5(t) {
    return [
        {
            value: 'appCallback',
            label: t('mcp.editor.redirectType.appCallback')
        },
        {
            value: 'localhost',
            label: t('mcp.editor.redirectType.localhost')
        }
    ];
}






var $7fPBF = parcelRequire("7fPBF");






/** Ties the switch to the row's title, the way the settings rows do. */ const $8792f0f4660b58e9$var$APPROVAL_LABEL_ID = 'mcp-require-approval-label';
function $8792f0f4660b58e9$export$2e2bcd8739ae039({ requireApproval: requireApproval, disabled: disabled, onToggle: onToggle }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $57a5002928f949a3$export$2e2bcd8739ae039), {
        title: t('mcp.editor.requireApprovalLabel'),
        titleId: $8792f0f4660b58e9$var$APPROVAL_LABEL_ID,
        description: t('mcp.editor.requireApprovalHelp'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
            "aria-labelledby": $8792f0f4660b58e9$var$APPROVAL_LABEL_ID,
            checked: requireApproval,
            disabled: disabled,
            onChange: (_, value)=>onToggle(value)
        })
    });
}









function $3c2f1d03582d58f1$export$2578b51b6d1cf035(status) {
    if (status === 'ok') return 'diminished_success';
    if (status === 'error') return 'diminished_error';
    return 'diminished';
}
function $3c2f1d03582d58f1$export$6d2e7473e733612a(status) {
    if (status === 'ok') return 'connectionStatusOn';
    if (status === 'error') return 'connectionOffline';
    return 'connect';
}
function $3c2f1d03582d58f1$export$57df62c7deab3577(t, status) {
    if (status === 'ok') return t('mcp.status.ok');
    if (status === 'error') return t('mcp.status.error');
    return t('mcp.status.unknown');
}



var $7fPBF = parcelRequire("7fPBF");

let $570ae8d697083555$var$_ = (t)=>t, $570ae8d697083555$var$t, $570ae8d697083555$var$t1, $570ae8d697083555$var$t2;
function $570ae8d697083555$export$2e2bcd8739ae039({ status: status, error: error, busy: busy, disabled: disabled, needsOauth: needsOauth, canDisconnect: canDisconnect, onTest: onTest, onReconnect: onReconnect, onDisconnect: onDisconnect, children: children }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const locked = busy !== null || !!disabled;
    /**
     * A completed sign-out that the caller's own props may not reflect yet. Callers whose data is live
     * (rather than a snapshot) only catch up an async round-trip after the disconnect resolves, which
     * would re-enable this row's buttons for a beat and then flip them — so hold the signed-out result
     * here until those props agree. Cleared by the effect below, or when a new connect supersedes it.
     */ const [signedOut, setSignedOut] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (!canDisconnect) setSignedOut(false);
    }, [
        canDisconnect
    ]);
    // Signing out invalidates whatever the last connection reported, so a held sign-out speaks for the
    // whole row: no status, no stale error, and back to offering sign-in.
    const resolved = signedOut ? {
        status: 'unknown',
        error: undefined,
        needsOauth: true,
        canDisconnect: false
    } : {
        status: status,
        error: error,
        needsOauth: needsOauth,
        canDisconnect: canDisconnect
    };
    // While a connect/test/disconnect flow runs, the values above can change several times in quick
    // succession (each sign-in/test step reloads the caller's data), which would restructure the row
    // through states too brief to read — the flicker. Hold the pill and the OAuth affordances to their
    // pre-flow snapshot until the flow ends, so the row settles exactly once. The button still animates
    // Connecting…/Testing… because its label reads the live `busy`.
    const steady = (0, $7fPBF.useRef)(resolved);
    if (busy === null) steady.current = resolved;
    const view = steady.current;
    /** Clear a held sign-out when the user starts connecting again, so the fresh outcome shows through. */ const startConnect = (run)=>()=>{
            setSignedOut(false);
            run();
        };
    const runDisconnect = async ()=>{
        if (!onDisconnect) return;
        try {
            await onDisconnect();
            setSignedOut(true);
        } catch (e) {
        // The caller surfaces the failure through `error`; there's no sign-out to hold onto.
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                size: "small",
                title: t('mcp.status.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($570ae8d697083555$var$ConnectionRow, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($570ae8d697083555$var$ConnectButton, {
                        $color: view.needsOauth ? 'primary' : 'simple',
                        $size: "small",
                        startIcon: view.needsOauth ? 'connect' : 'sync',
                        disabled: locked,
                        onClick: startConnect(onTest),
                        children: busy === 'oauth' ? t('mcp.oauth.connecting') : busy === 'test' ? t('mcp.status.testing') : view.needsOauth ? t('mcp.oauth.connect') : t('mcp.editor.testConnection')
                    }),
                    view.canDisconnect && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            onReconnect && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63e32f8e29f3f937$export$2e2bcd8739ae039), {
                                title: t('mcp.oauth.reconnect'),
                                variant: "underline_diminished",
                                disabled: locked,
                                onClick: startConnect(onReconnect)
                            }),
                            onDisconnect && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63e32f8e29f3f937$export$2e2bcd8739ae039), {
                                title: t('mcp.oauth.disconnect'),
                                variant: "underline_diminished",
                                disabled: locked,
                                onClick: runDisconnect
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ecd8fc09c60c02c$export$2e2bcd8739ae039), {
                        title: t('mcp.status.label'),
                        // "Connection Connected" says the same thing twice — the status word and its icon
                        // carry it on their own, so the label is left for screen readers.
                        hideLabel: true,
                        value: (0, $3c2f1d03582d58f1$export$57df62c7deab3577)(t, view.status),
                        icon: (0, $3c2f1d03582d58f1$export$6d2e7473e733612a)(view.status),
                        variant: (0, $3c2f1d03582d58f1$export$2578b51b6d1cf035)(view.status)
                    }),
                    children
                ]
            }),
            view.error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($570ae8d697083555$var$ErrorText, {
                children: view.error
            })
        ]
    });
}
/** Outlined even in its 'simple' colour, so the row's one real action still reads as a button. */ const $570ae8d697083555$var$ConnectButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))($570ae8d697083555$var$t || ($570ae8d697083555$var$t = $570ae8d697083555$var$_`
    border: 1px solid ${0};
`), (props)=>props.theme.color.textBody);
const $570ae8d697083555$var$ConnectionRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($570ae8d697083555$var$t1 || ($570ae8d697083555$var$t1 = $570ae8d697083555$var$_`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`));
const $570ae8d697083555$var$ErrorText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6))($570ae8d697083555$var$t2 || ($570ae8d697083555$var$t2 = $570ae8d697083555$var$_`
    color: ${0};
`), (props)=>props.theme.color.error);









/**
 * Rough token-cost estimation for MCP tool definitions, used to warn users about context/token bloat
 * and to power per-tool selection. Deliberately a cheap ~chars/4 heuristic (the same ratio the on-device
 * workflow model's {@link import('@desktop/services/inference/LlamaServerChatProvider')} uses) so it works
 * with no dependency on the model server running. It approximates what a tool costs when its definition
 * (name + description + JSON input schema) is injected into the agent's context.
 */ /** Average characters per token for the ~chars/4 heuristic. */ const $b530a36907fea367$var$AVG_CHARS_PER_TOKEN = 4;
/** Safely stringify a value for sizing; returns '' on circular refs or unserializable input. */ function $b530a36907fea367$var$safeStringify(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    try {
        var _JSON_stringify;
        return (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : '';
    } catch (e) {
        return '';
    }
}
function $b530a36907fea367$export$9ff15d171a92f4e4(tool) {
    var _tool_description;
    var _tool_description_length;
    const chars = tool.name.length + ((_tool_description_length = (_tool_description = tool.description) === null || _tool_description === void 0 ? void 0 : _tool_description.length) !== null && _tool_description_length !== void 0 ? _tool_description_length : 0) + $b530a36907fea367$var$safeStringify(tool.schema).length;
    return Math.ceil(chars / $b530a36907fea367$var$AVG_CHARS_PER_TOKEN);
}
function $b530a36907fea367$export$354d96be8f3cab60(server, toolName) {
    var _server_disabledTools;
    return !((_server_disabledTools = server.disabledTools) === null || _server_disabledTools === void 0 ? void 0 : _server_disabledTools.includes(toolName));
}
function $b530a36907fea367$export$f9978d77afae50bd(server, opts = {}) {
    var _server_cachedTools;
    return ((_server_cachedTools = server.cachedTools) !== null && _server_cachedTools !== void 0 ? _server_cachedTools : []).reduce((sum, tool)=>{
        if (opts.onlyEnabled && !$b530a36907fea367$export$354d96be8f3cab60(server, tool.name)) return sum;
        var _tool_tokenEstimate;
        return sum + ((_tool_tokenEstimate = tool.tokenEstimate) !== null && _tool_tokenEstimate !== void 0 ? _tool_tokenEstimate : 0);
    }, 0);
}
function $b530a36907fea367$export$b366f0481043956f(server) {
    var _server_cachedTools;
    return ((_server_cachedTools = server.cachedTools) !== null && _server_cachedTools !== void 0 ? _server_cachedTools : []).filter((tool)=>$b530a36907fea367$export$354d96be8f3cab60(server, tool.name)).length;
}



var $7fPBF = parcelRequire("7fPBF");

let $6389cab76761cf81$var$_ = (t)=>t, $6389cab76761cf81$var$t, $6389cab76761cf81$var$t1, $6389cab76761cf81$var$t2, $6389cab76761cf81$var$t3, $6389cab76761cf81$var$t4, $6389cab76761cf81$var$t5, $6389cab76761cf81$var$t6, $6389cab76761cf81$var$t7, $6389cab76761cf81$var$t8, $6389cab76761cf81$var$t9, $6389cab76761cf81$var$t10;
function $6389cab76761cf81$export$2e2bcd8739ae039({ tools: tools, disabledTools: disabledTools, contextWindow: contextWindow, disabled: disabled, onChange: onChange }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const [query, setQuery] = (0, $7fPBF.useState)('');
    const totalTokens = (0, $b530a36907fea367$export$f9978d77afae50bd)({
        cachedTools: tools
    }, {
        onlyEnabled: false
    });
    const enabledTokens = (0, $b530a36907fea367$export$f9978d77afae50bd)({
        cachedTools: tools,
        disabledTools: disabledTools
    }, {
        onlyEnabled: true
    });
    const enabledCount = tools.filter((tool)=>!disabledTools.includes(tool.name)).length;
    const contextPct = contextWindow && contextWindow > 0 ? Math.round(enabledTokens / contextWindow * 100) : undefined;
    // A server can advertise dozens of tools, so the list is filtered by name and description. The
    // counts above it stay whole-server totals — they describe the connector, not the current filter.
    const filtered = !!query.trim();
    const visibleTools = (0, $7fPBF.useMemo)(()=>{
        const trimmed = query.trim().toLowerCase();
        if (!trimmed) return tools;
        return tools.filter((tool)=>{
            var _tool_description;
            return tool.name.toLowerCase().includes(trimmed) || !!((_tool_description = tool.description) === null || _tool_description === void 0 ? void 0 : _tool_description.toLowerCase().includes(trimmed));
        });
    }, [
        tools,
        query
    ]);
    const toggleTool = (name, enabled)=>onChange(enabled ? disabledTools.filter((n)=>n !== name) : [
            ...new Set([
                ...disabledTools,
                name
            ])
        ]);
    /**
     * Bulk enable/disable, reported as the whole next disabled set. With a search in place both act on
     * the rows the user can actually see — reaching past the filter to the tools it hides is the one
     * thing a bulk action here must never do, so those keep whatever state they already had.
     */ const handleEnable = ()=>{
        if (filtered) onChange(disabledTools.filter((n)=>!visibleTools.some((tool)=>tool.name === n)));
        else onChange([]);
    };
    const handleDisable = ()=>{
        if (filtered) onChange([
            ...new Set([
                ...disabledTools,
                ...visibleTools.map((tool)=>tool.name)
            ])
        ]);
        else onChange(tools.map((tool)=>tool.name));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                size: "small",
                title: t('mcp.tools.label'),
                description: t('mcp.tools.help')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6389cab76761cf81$var$ToolsControls, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6389cab76761cf81$var$SearchWrap, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                            label: "",
                            value: query,
                            onChange: (e)=>setQuery(e.target.value),
                            onClear: ()=>setQuery(''),
                            placeholder: t('mcp.tools.searchPlaceholder')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6389cab76761cf81$var$ToolsActions, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63e32f8e29f3f937$export$2e2bcd8739ae039), {
                                title: filtered ? t('mcp.tools.enableSelected') : t('mcp.tools.enableAll'),
                                variant: "underline_diminished",
                                disabled: disabled,
                                onClick: handleEnable
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63e32f8e29f3f937$export$2e2bcd8739ae039), {
                                title: filtered ? t('mcp.tools.disableSelected') : t('mcp.tools.disableAll'),
                                variant: "underline_diminished",
                                disabled: disabled,
                                onClick: handleDisable
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6389cab76761cf81$var$ToolsSummary, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74c799a07a472449$export$2e2bcd8739ae039), {
                        variant: "text",
                        value: `${enabledCount}/${tools.length}`,
                        title: t('mcp.tools.label'),
                        icon: "listChecks"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74c799a07a472449$export$2e2bcd8739ae039), {
                        variant: "text",
                        value: `~${enabledTokens.toLocaleString()}`,
                        title: t('mcp.tools.tokensLabel')
                    }),
                    contextPct !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74c799a07a472449$export$2e2bcd8739ae039), {
                        value: `~${contextPct}%`,
                        title: t('mcp.tools.contextLabel'),
                        variant: contextPct >= 25 ? 'diminished_error' : 'diminished_accent'
                    }),
                    totalTokens !== enabledTokens && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74c799a07a472449$export$2e2bcd8739ae039), {
                        value: `~${totalTokens.toLocaleString()}`,
                        title: t('mcp.tools.allToolsLabel')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6389cab76761cf81$var$ToolList, {
                children: [
                    visibleTools.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6389cab76761cf81$var$EmptyRow, {
                        children: t('noResults')
                    }),
                    visibleTools.map((tool)=>{
                        const enabled = !disabledTools.includes(tool.name);
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6389cab76761cf81$var$ToolRow, {
                            $enabled: enabled,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                                    size: "small",
                                    checked: enabled,
                                    disabled: disabled,
                                    onChange: (e)=>toggleTool(tool.name, e.target.checked),
                                    slotProps: {
                                        input: {
                                            'aria-label': tool.name
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6389cab76761cf81$var$ToolText, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6389cab76761cf81$var$ToolName, {
                                            children: tool.name
                                        }),
                                        tool.description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6389cab76761cf81$var$ToolDescription, {
                                            children: tool.description
                                        })
                                    ]
                                }),
                                tool.tokenEstimate !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6389cab76761cf81$var$ToolTokens, {
                                    children: t('mcp.tools.tokens', {
                                        tokens: tool.tokenEstimate.toLocaleString()
                                    })
                                })
                            ]
                        }, tool.name);
                    })
                ]
            })
        ]
    });
}
/** Search takes the room; the bulk actions sit against the right and wrap under it when space runs out. */ const $6389cab76761cf81$var$ToolsControls = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t || ($6389cab76761cf81$var$t = $6389cab76761cf81$var$_`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`));
const $6389cab76761cf81$var$SearchWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t1 || ($6389cab76761cf81$var$t1 = $6389cab76761cf81$var$_`
    flex: 1 1 12rem;
    min-width: 0;
`));
const $6389cab76761cf81$var$ToolsActions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t2 || ($6389cab76761cf81$var$t2 = $6389cab76761cf81$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;
`));
const $6389cab76761cf81$var$ToolsSummary = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t3 || ($6389cab76761cf81$var$t3 = $6389cab76761cf81$var$_`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: ${0};
`), (props)=>props.theme.color.textBody);
const $6389cab76761cf81$var$EmptyRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t4 || ($6389cab76761cf81$var$t4 = $6389cab76761cf81$var$_`
    padding: 0.5rem;
    font-size: 0.75rem;
    color: ${0};
`), (props)=>props.theme.color.textBody);
const $6389cab76761cf81$var$ToolList = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t5 || ($6389cab76761cf81$var$t5 = $6389cab76761cf81$var$_`
    display: flex;
    flex-direction: column;
    border: 1px solid ${0};
    border-radius: 0.5rem;
    overflow: hidden;
    max-height: 50vh;
    overflow-y: auto;
`), (props)=>props.theme.color.border);
const $6389cab76761cf81$var$ToolRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t6 || ($6389cab76761cf81$var$t6 = $6389cab76761cf81$var$_`
    display: flex;
    align-items: flex-start;
    gap: 0.25rem;
    padding: 0.35rem 0.5rem;
    opacity: ${0};

    & + & {
        border-top: 1px solid ${0};
    }
`), (props)=>props.$enabled ? 1 : 0.55, (props)=>props.theme.color.border);
const $6389cab76761cf81$var$ToolText = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6389cab76761cf81$var$t7 || ($6389cab76761cf81$var$t7 = $6389cab76761cf81$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    min-width: 0;
    flex: 1;
    padding-top: 0.35rem;
`));
const $6389cab76761cf81$var$ToolName = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($6389cab76761cf81$var$t8 || ($6389cab76761cf81$var$t8 = $6389cab76761cf81$var$_`
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${0};
    word-break: break-word;
`), (props)=>props.theme.color.text);
const $6389cab76761cf81$var$ToolDescription = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($6389cab76761cf81$var$t9 || ($6389cab76761cf81$var$t9 = $6389cab76761cf81$var$_`
    font-size: 0.6875rem;
    color: ${0};
`), (props)=>props.theme.color.textBody);
const $6389cab76761cf81$var$ToolTokens = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($6389cab76761cf81$var$t10 || ($6389cab76761cf81$var$t10 = $6389cab76761cf81$var$_`
    flex: none;
    align-self: center;
    font-size: 0.6875rem;
    font-variant-numeric: tabular-nums;
    color: ${0};
    white-space: nowrap;
`), (props)=>props.theme.color.textBody);


let $c9b3b1654ddd2b83$var$_ = (t)=>t, $c9b3b1654ddd2b83$var$t, $c9b3b1654ddd2b83$var$t1, $c9b3b1654ddd2b83$var$t2, $c9b3b1654ddd2b83$var$t3, $c9b3b1654ddd2b83$var$t4, $c9b3b1654ddd2b83$var$t5, $c9b3b1654ddd2b83$var$t6, $c9b3b1654ddd2b83$var$t7, $c9b3b1654ddd2b83$var$t8, $c9b3b1654ddd2b83$var$t9, $c9b3b1654ddd2b83$var$t10, $c9b3b1654ddd2b83$var$t11;
const $c9b3b1654ddd2b83$var$initSecretState = (stored)=>({
        value: '',
        stored: !!stored,
        edited: false
    });
/** Parse a `KEY=VALUE` lines textarea into a record (ignoring blank lines and lines without `=`). */ function $c9b3b1654ddd2b83$var$parseEnv(text) {
    const env = {};
    for (const line of text.split('\n')){
        const trimmed = line.trim();
        if (!trimmed) continue;
        const eq = trimmed.indexOf('=');
        if (eq <= 0) continue;
        env[trimmed.slice(0, eq).trim()] = trimmed.slice(eq + 1).trim();
    }
    return env;
}
function $c9b3b1654ddd2b83$var$stringifyEnv(env) {
    return Object.entries(env !== null && env !== void 0 ? env : {}).map(([k, v])=>`${k}=${v}`).join('\n');
}
function $c9b3b1654ddd2b83$export$2e2bcd8739ae039({ server: server, data: data, onCancel: onCancel, onDone: onDone, editorMode: editorMode, onCopyCreated: onCopyCreated }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const isEdit = !!server;
    const caps = data.capabilities;
    var _server_id;
    const [serverId, setServerId] = (0, $7fPBF.useState)((_server_id = server === null || server === void 0 ? void 0 : server.id) !== null && _server_id !== void 0 ? _server_id : null);
    var _server_name;
    const [name, setName] = (0, $7fPBF.useState)((_server_name = server === null || server === void 0 ? void 0 : server.name) !== null && _server_name !== void 0 ? _server_name : '');
    var _server_description;
    const [description, setDescription] = (0, $7fPBF.useState)((_server_description = server === null || server === void 0 ? void 0 : server.description) !== null && _server_description !== void 0 ? _server_description : '');
    var _server_transport;
    const [transport, setTransport] = (0, $7fPBF.useState)((_server_transport = server === null || server === void 0 ? void 0 : server.transport) !== null && _server_transport !== void 0 ? _server_transport : caps.stdioTransport ? 'stdio' : 'http');
    var _server_command;
    const [command, setCommand] = (0, $7fPBF.useState)((_server_command = server === null || server === void 0 ? void 0 : server.command) !== null && _server_command !== void 0 ? _server_command : '');
    var _server_args;
    const [argsText, setArgsText] = (0, $7fPBF.useState)(((_server_args = server === null || server === void 0 ? void 0 : server.args) !== null && _server_args !== void 0 ? _server_args : []).join(' '));
    const [envText, setEnvText] = (0, $7fPBF.useState)($c9b3b1654ddd2b83$var$stringifyEnv(server === null || server === void 0 ? void 0 : server.env));
    var _server_url;
    const [url, setUrl] = (0, $7fPBF.useState)((_server_url = server === null || server === void 0 ? void 0 : server.url) !== null && _server_url !== void 0 ? _server_url : '');
    var _server_authType;
    const [authType, setAuthType] = (0, $7fPBF.useState)((_server_authType = server === null || server === void 0 ? void 0 : server.authType) !== null && _server_authType !== void 0 ? _server_authType : 'none');
    var _server_apiKeyHeaderName;
    const [apiKeyHeaderName, setApiKeyHeaderName] = (0, $7fPBF.useState)((_server_apiKeyHeaderName = server === null || server === void 0 ? void 0 : server.apiKeyHeaderName) !== null && _server_apiKeyHeaderName !== void 0 ? _server_apiKeyHeaderName : 'Authorization');
    var _server_apiKeyPrefix;
    const [apiKeyPrefix, setApiKeyPrefix] = (0, $7fPBF.useState)((_server_apiKeyPrefix = server === null || server === void 0 ? void 0 : server.apiKeyPrefix) !== null && _server_apiKeyPrefix !== void 0 ? _server_apiKeyPrefix : 'Bearer ');
    const [apiKeySecret, setApiKeySecret] = (0, $7fPBF.useState)($c9b3b1654ddd2b83$var$initSecretState(server === null || server === void 0 ? void 0 : server.hasApiKey));
    var _server_oauthClientId;
    const [oauthClientId, setOauthClientId] = (0, $7fPBF.useState)((_server_oauthClientId = server === null || server === void 0 ? void 0 : server.oauthClientId) !== null && _server_oauthClientId !== void 0 ? _server_oauthClientId : '');
    const [oauthClientSecret, setOauthClientSecret] = (0, $7fPBF.useState)($c9b3b1654ddd2b83$var$initSecretState(server === null || server === void 0 ? void 0 : server.hasOauthClientSecret));
    var _server_oauthScopes;
    const [oauthScopes, setOauthScopes] = (0, $7fPBF.useState)(((_server_oauthScopes = server === null || server === void 0 ? void 0 : server.oauthScopes) !== null && _server_oauthScopes !== void 0 ? _server_oauthScopes : []).join(' '));
    var _server_oauthDiscoveryUrl;
    const [oauthDiscoveryUrl, setOauthDiscoveryUrl] = (0, $7fPBF.useState)((_server_oauthDiscoveryUrl = server === null || server === void 0 ? void 0 : server.oauthDiscoveryUrl) !== null && _server_oauthDiscoveryUrl !== void 0 ? _server_oauthDiscoveryUrl : '');
    var _server_oauthAuthorizationUrl;
    const [oauthAuthorizationUrl, setOauthAuthorizationUrl] = (0, $7fPBF.useState)((_server_oauthAuthorizationUrl = server === null || server === void 0 ? void 0 : server.oauthAuthorizationUrl) !== null && _server_oauthAuthorizationUrl !== void 0 ? _server_oauthAuthorizationUrl : '');
    var _server_oauthTokenUrl;
    const [oauthTokenUrl, setOauthTokenUrl] = (0, $7fPBF.useState)((_server_oauthTokenUrl = server === null || server === void 0 ? void 0 : server.oauthTokenUrl) !== null && _server_oauthTokenUrl !== void 0 ? _server_oauthTokenUrl : '');
    var _server_oauthRedirectType;
    const [oauthRedirectType, setOauthRedirectType] = (0, $7fPBF.useState)((_server_oauthRedirectType = server === null || server === void 0 ? void 0 : server.oauthRedirectType) !== null && _server_oauthRedirectType !== void 0 ? _server_oauthRedirectType : (0, $66d12c911069c0ae$export$9c05bb6bb8458da7));
    var _server_oauthLocalhostPort;
    const [oauthLocalhostPort, setOauthLocalhostPort] = (0, $7fPBF.useState)((_server_oauthLocalhostPort = server === null || server === void 0 ? void 0 : server.oauthLocalhostPort) !== null && _server_oauthLocalhostPort !== void 0 ? _server_oauthLocalhostPort : (0, $66d12c911069c0ae$export$8f06ff8b33d03d12));
    const oauthRedirectUri = (0, $66d12c911069c0ae$export$d02027733503a8b2)(oauthRedirectType, oauthLocalhostPort);
    var _server_activation;
    const [activation, setActivation] = (0, $7fPBF.useState)((_server_activation = server === null || server === void 0 ? void 0 : server.activation) !== null && _server_activation !== void 0 ? _server_activation : (0, $033e083163b21c3e$export$9eaf6d18288e6f0f));
    var _server_requireApproval;
    const [requireApproval, setRequireApproval] = (0, $7fPBF.useState)((_server_requireApproval = server === null || server === void 0 ? void 0 : server.requireApproval) !== null && _server_requireApproval !== void 0 ? _server_requireApproval : true);
    const canEdit = server ? (0, $4d2b958a25fb9295$export$c345321b6781c7f0)(server) === 'mine' : true;
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [saveError, setSaveError] = (0, $7fPBF.useState)(null);
    const [busyAction, setBusyAction] = (0, $7fPBF.useState)(null);
    const [testResult, setTestResult] = (0, $7fPBF.useState)(server ? {
        status: server.connectionStatus,
        tools: server.cachedTools
    } : null);
    const [oauthConnected, setOauthConnected] = (0, $7fPBF.useState)(!!(server === null || server === void 0 ? void 0 : server.oauthConnected));
    const [redirectCopied, setRedirectCopied] = (0, $7fPBF.useState)(false);
    var _server_disabledTools;
    // Per-tool selection: which of the server's discovered tools are turned OFF (bare names), plus the
    // model's context-window size so we can show what fraction of it the enabled tools will consume.
    const [disabledTools, setDisabledTools] = (0, $7fPBF.useState)((_server_disabledTools = server === null || server === void 0 ? void 0 : server.disabledTools) !== null && _server_disabledTools !== void 0 ? _server_disabledTools : []);
    const [contextWindow, setContextWindow] = (0, $7fPBF.useState)(0);
    (0, $7fPBF.useEffect)(()=>{
        if (!data.getContextWindow) return;
        data.getContextWindow().then(setContextWindow).catch(()=>setContextWindow(0));
    }, []);
    const nameError = (0, $7fPBF.useMemo)(()=>name.trim() ? (0, $4bb2c0aa345dbcf8$export$3ff118014240f3c)(name).error : undefined, [
        name
    ]);
    const descriptionError = (0, $7fPBF.useMemo)(()=>description.trim() ? (0, $4bb2c0aa345dbcf8$export$3ec2d2df055cf711)(description).error : undefined, [
        description
    ]);
    const transportError = (0, $7fPBF.useMemo)(()=>(0, $4bb2c0aa345dbcf8$export$cfbcfd76795510ee)({
            transport: transport,
            command: command,
            url: url
        }).error, [
        transport,
        command,
        url
    ]);
    const redirectOptions = (0, $7fPBF.useMemo)(()=>(0, $66d12c911069c0ae$export$d9fd7e2a3e3716f5)(t), [
        t
    ]);
    const redirectPortError = oauthRedirectType === 'localhost' ? (0, $4bb2c0aa345dbcf8$export$b9557588c20ea9c0)(oauthLocalhostPort).error : undefined;
    const canSave = !!name.trim() && !nameError && !!description.trim() && !descriptionError && !transportError && !redirectPortError && !saving;
    /**
     * The form's non-secret fields. `commitToolSelection` is false for the writes the user didn't ask for
     * (test connection, OAuth sign-in): those have to persist the connection config to get an id and its
     * secrets, but the tool selection must reach disk — and therefore a run — only on save. Leaving the
     * field undefined is what makes the update skip it.
     */ const buildBaseInput = (commitToolSelection)=>({
            name: name.trim(),
            description: description.trim(),
            transport: transport,
            command: transport === 'stdio' ? command.trim() : undefined,
            args: transport === 'stdio' ? argsText.split(/\s+/).filter(Boolean) : undefined,
            env: transport === 'stdio' ? $c9b3b1654ddd2b83$var$parseEnv(envText) : undefined,
            url: transport !== 'stdio' ? url.trim() : undefined,
            authType: transport === 'stdio' ? 'none' : authType,
            apiKeyHeaderName: apiKeyHeaderName,
            apiKeyPrefix: apiKeyPrefix,
            // reset on cleared value
            oauthClientId: isEdit ? oauthClientId.trim() : oauthClientId.trim() || undefined,
            oauthScopes: oauthScopes.split(/\s+/).filter(Boolean),
            oauthDiscoveryUrl: oauthDiscoveryUrl.trim() || undefined,
            oauthAuthorizationUrl: oauthAuthorizationUrl.trim() || undefined,
            oauthTokenUrl: oauthTokenUrl.trim() || undefined,
            oauthRedirectType: oauthRedirectType,
            // Test connection saves without waiting for `canSave`, so a rejected port must not reach disk —
            // omitting it leaves the last good value stored rather than writing one nothing can bind.
            oauthLocalhostPort: redirectPortError ? undefined : oauthLocalhostPort,
            activation: activation,
            requireApproval: requireApproval,
            disabledTools: commitToolSelection ? disabledTools : undefined
        });
    /** Persist the current form (create on first save, then update), returning the server id. */ const persist = async (commitToolSelection)=>{
        if (serverId) {
            await data.updateServer((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                id: serverId
            }, buildBaseInput(commitToolSelection)));
            return serverId;
        }
        const created = await data.createServer(buildBaseInput(commitToolSelection));
        setServerId(created.id);
        return created.id;
    };
    const commitSecret = async (id, kind, { value: value, stored: stored, edited: edited }, setState)=>{
        // An untouched field is empty because the secret is unreadable, not because it was removed.
        if (!edited || !data.setSecret) return;
        if (value) {
            await data.setSecret(id, kind, value);
            setState({
                value: value,
                stored: true,
                edited: false
            });
        } else if (stored && data.clearSecret) {
            await data.clearSecret(id, kind);
            setState({
                value: '',
                stored: false,
                edited: false
            });
        }
    };
    /** Persist current form + any freshly-entered secrets. Returns the id. */ const persistWithSecrets = async (commitToolSelection)=>{
        const id = await persist(commitToolSelection);
        // Secrets are only handled on platforms with an on-device encrypted store (desktop).
        if (caps.secrets && data.setSecret && transport !== 'stdio') {
            if (authType === 'apiKey') await commitSecret(id, 'apiKey', apiKeySecret, setApiKeySecret);
            if (authType === 'oauth') await commitSecret(id, 'oauthClientSecret', oauthClientSecret, setOauthClientSecret);
        }
        return id;
    };
    const handleSave = async ()=>{
        setSaving(true);
        setSaveError(null);
        try {
            await persistWithSecrets(true);
            onDone();
        } catch (e) {
            setSaveError(e instanceof Error ? e.message : t('mcp.editor.saveError'));
        } finally{
            setSaving(false);
        }
    };
    /** True when this server authenticates with OAuth and this platform can run the sign-in flow. */ const usesOauth = transport !== 'stdio' && authType === 'oauth' && caps.oauth;
    /** An OAuth server that hasn't been authorized yet — testing it has to sign in first. */ const needsOauth = usesOauth && !oauthConnected && !!data.oauthConnect;
    /**
     * One action for "make this server work": save the form, sign in if OAuth hasn't happened yet, then
     * connect and read the tool list. Splitting the sign-in into its own button only ever meant the test
     * failed for anyone who pressed them out of order.
     */ const handleTest = async ()=>{
        setBusyAction(needsOauth ? 'oauth' : 'test');
        setSaveError(null);
        try {
            const id = await persistWithSecrets(false);
            if (needsOauth && data.oauthConnect) {
                const updated = await data.oauthConnect(id);
                setOauthConnected(!!updated.oauthConnected);
            }
            if (!data.testConnection) return;
            setBusyAction('test');
            const result = await data.testConnection(id);
            setTestResult(result);
            // A tool the server no longer advertises can't be turned off — drop it, or saving the form
            // would write the stale name back over the pruning the test connection just did.
            if (result.status === 'ok') {
                const live = new Set(result.tools.map((tool)=>tool.name));
                setDisabledTools((current)=>current.filter((name)=>live.has(name)));
            }
        } catch (e) {
            setSaveError(e instanceof Error ? e.message : t('mcp.status.error'));
        } finally{
            setBusyAction(null);
        }
    };
    var _server_cachedTools;
    /** The tools to show for selection — the last successful test's manifest (seeded from the server). */ const tools = (testResult === null || testResult === void 0 ? void 0 : testResult.status) === 'ok' ? testResult.tools : (_server_cachedTools = server === null || server === void 0 ? void 0 : server.cachedTools) !== null && _server_cachedTools !== void 0 ? _server_cachedTools : [];
    const handleOauthConnect = async ()=>{
        setBusyAction('oauth');
        setSaveError(null);
        try {
            const id = await persistWithSecrets(false);
            if (!data.oauthConnect) return;
            const updated = await data.oauthConnect(id);
            setOauthConnected(!!updated.oauthConnected);
        } catch (e) {
            setSaveError(e instanceof Error ? e.message : t('mcp.oauth.error'));
        } finally{
            setBusyAction(null);
        }
    };
    const handleOauthDisconnect = async ()=>{
        if (!serverId || !data.oauthDisconnect) return;
        await data.oauthDisconnect(serverId);
        setOauthConnected(false);
        // The last test's result no longer applies once we've signed out, and the row reads its status
        // from it — drop it so the status falls back to "unknown" instead of a stale "connected".
        setTestResult(null);
    };
    /** Copy the server's non-secret config into a new user-owned server, then hand it to the caller. */ const handleCopyServer = async ()=>{
        setSaveError(null);
        try {
            const cleansedName = (0, $4bb2c0aa345dbcf8$export$e02faa9d6aebbe9f)(name.trim()) || name.trim();
            const copyName = t('mcp.editor.copyName', {
                name: cleansedName
            });
            const newServer = await data.createServer((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, buildBaseInput(true)), {
                name: copyName,
                // Credentials are never copied — the user must supply their own.
                oauthClientId: undefined,
                env: undefined
            }));
            onCopyCreated === null || onCopyCreated === void 0 ? void 0 : onCopyCreated(newServer);
        } catch (e) {
            setSaveError(e instanceof Error ? e.message : t('mcp.editor.saveError'));
        }
    };
    const transportOptions = [
        // stdio (local process) is only offered on platforms that can spawn one.
        ...caps.stdioTransport ? [
            {
                value: 'stdio',
                label: t('mcp.transport.stdio')
            }
        ] : [],
        {
            value: 'http',
            label: t('mcp.transport.http')
        },
        {
            value: 'sse',
            label: t('mcp.transport.sse')
        }
    ];
    /**
     * The card and the detail dialog offer Off/Auto/Manual; the editor offers the two activations only —
     * pausing a server is something you do to one that already exists, not a choice made while writing it.
     */ const activationOptions = (0, $2b7e1534aed674fc$export$1b14be8dae83da24)(t).filter((option)=>option.value !== 'off').map((option)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, option), {
            value: option.value
        }));
    const authOptions = [
        {
            value: 'none',
            label: t('mcp.auth.none')
        },
        {
            value: 'apiKey',
            label: t('mcp.auth.apiKey')
        },
        // { value: 'headers', label: t('mcp.auth.headers') },
        {
            value: 'oauth',
            label: t('mcp.auth.oauth')
        }
    ];
    /**
     * A write-only secret field (API key / OAuth client secret). What the user types is obscured by the
     * password input; a secret already on disk has nothing to show, so the placeholder stands in for it.
     */ const secretField = (label, state, setState)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
            fullWidth: true,
            size: "small",
            type: "password",
            label: label,
            value: state.value,
            placeholder: state.stored && !state.edited ? t('mcp.editor.secretSet') : undefined,
            onChange: (e)=>setState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    value: e.target.value,
                    edited: true
                })),
            disabled: saving,
            slotProps: {
                inputLabel: {
                    shrink: true
                }
            }
        });
    const credentialsEditor = ()=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
            children: transport === 'stdio' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            size: "small",
                            label: t('mcp.editor.commandLabel'),
                            value: command,
                            placeholder: "npx",
                            onChange: (e)=>setCommand(e.target.value),
                            error: !!transportError,
                            helperText: transportError,
                            disabled: saving,
                            slotProps: {
                                inputLabel: {
                                    shrink: true
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            size: "small",
                            label: t('mcp.editor.argsLabel'),
                            value: argsText,
                            placeholder: "-y @modelcontextprotocol/server-filesystem /path",
                            onChange: (e)=>setArgsText(e.target.value),
                            helperText: t('mcp.editor.argsHelp'),
                            disabled: saving,
                            slotProps: {
                                inputLabel: {
                                    shrink: true
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            label: t('mcp.editor.envLabel'),
                            fullWidth: true,
                            multiline: true,
                            minRows: 2,
                            value: envText,
                            placeholder: 'KEY=value\nANOTHER_KEY=value',
                            onChange: (e)=>setEnvText(e.target.value),
                            helperText: t('mcp.editor.envHelp'),
                            disabled: saving,
                            slotProps: {
                                inputLabel: {
                                    shrink: true
                                }
                            }
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            size: "small",
                            label: t('mcp.editor.urlLabel'),
                            value: url,
                            placeholder: "https://example.com/mcp",
                            onChange: (e)=>setUrl(e.target.value),
                            error: !!transportError,
                            helperText: transportError,
                            disabled: saving,
                            slotProps: {
                                inputLabel: {
                                    shrink: true
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$Field, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                                size: "small",
                                title: t('mcp.editor.authLabel')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$SegmentRow, {
                                role: "radiogroup",
                                children: authOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Segment, {
                                        type: "button",
                                        role: "radio",
                                        "aria-checked": authType === option.value,
                                        $selected: authType === option.value,
                                        disabled: saving,
                                        onClick: ()=>setAuthType(option.value),
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    }),
                    authType === 'apiKey' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$TwoCol, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "small",
                                            label: t('mcp.editor.apiKeyHeaderLabel'),
                                            value: apiKeyHeaderName,
                                            onChange: (e)=>setApiKeyHeaderName(e.target.value),
                                            disabled: saving,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "small",
                                            label: t('mcp.editor.apiKeyPrefixLabel'),
                                            value: apiKeyPrefix,
                                            onChange: (e)=>setApiKeyPrefix(e.target.value),
                                            disabled: saving,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            }
                                        })
                                    })
                                ]
                            }),
                            caps.secrets ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                children: secretField(t('mcp.editor.apiKeyLabel'), apiKeySecret, setApiKeySecret)
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$FieldHint, {
                                children: t('mcp.editor.secretsOnDevice')
                            })
                        ]
                    }),
                    authType === 'oauth' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            caps.oauth && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$Banner, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                                        size: "small",
                                        title: t('mcp.editor.redirectLabel'),
                                        description: t('mcp.editor.redirectHelp')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$TwoCol, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    size: "small",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                                                            id: "mcp-redirect-url",
                                                            children: t('mcp.editor.redirectTypeLabel')
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                                                            labelId: "mcp-redirect-url",
                                                            label: t('mcp.editor.redirectTypeLabel'),
                                                            value: oauthRedirectType,
                                                            disabled: saving,
                                                            onChange: (e)=>{
                                                                setOauthRedirectType(e.target.value);
                                                                setRedirectCopied(false);
                                                            },
                                                            children: redirectOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                                                    value: option.value,
                                                                    children: option.label
                                                                }, option.value))
                                                        })
                                                    ]
                                                })
                                            }),
                                            oauthRedirectType === 'localhost' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    size: "small",
                                                    type: "number",
                                                    label: t('mcp.editor.redirectPortLabel'),
                                                    value: oauthLocalhostPort,
                                                    onChange: (e)=>{
                                                        setOauthLocalhostPort(Number(e.target.value));
                                                        setRedirectCopied(false);
                                                    },
                                                    error: !!redirectPortError,
                                                    helperText: redirectPortError,
                                                    disabled: saving,
                                                    slotProps: {
                                                        inputLabel: {
                                                            shrink: true
                                                        },
                                                        htmlInput: {
                                                            min: 1024,
                                                            max: 65535
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$RedirectRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$RedirectValue, {
                                                children: oauthRedirectUri
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                                                label: t('copy'),
                                                startIcon: "duplicate",
                                                $color: "simple",
                                                hideBorder: true,
                                                onClick: ()=>{
                                                    var _navigator_clipboard;
                                                    (_navigator_clipboard = navigator.clipboard) === null || _navigator_clipboard === void 0 ? void 0 : _navigator_clipboard.writeText(oauthRedirectUri);
                                                    setRedirectCopied(true);
                                                }
                                            }),
                                            redirectCopied && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$CopiedText, {
                                                children: t('copied')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$FieldHint, {
                                        children: t(`mcp.editor.redirectNotes.${oauthRedirectType}`)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$TwoCol, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "small",
                                            label: t('mcp.editor.oauthClientIdLabel'),
                                            value: oauthClientId,
                                            onChange: (e)=>setOauthClientId(e.target.value),
                                            helperText: t('mcp.editor.oauthClientIdHelp'),
                                            disabled: saving,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            }
                                        })
                                    }),
                                    caps.secrets && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                        children: secretField(t('mcp.editor.oauthClientSecretLabel'), oauthClientSecret, setOauthClientSecret)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    size: "small",
                                    label: t('mcp.editor.oauthScopesLabel'),
                                    value: oauthScopes,
                                    placeholder: "read write",
                                    onChange: (e)=>setOauthScopes(e.target.value),
                                    helperText: t('mcp.editor.oauthScopesHelp'),
                                    disabled: saving,
                                    slotProps: {
                                        inputLabel: {
                                            shrink: true
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    size: "small",
                                    label: t('mcp.editor.oauthDiscoveryLabelShort'),
                                    value: oauthDiscoveryUrl,
                                    placeholder: "https://example.com/.well-known/oauth-authorization-server",
                                    // "(optional)" in the label bloats it and isn't a convention MUI has;
                                    // the helper is where a field says what happens if you skip it.
                                    helperText: t('mcp.editor.oauthDiscoveryHelp'),
                                    onChange: (e)=>setOauthDiscoveryUrl(e.target.value),
                                    disabled: saving,
                                    slotProps: {
                                        inputLabel: {
                                            shrink: true
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$TwoCol, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "small",
                                            label: t('mcp.editor.oauthAuthUrlLabel'),
                                            value: oauthAuthorizationUrl,
                                            onChange: (e)=>setOauthAuthorizationUrl(e.target.value),
                                            disabled: saving,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            size: "small",
                                            label: t('mcp.editor.oauthTokenUrlLabel'),
                                            value: oauthTokenUrl,
                                            onChange: (e)=>setOauthTokenUrl(e.target.value),
                                            disabled: saving,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            }
                                        })
                                    })
                                ]
                            }),
                            !caps.oauth && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$FieldHint, {
                                children: t('mcp.editor.oauthOnDevice')
                            })
                        ]
                    }),
                    authType === 'headers' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$FieldHint, {
                        children: t('mcp.editor.headersHelp')
                    })
                ]
            })
        });
    };
    const editingBanner = ()=>{
        if (!server) return null;
        const classification = (0, $4d2b958a25fb9295$export$c345321b6781c7f0)(server);
        if (classification === 'mine') return null;
        const provenance = (0, $4d2b958a25fb9295$export$45f7fee5c406a8d0)(classification, t);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$Banner, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$9ee67e6e3f51a5ed), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8f303ae5b091ff2$export$2e2bcd8739ae039), {
                        title: t('extensions.managedBy', {
                            provenance: provenance
                        }),
                        variant: "accent",
                        icon: (0, $4d2b958a25fb9295$export$db4eb5b7eb2f0820)[classification]
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$InlineRow, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$StyledLabel, {
                            children: server.name
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$StyledLabel, {
                            children: t(`extensions.integrationType.${classification}`)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                    children: t(`mcp.editor.noPermissions`, {
                        provenance: provenance
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$9ee67e6e3f51a5ed), {
                    children: classification === 'organization' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        target: "_blank",
                        $size: "small",
                        href: (0, $07546889aef07ebc$export$3fbde059e3192133)(),
                        $color: "secondary",
                        children: t('mcp.editor.altOptions.organization')
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        onClick: handleCopyServer,
                        disabled: saving,
                        $size: "small",
                        $color: "secondary",
                        children: t('mcp.editor.altOptions.copy')
                    })
                })
            ]
        });
    };
    var _testResult_status;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8684a19e32913368$export$2e2bcd8739ae039), {
        open: true,
        fullWidth: true,
        maxWidth: "md",
        scroll: "paper",
        onClose: onCancel,
        onCancel: onCancel,
        onConfirm: handleSave,
        confirmDisabled: !canSave,
        cancelButtonText: t('cancel'),
        confirmButtonText: isEdit ? t('mcp.editor.save') : t('mcp.editor.create'),
        confirmIcon: "save",
        error: saveError !== null && saveError !== void 0 ? saveError : undefined,
        title: editorMode === 'edit' ? t('mcp.editTitle') : t('mcp.newTitle'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$Body, {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        size: "small",
                        label: t('mcp.editor.nameLabel'),
                        value: name,
                        placeholder: t('mcp.editor.namePlaceholder'),
                        onChange: (e)=>setName(e.target.value),
                        onBlur: ()=>setName((current)=>(0, $4bb2c0aa345dbcf8$export$e02faa9d6aebbe9f)(current) || current),
                        error: !!nameError,
                        helperText: nameError !== null && nameError !== void 0 ? nameError : t('mcp.editor.nameHelp'),
                        disabled: saving,
                        slotProps: {
                            inputLabel: {
                                shrink: true
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        label: t('mcp.editor.descriptionLabel'),
                        fullWidth: true,
                        multiline: true,
                        minRows: 2,
                        value: description,
                        placeholder: t('mcp.editor.descriptionPlaceholder'),
                        onChange: (e)=>setDescription(e.target.value.slice(0, (0, $033e083163b21c3e$export$46ed11839ca84ea))),
                        error: !!descriptionError,
                        helperText: descriptionError !== null && descriptionError !== void 0 ? descriptionError : t('mcp.editor.descriptionHelp'),
                        disabled: saving,
                        slotProps: {
                            inputLabel: {
                                shrink: true
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($c9b3b1654ddd2b83$var$Field, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b64f84dcf6c6afeb$export$2e2bcd8739ae039), {
                            size: "small",
                            title: t('mcp.editor.transportLabel')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$SegmentRow, {
                            role: "radiogroup",
                            children: transportOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Segment, {
                                    type: "button",
                                    role: "radio",
                                    "aria-checked": transport === option.value,
                                    $selected: transport === option.value,
                                    disabled: saving,
                                    onClick: ()=>setTransport(option.value),
                                    children: option.label
                                }, option.value))
                        })
                    ]
                }),
                canEdit ? credentialsEditor() : editingBanner(),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $575b7786b3f3cd02$export$2e2bcd8739ae039), {
                        label: t('mcp.editor.activationLabel'),
                        options: activationOptions,
                        value: activation,
                        onChange: setActivation
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8792f0f4660b58e9$export$2e2bcd8739ae039), {
                    requireApproval: requireApproval,
                    disabled: saving,
                    onToggle: setRequireApproval
                }),
                caps.testConnection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $570ae8d697083555$export$2e2bcd8739ae039), {
                        status: (_testResult_status = testResult === null || testResult === void 0 ? void 0 : testResult.status) !== null && _testResult_status !== void 0 ? _testResult_status : 'unknown',
                        error: testResult === null || testResult === void 0 ? void 0 : testResult.error,
                        busy: busyAction,
                        disabled: saving,
                        needsOauth: needsOauth,
                        canDisconnect: usesOauth && oauthConnected,
                        onTest: ()=>handleTest(),
                        onReconnect: handleOauthConnect,
                        onDisconnect: handleOauthDisconnect,
                        children: (testResult === null || testResult === void 0 ? void 0 : testResult.status) === 'ok' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74c799a07a472449$export$2e2bcd8739ae039), {
                            value: testResult.tools.length,
                            title: t('mcp.tools.label'),
                            icon: "listChecks"
                        })
                    })
                }),
                caps.toolSelection && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c9b3b1654ddd2b83$var$Field, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6389cab76761cf81$export$2e2bcd8739ae039), {
                        tools: tools,
                        disabledTools: disabledTools,
                        contextWindow: contextWindow,
                        disabled: saving,
                        onChange: setDisabledTools
                    })
                })
            ]
        })
    });
}
/**
 * The gap between fields is deliberately wider than the gap inside one (label → input → helper): a
 * helper has to sit closer to the field it describes than to the next field's label, or it reads as
 * loose body copy between the two.
 */ const $c9b3b1654ddd2b83$var$Body = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c9b3b1654ddd2b83$var$t || ($c9b3b1654ddd2b83$var$t = $c9b3b1654ddd2b83$var$_`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-top: 0.5rem;
`));
const $c9b3b1654ddd2b83$var$Field = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c9b3b1654ddd2b83$var$t1 || ($c9b3b1654ddd2b83$var$t1 = $c9b3b1654ddd2b83$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
`));
const $c9b3b1654ddd2b83$var$TwoCol = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c9b3b1654ddd2b83$var$t2 || ($c9b3b1654ddd2b83$var$t2 = $c9b3b1654ddd2b83$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 12rem), 1fr));
    gap: 0.75rem;
`));
const $c9b3b1654ddd2b83$var$FieldHint = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($c9b3b1654ddd2b83$var$t3 || ($c9b3b1654ddd2b83$var$t3 = $c9b3b1654ddd2b83$var$_`
    color: ${0};
`), (props)=>props.theme.color.textBody);
const $c9b3b1654ddd2b83$var$Banner = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $12a7318cc7b914d5$export$8e508ed4a13b5a61))($c9b3b1654ddd2b83$var$t4 || ($c9b3b1654ddd2b83$var$t4 = $c9b3b1654ddd2b83$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.625rem 0.75rem;
    border-radius: 0.5rem;
`));
const $c9b3b1654ddd2b83$var$RedirectRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c9b3b1654ddd2b83$var$t5 || ($c9b3b1654ddd2b83$var$t5 = $c9b3b1654ddd2b83$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`));
const $c9b3b1654ddd2b83$var$RedirectValue = (0, $8de346382d86c747$export$2e2bcd8739ae039).code($c9b3b1654ddd2b83$var$t6 || ($c9b3b1654ddd2b83$var$t6 = $c9b3b1654ddd2b83$var$_`
    flex: 1;
    min-width: 0;
    overflow-x: auto;
    white-space: nowrap;
    padding: 0.3rem 0.5rem;
    border-radius: 0.375rem;
    background: ${0};
    border: 1px solid ${0};
    font-size: 0.75rem;
    font-family: monospace;
    color: ${0};
`), (props)=>props.theme.color.background, (props)=>props.theme.color.border, (props)=>props.theme.color.text);
const $c9b3b1654ddd2b83$var$CopiedText = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($c9b3b1654ddd2b83$var$t7 || ($c9b3b1654ddd2b83$var$t7 = $c9b3b1654ddd2b83$var$_`
    color: ${0};
    flex: none;
`), (props)=>props.theme.color.success);
const $c9b3b1654ddd2b83$var$SegmentRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c9b3b1654ddd2b83$var$t8 || ($c9b3b1654ddd2b83$var$t8 = $c9b3b1654ddd2b83$var$_`
    display: flex;
    border: 1px solid ${0};
    border-radius: 0.5rem;
    overflow: hidden;
`), (props)=>props.theme.color.border);
const $c9b3b1654ddd2b83$var$Segment = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($c9b3b1654ddd2b83$var$t9 || ($c9b3b1654ddd2b83$var$t9 = $c9b3b1654ddd2b83$var$_`
    flex: 1;
    padding: 0.4rem 0.5rem;
    font-size: 0.8125rem;
    font-weight: ${0};
    cursor: pointer;
    border: none;
    background: ${0};
    color: ${0};

    & + & {
        border-left: 1px solid ${0};
    }
    &:hover {
        background: ${0};
        color: ${0};
    }
`), (props)=>props.$selected ? 600 : 400, (props)=>props.$selected ? props.theme.color.accent : 'transparent', (props)=>props.$selected ? props.theme.color.background : props.theme.color.textBody, (props)=>props.theme.color.border, (props)=>props.$selected ? props.theme.color.accent : props.theme.color.cardHover, (props)=>props.$selected ? props.theme.color.background : props.theme.color.text);
const $c9b3b1654ddd2b83$var$InlineRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($c9b3b1654ddd2b83$var$t10 || ($c9b3b1654ddd2b83$var$t10 = $c9b3b1654ddd2b83$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`));
const $c9b3b1654ddd2b83$var$StyledLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b))($c9b3b1654ddd2b83$var$t11 || ($c9b3b1654ddd2b83$var$t11 = $c9b3b1654ddd2b83$var$_`
    color: ${0};
`), (props)=>props.theme.banner['accent'].text);



/**
 * REST client for the API AI-Skill endpoints (`/api/skill/...`). Flat functions returning
 * `IResult<T>`, matching the `enabledPlayApi.ts` convention. Auth (JWT) is attached by `generic.ts`.
 */ const $12d232914efee838$var$appendQuery = (params)=>{
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value])=>{
        if (value === null || value === undefined || value === '') return;
        search.append(key, value.toString());
    });
    const q = search.toString();
    return q ? `?${q}` : '';
};
const $12d232914efee838$export$816c0cb8b58b493 = (modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/official${$12d232914efee838$var$appendQuery({
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $12d232914efee838$export$746a6a926013cb26 = (modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/featured${$12d232914efee838$var$appendQuery({
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $12d232914efee838$export$12b5582c08a88b9d = (filter, skip = 0, take = 25, modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/public${$12d232914efee838$var$appendQuery({
        searchPhrase: filter === null || filter === void 0 ? void 0 : filter.searchPhrase,
        category: filter === null || filter === void 0 ? void 0 : filter.category,
        skip: skip,
        take: take,
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $12d232914efee838$export$867288c23551811 = (organizationId, modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/organization/${organizationId}${$12d232914efee838$var$appendQuery({
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $12d232914efee838$export$56e21bee5962e0e5 = (organizationId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/organization/${organizationId}/usage`);
const $12d232914efee838$export$c19e14d462cb0900 = ()=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/mine`);
const $12d232914efee838$export$b2ec2d68bdf4cf1c = (id)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/${id}`);
const $12d232914efee838$export$41c1ca31d2725a5c = (id)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/${id}/package`);
const $12d232914efee838$export$67a34cb49b40fd75 = (id)=>(0, $7353c99a37ec31b7$export$409e9b97a28ed92d)(`/api/skill/${id}/package/content`);
const $12d232914efee838$export$8f7867c4ccc43108 = (request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill`, request);
const $12d232914efee838$export$37e1a524556b358a = (id, request)=>(0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/skill/${id}`, request);
const $12d232914efee838$export$72a62eb14c1dc479 = (id)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/skill/${id}`);
const $12d232914efee838$export$5096d74d419e6482 = (id, file)=>(0, $7353c99a37ec31b7$export$a5575dbeeffdad98)(`/api/skill/${id}/package`, file);
const $12d232914efee838$export$831fe834c7843c8a = (id, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${id}/publish`, request);
const $12d232914efee838$export$ee0923bafa3d791a = (id, request = {})=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${id}/submit`, request);
const $12d232914efee838$export$a3d73fec00d6800d = (id)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${id}/withdraw`, {});
const $12d232914efee838$export$7b6eb57179f69e66 = (id)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/${id}/submission`);
const $12d232914efee838$export$fafea65d3177ecd2 = (skip = 0, take = 25)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/mine/submissions${$12d232914efee838$var$appendQuery({
        skip: skip,
        take: take
    })}`);
const $12d232914efee838$export$bbf6ca2002304c5d = (id, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${id}/enable`, request);
const $12d232914efee838$export$f638c83d590c6fc = (id, userDeviceId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/skill/${id}/enable${$12d232914efee838$var$appendQuery({
        userDeviceId: userDeviceId
    })}`);
const $12d232914efee838$export$64af79ee26ad2e54 = (userDeviceId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/enabled${$12d232914efee838$var$appendQuery({
        userDeviceId: userDeviceId
    })}`);
const $12d232914efee838$export$1cbd71b874f3d666 = (skillId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/${skillId}/ratings`);
const $12d232914efee838$export$96d4968e3ca944d = (skillId, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${skillId}/ratings`, request);
const $12d232914efee838$export$a856bd63a558f8de = (skillId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/skill/${skillId}/ratings`);
const $12d232914efee838$export$a7cb1d7de361a5a9 = (skillId, organizationId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/${skillId}/organization/${organizationId}/ratings`);
const $12d232914efee838$export$eb6a7aa9d6637b11 = (skillId, organizationId, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${skillId}/organization/${organizationId}/ratings`, request);
const $12d232914efee838$export$c1a75a116181c6d8 = (skillId, organizationId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/skill/${skillId}/organization/${organizationId}/ratings`);
const $12d232914efee838$export$19792261c154af1a = (skillId, organizationId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/skill/${skillId}/organization/${organizationId}/comments`);
const $12d232914efee838$export$5ba1da32600e54b6 = (skillId, organizationId, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/skill/${skillId}/organization/${organizationId}/comments`, request);
const $12d232914efee838$export$e99d1c0915afc2c = (commentId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/skill/comments/${commentId}`);



/**
 * REST client for the API MCP-server endpoints (`/api/mcpServer/...`). Flat functions returning
 * `IResult<T>`, matching the `enabledPlayApi.ts` convention. Only NON-SECRET registration config is
 * ever exchanged — credentials stay on-device.
 */ const $83a72d0303cd25d3$var$appendQuery = (params)=>{
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value])=>{
        if (value === null || value === undefined || value === '') return;
        search.append(key, value.toString());
    });
    const q = search.toString();
    return q ? `?${q}` : '';
};
const $83a72d0303cd25d3$export$29cb55fc75468123 = (modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/official${$83a72d0303cd25d3$var$appendQuery({
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $83a72d0303cd25d3$export$c371d7b7a35c5f81 = (modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/featured${$83a72d0303cd25d3$var$appendQuery({
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $83a72d0303cd25d3$export$5956e4743f4b3ec2 = (filter, skip = 0, take = 25, modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/public${$83a72d0303cd25d3$var$appendQuery({
        searchPhrase: filter === null || filter === void 0 ? void 0 : filter.searchPhrase,
        category: filter === null || filter === void 0 ? void 0 : filter.category,
        skip: skip,
        take: take,
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $83a72d0303cd25d3$export$95c1b11ef82c9592 = (organizationId, modifiedSince, sortBy)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/organization/${organizationId}${$83a72d0303cd25d3$var$appendQuery({
        modifiedSince: modifiedSince,
        sortBy: sortBy
    })}`);
const $83a72d0303cd25d3$export$eeaf0e19dddc9c6d = (organizationId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/organization/${organizationId}/usage`);
const $83a72d0303cd25d3$export$6d35e82c1d5ab048 = ()=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/mine`);
const $83a72d0303cd25d3$export$184d8048feb3497c = (id)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/${id}`);
const $83a72d0303cd25d3$export$562546ea659b163f = (request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer`, request);
const $83a72d0303cd25d3$export$597b417cc37e7472 = (id, request)=>(0, $7353c99a37ec31b7$export$991733b4d823dec6)(`/api/mcpServer/${id}`, request);
const $83a72d0303cd25d3$export$29faea4e5a1837b7 = (id)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/mcpServer/${id}`);
const $83a72d0303cd25d3$export$aba4b21fcec0cd56 = (id, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${id}/publish`, request);
const $83a72d0303cd25d3$export$798907c4c0fb14e5 = (id, request = {})=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${id}/submit`, request);
const $83a72d0303cd25d3$export$8407e1a2d9e578f1 = (id)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${id}/withdraw`, {});
const $83a72d0303cd25d3$export$dddadfac2c7b5c8e = (id)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/${id}/submission`);
const $83a72d0303cd25d3$export$716d46971b4be4d8 = (id, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${id}/enable`, request);
const $83a72d0303cd25d3$export$a7b1fa543ee66799 = (id, userDeviceId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/mcpServer/${id}/enable${$83a72d0303cd25d3$var$appendQuery({
        userDeviceId: userDeviceId
    })}`);
const $83a72d0303cd25d3$export$aead82ebd1faf591 = (userDeviceId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/enabled${$83a72d0303cd25d3$var$appendQuery({
        userDeviceId: userDeviceId
    })}`);
const $83a72d0303cd25d3$export$71f073310e5132bd = (mcpServerId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/${mcpServerId}/ratings`);
const $83a72d0303cd25d3$export$3f310adf7aa96148 = (mcpServerId, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${mcpServerId}/ratings`, request);
const $83a72d0303cd25d3$export$5c80ca80a7fd8706 = (mcpServerId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/mcpServer/${mcpServerId}/ratings`);
const $83a72d0303cd25d3$export$828757fc8f601415 = (mcpServerId, organizationId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/${mcpServerId}/organization/${organizationId}/ratings`);
const $83a72d0303cd25d3$export$2425fb5f8d83edff = (mcpServerId, organizationId, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${mcpServerId}/organization/${organizationId}/ratings`, request);
const $83a72d0303cd25d3$export$41ea004ecc00fa7 = (mcpServerId, organizationId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/mcpServer/${mcpServerId}/organization/${organizationId}/ratings`);
const $83a72d0303cd25d3$export$e7a68ff80ec1a588 = (mcpServerId, organizationId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/${mcpServerId}/organization/${organizationId}/comments`);
const $83a72d0303cd25d3$export$fbc91715620919a1 = (mcpServerId, organizationId, request)=>(0, $7353c99a37ec31b7$export$4a68059d3a005c64)(`/api/mcpServer/${mcpServerId}/organization/${organizationId}/comments`, request);
const $83a72d0303cd25d3$export$970635e34baee49f = (commentId)=>(0, $7353c99a37ec31b7$export$21a4386506d04384)(`/api/mcpServer/comments/${commentId}`);
const $83a72d0303cd25d3$export$af3bcb8945af29c5 = (mcpServerId)=>(0, $7353c99a37ec31b7$export$f8781c51b9396ab9)(`/api/mcpServer/${mcpServerId}/oauth-credentials`);



var $9d91e3163899ed11$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $27564b8a0078aa3d$export$6100ba28696e12de(buf);
    else return $27564b8a0078aa3d$export$6100ba28696e12de(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $27564b8a0078aa3d$export$d622b2ad8d90c771($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $9d91e3163899ed11$require$Buffer = $82a04c4ec6982288$export$a143d493d941bafc;

!function(e) {
    $9d91e3163899ed11$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $9d91e3163899ed11$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($9d91e3163899ed11$require$Buffer.from && $9d91e3163899ed11$require$Buffer.from !== Uint8Array.from) return $9d91e3163899ed11$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $9d91e3163899ed11$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($9d91e3163899ed11$require$Buffer.alloc) return $9d91e3163899ed11$require$Buffer.alloc(e);
                        var t = new $9d91e3163899ed11$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $9d91e3163899ed11$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $9d91e3163899ed11$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $9d91e3163899ed11$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $3a3153321729209f$exports.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


/**
 * In-browser build/parse of a skill package zip, used by the admin portal (which has no local
 * filesystem) to create and read org skills through the REST API. A skill package is a zip whose root
 * `SKILL.md` holds YAML frontmatter (name/description/keywords/activation) followed by the markdown
 * instructions body, per the Agent Skills spec. The desktop app produces/consumes the same shape.
 *
 * Only the metadata-and-body subset is handled here; supporting files (scripts/references/assets) are
 * a native-desktop-only affordance and are never part of a portal-authored package.
 */ const $07f163472843ed04$var$FRONTMATTER_DELIMITER = '---';
const $07f163472843ed04$var$BOM = '\uFEFF';
/** Serialize a minimal YAML frontmatter block (we control both sides, so no YAML lib is needed). */ function $07f163472843ed04$var$buildSkillMarkdown(front, body) {
    const lines = [
        $07f163472843ed04$var$FRONTMATTER_DELIMITER,
        `name: ${front.name}`,
        `description: ${$07f163472843ed04$var$yamlScalar(front.description)}`
    ];
    if (front.keywords && front.keywords.length > 0) lines.push(`keywords: [${front.keywords.map((k)=>$07f163472843ed04$var$yamlScalar(k)).join(', ')}]`);
    if (front.activation) lines.push(`activation: ${front.activation}`);
    lines.push($07f163472843ed04$var$FRONTMATTER_DELIMITER, '', body !== null && body !== void 0 ? body : '');
    return lines.join('\n');
}
/** Quote a scalar if it contains characters that would break simple `key: value` YAML. */ function $07f163472843ed04$var$yamlScalar(value) {
    const v = value !== null && value !== void 0 ? value : '';
    return /[:#\n"']/.test(v) ? JSON.stringify(v) : v;
}
function $07f163472843ed04$export$8eb4a87dba407ecc(markdown) {
    const text = markdown.startsWith($07f163472843ed04$var$BOM) ? markdown.slice($07f163472843ed04$var$BOM.length) : markdown;
    if (!text.startsWith($07f163472843ed04$var$FRONTMATTER_DELIMITER)) return text.trim();
    const end = text.indexOf(`\n${$07f163472843ed04$var$FRONTMATTER_DELIMITER}`, $07f163472843ed04$var$FRONTMATTER_DELIMITER.length);
    if (end === -1) return text.trim();
    const afterDelimiter = text.indexOf('\n', end + 1);
    return afterDelimiter === -1 ? '' : text.slice(afterDelimiter + 1).trim();
}
async function $07f163472843ed04$export$99dad62689d907e(front, body) {
    const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($9d91e3163899ed11$exports)))();
    zip.file('SKILL.md', $07f163472843ed04$var$buildSkillMarkdown(front, body !== null && body !== void 0 ? body : ''));
    const blob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE'
    });
    return new File([
        blob
    ], 'skill.zip', {
        type: 'application/zip'
    });
}
async function $07f163472843ed04$export$4641195e291223ea(data) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($9d91e3163899ed11$exports))).loadAsync(data);
    var _zip_file, _ref;
    // The spec puts SKILL.md at the root; tolerate a single top-level folder wrapper too.
    const entry = (_ref = (_zip_file = zip.file('SKILL.md')) !== null && _zip_file !== void 0 ? _zip_file : zip.file(/(^|\/)SKILL\.md$/i)[0]) !== null && _ref !== void 0 ? _ref : null;
    if (!entry) return '';
    const markdown = await entry.async('string');
    return $07f163472843ed04$export$8eb4a87dba407ecc(markdown);
}



function $bb96f6c4983a84fb$export$1c7236893be4762e(organizationId) {
    return {
        capabilities: {
            manageFiles: false
        },
        async getBody (skillId) {
            // Download the package through the API (CORS-allowed), not the private-blob SAS URI,
            // which the browser blocks. Returns the empty body for a metadata-only skill.
            const result = await (0, $12d232914efee838$export$67a34cb49b40fd75)(skillId);
            if (result.resultType !== 'Ok' || !result.data) return '';
            return (0, $07f163472843ed04$export$4641195e291223ea)(await result.data.arrayBuffer());
        },
        async createSkill (input) {
            var _input_keywords;
            const result = await (0, $12d232914efee838$export$8f7867c4ccc43108)({
                name: input.name,
                displayName: $bb96f6c4983a84fb$var$titleize(input.name),
                description: input.description,
                categories: (_input_keywords = input.keywords) !== null && _input_keywords !== void 0 ? _input_keywords : [],
                version: '1',
                organizationId: organizationId
            });
            if (result.resultType !== 'Ok' || !result.data) throw new Error($bb96f6c4983a84fb$var$errorMessage(result, 'Could not create the skill.'));
            await $bb96f6c4983a84fb$var$uploadPackage(result.data.id, input);
            return $bb96f6c4983a84fb$var$toLocalSkill(result.data);
        },
        async updateSkill (input) {
            var _input_name, _input_name1, _input_keywords;
            const result = await (0, $12d232914efee838$export$37e1a524556b358a)(input.id, {
                name: (_input_name = input.name) !== null && _input_name !== void 0 ? _input_name : '',
                displayName: $bb96f6c4983a84fb$var$titleize((_input_name1 = input.name) !== null && _input_name1 !== void 0 ? _input_name1 : ''),
                description: input.description,
                categories: (_input_keywords = input.keywords) !== null && _input_keywords !== void 0 ? _input_keywords : []
            });
            if (result.resultType !== 'Ok' || !result.data) throw new Error($bb96f6c4983a84fb$var$errorMessage(result, 'Could not save the skill.'));
            // The editor always sends the current body on save; repackage and re-upload it.
            await $bb96f6c4983a84fb$var$uploadPackage(input.id, input);
            return $bb96f6c4983a84fb$var$toLocalSkill(result.data);
        }
    };
}
async function $bb96f6c4983a84fb$var$uploadPackage(skillId, input) {
    var _input_name, _input_description;
    const file = await (0, $07f163472843ed04$export$99dad62689d907e)({
        name: (_input_name = input.name) !== null && _input_name !== void 0 ? _input_name : '',
        description: (_input_description = input.description) !== null && _input_description !== void 0 ? _input_description : '',
        keywords: input.keywords,
        activation: input.activation
    }, input.body);
    const upload = await (0, $12d232914efee838$export$5096d74d419e6482)(skillId, file);
    if (upload.resultType !== 'Ok') throw new Error($bb96f6c4983a84fb$var$errorMessage(upload, 'Could not upload the skill package.'));
}
/** Build a minimal local SkillModel from the API read model (the editor only reads `id`). */ function $bb96f6c4983a84fb$var$toLocalSkill(model) {
    var _model_description;
    return {
        id: model.id,
        name: model.name,
        description: (_model_description = model.description) !== null && _model_description !== void 0 ? _model_description : '',
        keywords: [],
        dirPath: '',
        skillMdPath: '',
        source: 'organization',
        enabled: false,
        activation: (0, $83bad78370366bbe$export$fc097f65acdbbf35),
        hasScripts: false,
        hasReferences: false,
        visibility: 'organization',
        createdAt: Date.parse(model.createdDate) || 0,
        updatedAt: Date.parse(model.modifiedDate) || 0,
        remoteId: model.id,
        organizationId: model.organizationId,
        isOfficial: model.isOfficial
    };
}
function $bb96f6c4983a84fb$var$titleize(name) {
    return name.split('-').filter(Boolean).map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
function $bb96f6c4983a84fb$var$errorMessage(result, fallback) {
    var _result_errors;
    var _result_errors_;
    return (_result_errors_ = (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors[0]) !== null && _result_errors_ !== void 0 ? _result_errors_ : fallback;
}






/**
 * Converts between the local runtime {@link McpServerModel} (string unions, discrete OAuth/apiKey
 * fields, secrets held separately) and the API {@link McpServerRegistrationModel} / request shapes
 * (`transportType`/`authType` enums + an `authConfigJson` blob).
 *
 * CRITICAL: only NON-SECRET configuration crosses this boundary. API keys, OAuth client secrets, OAuth
 * tokens, and secret header/env values are never read from the local model here (the redacted model
 * doesn't even carry them) and are never written back — a recipient re-enters their own credentials.
 */ const $a6054cd09d79a201$var$TRANSPORT_TO_WIRE = {
    http: 'Http',
    sse: 'Sse',
    stdio: 'Stdio'
};
const $a6054cd09d79a201$var$WIRE_TO_TRANSPORT = {
    Http: 'http',
    Sse: 'sse',
    Stdio: 'stdio'
};
const $a6054cd09d79a201$var$AUTH_TO_WIRE = {
    none: 'None',
    apiKey: 'ApiKey',
    oauth: 'OAuth',
    headers: 'Custom'
};
const $a6054cd09d79a201$var$WIRE_TO_AUTH = {
    None: 'none',
    ApiKey: 'apiKey',
    OAuth: 'oauth',
    Custom: 'headers'
};
function $a6054cd09d79a201$var$titleize(name) {
    return name.split('-').filter(Boolean).map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
/** Build the non-secret `authConfigJson` from a local server's auth fields. */ function $a6054cd09d79a201$var$buildAuthConfigJson(local) {
    const config = {};
    if (local.authType === 'apiKey') {
        config.apiKeyHeaderName = local.apiKeyHeaderName;
        config.apiKeyPrefix = local.apiKeyPrefix;
    }
    if (local.authType === 'oauth') {
        config.oauthClientId = local.oauthClientId;
        config.oauthScopes = local.oauthScopes;
        config.oauthDiscoveryUrl = local.oauthDiscoveryUrl;
        config.oauthAuthorizationUrl = local.oauthAuthorizationUrl;
        config.oauthTokenUrl = local.oauthTokenUrl;
        config.oauthRedirectType = local.oauthRedirectType;
        // The port is only part of the URI a recipient has to register when the callback is loopback.
        if (local.oauthRedirectType === 'localhost') config.oauthLocalhostPort = local.oauthLocalhostPort;
    }
    if (local.headers) config.headerNames = Object.keys(local.headers);
    return Object.keys(config).length > 0 ? JSON.stringify(config) : undefined;
}
function $a6054cd09d79a201$var$parseAuthConfig(authConfigJson) {
    if (!authConfigJson) return {};
    try {
        return JSON.parse(authConfigJson);
    } catch (e) {
        return {};
    }
}
function $a6054cd09d79a201$export$483f083410bb1282(local, organizationId, metadata) {
    var _md_displayName, _md_iconUrl, _md_darkModeIconUrl, _md_version;
    const md = metadata !== null && metadata !== void 0 ? metadata : {};
    var _md_description, _md_shortDescription, _md_categories;
    return {
        name: local.name,
        displayName: ((_md_displayName = md.displayName) === null || _md_displayName === void 0 ? void 0 : _md_displayName.trim()) || $a6054cd09d79a201$var$titleize(local.name),
        description: (_md_description = md.description) !== null && _md_description !== void 0 ? _md_description : local.description,
        shortDescription: (_md_shortDescription = md.shortDescription) !== null && _md_shortDescription !== void 0 ? _md_shortDescription : local.description.slice(0, 140),
        iconUrl: ((_md_iconUrl = md.iconUrl) === null || _md_iconUrl === void 0 ? void 0 : _md_iconUrl.trim()) || undefined,
        darkModeIconUrl: ((_md_darkModeIconUrl = md.darkModeIconUrl) === null || _md_darkModeIconUrl === void 0 ? void 0 : _md_darkModeIconUrl.trim()) || undefined,
        categories: (_md_categories = md.categories) !== null && _md_categories !== void 0 ? _md_categories : [],
        version: ((_md_version = md.version) === null || _md_version === void 0 ? void 0 : _md_version.trim()) || (local.remoteVersion ? String(local.remoteVersion) : '1'),
        serverUrl: local.url,
        transportType: $a6054cd09d79a201$var$TRANSPORT_TO_WIRE[local.transport],
        command: local.command,
        commandArgs: local.args,
        authType: $a6054cd09d79a201$var$AUTH_TO_WIRE[local.authType],
        authConfigJson: $a6054cd09d79a201$var$buildAuthConfigJson(local),
        organizationId: organizationId
    };
}
function $a6054cd09d79a201$export$c9475e3537e8fadb(local, metadata) {
    const create = $a6054cd09d79a201$export$483f083410bb1282(local, undefined, metadata);
    // Update has the same shape minus organizationId.
    const { organizationId: organizationId } = create, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(create, [
        "organizationId"
    ]);
    return rest;
}
function $a6054cd09d79a201$export$f832804beecc52d9(reg) {
    const auth = $a6054cd09d79a201$var$parseAuthConfig(reg.authConfigJson);
    var _reg_description;
    return {
        name: reg.name,
        description: (_reg_description = reg.description) !== null && _reg_description !== void 0 ? _reg_description : '',
        transport: $a6054cd09d79a201$var$WIRE_TO_TRANSPORT[reg.transportType],
        command: reg.command,
        args: reg.commandArgs,
        url: reg.serverUrl,
        headers: auth.headerNames ? Object.fromEntries(auth.headerNames.map((h)=>[
                h,
                ''
            ])) : undefined,
        authType: $a6054cd09d79a201$var$WIRE_TO_AUTH[reg.authType],
        apiKeyHeaderName: auth.apiKeyHeaderName,
        apiKeyPrefix: auth.apiKeyPrefix,
        oauthClientId: auth.oauthClientId,
        oauthScopes: auth.oauthScopes,
        oauthDiscoveryUrl: auth.oauthDiscoveryUrl,
        oauthAuthorizationUrl: auth.oauthAuthorizationUrl,
        oauthTokenUrl: auth.oauthTokenUrl,
        oauthRedirectType: auth.oauthRedirectType,
        oauthLocalhostPort: auth.oauthLocalhostPort,
        activation: (0, $033e083163b21c3e$export$9eaf6d18288e6f0f),
        requireApproval: true
    };
}



function $84e2276405a3056c$export$432387839c70f346(organizationId) {
    return {
        capabilities: {
            stdioTransport: false,
            secrets: false,
            testConnection: false,
            oauth: false,
            toolSelection: false
        },
        async createServer (input) {
            var _result_errors;
            // The editor's CreateMcpServerInput is a structural subset of the local McpServerModel that
            // localToCreateRequest reads (it only touches non-secret config fields).
            const request = (0, $a6054cd09d79a201$export$483f083410bb1282)(input, organizationId);
            const result = await (0, $83a72d0303cd25d3$export$562546ea659b163f)(request);
            var _result_errors_;
            if (result.resultType !== 'Ok' || !result.data) throw new Error((_result_errors_ = (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors[0]) !== null && _result_errors_ !== void 0 ? _result_errors_ : 'Could not create the connector.');
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $a6054cd09d79a201$export$f832804beecc52d9)(result.data)), {
                id: result.data.id
            });
        },
        async updateServer (input) {
            var _result_errors;
            const request = (0, $a6054cd09d79a201$export$c9475e3537e8fadb)(input);
            const result = await (0, $83a72d0303cd25d3$export$597b417cc37e7472)(input.id, request);
            var _result_errors_;
            if (result.resultType !== 'Ok' || !result.data) throw new Error((_result_errors_ = (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors[0]) !== null && _result_errors_ !== void 0 ? _result_errors_ : 'Could not save the connector.');
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $a6054cd09d79a201$export$f832804beecc52d9)(result.data)), {
                id: result.data.id
            });
        }
    };
}






var $7fPBF = parcelRequire("7fPBF");
















var $7fPBF = parcelRequire("7fPBF");











'use client';
var $a10f68f3afd85288$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');




'use client';
var $f2e229f8d041a362$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');








function $2c6f1123f0e1c8b1$export$2c22c4f65a44ac6b(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiRating', slot);
}
const $2c6f1123f0e1c8b1$var$ratingClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiRating', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'readOnly',
    'disabled',
    'focusVisible',
    'visuallyHidden',
    'pristine',
    'label',
    'labelEmptyValueActive',
    'icon',
    'iconEmpty',
    'iconFilled',
    'iconHover',
    'iconFocus',
    'iconActive',
    'decimal'
]);
var $2c6f1123f0e1c8b1$export$2e2bcd8739ae039 = $2c6f1123f0e1c8b1$var$ratingClasses;





'use client';
function $115b127f7bce8d22$var$getDecimalPrecision(num) {
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $115b127f7bce8d22$var$roundValueToPrecision(value, precision) {
    if (value == null) return value;
    const nearest = Math.round(value / precision) * precision;
    return Number(nearest.toFixed($115b127f7bce8d22$var$getDecimalPrecision(precision)));
}
const $115b127f7bce8d22$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, size: size, readOnly: readOnly, disabled: disabled, emptyValueFocused: emptyValueFocused, focusVisible: focusVisible } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(size)}`,
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            readOnly && 'readOnly'
        ],
        label: [
            'label',
            'pristine'
        ],
        labelEmptyValue: [
            emptyValueFocused && 'labelEmptyValueActive'
        ],
        icon: [
            'icon'
        ],
        iconEmpty: [
            'iconEmpty'
        ],
        iconFilled: [
            'iconFilled'
        ],
        iconHover: [
            'iconHover'
        ],
        iconFocus: [
            'iconFocus'
        ],
        iconActive: [
            'iconActive'
        ],
        decimal: [
            'decimal'
        ],
        visuallyHidden: [
            'visuallyHidden'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $2c6f1123f0e1c8b1$export$2c22c4f65a44ac6b), classes);
};
const $115b127f7bce8d22$var$RatingRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiRating',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2c6f1123f0e1c8b1$export$2e2bcd8739ae039).visuallyHidden}`]: styles.visuallyHidden
            },
            styles.root,
            styles[`size${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.readOnly && styles.readOnly
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        // Required to position the pristine input absolutely
        position: 'relative',
        fontSize: theme.typography.pxToRem(24),
        color: '#faaf00',
        cursor: 'pointer',
        textAlign: 'left',
        width: 'min-content',
        WebkitTapHighlightColor: 'transparent',
        [`&.${(0, $2c6f1123f0e1c8b1$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`&.${(0, $2c6f1123f0e1c8b1$export$2e2bcd8739ae039).focusVisible} .${(0, $2c6f1123f0e1c8b1$export$2e2bcd8739ae039).iconActive}`]: {
            outline: '1px solid #999'
        },
        [`& .${(0, $2c6f1123f0e1c8b1$export$2e2bcd8739ae039).visuallyHidden}`]: (0, $a1838e012595e8ac$export$2e2bcd8739ae039),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(30)
                }
            },
            {
                // TODO v6: use the .Mui-readOnly global state class
                props: ({ ownerState: ownerState })=>ownerState.readOnly,
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $115b127f7bce8d22$var$RatingLabel = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('label', {
    name: 'MuiRating',
    slot: 'Label',
    overridesResolver: ({ ownerState: ownerState }, styles)=>[
            styles.label,
            ownerState.emptyValueFocused && styles.labelEmptyValueActive
        ]
})({
    cursor: 'inherit',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.emptyValueFocused,
            style: {
                top: 0,
                bottom: 0,
                position: 'absolute',
                outline: '1px solid #999',
                width: '100%'
            }
        }
    ]
});
const $115b127f7bce8d22$var$RatingIcon = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiRating',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.iconEmpty && styles.iconEmpty,
            ownerState.iconFilled && styles.iconFilled,
            ownerState.iconHover && styles.iconHover,
            ownerState.iconFocus && styles.iconFocus,
            ownerState.iconActive && styles.iconActive
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        // Fit wrapper to actual icon size.
        display: 'flex'
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
        duration: theme.transitions.duration.shortest
    })), {
        // Fix mouseLeave issue.
        // https://github.com/react/react/issues/4492
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.iconActive,
                style: {
                    transform: 'scale(1.2)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.iconEmpty,
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            }
        ]
    })));
const $115b127f7bce8d22$var$RatingDecimal = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiRating',
    slot: 'Decimal',
    shouldForwardProp: (prop)=>(0, $69b67c4b8d281c07$export$2e2bcd8739ae039)(prop) && prop !== 'iconActive',
    overridesResolver: (props, styles)=>{
        const { iconActive: iconActive } = props;
        return [
            styles.decimal,
            iconActive && styles.iconActive
        ];
    }
})({
    position: 'relative',
    variants: [
        {
            props: ({ iconActive: iconActive })=>iconActive,
            style: {
                transform: 'scale(1.2)'
            }
        }
    ]
});
function $115b127f7bce8d22$var$IconContainer(props) {
    const { value: value } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "value"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, other));
}
function $115b127f7bce8d22$var$RatingItem(props) {
    const { classes: classes, disabled: disabled, emptyIcon: emptyIcon, focus: focus, getLabelText: getLabelText, highlightSelectedOnly: highlightSelectedOnly, hover: hover, icon: icon, isActive: isActive, itemValue: itemValue, labelProps: labelProps, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, readOnly: readOnly, ownerState: ownerState, ratingValue: ratingValue, ratingValueRounded: ratingValueRounded, slots: slots = {}, slotProps: slotProps = {} } = props;
    const isFilled = highlightSelectedOnly ? itemValue === ratingValue : itemValue <= ratingValue;
    const isHovered = itemValue <= hover;
    const isFocused = itemValue <= focus;
    const isChecked = itemValue === ratingValueRounded;
    // "name" ensures unique IDs across different Rating components in React 17,
    // preventing one component from affecting another. React 18's useId already handles this.
    // Update to const id = useId(); when React 17 support is dropped.
    // More details: https://github.com/mui/material-ui/issues/40997
    const id = `${name}-${(0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)()}`;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [IconSlot, iconSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('icon', {
        elementType: $115b127f7bce8d22$var$RatingIcon,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.icon, isFilled ? classes.iconFilled : classes.iconEmpty, isHovered && classes.iconHover, isFocused && classes.iconFocus, isActive && classes.iconActive),
        externalForwardedProps: externalForwardedProps,
        ownerState: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ownerState), {
            iconEmpty: !isFilled,
            iconFilled: isFilled,
            iconHover: isHovered,
            iconFocus: isFocused,
            iconActive: isActive
        }),
        additionalProps: {
            value: itemValue
        },
        internalForwardedProps: {
            as: $115b127f7bce8d22$var$IconContainer
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('label', {
        elementType: $115b127f7bce8d22$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ownerState), {
            emptyValueFocused: undefined
        }),
        additionalProps: {
            style: labelProps === null || labelProps === void 0 ? void 0 : labelProps.style,
            htmlFor: id
        }
    });
    const container = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(IconSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, iconSlotProps), {
        children: emptyIcon && !isFilled ? emptyIcon : icon
    }));
    if (readOnly) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, labelProps), {
        children: container
    }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(LabelSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, labelSlotProps), {
                children: [
                    container,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: getLabelText(itemValue)
                    })
                ]
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                className: classes.visuallyHidden,
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
                onClick: onClick,
                disabled: disabled,
                value: itemValue,
                id: id,
                type: "radio",
                name: name,
                checked: isChecked
            })
        ]
    });
}
const $115b127f7bce8d22$var$defaultIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a10f68f3afd85288$export$2e2bcd8739ae039), {
    fontSize: "inherit"
});
const $115b127f7bce8d22$var$defaultEmptyIcon = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2e229f8d041a362$export$2e2bcd8739ae039), {
    fontSize: "inherit"
});
function $115b127f7bce8d22$var$defaultLabelText(value) {
    return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
}
const $115b127f7bce8d22$var$Rating = /*#__PURE__*/ $7fPBF.forwardRef(function Rating(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        name: 'MuiRating',
        props: inProps
    });
    const { component: component = 'span', className: className, defaultValue: defaultValue = null, disabled: disabled = false, emptyIcon: emptyIcon = $115b127f7bce8d22$var$defaultEmptyIcon, emptyLabelText: emptyLabelText = 'Empty', getLabelText: getLabelText = $115b127f7bce8d22$var$defaultLabelText, highlightSelectedOnly: highlightSelectedOnly = false, icon: icon = $115b127f7bce8d22$var$defaultIcon, max: max = 5, name: nameProp, onChange: onChange, onChangeActive: onChangeActive, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, precision: precision = 1, readOnly: readOnly = false, size: size = 'medium', value: valueProp, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "component",
        "className",
        "defaultValue",
        "disabled",
        "emptyIcon",
        "emptyLabelText",
        "getLabelText",
        "highlightSelectedOnly",
        "icon",
        "max",
        "name",
        "onChange",
        "onChangeActive",
        "onMouseLeave",
        "onMouseMove",
        "precision",
        "readOnly",
        "size",
        "value",
        "slots",
        "slotProps"
    ]);
    const name = (0, $ad114c389ed7c9ee$export$2e2bcd8739ae039)(nameProp);
    const [valueDerived, setValueState] = (0, $d2efeb5524b9e738$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Rating'
    });
    const valueRounded = $115b127f7bce8d22$var$roundValueToPrecision(valueDerived, precision);
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const [{ hover: hover, focus: focus }, setState] = $7fPBF.useState({
        hover: -1,
        focus: -1
    });
    let value = valueRounded;
    if (hover !== -1) value = hover;
    if (focus !== -1) value = focus;
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    const rootRef = $7fPBF.useRef();
    const handleRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(rootRef, ref);
    const handleMouseMove = (event)=>{
        if (onMouseMove) onMouseMove(event);
        const rootNode = rootRef.current;
        const { right: right, left: left, width: containerWidth } = rootNode.getBoundingClientRect();
        let percent;
        if (isRtl) percent = (right - event.clientX) / containerWidth;
        else percent = (event.clientX - left) / containerWidth;
        let newHover = $115b127f7bce8d22$var$roundValueToPrecision(max * percent + precision / 2, precision);
        newHover = (0, $99fc5207cecba1ae$export$2e2bcd8739ae039)(newHover, precision, max);
        setState((prev)=>prev.hover === newHover && prev.focus === newHover ? prev : {
                hover: newHover,
                focus: newHover
            });
        setFocusVisible(false);
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        const newHover = -1;
        setState({
            hover: newHover,
            focus: newHover
        });
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleChange = (event)=>{
        let newValue = event.target.value === '' ? null : parseFloat(event.target.value);
        // Give mouse priority over keyboard
        // Fix https://github.com/mui/material-ui/issues/22827
        if (hover !== -1) newValue = hover;
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    };
    const handleClear = (event)=>{
        // Ignore keyboard events
        // https://github.com/react/react/issues/7407
        if (event.clientX === 0 && event.clientY === 0) return;
        setState({
            hover: -1,
            focus: -1
        });
        setValueState(null);
        if (onChange && parseFloat(event.target.value) === valueRounded) onChange(event, null);
    };
    const handleFocus = (event)=>{
        if ((0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) setFocusVisible(true);
        const newFocus = parseFloat(event.target.value);
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const handleBlur = (event)=>{
        if (hover !== -1) return;
        if (!(0, $3ee2ed17fbd1526c$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        const newFocus = -1;
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const [emptyValueFocused, setEmptyValueFocused] = $7fPBF.useState(false);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        defaultValue: defaultValue,
        disabled: disabled,
        emptyIcon: emptyIcon,
        emptyLabelText: emptyLabelText,
        emptyValueFocused: emptyValueFocused,
        focusVisible: focusVisible,
        getLabelText: getLabelText,
        icon: icon,
        max: max,
        precision: precision,
        readOnly: readOnly,
        size: size
    });
    const classes = $115b127f7bce8d22$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: handleRef,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $115b127f7bce8d22$var$RatingRoot,
        externalForwardedProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other), {
            component: component
        }),
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onMouseMove: (event)=>{
                    var _handlers_onMouseMove;
                    handleMouseMove(event);
                    (_handlers_onMouseMove = handlers.onMouseMove) === null || _handlers_onMouseMove === void 0 ? void 0 : _handlers_onMouseMove.call(handlers, event);
                },
                onMouseLeave: (event)=>{
                    var _handlers_onMouseLeave;
                    handleMouseLeave(event);
                    (_handlers_onMouseLeave = handlers.onMouseLeave) === null || _handlers_onMouseLeave === void 0 ? void 0 : _handlers_onMouseLeave.call(handlers, event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            role: readOnly ? 'img' : null,
            'aria-label': readOnly ? getLabelText(value) : null
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('label', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.label, classes.labelEmptyValue),
        elementType: $115b127f7bce8d22$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DecimalSlot, decimalSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('decimal', {
        className: classes.decimal,
        elementType: $115b127f7bce8d22$var$RatingDecimal,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        children: [
            Array.from(new Array(max)).map((_, index)=>{
                const itemValue = index + 1;
                const ratingItemProps = {
                    classes: classes,
                    disabled: disabled,
                    emptyIcon: emptyIcon,
                    focus: focus,
                    getLabelText: getLabelText,
                    highlightSelectedOnly: highlightSelectedOnly,
                    hover: hover,
                    icon: icon,
                    name: name,
                    onBlur: handleBlur,
                    onChange: handleChange,
                    onClick: handleClear,
                    onFocus: handleFocus,
                    ratingValue: value,
                    ratingValueRounded: valueRounded,
                    readOnly: readOnly,
                    ownerState: ownerState,
                    slots: slots,
                    slotProps: slotProps
                };
                const isActive = itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1);
                if (precision < 1) {
                    const items = Array.from(new Array(1 / precision));
                    return /*#__PURE__*/ (0, $7fPBF.createElement)(DecimalSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, decimalSlotProps), {
                        key: itemValue,
                        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(decimalSlotProps.className, isActive && classes.iconActive),
                        iconActive: isActive
                    }), items.map(($, indexDecimal)=>{
                        const itemDecimalValue = $115b127f7bce8d22$var$roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($115b127f7bce8d22$var$RatingItem, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ratingItemProps), {
                            // The icon is already displayed as active
                            isActive: false,
                            itemValue: itemDecimalValue,
                            labelProps: {
                                style: items.length - 1 === indexDecimal ? {} : {
                                    width: itemDecimalValue === value ? `${(indexDecimal + 1) * precision * 100}%` : '0%',
                                    overflow: 'hidden',
                                    position: 'absolute'
                                }
                            }
                        }), itemDecimalValue);
                    }));
                }
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($115b127f7bce8d22$var$RatingItem, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ratingItemProps), {
                    isActive: isActive,
                    itemValue: itemValue
                }), itemValue);
            }),
            !readOnly && !disabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(LabelSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, labelSlotProps), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        className: classes.visuallyHidden,
                        value: "",
                        id: `${name}-empty`,
                        type: "radio",
                        name: name,
                        checked: valueRounded == null,
                        onFocus: ()=>setEmptyValueFocused(true),
                        onBlur: ()=>setEmptyValueFocused(false),
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: emptyLabelText
                    })
                ]
            }))
        ]
    }));
});
var $115b127f7bce8d22$export$2e2bcd8739ae039 = $115b127f7bce8d22$var$Rating;



var $7fPBF = parcelRequire("7fPBF");




let $333165d7b30849b1$var$_ = (t)=>t, $333165d7b30849b1$var$t, $333165d7b30849b1$var$t1, $333165d7b30849b1$var$t2, $333165d7b30849b1$var$t3, $333165d7b30849b1$var$t4;
function $333165d7b30849b1$export$2e2bcd8739ae039({ rating: rating, onRatingChange: onRatingChange, comment: comment = '', onCommentChange: onCommentChange, hideComment: hideComment = false, disabled: disabled = false, className: className }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const ratingLabelId = (0, $7fPBF.useId)();
    const commentId = (0, $7fPBF.useId)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($333165d7b30849b1$var$Wrap, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($333165d7b30849b1$var$RatingRow, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                        id: ratingLabelId,
                        children: t('rating.review.yourRating')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $115b127f7bce8d22$export$2e2bcd8739ae039), {
                        size: "large",
                        value: rating,
                        disabled: disabled,
                        "aria-labelledby": ratingLabelId,
                        onChange: (_, value)=>onRatingChange(value !== null && value !== void 0 ? value : 0)
                    })
                ]
            }),
            !hideComment && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($333165d7b30849b1$var$CommentSection, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($333165d7b30849b1$var$CommentLabel, {
                        htmlFor: commentId,
                        children: [
                            t('rating.review.comment'),
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($333165d7b30849b1$var$Optional, {
                                children: t('rating.review.optional')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                        id: commentId,
                        fullWidth: true,
                        multiline: true,
                        minRows: 3,
                        value: comment,
                        disabled: disabled,
                        placeholder: t('rating.review.commentPlaceholder'),
                        onChange: (event)=>onCommentChange === null || onCommentChange === void 0 ? void 0 : onCommentChange(event.target.value)
                    })
                ]
            })
        ]
    });
}
const $333165d7b30849b1$var$Wrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($333165d7b30849b1$var$t || ($333165d7b30849b1$var$t = $333165d7b30849b1$var$_`
    display: flex;
    flex-direction: column;
`));
const $333165d7b30849b1$var$RatingRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($333165d7b30849b1$var$t1 || ($333165d7b30849b1$var$t1 = $333165d7b30849b1$var$_`
    display: flex;
    align-items: center;
    margin: 0.75rem 0 1.25rem;
`));
const $333165d7b30849b1$var$CommentSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($333165d7b30849b1$var$t2 || ($333165d7b30849b1$var$t2 = $333165d7b30849b1$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
`));
const $333165d7b30849b1$var$CommentLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$df83f18906197f6b).withComponent('label'))($333165d7b30849b1$var$t3 || ($333165d7b30849b1$var$t3 = $333165d7b30849b1$var$_`
    color: ${0};
    font-weight: 700;
`), (props)=>props.theme.color.text);
const $333165d7b30849b1$var$Optional = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($333165d7b30849b1$var$t4 || ($333165d7b30849b1$var$t4 = $333165d7b30849b1$var$_`
    font-weight: 400;
    color: ${0};
`), (props)=>props.theme.color.textBody);





const $ea9d72e3a251c25d$export$2369f32a5da9d5b8 = (value, locale, t)=>{
    if (typeof value !== 'number' || isNaN(value)) return t('invalidNumber');
    const formatter = new Intl.NumberFormat(locale, {
        notation: 'compact',
        compactDisplay: 'short'
    });
    return formatter.format(value);
};






let $ca16fc37bc773bdd$var$_ = (t)=>t, $ca16fc37bc773bdd$var$t, $ca16fc37bc773bdd$var$t1, $ca16fc37bc773bdd$var$t2, $ca16fc37bc773bdd$var$t3, $ca16fc37bc773bdd$var$t4;
/**
 * Ratings below this many votes are withheld, so a single early rating can't stand in for consensus.
 * Mirrors MIN_PUBLIC_RATINGS in ExtensionMarketplaceStats; override per-surface with `minRatings`.
 */ const $ca16fc37bc773bdd$var$DEFAULT_MIN_RATINGS = 5;
function $ca16fc37bc773bdd$export$2e2bcd8739ae039({ averageRating: averageRating, ratingCount: ratingCount, installCount: installCount, commentCount: commentCount, compact: compact = false, showEmptyRating: showEmptyRating = false, minRatings: minRatings = $ca16fc37bc773bdd$var$DEFAULT_MIN_RATINGS, onClick: onClick, actionLabel: actionLabel, className: className }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const locale = i18n.language;
    const hasEnoughRatings = (ratingCount !== null && ratingCount !== void 0 ? ratingCount : 0) >= minRatings;
    const showAverage = hasEnoughRatings && averageRating !== undefined;
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (showAverage || showEmptyRating) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ca16fc37bc773bdd$var$AverageGroup, {
                children: [
                    showAverage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ca16fc37bc773bdd$var$Average, {
                        children: averageRating.toLocaleString(locale, {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ca16fc37bc773bdd$var$AverageStars, {
                        value: showAverage ? averageRating : 0,
                        precision: 0.5,
                        size: "small",
                        readOnly: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                        children: showAverage ? t('rating.summary.ratingCount', {
                            count: ratingCount !== null && ratingCount !== void 0 ? ratingCount : 0
                        }) : t('rating.summary.noRatings')
                    })
                ]
            }),
            installCount !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8f303ae5b091ff2$export$2e2bcd8739ae039), {
                icon: "download",
                value: (0, $ea9d72e3a251c25d$export$2369f32a5da9d5b8)(installCount, locale, t),
                title: t('rating.summary.installs'),
                hideLabel: compact
            }),
            commentCount !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8f303ae5b091ff2$export$2e2bcd8739ae039), {
                icon: "chat",
                value: (0, $ea9d72e3a251c25d$export$2369f32a5da9d5b8)(commentCount, locale, t),
                title: t('rating.summary.comments'),
                hideLabel: compact
            })
        ]
    });
    if (!onClick) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ca16fc37bc773bdd$var$Row, {
        $compact: compact,
        className: className,
        children: content
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ca16fc37bc773bdd$var$RowButton, {
        type: "button",
        $compact: compact,
        className: className,
        // These rows sit inside clickable cards; a rating click must not also open the card.
        onClick: (event)=>{
            event.stopPropagation();
            onClick();
        },
        children: [
            content,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30af349a5a5f3e57$export$2e2bcd8739ae039), {
                children: actionLabel !== null && actionLabel !== void 0 ? actionLabel : t('rating.summary.openReview')
            })
        ]
    });
}
/**
 * The padding lives here rather than on the button form, so a read-only row and a rateable one occupy
 * exactly the same box — otherwise the ratings strip shifts by a couple of pixels between a surface the
 * user can rate on and one they can't (browse vs. installed, for the same item).
 */ const $ca16fc37bc773bdd$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($ca16fc37bc773bdd$var$t || ($ca16fc37bc773bdd$var$t = $ca16fc37bc773bdd$var$_`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0.125rem 0;
    /* Label-less tags read as separate figures at a tighter gap; spelled-out ones need the air. */
    gap: ${0};
`), (props)=>props.$compact ? '0.625rem' : '0.75rem');
const $ca16fc37bc773bdd$var$RowButton = (0, $8de346382d86c747$export$2e2bcd8739ae039)($ca16fc37bc773bdd$var$Row.withComponent('button'))($ca16fc37bc773bdd$var$t1 || ($ca16fc37bc773bdd$var$t1 = $ca16fc37bc773bdd$var$_`
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    /* <button> doesn't inherit the themed text color, and the stars/icons use currentColor. */
    color: ${0};

    &:hover {
        opacity: 0.8;
    }
    &:focus-visible {
        outline: 2px solid ${0};
        outline-offset: 2px;
        border-radius: 0.25rem;
    }
`), (props)=>props.theme.color.text, (props)=>props.theme.color.accent);
const $ca16fc37bc773bdd$var$AverageGroup = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($ca16fc37bc773bdd$var$t2 || ($ca16fc37bc773bdd$var$t2 = $ca16fc37bc773bdd$var$_`
    display: flex;
    align-items: center;
    gap: 0.375rem;
`));
const $ca16fc37bc773bdd$var$Average = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))($ca16fc37bc773bdd$var$t3 || ($ca16fc37bc773bdd$var$t3 = $ca16fc37bc773bdd$var$_`
    color: ${0};
`), (props)=>props.theme.color.text);
/**
 * The aggregate stars read as text, not as MUI's amber: filled stars take the themed text color and
 * the remainder the muted body color. The rating *input* in `RateReviewDialog` keeps the amber, so
 * the thing you can act on stays visually distinct from the read-only score.
 */ const $ca16fc37bc773bdd$var$AverageStars = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $115b127f7bce8d22$export$2e2bcd8739ae039))($ca16fc37bc773bdd$var$t4 || ($ca16fc37bc773bdd$var$t4 = $ca16fc37bc773bdd$var$_`
    & .MuiRating-iconFilled {
        color: ${0};
    }
    & .MuiRating-iconEmpty {
        color: ${0};
    }
`), (props)=>props.theme.color.text, (props)=>props.theme.color.textBody);






var $7fPBF = parcelRequire("7fPBF");

let $4b4a63a5e741fa10$var$_ = (t)=>t, $4b4a63a5e741fa10$var$t, $4b4a63a5e741fa10$var$t1, $4b4a63a5e741fa10$var$t2, $4b4a63a5e741fa10$var$t3, $4b4a63a5e741fa10$var$t4, $4b4a63a5e741fa10$var$t5, $4b4a63a5e741fa10$var$t6, $4b4a63a5e741fa10$var$t7, $4b4a63a5e741fa10$var$t8;
function $4b4a63a5e741fa10$export$2e2bcd8739ae039({ organizationId: organizationId, kind: kind, extensionId: extensionId, title: title, initialRating: initialRating, stats: stats, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const isSkills = kind === 'skills';
    const [rating, setRating] = (0, $7fPBF.useState)(initialRating !== null && initialRating !== void 0 ? initialRating : 0);
    const [isSubmitting, setIsSubmitting] = (0, $7fPBF.useState)(false);
    const [comments, setComments] = (0, $7fPBF.useState)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [newComment, setNewComment] = (0, $7fPBF.useState)('');
    const [replyTo, setReplyTo] = (0, $7fPBF.useState)(null);
    const [replyBody, setReplyBody] = (0, $7fPBF.useState)('');
    const loadComments = async ()=>{
        setIsLoading(true);
        try {
            const result = isSkills ? await $12d232914efee838$export$19792261c154af1a(extensionId, organizationId) : await $83a72d0303cd25d3$export$e7a68ff80ec1a588(extensionId, organizationId);
            if (result.resultType !== 'Ok' || !result.data) throw new Error('load failed');
            setComments(result.data);
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('organization.governance.extensions.feedback.loadError'));
        } finally{
            setIsLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        loadComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        extensionId,
        kind
    ]);
    const submitRating = async (nextRating)=>{
        try {
            const request = {
                rating: nextRating
            };
            const result = isSkills ? await $12d232914efee838$export$eb6a7aa9d6637b11(extensionId, organizationId, request) : await $83a72d0303cd25d3$export$2425fb5f8d83edff(extensionId, organizationId, request);
            if (result.resultType !== 'Ok') throw new Error('rate failed');
            setRating(nextRating);
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('organization.governance.extensions.feedback.rateError'));
        }
    };
    const addComment = async (body, parentCommentId)=>{
        const trimmed = body.trim();
        if (!trimmed) return;
        try {
            const request = {
                body: trimmed,
                parentCommentId: parentCommentId
            };
            const result = isSkills ? await $12d232914efee838$export$5ba1da32600e54b6(extensionId, organizationId, request) : await $83a72d0303cd25d3$export$fbc91715620919a1(extensionId, organizationId, request);
            if (result.resultType !== 'Ok') throw new Error('comment failed');
            setNewComment('');
            setReplyTo(null);
            setReplyBody('');
            await loadComments();
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('organization.governance.extensions.feedback.commentError'));
        }
    };
    /**
     * One action for the whole review: save the score, then post the comment if one was written.
     * Replaces the old split flow, where a star click saved silently and the comment had its own
     * Send button.
     */ const submitReview = async ()=>{
        setIsSubmitting(true);
        try {
            if (rating > 0) await submitRating(rating);
            if (newComment.trim()) await addComment(newComment);
        } finally{
            setIsSubmitting(false);
        }
    };
    const deleteComment = async (commentId)=>{
        try {
            const result = isSkills ? await $12d232914efee838$export$e99d1c0915afc2c(commentId) : await $83a72d0303cd25d3$export$970635e34baee49f(commentId);
            if (result.resultType !== 'Ok') throw new Error('delete failed');
            await loadComments();
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('organization.governance.extensions.feedback.deleteError'));
        }
    };
    const renderComment = (comment, depth = 0)=>{
        var _comment_replies;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4b4a63a5e741fa10$var$CommentItem, {
            $depth: depth,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4b4a63a5e741fa10$var$CommentHeader, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                            children: comment.authorName || t('organization.governance.extensions.feedback.member')
                        }),
                        !comment.isDeleted && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                            label: t('delete'),
                            startIcon: "close",
                            iconSize: 12,
                            hideBorder: true,
                            $color: "simple",
                            onClick: ()=>deleteComment(comment.id)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4b4a63a5e741fa10$var$CommentBody, {
                    $deleted: comment.isDeleted,
                    children: comment.isDeleted ? t('organization.governance.extensions.feedback.deleted') : comment.body
                }),
                depth === 0 && !comment.isDeleted && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4b4a63a5e741fa10$var$ReplyLinkWrap, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "text",
                        $size: "small",
                        onClick: ()=>{
                            setReplyTo(replyTo === comment.id ? null : comment.id);
                            setReplyBody('');
                        },
                        children: t('organization.governance.extensions.feedback.reply')
                    })
                }),
                replyTo === comment.id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4b4a63a5e741fa10$var$ReplyRow, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            size: "small",
                            value: replyBody,
                            placeholder: t('organization.governance.extensions.feedback.replyPlaceholder'),
                            onChange: (event)=>setReplyBody(event.target.value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $size: "small",
                            $color: "secondary",
                            onClick: ()=>addComment(replyBody, comment.id),
                            children: t('send')
                        })
                    ]
                }),
                (_comment_replies = comment.replies) === null || _comment_replies === void 0 ? void 0 : _comment_replies.map((reply)=>renderComment(reply, depth + 1))
            ]
        }, comment.id);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$1a4605a7458e0ef), {
        open: true,
        fullWidth: true,
        maxWidth: "sm",
        scroll: "paper",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$a821680a90fed6), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                        label: t('cancel'),
                        startIcon: "closeX",
                        $color: "accent",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: [
                    stats && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4b4a63a5e741fa10$var$StatsStrip, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca16fc37bc773bdd$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, stats))
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $333165d7b30849b1$export$2e2bcd8739ae039), {
                        rating: rating,
                        onRatingChange: setRating,
                        comment: newComment,
                        onCommentChange: setNewComment,
                        disabled: isSubmitting
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4b4a63a5e741fa10$var$ReviewActions, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "primary",
                            disabled: rating === 0 || isSubmitting,
                            onClick: submitReview,
                            children: t('rating.review.submit')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($4b4a63a5e741fa10$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: t('organization.governance.extensions.feedback.comments')
                            }),
                            isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {}) : comments.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                children: t('organization.governance.extensions.feedback.noComments')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4b4a63a5e741fa10$var$CommentList, {
                                children: comments.map((comment)=>renderComment(comment))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $4b4a63a5e741fa10$var$Section = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t || ($4b4a63a5e741fa10$var$t = $4b4a63a5e741fa10$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
`));
const $4b4a63a5e741fa10$var$StatsStrip = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t1 || ($4b4a63a5e741fa10$var$t1 = $4b4a63a5e741fa10$var$_`
    padding: 0.75rem 0;
    margin: 0.5rem 0;
    border-bottom: 1px solid ${0};
`), (props)=>props.theme.color.card);
const $4b4a63a5e741fa10$var$ReviewActions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t2 || ($4b4a63a5e741fa10$var$t2 = $4b4a63a5e741fa10$var$_`
    display: flex;
    justify-content: flex-end;
    margin-top: 0.75rem;
`));
const $4b4a63a5e741fa10$var$CommentList = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t3 || ($4b4a63a5e741fa10$var$t3 = $4b4a63a5e741fa10$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 0.5rem;
`));
const $4b4a63a5e741fa10$var$CommentItem = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t4 || ($4b4a63a5e741fa10$var$t4 = $4b4a63a5e741fa10$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding-left: ${0};
    border-left: ${0};
`), (props)=>props.$depth > 0 ? '1rem' : '0', (props)=>props.$depth > 0 ? `2px solid ${props.theme.color.border}` : 'none');
const $4b4a63a5e741fa10$var$CommentHeader = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t5 || ($4b4a63a5e741fa10$var$t5 = $4b4a63a5e741fa10$var$_`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
`));
const $4b4a63a5e741fa10$var$CommentBody = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($4b4a63a5e741fa10$var$t6 || ($4b4a63a5e741fa10$var$t6 = $4b4a63a5e741fa10$var$_`
    white-space: pre-wrap;
    font-style: ${0};
    color: ${0};
`), (props)=>props.$deleted ? 'italic' : 'normal', (props)=>props.$deleted ? props.theme.color.textBody : props.theme.color.text);
const $4b4a63a5e741fa10$var$ReplyLinkWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t7 || ($4b4a63a5e741fa10$var$t7 = $4b4a63a5e741fa10$var$_`
    align-self: flex-start;
    margin-top: 0.1rem;
`));
const $4b4a63a5e741fa10$var$ReplyRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($4b4a63a5e741fa10$var$t8 || ($4b4a63a5e741fa10$var$t8 = $4b4a63a5e741fa10$var$_`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-top: 0.25rem;
`));








var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");







let $e462066395b12f17$var$_ = (t)=>t, $e462066395b12f17$var$t, $e462066395b12f17$var$t1, $e462066395b12f17$var$t2;
function $e462066395b12f17$export$2e2bcd8739ae039({ open: open, subject: subject, stats: stats, initialRating: initialRating, initialComment: initialComment, hideComment: hideComment = false, submitting: submitting = false, onSubmit: onSubmit, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const [rating, setRating] = (0, $7fPBF.useState)(initialRating !== null && initialRating !== void 0 ? initialRating : 0);
    const [comment, setComment] = (0, $7fPBF.useState)(initialComment !== null && initialComment !== void 0 ? initialComment : '');
    // Reopening is a fresh review: start from whatever the caller now knows the user's vote to be.
    (0, $7fPBF.useEffect)(()=>{
        if (open) {
            setRating(initialRating !== null && initialRating !== void 0 ? initialRating : 0);
            setComment(initialComment !== null && initialComment !== void 0 ? initialComment : '');
        }
    }, [
        open,
        initialRating,
        initialComment
    ]);
    const canSubmit = rating > 0 && !submitting;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$1a4605a7458e0ef), {
        open: open,
        fullWidth: true,
        maxWidth: "sm",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$6f975883ded828a4), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($e462066395b12f17$var$Heading, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $082accbd174d656b$export$a821680a90fed6), {
                                children: t('rating.review.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e462066395b12f17$var$Subtitle, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                                    children: t('rating.review.subtitle', {
                                        subject: subject
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                        label: t('close'),
                        startIcon: "closeX",
                        $color: "simple",
                        hideBorder: true,
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$5a0bc68f6657e9db), {
                children: [
                    stats && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e462066395b12f17$var$StatsStrip, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca16fc37bc773bdd$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, stats))
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $333165d7b30849b1$export$2e2bcd8739ae039), {
                        rating: rating,
                        onRatingChange: setRating,
                        comment: comment,
                        onCommentChange: setComment,
                        hideComment: hideComment,
                        disabled: submitting
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$b54ac9d7963ef6f6), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "text",
                        disabled: submitting,
                        onClick: onClose,
                        children: t('cancel')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "primary",
                        disabled: !canSubmit,
                        onClick: ()=>onSubmit({
                                rating: rating,
                                comment: comment.trim()
                            }),
                        children: t('rating.review.submit')
                    })
                ]
            })
        ]
    });
}
const $e462066395b12f17$var$Heading = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e462066395b12f17$var$t || ($e462066395b12f17$var$t = $e462066395b12f17$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`));
const $e462066395b12f17$var$Subtitle = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($e462066395b12f17$var$t1 || ($e462066395b12f17$var$t1 = $e462066395b12f17$var$_`
    color: ${0};

    /* The translation names the subject inside <strong> — see the Trans usage above. */
    strong {
        font-weight: 700;
        color: ${0};
    }
`), (props)=>props.theme.color.textBody, (props)=>props.theme.color.text);
/** Hairlines above and below the aggregate figures, separating them from the heading and the input. */ const $e462066395b12f17$var$StatsStrip = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($e462066395b12f17$var$t2 || ($e462066395b12f17$var$t2 = $e462066395b12f17$var$_`
    padding: 0.75rem 0;
    margin: 0.75rem 0;
    border-bottom: 1px solid ${0};
`), (props)=>props.theme.color.border);



function $0582614e0ede4178$export$2e2bcd8739ae039(_param) {
    var { subject: subject, myRating: myRating, canReview: canReview = true, compact: compact, showEmptyRating: showEmptyRating, hideComment: hideComment, showStatsInDialog: showStatsInDialog = true, submitting: submitting, onSubmit: onSubmit, className: className, minRatings: minRatings } = _param, stats = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "subject",
        "myRating",
        "canReview",
        "compact",
        "showEmptyRating",
        "hideComment",
        "showStatsInDialog",
        "submitting",
        "onSubmit",
        "className",
        "minRatings"
    ]);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const handleSubmit = async (submission)=>{
        try {
            setSaving(true);
            await onSubmit(submission);
            setOpen(false);
        } catch (e) {
        // The caller owns error messaging (it knows which API failed); keep the dialog open so
        // the user's draft survives a failed save.
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca16fc37bc773bdd$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, stats), {
                compact: compact,
                showEmptyRating: showEmptyRating,
                minRatings: minRatings,
                className: className,
                onClick: canReview ? ()=>setOpen(true) : undefined
            })),
            canReview && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e462066395b12f17$export$2e2bcd8739ae039), {
                open: open,
                subject: subject,
                stats: showStatsInDialog ? stats : undefined,
                initialRating: myRating,
                hideComment: hideComment,
                submitting: submitting || saving,
                onSubmit: handleSubmit,
                onClose: ()=>setOpen(false)
            })
        ]
    });
}



const $deb7c1e0c12ee5a4$export$1cedbcfaf2f5bae5 = 5;
function $deb7c1e0c12ee5a4$export$2e2bcd8739ae039({ title: title, installCount: installCount, averageRating: averageRating, ratingCount: ratingCount, myRating: myRating, compact: compact = true, showEmptyRating: showEmptyRating = true, onRate: onRate }) {
    if (!onRate) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca16fc37bc773bdd$export$2e2bcd8739ae039), {
        averageRating: averageRating,
        ratingCount: ratingCount,
        installCount: installCount,
        minRatings: $deb7c1e0c12ee5a4$export$1cedbcfaf2f5bae5,
        compact: compact,
        showEmptyRating: showEmptyRating
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0582614e0ede4178$export$2e2bcd8739ae039), {
        subject: title !== null && title !== void 0 ? title : '',
        averageRating: averageRating,
        ratingCount: ratingCount,
        myRating: myRating,
        minRatings: $deb7c1e0c12ee5a4$export$1cedbcfaf2f5bae5,
        compact: compact,
        showEmptyRating: showEmptyRating,
        hideComment: true,
        onSubmit: ({ rating: rating })=>onRate(rating)
    });
}



let $5cc73d5a4111dac3$var$_ = (t)=>t, $5cc73d5a4111dac3$var$t, $5cc73d5a4111dac3$var$t1, $5cc73d5a4111dac3$var$t2, $5cc73d5a4111dac3$var$t3, $5cc73d5a4111dac3$var$t4, $5cc73d5a4111dac3$var$t5, $5cc73d5a4111dac3$var$t6, $5cc73d5a4111dac3$var$t7;
const $5cc73d5a4111dac3$var$SORT_OPTIONS = [
    'recent',
    'rating',
    'installs'
];
function $5cc73d5a4111dac3$export$2e2bcd8739ae039({ organizationId: organizationId, kind: kind, canManage: canManage }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    const isSkills = kind === 'skills';
    const [items, setItems] = (0, $7fPBF.useState)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [sortBy, setSortBy] = (0, $7fPBF.useState)('recent');
    // Editor state: undefined = closed, null = create, model = edit.
    const [editing, setEditing] = (0, $7fPBF.useState)(undefined);
    const [feedbackFor, setFeedbackFor] = (0, $7fPBF.useState)(null);
    const load = async ()=>{
        setIsLoading(true);
        try {
            const result = isSkills ? await $12d232914efee838$export$867288c23551811(organizationId, undefined, sortBy) : await $83a72d0303cd25d3$export$95c1b11ef82c9592(organizationId, undefined, sortBy);
            if (result.resultType !== 'Ok' || !result.data) throw new Error('load failed');
            setItems(result.data);
        } catch (e) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('organization.governance.extensions.list.loadError'));
        } finally{
            setIsLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId,
        kind,
        sortBy
    ]);
    const cards = items.map((item)=>({
            id: item.id,
            displayName: item.displayName,
            description: item.description,
            averageRating: item.averageRating,
            ratingCount: item.ratingCount,
            installCount: item.installCount,
            commentCount: item.commentCount,
            myRating: item.myRating
        }));
    const onEditorDone = ()=>{
        setEditing(undefined);
        load();
    };
    var _feedbackFor_installCount, _feedbackFor_commentCount;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5cc73d5a4111dac3$var$Wrap, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t(isSkills ? 'organization.governance.extensions.skills.title' : 'organization.governance.extensions.connectors.title'),
                variant: "small",
                children: canManage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    $size: "small",
                    startIcon: "plus",
                    onClick: ()=>setEditing(null),
                    children: t(isSkills ? 'organization.governance.extensions.skills.create' : 'organization.governance.extensions.connectors.create')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: t(isSkills ? 'organization.governance.extensions.skills.description' : 'organization.governance.extensions.connectors.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cc73d5a4111dac3$var$SortRow, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                            id: `sort-${kind}`,
                            children: t('organization.governance.extensions.sort.label')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                            labelId: `sort-${kind}`,
                            label: t('organization.governance.extensions.sort.label'),
                            value: sortBy,
                            onChange: (event)=>setSortBy(event.target.value),
                            children: $5cc73d5a4111dac3$var$SORT_OPTIONS.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                    value: option,
                                    children: t(`organization.governance.extensions.sort.${option}`)
                                }, option))
                        })
                    ]
                })
            }),
            isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {}) : cards.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5cc73d5a4111dac3$var$EmptyState, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: isSkills ? 'sparkles' : 'tools',
                        size: 32
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: t('organization.governance.extensions.list.emptyTitle')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('organization.governance.extensions.list.emptyDescription')
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cc73d5a4111dac3$var$CardGrid, {
                children: cards.map((card)=>{
                    const source = items.find((i)=>i.id === card.id);
                    var _card_installCount, _card_commentCount;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($5cc73d5a4111dac3$var$ExtensionCardView, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: card.displayName
                            }),
                            card.description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cc73d5a4111dac3$var$CardDescription, {
                                children: card.description
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cc73d5a4111dac3$var$CardStats, {
                                averageRating: card.averageRating,
                                ratingCount: card.ratingCount,
                                installCount: (_card_installCount = card.installCount) !== null && _card_installCount !== void 0 ? _card_installCount : 0,
                                commentCount: (_card_commentCount = card.commentCount) !== null && _card_commentCount !== void 0 ? _card_commentCount : 0,
                                minRatings: (0, $deb7c1e0c12ee5a4$export$1cedbcfaf2f5bae5),
                                compact: true,
                                actionLabel: t('organization.governance.extensions.feedback.open'),
                                onClick: ()=>setFeedbackFor(card)
                            }),
                            canManage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5cc73d5a4111dac3$var$CardActions, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    $color: "text",
                                    $size: "small",
                                    startIcon: "edit",
                                    onClick: ()=>setEditing(source),
                                    children: t('edit')
                                })
                            })
                        ]
                    }, card.id);
                })
            }),
            editing !== undefined && (isSkills ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $433a5eef705569ef$export$2e2bcd8739ae039), {
                editorMode: editing ? 'edit' : 'create',
                skill: editing ? $5cc73d5a4111dac3$var$toLocalSkill(editing) : undefined,
                data: (0, $bb96f6c4983a84fb$export$1c7236893be4762e)(organizationId),
                onDone: onEditorDone,
                onCancel: ()=>setEditing(undefined)
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9b3b1654ddd2b83$export$2e2bcd8739ae039), {
                editorMode: editing ? 'edit' : 'create',
                server: editing ? $5cc73d5a4111dac3$var$toLocalServer(editing) : undefined,
                data: (0, $84e2276405a3056c$export$432387839c70f346)(organizationId),
                onDone: onEditorDone,
                onCancel: ()=>setEditing(undefined)
            })),
            feedbackFor && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b4a63a5e741fa10$export$2e2bcd8739ae039), {
                organizationId: organizationId,
                kind: kind,
                extensionId: feedbackFor.id,
                title: feedbackFor.displayName,
                initialRating: feedbackFor.myRating,
                stats: {
                    averageRating: feedbackFor.averageRating,
                    ratingCount: feedbackFor.ratingCount,
                    installCount: (_feedbackFor_installCount = feedbackFor.installCount) !== null && _feedbackFor_installCount !== void 0 ? _feedbackFor_installCount : 0,
                    commentCount: (_feedbackFor_commentCount = feedbackFor.commentCount) !== null && _feedbackFor_commentCount !== void 0 ? _feedbackFor_commentCount : 0
                },
                onClose: ()=>{
                    setFeedbackFor(null);
                    load();
                }
            })
        ]
    });
}
/** Map the API skill read model to the local SkillModel the editor edits (body loaded lazily by id). */ function $5cc73d5a4111dac3$var$toLocalSkill(model) {
    var _model_description, _model_categories;
    return {
        id: model.id,
        name: model.name,
        description: (_model_description = model.description) !== null && _model_description !== void 0 ? _model_description : '',
        keywords: (_model_categories = model.categories) !== null && _model_categories !== void 0 ? _model_categories : [],
        dirPath: '',
        skillMdPath: '',
        source: 'organization',
        enabled: false,
        activation: (0, $83bad78370366bbe$export$fc097f65acdbbf35),
        hasScripts: false,
        hasReferences: false,
        visibility: 'organization',
        createdAt: Date.parse(model.createdDate) || 0,
        updatedAt: Date.parse(model.modifiedDate) || 0,
        remoteId: model.id,
        organizationId: model.organizationId,
        isOfficial: model.isOfficial
    };
}
/** Map the API registration to the local McpServerModel shape the editor reads (non-secret config). */ function $5cc73d5a4111dac3$var$toLocalServer(reg) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $a6054cd09d79a201$export$f832804beecc52d9)(reg)), {
        id: reg.id,
        displayName: reg.displayName
    });
}
const $5cc73d5a4111dac3$var$Wrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($5cc73d5a4111dac3$var$t || ($5cc73d5a4111dac3$var$t = $5cc73d5a4111dac3$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1.5rem;
`));
const $5cc73d5a4111dac3$var$SortRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($5cc73d5a4111dac3$var$t1 || ($5cc73d5a4111dac3$var$t1 = $5cc73d5a4111dac3$var$_`
    display: flex;
    justify-content: flex-end;
`));
const $5cc73d5a4111dac3$var$CardGrid = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($5cc73d5a4111dac3$var$t2 || ($5cc73d5a4111dac3$var$t2 = $5cc73d5a4111dac3$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 18rem), 1fr));
    gap: 0.75rem;
`));
const $5cc73d5a4111dac3$var$ExtensionCardView = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$a30053b04ba33ef5))($5cc73d5a4111dac3$var$t3 || ($5cc73d5a4111dac3$var$t3 = $5cc73d5a4111dac3$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
`));
const $5cc73d5a4111dac3$var$CardDescription = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($5cc73d5a4111dac3$var$t4 || ($5cc73d5a4111dac3$var$t4 = $5cc73d5a4111dac3$var$_`
    color: ${0};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`), (props)=>props.theme.color.textBody);
/** Pinned to the bottom of the card, above the actions, where the hand-rolled stats row used to sit. */ const $5cc73d5a4111dac3$var$CardStats = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $ca16fc37bc773bdd$export$2e2bcd8739ae039))($5cc73d5a4111dac3$var$t5 || ($5cc73d5a4111dac3$var$t5 = $5cc73d5a4111dac3$var$_`
    margin-top: auto;
`));
const $5cc73d5a4111dac3$var$CardActions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($5cc73d5a4111dac3$var$t6 || ($5cc73d5a4111dac3$var$t6 = $5cc73d5a4111dac3$var$_`
    display: flex;
    gap: 0.25rem;
    border-top: 1px solid ${0};
    padding-top: 0.5rem;
`), (props)=>props.theme.color.border);
const $5cc73d5a4111dac3$var$EmptyState = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($5cc73d5a4111dac3$var$t7 || ($5cc73d5a4111dac3$var$t7 = $5cc73d5a4111dac3$var$_`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    padding: 2.5rem 1rem;
    text-align: center;
    border: 1px dashed ${0};
    border-radius: 0.5rem;
`), (props)=>props.theme.color.border);












var $7fPBF = parcelRequire("7fPBF");

let $f0f8722f8ba47db6$var$_ = (t)=>t, $f0f8722f8ba47db6$var$t, $f0f8722f8ba47db6$var$t1, $f0f8722f8ba47db6$var$t2, $f0f8722f8ba47db6$var$t3, $f0f8722f8ba47db6$var$t4, $f0f8722f8ba47db6$var$t5;
function $f0f8722f8ba47db6$export$2e2bcd8739ae039({ organizationId: organizationId, canViewSkills: canViewSkills, canViewConnectors: canViewConnectors }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [skillUsage, setSkillUsage] = (0, $7fPBF.useState)([]);
    const [connectorUsage, setConnectorUsage] = (0, $7fPBF.useState)([]);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        const load = async ()=>{
            setIsLoading(true);
            try {
                if (canViewSkills) {
                    const result = await $12d232914efee838$export$56e21bee5962e0e5(organizationId);
                    if (result.resultType === 'Ok' && result.data) setSkillUsage(result.data.map((u)=>({
                            id: u.agentSkillId,
                            displayName: u.displayName,
                            installCount: u.installCount,
                            members: u.members
                        })));
                }
                if (canViewConnectors) {
                    const result = await $83a72d0303cd25d3$export$eeaf0e19dddc9c6d(organizationId);
                    if (result.resultType === 'Ok' && result.data) setConnectorUsage(result.data.map((u)=>({
                            id: u.mcpServerRegistrationId,
                            displayName: u.displayName,
                            installCount: u.installCount,
                            members: u.members
                        })));
                }
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.governance.extensions.usage.loadError'));
            } finally{
                setIsLoading(false);
            }
        };
        load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId,
        canViewSkills,
        canViewConnectors
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f0f8722f8ba47db6$var$Wrap, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: t('common:organization.governance.extensions.usage.description')
            }),
            canViewSkills && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f0f8722f8ba47db6$var$UsageSection, {
                title: t('common:organization.governance.extensions.usage.skillsTitle'),
                rows: skillUsage
            }),
            canViewConnectors && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f0f8722f8ba47db6$var$UsageSection, {
                title: t('common:organization.governance.extensions.usage.connectorsTitle'),
                rows: connectorUsage
            })
        ]
    });
}
function $f0f8722f8ba47db6$var$UsageSection({ title: title, rows: rows }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: title,
                variant: "small"
            }),
            rows.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:organization.governance.extensions.usage.empty')
            }) : rows.map((row)=>{
                var _row_displayName;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f0f8722f8ba47db6$var$UsageCard, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f0f8722f8ba47db6$var$UsageHeader, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                    children: (_row_displayName = row.displayName) !== null && _row_displayName !== void 0 ? _row_displayName : t('common:organization.governance.extensions.usage.unnamed')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: t('common:organization.governance.extensions.usage.installCount', {
                                        count: row.installCount
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f0f8722f8ba47db6$var$MemberList, {
                            children: row.members.map((member)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($f0f8722f8ba47db6$var$MemberRow, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                            children: member.userDisplayName || member.userEmail || member.userId
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f0f8722f8ba47db6$var$MemberMeta, {
                                            children: member.isAccountWide ? t('common:organization.governance.extensions.usage.accountWide') : t('common:organization.governance.extensions.usage.perDevice')
                                        })
                                    ]
                                }, `${row.id}-${member.userId}`))
                        })
                    ]
                }, row.id);
            })
        ]
    });
}
const $f0f8722f8ba47db6$var$Wrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($f0f8722f8ba47db6$var$t || ($f0f8722f8ba47db6$var$t = $f0f8722f8ba47db6$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1.5rem;
`));
const $f0f8722f8ba47db6$var$UsageCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$a30053b04ba33ef5))($f0f8722f8ba47db6$var$t1 || ($f0f8722f8ba47db6$var$t1 = $f0f8722f8ba47db6$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
`));
const $f0f8722f8ba47db6$var$UsageHeader = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($f0f8722f8ba47db6$var$t2 || ($f0f8722f8ba47db6$var$t2 = $f0f8722f8ba47db6$var$_`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
`));
const $f0f8722f8ba47db6$var$MemberList = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($f0f8722f8ba47db6$var$t3 || ($f0f8722f8ba47db6$var$t3 = $f0f8722f8ba47db6$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`));
const $f0f8722f8ba47db6$var$MemberRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($f0f8722f8ba47db6$var$t4 || ($f0f8722f8ba47db6$var$t4 = $f0f8722f8ba47db6$var$_`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.25rem 0;
    border-top: 1px solid ${0};
`), (props)=>props.theme.color.border);
const $f0f8722f8ba47db6$var$MemberMeta = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($f0f8722f8ba47db6$var$t5 || ($f0f8722f8ba47db6$var$t5 = $f0f8722f8ba47db6$var$_`
    color: ${0};
    flex: none;
`), (props)=>props.theme.color.textBody);







var $7fPBF = parcelRequire("7fPBF");












function $6f4f7e7953e23bc3$export$72aef224d6115253(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTab', slot);
}
const $6f4f7e7953e23bc3$var$tabClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'icon'
]);
var $6f4f7e7953e23bc3$export$2e2bcd8739ae039 = $6f4f7e7953e23bc3$var$tabClasses;



'use client';
const $3f6f36f0de875664$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $6f4f7e7953e23bc3$export$72aef224d6115253), classes);
};
const $3f6f36f0de875664$var$TabRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).icon}`]: styles.icon
            }
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, theme.typography.button), {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $6f4f7e7953e23bc3$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $3f6f36f0de875664$var$Tab = /*#__PURE__*/ $7fPBF.forwardRef(function Tab(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "disabled",
        "disableFocusRipple",
        "fullWidth",
        "icon",
        "iconPosition",
        "indicator",
        "label",
        "onChange",
        "onClick",
        "onFocus",
        "selected",
        "selectionFollowsFocus",
        "textColor",
        "value",
        "wrapped"
    ]);
    const rovingContext = (0, $42a6f889b44da94f$export$7d0448bcff5cc25)();
    const rovingItemProps = (0, $bc3efb6b12d4ce5b$export$736d50a885584c2d)({
        id: value,
        ref: ref,
        disabled: disabled,
        selected: selected
    });
    // On the server, and on the first client render before registration effects run,
    // the roving item map is still empty. In that window, fall back to `tabIndex={0}`
    // for the selected tab so the rendered markup is immediately keyboard-accessible
    // and hydration stays consistent until item registration takes over.
    const shouldUseSelectedTabStopFallback = rovingContext.getItemMap().size === 0 && selected;
    const tabIndex = shouldUseSelectedTabStopFallback ? 0 : rovingItemProps.tabIndex;
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $3f6f36f0de875664$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($3f6f36f0de875664$var$TabRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        internalNativeButton: true,
        focusRipple: !disableFocusRipple,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: rovingItemProps.ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        tabIndex: tabIndex,
        ownerState: ownerState
    }, other), {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fPBF.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $3f6f36f0de875664$export$2e2bcd8739ae039 = $3f6f36f0de875664$var$Tab;





var $7fPBF = parcelRequire("7fPBF");











function $9c6aa667a8e51604$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $9c6aa667a8e51604$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $9c6aa667a8e51604$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}







var $7fPBF = parcelRequire("7fPBF");




'use client';
const $e9ed44cdc47a70b6$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll',
    pointerEvents: 'none'
};
function $e9ed44cdc47a70b6$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "onChange"
    ]);
    const scrollbarHeight = $7fPBF.useRef();
    const nodeRef = $7fPBF.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $e367f16ec1a5cce1$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $a20ff4b1b2349f15$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $0f23d889c670216c$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $7fPBF.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        style: $e9ed44cdc47a70b6$var$styles
    }, other), {
        ref: nodeRef
    }));
}






var $7fPBF = parcelRequire("7fPBF");







'use client';
var $39b024bd0ef3ecc5$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');




'use client';
var $1d43c637d7453b86$export$2e2bcd8739ae039 = (0, $a8d4aa799c2c536a$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');







function $2cd56265df651314$export$34861783d3c2eef8(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTabScrollButton', slot);
}
const $2cd56265df651314$var$tabScrollButtonClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $2cd56265df651314$export$2e2bcd8739ae039 = $2cd56265df651314$var$tabScrollButtonClasses;



'use client';
const $bb83a7c8fb48a9c4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $2cd56265df651314$export$34861783d3c2eef8), classes);
};
const $bb83a7c8fb48a9c4$var$TabScrollButtonRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $a3a679d546941285$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $2cd56265df651314$export$2e2bcd8739ae039).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $bb83a7c8fb48a9c4$var$TabScrollButton = /*#__PURE__*/ $7fPBF.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "slots",
        "slotProps",
        "direction",
        "orientation",
        "disabled"
    ]);
    const { nativeButton: nativeButton } = other, buttonBaseProps = (0, $8901fc92b5563702$export$71511d61b312f219)(other, [
        "nativeButton"
    ]);
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const ownerState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        isRtl: isRtl
    }, props);
    const classes = $bb83a7c8fb48a9c4$var$useUtilityClasses(ownerState);
    var _slots_StartScrollButtonIcon;
    const StartButtonIcon = (_slots_StartScrollButtonIcon = slots.StartScrollButtonIcon) !== null && _slots_StartScrollButtonIcon !== void 0 ? _slots_StartScrollButtonIcon : (0, $39b024bd0ef3ecc5$export$2e2bcd8739ae039);
    var _slots_EndScrollButtonIcon;
    const EndButtonIcon = (_slots_EndScrollButtonIcon = slots.EndScrollButtonIcon) !== null && _slots_EndScrollButtonIcon !== void 0 ? _slots_EndScrollButtonIcon : (0, $1d43c637d7453b86$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($bb83a7c8fb48a9c4$var$TabScrollButtonRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        component: "div",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, buttonBaseProps), {
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, buttonBaseProps.style, orientation === 'vertical' && {
            '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
        }),
        children: direction === 'left' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(StartButtonIcon, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(EndButtonIcon, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, endButtonIconProps))
    }));
});
var $bb83a7c8fb48a9c4$export$2e2bcd8739ae039 = $bb83a7c8fb48a9c4$var$TabScrollButton;





function $8b2f86b717550994$export$cdd93bd054dec359(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiTabs', slot);
}
const $8b2f86b717550994$var$tabsClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8b2f86b717550994$export$2e2bcd8739ae039 = $8b2f86b717550994$var$tabsClasses;












'use client';
const $c134be78e3e5ff0b$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $8b2f86b717550994$export$cdd93bd054dec359), classes);
};
const $c134be78e3e5ff0b$var$TabsRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8b2f86b717550994$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $8b2f86b717550994$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $8b2f86b717550994$export$2e2bcd8739ae039).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $c134be78e3e5ff0b$var$TabsScroller = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $c134be78e3e5ff0b$var$List = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $c134be78e3e5ff0b$var$TabsIndicator = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%'
    }, (0, $0ea347727154ba9d$export$cfbcd9a4c0ed32ac)(theme)), {
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $c134be78e3e5ff0b$var$TabsScrollbarSize = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $e9ed44cdc47a70b6$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $c134be78e3e5ff0b$var$defaultIndicatorStyle = {};
// Dev-only: tracks per-`Tabs` instance (keyed by its ref) whether the invalid-value warning was
// already logged, so it isn't repeated across the several effects that call `getTabsMeta`.
// Only referenced from `process.env.NODE_ENV !== 'production'` blocks; the `@__PURE__` annotation
// lets minifiers drop it (and the `WeakMap` allocation) entirely from production builds.
const $c134be78e3e5ff0b$var$warnedTabValueInvalid = /* @__PURE__ */ new WeakMap();
let $c134be78e3e5ff0b$var$warnedOnceTabPresent = false;
const $c134be78e3e5ff0b$var$Tabs = /*#__PURE__*/ $7fPBF.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $17852965b9ddab5b$export$2e2bcd8739ae039)();
    const isRtl = (0, $e4363aeb0e09b377$export$b2dd014b6c321cb)();
    const reducedMotion = (0, $1fb9020c3655f750$export$2e2bcd8739ae039)(theme.motion.reducedMotion, false);
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        'aria-label',
        'aria-labelledby',
        "action",
        "centered",
        "children",
        "className",
        "component",
        "allowScrollButtonsMobile",
        "indicatorColor",
        "onChange",
        "orientation",
        "scrollButtons",
        "selectionFollowsFocus",
        "slots",
        "slotProps",
        "textColor",
        "value",
        "variant",
        "visibleScrollbar"
    ]);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $c134be78e3e5ff0b$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: slots.startScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $506d49d02f67e45f$export$2e2bcd8739ae039)({
        elementType: slots.endScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $7fPBF.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $7fPBF.useState($c134be78e3e5ff0b$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $7fPBF.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $7fPBF.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $7fPBF.useState(false);
    const selectedValue = value === false ? null : value;
    // Tracks whether DOM focus is currently inside the tab list. When it is, roving focus
    // should follow in-list keyboard movement instead of snapping back to `selectedValue`.
    const [isFocusWithinList, setIsFocusWithinList] = $7fPBF.useState(false);
    const [scrollerStyle, setScrollerStyle] = $7fPBF.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $7fPBF.useRef(null);
    const tabListRef = $7fPBF.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation && !reducedMotion.shouldReduceMotion) (0, $9c6aa667a8e51604$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const _useSlot = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('scrollbar', {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.scrollableX, classes.hideScrollbar),
        elementType: $c134be78e3e5ff0b$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), [ScrollbarSlot, { onChange: scrollbarOnChange }] = _useSlot, scrollbarSlotProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_useSlot[1], [
        "onChange"
    ]);
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $7fPBF.useCallback((scrollbarWidth)=>{
        scrollbarOnChange === null || scrollbarOnChange === void 0 ? void 0 : scrollbarOnChange(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('scrollButtons', {
        className: classes.scrollButtons,
        elementType: (0, $bb83a7c8fb48a9c4$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ScrollbarSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scrollbarSlotProps), {
            onChange: handleScrollbarSizeChange
        })) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ScrollButtonsSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, scrollButtonSlotProps)) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ScrollButtonsSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, scrollButtonSlotProps)) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $4b34ab98a42d4f2d$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $7fPBF.useEffect(()=>{
        const handleResize = (0, $a20ff4b1b2349f15$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $0f23d889c670216c$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $7fPBF.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp === null || childrenProp === void 0 ? void 0 : childrenProp.length
    ]);
    $7fPBF.useEffect(()=>{
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setMounted(true);
    }, []);
    $7fPBF.useEffect(()=>{
        updateIndicatorState();
    });
    $7fPBF.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($c134be78e3e5ff0b$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $7fPBF.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('indicator', {
        className: classes.indicator,
        elementType: $c134be78e3e5ff0b$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(IndicatorSlot, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, indicatorSlotProps));
    const rovingContainer = (0, $bc3efb6b12d4ce5b$export$a80dd08291d838d9)({
        activeItemId: isFocusWithinList ? undefined : selectedValue,
        orientation: orientation,
        isRtl: isRtl
    });
    const rovingContainerProps = rovingContainer.getContainerProps();
    const validChildren = $7fPBF.Children.toArray(childrenProp).filter($7fPBF.isValidElement).map((child, index)=>{
        const childValue = child.props.value === undefined ? index : child.props.value;
        valueToIndex.set(childValue, index);
        return {
            child: child,
            index: index,
            childValue: childValue
        };
    });
    const children = validChildren.map(({ child: child, childValue: childValue })=>{
        const selected = childValue === value;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        });
    });
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $c134be78e3e5ff0b$var$TabsRoot,
        externalForwardedProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, externalForwardedProps, other), {
            component: component
        }),
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $c134be78e3e5ff0b$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const mergedRef = (0, $e25ff38916f49b9a$export$2e2bcd8739ae039)(rovingContainerProps.ref, tabListRef);
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $bf9d1879104a7d85$export$2e2bcd8739ae039)((0, $3f5ab0f2fc599ae7$export$2e2bcd8739ae039)(list));
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus === null || currentFocus === void 0 ? void 0 : currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        rovingContainerProps.onKeyDown(event);
    };
    const [ListSlot, listSlotProps] = (0, $5f8e5bdc972f8f36$export$2e2bcd8739ae039)('list', {
        ref: mergedRef,
        className: classes.list,
        elementType: $c134be78e3e5ff0b$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, handlers), {
                onBlur: (event)=>{
                    var _handlers_onBlur;
                    if (!(0, $ce3a34ab77d30b1b$export$2e2bcd8739ae039)(event.currentTarget, event.relatedTarget)) setIsFocusWithinList(false);
                    (_handlers_onBlur = handlers.onBlur) === null || _handlers_onBlur === void 0 ? void 0 : _handlers_onBlur.call(handlers, event);
                },
                onKeyDown: (event)=>{
                    var _handlers_onKeyDown;
                    handleKeyDown(event);
                    (_handlers_onKeyDown = handlers.onKeyDown) === null || _handlers_onKeyDown === void 0 ? void 0 : _handlers_onKeyDown.call(handlers, event);
                },
                onFocus: (event)=>{
                    var _handlers_onFocus;
                    setIsFocusWithinList(true);
                    rovingContainerProps.onFocus(event);
                    (_handlers_onFocus = handlers.onFocus) === null || _handlers_onFocus === void 0 ? void 0 : _handlers_onFocus.call(handlers, event);
                }
            })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(RootSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rootSlotProps), {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(ScrollerSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scrollerSlotProps), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(ListSlot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist"
                    }, listSlotProps), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42a6f889b44da94f$export$9248f542b77b4e3f).Provider, {
                            value: rovingContainer,
                            children: children
                        })
                    })),
                    mounted && indicator
                ]
            })),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $c134be78e3e5ff0b$export$2e2bcd8739ae039 = $c134be78e3e5ff0b$var$Tabs;








function $f8f95b189a35cb2e$export$2e2bcd8739ae039({ title: title, description: description, children: children }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: description !== null && description !== void 0 ? description : t('common:organization.noAccess.description'),
        fullHeight: true,
        icon: "cancel",
        title: title !== null && title !== void 0 ? title : t('common:organization.projects.accessDenied.title'),
        children: children ? children : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            href: "#",
            startIcon: "back",
            children: t('common:back')
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");

let $66abcfbc1029bce2$var$_ = (t)=>t, $66abcfbc1029bce2$var$t;
function $66abcfbc1029bce2$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading, canManageGovernance: canManageGovernance, canManageOrganizationSkills: canManageOrganizationSkills, canManageOrganizationMcpServers: canManageOrganizationMcpServers } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const [tab, setTab] = (0, $7fPBF.useState)('automation');
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    const canViewUsage = canManageOrganizationSkills || canManageOrganizationMcpServers;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.governance.orgTitle', {
                    value: currentOrg.name
                }),
                description: t('common:organization.governance.description'),
                items: items
            }),
            canManageGovernance ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($66abcfbc1029bce2$var$StyledTabs, {
                        value: tab,
                        onChange: (_, value)=>setTab(value),
                        variant: "scrollable",
                        scrollButtons: "auto",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f6f36f0de875664$export$2e2bcd8739ae039), {
                                value: "automation",
                                label: t('common:organization.governance.tabs.automation')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f6f36f0de875664$export$2e2bcd8739ae039), {
                                value: "permissions",
                                label: t('common:organization.governance.tabs.permissions')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f6f36f0de875664$export$2e2bcd8739ae039), {
                                value: "skills",
                                label: t('common:organization.governance.tabs.skills')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f6f36f0de875664$export$2e2bcd8739ae039), {
                                value: "connectors",
                                label: t('common:organization.governance.tabs.connectors')
                            }),
                            canViewUsage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3f6f36f0de875664$export$2e2bcd8739ae039), {
                                value: "usage",
                                label: t('common:organization.governance.tabs.usage')
                            })
                        ]
                    }),
                    tab === 'automation' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5a40d332c2f8520$export$2e2bcd8739ae039), {
                        organizationId: currentOrg.id
                    }),
                    tab === 'permissions' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $570b4391b76c7f06$export$2e2bcd8739ae039), {
                        organization: currentOrg
                    }),
                    tab === 'skills' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5cc73d5a4111dac3$export$2e2bcd8739ae039), {
                        organizationId: currentOrg.id,
                        kind: "skills",
                        canManage: canManageOrganizationSkills
                    }),
                    tab === 'connectors' && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5cc73d5a4111dac3$export$2e2bcd8739ae039), {
                        organizationId: currentOrg.id,
                        kind: "connectors",
                        canManage: canManageOrganizationMcpServers
                    }),
                    tab === 'usage' && canViewUsage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0f8722f8ba47db6$export$2e2bcd8739ae039), {
                        organizationId: currentOrg.id,
                        canViewSkills: canManageOrganizationSkills,
                        canViewConnectors: canManageOrganizationMcpServers
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {})
        ]
    });
}
const $66abcfbc1029bce2$var$StyledTabs = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $c134be78e3e5ff0b$export$2e2bcd8739ae039))($66abcfbc1029bce2$var$t || ($66abcfbc1029bce2$var$t = $66abcfbc1029bce2$var$_`
    border-bottom: 1px solid ${0};
    margin-top: 1rem;
`), (props)=>props.theme.color.border);














function $e5b2f0df2c7643ec$export$2e2bcd8739ae039({ markdown: markdown }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10952db78fee7c4f$export$2def7183994512e9), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09cf8ac2a6e57519$export$7460c8b7e4ce9582), {
            remarkPlugins: [
                (0, $78aec921ddca40c1$export$2e2bcd8739ae039)
            ],
            rehypePlugins: [
                (0, $952077a98b509239$export$2e2bcd8739ae039)
            ],
            children: markdown
        })
    });
}


let $015587f0fc8dd8b7$var$_ = (t)=>t, $015587f0fc8dd8b7$var$t;
function $015587f0fc8dd8b7$export$2e2bcd8739ae039() {
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            currentOrg.customResourcesMarkdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5b2f0df2c7643ec$export$2e2bcd8739ae039), {
                markdown: currentOrg.customResourcesMarkdown
            }),
            currentOrg.customResourcesMarkdown && currentOrg.managedResourcesMarkdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($015587f0fc8dd8b7$var$Break, {}),
            currentOrg.managedResourcesMarkdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5b2f0df2c7643ec$export$2e2bcd8739ae039), {
                markdown: currentOrg.managedResourcesMarkdown
            })
        ]
    });
}
const $015587f0fc8dd8b7$var$Break = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($015587f0fc8dd8b7$var$t || ($015587f0fc8dd8b7$var$t = $015587f0fc8dd8b7$var$_`
    margin: 0;
    border-radius: 10px;
    border-top: 6px solid ${0};
    width: 100%;
`), ({ theme: theme })=>theme.color.text);




function $0870cb345d848b86$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:resources.title'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $015587f0fc8dd8b7$export$2e2bcd8739ae039), {})
        ]
    });
}














function $5edf99d7a6a3464e$export$2e2bcd8739ae039({ open: open, onClose: onClose, orgId: orgId, canManageBilling: canManageBilling = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const onConfirm = ()=>{
        onClose();
        if (canManageBilling) navigate((0, $b969eaec2195befc$export$c169ff81af47339c)({
            organizationId: orgId
        }));
    };
    return canManageBilling == true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.member.seats.updateLimit.title'),
        description: t('common:organization.member.seats.updateLimit.description', 'Limit reached', {
            maxSeats: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.maxMembers
        }),
        confirmButtonText: t('common:organization.member.seats.updateLimit.action'),
        onConfirm: onConfirm
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('common:organization.member.seats.limit.title'),
        description: t('common:organization.member.seats.limit.description', 'Limit reached', {
            maxSeats: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.maxMembers
        }),
        confirmButtonText: t('common:close'),
        onConfirm: onConfirm
    });
}




var $7fPBF = parcelRequire("7fPBF");











var $7fPBF = parcelRequire("7fPBF");

let $7fcb1b0f8c5b974b$var$_ = (t)=>t, $7fcb1b0f8c5b974b$var$t;
const $7fcb1b0f8c5b974b$var$TextFieldWithValidation = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function TextFieldWithValidation({ label: label, value: value, placeholder: placeholder, hasError: hasError, helperTextMessageOnError: helperTextMessageOnError, onChange: onChange, inputProps: inputProps, helperTextSuccess: helperTextSuccess = null, onFocus: onFocus = onChange }, ref) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
        inputRef: ref,
        slotProps: {
            htmlInput: inputProps,
            formHelperText: {
                component: 'div'
            }
        },
        fullWidth: true,
        label: label,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        type: "text",
        error: hasError,
        helperText: hasError && helperTextMessageOnError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7fcb1b0f8c5b974b$var$ErrorHelpText, {
            helpMessage: helperTextMessageOnError
        }) : helperTextSuccess
    });
});
const $7fcb1b0f8c5b974b$var$ErrorHelpText = ({ helpMessage: helpMessage })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7fcb1b0f8c5b974b$var$StyledErrorHelpText, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: "warning",
                color: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$7f714e6c560938e5), {
                children: helpMessage
            })
        ]
    });
};
const $7fcb1b0f8c5b974b$var$StyledErrorHelpText = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($7fcb1b0f8c5b974b$var$t || ($7fcb1b0f8c5b974b$var$t = $7fcb1b0f8c5b974b$var$_`
    display: flex;
    gap: 0.5rem;
    padding: 5px;
`));
var $7fcb1b0f8c5b974b$export$2e2bcd8739ae039 = $7fcb1b0f8c5b974b$var$TextFieldWithValidation;



let $a387e7d4ce3b8793$var$_ = (t)=>t, $a387e7d4ce3b8793$var$t, $a387e7d4ce3b8793$var$t1, $a387e7d4ce3b8793$var$t2;
const $a387e7d4ce3b8793$export$54571ac7cbe36b70 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a387e7d4ce3b8793$var$t || ($a387e7d4ce3b8793$var$t = $a387e7d4ce3b8793$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem 0;
    border-bottom: 1px solid ${0};
    margin: 0 0 1rem 0;
`), (props)=>props.theme.input.background);
const $a387e7d4ce3b8793$export$78b81e628c724207 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a387e7d4ce3b8793$var$t1 || ($a387e7d4ce3b8793$var$t1 = $a387e7d4ce3b8793$var$_`
    padding: 0 1.5rem;
    width: 100%;
`));
const $a387e7d4ce3b8793$export$7c14887e48a97962 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a387e7d4ce3b8793$var$t2 || ($a387e7d4ce3b8793$var$t2 = $a387e7d4ce3b8793$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`));











function $777249ad5835b0ee$var$RoleEditor({ myRole: myRole, role: role, title: title, titleDescription: titleDescription, includeDescription: includeDescription = true, onChange: onChange }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleChange = (event)=>{
        const { name: name, checked: checked } = event.target;
        // If toggling isAdmin, update all permissions
        if (name === 'isAdmin' && checked) {
            const updatedRole = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, role);
            Object.keys(role).forEach((key)=>{
                updatedRole[key] = true;
            });
            onChange(updatedRole);
        } else onChange((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, role), {
            [name]: checked
        }));
    };
    const accessibleRoles = Object.keys(role).filter((key)=>{
        const typedKey = key;
        return myRole.isAdmin || myRole[typedKey];
    });
    if (!myRole.isAdmin && role.isAdmin) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$bdfe625add29c644), {
        $color: "default",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: "warning"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: t('common:organization.isAdmin.conflict')
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $21f5b9af76a0c38b$export$2d00230e1e6f7fbc), {
        children: [
            title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                children: title
            }),
            titleDescription && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: titleDescription
            }),
            accessibleRoles.map((key)=>{
                const typedKey = key;
                var _role_typedKey;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                    control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                        disabled: typedKey !== 'isAdmin' && role.isAdmin,
                        checked: (_role_typedKey = role[typedKey]) !== null && _role_typedKey !== void 0 ? _role_typedKey : false,
                        onChange: handleChange,
                        name: typedKey
                    }),
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: includeDescription ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                    as: "span",
                                    children: t(`common:organization.${typedKey}.title`)
                                }),
                                ': ',
                                t(`common:organization.${typedKey}.description`)
                            ]
                        }) : t(`common:organization.${typedKey}.title`)
                    })
                }, key);
            })
        ]
    });
}
var $777249ad5835b0ee$export$2e2bcd8739ae039 = $777249ad5835b0ee$var$RoleEditor;





var $7fPBF = parcelRequire("7fPBF");

function $ad7bfeb7fe241d67$export$2e2bcd8739ae039({ open: open, onClose: onClose, myRole: myRole, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const newMemberRole = {
        isAdmin: false,
        canViewMembers: false,
        canInviteMembers: false,
        canChangeMemberPermissions: false,
        canRemoveMembers: false,
        canCreateAuthClients: false,
        canViewAuthClients: false,
        canManageBilling: false,
        canViewAnalytics: false,
        canManageChildOrganizations: false,
        canAccessOrganizationProfiles: false,
        canEditOrganizationProfiles: false,
        canManageGlobalAutomationRules: false
    };
    const initialInvite = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        email: ''
    }, newMemberRole);
    const [invite, setInvite] = (0, $7fPBF.useState)(initialInvite);
    const [role, setRole] = (0, $7fPBF.useState)(newMemberRole);
    const [emailValidation, setEmailValidation] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (invite === null || invite === void 0 ? void 0 : invite.email) setEmailValidation(null);
    }, [
        invite
    ]);
    const handleRoleChange = (updatedRole)=>{
        const newRole = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, updatedRole);
        if (newRole.isAdmin) {
            for(const key in updatedRole)if (Object.prototype.hasOwnProperty.call(updatedRole, key)) {
                const typedKey = key;
                newRole[typedKey] = true;
            }
        }
        setRole(newRole);
        setInvite((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, invite, newRole));
    };
    const handleInviteChange = (event)=>{
        const { value: value } = event.target;
        setInvite((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, invite), {
            email: value
        }));
    };
    const handleSave = async ()=>{
        var _invite_email, _useOrganizationStore_getState_invites, _thisOrg_invites;
        if (!invite.email) {
            setEmailValidation(t('common:organization.invite.emailRequired'));
            return;
        }
        if (invite.email && !((_invite_email = invite.email) === null || _invite_email === void 0 ? void 0 : _invite_email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))) {
            setEmailValidation(t('common:organization.invite.emailInvalid'));
            return;
        }
        const thisOrg = (_useOrganizationStore_getState_invites = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().invites) === null || _useOrganizationStore_getState_invites === void 0 ? void 0 : _useOrganizationStore_getState_invites.find((org)=>org.organizationId === organizationId);
        if (thisOrg && ((_thisOrg_invites = thisOrg.invites) === null || _thisOrg_invites === void 0 ? void 0 : _thisOrg_invites.some((existingInvite)=>existingInvite.email === invite.email && new Date(existingInvite.expirationDate) > new Date()))) {
            // invite already exists
            setEmailValidation(t('common:organization.invite.emailExists'));
            return;
        }
        const membersResult = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadOrganizationMembers(organizationId);
        if (membersResult.resultType === 'Ok' && membersResult.data) {
            const existingMember = membersResult.data.find((member)=>member.user.email === invite.email);
            if (existingMember) {
                // member already exists
                setEmailValidation(t('common:organization.member.emailExists'));
                return;
            }
        }
        const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().createOrganizationInvite(organizationId, invite);
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.invite.send.success', 'Success', {
            value: invite.email
        }));
        else // console.log(result);
        (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.invite.send.error', 'Error with invite', {
            value: invite.email
        }));
        onClose();
        setRole((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, newMemberRole));
        setInvite((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialInvite));
    };
    if (!organizationId || !myRole) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.invite.edit'),
        description: t('common:organization.invite.editDescription'),
        confirmButtonText: t('common:organization.invite.send.title'),
        onConfirm: handleSave,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$54571ac7cbe36b70), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fcb1b0f8c5b974b$export$2e2bcd8739ae039), {
                    required: true,
                    label: "Email",
                    value: invite === null || invite === void 0 ? void 0 : invite.email,
                    placeholder: 'email@email.com',
                    hasError: !!emailValidation,
                    helperTextMessageOnError: emailValidation,
                    onChange: handleInviteChange
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $777249ad5835b0ee$export$2e2bcd8739ae039), {
                title: t('common:organization.role.title'),
                myRole: myRole,
                role: role,
                onChange: handleRoleChange
            })
        ]
    });
}


function $24d7412693118a64$export$2e2bcd8739ae039({ myRole: myRole, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    const { remainingSeats: remainingSeats, isScimManaged: isScimManaged } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!myRole || !organizationId) return null;
    if (!myRole.canInviteMembers && !myRole.isAdmin) return null;
    // Membership belongs to the customer's identity provider — the API refuses these invites, so the
    // button is hidden and InviteScimManagedNotice explains where to manage members instead.
    if (isScimManaged) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                onClick: handleOpenDialog,
                startIcon: "plus",
                children: t('common:organization.invite.edit')
            }),
            remainingSeats > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ad7bfeb7fe241d67$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog,
                organizationId: organizationId,
                myRole: myRole
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5edf99d7a6a3464e$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog,
                orgId: organizationId,
                canManageBilling: (myRole === null || myRole === void 0 ? void 0 : myRole.canManageBilling) || (myRole === null || myRole === void 0 ? void 0 : myRole.isAdmin)
            })
        ]
    });
}







function $e7ac331879f72d98$export$2e2bcd8739ae039({ onNext: onNext, onPrevious: onPrevious, disableNext: disableNext, disablePrevious: disablePrevious, nextButtonText: nextButtonText, previousButtonText: previousButtonText }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$81ea29a9084db687), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                $size: "small",
                startIcon: "previous",
                onClick: onPrevious,
                disabled: disablePrevious,
                children: previousButtonText !== null && previousButtonText !== void 0 ? previousButtonText : t('common:previous')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                $size: "small",
                onClick: onNext,
                endIcon: "forward",
                disabled: disableNext,
                children: nextButtonText !== null && nextButtonText !== void 0 ? nextButtonText : t('common:next')
            })
        ]
    });
}











var $7fPBF = parcelRequire("7fPBF");

function $243f463264eb1fab$export$7cca17e0b77721be() {
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.invites);
    const orgInvites = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.invites);
    const invites = (0, $7fPBF.useMemo)(()=>{
        var _orgInvites_find;
        if (!organizationId) return null;
        var _orgInvites_find_invites;
        return (_orgInvites_find_invites = (_orgInvites_find = orgInvites.find((org)=>org.organizationId === organizationId)) === null || _orgInvites_find === void 0 ? void 0 : _orgInvites_find.invites) !== null && _orgInvites_find_invites !== void 0 ? _orgInvites_find_invites : [];
    }, [
        organizationId,
        orgInvites
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function fetchInvites() {
            var _useOrganizationStore_getState_invites_find;
            if (!organizationId || (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.invites == true) return;
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('invites', true);
            if ((_useOrganizationStore_getState_invites_find = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().invites.find((org)=>org.organizationId === organizationId)) === null || _useOrganizationStore_getState_invites_find === void 0 ? void 0 : _useOrganizationStore_getState_invites_find.invites) {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('invites', false);
                return;
            }
            try {
                const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadInvites(organizationId);
                if ((result === null || result === void 0 ? void 0 : result.resultType) !== 'Ok') console.error('Failed to load invites for organization:', organizationId);
            } catch (error) {
                console.error('Error loading invites.');
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('invites', false);
            }
        }
        fetchInvites();
    }, [
        organizationId
    ]);
    return {
        invites: invites,
        isLoading: isLoading
    };
}





var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");

/**
 * Scrolls to an element with the given elementId
 * @param elementId ID of the element to scroll to
 * @param dependentParams Additional dependencies for the scroll effect
 * @param additionalConditions Optional conditions that must be met to trigger the scroll
 */ const $d856e666394c520b$var$useScrollToElement = (elementId, dependentParams = [], additionalConditions = [])=>{
    const isReducedMotion = (0, $b1f35a815c258980$export$2e2bcd8739ae039)();
    const [scrollCount, setScrollCount] = (0, $7fPBF.useState)(0);
    (0, $7fPBF.useEffect)(()=>{
        if (!elementId) return;
        const element = document.getElementById(elementId);
        const shouldScroll = additionalConditions.length === 0 || additionalConditions.some((condition)=>condition);
        if (element && shouldScroll) {
            element.focus();
            element.scrollIntoView({
                behavior: isReducedMotion ? 'instant' : 'smooth'
            });
        }
    }, [
        ...dependentParams,
        elementId,
        isReducedMotion,
        scrollCount
    ]);
    // Forces a re-scroll even when clicking the same element
    const triggerScroll = ()=>{
        setScrollCount(scrollCount + 1);
    };
    return triggerScroll;
};
var $d856e666394c520b$export$2e2bcd8739ae039 = $d856e666394c520b$var$useScrollToElement;


/**
 * Settle time before a typed value is acted on — every search box across desktop and admin, plus the
 * org-management search hooks. One value so the same keystroke costs the same wait wherever a user
 * types, and so tuning responsiveness is a single edit rather than a sweep.
 *
 * Applies to searches that do I/O. A filter over a list already in memory should run on the keystroke:
 * settling a synchronous match only adds lag.
 */ const $da83796f61485d54$export$a954cbc46095ce6a = 300;


function $a552b14f0ac5e4a1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const invitesStore = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.invites);
    const loadingData = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData);
    const orgInvitesSearchContentId = 'org-invites-search';
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    const invites = (0, $7fPBF.useMemo)(()=>{
        var _invitesStore_find;
        if (!currentOrg || loadingData.invites == true) return null;
        var _invitesStore_find_invites;
        return (_invitesStore_find_invites = (_invitesStore_find = invitesStore.find((org)=>org.organizationId === currentOrg.id)) === null || _invitesStore_find === void 0 ? void 0 : _invitesStore_find.invites) !== null && _invitesStore_find_invites !== void 0 ? _invitesStore_find_invites : [];
    }, [
        currentOrg,
        invitesStore,
        loadingData
    ]);
    (0, $d856e666394c520b$export$2e2bcd8739ae039)(orgInvitesSearchContentId, [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>invitesStore.length >= displayLimit, [
        invitesStore
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, (0, $da83796f61485d54$export$a954cbc46095ce6a));
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        const organizationStore = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
        const count = organizationStore.invites.length;
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: displayLimit + ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0)
            });
        });
    };
    const handlePrevious = ()=>{
        const organizationStore = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
        const count = organizationStore.invites.length;
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: Math.max(0, ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0) - displayLimit)
            });
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            const organizationStore = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
            if (organizationStore.loadingData.invites) return;
            if (!currentOrg) return;
            try {
                organizationStore.handleLoadingDataChange('invites', true);
                await organizationStore.loadInvites(currentOrg.id, debouncedQuery);
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.invite.error'));
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('invites', false);
            }
        };
        trySearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedQuery
    ]);
    return {
        results: invites,
        orgInvitesSearchContentId: orgInvitesSearchContentId,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        isLoading: loadingData.invites
    };
}







let $ac3fc121a11fd783$var$_ = (t)=>t, $ac3fc121a11fd783$var$t, $ac3fc121a11fd783$var$t1;
const $ac3fc121a11fd783$export$c14c794fcd73bed8 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($ac3fc121a11fd783$var$t || ($ac3fc121a11fd783$var$t = $ac3fc121a11fd783$var$_`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
`));
const $ac3fc121a11fd783$export$2b64bc092bad4151 = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($ac3fc121a11fd783$var$t1 || ($ac3fc121a11fd783$var$t1 = $ac3fc121a11fd783$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`));















let $6b6dbe5e3c17f869$var$_ = (t)=>t, $6b6dbe5e3c17f869$var$t, $6b6dbe5e3c17f869$var$t1, $6b6dbe5e3c17f869$var$t2;
function $6b6dbe5e3c17f869$export$2e2bcd8739ae039({ icon: icon, title: title, active: active = true, variant: variant = 'default', chip: chip = false, iconSize: iconSize = 24 }) {
    const BodyComponent = variant === 'default' ? (0, $b091aef3a32d2bd8$export$b312780b0d72eabb) : (0, $b091aef3a32d2bd8$export$1ef657600983666a);
    if (!title) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6b6dbe5e3c17f869$var$MemberDetail, {
        variant: variant,
        chip: chip,
        children: [
            icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: icon,
                size: iconSize
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(BodyComponent, {
                children: active ? title : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6b6dbe5e3c17f869$var$StrikeThrough, {
                    "aria-hidden": true,
                    children: title
                })
            })
        ]
    });
}
const $6b6dbe5e3c17f869$var$StrikeThrough = (0, $8de346382d86c747$export$2e2bcd8739ae039).s($6b6dbe5e3c17f869$var$t || ($6b6dbe5e3c17f869$var$t = $6b6dbe5e3c17f869$var$_`
    text-decoration: line-through;
    color: ${0};
`), ({ theme: theme })=>theme.color.neutral + '90');
const $6b6dbe5e3c17f869$var$chipStyle = (0, $84f3fdd51733d70b$export$dbf350e5966cf602)($6b6dbe5e3c17f869$var$t1 || ($6b6dbe5e3c17f869$var$t1 = $6b6dbe5e3c17f869$var$_`
    margin: 0 10px;
`));
const $6b6dbe5e3c17f869$var$MemberDetail = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6b6dbe5e3c17f869$var$t2 || ($6b6dbe5e3c17f869$var$t2 = $6b6dbe5e3c17f869$var$_`
    display: flex;
    align-items: center;
    gap: ${0};
    ${0}
`), ({ variant: variant })=>variant === 'default' ? '0.5rem' : '0.25rem', ({ chip: chip })=>chip && $6b6dbe5e3c17f869$var$chipStyle);





const $5d595f963199dd48$export$f45ccdad2e79cfb4 = {
    isAdmin: 'orgAdmin',
    canViewMembers: 'orgMembers',
    canInviteMembers: 'orgInvite',
    canChangeMemberPermissions: 'orgPermissions',
    canRemoveMembers: 'orgDeleteUser',
    canCreateAuthClients: 'orgAuthClient',
    canViewAuthClients: 'orgAuthClient',
    canManageBilling: 'orgTransaction',
    canManageChildOrganizations: 'orgAdmin',
    canViewAnalytics: 'futures',
    canAccessOrganizationProfiles: 'purchaseOrder',
    canEditOrganizationProfiles: 'purchaseOrder',
    canManageGlobalAutomationRules: 'automation'
};




let $2427d6ebbf2e60fd$var$_ = (t)=>t, $2427d6ebbf2e60fd$var$t;
function $2427d6ebbf2e60fd$export$2e2bcd8739ae039({ role: role, variant: variant = 'stack' }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const randomUUID = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const renderMemberDetailItems = (keys, activeKeys)=>keys.map((key)=>{
            const typedKey = key;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                chip: true,
                active: role[typedKey],
                variant: "small",
                title: t(`common:organization.${typedKey}.title`)
            }, randomUUID + typedKey);
        });
    if (!role) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2427d6ebbf2e60fd$var$IconWrapper, {
            children: renderMemberDetailItems(Object.keys((0, $5d595f963199dd48$export$f45ccdad2e79cfb4)), Object.keys(role))
        })
    });
}
const $2427d6ebbf2e60fd$var$IconWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($2427d6ebbf2e60fd$var$t || ($2427d6ebbf2e60fd$var$t = $2427d6ebbf2e60fd$var$_`
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`));


function $6a93256354a6d378$export$2e2bcd8739ae039({ invite: invite, hideEmail: hideEmail, hideWrapper: hideWrapper }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const getRelativeTime = (0, $1e6a0781013949e7$export$2e2bcd8739ae039)();
    if (!invite) return null;
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a387e7d4ce3b8793$export$7c14887e48a97962), {
        children: [
            !hideEmail && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                icon: "mail",
                title: invite.email
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2427d6ebbf2e60fd$export$2e2bcd8739ae039), {
                variant: "listOnly",
                role: (0, $d227fca458ea4785$export$68befc518ea2400f)(invite)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                iconSize: 16,
                variant: "small",
                icon: "orgInviteExpired",
                title: t('common:organization.invite.expiration') + getRelativeTime(new Date(invite.expirationDate))
            })
        ]
    });
    return hideWrapper ? content : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$54571ac7cbe36b70), {
        children: content
    });
}








var $7fPBF = parcelRequire("7fPBF");


function $7ebdde8f38264897$export$2e2bcd8739ae039({ invite: invite }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showRemoveDialog, setShowRemoveDialog] = (0, $7fPBF.useState)(false);
    const handleRemove = ()=>{
        setShowRemoveDialog(true);
    };
    const handleCancelRemove = ()=>{
        setShowRemoveDialog(false);
    };
    const handleConfirmDeleteInvite = async ()=>{
        if (invite.organizationId) await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().deleteOrganizationInvite(invite.organizationId, invite.id);
        setShowRemoveDialog(false);
    };
    if (!invite) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "negative",
                startIcon: "delete",
                onClick: handleRemove,
                children: t('common:delete')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showRemoveDialog,
                onConfirm: handleConfirmDeleteInvite,
                onCancel: handleCancelRemove,
                onClose: handleCancelRemove,
                title: t('common:organization.invite.confirm'),
                confirmButtonText: t('common:organization.invite.delete'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a93256354a6d378$export$2e2bcd8739ae039), {
                            invite: invite
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                            children: t('common:organization.invite.confirmLong')
                        })
                    ]
                })
            })
        ]
    });
}


function $f0e163beadbbd519$export$2e2bcd8739ae039({ invite: invite, myRole: myRole }) {
    if (!myRole || !invite) return null;
    if (!myRole.canRemoveMembers && !myRole.isAdmin) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$a27f3c48b2f1c458), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$c14c794fcd73bed8), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: "orgInvite",
                                    size: 35
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$68b378fffb2ccca3), {
                                    children: invite.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ebdde8f38264897$export$2e2bcd8739ae039), {
                                invite: invite
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$78b81e628c724207), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6a93256354a6d378$export$2e2bcd8739ae039), {
                        hideWrapper: true,
                        hideEmail: true,
                        invite: invite
                    })
                })
            ]
        })
    });
}






function $07e53c7e95507174$export$2e2bcd8739ae039({ myRole: myRole, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.invite.noInvites.description'),
        fullHeight: true,
        icon: "orgCompany",
        title: t('common:organization.invite.noInvites.title'),
        children: myRole && organizationId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24d7412693118a64$export$2e2bcd8739ae039), {
            organizationId: organizationId,
            myRole: myRole
        })
    });
}









let $db7a41c310321878$var$_ = (t)=>t, $db7a41c310321878$var$t, $db7a41c310321878$var$t1;
/**
 * InternalNotificationCard is a component that displays a notification card with a title, subtitle, and icon.
 *
 * - `default`: allows unstyled button and text buttons to be used for constructing custom notification cards
 * - `accent` & `info`: uses the secondary colors and should be used for informational notifications
 * - `warning`: uses the warning color should be used for warning notifications
 * - `error`: uses the error color should be used for error notifications
 * - `success`: uses the success color should be used for success notifications
 *
 *  */ const $db7a41c310321878$var$InternalNotificationCard = ({ color: color = 'default', title: title, subtitle: subtitle, subtitleAction: subtitleAction, icon: icon, children: children })=>{
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    if (!title || !subtitle) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$8e508ed4a13b5a61), {
        $color: color,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($db7a41c310321878$var$FlexWrap, {
                children: [
                    icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: icon,
                        color: theme.banner[color].icon
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$5c3bdb37a55baa65), {
                        as: "h2",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$dc254ddf4c41e5d7), {
                $color: color,
                children: [
                    subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($db7a41c310321878$var$StyledBodyMedium, {
                        children: subtitle
                    }),
                    subtitleAction
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12a7318cc7b914d5$export$503892287317b6c8), {
                $color: color,
                children: children
            })
        ]
    });
};
const $db7a41c310321878$var$FlexWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($db7a41c310321878$var$t || ($db7a41c310321878$var$t = $db7a41c310321878$var$_`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
`));
const $db7a41c310321878$var$StyledBodyMedium = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb))($db7a41c310321878$var$t1 || ($db7a41c310321878$var$t1 = $db7a41c310321878$var$_`
    display: inline;
`));
var $db7a41c310321878$export$2e2bcd8739ae039 = $db7a41c310321878$var$InternalNotificationCard;



function $9e61ce1e7c961b16$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db7a41c310321878$export$2e2bcd8739ae039), {
        color: "info",
        icon: "orgCompany",
        title: t('organization.invite.scimManaged.title'),
        subtitle: t('organization.invite.scimManaged.description')
    });
}


function $025d14e1ef64690b$export$2e2bcd8739ae039() {
    var _invitesSearch_results, _invitesSearch_results1;
    const { currentOrg: currentOrg, canInviteMembers: canInviteMembers, membership: membership, isExpiredOrg: isExpiredOrg, canManageBilling: canManageBilling, isManagedOrg: isManagedOrg, isScimManaged: isScimManaged } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { isLoading: isLoading } = (0, $243f463264eb1fab$export$7cca17e0b77721be)();
    const invitesSearch = (0, $a552b14f0ac5e4a1$export$2e2bcd8739ae039)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    var _invitesSearch_results_length;
    const hasResults = ((_invitesSearch_results_length = (_invitesSearch_results = invitesSearch.results) === null || _invitesSearch_results === void 0 ? void 0 : _invitesSearch_results.length) !== null && _invitesSearch_results_length !== void 0 ? _invitesSearch_results_length : 0) > 0;
    if (!currentOrg) return null;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!canInviteMembers || !membership) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            isScimManaged && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9e61ce1e7c961b16$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: invitesSearch.searchQuery,
                onChange: (e)=>invitesSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>invitesSearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? (_invitesSearch_results1 = invitesSearch.results) === null || _invitesSearch_results1 === void 0 ? void 0 : _invitesSearch_results1.map((invite, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0e163beadbbd519$export$2e2bcd8739ae039), {
                    invite: invite,
                    myRole: membership
                }, index)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07e53c7e95507174$export$2e2bcd8739ae039), {
                myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                organizationId: currentOrg.id
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: !invitesSearch.results || invitesSearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: invitesSearch.handleNext,
                    onPrevious: invitesSearch.handlePrevious,
                    disableNext: !invitesSearch.showNext,
                    disablePrevious: !invitesSearch.showPrevious
                })
            })
        ]
    });
}







function $baa978b131a43e54$export$2e2bcd8739ae039() {
    (0, $70228be3ff15ddce$export$f08c2f745253d47b)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, membership: membership, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.invite.orgTitle', {
                    value: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name
                }),
                description: t('common:organization.invite.description'),
                items: items,
                children: membership && !isExpiredOrg && (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24d7412693118a64$export$2e2bcd8739ae039), {
                    myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                    organizationId: currentOrg.id
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $025d14e1ef64690b$export$2e2bcd8739ae039), {})
        ]
    });
}








const $16d9b11fdb0c5246$var$Card = ({ title: title, description: description, statusText: statusChip, children: children })=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$401042fa3f49d26), {
        children: [
            statusChip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$fd5345d4562e9833), {
                children: statusChip
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                        children: description
                    }),
                    children
                ]
            })
        ]
    });
};
var $16d9b11fdb0c5246$export$2e2bcd8739ae039 = $16d9b11fdb0c5246$var$Card;









function $4643a3bccc023815$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { licenseType: licenseType, currentOrg: currentOrg, canViewMembers: canViewMembers, canManageBilling: canManageBilling, canViewOrgDetails: canViewOrgDetails } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const handleContinue = ()=>{
        navigate('/', {
            replace: true
        });
    };
    const guideLink = 'https://cephable.com/for-individuals/tutorials/';
    const cards = [
        {
            title: 'common:organization.titlePlural',
            description: 'common:organization.description',
            buttons: [
                {
                    text: 'common:organization.viewOrganization',
                    link: '#/org',
                    onCondition: canViewOrgDetails
                },
                {
                    text: 'common:organization.canViewMembers.title',
                    link: `#/org/${currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id}/members`,
                    onCondition: canViewOrgDetails && canViewMembers
                },
                {
                    text: 'common:organization.canManageBilling.title',
                    link: `#${(0, $b969eaec2195befc$export$c169ff81af47339c)({
                        organizationId: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id
                    })}`,
                    onCondition: canManageBilling
                }
            ]
        },
        {
            title: 'common:resources.title',
            description: 'common:resources.description',
            buttons: [
                {
                    text: 'common:resources.guides',
                    link: guideLink
                }
            ]
        },
        {
            title: 'common:feedback.title',
            description: 'common:feedback.description',
            buttons: [
                {
                    text: 'common:feedback.feature',
                    link: 'https://forms.office.com/pages/responsepage.aspx?id=nXUREBN1JUCrY3YZ6NyUAMhvlErPu6pKnaJDLXYRrXdUOVc0M0c2RDBTOVoxUEdSWVUzUkFXMlNMTyQlQCN0PWcu'
                },
                {
                    text: 'common:feedback.bug',
                    link: 'https://forms.office.com/pages/responsepage.aspx?id=nXUREBN1JUCrY3YZ6NyUAMhvlErPu6pKnaJDLXYRrXdUNUIzTFpYSFBTTk5HME1MU1kyQlEyVENVUCQlQCN0PWcu'
                },
                {
                    text: 'common:feedback.contact',
                    link: 'https://cephable.com/contact-us/'
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:license.welcome.title', {
                    license: t(`common:billing.${licenseType}.titleLong`)
                }),
                description: t('common:license.welcome.description', {
                    organization: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name,
                    description: t(`common:billing.${licenseType}.description`)
                }),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9926e0d0274623af$export$154f0ea7dcc0c8c6), {
                onClick: ()=>handleContinue(),
                children: t('tour:onboarding.finish.continueToApp')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $16d9b11fdb0c5246$export$2e2bcd8739ae039), {
                        title: t(card.title),
                        description: t(card.description),
                        children: card.buttons.filter((button)=>button.onCondition === undefined || button.onCondition).map((button, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $color: "context",
                                href: button.link,
                                children: t(button.text)
                            }, 'button_' + index + i))
                    }, 'card_' + index))
            })
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");



function $10c08b77230bafcc$export$c24add0d20ee4d6a() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.licenseKeys);
    const orgManagedLicenseKeys = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgManagedLicenseKeys);
    (0, $7fPBF.useEffect)(()=>{
        async function initializeLicenseKeys() {
            const organizationState = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
            if (!organizationId || organizationState.loadingData.licenseKeys == true) return;
            organizationState.handleLoadingDataChange('licenseKeys', true);
            const key = organizationState.orgManagedLicenseKeys.find((k)=>k.originatedByOrganizationId === organizationId);
            if (key) {
                organizationState.handleLoadingDataChange('licenseKeys', false);
                return;
            }
            try {
                await organizationState.getOrgManagedLicenseKeys(organizationId);
            } catch (error) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:license.key.error'));
            } finally{
                organizationState.handleLoadingDataChange('licenseKeys', false);
            }
        }
        initializeLicenseKeys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        orgManagedLicenseKeys: orgManagedLicenseKeys,
        isLoading: isLoading
    };
}






var $7fPBF = parcelRequire("7fPBF");







function $dff101a14f82f91d$export$2e2bcd8739ae039(defaultFilter = 'all') {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const orgManagedLicenseKeys = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgManagedLicenseKeys);
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    const [searchFilteredLicenseKeys, setSearchFilteredLicenseKeys, searchFilteredLicenseKeysRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(defaultFilter);
    (0, $d856e666394c520b$export$2e2bcd8739ae039)((0, $14e4f1609944ac39$export$18d6475ce2e9bfe8), [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    function handleSearchFilteredLicenseKeysChange(value) {
        setSearchFilteredLicenseKeys(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>orgManagedLicenseKeys.length >= displayLimit, [
        orgManagedLicenseKeys
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, (0, $da83796f61485d54$export$a954cbc46095ce6a));
        return ()=>clearTimeout(timeoutId);
    }, [
        searchQuery,
        searchFilteredLicenseKeys
    ]);
    const handleNext = ()=>{
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: displayLimit + ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0)
            });
        });
    };
    const handlePrevious = ()=>{
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: Math.max(0, ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0) - displayLimit)
            });
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if ((0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.licenseKeys || !organizationId) return;
            try {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('licenseKeys', true);
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().searchOrgManageLicenseKeys(organizationId, debouncedQuery, searchFilteredLicenseKeysRef.current);
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:license.key.error'));
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('licenseKeys', false);
            }
        };
        trySearch();
    }, [
        debouncedQuery
    ]);
    return {
        results: orgManagedLicenseKeys,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        searchFilteredLicenseKeys: searchFilteredLicenseKeys,
        handleSearchFilteredLicenseKeysChange: handleSearchFilteredLicenseKeysChange,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        loadingData: (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.licenseKeys
    };
}





const $9bc694be59ba7dc7$export$94edfa5bee6a54b8 = (str, visibleCount = 4, maskChar = '*')=>{
    if (str.length <= visibleCount) return str; // If the string is shorter than visibleCount, return as is
    return str.slice(0, visibleCount) + maskChar.repeat(str.length - visibleCount); // Visible + masked part
};



var $7fPBF = parcelRequire("7fPBF");






function $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
        fullWidth: true,
        multiline: true,
        rows: 4,
        label: t('common:description'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('description', e.target.value)
    });
}








var $7fPBF = parcelRequire("7fPBF");



function $65792f9bbfbfd034$export$2e2bcd8739ae039(licenseKey) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const loadingData = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData);
    const [licenseKeyAssign, setLicenseKeyAssign] = (0, $7fPBF.useState)(licenseKey);
    var _licenseKey_accessCode;
    const [assignKey, setAssignKey] = (0, $7fPBF.useState)({
        name: '',
        description: '',
        key: (_licenseKey_accessCode = licenseKey === null || licenseKey === void 0 ? void 0 : licenseKey.accessCode) !== null && _licenseKey_accessCode !== void 0 ? _licenseKey_accessCode : '',
        customBillingUrl: ''
    });
    const resetAssignKey = ()=>{
        var _licenseKey_accessCode;
        setAssignKey({
            name: '',
            description: '',
            key: (_licenseKey_accessCode = licenseKey === null || licenseKey === void 0 ? void 0 : licenseKey.accessCode) !== null && _licenseKey_accessCode !== void 0 ? _licenseKey_accessCode : '',
            customBillingUrl: ''
        });
    };
    const handleInputChange = (field, value)=>{
        setAssignKey((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                [field]: value
            }));
    };
    const handleSave = async ()=>{
        if (!assignKey.name || !assignKey.description) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:requiredFields'));
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        if (!(licenseKeyAssign === null || licenseKeyAssign === void 0 ? void 0 : licenseKeyAssign.originatedByOrganizationId) || !assignKey) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
        try {
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedKeys', true);
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().createManagedOrg(licenseKeyAssign === null || licenseKeyAssign === void 0 ? void 0 : licenseKeyAssign.originatedByOrganizationId, assignKey);
            if (result.resultType === 'Ok' && result.data) (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:saved'));
            else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
            return result;
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        } finally{
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedKeys', false);
        }
    };
    return {
        assignKey: assignKey,
        licenseKeyAssign: licenseKeyAssign,
        setLicenseKeyAssign: setLicenseKeyAssign,
        resetAssignKey: resetAssignKey,
        handleInputChange: handleInputChange,
        handleSave: handleSave,
        isLoading: loadingData.managedOrgs
    };
}







function $ae9382977fb78a94$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.orgCustomBillingUrl.title'),
        helperText: t('common:organization.orgCustomBillingUrl.description'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('customBillingUrl', e.target.value)
    });
}





function $09e78d309b5c4bb4$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.orgName'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('name', e.target.value)
    });
}










let $4fdc8319b8729c3b$var$_ = (t)=>t, $4fdc8319b8729c3b$var$t;
function $4fdc8319b8729c3b$export$2e2bcd8739ae039({ licenseKey: licenseKey }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: licenseKey.name,
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4fdc8319b8729c3b$var$StyledLicenseTypeLogo, {
                licenseType: (0, $427978696205d868$export$5122f57547dc8eca)(licenseKey)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: licenseKey.accessCode
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:created', 'Created', {
                            value: licenseKey.createdDate
                        })
                    }),
                    licenseKey.modifiedDate !== licenseKey.createdDate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:updated', 'Updated', {
                            value: licenseKey.modifiedDate
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:expires', 'Expires', {
                            value: licenseKey.expirationDate
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                        children: t('common:organization.member.seats.maxSeatValue', 'Max', {
                            value: licenseKey.maxMembers
                        })
                    })
                ]
            })
        ]
    });
}
// TODO - this is a hack to get the icons to work correctly I have put in a ticket with the team to get better license logos
const $4fdc8319b8729c3b$var$StyledLicenseTypeLogo = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039))($4fdc8319b8729c3b$var$t || ($4fdc8319b8729c3b$var$t = $4fdc8319b8729c3b$var$_`
    position: relative;
    margin-top: -80px;
    overflow: hidden;
    bottom: -50px;
`));


function $3cc9edccf5351c87$var$LicenseKeyAssignDialog({ open: open, onClose: onClose, licenseKey: licenseKey }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { assignKey: assignKey, handleInputChange: handleInputChange, handleSave: handleSave, setLicenseKeyAssign: setLicenseKeyAssign, resetAssignKey: resetAssignKey } = (0, $65792f9bbfbfd034$export$2e2bcd8739ae039)(licenseKey);
    const handleConfirm = async ()=>{
        const result = await handleSave();
        if (result.resultType === 'Ok' && result.data) {
            handleClose();
            navigate(`/org/${result.data.originatedByOrganizationId}/managed/${result.data.id}`);
        }
    };
    const handleClose = ()=>{
        setLicenseKeyAssign(undefined);
        resetAssignKey();
        onClose();
    };
    var _assignKey_name, _assignKey_description, _assignKey_customBillingUrl;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: handleClose,
        title: t('common:license.key.assign'),
        onCancel: handleClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:create'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4fdc8319b8729c3b$export$2e2bcd8739ae039), {
                licenseKey: licenseKey
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.new.details'),
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                        value: (_assignKey_name = assignKey.name) !== null && _assignKey_name !== void 0 ? _assignKey_name : '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                        value: (_assignKey_description = assignKey.description) !== null && _assignKey_description !== void 0 ? _assignKey_description : '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae9382977fb78a94$export$2e2bcd8739ae039), {
                        value: (_assignKey_customBillingUrl = assignKey.customBillingUrl) !== null && _assignKey_customBillingUrl !== void 0 ? _assignKey_customBillingUrl : '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    })
                ]
            })
        ]
    });
}
var $3cc9edccf5351c87$export$2e2bcd8739ae039 = $3cc9edccf5351c87$var$LicenseKeyAssignDialog;







function $1e7c30ae2efd49a7$var$LicenseKeyDetailsDialog({ open: open, onClose: onClose, licenseKey: licenseKey }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const handleConfirm = ()=>{
        onClose();
        navigate(`/org/${licenseKey.originatedByOrganizationId}/managed/${licenseKey.organizationId}`);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        title: t('common:license.key.details'),
        onCancel: onClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:organization.viewOrganization'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4fdc8319b8729c3b$export$2e2bcd8739ae039), {
            licenseKey: licenseKey
        })
    });
}
var $1e7c30ae2efd49a7$export$2e2bcd8739ae039 = $1e7c30ae2efd49a7$var$LicenseKeyDetailsDialog;


function $43d387c58d5b8cfc$export$2e2bcd8739ae039({ licenseKey: licenseKey }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    if (!licenseKey) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
                iconSize: 24,
                startIcon: licenseKey.organizationId ? 'check' : 'circle',
                endIcon: "more",
                title: licenseKey.name,
                description: licenseKey.organizationId ? t('common:used', 'Used', {
                    value: licenseKey.modifiedDate
                }) : (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(licenseKey.accessCode),
                onClick: ()=>setOpen(true)
            }),
            licenseKey.organizationId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e7c30ae2efd49a7$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                licenseKey: licenseKey
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3cc9edccf5351c87$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                licenseKey: licenseKey
            })
        ]
    });
}







function $14f7b42400a03c73$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:license.key.empty.description'),
        fullHeight: true,
        title: t('common:license.key.empty.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            onClick: ()=>navigate('../purchase'),
            startIcon: "plusLight",
            children: t('common:license.key.product.title')
        })
    });
}


function $331a2a11ebbf5c79$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $10c08b77230bafcc$export$c24add0d20ee4d6a)(); //initialize
    const licenseKeySearch = (0, $dff101a14f82f91d$export$2e2bcd8739ae039)(); //search
    const hasResults = licenseKeySearch.results.length > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: licenseKeySearch.searchQuery,
                onChange: (e)=>licenseKeySearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>licenseKeySearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? licenseKeySearch.results.map((licenseKey)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43d387c58d5b8cfc$export$2e2bcd8739ae039), {
                    licenseKey: licenseKey
                }, licenseKey.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $14f7b42400a03c73$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: licenseKeySearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: licenseKeySearch.handleNext,
                    onPrevious: licenseKeySearch.handlePrevious,
                    disableNext: !licenseKeySearch.showNext,
                    disablePrevious: !licenseKeySearch.showPrevious
                })
            })
        ]
    });
}




function $b9b520f8e9a5b827$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:license.key.titlePlural'),
                description: t('common:license.key.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $331a2a11ebbf5c79$export$2e2bcd8739ae039), {})
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");


function $13623c5fd2a6c1d6$export$1666dd65ac1e38fd() {
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const orgManagedOrgs = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgManagedOrgs);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.managedOrgs);
    (0, $7fPBF.useEffect)(()=>{
        async function initializeManagedOrgs() {
            if (!organizationId || (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.managedOrgs == true) return;
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedOrgs', true);
            const org = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().orgManagedOrgs.find((mo)=>mo.originatedByOrganizationId == organizationId);
            if (org) {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedOrgs', false);
                return;
            }
            try {
                const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrgManagedOrgsAll(organizationId);
                result === null || result === void 0 ? void 0 : result.resultType;
            } catch (error) {
                console.error('Error loading managed organizations.');
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedOrgs', false);
            }
        }
        initializeManagedOrgs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        orgManagedOrgs: orgManagedOrgs,
        isLoading: isLoading
    };
}





var $7fPBF = parcelRequire("7fPBF");






function $9b7339fe14b0b949$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const orgManagedOrgs = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgManagedOrgs);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.managedOrgs);
    const managedOrgsSearchContentId = 'managed-orgs-search';
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    (0, $d856e666394c520b$export$2e2bcd8739ae039)(managedOrgsSearchContentId, [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>orgManagedOrgs.length >= displayLimit, [
        orgManagedOrgs
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery.toLowerCase(),
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, (0, $da83796f61485d54$export$a954cbc46095ce6a));
        return ()=>clearTimeout(timeoutId);
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: displayLimit + ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0)
            });
        });
    };
    const handlePrevious = ()=>{
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: Math.max(0, ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0) - displayLimit)
            });
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if ((0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.managedOrgs) return;
            if (!organizationId) return;
            try {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedOrgs', true);
                await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrgManagedOrgsAll(organizationId, debouncedQuery);
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.managed.error'));
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('managedOrgs', false);
            }
        };
        trySearch();
    }, [
        debouncedQuery
    ]);
    return {
        results: orgManagedOrgs,
        managedOrgsSearchContentId: managedOrgsSearchContentId,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        isLoading: isLoading
    };
}










var $7fPBF = parcelRequire("7fPBF");





function $2795f850cc5132b5$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const handleConfirm = ()=>{
        onClose();
        navigate(`/org/${organizationId}/purchase`);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onCancel: onClose,
        onClose: onClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:license.key.product.title'),
        title: t('common:license.key.empty.title'),
        description: t('common:license.key.empty.description')
    });
}

















function $49c3dd2972df6e1a$export$2e2bcd8739ae039({ value: value, onUpdate: onUpdate, handleLicenseKeyChange: handleLicenseKeyChange, results: results = [], loadingData: loadingData }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $d62c6f18f523e962$export$3b14a55fb2447963)();
    const handleUpdate = (key)=>{
        const selectedKey = results.find((k)=>k.accessCode === key);
        if (selectedKey) {
            onUpdate('key', key);
            handleLicenseKeyChange(selectedKey);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                style: {
                    backgroundColor: theme.color.background
                },
                id: "license-key-label",
                children: "Choose a License Key"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                labelId: "license-key-label",
                value: value !== null && value !== void 0 ? value : '',
                onChange: (e)=>handleUpdate(e.target.value),
                disabled: loadingData || results.length === 0,
                displayEmpty: true,
                children: loadingData ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                    disabled: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5310a643ead17d95$export$2e2bcd8739ae039), {
                            size: 24
                        }),
                        t('common:loading')
                    ]
                }) : results.length > 0 ? results.map((key)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                        value: key.accessCode,
                        children: [
                            key.name,
                            " ",
                            ' | ',
                            t('common:organization.member.seats.maxSeatValue', 'Max', {
                                value: key.maxMembers
                            })
                        ]
                    }, key.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                    disabled: true,
                    children: t('common:license.key.product.title')
                })
            })
        ]
    });
}



function $4e925a1bb1238fb4$var$LicenseKeySelectDialog(_param) {
    var { open: open, onClose: onClose, availableKeys: availableKeys, loadingData: loadingData } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "open",
        "onClose",
        "availableKeys",
        "loadingData"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { assignKey: assignKey, licenseKeyAssign: licenseKeyAssign, handleInputChange: handleInputChange, handleSave: handleSave, setLicenseKeyAssign: setLicenseKeyAssign, resetAssignKey: resetAssignKey } = (0, $65792f9bbfbfd034$export$2e2bcd8739ae039)();
    const handleClose = ()=>{
        onClose();
        setLicenseKeyAssign(undefined);
        resetAssignKey();
    };
    const handleConfirm = async ()=>{
        const result = await handleSave();
        if (result.resultType === 'Ok' && result.data) {
            handleClose();
            navigate(`/org/${result.data.originatedByOrganizationId}/managed/${result.data.id}`);
        }
    };
    var _assignKey_name, _assignKey_description, _assignKey_customBillingUrl;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: handleClose,
        title: t('common:license.key.assign'),
        onCancel: handleClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:create'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $49c3dd2972df6e1a$export$2e2bcd8739ae039), {
                    value: assignKey.key,
                    onUpdate: handleInputChange,
                    handleLicenseKeyChange: setLicenseKeyAssign,
                    results: availableKeys,
                    loadingData: loadingData
                })
            }),
            licenseKeyAssign && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4fdc8319b8729c3b$export$2e2bcd8739ae039), {
                licenseKey: licenseKeyAssign
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.new.details'),
                variant: "small"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                        value: (_assignKey_name = assignKey.name) !== null && _assignKey_name !== void 0 ? _assignKey_name : '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                        value: (_assignKey_description = assignKey.description) !== null && _assignKey_description !== void 0 ? _assignKey_description : '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae9382977fb78a94$export$2e2bcd8739ae039), {
                        value: (_assignKey_customBillingUrl = assignKey.customBillingUrl) !== null && _assignKey_customBillingUrl !== void 0 ? _assignKey_customBillingUrl : '',
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    })
                ]
            })
        ]
    });
}
var $4e925a1bb1238fb4$export$2e2bcd8739ae039 = $4e925a1bb1238fb4$var$LicenseKeySelectDialog;


function $1e4b589f04a4e1a2$var$LicenseKeySelectAccess(_param) {
    var { $color: $color = 'accent', $size: $size = 'small', startIcon: startIcon = 'plusLight' } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "$color",
        "$size",
        "startIcon"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const { results: results, loadingData: loadingData } = (0, $dff101a14f82f91d$export$2e2bcd8739ae039)('available');
    const onClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                $color: $color,
                $size: $size,
                onClick: ()=>setOpen(true),
                startIcon: startIcon
            }, restProps), {
                children: t('common:organization.create')
            })),
            results.length < 1 && !loadingData ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2795f850cc5132b5$export$2e2bcd8739ae039), {
                open: open,
                onClose: onClose
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e925a1bb1238fb4$export$2e2bcd8739ae039), {
                availableKeys: results,
                loadingData: loadingData,
                open: open,
                onClose: onClose
            })
        ]
    });
}
var $1e4b589f04a4e1a2$export$2e2bcd8739ae039 = $1e4b589f04a4e1a2$var$LicenseKeySelectAccess;






var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");




function $2d24843f3708c077$export$15de29966ec5486a(initialModel) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [editOrganization, setEditOrganization, editOrganizationRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(initialModel);
    const [hasChanges, setHasChanges] = (0, $7fPBF.useState)(false);
    const resetEditOrganization = ()=>{
        setEditOrganization(initialModel);
        setHasChanges(false);
    };
    const handleFieldChange = (fieldName, value)=>{
        setEditOrganization((prevModel)=>prevModel ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevModel), {
                [fieldName]: value
            }) : null);
        if (!hasChanges) setHasChanges(true);
    };
    const handleInputChange = (fieldName, value)=>{
        handleFieldChange(fieldName, value);
    };
    const handleUpdate = async ()=>{
        try {
            if (!(initialModel === null || initialModel === void 0 ? void 0 : initialModel.id) || !editOrganizationRef.current) throw new Error('Missing data');
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().updateOrganization(initialModel.id, editOrganizationRef.current);
            if (result.resultType === 'Ok' && result.data) {
                setEditOrganization(result.data);
                setHasChanges(false);
            }
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleAlerts = (result)=>{
        if (result.resultType === 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:saved'));
        else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
    };
    const handleUpdateWithAlerts = async ()=>{
        const result = await handleUpdate();
        handleAlerts(result);
        return result;
    };
    return {
        hasChanges: hasChanges,
        editOrganization: editOrganization,
        setEditOrganization: setEditOrganization,
        handleFieldChange: handleFieldChange,
        handleInputChange: handleInputChange,
        handleUpdate: handleUpdate,
        resetEditOrganization: resetEditOrganization,
        handleUpdateWithAlerts: handleUpdateWithAlerts
    };
}






function $e11b18a0b779fb3d$var$ManagedOrgDetailsDialog({ open: open, onClose: onClose, org: org }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { handleInputChange: handleInputChange, handleUpdateWithAlerts: handleUpdateWithAlerts, editOrganization: editOrganization, hasChanges: hasChanges, resetEditOrganization: resetEditOrganization } = (0, $2d24843f3708c077$export$15de29966ec5486a)(org !== null && org !== void 0 ? org : null);
    const handleConfirm = async ()=>{
        if (hasChanges) {
            const response = await handleUpdateWithAlerts();
            if (response.resultType === 'Ok') handleClose();
        }
    };
    const handleClose = ()=>{
        onClose();
        resetEditOrganization();
    };
    var _org_maxMembers, _editOrganization_name, _editOrganization_description, _editOrganization_customBillingUrl;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        dialogTag: t(`common:billing.${(0, $427978696205d868$export$5122f57547dc8eca)(org)}.title`),
        open: open,
        onClose: handleClose,
        title: org.name,
        description: org.description,
        onCancel: handleClose,
        onConfirm: handleConfirm,
        confirmButtonText: t('common:unsaved.confirm'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                    title: t('common:billing.title'),
                    variant: "small",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $size: "small",
                        endIcon: "externalLink",
                        to: (0, $b969eaec2195befc$export$c169ff81af47339c)({
                            organizationId: org.originatedByOrganizationId,
                            managedOrgId: org.id
                        }),
                        children: t('common:billing.view')
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$a334180936c1c286), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:created', 'Created', {
                                value: org.createdDate
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:expires', 'Expires', {
                                value: org.licenseExpirationDate
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                            children: t('common:organization.member.seats.maxSeatValue', 'Max', {
                                value: (_org_maxMembers = org.maxMembers) !== null && _org_maxMembers !== void 0 ? _org_maxMembers : 0
                            })
                        })
                    ]
                }),
                editOrganization && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                            title: t('common:organization.new.details'),
                            variant: "small",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                $size: "small",
                                to: `/org/${org.originatedByOrganizationId}/managed/${org.id}`,
                                children: t('common:organization.viewOrganization')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                                    value: (_editOrganization_name = editOrganization.name) !== null && _editOrganization_name !== void 0 ? _editOrganization_name : '',
                                    onUpdate: (field, value)=>handleInputChange(field, value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                                    value: (_editOrganization_description = editOrganization.description) !== null && _editOrganization_description !== void 0 ? _editOrganization_description : '',
                                    onUpdate: (field, value)=>handleInputChange(field, value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae9382977fb78a94$export$2e2bcd8739ae039), {
                                    value: (_editOrganization_customBillingUrl = editOrganization.customBillingUrl) !== null && _editOrganization_customBillingUrl !== void 0 ? _editOrganization_customBillingUrl : '',
                                    onUpdate: (field, value)=>handleInputChange(field, value)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $e11b18a0b779fb3d$export$2e2bcd8739ae039 = $e11b18a0b779fb3d$var$ManagedOrgDetailsDialog;


function $e334800c0f0fce5a$export$2e2bcd8739ae039({ organization: organization }) {
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const handleNavigate = ()=>{
        navigate(`/org/${organization.originatedByOrganizationId}/managed/${organization.id}`);
    };
    if (!organization || !organization.originatedByOrganizationId) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
                iconSize: 24,
                startIcon: (0, $d0493a8b121d95e9$export$3aa18b5a5694efe6)(organization),
                endIcon: "more",
                title: organization.name,
                description: organization.description,
                onClick: ()=>setOpen(true)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e11b18a0b779fb3d$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                org: organization
            })
        ]
    });
}






function $ef94978f68775b91$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.managed.empty.description'),
        fullHeight: true,
        title: t('common:organization.managed.empty.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e4b589f04a4e1a2$export$2e2bcd8739ae039), {})
    });
}


function $b468ed531a071225$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $13623c5fd2a6c1d6$export$1666dd65ac1e38fd)(); //initialize
    const managedOrgSearch = (0, $9b7339fe14b0b949$export$2e2bcd8739ae039)(); //search
    const hasResults = managedOrgSearch.results.length > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: managedOrgSearch.searchQuery,
                onChange: (e)=>managedOrgSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>managedOrgSearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    managedOrgSearch.results.map((managedOrg)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e334800c0f0fce5a$export$2e2bcd8739ae039), {
                            organization: managedOrg
                        }, managedOrg.id)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$56d6cb3330e62b54), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e4b589f04a4e1a2$export$2e2bcd8739ae039), {})
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef94978f68775b91$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: managedOrgSearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: managedOrgSearch.handleNext,
                    onPrevious: managedOrgSearch.handlePrevious,
                    disableNext: !managedOrgSearch.showNext,
                    disablePrevious: !managedOrgSearch.showPrevious
                })
            })
        ]
    });
}



function $776f18f1a04f38af$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.managed.titlePlural'),
                description: t('common:organization.managed.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b468ed531a071225$export$2e2bcd8739ae039), {})
        ]
    });
}


















var $7fPBF = parcelRequire("7fPBF");

function $6a0a6661c03aa7cb$export$94554b1f485b23fb() {
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const organizationMembers = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.organizationMembers);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.organizationMembers);
    const members = (0, $7fPBF.useMemo)(()=>{
        var _organizationMembers_find;
        if (!organizationId) return null;
        var _organizationMembers_find_members;
        return (_organizationMembers_find_members = (_organizationMembers_find = organizationMembers.find((org)=>org.organizationId === organizationId)) === null || _organizationMembers_find === void 0 ? void 0 : _organizationMembers_find.members) !== null && _organizationMembers_find_members !== void 0 ? _organizationMembers_find_members : [];
    }, [
        organizationId,
        organizationMembers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function fetchMembers() {
            if (!organizationId || (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.organizationMembers == true) return;
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('organizationMembers', true);
            const org = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().organizationMembers.find((org)=>org.organizationId === organizationId);
            if ((org === null || org === void 0 ? void 0 : org.members) && org.members.length > 0) {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('organizationMembers', false);
                return;
            }
            try {
                const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadOrganizationMembers(organizationId);
                if ((result === null || result === void 0 ? void 0 : result.resultType) !== 'Ok') console.error('Failed to load members for organization:', organizationId);
            } catch (error) {
                console.error('Error loading members.');
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('organizationMembers', false);
            }
        }
        fetchMembers();
    }, [
        organizationId
    ]);
    return {
        members: members,
        isLoading: isLoading
    };
}





var $7fPBF = parcelRequire("7fPBF");






function $25a74ed7bce48d01$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const organizationMembers = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.organizationMembers);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.organizationMembers);
    const orgMembersSearchContentId = 'org-members-search';
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    const members = (0, $7fPBF.useMemo)(()=>{
        var _organizationMembers_find;
        if (!currentOrg) return null;
        var _organizationMembers_find_members;
        return (_organizationMembers_find_members = (_organizationMembers_find = organizationMembers.find((org)=>org.organizationId === currentOrg.id)) === null || _organizationMembers_find === void 0 ? void 0 : _organizationMembers_find.members) !== null && _organizationMembers_find_members !== void 0 ? _organizationMembers_find_members : [];
    }, [
        currentOrg,
        organizationMembers
    ]);
    (0, $d856e666394c520b$export$2e2bcd8739ae039)(orgMembersSearchContentId, [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>organizationMembers.length >= displayLimit, [
        organizationMembers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, (0, $da83796f61485d54$export$a954cbc46095ce6a));
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        const count = organizationMembers.length;
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: displayLimit + ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0)
            });
        });
    };
    const handlePrevious = ()=>{
        const count = organizationMembers.length;
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: Math.max(0, ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0) - displayLimit)
            });
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if ((0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.organizationMembers) return;
            if (!currentOrg) return;
            try {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('organizationMembers', true);
                await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadOrganizationMembers(currentOrg.id, debouncedQuery);
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.member.loadError'));
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('organizationMembers', false);
            }
        };
        trySearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedQuery
    ]);
    return {
        results: members,
        orgMembersSearchContentId: orgMembersSearchContentId,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        isLoading: isLoading
    };
}

















var $7fPBF = parcelRequire("7fPBF");







function $82c7f1922904df08$export$2e2bcd8739ae039({ member: member, hideWrapper: hideWrapper }) {
    var _member_user, _member_user1, _member_user2, _member_user3, _member_user4, _member_user5;
    if (!member) return null;
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a387e7d4ce3b8793$export$7c14887e48a97962), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$b59bdbef9ce70de2), {
                children: ((_member_user = member.user) === null || _member_user === void 0 ? void 0 : _member_user.firstName) && ((_member_user1 = member.user) === null || _member_user1 === void 0 ? void 0 : _member_user1.lastName) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                            icon: "user",
                            title: ((_member_user2 = member.user) === null || _member_user2 === void 0 ? void 0 : _member_user2.firstName) + ' ' + ((_member_user3 = member.user) === null || _member_user3 === void 0 ? void 0 : _member_user3.lastName)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                            title: (_member_user4 = member.user) === null || _member_user4 === void 0 ? void 0 : _member_user4.email
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b6dbe5e3c17f869$export$2e2bcd8739ae039), {
                    icon: "user",
                    title: (_member_user5 = member.user) === null || _member_user5 === void 0 ? void 0 : _member_user5.email
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2427d6ebbf2e60fd$export$2e2bcd8739ae039), {
                role: (0, $d227fca458ea4785$export$68befc518ea2400f)(member)
            })
        ]
    });
    return hideWrapper ? content : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$54571ac7cbe36b70), {
        children: content
    });
}










var $7fPBF = parcelRequire("7fPBF");


function $ac753ef9bc704b1f$var$MemberEditDialog({ open: open, onClose: onClose, member: member, myRole: myRole }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [editMember, setEditMember] = (0, $7fPBF.useState)(member);
    const [role, setRole] = (0, $7fPBF.useState)((0, $d227fca458ea4785$export$68befc518ea2400f)(member));
    (0, $7fPBF.useEffect)(()=>{
        setEditMember(member);
        setRole((0, $d227fca458ea4785$export$68befc518ea2400f)(member));
    }, [
        member
    ]);
    const handleRoleChange = (updatedRole)=>{
        setRole(updatedRole);
        setEditMember((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, editMember, updatedRole));
    };
    const handleSave = async ()=>{
        var _editMember_user, _editMember_user1;
        const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().updateMemberRole(editMember.organizationId, editMember.id, role);
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.member.updated', 'Member updated successfully', {
            value: (_editMember_user = editMember.user) === null || _editMember_user === void 0 ? void 0 : _editMember_user.email
        }));
        else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.member.error', 'Error updating member', {
            value: (_editMember_user1 = editMember.user) === null || _editMember_user1 === void 0 ? void 0 : _editMember_user1.email
        }));
        onClose();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.member.edit'),
        onConfirm: handleSave,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82c7f1922904df08$export$2e2bcd8739ae039), {
                member: editMember
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $777249ad5835b0ee$export$2e2bcd8739ae039), {
                myRole: myRole,
                role: role,
                onChange: handleRoleChange
            })
        ]
    });
}
var $ac753ef9bc704b1f$export$2e2bcd8739ae039 = $ac753ef9bc704b1f$var$MemberEditDialog;


function $db35b665e17b7e03$export$2e2bcd8739ae039({ myRole: myRole, member: member, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showEditDialog, setShowEditDialog] = (0, $7fPBF.useState)(false);
    const [showRemoveDialog, setShowRemoveDialog] = (0, $7fPBF.useState)(false);
    const handleEdit = ()=>{
        setShowEditDialog(true);
    };
    const handleCancelEdit = ()=>{
        setShowEditDialog(false);
    };
    const handleRemove = ()=>{
        setShowRemoveDialog(true);
    };
    const handleCancelRemove = ()=>{
        setShowRemoveDialog(false);
    };
    const handleConfirmRemoveMember = async ()=>{
        if (organizationId && (myRole.canRemoveMembers || myRole.isAdmin) && member.id) {
            var _member_user, _member_user1;
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().removeMember(organizationId, member.id);
            if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.member.delete', 'Member removed successfully', {
                value: (_member_user = member.user) === null || _member_user === void 0 ? void 0 : _member_user.email
            }));
            else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.member.deleteError', 'Error deleting member', {
                value: (_member_user1 = member.user) === null || _member_user1 === void 0 ? void 0 : _member_user1.email
            }));
        }
        setShowRemoveDialog(false);
    };
    if (!member || !myRole) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (myRole.canChangeMemberPermissions || myRole.isAdmin) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "text",
                        startIcon: "orgPermissions",
                        onClick: ()=>handleEdit(),
                        children: t('common:edit')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac753ef9bc704b1f$export$2e2bcd8739ae039), {
                        myRole: myRole,
                        open: showEditDialog,
                        member: member,
                        onClose: handleCancelEdit
                    })
                ]
            }),
            (myRole.canRemoveMembers || myRole.isAdmin) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "negative",
                        startIcon: "cancel2",
                        onClick: handleRemove,
                        children: t('common:organization.canRemoveMembers.action')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                        open: showRemoveDialog,
                        onConfirm: handleConfirmRemoveMember,
                        onCancel: handleCancelRemove,
                        onClose: handleCancelRemove,
                        title: t('common:organization.canRemoveMembers.confirm'),
                        confirmButtonText: t('common:organization.canRemoveMembers.titleSingle'),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82c7f1922904df08$export$2e2bcd8739ae039), {
                                member: member
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                                children: t('common:organization.canRemoveMembers.confirmLong')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






function $87483011d84430aa$export$2e2bcd8739ae039({ myRole: myRole, member: member, organizationId: organizationId }) {
    if (!member || !myRole.canViewMembers) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$a27f3c48b2f1c458), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9de46b28c4f6c978), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$c14c794fcd73bed8), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                    name: member.isAdmin ? (0, $5d595f963199dd48$export$f45ccdad2e79cfb4).isAdmin : 'user',
                                    size: 35
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$68b378fffb2ccca3), {
                                    children: member.user.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac3fc121a11fd783$export$2b64bc092bad4151), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db35b665e17b7e03$export$2e2bcd8739ae039), {
                                myRole: myRole,
                                member: member,
                                organizationId: organizationId
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a387e7d4ce3b8793$export$78b81e628c724207), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2427d6ebbf2e60fd$export$2e2bcd8739ae039), {
                        variant: "listOnly",
                        role: (0, $d227fca458ea4785$export$68befc518ea2400f)(member)
                    })
                })
            ]
        })
    });
}


function $1a021e4109b31685$export$2e2bcd8739ae039() {
    var _membersSearch_results, _membersSearch_results1;
    const { currentOrg: currentOrg, hasSomeMemberEditPermissions: hasSomeMemberEditPermissions, isExpiredOrg: isExpiredOrg, canManageBilling: canManageBilling, canViewMembers: canViewMembers, membership: membership, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { isLoading: isLoading } = (0, $6a0a6661c03aa7cb$export$94554b1f485b23fb)();
    const membersSearch = (0, $25a74ed7bce48d01$export$2e2bcd8739ae039)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    var _membersSearch_results_length;
    const hasResults = ((_membersSearch_results_length = (_membersSearch_results = membersSearch.results) === null || _membersSearch_results === void 0 ? void 0 : _membersSearch_results.length) !== null && _membersSearch_results_length !== void 0 ? _membersSearch_results_length : 0) > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg || !membership) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    if (!(hasSomeMemberEditPermissions || canViewMembers)) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: membersSearch.searchQuery,
                onChange: (e)=>membersSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>membersSearch.handleSearchQueryChange('')
            }),
            hasResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:results'),
                variant: "small"
            }),
            hasResults ? (_membersSearch_results1 = membersSearch.results) === null || _membersSearch_results1 === void 0 ? void 0 : _membersSearch_results1.map((member)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $87483011d84430aa$export$2e2bcd8739ae039), {
                    member: member,
                    myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                    organizationId: currentOrg.id
                }, member.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $07e53c7e95507174$export$2e2bcd8739ae039), {
                myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                organizationId: currentOrg.id
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: !membersSearch.results || membersSearch.results.length == 0,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: membersSearch.handleNext,
                    onPrevious: membersSearch.handlePrevious,
                    disableNext: !membersSearch.showNext,
                    disablePrevious: !membersSearch.showPrevious
                })
            })
        ]
    });
}






function $e25675874c945d68$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, membership: membership, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.member.orgTitle', {
                    value: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name
                }),
                description: t('common:organization.member.description'),
                items: items,
                children: currentOrg && !isExpiredOrg && currentOrg.id && membership && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24d7412693118a64$export$2e2bcd8739ae039), {
                    myRole: (0, $d227fca458ea4785$export$68befc518ea2400f)(membership),
                    organizationId: currentOrg.id
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a021e4109b31685$export$2e2bcd8739ae039), {})
        ]
    });
}













var $7fPBF = parcelRequire("7fPBF");



function $b0d3bd00e0c0516d$export$f2439d77aeb75ed4() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const orgProducts = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgProducts);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.products);
    (0, $7fPBF.useEffect)(()=>{
        async function initializeOrgProducts() {
            if (!organizationId || (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.products == true) return;
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('products', true);
            const product = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().orgProducts.find((p)=>p.organizationId === organizationId);
            if (product) {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('products', false);
                return;
            }
            try {
                await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrganizationProducts(organizationId, i18n.language);
            } catch (error) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:license.key.product.error.title'));
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('products', false);
            }
        }
        initializeOrgProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        organizationId
    ]);
    return {
        orgProducts: orgProducts,
        isLoading: isLoading
    };
}






var $7fPBF = parcelRequire("7fPBF");






function $64ed74c65dc8427b$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const orgProducts = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgProducts);
    const defaultTake = 51;
    const displayLimit = defaultTake - 1;
    const [searchQuery, setSearchQuery] = (0, $7fPBF.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)({
        searchText: '',
        skip: 0,
        take: defaultTake
    });
    (0, $d856e666394c520b$export$2e2bcd8739ae039)((0, $14e4f1609944ac39$export$18d6475ce2e9bfe8), [
        debouncedQuery.skip
    ]);
    function handleSearchQueryChange(value) {
        setSearchQuery(value);
    }
    const showPrevious = (0, $7fPBF.useMemo)(()=>debouncedQuery.skip && debouncedQuery.skip > 0, [
        debouncedQuery.skip
    ]);
    const showNext = (0, $7fPBF.useMemo)(()=>orgProducts.length >= displayLimit, [
        orgProducts
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const newQuery = {
                searchText: searchQuery,
                skip: 0,
                take: defaultTake
            };
            if (newQuery.searchText !== debouncedQuery.searchText) setDebouncedQuery(newQuery);
        }, (0, $da83796f61485d54$export$a954cbc46095ce6a));
        return ()=>clearTimeout(timeoutId);
    }, [
        searchQuery
    ]);
    const handleNext = ()=>{
        const count = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().orgManagedLicenseKeys.length;
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: displayLimit + ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0)
            });
        });
    };
    const handlePrevious = ()=>{
        const count = orgProducts.length;
        setDebouncedQuery((prev)=>{
            var _prev_skip;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                take: defaultTake,
                skip: Math.max(0, ((_prev_skip = prev.skip) !== null && _prev_skip !== void 0 ? _prev_skip : 0) - displayLimit)
            });
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        const trySearch = async ()=>{
            if ((0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.products || !organizationId) return;
            try {
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('products', true);
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrganizationProducts(organizationId, i18n.language, debouncedQuery);
            } catch (e) {
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:license.key.product.error.title'));
            } finally{
                (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('products', false);
            }
        };
        trySearch();
    }, [
        debouncedQuery
    ]);
    return {
        results: orgProducts,
        handleSearchQueryChange: handleSearchQueryChange,
        searchQuery: searchQuery,
        showPrevious: showPrevious,
        showNext: showNext,
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        loadingData: (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().loadingData.licenseKeys,
        displayLimit: displayLimit
    };
}











let $93eaee6431a08e4f$var$_ = (t)=>t, $93eaee6431a08e4f$var$t, $93eaee6431a08e4f$var$t1;
function $93eaee6431a08e4f$export$2e2bcd8739ae039({ orgProduct: orgProduct }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const match = orgProduct.product.billingCycle && orgProduct.product.billingCycle.match(/(\d+)\.\d{2}:\d{2}:\d{2}/);
    const days = match ? parseInt(match[1]) : null;
    const years = days ? Math.floor(days / 365) : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($93eaee6431a08e4f$var$StyledCardMedium, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($93eaee6431a08e4f$var$StyledIconWrap, {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039), {
                    licenseType: (0, $427978696205d868$export$5122f57547dc8eca)(orgProduct.product),
                    size: 200
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$2c65789109b698b0), {
                children: orgProduct.product.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t(`common:license.key.product.${orgProduct.product.billingType}.title`)
            }),
            years && years == 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:license.key.product.yearly')
            }),
            years && years > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:license.key.product.years', {
                    value: years
                })
            }),
            days && !years && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: t('common:license.key.product.days', {
                    value: days
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: orgProduct.product.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                to: `/org/${orgProduct.organizationId}/product/${orgProduct.productId}`,
                $color: "subsection",
                endIcon: "externalLink",
                children: t('common:license.key.product.titleLong')
            })
        ]
    });
}
const $93eaee6431a08e4f$var$StyledIconWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$f2e4196c0d2b5bb8))($93eaee6431a08e4f$var$t || ($93eaee6431a08e4f$var$t = $93eaee6431a08e4f$var$_`
    padding: 0 0;
    min-height: auto;
    align-items: flex-start;
`));
const $93eaee6431a08e4f$var$StyledCardMedium = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$1056953590c5547a))($93eaee6431a08e4f$var$t1 || ($93eaee6431a08e4f$var$t1 = $93eaee6431a08e4f$var$_`
    align-items: flex-start;
    max-height: fit-content;
`));





function $0895a725638fbacf$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:license.key.product.empty.description'),
        fullHeight: true,
        title: t('common:license.key.product.empty.title')
    });
}


function $32a219db9065feb1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $b0d3bd00e0c0516d$export$f2439d77aeb75ed4)(); //initialize
    const orgProductSearch = (0, $64ed74c65dc8427b$export$2e2bcd8739ae039)(); //search
    const hasResults = (orgProductSearch === null || orgProductSearch === void 0 ? void 0 : orgProductSearch.results.length) > 0;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                value: orgProductSearch.searchQuery,
                onChange: (e)=>orgProductSearch.handleSearchQueryChange(e.target.value),
                onClear: ()=>orgProductSearch.handleSearchQueryChange('')
            }),
            hasResults ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$8ffb7ce587ade322), {
                children: orgProductSearch.results.map((orgProduct)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $93eaee6431a08e4f$export$2e2bcd8739ae039), {
                        orgProduct: orgProduct
                    }, orgProduct.id))
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0895a725638fbacf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$7df9baccf69a86b2), {
                $visuallyHide: orgProductSearch.results.length == 0 || orgProductSearch.results.length < orgProductSearch.displayLimit,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7ac331879f72d98$export$2e2bcd8739ae039), {
                    onNext: orgProductSearch.handleNext,
                    onPrevious: orgProductSearch.handlePrevious,
                    disableNext: !orgProductSearch.showNext,
                    disablePrevious: !orgProductSearch.showPrevious
                })
            })
        ]
    });
}




function $d391d99bd393b0cc$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:license.key.product.titleLong'),
                description: t('common:license.key.product.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32a219db9065feb1$export$2e2bcd8739ae039), {})
        ]
    });
}










// StaggeredReveal.tsx



let $19758d730238f0ed$export$491112666e282270 = ()=>{};
let $19758d730238f0ed$export$f5708dca728d7177 = ()=>{};
var $19758d730238f0ed$var$check, $19758d730238f0ed$var$message, $19758d730238f0ed$var$errorCode, $19758d730238f0ed$var$check1, $19758d730238f0ed$var$message1, $19758d730238f0ed$var$errorCode1;


const $8e08dd08a6f8a76d$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $8e08dd08a6f8a76d$export$9de1236619d9e756 = /*@__PURE__*/ $8e08dd08a6f8a76d$var$checkStringStartsWith("--");
const $8e08dd08a6f8a76d$var$startsAsVariableToken = /*@__PURE__*/ $8e08dd08a6f8a76d$var$checkStringStartsWith("var(--");
const $8e08dd08a6f8a76d$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $8e08dd08a6f8a76d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $8e08dd08a6f8a76d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $8e08dd08a6f8a76d$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}


/**
 * Generate a list of every possible transform key.
 */ const $36437dbf5b93c477$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ const $36437dbf5b93c477$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set([
        ...$36437dbf5b93c477$export$280dc01950909d86,
        "pathRotation"
    ]))();


const $f0207664133f4738$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $f0207664133f4738$var$rotate = (v)=>{
    const angle = $f0207664133f4738$var$radToDeg(Math.atan2(v[1], v[0]));
    return $f0207664133f4738$var$rebaseAngle(angle);
};
const $f0207664133f4738$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $f0207664133f4738$var$rotate,
    rotateZ: $f0207664133f4738$var$rotate,
    skewX: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $f0207664133f4738$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $f0207664133f4738$var$rotateZ = $f0207664133f4738$var$rotate;
const $f0207664133f4738$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $f0207664133f4738$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $f0207664133f4738$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $f0207664133f4738$var$scaleX,
    scaleY: $f0207664133f4738$var$scaleY,
    scale: (v)=>($f0207664133f4738$var$scaleX(v) + $f0207664133f4738$var$scaleY(v)) / 2,
    rotateX: (v)=>$f0207664133f4738$var$rebaseAngle($f0207664133f4738$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$f0207664133f4738$var$rebaseAngle($f0207664133f4738$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $f0207664133f4738$var$rotateZ,
    rotate: $f0207664133f4738$var$rotateZ,
    skewX: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $f0207664133f4738$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $f0207664133f4738$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $f0207664133f4738$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(RegExp("^matrix3d\\(([-\\d.e\\s,]+)\\)$", "u"));
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $f0207664133f4738$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(RegExp("^matrix\\(([-\\d.e\\s,]+)\\)$", "u"));
        parsers = $f0207664133f4738$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $f0207664133f4738$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($f0207664133f4738$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $f0207664133f4738$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $f0207664133f4738$export$f9111f9e16b73a26(transform, name);
};
function $f0207664133f4738$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $fd94cc0f2e3ce586$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $fd94cc0f2e3ce586$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $fd94cc0f2e3ce586$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $98312100572e3dbc$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $8f62b661d366a749$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $8f62b661d366a749$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$8f62b661d366a749$var$isIdentityScale(scale) || !$8f62b661d366a749$var$isIdentityScale(scaleX) || !$8f62b661d366a749$var$isIdentityScale(scaleY);
}
function $8f62b661d366a749$export$a545127cf1fbb600(values) {
    return $8f62b661d366a749$export$bdf30dca883ea463(values) || $8f62b661d366a749$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $8f62b661d366a749$export$bf80f5f8f4dc327f(values) {
    return $8f62b661d366a749$var$is2DTranslate(values.x) || $8f62b661d366a749$var$is2DTranslate(values.y);
}
function $8f62b661d366a749$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $0043a8a3eeedd876$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $0043a8a3eeedd876$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $0043a8a3eeedd876$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $0043a8a3eeedd876$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $0043a8a3eeedd876$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $0043a8a3eeedd876$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $0043a8a3eeedd876$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $0043a8a3eeedd876$export$d80074982803af5c(box, { x: x, y: y }) {
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $0043a8a3eeedd876$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        var _node_layout;
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $0043a8a3eeedd876$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $0043a8a3eeedd876$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $0043a8a3eeedd876$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $8f62b661d366a749$export$a545127cf1fbb600)(node.latestValues)) $0043a8a3eeedd876$export$58b16271041fbfb(box, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX && treeScale.x > $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX && treeScale.y > $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $0043a8a3eeedd876$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $0043a8a3eeedd876$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $0043a8a3eeedd876$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $0043a8a3eeedd876$export$58b16271041fbfb(box, transform, sourceBox) {
    const resolveBox = sourceBox !== null && sourceBox !== void 0 ? sourceBox : box;
    $0043a8a3eeedd876$export$625f1dd140a2f5e7(box.x, $0043a8a3eeedd876$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $0043a8a3eeedd876$export$625f1dd140a2f5e7(box.y, $0043a8a3eeedd876$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}


function $b3c78c86be367659$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $fd94cc0f2e3ce586$export$d3955c6a8f65a36b)((0, $fd94cc0f2e3ce586$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $b3c78c86be367659$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $b3c78c86be367659$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


const $61e12cc57eeb85ed$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $3686a9bc645641a9$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $36437dbf5b93c477$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $cad1ef5802f691e6$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};




const $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $d1e8a31585ea6048$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $d1e8a31585ea6048$export$58f0f39f63f3cf42 = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $d1e8a31585ea6048$export$98e628dec113755e), {
    transform: (v)=>(0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1, v)
});
const $d1e8a31585ea6048$export$dcdf75081b88279d = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $d1e8a31585ea6048$export$98e628dec113755e), {
    default: 1
});


/*#__NO_SIDE_EFFECTS__*/ 

const $f1a72de1b348da89$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $f1a72de1b348da89$export$41fc368e1a942b97 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("deg");
const $f1a72de1b348da89$export$626336c2cd4b14de = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("%");
const $f1a72de1b348da89$export$91c0eda1d06bf008 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("px");
const $f1a72de1b348da89$export$f91e8c45a95a32f2 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("vh");
const $f1a72de1b348da89$export$aed3d7b7d206c196 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("vw");
const $f1a72de1b348da89$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $f1a72de1b348da89$export$626336c2cd4b14de), {
        parse: (v)=>$f1a72de1b348da89$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$f1a72de1b348da89$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $c97168000d203dd0$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $a40f0a2352427e09$export$d176691c1998a1f5 = [
    (0, $d1e8a31585ea6048$export$98e628dec113755e),
    (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    (0, $f1a72de1b348da89$export$626336c2cd4b14de),
    (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    (0, $f1a72de1b348da89$export$aed3d7b7d206c196),
    (0, $f1a72de1b348da89$export$f91e8c45a95a32f2),
    (0, $cad1ef5802f691e6$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a40f0a2352427e09$export$eefdd52e3ccae428 = (v)=>$a40f0a2352427e09$export$d176691c1998a1f5.find((0, $c97168000d203dd0$export$6eae4d0a6a7ca7cd)(v));


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $162a1451c8fa55b4$export$65583ed5a868f2d9 = (v)=>RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $89d5513ff5a37480$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $89d5513ff5a37480$export$b9f0c1f373aee2b0(current) {
    const match = $89d5513ff5a37480$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $89d5513ff5a37480$var$maxDepth = 4;
function $89d5513ff5a37480$export$289398774300c991(current, element, depth = 1) {
    (0, $19758d730238f0ed$export$f5708dca728d7177)(depth <= $89d5513ff5a37480$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $89d5513ff5a37480$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $162a1451c8fa55b4$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $8e08dd08a6f8a76d$export$31f9caa2600b5723)(fallback) ? $89d5513ff5a37480$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $08d1bfadb48645d9$export$5a98a90409277f5a(keyframes) {
    var _keyframes_i;
    for(let i = 1; i < keyframes.length; i++)(_keyframes_i = keyframes[i]) !== null && _keyframes_i !== void 0 ? _keyframes_i : keyframes[i] = keyframes[i - 1];
}






const $8f9fb54630ee1595$export$8e5250d1aa9bf370 = (v)=>v === (0, $d1e8a31585ea6048$export$98e628dec113755e) || v === (0, $f1a72de1b348da89$export$91c0eda1d06bf008);
const $8f9fb54630ee1595$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $8f9fb54630ee1595$var$nonTranslationalTransformKeys = (0, $36437dbf5b93c477$export$280dc01950909d86).filter((key)=>!$8f9fb54630ee1595$var$transformKeys.has(key));
function $8f9fb54630ee1595$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $8f9fb54630ee1595$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $8f9fb54630ee1595$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0", boxSizing: boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0", boxSizing: boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $f0207664133f4738$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $f0207664133f4738$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$8f9fb54630ee1595$export$781d46a8aa670d52.translateX = $8f9fb54630ee1595$export$781d46a8aa670d52.x;
$8f9fb54630ee1595$export$781d46a8aa670d52.translateY = $8f9fb54630ee1595$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $69d49105ec21595d$export$8793edee2d425525 = (any)=>any;


const $877fe7d159c5dd4c$export$dd826089e3c5e502 = {};


const $6df534696c4af587$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


function $22c8543101d08652$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $ebdeb8cab5a1d6c2$var$maxElapsed = 40;
function $ebdeb8cab5a1d6c2$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $6df534696c4af587$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $22c8543101d08652$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $ebdeb8cab5a1d6c2$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $6df534696c4af587$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $6df534696c4af587$export$71ecace0a033b35a).length; i++)steps[(0, $6df534696c4af587$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $44c600a9437aff7c$export$2cef06c20297c17d, cancel: $44c600a9437aff7c$export$ec99c0ef4978dccb, state: $44c600a9437aff7c$export$fff89137e9e818ce, steps: $44c600a9437aff7c$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $ebdeb8cab5a1d6c2$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $69d49105ec21595d$export$8793edee2d425525), true);


const $cf13d99b8a449fd0$var$toResolve = new Set();
let $cf13d99b8a449fd0$var$isScheduled = false;
let $cf13d99b8a449fd0$var$anyNeedsMeasurement = false;
let $cf13d99b8a449fd0$var$isForced = false;
function $cf13d99b8a449fd0$var$measureAllKeyframes() {
    if ($cf13d99b8a449fd0$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($cf13d99b8a449fd0$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $8f9fb54630ee1595$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _element_getValue;
                (_element_getValue = element.getValue(key)) === null || _element_getValue === void 0 ? void 0 : _element_getValue.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $cf13d99b8a449fd0$var$anyNeedsMeasurement = false;
    $cf13d99b8a449fd0$var$isScheduled = false;
    $cf13d99b8a449fd0$var$toResolve.forEach((resolver)=>resolver.complete($cf13d99b8a449fd0$var$isForced));
    $cf13d99b8a449fd0$var$toResolve.clear();
}
function $cf13d99b8a449fd0$var$readAllKeyframes() {
    $cf13d99b8a449fd0$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $cf13d99b8a449fd0$var$anyNeedsMeasurement = true;
    });
}
function $cf13d99b8a449fd0$export$78b96d2a12593b05() {
    $cf13d99b8a449fd0$var$isForced = true;
    $cf13d99b8a449fd0$var$readAllKeyframes();
    $cf13d99b8a449fd0$var$measureAllKeyframes();
    $cf13d99b8a449fd0$var$isForced = false;
}
class $cf13d99b8a449fd0$export$74d34ca3182f1750 {
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $cf13d99b8a449fd0$var$toResolve.add(this);
            if (!$cf13d99b8a449fd0$var$isScheduled) {
                $cf13d99b8a449fd0$var$isScheduled = true;
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).read($cf13d99b8a449fd0$var$readAllKeyframes);
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).resolveKeyframes($cf13d99b8a449fd0$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $08d1bfadb48645d9$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $cf13d99b8a449fd0$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $cf13d99b8a449fd0$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $410126928ba5c7af$export$ade84c85e44a6cb1 = (v)=>RegExp("^0[^.\\s]+$", "u").test(v);


function $42f46c117bba2041$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $410126928ba5c7af$export$ade84c85e44a6cb1)(value);
    else return true;
}






// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $76d9043daec1d091$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $8d7fedef37ba0db5$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");


function $b64c9e190d2d6cd7$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $9148c009abbebc0f$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $e8d29973fdcfed04$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $9148c009abbebc0f$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $b64c9e190d2d6cd7$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e8d29973fdcfed04$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $8d7fedef37ba0db5$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $ff7a2ec6f726704e$var$clampRgbUnit = (v)=>(0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 255, v);
const $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d1e8a31585ea6048$export$98e628dec113755e)), {
    transform: (v)=>Math.round($ff7a2ec6f726704e$var$clampRgbUnit(v))
});
const $ff7a2ec6f726704e$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(red) + ", " + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(green) + ", " + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)((0, $d1e8a31585ea6048$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $90a7f54b29f1453c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $90a7f54b29f1453c$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$2c8400d58aca05e)("#"),
    parse: $90a7f54b29f1453c$var$parseHex,
    transform: (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).transform
};






const $f6f2a31cd5829bc5$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $f1a72de1b348da89$export$626336c2cd4b14de).transform((0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $f1a72de1b348da89$export$626336c2cd4b14de).transform((0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)((0, $d1e8a31585ea6048$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d252968ea52f42fd$export$35e9368ef982300f = {
    test: (v)=>(0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).test(v) || (0, $90a7f54b29f1453c$export$834dfc94dde4b3d8).test(v) || (0, $f6f2a31cd5829bc5$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).test(v)) return (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $f6f2a31cd5829bc5$export$810b04175080204c).test(v)) return (0, $f6f2a31cd5829bc5$export$810b04175080204c).parse(v);
        else return (0, $90a7f54b29f1453c$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).transform(v) : (0, $f6f2a31cd5829bc5$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $d252968ea52f42fd$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $d252968ea52f42fd$export$35e9368ef982300f.transform(parsed);
    }
};


const $391b60cd5158e163$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");




function $ce3767268d4e9ade$var$test(v) {
    var _v_match, _v_match1;
    return isNaN(v) && typeof v === "string" && (((_v_match = v.match((0, $8d7fedef37ba0db5$export$2444ca58c08448e4))) === null || _v_match === void 0 ? void 0 : _v_match.length) || 0) + (((_v_match1 = v.match((0, $391b60cd5158e163$export$740b69c5fad25dba))) === null || _v_match1 === void 0 ? void 0 : _v_match1.length) || 0) > 0;
}
const $ce3767268d4e9ade$var$NUMBER_TOKEN = "number";
const $ce3767268d4e9ade$var$COLOR_TOKEN = "color";
const $ce3767268d4e9ade$var$VAR_TOKEN = "var";
const $ce3767268d4e9ade$var$VAR_FUNCTION_TOKEN = "var(";
const $ce3767268d4e9ade$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $ce3767268d4e9ade$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $ce3767268d4e9ade$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($ce3767268d4e9ade$var$complexRegex, (parsedValue)=>{
        if ((0, $d252968ea52f42fd$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($ce3767268d4e9ade$var$COLOR_TOKEN);
            values.push((0, $d252968ea52f42fd$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($ce3767268d4e9ade$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($ce3767268d4e9ade$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($ce3767268d4e9ade$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $ce3767268d4e9ade$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($ce3767268d4e9ade$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $ce3767268d4e9ade$var$parseComplexValue(v) {
    return $ce3767268d4e9ade$export$b61fc7c44bf646d5(v).values;
}
function $ce3767268d4e9ade$var$buildTransformer({ split: split, types: types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $ce3767268d4e9ade$var$NUMBER_TOKEN) output += (0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $ce3767268d4e9ade$var$COLOR_TOKEN) output += (0, $d252968ea52f42fd$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $ce3767268d4e9ade$var$createTransformer(source) {
    return $ce3767268d4e9ade$var$buildTransformer($ce3767268d4e9ade$export$b61fc7c44bf646d5(source));
}
const $ce3767268d4e9ade$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $d252968ea52f42fd$export$35e9368ef982300f).test(v) ? (0, $d252968ea52f42fd$export$35e9368ef982300f).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const $ce3767268d4e9ade$var$convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return (splitBefore === null || splitBefore === void 0 ? void 0 : splitBefore.trim().endsWith("/")) ? value : 0;
    return $ce3767268d4e9ade$var$convertNumbersToZero(value);
};
function $ce3767268d4e9ade$var$getAnimatableNone(v) {
    const info = $ce3767268d4e9ade$export$b61fc7c44bf646d5(v);
    const transformer = $ce3767268d4e9ade$var$buildTransformer(info);
    return transformer(info.values.map((value, i)=>$ce3767268d4e9ade$var$convertToZero(value, info.split[i])));
}
const $ce3767268d4e9ade$export$83a0e34f1302825b = {
    test: $ce3767268d4e9ade$var$test,
    parse: $ce3767268d4e9ade$var$parseComplexValue,
    createTransformer: $ce3767268d4e9ade$var$createTransformer,
    getAnimatableNone: $ce3767268d4e9ade$var$getAnimatableNone
};







/**
 * Properties that should default to 1 or 100%
 */ const $5eadb906d7cb4f97$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $5eadb906d7cb4f97$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $8d7fedef37ba0db5$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $5eadb906d7cb4f97$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $5eadb906d7cb4f97$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
const $5eadb906d7cb4f97$export$3dea766d36a8935f = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $ce3767268d4e9ade$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($5eadb906d7cb4f97$var$functionRegex);
        return functions ? functions.map($5eadb906d7cb4f97$var$applyDefaultFilter).join(" ") : v;
    }
});





const $68dbe71415cdbee1$export$d99f0801a68bbcf1 = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $ce3767268d4e9ade$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const parsed = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).parse(v);
        const transformer = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, v), {
                alpha: 1
            }) : v));
    }
});












const $8e24186f0b4b6a11$export$7d260a2a5f8bc19e = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d1e8a31585ea6048$export$98e628dec113755e)), {
    transform: Math.round
});






const $134d2ed44a1eadc8$export$f2e4285fee37e26 = {
    rotate: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    rotateX: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    rotateY: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    rotateZ: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    scale: $d1e8a31585ea6048$export$dcdf75081b88279d,
    scaleX: (0, $d1e8a31585ea6048$export$dcdf75081b88279d),
    scaleY: (0, $d1e8a31585ea6048$export$dcdf75081b88279d),
    scaleZ: (0, $d1e8a31585ea6048$export$dcdf75081b88279d),
    skew: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    skewX: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    skewY: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    distance: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    translateX: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    translateY: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    translateZ: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    x: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    y: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    z: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    perspective: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    transformPerspective: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    opacity: (0, $d1e8a31585ea6048$export$58f0f39f63f3cf42),
    originX: (0, $f1a72de1b348da89$export$44e2e1705876d7ed),
    originY: (0, $f1a72de1b348da89$export$44e2e1705876d7ed),
    originZ: (0, $f1a72de1b348da89$export$91c0eda1d06bf008)
};


const $d954abda96ea0996$export$eec14432cd1cb67b = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
    // Border props
    borderWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderTopWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderRightWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    maxWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    height: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    maxHeight: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    top: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    right: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    bottom: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    left: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    inset: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetBlock: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetBlockStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetBlockEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetInline: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetInlineStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetInlineEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingTop: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingRight: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBottom: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingLeft: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBlock: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBlockStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBlockEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingInline: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingInlineStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingInlineEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    margin: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginTop: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginRight: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBottom: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginLeft: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBlock: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBlockStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBlockEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginInline: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginInlineStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginInlineEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Typography
    fontSize: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $f1a72de1b348da89$export$91c0eda1d06bf008)
}, (0, $134d2ed44a1eadc8$export$f2e4285fee37e26)), {
    zIndex: (0, $8e24186f0b4b6a11$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $d1e8a31585ea6048$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $d1e8a31585ea6048$export$58f0f39f63f3cf42),
    numOctaves: (0, $8e24186f0b4b6a11$export$7d260a2a5f8bc19e)
});


/**
 * A map of default value types for common values
 */ const $4f34bdc9b52d7b1d$export$98cd7c72c5a731fb = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d954abda96ea0996$export$eec14432cd1cb67b)), {
    color: // Color props
    $d252968ea52f42fd$export$35e9368ef982300f,
    backgroundColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    outlineColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    fill: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    stroke: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderTopColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderRightColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderBottomColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderLeftColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    filter: $5eadb906d7cb4f97$export$3dea766d36a8935f,
    WebkitFilter: (0, $5eadb906d7cb4f97$export$3dea766d36a8935f),
    mask: $68dbe71415cdbee1$export$d99f0801a68bbcf1,
    WebkitMask: (0, $68dbe71415cdbee1$export$d99f0801a68bbcf1)
});
/**
 * Gets the default ValueType for the provided value key
 */ const $4f34bdc9b52d7b1d$export$67d1babe0338d23b = (key)=>$4f34bdc9b52d7b1d$export$98cd7c72c5a731fb[key];


const $a6324f331d30f12e$var$customTypes = /*@__PURE__*/ new Set([
    (0, $5eadb906d7cb4f97$export$3dea766d36a8935f),
    (0, $68dbe71415cdbee1$export$d99f0801a68bbcf1)
]);
function $a6324f331d30f12e$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $4f34bdc9b52d7b1d$export$67d1babe0338d23b)(key);
    if (!$a6324f331d30f12e$var$customTypes.has(defaultValueType)) defaultValueType = (0, $ce3767268d4e9ade$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $b33deb06f6bb5c07$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $b33deb06f6bb5c07$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$b33deb06f6bb5c07$var$invalidTemplates.has(keyframe) && (0, $ce3767268d4e9ade$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $a6324f331d30f12e$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $6543679a34c2f697$export$4983792d11b61017 extends (0, $cf13d99b8a449fd0$export$74d34ca3182f1750) {
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $8e08dd08a6f8a76d$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $89d5513ff5a37480$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $3686a9bc645641a9$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $a40f0a2352427e09$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $a40f0a2352427e09$export$eefdd52e3ccae428)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa)(origin);
        const targetHasVar = (0, $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa)(target);
        if (originHasVar !== targetHasVar && (0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $8f9fb54630ee1595$export$8e5250d1aa9bf370)(originType) && (0, $8f9fb54630ee1595$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $42f46c117bba2041$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $b33deb06f6bb5c07$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _this_removedTransforms;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_this_removedTransforms = this.removedTransforms) === null || _this_removedTransforms === void 0 ? void 0 : _this_removedTransforms.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
}




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $d17a7d2c2068c118$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $d17a7d2c2068c118$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

function $3fbb49f840f4b07a$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $3fbb49f840f4b07a$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $3fbb49f840f4b07a$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $530b27a3f7a9b181$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $3fbb49f840f4b07a$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}




const $1abad52e84ac08f3$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $0055d05149405828$export$37a5fde709c1db82(element, name, value) {
    (0, $1abad52e84ac08f3$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $373ae0ce1db34355$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $2e8f1cca8189061f$export$e3ad02c335474dee = {};


function $3361179f8f81e58e$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $373ae0ce1db34355$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _supportsFlags_supportsFlag;
        return (_supportsFlags_supportsFlag = (0, $2e8f1cca8189061f$export$e3ad02c335474dee)[supportsFlag]) !== null && _supportsFlags_supportsFlag !== void 0 ? _supportsFlags_supportsFlag : memoized();
    };
}


const $cf8d7908a6543c98$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $3361179f8f81e58e$export$1964673d5ec13c3a)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const $cf8d7908a6543c98$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $3361179f8f81e58e$export$1964673d5ec13c3a)(()=>window.ViewTimeline !== undefined, "viewTimeline");


const $fc831f8861054717$var$isNotNull = (value)=>value !== null;
function $fc831f8861054717$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($fc831f8861054717$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


class $6940fcbd8d4ca66f$export$655db786091c33e0 {
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
    constructor(){
        this.updateFinished();
    }
}


/*#__NO_SIDE_EFFECTS__*/ const $09983ccc000b48c8$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



const $ab271ab2951341fd$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $3361179f8f81e58e$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


const $0e9dc36f6f7cb032$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


const $6fd375bd8200fb33$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $7fa95de4cb88f140$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $5c7ca815419a9c0b$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $ab271ab2951341fd$export$866c1d07a1ac2ab)() ? (0, $0e9dc36f6f7cb032$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $09983ccc000b48c8$export$ff43f99925d7366b)(easing)) return (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$5c7ca815419a9c0b$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $7fa95de4cb88f140$export$2cf569f5e2221176).easeOut);
    else return (0, $7fa95de4cb88f140$export$2cf569f5e2221176)[easing];
}


function $583566263f64a846$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $5c7ca815419a9c0b$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    return element.animate(keyframeOptions, options);
}




function $7499953f74b707a4$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $53d8149960f311f6$export$a31269144d66b4a(_param) {
    var { type: type } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "type"
    ]);
    if ((0, $7499953f74b707a4$export$6ab7812f1bac68be)(type) && (0, $ab271ab2951341fd$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        var _options_duration;
        (_options_duration = options.duration) !== null && _options_duration !== void 0 ? _options_duration : options.duration = 300;
        var _options_ease;
        (_options_ease = options.ease) !== null && _options_ease !== void 0 ? _options_ease : options.ease = "easeOut";
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $d40de0a79038d88e$export$6c0f9803d8aa7219 extends (0, $6940fcbd8d4ca66f$export$655db786091c33e0) {
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        var _this_animation_finish, _this_animation;
        (_this_animation_finish = (_this_animation = this.animation).finish) === null || _this_animation_finish === void 0 ? void 0 : _this_animation_finish.call(_this_animation);
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        var _this_options, _this_animation_commitStyles, _this_animation;
        const element = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.element;
        if (!this.isPseudoElement && (element === null || element === void 0 ? void 0 : element.isConnected)) (_this_animation_commitStyles = (_this_animation = this.animation).commitStyles) === null || _this_animation_commitStyles === void 0 ? void 0 : _this_animation_commitStyles.call(_this_animation);
    }
    get duration() {
        var _this_animation_effect_getComputedTiming, _this_animation_effect;
        const duration = ((_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : (_this_animation_effect_getComputedTiming = _this_animation_effect.getComputedTiming) === null || _this_animation_effect_getComputedTiming === void 0 ? void 0 : _this_animation_effect_getComputedTiming.call(_this_animation_effect).duration) || 0;
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        var _this_manualStartTime;
        return (_this_manualStartTime = this.manualStartTime) !== null && _this_manualStartTime !== void 0 ? _this_manualStartTime : Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, rangeStart: rangeStart, rangeEnd: rangeEnd, observe: observe }) {
        var _this_animation_effect;
        if (this.allowFlatten) (_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : _this_animation_effect.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $cf8d7908a6543c98$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, $69d49105ec21595d$export$8793edee2d425525;
        } else return observe(this);
    }
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $19758d730238f0ed$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $53d8149960f311f6$export$a31269144d66b4a)(options);
        this.animation = (0, $583566263f64a846$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $fc831f8861054717$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $0055d05149405828$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            this.notifyFinished();
        };
    }
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $95afec150de2825d$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);



const { schedule: $4cb138f42ee448c1$export$bb76eed83315504c, cancel: $4cb138f42ee448c1$export$3252729004b8456e } = /* @__PURE__ */ (0, $ebdeb8cab5a1d6c2$export$510b0596a933801a)(queueMicrotask, false);




let $2a28679c5e08a25b$var$now;
function $2a28679c5e08a25b$var$clearTime() {
    $2a28679c5e08a25b$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $2a28679c5e08a25b$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($2a28679c5e08a25b$var$now === undefined) $2a28679c5e08a25b$export$2da9be4cfdb689b1.set((0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing || (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).useManualTiming ? (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp : performance.now());
        return $2a28679c5e08a25b$var$now;
    },
    set: (newTime)=>{
        $2a28679c5e08a25b$var$now = newTime;
        queueMicrotask($2a28679c5e08a25b$var$clearTime);
    }
};


const $a0d315cc230b7b79$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a0d315cc230b7b79$export$3d227df54007d73a = ()=>({
        x: $a0d315cc230b7b79$export$ff25708b37f72782(),
        y: $a0d315cc230b7b79$export$ff25708b37f72782()
    });
const $a0d315cc230b7b79$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a0d315cc230b7b79$export$6459fc9e86be362e = ()=>({
        x: $a0d315cc230b7b79$export$6db76765312617ac(),
        y: $a0d315cc230b7b79$export$6db76765312617ac()
    });


/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ const $53435ded96da5381$export$eab0632f7ad4f9d7 = (velocity, frameDuration)=>frameDuration ? velocity * (1000 / frameDuration) : 0;




/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $eba58299b894994c$var$MAX_VELOCITY_DELTA = 30;
const $eba58299b894994c$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $eba58299b894994c$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $eba58299b894994c$export$8cea36d14ee64562 {
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $eba58299b894994c$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $530b27a3f7a9b181$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $44c600a9437aff7c$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        var _this_events_change;
        (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($eba58299b894994c$export$67fcd818a264039d.current) $eba58299b894994c$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $eba58299b894994c$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $eba58299b894994c$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $53435ded96da5381$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        var _this_dependents, _this_events_destroy;
        (_this_dependents = this.dependents) === null || _this_dependents === void 0 ? void 0 : _this_dependents.clear();
        (_this_events_destroy = this.events.destroy) === null || _this_events_destroy === void 0 ? void 0 : _this_events_destroy.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                var _this_events_change;
                (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
}
function $eba58299b894994c$export$ce8bdc721e76545f(init, options) {
    return new $eba58299b894994c$export$8cea36d14ee64562(init, options);
}








/**
 * A list of all ValueTypes
 */ const $d47a0afa4e4d071c$var$valueTypes = [
    ...(0, $a40f0a2352427e09$export$d176691c1998a1f5),
    (0, $d252968ea52f42fd$export$35e9368ef982300f),
    (0, $ce3767268d4e9ade$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $d47a0afa4e4d071c$export$950e7e59ea1ffed7 = (v)=>$d47a0afa4e4d071c$var$valueTypes.find((0, $c97168000d203dd0$export$6eae4d0a6a7ca7cd)(v));



const $44b14b06958d6f59$export$bc2a978a17abfdde = new WeakMap();


function $197e81262ee8f44d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $b2fb93622bbd7df5$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $c8a0734e2ee77275$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $c8a0734e2ee77275$export$1405a65085f40b9 = [
    "initial",
    ...$c8a0734e2ee77275$export$16e45afcc206d3a8
];


function $05ee406980932703$export$4b3c3bd8d910d78d(props) {
    return (0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(props.animate) || (0, $c8a0734e2ee77275$export$1405a65085f40b9).some((name)=>(0, $b2fb93622bbd7df5$export$720b90e312cea233)(props[name]));
}
function $05ee406980932703$export$ce46fa4165cdec40(props) {
    return Boolean($05ee406980932703$export$4b3c3bd8d910d78d(props) || props.variants);
}





/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $16da05f34cd867a6$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $eba58299b894994c$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $eba58299b894994c$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


// Does this device prefer reduced motion? Returns `null` server-side.
const $ab7a52d88671d240$export$ff7706047246b98b = {
    current: null
};
const $ab7a52d88671d240$export$6476d16e2fd2d0db = {
    current: false
};


const $904a5ee8b5b90ab9$var$isBrowser = typeof window !== "undefined";
function $904a5ee8b5b90ab9$export$ca9f41fb23dded3d() {
    (0, $ab7a52d88671d240$export$6476d16e2fd2d0db).current = true;
    if (!$904a5ee8b5b90ab9$var$isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $ab7a52d88671d240$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $ab7a52d88671d240$export$ff7706047246b98b).current = false;
}


function $20ea58c6853b5985$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $20ea58c6853b5985$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $20ea58c6853b5985$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $20ea58c6853b5985$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}




const $67fdc880829ae48a$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let $67fdc880829ae48a$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $67fdc880829ae48a$export$8ad214844176d967(definitions) {
    $67fdc880829ae48a$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $67fdc880829ae48a$export$e183cb9c018608ba() {
    return $67fdc880829ae48a$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $67fdc880829ae48a$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    mount(instance) {
        var _this_parent;
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            var _this_values_get;
            (_this_values_get = this.values.get(key)) === null || _this_values_get === void 0 ? void 0 : _this_values_get.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, $44b14b06958d6f59$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, $ab7a52d88671d240$export$6476d16e2fd2d0db).current) (0, $904a5ee8b5b90ab9$export$ca9f41fb23dded3d)();
            this.shouldReduceMotion = (0, $ab7a52d88671d240$export$ff7706047246b98b).current;
        }
        var _this_skipAnimationsConfig;
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = (_this_skipAnimationsConfig = this.skipAnimationsConfig) !== null && _this_skipAnimationsConfig !== void 0 ? _this_skipAnimationsConfig : false;
        (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        var _this_parent;
        this.projection && this.projection.unmount();
        (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        var _this_enteringChildren;
        (_this_enteringChildren = this.enteringChildren) !== null && _this_enteringChildren !== void 0 ? _this_enteringChildren : this.enteringChildren = new Set();
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, $95afec150de2825d$export$a27eefbd8fb5e404).has(key) && this.current instanceof HTMLElement) {
            const { factory: factory, keyframes: keyframes, times: times, ease: ease, duration: duration } = value.accelerate;
            const animation = new (0, $d40de0a79038d88e$export$6c0f9803d8aa7219)({
                element: this.current,
                name: key,
                keyframes: keyframes,
                times: times,
                ease: ease,
                duration: (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $44c600a9437aff7c$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
        // Defer to MotionValue.on("change") auto-stop so React 19 remounts
        // can resubscribe before the animation is cancelled (#3315).
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in $67fdc880829ae48a$var$featureDefinitions){
            const featureDefinition = $67fdc880829ae48a$var$featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $67fdc880829ae48a$var$propEventHandlers.length; i++){
            const key = $67fdc880829ae48a$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $16da05f34cd867a6$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $eba58299b894994c$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _this_getBaseTargetFromProps;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this_getBaseTargetFromProps = this.getBaseTargetFromProps(this.props, key)) !== null && _this_getBaseTargetFromProps !== void 0 ? _this_getBaseTargetFromProps : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $162a1451c8fa55b4$export$65583ed5a868f2d9)(value) || (0, $410126928ba5c7af$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $d47a0afa4e4d071c$export$950e7e59ea1ffed7)(value) && (0, $ce3767268d4e9ade$export$83a0e34f1302825b).test(target)) value = (0, $a6324f331d30f12e$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            var _this_presenceContext;
            const variant = (0, $20ea58c6853b5985$export$d68f140c4d9b48bc)(this.props, initial, (_this_presenceContext = this.presenceContext) === null || _this_presenceContext === void 0 ? void 0 : _this_presenceContext.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $61e12cc57eeb85ed$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $530b27a3f7a9b181$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $4cb138f42ee448c1$export$bb76eed83315504c).render(this.render);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, skipAnimations: skipAnimations, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $cf13d99b8a449fd0$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, latestValues);
        this.initialValues = props.initial ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $05ee406980932703$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $05ee406980932703$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), { willChange: willChange } = _this_scrapeMotionValuesFromProps, initialMotionValues = (0, $8901fc92b5563702$export$71511d61b312f219)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
}


class $dba06d9a16f9b2fd$export$e49735c2a366bdc7 extends (0, $67fdc880829ae48a$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $6543679a34c2f697$export$4983792d11b61017);
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $1f8f8a4cd1b31868$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};








const $780bba6e980489ff$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $780bba6e980489ff$var$numTransforms = (0, $36437dbf5b93c477$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $780bba6e980489ff$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $780bba6e980489ff$var$numTransforms; i++){
        const key = (0, $36437dbf5b93c477$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $1f8f8a4cd1b31868$export$453ef540a9a1bd6b)(value, (0, $d954abda96ea0996$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $780bba6e980489ff$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    const pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += `rotate(${(0, $1f8f8a4cd1b31868$export$453ef540a9a1bd6b)(pathRotation, (0, $d954abda96ea0996$export$eec14432cd1cb67b).pathRotation)}) `;
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $4a12369564e40a1a$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $8e08dd08a6f8a76d$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $1f8f8a4cd1b31868$export$453ef540a9a1bd6b)(value, (0, $d954abda96ea0996$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $780bba6e980489ff$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $249f8557c7bc151a$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection === null || projection === void 0 ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}







/**
 * The four corner-radius longhands. Shared so the projection mixer, scale
 * corrector, WAAPI px-value set and view-transition crop pass don't each carry
 * their own copy. Order is irrelevant - every consumer mixes/corrects/animates
 * each corner independently.
 */ const $184da4a7f0af456c$export$41ef21965ed84e7a = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
];



function $2b08ad704c89288c$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $2b08ad704c89288c$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $f1a72de1b348da89$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $2b08ad704c89288c$export$fafff692be55225d(latest, node.target.x);
        const y = $2b08ad704c89288c$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $918aeea44afb5b07$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $e69bce41e90c0a87$export$91ddd985b97788d1 = {
    borderRadius: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $2b08ad704c89288c$export$5eafb6257a5844c)), {
        applyTo: [
            ...(0, $184da4a7f0af456c$export$41ef21965ed84e7a)
        ]
    }),
    borderTopLeftRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    boxShadow: (0, $918aeea44afb5b07$export$eb0bc629e74dcf8)
};
function $e69bce41e90c0a87$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $e69bce41e90c0a87$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $8e08dd08a6f8a76d$export$9de1236619d9e756)(key)) $e69bce41e90c0a87$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $b4fc036121a01de5$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $e69bce41e90c0a87$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $bb3887c01d961675$export$16da615486abaa45(props, prevProps, visualElement) {
    var _visualElement_getValue;
    const style = props.style;
    const prevStyle = prevProps === null || prevProps === void 0 ? void 0 : prevProps.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(style[key]) || prevStyle && (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(prevStyle[key]) || (0, $b4fc036121a01de5$export$6d27ce8e3de1c3cf)(key, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement_getValue = visualElement.getValue(key)) === null || _visualElement_getValue === void 0 ? void 0 : _visualElement_getValue.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}


function $81ed700fe5da0b90$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $81ed700fe5da0b90$export$23fea75b03ac16b3 extends (0, $dba06d9a16f9b2fd$export$e49735c2a366bdc7) {
    mount(instance) {
        /**
         * If a custom component forwards its ref to something other than a
         * HTML/SVG element (a class instance, an imperative handle) there's
         * nothing for Motion to style, measure or attach gestures to. #2777
         */ (0, $19758d730238f0ed$export$f5708dca728d7177)(Boolean(instance.style), "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref");
        super.mount(instance);
    }
    readValueFromInstance(instance, key) {
        var _this_projection;
        if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key)) return ((_this_projection = this.projection) === null || _this_projection === void 0 ? void 0 : _this_projection.isProjecting) ? (0, $f0207664133f4738$export$1f10c01143b9f089)(key) : (0, $f0207664133f4738$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $81ed700fe5da0b90$export$3735103072e4a80(instance);
            const value = ((0, $8e08dd08a6f8a76d$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $b3c78c86be367659$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $4a12369564e40a1a$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $bb3887c01d961675$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $249f8557c7bc151a$export$1a32bf6229c258c0);
    }
}





function $e3efdb4aa4767bb8$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}




const $17aabc3c06d8838a$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $17aabc3c06d8838a$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $17aabc3c06d8838a$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $17aabc3c06d8838a$var$dashKeys : $17aabc3c06d8838a$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}


/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const $b1850672c48c4c28$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $b1850672c48c4c28$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate, styleProp) {
    var { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0 } = _param, latest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $4a12369564e40a1a$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        var _attrs_transformOrigin;
        style.transformOrigin = (_attrs_transformOrigin = attrs.transformOrigin) !== null && _attrs_transformOrigin !== void 0 ? _attrs_transformOrigin : "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        var _styleProp_transformBox;
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = (_styleProp_transformBox = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp_transformBox !== void 0 ? _styleProp_transformBox : "fill-box";
        delete attrs.transformBox;
    }
    for (const key of $b1850672c48c4c28$var$cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $17aabc3c06d8838a$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $652662eb2acdfcdb$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $fe39d18929b68f56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $08ed0d1bc64f3540$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $249f8557c7bc151a$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $652662eb2acdfcdb$export$28931db5d57958e5).has(key) ? (0, $e3efdb4aa4767bb8$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $0cc03b58a88b997c$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $bb3887c01d961675$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(props[key]) || (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $36437dbf5b93c477$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $ea5a8c056a9a6168$export$86bcdffbaf733d84 extends (0, $dba06d9a16f9b2fd$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $4f34bdc9b52d7b1d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $652662eb2acdfcdb$export$28931db5d57958e5).has(key) ? (0, $e3efdb4aa4767bb8$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $0cc03b58a88b997c$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $b1850672c48c4c28$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $08ed0d1bc64f3540$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $fe39d18929b68f56$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $a0d315cc230b7b79$export$6459fc9e86be362e);
    }
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $087915a6be8a879b$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $e87a7c920482c926$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $087915a6be8a879b$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}


const $782ff79d5f331768$export$56ba0183203348f5 = (Component, options)=>{
    var _options_isSVG;
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ const isSVG = (_options_isSVG = options.isSVG) !== null && _options_isSVG !== void 0 ? _options_isSVG : (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component);
    return isSVG ? new (0, $ea5a8c056a9a6168$export$86bcdffbaf733d84)(options) : new (0, $81ed700fe5da0b90$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $7fPBF.Fragment)
    });
};








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $e8832bf2a75e672d$export$a3579ca508007a95 = (0, $7fPBF.createContext)({});



var $7fPBF = parcelRequire("7fPBF");
"use client";
const $1a3b4aa5979f4505$export$40f10139ecf1f171 = (0, $7fPBF.createContext)({
    strict: false
});



var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @public
 */ const $a8ff94f377278375$export$22a697fb29aac98d = (0, $7fPBF.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $7fPBF = parcelRequire("7fPBF");
"use client";
const $022ea981eb8a45f5$export$2285bbca2c666415 = /* @__PURE__ */ (0, $7fPBF.createContext)({});



var $7fPBF = parcelRequire("7fPBF");


function $854409cb45b6f949$export$12fc32fc096a04a3(props, context) {
    if ((0, $05ee406980932703$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $b2fb93622bbd7df5$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $b2fb93622bbd7df5$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $a9d13e94686be65e$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $854409cb45b6f949$export$12fc32fc096a04a3)(props, (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415)));
    return (0, $7fPBF.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a9d13e94686be65e$var$variantLabelsAsDependency(initial),
        $a9d13e94686be65e$var$variantLabelsAsDependency(animate)
    ]);
}
function $a9d13e94686be65e$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0e0ff089d25fb1a0$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $f78b51ebf65a693b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $61e12cc57eeb85ed$export$605d60a2578142d3)(source[key]) && !(0, $b4fc036121a01de5$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $f78b51ebf65a693b$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $7fPBF.useMemo)(()=>{
        const state = (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)();
        (0, $4a12369564e40a1a$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $f78b51ebf65a693b$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $f78b51ebf65a693b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $f78b51ebf65a693b$var$useInitialMotionValues(props, visualState));
    return style;
}
function $f78b51ebf65a693b$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $f78b51ebf65a693b$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}






var $7fPBF = parcelRequire("7fPBF");




const $9caa1e13b1076d24$export$41be8b43e1c4d4f9 = ()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)()), {
        attrs: {}
    });


"use client";
function $b38d0f78ad3b903e$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $7fPBF.useMemo)(()=>{
        const state = (0, $9caa1e13b1076d24$export$41be8b43e1c4d4f9)();
        (0, $b1850672c48c4c28$export$5475d24f125d7053)(state, visualState, (0, $fe39d18929b68f56$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.attrs), {
            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $f78b51ebf65a693b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}



/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $19b21865892304dc$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $19b21865892304dc$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $19b21865892304dc$var$validMotionProps.has(key);
}


let $8c94e6d37c758765$var$shouldForward = (key)=>!(0, $19b21865892304dc$export$2f9c46555243bf04)(key);
function $8c94e6d37c758765$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $8c94e6d37c758765$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $19b21865892304dc$export$2f9c46555243bf04)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ const emotionPkg = "@emotion/is-prop-valid";
    $8c94e6d37c758765$export$59d6962c470509a5(require(emotionPkg).default);
} catch (e) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $8c94e6d37c758765$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(props[key])) continue;
        if ($8c94e6d37c758765$var$shouldForward(key) || forwardMotionProps === true && (0, $19b21865892304dc$export$2f9c46555243bf04)(key) || !isDom && !(0, $19b21865892304dc$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $aa7c12fccf65e136$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false, isSVG) {
    const useVisualProps = (isSVG !== null && isSVG !== void 0 ? isSVG : (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component)) ? (0, $b38d0f78ad3b903e$export$84309c4f53cb1bd5) : (0, $f78b51ebf65a693b$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $8c94e6d37c758765$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $7fPBF.Fragment) ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filteredProps, visualProps), {
        ref: ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $7fPBF.useMemo)(()=>(0, $61e12cc57eeb85ed$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $7fPBF.createElement)(Component, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, elementProps), {
        children: renderedChildren
    }));
}






/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function $f1898fdc70290c7d$export$fcc2206ecb6d74b(value) {
    return (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value.get() : value;
}



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @public
 */ const $13549fe6f5cbc799$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $2a1bdfabf21bf6e8$export$fe4300aa8eebea86(init) {
    const ref = (0, $7fPBF.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


"use client";
function $598d667c288f7fba$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $598d667c288f7fba$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $598d667c288f7fba$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $05ee406980932703$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $05ee406980932703$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $20ea58c6853b5985$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition } = resolved, target = (0, $8901fc92b5563702$export$71511d61b312f219)(resolved, [
                    "transitionEnd",
                    "transition"
                ]);
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $598d667c288f7fba$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415));
        const presenceContext = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
        const make = ()=>$598d667c288f7fba$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $2a1bdfabf21bf6e8$export$fe4300aa8eebea86)(make);
    };



"use client";
const $8294e09ba1da91bf$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $598d667c288f7fba$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $bb3887c01d961675$export$16da615486abaa45),
    createRenderState: (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)
});





"use client";
const $e69222d4a1c31a59$export$9922240e40b88c48 = /*@__PURE__*/ (0, $598d667c288f7fba$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $0cc03b58a88b997c$export$16da615486abaa45),
    createRenderState: (0, $9caa1e13b1076d24$export$41be8b43e1c4d4f9)
});



const $000eadb1a85dd08b$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
let $000eadb1a85dd08b$var$isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function $000eadb1a85dd08b$export$e7d3655c4e2f701f() {
    if ($000eadb1a85dd08b$var$isInitialized) return;
    const initialFeatureDefinitions = {};
    for(const key in $000eadb1a85dd08b$var$featureProps)initialFeatureDefinitions[key] = {
        isEnabled: (props)=>$000eadb1a85dd08b$var$featureProps[key].some((name)=>!!props[name])
    };
    (0, $67fdc880829ae48a$export$8ad214844176d967)(initialFeatureDefinitions);
    $000eadb1a85dd08b$var$isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function $000eadb1a85dd08b$export$350148171c356c79() {
    $000eadb1a85dd08b$export$e7d3655c4e2f701f();
    return (0, $67fdc880829ae48a$export$e183cb9c018608ba)();
}





function $1a95148514458996$export$449561ec5703cdc8(features) {
    const featureDefinitions = (0, $000eadb1a85dd08b$export$350148171c356c79)();
    for(const key in features)featureDefinitions[key] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, featureDefinitions[key], features[key]);
    (0, $67fdc880829ae48a$export$8ad214844176d967)(featureDefinitions);
}


const $b4cb5ee9ecabcf16$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3efbe3f66e4b88ba$export$c684914703d321fd(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ const externalRefContainer = (0, $7fPBF.useRef)(externalRef);
    (0, $7fPBF.useInsertionEffect)(()=>{
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    const refCleanup = (0, $7fPBF.useRef)(null);
    return (0, $7fPBF.useCallback)((instance)=>{
        var _visualState_onMount;
        if (instance) (_visualState_onMount = visualState.onMount) === null || _visualState_onMount === void 0 ? void 0 : _visualState_onMount.call(visualState, instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        const ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                const cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
    }, [
        visualElement
    ]);
}



const $e429a9baf33d38af$export$ed7b8fa9dbf0105d = "framerAppearId";
const $e429a9baf33d38af$export$8592e1c077c890a6 = "data-" + (0, $e3efdb4aa4767bb8$export$9fd24a634729c672)($e429a9baf33d38af$export$ed7b8fa9dbf0105d);



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $813b6750233d847f$export$da5f7b802957459a = (0, $7fPBF.createContext)({});


function $881a839ff5ec248c$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $7fPBF = parcelRequire("7fPBF");
const $eab4d64e1bdb7129$export$4e09c449d6c407f7 = typeof window !== "undefined";


"use client";
const $af582d6e296d97ab$export$700979bc83e7db82 = (0, $eab4d64e1bdb7129$export$4e09c449d6c407f7) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


"use client";
function $7d1717bf2273b4e2$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    var _window_MotionHandoffIsComplete, _window, _window_MotionHasOptimisedAnimation, _window1;
    const { visualElement: parent } = (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415));
    const lazyContext = (0, $7fPBF.useContext)((0, $1a3b4aa5979f4505$export$40f10139ecf1f171));
    const presenceContext = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
    const motionConfig = (0, $7fPBF.useContext)((0, $a8ff94f377278375$export$22a697fb29aac98d));
    const reducedMotionConfig = motionConfig.reducedMotion;
    const skipAnimations = motionConfig.skipAnimations;
    const visualElementRef = (0, $7fPBF.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ const hasMountedOnce = (0, $7fPBF.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceContext: presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig: reducedMotionConfig,
            skipAnimations: skipAnimations,
            isSVG: isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $7fPBF.useContext)((0, $813b6750233d847f$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $7d1717bf2273b4e2$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $e429a9baf33d38af$export$8592e1c077c890a6];
    const wantsHandoff = (0, $7fPBF.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !((_window_MotionHandoffIsComplete = (_window = window).MotionHandoffIsComplete) === null || _window_MotionHandoffIsComplete === void 0 ? void 0 : _window_MotionHandoffIsComplete.call(_window, optimisedAppearId)) && ((_window_MotionHasOptimisedAnimation = (_window1 = window).MotionHasOptimisedAnimation) === null || _window_MotionHasOptimisedAnimation === void 0 ? void 0 : _window_MotionHasOptimisedAnimation.call(_window1, optimisedAppearId)));
    (0, $af582d6e296d97ab$export$700979bc83e7db82)(()=>{
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _window_MotionHandoffMarkAsComplete, _window;
                (_window_MotionHandoffMarkAsComplete = (_window = window).MotionHandoffMarkAsComplete) === null || _window_MotionHandoffMarkAsComplete === void 0 ? void 0 : _window_MotionHandoffMarkAsComplete.call(_window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $7d1717bf2273b4e2$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutAnchor: layoutAnchor, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $7d1717bf2273b4e2$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot,
        layoutAnchor: layoutAnchor
    });
}
function $7d1717bf2273b4e2$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $7d1717bf2273b4e2$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $9202ab606c3569b2$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false, type: type } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $1a95148514458996$export$449561ec5703cdc8)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ const isSVG = type ? type === "svg" : (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component);
    const useVisualState = isSVG ? (0, $e69222d4a1c31a59$export$9922240e40b88c48) : (0, $8294e09ba1da91bf$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $7fPBF.useContext)((0, $a8ff94f377278375$export$22a697fb29aac98d)), props), {
            layoutId: $9202ab606c3569b2$var$useLayoutId(props)
        });
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $a9d13e94686be65e$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            $9202ab606c3569b2$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $9202ab606c3569b2$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7d1717bf2273b4e2$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $824c049f32d4395d$exports.jsxs)((0, $022ea981eb8a45f5$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $824c049f32d4395d$exports.jsx)(MeasureLayout, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                (0, $aa7c12fccf65e136$export$e25bb1e5b53cbdff)(Component, props, (0, $3efbe3f66e4b88ba$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    var _Component_displayName, _ref;
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_ref = (_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) !== null && _ref !== void 0 ? _ref : ""})`}`;
    const ForwardRefMotionComponent = (0, $7fPBF.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $b4cb5ee9ecabcf16$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $9202ab606c3569b2$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $9202ab606c3569b2$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $7fPBF.useContext)((0, $1a3b4aa5979f4505$export$40f10139ecf1f171)).strict;
}
function $9202ab606c3569b2$var$getProjectionFunctionality(props) {
    const featureDefinitions = (0, $000eadb1a85dd08b$export$350148171c356c79)();
    const { drag: drag, layout: layout } = featureDefinitions;
    if (!drag && !layout) return {};
    const combined = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $832dbbf8caa22976$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $9202ab606c3569b2$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $9202ab606c3569b2$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $9202ab606c3569b2$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}






function $0f821ea1e0e898c8$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $20ea58c6853b5985$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}




/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ 

function $46f6985c0d37a6d0$export$b180037f8f468d61(transition, parentTransition) {
    if ((transition === null || transition === void 0 ? void 0 : transition.inherit) && parentTransition) {
        const { inherit: _ } = transition, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(transition, [
            "inherit"
        ]);
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, parentTransition, rest);
    }
    return transition;
}


function $445378a930c6db37$export$7c1391340308742e(transition, key) {
    var _transition_key, _ref;
    const valueTransition = (_ref = (_transition_key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition_key !== void 0 ? _transition_key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
    if (valueTransition !== transition) return (0, $46f6985c0d37a6d0$export$b180037f8f468d61)(valueTransition, transition);
    return valueTransition;
}








const $b86f35c91384031e$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $52953efd8694e3bd$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $eba58299b894994c$export$ce8bdc721e76545f)(value));
}
function $52953efd8694e3bd$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $b86f35c91384031e$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $52953efd8694e3bd$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, definition);
    let _ref = resolved || {}, { transitionEnd: transitionEnd = {}, transition: transition = {} } = _ref, target = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, target, transitionEnd);
    for(const key in target){
        const value = $52953efd8694e3bd$var$resolveFinalValueInKeyframes(target[key]);
        $52953efd8694e3bd$var$setMotionValue(visualElement, key, value);
    }
}




function $ffcae9ed317c42ed$export$98397f3adbf6259f(value) {
    return Boolean((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) && value.add);
}


function $5d399ca24ed34089$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $ffcae9ed317c42ed$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $dedda87bce0b0fc0$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $e429a9baf33d38af$export$8592e1c077c890a6];
}












/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $113d54600cb8d2d0$export$a4627e546088548d = (...transformers)=>transformers.reduce((a, b)=>(v)=>b(a(v)));












// Adapted from https://gist.github.com/mjackson/5311256
function $a395f4e8a86492ea$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $a395f4e8a86492ea$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $a395f4e8a86492ea$var$hueToRgb(p, q, hue + 1 / 3);
        green = $a395f4e8a86492ea$var$hueToRgb(p, q, hue);
        blue = $a395f4e8a86492ea$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $e493443a4fa45880$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $08f990a3e51e69f3$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $08f990a3e51e69f3$var$colorTypes = [
    (0, $90a7f54b29f1453c$export$834dfc94dde4b3d8),
    (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b),
    (0, $f6f2a31cd5829bc5$export$810b04175080204c)
];
const $08f990a3e51e69f3$var$getColorType = (v)=>$08f990a3e51e69f3$var$colorTypes.find((type)=>type.test(v));
function $08f990a3e51e69f3$var$asRGBA(color) {
    const type = $08f990a3e51e69f3$var$getColorType(color);
    (0, $19758d730238f0ed$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $f6f2a31cd5829bc5$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $a395f4e8a86492ea$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $08f990a3e51e69f3$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $08f990a3e51e69f3$var$asRGBA(from);
    const toRGBA = $08f990a3e51e69f3$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $e493443a4fa45880$export$a6f92d4bae65c0f1)(from, to);
    const blended = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fromRGBA);
    return (v)=>{
        blended.red = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $21b14ab67cf766da$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $21b14ab67cf766da$export$fed62ccc3fb1a568(origin, target) {
    if ($21b14ab67cf766da$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $864ea16ae0114b26$var$mixNumber(a, b) {
    return (p)=>(0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $864ea16ae0114b26$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $864ea16ae0114b26$var$mixNumber;
    else if (typeof a === "string") return (0, $8e08dd08a6f8a76d$export$31f9caa2600b5723)(a) ? (0, $e493443a4fa45880$export$a6f92d4bae65c0f1) : (0, $d252968ea52f42fd$export$35e9368ef982300f).test(a) ? (0, $08f990a3e51e69f3$export$51e568cf5c039bac) : $864ea16ae0114b26$export$65516310a87d8205;
    else if (Array.isArray(a)) return $864ea16ae0114b26$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $d252968ea52f42fd$export$35e9368ef982300f).test(a) ? (0, $08f990a3e51e69f3$export$51e568cf5c039bac) : $864ea16ae0114b26$export$ebc23b6840c51ba1;
    return 0, $e493443a4fa45880$export$a6f92d4bae65c0f1;
}
function $864ea16ae0114b26$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$864ea16ae0114b26$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $864ea16ae0114b26$export$ebc23b6840c51ba1(a, b) {
    const output = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a, b);
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $864ea16ae0114b26$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $864ea16ae0114b26$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        var _origin_values_originIndex;
        const originValue = (_origin_values_originIndex = origin.values[originIndex]) !== null && _origin_values_originIndex !== void 0 ? _origin_values_originIndex : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $864ea16ae0114b26$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $ce3767268d4e9ade$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $ce3767268d4e9ade$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $21b14ab67cf766da$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $21b14ab67cf766da$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $21b14ab67cf766da$export$fed62ccc3fb1a568)(origin, target);
        return (0, $113d54600cb8d2d0$export$a4627e546088548d)($864ea16ae0114b26$export$3bbefa2f402845c4($864ea16ae0114b26$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $19758d730238f0ed$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $e493443a4fa45880$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $a5735c6e2225d49f$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $864ea16ae0114b26$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $72b107753e53f4eb$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $44c600a9437aff7c$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing ? (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp : (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now()
    };
};






/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9c4fce4939386ba9$export$f4ff70a5b4808fd8 = 20000;
function $9c4fce4939386ba9$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9c4fce4939386ba9$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9c4fce4939386ba9$export$f4ff70a5b4808fd8 ? Infinity : duration;
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $419f83f95667f286$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        keyframes: [
            0,
            scale
        ]
    }));
    const duration = Math.min((0, $9c4fce4939386ba9$export$cbdd6b3d40ea54e2)(generator), (0, $9c4fce4939386ba9$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(duration)
    };
}


const $cf35667c22d9ae68$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $cf35667c22d9ae68$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const $cf35667c22d9ae68$var$rootIterations = 12;
function $cf35667c22d9ae68$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $cf35667c22d9ae68$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const $cf35667c22d9ae68$var$safeMin = 0.001;
function $cf35667c22d9ae68$var$findSpring({ duration: duration = $cf35667c22d9ae68$var$springDefaults.duration, bounce: bounce = $cf35667c22d9ae68$var$springDefaults.bounce, velocity: velocity = $cf35667c22d9ae68$var$springDefaults.velocity, mass: mass = $cf35667c22d9ae68$var$springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, $19758d730238f0ed$export$491112666e282270)(duration <= (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)($cf35667c22d9ae68$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)($cf35667c22d9ae68$var$springDefaults.minDamping, $cf35667c22d9ae68$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)($cf35667c22d9ae68$var$springDefaults.minDuration, $cf35667c22d9ae68$var$springDefaults.maxDuration, (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $cf35667c22d9ae68$var$calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $cf35667c22d9ae68$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $cf35667c22d9ae68$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $cf35667c22d9ae68$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$cf35667c22d9ae68$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $cf35667c22d9ae68$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $cf35667c22d9ae68$var$springDefaults.stiffness,
        damping: $cf35667c22d9ae68$var$springDefaults.damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $cf35667c22d9ae68$var$durationKeys = [
    "duration",
    "bounce"
];
const $cf35667c22d9ae68$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $cf35667c22d9ae68$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $cf35667c22d9ae68$var$getSpringOptions(options) {
    let springOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        velocity: $cf35667c22d9ae68$var$springDefaults.velocity,
        stiffness: $cf35667c22d9ae68$var$springDefaults.stiffness,
        damping: $cf35667c22d9ae68$var$springDefaults.damping,
        mass: $cf35667c22d9ae68$var$springDefaults.mass,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$cf35667c22d9ae68$var$isSpringType(options, $cf35667c22d9ae68$var$physicsKeys) && $cf35667c22d9ae68$var$isSpringType(options, $cf35667c22d9ae68$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, springOptions), {
                mass: $cf35667c22d9ae68$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            });
        } else {
            const derived = $cf35667c22d9ae68$var$findSpring((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                velocity: 0
            }));
            springOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, springOptions, derived), {
                mass: $cf35667c22d9ae68$var$springDefaults.mass
            });
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $cf35667c22d9ae68$export$b36281d89752ae66(optionsOrVisualDuration = $cf35667c22d9ae68$var$springDefaults.visualDuration, bounce = $cf35667c22d9ae68$var$springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $cf35667c22d9ae68$var$getSpringOptions((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        velocity: -(0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(options.velocity || 0)
    }));
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $cf35667c22d9ae68$var$springDefaults.restSpeed.granular : $cf35667c22d9ae68$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $cf35667c22d9ae68$var$springDefaults.restDelta.granular : $cf35667c22d9ae68$var$springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $cf35667c22d9ae68$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $9c4fce4939386ba9$export$cbdd6b3d40ea54e2)(generator), (0, $9c4fce4939386ba9$export$f4ff70a5b4808fd8));
            const easing = (0, $0e9dc36f6f7cb032$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$cf35667c22d9ae68$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $419f83f95667f286$export$7f1511d09ee75a99)(options, 100, $cf35667c22d9ae68$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



const $7ca1f8fd8c1eaa05$var$velocitySampleDuration = 5; // ms
function $7ca1f8fd8c1eaa05$export$279c5e002bb29070(resolveValue, t, current) {
    const prevT = Math.max(t - $7ca1f8fd8c1eaa05$var$velocitySampleDuration, 0);
    return (0, $53435ded96da5381$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


function $32e0d307ae2d0987$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $cf35667c22d9ae68$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $7ca1f8fd8c1eaa05$export$279c5e002bb29070)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $c1fbb59bb1e3e7b4$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $c1fbb59bb1e3e7b4$var$subdivisionPrecision = 0.0000001;
const $c1fbb59bb1e3e7b4$var$subdivisionMaxIterations = 12;
function $c1fbb59bb1e3e7b4$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $c1fbb59bb1e3e7b4$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $c1fbb59bb1e3e7b4$var$subdivisionPrecision && ++i < $c1fbb59bb1e3e7b4$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $69d49105ec21595d$export$8793edee2d425525;
    const getTForX = (aX)=>$c1fbb59bb1e3e7b4$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $c1fbb59bb1e3e7b4$var$calcBezier(getTForX(t), mY1, mY2);
}


const $0237323c43a18099$export$929e5a82286172a6 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $0237323c43a18099$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $0237323c43a18099$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ const $139640f8594c998b$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ const $931d9f9e77a0aee7$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $99127f009a705dfc$export$77edfce482316a60 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $99127f009a705dfc$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $931d9f9e77a0aee7$export$2c07eeff45156d4d)($99127f009a705dfc$export$77edfce482316a60);
const $99127f009a705dfc$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $139640f8594c998b$export$f946554fb8aeaf0d)($99127f009a705dfc$export$b01116c84cdfe1a2);


const $3364581cfa525123$export$6b0af63b873d419e = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $99127f009a705dfc$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $e4064fe071cf16bf$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $e4064fe071cf16bf$export$c8d67a19199d1a50 = (0, $931d9f9e77a0aee7$export$2c07eeff45156d4d)($e4064fe071cf16bf$export$e444123e42d03385);
const $e4064fe071cf16bf$export$30d3455eee55bed5 = (0, $139640f8594c998b$export$f946554fb8aeaf0d)($e4064fe071cf16bf$export$e444123e42d03385);





const $33255b886b199e10$var$easingLookup = {
    linear: (0, $69d49105ec21595d$export$8793edee2d425525),
    easeIn: $0237323c43a18099$export$929e5a82286172a6,
    easeInOut: $0237323c43a18099$export$c07234257a03d5e9,
    easeOut: $0237323c43a18099$export$57636bb43b1ccbb0,
    circIn: $e4064fe071cf16bf$export$e444123e42d03385,
    circInOut: $e4064fe071cf16bf$export$30d3455eee55bed5,
    circOut: $e4064fe071cf16bf$export$c8d67a19199d1a50,
    backIn: $99127f009a705dfc$export$b01116c84cdfe1a2,
    backInOut: $99127f009a705dfc$export$ddc5fd596f6c71b2,
    backOut: $99127f009a705dfc$export$77edfce482316a60,
    anticipate: $3364581cfa525123$export$6b0af63b873d419e
};
const $33255b886b199e10$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $33255b886b199e10$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $09983ccc000b48c8$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $19758d730238f0ed$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($33255b886b199e10$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $19758d730238f0ed$export$f5708dca728d7177)($33255b886b199e10$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $33255b886b199e10$var$easingLookup[definition];
    }
    return definition;
};

/*#__NO_SIDE_EFFECTS__*/ const $ab974cab0b2b4116$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ const $5a7354d1e57d5b3d$export$504d7abb21fa8c9 = (from, to, value)=>{
    const range = to - from;
    return range ? (value - from) / range : 1;
};



function $d37269c08d34236a$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).mix || (0, $a5735c6e2225d49f$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $69d49105ec21595d$export$8793edee2d425525) : ease;
            mixer = (0, $113d54600cb8d2d0$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $d37269c08d34236a$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $19758d730238f0ed$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $d37269c08d34236a$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $7e6dd1d3379cddbd$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $f8be49afc4edbaa8$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $7e6dd1d3379cddbd$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $7d2ae0a920715a8d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $01e9914588b77db2$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $0237323c43a18099$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $01e9914588b77db2$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $ab974cab0b2b4116$export$216948827bbdc797)(ease) ? ease.map((0, $33255b886b199e10$export$ef97fe084f156ca4)) : (0, $33255b886b199e10$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $7d2ae0a920715a8d$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $f8be49afc4edbaa8$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $d37269c08d34236a$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $01e9914588b77db2$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}








const $8edc467b0ada66ea$var$transitionTypeMap = {
    decay: (0, $32e0d307ae2d0987$export$ee3ff3a17106998),
    inertia: $32e0d307ae2d0987$export$ee3ff3a17106998,
    tween: (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e),
    keyframes: (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e),
    spring: $cf35667c22d9ae68$export$b36281d89752ae66
};
function $8edc467b0ada66ea$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $8edc467b0ada66ea$var$transitionTypeMap[transition.type];
}



const $66d5e49763a7f8a0$var$percentToProgress = (percent)=>percent / 100;
class $66d5e49763a7f8a0$export$3394f837405475c7 extends (0, $6940fcbd8d4ca66f$export$655db786091c33e0) {
    initAnimation() {
        const { options: options } = this;
        (0, $8edc467b0ada66ea$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $113d54600cb8d2d0$export$a4627e546088548d)($66d5e49763a7f8a0$var$percentToProgress, (0, $a5735c6e2225d49f$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            keyframes: keyframes$1
        }));
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        }));
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $9c4fce4939386ba9$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $32e0d307ae2d0987$export$ee3ff3a17106998)) state.value = (0, $fc831f8861054717$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, $7ca1f8fd8c1eaa05$export$279c5e002bb29070)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        var _this_options_onPlay, _this_options;
        if (this.isStopped) return;
        const { driver: driver = (0, $72b107753e53f4eb$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        (_this_options_onPlay = (_this_options = this.options).onPlay) === null || _this_options_onPlay === void 0 ? void 0 : _this_options_onPlay.call(_this_options);
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        var _this_options_onComplete, _this_options;
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        (_this_options_onComplete = (_this_options = this.options).onComplete) === null || _this_options_onComplete === void 0 ? void 0 : _this_options_onComplete.call(_this_options);
    }
    cancel() {
        var _this_options_onCancel, _this_options;
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        (_this_options_onCancel = (_this_options = this.options).onCancel) === null || _this_options_onCancel === void 0 ? void 0 : _this_options_onCancel.call(_this_options);
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        var _this_driver;
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.stop();
        return timeline.observe(this);
    }
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            var _this_options_onStop, _this_options;
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now()) this.tick((0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            (_this_options_onStop = (_this_options = this.options).onStop) === null || _this_options_onStop === void 0 ? void 0 : _this_options_onStop.call(_this_options);
        };
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
}
// Legacy function support
function $66d5e49763a7f8a0$export$ee9b76de7353d815(options) {
    return new $66d5e49763a7f8a0$export$3394f837405475c7(options);
}














const $3a789180528414af$var$unsupportedEasingFunctions = {
    anticipate: $3364581cfa525123$export$6b0af63b873d419e,
    backInOut: $99127f009a705dfc$export$ddc5fd596f6c71b2,
    circInOut: $e4064fe071cf16bf$export$30d3455eee55bed5
};
function $3a789180528414af$var$isUnsupportedEase(key) {
    return key in $3a789180528414af$var$unsupportedEasingFunctions;
}
function $3a789180528414af$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $3a789180528414af$var$isUnsupportedEase(transition.ease)) transition.ease = $3a789180528414af$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $9f819ae9491bd189$var$sampleDelta = 10; //ms
class $9f819ae9491bd189$export$bd2cd6a048093d96 extends (0, $d40de0a79038d88e$export$6c0f9803d8aa7219) {
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const _this_options = this.options, { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element } = _this_options, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_this_options, [
            "motionValue",
            "onUpdate",
            "onComplete",
            "element"
        ]);
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $66d5e49763a7f8a0$export$3394f837405475c7)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            autoplay: false
        }));
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max($9f819ae9491bd189$var$sampleDelta, (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now() - this.startTime);
        const delta = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, $9f819ae9491bd189$var$sampleDelta, sampleTime - $9f819ae9491bd189$var$sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name: name } = this.options;
        if (element && name) (0, $0055d05149405828$export$37a5fde709c1db82)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $3a789180528414af$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $8edc467b0ada66ea$export$98db6ef1242dfa2)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $e770b24f49f1bf00$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $ce3767268d4e9ade$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $2a4d473bd153758e$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $2a4d473bd153758e$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $e770b24f49f1bf00$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $e770b24f49f1bf00$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $19758d730238f0ed$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $2a4d473bd153758e$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $7499953f74b707a4$export$6ab7812f1bac68be)(type)) && velocity;
}


function $4513539b02d1ff31$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}





const $8814a910df4e458b$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $8814a910df4e458b$export$1af9e65d1501d15(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $8814a910df4e458b$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}


const $702fac286bb86197$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const $702fac286bb86197$var$supportsWaapi = /*@__PURE__*/ (0, $373ae0ce1db34355$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $702fac286bb86197$export$ea92bde116fda821(options) {
    var _motionValue_owner;
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type, keyframes: keyframes } = options;
    const subject = motionValue === null || motionValue === void 0 ? void 0 : (_motionValue_owner = motionValue.owner) === null || _motionValue_owner === void 0 ? void 0 : _motionValue_owner.current;
    /**
     * We use instanceof checks instead of isHTMLElement()/isSVGElement()
     * because we explicitly **don't** want elements in different timing
     * contexts (i.e. popups) to be accelerated, as it's not possible to sync
     * these animations properly with those driven from the main window
     * frameloop.
     */ if (!(subject instanceof HTMLElement) && !(subject instanceof SVGElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $702fac286bb86197$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $95afec150de2825d$export$a27eefbd8fb5e404).has(name) || $702fac286bb86197$var$colorProperties.has(name) && (0, $8814a910df4e458b$export$1af9e65d1501d15)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $583944b926d997b7$var$MAX_RESOLVE_DELAY = 40;
class $583944b926d997b7$export$b9855e2a7dee3dd2 extends (0, $6940fcbd8d4ca66f$export$655db786091c33e0) {
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        var _resolvedOptions_motionValue_owner, _resolvedOptions_motionValue;
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, $2a4d473bd153758e$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, $877fe7d159c5dd4c$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, $fc831f8861054717$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $4513539b02d1ff31$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $583944b926d997b7$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            startTime: startTime,
            finalKeyframe: finalKeyframe
        }, options), {
            keyframes: keyframes
        });
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, $702fac286bb86197$export$ea92bde116fda821)(resolvedOptions);
        const element = (_resolvedOptions_motionValue = resolvedOptions.motionValue) === null || _resolvedOptions_motionValue === void 0 ? void 0 : (_resolvedOptions_motionValue_owner = _resolvedOptions_motionValue.owner) === null || _resolvedOptions_motionValue_owner === void 0 ? void 0 : _resolvedOptions_motionValue_owner.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, $9f819ae9491bd189$export$bd2cd6a048093d96)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, resolvedOptions), {
                element: element
            }));
        } catch (e) {
            animation = new (0, $66d5e49763a7f8a0$export$3394f837405475c7)(resolvedOptions);
        }
        else animation = new (0, $66d5e49763a7f8a0$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, $69d49105ec21595d$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            var _this_keyframeResolver;
            (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.resume();
            (0, $cf13d99b8a449fd0$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        var _this_keyframeResolver;
        if (this._animation) this.animation.cancel();
        (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
    }
    constructor(_param){
        var { autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType",
            "keyframes",
            "name",
            "motionValue",
            "element"
        ]);
        var _this_keyframeResolver;
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            var _this_keyframeResolver;
            if (this._animation) {
                var _this_stopTimeline, _this;
                this._animation.stop();
                (_this_stopTimeline = (_this = this).stopTimeline) === null || _this_stopTimeline === void 0 ? void 0 : _this_stopTimeline.call(_this);
            }
            (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
        };
        this.createdAt = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element
        }, options);
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $cf13d99b8a449fd0$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.scheduleResolve();
    }
}






const $23d00b80313b3daf$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $23d00b80313b3daf$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $23d00b80313b3daf$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $23d00b80313b3daf$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $23d00b80313b3daf$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $23d00b80313b3daf$var$keyframesTransition;
    else if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $23d00b80313b3daf$var$criticallyDampedSpring(keyframes[1]) : $23d00b80313b3daf$var$underDampedSpring;
    return $23d00b80313b3daf$var$ease;
};



const $ddc4f6cd9cc92def$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ddc4f6cd9cc92def$export$ca8e47dc8ed5a9d7(transition) {
    for(const key in transition){
        if (!$ddc4f6cd9cc92def$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}



const $17ccdc0a04fec700$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $445378a930c6db37$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(delay);
        const options = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $ddc4f6cd9cc92def$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $23d00b80313b3daf$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $4513539b02d1ff31$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $877fe7d159c5dd4c$export$dd826089e3c5e502).instantAnimations || (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).skipAnimations || (element === null || element === void 0 ? void 0 : element.shouldSkipAnimations) || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $4513539b02d1ff31$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $fc831f8861054717$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $66d5e49763a7f8a0$export$3394f837405475c7)(options) : new (0, $583944b926d997b7$export$b9855e2a7dee3dd2)(options);
    };



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $8910548cca780654$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $8910548cca780654$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition, transitionEnd: transitionEnd } = targetAndTransition, target = (0, $8901fc92b5563702$export$71511d61b312f219)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $46f6985c0d37a6d0$export$b180037f8f468d61)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition === null || transition === void 0 ? void 0 : transition.reduceMotion;
    const skipAnimations = transition === null || transition === void 0 ? void 0 : transition.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    const path = transition === null || transition === void 0 ? void 0 : transition.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(const key in target){
        var _visualElement_latestValues_key;
        const value = visualElement.getValue(key, (_visualElement_latestValues_key = visualElement.latestValues[key]) !== null && _visualElement_latestValues_key !== void 0 ? _visualElement_latestValues_key : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $8910548cca780654$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            delay: delay
        }, (0, $445378a930c6db37$export$7c1391340308742e)(transition || {}, key));
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $dedda87bce0b0fc0$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $44c600a9437aff7c$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $5d399ca24ed34089$export$3ac5aed310be0bee)(visualElement, key);
        const shouldReduceMotion = reduceMotion !== null && reduceMotion !== void 0 ? reduceMotion : visualElement.shouldReduceMotion;
        value.start((0, $17ccdc0a04fec700$export$90b3dfc33ff3548)(key, value, valueTarget, shouldReduceMotion && (0, $3686a9bc645641a9$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>{
                transitionEnd && (0, $52953efd8694e3bd$export$1f61c53461aff4a5)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}





function $82431a0874d8653b$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $f887f02df845c390$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _visualElement_presenceContext;
    const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $8910548cca780654$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f887f02df845c390$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f887f02df845c390$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($f887f02df845c390$export$4709dc300705b2af(child, variant, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $82431a0874d8653b$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        })).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $f021ea9634d8167f$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f887f02df845c390$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f887f02df845c390$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $8910548cca780654$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





const $ea9b74448f41084f$var$numVariantProps = (0, $c8a0734e2ee77275$export$1405a65085f40b9).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function $ea9b74448f41084f$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $ea9b74448f41084f$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $ea9b74448f41084f$var$numVariantProps; i++){
        const name = (0, $c8a0734e2ee77275$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $b2fb93622bbd7df5$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}






function $13e2025e9e744d5f$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}



const $7cf90d6b464741cf$var$reversePriorityOrder = [
    ...(0, $c8a0734e2ee77275$export$16e45afcc206d3a8)
].reverse();
const $7cf90d6b464741cf$var$numAnimationTypes = (0, $c8a0734e2ee77275$export$16e45afcc206d3a8).length;
function $7cf90d6b464741cf$var$createAnimateFunction(visualElement) {
    return (animations)=>{
        return Promise.all(animations.map(({ animation: animation, options: options })=>(0, $f021ea9634d8167f$export$ff62cf473653f109)(visualElement, animation, options)));
    };
}
function $7cf90d6b464741cf$export$bb53502b7a672aa8(visualElement) {
    let animate = $7cf90d6b464741cf$var$createAnimateFunction(visualElement);
    let state = $7cf90d6b464741cf$var$createState();
    let isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ let wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _visualElement_presenceContext;
            const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $8901fc92b5563702$export$71511d61b312f219)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $ea9b74448f41084f$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $7cf90d6b464741cf$var$numAnimationTypes; i++){
            const type = $7cf90d6b464741cf$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $b2fb93622bbd7df5$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, encounteredKeys, typeState.prevResolvedValues);
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $7cf90d6b464741cf$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevResolvedValues, resolvedValues);
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $b86f35c91384031e$export$9153ad4c4999f4a0)(next) && (0, $b86f35c91384031e$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $13e2025e9e744d5f$export$90e866afbd6b9f1a)(next, prev) || variantDidChange;
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, encounteredKeys, resolvedValues);
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $82431a0874d8653b$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var // Propagate active change to children
        _visualElement_variantChildren;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        (_visualElement_variantChildren = visualElement.variantChildren) === null || _visualElement_variantChildren === void 0 ? void 0 : _visualElement_variantChildren.forEach((child)=>{
            var _child_animationState;
            return (_child_animationState = child.animationState) === null || _child_animationState === void 0 ? void 0 : _child_animationState.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $7cf90d6b464741cf$var$createState();
            wasReset = true;
        }
    };
}
function $7cf90d6b464741cf$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $13e2025e9e744d5f$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $7cf90d6b464741cf$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $7cf90d6b464741cf$var$createState() {
    return {
        animate: $7cf90d6b464741cf$var$createTypeState(true),
        whileInView: $7cf90d6b464741cf$var$createTypeState(),
        whileHover: $7cf90d6b464741cf$var$createTypeState(),
        whileTap: $7cf90d6b464741cf$var$createTypeState(),
        whileDrag: $7cf90d6b464741cf$var$createTypeState(),
        whileFocus: $7cf90d6b464741cf$var$createTypeState(),
        exit: $7cf90d6b464741cf$var$createTypeState()
    };
}

/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ class $3bb21a5535a42c32$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}


class $f6a9c87179214dae$export$b45b3fe5caabdca extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _this_unmountControls, _this;
        this.node.animationState.reset();
        (_this_unmountControls = (_this = this).unmountControls) === null || _this_unmountControls === void 0 ? void 0 : _this_unmountControls.call(_this);
    }
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $7cf90d6b464741cf$export$bb53502b7a672aa8)(node));
    }
}




let $4c6e705b5858a78b$var$id = 0;
class $4c6e705b5858a78b$export$4989d1eb6104cc6c extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        if (isPresent && prevIsPresent === false) {
            /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                const { initial: initial, custom: custom } = this.node.getProps();
                if (typeof initial === "string" || typeof initial === "object" && initial !== null && !Array.isArray(initial)) {
                    const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(this.node, initial, custom);
                    if (resolved) {
                        var _this_node_getValue;
                        const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $8901fc92b5563702$export$71511d61b312f219)(resolved, [
                            "transition",
                            "transitionEnd"
                        ]);
                        for(const key in target)(_this_node_getValue = this.node.getValue(key)) === null || _this_node_getValue === void 0 ? void 0 : _this_node_getValue.jump(target[key]);
                    }
                }
                this.node.animationState.reset();
                this.node.animationState.animateChanges();
            } else this.node.animationState.setActive("exit", false);
            this.isExitComplete = false;
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            this.isExitComplete = true;
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $4c6e705b5858a78b$var$id++;
        this.isExitComplete = false;
    }
}


const $9bb9392be544c52d$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f6a9c87179214dae$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $4c6e705b5858a78b$export$4989d1eb6104cc6c)
    }
};






function $4da397d0e67b1b1d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler, options);
}


const $69391feb435da50e$var$SCALE_PRECISION = 0.0001;
const $69391feb435da50e$var$SCALE_MIN = 1 - $69391feb435da50e$var$SCALE_PRECISION;
const $69391feb435da50e$var$SCALE_MAX = 1 + $69391feb435da50e$var$SCALE_PRECISION;
const $69391feb435da50e$var$TRANSLATE_PRECISION = 0.01;
const $69391feb435da50e$var$TRANSLATE_MIN = 0 - $69391feb435da50e$var$TRANSLATE_PRECISION;
const $69391feb435da50e$var$TRANSLATE_MAX = 0 + $69391feb435da50e$var$TRANSLATE_PRECISION;
function $69391feb435da50e$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $69391feb435da50e$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $69391feb435da50e$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $69391feb435da50e$export$c1c127004b72a37(target) / $69391feb435da50e$export$c1c127004b72a37(source);
    delta.translate = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $69391feb435da50e$var$SCALE_MIN && delta.scale <= $69391feb435da50e$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $69391feb435da50e$var$TRANSLATE_MIN && delta.translate <= $69391feb435da50e$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $69391feb435da50e$export$c0d25e96fc67d310(delta, source, target, origin) {
    $69391feb435da50e$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $69391feb435da50e$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $69391feb435da50e$export$cabef5b392704b41(target, relative, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + $69391feb435da50e$export$c1c127004b72a37(relative);
}
function $69391feb435da50e$export$426154f9d100f99(target, relative, parent, anchor) {
    $69391feb435da50e$export$cabef5b392704b41(target.x, relative.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    $69391feb435da50e$export$cabef5b392704b41(target.y, relative.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}
function $69391feb435da50e$export$ecd3d3bef81102c3(target, layout, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + $69391feb435da50e$export$c1c127004b72a37(layout);
}
function $69391feb435da50e$export$2785bfcc929c5650(target, layout, parent, anchor) {
    $69391feb435da50e$export$ecd3d3bef81102c3(target.x, layout.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    $69391feb435da50e$export$ecd3d3bef81102c3(target.y, layout.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}

function $2ac6ee71286c3d0e$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

const $86168a8dbbef73c2$var$keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function $86168a8dbbef73c2$export$5f6976e2f961e8b7(element) {
    return $86168a8dbbef73c2$var$keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
const $86168a8dbbef73c2$var$textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function $86168a8dbbef73c2$export$41e5a41992b76128(element) {
    return $86168a8dbbef73c2$var$textInputElements.has(element.tagName) || element.isContentEditable === true;
}

const $d93f81859b2d5a5f$export$a6cdc56e425d0d0a = (value)=>typeof value === "object" && value !== null;


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $d21d6497287d50b6$export$17eda790a720ec57(element) {
    return (0, $d93f81859b2d5a5f$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


function $6709e3be20d4c81f$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        var _selectorCache_elementOrSelector;
        const elements = (_selectorCache_elementOrSelector = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache_elementOrSelector !== void 0 ? _selectorCache_elementOrSelector : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}


const $d9065a51219d0ea0$var$resizeHandlers = new WeakMap();
let $d9065a51219d0ea0$var$observer;
const $d9065a51219d0ea0$var$getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, $d21d6497287d50b6$export$17eda790a720ec57)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const $d9065a51219d0ea0$var$getWidth = /*@__PURE__*/ $d9065a51219d0ea0$var$getSize("inline", "width", "offsetWidth");
const $d9065a51219d0ea0$var$getHeight = /*@__PURE__*/ $d9065a51219d0ea0$var$getSize("block", "height", "offsetHeight");
function $d9065a51219d0ea0$var$notifyTarget({ target: target, borderBoxSize: borderBoxSize }) {
    var _resizeHandlers_get;
    (_resizeHandlers_get = $d9065a51219d0ea0$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach((handler)=>{
        handler(target, {
            get width () {
                return $d9065a51219d0ea0$var$getWidth(target, borderBoxSize);
            },
            get height () {
                return $d9065a51219d0ea0$var$getHeight(target, borderBoxSize);
            }
        });
    });
}
function $d9065a51219d0ea0$var$notifyAll(entries) {
    entries.forEach($d9065a51219d0ea0$var$notifyTarget);
}
function $d9065a51219d0ea0$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $d9065a51219d0ea0$var$observer = new ResizeObserver($d9065a51219d0ea0$var$notifyAll);
}
function $d9065a51219d0ea0$export$81a0e12ec749d682(target, handler) {
    if (!$d9065a51219d0ea0$var$observer) $d9065a51219d0ea0$var$createResizeObserver();
    const elements = (0, $6709e3be20d4c81f$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $d9065a51219d0ea0$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $d9065a51219d0ea0$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $d9065a51219d0ea0$var$observer === null || $d9065a51219d0ea0$var$observer === void 0 ? void 0 : $d9065a51219d0ea0$var$observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $d9065a51219d0ea0$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $d9065a51219d0ea0$var$observer === null || $d9065a51219d0ea0$var$observer === void 0 ? void 0 : $d9065a51219d0ea0$var$observer.unobserve(element);
        });
    };
}


const $8744c9ec1840e76d$var$windowCallbacks = new Set();
let $8744c9ec1840e76d$var$windowResizeHandler;
function $8744c9ec1840e76d$var$createWindowResizeHandler() {
    $8744c9ec1840e76d$var$windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        $8744c9ec1840e76d$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $8744c9ec1840e76d$var$windowResizeHandler);
}
function $8744c9ec1840e76d$export$7fc81011b72cd94d(callback) {
    $8744c9ec1840e76d$var$windowCallbacks.add(callback);
    if (!$8744c9ec1840e76d$var$windowResizeHandler) $8744c9ec1840e76d$var$createWindowResizeHandler();
    return ()=>{
        $8744c9ec1840e76d$var$windowCallbacks.delete(callback);
        if (!$8744c9ec1840e76d$var$windowCallbacks.size && typeof $8744c9ec1840e76d$var$windowResizeHandler === "function") {
            window.removeEventListener("resize", $8744c9ec1840e76d$var$windowResizeHandler);
            $8744c9ec1840e76d$var$windowResizeHandler = undefined;
        }
    };
}


function $e568be821d367350$export$4380c87abf28fdf(a, b) {
    return typeof a === "function" ? (0, $8744c9ec1840e76d$export$7fc81011b72cd94d)(a) : (0, $d9065a51219d0ea0$export$81a0e12ec749d682)(a, b);
}

const $712c7e4e4b7d1d34$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $712c7e4e4b7d1d34$export$1b3dd616664938e4() {
    return $712c7e4e4b7d1d34$export$9e9bc3c487fccc00.x || $712c7e4e4b7d1d34$export$9e9bc3c487fccc00.y;
}


function $34c0dc4b9011d4ce$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).x || (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).x = (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).x = (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




const $8260b027ce2c0643$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $fc126d8b66e58ebd$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $fc126d8b66e58ebd$export$c404e80f92c98d29 = (handler)=>(event)=>(0, $8260b027ce2c0643$export$a4cf9c8a4b063a6e)(event) && handler(event, $fc126d8b66e58ebd$export$12f84bb882d06e1a(event));


function $1f42ffe5b9091d52$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(target, eventName, (0, $fc126d8b66e58ebd$export$c404e80f92c98d29)(handler), options);
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $4089e47ff1a2b128$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};









const $8df1b266d7b10633$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8df1b266d7b10633$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8df1b266d7b10633$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8df1b266d7b10633$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


const $caca2cdd35c93217$var$overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ class $caca2cdd35c93217$export$d9c66232c9c4689c {
    /**
     * Start tracking scroll on ancestors and window.
     */ startScrollTracking(element) {
        // Store initial scroll positions for scrollable ancestors
        let current = element.parentElement;
        while(current){
            const style = getComputedStyle(current);
            if ($caca2cdd35c93217$var$overflowStyles.has(style.overflowX) || $caca2cdd35c93217$var$overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                x: current.scrollLeft,
                y: current.scrollTop
            });
            current = current.parentElement;
        }
        // Track window scroll
        this.scrollPositions.set(window, {
            x: window.scrollX,
            y: window.scrollY
        });
        // Capture listener catches element scroll events as they bubble
        window.addEventListener("scroll", this.onElementScroll, {
            capture: true
        });
        // Direct window scroll listener (window scroll doesn't bubble)
        window.addEventListener("scroll", this.onWindowScroll);
        this.removeScrollListeners = ()=>{
            window.removeEventListener("scroll", this.onElementScroll, {
                capture: true
            });
            window.removeEventListener("scroll", this.onWindowScroll);
        };
    }
    /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ handleScroll(target) {
        const initial = this.scrollPositions.get(target);
        if (!initial) return;
        const isWindow = target === window;
        const current = isWindow ? {
            x: window.scrollX,
            y: window.scrollY
        } : {
            x: target.scrollLeft,
            y: target.scrollTop
        };
        const delta = {
            x: current.x - initial.x,
            y: current.y - initial.y
        };
        if (delta.x === 0 && delta.y === 0) return;
        if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
        {
            if (this.lastMoveEventInfo) {
                this.lastMoveEventInfo.point.x += delta.x;
                this.lastMoveEventInfo.point.y += delta.y;
            }
        } else // Element scroll: pageX/pageY unchanged, so adjust history origin
        if (this.history.length > 0) {
            this.history[0].x -= delta.x;
            this.history[0].y -= delta.y;
        }
        this.scrollPositions.set(target, current);
        (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(this.updatePoint, true);
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        this.removeScrollListeners && this.removeScrollListeners();
        this.scrollPositions.clear();
        (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3, element: element } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = (event)=>{
            this.handleScroll(event.target);
        };
        this.onWindowScroll = ()=>{
            this.handleScroll(window);
        };
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (this.lastRawMoveEventInfo) this.lastMoveEventInfo = $caca2cdd35c93217$var$transformPoint(this.lastRawMoveEventInfo, this.transformPagePoint);
            const info = $caca2cdd35c93217$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $8df1b266d7b10633$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $44c600a9437aff7c$export$fff89137e9e818ce);
            this.history.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            }));
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastRawMoveEventInfo = info;
            this.lastMoveEventInfo = $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (this.dragSnapToOrigin || !this.startEvent) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $caca2cdd35c93217$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $8260b027ce2c0643$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event);
        const initialInfo = $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $44c600a9437aff7c$export$fff89137e9e818ce);
        this.history = [
            (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            })
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $caca2cdd35c93217$var$getPanInfo(initialInfo, this.history));
        // Listen in the capture phase so a descendant calling
        // stopPropagation() (e.g. in its own pointerup handler) can't
        // prevent the gesture from ending. See #2794.
        const eventOptions = {
            passive: true,
            capture: true
        };
        this.removeListeners = (0, $113d54600cb8d2d0$export$a4627e546088548d)((0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove, eventOptions), (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp, eventOptions), (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp, eventOptions));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
}
function $caca2cdd35c93217$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $caca2cdd35c93217$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $caca2cdd35c93217$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $caca2cdd35c93217$var$subtractPoint(point, $caca2cdd35c93217$var$lastDevicePoint(history)),
        offset: $caca2cdd35c93217$var$subtractPoint(point, $caca2cdd35c93217$var$startDevicePoint(history)),
        velocity: $caca2cdd35c93217$var$getVelocity(history, 0.1)
    };
}
function $caca2cdd35c93217$var$startDevicePoint(history) {
    return history[0];
}
function $caca2cdd35c93217$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $caca2cdd35c93217$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $caca2cdd35c93217$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(timeDelta) * 2) timestampedPoint = history[1];
    const time = (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $1e37744b98f775f4$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $1e37744b98f775f4$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $1e37744b98f775f4$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $1e37744b98f775f4$export$690c180aa5775042(layoutBox.x, left, right),
        y: $1e37744b98f775f4$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $1e37744b98f775f4$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $1e37744b98f775f4$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $1e37744b98f775f4$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $1e37744b98f775f4$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $1e37744b98f775f4$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $69391feb435da50e$export$c1c127004b72a37)(source);
    const targetLength = (0, $69391feb435da50e$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $1e37744b98f775f4$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $1e37744b98f775f4$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $1e37744b98f775f4$export$7c5eaef8f4723d22(dragElastic = $1e37744b98f775f4$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $1e37744b98f775f4$export$a3366d3bac43a742;
    return {
        x: $1e37744b98f775f4$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $1e37744b98f775f4$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $1e37744b98f775f4$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a35deb4b2fbeb723$export$f0a15892c27dc07c = new WeakMap();
class $a35deb4b2fbeb723$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            if (snapToCursor) this.snapToCursor((0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event).point);
            this.stopAnimation();
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $34c0dc4b9011d4ce$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin and pointer offset
             */ (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $f1a72de1b348da89$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $69391feb435da50e$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            (0, $5d399ca24ed34089$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $a35deb4b2fbeb723$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>onDrag(event, info), false, true);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>{
            const { dragSnapToOrigin: snap } = this.getProps();
            if (snap || this.constraints) this.startAnimation({
                x: 0,
                y: 0
            });
        };
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $caca2cdd35c93217$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $4089e47ff1a2b128$export$d533d84f9871c879)(this.visualElement),
            element: this.visualElement.current
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.endPanSession();
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ endPanSession() {
        this.panSession && this.panSession.end();
        this.panSession = undefined;
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $1e37744b98f775f4$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _this_visualElement_projection;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_this_visualElement_projection = this.visualElement.projection) === null || _this_visualElement_projection === void 0 ? void 0 : _this_visualElement_projection.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $1e37744b98f775f4$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $1e37744b98f775f4$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $1e37744b98f775f4$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $881a839ff5ec248c$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $19758d730238f0ed$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        /**
         * Refresh the root scroll offset so the constraint's viewport box
         * translates to correct page coordinates. The scroll captured at
         * drag mount can be stale if the document was scrolled afterwards —
         * e.g. via the browser restoring scroll on refresh, or an ancestor
         * layout effect running after this element's mount (#2829).
         *
         * Clear the cached scroll first so `updateScroll` bypasses its
         * per-animationId cache and re-reads the live value.
         */ if (projection.root) {
            projection.root.scroll = undefined;
            projection.root.updateScroll();
        }
        const constraintsBox = (0, $b3c78c86be367659$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $1e37744b98f775f4$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $fd94cc0f2e3ce586$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $fd94cc0f2e3ce586$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition, transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $5d399ca24ed34089$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $17ccdc0a04fec700$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        var _this_visualElement_latestValues_axis;
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_this_visualElement_latestValues_axis = this.visualElement.latestValues[axis]) !== null && _this_visualElement_latestValues_axis !== void 0 ? _this_visualElement_latestValues_axis : 0);
    }
    snapToCursor(point) {
        (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ const current = axisValue.get() || 0;
                axisValue.set(point[axis] - (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, max, 0.5) + current);
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $1e37744b98f775f4$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
        /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $a35deb4b2fbeb723$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            const target = event.target;
            /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ const isClickingTextInputChild = target !== element && (0, $86168a8dbbef73c2$export$41e5a41992b76128)(target);
            if (drag && dragListener && !isClickingTextInputChild) this.start(event);
        });
        /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ let stopResizeObservers;
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) {
                this.constraints = this.resolveRefConstraints();
                if (!stopResizeObservers) stopResizeObservers = $a35deb4b2fbeb723$var$startResizeObservers(element, dragConstraints.current, ()=>this.scalePositionWithinConstraints());
            }
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $44c600a9437aff7c$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
            stopResizeObservers && stopResizeObservers();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $1e37744b98f775f4$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    }
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
}
function $a35deb4b2fbeb723$var$skipFirstCall(callback) {
    let isFirst = true;
    return ()=>{
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function $a35deb4b2fbeb723$var$startResizeObservers(element, constraintsElement, onResize) {
    const stopElement = (0, $e568be821d367350$export$4380c87abf28fdf)(element, $a35deb4b2fbeb723$var$skipFirstCall(onResize));
    const stopContainer = (0, $e568be821d367350$export$4380c87abf28fdf)(constraintsElement, $a35deb4b2fbeb723$var$skipFirstCall(onResize));
    return ()=>{
        stopElement();
        stopContainer();
    };
}
function $a35deb4b2fbeb723$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $a35deb4b2fbeb723$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $4c6ddc74cf07a272$export$5d97dc2872682820 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $69d49105ec21595d$export$8793edee2d425525);
    }
    update() {
        const { dragControls: dragControls } = this.node.getProps();
        const { dragControls: prevDragControls } = this.node.prevProps || {};
        if (dragControls !== prevDragControls) {
            this.removeGroupControls();
            if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        }
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
        /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $69d49105ec21595d$export$8793edee2d425525);
        this.removeListeners = (0, $69d49105ec21595d$export$8793edee2d425525);
        this.controls = new (0, $a35deb4b2fbeb723$export$86bff71f18910307)(node);
    }
}







const $11e1e830cf2014df$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>handler(event, info), false, true);
    };
class $11e1e830cf2014df$export$b4f8f1ee75ce5859 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $caca2cdd35c93217$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $4089e47ff1a2b128$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $11e1e830cf2014df$var$asyncHandler(onPanSessionStart),
            onStart: $11e1e830cf2014df$var$asyncHandler(onPanStart),
            onMove: $11e1e830cf2014df$var$asyncHandler(onPan),
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $69d49105ec21595d$export$8793edee2d425525);
    }
}





/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $694c3c23f78cdf80$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $0b8f44c4758488da$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $7fPBF.useId)();
    (0, $7fPBF.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $7fPBF.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $0b8f44c4758488da$export$8249053f690ea39a() {
    return $0b8f44c4758488da$export$ee27c052bca048fb((0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2)));
}
function $0b8f44c4758488da$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $fb4bab01f29b923f$var$hasTakenAnySnapshot = false;
class $fb4bab01f29b923f$var$MeasureLayoutWithContext extends (0, $7fPBF.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($fb4bab01f29b923f$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, projection.options), {
                layoutDependency: this.props.layoutDependency,
                onExitComplete: ()=>this.safeToRemove()
            }));
        }
        (0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (prevProps.layoutDependency !== layoutDependency) projection.setOptions((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, projection.options), {
            layoutDependency: layoutDependency
        }));
        $fb4bab01f29b923f$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { visualElement: visualElement, layoutAnchor: layoutAnchor } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.options.layoutAnchor = layoutAnchor;
            projection.root.didUpdate();
            (0, $4cb138f42ee448c1$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $fb4bab01f29b923f$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $fb4bab01f29b923f$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $0b8f44c4758488da$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95));
    return (0, $824c049f32d4395d$exports.jsx)($fb4bab01f29b923f$var$MeasureLayoutWithContext, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $7fPBF.useContext)((0, $813b6750233d847f$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}








function $e55ee0bef2336500$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value : (0, $eba58299b894994c$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $17ccdc0a04fec700$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}







const $7fcf3f225d921b82$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};





/**
 * Timeout defined in ms
 */ function $6e43bd716ab08f1a$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $44c600a9437aff7c$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(checkElapsed);
}
function $6e43bd716ab08f1a$export$fcd451ca460f8a2a(callback, timeout) {
    return $6e43bd716ab08f1a$export$1391212d75b2ee65(callback, (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(timeout));
}




/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $ee6f5690d36d6bc6$export$66957ea77182581d(element) {
    return (0, $d21d6497287d50b6$export$17eda790a720ec57)(element) && element.tagName === "svg";
}









const $ff0afc6dee0cd7ca$var$numBorders = (0, $184da4a7f0af456c$export$41ef21965ed84e7a).length;
const $ff0afc6dee0cd7ca$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $ff0afc6dee0cd7ca$var$isPx = (value)=>typeof value === "number" || (0, $f1a72de1b348da89$export$91c0eda1d06bf008).test(value);
function $ff0afc6dee0cd7ca$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _follow_opacity, _lead_opacity;
    if (shouldCrossfadeOpacity) {
        var _lead_opacity1;
        target.opacity = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(0, (_lead_opacity1 = lead.opacity) !== null && _lead_opacity1 !== void 0 ? _lead_opacity1 : 1, $ff0afc6dee0cd7ca$var$easeCrossfadeIn(progress));
        var _follow_opacity1;
        target.opacityExit = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)((_follow_opacity1 = follow.opacity) !== null && _follow_opacity1 !== void 0 ? _follow_opacity1 : 1, 0, $ff0afc6dee0cd7ca$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)((_follow_opacity = follow.opacity) !== null && _follow_opacity !== void 0 ? _follow_opacity : 1, (_lead_opacity = lead.opacity) !== null && _lead_opacity !== void 0 ? _lead_opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $ff0afc6dee0cd7ca$var$numBorders; i++){
        const borderLabel = (0, $184da4a7f0af456c$export$41ef21965ed84e7a)[i];
        let followRadius = $ff0afc6dee0cd7ca$var$getRadius(follow, borderLabel);
        let leadRadius = $ff0afc6dee0cd7ca$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $ff0afc6dee0cd7ca$var$isPx(followRadius) === $ff0afc6dee0cd7ca$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)($ff0afc6dee0cd7ca$var$asNumber(followRadius), $ff0afc6dee0cd7ca$var$asNumber(leadRadius), progress), 0);
            if ((0, $f1a72de1b348da89$export$626336c2cd4b14de).test(leadRadius) || (0, $f1a72de1b348da89$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $ff0afc6dee0cd7ca$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
const $ff0afc6dee0cd7ca$var$easeCrossfadeIn = /*@__PURE__*/ $ff0afc6dee0cd7ca$var$compress(0, 0.5, (0, $e4064fe071cf16bf$export$c8d67a19199d1a50));
const $ff0afc6dee0cd7ca$var$easeCrossfadeOut = /*@__PURE__*/ $ff0afc6dee0cd7ca$var$compress(0.5, 0.95, (0, $69d49105ec21595d$export$8793edee2d425525));
function $ff0afc6dee0cd7ca$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $e6c55823fed0ff43$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $e6c55823fed0ff43$export$c53fd88f45d77e4b(box, originBox) {
    $e6c55823fed0ff43$export$a0230ae482601ae8(box.x, originBox.x);
    $e6c55823fed0ff43$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $e6c55823fed0ff43$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $a22a0dc53072c11b$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $0043a8a3eeedd876$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $0043a8a3eeedd876$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $a22a0dc53072c11b$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $f1a72de1b348da89$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $a22a0dc53072c11b$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a22a0dc53072c11b$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a22a0dc53072c11b$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $a22a0dc53072c11b$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $a22a0dc53072c11b$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $a22a0dc53072c11b$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a22a0dc53072c11b$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $a22a0dc53072c11b$export$42b76f1d0d16d5b(box.x, transforms, $a22a0dc53072c11b$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $a22a0dc53072c11b$export$42b76f1d0d16d5b(box.y, transforms, $a22a0dc53072c11b$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $f090a83eda83ce9a$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $f090a83eda83ce9a$export$a7ec7642fe550fb6(delta) {
    return $f090a83eda83ce9a$var$isAxisDeltaZero(delta.x) && $f090a83eda83ce9a$var$isAxisDeltaZero(delta.y);
}
function $f090a83eda83ce9a$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $f090a83eda83ce9a$export$8d5cf76bb7daff09(a, b) {
    return $f090a83eda83ce9a$export$7a9a6f114ddd0fdb(a.x, b.x) && $f090a83eda83ce9a$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $f090a83eda83ce9a$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $f090a83eda83ce9a$export$ef641b782d85522(a, b) {
    return $f090a83eda83ce9a$export$22adf28bfca1c186(a.x, b.x) && $f090a83eda83ce9a$export$22adf28bfca1c186(a.y, b.y);
}
function $f090a83eda83ce9a$export$c5706146bc63213(box) {
    return (0, $69391feb435da50e$export$c1c127004b72a37)(box.x) / (0, $69391feb435da50e$export$c1c127004b72a37)(box.y);
}
function $f090a83eda83ce9a$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $9df5309f0cf07ef5$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $3fbb49f840f4b07a$export$20e507e47fae79fd)(this.members, node);
        for(let i = this.members.length - 1; i >= 0; i--){
            const member = this.members[i];
            if (member === node || member === this.lead || member === this.prevLead) continue;
            const inst = member.instance;
            if ((!inst || inst.isConnected === false) && !member.snapshot) {
                (0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.members, member);
                member.unmount();
            }
        }
        node.scheduleRender();
    }
    remove(node) {
        (0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        for(let i = this.members.indexOf(node) - 1; i >= 0; i--){
            var _member_instance;
            const member = this.members[i];
            if (member.isPresent !== false && ((_member_instance = member.instance) === null || _member_instance === void 0 ? void 0 : _member_instance.isConnected) !== false) {
                this.promote(member);
                return true;
            }
        }
        return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.updateSnapshot();
            node.scheduleRender();
            const { layoutDependency: prevDep } = prevLead.options;
            const { layoutDependency: nextDep } = node.options;
            if (prevDep === undefined || prevDep !== nextDep) {
                var _node_root;
                node.resumeFrom = prevLead;
                if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                if (prevLead.snapshot) {
                    node.snapshot = prevLead.snapshot;
                    node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                }
                if ((_node_root = node.root) === null || _node_root === void 0 ? void 0 : _node_root.isUpdating) node.isLayoutDirty = true;
            }
            if (node.options.crossfade === false) prevLead.hide();
        }
    }
    exitAnimationComplete() {
        this.members.forEach((member)=>{
            var _member_options_onExitComplete, _member_options, _member_resumingFrom_options_onExitComplete, _member_resumingFrom, _member_resumingFrom_options;
            (_member_options_onExitComplete = (_member_options = member.options).onExitComplete) === null || _member_options_onExitComplete === void 0 ? void 0 : _member_options_onExitComplete.call(_member_options);
            (_member_resumingFrom = member.resumingFrom) === null || _member_resumingFrom === void 0 ? void 0 : (_member_resumingFrom_options_onExitComplete = (_member_resumingFrom_options = _member_resumingFrom.options).onExitComplete) === null || _member_resumingFrom_options_onExitComplete === void 0 ? void 0 : _member_resumingFrom_options_onExitComplete.call(_member_resumingFrom_options);
        });
    }
    scheduleRender() {
        this.members.forEach((member)=>member.instance && member.scheduleRender(false));
    }
    removeLeadSnapshot() {
        var _this_lead;
        if ((_this_lead = this.lead) === null || _this_lead === void 0 ? void 0 : _this_lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}


function $9a7afe62da049e74$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, pathRotation: pathRotation, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        // Additive `rotate()` so user `rotate` isn't clobbered.
        if (pathRotation) transform += `rotate(${pathRotation}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}




const $a535f9dde2d7ff9c$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e519d4bf7457ef44$export$1465d17e3de78a96 {
    add(child) {
        (0, $3fbb49f840f4b07a$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $a535f9dde2d7ff9c$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}





const $a7634071eff95f0f$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $a7634071eff95f0f$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $a7634071eff95f0f$var$animationTarget = 1000;
let $a7634071eff95f0f$var$id = 0;
function $a7634071eff95f0f$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $a7634071eff95f0f$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $dedda87bce0b0fc0$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $44c600a9437aff7c$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $a7634071eff95f0f$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $a7634071eff95f0f$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $530b27a3f7a9b181$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $d21d6497287d50b6$export$17eda790a720ec57)(instance) && !(0, $ee6f5690d36d6bc6$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $6e43bd716ab08f1a$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($a7634071eff95f0f$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $a7634071eff95f0f$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $f090a83eda83ce9a$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $445378a930c6db37$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged, animationOptions.path);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $a7634071eff95f0f$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($a7634071eff95f0f$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $a7634071eff95f0f$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                const wasBlockedByResize = this.updateBlockedByResize;
                this.unblockUpdate();
                this.updateBlockedByResize = false;
                this.clearAllSnapshots();
                /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach($a7634071eff95f0f$var$forceLayoutMeasure);
                this.nodes.forEach($a7634071eff95f0f$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($a7634071eff95f0f$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($a7634071eff95f0f$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach($a7634071eff95f0f$var$ensureDraggedNodesSnapshotted);
                /**
                 * Write
                 */ this.nodes.forEach($a7634071eff95f0f$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($a7634071eff95f0f$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($a7634071eff95f0f$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).delta = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp);
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp = now;
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing = true;
            (0, $44c600a9437aff7c$export$1811c3a7e3af92f0).update.process((0, $44c600a9437aff7c$export$fff89137e9e818ce));
            (0, $44c600a9437aff7c$export$1811c3a7e3af92f0).preRender.process((0, $44c600a9437aff7c$export$fff89137e9e818ce));
            (0, $44c600a9437aff7c$export$1811c3a7e3af92f0).render.process((0, $44c600a9437aff7c$export$fff89137e9e818ce));
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $4cb138f42ee448c1$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($a7634071eff95f0f$var$clearSnapshot);
            this.sharedNodes.forEach($a7634071eff95f0f$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $69391feb435da50e$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $69391feb435da50e$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            if (!this.layoutCorrected) this.layoutCorrected = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $f090a83eda83ce9a$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $a7634071eff95f0f$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _this_scroll;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) || this.path.some($a7634071eff95f0f$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _this_scroll;
            const boxWithoutScroll = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false, output) {
            var _this_layout;
            const withTransforms = output || (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                var _node_layout;
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(withTransforms.x, -node.scroll.offset.x);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(withTransforms.y, -node.scroll.offset.y);
                }
                if (!(0, $8f62b661d366a749$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $0043a8a3eeedd876$export$58b16271041fbfb)(withTransforms, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
            }
            if ((0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues)) (0, $0043a8a3eeedd876$export$58b16271041fbfb)(withTransforms, this.latestValues, (_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.layoutBox);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                var _node_snapshot;
                const node = this.path[i];
                if (!(0, $8f62b661d366a749$export$a545127cf1fbb600)(node.latestValues)) continue;
                let sourceBox;
                if (node.instance) {
                    (0, $8f62b661d366a749$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                    sourceBox = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(sourceBox, node.measurePageBox());
                }
                (0, $a22a0dc53072c11b$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_node_snapshot = node.snapshot) === null || _node_snapshot === void 0 ? void 0 : _node_snapshot.layoutBox, sourceBox);
            }
            if ((0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues)) (0, $a22a0dc53072c11b$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, options), {
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            });
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _this_parent;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $69391feb435da50e$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                else (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $0043a8a3eeedd876$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $8f62b661d366a749$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $8f62b661d366a749$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            this.relativeTargetOrigin = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $69391feb435da50e$export$2785bfcc929c5650)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            var _this_parent;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $0043a8a3eeedd876$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $e6c55823fed0ff43$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $e6c55823fed0ff43$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $69391feb435da50e$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $f090a83eda83ce9a$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $f090a83eda83ce9a$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _this_options_visualElement;
            (_this_options_visualElement = this.options.visualElement) === null || _this_options_visualElement === void 0 ? void 0 : _this_options_visualElement.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
            this.projectionDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false, pathFn) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.latestValues);
            const targetDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($a7634071eff95f0f$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            // The path decides whether the layout shift is worth curving
            // (distance floor) and resolves the interpolator from the delta.
            const interpolate = pathFn === null || pathFn === void 0 ? void 0 : pathFn.interpolateProjection(delta);
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                const point = interpolate === null || interpolate === void 0 ? void 0 : interpolate(progress);
                if (point) {
                    targetDelta.x.translate = point.x;
                    targetDelta.x.scale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.x.scale, 1, progress);
                    targetDelta.x.origin = delta.x.origin;
                    targetDelta.x.originPoint = delta.x.originPoint;
                    targetDelta.y.translate = point.y;
                    targetDelta.y.scale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.y.scale, 1, progress);
                    targetDelta.y.origin = delta.y.origin;
                    targetDelta.y.originPoint = delta.y.originPoint;
                } else {
                    $a7634071eff95f0f$var$mixAxisDeltaLinear(targetDelta.x, delta.x, progress);
                    $a7634071eff95f0f$var$mixAxisDeltaLinear(targetDelta.y, delta.y, progress);
                }
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $69391feb435da50e$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || undefined);
                    $a7634071eff95f0f$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $f090a83eda83ce9a$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $ff0afc6dee0cd7ca$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                if (point && point.rotate !== undefined) {
                    // Dedicated `pathRotation` channel, not `rotate`, so an
                    // animating `rotate` is composed with, never clobbered.
                    if (!this.animationValues) this.animationValues = mixedValues;
                    this.animationValues.pathRotation = point.rotate;
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            var _this_currentAnimation, _this_resumingFrom_currentAnimation, _this_resumingFrom;
            this.notifyListeners("animationStart");
            (_this_currentAnimation = this.currentAnimation) === null || _this_currentAnimation === void 0 ? void 0 : _this_currentAnimation.stop();
            (_this_resumingFrom = this.resumingFrom) === null || _this_resumingFrom === void 0 ? void 0 : (_this_resumingFrom_currentAnimation = _this_resumingFrom.currentAnimation) === null || _this_resumingFrom_currentAnimation === void 0 ? void 0 : _this_resumingFrom_currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>{
                (0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.motionValue || (this.motionValue = (0, $eba58299b894994c$export$ce8bdc721e76545f)(0));
                this.motionValue.jump(0, false);
                this.currentAnimation = (0, $e55ee0bef2336500$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                }));
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($a7634071eff95f0f$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $a7634071eff95f0f$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                const xLength = (0, $69391feb435da50e$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $69391feb435da50e$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $0043a8a3eeedd876$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $69391feb435da50e$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $9df5309f0cf07ef5$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _this_getStack;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.lead) || this : this;
        }
        getPrevLead() {
            var _this_getStack;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $a7634071eff95f0f$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $a7634071eff95f0f$var$transformAxes.length; i++){
                $a7634071eff95f0f$var$resetDistortingTransform(`rotate${$a7634071eff95f0f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $a7634071eff95f0f$var$resetDistortingTransform(`skew${$a7634071eff95f0f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $9a7afe62da049e74$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            var _valuesToRender_opacity, _ref;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? (_ref = (_valuesToRender_opacity = valuesToRender.opacity) !== null && _valuesToRender_opacity !== void 0 ? _valuesToRender_opacity : this.latestValues.opacity) !== null && _ref !== void 0 ? _ref : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $e69bce41e90c0a87$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $e69bce41e90c0a87$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _node_currentAnimation;
                return (_node_currentAnimation = node.currentAnimation) === null || _node_currentAnimation === void 0 ? void 0 : _node_currentAnimation.stop();
            });
            this.root.nodes.forEach($a7634071eff95f0f$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $a7634071eff95f0f$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.nodes = $a7634071eff95f0f$var$metrics.calculatedTargetDeltas = $a7634071eff95f0f$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($a7634071eff95f0f$export$131f2f0cc5fe9609);
                this.nodes.forEach($a7634071eff95f0f$var$resolveTargetDelta);
                this.nodes.forEach($a7634071eff95f0f$var$calcProjection);
                this.nodes.forEach($a7634071eff95f0f$export$c2664f37bc951031);
                if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).addProjectionMetrics) (0, $7fcf3f225d921b82$export$84ce9a476f53d110).addProjectionMetrics($a7634071eff95f0f$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e519d4bf7457ef44$export$1465d17e3de78a96)();
        }
    };
}
function $a7634071eff95f0f$var$updateLayout(node) {
    node.updateLayout();
}
function $a7634071eff95f0f$var$notifyLayoutUpdate(node) {
    var _node_resumeFrom;
    const snapshot = ((_node_resumeFrom = node.resumeFrom) === null || _node_resumeFrom === void 0 ? void 0 : _node_resumeFrom.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $69391feb435da50e$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            const snapAxis = animationType === "x" ? "y" : "x";
            (0, $e6c55823fed0ff43$export$a0230ae482601ae8)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if ($a7634071eff95f0f$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $69391feb435da50e$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
        (0, $69391feb435da50e$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
        if (isShared) (0, $69391feb435da50e$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $69391feb435da50e$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $f090a83eda83ce9a$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const anchor = node.options.layoutAnchor || undefined;
                    const relativeSnapshot = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $69391feb435da50e$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    const relativeLayout = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $69391feb435da50e$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, $f090a83eda83ce9a$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $a7634071eff95f0f$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $a7634071eff95f0f$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $a7634071eff95f0f$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $a7634071eff95f0f$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $a7634071eff95f0f$var$forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function $a7634071eff95f0f$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function $a7634071eff95f0f$var$ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function $a7634071eff95f0f$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $a7634071eff95f0f$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $a7634071eff95f0f$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $a7634071eff95f0f$var$calcProjection(node) {
    node.calcProjection();
}
function $a7634071eff95f0f$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $a7634071eff95f0f$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $a7634071eff95f0f$var$mixAxisDeltaLinear(output, delta, p) {
    output.translate = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $a7634071eff95f0f$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $a7634071eff95f0f$export$6ffd3e6ae339a132(output, from, to, p) {
    $a7634071eff95f0f$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $a7634071eff95f0f$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $a7634071eff95f0f$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $a7634071eff95f0f$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $a7634071eff95f0f$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $a7634071eff95f0f$var$roundPoint = $a7634071eff95f0f$var$userAgentContains("applewebkit/") && !$a7634071eff95f0f$var$userAgentContains("chrome/") ? Math.round : (0, $69d49105ec21595d$export$8793edee2d425525);
function $a7634071eff95f0f$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $a7634071eff95f0f$var$roundPoint(axis.min);
    axis.max = $a7634071eff95f0f$var$roundPoint(axis.max);
}
function $a7634071eff95f0f$var$roundBox(box) {
    $a7634071eff95f0f$var$roundAxis(box.x);
    $a7634071eff95f0f$var$roundAxis(box.y);
}
function $a7634071eff95f0f$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $69391feb435da50e$export$28d0384c4b79bde2)((0, $f090a83eda83ce9a$export$c5706146bc63213)(snapshot), (0, $f090a83eda83ce9a$export$c5706146bc63213)(layout), 0.2);
}
function $a7634071eff95f0f$var$checkNodeWasScrollRoot(node) {
    var _node_scroll;
    return node !== node.root && ((_node_scroll = node.scroll) === null || _node_scroll === void 0 ? void 0 : _node_scroll.wasRoot);
}




const $b00564a5cf5376d5$export$2d029a49a09b6177 = (0, $a7634071eff95f0f$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>{
        var _document_body, _document_body1;
        return {
            x: document.documentElement.scrollLeft || ((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.scrollLeft) || 0,
            y: document.documentElement.scrollTop || ((_document_body1 = document.body) === null || _document_body1 === void 0 ? void 0 : _document_body1.scrollTop) || 0
        };
    },
    checkIsScrollRoot: ()=>true
});


const $df5100f59fd5f7c7$export$b91509fcf893b648 = {
    current: undefined
};
const $df5100f59fd5f7c7$export$b61a9eb3dbde8858 = (0, $a7634071eff95f0f$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$df5100f59fd5f7c7$export$b91509fcf893b648.current) {
            const documentNode = new (0, $b00564a5cf5376d5$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $df5100f59fd5f7c7$export$b91509fcf893b648.current = documentNode;
        }
        return $df5100f59fd5f7c7$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $58aa614d3a6a82b6$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $11e1e830cf2014df$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $4c6ddc74cf07a272$export$5d97dc2872682820),
        ProjectionNode: (0, $df5100f59fd5f7c7$export$b61a9eb3dbde8858),
        MeasureLayout: $fb4bab01f29b923f$export$779f5fb01ad751cd
    }
};






function $25bb4b427e2bca4e$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $6709e3be20d4c81f$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        passive: true
    }, options), {
        signal: gestureAbortController.signal
    });
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $1f2a858d47bdd163$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $712c7e4e4b7d1d34$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $1f2a858d47bdd163$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $25bb4b427e2bca4e$export$edc0ace9d5e7e842)(elementOrSelector, options);
    elements.forEach((element)=>{
        let isPressed = false;
        let deferredHoverEnd = false;
        let hoverEndCallback;
        const removePointerLeave = ()=>{
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        const endHover = (event)=>{
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        const onPointerUp = (event)=>{
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        const onPointerDown = ()=>{
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        const onPointerLeave = (leaveEvent)=>{
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        const onPointerEnter = (enterEvent)=>{
            if (!$1f2a858d47bdd163$var$isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            const onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}



function $cc9187ec974de0d4$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event)));
}
class $cc9187ec974de0d4$export$93a81ea037eac456 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $1f2a858d47bdd163$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $cc9187ec974de0d4$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$cc9187ec974de0d4$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}




class $78cbf4a00036ebdd$export$d4826db40d47595b extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $113d54600cb8d2d0$export$a4627e546088548d)((0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}





/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $80af6ff61bd6e9d1$export$1b3bfaa9684536aa(element) {
    return (0, $d93f81859b2d5a5f$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $14401caf9c9c2c14$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $14401caf9c9c2c14$export$e841ada32ff745b(parent, child.parentElement);
};





const $45665e91e5eab086$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $383fd3a718194f0b$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $383fd3a718194f0b$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $383fd3a718194f0b$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $383fd3a718194f0b$var$filterEvents(()=>{
        if ((0, $45665e91e5eab086$export$7987404a4e35b84b).has(element)) return;
        $383fd3a718194f0b$var$firePointerEvent(element, "down");
        const handleKeyup = $383fd3a718194f0b$var$filterEvents(()=>{
            $383fd3a718194f0b$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$383fd3a718194f0b$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $53da3250d6db73d2$var$isValidPressEvent(event) {
    return (0, $8260b027ce2c0643$export$a4cf9c8a4b063a6e)(event) && !(0, $712c7e4e4b7d1d34$export$1b3dd616664938e4)();
}
const $53da3250d6db73d2$var$claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $53da3250d6db73d2$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $25bb4b427e2bca4e$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$53da3250d6db73d2$var$isValidPressEvent(startEvent)) return;
        if ($53da3250d6db73d2$var$claimedPointerDownEvents.has(startEvent)) return;
        (0, $45665e91e5eab086$export$7987404a4e35b84b).add(target);
        if (options.stopPropagation) $53da3250d6db73d2$var$claimedPointerDownEvents.add(startEvent);
        const onPressEnd = onPressStart(target, startEvent);
        /**
         * End listeners run in the capture phase so a descendant calling
         * stopPropagation() in its own pointerup handler can't prevent the
         * press gesture from ending. This also keeps the gesture-end
         * ordering consistent with the drag gesture. See #2794.
         */ const endEventOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, eventOptions), {
            capture: true
        });
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp, endEventOptions);
            window.removeEventListener("pointercancel", onPointerCancel, endEventOptions);
            if ((0, $45665e91e5eab086$export$7987404a4e35b84b).has(target)) (0, $45665e91e5eab086$export$7987404a4e35b84b).delete(target);
            if (!$53da3250d6db73d2$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $14401caf9c9c2c14$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, endEventOptions);
        window.addEventListener("pointercancel", onPointerCancel, endEventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $80af6ff61bd6e9d1$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $383fd3a718194f0b$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $86168a8dbbef73c2$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}



function $1ff4529f1b09a613$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event)));
}
class $1ff4529f1b09a613$export$f026abdbba7f0c9e extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        const { globalTapTarget: globalTapTarget, propagate: propagate } = this.node.props;
        this.unmount = (0, $53da3250d6db73d2$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $1ff4529f1b09a613$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$1ff4529f1b09a613$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: globalTapTarget,
            stopPropagation: (propagate === null || propagate === void 0 ? void 0 : propagate.tap) === false
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 

const $d711141c523810a9$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $d711141c523810a9$var$observers = new WeakMap();
const $d711141c523810a9$var$fireObserverCallback = (entry)=>{
    const callback = $d711141c523810a9$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $d711141c523810a9$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($d711141c523810a9$var$fireObserverCallback);
};
function $d711141c523810a9$var$initIntersectionObserver(_param) {
    var { root: root } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "root"
    ]);
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$d711141c523810a9$var$observers.has(lookupRoot)) $d711141c523810a9$var$observers.set(lookupRoot, {});
    const rootObservers = $d711141c523810a9$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($d711141c523810a9$var$fireAllObserverCallbacks, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        root: root
    }, options));
    return rootObservers[key];
}
function $d711141c523810a9$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $d711141c523810a9$var$initIntersectionObserver(options);
    $d711141c523810a9$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $d711141c523810a9$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $13f3207f49b45e2c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $13f3207f49b45e2c$export$150851c8cc2f0c72 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    startObserver() {
        var _this_stopObserver, _this;
        (_this_stopObserver = (_this = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this);
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $13f3207f49b45e2c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        this.stopObserver = (0, $d711141c523810a9$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($13f3207f49b45e2c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {
        var _this_stopObserver, _this;
        (_this_stopObserver = (_this = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $13f3207f49b45e2c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $55b9f4465d1c76fa$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $13f3207f49b45e2c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $1ff4529f1b09a613$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $78cbf4a00036ebdd$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $cc9187ec974de0d4$export$93a81ea037eac456)
    }
};




const $55377c4d7156276f$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $df5100f59fd5f7c7$export$b61a9eb3dbde8858),
        MeasureLayout: $fb4bab01f29b923f$export$779f5fb01ad751cd
    }
};


const $937872241f1f7f1f$export$d596cd8841d25433 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $9bb9392be544c52d$export$7f9953c70dacfd7f), (0, $55b9f4465d1c76fa$export$e5b72898e5a201f1), (0, $58aa614d3a6a82b6$export$d7d5d435647ed5a0), (0, $55377c4d7156276f$export$b3219800bda33a1f));


const $682ba43d460c7b6e$export$e25e478948902b8b = /*@__PURE__*/ (0, $832dbbf8caa22976$export$a28d6df673050e18)((0, $937872241f1f7f1f$export$d596cd8841d25433), (0, $782ff79d5f331768$export$56ba0183203348f5));




var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $505ae97bb14ecd76$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, $ab7a52d88671d240$export$6476d16e2fd2d0db).current && (0, $904a5ee8b5b90ab9$export$ca9f41fb23dded3d)();
    const [shouldReduceMotion] = (0, $7fPBF.useState)((0, $ab7a52d88671d240$export$ff7706047246b98b).current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}



var $7fPBF = parcelRequire("7fPBF");
let $6b389fa467c067a6$var$_ = (t)=>t, $6b389fa467c067a6$var$t, $6b389fa467c067a6$var$t1;
const $6b389fa467c067a6$var$Container = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($6b389fa467c067a6$var$t || ($6b389fa467c067a6$var$t = $6b389fa467c067a6$var$_`
    display: contents;
`));
const $6b389fa467c067a6$var$ItemWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $682ba43d460c7b6e$export$e25e478948902b8b).div)($6b389fa467c067a6$var$t1 || ($6b389fa467c067a6$var$t1 = $6b389fa467c067a6$var$_`
    display: flex;
    flex: ${0};
    height: 100%;
    overflow: clip;
`), (p)=>p.$fullWidth ? '1' : '0 1 auto');
const $6b389fa467c067a6$var$animationVariants = {
    fadeInUp: {
        hidden: {
            opacity: 0,
            y: 24
        },
        visible: {
            opacity: 1,
            y: 0
        }
    }
};
function $6b389fa467c067a6$export$2e2bcd8739ae039({ children: children, trigger: trigger = true, staggerDelay: staggerDelay = 120, baseDuration: baseDuration = 420, animation: animation = 'fadeInUp', startDelay: startDelay = 0, onComplete: onComplete, fullWidth: fullWidth = false }) {
    const items = (0, $7fPBF.useMemo)(()=>(0, $7fPBF.Children).toArray(children).filter(Boolean), [
        children
    ]);
    const [running, setRunning] = (0, $7fPBF.useState)(false);
    const reducedMotion = (0, $505ae97bb14ecd76$export$6a42007cf1e7b6f8)();
    (0, $7fPBF.useEffect)(()=>{
        setRunning(false);
        if (!trigger) return;
        const t = window.setTimeout(()=>setRunning(true), startDelay);
        return ()=>clearTimeout(t);
    }, [
        trigger,
        startDelay,
        items.length
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!running || items.length === 0) return;
        const total = (items.length - 1) * staggerDelay + baseDuration;
        const t = window.setTimeout(()=>onComplete === null || onComplete === void 0 ? void 0 : onComplete(), total);
        return ()=>clearTimeout(t);
    }, [
        running,
        items.length,
        staggerDelay,
        baseDuration,
        onComplete
    ]);
    var _animationVariants_animation;
    const variants = (_animationVariants_animation = $6b389fa467c067a6$var$animationVariants[animation]) !== null && _animationVariants_animation !== void 0 ? _animationVariants_animation : $6b389fa467c067a6$var$animationVariants.fadeInUp;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6b389fa467c067a6$var$Container, {
        children: items.map((child, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6b389fa467c067a6$var$ItemWrapper, {
                $fullWidth: fullWidth,
                initial: "hidden",
                animate: running ? 'visible' : 'hidden',
                variants: reducedMotion ? {
                    hidden: {
                        opacity: 1
                    },
                    visible: {
                        opacity: 1
                    }
                } : variants,
                transition: {
                    duration: baseDuration / 1000,
                    delay: i * staggerDelay / 1000,
                    ease: [
                        0.4,
                        0,
                        0.2,
                        1
                    ]
                },
                children: /*#__PURE__*/ (0, $7fPBF.isValidElement)(child) ? child : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: child
                })
            }, i))
    });
}












var $7fPBF = parcelRequire("7fPBF");


let $30ba1e267b5a3af7$var$_ = (t)=>t, $30ba1e267b5a3af7$var$t;
function $30ba1e267b5a3af7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, membership: membership, isLoading: isLoading, canEditOrganizationProfiles: canEditOrganizationProfiles, isManagedOrg: isManagedOrg, canManageBilling: canManageBilling } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const [orgProfiles, setOrgProfiles] = (0, $7fPBF.useState)([]);
    const [loadingProfiles, setLoadingProfiles] = (0, $7fPBF.useState)(true);
    const [filter, setFilter] = (0, $7fPBF.useState)('');
    const myRole = membership ? (0, $d227fca458ea4785$export$68befc518ea2400f)(membership) : undefined;
    const canManage = (myRole === null || myRole === void 0 ? void 0 : myRole.canEditOrganizationProfiles) || (myRole === null || myRole === void 0 ? void 0 : myRole.isAdmin);
    (0, $7fPBF.useEffect)(()=>{
        const loadProfiles = async ()=>{
            if (!(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id)) return;
            setLoadingProfiles(true);
            try {
                const result = await $1a4c36336f303477$export$244d7766d2df1442(currentOrg.id);
                if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && result.data) setOrgProfiles(result.data);
            } catch (error) {
                console.error('Error loading organization profiles:', error);
            } finally{
                setLoadingProfiles(false);
            }
        };
        if (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id) loadProfiles();
    }, [
        currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id
    ]);
    const filteredProfiles = (0, $7fPBF.useMemo)(()=>{
        if (!filter) return orgProfiles;
        const lowerFilter = filter.toLowerCase();
        return orgProfiles.filter((profile)=>{
            var _profile_description;
            return profile.name.toLowerCase().includes(lowerFilter) || ((_profile_description = profile.description) === null || _profile_description === void 0 ? void 0 : _profile_description.toLowerCase().includes(lowerFilter));
        });
    }, [
        orgProfiles,
        filter
    ]);
    const handleSearchChange = (e)=>{
        setFilter(e.target.value);
    };
    const handleClearSearch = ()=>{
        setFilter('');
    };
    const handleNavigateToProfile = (profileId, preview)=>{
        const destination = preview ? `./preview/${profileId}` : `./edit/${profileId}`;
        navigate(destination);
    };
    const handleCreateProfile = ()=>{
        navigate('./new');
    };
    if (!currentOrg || isLoading || loadingProfiles) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.profiles.title', {
                    value: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name
                }),
                description: t('common:organization.profiles.description'),
                items: items
            }),
            isExpiredOrg ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
                organizationId: currentOrg.id,
                canManageBilling: canManageBilling,
                isManagedOrg: isManagedOrg,
                customBillingUrl: currentOrg.customBillingUrl
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    canManage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "solidAccent",
                        $dashed: true,
                        startIcon: "plus",
                        onClick: handleCreateProfile,
                        children: t('common:profile.create')
                    }),
                    orgProfiles.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                        label: t('common:profile.search'),
                        value: filter,
                        onChange: handleSearchChange,
                        onClear: handleClearSearch
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9926e0d0274623af$export$ce6636bfa4e9f0e8), {
                        children: [
                            filteredProfiles.length === 0 && filter && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t('common:search.noResults')
                            }),
                            filteredProfiles.length === 0 && !filter && canManage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
                                fullHeight: true,
                                description: t('common:organization.profiles.empty'),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    $color: "primary",
                                    startIcon: "plus",
                                    onClick: handleCreateProfile,
                                    children: t('common:profile.create')
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b389fa467c067a6$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                children: filteredProfiles.map((profile)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
                                        startComponent: profile.defaultLocale && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($30ba1e267b5a3af7$var$IconSpan, {
                                            children: (0, $3ecd3f7dea3d56de$export$a1451363a805f944)[profile.defaultLocale]
                                        }),
                                        title: profile.name,
                                        description: profile.description,
                                        onClick: ()=>handleNavigateToProfile(profile.id, !canEditOrganizationProfiles),
                                        iconSize: 24
                                    }, profile.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $30ba1e267b5a3af7$var$IconSpan = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($30ba1e267b5a3af7$var$t || ($30ba1e267b5a3af7$var$t = $30ba1e267b5a3af7$var$_`
    ${0}
    line-height: 0;
    display: flex;
    align-items: center;
`), (0, $b091aef3a32d2bd8$export$734b24ef8489e701));





























var $7fPBF = parcelRequire("7fPBF");


function $f5d4d30d0c746c1c$export$2e2bcd8739ae039({ value: value, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleUpdate = (value)=>{
        onUpdate(value);
    };
    const customCommands = (0, $7fPBF.useMemo)(()=>{
        return (0, $85b654349d31b699$export$7a6092e2ae7e1845)().map((cmd)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cmd), {
                buttonProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cmd.buttonProps), {
                    'aria-label': t(`editor.${cmd.name}`),
                    title: t(`editor.${cmd.name}`),
                    style: {
                        height: '2rem',
                        width: '2rem'
                    }
                }),
                icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: cmd.icon
                })
            }));
    }, [
        t
    ]);
    const extraCommands = (0, $7fPBF.useMemo)(()=>{
        return (0, $85b654349d31b699$export$6e591f5fe2c6ad02)().map((cmd)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cmd), {
                buttonProps: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cmd.buttonProps), {
                    'aria-label': t(`editor.${cmd.name}`),
                    title: t(`editor.${cmd.name}`),
                    style: {
                        height: '2rem',
                        width: '2rem'
                    }
                })
            }));
    }, [
        t
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a046c90ce2b9f87e$export$2e2bcd8739ae039), {
            defaultTabEnable: false,
            height: 600,
            value: value,
            commands: customCommands,
            extraCommands: extraCommands,
            onChange: handleUpdate,
            textareaProps: {
                placeholder: t('editor.placeholder'),
                maxLength: 12000
            },
            previewOptions: {
                disallowedElements: [
                    'style',
                    'script',
                    'language-js',
                    'language-css'
                ],
                rehypePlugins: [
                    [
                        (0, $952077a98b509239$export$2e2bcd8739ae039)
                    ]
                ]
            }
        })
    });
}












let $deb5be3631cfd11d$var$_ = (t)=>t, $deb5be3631cfd11d$var$t, $deb5be3631cfd11d$var$t1, $deb5be3631cfd11d$var$t2, $deb5be3631cfd11d$var$t3;
function $deb5be3631cfd11d$export$2e2bcd8739ae039({ organization: organization }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('common');
    // Absent on older API responses, which means email was never disabled for the organization.
    const allowsEmails = !organization.disableCephableEmails;
    const isScimEnabled = !!organization.isScimEnabled;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('organization.settings.managed.title'),
                description: t('organization.settings.managed.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($deb5be3631cfd11d$var$ManagedCard, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($deb5be3631cfd11d$var$ManagedRow, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                        children: t('organization.settings.managed.email.title')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: allowsEmails ? t('organization.settings.managed.email.allowedDescription') : t('organization.settings.managed.email.blockedDescription')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($deb5be3631cfd11d$var$StateWrap, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8f303ae5b091ff2$export$2e2bcd8739ae039), {
                                        title: t('organization.settings.managed.email.title'),
                                        value: allowsEmails ? t('on') : t('off'),
                                        hideLabel: true
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                                        checked: allowsEmails,
                                        disabled: true,
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    }),
                    isScimEnabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($deb5be3631cfd11d$var$ManagedRow, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                        children: t('organization.settings.managed.scim.title')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                        children: t('organization.settings.managed.scim.description')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($deb5be3631cfd11d$var$StateWrap, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8f303ae5b091ff2$export$2e2bcd8739ae039), {
                                        title: t('organization.settings.managed.scim.title'),
                                        value: t('on'),
                                        hideLabel: true
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f5b9af76a0c38b$export$b5d5cf8927ab7262), {
                                        checked: true,
                                        disabled: true,
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($deb5be3631cfd11d$var$LockedNote, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                name: "settings"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                                children: t('organization.settings.managed.lockedNote')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $deb5be3631cfd11d$var$ManagedCard = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$a30053b04ba33ef5))($deb5be3631cfd11d$var$t || ($deb5be3631cfd11d$var$t = $deb5be3631cfd11d$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
`));
const $deb5be3631cfd11d$var$ManagedRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($deb5be3631cfd11d$var$t1 || ($deb5be3631cfd11d$var$t1 = $deb5be3631cfd11d$var$_`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;

    & > div:first-of-type {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
    }
`));
const $deb5be3631cfd11d$var$StateWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($deb5be3631cfd11d$var$t2 || ($deb5be3631cfd11d$var$t2 = $deb5be3631cfd11d$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
`));
const $deb5be3631cfd11d$var$LockedNote = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($deb5be3631cfd11d$var$t3 || ($deb5be3631cfd11d$var$t3 = $deb5be3631cfd11d$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    border-top: 1px solid ${0};
    padding-top: 0.75rem;
`), (props)=>props.theme.color.border);


let $37c9dbb5637bee33$var$_ = (t)=>t, $37c9dbb5637bee33$var$t;
function $37c9dbb5637bee33$export$2e2bcd8739ae039({ sendToPortal: sendToPortal }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg, membership: membership, isLoading: isLoading, canManageBilling: canManageBilling } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { handleInputChange: handleInputChange, handleUpdateWithAlerts: handleUpdateWithAlerts, editOrganization: editOrganization, hasChanges: hasChanges } = (0, $2d24843f3708c077$export$15de29966ec5486a)(currentOrg !== null && currentOrg !== void 0 ? currentOrg : null);
    if (!currentOrg || !editOrganization || !membership) return null;
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    var _editOrganization_name, _editOrganization_description, _editOrganization_customResourcesMarkdown;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            membership.isAdmin && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                        title: t('common:organization.settings.general.title')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0f22230e48d02ba$export$2e2bcd8739ae039), {
                        licenseType: (0, $427978696205d868$export$5122f57547dc8eca)(currentOrg)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e78d309b5c4bb4$export$2e2bcd8739ae039), {
                                value: (_editOrganization_name = editOrganization.name) !== null && _editOrganization_name !== void 0 ? _editOrganization_name : '',
                                onUpdate: (field, value)=>handleInputChange(field, value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                                value: (_editOrganization_description = editOrganization.description) !== null && _editOrganization_description !== void 0 ? _editOrganization_description : '',
                                onUpdate: (field, value)=>handleInputChange(field, value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                        title: t('common:organization.settings.resources.edit'),
                        description: t('common:organization.settings.resources.description')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5d4d30d0c746c1c$export$2e2bcd8739ae039), {
                        value: (_editOrganization_customResourcesMarkdown = editOrganization === null || editOrganization === void 0 ? void 0 : editOrganization.customResourcesMarkdown) !== null && _editOrganization_customResourcesMarkdown !== void 0 ? _editOrganization_customResourcesMarkdown : '',
                        onUpdate: (value)=>handleInputChange('customResourcesMarkdown', value !== null && value !== void 0 ? value : '')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.member.aboutMe')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82c7f1922904df08$export$2e2bcd8739ae039), {
                member: membership
            }),
            membership.isAdmin && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $deb5be3631cfd11d$export$2e2bcd8739ae039), {
                        organization: currentOrg
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                        title: t('common:organization.settings.other.title')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6e1b40cb257f60f$export$2e2bcd8739ae039), {
                        currentOrg: currentOrg,
                        canManageBilling: canManageBilling
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                $visuallyHide: !hasChanges,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    disabled: !hasChanges,
                    onClick: async ()=>await handleUpdateWithAlerts(),
                    children: t('common:save')
                })
            })
        ]
    });
}
const $37c9dbb5637bee33$var$Row = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($37c9dbb5637bee33$var$t || ($37c9dbb5637bee33$var$t = $37c9dbb5637bee33$var$_`
    margin: 1rem;
`));





function $077db4f25b761cd8$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    if (!currentOrg || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:settings.orgTitle', {
                    value: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name
                }),
                description: t('common:organization.settings.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $37c9dbb5637bee33$export$2e2bcd8739ae039), {})
        ]
    });
}
















parcelRequire("7fPBF");




const $dd50f9e7fc2705de$var$DeprecatedHotkeyDialog = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const hotkeys = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hotkeys);
    const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.macros);
    const isDeprecatedHotkey = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isDeprecatedHotkey);
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const onConfirm = async ()=>{
        hotkeys.forEach((hotkey)=>{
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            hotkey.command.startsWith((0, $f44f3a5bc46b1c4c$export$b617c310e3426257)) || (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateDeprecatedHotkey(hotkey, macros);
        });
        const result = await (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().saveChanges();
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') {
            var _result_data;
            (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setIsDeprecatedHotkey(false);
            navigate(`/profiles/edit/${result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.id}`, {
                replace: true
            });
        }
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setIsDeprecatedHotkey(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: isDeprecatedHotkey,
        onClose: onConfirm,
        description: t('common:hotkey.deprecatedDialog.description1'),
        title: t('common:hotkey.deprecatedDialog.title'),
        onConfirm: onConfirm,
        confirmButtonText: t('common:hotkey.deprecatedDialog.confirm'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
            children: t('common:hotkey.deprecatedDialog.description2')
        })
    });
};
var $dd50f9e7fc2705de$export$2e2bcd8739ae039 = $dd50f9e7fc2705de$var$DeprecatedHotkeyDialog;






var $7fPBF = parcelRequire("7fPBF");
























const $abf1344db012a77a$export$7e892870081a5226 = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    function prepareHotkeysForCopyMacro(macro, hotkeys) {
        const newMacro = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, macro);
        const commands = macro.commands;
        const newHotkeys = [
            ...hotkeys
        ];
        newMacro.commands.forEach((c, i)=>{
            if (c.commandType === 'hotkey') {
                const hkLocalId = (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
                const displayName = c.command.replace((0, $f44f3a5bc46b1c4c$export$b617c310e3426257), '');
                newHotkeys.push({
                    localId: hkLocalId,
                    command: c.command + '_copy',
                    displayName: t('common:hotkey.copySuffix', displayName + '_copy', {
                        name: displayName
                    }),
                    macroLocalId: macro.id
                });
                newMacro.commands[i] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, commands[i]), {
                    command: c.command + '_copy',
                    hotkeyLocalId: hkLocalId
                });
            }
        });
        newMacro.id = (0, $6810e10b84975c3e$export$2e2bcd8739ae039)();
        newMacro.name = t('common:macros.copySuffix', macro.name + '_copy', {
            name: macro.name
        });
        return {
            newMacro: newMacro,
            hotkeys: newHotkeys
        };
    }
    return prepareHotkeysForCopyMacro;
};



var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");
function $33444986c68d8356$export$bd0e99c4527b3b17() {
    const filter = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.filter);
    const hotkeys = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hotkeys);
    const prepareHotkeysForCopyMacro = (0, $abf1344db012a77a$export$7e892870081a5226)();
    const [macroToAddCommand, setMacroToAddCommand] = (0, $7fPBF.useState)();
    const [editingMacroIndex, setEditingMacroIndex] = (0, $7fPBF.useState)();
    // ── Search ────────────────────────────────────────────────────────────────
    const handleSearchChange = (e)=>{
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setFilter(e.target.value);
    };
    const handleClearSearch = ()=>{
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setFilter('');
    };
    // ── Macro-level actions ───────────────────────────────────────────────────
    const copyMacro = (macro)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        const cloneMacro = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).cloneDeep(macro);
        const preparedCopy = prepareHotkeysForCopyMacro(cloneMacro, hotkeys);
        const updatedMacros = [
            (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, preparedCopy.newMacro),
            ...macros
        ];
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
    };
    const handleRemoveMacro = (macro)=>{
        var _macro_commands;
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        (_macro_commands = macro.commands) === null || _macro_commands === void 0 ? void 0 : _macro_commands.forEach((c)=>{
            if (c.commandType === 'hotkey') (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().removeHotkeyFromMacro(c);
        });
        const updatedMacros = macros.filter((h)=>h !== macro);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
    };
    const handleMacroChange = (updatedMacro)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        const updatedMacros = macros.map((m)=>m.id === updatedMacro.id ? updatedMacro : m);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
    };
    const handleNameChange = (text, macro)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        const updatedMacros = macros.map((m)=>m.id === macro.id ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                name: text
            }) : m);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
    };
    // ── Step actions ─────────────────────────────────────────────────────────
    const handleAddStep = (macroIndex)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        const updatedMacros = macros.map((m, i)=>{
            if (i !== macroIndex) return m;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                events: [
                    ...m.events,
                    {
                        eventType: 'KeyPress',
                        keys: [
                            ''
                        ],
                        holdTimeMilliseconds: 0
                    }
                ]
            });
        });
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
    };
    // ── Command actions ───────────────────────────────────────────────────────
    const handleCommandChange = (value, macro, index)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        const originalValue = macro.commands[index].command;
        const commandType = macro.commands[index].commandType;
        let hotkeyLocalId = macro.commands[index].hotkeyLocalId;
        if (commandType === 'hotkey') {
            const hotkeyId = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateHotkeyFromMacro(value, macro, index, originalValue);
            hotkeyLocalId = hotkeyId !== null && hotkeyId !== void 0 ? hotkeyId : null;
        }
        const updatedMacros = macros.map((m)=>{
            if (m.id !== macro.id) return m;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                commands: m.commands.map((c, i)=>i === index ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, c), {
                        command: value,
                        hotkeyLocalId: hotkeyLocalId
                    }) : c)
            });
        });
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
    };
    const handleRemoveCommand = (_command, macro, index)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        const c = macro.commands[index];
        const updatedMacros = macros.map((m)=>{
            if (m.id !== macro.id) return m;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                commands: m.commands.filter((_, i)=>i !== index)
            });
        });
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
        if (c.commandType === 'hotkey') (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().removeHotkeyFromMacro(c);
    };
    const handleAddCommand = (macro)=>{
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        setMacroToAddCommand(macro);
    };
    const handleAddCommandWithType = (macro, commandType)=>{
        const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().macros;
        setMacroToAddCommand(undefined);
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
        if (!macro) return;
        const updatedMacros = macros.map((m)=>{
            if (m.id !== macro.id) return m;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                commands: [
                    ...m.commands,
                    {
                        command: '',
                        commandType: commandType
                    }
                ]
            });
        });
        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateMacros(updatedMacros);
    };
    return {
        // state
        filter: filter,
        macroToAddCommand: macroToAddCommand,
        setMacroToAddCommand: setMacroToAddCommand,
        editingMacroIndex: editingMacroIndex,
        setEditingMacroIndex: setEditingMacroIndex,
        handleSearchChange: // search
        handleSearchChange,
        handleClearSearch: handleClearSearch,
        copyMacro: // macro
        copyMacro,
        handleRemoveMacro: handleRemoveMacro,
        handleMacroChange: handleMacroChange,
        handleNameChange: handleNameChange,
        handleAddStep: // steps
        handleAddStep,
        handleCommandChange: // commands
        handleCommandChange,
        handleRemoveCommand: handleRemoveCommand,
        handleAddCommand: handleAddCommand,
        handleAddCommandWithType: handleAddCommandWithType
    };
}





let $d7cbb52506443fe8$var$_ = (t)=>t, $d7cbb52506443fe8$var$t, $d7cbb52506443fe8$var$t1, $d7cbb52506443fe8$var$t2;
function $d7cbb52506443fe8$export$87aba18bb0c42cdf({ selectRef: selectRef, addMacroHref: addMacroHref, onNewMacro: onNewMacro, disabled: disabled = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const macros = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.macros);
    const { filter: filter, macroToAddCommand: macroToAddCommand, setMacroToAddCommand: setMacroToAddCommand, editingMacroIndex: editingMacroIndex, setEditingMacroIndex: setEditingMacroIndex, handleSearchChange: handleSearchChange, handleClearSearch: handleClearSearch, copyMacro: copyMacro, handleRemoveMacro: handleRemoveMacro, handleMacroChange: handleMacroChange, handleNameChange: handleNameChange, handleAddStep: handleAddStep, handleCommandChange: handleCommandChange, handleRemoveCommand: handleRemoveCommand, handleAddCommand: handleAddCommand, handleAddCommandWithType: handleAddCommandWithType } = (0, $33444986c68d8356$export$bd0e99c4527b3b17)();
    const { filteredMacros: filteredMacros } = (0, $138dae19c52184af$export$2e2bcd8739ae039)({
        profile: (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState(),
        filter: filter
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$MacroControlWrap, {
                ref: selectRef,
                children: [
                    macros.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51af5a17187af6b5$export$2e2bcd8739ae039), {
                        value: filter,
                        onChange: handleSearchChange,
                        onClear: handleClearSearch
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        id: "new-macro-control",
                        $color: "solidAccent",
                        $dashed: true,
                        startIcon: "plus",
                        disabled: disabled,
                        to: "./controls/new",
                        children: t('common:macros.add')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$12253aa05c1176e2), {
                children: filteredMacros === null || filteredMacros === void 0 ? void 0 : filteredMacros.map((h, i)=>{
                    var _h_commands, _h_events;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfa8aa82a863cabd$export$2e2bcd8739ae039), {
                        macro: h,
                        alwaysShowIcons: true,
                        id: h.id,
                        children: editingMacroIndex === i ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$EditWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        disabled: disabled,
                                        label: t('common:macros.name.title'),
                                        value: h.name,
                                        name: `${i}name`,
                                        placeholder: t('common:macros.name.placeholder'),
                                        onChange: (e)=>handleNameChange(e.target.value, h)
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:input.titlePlural')
                                }),
                                (_h_commands = h.commands) === null || _h_commands === void 0 ? void 0 : _h_commands.map((c, ci)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0cb68ea454bd64de$export$2e2bcd8739ae039), {
                                        value: c.command,
                                        commandType: c.commandType,
                                        onChange: (value)=>handleCommandChange(value, h, ci),
                                        onRemove: ()=>handleRemoveCommand(c.command, h, ci)
                                    }, h.id + ci)),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "text",
                                        startIcon: "plus",
                                        onClick: ()=>handleAddCommand(h),
                                        children: t('common:input.addMore')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e7e100f470a300$export$1acdcf5a973a8414), {
                                    children: t('common:event.titlePlural')
                                }),
                                (_h_events = h.events) === null || _h_events === void 0 ? void 0 : _h_events.map((e, ei)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3546a67590dd0db1$export$2e2bcd8739ae039), {
                                        macro: h,
                                        step: e,
                                        stepIndex: ei,
                                        onChange: (macro)=>handleMacroChange(macro)
                                    }, ei)),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "text",
                                        startIcon: "plus",
                                        onClick: ()=>handleAddStep(i),
                                        children: t('common:event.add')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$ButtonContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "secondary",
                                            $size: "small",
                                            startIcon: "replicateRows",
                                            onClick: ()=>copyMacro(h),
                                            children: t('common:copy')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "secondary",
                                            $size: "small",
                                            startIcon: "delete",
                                            onClick: ()=>handleRemoveMacro(h),
                                            children: t('common:delete')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                            $color: "primary",
                                            $size: "small",
                                            onClick: ()=>setEditingMacroIndex(undefined),
                                            children: t('common:finishEdit')
                                        })
                                    ]
                                })
                            ]
                        }, i) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2169ab088e8080bb$export$f2170af9598ce20e), {
                            macro: h,
                            showTitle: false,
                            id: h.id,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($d7cbb52506443fe8$var$ButtonContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "secondary",
                                        $size: "small",
                                        startIcon: "edit",
                                        onClick: ()=>setEditingMacroIndex(i),
                                        children: t('common:edit')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "secondary",
                                        $size: "small",
                                        startIcon: "replicateRows",
                                        onClick: ()=>copyMacro(h),
                                        children: t('common:copy')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                        $color: "secondary",
                                        $size: "small",
                                        startIcon: "delete",
                                        onClick: ()=>handleRemoveMacro(h),
                                        children: t('common:delete')
                                    })
                                ]
                            })
                        })
                    }, h.id);
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd50f9e7fc2705de$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4321e97835f672ea$export$2e2bcd8739ae039), {
                open: !!macroToAddCommand,
                onClose: ()=>setMacroToAddCommand(undefined),
                onCommandTypeSelected: (commandType)=>handleAddCommandWithType(macroToAddCommand, commandType)
            })
        ]
    });
}
const $d7cbb52506443fe8$var$MacroControlWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d7cbb52506443fe8$var$t || ($d7cbb52506443fe8$var$t = $d7cbb52506443fe8$var$_`
    flex-basis: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    padding: 1rem 0;
`));
const $d7cbb52506443fe8$var$ButtonContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d7cbb52506443fe8$var$t1 || ($d7cbb52506443fe8$var$t1 = $d7cbb52506443fe8$var$_`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    margin: 2rem 0;
`));
const $d7cbb52506443fe8$var$EditWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($d7cbb52506443fe8$var$t2 || ($d7cbb52506443fe8$var$t2 = $d7cbb52506443fe8$var$_`
    box-shadow: none;
    border-top: none;
    border-radius: 10px;
    padding: 1rem;
    width: 100%;
    > * {
        max-width: calc(100% - 2rem);
    }
`));


function $21f89ae18675d949$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    var _useScrollToQueryParam;
    const selectRef = (_useScrollToQueryParam = (0, $c449c760a7ee086f$export$29bdea29542a2205)()) !== null && _useScrollToQueryParam !== void 0 ? _useScrollToQueryParam : undefined;
    const hasChanges = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.hasChanges);
    const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.id);
    const originatedByProfileId = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.originatedByProfileId);
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const commandKeyMappings = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.commandKeyMappings);
    const [macroToAddCommand, setMacroToAddCommand] = (0, $7fPBF.useState)();
    const handleSave = async ()=>{
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        editProfileStore.setOrganizationId(organizationId !== null && organizationId !== void 0 ? organizationId : null);
        const result = await editProfileStore.saveChanges();
        if (result.resultType === 'Ok' && result.data) {
            if (organizationId) navigate(`/org/${result.data.organizationId}/profiles/edit/${result.data.id}`);
            else navigate(`/profiles/edit/${result.data.id}`);
        }
        return result;
    };
    const handleAddCommandWithType = (macro, commandType)=>{
        setMacroToAddCommand(undefined);
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        editProfileStore.setHasChanges(true);
        if (!macro) return;
        const updatedMacros = editProfileStore.macros.map((m)=>{
            if (m.id !== macro.id) return m;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, m), {
                commands: [
                    ...m.commands,
                    {
                        command: '',
                        commandType: commandType
                    }
                ]
            });
        });
        editProfileStore.updateMacros(updatedMacros);
    };
    const saveAndExit = async ()=>{
        await handleSave();
    };
    if (!commandKeyMappings) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d7cbb52506443fe8$export$87aba18bb0c42cdf), {
                selectRef: selectRef,
                disabled: isPreview,
                addMacroHref: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/controls/new`)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd50f9e7fc2705de$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4321e97835f672ea$export$2e2bcd8739ae039), {
                open: !!macroToAddCommand,
                onClose: ()=>setMacroToAddCommand(undefined),
                onCommandTypeSelected: (commandType)=>handleAddCommandWithType(macroToAddCommand, commandType)
            }),
            hasChanges && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $258cb68b976e3a51$export$2e2bcd8739ae039), {
                hasChanges: hasChanges,
                setHasChanges: (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges,
                onSave: async ()=>{
                    await (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().saveChanges();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcaddb9c30332041$export$de401b45f203ff7f), {
                contentPosition: "center",
                $visuallyHide: !hasChanges || id !== undefined && originatedByProfileId !== undefined && !hasChanges,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "primary",
                    $size: "large",
                    startIcon: "save",
                    onClick: saveAndExit,
                    children: t('common:saveAndFinish')
                })
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");

const $156f799d529efa2e$var$OrgProfileEditPage = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const name = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.name);
    const defaultLocale = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.defaultLocale);
    const description = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.description);
    const { handleLocaleChange: handleLocaleChange } = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
    const headerTextFieldRef = (0, $7fPBF.useRef)(null);
    // TODO text validation but not checking against all profiles
    // TODO add modified version of associated programs editor for org profiles
    // TODO check scroll to for all errors
    // TODO add error validation messaging
    // TODO figure out how to handle device custom controls might need a new container
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bdbd121ff5ebdd35$export$2e2bcd8739ae039), {
                    variant: 'voice',
                    value: defaultLocale || (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec),
                    onChange: handleLocaleChange
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    label: t('common:profile.name'),
                    value: name,
                    placeholder: t('common:profile.nameQuestion'),
                    onChange: (e)=>{
                        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateName(e.target.value);
                        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
                    },
                    ref: headerTextFieldRef
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73229ceea4361fb2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62386b9deba6bf98$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    multiline: true,
                    rows: 3,
                    label: t('common:description'),
                    value: description || '',
                    placeholder: t('common:description'),
                    onChange: (e)=>{
                        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().updateDescription(e.target.value);
                        (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(true);
                    }
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $21f89ae18675d949$export$2e2bcd8739ae039), {})
        ]
    });
};
var $156f799d529efa2e$export$2e2bcd8739ae039 = $156f799d529efa2e$var$OrgProfileEditPage;

























var $7fPBF = parcelRequire("7fPBF");






let $d6a81d2896b045d6$var$_ = (t)=>t, $d6a81d2896b045d6$var$t, $d6a81d2896b045d6$var$t1, $d6a81d2896b045d6$var$t2, $d6a81d2896b045d6$var$t3;
const $d6a81d2896b045d6$export$46453a0401d6cd1a = (0, $8de346382d86c747$export$2e2bcd8739ae039).summary($d6a81d2896b045d6$var$t || ($d6a81d2896b045d6$var$t = $d6a81d2896b045d6$var$_`
    font-weight: 900;
    list-style: none;
    display: flex;
    align-items: center;
    font-weight: 900;
    gap: 0.5rem;
    ${0}
    ::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 10px solid ${0};
        border-inline: 7px solid transparent;
        transition: 0.2s;
    }
`), (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd), (props)=>props.theme.color.text);
const $d6a81d2896b045d6$export$89693000420c0acd = (0, $8de346382d86c747$export$2e2bcd8739ae039).article($d6a81d2896b045d6$var$t1 || ($d6a81d2896b045d6$var$t1 = $d6a81d2896b045d6$var$_`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: ${0};
    p {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: ${0};
    }
`), (props)=>props.theme.color.text, (props)=>props.theme.color.text);
const $d6a81d2896b045d6$export$3e8048d3cf2ba3fd = (0, $8de346382d86c747$export$2e2bcd8739ae039).details($d6a81d2896b045d6$var$t2 || ($d6a81d2896b045d6$var$t2 = $d6a81d2896b045d6$var$_`
    padding: 1rem;
    border-radius: 6px;
    border-left: 4px solid ${0};
    &[open] {
        & > summary::after {
            transform: rotate(180deg);
        }
    }
    &:focus-within {
        outline: ${0} auto 2px;
    }
`), (props)=>props.theme.color.text, (props)=>props.theme.color.text);
const $d6a81d2896b045d6$export$cf345ef34cd72655 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($d6a81d2896b045d6$var$t3 || ($d6a81d2896b045d6$var$t3 = $d6a81d2896b045d6$var$_`
    font-weight: 100;
`));


function $c09a3f0eb9fc1127$export$2e2bcd8739ae039({ icon: icon, title: title, subtitle: subtitle, children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d6a81d2896b045d6$export$3e8048d3cf2ba3fd), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d6a81d2896b045d6$export$46453a0401d6cd1a), {
                children: [
                    icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                        name: icon
                    }),
                    title,
                    subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6a81d2896b045d6$export$cf345ef34cd72655), {
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6a81d2896b045d6$export$89693000420c0acd), {
                children: children
            })
        ]
    });
}


let $ef18313c3ee7961b$var$_ = (t)=>t, $ef18313c3ee7961b$var$t, $ef18313c3ee7961b$var$t1, $ef18313c3ee7961b$var$t2, $ef18313c3ee7961b$var$t3, $ef18313c3ee7961b$var$t4;
const $ef18313c3ee7961b$export$ee154ca4432ae97f = 'profile_conflict_indicator_id';
const $ef18313c3ee7961b$var$ProfileConflictIndicators = ({ errorOnly: errorOnly = false })=>{
    var _currentUser_userPreferences;
    const profileConflictErrors = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.profileConflictErrors);
    const isProfileConflictsAcknowledged = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isProfileConflictsAcknowledged);
    const profileConflictWarnings = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.profileConflictWarnings);
    const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108)((state)=>state.currentUser);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [scrollElementID, setScrollElementID] = (0, $7fPBF.useState)(null);
    const triggerScroll = (0, $d856e666394c520b$export$2e2bcd8739ae039)(scrollElementID);
    // error and warning conditional checks
    const showErrors = (profileConflictErrors === null || profileConflictErrors === void 0 ? void 0 : profileConflictErrors.length) > 0;
    const showWarningsBecauseNoErrors = !showErrors && (profileConflictWarnings === null || profileConflictWarnings === void 0 ? void 0 : profileConflictWarnings.length) > 0;
    var _currentUser_userPreferences_isWarningConflictIndicatorsOptOut;
    const [userWarningOptOut, setUserWarningOptOut] = (0, $7fPBF.useState)((_currentUser_userPreferences_isWarningConflictIndicatorsOptOut = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_userPreferences = currentUser.userPreferences) === null || _currentUser_userPreferences === void 0 ? void 0 : _currentUser_userPreferences.isWarningConflictIndicatorsOptOut) !== null && _currentUser_userPreferences_isWarningConflictIndicatorsOptOut !== void 0 ? _currentUser_userPreferences_isWarningConflictIndicatorsOptOut : false);
    const showWarnings = !userWarningOptOut && !isProfileConflictsAcknowledged && showWarningsBecauseNoErrors;
    // handlers
    const handleConflictItemClick = (scrollID, pageLink)=>{
        const element = document.getElementById(scrollID);
        if (!element && pageLink) navigate(pageLink);
        else {
            setScrollElementID(scrollID);
            triggerScroll();
        }
    };
    const handleWarningOptOut = async ()=>{
        var _currentUser_userPreferences, _result_errors;
        const currentUser = (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().currentUser;
        var _currentUser_userPreferences_featureFlags;
        const preferences = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentUser === null || currentUser === void 0 ? void 0 : currentUser.userPreferences), {
            isWarningConflictIndicatorsOptOut: !userWarningOptOut,
            featureFlags: (_currentUser_userPreferences_featureFlags = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_userPreferences = currentUser.userPreferences) === null || _currentUser_userPreferences === void 0 ? void 0 : _currentUser_userPreferences.featureFlags) !== null && _currentUser_userPreferences_featureFlags !== void 0 ? _currentUser_userPreferences_featureFlags : []
        });
        const result = await (0, $8a1185b15e8317ab$export$887dff289a6ce108).getState().updateUserPreferences(preferences);
        var _result_errors_join;
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') {
            setUserWarningOptOut(!userWarningOptOut);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:account.success.userPreferences'));
        } else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError((_result_errors_join = result === null || result === void 0 ? void 0 : (_result_errors = result.errors) === null || _result_errors === void 0 ? void 0 : _result_errors.join(', ')) !== null && _result_errors_join !== void 0 ? _result_errors_join : t('common:account.error.userPreferences'));
    };
    if (!showErrors && !showWarnings) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $12a7318cc7b914d5$export$7cee909993ddd8b7), {
        id: $ef18313c3ee7961b$export$ee154ca4432ae97f,
        as: "aside",
        tabIndex: -1,
        children: [
            showErrors && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db7a41c310321878$export$2e2bcd8739ae039), {
                title: t('common:profile.conflictIndicators.errorTitle'),
                icon: "warning",
                color: "error",
                subtitle: t('common:profile.conflictIndicators.subtitle'),
                children: profileConflictErrors === null || profileConflictErrors === void 0 ? void 0 : profileConflictErrors.map((conflictModel, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ef18313c3ee7961b$var$ConflictActionCard, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                                children: conflictModel.title
                            }),
                            conflictModel.subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6), {
                                children: conflictModel.subtitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$ConflictItemsWrap, {
                                children: conflictModel.items.map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$StyledConflictItem, {
                                        startIcon: "warning",
                                        onClick: ()=>handleConflictItemClick(item.scrollID, item.pageLink),
                                        children: item.displayString
                                    }, `${item.key}${idx}_ConflictErrorItem`))
                            })
                        ]
                    }, `${conflictModel.title}${index}_ConflictError`))
            }),
            showWarnings && !errorOnly && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db7a41c310321878$export$2e2bcd8739ae039), {
                title: t('common:profile.conflictIndicators.warningTitle'),
                icon: "warningTriangle",
                color: "warning",
                subtitle: t('common:profile.conflictIndicators.subtitle'),
                children: [
                    profileConflictWarnings === null || profileConflictWarnings === void 0 ? void 0 : profileConflictWarnings.map((conflictModel, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ef18313c3ee7961b$var$ConflictActionCard, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6392222d2b8fb222$export$f37ee4cff56f2c69), {
                                    children: conflictModel.title
                                }),
                                conflictModel.subtitle && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: conflictModel.subtitle
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$ConflictItemsWrap, {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c09a3f0eb9fc1127$export$2e2bcd8739ae039), {
                                        title: t('common:profile.conflictIndicators.warningDetails'),
                                        children: conflictModel.items.map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$StyledConflictItem, {
                                                startIcon: "warningTriangle",
                                                onClick: ()=>handleConflictItemClick(item.scrollID, item.pageLink),
                                                children: item.displayString
                                            }, `${item.key}${idx}_ConflictWarningItem`))
                                    })
                                })
                            ]
                        }, `${conflictModel.title}${index}_ConflictWarning`)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($ef18313c3ee7961b$var$WarningButtonsWrap, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$WarningButtons, {
                                startIcon: "cancel2",
                                $color: "secondary",
                                $size: "small",
                                onClick: ()=>(0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setIsConflictsAcknowledged(true),
                                children: t('common:profile.conflictIndicators.warningIgnore')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ef18313c3ee7961b$var$WarningButtons, {
                                startIcon: "settings",
                                $color: "secondary",
                                $size: "small",
                                onClick: handleWarningOptOut,
                                children: t('common:profile.conflictIndicators.warningDoNotShowAgain')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $ef18313c3ee7961b$var$WarningButtons = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039))($ef18313c3ee7961b$var$t || ($ef18313c3ee7961b$var$t = $ef18313c3ee7961b$var$_`
    &:hover {
        color: ${0} !important;
    }
`), (0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light);
const $ef18313c3ee7961b$var$WarningButtonsWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039))($ef18313c3ee7961b$var$t1 || ($ef18313c3ee7961b$var$t1 = $ef18313c3ee7961b$var$_`
    gap: 1rem;
`));
const $ef18313c3ee7961b$var$ConflictItemsWrap = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$1d02c21cd5285ce0))($ef18313c3ee7961b$var$t2 || ($ef18313c3ee7961b$var$t2 = $ef18313c3ee7961b$var$_`
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0;
`));
const $ef18313c3ee7961b$var$StyledConflictItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $9926e0d0274623af$export$da51057063e69428))($ef18313c3ee7961b$var$t3 || ($ef18313c3ee7961b$var$t3 = $ef18313c3ee7961b$var$_`
    text-align: left;
    justify-content: left;
    text-decoration: underline;
    z-index: 2;
    width: fit-content;
    :hover {
        text-decoration: none;
    }
`));
const $ef18313c3ee7961b$var$ConflictActionCard = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($ef18313c3ee7961b$var$t4 || ($ef18313c3ee7961b$var$t4 = $ef18313c3ee7961b$var$_`
    margin: 1rem 0rem;
`));
var $ef18313c3ee7961b$export$2e2bcd8739ae039 = $ef18313c3ee7961b$var$ProfileConflictIndicators;












var $7fPBF = parcelRequire("7fPBF");



let $afabe4cc9e2cf491$var$_ = (t)=>t, $afabe4cc9e2cf491$var$t;
function $afabe4cc9e2cf491$export$3d73c2564f98ccd9({ disabled: disabled = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $39c9549f68558626$export$45d76561a5302f2b)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const id = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.id);
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const open = Boolean(anchorEl);
    const [dialogConfig, setDialogConfig] = (0, $7fPBF.useState)();
    const handleOpen = (e)=>setAnchorEl(e.currentTarget);
    const handleClose = ()=>setAnchorEl(null);
    const handleDelete = async ()=>{
        if (!id) return;
        const result = await (0, $60065a32b4a31650$export$8689cd9d602d0ad).getState().deleteProfile(id);
        if ((result === null || result === void 0 ? void 0 : result.resultType) == 'Ok') navigate(-1);
    };
    const copyProfile = ()=>{
        showDialog(undefined);
        const editProfileStore = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState();
        if (!editProfileStore.originalProfile) return;
        // Clone the profile with updated name
        const updatedName = t(`common:profile.copy.profileSuffix`, `${editProfileStore.name} (copy)`, {
            name: editProfileStore.name
        });
        const clonedProfile = editProfileStore.getClonedProfile(editProfileStore.originalProfile, editProfileStore.id, updatedName);
        editProfileStore.updateProfileState(clonedProfile);
        editProfileStore.setHasChanges(true);
        // Navigate to appropriate new profile route based on context
        const newProfilePath = organizationId ? `/org/${organizationId}/profiles/new` : '/profiles/create';
        navigate(newProfilePath, {
            replace: true
        });
    };
    const showDialog = (config)=>{
        setDialogConfig(config);
    };
    const closeDialog = ()=>{
        setDialogConfig(undefined);
    };
    const handleShowDialog = (config)=>{
        handleClose(); // Close the popover first
        if (config == 'delete') showDialog(deleteConfig);
        else if (config == 'copy') showDialog(copyConfig);
    };
    const deleteConfig = {
        open: true,
        title: t('common:profile.delete.titleLong'),
        description: t('common:profile.delete.confirmLong'),
        cancelButtonText: t('common:cancel'),
        confirmButtonText: t('common:profile.delete.confirmButton'),
        onConfirm: handleDelete,
        onClose: closeDialog,
        onCancel: closeDialog
    };
    const copyConfig = {
        open: true,
        title: t('common:profile.copy.question'),
        description: t('common:profile.copy.description'),
        cancelButtonText: t('common:cancel'),
        confirmButtonText: t('common:profile.copy.confirm'),
        onConfirm: copyProfile,
        onClose: closeDialog,
        onCancel: closeDialog
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "quick",
                endIcon: "more",
                $size: "small",
                iconSize: 20,
                "aria-describedby": id,
                onClick: handleOpen,
                children: t('common:options')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0be5f260e07bc5b9$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($afabe4cc9e2cf491$var$PopoverContent, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "automation",
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/advanced`),
                            children: t('common:advancedOptions')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "layers",
                            disabled: disabled,
                            href: (0, $0609c53c7172c5fc$export$da6d2f7032b7150b)(`${location.pathname}/advanced/summary`),
                            children: t('common:profile.summary.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "duplicate",
                            disabled: disabled,
                            onClick: ()=>handleShowDialog('copy'),
                            children: t('common:profile.copy.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "userGroups",
                            disabled: disabled,
                            to: `./advanced/share`,
                            children: t('common:profile.share.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            $size: "small",
                            startIcon: "delete",
                            disabled: disabled,
                            onClick: ()=>handleShowDialog('delete'),
                            children: t('common:profile.delete.title')
                        })
                    ]
                })
            }),
            dialogConfig && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, dialogConfig), {
                onClose: closeDialog
            }))
        ]
    });
}
const $afabe4cc9e2cf491$var$PopoverContent = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($afabe4cc9e2cf491$var$t || ($afabe4cc9e2cf491$var$t = $afabe4cc9e2cf491$var$_`
    width: 300px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 1rem;
`));









var $7fPBF = parcelRequire("7fPBF");


let $b1a3a2a9b20cff10$var$_ = (t)=>t, $b1a3a2a9b20cff10$var$t;
function $b1a3a2a9b20cff10$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { profileId: profileId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const matches = (0, $39c9549f68558626$export$2378eb7f5ff86053)();
    const isPreview = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.isPreview);
    const name = (0, $697752726c88b03c$export$9ebe82a12f9194e3)((state)=>state.name);
    const { currentOrg: currentOrg, membership: membership, isLoading: orgLoading, canEditOrganizationProfiles: canEditOrganizationProfiles } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const [isInitialized, setIsInitialized] = (0, $7fPBF.useState)(false);
    const isNew = (profileId === null || profileId === void 0 ? void 0 : profileId.toLowerCase()) === 'new';
    const myRole = membership ? (0, $d227fca458ea4785$export$68befc518ea2400f)(membership) : undefined;
    const canManage = (myRole === null || myRole === void 0 ? void 0 : myRole.canEditOrganizationProfiles) || (myRole === null || myRole === void 0 ? void 0 : myRole.isAdmin);
    // Get title and description from route handle, with fallbacks
    const currentMatch = matches[matches.length - 1];
    const handle = currentMatch === null || currentMatch === void 0 ? void 0 : currentMatch.handle;
    const pageTitle = (handle === null || handle === void 0 ? void 0 : handle.title) ? t(handle.title) : isNew ? t('common:profile.createTitle') : name || t('common:profile.edit');
    const pageDescription = (handle === null || handle === void 0 ? void 0 : handle.description) ? t(handle.description) : undefined;
    (0, $7fPBF.useEffect)(()=>{
        // Don't update if user has unsaved changes (e.g., copying a profile)
        // This check MUST happen before any other logic
        if ((0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().hasChanges) {
            setIsInitialized(true);
            return;
        }
        const getDeviceTypeCustomControls = async ()=>{
            if (!(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id)) return;
            const defaultLocale = (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().defaultLocale || (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().getOrgAvailableCustomControls(currentOrg.id, defaultLocale);
            const orgAvailableCustomControls = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().orgAvailableCustomControls;
            if (!result) (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', t('common:errors.loadCustomControls'));
            else (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setAvailableCustomControls(orgAvailableCustomControls);
            console.log('Available custom controls:', orgAvailableCustomControls);
        };
        const initializeProfile = async ()=>{
            if (orgLoading || !(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id)) return;
            (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setOrganizationId(currentOrg.id);
            if (isNew || !profileId) {
                (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setDefaultProfile((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
                setIsInitialized(true);
            } else if (profileId) {
                const success = await (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().loadOrgPreview(profileId);
                (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setIsPreview(false);
                setIsInitialized(true);
            } else (0, $e7df95de73caec26$export$89b472e03be495df)('alertError', t('common:errors.loadProfile'));
        };
        setIsInitialized(false);
        initializeProfile();
        getDeviceTypeCustomControls();
        return ()=>{
            // Only reset if there are no unsaved changes (e.g., not in the middle of copying)
            if (!(0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().hasChanges) {
                (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setDefaultProfile((0, $3ecd3f7dea3d56de$export$f44b61b0f29ec));
                (0, $697752726c88b03c$export$9ebe82a12f9194e3).getState().setHasChanges(false);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        profileId,
        isNew,
        currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id,
        orgLoading
    ]);
    if (!isInitialized) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: name || pageTitle,
                description: pageDescription,
                items: items,
                children: (handle === null || handle === void 0 ? void 0 : handle.showActions) && profileId && canEditOrganizationProfiles && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b1a3a2a9b20cff10$var$HeaderActions, {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afabe4cc9e2cf491$export$3d73c2564f98ccd9), {
                        disabled: !canManage || isPreview
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef18313c3ee7961b$export$2e2bcd8739ae039), {
                errorOnly: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74e05fac257f9d21$export$910ae8079b2c2852), {})
        ]
    });
}
const $b1a3a2a9b20cff10$var$HeaderActions = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b1a3a2a9b20cff10$var$t || ($b1a3a2a9b20cff10$var$t = $b1a3a2a9b20cff10$var$_`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
`));














var $7fPBF = parcelRequire("7fPBF");







const $37766e6a1a6352f1$export$a58d95327faf613d = {
    createdDate: '',
    modifiedDate: '',
    name: '',
    description: '',
    isPrivate: false,
    isSupported: false,
    isVirtual: false,
    defaultLocale: '',
    supportsVoiceInput: false,
    supportsFaceInput: false,
    supportsGestureInput: false,
    supportsPhysicalInput: false,
    supportsWifi: false,
    supportsDigitalExtensions: false,
    supportsPhysicalExtensions: false,
    supportsKeyboardOutput: false,
    supportsGenericControllerOutput: false,
    supportsXboxControllerOutput: false,
    supportsPlayStationControllerOutput: false,
    supportsNintendoControllerOutput: false,
    supportsTextGeneration: false,
    supportsTextSummarization: false,
    supportsNLUCommands: false,
    supportsEnhancedDictation: false,
    supportsAIWorkflows: false,
    supportsAutoProfileSwitching: false,
    isApplication: true
};
const $37766e6a1a6352f1$export$3d14a40e22c549b = {
    organizationId: '',
    name: '',
    originHost: '',
    createdDate: new Date().toISOString(),
    modifiedDate: new Date().toISOString(),
    tokenAdditionalRedirectUris: [],
    additionalRedirectUris: [],
    authClientScopes: [],
    authClientDeviceTypes: []
};
const $37766e6a1a6352f1$export$7e4b5db9af1d87c4 = (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.map((locale)=>({
        deviceTypeId: '',
        locale: locale,
        title: '',
        shortDescription: '',
        markdownDescription: '',
        markdownOnboardingInstructions: '',
        markdownTroubleshootingInstructions: '',
        iconUrl: '',
        darkModeIconUrl: '',
        createdDate: '',
        updatedDate: '',
        priority: 0,
        isPublic: false
    }));


const $710192f33815db16$export$c9f16ca2d09e032e = (organizationId)=>{
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $37766e6a1a6352f1$export$a58d95327faf613d)), {
        organizationId: organizationId
    });
};
const $710192f33815db16$export$78965615411ef913 = (organizationId)=>{
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $37766e6a1a6352f1$export$3d14a40e22c549b)), {
        organizationId: organizationId
    });
};
const $710192f33815db16$export$e0ee21b9e212f3d0 = (listing)=>{
    if (!listing) return [];
    return listing.map((_param)=>{
        var { createdDate: createdDate, updatedDate: updatedDate, deviceTypeId: deviceTypeId, priority: priority, isPublic: isPublic } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "createdDate",
            "updatedDate",
            "deviceTypeId",
            "priority",
            "isPublic"
        ]);
        return rest;
    });
};
const $710192f33815db16$export$304e7ba006a6c8a3 = (listing)=>{
    var _listing_find, _listing_find1;
    const updatedListing = [
        ...listing
    ];
    const iconLight = ((_listing_find = listing.find((l)=>l.locale === 'en')) === null || _listing_find === void 0 ? void 0 : _listing_find.iconUrl) || '';
    const darkModeIconUrl = ((_listing_find1 = listing.find((l)=>l.locale === 'en')) === null || _listing_find1 === void 0 ? void 0 : _listing_find1.darkModeIconUrl) || '';
    (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.forEach((locale)=>{
        if (!updatedListing.find((l)=>l.locale === locale)) updatedListing.push({
            locale: locale,
            markdownDescription: '',
            markdownOnboardingInstructions: '',
            markdownTroubleshootingInstructions: '',
            title: '',
            shortDescription: '',
            iconUrl: iconLight,
            darkModeIconUrl: darkModeIconUrl
        });
    });
    return updatedListing;
};
const $710192f33815db16$export$6a89f8c462a1c4ca = (customControls, deviceTypeId)=>{
    const updated = [
        ...customControls
    ];
    var _customControls_find;
    const baseEntry = (_customControls_find = customControls.find((c)=>c.locale === 'en')) !== null && _customControls_find !== void 0 ? _customControls_find : customControls[0];
    (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.forEach((locale)=>{
        if (!updated.find((c)=>c.locale === locale)) updated.push({
            id: '',
            createdDate: new Date(),
            modifiedDate: new Date(),
            locale: locale,
            deviceTypeId: deviceTypeId !== null && deviceTypeId !== void 0 ? deviceTypeId : baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.deviceTypeId,
            controls: baseEntry ? baseEntry.controls.map((control)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control)) : []
        });
    });
    return updated;
};






function $4b8a9e84dae5e7a0$export$8f7032ec10a68144(initialModel) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { clientId: clientId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const [editClient, setEditClient, editClientRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(initialModel);
    (0, $7fPBF.useEffect)(()=>{
        if (initialModel) {
            // Create a copy to avoid mutating the original object
            const modelCopy = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialModel);
            setEditClient(modelCopy);
        } else setEditClient((0, $710192f33815db16$export$78965615411ef913)(organizationId || ''));
    }, [
        initialModel
    ]);
    const handleFieldChange = (fieldName, value)=>{
        setEditClient((prevModel)=>prevModel ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevModel), {
                [fieldName]: value
            }) : null);
    };
    const handleInputChange = (fieldName, value)=>{
        handleFieldChange(fieldName, value);
    };
    const createUpdateRequest = ()=>{
        if (editClientRef.current && organizationId) {
            const updatedClient = editClientRef.current;
            return updatedClient;
        }
    };
    const handleUpdate = async ()=>{
        const request = createUpdateRequest();
        try {
            if (!request || !organizationId || !clientId) throw new Error('Missing data');
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().updateOrgAuthClient(organizationId, clientId, request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && (result === null || result === void 0 ? void 0 : result.data)) setEditClient(result.data);
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleCreate = async ()=>{
        const request = createUpdateRequest();
        try {
            if (!request || !organizationId) throw new Error('Missing data');
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().createOrgAuthClient(organizationId, request);
            if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok' && (result === null || result === void 0 ? void 0 : result.data)) setEditClient(result.data);
            return result;
        } catch (error) {
            return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
        }
    };
    const handleAlerts = (result)=>{
        if ((result === null || result === void 0 ? void 0 : result.resultType) === 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:saved'));
        else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
    };
    const handleSave = async ()=>{
        var _editClientRef_current;
        return ((_editClientRef_current = editClientRef.current) === null || _editClientRef_current === void 0 ? void 0 : _editClientRef_current.id) ? await handleUpdate() : await handleCreate();
    };
    const handleSaveWithAlerts = async ()=>{
        const result = await handleSave();
        handleAlerts(result);
        return result;
    };
    return {
        editClient: editClient,
        setEditClient: setEditClient,
        handleFieldChange: handleFieldChange,
        handleInputChange: handleInputChange,
        handleSave: handleSave,
        handleSaveWithAlerts: handleSaveWithAlerts
    };
}






var $7fPBF = parcelRequire("7fPBF");





function $76dd6d0d6f9746d5$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { clientId: clientId, deviceId: deviceId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const orgAuthClients = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgAuthClients);
    const orgDeviceTypes = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.orgDeviceTypes);
    const isLoading = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData.projects);
    const { getOrgAuthClients: getOrgAuthClients, getOrgDeviceTypes: getOrgDeviceTypes } = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
    const [error, setError] = (0, $7fPBF.useState)({
        client: false,
        device: false
    });
    const fetchOrgData = (0, $7fPBF.useCallback)(async ()=>{
        const { currentOrgId: currentOrgId, loadingData: loadingData } = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
        if (!organizationId || currentOrgId == organizationId || loadingData.projects) return;
        try {
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('projects', true);
            await Promise.all([
                getOrgAuthClients(organizationId),
                getOrgDeviceTypes(organizationId)
            ]);
            (0, $55ce97f088539572$export$87aeeca3aeff7121).setState({
                currentOrgId: organizationId
            });
            setError({
                client: false,
                device: false
            });
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.projects.error'));
            setError({
                client: true,
                device: true
            });
        } finally{
            (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().handleLoadingDataChange('projects', false);
        }
    }, [
        organizationId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchOrgData();
    }, [
        fetchOrgData
    ]);
    const currentOrgClient = (0, $7fPBF.useMemo)(()=>{
        if (!orgAuthClients || !clientId) return null;
        var _orgAuthClients_find;
        const client = (_orgAuthClients_find = orgAuthClients === null || orgAuthClients === void 0 ? void 0 : orgAuthClients.find((client)=>client.id === clientId)) !== null && _orgAuthClients_find !== void 0 ? _orgAuthClients_find : null;
        if (!client && error.client === false) setError((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                client: true
            }));
        else if (error.client === true) setError((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                client: false
            }));
        return client;
    }, [
        orgAuthClients,
        clientId
    ]);
    const currentOrgDeviceType = (0, $7fPBF.useMemo)(()=>{
        if (!orgDeviceTypes || !deviceId) return null;
        var _orgDeviceTypes_find;
        const device = (_orgDeviceTypes_find = orgDeviceTypes.find((device)=>device.id === deviceId)) !== null && _orgDeviceTypes_find !== void 0 ? _orgDeviceTypes_find : null;
        if (!device && error.device === false) setError((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                device: true
            }));
        else if (error.device === true) setError((prev)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev), {
                device: false
            }));
        return device;
    }, [
        orgDeviceTypes,
        deviceId
    ]);
    return {
        error: error,
        currentOrgClient: currentOrgClient,
        currentOrgDeviceType: currentOrgDeviceType,
        authClients: orgAuthClients,
        deviceTypes: orgDeviceTypes,
        isLoading: isLoading
    };
}









function $0ec5f0e18dd3ab72$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.projects.upgrade.description'),
        fullHeight: true,
        icon: "virtualApps",
        title: t('common:organization.projects.upgrade.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            href: "https://cephable.com/sdk-trial/",
            target: "_blank",
            startIcon: "plusLight",
            children: t('common:upgrade')
        })
    });
}







var $7fPBF = parcelRequire("7fPBF");






let $3faa7d453f5d11ef$var$_ = (t)=>t, $3faa7d453f5d11ef$var$t, $3faa7d453f5d11ef$var$t1, $3faa7d453f5d11ef$var$t2, $3faa7d453f5d11ef$var$t3, $3faa7d453f5d11ef$var$t4, $3faa7d453f5d11ef$var$t5;
const $3faa7d453f5d11ef$export$22fa1e7523221c6e = (0, $8de346382d86c747$export$2e2bcd8739ae039)('fieldset')($3faa7d453f5d11ef$var$t || ($3faa7d453f5d11ef$var$t = $3faa7d453f5d11ef$var$_`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`));
const $3faa7d453f5d11ef$export$e37cfa0e4472699e = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))($3faa7d453f5d11ef$var$t1 || ($3faa7d453f5d11ef$var$t1 = $3faa7d453f5d11ef$var$_`
    margin-bottom: 0.5rem;
`));
const $3faa7d453f5d11ef$export$9e6d910ccc56f44f = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')($3faa7d453f5d11ef$var$t2 || ($3faa7d453f5d11ef$var$t2 = $3faa7d453f5d11ef$var$_`
    padding: 0.5rem 0;
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-direction: row;
    flex-grow: 1;
`));
const $3faa7d453f5d11ef$export$dbe450127ad7120d = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')($3faa7d453f5d11ef$var$t3 || ($3faa7d453f5d11ef$var$t3 = $3faa7d453f5d11ef$var$_`
    width: 100%;
`));
const $3faa7d453f5d11ef$export$fa089c085574c34c = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6))($3faa7d453f5d11ef$var$t4 || ($3faa7d453f5d11ef$var$t4 = $3faa7d453f5d11ef$var$_`
    transition: all 0.3s;
    color: ${0};
`), ({ theme: theme })=>theme.color.error);
const $3faa7d453f5d11ef$export$a82c6f1cc70eb063 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$1ef657600983666a))($3faa7d453f5d11ef$var$t5 || ($3faa7d453f5d11ef$var$t5 = $3faa7d453f5d11ef$var$_`
    align-self: flex-start;
`));


let $0f47f90096855080$var$_ = (t)=>t, $0f47f90096855080$var$t;
function $0f47f90096855080$export$2e2bcd8739ae039({ initialValues: initialValues = [
    ''
], maxItems: maxItems, placeholder: placeholder = '---', legend: legend, description: description, selectOptions: selectOptions, onChange: onChange, dialogComponent: dialogComponent, createNewItemLabel: createNewItemLabel }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [items, setItems] = (0, $7fPBF.useState)(initialValues.length === 0 ? [
        ''
    ] : initialValues);
    const [error, setError] = (0, $7fPBF.useState)();
    const [isDialogOpenProps, setDialogOpenProps] = (0, $7fPBF.useState)({
        open: false,
        index: -1
    });
    const [errorValues, setErrorValues] = (0, $7fPBF.useState)();
    const inputRefs = (0, $7fPBF.useRef)([]);
    const buttonRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        setItems(initialValues.length === 0 ? [
            ''
        ] : initialValues);
    }, [
        initialValues
    ]);
    const handleAddItem = ()=>{
        if (maxItems && items.length + 1 >= maxItems) setError(t('common:input.maximum', 'Max number of items.', {
            maxItems: maxItems
        }));
        setItems((prevItems)=>{
            const newItems = [
                ...prevItems,
                ''
            ];
            // Schedule a focus on the new field
            setTimeout(()=>{
                var _inputRefs_current_newIndex;
                const newIndex = newItems.length - 1;
                (_inputRefs_current_newIndex = inputRefs.current[newIndex]) === null || _inputRefs_current_newIndex === void 0 ? void 0 : _inputRefs_current_newIndex.focus();
            }, 0);
            return newItems;
        });
    };
    const handleRemoveItem = (index)=>{
        const updatedItems = items.filter((_, i)=>i !== index);
        setItems(updatedItems);
        setError(null);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedItems);
        // Move focus to the next or previous input
        setTimeout(()=>{
            var // If no items left, focus the Add button
            _buttonRef_current, // Focus the next input if available
            _inputRefs_current_index, // Focus the previous input
            _inputRefs_current_;
            if (updatedItems.length === 0) (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.focus();
            else if (inputRefs.current[index]) (_inputRefs_current_index = inputRefs.current[index]) === null || _inputRefs_current_index === void 0 ? void 0 : _inputRefs_current_index.focus();
            else if (inputRefs.current[index - 1]) (_inputRefs_current_ = inputRefs.current[index - 1]) === null || _inputRefs_current_ === void 0 ? void 0 : _inputRefs_current_.focus();
        }, 0);
    };
    const handleChangeItem = (index, value)=>{
        setError(null);
        setErrorValues(null);
        if (items.includes(value)) {
            setErrorValues(value);
            setError(t('common:input.duplicate'));
        }
        const updatedItems = [
            ...items
        ];
        updatedItems[index] = value;
        setItems(updatedItems);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedItems);
    };
    const handleDialogOpen = (index)=>{
        setDialogOpenProps({
            open: true,
            index: index
        });
    };
    const handleDialogClose = ()=>{
        setDialogOpenProps({
            open: false,
            index: -1
        });
    };
    const handleNewItemCreated = (newValue, index)=>{
        var // Focus the updated item
        _inputRefs_current_currentIndex;
        // get current index of where dialog was opened from
        if (index == null || index === -1) return;
        const currentIndex = index;
        // Update the current empty item with the new value
        const updatedItems = [
            ...items
        ];
        updatedItems[currentIndex] = newValue;
        // Update state and notify parent
        setItems(updatedItems);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedItems);
        (_inputRefs_current_currentIndex = inputRefs.current[currentIndex]) === null || _inputRefs_current_currentIndex === void 0 ? void 0 : _inputRefs_current_currentIndex.focus();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                as: "legend",
                children: legend
            }),
            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$dbe450127ad7120d), {
                role: "list",
                children: items.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$9e6d910ccc56f44f), {
                        role: "listitem",
                        children: [
                            selectOptions ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: item,
                                onChange: (e)=>e.target.value === '__open_dialog__' ? handleDialogOpen(index) : handleChangeItem(index, e.target.value),
                                "aria-label": t('common:input.item', 'Item', {
                                    index: index + 1,
                                    label: legend
                                }),
                                error: !!error && errorValues === item,
                                inputRef: (el)=>inputRefs.current[index] = el,
                                children: [
                                    selectOptions.map((option, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                            value: option.value,
                                            children: option.label || option.value
                                        }, i)),
                                    dialogComponent && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($0f47f90096855080$var$CreateMenuItem, {
                                        value: "__open_dialog__",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "plusLight"
                                            }),
                                            createNewItemLabel !== null && createNewItemLabel !== void 0 ? createNewItemLabel : t('common:input.add')
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: item,
                                placeholder: placeholder,
                                onChange: (e)=>handleChangeItem(index, e.target.value),
                                "aria-label": t('common:input.item', 'Item', {
                                    index: index + 1,
                                    label: legend
                                }),
                                error: !!error && errorValues === item,
                                inputRef: (el)=>inputRefs.current[index] = el
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb13d1f471bb27c$export$2e2bcd8739ae039), {
                                hideBorder: true,
                                startIcon: "cancel2",
                                label: t('common:input.removeItem', 'Remove item', {
                                    index: index + 1
                                }),
                                onClick: ()=>handleRemoveItem(index)
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$fa089c085574c34c), {
                role: "alert",
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0295843db55c2695$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                },
                children: (maxItems == undefined || items.length < maxItems) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "accent",
                    startIcon: "plusLight",
                    onClick: handleAddItem,
                    ref: buttonRef,
                    children: t('common:add')
                })
            }),
            dialogComponent && dialogComponent({
                open: isDialogOpenProps.open,
                index: isDialogOpenProps.index,
                onClose: handleDialogClose,
                onCreated: handleNewItemCreated
            })
        ]
    });
}
const $0f47f90096855080$var$CreateMenuItem = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039))($0f47f90096855080$var$t || ($0f47f90096855080$var$t = $0f47f90096855080$var$_`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
`));



var $7fPBF = parcelRequire("7fPBF");

function $86bb7a18b305ac09$export$2e2bcd8739ae039({ additionalRedirectUris: additionalRedirectUris, authCodeRedirectUrlHost: authCodeRedirectUrlHost, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // Compute combined values directly - no state needed
    const displayValues = (0, $7fPBF.useMemo)(()=>{
        return authCodeRedirectUrlHost ? [
            authCodeRedirectUrlHost,
            ...additionalRedirectUris
        ] : [
            ...additionalRedirectUris
        ];
    }, [
        authCodeRedirectUrlHost,
        additionalRedirectUris
    ]);
    const handleChange = (updatedUris)=>{
        // Split back into host (first item) and additional (rest)
        const newHost = updatedUris.length > 0 ? updatedUris[0] : undefined;
        const newAdditional = updatedUris.slice(1);
        onUpdate('additionalRedirectUris', newAdditional, 'authCodeRedirectUrlHost', newHost);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f47f90096855080$export$2e2bcd8739ae039), {
        initialValues: displayValues,
        legend: t('common:organization.projects.authRedirect.title'),
        description: t('common:organization.projects.authRedirect.description'),
        onChange: handleChange
    });
}

















const $c6a32ec408b1369c$export$a8fe2d44e6831742 = (0, $368cd3e6bcd15ad5$export$185802fd694ee1f5)()((0, $d50bbc3134998c1f$export$428de7ec69ac95c)((set, get)=>{
    const setEditDeviceType = (model)=>set((state)=>{
            state.editDeviceType = model;
        });
    const setListingHasChanges = (v)=>set((state)=>{
            state.listingHasChanges = v;
        });
    const setEditListing = (listing)=>set((state)=>{
            state.editListing = listing;
        });
    const setCustomControlsHasChanges = (v)=>set((state)=>{
            state.customControlsHasChanges = v;
        });
    const setEditCustomControls = (controls)=>set((state)=>{
            state.editCustomControls = controls;
        });
    const initializeEditCustomControls = async (organizationId, deviceId)=>{
        set((state)=>{
            state.loadingCustomControls = true;
        });
        let model = [];
        if (organizationId && deviceId) try {
            const results = await Promise.all((0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).voice.map((locale)=>$1a4c36336f303477$export$fb1c38ee1d8d29f5(deviceId, locale)));
            const fetched = [];
            results.forEach((result, index)=>{
                if (result.resultType === 'Ok' && result.data) fetched.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, result.data), {
                    locale: (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).voice[index]
                }));
            });
            model = (0, $710192f33815db16$export$6a89f8c462a1c4ca)(fetched, deviceId);
        } catch (error) {
            console.error('Error fetching device type custom controls:', error);
            model = (0, $710192f33815db16$export$6a89f8c462a1c4ca)([], deviceId);
        }
        set((state)=>{
            state.editCustomControls = model;
            state.customControlsHasChanges = false;
            state.loadingCustomControls = false;
        });
    };
    const initializeEditListing = async (organizationId, deviceId)=>{
        set((state)=>{
            state.loadingListing = true;
        });
        let model = (0, $37766e6a1a6352f1$export$7e4b5db9af1d87c4);
        if (organizationId && deviceId) try {
            const result = await $1a4c36336f303477$export$f942174137d3f696(organizationId, deviceId);
            if (result.resultType === 'Ok' && result.data && result.data.length > 0) model = (0, $710192f33815db16$export$304e7ba006a6c8a3)(result.data);
            set((state)=>{
                state.listingHasChanges = false;
            });
        } catch (error) {
            console.error('Error fetching device type client listings:', error);
        } finally{
            set((state)=>{
                state.editListing = model;
                state.listingHasChanges = false;
                state.loadingListing = false;
            });
        }
        set((state)=>{
            state.editListing = model;
        });
    };
    const initializeEditor = (model, organizationId)=>{
        set((state)=>{
            if (model) state.editDeviceType = model;
            else if (organizationId) {
                const defaultType = (0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId);
                state.editDeviceType = defaultType;
            }
            state.hasChanges = false;
        });
    };
    const handleFieldChange = (fieldName, value)=>{
        set((state)=>{
            if (state.editDeviceType) state.editDeviceType = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.editDeviceType), {
                [fieldName]: value
            });
            state.hasChanges = true;
        });
    };
    const handleInputChange = (fieldName, value)=>{
        get().handleFieldChange(fieldName, value);
    };
    const createUpdateRequest = ()=>{
        const current = get().editDeviceType;
        if (current) return current;
    };
    const handleSave = async (actions, organizationId, deviceId)=>{
        var _get_editDeviceType;
        if (((_get_editDeviceType = get().editDeviceType) === null || _get_editDeviceType === void 0 ? void 0 : _get_editDeviceType.id) && deviceId) return await $c6a32ec408b1369c$var$handleUpdate(actions, organizationId, deviceId);
        else return await $c6a32ec408b1369c$var$handleCreate(actions, organizationId);
    };
    const handleCreateAndClearEditor = async (actions, organizationId)=>{
        const result = await $c6a32ec408b1369c$var$handleCreate(actions, organizationId);
        if (result.resultType === 'Ok') {
            const defaultType = (0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId);
            set((state)=>{
                state.editDeviceType = defaultType;
                state.hasChanges = false;
            });
        }
        return result;
    };
    const clearEditor = (organizationId)=>{
        set((state)=>{
            const model = organizationId ? (0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId) : null;
            state.editDeviceType = model;
            state.hasChanges = false;
        });
    };
    return {
        // State
        editDeviceType: null,
        editListing: null,
        editCustomControls: null,
        hasChanges: false,
        listingHasChanges: false,
        customControlsHasChanges: false,
        loadingListing: false,
        loadingCustomControls: false,
        clearEditor: // Actions
        clearEditor,
        createUpdateRequest: createUpdateRequest,
        handleCreateAndClearEditor: handleCreateAndClearEditor,
        handleFieldChange: handleFieldChange,
        handleInputChange: handleInputChange,
        handleSave: handleSave,
        initializeEditListing: initializeEditListing,
        initializeEditCustomControls: initializeEditCustomControls,
        initializeEditor: initializeEditor,
        setEditDeviceType: setEditDeviceType,
        setEditListing: setEditListing,
        setEditCustomControls: setEditCustomControls,
        setListingHasChanges: setListingHasChanges,
        setCustomControlsHasChanges: setCustomControlsHasChanges
    };
}));
async function $c6a32ec408b1369c$var$handleUpdate(actions, organizationId, deviceId) {
    try {
        const request = $c6a32ec408b1369c$export$a8fe2d44e6831742.getState().createUpdateRequest();
        if (!request) throw new Error('Missing request data');
        const result = await actions.updateOrgDeviceType(organizationId, deviceId, request);
        if (result.resultType === 'Ok' && result.data) {
            $c6a32ec408b1369c$export$a8fe2d44e6831742.getState().setEditDeviceType(result.data);
            $c6a32ec408b1369c$export$a8fe2d44e6831742.setState((state)=>{
                state.hasChanges = false;
            });
        }
        return result;
    } catch (e) {
        return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
    }
}
async function $c6a32ec408b1369c$var$handleCreate(actions, organizationId) {
    try {
        const request = $c6a32ec408b1369c$export$a8fe2d44e6831742.getState().createUpdateRequest();
        if (!request) throw new Error('Missing request data');
        const result = await actions.createOrgDeviceType(organizationId, request);
        if (result.resultType === 'Ok' && result.data) {
            $c6a32ec408b1369c$export$a8fe2d44e6831742.getState().setEditDeviceType(result.data);
            $c6a32ec408b1369c$export$a8fe2d44e6831742.setState((state)=>{
                state.hasChanges = false;
            });
        }
        return result;
    } catch (e) {
        return new (0, $5f3c730b3d8aae7c$export$2e2bcd8739ae039)();
    }
}



var $7fPBF = parcelRequire("7fPBF");





function $bc567063fd13cd58$export$d5236bf86334668(initialModel) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { deviceId: deviceId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { updateOrgDeviceType: updateOrgDeviceType, createOrgDeviceType: createOrgDeviceType } = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
    const { handleInputChange: handleInputChange } = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
    const editDeviceType = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.editDeviceType);
    (0, $7fPBF.useEffect)(()=>{
        var _editDeviceTypeStore_editDeviceType;
        const editDeviceTypeStore = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
        if (deviceId && deviceId == ((_editDeviceTypeStore_editDeviceType = editDeviceTypeStore.editDeviceType) === null || _editDeviceTypeStore_editDeviceType === void 0 ? void 0 : _editDeviceTypeStore_editDeviceType.id) && !editDeviceTypeStore.hasChanges || !initialModel) return;
        editDeviceTypeStore.initializeEditor(initialModel, organizationId);
        editDeviceTypeStore.initializeEditListing(organizationId, deviceId);
        editDeviceTypeStore.initializeEditCustomControls(organizationId, deviceId);
    }, [
        deviceId,
        organizationId,
        initialModel
    ]);
    const actions = {
        updateOrgDeviceType: updateOrgDeviceType,
        createOrgDeviceType: createOrgDeviceType
    };
    const handleAlerts = (result)=>{
        if (result.resultType === 'Ok') (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:saved'));
        else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
    };
    const handleSave = async ()=>{
        if (!organizationId) throw new Error('Missing organization ID');
        return await (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().handleSave(actions, organizationId, deviceId);
    };
    const handleSaveWithAlerts = async ()=>{
        const result = await handleSave();
        handleAlerts(result);
        return result;
    };
    const handleCreateAndClearEditor = async ()=>{
        if (!organizationId) throw new Error('Missing organization ID');
        const result = await (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().handleCreateAndClearEditor(actions, organizationId);
        handleAlerts(result);
        return result;
    };
    const resetEditor = ()=>{
        (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().initializeEditor(null, organizationId);
    };
    return {
        handleSave: handleSave,
        handleSaveWithAlerts: handleSaveWithAlerts,
        handleCreateAndClearEditor: handleCreateAndClearEditor,
        handleInputChange: handleInputChange,
        editDeviceType: editDeviceType,
        resetEditor: resetEditor
    };
}



var $7fPBF = parcelRequire("7fPBF");




function $e01b516a47e1de8f$export$2e2bcd8739ae039({ value: value = '-', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.projects.deviceType.name'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('name', e.target.value)
    });
}






let $3ad34c58e371e6c3$var$_ = (t)=>t, $3ad34c58e371e6c3$var$t;
// List of specific fields to show checkboxes for
const $3ad34c58e371e6c3$var$specificBooleanFields = [
    'supportsVoiceInput',
    'supportsFaceInput',
    'supportsGestureInput',
    'supportsPhysicalInput',
    'supportsDigitalExtensions',
    'supportsPhysicalExtensions',
    'supportsKeyboardOutput',
    'supportsGenericControllerOutput',
    'supportsXboxControllerOutput',
    'supportsPlayStationControllerOutput',
    'supportsNintendoControllerOutput'
];
function $3ad34c58e371e6c3$export$2e2bcd8739ae039({ editDeviceType: editDeviceType, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                as: "legend",
                children: t('common:organization.projects.deviceType.features.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.features.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ad34c58e371e6c3$var$StyledFormGroup, {
                children: $3ad34c58e371e6c3$var$specificBooleanFields.map((fieldName)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                            checked: !!editDeviceType[fieldName],
                            onChange: (e)=>onUpdate(fieldName, e.target.checked)
                        }),
                        label: t(`common:organization.projects.deviceType.features.${fieldName}`)
                    }, fieldName))
            })
        ]
    });
}
const $3ad34c58e371e6c3$var$StyledFormGroup = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $ea5892afc276c974$export$2e2bcd8739ae039))($3ad34c58e371e6c3$var$t || ($3ad34c58e371e6c3$var$t = $3ad34c58e371e6c3$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    width: 100%;
`));






const $f5f187ec04d6f075$var$specificBooleanFields = [
    'canAutoStart',
    'isSupported'
];
function $f5f187ec04d6f075$export$2e2bcd8739ae039({ editDeviceType: editDeviceType, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: $f5f187ec04d6f075$var$specificBooleanFields.map((fieldName)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                value: "start",
                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b6e9b66c5b93a14$export$2e2bcd8739ae039), {
                    checked: !!editDeviceType[fieldName],
                    onChange: (e)=>onUpdate(fieldName, e.target.checked)
                }),
                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
                            as: "label",
                            children: t(`common:organization.projects.deviceType.${fieldName}.title`)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                            children: t(`common:organization.projects.deviceType.${fieldName}.description`)
                        })
                    ]
                }),
                labelPlacement: "end"
            }, fieldName))
    });
}


function $42567f24cb8195b5$export$2e2bcd8739ae039({ open: open, onClose: onClose, index: index, onCreated: onCreated }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { editDeviceType: editDeviceType, handleCreateAndClearEditor: handleCreateAndClearEditor, handleInputChange: handleInputChange, resetEditor: resetEditor } = (0, $bc567063fd13cd58$export$d5236bf86334668)(null);
    const handleSaveAndClose = async ()=>{
        const response = await handleCreateAndClearEditor();
        if (response.resultType === 'Ok' && response.data) {
            onCreated === null || onCreated === void 0 ? void 0 : onCreated(response.data.id, index !== null && index !== void 0 ? index : -1);
            onClose();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (open) resetEditor();
    }, [
        open
    ]);
    if (!editDeviceType) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        fullWidth: true,
        open: open,
        onClose: onClose,
        onCancel: onClose,
        title: t('common:organization.projects.deviceType.action'),
        description: t('common:organization.projects.deviceType.description'),
        onConfirm: handleSaveAndClose,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e01b516a47e1de8f$export$2e2bcd8739ae039), {
                    value: editDeviceType.name,
                    onUpdate: (field, value)=>handleInputChange(field, value)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ad34c58e371e6c3$export$2e2bcd8739ae039), {
                    editDeviceType: editDeviceType,
                    onUpdate: handleInputChange
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5f187ec04d6f075$export$2e2bcd8739ae039), {
                    editDeviceType: editDeviceType,
                    onUpdate: handleInputChange
                })
            ]
        })
    });
}


function $1f273ff0abbe6580$export$2e2bcd8739ae039({ value: value, deviceOptions: deviceOptions, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const selectOptions = deviceOptions.map((device)=>({
            value: device.id,
            label: device.name
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f47f90096855080$export$2e2bcd8739ae039), {
        initialValues: value,
        legend: t('common:organization.projects.deviceScopes.titleLong'),
        description: t('common:organization.projects.deviceScopes.description'),
        selectOptions: selectOptions,
        onChange: (updatedDevices)=>onUpdate('authClientDeviceTypes', updatedDevices),
        dialogComponent: ({ open: open, index: index, onClose: onClose, onCreated: onCreated })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42567f24cb8195b5$export$2e2bcd8739ae039), {
                open: open,
                index: index,
                onClose: onClose,
                onCreated: onCreated
            }),
        createNewItemLabel: t('common:organization.projects.deviceScopes.action')
    });
}










var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");


function $7c682d04727f84e5$export$2e2bcd8739ae039({ clientId: clientId, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [showWarning, setShowWarning] = (0, $7fPBF.useState)(false);
    const handleCancelWarning = ()=>{
        setShowWarning(false);
    };
    const deleteClient = async ()=>{
        try {
            const result = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().deleteOrgAuthClient(organizationId, clientId);
            if (result.resultType == 'Ok') {
                navigate(-1);
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.projects.key.delete.success'));
            }
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.projects.key.delete.error'));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "accent",
                startIcon: "cancel2",
                onClick: ()=>setShowWarning(true),
                children: t('common:organization.projects.key.delete.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showWarning,
                onCancel: handleCancelWarning,
                onClose: handleCancelWarning,
                onConfirm: deleteClient,
                confirmButtonText: t('common:organization.projects.key.delete.title'),
                title: t('common:organization.projects.key.delete.title'),
                description: t('common:organization.projects.key.delete.description')
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");







function $f2dd45cbffb74c92$export$2e2bcd8739ae039({ secret: secret, open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const copySecret = ()=>{
        navigator.clipboard.writeText(secret !== null && secret !== void 0 ? secret : '').then(()=>{
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:profile.share.copied'));
        });
    };
    if (!secret) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        onConfirm: onClose,
        confirmButtonText: t('common:done'),
        title: t('common:organization.projects.secret.title'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$b312780b0d72eabb), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                    children: t('common:organization.projects.secret.description')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61f23b7617a6c4bc$export$2e2bcd8739ae039), {
                value: secret !== null && secret !== void 0 ? secret : '',
                readOnly: true,
                onClick: copySecret,
                inputLabel: t('common:organization.projects.secret.title'),
                actionLabel: t('common:organization.projects.secret.copy')
            })
        ]
    });
}


function $fe218ac773675bd0$export$2e2bcd8739ae039({ clientId: clientId, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showWarning, setShowWarning] = (0, $7fPBF.useState)(false);
    const [showSecret, setShowSecret] = (0, $7fPBF.useState)(false);
    const [result, setResult] = (0, $7fPBF.useState)(null);
    const handleCancelWarning = ()=>{
        setShowWarning(false);
    };
    const handleRotateClientSecret = async ()=>{
        setShowWarning(false);
        try {
            const response = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().rotateClientSecret(organizationId, clientId);
            if ((response === null || response === void 0 ? void 0 : response.resultType) == 'Ok') {
                setResult(response.data);
                setShowSecret(true);
            }
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:organization.projects.secret.rotate.error'));
        }
    };
    if (!organizationId || !clientId) return null;
    var _result_secret;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "accent",
                startIcon: "repeat",
                onClick: ()=>setShowWarning(true),
                children: t('common:organization.projects.secret.rotate.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                open: showWarning,
                onCancel: handleCancelWarning,
                onClose: handleCancelWarning,
                onConfirm: handleRotateClientSecret,
                confirmButtonText: t('common:continue'),
                title: t('common:organization.projects.secret.rotate.title'),
                description: t('common:organization.projects.secret.rotate.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2dd45cbffb74c92$export$2e2bcd8739ae039), {
                secret: (_result_secret = result === null || result === void 0 ? void 0 : result.secret) !== null && _result_secret !== void 0 ? _result_secret : '',
                open: showSecret,
                onClose: ()=>setShowSecret(false)
            })
        ]
    });
}


let $b144367e0a20d9c5$var$_ = (t)=>t, $b144367e0a20d9c5$var$t;
function $b144367e0a20d9c5$export$2e2bcd8739ae039({ clientId: clientId, organizationId: organizationId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [showKey, setShowKey] = (0, $7fPBF.useState)(false);
    if (!clientId) return null;
    const handleKeyViewToggle = ()=>{
        setShowKey(!showKey);
    };
    const copyKey = ()=>{
        navigator.clipboard.writeText(clientId).then(()=>{
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:profile.share.copied'));
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($b144367e0a20d9c5$var$Content, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $61f23b7617a6c4bc$export$2e2bcd8739ae039), {
                value: showKey ? clientId : (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(clientId),
                readOnly: true,
                onClick: copyKey,
                inputLabel: t('common:organization.projects.key.title'),
                actionLabel: t('common:organization.projects.key.copy')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$564cbe3426fc093a), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "accent",
                        startIcon: "eye",
                        onClick: handleKeyViewToggle,
                        children: t('common:organization.projects.key.view')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe218ac773675bd0$export$2e2bcd8739ae039), {
                        organizationId: organizationId,
                        clientId: clientId
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c682d04727f84e5$export$2e2bcd8739ae039), {
                        organizationId: organizationId,
                        clientId: clientId
                    })
                ]
            })
        ]
    });
}
const $b144367e0a20d9c5$var$Content = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($b144367e0a20d9c5$var$t || ($b144367e0a20d9c5$var$t = $b144367e0a20d9c5$var$_`
    display: flex;
    flex-direction: column;
`));





function $98c9acefb60389ed$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.projects.name'),
        value: value,
        placeholder: '-',
        onChange: (e)=>onUpdate('name', e.target.value)
    });
}





function $50c02032c88163c7$export$2e2bcd8739ae039({ value: value = '', onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
        fullWidth: true,
        label: t('common:organization.projects.originHost.title'),
        value: value,
        placeholder: 'https://abcd.com',
        onChange: (e)=>onUpdate('originHost', e.target.value)
    });
}



/** @jsxImportSource @emotion/react */ 

parcelRequire("7fPBF");








var $addf5d80adbc84db$export$ffb0004e005737fa = $824c049f32d4395d$exports.Fragment;
var $addf5d80adbc84db$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $d62c6f18f523e962$export$dda1d9f60106f0e9).call(props, 'css')) return $824c049f32d4395d$exports.jsx(type, props, key);
    return $824c049f32d4395d$exports.jsx((0, $d62c6f18f523e962$export$a9c23c6ac3fc3eca), (0, $d62c6f18f523e962$export$db3b6bfb95261072)(type, props), key);
};
var $addf5d80adbc84db$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $d62c6f18f523e962$export$dda1d9f60106f0e9).call(props, 'css')) return $824c049f32d4395d$exports.jsxs(type, props, key);
    return $824c049f32d4395d$exports.jsxs((0, $d62c6f18f523e962$export$a9c23c6ac3fc3eca), (0, $d62c6f18f523e962$export$db3b6bfb95261072)(type, props), key);
};









let $cef4d3c57a62fbd6$var$_ = (t)=>t, $cef4d3c57a62fbd6$var$t, $cef4d3c57a62fbd6$var$t1;
const $cef4d3c57a62fbd6$export$2e05d2650e03ee9e = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0295843db55c2695$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'first'
})($cef4d3c57a62fbd6$var$t || ($cef4d3c57a62fbd6$var$t = $cef4d3c57a62fbd6$var$_`
    padding: 0 0 0.5rem 0;
    ${0};
    width: 100%;
    border-bottom: 1px solid ${0};
`), (props)=>!props.first && `padding-top: 0.5rem;`, (props)=>props.theme.input.border);
const $cef4d3c57a62fbd6$export$8a566344fe5517e6 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039))($cef4d3c57a62fbd6$var$t1 || ($cef4d3c57a62fbd6$var$t1 = $cef4d3c57a62fbd6$var$_`
    margin: 0;
`));






let $df4d569ff53deb23$var$_ = (t)=>t, $df4d569ff53deb23$var$t, $df4d569ff53deb23$var$t1;
function $df4d569ff53deb23$export$2e2bcd8739ae039({ label: label, description: description, subOption: subOption = false }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($df4d569ff53deb23$var$LabelWrapper, {
        subOption: subOption,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($df4d569ff53deb23$var$Label, {
                children: label
            }),
            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                children: description
            })
        ]
    });
}
const $df4d569ff53deb23$var$Label = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd))($df4d569ff53deb23$var$t || ($df4d569ff53deb23$var$t = $df4d569ff53deb23$var$_`
    color: ${0};
`), (props)=>props.theme.color.text);
const $df4d569ff53deb23$var$LabelWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0295843db55c2695$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'subOption'
})($df4d569ff53deb23$var$t1 || ($df4d569ff53deb23$var$t1 = $df4d569ff53deb23$var$_`
    display: grid;
    grid-template-columns: 13rem auto;
    column-gap: ${0};
    align-items: center;
`), (props)=>props.subOption ? '1rem' : '3rem');


let $5569661c7d97b5c7$var$_ = (t)=>t, $5569661c7d97b5c7$var$t;
function $5569661c7d97b5c7$export$2e2bcd8739ae039({ option: option, state: state, handleParentChange: handleParentChange, handleSubOptionChange: handleSubOptionChange }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cef4d3c57a62fbd6$export$2e05d2650e03ee9e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$8a566344fe5517e6), {
                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                    checked: !!state[option.value],
                    onChange: ()=>{
                        var _option_subOptions;
                        return handleParentChange(option.value, !!((_option_subOptions = option.subOptions) === null || _option_subOptions === void 0 ? void 0 : _option_subOptions.length));
                    },
                    indeterminate: option.subOptions ? option.subOptions.some((sub)=>state[sub.value]) && !option.subOptions.every((sub)=>state[sub.value]) : false
                }),
                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df4d569ff53deb23$export$2e2bcd8739ae039), {
                    label: option.label,
                    description: option.description
                })
            }),
            option.subOptions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: option.subOptions.map((subOption)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5569661c7d97b5c7$var$SubSection, {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$8a566344fe5517e6), {
                            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                                checked: state[subOption.value],
                                onChange: ()=>handleSubOptionChange(option.value, subOption.value)
                            }),
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df4d569ff53deb23$export$2e2bcd8739ae039), {
                                label: subOption.label,
                                description: subOption.description,
                                subOption: true
                            })
                        })
                    }, subOption.value))
            })
        ]
    });
}
const $5569661c7d97b5c7$var$SubSection = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $0295843db55c2695$export$2e2bcd8739ae039))($5569661c7d97b5c7$var$t || ($5569661c7d97b5c7$var$t = $5569661c7d97b5c7$var$_`
    margin-left: 2rem;
`));





function $a6e7a7946e260452$export$2e2bcd8739ae039({ checked: checked, indeterminate: indeterminate, onChange: onChange, label: label }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$2e05d2650e03ee9e), {
        first: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cef4d3c57a62fbd6$export$8a566344fe5517e6), {
            control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                size: "medium",
                checked: checked,
                indeterminate: indeterminate,
                onChange: onChange
            }),
            label: label
        })
    });
}


let $ddeece3e20817772$var$_ = (t)=>t, $ddeece3e20817772$var$t;
function $ddeece3e20817772$export$2e2bcd8739ae039({ legend: legend, selectAllLabel: selectAllLabel, options: options, activeValues: activeValues = [], onUpdate: onUpdate }) {
    const state = $ddeece3e20817772$var$mapActiveValuesToState(options, activeValues);
    const handleParentChange = (parentValue, hasSubOptions)=>{
        const isChecked = !state[parentValue];
        const updatedValues = $ddeece3e20817772$var$updateParentValues(activeValues, options, parentValue, isChecked);
        onUpdate(updatedValues);
    };
    const handleSubOptionChange = (parentValue, subValue)=>{
        const updatedValues = $ddeece3e20817772$var$updateSubOptionValues(activeValues, options, parentValue, subValue);
        onUpdate(updatedValues);
    };
    const handleSelectAllChange = ()=>{
        const allChecked = $ddeece3e20817772$var$areAllOptionsChecked(state, options);
        const updatedValues = $ddeece3e20817772$var$toggleAllValues(activeValues, options, !allChecked);
        onUpdate(updatedValues);
    };
    return /*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)($ddeece3e20817772$var$Scrollable, {
        children: /*#__PURE__*/ (0, $addf5d80adbc84db$export$25062201e9e25d76)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
            children: [
                /*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                    as: "legend",
                    children: legend
                }),
                selectAllLabel && /*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)((0, $a6e7a7946e260452$export$2e2bcd8739ae039), {
                    checked: $ddeece3e20817772$var$areAllOptionsChecked(state, options),
                    indeterminate: $ddeece3e20817772$var$areSomeOptionsChecked(state, options) && !$ddeece3e20817772$var$areAllOptionsChecked(state, options),
                    onChange: handleSelectAllChange,
                    label: selectAllLabel
                }),
                options && options.map((option)=>/*#__PURE__*/ (0, $addf5d80adbc84db$export$34b9dba7ce09269b)((0, $5569661c7d97b5c7$export$2e2bcd8739ae039), {
                        option: option,
                        state: state,
                        handleParentChange: handleParentChange,
                        handleSubOptionChange: handleSubOptionChange
                    }, option.value))
            ]
        })
    });
}
const $ddeece3e20817772$var$mapActiveValuesToState = (options = [], activeValues = [])=>options.reduce((acc, option)=>{
        acc[option.value] = activeValues.includes(option.value);
        if (option.subOptions) option.subOptions.forEach((subOption)=>{
            acc[subOption.value] = activeValues.includes(subOption.value);
        });
        return acc;
    }, {});
const $ddeece3e20817772$var$updateParentValues = (activeValues, options, parentValue, isChecked)=>{
    var _parentOption_subOptions;
    const parentOption = options.find((opt)=>opt.value === parentValue);
    let updatedValues = [
        ...activeValues
    ];
    if (isChecked) // Add parent and all sub-options
    updatedValues = Array.from(new Set([
        ...updatedValues,
        parentValue,
        ...(parentOption === null || parentOption === void 0 ? void 0 : (_parentOption_subOptions = parentOption.subOptions) === null || _parentOption_subOptions === void 0 ? void 0 : _parentOption_subOptions.map((sub)=>sub.value)) || []
    ]));
    else // Remove parent and all sub-options
    updatedValues = updatedValues.filter((value)=>{
        var _parentOption_subOptions;
        return value !== parentValue && !(parentOption === null || parentOption === void 0 ? void 0 : (_parentOption_subOptions = parentOption.subOptions) === null || _parentOption_subOptions === void 0 ? void 0 : _parentOption_subOptions.some((sub)=>sub.value === value));
    });
    return updatedValues;
};
const $ddeece3e20817772$var$updateSubOptionValues = (activeValues, options, parentValue, subValue)=>{
    var _parentOption_subOptions;
    const parentOption = options.find((opt)=>opt.value === parentValue);
    let updatedValues = [
        ...activeValues
    ];
    if (updatedValues.includes(subValue)) // Remove sub-option
    updatedValues = updatedValues.filter((value)=>value !== subValue);
    else // Add sub-option
    updatedValues = [
        ...updatedValues,
        subValue
    ];
    // Check if all siblings are selected to toggle parent
    if (parentOption === null || parentOption === void 0 ? void 0 : (_parentOption_subOptions = parentOption.subOptions) === null || _parentOption_subOptions === void 0 ? void 0 : _parentOption_subOptions.every((sub)=>updatedValues.includes(sub.value))) updatedValues = [
        ...updatedValues,
        parentValue
    ];
    else updatedValues = updatedValues.filter((value)=>value !== parentValue);
    return updatedValues;
};
const $ddeece3e20817772$var$toggleAllValues = (activeValues, options, isChecked)=>{
    if (isChecked) // Select all options and sub-options
    return Array.from(new Set(options.flatMap((option)=>{
        var _option_subOptions;
        return [
            option.value,
            ...((_option_subOptions = option.subOptions) === null || _option_subOptions === void 0 ? void 0 : _option_subOptions.map((sub)=>sub.value)) || []
        ];
    })));
    // Deselect all
    return [];
};
const $ddeece3e20817772$var$areAllOptionsChecked = (state, options)=>options.every((option)=>{
        var _option_subOptions;
        return state[option.value] && ((_option_subOptions = option.subOptions) === null || _option_subOptions === void 0 ? void 0 : _option_subOptions.every((sub)=>state[sub.value])) !== false;
    });
const $ddeece3e20817772$var$areSomeOptionsChecked = (state, options)=>options.some((option)=>{
        var _option_subOptions;
        return state[option.value] || ((_option_subOptions = option.subOptions) === null || _option_subOptions === void 0 ? void 0 : _option_subOptions.some((sub)=>state[sub.value])) === true;
    });
const $ddeece3e20817772$var$Scrollable = (0, $8de346382d86c747$export$2e2bcd8739ae039)('div')($ddeece3e20817772$var$t || ($ddeece3e20817772$var$t = $ddeece3e20817772$var$_`
    overflow-x: auto;
    padding: 0 0.25rem;
`));




var $7fPBF = parcelRequire("7fPBF");

const $b3442ae70315e7e8$var$excludedIds = [
    '9760cf0c-fa0a-4023-8822-54c8d2112fd7',
    '9e87110e-cd07-4025-ae8b-db9f9840758e',
    '0887b18e-fb6b-4a2a-92cf-8641e1d19485',
    '2cf82a34-a1ee-44cf-98ce-9fe6e09756fd'
];
const $b3442ae70315e7e8$var$toPascalCase = (str)=>{
    return str.split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join('');
};
function $b3442ae70315e7e8$export$95fa510925bbc2d1() {
    const [error, setError] = (0, $7fPBF.useState)(false);
    const scopes = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.scopes);
    const loadingData = (0, $55ce97f088539572$export$87aeeca3aeff7121)((state)=>state.loadingData);
    const { getScopes: fetchScopes, setScopes: setScopes, handleLoadingDataChange: handleLoadingDataChange } = (0, $55ce97f088539572$export$87aeeca3aeff7121).getState();
    (0, $7fPBF.useEffect)(()=>{
        const getScopes = async ()=>{
            try {
                handleLoadingDataChange('scopes', true);
                const data = await fetchScopes();
                // Filter out excluded IDs, then map and sort the data alphabetically by label
                const sortedScopes = data.filter((scope)=>!$b3442ae70315e7e8$var$excludedIds.includes(scope.id)).map((scope)=>({
                        label: $b3442ae70315e7e8$var$toPascalCase(scope.name),
                        value: scope.id,
                        description: scope.description
                    })).sort((a, b)=>a.label.localeCompare(b.label));
                setScopes(sortedScopes);
                setError(false);
            } catch (err) {
                setError(true);
            } finally{
                handleLoadingDataChange('scopes', false);
            }
        };
        if (scopes.length === 0) getScopes();
    }, []);
    return {
        scopes: scopes,
        loading: loadingData.scopes,
        error: error
    };
}



function $f61ab26e94239cef$export$2e2bcd8739ae039({ value: value, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { scopes: scopes, loading: loading, error: error } = (0, $b3442ae70315e7e8$export$95fa510925bbc2d1)();
    const handleStateChange = (updatedState)=>{
        onUpdate('authClientScopes', updatedState);
    };
    if (!scopes || error || loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddeece3e20817772$export$2e2bcd8739ae039), {
        legend: t('common:organization.projects.scopes.manage'),
        options: scopes,
        activeValues: value,
        onUpdate: handleStateChange
    });
}





var $7fPBF = parcelRequire("7fPBF");

function $d5d3b4079485dd94$export$2e2bcd8739ae039({ tokenAdditionalRedirectUris: tokenAdditionalRedirectUris, tokenRedirectUrlHost: tokenRedirectUrlHost, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    // Compute combined values directly - no state needed
    const displayValues = (0, $7fPBF.useMemo)(()=>{
        return tokenRedirectUrlHost ? [
            tokenRedirectUrlHost,
            ...tokenAdditionalRedirectUris
        ] : [
            ...tokenAdditionalRedirectUris
        ];
    }, [
        tokenRedirectUrlHost,
        tokenAdditionalRedirectUris
    ]);
    const handleChange = (updatedUris)=>{
        // Split back into host (first item) and additional (rest)
        const newHost = updatedUris.length > 0 ? updatedUris[0] : undefined;
        const newAdditional = updatedUris.slice(1);
        onUpdate('tokenAdditionalRedirectUris', newAdditional, 'tokenRedirectUrlHost', newHost);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0f47f90096855080$export$2e2bcd8739ae039), {
        initialValues: displayValues,
        legend: t('common:organization.projects.tokenRedirect.title'),
        description: t('common:organization.projects.tokenRedirect.description'),
        onChange: handleChange
    });
}


function $712a21b5a921b4f4$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, clientId: clientId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { currentOrg: currentOrg, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { deviceTypes: deviceTypes, currentOrgClient: currentOrgClient, error: error, isLoading: isLoadingProjects } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    const { editClient: editClient, handleInputChange: handleInputChange, handleSaveWithAlerts: handleSave } = (0, $4b8a9e84dae5e7a0$export$8f7032ec10a68144)(currentOrgClient);
    if (!currentOrgClient || !deviceTypes || !editClient || isLoadingProjects || isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!organizationId || !clientId || !currentOrg || error.client || !canCreateAuthClients || organizationId !== currentOrg.id) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$54fb318478ce42e9), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.key.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b144367e0a20d9c5$export$2e2bcd8739ae039), {
                    organizationId: organizationId,
                    clientId: currentOrgClient.id
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.clients.settings')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c9acefb60389ed$export$2e2bcd8739ae039), {
                        value: editClient.name,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50c02032c88163c7$export$2e2bcd8739ae039), {
                        value: editClient.originHost,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5d3b4079485dd94$export$2e2bcd8739ae039), {
                        tokenAdditionalRedirectUris: editClient.tokenAdditionalRedirectUris,
                        tokenRedirectUrlHost: editClient.tokenRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86bb7a18b305ac09$export$2e2bcd8739ae039), {
                        additionalRedirectUris: editClient.additionalRedirectUris,
                        authCodeRedirectUrlHost: editClient.authCodeRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.scopes.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f61ab26e94239cef$export$2e2bcd8739ae039), {
                    value: editClient.authClientScopes,
                    onUpdate: (field, value)=>handleInputChange(field, value)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceScopes.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1f273ff0abbe6580$export$2e2bcd8739ae039), {
                    value: editClient.authClientDeviceTypes,
                    deviceOptions: deviceTypes !== null && deviceTypes !== void 0 ? deviceTypes : [],
                    onUpdate: (field, value)=>handleInputChange(field, value)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: handleSave,
                children: t('common:save')
            })
        ]
    });
}




function $f1f3f26007c0cbd9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrgClient: currentOrgClient } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    var _currentOrgClient_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: (_currentOrgClient_name = currentOrgClient === null || currentOrgClient === void 0 ? void 0 : currentOrgClient.name) !== null && _currentOrgClient_name !== void 0 ? _currentOrgClient_name : t('common:organization.projects.clients.title'),
                description: t('common:organization.projects.clients.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $712a21b5a921b4f4$export$2e2bcd8739ae039), {})
        ]
    });
}











var $7fPBF = parcelRequire("7fPBF");

const $fca7ea4f5f2a2056$var$FALLBACK_LOCALE = (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec);
const $fca7ea4f5f2a2056$var$arraysEqual = (a, b)=>{
    const left = a !== null && a !== void 0 ? a : [];
    const right = b !== null && b !== void 0 ? b : [];
    if (left.length !== right.length) return false;
    return left.every((value, index)=>value === right[index]);
};
const $fca7ea4f5f2a2056$var$isControlCustomizedAgainst = (control, fallback)=>{
    if (!fallback) return false;
    var _control_description, _fallback_description;
    return control.name !== fallback.name || ((_control_description = control.description) !== null && _control_description !== void 0 ? _control_description : '') !== ((_fallback_description = fallback.description) !== null && _fallback_description !== void 0 ? _fallback_description : '') || !$fca7ea4f5f2a2056$var$arraysEqual(control.defaultCommands, fallback.defaultCommands);
};
function $fca7ea4f5f2a2056$export$f530b0e5c83c4707(organizationId, deviceId) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editCustomControls = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.editCustomControls);
    const [activeLocale, setActiveLocale] = (0, $7fPBF.useState)($fca7ea4f5f2a2056$var$FALLBACK_LOCALE);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [addedControlIds, setAddedControlIds] = (0, $7fPBF.useState)(new Set());
    // Stable React keys for newly-added controls. Maps the control's current id (which can
    // change as the admin edits it) back to the immutable UUID assigned at creation time,
    // so the AccordionRow doesn't remount on every keystroke in the ID field.
    const [controlRowKeys, setControlRowKeys] = (0, $7fPBF.useState)(new Map());
    const LOCALES = (0, $7fPBF.useMemo)(()=>(0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).voice.map((code)=>({
                code: code,
                label: t(`common:localization.localesShort.${code}`),
                flag: (0, $3ecd3f7dea3d56de$export$a1451363a805f944)[code]
            })), [
        t
    ]);
    const currentControls = (0, $7fPBF.useMemo)(()=>{
        var _editCustomControls_find;
        if (!editCustomControls) return [];
        var _editCustomControls_find_controls;
        return (_editCustomControls_find_controls = (_editCustomControls_find = editCustomControls.find((c)=>c.locale === activeLocale)) === null || _editCustomControls_find === void 0 ? void 0 : _editCustomControls_find.controls) !== null && _editCustomControls_find_controls !== void 0 ? _editCustomControls_find_controls : [];
    }, [
        editCustomControls,
        activeLocale
    ]);
    const isControlComplete = (control)=>{
        const hasName = !!control.name && control.name.trim().length > 0;
        const hasDefaultCommand = !!(control.defaultCommands && control.defaultCommands.some((c)=>c && c.trim().length > 0));
        return hasName && hasDefaultCommand;
    };
    const isLocaleCustomized = (localeCode)=>{
        if (localeCode === $fca7ea4f5f2a2056$var$FALLBACK_LOCALE) return true;
        const all = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editCustomControls;
        if (!all) return false;
        const entry = all.find((c)=>c.locale === localeCode);
        const fallback = all.find((c)=>c.locale === $fca7ea4f5f2a2056$var$FALLBACK_LOCALE);
        if (!entry || !fallback) return false;
        return entry.controls.some((control)=>{
            const fallbackControl = fallback.controls.find((c)=>c.id === control.id);
            return $fca7ea4f5f2a2056$var$isControlCustomizedAgainst(control, fallbackControl);
        });
    };
    const getLocaleCompletion = (localeCode)=>{
        const all = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editCustomControls;
        if (!all) return 0;
        const entry = all.find((c)=>c.locale === localeCode);
        if (!entry || entry.controls.length === 0) return localeCode === $fca7ea4f5f2a2056$var$FALLBACK_LOCALE ? 100 : 0;
        if (localeCode === $fca7ea4f5f2a2056$var$FALLBACK_LOCALE) {
            const completed = entry.controls.filter(isControlComplete).length;
            return Math.round(completed / entry.controls.length * 100);
        }
        const fallback = all.find((c)=>c.locale === $fca7ea4f5f2a2056$var$FALLBACK_LOCALE);
        const customizedComplete = entry.controls.filter((control)=>{
            const fallbackControl = fallback === null || fallback === void 0 ? void 0 : fallback.controls.find((c)=>c.id === control.id);
            return $fca7ea4f5f2a2056$var$isControlCustomizedAgainst(control, fallbackControl) && isControlComplete(control);
        }).length;
        return Math.round(customizedComplete / entry.controls.length * 100);
    };
    const handlePerLocaleFieldChange = (controlId, fieldName, value)=>{
        const store = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
        if (!store.editCustomControls) return;
        const updated = store.editCustomControls.map((entry)=>{
            if (entry.locale !== activeLocale) return entry;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, entry), {
                controls: entry.controls.map((control)=>control.id === controlId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control), {
                        [fieldName]: value
                    }) : control)
            });
        });
        store.setEditCustomControls(updated);
        store.setCustomControlsHasChanges(true);
    };
    const handleSharedFieldChange = (controlId, fieldName, value)=>{
        const store = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
        if (!store.editCustomControls) return;
        const updated = store.editCustomControls.map((entry)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, entry), {
                controls: entry.controls.map((control)=>control.id === controlId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control), {
                        [fieldName]: value
                    }) : control)
            }));
        store.setEditCustomControls(updated);
        store.setCustomControlsHasChanges(true);
    };
    const handleIdChange = (oldId, newId)=>{
        if (!addedControlIds.has(oldId)) return;
        if (newId === oldId) return;
        const store = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
        if (!store.editCustomControls) return;
        // Reject duplicates against any other control id (including other new controls and
        // existing read-only ids). This also prevents an empty id when another row is already
        // empty — without this, two rows could collide on the same React row key.
        const conflicts = store.editCustomControls.some((entry)=>entry.controls.some((c)=>c.id === newId && c.id !== oldId));
        if (conflicts) return;
        const updated = store.editCustomControls.map((entry)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, entry), {
                controls: entry.controls.map((control)=>control.id === oldId ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control), {
                        id: newId
                    }) : control)
            }));
        store.setEditCustomControls(updated);
        store.setCustomControlsHasChanges(true);
        setAddedControlIds((prev)=>{
            const next = new Set(prev);
            next.delete(oldId);
            next.add(newId);
            return next;
        });
        setControlRowKeys((prev)=>{
            const next = new Map(prev);
            const rowKey = next.get(oldId);
            if (rowKey !== undefined) {
                next.delete(oldId);
                next.set(newId, rowKey);
            }
            return next;
        });
    };
    const handleAddControl = ()=>{
        const store = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
        const newId = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
        const blankControl = {
            id: newId,
            name: '',
            description: '',
            iconUrl: '',
            isProfileControl: false,
            isPrefixVoiceCommand: false,
            allowWhenDictating: false,
            allowsHold: false,
            isDeprecated: false,
            defaultCommands: [
                ''
            ],
            requiresEmployeeAccess: false,
            requiresStudentAccess: false,
            requiresGenericLicense: false,
            requiresPlusAccess: false
        };
        var _store_editCustomControls;
        const existing = (_store_editCustomControls = store.editCustomControls) !== null && _store_editCustomControls !== void 0 ? _store_editCustomControls : [];
        const updated = existing.length > 0 ? existing.map((entry)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, entry), {
                controls: [
                    ...entry.controls,
                    (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, blankControl)
                ]
            })) : (0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).voice.map((locale)=>({
                id: '',
                createdDate: new Date(),
                modifiedDate: new Date(),
                locale: locale,
                deviceTypeId: deviceId,
                controls: [
                    (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, blankControl)
                ]
            }));
        store.setEditCustomControls(updated);
        store.setCustomControlsHasChanges(true);
        setAddedControlIds((prev)=>new Set(prev).add(newId));
        // The newly-created id doubles as its own row key. Subsequent id edits will move the
        // mapping forward while keeping the stable rowKey value, so the React key stays put.
        setControlRowKeys((prev)=>new Map(prev).set(newId, newId));
        return newId;
    };
    const isControlNew = (0, $7fPBF.useCallback)((controlId)=>addedControlIds.has(controlId), [
        addedControlIds
    ]);
    const getControlRowKey = (0, $7fPBF.useCallback)((controlId)=>{
        var _controlRowKeys_get;
        return (_controlRowKeys_get = controlRowKeys.get(controlId)) !== null && _controlRowKeys_get !== void 0 ? _controlRowKeys_get : controlId;
    }, [
        controlRowKeys
    ]);
    const saveCustomControls = async (onSuccess, onError)=>{
        const store = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
        const current = store.editCustomControls;
        if (!organizationId || !deviceId || !current) {
            onError(t('common:saveError'));
            return false;
        }
        const entriesToSave = current.filter((entry)=>entry.locale === $fca7ea4f5f2a2056$var$FALLBACK_LOCALE || isLocaleCustomized(entry.locale));
        setIsSaving(true);
        try {
            const responses = await Promise.all(entriesToSave.map((entry)=>{
                const request = {
                    controls: entry.controls
                };
                return $1a4c36336f303477$export$ae6dfd1cb318a3be(organizationId, deviceId, entry.locale, request);
            }));
            const failed = responses.filter((r)=>r.resultType !== 'Ok');
            if (failed.length > 0) {
                onError(t('common:saveError'));
                return false;
            }
            onSuccess(t('common:saved'));
            store.setCustomControlsHasChanges(false);
            setAddedControlIds(new Set());
            setControlRowKeys(new Map());
            await store.initializeEditCustomControls(organizationId, deviceId);
            return true;
        } catch (error) {
            console.error('Error saving device type custom controls:', error);
            onError(t('common:saveError'));
            return false;
        } finally{
            setIsSaving(false);
        }
    };
    const totalControlCount = (0, $7fPBF.useMemo)(()=>currentControls.length, [
        currentControls
    ]);
    const isControlCompleteById = (0, $7fPBF.useCallback)((controlId)=>{
        const control = currentControls.find((c)=>c.id === controlId);
        return control ? isControlComplete(control) : false;
    }, [
        currentControls
    ]);
    return {
        activeLocale: activeLocale,
        setActiveLocale: setActiveLocale,
        isSaving: isSaving,
        LOCALES: LOCALES,
        currentControls: currentControls,
        totalControlCount: totalControlCount,
        getLocaleCompletion: getLocaleCompletion,
        isLocaleCustomized: isLocaleCustomized,
        isControlCompleteById: isControlCompleteById,
        isControlNew: isControlNew,
        getControlRowKey: getControlRowKey,
        handlePerLocaleFieldChange: handlePerLocaleFieldChange,
        handleSharedFieldChange: handleSharedFieldChange,
        handleIdChange: handleIdChange,
        handleAddControl: handleAddControl,
        saveCustomControls: saveCustomControls
    };
}

















var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
function $c4026d6932f3d411$export$2e2bcd8739ae039(children) {
    return $7fPBF.Children.toArray(children).filter((child)=>/*#__PURE__*/ $7fPBF.isValidElement(child));
}









function $ea2e6573fef7cc68$export$b85c003f960b1f3a(slot) {
    return (0, $e3a5efaa168b7e25$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $ea2e6573fef7cc68$var$buttonGroupClasses = (0, $e320bada9cd4dcc5$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'lastButton',
    'middleButton'
]);
var $ea2e6573fef7cc68$export$2e2bcd8739ae039 = $ea2e6573fef7cc68$var$buttonGroupClasses;





'use client';
const $8d51ecc339c58f69$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $8d51ecc339c58f69$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $8353d23c1e9a3769$export$2e2bcd8739ae039)(color)}`
        ],
        grouped: [
            'grouped',
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $ea2e6573fef7cc68$export$b85c003f960b1f3a), classes);
};
const $8d51ecc339c58f69$var$ButtonGroupRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $8d51ecc339c58f69$var$overridesResolver
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2],
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).grouped}`]: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    }
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).lastButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).lastButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).lastButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).lastButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9c4e6c7e7d64f2cc$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).firstButton},& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $ea2e6573fef7cc68$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40
        }
    })));
const $8d51ecc339c58f69$var$ButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "disableRipple",
        "fullWidth",
        "orientation",
        "size",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $8d51ecc339c58f69$var$useUtilityClasses(ownerState);
    const context = $7fPBF.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $c4026d6932f3d411$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8d51ecc339c58f69$var$ButtonGroupRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        role: "group",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6c601e9bdfa4b364$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5ae2da91f81c1497$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $8d51ecc339c58f69$export$2e2bcd8739ae039 = $8d51ecc339c58f69$var$ButtonGroup;



let $39fdc36270d4c003$var$_ = (t)=>t, $39fdc36270d4c003$var$t, $39fdc36270d4c003$var$t1, $39fdc36270d4c003$var$t2, $39fdc36270d4c003$var$t3;
const $39fdc36270d4c003$export$2e54018d3f9b15e2 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $8d51ecc339c58f69$export$2e2bcd8739ae039))($39fdc36270d4c003$var$t || ($39fdc36270d4c003$var$t = $39fdc36270d4c003$var$_`
    margin: 0.5rem 0 0 0;
    background-color: ${0};
    color: ${0};
`), (props)=>props.theme.button.secondary.background, (props)=>props.theme.button.secondary.text);
const $39fdc36270d4c003$export$2cf8749a323c7474 = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $7c35bba429ede747$export$2e2bcd8739ae039))($39fdc36270d4c003$var$t1 || ($39fdc36270d4c003$var$t1 = $39fdc36270d4c003$var$_`
    ${0}
    text-transform: none;
    background-color: ${0};
    color: ${0};
    &:hover {
        background-color: ${0};
        color: ${0};
    }
`), (0, $b091aef3a32d2bd8$export$3e193b19d995235f), (props)=>props.theme.button.secondary.background, (props)=>props.theme.button.secondary.text, (props)=>props.theme.button.accent.hoverBackground, (props)=>props.theme.button.accent.hoverText);
const $39fdc36270d4c003$export$e018019c2d136eee = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $7c35bba429ede747$export$2e2bcd8739ae039))($39fdc36270d4c003$var$t2 || ($39fdc36270d4c003$var$t2 = $39fdc36270d4c003$var$_`
    max-width: fit-content;
    background-color: ${0};
    color: ${0};
    &:hover {
        background-color: ${0};
        color: ${0};
    }
`), (props)=>props.theme.button.secondary.background, (props)=>props.theme.button.secondary.text, (props)=>props.theme.button.accent.hoverBackground, (props)=>props.theme.button.accent.hoverText);
const $39fdc36270d4c003$export$f4f1ce1dc21e0917 = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($39fdc36270d4c003$var$t3 || ($39fdc36270d4c003$var$t3 = $39fdc36270d4c003$var$_`
    ${0}
`), (0, $b091aef3a32d2bd8$export$90f89b8a63d85ede));


function $94228c19da943b16$export$2e2bcd8739ae039({ options: options, renderOptionLabel: renderOptionLabel = (option)=>option, onSelect: onSelect, selectedIndex: selectedIndexProp, initialSelectedIndex: initialSelectedIndex = 0, buttonLabel: buttonLabel, groupLabel: groupLabel, onOpen: onOpen, className: className }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const isControlled = selectedIndexProp !== undefined;
    const [uncontrolledIndex, setUncontrolledIndex] = (0, $7fPBF.useState)(initialSelectedIndex);
    const selectedIndex = isControlled ? selectedIndexProp : uncontrolledIndex;
    const anchorRef = (0, $7fPBF.useRef)(null);
    const uuid = (0, $db3063bd3b6d501e$export$5dbf9a24b655dde4)();
    const isSingleOption = options.length <= 1;
    const handleMenuItemClick = (_event, index)=>{
        if (!isControlled) setUncontrolledIndex(index);
        setOpen(false);
        onSelect(options[index], index);
    };
    const handleToggle = ()=>{
        setOpen((prev)=>{
            const next = !prev;
            if (!prev && onOpen) onOpen();
            return next;
        });
    };
    const handleClose = (event)=>{
        var _anchorRef_current;
        if ((_anchorRef_current = anchorRef.current) === null || _anchorRef_current === void 0 ? void 0 : _anchorRef_current.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $39fdc36270d4c003$export$2e54018d3f9b15e2), {
                className: className,
                fullWidth: true,
                variant: "contained",
                ref: anchorRef,
                "aria-label": groupLabel,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fdc36270d4c003$export$2cf8749a323c7474), {
                        className: "split-button-primary",
                        fullWidth: true,
                        onClick: handleToggle,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fdc36270d4c003$export$f4f1ce1dc21e0917), {
                            children: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : renderOptionLabel(options[selectedIndex])
                        })
                    }),
                    !isSingleOption && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $39fdc36270d4c003$export$e018019c2d136eee), {
                        className: "split-button-secondary",
                        size: "small",
                        "aria-controls": open ? uuid + 'split-button-menu' : undefined,
                        "aria-expanded": open ? 'true' : undefined,
                        "aria-haspopup": "menu",
                        "aria-label": t('common:expandMenu'),
                        onClick: handleToggle,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                            name: "expandArrow",
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5b41facef9806db$export$2e2bcd8739ae039), {
                sx: {
                    zIndex: 1
                },
                open: open,
                anchorEl: anchorRef.current,
                transition: true,
                disablePortal: true,
                children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ab1beedea58600b$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, TransitionProps), {
                        style: {
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c12b3e51dd27af1e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $114507656b938c3f$export$58385c17fee43f89), {
                                onClickAway: handleClose,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6b48b896db5396e8$export$2e2bcd8739ae039), {
                                    id: uuid + 'split-button-menu',
                                    autoFocusItem: true,
                                    children: options && options.map((option, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                            selected: index === selectedIndex,
                                            onClick: (event)=>handleMenuItemClick(event, index),
                                            children: renderOptionLabel(option)
                                        }, index))
                                })
                            })
                        })
                    }))
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");



let $6f194f393743bc4e$var$_ = (t)=>t, $6f194f393743bc4e$var$t, $6f194f393743bc4e$var$t1, $6f194f393743bc4e$var$t2, $6f194f393743bc4e$var$t3, $6f194f393743bc4e$var$t4;
function $6f194f393743bc4e$export$2e2bcd8739ae039({ title: title, description: description, disabled: disabled = false, startIcon: startIcon, iconSize: iconSize = 16, iconColor: iconColor, tagNode: tagNode, children: children, defaultOpen: defaultOpen = false }) {
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(defaultOpen);
    const toggleOpen = ()=>{
        if (!disabled) setIsOpen((prev)=>!prev);
    };
    (0, $7fPBF.useEffect)(()=>{
        setIsOpen(defaultOpen);
    }, [
        defaultOpen
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6f194f393743bc4e$var$StyledRowWrapper, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6f194f393743bc4e$var$StyledButtonRow, {
                onClick: toggleOpen,
                disabled: disabled,
                isOpen: isOpen,
                role: "button",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $28d9662e98370ec0$export$e9f274a1a8d32886), {
                        children: [
                            tagNode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $347ffda0d89c401a$export$9ee67e6e3f51a5ed), {
                                children: [
                                    tagNode,
                                    ' ',
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6f194f393743bc4e$var$ActionRowTitle, {
                                        as: "span",
                                        children: [
                                            startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$d210d4f1518e7142), {
                                                name: startIcon,
                                                size: iconSize,
                                                color: iconColor
                                            }),
                                            title
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($6f194f393743bc4e$var$ActionRowTitle, {
                                as: "span",
                                children: [
                                    startIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28d9662e98370ec0$export$d210d4f1518e7142), {
                                        name: startIcon,
                                        size: iconSize,
                                        color: iconColor
                                    }),
                                    title
                                ]
                            }),
                            description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                                as: "span",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6f194f393743bc4e$var$RotatingEndIcon, {
                        name: "expandArrow",
                        size: iconSize,
                        isOpen: isOpen
                    })
                ]
            }),
            isOpen && children && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6f194f393743bc4e$var$StyledRowChildrenContainer, {
                children: children
            })
        ]
    });
}
const $6f194f393743bc4e$var$StyledButtonRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $28d9662e98370ec0$export$564cbe3426fc093a))($6f194f393743bc4e$var$t || ($6f194f393743bc4e$var$t = $6f194f393743bc4e$var$_`
    border-radius: ${0};
    background-color: ${0};

    &:hover {
        background-color: ${0};
    }
    &:focus-visible,
    :focus {
        outline: none !important;
        background-color: ${0};
    }
`), (props)=>props.isOpen ? '10px 10px 0 0' : '10px', (props)=>props.theme.color.cardHover, (props)=>props.isOpen ? props.theme.color.cardHover : props.theme.input.background, (props)=>props.theme.color.cardHover);
const $6f194f393743bc4e$var$ActionRowTitle = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$a35e4d6f9ac473d6))($6f194f393743bc4e$var$t1 || ($6f194f393743bc4e$var$t1 = $6f194f393743bc4e$var$_`
    color: inherit;
`));
const $6f194f393743bc4e$var$StyledRowChildrenContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $28d9662e98370ec0$export$23f145dc49963d58))($6f194f393743bc4e$var$t2 || ($6f194f393743bc4e$var$t2 = $6f194f393743bc4e$var$_`
    background-color: ${0};
    padding: 0 1rem 1rem 1rem;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: -0.5rem;
`), (props)=>props.theme.color.cardHover);
const $6f194f393743bc4e$var$RotatingEndIcon = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $28d9662e98370ec0$export$ec763714b6894364))($6f194f393743bc4e$var$t3 || ($6f194f393743bc4e$var$t3 = $6f194f393743bc4e$var$_`
    transition: transform 0.2s ease;
    transform: rotate(${0});
    align-self: center;
`), (p)=>p.isOpen ? '180deg' : '0deg');
const $6f194f393743bc4e$var$StyledRowWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $28d9662e98370ec0$export$bc7adc8ef74607f))($6f194f393743bc4e$var$t4 || ($6f194f393743bc4e$var$t4 = $6f194f393743bc4e$var$_`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 0.5rem;
    border-radius: 10px;
    border: 1px solid ${0};
    &:focus-within {
        outline: 2px solid ${0};
        outline-offset: -2px;
    }
`), (props)=>props.theme.color.cardHover, (props)=>props.theme.color.accent);











let $7d875aeefacd56ae$var$_ = (t)=>t, $7d875aeefacd56ae$var$t, $7d875aeefacd56ae$var$t1, $7d875aeefacd56ae$var$t2, $7d875aeefacd56ae$var$t3, $7d875aeefacd56ae$var$t4, $7d875aeefacd56ae$var$t5, $7d875aeefacd56ae$var$t6, $7d875aeefacd56ae$var$t7, $7d875aeefacd56ae$var$t8, $7d875aeefacd56ae$var$t9, $7d875aeefacd56ae$var$t10, $7d875aeefacd56ae$var$t11, $7d875aeefacd56ae$var$t12, $7d875aeefacd56ae$var$t13, $7d875aeefacd56ae$var$t14, $7d875aeefacd56ae$var$t15, $7d875aeefacd56ae$var$t16, $7d875aeefacd56ae$var$t17;
const $7d875aeefacd56ae$var$ContentWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t || ($7d875aeefacd56ae$var$t = $7d875aeefacd56ae$var$_`
    display: flex;
    flex: 1;
    gap: 0.5rem;
`));
const $7d875aeefacd56ae$var$Sidebar = (0, $8de346382d86c747$export$2e2bcd8739ae039).aside($7d875aeefacd56ae$var$t1 || ($7d875aeefacd56ae$var$t1 = $7d875aeefacd56ae$var$_`
    display: flex;
    width: fit-content;
    flex-shrink: 0;
    flex-direction: column;
    padding-right: 0.5rem;
    border-right: 1px solid ${0};
    background-color: var(--sidebar);
    gap: 1rem;
`), (props)=>props.theme.color.border);
const $7d875aeefacd56ae$var$SectionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).label($7d875aeefacd56ae$var$t2 || ($7d875aeefacd56ae$var$t2 = $7d875aeefacd56ae$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding-top: 1rem;
    color: var(--muted-foreground);
    ${0}
`), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944));
const $7d875aeefacd56ae$var$NavList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($7d875aeefacd56ae$var$t3 || ($7d875aeefacd56ae$var$t3 = $7d875aeefacd56ae$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`));
const $7d875aeefacd56ae$var$CompletionButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($7d875aeefacd56ae$var$t4 || ($7d875aeefacd56ae$var$t4 = $7d875aeefacd56ae$var$_`
    ${0}
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.375rem 0.5rem;
    border-radius: 0.375rem;
    background-color: ${0};
    color: ${0};
    transition: background-color 0.2s;
    cursor: pointer;
    border: none;
    text-align: left;

    &:hover {
        background-color: ${0};
    }
`), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944), ({ $isActive: $isActive, theme: theme })=>$isActive ? theme.color.accent + '30' : 'transparent', (props)=>props.theme.color.text, ({ $isActive: $isActive, theme: theme })=>$isActive ? theme.color.accent + '30' : theme.color.accent + '15');
const $7d875aeefacd56ae$var$CompletionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($7d875aeefacd56ae$var$t5 || ($7d875aeefacd56ae$var$t5 = $7d875aeefacd56ae$var$_`
    flex: 1;
    color: ${0};
`), (props)=>props.theme.color.text);
const $7d875aeefacd56ae$var$CompletionPercentage = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($7d875aeefacd56ae$var$t6 || ($7d875aeefacd56ae$var$t6 = $7d875aeefacd56ae$var$_`
    font-weight: 500;
    color: ${0};
`), ({ $isComplete: $isComplete, theme: theme })=>$isComplete ? theme.color.success : theme.color.textBody);
const $7d875aeefacd56ae$var$MainContent = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t7 || ($7d875aeefacd56ae$var$t7 = $7d875aeefacd56ae$var$_`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 1rem 0;
    gap: 1rem;
`));
const $7d875aeefacd56ae$var$ControlList = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t8 || ($7d875aeefacd56ae$var$t8 = $7d875aeefacd56ae$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`));
const $7d875aeefacd56ae$var$ControlEditorBody = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t9 || ($7d875aeefacd56ae$var$t9 = $7d875aeefacd56ae$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 0.5rem;
`));
const $7d875aeefacd56ae$var$SharedSectionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e))($7d875aeefacd56ae$var$t10 || ($7d875aeefacd56ae$var$t10 = $7d875aeefacd56ae$var$_`
    margin-top: 0.5rem;
`));
const $7d875aeefacd56ae$var$SharedFieldsGrid = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t11 || ($7d875aeefacd56ae$var$t11 = $7d875aeefacd56ae$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0.5rem 1rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    background-color: ${0};
    border: 1px dashed ${0};
`), (props)=>props.theme.color.cardHover, (props)=>props.theme.color.border);
const $7d875aeefacd56ae$var$Description = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t12 || ($7d875aeefacd56ae$var$t12 = $7d875aeefacd56ae$var$_`
    color: ${0};
    margin-bottom: 0.5rem;
    padding: 1rem;
    background-color: ${0};
    border-radius: 0.375rem;
    border: 1px solid ${0};
`), (props)=>props.theme.color.textBody, (props)=>props.theme.color.cardHover, (props)=>props.theme.color.border);
const $7d875aeefacd56ae$var$EmptyState = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t13 || ($7d875aeefacd56ae$var$t13 = $7d875aeefacd56ae$var$_`
    padding: 2rem;
    text-align: center;
    color: ${0};
    border-radius: 0.5rem;
    border: 1px dashed ${0};
`), (props)=>props.theme.color.textBody, (props)=>props.theme.color.border);
const $7d875aeefacd56ae$var$AddControlRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t14 || ($7d875aeefacd56ae$var$t14 = $7d875aeefacd56ae$var$_`
    display: flex;
    justify-content: flex-end;
`));
const $7d875aeefacd56ae$var$ReadOnlyIdRow = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($7d875aeefacd56ae$var$t15 || ($7d875aeefacd56ae$var$t15 = $7d875aeefacd56ae$var$_`
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.375rem;
    background-color: ${0};
    border: 1px solid ${0};
`), (props)=>props.theme.color.cardHover, (props)=>props.theme.color.border);
const $7d875aeefacd56ae$var$ReadOnlyIdLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($7d875aeefacd56ae$var$t16 || ($7d875aeefacd56ae$var$t16 = $7d875aeefacd56ae$var$_`
    ${0}
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${0};
`), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944), (props)=>props.theme.color.textBody);
const $7d875aeefacd56ae$var$ReadOnlyIdValue = (0, $8de346382d86c747$export$2e2bcd8739ae039).code($7d875aeefacd56ae$var$t17 || ($7d875aeefacd56ae$var$t17 = $7d875aeefacd56ae$var$_`
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    color: ${0};
    word-break: break-all;
`), (props)=>props.theme.color.text);
function $7d875aeefacd56ae$export$2e2bcd8739ae039({ hideSaveButton: hideSaveButton = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { deviceId: deviceId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState();
    const loadingCustomControls = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.loadingCustomControls);
    const customControlsHasChanges = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.customControlsHasChanges);
    const { activeLocale: activeLocale, setActiveLocale: setActiveLocale, isSaving: isSaving, LOCALES: LOCALES, currentControls: currentControls, totalControlCount: totalControlCount, getLocaleCompletion: getLocaleCompletion, isLocaleCustomized: isLocaleCustomized, isControlCompleteById: isControlCompleteById, isControlNew: isControlNew, getControlRowKey: getControlRowKey, handlePerLocaleFieldChange: handlePerLocaleFieldChange, handleSharedFieldChange: handleSharedFieldChange, handleIdChange: handleIdChange, handleAddControl: handleAddControl, saveCustomControls: saveCustomControls } = (0, $fca7ea4f5f2a2056$export$f530b0e5c83c4707)(organizationId, deviceId);
    const handleSave = async ()=>{
        await saveCustomControls(showSuccess, showError);
    };
    if (loadingCustomControls) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$b1ae020268e0b4d5), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceType.customControls.title'),
                $sticky: true,
                children: !hideSaveButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    onClick: handleSave,
                    disabled: !customControlsHasChanges || isSaving,
                    children: isSaving ? t('common:saving') : t('common:save')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$Sidebar, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$SectionLabel, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "globe",
                                                ariaLabel: t('common:localization.titleShort')
                                            }),
                                            t('common:localization.titleShort')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94228c19da943b16$export$2e2bcd8739ae039), {
                                        options: LOCALES.map((locale)=>locale.code),
                                        selectedIndex: LOCALES.findIndex((l)=>l.code === activeLocale),
                                        renderOptionLabel: (option)=>{
                                            const locale = LOCALES.find((l)=>l.code === option);
                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        children: locale === null || locale === void 0 ? void 0 : locale.flag
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        children: locale === null || locale === void 0 ? void 0 : locale.label
                                                    })
                                                ]
                                            });
                                        },
                                        groupLabel: t('common:localization.select'),
                                        onSelect: (option)=>setActiveLocale(option)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$SectionLabel, {
                                id: "custom-controls-completion-label",
                                children: t('common:organization.completionStatus.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$NavList, {
                                "aria-labelledby": "custom-controls-completion-label",
                                children: LOCALES.map((locale)=>{
                                    const isFallback = locale.code !== (0, $3ecd3f7dea3d56de$export$f44b61b0f29ec) && !isLocaleCustomized(locale.code);
                                    const percentage = isFallback ? null : getLocaleCompletion(locale.code);
                                    const isComplete = percentage === 100;
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$CompletionButton, {
                                        $isActive: activeLocale === locale.code,
                                        onClick: ()=>setActiveLocale(locale.code),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: isFallback ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "globe",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.projects.deviceType.customControls.fallback')
                                                }) : isComplete ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "check",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.completionStatus.complete')
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "warningTriangle",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.completionStatus.incomplete')
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$CompletionLabel, {
                                                children: locale.label
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$CompletionPercentage, {
                                                $isComplete: isComplete,
                                                children: isFallback ? t('common:organization.projects.deviceType.customControls.fallback') : `${percentage}%`
                                            })
                                        ]
                                    }, locale.code);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$MainContent, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$Description, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: t('common:organization.projects.deviceType.customControls.description')
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$AddControlRow, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                                    $color: "text",
                                    startIcon: "plus",
                                    onClick: ()=>handleAddControl(),
                                    children: t('common:organization.projects.deviceType.customControls.addControl')
                                })
                            }),
                            totalControlCount === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$EmptyState, {
                                children: t('common:organization.projects.deviceType.customControls.empty')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$ControlList, {
                                children: currentControls.map((control)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$ControlEditor, {
                                        control: control,
                                        isComplete: isControlCompleteById(control.id),
                                        isNew: isControlNew(control.id),
                                        onPerLocaleChange: handlePerLocaleFieldChange,
                                        onSharedChange: handleSharedFieldChange,
                                        onIdChange: handleIdChange
                                    }, getControlRowKey(control.id)))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $7d875aeefacd56ae$var$ControlEditor({ control: control, isComplete: isComplete, isNew: isNew, onPerLocaleChange: onPerLocaleChange, onSharedChange: onSharedChange, onIdChange: onIdChange }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const commands = control.defaultCommands && control.defaultCommands.length > 0 ? control.defaultCommands : [
        ''
    ];
    const handleCommandChange = (index, value)=>{
        const next = [
            ...commands
        ];
        next[index] = value;
        onPerLocaleChange(control.id, 'defaultCommands', next);
    };
    const handleCommandRemove = (index)=>{
        const next = commands.filter((_, i)=>i !== index);
        onPerLocaleChange(control.id, 'defaultCommands', next.length > 0 ? next : [
            ''
        ]);
    };
    const handleCommandAdd = ()=>{
        onPerLocaleChange(control.id, 'defaultCommands', [
            ...commands,
            ''
        ]);
    };
    const title = control.name || t('common:organization.projects.deviceType.customControls.untitled');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6f194f393743bc4e$export$2e2bcd8739ae039), {
        title: title,
        description: control.description,
        startIcon: isComplete ? 'check' : 'warningTriangle',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$ControlEditorBody, {
            children: [
                isNew ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                    label: t('common:organization.projects.deviceType.customControls.controlId'),
                    value: control.id,
                    onChange: (e)=>onIdChange(control.id, e.target.value),
                    helperText: t('common:organization.projects.deviceType.customControls.controlIdHelp'),
                    error: !control.id || !control.id.trim(),
                    fullWidth: true
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$ReadOnlyIdRow, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$ReadOnlyIdLabel, {
                            children: t('common:organization.projects.deviceType.customControls.controlId')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$ReadOnlyIdValue, {
                            children: control.id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                    label: t('common:organization.projects.deviceType.customControls.controlName'),
                    value: control.name || '',
                    onChange: (e)=>onPerLocaleChange(control.id, 'name', e.target.value),
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                    label: t('common:organization.projects.deviceType.customControls.controlDescription'),
                    value: control.description || '',
                    onChange: (e)=>onPerLocaleChange(control.id, 'description', e.target.value),
                    multiline: true,
                    rows: 2,
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$SharedSectionLabel, {
                    as: "div",
                    children: t('common:organization.projects.deviceType.customControls.defaultCommandsLabel')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                    children: t('common:organization.projects.deviceType.customControls.defaultCommandsHelp')
                }),
                commands.map((command, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0cb68ea454bd64de$export$2e2bcd8739ae039), {
                        startIcon: "voice",
                        value: command,
                        commandType: "voice",
                        onChange: (value)=>handleCommandChange(index, value),
                        onRemove: ()=>handleCommandRemove(index)
                    }, index)),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e5f1d53bbf8fecdc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        $color: "text",
                        startIcon: "plus",
                        onClick: handleCommandAdd,
                        children: t('common:input.addMore')
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$SharedSectionLabel, {
                    as: "div",
                    children: t('common:organization.projects.deviceType.customControls.sharedAcrossLanguages')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
                    children: t('common:organization.projects.deviceType.customControls.sharedAcrossLanguagesHelp')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($7d875aeefacd56ae$var$SharedFieldsGrid, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                            label: t('common:organization.projects.deviceType.customControls.iconUrl'),
                            value: control.iconUrl || '',
                            onChange: (e)=>onSharedChange(control.id, 'iconUrl', e.target.value),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                            label: t('common:organization.projects.deviceType.customControls.contextGroupName'),
                            value: control.contextGroupName || '',
                            onChange: (e)=>onSharedChange(control.id, 'contextGroupName', e.target.value),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.isProfileControl,
                            label: t('common:organization.projects.deviceType.customControls.isProfileControl'),
                            onChange: (value)=>onSharedChange(control.id, 'isProfileControl', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.isPrefixVoiceCommand,
                            label: t('common:organization.projects.deviceType.customControls.isPrefixVoiceCommand'),
                            onChange: (value)=>onSharedChange(control.id, 'isPrefixVoiceCommand', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.allowWhenDictating,
                            label: t('common:organization.projects.deviceType.customControls.allowWhenDictating'),
                            onChange: (value)=>onSharedChange(control.id, 'allowWhenDictating', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.allowsHold,
                            label: t('common:organization.projects.deviceType.customControls.allowsHold'),
                            onChange: (value)=>onSharedChange(control.id, 'allowsHold', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.isDeprecated,
                            label: t('common:organization.projects.deviceType.customControls.isDeprecated'),
                            onChange: (value)=>onSharedChange(control.id, 'isDeprecated', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.requiresEmployeeAccess,
                            label: t('common:organization.projects.deviceType.customControls.requiresEmployeeAccess'),
                            onChange: (value)=>onSharedChange(control.id, 'requiresEmployeeAccess', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.requiresStudentAccess,
                            label: t('common:organization.projects.deviceType.customControls.requiresStudentAccess'),
                            onChange: (value)=>onSharedChange(control.id, 'requiresStudentAccess', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.requiresGenericLicense,
                            label: t('common:organization.projects.deviceType.customControls.requiresGenericLicense'),
                            onChange: (value)=>onSharedChange(control.id, 'requiresGenericLicense', value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7d875aeefacd56ae$var$BooleanToggle, {
                            checked: !!control.requiresPlusAccess,
                            label: t('common:organization.projects.deviceType.customControls.requiresPlusAccess'),
                            onChange: (value)=>onSharedChange(control.id, 'requiresPlusAccess', value)
                        })
                    ]
                })
            ]
        })
    });
}
function $7d875aeefacd56ae$var$BooleanToggle({ checked: checked, label: label, onChange: onChange }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b6e9b66c5b93a14$export$2e2bcd8739ae039), {
            checked: checked,
            onChange: (e)=>onChange(e.target.checked)
        }),
        label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$509f2eb89cb5202e), {
            as: "span",
            children: label
        }),
        labelPlacement: "end"
    });
}












function $f5435d2a87cfbb47$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrg: currentOrg, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { currentOrgDeviceType: currentOrgDeviceType, error: error, isLoading: isLoadingProject } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    (0, $bc567063fd13cd58$export$d5236bf86334668)(currentOrgDeviceType);
    if (!currentOrgDeviceType || isLoading || isLoadingProject) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg || !canCreateAuthClients || error.device) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceType.customControls.title'),
                description: currentOrgDeviceType.name ? `${currentOrgDeviceType.name} \u{2014} ${t('common:organization.projects.deviceType.customControls.description')}` : t('common:organization.projects.deviceType.customControls.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa23c6db410f15d5$export$54fb318478ce42e9), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7d875aeefacd56ae$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
















var $7fPBF = parcelRequire("7fPBF");

// Locale flags for display
const $454d6d8464fffdd6$var$LOCALE_FLAGS = {
    en: "\uD83C\uDDFA\uD83C\uDDF8",
    es: "\uD83C\uDDEA\uD83C\uDDF8",
    fr: "\uD83C\uDDEB\uD83C\uDDF7",
    it: "\uD83C\uDDEE\uD83C\uDDF9",
    de: "\uD83C\uDDE9\uD83C\uDDEA",
    ja: "\uD83C\uDDEF\uD83C\uDDF5"
};
// Map document type IDs to DeviceTypeClientListingModel field names
const $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP = {
    metadata: 'markdownDescription',
    troubleshooting: 'markdownTroubleshootingInstructions',
    onboarding: 'markdownOnboardingInstructions',
    'client-listing': 'markdownDescription'
};
function $454d6d8464fffdd6$export$9ee234e2f2bcf99f(organizationId, deviceId) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.editListing);
    const [activeDocument, setActiveDocument] = (0, $7fPBF.useState)('metadata');
    const [activeLocale, setActiveLocale] = (0, $7fPBF.useState)('en');
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const LOCALES = (0, $7fPBF.useMemo)(()=>(0, $3ecd3f7dea3d56de$export$df1c34db1371eeed).display.map((code)=>({
                code: code,
                label: t(`common:localization.localesShort.${code}`),
                flag: $454d6d8464fffdd6$var$LOCALE_FLAGS[code]
            })), [
        t
    ]);
    // Validation helper for URL fields
    const isValidUrl = (url, isOptional = false)=>{
        if (!url || url.trim() === '') return isOptional;
        return url.startsWith('http://') || url.startsWith('https://');
    };
    // Helper function to check if a listing is complete
    const isListingComplete = (listing)=>{
        const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editListing;
        if (!editListing) return false;
        const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
        const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
        const requiredFields = [
            listing.title,
            listing.shortDescription,
            isValidUrl(listing.iconUrl),
            isValidUrl(listing.darkModeIconUrl),
            listing.markdownDescription && listing.markdownDescription.length > 25 || listing.externalLink && listing.externalLink.trim() !== ''
        ];
        // Validate optional external link if provided
        if (listing.externalLink && listing.externalLink.trim() !== '') requiredFields.push(isValidUrl(listing.externalLink, true));
        if (anyHasOnboarding) requiredFields.push(listing.markdownOnboardingInstructions && listing.markdownOnboardingInstructions.length > 25);
        if (anyHasTroubleshooting) requiredFields.push(listing.markdownTroubleshootingInstructions && listing.markdownTroubleshootingInstructions.length > 25);
        return requiredFields.every(Boolean);
    };
    // Calculate completion percentage for each locale
    const getLocaleCompletion = (localeCode)=>{
        const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editListing;
        if (!editListing) return 0;
        const listing = editListing.find((l)=>l.locale === localeCode);
        if (!listing) return 0;
        const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
        const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
        let filled = [
            listing.title,
            listing.shortDescription,
            isValidUrl(listing.iconUrl),
            isValidUrl(listing.darkModeIconUrl),
            listing.markdownDescription && listing.markdownDescription.length > 25 || listing.externalLink && listing.externalLink.trim() !== ''
        ].filter(Boolean).length;
        let total = 5;
        if (anyHasOnboarding) {
            total += 1;
            filled += listing.markdownOnboardingInstructions && listing.markdownOnboardingInstructions.length > 25 ? 1 : 0;
        }
        if (anyHasTroubleshooting) {
            total += 1;
            filled += listing.markdownTroubleshootingInstructions && listing.markdownTroubleshootingInstructions.length > 25 ? 1 : 0;
        }
        return Math.round(filled / total * 100);
    };
    // Handle content changes for markdown fields
    const handleContentChange = (value)=>{
        const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editListing;
        if (value !== undefined && editListing) {
            const fieldName = $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP[activeDocument];
            const updatedListing = editListing.map((listing)=>{
                if (listing.locale === activeLocale) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, listing), {
                    [fieldName]: value
                });
                return listing;
            });
            (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setEditListing(updatedListing);
            (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setListingHasChanges(true);
        }
    };
    // Handle metadata field changes
    const handleMetadataFieldChange = (fieldName, value)=>{
        const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editListing;
        if (editListing) {
            const updatedListing = editListing.map((listing)=>{
                if (listing.locale === activeLocale) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, listing), {
                    [fieldName]: value
                });
                return listing;
            });
            (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setEditListing(updatedListing);
            (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setListingHasChanges(true);
        }
    };
    // Save listings
    const saveListings = async (onSuccess, onError)=>{
        const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().editListing;
        if (!organizationId || !deviceId || !editListing) {
            onError(t('common:saveError'));
            return false;
        }
        // Filter to only complete listings
        const completeListings = editListing.filter(isListingComplete);
        const incompleteListings = editListing.filter((listing)=>!isListingComplete(listing));
        if (completeListings.length === 0) {
            onError('All locales are incomplete. Please complete at least one locale to 100% before saving.');
            return false;
        }
        setIsSaving(true);
        try {
            // Create en-us as a copy of en if en exists
            let listingsToSave = [
                ...completeListings
            ];
            const enListing = completeListings.find((l)=>l.locale === 'en');
            if (enListing) {
                const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                if (!hasEnUs) {
                    const enUsListing = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, enListing), {
                        locale: 'en-us'
                    });
                    listingsToSave.push(enUsListing);
                }
            }
            const request = {
                listings: (0, $710192f33815db16$export$e0ee21b9e212f3d0)(listingsToSave)
            };
            const response = await $1a4c36336f303477$export$2fbd549f3e7afb42(organizationId, deviceId, request);
            if (response.resultType === 'Ok') {
                // Show success message with incomplete locale info
                if (incompleteListings.length > 0) {
                    const enListing = completeListings.find((l)=>l.locale === 'en');
                    const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                    const supportedLocaleCodes = LOCALES.map((loc)=>loc.code);
                    const actuallyIncompleteListings = incompleteListings.filter((l)=>!(l.locale === 'en-us' && enListing && !hasEnUs) && supportedLocaleCodes.includes(l.locale));
                    if (actuallyIncompleteListings.length > 0) {
                        const incompleteLocales = actuallyIncompleteListings.map((l)=>{
                            const localeInfo = LOCALES.find((loc)=>loc.code === l.locale);
                            return localeInfo ? `${localeInfo.flag} ${localeInfo.label}` : l.locale;
                        }).join(', ');
                        onSuccess(`Saved ${listingsToSave.length} complete locale(s). ` + `Incomplete locales not saved: ${incompleteLocales}`);
                    } else onSuccess(`Saved ${listingsToSave.length} locale(s) successfully.`);
                } else onSuccess(t('common:saved'));
                (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setListingHasChanges(false);
                // Reload the listings to get updated data
                const refreshResult = await $1a4c36336f303477$export$f942174137d3f696(organizationId, deviceId);
                if (refreshResult.resultType === 'Ok' && refreshResult.data) (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setEditListing(refreshResult.data);
                return true;
            } else {
                const errorMessage = response.errors ? response.errors.join(', ') : '';
                onError(t('common:saveError') + (errorMessage ? ': ' + errorMessage : ''));
                return false;
            }
        } catch (error) {
            console.error('Error saving device type client listings:', error);
            onError(t('common:saveError'));
            return false;
        } finally{
            setIsSaving(false);
        }
    };
    // Get current content for the active document and locale
    const currentContent = (0, $7fPBF.useMemo)(()=>{
        if (!editListing) return '';
        const listing = editListing.find((l)=>l.locale === activeLocale);
        if (!listing) return '';
        const fieldName = $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP[activeDocument];
        return listing[fieldName] || '';
    }, [
        editListing,
        activeLocale,
        activeDocument
    ]);
    // Get current listing for metadata fields
    const currentListing = (0, $7fPBF.useMemo)(()=>{
        if (!editListing) return null;
        return editListing.find((l)=>l.locale === activeLocale);
    }, [
        editListing,
        activeLocale
    ]);
    const isDocumentEmpty = (0, $7fPBF.useCallback)((documentType)=>{
        if (!editListing) return true;
        const listing = editListing.find((l)=>l.locale === activeLocale);
        if (!listing) return true;
        const fieldName = $454d6d8464fffdd6$var$DOCUMENT_TYPE_FIELD_MAP[documentType];
        const content = listing[fieldName];
        return !content || content.length === 0;
    }, [
        editListing,
        activeLocale
    ]);
    // Check if a specific document is complete for the current locale
    const isDocumentComplete = (0, $7fPBF.useCallback)((documentType)=>{
        if (!editListing || !currentListing) return false;
        // Check if any locale has onboarding or troubleshooting instructions
        const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
        const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
        switch(documentType){
            case 'metadata':
                return !!(currentListing.title && currentListing.shortDescription && isValidUrl(currentListing.iconUrl) && isValidUrl(currentListing.darkModeIconUrl) && (currentListing.markdownDescription && currentListing.markdownDescription.length > 25 || currentListing.externalLink && currentListing.externalLink.trim() !== ''));
            case 'troubleshooting':
                // Only required if any locale has troubleshooting
                if (!anyHasTroubleshooting) return true;
                return !!(currentListing.markdownTroubleshootingInstructions && currentListing.markdownTroubleshootingInstructions.length > 25);
            case 'onboarding':
                // Only required if any locale has onboarding
                if (!anyHasOnboarding) return true;
                return !!(currentListing.markdownOnboardingInstructions && currentListing.markdownOnboardingInstructions.length > 25);
            case 'client-listing':
                return !!(currentListing.markdownDescription && currentListing.markdownDescription.length > 25);
            default:
                return false;
        }
    }, [
        editListing,
        currentListing
    ]);
    return {
        activeDocument: // State
        activeDocument,
        setActiveDocument: setActiveDocument,
        activeLocale: activeLocale,
        setActiveLocale: setActiveLocale,
        isSaving: isSaving,
        LOCALES: LOCALES,
        currentContent: // Computed values
        currentContent,
        currentListing: currentListing,
        isValidUrl: // Functions
        isValidUrl,
        isListingComplete: isListingComplete,
        getLocaleCompletion: getLocaleCompletion,
        handleContentChange: handleContentChange,
        handleMetadataFieldChange: handleMetadataFieldChange,
        saveListings: saveListings,
        isDocumentComplete: isDocumentComplete,
        isDocumentEmpty: isDocumentEmpty
    };
}













var $7fPBF = parcelRequire("7fPBF");



let $9d497189a1b403bd$var$_ = (t)=>t, $9d497189a1b403bd$var$t;
const $9d497189a1b403bd$var$TabButton = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_param, ref)=>{
    var { isActive: isActive, statusAlert: statusAlert, children: children, iconName: iconName, iconColor: iconColor, disabled: disabled } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "isActive",
        "statusAlert",
        "children",
        "iconName",
        "iconColor",
        "disabled"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($9d497189a1b403bd$var$TabButtonStyle, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        statusAlert: statusAlert,
        isActive: isActive,
        disabled: disabled
    }, restProps), {
        ref: ref,
        children: [
            (isActive || iconName) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                name: iconName || 'check',
                size: 16,
                color: iconColor
            }),
            children
        ]
    }));
});
$9d497189a1b403bd$var$TabButton.displayName = 'TabButton';
var $9d497189a1b403bd$export$2e2bcd8739ae039 = $9d497189a1b403bd$var$TabButton;
const $9d497189a1b403bd$var$TabButtonStyle = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($9d497189a1b403bd$var$t || ($9d497189a1b403bd$var$t = $9d497189a1b403bd$var$_`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0.5rem;
    ${0};
    border: ${0};
    background: ${0};
    color: ${0};
    ${0};
    cursor: pointer;
    border-radius: ${0};
    transition: all 0.2s ease;
    ${0}
    ${0}
    ${0}

    &:hover {
        background: ${0};
        color: ${0};
    }
    &:focus {
        outline: none !important;
        box-shadow: none !important;
    }
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    ${0}
`), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944), (props)=>props.isActive ? `1px solid ${props.theme.color.text}` : '1px solid transparent', (props)=>props.isActive ? props.theme.color.accent : props.theme.color.cardHover, (props)=>props.isActive ? props.theme.color.background : props.theme.button.secondary.text, (props)=>props.isActive && `text-decoration: underline;`, (0, $8951886a6b49e92a$export$7a57f79000377ca2).md, (props)=>props.statusAlert === 'warning' && ` background: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).accent_2_light}; color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).primary_dark};`, (props)=>props.statusAlert === 'error' && ` color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light}; background: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).error};`, (props)=>props.statusAlert === 'success' && ` background: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).success}; color: ${(0, $8951886a6b49e92a$export$35e9368ef982300f).bg_light};`, (props)=>props.theme.button.secondary.text, (props)=>props.theme.color.background, (0, $19e0bc52fddd02b4$export$87f1b08a59e6d1dd));












let $a326367fe13d13bb$var$_ = (t)=>t, $a326367fe13d13bb$var$t, $a326367fe13d13bb$var$t1, $a326367fe13d13bb$var$t2, $a326367fe13d13bb$var$t3, $a326367fe13d13bb$var$t4, $a326367fe13d13bb$var$t5, $a326367fe13d13bb$var$t6, $a326367fe13d13bb$var$t7, $a326367fe13d13bb$var$t8, $a326367fe13d13bb$var$t9, $a326367fe13d13bb$var$t10, $a326367fe13d13bb$var$t11, $a326367fe13d13bb$var$t12;
const $a326367fe13d13bb$var$ContentWrapper = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a326367fe13d13bb$var$t || ($a326367fe13d13bb$var$t = $a326367fe13d13bb$var$_`
    display: flex;
    flex: 1;
    gap: 0.5rem;
`));
const $a326367fe13d13bb$var$Sidebar = (0, $8de346382d86c747$export$2e2bcd8739ae039).aside($a326367fe13d13bb$var$t1 || ($a326367fe13d13bb$var$t1 = $a326367fe13d13bb$var$_`
    display: flex;
    width: fit-content;
    flex-shrink: 0;
    flex-direction: column;
    padding-right: 0.5rem;
    border-right: 1px solid ${0};
    background-color: var(--sidebar);
    gap: 1rem;
`), (props)=>props.theme.color.border);
const $a326367fe13d13bb$var$SectionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).label($a326367fe13d13bb$var$t2 || ($a326367fe13d13bb$var$t2 = $a326367fe13d13bb$var$_`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding-top: 1rem;
    color: var(--muted-foreground);
    ${0}
`), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944));
const $a326367fe13d13bb$var$NavList = (0, $8de346382d86c747$export$2e2bcd8739ae039).ul($a326367fe13d13bb$var$t3 || ($a326367fe13d13bb$var$t3 = $a326367fe13d13bb$var$_`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`));
const $a326367fe13d13bb$var$CompletionButton = (0, $8de346382d86c747$export$2e2bcd8739ae039).button($a326367fe13d13bb$var$t4 || ($a326367fe13d13bb$var$t4 = $a326367fe13d13bb$var$_`
    ${0}
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.375rem 0.5rem;
    border-radius: 0.375rem;
    background-color: ${0};
    color: ${0};
    transition: background-color 0.2s;
    cursor: pointer;
    border: none;
    text-align: left;

    &:hover {
        background-color: ${0};
    }
`), (0, $b091aef3a32d2bd8$export$c0ddd0327d77e944), ({ $isActive: $isActive, theme: theme })=>$isActive ? theme.color.accent + '30' : 'transparent', (props)=>props.theme.color.text, ({ $isActive: $isActive, theme: theme })=>$isActive ? theme.color.accent + '30' : theme.color.accent + '15');
const $a326367fe13d13bb$var$CompletionLabel = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($a326367fe13d13bb$var$t5 || ($a326367fe13d13bb$var$t5 = $a326367fe13d13bb$var$_`
    flex: 1;
    color: ${0};
`), (props)=>props.theme.color.text);
const $a326367fe13d13bb$var$CompletionPercentage = (0, $8de346382d86c747$export$2e2bcd8739ae039).span($a326367fe13d13bb$var$t6 || ($a326367fe13d13bb$var$t6 = $a326367fe13d13bb$var$_`
    font-weight: 500;
    color: ${0};
`), ({ $isComplete: $isComplete, theme: theme })=>$isComplete ? theme.color.success : theme.color.textBody);
const $a326367fe13d13bb$var$MainContent = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a326367fe13d13bb$var$t7 || ($a326367fe13d13bb$var$t7 = $a326367fe13d13bb$var$_`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 1rem 0;
`));
const $a326367fe13d13bb$var$EditorSection = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a326367fe13d13bb$var$t8 || ($a326367fe13d13bb$var$t8 = $a326367fe13d13bb$var$_`
    flex: 1;
    overflow: hidden;
`));
const $a326367fe13d13bb$var$EditorContainer = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a326367fe13d13bb$var$t9 || ($a326367fe13d13bb$var$t9 = $a326367fe13d13bb$var$_`
    height: 100%;
    border-radius: 0.5rem;
    border: 1px solid var(--border);
    background-color: var(--card);
    overflow: hidden;
`));
const $a326367fe13d13bb$var$MetadataForm = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a326367fe13d13bb$var$t10 || ($a326367fe13d13bb$var$t10 = $a326367fe13d13bb$var$_`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
    overflow-y: auto;
    height: 100%;
`));
const $a326367fe13d13bb$var$StyledTextField = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039))($a326367fe13d13bb$var$t11 || ($a326367fe13d13bb$var$t11 = $a326367fe13d13bb$var$_`
    & .MuiOutlinedInput-root {
        &.Mui-error .MuiOutlinedInput-notchedOutline {
            border-color: ${0};
        }
        &.Mui-error:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${0};
        }
        &.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: ${0};
        }
    }
    & .MuiFormHelperText-root.Mui-error {
        color: ${0};
    }
`), (props)=>props.theme.color.danger, (props)=>props.theme.color.danger, (props)=>props.theme.color.danger, (props)=>props.theme.color.danger);
const $a326367fe13d13bb$var$DocumentDescription = (0, $8de346382d86c747$export$2e2bcd8739ae039).div($a326367fe13d13bb$var$t12 || ($a326367fe13d13bb$var$t12 = $a326367fe13d13bb$var$_`
    color: ${0};
    margin-bottom: 1rem;
    padding: 1rem;
    background-color: ${0};
    border-radius: 0.375rem;
    border: 1px solid ${0};
`), (props)=>props.theme.color.textBody, (props)=>props.theme.color.cardHover, (props)=>props.theme.color.border);
const $a326367fe13d13bb$var$DOCUMENT_TYPES = [
    {
        id: 'metadata',
        icon: 'fileMd'
    },
    {
        id: 'client-listing',
        icon: 'fileMd'
    },
    {
        id: 'troubleshooting',
        icon: 'fileMd'
    },
    {
        id: 'onboarding',
        icon: 'fileMd'
    }
];
function $a326367fe13d13bb$export$2e2bcd8739ae039({ hideSaveButton: hideSaveButton = false }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $748d28edcc8cedba$export$2e2bcd8739ae039)();
    const { deviceId: deviceId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { showSuccess: showSuccess, showError: showError } = (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState();
    const loadingListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.loadingListing);
    const listingHasChanges = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.listingHasChanges);
    const { activeDocument: activeDocument, setActiveDocument: setActiveDocument, activeLocale: activeLocale, setActiveLocale: setActiveLocale, isSaving: isSaving, LOCALES: LOCALES, currentContent: currentContent, currentListing: currentListing, isValidUrl: isValidUrl, getLocaleCompletion: getLocaleCompletion, handleContentChange: handleContentChange, handleMetadataFieldChange: handleMetadataFieldChange, saveListings: saveListings, isDocumentComplete: isDocumentComplete, isDocumentEmpty: isDocumentEmpty } = (0, $454d6d8464fffdd6$export$9ee234e2f2bcf99f)(organizationId, deviceId);
    const handleSave = async ()=>{
        await saveListings(showSuccess, showError);
    };
    if (loadingListing) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bebe83a624352a6$export$b1ae020268e0b4d5), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: 'Cephable In-App Documentation Editor',
                $sticky: true,
                children: !hideSaveButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    onClick: handleSave,
                    disabled: !listingHasChanges || isSaving,
                    children: isSaving ? t('common:saving') : t('common:save')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$Sidebar, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$SectionLabel, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                name: "globe",
                                                ariaLabel: t('common:localization.titleShort')
                                            }),
                                            t('common:localization.titleShort')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $94228c19da943b16$export$2e2bcd8739ae039), {
                                        options: LOCALES.map((locale)=>locale.code),
                                        selectedIndex: LOCALES.findIndex((l)=>l.code === activeLocale),
                                        renderOptionLabel: (option)=>{
                                            const locale = LOCALES.find((l)=>l.code === option);
                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        children: locale === null || locale === void 0 ? void 0 : locale.flag
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        children: locale === null || locale === void 0 ? void 0 : locale.label
                                                    })
                                                ]
                                            });
                                        },
                                        groupLabel: t('common:localization.select'),
                                        onSelect: (option)=>setActiveLocale(option)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$SectionLabel, {
                                id: "documents-label",
                                children: t('common:organization.documents')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$NavList, {
                                "aria-labelledby": "documents-label",
                                children: $a326367fe13d13bb$var$DOCUMENT_TYPES.map((doc)=>{
                                    const isComplete = isDocumentComplete(doc.id);
                                    const isEmpty = isDocumentEmpty(doc.id);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d497189a1b403bd$export$2e2bcd8739ae039), {
                                        isActive: activeDocument === doc.id,
                                        iconName: isComplete ? 'check' : 'warningTriangle',
                                        statusAlert: isComplete ? 'success' : 'warning',
                                        onClick: ()=>setActiveDocument(doc.id),
                                        children: t(`common:organization.${doc.id}.title`)
                                    }, doc.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$SectionLabel, {
                                id: "completion-status-label",
                                children: t('common:organization.completionStatus.title')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$NavList, {
                                "aria-labelledby": "completion-status-label",
                                children: LOCALES.map((locale)=>{
                                    const percentage = getLocaleCompletion(locale.code);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$CompletionButton, {
                                        $isActive: activeLocale === locale.code,
                                        onClick: ()=>setActiveLocale(locale.code),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: percentage == 100 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "check",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.completionStatus.complete')
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f7580c2fb20f0ef1$export$2e2bcd8739ae039), {
                                                    name: "warningTriangle",
                                                    size: 15,
                                                    ariaLabel: t('common:organization.completionStatus.incomplete')
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$CompletionLabel, {
                                                children: locale.label
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$CompletionPercentage, {
                                                $isComplete: percentage === 100,
                                                children: [
                                                    percentage,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, locale.code);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$MainContent, {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$DocumentDescription, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$476b59e00e6c3fbd), {
                                    children: t(`common:organization.${activeDocument}.editorDescription`)
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$EditorSection, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$EditorContainer, {
                                    children: activeDocument === 'metadata' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($a326367fe13d13bb$var$MetadataForm, {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "title",
                                                label: t('common:organization.metadata.metatitle.label'),
                                                value: (currentListing === null || currentListing === void 0 ? void 0 : currentListing.title) || '',
                                                onChange: (e)=>handleMetadataFieldChange('title', e.target.value),
                                                placeholder: t('common:organization.metadata.metatitle.placeholder')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "shortDescription",
                                                label: t('common:organization.metadata.shortDescription.label'),
                                                value: (currentListing === null || currentListing === void 0 ? void 0 : currentListing.shortDescription) || '',
                                                onChange: (e)=>handleMetadataFieldChange('shortDescription', e.target.value),
                                                placeholder: t('common:organization.metadata.shortDescription.placeholder'),
                                                multiline: true,
                                                rows: 3
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6), {
                                                children: t('common:organization.metadata.iconUrl.description')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "iconUrl",
                                                label: t('common:organization.metadata.iconUrl.label'),
                                                value: (currentListing === null || currentListing === void 0 ? void 0 : currentListing.iconUrl) || '',
                                                onChange: (e)=>handleMetadataFieldChange('iconUrl', e.target.value),
                                                placeholder: "Enter icon URL (must start with http:// or https://)",
                                                error: !isValidUrl(currentListing === null || currentListing === void 0 ? void 0 : currentListing.iconUrl),
                                                helperText: !isValidUrl(currentListing === null || currentListing === void 0 ? void 0 : currentListing.iconUrl) ? t('common:organization.metadata.urlError') : ''
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "darkModeIconUrl",
                                                label: t('common:organization.metadata.darkModeIconUrl.label'),
                                                value: (currentListing === null || currentListing === void 0 ? void 0 : currentListing.darkModeIconUrl) || '',
                                                onChange: (e)=>handleMetadataFieldChange('darkModeIconUrl', e.target.value),
                                                placeholder: t('common:organization.metadata.darkModeIconUrl.placeholder'),
                                                error: !isValidUrl(currentListing === null || currentListing === void 0 ? void 0 : currentListing.darkModeIconUrl),
                                                helperText: !isValidUrl(currentListing === null || currentListing === void 0 ? void 0 : currentListing.darkModeIconUrl) ? t('common:organization.metadata.urlError') : ''
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$f51cc64edb23e9d6), {
                                                children: t('common:organization.metadata.externalLink.description')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a326367fe13d13bb$var$StyledTextField, {
                                                id: "externalLink",
                                                label: t('common:organization.metadata.externalLink.label'),
                                                value: (currentListing === null || currentListing === void 0 ? void 0 : currentListing.externalLink) || '',
                                                onChange: (e)=>handleMetadataFieldChange('externalLink', e.target.value),
                                                placeholder: t('common:organization.metadata.externalLink.placeholder'),
                                                error: !!((currentListing === null || currentListing === void 0 ? void 0 : currentListing.externalLink) && currentListing.externalLink.trim() !== '' && !isValidUrl(currentListing === null || currentListing === void 0 ? void 0 : currentListing.externalLink, true)),
                                                helperText: (currentListing === null || currentListing === void 0 ? void 0 : currentListing.externalLink) && currentListing.externalLink.trim() !== '' && !isValidUrl(currentListing === null || currentListing === void 0 ? void 0 : currentListing.externalLink, true) ? t('common:organization.metadata.urlError') : ''
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5d4d30d0c746c1c$export$2e2bcd8739ae039), {
                                        value: currentContent,
                                        onUpdate: handleContentChange
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}















const $d17cda234e660d8e$export$6102c700e909f46e = ()=>({
        disableVoiceInput: false,
        disableHotkeyInput: false,
        disableCameraInput: false,
        disableMultiInputs: false,
        maximumCommandsPerSecond: undefined,
        maximumCommandsPerMinute: undefined,
        maximumMacroLength: undefined,
        holdTimeJitterMinMilliseconds: undefined,
        holdTimeJitterMaxMilliseconds: undefined,
        pauseTimeJitterMinMilliseconds: undefined,
        pauseTimeJitterMaxMilliseconds: undefined,
        incompatibleActionGroups: undefined,
        requiredPauseBetweenRules: undefined,
        macroStepRules: undefined
    });



var $7fPBF = parcelRequire("7fPBF");













var $7fPBF = parcelRequire("7fPBF");








'use client';
const $c49cdb968bde378c$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $f711ef723d44714d$export$2e2bcd8739ae039)(slots, (0, $2ce3a65194a0babc$export$46f01d01378ec5a2), classes);
};
const $c49cdb968bde378c$var$DividerRoot = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $c49cdb968bde378c$var$DividerWrapper = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $958b1f7c7bc02768$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $c49cdb968bde378c$var$Divider = /*#__PURE__*/ $7fPBF.forwardRef(function Divider(inProps, ref) {
    const props = (0, $c6c3e15a46633a8f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "absolute",
        "children",
        "className",
        "orientation",
        "component",
        "flexItem",
        "role",
        "textAlign",
        "variant"
    ]);
    const ownerState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $c49cdb968bde378c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c49cdb968bde378c$var$DividerRoot, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined
    }, other), {
        children: children ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c49cdb968bde378c$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
var $c49cdb968bde378c$export$2e2bcd8739ae039 = $c49cdb968bde378c$var$Divider;







let $12686fdc2c572a78$var$_ = (t)=>t, $12686fdc2c572a78$var$t, $12686fdc2c572a78$var$t1, $12686fdc2c572a78$var$t2, $12686fdc2c572a78$var$t3, $12686fdc2c572a78$var$t4, $12686fdc2c572a78$var$t5, $12686fdc2c572a78$var$t6, $12686fdc2c572a78$var$t7, $12686fdc2c572a78$var$t8, $12686fdc2c572a78$var$t9, $12686fdc2c572a78$var$t10;
const $12686fdc2c572a78$var$createDefaultActionRef = ()=>({
        eventType: 'KeyPress',
        key: '',
        deviceTypeCustomActionId: undefined
    });
function $12686fdc2c572a78$export$2e2bcd8739ae039({ throttleRules: throttleRules, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const currentRules = throttleRules !== null && throttleRules !== void 0 ? throttleRules : (0, $d17cda234e660d8e$export$6102c700e909f46e)();
    const handleBooleanChange = (field, value)=>{
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            [field]: value
        }));
    };
    const handleNumberChange = (field, value)=>{
        if (value === '') {
            onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
                [field]: undefined
            }));
            return;
        }
        const numValue = parseInt(value, 10);
        if (!isNaN(numValue) && numValue >= 0) onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            [field]: numValue
        }));
    };
    var _currentRules_incompatibleActionGroups;
    // --- Incompatible Action Groups ---
    const incompatibleGroups = (_currentRules_incompatibleActionGroups = currentRules.incompatibleActionGroups) !== null && _currentRules_incompatibleActionGroups !== void 0 ? _currentRules_incompatibleActionGroups : [];
    const addIncompatibleGroup = ()=>{
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            incompatibleActionGroups: [
                ...incompatibleGroups,
                {
                    actions: [
                        $12686fdc2c572a78$var$createDefaultActionRef(),
                        $12686fdc2c572a78$var$createDefaultActionRef()
                    ],
                    reason: ''
                }
            ]
        }));
    };
    const removeIncompatibleGroup = (index)=>{
        const updated = incompatibleGroups.filter((_, i)=>i !== index);
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            incompatibleActionGroups: updated.length > 0 ? updated : undefined
        }));
    };
    const updateIncompatibleGroup = (index, group)=>{
        const updated = [
            ...incompatibleGroups
        ];
        updated[index] = group;
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            incompatibleActionGroups: updated
        }));
    };
    var _currentRules_requiredPauseBetweenRules;
    // --- Required Pause Between Rules ---
    const pauseRules = (_currentRules_requiredPauseBetweenRules = currentRules.requiredPauseBetweenRules) !== null && _currentRules_requiredPauseBetweenRules !== void 0 ? _currentRules_requiredPauseBetweenRules : [];
    const addPauseRule = ()=>{
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            requiredPauseBetweenRules: [
                ...pauseRules,
                {
                    actionA: $12686fdc2c572a78$var$createDefaultActionRef(),
                    actionB: $12686fdc2c572a78$var$createDefaultActionRef(),
                    minimumPauseMilliseconds: 100,
                    bidirectional: true
                }
            ]
        }));
    };
    const removePauseRule = (index)=>{
        const updated = pauseRules.filter((_, i)=>i !== index);
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            requiredPauseBetweenRules: updated.length > 0 ? updated : undefined
        }));
    };
    const updatePauseRule = (index, rule)=>{
        const updated = [
            ...pauseRules
        ];
        updated[index] = rule;
        onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentRules), {
            requiredPauseBetweenRules: updated
        }));
    };
    var _currentRules_maximumCommandsPerSecond, _currentRules_maximumCommandsPerMinute, _currentRules_maximumMacroLength, _currentRules_holdTimeJitterMinMilliseconds, _currentRules_holdTimeJitterMaxMilliseconds, _currentRules_pauseTimeJitterMinMilliseconds, _currentRules_pauseTimeJitterMaxMilliseconds;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $3faa7d453f5d11ef$export$22fa1e7523221c6e), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$e37cfa0e4472699e), {
                as: "legend",
                children: t('common:organization.projects.deviceType.throttleRules.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.throttleRules.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$StyledFormGroup, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                            checked: currentRules.disableVoiceInput,
                            onChange: (e)=>handleBooleanChange('disableVoiceInput', e.target.checked)
                        }),
                        label: t('common:organization.projects.deviceType.throttleRules.disableVoiceInput')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                            checked: currentRules.disableHotkeyInput,
                            onChange: (e)=>handleBooleanChange('disableHotkeyInput', e.target.checked)
                        }),
                        label: t('common:organization.projects.deviceType.throttleRules.disableHotkeyInput')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                            checked: currentRules.disableCameraInput,
                            onChange: (e)=>handleBooleanChange('disableCameraInput', e.target.checked)
                        }),
                        label: t('common:organization.projects.deviceType.throttleRules.disableCameraInput')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$NumberInputsContainer, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.maximumCommandsPerSecond'),
                        value: (_currentRules_maximumCommandsPerSecond = currentRules.maximumCommandsPerSecond) !== null && _currentRules_maximumCommandsPerSecond !== void 0 ? _currentRules_maximumCommandsPerSecond : '',
                        onChange: (e)=>handleNumberChange('maximumCommandsPerSecond', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.maximumCommandsPerMinute'),
                        value: (_currentRules_maximumCommandsPerMinute = currentRules.maximumCommandsPerMinute) !== null && _currentRules_maximumCommandsPerMinute !== void 0 ? _currentRules_maximumCommandsPerMinute : '',
                        onChange: (e)=>handleNumberChange('maximumCommandsPerMinute', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.maximumMacroLength'),
                        value: (_currentRules_maximumMacroLength = currentRules.maximumMacroLength) !== null && _currentRules_maximumMacroLength !== void 0 ? _currentRules_maximumMacroLength : '',
                        onChange: (e)=>handleNumberChange('maximumMacroLength', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$StyledDivider, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$SectionHeader, {
                variant: "subtitle2",
                children: t('common:organization.projects.deviceType.throttleRules.jitter.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.throttleRules.jitter.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$NumberInputsContainer, {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.jitter.holdTimeJitterMin'),
                        value: (_currentRules_holdTimeJitterMinMilliseconds = currentRules.holdTimeJitterMinMilliseconds) !== null && _currentRules_holdTimeJitterMinMilliseconds !== void 0 ? _currentRules_holdTimeJitterMinMilliseconds : '',
                        onChange: (e)=>handleNumberChange('holdTimeJitterMinMilliseconds', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.jitter.holdTimeJitterMax'),
                        value: (_currentRules_holdTimeJitterMaxMilliseconds = currentRules.holdTimeJitterMaxMilliseconds) !== null && _currentRules_holdTimeJitterMaxMilliseconds !== void 0 ? _currentRules_holdTimeJitterMaxMilliseconds : '',
                        onChange: (e)=>handleNumberChange('holdTimeJitterMaxMilliseconds', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.jitter.pauseTimeJitterMin'),
                        value: (_currentRules_pauseTimeJitterMinMilliseconds = currentRules.pauseTimeJitterMinMilliseconds) !== null && _currentRules_pauseTimeJitterMinMilliseconds !== void 0 ? _currentRules_pauseTimeJitterMinMilliseconds : '',
                        onChange: (e)=>handleNumberChange('pauseTimeJitterMinMilliseconds', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                        type: "number",
                        label: t('common:organization.projects.deviceType.throttleRules.jitter.pauseTimeJitterMax'),
                        value: (_currentRules_pauseTimeJitterMaxMilliseconds = currentRules.pauseTimeJitterMaxMilliseconds) !== null && _currentRules_pauseTimeJitterMaxMilliseconds !== void 0 ? _currentRules_pauseTimeJitterMaxMilliseconds : '',
                        onChange: (e)=>handleNumberChange('pauseTimeJitterMaxMilliseconds', e.target.value),
                        slotProps: {
                            htmlInput: {
                                min: 0
                            }
                        },
                        fullWidth: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$StyledDivider, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$SectionHeader, {
                variant: "subtitle2",
                children: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.description')
            }),
            incompatibleGroups.map((group, groupIndex)=>{
                var _group_reason;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$GroupCard, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$GroupHeader, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        fontWeight: 600
                                    },
                                    children: [
                                        "Group ",
                                        groupIndex + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: ()=>removeIncompatibleGroup(groupIndex),
                                    "aria-label": t('common:organization.projects.deviceType.throttleRules.incompatibleActions.removeGroup'),
                                    children: "x"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                            label: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.reason'),
                            value: (_group_reason = group.reason) !== null && _group_reason !== void 0 ? _group_reason : '',
                            onChange: (e)=>updateIncompatibleGroup(groupIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, group), {
                                    reason: e.target.value || undefined
                                })),
                            placeholder: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.reasonPlaceholder'),
                            fullWidth: true,
                            size: "small",
                            sx: {
                                marginBottom: '12px'
                            }
                        }),
                        group.actions.map((action, actionIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$ActionRefRow, {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$MacroActionReferenceEditor, {
                                        action: action,
                                        onUpdate: (updated)=>{
                                            const newActions = [
                                                ...group.actions
                                            ];
                                            newActions[actionIndex] = updated;
                                            updateIncompatibleGroup(groupIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, group), {
                                                actions: newActions
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
                                        size: "small",
                                        disabled: group.actions.length <= 2,
                                        onClick: ()=>{
                                            const newActions = group.actions.filter((_, i)=>i !== actionIndex);
                                            updateIncompatibleGroup(groupIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, group), {
                                                actions: newActions
                                            }));
                                        },
                                        "aria-label": t('common:organization.projects.deviceType.throttleRules.incompatibleActions.removeAction'),
                                        children: "x"
                                    })
                                ]
                            }, actionIndex)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "solidAccent",
                            $size: "small",
                            onClick: ()=>{
                                updateIncompatibleGroup(groupIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, group), {
                                    actions: [
                                        ...group.actions,
                                        $12686fdc2c572a78$var$createDefaultActionRef()
                                    ]
                                }));
                            },
                            children: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.addAction')
                        })
                    ]
                }, groupIndex);
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "solidAccent",
                $size: "small",
                onClick: addIncompatibleGroup,
                children: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.addGroup')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$StyledDivider, {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$SectionHeader, {
                variant: "subtitle2",
                children: t('common:organization.projects.deviceType.throttleRules.requiredPause.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3faa7d453f5d11ef$export$a82c6f1cc70eb063), {
                children: t('common:organization.projects.deviceType.throttleRules.requiredPause.description')
            }),
            pauseRules.map((rule, ruleIndex)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$GroupCard, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$GroupHeader, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    sx: {
                                        fontWeight: 600
                                    },
                                    children: [
                                        "Rule ",
                                        ruleIndex + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6767d63d9006cc81$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: ()=>removePauseRule(ruleIndex),
                                    "aria-label": t('common:organization.projects.deviceType.throttleRules.requiredPause.removeRule'),
                                    children: "x"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$PauseRuleRow, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$ActionRefSection, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: t('common:organization.projects.deviceType.throttleRules.requiredPause.actionA')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$MacroActionReferenceEditor, {
                                            action: rule.actionA,
                                            onUpdate: (updated)=>updatePauseRule(ruleIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rule), {
                                                    actionA: updated
                                                }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$ActionRefSection, {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: t('common:organization.projects.deviceType.throttleRules.requiredPause.actionB')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12686fdc2c572a78$var$MacroActionReferenceEditor, {
                                            action: rule.actionB,
                                            onUpdate: (updated)=>updatePauseRule(ruleIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rule), {
                                                    actionB: updated
                                                }))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$PauseRuleOptionsRow, {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                                    type: "number",
                                    label: t('common:organization.projects.deviceType.throttleRules.requiredPause.minimumPause'),
                                    value: rule.minimumPauseMilliseconds,
                                    onChange: (e)=>{
                                        const val = parseInt(e.target.value, 10);
                                        if (!isNaN(val) && val >= 0) updatePauseRule(ruleIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rule), {
                                            minimumPauseMilliseconds: val
                                        }));
                                    },
                                    slotProps: {
                                        htmlInput: {
                                            min: 0
                                        }
                                    },
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $302bb1ec2a19f6b0$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $782ff1a97e868b05$export$2e2bcd8739ae039), {
                                        checked: rule.bidirectional,
                                        onChange: (e)=>updatePauseRule(ruleIndex, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rule), {
                                                bidirectional: e.target.checked
                                            }))
                                    }),
                                    label: t('common:organization.projects.deviceType.throttleRules.requiredPause.bidirectional')
                                })
                            ]
                        })
                    ]
                }, ruleIndex)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "solidAccent",
                $size: "small",
                onClick: addPauseRule,
                children: t('common:organization.projects.deviceType.throttleRules.requiredPause.addRule')
            })
        ]
    });
}
function $12686fdc2c572a78$var$MacroActionReferenceEditor({ action: action, onUpdate: onUpdate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const isCustomAction = action.eventType === 'DeviceTypeCustomAction';
    var _action_deviceTypeCustomActionId, _action_key;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($12686fdc2c572a78$var$ActionRefFields, {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $2987d9546a369844$export$2e2bcd8739ae039), {
                size: "small",
                sx: {
                    minWidth: 160
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbc61dc9c3129b5f$export$2e2bcd8739ae039), {
                        children: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.eventType')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69621a0a62cf21c5$export$2e2bcd8739ae039), {
                        value: action.eventType,
                        label: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.eventType'),
                        onChange: (e)=>onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, action), {
                                eventType: e.target.value,
                                key: e.target.value === 'DeviceTypeCustomAction' ? undefined : action.key,
                                deviceTypeCustomActionId: e.target.value === 'DeviceTypeCustomAction' ? action.deviceTypeCustomActionId : undefined
                            })),
                        children: (0, $03a56fb167cf9474$export$caaa93ee9052213c).map((evt)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce4664bb90d2045a$export$2e2bcd8739ae039), {
                                value: evt.eventType,
                                children: t(evt.displayName)
                            }, evt.eventType))
                    })
                ]
            }),
            isCustomAction ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                label: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.customActionId'),
                value: (_action_deviceTypeCustomActionId = action.deviceTypeCustomActionId) !== null && _action_deviceTypeCustomActionId !== void 0 ? _action_deviceTypeCustomActionId : '',
                onChange: (e)=>onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, action), {
                        deviceTypeCustomActionId: e.target.value || undefined
                    })),
                size: "small"
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e90c645ab00aca9$export$2e2bcd8739ae039), {
                label: t('common:organization.projects.deviceType.throttleRules.incompatibleActions.key'),
                value: (_action_key = action.key) !== null && _action_key !== void 0 ? _action_key : '',
                onChange: (e)=>onUpdate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, action), {
                        key: e.target.value || undefined
                    })),
                size: "small"
            })
        ]
    });
}
// --- Styled components ---
const $12686fdc2c572a78$var$StyledFormGroup = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $ea5892afc276c974$export$2e2bcd8739ae039))($12686fdc2c572a78$var$t || ($12686fdc2c572a78$var$t = $12686fdc2c572a78$var$_`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    width: 100%;
    margin-bottom: 16px;
`));
const $12686fdc2c572a78$var$NumberInputsContainer = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t1 || ($12686fdc2c572a78$var$t1 = $12686fdc2c572a78$var$_`
    display: grid;
    padding-top: 0.5rem;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
    width: 100%;
`));
const $12686fdc2c572a78$var$StyledDivider = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $c49cdb968bde378c$export$2e2bcd8739ae039))($12686fdc2c572a78$var$t2 || ($12686fdc2c572a78$var$t2 = $12686fdc2c572a78$var$_`
    width: 100%;
    margin: 24px 0;
`));
const $12686fdc2c572a78$var$SectionHeader = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)((0, $f577398c4e8dc99c$export$2e2bcd8739ae039))($12686fdc2c572a78$var$t3 || ($12686fdc2c572a78$var$t3 = $12686fdc2c572a78$var$_`
    align-self: flex-start;
    margin-bottom: 4px;
`));
const $12686fdc2c572a78$var$GroupCard = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t4 || ($12686fdc2c572a78$var$t4 = $12686fdc2c572a78$var$_`
    width: 100%;
    border: 1px solid ${0};
    border-radius: 8px;
    padding: 16px;
    margin: 8px 0;
`), ({ theme: theme })=>theme.palette.divider);
const $12686fdc2c572a78$var$GroupHeader = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t5 || ($12686fdc2c572a78$var$t5 = $12686fdc2c572a78$var$_`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`));
const $12686fdc2c572a78$var$ActionRefRow = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t6 || ($12686fdc2c572a78$var$t6 = $12686fdc2c572a78$var$_`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`));
const $12686fdc2c572a78$var$ActionRefFields = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t7 || ($12686fdc2c572a78$var$t7 = $12686fdc2c572a78$var$_`
    display: flex;
    gap: 8px;
    flex: 1;
`));
const $12686fdc2c572a78$var$PauseRuleRow = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t8 || ($12686fdc2c572a78$var$t8 = $12686fdc2c572a78$var$_`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 12px;
`));
const $12686fdc2c572a78$var$ActionRefSection = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t9 || ($12686fdc2c572a78$var$t9 = $12686fdc2c572a78$var$_`
    display: flex;
    flex-direction: column;
    gap: 4px;
`));
const $12686fdc2c572a78$var$PauseRuleOptionsRow = (0, $ce10e2b5fa342a3c$export$2e2bcd8739ae039)('div')($12686fdc2c572a78$var$t10 || ($12686fdc2c572a78$var$t10 = $12686fdc2c572a78$var$_`
    display: flex;
    gap: 16px;
    align-items: center;
`));



function $ed3a310fcee8addc$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId, deviceId: deviceId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const { currentOrg: currentOrg, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { currentOrgDeviceType: currentOrgDeviceType, error: error, isLoading: isLoadingProject } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    const { handleSave: handleSaveDeviceType } = (0, $bc567063fd13cd58$export$d5236bf86334668)(currentOrgDeviceType);
    const editDeviceType = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.editDeviceType);
    const { handleInputChange: handleInputChange } = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState();
    const hasChanges = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.hasChanges);
    const listingHasChanges = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.listingHasChanges);
    const editListing = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.editListing);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const [throttleRules, setThrottleRules] = (0, $7fPBF.useState)(currentOrgDeviceType === null || currentOrgDeviceType === void 0 ? void 0 : currentOrgDeviceType.commandThrottleRules);
    const [throttleRulesChanged, setThrottleRulesChanged] = (0, $7fPBF.useState)(false);
    // Sync throttle rules when currentOrgDeviceType changes
    (0, $7fPBF.useEffect)(()=>{
        setThrottleRules(currentOrgDeviceType === null || currentOrgDeviceType === void 0 ? void 0 : currentOrgDeviceType.commandThrottleRules);
        setThrottleRulesChanged(false);
    }, [
        currentOrgDeviceType
    ]);
    const handleThrottleRulesUpdate = (rules)=>{
        setThrottleRules(rules);
        setThrottleRulesChanged(true);
    };
    const handleUnifiedSave = async ()=>{
        if (!organizationId || !deviceId) return;
        setIsSaving(true);
        let deviceTypeSaveSuccess = true;
        let listingSaveSuccess = true;
        let throttleRulesSaveSuccess = true;
        try {
            // Save device type if it has changes
            if (hasChanges) {
                const deviceTypeResult = await handleSaveDeviceType();
                deviceTypeSaveSuccess = deviceTypeResult.resultType === 'Ok';
            }
            // Save throttle rules if they have changes
            if (throttleRulesChanged) {
                const rulesPayload = throttleRules !== null && throttleRules !== void 0 ? throttleRules : (0, $d17cda234e660d8e$export$6102c700e909f46e)();
                const throttleRulesResult = await (0, $55ce97f088539572$export$87aeeca3aeff7121).getState().updateOrgDeviceTypeThrottleRules(organizationId, deviceId, rulesPayload);
                throttleRulesSaveSuccess = throttleRulesResult.resultType === 'Ok';
                if (throttleRulesSaveSuccess) setThrottleRulesChanged(false);
            }
            // Save client listings if they have changes
            if (listingHasChanges && editListing) {
                // Helper to validate URL format
                const isValidUrl = (url, isOptional = false)=>{
                    if (!url || url.trim() === '') return isOptional;
                    return url.startsWith('http://') || url.startsWith('https://');
                };
                // Helper to check if a listing is complete
                const isListingComplete = (listing)=>{
                    const anyHasOnboarding = editListing.some((l)=>l.markdownOnboardingInstructions && l.markdownOnboardingInstructions.length > 1);
                    const anyHasTroubleshooting = editListing.some((l)=>l.markdownTroubleshootingInstructions && l.markdownTroubleshootingInstructions.length > 1);
                    const requiredFields = [
                        listing.title,
                        listing.shortDescription,
                        isValidUrl(listing.iconUrl),
                        isValidUrl(listing.darkModeIconUrl),
                        listing.markdownDescription && listing.markdownDescription.length > 25 || listing.externalLink && listing.externalLink.trim() !== ''
                    ];
                    // Validate optional external link if provided
                    if (listing.externalLink && listing.externalLink.trim() !== '') requiredFields.push(isValidUrl(listing.externalLink, true));
                    if (anyHasOnboarding) requiredFields.push(listing.markdownOnboardingInstructions && listing.markdownOnboardingInstructions.length > 25);
                    if (anyHasTroubleshooting) requiredFields.push(listing.markdownTroubleshootingInstructions && listing.markdownTroubleshootingInstructions.length > 25);
                    return requiredFields.every(Boolean);
                };
                // Filter to only complete listings
                const completeListings = editListing.filter(isListingComplete);
                const incompleteListings = editListing.filter((listing)=>!isListingComplete(listing));
                if (completeListings.length === 0) {
                    (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError('All locales are incomplete. Please complete at least one locale to 100% before saving.');
                    listingSaveSuccess = false;
                } else {
                    // Create en-us as a copy of en if en exists
                    let listingsToSave = [
                        ...completeListings
                    ];
                    const enListing = completeListings.find((l)=>l.locale === 'en');
                    if (enListing) {
                        // Check if en-us already exists in complete listings
                        const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                        if (!hasEnUs) {
                            // Create en-us as a copy of en
                            const enUsListing = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, enListing), {
                                locale: 'en-us'
                            });
                            listingsToSave.push(enUsListing);
                        }
                    }
                    const request = {
                        listings: (0, $710192f33815db16$export$e0ee21b9e212f3d0)(listingsToSave)
                    };
                    // Use PUT for both create and update (upsert)
                    const response = await $1a4c36336f303477$export$2fbd549f3e7afb42(organizationId, deviceId, request);
                    listingSaveSuccess = response.resultType === 'Ok';
                    if (listingSaveSuccess) {
                        (0, $c6a32ec408b1369c$export$a8fe2d44e6831742).getState().setListingHasChanges(false);
                        // Reload the listings
                        const refreshResult = await $1a4c36336f303477$export$f942174137d3f696(organizationId, deviceId);
                        refreshResult.resultType === 'Ok' && refreshResult.data;
                        // Show info about incomplete locales
                        if (incompleteListings.length > 0) {
                            // Filter out en-us from incomplete list if it was auto-generated
                            const enListing = completeListings.find((l)=>l.locale === 'en');
                            const hasEnUs = completeListings.some((l)=>l.locale === 'en-us');
                            const supportedLocaleCodes = [
                                'en',
                                'es',
                                'fr',
                                'it',
                                'de',
                                'ja'
                            ];
                            const actuallyIncompleteListings = incompleteListings.filter((l)=>!(l.locale === 'en-us' && enListing && !hasEnUs) && supportedLocaleCodes.includes(l.locale));
                            if (actuallyIncompleteListings.length > 0) {
                                const incompleteLocales = actuallyIncompleteListings.map((l)=>l.locale).join(', ');
                                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(`Saved successfully. Incomplete locales not saved: ${incompleteLocales.toUpperCase()}`);
                                return; // Early return to avoid the generic success message
                            }
                        }
                    }
                }
            }
            // Show appropriate success/error message
            if (deviceTypeSaveSuccess && listingSaveSuccess && throttleRulesSaveSuccess) (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:saved'));
            else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
        } catch (error) {
            console.error('Error saving:', error);
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
        } finally{
            setIsSaving(false);
        }
    };
    const hasAnyChanges = hasChanges || listingHasChanges || throttleRulesChanged;
    if (!organizationId || !deviceId) return null;
    if (!currentOrgDeviceType || !editDeviceType || isLoading || isLoadingProject) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg || !canCreateAuthClients || error.device) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$54fb318478ce42e9), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:settings.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e01b516a47e1de8f$export$2e2bcd8739ae039), {
                        value: editDeviceType.name,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e7f3fc00fe5d6c8d$export$2e2bcd8739ae039), {
                        value: editDeviceType.description,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ad34c58e371e6c3$export$2e2bcd8739ae039), {
                        editDeviceType: editDeviceType,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5f187ec04d6f075$export$2e2bcd8739ae039), {
                        editDeviceType: editDeviceType,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12686fdc2c572a78$export$2e2bcd8739ae039), {
                        throttleRules: throttleRules,
                        onUpdate: handleThrottleRulesUpdate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a326367fe13d13bb$export$2e2bcd8739ae039), {
                hideSaveButton: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceType.customControls.title'),
                description: t('common:organization.projects.deviceType.customControls.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    startIcon: "edit",
                    onClick: ()=>navigate(`customControls`),
                    children: t('common:edit')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: handleUnifiedSave,
                disabled: !hasAnyChanges || isSaving,
                children: isSaving ? t('common:saving') : t('common:save')
            })
        ]
    });
}




function $2be582792e299f82$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { currentOrgDeviceType: currentOrgDeviceType } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    var _currentOrgDeviceType_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: (_currentOrgDeviceType_name = currentOrgDeviceType === null || currentOrgDeviceType === void 0 ? void 0 : currentOrgDeviceType.name) !== null && _currentOrgDeviceType_name !== void 0 ? _currentOrgDeviceType_name : t('common:organization.projects.deviceType.title'),
                description: (currentOrgDeviceType === null || currentOrgDeviceType === void 0 ? void 0 : currentOrgDeviceType.id) ? `${t('common:organization.projects.deviceType.id')}:  ${currentOrgDeviceType.id}` : t('common:organization.projects.deviceType.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed3a310fcee8addc$export$2e2bcd8739ae039), {})
        ]
    });
}






















function $78d4a77ac2e2ef58$export$2e2bcd8739ae039({ clientId: clientId, title: title, createdDate: createdDate }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const getRelativeTime = (0, $1e6a0781013949e7$export$2e2bcd8739ae039)();
    createdDate = createdDate || new Date().toISOString();
    const handleNavigate = ()=>{
        navigate(`client/${clientId}`);
    };
    if (!clientId || !title || !createdDate) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
        iconSize: 24,
        title: title,
        description: t('common:profile.share.created', 'Created: ', {
            value: getRelativeTime(new Date(createdDate))
        }),
        onClick: handleNavigate,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b091aef3a32d2bd8$export$1ef657600983666a), {
            as: "span",
            children: t('common:organization.projects.key.title') + ': ' + (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(clientId)
        })
    });
}








var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");






function $5201702d84bc65d1$export$2e2bcd8739ae039({ open: open, onClose: onClose }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { editClient: editClient, handleSave: handleSave, handleInputChange: handleInputChange } = (0, $4b8a9e84dae5e7a0$export$8f7032ec10a68144)(null);
    const [showSecret, setShowSecret] = (0, $7fPBF.useState)(false);
    const handleSaveAndClose = async ()=>{
        const response = await handleSave();
        if (response.resultType == 'Ok') {
            onClose();
            setShowSecret(true);
        }
    };
    if (!editClient) return null;
    var _editClient_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54aed6520e5f6aee$export$2e2bcd8739ae039), {
                fullWidth: true,
                open: open,
                onClose: onClose,
                onCancel: onClose,
                title: t('common:organization.projects.clients.create'),
                description: t('common:organization.projects.clients.description'),
                onConfirm: handleSaveAndClose,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $082accbd174d656b$export$174d4944f63edcc7), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c9acefb60389ed$export$2e2bcd8739ae039), {
                            value: (_editClient_name = editClient.name) !== null && _editClient_name !== void 0 ? _editClient_name : '',
                            onUpdate: (field, value)=>handleInputChange(field, value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50c02032c88163c7$export$2e2bcd8739ae039), {
                            value: editClient.originHost,
                            onUpdate: (field, value)=>handleInputChange(field, value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5d3b4079485dd94$export$2e2bcd8739ae039), {
                            tokenAdditionalRedirectUris: editClient.tokenAdditionalRedirectUris,
                            tokenRedirectUrlHost: editClient.tokenRedirectUrlHost,
                            onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                                handleInputChange(additionalField, additionalValue);
                                handleInputChange(hostField, hostValue);
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86bb7a18b305ac09$export$2e2bcd8739ae039), {
                            additionalRedirectUris: editClient.additionalRedirectUris,
                            authCodeRedirectUrlHost: editClient.authCodeRedirectUrlHost,
                            onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                                handleInputChange(additionalField, additionalValue);
                                handleInputChange(hostField, hostValue);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2dd45cbffb74c92$export$2e2bcd8739ae039), {
                open: showSecret,
                secret: editClient.secret,
                onClose: ()=>setShowSecret(false)
            })
        ]
    });
}


function $79fb8802f7614534$export$2e2bcd8739ae039(_param) {
    var { $color: $color = 'accent', $size: $size = 'small', startIcon: startIcon = 'plusLight' } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "$color",
        "$size",
        "startIcon"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                $color: $color,
                $size: $size,
                onClick: handleOpenDialog,
                startIcon: startIcon
            }, restProps), {
                children: t('common:organization.projects.clients.create')
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5201702d84bc65d1$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog
            })
        ]
    });
}








var $7fPBF = parcelRequire("7fPBF");


function $73aed8982a72a65d$export$2e2bcd8739ae039(_param) {
    var { $color: $color = 'accent', $size: $size = 'small', startIcon: startIcon = 'plusLight' } = _param, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "$color",
        "$size",
        "startIcon"
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [openDialog, setOpenDialog] = (0, $7fPBF.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                $color: $color,
                $size: $size,
                onClick: handleOpenDialog,
                startIcon: startIcon
            }, restProps), {
                children: t('common:organization.projects.deviceType.action')
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42567f24cb8195b5$export$2e2bcd8739ae039), {
                open: openDialog,
                onClose: handleCloseDialog
            })
        ]
    });
}







function $51b9dde09f5e56b2$export$2e2bcd8739ae039({ deviceTypeId: deviceTypeId, title: title }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const handleNavigate = ()=>{
        navigate(`device/${deviceTypeId}`);
    };
    if (!deviceTypeId || !title) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f034ea975db3d0b$export$2e2bcd8739ae039), {
        iconSize: 24,
        title: title,
        description: t('common:organization.projects.deviceType.id') + ': ' + (0, $9bc694be59ba7dc7$export$94edfa5bee6a54b8)(deviceTypeId),
        onClick: handleNavigate
    });
}







function $88bab46ef376a28f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5292444ccdcf3a91$export$2e2bcd8739ae039), {
        description: t('common:organization.projects.create.first.description'),
        fullHeight: true,
        title: t('common:organization.projects.create.first.title'),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
            onClick: ()=>navigate('new'),
            startIcon: "plusLight",
            children: t('common:organization.projects.create.title')
        })
    });
}



function $4e320ec7bd47b761$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { currentOrg: currentOrg, isExpiredOrg: isExpiredOrg, canManageBilling: canManageBilling, canCreateAuthClients: canCreateAuthClients, isLoading: isLoading, isManagedOrg: isManagedOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const { authClients: authClients, deviceTypes: deviceTypes, isLoading: isLoadingProjects } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    if (isLoading || isLoadingProjects) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    if (!currentOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (currentOrg.canCreateAuthClients && !canCreateAuthClients) // org can create auth clients, but user doesn't have access
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f8f95b189a35cb2e$export$2e2bcd8739ae039), {});
    if (!canCreateAuthClients || !currentOrg.isDeveloperAccess) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ec5f0e18dd3ab72$export$2e2bcd8739ae039), {});
    if (isExpiredOrg) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1ebcf00b940bfdd$export$2e2bcd8739ae039), {
        organizationId: currentOrg.id,
        canManageBilling: canManageBilling,
        isManagedOrg: isManagedOrg,
        customBillingUrl: currentOrg.customBillingUrl
    });
    if (authClients.length === 0 && deviceTypes.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88bab46ef376a28f$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.clients.title'),
                description: t('common:organization.projects.clients.description')
            }),
            authClients.map((client)=>{
                var _client_name;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78d4a77ac2e2ef58$export$2e2bcd8739ae039), {
                    clientId: client.id,
                    title: (_client_name = client.name) !== null && _client_name !== void 0 ? _client_name : '-',
                    createdDate: client.createdDate
                }, client.id);
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$56d6cb3330e62b54), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79fb8802f7614534$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.deviceType.title'),
                description: t('common:organization.projects.deviceType.description')
            }),
            deviceTypes && deviceTypes.map((device)=>{
                var _device_name;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $51b9dde09f5e56b2$export$2e2bcd8739ae039), {
                    deviceTypeId: device.id,
                    title: (_device_name = device.name) !== null && _device_name !== void 0 ? _device_name : device.id
                }, device.id);
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $347ffda0d89c401a$export$56d6cb3330e62b54), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $73aed8982a72a65d$export$2e2bcd8739ae039), {})
            })
        ]
    });
}






function $f07d8ec8cbd03474$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    const { isExpiredOrg: isExpiredOrg, currentOrg: currentOrg } = (0, $b194594edd326788$export$2e2bcd8739ae039)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    if (!currentOrg) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $e8ddd06b3da44631$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.name) + ' ' + t('common:organization.projects.title'),
                description: t('common:organization.projects.description'),
                items: items,
                children: !isExpiredOrg && (currentOrg.canCreateAuthClients || currentOrg.isDeveloperAccess) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    startIcon: "plus",
                    onClick: ()=>navigate('new'),
                    children: t('common:organization.projects.create.title')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e320ec7bd47b761$export$2e2bcd8739ae039), {})
        ]
    });
}















function $fd3af74d2f3a641d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                name: "javaScript",
                title: t('common:developer.sdk.javascript.title'),
                description: t('common:developer.sdk.javascript.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    endIcon: "externalLink",
                    $color: "subsection",
                    href: "https://www.npmjs.com/package/@cephable/cephable-web",
                    children: t('common:developer.sdk.javascript.action')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                name: "windows11",
                title: t('common:developer.sdk.net.title'),
                description: t('common:developer.sdk.net.description'),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        endIcon: "externalLink",
                        $color: "subsection",
                        href: "https://www.nuget.org/packages/Cephable.Core",
                        children: t('common:developer.sdk.net.actionCore')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                        endIcon: "externalLink",
                        $color: "subsection",
                        href: "https://www.nuget.org/packages/Cephable.WPF",
                        children: t('common:developer.sdk.net.actionWpf')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                name: "logo",
                title: t('common:developer.sdk.docs.title'),
                description: t('common:developer.sdk.docs.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    endIcon: "externalLink",
                    href: "https://developers.cephable.com",
                    $color: "subsection",
                    children: t('common:developer.sdk.docs.action')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
                name: "sdk",
                title: t('common:developer.sdk.more.title'),
                description: t('common:developer.sdk.more.description'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                    $color: "secondary",
                    href: "https://forms.office.com/Pages/ResponsePage.aspx?id=nXUREBN1JUCrY3YZ6NyUADMAro2v4K5DnCn2crFpV3hUOEY0OVhPTDE3REsyRU81QTBVVElTWkpMSC4u",
                    startIcon: "plusLight",
                    children: t('common:developer.sdk.more.action')
                })
            })
        ]
    });
}










var $7fPBF = parcelRequire("7fPBF");














let $903c940fba92da6d$var$_ = (t)=>t, $903c940fba92da6d$var$t;
function $903c940fba92da6d$export$2e2bcd8739ae039({ active: active, handleSectionChange: handleSectionChange, handleSave: handleSave }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($903c940fba92da6d$var$StyledButtonRow, {
        children: [
            active > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "simple",
                $size: "small",
                onClick: ()=>handleSectionChange(active - 1),
                children: t('common:previous')
            }),
            handleSave ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                onClick: handleSave,
                children: t('common:save')
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                $color: "secondary",
                onClick: ()=>handleSectionChange(active + 1),
                children: t('common:next')
            })
        ]
    });
}
const $903c940fba92da6d$var$StyledButtonRow = (0, $8de346382d86c747$export$2e2bcd8739ae039)((0, $347ffda0d89c401a$export$564cbe3426fc093a))($903c940fba92da6d$var$t || ($903c940fba92da6d$var$t = $903c940fba92da6d$var$_`
    justify-content: flex-end;
`));


function $65e6bcb675663333$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { organizationId: organizationId } = (0, $39c9549f68558626$export$99eaa27ddbbb95ef)();
    const navigate = (0, $39c9549f68558626$export$9770f232ac06a008)();
    const { deviceTypes: deviceTypes } = (0, $76dd6d0d6f9746d5$export$2e2bcd8739ae039)();
    const initialClientModel = (0, $7fPBF.useMemo)(()=>(0, $710192f33815db16$export$78965615411ef913)(organizationId || ''), [
        organizationId
    ]);
    const initialDeviceModel = (0, $7fPBF.useMemo)(()=>(0, $710192f33815db16$export$c9f16ca2d09e032e)(organizationId || ''), [
        organizationId
    ]);
    const [showSecret, setShowSecret] = (0, $7fPBF.useState)(false);
    const { editClient: editClient, handleInputChange: handleInputChange, handleSave: handleClientSave } = (0, $4b8a9e84dae5e7a0$export$8f7032ec10a68144)(initialClientModel);
    const { handleSave: handleDeviceSave } = (0, $bc567063fd13cd58$export$d5236bf86334668)(initialDeviceModel);
    const editDeviceType = (0, $c6a32ec408b1369c$export$a8fe2d44e6831742)((state)=>state.editDeviceType);
    const [activeSection, setActiveSection, activeSectionRef] = (0, $03ffc57089f4cd6c$export$2e2bcd8739ae039)(1);
    const updateActiveSection = (section)=>{
        if (section < 1 || section > 5) return;
        setActiveSection(section);
    };
    const save = async ()=>{
        try {
            const clientResponse = await handleClientSave();
            const deviceResponse = await handleDeviceSave();
            if ((clientResponse === null || clientResponse === void 0 ? void 0 : clientResponse.resultType) == 'Ok' && (deviceResponse === null || deviceResponse === void 0 ? void 0 : deviceResponse.resultType) == 'Ok') {
                setShowSecret(true);
                (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showSuccess(t('common:organization.projects.create.success'));
            } else (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
        } catch (error) {
            (0, $d8990c2b9fb87b75$export$52a528b1f45cfa42).getState().showError(t('common:saveError'));
        }
    };
    const handleCloseSecret = ()=>{
        setShowSecret(false);
        navigate(-1);
    };
    if (!organizationId || !editClient || !editDeviceType) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2b7126a11f803509$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 1,
                description: t('common:organization.projects.create.details.description'),
                number: 1,
                title: t('common:organization.projects.create.details.title'),
                variant: activeSection === 1 ? 'default' : 'small'
            }),
            activeSection === 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98c9acefb60389ed$export$2e2bcd8739ae039), {
                        value: editClient.name,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 2,
                description: t('common:organization.projects.sdk.description'),
                number: 2,
                title: t('common:organization.projects.sdk.title'),
                variant: activeSection === 2 ? 'default' : 'small'
            }),
            activeSection === 2 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd3af74d2f3a641d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 3,
                description: t('common:organization.projects.clients.description'),
                number: 3,
                title: t('common:organization.projects.clients.configure'),
                variant: activeSection === 3 ? 'default' : 'small'
            }),
            activeSection === 3 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50c02032c88163c7$export$2e2bcd8739ae039), {
                        value: editClient.originHost,
                        onUpdate: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d5d3b4079485dd94$export$2e2bcd8739ae039), {
                        tokenAdditionalRedirectUris: editClient.tokenAdditionalRedirectUris,
                        tokenRedirectUrlHost: editClient.tokenRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86bb7a18b305ac09$export$2e2bcd8739ae039), {
                        additionalRedirectUris: editClient.additionalRedirectUris,
                        authCodeRedirectUrlHost: editClient.authCodeRedirectUrlHost,
                        onUpdate: (additionalField, additionalValue, hostField, hostValue)=>{
                            handleInputChange(additionalField, additionalValue);
                            handleInputChange(hostField, hostValue);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 4,
                description: t('common:organization.projects.scopes.description'),
                number: 4,
                title: t('common:organization.projects.scopes.configure'),
                variant: activeSection === 4 ? 'default' : 'small'
            }),
            activeSection === 4 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f61ab26e94239cef$export$2e2bcd8739ae039), {
                        value: editClient.authClientScopes,
                        onUpdate: (field, value)=>handleInputChange(field, value)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                complete: activeSection > 5,
                description: t('common:organization.projects.deviceScopes.description'),
                number: 5,
                title: t('common:organization.projects.deviceScopes.configure'),
                variant: activeSection === 5 ? 'default' : 'small'
            }),
            activeSection === 5 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $aa23c6db410f15d5$export$9f629bf691066a45), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1f273ff0abbe6580$export$2e2bcd8739ae039), {
                        value: editClient.authClientDeviceTypes,
                        onUpdate: handleInputChange,
                        deviceOptions: deviceTypes
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $903c940fba92da6d$export$2e2bcd8739ae039), {
                        active: activeSection,
                        handleSectionChange: updateActiveSection,
                        handleSave: save
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2dd45cbffb74c92$export$2e2bcd8739ae039), {
                secret: editClient.secret,
                open: showSecret,
                onClose: handleCloseSecret
            })
        ]
    });
}



function $ffc3d2d483d5abdd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:organization.projects.create.titleLong'),
                description: t('common:organization.projects.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65e6bcb675663333$export$2e2bcd8739ae039), {})
        ]
    });
}












function $efd6ce3b83edd707$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { items: items } = (0, $f5559fd1343df4e9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dbcf46d7f0dc128d$export$2e2bcd8739ae039), {
                title: t('common:developer.titleLong'),
                description: t('common:developer.description'),
                items: items
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:developer.sdk.title'),
                description: t('common:developer.sdk.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd3af74d2f3a641d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:developer.demo.samples'),
                description: t('common:developer.demo.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "code",
                        title: t('common:developer.demo.docs.title'),
                        description: t('common:developer.demo.docs.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            $color: "subsection",
                            href: "https://developers.cephable.com/",
                            children: t('common:developer.demo.docs.action')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "globe",
                        title: t('common:developer.demo.web.title'),
                        description: t('common:developer.demo.web.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            $color: "subsection",
                            href: "https://web-samples.cephable.com/",
                            children: t('common:developer.demo.web.action')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "unity",
                        title: t('common:developer.demo.unity.title'),
                        description: t('common:developer.demo.unity.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            $color: "subsection",
                            href: "https://github.com/Cephable/Cephable-Unity-Samples",
                            children: t('common:developer.demo.unity.action')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "multipleDevices",
                        title: t('common:developer.demo.other.title'),
                        description: t('common:developer.demo.other.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            $color: "subsection",
                            href: "https://github.com/Cephable",
                            children: t('common:developer.demo.other.action')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d955c60ca6420e2e$export$2e2bcd8739ae039), {
                title: t('common:developer.other.title'),
                description: t('common:developer.other.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $348d9e775387b4da$export$85a4c3b5f32264b8), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6601f3edf09b4a92$export$2e2bcd8739ae039), {
                        name: "code",
                        title: t('common:developer.other.api.title'),
                        description: t('common:developer.other.api.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            endIcon: "externalLink",
                            $color: "subsection",
                            href: "https://services.cephable.com/swagger/index.html",
                            children: "Learn More"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a5e039f9955fc75e$export$2e2bcd8739ae039), {
                        name: "help",
                        title: t('common:developer.other.support.title'),
                        description: t('common:developer.other.support.description'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc5329fe346ebf22$export$2e2bcd8739ae039), {
                            $color: "secondary",
                            href: "https://discord.gg/YSDpstxXb5",
                            startIcon: "plusLight",
                            children: t('common:developer.other.support.action')
                        })
                    })
                ]
            })
        ]
    });
}


const $e938c8b8c236f168$var$getBillingRoutes = ()=>[
        {
            path: 'upgrade',
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa7643c656d80855$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:license.redirect.title'
                    }
                },
                {
                    path: 'product/:productId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa7643c656d80855$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:license.redirect.title'
                    }
                }
            ]
        },
        {
            path: 'error',
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $572ce21afb4be0ad$export$2e2bcd8739ae039), {}),
            handle: {
                crumbKey: 'common:license.redirect.error'
            }
        }
    ];
const $e938c8b8c236f168$var$getProfileRoutes = ()=>[
        {
            index: true,
            handle: {
                showActions: true
            },
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $156f799d529efa2e$export$2e2bcd8739ae039), {})
        },
        {
            path: 'controls/:index',
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f0c21677a1de5b0$export$2e2bcd8739ae039), {}),
            handle: {
                crumbKey: 'common:macros.new'
            }
        },
        {
            path: 'advanced',
            handle: {
                crumbKey: 'common:advancedOptions',
                title: 'common:profile.advancedOptions'
            },
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e30fe951f2edb943$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'hotkeys',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a7f35c066805bff$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:hotkey.title',
                        title: 'common:hotkey.title',
                        description: 'common:hotkey.usagePrompt'
                    }
                },
                {
                    path: 'keybindings',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48f7f3d9d01bd5f7$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:keys.title',
                        title: 'common:keys.title',
                        description: 'common:keys.description'
                    }
                },
                {
                    path: 'dictation',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $013893ecb4f625ea$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:dictation.title',
                        title: 'common:dictation.title',
                        description: 'common:dictation.description'
                    }
                },
                {
                    path: 'suggested-prompts',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7d3c7fab6a83fa5f$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:suggestedPrompts.title',
                        title: 'common:suggestedPrompts.title',
                        description: 'common:suggestedPrompts.description'
                    }
                },
                {
                    path: 'summary',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4025efcf1cd15ab4$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:profile.summary.title',
                        title: 'common:profile.summary.title',
                        description: 'common:profile.summary.description'
                    }
                },
                {
                    path: 'share',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7a1bf8f9f1406bc7$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:share',
                        title: 'common:profile.share.title',
                        description: 'common:profile.share.description'
                    }
                }
            ]
        }
    ];
const $e938c8b8c236f168$var$getOrgRoutes = ()=>[
        {
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6da00e256676a096$export$2e2bcd8739ae039), {}),
            index: true
        },
        {
            path: 'billing/compare',
            handle: {
                crumbKey: 'common:billing.upgrade.compare'
            },
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fb8c11d74adb839$export$2e2bcd8739ae039), {})
        },
        {
            path: 'billing/redirect',
            children: $e938c8b8c236f168$var$getBillingRoutes()
        },
        {
            path: 'trial/redirect',
            children: $e938c8b8c236f168$var$getBillingRoutes()
        },
        {
            path: 'license',
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4643a3bccc023815$export$2e2bcd8739ae039), {}),
            handle: {
                crumbKey: 'common:license.activate.title'
            }
        },
        {
            path: 'members',
            handle: {
                crumbKey: 'common:organization.member.titlePlural'
            },
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e25675874c945d68$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'invites',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $baa978b131a43e54$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.invite.titlePlural'
                    }
                }
            ]
        },
        {
            path: 'projects',
            handle: {
                crumbKey: 'common:organization.projects.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f07d8ec8cbd03474$export$2e2bcd8739ae039), {}),
                    index: true
                },
                {
                    path: 'new',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ffc3d2d483d5abdd$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.projects.create.title'
                    }
                },
                {
                    path: 'client/:clientId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f1f3f26007c0cbd9$export$2e2bcd8739ae039), {}),
                    handle: {
                        crumbKey: 'common:organization.projects.clients.title'
                    }
                },
                {
                    path: 'device/:deviceId',
                    handle: {
                        crumbKey: 'common:organization.projects.deviceType.title'
                    },
                    children: [
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2be582792e299f82$export$2e2bcd8739ae039), {})
                        },
                        {
                            path: 'customControls',
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f5435d2a87cfbb47$export$2e2bcd8739ae039), {}),
                            handle: {
                                crumbKey: 'common:organization.projects.deviceType.customControls.title'
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'governance',
            handle: {
                crumbKey: 'common:organization.governance.title'
            },
            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $66abcfbc1029bce2$export$2e2bcd8739ae039), {})
        },
        {
            path: 'metrics',
            handle: {
                crumbKey: 'common:organization.metrics.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $71606fe9d87fd62f$export$2e2bcd8739ae039), {}),
                    index: true
                },
                {
                    path: ':clientId',
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdd92f3efb1b659$export$2e2bcd8739ae039), {
                        pageTitle: "Org Metrics Client Detail"
                    }),
                    handle: {
                        crumbKey: 'common:organization.project.title'
                    }
                }
            ]
        },
        {
            path: 'documentation',
            handle: {
                crumbKey: 'common:resources.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0870cb345d848b86$export$2e2bcd8739ae039), {}),
                    index: true
                }
            ]
        },
        {
            path: 'settings',
            handle: {
                crumbKey: 'common:organization.settings.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $077db4f25b761cd8$export$2e2bcd8739ae039), {}),
                    index: true
                }
            ]
        },
        {
            path: 'profiles',
            handle: {
                crumbKey: 'common:profile.title',
                title: 'common:profile.title'
            },
            children: [
                {
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $30ba1e267b5a3af7$export$2e2bcd8739ae039), {}),
                    index: true
                },
                {
                    path: 'new',
                    handle: {
                        crumbKey: 'common:create'
                    },
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1a3a2a9b20cff10$export$2e2bcd8739ae039), {}),
                    children: $e938c8b8c236f168$var$getProfileRoutes()
                },
                {
                    path: 'edit/:profileId',
                    handle: {
                        crumbKey: 'common:edit'
                    },
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1a3a2a9b20cff10$export$2e2bcd8739ae039), {}),
                    children: $e938c8b8c236f168$var$getProfileRoutes()
                },
                {
                    path: 'preview/:profileId',
                    handle: {
                        crumbKey: 'common:profile.preview',
                        description: 'common:profile.previewDescription'
                    },
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1a3a2a9b20cff10$export$2e2bcd8739ae039), {}),
                    children: [
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ac5e11d07b654ce$export$2e2bcd8739ae039), {})
                        }
                    ]
                }
            ]
        }
    ];
const $e938c8b8c236f168$var$router = (0, $f232cebbf1b70e96$export$1ba7ed8a3a7b3765)([
    {
        path: '/',
        handle: {
            crumbKey: 'common:dashboard.title'
        },
        errorElement: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0a3a060208427f7$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: 'login',
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d308289446e38196$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fc44e910064c4f6$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: 'authcallback',
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d308289446e38196$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6147295756e879a$export$2e2bcd8739ae039), {})
                })
            },
            {
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18eb3fb4329f0ffa$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1571b35751ed6eec$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: 'upgrade',
                        handle: {
                            crumbKey: 'common:upgrade'
                        },
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fb8c11d74adb839$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: 'my-account',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6895f6b5d8df95cd$export$2e2bcd8739ae039), {}),
                        handle: {
                            crumbKey: 'common:account.settings'
                        }
                    },
                    {
                        path: 'notifications',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9a22a8e524cd97e1$export$2e2bcd8739ae039), {}),
                        handle: {
                            crumbKey: 'common:notifications.title'
                        }
                    },
                    {
                        path: 'org/:organizationId',
                        handle: {
                            crumbKey: 'common:organization.title'
                        },
                        children: [
                            ...$e938c8b8c236f168$var$getOrgRoutes(),
                            {
                                path: 'managed',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $776f18f1a04f38af$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:organization.managed.title'
                                }
                            },
                            {
                                path: 'managed/:managedOrgId',
                                handle: {
                                    crumbKey: 'common:organization.managed.title'
                                },
                                children: $e938c8b8c236f168$var$getOrgRoutes()
                            },
                            {
                                path: 'licensekey',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9b520f8e9a5b827$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:license.key.title'
                                }
                            },
                            {
                                path: 'purchase',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d391d99bd393b0cc$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:license.key.product.title'
                                }
                            },
                            {
                                path: 'product/:productId',
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa7643c656d80855$export$2e2bcd8739ae039), {}),
                                handle: {
                                    crumbKey: 'common:license.redirect.title'
                                }
                            }
                        ]
                    },
                    {
                        path: 'developer',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efd6ce3b83edd707$export$2e2bcd8739ae039), {}),
                        handle: {
                            crumbKey: 'common:developer.title'
                        }
                    },
                    {
                        path: 'support',
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3bdd92f3efb1b659$export$2e2bcd8739ae039), {
                            pageTitle: "Support"
                        }),
                        handle: {
                            crumbKey: 'common:support.title'
                        }
                    }
                ]
            },
            {
                path: '*',
                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d308289446e38196$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4fdfd1bcb4375a9$export$2e2bcd8739ae039), {})
                }),
                handle: {
                    crumbKey: 'common:notFound'
                }
            }
        ]
    }
]);
function $e938c8b8c236f168$export$2e2bcd8739ae039() {
    const restructureUrl = ()=>{
        const { search: search, hash: hash } = window.location;
        // If there are query parameters but they are before the hash
        // specifically addresses the base url overwriting that happens with auth callbacks
        if (search && !hash.includes('?')) {
            let newHash = hash || '#/';
            const params = new URLSearchParams(search);
            // Directly move to authcallback if code is present to minimize the number of redirects
            if (search.includes('code')) newHash = '#/authcallback';
            const newUrl = `${window.location.origin}${newHash}${search}`;
            window.history.replaceState(null, '', newUrl);
            window.location.reload();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        restructureUrl();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $74e05fac257f9d21$export$323e4fc2fa4753fb), {
        router: $e938c8b8c236f168$var$router
    });
}


const $e6b179db45cb0d87$var$AppWithProviders = ()=>{
    window.ADMIN_ENVIRONMENT = 'true';
    window.commandHandlers = [];
    window.commandMacroHandler = [];
    (0, $697752726c88b03c$export$a1250c97601dad3d)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c6dc2c2d62651942$export$e6cf561029f29d90), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $19e0bc52fddd02b4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9a7f2bc06270517e$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $90896a2fcfe0b000$export$33545c6a80bae043),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e938c8b8c236f168$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $e6b179db45cb0d87$export$2e2bcd8739ae039 = $e6b179db45cb0d87$var$AppWithProviders;


const $17e918899ef0ee5d$var$theme = (0, $1626f90a7ddd654a$export$2e2bcd8739ae039)({
    palette: {
        primary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).tertiary
        },
        secondary: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).secondary
        },
        error: {
            main: (0, $8951886a6b49e92a$export$35e9368ef982300f).error
        }
    }
});
const $17e918899ef0ee5d$var$rootElement = document.getElementById('root');
if (!$17e918899ef0ee5d$var$rootElement) throw new Error('Root element not found');
const $17e918899ef0ee5d$var$root = (0, $f11ec298ebcca059$exports.createRoot)($17e918899ef0ee5d$var$rootElement);
$17e918899ef0ee5d$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e6b179db45cb0d87$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=admin.539b1abb.js.map
